export const ugandaSubcounties = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.53695864479158, 0.547656927088746],
            [32.53277348371439, 0.550577096485597],
            [32.531287971170094, 0.552431621999842],
            [32.53062199165947, 0.553788624801635],
            [32.530074081319924, 0.557208362034633],
            [32.526352142807184, 0.564700592005125],
            [32.524675275632646, 0.570072802849732],
            [32.52359462929529, 0.569701784651425],
            [32.52105382626085, 0.566716052748092],
            [32.51878493158481, 0.566489686568953],
            [32.51631477026768, 0.565123377916032],
            [32.511527545710685, 0.565322007319392],
            [32.50069728057553, 0.561394677407374],
            [32.49431201601013, 0.562497855228052],
            [32.486144343004106, 0.559538771368875],
            [32.48476514248037, 0.559538649203829],
            [32.48336200365099, 0.560307517370813],
            [32.47452738364877, 0.566912208257734],
            [32.47321873950243, 0.567725016183091],
            [32.46767787782938, 0.568271388707525],
            [32.45915310563328, 0.566746742188396],
            [32.447573171240705, 0.562887901981851],
            [32.44343541965093, 0.563124265169223],
            [32.44155665431965, 0.563768794981823],
            [32.42352231742417, 0.563429686588983],
            [32.42552142735914, 0.56006924613903],
            [32.43127641415824, 0.552726648255633],
            [32.43618871205058, 0.545135740227788],
            [32.43823424602112, 0.543080105768984],
            [32.44228998771364, 0.537497788912649],
            [32.44338464597279, 0.534030294397649],
            [32.44320692776855, 0.531291446763016],
            [32.44251776004552, 0.529329630878609],
            [32.439973734754155, 0.527557912289925],
            [32.43941524405716, 0.526086518784172],
            [32.43910685152181, 0.522809421355267],
            [32.43984449952409, 0.520728970798657],
            [32.43938102902462, 0.519688188779268],
            [32.43764551443844, 0.51789308886742],
            [32.42773071522282, 0.512121939166642],
            [32.425662279602406, 0.510374466605735],
            [32.424404552864715, 0.505330172593655],
            [32.42432211267445, 0.501849925493483],
            [32.42273138674912, 0.497111806826898],
            [32.42305147175619, 0.497111530156206],
            [32.42308374013953, 0.491003780141873],
            [32.43859973188267, 0.492160036440867],
            [32.4427271267955, 0.491544615231605],
            [32.44974395371803, 0.488540010523899],
            [32.45402914220212, 0.485682059056758],
            [32.46316184387687, 0.474463477745481],
            [32.470280461599174, 0.466988749728895],
            [32.47266105189931, 0.463935042064186],
            [32.47416798117833, 0.459644529386328],
            [32.474985850532114, 0.458665561554079],
            [32.477752581657164, 0.457657647199728],
            [32.47915652537705, 0.457754690001649],
            [32.48306695289426, 0.456930211957448],
            [32.488743027187226, 0.454912242002475],
            [32.493511363767084, 0.45258940896333],
            [32.49554873744156, 0.450460436409414],
            [32.503124810544236, 0.439997735542696],
            [32.5042079919273, 0.439777757189367],
            [32.505307360053465, 0.437897137202347],
            [32.50609365991325, 0.437327223083759],
            [32.50871122039545, 0.436548375837546],
            [32.51315196923894, 0.438207784412862],
            [32.51673989797592, 0.438862884102689],
            [32.51830921704802, 0.438796228368747],
            [32.520451228283434, 0.438039745977123],
            [32.52579479117401, 0.439105747291101],
            [32.52876987574941, 0.441924709385256],
            [32.53080572318622, 0.444792907383456],
            [32.53211097619235, 0.445560129918644],
            [32.5332761279468, 0.445492215743142],
            [32.534828864118744, 0.446963752584667],
            [32.535046816067954, 0.449552029622646],
            [32.5342076144211, 0.455762011544641],
            [32.53331211445708, 0.457484545568019],
            [32.531996188567035, 0.458488183204601],
            [32.53213872515149, 0.460462996684385],
            [32.532851959639295, 0.461863360172185],
            [32.5338148898435, 0.462796968614641],
            [32.541274318503135, 0.457799267474791],
            [32.543887387408915, 0.458499021929805],
            [32.54585701733121, 0.459697601043621],
            [32.546282835843876, 0.460390543607983],
            [32.545474414970236, 0.464311152536936],
            [32.54603442920993, 0.467770984736729],
            [32.54463994564832, 0.468970995045555],
            [32.540688367206236, 0.470604240822976],
            [32.53582450198244, 0.471244912914051],
            [32.53303603971237, 0.473478001208258],
            [32.53013177561905, 0.474709075006961],
            [32.53388648018175, 0.479144732136768],
            [32.53856904651658, 0.48336865832555],
            [32.539965675255125, 0.485352465538121],
            [32.54233954615694, 0.486528467966434],
            [32.54519182115152, 0.486752003865158],
            [32.546257225773424, 0.488210111728898],
            [32.54817996004465, 0.489193905450762],
            [32.553538087320895, 0.490200351914136],
            [32.556596245398815, 0.493071756822685],
            [32.55970479716757, 0.495013206283596],
            [32.56259073832407, 0.495892694132219],
            [32.563104916026376, 0.496550644078887],
            [32.56375166260677, 0.498051113646284],
            [32.56488207920408, 0.49864499795834],
            [32.56276674074609, 0.499726347956996],
            [32.56143577795653, 0.500921618667337],
            [32.560888836899146, 0.502117238590925],
            [32.55423292790496, 0.510748387174707],
            [32.55029821982394, 0.517168392694799],
            [32.548444307283276, 0.519009183744539],
            [32.54751690994016, 0.520946055887114],
            [32.55126649320744, 0.530562350584791],
            [32.55124090828984, 0.534771730683396],
            [32.550384103256675, 0.538263240177901],
            [32.54534564147424, 0.542326903989076],
            [32.54009406606878, 0.544764113224703],
            [32.53695864479158, 0.547656927088746],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2,
        District: "WAKISO",
        County: "NANSANA MUNICIPALITY",
        Subcounty: "GOMBE DIVISION",
        Population: 76639,
        Key: "WAKISOGOMBE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.52579479117401, 0.439105747291101],
            [32.520451228283434, 0.438039745977123],
            [32.51830921704802, 0.438796228368747],
            [32.51673989797592, 0.438862884102689],
            [32.51315196923894, 0.438207784412862],
            [32.50871122039545, 0.436548375837546],
            [32.50609365991325, 0.437327223083759],
            [32.505307360053465, 0.437897137202347],
            [32.5042079919273, 0.439777757189367],
            [32.503124810544236, 0.439997735542696],
            [32.504284822138594, 0.437975220977449],
            [32.50559633999554, 0.436691484985028],
            [32.50987244202049, 0.433878748764316],
            [32.51235384216014, 0.430976944261165],
            [32.51276959055848, 0.427186295707269],
            [32.513416379359676, 0.425590448660401],
            [32.516408441195615, 0.422845244551254],
            [32.51727028308259, 0.420892332214466],
            [32.51767104398873, 0.418115204766006],
            [32.51893733346771, 0.416068154781216],
            [32.5201476498197, 0.412888121934563],
            [32.51848754251337, 0.407648158642988],
            [32.5184172493424, 0.40341479670201],
            [32.51550526782247, 0.395499886390003],
            [32.514393101398426, 0.394030933222783],
            [32.51465909435067, 0.393664064538493],
            [32.51535306626388, 0.393169207789097],
            [32.51955373226287, 0.387259394175302],
            [32.52549523177285, 0.382883378847104],
            [32.526597812274474, 0.381263626640076],
            [32.530333630656635, 0.378522735615997],
            [32.533196482415406, 0.372667784334939],
            [32.53536971729346, 0.372574295047154],
            [32.5378392452983, 0.374449279951721],
            [32.539285791620536, 0.376614646687264],
            [32.53997006172865, 0.376989880138299],
            [32.542852982749146, 0.376013358846373],
            [32.54675385758163, 0.375765688771062],
            [32.548284337094124, 0.377873860689862],
            [32.54845728524421, 0.379334348420219],
            [32.55118678479396, 0.381208974348045],
            [32.554670256531374, 0.380443702088957],
            [32.557227274156695, 0.382470207049555],
            [32.5576112895676, 0.382263171546514],
            [32.55826157281524, 0.383771214277728],
            [32.55803618281553, 0.384522980373993],
            [32.55861536979832, 0.385094629276711],
            [32.56372446700984, 0.387463404100363],
            [32.56485914072333, 0.401882248484491],
            [32.560561241077984, 0.40189293637683],
            [32.55582777440252, 0.402913259034183],
            [32.554349195953854, 0.404411142832728],
            [32.55292258773937, 0.404646809973536],
            [32.55178790683937, 0.406227616648805],
            [32.547858117034515, 0.40852874220319],
            [32.545108972227816, 0.411261133574857],
            [32.547156154606895, 0.412628551485725],
            [32.549937618102575, 0.417240243775518],
            [32.55005195657027, 0.418063161357301],
            [32.55014346525329, 0.423149838793389],
            [32.55076901518624, 0.426075956695738],
            [32.54907337681549, 0.428412656819621],
            [32.547405795526046, 0.432113815345432],
            [32.542765079005335, 0.43364953581528],
            [32.541149520950604, 0.433286781332263],
            [32.53352969719868, 0.43332267159477],
            [32.52907334821193, 0.436766865820543],
            [32.527296529987275, 0.438609598957854],
            [32.52579479117401, 0.439105747291101],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 3,
        District: "WAKISO",
        County: "NANSANA MUNICIPALITY",
        Subcounty: "NABWERU DIVISION",
        Population: 106265,
        Key: "WAKISONABWERU DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.663130565808395, 0.508016426413061],
            [32.66035486949682, 0.507968372925699],
            [32.65729051214513, 0.506890806951152],
            [32.65643508961919, 0.507201373824356],
            [32.655769994050814, 0.506890168273977],
            [32.65510460203839, 0.5072725634191],
            [32.65321588337377, 0.507140232389945],
            [32.64970034357736, 0.505536286608862],
            [32.64757498171742, 0.503155623253453],
            [32.64403585485659, 0.501145075033367],
            [32.63677689333743, 0.503210859428434],
            [32.63337941911881, 0.503376841027816],
            [32.63151448784289, 0.503196663899496],
            [32.62840296354887, 0.501329805604124],
            [32.62436370594182, 0.502236945284305],
            [32.622213819176324, 0.501721809087801],
            [32.619370842643235, 0.499720871137011],
            [32.61843889623152, 0.498535645687759],
            [32.618389896726036, 0.497597383638685],
            [32.61632995737161, 0.492362761650177],
            [32.616540821613185, 0.489823439791965],
            [32.6152283434572, 0.488067229088806],
            [32.60862008380062, 0.483789632500888],
            [32.60652123391968, 0.478178581052603],
            [32.60443910348278, 0.474880948260399],
            [32.60283711897199, 0.473957783087194],
            [32.60154529308441, 0.468778532948938],
            [32.6020508119257, 0.462829777611707],
            [32.601143739864206, 0.460120106432558],
            [32.60150283151754, 0.459310356964891],
            [32.601381989247194, 0.456054592553158],
            [32.59876490217717, 0.456666526174545],
            [32.59400098171524, 0.45960898778743],
            [32.592046388692495, 0.46127233640268],
            [32.5872607227125, 0.467446256373049],
            [32.581428972177406, 0.467246688796958],
            [32.57954071345019, 0.467769398364791],
            [32.57831948436414, 0.467335402565557],
            [32.576595319991554, 0.4679861806659],
            [32.57476344941305, 0.467805267796899],
            [32.57739443252224, 0.486840485625348],
            [32.57318318975909, 0.492565201199603],
            [32.57287581231999, 0.494580392559757],
            [32.56633223046556, 0.49507525599402],
            [32.56387220843304, 0.495718972748998],
            [32.563104916026376, 0.496550644078887],
            [32.56259073832407, 0.495892694132219],
            [32.55970479716757, 0.495013206283596],
            [32.556596245398815, 0.493071756822685],
            [32.553538087320895, 0.490200351914136],
            [32.54817996004465, 0.489193905450762],
            [32.546257225773424, 0.488210111728898],
            [32.54519182115152, 0.486752003865158],
            [32.54233954615694, 0.486528467966434],
            [32.539965675255125, 0.485352465538121],
            [32.53856904651658, 0.48336865832555],
            [32.53388648018175, 0.479144732136768],
            [32.53013177561905, 0.474709075006961],
            [32.53303603971237, 0.473478001208258],
            [32.53582450198244, 0.471244912914051],
            [32.540688367206236, 0.470604240822976],
            [32.54463994564832, 0.468970995045555],
            [32.54603442920993, 0.467770984736729],
            [32.545474414970236, 0.464311152536936],
            [32.546282835843876, 0.460390543607983],
            [32.54585701733121, 0.459697601043621],
            [32.543887387408915, 0.458499021929805],
            [32.541274318503135, 0.457799267474791],
            [32.5338148898435, 0.462796968614641],
            [32.532851959639295, 0.461863360172185],
            [32.53213872515149, 0.460462996684385],
            [32.531996188567035, 0.458488183204601],
            [32.53331211445708, 0.457484545568019],
            [32.5342076144211, 0.455762011544641],
            [32.535046816067954, 0.449552029622646],
            [32.534828864118744, 0.446963752584667],
            [32.5332761279468, 0.445492215743142],
            [32.53211097619235, 0.445560129918644],
            [32.53080572318622, 0.444792907383456],
            [32.52876987574941, 0.441924709385256],
            [32.52579479117401, 0.439105747291101],
            [32.527296529987275, 0.438609598957854],
            [32.52907334821193, 0.436766865820543],
            [32.53352969719868, 0.43332267159477],
            [32.541149520950604, 0.433286781332263],
            [32.542765079005335, 0.43364953581528],
            [32.547405795526046, 0.432113815345432],
            [32.54907337681549, 0.428412656819621],
            [32.55076901518624, 0.426075956695738],
            [32.55014346525329, 0.423149838793389],
            [32.55005195657027, 0.418063161357301],
            [32.549937618102575, 0.417240243775518],
            [32.547156154606895, 0.412628551485725],
            [32.545108972227816, 0.411261133574857],
            [32.547858117034515, 0.40852874220319],
            [32.55178790683937, 0.406227616648805],
            [32.55292258773937, 0.404646809973536],
            [32.554349195953854, 0.404411142832728],
            [32.55582777440252, 0.402913259034183],
            [32.560561241077984, 0.40189293637683],
            [32.56485914072333, 0.401882248484491],
            [32.564950711390125, 0.402546567708984],
            [32.56881675494578, 0.40137186163571],
            [32.57192213566155, 0.400900175026886],
            [32.573947660557444, 0.401146969427943],
            [32.575803187370646, 0.400403243652952],
            [32.57770188092821, 0.401520606419202],
            [32.58376373671998, 0.402012606994048],
            [32.58563275533042, 0.403433341961337],
            [32.588657379298795, 0.4036017961539],
            [32.59894621633745, 0.405746584483668],
            [32.60291375784213, 0.405222056053548],
            [32.604248745084185, 0.403828130952519],
            [32.60588208349334, 0.403088026441075],
            [32.61105866394562, 0.4051550910186],
            [32.613637741499396, 0.409217423469682],
            [32.61527383054993, 0.410653438917105],
            [32.61785458436002, 0.414167244667147],
            [32.62033151268618, 0.416643300329023],
            [32.62355889449902, 0.418608929938581],
            [32.62631023927984, 0.424663199911592],
            [32.630600743095464, 0.428850090884363],
            [32.63280271058788, 0.431838053865622],
            [32.63323554224796, 0.434140825627714],
            [32.63647082564203, 0.441329438682516],
            [32.630162686833664, 0.447808735181312],
            [32.628924946712694, 0.450811756650493],
            [32.633155989243036, 0.4559615255458],
            [32.6343739763092, 0.456622528089364],
            [32.634296264850626, 0.460002915100276],
            [32.63541769380354, 0.463183850494428],
            [32.637907207526844, 0.465433397051511],
            [32.63960882508411, 0.468777545733471],
            [32.641775894824356, 0.471515000229726],
            [32.64530081932054, 0.473374241250281],
            [32.647516529240185, 0.475754106720918],
            [32.653504784264065, 0.476750503374402],
            [32.654264058308534, 0.477253696106787],
            [32.657849787071356, 0.48257125307682],
            [32.6608154716756, 0.484607626256351],
            [32.662470977811026, 0.485203527511326],
            [32.663259849547465, 0.486070013105094],
            [32.663706124495775, 0.487860077910562],
            [32.66470024151168, 0.489317962760011],
            [32.665463678349134, 0.492361100726538],
            [32.66733339764552, 0.495157252049893],
            [32.66447775486692, 0.496875617183571],
            [32.6631987560233, 0.49913980090334],
            [32.6626268570724, 0.50325334361108],
            [32.663130565808395, 0.508016426413061],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 4,
        District: "WAKISO",
        County: "KYADONDO",
        Subcounty: "KASANGATI TOWN COUNCIL",
        Population: 142361,
        Key: "WAKISOKASANGATI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.62594921175706, 0.186453746937607],
            [32.620680819889465, 0.188950712261512],
            [32.60149163491585, 0.199773338718962],
            [32.59945948943632, 0.199942292829748],
            [32.59834336413684, 0.201987170129448],
            [32.59708092393881, 0.207001508953302],
            [32.596230183432134, 0.207037798857261],
            [32.595361829657676, 0.208354442833608],
            [32.596003447756104, 0.214156920948406],
            [32.59574543453851, 0.21539139869826],
            [32.59110799866523, 0.223506645781776],
            [32.59111856824288, 0.225047988490485],
            [32.59371814085983, 0.226996003264366],
            [32.59395310061228, 0.227592403563309],
            [32.59286365527672, 0.228999649098897],
            [32.59147998383787, 0.23379394112759],
            [32.58473752396267, 0.243153541738594],
            [32.584084473005646, 0.244932403663862],
            [32.58369904274815, 0.248470886868562],
            [32.58162903058443, 0.253311495910249],
            [32.57862339969613, 0.255857652921473],
            [32.57624961233764, 0.256854996584339],
            [32.57236792012971, 0.259424243848682],
            [32.5694615944028, 0.259970065388344],
            [32.568254846159135, 0.259820461500005],
            [32.568171942438205, 0.260114986405567],
            [32.56857780308019, 0.257866834339691],
            [32.567945152863246, 0.257123154473967],
            [32.567607141076365, 0.255823484043652],
            [32.56681673681404, 0.252574902521562],
            [32.566747392264, 0.250646282220648],
            [32.565951217224324, 0.250033068416608],
            [32.56421868234992, 0.25006161750279],
            [32.56380469375126, 0.248856069156695],
            [32.561956240272565, 0.249172309980894],
            [32.55932769429276, 0.248197047009496],
            [32.55618265834709, 0.241312967663025],
            [32.55075537157369, 0.241619468319449],
            [32.545246132395306, 0.240325259868005],
            [32.543927142351826, 0.239498983238607],
            [32.54376104834736, 0.237723083221111],
            [32.542928338825064, 0.236824280672371],
            [32.542003762191925, 0.232868773888246],
            [32.54156636349694, 0.224177792669903],
            [32.538271254999906, 0.21763265238025],
            [32.5385065938414, 0.216723537792563],
            [32.539313338458726, 0.216291509615905],
            [32.5416352795506, 0.213680469520585],
            [32.54177319430291, 0.211815082183763],
            [32.54311089625373, 0.21022016295984],
            [32.54348158156418, 0.206417473970563],
            [32.54441665950298, 0.205040666451137],
            [32.5450039762391, 0.20236138618417],
            [32.54721223373513, 0.201806958422546],
            [32.549398105214294, 0.201802555806647],
            [32.55275592959293, 0.200133916684998],
            [32.554561293582346, 0.199986805877594],
            [32.55619706013772, 0.198524893729682],
            [32.619610391888465, 0.164693055302676],
            [32.62594921175706, 0.186453746937607],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 5,
        District: "WAKISO",
        County: "MAKINDYE SSABAGABO MUNICIPALITY",
        Subcounty: "NDEJJE DIVISION",
        Population: 93491,
        Key: "WAKISONDEJJE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49041931405011, -0.020104433986596],
            [32.490797695227585, -0.00092654394357],
            [32.49016545284576, 0.010069286036457],
            [32.48958484742312, 0.035592945286808],
            [32.490866743333584, 0.053577127314478],
            [32.491328484576115, 0.072074882186135],
            [32.49097320627116, 0.074703635316746],
            [32.48784941368532, 0.080569792227517],
            [32.48389291966201, 0.085647028039535],
            [32.48055326011676, 0.088071692291059],
            [32.477226448276724, 0.092276814114818],
            [32.470546896522556, 0.096672058211426],
            [32.463771548426486, 0.099776739068524],
            [32.46158565898102, 0.103121857821518],
            [32.460751604680766, 0.106078324377128],
            [32.45481837865455, 0.099685604222719],
            [32.45161601492237, 0.091953403962489],
            [32.44677461836045, 0.087446995592115],
            [32.445899088843504, 0.083400418518887],
            [32.44877049975028, 0.0807583187744],
            [32.45080360463056, 0.07956732724822],
            [32.45277526923697, 0.078781948013155],
            [32.453949159802484, 0.078898472869935],
            [32.454580144542874, 0.077340718360135],
            [32.46142199671603, 0.069726253047233],
            [32.46114556893345, 0.067859540859373],
            [32.46174833220087, 0.064992554285794],
            [32.46645936614708, 0.062213332901105],
            [32.46842563367524, 0.05957060491394],
            [32.46822135588131, 0.058799372009577],
            [32.46930918155441, 0.057925322471376],
            [32.469401134005196, 0.056291303950985],
            [32.468480511755956, 0.05613235073121],
            [32.46749847258906, 0.056543587591359],
            [32.4648196083769, 0.055859352846736],
            [32.45840275814779, 0.053075353766922],
            [32.45700816589003, 0.051907212011151],
            [32.45675158279037, 0.049166598672727],
            [32.45705777894485, 0.047249034884844],
            [32.45766391538617, 0.046638823890183],
            [32.45935098382911, 0.046506623365077],
            [32.461708250271215, 0.044147063364246],
            [32.459844847029586, 0.043230003201703],
            [32.4585509514236, 0.0380034489886],
            [32.46286342623442, 0.030238261240263],
            [32.47210645809405, 0.009966702924148],
            [32.47667364122052, 0.003202561359867],
            [32.480568416492254, -0.004144796174598],
            [32.49041931405011, -0.020104433986596],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 6,
        District: "WAKISO",
        County: "ENTEBBE MUNICIPALITY",
        Subcounty: "DIVISION A",
        Population: 39484,
        Key: "WAKISODIVISION A",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49041931405011, -0.020104433986596],
            [32.480568416492254, -0.004144796174598],
            [32.47667364122052, 0.003202561359867],
            [32.47210645809405, 0.009966702924148],
            [32.46286342623442, 0.030238261240263],
            [32.4585509514236, 0.0380034489886],
            [32.459844847029586, 0.043230003201703],
            [32.461708250271215, 0.044147063364246],
            [32.45935098382911, 0.046506623365077],
            [32.45766391538617, 0.046638823890183],
            [32.45705777894485, 0.047249034884844],
            [32.45675158279037, 0.049166598672727],
            [32.45700816589003, 0.051907212011151],
            [32.45840275814779, 0.053075353766922],
            [32.4648196083769, 0.055859352846736],
            [32.46749847258906, 0.056543587591359],
            [32.468480511755956, 0.05613235073121],
            [32.469401134005196, 0.056291303950985],
            [32.46930918155441, 0.057925322471376],
            [32.46822135588131, 0.058799372009577],
            [32.46842563367524, 0.05957060491394],
            [32.46645936614708, 0.062213332901105],
            [32.46174833220087, 0.064992554285794],
            [32.46114556893345, 0.067859540859373],
            [32.46142199671603, 0.069726253047233],
            [32.454580144542874, 0.077340718360135],
            [32.453949159802484, 0.078898472869935],
            [32.45277526923697, 0.078781948013155],
            [32.45080360463056, 0.07956732724822],
            [32.44877049975028, 0.0807583187744],
            [32.445899088843504, 0.083400418518887],
            [32.443357577936645, 0.078495919306219],
            [32.44020445086519, 0.073942265244987],
            [32.43677842459359, 0.070428110745326],
            [32.42607287346764, 0.060913169601587],
            [32.419138532549454, 0.055617507622068],
            [32.4171173599911, 0.055664677237083],
            [32.411875116284826, 0.057443485261808],
            [32.40999634376699, 0.056964933185538],
            [32.408152742089186, 0.055566301878355],
            [32.406582153697585, 0.053343269896659],
            [32.4062702640208, 0.049616430782433],
            [32.40279827005779, -0.029984499783969],
            [32.40367049287619, -0.128044308626855],
            [32.40343573344801, -0.152547129135894],
            [32.46204534757315, -0.152602934080118],
            [32.48674501140029, -0.15264877764134],
            [32.48861280381039, -0.118225338321939],
            [32.49041931405011, -0.020104433986596],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 7,
        District: "WAKISO",
        County: "ENTEBBE MUNICIPALITY",
        Subcounty: "DIVISION B",
        Population: 30735,
        Key: "WAKISODIVISION B",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.38892449926534, 0.494006757851496],
            [32.382647165484705, 0.494216638717899],
            [32.37678412303499, 0.493159977099309],
            [32.375824362087144, 0.492692273080935],
            [32.36959653536011, 0.489269742953893],
            [32.365435838103075, 0.48757473570369],
            [32.3630289702842, 0.487162409532662],
            [32.3574225010527, 0.487410643695466],
            [32.34891711090718, 0.489387868902279],
            [32.342157495905006, 0.490443124407825],
            [32.33479047693862, 0.490587755953016],
            [32.3306690594157, 0.489965049528432],
            [32.32529960348539, 0.49016258452853],
            [32.31683622125746, 0.492275367782523],
            [32.31232843204262, 0.492359226011751],
            [32.31041663565832, 0.493307195637773],
            [32.308780143264194, 0.491916646889717],
            [32.30854380908938, 0.490363869851763],
            [32.306452319105524, 0.487093668440055],
            [32.305271592360704, 0.484340519959106],
            [32.30517275432326, 0.482432001179338],
            [32.30609023785892, 0.480119341324457],
            [32.30595062169746, 0.477032425369008],
            [32.3036674788427, 0.473658966928847],
            [32.303604980353434, 0.472622368893897],
            [32.302847999707915, 0.47123058347329],
            [32.30313140560364, 0.467807269176621],
            [32.30450043629999, 0.465487909515638],
            [32.304772992343736, 0.462960809687468],
            [32.3057441259631, 0.461071785927267],
            [32.30599631989428, 0.458780781169443],
            [32.30495464696553, 0.457428590394168],
            [32.3027694950369, 0.455904722377312],
            [32.29922696176452, 0.448455304779393],
            [32.29894744826892, 0.446645229551647],
            [32.29774902740794, 0.444151269964461],
            [32.29762215564544, 0.442862443536821],
            [32.29813577818891, 0.442839375489392],
            [32.3013404999987, 0.439243032782918],
            [32.30164702403825, 0.437422829790386],
            [32.30131946325137, 0.434491966983705],
            [32.29972620407695, 0.430393692710279],
            [32.29838300263994, 0.428675905241583],
            [32.29671384031557, 0.425022188271206],
            [32.295671324767106, 0.423611069776717],
            [32.29568788071778, 0.421465043039724],
            [32.295144619159814, 0.420058297678733],
            [32.29355309732715, 0.418490266554119],
            [32.29017965933057, 0.412044041850139],
            [32.289715798063945, 0.409551454379654],
            [32.2867649087124, 0.401354046684119],
            [32.28987576196492, 0.399492210657443],
            [32.29662175940569, 0.393390958879482],
            [32.301352907529406, 0.390974502459099],
            [32.30852028131376, 0.390184262983807],
            [32.319362309887545, 0.387889277542901],
            [32.32881556369333, 0.385393519863083],
            [32.334776420999376, 0.38253431478951],
            [32.340795710121405, 0.380428802960106],
            [32.35557543457283, 0.377556469440747],
            [32.36204893166544, 0.373982196509276],
            [32.37222169379299, 0.365672227412593],
            [32.37572840584511, 0.363238497101847],
            [32.3818982687784, 0.360859502095423],
            [32.39328393530427, 0.358344011028443],
            [32.399085272477095, 0.355958685339182],
            [32.40400316867027, 0.353303507561029],
            [32.4087924674373, 0.349152865880321],
            [32.41008352616363, 0.351371173598722],
            [32.413172642881186, 0.354579372991026],
            [32.41441131275848, 0.356400234702004],
            [32.41731259085183, 0.358125647427507],
            [32.41835488990628, 0.357874345039133],
            [32.41869136916732, 0.358128729487041],
            [32.420340375093346, 0.360379748354397],
            [32.420334673486245, 0.361629600803723],
            [32.422365132827984, 0.36395747261833],
            [32.424260392126214, 0.36515548834289],
            [32.426975906703646, 0.36882907064262],
            [32.42874964730011, 0.373129748457016],
            [32.43160673456968, 0.376730484634814],
            [32.43240067010935, 0.379029589955976],
            [32.43417624596399, 0.380170434311241],
            [32.43652795093616, 0.383342447220423],
            [32.439179088647066, 0.389139262607901],
            [32.44210382624405, 0.394130268373846],
            [32.442216034806194, 0.395314280007624],
            [32.441458380424216, 0.408677353908049],
            [32.43746766957173, 0.408878138433502],
            [32.43602456469536, 0.409359404865914],
            [32.43330378599036, 0.411899388980955],
            [32.429884579728395, 0.413813060772817],
            [32.42789758267672, 0.414491051012673],
            [32.42298816568151, 0.415271415007519],
            [32.420317899244935, 0.416372215702024],
            [32.41859564558898, 0.415631430546011],
            [32.416099668487206, 0.415633143588169],
            [32.41413754398913, 0.414742651756176],
            [32.412427306198374, 0.413188164019426],
            [32.40884788001559, 0.412239160763226],
            [32.40659042628302, 0.412296278661919],
            [32.40188308261602, 0.413898941965125],
            [32.39988875980321, 0.41407005218709],
            [32.39872370776178, 0.41405199023331],
            [32.394161870509535, 0.41256343879065],
            [32.390906156730935, 0.410984747043565],
            [32.38963070623269, 0.409907195203919],
            [32.38607670506739, 0.404135617529225],
            [32.38088078388703, 0.401536423566313],
            [32.37928180424086, 0.401100357888462],
            [32.37956077695063, 0.402310601375715],
            [32.378629968704374, 0.40534271833706],
            [32.378651094384914, 0.406804393307066],
            [32.37696716555393, 0.412005303005188],
            [32.37718710098326, 0.414065322680613],
            [32.37612161461465, 0.416002955878425],
            [32.37515741958253, 0.416724686439772],
            [32.3741168749378, 0.422033936086511],
            [32.36794569327764, 0.430909254525937],
            [32.36297342295862, 0.433918835832668],
            [32.36126845378704, 0.436019216102796],
            [32.357792280861304, 0.443864114140106],
            [32.35762247411981, 0.446920287125472],
            [32.356684815321174, 0.449480874462309],
            [32.35483639777513, 0.451524426460516],
            [32.35127527117299, 0.453487280258896],
            [32.34949592688576, 0.455376524302724],
            [32.34901959251142, 0.457400254839859],
            [32.3492925474071, 0.457730058084337],
            [32.352173625084646, 0.457536963288657],
            [32.35505477822069, 0.456531758906884],
            [32.36373648070703, 0.455488401445313],
            [32.36844682923869, 0.455532159694815],
            [32.36950656549114, 0.455044175205081],
            [32.37247462524101, 0.454811477559228],
            [32.382573421884715, 0.454531874951108],
            [32.383333057051885, 0.45775112470209],
            [32.384705776230824, 0.458980505285698],
            [32.38677715293543, 0.462498614597905],
            [32.38797295969893, 0.46299963989449],
            [32.388201117408066, 0.467276103152774],
            [32.387581552051536, 0.46881802426183],
            [32.38799704083675, 0.471252433355239],
            [32.387164263042514, 0.472844683579669],
            [32.38862502161085, 0.476878849319433],
            [32.38863954557236, 0.479531426265773],
            [32.38959230954248, 0.481309402797016],
            [32.38970705764195, 0.485964838542378],
            [32.38944194324203, 0.487360020969229],
            [32.3886941775147, 0.488255386972023],
            [32.38892449926534, 0.494006757851496],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 9,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KAKIRI",
        Population: 39137,
        Key: "WAKISOKAKIRI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.420317899244935, 0.416372215702024],
            [32.42048971012787, 0.420036450339816],
            [32.41875910303807, 0.428586542439484],
            [32.41887587863512, 0.431732811133815],
            [32.4181120285726, 0.433158991551279],
            [32.41573614993614, 0.434892082163736],
            [32.41453698976167, 0.439095443019071],
            [32.41241675099381, 0.440423871159269],
            [32.41075481381926, 0.440566449344001],
            [32.407194523548654, 0.442588296676292],
            [32.40328701286118, 0.446902613309908],
            [32.39740058906124, 0.45081005709056],
            [32.39632265922935, 0.451887180949847],
            [32.39514206813012, 0.454085902381962],
            [32.39508915825821, 0.45536003534815],
            [32.393582409540564, 0.456372781909539],
            [32.39256222700838, 0.458156470237765],
            [32.39152450666689, 0.45872601264218],
            [32.39064249311023, 0.46020109233336],
            [32.38814538682617, 0.461770892397239],
            [32.38797295969893, 0.46299963989449],
            [32.38677715293543, 0.462498614597905],
            [32.384705776230824, 0.458980505285698],
            [32.383333057051885, 0.45775112470209],
            [32.382573421884715, 0.454531874951108],
            [32.37247462524101, 0.454811477559228],
            [32.36950656549114, 0.455044175205081],
            [32.36844682923869, 0.455532159694815],
            [32.36373648070703, 0.455488401445313],
            [32.35505477822069, 0.456531758906884],
            [32.352173625084646, 0.457536963288657],
            [32.3492925474071, 0.457730058084337],
            [32.34901959251142, 0.457400254839859],
            [32.34949592688576, 0.455376524302724],
            [32.35127527117299, 0.453487280258896],
            [32.35483639777513, 0.451524426460516],
            [32.356684815321174, 0.449480874462309],
            [32.35762247411981, 0.446920287125472],
            [32.357792280861304, 0.443864114140106],
            [32.36126845378704, 0.436019216102796],
            [32.36297342295862, 0.433918835832668],
            [32.36794569327764, 0.430909254525937],
            [32.3741168749378, 0.422033936086511],
            [32.37515741958253, 0.416724686439772],
            [32.37612161461465, 0.416002955878425],
            [32.37718710098326, 0.414065322680613],
            [32.37696716555393, 0.412005303005188],
            [32.378651094384914, 0.406804393307066],
            [32.378629968704374, 0.40534271833706],
            [32.37956077695063, 0.402310601375715],
            [32.37928180424086, 0.401100357888462],
            [32.38088078388703, 0.401536423566313],
            [32.38607670506739, 0.404135617529225],
            [32.38963070623269, 0.409907195203919],
            [32.390906156730935, 0.410984747043565],
            [32.394161870509535, 0.41256343879065],
            [32.39872370776178, 0.41405199023331],
            [32.39988875980321, 0.41407005218709],
            [32.40188308261602, 0.413898941965125],
            [32.40659042628302, 0.412296278661919],
            [32.40884788001559, 0.412239160763226],
            [32.412427306198374, 0.413188164019426],
            [32.41413754398913, 0.414742651756176],
            [32.416099668487206, 0.415633143588169],
            [32.41859564558898, 0.415631430546011],
            [32.420317899244935, 0.416372215702024],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 10,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KAKIRI TOWN COUNCIL",
        Population: 19257,
        Key: "WAKISOKAKIRI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.41078425520437, 0.222809016728644],
            [32.4106676592704, 0.22124834128629],
            [32.40944070072946, 0.220886967907053],
            [32.400647377179176, 0.226179943210875],
            [32.4002421705107, 0.224267934325151],
            [32.40014438350214, 0.219010261867956],
            [32.39699358306726, 0.218782156129176],
            [32.396565355273005, 0.218375737895914],
            [32.39404270539384, 0.214240468177549],
            [32.39025763957116, 0.205898667014735],
            [32.385071508230745, 0.201236743746548],
            [32.38302639557008, 0.200949268456553],
            [32.381897257275405, 0.201653887345211],
            [32.378268009628634, 0.202179500032121],
            [32.37716032849283, 0.19821356826422],
            [32.37483897849241, 0.192465255221817],
            [32.37391102060054, 0.191317827374972],
            [32.371924877846695, 0.190086401146616],
            [32.37104483699039, 0.189632038465404],
            [32.36819126482854, 0.18936819752301],
            [32.362046455010216, 0.193201780650199],
            [32.36080956020391, 0.192412726531862],
            [32.34485311639212, 0.166317618478536],
            [32.343364810985584, 0.162146906869421],
            [32.341921621667574, 0.153244389095336],
            [32.34086254118527, 0.151415834372953],
            [32.3381979700676, 0.148738365446533],
            [32.30837740786107, 0.1209949461054],
            [32.30562987732695, 0.118807393278534],
            [32.303679509080986, 0.117731353099495],
            [32.29968407578507, 0.116415671602887],
            [32.29180098726439, 0.115445230774502],
            [32.28848361941291, 0.114619684285497],
            [32.28541553584939, 0.113280408439987],
            [32.281526546626445, 0.110853520917604],
            [32.27875676661935, 0.108468739853225],
            [32.27688733208891, 0.106096360720467],
            [32.273817201264876, 0.100837864286898],
            [32.27320574140717, 0.099125861218345],
            [32.27274325725787, 0.092013297260251],
            [32.271610866163535, 0.086456710132939],
            [32.26743347551357, 0.078222620611332],
            [32.264314405371174, 0.073596810303988],
            [32.26982081216148, 0.075358308968144],
            [32.27254359590619, 0.07572958325067],
            [32.28156694296645, 0.074931870984704],
            [32.28904443854311, 0.073584008423411],
            [32.29956594732519, 0.072977941648089],
            [32.304036400760204, 0.073266137126202],
            [32.31511668680185, 0.07257659626248],
            [32.319373148061466, 0.072864712691481],
            [32.32198827321093, 0.071957416775734],
            [32.3255429723672, 0.071659806054181],
            [32.33053371654004, 0.066595002169012],
            [32.33270926817321, 0.066273058764026],
            [32.33468308514305, 0.066679945906533],
            [32.33682308684718, 0.066585020994637],
            [32.337393121793845, 0.065390296595121],
            [32.34242169312499, 0.064352311915943],
            [32.34784215090558, 0.062442163312969],
            [32.35165924885465, 0.063674106757608],
            [32.353347472531034, 0.063602945857964],
            [32.35575027637153, 0.06580231851161],
            [32.36383841793223, 0.069328870099135],
            [32.37042294769225, 0.071906884784198],
            [32.37486381691002, 0.072721798031661],
            [32.377879220570314, 0.071532886780028],
            [32.382882923839446, 0.068367930357068],
            [32.38660275310787, 0.065537147692011],
            [32.393649428352354, 0.058668581864526],
            [32.402063602665606, 0.052218641621919],
            [32.4062702640208, 0.049616430782433],
            [32.406582153697585, 0.053343269896659],
            [32.408152742089186, 0.055566301878355],
            [32.40999634376699, 0.056964933185538],
            [32.411875116284826, 0.057443485261808],
            [32.4171173599911, 0.055664677237083],
            [32.419138532549454, 0.055617507622068],
            [32.42607287346764, 0.060913169601587],
            [32.43677842459359, 0.070428110745326],
            [32.44020445086519, 0.073942265244987],
            [32.443357577936645, 0.078495919306219],
            [32.445899088843504, 0.083400418518887],
            [32.44677461836045, 0.087446995592115],
            [32.45161601492237, 0.091953403962489],
            [32.45481837865455, 0.099685604222719],
            [32.460751604680766, 0.106078324377128],
            [32.46001848688245, 0.1080159196895],
            [32.459758535998766, 0.111074856405389],
            [32.46283732837878, 0.132512896386394],
            [32.462232352560825, 0.157869131795602],
            [32.46104459649888, 0.160163014158142],
            [32.45442542680318, 0.166458128769512],
            [32.45158602286998, 0.170651396064051],
            [32.44900861079276, 0.175681193977855],
            [32.44817780839383, 0.178500952659681],
            [32.447417409658655, 0.179528340055707],
            [32.447359753088755, 0.182981662323],
            [32.446051855442434, 0.182885627518721],
            [32.44543553839399, 0.186637501744893],
            [32.444651134877766, 0.187210800813318],
            [32.44217843402335, 0.187807445155168],
            [32.43988348191587, 0.187268963722443],
            [32.437170904829415, 0.183802781168518],
            [32.43607671818581, 0.18310936078225],
            [32.43495549854035, 0.183944432182961],
            [32.432439702806775, 0.18769123522234],
            [32.431893937644126, 0.187796042002203],
            [32.42971835097663, 0.187946689563816],
            [32.41589782961926, 0.185073586182374],
            [32.41377707252348, 0.192709106019728],
            [32.41381411724918, 0.195397686260809],
            [32.41345815173301, 0.196783678914052],
            [32.416088644362056, 0.20250823286713],
            [32.418752981019416, 0.204683889341922],
            [32.419861300857384, 0.209762681906],
            [32.42158661507352, 0.212404037004408],
            [32.423062668357915, 0.217395321887361],
            [32.42066119222739, 0.218434742408344],
            [32.416656747032555, 0.221649652557156],
            [32.41318636913873, 0.221481957212075],
            [32.41078425520437, 0.222809016728644],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 11,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KASANJE",
        Population: 29008,
        Key: "WAKISOKASANJE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.303376787670445, 0.234924739930677],
            [33.30178280804716, 0.234252416762976],
            [33.30012027439127, 0.232946154127491],
            [33.29809067024566, 0.230198436728734],
            [33.297580211568594, 0.228687981097053],
            [33.29534785496843, 0.226617105829358],
            [33.29168592571333, 0.224781953570537],
            [33.286647550169164, 0.223327330837885],
            [33.28517884240887, 0.224602024199326],
            [33.28216163582981, 0.225653539038031],
            [33.280362930153274, 0.22699710189536],
            [33.27920247928274, 0.228165409198169],
            [33.278100075749215, 0.230501999264438],
            [33.27824514737937, 0.231115345997474],
            [33.281552525066566, 0.232634048736182],
            [33.284627823000136, 0.234853726009289],
            [33.28573030738203, 0.236547714214078],
            [33.280218087593504, 0.237891355987355],
            [33.27592438936874, 0.240578499004737],
            [33.27184796486512, 0.242094840854432],
            [33.26867648790734, 0.237808108030649],
            [33.26674783284012, 0.237503576379165],
            [33.26020554276305, 0.237084920131572],
            [33.252566575912425, 0.237275419730057],
            [33.250411034252195, 0.237846529542673],
            [33.247121024592715, 0.240245077849163],
            [33.24605762590883, 0.24274316715827],
            [33.246712184238916, 0.249333799489727],
            [33.24618909435064, 0.250147686066786],
            [33.23903212665056, 0.254169332780238],
            [33.23615459821668, 0.256606493630403],
            [33.229509332462, 0.267889419309988],
            [33.226650178168946, 0.267700662872633],
            [33.22143555765764, 0.268303764495409],
            [33.21884308352806, 0.267574828240507],
            [33.2125676011752, 0.264532202497956],
            [33.210665940482265, 0.263961710087938],
            [33.19992155428829, 0.262202692557467],
            [33.19126899584471, 0.261584658098401],
            [33.18375743345752, 0.261632199142625],
            [33.17888684434386, 0.260999245590034],
            [33.18088924031611, 0.246130121824464],
            [33.18065486896019, 0.244697690395755],
            [33.19831052104763, 0.234304739597608],
            [33.198607531928324, 0.115691683071342],
            [33.19860101644758, 0.113575123547645],
            [33.20986538346064, 0.109275501878672],
            [33.2211636007902, 0.105698514628685],
            [33.2387434485424, 0.09886881676834],
            [33.2466508284067, 0.110319844479457],
            [33.248018851193315, 0.117636078879741],
            [33.25049194011994, 0.141860857004305],
            [33.25020676274648, 0.155074389045606],
            [33.251633517386395, 0.164074889370638],
            [33.25311560465452, 0.168716677768402],
            [33.2569989524575, 0.173065179933462],
            [33.26007703067682, 0.175048356282269],
            [33.26743528298433, 0.177559359294007],
            [33.2733995565834, 0.17337901572347],
            [33.27829638279162, 0.168854736550404],
            [33.27980705355376, 0.173806764549031],
            [33.279466580382994, 0.176777805377085],
            [33.279587270838036, 0.183922287028692],
            [33.282083894726824, 0.181217263235376],
            [33.29089564092695, 0.174619579816952],
            [33.289392233043884, 0.181165722653665],
            [33.289772802517355, 0.189160833350817],
            [33.290081923586385, 0.190094389820471],
            [33.29357727195016, 0.194570634625766],
            [33.29350604632794, 0.20055500209513],
            [33.294623665525734, 0.205055224455405],
            [33.29770416650139, 0.210373148615504],
            [33.300623014743394, 0.214063210250584],
            [33.30121912688446, 0.216713335698841],
            [33.302067641365866, 0.21831493317247],
            [33.303953225808485, 0.21947493899617],
            [33.30527629061006, 0.223486848860157],
            [33.30470574452199, 0.228729160439923],
            [33.303376787670445, 0.234924739930677],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1729,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "BUVUMA TOWN COUNCIL",
        Population: 9935,
        Key: "BUVUMABUVUMA TOWN COUNCIL",
        Dist2: "Buvuma",
        "Sub Country": "Buvuma TC",
        id2_original: "Buvuma Buvuma TC",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.86445701673169, 0.372995131578765],
            [32.86271140687833, 0.373090013221264],
            [32.861091898032996, 0.373850828781317],
            [32.8601741593758, 0.375372497431963],
            [32.85894780180779, 0.375838711249761],
            [32.84729926217866, 0.369856179404566],
            [32.84729931607758, 0.366704121765282],
            [32.83704262884461, 0.360888937506812],
            [32.833803674934295, 0.359312851113307],
            [32.83125757812789, 0.359031515972328],
            [32.830449144677814, 0.35821761874249],
            [32.82878470389859, 0.357619145828107],
            [32.82791683970598, 0.356087119487434],
            [32.82422181561748, 0.352546621224659],
            [32.82249444875091, 0.347764161711005],
            [32.821246821771915, 0.34576124636413],
            [32.81991578621883, 0.345458642687853],
            [32.81358728260295, 0.346840109602298],
            [32.80782475175211, 0.345637935073032],
            [32.80327703242288, 0.346704012837866],
            [32.80067859886968, 0.346825755685369],
            [32.79977655018726, 0.347486170586544],
            [32.799063189036964, 0.348730911660527],
            [32.7981358473894, 0.349042081407666],
            [32.79559155260344, 0.352129979694091],
            [32.79506841330785, 0.35335078679207],
            [32.79554392302877, 0.355505183202168],
            [32.79497325387149, 0.355529107572564],
            [32.7946076781784, 0.35639811202403],
            [32.787880654953064, 0.353602772010225],
            [32.7883209363418, 0.353439483857727],
            [32.788593117788054, 0.350969845309008],
            [32.78654182920981, 0.348306861690982],
            [32.784220591498794, 0.347274241245015],
            [32.78128498428687, 0.34679094660579],
            [32.776936864325585, 0.342104243781257],
            [32.77580323445446, 0.338492570697834],
            [32.77313606271406, 0.336665588123289],
            [32.77149625733317, 0.336279183568558],
            [32.77031003649206, 0.335120056049413],
            [32.76386774687245, 0.331513480028515],
            [32.76263776550058, 0.329325707263568],
            [32.76252004128259, 0.325589840302034],
            [32.761211590274065, 0.323207468200791],
            [32.759730649256234, 0.322058039915882],
            [32.75652069565821, 0.320573834403513],
            [32.755055396106115, 0.318381640524811],
            [32.75396826033916, 0.319949264408204],
            [32.75085995111555, 0.319448512636618],
            [32.747528025166574, 0.317312127296183],
            [32.7457294650171, 0.314884954066149],
            [32.74339524215868, 0.308489608019303],
            [32.74188369194585, 0.30619728592167],
            [32.7361435264506, 0.301959304302192],
            [32.731608849760995, 0.296546317083432],
            [32.72326638346528, 0.294850974378603],
            [32.71917170968665, 0.293194263857013],
            [32.71555537172884, 0.292365867182227],
            [32.71002941310636, 0.292405721319181],
            [32.70537602674689, 0.291286881452486],
            [32.69988458678752, 0.289071507169286],
            [32.69548375278703, 0.288454976965389],
            [32.6874473955092, 0.289379372064335],
            [32.70549137492096, 0.269789540034848],
            [32.706888181525905, 0.269115374445745],
            [32.74961474509627, 0.268904449646911],
            [32.7529124039104, 0.269124617109757],
            [32.75612432032731, 0.270727875605949],
            [32.761630494453975, 0.271923589910474],
            [32.76341189228993, 0.272901845096225],
            [32.76783845044691, 0.27279324180644],
            [32.76940392383128, 0.273608455455861],
            [32.77302068040403, 0.276977952276157],
            [32.773668519335764, 0.274315030739997],
            [32.77480216986816, 0.273282486602741],
            [32.778230074517026, 0.27211412043495],
            [32.780551324804435, 0.271788089558297],
            [32.78410262114243, 0.269003380917505],
            [32.787630410366056, 0.265278512164248],
            [32.78899122866409, 0.264627372597704],
            [32.79611695026366, 0.264127591226796],
            [32.80673209853268, 0.266571144291052],
            [32.80877742499236, 0.266268370397779],
            [32.811738287440186, 0.262781553665171],
            [32.812927181667575, 0.261943754088959],
            [32.81750251071706, 0.260131552965305],
            [32.82373758056022, 0.253691669997149],
            [32.827192435565905, 0.255485127977009],
            [32.83345441174846, 0.255159137987045],
            [32.83766512270896, 0.249235499575253],
            [32.83858285597624, 0.24678994895739],
            [32.84789496199302, 0.235785030355621],
            [32.850540114229176, 0.23486118016688],
            [32.855128671869544, 0.230404869710022],
            [32.859609223266666, 0.22991580296759],
            [32.86476459629174, 0.225106243787159],
            [32.86597518213828, 0.222411033722316],
            [32.867506073079184, 0.222357225940412],
            [32.86876221878199, 0.221489667394554],
            [32.86908026641001, 0.220996365725599],
            [32.86871842052199, 0.219122230659786],
            [32.86911281955929, 0.215666658520109],
            [32.87121614933855, 0.21199053363689],
            [32.87340709540075, 0.210725957764515],
            [32.87467783154044, 0.211520015474214],
            [32.87634292449656, 0.213828647392141],
            [32.877453006829136, 0.212769927284216],
            [32.8779642362607, 0.211578861012399],
            [32.877306978493166, 0.208608530527976],
            [32.87681037004116, 0.208108571072569],
            [32.87371384312082, 0.208696729232689],
            [32.87279365475787, 0.208079128983318],
            [32.87254535861671, 0.206917465818566],
            [32.872501544187045, 0.206329282439639],
            [32.875028460165495, 0.201594428224719],
            [32.87486779647695, 0.20088860739503],
            [32.873932997914174, 0.200844486012664],
            [32.87375772672079, 0.200432756506436],
            [32.8744588483253, 0.197624187122712],
            [32.87700034396084, 0.195933180557208],
            [32.88135301299072, 0.19408043487948],
            [32.883658717932164, 0.19206409502737],
            [32.88608793493695, 0.190759810497051],
            [32.88797732464311, 0.189944634299662],
            [32.88936996576011, 0.189933067655626],
            [32.89132423449104, 0.189890309879628],
            [32.8920799844446, 0.190488120136297],
            [32.8948600079409, 0.201656226543732],
            [32.89512696209051, 0.228784974120295],
            [32.89607805070261, 0.231346318942374],
            [32.897632215195884, 0.233732217499852],
            [32.89893792634283, 0.238355004840601],
            [32.8998531245644, 0.240214703381461],
            [32.90260615548305, 0.242496863892041],
            [32.90452491201415, 0.243333858042262],
            [32.906007101690214, 0.244722533078367],
            [32.90584505010455, 0.245808212610449],
            [32.90290293370006, 0.251924190795645],
            [32.90279508196708, 0.253172722825728],
            [32.90619595361408, 0.258121740395439],
            [32.90824724219233, 0.265458459853574],
            [32.908004543453714, 0.267928969902923],
            [32.90641894421371, 0.269487124644979],
            [32.90119413770539, 0.273266844416603],
            [32.89543405386534, 0.280034201259688],
            [32.89365716916536, 0.281201291055281],
            [32.889037593596534, 0.285426352152205],
            [32.886846171427244, 0.28817671924432],
            [32.885860941444456, 0.292465144101208],
            [32.884152825474416, 0.296916413525586],
            [32.88141797645712, 0.299467730923156],
            [32.878887277673, 0.303738042531258],
            [32.87756057379621, 0.304986558294398],
            [32.87556039396773, 0.307990248067468],
            [32.87425415371309, 0.312224381665336],
            [32.87378482529963, 0.315897590679279],
            [32.872845959165275, 0.318448105846296],
            [32.87305004292309, 0.324284453778404],
            [32.873641757810866, 0.325532993133626],
            [32.876825602773444, 0.329522904870247],
            [32.87837663304471, 0.333919925488402],
            [32.8777233799667, 0.335231780304529],
            [32.87472339858321, 0.338045460023874],
            [32.872886410302534, 0.338543038966258],
            [32.871906839706, 0.338253511610133],
            [32.86819236798993, 0.343066638453781],
            [32.86576365224506, 0.343120887639458],
            [32.86486561004878, 0.353848872470383],
            [32.86341647118867, 0.35616709405398],
            [32.864437023826724, 0.35789514871697],
            [32.86504922479454, 0.36019317734846],
            [32.8645388532541, 0.365721084887406],
            [32.865518396002834, 0.367982930832075],
            [32.864334623969185, 0.369466673512688],
            [32.86445701673169, 0.372995131578765],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1732,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "NAKISUNGA",
        Population: 48330,
        Key: "MUKONONAKISUNGA",
        Dist2: "Mukono",
        "Sub Country": "Nakisunga",
        id2_original: "MukonoNakisunga",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.95609217268964, 0.493018160825697],
            [32.950970207111666, 0.493086152690301],
            [32.94462110692298, 0.494930187083022],
            [32.933363477274575, 0.495341868706768],
            [32.926605355272414, 0.494840490952913],
            [32.923830952534864, 0.495807261259871],
            [32.91739281762342, 0.505976500541091],
            [32.91490294098076, 0.508662027383938],
            [32.900550625060006, 0.519028073641609],
            [32.897278237651456, 0.520317087780844],
            [32.8947527868252, 0.522501299456534],
            [32.8932779058423, 0.52241128931238],
            [32.892188084112654, 0.523000458110612],
            [32.89078512584462, 0.524628199362351],
            [32.89007173055837, 0.526926208694749],
            [32.888771696764046, 0.527968830980187],
            [32.88842798337002, 0.524507006438644],
            [32.888653029315, 0.522841400047953],
            [32.889261923584236, 0.521242424791225],
            [32.89122092823336, 0.518923929934875],
            [32.89078423741082, 0.512727850152263],
            [32.88878486516779, 0.505556528457517],
            [32.88696492331791, 0.503474484129994],
            [32.88597226875928, 0.49997668542518],
            [32.885020952873404, 0.497977936952631],
            [32.88357327826719, 0.496145738268453],
            [32.87644796450273, 0.494182383637141],
            [32.87467782165897, 0.489283854972434],
            [32.873376888651016, 0.48751575445755],
            [32.871750684661855, 0.487319271268763],
            [32.866676906512375, 0.487908529483711],
            [32.86348952128923, 0.488890728798163],
            [32.86114774809084, 0.490527787521055],
            [32.8566594029103, 0.491182533825513],
            [32.85490307885056, 0.49209927483987],
            [32.85366716680118, 0.491837309709172],
            [32.8530132956823, 0.492082653026912],
            [32.83666786158955, 0.485359930270296],
            [32.837122904095025, 0.483277933506511],
            [32.83832248108777, 0.481029392525915],
            [32.837908878764665, 0.47994673789724],
            [32.837707017438866, 0.479649158037351],
            [32.835974337935696, 0.479525866787185],
            [32.83521657216261, 0.480433971486886],
            [32.832504257384244, 0.476409524570053],
            [32.83074101539849, 0.475729473070079],
            [32.83024558733276, 0.475684118694669],
            [32.82897845074245, 0.476552144257594],
            [32.82339950499291, 0.481850312322909],
            [32.821933524517846, 0.483541123330465],
            [32.821687947577026, 0.484684074643644],
            [32.81626746823691, 0.480494001989959],
            [32.813561300630006, 0.480559516514453],
            [32.811402323812146, 0.481102251412091],
            [32.81295289324763, 0.478384792920992],
            [32.8136187981981, 0.474147847519261],
            [32.816115630496014, 0.469671574818499],
            [32.821253015655806, 0.464333174911275],
            [32.82936191279114, 0.468330874293119],
            [32.83105015533216, 0.468809670209354],
            [32.83212022849858, 0.466583492729439],
            [32.833527148337005, 0.461196190479981],
            [32.83709699847886, 0.460063457802281],
            [32.84553664542035, 0.454692529090901],
            [32.84930058376585, 0.449653522650179],
            [32.85102739367695, 0.444594939929016],
            [32.85252146896254, 0.435239454262629],
            [32.85067855719088, 0.425141712118432],
            [32.8494951283137, 0.423012771296092],
            [32.84602249744515, 0.414282192781806],
            [32.845362870820196, 0.413735301934603],
            [32.844412255620234, 0.411762617723945],
            [32.84495559263669, 0.406254790003098],
            [32.84427663247021, 0.402172726852099],
            [32.843229012694316, 0.400180509119254],
            [32.843112635050936, 0.398696124999126],
            [32.84390810581142, 0.397270353376586],
            [32.84802121840958, 0.392504781811497],
            [32.848370474408895, 0.390473528165741],
            [32.84926978053478, 0.388708474658512],
            [32.85334115650649, 0.388725512612374],
            [32.85316572541296, 0.387577422854803],
            [32.851767186856144, 0.385521826026456],
            [32.853550655308844, 0.384672810597903],
            [32.853977516765546, 0.382446244124927],
            [32.8544043503745, 0.381782185607482],
            [32.855878836996986, 0.381352521053668],
            [32.85661609243551, 0.380415028497173],
            [32.856771319519986, 0.379282212241947],
            [32.85770258141545, 0.378500973504803],
            [32.85816823751604, 0.376625973299962],
            [32.85894780180779, 0.375838711249761],
            [32.8601741593758, 0.375372497431963],
            [32.861091898032996, 0.373850828781317],
            [32.86271140687833, 0.373090013221264],
            [32.86445701673169, 0.372995131578765],
            [32.867436759970175, 0.372461385490627],
            [32.874416779322225, 0.368642180018109],
            [32.877845404419965, 0.36753074440245],
            [32.879478235280985, 0.366463181469699],
            [32.88017219731269, 0.366381765227209],
            [32.88127420199424, 0.367901731092929],
            [32.88416860348407, 0.36981682862501],
            [32.88737631129384, 0.370344591319746],
            [32.89088684567752, 0.369892269367405],
            [32.891968359787406, 0.370652258770286],
            [32.89118304627783, 0.374843842132099],
            [32.89165856677851, 0.378003629390899],
            [32.8938664847114, 0.378071094993471],
            [32.89958077153994, 0.379591119026284],
            [32.908275069304885, 0.382803018254078],
            [32.90890780216683, 0.383391102480316],
            [32.90898946531436, 0.38922663522833],
            [32.90915261374302, 0.39058583832353],
            [32.90972412641833, 0.391452289051376],
            [32.90896888131794, 0.396808304326128],
            [32.908928124753494, 0.399893445094189],
            [32.91015259765604, 0.40030058938329],
            [32.91268328476206, 0.399812060609627],
            [32.92031624188345, 0.402399960881842],
            [32.923316405624945, 0.399050975191819],
            [32.930214676489534, 0.398391798414736],
            [32.93201881427862, 0.398663233981237],
            [32.93417399930767, 0.399794169299684],
            [32.93774546282377, 0.403015051807958],
            [32.939623178024526, 0.403965037088309],
            [32.94550094745499, 0.4056840740869],
            [32.94735816849082, 0.405629802830952],
            [32.949664866968945, 0.411041278366466],
            [32.95298163115255, 0.4108188091217],
            [32.9605117841745, 0.41116209776378],
            [32.970093878849916, 0.409773605664154],
            [32.97380832541317, 0.409239825084825],
            [32.97005341064471, 0.416731014903564],
            [32.96822143047172, 0.4244755362214],
            [32.967438992469354, 0.425660735400408],
            [32.96558934602799, 0.426411656810844],
            [32.9626904511651, 0.42944250421341],
            [32.958440099347754, 0.437910797483893],
            [32.957372882823904, 0.438770289377251],
            [32.95676821153479, 0.440805938504638],
            [32.95518535305474, 0.443221570267488],
            [32.95340701577892, 0.447093822882156],
            [32.95056147545405, 0.449274213506224],
            [32.94985008251256, 0.450776067688897],
            [32.95004569246229, 0.453697913320895],
            [32.951575140708826, 0.455989603297479],
            [32.95157512903073, 0.457744170167112],
            [32.95059705323086, 0.462275247691568],
            [32.94956543784004, 0.464207405917395],
            [32.94967214062781, 0.46481613375559],
            [32.95027680473038, 0.466033593765912],
            [32.95230422596985, 0.467394292359726],
            [32.953691406228224, 0.468969829969648],
            [32.95402930482738, 0.470133576305845],
            [32.95337122689802, 0.477850085772429],
            [32.9535490591883, 0.479712075631457],
            [32.95493622776855, 0.483400257237722],
            [32.95609217268964, 0.493018160825697],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1735,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "NAGOJJE",
        Population: 34503,
        Key: "MUKONONAGOJJE",
        Dist2: "Mukono",
        "Sub Country": "Nagojje",
        id2_original: "MukonoNagojje",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.7830592512961, 0.503184894626518],
            [32.780044925614156, 0.502691679248978],
            [32.77850006497229, 0.502957149040027],
            [32.769965624208766, 0.505441377902955],
            [32.76815703077591, 0.505099926269591],
            [32.76608472970486, 0.503468788132682],
            [32.76356026702542, 0.502179017851856],
            [32.760564794286324, 0.501477171278424],
            [32.75928368889333, 0.501780577315139],
            [32.7573243770204, 0.50159084602753],
            [32.748789971291195, 0.503316410097436],
            [32.7464161444068, 0.504264609004765],
            [32.743703241231934, 0.50430243290139],
            [32.74178157954918, 0.504871330976803],
            [32.74121635687747, 0.505743734563748],
            [32.741159670488095, 0.509935178201182],
            [32.74066975268834, 0.512135193279171],
            [32.73557809536973, 0.518218266605894],
            [32.73388234920116, 0.52253291524652],
            [32.732092501811636, 0.524429418604944],
            [32.72827738015618, 0.526610318696339],
            [32.72410908944004, 0.527107984983947],
            [32.7221308401826, 0.529099303681952],
            [32.714170836110675, 0.534741254868189],
            [32.71165084434642, 0.538747655061517],
            [32.70915420788124, 0.54676057058939],
            [32.70724650691631, 0.550529921839787],
            [32.705880366998514, 0.555840266345474],
            [32.70566818762335, 0.560510572725823],
            [32.70689253027018, 0.565252074183393],
            [32.70696298962949, 0.569021523177264],
            [32.706962830627695, 0.572150872968353],
            [32.70614212619084, 0.574301069835346],
            [32.701427172895066, 0.570582415218349],
            [32.688303554653665, 0.56389582229019],
            [32.68417080668006, 0.560421469502688],
            [32.68166583025575, 0.557272904731814],
            [32.67859588089141, 0.552504860935037],
            [32.675735232700085, 0.54651545755548],
            [32.6725564030317, 0.535007247907714],
            [32.66957755541359, 0.528420729043808],
            [32.66884274069772, 0.524422809976232],
            [32.66555400754421, 0.520128266996544],
            [32.66324038664852, 0.513370644425656],
            [32.663130565808395, 0.508016426413061],
            [32.6626268570724, 0.50325334361108],
            [32.6631987560233, 0.49913980090334],
            [32.66447775486692, 0.496875617183571],
            [32.66733339764552, 0.495157252049893],
            [32.67395089108491, 0.491211312992973],
            [32.675287288681965, 0.489569859140916],
            [32.67703831986804, 0.480572227228607],
            [32.677407735858985, 0.472452721534011],
            [32.67700368262732, 0.471473836325655],
            [32.67734960048706, 0.47209326030835],
            [32.686448792306756, 0.466073524355887],
            [32.69173900515091, 0.463539940011279],
            [32.69330650064301, 0.462235164371512],
            [32.69589894333157, 0.458927651906706],
            [32.701008286681464, 0.456515426256856],
            [32.70435429641747, 0.453329318258957],
            [32.70724808345965, 0.451903211785797],
            [32.70833329862851, 0.45029495927007],
            [32.712900140395185, 0.445879910601938],
            [32.71374420821592, 0.444271645984548],
            [32.72113575388449, 0.436606625401136],
            [32.72460847188962, 0.437436162197278],
            [32.72656944564585, 0.438751508850281],
            [32.72986748534566, 0.442384431000551],
            [32.732622387455024, 0.443634529605593],
            [32.73343718007897, 0.445040805283256],
            [32.73479522707436, 0.445783041011023],
            [32.73543540427508, 0.447365091460824],
            [32.73659943133876, 0.448380756775441],
            [32.73865591307766, 0.449240204335076],
            [32.74280762448693, 0.452560661076144],
            [32.747541453183445, 0.453576452325125],
            [32.74975312787084, 0.454943716181262],
            [32.75485567277067, 0.453322801185572],
            [32.75698985967996, 0.451330688325088],
            [32.758348151017124, 0.444846362718401],
            [32.759376448031254, 0.443615927850265],
            [32.759298909947525, 0.441584676614384],
            [32.759764584912716, 0.440061257136323],
            [32.759687082761566, 0.43685813110273],
            [32.7591051424424, 0.434006551109183],
            [32.75945438227205, 0.433342498642636],
            [32.76213176606062, 0.432131648193255],
            [32.76380026183504, 0.431975450877756],
            [32.76541052701611, 0.432698157288109],
            [32.7663381507347, 0.433823392570271],
            [32.77108086826097, 0.433997158594029],
            [32.77286042095735, 0.436487452066548],
            [32.776546586758805, 0.437815689333885],
            [32.7826191010614, 0.438772903398086],
            [32.786339014771485, 0.433070991507133],
            [32.788666458942785, 0.436468792802885],
            [32.79075887868293, 0.438240236001592],
            [32.79232816541571, 0.440610104379479],
            [32.79663192028008, 0.443482738634154],
            [32.80075882471276, 0.450394533545119],
            [32.80217332094229, 0.451869267303568],
            [32.80329487745599, 0.452099756155498],
            [32.80417376936703, 0.453328697542525],
            [32.81420357270196, 0.46025820357999],
            [32.8199656840396, 0.461957577807228],
            [32.820780516189394, 0.462699788443547],
            [32.821253015655806, 0.464333174911275],
            [32.816115630496014, 0.469671574818499],
            [32.8136187981981, 0.474147847519261],
            [32.81295289324763, 0.478384792920992],
            [32.811402323812146, 0.481102251412091],
            [32.804216824720285, 0.481507547086365],
            [32.802973393772, 0.482076486634533],
            [32.80210673152524, 0.483479938560176],
            [32.80048648965461, 0.484693707832057],
            [32.78882463160308, 0.489188264236378],
            [32.785960943512805, 0.491274419118789],
            [32.784491393132775, 0.493133026842439],
            [32.78266383087434, 0.496793381307844],
            [32.782324648582644, 0.498879615546155],
            [32.7830592512961, 0.503184894626518],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1738,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "KYAMPISI",
        Population: 45074,
        Key: "MUKONOKYAMPISI",
        Dist2: "Mukono",
        "Sub Country": "Mpatta",
        id2_original: "MukonoMpatta",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [32.3306690594157, 0.489965049528432],
            [32.33073446844646, 0.493095513687219],
            [32.33124902972943, 0.494160779059849],
            [32.334042028491666, 0.49710825592026],
            [32.33302379710027, 0.497109357213349],
            [32.333831881105674, 0.498808124037333],
            [32.33421133936317, 0.503018038096899],
            [32.33467462391138, 0.504728525948865],
            [32.33619596486248, 0.506930072572055],
            [32.336385629761686, 0.509274210485239],
            [32.335992694080005, 0.511701661169797],
            [32.33437474381166, 0.515671005958245],
            [32.33362539525279, 0.516926206874388],
            [32.327084975468175, 0.521561847089692],
            [32.32360027483546, 0.52582886317257],
            [32.31786850319822, 0.529819243896232],
            [32.3146697857278, 0.531527171622325],
            [32.311079056942106, 0.531811684569187],
            [32.30607763359714, 0.533981931203344],
            [32.30427031307704, 0.534411203046167],
            [32.2975519244582, 0.53752782276248],
            [32.294365370176706, 0.538147456039472],
            [32.290869791844244, 0.538360261132867],
            [32.28845636901875, 0.537724732888602],
            [32.28508015971956, 0.53609592253949],
            [32.28871243468882, 0.531869184151621],
            [32.29185631719768, 0.527111049906004],
            [32.29409881398078, 0.520591736347587],
            [32.30223691534599, 0.508389330265933],
            [32.30497739949504, 0.503207393861728],
            [32.30667793548071, 0.497471291876381],
            [32.306970776381874, 0.496562641527248],
            [32.3087144970782, 0.495309058967107],
            [32.31041663565832, 0.493307195637773],
            [32.31232843204262, 0.492359226011751],
            [32.31683622125746, 0.492275367782523],
            [32.32529960348539, 0.49016258452853],
            [32.3306690594157, 0.489965049528432],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 13,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "MASULIITA",
        Population: 10714,
        Key: "WAKISOMASULIITA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.375824362087144, 0.492692273080935],
            [32.37368223227408, 0.4964481806949],
            [32.37362565907243, 0.504001028350924],
            [32.37518272153081, 0.504910378327774],
            [32.377861699829, 0.504910638829083],
            [32.37794971316728, 0.503053745651505],
            [32.384624613444906, 0.509288276648601],
            [32.38963114640716, 0.510305635927599],
            [32.38998272634814, 0.507785583726524],
            [32.39039611038062, 0.50740418210945],
            [32.396131292921, 0.508968330037624],
            [32.40048223179564, 0.512032893627334],
            [32.40158906043027, 0.513216230224968],
            [32.40151577497107, 0.515752967619505],
            [32.40096853387639, 0.5170920408023],
            [32.400979614595414, 0.520572230236354],
            [32.401560910822525, 0.526157656067244],
            [32.40248770270114, 0.528789354099935],
            [32.40278900932555, 0.53125937020154],
            [32.39958060621972, 0.534275236364586],
            [32.40000842168724, 0.536070515702149],
            [32.402221524695946, 0.539466973436905],
            [32.399570271102384, 0.541502423981497],
            [32.398119235898655, 0.543510604014296],
            [32.397060888441615, 0.544167637248919],
            [32.39601425591419, 0.545554207735134],
            [32.39522946073254, 0.545816769790907],
            [32.39346922091645, 0.54811175566107],
            [32.389033715539256, 0.550656051159798],
            [32.386643050633204, 0.554062814642923],
            [32.38357487993311, 0.556548240177707],
            [32.380318006429526, 0.552695078433936],
            [32.3789865477699, 0.551880924607937],
            [32.37771461417594, 0.551361153830049],
            [32.37523078409348, 0.551186481813456],
            [32.37504793291569, 0.550879617131348],
            [32.37259647003121, 0.551248137524545],
            [32.372862780088774, 0.554089156506878],
            [32.370899812970954, 0.558811728468188],
            [32.36985255611441, 0.562685814148344],
            [32.36978986987725, 0.56693133964009],
            [32.364875242653376, 0.566688712063172],
            [32.35896641846352, 0.565094014316001],
            [32.349847988323724, 0.561057373505513],
            [32.33963570571353, 0.557115647704727],
            [32.33602175907102, 0.55505613234136],
            [32.332967425121254, 0.551987343081844],
            [32.32960323887381, 0.549748643645612],
            [32.32188736815, 0.547674295221298],
            [32.315704884785255, 0.547191596756892],
            [32.313208415406734, 0.545802588731006],
            [32.30936922878313, 0.541243453042419],
            [32.30818078910327, 0.539161721460365],
            [32.30771782166036, 0.536279245389937],
            [32.30607763359714, 0.533981931203344],
            [32.311079056942106, 0.531811684569187],
            [32.3146697857278, 0.531527171622325],
            [32.31786850319822, 0.529819243896232],
            [32.32360027483546, 0.52582886317257],
            [32.327084975468175, 0.521561847089692],
            [32.33362539525279, 0.516926206874388],
            [32.33437474381166, 0.515671005958245],
            [32.335992694080005, 0.511701661169797],
            [32.336385629761686, 0.509274210485239],
            [32.33619596486248, 0.506930072572055],
            [32.33467462391138, 0.504728525948865],
            [32.33421133936317, 0.503018038096899],
            [32.333831881105674, 0.498808124037333],
            [32.33302379710027, 0.497109357213349],
            [32.334042028491666, 0.49710825592026],
            [32.33124902972943, 0.494160779059849],
            [32.33073446844646, 0.493095513687219],
            [32.3306690594157, 0.489965049528432],
            [32.33479047693862, 0.490587755953016],
            [32.342157495905006, 0.490443124407825],
            [32.34891711090718, 0.489387868902279],
            [32.3574225010527, 0.487410643695466],
            [32.3630289702842, 0.487162409532662],
            [32.365435838103075, 0.48757473570369],
            [32.36959653536011, 0.489269742953893],
            [32.375824362087144, 0.492692273080935],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 14,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "MASULITA TOWN COUNCIL",
        Population: 14589,
        Key: "WAKISOMASULITA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.42308374013953, 0.491003780141873],
            [32.41706555953858, 0.490722941158055],
            [32.406452136034915, 0.491198600502274],
            [32.39892255613812, 0.492006172385623],
            [32.38892449926534, 0.494006757851496],
            [32.3886941775147, 0.488255386972023],
            [32.38944194324203, 0.487360020969229],
            [32.38970705764195, 0.485964838542378],
            [32.38959230954248, 0.481309402797016],
            [32.38863954557236, 0.479531426265773],
            [32.38862502161085, 0.476878849319433],
            [32.387164263042514, 0.472844683579669],
            [32.38799704083675, 0.471252433355239],
            [32.387581552051536, 0.46881802426183],
            [32.388201117408066, 0.467276103152774],
            [32.38797295969893, 0.46299963989449],
            [32.38814538682617, 0.461770892397239],
            [32.39064249311023, 0.46020109233336],
            [32.39152450666689, 0.45872601264218],
            [32.39256222700838, 0.458156470237765],
            [32.393582409540564, 0.456372781909539],
            [32.39508915825821, 0.45536003534815],
            [32.39514206813012, 0.454085902381962],
            [32.39632265922935, 0.451887180949847],
            [32.39740058906124, 0.45081005709056],
            [32.40328701286118, 0.446902613309908],
            [32.407194523548654, 0.442588296676292],
            [32.41075481381926, 0.440566449344001],
            [32.41241675099381, 0.440423871159269],
            [32.41453698976167, 0.439095443019071],
            [32.41573614993614, 0.434892082163736],
            [32.4181120285726, 0.433158991551279],
            [32.41887587863512, 0.431732811133815],
            [32.41875910303807, 0.428586542439484],
            [32.42048971012787, 0.420036450339816],
            [32.420317899244935, 0.416372215702024],
            [32.42298816568151, 0.415271415007519],
            [32.42789758267672, 0.414491051012673],
            [32.429884579728395, 0.413813060772817],
            [32.43330378599036, 0.411899388980955],
            [32.43602456469536, 0.409359404865914],
            [32.43746766957173, 0.408878138433502],
            [32.441458380424216, 0.408677353908049],
            [32.44516833002113, 0.408787282443724],
            [32.449604903495214, 0.409829640239962],
            [32.455819080321476, 0.413143986920702],
            [32.45571001137126, 0.415701869187027],
            [32.45302390583961, 0.416871001958432],
            [32.4511725346329, 0.419648006781891],
            [32.44783298108887, 0.422096031344024],
            [32.445909148178075, 0.422936341121159],
            [32.44612689980296, 0.423411392320464],
            [32.45090645903565, 0.425284186388776],
            [32.45195315714007, 0.424273313930003],
            [32.4518243369317, 0.423063946024583],
            [32.453878907055675, 0.423039960762016],
            [32.46173751648485, 0.424383566531098],
            [32.4631888122, 0.420802928000986],
            [32.46549373920042, 0.419094431223687],
            [32.46830866314378, 0.418132947817039],
            [32.471040618687525, 0.4180098118326],
            [32.47416100216689, 0.415157313098044],
            [32.47622299327342, 0.414338821995064],
            [32.48214428428276, 0.414486608061522],
            [32.48378035177376, 0.415841768227568],
            [32.48544691078044, 0.416017432745941],
            [32.4877493090233, 0.417421643853599],
            [32.4874681956282, 0.417708794386335],
            [32.48858525697219, 0.420981712173053],
            [32.488558276072645, 0.424047631873913],
            [32.48982806538799, 0.426375056866435],
            [32.489940274848436, 0.429203093741711],
            [32.49105835039042, 0.432546746071677],
            [32.49062246266171, 0.433637946083414],
            [32.49105820306669, 0.435824493036336],
            [32.49046514968918, 0.4375547103076],
            [32.490963488296394, 0.439139010929094],
            [32.49099655258706, 0.441425869068586],
            [32.49046389833598, 0.442400593007351],
            [32.49118261254705, 0.444429661179097],
            [32.49185966918341, 0.44522134503707],
            [32.49166110916628, 0.44628543555953],
            [32.4924733622529, 0.44820700096869],
            [32.49554873744156, 0.450460436409414],
            [32.493511363767084, 0.45258940896333],
            [32.488743027187226, 0.454912242002475],
            [32.48306695289426, 0.456930211957448],
            [32.47915652537705, 0.457754690001649],
            [32.477752581657164, 0.457657647199728],
            [32.474985850532114, 0.458665561554079],
            [32.47416798117833, 0.459644529386328],
            [32.47266105189931, 0.463935042064186],
            [32.470280461599174, 0.466988749728895],
            [32.46316184387687, 0.474463477745481],
            [32.45402914220212, 0.485682059056758],
            [32.44974395371803, 0.488540010523899],
            [32.4427271267955, 0.491544615231605],
            [32.43859973188267, 0.492160036440867],
            [32.42308374013953, 0.491003780141873],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 15,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "MENDE",
        Population: 26327,
        Key: "WAKISOMENDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.28508015971956, 0.53609592253949],
            [32.272045149501125, 0.551992280891796],
            [32.26860788530531, 0.556594080840396],
            [32.26374294569645, 0.564639057701694],
            [32.261578324763626, 0.567388081837811],
            [32.25953286894653, 0.56913264468651],
            [32.25601020730654, 0.570617083079202],
            [32.25062284256272, 0.574383191489135],
            [32.24823289720721, 0.574460190307164],
            [32.24312561728751, 0.573617117015256],
            [32.24129671294605, 0.573974068947339],
            [32.23187798409158, 0.579359959837584],
            [32.221224829899526, 0.57116828083946],
            [32.21934772824817, 0.569395447325838],
            [32.21636529635204, 0.565168647210834],
            [32.21064924882557, 0.55488473374093],
            [32.206619365138486, 0.54369334815217],
            [32.20557986792938, 0.541745760430885],
            [32.20363659367919, 0.538437600867503],
            [32.200027722518016, 0.53417126627988],
            [32.205485764911764, 0.527174018243975],
            [32.20892934695897, 0.525335165373043],
            [32.21244319343108, 0.520576995602258],
            [32.213712947712146, 0.517527354730135],
            [32.21641978097066, 0.514539085512402],
            [32.219019103855985, 0.509744014395778],
            [32.22833828680053, 0.498423374899392],
            [32.22914670677588, 0.496503197745563],
            [32.23447569629758, 0.496649119091283],
            [32.239490475794156, 0.495961299493747],
            [32.240509364752356, 0.495104293849789],
            [32.245637692199146, 0.494895021148234],
            [32.24813910141344, 0.496700146872039],
            [32.25014001606382, 0.500016243927355],
            [32.251223704995006, 0.503038425474839],
            [32.25220542615834, 0.512133030222405],
            [32.26109102195968, 0.512678619055916],
            [32.264399578236535, 0.512456958748211],
            [32.26622458568625, 0.511933489128476],
            [32.27179828796946, 0.50919725754929],
            [32.27277554450581, 0.50798670322693],
            [32.27224978482453, 0.50458164541944],
            [32.27322708088675, 0.502992755987535],
            [32.27503112794596, 0.50178229303153],
            [32.27826327352477, 0.500571986152455],
            [32.282133611027454, 0.500101214130409],
            [32.283417864117204, 0.499336724799155],
            [32.283489573931405, 0.497829928030366],
            [32.28220578437236, 0.492779727128003],
            [32.28323003806939, 0.489628410989991],
            [32.283192165995324, 0.488650404966701],
            [32.281831324341105, 0.484944951333983],
            [32.28412785568685, 0.479082426268787],
            [32.290387767540885, 0.48248429385132],
            [32.29449623944226, 0.483691100707538],
            [32.294039441628684, 0.4864484785688],
            [32.29603611173934, 0.491848651420061],
            [32.296122562009046, 0.493747732872593],
            [32.29891005409861, 0.495436599699024],
            [32.30667793548071, 0.497471291876381],
            [32.30497739949504, 0.503207393861728],
            [32.30223691534599, 0.508389330265933],
            [32.29409881398078, 0.520591736347587],
            [32.29185631719768, 0.527111049906004],
            [32.28871243468882, 0.531869184151621],
            [32.28508015971956, 0.53609592253949],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 17,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "NAMAYUMBA TOWN COUNCIL",
        Population: 15144,
        Key: "WAKISONAMAYUMBA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.510371548687296, 0.307316828536407],
            [32.504794609774144, 0.305819393427531],
            [32.50225117826916, 0.305692262963785],
            [32.4939800732413, 0.309175245284488],
            [32.489704344915474, 0.309392151129428],
            [32.478383301394544, 0.312272430938043],
            [32.46183025226658, 0.310066343967179],
            [32.4497749312223, 0.311483699345699],
            [32.436017281155024, 0.310249964107376],
            [32.43258774067401, 0.311444651953884],
            [32.4297456489815, 0.313809620380022],
            [32.42823667244195, 0.316308033669198],
            [32.427333280778164, 0.319587390918338],
            [32.42583146920134, 0.322580889765439],
            [32.421886548173845, 0.327523402002814],
            [32.41740477057639, 0.320067857243933],
            [32.416727936722204, 0.317022553512939],
            [32.41720613689739, 0.313795717362867],
            [32.419779461640054, 0.305999421329308],
            [32.421415763591334, 0.296696110048002],
            [32.42227509019549, 0.29447853599056],
            [32.42479165488695, 0.290974739785453],
            [32.426603878411875, 0.28725740485513],
            [32.42693989144728, 0.285837562541791],
            [32.426865619637894, 0.282348738410751],
            [32.42552171571835, 0.276544318987887],
            [32.421189498632515, 0.265466951536825],
            [32.419993858057346, 0.258410563791338],
            [32.41579185356858, 0.249760078388185],
            [32.413568515155546, 0.247246469440373],
            [32.41171236221659, 0.24166988761299],
            [32.40822602215847, 0.236231799180355],
            [32.40886673295848, 0.233627099316209],
            [32.409398485301, 0.227162764305689],
            [32.41078425520437, 0.222809016728644],
            [32.41318636913873, 0.221481957212075],
            [32.416656747032555, 0.221649652557156],
            [32.42066119222739, 0.218434742408344],
            [32.423062668357915, 0.217395321887361],
            [32.42627240007205, 0.223444604108597],
            [32.427532394157545, 0.224814667266442],
            [32.42939725716148, 0.225068446564922],
            [32.43126216597955, 0.224155178654018],
            [32.43499203661622, 0.220958623289623],
            [32.437005509714254, 0.220113500819021],
            [32.44867179646015, 0.217539772639503],
            [32.449903855635235, 0.217624387939237],
            [32.45026785927657, 0.218047250633356],
            [32.450351761924104, 0.220781678052964],
            [32.45091170160365, 0.223177844224604],
            [32.45317979947403, 0.223713539690799],
            [32.45494380412945, 0.226025182658758],
            [32.455257901865174, 0.227027352425107],
            [32.456414521421046, 0.227540162450029],
            [32.45943455140503, 0.22770847755824],
            [32.4619687967379, 0.231186576429944],
            [32.46341004030503, 0.236313317006009],
            [32.46493281406902, 0.238106235641042],
            [32.48202862618994, 0.235387570524758],
            [32.48692624291561, 0.23362071773748],
            [32.4889948573007, 0.233286832887611],
            [32.492053027056755, 0.238270754375503],
            [32.493504425179836, 0.23996805242445],
            [32.49476519990131, 0.240900525123508],
            [32.49782089390039, 0.241009104430042],
            [32.49908167850337, 0.241965478319504],
            [32.50436589958455, 0.241337390842339],
            [32.505955048966584, 0.240234276601146],
            [32.50616621414379, 0.239157837510887],
            [32.505514677746305, 0.235118111448565],
            [32.50588108078779, 0.23436416175835],
            [32.5110610963977, 0.234545045009549],
            [32.512799040028426, 0.235952321295091],
            [32.516093243921986, 0.237368436784841],
            [32.51844572234366, 0.237483265645076],
            [32.520107525669204, 0.236929958477567],
            [32.52126424673469, 0.233914784188002],
            [32.52234301828804, 0.232992017235205],
            [32.52293040329614, 0.230336660283531],
            [32.52506614518917, 0.229280256295092],
            [32.53119717035948, 0.224927968205658],
            [32.53642307101583, 0.219668862282443],
            [32.537723653680786, 0.217179441209021],
            [32.538271254999906, 0.21763265238025],
            [32.54156636349694, 0.224177792669903],
            [32.542003762191925, 0.232868773888246],
            [32.542928338825064, 0.236824280672371],
            [32.54288968072513, 0.240387184687234],
            [32.54146564438731, 0.248031397427645],
            [32.54136789061639, 0.251950904637307],
            [32.540201465949195, 0.256371251469116],
            [32.538458683094035, 0.258774603250806],
            [32.5369747434998, 0.262061147397855],
            [32.53059801652288, 0.267729375410625],
            [32.529499862918954, 0.269228451329229],
            [32.52797082071091, 0.271704000108663],
            [32.52231082356656, 0.284052068909151],
            [32.52165981358184, 0.287054990912637],
            [32.52209956855782, 0.294914511377138],
            [32.52113525764304, 0.298483785452428],
            [32.520477795059634, 0.300498152702646],
            [32.51995331727427, 0.30100476679733],
            [32.51293331570554, 0.303514468471037],
            [32.51133159170617, 0.305267020925424],
            [32.510371548687296, 0.307316828536407],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 18,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KYENGERA TOWN COUNCIL",
        Population: 195531,
        Key: "WAKISOKYENGERA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.51531519418982, 0.375332005841109],
            [32.50581566097719, 0.372634626422478],
            [32.50074625133494, 0.373164754162917],
            [32.50072336405812, 0.374152012208033],
            [32.49863881715313, 0.374837705871713],
            [32.491880466080545, 0.375451719054621],
            [32.49158977035631, 0.378501741547629],
            [32.492609147998, 0.379994620810642],
            [32.49047723113144, 0.385172708178928],
            [32.494277094003465, 0.384566480311854],
            [32.495111192321176, 0.384753132546693],
            [32.49594521787535, 0.386152701240555],
            [32.49525000718542, 0.388158636593697],
            [32.493118249320645, 0.390584337273559],
            [32.49001340310248, 0.392356868686324],
            [32.488344999854526, 0.395389053093447],
            [32.4879302692474, 0.395417998817566],
            [32.48698360034648, 0.394064388387703],
            [32.486598622839914, 0.392101104555086],
            [32.485174573925626, 0.390613107846931],
            [32.48255827198316, 0.388871654364551],
            [32.48052658913596, 0.386461249357705],
            [32.47776968019028, 0.386502238551571],
            [32.475164406864515, 0.387165866418732],
            [32.473218928148654, 0.386930158357948],
            [32.47288870206032, 0.387999342896697],
            [32.47028497024357, 0.390166570176226],
            [32.466797721090416, 0.387550410233883],
            [32.46160574171753, 0.385735956183907],
            [32.46030088756338, 0.388266439139723],
            [32.45862454410661, 0.389199863355648],
            [32.45627059693948, 0.389486951105445],
            [32.45534315468058, 0.391605291029753],
            [32.45257577587022, 0.393349715501902],
            [32.450792563437396, 0.39388336506955],
            [32.449774835102545, 0.39175606254065],
            [32.44864088812614, 0.393558947062772],
            [32.448438361148725, 0.394796957024407],
            [32.44699711039509, 0.396176647499147],
            [32.442216034806194, 0.395314280007624],
            [32.44210382624405, 0.394130268373846],
            [32.439179088647066, 0.389139262607901],
            [32.43652795093616, 0.383342447220423],
            [32.43417624596399, 0.380170434311241],
            [32.43240067010935, 0.379029589955976],
            [32.43160673456968, 0.376730484634814],
            [32.42874964730011, 0.373129748457016],
            [32.426975906703646, 0.36882907064262],
            [32.424260392126214, 0.36515548834289],
            [32.422365132827984, 0.36395747261833],
            [32.420334673486245, 0.361629600803723],
            [32.420340375093346, 0.360379748354397],
            [32.41869136916732, 0.358128729487041],
            [32.41835488990628, 0.357874345039133],
            [32.41731259085183, 0.358125647427507],
            [32.41441131275848, 0.356400234702004],
            [32.413172642881186, 0.354579372991026],
            [32.41008352616363, 0.351371173598722],
            [32.4087924674373, 0.349152865880321],
            [32.42097909432835, 0.336273523381436],
            [32.42219878819356, 0.333496443490168],
            [32.42253811780899, 0.330661726070192],
            [32.42246920714524, 0.328363644508143],
            [32.421886548173845, 0.327523402002814],
            [32.42583146920134, 0.322580889765439],
            [32.427333280778164, 0.319587390918338],
            [32.42823667244195, 0.316308033669198],
            [32.4297456489815, 0.313809620380022],
            [32.43258774067401, 0.311444651953884],
            [32.436017281155024, 0.310249964107376],
            [32.4497749312223, 0.311483699345699],
            [32.46183025226658, 0.310066343967179],
            [32.478383301394544, 0.312272430938043],
            [32.489704344915474, 0.309392151129428],
            [32.4939800732413, 0.309175245284488],
            [32.50225117826916, 0.305692262963785],
            [32.504794609774144, 0.305819393427531],
            [32.510371548687296, 0.307316828536407],
            [32.511517061473, 0.310221116931532],
            [32.51300253449145, 0.312651495486431],
            [32.51759834872264, 0.317278645802342],
            [32.52304269989316, 0.326492110632682],
            [32.525288934566156, 0.334884271182314],
            [32.52902854024558, 0.339491824756978],
            [32.533396658501715, 0.343263895070619],
            [32.53701085307926, 0.344431344353464],
            [32.5333349199872, 0.347759261491368],
            [32.531873705074695, 0.350510780664405],
            [32.523963303277796, 0.358841225986525],
            [32.52073862539396, 0.363203020649185],
            [32.51981911076747, 0.364014499216756],
            [32.51745110945769, 0.364901979931504],
            [32.51515962394891, 0.369731299113105],
            [32.515708223296265, 0.374023240558478],
            [32.51531519418982, 0.375332005841109],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 19,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "WAKISO",
        Population: 176780,
        Key: "WAKISOWAKISO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.503124810544236, 0.439997735542696],
            [32.49554873744156, 0.450460436409414],
            [32.4924733622529, 0.44820700096869],
            [32.49166110916628, 0.44628543555953],
            [32.49185966918341, 0.44522134503707],
            [32.49118261254705, 0.444429661179097],
            [32.49046389833598, 0.442400593007351],
            [32.49099655258706, 0.441425869068586],
            [32.490963488296394, 0.439139010929094],
            [32.49046514968918, 0.4375547103076],
            [32.49105820306669, 0.435824493036336],
            [32.49062246266171, 0.433637946083414],
            [32.49105835039042, 0.432546746071677],
            [32.489940274848436, 0.429203093741711],
            [32.48982806538799, 0.426375056866435],
            [32.488558276072645, 0.424047631873913],
            [32.48858525697219, 0.420981712173053],
            [32.4874681956282, 0.417708794386335],
            [32.4877493090233, 0.417421643853599],
            [32.48544691078044, 0.416017432745941],
            [32.48378035177376, 0.415841768227568],
            [32.48214428428276, 0.414486608061522],
            [32.47622299327342, 0.414338821995064],
            [32.47416100216689, 0.415157313098044],
            [32.471040618687525, 0.4180098118326],
            [32.46830866314378, 0.418132947817039],
            [32.46549373920042, 0.419094431223687],
            [32.4631888122, 0.420802928000986],
            [32.46173751648485, 0.424383566531098],
            [32.453878907055675, 0.423039960762016],
            [32.4518243369317, 0.423063946024583],
            [32.45195315714007, 0.424273313930003],
            [32.45090645903565, 0.425284186388776],
            [32.44612689980296, 0.423411392320464],
            [32.445909148178075, 0.422936341121159],
            [32.44783298108887, 0.422096031344024],
            [32.4511725346329, 0.419648006781891],
            [32.45302390583961, 0.416871001958432],
            [32.45571001137126, 0.415701869187027],
            [32.455819080321476, 0.413143986920702],
            [32.449604903495214, 0.409829640239962],
            [32.44516833002113, 0.408787282443724],
            [32.441458380424216, 0.408677353908049],
            [32.442216034806194, 0.395314280007624],
            [32.44699711039509, 0.396176647499147],
            [32.448438361148725, 0.394796957024407],
            [32.44864088812614, 0.393558947062772],
            [32.449774835102545, 0.39175606254065],
            [32.450792563437396, 0.39388336506955],
            [32.45257577587022, 0.393349715501902],
            [32.45534315468058, 0.391605291029753],
            [32.45627059693948, 0.389486951105445],
            [32.45862454410661, 0.389199863355648],
            [32.46030088756338, 0.388266439139723],
            [32.46160574171753, 0.385735956183907],
            [32.466797721090416, 0.387550410233883],
            [32.47028497024357, 0.390166570176226],
            [32.47288870206032, 0.387999342896697],
            [32.473218928148654, 0.386930158357948],
            [32.475164406864515, 0.387165866418732],
            [32.47776968019028, 0.386502238551571],
            [32.48052658913596, 0.386461249357705],
            [32.48255827198316, 0.388871654364551],
            [32.485174573925626, 0.390613107846931],
            [32.486598622839914, 0.392101104555086],
            [32.48698360034648, 0.394064388387703],
            [32.4879302692474, 0.395417998817566],
            [32.488344999854526, 0.395389053093447],
            [32.49001340310248, 0.392356868686324],
            [32.493118249320645, 0.390584337273559],
            [32.49525000718542, 0.388158636593697],
            [32.49594521787535, 0.386152701240555],
            [32.495111192321176, 0.384753132546693],
            [32.494277094003465, 0.384566480311854],
            [32.49047723113144, 0.385172708178928],
            [32.492609147998, 0.379994620810642],
            [32.49158977035631, 0.378501741547629],
            [32.491880466080545, 0.375451719054621],
            [32.49863881715313, 0.374837705871713],
            [32.50072336405812, 0.374152012208033],
            [32.50074625133494, 0.373164754162917],
            [32.50581566097719, 0.372634626422478],
            [32.51531519418982, 0.375332005841109],
            [32.514938729118846, 0.375406668611923],
            [32.51450861845577, 0.377988292787816],
            [32.5129866819216, 0.381435126500397],
            [32.5133645717206, 0.384072871659372],
            [32.51212603299735, 0.386235806991173],
            [32.51185728581043, 0.389262499638405],
            [32.51268532499159, 0.390276457637982],
            [32.51390383038567, 0.39319384979375],
            [32.51465909435067, 0.393664064538493],
            [32.514393101398426, 0.394030933222783],
            [32.51550526782247, 0.395499886390003],
            [32.5184172493424, 0.40341479670201],
            [32.51848754251337, 0.407648158642988],
            [32.5201476498197, 0.412888121934563],
            [32.51893733346771, 0.416068154781216],
            [32.51767104398873, 0.418115204766006],
            [32.51727028308259, 0.420892332214466],
            [32.516408441195615, 0.422845244551254],
            [32.513416379359676, 0.425590448660401],
            [32.51276959055848, 0.427186295707269],
            [32.51235384216014, 0.430976944261165],
            [32.50987244202049, 0.433878748764316],
            [32.50559633999554, 0.436691484985028],
            [32.504284822138594, 0.437975220977449],
            [32.503124810544236, 0.439997735542696],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 20,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "WAKISO TOWN COUNCIL",
        Population: 60210,
        Key: "WAKISOWAKISO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.67700368262732, 0.471473836325655],
            [32.677407735858985, 0.472452721534011],
            [32.67703831986804, 0.480572227228607],
            [32.675287288681965, 0.489569859140916],
            [32.67395089108491, 0.491211312992973],
            [32.66733339764552, 0.495157252049893],
            [32.665463678349134, 0.492361100726538],
            [32.66470024151168, 0.489317962760011],
            [32.663706124495775, 0.487860077910562],
            [32.663259849547465, 0.486070013105094],
            [32.662470977811026, 0.485203527511326],
            [32.6608154716756, 0.484607626256351],
            [32.657849787071356, 0.48257125307682],
            [32.654264058308534, 0.477253696106787],
            [32.653504784264065, 0.476750503374402],
            [32.647516529240185, 0.475754106720918],
            [32.64530081932054, 0.473374241250281],
            [32.641775894824356, 0.471515000229726],
            [32.63960882508411, 0.468777545733471],
            [32.637907207526844, 0.465433397051511],
            [32.63541769380354, 0.463183850494428],
            [32.634296264850626, 0.460002915100276],
            [32.6343739763092, 0.456622528089364],
            [32.633155989243036, 0.4559615255458],
            [32.628924946712694, 0.450811756650493],
            [32.630162686833664, 0.447808735181312],
            [32.63647082564203, 0.441329438682516],
            [32.63323554224796, 0.434140825627714],
            [32.63280271058788, 0.431838053865622],
            [32.630600743095464, 0.428850090884363],
            [32.62631023927984, 0.424663199911592],
            [32.62355889449902, 0.418608929938581],
            [32.62033151268618, 0.416643300329023],
            [32.61785458436002, 0.414167244667147],
            [32.61527383054993, 0.410653438917105],
            [32.613637741499396, 0.409217423469682],
            [32.61105866394562, 0.4051550910186],
            [32.60588208349334, 0.403088026441075],
            [32.604248745084185, 0.403828130952519],
            [32.606531188151315, 0.399404901025286],
            [32.60647292521864, 0.396238400706829],
            [32.605131214086676, 0.393533243275573],
            [32.605072933187685, 0.390710535959579],
            [32.60891374216868, 0.386348424422131],
            [32.61071694301492, 0.384997631382714],
            [32.61257201258564, 0.385966630233183],
            [32.61551633076088, 0.386486011753494],
            [32.617616376299495, 0.387716520199644],
            [32.61928472924178, 0.377339515736017],
            [32.62480735241962, 0.376298715123074],
            [32.628073331246945, 0.376183998243103],
            [32.62982792874474, 0.377304883737877],
            [32.63116238328581, 0.377288355095023],
            [32.63238970923769, 0.378291825115086],
            [32.63387243161474, 0.378399694259169],
            [32.63355954570633, 0.37988927050709],
            [32.63405486597421, 0.382288958011104],
            [32.63305640740053, 0.384438845160498],
            [32.63367765170829, 0.386830969543866],
            [32.63733403656148, 0.388499437906676],
            [32.64098326184183, 0.392551109538422],
            [32.64243354695228, 0.389393581473358],
            [32.64651859618094, 0.392069482800886],
            [32.651675313984, 0.392892996710976],
            [32.65593280650955, 0.400112829001374],
            [32.659903425642376, 0.403976145379008],
            [32.66203772843433, 0.405749483274413],
            [32.663653381710496, 0.406111440452304],
            [32.664850553913205, 0.407197152890934],
            [32.666918658953584, 0.407278666655759],
            [32.66653180666301, 0.409445304970341],
            [32.66671555795269, 0.411568445599071],
            [32.666176544527694, 0.412914251451022],
            [32.66659551428463, 0.415872850914302],
            [32.66162099817739, 0.429463387660496],
            [32.66187918297321, 0.430561249832583],
            [32.66520442096489, 0.435544094722217],
            [32.665842405377965, 0.440757113818846],
            [32.66578586990558, 0.443714237425854],
            [32.662044245711705, 0.458405640553845],
            [32.66288387316001, 0.460017499677177],
            [32.66662960624798, 0.463368553350256],
            [32.67700368262732, 0.471473836325655],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 21,
        District: "WAKISO",
        County: "KIRA MUNICIPALITY",
        Subcounty: "KIRA DIVISION",
        Population: 60499,
        Key: "WAKISOKIRA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.538271254999906, 0.21763265238025],
            [32.537723653680786, 0.217179441209021],
            [32.53642307101583, 0.219668862282443],
            [32.53119717035948, 0.224927968205658],
            [32.52506614518917, 0.229280256295092],
            [32.52293040329614, 0.230336660283531],
            [32.52234301828804, 0.232992017235205],
            [32.52126424673469, 0.233914784188002],
            [32.520107525669204, 0.236929958477567],
            [32.51844572234366, 0.237483265645076],
            [32.516093243921986, 0.237368436784841],
            [32.512799040028426, 0.235952321295091],
            [32.5110610963977, 0.234545045009549],
            [32.50588108078779, 0.23436416175835],
            [32.505514677746305, 0.235118111448565],
            [32.50616621414379, 0.239157837510887],
            [32.505955048966584, 0.240234276601146],
            [32.50436589958455, 0.241337390842339],
            [32.49908167850337, 0.241965478319504],
            [32.49782089390039, 0.241009104430042],
            [32.49476519990131, 0.240900525123508],
            [32.493504425179836, 0.23996805242445],
            [32.492053027056755, 0.238270754375503],
            [32.4889948573007, 0.233286832887611],
            [32.48692624291561, 0.23362071773748],
            [32.48202862618994, 0.235387570524758],
            [32.46493281406902, 0.238106235641042],
            [32.46341004030503, 0.236313317006009],
            [32.4619687967379, 0.231186576429944],
            [32.45943455140503, 0.22770847755824],
            [32.456414521421046, 0.227540162450029],
            [32.455257901865174, 0.227027352425107],
            [32.45494380412945, 0.226025182658758],
            [32.45317979947403, 0.223713539690799],
            [32.45091170160365, 0.223177844224604],
            [32.450351761924104, 0.220781678052964],
            [32.45026785927657, 0.218047250633356],
            [32.449903855635235, 0.217624387939237],
            [32.44867179646015, 0.217539772639503],
            [32.437005509714254, 0.220113500819021],
            [32.43499203661622, 0.220958623289623],
            [32.43126216597955, 0.224155178654018],
            [32.42939725716148, 0.225068446564922],
            [32.427532394157545, 0.224814667266442],
            [32.42627240007205, 0.223444604108597],
            [32.423062668357915, 0.217395321887361],
            [32.42158661507352, 0.212404037004408],
            [32.419861300857384, 0.209762681906],
            [32.418752981019416, 0.204683889341922],
            [32.416088644362056, 0.20250823286713],
            [32.41345815173301, 0.196783678914052],
            [32.41381411724918, 0.195397686260809],
            [32.41377707252348, 0.192709106019728],
            [32.41589782961926, 0.185073586182374],
            [32.42971835097663, 0.187946689563816],
            [32.431893937644126, 0.187796042002203],
            [32.432439702806775, 0.18769123522234],
            [32.43495549854035, 0.183944432182961],
            [32.43607671818581, 0.18310936078225],
            [32.437170904829415, 0.183802781168518],
            [32.43988348191587, 0.187268963722443],
            [32.44217843402335, 0.187807445155168],
            [32.444651134877766, 0.187210800813318],
            [32.44543553839399, 0.186637501744893],
            [32.446051855442434, 0.182885627518721],
            [32.447359753088755, 0.182981662323],
            [32.447417409658655, 0.179528340055707],
            [32.44817780839383, 0.178500952659681],
            [32.44900861079276, 0.175681193977855],
            [32.45158602286998, 0.170651396064051],
            [32.45442542680318, 0.166458128769512],
            [32.46104459649888, 0.160163014158142],
            [32.462232352560825, 0.157869131795602],
            [32.46283732837878, 0.132512896386394],
            [32.459758535998766, 0.111074856405389],
            [32.46001848688245, 0.1080159196895],
            [32.460751604680766, 0.106078324377128],
            [32.46269542241166, 0.107167129125225],
            [32.46352773038702, 0.107239088545092],
            [32.46505078083213, 0.109509947367476],
            [32.4661093546646, 0.11028698147234],
            [32.47397063568344, 0.114698789771001],
            [32.481997983757275, 0.1183458946711],
            [32.49573301604234, 0.123333163846709],
            [32.49995424807145, 0.124182915122619],
            [32.5132192979695, 0.123625172229808],
            [32.51583443749202, 0.124265475493076],
            [32.51911680248843, 0.125693514919682],
            [32.52322193984349, 0.128351332259501],
            [32.52771016195482, 0.132180031037431],
            [32.533874023243705, 0.141002863419112],
            [32.53797863867757, 0.143445486542148],
            [32.53950390167319, 0.145307498669949],
            [32.539695998311885, 0.146120101268319],
            [32.54840526111114, 0.13717148546185],
            [32.55275286543949, 0.137019199897578],
            [32.55838586731123, 0.142567245052006],
            [32.5657379751422, 0.151483347920583],
            [32.619610391888465, 0.164693055302676],
            [32.55619706013772, 0.198524893729682],
            [32.554561293582346, 0.199986805877594],
            [32.55275592959293, 0.200133916684998],
            [32.549398105214294, 0.201802555806647],
            [32.54721223373513, 0.201806958422546],
            [32.5450039762391, 0.20236138618417],
            [32.54441665950298, 0.205040666451137],
            [32.54348158156418, 0.206417473970563],
            [32.54311089625373, 0.21022016295984],
            [32.54177319430291, 0.211815082183763],
            [32.5416352795506, 0.213680469520585],
            [32.539313338458726, 0.216291509615905],
            [32.5385065938414, 0.216723537792563],
            [32.538271254999906, 0.21763265238025],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 22,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KAJJANSI TOWN COUNCIL",
        Population: 92916,
        Key: "WAKISOKAJJANSI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.179356701804565, 0.388886912796491],
            [32.17982251780526, 0.390673472332659],
            [32.17948856820006, 0.401635824202433],
            [32.17598881449815, 0.401367400711482],
            [32.17122442421734, 0.398829767720458],
            [32.16837139553623, 0.398369912390204],
            [32.16475739858805, 0.399346109514824],
            [32.15957408705932, 0.401614626279159],
            [32.15782449227937, 0.402039108439188],
            [32.15601897647464, 0.401692610706026],
            [32.150914130091046, 0.399944712495192],
            [32.149995661103546, 0.395730392190248],
            [32.14676220039119, 0.398471010839499],
            [32.14533232410566, 0.402993440673456],
            [32.145564740727565, 0.40910964545186],
            [32.14468962263903, 0.41077543328649],
            [32.14453732675731, 0.412058339066476],
            [32.14498410206723, 0.413963628858909],
            [32.14683728966746, 0.417154241350171],
            [32.146926788819215, 0.418658479687028],
            [32.14335675452272, 0.424307947526121],
            [32.143992873134955, 0.427156068238058],
            [32.14195367947373, 0.430864670602544],
            [32.14251308914722, 0.432258277401223],
            [32.142262955951296, 0.432869623716173],
            [32.14111974644602, 0.433408937038793],
            [32.137482023194536, 0.436589436637225],
            [32.1354614857451, 0.439726301408867],
            [32.133559657067195, 0.437868715336799],
            [32.13112509508648, 0.437408881157153],
            [32.129812028534, 0.436285260635427],
            [32.12552386572801, 0.435043443029021],
            [32.12334628120734, 0.432869885118468],
            [32.12207228058993, 0.429729464761569],
            [32.12241631558082, 0.429432884425236],
            [32.12127184214593, 0.429351467007589],
            [32.12054857886627, 0.429822479997469],
            [32.11730394490841, 0.433853041514573],
            [32.11316322348833, 0.433234893430032],
            [32.11092832106262, 0.433426100657849],
            [32.10971566549767, 0.434311552730907],
            [32.10649416315837, 0.433844433206013],
            [32.10463985356236, 0.432384187076994],
            [32.10302339270077, 0.430181986429248],
            [32.10213248761945, 0.424497349412789],
            [32.10046859032093, 0.421265944926028],
            [32.09740160000715, 0.421074112185067],
            [32.095951432575994, 0.420044740668775],
            [32.09357394505686, 0.419709379832309],
            [32.093169847807744, 0.41901522259549],
            [32.092944341027035, 0.415939571524152],
            [32.090589687784096, 0.411923764136268],
            [32.08857022202479, 0.41136751741434],
            [32.083196969814075, 0.412037065714044],
            [32.07888200666989, 0.410085880810361],
            [32.07619564332177, 0.408194730114795],
            [32.07355665891836, 0.407763596420877],
            [32.074733182445954, 0.405662787243193],
            [32.073259109946804, 0.403112155490771],
            [32.073961574532674, 0.399019868186288],
            [32.07383110232251, 0.397836517328356],
            [32.072753875871435, 0.395502595644368],
            [32.07344403713118, 0.392467420857113],
            [32.07103188721848, 0.392272883565944],
            [32.07165706524887, 0.386317916531977],
            [32.06888414383322, 0.383684696778147],
            [32.067750687336975, 0.384005013548851],
            [32.066052117763455, 0.386121170191838],
            [32.06542616269034, 0.386391154511995],
            [32.057988444514464, 0.3863876260098],
            [32.05785055491499, 0.387251935633867],
            [32.04980450751022, 0.385856185772571],
            [32.04854955746502, 0.385980083097626],
            [32.047026187219686, 0.387033188279423],
            [32.04579015838935, 0.384711395064592],
            [32.04598059494136, 0.382605189387181],
            [32.044888114198486, 0.375474470197302],
            [32.04126366625027, 0.360812340579984],
            [32.03857768199119, 0.355546477062488],
            [32.03841138586581, 0.354325804998154],
            [32.03654530115305, 0.352087739012135],
            [32.030781603390636, 0.335871588105098],
            [32.03015191941074, 0.332460879525434],
            [32.03464763167491, 0.333081227631296],
            [32.03858474454597, 0.332622071403358],
            [32.041608965170774, 0.331722442629864],
            [32.04572695382427, 0.329453857007643],
            [32.05199454088407, 0.323317652901471],
            [32.05395370812823, 0.321862614511231],
            [32.06581304911691, 0.316358762556747],
            [32.06680211131272, 0.315975901920208],
            [32.06824761469088, 0.316052622268424],
            [32.07721478470655, 0.323626375588357],
            [32.08422331928067, 0.32691086876611],
            [32.09089909811066, 0.329400702774252],
            [32.091279450191834, 0.329898575898492],
            [32.09352260005016, 0.342842733787093],
            [32.09348433541229, 0.34521705775685],
            [32.094282923326844, 0.347916985680677],
            [32.10146235429895, 0.354533279519716],
            [32.10231797625088, 0.357348104229753],
            [32.10224182875919, 0.358056564738128],
            [32.10118607024678, 0.359521272328073],
            [32.1013761869986, 0.360402095301647],
            [32.10246012027153, 0.36250847606451],
            [32.1030304184246, 0.365572197550839],
            [32.10545499473266, 0.370407290619926],
            [32.1065005600615, 0.371724173446197],
            [32.115212181836704, 0.371978416469915],
            [32.11615364589887, 0.372275301612842],
            [32.11710456922098, 0.373213648426665],
            [32.117922417913526, 0.373347773933525],
            [32.12326711268135, 0.373195126456741],
            [32.12496000130901, 0.372352782365166],
            [32.12729023474926, 0.369777615284673],
            [32.13141770691722, 0.368954654313035],
            [32.13322474806129, 0.367767654011659],
            [32.1364963332743, 0.366810571742193],
            [32.13708583381489, 0.36813184328083],
            [32.13955822475055, 0.370678789956988],
            [32.1403475501362, 0.370860773145055],
            [32.14291511038969, 0.372718392550744],
            [32.14430345127141, 0.374135484457527],
            [32.147108872835716, 0.374987850667145],
            [32.14821197346192, 0.375849627342226],
            [32.14933388121689, 0.378798556402019],
            [32.160558231877246, 0.382584586985452],
            [32.16195358231313, 0.382217751939902],
            [32.166914831201936, 0.385778853359721],
            [32.17130188324933, 0.384889852150822],
            [32.17276644258966, 0.385119776146715],
            [32.179356701804565, 0.388886912796491],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 23,
        District: "MITYANA",
        County: "MITYANA MUNICIPALITY",
        Subcounty: "TTAMU DIVISION",
        Population: 30184,
        Key: "MITYANATTAMU DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.26120566675285, 0.382122294589723],
            [32.257369551469196, 0.380750546345398],
            [32.251898008295065, 0.380159886525377],
            [32.24430502440719, 0.377433151395128],
            [32.24220446593055, 0.377176894550434],
            [32.242471150585594, 0.381827776790798],
            [32.24118799254217, 0.383391974724903],
            [32.240224581739284, 0.388777423261103],
            [32.239130371739485, 0.390060687309728],
            [32.21901230989747, 0.389738214860833],
            [32.216767953601746, 0.388911124530618],
            [32.21335644500344, 0.385356375366292],
            [32.211573260418355, 0.385308334551348],
            [32.20732987503606, 0.386830755749696],
            [32.20615053888328, 0.386456924966282],
            [32.20431287506949, 0.384675102148551],
            [32.201676912598685, 0.383176105409183],
            [32.19681348395611, 0.382075376625791],
            [32.191403434056426, 0.382735022694337],
            [32.18846811430541, 0.383670667204611],
            [32.18814693425197, 0.383440115261405],
            [32.18552623325952, 0.38453625717485],
            [32.179356701804565, 0.388886912796491],
            [32.17276644258966, 0.385119776146715],
            [32.17130188324933, 0.384889852150822],
            [32.166914831201936, 0.385778853359721],
            [32.16195358231313, 0.382217751939902],
            [32.160558231877246, 0.382584586985452],
            [32.14933388121689, 0.378798556402019],
            [32.14821197346192, 0.375849627342226],
            [32.147108872835716, 0.374987850667145],
            [32.14430345127141, 0.374135484457527],
            [32.14291511038969, 0.372718392550744],
            [32.1403475501362, 0.370860773145055],
            [32.13955822475055, 0.370678789956988],
            [32.13708583381489, 0.36813184328083],
            [32.1364963332743, 0.366810571742193],
            [32.13990734959582, 0.364521707419714],
            [32.14007386760513, 0.363588255410307],
            [32.139588559061075, 0.35967664547274],
            [32.13742259245196, 0.356556636450587],
            [32.13664009246587, 0.353747088102708],
            [32.13715086195999, 0.350800615764445],
            [32.13920719098531, 0.348981080643408],
            [32.13988836999052, 0.351638723686257],
            [32.146074019916625, 0.35354368734577],
            [32.15171599505974, 0.353644196132261],
            [32.1599797752248, 0.35943009781621],
            [32.16196028733843, 0.359985146908466],
            [32.16461493566546, 0.359539986561957],
            [32.167337758936014, 0.357929917331646],
            [32.168279195150404, 0.356210085694407],
            [32.17077582173412, 0.354020232722742],
            [32.17216686025663, 0.352117503228725],
            [32.17625529254067, 0.349399439861074],
            [32.186589336397695, 0.349458368247827],
            [32.18742005615162, 0.348544952161325],
            [32.18777679691389, 0.347276405246772],
            [32.18894194956663, 0.345505286861003],
            [32.19101057922312, 0.34373424719544],
            [32.19297227881806, 0.341281036005695],
            [32.19891660532625, 0.336302962462865],
            [32.19996292703657, 0.333885560122477],
            [32.19987984185597, 0.332341712821894],
            [32.19731269033593, 0.324706088362874],
            [32.19715827892174, 0.323042570679654],
            [32.1986690979059, 0.309243884555779],
            [32.19814631973305, 0.30536629862612],
            [32.19832491559132, 0.303623712856026],
            [32.199620918644975, 0.303256399582548],
            [32.20192747069774, 0.298852434663319],
            [32.20363937935489, 0.297895139995176],
            [32.20796720547562, 0.288560606723863],
            [32.20922741425845, 0.287124560964799],
            [32.20961980645939, 0.285724358257851],
            [32.21123669312244, 0.283570275993757],
            [32.21461295632059, 0.281655665122862],
            [32.22132956447852, 0.281811705991156],
            [32.222019003492775, 0.282625562579049],
            [32.22225668783549, 0.283798419228308],
            [32.221901818263945, 0.285779301232277],
            [32.22330259721908, 0.28700586356454],
            [32.2251570999529, 0.287077805139569],
            [32.22594172535296, 0.286623077353437],
            [32.23440568250267, 0.289543811070141],
            [32.23515457292073, 0.290273893996595],
            [32.23539210993972, 0.293481293388077],
            [32.233870379119786, 0.29465404022314],
            [32.23353746437384, 0.295515702697363],
            [32.24198936074251, 0.301153152060495],
            [32.24391502711478, 0.303666541232365],
            [32.24650650411439, 0.304935311929991],
            [32.24800428225562, 0.306347628514589],
            [32.25038177426634, 0.307736074325381],
            [32.25451614819063, 0.308869076041086],
            [32.257940293390035, 0.311271300324944],
            [32.26397785154998, 0.31422576048204],
            [32.266077924038036, 0.31456653484791],
            [32.26811804925225, 0.317499641446203],
            [32.26290376920241, 0.323986312198141],
            [32.25839973494546, 0.33069273449906],
            [32.256748456281784, 0.335608155382615],
            [32.25652663439034, 0.337487437164192],
            [32.25684707872355, 0.342743629825407],
            [32.26046876345392, 0.355247145303741],
            [32.26199533080337, 0.377575730698859],
            [32.26120566675285, 0.382122294589723],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 25,
        District: "MITYANA",
        County: "BUSUJJU",
        Subcounty: "MALANGALA",
        Population: 24159,
        Key: "MITYANAMALANGALA",
        Dist2: "Mityana",
        "Sub Country": "Malangala",
        id2_original: "Mityana Malangala",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.08472939244293, 0.54617086510616],
            [33.084117959534694, 0.544614730143532],
            [33.08403227552795, 0.542913830585621],
            [33.08124535566524, 0.539104938770216],
            [33.08070247858619, 0.539132090944288],
            [33.080330904841986, 0.53847164102193],
            [33.08067380256572, 0.537033104558342],
            [33.07985904407775, 0.535486022773954],
            [33.078815878148994, 0.528682438472466],
            [33.077043660196935, 0.523706428115019],
            [33.07792972246058, 0.522439787180084],
            [33.07782970224022, 0.519200844918589],
            [33.07717220821576, 0.518024698356703],
            [33.07574297422568, 0.517445688625454],
            [33.07580025260485, 0.515898585812097],
            [33.07508547301474, 0.513881041271376],
            [33.06998353537602, 0.509809799013416],
            [33.06866889228022, 0.509583629242325],
            [33.06761122305123, 0.510705514086147],
            [33.06538186143422, 0.511194090137825],
            [33.061823237538455, 0.511121742704034],
            [33.058307545926745, 0.507086668845951],
            [33.053291296786384, 0.504598691189214],
            [33.0466601974637, 0.50371210359847],
            [33.042644356241155, 0.504155446365228],
            [33.04098651807926, 0.504698300608931],
            [33.03641348602196, 0.507692997107397],
            [33.03319780656234, 0.512949523924773],
            [33.03324079005036, 0.515898954106443],
            [33.02922495870928, 0.520395508369215],
            [33.02458031385586, 0.527895778590912],
            [33.0219793793929, 0.530257145774048],
            [33.019921322009, 0.531433308001777],
            [33.013561786091664, 0.536545075774798],
            [33.0069590214297, 0.538933586424535],
            [33.00494392777087, 0.540498779260032],
            [32.998777313145624, 0.547284290581283],
            [32.995168671953174, 0.550088965495028],
            [32.98366420143437, 0.554983558159819],
            [32.98195411635723, 0.551274141650074],
            [32.97996507294333, 0.545142115282793],
            [32.9792021131113, 0.537956441310344],
            [32.97663714090412, 0.531342821900017],
            [32.97404548513975, 0.526746760735059],
            [32.968167640250826, 0.518622217063227],
            [32.96140796506151, 0.50767489227362],
            [32.95905676045096, 0.498953237777254],
            [32.95609217268964, 0.493018160825697],
            [32.95493622776855, 0.483400257237722],
            [32.9535490591883, 0.479712075631457],
            [32.95337122689802, 0.477850085772429],
            [32.95402930482738, 0.470133576305845],
            [32.95504890794623, 0.46984390272878],
            [32.957561510168965, 0.467592443335576],
            [32.96004649368826, 0.466258249593274],
            [32.96115093549917, 0.464812863995555],
            [32.968440203481045, 0.463339713881125],
            [32.97156021415954, 0.466508469720774],
            [32.97618501971993, 0.470163662566709],
            [32.977620776377286, 0.472581918234448],
            [32.97860095333664, 0.475486603036176],
            [32.981362034058506, 0.478349599053146],
            [32.982383635030544, 0.479350256788971],
            [32.98579357696698, 0.481031922990889],
            [32.988637495832826, 0.483894915789672],
            [32.9894934339917, 0.484089489327879],
            [32.99831512274544, 0.483130536888389],
            [33.000303108842225, 0.482685800381275],
            [33.00339553046173, 0.480712283127986],
            [33.005825290947264, 0.481268202121839],
            [33.00768902387058, 0.478474702163205],
            [33.01475740780222, 0.47602864306294],
            [33.01813973642515, 0.473985628111614],
            [33.02101125243482, 0.469093524737903],
            [33.02008627245812, 0.463298061261594],
            [33.020583264490725, 0.46215842469206],
            [33.02040377391045, 0.455167730981305],
            [33.02113544452284, 0.449594630913552],
            [33.022916329420795, 0.446189616970953],
            [33.02338569915675, 0.442325971282525],
            [33.04900849782097, 0.445438994866101],
            [33.075694328656425, 0.449232917425478],
            [33.07759946672784, 0.448843753145111],
            [33.07895238434296, 0.447982063412528],
            [33.08299731481101, 0.443965500349891],
            [33.08552364957951, 0.439837769170488],
            [33.086766082499516, 0.435640563809264],
            [33.088188004203175, 0.433152807725612],
            [33.09081098961138, 0.430595546541647],
            [33.09503540257491, 0.42895553307634],
            [33.10489228830248, 0.419921717899079],
            [33.105140744343764, 0.417003138841465],
            [33.10464373434482, 0.415529959520753],
            [33.10520974214409, 0.414848951109608],
            [33.11081469052784, 0.41445973027317],
            [33.11563272550245, 0.413389517050272],
            [33.11853359306572, 0.416994766764753],
            [33.12255320900907, 0.419213841079008],
            [33.12649096956544, 0.422975656614945],
            [33.13067383365045, 0.423551433153065],
            [33.13091131407559, 0.424824325398355],
            [33.12983661638204, 0.427418162400122],
            [33.12542225016014, 0.432858519957842],
            [33.1241708933761, 0.433728381383926],
            [33.12533291270513, 0.435633011890993],
            [33.128282605500715, 0.437357646339482],
            [33.131083312706416, 0.438302423650996],
            [33.13525452115058, 0.436502678967032],
            [33.13611637651228, 0.434350773845913],
            [33.137613759394746, 0.43375296667047],
            [33.13876579035615, 0.43594352984145],
            [33.14100576916149, 0.435685772015652],
            [33.142093804142036, 0.438069622171947],
            [33.14375037567939, 0.437760758059498],
            [33.14310579493716, 0.444923679282416],
            [33.1438219579328, 0.446638636117791],
            [33.1490714483485, 0.450241882153934],
            [33.14893928191571, 0.450643984394603],
            [33.148115348035425, 0.450790378306765],
            [33.14760651351242, 0.454132639359908],
            [33.147805899081284, 0.455443552675189],
            [33.147188792413715, 0.457250933545249],
            [33.14831091666265, 0.459453639935393],
            [33.15002438749013, 0.460490674681024],
            [33.15395583289003, 0.461402509745591],
            [33.15453742915443, 0.461109744807013],
            [33.1552159383666, 0.45984113911968],
            [33.156799010645734, 0.459887823061293],
            [33.154981105276605, 0.462347521989877],
            [33.158196733532286, 0.463402885837557],
            [33.15919032772868, 0.464403098374709],
            [33.16212727792197, 0.464571028407105],
            [33.16455224948871, 0.469229635601447],
            [33.16358373805166, 0.471130831629071],
            [33.160421189449515, 0.473338449997588],
            [33.15926891684132, 0.474930803944361],
            [33.1589471142554, 0.476984551315098],
            [33.1595459195457, 0.478793998087892],
            [33.159751257351665, 0.480485841082604],
            [33.1580361228443, 0.480060657345411],
            [33.15669589213595, 0.478549787024217],
            [33.1547125512275, 0.478224129440923],
            [33.154069147278264, 0.478821267292771],
            [33.15278293675954, 0.481680247488748],
            [33.154069244296316, 0.483136835651198],
            [33.15377467862982, 0.484946305944917],
            [33.15168413277536, 0.488176244675445],
            [33.15029032474682, 0.489632894317861],
            [33.14841427951421, 0.490012923490814],
            [33.1447692197218, 0.492066745348234],
            [33.14337536408256, 0.491415369485362],
            [33.14165995199579, 0.491306838125538],
            [33.141231132211786, 0.492872033693533],
            [33.13997157111425, 0.494572956582891],
            [33.13852439686962, 0.49592103851099],
            [33.13696964487815, 0.496681045813566],
            [33.136701734022765, 0.497486263532876],
            [33.13798837124127, 0.501213732440441],
            [33.13729163161871, 0.503213204839195],
            [33.13560292015714, 0.504262729801986],
            [33.13474524196152, 0.505665082937779],
            [33.131153812489885, 0.507872703412271],
            [33.12911683317581, 0.508144165417123],
            [33.128741662577184, 0.510252198169018],
            [33.127079900574145, 0.510903639529642],
            [33.123461810901524, 0.514432167846287],
            [33.12131754669135, 0.514866481273323],
            [33.119387860358195, 0.515834581645789],
            [33.118046274092066, 0.517137422740359],
            [33.118637494008105, 0.519019255242299],
            [33.117136376829, 0.519833542787662],
            [33.11638598622439, 0.521606830160208],
            [33.11314305008241, 0.522828278902929],
            [33.112392375610185, 0.524393486600383],
            [33.10649599398535, 0.526121628855209],
            [33.10520944570005, 0.527198282509285],
            [33.105477404166145, 0.528926318888056],
            [33.10510219943154, 0.529460117281585],
            [33.10376227055712, 0.529405855965157],
            [33.10290459056487, 0.531296762764281],
            [33.096606066425, 0.535693869476341],
            [33.09537316822342, 0.537530497827675],
            [33.094408208725, 0.540009482389086],
            [33.091040036652636, 0.543357050211753],
            [33.090387915451906, 0.54417131568409],
            [33.09022701011654, 0.545845073522782],
            [33.08915503072505, 0.547030293635492],
            [33.086528244544894, 0.546976052237412],
            [33.08472939244293, 0.54617086510616],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1741,
        District: "BUIKWE",
        County: "NJERU MUNICIPALITY",
        Subcounty: "WAKISI DIVISION",
        Population: 41130,
        Key: "BUIKWEWAKISI DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Wakisi",
        id2_original: "Buikwe  Wakisi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.9313891392819, 0.635088309844112],
            [32.93032242581462, 0.637313940090526],
            [32.92408062309842, 0.644026973664616],
            [32.91957056204421, 0.6503328955762],
            [32.91674877048047, 0.653001812581991],
            [32.913371448168604, 0.655408345654075],
            [32.90796352637784, 0.658574813832511],
            [32.905270361884696, 0.660890879110828],
            [32.90014014438251, 0.666572500137082],
            [32.89515966525845, 0.669784197247178],
            [32.89310771552013, 0.670598411347705],
            [32.8913121961679, 0.670987406409063],
            [32.88336060571692, 0.671113884119213],
            [32.87679839729508, 0.671783223178729],
            [32.87389148317165, 0.665025138859449],
            [32.872031998381296, 0.659107713124476],
            [32.87216031373646, 0.656525587097958],
            [32.87489646620921, 0.651060150779285],
            [32.877354695204424, 0.64716549879811],
            [32.87859448078929, 0.645874464775383],
            [32.88259164334215, 0.644863224446319],
            [32.88447267781785, 0.643615240679716],
            [32.88605446909935, 0.641936890904551],
            [32.88661027024037, 0.639699056213901],
            [32.8857340562072, 0.632361484296291],
            [32.882399650908035, 0.62801482292536],
            [32.882100429273414, 0.626723751767903],
            [32.88267765343735, 0.622269589766429],
            [32.883361711543046, 0.619601403318157],
            [32.88400297660356, 0.618826779185944],
            [32.88686725309033, 0.617406669382734],
            [32.888769709690635, 0.613382890090057],
            [32.889667537189524, 0.609423640888467],
            [32.891292069413964, 0.607573146597239],
            [32.89161277156364, 0.603721476585208],
            [32.893109106112206, 0.599030634653664],
            [32.89404962424837, 0.597825657139986],
            [32.8957168866359, 0.596792837539247],
            [32.89808957984639, 0.59242477575102],
            [32.89642244771456, 0.586571911992759],
            [32.89614461227191, 0.584527720860301],
            [32.896636345566876, 0.582424058195117],
            [32.89704243438096, 0.580267219902269],
            [32.89652947030256, 0.578459717807191],
            [32.89646540065988, 0.575511784275643],
            [32.89834640998275, 0.574005574876559],
            [32.899030424071, 0.572843628115074],
            [32.899386826168396, 0.570424757922015],
            [32.900525200940855, 0.567573252366045],
            [32.90012815546675, 0.565068166550837],
            [32.90096212083379, 0.560444443715338],
            [32.900485653508774, 0.55807260550661],
            [32.901266640731954, 0.555420966860762],
            [32.89944011063779, 0.55062397559897],
            [32.89646200862137, 0.546826332358276],
            [32.895561951503915, 0.546213370555661],
            [32.894278109842574, 0.541696213371126],
            [32.892901566535485, 0.539937302368267],
            [32.89046611522261, 0.538578119917329],
            [32.890016100587786, 0.537592071037031],
            [32.888771696764046, 0.527968830980187],
            [32.89007173055837, 0.526926208694749],
            [32.89078512584462, 0.524628199362351],
            [32.892188084112654, 0.523000458110612],
            [32.8932779058423, 0.52241128931238],
            [32.8947527868252, 0.522501299456534],
            [32.897278237651456, 0.520317087780844],
            [32.900550625060006, 0.519028073641609],
            [32.91490294098076, 0.508662027383938],
            [32.91739281762342, 0.505976500541091],
            [32.923830952534864, 0.495807261259871],
            [32.926605355272414, 0.494840490952913],
            [32.933363477274575, 0.495341868706768],
            [32.94462110692298, 0.494930187083022],
            [32.950970207111666, 0.493086152690301],
            [32.95609217268964, 0.493018160825697],
            [32.95905676045096, 0.498953237777254],
            [32.96140796506151, 0.50767489227362],
            [32.968167640250826, 0.518622217063227],
            [32.97404548513975, 0.526746760735059],
            [32.97663714090412, 0.531342821900017],
            [32.9792021131113, 0.537956441310344],
            [32.97996507294333, 0.545142115282793],
            [32.98195411635723, 0.551274141650074],
            [32.98366420143437, 0.554983558159819],
            [32.98078912899449, 0.558014410012991],
            [32.97865155992815, 0.562619501016707],
            [32.9786088567145, 0.566410338664587],
            [32.97978447024874, 0.57418201220909],
            [32.9780102984609, 0.583536959321858],
            [32.97664225950461, 0.586124494460983],
            [32.9751888437654, 0.58797014623099],
            [32.973265002769764, 0.589390570027453],
            [32.96366769781996, 0.59488225209354],
            [32.960931618110735, 0.597551199025232],
            [32.95525731529551, 0.604889430796361],
            [32.945584237451506, 0.618631369276856],
            [32.934832481478914, 0.629415673844835],
            [32.9313891392819, 0.635088309844112],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1744,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "NTUNDA",
        Population: 15066,
        Key: "MUKONONTUNDA",
        Dist2: "Mukono",
        "Sub Country": "Ntunda",
        id2_original: "MukonoNtunda",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.377588376503166, -0.521166890380963],
              [30.37413929227487, -0.520356146715249],
              [30.371883306389456, -0.518944372955573],
              [30.368605757261246, -0.517962601257233],
              [30.368154297237126, -0.51832109883761],
              [30.36703790603633, -0.518296721354896],
              [30.35318450993282, -0.516478709550125],
              [30.35297623194092, -0.51793216757896],
              [30.350313869780543, -0.522833009234262],
              [30.34497786441648, -0.526313695833576],
              [30.346977515137244, -0.528653429513586],
              [30.34802361496369, -0.529180542055103],
              [30.35168548043843, -0.529814108447328],
              [30.35335964637893, -0.529709492426379],
              [30.35809594454418, -0.525761503142512],
              [30.358854643666813, -0.525498490190479],
              [30.37209016324655, -0.527031440980803],
              [30.37261356574855, -0.526478653693653],
              [30.37324138123261, -0.52645258478632],
              [30.37903026326402, -0.527936793027452],
              [30.37903485545178, -0.52637327228424],
              [30.377588376503166, -0.521166890380963],
            ],
          ],
          [
            [
              [30.365790881826896, -0.496143396448289],
              [30.362320447339215, -0.49488469090784],
              [30.359125367147374, -0.495648605854632],
              [30.355420271147917, -0.49472650977327],
              [30.352545841901787, -0.495562281883679],
              [30.351168201751744, -0.4955019505907],
              [30.348293857845572, -0.49614642096245],
              [30.34651814814197, -0.498699219113504],
              [30.343602380223114, -0.496805539548133],
              [30.340785465613042, -0.500781743745577],
              [30.336984527457595, -0.503781667343668],
              [30.338017329522906, -0.504858119068519],
              [30.33943888381562, -0.507970673420719],
              [30.340259104060507, -0.511853236843979],
              [30.342022944324263, -0.510673943151285],
              [30.34535959181835, -0.511816339117678],
              [30.352041983147135, -0.508178660265623],
              [30.354458306632655, -0.505799306673584],
              [30.35605730873668, -0.505502153753264],
              [30.36088001854405, -0.503381912720187],
              [30.36609965345129, -0.503285040341398],
              [30.36651455294167, -0.502322114876876],
              [30.365655845276745, -0.499725268223088],
              [30.365790881826896, -0.496143396448289],
            ],
          ],
          [
            [
              [30.349570784275862, -0.450199331170925],
              [30.34908946604832, -0.449568160173678],
              [30.347780851546382, -0.449242331480282],
              [30.34319144589638, -0.45084934638819],
              [30.33902320279096, -0.453459665115368],
              [30.33844016742547, -0.45558326682912],
              [30.337400759149574, -0.456748720310078],
              [30.33180105153719, -0.45596038112837],
              [30.32846014602863, -0.457784703553975],
              [30.324498891832636, -0.456798146741257],
              [30.321195473020918, -0.456670390604141],
              [30.319549991185735, -0.455512992049077],
              [30.31812773530879, -0.453653180418711],
              [30.318329666703196, -0.453166428252106],
              [30.317238680756947, -0.45199659863567],
              [30.316775627974085, -0.449764200667062],
              [30.317003382339614, -0.445607100506109],
              [30.316376719394064, -0.443898812323288],
              [30.315588687582405, -0.44313938855561],
              [30.312970619552082, -0.442297967138024],
              [30.310285311724414, -0.437669891628626],
              [30.308180301197215, -0.434976022816928],
              [30.305693493199577, -0.433456872465679],
              [30.3058187668592, -0.436128482212576],
              [30.30592452731421, -0.438174412077726],
              [30.307127549346095, -0.441048701021445],
              [30.306977733712902, -0.444211696021126],
              [30.30762233242143, -0.444781279940794],
              [30.308121671751888, -0.447140195200078],
              [30.305902375757622, -0.452136992859637],
              [30.30760836361877, -0.455770615336227],
              [30.307044449792436, -0.459285907405084],
              [30.308813035855785, -0.461274779741068],
              [30.310434925236667, -0.462450243692284],
              [30.309299451124264, -0.470276113480199],
              [30.30848574097024, -0.471432572711738],
              [30.30680515387209, -0.472651954799451],
              [30.30534354998908, -0.474901666292459],
              [30.30502116439654, -0.476853590466821],
              [30.305067132986238, -0.483432739162194],
              [30.306431787988874, -0.48771695003188],
              [30.30886757437333, -0.490085697841639],
              [30.31017269083554, -0.492038280583218],
              [30.310332003457912, -0.495273700802032],
              [30.31106336325322, -0.493641907175951],
              [30.318983360853974, -0.485903995141542],
              [30.323201059809065, -0.483783100184998],
              [30.330219201865173, -0.482932674707247],
              [30.33464328785847, -0.481727449593753],
              [30.34660578508614, -0.475461777151522],
              [30.349476157540447, -0.477393772734531],
              [30.351352324045628, -0.478183593477337],
              [30.36458174047132, -0.480675569376138],
              [30.36740780711748, -0.482111401117017],
              [30.367906118775284, -0.483426771866189],
              [30.366988019893657, -0.492740260207324],
              [30.36601407544577, -0.494823391260903],
              [30.367035466212016, -0.492726168856548],
              [30.37306967096099, -0.490590546916286],
              [30.37977897851061, -0.489089436986907],
              [30.381378630096645, -0.488433455339306],
              [30.382783286180526, -0.487210579050041],
              [30.386642938222938, -0.477978300547458],
              [30.38774005247608, -0.474542393833491],
              [30.387892126473883, -0.472057139378543],
              [30.388401434409058, -0.471574034612563],
              [30.383563971569785, -0.4666110440439],
              [30.379703224481045, -0.463271519607571],
              [30.37421443994163, -0.455849468753192],
              [30.368670235637413, -0.456651800559822],
              [30.3673808540657, -0.455449310694262],
              [30.365822002163274, -0.452701274471282],
              [30.365013113267377, -0.452511187905032],
              [30.364284519384835, -0.451769831384984],
              [30.361096335559445, -0.446427401897253],
              [30.360050615720336, -0.446390875709856],
              [30.353551993647542, -0.450952538059227],
              [30.35257767190724, -0.450934107895379],
              [30.350657206780454, -0.451728717670725],
              [30.349570784275862, -0.450199331170925],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1950,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "KYANGYENYI",
        Population: 9527,
        Key: "SHEEMAKYANGYENYI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.01362483608608, 0.320336584962958],
            [32.00971872497382, 0.322657755589121],
            [32.0034303967124, 0.32276483397082],
            [32.002313031737856, 0.322453577150514],
            [31.99993728784866, 0.323295241190261],
            [31.99469983845102, 0.326961532025008],
            [31.976604784425497, 0.342162014305514],
            [31.97384843782513, 0.342181535246825],
            [31.962063091964772, 0.340520295901492],
            [31.927132195566543, 0.34016343567103],
            [31.926103009220284, 0.337208080326141],
            [31.924700676179693, 0.335199775675337],
            [31.887608881467223, 0.329858646445919],
            [31.883124674825208, 0.330002865878744],
            [31.880164828372006, 0.330536217344664],
            [31.869196110393673, 0.333420499405621],
            [31.865688092191164, 0.334668371975743],
            [31.858330318685702, 0.338874622004922],
            [31.857849775704217, 0.339139429935569],
            [31.8557194767035, 0.337548965303708],
            [31.850965526642927, 0.331684823612816],
            [31.849301980585707, 0.326778363129484],
            [31.85001561841707, 0.322829508949923],
            [31.852512315967687, 0.318162856517977],
            [31.85441443839471, 0.315889430507238],
            [31.85702967583358, 0.314094755743605],
            [31.863091946647007, 0.313138103823073],
            [31.86814373942822, 0.313318151363243],
            [31.878365917879563, 0.316550254403366],
            [31.87848472277083, 0.317028926962313],
            [31.87765249744047, 0.31846483042192],
            [31.878246831815613, 0.318584570405664],
            [31.879435523922062, 0.318345361723821],
            [31.883477356100727, 0.314995149635603],
            [31.88828708345558, 0.312006439238093],
            [31.8902566442076, 0.304153175132217],
            [31.89290788612307, 0.299163352620629],
            [31.897876743742323, 0.297129526979932],
            [31.902037605391094, 0.29207999373935],
            [31.903797325082632, 0.287125953336017],
            [31.903643416724986, 0.280580154823157],
            [31.910277934137326, 0.261721206885933],
            [31.915187255911114, 0.256081993246776],
            [31.92103620289571, 0.24822032214009],
            [31.92217749629451, 0.246245897426155],
            [31.925814519758358, 0.236870139275811],
            [31.92968042677009, 0.23194487499896],
            [31.930750273561074, 0.231227802477609],
            [31.931349033935618, 0.231599357919862],
            [31.932631411343028, 0.231499952958906],
            [31.955583707313778, 0.22119939424793],
            [31.956318594793213, 0.220839702501211],
            [31.959157291752266, 0.224320152094183],
            [31.960202396245396, 0.224534422900174],
            [31.965846071899346, 0.228174214414764],
            [31.96798411437785, 0.228937259803968],
            [31.96966935474917, 0.228099655735546],
            [31.970453047697976, 0.228122962340892],
            [31.971640713928377, 0.22840881387721],
            [31.973434813942458, 0.22956639167372],
            [31.981197537198213, 0.226812580399818],
            [31.98308527130929, 0.22660804818717],
            [31.98677187459034, 0.23231629298131],
            [31.991087703710427, 0.237940443104551],
            [31.992812574158826, 0.241105305959036],
            [31.99669868068803, 0.244459719861982],
            [31.997624963221885, 0.244578503908596],
            [31.998670630060392, 0.245342381125654],
            [31.999587313197097, 0.24653534720568],
            [32.00603959298103, 0.246353312483772],
            [32.01373473418133, 0.246950272492893],
            [32.016922657495286, 0.245366734229742],
            [32.019483764251795, 0.243080258735737],
            [32.02098389418242, 0.242384569198619],
            [32.02243414695351, 0.242436392543544],
            [32.023701860262236, 0.243083366878655],
            [32.02816438247161, 0.244102566425865],
            [32.02506203985812, 0.257002067283937],
            [32.025337859481255, 0.255614429294563],
            [32.02646448428978, 0.25850924721282],
            [32.02815217885848, 0.26093371506811],
            [32.02898423620385, 0.263900884008766],
            [32.031765701496184, 0.26561985483411],
            [32.03968676090561, 0.267899647416004],
            [32.039626758834515, 0.275068007923764],
            [32.04016102196826, 0.283169857751401],
            [32.03973283190325, 0.286137696719121],
            [32.032754565164296, 0.291462500717931],
            [32.029330858342774, 0.29359236322542],
            [32.02802304962964, 0.295961750718186],
            [32.02585943660659, 0.297565155517287],
            [32.01902353487384, 0.305953506394926],
            [32.01809610878465, 0.308322916355092],
            [32.014422518498826, 0.313097461951563],
            [32.01356641145666, 0.315490800167709],
            [32.01362483608608, 0.320336584962958],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 26,
        District: "MITYANA",
        County: "BUSUJJU",
        Subcounty: "MAANYI",
        Population: 21286,
        Key: "MITYANAMAANYI",
        Dist2: "Mityana",
        "Sub Country": "Mityana TC",
        id2_original: "Mityana Mityana TC",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.19832491559132, 0.303623712856026],
            [32.19814631973305, 0.30536629862612],
            [32.1986690979059, 0.309243884555779],
            [32.19715827892174, 0.323042570679654],
            [32.19731269033593, 0.324706088362874],
            [32.19987984185597, 0.332341712821894],
            [32.19996292703657, 0.333885560122477],
            [32.19891660532625, 0.336302962462865],
            [32.19297227881806, 0.341281036005695],
            [32.19101057922312, 0.34373424719544],
            [32.18894194956663, 0.345505286861003],
            [32.18777679691389, 0.347276405246772],
            [32.18742005615162, 0.348544952161325],
            [32.186589336397695, 0.349458368247827],
            [32.17625529254067, 0.349399439861074],
            [32.17216686025663, 0.352117503228725],
            [32.17077582173412, 0.354020232722742],
            [32.168279195150404, 0.356210085694407],
            [32.167337758936014, 0.357929917331646],
            [32.16461493566546, 0.359539986561957],
            [32.16196028733843, 0.359985146908466],
            [32.1599797752248, 0.35943009781621],
            [32.15171599505974, 0.353644196132261],
            [32.146074019916625, 0.35354368734577],
            [32.13988836999052, 0.351638723686257],
            [32.13920719098531, 0.348981080643408],
            [32.13832793345995, 0.346965156391094],
            [32.13589124067535, 0.343841407093235],
            [32.13035191242648, 0.340513923365427],
            [32.1259896233382, 0.335355523810992],
            [32.12349335967389, 0.333871328355067],
            [32.116894334698394, 0.332316390638307],
            [32.11401739555938, 0.330511497915984],
            [32.11308159178182, 0.329397909059882],
            [32.115944032112154, 0.326649936674538],
            [32.11559502045461, 0.323961124738548],
            [32.11415701711075, 0.31952106304433],
            [32.11072218016282, 0.311801750353766],
            [32.10737040234438, 0.305769870011258],
            [32.10343593411354, 0.302263073477471],
            [32.09894294194806, 0.29639866387519],
            [32.095281787939044, 0.294172411248817],
            [32.10058573602389, 0.289836697634988],
            [32.102654142898196, 0.290004410951402],
            [32.10545952044504, 0.290914167166793],
            [32.109002024971346, 0.290483622769131],
            [32.110594895175254, 0.291129989121325],
            [32.113661895370534, 0.29086695232396],
            [32.11613456927551, 0.289957616510961],
            [32.118001074399814, 0.287815587587491],
            [32.12030737312763, 0.286259991836184],
            [32.12878348627975, 0.282443014556387],
            [32.13112561970258, 0.278625546447015],
            [32.13264752299906, 0.274604577790219],
            [32.13509648138056, 0.27288142662143],
            [32.13683219629106, 0.271038549084948],
            [32.13841332371758, 0.269973553387826],
            [32.14079088669523, 0.269207804678664],
            [32.14328729139507, 0.269040436014513],
            [32.146235514546824, 0.267652407698834],
            [32.14873232079359, 0.26162092719996],
            [32.14946939656906, 0.260950782881486],
            [32.15051548831067, 0.261166277498124],
            [32.15207293884126, 0.258617281102074],
            [32.1520018542545, 0.25507487145886],
            [32.153571184106404, 0.252466042139454],
            [32.15326224090379, 0.250359722383884],
            [32.15495028401879, 0.25033589659504],
            [32.15599642067619, 0.249833327218626],
            [32.15689987162878, 0.250048800462367],
            [32.15876608569892, 0.252167192610238],
            [32.16806228345034, 0.251162515708424],
            [32.168727964720254, 0.25154552221893],
            [32.169655101551946, 0.253077442148322],
            [32.17109329174541, 0.256344711009701],
            [32.17591951666049, 0.258930041649677],
            [32.18111461588237, 0.256094047619187],
            [32.185085280829284, 0.253317798428687],
            [32.18703471213241, 0.255735394328026],
            [32.19080237848633, 0.267188735637263],
            [32.188519541957106, 0.272980950740873],
            [32.18757999939133, 0.27902458325263],
            [32.187722308702014, 0.283955284711107],
            [32.18882766409956, 0.286839578507327],
            [32.1912288186332, 0.289281162303159],
            [32.19308307792353, 0.292440782108087],
            [32.1939864848587, 0.293374327898367],
            [32.195127691120916, 0.293565889323228],
            [32.19584088787947, 0.294547295727297],
            [32.197611813155866, 0.299370420452145],
            [32.19832491559132, 0.303623712856026],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 28,
        District: "MITYANA",
        County: "BUSUJJU",
        Subcounty: "KAKINDU",
        Population: 18423,
        Key: "MITYANAKAKINDU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.1364963332743, 0.366810571742193],
            [32.13322474806129, 0.367767654011659],
            [32.13141770691722, 0.368954654313035],
            [32.12729023474926, 0.369777615284673],
            [32.12496000130901, 0.372352782365166],
            [32.12326711268135, 0.373195126456741],
            [32.117922417913526, 0.373347773933525],
            [32.11710456922098, 0.373213648426665],
            [32.11615364589887, 0.372275301612842],
            [32.115212181836704, 0.371978416469915],
            [32.1065005600615, 0.371724173446197],
            [32.10545499473266, 0.370407290619926],
            [32.1030304184246, 0.365572197550839],
            [32.10246012027153, 0.36250847606451],
            [32.1013761869986, 0.360402095301647],
            [32.10118607024678, 0.359521272328073],
            [32.10224182875919, 0.358056564738128],
            [32.10231797625088, 0.357348104229753],
            [32.10146235429895, 0.354533279519716],
            [32.094282923326844, 0.347916985680677],
            [32.09348433541229, 0.34521705775685],
            [32.09352260005016, 0.342842733787093],
            [32.091279450191834, 0.329898575898492],
            [32.09089909811066, 0.329400702774252],
            [32.08422331928067, 0.32691086876611],
            [32.07721478470655, 0.323626375588357],
            [32.06824761469088, 0.316052622268424],
            [32.06680211131272, 0.315975901920208],
            [32.06581304911691, 0.316358762556747],
            [32.05395370812823, 0.321862614511231],
            [32.05199454088407, 0.323317652901471],
            [32.04572695382427, 0.329453857007643],
            [32.041608965170774, 0.331722442629864],
            [32.03858474454597, 0.332622071403358],
            [32.03464763167491, 0.333081227631296],
            [32.03015191941074, 0.332460879525434],
            [32.02580128057339, 0.331455201003192],
            [32.02382808433943, 0.330521567862764],
            [32.02016712167156, 0.327409737331428],
            [32.01362483608608, 0.320336584962958],
            [32.01356641145666, 0.315490800167709],
            [32.014422518498826, 0.313097461951563],
            [32.01809610878465, 0.308322916355092],
            [32.01902353487384, 0.305953506394926],
            [32.02585943660659, 0.297565155517287],
            [32.02802304962964, 0.295961750718186],
            [32.029330858342774, 0.29359236322542],
            [32.032754565164296, 0.291462500717931],
            [32.03973283190325, 0.286137696719121],
            [32.04016102196826, 0.283169857751401],
            [32.039626758834515, 0.275068007923764],
            [32.03968676090561, 0.267899647416004],
            [32.04311017577468, 0.269335983870973],
            [32.04819787960769, 0.269910817541318],
            [32.04910134493334, 0.269551875392596],
            [32.049671988039506, 0.268762074529827],
            [32.04947019498565, 0.265088115380777],
            [32.05004080844737, 0.264777008767567],
            [32.05714943241216, 0.264394609011648],
            [32.05976438957667, 0.26767384845406],
            [32.06154739719363, 0.268822851178178],
            [32.06752662953879, 0.269984148898996],
            [32.070926214798355, 0.272593290766961],
            [32.0743497626181, 0.272737166906901],
            [32.07664397990365, 0.273275875077441],
            [32.080803844422434, 0.282515002871706],
            [32.08098199112306, 0.284489635593327],
            [32.08057771870251, 0.285758145272144],
            [32.07629782488871, 0.29107129395824],
            [32.076820796199335, 0.292052661055319],
            [32.07982810334399, 0.294530153403228],
            [32.08165868663669, 0.295391959615603],
            [32.089504217493655, 0.297451005438064],
            [32.09233352526138, 0.296374170738375],
            [32.095281787939044, 0.294172411248817],
            [32.09894294194806, 0.29639866387519],
            [32.10343593411354, 0.302263073477471],
            [32.10737040234438, 0.305769870011258],
            [32.11072218016282, 0.311801750353766],
            [32.11415701711075, 0.31952106304433],
            [32.11559502045461, 0.323961124738548],
            [32.115944032112154, 0.326649936674538],
            [32.11308159178182, 0.329397909059882],
            [32.11401739555938, 0.330511497915984],
            [32.116894334698394, 0.332316390638307],
            [32.12349335967389, 0.333871328355067],
            [32.1259896233382, 0.335355523810992],
            [32.13035191242648, 0.340513923365427],
            [32.13589124067535, 0.343841407093235],
            [32.13832793345995, 0.346965156391094],
            [32.13920719098531, 0.348981080643408],
            [32.13715086195999, 0.350800615764445],
            [32.13664009246587, 0.353747088102708],
            [32.13742259245196, 0.356556636450587],
            [32.139588559061075, 0.35967664547274],
            [32.14007386760513, 0.363588255410307],
            [32.13990734959582, 0.364521707419714],
            [32.1364963332743, 0.366810571742193],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 29,
        District: "MITYANA",
        County: "BUSUJJU",
        Subcounty: "BUTAYUNJA",
        Population: 10883,
        Key: "MITYANABUTAYUNJA",
        Dist2: "Mityana",
        "Sub Country": "Butayunja",
        id2_original: "Mityana Butayunja",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.193299428176545, 0.484624892156806],
            [32.19301418522606, 0.484026478352736],
            [32.19137358124292, 0.484504983931142],
            [32.185880898913496, 0.487974951202082],
            [32.18116114681746, 0.489709689385157],
            [32.177761180672256, 0.489709268090673],
            [32.17336274337695, 0.488751309051993],
            [32.16659901409078, 0.484478007589322],
            [32.16505385790316, 0.482203969229283],
            [32.15918170743481, 0.478253921927808],
            [32.15776731001996, 0.476135485892704],
            [32.15619806460969, 0.476446450339819],
            [32.15220374791966, 0.476302343091398],
            [32.15139543394554, 0.475799597635119],
            [32.1492796346518, 0.473788784321461],
            [32.14906577452874, 0.472831350339962],
            [32.147758261361346, 0.471538687103302],
            [32.14551510701146, 0.471071670584334],
            [32.144596275104576, 0.470426288769042],
            [32.14258875334527, 0.466588702785311],
            [32.138520938295365, 0.467742069829662],
            [32.137975456102005, 0.464273170318859],
            [32.13864179673536, 0.459127203547887],
            [32.1396405876857, 0.45735613010075],
            [32.139890427132514, 0.455716606736706],
            [32.14207797576632, 0.454113213003781],
            [32.145597234588, 0.450164339277495],
            [32.1424113441615, 0.449757064670317],
            [32.14179324036396, 0.449254347874433],
            [32.13590967859654, 0.441582456044977],
            [32.13548180024696, 0.440864351523583],
            [32.1354614857451, 0.439726301408867],
            [32.137482023194536, 0.436589436637225],
            [32.14111974644602, 0.433408937038793],
            [32.142262955951296, 0.432869623716173],
            [32.14251308914722, 0.432258277401223],
            [32.14195367947373, 0.430864670602544],
            [32.143992873134955, 0.427156068238058],
            [32.14335675452272, 0.424307947526121],
            [32.146926788819215, 0.418658479687028],
            [32.14683728966746, 0.417154241350171],
            [32.14498410206723, 0.413963628858909],
            [32.14453732675731, 0.412058339066476],
            [32.14468962263903, 0.41077543328649],
            [32.145564740727565, 0.40910964545186],
            [32.14533232410566, 0.402993440673456],
            [32.14676220039119, 0.398471010839499],
            [32.149995661103546, 0.395730392190248],
            [32.150914130091046, 0.399944712495192],
            [32.15601897647464, 0.401692610706026],
            [32.15782449227937, 0.402039108439188],
            [32.15957408705932, 0.401614626279159],
            [32.16475739858805, 0.399346109514824],
            [32.16837139553623, 0.398369912390204],
            [32.17122442421734, 0.398829767720458],
            [32.17598881449815, 0.401367400711482],
            [32.17948856820006, 0.401635824202433],
            [32.17982251780526, 0.390673472332659],
            [32.179356701804565, 0.388886912796491],
            [32.18552623325952, 0.38453625717485],
            [32.18814693425197, 0.383440115261405],
            [32.18846811430541, 0.383670667204611],
            [32.191403434056426, 0.382735022694337],
            [32.19681348395611, 0.382075376625791],
            [32.201676912598685, 0.383176105409183],
            [32.20431287506949, 0.384675102148551],
            [32.20615053888328, 0.386456924966282],
            [32.20732987503606, 0.386830755749696],
            [32.211573260418355, 0.385308334551348],
            [32.21335644500344, 0.385356375366292],
            [32.216767953601746, 0.388911124530618],
            [32.21901230989747, 0.389738214860833],
            [32.239130371739485, 0.390060687309728],
            [32.240224581739284, 0.388777423261103],
            [32.24118799254217, 0.383391974724903],
            [32.242471150585594, 0.381827776790798],
            [32.24220446593055, 0.377176894550434],
            [32.24430502440719, 0.377433151395128],
            [32.251898008295065, 0.380159886525377],
            [32.257369551469196, 0.380750546345398],
            [32.26120566675285, 0.382122294589723],
            [32.26022236814792, 0.385875796448807],
            [32.25934048484697, 0.394766690806034],
            [32.25613421523996, 0.40072102300352],
            [32.254347961111556, 0.405922938214551],
            [32.25367944655523, 0.406864613947265],
            [32.25192215590821, 0.406985005820187],
            [32.24737424883109, 0.409377227884529],
            [32.24599521539402, 0.409568577628116],
            [32.245044203138704, 0.409233392413164],
            [32.24425952922963, 0.409831703617375],
            [32.243593807535476, 0.409735899844373],
            [32.24269022273392, 0.410765043638941],
            [32.23857675979283, 0.412847054720956],
            [32.23651970762371, 0.417215122156373],
            [32.23285791850578, 0.419943424206594],
            [32.22964804665447, 0.421044144298105],
            [32.22686599835554, 0.42353317090232],
            [32.224678293414875, 0.426620647664229],
            [32.22327546630088, 0.427003472066814],
            [32.22120680430504, 0.428439398019718],
            [32.22132546456757, 0.430593611625176],
            [32.22011037097493, 0.432167912149757],
            [32.220326436461995, 0.434877978121757],
            [32.21985091865624, 0.434806125748169],
            [32.219470417454716, 0.435643822802928],
            [32.21752086398072, 0.434829810046899],
            [32.21695023434931, 0.434877624195729],
            [32.21671238561489, 0.435739282211527],
            [32.215785176019665, 0.435236531229012],
            [32.215166963525974, 0.435523694571537],
            [32.21514311145854, 0.436217819773776],
            [32.214025549752925, 0.43717512656559],
            [32.21448898701475, 0.438982311615313],
            [32.214346233936304, 0.43989185244499],
            [32.212848250979235, 0.440777304654013],
            [32.21211110244023, 0.441710709199418],
            [32.21211090211591, 0.443601615421836],
            [32.21075556623604, 0.444558888926997],
            [32.209281110156255, 0.447694289715563],
            [32.20701028230573, 0.449740526297151],
            [32.2058450541945, 0.45155949919327],
            [32.20503664499895, 0.45179876072934],
            [32.20446590217981, 0.452851857055363],
            [32.203776359859326, 0.453210818011575],
            [32.203847473192155, 0.455197466973752],
            [32.20267016902857, 0.458679949408949],
            [32.200910491557835, 0.460953625359797],
            [32.2009103891499, 0.461863169735521],
            [32.198936605417764, 0.465213918018183],
            [32.19758125785979, 0.466147237668832],
            [32.1959519439031, 0.471879584403608],
            [32.19471540482968, 0.473483119633945],
            [32.194287246205704, 0.475110676414883],
            [32.19268213915097, 0.477061225257041],
            [32.19282470178657, 0.477851108917938],
            [32.192230042221304, 0.480029159025565],
            [32.193299428176545, 0.484624892156806],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 30,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "NAMUNGO",
        Population: 17161,
        Key: "MITYANANAMUNGO",
        Dist2: "Mityana",
        "Sub Country": "Namugo",
        id2_original: "Mityana Namugo",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.047026187219686, 0.387033188279423],
            [32.04719249502319, 0.388086322075881],
            [32.0460065508632, 0.390900018584545],
            [32.048645495740736, 0.392578491342199],
            [32.049808478962085, 0.394386486979677],
            [32.04987424911561, 0.395704780934053],
            [32.049523251282956, 0.39786422070385],
            [32.04874955298998, 0.398821947177063],
            [32.0488606251833, 0.399386712379307],
            [32.04637517274342, 0.402740406784407],
            [32.04555424372775, 0.405012381931122],
            [32.044242181491754, 0.405424809722834],
            [32.04397388256415, 0.404747717008865],
            [32.04442142593366, 0.402661904052459],
            [32.0419963896882, 0.400688589225048],
            [32.04094743052419, 0.401143147190074],
            [32.038915959679414, 0.399275508139707],
            [32.0382130450376, 0.399097951450083],
            [32.037153675297766, 0.398911462125999],
            [32.03486001317102, 0.399309109705229],
            [32.031942944491625, 0.397765080527231],
            [32.028078185526816, 0.396393816312768],
            [32.026479354102676, 0.395328053548],
            [32.023925739295656, 0.394499729514075],
            [32.02407715842164, 0.396643435084488],
            [32.02361441735417, 0.3995479803077],
            [32.02160320172245, 0.401744793456541],
            [32.020943133126394, 0.401911248981661],
            [32.02098835072452, 0.404088267610047],
            [32.02466342233227, 0.407514795435359],
            [32.025990434331185, 0.409570605972204],
            [32.02699795510945, 0.414677325285004],
            [32.028089860930564, 0.415019253746812],
            [32.03022678320992, 0.414901543395805],
            [32.031852974622666, 0.418319759181532],
            [32.03548828050769, 0.417925374239254],
            [32.03712014388314, 0.419546967886564],
            [32.03795188322494, 0.422634606130386],
            [32.04204085449813, 0.425100374583569],
            [32.04246113669369, 0.426375144000607],
            [32.03602518289177, 0.430125837018219],
            [32.03374268682401, 0.431011121495825],
            [32.03180543847276, 0.427839567430572],
            [32.031258976217465, 0.424991300549968],
            [32.02885794385471, 0.42317199154242],
            [32.02819224282182, 0.423243704790174],
            [32.02743132126714, 0.424296716198121],
            [32.0246496188196, 0.424703244808583],
            [32.02184422959463, 0.424487480791928],
            [32.01474764754623, 0.423086412277365],
            [32.01037337313545, 0.421003570288799],
            [32.00952709905235, 0.420216952960366],
            [32.0072475296958, 0.416898453746827],
            [32.00589273999163, 0.414026179614207],
            [32.003753225174385, 0.412398374939806],
            [32.00172141027488, 0.405086229686956],
            [32.00029529972706, 0.402190019893583],
            [31.995821018570606, 0.398607440969355],
            [31.995179325912012, 0.396764440642638],
            [31.99227916891615, 0.394059524125468],
            [31.99066280417429, 0.391618052198604],
            [31.987584257932674, 0.389667049275233],
            [31.986015388916517, 0.387632465864304],
            [31.98233071072515, 0.384736000263855],
            [31.979575177998452, 0.380510364596348],
            [31.97674952727225, 0.381094085958637],
            [31.97419725364997, 0.380237271090076],
            [31.969115116676736, 0.38016422888586],
            [31.965905488268863, 0.38112119561585],
            [31.953796306935086, 0.382324821552141],
            [31.939515994577643, 0.382912968691804],
            [31.93559668901048, 0.370678522264655],
            [31.93409924144929, 0.368172658291511],
            [31.93268538661689, 0.36394811056533],
            [31.929785386826186, 0.358845954625437],
            [31.92855074319801, 0.346661171169591],
            [31.927132195566543, 0.34016343567103],
            [31.962063091964772, 0.340520295901492],
            [31.97384843782513, 0.342181535246825],
            [31.976604784425497, 0.342162014305514],
            [31.99469983845102, 0.326961532025008],
            [31.99993728784866, 0.323295241190261],
            [32.002313031737856, 0.322453577150514],
            [32.0034303967124, 0.32276483397082],
            [32.00971872497382, 0.322657755589121],
            [32.01362483608608, 0.320336584962958],
            [32.02016712167156, 0.327409737331428],
            [32.02382808433943, 0.330521567862764],
            [32.02580128057339, 0.331455201003192],
            [32.03015191941074, 0.332460879525434],
            [32.030781603390636, 0.335871588105098],
            [32.03654530115305, 0.352087739012135],
            [32.03841138586581, 0.354325804998154],
            [32.03857768199119, 0.355546477062488],
            [32.04126366625027, 0.360812340579984],
            [32.044888114198486, 0.375474470197302],
            [32.04598059494136, 0.382605189387181],
            [32.04579015838935, 0.384711395064592],
            [32.047026187219686, 0.387033188279423],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 33,
        District: "MITYANA",
        County: "MITYANA MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 22515,
        Key: "MITYANACENTRAL DIVISION",
        Dist2: "Mityana",
        "Sub Country": "Maanyi",
        id2_original: "Mityana Maanyi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.20557986792938, 0.541745760430885],
            [32.206619365138486, 0.54369334815217],
            [32.21064924882557, 0.55488473374093],
            [32.21636529635204, 0.565168647210834],
            [32.21934772824817, 0.569395447325838],
            [32.221224829899526, 0.57116828083946],
            [32.23187798409158, 0.579359959837584],
            [32.23365127732706, 0.581567219214656],
            [32.23474483784492, 0.584296375387051],
            [32.23500678119189, 0.586282816938035],
            [32.234449869733155, 0.590242560759447],
            [32.229415803407434, 0.595405854519445],
            [32.22592466275246, 0.597316399361487],
            [32.2238945492621, 0.599838743601241],
            [32.22313498596012, 0.601536906332572],
            [32.22258967893826, 0.604695009369778],
            [32.22231811283799, 0.609707943382097],
            [32.21932056858385, 0.617067297477194],
            [32.21649783917894, 0.613376987598581],
            [32.21283483913203, 0.604229167191995],
            [32.207517236654844, 0.594440275135178],
            [32.20088532166189, 0.58508374636203],
            [32.20154196318512, 0.58325799029429],
            [32.20172258294772, 0.581157749560038],
            [32.20135977316743, 0.580518084031863],
            [32.19599878206203, 0.576710872153249],
            [32.190444281268014, 0.575068466471044],
            [32.19027898317088, 0.567344787858814],
            [32.191726234670625, 0.561734532382592],
            [32.192109853924514, 0.556423922799483],
            [32.1947589228153, 0.548633191223839],
            [32.19862053587998, 0.544818430097846],
            [32.20215187614393, 0.542934470249232],
            [32.20557986792938, 0.541745760430885],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 34,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "BUSUNJU TOWN COUNCIL",
        Population: 7129,
        Key: "MITYANABUSUNJU TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.190444281268014, 0.575068466471044],
            [32.1811874503873, 0.572961814446889],
            [32.17432051994635, 0.572543330029061],
            [32.17237174980328, 0.5732261188191],
            [32.17134091325182, 0.574218126263179],
            [32.16973292889325, 0.577549638683132],
            [32.16309199571314, 0.575122286320049],
            [32.16038337750216, 0.573738050241539],
            [32.15641776378209, 0.574829558075584],
            [32.151658241471814, 0.573614294650091],
            [32.15057052090162, 0.573864235651245],
            [32.14957367839715, 0.574844853818415],
            [32.1498471606039, 0.579708069744784],
            [32.14950731805046, 0.580004495912613],
            [32.14448747564895, 0.579736405649915],
            [32.139819278765394, 0.580644469605173],
            [32.13589965339797, 0.583813575769995],
            [32.13386072743467, 0.586071539749056],
            [32.13333975757048, 0.586938523083144],
            [32.13319391788074, 0.591675689968132],
            [32.132130066445946, 0.592818099126013],
            [32.1288075692142, 0.593683225589306],
            [32.12673490073221, 0.600490075380967],
            [32.124429273944216, 0.604695305797311],
            [32.1146127809634, 0.598526993845988],
            [32.09453136499507, 0.590011717654339],
            [32.08196450100721, 0.587817395758194],
            [32.080355091920566, 0.586491451413905],
            [32.07868804962028, 0.580286798578058],
            [32.07849725194551, 0.577726220527382],
            [32.07955231426356, 0.57137435220703],
            [32.079194165841244, 0.565296073321186],
            [32.07976362945941, 0.563334564090645],
            [32.08162748185868, 0.561003589456378],
            [32.08808561416667, 0.554703128057328],
            [32.08745853979268, 0.537897809957578],
            [32.08830958752319, 0.536493221001912],
            [32.0928118907266, 0.533531833692015],
            [32.09356781585166, 0.532322340415978],
            [32.09441952653883, 0.53030994289187],
            [32.09535634900593, 0.524125883391776],
            [32.09610536788308, 0.522173087555787],
            [32.10070067097292, 0.516760432228543],
            [32.10179018637705, 0.513563208540254],
            [32.10423520474769, 0.509019413415412],
            [32.104483612279964, 0.505968760060131],
            [32.10393619242053, 0.502570277508216],
            [32.10196383700968, 0.499768455782491],
            [32.0951399511422, 0.493911015373413],
            [32.091978005309606, 0.492498422908792],
            [32.087413266499, 0.491420728637223],
            [32.08322903338151, 0.489720780478851],
            [32.08204034307169, 0.489098316509987],
            [32.0810799344385, 0.487963508876977],
            [32.07999539570102, 0.487618162285216],
            [32.07489041007858, 0.48765171584078],
            [32.07230417744359, 0.485561418749183],
            [32.071707382582886, 0.484488957661157],
            [32.07109509178356, 0.482261891445506],
            [32.0713334202183, 0.481542439114698],
            [32.07708509672562, 0.480995048447978],
            [32.079944021049954, 0.47996759874113],
            [32.07769800197259, 0.478699624378748],
            [32.07606485220967, 0.475410316237272],
            [32.073472797593325, 0.47446962201135],
            [32.0724575791514, 0.473628241104452],
            [32.0682388103028, 0.463623389871283],
            [32.06720610615387, 0.459605407217902],
            [32.071571272545974, 0.459549525720119],
            [32.076455927480396, 0.457449014737852],
            [32.078639946633444, 0.457675636287692],
            [32.080663147587714, 0.459680594686036],
            [32.081272926697515, 0.459188922114218],
            [32.08387555089148, 0.45528361089366],
            [32.084036433768986, 0.452987928704745],
            [32.084486172621034, 0.452341309204653],
            [32.09031355015732, 0.452534131060099],
            [32.090657633657216, 0.45160213909878],
            [32.08968330383208, 0.447916062612492],
            [32.089921090582735, 0.44770067384737],
            [32.09291694061424, 0.446360704011745],
            [32.09653090881635, 0.445331953952669],
            [32.09839743460188, 0.444051678537255],
            [32.10108412044519, 0.44342969829861],
            [32.102867395760114, 0.44240071337804],
            [32.10555401782304, 0.44240104215161],
            [32.110155076418884, 0.441537658392124],
            [32.11474997975843, 0.438112048362609],
            [32.11730394490841, 0.433853041514573],
            [32.12054857886627, 0.429822479997469],
            [32.12127184214593, 0.429351467007589],
            [32.12241631558082, 0.429432884425236],
            [32.12207228058993, 0.429729464761569],
            [32.12334628120734, 0.432869885118468],
            [32.12552386572801, 0.435043443029021],
            [32.129812028534, 0.436285260635427],
            [32.13112509508648, 0.437408881157153],
            [32.133559657067195, 0.437868715336799],
            [32.1354614857451, 0.439726301408867],
            [32.13548180024696, 0.440864351523583],
            [32.13590967859654, 0.441582456044977],
            [32.14179324036396, 0.449254347874433],
            [32.1424113441615, 0.449757064670317],
            [32.145597234588, 0.450164339277495],
            [32.14207797576632, 0.454113213003781],
            [32.139890427132514, 0.455716606736706],
            [32.1396405876857, 0.45735613010075],
            [32.13864179673536, 0.459127203547887],
            [32.137975456102005, 0.464273170318859],
            [32.138520938295365, 0.467742069829662],
            [32.14258875334527, 0.466588702785311],
            [32.144596275104576, 0.470426288769042],
            [32.14551510701146, 0.471071670584334],
            [32.147758261361346, 0.471538687103302],
            [32.14906577452874, 0.472831350339962],
            [32.1492796346518, 0.473788784321461],
            [32.15139543394554, 0.475799597635119],
            [32.15220374791966, 0.476302343091398],
            [32.15619806460969, 0.476446450339819],
            [32.15776731001996, 0.476135485892704],
            [32.15918170743481, 0.478253921927808],
            [32.16505385790316, 0.482203969229283],
            [32.16659901409078, 0.484478007589322],
            [32.17336274337695, 0.488751309051993],
            [32.177761180672256, 0.489709268090673],
            [32.18116114681746, 0.489709689385157],
            [32.185880898913496, 0.487974951202082],
            [32.19137358124292, 0.484504983931142],
            [32.19301418522606, 0.484026478352736],
            [32.193299428176545, 0.484624892156806],
            [32.19636606635076, 0.488550678528408],
            [32.19725713043391, 0.493086553324104],
            [32.198659444609866, 0.496988207786486],
            [32.20224601150087, 0.500292630636359],
            [32.20160535819305, 0.502254150954181],
            [32.202223536550754, 0.50402559183194],
            [32.20195121227239, 0.506454132304918],
            [32.20102591429206, 0.509587886190097],
            [32.20157338894872, 0.513010383244278],
            [32.201301385368886, 0.516420029488087],
            [32.19827506717789, 0.522913592844406],
            [32.197563485590216, 0.5259039942001],
            [32.19782608201237, 0.529828695565537],
            [32.19847995582621, 0.531803580317817],
            [32.200027722518016, 0.53417126627988],
            [32.20363659367919, 0.538437600867503],
            [32.20557986792938, 0.541745760430885],
            [32.20215187614393, 0.542934470249232],
            [32.19862053587998, 0.544818430097846],
            [32.1947589228153, 0.548633191223839],
            [32.192109853924514, 0.556423922799483],
            [32.191726234670625, 0.561734532382592],
            [32.19027898317088, 0.567344787858814],
            [32.190444281268014, 0.575068466471044],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 35,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "SSEKANYONYI",
        Population: 30542,
        Key: "MITYANASSEKANYONYI",
        Dist2: "Mityana",
        "Sub Country": "Sekanyonyi",
        id2_original: "Mityana Sekanyonyi",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.706229650785183, 0.495390472035263],
            [31.705990351271613, 0.496255771476091],
            [31.706323100727566, 0.497522142689328],
            [31.70603306257011, 0.497522085199314],
            [31.705567172009246, 0.502225401478074],
            [31.70458209743499, 0.507010020400904],
            [31.702000736363797, 0.513530951334184],
            [31.69669264524884, 0.516451386604211],
            [31.68771853574759, 0.516377156437567],
            [31.686490570195232, 0.5170643172267],
            [31.68215856601015, 0.520844195635122],
            [31.682309809964625, 0.523964731472287],
            [31.68140813947295, 0.528441775675776],
            [31.676630303208952, 0.53326169324657],
            [31.671284906856897, 0.533423334485365],
            [31.670327981890388, 0.533649248289233],
            [31.668433321768426, 0.53496938556907],
            [31.666904809566436, 0.534914782057894],
            [31.664719636976546, 0.535827834767572],
            [31.66322294489851, 0.535348121229534],
            [31.660310690290732, 0.535727363494255],
            [31.652525345659495, 0.533681504493533],
            [31.64158493179914, 0.532005785069577],
            [31.63985103238385, 0.531390354209089],
            [31.637358741967986, 0.529689380006702],
            [31.629707211279786, 0.52209913502424],
            [31.626907387118003, 0.52027924511492],
            [31.621418209116523, 0.523572934157615],
            [31.611193077004554, 0.52384614533776],
            [31.60954048410558, 0.523348358421202],
            [31.611735382755047, 0.51930938389692],
            [31.611040161285306, 0.515673272315928],
            [31.61202187526209, 0.511060704608989],
            [31.61188507082745, 0.507478983686041],
            [31.614920665022076, 0.50105791573319],
            [31.614907107647813, 0.497440038869016],
            [31.614321712408085, 0.497439914906155],
            [31.614419017919644, 0.496671136869967],
            [31.61513269527692, 0.494111642142912],
            [31.616975914272423, 0.490060007862589],
            [31.617726551913705, 0.481069737138276],
            [31.619224705550717, 0.478320454229447],
            [31.621911271019787, 0.475878928715211],
            [31.62579880137872, 0.471348305505273],
            [31.628105450449503, 0.46765851402075],
            [31.628842657379014, 0.465198489961724],
            [31.629259490043886, 0.461381691963902],
            [31.62887978385139, 0.457573782261448],
            [31.62703912595274, 0.449975849800226],
            [31.625375842203606, 0.445670242974095],
            [31.624533403028448, 0.437348941019698],
            [31.62415345878242, 0.436200188152376],
            [31.622798793944078, 0.434571888694369],
            [31.619649339185518, 0.432219679688466],
            [31.61565648225781, 0.428293552524737],
            [31.61372050142946, 0.421175032486222],
            [31.60864730448993, 0.410682304638957],
            [31.606045010875974, 0.406982582226695],
            [31.600305969173164, 0.397303824697736],
            [31.596336949939865, 0.391894459146938],
            [31.591476807334605, 0.38646687088686],
            [31.57025075443802, 0.367704957387742],
            [31.574545540522568, 0.3636898824665],
            [31.581534680469716, 0.360027953481705],
            [31.586230533785944, 0.353245260108587],
            [31.589464022346085, 0.349392766400922],
            [31.590462684837302, 0.347430242505367],
            [31.592031713753578, 0.346381302568088],
            [31.59427848022925, 0.343469278595739],
            [31.59520557304349, 0.343234255689709],
            [31.601125133897593, 0.338902757645756],
            [31.60598692760635, 0.333648529283547],
            [31.61174007824904, 0.330727922719192],
            [31.613474983777447, 0.332021556838762],
            [31.614782255298056, 0.333631696937121],
            [31.617075933594453, 0.334527451168539],
            [31.619643387846747, 0.333189202405014],
            [31.623351709696387, 0.332873162460543],
            [31.62377966440279, 0.332303403014386],
            [31.6257051142811, 0.332376035973117],
            [31.628106259831586, 0.331752286858291],
            [31.62823672036366, 0.332430658911365],
            [31.630218579051906, 0.332525544560614],
            [31.631847121355754, 0.333085004983227],
            [31.632437405227254, 0.336687494959925],
            [31.632112225874213, 0.338341792005845],
            [31.632557000635998, 0.344417131465825],
            [31.633707615852515, 0.348735420221412],
            [31.637661679034633, 0.355596404464553],
            [31.63909082678645, 0.359774550925862],
            [31.639239036231903, 0.362028100788805],
            [31.635016841208806, 0.364174258669361],
            [31.634852837584017, 0.370841575651258],
            [31.633798549613765, 0.373574144576248],
            [31.63169049649273, 0.375663547129463],
            [31.625654319941685, 0.378331012366799],
            [31.625294716248604, 0.379136614692994],
            [31.629577672419206, 0.382645736638312],
            [31.633393003382125, 0.388465467996761],
            [31.634718137003812, 0.38959092869646],
            [31.635915639786568, 0.390041223065192],
            [31.640610129460164, 0.390122367800796],
            [31.64659153303338, 0.388927104293036],
            [31.64974192653144, 0.385852380595322],
            [31.652071499709955, 0.38541859307201],
            [31.656509258960206, 0.383556074387236],
            [31.657525856316113, 0.383718209474962],
            [31.65896418934168, 0.384640639059344],
            [31.661751478411997, 0.384671970692047],
            [31.664670727302582, 0.384534218943407],
            [31.666731149052314, 0.383416886246617],
            [31.667963188464505, 0.38330463078992],
            [31.670363779754453, 0.384905959478757],
            [31.67362074219128, 0.384526584333717],
            [31.675546116611066, 0.385386151149488],
            [31.67988460214095, 0.383197960931281],
            [31.680759704958138, 0.38226118092415],
            [31.684163645250162, 0.382294136683461],
            [31.68606569671028, 0.381480382621429],
            [31.68797123363366, 0.381289676308218],
            [31.691915186277292, 0.383766198197725],
            [31.698040486484295, 0.383954017335377],
            [31.706485690404094, 0.386244391995265],
            [31.7093163312717, 0.38638497334509],
            [31.72174738795494, 0.38205567880619],
            [31.724148300841748, 0.381911319155022],
            [31.733485124901897, 0.385329352857064],
            [31.748093062724916, 0.389331930620673],
            [31.750211742017484, 0.391539271788071],
            [31.759883164266412, 0.393892517787689],
            [31.757305564441292, 0.397229777450476],
            [31.754078007456986, 0.402936802397306],
            [31.751946806547714, 0.405432941967526],
            [31.747168126765676, 0.406318619089133],
            [31.744933229729888, 0.407611731083484],
            [31.743661118269507, 0.408841666863267],
            [31.74171159533824, 0.411229281931988],
            [31.7407851133784, 0.413961498110675],
            [31.73982846958455, 0.415068111833197],
            [31.739036466321053, 0.417845969771726],
            [31.738112847291994, 0.418675893962207],
            [31.737628770338226, 0.420822941925702],
            [31.7379251685679, 0.423512433860538],
            [31.74012306938703, 0.428869551441526],
            [31.739661037988633, 0.430618167278298],
            [31.739660693035585, 0.43269889029247],
            [31.73909965561475, 0.434790585341229],
            [31.738274918640624, 0.435952550462416],
            [31.737636787802124, 0.438830036371225],
            [31.73688904273603, 0.439781726727672],
            [31.736822967155327, 0.440445775031988],
            [31.73766928705248, 0.441685499628396],
            [31.73717414285441, 0.444142434400785],
            [31.73670121758655, 0.445238051400309],
            [31.735293800081454, 0.446388842884055],
            [31.734875784335337, 0.447827565989447],
            [31.73394362861616, 0.449173031280965],
            [31.731102326542757, 0.450980856571365],
            [31.73017492650472, 0.452563592187469],
            [31.729651637190447, 0.45535843999059],
            [31.727297544496228, 0.458858466780932],
            [31.726417193721165, 0.462684385533638],
            [31.725192620207316, 0.464827855485968],
            [31.725310294119666, 0.470806675628861],
            [31.725725920347106, 0.473502194707636],
            [31.72548762514999, 0.476061910122899],
            [31.722169797361097, 0.484500351484875],
            [31.72098096242251, 0.486128237111351],
            [31.71910261301121, 0.487412277671827],
            [31.71470444251554, 0.489301840385215],
            [31.71177995824344, 0.491870067365582],
            [31.706229650785183, 0.495390472035263],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 36,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "KIGANDA",
        Population: 38227,
        Key: "MUBENDEKIGANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.444522568832213, 0.624442523560693],
            [31.442595983483375, 0.629452311219404],
            [31.442301279476325, 0.63666931654343],
            [31.44142723936614, 0.637817634708158],
            [31.44068136818572, 0.638477615654364],
            [31.43798957182675, 0.638377306115744],
            [31.434255277885633, 0.639461430694392],
            [31.431329130831976, 0.641902388779987],
            [31.42735282985497, 0.64392699030258],
            [31.424334222802365, 0.648475129122461],
            [31.42208590852949, 0.653240550408272],
            [31.419856207349312, 0.66036642001963],
            [31.414573054364944, 0.666641155524],
            [31.414988102077356, 0.668070219807649],
            [31.417113723550422, 0.669572194948852],
            [31.4165716872945, 0.671905335356226],
            [31.41514216045364, 0.675233005992752],
            [31.413934825610095, 0.67559436234303],
            [31.412330126390536, 0.677140330680592],
            [31.41005339301533, 0.678450932173753],
            [31.40629161601637, 0.679426413420568],
            [31.402547209740096, 0.683069816083227],
            [31.400470385651587, 0.683485131603965],
            [31.399769988987476, 0.683285932681583],
            [31.39878667600949, 0.683701615568424],
            [31.397265592874863, 0.685383245956987],
            [31.39588794823324, 0.686287156764373],
            [31.39454053729083, 0.686612275053113],
            [31.388812372389474, 0.691928047462028],
            [31.38776430345589, 0.694541327520429],
            [31.3843113888112, 0.695908433988934],
            [31.383006808643202, 0.694868024366745],
            [31.37810134333692, 0.69450245129124],
            [31.372706107554567, 0.691875498951376],
            [31.37017683799006, 0.689041619725377],
            [31.36034453735521, 0.67547105827644],
            [31.35657605802591, 0.672428865323103],
            [31.354872869315223, 0.669959174410041],
            [31.35195721278747, 0.664500157421622],
            [31.350951264060924, 0.661588872110071],
            [31.350513822246807, 0.657144335649316],
            [31.34909461076036, 0.654726739583974],
            [31.344681038649153, 0.650618767788059],
            [31.345560518956695, 0.645524918360336],
            [31.34633555214619, 0.644017721601684],
            [31.347979266995182, 0.642195051405016],
            [31.356870850966207, 0.639498791994856],
            [31.36022771235082, 0.637992416266368],
            [31.363584889942437, 0.635498384426773],
            [31.36766491669033, 0.633212498987626],
            [31.37143539926269, 0.630042813644298],
            [31.373191312792354, 0.629211659885841],
            [31.378253087653015, 0.624846774651233],
            [31.384502495506418, 0.620534211383277],
            [31.386620218991506, 0.618559545969617],
            [31.38986588780859, 0.611084878366398],
            [31.38900830663102, 0.610109366958247],
            [31.388258442439177, 0.608246129221551],
            [31.388350190972428, 0.602747561863459],
            [31.3877678886322, 0.601001945919835],
            [31.384407743006907, 0.596108286521132],
            [31.378102871371212, 0.591400461732467],
            [31.37902614365056, 0.590094661892478],
            [31.38115421842267, 0.588741441287538],
            [31.383021112517483, 0.5882166147916],
            [31.385871360912777, 0.58837910427427],
            [31.386554712044365, 0.585307880504028],
            [31.38874362252414, 0.581792541906561],
            [31.390191190230837, 0.5776516794192],
            [31.393053728477557, 0.577655255430593],
            [31.39313952926529, 0.576220684517544],
            [31.394163634740337, 0.573256029424346],
            [31.394128713631968, 0.570855396995053],
            [31.3933818282536, 0.568884526969635],
            [31.389725628453384, 0.565708053880938],
            [31.3895369157684, 0.564378059474356],
            [31.391144170694965, 0.56413834488599],
            [31.391287448389516, 0.563417007481809],
            [31.39074065824912, 0.561606589687858],
            [31.3901429210557, 0.561092512117927],
            [31.389766446103263, 0.558731192943044],
            [31.388534536946818, 0.556397418358557],
            [31.388236568462016, 0.55282773905445],
            [31.38757273502663, 0.551247995597306],
            [31.394967553257764, 0.552800445015023],
            [31.39717040109917, 0.55256100572449],
            [31.397209791326063, 0.553864099522358],
            [31.398701771740427, 0.558093813724374],
            [31.39854236569325, 0.559716907775329],
            [31.394703850111146, 0.562161980540659],
            [31.392553410881764, 0.564450322737668],
            [31.395286284503705, 0.564841969182488],
            [31.39590813607264, 0.563242638540346],
            [31.39639842307998, 0.563080618137564],
            [31.40167847777489, 0.565112579793243],
            [31.405627698139327, 0.567821009932536],
            [31.40855799271468, 0.567102787292584],
            [31.413163811483216, 0.567779310388105],
            [31.41057628617254, 0.571947729990545],
            [31.410554740978757, 0.573879521515687],
            [31.408865580359535, 0.578588682358131],
            [31.40856332601252, 0.582515642993797],
            [31.407196900430474, 0.585130932403398],
            [31.40660795504872, 0.587415074976591],
            [31.405031647083693, 0.589226557112115],
            [31.404946831747843, 0.591926813186018],
            [31.402592810918854, 0.594837914539119],
            [31.399342568778682, 0.596952057080196],
            [31.401035934411745, 0.602042891336501],
            [31.404871855659295, 0.608889907384714],
            [31.402455136915023, 0.6105742124541],
            [31.39863481131915, 0.614210308665037],
            [31.402234013912896, 0.614065497780605],
            [31.405283346043166, 0.614410084297656],
            [31.408960924848838, 0.613081749835011],
            [31.41292552437095, 0.61237751900866],
            [31.428193887421195, 0.612336850107003],
            [31.437004764950462, 0.621283927345617],
            [31.442480202321374, 0.623202886913298],
            [31.444522568832213, 0.624442523560693],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 37,
        District: "MUBENDE",
        County: "MUBENDE MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 27704,
        Key: "MUBENDEEASTERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.57205686941901, 0.58684489300001],
            [31.56763313287035, 0.589132006342873],
            [31.56334863159747, 0.593689309552092],
            [31.560088555599876, 0.5963656147634],
            [31.556107788199302, 0.596798693338918],
            [31.55456197803817, 0.597612282938679],
            [31.547875927871235, 0.602856262776381],
            [31.543106998403296, 0.605685871309935],
            [31.53803902247224, 0.609691151226978],
            [31.536850483977695, 0.609980245048695],
            [31.533216294698555, 0.609038630350815],
            [31.522321444287748, 0.608954221330197],
            [31.51135133571737, 0.611148926399434],
            [31.5111403475083, 0.609620385955127],
            [31.50983848294739, 0.606535927345045],
            [31.504068526622394, 0.596730360405261],
            [31.502981919064805, 0.592886261437333],
            [31.500760263196298, 0.58886097199386],
            [31.492919466460897, 0.587384629976695],
            [31.48484019127205, 0.584388802731172],
            [31.482202727716427, 0.584659407026201],
            [31.47989917244345, 0.585635543659496],
            [31.476267668228704, 0.585553149095375],
            [31.47365767425612, 0.586022724256939],
            [31.47147126288947, 0.585732710245321],
            [31.469569543806053, 0.584375570337027],
            [31.46518086760461, 0.584320095066948],
            [31.46178292716036, 0.585431574757751],
            [31.458616245409598, 0.584797611025208],
            [31.455873510980748, 0.585149566083854],
            [31.455933361236564, 0.582915704980762],
            [31.457772200945055, 0.576965232505903],
            [31.45935466506472, 0.574279583213121],
            [31.460522784852838, 0.573520200838968],
            [31.46178425936192, 0.57326730990305],
            [31.462248591345784, 0.572317809351271],
            [31.462352614459046, 0.566502503104927],
            [31.460638865153875, 0.564602790881408],
            [31.457146011411634, 0.56377884574497],
            [31.451318042783893, 0.560948228938999],
            [31.453087956557255, 0.557735251110454],
            [31.455704923253066, 0.555091096724632],
            [31.461049164371687, 0.548308834318032],
            [31.462039043136095, 0.546239683709467],
            [31.461919013841083, 0.542742684950714],
            [31.45854568454065, 0.536792743908508],
            [31.460338121773137, 0.534553182785536],
            [31.461239626974855, 0.5341550236488],
            [31.4633942954726, 0.533801445939095],
            [31.464471371006695, 0.534664894207831],
            [31.466230275027964, 0.534421879058885],
            [31.4675492767495, 0.534953398948814],
            [31.468992069012163, 0.532847951624913],
            [31.45484394554541, 0.525765131285197],
            [31.45301919681045, 0.525609745451153],
            [31.449699076520968, 0.52693686675487],
            [31.448281106506236, 0.526593455335805],
            [31.44409276898621, 0.527134644954979],
            [31.44145417984152, 0.528550456421811],
            [31.437354167375176, 0.527608785320942],
            [31.436057000104885, 0.527763381519498],
            [31.434727166497648, 0.526678554537665],
            [31.43333003560085, 0.526948664728844],
            [31.433082590164272, 0.520623704272224],
            [31.433443454193682, 0.520180642009126],
            [31.43357114611807, 0.51810056786242],
            [31.43268172415524, 0.515938843077785],
            [31.432508941295186, 0.514166188304629],
            [31.432707500414022, 0.49757060946302],
            [31.429155546509243, 0.491682159306376],
            [31.42145402008392, 0.482179279908044],
            [31.41979228233536, 0.479696776061773],
            [31.41728600874382, 0.47408898922208],
            [31.415589525956726, 0.471538226283164],
            [31.410703700517484, 0.46596609029995],
            [31.40537494725269, 0.458820252775816],
            [31.401025209425562, 0.455084179516159],
            [31.399702301829148, 0.451638196354124],
            [31.399324169485027, 0.447713105253074],
            [31.398245683595924, 0.445967415538461],
            [31.39429253400045, 0.441363263740984],
            [31.38927812640641, 0.43716586520461],
            [31.38818188172245, 0.437075189203812],
            [31.386525757546117, 0.436134280669717],
            [31.386147009856025, 0.4350037314516],
            [31.384595904126307, 0.433954322760184],
            [31.38302161018414, 0.433700757183786],
            [31.3809166131317, 0.431376067914722],
            [31.379832228904455, 0.430986953905203],
            [31.379191007861404, 0.429802090610867],
            [31.376555518802764, 0.428390708895828],
            [31.376100930844782, 0.427459110962826],
            [31.375401175577828, 0.426952514750687],
            [31.373995873605235, 0.426771339467486],
            [31.372491562915283, 0.424844714798169],
            [31.370666544685733, 0.423460643805834],
            [31.367093978038454, 0.417992243948127],
            [31.3705772054341, 0.413336224984648],
            [31.380510552165386, 0.403160150390047],
            [31.38391083721253, 0.401269320563148],
            [31.38999447265835, 0.40343227478924],
            [31.398852186549924, 0.403434046223069],
            [31.40833421878412, 0.402748895654123],
            [31.411494385054137, 0.395297646299407],
            [31.411733736670033, 0.394429482923703],
            [31.41146557877795, 0.393253730978624],
            [31.408870851673605, 0.391227410048673],
            [31.408060893782523, 0.388459841977449],
            [31.408813335240914, 0.386578867593023],
            [31.408662120930835, 0.384534931291362],
            [31.410879060644078, 0.380094822082984],
            [31.41198819794898, 0.374189394801425],
            [31.412904126500887, 0.371675371698708],
            [31.41267191738981, 0.367207665663497],
            [31.414678934295907, 0.362161550944115],
            [31.415758573621815, 0.357694071947827],
            [31.41833164324297, 0.350314718037272],
            [31.41822767223197, 0.344210081616317],
            [31.41954606759071, 0.340402828878925],
            [31.41566882563673, 0.335391880702645],
            [31.41138482742043, 0.321318947393819],
            [31.411280727950352, 0.315521823913995],
            [31.409538426592167, 0.306739984557239],
            [31.40976622767012, 0.303981647837457],
            [31.411213231234843, 0.299396632934305],
            [31.413535357379683, 0.300030044341244],
            [31.41789895710995, 0.302716717272106],
            [31.420910123417038, 0.302581504741895],
            [31.42324774190726, 0.302925518760415],
            [31.4370321033795, 0.30678027521688],
            [31.44368286772207, 0.305949213407403],
            [31.44911419152432, 0.306610224773221],
            [31.456673111296624, 0.306267660732451],
            [31.476772420807063, 0.311950296263422],
            [31.489542645408978, 0.315090498073423],
            [31.499990506710823, 0.31713602696198],
            [31.504777417755797, 0.319533456907552],
            [31.507254748527227, 0.321216054182074],
            [31.51401923688978, 0.329402134665161],
            [31.520158955955434, 0.334594496685058],
            [31.536324317359586, 0.341099866093145],
            [31.54829152714923, 0.348843734376449],
            [31.557881694085804, 0.356370225263839],
            [31.57025075443802, 0.367704957387742],
            [31.591476807334605, 0.38646687088686],
            [31.596336949939865, 0.391894459146938],
            [31.600305969173164, 0.397303824697736],
            [31.606045010875974, 0.406982582226695],
            [31.60864730448993, 0.410682304638957],
            [31.61372050142946, 0.421175032486222],
            [31.61565648225781, 0.428293552524737],
            [31.619649339185518, 0.432219679688466],
            [31.622798793944078, 0.434571888694369],
            [31.62415345878242, 0.436200188152376],
            [31.624533403028448, 0.437348941019698],
            [31.625375842203606, 0.445670242974095],
            [31.62703912595274, 0.449975849800226],
            [31.62887978385139, 0.457573782261448],
            [31.629259490043886, 0.461381691963902],
            [31.628842657379014, 0.465198489961724],
            [31.628105450449503, 0.46765851402075],
            [31.62579880137872, 0.471348305505273],
            [31.621911271019787, 0.475878928715211],
            [31.619224705550717, 0.478320454229447],
            [31.617726551913705, 0.481069737138276],
            [31.616975914272423, 0.490060007862589],
            [31.61513269527692, 0.494111642142912],
            [31.614419017919644, 0.496671136869967],
            [31.614321712408085, 0.497439914906155],
            [31.614907107647813, 0.497440038869016],
            [31.614920665022076, 0.50105791573319],
            [31.61188507082745, 0.507478983686041],
            [31.61202187526209, 0.511060704608989],
            [31.611040161285306, 0.515673272315928],
            [31.611735382755047, 0.51930938389692],
            [31.60954048410558, 0.523348358421202],
            [31.60921636386625, 0.52688825198751],
            [31.60811813929542, 0.53007172347135],
            [31.608716526869102, 0.534711770749673],
            [31.60823591831063, 0.538148630984014],
            [31.603012318239745, 0.542841590414973],
            [31.599581105993998, 0.548783105983327],
            [31.594641431943383, 0.554281054624228],
            [31.58959960327528, 0.564201752989579],
            [31.587386113092684, 0.566272417175546],
            [31.585492522864264, 0.569030544512765],
            [31.58087472595973, 0.573850142689642],
            [31.58023151424998, 0.574899148854404],
            [31.580047923758745, 0.578164184438538],
            [31.579594777596842, 0.579258459890415],
            [31.576855819685424, 0.583011247543692],
            [31.573739369030424, 0.585108779307075],
            [31.57205686941901, 0.58684489300001],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 38,
        District: "MUBENDE",
        County: "BUWEKULA",
        Subcounty: "KITENGA",
        Population: 61421,
        Key: "MUBENDEKITENGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.543267808517268, 0.856640811237147],
            [31.539595188411944, 0.857534792728084],
            [31.532087209404477, 0.860534615679919],
            [31.523385365791107, 0.862855611541167],
            [31.509294526991727, 0.864785531267779],
            [31.504306603528878, 0.864765461597294],
            [31.501268958480452, 0.863253865877514],
            [31.50127397377468, 0.862638860959971],
            [31.4917418083611, 0.863991684279946],
            [31.470812053981177, 0.860645963670954],
            [31.46425753693478, 0.864134313340026],
            [31.46257418033061, 0.864522520131489],
            [31.449390425270817, 0.865005215289905],
            [31.447706780307442, 0.862703111965447],
            [31.440076319604227, 0.856775094359643],
            [31.43882140279669, 0.854621877845831],
            [31.43739082582526, 0.850157895843755],
            [31.43831525872796, 0.844648152607658],
            [31.43725749787079, 0.840125081471053],
            [31.437336315155527, 0.839295632986577],
            [31.43786204339578, 0.838690389686773],
            [31.437561512017457, 0.836973377136601],
            [31.440959569242693, 0.82987522844021],
            [31.444052385222594, 0.82715422130428],
            [31.445047297247534, 0.825996985564016],
            [31.444975953047688, 0.825354834074558],
            [31.439055888238677, 0.820125083474325],
            [31.434761508192622, 0.816894703061489],
            [31.429178266699438, 0.818475187130514],
            [31.42280763209673, 0.813272425492918],
            [31.421525640964873, 0.811237045808597],
            [31.4100705068198, 0.808275182018533],
            [31.409406357177435, 0.807967429154656],
            [31.406963150708712, 0.803824393006758],
            [31.40438736997205, 0.801282067021021],
            [31.40749618315053, 0.766446487260498],
            [31.40710486533465, 0.764791321147423],
            [31.407765940942152, 0.762015114897704],
            [31.407659959501554, 0.759338103596231],
            [31.40912635589661, 0.755431714868147],
            [31.408846378870344, 0.747111288099569],
            [31.41393247292236, 0.747149322229803],
            [31.416347186626915, 0.746480956081716],
            [31.41831700070381, 0.744772381131782],
            [31.41902357867539, 0.743416056507304],
            [31.423841470817894, 0.741373876710675],
            [31.42543852806934, 0.741799514041397],
            [31.427769644553532, 0.740959267931797],
            [31.43018315451557, 0.740544112984069],
            [31.432650370256887, 0.740698742345989],
            [31.43486825948943, 0.740111677649854],
            [31.440478826835257, 0.736233813424556],
            [31.443265352337573, 0.733738658775719],
            [31.44372013792489, 0.732228473621723],
            [31.446751399544873, 0.731587412684301],
            [31.448363938361968, 0.735196533438091],
            [31.449898118933408, 0.737259105246478],
            [31.453356763931307, 0.748028912710933],
            [31.459525627938017, 0.745547059543484],
            [31.463677055479643, 0.74500047734246],
            [31.469869577517677, 0.74592748809527],
            [31.480612902801315, 0.748974743616941],
            [31.4830981073062, 0.748051287837576],
            [31.48317011805599, 0.746025423109452],
            [31.483805182944433, 0.744442917689238],
            [31.48538434665373, 0.742336177375718],
            [31.486167278729496, 0.739369963711874],
            [31.486282988924625, 0.73843845409361],
            [31.4852581746788, 0.735227425753842],
            [31.485209997131804, 0.733228649727738],
            [31.48584699878799, 0.731700404347569],
            [31.485811033837262, 0.730471525541678],
            [31.484831693209475, 0.729333217090813],
            [31.482269615374175, 0.728510473588585],
            [31.482144574378196, 0.72682875729863],
            [31.48146471230317, 0.725611884879624],
            [31.484188242547862, 0.721433907493742],
            [31.48793400438193, 0.712871831565832],
            [31.492766025227215, 0.712188364404864],
            [31.497801457890496, 0.713834194001515],
            [31.500662931633585, 0.714304348282426],
            [31.506904304056782, 0.714234047998056],
            [31.50830751205644, 0.711765427105767],
            [31.509199781678696, 0.711747630158328],
            [31.50920290601927, 0.709893557577434],
            [31.506360901463307, 0.705913162276713],
            [31.505656644738462, 0.702729359355963],
            [31.504472508887126, 0.701480871211228],
            [31.505793489597266, 0.699726714781341],
            [31.5066252091761, 0.699401388999096],
            [31.508732284930122, 0.700424067098449],
            [31.509969369280913, 0.700279757241394],
            [31.512055600527088, 0.70152853584067],
            [31.514407851674964, 0.701465981853039],
            [31.515696802953634, 0.700679542342285],
            [31.517143187579116, 0.696564852771977],
            [31.521220689162767, 0.689430187529918],
            [31.52357774180586, 0.686554833711737],
            [31.52673553472688, 0.683661632605133],
            [31.528818556292524, 0.678009565103739],
            [31.534963851201123, 0.686540285641853],
            [31.53652694764327, 0.688123535046367],
            [31.53931014937903, 0.692782254181662],
            [31.540388823914324, 0.695604438663706],
            [31.5406045174989, 0.699023284811654],
            [31.54106912706213, 0.700117802191888],
            [31.542269704778107, 0.700959307996251],
            [31.544736155154794, 0.701231415171],
            [31.5471725667667, 0.700599071886208],
            [31.55007197366933, 0.699026249031488],
            [31.55577133588771, 0.694243511164414],
            [31.557530837288652, 0.693556675535236],
            [31.578961446456898, 0.688688221086833],
            [31.580142828073566, 0.692794801830575],
            [31.581256714771353, 0.694441247278892],
            [31.581643805115494, 0.697561734683994],
            [31.584162638053023, 0.697444921929231],
            [31.587464905224568, 0.698015732913987],
            [31.58953355015243, 0.697356106686852],
            [31.59171997409548, 0.697184921132083],
            [31.592314772001288, 0.696778093462751],
            [31.594749799309337, 0.697158702148368],
            [31.59605884410432, 0.695938074410111],
            [31.600694761824766, 0.694745576827724],
            [31.60342514711338, 0.696157356751867],
            [31.605276103298426, 0.697740722413049],
            [31.60598663565389, 0.699052409618657],
            [31.606398325463744, 0.701639302386992],
            [31.606653914128376, 0.705130613824143],
            [31.606103118400153, 0.707662948206253],
            [31.604243658762627, 0.711026988915432],
            [31.603257237613747, 0.71122566927433],
            [31.6023996510463, 0.712491655322349],
            [31.601091932164703, 0.712988708607172],
            [31.600094104208353, 0.712843688628023],
            [31.59159531488353, 0.714830879089829],
            [31.58583936868367, 0.717886154609027],
            [31.582649294802888, 0.721294953624592],
            [31.58214726950975, 0.723112750509189],
            [31.582795474055832, 0.726133836933675],
            [31.582027554625096, 0.730619691501364],
            [31.582154966275112, 0.732591444187422],
            [31.58336193999589, 0.735486088707773],
            [31.584429034348872, 0.736770758580975],
            [31.584712230038804, 0.737991864974539],
            [31.586965518283407, 0.74040748974146],
            [31.587621949600873, 0.745753044658157],
            [31.589013331279812, 0.747064958732568],
            [31.591844136539127, 0.748730081398366],
            [31.593044024348934, 0.750069071078627],
            [31.59401570234738, 0.750340724383767],
            [31.598514074523088, 0.749283963119462],
            [31.605265379210575, 0.750091112948456],
            [31.608987625845455, 0.753692083256187],
            [31.609168664222967, 0.754768456465738],
            [31.61062950723294, 0.757554684508335],
            [31.61257230088444, 0.758161305970446],
            [31.612563837856154, 0.759165261352738],
            [31.61400098869881, 0.760531473358633],
            [31.614963508372906, 0.760504651128976],
            [31.6192220079099, 0.762513952835973],
            [31.61981615004557, 0.762477965919386],
            [31.61989650704266, 0.761428807582984],
            [31.62073081646449, 0.761076333490265],
            [31.62203349400071, 0.761519945297214],
            [31.622996727835467, 0.762786515274837],
            [31.63042030203715, 0.762743685601094],
            [31.6340431186448, 0.761297688484992],
            [31.634548482077555, 0.760547135902308],
            [31.635263152971515, 0.760285066517099],
            [31.635948698687343, 0.760674210265875],
            [31.638243375012017, 0.767377115115964],
            [31.637506013572306, 0.774504152512327],
            [31.641844300574498, 0.778295322834592],
            [31.644906793922008, 0.782710176812425],
            [31.651544818357213, 0.787080985002135],
            [31.653607373605723, 0.791721653596064],
            [31.6567180849244, 0.794680334357028],
            [31.656903454978217, 0.797981760711308],
            [31.65858258051743, 0.803083605470045],
            [31.658636392297893, 0.805100623200919],
            [31.65829459501037, 0.806194935215243],
            [31.656541175203948, 0.808464604382849],
            [31.655670802016708, 0.811657139445259],
            [31.65454183080866, 0.813122022240084],
            [31.654620397463443, 0.815817407205005],
            [31.64905960486915, 0.820247479864838],
            [31.643679351189128, 0.823022391368734],
            [31.63964125690039, 0.825797746460138],
            [31.63842556592807, 0.826285743246998],
            [31.63547954185211, 0.82632994654148],
            [31.634666449738987, 0.826962796787451],
            [31.633244281896925, 0.829377250163216],
            [31.631314777921776, 0.830027797571508],
            [31.62978173282083, 0.831519642707126],
            [31.62897156292731, 0.831817833998582],
            [31.626786793681017, 0.831753754041062],
            [31.622428229007912, 0.827528342291107],
            [31.620432693469457, 0.827527641678252],
            [31.619737786410074, 0.828241928081628],
            [31.618656417827246, 0.832465418673848],
            [31.61740096203055, 0.833468933807649],
            [31.61577741974958, 0.834399960533717],
            [31.612648638818957, 0.833611961006765],
            [31.609106440618188, 0.83393630651389],
            [31.606280239224724, 0.836648689658498],
            [31.604904768506074, 0.836403990403457],
            [31.603201924748433, 0.836900833341171],
            [31.599091350789283, 0.839811718098576],
            [31.595600129285934, 0.839738096493157],
            [31.592620725610654, 0.843707589246472],
            [31.589064828101787, 0.847016602786017],
            [31.586077372826622, 0.849159064710954],
            [31.583747070216063, 0.849420495142812],
            [31.582146212192665, 0.850523336963564],
            [31.57962111979423, 0.851363541882455],
            [31.575284495573598, 0.854310439623277],
            [31.5726432896365, 0.854806897629423],
            [31.566605726984967, 0.853909222040545],
            [31.56596384029027, 0.853972291141039],
            [31.56316766149191, 0.855951976469756],
            [31.558729271624358, 0.855507115683005],
            [31.555990228373016, 0.856383386436177],
            [31.551794124019015, 0.856788786746795],
            [31.543267808517268, 0.856640811237147],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 39,
        District: "MUBENDE",
        County: "BUWEKULA",
        Subcounty: "BUTOLOOGO",
        Population: 44374,
        Key: "MUBENDEBUTOLOOGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.91878784376748, 0.77666077936577],
            [32.91715797465196, 0.77788213770369],
            [32.91374772369505, 0.778732516776585],
            [32.91372242983158, 0.779519634086639],
            [32.912646720635074, 0.779791031327806],
            [32.91010484680879, 0.782930400705791],
            [32.90855700286186, 0.7833555911006],
            [32.90495261339564, 0.786703020358782],
            [32.901437308957846, 0.787625765373001],
            [32.90041384667655, 0.787526219885084],
            [32.897739148850704, 0.789109436945914],
            [32.89577141347532, 0.789453185095124],
            [32.887505612100895, 0.789416778934277],
            [32.882860159662016, 0.788602390521622],
            [32.8820346761879, 0.789561382288229],
            [32.88064411826403, 0.789751336369271],
            [32.880277297506005, 0.790203691234618],
            [32.87909654650666, 0.790312224346137],
            [32.87697043096019, 0.789705991026521],
            [32.874268774692645, 0.790845871634879],
            [32.8725367060439, 0.790420593977007],
            [32.86869035086433, 0.788375780510179],
            [32.86722114364072, 0.788828098697685],
            [32.86289164395863, 0.788809862829163],
            [32.860164139567104, 0.790184962243957],
            [32.857461666731005, 0.79050152537982],
            [32.85675413924016, 0.791478609746444],
            [32.85296412010703, 0.793052707375801],
            [32.838558172068865, 0.805600773705552],
            [32.83190889713304, 0.80828754969094],
            [32.82415562235745, 0.809083380451774],
            [32.82346725682997, 0.801854561221587],
            [32.82508880305439, 0.792309734303445],
            [32.82650759682422, 0.788509930297013],
            [32.837370563330644, 0.772596168208998],
            [32.84657175256268, 0.759993615808081],
            [32.85086825532775, 0.754854896538978],
            [32.85370564972964, 0.750611805494326],
            [32.85690765054245, 0.744613544558927],
            [32.8576375622535, 0.737185725250727],
            [32.859096762244846, 0.732861156566239],
            [32.876254746766605, 0.736313592505636],
            [32.8825097268697, 0.737089096083341],
            [32.88485672107653, 0.736878210661037],
            [32.88513333750535, 0.737180787620334],
            [32.89102873188167, 0.734481380580038],
            [32.8959534121519, 0.733001320909307],
            [32.90177810013225, 0.732403853558126],
            [32.90183320818165, 0.731394609514139],
            [32.90568517423849, 0.731803854881293],
            [32.90670469920391, 0.731577693705261],
            [32.90568238586784, 0.728377527383708],
            [32.90797523951083, 0.72795693869495],
            [32.91042879367328, 0.728097201099461],
            [32.911575226333845, 0.727633444630097],
            [32.911543205885536, 0.721323895947704],
            [32.9122958512615, 0.718235754155987],
            [32.91522684113284, 0.722100886006687],
            [32.91621454238101, 0.724548865970107],
            [32.918560962564364, 0.724214556809374],
            [32.9229537054391, 0.722367820744185],
            [32.924203557545034, 0.720648848392976],
            [32.923874738218444, 0.716677063988695],
            [32.922296117989866, 0.711511009706722],
            [32.922230447549346, 0.708462058103214],
            [32.921084757795555, 0.705730256706329],
            [32.922396982626594, 0.704638840492091],
            [32.92564340333358, 0.703074987998618],
            [32.926542738205534, 0.700524118468838],
            [32.92639031296644, 0.698544104281773],
            [32.92766847547857, 0.696975788151584],
            [32.928589892736845, 0.6969973730707],
            [32.92880418045796, 0.696684594738183],
            [32.92818687795766, 0.695279833890598],
            [32.92658638375192, 0.694473520477996],
            [32.92510785471063, 0.69298509061831],
            [32.930387964202794, 0.690249903691658],
            [32.935054412964796, 0.688558456240491],
            [32.934437368280996, 0.686744459839904],
            [32.93195244674543, 0.683279182322269],
            [32.93240971886944, 0.680811001504423],
            [32.9301919518078, 0.676903900722964],
            [32.9281348699943, 0.674994826145538],
            [32.92627062143798, 0.674617303891201],
            [32.925037027042045, 0.675204104705547],
            [32.92262611141455, 0.678026834904107],
            [32.92182452133034, 0.679682483536667],
            [32.92083140593596, 0.680062454929668],
            [32.91599835382474, 0.684305571877616],
            [32.912468817377864, 0.685300037371922],
            [32.90737004989379, 0.687659187123528],
            [32.90367354897499, 0.692966363911029],
            [32.87096536935565, 0.690465784623857],
            [32.86944033183713, 0.684737239055102],
            [32.87030617302374, 0.680338291944632],
            [32.87146827320115, 0.677588965590552],
            [32.87679839729508, 0.671783223178729],
            [32.88336060571692, 0.671113884119213],
            [32.8913121961679, 0.670987406409063],
            [32.89310771552013, 0.670598411347705],
            [32.89515966525845, 0.669784197247178],
            [32.90014014438251, 0.666572500137082],
            [32.905270361884696, 0.660890879110828],
            [32.90796352637784, 0.658574813832511],
            [32.913371448168604, 0.655408345654075],
            [32.91674877048047, 0.653001812581991],
            [32.91957056204421, 0.6503328955762],
            [32.92408062309842, 0.644026973664616],
            [32.93032242581462, 0.637313940090526],
            [32.9313891392819, 0.635088309844112],
            [32.93963241989216, 0.640860615837224],
            [32.94441674828067, 0.643330594196307],
            [32.94797318028716, 0.64631625329469],
            [32.95055589242455, 0.649211428250711],
            [32.9568009955511, 0.647700580269947],
            [32.9570973012543, 0.647184885001811],
            [32.95828279446002, 0.646678243224307],
            [32.96061136332208, 0.64637969996089],
            [32.964887669264606, 0.644841684210116],
            [32.9684016855183, 0.650984851666715],
            [32.969925878620444, 0.652432436218031],
            [32.9750278791412, 0.655264282374378],
            [32.975366544003336, 0.664854466856341],
            [32.97614940151892, 0.667494935554148],
            [32.97930971780758, 0.67001225851889],
            [32.979629277300255, 0.671513514462077],
            [32.979469485875825, 0.673443698457306],
            [32.98000208802463, 0.675641966150064],
            [32.98271840030602, 0.675910056884927],
            [32.986872764440314, 0.675481140266521],
            [32.98953581560849, 0.676231775089041],
            [32.99070755650555, 0.677357718571786],
            [32.991186903829366, 0.678430043316314],
            [32.99225212519496, 0.679234288964394],
            [32.991826030001185, 0.683041040598071],
            [32.99006840338425, 0.687062254659618],
            [32.99038796826681, 0.688295428749852],
            [32.98948252485092, 0.689689448594802],
            [32.98910969256698, 0.691297934182181],
            [32.98905662459154, 0.693167545764132],
            [32.98936433889885, 0.693344597033846],
            [32.98978281098913, 0.696122131918143],
            [32.99143425134959, 0.697823036124382],
            [32.99050264360271, 0.698592058177064],
            [32.979452001067116, 0.700763383922098],
            [32.976297674744764, 0.702835209764185],
            [32.97379971685782, 0.703893735272341],
            [32.97070885740859, 0.706236977652088],
            [32.96435804143772, 0.712588165547891],
            [32.962918352854366, 0.713483840490923],
            [32.95883269456794, 0.714234735155842],
            [32.95726606774673, 0.713936158345872],
            [32.9543021546202, 0.714958478436061],
            [32.95476808650356, 0.716279394737058],
            [32.961076431026136, 0.719346500965885],
            [32.96255851649763, 0.720459335923357],
            [32.963574655712755, 0.721517883433228],
            [32.963405273874336, 0.724422078006009],
            [32.96190208877345, 0.727507207375394],
            [32.96046267417625, 0.728574781475616],
            [32.95411158691415, 0.72942517017523],
            [32.951994448232334, 0.7311712840679],
            [32.94860726421527, 0.732492157022932],
            [32.94712542398384, 0.734536838008391],
            [32.94593988316741, 0.737097219774473],
            [32.94267961223541, 0.740761349688891],
            [32.941494072317276, 0.742896504771829],
            [32.94077448224884, 0.744814530116837],
            [32.9406896444551, 0.746135440335803],
            [32.94116315183125, 0.747899676815679],
            [32.94285639349681, 0.753201438025924],
            [32.946594020187625, 0.7591093964358],
            [32.94147496784613, 0.764320594647116],
            [32.93945916900982, 0.768111399477146],
            [32.93543632811459, 0.77167598884956],
            [32.933928095380104, 0.771829770068078],
            [32.92679282738401, 0.769622103091256],
            [32.92376372351732, 0.770002037296489],
            [32.92113394954051, 0.773349501406024],
            [32.919781549354994, 0.775927965091807],
            [32.91878784376748, 0.77666077936577],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1747,
        District: "KAYUNGA",
        County: "NTENJERU",
        Subcounty: "KAYUNGA",
        Population: 41782,
        Key: "KAYUNGAKAYUNGA",
        Dist2: "Kayunga",
        "Sub Country": "KAYUNGA",
        id2_original: "Kayunga KAYUNGA",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.889904399513338, 0.706395582027929],
            [31.880116718198618, 0.705096676246181],
            [31.864587124165467, 0.701773158393094],
            [31.853369739940103, 0.704818734282094],
            [31.840737602567042, 0.712458816352974],
            [31.83314382277181, 0.711828987888405],
            [31.827048210088314, 0.70986850458884],
            [31.817877966021197, 0.718532955473313],
            [31.808114192469464, 0.722196318136852],
            [31.807763882746322, 0.728416611719756],
            [31.802608603146048, 0.738477019158673],
            [31.79985702120998, 0.741986188968387],
            [31.793902411686727, 0.746650627146137],
            [31.793880870086227, 0.731460112920162],
            [31.793407071655917, 0.730772539094621],
            [31.782025982944763, 0.727278824628646],
            [31.77945589213712, 0.725768684014584],
            [31.77784982657998, 0.72393535576616],
            [31.77699360275682, 0.72167096847065],
            [31.776138413792857, 0.715525174204368],
            [31.776068527558703, 0.711580118060182],
            [31.773548366911157, 0.708426439031937],
            [31.769347153838172, 0.706810367328603],
            [31.76881260324352, 0.706041201112041],
            [31.76885111312143, 0.704849224388906],
            [31.755519729826172, 0.707729464277091],
            [31.752998844238203, 0.707421171609005],
            [31.749246148308444, 0.705677149640324],
            [31.74613480637244, 0.704799845039254],
            [31.744071104873594, 0.699344243336532],
            [31.745742811226883, 0.696167143174479],
            [31.74575331971906, 0.693488228026773],
            [31.75300686439706, 0.69315074131162],
            [31.755845464338055, 0.69410408310321],
            [31.760677823848216, 0.691882655307452],
            [31.758642873828375, 0.688063096261241],
            [31.755477050867004, 0.677273467875185],
            [31.754301557707038, 0.676537070518458],
            [31.75245712778251, 0.673434687180848],
            [31.749497645146967, 0.670711559880755],
            [31.747356806213, 0.669347990759287],
            [31.758526471930484, 0.668508326216625],
            [31.769691374780326, 0.666746203689545],
            [31.77025672591112, 0.664867918222023],
            [31.771856221190255, 0.663312199044773],
            [31.77420178887242, 0.662507893291359],
            [31.777600536003796, 0.666006714750869],
            [31.784443546105372, 0.664720310702788],
            [31.793135648387782, 0.664488348963103],
            [31.79392176049964, 0.663792053176125],
            [31.7939268072349, 0.661503589047068],
            [31.7954187553099, 0.658790354832531],
            [31.796042447526855, 0.656257817782649],
            [31.795832867876094, 0.654349199611735],
            [31.798085806676053, 0.651428099407903],
            [31.797781639815817, 0.6493476005107],
            [31.798045873866748, 0.648135586783833],
            [31.80083653431431, 0.643957307426924],
            [31.802831807544685, 0.639335601626671],
            [31.803383811507, 0.637047258452451],
            [31.806543465737306, 0.635194241656551],
            [31.808492754208295, 0.632552902722498],
            [31.8085901603312, 0.631449393125701],
            [31.807553543120882, 0.627442049256803],
            [31.807367822724093, 0.625479160847024],
            [31.80770308117464, 0.624285248672815],
            [31.808394285378423, 0.623498460064076],
            [31.80984585058817, 0.622856570015983],
            [31.81413543812218, 0.623237456531883],
            [31.817987460772876, 0.622786061822019],
            [31.8232873700322, 0.62310384901949],
            [31.824144466119503, 0.62260654770798],
            [31.824933688198914, 0.620481045914526],
            [31.824595699768185, 0.617532162130051],
            [31.823036579269502, 0.613135739983931],
            [31.824431723991175, 0.608689847695051],
            [31.828309785208702, 0.60843327906837],
            [31.829855933136376, 0.607981345942991],
            [31.83185639952744, 0.606263148526012],
            [31.833550482016086, 0.603405153308037],
            [31.838269254948454, 0.597987937044465],
            [31.839466225928557, 0.594243365138015],
            [31.84193275086543, 0.591412652119778],
            [31.844103730073808, 0.587948686608818],
            [31.846818618525468, 0.585760243966528],
            [31.8489065044684, 0.582142475149901],
            [31.853148920568522, 0.577132131020803],
            [31.856292679109856, 0.580018296023192],
            [31.859389719866574, 0.582063219984506],
            [31.870149347775964, 0.585828370433474],
            [31.876666806621934, 0.589239884711176],
            [31.878874136158295, 0.590732858558646],
            [31.882873668466836, 0.594512089779809],
            [31.895999629514538, 0.606774271165084],
            [31.900173064882313, 0.611415558149816],
            [31.901594935382004, 0.61330639753675],
            [31.90218569805556, 0.614880467215301],
            [31.903230479155166, 0.620724190326682],
            [31.905462635431043, 0.621783002850025],
            [31.90717442012069, 0.621710996339998],
            [31.90955318953575, 0.62261606299994],
            [31.90940518400787, 0.624081433928175],
            [31.907397562535596, 0.62892950168948],
            [31.907781735151666, 0.631444284716954],
            [31.907509642638658, 0.634094613106504],
            [31.90869977204953, 0.637676960961285],
            [31.911647314278323, 0.641892888793764],
            [31.914674975450676, 0.644372063023997],
            [31.915295430139324, 0.647583424983837],
            [31.916698498001807, 0.64942000815658],
            [31.91736920714238, 0.651355937015059],
            [31.920582389285528, 0.651673233798219],
            [31.92173989008866, 0.652876566818411],
            [31.921852040260326, 0.653681660997795],
            [31.92283792960655, 0.655074918215314],
            [31.91847653613862, 0.666381118929437],
            [31.91466730832972, 0.673200736222072],
            [31.91178584886817, 0.677478703302506],
            [31.905830397623532, 0.683022350680091],
            [31.904321851376995, 0.685753797840066],
            [31.902818167711118, 0.690520518592488],
            [31.90334619114692, 0.692483552939053],
            [31.905697184653427, 0.695758638386303],
            [31.905562221765138, 0.696518443844136],
            [31.899409091750616, 0.696996416435713],
            [31.8958116444649, 0.698406686628011],
            [31.893353836779557, 0.700450417208214],
            [31.892151897217612, 0.702033117616566],
            [31.889904399513338, 0.706395582027929],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 40,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "BUKUYA",
        Population: 31109,
        Key: "MUBENDEBUKUYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.821363734750797, 0.775681027384079],
            [31.818324078374467, 0.777173107943849],
            [31.812216094991175, 0.778066869991014],
            [31.803621100591002, 0.780814203781877],
            [31.797456420038564, 0.78072197423076],
            [31.789211476646713, 0.777556986510407],
            [31.788821279030014, 0.765803762407576],
            [31.78970559137548, 0.763533642495312],
            [31.789710342565026, 0.761606993341366],
            [31.789186848434888, 0.75688519446266],
            [31.792291532956305, 0.750156353792507],
            [31.794095596185226, 0.747325669877941],
            [31.793902411686727, 0.746650627146137],
            [31.79985702120998, 0.741986188968387],
            [31.802608603146048, 0.738477019158673],
            [31.807763882746322, 0.728416611719756],
            [31.808114192469464, 0.722196318136852],
            [31.817877966021197, 0.718532955473313],
            [31.827048210088314, 0.70986850458884],
            [31.83314382277181, 0.711828987888405],
            [31.840737602567042, 0.712458816352974],
            [31.853369739940103, 0.704818734282094],
            [31.864587124165467, 0.701773158393094],
            [31.880116718198618, 0.705096676246181],
            [31.889904399513338, 0.706395582027929],
            [31.889284433508212, 0.708617648785704],
            [31.889639250079124, 0.711467108830543],
            [31.892360877692074, 0.714733246104604],
            [31.898624680149563, 0.720017432957904],
            [31.90341454305857, 0.725283181733883],
            [31.90456891682624, 0.727716751263742],
            [31.907786940888744, 0.730196057082366],
            [31.908677947479713, 0.731345078648322],
            [31.910064992990797, 0.731960526250356],
            [31.912929626108745, 0.735018676261464],
            [31.913611730378694, 0.736104328371914],
            [31.912397966292687, 0.738844876543239],
            [31.91338352865214, 0.740319569083805],
            [31.91183890247055, 0.742173554633946],
            [31.90944759976062, 0.744163011892932],
            [31.90441474705884, 0.747192053250879],
            [31.89894116650563, 0.748529427469537],
            [31.891791240699032, 0.748455242839113],
            [31.8897634376756, 0.747694891848625],
            [31.887744275546844, 0.746084254179575],
            [31.886720259005013, 0.745731212954525],
            [31.88330616685196, 0.74587506865425],
            [31.882088720571584, 0.746462720930858],
            [31.877459581538265, 0.751011462190299],
            [31.875438724288593, 0.751680310899415],
            [31.87304755363104, 0.753172208473953],
            [31.87238076384003, 0.753769042453492],
            [31.871950248036743, 0.755008173549657],
            [31.86762638258812, 0.75504322007395],
            [31.866584097906678, 0.753704203175624],
            [31.86577745210403, 0.753278849943638],
            [31.86492118336509, 0.753631401020677],
            [31.86365859404674, 0.7550421736275],
            [31.862446895187563, 0.755132309043394],
            [31.861528531302927, 0.756696945561221],
            [31.85925593556791, 0.763236263651164],
            [31.857349434752237, 0.765768500394227],
            [31.855778577764337, 0.766934949173707],
            [31.849741510084545, 0.768091138898314],
            [31.846911847482303, 0.769094419184003],
            [31.840809577384217, 0.7725752564321],
            [31.838075118235764, 0.773551412605272],
            [31.832016098425367, 0.773947732031925],
            [31.823297168855337, 0.773881978656937],
            [31.823308018707316, 0.774252843918509],
            [31.821363734750797, 0.775681027384079],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 41,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "MAKOKOTO",
        Population: 7981,
        Key: "MUBENDEMAKOKOTO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.81813934253123, 0.305848590054949],
            [31.80432383646809, 0.337195943398518],
            [31.804103748325144, 0.339372574597342],
            [31.80148582222863, 0.342059722272639],
            [31.799015350992736, 0.345641359388591],
            [31.794730414036934, 0.35400774907354],
            [31.79064569898156, 0.364119878455354],
            [31.784179612990073, 0.374548229063191],
            [31.78066296287595, 0.379721639574965],
            [31.7755772910321, 0.385111879235456],
            [31.774219581803262, 0.386079523444255],
            [31.762881000473033, 0.391324096163096],
            [31.759883164266412, 0.393892517787689],
            [31.750211742017484, 0.391539271788071],
            [31.748093062724916, 0.389331930620673],
            [31.733485124901897, 0.385329352857064],
            [31.724148300841748, 0.381911319155022],
            [31.72174738795494, 0.38205567880619],
            [31.7093163312717, 0.38638497334509],
            [31.706485690404094, 0.386244391995265],
            [31.698040486484295, 0.383954017335377],
            [31.691915186277292, 0.383766198197725],
            [31.68797123363366, 0.381289676308218],
            [31.68606569671028, 0.381480382621429],
            [31.684163645250162, 0.382294136683461],
            [31.680759704958138, 0.38226118092415],
            [31.67988460214095, 0.383197960931281],
            [31.675546116611066, 0.385386151149488],
            [31.67362074219128, 0.384526584333717],
            [31.670363779754453, 0.384905959478757],
            [31.667963188464505, 0.38330463078992],
            [31.666731149052314, 0.383416886246617],
            [31.664670727302582, 0.384534218943407],
            [31.661751478411997, 0.384671970692047],
            [31.65896418934168, 0.384640639059344],
            [31.657525856316113, 0.383718209474962],
            [31.656509258960206, 0.383556074387236],
            [31.652071499709955, 0.38541859307201],
            [31.64974192653144, 0.385852380595322],
            [31.64659153303338, 0.388927104293036],
            [31.640610129460164, 0.390122367800796],
            [31.635915639786568, 0.390041223065192],
            [31.634718137003812, 0.38959092869646],
            [31.633393003382125, 0.388465467996761],
            [31.629577672419206, 0.382645736638312],
            [31.625294716248604, 0.379136614692994],
            [31.625654319941685, 0.378331012366799],
            [31.63169049649273, 0.375663547129463],
            [31.633798549613765, 0.373574144576248],
            [31.634852837584017, 0.370841575651258],
            [31.635016841208806, 0.364174258669361],
            [31.639239036231903, 0.362028100788805],
            [31.63909082678645, 0.359774550925862],
            [31.637661679034633, 0.355596404464553],
            [31.633707615852515, 0.348735420221412],
            [31.632557000635998, 0.344417131465825],
            [31.632112225874213, 0.338341792005845],
            [31.632437405227254, 0.336687494959925],
            [31.631847121355754, 0.333085004983227],
            [31.630218579051906, 0.332525544560614],
            [31.62823672036366, 0.332430658911365],
            [31.631529698056852, 0.328831311431941],
            [31.641241995447874, 0.314795147249802],
            [31.64159896887379, 0.311665699822746],
            [31.64310899015399, 0.306600812360437],
            [31.644131349304107, 0.305786914402754],
            [31.64603328667816, 0.303127982719075],
            [31.65039599527968, 0.299031230208879],
            [31.652202442637364, 0.298859607613297],
            [31.65362880201852, 0.298190466132305],
            [31.655530997209066, 0.295631008014631],
            [31.661271937950414, 0.294184539243603],
            [31.66260313250532, 0.293397797874103],
            [31.667239988066907, 0.292509865246592],
            [31.66962515797838, 0.294004347656226],
            [31.6712153952202, 0.294004539893174],
            [31.685354782570812, 0.292239695052619],
            [31.68854525350695, 0.291250828034449],
            [31.688263375645526, 0.290864609547885],
            [31.694463883706426, 0.288936007913916],
            [31.69969596746687, 0.285174590736962],
            [31.70653808643969, 0.278716224014187],
            [31.710505511163348, 0.273739182194616],
            [31.714990025029195, 0.271656070137194],
            [31.720509867022898, 0.26500070125575],
            [31.723786259121013, 0.2554906525611],
            [31.723593529170074, 0.254854868139223],
            [31.726161423596846, 0.249428065107799],
            [31.72754050913618, 0.247058381037771],
            [31.728083800338553, 0.247058434037874],
            [31.72882725954243, 0.244381156617059],
            [31.733003865064827, 0.239786634751227],
            [31.73352527779846, 0.239542466708279],
            [31.73451300240282, 0.239813911855919],
            [31.738768726145548, 0.241948969228421],
            [31.7405775881747, 0.243522995719974],
            [31.74821854748866, 0.251990003431987],
            [31.75001317032222, 0.255644436319683],
            [31.75358211496227, 0.258105077714326],
            [31.77685368565974, 0.27060794915877],
            [31.78152475984713, 0.272553159884086],
            [31.785061058811458, 0.273349511838439],
            [31.79235294448408, 0.27507791532884],
            [31.795966379985202, 0.27676072151549],
            [31.800767854517588, 0.280632628382864],
            [31.80277990558252, 0.283445946188924],
            [31.806246479111103, 0.290646429541004],
            [31.81813934253123, 0.305848590054949],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 43,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "MANYOGASEKA",
        Population: 11734,
        Key: "MUBENDEMANYOGASEKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.578961446456898, 0.688688221086833],
            [31.557530837288652, 0.693556675535236],
            [31.55577133588771, 0.694243511164414],
            [31.55007197366933, 0.699026249031488],
            [31.5471725667667, 0.700599071886208],
            [31.544736155154794, 0.701231415171],
            [31.542269704778107, 0.700959307996251],
            [31.54106912706213, 0.700117802191888],
            [31.5406045174989, 0.699023284811654],
            [31.540388823914324, 0.695604438663706],
            [31.53931014937903, 0.692782254181662],
            [31.53652694764327, 0.688123535046367],
            [31.534963851201123, 0.686540285641853],
            [31.528818556292524, 0.678009565103739],
            [31.52673553472688, 0.683661632605133],
            [31.52357774180586, 0.686554833711737],
            [31.521220689162767, 0.689430187529918],
            [31.517143187579116, 0.696564852771977],
            [31.515696802953634, 0.700679542342285],
            [31.514407851674964, 0.701465981853039],
            [31.512055600527088, 0.70152853584067],
            [31.509969369280913, 0.700279757241394],
            [31.508732284930122, 0.700424067098449],
            [31.5066252091761, 0.699401388999096],
            [31.505793489597266, 0.699726714781341],
            [31.504472508887126, 0.701480871211228],
            [31.505656644738462, 0.702729359355963],
            [31.506360901463307, 0.705913162276713],
            [31.50920290601927, 0.709893557577434],
            [31.509199781678696, 0.711747630158328],
            [31.50830751205644, 0.711765427105767],
            [31.506904304056782, 0.714234047998056],
            [31.500662931633585, 0.714304348282426],
            [31.497801457890496, 0.713834194001515],
            [31.492766025227215, 0.712188364404864],
            [31.48793400438193, 0.712871831565832],
            [31.484188242547862, 0.721433907493742],
            [31.48146471230317, 0.725611884879624],
            [31.482144574378196, 0.72682875729863],
            [31.482269615374175, 0.728510473588585],
            [31.484831693209475, 0.729333217090813],
            [31.485811033837262, 0.730471525541678],
            [31.48584699878799, 0.731700404347569],
            [31.485209997131804, 0.733228649727738],
            [31.4852581746788, 0.735227425753842],
            [31.486282988924625, 0.73843845409361],
            [31.486167278729496, 0.739369963711874],
            [31.48538434665373, 0.742336177375718],
            [31.483805182944433, 0.744442917689238],
            [31.48317011805599, 0.746025423109452],
            [31.4830981073062, 0.748051287837576],
            [31.480612902801315, 0.748974743616941],
            [31.469869577517677, 0.74592748809527],
            [31.463677055479643, 0.74500047734246],
            [31.459525627938017, 0.745547059543484],
            [31.453356763931307, 0.748028912710933],
            [31.449898118933408, 0.737259105246478],
            [31.448363938361968, 0.735196533438091],
            [31.446751399544873, 0.731587412684301],
            [31.44372013792489, 0.732228473621723],
            [31.443265352337573, 0.733738658775719],
            [31.440478826835257, 0.736233813424556],
            [31.43486825948943, 0.740111677649854],
            [31.432650370256887, 0.740698742345989],
            [31.43018315451557, 0.740544112984069],
            [31.427769644553532, 0.740959267931797],
            [31.42543852806934, 0.741799514041397],
            [31.423841470817894, 0.741373876710675],
            [31.41902357867539, 0.743416056507304],
            [31.41831700070381, 0.744772381131782],
            [31.416347186626915, 0.746480956081716],
            [31.41393247292236, 0.747149322229803],
            [31.408846378870344, 0.747111288099569],
            [31.408728893604216, 0.745139690067067],
            [31.40716425026314, 0.745073098196508],
            [31.4070288076745, 0.743176560654442],
            [31.40619140984475, 0.742163347035478],
            [31.402986161622195, 0.744233166195111],
            [31.40222930045263, 0.74414249520409],
            [31.399116469109867, 0.74057500526272],
            [31.39824825726924, 0.740261253526866],
            [31.397135382074456, 0.738035194312502],
            [31.395485000827705, 0.736959912864507],
            [31.394792728527072, 0.734734293933835],
            [31.393239336584937, 0.733954840378721],
            [31.392569677574905, 0.733051364652887],
            [31.39248872768973, 0.732318728969668],
            [31.390953788940173, 0.730400881480611],
            [31.390149007141737, 0.728284368836183],
            [31.388810240687295, 0.726366612147068],
            [31.386389169605486, 0.718129157659202],
            [31.38545229234116, 0.71743924367946],
            [31.384812383736737, 0.716281277458743],
            [31.384546512057025, 0.712508461501763],
            [31.38427009056264, 0.711494403832512],
            [31.382917595155725, 0.709561915138271],
            [31.382785857219314, 0.707422743540902],
            [31.378058440697274, 0.704366614947191],
            [31.374837168326696, 0.703398308636874],
            [31.373721785035613, 0.703552430854055],
            [31.37476470033441, 0.701853162638341],
            [31.376673952689796, 0.701302167471215],
            [31.378392799934225, 0.699304113192242],
            [31.3843113888112, 0.695908433988934],
            [31.38776430345589, 0.694541327520429],
            [31.388812372389474, 0.691928047462028],
            [31.39454053729083, 0.686612275053113],
            [31.39588794823324, 0.686287156764373],
            [31.397265592874863, 0.685383245956987],
            [31.39878667600949, 0.683701615568424],
            [31.399769988987476, 0.683285932681583],
            [31.400470385651587, 0.683485131603965],
            [31.402547209740096, 0.683069816083227],
            [31.40629161601637, 0.679426413420568],
            [31.41005339301533, 0.678450932173753],
            [31.412330126390536, 0.677140330680592],
            [31.413934825610095, 0.67559436234303],
            [31.41514216045364, 0.675233005992752],
            [31.4165716872945, 0.671905335356226],
            [31.417113723550422, 0.669572194948852],
            [31.414988102077356, 0.668070219807649],
            [31.414573054364944, 0.666641155524],
            [31.419856207349312, 0.66036642001963],
            [31.42208590852949, 0.653240550408272],
            [31.424334222802365, 0.648475129122461],
            [31.42735282985497, 0.64392699030258],
            [31.431329130831976, 0.641902388779987],
            [31.434255277885633, 0.639461430694392],
            [31.43798957182675, 0.638377306115744],
            [31.44068136818572, 0.638477615654364],
            [31.44142723936614, 0.637817634708158],
            [31.442301279476325, 0.63666931654343],
            [31.442595983483375, 0.629452311219404],
            [31.444522568832213, 0.624442523560693],
            [31.44516214146672, 0.622453036484187],
            [31.445220266058882, 0.614738529894246],
            [31.445649614950586, 0.612513834158309],
            [31.444953651472446, 0.607602742625039],
            [31.445071417012937, 0.606164783118531],
            [31.44589170732639, 0.604401441904235],
            [31.44854005576834, 0.601282026107414],
            [31.452886475218826, 0.597792280255802],
            [31.45378918146806, 0.59644497661905],
            [31.455420251631107, 0.591715409555292],
            [31.455873510980748, 0.585149566083854],
            [31.458616245409598, 0.584797611025208],
            [31.46178292716036, 0.585431574757751],
            [31.46518086760461, 0.584320095066948],
            [31.469569543806053, 0.584375570337027],
            [31.47147126288947, 0.585732710245321],
            [31.47365767425612, 0.586022724256939],
            [31.476267668228704, 0.585553149095375],
            [31.47989917244345, 0.585635543659496],
            [31.482202727716427, 0.584659407026201],
            [31.48484019127205, 0.584388802731172],
            [31.492919466460897, 0.587384629976695],
            [31.500760263196298, 0.58886097199386],
            [31.502981919064805, 0.592886261437333],
            [31.504068526622394, 0.596730360405261],
            [31.50983848294739, 0.606535927345045],
            [31.5111403475083, 0.609620385955127],
            [31.51135133571737, 0.611148926399434],
            [31.522321444287748, 0.608954221330197],
            [31.533216294698555, 0.609038630350815],
            [31.536850483977695, 0.609980245048695],
            [31.53803902247224, 0.609691151226978],
            [31.543106998403296, 0.605685871309935],
            [31.547875927871235, 0.602856262776381],
            [31.55456197803817, 0.597612282938679],
            [31.556107788199302, 0.596798693338918],
            [31.560088555599876, 0.5963656147634],
            [31.56334863159747, 0.593689309552092],
            [31.56763313287035, 0.589132006342873],
            [31.57205686941901, 0.58684489300001],
            [31.571815471440928, 0.596450106619665],
            [31.57233225605421, 0.600086137744752],
            [31.573194169806385, 0.603441882484644],
            [31.57499536920616, 0.606309475644687],
            [31.57562890875523, 0.611130379040602],
            [31.577606697176932, 0.615083371474687],
            [31.577764859057428, 0.620003643569438],
            [31.576916405661464, 0.623051421049861],
            [31.57334306825968, 0.62832339903516],
            [31.57208956899366, 0.63198608232601],
            [31.57154189760597, 0.632628089823864],
            [31.57042463593766, 0.632962425974043],
            [31.56750220880758, 0.632726453841868],
            [31.565365332342342, 0.6315952949193],
            [31.564342974090522, 0.631929655389001],
            [31.56324723875135, 0.633629711295691],
            [31.563241523669518, 0.637021390367863],
            [31.563928827388338, 0.638070743604095],
            [31.565851105315392, 0.639527449162186],
            [31.56662283539956, 0.639871357614265],
            [31.569997042353993, 0.640017022029422],
            [31.572489557348657, 0.641501025125461],
            [31.574247973584704, 0.641601010331472],
            [31.57588598413166, 0.642560191821112],
            [31.57721648159392, 0.642768591449967],
            [31.57890529636176, 0.644804088503274],
            [31.578946320624134, 0.645690465560466],
            [31.577851302140587, 0.646784544879354],
            [31.575141466712367, 0.647308358643634],
            [31.57397544628707, 0.648284835909593],
            [31.575172726287633, 0.649967459293883],
            [31.575406840725417, 0.652120123911375],
            [31.576923730524292, 0.654463091374163],
            [31.57713430730497, 0.656443905057902],
            [31.577797388850485, 0.657755554043259],
            [31.577711254787793, 0.659510169454192],
            [31.578159986628396, 0.661255895110597],
            [31.57713627281882, 0.662349987205163],
            [31.57703698742035, 0.664909561314516],
            [31.576416939668555, 0.666266060607433],
            [31.577103875976427, 0.667604852239791],
            [31.577752139811324, 0.670625917674132],
            [31.57774602497918, 0.674279908369299],
            [31.57852578240874, 0.676957322499181],
            [31.57850379524382, 0.682990023508351],
            [31.577786136553243, 0.685875016803375],
            [31.578961446456898, 0.688688221086833],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 45,
        District: "MUBENDE",
        County: "BUWEKULA",
        Subcounty: "MADUDU",
        Population: 36897,
        Key: "MUBENDEMADUDU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.38757273502663, 0.551247995597306],
            [31.388236568462016, 0.55282773905445],
            [31.388534536946818, 0.556397418358557],
            [31.389766446103263, 0.558731192943044],
            [31.3901429210557, 0.561092512117927],
            [31.39074065824912, 0.561606589687858],
            [31.391287448389516, 0.563417007481809],
            [31.391144170694965, 0.56413834488599],
            [31.3895369157684, 0.564378059474356],
            [31.389725628453384, 0.565708053880938],
            [31.3933818282536, 0.568884526969635],
            [31.394128713631968, 0.570855396995053],
            [31.394163634740337, 0.573256029424346],
            [31.39313952926529, 0.576220684517544],
            [31.393053728477557, 0.577655255430593],
            [31.390191190230837, 0.5776516794192],
            [31.38874362252414, 0.581792541906561],
            [31.386554712044365, 0.585307880504028],
            [31.385871360912777, 0.58837910427427],
            [31.383021112517483, 0.5882166147916],
            [31.38115421842267, 0.588741441287538],
            [31.37902614365056, 0.590094661892478],
            [31.378102871371212, 0.591400461732467],
            [31.384407743006907, 0.596108286521132],
            [31.3877678886322, 0.601001945919835],
            [31.388350190972428, 0.602747561863459],
            [31.388258442439177, 0.608246129221551],
            [31.38900830663102, 0.610109366958247],
            [31.38986588780859, 0.611084878366398],
            [31.386620218991506, 0.618559545969617],
            [31.384502495506418, 0.620534211383277],
            [31.378253087653015, 0.624846774651233],
            [31.373191312792354, 0.629211659885841],
            [31.37143539926269, 0.630042813644298],
            [31.36766491669033, 0.633212498987626],
            [31.363584889942437, 0.635498384426773],
            [31.36022771235082, 0.637992416266368],
            [31.356870850966207, 0.639498791994856],
            [31.347979266995182, 0.642195051405016],
            [31.343987718014542, 0.639000785320516],
            [31.34274908406986, 0.637025105570256],
            [31.341096725631196, 0.637024567512652],
            [31.33934079593185, 0.637959650451058],
            [31.336862162603296, 0.638270726723555],
            [31.330460308849528, 0.635149790358002],
            [31.32866719428733, 0.633061291215024],
            [31.327996719607036, 0.63388033401242],
            [31.323969920734665, 0.63143593538343],
            [31.3229892946177, 0.630032144100438],
            [31.317206982864263, 0.627327284681674],
            [31.317259418425703, 0.624832247062069],
            [31.316020815922055, 0.62280461632634],
            [31.31405920346369, 0.621140615854013],
            [31.31122037175734, 0.617657030581531],
            [31.301827199972692, 0.603671417151599],
            [31.298711224526453, 0.601580523423706],
            [31.30352257064548, 0.598127478230178],
            [31.30722575772494, 0.594158595683459],
            [31.30906100776556, 0.590984938474033],
            [31.311732422249047, 0.589140908176738],
            [31.31450485228625, 0.586519170174621],
            [31.322858686761908, 0.576546790600101],
            [31.325411953920906, 0.57262269132305],
            [31.325306327314863, 0.570940578208176],
            [31.325788148598953, 0.569674636210612],
            [31.328067418816534, 0.567658612383598],
            [31.329889155500318, 0.562098005605258],
            [31.326995958651295, 0.558614300732145],
            [31.32608450909938, 0.55547140489379],
            [31.323919467755047, 0.554082051165232],
            [31.320720742199782, 0.548134421813399],
            [31.317792202932488, 0.545168018828051],
            [31.317153293254673, 0.543647818193482],
            [31.31988394534293, 0.539643928311496],
            [31.323676185111488, 0.537413505494431],
            [31.32291866008689, 0.534477136519544],
            [31.317553807124106, 0.52807484025833],
            [31.309564466769935, 0.519968903446709],
            [31.311913163284224, 0.517724018462638],
            [31.31488668479101, 0.513827153504717],
            [31.31954480527202, 0.512897982455804],
            [31.32335545241907, 0.510396932579632],
            [31.324130138858852, 0.509102099175312],
            [31.32509192910094, 0.508725156697268],
            [31.326490793746203, 0.508574646309379],
            [31.330174975169207, 0.509468309882877],
            [31.333359978060212, 0.508827910033065],
            [31.338045018355338, 0.503968049777751],
            [31.337170321576668, 0.494861005912222],
            [31.33315590328553, 0.484318372787062],
            [31.327897193460085, 0.47605727587431],
            [31.33152405518143, 0.468995415826738],
            [31.33257030053497, 0.469957551959669],
            [31.333944115658532, 0.470083616386401],
            [31.335742305702105, 0.471328803740352],
            [31.337078648501908, 0.471480005746138],
            [31.33866462593266, 0.472285078243321],
            [31.34171144008519, 0.474938779811736],
            [31.34389697469611, 0.47551768277635],
            [31.345645280393658, 0.476498826597958],
            [31.348168050647068, 0.477027518940985],
            [31.349454287216975, 0.477832526115924],
            [31.352063646080637, 0.481869207716677],
            [31.353249990889243, 0.482573607477668],
            [31.35423630154534, 0.484107800831318],
            [31.355709864699744, 0.485000872152056],
            [31.35632156261098, 0.486220641681291],
            [31.358082371060632, 0.487189226867694],
            [31.361566786927398, 0.488045078335861],
            [31.36656221671276, 0.489932325997398],
            [31.369760670078502, 0.485482106645493],
            [31.370797419341166, 0.485067434929471],
            [31.371771587469564, 0.485205980722398],
            [31.376343864043708, 0.480944672701838],
            [31.382489468871075, 0.47831827858566],
            [31.383701193781437, 0.477413271787496],
            [31.38560012808749, 0.475364231554561],
            [31.38741184496258, 0.472397295568523],
            [31.388462257600725, 0.466902884419103],
            [31.390782155025338, 0.465625839477439],
            [31.39120819003198, 0.469244777096058],
            [31.390480810671715, 0.477389163638818],
            [31.390062908113332, 0.478230077877527],
            [31.38858982286265, 0.478738762609494],
            [31.387951677651127, 0.48126164914299],
            [31.38799492793878, 0.484293732879117],
            [31.38852239441912, 0.484979948443788],
            [31.388873594372694, 0.48730388637935],
            [31.388587422564207, 0.488853051233422],
            [31.388918781428117, 0.491347934538746],
            [31.390081326271588, 0.493213406912949],
            [31.38986114200892, 0.494607665293933],
            [31.391069147894, 0.499322066647015],
            [31.390342846512056, 0.502619546409313],
            [31.387285838277688, 0.507244352034951],
            [31.38698815186391, 0.510821345442785],
            [31.381313809522783, 0.519938220955005],
            [31.380433161405346, 0.524851259658555],
            [31.379157262647738, 0.527905116181957],
            [31.37594365021161, 0.53295489323039],
            [31.374082243026535, 0.534526083589455],
            [31.372832311868855, 0.538084045861966],
            [31.372768442550456, 0.540248962602261],
            [31.370923670367837, 0.54126128829656],
            [31.369358673988863, 0.541134259606007],
            [31.36780803089151, 0.539600533523126],
            [31.365488457758723, 0.539529567965883],
            [31.365333219894474, 0.545198521539249],
            [31.367121422468713, 0.546676047460818],
            [31.37069841691202, 0.547478850504388],
            [31.374609930492422, 0.55141869903895],
            [31.37723661516298, 0.552671392758499],
            [31.379612346475746, 0.552606364045186],
            [31.379501261706007, 0.551786375021568],
            [31.384127471333187, 0.55333400775672],
            [31.384174330153353, 0.550130186385084],
            [31.385707147082236, 0.548545736154958],
            [31.38625050745488, 0.549208033622987],
            [31.386188601853707, 0.549741597584861],
            [31.38757273502663, 0.551247995597306],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 46,
        District: "MUBENDE",
        County: "MUBENDE MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 28613,
        Key: "MUBENDEWESTERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.373721785035613, 0.703552430854055],
            [31.369545513686496, 0.704718164714989],
            [31.36589177167687, 0.706733601348693],
            [31.3619325746229, 0.70798021164816],
            [31.354515274255146, 0.711386988877137],
            [31.351107911381877, 0.7113857591783],
            [31.341933384147502, 0.715957591236992],
            [31.332612884272713, 0.721960141059434],
            [31.32997151843546, 0.723273219954454],
            [31.325057496676095, 0.724859513578661],
            [31.32151087067927, 0.726741959177961],
            [31.313607065211524, 0.730516576882962],
            [31.298049721320904, 0.735806965629751],
            [31.28859358392304, 0.739807851437666],
            [31.287297557513195, 0.736602040171586],
            [31.286774291555115, 0.733527128257653],
            [31.287910064806525, 0.727161098215861],
            [31.28809152718886, 0.723896545355647],
            [31.289963076353466, 0.719158585520898],
            [31.289523031221663, 0.714012782283343],
            [31.286525663935624, 0.708667081989572],
            [31.284539360383373, 0.707481671226215],
            [31.282057778784015, 0.708014294721011],
            [31.281069356188706, 0.705644594468733],
            [31.27864381509004, 0.703428096323354],
            [31.27660358567126, 0.700813843906894],
            [31.273974929198683, 0.695947618305921],
            [31.273460988651575, 0.691109312478655],
            [31.273262626263804, 0.682228810128111],
            [31.272393043594047, 0.681125224369556],
            [31.270168832018562, 0.680346703175938],
            [31.266261103040463, 0.680345284836086],
            [31.265262661534763, 0.680833252999652],
            [31.26407602746863, 0.680832820940487],
            [31.26252761398981, 0.679285804623821],
            [31.256081952992922, 0.671732521257471],
            [31.253659374538085, 0.666766977620414],
            [31.251820758510103, 0.664017214260237],
            [31.248370823577186, 0.660371615530137],
            [31.242412828303642, 0.652158391460217],
            [31.237384760927366, 0.642616212628688],
            [31.236673950992532, 0.641874435860903],
            [31.235100841928205, 0.640915327001688],
            [31.22835645157348, 0.638742654301721],
            [31.22295262699871, 0.63461717599345],
            [31.215540950982952, 0.631838417257736],
            [31.222024288221164, 0.624732898400316],
            [31.227128372833388, 0.620339751899054],
            [31.228482974789667, 0.619933276364619],
            [31.230766606327954, 0.61828822205021],
            [31.235204344018612, 0.614491645736797],
            [31.237652847852587, 0.61342538515407],
            [31.24180273927507, 0.610813322315053],
            [31.244655240645113, 0.609629623706588],
            [31.250702488932014, 0.605399443309316],
            [31.25523741804823, 0.604035409559872],
            [31.26327316626829, 0.603793848032768],
            [31.267035199287083, 0.602709881418942],
            [31.271453052768948, 0.602376703026536],
            [31.274596540019097, 0.601681383398104],
            [31.283474050084568, 0.601223009144555],
            [31.287121701516533, 0.600645399035219],
            [31.291408373119133, 0.601614388941339],
            [31.29434191690086, 0.600882808916953],
            [31.298711224526453, 0.601580523423706],
            [31.301827199972692, 0.603671417151599],
            [31.31122037175734, 0.617657030581531],
            [31.31405920346369, 0.621140615854013],
            [31.316020815922055, 0.62280461632634],
            [31.317259418425703, 0.624832247062069],
            [31.317206982864263, 0.627327284681674],
            [31.3229892946177, 0.630032144100438],
            [31.323969920734665, 0.63143593538343],
            [31.327996719607036, 0.63388033401242],
            [31.32866719428733, 0.633061291215024],
            [31.330460308849528, 0.635149790358002],
            [31.336862162603296, 0.638270726723555],
            [31.33934079593185, 0.637959650451058],
            [31.341096725631196, 0.637024567512652],
            [31.34274908406986, 0.637025105570256],
            [31.343987718014542, 0.639000785320516],
            [31.347979266995182, 0.642195051405016],
            [31.34633555214619, 0.644017721601684],
            [31.345560518956695, 0.645524918360336],
            [31.344681038649153, 0.650618767788059],
            [31.34909461076036, 0.654726739583974],
            [31.350513822246807, 0.657144335649316],
            [31.350951264060924, 0.661588872110071],
            [31.35195721278747, 0.664500157421622],
            [31.354872869315223, 0.669959174410041],
            [31.35657605802591, 0.672428865323103],
            [31.36034453735521, 0.67547105827644],
            [31.37017683799006, 0.689041619725377],
            [31.372706107554567, 0.691875498951376],
            [31.37810134333692, 0.69450245129124],
            [31.383006808643202, 0.694868024366745],
            [31.3843113888112, 0.695908433988934],
            [31.378392799934225, 0.699304113192242],
            [31.376673952689796, 0.701302167471215],
            [31.37476470033441, 0.701853162638341],
            [31.373721785035613, 0.703552430854055],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 47,
        District: "MUBENDE",
        County: "BUWEKULA",
        Subcounty: "KIYUNI",
        Population: 16881,
        Key: "MUBENDEKIYUNI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.42145402008392, 0.482179279908044],
            [31.417619112135995, 0.48523035563355],
            [31.41583775831749, 0.487697675579121],
            [31.413078019678622, 0.490408210866695],
            [31.41270406989049, 0.49128234286663],
            [31.409922618072873, 0.492841989752115],
            [31.403436873349705, 0.49381423088692],
            [31.40011723455719, 0.493581035998061],
            [31.388918781428117, 0.491347934538746],
            [31.388587422564207, 0.488853051233422],
            [31.388873594372694, 0.48730388637935],
            [31.38852239441912, 0.484979948443788],
            [31.38799492793878, 0.484293732879117],
            [31.387951677651127, 0.48126164914299],
            [31.38858982286265, 0.478738762609494],
            [31.390062908113332, 0.478230077877527],
            [31.390480810671715, 0.477389163638818],
            [31.39120819003198, 0.469244777096058],
            [31.390782155025338, 0.465625839477439],
            [31.388462257600725, 0.466902884419103],
            [31.38741184496258, 0.472397295568523],
            [31.38560012808749, 0.475364231554561],
            [31.383701193781437, 0.477413271787496],
            [31.382489468871075, 0.47831827858566],
            [31.376343864043708, 0.480944672701838],
            [31.371771587469564, 0.485205980722398],
            [31.370797419341166, 0.485067434929471],
            [31.369760670078502, 0.485482106645493],
            [31.36656221671276, 0.489932325997398],
            [31.361566786927398, 0.488045078335861],
            [31.358082371060632, 0.487189226867694],
            [31.35632156261098, 0.486220641681291],
            [31.355709864699744, 0.485000872152056],
            [31.35423630154534, 0.484107800831318],
            [31.353249990889243, 0.482573607477668],
            [31.352063646080637, 0.481869207716677],
            [31.349454287216975, 0.477832526115924],
            [31.348168050647068, 0.477027518940985],
            [31.345645280393658, 0.476498826597958],
            [31.34389697469611, 0.47551768277635],
            [31.34171144008519, 0.474938779811736],
            [31.33866462593266, 0.472285078243321],
            [31.337078648501908, 0.471480005746138],
            [31.335742305702105, 0.471328803740352],
            [31.333944115658532, 0.470083616386401],
            [31.33257030053497, 0.469957551959669],
            [31.33152405518143, 0.468995415826738],
            [31.33213252724253, 0.467810653017527],
            [31.333099236659088, 0.449009460278977],
            [31.33297962687733, 0.443833975668353],
            [31.33435445440222, 0.443637913457821],
            [31.337230034390235, 0.440672296500606],
            [31.34244392097797, 0.439633466850995],
            [31.34582059380787, 0.437979256091816],
            [31.351362072623527, 0.431957470710029],
            [31.35399254009972, 0.430447768866178],
            [31.35725326288433, 0.426234161810814],
            [31.360461864517813, 0.420202760858883],
            [31.363985273556125, 0.414912982242681],
            [31.365967950609598, 0.415465059744621],
            [31.3662710260168, 0.41600774287441],
            [31.366060815748742, 0.417092935651663],
            [31.367093978038454, 0.417992243948127],
            [31.370666544685733, 0.423460643805834],
            [31.372491562915283, 0.424844714798169],
            [31.373995873605235, 0.426771339467486],
            [31.375401175577828, 0.426952514750687],
            [31.376100930844782, 0.427459110962826],
            [31.376555518802764, 0.428390708895828],
            [31.379191007861404, 0.429802090610867],
            [31.379832228904455, 0.430986953905203],
            [31.3809166131317, 0.431376067914722],
            [31.38302161018414, 0.433700757183786],
            [31.384595904126307, 0.433954322760184],
            [31.386147009856025, 0.4350037314516],
            [31.386525757546117, 0.436134280669717],
            [31.38818188172245, 0.437075189203812],
            [31.38927812640641, 0.43716586520461],
            [31.39429253400045, 0.441363263740984],
            [31.398245683595924, 0.445967415538461],
            [31.399324169485027, 0.447713105253074],
            [31.399702301829148, 0.451638196354124],
            [31.401025209425562, 0.455084179516159],
            [31.40537494725269, 0.458820252775816],
            [31.410703700517484, 0.46596609029995],
            [31.415589525956726, 0.471538226283164],
            [31.41728600874382, 0.47408898922208],
            [31.41979228233536, 0.479696776061773],
            [31.42145402008392, 0.482179279908044],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 48,
        District: "MUBENDE",
        County: "KASAMBYA",
        Subcounty: "BAGEZZA",
        Population: 11678,
        Key: "MUBENDEBAGEZZA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.234327384383757, 0.394656994739845],
            [31.232455908880983, 0.393669390524068],
            [31.231439571138203, 0.395646527475281],
            [31.23153245424366, 0.397218513745836],
            [31.2310429379908, 0.397640732433032],
            [31.229924161762913, 0.398062817252863],
            [31.228572500890902, 0.397663665869886],
            [31.226894412905867, 0.397851009499488],
            [31.224283234953752, 0.402003288100678],
            [31.217546463210937, 0.408078570115943],
            [31.214796072440922, 0.409485693092417],
            [31.20789743506372, 0.409859533611205],
            [31.203587552790783, 0.411760424094681],
            [31.202626121874797, 0.41396849849897],
            [31.201284238266325, 0.415286996775148],
            [31.200021458505123, 0.415858703719539],
            [31.198908435986645, 0.417201081860707],
            [31.196981577549987, 0.422912760987352],
            [31.195316481898914, 0.42284880807096],
            [31.193832644712607, 0.42380179755748],
            [31.193650933496933, 0.424691549064916],
            [31.194274193624185, 0.42543054037327],
            [31.194155571989228, 0.426476009436995],
            [31.193461117680748, 0.426452014303824],
            [31.190043354113115, 0.429541615249035],
            [31.187999182886877, 0.430577099259928],
            [31.18653096560673, 0.432372192214571],
            [31.186577899885382, 0.434037357049664],
            [31.187161610783953, 0.435082201521192],
            [31.18724812573235, 0.436321558707004],
            [31.18698747506107, 0.437362254562632],
            [31.185723245419027, 0.43903826513349],
            [31.184876629077827, 0.439148534588016],
            [31.18312096438149, 0.438335300130041],
            [31.181302477802372, 0.438034998519575],
            [31.180131513049744, 0.439069791481077],
            [31.176390693746374, 0.439632811998455],
            [31.17580318117752, 0.44047861107856],
            [31.174601356599936, 0.44096040373617],
            [31.174372518866136, 0.442746909268645],
            [31.170220601742663, 0.445762904985068],
            [31.167368483953272, 0.443132134876635],
            [31.165416646063495, 0.443346770111369],
            [31.164063344867746, 0.44269477889403],
            [31.1620043388629, 0.440235765900616],
            [31.159151565303333, 0.435110724005677],
            [31.158903264670585, 0.43112252201456],
            [31.159774687988357, 0.428692208309342],
            [31.159565922211268, 0.422721664885474],
            [31.158935546528642, 0.421723926902785],
            [31.15665378258785, 0.419909547850488],
            [31.150585734708827, 0.415817405660389],
            [31.1479173143102, 0.413105067524416],
            [31.147032162039945, 0.411210356713015],
            [31.14435823047702, 0.4084563209673],
            [31.146595037331103, 0.405472609678919],
            [31.146801718118397, 0.402303297354206],
            [31.141330550440056, 0.395963335055283],
            [31.14063863566887, 0.391264319166549],
            [31.14136280714527, 0.386091283022636],
            [31.14296442783837, 0.383232077284347],
            [31.144230458602564, 0.379878868244747],
            [31.146090054784025, 0.378150535775744],
            [31.151811260436897, 0.37108082523442],
            [31.151376741740705, 0.368981428943209],
            [31.15216158812632, 0.368422489881847],
            [31.152101527664747, 0.366939676764723],
            [31.153248916132753, 0.364939348191059],
            [31.152935222638895, 0.363845381301398],
            [31.153502918372617, 0.362545029578319],
            [31.15339473785619, 0.360143341597776],
            [31.155157902586826, 0.357664245766622],
            [31.15622992060586, 0.353748277449463],
            [31.157499568885733, 0.352462017695806],
            [31.15156160244977, 0.344611835088888],
            [31.149392557314172, 0.344351446940465],
            [31.147688432558937, 0.343519235705845],
            [31.143919082762153, 0.339723074896614],
            [31.139557524902518, 0.338688294909255],
            [31.138715246525834, 0.336807281437506],
            [31.138808829418856, 0.336107429541315],
            [31.1366607267075, 0.333072317392546],
            [31.13424814650179, 0.33324366184812],
            [31.131540808390067, 0.331895209118078],
            [31.129739628753228, 0.3289813554599],
            [31.128190535249736, 0.328847844652414],
            [31.127578012685056, 0.327645077717609],
            [31.12505289154055, 0.326306312402407],
            [31.121381495838964, 0.321621625472986],
            [31.11846857288461, 0.319352582139708],
            [31.117481506745353, 0.317823636331652],
            [31.11623666993365, 0.317144585080592],
            [31.116410807453157, 0.316495510108691],
            [31.116887810174077, 0.315577745887267],
            [31.116005545089138, 0.31033567201006],
            [31.115200371625264, 0.308074921144128],
            [31.11398887398867, 0.306763552419248],
            [31.112229221670816, 0.303688819138498],
            [31.110599198045055, 0.299266797604876],
            [31.10749324600073, 0.295251436225764],
            [31.10152604569049, 0.290855819646115],
            [31.09910362983069, 0.28812461941334],
            [31.09439220242242, 0.28559197158656],
            [31.087151983353362, 0.280418568704573],
            [31.083353273918142, 0.278410556088502],
            [31.078669512823986, 0.27683643333906],
            [31.072138811014074, 0.268742591183951],
            [31.06856260439325, 0.267394732361683],
            [31.062950127229133, 0.26214938888318],
            [31.061739923166588, 0.25981632659728],
            [31.061801654494598, 0.256262775594116],
            [31.059132492985828, 0.253857158710457],
            [31.054772288887317, 0.2512161985139],
            [31.050028334380915, 0.247191755362348],
            [31.042617955532428, 0.243302570003058],
            [31.034940522821316, 0.238590554542538],
            [31.029904663458286, 0.234864530854736],
            [31.0231992554953, 0.228000742124826],
            [31.0232183222372, 0.226101939509058],
            [31.024167431860725, 0.222846974753938],
            [31.027926840002266, 0.213606610551397],
            [31.0281300128684, 0.211680700524843],
            [31.027614732034923, 0.209230263877621],
            [31.02527254111991, 0.204672825761463],
            [31.01932517830607, 0.197438550474148],
            [31.02588067990598, 0.193668856121993],
            [31.02858690859832, 0.193678220107041],
            [31.03857217705471, 0.197784476157847],
            [31.044437476072407, 0.197233619023855],
            [31.051034577754837, 0.19852742696359],
            [31.053881069395636, 0.199531441847869],
            [31.060834396207337, 0.200743925624047],
            [31.06372832787829, 0.201829333520808],
            [31.07298586663145, 0.202400115009431],
            [31.080057999232775, 0.203621673295711],
            [31.095496848150898, 0.210803143186461],
            [31.10004890903787, 0.213543540273499],
            [31.104388874991333, 0.215533406967531],
            [31.107873567539205, 0.217812529734038],
            [31.10924704579456, 0.219349910595052],
            [31.111324606501586, 0.224278288227809],
            [31.112035515251137, 0.224802841036754],
            [31.11343462962806, 0.225598757501827],
            [31.118737420682837, 0.227263267029422],
            [31.12651299613537, 0.231740324893498],
            [31.130059606860815, 0.233006751280666],
            [31.144991781704185, 0.232773655661387],
            [31.151217922293398, 0.23400428439022],
            [31.15414710116116, 0.23496319558638],
            [31.158153948451062, 0.23528926961077],
            [31.167457287808976, 0.233038888244143],
            [31.17010001369556, 0.23101367190717],
            [31.175504035899685, 0.23541828725832],
            [31.18583245540472, 0.240566994382323],
            [31.1938883860743, 0.246599329119323],
            [31.195644106466155, 0.248367352513618],
            [31.19714137346597, 0.25174714444485],
            [31.19920688237517, 0.254139143395498],
            [31.200549125309745, 0.258090853934434],
            [31.20085844310984, 0.261990426470009],
            [31.202561601277836, 0.269971716353488],
            [31.202251165075214, 0.273715219009581],
            [31.203645371955727, 0.275327238961585],
            [31.203180072486326, 0.278498786675408],
            [31.20508952516606, 0.287909965196719],
            [31.205185489492923, 0.295765279208609],
            [31.20553099592422, 0.297591995019332],
            [31.20712634368169, 0.302131783829927],
            [31.211124245548003, 0.316589891061945],
            [31.213554612396376, 0.322226209963781],
            [31.214946704642717, 0.326810933715284],
            [31.217331820655268, 0.329868164836916],
            [31.218731350952147, 0.330510483734902],
            [31.221284282141234, 0.330428928843461],
            [31.225168368359395, 0.332745287640473],
            [31.227751298787386, 0.334943220319103],
            [31.2329457889515, 0.340858263086044],
            [31.23953905842095, 0.349377392918996],
            [31.244364541327588, 0.358639080263873],
            [31.245805009648624, 0.362929516984151],
            [31.246503776768776, 0.368794378425093],
            [31.248603821409052, 0.374311581938034],
            [31.248850953333612, 0.376454831764506],
            [31.246510713559395, 0.379131098259627],
            [31.241750297425412, 0.382367565136558],
            [31.234936335246875, 0.390347991519159],
            [31.234327384383757, 0.394656994739845],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 49,
        District: "MUBENDE",
        County: "KASAMBYA",
        Subcounty: "KASAMBYA",
        Population: 38216,
        Key: "MUBENDEKASAMBYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.858330318685702, 0.338874622004922],
            [31.85907502744611, 0.368508293386854],
            [31.86012575898619, 0.388125773381443],
            [31.859555527308434, 0.39495541697551],
            [31.859952227829485, 0.407913792727864],
            [31.85987383544791, 0.425092214512133],
            [31.859796983677025, 0.431503531646479],
            [31.85850563838813, 0.437589914256957],
            [31.85897927601999, 0.442685047735042],
            [31.857402951885287, 0.450721901851804],
            [31.8594138315471, 0.454982432349375],
            [31.86165280513765, 0.456835892749739],
            [31.867307519289803, 0.459282131907254],
            [31.86916671661928, 0.46266386778322],
            [31.86931823545824, 0.464526549787835],
            [31.870664791204515, 0.469551165987469],
            [31.871632367495344, 0.471079665320145],
            [31.873169428065616, 0.471595737174668],
            [31.875177974802636, 0.475920490533068],
            [31.875953861391633, 0.479778815422494],
            [31.875051200956484, 0.485159951799291],
            [31.877280280502504, 0.486900296890746],
            [31.88013477253922, 0.49349753440217],
            [31.880784967751968, 0.499895190670035],
            [31.883463930778806, 0.507460750397585],
            [31.88376407588151, 0.509982493287959],
            [31.8825895852414, 0.512123283890912],
            [31.886655190435725, 0.513894933158446],
            [31.887401653605924, 0.514629955421557],
            [31.885327288206348, 0.51748563956829],
            [31.88356472175367, 0.523163066163211],
            [31.882387460709225, 0.528870627509938],
            [31.882293366674787, 0.533682883347661],
            [31.883524514059857, 0.535998778484824],
            [31.886301538081412, 0.537826510221974],
            [31.889917084623484, 0.541418523283957],
            [31.879955515520912, 0.542428636331612],
            [31.87837941237176, 0.542227916773362],
            [31.874115920896735, 0.5401727717848],
            [31.86988510204694, 0.540906863026449],
            [31.8678279187238, 0.540438821179094],
            [31.86361436639205, 0.537598697617182],
            [31.857676049613115, 0.531117243068868],
            [31.853064589424605, 0.526890806688165],
            [31.846342961480865, 0.519341562923463],
            [31.842566030801372, 0.520713254523522],
            [31.836576846021167, 0.520277956085632],
            [31.83321446898071, 0.509033825417064],
            [31.832384761628077, 0.502620453672838],
            [31.831110669382532, 0.497174857203202],
            [31.831880645955263, 0.492100491113912],
            [31.82847885802665, 0.49384566266951],
            [31.82567488095331, 0.494017018027288],
            [31.824673398650372, 0.493528389489249],
            [31.819800541290597, 0.48911335825134],
            [31.81680734488245, 0.489167093513378],
            [31.815205019011856, 0.490062303872449],
            [31.813023677736656, 0.492666977457755],
            [31.809729751422534, 0.499061469884243],
            [31.807694368414694, 0.504958683356326],
            [31.806980580564677, 0.505193733688757],
            [31.803486774608253, 0.505048357789491],
            [31.801063702978308, 0.504469002846656],
            [31.793690620383778, 0.501012307315154],
            [31.792219213186044, 0.499980866923591],
            [31.78989480352378, 0.497348243489206],
            [31.787227054166642, 0.495909548590581],
            [31.785751966571205, 0.492019784953522],
            [31.78527216919144, 0.489053545209022],
            [31.785959873558866, 0.48773440456374],
            [31.78505112164777, 0.484741637525431],
            [31.78389747192226, 0.482241725880024],
            [31.782498881263148, 0.480481119703481],
            [31.780750408478973, 0.479600629152786],
            [31.776553904374705, 0.478473247841484],
            [31.7730220026637, 0.476677056065836],
            [31.765504099967266, 0.470127227227133],
            [31.758545524299326, 0.464985794774702],
            [31.755153526210677, 0.463260062868962],
            [31.750607342102292, 0.46216784681455],
            [31.74639349512312, 0.462432223176316],
            [31.7434561945869, 0.458174650659508],
            [31.740353458511322, 0.452303416751847],
            [31.736698983476433, 0.451809883323387],
            [31.734417302180642, 0.450480439475895],
            [31.73394362861616, 0.449173031280965],
            [31.734875784335337, 0.447827565989447],
            [31.735293800081454, 0.446388842884055],
            [31.73670121758655, 0.445238051400309],
            [31.73717414285441, 0.444142434400785],
            [31.73766928705248, 0.441685499628396],
            [31.736822967155327, 0.440445775031988],
            [31.73688904273603, 0.439781726727672],
            [31.737636787802124, 0.438830036371225],
            [31.738274918640624, 0.435952550462416],
            [31.73909965561475, 0.434790585341229],
            [31.739660693035585, 0.43269889029247],
            [31.739661037988633, 0.430618167278298],
            [31.74012306938703, 0.428869551441526],
            [31.7379251685679, 0.423512433860538],
            [31.737628770338226, 0.420822941925702],
            [31.738112847291994, 0.418675893962207],
            [31.739036466321053, 0.417845969771726],
            [31.73982846958455, 0.415068111833197],
            [31.7407851133784, 0.413961498110675],
            [31.74171159533824, 0.411229281931988],
            [31.743661118269507, 0.408841666863267],
            [31.744933229729888, 0.407611731083484],
            [31.747168126765676, 0.406318619089133],
            [31.751946806547714, 0.405432941967526],
            [31.754078007456986, 0.402936802397306],
            [31.757305564441292, 0.397229777450476],
            [31.759883164266412, 0.393892517787689],
            [31.762881000473033, 0.391324096163096],
            [31.774219581803262, 0.386079523444255],
            [31.7755772910321, 0.385111879235456],
            [31.78066296287595, 0.379721639574965],
            [31.784179612990073, 0.374548229063191],
            [31.79064569898156, 0.364119878455354],
            [31.794730414036934, 0.35400774907354],
            [31.799015350992736, 0.345641359388591],
            [31.80148582222863, 0.342059722272639],
            [31.804103748325144, 0.339372574597342],
            [31.80432383646809, 0.337195943398518],
            [31.81813934253123, 0.305848590054949],
            [31.83080687622142, 0.324370490342955],
            [31.838383015799415, 0.333525396599608],
            [31.842755475613323, 0.337505931358415],
            [31.846816453585628, 0.339822079178164],
            [31.851133374158792, 0.341079926542106],
            [31.85419339624095, 0.340908428615217],
            [31.857849775704217, 0.339139429935569],
            [31.858330318685702, 0.338874622004922],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 51,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "NALUTUNTU",
        Population: 25314,
        Key: "MUBENDENALUTUNTU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.298711224526453, 0.601580523423706],
            [31.29434191690086, 0.600882808916953],
            [31.291408373119133, 0.601614388941339],
            [31.287121701516533, 0.600645399035219],
            [31.283474050084568, 0.601223009144555],
            [31.274596540019097, 0.601681383398104],
            [31.271453052768948, 0.602376703026536],
            [31.267035199287083, 0.602709881418942],
            [31.26327316626829, 0.603793848032768],
            [31.25523741804823, 0.604035409559872],
            [31.255633361289497, 0.593030056047245],
            [31.256444084545205, 0.588544922733017],
            [31.25825000279517, 0.582079651119742],
            [31.258058740691386, 0.579637944554594],
            [31.25693694971741, 0.576997000713387],
            [31.256563439205422, 0.574736102954498],
            [31.256970014008072, 0.568876279045284],
            [31.256791587033092, 0.564770643719619],
            [31.25488404596828, 0.560239460665588],
            [31.251160923476032, 0.554378406783341],
            [31.250692381088435, 0.546791104732108],
            [31.246569109442778, 0.546138785029917],
            [31.243533065192178, 0.544510135934541],
            [31.243323013925938, 0.542837107124618],
            [31.241279990746623, 0.537871868653671],
            [31.243203561349336, 0.532609365805462],
            [31.246102121140634, 0.532040487289553],
            [31.24658157716059, 0.530087319353818],
            [31.248265968623954, 0.530756990090461],
            [31.248693827210634, 0.530594337322225],
            [31.248356723620486, 0.527474374305908],
            [31.242040490991435, 0.521883960612907],
            [31.238387203529342, 0.520083361167409],
            [31.218295110185583, 0.517192953430693],
            [31.219998251285563, 0.512943250342264],
            [31.223558996103705, 0.508178607267112],
            [31.225038037184706, 0.50522196574229],
            [31.225552511331088, 0.50342255452819],
            [31.22681633223969, 0.501153113749315],
            [31.226891484398035, 0.499362623143502],
            [31.227714877492495, 0.497038799898058],
            [31.229086825018598, 0.495592292576377],
            [31.23325187191828, 0.492767953345041],
            [31.235497170546726, 0.490295352464241],
            [31.236911200550622, 0.489993251105517],
            [31.24001956726641, 0.485675017416238],
            [31.241209934730875, 0.48296241417485],
            [31.24255860600965, 0.481407360621645],
            [31.24246556749567, 0.47969819714674],
            [31.243955025440716, 0.475339825168275],
            [31.243656694036517, 0.473965202019313],
            [31.246069116138774, 0.471876869786914],
            [31.246470575035886, 0.470610940232371],
            [31.2487572842023, 0.467202276667686],
            [31.250876469246364, 0.462373793263236],
            [31.25124584481307, 0.459127411052054],
            [31.25083196131731, 0.453809963858892],
            [31.251570338751602, 0.448718874981772],
            [31.25265773952157, 0.44672061028617],
            [31.25561481107887, 0.443665092070243],
            [31.256936527509243, 0.444924336829365],
            [31.25827907587103, 0.447931683837908],
            [31.2593392190603, 0.449302005628297],
            [31.262988678800962, 0.450681850805714],
            [31.265710580400057, 0.450593541958219],
            [31.267177676582723, 0.450149067490702],
            [31.272215604765872, 0.447321162487429],
            [31.273682890493053, 0.44607598712552],
            [31.274726139066814, 0.444172361773572],
            [31.274437890353372, 0.441772151240366],
            [31.27585958927485, 0.443896835190682],
            [31.27623021439816, 0.445151203103817],
            [31.27953567687718, 0.444936383772397],
            [31.28052555474325, 0.444527373382208],
            [31.282523364815994, 0.442072370057817],
            [31.28413195194412, 0.441254255516496],
            [31.28519297548241, 0.438905786381982],
            [31.28590010232461, 0.438300978303991],
            [31.286554148614993, 0.437945263936238],
            [31.28862208477208, 0.437981329342908],
            [31.28975615661428, 0.43700933742279],
            [31.289655396182145, 0.434610571732642],
            [31.290287779599417, 0.434756259007577],
            [31.291465113407433, 0.43724343606425],
            [31.29323186870427, 0.437659835282419],
            [31.295448553296005, 0.43464892150535],
            [31.29775230080843, 0.432705132507354],
            [31.313608657026215, 0.431035691520216],
            [31.31900818675559, 0.433098803452133],
            [31.319998971920132, 0.435124754387516],
            [31.32083882394725, 0.435450508244435],
            [31.32448275635394, 0.438625582213357],
            [31.326972522503823, 0.439783710149401],
            [31.328424182036663, 0.442153428920883],
            [31.33297962687733, 0.443833975668353],
            [31.333099236659088, 0.449009460278977],
            [31.33213252724253, 0.467810653017527],
            [31.33152405518143, 0.468995415826738],
            [31.327897193460085, 0.47605727587431],
            [31.33315590328553, 0.484318372787062],
            [31.337170321576668, 0.494861005912222],
            [31.338045018355338, 0.503968049777751],
            [31.333359978060212, 0.508827910033065],
            [31.330174975169207, 0.509468309882877],
            [31.326490793746203, 0.508574646309379],
            [31.32509192910094, 0.508725156697268],
            [31.324130138858852, 0.509102099175312],
            [31.32335545241907, 0.510396932579632],
            [31.31954480527202, 0.512897982455804],
            [31.31488668479101, 0.513827153504717],
            [31.311913163284224, 0.517724018462638],
            [31.309564466769935, 0.519968903446709],
            [31.317553807124106, 0.52807484025833],
            [31.32291866008689, 0.534477136519544],
            [31.323676185111488, 0.537413505494431],
            [31.31988394534293, 0.539643928311496],
            [31.317153293254673, 0.543647818193482],
            [31.317792202932488, 0.545168018828051],
            [31.320720742199782, 0.548134421813399],
            [31.323919467755047, 0.554082051165232],
            [31.32608450909938, 0.55547140489379],
            [31.326995958651295, 0.558614300732145],
            [31.329889155500318, 0.562098005605258],
            [31.328067418816534, 0.567658612383598],
            [31.325788148598953, 0.569674636210612],
            [31.325306327314863, 0.570940578208176],
            [31.325411953920906, 0.57262269132305],
            [31.322858686761908, 0.576546790600101],
            [31.31450485228625, 0.586519170174621],
            [31.311732422249047, 0.589140908176738],
            [31.30906100776556, 0.590984938474033],
            [31.30722575772494, 0.594158595683459],
            [31.30352257064548, 0.598127478230178],
            [31.298711224526453, 0.601580523423706],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 52,
        District: "MUBENDE",
        County: "KASAMBYA",
        Subcounty: "KIBALINGA",
        Population: 36176,
        Key: "MUBENDEKIBALINGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.274437890353372, 0.441772151240366],
            [31.274726139066814, 0.444172361773572],
            [31.273682890493053, 0.44607598712552],
            [31.272215604765872, 0.447321162487429],
            [31.267177676582723, 0.450149067490702],
            [31.265710580400057, 0.450593541958219],
            [31.262988678800962, 0.450681850805714],
            [31.2593392190603, 0.449302005628297],
            [31.25827907587103, 0.447931683837908],
            [31.256936527509243, 0.444924336829365],
            [31.25561481107887, 0.443665092070243],
            [31.25265773952157, 0.44672061028617],
            [31.251570338751602, 0.448718874981772],
            [31.25083196131731, 0.453809963858892],
            [31.25124584481307, 0.459127411052054],
            [31.250876469246364, 0.462373793263236],
            [31.2487572842023, 0.467202276667686],
            [31.246470575035886, 0.470610940232371],
            [31.246069116138774, 0.471876869786914],
            [31.243656694036517, 0.473965202019313],
            [31.243955025440716, 0.475339825168275],
            [31.24246556749567, 0.47969819714674],
            [31.24255860600965, 0.481407360621645],
            [31.241209934730875, 0.48296241417485],
            [31.24001956726641, 0.485675017416238],
            [31.236911200550622, 0.489993251105517],
            [31.235497170546726, 0.490295352464241],
            [31.23325187191828, 0.492767953345041],
            [31.229086825018598, 0.495592292576377],
            [31.227714877492495, 0.497038799898058],
            [31.226891484398035, 0.499362623143502],
            [31.22681633223969, 0.501153113749315],
            [31.225552511331088, 0.50342255452819],
            [31.225038037184706, 0.50522196574229],
            [31.223558996103705, 0.508178607267112],
            [31.219998251285563, 0.512943250342264],
            [31.218295110185583, 0.517192953430693],
            [31.214556054275114, 0.515112017752774],
            [31.20828095819785, 0.5124335379106],
            [31.207689814638595, 0.511312052204656],
            [31.206528518453393, 0.510307963370195],
            [31.203124218835228, 0.508778757057178],
            [31.202675388179948, 0.507684443685063],
            [31.20170315861592, 0.507159683747115],
            [31.199799478510233, 0.50886824729007],
            [31.198541417599223, 0.508605648643338],
            [31.194835651456554, 0.509101956348812],
            [31.19133616994417, 0.507744542211219],
            [31.188341190380186, 0.508159661644615],
            [31.181386588859066, 0.507533732058174],
            [31.17756177348336, 0.508265104439533],
            [31.170355322085836, 0.508000802629452],
            [31.167862775650136, 0.507638379885508],
            [31.163888109606948, 0.506326051920997],
            [31.15959157629918, 0.50569183282675],
            [31.15566724465799, 0.503140683948043],
            [31.154242739399578, 0.502950380495154],
            [31.150844553715228, 0.504016433861984],
            [31.14538861427758, 0.506863274665105],
            [31.143345286569375, 0.507260555211008],
            [31.142313316344012, 0.508146197326378],
            [31.142177449750577, 0.501798509695396],
            [31.141706670557944, 0.499980818416428],
            [31.144985795331127, 0.499005161126519],
            [31.145276008660083, 0.497115347852472],
            [31.144429779492775, 0.492810841821933],
            [31.142140463415384, 0.486498488672946],
            [31.1410872453386, 0.484590216630558],
            [31.14036938362875, 0.480909698926659],
            [31.138773579527125, 0.475863519546325],
            [31.138753798624574, 0.473223092284495],
            [31.14095392816393, 0.459316242537518],
            [31.140197472134513, 0.457064448330178],
            [31.141766483982813, 0.455220178362295],
            [31.14146764233557, 0.45264297113746],
            [31.139050372924043, 0.45009234602083],
            [31.138206960873458, 0.449775638563182],
            [31.137525793546345, 0.448346742210422],
            [31.1346165509897, 0.446564615390457],
            [31.132418899003905, 0.443580021467936],
            [31.132116718318713, 0.441961335304736],
            [31.13081618775602, 0.44112005119183],
            [31.128494284393398, 0.437746610904995],
            [31.126794839860803, 0.437113207495288],
            [31.124384541375886, 0.434770598401646],
            [31.122774408247157, 0.433947329576262],
            [31.117824823982325, 0.42763446351231],
            [31.11873474819487, 0.422209226777026],
            [31.118083463325675, 0.42136812013724],
            [31.11711994023338, 0.420988102615467],
            [31.115409164351803, 0.418491975104223],
            [31.11518312037854, 0.416511629653261],
            [31.113950108989226, 0.413879988905451],
            [31.113829044835025, 0.411881585730388],
            [31.115421586255536, 0.408735204838794],
            [31.1154219357002, 0.407243205657446],
            [31.116251263963758, 0.40652905043843],
            [31.11672541812692, 0.405037162237391],
            [31.11789226320566, 0.403780538492422],
            [31.117149569366408, 0.40128465263241],
            [31.118503277498977, 0.399132869016314],
            [31.11850353980703, 0.397984478863834],
            [31.119510862057606, 0.395859737521805],
            [31.119348948812497, 0.394421952525137],
            [31.12040004686519, 0.391085529845851],
            [31.12481206668761, 0.384277549992369],
            [31.12407761309444, 0.382459850603394],
            [31.123221358728546, 0.381835730297714],
            [31.12326584330145, 0.381220853406423],
            [31.12469791596781, 0.381293509334656],
            [31.125067755065224, 0.380524980762013],
            [31.125737832690167, 0.380217684654925],
            [31.127033073972477, 0.377025972766749],
            [31.127058921198127, 0.375615351753667],
            [31.128239199683634, 0.373137966070966],
            [31.129251803129776, 0.372450955372242],
            [31.130284333005534, 0.370443742594019],
            [31.132305544191464, 0.36937715825532],
            [31.133107738841858, 0.368156590457751],
            [31.13326095100515, 0.367035350769765],
            [31.133952558552494, 0.367125922447749],
            [31.1344703376008, 0.366257950267258],
            [31.135788108630415, 0.366656099711955],
            [31.13546751517688, 0.365507630657215],
            [31.136086021419658, 0.364838614056235],
            [31.136315633501226, 0.363455154713646],
            [31.137415499294082, 0.361565495606787],
            [31.13808364374451, 0.361104465116601],
            [31.138698863950005, 0.358645020706467],
            [31.141221965681776, 0.357524264022259],
            [31.14313680735486, 0.353600184013206],
            [31.14259759719884, 0.349359111644496],
            [31.14195655581884, 0.347622811708774],
            [31.14234328683684, 0.346519696287326],
            [31.14202986463424, 0.345949952916172],
            [31.142256011913734, 0.34498244361993],
            [31.139307952255347, 0.340333989498449],
            [31.139863630327156, 0.339366546109206],
            [31.139557524902518, 0.338688294909255],
            [31.143919082762153, 0.339723074896614],
            [31.147688432558937, 0.343519235705845],
            [31.149392557314172, 0.344351446940465],
            [31.15156160244977, 0.344611835088888],
            [31.157499568885733, 0.352462017695806],
            [31.15622992060586, 0.353748277449463],
            [31.155157902586826, 0.357664245766622],
            [31.15339473785619, 0.360143341597776],
            [31.153502918372617, 0.362545029578319],
            [31.152935222638895, 0.363845381301398],
            [31.153248916132753, 0.364939348191059],
            [31.152101527664747, 0.366939676764723],
            [31.15216158812632, 0.368422489881847],
            [31.151376741740705, 0.368981428943209],
            [31.151811260436897, 0.37108082523442],
            [31.146090054784025, 0.378150535775744],
            [31.144230458602564, 0.379878868244747],
            [31.14296442783837, 0.383232077284347],
            [31.14136280714527, 0.386091283022636],
            [31.14063863566887, 0.391264319166549],
            [31.141330550440056, 0.395963335055283],
            [31.146801718118397, 0.402303297354206],
            [31.146595037331103, 0.405472609678919],
            [31.14435823047702, 0.4084563209673],
            [31.147032162039945, 0.411210356713015],
            [31.1479173143102, 0.413105067524416],
            [31.150585734708827, 0.415817405660389],
            [31.15665378258785, 0.419909547850488],
            [31.158935546528642, 0.421723926902785],
            [31.159565922211268, 0.422721664885474],
            [31.159774687988357, 0.428692208309342],
            [31.158903264670585, 0.43112252201456],
            [31.159151565303333, 0.435110724005677],
            [31.1620043388629, 0.440235765900616],
            [31.164063344867746, 0.44269477889403],
            [31.165416646063495, 0.443346770111369],
            [31.167368483953272, 0.443132134876635],
            [31.170220601742663, 0.445762904985068],
            [31.174372518866136, 0.442746909268645],
            [31.174601356599936, 0.44096040373617],
            [31.17580318117752, 0.44047861107856],
            [31.176390693746374, 0.439632811998455],
            [31.180131513049744, 0.439069791481077],
            [31.181302477802372, 0.438034998519575],
            [31.18312096438149, 0.438335300130041],
            [31.184876629077827, 0.439148534588016],
            [31.185723245419027, 0.43903826513349],
            [31.18698747506107, 0.437362254562632],
            [31.18724812573235, 0.436321558707004],
            [31.187161610783953, 0.435082201521192],
            [31.186577899885382, 0.434037357049664],
            [31.18653096560673, 0.432372192214571],
            [31.187999182886877, 0.430577099259928],
            [31.190043354113115, 0.429541615249035],
            [31.193461117680748, 0.426452014303824],
            [31.194155571989228, 0.426476009436995],
            [31.194274193624185, 0.42543054037327],
            [31.193650933496933, 0.424691549064916],
            [31.193832644712607, 0.42380179755748],
            [31.195316481898914, 0.42284880807096],
            [31.196981577549987, 0.422912760987352],
            [31.198908435986645, 0.417201081860707],
            [31.200021458505123, 0.415858703719539],
            [31.201284238266325, 0.415286996775148],
            [31.202626121874797, 0.41396849849897],
            [31.203587552790783, 0.411760424094681],
            [31.20789743506372, 0.409859533611205],
            [31.214796072440922, 0.409485693092417],
            [31.217546463210937, 0.408078570115943],
            [31.224283234953752, 0.402003288100678],
            [31.226894412905867, 0.397851009499488],
            [31.228572500890902, 0.397663665869886],
            [31.229924161762913, 0.398062817252863],
            [31.2310429379908, 0.397640732433032],
            [31.23153245424366, 0.397218513745836],
            [31.231439571138203, 0.395646527475281],
            [31.232455908880983, 0.393669390524068],
            [31.234327384383757, 0.394656994739845],
            [31.240287703598934, 0.397713345999914],
            [31.249247652058035, 0.404587998738403],
            [31.251463412283325, 0.407573414414618],
            [31.252306937521645, 0.409372476816288],
            [31.254195925680868, 0.411615587968771],
            [31.25461520086501, 0.413433347406945],
            [31.255132974523402, 0.414030299180537],
            [31.256609692561078, 0.414955645710003],
            [31.259746439751662, 0.415631969520988],
            [31.264173114689594, 0.417712898679798],
            [31.26448529901376, 0.418969981952499],
            [31.263999155036515, 0.42371751093972],
            [31.264427334321756, 0.428266327145722],
            [31.27203108811156, 0.440222260128991],
            [31.273019726302536, 0.439004225373406],
            [31.274437890353372, 0.441772151240366],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 53,
        District: "MUBENDE",
        County: "KASAMBYA",
        Subcounty: "NABINGOOLA",
        Population: 36152,
        Key: "MUBENDENABINGOOLA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.857849775704217, 0.339139429935569],
            [31.85419339624095, 0.340908428615217],
            [31.851133374158792, 0.341079926542106],
            [31.846816453585628, 0.339822079178164],
            [31.842755475613323, 0.337505931358415],
            [31.838383015799415, 0.333525396599608],
            [31.83080687622142, 0.324370490342955],
            [31.81813934253123, 0.305848590054949],
            [31.806246479111103, 0.290646429541004],
            [31.80277990558252, 0.283445946188924],
            [31.81218860474686, 0.277223700616054],
            [31.81739508292844, 0.274637242853692],
            [31.821389046580542, 0.273154195164068],
            [31.82364740312, 0.272747376144441],
            [31.827629382347887, 0.273308588652995],
            [31.834285524005754, 0.276800796689333],
            [31.84007393531995, 0.278755197859926],
            [31.842206752298438, 0.278818729557999],
            [31.844591001436754, 0.277561643763631],
            [31.845256881234363, 0.276096338856982],
            [31.84941739793005, 0.271573992890269],
            [31.85071358873159, 0.267612181579258],
            [31.850166987237415, 0.263713511799685],
            [31.847588221399068, 0.258195510196054],
            [31.846185850629237, 0.256693826966141],
            [31.84442656302734, 0.255635341866258],
            [31.842798550729512, 0.252921545542207],
            [31.842965029212902, 0.250045093150484],
            [31.8438210131859, 0.248227025305859],
            [31.846008455818485, 0.246526665967126],
            [31.851539872604654, 0.24651810689834],
            [31.856680823177822, 0.245433093069433],
            [31.858081151178688, 0.244718617357737],
            [31.860097104525245, 0.242276493853445],
            [31.86454068665515, 0.233303677057885],
            [31.866260372926032, 0.231241428911174],
            [31.867731765750715, 0.230183216695713],
            [31.86970208288419, 0.229514003245077],
            [31.89232729866674, 0.225813542121384],
            [31.901020629844442, 0.226051996263022],
            [31.905539188062928, 0.220606840246234],
            [31.908588150087294, 0.218282323666022],
            [31.9095844760605, 0.21703409124629],
            [31.910836537123693, 0.21273747317339],
            [31.91126153457618, 0.212530827046807],
            [31.91266450811557, 0.21214058809246],
            [31.917877318521587, 0.212502789921327],
            [31.92350911485422, 0.216230036542258],
            [31.924496243875534, 0.217984982563571],
            [31.924666664166395, 0.222118901095078],
            [31.925677668611335, 0.223729119053994],
            [31.926130978266645, 0.225972499572121],
            [31.92785538787931, 0.228659218169039],
            [31.930750273561074, 0.231227802477609],
            [31.92968042677009, 0.23194487499896],
            [31.925814519758358, 0.236870139275811],
            [31.92217749629451, 0.246245897426155],
            [31.92103620289571, 0.24822032214009],
            [31.915187255911114, 0.256081993246776],
            [31.910277934137326, 0.261721206885933],
            [31.903643416724986, 0.280580154823157],
            [31.903797325082632, 0.287125953336017],
            [31.902037605391094, 0.29207999373935],
            [31.897876743742323, 0.297129526979932],
            [31.89290788612307, 0.299163352620629],
            [31.8902566442076, 0.304153175132217],
            [31.88828708345558, 0.312006439238093],
            [31.883477356100727, 0.314995149635603],
            [31.879435523922062, 0.318345361723821],
            [31.878246831815613, 0.318584570405664],
            [31.87765249744047, 0.31846483042192],
            [31.87848472277083, 0.317028926962313],
            [31.878365917879563, 0.316550254403366],
            [31.86814373942822, 0.313318151363243],
            [31.863091946647007, 0.313138103823073],
            [31.85702967583358, 0.314094755743605],
            [31.85441443839471, 0.315889430507238],
            [31.852512315967687, 0.318162856517977],
            [31.85001561841707, 0.322829508949923],
            [31.849301980585707, 0.326778363129484],
            [31.850965526642927, 0.331684823612816],
            [31.8557194767035, 0.337548965303708],
            [31.857849775704217, 0.339139429935569],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1639,
        District: "MITYANA",
        County: "BUSUJJU",
        Subcounty: "BBANDA",
        Population: 13597,
        Key: "MITYANABBANDA",
        Dist2: "Mityana",
        "Sub Country": "Banda",
        id2_original: "Mityana Banda",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.860934032536107, 0.171545400838485],
            [31.859492344302918, 0.171811641428886],
            [31.856380498412037, 0.17078026061616],
            [31.855666557848416, 0.169305794860233],
            [31.85445502427924, 0.168636352560396],
            [31.851519335320642, 0.165877291329322],
            [31.849592535274464, 0.162412745143483],
            [31.845421715800796, 0.159228485126714],
            [31.841501829023617, 0.157654345425377],
            [31.839412259637857, 0.157699453258252],
            [31.837964786254254, 0.158631054760539],
            [31.837846541911716, 0.159255185648751],
            [31.83822697214634, 0.159734618251569],
            [31.841659983717605, 0.161272549543147],
            [31.845178492446045, 0.165279910566644],
            [31.846156471227864, 0.169676083291755],
            [31.84581990932183, 0.177265239703571],
            [31.843542889384043, 0.179897332921638],
            [31.83890362454084, 0.183135313876537],
            [31.836080746913943, 0.18605681405358],
            [31.83186884748232, 0.189032484558675],
            [31.828951590156702, 0.192496690689492],
            [31.827897366865134, 0.19504743246974],
            [31.82666434289943, 0.196765977715773],
            [31.82545044047283, 0.205811327078327],
            [31.8255589596541, 0.207710876938207],
            [31.825061345088972, 0.208687746139437],
            [31.825064484700896, 0.211727012853161],
            [31.82284747042746, 0.21512792198998],
            [31.821545723545867, 0.219388214478003],
            [31.822868635633874, 0.224390442031353],
            [31.821931952405656, 0.237895184574083],
            [31.820959266497475, 0.238654914681209],
            [31.811877887371555, 0.240273244277248],
            [31.79685823099254, 0.240299041868729],
            [31.79564749422902, 0.240588383978987],
            [31.793751604313467, 0.241537972982937],
            [31.791782364260015, 0.243238315886611],
            [31.78996933584459, 0.246928640363436],
            [31.787257597784624, 0.246928388837518],
            [31.785472288683902, 0.2631554977181],
            [31.785061058811458, 0.273349511838439],
            [31.78152475984713, 0.272553159884086],
            [31.77685368565974, 0.27060794915877],
            [31.75358211496227, 0.258105077714326],
            [31.75001317032222, 0.255644436319683],
            [31.74821854748866, 0.251990003431987],
            [31.7405775881747, 0.243522995719974],
            [31.738768726145548, 0.241948969228421],
            [31.73451300240282, 0.239813911855919],
            [31.736966482005116, 0.238656365447803],
            [31.738196671786113, 0.237218302639003],
            [31.73899879097802, 0.231483756466535],
            [31.73872868284347, 0.228408382689296],
            [31.738201807454587, 0.226906842578621],
            [31.735022927480568, 0.223659357319021],
            [31.731291074262067, 0.222021863112023],
            [31.727849165776213, 0.218204527431867],
            [31.725489565511023, 0.215065675467649],
            [31.724749033018355, 0.21344653996419],
            [31.72427566488106, 0.209955094359289],
            [31.722774819891473, 0.208191177804333],
            [31.717200094427174, 0.205612871646542],
            [31.709477499813456, 0.203179121059643],
            [31.708406180683724, 0.20208458462986],
            [31.708270695874255, 0.200501691901086],
            [31.713604977371286, 0.182104479866306],
            [31.720088348745495, 0.163092198438753],
            [31.72217039294414, 0.160704431148919],
            [31.7241133851233, 0.159456332934261],
            [31.727779962261685, 0.159058581124195],
            [31.730439660018934, 0.159411508073438],
            [31.733097442567974, 0.159022735787509],
            [31.73671355594698, 0.157611920850016],
            [31.738940710403316, 0.156110565854039],
            [31.741212833624495, 0.153858461743601],
            [31.74305092413804, 0.150973167701782],
            [31.74422865140815, 0.147897882024907],
            [31.749504592717383, 0.137948488213958],
            [31.74979363913478, 0.135415853580546],
            [31.749242855084617, 0.133742465705701],
            [31.745246231520944, 0.130992526042293],
            [31.742717900695933, 0.130983349775623],
            [31.73794870891991, 0.131824301823942],
            [31.733746724194077, 0.131769811959601],
            [31.73263460627911, 0.136979744206454],
            [31.729920410428516, 0.142234806541566],
            [31.72752049826491, 0.145518044229845],
            [31.722111487716, 0.150619158145748],
            [31.720734602150788, 0.150646210817046],
            [31.714557264336023, 0.148945367132247],
            [31.709381067464335, 0.148700840248593],
            [31.706354106079587, 0.149089594756591],
            [31.70165599439876, 0.154697219276935],
            [31.692651821878247, 0.168291256354235],
            [31.690980109236783, 0.168897154813892],
            [31.689080464363325, 0.168788484289169],
            [31.683493729322, 0.166056524239487],
            [31.682068865635777, 0.165893618141172],
            [31.674660147772222, 0.169194504861881],
            [31.673354875003156, 0.169311997700176],
            [31.672296721582228, 0.16873304949345],
            [31.66216747654197, 0.159280453363452],
            [31.65218719553203, 0.151971564395978],
            [31.646865451821384, 0.146625740630458],
            [31.635624930587575, 0.138557107623553],
            [31.630525399535504, 0.136060454971739],
            [31.621673878629526, 0.133084226067416],
            [31.615895823992236, 0.129954430201657],
            [31.60720863279949, 0.12629085181687],
            [31.60544919517895, 0.125413423581506],
            [31.602819495762304, 0.123143074484125],
            [31.591146762705947, 0.109557457379416],
            [31.589503880595235, 0.10791126255146],
            [31.58717314948829, 0.106436883611214],
            [31.58377931703984, 0.102719406037015],
            [31.581444437512904, 0.099906441225587],
            [31.57973733574082, 0.096614147500722],
            [31.57785417135958, 0.094018282229929],
            [31.571750033664067, 0.088944047917541],
            [31.5697253576761, 0.086682838289714],
            [31.566966372723755, 0.080903294140601],
            [31.565199038911885, 0.073414387772736],
            [31.578995486317947, 0.059287265645953],
            [31.60092745692437, 0.050008056572414],
            [31.618314975374286, 0.042600836827928],
            [31.631871045288424, 0.039100776792336],
            [31.639712328012383, 0.037708017410653],
            [31.6435118126937, 0.038106052741079],
            [31.646436446086117, 0.039435689312842],
            [31.652852709715315, 0.049448427920747],
            [31.658687214485077, 0.059479297502805],
            [31.663011901892215, 0.064797792470615],
            [31.666984306875804, 0.067439008326982],
            [31.673986661040793, 0.071156670834088],
            [31.690167136599612, 0.075788178508787],
            [31.694988107268575, 0.07643957239769],
            [31.698583031186644, 0.075924116848352],
            [31.708887767507537, 0.072595865109858],
            [31.719264595426594, 0.070335195370648],
            [31.732189807262802, 0.069403628740628],
            [31.750589154811053, 0.069603133638652],
            [31.780544847890823, 0.06283807307997],
            [31.78595653002937, 0.060558792505955],
            [31.80637696838928, 0.048185201257093],
            [31.812024860735168, 0.043147024045857],
            [31.817408070770806, 0.050039713190963],
            [31.822221554880223, 0.054654964139132],
            [31.82493216016462, 0.05802186616218],
            [31.825433263786266, 0.060339200355294],
            [31.825208790068135, 0.061402672100827],
            [31.824592791921617, 0.062741241038691],
            [31.822813978538743, 0.064797563400369],
            [31.82312460608251, 0.06663716636501],
            [31.824230267805568, 0.068034092379506],
            [31.825228283509812, 0.068678438202857],
            [31.829408023254256, 0.069057406604748],
            [31.830168327666335, 0.069463001049094],
            [31.831832215981674, 0.071038693382017],
            [31.838798990573192, 0.079854019802143],
            [31.84283931268384, 0.083047196830205],
            [31.855491884933006, 0.090410643738818],
            [31.858544771696852, 0.091803757404986],
            [31.862749429808947, 0.093187866316387],
            [31.86720859411577, 0.093986578031272],
            [31.866229091791244, 0.096182699856794],
            [31.866038836698873, 0.098264869516715],
            [31.86770290018572, 0.09936584937972],
            [31.868225858919917, 0.100658254508373],
            [31.873432022691176, 0.103626148743348],
            [31.874691926046804, 0.10532544672039],
            [31.876664908481736, 0.109944617980171],
            [31.87685349360596, 0.112245416489853],
            [31.884202884033208, 0.11264410421487],
            [31.884795124435385, 0.115449880444973],
            [31.885171057703705, 0.123156769268976],
            [31.883411262553686, 0.132274679080367],
            [31.88252304343504, 0.134454631942735],
            [31.8802704397067, 0.137729036713312],
            [31.87576763973493, 0.146557321569095],
            [31.87365685753205, 0.149162342776826],
            [31.87163051786419, 0.153115157022081],
            [31.869949224690213, 0.157655946217145],
            [31.868623972490905, 0.159377290478342],
            [31.867068417405594, 0.162232844755062],
            [31.86257583577018, 0.168103151740876],
            [31.860934032536107, 0.171545400838485],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1642,
        District: "GOMBA",
        County: "GOMBA",
        Subcounty: "KABULASOKE",
        Population: 49954,
        Key: "GOMBAKABULASOKE",
        Dist2: "Gomba",
        "Sub Country": "Kabulasoke",
        id2_original: "Gomba Kabulasoke",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.931080879636784, 0.120250543523534],
            [31.921612856629384, 0.122977397680085],
            [31.91731005128428, 0.123066207619315],
            [31.916091739027973, 0.122922893424019],
            [31.912884366289788, 0.121556856328216],
            [31.90800106511649, 0.118155471999366],
            [31.8938191964361, 0.101981266935646],
            [31.890859555697062, 0.098815185629032],
            [31.887627252014795, 0.096282295931876],
            [31.88424188618789, 0.094889155493674],
            [31.88046537142839, 0.094156335136662],
            [31.86720859411577, 0.093986578031272],
            [31.862749429808947, 0.093187866316387],
            [31.858544771696852, 0.091803757404986],
            [31.855491884933006, 0.090410643738818],
            [31.84283931268384, 0.083047196830205],
            [31.838798990573192, 0.079854019802143],
            [31.831832215981674, 0.071038693382017],
            [31.830168327666335, 0.069463001049094],
            [31.829408023254256, 0.069057406604748],
            [31.825228283509812, 0.068678438202857],
            [31.824230267805568, 0.068034092379506],
            [31.82312460608251, 0.06663716636501],
            [31.822813978538743, 0.064797563400369],
            [31.824592791921617, 0.062741241038691],
            [31.825208790068135, 0.061402672100827],
            [31.825433263786266, 0.060339200355294],
            [31.82493216016462, 0.05802186616218],
            [31.822221554880223, 0.054654964139132],
            [31.817408070770806, 0.050039713190963],
            [31.812024860735168, 0.043147024045857],
            [31.821547267749846, 0.03362235722168],
            [31.827774978594185, 0.02827656639275],
            [31.838844176730294, 0.0202985868569],
            [31.852432546468798, 0.014138688317847],
            [31.869214030885303, 0.007264153762027],
            [31.871539466423616, 0.005807818507674],
            [31.873335617291506, 0.00967933815721],
            [31.878437948392296, 0.017883731352775],
            [31.88653258567081, 0.026133393877372],
            [31.88722245138481, 0.027445021185374],
            [31.8869424590872, 0.032103512040334],
            [31.887786212497577, 0.032781952871792],
            [31.889520049030814, 0.033026203858948],
            [31.895977823809325, 0.031705616821629],
            [31.901183004823626, 0.031597127301323],
            [31.905014032947822, 0.032185145530587],
            [31.908138042925966, 0.033388260790262],
            [31.92240665023526, 0.041511505871907],
            [31.927813714134956, 0.045898777627388],
            [31.934245315599338, 0.053497315629566],
            [31.938048241726502, 0.056799104265803],
            [31.953610004430015, 0.063710421130535],
            [31.958192220862777, 0.066953039855408],
            [31.95624761620766, 0.065287987533951],
            [31.952865598401832, 0.067166478522408],
            [31.949748109294315, 0.072198919665615],
            [31.94786574531199, 0.077493211731977],
            [31.946435567192577, 0.083742944874016],
            [31.945528064838044, 0.090231206382086],
            [31.945343385588654, 0.095321025361466],
            [31.945857217439617, 0.098462833659107],
            [31.948368996805538, 0.104995508648684],
            [31.943431857800633, 0.106885814998276],
            [31.93910086242361, 0.109744129648546],
            [31.936278256087903, 0.112928141075901],
            [31.932710610411757, 0.118816802212604],
            [31.931080879636784, 0.120250543523534],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1645,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "NGANDO",
        Population: 18661,
        Key: "BUTAMBALANGANDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.88426153222231, -0.61125423978931],
            [29.881841213030413, -0.610016856508017],
            [29.88020091447441, -0.61001590255127],
            [29.878786946454287, -0.609283385872361],
            [29.877835187698945, -0.60755741798094],
            [29.875517945694323, -0.60620145568578],
            [29.87450696999549, -0.604974792939842],
            [29.87341672965093, -0.604954387049036],
            [29.87388868473826, -0.604084541082003],
            [29.873113252696793, -0.603184312043364],
            [29.872611962225548, -0.603826724546459],
            [29.872196491406644, -0.603594821160093],
            [29.871741169525098, -0.605995546394654],
            [29.870712386522367, -0.607244939501054],
            [29.869524272032653, -0.606948553418467],
            [29.86766310739273, -0.608677618720877],
            [29.86730560216413, -0.610986194163081],
            [29.865929490048387, -0.612557947900843],
            [29.866353028636862, -0.614527000494526],
            [29.865594043849946, -0.616591500919731],
            [29.865723852205125, -0.618038357620616],
            [29.864743096730745, -0.619510859329623],
            [29.864663749440027, -0.621141724309925],
            [29.864166751119207, -0.622022646673914],
            [29.86462321386113, -0.62341708560195],
            [29.865406624738956, -0.624272468201644],
            [29.865209756249488, -0.625778314340944],
            [29.865705380147944, -0.627225391292473],
            [29.866436598907736, -0.627962371649971],
            [29.86637058351414, -0.629119754298937],
            [29.86669700523727, -0.629475071358451],
            [29.867364924210555, -0.629303141491905],
            [29.867879210609043, -0.630911167843978],
            [29.868581989605264, -0.631806438279774],
            [29.86910809244297, -0.634117621145063],
            [29.869782326572754, -0.633744357161526],
            [29.8700554189107, -0.634442700627636],
            [29.871111615800952, -0.634334138693832],
            [29.872195783534195, -0.636447310724752],
            [29.87317764752963, -0.636770510002946],
            [29.87379742039698, -0.637561779819997],
            [29.874562348437824, -0.637635090384107],
            [29.87496501017908, -0.638467857861303],
            [29.876949594355885, -0.638822888632819],
            [29.877455801306713, -0.639374743278073],
            [29.87828940644932, -0.639312170531236],
            [29.878561728032754, -0.639687614186979],
            [29.87826180930549, -0.639905968441913],
            [29.879171171172647, -0.640468476324332],
            [29.87932659049661, -0.639875397984434],
            [29.88045266194289, -0.641072838525865],
            [29.88223526711461, -0.64201489301234],
            [29.88231892003049, -0.642594817900939],
            [29.88429888956171, -0.642798624731408],
            [29.885666622192492, -0.64337003403906],
            [29.885678123323064, -0.644197571821042],
            [29.88723752589278, -0.645322036844939],
            [29.8872488473603, -0.64644555485626],
            [29.888136509523434, -0.647080341246057],
            [29.887991641810853, -0.648493701499644],
            [29.887522753571876, -0.649906861047173],
            [29.886694175401598, -0.650776163136347],
            [29.886657163015258, -0.652431202012874],
            [29.885900585713298, -0.653300546782785],
            [29.88605616224242, -0.654007367114024],
            [29.884771070126178, -0.65566766421802],
            [29.885142696871014, -0.656308176728672],
            [29.88461339872583, -0.65836156876544],
            [29.88479295218817, -0.659098606606706],
            [29.88391625126812, -0.660155117058044],
            [29.88505526114946, -0.661847137597157],
            [29.885113382148333, -0.664867356812771],
            [29.884632970320926, -0.665483169726744],
            [29.885832038867218, -0.667078587471237],
            [29.886609644831662, -0.670957001419999],
            [29.887521123129645, -0.6718757217342],
            [29.88815586911615, -0.673917774932447],
            [29.88981117492726, -0.675175238449991],
            [29.890002605015994, -0.676093501656699],
            [29.89100342615884, -0.676789101345408],
            [29.888416027510623, -0.678614480561446],
            [29.887206970596704, -0.678884027198741],
            [29.88489616771601, -0.678460167105698],
            [29.885690629668453, -0.680591780436377],
            [29.88551639692752, -0.682315765373791],
            [29.88744061162232, -0.683388956727216],
            [29.888661909878614, -0.68210342138868],
            [29.890202278045766, -0.684799117778824],
            [29.890559176013195, -0.68498438835704],
            [29.891163941625397, -0.684507953261603],
            [29.891587909608585, -0.684842721582867],
            [29.890827178496746, -0.68598981776092],
            [29.890986039266522, -0.686310179831677],
            [29.89348608573652, -0.685992465804589],
            [29.894436179015308, -0.687269423603065],
            [29.89531579317185, -0.686847982340344],
            [29.89643119532754, -0.685469434937438],
            [29.897023903752007, -0.685994769818128],
            [29.897984742678204, -0.68587623303513],
            [29.8965215892013, -0.688006740922172],
            [29.898299869883235, -0.689335712262227],
            [29.898850851562752, -0.691142514490875],
            [29.89885015896166, -0.692212997434621],
            [29.898369119211875, -0.69293319873983],
            [29.89888340111875, -0.69396647938241],
            [29.90042424090141, -0.693505109727546],
            [29.90253542375293, -0.693469261488891],
            [29.903882494233844, -0.692941292866859],
            [29.905176577587763, -0.691765042969959],
            [29.90633635023025, -0.691669082043469],
            [29.907240435393433, -0.691993787668211],
            [29.90679670088075, -0.693250854815682],
            [29.90721264690845, -0.693866430567433],
            [29.907088051476865, -0.694758093032677],
            [29.9083284640858, -0.694393293341335],
            [29.908692112892584, -0.693689052354427],
            [29.909115120576732, -0.693890739891228],
            [29.909271837966227, -0.695871303068866],
            [29.909796687654158, -0.696051223244628],
            [29.90949496870304, -0.697603070292912],
            [29.910295253535136, -0.697459937953251],
            [29.911098922320935, -0.697879850351707],
            [29.91078500514657, -0.69879804003006],
            [29.912498678094952, -0.699380514605484],
            [29.911667785864484, -0.700788232159121],
            [29.91009553289466, -0.700934325921184],
            [29.908718450598414, -0.702352751019742],
            [29.90914199367844, -0.702903449641324],
            [29.908766755706168, -0.703639153960459],
            [29.909336178900137, -0.706567883766559],
            [29.908795317640614, -0.706913854356433],
            [29.908825750765818, -0.707346787789752],
            [29.909746647001242, -0.708312182958858],
            [29.910379344828893, -0.708445573481359],
            [29.910267895343168, -0.709756610041055],
            [29.911004449197456, -0.71077445060664],
            [29.910764299877602, -0.711603012554353],
            [29.911353433905553, -0.711499645996294],
            [29.91175003920518, -0.711868820605236],
            [29.912161331061352, -0.711405970612472],
            [29.912801751705523, -0.711486994201053],
            [29.91391789946287, -0.712196109080894],
            [29.9145158711166, -0.713471201276581],
            [29.91644435370728, -0.714401256392659],
            [29.91745012546569, -0.715478451978202],
            [29.91830955717275, -0.715249790171713],
            [29.919957429424873, -0.715876627011343],
            [29.919828961356103, -0.71777170115692],
            [29.920549057176068, -0.718864895482322],
            [29.920581319271157, -0.721344848389413],
            [29.92166736268674, -0.722966226292841],
            [29.92185457877846, -0.724589467472443],
            [29.922701451139535, -0.725348288205165],
            [29.922794885810536, -0.726314352363381],
            [29.92460638170011, -0.727837578396212],
            [29.926465295161936, -0.728762961511939],
            [29.927721192031406, -0.733793131740475],
            [29.92817385400141, -0.733398641971296],
            [29.929026100084485, -0.733035438826397],
            [29.932907481475322, -0.734167082283889],
            [29.93482586790052, -0.736026980825924],
            [29.936152013025215, -0.736738706646768],
            [29.940881546876376, -0.735519541907388],
            [29.94268561459685, -0.733960940337288],
            [29.943097487663053, -0.734963359863032],
            [29.945808428019028, -0.735274379522379],
            [29.946496710901513, -0.73583556742622],
            [29.946566782188643, -0.737048798299389],
            [29.947103068328417, -0.73773221949059],
            [29.948355837264092, -0.742183126278538],
            [29.950148102020037, -0.744643061604566],
            [29.950818144610697, -0.74276684296028],
            [29.952570292402697, -0.741360915106253],
            [29.95366462906495, -0.738204013270532],
            [29.957572084955203, -0.736730850630787],
            [29.960617674703993, -0.731919302332687],
            [29.959049302456194, -0.728073161428604],
            [29.95931731571952, -0.725915289880419],
            [29.96018637197651, -0.723410433865094],
            [29.96017429772079, -0.720007707666252],
            [29.958391555106846, -0.71544945123214],
            [29.959617655756656, -0.714162526996957],
            [29.960290397784725, -0.712519996774616],
            [29.96105671641764, -0.71170224628031],
            [29.96129271552087, -0.710625745053758],
            [29.96084866390288, -0.702939336432714],
            [29.959635384008806, -0.702507881105447],
            [29.95981338248741, -0.701258351832159],
            [29.96054743094036, -0.700663494241506],
            [29.966392371438772, -0.699721564225597],
            [29.966985702395725, -0.699866504670149],
            [29.96729552954057, -0.700579665235357],
            [29.96893198240883, -0.70045488689104],
            [29.970802583850794, -0.698931661674464],
            [29.972875366418855, -0.6950658978872],
            [29.972023388033715, -0.692879643302504],
            [29.97202469777739, -0.690806308513257],
            [29.971196879581854, -0.686843650077046],
            [29.96570909217241, -0.677877922621394],
            [29.9632412368306, -0.675151319771365],
            [29.960890119356634, -0.671761604910771],
            [29.959279327762793, -0.668357009016816],
            [29.957742490873034, -0.667035782954134],
            [29.957841586726946, -0.666031241592557],
            [29.95712923348643, -0.665357852416683],
            [29.958693638773948, -0.663521106225685],
            [29.958371702339058, -0.662025160127292],
            [29.959714168954147, -0.661644120206292],
            [29.959576087115206, -0.660719766820025],
            [29.95904201981416, -0.660160524557081],
            [29.95914204003455, -0.659320584485196],
            [29.957926958119973, -0.658873452485509],
            [29.957841903832257, -0.657749231218653],
            [29.956873408564864, -0.657855825471341],
            [29.95637462259662, -0.657284724108856],
            [29.955435992719195, -0.657722296111407],
            [29.953660102454243, -0.657272572499304],
            [29.953348278354483, -0.656655803720701],
            [29.95365629988563, -0.655731466476072],
            [29.953201527773043, -0.655011666580168],
            [29.95081737924607, -0.655528747955464],
            [29.948964430597698, -0.65472315194698],
            [29.948282170020885, -0.65493630914009],
            [29.947078958444518, -0.653851974979451],
            [29.946582500011157, -0.652692305567292],
            [29.945815850798244, -0.65267977937342],
            [29.945160462424838, -0.653571741309399],
            [29.942343649324375, -0.651590057877455],
            [29.941784593587112, -0.651805530910432],
            [29.9400239171898, -0.651264924692818],
            [29.939016863535493, -0.649642803877688],
            [29.937987600832408, -0.650739567233917],
            [29.937559480835976, -0.649667949699252],
            [29.937789868163637, -0.648511950503952],
            [29.935477688165623, -0.648379517668539],
            [29.93488076933743, -0.647901285211517],
            [29.93508024383954, -0.647223138215894],
            [29.936206206589674, -0.646453063395759],
            [29.931674173641962, -0.645456042610424],
            [29.930486844279777, -0.646426474057477],
            [29.930497133583064, -0.645289578280927],
            [29.9276586261685, -0.644902403782254],
            [29.926624635632095, -0.643876818969152],
            [29.92579474681978, -0.644075794015763],
            [29.925298181486934, -0.64605155547997],
            [29.923050366677348, -0.646068890964532],
            [29.922071453647614, -0.646953469488602],
            [29.920764987915838, -0.646778133113418],
            [29.919622295840163, -0.645049594194931],
            [29.919824328744166, -0.643264181441999],
            [29.919194805562725, -0.642345087579822],
            [29.917839103170238, -0.641671039497945],
            [29.91521984666878, -0.641563483766697],
            [29.914124177804933, -0.640964398895115],
            [29.913208277100832, -0.637053064803536],
            [29.91051024284052, -0.633895376279518],
            [29.909578440159233, -0.631617566395151],
            [29.908764653648394, -0.631340414336263],
            [29.90830965785533, -0.630569575410457],
            [29.906387323334425, -0.63106026656283],
            [29.906812062970445, -0.629016535111239],
            [29.90510341879101, -0.62834229845221],
            [29.905296136165553, -0.62704584139971],
            [29.90571123238697, -0.626665843540656],
            [29.904740920726077, -0.626421749940379],
            [29.904829695835737, -0.625475122262165],
            [29.90418085707907, -0.624560712373373],
            [29.902771277329062, -0.624407571290486],
            [29.902753366718933, -0.62354670572099],
            [29.901998084787625, -0.622992110594858],
            [29.901992393061985, -0.622131883458524],
            [29.89988030291206, -0.623115530020641],
            [29.899304522340795, -0.62296558760735],
            [29.898908673422657, -0.62219863512825],
            [29.898264743958993, -0.622110986283673],
            [29.89571816475728, -0.624889608268096],
            [29.895861425383856, -0.623449762580863],
            [29.895329427801226, -0.622551830062869],
            [29.89553453923173, -0.621224224330056],
            [29.89208004355215, -0.620037833243845],
            [29.89247775467787, -0.617594558179982],
            [29.8927510275772, -0.616933790414555],
            [29.893216003653112, -0.617033678180764],
            [29.890441950360195, -0.615193493191714],
            [29.888169221674506, -0.615616036326705],
            [29.88744598175107, -0.613483785774705],
            [29.885359857404413, -0.612651361960778],
            [29.88426153222231, -0.61125423978931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2043,
        District: "RUKUNGIRI",
        County: "RUJUMBURA",
        Subcounty: "RUHINDA",
        Population: 25803,
        Key: "RUKUNGIRIRUHINDA",
        Dist2: "Rukungiri",
        "Sub Country": "Ruhinda",
        id2_original: "Rukungiri Ruhinda",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.70818172313524, 0.589816394738914],
            [31.70508172692127, 0.591639683818136],
            [31.698220440595247, 0.593320146031491],
            [31.69725823173824, 0.594033529071671],
            [31.695915610612918, 0.597524807957441],
            [31.695737695677643, 0.600455669998488],
            [31.694395276673234, 0.603065122988787],
            [31.690921014464124, 0.608055915387361],
            [31.687358045417334, 0.609760478376589],
            [31.686784455837067, 0.612664047243982],
            [31.685315486667054, 0.614974166882494],
            [31.68442956813384, 0.615410521733927],
            [31.682821103176586, 0.615020235226207],
            [31.678887875519138, 0.616502618666979],
            [31.678098129721956, 0.616167758680527],
            [31.676267707227666, 0.616293927849308],
            [31.67444532196025, 0.615723640200365],
            [31.674659789344414, 0.622661138697511],
            [31.67560522485845, 0.625790917850944],
            [31.675377490255848, 0.626993832957525],
            [31.67397160258168, 0.629336103182886],
            [31.662832081630192, 0.62584191037106],
            [31.66130065619172, 0.625009387892392],
            [31.659332513879548, 0.622403963517681],
            [31.657599212742188, 0.621571391989014],
            [31.656983871264153, 0.619997431184684],
            [31.65299181204043, 0.619969270649232],
            [31.65235257447754, 0.618512889294324],
            [31.65166424667926, 0.617988113278201],
            [31.650616679005662, 0.619082267602099],
            [31.650305808018416, 0.620393685383753],
            [31.651111243790368, 0.621922467964734],
            [31.650513148169146, 0.624292055701966],
            [31.651532546472097, 0.625766626159629],
            [31.65107570643773, 0.629113090997864],
            [31.650120956292522, 0.631717748511911],
            [31.649132570528128, 0.633010897006948],
            [31.646800838697953, 0.634755929343546],
            [31.646062079479663, 0.635976781526985],
            [31.64589385197639, 0.637215874382033],
            [31.643084209228565, 0.637477880569723],
            [31.6406654144777, 0.638545504311076],
            [31.639085952527697, 0.638644455678079],
            [31.63812329451304, 0.639364656723816],
            [31.635556779898543, 0.639115533468543],
            [31.633187221808388, 0.640655186673567],
            [31.62928805557159, 0.640455386891842],
            [31.627042025714474, 0.641498197406178],
            [31.612999102154003, 0.644674292857835],
            [31.605285943444063, 0.648907907890749],
            [31.60064599857619, 0.650409615741711],
            [31.597709365488218, 0.650098253666136],
            [31.596031454471284, 0.64932765020953],
            [31.592342114023616, 0.64911544762679],
            [31.59074262593099, 0.649533568573439],
            [31.589375291253887, 0.648352509752213],
            [31.58917026516331, 0.64656162507288],
            [31.58673746208391, 0.646343871139113],
            [31.5852009800287, 0.644733505154373],
            [31.58391137028493, 0.644877856177167],
            [31.582165107356346, 0.644461314883482],
            [31.57890529636176, 0.644804088503274],
            [31.57721648159392, 0.642768591449967],
            [31.57588598413166, 0.642560191821112],
            [31.574247973584704, 0.641601010331472],
            [31.572489557348657, 0.641501025125461],
            [31.569997042353993, 0.640017022029422],
            [31.56662283539956, 0.639871357614265],
            [31.565851105315392, 0.639527449162186],
            [31.563928827388338, 0.638070743604095],
            [31.563241523669518, 0.637021390367863],
            [31.56324723875135, 0.633629711295691],
            [31.564342974090522, 0.631929655389001],
            [31.565365332342342, 0.6315952949193],
            [31.56750220880758, 0.632726453841868],
            [31.57042463593766, 0.632962425974043],
            [31.57154189760597, 0.632628089823864],
            [31.57208956899366, 0.63198608232601],
            [31.57334306825968, 0.62832339903516],
            [31.576916405661464, 0.623051421049861],
            [31.577764859057428, 0.620003643569438],
            [31.577606697176932, 0.615083371474687],
            [31.57562890875523, 0.611130379040602],
            [31.57499536920616, 0.606309475644687],
            [31.573194169806385, 0.603441882484644],
            [31.57233225605421, 0.600086137744752],
            [31.571815471440928, 0.596450106619665],
            [31.57205686941901, 0.58684489300001],
            [31.573739369030424, 0.585108779307075],
            [31.576855819685424, 0.583011247543692],
            [31.579594777596842, 0.579258459890415],
            [31.580047923758745, 0.578164184438538],
            [31.58023151424998, 0.574899148854404],
            [31.58087472595973, 0.573850142689642],
            [31.585492522864264, 0.569030544512765],
            [31.587386113092684, 0.566272417175546],
            [31.58959960327528, 0.564201752989579],
            [31.594641431943383, 0.554281054624228],
            [31.599581105993998, 0.548783105983327],
            [31.603012318239745, 0.542841590414973],
            [31.60823591831063, 0.538148630984014],
            [31.608716526869102, 0.534711770749673],
            [31.60811813929542, 0.53007172347135],
            [31.60921636386625, 0.52688825198751],
            [31.60954048410558, 0.523348358421202],
            [31.611193077004554, 0.52384614533776],
            [31.621418209116523, 0.523572934157615],
            [31.626907387118003, 0.52027924511492],
            [31.629707211279786, 0.52209913502424],
            [31.637358741967986, 0.529689380006702],
            [31.63985103238385, 0.531390354209089],
            [31.64158493179914, 0.532005785069577],
            [31.652525345659495, 0.533681504493533],
            [31.660310690290732, 0.535727363494255],
            [31.66322294489851, 0.535348121229534],
            [31.664719636976546, 0.535827834767572],
            [31.666904809566436, 0.534914782057894],
            [31.668433321768426, 0.53496938556907],
            [31.670327981890388, 0.533649248289233],
            [31.671284906856897, 0.533423334485365],
            [31.676630303208952, 0.53326169324657],
            [31.68140813947295, 0.528441775675776],
            [31.682309809964625, 0.523964731472287],
            [31.68215856601015, 0.520844195635122],
            [31.686490570195232, 0.5170643172267],
            [31.68771853574759, 0.516377156437567],
            [31.69669264524884, 0.516451386604211],
            [31.702000736363797, 0.513530951334184],
            [31.70458209743499, 0.507010020400904],
            [31.705567172009246, 0.502225401478074],
            [31.70603306257011, 0.497522085199314],
            [31.706323100727566, 0.497522142689328],
            [31.705990351271613, 0.496255771476091],
            [31.706229650785183, 0.495390472035263],
            [31.706940538873496, 0.497321567225192],
            [31.709055760550505, 0.500208882098011],
            [31.71491258396348, 0.505015683738679],
            [31.718216493255387, 0.509716368040378],
            [31.719893717061105, 0.516863564508982],
            [31.721492981473222, 0.521041687476849],
            [31.72605931569177, 0.524433171609002],
            [31.729212732919024, 0.528418714208343],
            [31.734214183213435, 0.529719213578896],
            [31.732540590398088, 0.535887637492067],
            [31.72887944896547, 0.54286969115068],
            [31.730528144074402, 0.545507993305271],
            [31.73204500872046, 0.546669312199399],
            [31.732958097697743, 0.548044365335181],
            [31.735700358714418, 0.549971563792246],
            [31.73761292046334, 0.550541816781655],
            [31.737757075811928, 0.551328774656489],
            [31.73877074825325, 0.552414408384154],
            [31.73561241544474, 0.552902166400552],
            [31.73425913580856, 0.553815431972367],
            [31.73370699620064, 0.554394201121591],
            [31.73364111016446, 0.556565015424174],
            [31.729746519945703, 0.55990181265885],
            [31.72937233390064, 0.564632321562467],
            [31.72885383170854, 0.565455310817055],
            [31.728270519661944, 0.568261939793817],
            [31.723921611878136, 0.572961014087995],
            [31.72305461725472, 0.574945408864239],
            [31.722185049856314, 0.580405347656126],
            [31.720019960002936, 0.581589756784038],
            [31.715646115885168, 0.585830882889986],
            [31.70818172313524, 0.589816394738914],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 54,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "KALWANA",
        Population: 33140,
        Key: "MUBENDEKALWANA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.789211476646713, 0.777556986510407],
            [31.787320260665584, 0.777191366318783],
            [31.786939710955014, 0.777426433794601],
            [31.78673017622004, 0.78056509084251],
            [31.783959055028248, 0.787040708345215],
            [31.780919532500885, 0.791390590432971],
            [31.776324456684836, 0.795441500626122],
            [31.774845270076735, 0.798064182126545],
            [31.77420232965821, 0.798706201420509],
            [31.772265602329835, 0.79888652248459],
            [31.76883916013825, 0.801201067564433],
            [31.765081901665198, 0.802692387153623],
            [31.762159623655474, 0.802709584610207],
            [31.759334792192817, 0.801777063964675],
            [31.756246923235167, 0.801559032747808],
            [31.751473601903818, 0.803538459535582],
            [31.747552834777675, 0.803528201783865],
            [31.744494326356794, 0.802830776106905],
            [31.742732332130974, 0.801898579749053],
            [31.73879407211129, 0.801291331338806],
            [31.73687734487443, 0.80042240309042],
            [31.7346834882707, 0.79859460647013],
            [31.73154246599769, 0.797842883856481],
            [31.72750699838283, 0.797470776643234],
            [31.723514017487652, 0.797749925321686],
            [31.722056967164797, 0.79869015547542],
            [31.719552802817535, 0.797025076648411],
            [31.716651103414318, 0.79605634352511],
            [31.711619750000725, 0.795493966165049],
            [31.705944622532066, 0.79380979867938],
            [31.70090629459861, 0.794079553028343],
            [31.698952907115007, 0.794730171687969],
            [31.69847109661068, 0.795535022402417],
            [31.69858338332624, 0.801857505610704],
            [31.69746416422892, 0.803575693736916],
            [31.694769286648505, 0.804841121036824],
            [31.694334350235728, 0.80569120804573],
            [31.689317220746343, 0.809045258853796],
            [31.686374356943563, 0.808718679235538],
            [31.684762003179443, 0.809758319776954],
            [31.683802231451796, 0.808111827060337],
            [31.68306717778406, 0.807939732356884],
            [31.68120716478432, 0.81158422871278],
            [31.678639179627705, 0.814658652879128],
            [31.67555133941616, 0.814630494439754],
            [31.672648063469605, 0.815217447272658],
            [31.670798446672666, 0.816238903390755],
            [31.669255476086125, 0.818888538844562],
            [31.666517831511698, 0.819584074586642],
            [31.664960338760284, 0.821139267227542],
            [31.664082923679565, 0.820985208501383],
            [31.662765105937567, 0.81952854102755],
            [31.66002318358573, 0.817908588523608],
            [31.656509674880194, 0.816243151990893],
            [31.654620397463443, 0.815817407205005],
            [31.65454183080866, 0.813122022240084],
            [31.655670802016708, 0.811657139445259],
            [31.656541175203948, 0.808464604382849],
            [31.65829459501037, 0.806194935215243],
            [31.658636392297893, 0.805100623200919],
            [31.65858258051743, 0.803083605470045],
            [31.656903454978217, 0.797981760711308],
            [31.6567180849244, 0.794680334357028],
            [31.653607373605723, 0.791721653596064],
            [31.651544818357213, 0.787080985002135],
            [31.644906793922008, 0.782710176812425],
            [31.641844300574498, 0.778295322834592],
            [31.637506013572306, 0.774504152512327],
            [31.638243375012017, 0.767377115115964],
            [31.635948698687343, 0.760674210265875],
            [31.635263152971515, 0.760285066517099],
            [31.634548482077555, 0.760547135902308],
            [31.6340431186448, 0.761297688484992],
            [31.63042030203715, 0.762743685601094],
            [31.622996727835467, 0.762786515274837],
            [31.62203349400071, 0.761519945297214],
            [31.62073081646449, 0.761076333490265],
            [31.61989650704266, 0.761428807582984],
            [31.61981615004557, 0.762477965919386],
            [31.6192220079099, 0.762513952835973],
            [31.614963508372906, 0.760504651128976],
            [31.61400098869881, 0.760531473358633],
            [31.612563837856154, 0.759165261352738],
            [31.61257230088444, 0.758161305970446],
            [31.61062950723294, 0.757554684508335],
            [31.609168664222967, 0.754768456465738],
            [31.608987625845455, 0.753692083256187],
            [31.605265379210575, 0.750091112948456],
            [31.598514074523088, 0.749283963119462],
            [31.59401570234738, 0.750340724383767],
            [31.593044024348934, 0.750069071078627],
            [31.591844136539127, 0.748730081398366],
            [31.589013331279812, 0.747064958732568],
            [31.587621949600873, 0.745753044658157],
            [31.586965518283407, 0.74040748974146],
            [31.584712230038804, 0.737991864974539],
            [31.584429034348872, 0.736770758580975],
            [31.58336193999589, 0.735486088707773],
            [31.582154966275112, 0.732591444187422],
            [31.582027554625096, 0.730619691501364],
            [31.582795474055832, 0.726133836933675],
            [31.58214726950975, 0.723112750509189],
            [31.582649294802888, 0.721294953624592],
            [31.58583936868367, 0.717886154609027],
            [31.59159531488353, 0.714830879089829],
            [31.600094104208353, 0.712843688628023],
            [31.601091932164703, 0.712988708607172],
            [31.6023996510463, 0.712491655322349],
            [31.603257237613747, 0.71122566927433],
            [31.604243658762627, 0.711026988915432],
            [31.606103118400153, 0.707662948206253],
            [31.606653914128376, 0.705130613824143],
            [31.606398325463744, 0.701639302386992],
            [31.60598663565389, 0.699052409618657],
            [31.605276103298426, 0.697740722413049],
            [31.60342514711338, 0.696157356751867],
            [31.600694761824766, 0.694745576827724],
            [31.59605884410432, 0.695938074410111],
            [31.594749799309337, 0.697158702148368],
            [31.592314772001288, 0.696778093462751],
            [31.59171997409548, 0.697184921132083],
            [31.58953355015243, 0.697356106686852],
            [31.587464905224568, 0.698015732913987],
            [31.584162638053023, 0.697444921929231],
            [31.581643805115494, 0.697561734683994],
            [31.581256714771353, 0.694441247278892],
            [31.580142828073566, 0.692794801830575],
            [31.578961446456898, 0.688688221086833],
            [31.577786136553243, 0.685875016803375],
            [31.57850379524382, 0.682990023508351],
            [31.57852578240874, 0.676957322499181],
            [31.57774602497918, 0.674279908369299],
            [31.577752139811324, 0.670625917674132],
            [31.577103875976427, 0.667604852239791],
            [31.576416939668555, 0.666266060607433],
            [31.57703698742035, 0.664909561314516],
            [31.57713627281882, 0.662349987205163],
            [31.578159986628396, 0.661255895110597],
            [31.577711254787793, 0.659510169454192],
            [31.577797388850485, 0.657755554043259],
            [31.57713430730497, 0.656443905057902],
            [31.576923730524292, 0.654463091374163],
            [31.575406840725417, 0.652120123911375],
            [31.575172726287633, 0.649967459293883],
            [31.57397544628707, 0.648284835909593],
            [31.575141466712367, 0.647308358643634],
            [31.577851302140587, 0.646784544879354],
            [31.578946320624134, 0.645690465560466],
            [31.57890529636176, 0.644804088503274],
            [31.582165107356346, 0.644461314883482],
            [31.58391137028493, 0.644877856177167],
            [31.5852009800287, 0.644733505154373],
            [31.58673746208391, 0.646343871139113],
            [31.58917026516331, 0.64656162507288],
            [31.589375291253887, 0.648352509752213],
            [31.59074262593099, 0.649533568573439],
            [31.592342114023616, 0.64911544762679],
            [31.596031454471284, 0.64932765020953],
            [31.597709365488218, 0.650098253666136],
            [31.60064599857619, 0.650409615741711],
            [31.605285943444063, 0.648907907890749],
            [31.612999102154003, 0.644674292857835],
            [31.627042025714474, 0.641498197406178],
            [31.62928805557159, 0.640455386891842],
            [31.633187221808388, 0.640655186673567],
            [31.635556779898543, 0.639115533468543],
            [31.63812329451304, 0.639364656723816],
            [31.639085952527697, 0.638644455678079],
            [31.6406654144777, 0.638545504311076],
            [31.643084209228565, 0.637477880569723],
            [31.64589385197639, 0.637215874382033],
            [31.646062079479663, 0.635976781526985],
            [31.646800838697953, 0.634755929343546],
            [31.649132570528128, 0.633010897006948],
            [31.650120956292522, 0.631717748511911],
            [31.65107570643773, 0.629113090997864],
            [31.651532546472097, 0.625766626159629],
            [31.650513148169146, 0.624292055701966],
            [31.651111243790368, 0.621922467964734],
            [31.650305808018416, 0.620393685383753],
            [31.650616679005662, 0.619082267602099],
            [31.65166424667926, 0.617988113278201],
            [31.65235257447754, 0.618512889294324],
            [31.65299181204043, 0.619969270649232],
            [31.656983871264153, 0.619997431184684],
            [31.657599212742188, 0.621571391989014],
            [31.659332513879548, 0.622403963517681],
            [31.66130065619172, 0.625009387892392],
            [31.662832081630192, 0.62584191037106],
            [31.67397160258168, 0.629336103182886],
            [31.675377490255848, 0.626993832957525],
            [31.67560522485845, 0.625790917850944],
            [31.674659789344414, 0.622661138697511],
            [31.67444532196025, 0.615723640200365],
            [31.676267707227666, 0.616293927849308],
            [31.678098129721956, 0.616167758680527],
            [31.678887875519138, 0.616502618666979],
            [31.682821103176586, 0.615020235226207],
            [31.68442956813384, 0.615410521733927],
            [31.685315486667054, 0.614974166882494],
            [31.686784455837067, 0.612664047243982],
            [31.687358045417334, 0.609760478376589],
            [31.690921014464124, 0.608055915387361],
            [31.694395276673234, 0.603065122988787],
            [31.695737695677643, 0.600455669998488],
            [31.695915610612918, 0.597524807957441],
            [31.69725823173824, 0.594033529071671],
            [31.698220440595247, 0.593320146031491],
            [31.70508172692127, 0.591639683818136],
            [31.70818172313524, 0.589816394738914],
            [31.710577516523255, 0.598636162839537],
            [31.711973985361688, 0.601174883654349],
            [31.71588081512616, 0.603398517820997],
            [31.718790581400615, 0.604346539030355],
            [31.71898811733836, 0.606042838252263],
            [31.726349746412993, 0.603037124052298],
            [31.730210851929538, 0.600369730199194],
            [31.73650160923547, 0.595097892727867],
            [31.74174213985452, 0.588966494210912],
            [31.74424160780949, 0.586778136404366],
            [31.7470907153444, 0.586814962704649],
            [31.74821482397179, 0.586236326166023],
            [31.750719812074184, 0.58699668774207],
            [31.754756706213712, 0.585496096477695],
            [31.75650374169343, 0.585541714139001],
            [31.75938168335231, 0.584755425641801],
            [31.763231136821304, 0.585289953761327],
            [31.76915132110623, 0.589985752329442],
            [31.772716438024844, 0.590140318141712],
            [31.775328963449912, 0.591045426908741],
            [31.777390116428283, 0.594085097681865],
            [31.782880238559148, 0.599739629822056],
            [31.78955714387646, 0.600898927399941],
            [31.791316315595665, 0.600781731547457],
            [31.795352514439166, 0.597643903713104],
            [31.799261892724136, 0.592760283055586],
            [31.801203107137347, 0.590933547691982],
            [31.80284535863077, 0.590047460622492],
            [31.80629266958472, 0.589822076281999],
            [31.809973204745976, 0.591469132480584],
            [31.812689619435336, 0.593902930928744],
            [31.814803865541926, 0.594428022774136],
            [31.816299139180114, 0.595477613458963],
            [31.81784000411562, 0.597350346647784],
            [31.81921219149188, 0.600163767689735],
            [31.82146687302351, 0.607038777837216],
            [31.823103553165495, 0.60861304158056],
            [31.824431723991175, 0.608689847695051],
            [31.823036579269502, 0.613135739983931],
            [31.824595699768185, 0.617532162130051],
            [31.824933688198914, 0.620481045914526],
            [31.824144466119503, 0.62260654770798],
            [31.8232873700322, 0.62310384901949],
            [31.817987460772876, 0.622786061822019],
            [31.81413543812218, 0.623237456531883],
            [31.80984585058817, 0.622856570015983],
            [31.808394285378423, 0.623498460064076],
            [31.80770308117464, 0.624285248672815],
            [31.807367822724093, 0.625479160847024],
            [31.807553543120882, 0.627442049256803],
            [31.8085901603312, 0.631449393125701],
            [31.808492754208295, 0.632552902722498],
            [31.806543465737306, 0.635194241656551],
            [31.803383811507, 0.637047258452451],
            [31.802831807544685, 0.639335601626671],
            [31.80083653431431, 0.643957307426924],
            [31.798045873866748, 0.648135586783833],
            [31.797781639815817, 0.6493476005107],
            [31.798085806676053, 0.651428099407903],
            [31.795832867876094, 0.654349199611735],
            [31.796042447526855, 0.656257817782649],
            [31.7954187553099, 0.658790354832531],
            [31.7939268072349, 0.661503589047068],
            [31.79392176049964, 0.663792053176125],
            [31.793135648387782, 0.664488348963103],
            [31.784443546105372, 0.664720310702788],
            [31.777600536003796, 0.666006714750869],
            [31.77420178887242, 0.662507893291359],
            [31.771856221190255, 0.663312199044773],
            [31.77025672591112, 0.664867918222023],
            [31.769691374780326, 0.666746203689545],
            [31.758526471930484, 0.668508326216625],
            [31.747356806213, 0.669347990759287],
            [31.749497645146967, 0.670711559880755],
            [31.75245712778251, 0.673434687180848],
            [31.754301557707038, 0.676537070518458],
            [31.755477050867004, 0.677273467875185],
            [31.758642873828375, 0.688063096261241],
            [31.760677823848216, 0.691882655307452],
            [31.755845464338055, 0.69410408310321],
            [31.75300686439706, 0.69315074131162],
            [31.74575331971906, 0.693488228026773],
            [31.745742811226883, 0.696167143174479],
            [31.744071104873594, 0.699344243336532],
            [31.74613480637244, 0.704799845039254],
            [31.749246148308444, 0.705677149640324],
            [31.752998844238203, 0.707421171609005],
            [31.755519729826172, 0.707729464277091],
            [31.76885111312143, 0.704849224388906],
            [31.76881260324352, 0.706041201112041],
            [31.769347153838172, 0.706810367328603],
            [31.773548366911157, 0.708426439031937],
            [31.776068527558703, 0.711580118060182],
            [31.776138413792857, 0.715525174204368],
            [31.77699360275682, 0.72167096847065],
            [31.77784982657998, 0.72393535576616],
            [31.77945589213712, 0.725768684014584],
            [31.782025982944763, 0.727278824628646],
            [31.793407071655917, 0.730772539094621],
            [31.793880870086227, 0.731460112920162],
            [31.793902411686727, 0.746650627146137],
            [31.794095596185226, 0.747325669877941],
            [31.792291532956305, 0.750156353792507],
            [31.789186848434888, 0.75688519446266],
            [31.789710342565026, 0.761606993341366],
            [31.78970559137548, 0.763533642495312],
            [31.788821279030014, 0.765803762407576],
            [31.789211476646713, 0.777556986510407],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 55,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "KITUMBI",
        Population: 58711,
        Key: "MUBENDEKITUMBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.11730394490841, 0.433853041514573],
            [32.11474997975843, 0.438112048362609],
            [32.110155076418884, 0.441537658392124],
            [32.10555401782304, 0.44240104215161],
            [32.102867395760114, 0.44240071337804],
            [32.10108412044519, 0.44342969829861],
            [32.09839743460188, 0.444051678537255],
            [32.09653090881635, 0.445331953952669],
            [32.09291694061424, 0.446360704011745],
            [32.089921090582735, 0.44770067384737],
            [32.08968330383208, 0.447916062612492],
            [32.090657633657216, 0.45160213909878],
            [32.09031355015732, 0.452534131060099],
            [32.084486172621034, 0.452341309204653],
            [32.084036433768986, 0.452987928704745],
            [32.08387555089148, 0.45528361089366],
            [32.081272926697515, 0.459188922114218],
            [32.07938765756355, 0.455502063490731],
            [32.078698222142556, 0.45514294814295],
            [32.076368735202294, 0.451337034725675],
            [32.074823526014086, 0.449972559372834],
            [32.07384875242118, 0.449900625401257],
            [32.05999962960349, 0.450700638488618],
            [32.054816500432764, 0.451896692016257],
            [32.049241285386614, 0.45166857104339],
            [32.04729165914909, 0.452218806172903],
            [32.040099709255195, 0.452397356941568],
            [32.02777215286574, 0.454274538173291],
            [32.02710638625584, 0.454801009821011],
            [32.02567989661897, 0.454824741664786],
            [32.024705060143994, 0.455303298648139],
            [32.02197098996605, 0.455039647838829],
            [32.02090118898915, 0.454489011389399],
            [32.01828661001535, 0.449653925981321],
            [32.014376434026424, 0.443897207082052],
            [32.00830295044163, 0.436656281929798],
            [32.00435682656998, 0.433089560950216],
            [31.99736266234543, 0.427926946816575],
            [31.99208512742488, 0.424695150311947],
            [31.988899474153648, 0.423665559194029],
            [31.984251590873594, 0.423461498080342],
            [31.979211270476874, 0.424513929162912],
            [31.977000133880352, 0.425375258676123],
            [31.96926083599223, 0.430795240878791],
            [31.966782834179305, 0.431833689075634],
            [31.964101694534573, 0.431608284813531],
            [31.961272698482244, 0.430459074743272],
            [31.958305598133077, 0.428090046676878],
            [31.948120023334628, 0.415559316590446],
            [31.9438059189799, 0.408773519705544],
            [31.941940161253918, 0.404836169212399],
            [31.940086422088104, 0.399953455584828],
            [31.93891030370069, 0.394484448634992],
            [31.939515994577643, 0.382912968691804],
            [31.953796306935086, 0.382324821552141],
            [31.965905488268863, 0.38112119561585],
            [31.969115116676736, 0.38016422888586],
            [31.97419725364997, 0.380237271090076],
            [31.97674952727225, 0.381094085958637],
            [31.979575177998452, 0.380510364596348],
            [31.98233071072515, 0.384736000263855],
            [31.986015388916517, 0.387632465864304],
            [31.987584257932674, 0.389667049275233],
            [31.99066280417429, 0.391618052198604],
            [31.99227916891615, 0.394059524125468],
            [31.995179325912012, 0.396764440642638],
            [31.995821018570606, 0.398607440969355],
            [32.00029529972706, 0.402190019893583],
            [32.00172141027488, 0.405086229686956],
            [32.003753225174385, 0.412398374939806],
            [32.00589273999163, 0.414026179614207],
            [32.0072475296958, 0.416898453746827],
            [32.00952709905235, 0.420216952960366],
            [32.01037337313545, 0.421003570288799],
            [32.01474764754623, 0.423086412277365],
            [32.02184422959463, 0.424487480791928],
            [32.0246496188196, 0.424703244808583],
            [32.02743132126714, 0.424296716198121],
            [32.02819224282182, 0.423243704790174],
            [32.02885794385471, 0.42317199154242],
            [32.031258976217465, 0.424991300549968],
            [32.03180543847276, 0.427839567430572],
            [32.03374268682401, 0.431011121495825],
            [32.03602518289177, 0.430125837018219],
            [32.04246113669369, 0.426375144000607],
            [32.04204085449813, 0.425100374583569],
            [32.03795188322494, 0.422634606130386],
            [32.03712014388314, 0.419546967886564],
            [32.03548828050769, 0.417925374239254],
            [32.031852974622666, 0.418319759181532],
            [32.03022678320992, 0.414901543395805],
            [32.028089860930564, 0.415019253746812],
            [32.02699795510945, 0.414677325285004],
            [32.025990434331185, 0.409570605972204],
            [32.02466342233227, 0.407514795435359],
            [32.02098835072452, 0.404088267610047],
            [32.020943133126394, 0.401911248981661],
            [32.02160320172245, 0.401744793456541],
            [32.02361441735417, 0.3995479803077],
            [32.02407715842164, 0.396643435084488],
            [32.023925739295656, 0.394499729514075],
            [32.026479354102676, 0.395328053548],
            [32.028078185526816, 0.396393816312768],
            [32.031942944491625, 0.397765080527231],
            [32.03486001317102, 0.399309109705229],
            [32.037153675297766, 0.398911462125999],
            [32.0382130450376, 0.399097951450083],
            [32.038915959679414, 0.399275508139707],
            [32.04094743052419, 0.401143147190074],
            [32.0419963896882, 0.400688589225048],
            [32.04442142593366, 0.402661904052459],
            [32.04397388256415, 0.404747717008865],
            [32.044242181491754, 0.405424809722834],
            [32.04555424372775, 0.405012381931122],
            [32.04637517274342, 0.402740406784407],
            [32.0488606251833, 0.399386712379307],
            [32.04874955298998, 0.398821947177063],
            [32.049523251282956, 0.39786422070385],
            [32.04987424911561, 0.395704780934053],
            [32.049808478962085, 0.394386486979677],
            [32.048645495740736, 0.392578491342199],
            [32.0460065508632, 0.390900018584545],
            [32.04719249502319, 0.388086322075881],
            [32.047026187219686, 0.387033188279423],
            [32.04854955746502, 0.385980083097626],
            [32.04980450751022, 0.385856185772571],
            [32.05785055491499, 0.387251935633867],
            [32.057988444514464, 0.3863876260098],
            [32.06542616269034, 0.386391154511995],
            [32.066052117763455, 0.386121170191838],
            [32.067750687336975, 0.384005013548851],
            [32.06888414383322, 0.383684696778147],
            [32.07165706524887, 0.386317916531977],
            [32.07103188721848, 0.392272883565944],
            [32.07344403713118, 0.392467420857113],
            [32.072753875871435, 0.395502595644368],
            [32.07383110232251, 0.397836517328356],
            [32.073961574532674, 0.399019868186288],
            [32.073259109946804, 0.403112155490771],
            [32.074733182445954, 0.405662787243193],
            [32.07355665891836, 0.407763596420877],
            [32.07619564332177, 0.408194730114795],
            [32.07888200666989, 0.410085880810361],
            [32.083196969814075, 0.412037065714044],
            [32.08857022202479, 0.41136751741434],
            [32.090589687784096, 0.411923764136268],
            [32.092944341027035, 0.415939571524152],
            [32.093169847807744, 0.41901522259549],
            [32.09357394505686, 0.419709379832309],
            [32.095951432575994, 0.420044740668775],
            [32.09740160000715, 0.421074112185067],
            [32.10046859032093, 0.421265944926028],
            [32.10213248761945, 0.424497349412789],
            [32.10302339270077, 0.430181986429248],
            [32.10463985356236, 0.432384187076994],
            [32.10649416315837, 0.433844433206013],
            [32.10971566549767, 0.434311552730907],
            [32.11092832106262, 0.433426100657849],
            [32.11316322348833, 0.433234893430032],
            [32.11730394490841, 0.433853041514573],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 57,
        District: "MITYANA",
        County: "MITYANA MUNICIPALITY",
        Subcounty: "BUSIMBI DIVISION",
        Population: 42729,
        Key: "MITYANABUSIMBI DIVISION",
        Dist2: "Mityana",
        "Sub Country": "Busimbi",
        id2_original: "Mityana Busimbi",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.288479493329973, -0.620392045156211],
            [30.27961194558098, -0.619764898815024],
            [30.275915177862544, -0.620097363806357],
            [30.272285257377618, -0.622490298199667],
            [30.26536026881985, -0.62450194358732],
            [30.26092716553772, -0.625068954329288],
            [30.25105849032037, -0.62521740916106],
            [30.2497657122186, -0.627313277192761],
            [30.249049286914875, -0.627764741577741],
            [30.247808210450952, -0.628080376239713],
            [30.245354554778864, -0.627319987205745],
            [30.242922368842034, -0.627625953907183],
            [30.23506268053621, -0.634155348974457],
            [30.23357050069586, -0.636666758299445],
            [30.232657581500163, -0.640000813839702],
            [30.232245136207144, -0.646669682824906],
            [30.232672507008605, -0.6505737767711],
            [30.232140705258736, -0.653528487547537],
            [30.232509142984316, -0.65502039493939],
            [30.2346093412365, -0.657867481242095],
            [30.236933900917442, -0.662748615806795],
            [30.23841215687088, -0.6647465666914],
            [30.2350434440127, -0.671052313321611],
            [30.22984327380107, -0.674392936451107],
            [30.225630234407358, -0.675086351832172],
            [30.228666996411842, -0.67842262465048],
            [30.229971045675498, -0.679119199506646],
            [30.233045496497734, -0.687199789414982],
            [30.233761013604695, -0.690073882599362],
            [30.236300580557298, -0.690653714700418],
            [30.23656307726648, -0.690301435401216],
            [30.237108916989282, -0.690419231017953],
            [30.23931209900398, -0.692282088108281],
            [30.23921326635642, -0.697279359414934],
            [30.240039112749955, -0.699023942329491],
            [30.239678179550232, -0.700523831927682],
            [30.24046890540942, -0.702114771040404],
            [30.240038615981593, -0.703000119056194],
            [30.23827732872989, -0.704164815579391],
            [30.238060143941972, -0.705212949861649],
            [30.2393195415461, -0.708855514355151],
            [30.239142641707108, -0.712217084020522],
            [30.240591406868074, -0.716049545490447],
            [30.240975156377672, -0.71866140535407],
            [30.240685111033706, -0.720260738602932],
            [30.238391816317904, -0.724380103986074],
            [30.235785845001196, -0.725978011506996],
            [30.23369527129891, -0.729085359639788],
            [30.233833459139078, -0.729712872743679],
            [30.233030908755836, -0.730066239505438],
            [30.23178823149405, -0.731887259346099],
            [30.223471981631594, -0.737166085212754],
            [30.220572778646577, -0.739650846198744],
            [30.216196924997497, -0.748637986791902],
            [30.215668373352305, -0.758153544307624],
            [30.214657758776198, -0.758969673958422],
            [30.21743538826227, -0.758155058734604],
            [30.222441022909255, -0.757957128693395],
            [30.22409531901399, -0.757210502622231],
            [30.225977745878385, -0.75532304972272],
            [30.229926854851712, -0.75274108580893],
            [30.233664812122598, -0.750918049916463],
            [30.23599050817237, -0.751000858489326],
            [30.23564933431564, -0.750404216354252],
            [30.238241498526463, -0.749429890938886],
            [30.239481248178706, -0.74795768327754],
            [30.24131427578731, -0.7429434297156],
            [30.242767940359872, -0.741444233161121],
            [30.242621865311524, -0.73880540066537],
            [30.24469626754202, -0.736285424562673],
            [30.245457651729076, -0.732119928269451],
            [30.24684388426482, -0.729382626716086],
            [30.247272952882156, -0.728931048752047],
            [30.248579256018896, -0.728931849984412],
            [30.250733205864428, -0.727984301864706],
            [30.251139146456467, -0.728436392820204],
            [30.25327251679716, -0.728591324410598],
            [30.256120869747246, -0.727056795142834],
            [30.262825497074225, -0.719849401078326],
            [30.26684980671497, -0.71127573840852],
            [30.267929900588413, -0.707390478515257],
            [30.27056899638289, -0.703867607049157],
            [30.275159221296448, -0.69398378415694],
            [30.277240941203235, -0.687577718489486],
            [30.277275473341096, -0.683689941894137],
            [30.277395298718528, -0.679218532723222],
            [30.28043984642155, -0.677683950398446],
            [30.28195607056881, -0.676067165784421],
            [30.28577396622187, -0.668023936360526],
            [30.291292511048333, -0.656832292214773],
            [30.292905594244434, -0.652404954941945],
            [30.292851848939325, -0.641225037741331],
            [30.28984762481274, -0.630716432079992],
            [30.288479493329973, -0.620392045156211],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 58,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "BUGONGI TOWN COUNCIL",
        Population: 11547,
        Key: "SHEEMABUGONGI TOWN COUNCIL",
        Dist2: "Sheema",
        "Sub Country": "Bugongi T.C",
        id2_original: "Sheema Bugongi T.C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.469240528586305, -0.498536911366056],
            [30.462000490078594, -0.496772412722373],
            [30.460070106652754, -0.49579983516548],
            [30.457659501842333, -0.495428974185651],
            [30.45684002540251, -0.4948938255352],
            [30.456643331186214, -0.493304560078411],
            [30.45582404698584, -0.492173428929349],
            [30.455702953187235, -0.491256528030934],
            [30.450451607750463, -0.489558340464529],
            [30.44858515293183, -0.488014273527335],
            [30.447811539080494, -0.486623417366285],
            [30.447811945119014, -0.485538486481761],
            [30.44688691214169, -0.483139037343707],
            [30.44544538021539, -0.481845737364946],
            [30.44414086292945, -0.479476719882484],
            [30.443063341830992, -0.478956768928637],
            [30.439027055850907, -0.475349015515655],
            [30.437114680053252, -0.474859322961036],
            [30.435354610917077, -0.472902732532898],
            [30.43324506210108, -0.472107364277818],
            [30.431985034777917, -0.47258064177186],
            [30.430072493690265, -0.472534081877684],
            [30.42825132653834, -0.471815207923524],
            [30.42503326564489, -0.472226563075138],
            [30.41190353257134, -0.472603697147629],
            [30.411160640204436, -0.470265522699734],
            [30.40938540930289, -0.468522937563393],
            [30.40270538952647, -0.464853947093018],
            [30.40053283916463, -0.464612844507139],
            [30.39456357991574, -0.46607671326964],
            [30.39253366405474, -0.46739791334814],
            [30.391195750999838, -0.469897069527626],
            [30.388401434409058, -0.471574034612563],
            [30.387892126473883, -0.472057139378543],
            [30.38774005247608, -0.474542393833491],
            [30.386642938222938, -0.477978300547458],
            [30.382783286180526, -0.487210579050041],
            [30.381378630096645, -0.488433455339306],
            [30.37977897851061, -0.489089436986907],
            [30.37306967096099, -0.490590546916286],
            [30.367035466212016, -0.492726168856548],
            [30.36601407544577, -0.494823391260903],
            [30.365790881826896, -0.496143396448289],
            [30.365655845276745, -0.499725268223088],
            [30.36651455294167, -0.502322114876876],
            [30.36609965345129, -0.503285040341398],
            [30.366859696453613, -0.504578183446579],
            [30.366844337957204, -0.506846645703256],
            [30.36832471662969, -0.511564944831205],
            [30.37124758123928, -0.514096717194203],
            [30.373605136938913, -0.514920126495851],
            [30.374513740627993, -0.516203865878467],
            [30.37663719716122, -0.518012303010716],
            [30.377588376503166, -0.521166890380963],
            [30.37903485545178, -0.52637327228424],
            [30.37903026326402, -0.527936793027452],
            [30.38046825403149, -0.531290450574164],
            [30.381180885749774, -0.534228047219278],
            [30.382831936241363, -0.536912989808732],
            [30.385924867205627, -0.540646952466018],
            [30.388955743448392, -0.54187741163235],
            [30.39175001871664, -0.54498765695923],
            [30.40029007215407, -0.549509833922431],
            [30.402888537148268, -0.547071217217832],
            [30.413698666546313, -0.540785407228264],
            [30.416757050101374, -0.53815663012878],
            [30.419156938908788, -0.537579210423193],
            [30.420639846338766, -0.536585646405516],
            [30.421851839845363, -0.53634212919647],
            [30.424214421619023, -0.53845805011189],
            [30.425668747351615, -0.539407671086911],
            [30.42623943627183, -0.539353683832363],
            [30.428182828201297, -0.537519759839337],
            [30.43144755298051, -0.535993683463472],
            [30.435765519192657, -0.533121343849034],
            [30.43647558172921, -0.532217817858243],
            [30.441402917419396, -0.530095877237256],
            [30.444495928333733, -0.530350228809947],
            [30.445641612697607, -0.531417220765359],
            [30.445548129517594, -0.531887173038374],
            [30.44657257904736, -0.532339512768059],
            [30.44676673552299, -0.533360921345745],
            [30.448210559949914, -0.534681114380647],
            [30.449574986780444, -0.537013567957411],
            [30.451073248215277, -0.536959964245456],
            [30.451719008445465, -0.537909258481341],
            [30.457165291892142, -0.540975544253646],
            [30.460065924995103, -0.529109354503103],
            [30.464354301600128, -0.521464608488375],
            [30.46701888439589, -0.509001674185212],
            [30.46887344821511, -0.502485679225396],
            [30.469240528586305, -0.498536911366056],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 59,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "KIGARAMA",
        Population: 21126,
        Key: "SHEEMAKIGARAMA",
        Dist2: "Sheema",
        "Sub Country": "Kigarama",
        id2_original: "Sheema Kigarama",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.242922368842034, -0.627625953907183],
            [30.241743654323447, -0.627516889703004],
            [30.23973499439869, -0.624199333508604],
            [30.23681065295877, -0.621242777043312],
            [30.23054631600367, -0.619269487134231],
            [30.228086432311702, -0.619774251526572],
            [30.227135995876495, -0.620456944630411],
            [30.221472225807936, -0.624749956393477],
            [30.218143354130923, -0.625959093997411],
            [30.215912907349054, -0.625216907032713],
            [30.212976015546282, -0.622531485320987],
            [30.211161124024947, -0.621870854707303],
            [30.20793013547626, -0.62210409122201],
            [30.20707391434803, -0.622528352182225],
            [30.205118172380033, -0.625147898967608],
            [30.202668224953428, -0.626312295865569],
            [30.19939550426988, -0.628578693864141],
            [30.195875286047496, -0.630212392737553],
            [30.19033256126853, -0.629233466970928],
            [30.185745310676932, -0.630315348711117],
            [30.183126512316235, -0.632283847634441],
            [30.18020535989557, -0.636177877671749],
            [30.17773375318915, -0.644281099980504],
            [30.17504709699024, -0.645156124041676],
            [30.17433236770577, -0.645896699360779],
            [30.173731851124863, -0.648083138408326],
            [30.17154885425461, -0.651235562459647],
            [30.170075303676636, -0.651541964288768],
            [30.167814901673292, -0.652896121872477],
            [30.166574000380837, -0.65477495081382],
            [30.16567330905279, -0.657982287349104],
            [30.1629112653369, -0.66023975609491],
            [30.162692208459923, -0.661938429982445],
            [30.159779940377426, -0.666671697972719],
            [30.15880771710161, -0.666147039183554],
            [30.158646485677764, -0.664565621337863],
            [30.15766403777742, -0.663525899314608],
            [30.157029302570677, -0.66145626176563],
            [30.151050178921665, -0.655723948967809],
            [30.147844552508396, -0.655496214901813],
            [30.145236696526176, -0.654012815041285],
            [30.1418790311494, -0.653080189092658],
            [30.138789160745315, -0.65381033987878],
            [30.136914387527128, -0.65337554135163],
            [30.133542922230937, -0.653581439788505],
            [30.130605310877627, -0.651212347000767],
            [30.12737778174106, -0.650388237215439],
            [30.126449668440657, -0.651029254321492],
            [30.12374250460211, -0.65090120414948],
            [30.12267140735626, -0.651668638314495],
            [30.121103822930955, -0.651703883231343],
            [30.11724563873574, -0.651349272844645],
            [30.116393264193547, -0.650508453697775],
            [30.11374942798928, -0.6497931102081],
            [30.11486800389285, -0.652838813078016],
            [30.116760390378822, -0.655279568904111],
            [30.117486412384707, -0.658550951663335],
            [30.120147377664793, -0.665826339835251],
            [30.12017268500299, -0.669106361329554],
            [30.1215577515255, -0.678043625037686],
            [30.124794792922557, -0.67959068935946],
            [30.125784642042554, -0.682030966615426],
            [30.125805226937313, -0.683033961478371],
            [30.122530828200823, -0.68582407250212],
            [30.11931052241749, -0.690321969398156],
            [30.11993398466569, -0.692170148227749],
            [30.121662317221205, -0.693919663522055],
            [30.128643102836218, -0.698197901324016],
            [30.132054120056043, -0.701046306912932],
            [30.133211337889886, -0.703125283579147],
            [30.133659851439894, -0.707742923606422],
            [30.134819496521633, -0.7090538552702],
            [30.137406916729418, -0.709444008619765],
            [30.142138099887422, -0.711687872548069],
            [30.143799644498202, -0.711978058090413],
            [30.14652347208524, -0.7143291209943],
            [30.14762626997919, -0.714817754826676],
            [30.157036949030406, -0.724347685480121],
            [30.15874379208766, -0.725360807022009],
            [30.166175289430175, -0.724512708077795],
            [30.16646479847994, -0.724737755786437],
            [30.16624344550909, -0.723776061246969],
            [30.164116267255654, -0.72328393420539],
            [30.161059314716837, -0.721184993275073],
            [30.15962114787957, -0.717436225576702],
            [30.159023195090477, -0.716788899982313],
            [30.159379360930966, -0.714201308746381],
            [30.158915267000673, -0.712090616388084],
            [30.159117525381856, -0.70747283696891],
            [30.158301384386654, -0.701147816126555],
            [30.158635821777054, -0.697779402797328],
            [30.15679855681524, -0.694262440870981],
            [30.15646720334121, -0.692477548139986],
            [30.156556720459275, -0.691005228664577],
            [30.15875291897097, -0.687178371525889],
            [30.16022656207541, -0.677856551399935],
            [30.160916922761153, -0.676998016035795],
            [30.161352540096928, -0.677144474319607],
            [30.161498505550835, -0.675883561122697],
            [30.162833392181547, -0.673998641069437],
            [30.16320166461712, -0.672519367947329],
            [30.16458092083637, -0.670038947437614],
            [30.165346577410894, -0.669700340753112],
            [30.169143115618095, -0.669979947429052],
            [30.17578771751779, -0.669367335557073],
            [30.18286150930742, -0.667891906461122],
            [30.18720949362311, -0.667740289225406],
            [30.1941916994746, -0.665894883848949],
            [30.20022504992577, -0.663494082222477],
            [30.20454301434129, -0.662374547300436],
            [30.20886142971109, -0.660465910811034],
            [30.213791312125107, -0.660252918234794],
            [30.22634669294871, -0.658009786559721],
            [30.232509142984316, -0.65502039493939],
            [30.232140705258736, -0.653528487547537],
            [30.232672507008605, -0.6505737767711],
            [30.232245136207144, -0.646669682824906],
            [30.232657581500163, -0.640000813839702],
            [30.23357050069586, -0.636666758299445],
            [30.23506268053621, -0.634155348974457],
            [30.242922368842034, -0.627625953907183],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 60,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "KITAGATA",
        Population: 18249,
        Key: "SHEEMAKITAGATA",
        Dist2: "Sheema",
        "Sub Country": "Kitagata",
        id2_original: "Sheema Kitagata",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.36601407544577, -0.494823391260903],
            [30.366988019893657, -0.492740260207324],
            [30.367906118775284, -0.483426771866189],
            [30.36740780711748, -0.482111401117017],
            [30.36458174047132, -0.480675569376138],
            [30.351352324045628, -0.478183593477337],
            [30.349476157540447, -0.477393772734531],
            [30.34660578508614, -0.475461777151522],
            [30.33464328785847, -0.481727449593753],
            [30.330219201865173, -0.482932674707247],
            [30.323201059809065, -0.483783100184998],
            [30.318983360853974, -0.485903995141542],
            [30.31106336325322, -0.493641907175951],
            [30.310332003457912, -0.495273700802032],
            [30.3099335584086, -0.498617340776455],
            [30.310403804001954, -0.502259567587222],
            [30.30850363451239, -0.509344020299414],
            [30.307875134512074, -0.512967709588869],
            [30.308126626859007, -0.514409371319866],
            [30.31038908510601, -0.514181164414015],
            [30.312743058324322, -0.51460347684999],
            [30.318313542842155, -0.517054755948142],
            [30.32759848829633, -0.519349630361602],
            [30.33547052394576, -0.522749911343226],
            [30.34214469658797, -0.525054743783865],
            [30.34454602000488, -0.52580840849663],
            [30.34497786441648, -0.526313695833576],
            [30.350313869780543, -0.522833009234262],
            [30.35297623194092, -0.51793216757896],
            [30.35318450993282, -0.516478709550125],
            [30.36703790603633, -0.518296721354896],
            [30.368154297237126, -0.51832109883761],
            [30.368605757261246, -0.517962601257233],
            [30.371883306389456, -0.518944372955573],
            [30.37413929227487, -0.520356146715249],
            [30.377588376503166, -0.521166890380963],
            [30.37663719716122, -0.518012303010716],
            [30.374513740627993, -0.516203865878467],
            [30.373605136938913, -0.514920126495851],
            [30.37124758123928, -0.514096717194203],
            [30.36832471662969, -0.511564944831205],
            [30.366844337957204, -0.506846645703256],
            [30.366859696453613, -0.504578183446579],
            [30.36609965345129, -0.503285040341398],
            [30.36088001854405, -0.503381912720187],
            [30.35605730873668, -0.505502153753264],
            [30.354458306632655, -0.505799306673584],
            [30.352041983147135, -0.508178660265623],
            [30.34535959181835, -0.511816339117678],
            [30.342022944324263, -0.510673943151285],
            [30.340259104060507, -0.511853236843979],
            [30.33943888381562, -0.507970673420719],
            [30.338017329522906, -0.504858119068519],
            [30.336984527457595, -0.503781667343668],
            [30.340785465613042, -0.500781743745577],
            [30.343602380223114, -0.496805539548133],
            [30.34651814814197, -0.498699219113504],
            [30.348293857845572, -0.49614642096245],
            [30.351168201751744, -0.4955019505907],
            [30.352545841901787, -0.495562281883679],
            [30.355420271147917, -0.49472650977327],
            [30.359125367147374, -0.495648605854632],
            [30.362320447339215, -0.49488469090784],
            [30.365790881826896, -0.496143396448289],
            [30.36601407544577, -0.494823391260903],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 61,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "KAKINDO TOWN COUNCIL",
        Population: 9945,
        Key: "SHEEMAKAKINDO TOWN COUNCIL",
        Dist2: "Sheema",
        "Sub Country": "Kyangenyi",
        id2_original: "Sheema Kyangenyi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.45715978971105, -0.429270309194915],
            [30.442003010893796, -0.430042539487025],
            [30.43997715990946, -0.42891207829222],
            [30.43842157697637, -0.426805646973024],
            [30.436847297407258, -0.425666304801478],
            [30.43396386883861, -0.42638840186875],
            [30.431489780985366, -0.425854322389174],
            [30.423508326941086, -0.428671554822438],
            [30.419919471142773, -0.428525735382264],
            [30.419149342754732, -0.428941227806368],
            [30.416862480874716, -0.432402043279741],
            [30.414942335548165, -0.433269043705858],
            [30.407869063883084, -0.432516468319479],
            [30.406631113556326, -0.432091258391807],
            [30.401731710979888, -0.428989556712419],
            [30.40088935534809, -0.431465674120676],
            [30.39914231268186, -0.433643224432845],
            [30.397520267892453, -0.437004783096748],
            [30.39685730402626, -0.437465487743304],
            [30.396023769850522, -0.437085604866486],
            [30.39372771371354, -0.434246901040453],
            [30.39023937670058, -0.432871935913746],
            [30.38646396147899, -0.433394831197472],
            [30.38553940820205, -0.433801215598212],
            [30.384267901307883, -0.435225745468586],
            [30.378955421922775, -0.446849536169134],
            [30.3754318673574, -0.452370364306973],
            [30.375063670380314, -0.454656790742622],
            [30.37421443994163, -0.455849468753192],
            [30.379703224481045, -0.463271519607571],
            [30.383563971569785, -0.4666110440439],
            [30.388401434409058, -0.471574034612563],
            [30.391195750999838, -0.469897069527626],
            [30.39253366405474, -0.46739791334814],
            [30.39456357991574, -0.46607671326964],
            [30.40053283916463, -0.464612844507139],
            [30.40270538952647, -0.464853947093018],
            [30.40938540930289, -0.468522937563393],
            [30.411160640204436, -0.470265522699734],
            [30.41190353257134, -0.472603697147629],
            [30.42503326564489, -0.472226563075138],
            [30.42825132653834, -0.471815207923524],
            [30.430072493690265, -0.472534081877684],
            [30.431985034777917, -0.47258064177186],
            [30.43324506210108, -0.472107364277818],
            [30.435354610917077, -0.472902732532898],
            [30.437114680053252, -0.474859322961036],
            [30.439027055850907, -0.475349015515655],
            [30.443063341830992, -0.478956768928637],
            [30.44414086292945, -0.479476719882484],
            [30.44544538021539, -0.481845737364946],
            [30.44688691214169, -0.483139037343707],
            [30.447811945119014, -0.485538486481761],
            [30.447811539080494, -0.486623417366285],
            [30.44858515293183, -0.488014273527335],
            [30.450451607750463, -0.489558340464529],
            [30.455702953187235, -0.491256528030934],
            [30.45582404698584, -0.492173428929349],
            [30.456643331186214, -0.493304560078411],
            [30.45684002540251, -0.4948938255352],
            [30.457659501842333, -0.495428974185651],
            [30.460070106652754, -0.49579983516548],
            [30.462000490078594, -0.496772412722373],
            [30.469240528586305, -0.498536911366056],
            [30.469916756077673, -0.490618585003359],
            [30.471153991345446, -0.486325780308699],
            [30.47307529999027, -0.475326667098811],
            [30.474164026673584, -0.4711332057961],
            [30.47750356045471, -0.46672362257092],
            [30.478066992784036, -0.465413239521585],
            [30.478308239845177, -0.461553877249304],
            [30.476597508879358, -0.452496684158799],
            [30.475638898673356, -0.450977881443307],
            [30.472047715340135, -0.448156628581941],
            [30.4689100222236, -0.443437470289662],
            [30.46664544125756, -0.442089967530427],
            [30.463969407636856, -0.441591939277775],
            [30.462205145164933, -0.440488651251806],
            [30.461173559418523, -0.438635427460369],
            [30.45999940564663, -0.432244884799794],
            [30.458359117870433, -0.432108759770781],
            [30.457523551705563, -0.431376370638397],
            [30.45715978971105, -0.429270309194915],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 62,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "MASHERUKA",
        Population: 16461,
        Key: "SHEEMAMASHERUKA",
        Dist2: "Sheema",
        "Sub Country": "Masheruka",
        id2_original: "Sheema Masheruka",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.308792232670434, -0.71395933397916],
            [30.30698015107932, -0.712538841971953],
            [30.30389971298573, -0.707716307656882],
            [30.30423055531834, -0.702763696671359],
            [30.301307365518593, -0.696642901618152],
            [30.295257707051785, -0.691942889243118],
            [30.29094832424217, -0.691124732735248],
            [30.289773803059298, -0.688948175641361],
            [30.286450609633203, -0.685120555135764],
            [30.282465577031644, -0.684023179652314],
            [30.277275473341096, -0.683689941894137],
            [30.277240941203235, -0.687577718489486],
            [30.275159221296448, -0.69398378415694],
            [30.27056899638289, -0.703867607049157],
            [30.267929900588413, -0.707390478515257],
            [30.26684980671497, -0.71127573840852],
            [30.262825497074225, -0.719849401078326],
            [30.256120869747246, -0.727056795142834],
            [30.25327251679716, -0.728591324410598],
            [30.251139146456467, -0.728436392820204],
            [30.250733205864428, -0.727984301864706],
            [30.248579256018896, -0.728931849984412],
            [30.247272952882156, -0.728931048752047],
            [30.24684388426482, -0.729382626716086],
            [30.245457651729076, -0.732119928269451],
            [30.24469626754202, -0.736285424562673],
            [30.242621865311524, -0.73880540066537],
            [30.242767940359872, -0.741444233161121],
            [30.24131427578731, -0.7429434297156],
            [30.239481248178706, -0.74795768327754],
            [30.238241498526463, -0.749429890938886],
            [30.23564933431564, -0.750404216354252],
            [30.23599050817237, -0.751000858489326],
            [30.239838988765875, -0.751229218458287],
            [30.245543555823048, -0.749786942500794],
            [30.24631921154502, -0.749145818531752],
            [30.246874198812403, -0.747194215311898],
            [30.248564761701758, -0.744601708458024],
            [30.24975593675165, -0.743653586100625],
            [30.25181917112657, -0.742904817082692],
            [30.255918939251142, -0.739672168630098],
            [30.260724371760666, -0.737171920185854],
            [30.263299745560506, -0.736640330390834],
            [30.2661510467813, -0.737473487502462],
            [30.26833906343737, -0.736390398407243],
            [30.27072046311959, -0.736084603894482],
            [30.273502841998546, -0.736565274267084],
            [30.274777575641252, -0.734776725062033],
            [30.274889550641415, -0.732851905573932],
            [30.27569290771179, -0.732102321828984],
            [30.2774096564917, -0.732130479917608],
            [30.279873018460428, -0.733641170814686],
            [30.282600035066768, -0.734085651298249],
            [30.286502959854722, -0.736148493092488],
            [30.291750799166923, -0.734759972859612],
            [30.292609606544865, -0.733956187741079],
            [30.29374606700741, -0.731887365338642],
            [30.29709784392755, -0.729584908226971],
            [30.302760303354074, -0.729470835026589],
            [30.303922937130753, -0.729860135994766],
            [30.308598856830823, -0.735917927161336],
            [30.311146272364066, -0.735856208110759],
            [30.31239315913125, -0.734465215826442],
            [30.31355800276352, -0.731149221444431],
            [30.313324724657296, -0.727832385654561],
            [30.31483874433885, -0.719392422816728],
            [30.3140645546674, -0.717250118220168],
            [30.313928768922338, -0.717102123388406],
            [30.311701256936484, -0.716239724640813],
            [30.308792232670434, -0.71395933397916],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 63,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "RUGARAMA",
        Population: 9239,
        Key: "SHEEMARUGARAMA",
        Dist2: "Sheema",
        "Sub Country": "Rugarama",
        id2_original: "Sheema Rugarama",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.384157925059228, -0.69372684889447],
              [30.382107007485185, -0.691085772042543],
              [30.37948301955712, -0.69075411300246],
              [30.374695333266047, -0.688175856341091],
              [30.372072549080464, -0.685664847641322],
              [30.36964507211238, -0.685927673170327],
              [30.366301054839674, -0.682689832351917],
              [30.362562101337176, -0.681895290194484],
              [30.360397987952506, -0.680441210059595],
              [30.355478848490943, -0.678457303477361],
              [30.352329923738406, -0.678455575239917],
              [30.347017776729952, -0.675414830341921],
              [30.344262630278845, -0.675149161269606],
              [30.33901533534568, -0.673561340885273],
              [30.336734613450623, -0.671215026582184],
              [30.33488277152671, -0.672931704866756],
              [30.332945719008187, -0.676265608675811],
              [30.33283589457481, -0.677447071341084],
              [30.329061404617963, -0.679616444941708],
              [30.32880251374637, -0.681722805211842],
              [30.329047899346, -0.684716674493591],
              [30.3286199338598, -0.685452913406797],
              [30.328524059364486, -0.687011894233949],
              [30.329083760990464, -0.688590374670662],
              [30.32906387229006, -0.690187658552517],
              [30.328635348950097, -0.69191861673759],
              [30.328709740235393, -0.694816744216627],
              [30.327948341675285, -0.697121388893638],
              [30.329248531776503, -0.699771534676269],
              [30.32995958605312, -0.702507431083297],
              [30.32955934886479, -0.704592293314126],
              [30.329995135982188, -0.7089186341388],
              [30.329701442579804, -0.713786085765221],
              [30.33044824890643, -0.71409663170644],
              [30.331455241475304, -0.716374657220634],
              [30.33401917253505, -0.718382474341813],
              [30.33499882218331, -0.719666369408966],
              [30.338298689954733, -0.717969252130446],
              [30.342033506715367, -0.714898671464002],
              [30.345720598679904, -0.715072525951608],
              [30.350374313822776, -0.712870050344498],
              [30.35514099211259, -0.712339580504557],
              [30.357204542694483, -0.710768217676509],
              [30.35975156566393, -0.708076456086876],
              [30.36153329677488, -0.707499062182534],
              [30.372413046505745, -0.707125672650602],
              [30.374839459868557, -0.706339346375156],
              [30.37529120465863, -0.705598315876723],
              [30.377031304246024, -0.704977300081669],
              [30.37965863839854, -0.698128124474982],
              [30.381647638693284, -0.695661910436092],
              [30.384157925059228, -0.69372684889447],
            ],
          ],
          [
            [
              [30.308792232670434, -0.71395933397916],
              [30.309485329624536, -0.710766176861244],
              [30.310004908896655, -0.699382504225587],
              [30.31052888721873, -0.69688647257575],
              [30.31092846055207, -0.695958944327774],
              [30.313360289857716, -0.696568987411677],
              [30.314671811307893, -0.695938477723921],
              [30.314773116119134, -0.693198298235446],
              [30.31610602645623, -0.688297229742038],
              [30.31686098499405, -0.68328922207823],
              [30.318298642486532, -0.682202058398789],
              [30.321018597436417, -0.681785128608972],
              [30.322189272931514, -0.680428388411431],
              [30.31980807716687, -0.678123927901735],
              [30.319328280685436, -0.675752295848817],
              [30.313096486099795, -0.681689318388433],
              [30.30915086977628, -0.686884079444352],
              [30.30508653030817, -0.686634801386161],
              [30.302863052656278, -0.687025684178819],
              [30.301922198550173, -0.687465115589313],
              [30.299610396742906, -0.689918031707951],
              [30.299639523717694, -0.688806185614571],
              [30.298920452875482, -0.68767239410187],
              [30.297634369917517, -0.687451443316595],
              [30.296204201679533, -0.68791450406662],
              [30.294062742908, -0.686086492013004],
              [30.292433149575277, -0.684068456905526],
              [30.292500147725804, -0.681559098837132],
              [30.291517076394605, -0.679907626821726],
              [30.29197799118711, -0.676804161448739],
              [30.291126805116075, -0.673898071749654],
              [30.28577396622187, -0.668023936360526],
              [30.28195607056881, -0.676067165784421],
              [30.28043984642155, -0.677683950398446],
              [30.277395298718528, -0.679218532723222],
              [30.277275473341096, -0.683689941894137],
              [30.282465577031644, -0.684023179652314],
              [30.286450609633203, -0.685120555135764],
              [30.289773803059298, -0.688948175641361],
              [30.29094832424217, -0.691124732735248],
              [30.295257707051785, -0.691942889243118],
              [30.301307365518593, -0.696642901618152],
              [30.30423055531834, -0.702763696671359],
              [30.30389971298573, -0.707716307656882],
              [30.30698015107932, -0.712538841971953],
              [30.308792232670434, -0.71395933397916],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 64,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "SHUUKU TOWN COUNCIL",
        Population: 8029,
        Key: "SHEEMASHUUKU TOWN COUNCIL",
        Dist2: "Sheema",
        "Sub Country": "Shuuku",
        id2_original: "Sheema Shuuku",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.34497786441648, -0.526313695833576],
            [30.34454602000488, -0.52580840849663],
            [30.34214469658797, -0.525054743783865],
            [30.343870903729517, -0.529475008018248],
            [30.343830842461095, -0.53141705907557],
            [30.339307166540483, -0.542784392756223],
            [30.339064458818694, -0.544495931516425],
            [30.33775503762963, -0.547977890349944],
            [30.336976494722347, -0.548760949154847],
            [30.335256610822064, -0.548766765479534],
            [30.333928847831537, -0.549338913043848],
            [30.33191919077684, -0.553946265479963],
            [30.328065799991965, -0.55765086467538],
            [30.32727650604735, -0.559045595520866],
            [30.328858314396875, -0.558452931448906],
            [30.33033610142973, -0.559330237416375],
            [30.3310291858074, -0.56026141174674],
            [30.331583492151783, -0.562231831971036],
            [30.33562330940926, -0.561338969262371],
            [30.3381563132704, -0.561421463883231],
            [30.341205896030626, -0.56285982200112],
            [30.34856085062273, -0.561299677040884],
            [30.35135209677186, -0.563632647516898],
            [30.352924393759142, -0.564338298375537],
            [30.355232724476163, -0.564709894506359],
            [30.356472637621778, -0.565587111503436],
            [30.359134950374813, -0.565199706747222],
            [30.359763448578505, -0.564739072166098],
            [30.35932337110734, -0.567929168068346],
            [30.35780519312436, -0.572212320059504],
            [30.35572551508821, -0.575808340013247],
            [30.355644504117564, -0.579622186215955],
            [30.354795999517634, -0.581700444184564],
            [30.35549569369915, -0.58441206339544],
            [30.357227544057334, -0.586491540342458],
            [30.35896796973318, -0.587631110240626],
            [30.360266638986612, -0.591526962038482],
            [30.36151846019965, -0.592422289347238],
            [30.36173601419515, -0.593344236657336],
            [30.363382560533925, -0.59486335704998],
            [30.365716744764804, -0.595786320790712],
            [30.367238640874774, -0.598968329113978],
            [30.368119717488593, -0.599266998125387],
            [30.36902352237741, -0.599267433784482],
            [30.378647588139515, -0.593822263854538],
            [30.38002695574987, -0.593795806297108],
            [30.382693561551633, -0.5945743271017],
            [30.384862018290697, -0.595705088734233],
            [30.388201133456878, -0.598475390245027],
            [30.388910198863485, -0.597799795152406],
            [30.391659247550464, -0.592570313011346],
            [30.392529889333932, -0.585456194497785],
            [30.393430682171616, -0.582578460731209],
            [30.39404279330789, -0.578730426585742],
            [30.395264486822946, -0.576564287099315],
            [30.396218768945893, -0.569916218973101],
            [30.397080686291314, -0.568253628989572],
            [30.399973212997143, -0.565814684994674],
            [30.400307969289475, -0.566147523313761],
            [30.399284259073156, -0.561944777457795],
            [30.40188226951982, -0.55933169621088],
            [30.402016435602444, -0.558631031059106],
            [30.401856158189457, -0.557822432070741],
            [30.401133531815365, -0.557336995597058],
            [30.40129506686973, -0.555261845867645],
            [30.400145260137005, -0.552081131827298],
            [30.40029007215407, -0.549509833922431],
            [30.39175001871664, -0.54498765695923],
            [30.388955743448392, -0.54187741163235],
            [30.385924867205627, -0.540646952466018],
            [30.382831936241363, -0.536912989808732],
            [30.381180885749774, -0.534228047219278],
            [30.38046825403149, -0.531290450574164],
            [30.37903026326402, -0.527936793027452],
            [30.37324138123261, -0.52645258478632],
            [30.37261356574855, -0.526478653693653],
            [30.37209016324655, -0.527031440980803],
            [30.358854643666813, -0.525498490190479],
            [30.35809594454418, -0.525761503142512],
            [30.35335964637893, -0.529709492426379],
            [30.35168548043843, -0.529814108447328],
            [30.34802361496369, -0.529180542055103],
            [30.346977515137244, -0.528653429513586],
            [30.34497786441648, -0.526313695833576],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 65,
        District: "SHEEMA",
        County: "SHEEMA MUNICIPALITY",
        Subcounty: "KABWOHE DIVISION",
        Population: 19781,
        Key: "SHEEMAKABWOHE DIVISION",
        Dist2: "Sheema",
        "Sub Country": "Kabwohe/Itendero  T.C",
        id2_original: "Sheema Kabwohe/Itendero  T.C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.457165291892142, -0.540975544253646],
            [30.451719008445465, -0.537909258481341],
            [30.451073248215277, -0.536959964245456],
            [30.449574986780444, -0.537013567957411],
            [30.448210559949914, -0.534681114380647],
            [30.44676673552299, -0.533360921345745],
            [30.44657257904736, -0.532339512768059],
            [30.445548129517594, -0.531887173038374],
            [30.445641612697607, -0.531417220765359],
            [30.444495928333733, -0.530350228809947],
            [30.441402917419396, -0.530095877237256],
            [30.43647558172921, -0.532217817858243],
            [30.435765519192657, -0.533121343849034],
            [30.43144755298051, -0.535993683463472],
            [30.428182828201297, -0.537519759839337],
            [30.42623943627183, -0.539353683832363],
            [30.425668747351615, -0.539407671086911],
            [30.424214421619023, -0.53845805011189],
            [30.421851839845363, -0.53634212919647],
            [30.420639846338766, -0.536585646405516],
            [30.419156938908788, -0.537579210423193],
            [30.416757050101374, -0.53815663012878],
            [30.413698666546313, -0.540785407228264],
            [30.402888537148268, -0.547071217217832],
            [30.40029007215407, -0.549509833922431],
            [30.400145260137005, -0.552081131827298],
            [30.40129506686973, -0.555261845867645],
            [30.401133531815365, -0.557336995597058],
            [30.401856158189457, -0.557822432070741],
            [30.402016435602444, -0.558631031059106],
            [30.40188226951982, -0.55933169621088],
            [30.399284259073156, -0.561944777457795],
            [30.400307969289475, -0.566147523313761],
            [30.399973212997143, -0.565814684994674],
            [30.397080686291314, -0.568253628989572],
            [30.396218768945893, -0.569916218973101],
            [30.395264486822946, -0.576564287099315],
            [30.39404279330789, -0.578730426585742],
            [30.393430682171616, -0.582578460731209],
            [30.392529889333932, -0.585456194497785],
            [30.391659247550464, -0.592570313011346],
            [30.388910198863485, -0.597799795152406],
            [30.388201133456878, -0.598475390245027],
            [30.387520839292215, -0.600821787918579],
            [30.38601779612513, -0.602791319972613],
            [30.386045248640226, -0.603767421962782],
            [30.384965942589307, -0.605433087829991],
            [30.384335158173204, -0.605781427851193],
            [30.384149241045353, -0.607674858913577],
            [30.38485818428109, -0.608264991881232],
            [30.385150510447584, -0.609522316137821],
            [30.383314915453877, -0.611368407366804],
            [30.383299109596447, -0.612159913657849],
            [30.383854105846968, -0.612261078844743],
            [30.3841313061807, -0.612897573403535],
            [30.384238550652583, -0.614325519961892],
            [30.38374375500085, -0.617254030221726],
            [30.3823540783243, -0.6214905124398],
            [30.378789877687264, -0.62702958017196],
            [30.3753348609848, -0.63003882356904],
            [30.374532526197225, -0.631249027083388],
            [30.367366932873747, -0.63689102951982],
            [30.370995516665527, -0.64097759611741],
            [30.3714268436475, -0.641863517523818],
            [30.371395393629417, -0.643020333849923],
            [30.372826996476903, -0.644277321905285],
            [30.37473329157837, -0.648571250784971],
            [30.37678817341777, -0.651157127533551],
            [30.37919828415476, -0.656644334784378],
            [30.38024895011782, -0.657783651493666],
            [30.380443598870222, -0.658976745623844],
            [30.38184078097095, -0.660604291575748],
            [30.382942690431076, -0.662737802610827],
            [30.38341735932887, -0.665756692763867],
            [30.38392020119064, -0.66667882023244],
            [30.386353915161727, -0.668840164638948],
            [30.387383925263126, -0.670838083409014],
            [30.38826659279334, -0.671597737412517],
            [30.392064990513134, -0.672928343602826],
            [30.393615428794615, -0.674167368934527],
            [30.395631041679668, -0.672496434639634],
            [30.396652360580685, -0.672108350527381],
            [30.397271465999793, -0.672298478447982],
            [30.398132759914393, -0.673699820089581],
            [30.401001861252574, -0.676268138155433],
            [30.40369451460434, -0.675618848715271],
            [30.405840765887884, -0.673911816819329],
            [30.40715755326228, -0.669736959870577],
            [30.408943872069372, -0.667143995661463],
            [30.412686700005718, -0.662970392312983],
            [30.415093354025508, -0.660901936636344],
            [30.419296866785633, -0.655897023222088],
            [30.420331010933978, -0.653755527350409],
            [30.42241798957847, -0.648830827501065],
            [30.42768467105376, -0.641874135842434],
            [30.43459102495927, -0.634529553406778],
            [30.439215425379466, -0.631314238119722],
            [30.438163826965155, -0.628466675298627],
            [30.43813503865524, -0.627083811810946],
            [30.438864680871724, -0.625014413667381],
            [30.441980816218077, -0.621870622057358],
            [30.442499615752546, -0.620650708855099],
            [30.442591268166044, -0.619674620715039],
            [30.440639260494677, -0.616004145400443],
            [30.44115047645152, -0.612714467696272],
            [30.444209060330895, -0.606877205136741],
            [30.44458778286814, -0.606380279585345],
            [30.44606222008332, -0.606308670799254],
            [30.4465599092086, -0.605802761646685],
            [30.447892992022243, -0.602902096776321],
            [30.44771924886316, -0.600931665598152],
            [30.44702311470507, -0.59918694823864],
            [30.44710330371724, -0.598391615236426],
            [30.44771906560682, -0.597677877047075],
            [30.448778278141496, -0.591423860700743],
            [30.448148525889653, -0.588350546540526],
            [30.450494128606106, -0.582684594787647],
            [30.451362370091168, -0.579512535377536],
            [30.452749232345905, -0.578256831959067],
            [30.456505205329815, -0.577725257582381],
            [30.45761148329715, -0.574598477195905],
            [30.45734357603502, -0.572908182316027],
            [30.4546053924714, -0.568930089071377],
            [30.454360200907875, -0.566932505596242],
            [30.45574356332629, -0.555183247869134],
            [30.45759116969362, -0.546769319781861],
            [30.457165291892142, -0.540975544253646],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 66,
        District: "SHEEMA",
        County: "SHEEMA MUNICIPALITY",
        Subcounty: "KAGANGO DIVISION",
        Population: 25778,
        Key: "SHEEMAKAGANGO DIVISION",
        Dist2: "Sheema",
        "Sub Country": "Kagango",
        id2_original: "Sheema Kagango",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.455873510980748, 0.585149566083854],
            [31.455420251631107, 0.591715409555292],
            [31.45378918146806, 0.59644497661905],
            [31.452886475218826, 0.597792280255802],
            [31.44854005576834, 0.601282026107414],
            [31.44589170732639, 0.604401441904235],
            [31.445071417012937, 0.606164783118531],
            [31.444953651472446, 0.607602742625039],
            [31.445649614950586, 0.612513834158309],
            [31.445220266058882, 0.614738529894246],
            [31.44516214146672, 0.622453036484187],
            [31.444522568832213, 0.624442523560693],
            [31.442480202321374, 0.623202886913298],
            [31.437004764950462, 0.621283927345617],
            [31.428193887421195, 0.612336850107003],
            [31.41292552437095, 0.61237751900866],
            [31.408960924848838, 0.613081749835011],
            [31.405283346043166, 0.614410084297656],
            [31.402234013912896, 0.614065497780605],
            [31.39863481131915, 0.614210308665037],
            [31.402455136915023, 0.6105742124541],
            [31.404871855659295, 0.608889907384714],
            [31.401035934411745, 0.602042891336501],
            [31.399342568778682, 0.596952057080196],
            [31.402592810918854, 0.594837914539119],
            [31.404946831747843, 0.591926813186018],
            [31.405031647083693, 0.589226557112115],
            [31.40660795504872, 0.587415074976591],
            [31.407196900430474, 0.585130932403398],
            [31.40856332601252, 0.582515642993797],
            [31.408865580359535, 0.578588682358131],
            [31.410554740978757, 0.573879521515687],
            [31.41057628617254, 0.571947729990545],
            [31.413163811483216, 0.567779310388105],
            [31.40855799271468, 0.567102787292584],
            [31.405627698139327, 0.567821009932536],
            [31.40167847777489, 0.565112579793243],
            [31.39639842307998, 0.563080618137564],
            [31.39590813607264, 0.563242638540346],
            [31.395286284503705, 0.564841969182488],
            [31.392553410881764, 0.564450322737668],
            [31.394703850111146, 0.562161980540659],
            [31.39854236569325, 0.559716907775329],
            [31.398701771740427, 0.558093813724374],
            [31.397209791326063, 0.553864099522358],
            [31.39717040109917, 0.55256100572449],
            [31.394967553257764, 0.552800445015023],
            [31.38757273502663, 0.551247995597306],
            [31.386188601853707, 0.549741597584861],
            [31.38625050745488, 0.549208033622987],
            [31.385707147082236, 0.548545736154958],
            [31.384174330153353, 0.550130186385084],
            [31.384127471333187, 0.55333400775672],
            [31.379501261706007, 0.551786375021568],
            [31.379612346475746, 0.552606364045186],
            [31.37723661516298, 0.552671392758499],
            [31.374609930492422, 0.55141869903895],
            [31.37069841691202, 0.547478850504388],
            [31.367121422468713, 0.546676047460818],
            [31.365333219894474, 0.545198521539249],
            [31.365488457758723, 0.539529567965883],
            [31.36780803089151, 0.539600533523126],
            [31.369358673988863, 0.541134259606007],
            [31.370923670367837, 0.54126128829656],
            [31.372768442550456, 0.540248962602261],
            [31.372832311868855, 0.538084045861966],
            [31.374082243026535, 0.534526083589455],
            [31.37594365021161, 0.53295489323039],
            [31.379157262647738, 0.527905116181957],
            [31.380433161405346, 0.524851259658555],
            [31.381313809522783, 0.519938220955005],
            [31.38698815186391, 0.510821345442785],
            [31.387285838277688, 0.507244352034951],
            [31.390342846512056, 0.502619546409313],
            [31.391069147894, 0.499322066647015],
            [31.38986114200892, 0.494607665293933],
            [31.390081326271588, 0.493213406912949],
            [31.388918781428117, 0.491347934538746],
            [31.40011723455719, 0.493581035998061],
            [31.403436873349705, 0.49381423088692],
            [31.409922618072873, 0.492841989752115],
            [31.41270406989049, 0.49128234286663],
            [31.413078019678622, 0.490408210866695],
            [31.41583775831749, 0.487697675579121],
            [31.417619112135995, 0.48523035563355],
            [31.42145402008392, 0.482179279908044],
            [31.429155546509243, 0.491682159306376],
            [31.432707500414022, 0.49757060946302],
            [31.432508941295186, 0.514166188304629],
            [31.43268172415524, 0.515938843077785],
            [31.43357114611807, 0.51810056786242],
            [31.433443454193682, 0.520180642009126],
            [31.433082590164272, 0.520623704272224],
            [31.43333003560085, 0.526948664728844],
            [31.434727166497648, 0.526678554537665],
            [31.436057000104885, 0.527763381519498],
            [31.437354167375176, 0.527608785320942],
            [31.44145417984152, 0.528550456421811],
            [31.44409276898621, 0.527134644954979],
            [31.448281106506236, 0.526593455335805],
            [31.449699076520968, 0.52693686675487],
            [31.45301919681045, 0.525609745451153],
            [31.45484394554541, 0.525765131285197],
            [31.468992069012163, 0.532847951624913],
            [31.4675492767495, 0.534953398948814],
            [31.466230275027964, 0.534421879058885],
            [31.464471371006695, 0.534664894207831],
            [31.4633942954726, 0.533801445939095],
            [31.461239626974855, 0.5341550236488],
            [31.460338121773137, 0.534553182785536],
            [31.45854568454065, 0.536792743908508],
            [31.461919013841083, 0.542742684950714],
            [31.462039043136095, 0.546239683709467],
            [31.461049164371687, 0.548308834318032],
            [31.455704923253066, 0.555091096724632],
            [31.453087956557255, 0.557735251110454],
            [31.451318042783893, 0.560948228938999],
            [31.457146011411634, 0.56377884574497],
            [31.460638865153875, 0.564602790881408],
            [31.462352614459046, 0.566502503104927],
            [31.462248591345784, 0.572317809351271],
            [31.46178425936192, 0.57326730990305],
            [31.460522784852838, 0.573520200838968],
            [31.45935466506472, 0.574279583213121],
            [31.457772200945055, 0.576965232505903],
            [31.455933361236564, 0.582915704980762],
            [31.455873510980748, 0.585149566083854],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1993,
        District: "MUBENDE",
        County: "MUBENDE MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 34147,
        Key: "MUBENDESOUTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.367366932873747, -0.63689102951982],
            [30.36661995856216, -0.634612787992437],
            [30.365644504944623, -0.634539988495464],
            [30.364789982530603, -0.635000474377786],
            [30.35877141475576, -0.631337141972341],
            [30.356842766875054, -0.630748711982017],
            [30.355631519868446, -0.631227088860689],
            [30.355130038954353, -0.630657462152677],
            [30.352870737387217, -0.63068342368819],
            [30.351487578886374, -0.629643392904749],
            [30.35079784252978, -0.629643041684693],
            [30.348212408497076, -0.628277047855198],
            [30.347185961114068, -0.62726431655433],
            [30.342712976226597, -0.626774013094059],
            [30.33825779055815, -0.623834552900672],
            [30.33159219413193, -0.616375262897309],
            [30.330035267319186, -0.613328859521777],
            [30.328794659775813, -0.61226182081078],
            [30.325845577834663, -0.612242271891448],
            [30.32491511364315, -0.611464588999237],
            [30.3267225006386, -0.604931434576293],
            [30.326350431922624, -0.600737887188669],
            [30.324592076772017, -0.597926389629768],
            [30.323375562942896, -0.596922643342644],
            [30.32199452087288, -0.59647913769815],
            [30.320686989739176, -0.596605022575326],
            [30.31950198342032, -0.597752189728361],
            [30.317539510375937, -0.597624705963234],
            [30.315205439332754, -0.596674641828264],
            [30.31065251875803, -0.593807585272839],
            [30.308055848597768, -0.592622434069508],
            [30.305043395004876, -0.591500344578525],
            [30.300404071771162, -0.591037184406278],
            [30.2991465417645, -0.593115131828198],
            [30.296646841145883, -0.595662398607639],
            [30.29559231422374, -0.599954546263323],
            [30.289777837393263, -0.609756967060988],
            [30.289358380749434, -0.612115449589032],
            [30.289628128659587, -0.614329687905201],
            [30.288686741852537, -0.620537723590065],
            [30.288479493329973, -0.620392045156211],
            [30.28984762481274, -0.630716432079992],
            [30.292851848939325, -0.641225037741331],
            [30.292905594244434, -0.652404954941945],
            [30.294594893204238, -0.652613722451448],
            [30.302808337170642, -0.651723459848169],
            [30.309468657791175, -0.652061413826986],
            [30.311883944620867, -0.652424200099205],
            [30.314195015199502, -0.653582216780639],
            [30.31948750347627, -0.653838099606783],
            [30.322375411044916, -0.653369701783675],
            [30.322394550550374, -0.652869898158682],
            [30.336272358371716, -0.650446146073739],
            [30.333908461464507, -0.654737428837919],
            [30.33226483015881, -0.661538558130189],
            [30.33422940975259, -0.66801143984771],
            [30.336734613450623, -0.671215026582184],
            [30.33901533534568, -0.673561340885273],
            [30.344262630278845, -0.675149161269606],
            [30.347017776729952, -0.675414830341921],
            [30.352329923738406, -0.678455575239917],
            [30.355478848490943, -0.678457303477361],
            [30.360397987952506, -0.680441210059595],
            [30.362562101337176, -0.681895290194484],
            [30.366301054839674, -0.682689832351917],
            [30.36964507211238, -0.685927673170327],
            [30.372072549080464, -0.685664847641322],
            [30.374695333266047, -0.688175856341091],
            [30.37948301955712, -0.69075411300246],
            [30.382107007485185, -0.691085772042543],
            [30.384157925059228, -0.69372684889447],
            [30.389106167241028, -0.68967394389801],
            [30.389992957140052, -0.688255484449732],
            [30.390909154288224, -0.685110801027457],
            [30.398149247593125, -0.681210359777011],
            [30.39902508343558, -0.680063014540672],
            [30.39863801644766, -0.678273291099559],
            [30.399087067190198, -0.677469155776819],
            [30.401001861252574, -0.676268138155433],
            [30.398132759914393, -0.673699820089581],
            [30.397271465999793, -0.672298478447982],
            [30.396652360580685, -0.672108350527381],
            [30.395631041679668, -0.672496434639634],
            [30.393615428794615, -0.674167368934527],
            [30.392064990513134, -0.672928343602826],
            [30.38826659279334, -0.671597737412517],
            [30.387383925263126, -0.670838083409014],
            [30.386353915161727, -0.668840164638948],
            [30.38392020119064, -0.66667882023244],
            [30.38341735932887, -0.665756692763867],
            [30.382942690431076, -0.662737802610827],
            [30.38184078097095, -0.660604291575748],
            [30.380443598870222, -0.658976745623844],
            [30.38024895011782, -0.657783651493666],
            [30.37919828415476, -0.656644334784378],
            [30.37678817341777, -0.651157127533551],
            [30.37473329157837, -0.648571250784971],
            [30.372826996476903, -0.644277321905285],
            [30.371395393629417, -0.643020333849923],
            [30.3714268436475, -0.641863517523818],
            [30.370995516665527, -0.64097759611741],
            [30.367366932873747, -0.63689102951982],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 67,
        District: "SHEEMA",
        County: "SHEEMA MUNICIPALITY",
        Subcounty: "KASHOZI DIVISION",
        Population: 13866,
        Key: "SHEEMAKASHOZI DIVISION",
        Dist2: "Sheema",
        "Sub Country": "Kashozi",
        id2_original: "Sheema Kashozi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.388201133456878, -0.598475390245027],
            [30.384862018290697, -0.595705088734233],
            [30.382693561551633, -0.5945743271017],
            [30.38002695574987, -0.593795806297108],
            [30.378647588139515, -0.593822263854538],
            [30.36902352237741, -0.599267433784482],
            [30.368119717488593, -0.599266998125387],
            [30.367238640874774, -0.598968329113978],
            [30.365716744764804, -0.595786320790712],
            [30.363382560533925, -0.59486335704998],
            [30.36173601419515, -0.593344236657336],
            [30.36151846019965, -0.592422289347238],
            [30.360266638986612, -0.591526962038482],
            [30.35896796973318, -0.587631110240626],
            [30.357227544057334, -0.586491540342458],
            [30.35549569369915, -0.58441206339544],
            [30.354795999517634, -0.581700444184564],
            [30.355644504117564, -0.579622186215955],
            [30.35572551508821, -0.575808340013247],
            [30.35780519312436, -0.572212320059504],
            [30.35932337110734, -0.567929168068346],
            [30.359763448578505, -0.564739072166098],
            [30.359134950374813, -0.565199706747222],
            [30.356472637621778, -0.565587111503436],
            [30.355232724476163, -0.564709894506359],
            [30.352924393759142, -0.564338298375537],
            [30.35135209677186, -0.563632647516898],
            [30.34856085062273, -0.561299677040884],
            [30.341205896030626, -0.56285982200112],
            [30.3381563132704, -0.561421463883231],
            [30.33562330940926, -0.561338969262371],
            [30.331583492151783, -0.562231831971036],
            [30.3310291858074, -0.56026141174674],
            [30.33033610142973, -0.559330237416375],
            [30.328858314396875, -0.558452931448906],
            [30.32727650604735, -0.559045595520866],
            [30.328065799991965, -0.55765086467538],
            [30.33191919077684, -0.553946265479963],
            [30.333928847831537, -0.549338913043848],
            [30.335256610822064, -0.548766765479534],
            [30.336976494722347, -0.548760949154847],
            [30.33775503762963, -0.547977890349944],
            [30.339064458818694, -0.544495931516425],
            [30.339307166540483, -0.542784392756223],
            [30.343830842461095, -0.53141705907557],
            [30.343870903729517, -0.529475008018248],
            [30.34214469658797, -0.525054743783865],
            [30.33547052394576, -0.522749911343226],
            [30.32759848829633, -0.519349630361602],
            [30.318313542842155, -0.517054755948142],
            [30.312743058324322, -0.51460347684999],
            [30.31038908510601, -0.514181164414015],
            [30.308126626859007, -0.514409371319866],
            [30.30919328642736, -0.518878657599561],
            [30.308694980159466, -0.52237587739916],
            [30.307751109510676, -0.524372712132873],
            [30.30908632941638, -0.528073110176571],
            [30.309153058072305, -0.529537791287197],
            [30.30904467543497, -0.530961710949573],
            [30.307696177531035, -0.534107407821355],
            [30.30764961515491, -0.53661819004264],
            [30.307518965078327, -0.538687670015066],
            [30.30812058389207, -0.540594804890276],
            [30.307589848442426, -0.541778453154111],
            [30.307787717655124, -0.543802892767884],
            [30.306831640698235, -0.54571836830745],
            [30.307095610644495, -0.546387245948046],
            [30.309243124959323, -0.548286042407994],
            [30.30829129703374, -0.55134925439844],
            [30.307486526015108, -0.552397214530468],
            [30.308356982745607, -0.556256532332653],
            [30.308159101854848, -0.557413214042317],
            [30.307289186808426, -0.560124000330885],
            [30.305942240295018, -0.562464032592558],
            [30.305922771107856, -0.56362983143476],
            [30.307482481799674, -0.569296930359517],
            [30.307914954133643, -0.570462943412093],
            [30.309408228122024, -0.572352438576036],
            [30.30972336341189, -0.573970262976451],
            [30.30733097463881, -0.576571871191228],
            [30.30421621281652, -0.57675113799419],
            [30.302388106179045, -0.577608807704412],
            [30.298159802612023, -0.582161548992047],
            [30.29699496167467, -0.585513791466521],
            [30.297264376309865, -0.58765573895365],
            [30.299792347808772, -0.58959996881305],
            [30.300404071771162, -0.591037184406278],
            [30.305043395004876, -0.591500344578525],
            [30.308055848597768, -0.592622434069508],
            [30.31065251875803, -0.593807585272839],
            [30.315205439332754, -0.596674641828264],
            [30.317539510375937, -0.597624705963234],
            [30.31950198342032, -0.597752189728361],
            [30.320686989739176, -0.596605022575326],
            [30.32199452087288, -0.59647913769815],
            [30.323375562942896, -0.596922643342644],
            [30.324592076772017, -0.597926389629768],
            [30.326350431922624, -0.600737887188669],
            [30.3267225006386, -0.604931434576293],
            [30.32491511364315, -0.611464588999237],
            [30.325845577834663, -0.612242271891448],
            [30.328794659775813, -0.61226182081078],
            [30.330035267319186, -0.613328859521777],
            [30.33159219413193, -0.616375262897309],
            [30.33825779055815, -0.623834552900672],
            [30.342712976226597, -0.626774013094059],
            [30.347185961114068, -0.62726431655433],
            [30.348212408497076, -0.628277047855198],
            [30.35079784252978, -0.629643041684693],
            [30.351487578886374, -0.629643392904749],
            [30.352870737387217, -0.63068342368819],
            [30.355130038954353, -0.630657462152677],
            [30.355631519868446, -0.631227088860689],
            [30.356842766875054, -0.630748711982017],
            [30.35877141475576, -0.631337141972341],
            [30.364789982530603, -0.635000474377786],
            [30.365644504944623, -0.634539988495464],
            [30.36661995856216, -0.634612787992437],
            [30.367366932873747, -0.63689102951982],
            [30.374532526197225, -0.631249027083388],
            [30.3753348609848, -0.63003882356904],
            [30.378789877687264, -0.62702958017196],
            [30.3823540783243, -0.6214905124398],
            [30.38374375500085, -0.617254030221726],
            [30.384238550652583, -0.614325519961892],
            [30.3841313061807, -0.612897573403535],
            [30.383854105846968, -0.612261078844743],
            [30.383299109596447, -0.612159913657849],
            [30.383314915453877, -0.611368407366804],
            [30.385150510447584, -0.609522316137821],
            [30.38485818428109, -0.608264991881232],
            [30.384149241045353, -0.607674858913577],
            [30.384335158173204, -0.605781427851193],
            [30.384965942589307, -0.605433087829991],
            [30.386045248640226, -0.603767421962782],
            [30.38601779612513, -0.602791319972613],
            [30.387520839292215, -0.600821787918579],
            [30.388201133456878, -0.598475390245027],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 68,
        District: "SHEEMA",
        County: "SHEEMA MUNICIPALITY",
        Subcounty: "SHEEMA CENTRAL DIVISION",
        Population: 21310,
        Key: "SHEEMASHEEMA CENTRAL DIVISION",
        Dist2: "Sheema",
        "Sub Country": "Sheema T.C",
        id2_original: "Sheema Sheema T.C",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.031016769755595, 1.821621396810566],
            [32.02703279267449, 1.822636769920152],
            [32.02570679846678, 1.824662342748798],
            [32.02461552505963, 1.825385423211792],
            [32.01655687159644, 1.827877677242652],
            [32.01222248597752, 1.834171240852643],
            [32.011236693649344, 1.834134508705071],
            [32.010406915329845, 1.834948178884824],
            [32.010313909155215, 1.835997453710318],
            [32.008786461456786, 1.836601031547729],
            [31.995015486678934, 1.830556527615651],
            [31.985762947050315, 1.830061057817998],
            [31.978381571209084, 1.826710217005983],
            [31.976963584126377, 1.823296271902516],
            [31.976625814884613, 1.820564680183139],
            [31.97751105339312, 1.815820752707019],
            [31.981822280444007, 1.810261655717976],
            [31.98679350692067, 1.807486322604415],
            [31.98742510610875, 1.806534171604206],
            [31.98750480374244, 1.805065771241576],
            [31.985809234541957, 1.802937343359436],
            [31.98302000241571, 1.801568857902148],
            [31.98254256311357, 1.789586039019084],
            [31.98334417026576, 1.784350208299376],
            [31.986104132585115, 1.782987872893742],
            [31.988621577625562, 1.782502172530783],
            [31.992736359293485, 1.782212187603667],
            [32.00045719500586, 1.782484328949619],
            [32.00229710011627, 1.781705978536664],
            [32.015461079663424, 1.787119930720276],
            [32.017739146138496, 1.781665629560599],
            [32.02182206276669, 1.781534749931558],
            [32.02606304605394, 1.779651824133495],
            [32.029561405570526, 1.779079739436488],
            [32.0295801992246, 1.788501366308085],
            [32.02855974540118, 1.794575922440031],
            [32.030939600879435, 1.806662265153586],
            [32.02912111519864, 1.81442033273002],
            [32.03119151094299, 1.815056463607416],
            [32.030749414059045, 1.819744935733472],
            [32.031016769755595, 1.821621396810566],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 70,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "KIGUMBA TOWN COUNCIL",
        Population: 18625,
        Key: "KIRYANDONGOKIGUMBA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.06542630552245, 1.888271156450668],
            [32.063702380101724, 1.888858830228013],
            [32.06095270259408, 1.892042342023788],
            [32.05945923995951, 1.892777345842497],
            [32.06071889807506, 1.897540659957684],
            [32.05866648031453, 1.899920848199588],
            [32.0579448995794, 1.901515823670202],
            [32.05415919415622, 1.904721071716384],
            [32.0400482600439, 1.894857692560338],
            [32.0392568191258, 1.893407909879929],
            [32.04167171878158, 1.88945980062257],
            [32.04549033218856, 1.886780634698661],
            [32.04315341168931, 1.879858730530555],
            [32.04121097556729, 1.875944435295655],
            [32.038043436823756, 1.87340633802209],
            [32.03631652180976, 1.8705067016463],
            [32.03660654289924, 1.866955978693945],
            [32.042086417947644, 1.855291791490363],
            [32.04467844651287, 1.856597612271232],
            [32.048133714743585, 1.859788049423607],
            [32.05144557502406, 1.861818930243222],
            [32.0577807010202, 1.866895074720667],
            [32.06008633679136, 1.86508463101004],
            [32.06311417223685, 1.859506255377293],
            [32.06621316772758, 1.855522190013142],
            [32.07075036239495, 1.855742001127793],
            [32.074782816162056, 1.857121019162191],
            [32.07420566386336, 1.859004875963017],
            [32.07431349852837, 1.869933244326877],
            [32.07394280782807, 1.879549352023567],
            [32.07282510957853, 1.882121359520267],
            [32.069845052828036, 1.883352291198172],
            [32.067336330429, 1.885614248566012],
            [32.06648806118768, 1.885873513687165],
            [32.06542630552245, 1.888271156450668],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 71,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "KIRYANDONGO TOWN COUNCIL",
        Population: 5972,
        Key: "KIRYANDONGOKIRYANDONGO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.100150928968496, 1.724732355901237],
            [32.09638582999964, 1.726114618800878],
            [32.09338609026294, 1.726076995571654],
            [32.09085490189699, 1.72375996674374],
            [32.089606013683344, 1.720557034571385],
            [32.08893839474736, 1.72024914470304],
            [32.08624505238778, 1.722798853931577],
            [32.08463543938357, 1.725520957181869],
            [32.08406451151149, 1.725692557258493],
            [32.08218227059837, 1.725157922192072],
            [32.08041244126664, 1.726296870701524],
            [32.07765977775897, 1.728900804473113],
            [32.0751140420753, 1.72941518352062],
            [32.07394591420234, 1.728898982621143],
            [32.072006076008115, 1.728970396702931],
            [32.0710086909212, 1.729738822073862],
            [32.06705984156096, 1.730587201134508],
            [32.06618055978111, 1.731120483324973],
            [32.062733252420415, 1.733906539529931],
            [32.06032750929231, 1.739207304605412],
            [32.0578967813212, 1.747127863439316],
            [32.0567516080987, 1.749026953774748],
            [32.05421585808774, 1.751992769100793],
            [32.048062180100885, 1.756838296370825],
            [32.04371457128099, 1.762236528254734],
            [32.03975922260968, 1.76796964224952],
            [32.01918351584279, 1.757501690145347],
            [32.01659147739613, 1.755745404909075],
            [32.013359434225286, 1.754640085056426],
            [32.00999961468843, 1.755063454636337],
            [32.0063415742402, 1.754726800970678],
            [32.00318327377102, 1.754978392658253],
            [32.00168791928446, 1.755484159171954],
            [32.00085822360995, 1.756243567854747],
            [31.9995855381261, 1.755890092367389],
            [31.988154099741596, 1.756489964128193],
            [31.983145656961014, 1.755682144716089],
            [31.976923574960253, 1.755506853434367],
            [31.96208071062244, 1.757597231313762],
            [31.9575139308395, 1.757793674952428],
            [31.950478557299633, 1.757237913493951],
            [31.945540260366332, 1.758212049740487],
            [31.94411284097314, 1.758817300924701],
            [31.94328337796228, 1.760131042264343],
            [31.937352622303084, 1.760679304571867],
            [31.937255292537003, 1.760419965748504],
            [31.927394222456844, 1.761782602390103],
            [31.926386166282676, 1.763320904814652],
            [31.923531214308547, 1.764721322512153],
            [31.9205058923492, 1.764402957005059],
            [31.915869660218398, 1.761388038672323],
            [31.913673785100222, 1.758365504925929],
            [31.913138832958644, 1.757010719657592],
            [31.913278087997362, 1.751363944151136],
            [31.910220791403763, 1.738833951756801],
            [31.913027540678073, 1.736158071907148],
            [31.91961743787195, 1.728391653796263],
            [31.914586445581097, 1.717181202302459],
            [31.913575429458085, 1.713227676099286],
            [31.913754495135244, 1.696999884926679],
            [31.91457552745714, 1.689049220920122],
            [31.91405215549791, 1.686090998547946],
            [31.91069809056876, 1.677550024791122],
            [31.908378812083384, 1.673713372397981],
            [31.9058096716933, 1.671152016911485],
            [31.903871036343258, 1.667813093455304],
            [31.903601982830832, 1.666311005219219],
            [31.903847157326382, 1.664773750863742],
            [31.9049296200572, 1.662992369620908],
            [31.908390912390253, 1.659927831533367],
            [31.912125949238142, 1.658636378508419],
            [31.930086556008344, 1.655217926636007],
            [31.933892673849726, 1.653908364456908],
            [31.93997062385809, 1.650718502648325],
            [31.943443911395118, 1.649851975385892],
            [31.94716695124237, 1.649464996986356],
            [31.948498909365277, 1.648579222657996],
            [31.952091115879625, 1.644845229951652],
            [31.957265305016634, 1.643934338033251],
            [31.962356095460976, 1.642426362731601],
            [31.966459630221543, 1.640121824619573],
            [31.968743217742375, 1.637725871817143],
            [31.97125290403369, 1.632625327529521],
            [31.9727632127748, 1.627325250545577],
            [31.974464002085377, 1.618036052877681],
            [31.975891328952105, 1.616245704315221],
            [31.983015825249645, 1.61298375829114],
            [31.986227530562434, 1.613844730501377],
            [31.987131334552952, 1.61470454218462],
            [31.989343763825172, 1.615782111049275],
            [31.994874720673895, 1.616463319012034],
            [31.996468701195514, 1.617350611573592],
            [32.000179778178115, 1.617849982687753],
            [32.002127466749606, 1.620944650586398],
            [32.004378950278806, 1.623198200552341],
            [32.00536977676584, 1.62363289683993],
            [32.00773222379217, 1.623018943620508],
            [32.00884531098938, 1.623896948460946],
            [32.00848812735767, 1.625353167042631],
            [32.012946324178955, 1.627264061334715],
            [32.014273333482954, 1.627264715044531],
            [32.01593411542403, 1.625999100169339],
            [32.01665751524762, 1.625872811975253],
            [32.01801042118465, 1.626343864923466],
            [32.01895513085993, 1.627475073096808],
            [32.023120536187385, 1.628454073206657],
            [32.02710088766796, 1.628139406389295],
            [32.029617919483385, 1.626792777827363],
            [32.03423341131089, 1.628251415199793],
            [32.035446508846995, 1.62798062052372],
            [32.039981974257415, 1.624653869191693],
            [32.04396995962133, 1.624854788222835],
            [32.04948673386834, 1.623111527257835],
            [32.05277566015959, 1.624261930118136],
            [32.05576438026271, 1.624634228240064],
            [32.0570530449788, 1.625575625221117],
            [32.05895883612543, 1.625992640291344],
            [32.070419404179646, 1.625563779415082],
            [32.071681977328346, 1.625844794025996],
            [32.074484986916104, 1.627555804449839],
            [32.07817627311472, 1.627982675937427],
            [32.08192766648729, 1.632154663067],
            [32.08436024139459, 1.633711714585194],
            [32.08367462201693, 1.634742658049641],
            [32.0833668834551, 1.638749949304833],
            [32.086585740255885, 1.640325458395046],
            [32.09049189897889, 1.64089715882701],
            [32.09122150166951, 1.642001123190403],
            [32.09189727371502, 1.644733368433016],
            [32.092806540360755, 1.646108799990032],
            [32.094666890228744, 1.647095682132129],
            [32.09557515615124, 1.648208775153155],
            [32.09394644316751, 1.649962982673489],
            [32.092954346462676, 1.652205971661976],
            [32.09246795185544, 1.656186052574061],
            [32.09279425230599, 1.657696909706122],
            [32.098319846212476, 1.668998107437512],
            [32.10137949998536, 1.679764456973418],
            [32.10136329527595, 1.682025991062688],
            [32.10081091761447, 1.684043029516727],
            [32.097226570460556, 1.690844067062238],
            [32.09612173698419, 1.694995733437702],
            [32.09572141445593, 1.699835235448066],
            [32.098339358518764, 1.713677089048379],
            [32.09901635586631, 1.720344428261248],
            [32.100150928968496, 1.724732355901237],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 72,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "MASINDI PORT",
        Population: 8875,
        Key: "KIRYANDONGOMASINDI PORT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.18075472023683, 1.97582389394002],
            [32.179769077927304, 1.977076812674612],
            [32.17846994963479, 1.976189702033276],
            [32.1763400827237, 1.973180946971449],
            [32.17067929955346, 1.970959139966028],
            [32.16885128095091, 1.970614717733071],
            [32.16768337047024, 1.971644640872573],
            [32.16680755798398, 1.973923717389778],
            [32.16576865096799, 1.974902680391842],
            [32.16615534425679, 1.976144109122055],
            [32.16542932943741, 1.978089042850929],
            [32.16472415104108, 1.978753530977571],
            [32.163182131770434, 1.979085170735497],
            [32.16176406563598, 1.978736416604607],
            [32.1579891867086, 1.97882499692699],
            [32.15532923472813, 1.978549130785904],
            [32.153693407087324, 1.976283644937259],
            [32.148784511115, 1.972300838754232],
            [32.141691127068995, 1.972022667817823],
            [32.13864416289781, 1.976306048163057],
            [32.13602392094448, 1.97841284512407],
            [32.133184724522145, 1.981837124582688],
            [32.12825078980784, 1.984118362411684],
            [32.126896960402746, 1.985259565496449],
            [32.126026399467605, 1.980515734969652],
            [32.12506708408412, 1.978538820683451],
            [32.12336547101844, 1.976956794676219],
            [32.11895709745777, 1.975988204949939],
            [32.11668771589487, 1.974976831772006],
            [32.11625154250192, 1.974317797955123],
            [32.1162525180723, 1.972473161928032],
            [32.116558547140166, 1.971594925214949],
            [32.11738826167927, 1.970980489265352],
            [32.117257606212796, 1.970409460952104],
            [32.11548987085396, 1.97007911586341],
            [32.1132206851238, 1.96871638377304],
            [32.11151911787216, 1.967090434123952],
            [32.11124666872797, 1.962762557248738],
            [32.10979312902124, 1.960359868597964],
            [32.10974270927929, 1.958834069209975],
            [32.11057220013792, 1.957853320951279],
            [32.112221138690295, 1.956857537703898],
            [32.112741653108635, 1.955782589263495],
            [32.11352449984444, 1.955255052896494],
            [32.11364167159855, 1.954420078051535],
            [32.11489728999028, 1.95269854348604],
            [32.11557089619766, 1.950943471836812],
            [32.11432957449366, 1.947729287003409],
            [32.11246061607032, 1.945459321595172],
            [32.11338300081417, 1.943381408423287],
            [32.11554121765729, 1.941656445551664],
            [32.11596680350631, 1.940629537667396],
            [32.116112748298946, 1.936229813381277],
            [32.11502941510057, 1.934886771397192],
            [32.11310357894671, 1.933916513510431],
            [32.1126511262842, 1.933322136886735],
            [32.11201251035546, 1.928543903623978],
            [32.11153521298712, 1.927377378807614],
            [32.10941369232334, 1.923451255883334],
            [32.106164596433466, 1.919875157133171],
            [32.10391787128032, 1.916414459358094],
            [32.104652820743496, 1.915696341815681],
            [32.104151786292086, 1.914529918654692],
            [32.104581750529796, 1.909604551638565],
            [32.10332580425295, 1.904947902067244],
            [32.104628012868616, 1.902773162627054],
            [32.11106821839677, 1.898325576770418],
            [32.111461037297495, 1.901149560404362],
            [32.11264778724629, 1.904230746682629],
            [32.113758676265995, 1.904484973149395],
            [32.11686916659909, 1.906629989063603],
            [32.11844978198592, 1.908221997324384],
            [32.12069255365347, 1.90949980878295],
            [32.127311423311866, 1.911630968743227],
            [32.1300327868201, 1.911983902610593],
            [32.13304886601351, 1.911356362023511],
            [32.13961388616221, 1.910934134612472],
            [32.14097500988745, 1.910231731045883],
            [32.14292540957444, 1.907845909771439],
            [32.149197792739535, 1.904204076963],
            [32.15031964569729, 1.903927098814483],
            [32.15248250054222, 1.904705882415345],
            [32.15675511261231, 1.905206948816785],
            [32.16407438252808, 1.904174404935429],
            [32.16637325937504, 1.903620452175688],
            [32.1686541465601, 1.902233876208686],
            [32.172094376993, 1.899071617539496],
            [32.17404402748505, 1.898165934984384],
            [32.177960804294685, 1.8982788298574],
            [32.180217109082, 1.898745033899339],
            [32.17775906513976, 1.911288800509246],
            [32.17487687175461, 1.913251271483321],
            [32.168927800345095, 1.914651135188062],
            [32.16074835581557, 1.915488772775433],
            [32.15740670290872, 1.916246474977135],
            [32.14478249855793, 1.921233383059249],
            [32.14337780474477, 1.922574007245998],
            [32.141739946013125, 1.925052492344131],
            [32.14126071816523, 1.927272530201236],
            [32.14127817871941, 1.929122773215709],
            [32.1418843951108, 1.930362738224218],
            [32.14600246191774, 1.932529602077117],
            [32.14743602488915, 1.934103029508152],
            [32.149669556485726, 1.938016992245103],
            [32.15181350179395, 1.940266274257628],
            [32.14881562516316, 1.947101668928442],
            [32.151621221898964, 1.949170709989184],
            [32.15503982089979, 1.952798911424222],
            [32.15654661992308, 1.955056967590797],
            [32.157950790018425, 1.959351674892648],
            [32.16222814159994, 1.958651181225996],
            [32.165298465561776, 1.956593950615166],
            [32.16734578628141, 1.954330321222888],
            [32.16864167974058, 1.954399594910709],
            [32.17361982683822, 1.956323597726815],
            [32.176757076187016, 1.95687415761833],
            [32.17754561464847, 1.957468334713713],
            [32.17893946310117, 1.957355618835464],
            [32.18765852113032, 1.965064643620284],
            [32.18569802617614, 1.969256697655149],
            [32.18075472023683, 1.97582389394002],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 73,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "BWEYALE TOWN COUNCIL",
        Population: 31173,
        Key: "KIRYANDONGOBWEYALE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19579238687855, 1.965554374687647],
            [31.325912189770033, 1.934771069711711],
            [31.358505237709277, 1.9351468164549],
            [31.377588003762767, 1.93435139157058],
            [31.38169864060399, 1.932673229219787],
            [31.38742570147584, 1.932552107338599],
            [31.39458811566153, 1.933011129496244],
            [31.398937485179374, 1.933765895275576],
            [31.402087464554075, 1.934836045521114],
            [31.407718704829538, 1.93391891872633],
            [31.409951909439368, 1.932555419338809],
            [31.411877190434385, 1.932774285168089],
            [31.41370676132576, 1.932314775438599],
            [31.418650091519595, 1.932337506949665],
            [31.420420935049293, 1.933116935705622],
            [31.421727672072286, 1.932467005361064],
            [31.42384306892076, 1.93274934147325],
            [31.42419901557233, 1.931772942277974],
            [31.424650360612087, 1.931818583977461],
            [31.42552915909837, 1.930408565807316],
            [31.42621824956628, 1.930336858980616],
            [31.427002609963367, 1.930816911927254],
            [31.428189983342982, 1.928927856795948],
            [31.429615926804146, 1.928766393516191],
            [31.42952050056814, 1.92837741977357],
            [31.43079169305199, 1.927582741388962],
            [31.43143326982789, 1.927556206703987],
            [31.431647387767452, 1.928080947866637],
            [31.432479192686245, 1.927982237608356],
            [31.433215495910574, 1.927268455054702],
            [31.433262670039383, 1.926671604442777],
            [31.43487823168737, 1.925569748354822],
            [31.437301996816714, 1.924685688236339],
            [31.437705227191568, 1.923591749540648],
            [31.438751045845326, 1.92382785625005],
            [31.43939259836673, 1.923520955498807],
            [31.440366345185264, 1.922391364931392],
            [31.440818268740085, 1.923042942113987],
            [31.442006348195513, 1.922826981242769],
            [31.44290962846822, 1.923207656005705],
            [31.442838713663054, 1.923659785510252],
            [31.44375367293276, 1.923552100496285],
            [31.4442294126224, 1.924267005969738],
            [31.445274528793586, 1.923426882160655],
            [31.446154575039806, 1.924648617723414],
            [31.446534601930832, 1.924359561964889],
            [31.44691505552165, 1.924839239517495],
            [31.44719996609548, 1.924432523281969],
            [31.447628171431866, 1.924912244806668],
            [31.447960685529214, 1.924668363225818],
            [31.449006850034387, 1.925772682583725],
            [31.449600917609857, 1.92548382004453],
            [31.450052677671312, 1.926008783604222],
            [31.450741860665694, 1.925837580627715],
            [31.45078971661583, 1.926344084256136],
            [31.45157397370665, 1.926335758886109],
            [31.451574101267404, 1.926815088430998],
            [31.45221587387607, 1.926888027197752],
            [31.45285803635355, 1.927774923243092],
            [31.453618350647098, 1.927531431720286],
            [31.45390386668543, 1.928011023088186],
            [31.45624481882365, 1.928329701355114],
            [31.46009576708928, 1.9296898131206],
            [31.4636602426108, 1.929141376656828],
            [31.467819386680716, 1.929208464321541],
            [31.470634834341922, 1.927908676708376],
            [31.475721753047377, 1.929902962989853],
            [31.47850251136557, 1.929715547827305],
            [31.481937131819528, 1.930867235706686],
            [31.484457482011557, 1.93292250994508],
            [31.487927617360267, 1.933323566190607],
            [31.4895901770673, 1.931507191153309],
            [31.491016141189736, 1.931363763224738],
            [31.49156241210391, 1.93081256116298],
            [31.491609432620816, 1.930052897439319],
            [31.492227584029077, 1.930171022623562],
            [31.494234829107228, 1.928318769662309],
            [31.494779716615874, 1.925506531895093],
            [31.495492647473124, 1.925172533798133],
            [31.495348790365206, 1.922974681667453],
            [31.496251721193246, 1.922830778078991],
            [31.496940786508343, 1.922162123574952],
            [31.497938878569403, 1.922090655218566],
            [31.497796062608895, 1.921584056954818],
            [31.498627758831528, 1.921630014956496],
            [31.500338459254653, 1.920627626747573],
            [31.502176432987206, 1.921524623719378],
            [31.503413282877723, 1.921136816375714],
            [31.50367467915069, 1.921598299814506],
            [31.50505387787776, 1.921934149895349],
            [31.509193219485564, 1.919324027669956],
            [31.51266513888841, 1.919634576084333],
            [31.513569165661107, 1.91920124568445],
            [31.51375905244416, 1.919852595142111],
            [31.51623264173242, 1.919538212215734],
            [31.51727828790966, 1.921329881503762],
            [31.517372575081875, 1.922740862458657],
            [31.51834743581137, 1.923555695323842],
            [31.518132568676858, 1.925156334644122],
            [31.519630892095428, 1.925157646341958],
            [31.52074881312718, 1.924579792619566],
            [31.523959175458643, 1.925297091218755],
            [31.526980288810886, 1.923644624209093],
            [31.526671224335708, 1.923074567448189],
            [31.52686190612779, 1.922477812331447],
            [31.5283363972419, 1.922759465969456],
            [31.53038259955898, 1.92032833167401],
            [31.53245150230331, 1.920583362887634],
            [31.53454565938524, 1.917908062832609],
            [31.535712335580694, 1.915159603854905],
            [31.53535618321496, 1.913802653391391],
            [31.536593114852177, 1.913324370639942],
            [31.537045298918425, 1.912411284118981],
            [31.538115570612533, 1.912032341533173],
            [31.538425415723697, 1.910694050595975],
            [31.539115294912456, 1.910378091219999],
            [31.53785534035283, 1.909517801922401],
            [31.53604784555953, 1.909398676041135],
            [31.535429625879328, 1.90901828461228],
            [31.534860204481987, 1.906078401048977],
            [31.53545534015434, 1.90485793253783],
            [31.535098759292186, 1.90433305676904],
            [31.535551095173716, 1.903564678728335],
            [31.535408699624778, 1.902877190329462],
            [31.53693061280272, 1.902878492168324],
            [31.53922371617734, 1.903945268882623],
            [31.539665353123866, 1.903658638235113],
            [31.539677846892832, 1.902792000685402],
            [31.543054816166766, 1.90551561346931],
            [31.550687461572753, 1.908524828319358],
            [31.554183448638703, 1.909007144502554],
            [31.556489660229936, 1.910013023036875],
            [31.55986710022109, 1.909509392973562],
            [31.56081761031816, 1.911608494629502],
            [31.565905368050103, 1.915293861083753],
            [31.568496440807852, 1.917991282825263],
            [31.571943723914035, 1.920689426642937],
            [31.57303708320928, 1.92229121515462],
            [31.579361044943056, 1.927840787250962],
            [31.579812515746976, 1.928456190624424],
            [31.580642918395593, 1.932807281268498],
            [31.581570604097948, 1.932663349781516],
            [31.582640140071835, 1.934554545610906],
            [31.583400969100055, 1.935079765834698],
            [31.58539715142549, 1.938762552437029],
            [31.586466792502303, 1.939857836144273],
            [31.589248542560554, 1.942030856636843],
            [31.592078496216953, 1.942657306765935],
            [31.592791233038096, 1.944276873403854],
            [31.594051985301714, 1.943581503478032],
            [31.597475763988474, 1.946288687859873],
            [31.60170829233228, 1.948336298631843],
            [31.611005285092695, 1.954024048173229],
            [31.613002195053546, 1.955888898604278],
            [31.62008829915246, 1.95937696384318],
            [31.62251341714463, 1.961504462771602],
            [31.623046523248274, 1.962970136650498],
            [31.620976802138717, 1.963881925536682],
            [31.619431350405392, 1.962994267399666],
            [31.618289425490968, 1.964006314907238],
            [31.615102568477226, 1.963117285016138],
            [31.61289122167491, 1.962039130999301],
            [31.612273226573517, 1.960989442489629],
            [31.610727545769798, 1.960391207736782],
            [31.608395636971533, 1.963120719055429],
            [31.607610730398775, 1.96314719572257],
            [31.607397065210115, 1.962333003227591],
            [31.60654080635264, 1.962359417959792],
            [31.60639771191443, 1.963164266264158],
            [31.6043995676684, 1.963813796022485],
            [31.60423249629689, 1.965414541703669],
            [31.60375656706273, 1.966155794734322],
            [31.600569051583914, 1.967093738873885],
            [31.598571782296965, 1.965681101770182],
            [31.598000899340644, 1.965752974080667],
            [31.596978183559337, 1.966303826241077],
            [31.59593085214264, 1.967731974756693],
            [31.593243189830577, 1.968218097739877],
            [31.591244586545436, 1.970079567448901],
            [31.58917497053877, 1.970864673353214],
            [31.588532486464437, 1.971895199648444],
            [31.587438045597587, 1.972545468472548],
            [31.587223663553342, 1.973259799218064],
            [31.58429792702976, 1.973908495491987],
            [31.582275902868517, 1.974883564823747],
            [31.580611171035137, 1.974574620152456],
            [31.579112575427047, 1.975125042050943],
            [31.577899778826588, 1.974888842882435],
            [31.577280866545255, 1.976272109349746],
            [31.57525872200981, 1.977057229387892],
            [31.57228603413956, 1.976439637064179],
            [31.570668898643184, 1.976655301970866],
            [31.56529274756907, 1.978929821667441],
            [31.564364871423898, 1.979598296494403],
            [31.551609849909863, 1.994510302513906],
            [31.539133632222345, 2.010561873089497],
            [31.538046993223748, 2.16192408869633],
            [31.528993077392663, 2.16023945087686],
            [31.529532529195507, 2.160068649890159],
            [31.52286445970731, 2.159473379530831],
            [31.51821712170466, 2.15559542114025],
            [31.51720042283915, 2.155842323407623],
            [31.51634007395219, 2.153672376560666],
            [31.515324577930826, 2.152679789996242],
            [31.50973774587144, 2.148893873556461],
            [31.509031204730782, 2.146940996749063],
            [31.507923676308586, 2.145576475000019],
            [31.508171497240955, 2.14412032518991],
            [31.50783349533554, 2.143283344645068],
            [31.506756467412156, 2.142228725616086],
            [31.50583245671766, 2.142196832575471],
            [31.505062992184616, 2.14160732288696],
            [31.50229090260891, 2.141573612015543],
            [31.501211318080255, 2.143152882912417],
            [31.500090374217574, 2.143113767101927],
            [31.499067399721476, 2.143829130071365],
            [31.497108823568766, 2.143712780916238],
            [31.49157693067553, 2.141994822356988],
            [31.490548466574705, 2.139878085199515],
            [31.48937171667167, 2.138975307093983],
            [31.48885976768956, 2.139094992422292],
            [31.486779366509584, 2.138288634717337],
            [31.485542038715348, 2.137219339503027],
            [31.483493143249, 2.137126906115427],
            [31.48301211607561, 2.137651133011881],
            [31.481987526408634, 2.137533516746914],
            [31.48069004562632, 2.136511908138631],
            [31.479576042147546, 2.136894190620573],
            [31.478173514172557, 2.136075008242701],
            [31.476305254638493, 2.135910925567762],
            [31.47518873587694, 2.134984268325497],
            [31.474103762354865, 2.134795332936451],
            [31.473981594171175, 2.13393873541985],
            [31.47295592203429, 2.133249938646116],
            [31.470817624434243, 2.133657397725201],
            [31.47054463630086, 2.132705800314675],
            [31.469881364312528, 2.132468700714666],
            [31.468797547820547, 2.132874739850465],
            [31.46813368024917, 2.132328245839215],
            [31.46719963177968, 2.132281904219658],
            [31.466685993066527, 2.131521028183638],
            [31.4656006224891, 2.131117899912236],
            [31.46363737599525, 2.128550251567694],
            [31.46333431136785, 2.127622500091185],
            [31.462082434459255, 2.12680311797855],
            [31.460632652405344, 2.124901143949507],
            [31.460478673080804, 2.123164038011637],
            [31.46068726907631, 2.12197381759607],
            [31.46110960751556, 2.122258831704874],
            [31.46138015762125, 2.121949091366916],
            [31.461197138458537, 2.120783194992533],
            [31.460048720521225, 2.118928423654757],
            [31.45914471620642, 2.118834435250059],
            [31.45832976547897, 2.11805016566647],
            [31.457905692392895, 2.11686079413555],
            [31.45507418465105, 2.117102574057555],
            [31.453898491166765, 2.116723369381404],
            [31.45261984805596, 2.117641330779442],
            [31.452591141492743, 2.11837913375269],
            [31.451537459885298, 2.118785120937006],
            [31.45120903761406, 2.120332476827985],
            [31.45066779546884, 2.12088056670987],
            [31.448719468195215, 2.121343971006206],
            [31.448890705952994, 2.12109712153809],
            [31.439555603963242, 2.12115041528049],
            [31.43862774847934, 2.116505717846901],
            [31.438386372959116, 2.112305377658738],
            [31.43900291368808, 2.109711824406296],
            [31.438699145679784, 2.106499678653281],
            [31.438947187597734, 2.104029285087198],
            [31.438395250110766, 2.103411068235136],
            [31.438151887517126, 2.101187242360667],
            [31.434261004645563, 2.093493454373138],
            [31.434450029944273, 2.088614132126961],
            [31.43392213317092, 2.086437114795165],
            [31.43248714457315, 2.085693940926199],
            [31.42206032720515, 2.082182474076944],
            [31.421222798221354, 2.08529970976123],
            [31.42035039753657, 2.083539910197844],
            [31.417887630252515, 2.08277789088231],
            [31.415902197167753, 2.081496672547092],
            [31.41125458697558, 2.080212757307518],
            [31.40704474827923, 2.078249703682199],
            [31.39701790399484, 2.072343184071341],
            [31.326016107780394, 2.055731046344356],
            [31.280754744616647, 2.04955695589292],
            [31.26031598242155, 2.050297547729491],
            [31.24271825639857, 2.025959005687978],
            [31.19579238687855, 1.965554374687647],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 75,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "BULIISA",
        Population: 17138,
        Key: "BULIISABULIISA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.26031598242155, 2.050297547729491],
            [31.280754744616647, 2.04955695589292],
            [31.326016107780394, 2.055731046344356],
            [31.39701790399484, 2.072343184071341],
            [31.40704474827923, 2.078249703682199],
            [31.41125458697558, 2.080212757307518],
            [31.415902197167753, 2.081496672547092],
            [31.417887630252515, 2.08277789088231],
            [31.42035039753657, 2.083539910197844],
            [31.421222798221354, 2.08529970976123],
            [31.42206032720515, 2.082182474076944],
            [31.43248714457315, 2.085693940926199],
            [31.43392213317092, 2.086437114795165],
            [31.434450029944273, 2.088614132126961],
            [31.434261004645563, 2.093493454373138],
            [31.438151887517126, 2.101187242360667],
            [31.438395250110766, 2.103411068235136],
            [31.438947187597734, 2.104029285087198],
            [31.438699145679784, 2.106499678653281],
            [31.43900291368808, 2.109711824406296],
            [31.438386372959116, 2.112305377658738],
            [31.43862774847934, 2.116505717846901],
            [31.439555603963242, 2.12115041528049],
            [31.439682785644543, 2.121924983652193],
            [31.438922521656664, 2.123157054814309],
            [31.435324717739803, 2.124411241576606],
            [31.435150474219068, 2.129968749775618],
            [31.43210617265441, 2.136608102887549],
            [31.428655156149922, 2.138160960784211],
            [31.41873925200651, 2.140825434793013],
            [31.410572748606935, 2.141313661341612],
            [31.40156449324345, 2.139722202421903],
            [31.398420874839267, 2.139916544882075],
            [31.395644935982602, 2.140778331292515],
            [31.389063075117257, 2.141117261557419],
            [31.373691570201036, 2.139569161711915],
            [31.320633429547403, 2.138289443535801],
            [31.30638684623395, 2.137450297271074],
            [31.306289414059894, 2.113617965270804],
            [31.26031598242155, 2.050297547729491],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 76,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "BULIISA TOWN COUNCIL",
        Population: 7238,
        Key: "BULIISABULIISA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19579238687855, 1.965554374687647],
            [31.100024457794174, 1.851894361287752],
            [31.25069786889651, 1.810352924789197],
            [31.30868297333783, 1.798425984390785],
            [31.321095024364578, 1.791311357604667],
            [31.32290033176014, 1.78978469163051],
            [31.32556156743316, 1.789615318792174],
            [31.326488104190254, 1.788992175803799],
            [31.328436619211775, 1.789039183277889],
            [31.32969572396515, 1.788687645386184],
            [31.33034874527777, 1.788028075176827],
            [31.331726980112553, 1.787929860800523],
            [31.333246810995664, 1.78623108751477],
            [31.33303281882026, 1.785588809574382],
            [31.332557574102353, 1.785633591293349],
            [31.333863276266133, 1.783437231430239],
            [31.334766261891396, 1.783700312985783],
            [31.3357166498176, 1.78341178999631],
            [31.342489053236147, 1.783535515183373],
            [31.343678273551987, 1.785634680420663],
            [31.34329809215069, 1.785842334696306],
            [31.343465092555302, 1.786900573641409],
            [31.345651191308228, 1.786676472146052],
            [31.34588911729773, 1.787255470838008],
            [31.346660820432447, 1.786098604598905],
            [31.349333751272134, 1.785440850767061],
            [31.350521095007345, 1.784311486339296],
            [31.35151896787945, 1.784004907979635],
            [31.351209956404897, 1.783769498230832],
            [31.351660382468125, 1.781952159528238],
            [31.35268112824399, 1.779610807088244],
            [31.35270335975066, 1.777033425118557],
            [31.354152256963992, 1.776121329939079],
            [31.355150593366766, 1.77655631503433],
            [31.35555462863212, 1.776366764636775],
            [31.355696556158808, 1.77562532095814],
            [31.357288191179208, 1.774641001955928],
            [31.358523978362754, 1.77493150076487],
            [31.360305168687887, 1.773015860071141],
            [31.361991632564617, 1.771823614484709],
            [31.362694611885154, 1.771730004501699],
            [31.37798138770377, 1.782038995380243],
            [31.380870331029943, 1.785200286477161],
            [31.38583873859325, 1.788706490938453],
            [31.389928525536703, 1.793287452057196],
            [31.392293416878967, 1.794109623732151],
            [31.394789685933205, 1.796137243249456],
            [31.39643014528761, 1.797568584806768],
            [31.39809486184961, 1.799883173890551],
            [31.410469714538785, 1.810606271387167],
            [31.420680598472057, 1.818418289012677],
            [31.42827596020048, 1.823414966359522],
            [31.432627739898273, 1.828688146706982],
            [31.435563914845428, 1.831013936237074],
            [31.437061527696628, 1.831848561105237],
            [31.440127440930418, 1.832443509253571],
            [31.443312610009716, 1.833778436416042],
            [31.453594058405184, 1.839704521604324],
            [31.45863318673752, 1.841563503069768],
            [31.460737316915733, 1.843245243331161],
            [31.47560535384444, 1.848834245963418],
            [31.478149429441473, 1.850981238106461],
            [31.486671809423978, 1.85554762414502],
            [31.49073721339571, 1.858266618540335],
            [31.506264118771217, 1.871455692247982],
            [31.51118532256131, 1.87489672485257],
            [31.514679343215082, 1.879031177198727],
            [31.520598702846566, 1.884073485582656],
            [31.527635940390674, 1.888900480430377],
            [31.53006060024202, 1.891338074963478],
            [31.53922371617734, 1.903945268882623],
            [31.53693061280272, 1.902878492168324],
            [31.535408699624778, 1.902877190329462],
            [31.535551095173716, 1.903564678728335],
            [31.535098759292186, 1.90433305676904],
            [31.53545534015434, 1.90485793253783],
            [31.534860204481987, 1.906078401048977],
            [31.535429625879328, 1.90901828461228],
            [31.53604784555953, 1.909398676041135],
            [31.53785534035283, 1.909517801922401],
            [31.539115294912456, 1.910378091219999],
            [31.538425415723697, 1.910694050595975],
            [31.538115570612533, 1.912032341533173],
            [31.537045298918425, 1.912411284118981],
            [31.536593114852177, 1.913324370639942],
            [31.53535618321496, 1.913802653391391],
            [31.535712335580694, 1.915159603854905],
            [31.53454565938524, 1.917908062832609],
            [31.53245150230331, 1.920583362887634],
            [31.53038259955898, 1.92032833167401],
            [31.5283363972419, 1.922759465969456],
            [31.52686190612779, 1.922477812331447],
            [31.526671224335708, 1.923074567448189],
            [31.526980288810886, 1.923644624209093],
            [31.523959175458643, 1.925297091218755],
            [31.52074881312718, 1.924579792619566],
            [31.519630892095428, 1.925157646341958],
            [31.518132568676858, 1.925156334644122],
            [31.51834743581137, 1.923555695323842],
            [31.517372575081875, 1.922740862458657],
            [31.51727828790966, 1.921329881503762],
            [31.51623264173242, 1.919538212215734],
            [31.51375905244416, 1.919852595142111],
            [31.513569165661107, 1.91920124568445],
            [31.51266513888841, 1.919634576084333],
            [31.509193219485564, 1.919324027669956],
            [31.50505387787776, 1.921934149895349],
            [31.50367467915069, 1.921598299814506],
            [31.503413282877723, 1.921136816375714],
            [31.502176432987206, 1.921524623719378],
            [31.500338459254653, 1.920627626747573],
            [31.498627758831528, 1.921630014956496],
            [31.497796062608895, 1.921584056954818],
            [31.497938878569403, 1.922090655218566],
            [31.496940786508343, 1.922162123574952],
            [31.496251721193246, 1.922830778078991],
            [31.495348790365206, 1.922974681667453],
            [31.495492647473124, 1.925172533798133],
            [31.494779716615874, 1.925506531895093],
            [31.494234829107228, 1.928318769662309],
            [31.492227584029077, 1.930171022623562],
            [31.491609432620816, 1.930052897439319],
            [31.49156241210391, 1.93081256116298],
            [31.491016141189736, 1.931363763224738],
            [31.4895901770673, 1.931507191153309],
            [31.487927617360267, 1.933323566190607],
            [31.484457482011557, 1.93292250994508],
            [31.481937131819528, 1.930867235706686],
            [31.47850251136557, 1.929715547827305],
            [31.475721753047377, 1.929902962989853],
            [31.470634834341922, 1.927908676708376],
            [31.467819386680716, 1.929208464321541],
            [31.4636602426108, 1.929141376656828],
            [31.46009576708928, 1.9296898131206],
            [31.45624481882365, 1.928329701355114],
            [31.45390386668543, 1.928011023088186],
            [31.453618350647098, 1.927531431720286],
            [31.45285803635355, 1.927774923243092],
            [31.45221587387607, 1.926888027197752],
            [31.451574101267404, 1.926815088430998],
            [31.45157397370665, 1.926335758886109],
            [31.45078971661583, 1.926344084256136],
            [31.450741860665694, 1.925837580627715],
            [31.450052677671312, 1.926008783604222],
            [31.449600917609857, 1.92548382004453],
            [31.449006850034387, 1.925772682583725],
            [31.447960685529214, 1.924668363225818],
            [31.447628171431866, 1.924912244806668],
            [31.44719996609548, 1.924432523281969],
            [31.44691505552165, 1.924839239517495],
            [31.446534601930832, 1.924359561964889],
            [31.446154575039806, 1.924648617723414],
            [31.445274528793586, 1.923426882160655],
            [31.4442294126224, 1.924267005969738],
            [31.44375367293276, 1.923552100496285],
            [31.442838713663054, 1.923659785510252],
            [31.44290962846822, 1.923207656005705],
            [31.442006348195513, 1.922826981242769],
            [31.440818268740085, 1.923042942113987],
            [31.440366345185264, 1.922391364931392],
            [31.43939259836673, 1.923520955498807],
            [31.438751045845326, 1.92382785625005],
            [31.437705227191568, 1.923591749540648],
            [31.437301996816714, 1.924685688236339],
            [31.43487823168737, 1.925569748354822],
            [31.433262670039383, 1.926671604442777],
            [31.433215495910574, 1.927268455054702],
            [31.432479192686245, 1.927982237608356],
            [31.431647387767452, 1.928080947866637],
            [31.43143326982789, 1.927556206703987],
            [31.43079169305199, 1.927582741388962],
            [31.42952050056814, 1.92837741977357],
            [31.429615926804146, 1.928766393516191],
            [31.428189983342982, 1.928927856795948],
            [31.427002609963367, 1.930816911927254],
            [31.42621824956628, 1.930336858980616],
            [31.42552915909837, 1.930408565807316],
            [31.424650360612087, 1.931818583977461],
            [31.42419901557233, 1.931772942277974],
            [31.42384306892076, 1.93274934147325],
            [31.421727672072286, 1.932467005361064],
            [31.420420935049293, 1.933116935705622],
            [31.418650091519595, 1.932337506949665],
            [31.41370676132576, 1.932314775438599],
            [31.411877190434385, 1.932774285168089],
            [31.409951909439368, 1.932555419338809],
            [31.407718704829538, 1.93391891872633],
            [31.402087464554075, 1.934836045521114],
            [31.398937485179374, 1.933765895275576],
            [31.39458811566153, 1.933011129496244],
            [31.38742570147584, 1.932552107338599],
            [31.38169864060399, 1.932673229219787],
            [31.377588003762767, 1.93435139157058],
            [31.358505237709277, 1.9351468164549],
            [31.325912189770033, 1.934771069711711],
            [31.19579238687855, 1.965554374687647],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 77,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "BUTIABA",
        Population: 28911,
        Key: "BULIISABUTIABA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.008786461456786, 1.836601031547729],
            [32.00837056303983, 1.838203570591356],
            [32.007444076588406, 1.838112592939681],
            [32.007533920693206, 1.841767189607308],
            [32.0067746367673, 1.842101461377835],
            [32.00753655006204, 1.843105984922638],
            [32.007252509057416, 1.843630487580671],
            [32.00794524129552, 1.84577475655135],
            [32.00742403068281, 1.846398631440988],
            [32.00780454895234, 1.846679268450344],
            [32.00769973172836, 1.847737580394142],
            [32.008388999164396, 1.848027437193667],
            [32.00767800866815, 1.84891353668278],
            [32.00839137610665, 1.849311957410099],
            [32.00829792167268, 1.850144128875469],
            [32.00746794213056, 1.85079496636066],
            [32.00687970372295, 1.853725507575355],
            [32.00599193735521, 1.855217579264412],
            [32.00501921102283, 1.855913562076218],
            [32.00573517010092, 1.857705056348973],
            [32.00516602538465, 1.858129890535005],
            [32.00559466370901, 1.858772393103805],
            [32.00504915187125, 1.85913391926733],
            [32.00505085148376, 1.860110877494796],
            [32.00428057846699, 1.860987891062346],
            [32.004401181785475, 1.861847319977088],
            [32.00304880495614, 1.86270590988964],
            [32.001770586748485, 1.865075203696435],
            [31.999999914797005, 1.864884226962367],
            [31.999380436577066, 1.865381395633561],
            [31.997727480758734, 1.8691525785509],
            [31.9961492261445, 1.870490459781851],
            [31.995293576344793, 1.87179257200396],
            [31.99372727112045, 1.878259460585473],
            [31.99108668771584, 1.881668214453803],
            [31.991322253831108, 1.882410112608909],
            [31.99031950580195, 1.8829975082424],
            [31.989623354575887, 1.888786447399329],
            [31.99062506594922, 1.88999917900838],
            [31.99027009486807, 1.891690545214029],
            [31.991684103312398, 1.893618141834838],
            [31.9924506635921, 1.893862828681047],
            [31.992538701184905, 1.89465891609458],
            [31.99463147396295, 1.895139572485902],
            [31.997268425478893, 1.89857854446258],
            [31.997916716263234, 1.898814115918313],
            [31.997857199282404, 1.899709622224237],
            [31.99850563559384, 1.90018038681237],
            [31.9987999946478, 1.901284155409728],
            [31.998268479460517, 1.902676910039697],
            [31.998651248908114, 1.90344603276853],
            [31.997943194106245, 1.904042646366767],
            [31.99763287109133, 1.905281749681853],
            [31.996246992491812, 1.905697046424617],
            [31.995332258699243, 1.90708957303381],
            [31.995330671376134, 1.909821423665222],
            [31.99388465146667, 1.912190586829488],
            [31.99412024453138, 1.912398781148194],
            [31.993662952644435, 1.913203593044046],
            [31.993957393445104, 1.91367415193305],
            [31.993042841112246, 1.914741022503646],
            [31.99268744243301, 1.917617395258331],
            [31.992068206758187, 1.917653210782407],
            [31.991743556512834, 1.918394778348175],
            [31.99206732101932, 1.919163868898769],
            [31.99166705328829, 1.922845293862357],
            [31.990056895006738, 1.925277668934564],
            [31.989029340001007, 1.925476063880621],
            [31.988343603842353, 1.926316917495294],
            [31.987656628008608, 1.929726789254138],
            [31.98645703933777, 1.93101962467039],
            [31.98555619260116, 1.933579055133661],
            [31.98606957439614, 1.934384444201927],
            [31.985526535620384, 1.9357319468675],
            [31.984698569202795, 1.935731447689235],
            [31.98347092165405, 1.936481510467591],
            [31.982984787558266, 1.937566716031023],
            [31.982271011386317, 1.937828613739891],
            [31.981414018605275, 1.938913593092031],
            [31.97944405810295, 1.939717475808831],
            [31.97794386978184, 1.942357941953598],
            [31.977429985828618, 1.942393811722304],
            [31.97734393441093, 1.942990783391093],
            [31.97668736744786, 1.943424581761621],
            [31.974346572514804, 1.943251280591879],
            [31.973261520839316, 1.944200425892168],
            [31.972490553424823, 1.944254228241701],
            [31.971918977867407, 1.945375556189367],
            [31.969977041208697, 1.94674932322262],
            [31.969490293563563, 1.949281845398821],
            [31.969775532920796, 1.949625761175096],
            [31.882037389039606, 1.964910287093631],
            [31.880766899936653, 1.960076966115294],
            [31.8821667275759, 1.958325997005975],
            [31.882339104397467, 1.95666039257511],
            [31.88331050032489, 1.955311220575194],
            [31.88386866762836, 1.952956588209417],
            [31.88546765266441, 1.952182221391812],
            [31.886009800311445, 1.95246978475554],
            [31.88692365465336, 1.95180984067851],
            [31.887009907293667, 1.950862146909487],
            [31.88581249434243, 1.94867864704985],
            [31.88659919305419, 1.946036973380078],
            [31.88757059616812, 1.944659072304981],
            [31.889569731255914, 1.94305209586595],
            [31.89005597494618, 1.941530270598968],
            [31.891055536651027, 1.940726781980154],
            [31.891327849251294, 1.938975061034298],
            [31.892441439505074, 1.938401400254927],
            [31.89481232440687, 1.935732024078531],
            [31.89599911298324, 1.932315132764771],
            [31.895401335365612, 1.929787407307169],
            [31.896174014969045, 1.926686192018048],
            [31.895964188281614, 1.92008050715054],
            [31.896351503204595, 1.917007750137424],
            [31.896899053319707, 1.916240834916324],
            [31.89800793370643, 1.917597481783538],
            [31.89931852270536, 1.917903923919019],
            [31.90246825414502, 1.916892681093607],
            [31.903747664417086, 1.915960645435415],
            [31.906725082815584, 1.912507953645614],
            [31.911117280412917, 1.906517092941477],
            [31.912563064065473, 1.905472079145881],
            [31.915913303069818, 1.904865428427604],
            [31.917491616074564, 1.905980045955799],
            [31.921624966817756, 1.907185368385415],
            [31.920892231701732, 1.905734019485336],
            [31.918616658949865, 1.903747157848727],
            [31.915650410203618, 1.898371392640491],
            [31.913633063570067, 1.895879333455562],
            [31.910975603516224, 1.895729114102714],
            [31.906742462521393, 1.896914729294127],
            [31.90536447472331, 1.896913851223212],
            [31.90413440980814, 1.896467454464034],
            [31.901773958838362, 1.893594219295117],
            [31.898182738674187, 1.891413373824205],
            [31.8971508178562, 1.888937090230159],
            [31.896955652572498, 1.886263292515173],
            [31.89774521870663, 1.88284743501958],
            [31.8948944034744, 1.877201198398187],
            [31.89337153808223, 1.872843135829441],
            [31.89190192032858, 1.870209570673249],
            [31.891011852477078, 1.869412570668495],
            [31.88937989657516, 1.868216880090245],
            [31.886708949215592, 1.867020526991194],
            [31.88592678519941, 1.866205924307431],
            [31.885257592415005, 1.863735611549424],
            [31.883746203000626, 1.861551949105374],
            [31.88210804063839, 1.856726005712613],
            [31.879427110301116, 1.85345025516124],
            [31.877173195930737, 1.851955395068538],
            [31.880116154056644, 1.847013181954284],
            [31.882018931355475, 1.842883571169417],
            [31.882121942067407, 1.840937713163594],
            [31.881749329870722, 1.839913308154482],
            [31.882938966106522, 1.836670852250156],
            [31.883041568085037, 1.835373635336849],
            [31.8835850066111, 1.8345205010387],
            [31.885824740176393, 1.834146378348798],
            [31.88609644910881, 1.833736880084174],
            [31.886135992049276, 1.824655917664134],
            [31.890992215304962, 1.818138371252399],
            [31.886180351756344, 1.807654695354314],
            [31.88601159065379, 1.80618661284511],
            [31.886758599999663, 1.805333596721408],
            [31.890499739103266, 1.803474811298097],
            [31.892714125804495, 1.799512842923176],
            [31.897326298357033, 1.79506408786341],
            [31.898326532900043, 1.792939429265175],
            [31.900440129524696, 1.790413363474471],
            [31.906150125101124, 1.787630975166176],
            [31.90929127493489, 1.784990625368548],
            [31.90960597813512, 1.783727187432206],
            [31.9062556591807, 1.778096086708497],
            [31.90595824315982, 1.774247434929675],
            [31.90738492234121, 1.769424463005675],
            [31.90803001961473, 1.768698167497255],
            [31.912912801561774, 1.767236630867368],
            [31.913671291376982, 1.766504864567008],
            [31.91406628240406, 1.765132199269064],
            [31.9139762900772, 1.763454159751952],
            [31.913138832958644, 1.757010719657592],
            [31.913673785100222, 1.758365504925929],
            [31.915869660218398, 1.761388038672323],
            [31.9205058923492, 1.764402957005059],
            [31.923531214308547, 1.764721322512153],
            [31.926386166282676, 1.763320904814652],
            [31.927394222456844, 1.761782602390103],
            [31.937255292537003, 1.760419965748504],
            [31.937352622303084, 1.760679304571867],
            [31.94328337796228, 1.760131042264343],
            [31.94411284097314, 1.758817300924701],
            [31.945540260366332, 1.758212049740487],
            [31.950478557299633, 1.757237913493951],
            [31.9575139308395, 1.757793674952428],
            [31.96208071062244, 1.757597231313762],
            [31.976923574960253, 1.755506853434367],
            [31.983145656961014, 1.755682144716089],
            [31.988154099741596, 1.756489964128193],
            [31.9995855381261, 1.755890092367389],
            [32.00085822360995, 1.756243567854747],
            [32.00168791928446, 1.755484159171954],
            [32.00318327377102, 1.754978392658253],
            [32.0063415742402, 1.754726800970678],
            [32.00999961468843, 1.755063454636337],
            [32.013359434225286, 1.754640085056426],
            [32.01659147739613, 1.755745404909075],
            [32.01918351584279, 1.757501690145347],
            [32.03975922260968, 1.76796964224952],
            [32.04371457128099, 1.762236528254734],
            [32.048062180100885, 1.756838296370825],
            [32.05421585808774, 1.751992769100793],
            [32.0567516080987, 1.749026953774748],
            [32.0578967813212, 1.747127863439316],
            [32.06032750929231, 1.739207304605412],
            [32.062733252420415, 1.733906539529931],
            [32.06618055978111, 1.731120483324973],
            [32.06705984156096, 1.730587201134508],
            [32.0710086909212, 1.729738822073862],
            [32.072006076008115, 1.728970396702931],
            [32.07394591420234, 1.728898982621143],
            [32.0751140420753, 1.72941518352062],
            [32.07765977775897, 1.728900804473113],
            [32.08041244126664, 1.726296870701524],
            [32.08218227059837, 1.725157922192072],
            [32.08406451151149, 1.725692557258493],
            [32.08463543938357, 1.725520957181869],
            [32.08624505238778, 1.722798853931577],
            [32.08893839474736, 1.72024914470304],
            [32.089606013683344, 1.720557034571385],
            [32.09085490189699, 1.72375996674374],
            [32.09338609026294, 1.726076995571654],
            [32.09638582999964, 1.726114618800878],
            [32.100150928968496, 1.724732355901237],
            [32.102626695772976, 1.732033789268913],
            [32.10626902738187, 1.73786126005687],
            [32.10452726321622, 1.739624431862628],
            [32.10338396118448, 1.742998104249464],
            [32.10098933919957, 1.745864586531435],
            [32.10057756943964, 1.74747460455272],
            [32.10125322111091, 1.748632839007339],
            [32.10137453409847, 1.749917451661434],
            [32.10028760584235, 1.75285692852442],
            [32.10077716790926, 1.754250273281201],
            [32.10049366679211, 1.754919551873324],
            [32.099068276693124, 1.754783168063684],
            [32.09783394837359, 1.755171552974556],
            [32.09657264903601, 1.753814017833691],
            [32.095313810183974, 1.753768174034986],
            [32.09436529973671, 1.754518541620712],
            [32.09472623383473, 1.756988314534983],
            [32.09425229975879, 1.757567036081382],
            [32.09304027750613, 1.75714127508205],
            [32.09066551098397, 1.757221526949724],
            [32.08609493042908, 1.757970107240926],
            [32.08264875674228, 1.756765271627891],
            [32.080238090846414, 1.756736938612302],
            [32.07921821014815, 1.75750535085391],
            [32.07746588808298, 1.760091664337067],
            [32.07683012071201, 1.762977052458631],
            [32.076779136828044, 1.767228692639459],
            [32.07736656315864, 1.770078507089487],
            [32.07786614413591, 1.77048583241788],
            [32.078344311971776, 1.77215055442452],
            [32.077822687235724, 1.772575459894036],
            [32.07818136117248, 1.773869231526448],
            [32.07799409836834, 1.775325559686004],
            [32.07731931626626, 1.776410751952943],
            [32.0777254850304, 1.777668364053253],
            [32.076969132307276, 1.779513386888248],
            [32.07730331008455, 1.780345796090542],
            [32.07922959090448, 1.781667498050985],
            [32.079198628671584, 1.784046607315686],
            [32.080893992157826, 1.788733343762591],
            [32.081810479461836, 1.789719831685877],
            [32.08140828933609, 1.790624239688636],
            [32.08205343422032, 1.792650893362215],
            [32.08497716211093, 1.793765040855988],
            [32.08483625686704, 1.794642442382868],
            [32.08535990820234, 1.795239749807568],
            [32.08514277192343, 1.79969032981348],
            [32.0837209741873, 1.8013088640003],
            [32.08285466138518, 1.801661223710708],
            [32.082808546370046, 1.802303473561369],
            [32.08169325830042, 1.802782351138943],
            [32.08133809587812, 1.803451582495248],
            [32.08160051982374, 1.803958297334552],
            [32.0809123447391, 1.804265515224767],
            [32.08148455630373, 1.805505122987827],
            [32.08134698560616, 1.808119377126922],
            [32.07835309480029, 1.80739416000995],
            [32.077780824845185, 1.80627215192176],
            [32.07702152924115, 1.806660745061811],
            [32.07635610309277, 1.806425206243857],
            [32.07495612543487, 1.807093899333886],
            [32.07216574885493, 1.807264340809048],
            [32.068750714369116, 1.809894986570881],
            [32.064914988056, 1.81001964284792],
            [32.06239862458719, 1.810552051007206],
            [32.05824832712619, 1.813788367723454],
            [32.05382296732181, 1.815966135769356],
            [32.049081634099394, 1.82064946706988],
            [32.04567554503718, 1.82167889854139],
            [32.04140421216805, 1.82367578042497],
            [32.038744661734526, 1.824018098604026],
            [32.03426300001973, 1.821618495820672],
            [32.031016769755595, 1.821621396810566],
            [32.030749414059045, 1.819744935733472],
            [32.03119151094299, 1.815056463607416],
            [32.02912111519864, 1.81442033273002],
            [32.030939600879435, 1.806662265153586],
            [32.02855974540118, 1.794575922440031],
            [32.0295801992246, 1.788501366308085],
            [32.029561405570526, 1.779079739436488],
            [32.02606304605394, 1.779651824133495],
            [32.02182206276669, 1.781534749931558],
            [32.017739146138496, 1.781665629560599],
            [32.015461079663424, 1.787119930720276],
            [32.00229710011627, 1.781705978536664],
            [32.00045719500586, 1.782484328949619],
            [31.992736359293485, 1.782212187603667],
            [31.988621577625562, 1.782502172530783],
            [31.986104132585115, 1.782987872893742],
            [31.98334417026576, 1.784350208299376],
            [31.98254256311357, 1.789586039019084],
            [31.98302000241571, 1.801568857902148],
            [31.985809234541957, 1.802937343359436],
            [31.98750480374244, 1.805065771241576],
            [31.98742510610875, 1.806534171604206],
            [31.98679350692067, 1.807486322604415],
            [31.981822280444007, 1.810261655717976],
            [31.97751105339312, 1.815820752707019],
            [31.976625814884613, 1.820564680183139],
            [31.976963584126377, 1.823296271902516],
            [31.978381571209084, 1.826710217005983],
            [31.985762947050315, 1.830061057817998],
            [31.995015486678934, 1.830556527615651],
            [32.008786461456786, 1.836601031547729],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 82,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "KIGUMBA",
        Population: 43940,
        Key: "KIRYANDONGOKIGUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.615459009141766, 0.694064111006211],
            [30.61431902638497, 0.692612348466894],
            [30.61245037967702, 0.691302452379192],
            [30.605631048268027, 0.689103867574235],
            [30.602846183750675, 0.689654256948205],
            [30.600920140085982, 0.68873715148019],
            [30.59921947114965, 0.685368892804032],
            [30.595845933440092, 0.681926542166347],
            [30.59389962917246, 0.676823305906608],
            [30.592837566283425, 0.675509029221111],
            [30.589074510981803, 0.672461303050496],
            [30.585655929947283, 0.671956741506415],
            [30.580797937908812, 0.670591895414947],
            [30.57763883793905, 0.674676460139752],
            [30.574488920548113, 0.685563489900143],
            [30.571205883611835, 0.688554554240685],
            [30.570187656712033, 0.688940675251019],
            [30.567334999933454, 0.687719419316153],
            [30.565199453873117, 0.690073901462632],
            [30.56261844134826, 0.691063164888042],
            [30.56031807599287, 0.691218416609213],
            [30.557252165454038, 0.690045901209468],
            [30.55495547151322, 0.688500526274292],
            [30.552934956521675, 0.687655291410746],
            [30.552176424485637, 0.687778355332467],
            [30.550615026757704, 0.688666911892751],
            [30.550275959450364, 0.689275528595553],
            [30.549718658122792, 0.693131684947416],
            [30.548124373072323, 0.697041059401677],
            [30.54751069257922, 0.697686586761624],
            [30.5421986704366, 0.690687185292571],
            [30.535673628013, 0.683028492025276],
            [30.530370343783144, 0.677836752120125],
            [30.526119313737752, 0.674399346384943],
            [30.526011122441567, 0.672327766899683],
            [30.52660841676554, 0.670597458300466],
            [30.52589266519831, 0.670283162894114],
            [30.52138200766277, 0.67105146447191],
            [30.519892654820616, 0.670509193190836],
            [30.51770040620122, 0.668904374534797],
            [30.51687342703214, 0.667737628596232],
            [30.51476376053685, 0.666486919837832],
            [30.514267609327334, 0.665716062909752],
            [30.51156038619998, 0.664506708394383],
            [30.51013561593856, 0.66326239978257],
            [30.5086163474008, 0.660965782841953],
            [30.507905468295657, 0.657330338455458],
            [30.503202717714714, 0.654381447925457],
            [30.499321669598874, 0.650714950491291],
            [30.49756388577678, 0.650164581894804],
            [30.496138622340247, 0.650522373992514],
            [30.493597029686658, 0.648203421416571],
            [30.49288441054484, 0.647988067698238],
            [30.487765420187078, 0.648188883114125],
            [30.48503366586595, 0.649597466124606],
            [30.483299639788164, 0.649142685492974],
            [30.48281270709009, 0.64838978385651],
            [30.482599006867176, 0.646502003191965],
            [30.484131311756315, 0.640947144236554],
            [30.482349881580994, 0.637696669676202],
            [30.480273631515967, 0.636083303477991],
            [30.495533906135385, 0.628731250057071],
            [30.49966958351513, 0.629056983810676],
            [30.503823755409982, 0.626651278229541],
            [30.506772255242847, 0.625993863011953],
            [30.510512179824172, 0.626219943791686],
            [30.511549935199984, 0.627176065060838],
            [30.514074778765053, 0.627914402698157],
            [30.51724361108264, 0.627033809187036],
            [30.52176358235106, 0.623272602834489],
            [30.523901490082228, 0.622841588798894],
            [30.525035008562252, 0.623254620524813],
            [30.5260973652004, 0.624210620170301],
            [30.526933678763626, 0.624206019272489],
            [30.529997886994988, 0.622043521392544],
            [30.531507917258367, 0.621480307280224],
            [30.53291320665453, 0.622138478500541],
            [30.53517091371202, 0.62609674630944],
            [30.536480341189293, 0.627273362945403],
            [30.539920040717845, 0.628968513171704],
            [30.544502988379246, 0.630546411957018],
            [30.54626236940591, 0.62814443394816],
            [30.554414794408338, 0.620182736486736],
            [30.5551845850298, 0.61662700926658],
            [30.554646099814196, 0.60962117013997],
            [30.55960225884862, 0.612052308814198],
            [30.566014518686597, 0.612941821882496],
            [30.56768572737318, 0.612636648397584],
            [30.57060336288954, 0.61067215020736],
            [30.570420204487945, 0.608428786846915],
            [30.576704456194594, 0.608283122455172],
            [30.58054828082001, 0.609593735347467],
            [30.58359536806036, 0.606432299008102],
            [30.58437297222818, 0.604479574816334],
            [30.586136673253055, 0.602965349043015],
            [30.58619250983617, 0.604321547492756],
            [30.58686572078483, 0.606167603670694],
            [30.586707173527042, 0.608955474409238],
            [30.58777479519108, 0.610972007876404],
            [30.590433834483225, 0.611450605721507],
            [30.59188460648057, 0.611230827432077],
            [30.5898721853097, 0.612441137656085],
            [30.58920205737912, 0.615530273726603],
            [30.589872374854224, 0.620123513130997],
            [30.590426161972385, 0.621269689885401],
            [30.592028792371856, 0.622884774550866],
            [30.594678316708507, 0.624569036566521],
            [30.596463176651582, 0.627782068141179],
            [30.599708559804387, 0.631574169623979],
            [30.605325614783215, 0.636277630332079],
            [30.610210380210415, 0.644108116052248],
            [30.610146589045467, 0.646356994690313],
            [30.607884084086045, 0.649954592653678],
            [30.607564410507344, 0.650830775385774],
            [30.60769593284808, 0.652254114226451],
            [30.609003552915, 0.657256157765909],
            [30.61166122766621, 0.660614371799823],
            [30.612360125940434, 0.663421209484272],
            [30.612252043340398, 0.666819591078466],
            [30.6125990544498, 0.669003758261968],
            [30.614684777249522, 0.675175813331883],
            [30.61465688006836, 0.685073684395116],
            [30.614403299138402, 0.686597363191835],
            [30.61591564615686, 0.692713953974996],
            [30.615459009141766, 0.694064111006211],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 85,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "BUTIITI",
        Population: 18855,
        Key: "KYENJOJOBUTIITI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.859198640060377, 0.47008613158455],
            [30.862789669781662, 0.48147747973891],
            [30.865546778153366, 0.485732512918399],
            [30.867495328209205, 0.487788139836836],
            [30.86810266839303, 0.491458041484948],
            [30.871477383793916, 0.495904207407973],
            [30.871810336269146, 0.496860478445347],
            [30.87180943975048, 0.499327942304131],
            [30.87271512211826, 0.502107905453516],
            [30.87209333163476, 0.503722286506998],
            [30.87132796880932, 0.509040531075975],
            [30.87136349897546, 0.5114765855697],
            [30.871665238587802, 0.517204179219446],
            [30.87260454399835, 0.52074126912527],
            [30.874149875357425, 0.523240132113172],
            [30.879127483465872, 0.527987175596047],
            [30.879325348186985, 0.528842718941307],
            [30.877938220030902, 0.535907029474152],
            [30.876989551480143, 0.538773035837759],
            [30.875810120105974, 0.540717732067229],
            [30.87625764011926, 0.544782555702145],
            [30.874750140410075, 0.546859573899588],
            [30.87475211131381, 0.548670212692564],
            [30.873755196944106, 0.552474546000266],
            [30.874905436664797, 0.553854933541481],
            [30.87346420028421, 0.556524379354519],
            [30.873235590722505, 0.557578297711921],
            [30.873762013360484, 0.558762402525208],
            [30.873091402136257, 0.560821277919618],
            [30.87072812057499, 0.560661372880892],
            [30.86925285062154, 0.562211578631458],
            [30.86219959791258, 0.565221353295645],
            [30.861773810840937, 0.566045210196996],
            [30.861531700498823, 0.569815083556106],
            [30.857626246953334, 0.570020344731898],
            [30.854181798930192, 0.571640251980931],
            [30.852640890875588, 0.573190558093305],
            [30.852411668662864, 0.573684816949932],
            [30.85280629227896, 0.574408280174209],
            [30.851035240340106, 0.575596906133655],
            [30.850740870506343, 0.576552174829295],
            [30.85176016999462, 0.578294942840456],
            [30.851449094191505, 0.57897042082513],
            [30.847803825989967, 0.580171339543698],
            [30.8459296753043, 0.576474199620216],
            [30.844864963283456, 0.572010188536463],
            [30.845370878281795, 0.569919831818423],
            [30.844925938230013, 0.558930158517746],
            [30.844140612144013, 0.55774334005632],
            [30.841224914293726, 0.549945097049974],
            [30.839205545552474, 0.546752045067233],
            [30.836400027868418, 0.544660485561874],
            [30.832078507022686, 0.544319908294474],
            [30.830787811215725, 0.543810931429288],
            [30.82877025078313, 0.535561094397937],
            [30.826448077027607, 0.530634941228419],
            [30.82471787058641, 0.529061965002535],
            [30.81999208001505, 0.522983343222504],
            [30.817586287479607, 0.521920096540952],
            [30.816447043137952, 0.520432335980063],
            [30.815730020454595, 0.518689749639264],
            [30.812884622961825, 0.515630511545233],
            [30.810806633758386, 0.512400556685662],
            [30.808252648845464, 0.511442864157521],
            [30.804808243941455, 0.508690857676737],
            [30.802016598042044, 0.507912491826183],
            [30.800763218251973, 0.506835128853628],
            [30.800977831163237, 0.503861346625391],
            [30.804399609301857, 0.498791072862796],
            [30.80546291725591, 0.497860890891042],
            [30.806295492929234, 0.495860507802758],
            [30.807358845799037, 0.494790742311128],
            [30.80514066012245, 0.494045567222332],
            [30.803985903672483, 0.491997993526504],
            [30.80390240167359, 0.487316116499601],
            [30.80550333335885, 0.48403091587188],
            [30.80540816224439, 0.481183174189422],
            [30.814514598976878, 0.478060578872289],
            [30.820558746279424, 0.477305713943446],
            [30.82428714817062, 0.476372200860196],
            [30.832089103549784, 0.476094985848155],
            [30.83958296732922, 0.477180648540036],
            [30.85076216237522, 0.477917767881531],
            [30.85393420616992, 0.472166907084788],
            [30.85738776670329, 0.469837707256577],
            [30.859198640060377, 0.47008613158455],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 86,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "BUTUNDUZI TOWN COUNCIL",
        Population: 14111,
        Key: "KYENJOJOBUTUNDUZI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.659210628604747, 0.860227108523017],
            [30.658426843129437, 0.860020911807864],
            [30.655712082238566, 0.860649126282237],
            [30.65389845015526, 0.859764571378874],
            [30.652664774910953, 0.85996502582513],
            [30.65239526146108, 0.856412676327136],
            [30.65186664334057, 0.85575379429747],
            [30.645545646047243, 0.854304655115909],
            [30.646351367483444, 0.851430097899588],
            [30.647799363686556, 0.848644657810268],
            [30.647451152427898, 0.848233014933357],
            [30.647580066959392, 0.846715203323254],
            [30.648556125143152, 0.844289390979092],
            [30.64947559844714, 0.843499233229647],
            [30.64976845641629, 0.841719307089227],
            [30.649227222355936, 0.840977596031109],
            [30.64975677652096, 0.839100766186365],
            [30.648086546998037, 0.838309772940582],
            [30.647219565849344, 0.837014033242884],
            [30.64478627139146, 0.838552170839398],
            [30.644322502651313, 0.837181773921399],
            [30.641242537969887, 0.835502695226641],
            [30.640119610627043, 0.833486433832518],
            [30.640014778131704, 0.832397251823662],
            [30.64146081331255, 0.829398551478232],
            [30.640149334083173, 0.827549845715927],
            [30.64013993860363, 0.826507198944999],
            [30.64124691276532, 0.825431037438804],
            [30.641452599117592, 0.824528690636323],
            [30.640628003178943, 0.822663840648551],
            [30.64074873765144, 0.821560815849024],
            [30.63985529303282, 0.818954838519648],
            [30.640878549599908, 0.816192091541788],
            [30.64189098326446, 0.80990317122282],
            [30.64172582081295, 0.806077413971458],
            [30.64102511692503, 0.804780223065499],
            [30.641297370236487, 0.80335593352896],
            [30.64044024091152, 0.799204529304029],
            [30.640520949149916, 0.797616055183247],
            [30.639707883087944, 0.795715563671404],
            [30.637818502364922, 0.794334106631151],
            [30.63681731650606, 0.793963802745222],
            [30.635117765073943, 0.795187441117419],
            [30.634356061984953, 0.795028296533756],
            [30.63505891733799, 0.792616756285205],
            [30.634037193296784, 0.789971633546046],
            [30.63387496653962, 0.786477636328929],
            [30.63343920457508, 0.785580984667069],
            [30.63382701985964, 0.782484973111989],
            [30.632422783288973, 0.774321676431322],
            [30.633756972827037, 0.773421175944096],
            [30.634466205320265, 0.770405261779321],
            [30.63382858921644, 0.766891783601542],
            [30.631986251468216, 0.762832106124624],
            [30.632116994071307, 0.761527565930934],
            [30.631279863041193, 0.756973162394708],
            [30.63218490401185, 0.754595353551247],
            [30.63201815783049, 0.753234212023468],
            [30.629590471554955, 0.750127674840249],
            [30.62954803963249, 0.748066331539687],
            [30.62782706068591, 0.746967489029323],
            [30.627640152716335, 0.745249688452509],
            [30.626609853357397, 0.743138321691298],
            [30.625351140269494, 0.742859736224746],
            [30.62462560335384, 0.739985570093874],
            [30.622783542286765, 0.739270113501471],
            [30.62211471242175, 0.73832229360765],
            [30.622489478778512, 0.737321250043795],
            [30.62141666036056, 0.736232926860552],
            [30.621547199944374, 0.735292404530839],
            [30.620787034771176, 0.735082465769958],
            [30.621538513235578, 0.733484727657796],
            [30.621008594354528, 0.731822587718437],
            [30.620032043894, 0.731019179334514],
            [30.619010659415963, 0.730763089586495],
            [30.616948555121695, 0.731154872285772],
            [30.616278706567144, 0.729993010296457],
            [30.616052607796657, 0.727377796624962],
            [30.616518600765453, 0.723153272080708],
            [30.615265380875535, 0.716630878924749],
            [30.616025204688935, 0.714307616099465],
            [30.614014320535535, 0.71056041381126],
            [30.613567175119705, 0.703938502130777],
            [30.613690821930355, 0.702522578235291],
            [30.614538297959275, 0.701162159350951],
            [30.615307707695067, 0.698375017977107],
            [30.61570625066077, 0.694935782898074],
            [30.615459009141766, 0.694064111006211],
            [30.61591564615686, 0.692713953974996],
            [30.614403299138402, 0.686597363191835],
            [30.61465688006836, 0.685073684395116],
            [30.620483947685884, 0.680772232055426],
            [30.63405189512471, 0.675441178793253],
            [30.6361082052854, 0.673860019949597],
            [30.641208775688245, 0.671393958704573],
            [30.644134185225052, 0.668024026185963],
            [30.649991012231286, 0.66495910186275],
            [30.65341600723695, 0.662169364237635],
            [30.656388928669138, 0.65875891946882],
            [30.657799875654998, 0.65594866398366],
            [30.660000275587247, 0.654723442982137],
            [30.663353299368993, 0.653908145671023],
            [30.665227830042028, 0.653969187608439],
            [30.66883805496433, 0.657243788778293],
            [30.6708076085298, 0.657328093713312],
            [30.675164003771513, 0.655496319099557],
            [30.678180402765125, 0.653755165352911],
            [30.68162050923053, 0.653760003364089],
            [30.684479287129427, 0.651317987443212],
            [30.687542209871655, 0.649386248941781],
            [30.689191054999235, 0.646950874421194],
            [30.697188508038725, 0.649820716356222],
            [30.697810335353104, 0.650840137023649],
            [30.704293553115406, 0.649698286550934],
            [30.706004395472338, 0.650235960125928],
            [30.70679486082006, 0.651777782848548],
            [30.70807784279369, 0.652151310499545],
            [30.710207120409944, 0.6509264002672],
            [30.711397600163817, 0.649361757050369],
            [30.711887209841436, 0.647598782499242],
            [30.711994356396936, 0.642828796344519],
            [30.713309312106485, 0.640038400599308],
            [30.718497895847577, 0.638558696150045],
            [30.721543777548867, 0.637982854292981],
            [30.724126552568325, 0.637961321213918],
            [30.727743863401557, 0.639566156054652],
            [30.73073397319842, 0.6421306094159],
            [30.731883363112853, 0.644288953454474],
            [30.73394848394984, 0.6444916346994],
            [30.737913304457503, 0.647455114229766],
            [30.744094167261487, 0.649942509293978],
            [30.74627590649033, 0.652154648422892],
            [30.746978713334325, 0.655171854470557],
            [30.747528231658244, 0.655953826263255],
            [30.750495809911133, 0.658756339677847],
            [30.754161004542322, 0.660673193167509],
            [30.75725679214915, 0.663483293281033],
            [30.75863752789369, 0.66426818938381],
            [30.761433337484444, 0.664465736294899],
            [30.764623604503004, 0.666559736838995],
            [30.76701830374302, 0.667367996946165],
            [30.766962326124393, 0.67091196208151],
            [30.76625162488567, 0.674039540330794],
            [30.76415045914792, 0.678589669037027],
            [30.766770723559144, 0.681734815735271],
            [30.76718881117046, 0.683488058106904],
            [30.766353005155402, 0.692546152856729],
            [30.76696418204376, 0.697138899355574],
            [30.766546336079266, 0.699781158508414],
            [30.764728490897273, 0.699556800334301],
            [30.761740140900066, 0.700765445401474],
            [30.757814688161428, 0.701106891946455],
            [30.754219188423253, 0.702115998945202],
            [30.753575574268265, 0.704271889368035],
            [30.75439986747466, 0.710403073410433],
            [30.753876440718177, 0.712411839892055],
            [30.752734466396404, 0.712976868830155],
            [30.74867659928992, 0.71390720250234],
            [30.7457565158644, 0.713542593839276],
            [30.740174601182897, 0.709802775412529],
            [30.73702906218065, 0.711865780940951],
            [30.73626996869756, 0.711893721779387],
            [30.732252657831225, 0.710321950097485],
            [30.730698019925782, 0.710199622430178],
            [30.72700359681024, 0.711599549815992],
            [30.72629244641387, 0.716622663575799],
            [30.72358692110239, 0.718909182532922],
            [30.7221431496761, 0.719630703715801],
            [30.720898266151977, 0.722230367869133],
            [30.71962275456828, 0.723402936225066],
            [30.71864968148621, 0.723336892857661],
            [30.714941708182877, 0.724391922175693],
            [30.71009933066069, 0.727541966679604],
            [30.70711915533257, 0.722410606795194],
            [30.705664992195054, 0.721655565382042],
            [30.704386736258158, 0.721699283817037],
            [30.70262213422303, 0.724715571868617],
            [30.69675885012653, 0.726797963731798],
            [30.695182260090515, 0.726945251330696],
            [30.693661445552152, 0.724577557662529],
            [30.68801692009195, 0.7259764683252],
            [30.68558773632482, 0.726123411025525],
            [30.68470412286863, 0.726715747548253],
            [30.683819139481667, 0.729975657151973],
            [30.680945857384163, 0.734864702418386],
            [30.680090175245095, 0.735916376797039],
            [30.678351373723267, 0.736475563338989],
            [30.680696830014366, 0.742157459971013],
            [30.68138506528614, 0.747631442056125],
            [30.68107170327061, 0.747704023344226],
            [30.683712239064537, 0.750550010298846],
            [30.68664480098764, 0.755607295985673],
            [30.687934129558755, 0.756306801717023],
            [30.689166928047324, 0.756011447900105],
            [30.69295503915882, 0.757162711931077],
            [30.695224868082747, 0.758564459705974],
            [30.699095182229264, 0.759608338905421],
            [30.69967330021688, 0.760480072693078],
            [30.70088859503217, 0.760872139284451],
            [30.70176708090469, 0.764739103138627],
            [30.703380516240422, 0.767118373208846],
            [30.703632488287706, 0.768703972860353],
            [30.702584355573762, 0.77627327095892],
            [30.702936379282473, 0.782348942234867],
            [30.703919047270077, 0.785918767956698],
            [30.70565403544352, 0.788605067247612],
            [30.707949016297103, 0.79804064046506],
            [30.709482574336057, 0.799472686250766],
            [30.709867936321615, 0.800487065598576],
            [30.708529353123478, 0.800603754346162],
            [30.707399275191005, 0.801751327955139],
            [30.703640646787115, 0.802554862290189],
            [30.70215248331442, 0.803516011945975],
            [30.700033778869035, 0.803060809365834],
            [30.69910871984059, 0.803234896542882],
            [30.69641877670607, 0.803981547677027],
            [30.695309882844622, 0.804844531603451],
            [30.693913564923164, 0.808079945428885],
            [30.693332167186448, 0.808105101144544],
            [30.68991310645155, 0.817503307249892],
            [30.690461097639503, 0.81802401566391],
            [30.690224946720964, 0.820058129013834],
            [30.689801644389426, 0.820641349834262],
            [30.69027020743825, 0.823070106749835],
            [30.692269259881044, 0.825417702434012],
            [30.68952278307072, 0.823726684060329],
            [30.6883406648355, 0.822162068273044],
            [30.68563835279784, 0.821633162316576],
            [30.68384955104727, 0.822962947894347],
            [30.68183769940833, 0.82543911604804],
            [30.680242035443882, 0.82749681740783],
            [30.67972120481857, 0.829031766440941],
            [30.676012691627754, 0.828436402896544],
            [30.674729864164362, 0.828993915397297],
            [30.67460563075384, 0.829523718595779],
            [30.677753957228415, 0.830858479472348],
            [30.67876485118058, 0.831962205893826],
            [30.6805330159341, 0.835442298928462],
            [30.680784300770206, 0.838157821206928],
            [30.677870543280914, 0.84427355450178],
            [30.67673713888696, 0.845317455856514],
            [30.67564568761338, 0.848123513316464],
            [30.67331113686985, 0.848585351252633],
            [30.672599074683493, 0.851480033325108],
            [30.669684497032353, 0.854989407790621],
            [30.66831919973433, 0.855084387766626],
            [30.667449126584426, 0.856087405738766],
            [30.661244317389926, 0.858322330205634],
            [30.659210628604747, 0.860227108523017],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 87,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KATOOKE",
        Population: 35277,
        Key: "KYENJOJOKATOOKE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.764014118243978, 0.779088055076005],
            [30.76246138925854, 0.778766386422303],
            [30.76045360878445, 0.779417172744501],
            [30.75876994944802, 0.779427130546317],
            [30.75032340434349, 0.780994880423854],
            [30.748442465987523, 0.780543357222864],
            [30.74797375471668, 0.781258524931433],
            [30.748155520729576, 0.782963289449014],
            [30.74728335450507, 0.783729438554574],
            [30.745157492283504, 0.782492244296052],
            [30.739068936764877, 0.780520014869686],
            [30.73700220524859, 0.780562095239066],
            [30.735422219580787, 0.781879589281378],
            [30.734511981856222, 0.783688859161386],
            [30.729857009071978, 0.787842061944274],
            [30.72639234895494, 0.794876006328211],
            [30.724751594953112, 0.797355293229035],
            [30.723990066137294, 0.800469786393966],
            [30.722581969505864, 0.80046730279459],
            [30.721330733096064, 0.801355263574378],
            [30.719454282723266, 0.801419304494469],
            [30.71853329396137, 0.802043656929476],
            [30.716612314998248, 0.80112456912415],
            [30.715805626974774, 0.801250223959957],
            [30.71609376339881, 0.806840682668395],
            [30.71482134381629, 0.808013209935486],
            [30.71428667464403, 0.806690803740973],
            [30.712191279683626, 0.806187993721951],
            [30.711687666169052, 0.805671062622442],
            [30.7114348793498, 0.803990674560007],
            [30.711847530357016, 0.802328075195911],
            [30.709867936321615, 0.800487065598576],
            [30.709482574336057, 0.799472686250766],
            [30.707949016297103, 0.79804064046506],
            [30.70565403544352, 0.788605067247612],
            [30.703919047270077, 0.785918767956698],
            [30.702936379282473, 0.782348942234867],
            [30.702584355573762, 0.77627327095892],
            [30.703632488287706, 0.768703972860353],
            [30.703380516240422, 0.767118373208846],
            [30.70176708090469, 0.764739103138627],
            [30.70088859503217, 0.760872139284451],
            [30.69967330021688, 0.760480072693078],
            [30.699095182229264, 0.759608338905421],
            [30.695224868082747, 0.758564459705974],
            [30.69295503915882, 0.757162711931077],
            [30.689166928047324, 0.756011447900105],
            [30.687934129558755, 0.756306801717023],
            [30.68664480098764, 0.755607295985673],
            [30.683712239064537, 0.750550010298846],
            [30.68107170327061, 0.747704023344226],
            [30.68138506528614, 0.747631442056125],
            [30.680696830014366, 0.742157459971013],
            [30.678351373723267, 0.736475563338989],
            [30.680090175245095, 0.735916376797039],
            [30.680945857384163, 0.734864702418386],
            [30.683819139481667, 0.729975657151973],
            [30.68470412286863, 0.726715747548253],
            [30.68558773632482, 0.726123411025525],
            [30.68801692009195, 0.7259764683252],
            [30.693661445552152, 0.724577557662529],
            [30.695182260090515, 0.726945251330696],
            [30.69675885012653, 0.726797963731798],
            [30.70262213422303, 0.724715571868617],
            [30.704386736258158, 0.721699283817037],
            [30.705664992195054, 0.721655565382042],
            [30.70711915533257, 0.722410606795194],
            [30.71009933066069, 0.727541966679604],
            [30.714941708182877, 0.724391922175693],
            [30.71864968148621, 0.723336892857661],
            [30.71962275456828, 0.723402936225066],
            [30.720898266151977, 0.722230367869133],
            [30.7221431496761, 0.719630703715801],
            [30.72358692110239, 0.718909182532922],
            [30.72629244641387, 0.716622663575799],
            [30.72700359681024, 0.711599549815992],
            [30.730698019925782, 0.710199622430178],
            [30.732252657831225, 0.710321950097485],
            [30.73626996869756, 0.711893721779387],
            [30.73702906218065, 0.711865780940951],
            [30.740174601182897, 0.709802775412529],
            [30.7457565158644, 0.713542593839276],
            [30.74867659928992, 0.71390720250234],
            [30.752734466396404, 0.712976868830155],
            [30.753876440718177, 0.712411839892055],
            [30.75439986747466, 0.710403073410433],
            [30.753575574268265, 0.704271889368035],
            [30.754219188423253, 0.702115998945202],
            [30.757814688161428, 0.701106891946455],
            [30.761740140900066, 0.700765445401474],
            [30.764728490897273, 0.699556800334301],
            [30.766546336079266, 0.699781158508414],
            [30.76652806344807, 0.701327911258624],
            [30.76862371173335, 0.703280864559498],
            [30.769648279840776, 0.704806269304078],
            [30.771172190871898, 0.706020497415056],
            [30.773159319077614, 0.706458271584715],
            [30.77430222225738, 0.707339124846074],
            [30.775708154847305, 0.709579739939772],
            [30.77597127768223, 0.711034991390061],
            [30.775553118205675, 0.712340103283662],
            [30.777194681589584, 0.714866520567798],
            [30.776856535055373, 0.718523407132711],
            [30.77382922153106, 0.718386470632392],
            [30.772954482531564, 0.718724654350337],
            [30.769120143217236, 0.718045534667522],
            [30.766832405479814, 0.718857078059744],
            [30.764005943574894, 0.720751912036418],
            [30.75788072691122, 0.727317930532043],
            [30.75495613214638, 0.72927326389434],
            [30.75242924760893, 0.731852565647135],
            [30.75148679899321, 0.733071084652489],
            [30.75188871064123, 0.736525112112848],
            [30.75316647879293, 0.737406149976681],
            [30.755419223556785, 0.741424259894898],
            [30.754732701372273, 0.741961036452976],
            [30.749249525015202, 0.743752093343945],
            [30.746301758207565, 0.746477357736094],
            [30.746435167010414, 0.749466240851922],
            [30.74784411883801, 0.750640658701624],
            [30.748968912879985, 0.75323784270007],
            [30.748401253977217, 0.754421078430043],
            [30.746689827715375, 0.755625708949337],
            [30.744522695093032, 0.75585419622555],
            [30.744407808653044, 0.757461501425345],
            [30.744690640525285, 0.761881907419147],
            [30.745486505646195, 0.763520755510267],
            [30.746766820521735, 0.764316174430922],
            [30.748521062286674, 0.764670322568853],
            [30.750204232939577, 0.766737545003515],
            [30.75305756884453, 0.767280554882934],
            [30.755653237383264, 0.769189055358088],
            [30.76071477778365, 0.769856962596004],
            [30.762036293889665, 0.770401936516755],
            [30.762215992879106, 0.771445220002116],
            [30.761789532969342, 0.772532272360211],
            [30.763851655229917, 0.774439591101457],
            [30.764014118243978, 0.779088055076005],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 88,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KATOOKE TOWN COUNCIL",
        Population: 14594,
        Key: "KYENJOJOKATOOKE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.839109555174463, 0.595438277458771],
            [30.83856194487221, 0.59558743106169],
            [30.83749300088808, 0.597260121170409],
            [30.83647073067117, 0.598073547217382],
            [30.834210853283963, 0.598531416010836],
            [30.832356099021894, 0.599608986901285],
            [30.831037507830427, 0.601461138512077],
            [30.831038712471198, 0.602606671600739],
            [30.831920155597672, 0.603655033688507],
            [30.832445496664008, 0.605467776134501],
            [30.83267480780998, 0.608605637185432],
            [30.831178737366134, 0.61140080955094],
            [30.829384331026542, 0.613325460491513],
            [30.82712521002079, 0.614523127181805],
            [30.824502190476593, 0.620458746545197],
            [30.824502733059006, 0.620983787304092],
            [30.825812888171665, 0.62246090346516],
            [30.82521918531218, 0.623559854481421],
            [30.82522058668402, 0.624920172525959],
            [30.82587578012302, 0.625766124929611],
            [30.826878035875403, 0.628628020980851],
            [30.826831427685196, 0.6295827279467],
            [30.824109571900184, 0.63201031470318],
            [30.826325097665197, 0.634678953837038],
            [30.826768304866818, 0.637649332290918],
            [30.826341180203734, 0.638771829768984],
            [30.824960984346685, 0.638607427625657],
            [30.824866960380852, 0.639729288926909],
            [30.823560514412016, 0.641879679896433],
            [30.824647536991236, 0.646232998239123],
            [30.82016815789559, 0.651838009194314],
            [30.819160205027654, 0.655073684909044],
            [30.816903133977377, 0.658347531719208],
            [30.815611373666822, 0.663302020018155],
            [30.815412318677954, 0.666488403754268],
            [30.814131012960647, 0.670022888455112],
            [30.813204562441836, 0.671528149707782],
            [30.81031556701337, 0.673430922601561],
            [30.809388643980718, 0.674458879902383],
            [30.80695430747714, 0.678962061063762],
            [30.805929922626028, 0.677675298430858],
            [30.805855793648778, 0.674907099168951],
            [30.80523558240358, 0.673309327856103],
            [30.803128529107447, 0.671941091235546],
            [30.79900778891424, 0.667390734458415],
            [30.797769962555016, 0.666796466415914],
            [30.796223029499778, 0.666417575487562],
            [30.794070611281796, 0.667268871883193],
            [30.78928905778917, 0.668113237202018],
            [30.784639271877367, 0.669852262436386],
            [30.781117038733758, 0.668952091587072],
            [30.7783319676039, 0.667620964227236],
            [30.776415241265337, 0.66620466850167],
            [30.772608093056313, 0.665877790063568],
            [30.77117935583461, 0.664687279177829],
            [30.76987606654567, 0.665040725376263],
            [30.768278624815263, 0.666673538496139],
            [30.76701830374302, 0.667367996946165],
            [30.764623604503004, 0.666559736838995],
            [30.761433337484444, 0.664465736294899],
            [30.75863752789369, 0.66426818938381],
            [30.75725679214915, 0.663483293281033],
            [30.754161004542322, 0.660673193167509],
            [30.750495809911133, 0.658756339677847],
            [30.747528231658244, 0.655953826263255],
            [30.746978713334325, 0.655171854470557],
            [30.74627590649033, 0.652154648422892],
            [30.744094167261487, 0.649942509293978],
            [30.737913304457503, 0.647455114229766],
            [30.73394848394984, 0.6444916346994],
            [30.731883363112853, 0.644288953454474],
            [30.73073397319842, 0.6421306094159],
            [30.727743863401557, 0.639566156054652],
            [30.724126552568325, 0.637961321213918],
            [30.723472078679862, 0.637200001234343],
            [30.721187653030874, 0.631253539047189],
            [30.719229961718703, 0.628416000788526],
            [30.71914711818491, 0.626767406380461],
            [30.71775286638861, 0.624488938551175],
            [30.71719348366457, 0.622218337613866],
            [30.7138131807426, 0.618938961440493],
            [30.713138395047267, 0.61600689318808],
            [30.7120312699686, 0.613839282640534],
            [30.709865377919684, 0.61174001563755],
            [30.70923564093919, 0.610369305792792],
            [30.70718932184112, 0.609780992040963],
            [30.706538356772157, 0.609159964329596],
            [30.705981414770726, 0.607389090344608],
            [30.705288955620496, 0.608467299044752],
            [30.703139773134154, 0.607229945664459],
            [30.70076975959817, 0.60669341025552],
            [30.698527564649, 0.607313716944029],
            [30.694629744986813, 0.6047036461902],
            [30.693113727452083, 0.603000562848613],
            [30.692408626310836, 0.601505360136682],
            [30.692067580014893, 0.595498318507939],
            [30.690259395315486, 0.592660042721875],
            [30.687415674079038, 0.589540206162952],
            [30.68446960778227, 0.58840725060116],
            [30.683017314038842, 0.586991174172216],
            [30.679905894847725, 0.585172057827225],
            [30.682497683562726, 0.581970436887699],
            [30.68302986440166, 0.580197729795357],
            [30.6841044803485, 0.578735987771967],
            [30.684410597451237, 0.577307059163548],
            [30.688827388226112, 0.575241562206299],
            [30.70184168239578, 0.572099323020941],
            [30.704906952435824, 0.570183384477952],
            [30.70772116760844, 0.567062507011609],
            [30.708767006923466, 0.566788603429101],
            [30.71298750413068, 0.566441152067951],
            [30.716801953846307, 0.567335815925599],
            [30.718758491721633, 0.568743489437426],
            [30.719500922354502, 0.570191429391276],
            [30.72086377982824, 0.570943383507492],
            [30.724205948368052, 0.570947103246416],
            [30.726350391342947, 0.572052144057377],
            [30.728747914886203, 0.572519083015206],
            [30.729955707870538, 0.573450633398418],
            [30.732833204863354, 0.574104798700752],
            [30.741185377455743, 0.571187541558655],
            [30.74613038749915, 0.568646692648989],
            [30.749980532670907, 0.567731601409154],
            [30.750515845935222, 0.567685656634445],
            [30.75053709199001, 0.569613339103575],
            [30.752008583629376, 0.569659918940466],
            [30.753693775491683, 0.570258357751738],
            [30.753072678507607, 0.563453154839314],
            [30.7533651106753, 0.55876327384959],
            [30.752419206240678, 0.553001945717173],
            [30.752511120962257, 0.549947152300656],
            [30.751952378736977, 0.545990098145571],
            [30.755787093547127, 0.543262454678925],
            [30.758371260955254, 0.542800978505337],
            [30.759979509418542, 0.541645449148118],
            [30.761990139348697, 0.539333933449295],
            [30.7639535349629, 0.538288126006303],
            [30.765092406503694, 0.535346414504986],
            [30.765495198500695, 0.533034290086211],
            [30.76687322582462, 0.531555459251617],
            [30.766554754191798, 0.529896302577714],
            [30.76247881837169, 0.526152404737509],
            [30.761358398226815, 0.522845141375352],
            [30.760222466871955, 0.521266657639755],
            [30.75716621681571, 0.519805840782742],
            [30.754051109142033, 0.516489157430695],
            [30.75161623275093, 0.514963432526629],
            [30.75093469441962, 0.510508227629729],
            [30.759404297480845, 0.495800793631996],
            [30.761544892073065, 0.48931338062082],
            [30.762376677228918, 0.488775474650451],
            [30.76588131956263, 0.488746756555774],
            [30.770514138993658, 0.490063892934087],
            [30.77176201390765, 0.488688936799311],
            [30.771673772397303, 0.486087649992699],
            [30.770813305831055, 0.483516008227786],
            [30.769774038590633, 0.482768175664037],
            [30.765828647744254, 0.477307236535025],
            [30.763405946220214, 0.474723137650028],
            [30.762123708949982, 0.472211175456956],
            [30.76205337265985, 0.46926906223524],
            [30.763266190819913, 0.465968568669879],
            [30.762571555950046, 0.463445652330967],
            [30.764683095432716, 0.460192459801946],
            [30.76523479576445, 0.455301767967216],
            [30.769742705353536, 0.451696043366037],
            [30.771906756754436, 0.450449132359232],
            [30.775733500813047, 0.449853644960134],
            [30.777887103908903, 0.447919643187805],
            [30.779673875466898, 0.447061343485239],
            [30.78114984700458, 0.445262732765789],
            [30.781284848520414, 0.444108925552475],
            [30.785586795076124, 0.449196003191774],
            [30.78696425376648, 0.452116342132535],
            [30.7886748733412, 0.453478590229036],
            [30.790659648859187, 0.457004423914283],
            [30.79427189858415, 0.460902785953146],
            [30.79413294088777, 0.462773422742509],
            [30.79258960289031, 0.467290427211899],
            [30.79280662777812, 0.468643753335354],
            [30.79422964362981, 0.469599448812404],
            [30.79446666321921, 0.470236352690023],
            [30.79159952829318, 0.472543929773198],
            [30.791875917448237, 0.473698266879463],
            [30.79685706581721, 0.475172539464626],
            [30.79974362142136, 0.47399931706978],
            [30.80225417279028, 0.474119529997831],
            [30.802669101026737, 0.474776396036608],
            [30.802430336010744, 0.47961225474188],
            [30.80298316821976, 0.481741839197626],
            [30.803457225364866, 0.482936053151017],
            [30.80550333335885, 0.48403091587188],
            [30.80390240167359, 0.487316116499601],
            [30.803985903672483, 0.491997993526504],
            [30.80514066012245, 0.494045567222332],
            [30.807358845799037, 0.494790742311128],
            [30.806295492929234, 0.495860507802758],
            [30.80546291725591, 0.497860890891042],
            [30.804399609301857, 0.498791072862796],
            [30.800977831163237, 0.503861346625391],
            [30.800763218251973, 0.506835128853628],
            [30.802016598042044, 0.507912491826183],
            [30.804808243941455, 0.508690857676737],
            [30.808252648845464, 0.511442864157521],
            [30.810806633758386, 0.512400556685662],
            [30.812884622961825, 0.515630511545233],
            [30.815730020454595, 0.518689749639264],
            [30.816447043137952, 0.520432335980063],
            [30.817586287479607, 0.521920096540952],
            [30.81999208001505, 0.522983343222504],
            [30.82471787058641, 0.529061965002535],
            [30.826448077027607, 0.530634941228419],
            [30.82877025078313, 0.535561094397937],
            [30.830787811215725, 0.543810931429288],
            [30.832078507022686, 0.544319908294474],
            [30.836400027868418, 0.544660485561874],
            [30.839205545552474, 0.546752045067233],
            [30.841224914293726, 0.549945097049974],
            [30.844140612144013, 0.55774334005632],
            [30.844925938230013, 0.558930158517746],
            [30.845370878281795, 0.569919831818423],
            [30.844864963283456, 0.572010188536463],
            [30.8459296753043, 0.576474199620216],
            [30.847803825989967, 0.580171339543698],
            [30.84656173263313, 0.581712427092835],
            [30.84511801690235, 0.582077399159535],
            [30.842920858989988, 0.583793560547889],
            [30.842628158226006, 0.586328992417489],
            [30.841644140070528, 0.586890560953326],
            [30.841103668679818, 0.587895688797308],
            [30.839109555174463, 0.595438277458771],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 90,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KIHUURA",
        Population: 29129,
        Key: "KYENJOJOKIHUURA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.53408297125794, 0.744173399134678],
            [30.54387789748541, 0.743931699043049],
            [30.553862388899084, 0.745816122606743],
            [30.558997569593195, 0.747028237826967],
            [30.55980795328573, 0.747549575672126],
            [30.561596615797416, 0.75009126834367],
            [30.565402129072584, 0.751894009793332],
            [30.566612978125512, 0.751812183909722],
            [30.56770335950558, 0.751541854698805],
            [30.568826462918185, 0.749636159714728],
            [30.569986372104633, 0.749175634660381],
            [30.572380685967367, 0.747294200977202],
            [30.575669925770665, 0.742106485753261],
            [30.577495788416556, 0.738440566755675],
            [30.577358123395896, 0.737223720841935],
            [30.57643123899082, 0.735230377374841],
            [30.57643275444869, 0.732427956082749],
            [30.57903353080812, 0.727820941142946],
            [30.579714239096152, 0.72744765297446],
            [30.581012389123327, 0.729316644516554],
            [30.584236994243607, 0.732237891688333],
            [30.585092435634188, 0.734923740232122],
            [30.58298347341806, 0.740823453118161],
            [30.583647906928075, 0.743617098708856],
            [30.58262590710406, 0.745203113846571],
            [30.580382890196407, 0.746967216862933],
            [30.57924870067488, 0.750720739330402],
            [30.579380494306843, 0.753245928635471],
            [30.58546169711487, 0.755416926290779],
            [30.588836149309373, 0.754949547397693],
            [30.594031460533667, 0.753477594001318],
            [30.595096791493738, 0.753858078453051],
            [30.596782666075644, 0.756093663539657],
            [30.599844560246826, 0.758888688059189],
            [30.602752454432224, 0.759180823298857],
            [30.60490625695407, 0.758265820293335],
            [30.60755078216618, 0.75949446319562],
            [30.60754962333945, 0.761590699341703],
            [30.606784179665645, 0.765014122109675],
            [30.604282580906833, 0.769903918686487],
            [30.60323839898349, 0.775213776451697],
            [30.60191769315786, 0.778497111638199],
            [30.597379629819592, 0.781880537813987],
            [30.59492346784787, 0.781964372466963],
            [30.59303248542869, 0.781082297242947],
            [30.59136660734501, 0.78150761267922],
            [30.590631541100848, 0.783354399147631],
            [30.58975608434744, 0.78386542627177],
            [30.589586240774985, 0.784661048867705],
            [30.58876706616909, 0.785484711385447],
            [30.58741209141198, 0.785284991543502],
            [30.586932556340276, 0.784602665645796],
            [30.58238778079023, 0.78388955186393],
            [30.58018567316063, 0.784058776824226],
            [30.579027568689582, 0.785166417875635],
            [30.579335077282693, 0.790395588157406],
            [30.57863406347601, 0.791926111289711],
            [30.578989071388108, 0.79244921495452],
            [30.5808498937699, 0.793309554220905],
            [30.58138490160704, 0.794679246601877],
            [30.582053687454593, 0.795076185602189],
            [30.584309807188973, 0.794985152807582],
            [30.58486964805384, 0.796473120667456],
            [30.587296550100138, 0.796878220798441],
            [30.58952073921773, 0.799832531575685],
            [30.593591717235785, 0.800768151548886],
            [30.593743878370177, 0.801386953935957],
            [30.59226614164299, 0.803099743915313],
            [30.59293031913313, 0.804917796358222],
            [30.5913611105538, 0.806830180607435],
            [30.58888949216928, 0.808024523989646],
            [30.586228260089523, 0.808453422369143],
            [30.582045198375152, 0.81103387264294],
            [30.581046707462146, 0.812085588327778],
            [30.57958141958814, 0.808066951692372],
            [30.57513968978431, 0.804761001014702],
            [30.574319398572523, 0.804622870816109],
            [30.565567896090275, 0.806131593190175],
            [30.56440575189541, 0.806062073163018],
            [30.560783255088037, 0.80475234929537],
            [30.555585529192246, 0.808258882811351],
            [30.552717620816775, 0.811111400263219],
            [30.552927100754495, 0.812524077523439],
            [30.551908176762037, 0.815964908194881],
            [30.55140868920953, 0.816897316893287],
            [30.548627723380516, 0.818976272827495],
            [30.54705841778313, 0.821055970513876],
            [30.545559855412705, 0.823996670856682],
            [30.545700415703507, 0.827225377526504],
            [30.545200211295416, 0.829305730200079],
            [30.542843788371357, 0.830426680441618],
            [30.54236712521364, 0.831838002644252],
            [30.54128979545633, 0.832719586315274],
            [30.54041144433107, 0.835769137742574],
            [30.535055297840017, 0.83143007573237],
            [30.53417958955832, 0.830244777225257],
            [30.53090055192172, 0.828049672762422],
            [30.527769777629466, 0.829055991467968],
            [30.52531464782201, 0.830818944282104],
            [30.522584350568273, 0.832127987768775],
            [30.520948326196404, 0.832133837879168],
            [30.517776684846957, 0.834913281569162],
            [30.514999196396403, 0.835433914046724],
            [30.512203948252665, 0.834862162975529],
            [30.511351620422893, 0.835087225443861],
            [30.512142741540796, 0.830169564691276],
            [30.515023038582367, 0.824505617102611],
            [30.519025832673705, 0.820862682789302],
            [30.5193690088752, 0.81777111088431],
            [30.520668050031134, 0.81426341522508],
            [30.52035014523525, 0.80390088600723],
            [30.519541372222008, 0.800963038179702],
            [30.51930149688834, 0.795496153351923],
            [30.51727688917235, 0.792557574648998],
            [30.51565857239136, 0.787905799471978],
            [30.512904083507028, 0.785619543022501],
            [30.511446222903782, 0.783742035349525],
            [30.51028331064937, 0.78023882604858],
            [30.508367667679007, 0.777875058733389],
            [30.507956413552044, 0.776486098241917],
            [30.50734749592662, 0.776088959864384],
            [30.502993913310082, 0.77601422329551],
            [30.501769830276384, 0.774711386586353],
            [30.50094198872459, 0.772457266258536],
            [30.500777525162388, 0.770120074246283],
            [30.501525087870473, 0.767866890141952],
            [30.502105795701045, 0.767366427021071],
            [30.503465154236753, 0.767205032203883],
            [30.50741620985933, 0.768046839765803],
            [30.510584905632957, 0.767746322802848],
            [30.513743792702005, 0.765040778137711],
            [30.522212690585775, 0.763709985885591],
            [30.5234840887838, 0.76244286286648],
            [30.52366322273293, 0.761232774766159],
            [30.5284314209722, 0.756534315268524],
            [30.528794372686335, 0.754635417632822],
            [30.528678820594727, 0.751046506950251],
            [30.5291376297362, 0.749241543807502],
            [30.531530813518316, 0.747241715082811],
            [30.532942948076965, 0.746666601428648],
            [30.533674124615928, 0.745782620081691],
            [30.53408297125794, 0.744173399134678],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 92,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KYARUSOZI  TOWN COUNCIL",
        Population: 13147,
        Key: "KYENJOJOKYARUSOZI  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.724126552568325, 0.637961321213918],
            [30.721543777548867, 0.637982854292981],
            [30.718497895847577, 0.638558696150045],
            [30.713309312106485, 0.640038400599308],
            [30.711994356396936, 0.642828796344519],
            [30.711887209841436, 0.647598782499242],
            [30.711397600163817, 0.649361757050369],
            [30.710207120409944, 0.6509264002672],
            [30.70807784279369, 0.652151310499545],
            [30.70679486082006, 0.651777782848548],
            [30.706004395472338, 0.650235960125928],
            [30.704293553115406, 0.649698286550934],
            [30.697810335353104, 0.650840137023649],
            [30.697188508038725, 0.649820716356222],
            [30.689191054999235, 0.646950874421194],
            [30.687542209871655, 0.649386248941781],
            [30.684479287129427, 0.651317987443212],
            [30.68162050923053, 0.653760003364089],
            [30.678180402765125, 0.653755165352911],
            [30.675164003771513, 0.655496319099557],
            [30.6708076085298, 0.657328093713312],
            [30.66883805496433, 0.657243788778293],
            [30.665227830042028, 0.653969187608439],
            [30.663353299368993, 0.653908145671023],
            [30.660000275587247, 0.654723442982137],
            [30.657799875654998, 0.65594866398366],
            [30.656388928669138, 0.65875891946882],
            [30.65341600723695, 0.662169364237635],
            [30.649991012231286, 0.66495910186275],
            [30.644134185225052, 0.668024026185963],
            [30.641208775688245, 0.671393958704573],
            [30.6361082052854, 0.673860019949597],
            [30.63405189512471, 0.675441178793253],
            [30.620483947685884, 0.680772232055426],
            [30.61465688006836, 0.685073684395116],
            [30.614684777249522, 0.675175813331883],
            [30.6125990544498, 0.669003758261968],
            [30.612252043340398, 0.666819591078466],
            [30.612360125940434, 0.663421209484272],
            [30.61166122766621, 0.660614371799823],
            [30.609003552915, 0.657256157765909],
            [30.60769593284808, 0.652254114226451],
            [30.607564410507344, 0.650830775385774],
            [30.607884084086045, 0.649954592653678],
            [30.610146589045467, 0.646356994690313],
            [30.610210380210415, 0.644108116052248],
            [30.605325614783215, 0.636277630332079],
            [30.599708559804387, 0.631574169623979],
            [30.596463176651582, 0.627782068141179],
            [30.594678316708507, 0.624569036566521],
            [30.592028792371856, 0.622884774550866],
            [30.590426161972385, 0.621269689885401],
            [30.589872374854224, 0.620123513130997],
            [30.58920205737912, 0.615530273726603],
            [30.5898721853097, 0.612441137656085],
            [30.59188460648057, 0.611230827432077],
            [30.598723328923263, 0.610980710260081],
            [30.603632074876984, 0.608417768732898],
            [30.604752252476707, 0.608186734165001],
            [30.606196966235757, 0.608078814849244],
            [30.609240924643988, 0.608886455354006],
            [30.611094888388614, 0.608389025162685],
            [30.61482778634781, 0.602322320228036],
            [30.61948150418561, 0.598561490863723],
            [30.62284662018938, 0.593720962686652],
            [30.624780987643483, 0.591836455574714],
            [30.62609813254735, 0.589621820971877],
            [30.626862029322258, 0.589376484290781],
            [30.63115291222692, 0.590377053876911],
            [30.633961608150436, 0.58893738404548],
            [30.63564877540806, 0.587453960103106],
            [30.637807293186807, 0.588079090865856],
            [30.63952613144807, 0.587969618049442],
            [30.640470806089063, 0.587514664160488],
            [30.643595952436037, 0.584549176004264],
            [30.64667520026191, 0.582383434883496],
            [30.646773734668766, 0.579622117049218],
            [30.648138687013766, 0.578490234716911],
            [30.650279659796702, 0.578078591925672],
            [30.65442061388043, 0.57898001703736],
            [30.65673799871719, 0.578967138548686],
            [30.664490962675718, 0.577087686431831],
            [30.666822733133436, 0.577461988225216],
            [30.6697265633405, 0.580144204626696],
            [30.675849290772515, 0.581887847345526],
            [30.679905894847725, 0.585172057827225],
            [30.683017314038842, 0.586991174172216],
            [30.68446960778227, 0.58840725060116],
            [30.687415674079038, 0.589540206162952],
            [30.690259395315486, 0.592660042721875],
            [30.692067580014893, 0.595498318507939],
            [30.692408626310836, 0.601505360136682],
            [30.693113727452083, 0.603000562848613],
            [30.694629744986813, 0.6047036461902],
            [30.698527564649, 0.607313716944029],
            [30.70076975959817, 0.60669341025552],
            [30.703139773134154, 0.607229945664459],
            [30.705288955620496, 0.608467299044752],
            [30.705981414770726, 0.607389090344608],
            [30.706538356772157, 0.609159964329596],
            [30.70718932184112, 0.609780992040963],
            [30.70923564093919, 0.610369305792792],
            [30.709865377919684, 0.61174001563755],
            [30.7120312699686, 0.613839282640534],
            [30.713138395047267, 0.61600689318808],
            [30.7138131807426, 0.618938961440493],
            [30.71719348366457, 0.622218337613866],
            [30.71775286638861, 0.624488938551175],
            [30.71914711818491, 0.626767406380461],
            [30.719229961718703, 0.628416000788526],
            [30.721187653030874, 0.631253539047189],
            [30.723472078679862, 0.637200001234343],
            [30.724126552568325, 0.637961321213918],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 93,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KYENJOJO TOWN COUNCIL",
        Population: 22960,
        Key: "KYENJOJOKYENJOJO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.668229363714335, 1.117018843238651],
            [30.6678103535332, 1.118301273956296],
            [30.66698646636533, 1.118936143268703],
            [30.666053735724343, 1.118783278259996],
            [30.66235218268037, 1.120159144782479],
            [30.64964800940466, 1.127487450384903],
            [30.64432952568022, 1.131745276784424],
            [30.616177414332363, 1.150966726315912],
            [30.600091878122644, 1.163570163048935],
            [30.5625027410346, 1.194476139918966],
            [30.550470387217178, 1.206360111760132],
            [30.550796742464964, 1.084469761679589],
            [30.551007952557924, 1.036975659271144],
            [30.549958814629193, 1.033279543339915],
            [30.54709420307081, 1.030833831236831],
            [30.544370648571583, 1.025782921205929],
            [30.544121740677696, 1.022670384225356],
            [30.542338035968097, 1.02064041024021],
            [30.540293834199115, 1.013717047356729],
            [30.538295988193756, 1.009212018252778],
            [30.53912141956564, 0.996348602816164],
            [30.542350529737057, 0.992102674927199],
            [30.544050678548842, 0.990926803597683],
            [30.549708443379696, 0.988626536268922],
            [30.55278678750039, 0.986135373987308],
            [30.553081328912363, 0.984521464071249],
            [30.552454003908448, 0.983436885867611],
            [30.54805407540976, 0.982906405495959],
            [30.54697413155497, 0.981683581969332],
            [30.545926757019142, 0.981455711926607],
            [30.546989383151853, 0.979384912416036],
            [30.546722393069626, 0.978747426226601],
            [30.54577193956644, 0.978731998116213],
            [30.546261986723582, 0.977732489581016],
            [30.546160241737894, 0.976975094524914],
            [30.545895562122567, 0.976598257522625],
            [30.54380566215678, 0.976687506551792],
            [30.543512547269465, 0.975887031613996],
            [30.54273307819914, 0.97361632579532],
            [30.544503486045905, 0.968042836200163],
            [30.547086950971504, 0.969629643166939],
            [30.55141344219571, 0.974434566481575],
            [30.55574192678154, 0.976506198070828],
            [30.573234769105202, 0.991293884737509],
            [30.57572793178521, 0.994213774146779],
            [30.57858916388148, 0.995619513639533],
            [30.581744320247157, 0.996545287945617],
            [30.595127731268743, 1.011034805622121],
            [30.596593427876194, 1.013953991219614],
            [30.59673850130301, 1.015277223117493],
            [30.597622265676144, 1.016253559940446],
            [30.602609055465123, 1.020167952471987],
            [30.604280598325005, 1.022272634034166],
            [30.606439969503256, 1.023741415765064],
            [30.61490241029676, 1.031396987306568],
            [30.617665972165483, 1.033247138292863],
            [30.61766514212216, 1.034357418060864],
            [30.618728143750666, 1.035983514721048],
            [30.62091001143863, 1.038146072764241],
            [30.621074110284844, 1.039531391251886],
            [30.6223413681477, 1.041039687058828],
            [30.623365184365216, 1.043683061506472],
            [30.62466491812228, 1.04541172569041],
            [30.62436135223493, 1.046648081150826],
            [30.62464807021912, 1.049648436276144],
            [30.626770136160275, 1.051117159501533],
            [30.62901235087239, 1.055229544029889],
            [30.62993204875522, 1.058644275906064],
            [30.63089953162125, 1.059434592754719],
            [30.630215016273056, 1.06258196538057],
            [30.633611204104195, 1.067522777250944],
            [30.636659692716425, 1.070719084964723],
            [30.637288201699878, 1.072258250598636],
            [30.63632719209377, 1.074523676327648],
            [30.63624728515262, 1.075835717723584],
            [30.6376996345916, 1.076740022402477],
            [30.638219136608605, 1.0775289855666],
            [30.64026925468203, 1.078322644985139],
            [30.64141291603991, 1.08173810025365],
            [30.645727712097436, 1.090356215722027],
            [30.644636831254086, 1.092415029623359],
            [30.64321309315689, 1.093685451003288],
            [30.642367637439044, 1.095051374062644],
            [30.642063878413925, 1.09632523424361],
            [30.645971753817413, 1.099336788178552],
            [30.647155581546617, 1.102040008989459],
            [30.648796098393206, 1.102569981590367],
            [30.650223265359788, 1.105105229591732],
            [30.66524028518345, 1.112162986466711],
            [30.665993515362658, 1.115183612664777],
            [30.666735061154977, 1.116460719082967],
            [30.668229363714335, 1.117018843238651],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1571,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "NDAIGA",
        Population: 8660,
        Key: "KAGADINDAIGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.084345562862424, 1.141592011193503],
            [31.0832845069848, 1.142771887215208],
            [31.083108115592278, 1.143530517064713],
            [31.080001824883116, 1.145752784015725],
            [31.07848097710709, 1.149351498250098],
            [31.076759139371088, 1.15019430578938],
            [31.076269813561087, 1.151259438962075],
            [31.073865072952845, 1.152536762979814],
            [31.072969359189784, 1.153789011445352],
            [31.07158673249159, 1.154135525563619],
            [31.07104474743967, 1.153799297764307],
            [31.071012157459467, 1.154463944955421],
            [31.0694477791214, 1.155972710890249],
            [31.068334059510274, 1.155751207167436],
            [31.068231462921673, 1.156320380638536],
            [31.067050889788757, 1.155765974262462],
            [31.065588246554938, 1.158557703780915],
            [31.06401336870783, 1.159069082826774],
            [31.0616387378313, 1.160762123027777],
            [31.060786978635086, 1.160494954207639],
            [31.05997230638537, 1.161011651634428],
            [31.05833784238719, 1.160644025093372],
            [31.05813445572202, 1.159858999231925],
            [31.057135097934747, 1.159970722263858],
            [31.056878834635324, 1.159589004805371],
            [31.055149029741067, 1.159244451075846],
            [31.053902247178446, 1.158309650588329],
            [31.05267792159963, 1.156579539410658],
            [31.05253656360484, 1.154702664189287],
            [31.052045571419985, 1.154105596178007],
            [31.051121284044385, 1.153932904946192],
            [31.04995998336756, 1.15193016351895],
            [31.050279231144806, 1.151148807718381],
            [31.04991080689399, 1.150267646535844],
            [31.050333017772452, 1.149783827855978],
            [31.04998352551623, 1.147478090457814],
            [31.04955528424725, 1.147522581377726],
            [31.04909214432777, 1.146617014941596],
            [31.048452623795562, 1.14647006830948],
            [31.047827615546726, 1.145230943787696],
            [31.047188405831573, 1.145060249473378],
            [31.046510516456937, 1.144224423430404],
            [31.046969146833693, 1.143681491988949],
            [31.04653161698466, 1.141743190994861],
            [31.043912031699808, 1.140418870717736],
            [31.0419293654261, 1.137650555014852],
            [31.039864473659506, 1.137493634997106],
            [31.039375063407906, 1.136777856438464],
            [31.037017175331616, 1.136322077169528],
            [31.0366785931145, 1.136770859041577],
            [31.033273599996946, 1.137340659594226],
            [31.03218366238461, 1.137119324177987],
            [31.031396466006193, 1.13792985712349],
            [31.02996817345055, 1.137286057275442],
            [31.027306719486937, 1.137413541720555],
            [31.02399012598322, 1.135977632904031],
            [31.022479991515286, 1.136782084874439],
            [31.020406097731247, 1.136595909743045],
            [31.019025369173253, 1.137142080309897],
            [31.016735094593457, 1.136852004954219],
            [31.013391408799077, 1.1371989630047],
            [31.01093182783936, 1.136545135276646],
            [31.00731952601214, 1.136753091167901],
            [31.005352012520678, 1.1377570625287],
            [31.00477579626649, 1.13724823038346],
            [31.003981698131767, 1.137288308908188],
            [31.00394702585673, 1.136683958753216],
            [31.003355706227712, 1.136671849151638],
            [31.003645754266632, 1.135611625182041],
            [31.001620058690825, 1.134853095635429],
            [30.9985336881231, 1.128452165413834],
            [30.998008586906927, 1.125073542697305],
            [30.998107842660986, 1.122858822227731],
            [31.000122616519544, 1.118509990980703],
            [31.0014176601725, 1.118049797167354],
            [31.002914665762557, 1.115615368063708],
            [31.004470808346067, 1.109832554304182],
            [31.00776046856091, 1.104940414902554],
            [31.00756016132056, 1.097661267449214],
            [31.00925065144642, 1.093802692122242],
            [31.011368846547015, 1.091727943256695],
            [31.013257172647876, 1.090862565388785],
            [31.014178586312894, 1.091248911937862],
            [31.015886329482072, 1.094145818345592],
            [31.016809953002685, 1.094365971435126],
            [31.019308994257898, 1.094027234503499],
            [31.022521836837846, 1.091817633633787],
            [31.024184409121304, 1.091852976820377],
            [31.025725976539345, 1.087577772108902],
            [31.025889925366908, 1.085964253369334],
            [31.026887828781717, 1.084166594145265],
            [31.028763105954777, 1.082493772007245],
            [31.02967755677803, 1.078926518447194],
            [31.030598841983963, 1.077531982714617],
            [31.030032333823073, 1.075462216447397],
            [31.0302160096543, 1.074494473640564],
            [31.030025927038476, 1.07375063312719],
            [31.0289946485159, 1.072971052040817],
            [31.027522131898788, 1.070707543628856],
            [31.026795152288834, 1.066935738436678],
            [31.025969410998183, 1.064775739435675],
            [31.03057189971198, 1.06038829125978],
            [31.031935905232643, 1.056278133812914],
            [31.036418865013015, 1.052755343965608],
            [31.036630796453174, 1.052037043790739],
            [31.03991016377151, 1.04977738126623],
            [31.040148977296514, 1.048340658129658],
            [31.041034793421783, 1.04795539206016],
            [31.047273673918365, 1.047666626600774],
            [31.04981211438361, 1.046603866263979],
            [31.050182554453944, 1.046045310613863],
            [31.05042211717393, 1.043384569410825],
            [31.051242446114966, 1.042028026284989],
            [31.051548147297712, 1.03927419201454],
            [31.05218347359591, 1.03783770389017],
            [31.053770908094013, 1.035683362980203],
            [31.056389148600914, 1.033795745392721],
            [31.056984858296715, 1.03229270222297],
            [31.058651168470067, 1.030830232270049],
            [31.061392305694348, 1.022410138821936],
            [31.061857805488035, 1.017607478794464],
            [31.062678346431518, 1.015851773460531],
            [31.062877476878842, 1.01440169620865],
            [31.06605682218019, 1.007676489128206],
            [31.068494245295096, 1.007866420189807],
            [31.07360300204512, 1.006940542199234],
            [31.076605583153047, 1.006876913574685],
            [31.080037832952936, 1.005570594519684],
            [31.08245850787769, 1.003794170707195],
            [31.084398965011147, 1.003123196173914],
            [31.086041677340276, 1.003082597647483],
            [31.092723969854386, 1.000680171024092],
            [31.094751669571583, 1.001429598320942],
            [31.099826496055005, 1.001617322024104],
            [31.101399884495365, 1.002458859935139],
            [31.104943939513834, 1.002706853999719],
            [31.107894788441172, 1.002276809171422],
            [31.110702352487454, 1.002383116600985],
            [31.113327102186858, 1.003954708241882],
            [31.113638610079644, 1.004739923556669],
            [31.115496426698485, 1.006376491761254],
            [31.116521499659097, 1.006546085484353],
            [31.117704208985746, 1.00854672130686],
            [31.119919732055806, 1.010275285036903],
            [31.120714478774197, 1.012268769989598],
            [31.121547860236326, 1.013086419985764],
            [31.12086653211076, 1.014952242997995],
            [31.121633774211794, 1.016299907513971],
            [31.121248866773765, 1.017845663647886],
            [31.12223519090459, 1.01980080991059],
            [31.122081128935076, 1.020584754066454],
            [31.122595922881658, 1.022097912571123],
            [31.12186009845942, 1.0233232224136],
            [31.122781045898776, 1.024494297487833],
            [31.122067516763565, 1.025112270083221],
            [31.12279143042349, 1.025499194262237],
            [31.121978210749585, 1.027729346783987],
            [31.122547593519382, 1.029695292905661],
            [31.124017330748984, 1.030524372172027],
            [31.12394009360088, 1.031264191111344],
            [31.12482393882238, 1.031918492458352],
            [31.12557336643301, 1.033871254464931],
            [31.126555852960927, 1.034311008775092],
            [31.127296713338662, 1.03556021598907],
            [31.127167946130896, 1.036263466627074],
            [31.127809398939327, 1.036794933461172],
            [31.127495324559803, 1.037340183493112],
            [31.127851625147557, 1.037742297798058],
            [31.127836661011578, 1.038933639210871],
            [31.129233818857784, 1.039723925112042],
            [31.129831971072864, 1.041130939029019],
            [31.13112654221197, 1.042220474666845],
            [31.131356849589558, 1.042997827045563],
            [31.13186538856685, 1.043030620000595],
            [31.132018759731928, 1.043968628962624],
            [31.13185488007467, 1.044892808584369],
            [31.13001421498951, 1.046456250079711],
            [31.129328808512565, 1.047891201103005],
            [31.127764521802664, 1.049428006031542],
            [31.12692227037543, 1.05310865278434],
            [31.126334167613418, 1.053634148472654],
            [31.12568138435436, 1.053107900123294],
            [31.124570790880362, 1.053654987659721],
            [31.12446798408601, 1.055547220651736],
            [31.123727503695612, 1.057498080035749],
            [31.123938322123134, 1.05818154732614],
            [31.122443525490336, 1.059995274648545],
            [31.121326943846693, 1.060123666840548],
            [31.120949255270343, 1.060935847251958],
            [31.11975706961575, 1.061337525610033],
            [31.11966572262943, 1.06268895698847],
            [31.120655565461217, 1.064196506009234],
            [31.120501547509132, 1.06524818781463],
            [31.11999590470035, 1.065574359103113],
            [31.120242972844512, 1.068664712126062],
            [31.11978957156103, 1.069917216197544],
            [31.120904718595177, 1.072142547190999],
            [31.12053118832026, 1.072996317218819],
            [31.12063127950752, 1.075171837772188],
            [31.119763190736105, 1.076036858164841],
            [31.119528693616022, 1.077069309969221],
            [31.118645712573787, 1.077615428630964],
            [31.117916110781508, 1.078715696074172],
            [31.118251759999186, 1.080318156988697],
            [31.117028045274765, 1.082891288182451],
            [31.116273510741777, 1.083111000201598],
            [31.115187483495873, 1.08261679947523],
            [31.114908187392572, 1.082889958015126],
            [31.115072233238195, 1.085987844280459],
            [31.113827535665333, 1.088036423116525],
            [31.11413493646063, 1.088948370134099],
            [31.114022246401507, 1.09023301432757],
            [31.113673802479198, 1.090474191659687],
            [31.11492584737275, 1.090884984172589],
            [31.115325129651925, 1.091765979104659],
            [31.115211537684218, 1.092456835006571],
            [31.11369460566455, 1.093397356279802],
            [31.11402619449715, 1.093951826598383],
            [31.11374264037941, 1.095557484029611],
            [31.11478901239541, 1.09554979136569],
            [31.115529103815266, 1.096798712384341],
            [31.114811551125882, 1.098954636134505],
            [31.11465557304983, 1.100865114744561],
            [31.114128914154954, 1.101976676003523],
            [31.1116532614365, 1.103412667039324],
            [31.111370459208633, 1.10412291486848],
            [31.109966599930406, 1.104748863227551],
            [31.109169425964126, 1.104656414126842],
            [31.10875778466328, 1.105531642481665],
            [31.109141842294985, 1.108860459366127],
            [31.107994915561054, 1.110280575023648],
            [31.10729637391801, 1.112058308440371],
            [31.107203733357707, 1.113807125888611],
            [31.10790789396286, 1.114541022084587],
            [31.107761124516788, 1.115539772994202],
            [31.10831438162893, 1.117176108349228],
            [31.107273939392133, 1.119133909179092],
            [31.10671574244426, 1.124797356802541],
            [31.109946403107866, 1.130183624587294],
            [31.108475546577417, 1.132440097597278],
            [31.108832553240997, 1.133210355683041],
            [31.108186996030057, 1.133860340128571],
            [31.108658287262397, 1.134699590190649],
            [31.107924248690917, 1.134804632948462],
            [31.106843607743475, 1.135811701768962],
            [31.10659937288569, 1.137218322376751],
            [31.104593979235318, 1.139685783080015],
            [31.104250845254686, 1.140984540016363],
            [31.103597457429416, 1.141061523842844],
            [31.103451399449042, 1.142182518234564],
            [31.102423848934897, 1.143251162509566],
            [31.100414903345868, 1.140271494458654],
            [31.099433871190385, 1.139702695010483],
            [31.098168454873836, 1.140168780770229],
            [31.096658407542485, 1.139374629587255],
            [31.09493574964463, 1.137593526830571],
            [31.09236421883757, 1.136222065839617],
            [31.09094910277052, 1.134258314645035],
            [31.089036567072753, 1.134536631822947],
            [31.08735540595112, 1.133911441564827],
            [31.085359132895846, 1.135815838596183],
            [31.084635452797894, 1.137652237227721],
            [31.083333637644326, 1.13930096343633],
            [31.083360629323682, 1.14002286846241],
            [31.084345562862424, 1.141592011193503],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1578,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KIRYANGA",
        Population: 24304,
        Key: "KAGADIKIRYANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.882037389039606, 1.964910287093631],
            [31.770929047527613, 1.983909714602183],
            [31.767911029769863, 1.984861556169838],
            [31.767178490486575, 1.984542969443403],
            [31.76648714794224, 1.986826518902106],
            [31.766889042522276, 1.987318310229351],
            [31.76579734151704, 1.986970580399553],
            [31.76513593532954, 1.987606148531319],
            [31.764271217037034, 1.991132801747399],
            [31.763508898602094, 1.992230875490432],
            [31.763910525484164, 1.993127455302283],
            [31.76382351286911, 1.994197148269313],
            [31.763247938910382, 1.995324323896332],
            [31.76284535083095, 1.995699880152854],
            [31.761696656212536, 1.994687074522789],
            [31.760029619302127, 1.995119493927786],
            [31.757673342803464, 1.994973148315899],
            [31.757155824266583, 1.99531969858214],
            [31.757154824441685, 1.996649666203086],
            [31.75563073105255, 1.998065194635332],
            [31.755371089189342, 1.999423844631202],
            [31.756275662137746, 2.000234077691757],
            [31.75656203966043, 2.001535357670013],
            [31.756849215785397, 2.00179578016733],
            [31.758200220887268, 2.001276395798828],
            [31.758717176180465, 2.001652659032283],
            [31.75831390178815, 2.002953422566626],
            [31.757077240543865, 2.004282425186582],
            [31.75839825089841, 2.005411020434549],
            [31.757461260446355, 2.009458040800046],
            [31.757402781019675, 2.010787918837818],
            [31.757947396338768, 2.012609830912627],
            [31.754700310878494, 2.012404967195714],
            [31.753606566205995, 2.014717066153175],
            [31.754324390186603, 2.015469351130301],
            [31.753806390152743, 2.016451984579873],
            [31.754164372386732, 2.018071328269241],
            [31.752266638229905, 2.019515494559706],
            [31.752437905632053, 2.021019037182195],
            [31.753328205248906, 2.021713623152596],
            [31.753040472168472, 2.022204931779788],
            [31.751632327028, 2.022261666356703],
            [31.74815386699155, 2.023964789922341],
            [31.747303954731564, 2.026797516458871],
            [31.746037823356062, 2.029022762551681],
            [31.744484850028847, 2.030553889634188],
            [31.743318949977787, 2.033212889170168],
            [31.744436670685218, 2.03708799339717],
            [31.744676330423253, 2.043044050045508],
            [31.745048921060377, 2.044316481716319],
            [31.74481830556065, 2.045241512799651],
            [31.745380588046423, 2.04834816567006],
            [31.74595052507677, 2.048943141797549],
            [31.74560025847275, 2.049561860249838],
            [31.74600627721823, 2.051805145457048],
            [31.74934777920813, 2.223614310741882],
            [31.75045670001903, 2.30176705448866],
            [31.750353065876283, 2.301543149627067],
            [31.746877253174986, 2.299519390998978],
            [31.744417263481825, 2.298618973196283],
            [31.74266874398527, 2.296906858523576],
            [31.74233878918815, 2.296097354582563],
            [31.741392953923803, 2.295575049894744],
            [31.740304532667675, 2.295386675340494],
            [31.73689399245327, 2.296680506059029],
            [31.734458137796832, 2.295517880312425],
            [31.732614484016725, 2.29409193149399],
            [31.727266116936008, 2.293674016442373],
            [31.72395508759718, 2.292203411258446],
            [31.7217803408545, 2.290635153142197],
            [31.716787340113687, 2.29004967173038],
            [31.70950123060831, 2.287919993598895],
            [31.707940547939334, 2.287112988879063],
            [31.705337035311544, 2.28711831433797],
            [31.70344138255122, 2.288361308040385],
            [31.69915656147811, 2.288870458360519],
            [31.698495030424784, 2.288204595341989],
            [31.698212849831105, 2.287156698392535],
            [31.696794445930077, 2.28620642278657],
            [31.69637027313102, 2.285158834947742],
            [31.69751388867485, 2.280867286411201],
            [31.696904473382734, 2.277484812327225],
            [31.696101935575882, 2.276247342067002],
            [31.69506147267782, 2.275725233015062],
            [31.693972656162998, 2.275775117511544],
            [31.690420446238342, 2.276926150513197],
            [31.687387830857226, 2.2786956603575],
            [31.68672522452051, 2.278649352917896],
            [31.681592938198243, 2.276586685741635],
            [31.677854605431573, 2.275927071556606],
            [31.67690923729119, 2.275166464601384],
            [31.66900572557253, 2.274324641706031],
            [31.666379928437475, 2.273591265541144],
            [31.658766844745116, 2.269174532263148],
            [31.65361422146313, 2.265324706464884],
            [31.649529513594302, 2.259876213415604],
            [31.647732582090434, 2.258879037302401],
            [31.64451495059169, 2.258265983448481],
            [31.637887871229918, 2.258422287391156],
            [31.635755607613643, 2.259665642414369],
            [31.63279117795585, 2.26303137639905],
            [31.626525432442367, 2.272813517518221],
            [31.62420378869283, 2.274057219225714],
            [31.622120289223464, 2.274490275443155],
            [31.619304100452155, 2.274376739751393],
            [31.611780881525863, 2.272771378384208],
            [31.61026774398993, 2.27191657466334],
            [31.607854740677688, 2.271349470470712],
            [31.603025614204252, 2.271930925638508],
            [31.598975396252413, 2.273678377508781],
            [31.59124965484029, 2.279316997621997],
            [31.588596319850186, 2.280751901260909],
            [31.579524877887927, 2.284558318274312],
            [31.573842783984244, 2.285665499153187],
            [31.571617642652438, 2.285908108902892],
            [31.568164655244185, 2.284628157037837],
            [31.559667421801436, 2.285097419297307],
            [31.556401843622712, 2.284865481887614],
            [31.554225663168836, 2.284250192366533],
            [31.55119934048626, 2.282635790583112],
            [31.547252288654914, 2.279807960300287],
            [31.54385025818118, 2.276621678023422],
            [31.54063535935754, 2.27462641916561],
            [31.53762450476585, 2.2734092440674],
            [31.537364837749795, 2.237184171759298],
            [31.538046993223748, 2.16192408869633],
            [31.539133632222345, 2.010561873089497],
            [31.551609849909863, 1.994510302513906],
            [31.564364871423898, 1.979598296494403],
            [31.56529274756907, 1.978929821667441],
            [31.570668898643184, 1.976655301970866],
            [31.57228603413956, 1.976439637064179],
            [31.57525872200981, 1.977057229387892],
            [31.577280866545255, 1.976272109349746],
            [31.577899778826588, 1.974888842882435],
            [31.579112575427047, 1.975125042050943],
            [31.580611171035137, 1.974574620152456],
            [31.582275902868517, 1.974883564823747],
            [31.58429792702976, 1.973908495491987],
            [31.587223663553342, 1.973259799218064],
            [31.587438045597587, 1.972545468472548],
            [31.588532486464437, 1.971895199648444],
            [31.58917497053877, 1.970864673353214],
            [31.591244586545436, 1.970079567448901],
            [31.593243189830577, 1.968218097739877],
            [31.59593085214264, 1.967731974756693],
            [31.596978183559337, 1.966303826241077],
            [31.598000899340644, 1.965752974080667],
            [31.598571782296965, 1.965681101770182],
            [31.600569051583914, 1.967093738873885],
            [31.60375656706273, 1.966155794734322],
            [31.60423249629689, 1.965414541703669],
            [31.6043995676684, 1.963813796022485],
            [31.60639771191443, 1.963164266264158],
            [31.60654080635264, 1.962359417959792],
            [31.607397065210115, 1.962333003227591],
            [31.607610730398775, 1.96314719572257],
            [31.608395636971533, 1.963120719055429],
            [31.610727545769798, 1.960391207736782],
            [31.612273226573517, 1.960989442489629],
            [31.61289122167491, 1.962039130999301],
            [31.615102568477226, 1.963117285016138],
            [31.618289425490968, 1.964006314907238],
            [31.619431350405392, 1.962994267399666],
            [31.620976802138717, 1.963881925536682],
            [31.623046523248274, 1.962970136650498],
            [31.62251341714463, 1.961504462771602],
            [31.62008829915246, 1.95937696384318],
            [31.613002195053546, 1.955888898604278],
            [31.611005285092695, 1.954024048173229],
            [31.60170829233228, 1.948336298631843],
            [31.597475763988474, 1.946288687859873],
            [31.594051985301714, 1.943581503478032],
            [31.592791233038096, 1.944276873403854],
            [31.592078496216953, 1.942657306765935],
            [31.589248542560554, 1.942030856636843],
            [31.586466792502303, 1.939857836144273],
            [31.58539715142549, 1.938762552437029],
            [31.583400969100055, 1.935079765834698],
            [31.582640140071835, 1.934554545610906],
            [31.581570604097948, 1.932663349781516],
            [31.580642918395593, 1.932807281268498],
            [31.579812515746976, 1.928456190624424],
            [31.579361044943056, 1.927840787250962],
            [31.57303708320928, 1.92229121515462],
            [31.571943723914035, 1.920689426642937],
            [31.568496440807852, 1.917991282825263],
            [31.565905368050103, 1.915293861083753],
            [31.56081761031816, 1.911608494629502],
            [31.55986710022109, 1.909509392973562],
            [31.556489660229936, 1.910013023036875],
            [31.554183448638703, 1.909007144502554],
            [31.550687461572753, 1.908524828319358],
            [31.543054816166766, 1.90551561346931],
            [31.539677846892832, 1.902792000685402],
            [31.53875176378497, 1.90198130319514],
            [31.539251444475216, 1.90140756176342],
            [31.539632987722477, 1.899112871556872],
            [31.540465732279056, 1.898276120229721],
            [31.542582596076425, 1.897702075001098],
            [31.54557908840336, 1.897821040980395],
            [31.546292157601158, 1.898729188237796],
            [31.54721968250507, 1.89868121221725],
            [31.54838470130881, 1.89937416553254],
            [31.548956025337937, 1.898131127309062],
            [31.549788636943852, 1.8976051164425],
            [31.55188284792471, 1.894449580294576],
            [31.55288204940512, 1.893636702565132],
            [31.552526385722874, 1.891198711728641],
            [31.553358941633267, 1.890768301088228],
            [31.55331169114764, 1.890051240380225],
            [31.55274106960104, 1.889692789372821],
            [31.552646313508244, 1.888832331756472],
            [31.5515527476005, 1.887876459772667],
            [31.55053012704062, 1.887900550284972],
            [31.550102984411225, 1.885725507514077],
            [31.55007937938053, 1.885319171700991],
            [31.552244659676724, 1.882713348551123],
            [31.551864559123835, 1.88178123789149],
            [31.551079792688263, 1.881685781412863],
            [31.55096102822117, 1.881351158914341],
            [31.5513183483968, 1.879964753691204],
            [31.55255519110077, 1.879558155266105],
            [31.55441012053434, 1.879701199645964],
            [31.55464858730966, 1.878195303259426],
            [31.556171432040525, 1.876330593583407],
            [31.55602905894948, 1.875589624797461],
            [31.55638593266239, 1.875231030754022],
            [31.558193259470734, 1.875493594264509],
            [31.559143768669475, 1.877309989739667],
            [31.559571779071437, 1.877453314427517],
            [31.560095239065614, 1.876855643919099],
            [31.560262334691608, 1.87539755564581],
            [31.558170339854556, 1.873461834108589],
            [31.557743028341907, 1.87164535563128],
            [31.55912258459846, 1.871167023542625],
            [31.560003719602758, 1.868298514193549],
            [31.563049029975485, 1.865381762849804],
            [31.563739343948843, 1.863827930157165],
            [31.565689731059415, 1.863182154108723],
            [31.56614229690966, 1.8614849503989],
            [31.56944847714259, 1.860265212025316],
            [31.570565153109367, 1.862894261574333],
            [31.571207111669267, 1.863252660612785],
            [31.57344322861722, 1.861770216978388],
            [31.573729075235583, 1.860622808927875],
            [31.574323677308662, 1.860503171522373],
            [31.57520319085387, 1.861530795966849],
            [31.576344517490327, 1.862032495192311],
            [31.576106308531504, 1.86301255115907],
            [31.57653432162841, 1.863155888686689],
            [31.58026896321754, 1.861027723798997],
            [31.582100363977172, 1.860549255941735],
            [31.582861111258687, 1.861266160844751],
            [31.583693739932617, 1.860596677246134],
            [31.582862013167244, 1.859019271071537],
            [31.582839840949383, 1.855027521753901],
            [31.581389503736666, 1.854119516108698],
            [31.582508701274428, 1.850486026279401],
            [31.581772318100057, 1.848358851733521],
            [31.58041741610648, 1.84670986264566],
            [31.581132588260356, 1.842383275249657],
            [31.57987331192877, 1.839467415868378],
            [31.579992933388624, 1.837674679425702],
            [31.57711566636453, 1.836886567891874],
            [31.576450354302153, 1.835452534292948],
            [31.5795214202724, 1.827205337563965],
            [31.58111579156116, 1.824623449257963],
            [31.579739007505587, 1.818050491109282],
            [31.579906130979364, 1.816401150884078],
            [31.582522578448923, 1.815133664695406],
            [31.585328570443444, 1.815706642245108],
            [31.586446928954715, 1.814057074516481],
            [31.586376130032242, 1.81262291048043],
            [31.584571099317778, 1.806456397309544],
            [31.585094526972597, 1.805810905821772],
            [31.586117262516805, 1.805452099315258],
            [31.586379069319843, 1.804878355335229],
            [31.586927917500564, 1.799882497792872],
            [31.586500182881416, 1.799022106284305],
            [31.5835043858505, 1.797325759468615],
            [31.582957822983868, 1.796274154651138],
            [31.585051412330504, 1.794002842158933],
            [31.58417252580937, 1.791278136181703],
            [31.584672371789654, 1.790106778950542],
            [31.588144946962647, 1.788671708059168],
            [31.589548542136196, 1.787308879330601],
            [31.58995336702066, 1.785802878302655],
            [31.589739741357906, 1.784727303365858],
            [31.58595925334991, 1.782816058091888],
            [31.58322600513048, 1.778562030327924],
            [31.58389223527106, 1.777581857518467],
            [31.587174501452786, 1.776218529438725],
            [31.58786445879497, 1.775405644659745],
            [31.58738960843746, 1.773278393606741],
            [31.587770934292422, 1.770983620590926],
            [31.587201020618302, 1.768712992514412],
            [31.586212399495306, 1.767433078876374],
            [31.660711381128262, 1.747549385945369],
            [31.661424003863374, 1.748496909973845],
            [31.662519872153208, 1.747066651957959],
            [31.664526981585766, 1.747944719386857],
            [31.67173923520172, 1.749369851539912],
            [31.674716668871596, 1.752159338557104],
            [31.679680866929473, 1.754266547614667],
            [31.681502941379804, 1.755666595892963],
            [31.68278652522468, 1.757721929743818],
            [31.684165829054642, 1.757817084807154],
            [31.690240454398154, 1.763109840517739],
            [31.691131708924118, 1.764986014849061],
            [31.693318915299802, 1.767327902976914],
            [31.695863031321004, 1.769167675401283],
            [31.698145850782282, 1.770003574856893],
            [31.70113091833543, 1.768580306316933],
            [31.703177326366713, 1.76475497539994],
            [31.705294362640622, 1.763248305925443],
            [31.707113884078936, 1.7625903455336],
            [31.710824915247454, 1.759051285298022],
            [31.71303702921102, 1.757711899385596],
            [31.717449845839067, 1.753347860595493],
            [31.72659558476356, 1.747786936379784],
            [31.72944770704454, 1.746922032058547],
            [31.731337399482946, 1.744675723938835],
            [31.732080669142306, 1.742079412613695],
            [31.73455916682526, 1.739559733586582],
            [31.735216192827444, 1.738214738936729],
            [31.735458192676784, 1.73645135301169],
            [31.73391937769675, 1.733800620080766],
            [31.733779108460073, 1.732822785288084],
            [31.73534601196242, 1.728786600659789],
            [31.73822919529096, 1.72602970726322],
            [31.73941091018262, 1.72972205188443],
            [31.745209906345814, 1.735305696080836],
            [31.746584404189004, 1.737097717184584],
            [31.749123431254123, 1.739036212169425],
            [31.752712339154737, 1.74509472030803],
            [31.75920580579609, 1.750750957874928],
            [31.762523544651774, 1.753047630623628],
            [31.766387123230295, 1.756727380540547],
            [31.76989298817109, 1.760807247774355],
            [31.770382782003352, 1.762143593900042],
            [31.77130570573636, 1.763218832688125],
            [31.773555941505652, 1.764904876201265],
            [31.77607042839383, 1.766142099675645],
            [31.78024881168218, 1.766829389227184],
            [31.786356745658132, 1.764323469550482],
            [31.790535998515683, 1.763706877114094],
            [31.794972934010826, 1.765372221151973],
            [31.798730297586776, 1.765961414862851],
            [31.801111332552974, 1.765897766230836],
            [31.805062503159913, 1.767367205328457],
            [31.80985504933668, 1.770238854371124],
            [31.81213844821129, 1.770892274136701],
            [31.818714376602472, 1.771189878506626],
            [31.823085117939264, 1.775202143718208],
            [31.824121426129118, 1.775724367431071],
            [31.829125793253237, 1.776738077171809],
            [31.832300701775385, 1.776414127097248],
            [31.840644145438144, 1.773616049546135],
            [31.842522749970986, 1.774106194083347],
            [31.84423875674249, 1.775606756309647],
            [31.848707795330913, 1.777989194662939],
            [31.849254107567592, 1.777312065209018],
            [31.849609501755246, 1.771264983983259],
            [31.848696957156996, 1.770029481580772],
            [31.847799646189365, 1.767243145044844],
            [31.847658355568225, 1.764945508377837],
            [31.8481454939805, 1.761786688690405],
            [31.84843139629442, 1.760982725319646],
            [31.85044452174444, 1.759346974564328],
            [31.852357224528838, 1.758572737556296],
            [31.858207923228246, 1.758834828675681],
            [31.861289648607645, 1.759956784873475],
            [31.86668837614148, 1.760755531041432],
            [31.86909808083998, 1.76156543226173],
            [31.871144695483796, 1.762818438376054],
            [31.87649344255189, 1.766923158383742],
            [31.882967736450123, 1.768541270663625],
            [31.89497881726332, 1.770705630514854],
            [31.89705929120683, 1.771404768675283],
            [31.898634954181468, 1.772706327587679],
            [31.905381482526586, 1.773757196151984],
            [31.90595824315982, 1.774247434929675],
            [31.9062556591807, 1.778096086708497],
            [31.90960597813512, 1.783727187432206],
            [31.90929127493489, 1.784990625368548],
            [31.906150125101124, 1.787630975166176],
            [31.900440129524696, 1.790413363474471],
            [31.898326532900043, 1.792939429265175],
            [31.897326298357033, 1.79506408786341],
            [31.892714125804495, 1.799512842923176],
            [31.890499739103266, 1.803474811298097],
            [31.886758599999663, 1.805333596721408],
            [31.88601159065379, 1.80618661284511],
            [31.886180351756344, 1.807654695354314],
            [31.890992215304962, 1.818138371252399],
            [31.886135992049276, 1.824655917664134],
            [31.88609644910881, 1.833736880084174],
            [31.885824740176393, 1.834146378348798],
            [31.8835850066111, 1.8345205010387],
            [31.883041568085037, 1.835373635336849],
            [31.882938966106522, 1.836670852250156],
            [31.881749329870722, 1.839913308154482],
            [31.882121942067407, 1.840937713163594],
            [31.882018931355475, 1.842883571169417],
            [31.880116154056644, 1.847013181954284],
            [31.877173195930737, 1.851955395068538],
            [31.879427110301116, 1.85345025516124],
            [31.88210804063839, 1.856726005712613],
            [31.883746203000626, 1.861551949105374],
            [31.885257592415005, 1.863735611549424],
            [31.88592678519941, 1.866205924307431],
            [31.886708949215592, 1.867020526991194],
            [31.88937989657516, 1.868216880090245],
            [31.891011852477078, 1.869412570668495],
            [31.89190192032858, 1.870209570673249],
            [31.89337153808223, 1.872843135829441],
            [31.8948944034744, 1.877201198398187],
            [31.89774521870663, 1.88284743501958],
            [31.896955652572498, 1.886263292515173],
            [31.8971508178562, 1.888937090230159],
            [31.898182738674187, 1.891413373824205],
            [31.901773958838362, 1.893594219295117],
            [31.90413440980814, 1.896467454464034],
            [31.90536447472331, 1.896913851223212],
            [31.906742462521393, 1.896914729294127],
            [31.910975603516224, 1.895729114102714],
            [31.913633063570067, 1.895879333455562],
            [31.915650410203618, 1.898371392640491],
            [31.918616658949865, 1.903747157848727],
            [31.920892231701732, 1.905734019485336],
            [31.921624966817756, 1.907185368385415],
            [31.917491616074564, 1.905980045955799],
            [31.915913303069818, 1.904865428427604],
            [31.912563064065473, 1.905472079145881],
            [31.911117280412917, 1.906517092941477],
            [31.906725082815584, 1.912507953645614],
            [31.903747664417086, 1.915960645435415],
            [31.90246825414502, 1.916892681093607],
            [31.89931852270536, 1.917903923919019],
            [31.89800793370643, 1.917597481783538],
            [31.896899053319707, 1.916240834916324],
            [31.896351503204595, 1.917007750137424],
            [31.895964188281614, 1.92008050715054],
            [31.896174014969045, 1.926686192018048],
            [31.895401335365612, 1.929787407307169],
            [31.89599911298324, 1.932315132764771],
            [31.89481232440687, 1.935732024078531],
            [31.892441439505074, 1.938401400254927],
            [31.891327849251294, 1.938975061034298],
            [31.891055536651027, 1.940726781980154],
            [31.89005597494618, 1.941530270598968],
            [31.889569731255914, 1.94305209586595],
            [31.88757059616812, 1.944659072304981],
            [31.88659919305419, 1.946036973380078],
            [31.88581249434243, 1.94867864704985],
            [31.887009907293667, 1.950862146909487],
            [31.88692365465336, 1.95180984067851],
            [31.886009800311445, 1.95246978475554],
            [31.88546765266441, 1.952182221391812],
            [31.88386866762836, 1.952956588209417],
            [31.88331050032489, 1.955311220575194],
            [31.882339104397467, 1.95666039257511],
            [31.8821667275759, 1.958325997005975],
            [31.880766899936653, 1.960076966115294],
            [31.882037389039606, 1.964910287093631],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1884,
        District: "MASINDI",
        County: "BURULI",
        Subcounty: "PAKANYI",
        Population: 58402,
        Key: "MASINDIPAKANYI",
        Dist2: "Masindi",
        "Sub Country": "Pakanyi",
        id2_original: "Masindi Pakanyi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.554646099814196, 0.60962117013997],
            [30.5551845850298, 0.61662700926658],
            [30.554414794408338, 0.620182736486736],
            [30.54626236940591, 0.62814443394816],
            [30.544502988379246, 0.630546411957018],
            [30.539920040717845, 0.628968513171704],
            [30.536480341189293, 0.627273362945403],
            [30.53517091371202, 0.62609674630944],
            [30.53291320665453, 0.622138478500541],
            [30.531507917258367, 0.621480307280224],
            [30.529997886994988, 0.622043521392544],
            [30.526933678763626, 0.624206019272489],
            [30.5260973652004, 0.624210620170301],
            [30.525035008562252, 0.623254620524813],
            [30.523901490082228, 0.622841588798894],
            [30.52176358235106, 0.623272602834489],
            [30.51724361108264, 0.627033809187036],
            [30.514074778765053, 0.627914402698157],
            [30.511549935199984, 0.627176065060838],
            [30.510512179824172, 0.626219943791686],
            [30.506772255242847, 0.625993863011953],
            [30.503823755409982, 0.626651278229541],
            [30.49966958351513, 0.629056983810676],
            [30.495533906135385, 0.628731250057071],
            [30.480273631515967, 0.636083303477991],
            [30.474736903889863, 0.634503395171539],
            [30.473501766188246, 0.632185080289038],
            [30.47106712335916, 0.62906577509248],
            [30.469119359329213, 0.627846311793417],
            [30.468169248982413, 0.6265794981481],
            [30.466090917520877, 0.622217855247003],
            [30.465663411073795, 0.61963706794257],
            [30.464855810362, 0.618609267517618],
            [30.463976946298732, 0.61798764258837],
            [30.460057631748395, 0.618917841483847],
            [30.45673216648298, 0.618414638191028],
            [30.454681620811463, 0.617568489686551],
            [30.453454308334333, 0.614709625568687],
            [30.453430556878214, 0.613849420444999],
            [30.452611101997952, 0.612666313563887],
            [30.452349855743634, 0.610539615805332],
            [30.450764920358615, 0.606882281231644],
            [30.447924583075835, 0.603046914248307],
            [30.4454839188394, 0.602093796951325],
            [30.445723756443822, 0.59972849042449],
            [30.447184596758873, 0.594125927509693],
            [30.445070584214225, 0.592786986743165],
            [30.446709535297273, 0.592572614372024],
            [30.446602643863322, 0.591580969468003],
            [30.447624029239655, 0.590291099548234],
            [30.446745173261224, 0.588618151327589],
            [30.447766539772957, 0.587662801136951],
            [30.44807531499064, 0.585799189288501],
            [30.447552758701637, 0.585297194703008],
            [30.446163214077462, 0.585236904723307],
            [30.445569386352147, 0.58463930916641],
            [30.44594942402297, 0.584161581203328],
            [30.44754088117698, 0.584018857100971],
            [30.44799217860603, 0.582752653023472],
            [30.448728520457898, 0.582537898502979],
            [30.452885289382223, 0.582587364372021],
            [30.452243951558156, 0.581296813288467],
            [30.453870996370444, 0.578059792042001],
            [30.454322303680957, 0.578012184653087],
            [30.45631759847092, 0.581597118098524],
            [30.456911427992868, 0.581573463980802],
            [30.45826534273793, 0.580212033834497],
            [30.461163201843323, 0.578468887342277],
            [30.462113307698505, 0.577346229111283],
            [30.464738014278808, 0.575758289311325],
            [30.4648330111201, 0.573942338450372],
            [30.46426829419989, 0.572488986464097],
            [30.46477566446899, 0.571350582169946],
            [30.465580363622394, 0.571087610745007],
            [30.465591002370324, 0.571965362142672],
            [30.468854529695236, 0.574105020573463],
            [30.468587652800743, 0.572762397523422],
            [30.469398322157517, 0.571116866522085],
            [30.469778793714646, 0.571147376284855],
            [30.46937907036266, 0.572061161795017],
            [30.469834739892214, 0.572425433829965],
            [30.47262721314005, 0.570181584343276],
            [30.473320808659103, 0.569195869488135],
            [30.474918474070023, 0.568339495621948],
            [30.473928787545102, 0.565847454836503],
            [30.474098495471917, 0.565422780811525],
            [30.477184506713577, 0.56710929436977],
            [30.47852355523901, 0.566626759186378],
            [30.479835109926874, 0.564546435113187],
            [30.48103069211153, 0.564174331448366],
            [30.480739543636393, 0.563394338693297],
            [30.480977594491726, 0.562959868833887],
            [30.482263678348026, 0.562819505759881],
            [30.483136768938948, 0.561847585316313],
            [30.48437194886136, 0.561513528694374],
            [30.484928748928983, 0.560364060918912],
            [30.486331553585078, 0.559160632790446],
            [30.4881128193687, 0.555966805165095],
            [30.488644755865888, 0.555922194233273],
            [30.48976613990302, 0.557184433843654],
            [30.493014463241753, 0.557929666069393],
            [30.49320681949357, 0.556276659934579],
            [30.49608890148757, 0.553994362625354],
            [30.496763806658855, 0.552648326891698],
            [30.498075253548905, 0.551594580125059],
            [30.498776026607064, 0.551443179691554],
            [30.499156330179236, 0.551894646635605],
            [30.49965406422031, 0.550806418598485],
            [30.49928165594116, 0.549494066519416],
            [30.499882640544353, 0.548926671737999],
            [30.499997992311673, 0.548159419885416],
            [30.500772623055894, 0.54776801486743],
            [30.500842476950687, 0.547310567799417],
            [30.501824995817973, 0.547459840325869],
            [30.50169921640685, 0.546893314881284],
            [30.502090572850232, 0.546447220138853],
            [30.503637477159398, 0.545896060482543],
            [30.50324148900237, 0.545405020497423],
            [30.503929108029872, 0.545179240972896],
            [30.50402080985071, 0.543822310774703],
            [30.50475627674347, 0.543324980001555],
            [30.50460492588947, 0.542561298975911],
            [30.505194276411387, 0.542360724942604],
            [30.505638469963188, 0.542654203067908],
            [30.50722061518095, 0.541769911455954],
            [30.50704565480463, 0.541203643281821],
            [30.508049002908383, 0.540162252082046],
            [30.507259967678596, 0.539772039455118],
            [30.50735665604756, 0.539426232153028],
            [30.50814204142236, 0.539076591889599],
            [30.506911840861598, 0.539009451183498],
            [30.50720214492036, 0.538021345321619],
            [30.50692914241396, 0.537529617517428],
            [30.508554290882678, 0.535387296845427],
            [30.50860019209873, 0.534721157735605],
            [30.507957021711515, 0.53398486407539],
            [30.508196533227494, 0.532676442804101],
            [30.507773779766588, 0.531741633367344],
            [30.506592423302735, 0.531600223968789],
            [30.506511448264735, 0.53014560045311],
            [30.50742437285032, 0.528229199300144],
            [30.506811162176135, 0.528577888904921],
            [30.50554907591433, 0.527031202039051],
            [30.505570258188722, 0.526340535463477],
            [30.50618613865595, 0.526534403481231],
            [30.506083728916913, 0.525721113892781],
            [30.506820522621393, 0.525495065058344],
            [30.506517086091456, 0.523819716210067],
            [30.50430254577829, 0.523659423036295],
            [30.505285233528863, 0.520928765829188],
            [30.50437016017312, 0.519922717569847],
            [30.50424278625235, 0.519035588638901],
            [30.504752122933596, 0.517577686180369],
            [30.5040600060415, 0.5168910033311],
            [30.503882948098987, 0.515905503457676],
            [30.504409029377133, 0.515347663273274],
            [30.503719715228712, 0.515228203849827],
            [30.503984911375298, 0.514141597015586],
            [30.504723523269902, 0.514285434855834],
            [30.50535399237733, 0.512456917427364],
            [30.50343511726861, 0.512393638138024],
            [30.502929633461612, 0.50965895628734],
            [30.503503185312642, 0.508755600300437],
            [30.5010459956682, 0.509262548118624],
            [30.500750341243588, 0.508390063262342],
            [30.49980912691305, 0.508687316657443],
            [30.499048869213382, 0.506847134367656],
            [30.49688730524748, 0.506894196162062],
            [30.49683972687678, 0.505938381120019],
            [30.49752853257878, 0.505245656090199],
            [30.49612695502135, 0.503763699037597],
            [30.496756198826734, 0.500836772437674],
            [30.49901259434389, 0.49825683264705],
            [30.500627782292725, 0.497516615563768],
            [30.502539177130082, 0.495768739349486],
            [30.5037975551464, 0.493977514284369],
            [30.50569613012635, 0.492998359994955],
            [30.506480459980704, 0.490299533070493],
            [30.508996650972964, 0.487815713523452],
            [30.509957713579674, 0.487493300083228],
            [30.509388762899544, 0.486585716433535],
            [30.509626113068975, 0.486394657948139],
            [30.510575105911517, 0.486466327450156],
            [30.511666762899296, 0.485940910080508],
            [30.51427523871905, 0.488663690566538],
            [30.515366695382514, 0.488568173480837],
            [30.517028096262823, 0.487421798571008],
            [30.519602814292487, 0.486550099516864],
            [30.519531944403106, 0.48592911382849],
            [30.51865416999628, 0.485761906534763],
            [30.518179998765113, 0.485069271918402],
            [30.5192482231987, 0.483946762003629],
            [30.521312881403315, 0.482991443998463],
            [30.521218456788883, 0.482036095317401],
            [30.52232177211239, 0.481904746507257],
            [30.522464837804566, 0.480495618002343],
            [30.524623608908225, 0.481116631136198],
            [30.525098276907727, 0.480830014879228],
            [30.525336059166793, 0.479755255235216],
            [30.526474964843576, 0.479659736227452],
            [30.527874338833588, 0.480615096020806],
            [30.530378001920937, 0.479504528054929],
            [30.53163938120859, 0.479757340151887],
            [30.529202206028714, 0.481915228577541],
            [30.52803933779173, 0.482464539700314],
            [30.528157609083713, 0.483204937206282],
            [30.529035046622322, 0.484064773065007],
            [30.530102589234623, 0.48435139457537],
            [30.530648000461042, 0.484924614204404],
            [30.53082483382474, 0.487133879172174],
            [30.529851581079622, 0.488065338203755],
            [30.52769252790494, 0.488017542378096],
            [30.52728882411795, 0.488710151539642],
            [30.528332029572546, 0.490214859175007],
            [30.5317248810607, 0.490214922953033],
            [30.532484280869305, 0.489904441513774],
            [30.534370036890135, 0.490847900314445],
            [30.53391774412774, 0.493809499636034],
            [30.534178302272515, 0.494669326950401],
            [30.532682751953224, 0.496221745467672],
            [30.532906360593753, 0.497169988517668],
            [30.531848455107816, 0.498226632429102],
            [30.533043193774468, 0.501056159593952],
            [30.532037287268754, 0.504058312598298],
            [30.532681099951425, 0.504917899629614],
            [30.532463890010657, 0.505757644434016],
            [30.53306118433463, 0.50716008797314],
            [30.533297109776036, 0.510093623061777],
            [30.533841778994052, 0.510805804307725],
            [30.5346660874718, 0.510862852247332],
            [30.536640444329116, 0.512183616826537],
            [30.53814267811412, 0.51254517157667],
            [30.540797047065084, 0.517068310075534],
            [30.543086885961984, 0.520002757758914],
            [30.5441298497698, 0.521994624870781],
            [30.54509329470864, 0.52282778934146],
            [30.549427875261976, 0.523913449695254],
            [30.550951544646278, 0.526112289464939],
            [30.555727081223143, 0.526825545943615],
            [30.55814383859495, 0.52806989344616],
            [30.56134953238187, 0.532158457050088],
            [30.566570261437136, 0.535841175064432],
            [30.56831719810217, 0.540912102666016],
            [30.568002309848975, 0.541900385916497],
            [30.56605915597307, 0.544414534352087],
            [30.56314665522688, 0.547390338149823],
            [30.55915737179739, 0.553985267608232],
            [30.553603727097876, 0.557604611713737],
            [30.551130808851127, 0.55993666562756],
            [30.55043639137356, 0.561284659726606],
            [30.549884496107424, 0.564099310487363],
            [30.550436430001135, 0.566291254825244],
            [30.54712403881634, 0.570489996632485],
            [30.544549556145252, 0.574684639264316],
            [30.54260345220194, 0.576606789633065],
            [30.54128670345512, 0.578957054576146],
            [30.541219928985107, 0.580387866439322],
            [30.540023728759486, 0.582244205002099],
            [30.540759093244347, 0.584225489420416],
            [30.54059622329343, 0.586125429558264],
            [30.54247638370838, 0.58831002836919],
            [30.543905290711702, 0.59127401082828],
            [30.54459390237756, 0.59124554293615],
            [30.546714713372275, 0.592343652335465],
            [30.54718799347466, 0.593549523925336],
            [30.548474305503056, 0.595022195781533],
            [30.549556554434833, 0.597519521659467],
            [30.550236330271577, 0.598070811996374],
            [30.553633673336183, 0.598767149819474],
            [30.555928857209015, 0.600308245689865],
            [30.555543013726485, 0.601888823497457],
            [30.55435757980957, 0.603436807284768],
            [30.553948341502092, 0.605264132240234],
            [30.55455352393259, 0.608294360644316],
            [30.554237970926106, 0.609159303206933],
            [30.554646099814196, 0.60962117013997],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 94,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "NYABUHARWA",
        Population: 24730,
        Key: "KYENJOJONYABUHARWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.59188460648057, 0.611230827432077],
            [30.590433834483225, 0.611450605721507],
            [30.58777479519108, 0.610972007876404],
            [30.586707173527042, 0.608955474409238],
            [30.58686572078483, 0.606167603670694],
            [30.58619250983617, 0.604321547492756],
            [30.586136673253055, 0.602965349043015],
            [30.58437297222818, 0.604479574816334],
            [30.58359536806036, 0.606432299008102],
            [30.58054828082001, 0.609593735347467],
            [30.576704456194594, 0.608283122455172],
            [30.570420204487945, 0.608428786846915],
            [30.57060336288954, 0.61067215020736],
            [30.56768572737318, 0.612636648397584],
            [30.566014518686597, 0.612941821882496],
            [30.55960225884862, 0.612052308814198],
            [30.554646099814196, 0.60962117013997],
            [30.554237970926106, 0.609159303206933],
            [30.55455352393259, 0.608294360644316],
            [30.553948341502092, 0.605264132240234],
            [30.55435757980957, 0.603436807284768],
            [30.555543013726485, 0.601888823497457],
            [30.555928857209015, 0.600308245689865],
            [30.553633673336183, 0.598767149819474],
            [30.550236330271577, 0.598070811996374],
            [30.549556554434833, 0.597519521659467],
            [30.548474305503056, 0.595022195781533],
            [30.54718799347466, 0.593549523925336],
            [30.546714713372275, 0.592343652335465],
            [30.54459390237756, 0.59124554293615],
            [30.543905290711702, 0.59127401082828],
            [30.54247638370838, 0.58831002836919],
            [30.54059622329343, 0.586125429558264],
            [30.540759093244347, 0.584225489420416],
            [30.540023728759486, 0.582244205002099],
            [30.541219928985107, 0.580387866439322],
            [30.54128670345512, 0.578957054576146],
            [30.54260345220194, 0.576606789633065],
            [30.544549556145252, 0.574684639264316],
            [30.54712403881634, 0.570489996632485],
            [30.550436430001135, 0.566291254825244],
            [30.549884496107424, 0.564099310487363],
            [30.55043639137356, 0.561284659726606],
            [30.551130808851127, 0.55993666562756],
            [30.553603727097876, 0.557604611713737],
            [30.55915737179739, 0.553985267608232],
            [30.56314665522688, 0.547390338149823],
            [30.56605915597307, 0.544414534352087],
            [30.568002309848975, 0.541900385916497],
            [30.56831719810217, 0.540912102666016],
            [30.566570261437136, 0.535841175064432],
            [30.56134953238187, 0.532158457050088],
            [30.55814383859495, 0.52806989344616],
            [30.555727081223143, 0.526825545943615],
            [30.550951544646278, 0.526112289464939],
            [30.549427875261976, 0.523913449695254],
            [30.54509329470864, 0.52282778934146],
            [30.5441298497698, 0.521994624870781],
            [30.543086885961984, 0.520002757758914],
            [30.540797047065084, 0.517068310075534],
            [30.53814267811412, 0.51254517157667],
            [30.536640444329116, 0.512183616826537],
            [30.5346660874718, 0.510862852247332],
            [30.533841778994052, 0.510805804307725],
            [30.533297109776036, 0.510093623061777],
            [30.53306118433463, 0.50716008797314],
            [30.532463890010657, 0.505757644434016],
            [30.532681099951425, 0.504917899629614],
            [30.532037287268754, 0.504058312598298],
            [30.533043193774468, 0.501056159593952],
            [30.531848455107816, 0.498226632429102],
            [30.532906360593753, 0.497169988517668],
            [30.532682751953224, 0.496221745467672],
            [30.534178302272515, 0.494669326950401],
            [30.53391774412774, 0.493809499636034],
            [30.534370036890135, 0.490847900314445],
            [30.532484280869305, 0.489904441513774],
            [30.5317248810607, 0.490214922953033],
            [30.528332029572546, 0.490214859175007],
            [30.52728882411795, 0.488710151539642],
            [30.52769252790494, 0.488017542378096],
            [30.529851581079622, 0.488065338203755],
            [30.53082483382474, 0.487133879172174],
            [30.530648000461042, 0.484924614204404],
            [30.530102589234623, 0.48435139457537],
            [30.529035046622322, 0.484064773065007],
            [30.528157609083713, 0.483204937206282],
            [30.52803933779173, 0.482464539700314],
            [30.529202206028714, 0.481915228577541],
            [30.53163938120859, 0.479757340151887],
            [30.53256077870396, 0.479600086589381],
            [30.53275123142566, 0.478310364703772],
            [30.533747754129895, 0.478262606537419],
            [30.533938039764962, 0.477307250009281],
            [30.53479265290882, 0.476375783217697],
            [30.535599448730114, 0.476160830983226],
            [30.535730833628598, 0.474357587071443],
            [30.53755839588703, 0.473067866899606],
            [30.53828337225392, 0.470380915494969],
            [30.539493881743674, 0.469425556981674],
            [30.53939947689214, 0.468398546613974],
            [30.54015879585237, 0.468231367639396],
            [30.540444568808876, 0.466057908559626],
            [30.54203452667463, 0.465484688263357],
            [30.54256926501717, 0.463633668058266],
            [30.54226114826463, 0.462941041108341],
            [30.542996780447424, 0.462726073189919],
            [30.542973484437162, 0.46181847551059],
            [30.54382769872901, 0.461699050168707],
            [30.543828250294595, 0.460552612417445],
            [30.54284462290626, 0.45843886727434],
            [30.544315622268847, 0.458510510116097],
            [30.546190323621794, 0.457865625702864],
            [30.54649902517762, 0.457316291087037],
            [30.545929831952336, 0.456814728216063],
            [30.54574046349721, 0.455883247033639],
            [30.547657974963332, 0.454665151998046],
            [30.54919107755646, 0.455007214290013],
            [30.549394013267317, 0.456251868015484],
            [30.551432985044734, 0.459404562057666],
            [30.55422052294835, 0.460085252923319],
            [30.556212875755755, 0.461518300626743],
            [30.557302925657496, 0.464384414928827],
            [30.55661439753493, 0.465315910271032],
            [30.55655448349872, 0.466545956971489],
            [30.559624451727707, 0.471979647941948],
            [30.569904530192343, 0.483169592451668],
            [30.5710667785918, 0.483933920146412],
            [30.57636887974041, 0.485737252259536],
            [30.583830040351916, 0.487803358542803],
            [30.59055367423371, 0.493906021824289],
            [30.591572173323076, 0.495915815003303],
            [30.59258492588953, 0.500734540876897],
            [30.594798253477048, 0.504530728188508],
            [30.596052371682266, 0.505841636335115],
            [30.60444641564833, 0.511546644183382],
            [30.608442333136185, 0.513154955004146],
            [30.615750865489346, 0.513359776145309],
            [30.620961819975996, 0.512883849827691],
            [30.62339915685265, 0.512434606863026],
            [30.62555262969276, 0.510903552396521],
            [30.629336433382473, 0.510167538903428],
            [30.632919068347455, 0.507053600460457],
            [30.636105036927376, 0.507058083776467],
            [30.637421582654948, 0.50747513455603],
            [30.64023436321807, 0.506353610259425],
            [30.643689698822463, 0.506758675332384],
            [30.648360337326963, 0.502901416113672],
            [30.65181202127972, 0.498101573702355],
            [30.65196114521015, 0.494527596944066],
            [30.653730242414923, 0.491816518967925],
            [30.654039807251724, 0.489571229021714],
            [30.65571435048464, 0.486095801910509],
            [30.65565353903149, 0.48243580091826],
            [30.660187570730713, 0.485247829934102],
            [30.66372271176665, 0.486107721227009],
            [30.664552745207693, 0.48708706965444],
            [30.667091214419045, 0.488090271836395],
            [30.667944819653126, 0.489380131096678],
            [30.668454082672547, 0.491255212047426],
            [30.66828622347855, 0.494862040732813],
            [30.668677550277565, 0.497588917336428],
            [30.667589950081613, 0.498481765878125],
            [30.662633676062867, 0.499912003797238],
            [30.658777964031295, 0.50337516214137],
            [30.65854818306644, 0.504345152426407],
            [30.65969414860304, 0.507671539892554],
            [30.66079484174426, 0.509288735669584],
            [30.6635319563127, 0.511753570942975],
            [30.66377604294843, 0.513972490579947],
            [30.666236524020036, 0.517116253006345],
            [30.668745011060462, 0.519328916062134],
            [30.670209354805117, 0.521442210822707],
            [30.671378833744246, 0.52476288980301],
            [30.674121246576235, 0.529139984849801],
            [30.675673968375165, 0.536223232495478],
            [30.681556539300825, 0.543081982265323],
            [30.683108663720084, 0.546066764975172],
            [30.685104253157437, 0.553114818265566],
            [30.684689671670654, 0.554881919451139],
            [30.680125770988248, 0.562357478668823],
            [30.679829199383697, 0.565464267482574],
            [30.678886231541757, 0.566262565832962],
            [30.678248397147293, 0.567941551634436],
            [30.67727129871447, 0.568594823783992],
            [30.673011198379648, 0.569925361573744],
            [30.672457628653785, 0.570620959117413],
            [30.673308991692945, 0.571576794554088],
            [30.67387514052773, 0.57342778409695],
            [30.67296607869787, 0.574326401951997],
            [30.673115142441162, 0.575185622441163],
            [30.67465442274849, 0.575579171589952],
            [30.675898094445294, 0.579280539351592],
            [30.675849290772515, 0.581887847345526],
            [30.6697265633405, 0.580144204626696],
            [30.666822733133436, 0.577461988225216],
            [30.664490962675718, 0.577087686431831],
            [30.65673799871719, 0.578967138548686],
            [30.65442061388043, 0.57898001703736],
            [30.650279659796702, 0.578078591925672],
            [30.648138687013766, 0.578490234716911],
            [30.646773734668766, 0.579622117049218],
            [30.64667520026191, 0.582383434883496],
            [30.643595952436037, 0.584549176004264],
            [30.640470806089063, 0.587514664160488],
            [30.63952613144807, 0.587969618049442],
            [30.637807293186807, 0.588079090865856],
            [30.63564877540806, 0.587453960103106],
            [30.633961608150436, 0.58893738404548],
            [30.63115291222692, 0.590377053876911],
            [30.626862029322258, 0.589376484290781],
            [30.62609813254735, 0.589621820971877],
            [30.624780987643483, 0.591836455574714],
            [30.62284662018938, 0.593720962686652],
            [30.61948150418561, 0.598561490863723],
            [30.61482778634781, 0.602322320228036],
            [30.611094888388614, 0.608389025162685],
            [30.609240924643988, 0.608886455354006],
            [30.606196966235757, 0.608078814849244],
            [30.604752252476707, 0.608186734165001],
            [30.603632074876984, 0.608417768732898],
            [30.598723328923263, 0.610980710260081],
            [30.59188460648057, 0.611230827432077],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 96,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "NYANTUNGO",
        Population: 24213,
        Key: "KYENJOJONYANTUNGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.032143032482626, 0.583358094259971],
            [31.030203824007437, 0.58504167146779],
            [31.02434388074547, 0.587979067828605],
            [31.020916472864972, 0.591482932562932],
            [31.019680919243402, 0.591838585366638],
            [31.018348099636142, 0.593173320675803],
            [31.01130977153729, 0.592310376922328],
            [31.008700813322232, 0.591038883928358],
            [31.00715736034041, 0.591059470422635],
            [31.006765158582322, 0.59123777741398],
            [31.005662455011503, 0.595725851271427],
            [30.999174162666165, 0.597559892447725],
            [30.993548272756517, 0.60025045484957],
            [30.98679166082234, 0.601528859667758],
            [30.981832616399245, 0.603722586841284],
            [30.978543026253007, 0.609421538051352],
            [30.978378674081878, 0.611498353849445],
            [30.97651629851294, 0.616740974620106],
            [30.975351530339125, 0.617888923480316],
            [30.975353487768132, 0.619726721750565],
            [30.97322645773671, 0.622248944105578],
            [30.972516047552148, 0.625520200629999],
            [30.97095888807572, 0.626895646687114],
            [30.970176530023437, 0.629641949399247],
            [30.967502470001428, 0.632427756164374],
            [30.967052182278753, 0.634170965229073],
            [30.965078809076655, 0.635750086761428],
            [30.961832093722283, 0.63705721386535],
            [30.96092912067341, 0.638252348333228],
            [30.960941562340114, 0.650186035875654],
            [30.959771179695768, 0.657408193011586],
            [30.95817816755805, 0.658652394401141],
            [30.952339430824967, 0.661611338375783],
            [30.94701341472686, 0.665655213342969],
            [30.94571837017561, 0.667411956615504],
            [30.94521884040231, 0.667579990357103],
            [30.944483386085935, 0.669729461246887],
            [30.942534250328524, 0.671761931875041],
            [30.942142589356255, 0.67270544472922],
            [30.942262638414164, 0.673755359083748],
            [30.94174008751508, 0.674687185280609],
            [30.93852889603863, 0.675838996107197],
            [30.937055190052085, 0.677417065216459],
            [30.934533794221036, 0.678305000305288],
            [30.93393884629657, 0.678234536900476],
            [30.93317599426236, 0.676851723026059],
            [30.93133454404964, 0.676565645732052],
            [30.930959722895658, 0.67687531742712],
            [30.93121406649531, 0.678013047628239],
            [30.930905461059243, 0.678599580352679],
            [30.93010246151835, 0.678821503453881],
            [30.926807238036954, 0.681448278825394],
            [30.92486963035959, 0.68176410233347],
            [30.92380883858665, 0.682798926793942],
            [30.9240061535388, 0.680366661436044],
            [30.92311455495808, 0.679645380336218],
            [30.92293080546503, 0.678733348978465],
            [30.92526561043177, 0.67616718622694],
            [30.92577867152819, 0.674880095888302],
            [30.92449072456601, 0.669057754109017],
            [30.925350745567894, 0.666810992088634],
            [30.924999860024638, 0.664761188483446],
            [30.925564181686127, 0.657856609648882],
            [30.925105096761875, 0.655704620285376],
            [30.922300126151818, 0.650296723648075],
            [30.92260285121605, 0.645674157682074],
            [30.921220280213408, 0.644317562089019],
            [30.9211137984112, 0.642882414307078],
            [30.918197765489325, 0.641538056750021],
            [30.916682629201883, 0.641374005914627],
            [30.916310770691695, 0.640938048465126],
            [30.91622391977342, 0.638261900425259],
            [30.91319390860829, 0.637307336983368],
            [30.911016569327693, 0.635440663135282],
            [30.90883872249897, 0.634840542754899],
            [30.905088531072213, 0.63188719460802],
            [30.90290778268513, 0.631630892092635],
            [30.901035777176336, 0.629415687318745],
            [30.898085203133476, 0.630886701015623],
            [30.896143833311733, 0.631001666722872],
            [30.893328783604176, 0.629664962847117],
            [30.89115336492167, 0.627295343403028],
            [30.888279016523917, 0.626259154708228],
            [30.886885624415374, 0.62620411193044],
            [30.88345564914977, 0.627591809195172],
            [30.881196428431036, 0.627597693705557],
            [30.873459076293837, 0.62567430641357],
            [30.87232976642091, 0.624952062618153],
            [30.870712045223, 0.622963794676026],
            [30.86465172375374, 0.618350249803467],
            [30.848029547468037, 0.604194022560749],
            [30.846713608103272, 0.601233782944887],
            [30.846218952588718, 0.598996188840017],
            [30.843197840134803, 0.597454855458398],
            [30.84247577880099, 0.597456264838484],
            [30.8400615618648, 0.595633945110371],
            [30.839109555174463, 0.595438277458771],
            [30.841103668679818, 0.587895688797308],
            [30.841644140070528, 0.586890560953326],
            [30.842628158226006, 0.586328992417489],
            [30.842920858989988, 0.583793560547889],
            [30.84511801690235, 0.582077399159535],
            [30.84656173263313, 0.581712427092835],
            [30.847803825989967, 0.580171339543698],
            [30.851449094191505, 0.57897042082513],
            [30.85176016999462, 0.578294942840456],
            [30.850740870506343, 0.576552174829295],
            [30.851035240340106, 0.575596906133655],
            [30.85280629227896, 0.574408280174209],
            [30.852411668662864, 0.573684816949932],
            [30.852640890875588, 0.573190558093305],
            [30.854181798930192, 0.571640251980931],
            [30.857626246953334, 0.570020344731898],
            [30.861531700498823, 0.569815083556106],
            [30.861773810840937, 0.566045210196996],
            [30.86219959791258, 0.565221353295645],
            [30.86925285062154, 0.562211578631458],
            [30.87072812057499, 0.560661372880892],
            [30.873091402136257, 0.560821277919618],
            [30.873762013360484, 0.558762402525208],
            [30.873235590722505, 0.557578297711921],
            [30.87346420028421, 0.556524379354519],
            [30.874905436664797, 0.553854933541481],
            [30.873755196944106, 0.552474546000266],
            [30.87475211131381, 0.548670212692564],
            [30.874750140410075, 0.546859573899588],
            [30.87625764011926, 0.544782555702145],
            [30.875810120105974, 0.540717732067229],
            [30.876989551480143, 0.538773035837759],
            [30.877938220030902, 0.535907029474152],
            [30.879325348186985, 0.528842718941307],
            [30.879127483465872, 0.527987175596047],
            [30.874149875357425, 0.523240132113172],
            [30.87260454399835, 0.52074126912527],
            [30.871665238587802, 0.517204179219446],
            [30.87136349897546, 0.5114765855697],
            [30.87132796880932, 0.509040531075975],
            [30.87209333163476, 0.503722286506998],
            [30.87271512211826, 0.502107905453516],
            [30.87180943975048, 0.499327942304131],
            [30.871810336269146, 0.496860478445347],
            [30.871477383793916, 0.495904207407973],
            [30.86810266839303, 0.491458041484948],
            [30.867495328209205, 0.487788139836836],
            [30.865546778153366, 0.485732512918399],
            [30.862789669781662, 0.48147747973891],
            [30.859198640060377, 0.47008613158455],
            [30.858613923946983, 0.465614998068273],
            [30.858908933381247, 0.461657945494089],
            [30.859454395811632, 0.459936322439274],
            [30.862314403504197, 0.455763288908567],
            [30.86441358935508, 0.449964658933537],
            [30.865801190025, 0.448546970554097],
            [30.868610358462362, 0.451302822551171],
            [30.87309522177285, 0.451902184145049],
            [30.873867166554355, 0.452978868579949],
            [30.87410446012994, 0.454085296038197],
            [30.875203234469684, 0.454803260928183],
            [30.875766625476544, 0.458032799532216],
            [30.874920667600453, 0.461635390427752],
            [30.874963863090883, 0.46364150470423],
            [30.877786980567972, 0.469462271691596],
            [30.878750371607925, 0.46990347160536],
            [30.882400803325716, 0.47011542915135],
            [30.884169181878274, 0.469448459659434],
            [30.88518538487375, 0.471095302664047],
            [30.886953320556874, 0.471896862912079],
            [30.889339527124168, 0.47465665741416],
            [30.89119576899633, 0.475814256736736],
            [30.891637570334556, 0.476615412210894],
            [30.894156843446567, 0.4779067252759],
            [30.894289309018355, 0.478396279278152],
            [30.89512913050277, 0.478619045614787],
            [30.8978700476398, 0.477907877774316],
            [30.899240385384893, 0.477952803653603],
            [30.903085931182382, 0.478888522707478],
            [30.90706429379296, 0.479201264733801],
            [30.91197134193079, 0.478312749647725],
            [30.91387202346007, 0.483197872207827],
            [30.91491163385691, 0.482616862519162],
            [30.92218816911796, 0.480991377162778],
            [30.92588726796457, 0.478940227928917],
            [30.928310499494632, 0.477040164985238],
            [30.930095784340825, 0.474806369093554],
            [30.932634544606337, 0.469114946144488],
            [30.935612404975938, 0.465278392472045],
            [30.940990992281147, 0.46258678136999],
            [30.942582304806354, 0.462394997305025],
            [30.947535573960476, 0.464246484044474],
            [30.9479628414557, 0.463672502753039],
            [30.949293002049714, 0.463719903501597],
            [30.950076333875792, 0.46271541323007],
            [30.95153706729132, 0.462607344034922],
            [30.95428921247106, 0.456198434323092],
            [30.95715103206553, 0.455468239395858],
            [30.96256511629918, 0.452429828230153],
            [30.967113170699992, 0.451268677748099],
            [30.969202928731974, 0.45031155692899],
            [30.97024755532138, 0.449330866712606],
            [30.971161030574212, 0.447310102766726],
            [30.972490550669438, 0.446042383965724],
            [30.976361314871905, 0.444199959884667],
            [30.981810250145315, 0.439547455694098],
            [30.987901189792705, 0.436257632851495],
            [30.9912826928639, 0.433827051303535],
            [30.99199996258396, 0.436648804570506],
            [30.992832002861356, 0.43798754101161],
            [30.99416247247584, 0.438584869960984],
            [30.994625253069184, 0.437783685989551],
            [30.995076681652268, 0.438022647943683],
            [30.995648065868536, 0.44060486376304],
            [30.996218516735183, 0.441345915990938],
            [31.000103577625435, 0.444178095547712],
            [30.999915061671476, 0.447167062093685],
            [30.999001669961935, 0.449355247137949],
            [30.99977647677596, 0.455010006165887],
            [31.00062908218517, 0.457191210955194],
            [31.005725467337108, 0.46375731351457],
            [31.005765226771572, 0.465067357319413],
            [31.007186643622063, 0.466037303685297],
            [31.00828729454245, 0.466083787268424],
            [31.00957106523689, 0.467284539849328],
            [31.010120204471768, 0.471486044017046],
            [31.00961562616654, 0.471855247172982],
            [31.00911073075605, 0.473332496167068],
            [31.009248114604045, 0.47402506459963],
            [31.00855961343093, 0.476056283270181],
            [31.008811414798334, 0.477556836449091],
            [31.01027873196658, 0.478388302516483],
            [31.012333486245165, 0.482003730163081],
            [31.013212495835532, 0.483052205681689],
            [31.012157212531925, 0.484667798651358],
            [31.011881678573033, 0.485914271498841],
            [31.012315784044194, 0.491246885869112],
            [31.011581108567174, 0.494247628543891],
            [31.012635477385835, 0.495725346955685],
            [31.015305571345824, 0.497424126711766],
            [31.017886560514523, 0.500582355908305],
            [31.020248676960854, 0.511153434904444],
            [31.020066017124243, 0.512890625548417],
            [31.020749556003693, 0.515704235989543],
            [31.021889704948826, 0.517427083478],
            [31.024569710021396, 0.51938008649003],
            [31.02513947906674, 0.521217591892804],
            [31.02468204883925, 0.524892097154415],
            [31.022912744123616, 0.528795841456608],
            [31.021429410892182, 0.530173353613998],
            [31.019528583835843, 0.531135720620336],
            [31.01760999169641, 0.533364544094333],
            [31.017715503318126, 0.533949958855942],
            [31.022196386193578, 0.536945042985536],
            [31.024147943808963, 0.540161736471994],
            [31.02353527931048, 0.544669412615821],
            [31.02449864250262, 0.54772224869344],
            [31.02549372251252, 0.548679760447916],
            [31.025797904644136, 0.550639018990309],
            [31.027029554187486, 0.551979202028227],
            [31.030125844850893, 0.552671595768332],
            [31.031674457755702, 0.553498884039123],
            [31.03231970325125, 0.554676712537695],
            [31.030909897125813, 0.557982670446001],
            [31.030713662846964, 0.560705214855695],
            [31.033155579334917, 0.567505846094158],
            [31.033233147961383, 0.569906514953166],
            [31.03380032446885, 0.571078112430998],
            [31.034677320036323, 0.576896143885098],
            [31.034460136146727, 0.578400473340165],
            [31.03291250959207, 0.580212498239683],
            [31.03212428284604, 0.582217215614638],
            [31.032143032482626, 0.583358094259971],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 97,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "KAKABARA",
        Population: 48502,
        Key: "KYEGEGWAKAKABARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.11692319211816, 0.528170027091957],
            [31.116024398032017, 0.52930579869282],
            [31.115110832947643, 0.532620413707803],
            [31.114328571913376, 0.53353019703253],
            [31.11061611691512, 0.53363638946367],
            [31.10646009538911, 0.535121422394824],
            [31.106885291369295, 0.536286877142298],
            [31.10660486518535, 0.537855932344419],
            [31.104663410921948, 0.539421518003326],
            [31.10320387765565, 0.539342520064643],
            [31.1028255674451, 0.53969615943502],
            [31.102756486999777, 0.54239224810843],
            [31.099480235937175, 0.544360107885804],
            [31.098394404524004, 0.545952784721134],
            [31.09631372756125, 0.547859838255182],
            [31.096135073312464, 0.548948075812182],
            [31.095655796057258, 0.549428087397521],
            [31.093868919396368, 0.549424338900186],
            [31.092833062160793, 0.551169014881004],
            [31.0919260628628, 0.551597491429967],
            [31.086174978345298, 0.551749993143023],
            [31.08129641488683, 0.555549882519884],
            [31.073547779011356, 0.559799391639788],
            [31.069197842656532, 0.563549692113841],
            [31.063943644170443, 0.566538579479802],
            [31.057690949381403, 0.573861688156893],
            [31.057049064483362, 0.574194730816534],
            [31.055190385481804, 0.577033239609114],
            [31.053703794060834, 0.578116891444879],
            [31.04999794527317, 0.578801740197647],
            [31.04776049522533, 0.581137811579609],
            [31.04673918530745, 0.581255072522012],
            [31.043707564361362, 0.583028135894947],
            [31.039599790450954, 0.582971636585196],
            [31.03776799622924, 0.58444866424586],
            [31.033912128789094, 0.583282018983022],
            [31.032143032482626, 0.583358094259971],
            [31.03212428284604, 0.582217215614638],
            [31.03291250959207, 0.580212498239683],
            [31.034460136146727, 0.578400473340165],
            [31.034677320036323, 0.576896143885098],
            [31.03380032446885, 0.571078112430998],
            [31.033233147961383, 0.569906514953166],
            [31.033155579334917, 0.567505846094158],
            [31.030713662846964, 0.560705214855695],
            [31.030909897125813, 0.557982670446001],
            [31.03231970325125, 0.554676712537695],
            [31.031674457755702, 0.553498884039123],
            [31.030125844850893, 0.552671595768332],
            [31.027029554187486, 0.551979202028227],
            [31.025797904644136, 0.550639018990309],
            [31.02549372251252, 0.548679760447916],
            [31.02449864250262, 0.54772224869344],
            [31.02353527931048, 0.544669412615821],
            [31.024147943808963, 0.540161736471994],
            [31.022196386193578, 0.536945042985536],
            [31.017715503318126, 0.533949958855942],
            [31.01760999169641, 0.533364544094333],
            [31.019528583835843, 0.531135720620336],
            [31.021429410892182, 0.530173353613998],
            [31.022912744123616, 0.528795841456608],
            [31.02468204883925, 0.524892097154415],
            [31.02513947906674, 0.521217591892804],
            [31.024569710021396, 0.51938008649003],
            [31.021889704948826, 0.517427083478],
            [31.020749556003693, 0.515704235989543],
            [31.020066017124243, 0.512890625548417],
            [31.020248676960854, 0.511153434904444],
            [31.017886560514523, 0.500582355908305],
            [31.015305571345824, 0.497424126711766],
            [31.012635477385835, 0.495725346955685],
            [31.011581108567174, 0.494247628543891],
            [31.012315784044194, 0.491246885869112],
            [31.011881678573033, 0.485914271498841],
            [31.012157212531925, 0.484667798651358],
            [31.013212495835532, 0.483052205681689],
            [31.012333486245165, 0.482003730163081],
            [31.012982997839995, 0.481312172205315],
            [31.014366597413648, 0.481177789877502],
            [31.018339720151186, 0.477854119067753],
            [31.019522488766643, 0.477697208606099],
            [31.02133076509422, 0.475204102483229],
            [31.021628629374455, 0.474073440815119],
            [31.022640132384353, 0.474552990895435],
            [31.023770822069547, 0.47443350468705],
            [31.02579420628012, 0.474074645414658],
            [31.027817882443152, 0.472697359498651],
            [31.03245954219492, 0.472698693451475],
            [31.031984336104554, 0.469643273448019],
            [31.034187492068106, 0.464851293556995],
            [31.034426622698415, 0.460897458217576],
            [31.038236533226915, 0.455926178856879],
            [31.03905364170765, 0.455463769520237],
            [31.042497913660995, 0.459520069112782],
            [31.04353181346759, 0.460040844342299],
            [31.04687254919454, 0.460121847311429],
            [31.047468916457152, 0.460842690604819],
            [31.04846312510123, 0.461083194161966],
            [31.048462145039263, 0.464646551781514],
            [31.04878002647896, 0.465687622663861],
            [31.049582637049344, 0.466545929124669],
            [31.05319560362988, 0.466072542529744],
            [31.05928189898725, 0.46233745849138],
            [31.065739931582232, 0.457600262853194],
            [31.06732209027471, 0.457820540698244],
            [31.07442979346631, 0.453422832647258],
            [31.075227925934996, 0.453155242780043],
            [31.076937933757023, 0.45361479660972],
            [31.079407138368374, 0.457326476759593],
            [31.080850934947524, 0.458512864525065],
            [31.08481915647686, 0.4644532056534],
            [31.087431408814048, 0.469366453412738],
            [31.08802455022648, 0.472955277695411],
            [31.089516179399574, 0.475625886514772],
            [31.090870697812527, 0.475848211883509],
            [31.093429707002805, 0.479285097075033],
            [31.0949227815652, 0.480144561538827],
            [31.095669049800964, 0.481540718003379],
            [31.08729433937643, 0.486853647265734],
            [31.083773174329703, 0.491147821503499],
            [31.083613008307818, 0.491738363027302],
            [31.085212348178384, 0.493940113419143],
            [31.08585101890438, 0.498503940849936],
            [31.085210621616433, 0.499899689261737],
            [31.083823633597532, 0.501080456296607],
            [31.085529597204157, 0.503389626255819],
            [31.08744914515104, 0.50483982468963],
            [31.08776860313404, 0.50666537905724],
            [31.089208061748707, 0.508437578676891],
            [31.093419204798842, 0.510701670347764],
            [31.093549498244286, 0.512609222486503],
            [31.09526156231, 0.515418008395483],
            [31.09829533382288, 0.51714330556752],
            [31.098612187589893, 0.521331180057608],
            [31.099549485265786, 0.52230677916411],
            [31.110556583764613, 0.51795183718503],
            [31.1129553155419, 0.515827870604292],
            [31.115150850198575, 0.516289844635755],
            [31.1154887559843, 0.516566400423011],
            [31.116712134738805, 0.522712581608625],
            [31.11694368538474, 0.525434673861625],
            [31.116583937062924, 0.527539878476753],
            [31.11692319211816, 0.528170027091957],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 100,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "KYEGEGWA TOWN COUNCIL",
        Population: 18763,
        Key: "KYEGEGWAKYEGEGWA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.9912826928639, 0.433827051303535],
            [30.987901189792705, 0.436257632851495],
            [30.981810250145315, 0.439547455694098],
            [30.976361314871905, 0.444199959884667],
            [30.972490550669438, 0.446042383965724],
            [30.971161030574212, 0.447310102766726],
            [30.97024755532138, 0.449330866712606],
            [30.969202928731974, 0.45031155692899],
            [30.967113170699992, 0.451268677748099],
            [30.96256511629918, 0.452429828230153],
            [30.95715103206553, 0.455468239395858],
            [30.95428921247106, 0.456198434323092],
            [30.95153706729132, 0.462607344034922],
            [30.950076333875792, 0.46271541323007],
            [30.949293002049714, 0.463719903501597],
            [30.9479628414557, 0.463672502753039],
            [30.947535573960476, 0.464246484044474],
            [30.942582304806354, 0.462394997305025],
            [30.940990992281147, 0.46258678136999],
            [30.935612404975938, 0.465278392472045],
            [30.932634544606337, 0.469114946144488],
            [30.930095784340825, 0.474806369093554],
            [30.928310499494632, 0.477040164985238],
            [30.92588726796457, 0.478940227928917],
            [30.92384318207828, 0.475320591103334],
            [30.922923981862144, 0.47439466825542],
            [30.91687037170637, 0.475704145943661],
            [30.915261292301466, 0.475703653683852],
            [30.912733000104, 0.474854380600084],
            [30.911030590232624, 0.474918928624273],
            [30.91073902314257, 0.472980078437059],
            [30.910259391951108, 0.472625765308434],
            [30.909332562343252, 0.470419994486005],
            [30.905461273524644, 0.46519653619037],
            [30.905024448853137, 0.463837651709802],
            [30.906146494948658, 0.462268722541737],
            [30.90850424198944, 0.460508784132216],
            [30.908865744721023, 0.459437195904497],
            [30.909835390730265, 0.458959047916994],
            [30.911471209387937, 0.45564875284112],
            [30.91334406919454, 0.45530370287727],
            [30.9142613533042, 0.454155722642615],
            [30.912814077549964, 0.446348338178817],
            [30.912243834194108, 0.446156799813739],
            [30.910581440675404, 0.442711582278135],
            [30.909774433750023, 0.439457988818961],
            [30.908491588320327, 0.438309379102731],
            [30.90844421027394, 0.437783087729048],
            [30.9085398979197, 0.435486624865564],
            [30.909395818112305, 0.433764497115018],
            [30.911584798660652, 0.42333519750164],
            [30.913629385806885, 0.419508259620308],
            [30.916768192834382, 0.416270479690307],
            [30.921796808182954, 0.413897403191182],
            [30.92603861612365, 0.413898529649149],
            [30.926441020048436, 0.413272817253441],
            [30.926387616103128, 0.407695658556175],
            [30.924743102651817, 0.403737852508346],
            [30.92419519321056, 0.401381692556948],
            [30.92456246132965, 0.395049984869661],
            [30.921565623151338, 0.388312496503317],
            [30.92262664758793, 0.385956744497793],
            [30.921914157803485, 0.383618959539389],
            [30.92244541337768, 0.379348811877613],
            [30.921757432329112, 0.376493770196538],
            [30.924808302375144, 0.37820102987627],
            [30.928537683430008, 0.378845224657602],
            [30.933869191827768, 0.377372779629548],
            [30.93672385095111, 0.377658652381764],
            [30.93583881636015, 0.37598943453058],
            [30.935885517076816, 0.374357496547228],
            [30.93486655535512, 0.374403880964999],
            [30.934403687625192, 0.373168152417561],
            [30.932968047748822, 0.37251503174569],
            [30.931000566596683, 0.368481331011246],
            [30.929125157371285, 0.366848946984605],
            [30.928384763219178, 0.364004532609837],
            [30.929010888972197, 0.360227899242939],
            [30.92718169537324, 0.359015178633027],
            [30.925792617872993, 0.357289666363693],
            [30.923893753635515, 0.356962844052475],
            [30.921416322252806, 0.354980642735624],
            [30.917456870975595, 0.352695036268502],
            [30.915741105850902, 0.350910516290666],
            [30.91457623976074, 0.344381987311887],
            [30.91285071713544, 0.341563650857793],
            [30.911032606052146, 0.335410726136087],
            [30.910333073567333, 0.334236428922075],
            [30.90986738782238, 0.330291201433537],
            [30.91070720661181, 0.32991565438556],
            [30.91565234691096, 0.32991670809192],
            [30.91779845446407, 0.32944750422699],
            [30.918824767998085, 0.329635584980305],
            [30.920130623773765, 0.331608438448911],
            [30.922649997497114, 0.330951450378139],
            [30.92493593501072, 0.331139800593089],
            [30.926894921693506, 0.333159767805748],
            [30.937298269676408, 0.334289184284293],
            [30.938557970012784, 0.333960686750428],
            [30.9392112311756, 0.333397225348979],
            [30.93701322794854, 0.318498580504065],
            [30.937145824674367, 0.315889279592586],
            [30.93966571492898, 0.315430818768705],
            [30.94318173352744, 0.316720536448358],
            [30.945533082766797, 0.316552209107584],
            [30.94742179424491, 0.317280705607704],
            [30.949014049102843, 0.318810328815478],
            [30.949869291965733, 0.319096904916973],
            [30.951486078017467, 0.32194159853435],
            [30.953161297681795, 0.32314840131721],
            [30.955633403851508, 0.326447070733808],
            [30.95985524673501, 0.336691081870904],
            [30.961604720242416, 0.343206060773758],
            [30.96562152535725, 0.347962714475356],
            [30.967867133006163, 0.349767099988622],
            [30.970931750869305, 0.350746243555902],
            [30.97638454261022, 0.353625387565094],
            [30.984485317178734, 0.355654668969858],
            [30.98585180923613, 0.356933378984655],
            [30.987514915118833, 0.357697890611672],
            [30.988418317562417, 0.359132204358504],
            [30.990667086382818, 0.361277653268789],
            [30.991839923224532, 0.361306794935548],
            [30.993145895781204, 0.360541128399764],
            [30.996114843964893, 0.360253052472021],
            [30.996541938085244, 0.359439907226088],
            [30.9978717465397, 0.358817697774036],
            [30.998469988586287, 0.359087370323301],
            [31.004194701262033, 0.357416424269635],
            [31.005677597912243, 0.357527338895625],
            [31.00787485104606, 0.355924365866036],
            [31.015301069887936, 0.352873872180178],
            [31.017058653385735, 0.352653075858193],
            [31.017585724607322, 0.353493629679436],
            [31.01907955285624, 0.353892059052273],
            [31.019475321824338, 0.352343961537586],
            [31.021848011441538, 0.352300244054189],
            [31.022550964710927, 0.352654261611901],
            [31.02430867756612, 0.351814197287489],
            [31.029559482217103, 0.351173936913599],
            [31.03241569362926, 0.350245630798206],
            [31.03496466953613, 0.347724827904131],
            [31.048869063896664, 0.337491890035822],
            [31.05365007480684, 0.335404990491299],
            [31.055671247365193, 0.335564636346846],
            [31.056268905506865, 0.335104717578298],
            [31.058730345080907, 0.330894066954916],
            [31.059538917769828, 0.330469576035719],
            [31.060452890689355, 0.330328204221804],
            [31.06178854807458, 0.330823897124762],
            [31.062772588687945, 0.331850339920658],
            [31.06410829098896, 0.332169092764416],
            [31.068906916963577, 0.329993683452184],
            [31.071648772840067, 0.329888066682182],
            [31.071684111665018, 0.328932589421831],
            [31.0736528055428, 0.327906720339028],
            [31.07715046796674, 0.327641987563553],
            [31.083900016447835, 0.325696946500056],
            [31.087098810275037, 0.325909897678431],
            [31.088328656001316, 0.328422708666238],
            [31.089400715342855, 0.328794492789686],
            [31.091615405674634, 0.328299485189072],
            [31.095517274942136, 0.328441797552407],
            [31.09653674421199, 0.328158881391335],
            [31.09716966212687, 0.327238902111775],
            [31.098927231251622, 0.327486966031824],
            [31.100051929173876, 0.32837189450023],
            [31.10087798397654, 0.328531306012866],
            [31.102389668936638, 0.327823821568634],
            [31.107557189879287, 0.327258591963322],
            [31.10811970682537, 0.326904815117941],
            [31.111037224662415, 0.327577755477481],
            [31.114341739418826, 0.326729056303692],
            [31.11472803475393, 0.32874629806982],
            [31.11388420588503, 0.329595475866597],
            [31.113672999385326, 0.331152548372351],
            [31.112723601402596, 0.332567926361874],
            [31.11275847130696, 0.334089655684076],
            [31.11131708580605, 0.334726376102277],
            [31.111808727472845, 0.337274470065484],
            [31.110911783017826, 0.340123101127232],
            [31.109997725656672, 0.340547593424214],
            [31.10908342305544, 0.34231685594531],
            [31.107799010065577, 0.348987384903128],
            [31.106040808526867, 0.351853521195941],
            [31.105056012430342, 0.354436695407253],
            [31.099623685209938, 0.360504730283343],
            [31.09856857078959, 0.363087874213973],
            [31.0978118802999, 0.367422818532462],
            [31.095613162912176, 0.375260915592923],
            [31.091534533044538, 0.379577408340975],
            [31.088281517805093, 0.385964296463043],
            [31.085538958547712, 0.388971685755042],
            [31.08390341926614, 0.39312943491792],
            [31.082637756811188, 0.393943066590667],
            [31.082320850941873, 0.396278621811768],
            [31.080404246774183, 0.399728530101254],
            [31.076712812353577, 0.40167399986733],
            [31.076500857557225, 0.406062092741666],
            [31.075604028086573, 0.407955138437474],
            [31.075708585697434, 0.411670926355284],
            [31.074653898875198, 0.412201483700414],
            [31.07004900447308, 0.41205880617832],
            [31.06604132803815, 0.413473337565548],
            [31.06495139222248, 0.414393156970671],
            [31.062947750286877, 0.414321884703223],
            [31.062279724414076, 0.414887925293122],
            [31.061313165016124, 0.414409945145908],
            [31.05772777222322, 0.414019790064408],
            [31.05568923523044, 0.41292226331697],
            [31.05273670286024, 0.412036840242736],
            [31.043403590638864, 0.413503100670812],
            [31.040450977420317, 0.413042327222264],
            [31.038060902707393, 0.412157046989799],
            [31.037287526011315, 0.412333788641982],
            [31.03672502613321, 0.412652131650394],
            [31.03605628879467, 0.416119928715657],
            [31.034632461764293, 0.416915779993355],
            [31.030941270787103, 0.418118011926521],
            [31.026862984974223, 0.421089490029111],
            [31.025790927429316, 0.42085920144402],
            [31.024560474441937, 0.421495853522011],
            [31.020693898185332, 0.421317922738173],
            [31.019428201594426, 0.422343817700593],
            [31.019076228191352, 0.424148462307387],
            [31.01752911996465, 0.425952796583192],
            [31.015665108563592, 0.429844868977583],
            [31.006754515342813, 0.429223249574487],
            [30.99907461316302, 0.42718649153456],
            [30.99475730721257, 0.425382767486648],
            [30.994832816900423, 0.427982002126234],
            [30.993966098958108, 0.428496389141005],
            [30.992590181776773, 0.431916163753812],
            [30.9912826928639, 0.433827051303535],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 101,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "MPARA",
        Population: 38110,
        Key: "KYEGEGWAMPARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.88595817047837, 0.891323014715536],
            [30.88502404655038, 0.889231436788688],
            [30.883855801896434, 0.888381442655932],
            [30.88194027840205, 0.889936375699323],
            [30.88091155828138, 0.891544745987086],
            [30.880254100189557, 0.894275212895593],
            [30.87934073363284, 0.89570995636673],
            [30.878684678709487, 0.895996629424158],
            [30.877571059709666, 0.898522061604609],
            [30.873833949550114, 0.900931124293709],
            [30.872463217444587, 0.904231439516135],
            [30.869810078287248, 0.906067011146869],
            [30.869825544581477, 0.907414060249739],
            [30.868610415056217, 0.909396117157759],
            [30.862690964694888, 0.913152968683962],
            [30.858182662541996, 0.917628261448306],
            [30.857408719907287, 0.919699874895714],
            [30.854820664590587, 0.921555307692252],
            [30.851278392727956, 0.932770697801587],
            [30.851126518156143, 0.93499245646648],
            [30.849793306883416, 0.938208625147416],
            [30.84998310473326, 0.941198554651825],
            [30.848632479618765, 0.936621995917006],
            [30.847789671236033, 0.931227436437433],
            [30.84807330979544, 0.928122784262845],
            [30.848661631746342, 0.926644740806585],
            [30.848497730529488, 0.924091054853025],
            [30.847561096708617, 0.922619395910504],
            [30.845428955263248, 0.922192495458353],
            [30.84326883489001, 0.922440980386882],
            [30.84088938275533, 0.920607613216175],
            [30.839421300222483, 0.920483129972716],
            [30.839163227716075, 0.910243752209555],
            [30.838616682815747, 0.90990628964705],
            [30.838454947437036, 0.907996142212293],
            [30.833255720456428, 0.905769625115985],
            [30.828755627108617, 0.899697592369156],
            [30.825263094064976, 0.899491947536741],
            [30.82189841823568, 0.90067417050903],
            [30.81961771790019, 0.902837748204698],
            [30.820063222093985, 0.906127892241351],
            [30.818327818898883, 0.905263071801904],
            [30.81767052609706, 0.904414811331817],
            [30.814959183295812, 0.900535822793447],
            [30.81329620946545, 0.899498602334503],
            [30.812955872838575, 0.898560006267242],
            [30.814107439370982, 0.895942501767236],
            [30.816212898157467, 0.894282282673948],
            [30.817041293969773, 0.892265860253549],
            [30.81777951330057, 0.88729801496681],
            [30.81589312756074, 0.884227141722473],
            [30.815999609362926, 0.881893832025336],
            [30.816487169983404, 0.881153968319112],
            [30.81776501269526, 0.880673623152177],
            [30.818059423851558, 0.880164941216685],
            [30.818861019325652, 0.876779205324457],
            [30.82075506230498, 0.875614574243266],
            [30.821500103442077, 0.874649975208042],
            [30.81887700215118, 0.87161095291067],
            [30.818501320411176, 0.870432264113901],
            [30.818457165520012, 0.866695982155281],
            [30.81619351970018, 0.859049868601601],
            [30.816172467681504, 0.854539148617912],
            [30.81531752665253, 0.85362011878914],
            [30.813521433276858, 0.852958887446222],
            [30.81106911519621, 0.852957479043953],
            [30.806079519968602, 0.851949962887637],
            [30.80060616399423, 0.84921992517457],
            [30.79946604918509, 0.848358149112628],
            [30.798811099189535, 0.846779051295612],
            [30.795546686125746, 0.845801242069461],
            [30.791243016601335, 0.84212467480557],
            [30.790217375007153, 0.840545375051809],
            [30.788578345770656, 0.839215647490315],
            [30.78807692863695, 0.837511764442201],
            [30.78824696714384, 0.833856684687543],
            [30.790196285259228, 0.833580166705939],
            [30.794094049225862, 0.834600331859497],
            [30.796464599954408, 0.837377924372526],
            [30.798708094765782, 0.837194113659364],
            [30.800914401121016, 0.837750616220727],
            [30.80496061887491, 0.836420300274367],
            [30.80611900451862, 0.836587530789575],
            [30.81010827357506, 0.838477649194698],
            [30.81391473008128, 0.838461290828533],
            [30.816673246113037, 0.837968671515362],
            [30.82237085571832, 0.839994815503143],
            [30.828948295974147, 0.83928614869313],
            [30.83273467872703, 0.841760582018577],
            [30.835684106519597, 0.841972752861483],
            [30.838150499404104, 0.840917035443369],
            [30.839121330291213, 0.840032831713163],
            [30.84004741339908, 0.837482519319393],
            [30.840584214273527, 0.837011718531413],
            [30.8417601359299, 0.836840019392438],
            [30.84328961471917, 0.837277498058994],
            [30.848638308786636, 0.840592400389147],
            [30.85237473532826, 0.841990521415669],
            [30.853987791574912, 0.841825757638969],
            [30.856522790594315, 0.839849164839668],
            [30.858736006790725, 0.839237812838672],
            [30.86292015995817, 0.840296812801821],
            [30.86463031779884, 0.841790431610315],
            [30.869685811639034, 0.843947428685586],
            [30.871079829873356, 0.846246095891498],
            [30.871599194448134, 0.847937238403137],
            [30.87142654723367, 0.849946745822294],
            [30.87068430255207, 0.852242538767204],
            [30.87095162501096, 0.85357181275445],
            [30.874361927171833, 0.854053034426732],
            [30.878396067975018, 0.855777618554454],
            [30.88061885931405, 0.858505889313887],
            [30.88312778652896, 0.859483284829371],
            [30.886174254830078, 0.862963622601594],
            [30.885899983902476, 0.864162814540379],
            [30.88313297250307, 0.86570818539233],
            [30.87974543634644, 0.866343018754024],
            [30.879275666860178, 0.867920489025537],
            [30.880911132479927, 0.869013188285702],
            [30.88261865915513, 0.872733591171481],
            [30.884676811760468, 0.874048594409586],
            [30.886441453321435, 0.874271653368493],
            [30.886937097881155, 0.875511751608029],
            [30.886880292914167, 0.878453967093789],
            [30.89127876883701, 0.885823094074856],
            [30.88595817047837, 0.891323014715536],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 105,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KAGADI",
        Population: 13075,
        Key: "KAGADIKAGADI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.85292799064374, 1.066388906527666],
            [30.852466268265815, 1.068536725359405],
            [30.85249640404864, 1.075844472957296],
            [30.85458952627135, 1.08132676131715],
            [30.85561025677587, 1.083207636265466],
            [30.857300562747085, 1.085159941146598],
            [30.85648876061473, 1.086862135926587],
            [30.85460171910472, 1.089006985397566],
            [30.853296934120845, 1.090105755074176],
            [30.85213405330743, 1.089892072863219],
            [30.850335760855927, 1.091132377565178],
            [30.856023539298747, 1.096794654539487],
            [30.85836126109523, 1.099890859516514],
            [30.85807495543778, 1.100818706462666],
            [30.855565389520702, 1.104005279867382],
            [30.85450597935667, 1.104518138799155],
            [30.85354538656884, 1.105739049112914],
            [30.851738383154014, 1.106251987680489],
            [30.851382385298518, 1.107985556224853],
            [30.850540748318927, 1.108718129998419],
            [30.849906482032807, 1.110170941855453],
            [30.8486061517944, 1.110757067816945],
            [30.845904192794634, 1.110464374438058],
            [30.844941490762523, 1.111050457230303],
            [30.844441353728087, 1.112954940116044],
            [30.848695628488294, 1.119583374494858],
            [30.84888287063116, 1.12099523194066],
            [30.846978795266725, 1.122973374948701],
            [30.84501554517958, 1.128002723916338],
            [30.842646029310256, 1.130231006888473],
            [30.842166193302923, 1.129244835865719],
            [30.839484956640135, 1.127397351536822],
            [30.83850464403519, 1.126162797560172],
            [30.837852300052283, 1.126093619986009],
            [30.837386904463155, 1.125230412192755],
            [30.836448080549587, 1.125734297684113],
            [30.834893637578585, 1.124284058617599],
            [30.833569918803484, 1.123752603493466],
            [30.83336554938139, 1.121966985168401],
            [30.831736443833858, 1.122024669303865],
            [30.830319719782405, 1.120735584971971],
            [30.83008555144573, 1.119229501330052],
            [30.82634172188785, 1.116399413518414],
            [30.825594876035353, 1.114676986914067],
            [30.82403600796328, 1.114471166136279],
            [30.82400525054626, 1.11357966962022],
            [30.823232764978936, 1.11319223741553],
            [30.822839291206392, 1.112323785143026],
            [30.820545286821513, 1.110113026663806],
            [30.81979283817662, 1.108237286251463],
            [30.818166830020186, 1.107167307076385],
            [30.817421259775394, 1.107109903770109],
            [30.816519056582703, 1.10764317436212],
            [30.814507573253046, 1.10577746200464],
            [30.813728030520824, 1.105833731873973],
            [30.813319889056338, 1.10780041482428],
            [30.811952837348517, 1.107935834788602],
            [30.8094885761662, 1.109957826913865],
            [30.809228130310824, 1.110787629945285],
            [30.80865209551635, 1.110628021229471],
            [30.8083013734665, 1.111321318410716],
            [30.807476625712543, 1.111400289720295],
            [30.80765017663218, 1.112139253855273],
            [30.807068861540472, 1.112843950846939],
            [30.808017809467255, 1.112856032704869],
            [30.80851366962265, 1.114493659288369],
            [30.80801620866943, 1.115016298101186],
            [30.808199561107134, 1.115511520046007],
            [30.805686857374766, 1.11790247635727],
            [30.804150231589126, 1.118196931156032],
            [30.803844498067015, 1.11915176338215],
            [30.802770424702587, 1.120287929592189],
            [30.800929093965813, 1.120161468279988],
            [30.795042671962538, 1.121032472556539],
            [30.79451188890218, 1.120858124965318],
            [30.793473697843478, 1.119280343459325],
            [30.790649634440378, 1.119028064711747],
            [30.78956141261027, 1.118531589550371],
            [30.78798505703453, 1.117013606157618],
            [30.786912362584083, 1.11728053381505],
            [30.78400944955692, 1.113424698181491],
            [30.783198231329514, 1.112905527725593],
            [30.783039230422528, 1.111715752808795],
            [30.78077196798535, 1.10947006314664],
            [30.77973317415713, 1.10572330996726],
            [30.777736938831065, 1.104340077286332],
            [30.777602781731574, 1.102452624954051],
            [30.776433037789435, 1.10110815308445],
            [30.772300059847105, 1.093318877578042],
            [30.770256407847082, 1.091884783981465],
            [30.768279699200356, 1.091587695886753],
            [30.76714644572335, 1.090821031225466],
            [30.76587804071186, 1.088657725998362],
            [30.765560637175888, 1.086924164214473],
            [30.766262923895333, 1.08435518053095],
            [30.767103392166728, 1.083640437249747],
            [30.764710264080165, 1.081882837958521],
            [30.764764461237878, 1.080039542819692],
            [30.764391108829386, 1.079680926296922],
            [30.76179263305539, 1.080020080684028],
            [30.76005796288555, 1.078770462936959],
            [30.75909362951288, 1.078843805462074],
            [30.75839303072785, 1.07845325575447],
            [30.758224586730606, 1.0775683122438],
            [30.759738605513824, 1.075849161336446],
            [30.760463313284458, 1.073728855501163],
            [30.759952156616457, 1.072288460142175],
            [30.759013674961015, 1.071718757589805],
            [30.757830903650603, 1.072532831851395],
            [30.756961691086747, 1.072553391583795],
            [30.753653350405564, 1.070939988819276],
            [30.750663915243496, 1.070995480635291],
            [30.751231673859284, 1.067675091603349],
            [30.75184307712311, 1.06661300005852],
            [30.75287650890742, 1.065563078214332],
            [30.755598578491472, 1.064708279522871],
            [30.75597721928204, 1.062535367001257],
            [30.758609050400867, 1.063560471904994],
            [30.758699047219274, 1.061607315249922],
            [30.759369386253976, 1.060142378239427],
            [30.75978924264808, 1.059495347107356],
            [30.760898572192456, 1.059519633399695],
            [30.761060330029036, 1.057395561096833],
            [30.758499137034278, 1.055857755050896],
            [30.75769696663837, 1.053929119688883],
            [30.75767075110344, 1.053294353481431],
            [30.758751506136946, 1.051975847395751],
            [30.760748524793907, 1.050632814581495],
            [30.763214494571915, 1.052536836908781],
            [30.76436028403872, 1.052646561975043],
            [30.764821446766256, 1.053549841466101],
            [30.764007070062256, 1.055210124848988],
            [30.76408168323144, 1.055893722876381],
            [30.768018059483975, 1.057626675315831],
            [30.769004887569672, 1.057065022978312],
            [30.769627483841933, 1.055746564296107],
            [30.771771792069522, 1.055184773301679],
            [30.774357883669037, 1.053316735715666],
            [30.774427871412797, 1.052608702579312],
            [30.77280661175098, 1.050924303898998],
            [30.772993760469056, 1.04919083757452],
            [30.771185757229325, 1.049361965783601],
            [30.770050192387085, 1.048702920354581],
            [30.76963757192257, 1.047897294254674],
            [30.77028387114194, 1.046456752154203],
            [30.773537429862174, 1.045894797819176],
            [30.775386849928076, 1.047298401337122],
            [30.776552211888273, 1.049666475910978],
            [30.7783901838242, 1.05125319004746],
            [30.780175873810585, 1.051619189195184],
            [30.78135593670042, 1.051155153639982],
            [30.78173648551266, 1.04956814934654],
            [30.782768614739812, 1.048127542448536],
            [30.78242597752751, 1.046613874521218],
            [30.783603109214578, 1.045270908565197],
            [30.78422976407533, 1.045173170161449],
            [30.785938414542937, 1.047748703622196],
            [30.785102610324508, 1.050214704719357],
            [30.785320782360905, 1.05055648049818],
            [30.786526754460187, 1.050629569514027],
            [30.786698235661383, 1.051435234429248],
            [30.787470711347233, 1.051679287142686],
            [30.787860364584894, 1.052826730011703],
            [30.788874801492508, 1.053314902563971],
            [30.790874779200045, 1.052850754990533],
            [30.791949459825577, 1.053326712515662],
            [30.792245015435547, 1.055182200962977],
            [30.793540412126386, 1.056169090580112],
            [30.79709786731396, 1.054774680155325],
            [30.798069612686014, 1.055994496734709],
            [30.798059830032557, 1.056853416806379],
            [30.796921295360008, 1.057942422440249],
            [30.79699006858153, 1.059349354511826],
            [30.798279797801253, 1.060638178624689],
            [30.800670165364973, 1.061541233047032],
            [30.80320141571468, 1.061296749990923],
            [30.805131084081527, 1.062266489973866],
            [30.80569878071354, 1.061374793011165],
            [30.80788540857416, 1.063005214649976],
            [30.81325923570665, 1.061857000430087],
            [30.816928878795128, 1.063101704948821],
            [30.819666482047055, 1.063260038992179],
            [30.82145596561889, 1.064749143116646],
            [30.824063670684133, 1.065725416128102],
            [30.825509043806587, 1.065261327895839],
            [30.827053561292026, 1.065602937653974],
            [30.833380380566737, 1.064564424794907],
            [30.836457021481632, 1.065137777000129],
            [30.837278816473198, 1.065699225785558],
            [30.8422967239036, 1.066260101442735],
            [30.845430933353487, 1.066015501999737],
            [30.84857888163732, 1.06627143711673],
            [30.849975556189918, 1.065660845616547],
            [30.85292799064374, 1.066388906527666],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 106,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "RUGASHARI",
        Population: 15745,
        Key: "KAGADIRUGASHARI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.886974129132103, 1.047089524027029],
            [30.88277007019628, 1.049608217365788],
            [30.878436087920942, 1.051178658594663],
            [30.875309306640123, 1.051921808467583],
            [30.873225199909616, 1.051809961014488],
            [30.87322274571224, 1.055922249423163],
            [30.875086652908774, 1.056724675991925],
            [30.876485156431265, 1.056863658552963],
            [30.878157072092, 1.058217391178354],
            [30.878293869340094, 1.058686747289835],
            [30.87748399858557, 1.059969755184111],
            [30.877510196154223, 1.061764006633314],
            [30.877701272306737, 1.063061509564765],
            [30.8783587393817, 1.064083300980173],
            [30.868398667770727, 1.065243117701252],
            [30.867203901256303, 1.064938091761495],
            [30.865173752731646, 1.063619928334651],
            [30.862664801262223, 1.06335171154972],
            [30.859536267368334, 1.065305450904973],
            [30.85714847617286, 1.065208133469649],
            [30.855798894002398, 1.065476895276241],
            [30.854258577039214, 1.066404919816854],
            [30.852999697762982, 1.066077704056487],
            [30.85292799064374, 1.066388906527666],
            [30.849975556189918, 1.065660845616547],
            [30.84857888163732, 1.06627143711673],
            [30.845430933353487, 1.066015501999737],
            [30.8422967239036, 1.066260101442735],
            [30.837278816473198, 1.065699225785558],
            [30.836457021481632, 1.065137777000129],
            [30.833380380566737, 1.064564424794907],
            [30.827053561292026, 1.065602937653974],
            [30.825509043806587, 1.065261327895839],
            [30.824063670684133, 1.065725416128102],
            [30.82145596561889, 1.064749143116646],
            [30.819666482047055, 1.063260038992179],
            [30.816928878795128, 1.063101704948821],
            [30.81325923570665, 1.061857000430087],
            [30.80788540857416, 1.063005214649976],
            [30.80569878071354, 1.061374793011165],
            [30.806395960510617, 1.061088816689191],
            [30.80646603000108, 1.060405182083855],
            [30.8074786918377, 1.060356220608975],
            [30.80903909782557, 1.058231900986599],
            [30.809617937160382, 1.058256235789606],
            [30.810486945806666, 1.054899028135093],
            [30.811925867228762, 1.052506147552734],
            [30.812495453916135, 1.046145891684391],
            [30.813189325218, 1.044509975223141],
            [30.814785912650567, 1.042397816772624],
            [30.81461090196858, 1.04054228841869],
            [30.816245812429486, 1.039077123278957],
            [30.81571063570909, 1.037685531787145],
            [30.81655146779818, 1.036733213137294],
            [30.816873052991774, 1.035549017623424],
            [30.819427520300035, 1.035035916334209],
            [30.823907481503998, 1.033363700895471],
            [30.82448393581171, 1.033424444975046],
            [30.829191124968474, 1.030672056463154],
            [30.830560880605294, 1.029295176908991],
            [30.832585401184694, 1.02958361262218],
            [30.833284459359, 1.029010000630179],
            [30.835195460734266, 1.028494625016422],
            [30.836422435444884, 1.027404685876134],
            [30.840187617957067, 1.026058131664727],
            [30.847660196155818, 1.024513151907717],
            [30.848521645478986, 1.024686457720736],
            [30.851527074246377, 1.023791087364896],
            [30.85838129262774, 1.02287148946386],
            [30.86168589272408, 1.02266668914494],
            [30.86379678362311, 1.023689433168173],
            [30.865387428700075, 1.023524881783324],
            [30.865962323532468, 1.025015852268508],
            [30.868155638452073, 1.025817827735931],
            [30.86905977571755, 1.027060591210224],
            [30.870923723338215, 1.028304002680448],
            [30.87376535688994, 1.027559945484394],
            [30.87436776442454, 1.028347175945136],
            [30.875391552794273, 1.030096414802595],
            [30.875394970883928, 1.031112073481452],
            [30.876533973578766, 1.031194227277561],
            [30.8770780795531, 1.031743133822147],
            [30.878296841865364, 1.031358624680374],
            [30.880005667504474, 1.031577932577302],
            [30.88058058389643, 1.033224852019983],
            [30.88106897815344, 1.033334564286992],
            [30.882569420697795, 1.036079342107159],
            [30.882545455442624, 1.037012662901017],
            [30.883211514004994, 1.037547822876166],
            [30.884061431654857, 1.040347614276017],
            [30.884742483997645, 1.041308261436483],
            [30.88562038596525, 1.044368831125015],
            [30.885122220732843, 1.045384579528422],
            [30.88528729964105, 1.046098270048506],
            [30.886974129132103, 1.047089524027029],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 108,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KYAKABADIIMA",
        Population: 9498,
        Key: "KAGADIKYAKABADIIMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.025969410998183, 1.064775739435675],
            [31.02217567643302, 1.065265540266364],
            [31.019981780303425, 1.064944816286314],
            [31.018368791430387, 1.065662198245348],
            [31.016306699712544, 1.065926942543379],
            [31.01509165193399, 1.064436083084446],
            [31.01223798814396, 1.062411996526734],
            [31.008896151980775, 1.059043879807564],
            [31.007294834918223, 1.0581703247909],
            [31.007706745713662, 1.056155122354316],
            [31.01157636905572, 1.055341632067871],
            [31.011723952375434, 1.055045001180296],
            [31.011172497283773, 1.053041753969895],
            [31.00888939664983, 1.050666484963117],
            [31.009885388449746, 1.048960960400925],
            [31.010991431058482, 1.04803440543318],
            [31.01088168298189, 1.04677325307175],
            [31.012690012310095, 1.045294751274379],
            [31.010929854240707, 1.044097735856187],
            [31.009149719436035, 1.040936033195611],
            [31.00716753286268, 1.038575026912463],
            [31.003137251221958, 1.03746199394097],
            [30.99674587362104, 1.030596783533695],
            [30.995844135755714, 1.027704417155886],
            [30.995779272002295, 1.025748684711359],
            [30.99519818508268, 1.025003291339565],
            [30.99411670421042, 1.021277485912292],
            [30.991368500838142, 1.019759097858282],
            [30.9902327293834, 1.018321553677397],
            [30.98917559914356, 1.017948376077724],
            [30.983888469317446, 1.018477200837892],
            [30.97862779577478, 1.021585351615412],
            [30.977667902774556, 1.020917079772674],
            [30.975334474026834, 1.020531211292319],
            [30.969033618758797, 1.022383844828768],
            [30.96832933598277, 1.020223830501629],
            [30.969339519367566, 1.018288267370755],
            [30.969193094874544, 1.015103879972672],
            [30.96813200216601, 1.01403348685804],
            [30.966937967778556, 1.013731770236186],
            [30.96609098043316, 1.011837777051971],
            [30.963985301559383, 1.010561712337814],
            [30.963247523301384, 1.008887312367404],
            [30.96240418131941, 1.008063943524191],
            [30.961829087959327, 1.006389509934552],
            [30.962771787205003, 1.004550037221889],
            [30.965220188631008, 1.002971035003206],
            [30.96663383505431, 0.997757805675035],
            [30.965695069531254, 0.991824517359681],
            [30.963699698384495, 0.988328729788206],
            [30.96328408563178, 0.985298797069628],
            [30.962636203580853, 0.983798184435005],
            [30.96069501701542, 0.981579997167005],
            [30.959870064445628, 0.979759553045638],
            [30.959229714768362, 0.976432226262841],
            [30.958118895817268, 0.97472301061791],
            [30.956935199242107, 0.970494482731054],
            [30.95701831766041, 0.967638783129418],
            [30.95756975478576, 0.966572756935101],
            [30.958136031181336, 0.962575304828418],
            [30.95728440493579, 0.960813051321018],
            [30.957951447153377, 0.96071008742586],
            [30.96066720607255, 0.960127797730964],
            [30.961523182859008, 0.959439343754978],
            [30.963735626504274, 0.955680046556466],
            [30.965305268071575, 0.953815023899752],
            [30.96559206151425, 0.951088019408459],
            [30.969059078810567, 0.947731340430507],
            [30.973468867217832, 0.9415331813324],
            [30.978149178781305, 0.935995408561019],
            [30.979917754064896, 0.935307459963352],
            [30.9821703488101, 0.936026454685565],
            [30.98368095399525, 0.937606241736194],
            [30.98382282582638, 0.938869451288814],
            [30.983162507498704, 0.939705175532758],
            [30.983873907626695, 0.940984720681697],
            [30.984447774786403, 0.946621014574367],
            [30.98916393182466, 0.949695299519824],
            [30.992099875904795, 0.952366829232109],
            [30.993098020966457, 0.952424830825902],
            [30.997089678643242, 0.954264467774483],
            [31.000695765925343, 0.957079945951157],
            [31.006526291158366, 0.959444091583824],
            [31.008807677806736, 0.961849582801942],
            [31.023570692695586, 0.97003242057536],
            [31.027282316752224, 0.965590939996865],
            [31.034525466125743, 0.967559919599718],
            [31.034900076175642, 0.968354733442585],
            [31.035491501805883, 0.970738426561409],
            [31.035505825443067, 0.974622545896559],
            [31.04548008863892, 0.974903599748559],
            [31.054307222979894, 0.978447758724627],
            [31.060685877741417, 0.98769814783434],
            [31.06765002296413, 0.990243421662531],
            [31.074742475457168, 0.999494326684588],
            [31.08245850787769, 1.003794170707195],
            [31.080037832952936, 1.005570594519684],
            [31.076605583153047, 1.006876913574685],
            [31.07360300204512, 1.006940542199234],
            [31.068494245295096, 1.007866420189807],
            [31.06605682218019, 1.007676489128206],
            [31.062877476878842, 1.01440169620865],
            [31.062678346431518, 1.015851773460531],
            [31.061857805488035, 1.017607478794464],
            [31.061392305694348, 1.022410138821936],
            [31.058651168470067, 1.030830232270049],
            [31.056984858296715, 1.03229270222297],
            [31.056389148600914, 1.033795745392721],
            [31.053770908094013, 1.035683362980203],
            [31.05218347359591, 1.03783770389017],
            [31.051548147297712, 1.03927419201454],
            [31.051242446114966, 1.042028026284989],
            [31.05042211717393, 1.043384569410825],
            [31.050182554453944, 1.046045310613863],
            [31.04981211438361, 1.046603866263979],
            [31.047273673918365, 1.047666626600774],
            [31.041034793421783, 1.04795539206016],
            [31.040148977296514, 1.048340658129658],
            [31.03991016377151, 1.04977738126623],
            [31.036630796453174, 1.052037043790739],
            [31.036418865013015, 1.052755343965608],
            [31.031935905232643, 1.056278133812914],
            [31.03057189971198, 1.06038829125978],
            [31.025969410998183, 1.064775739435675],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 109,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KABAMBA",
        Population: 17184,
        Key: "KAGADIKABAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.546200772885598, 0.974981460732209],
            [31.5481360485365, 0.98046970390575],
            [31.548102431781917, 0.981591195718384],
            [31.547507591655304, 0.984485145156646],
            [31.543244101078606, 0.995426976248771],
            [31.542734935077238, 0.997561224806826],
            [31.543974844629634, 1.000853937080446],
            [31.548216449551045, 1.004012332607675],
            [31.547610159497793, 1.009221638615197],
            [31.544245062358662, 1.01230157224185],
            [31.536858576001777, 1.017094412350165],
            [31.52823295803355, 1.023421481531817],
            [31.52855409047627, 1.018691447512259],
            [31.527650326011624, 1.013544810679597],
            [31.526619838006503, 1.011057149532227],
            [31.522414787330614, 1.004814651896052],
            [31.519578944319207, 1.001485056325704],
            [31.518226097670993, 0.998418426201414],
            [31.518062764189406, 0.996980310335985],
            [31.517286521867554, 0.996066485532746],
            [31.51563022970627, 0.99531505766533],
            [31.512450524180487, 0.994924708724924],
            [31.510941911458666, 0.993585471098276],
            [31.50988025281149, 0.988610650131619],
            [31.50922218117032, 0.98779636940311],
            [31.504580161194124, 0.986184390485992],
            [31.50148839175154, 0.983849578458063],
            [31.49936101946199, 0.982980369077359],
            [31.495566820467833, 0.98298769016766],
            [31.49044398172741, 0.982361308005862],
            [31.487893554142993, 0.980750653078978],
            [31.486929652859992, 0.975073262446566],
            [31.485240079015743, 0.97346053101013],
            [31.479180116872588, 0.971049026574517],
            [31.47823179956313, 0.969957712112421],
            [31.476430084530385, 0.969238908598635],
            [31.475596101197034, 0.968260264828408],
            [31.474465563327122, 0.968336351147639],
            [31.473916306412956, 0.967941104836387],
            [31.472993945923633, 0.96815793438043],
            [31.47237584661767, 0.967475481020092],
            [31.471725614573966, 0.967680041357219],
            [31.471640002432455, 0.968117818652406],
            [31.46928545788566, 0.96774149981355],
            [31.463616333858003, 0.963749459766348],
            [31.462203637852333, 0.96347231929323],
            [31.459967207392335, 0.962286315355975],
            [31.45741739784886, 0.95981643954661],
            [31.457025516789297, 0.958552279273306],
            [31.455162000359977, 0.957188702382387],
            [31.45276844108207, 0.956358127191552],
            [31.44974679323222, 0.955922257940072],
            [31.44819653102054, 0.956138798132438],
            [31.447646874356074, 0.956652036551766],
            [31.446665829624195, 0.956493592226906],
            [31.44335128248269, 0.952897652998868],
            [31.4379167238471, 0.951117710925503],
            [31.43599370301334, 0.95121557966799],
            [31.432580356461973, 0.949199569419112],
            [31.432188520318203, 0.947856426293904],
            [31.432575820868095, 0.945824885231342],
            [31.430131167213453, 0.941259167482585],
            [31.430582210419317, 0.939948905083947],
            [31.43030906597907, 0.938356078200368],
            [31.43197059891173, 0.935703657610953],
            [31.433366958155684, 0.931055707523539],
            [31.434845789929227, 0.929293111963716],
            [31.434358281411054, 0.922380570225233],
            [31.435348771928147, 0.919949903104726],
            [31.435675699402772, 0.916100811711331],
            [31.438915151878078, 0.911895586486754],
            [31.439053383735672, 0.909861443318714],
            [31.439508810720103, 0.909133208892211],
            [31.441761678553164, 0.908796149518693],
            [31.4430937103379, 0.906791156673744],
            [31.44441156580918, 0.906664346606289],
            [31.44588385964408, 0.90516401526133],
            [31.44570756526957, 0.904452953537782],
            [31.44447154632071, 0.904057426971248],
            [31.44425600005986, 0.903366097666548],
            [31.44473820222965, 0.902463392127199],
            [31.445668935915723, 0.903011215598354],
            [31.44645401855827, 0.902537564004255],
            [31.44612112537188, 0.900937701843278],
            [31.44727889117803, 0.900780203524522],
            [31.448337876438938, 0.902202631862464],
            [31.448926503817063, 0.902281884884312],
            [31.450644148217307, 0.899211843323961],
            [31.452028217609843, 0.898906025284771],
            [31.452303643770914, 0.897207672439618],
            [31.4526599344772, 0.896477260922581],
            [31.45346180214085, 0.896121934470795],
            [31.454228289657024, 0.89319930761919],
            [31.45315242684858, 0.885180482835881],
            [31.449250785753136, 0.877634475500375],
            [31.449212251620715, 0.875916240883646],
            [31.45035275629869, 0.869991822425883],
            [31.450353854039978, 0.867305870197659],
            [31.449390425270817, 0.865005215289905],
            [31.46257418033061, 0.864522520131489],
            [31.46425753693478, 0.864134313340026],
            [31.470812053981177, 0.860645963670954],
            [31.4917418083611, 0.863991684279946],
            [31.50127397377468, 0.862638860959971],
            [31.501268958480452, 0.863253865877514],
            [31.504306603528878, 0.864765461597294],
            [31.509294526991727, 0.864785531267779],
            [31.523385365791107, 0.862855611541167],
            [31.532087209404477, 0.860534615679919],
            [31.539595188411944, 0.857534792728084],
            [31.543267808517268, 0.856640811237147],
            [31.5423085596091, 0.857680547816595],
            [31.541263586270013, 0.860429639615714],
            [31.53974467166848, 0.861668131896979],
            [31.536518637328587, 0.869463125085391],
            [31.53493119474561, 0.878669660471176],
            [31.53417202670239, 0.879962703101607],
            [31.53451832993935, 0.881129562182624],
            [31.534535768035642, 0.884629735731807],
            [31.531970031362192, 0.887441502724681],
            [31.531038170290394, 0.889467061652578],
            [31.53039187825756, 0.890027550886817],
            [31.530002297783472, 0.893907415538947],
            [31.532361202752647, 0.898611429390769],
            [31.53398684439643, 0.898783931415515],
            [31.542046091646025, 0.897991282694289],
            [31.547929703719085, 0.89702333289429],
            [31.551329051823416, 0.90131968832185],
            [31.552795692560213, 0.91049638047387],
            [31.554693196748353, 0.913926481508734],
            [31.554354029728007, 0.914734171605814],
            [31.561318491157664, 0.92283334416857],
            [31.566413894451003, 0.926979491926117],
            [31.571822494469806, 0.930093469287691],
            [31.566892117084084, 0.933690435365769],
            [31.564983815146235, 0.935625478674273],
            [31.560733060883617, 0.938228524654312],
            [31.555508257070247, 0.939483528076996],
            [31.550906210327593, 0.941489465332099],
            [31.54873266642906, 0.940113801896232],
            [31.54782935112207, 0.940194821721363],
            [31.54642559155682, 0.941840313366927],
            [31.54519422767775, 0.944164205223983],
            [31.545211030665126, 0.94494203067033],
            [31.54607778454005, 0.946353323504262],
            [31.545907428029594, 0.946832604512736],
            [31.54258206876533, 0.949589732331396],
            [31.542511330029992, 0.95088305030049],
            [31.541594145633308, 0.952555869730272],
            [31.5406799499316, 0.966339112321258],
            [31.541399909207644, 0.968247789010782],
            [31.54437355468196, 0.971884925322954],
            [31.546200772885598, 0.974981460732209],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1596,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "GAYAZA",
        Population: 20429,
        Key: "KYANKWANZIGAYAZA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Gayaza",
        id2_original: "KyankwanziGayaza",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.07715304259875, 0.169434432148552],
            [32.0768080266476, 0.168241364138499],
            [32.076131256573774, 0.16905548578741],
            [32.07418779098247, 0.1698424074332],
            [32.07204591539266, 0.168268271260207],
            [32.07023085049648, 0.167580674948812],
            [32.06707313123729, 0.164061571901169],
            [32.0651079560605, 0.160913422478336],
            [32.06470605429396, 0.156426519232277],
            [32.06252442735451, 0.152129507429717],
            [32.061951403712875, 0.150076010747165],
            [32.061130949007676, 0.149089946894961],
            [32.0598434961189, 0.148746137644197],
            [32.056682612993306, 0.146873452952497],
            [32.054179431402964, 0.143453915408029],
            [32.05184384220696, 0.141065644687461],
            [32.049404607190105, 0.132417474896999],
            [32.04836982972951, 0.133267766655505],
            [32.0473230157424, 0.133186310340709],
            [32.044910713116096, 0.132218282997047],
            [32.04212688884785, 0.131946790381701],
            [32.037729946349145, 0.13003789605314],
            [32.03585225270799, 0.130019730368248],
            [32.03481104151332, 0.130363440179957],
            [32.031312735895625, 0.133683201312844],
            [32.0307326020885, 0.133846007039679],
            [32.02734734585607, 0.13298649591617],
            [32.02055153773111, 0.132117801309989],
            [32.017201039113644, 0.13304940476597],
            [32.0168176749813, 0.134940004722495],
            [32.015273023646884, 0.134749975633578],
            [32.01259820454846, 0.133718620889764],
            [32.009307672069475, 0.130968503357718],
            [32.00837576518363, 0.129638705528773],
            [32.002620115427845, 0.127395072631246],
            [32.000663303566334, 0.126191881967318],
            [31.998953265201603, 0.126191813695537],
            [31.995630015181625, 0.127412885280954],
            [31.994988686340722, 0.127268124825418],
            [31.990114875868432, 0.121849413600071],
            [31.98488256573255, 0.114395372712072],
            [31.98195795210307, 0.110840222283028],
            [31.980377415768007, 0.10949232604706],
            [31.97567499486874, 0.109157461668159],
            [31.972635955635013, 0.109881026358218],
            [31.96694933781555, 0.110514034730475],
            [31.964123986228344, 0.111309968428675],
            [31.9606235623832, 0.11354416676544],
            [31.959555148405087, 0.113661723665693],
            [31.955991142702477, 0.111707689580973],
            [31.95096321276846, 0.106542340253562],
            [31.949085622433547, 0.105031621760742],
            [31.948368996805538, 0.104995508648684],
            [31.945857217439617, 0.098462833659107],
            [31.945343385588654, 0.095321025361466],
            [31.945528064838044, 0.090231206382086],
            [31.946435567192577, 0.083742944874016],
            [31.94786574531199, 0.077493211731977],
            [31.949748109294315, 0.072198919665615],
            [31.952865598401832, 0.067166478522408],
            [31.95624761620766, 0.065287987533951],
            [31.958192220862777, 0.066953039855408],
            [31.960068930848706, 0.068486767502943],
            [31.962562329785584, 0.069518059650666],
            [31.96552072096806, 0.070359390576267],
            [31.978714785992366, 0.072630213963788],
            [31.99501241533895, 0.079161768829229],
            [32.00329159083134, 0.080817382047314],
            [32.00577575508712, 0.081830604310381],
            [32.00920391845081, 0.084182637394141],
            [32.01895893253021, 0.087900814060868],
            [32.021393641834656, 0.090596597465596],
            [32.025861880922456, 0.093437180816455],
            [32.029040174296604, 0.094839397878314],
            [32.02979015706607, 0.095879717401662],
            [32.03505543177963, 0.094133987777504],
            [32.03851007298627, 0.0942335919433],
            [32.03849573767099, 0.094893954287354],
            [32.04488376455587, 0.099209115157542],
            [32.05350085841037, 0.109639538991699],
            [32.05389221036221, 0.112362427220741],
            [32.053203995751694, 0.119888763108582],
            [32.05342785861544, 0.126239141321451],
            [32.054222442738755, 0.127976023360953],
            [32.05692644899907, 0.130364306153651],
            [32.06133524117466, 0.131350500151624],
            [32.06576851154342, 0.131441135433871],
            [32.068423776114756, 0.130961790265146],
            [32.07449336011288, 0.128944721907798],
            [32.0785599166231, 0.129180078118498],
            [32.0794081723897, 0.130464658490709],
            [32.07984408437289, 0.134824938938299],
            [32.08038290286345, 0.136073326895151],
            [32.081652329259434, 0.13777406104354],
            [32.08304442689566, 0.140723168410792],
            [32.08453711158921, 0.142242992863522],
            [32.08849136880744, 0.142035090108866],
            [32.09034655246422, 0.144025331962076],
            [32.09969118108755, 0.146124710509037],
            [32.09972380340708, 0.147411006639118],
            [32.09873066196159, 0.150589512047154],
            [32.0977088292242, 0.152452509922173],
            [32.09730567161291, 0.154378375104732],
            [32.0954034324049, 0.155221746347933],
            [32.09403957780122, 0.1563543030373],
            [32.09073541787936, 0.160002262163789],
            [32.089696032061354, 0.160490326626879],
            [32.087558539351804, 0.160589985333261],
            [32.08275539035973, 0.164091965375874],
            [32.078130212896845, 0.166643189021029],
            [32.076807899985134, 0.168237511280858],
            [32.07715304259875, 0.169434432148552],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1648,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "BULO",
        Population: 18922,
        Key: "BUTAMBALABULO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.095281787939044, 0.294172411248817],
            [32.09233352526138, 0.296374170738375],
            [32.089504217493655, 0.297451005438064],
            [32.08165868663669, 0.295391959615603],
            [32.07982810334399, 0.294530153403228],
            [32.076820796199335, 0.292052661055319],
            [32.07629782488871, 0.29107129395824],
            [32.08057771870251, 0.285758145272144],
            [32.08098199112306, 0.284489635593327],
            [32.080803844422434, 0.282515002871706],
            [32.07664397990365, 0.273275875077441],
            [32.0743497626181, 0.272737166906901],
            [32.070926214798355, 0.272593290766961],
            [32.06752662953879, 0.269984148898996],
            [32.06154739719363, 0.268822851178178],
            [32.05976438957667, 0.26767384845406],
            [32.05714943241216, 0.264394609011648],
            [32.05004080844737, 0.264777008767567],
            [32.04947019498565, 0.265088115380777],
            [32.049671988039506, 0.268762074529827],
            [32.04910134493334, 0.269551875392596],
            [32.04819787960769, 0.269910817541318],
            [32.04311017577468, 0.269335983870973],
            [32.03968676090561, 0.267899647416004],
            [32.031765701496184, 0.26561985483411],
            [32.02898423620385, 0.263900884008766],
            [32.02815217885848, 0.26093371506811],
            [32.02646448428978, 0.25850924721282],
            [32.025337859481255, 0.255614429294563],
            [32.02506203985812, 0.257002067283937],
            [32.02816438247161, 0.244102566425865],
            [32.023701860262236, 0.243083366878655],
            [32.02243414695351, 0.242436392543544],
            [32.02098389418242, 0.242384569198619],
            [32.019483764251795, 0.243080258735737],
            [32.016922657495286, 0.245366734229742],
            [32.01373473418133, 0.246950272492893],
            [32.00603959298103, 0.246353312483772],
            [31.999587313197097, 0.24653534720568],
            [31.998670630060392, 0.245342381125654],
            [31.997624963221885, 0.244578503908596],
            [31.99669868068803, 0.244459719861982],
            [31.992812574158826, 0.241105305959036],
            [31.991087703710427, 0.237940443104551],
            [31.98677187459034, 0.23231629298131],
            [31.98308527130929, 0.22660804818717],
            [31.981197537198213, 0.226812580399818],
            [31.973434813942458, 0.22956639167372],
            [31.971640713928377, 0.22840881387721],
            [31.970453047697976, 0.228122962340892],
            [31.96966935474917, 0.228099655735546],
            [31.96798411437785, 0.228937259803968],
            [31.965846071899346, 0.228174214414764],
            [31.960202396245396, 0.224534422900174],
            [31.959157291752266, 0.224320152094183],
            [31.956318594793213, 0.220839702501211],
            [31.955583707313778, 0.22119939424793],
            [31.960094567868598, 0.218864979296022],
            [31.96287089839073, 0.216947453850013],
            [31.97004706488511, 0.209503195391545],
            [31.973462366170533, 0.20500761764341],
            [31.978206428474785, 0.199743212102404],
            [31.98101844008003, 0.197463820831339],
            [31.989407774179046, 0.192118197557932],
            [31.99991641639133, 0.184366438760716],
            [32.00343637589896, 0.181010584378965],
            [32.00448892023924, 0.178776287650953],
            [32.005016716401286, 0.175429305757961],
            [32.00513854142855, 0.165433507467524],
            [32.00578789671653, 0.162321723712799],
            [32.00702045894818, 0.159282335326699],
            [32.01088674774389, 0.153140297183832],
            [32.01546193396127, 0.142954710587471],
            [32.0168176749813, 0.134940004722495],
            [32.017201039113644, 0.13304940476597],
            [32.02055153773111, 0.132117801309989],
            [32.02734734585607, 0.13298649591617],
            [32.0307326020885, 0.133846007039679],
            [32.031312735895625, 0.133683201312844],
            [32.03481104151332, 0.130363440179957],
            [32.03585225270799, 0.130019730368248],
            [32.037729946349145, 0.13003789605314],
            [32.04212688884785, 0.131946790381701],
            [32.044910713116096, 0.132218282997047],
            [32.0473230157424, 0.133186310340709],
            [32.04836982972951, 0.133267766655505],
            [32.049404607190105, 0.132417474896999],
            [32.05184384220696, 0.141065644687461],
            [32.054179431402964, 0.143453915408029],
            [32.056682612993306, 0.146873452952497],
            [32.0598434961189, 0.148746137644197],
            [32.061130949007676, 0.149089946894961],
            [32.061951403712875, 0.150076010747165],
            [32.06252442735451, 0.152129507429717],
            [32.06470605429396, 0.156426519232277],
            [32.0651079560605, 0.160913422478336],
            [32.06707313123729, 0.164061571901169],
            [32.07023085049648, 0.167580674948812],
            [32.07204591539266, 0.168268271260207],
            [32.07418779098247, 0.1698424074332],
            [32.076131256573774, 0.16905548578741],
            [32.0768080266476, 0.168241364138499],
            [32.07715304259875, 0.169434432148552],
            [32.07801540011869, 0.171611866888334],
            [32.081038280457086, 0.174784191734292],
            [32.081576727045146, 0.1760099093484],
            [32.08057623019408, 0.177682919272634],
            [32.07986992710699, 0.180063297648193],
            [32.0782517324969, 0.182681081271092],
            [32.07680889801341, 0.189730210313257],
            [32.076915497494916, 0.191566271249636],
            [32.07937211760746, 0.195990912247905],
            [32.08091636200505, 0.202478596732672],
            [32.083723977255296, 0.202749394876777],
            [32.086895123633, 0.201711309997353],
            [32.08775943319206, 0.202035992363374],
            [32.090458425056454, 0.20440226480335],
            [32.09322184858462, 0.204934444941872],
            [32.09741552748732, 0.203017324713694],
            [32.1003776808142, 0.20236137989603],
            [32.103494418930104, 0.201064772226683],
            [32.10893128084609, 0.201310786926975],
            [32.11075779297395, 0.201049336570194],
            [32.11342938981542, 0.199970479096762],
            [32.11658677759628, 0.199714983614427],
            [32.11695626006251, 0.200400956339933],
            [32.11810943457925, 0.209762815754071],
            [32.11824082666431, 0.213542782998972],
            [32.117651493210374, 0.22043833551335],
            [32.118091878803675, 0.221428275190013],
            [32.120414223239116, 0.223709033775672],
            [32.12136505942463, 0.225593144871436],
            [32.124972092632746, 0.229848406507526],
            [32.13026587538184, 0.234994023711046],
            [32.13200944785615, 0.235682091481827],
            [32.13275956357625, 0.235802497948395],
            [32.13441221306907, 0.234950618379837],
            [32.13522327768457, 0.233327541503845],
            [32.13724067462379, 0.231261599518275],
            [32.13954984706222, 0.229713387212861],
            [32.140453952886666, 0.229796173487232],
            [32.143904594793696, 0.238558437354608],
            [32.14790995357518, 0.244231018955194],
            [32.1490156296713, 0.245212108636882],
            [32.14996847359146, 0.24538909309212],
            [32.15302693350333, 0.244826710649475],
            [32.154882974152876, 0.245015370406832],
            [32.15605810798674, 0.247118438245951],
            [32.156303940049064, 0.249207831726228],
            [32.15599642067619, 0.249833327218626],
            [32.15495028401879, 0.25033589659504],
            [32.15326224090379, 0.250359722383884],
            [32.153571184106404, 0.252466042139454],
            [32.1520018542545, 0.25507487145886],
            [32.15207293884126, 0.258617281102074],
            [32.15051548831067, 0.261166277498124],
            [32.14946939656906, 0.260950782881486],
            [32.14873232079359, 0.26162092719996],
            [32.146235514546824, 0.267652407698834],
            [32.14328729139507, 0.269040436014513],
            [32.14079088669523, 0.269207804678664],
            [32.13841332371758, 0.269973553387826],
            [32.13683219629106, 0.271038549084948],
            [32.13509648138056, 0.27288142662143],
            [32.13264752299906, 0.274604577790219],
            [32.13112561970258, 0.278625546447015],
            [32.12878348627975, 0.282443014556387],
            [32.12030737312763, 0.286259991836184],
            [32.118001074399814, 0.287815587587491],
            [32.11613456927551, 0.289957616510961],
            [32.113661895370534, 0.29086695232396],
            [32.110594895175254, 0.291129989121325],
            [32.109002024971346, 0.290483622769131],
            [32.10545952044504, 0.290914167166793],
            [32.102654142898196, 0.290004410951402],
            [32.10058573602389, 0.289836697634988],
            [32.095281787939044, 0.294172411248817],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1651,
        District: "GOMBA",
        County: "GOMBA",
        Subcounty: "MPENJA",
        Population: 31932,
        Key: "GOMBAMPENJA",
        Dist2: "Gomba",
        "Sub Country": "Mpenja",
        id2_original: "Gomba Mpenja",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.748330331087246, 1.007365371601141],
            [30.746755718243147, 1.00616997218605],
            [30.74475913526907, 1.006914856145854],
            [30.74416061294809, 1.006483893934839],
            [30.743048142893493, 1.007028471886976],
            [30.741765176191258, 1.006711842188092],
            [30.741052060281035, 1.00705577824991],
            [30.740309891956258, 1.008174670690538],
            [30.73862779568841, 1.007742948788942],
            [30.73785774904708, 1.007943328331399],
            [30.736376254667036, 1.00607660850553],
            [30.735778826494087, 1.004066996579914],
            [30.735864964150036, 1.001527909298826],
            [30.73425433604957, 1.000123383973694],
            [30.733043418724698, 0.998517274380471],
            [30.73282098957212, 0.997297116120395],
            [30.7312909196914, 0.995979734860672],
            [30.730541217196333, 0.996220003274438],
            [30.729106219615385, 0.995801636626432],
            [30.72776732739678, 0.994773338471066],
            [30.718613650060163, 0.994478015112725],
            [30.716189281262942, 0.993652487916214],
            [30.714878074223122, 0.9897188874379],
            [30.713042727164446, 0.988572945367477],
            [30.711965806140586, 0.989488864106134],
            [30.708474509178753, 0.994634456504041],
            [30.70474483886639, 0.997888533841056],
            [30.703489528596762, 0.998863521419113],
            [30.70200654301337, 0.999206899638548],
            [30.69955303017338, 1.001042095534809],
            [30.697660720044222, 1.001060751593766],
            [30.69668241966555, 1.002004582234166],
            [30.69604144296421, 1.003614962749512],
            [30.694768749395543, 1.004473543958182],
            [30.691370355302094, 1.009506466357756],
            [30.68949635553338, 1.011375606594968],
            [30.68949399835406, 1.0119755158099],
            [30.687923088365597, 1.012720702921135],
            [30.68746934841724, 1.014181647042031],
            [30.685974127779684, 1.014664590975158],
            [30.684997729134427, 1.016123960617515],
            [30.683312603747467, 1.017431214015809],
            [30.68256034374876, 1.018853759100464],
            [30.681065865119574, 1.019149225754828],
            [30.679122178542723, 1.020179975414286],
            [30.678755534752753, 1.018612001388016],
            [30.677771415087644, 1.017438309587669],
            [30.677742418368602, 1.016746831665061],
            [30.677249907132584, 1.016520737947718],
            [30.677313885147132, 1.013116223223898],
            [30.67634544377867, 1.011348815820908],
            [30.676348396541023, 1.008973865098787],
            [30.675603086807662, 1.00789818778742],
            [30.675663885684415, 1.007041478381379],
            [30.672738812117522, 1.005594786017231],
            [30.671636246887257, 1.003601758642415],
            [30.670607082998817, 1.002623430353406],
            [30.669233293028107, 1.002591637555541],
            [30.668456263782065, 1.003011529342425],
            [30.667008650261252, 1.00230324434161],
            [30.665679806597446, 1.002151255582953],
            [30.658897513625917, 1.004900704450905],
            [30.653086135983163, 1.006523322094756],
            [30.64729641492527, 1.005798127879068],
            [30.646584423705818, 1.004726967351028],
            [30.646422394578018, 1.002964505251685],
            [30.64489188811607, 1.001389557542113],
            [30.64323560583625, 0.996583791998509],
            [30.64010131823292, 0.996948609995903],
            [30.638666692554505, 0.998088525973535],
            [30.6372980472354, 0.998116233897039],
            [30.635815762337916, 0.997569844631948],
            [30.63128132370184, 0.998800678544012],
            [30.627703014124958, 0.99872632011715],
            [30.626819365634475, 0.998381270336533],
            [30.6264490297687, 0.997921791614528],
            [30.626565681398258, 0.996418238669267],
            [30.625809829036726, 0.99424463112208],
            [30.62635217790634, 0.987095060907553],
            [30.626167766354925, 0.985058671573169],
            [30.62483040127232, 0.980279494627693],
            [30.62151604277705, 0.978167277312426],
            [30.61579866933719, 0.97571285288269],
            [30.616730740614738, 0.974458832755711],
            [30.616853018392916, 0.972385653231217],
            [30.616487937671558, 0.970592713785722],
            [30.617621961903083, 0.96987190026523],
            [30.618228693029106, 0.968634341735106],
            [30.619433557505634, 0.967865516103942],
            [30.619351916815987, 0.965366130788708],
            [30.620438004248996, 0.964598338231985],
            [30.62060127395019, 0.961587327857039],
            [30.621718991962663, 0.957703011286885],
            [30.62200007481509, 0.956882425889898],
            [30.623465248603033, 0.956070651542737],
            [30.624232592213705, 0.953822883967554],
            [30.62477697037756, 0.950996824225591],
            [30.624459497671317, 0.948651942603188],
            [30.622691094864237, 0.945005257177832],
            [30.622150848052364, 0.941793025253215],
            [30.62528513655399, 0.930971198891376],
            [30.623739339867583, 0.928384598923011],
            [30.623740177995742, 0.927131972661947],
            [30.623134423338428, 0.926392834038382],
            [30.623105558671693, 0.921831973659594],
            [30.62146377250564, 0.91963074496617],
            [30.62214055874911, 0.915742739588823],
            [30.619331887978404, 0.910668244210326],
            [30.619301122476546, 0.908933823267616],
            [30.616661424810804, 0.906118404523615],
            [30.617894648202505, 0.903240428197999],
            [30.620897770994546, 0.901650058566511],
            [30.62301488901512, 0.899285424248556],
            [30.624015653564154, 0.896954281573016],
            [30.623697053472213, 0.895866982447943],
            [30.62606690890474, 0.896521571187521],
            [30.62615154188258, 0.895359640929586],
            [30.62930738725609, 0.894905388688226],
            [30.630779663124688, 0.892167221026429],
            [30.631588673293162, 0.892302309467349],
            [30.634340677437393, 0.894505744609661],
            [30.636876200174598, 0.895087777437422],
            [30.637981754099844, 0.893845779747474],
            [30.63809861054527, 0.890977315642433],
            [30.638682555904115, 0.889858381696523],
            [30.639854078510538, 0.890677521189302],
            [30.640993785484532, 0.890596420304989],
            [30.64160002523214, 0.891965576382836],
            [30.643053455344397, 0.89242676942796],
            [30.64339731336716, 0.893679741878838],
            [30.643797781422506, 0.893297055798174],
            [30.645250429102155, 0.893423470221521],
            [30.6447485223866, 0.892000665715088],
            [30.645237445751338, 0.890882562022947],
            [30.643967280940203, 0.889661427363453],
            [30.645978561250654, 0.888743237845681],
            [30.64672034419818, 0.889329168905247],
            [30.6478617552763, 0.889437630102405],
            [30.648569158799603, 0.888838961583845],
            [30.64940870000963, 0.887077928956461],
            [30.650824569763213, 0.885999069170935],
            [30.652048424624848, 0.88867805225281],
            [30.651899141692596, 0.893229398422645],
            [30.652520440797613, 0.893626807903534],
            [30.65562129939426, 0.893658818169715],
            [30.656730249849563, 0.892795942086573],
            [30.658368658350167, 0.892686748950182],
            [30.66279557852821, 0.890894180326553],
            [30.66463391158687, 0.890558086636448],
            [30.665276396559538, 0.889632160186717],
            [30.666564180028345, 0.888550462811522],
            [30.668198344887564, 0.887967330442672],
            [30.66868620195208, 0.886730724988025],
            [30.669958692501503, 0.885558314944021],
            [30.670329026570613, 0.884464927994001],
            [30.670944813613044, 0.884246229547234],
            [30.67212253459494, 0.885752572177168],
            [30.671944172298645, 0.887057553116562],
            [30.67289788219475, 0.88742833769685],
            [30.674680418196193, 0.886168490934242],
            [30.677537285378506, 0.886806923539664],
            [30.678239385248386, 0.885615818219032],
            [30.6774738194037, 0.885030091362854],
            [30.679226148655385, 0.884374809860564],
            [30.679951368465723, 0.883112402166005],
            [30.68150093627968, 0.883691237371451],
            [30.68347303926395, 0.883697580519456],
            [30.685025235548416, 0.883245490627282],
            [30.686176882030864, 0.884491391903693],
            [30.689318869992782, 0.885127300833263],
            [30.690596901350865, 0.884570988423099],
            [30.692592781842414, 0.884577121388898],
            [30.69511608210184, 0.883784692365725],
            [30.69616781706008, 0.884486407746108],
            [30.69807292997867, 0.884967305716725],
            [30.69965130406885, 0.883460382525346],
            [30.70062134354019, 0.883001556039795],
            [30.70063177208233, 0.88416271952719],
            [30.702969557659173, 0.882554303815124],
            [30.70340891198654, 0.883853875970333],
            [30.70452434019338, 0.884567638106409],
            [30.701676776862442, 0.890729981852074],
            [30.701391313824704, 0.893339379269645],
            [30.70059267919777, 0.894365461925328],
            [30.700959469413135, 0.895523481711389],
            [30.701989360936917, 0.896438685698194],
            [30.70306967489758, 0.899000526301438],
            [30.70487088058557, 0.90114129509584],
            [30.712380919430014, 0.901356434751069],
            [30.713030956539278, 0.902288271114018],
            [30.714426617792224, 0.903107841658482],
            [30.715103432781802, 0.904609195111025],
            [30.717270574387314, 0.907284949907109],
            [30.71970942312858, 0.909005748608486],
            [30.720577108556437, 0.908760695677946],
            [30.72789638206546, 0.909638625438682],
            [30.73171937296279, 0.908527659780072],
            [30.732431056958433, 0.911261060954494],
            [30.733778405917114, 0.913386052785591],
            [30.734157120369552, 0.915699000814574],
            [30.737309146106437, 0.916592385113099],
            [30.744423156369653, 0.915949314931062],
            [30.74565417888893, 0.916801232853056],
            [30.748161046266887, 0.916859643715314],
            [30.742997111398846, 0.918307529683308],
            [30.74121347136793, 0.919324051115616],
            [30.738788250069536, 0.92204754501053],
            [30.741281214221818, 0.931270598378376],
            [30.737297631501143, 0.933946281998671],
            [30.73468891762786, 0.938110893462417],
            [30.733010093024276, 0.939026208712216],
            [30.732968197396048, 0.940981786281462],
            [30.733694539202194, 0.942492173948995],
            [30.736044130438493, 0.944841517469912],
            [30.737238446896935, 0.945542027213491],
            [30.737662917038367, 0.947837156474919],
            [30.739744375535434, 0.949430474817924],
            [30.7406433870139, 0.951650356416662],
            [30.74388894174492, 0.954548807092774],
            [30.744373240582604, 0.955563647375724],
            [30.746824472600057, 0.95599244881372],
            [30.74705186853782, 0.957507235546181],
            [30.748253848523934, 0.95640650999989],
            [30.74872012536038, 0.955407033512668],
            [30.75002138535508, 0.954779436388845],
            [30.751014706463657, 0.955404830251637],
            [30.751851081112278, 0.955396131277638],
            [30.7529361229063, 0.954601217413261],
            [30.75536099745502, 0.956934204747225],
            [30.755976323661706, 0.957646979512434],
            [30.755556782576253, 0.959719047089479],
            [30.755937809292213, 0.960325275390155],
            [30.75590373439685, 0.963234863453315],
            [30.756337795850587, 0.964552005204621],
            [30.754430719214778, 0.966985377941914],
            [30.75434099368759, 0.968899228722227],
            [30.75501519278305, 0.970916514456431],
            [30.75418618701465, 0.973663662870135],
            [30.753211431388085, 0.974440134332722],
            [30.752566410471346, 0.976928359280408],
            [30.752143627366035, 0.976928073657654],
            [30.751253691566873, 0.977924951650142],
            [30.750273869442076, 0.977755975309007],
            [30.74924058408316, 0.979078509488288],
            [30.749659089411093, 0.980710127929144],
            [30.750658952051566, 0.980984498785363],
            [30.751340862285417, 0.982381844067646],
            [30.75093358500024, 0.983282144208947],
            [30.75201762517269, 0.983910556989357],
            [30.75166830808797, 0.985592805408381],
            [30.749675171051333, 0.986504575366765],
            [30.749377791861356, 0.989125995237288],
            [30.74858412401961, 0.990720821062279],
            [30.748595543403518, 0.992000498796609],
            [30.749032731892715, 0.993063164890559],
            [30.750063484002553, 0.994073249384836],
            [30.751495051815745, 0.994748840614408],
            [30.75181678523136, 0.997208057160123],
            [30.752954301214395, 0.998453013274267],
            [30.75235523181942, 0.999576157041706],
            [30.750984191591755, 1.00060176904106],
            [30.750561386028547, 1.002028223175017],
            [30.749606524492236, 1.002853247983779],
            [30.749024316475143, 1.004329322737456],
            [30.749382994903485, 1.005945342658303],
            [30.748330331087246, 1.007365371601141],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 110,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "BWIKARA",
        Population: 41633,
        Key: "KAGADIBWIKARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.653086135983163, 1.006523322094756],
            [30.652410248953288, 1.009384087200976],
            [30.651437635808634, 1.010419188938455],
            [30.651293426561153, 1.012202975969154],
            [30.649377753946386, 1.012920886354453],
            [30.648275559720354, 1.0152650321983],
            [30.6484172923126, 1.016905166237541],
            [30.647501922512816, 1.017825208643645],
            [30.646100850706894, 1.018428396791431],
            [30.644157516269598, 1.017880287339471],
            [30.639069564501554, 1.017818986097314],
            [30.639468712931762, 1.019229120952373],
            [30.640268630352917, 1.01983393183594],
            [30.64026802039682, 1.020668326347624],
            [30.642482089094436, 1.022324373249348],
            [30.64288121596509, 1.023763285352417],
            [30.644366610830094, 1.025116687290722],
            [30.646993692555995, 1.028772732739629],
            [30.645089361171713, 1.033475595708701],
            [30.642515719323743, 1.034883510572724],
            [30.640657564938326, 1.035112294804195],
            [30.63868558681989, 1.034650456430172],
            [30.637227231244918, 1.03539743730354],
            [30.63714092201075, 1.036145448200027],
            [30.636139744236694, 1.03712294896641],
            [30.634767826355, 1.036949281868467],
            [30.632510679846266, 1.035595288573091],
            [30.631527338122176, 1.031811019279371],
            [30.629801100437927, 1.027623388677894],
            [30.62625586772809, 1.028714065141504],
            [30.62568284228983, 1.03052626731069],
            [30.62491083911782, 1.030842177031533],
            [30.62473856470422, 1.031877837709628],
            [30.624280899118084, 1.032309071361819],
            [30.62336601979845, 1.032567327411767],
            [30.622308669471355, 1.032221268108293],
            [30.618104746181157, 1.033668704765281],
            [30.617665972165483, 1.033247138292863],
            [30.61490241029676, 1.031396987306568],
            [30.606439969503256, 1.023741415765064],
            [30.604280598325005, 1.022272634034166],
            [30.602609055465123, 1.020167952471987],
            [30.597622265676144, 1.016253559940446],
            [30.59673850130301, 1.015277223117493],
            [30.596593427876194, 1.013953991219614],
            [30.595127731268743, 1.011034805622121],
            [30.581744320247157, 0.996545287945617],
            [30.57858916388148, 0.995619513639533],
            [30.57572793178521, 0.994213774146779],
            [30.573234769105202, 0.991293884737509],
            [30.55574192678154, 0.976506198070828],
            [30.55141344219571, 0.974434566481575],
            [30.547086950971504, 0.969629643166939],
            [30.544503486045905, 0.968042836200163],
            [30.544175650374545, 0.964836195466818],
            [30.545483474359035, 0.963628154057855],
            [30.54802493765521, 0.963558645065799],
            [30.548685047573763, 0.962984182670748],
            [30.54860536880468, 0.962037029390682],
            [30.55073961590108, 0.961591917601678],
            [30.551207582468564, 0.960782171583773],
            [30.551456839807088, 0.955412777440243],
            [30.552900685793574, 0.954807785977389],
            [30.55331103172377, 0.952861111892119],
            [30.55562478018029, 0.951229593251567],
            [30.556722951750483, 0.947819586933992],
            [30.557685148031094, 0.946484201862251],
            [30.560307730994065, 0.944849967670992],
            [30.562203789792875, 0.944335806849563],
            [30.56206459044971, 0.943377310543671],
            [30.560987547254978, 0.942486234193725],
            [30.561326674749456, 0.940502070639019],
            [30.560910390056915, 0.935152835588174],
            [30.56147875144225, 0.932280596088792],
            [30.565897425085932, 0.928249135489086],
            [30.566683271296487, 0.928455545735436],
            [30.567488021653887, 0.928116759154494],
            [30.567316659928615, 0.927549540247156],
            [30.568656603176088, 0.925950158988811],
            [30.569586049576355, 0.926273794076798],
            [30.571384754354586, 0.925499777344278],
            [30.57222540049241, 0.923857363369295],
            [30.572969800232375, 0.923412464063685],
            [30.573053287858258, 0.919454378984428],
            [30.576799361407716, 0.918592241078443],
            [30.580252327256403, 0.916832167768936],
            [30.583535052477252, 0.915962206802796],
            [30.5846212827424, 0.915218104201771],
            [30.586030368418967, 0.913381103697281],
            [30.590517914098893, 0.911742275161982],
            [30.591508687585304, 0.910951601723215],
            [30.594282899880007, 0.910334890961243],
            [30.595602244758002, 0.909091077819543],
            [30.598444550249564, 0.908118302238953],
            [30.60005617817493, 0.907677636004892],
            [30.60040922236981, 0.908634279990393],
            [30.60090853654744, 0.908677304779697],
            [30.60201350566941, 0.907384468065853],
            [30.60381307462695, 0.906705185193406],
            [30.61111282415156, 0.906036936616977],
            [30.613734530358833, 0.906961860108512],
            [30.616661424810804, 0.906118404523615],
            [30.619301122476546, 0.908933823267616],
            [30.619331887978404, 0.910668244210326],
            [30.62214055874911, 0.915742739588823],
            [30.62146377250564, 0.91963074496617],
            [30.623105558671693, 0.921831973659594],
            [30.623134423338428, 0.926392834038382],
            [30.623740177995742, 0.927131972661947],
            [30.623739339867583, 0.928384598923011],
            [30.62528513655399, 0.930971198891376],
            [30.622150848052364, 0.941793025253215],
            [30.622691094864237, 0.945005257177832],
            [30.624459497671317, 0.948651942603188],
            [30.62477697037756, 0.950996824225591],
            [30.624232592213705, 0.953822883967554],
            [30.623465248603033, 0.956070651542737],
            [30.62200007481509, 0.956882425889898],
            [30.621718991962663, 0.957703011286885],
            [30.62060127395019, 0.961587327857039],
            [30.620438004248996, 0.964598338231985],
            [30.619351916815987, 0.965366130788708],
            [30.619433557505634, 0.967865516103942],
            [30.618228693029106, 0.968634341735106],
            [30.617621961903083, 0.96987190026523],
            [30.616487937671558, 0.970592713785722],
            [30.616853018392916, 0.972385653231217],
            [30.616730740614738, 0.974458832755711],
            [30.61579866933719, 0.97571285288269],
            [30.62151604277705, 0.978167277312426],
            [30.62483040127232, 0.980279494627693],
            [30.626167766354925, 0.985058671573169],
            [30.62635217790634, 0.987095060907553],
            [30.625809829036726, 0.99424463112208],
            [30.626565681398258, 0.996418238669267],
            [30.6264490297687, 0.997921791614528],
            [30.626819365634475, 0.998381270336533],
            [30.627703014124958, 0.99872632011715],
            [30.63128132370184, 0.998800678544012],
            [30.635815762337916, 0.997569844631948],
            [30.6372980472354, 0.998116233897039],
            [30.638666692554505, 0.998088525973535],
            [30.64010131823292, 0.996948609995903],
            [30.64323560583625, 0.996583791998509],
            [30.64489188811607, 1.001389557542113],
            [30.646422394578018, 1.002964505251685],
            [30.646584423705818, 1.004726967351028],
            [30.64729641492527, 1.005798127879068],
            [30.653086135983163, 1.006523322094756],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 111,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KYATEREKERA",
        Population: 24282,
        Key: "KAGADIKYATEREKERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.750663915243496, 1.070995480635291],
            [30.74660341337829, 1.071766337516812],
            [30.744919796262693, 1.072661159751248],
            [30.74195937578601, 1.075426940431339],
            [30.740642266814756, 1.078047701398053],
            [30.737907336949085, 1.080439174472704],
            [30.733175064134638, 1.082805817969901],
            [30.730410382066772, 1.083284861406277],
            [30.723713082297557, 1.086901614270733],
            [30.721238440183768, 1.089556292146664],
            [30.720491014917947, 1.089741492159675],
            [30.718970252481878, 1.091930369694463],
            [30.718478938700166, 1.093428703570842],
            [30.71601294287101, 1.093908621915851],
            [30.714846926038966, 1.096079827090698],
            [30.71417296589536, 1.096565210258694],
            [30.714168190451293, 1.097765068489909],
            [30.713422699258253, 1.097462814816153],
            [30.712855959332046, 1.099148397631123],
            [30.71225921387869, 1.098996584232321],
            [30.711468771887155, 1.100606491693869],
            [30.709391569607906, 1.101893735521885],
            [30.709089605416715, 1.102717718109315],
            [30.70777947545691, 1.10357610135871],
            [30.70680130353728, 1.105447891969596],
            [30.705193992016866, 1.105930407622248],
            [30.70451809061394, 1.106903223836094],
            [30.702500704454515, 1.107234490310245],
            [30.70163887783893, 1.108019260101106],
            [30.701117241424793, 1.107755185918216],
            [30.700481072506882, 1.108128186507083],
            [30.699174833150575, 1.108011691413682],
            [30.698202198446353, 1.108496149341492],
            [30.69351777619213, 1.108238044287723],
            [30.692320695617582, 1.108834293647773],
            [30.691164848612843, 1.108455795588935],
            [30.690378892807843, 1.108940810295274],
            [30.687505241502738, 1.108669513295451],
            [30.686234705687397, 1.108965573107006],
            [30.68097486847626, 1.107899539756301],
            [30.6775944721295, 1.108320328046578],
            [30.672843980582776, 1.110592897413252],
            [30.671566686741542, 1.112576179428238],
            [30.669245416691165, 1.114218790874374],
            [30.668229363714335, 1.117018843238651],
            [30.666735061154977, 1.116460719082967],
            [30.665993515362658, 1.115183612664777],
            [30.66524028518345, 1.112162986466711],
            [30.650223265359788, 1.105105229591732],
            [30.648796098393206, 1.102569981590367],
            [30.647155581546617, 1.102040008989459],
            [30.645971753817413, 1.099336788178552],
            [30.642063878413925, 1.09632523424361],
            [30.642367637439044, 1.095051374062644],
            [30.64321309315689, 1.093685451003288],
            [30.644636831254086, 1.092415029623359],
            [30.645727712097436, 1.090356215722027],
            [30.64141291603991, 1.08173810025365],
            [30.64026925468203, 1.078322644985139],
            [30.638219136608605, 1.0775289855666],
            [30.6376996345916, 1.076740022402477],
            [30.63624728515262, 1.075835717723584],
            [30.63632719209377, 1.074523676327648],
            [30.637288201699878, 1.072258250598636],
            [30.636659692716425, 1.070719084964723],
            [30.633611204104195, 1.067522777250944],
            [30.630215016273056, 1.06258196538057],
            [30.63089953162125, 1.059434592754719],
            [30.62993204875522, 1.058644275906064],
            [30.62901235087239, 1.055229544029889],
            [30.626770136160275, 1.051117159501533],
            [30.62464807021912, 1.049648436276144],
            [30.62436135223493, 1.046648081150826],
            [30.62466491812228, 1.04541172569041],
            [30.623365184365216, 1.043683061506472],
            [30.6223413681477, 1.041039687058828],
            [30.621074110284844, 1.039531391251886],
            [30.62091001143863, 1.038146072764241],
            [30.618728143750666, 1.035983514721048],
            [30.61766514212216, 1.034357418060864],
            [30.617665972165483, 1.033247138292863],
            [30.618104746181157, 1.033668704765281],
            [30.622308669471355, 1.032221268108293],
            [30.62336601979845, 1.032567327411767],
            [30.624280899118084, 1.032309071361819],
            [30.62473856470422, 1.031877837709628],
            [30.62491083911782, 1.030842177031533],
            [30.62568284228983, 1.03052626731069],
            [30.62625586772809, 1.028714065141504],
            [30.629801100437927, 1.027623388677894],
            [30.631527338122176, 1.031811019279371],
            [30.632510679846266, 1.035595288573091],
            [30.634767826355, 1.036949281868467],
            [30.636139744236694, 1.03712294896641],
            [30.63714092201075, 1.036145448200027],
            [30.637227231244918, 1.03539743730354],
            [30.63868558681989, 1.034650456430172],
            [30.640657564938326, 1.035112294804195],
            [30.642515719323743, 1.034883510572724],
            [30.645089361171713, 1.033475595708701],
            [30.646993692555995, 1.028772732739629],
            [30.644366610830094, 1.025116687290722],
            [30.64288121596509, 1.023763285352417],
            [30.642482089094436, 1.022324373249348],
            [30.64026802039682, 1.020668326347624],
            [30.640268630352917, 1.01983393183594],
            [30.639468712931762, 1.019229120952373],
            [30.639069564501554, 1.017818986097314],
            [30.644157516269598, 1.017880287339471],
            [30.646100850706894, 1.018428396791431],
            [30.647501922512816, 1.017825208643645],
            [30.6484172923126, 1.016905166237541],
            [30.648275559720354, 1.0152650321983],
            [30.649377753946386, 1.012920886354453],
            [30.651293426561153, 1.012202975969154],
            [30.651437635808634, 1.010419188938455],
            [30.652410248953288, 1.009384087200976],
            [30.653086135983163, 1.006523322094756],
            [30.658897513625917, 1.004900704450905],
            [30.665679806597446, 1.002151255582953],
            [30.667008650261252, 1.00230324434161],
            [30.668456263782065, 1.003011529342425],
            [30.669233293028107, 1.002591637555541],
            [30.670607082998817, 1.002623430353406],
            [30.671636246887257, 1.003601758642415],
            [30.672738812117522, 1.005594786017231],
            [30.675663885684415, 1.007041478381379],
            [30.675603086807662, 1.00789818778742],
            [30.676348396541023, 1.008973865098787],
            [30.67634544377867, 1.011348815820908],
            [30.677313885147132, 1.013116223223898],
            [30.677249907132584, 1.016520737947718],
            [30.677742418368602, 1.016746831665061],
            [30.677771415087644, 1.017438309587669],
            [30.678755534752753, 1.018612001388016],
            [30.679122178542723, 1.020179975414286],
            [30.681065865119574, 1.019149225754828],
            [30.68256034374876, 1.018853759100464],
            [30.683312603747467, 1.017431214015809],
            [30.684997729134427, 1.016123960617515],
            [30.685974127779684, 1.014664590975158],
            [30.68746934841724, 1.014181647042031],
            [30.687923088365597, 1.012720702921135],
            [30.68949399835406, 1.0119755158099],
            [30.68949635553338, 1.011375606594968],
            [30.691370355302094, 1.009506466357756],
            [30.694768749395543, 1.004473543958182],
            [30.69604144296421, 1.003614962749512],
            [30.69668241966555, 1.002004582234166],
            [30.697660720044222, 1.001060751593766],
            [30.69955303017338, 1.001042095534809],
            [30.70200654301337, 0.999206899638548],
            [30.703489528596762, 0.998863521419113],
            [30.70474483886639, 0.997888533841056],
            [30.708474509178753, 0.994634456504041],
            [30.711965806140586, 0.989488864106134],
            [30.713042727164446, 0.988572945367477],
            [30.714878074223122, 0.9897188874379],
            [30.716189281262942, 0.993652487916214],
            [30.718613650060163, 0.994478015112725],
            [30.72776732739678, 0.994773338471066],
            [30.729106219615385, 0.995801636626432],
            [30.730541217196333, 0.996220003274438],
            [30.7312909196914, 0.995979734860672],
            [30.73282098957212, 0.997297116120395],
            [30.733043418724698, 0.998517274380471],
            [30.73425433604957, 1.000123383973694],
            [30.735864964150036, 1.001527909298826],
            [30.735778826494087, 1.004066996579914],
            [30.736376254667036, 1.00607660850553],
            [30.73785774904708, 1.007943328331399],
            [30.73862779568841, 1.007742948788942],
            [30.740309891956258, 1.008174670690538],
            [30.741052060281035, 1.00705577824991],
            [30.741765176191258, 1.006711842188092],
            [30.743048142893493, 1.007028471886976],
            [30.74416061294809, 1.006483893934839],
            [30.74475913526907, 1.006914856145854],
            [30.746755718243147, 1.00616997218605],
            [30.748330331087246, 1.007365371601141],
            [30.749353554416672, 1.008508267692531],
            [30.751092750298888, 1.007816157345203],
            [30.751937703858527, 1.008108998739157],
            [30.751432220051495, 1.008377626175676],
            [30.75110058899806, 1.010159922457453],
            [30.75179431297624, 1.012100753760461],
            [30.751611286626982, 1.015054894444011],
            [30.755757460820842, 1.014639261558102],
            [30.757478102899203, 1.017202514744408],
            [30.75747090649546, 1.018655168495954],
            [30.759137935321018, 1.019607087462401],
            [30.759238718211048, 1.020901037510342],
            [30.760277975570002, 1.021608908883557],
            [30.76116677230538, 1.020583375371226],
            [30.762615318277412, 1.021095870920161],
            [30.7635377632084, 1.022926821357863],
            [30.762742976964134, 1.023219915565526],
            [30.762696217856952, 1.023659374946979],
            [30.76481792357371, 1.023561415825471],
            [30.765351366545595, 1.024440261682662],
            [30.764991860768898, 1.025099503473377],
            [30.76623850049938, 1.02652757430311],
            [30.767131291144512, 1.026698353451841],
            [30.767305134914913, 1.028212031804777],
            [30.76839215030762, 1.028773409062006],
            [30.770957366856543, 1.031507488229618],
            [30.772192847714546, 1.031335479743956],
            [30.772822993428484, 1.0322875700825],
            [30.772609142288594, 1.033239767018075],
            [30.77198624328404, 1.034460581739445],
            [30.770735480286415, 1.03541292173032],
            [30.772258260338596, 1.036486956056782],
            [30.77398624794103, 1.038971357759262],
            [30.77451601231187, 1.041027763891824],
            [30.776281966311462, 1.042712136452502],
            [30.776284730427594, 1.04354223532212],
            [30.775433020638722, 1.044848537088356],
            [30.773537429862174, 1.045894797819176],
            [30.77028387114194, 1.046456752154203],
            [30.76963757192257, 1.047897294254674],
            [30.770050192387085, 1.048702920354581],
            [30.771185757229325, 1.049361965783601],
            [30.772993760469056, 1.04919083757452],
            [30.77280661175098, 1.050924303898998],
            [30.774427871412797, 1.052608702579312],
            [30.774357883669037, 1.053316735715666],
            [30.771771792069522, 1.055184773301679],
            [30.769627483841933, 1.055746564296107],
            [30.769004887569672, 1.057065022978312],
            [30.768018059483975, 1.057626675315831],
            [30.76408168323144, 1.055893722876381],
            [30.764007070062256, 1.055210124848988],
            [30.764821446766256, 1.053549841466101],
            [30.76436028403872, 1.052646561975043],
            [30.763214494571915, 1.052536836908781],
            [30.760748524793907, 1.050632814581495],
            [30.758751506136946, 1.051975847395751],
            [30.75767075110344, 1.053294353481431],
            [30.75769696663837, 1.053929119688883],
            [30.758499137034278, 1.055857755050896],
            [30.761060330029036, 1.057395561096833],
            [30.760898572192456, 1.059519633399695],
            [30.75978924264808, 1.059495347107356],
            [30.759369386253976, 1.060142378239427],
            [30.758699047219274, 1.061607315249922],
            [30.758609050400867, 1.063560471904994],
            [30.75597721928204, 1.062535367001257],
            [30.755598578491472, 1.064708279522871],
            [30.75287650890742, 1.065563078214332],
            [30.75184307712311, 1.06661300005852],
            [30.751231673859284, 1.067675091603349],
            [30.750663915243496, 1.070995480635291],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 112,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "MPEEFU",
        Population: 38850,
        Key: "KAGADIMPEEFU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.969033618758797, 1.022383844828768],
            [30.972001908477388, 1.027786069860526],
            [30.97206305140889, 1.029817498841659],
            [30.96947251674201, 1.037463362749055],
            [30.96914937386968, 1.042116519956614],
            [30.96449496343078, 1.044835140045447],
            [30.96249810108068, 1.047663057292622],
            [30.96189221706592, 1.052906443829143],
            [30.959465783940203, 1.056997195548997],
            [30.959592297274924, 1.058328585437279],
            [30.957940001718324, 1.058823012823273],
            [30.955435716996824, 1.06395691454487],
            [30.955385007997368, 1.065000084568699],
            [30.953709544889588, 1.067671014858167],
            [30.951919260918807, 1.069588000611553],
            [30.95043741709413, 1.074938660905182],
            [30.947869864027155, 1.076189214307127],
            [30.944996857712457, 1.079412863604745],
            [30.94885007332583, 1.080764046306824],
            [30.951441282627506, 1.080913598171236],
            [30.950580364208655, 1.083516974218294],
            [30.945653636677903, 1.089955140251503],
            [30.94481861758704, 1.091602349240822],
            [30.94401292310028, 1.093908391090907],
            [30.94378948963122, 1.096008462712752],
            [30.942439759238734, 1.097793009948936],
            [30.941601151378293, 1.098369608977304],
            [30.94040693822612, 1.098543673180461],
            [30.944832153401734, 1.100648981352607],
            [30.94497859765766, 1.101203283271275],
            [30.947289803881883, 1.103070698695882],
            [30.947050134262412, 1.104640764790266],
            [30.94585651309999, 1.105609782260533],
            [30.945571116537607, 1.106948898236397],
            [30.944652816433354, 1.107881158272601],
            [30.94441332557861, 1.109183358484302],
            [30.944852961976967, 1.110393669644689],
            [30.946595730459073, 1.111521764901176],
            [30.947292119738705, 1.113009357872243],
            [30.94568680966472, 1.118274878396823],
            [30.94368515300594, 1.121406749521547],
            [30.943157191553873, 1.124608182903692],
            [30.94241628356542, 1.124645488139778],
            [30.940247138716845, 1.123206813017451],
            [30.933116271567325, 1.122105620731224],
            [30.929655433781807, 1.121973240734821],
            [30.925870817116788, 1.123383295353702],
            [30.922692300960463, 1.123324181401946],
            [30.92274195264283, 1.121562330378381],
            [30.922153538165457, 1.12084741101272],
            [30.9226850156235, 1.120205336308086],
            [30.92246086799381, 1.119759645985793],
            [30.921460524754686, 1.119742691726474],
            [30.921555692275856, 1.118866401489161],
            [30.921043892414104, 1.118240325891506],
            [30.920739607874545, 1.115433471241556],
            [30.919595244034095, 1.113759111026915],
            [30.91824153679986, 1.110286743494668],
            [30.917850501953303, 1.106855419926992],
            [30.916365337955316, 1.104618378442915],
            [30.915299382666156, 1.102065584683699],
            [30.913774967680126, 1.100254040723638],
            [30.91225452684096, 1.095573883369949],
            [30.909907709602233, 1.091072281289779],
            [30.909748171502716, 1.087956634767414],
            [30.90696459786442, 1.082576695061199],
            [30.904663724960905, 1.079653526257986],
            [30.90383772854872, 1.075892908763624],
            [30.90272222488342, 1.074740143908898],
            [30.901697614555175, 1.072393263499563],
            [30.89810127129896, 1.06720564883837],
            [30.896850754439733, 1.066217622977776],
            [30.89485510481525, 1.06133173785949],
            [30.89378271040209, 1.060906419895491],
            [30.893129325271776, 1.060110453986406],
            [30.89132715928476, 1.056322576696028],
            [30.889805553330618, 1.05131311016549],
            [30.88857726887633, 1.048870217917615],
            [30.886974129132103, 1.047089524027029],
            [30.88528729964105, 1.046098270048506],
            [30.885122220732843, 1.045384579528422],
            [30.88562038596525, 1.044368831125015],
            [30.884742483997645, 1.041308261436483],
            [30.884061431654857, 1.040347614276017],
            [30.883211514004994, 1.037547822876166],
            [30.882545455442624, 1.037012662901017],
            [30.882569420697795, 1.036079342107159],
            [30.88106897815344, 1.033334564286992],
            [30.88058058389643, 1.033224852019983],
            [30.880005667504474, 1.031577932577302],
            [30.878296841865364, 1.031358624680374],
            [30.8770780795531, 1.031743133822147],
            [30.876533973578766, 1.031194227277561],
            [30.875394970883928, 1.031112073481452],
            [30.875391552794273, 1.030096414802595],
            [30.87436776442454, 1.028347175945136],
            [30.87741440789716, 1.026624648635373],
            [30.87763498382529, 1.026089093423676],
            [30.87857095199451, 1.026052774971427],
            [30.879397895231016, 1.024372326669274],
            [30.88022383774428, 1.024206626557788],
            [30.882060300510513, 1.022268231193546],
            [30.886154866491292, 1.019075190237194],
            [30.88681617476244, 1.018096579194525],
            [30.886670239851266, 1.016747980429415],
            [30.885418971102112, 1.014876828686454],
            [30.885516353868823, 1.013042388759198],
            [30.885001826721844, 1.012708965570688],
            [30.886235576526307, 1.009563981946152],
            [30.886934611344422, 1.008861261669927],
            [30.887063931914405, 1.007880597902781],
            [30.887570426326107, 1.007541191431566],
            [30.89136465945629, 1.009530334482753],
            [30.896626652624093, 1.010421653532297],
            [30.897011364229353, 1.009082830012906],
            [30.899472275594, 1.006368936298697],
            [30.8988685906551, 1.003357480406157],
            [30.901861354973615, 1.001179627269545],
            [30.90678338521374, 0.99536384858509],
            [30.90743951379892, 0.994314005649215],
            [30.906907132635695, 0.992442871597242],
            [30.912226768000355, 0.993486214099295],
            [30.916823043067325, 0.993026518233575],
            [30.916235721839616, 0.99149022526656],
            [30.915860769531594, 0.988427402225474],
            [30.918435623206886, 0.986661798552905],
            [30.922288037523046, 0.985100547536747],
            [30.924006975497313, 0.985046114083275],
            [30.92649837119113, 0.986678037685102],
            [30.92916420534005, 0.985664443536087],
            [30.930589616998606, 0.983185847313314],
            [30.936328096356068, 0.97889620774477],
            [30.939189607828403, 0.975144012494189],
            [30.93889958314567, 0.975108590764929],
            [30.937463828284933, 0.970527891672992],
            [30.93772302368545, 0.967530193196058],
            [30.939911714077965, 0.965903067400647],
            [30.941273387572164, 0.963831301776468],
            [30.943186190967907, 0.962407555544452],
            [30.944216756228148, 0.960650172829492],
            [30.944866719675545, 0.957435255509305],
            [30.946890941115953, 0.954133265464435],
            [30.949613749115183, 0.950831683622072],
            [30.951607904841335, 0.949434963083102],
            [30.952998757412583, 0.950467605234836],
            [30.95519272810237, 0.953798922033025],
            [30.957951447153377, 0.96071008742586],
            [30.95728440493579, 0.960813051321018],
            [30.958136031181336, 0.962575304828418],
            [30.95756975478576, 0.966572756935101],
            [30.95701831766041, 0.967638783129418],
            [30.956935199242107, 0.970494482731054],
            [30.958118895817268, 0.97472301061791],
            [30.959229714768362, 0.976432226262841],
            [30.959870064445628, 0.979759553045638],
            [30.96069501701542, 0.981579997167005],
            [30.962636203580853, 0.983798184435005],
            [30.96328408563178, 0.985298797069628],
            [30.963699698384495, 0.988328729788206],
            [30.965695069531254, 0.991824517359681],
            [30.96663383505431, 0.997757805675035],
            [30.965220188631008, 1.002971035003206],
            [30.962771787205003, 1.004550037221889],
            [30.961829087959327, 1.006389509934552],
            [30.96240418131941, 1.008063943524191],
            [30.963247523301384, 1.008887312367404],
            [30.963985301559383, 1.010561712337814],
            [30.96609098043316, 1.011837777051971],
            [30.966937967778556, 1.013731770236186],
            [30.96813200216601, 1.01403348685804],
            [30.969193094874544, 1.015103879972672],
            [30.969339519367566, 1.018288267370755],
            [30.96832933598277, 1.020223830501629],
            [30.969033618758797, 1.022383844828768],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 114,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "MABAALE",
        Population: 25503,
        Key: "KAGADIMABAALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.87436776442454, 1.028347175945136],
            [30.87376535688994, 1.027559945484394],
            [30.870923723338215, 1.028304002680448],
            [30.86905977571755, 1.027060591210224],
            [30.868155638452073, 1.025817827735931],
            [30.865962323532468, 1.025015852268508],
            [30.865387428700075, 1.023524881783324],
            [30.86379678362311, 1.023689433168173],
            [30.86168589272408, 1.02266668914494],
            [30.85838129262774, 1.02287148946386],
            [30.851527074246377, 1.023791087364896],
            [30.848521645478986, 1.024686457720736],
            [30.847660196155818, 1.024513151907717],
            [30.840187617957067, 1.026058131664727],
            [30.836422435444884, 1.027404685876134],
            [30.835195460734266, 1.028494625016422],
            [30.833284459359, 1.029010000630179],
            [30.832585401184694, 1.02958361262218],
            [30.830560880605294, 1.029295176908991],
            [30.829191124968474, 1.030672056463154],
            [30.82448393581171, 1.033424444975046],
            [30.823907481503998, 1.033363700895471],
            [30.82385483843172, 1.028504113290162],
            [30.822885987431476, 1.027234663923225],
            [30.824761622134016, 1.02564736020564],
            [30.823597060572727, 1.023547822891256],
            [30.821948157054635, 1.022396205475546],
            [30.82182479500993, 1.021566101084237],
            [30.822878308632422, 1.019319710695451],
            [30.822752835546805, 1.014277945724043],
            [30.825825577773365, 1.002973072968299],
            [30.82719658296674, 1.0019229683985],
            [30.829534321831204, 1.001507488322656],
            [30.830586228367654, 0.998797179239415],
            [30.831283504284457, 0.998186666397453],
            [30.833211211629035, 0.997746833519387],
            [30.834081147336722, 0.996096163181001],
            [30.83406215246003, 0.995227202212371],
            [30.833089593214297, 0.994621634087327],
            [30.833075776226945, 0.992232557231203],
            [30.83175783361908, 0.988903194141749],
            [30.835532476289533, 0.982019807938495],
            [30.837357762217014, 0.977695415219544],
            [30.838026743897302, 0.976959796643158],
            [30.839422503964958, 0.970161774704331],
            [30.842166344219905, 0.965171436905575],
            [30.843356461952716, 0.962069453102835],
            [30.844392424291183, 0.955989980586941],
            [30.84609520965831, 0.952558970286074],
            [30.848280197195262, 0.950414265223066],
            [30.85017475850251, 0.946612475456524],
            [30.850094975528865, 0.944754269681476],
            [30.860426729580226, 0.943345910596204],
            [30.86909871948172, 0.940731511661196],
            [30.869573487194227, 0.939758687264126],
            [30.870676777364924, 0.939259744700473],
            [30.876283932909306, 0.938782071316265],
            [30.87836198499481, 0.937543537844029],
            [30.879134102252884, 0.937507001066707],
            [30.879666007309012, 0.9395058248578],
            [30.879528984583782, 0.942377829391831],
            [30.87991891090929, 0.944269975569346],
            [30.877581484658517, 0.950357528249432],
            [30.877810652972354, 0.955313014533474],
            [30.881558791748642, 0.958669563967504],
            [30.885580516037976, 0.955218072211925],
            [30.887086154437906, 0.953349642466475],
            [30.88922864088212, 0.952009376065802],
            [30.894873287614896, 0.950486216664695],
            [30.896325594833044, 0.950468604922205],
            [30.89830037659349, 0.951324264429292],
            [30.89806015181515, 0.952081833155847],
            [30.89858328302593, 0.953395998998433],
            [30.90168843736626, 0.95613663349404],
            [30.903341314132817, 0.958839368492567],
            [30.90282570182098, 0.960263926379023],
            [30.90159329859113, 0.961410463704342],
            [30.900048666121325, 0.962075680244741],
            [30.89899958568478, 0.964055046733121],
            [30.898722510216867, 0.966201435440551],
            [30.89965759444385, 0.970217571846167],
            [30.899845181539806, 0.97858383993065],
            [30.904497095560536, 0.977636444915595],
            [30.906040524287825, 0.978932762942501],
            [30.906810647285987, 0.982134602054901],
            [30.90578485207986, 0.988498472641344],
            [30.906907132635695, 0.992442871597242],
            [30.90743951379892, 0.994314005649215],
            [30.90678338521374, 0.99536384858509],
            [30.901861354973615, 1.001179627269545],
            [30.8988685906551, 1.003357480406157],
            [30.899472275594, 1.006368936298697],
            [30.897011364229353, 1.009082830012906],
            [30.896626652624093, 1.010421653532297],
            [30.89136465945629, 1.009530334482753],
            [30.887570426326107, 1.007541191431566],
            [30.887063931914405, 1.007880597902781],
            [30.886934611344422, 1.008861261669927],
            [30.886235576526307, 1.009563981946152],
            [30.885001826721844, 1.012708965570688],
            [30.885516353868823, 1.013042388759198],
            [30.885418971102112, 1.014876828686454],
            [30.886670239851266, 1.016747980429415],
            [30.88681617476244, 1.018096579194525],
            [30.886154866491292, 1.019075190237194],
            [30.882060300510513, 1.022268231193546],
            [30.88022383774428, 1.024206626557788],
            [30.879397895231016, 1.024372326669274],
            [30.87857095199451, 1.026052774971427],
            [30.87763498382529, 1.026089093423676],
            [30.87741440789716, 1.026624648635373],
            [30.87436776442454, 1.028347175945136],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 115,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KYENZIGE",
        Population: 16163,
        Key: "KAGADIKYENZIGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.9985336881231, 1.128452165413834],
            [30.996111846286784, 1.128851513929636],
            [30.99302305835263, 1.130813971873029],
            [30.99174849628817, 1.130452236850785],
            [30.990612689799107, 1.131072900330049],
            [30.989039235781735, 1.130871330706553],
            [30.985153837124983, 1.132632741398752],
            [30.979913061265854, 1.132665711211318],
            [30.979596795895343, 1.132187805618059],
            [30.977515317635337, 1.131665730316022],
            [30.97421690513467, 1.128126713204475],
            [30.973416714625674, 1.128264985625552],
            [30.972630194678665, 1.128583750261396],
            [30.970959305792338, 1.131067708181258],
            [30.970088476260944, 1.133593874734103],
            [30.96939848837607, 1.133954354663675],
            [30.966460615613, 1.133383055346837],
            [30.965785083417643, 1.132799474754867],
            [30.96453151587971, 1.130299579915716],
            [30.96345550395091, 1.130340468659381],
            [30.962462814357995, 1.129590065008417],
            [30.96185572390583, 1.129770118863407],
            [30.961152528091326, 1.129297588166083],
            [30.956545347476794, 1.128250171685905],
            [30.9556091421523, 1.126378166559144],
            [30.955043584409005, 1.126349999937115],
            [30.954256741068477, 1.127140790253322],
            [30.952064090003887, 1.12616740592556],
            [30.951264882251806, 1.124917347698218],
            [30.950809682541138, 1.124889257404149],
            [30.95056098305641, 1.125458294174742],
            [30.94971949879043, 1.125485464765904],
            [30.94963610009777, 1.126387815295408],
            [30.94747030506687, 1.126469575827452],
            [30.94423634578955, 1.125565908647152],
            [30.943157191553873, 1.124608182903692],
            [30.94368515300594, 1.121406749521547],
            [30.94568680966472, 1.118274878396823],
            [30.947292119738705, 1.113009357872243],
            [30.946595730459073, 1.111521764901176],
            [30.944852961976967, 1.110393669644689],
            [30.94441332557861, 1.109183358484302],
            [30.944652816433354, 1.107881158272601],
            [30.945571116537607, 1.106948898236397],
            [30.94585651309999, 1.105609782260533],
            [30.947050134262412, 1.104640764790266],
            [30.947289803881883, 1.103070698695882],
            [30.94497859765766, 1.101203283271275],
            [30.944832153401734, 1.100648981352607],
            [30.94040693822612, 1.098543673180461],
            [30.941601151378293, 1.098369608977304],
            [30.942439759238734, 1.097793009948936],
            [30.94378948963122, 1.096008462712752],
            [30.94401292310028, 1.093908391090907],
            [30.94481861758704, 1.091602349240822],
            [30.945653636677903, 1.089955140251503],
            [30.950580364208655, 1.083516974218294],
            [30.951441282627506, 1.080913598171236],
            [30.94885007332583, 1.080764046306824],
            [30.944996857712457, 1.079412863604745],
            [30.947869864027155, 1.076189214307127],
            [30.95043741709413, 1.074938660905182],
            [30.951919260918807, 1.069588000611553],
            [30.953709544889588, 1.067671014858167],
            [30.955385007997368, 1.065000084568699],
            [30.955435716996824, 1.06395691454487],
            [30.957940001718324, 1.058823012823273],
            [30.959592297274924, 1.058328585437279],
            [30.959465783940203, 1.056997195548997],
            [30.96189221706592, 1.052906443829143],
            [30.96249810108068, 1.047663057292622],
            [30.96449496343078, 1.044835140045447],
            [30.96914937386968, 1.042116519956614],
            [30.96947251674201, 1.037463362749055],
            [30.97206305140889, 1.029817498841659],
            [30.972001908477388, 1.027786069860526],
            [30.969033618758797, 1.022383844828768],
            [30.975334474026834, 1.020531211292319],
            [30.977667902774556, 1.020917079772674],
            [30.97862779577478, 1.021585351615412],
            [30.983888469317446, 1.018477200837892],
            [30.98917559914356, 1.017948376077724],
            [30.9902327293834, 1.018321553677397],
            [30.991368500838142, 1.019759097858282],
            [30.99411670421042, 1.021277485912292],
            [30.99519818508268, 1.025003291339565],
            [30.995779272002295, 1.025748684711359],
            [30.995844135755714, 1.027704417155886],
            [30.99674587362104, 1.030596783533695],
            [31.003137251221958, 1.03746199394097],
            [31.00716753286268, 1.038575026912463],
            [31.009149719436035, 1.040936033195611],
            [31.010929854240707, 1.044097735856187],
            [31.012690012310095, 1.045294751274379],
            [31.01088168298189, 1.04677325307175],
            [31.010991431058482, 1.04803440543318],
            [31.009885388449746, 1.048960960400925],
            [31.00888939664983, 1.050666484963117],
            [31.011172497283773, 1.053041753969895],
            [31.011723952375434, 1.055045001180296],
            [31.01157636905572, 1.055341632067871],
            [31.007706745713662, 1.056155122354316],
            [31.007294834918223, 1.0581703247909],
            [31.008896151980775, 1.059043879807564],
            [31.01223798814396, 1.062411996526734],
            [31.01509165193399, 1.064436083084446],
            [31.016306699712544, 1.065926942543379],
            [31.018368791430387, 1.065662198245348],
            [31.019981780303425, 1.064944816286314],
            [31.02217567643302, 1.065265540266364],
            [31.025969410998183, 1.064775739435675],
            [31.026795152288834, 1.066935738436678],
            [31.027522131898788, 1.070707543628856],
            [31.0289946485159, 1.072971052040817],
            [31.030025927038476, 1.07375063312719],
            [31.0302160096543, 1.074494473640564],
            [31.030032333823073, 1.075462216447397],
            [31.030598841983963, 1.077531982714617],
            [31.02967755677803, 1.078926518447194],
            [31.028763105954777, 1.082493772007245],
            [31.026887828781717, 1.084166594145265],
            [31.025889925366908, 1.085964253369334],
            [31.025725976539345, 1.087577772108902],
            [31.024184409121304, 1.091852976820377],
            [31.022521836837846, 1.091817633633787],
            [31.019308994257898, 1.094027234503499],
            [31.016809953002685, 1.094365971435126],
            [31.015886329482072, 1.094145818345592],
            [31.014178586312894, 1.091248911937862],
            [31.013257172647876, 1.090862565388785],
            [31.011368846547015, 1.091727943256695],
            [31.00925065144642, 1.093802692122242],
            [31.00756016132056, 1.097661267449214],
            [31.00776046856091, 1.104940414902554],
            [31.004470808346067, 1.109832554304182],
            [31.002914665762557, 1.115615368063708],
            [31.0014176601725, 1.118049797167354],
            [31.000122616519544, 1.118509990980703],
            [30.998107842660986, 1.122858822227731],
            [30.998008586906927, 1.125073542697305],
            [30.9985336881231, 1.128452165413834],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 116,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "PAACWA",
        Population: 16081,
        Key: "KAGADIPAACWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.906371650488094, 1.123541564246068],
            [30.903068887446484, 1.126996614294677],
            [30.90126615462253, 1.127730931108232],
            [30.897703835057712, 1.13126607412506],
            [30.89750234114286, 1.132136322441962],
            [30.897892010550166, 1.133383238567325],
            [30.899107145465308, 1.135063151497436],
            [30.896129649811694, 1.139985717903869],
            [30.89362948476408, 1.140685803411702],
            [30.893823860428633, 1.141932575734834],
            [30.892724371029892, 1.142358535078395],
            [30.892132237527203, 1.143312720781998],
            [30.8909993532578, 1.143626346417944],
            [30.890467823697424, 1.145630660912442],
            [30.888904137062152, 1.145692017951379],
            [30.888744462418714, 1.144691246724565],
            [30.888331758410867, 1.144388063833517],
            [30.887572854472328, 1.144356434174121],
            [30.88710460763048, 1.143904225298686],
            [30.88635670715586, 1.144229364077387],
            [30.885151938799083, 1.143661311763753],
            [30.883800257265808, 1.143608537272311],
            [30.88270356432253, 1.14223317764009],
            [30.8811972036771, 1.14207482624195],
            [30.87820561615162, 1.143375367594445],
            [30.876243534772666, 1.148337898446526],
            [30.875307862149153, 1.148567027011994],
            [30.874703784646456, 1.148067205973672],
            [30.874145516731677, 1.14849355509416],
            [30.873397885751615, 1.14845930113016],
            [30.872705486788522, 1.149183163581194],
            [30.869771558527844, 1.147973656235587],
            [30.867053798162235, 1.148701606220861],
            [30.865564845070356, 1.147661646820507],
            [30.864142184053215, 1.147514576299363],
            [30.86305518752515, 1.146166077284638],
            [30.862251103717686, 1.147024616602486],
            [30.858988011177367, 1.145814861356858],
            [30.8566124963586, 1.14402178594353],
            [30.85684769326629, 1.142865209894585],
            [30.855944010548342, 1.142611841062864],
            [30.85554830805556, 1.142021935861717],
            [30.854231593444734, 1.141976022207642],
            [30.85378558080448, 1.141515231258327],
            [30.853791393802666, 1.141200779105804],
            [30.85461715126299, 1.14120140061666],
            [30.85356889278489, 1.140290934642463],
            [30.853224277482344, 1.138527471881174],
            [30.852694706249302, 1.137886930611616],
            [30.851478571509226, 1.137644559942296],
            [30.85140683025403, 1.136577601188905],
            [30.850380467312675, 1.136239912752761],
            [30.850448106860295, 1.135313442172526],
            [30.849103194132677, 1.135683041589428],
            [30.849554385560566, 1.135001895721619],
            [30.8482903274967, 1.133352091088061],
            [30.847213898749615, 1.132817832730603],
            [30.846512602871933, 1.133165735209789],
            [30.84632713310511, 1.13233425451111],
            [30.844174790345612, 1.13057506294259],
            [30.842646029310256, 1.130231006888473],
            [30.84501554517958, 1.128002723916338],
            [30.846978795266725, 1.122973374948701],
            [30.84888287063116, 1.12099523194066],
            [30.848695628488294, 1.119583374494858],
            [30.844441353728087, 1.112954940116044],
            [30.844941490762523, 1.111050457230303],
            [30.845904192794634, 1.110464374438058],
            [30.8486061517944, 1.110757067816945],
            [30.849906482032807, 1.110170941855453],
            [30.850540748318927, 1.108718129998419],
            [30.851382385298518, 1.107985556224853],
            [30.851738383154014, 1.106251987680489],
            [30.85354538656884, 1.105739049112914],
            [30.85450597935667, 1.104518138799155],
            [30.855565389520702, 1.104005279867382],
            [30.85807495543778, 1.100818706462666],
            [30.85836126109523, 1.099890859516514],
            [30.856023539298747, 1.096794654539487],
            [30.850335760855927, 1.091132377565178],
            [30.85213405330743, 1.089892072863219],
            [30.853296934120845, 1.090105755074176],
            [30.85460171910472, 1.089006985397566],
            [30.85648876061473, 1.086862135926587],
            [30.857300562747085, 1.085159941146598],
            [30.85561025677587, 1.083207636265466],
            [30.85458952627135, 1.08132676131715],
            [30.85249640404864, 1.075844472957296],
            [30.852466268265815, 1.068536725359405],
            [30.85292799064374, 1.066388906527666],
            [30.852999697762982, 1.066077704056487],
            [30.854258577039214, 1.066404919816854],
            [30.855798894002398, 1.065476895276241],
            [30.85714847617286, 1.065208133469649],
            [30.859536267368334, 1.065305450904973],
            [30.862664801262223, 1.06335171154972],
            [30.865173752731646, 1.063619928334651],
            [30.867203901256303, 1.064938091761495],
            [30.868398667770727, 1.065243117701252],
            [30.8783587393817, 1.064083300980173],
            [30.877701272306737, 1.063061509564765],
            [30.877510196154223, 1.061764006633314],
            [30.87748399858557, 1.059969755184111],
            [30.878293869340094, 1.058686747289835],
            [30.878157072092, 1.058217391178354],
            [30.876485156431265, 1.056863658552963],
            [30.875086652908774, 1.056724675991925],
            [30.87322274571224, 1.055922249423163],
            [30.873225199909616, 1.051809961014488],
            [30.875309306640123, 1.051921808467583],
            [30.878436087920942, 1.051178658594663],
            [30.88277007019628, 1.049608217365788],
            [30.886974129132103, 1.047089524027029],
            [30.88857726887633, 1.048870217917615],
            [30.889805553330618, 1.05131311016549],
            [30.89132715928476, 1.056322576696028],
            [30.893129325271776, 1.060110453986406],
            [30.89378271040209, 1.060906419895491],
            [30.89485510481525, 1.06133173785949],
            [30.896850754439733, 1.066217622977776],
            [30.89810127129896, 1.06720564883837],
            [30.901697614555175, 1.072393263499563],
            [30.90272222488342, 1.074740143908898],
            [30.90383772854872, 1.075892908763624],
            [30.904663724960905, 1.079653526257986],
            [30.90696459786442, 1.082576695061199],
            [30.909748171502716, 1.087956634767414],
            [30.909907709602233, 1.091072281289779],
            [30.91225452684096, 1.095573883369949],
            [30.913774967680126, 1.100254040723638],
            [30.915299382666156, 1.102065584683699],
            [30.916365337955316, 1.104618378442915],
            [30.917850501953303, 1.106855419926992],
            [30.91824153679986, 1.110286743494668],
            [30.919595244034095, 1.113759111026915],
            [30.920739607874545, 1.115433471241556],
            [30.921043892414104, 1.118240325891506],
            [30.9197412813532, 1.11843937080605],
            [30.918021631913263, 1.1200273359174],
            [30.91607429548137, 1.120093325225253],
            [30.914696423565978, 1.119676787734391],
            [30.912429933679935, 1.1213205044185],
            [30.909277248579613, 1.121610239131584],
            [30.906371650488094, 1.123541564246068],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 117,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "BURORA",
        Population: 13115,
        Key: "KAGADIBURORA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.80569878071354, 1.061374793011165],
            [30.805131084081527, 1.062266489973866],
            [30.80320141571468, 1.061296749990923],
            [30.800670165364973, 1.061541233047032],
            [30.798279797801253, 1.060638178624689],
            [30.79699006858153, 1.059349354511826],
            [30.796921295360008, 1.057942422440249],
            [30.798059830032557, 1.056853416806379],
            [30.798069612686014, 1.055994496734709],
            [30.79709786731396, 1.054774680155325],
            [30.793540412126386, 1.056169090580112],
            [30.792245015435547, 1.055182200962977],
            [30.791949459825577, 1.053326712515662],
            [30.790874779200045, 1.052850754990533],
            [30.788874801492508, 1.053314902563971],
            [30.787860364584894, 1.052826730011703],
            [30.787470711347233, 1.051679287142686],
            [30.786698235661383, 1.051435234429248],
            [30.786526754460187, 1.050629569514027],
            [30.785320782360905, 1.05055648049818],
            [30.785102610324508, 1.050214704719357],
            [30.785938414542937, 1.047748703622196],
            [30.78422976407533, 1.045173170161449],
            [30.783603109214578, 1.045270908565197],
            [30.78242597752751, 1.046613874521218],
            [30.782768614739812, 1.048127542448536],
            [30.78173648551266, 1.04956814934654],
            [30.78135593670042, 1.051155153639982],
            [30.780175873810585, 1.051619189195184],
            [30.7783901838242, 1.05125319004746],
            [30.776552211888273, 1.049666475910978],
            [30.775386849928076, 1.047298401337122],
            [30.773537429862174, 1.045894797819176],
            [30.775433020638722, 1.044848537088356],
            [30.776284730427594, 1.04354223532212],
            [30.776281966311462, 1.042712136452502],
            [30.77451601231187, 1.041027763891824],
            [30.77398624794103, 1.038971357759262],
            [30.772258260338596, 1.036486956056782],
            [30.770735480286415, 1.03541292173032],
            [30.77198624328404, 1.034460581739445],
            [30.772609142288594, 1.033239767018075],
            [30.772822993428484, 1.0322875700825],
            [30.772192847714546, 1.031335479743956],
            [30.771860828588903, 1.029394575621867],
            [30.7727514246498, 1.028906153267132],
            [30.773683471672825, 1.026391324437121],
            [30.773269292631316, 1.02512182213722],
            [30.77406351383524, 1.024657833888984],
            [30.77476306518465, 1.024730975597182],
            [30.77493031172763, 1.024267073516809],
            [30.77411722230947, 1.022692445130679],
            [30.774258732119534, 1.021740249542187],
            [30.77517465528153, 1.021618044195927],
            [30.775820025642908, 1.019908924788487],
            [30.776952896437585, 1.019762270205336],
            [30.77796324421405, 1.019029682495495],
            [30.77868184433908, 1.017589111144153],
            [30.77872557702204, 1.01624629101838],
            [30.780927643329143, 1.014939776338068],
            [30.78084949528932, 1.013206343392959],
            [30.782970561405573, 1.012913032713038],
            [30.78393267773611, 1.0121804389593],
            [30.78388083865601, 1.011106200688105],
            [30.785354483557114, 1.008310477626744],
            [30.78465033552839, 1.006870111683479],
            [30.78496095408901, 1.006015551344347],
            [30.785852935352064, 1.005942158621427],
            [30.78632906580887, 1.004110970444557],
            [30.786347434559787, 1.002401934324306],
            [30.7855598348378, 1.001242356928648],
            [30.78610994335488, 0.999899450119242],
            [30.786388651061646, 0.995574470827314],
            [30.78710438915416, 0.992902770532884],
            [30.786814178520157, 0.990797214947614],
            [30.787448372941075, 0.989765206645431],
            [30.788106196647217, 0.983419201543223],
            [30.7893567970498, 0.977802364740976],
            [30.790918685257882, 0.974268950974899],
            [30.796427086308153, 0.971205971149393],
            [30.797641237568076, 0.969800496227259],
            [30.803600060189986, 0.965289508184788],
            [30.805291864551094, 0.964328419259928],
            [30.806872662295913, 0.964477477156801],
            [30.808453033340975, 0.965292670704026],
            [30.809444666515105, 0.96688463904352],
            [30.809883630973633, 0.970326623361248],
            [30.811756021859686, 0.974398679484846],
            [30.813483555812883, 0.975065949422653],
            [30.814744928812356, 0.974081843678281],
            [30.820212570603225, 0.974232404708285],
            [30.823699321191413, 0.974965975120673],
            [30.82424096488354, 0.97997569920956],
            [30.828871424440326, 0.981569303394709],
            [30.835532476289533, 0.982019807938495],
            [30.83175783361908, 0.988903194141749],
            [30.833075776226945, 0.992232557231203],
            [30.833089593214297, 0.994621634087327],
            [30.83406215246003, 0.995227202212371],
            [30.834081147336722, 0.996096163181001],
            [30.833211211629035, 0.997746833519387],
            [30.831283504284457, 0.998186666397453],
            [30.830586228367654, 0.998797179239415],
            [30.829534321831204, 1.001507488322656],
            [30.82719658296674, 1.0019229683985],
            [30.825825577773365, 1.002973072968299],
            [30.822752835546805, 1.014277945724043],
            [30.822878308632422, 1.019319710695451],
            [30.82182479500993, 1.021566101084237],
            [30.821948157054635, 1.022396205475546],
            [30.823597060572727, 1.023547822891256],
            [30.824761622134016, 1.02564736020564],
            [30.822885987431476, 1.027234663923225],
            [30.82385483843172, 1.028504113290162],
            [30.823907481503998, 1.033363700895471],
            [30.819427520300035, 1.035035916334209],
            [30.816873052991774, 1.035549017623424],
            [30.81655146779818, 1.036733213137294],
            [30.81571063570909, 1.037685531787145],
            [30.816245812429486, 1.039077123278957],
            [30.81461090196858, 1.04054228841869],
            [30.814785912650567, 1.042397816772624],
            [30.813189325218, 1.044509975223141],
            [30.812495453916135, 1.046145891684391],
            [30.811925867228762, 1.052506147552734],
            [30.810486945806666, 1.054899028135093],
            [30.809617937160382, 1.058256235789606],
            [30.80903909782557, 1.058231900986599],
            [30.8074786918377, 1.060356220608975],
            [30.80646603000108, 1.060405182083855],
            [30.806395960510617, 1.061088816689191],
            [30.80569878071354, 1.061374793011165],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 118,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "RUTEETE",
        Population: 11824,
        Key: "KAGADIRUTEETE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.850094975528865, 0.944754269681476],
            [30.85017475850251, 0.946612475456524],
            [30.848280197195262, 0.950414265223066],
            [30.84609520965831, 0.952558970286074],
            [30.844392424291183, 0.955989980586941],
            [30.843356461952716, 0.962069453102835],
            [30.842166344219905, 0.965171436905575],
            [30.839422503964958, 0.970161774704331],
            [30.838026743897302, 0.976959796643158],
            [30.837357762217014, 0.977695415219544],
            [30.835532476289533, 0.982019807938495],
            [30.828871424440326, 0.981569303394709],
            [30.82424096488354, 0.97997569920956],
            [30.823699321191413, 0.974965975120673],
            [30.820212570603225, 0.974232404708285],
            [30.814744928812356, 0.974081843678281],
            [30.813483555812883, 0.975065949422653],
            [30.811756021859686, 0.974398679484846],
            [30.809883630973633, 0.970326623361248],
            [30.809444666515105, 0.96688463904352],
            [30.808453033340975, 0.965292670704026],
            [30.806872662295913, 0.964477477156801],
            [30.805291864551094, 0.964328419259928],
            [30.803600060189986, 0.965289508184788],
            [30.797641237568076, 0.969800496227259],
            [30.796427086308153, 0.971205971149393],
            [30.790918685257882, 0.974268950974899],
            [30.79297376023506, 0.967095732830825],
            [30.793137484483786, 0.962713031256175],
            [30.792657993429536, 0.957773201225893],
            [30.793000247959515, 0.957206594325734],
            [30.791935584447714, 0.955285261347566],
            [30.788568944002904, 0.9521857637636],
            [30.782269828771575, 0.947651683338868],
            [30.779935181908325, 0.945663277872082],
            [30.779473476598373, 0.942981450588682],
            [30.780048142360336, 0.94061330211649],
            [30.779395030317875, 0.939833497879368],
            [30.779194972809144, 0.938173383574035],
            [30.779999512960764, 0.932648940113065],
            [30.780580063586182, 0.930770118691602],
            [30.784471357886147, 0.928487744313642],
            [30.78581161644227, 0.926441261274219],
            [30.786094379144266, 0.924498031241515],
            [30.785954519539338, 0.923020145255778],
            [30.784029729922793, 0.920232515276861],
            [30.783847602787127, 0.917829668438789],
            [30.78295786012578, 0.916668395315861],
            [30.785340653095, 0.915617860967726],
            [30.788828834699437, 0.9166861473469],
            [30.791384188644862, 0.915025856915496],
            [30.794423256624658, 0.913919372247753],
            [30.79606075064032, 0.910745251542401],
            [30.799061627644146, 0.906792089906439],
            [30.800328807353633, 0.905122777854633],
            [30.80305061013801, 0.90305203177149],
            [30.808566231846548, 0.901427065031894],
            [30.81253669916407, 0.901577507031503],
            [30.81621235108347, 0.902912011690912],
            [30.81767052609706, 0.904414811331817],
            [30.818327818898883, 0.905263071801904],
            [30.820063222093985, 0.906127892241351],
            [30.81961771790019, 0.902837748204698],
            [30.82189841823568, 0.90067417050903],
            [30.825263094064976, 0.899491947536741],
            [30.828755627108617, 0.899697592369156],
            [30.833255720456428, 0.905769625115985],
            [30.838454947437036, 0.907996142212293],
            [30.838616682815747, 0.90990628964705],
            [30.839163227716075, 0.910243752209555],
            [30.839421300222483, 0.920483129972716],
            [30.84088938275533, 0.920607613216175],
            [30.84326883489001, 0.922440980386882],
            [30.845428955263248, 0.922192495458353],
            [30.847561096708617, 0.922619395910504],
            [30.848497730529488, 0.924091054853025],
            [30.848661631746342, 0.926644740806585],
            [30.84807330979544, 0.928122784262845],
            [30.847789671236033, 0.931227436437433],
            [30.848632479618765, 0.936621995917006],
            [30.84998310473326, 0.941198554651825],
            [30.850094975528865, 0.944754269681476],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 119,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KAGADI  TOWN COUNCIL",
        Population: 22894,
        Key: "KAGADIKAGADI  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.81767052609706, 0.904414811331817],
              [30.81621235108347, 0.902912011690912],
              [30.81253669916407, 0.901577507031503],
              [30.808566231846548, 0.901427065031894],
              [30.80305061013801, 0.90305203177149],
              [30.800328807353633, 0.905122777854633],
              [30.799061627644146, 0.906792089906439],
              [30.794238333033533, 0.903486058148662],
              [30.794032074454407, 0.902871424558156],
              [30.790745932940528, 0.899507481086803],
              [30.78999165442738, 0.898029881255628],
              [30.787834198457304, 0.896056656493534],
              [30.78544151773173, 0.894298410858428],
              [30.7833403430108, 0.893522710314784],
              [30.781759486875508, 0.892331437400942],
              [30.781501798848055, 0.894353372074634],
              [30.78093853989354, 0.89527165630067],
              [30.780363625298243, 0.897802824020325],
              [30.772057964776337, 0.904217186824277],
              [30.770772578911014, 0.902033003353973],
              [30.76937859211772, 0.897073268611635],
              [30.76702666256675, 0.895554554234414],
              [30.765356657622632, 0.891439101627728],
              [30.763896014936954, 0.890182550856066],
              [30.76026118246406, 0.888781167339785],
              [30.755811737030303, 0.888968508208577],
              [30.75215035844245, 0.887685865465044],
              [30.746997355173125, 0.886877431944167],
              [30.747024553464975, 0.885711692937059],
              [30.74873010384654, 0.88497202939328],
              [30.749396333088818, 0.88281141874576],
              [30.749615559747376, 0.880408514909932],
              [30.74805405511992, 0.880210744501035],
              [30.74742429657987, 0.878466675862843],
              [30.748712492375407, 0.873962281743813],
              [30.747219743003168, 0.871490598876351],
              [30.744830800167513, 0.870102587199934],
              [30.744536231806062, 0.868770571346926],
              [30.741619758709678, 0.865914881205434],
              [30.742566000910845, 0.864084176879897],
              [30.740417679908884, 0.861602747328314],
              [30.741422222771973, 0.861063570255666],
              [30.743785946304342, 0.858376477269217],
              [30.74584696453542, 0.857694677631047],
              [30.748028666035054, 0.858555271347289],
              [30.74908680687956, 0.859750635586335],
              [30.75086219049472, 0.860712091078941],
              [30.753014667103184, 0.860639723778711],
              [30.75694476143692, 0.859234633078464],
              [30.759724781339926, 0.860098731279247],
              [30.760761853996108, 0.859785793484503],
              [30.761699470573905, 0.858519658941293],
              [30.76107138290029, 0.856534809304613],
              [30.760877173424067, 0.853860575585793],
              [30.762361398682586, 0.850399163047659],
              [30.767620210916, 0.848459975460419],
              [30.773188099302658, 0.844015695935117],
              [30.77494995339133, 0.844087086286784],
              [30.776934781011583, 0.845495680172483],
              [30.779241829832678, 0.845848877232907],
              [30.780402585232093, 0.845610281044073],
              [30.783369074726867, 0.842065211858373],
              [30.783832587447176, 0.838420173052659],
              [30.7865188385059, 0.835860138177238],
              [30.787518407397258, 0.834252991075376],
              [30.78824696714384, 0.833856684687543],
              [30.78807692863695, 0.837511764442201],
              [30.788578345770656, 0.839215647490315],
              [30.790217375007153, 0.840545375051809],
              [30.791243016601335, 0.84212467480557],
              [30.795546686125746, 0.845801242069461],
              [30.798811099189535, 0.846779051295612],
              [30.79946604918509, 0.848358149112628],
              [30.80060616399423, 0.84921992517457],
              [30.806079519968602, 0.851949962887637],
              [30.81106911519621, 0.852957479043953],
              [30.813521433276858, 0.852958887446222],
              [30.81531752665253, 0.85362011878914],
              [30.816172467681504, 0.854539148617912],
              [30.81619351970018, 0.859049868601601],
              [30.818457165520012, 0.866695982155281],
              [30.818501320411176, 0.870432264113901],
              [30.81887700215118, 0.87161095291067],
              [30.821500103442077, 0.874649975208042],
              [30.82075506230498, 0.875614574243266],
              [30.818861019325652, 0.876779205324457],
              [30.818059423851558, 0.880164941216685],
              [30.81776501269526, 0.880673623152177],
              [30.816487169983404, 0.881153968319112],
              [30.815999609362926, 0.881893832025336],
              [30.81589312756074, 0.884227141722473],
              [30.81777951330057, 0.88729801496681],
              [30.817041293969773, 0.892265860253549],
              [30.816212898157467, 0.894282282673948],
              [30.814107439370982, 0.895942501767236],
              [30.812955872838575, 0.898560006267242],
              [30.81329620946545, 0.899498602334503],
              [30.814959183295812, 0.900535822793447],
              [30.81767052609706, 0.904414811331817],
            ],
          ],
          [
            [
              [30.772192847714546, 1.031335479743956],
              [30.770957366856543, 1.031507488229618],
              [30.76839215030762, 1.028773409062006],
              [30.767305134914913, 1.028212031804777],
              [30.767131291144512, 1.026698353451841],
              [30.76623850049938, 1.02652757430311],
              [30.764991860768898, 1.025099503473377],
              [30.765351366545595, 1.024440261682662],
              [30.76481792357371, 1.023561415825471],
              [30.762696217856952, 1.023659374946979],
              [30.762742976964134, 1.023219915565526],
              [30.7635377632084, 1.022926821357863],
              [30.762615318277412, 1.021095870920161],
              [30.76116677230538, 1.020583375371226],
              [30.760277975570002, 1.021608908883557],
              [30.759238718211048, 1.020901037510342],
              [30.759137935321018, 1.019607087462401],
              [30.75747090649546, 1.018655168495954],
              [30.757478102899203, 1.017202514744408],
              [30.755757460820842, 1.014639261558102],
              [30.751611286626982, 1.015054894444011],
              [30.75179431297624, 1.012100753760461],
              [30.75110058899806, 1.010159922457453],
              [30.751432220051495, 1.008377626175676],
              [30.751937703858527, 1.008108998739157],
              [30.751092750298888, 1.007816157345203],
              [30.749353554416672, 1.008508267692531],
              [30.748330331087246, 1.007365371601141],
              [30.749382994903485, 1.005945342658303],
              [30.749024316475143, 1.004329322737456],
              [30.749606524492236, 1.002853247983779],
              [30.750561386028547, 1.002028223175017],
              [30.750984191591755, 1.00060176904106],
              [30.75235523181942, 0.999576157041706],
              [30.752954301214395, 0.998453013274267],
              [30.75181678523136, 0.997208057160123],
              [30.751495051815745, 0.994748840614408],
              [30.750063484002553, 0.994073249384836],
              [30.749032731892715, 0.993063164890559],
              [30.748595543403518, 0.992000498796609],
              [30.74858412401961, 0.990720821062279],
              [30.749377791861356, 0.989125995237288],
              [30.749675171051333, 0.986504575366765],
              [30.75166830808797, 0.985592805408381],
              [30.75201762517269, 0.983910556989357],
              [30.75093358500024, 0.983282144208947],
              [30.751340862285417, 0.982381844067646],
              [30.750658952051566, 0.980984498785363],
              [30.749659089411093, 0.980710127929144],
              [30.74924058408316, 0.979078509488288],
              [30.750273869442076, 0.977755975309007],
              [30.751253691566873, 0.977924951650142],
              [30.752143627366035, 0.976928073657654],
              [30.752566410471346, 0.976928359280408],
              [30.753211431388085, 0.974440134332722],
              [30.75418618701465, 0.973663662870135],
              [30.75501519278305, 0.970916514456431],
              [30.75434099368759, 0.968899228722227],
              [30.754430719214778, 0.966985377941914],
              [30.756337795850587, 0.964552005204621],
              [30.759049515944245, 0.963952458378477],
              [30.758913415788797, 0.961260164376328],
              [30.760394491553924, 0.959216548780149],
              [30.761497283159628, 0.959402308713718],
              [30.764485095964307, 0.95824783251501],
              [30.766169516173775, 0.954437280558002],
              [30.766142960177348, 0.952864489988697],
              [30.766814484988213, 0.951958271676001],
              [30.76726614892991, 0.949932464384336],
              [30.768121610083394, 0.94884133180324],
              [30.768895794364926, 0.94550200014211],
              [30.77078966486771, 0.944670581430444],
              [30.772222728375873, 0.945809461463025],
              [30.77442831518056, 0.946199460387867],
              [30.775925424076885, 0.94780096920243],
              [30.776697420960687, 0.947875483241204],
              [30.778424437484286, 0.949273606487846],
              [30.77906773902555, 0.949385044268619],
              [30.78135701557707, 0.948276324012324],
              [30.781734285538537, 0.947591942764414],
              [30.782269828771575, 0.947651683338868],
              [30.788568944002904, 0.9521857637636],
              [30.791935584447714, 0.955285261347566],
              [30.793000247959515, 0.957206594325734],
              [30.792657993429536, 0.957773201225893],
              [30.793137484483786, 0.962713031256175],
              [30.79297376023506, 0.967095732830825],
              [30.790918685257882, 0.974268950974899],
              [30.7893567970498, 0.977802364740976],
              [30.788106196647217, 0.983419201543223],
              [30.787448372941075, 0.989765206645431],
              [30.786814178520157, 0.990797214947614],
              [30.78710438915416, 0.992902770532884],
              [30.786388651061646, 0.995574470827314],
              [30.78610994335488, 0.999899450119242],
              [30.7855598348378, 1.001242356928648],
              [30.786347434559787, 1.002401934324306],
              [30.78632906580887, 1.004110970444557],
              [30.785852935352064, 1.005942158621427],
              [30.78496095408901, 1.006015551344347],
              [30.78465033552839, 1.006870111683479],
              [30.785354483557114, 1.008310477626744],
              [30.78388083865601, 1.011106200688105],
              [30.78393267773611, 1.0121804389593],
              [30.782970561405573, 1.012913032713038],
              [30.78084949528932, 1.013206343392959],
              [30.780927643329143, 1.014939776338068],
              [30.77872557702204, 1.01624629101838],
              [30.77868184433908, 1.017589111144153],
              [30.77796324421405, 1.019029682495495],
              [30.776952896437585, 1.019762270205336],
              [30.775820025642908, 1.019908924788487],
              [30.77517465528153, 1.021618044195927],
              [30.774258732119534, 1.021740249542187],
              [30.77411722230947, 1.022692445130679],
              [30.77493031172763, 1.024267073516809],
              [30.77476306518465, 1.024730975597182],
              [30.77406351383524, 1.024657833888984],
              [30.773269292631316, 1.02512182213722],
              [30.773683471672825, 1.026391324437121],
              [30.7727514246498, 1.028906153267132],
              [30.771860828588903, 1.029394575621867],
              [30.772192847714546, 1.031335479743956],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 120,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "MUHORRO",
        Population: 14509,
        Key: "KAGADIMUHORRO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.782269828771575, 0.947651683338868],
            [30.781734285538537, 0.947591942764414],
            [30.78135701557707, 0.948276324012324],
            [30.77906773902555, 0.949385044268619],
            [30.778424437484286, 0.949273606487846],
            [30.776697420960687, 0.947875483241204],
            [30.775925424076885, 0.94780096920243],
            [30.77442831518056, 0.946199460387867],
            [30.772222728375873, 0.945809461463025],
            [30.77078966486771, 0.944670581430444],
            [30.768895794364926, 0.94550200014211],
            [30.768121610083394, 0.94884133180324],
            [30.76726614892991, 0.949932464384336],
            [30.766814484988213, 0.951958271676001],
            [30.766142960177348, 0.952864489988697],
            [30.766169516173775, 0.954437280558002],
            [30.764485095964307, 0.95824783251501],
            [30.761497283159628, 0.959402308713718],
            [30.760394491553924, 0.959216548780149],
            [30.758913415788797, 0.961260164376328],
            [30.759049515944245, 0.963952458378477],
            [30.756337795850587, 0.964552005204621],
            [30.75590373439685, 0.963234863453315],
            [30.755937809292213, 0.960325275390155],
            [30.755556782576253, 0.959719047089479],
            [30.755976323661706, 0.957646979512434],
            [30.75536099745502, 0.956934204747225],
            [30.7529361229063, 0.954601217413261],
            [30.751851081112278, 0.955396131277638],
            [30.751014706463657, 0.955404830251637],
            [30.75002138535508, 0.954779436388845],
            [30.74872012536038, 0.955407033512668],
            [30.748253848523934, 0.95640650999989],
            [30.74705186853782, 0.957507235546181],
            [30.746824472600057, 0.95599244881372],
            [30.744373240582604, 0.955563647375724],
            [30.74388894174492, 0.954548807092774],
            [30.7406433870139, 0.951650356416662],
            [30.739744375535434, 0.949430474817924],
            [30.737662917038367, 0.947837156474919],
            [30.737238446896935, 0.945542027213491],
            [30.736044130438493, 0.944841517469912],
            [30.733694539202194, 0.942492173948995],
            [30.732968197396048, 0.940981786281462],
            [30.733010093024276, 0.939026208712216],
            [30.73468891762786, 0.938110893462417],
            [30.737297631501143, 0.933946281998671],
            [30.741281214221818, 0.931270598378376],
            [30.738788250069536, 0.92204754501053],
            [30.74121347136793, 0.919324051115616],
            [30.742997111398846, 0.918307529683308],
            [30.748161046266887, 0.916859643715314],
            [30.74565417888893, 0.916801232853056],
            [30.744423156369653, 0.915949314931062],
            [30.737309146106437, 0.916592385113099],
            [30.734157120369552, 0.915699000814574],
            [30.733778405917114, 0.913386052785591],
            [30.732431056958433, 0.911261060954494],
            [30.73171937296279, 0.908527659780072],
            [30.72789638206546, 0.909638625438682],
            [30.720577108556437, 0.908760695677946],
            [30.71970942312858, 0.909005748608486],
            [30.717270574387314, 0.907284949907109],
            [30.715103432781802, 0.904609195111025],
            [30.714426617792224, 0.903107841658482],
            [30.713030956539278, 0.902288271114018],
            [30.712380919430014, 0.901356434751069],
            [30.70487088058557, 0.90114129509584],
            [30.70306967489758, 0.899000526301438],
            [30.701989360936917, 0.896438685698194],
            [30.700959469413135, 0.895523481711389],
            [30.70059267919777, 0.894365461925328],
            [30.701391313824704, 0.893339379269645],
            [30.701676776862442, 0.890729981852074],
            [30.70452434019338, 0.884567638106409],
            [30.706339032288692, 0.884704942704806],
            [30.70796067283624, 0.882723640405836],
            [30.712825142626215, 0.882017223467511],
            [30.71381788162648, 0.881439700284896],
            [30.714986514352642, 0.881927087310578],
            [30.719696305030464, 0.879871154909846],
            [30.721845907928348, 0.879792963089366],
            [30.724721205845373, 0.877184386983133],
            [30.72599254475458, 0.878524045414197],
            [30.72727294676671, 0.878228370043132],
            [30.727592990451278, 0.876827275732619],
            [30.729052163493144, 0.875273952190891],
            [30.72891588187802, 0.873331801495836],
            [30.727920634781494, 0.872309647197256],
            [30.728197216175996, 0.871359239053898],
            [30.728527058683714, 0.871048231546602],
            [30.729764205916595, 0.871226916344236],
            [30.7310075272704, 0.872092834282843],
            [30.73297074591651, 0.871103832633015],
            [30.734805480324162, 0.871680133147612],
            [30.73668697114405, 0.869530576303961],
            [30.736628999265488, 0.868369811578288],
            [30.73574097777621, 0.867382263158681],
            [30.736458246597977, 0.866558296055136],
            [30.736114967090252, 0.865376351457592],
            [30.737633375041952, 0.865125953067564],
            [30.737787311247338, 0.863750018227446],
            [30.73874370081795, 0.861774510038636],
            [30.740417679908884, 0.861602747328314],
            [30.742566000910845, 0.864084176879897],
            [30.741619758709678, 0.865914881205434],
            [30.744536231806062, 0.868770571346926],
            [30.744830800167513, 0.870102587199934],
            [30.747219743003168, 0.871490598876351],
            [30.748712492375407, 0.873962281743813],
            [30.74742429657987, 0.878466675862843],
            [30.74805405511992, 0.880210744501035],
            [30.749615559747376, 0.880408514909932],
            [30.749396333088818, 0.88281141874576],
            [30.74873010384654, 0.88497202939328],
            [30.747024553464975, 0.885711692937059],
            [30.746997355173125, 0.886877431944167],
            [30.75215035844245, 0.887685865465044],
            [30.755811737030303, 0.888968508208577],
            [30.76026118246406, 0.888781167339785],
            [30.763896014936954, 0.890182550856066],
            [30.765356657622632, 0.891439101627728],
            [30.76702666256675, 0.895554554234414],
            [30.76937859211772, 0.897073268611635],
            [30.770772578911014, 0.902033003353973],
            [30.772057964776337, 0.904217186824277],
            [30.780363625298243, 0.897802824020325],
            [30.78093853989354, 0.89527165630067],
            [30.781501798848055, 0.894353372074634],
            [30.781759486875508, 0.892331437400942],
            [30.7833403430108, 0.893522710314784],
            [30.78544151773173, 0.894298410858428],
            [30.787834198457304, 0.896056656493534],
            [30.78999165442738, 0.898029881255628],
            [30.790745932940528, 0.899507481086803],
            [30.794032074454407, 0.902871424558156],
            [30.794238333033533, 0.903486058148662],
            [30.799061627644146, 0.906792089906439],
            [30.79606075064032, 0.910745251542401],
            [30.794423256624658, 0.913919372247753],
            [30.791384188644862, 0.915025856915496],
            [30.788828834699437, 0.9166861473469],
            [30.785340653095, 0.915617860967726],
            [30.78295786012578, 0.916668395315861],
            [30.783847602787127, 0.917829668438789],
            [30.784029729922793, 0.920232515276861],
            [30.785954519539338, 0.923020145255778],
            [30.786094379144266, 0.924498031241515],
            [30.78581161644227, 0.926441261274219],
            [30.784471357886147, 0.928487744313642],
            [30.780580063586182, 0.930770118691602],
            [30.779999512960764, 0.932648940113065],
            [30.779194972809144, 0.938173383574035],
            [30.779395030317875, 0.939833497879368],
            [30.780048142360336, 0.94061330211649],
            [30.779473476598373, 0.942981450588682],
            [30.779935181908325, 0.945663277872082],
            [30.782269828771575, 0.947651683338868],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 121,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "MUHORRO  TOWN COUNCIL",
        Population: 22392,
        Key: "KAGADIMUHORRO  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.23879139869481, 0.768055118793846],
            [31.238043382337494, 0.770479105602292],
            [31.237028462136237, 0.771147976443035],
            [31.23193997856554, 0.768068872561636],
            [31.230152924038226, 0.767397232878818],
            [31.227240323579068, 0.766980577705255],
            [31.22297317146926, 0.76776016549686],
            [31.220883783543186, 0.765655132350209],
            [31.218915006122106, 0.76492242846187],
            [31.216173563470647, 0.764631577189724],
            [31.214568439347932, 0.763594075780725],
            [31.212690334278378, 0.763379824150817],
            [31.211025107473258, 0.761183496640645],
            [31.209239372571115, 0.757370898974672],
            [31.207967382383313, 0.756577504298591],
            [31.200723650003177, 0.75807176075895],
            [31.194955075287055, 0.759899008174895],
            [31.191683565532532, 0.759556087599046],
            [31.184618982372847, 0.760175178993944],
            [31.182996191981776, 0.758003291770926],
            [31.18285138715122, 0.756563897804978],
            [31.181118987922446, 0.755721520313659],
            [31.179689859933564, 0.754062025974045],
            [31.17925417073256, 0.752793278811895],
            [31.17620214275813, 0.749230265525132],
            [31.175681630136427, 0.747973683604227],
            [31.175367716555346, 0.745241271052061],
            [31.174423180254905, 0.74380154772133],
            [31.17378621902293, 0.739500994541347],
            [31.174075159439095, 0.73782949986861],
            [31.17324883424354, 0.730792792660116],
            [31.17341194584124, 0.727102521098704],
            [31.166414583614287, 0.717917682102198],
            [31.165443601810228, 0.719105379802765],
            [31.164290350038367, 0.719385109310203],
            [31.160113900822793, 0.7225856610506],
            [31.160550473067723, 0.724627275437337],
            [31.159356222186297, 0.727949121288036],
            [31.15693036218573, 0.72866862537626],
            [31.154067630801237, 0.728107047636476],
            [31.153551979861856, 0.724984650559226],
            [31.152419500732613, 0.723082854262621],
            [31.148881877651558, 0.719879165304222],
            [31.150993535711848, 0.709392711562852],
            [31.15130591586875, 0.705095860637647],
            [31.150508481391043, 0.699855931389748],
            [31.147344732639667, 0.695715551175568],
            [31.146431943699675, 0.69334997934494],
            [31.14220532177889, 0.695138632716077],
            [31.13943144006421, 0.695433178490657],
            [31.137375087682695, 0.696713505776431],
            [31.135090567710606, 0.69733674134204],
            [31.13381798193976, 0.697139132002034],
            [31.131922424400866, 0.695350838688349],
            [31.135910770887513, 0.689345865185017],
            [31.136482157798703, 0.686810038432523],
            [31.138241498401197, 0.685231679569891],
            [31.14161654348379, 0.684754503441855],
            [31.146656330281264, 0.681502654494713],
            [31.14568877554996, 0.679155269721149],
            [31.144810867294172, 0.671220688274894],
            [31.147301506606496, 0.660805055286015],
            [31.15340245977437, 0.660599095167246],
            [31.1586481961305, 0.659506904294461],
            [31.160919929482837, 0.658883811172411],
            [31.164305685178583, 0.657058453373317],
            [31.16925828059625, 0.655477820405247],
            [31.178560056885576, 0.653528026741804],
            [31.17949539174255, 0.652711674682874],
            [31.185114920681652, 0.649957486839299],
            [31.188067943532, 0.646757291730114],
            [31.18944485604666, 0.645777711586219],
            [31.19311700094319, 0.644175123442692],
            [31.203948821960385, 0.640605960276601],
            [31.208819703924878, 0.638482603689391],
            [31.21077373280561, 0.636973127768841],
            [31.215540950982952, 0.631838417257736],
            [31.22295262699871, 0.63461717599345],
            [31.22835645157348, 0.638742654301721],
            [31.235100841928205, 0.640915327001688],
            [31.236673950992532, 0.641874435860903],
            [31.237384760927366, 0.642616212628688],
            [31.242412828303642, 0.652158391460217],
            [31.248370823577186, 0.660371615530137],
            [31.251820758510103, 0.664017214260237],
            [31.253659374538085, 0.666766977620414],
            [31.256081952992922, 0.671732521257471],
            [31.26252761398981, 0.679285804623821],
            [31.26407602746863, 0.680832820940487],
            [31.265262661534763, 0.680833252999652],
            [31.266261103040463, 0.680345284836086],
            [31.270168832018562, 0.680346703175938],
            [31.272393043594047, 0.681125224369556],
            [31.273262626263804, 0.682228810128111],
            [31.273460988651575, 0.691109312478655],
            [31.273974929198683, 0.695947618305921],
            [31.27660358567126, 0.700813843906894],
            [31.27864381509004, 0.703428096323354],
            [31.281069356188706, 0.705644594468733],
            [31.282057778784015, 0.708014294721011],
            [31.284539360383373, 0.707481671226215],
            [31.286525663935624, 0.708667081989572],
            [31.289523031221663, 0.714012782283343],
            [31.289963076353466, 0.719158585520898],
            [31.28809152718886, 0.723896545355647],
            [31.287910064806525, 0.727161098215861],
            [31.286774291555115, 0.733527128257653],
            [31.287297557513195, 0.736602040171586],
            [31.28859358392304, 0.739807851437666],
            [31.281793598632003, 0.742698711470875],
            [31.275611708155346, 0.745565601895967],
            [31.267523940293838, 0.75113863653732],
            [31.26574285417328, 0.751173508834532],
            [31.263247904744176, 0.754472192629766],
            [31.259503219990165, 0.757362294764303],
            [31.25518800621602, 0.76190939613125],
            [31.254359044465115, 0.762247620543314],
            [31.250738512273216, 0.760603628667697],
            [31.24635585029264, 0.761425324223924],
            [31.241610462973327, 0.764557796142257],
            [31.239606067351232, 0.76637387754262],
            [31.23879139869481, 0.768055118793846],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 122,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "NYAMARWA",
        Population: 20010,
        Key: "KIBAALENYAMARWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.12440956125318, 0.997163698782215],
            [31.123194248471613, 0.999264523189663],
            [31.121411159107954, 1.000325979789225],
            [31.121855732647123, 1.003325736116962],
            [31.12067725258881, 1.006435589094106],
            [31.12096651100862, 1.008498758701821],
            [31.119919732055806, 1.010275285036903],
            [31.117704208985746, 1.00854672130686],
            [31.116521499659097, 1.006546085484353],
            [31.115496426698485, 1.006376491761254],
            [31.113638610079644, 1.004739923556669],
            [31.113327102186858, 1.003954708241882],
            [31.110702352487454, 1.002383116600985],
            [31.107894788441172, 1.002276809171422],
            [31.104943939513834, 1.002706853999719],
            [31.101399884495365, 1.002458859935139],
            [31.099826496055005, 1.001617322024104],
            [31.094751669571583, 1.001429598320942],
            [31.092723969854386, 1.000680171024092],
            [31.086041677340276, 1.003082597647483],
            [31.084398965011147, 1.003123196173914],
            [31.08245850787769, 1.003794170707195],
            [31.074742475457168, 0.999494326684588],
            [31.06765002296413, 0.990243421662531],
            [31.060685877741417, 0.98769814783434],
            [31.054307222979894, 0.978447758724627],
            [31.04548008863892, 0.974903599748559],
            [31.035505825443067, 0.974622545896559],
            [31.035491501805883, 0.970738426561409],
            [31.034900076175642, 0.968354733442585],
            [31.045184833066287, 0.964785596050036],
            [31.051213412564973, 0.961534554775129],
            [31.04934495989313, 0.957366378716966],
            [31.048537506505063, 0.956265422290611],
            [31.046114174363694, 0.954685063505391],
            [31.045306830570105, 0.953392719703377],
            [31.051630612640793, 0.950238397487743],
            [31.06121169491488, 0.946190647320197],
            [31.063790778756836, 0.945551175308799],
            [31.060196801663107, 0.939236040447179],
            [31.05421465069157, 0.933784839357844],
            [31.052545925846722, 0.928960970326041],
            [31.04901528447208, 0.923254809543708],
            [31.04703038588492, 0.914392993607404],
            [31.046435186432173, 0.909224676413957],
            [31.05455343592792, 0.903500457250578],
            [31.055272006408515, 0.902802215263727],
            [31.058730185180792, 0.895327740259305],
            [31.063652547797577, 0.892157797045074],
            [31.06631557650786, 0.889958201229362],
            [31.063797576308605, 0.887516620718055],
            [31.061581755896178, 0.885999862288469],
            [31.060945757658185, 0.884649031938815],
            [31.06017652039894, 0.874823840934769],
            [31.060721245312475, 0.873439688303905],
            [31.060979372616107, 0.870314894799258],
            [31.062365793798076, 0.867760785991144],
            [31.064784217544737, 0.864418029212305],
            [31.068425484649964, 0.861216492057516],
            [31.071443217641804, 0.863763875860787],
            [31.074982605912382, 0.865618799749907],
            [31.076218199958124, 0.866642482821314],
            [31.077501628394433, 0.86848481506273],
            [31.077160098804885, 0.870510021395105],
            [31.07829905388901, 0.874147085014552],
            [31.085517324420746, 0.887548414569276],
            [31.088839404834168, 0.897789766814173],
            [31.10110361023319, 0.89717418375874],
            [31.105096347684913, 0.897511218162108],
            [31.10904109084599, 0.898757360722192],
            [31.111132698509127, 0.898614906341559],
            [31.112511531621877, 0.897993584793576],
            [31.11369980601171, 0.898185602145562],
            [31.121111779369844, 0.904984097973125],
            [31.12239537938437, 0.904697671730101],
            [31.125295895706348, 0.903024447037297],
            [31.12624731489851, 0.901637300476089],
            [31.126818867099704, 0.89943650945105],
            [31.12620152237857, 0.895305164759467],
            [31.12943360507529, 0.898863666847641],
            [31.133424872883232, 0.902215223783177],
            [31.13361433027161, 0.903555120124697],
            [31.13798589356688, 0.906906887405805],
            [31.13964861317403, 0.908917454429773],
            [31.140930087774592, 0.912793980102071],
            [31.144117310402656, 0.916285676630772],
            [31.143578446996308, 0.917485636255166],
            [31.141466599391507, 0.918848380716282],
            [31.139011532466103, 0.921308811314872],
            [31.133447349629975, 0.925085766382377],
            [31.132712702899024, 0.926541810929755],
            [31.133297109991947, 0.929355392952153],
            [31.132728298550667, 0.930429563783122],
            [31.131660374154407, 0.930979756909567],
            [31.13208827765684, 0.931527692782204],
            [31.132089736520857, 0.9330541793031],
            [31.130856516722414, 0.934558674634259],
            [31.13097693947949, 0.936347345759968],
            [31.130467412355383, 0.937349869926122],
            [31.130135527977036, 0.937898950003655],
            [31.129257341243516, 0.938234190467413],
            [31.128188258020497, 0.937567960664823],
            [31.127595968210976, 0.938928377350441],
            [31.125756722463965, 0.93983749125183],
            [31.12521148730731, 0.940744656733343],
            [31.123763147947773, 0.940746831261503],
            [31.122576979208972, 0.941798067713934],
            [31.122744581484767, 0.943276593408077],
            [31.120765063806154, 0.946499475629389],
            [31.12055346653931, 0.948717955235031],
            [31.119628333849004, 0.949625686055276],
            [31.120009529448257, 0.951008484548229],
            [31.11883477470344, 0.951582668713887],
            [31.11821830314476, 0.952489933518002],
            [31.119051379179673, 0.954683000361625],
            [31.118601174102, 0.955661572577812],
            [31.11886340131658, 0.956782186086914],
            [31.121274021398357, 0.957494130956305],
            [31.12158322062084, 0.958066099103234],
            [31.122699472582784, 0.958398352031845],
            [31.123079993547247, 0.959065620623098],
            [31.12281966626949, 0.95997235531521],
            [31.12334472346821, 0.962857574928672],
            [31.122918346203445, 0.963931515325293],
            [31.121625021027643, 0.964672826756887],
            [31.121298407963398, 0.965802779360332],
            [31.122399420006513, 0.967605379548131],
            [31.122590768348584, 0.969107723929757],
            [31.12214022101278, 0.96972852453383],
            [31.120478957574694, 0.970565781666563],
            [31.120289653798253, 0.971257747094325],
            [31.121097838414954, 0.972234449915817],
            [31.123211451209293, 0.972708341776031],
            [31.12353291962193, 0.973709616738557],
            [31.123082680408267, 0.974664334866616],
            [31.12339229824566, 0.975689479413544],
            [31.122632926284865, 0.976143777782111],
            [31.12210481571248, 0.982751351245005],
            [31.120942637381628, 0.98411258704434],
            [31.1222412329732, 0.98907172801331],
            [31.120939325293193, 0.99341456715872],
            [31.12185400069525, 0.994009503747361],
            [31.12183108826562, 0.994915883209693],
            [31.123271187379046, 0.996239915015671],
            [31.12526269846504, 0.996319923047604],
            [31.12440956125318, 0.997163698782215],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 123,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "KASIMBI",
        Population: 10040,
        Key: "KIBAALEKASIMBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.10814344480677, 0.791634214544019],
            [31.10742355020943, 0.791466631855058],
            [31.10557068151113, 0.789408262815464],
            [31.10290948805895, 0.787923715574465],
            [31.099676920272, 0.788592112971718],
            [31.096492240774488, 0.788494945122282],
            [31.0953037157547, 0.788925035694174],
            [31.089243144553777, 0.787984797033845],
            [31.08939657321107, 0.791458280116433],
            [31.090584437070827, 0.792463656686221],
            [31.092461195565765, 0.792898168829652],
            [31.096968397282414, 0.796614791058965],
            [31.097943284961353, 0.798044308828808],
            [31.097955790408445, 0.798664411362462],
            [31.096865826744956, 0.800788861083288],
            [31.09457766140945, 0.803436974261324],
            [31.090965344310845, 0.802818615010188],
            [31.088000540953892, 0.80330338365719],
            [31.089014354430724, 0.806047286560183],
            [31.090091363489467, 0.807684545451625],
            [31.08827931333938, 0.808744688261767],
            [31.08744397354995, 0.808774445584022],
            [31.08567194244743, 0.807390878524651],
            [31.079874054805288, 0.804971769000215],
            [31.077213754278482, 0.801692889284223],
            [31.07350757041924, 0.798772385553902],
            [31.066450219595918, 0.796146363992525],
            [31.064572546616, 0.796456485475766],
            [31.062528813767603, 0.796120580341568],
            [31.061721011833228, 0.795593868956683],
            [31.05977335290614, 0.793750419449837],
            [31.058976270568028, 0.793486512551082],
            [31.05665780954954, 0.789470337695433],
            [31.056828486758604, 0.78871802687916],
            [31.055492251756615, 0.787596032149951],
            [31.055269995978907, 0.786305993429513],
            [31.052525098406882, 0.78751744237734],
            [31.050205306085132, 0.78721020534173],
            [31.05119499081343, 0.785830185334914],
            [31.051005431915446, 0.78460998173776],
            [31.052313687989574, 0.782170366614834],
            [31.052456814767183, 0.781022089662376],
            [31.05552716567847, 0.779616316200774],
            [31.05606370514316, 0.777406901726851],
            [31.059657456759783, 0.774419927877887],
            [31.061171943565252, 0.769599750532053],
            [31.06236839621743, 0.767188960089452],
            [31.06822420004257, 0.764065350284221],
            [31.069374449644766, 0.762741313360645],
            [31.073652456098134, 0.762885503539995],
            [31.07477128263169, 0.761723354414203],
            [31.07871833536133, 0.759530777993362],
            [31.081136642327007, 0.756330928363413],
            [31.081990888958245, 0.755900250638776],
            [31.083762415207538, 0.755902170171476],
            [31.08784061568049, 0.753504222255113],
            [31.08925603717476, 0.751968550965888],
            [31.0906375436738, 0.7515654630883],
            [31.09188520928034, 0.751543586501685],
            [31.094224104276563, 0.752598724104076],
            [31.098375763583533, 0.756270113225643],
            [31.10190650287456, 0.75749275737061],
            [31.10386105008322, 0.759729113965394],
            [31.104576649835177, 0.762924005513],
            [31.105824794243766, 0.764543880680878],
            [31.105436337562075, 0.767692837421009],
            [31.10577197779662, 0.770816786804325],
            [31.107220909145944, 0.77145845547803],
            [31.10742413052112, 0.772817641174748],
            [31.109778160333242, 0.776248445599678],
            [31.11079998588409, 0.777129309221589],
            [31.10986697047719, 0.78175790673734],
            [31.108348735900325, 0.78297672249971],
            [31.107152746778816, 0.789058827069518],
            [31.10814344480677, 0.791634214544019],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 124,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "KIBAALE TOWN COUNCIL",
        Population: 6650,
        Key: "KIBAALEKIBAALE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.24694993679315, 0.247803457448027],
            [32.23826870682065, 0.248639717349344],
            [32.23674701552658, 0.249429503296957],
            [32.23432174482081, 0.252062284773732],
            [32.23120707911828, 0.252851981582497],
            [32.22724848663045, 0.252002025469132],
            [32.22432419369954, 0.250278479524947],
            [32.22282641106676, 0.248937998330823],
            [32.221827927340264, 0.247334256483827],
            [32.222156249000186, 0.247103555995051],
            [32.22119715550058, 0.243642766116122],
            [32.22034949441869, 0.242397406907458],
            [32.21954560015579, 0.238993822737522],
            [32.21747535892168, 0.234125228059289],
            [32.21644786949297, 0.229029328300481],
            [32.21400667974206, 0.22302758775939],
            [32.21374850303109, 0.22141872527155],
            [32.21327423029032, 0.217773646437859],
            [32.213432919481875, 0.216242213119229],
            [32.21415334228862, 0.21310282445986],
            [32.216911564571255, 0.206212764515842],
            [32.21310401391703, 0.203739810890553],
            [32.20796892485106, 0.201496105530223],
            [32.20772587487118, 0.201072561470551],
            [32.20832337850262, 0.199476001757891],
            [32.21065414374555, 0.196824899664326],
            [32.210288197946554, 0.194221643841535],
            [32.20832937655377, 0.191568511635441],
            [32.20167477730325, 0.190602190275219],
            [32.20089127569559, 0.190660069306947],
            [32.19864913464537, 0.19187550197857],
            [32.19805391363306, 0.191788599445077],
            [32.19685008401575, 0.189864174438258],
            [32.199697267359284, 0.187415824909919],
            [32.200784360905445, 0.185077711224625],
            [32.20566560224176, 0.185818725824389],
            [32.207873999875005, 0.183821289961366],
            [32.20777410092719, 0.175998207948718],
            [32.208188535988576, 0.168440918627654],
            [32.20659207342184, 0.161598086930148],
            [32.20388808692446, 0.157354468255346],
            [32.202271266736766, 0.15170928061024],
            [32.20123677044883, 0.143282217352027],
            [32.19742100380299, 0.137583428310835],
            [32.19526636584794, 0.131696477286918],
            [32.19486693265181, 0.128334956012967],
            [32.19485756052843, 0.118305626876046],
            [32.193908014323675, 0.111880965286295],
            [32.19248658579509, 0.105723426665724],
            [32.19036990974565, 0.10095038798326],
            [32.18828285204941, 0.097564005853766],
            [32.184559241771936, 0.093500043039761],
            [32.1786887972043, 0.089737455181612],
            [32.174610803343874, 0.087693614290582],
            [32.173156557561356, 0.087333693013733],
            [32.16965835345331, 0.087836476795874],
            [32.16931937058756, 0.087931734036529],
            [32.16038937016343, 0.077193488212196],
            [32.15578145921858, 0.070888080160384],
            [32.153822055717484, 0.06727855046349],
            [32.15216002242321, 0.063669029482748],
            [32.14821739928622, 0.05269573038114],
            [32.14459543158653, 0.040799753787938],
            [32.14451321956837, 0.035308631248744],
            [32.146457627492424, 0.021983389633915],
            [32.146530939002744, 0.018428188541041],
            [32.14432242279189, 0.013914052909665],
            [32.14011738738738, 0.009354682526417],
            [32.13824302200434, 0.005898980440545],
            [32.14239950616269, 0.000154573110925],
            [32.14353367502297, -0.002206521052063],
            [32.14347301718173, -0.007127725722582],
            [32.14419103340182, -0.011831815625919],
            [32.144899779008156, -0.013270189041175],
            [32.1484070336427, -0.017006336075672],
            [32.15179409908211, -0.01833616422975],
            [32.15695869151696, -0.018752320441409],
            [32.168164564730255, -0.018345272247955],
            [32.1762535084865, -0.018851916651608],
            [32.18626824437918, -0.020136542467803],
            [32.194996604463064, -0.022669582084624],
            [32.19737422044132, -0.022886712956493],
            [32.20279975010999, -0.022380133244363],
            [32.21456850318876, -0.019865267438216],
            [32.2251632183783, -0.016490958246131],
            [32.22724280568461, -0.0163617984799],
            [32.224633625585696, -0.009440844435727],
            [32.22301200300446, -0.003077266140864],
            [32.21649468249905, 0.002640105499952],
            [32.21382340905107, 0.006079812204572],
            [32.21273641970951, 0.008417981343169],
            [32.21196996902425, 0.01258942597326],
            [32.21297587103838, 0.026185727025424],
            [32.21382877019668, 0.030620019131025],
            [32.21731506713563, 0.036560248298058],
            [32.221585254652794, 0.040616876605158],
            [32.22157575676528, 0.041731392734179],
            [32.22060269266638, 0.04368866578584],
            [32.221540196056445, 0.046379120128807],
            [32.22308171676211, 0.047057948915574],
            [32.22827370421984, 0.04793690789824],
            [32.23069314306275, 0.051070327457339],
            [32.23339503019732, 0.051650220282993],
            [32.23498964043794, 0.053691709175382],
            [32.23677636169027, 0.054960030073427],
            [32.23863395103537, 0.055267127096057],
            [32.24073895976595, 0.054480234709111],
            [32.24320655100304, 0.055099266183288],
            [32.247315470265406, 0.058624596777988],
            [32.25371703476164, 0.062338270517019],
            [32.259509858600545, 0.067776820452698],
            [32.264314405371174, 0.073596810303988],
            [32.26743347551357, 0.078222620611332],
            [32.271610866163535, 0.086456710132939],
            [32.27274325725787, 0.092013297260251],
            [32.27320574140717, 0.099125861218345],
            [32.27311537538119, 0.09874469583175],
            [32.27025826295877, 0.114576198726185],
            [32.267968000057074, 0.122736177224641],
            [32.267779488594705, 0.12586630454989],
            [32.269458072449765, 0.130172536099108],
            [32.276098413640085, 0.142268068359079],
            [32.280180638565504, 0.150627287870988],
            [32.28460742579285, 0.158588481067427],
            [32.29150893149078, 0.16974325003089],
            [32.29233049920862, 0.172457273879553],
            [32.29225996528912, 0.173750945290669],
            [32.29063462008937, 0.180499682679958],
            [32.28970812824806, 0.182480860387255],
            [32.28823488579219, 0.184371553741474],
            [32.28373073385596, 0.187827185527491],
            [32.27801581012185, 0.195218041315677],
            [32.27572331400837, 0.199506036747357],
            [32.27376514119922, 0.206707059291804],
            [32.27179337059162, 0.21008135441921],
            [32.268216966341434, 0.214676856804176],
            [32.26466390122064, 0.218367698930809],
            [32.250522747782206, 0.231846376433111],
            [32.249968324656834, 0.233682797993922],
            [32.24554252108469, 0.241625438469738],
            [32.24302881932408, 0.243905024194669],
            [32.24162660665773, 0.245777583934349],
            [32.24135807596478, 0.247080271879409],
            [32.24187077324354, 0.248292537027903],
            [32.24694993679315, 0.247803457448027],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1660,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "KAMMENGO",
        Population: 38923,
        Key: "MPIGIKAMMENGO",
        Dist2: "Mpigi",
        "Sub Country": "Kammengo",
        id2_original: "MpigiKammengo",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.33725806009091, 0.276342653147193],
            [32.334951865567625, 0.277952841100017],
            [32.33332559600143, 0.278576972418912],
            [32.32834605471853, 0.278938553516036],
            [32.32309357470955, 0.283922987978282],
            [32.32285511332412, 0.284691943581124],
            [32.32017922612884, 0.283759973602358],
            [32.317754159340645, 0.282077141469125],
            [32.312918246095236, 0.280529866838123],
            [32.306159227574405, 0.279977614360734],
            [32.30592778382799, 0.280472329535388],
            [32.30595544834547, 0.27908944623672],
            [32.30483596873672, 0.277290432083923],
            [32.29817595893325, 0.278639220440574],
            [32.29361746251558, 0.271621206014535],
            [32.2910725326207, 0.26412524485221],
            [32.28760324617995, 0.263386915665274],
            [32.287648757527194, 0.255849078587567],
            [32.287247550158376, 0.254419688089166],
            [32.28579153289811, 0.25399441364973],
            [32.28125984670008, 0.251298261520979],
            [32.280089791042506, 0.249289844440709],
            [32.28210616659723, 0.247353975218904],
            [32.28175882850105, 0.246729739035569],
            [32.266433646110755, 0.24567815751648],
            [32.262031004699935, 0.245750570943971],
            [32.250242522820876, 0.246197971849978],
            [32.24855838558073, 0.247505752255726],
            [32.24694993679315, 0.247803457448027],
            [32.24187077324354, 0.248292537027903],
            [32.24135807596478, 0.247080271879409],
            [32.24162660665773, 0.245777583934349],
            [32.24302881932408, 0.243905024194669],
            [32.24554252108469, 0.241625438469738],
            [32.249968324656834, 0.233682797993922],
            [32.250522747782206, 0.231846376433111],
            [32.26466390122064, 0.218367698930809],
            [32.268216966341434, 0.214676856804176],
            [32.27179337059162, 0.21008135441921],
            [32.27376514119922, 0.206707059291804],
            [32.27572331400837, 0.199506036747357],
            [32.27801581012185, 0.195218041315677],
            [32.28373073385596, 0.187827185527491],
            [32.28823488579219, 0.184371553741474],
            [32.28970812824806, 0.182480860387255],
            [32.29063462008937, 0.180499682679958],
            [32.29225996528912, 0.173750945290669],
            [32.29233049920862, 0.172457273879553],
            [32.29150893149078, 0.16974325003089],
            [32.28460742579285, 0.158588481067427],
            [32.280180638565504, 0.150627287870988],
            [32.276098413640085, 0.142268068359079],
            [32.269458072449765, 0.130172536099108],
            [32.267779488594705, 0.12586630454989],
            [32.267968000057074, 0.122736177224641],
            [32.27025826295877, 0.114576198726185],
            [32.27311537538119, 0.09874469583175],
            [32.27320574140717, 0.099125861218345],
            [32.273817201264876, 0.100837864286898],
            [32.27688733208891, 0.106096360720467],
            [32.27875676661935, 0.108468739853225],
            [32.281526546626445, 0.110853520917604],
            [32.28541553584939, 0.113280408439987],
            [32.28848361941291, 0.114619684285497],
            [32.29180098726439, 0.115445230774502],
            [32.29968407578507, 0.116415671602887],
            [32.303679509080986, 0.117731353099495],
            [32.30562987732695, 0.118807393278534],
            [32.30837740786107, 0.1209949461054],
            [32.3381979700676, 0.148738365446533],
            [32.34086254118527, 0.151415834372953],
            [32.341921621667574, 0.153244389095336],
            [32.343364810985584, 0.162146906869421],
            [32.34485311639212, 0.166317618478536],
            [32.36080956020391, 0.192412726531862],
            [32.362046455010216, 0.193201780650199],
            [32.36819126482854, 0.18936819752301],
            [32.37104483699039, 0.189632038465404],
            [32.371924877846695, 0.190086401146616],
            [32.37391102060054, 0.191317827374972],
            [32.37483897849241, 0.192465255221817],
            [32.37716032849283, 0.19821356826422],
            [32.378268009628634, 0.202179500032121],
            [32.37838887076359, 0.205969748447394],
            [32.37760502869446, 0.207661470820492],
            [32.37768894122346, 0.209018496443107],
            [32.376714716501176, 0.210285010106961],
            [32.377666377340134, 0.211433994286873],
            [32.37956919865643, 0.212221144861487],
            [32.38178196839014, 0.214989562647956],
            [32.38177068465187, 0.216174694426549],
            [32.380821346856244, 0.220046694502488],
            [32.377507645029446, 0.226505977911],
            [32.3746675556817, 0.229509393128027],
            [32.37116164582511, 0.232340886854954],
            [32.365265418710514, 0.234222350401682],
            [32.3642668164064, 0.23422230458798],
            [32.36317276001847, 0.233670397752887],
            [32.36120965635673, 0.230956272721879],
            [32.36030571222906, 0.230485797381091],
            [32.35999703582606, 0.231652819818822],
            [32.358286172807894, 0.233805875146805],
            [32.35798981500239, 0.235796151404648],
            [32.35706357738429, 0.237659744453768],
            [32.354176281568364, 0.241233081193118],
            [32.35150868761976, 0.248488458648575],
            [32.349125773378, 0.251356164570484],
            [32.3460122934516, 0.257145929231993],
            [32.34584307959818, 0.260230864289266],
            [32.34513898457005, 0.261669261448178],
            [32.344742630798706, 0.263849508105895],
            [32.343789724894776, 0.265342170594375],
            [32.342449796020354, 0.272959462384844],
            [32.34188895622892, 0.273628890098951],
            [32.339453342320965, 0.274515335682983],
            [32.33725806009091, 0.276342653147193],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1663,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "MPIGI TOWN COUNCIL",
        Population: 43360,
        Key: "MPIGIMPIGI TOWN COUNCIL",
        Dist2: "Mpigi",
        "Sub Country": "Mpigi TC",
        id2_original: "MpigiMpigi TC",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.06033088150745, 0.848965101112788],
            [31.0534489995069, 0.849028059813555],
            [31.0492570022504, 0.847412677894677],
            [31.045291357987626, 0.846607859181233],
            [31.03993853346648, 0.847522375342983],
            [31.03512039249064, 0.848936908785957],
            [31.033221125807934, 0.848987516109786],
            [31.027451911491344, 0.847873462307199],
            [31.022345592769003, 0.848079035413312],
            [31.01141678693878, 0.847598437256693],
            [31.003551622502954, 0.846412646933245],
            [31.00023474333499, 0.844365585892374],
            [30.99749999672566, 0.84442850873912],
            [30.994529017451132, 0.845001112615719],
            [30.99274577088228, 0.846626944500679],
            [30.98948917944969, 0.848036691672966],
            [30.987119909718732, 0.851002210181368],
            [30.985542499520875, 0.851168512212437],
            [30.98273876319603, 0.850066582265664],
            [30.981029056309634, 0.847386327799684],
            [30.977845210448727, 0.846044976049774],
            [30.97784575662443, 0.844992375653195],
            [30.976848065212, 0.844130632783843],
            [30.973996866399112, 0.842932999294482],
            [30.97067151252476, 0.83953423495141],
            [30.96445028572014, 0.829435655198002],
            [30.963691401544537, 0.82632533057936],
            [30.961856386862518, 0.822056583680519],
            [30.960605626559822, 0.819146984694315],
            [30.95875187661424, 0.819337411660089],
            [30.952621649147886, 0.817229082194884],
            [30.950721110450758, 0.815984140971183],
            [30.94706213934786, 0.814451230385349],
            [30.945839386719094, 0.814450600729937],
            [30.94323273178446, 0.812587392501936],
            [30.941065000884116, 0.812857159982892],
            [30.94021679452486, 0.809622623939494],
            [30.938649953006315, 0.806435380523842],
            [30.934502801445444, 0.802242095988292],
            [30.933891498792892, 0.798624757290208],
            [30.93152685897895, 0.794059218919948],
            [30.921705910354323, 0.787710140645506],
            [30.919226297862068, 0.784981791891834],
            [30.917650523496317, 0.78253653070224],
            [30.91744504106162, 0.778090321043878],
            [30.917940527517818, 0.77603187536826],
            [30.91679581063948, 0.772841466820105],
            [30.91659606304952, 0.767638081934639],
            [30.914371728404838, 0.766008134229719],
            [30.909041571073242, 0.765180354005789],
            [30.907996086592778, 0.764892804663867],
            [30.90690337857612, 0.763983325222304],
            [30.908455319739048, 0.762293445838333],
            [30.910279487264013, 0.760684084575506],
            [30.914510505539834, 0.758629063573273],
            [30.91574691256091, 0.757242326254988],
            [30.916507046293077, 0.757912446807686],
            [30.916315898275357, 0.760065123497816],
            [30.91674155958284, 0.760693845707356],
            [30.93211270427462, 0.76366361807144],
            [30.937034154203086, 0.764019889691675],
            [30.941778238066874, 0.767737964729559],
            [30.952324912253342, 0.767212254909511],
            [30.9577735025737, 0.768099603860862],
            [30.9702490150837, 0.777660631768203],
            [30.97675217095371, 0.7789024057383],
            [30.97991319601315, 0.785097044805111],
            [30.98065378869296, 0.794311782946844],
            [30.981983019530645, 0.795601983554589],
            [30.98928934831643, 0.798548113288938],
            [30.990999913093923, 0.799625493665498],
            [30.99226445534969, 0.801581823471031],
            [30.993871288068085, 0.808149246254428],
            [30.996718142628247, 0.807514034302603],
            [30.998971214378845, 0.807926540111968],
            [31.002469228942406, 0.807756125981545],
            [31.00988173679811, 0.812448750581407],
            [31.011116764006914, 0.812854829987555],
            [31.01110186365129, 0.813323159025193],
            [31.013034402135503, 0.812672965493113],
            [31.017088927509125, 0.806800711601557],
            [31.01741127896567, 0.803893997505412],
            [31.020268863901926, 0.801595045377937],
            [31.022075005832363, 0.792482977599756],
            [31.022894391542383, 0.790049818170635],
            [31.022650519603992, 0.789560043027296],
            [31.021449691258056, 0.789506907333661],
            [31.022071859033932, 0.786185474222882],
            [31.020565015993196, 0.781376154668279],
            [31.020086925412485, 0.775945585726769],
            [31.016359891655473, 0.769566289509693],
            [31.015219770558122, 0.768238008331413],
            [31.014053492316318, 0.763440500860229],
            [31.015107358078406, 0.762803772178623],
            [31.016195685909743, 0.759153040846076],
            [31.01904407479241, 0.758671541179163],
            [31.01961453913378, 0.759338434147232],
            [31.021260714468358, 0.759394061926807],
            [31.023781701565962, 0.759178439379378],
            [31.026347481358535, 0.761117424195649],
            [31.028391024662405, 0.76174037957738],
            [31.029032331943746, 0.762530151619185],
            [31.03193170111709, 0.762579339905709],
            [31.033380677382166, 0.764158964377611],
            [31.035472462013434, 0.763250834828774],
            [31.03863336130872, 0.763084827416886],
            [31.039346492490285, 0.762726301147582],
            [31.040153773401816, 0.764377405338331],
            [31.04549994230504, 0.76682008919251],
            [31.045023864848858, 0.768494529735126],
            [31.044453224437657, 0.769068435060515],
            [31.044880548526727, 0.77007342984542],
            [31.0432636672536, 0.771843034286262],
            [31.042121107230226, 0.775765987646225],
            [31.039362999033617, 0.778539839653275],
            [31.041689281683265, 0.784474004823506],
            [31.04173629950525, 0.785574516506724],
            [31.044017408574184, 0.786448811208873],
            [31.04541201251008, 0.786545923415668],
            [31.045882551852518, 0.787466453428358],
            [31.04678547549405, 0.787849660973131],
            [31.048686611570854, 0.788137646191671],
            [31.042840031647078, 0.788517653280411],
            [31.041413612078784, 0.789521769447229],
            [31.038461647443842, 0.800094609276323],
            [31.038177510319485, 0.801616033358605],
            [31.038697453409302, 0.803970352177613],
            [31.04012225780671, 0.80636340924224],
            [31.039881485056043, 0.812822678027719],
            [31.04320563069636, 0.819188011051471],
            [31.043205047689707, 0.820384194827697],
            [31.041825122225585, 0.823445744320385],
            [31.039352849867548, 0.824688545453718],
            [31.038877035617748, 0.82569310090324],
            [31.04039648022527, 0.828899628212509],
            [31.040110223975162, 0.831052614631204],
            [31.040821949293303, 0.833588878543799],
            [31.043007002407244, 0.836460819857006],
            [31.044574780868626, 0.838040574860777],
            [31.048329715400058, 0.838281705389014],
            [31.05122876387487, 0.839144421423587],
            [31.053129518167676, 0.840245873922107],
            [31.05536216851696, 0.843022166299459],
            [31.057928099226515, 0.844698133031579],
            [31.06033088150745, 0.848965101112788],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 125,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "KABASEKENDE",
        Population: 7763,
        Key: "KIBAALEKABASEKENDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.021260714468358, 0.759394061926807],
            [31.01961453913378, 0.759338434147232],
            [31.01904407479241, 0.758671541179163],
            [31.016195685909743, 0.759153040846076],
            [31.015107358078406, 0.762803772178623],
            [31.014053492316318, 0.763440500860229],
            [31.015219770558122, 0.768238008331413],
            [31.016359891655473, 0.769566289509693],
            [31.020086925412485, 0.775945585726769],
            [31.020565015993196, 0.781376154668279],
            [31.022071859033932, 0.786185474222882],
            [31.021449691258056, 0.789506907333661],
            [31.022650519603992, 0.789560043027296],
            [31.022894391542383, 0.790049818170635],
            [31.022075005832363, 0.792482977599756],
            [31.020268863901926, 0.801595045377937],
            [31.01741127896567, 0.803893997505412],
            [31.017088927509125, 0.806800711601557],
            [31.013034402135503, 0.812672965493113],
            [31.01110186365129, 0.813323159025193],
            [31.011116764006914, 0.812854829987555],
            [31.00988173679811, 0.812448750581407],
            [31.002469228942406, 0.807756125981545],
            [30.998971214378845, 0.807926540111968],
            [30.996718142628247, 0.807514034302603],
            [30.993871288068085, 0.808149246254428],
            [30.99226445534969, 0.801581823471031],
            [30.990999913093923, 0.799625493665498],
            [30.98928934831643, 0.798548113288938],
            [30.981983019530645, 0.795601983554589],
            [30.98065378869296, 0.794311782946844],
            [30.97991319601315, 0.785097044805111],
            [30.97675217095371, 0.7789024057383],
            [30.9702490150837, 0.777660631768203],
            [30.9577735025737, 0.768099603860862],
            [30.952324912253342, 0.767212254909511],
            [30.941778238066874, 0.767737964729559],
            [30.937034154203086, 0.764019889691675],
            [30.93211270427462, 0.76366361807144],
            [30.91674155958284, 0.760693845707356],
            [30.920119096592042, 0.753590327310824],
            [30.919763334993444, 0.749210334511439],
            [30.920117953935, 0.746785694445613],
            [30.92102773441708, 0.744778308613548],
            [30.923811625160678, 0.741691121623171],
            [30.92474850152667, 0.737592028348808],
            [30.926414027470784, 0.735701486061608],
            [30.926149573332598, 0.733217303138232],
            [30.927469416775587, 0.731028768967876],
            [30.92672734636716, 0.727303149944965],
            [30.927298542835498, 0.726824248118739],
            [30.92771352227596, 0.724924111650309],
            [30.92830839204697, 0.724301807693258],
            [30.92787823287486, 0.722869151290952],
            [30.92913920163244, 0.721385512797512],
            [30.932520897841407, 0.720686250384267],
            [30.93382991209365, 0.719608663492157],
            [30.93469839612382, 0.718663304243184],
            [30.934291753947527, 0.716943903829568],
            [30.9347679068622, 0.716704087689731],
            [30.934671087339165, 0.715151341588671],
            [30.9350277140154, 0.714481702356741],
            [30.936146832501414, 0.714073424635254],
            [30.938573776768546, 0.711392974788739],
            [30.940002098070295, 0.710530166268456],
            [30.94755364986064, 0.708142761962083],
            [30.947664349253092, 0.70720194548649],
            [30.948177404061294, 0.706708260904012],
            [30.950599213558284, 0.705908601876159],
            [30.95419425964723, 0.706103287949827],
            [30.95672559893015, 0.703198238353856],
            [30.96045225359809, 0.701041128512947],
            [30.961880880327048, 0.700657665509461],
            [30.962884461094475, 0.699468778285126],
            [30.96451433739652, 0.6993760736656],
            [30.965373177113786, 0.698579377602812],
            [30.966400070959487, 0.69837584975526],
            [30.967604515024437, 0.697096985270401],
            [30.971756914543217, 0.696417147415466],
            [30.97191137087316, 0.694602799209778],
            [30.973059636995192, 0.692976894989142],
            [30.976295696533658, 0.691425367097173],
            [30.976830184246243, 0.690058193762574],
            [30.979910172283894, 0.688730906843527],
            [30.980043749071687, 0.688349922012284],
            [30.98320153031465, 0.686675338545377],
            [30.984541133998917, 0.686560775640726],
            [30.98654974810958, 0.685616271127379],
            [30.99129111277306, 0.68223651802512],
            [30.99617966370086, 0.680838504180025],
            [30.996825863207224, 0.679538287128473],
            [30.998744724841217, 0.678168411155259],
            [31.00102123992581, 0.677178557614196],
            [31.001285081412973, 0.677771240774132],
            [31.005374606048374, 0.675511088016663],
            [31.012920130143158, 0.672792707348441],
            [31.023582519016305, 0.667453674241598],
            [31.027311243402693, 0.667151281402788],
            [31.028119717276926, 0.666675327819056],
            [31.031980207447496, 0.665883562247747],
            [31.03321710764368, 0.664978596686337],
            [31.035996045076786, 0.66467412333748],
            [31.04012385141803, 0.661303256527661],
            [31.046212081746514, 0.657327538591007],
            [31.04756405433395, 0.657975383353087],
            [31.048055880155378, 0.660866638787205],
            [31.04903836758163, 0.662122781616185],
            [31.051200385196733, 0.661625864063743],
            [31.053221517330886, 0.660459834111887],
            [31.056667608372685, 0.659201347313055],
            [31.069464244342264, 0.65010452619798],
            [31.071412128746456, 0.649798208717756],
            [31.074717388206228, 0.647846667540907],
            [31.07535841341654, 0.64789582200728],
            [31.075644425324914, 0.647442600598526],
            [31.077212827217117, 0.646944370134865],
            [31.077900943012974, 0.647160827856612],
            [31.07912820338784, 0.645312284454512],
            [31.079888238305326, 0.64524225803281],
            [31.081714816010166, 0.646034446356428],
            [31.084900409992624, 0.644488686615144],
            [31.08909405565767, 0.643434756269225],
            [31.090615589746573, 0.642673664361939],
            [31.092159244849334, 0.642605320342698],
            [31.092730601217788, 0.641985503777914],
            [31.09290542954177, 0.638307354154625],
            [31.09487880454046, 0.637260589751161],
            [31.095724045560967, 0.636294987407935],
            [31.099608774074518, 0.635706736734381],
            [31.101612846303127, 0.636403165743605],
            [31.103442745079604, 0.635786031532819],
            [31.104676988957475, 0.636027541297995],
            [31.105421844143304, 0.637378734257942],
            [31.104702872115745, 0.640195825917533],
            [31.105487848757107, 0.644700143836877],
            [31.105455826512173, 0.648235306873481],
            [31.10681757905811, 0.649802807796207],
            [31.107815416895928, 0.649589979147946],
            [31.10807466260208, 0.650426569451954],
            [31.108789510464167, 0.649377084917879],
            [31.109823222522845, 0.649134875142874],
            [31.110662128623954, 0.650253365660228],
            [31.111897847535523, 0.650564854380561],
            [31.11329931280354, 0.652527209521398],
            [31.113536723160113, 0.653197190649256],
            [31.112822211267943, 0.657264118112166],
            [31.113154494498268, 0.658436554275907],
            [31.113891189388063, 0.659587713179779],
            [31.115552659438656, 0.660630955394215],
            [31.115654462814852, 0.661659742663976],
            [31.11626752347039, 0.661917165583857],
            [31.11688031193641, 0.66289471251969],
            [31.113981376649328, 0.670467524994642],
            [31.113718181050874, 0.672104021843873],
            [31.11119023290813, 0.676694359946447],
            [31.110048428367946, 0.677532702648737],
            [31.10477567248468, 0.677970357285069],
            [31.10310041329448, 0.679457247721185],
            [31.09966109105838, 0.683835368782316],
            [31.099432035932278, 0.684293493991768],
            [31.099769560832303, 0.686166934869979],
            [31.09885616013959, 0.686814666220362],
            [31.098493321613194, 0.687616462732484],
            [31.098892831166136, 0.691391417743028],
            [31.09803407139891, 0.693032946660917],
            [31.097715617732398, 0.695143825494558],
            [31.097220651400722, 0.695582257300829],
            [31.096081961319605, 0.695102047925495],
            [31.094104911313085, 0.695671015088693],
            [31.08922033004053, 0.694794913167258],
            [31.088046389169353, 0.694105967630393],
            [31.085848790184148, 0.691312798421501],
            [31.084692101458025, 0.691525071035725],
            [31.080943548558377, 0.693895444921628],
            [31.07623920616275, 0.696708763022384],
            [31.06902795596496, 0.699058279672087],
            [31.067291435265627, 0.70034433320151],
            [31.066873982763227, 0.701143605139816],
            [31.068177105863807, 0.702364657294201],
            [31.067599068724572, 0.705779106978561],
            [31.068813761668608, 0.709233318629117],
            [31.066482266095374, 0.711067436937778],
            [31.065033287135336, 0.716235600797572],
            [31.064813985916615, 0.718575955342529],
            [31.063370978058288, 0.721236074621582],
            [31.064269324783442, 0.722910080667333],
            [31.064309047386992, 0.726158682338974],
            [31.063435072853796, 0.729178342115242],
            [31.062649048776812, 0.730179821352143],
            [31.06131179239036, 0.738238412297197],
            [31.061617336367945, 0.739552827506959],
            [31.06305009534723, 0.741168300090987],
            [31.062454438651987, 0.742002998630938],
            [31.06031384046651, 0.74343141999857],
            [31.05691603656619, 0.744307674262953],
            [31.055664888191306, 0.747171978509679],
            [31.05140633834864, 0.747209536572745],
            [31.043630016396122, 0.74937872637879],
            [31.041696042404087, 0.750264260953571],
            [31.037803370986797, 0.751081359486926],
            [31.035191526484738, 0.750751610878115],
            [31.032415500491453, 0.752353974060934],
            [31.030433636413324, 0.752834120783915],
            [31.027323148775157, 0.752409759121611],
            [31.025922691416874, 0.75265048056519],
            [31.024761806660045, 0.754989611475972],
            [31.022957535920327, 0.755016320561868],
            [31.021724026864348, 0.755996119484218],
            [31.021260714468358, 0.759394061926807],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 126,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "BUBANGO",
        Population: 18153,
        Key: "KIBAALEBUBANGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.06033088150745, 0.848965101112788],
            [31.06146191075581, 0.84908729899815],
            [31.062388708922665, 0.849968339843794],
            [31.062841281959425, 0.851470219416125],
            [31.065123407921277, 0.854424168964369],
            [31.06538590373213, 0.855783243177289],
            [31.068425484649964, 0.861216492057516],
            [31.064784217544737, 0.864418029212305],
            [31.062365793798076, 0.867760785991144],
            [31.060979372616107, 0.870314894799258],
            [31.060721245312475, 0.873439688303905],
            [31.06017652039894, 0.874823840934769],
            [31.060945757658185, 0.884649031938815],
            [31.061581755896178, 0.885999862288469],
            [31.063797576308605, 0.887516620718055],
            [31.06631557650786, 0.889958201229362],
            [31.063652547797577, 0.892157797045074],
            [31.058730185180792, 0.895327740259305],
            [31.055272006408515, 0.902802215263727],
            [31.05455343592792, 0.903500457250578],
            [31.046435186432173, 0.909224676413957],
            [31.04703038588492, 0.914392993607404],
            [31.04901528447208, 0.923254809543708],
            [31.052545925846722, 0.928960970326041],
            [31.05421465069157, 0.933784839357844],
            [31.060196801663107, 0.939236040447179],
            [31.063790778756836, 0.945551175308799],
            [31.06121169491488, 0.946190647320197],
            [31.051630612640793, 0.950238397487743],
            [31.045306830570105, 0.953392719703377],
            [31.046114174363694, 0.954685063505391],
            [31.048537506505063, 0.956265422290611],
            [31.04934495989313, 0.957366378716966],
            [31.051213412564973, 0.961534554775129],
            [31.045184833066287, 0.964785596050036],
            [31.034900076175642, 0.968354733442585],
            [31.034525466125743, 0.967559919599718],
            [31.03260249200437, 0.964343151340344],
            [31.030957558141544, 0.963252445490049],
            [31.02942141385285, 0.961246418493961],
            [31.02589367134164, 0.958563594665541],
            [31.019484881695583, 0.947603570763594],
            [31.015942789496012, 0.942821999660216],
            [31.014882210623774, 0.938189677726979],
            [31.009546239395704, 0.931710418293015],
            [31.00226605338132, 0.915193404581153],
            [31.00220334019472, 0.914159694901097],
            [31.001424806270574, 0.912502873951048],
            [30.998937166432956, 0.909155416043369],
            [30.997964583831035, 0.905265161920673],
            [30.998228793627444, 0.897244937174605],
            [30.996758549748016, 0.893495476707216],
            [30.995373724872326, 0.891925512782969],
            [30.993642008363146, 0.89122713744849],
            [30.9909573122882, 0.891138481760262],
            [30.98775564564868, 0.886167604403086],
            [30.985505069417915, 0.884074114867507],
            [30.984494718946525, 0.879193340913216],
            [30.985210417513166, 0.878418327928969],
            [30.987249086558286, 0.871924724167579],
            [30.98365625930807, 0.869612586636729],
            [30.978461326274527, 0.867212415690833],
            [30.974607506094973, 0.867166745183463],
            [30.972183132806165, 0.866206492233574],
            [30.97023591495192, 0.863677322238909],
            [30.968290247589835, 0.858227750015386],
            [30.9663865827555, 0.855219147895908],
            [30.961668348812292, 0.852209046990403],
            [30.957685601524815, 0.850419813041276],
            [30.949489623502476, 0.850275720275913],
            [30.94955719657478, 0.849519499266255],
            [30.948896359020843, 0.848867742508148],
            [30.949482000398977, 0.846819436936254],
            [30.949223973706655, 0.843441255057714],
            [30.949768300666545, 0.837579002444952],
            [30.95033168538519, 0.836663959390225],
            [30.9512867759919, 0.831891608449982],
            [30.95104902876712, 0.831106903993636],
            [30.95211053380239, 0.829865210580741],
            [30.953626513607873, 0.828972453298519],
            [30.95765174132682, 0.825249825624288],
            [30.961856386862518, 0.822056583680519],
            [30.963691401544537, 0.82632533057936],
            [30.96445028572014, 0.829435655198002],
            [30.97067151252476, 0.83953423495141],
            [30.973996866399112, 0.842932999294482],
            [30.976848065212, 0.844130632783843],
            [30.97784575662443, 0.844992375653195],
            [30.977845210448727, 0.846044976049774],
            [30.981029056309634, 0.847386327799684],
            [30.98273876319603, 0.850066582265664],
            [30.985542499520875, 0.851168512212437],
            [30.987119909718732, 0.851002210181368],
            [30.98948917944969, 0.848036691672966],
            [30.99274577088228, 0.846626944500679],
            [30.994529017451132, 0.845001112615719],
            [30.99749999672566, 0.84442850873912],
            [31.00023474333499, 0.844365585892374],
            [31.003551622502954, 0.846412646933245],
            [31.01141678693878, 0.847598437256693],
            [31.022345592769003, 0.848079035413312],
            [31.027451911491344, 0.847873462307199],
            [31.033221125807934, 0.848987516109786],
            [31.03512039249064, 0.848936908785957],
            [31.03993853346648, 0.847522375342983],
            [31.045291357987626, 0.846607859181233],
            [31.0492570022504, 0.847412677894677],
            [31.0534489995069, 0.849028059813555],
            [31.06033088150745, 0.848965101112788],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 127,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "MUGARAMA",
        Population: 11878,
        Key: "KIBAALEMUGARAMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.237028462136237, 0.771147976443035],
            [31.235959031265246, 0.771553684433943],
            [31.234442044448315, 0.771383384684585],
            [31.23377043789074, 0.773300023113998],
            [31.232383494787626, 0.773050878293421],
            [31.22877951764811, 0.775389298374173],
            [31.22830809616005, 0.777432124098054],
            [31.22696613349983, 0.778612126697891],
            [31.227948986540405, 0.782473967979477],
            [31.227270440497286, 0.783176737071681],
            [31.22533894226215, 0.783529923425568],
            [31.22455201717495, 0.784046754898175],
            [31.22377143778692, 0.786639583719957],
            [31.221578649280072, 0.789308218852486],
            [31.221456232263044, 0.791509040866138],
            [31.2203381863655, 0.792033611392286],
            [31.21882635767494, 0.795575308857414],
            [31.216878672696705, 0.798187105544336],
            [31.215941080373423, 0.798851781721503],
            [31.215609522981854, 0.799663298277044],
            [31.21591989360745, 0.801284770685603],
            [31.214059297601086, 0.804412433359988],
            [31.213613759271297, 0.809756102058022],
            [31.21310431838549, 0.810758721077581],
            [31.21296369700922, 0.812524029917514],
            [31.21239531765761, 0.813932231728609],
            [31.210154772015304, 0.81703662514288],
            [31.209871063387325, 0.818205846682334],
            [31.20844770797246, 0.819424586938275],
            [31.207109063688897, 0.82219359768967],
            [31.206613758692374, 0.825390604870578],
            [31.205001829831374, 0.827945368589042],
            [31.203671841713902, 0.827613545793771],
            [31.203244948816135, 0.828091271195022],
            [31.202176586042025, 0.828188373425046],
            [31.201241321253626, 0.830718203423903],
            [31.198046082059967, 0.835200108326278],
            [31.19634671118924, 0.832538726038525],
            [31.193139839710966, 0.831088812928902],
            [31.18940904919942, 0.828113193187981],
            [31.18559742378707, 0.827332104222552],
            [31.184551685981653, 0.826331970235358],
            [31.183388139516655, 0.82621455018085],
            [31.183007829656272, 0.825809666764049],
            [31.181084644430808, 0.825836561326438],
            [31.18063290862388, 0.825240974543663],
            [31.181011329327198, 0.823809253158121],
            [31.180535040766937, 0.82242658769346],
            [31.17798232068193, 0.822120553313143],
            [31.173827969124062, 0.82281883525798],
            [31.17031314708157, 0.822013428564668],
            [31.16806827155959, 0.820895938600964],
            [31.166287318389696, 0.820684087291195],
            [31.156731194907458, 0.821128514599633],
            [31.15107994286239, 0.820708100388372],
            [31.148917902789393, 0.819304263622308],
            [31.146597284017613, 0.813750502016389],
            [31.14467250428254, 0.812179339668498],
            [31.142475446083118, 0.811348007164215],
            [31.139246246080155, 0.811162297299642],
            [31.13232405397789, 0.809980654851718],
            [31.127148573961822, 0.810370442492703],
            [31.12588990668797, 0.810062360139025],
            [31.123885015195842, 0.80869258397951],
            [31.123854957566458, 0.806709081746896],
            [31.12122579803727, 0.801227444911876],
            [31.116862929535642, 0.795247691608196],
            [31.115034139280247, 0.794630456605237],
            [31.11396659666795, 0.795466935768575],
            [31.110808836086257, 0.795424228586137],
            [31.110024901490668, 0.794996150721158],
            [31.10814344480677, 0.791634214544019],
            [31.107152746778816, 0.789058827069518],
            [31.108348735900325, 0.78297672249971],
            [31.10986697047719, 0.78175790673734],
            [31.11079998588409, 0.777129309221589],
            [31.109778160333242, 0.776248445599678],
            [31.10742413052112, 0.772817641174748],
            [31.107220909145944, 0.77145845547803],
            [31.10577197779662, 0.770816786804325],
            [31.105436337562075, 0.767692837421009],
            [31.105824794243766, 0.764543880680878],
            [31.104576649835177, 0.762924005513],
            [31.10386105008322, 0.759729113965394],
            [31.10190650287456, 0.75749275737061],
            [31.102861445259247, 0.757393318066962],
            [31.104771439623057, 0.756221556327946],
            [31.10522133478197, 0.75507598687174],
            [31.104341459215707, 0.753717888723093],
            [31.1021562084724, 0.752767354772131],
            [31.101631407293524, 0.750406948794987],
            [31.099352657200495, 0.746456651529597],
            [31.098012452543298, 0.741971697663075],
            [31.0975924515204, 0.73886551541738],
            [31.097499667229656, 0.737948070347451],
            [31.098224942735555, 0.736535583807137],
            [31.09804691640917, 0.735512849111717],
            [31.096418737024685, 0.733177935897804],
            [31.09574783025475, 0.730346969876119],
            [31.09336974355929, 0.729177398062316],
            [31.09271326193618, 0.729625016548931],
            [31.092086727449708, 0.729470766760176],
            [31.091842227588916, 0.728438332126162],
            [31.090817293867175, 0.728053900409091],
            [31.0899463044357, 0.726848106351137],
            [31.088901939256047, 0.722670460658392],
            [31.087844217026458, 0.720107512493761],
            [31.08590447405366, 0.716978907537176],
            [31.084654354249793, 0.71144407690407],
            [31.084809368433522, 0.70617985812229],
            [31.084445355809052, 0.703475122278905],
            [31.082867586285047, 0.699907827683267],
            [31.082007642538283, 0.696317956480152],
            [31.080943548558377, 0.693895444921628],
            [31.084692101458025, 0.691525071035725],
            [31.085848790184148, 0.691312798421501],
            [31.088046389169353, 0.694105967630393],
            [31.08922033004053, 0.694794913167258],
            [31.094104911313085, 0.695671015088693],
            [31.096081961319605, 0.695102047925495],
            [31.097220651400722, 0.695582257300829],
            [31.097715617732398, 0.695143825494558],
            [31.09803407139891, 0.693032946660917],
            [31.098892831166136, 0.691391417743028],
            [31.098493321613194, 0.687616462732484],
            [31.09885616013959, 0.686814666220362],
            [31.099769560832303, 0.686166934869979],
            [31.099432035932278, 0.684293493991768],
            [31.09966109105838, 0.683835368782316],
            [31.10310041329448, 0.679457247721185],
            [31.10477567248468, 0.677970357285069],
            [31.110048428367946, 0.677532702648737],
            [31.11119023290813, 0.676694359946447],
            [31.113718181050874, 0.672104021843873],
            [31.113981376649328, 0.670467524994642],
            [31.11688031193641, 0.66289471251969],
            [31.11626752347039, 0.661917165583857],
            [31.115654462814852, 0.661659742663976],
            [31.115552659438656, 0.660630955394215],
            [31.113891189388063, 0.659587713179779],
            [31.113154494498268, 0.658436554275907],
            [31.112822211267943, 0.657264118112166],
            [31.113536723160113, 0.653197190649256],
            [31.11329931280354, 0.652527209521398],
            [31.111897847535523, 0.650564854380561],
            [31.110662128623954, 0.650253365660228],
            [31.109823222522845, 0.649134875142874],
            [31.110699016144466, 0.64871086608401],
            [31.111364421631603, 0.64883074126834],
            [31.111863205803214, 0.649644368642344],
            [31.11412091106408, 0.649836619107137],
            [31.115641345615064, 0.651440149528534],
            [31.115617310291327, 0.652157882148457],
            [31.11723297883884, 0.653306882188617],
            [31.118111789901516, 0.654742700706085],
            [31.118277759040147, 0.65579545377416],
            [31.119726957189112, 0.657231491651152],
            [31.121557064374716, 0.656945090742844],
            [31.12364814382846, 0.657878953768627],
            [31.125430856798005, 0.657233660041578],
            [31.126619913620477, 0.655248345506863],
            [31.12875876548103, 0.655560178848211],
            [31.1297576812972, 0.653598711470949],
            [31.130921599664724, 0.655297820578609],
            [31.13229992343273, 0.655633290637726],
            [31.13348840263843, 0.655203088647377],
            [31.136315394549367, 0.658457955224289],
            [31.137741408079137, 0.658386719034579],
            [31.13831224881466, 0.657190682076006],
            [31.13914356684656, 0.658554723440056],
            [31.140284385036594, 0.658483378562758],
            [31.1409263202403, 0.657837643870137],
            [31.14263735842993, 0.658245014661005],
            [31.143254923238317, 0.65922617779889],
            [31.14527459022024, 0.660542820353281],
            [31.147301506606496, 0.660805055286015],
            [31.144810867294172, 0.671220688274894],
            [31.14568877554996, 0.679155269721149],
            [31.146656330281264, 0.681502654494713],
            [31.14161654348379, 0.684754503441855],
            [31.138241498401197, 0.685231679569891],
            [31.136482157798703, 0.686810038432523],
            [31.135910770887513, 0.689345865185017],
            [31.131922424400866, 0.695350838688349],
            [31.13381798193976, 0.697139132002034],
            [31.135090567710606, 0.69733674134204],
            [31.137375087682695, 0.696713505776431],
            [31.13943144006421, 0.695433178490657],
            [31.14220532177889, 0.695138632716077],
            [31.146431943699675, 0.69334997934494],
            [31.147344732639667, 0.695715551175568],
            [31.150508481391043, 0.699855931389748],
            [31.15130591586875, 0.705095860637647],
            [31.150993535711848, 0.709392711562852],
            [31.148881877651558, 0.719879165304222],
            [31.152419500732613, 0.723082854262621],
            [31.153551979861856, 0.724984650559226],
            [31.154067630801237, 0.728107047636476],
            [31.15693036218573, 0.72866862537626],
            [31.159356222186297, 0.727949121288036],
            [31.160550473067723, 0.724627275437337],
            [31.160113900822793, 0.7225856610506],
            [31.164290350038367, 0.719385109310203],
            [31.165443601810228, 0.719105379802765],
            [31.166414583614287, 0.717917682102198],
            [31.17341194584124, 0.727102521098704],
            [31.17324883424354, 0.730792792660116],
            [31.174075159439095, 0.73782949986861],
            [31.17378621902293, 0.739500994541347],
            [31.174423180254905, 0.74380154772133],
            [31.175367716555346, 0.745241271052061],
            [31.175681630136427, 0.747973683604227],
            [31.17620214275813, 0.749230265525132],
            [31.17925417073256, 0.752793278811895],
            [31.179689859933564, 0.754062025974045],
            [31.181118987922446, 0.755721520313659],
            [31.18285138715122, 0.756563897804978],
            [31.182996191981776, 0.758003291770926],
            [31.184618982372847, 0.760175178993944],
            [31.191683565532532, 0.759556087599046],
            [31.194955075287055, 0.759899008174895],
            [31.200723650003177, 0.75807176075895],
            [31.207967382383313, 0.756577504298591],
            [31.209239372571115, 0.757370898974672],
            [31.211025107473258, 0.761183496640645],
            [31.212690334278378, 0.763379824150817],
            [31.214568439347932, 0.763594075780725],
            [31.216173563470647, 0.764631577189724],
            [31.218915006122106, 0.76492242846187],
            [31.220883783543186, 0.765655132350209],
            [31.22297317146926, 0.76776016549686],
            [31.227240323579068, 0.766980577705255],
            [31.230152924038226, 0.767397232878818],
            [31.23193997856554, 0.768068872561636],
            [31.237028462136237, 0.771147976443035],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 128,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "MATALE",
        Population: 17845,
        Key: "KIBAALEMATALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.034525466125743, 0.967559919599718],
            [31.027282316752224, 0.965590939996865],
            [31.023570692695586, 0.97003242057536],
            [31.008807677806736, 0.961849582801942],
            [31.006526291158366, 0.959444091583824],
            [31.000695765925343, 0.957079945951157],
            [30.997089678643242, 0.954264467774483],
            [30.993098020966457, 0.952424830825902],
            [30.992099875904795, 0.952366829232109],
            [30.98916393182466, 0.949695299519824],
            [30.984447774786403, 0.946621014574367],
            [30.983873907626695, 0.940984720681697],
            [30.983162507498704, 0.939705175532758],
            [30.98382282582638, 0.938869451288814],
            [30.98368095399525, 0.937606241736194],
            [30.9821703488101, 0.936026454685565],
            [30.979917754064896, 0.935307459963352],
            [30.978149178781305, 0.935995408561019],
            [30.973468867217832, 0.9415331813324],
            [30.969059078810567, 0.947731340430507],
            [30.96559206151425, 0.951088019408459],
            [30.965305268071575, 0.953815023899752],
            [30.963735626504274, 0.955680046556466],
            [30.961523182859008, 0.959439343754978],
            [30.96066720607255, 0.960127797730964],
            [30.957951447153377, 0.96071008742586],
            [30.95519272810237, 0.953798922033025],
            [30.952998757412583, 0.950467605234836],
            [30.951607904841335, 0.949434963083102],
            [30.948386718709045, 0.94576176113275],
            [30.94718417817417, 0.945009830777125],
            [30.94490348772011, 0.942111615523806],
            [30.944569144652846, 0.941603585369932],
            [30.94496530798133, 0.939874548059377],
            [30.944156371474755, 0.938462185544925],
            [30.93991136822659, 0.935572831842005],
            [30.93831286109426, 0.934045195825568],
            [30.938071071450704, 0.933150797365761],
            [30.935352246581466, 0.929744216174008],
            [30.93430594104082, 0.927041829541741],
            [30.93318541040317, 0.925523737676531],
            [30.932341399176284, 0.922691939835724],
            [30.93011928876025, 0.918675002108498],
            [30.931500305677442, 0.914789710953845],
            [30.930178410482355, 0.911772591260587],
            [30.928261219714788, 0.90944782755252],
            [30.925862039678147, 0.908221744621143],
            [30.923709190268823, 0.907789901443217],
            [30.916180441313667, 0.907900352508997],
            [30.912986678950336, 0.907525309829108],
            [30.91182718388725, 0.906781706682266],
            [30.910341692004188, 0.904072217687576],
            [30.911825461816846, 0.906780405186416],
            [30.907441153224323, 0.90554135578928],
            [30.90244658133005, 0.901500746510668],
            [30.896947468859842, 0.900179219489638],
            [30.893275208080652, 0.897803106056685],
            [30.892142004909278, 0.896706766747746],
            [30.88850699007841, 0.894608788575152],
            [30.88595817047837, 0.891323014715536],
            [30.89127876883701, 0.885823094074856],
            [30.886880292914167, 0.878453967093789],
            [30.886937097881155, 0.875511751608029],
            [30.886441453321435, 0.874271653368493],
            [30.884676811760468, 0.874048594409586],
            [30.88261865915513, 0.872733591171481],
            [30.880911132479927, 0.869013188285702],
            [30.879275666860178, 0.867920489025537],
            [30.87974543634644, 0.866343018754024],
            [30.88313297250307, 0.86570818539233],
            [30.885899983902476, 0.864162814540379],
            [30.886174254830078, 0.862963622601594],
            [30.88312778652896, 0.859483284829371],
            [30.88061885931405, 0.858505889313887],
            [30.878396067975018, 0.855777618554454],
            [30.874361927171833, 0.854053034426732],
            [30.87095162501096, 0.85357181275445],
            [30.87068430255207, 0.852242538767204],
            [30.87142654723367, 0.849946745822294],
            [30.871599194448134, 0.847937238403137],
            [30.871079829873356, 0.846246095891498],
            [30.869685811639034, 0.843947428685586],
            [30.86463031779884, 0.841790431610315],
            [30.86292015995817, 0.840296812801821],
            [30.858736006790725, 0.839237812838672],
            [30.856522790594315, 0.839849164839668],
            [30.853987791574912, 0.841825757638969],
            [30.85237473532826, 0.841990521415669],
            [30.848638308786636, 0.840592400389147],
            [30.84328961471917, 0.837277498058994],
            [30.8417601359299, 0.836840019392438],
            [30.840584214273527, 0.837011718531413],
            [30.84004741339908, 0.837482519319393],
            [30.839121330291213, 0.840032831713163],
            [30.838150499404104, 0.840917035443369],
            [30.835684106519597, 0.841972752861483],
            [30.83273467872703, 0.841760582018577],
            [30.828948295974147, 0.83928614869313],
            [30.83000646197147, 0.838213852118227],
            [30.83092384759078, 0.835895182218457],
            [30.830870694275422, 0.831592088695731],
            [30.830095070892806, 0.828518044033784],
            [30.831012444833977, 0.826199367536268],
            [30.832539522426497, 0.825781079053018],
            [30.83453765589273, 0.826983687628098],
            [30.836341145996506, 0.828772972722559],
            [30.838284051937382, 0.829444656272198],
            [30.84255931852916, 0.829335243951728],
            [30.84472559775196, 0.82765990300879],
            [30.84419982908754, 0.824530085575494],
            [30.845506363091264, 0.821261558494923],
            [30.845506933521488, 0.82019975277316],
            [30.844191448704255, 0.816399665745733],
            [30.843983556987943, 0.813688387982574],
            [30.84440088013296, 0.811984137399528],
            [30.845651180498216, 0.810000911633649],
            [30.849899437444336, 0.808466363109101],
            [30.850538341732268, 0.807712262012142],
            [30.8516229065209, 0.804136219642342],
            [30.86303623936087, 0.797463999510896],
            [30.866647139816255, 0.793721579110354],
            [30.870617929629002, 0.791935313650685],
            [30.877116469056762, 0.787300173005609],
            [30.878839434178456, 0.783836144832248],
            [30.883033249625086, 0.7802057082349],
            [30.88661503568211, 0.779117751531915],
            [30.888059976714924, 0.776435952599567],
            [30.891003915801125, 0.774006389362666],
            [30.893502519576785, 0.773895872530301],
            [30.895695264066177, 0.774763210148669],
            [30.89669470000686, 0.774735769125626],
            [30.89797209984932, 0.774009886184969],
            [30.898722329655488, 0.772668987109389],
            [30.898584718533723, 0.770237858789033],
            [30.899446100483274, 0.768673467022322],
            [30.902334568600647, 0.766132062813049],
            [30.90690337857612, 0.763983325222304],
            [30.907996086592778, 0.764892804663867],
            [30.909041571073242, 0.765180354005789],
            [30.914371728404838, 0.766008134229719],
            [30.91659606304952, 0.767638081934639],
            [30.91679581063948, 0.772841466820105],
            [30.917940527517818, 0.77603187536826],
            [30.91744504106162, 0.778090321043878],
            [30.917650523496317, 0.78253653070224],
            [30.919226297862068, 0.784981791891834],
            [30.921705910354323, 0.787710140645506],
            [30.93152685897895, 0.794059218919948],
            [30.933891498792892, 0.798624757290208],
            [30.934502801445444, 0.802242095988292],
            [30.938649953006315, 0.806435380523842],
            [30.94021679452486, 0.809622623939494],
            [30.941065000884116, 0.812857159982892],
            [30.94323273178446, 0.812587392501936],
            [30.945839386719094, 0.814450600729937],
            [30.94706213934786, 0.814451230385349],
            [30.950721110450758, 0.815984140971183],
            [30.952621649147886, 0.817229082194884],
            [30.95875187661424, 0.819337411660089],
            [30.960605626559822, 0.819146984694315],
            [30.961856386862518, 0.822056583680519],
            [30.95765174132682, 0.825249825624288],
            [30.953626513607873, 0.828972453298519],
            [30.95211053380239, 0.829865210580741],
            [30.95104902876712, 0.831106903993636],
            [30.9512867759919, 0.831891608449982],
            [30.95033168538519, 0.836663959390225],
            [30.949768300666545, 0.837579002444952],
            [30.949223973706655, 0.843441255057714],
            [30.949482000398977, 0.846819436936254],
            [30.948896359020843, 0.848867742508148],
            [30.94955719657478, 0.849519499266255],
            [30.949489623502476, 0.850275720275913],
            [30.957685601524815, 0.850419813041276],
            [30.961668348812292, 0.852209046990403],
            [30.9663865827555, 0.855219147895908],
            [30.968290247589835, 0.858227750015386],
            [30.97023591495192, 0.863677322238909],
            [30.972183132806165, 0.866206492233574],
            [30.974607506094973, 0.867166745183463],
            [30.978461326274527, 0.867212415690833],
            [30.98365625930807, 0.869612586636729],
            [30.987249086558286, 0.871924724167579],
            [30.985210417513166, 0.878418327928969],
            [30.984494718946525, 0.879193340913216],
            [30.985505069417915, 0.884074114867507],
            [30.98775564564868, 0.886167604403086],
            [30.9909573122882, 0.891138481760262],
            [30.993642008363146, 0.89122713744849],
            [30.995373724872326, 0.891925512782969],
            [30.996758549748016, 0.893495476707216],
            [30.998228793627444, 0.897244937174605],
            [30.997964583831035, 0.905265161920673],
            [30.998937166432956, 0.909155416043369],
            [31.001424806270574, 0.912502873951048],
            [31.00220334019472, 0.914159694901097],
            [31.00226605338132, 0.915193404581153],
            [31.009546239395704, 0.931710418293015],
            [31.014882210623774, 0.938189677726979],
            [31.015942789496012, 0.942821999660216],
            [31.019484881695583, 0.947603570763594],
            [31.02589367134164, 0.958563594665541],
            [31.02942141385285, 0.961246418493961],
            [31.030957558141544, 0.963252445490049],
            [31.03260249200437, 0.964343151340344],
            [31.034525466125743, 0.967559919599718],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 129,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "NYAMARUNDA",
        Population: 24856,
        Key: "KIBAALENYAMARUNDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.951607904841335, 0.949434963083102],
            [30.949613749115183, 0.950831683622072],
            [30.946890941115953, 0.954133265464435],
            [30.944866719675545, 0.957435255509305],
            [30.944216756228148, 0.960650172829492],
            [30.943186190967907, 0.962407555544452],
            [30.941273387572164, 0.963831301776468],
            [30.939911714077965, 0.965903067400647],
            [30.93772302368545, 0.967530193196058],
            [30.937463828284933, 0.970527891672992],
            [30.93889958314567, 0.975108590764929],
            [30.939189607828403, 0.975144012494189],
            [30.936328096356068, 0.97889620774477],
            [30.930589616998606, 0.983185847313314],
            [30.92916420534005, 0.985664443536087],
            [30.92649837119113, 0.986678037685102],
            [30.924006975497313, 0.985046114083275],
            [30.922288037523046, 0.985100547536747],
            [30.918435623206886, 0.986661798552905],
            [30.915860769531594, 0.988427402225474],
            [30.916235721839616, 0.99149022526656],
            [30.916823043067325, 0.993026518233575],
            [30.912226768000355, 0.993486214099295],
            [30.906907132635695, 0.992442871597242],
            [30.90578485207986, 0.988498472641344],
            [30.906810647285987, 0.982134602054901],
            [30.906040524287825, 0.978932762942501],
            [30.904497095560536, 0.977636444915595],
            [30.899845181539806, 0.97858383993065],
            [30.89965759444385, 0.970217571846167],
            [30.898722510216867, 0.966201435440551],
            [30.89899958568478, 0.964055046733121],
            [30.900048666121325, 0.962075680244741],
            [30.90159329859113, 0.961410463704342],
            [30.90282570182098, 0.960263926379023],
            [30.903341314132817, 0.958839368492567],
            [30.90168843736626, 0.95613663349404],
            [30.89858328302593, 0.953395998998433],
            [30.89806015181515, 0.952081833155847],
            [30.89830037659349, 0.951324264429292],
            [30.896325594833044, 0.950468604922205],
            [30.894873287614896, 0.950486216664695],
            [30.88922864088212, 0.952009376065802],
            [30.887086154437906, 0.953349642466475],
            [30.885580516037976, 0.955218072211925],
            [30.881558791748642, 0.958669563967504],
            [30.877810652972354, 0.955313014533474],
            [30.877581484658517, 0.950357528249432],
            [30.87991891090929, 0.944269975569346],
            [30.879528984583782, 0.942377829391831],
            [30.879666007309012, 0.9395058248578],
            [30.879134102252884, 0.937507001066707],
            [30.87836198499481, 0.937543537844029],
            [30.876283932909306, 0.938782071316265],
            [30.870676777364924, 0.939259744700473],
            [30.869573487194227, 0.939758687264126],
            [30.86909871948172, 0.940731511661196],
            [30.860426729580226, 0.943345910596204],
            [30.850094975528865, 0.944754269681476],
            [30.84998310473326, 0.941198554651825],
            [30.849793306883416, 0.938208625147416],
            [30.851126518156143, 0.93499245646648],
            [30.851278392727956, 0.932770697801587],
            [30.854820664590587, 0.921555307692252],
            [30.857408719907287, 0.919699874895714],
            [30.858182662541996, 0.917628261448306],
            [30.862690964694888, 0.913152968683962],
            [30.868610415056217, 0.909396117157759],
            [30.869825544581477, 0.907414060249739],
            [30.869810078287248, 0.906067011146869],
            [30.872463217444587, 0.904231439516135],
            [30.873833949550114, 0.900931124293709],
            [30.877571059709666, 0.898522061604609],
            [30.878684678709487, 0.895996629424158],
            [30.87934073363284, 0.89570995636673],
            [30.880254100189557, 0.894275212895593],
            [30.88091155828138, 0.891544745987086],
            [30.88194027840205, 0.889936375699323],
            [30.883855801896434, 0.888381442655932],
            [30.88502404655038, 0.889231436788688],
            [30.88595817047837, 0.891323014715536],
            [30.88850699007841, 0.894608788575152],
            [30.892142004909278, 0.896706766747746],
            [30.893275208080652, 0.897803106056685],
            [30.896947468859842, 0.900179219489638],
            [30.90244658133005, 0.901500746510668],
            [30.907441153224323, 0.90554135578928],
            [30.911825461816846, 0.906780405186416],
            [30.910341692004188, 0.904072217687576],
            [30.91182718388725, 0.906781706682266],
            [30.912986678950336, 0.907525309829108],
            [30.916180441313667, 0.907900352508997],
            [30.923709190268823, 0.907789901443217],
            [30.925862039678147, 0.908221744621143],
            [30.928261219714788, 0.90944782755252],
            [30.930178410482355, 0.911772591260587],
            [30.931500305677442, 0.914789710953845],
            [30.93011928876025, 0.918675002108498],
            [30.932341399176284, 0.922691939835724],
            [30.93318541040317, 0.925523737676531],
            [30.93430594104082, 0.927041829541741],
            [30.935352246581466, 0.929744216174008],
            [30.938071071450704, 0.933150797365761],
            [30.93831286109426, 0.934045195825568],
            [30.93991136822659, 0.935572831842005],
            [30.944156371474755, 0.938462185544925],
            [30.94496530798133, 0.939874548059377],
            [30.944569144652846, 0.941603585369932],
            [30.94490348772011, 0.942111615523806],
            [30.94718417817417, 0.945009830777125],
            [30.948386718709045, 0.94576176113275],
            [30.951607904841335, 0.949434963083102],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 130,
        District: "KAGADI",
        County: "BUYAGA",
        Subcounty: "KYANAISOKE",
        Population: 15321,
        Key: "KAGADIKYANAISOKE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.52823295803355, 1.023421481531817],
            [31.52708284946687, 1.028160836078015],
            [31.523942280843094, 1.033675735632978],
            [31.52118779645035, 1.036586705728487],
            [31.518505465639493, 1.038303854801065],
            [31.51590152182036, 1.039315580471248],
            [31.514781421475757, 1.040590290961561],
            [31.514141548803945, 1.042489330069969],
            [31.51455961755066, 1.04353861750828],
            [31.51446561514436, 1.044723362396168],
            [31.51316657848001, 1.047209923080239],
            [31.509900894300063, 1.048637349831567],
            [31.508964278445493, 1.048437925796236],
            [31.50837293276533, 1.049043605926638],
            [31.506653464785035, 1.049467857594901],
            [31.50552778680085, 1.050643064432012],
            [31.504183543318103, 1.050972405979333],
            [31.50374235552925, 1.050315668274003],
            [31.50426587660884, 1.049669157830284],
            [31.504312353645, 1.048449570504041],
            [31.50543252046496, 1.0478033461894],
            [31.505543061753926, 1.046981085836646],
            [31.506350939146827, 1.046750488172228],
            [31.50815130131674, 1.044127337615494],
            [31.50957538975687, 1.041337692570294],
            [31.509796351062253, 1.039933394803485],
            [31.510779082830243, 1.038741966645353],
            [31.511955389863882, 1.035813602803114],
            [31.513018652003844, 1.032351212575506],
            [31.511063740977487, 1.029454646149458],
            [31.508093787579003, 1.027671781222232],
            [31.504554136102048, 1.027670109726404],
            [31.501013627632314, 1.029513515822279],
            [31.496523921504142, 1.033646903506688],
            [31.491845036465325, 1.036825827753043],
            [31.489631796014397, 1.038860703509629],
            [31.47695859485308, 1.039013620136968],
            [31.4682462643071, 1.037735325320317],
            [31.46816826898088, 1.034110966791297],
            [31.46997934984876, 1.030126278958513],
            [31.4716337277002, 1.025010351866028],
            [31.472071227006495, 1.022010089277245],
            [31.47129429118525, 1.017881847466902],
            [31.469765822102357, 1.015149531477605],
            [31.46970705072322, 1.011998743517893],
            [31.468554451128252, 1.008874042714826],
            [31.466443635687707, 1.005519465797106],
            [31.465807065222865, 1.005248730103628],
            [31.461889648812765, 1.000660851209224],
            [31.458841738715567, 0.999709366802741],
            [31.456268107647396, 0.997568207251381],
            [31.454637203672675, 0.997137805172768],
            [31.454404966713827, 0.994109998422731],
            [31.45369283356057, 0.99296093669517],
            [31.45362113632279, 0.992050826552405],
            [31.451402885967518, 0.990507907250884],
            [31.45097502378758, 0.988855614773557],
            [31.451116291950864, 0.987202805019129],
            [31.450522961892208, 0.986436876684095],
            [31.450133811711122, 0.984426544125444],
            [31.449210372345153, 0.983134265559747],
            [31.449056772109685, 0.982255741832244],
            [31.44608056104692, 0.979567314729581],
            [31.44410465369741, 0.978481244831534],
            [31.44205131696031, 0.978325261653006],
            [31.438303502475847, 0.979072766498934],
            [31.43568551080231, 0.978864842254869],
            [31.435069801913293, 0.978192797424977],
            [31.43436536552536, 0.975130818153818],
            [31.432748841781713, 0.97399324666271],
            [31.431568176122326, 0.973915181768136],
            [31.430464175384234, 0.974560579192404],
            [31.42840891625245, 0.978564284662798],
            [31.42707380055131, 0.979442097099411],
            [31.425431122358138, 0.979363808683566],
            [31.42041456150235, 0.976351473157543],
            [31.41638452959326, 0.976917960097857],
            [31.413662450127767, 0.979784507290177],
            [31.41230032388267, 0.983504298090866],
            [31.411849385779693, 0.98721160450763],
            [31.410609449277885, 0.990169433093494],
            [31.407116683570532, 0.987975979708026],
            [31.40236265625484, 0.983234587215001],
            [31.401123091655563, 0.982596102979246],
            [31.397981864566688, 0.983066063826095],
            [31.394674622525084, 0.985005849458527],
            [31.389135625754577, 0.986944534587005],
            [31.386779182169246, 0.988399417580798],
            [31.383913777398455, 0.988287075716139],
            [31.381984378526173, 0.989783760375498],
            [31.38157009168681, 0.991835867669103],
            [31.378632817201737, 0.997838808852491],
            [31.378494482037883, 0.999003562756515],
            [31.37499627523487, 0.997060447687728],
            [31.373549904084108, 0.996796256328625],
            [31.372393126424743, 0.995935930643032],
            [31.369362436133272, 0.995795749059079],
            [31.36803948811265, 0.996682569276512],
            [31.36506334622017, 0.997679493440184],
            [31.364622097345883, 0.998511281731008],
            [31.35635785814174, 1.005926639922021],
            [31.35664747858258, 1.003205762047894],
            [31.35641329497455, 1.001156451578833],
            [31.358083688889174, 0.996386145819367],
            [31.35788114574204, 0.992782870632566],
            [31.355818930955003, 0.989916642695704],
            [31.350598474987617, 0.985439995840172],
            [31.34477504285205, 0.979610910784321],
            [31.344011906051886, 0.979163535189782],
            [31.3405877967851, 0.979943959187059],
            [31.340030561932878, 0.979749487098094],
            [31.33541768599948, 0.981936883160399],
            [31.33276277626269, 0.983862488040143],
            [31.326814109993364, 0.986119733041854],
            [31.326982257546565, 0.975865541639981],
            [31.328699000038263, 0.969811912179004],
            [31.329341175990496, 0.96642954004339],
            [31.329450775845036, 0.96332403559068],
            [31.32904045416936, 0.957104986588926],
            [31.327847713355926, 0.954602262008951],
            [31.32533151697374, 0.947018926484631],
            [31.32270690651319, 0.942595151860876],
            [31.32226774981518, 0.940884839695708],
            [31.322234796915623, 0.939528912049627],
            [31.323334269246352, 0.935296562156166],
            [31.32250562280409, 0.933936189869012],
            [31.322781114542185, 0.932530785085699],
            [31.322266978162343, 0.932022419413221],
            [31.321913774067347, 0.928979244148311],
            [31.322211236800648, 0.927311995723529],
            [31.322898260245104, 0.927046065442098],
            [31.32508487642763, 0.927246757832443],
            [31.326474755225124, 0.925548998599408],
            [31.32564909657951, 0.924638089103259],
            [31.326131555667466, 0.922232151839032],
            [31.32557572488205, 0.920831854060568],
            [31.325754247976757, 0.91739284230205],
            [31.326612840657322, 0.914413586659112],
            [31.328479194864673, 0.912927012692389],
            [31.329455101233123, 0.911481601793121],
            [31.32925974730323, 0.910697673792765],
            [31.3273269590874, 0.909401016850395],
            [31.32584518712792, 0.90150976807255],
            [31.327265642781054, 0.897820138718083],
            [31.329322428150505, 0.887926762905019],
            [31.331426093001383, 0.881516159425751],
            [31.331904408160934, 0.880424235367899],
            [31.333639408910802, 0.878952574943792],
            [31.336609347037935, 0.873338259632432],
            [31.339514198629466, 0.871546298759483],
            [31.34104902958121, 0.871275933538268],
            [31.34147450942901, 0.868742712402866],
            [31.34373174217603, 0.865558999438096],
            [31.346373825767156, 0.863429487237561],
            [31.349660324810547, 0.8622221312044],
            [31.351342688776327, 0.860672493317828],
            [31.352502918661305, 0.858943459844707],
            [31.353407608390693, 0.856028967869653],
            [31.353257410973498, 0.853107959819169],
            [31.354634192334146, 0.85257766221055],
            [31.35591411195093, 0.853117603062983],
            [31.356023815111765, 0.85011671621467],
            [31.35633438516335, 0.849827816573874],
            [31.357063091335327, 0.849745036942852],
            [31.359074931296174, 0.850671774391812],
            [31.36006318949981, 0.850456944406148],
            [31.3584617152321, 0.846697029694706],
            [31.35857265537304, 0.84387875094931],
            [31.359630014683276, 0.840441521217229],
            [31.361122366101835, 0.837771207897238],
            [31.363813824694265, 0.835249989168581],
            [31.36531867796666, 0.834405812437207],
            [31.369439831384906, 0.833375824296455],
            [31.37419094456581, 0.831154868084655],
            [31.376572905695085, 0.829079048807213],
            [31.37893666875333, 0.822450793898077],
            [31.379826432075948, 0.817370937795907],
            [31.37678473472728, 0.81249814307418],
            [31.37806108713409, 0.812516297997095],
            [31.379359547080064, 0.811960355094092],
            [31.380208085815987, 0.810363644722608],
            [31.380584242764787, 0.808248087932439],
            [31.38206429265386, 0.8075866549813],
            [31.384135451966173, 0.807665084486419],
            [31.384827719775252, 0.806069339814493],
            [31.387771816066614, 0.80620755619378],
            [31.388468028378117, 0.80518574544022],
            [31.392140838027963, 0.805241155241178],
            [31.396063292190185, 0.807512599835585],
            [31.406703625626495, 0.807409254434056],
            [31.4100705068198, 0.808275182018533],
            [31.421525640964873, 0.811237045808597],
            [31.42280763209673, 0.813272425492918],
            [31.429178266699438, 0.818475187130514],
            [31.434761508192622, 0.816894703061489],
            [31.439055888238677, 0.820125083474325],
            [31.444975953047688, 0.825354834074558],
            [31.445047297247534, 0.825996985564016],
            [31.444052385222594, 0.82715422130428],
            [31.440959569242693, 0.82987522844021],
            [31.437561512017457, 0.836973377136601],
            [31.43786204339578, 0.838690389686773],
            [31.437336315155527, 0.839295632986577],
            [31.43725749787079, 0.840125081471053],
            [31.43831525872796, 0.844648152607658],
            [31.43739082582526, 0.850157895843755],
            [31.43882140279669, 0.854621877845831],
            [31.440076319604227, 0.856775094359643],
            [31.447706780307442, 0.862703111965447],
            [31.449390425270817, 0.865005215289905],
            [31.450353854039978, 0.867305870197659],
            [31.45035275629869, 0.869991822425883],
            [31.449212251620715, 0.875916240883646],
            [31.449250785753136, 0.877634475500375],
            [31.45315242684858, 0.885180482835881],
            [31.454228289657024, 0.89319930761919],
            [31.45346180214085, 0.896121934470795],
            [31.4526599344772, 0.896477260922581],
            [31.452303643770914, 0.897207672439618],
            [31.452028217609843, 0.898906025284771],
            [31.450644148217307, 0.899211843323961],
            [31.448926503817063, 0.902281884884312],
            [31.448337876438938, 0.902202631862464],
            [31.44727889117803, 0.900780203524522],
            [31.44612112537188, 0.900937701843278],
            [31.44645401855827, 0.902537564004255],
            [31.445668935915723, 0.903011215598354],
            [31.44473820222965, 0.902463392127199],
            [31.44425600005986, 0.903366097666548],
            [31.44447154632071, 0.904057426971248],
            [31.44570756526957, 0.904452953537782],
            [31.44588385964408, 0.90516401526133],
            [31.44441156580918, 0.906664346606289],
            [31.4430937103379, 0.906791156673744],
            [31.441761678553164, 0.908796149518693],
            [31.439508810720103, 0.909133208892211],
            [31.439053383735672, 0.909861443318714],
            [31.438915151878078, 0.911895586486754],
            [31.435675699402772, 0.916100811711331],
            [31.435348771928147, 0.919949903104726],
            [31.434358281411054, 0.922380570225233],
            [31.434845789929227, 0.929293111963716],
            [31.433366958155684, 0.931055707523539],
            [31.43197059891173, 0.935703657610953],
            [31.43030906597907, 0.938356078200368],
            [31.430582210419317, 0.939948905083947],
            [31.430131167213453, 0.941259167482585],
            [31.432575820868095, 0.945824885231342],
            [31.432188520318203, 0.947856426293904],
            [31.432580356461973, 0.949199569419112],
            [31.43599370301334, 0.95121557966799],
            [31.4379167238471, 0.951117710925503],
            [31.44335128248269, 0.952897652998868],
            [31.446665829624195, 0.956493592226906],
            [31.447646874356074, 0.956652036551766],
            [31.44819653102054, 0.956138798132438],
            [31.44974679323222, 0.955922257940072],
            [31.45276844108207, 0.956358127191552],
            [31.455162000359977, 0.957188702382387],
            [31.457025516789297, 0.958552279273306],
            [31.45741739784886, 0.95981643954661],
            [31.459967207392335, 0.962286315355975],
            [31.462203637852333, 0.96347231929323],
            [31.463616333858003, 0.963749459766348],
            [31.46928545788566, 0.96774149981355],
            [31.471640002432455, 0.968117818652406],
            [31.471725614573966, 0.967680041357219],
            [31.47237584661767, 0.967475481020092],
            [31.472993945923633, 0.96815793438043],
            [31.473916306412956, 0.967941104836387],
            [31.474465563327122, 0.968336351147639],
            [31.475596101197034, 0.968260264828408],
            [31.476430084530385, 0.969238908598635],
            [31.47823179956313, 0.969957712112421],
            [31.479180116872588, 0.971049026574517],
            [31.485240079015743, 0.97346053101013],
            [31.486929652859992, 0.975073262446566],
            [31.487893554142993, 0.980750653078978],
            [31.49044398172741, 0.982361308005862],
            [31.495566820467833, 0.98298769016766],
            [31.49936101946199, 0.982980369077359],
            [31.50148839175154, 0.983849578458063],
            [31.504580161194124, 0.986184390485992],
            [31.50922218117032, 0.98779636940311],
            [31.50988025281149, 0.988610650131619],
            [31.510941911458666, 0.993585471098276],
            [31.512450524180487, 0.994924708724924],
            [31.51563022970627, 0.99531505766533],
            [31.517286521867554, 0.996066485532746],
            [31.518062764189406, 0.996980310335985],
            [31.518226097670993, 0.998418426201414],
            [31.519578944319207, 1.001485056325704],
            [31.522414787330614, 1.004814651896052],
            [31.526619838006503, 1.011057149532227],
            [31.527650326011624, 1.013544810679597],
            [31.52855409047627, 1.018691447512259],
            [31.52823295803355, 1.023421481531817],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 131,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "NKOOKO",
        Population: 34676,
        Key: "KAKUMIRONKOOKO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.191159796517915, 1.185751441885358],
            [31.186029958104807, 1.182298401397961],
            [31.182398693740218, 1.180841460608647],
            [31.174601674603544, 1.181065969273782],
            [31.169199416690617, 1.183378154646548],
            [31.162578437787932, 1.188196646913885],
            [31.15760548474931, 1.189112672951789],
            [31.1527237753907, 1.190823946565921],
            [31.130277982814818, 1.192044290126399],
            [31.12629054632156, 1.187255250409877],
            [31.118892952296168, 1.183919063955269],
            [31.117148918087814, 1.18248672632675],
            [31.1160559720176, 1.181009529337349],
            [31.11709709158414, 1.177300613255764],
            [31.118924590960468, 1.172979702254561],
            [31.11910087635184, 1.170440088824484],
            [31.11842609963965, 1.169366788110925],
            [31.114584909772947, 1.167879551187157],
            [31.107333878581127, 1.168208803343598],
            [31.106388011875755, 1.167869739131397],
            [31.105012353409244, 1.163217772720993],
            [31.105482072589833, 1.157367645875539],
            [31.104941488909713, 1.154877054641645],
            [31.102264057510467, 1.154703106968789],
            [31.097305720061485, 1.150447939797749],
            [31.09464808034459, 1.15167343646952],
            [31.092337270277383, 1.150888519497066],
            [31.09198077385689, 1.150174864774626],
            [31.090548746106283, 1.150048306872865],
            [31.088023902541174, 1.147196018530282],
            [31.08721231151287, 1.144179636972449],
            [31.085666836423357, 1.142308472037908],
            [31.084345562862424, 1.141592011193503],
            [31.083360629323682, 1.14002286846241],
            [31.083333637644326, 1.13930096343633],
            [31.084635452797894, 1.137652237227721],
            [31.085359132895846, 1.135815838596183],
            [31.08735540595112, 1.133911441564827],
            [31.089036567072753, 1.134536631822947],
            [31.09094910277052, 1.134258314645035],
            [31.09236421883757, 1.136222065839617],
            [31.09493574964463, 1.137593526830571],
            [31.096658407542485, 1.139374629587255],
            [31.098168454873836, 1.140168780770229],
            [31.099433871190385, 1.139702695010483],
            [31.100414903345868, 1.140271494458654],
            [31.102423848934897, 1.143251162509566],
            [31.103451399449042, 1.142182518234564],
            [31.103597457429416, 1.141061523842844],
            [31.104250845254686, 1.140984540016363],
            [31.104593979235318, 1.139685783080015],
            [31.10659937288569, 1.137218322376751],
            [31.106843607743475, 1.135811701768962],
            [31.107924248690917, 1.134804632948462],
            [31.108658287262397, 1.134699590190649],
            [31.108186996030057, 1.133860340128571],
            [31.108832553240997, 1.133210355683041],
            [31.108475546577417, 1.132440097597278],
            [31.109946403107866, 1.130183624587294],
            [31.10671574244426, 1.124797356802541],
            [31.107273939392133, 1.119133909179092],
            [31.10831438162893, 1.117176108349228],
            [31.107761124516788, 1.115539772994202],
            [31.10790789396286, 1.114541022084587],
            [31.107203733357707, 1.113807125888611],
            [31.10729637391801, 1.112058308440371],
            [31.107994915561054, 1.110280575023648],
            [31.109141842294985, 1.108860459366127],
            [31.10875778466328, 1.105531642481665],
            [31.109169425964126, 1.104656414126842],
            [31.109966599930406, 1.104748863227551],
            [31.111370459208633, 1.10412291486848],
            [31.1116532614365, 1.103412667039324],
            [31.114128914154954, 1.101976676003523],
            [31.11465557304983, 1.100865114744561],
            [31.114811551125882, 1.098954636134505],
            [31.115529103815266, 1.096798712384341],
            [31.11478901239541, 1.09554979136569],
            [31.11374264037941, 1.095557484029611],
            [31.11402619449715, 1.093951826598383],
            [31.11369460566455, 1.093397356279802],
            [31.115211537684218, 1.092456835006571],
            [31.115325129651925, 1.091765979104659],
            [31.11492584737275, 1.090884984172589],
            [31.113673802479198, 1.090474191659687],
            [31.114022246401507, 1.09023301432757],
            [31.11413493646063, 1.088948370134099],
            [31.113827535665333, 1.088036423116525],
            [31.115072233238195, 1.085987844280459],
            [31.114908187392572, 1.082889958015126],
            [31.115187483495873, 1.08261679947523],
            [31.116273510741777, 1.083111000201598],
            [31.117028045274765, 1.082891288182451],
            [31.118251759999186, 1.080318156988697],
            [31.117916110781508, 1.078715696074172],
            [31.118645712573787, 1.077615428630964],
            [31.119528693616022, 1.077069309969221],
            [31.119763190736105, 1.076036858164841],
            [31.12063127950752, 1.075171837772188],
            [31.12053118832026, 1.072996317218819],
            [31.120904718595177, 1.072142547190999],
            [31.11978957156103, 1.069917216197544],
            [31.120242972844512, 1.068664712126062],
            [31.11999590470035, 1.065574359103113],
            [31.120501547509132, 1.06524818781463],
            [31.120655565461217, 1.064196506009234],
            [31.11966572262943, 1.06268895698847],
            [31.11975706961575, 1.061337525610033],
            [31.120949255270343, 1.060935847251958],
            [31.121326943846693, 1.060123666840548],
            [31.122443525490336, 1.059995274648545],
            [31.123938322123134, 1.05818154732614],
            [31.123727503695612, 1.057498080035749],
            [31.12446798408601, 1.055547220651736],
            [31.124570790880362, 1.053654987659721],
            [31.12568138435436, 1.053107900123294],
            [31.126334167613418, 1.053634148472654],
            [31.12692227037543, 1.05310865278434],
            [31.127764521802664, 1.049428006031542],
            [31.129328808512565, 1.047891201103005],
            [31.13001421498951, 1.046456250079711],
            [31.13185488007467, 1.044892808584369],
            [31.132018759731928, 1.043968628962624],
            [31.1359141377732, 1.045201607887727],
            [31.14391948071583, 1.045457942605497],
            [31.148536416136018, 1.046580216670299],
            [31.154820659757824, 1.043623973842652],
            [31.156416699218063, 1.0435844482394],
            [31.15825877106494, 1.042944868456851],
            [31.160841552372613, 1.042888505816288],
            [31.162070988467082, 1.043498929335846],
            [31.16403502997, 1.043426184151461],
            [31.16750245510147, 1.046347396914976],
            [31.16856687337319, 1.046662113188911],
            [31.173174963981086, 1.046553100157877],
            [31.17600864834087, 1.043374001585664],
            [31.17723420550997, 1.040329985948283],
            [31.177714231960117, 1.035471110481009],
            [31.17841240709051, 1.034289059323039],
            [31.179605865657862, 1.033643093473325],
            [31.181294274387213, 1.034124444714875],
            [31.184451348656015, 1.034181696698984],
            [31.188105387109648, 1.031837354510775],
            [31.190566611088023, 1.028993463516507],
            [31.19176010289303, 1.028292057909455],
            [31.193615105988428, 1.026316181641516],
            [31.19605443802333, 1.024789343279095],
            [31.197377901676926, 1.02641070517413],
            [31.198327528730047, 1.029660623534977],
            [31.20075055005436, 1.034837730910972],
            [31.20089657928862, 1.036278951049623],
            [31.201580747887103, 1.037375138397388],
            [31.20252329711413, 1.0376597795153],
            [31.203363491399344, 1.038588299136638],
            [31.20352559598564, 1.04271289989406],
            [31.20543530288858, 1.046518579169327],
            [31.208085527012845, 1.047590491837781],
            [31.210141460779415, 1.047406915860556],
            [31.21377684212293, 1.045709195480964],
            [31.216236731204784, 1.04530412902341],
            [31.219466412704755, 1.046931894220482],
            [31.221410656237104, 1.049519692469634],
            [31.222800738952145, 1.052602001379985],
            [31.222360850127203, 1.057095534453279],
            [31.22371778860153, 1.059535194949189],
            [31.225271457224768, 1.060443726681739],
            [31.226221228906663, 1.063538063698062],
            [31.22764821800685, 1.066069167945859],
            [31.227997200020017, 1.06778737229444],
            [31.226937108034686, 1.074277383618873],
            [31.22723622995629, 1.078615182527447],
            [31.22850583960859, 1.083451338871385],
            [31.228587702182114, 1.085100378255802],
            [31.228192359015477, 1.086290502379019],
            [31.228197833348823, 1.089288386607721],
            [31.227070962401918, 1.092943981833035],
            [31.227838785712905, 1.099492038779682],
            [31.227224245532117, 1.101601769667757],
            [31.228216669223695, 1.105004537297691],
            [31.22706426725809, 1.108048257685104],
            [31.226877652139294, 1.109785141136201],
            [31.227874308692495, 1.111177209035427],
            [31.227762196250104, 1.112456542795545],
            [31.228216110471596, 1.113717542155285],
            [31.22798324828533, 1.115197583312307],
            [31.228372187362332, 1.116495898514246],
            [31.227530887250957, 1.117707895183823],
            [31.225350277204424, 1.124748304766547],
            [31.22470902831357, 1.125493834550984],
            [31.224356288647606, 1.128337443159432],
            [31.221474148263056, 1.134623863589206],
            [31.219524488787872, 1.137130864357924],
            [31.216714811904055, 1.139690311489668],
            [31.216246553384114, 1.14090564225745],
            [31.216727782678444, 1.143507208629418],
            [31.215876990069475, 1.146994776955816],
            [31.21554537249076, 1.152736296811838],
            [31.213991890717114, 1.159182690169696],
            [31.214035697960277, 1.160644565768206],
            [31.21081795417213, 1.163018148017434],
            [31.208685177617813, 1.163806267956936],
            [31.205745695073777, 1.165957518344141],
            [31.204995374537766, 1.168361371133871],
            [31.199273641573832, 1.174592966079021],
            [31.199300334114184, 1.176883903579204],
            [31.198639384270844, 1.179356836149338],
            [31.197454810939956, 1.180487172022195],
            [31.195626049430636, 1.181330536961488],
            [31.195073465156657, 1.182248331880496],
            [31.194770076237436, 1.18412004333347],
            [31.191159796517915, 1.185751441885358],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 132,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KAKINDO",
        Population: 35846,
        Key: "KAKUMIROKAKINDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.504183543318103, 1.050972405979333],
            [31.502682140474718, 1.052703771408363],
            [31.50239457537924, 1.052785030070429],
            [31.501946254068702, 1.051997965579219],
            [31.49980369845422, 1.054059005777209],
            [31.498583202393466, 1.053877528289648],
            [31.49580138765649, 1.055160448354402],
            [31.49542725101876, 1.054843719255086],
            [31.49347111019878, 1.055213575591004],
            [31.49231461820369, 1.054787566100811],
            [31.49105770264468, 1.055890707744031],
            [31.48997324745053, 1.055428923621177],
            [31.486109625752878, 1.057552024560061],
            [31.485597542921806, 1.058654847272163],
            [31.480932535955812, 1.06272591091518],
            [31.480727660782218, 1.063497654557474],
            [31.48112282608247, 1.064586456665271],
            [31.480106076012955, 1.065554199903304],
            [31.48039612225525, 1.066546966463501],
            [31.47919333468368, 1.067299597214506],
            [31.478646843682284, 1.068534904790967],
            [31.477898180537988, 1.069155195836524],
            [31.476910781123774, 1.071698337066294],
            [31.475934834331092, 1.07177365840367],
            [31.475559145404546, 1.072777175698242],
            [31.474627130720876, 1.073041382284256],
            [31.471565264397444, 1.072818183788072],
            [31.470813010686953, 1.073626441288682],
            [31.469013548628926, 1.073262894024044],
            [31.46719031535188, 1.074144659306239],
            [31.466376378822385, 1.077560775813255],
            [31.46579492449179, 1.078137263744357],
            [31.46465849636857, 1.077903935315687],
            [31.462870443812985, 1.078809862348755],
            [31.461446369745914, 1.08181469851961],
            [31.459650457829884, 1.083754690599013],
            [31.45857199709363, 1.087330258970064],
            [31.4575372825151, 1.089237814309489],
            [31.455826967469264, 1.091673029331576],
            [31.453596846775806, 1.093874483174723],
            [31.446011368312156, 1.092114137008764],
            [31.442504741599986, 1.087690251456392],
            [31.44010936862351, 1.085851267398753],
            [31.434505166739783, 1.083019964129913],
            [31.430928763387936, 1.078746196556334],
            [31.4180746720711, 1.079055747826714],
            [31.41545042722487, 1.078323785643511],
            [31.410071233556852, 1.078103083509872],
            [31.405993471461777, 1.077004375943326],
            [31.39918035010636, 1.076844008284617],
            [31.390883255919007, 1.075841790162546],
            [31.388717787874885, 1.074473269942417],
            [31.387597239270924, 1.07336209823324],
            [31.38620248621471, 1.068413859890609],
            [31.386278277075252, 1.067316117959055],
            [31.38554665407357, 1.064372447530703],
            [31.383444758903767, 1.057311577530675],
            [31.383068209391208, 1.055382004490168],
            [31.38340489167149, 1.050164097646915],
            [31.381460360678226, 1.047649050407665],
            [31.379355415728085, 1.046464020109091],
            [31.376946276968184, 1.043831805019687],
            [31.373985208806165, 1.041462402146697],
            [31.37350602317909, 1.041447536586542],
            [31.37220141695997, 1.037003471048167],
            [31.370924382731868, 1.035424238654735],
            [31.36943374260391, 1.025586641126721],
            [31.368011646627078, 1.023715014002194],
            [31.362338007666807, 1.018781229812663],
            [31.361401250776733, 1.018738803699375],
            [31.359729232708087, 1.017931129349938],
            [31.359536089532124, 1.015600561341932],
            [31.357514513630207, 1.010696546450233],
            [31.35635785814174, 1.005926639922021],
            [31.364622097345883, 0.998511281731008],
            [31.36506334622017, 0.997679493440184],
            [31.36803948811265, 0.996682569276512],
            [31.369362436133272, 0.995795749059079],
            [31.372393126424743, 0.995935930643032],
            [31.373549904084108, 0.996796256328625],
            [31.37499627523487, 0.997060447687728],
            [31.378494482037883, 0.999003562756515],
            [31.378632817201737, 0.997838808852491],
            [31.38157009168681, 0.991835867669103],
            [31.381984378526173, 0.989783760375498],
            [31.383913777398455, 0.988287075716139],
            [31.386779182169246, 0.988399417580798],
            [31.389135625754577, 0.986944534587005],
            [31.394674622525084, 0.985005849458527],
            [31.397981864566688, 0.983066063826095],
            [31.401123091655563, 0.982596102979246],
            [31.40236265625484, 0.983234587215001],
            [31.407116683570532, 0.987975979708026],
            [31.410609449277885, 0.990169433093494],
            [31.411849385779693, 0.98721160450763],
            [31.41230032388267, 0.983504298090866],
            [31.413662450127767, 0.979784507290177],
            [31.41638452959326, 0.976917960097857],
            [31.42041456150235, 0.976351473157543],
            [31.425431122358138, 0.979363808683566],
            [31.42707380055131, 0.979442097099411],
            [31.42840891625245, 0.978564284662798],
            [31.430464175384234, 0.974560579192404],
            [31.431568176122326, 0.973915181768136],
            [31.432748841781713, 0.97399324666271],
            [31.43436536552536, 0.975130818153818],
            [31.435069801913293, 0.978192797424977],
            [31.43568551080231, 0.978864842254869],
            [31.438303502475847, 0.979072766498934],
            [31.44205131696031, 0.978325261653006],
            [31.44410465369741, 0.978481244831534],
            [31.44608056104692, 0.979567314729581],
            [31.449056772109685, 0.982255741832244],
            [31.449210372345153, 0.983134265559747],
            [31.450133811711122, 0.984426544125444],
            [31.450522961892208, 0.986436876684095],
            [31.451116291950864, 0.987202805019129],
            [31.45097502378758, 0.988855614773557],
            [31.451402885967518, 0.990507907250884],
            [31.45362113632279, 0.992050826552405],
            [31.45369283356057, 0.99296093669517],
            [31.454404966713827, 0.994109998422731],
            [31.454637203672675, 0.997137805172768],
            [31.456268107647396, 0.997568207251381],
            [31.458841738715567, 0.999709366802741],
            [31.461889648812765, 1.000660851209224],
            [31.465807065222865, 1.005248730103628],
            [31.466443635687707, 1.005519465797106],
            [31.468554451128252, 1.008874042714826],
            [31.46970705072322, 1.011998743517893],
            [31.469765822102357, 1.015149531477605],
            [31.47129429118525, 1.017881847466902],
            [31.472071227006495, 1.022010089277245],
            [31.4716337277002, 1.025010351866028],
            [31.46997934984876, 1.030126278958513],
            [31.46816826898088, 1.034110966791297],
            [31.4682462643071, 1.037735325320317],
            [31.47695859485308, 1.039013620136968],
            [31.489631796014397, 1.038860703509629],
            [31.491845036465325, 1.036825827753043],
            [31.496523921504142, 1.033646903506688],
            [31.501013627632314, 1.029513515822279],
            [31.504554136102048, 1.027670109726404],
            [31.508093787579003, 1.027671781222232],
            [31.511063740977487, 1.029454646149458],
            [31.513018652003844, 1.032351212575506],
            [31.511955389863882, 1.035813602803114],
            [31.510779082830243, 1.038741966645353],
            [31.509796351062253, 1.039933394803485],
            [31.50957538975687, 1.041337692570294],
            [31.50815130131674, 1.044127337615494],
            [31.506350939146827, 1.046750488172228],
            [31.505543061753926, 1.046981085836646],
            [31.50543252046496, 1.0478033461894],
            [31.504312353645, 1.048449570504041],
            [31.50426587660884, 1.049669157830284],
            [31.50374235552925, 1.050315668274003],
            [31.504183543318103, 1.050972405979333],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 133,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "MPASAANA",
        Population: 23021,
        Key: "KAKUMIROMPASAANA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.322196313088835, 0.825242744041187],
            [31.31146934612654, 0.82752753299344],
            [31.309249516533, 0.826876077970724],
            [31.305835772027958, 0.826859203977111],
            [31.305537322046177, 0.824439695671207],
            [31.3058374087584, 0.823061740704549],
            [31.30759302225077, 0.819775188672512],
            [31.30709117751898, 0.817208599096834],
            [31.30787200663868, 0.814397213856544],
            [31.307384358881613, 0.813250481861229],
            [31.30665915883421, 0.812738332014964],
            [31.306864343926566, 0.808425299815612],
            [31.307557818173084, 0.80369617291398],
            [31.30844019195418, 0.801191928100065],
            [31.30804049106009, 0.800482006780682],
            [31.30816635581117, 0.799617248832498],
            [31.309970295970892, 0.796910592949907],
            [31.308971717921267, 0.794247666464884],
            [31.307854976377502, 0.793218333657456],
            [31.3073091680957, 0.791040729991181],
            [31.30398242542594, 0.788670565294817],
            [31.299085194975852, 0.790534862279983],
            [31.29775332578615, 0.792472407236648],
            [31.295232764490006, 0.794959776047019],
            [31.29439964803089, 0.797854605734361],
            [31.292019222122452, 0.800908078332728],
            [31.291308812836192, 0.800086000662045],
            [31.29286923050216, 0.797343205770817],
            [31.292869738050317, 0.79611479485137],
            [31.292148816678584, 0.794640638927941],
            [31.288013970240495, 0.794625551377242],
            [31.286774711068364, 0.795327157905571],
            [31.284104197595095, 0.794965735795232],
            [31.28199309559198, 0.795620780786141],
            [31.281093928704973, 0.795066094001698],
            [31.28152581982896, 0.793745174690212],
            [31.281379319877484, 0.792922889895483],
            [31.28028305722725, 0.790858510625138],
            [31.280057993315957, 0.7910577155142],
            [31.280712053081057, 0.789570140030637],
            [31.28477792327842, 0.7862459898224],
            [31.291317916363276, 0.77763496656972],
            [31.29318088392201, 0.771802220339786],
            [31.29498720192228, 0.767577312766458],
            [31.294909194019628, 0.766432015797828],
            [31.289791755950688, 0.760841857051513],
            [31.287595471200735, 0.759202067488554],
            [31.28451615150966, 0.758430744617304],
            [31.282809595014985, 0.758469552030473],
            [31.281691885087323, 0.757541050172479],
            [31.28141789353578, 0.755961272376276],
            [31.279966520565512, 0.755546029922701],
            [31.281990571326034, 0.746187309153165],
            [31.281793598632003, 0.742698711470875],
            [31.28859358392304, 0.739807851437666],
            [31.298049721320904, 0.735806965629751],
            [31.313607065211524, 0.730516576882962],
            [31.32151087067927, 0.726741959177961],
            [31.323057259355462, 0.728746732064249],
            [31.324794103448276, 0.729647039657216],
            [31.325702705340696, 0.730620564592853],
            [31.328136775942966, 0.736156103889629],
            [31.328683455590593, 0.738588077633715],
            [31.331814679040455, 0.740833008597342],
            [31.33513219511396, 0.745462965487303],
            [31.333727919915752, 0.748502835114953],
            [31.3337275938273, 0.749364361749471],
            [31.334327078243945, 0.750697926775392],
            [31.33423165021131, 0.751619101370223],
            [31.33583498758494, 0.754514957712299],
            [31.33594045878245, 0.75841519614203],
            [31.3373306187526, 0.759348912973002],
            [31.337056905678796, 0.76029394648015],
            [31.33331198736277, 0.763450924883637],
            [31.332401875402365, 0.765489097185969],
            [31.336173665023438, 0.766879578386809],
            [31.338706149658357, 0.770264583050317],
            [31.34033286029736, 0.771289972852],
            [31.340760211335873, 0.7725822348091],
            [31.34159199020355, 0.77298933312867],
            [31.34228042490131, 0.7752627337462],
            [31.343013503173765, 0.776301302110949],
            [31.347444322938436, 0.774334663087667],
            [31.35001872476112, 0.773873705927829],
            [31.351794593466508, 0.774256031748389],
            [31.35366398038623, 0.775621696401766],
            [31.358097970305565, 0.780685939861901],
            [31.350588967218645, 0.787840054399431],
            [31.348128130414153, 0.789502047011126],
            [31.3474024803108, 0.791188661229392],
            [31.348067071025977, 0.793617592923879],
            [31.34788857847397, 0.795688059011652],
            [31.349533703677974, 0.796519425244092],
            [31.350697645401723, 0.798481973165118],
            [31.350161666485757, 0.801365051558582],
            [31.35106321031501, 0.804153851834622],
            [31.34948648822663, 0.805270822766392],
            [31.347135721993926, 0.808318657948297],
            [31.345854867230894, 0.808758735614933],
            [31.34579260859183, 0.809219526318369],
            [31.3462290838187, 0.809466533884488],
            [31.34601002784002, 0.809706594558937],
            [31.343455441055884, 0.811281130703272],
            [31.343687457927448, 0.810581423066757],
            [31.341859260560135, 0.811534708660848],
            [31.338835356142308, 0.812403773762046],
            [31.334075937138273, 0.812633831629434],
            [31.329519169079212, 0.814679321922596],
            [31.327328050540476, 0.817804082882934],
            [31.32719200338562, 0.818895966254958],
            [31.327896449655018, 0.820424979550131],
            [31.327461879754857, 0.821538195002506],
            [31.322196313088835, 0.825242744041187],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 134,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KAKUMIRO  TOWN COUNCIL",
        Population: 9834,
        Key: "KAKUMIROKAKUMIRO  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19943114678585, 0.95349469670641],
            [31.199037667623422, 0.95347994751369],
            [31.195215753806107, 0.957950137421858],
            [31.194888067255064, 0.959230071021514],
            [31.19565061925198, 0.960144839972018],
            [31.1934867573956, 0.963819420543153],
            [31.19344966775414, 0.965245805958935],
            [31.191595369836232, 0.96754900213429],
            [31.19032384497576, 0.96718257317274],
            [31.185490620387995, 0.968496642492879],
            [31.184037758909298, 0.967508351977692],
            [31.180949136265152, 0.967835847186939],
            [31.180512573901694, 0.96885968874076],
            [31.177441251013285, 0.970814739167887],
            [31.173187660769326, 0.975347606818057],
            [31.171552031656212, 0.97640735732094],
            [31.16778887394665, 0.981068468174581],
            [31.165389918488852, 0.982676393369734],
            [31.161683365421997, 0.983478959451768],
            [31.155633485071306, 0.983859612956866],
            [31.1487288721008, 0.985867297117918],
            [31.143442087227776, 0.986175200285517],
            [31.14086200445921, 0.986832066927697],
            [31.13342940937541, 0.990942352906027],
            [31.13063149503195, 0.991306492501925],
            [31.128774889342065, 0.992969459528865],
            [31.126426811767004, 0.997249111136068],
            [31.12585388963498, 0.997715363120546],
            [31.12440956125318, 0.997163698782215],
            [31.12526269846504, 0.996319923047604],
            [31.123271187379046, 0.996239915015671],
            [31.12183108826562, 0.994915883209693],
            [31.12185400069525, 0.994009503747361],
            [31.120939325293193, 0.99341456715872],
            [31.1222412329732, 0.98907172801331],
            [31.120942637381628, 0.98411258704434],
            [31.12210481571248, 0.982751351245005],
            [31.122632926284865, 0.976143777782111],
            [31.12339229824566, 0.975689479413544],
            [31.123082680408267, 0.974664334866616],
            [31.12353291962193, 0.973709616738557],
            [31.123211451209293, 0.972708341776031],
            [31.121097838414954, 0.972234449915817],
            [31.120289653798253, 0.971257747094325],
            [31.120478957574694, 0.970565781666563],
            [31.12214022101278, 0.96972852453383],
            [31.122590768348584, 0.969107723929757],
            [31.122399420006513, 0.967605379548131],
            [31.121298407963398, 0.965802779360332],
            [31.121625021027643, 0.964672826756887],
            [31.122918346203445, 0.963931515325293],
            [31.12334472346821, 0.962857574928672],
            [31.12281966626949, 0.95997235531521],
            [31.123079993547247, 0.959065620623098],
            [31.122699472582784, 0.958398352031845],
            [31.12158322062084, 0.958066099103234],
            [31.121274021398357, 0.957494130956305],
            [31.11886340131658, 0.956782186086914],
            [31.118601174102, 0.955661572577812],
            [31.119051379179673, 0.954683000361625],
            [31.11821830314476, 0.952489933518002],
            [31.11883477470344, 0.951582668713887],
            [31.120009529448257, 0.951008484548229],
            [31.119628333849004, 0.949625686055276],
            [31.12055346653931, 0.948717955235031],
            [31.120765063806154, 0.946499475629389],
            [31.122744581484767, 0.943276593408077],
            [31.122576979208972, 0.941798067713934],
            [31.123763147947773, 0.940746831261503],
            [31.12521148730731, 0.940744656733343],
            [31.125756722463965, 0.93983749125183],
            [31.127595968210976, 0.938928377350441],
            [31.128188258020497, 0.937567960664823],
            [31.129257341243516, 0.938234190467413],
            [31.130135527977036, 0.937898950003655],
            [31.130467412355383, 0.937349869926122],
            [31.13097693947949, 0.936347345759968],
            [31.130856516722414, 0.934558674634259],
            [31.132089736520857, 0.9330541793031],
            [31.13208827765684, 0.931527692782204],
            [31.131660374154407, 0.930979756909567],
            [31.132728298550667, 0.930429563783122],
            [31.133297109991947, 0.929355392952153],
            [31.132712702899024, 0.926541810929755],
            [31.133447349629975, 0.925085766382377],
            [31.139011532466103, 0.921308811314872],
            [31.141466599391507, 0.918848380716282],
            [31.143578446996308, 0.917485636255166],
            [31.144117310402656, 0.916285676630772],
            [31.147160257307853, 0.913926303664936],
            [31.15178981046454, 0.913489918069312],
            [31.153782731905505, 0.911912669381285],
            [31.155468148346625, 0.911528469054922],
            [31.15816052591558, 0.908948370551246],
            [31.160106681062857, 0.90811058308706],
            [31.16136387420131, 0.906868366184106],
            [31.162075155751687, 0.905817797540858],
            [31.162346033742484, 0.903599166231775],
            [31.163056562504664, 0.901785338873051],
            [31.163372389497294, 0.896990641817927],
            [31.16284805993395, 0.894987896965814],
            [31.16369925049657, 0.891361112147737],
            [31.166130601898494, 0.888972180977659],
            [31.166815288824868, 0.885059420552371],
            [31.16728994424798, 0.884844020361035],
            [31.167407668465966, 0.883842060038768],
            [31.168297077852362, 0.882862759453849],
            [31.168367883063052, 0.88243331599733],
            [31.16734601259641, 0.881528525068562],
            [31.16701237111338, 0.880288745892416],
            [31.16722523141154, 0.879453598910727],
            [31.168886585579433, 0.878759322452204],
            [31.17097644062947, 0.879185419603386],
            [31.172163330715474, 0.87889735840743],
            [31.172661255199362, 0.878204880061485],
            [31.172659066005004, 0.876010506258358],
            [31.174878561425256, 0.875482317252794],
            [31.175638592749486, 0.875719657671183],
            [31.177513593241404, 0.874977335238505],
            [31.179318606887893, 0.875475422589595],
            [31.180386805270334, 0.875211390034941],
            [31.180980776726084, 0.875592098324748],
            [31.18157384268003, 0.875066432333561],
            [31.182879455910598, 0.874778178603535],
            [31.18461034956297, 0.872390276918992],
            [31.183431639535968, 0.869005116953005],
            [31.1841665395918, 0.867859070171628],
            [31.18463860427361, 0.865067640188524],
            [31.185136426349562, 0.864279743921369],
            [31.186537010370273, 0.863991331282192],
            [31.187841946271124, 0.863035206615598],
            [31.189417039713874, 0.859216400226896],
            [31.190271979844507, 0.85938202644498],
            [31.19048509256925, 0.858809239673299],
            [31.19188529211103, 0.85813918696191],
            [31.19334630310599, 0.855838802270837],
            [31.194921248326718, 0.855261361316114],
            [31.19595335958756, 0.855589317637794],
            [31.196919135654575, 0.855249608170144],
            [31.199545848172907, 0.856075879843724],
            [31.20079006155379, 0.85604247432896],
            [31.201998651343782, 0.857970571431917],
            [31.2065692148307, 0.860073067506754],
            [31.21081266040013, 0.859862685105475],
            [31.2112578744381, 0.86033488073304],
            [31.214235322481002, 0.860194693774606],
            [31.217142267147167, 0.860432060302409],
            [31.21754066189085, 0.860762638965465],
            [31.221788593646817, 0.856202143722641],
            [31.2282952978622, 0.856797286553886],
            [31.231236787242587, 0.855762484528464],
            [31.235613179880854, 0.852211908706341],
            [31.238720114682067, 0.85115866147581],
            [31.2415831955112, 0.849221433280263],
            [31.242393575610482, 0.849118610830272],
            [31.24499551349159, 0.851739896212797],
            [31.24633716084313, 0.855632096929462],
            [31.24880286022824, 0.858481241411235],
            [31.246588098929553, 0.863478691360962],
            [31.243295709632864, 0.868450354257679],
            [31.24001487895896, 0.871496009701656],
            [31.23263499162615, 0.874095322027674],
            [31.22285999003166, 0.873836732533431],
            [31.22222729849222, 0.878153250065692],
            [31.223297537847, 0.882089691854687],
            [31.224495054104473, 0.883613854917009],
            [31.225502616205237, 0.88672499532105],
            [31.225943193139724, 0.888566209283017],
            [31.225676885777087, 0.890100661335186],
            [31.225938659342475, 0.891236220113727],
            [31.225320114472122, 0.892384375885908],
            [31.222514114392755, 0.895014883555714],
            [31.22075380181314, 0.897933008952748],
            [31.220092801664162, 0.8998052439776],
            [31.22139365112879, 0.906783510273439],
            [31.22164435744986, 0.909957766501976],
            [31.221138582588704, 0.912496819175666],
            [31.21979761975339, 0.91486432988181],
            [31.21712748716579, 0.91443921053382],
            [31.20955466057459, 0.916072848934503],
            [31.208605479085822, 0.916670620158034],
            [31.207795212174275, 0.925735777088845],
            [31.207392729197743, 0.926929014112241],
            [31.20465231871051, 0.929032219819355],
            [31.201825787635357, 0.938346419911514],
            [31.201076750791902, 0.938346030993166],
            [31.1995074631608, 0.939397952592639],
            [31.198354065861867, 0.940871130558174],
            [31.19884597971818, 0.943082186594867],
            [31.19849713155401, 0.945590709271668],
            [31.200459919008782, 0.94762894110682],
            [31.201267171174237, 0.949352026731781],
            [31.20093338685906, 0.951313772654822],
            [31.19943114678585, 0.95349469670641],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 135,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "BIREMBO",
        Population: 27454,
        Key: "KAKUMIROBIREMBO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.29792938390376, 1.020062762053811],
            [31.297209283592206, 1.020805885992607],
            [31.29942731475856, 1.022383631063762],
            [31.303210547119726, 1.025976710644143],
            [31.305603564713543, 1.025759023561509],
            [31.307865117458736, 1.027336798528748],
            [31.30834330595583, 1.028081544673683],
            [31.30877703862616, 1.030621801159828],
            [31.308515483351407, 1.031585118833],
            [31.3087750659258, 1.034344250904692],
            [31.310167144697417, 1.034651553992481],
            [31.311297272935526, 1.03666666605608],
            [31.318819897177107, 1.044597378451454],
            [31.321603611850875, 1.046087870189432],
            [31.32351572174722, 1.050293113570713],
            [31.325103319738737, 1.061074719150324],
            [31.322812521441136, 1.063000012503297],
            [31.321380320315658, 1.06368288669089],
            [31.322104332790264, 1.065678833065018],
            [31.321837204367487, 1.067434030122653],
            [31.322726440379036, 1.069402353884207],
            [31.323083005071478, 1.071961658161608],
            [31.322852606065755, 1.073679921183093],
            [31.321548656515077, 1.074797074503874],
            [31.321455662018554, 1.077005061236791],
            [31.321785700358994, 1.077707381882279],
            [31.32128044921565, 1.078501624157619],
            [31.321206107337655, 1.080164540042506],
            [31.32073783354636, 1.080478393333596],
            [31.319755958771164, 1.080080583145473],
            [31.319442198801987, 1.083147635934847],
            [31.31887277291306, 1.083803260104355],
            [31.317633667352833, 1.08383028198277],
            [31.317156178643348, 1.084208798423345],
            [31.318706031223254, 1.086565518867458],
            [31.31974281282527, 1.087258999468423],
            [31.321127732024095, 1.089116745084489],
            [31.325917644340436, 1.091392147476387],
            [31.327779386597097, 1.094090887399783],
            [31.32800787398793, 1.095846364427662],
            [31.330778282815725, 1.098564099809802],
            [31.33226338662657, 1.101835435760845],
            [31.332665665685536, 1.104662705655896],
            [31.332132698820736, 1.105752570731078],
            [31.332132108627576, 1.106805781101398],
            [31.330368701351826, 1.108800336503316],
            [31.324514835192755, 1.105138488917363],
            [31.31754010332441, 1.103453079240133],
            [31.309280084405465, 1.102358198955963],
            [31.306232575855244, 1.10281837994372],
            [31.30443286586222, 1.104110744956381],
            [31.303752767530288, 1.105680909297638],
            [31.30497891668914, 1.112277954548302],
            [31.30391168130069, 1.116693369099368],
            [31.30183476738064, 1.121163619444743],
            [31.299097160535453, 1.125337834471172],
            [31.293091451245573, 1.130452429951003],
            [31.288260536226414, 1.135623113275971],
            [31.283504182274136, 1.138853727653096],
            [31.283097561657403, 1.143509668624985],
            [31.28060712266936, 1.148653980828964],
            [31.28077971149331, 1.151656581192134],
            [31.28186068302078, 1.155130898395965],
            [31.28179499641059, 1.157514379986482],
            [31.282638599802322, 1.15887294886758],
            [31.28238907027428, 1.161699764390435],
            [31.282926745209494, 1.163766242794398],
            [31.281130173930066, 1.16407327390229],
            [31.27931308602786, 1.163647186680882],
            [31.278286057434894, 1.162057543691053],
            [31.277278070431, 1.159340823270322],
            [31.27098512752396, 1.15957605375181],
            [31.269761877228543, 1.157737956460081],
            [31.266423015387275, 1.15429922108312],
            [31.264355549049068, 1.153521288718408],
            [31.25158303374318, 1.155573499965123],
            [31.247602535837174, 1.156791865953991],
            [31.24578375101742, 1.164485506509725],
            [31.242915920795365, 1.171209159193869],
            [31.2406715573131, 1.178930916507176],
            [31.238759494129162, 1.183622722697417],
            [31.23321006701989, 1.192561751399562],
            [31.2300464575074, 1.202278283849633],
            [31.22703203929895, 1.208299603725548],
            [31.22438398191116, 1.215466677460355],
            [31.224877584600247, 1.217685149866599],
            [31.220568540455467, 1.217826359180436],
            [31.216763177198946, 1.21682696200041],
            [31.214456150835748, 1.214305498626345],
            [31.208700070786918, 1.20042056664507],
            [31.20562500821196, 1.195792127112756],
            [31.202353957496552, 1.192504056124976],
            [31.20000044511402, 1.190801589633073],
            [31.191159796517915, 1.185751441885358],
            [31.194770076237436, 1.18412004333347],
            [31.195073465156657, 1.182248331880496],
            [31.195626049430636, 1.181330536961488],
            [31.197454810939956, 1.180487172022195],
            [31.198639384270844, 1.179356836149338],
            [31.199300334114184, 1.176883903579204],
            [31.199273641573832, 1.174592966079021],
            [31.204995374537766, 1.168361371133871],
            [31.205745695073777, 1.165957518344141],
            [31.208685177617813, 1.163806267956936],
            [31.21081795417213, 1.163018148017434],
            [31.214035697960277, 1.160644565768206],
            [31.213991890717114, 1.159182690169696],
            [31.21554537249076, 1.152736296811838],
            [31.215876990069475, 1.146994776955816],
            [31.216727782678444, 1.143507208629418],
            [31.216246553384114, 1.14090564225745],
            [31.216714811904055, 1.139690311489668],
            [31.219524488787872, 1.137130864357924],
            [31.221474148263056, 1.134623863589206],
            [31.224356288647606, 1.128337443159432],
            [31.22470902831357, 1.125493834550984],
            [31.225350277204424, 1.124748304766547],
            [31.227530887250957, 1.117707895183823],
            [31.228372187362332, 1.116495898514246],
            [31.22798324828533, 1.115197583312307],
            [31.22940298708285, 1.11438817121765],
            [31.231112374169015, 1.114045171274666],
            [31.233928755179804, 1.111942178149143],
            [31.23933966476721, 1.108849095111364],
            [31.24277777876928, 1.112597088265396],
            [31.24545592702415, 1.114829562933568],
            [31.249564954084367, 1.11956203998723],
            [31.252538261792143, 1.120302894460368],
            [31.254189667118286, 1.121449440065211],
            [31.255925210450574, 1.121788633710861],
            [31.256623865281313, 1.118143581389274],
            [31.26060929942981, 1.10600704927992],
            [31.2614446949148, 1.102128077000181],
            [31.26249027731165, 1.092896688748689],
            [31.262694161643477, 1.087554783871164],
            [31.261031425866673, 1.082714823204172],
            [31.262040245608816, 1.076725020491712],
            [31.26290632844224, 1.074195793204396],
            [31.26650953752218, 1.067357467422459],
            [31.26771969217738, 1.060801091620658],
            [31.27127935901717, 1.051752050098711],
            [31.274788113838262, 1.04717842173049],
            [31.27710682997826, 1.045295640458508],
            [31.27859549291427, 1.044905639782471],
            [31.28096569779144, 1.042224255948523],
            [31.281819711758995, 1.039879002688206],
            [31.282373020075102, 1.032708156779446],
            [31.285341566711864, 1.025856728433315],
            [31.28808867054626, 1.022953189894892],
            [31.294151436331386, 1.021437596847331],
            [31.29792938390376, 1.020062762053811],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 137,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "NALWEYO",
        Population: 17498,
        Key: "KAKUMIRONALWEYO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.32533151697374, 0.947018926484631],
            [31.321540581558967, 0.949240201829197],
            [31.3208756908065, 0.94926807003239],
            [31.31864529253364, 0.947866140244301],
            [31.313885736985707, 0.946539196405553],
            [31.31197430621573, 0.944885501987849],
            [31.31072387200148, 0.944381649735765],
            [31.306045917617325, 0.944576870239377],
            [31.303086198724834, 0.942453776165997],
            [31.297026992963175, 0.940361580478813],
            [31.295833610752645, 0.939512402336272],
            [31.295349549070195, 0.938183049947124],
            [31.29374368563404, 0.936051669725239],
            [31.292266579524153, 0.935394565174729],
            [31.29103887627985, 0.935703518390637],
            [31.29043256915862, 0.936867271476928],
            [31.289808310104736, 0.937199550690186],
            [31.290871529125564, 0.943932320443712],
            [31.29240478083904, 0.950433406586315],
            [31.300344664445213, 0.960794904310815],
            [31.30258900906287, 0.964422640083576],
            [31.302147819477366, 0.965715816829619],
            [31.30216443381855, 0.969208001992292],
            [31.3017235281007, 0.969928385422794],
            [31.299960835883898, 0.970943733094225],
            [31.298235235105157, 0.971201535905784],
            [31.295792616134637, 0.973713173553409],
            [31.29645195350205, 0.976651363596412],
            [31.29507418219797, 0.978757043085038],
            [31.29448543714053, 0.981417435836801],
            [31.29521836629263, 0.984004600323443],
            [31.294189821343462, 0.985186600605837],
            [31.293987451571205, 0.986073393125329],
            [31.293473433769016, 0.98616551249204],
            [31.292866472674238, 0.988530258389663],
            [31.292003442316172, 0.989102598509261],
            [31.29066334276183, 0.989305149194148],
            [31.28629455256587, 0.98939525834141],
            [31.284366930561212, 0.989856176237789],
            [31.28289857224556, 0.989615209474673],
            [31.28190641265866, 0.991425429605922],
            [31.280657840651983, 0.992126897960208],
            [31.27774008026983, 0.990499399679952],
            [31.27577599295283, 0.990498368568114],
            [31.27540906619357, 0.990128638603927],
            [31.273151045624033, 0.990589373169437],
            [31.272692590418778, 0.9897391971126],
            [31.269884587994685, 0.988869309346815],
            [31.267240564042492, 0.990364535995639],
            [31.262449775868742, 0.990195713873628],
            [31.259145461436685, 0.990711311121899],
            [31.256304537554033, 0.990449822779979],
            [31.25619906455989, 0.989511141697505],
            [31.252574993005794, 0.989007967908582],
            [31.246407404606796, 0.989152496080147],
            [31.240093539936797, 0.988262249975149],
            [31.235835869544825, 0.986707945352099],
            [31.233232739599334, 0.979421000552761],
            [31.226313836229306, 0.972434634003527],
            [31.22054875236641, 0.965192176960691],
            [31.217911758629665, 0.963812728142972],
            [31.21596423534817, 0.963338628456238],
            [31.210393186688325, 0.960293958230394],
            [31.208301967995695, 0.958532047553144],
            [31.207845472914414, 0.95678170016611],
            [31.203970660903256, 0.956176464636653],
            [31.20117868711877, 0.953917206575998],
            [31.19943114678585, 0.95349469670641],
            [31.20093338685906, 0.951313772654822],
            [31.201267171174237, 0.949352026731781],
            [31.200459919008782, 0.94762894110682],
            [31.19849713155401, 0.945590709271668],
            [31.19884597971818, 0.943082186594867],
            [31.198354065861867, 0.940871130558174],
            [31.1995074631608, 0.939397952592639],
            [31.201076750791902, 0.938346030993166],
            [31.201825787635357, 0.938346419911514],
            [31.20465231871051, 0.929032219819355],
            [31.207392729197743, 0.926929014112241],
            [31.207795212174275, 0.925735777088845],
            [31.208605479085822, 0.916670620158034],
            [31.20955466057459, 0.916072848934503],
            [31.21712748716579, 0.91443921053382],
            [31.21979761975339, 0.91486432988181],
            [31.221138582588704, 0.912496819175666],
            [31.22164435744986, 0.909957766501976],
            [31.22139365112879, 0.906783510273439],
            [31.220092801664162, 0.8998052439776],
            [31.22075380181314, 0.897933008952748],
            [31.222514114392755, 0.895014883555714],
            [31.225320114472122, 0.892384375885908],
            [31.225938659342475, 0.891236220113727],
            [31.225676885777087, 0.890100661335186],
            [31.225943193139724, 0.888566209283017],
            [31.225502616205237, 0.88672499532105],
            [31.224495054104473, 0.883613854917009],
            [31.223297537847, 0.882089691854687],
            [31.22222729849222, 0.878153250065692],
            [31.22285999003166, 0.873836732533431],
            [31.23263499162615, 0.874095322027674],
            [31.24001487895896, 0.871496009701656],
            [31.243295709632864, 0.868450354257679],
            [31.246588098929553, 0.863478691360962],
            [31.24880286022824, 0.858481241411235],
            [31.24633716084313, 0.855632096929462],
            [31.24499551349159, 0.851739896212797],
            [31.242393575610482, 0.849118610830272],
            [31.2415831955112, 0.849221433280263],
            [31.238720114682067, 0.85115866147581],
            [31.235613179880854, 0.852211908706341],
            [31.231236787242587, 0.855762484528464],
            [31.2282952978622, 0.856797286553886],
            [31.221788593646817, 0.856202143722641],
            [31.21754066189085, 0.860762638965465],
            [31.217142267147167, 0.860432060302409],
            [31.214235322481002, 0.860194693774606],
            [31.2112578744381, 0.86033488073304],
            [31.21081266040013, 0.859862685105475],
            [31.2065692148307, 0.860073067506754],
            [31.201998651343782, 0.857970571431917],
            [31.20079006155379, 0.85604247432896],
            [31.199545848172907, 0.856075879843724],
            [31.196919135654575, 0.855249608170144],
            [31.19595335958756, 0.855589317637794],
            [31.194921248326718, 0.855261361316114],
            [31.19334630310599, 0.855838802270837],
            [31.194267536209626, 0.854199835170379],
            [31.194194535516367, 0.852458737534321],
            [31.193409419636158, 0.85090957804184],
            [31.19063005909655, 0.849578220172373],
            [31.19042712158903, 0.848481339546718],
            [31.190947853399656, 0.846882424414882],
            [31.190922311601188, 0.845117403049168],
            [31.1912776860259, 0.844353574924779],
            [31.19232159845465, 0.843564807629732],
            [31.19196444536568, 0.842587431434182],
            [31.19252151672449, 0.841704022107532],
            [31.196319927919042, 0.841149431517719],
            [31.1963666331273, 0.840386086755057],
            [31.19589117730528, 0.839814382215525],
            [31.196317902218052, 0.839169697304509],
            [31.197623383396284, 0.838762148405665],
            [31.198073728611167, 0.837998165441257],
            [31.198046082059967, 0.835200108326278],
            [31.201241321253626, 0.830718203423903],
            [31.202176586042025, 0.828188373425046],
            [31.203244948816135, 0.828091271195022],
            [31.203671841713902, 0.827613545793771],
            [31.205001829831374, 0.827945368589042],
            [31.206613758692374, 0.825390604870578],
            [31.207109063688897, 0.82219359768967],
            [31.20844770797246, 0.819424586938275],
            [31.209871063387325, 0.818205846682334],
            [31.210154772015304, 0.81703662514288],
            [31.21239531765761, 0.813932231728609],
            [31.21296369700922, 0.812524029917514],
            [31.21310431838549, 0.810758721077581],
            [31.213613759271297, 0.809756102058022],
            [31.214059297601086, 0.804412433359988],
            [31.21591989360745, 0.801284770685603],
            [31.215609522981854, 0.799663298277044],
            [31.215941080373423, 0.798851781721503],
            [31.216878672696705, 0.798187105544336],
            [31.21882635767494, 0.795575308857414],
            [31.2203381863655, 0.792033611392286],
            [31.221456232263044, 0.791509040866138],
            [31.221578649280072, 0.789308218852486],
            [31.22377143778692, 0.786639583719957],
            [31.22455201717495, 0.784046754898175],
            [31.22533894226215, 0.783529923425568],
            [31.227270440497286, 0.783176737071681],
            [31.227948986540405, 0.782473967979477],
            [31.22696613349983, 0.778612126697891],
            [31.22830809616005, 0.777432124098054],
            [31.22877951764811, 0.775389298374173],
            [31.232383494787626, 0.773050878293421],
            [31.23377043789074, 0.773300023113998],
            [31.234442044448315, 0.771383384684585],
            [31.235959031265246, 0.771553684433943],
            [31.237028462136237, 0.771147976443035],
            [31.238043382337494, 0.770479105602292],
            [31.23879139869481, 0.768055118793846],
            [31.242651489115072, 0.770191985972582],
            [31.244503976029364, 0.773724308162206],
            [31.248880602229576, 0.777458676751596],
            [31.252316849532484, 0.783705091098365],
            [31.255880433026917, 0.793181735308595],
            [31.2566487540046, 0.794060448595473],
            [31.25825046542754, 0.797632160415591],
            [31.258027316724423, 0.79876762314913],
            [31.25868001194863, 0.799873576092845],
            [31.258501231037425, 0.801397537749593],
            [31.260503747383925, 0.804954489814555],
            [31.26059063603148, 0.805770701087534],
            [31.258299776648407, 0.809353192179327],
            [31.25804655504456, 0.812407811283363],
            [31.255334171994214, 0.815533796489439],
            [31.252464541548346, 0.821641977476289],
            [31.25154072848321, 0.821967566204678],
            [31.250460380386524, 0.823645370675877],
            [31.249760414015483, 0.82788357184787],
            [31.249815682863336, 0.830100958571378],
            [31.248838881772816, 0.834299354500028],
            [31.249811878498093, 0.838677903543813],
            [31.251267705315545, 0.8382111691376],
            [31.25394300591094, 0.838317067378159],
            [31.261811445604287, 0.837564282427005],
            [31.264092640911517, 0.837891118369676],
            [31.26711339224266, 0.838994034419777],
            [31.268423919257852, 0.838327475043223],
            [31.269017600557774, 0.837251935633847],
            [31.28357106454197, 0.834819796636212],
            [31.283960433013682, 0.834448625196293],
            [31.284401687277875, 0.83159438634421],
            [31.286071552084778, 0.83182139634155],
            [31.287600994043125, 0.830314569892554],
            [31.287552711393232, 0.827768676740013],
            [31.28856828287305, 0.826537601957071],
            [31.29105845865471, 0.828383203040058],
            [31.29194238562295, 0.827069230670284],
            [31.29250204772303, 0.827030815524694],
            [31.294668868629977, 0.831012109364447],
            [31.295725669188087, 0.83187603599942],
            [31.29694812177955, 0.832048651540047],
            [31.303823836845687, 0.830245538018417],
            [31.304915993296756, 0.829170064666056],
            [31.305835772027958, 0.826859203977111],
            [31.309249516533, 0.826876077970724],
            [31.31146934612654, 0.82752753299344],
            [31.322196313088835, 0.825242744041187],
            [31.32493897655078, 0.825351673231051],
            [31.325812998694655, 0.82588333533719],
            [31.326007416580044, 0.829275232895984],
            [31.325062180491994, 0.831968189839355],
            [31.32484652373837, 0.834708803597701],
            [31.325873297209796, 0.836938615145939],
            [31.327047175198878, 0.844186013299678],
            [31.325672874086752, 0.846890656575098],
            [31.325099194674966, 0.847252649748264],
            [31.32273249232908, 0.84733906361879],
            [31.320928485694044, 0.848757791800854],
            [31.32060245833137, 0.850149868483818],
            [31.320777092619213, 0.853917126337114],
            [31.321629927997147, 0.857138716863879],
            [31.322917406937073, 0.858654350685452],
            [31.324205460798773, 0.858859659140364],
            [31.324923792327503, 0.85958338720942],
            [31.32566869422572, 0.861562857657002],
            [31.32526144478832, 0.862627317120425],
            [31.324108366391293, 0.863827936426046],
            [31.32321233552296, 0.866181453658266],
            [31.321161680256967, 0.869102960977261],
            [31.31803675848881, 0.869174427209567],
            [31.31731268852205, 0.869935455148472],
            [31.317500866709462, 0.870795206263412],
            [31.316834574585116, 0.872390701772867],
            [31.317074207373672, 0.874593348417521],
            [31.31613468726579, 0.876699578099506],
            [31.316200822135336, 0.878760140721175],
            [31.318640206272505, 0.880048445266105],
            [31.320185384917977, 0.879943444595088],
            [31.322656749079286, 0.880615939260651],
            [31.331426093001383, 0.881516159425751],
            [31.329322428150505, 0.887926762905019],
            [31.327265642781054, 0.897820138718083],
            [31.32584518712792, 0.90150976807255],
            [31.3273269590874, 0.909401016850395],
            [31.32925974730323, 0.910697673792765],
            [31.329455101233123, 0.911481601793121],
            [31.328479194864673, 0.912927012692389],
            [31.326612840657322, 0.914413586659112],
            [31.325754247976757, 0.91739284230205],
            [31.32557572488205, 0.920831854060568],
            [31.326131555667466, 0.922232151839032],
            [31.32564909657951, 0.924638089103259],
            [31.326474755225124, 0.925548998599408],
            [31.32508487642763, 0.927246757832443],
            [31.322898260245104, 0.927046065442098],
            [31.322211236800648, 0.927311995723529],
            [31.321913774067347, 0.928979244148311],
            [31.322266978162343, 0.932022419413221],
            [31.322781114542185, 0.932530785085699],
            [31.32250562280409, 0.933936189869012],
            [31.323334269246352, 0.935296562156166],
            [31.322234796915623, 0.939528912049627],
            [31.32226774981518, 0.940884839695708],
            [31.32270690651319, 0.942595151860876],
            [31.32533151697374, 0.947018926484631],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 138,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KASAMBYA",
        Population: 31432,
        Key: "KAKUMIROKASAMBYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.30592778382799, 0.280472329535388],
            [32.30559059220292, 0.284211427182717],
            [32.30402709960375, 0.287033894242957],
            [32.301851540784035, 0.287820820208029],
            [32.299034820210075, 0.289476184962235],
            [32.29643874114127, 0.292416186555942],
            [32.29463217879926, 0.293230269658723],
            [32.285643074619294, 0.294613827671127],
            [32.270019005666, 0.313854938807962],
            [32.26811804925225, 0.317499641446203],
            [32.266077924038036, 0.31456653484791],
            [32.26397785154998, 0.31422576048204],
            [32.257940293390035, 0.311271300324944],
            [32.25451614819063, 0.308869076041086],
            [32.25038177426634, 0.307736074325381],
            [32.24800428225562, 0.306347628514589],
            [32.24650650411439, 0.304935311929991],
            [32.24391502711478, 0.303666541232365],
            [32.24198936074251, 0.301153152060495],
            [32.23353746437384, 0.295515702697363],
            [32.233870379119786, 0.29465404022314],
            [32.23539210993972, 0.293481293388077],
            [32.23515457292073, 0.290273893996595],
            [32.23440568250267, 0.289543811070141],
            [32.22594172535296, 0.286623077353437],
            [32.2251570999529, 0.287077805139569],
            [32.22330259721908, 0.28700586356454],
            [32.221901818263945, 0.285779301232277],
            [32.22225668783549, 0.283798419228308],
            [32.222019003492775, 0.282625562579049],
            [32.22132956447852, 0.281811705991156],
            [32.21461295632059, 0.281655665122862],
            [32.21123669312244, 0.283570275993757],
            [32.20961980645939, 0.285724358257851],
            [32.20922741425845, 0.287124560964799],
            [32.20796720547562, 0.288560606723863],
            [32.20363937935489, 0.297895139995176],
            [32.20192747069774, 0.298852434663319],
            [32.199620918644975, 0.303256399582548],
            [32.19832491559132, 0.303623712856026],
            [32.197611813155866, 0.299370420452145],
            [32.19584088787947, 0.294547295727297],
            [32.195127691120916, 0.293565889323228],
            [32.1939864848587, 0.293374327898367],
            [32.19308307792353, 0.292440782108087],
            [32.1912288186332, 0.289281162303159],
            [32.18882766409956, 0.286839578507327],
            [32.187722308702014, 0.283955284711107],
            [32.18757999939133, 0.27902458325263],
            [32.188519541957106, 0.272980950740873],
            [32.19080237848633, 0.267188735637263],
            [32.18703471213241, 0.255735394328026],
            [32.185085280829284, 0.253317798428687],
            [32.183347179095065, 0.249330502703862],
            [32.18368015851974, 0.247391757109286],
            [32.183137759344454, 0.247101356939675],
            [32.18242451228023, 0.245214043590276],
            [32.18237669046608, 0.240531914581304],
            [32.18408243668037, 0.23732015454924],
            [32.18822988648194, 0.226180326788513],
            [32.191621465057345, 0.219128719143635],
            [32.19410703697318, 0.210915529752252],
            [32.19600231244109, 0.208590354136972],
            [32.19733832915245, 0.200617721185591],
            [32.197331976266746, 0.200119896763888],
            [32.19598987257102, 0.19923680699846],
            [32.193863836076325, 0.196514770715915],
            [32.192138837168834, 0.195423401284563],
            [32.19033188316135, 0.195048805087551],
            [32.19316379694172, 0.192498370529583],
            [32.19410430519641, 0.190874651384405],
            [32.19534316641482, 0.19003335681925],
            [32.19685008401575, 0.189864174438258],
            [32.19805391363306, 0.191788599445077],
            [32.19864913464537, 0.19187550197857],
            [32.20089127569559, 0.190660069306947],
            [32.20167477730325, 0.190602190275219],
            [32.20832937655377, 0.191568511635441],
            [32.210288197946554, 0.194221643841535],
            [32.21065414374555, 0.196824899664326],
            [32.20832337850262, 0.199476001757891],
            [32.20772587487118, 0.201072561470551],
            [32.20796892485106, 0.201496105530223],
            [32.21310401391703, 0.203739810890553],
            [32.216911564571255, 0.206212764515842],
            [32.21415334228862, 0.21310282445986],
            [32.213432919481875, 0.216242213119229],
            [32.21327423029032, 0.217773646437859],
            [32.21374850303109, 0.22141872527155],
            [32.21400667974206, 0.22302758775939],
            [32.21644786949297, 0.229029328300481],
            [32.21747535892168, 0.234125228059289],
            [32.21954560015579, 0.238993822737522],
            [32.22034949441869, 0.242397406907458],
            [32.22119715550058, 0.243642766116122],
            [32.222156249000186, 0.247103555995051],
            [32.221827927340264, 0.247334256483827],
            [32.22282641106676, 0.248937998330823],
            [32.22432419369954, 0.250278479524947],
            [32.22724848663045, 0.252002025469132],
            [32.23120707911828, 0.252851981582497],
            [32.23432174482081, 0.252062284773732],
            [32.23674701552658, 0.249429503296957],
            [32.23826870682065, 0.248639717349344],
            [32.24694993679315, 0.247803457448027],
            [32.24855838558073, 0.247505752255726],
            [32.250242522820876, 0.246197971849978],
            [32.262031004699935, 0.245750570943971],
            [32.266433646110755, 0.24567815751648],
            [32.28175882850105, 0.246729739035569],
            [32.28210616659723, 0.247353975218904],
            [32.280089791042506, 0.249289844440709],
            [32.28125984670008, 0.251298261520979],
            [32.28579153289811, 0.25399441364973],
            [32.287247550158376, 0.254419688089166],
            [32.287648757527194, 0.255849078587567],
            [32.28760324617995, 0.263386915665274],
            [32.2910725326207, 0.26412524485221],
            [32.29361746251558, 0.271621206014535],
            [32.29817595893325, 0.278639220440574],
            [32.30483596873672, 0.277290432083923],
            [32.30595544834547, 0.27908944623672],
            [32.30592778382799, 0.280472329535388],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1666,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "KALAMBA",
        Population: 19515,
        Key: "BUTAMBALAKALAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.416727936722204, 0.317022553512939],
            [32.41740477057639, 0.320067857243933],
            [32.421886548173845, 0.327523402002814],
            [32.42246920714524, 0.328363644508143],
            [32.42253811780899, 0.330661726070192],
            [32.42219878819356, 0.333496443490168],
            [32.42097909432835, 0.336273523381436],
            [32.4087924674373, 0.349152865880321],
            [32.40400316867027, 0.353303507561029],
            [32.399085272477095, 0.355958685339182],
            [32.39328393530427, 0.358344011028443],
            [32.3818982687784, 0.360859502095423],
            [32.37572840584511, 0.363238497101847],
            [32.37222169379299, 0.365672227412593],
            [32.36204893166544, 0.373982196509276],
            [32.35557543457283, 0.377556469440747],
            [32.340795710121405, 0.380428802960106],
            [32.334776420999376, 0.38253431478951],
            [32.32881556369333, 0.385393519863083],
            [32.319362309887545, 0.387889277542901],
            [32.30852028131376, 0.390184262983807],
            [32.301352907529406, 0.390974502459099],
            [32.29662175940569, 0.393390958879482],
            [32.28987576196492, 0.399492210657443],
            [32.2867649087124, 0.401354046684119],
            [32.282576085203814, 0.402642374262134],
            [32.27588778655374, 0.4036848352564],
            [32.265473885162905, 0.404346355253125],
            [32.254347961111556, 0.405922938214551],
            [32.25613421523996, 0.40072102300352],
            [32.25934048484697, 0.394766690806034],
            [32.26022236814792, 0.385875796448807],
            [32.26120566675285, 0.382122294589723],
            [32.26199533080337, 0.377575730698859],
            [32.26046876345392, 0.355247145303741],
            [32.25684707872355, 0.342743629825407],
            [32.25652663439034, 0.337487437164192],
            [32.256748456281784, 0.335608155382615],
            [32.25839973494546, 0.33069273449906],
            [32.26290376920241, 0.323986312198141],
            [32.26811804925225, 0.317499641446203],
            [32.270019005666, 0.313854938807962],
            [32.285643074619294, 0.294613827671127],
            [32.29463217879926, 0.293230269658723],
            [32.29643874114127, 0.292416186555942],
            [32.299034820210075, 0.289476184962235],
            [32.301851540784035, 0.287820820208029],
            [32.30402709960375, 0.287033894242957],
            [32.30559059220292, 0.284211427182717],
            [32.30592778382799, 0.280472329535388],
            [32.306159227574405, 0.279977614360734],
            [32.312918246095236, 0.280529866838123],
            [32.317754159340645, 0.282077141469125],
            [32.32017922612884, 0.283759973602358],
            [32.32285511332412, 0.284691943581124],
            [32.32309357470955, 0.283922987978282],
            [32.32834605471853, 0.278938553516036],
            [32.33332559600143, 0.278576972418912],
            [32.334951865567625, 0.277952841100017],
            [32.33725806009091, 0.276342653147193],
            [32.33983689060795, 0.275501450825212],
            [32.34182173799114, 0.275483470354326],
            [32.34401800926633, 0.276134958779237],
            [32.34481521197873, 0.277012539705338],
            [32.34617400367746, 0.278930528062372],
            [32.34820377041815, 0.284128422074768],
            [32.34843656433244, 0.287040488692696],
            [32.34983391082487, 0.293846697194917],
            [32.35181799733502, 0.297150564342684],
            [32.354416881842496, 0.303827062528041],
            [32.36072757006963, 0.310163639968719],
            [32.366814094497386, 0.314089565355867],
            [32.36788416317225, 0.311935363789787],
            [32.37009554500886, 0.309039202804402],
            [32.372996432335064, 0.306310634623288],
            [32.37523149016926, 0.305066077833111],
            [32.37741759161715, 0.301609715385657],
            [32.38199578359745, 0.304326918536797],
            [32.385833443085055, 0.305883196259852],
            [32.38965175914969, 0.306905709672798],
            [32.392965646029424, 0.309221891422998],
            [32.395899341626425, 0.310723837326444],
            [32.40131162833118, 0.311845960285744],
            [32.404352836098, 0.314216411855468],
            [32.40770710763967, 0.317681553784765],
            [32.40920195457811, 0.317491657342518],
            [32.41266900421379, 0.318061810182348],
            [32.41740475171175, 0.320070490164943],
            [32.416727936722204, 0.317022553512939],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1669,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "MUDUUMA",
        Population: 30636,
        Key: "MPIGIMUDUUMA",
        Dist2: "Mpigi",
        "Sub Country": "Muduuma",
        id2_original: "MpigiMuduuma",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.305835772027958, 0.826859203977111],
              [31.304915993296756, 0.829170064666056],
              [31.303823836845687, 0.830245538018417],
              [31.29694812177955, 0.832048651540047],
              [31.295725669188087, 0.83187603599942],
              [31.294668868629977, 0.831012109364447],
              [31.29250204772303, 0.827030815524694],
              [31.29194238562295, 0.827069230670284],
              [31.29105845865471, 0.828383203040058],
              [31.28856828287305, 0.826537601957071],
              [31.287552711393232, 0.827768676740013],
              [31.287600994043125, 0.830314569892554],
              [31.286071552084778, 0.83182139634155],
              [31.284401687277875, 0.83159438634421],
              [31.283960433013682, 0.834448625196293],
              [31.28357106454197, 0.834819796636212],
              [31.269017600557774, 0.837251935633847],
              [31.268423919257852, 0.838327475043223],
              [31.26711339224266, 0.838994034419777],
              [31.264092640911517, 0.837891118369676],
              [31.261811445604287, 0.837564282427005],
              [31.25394300591094, 0.838317067378159],
              [31.251267705315545, 0.8382111691376],
              [31.249811878498093, 0.838677903543813],
              [31.248838881772816, 0.834299354500028],
              [31.249815682863336, 0.830100958571378],
              [31.249760414015483, 0.82788357184787],
              [31.250460380386524, 0.823645370675877],
              [31.25154072848321, 0.821967566204678],
              [31.252464541548346, 0.821641977476289],
              [31.255334171994214, 0.815533796489439],
              [31.25804655504456, 0.812407811283363],
              [31.258299776648407, 0.809353192179327],
              [31.26059063603148, 0.805770701087534],
              [31.260503747383925, 0.804954489814555],
              [31.258501231037425, 0.801397537749593],
              [31.25868001194863, 0.799873576092845],
              [31.258027316724423, 0.79876762314913],
              [31.25825046542754, 0.797632160415591],
              [31.2566487540046, 0.794060448595473],
              [31.255880433026917, 0.793181735308595],
              [31.252316849532484, 0.783705091098365],
              [31.248880602229576, 0.777458676751596],
              [31.244503976029364, 0.773724308162206],
              [31.242651489115072, 0.770191985972582],
              [31.23879139869481, 0.768055118793846],
              [31.239606067351232, 0.76637387754262],
              [31.241610462973327, 0.764557796142257],
              [31.24635585029264, 0.761425324223924],
              [31.250738512273216, 0.760603628667697],
              [31.254359044465115, 0.762247620543314],
              [31.25518800621602, 0.76190939613125],
              [31.259503219990165, 0.757362294764303],
              [31.263247904744176, 0.754472192629766],
              [31.26574285417328, 0.751173508834532],
              [31.267523940293838, 0.75113863653732],
              [31.275611708155346, 0.745565601895967],
              [31.281793598632003, 0.742698711470875],
              [31.281990571326034, 0.746187309153165],
              [31.279966520565512, 0.755546029922701],
              [31.28141789353578, 0.755961272376276],
              [31.281691885087323, 0.757541050172479],
              [31.282809595014985, 0.758469552030473],
              [31.28451615150966, 0.758430744617304],
              [31.287595471200735, 0.759202067488554],
              [31.289791755950688, 0.760841857051513],
              [31.294909194019628, 0.766432015797828],
              [31.29498720192228, 0.767577312766458],
              [31.29318088392201, 0.771802220339786],
              [31.291317916363276, 0.77763496656972],
              [31.28477792327842, 0.7862459898224],
              [31.280712053081057, 0.789570140030637],
              [31.280057993315957, 0.7910577155142],
              [31.28028305722725, 0.790858510625138],
              [31.281379319877484, 0.792922889895483],
              [31.28152581982896, 0.793745174690212],
              [31.281093928704973, 0.795066094001698],
              [31.28199309559198, 0.795620780786141],
              [31.284104197595095, 0.794965735795232],
              [31.286774711068364, 0.795327157905571],
              [31.288013970240495, 0.794625551377242],
              [31.292148816678584, 0.794640638927941],
              [31.292869738050317, 0.79611479485137],
              [31.29286923050216, 0.797343205770817],
              [31.291308812836192, 0.800086000662045],
              [31.292019222122452, 0.800908078332728],
              [31.29439964803089, 0.797854605734361],
              [31.295232764490006, 0.794959776047019],
              [31.29775332578615, 0.792472407236648],
              [31.299085194975852, 0.790534862279983],
              [31.30398242542594, 0.788670565294817],
              [31.3073091680957, 0.791040729991181],
              [31.307854976377502, 0.793218333657456],
              [31.308971717921267, 0.794247666464884],
              [31.309970295970892, 0.796910592949907],
              [31.30816635581117, 0.799617248832498],
              [31.30804049106009, 0.800482006780682],
              [31.30844019195418, 0.801191928100065],
              [31.307557818173084, 0.80369617291398],
              [31.306864343926566, 0.808425299815612],
              [31.30665915883421, 0.812738332014964],
              [31.307384358881613, 0.813250481861229],
              [31.30787200663868, 0.814397213856544],
              [31.30709117751898, 0.817208599096834],
              [31.30759302225077, 0.819775188672512],
              [31.3058374087584, 0.823061740704549],
              [31.305537322046177, 0.824439695671207],
              [31.305835772027958, 0.826859203977111],
            ],
          ],
          [
            [
              [31.4100705068198, 0.808275182018533],
              [31.406703625626495, 0.807409254434056],
              [31.396063292190185, 0.807512599835585],
              [31.392140838027963, 0.805241155241178],
              [31.388468028378117, 0.80518574544022],
              [31.387771816066614, 0.80620755619378],
              [31.384827719775252, 0.806069339814493],
              [31.384135451966173, 0.807665084486419],
              [31.38206429265386, 0.8075866549813],
              [31.380584242764787, 0.808248087932439],
              [31.380208085815987, 0.810363644722608],
              [31.379359547080064, 0.811960355094092],
              [31.37806108713409, 0.812516297997095],
              [31.37678473472728, 0.81249814307418],
              [31.379826432075948, 0.817370937795907],
              [31.37893666875333, 0.822450793898077],
              [31.376572905695085, 0.829079048807213],
              [31.37419094456581, 0.831154868084655],
              [31.369439831384906, 0.833375824296455],
              [31.36531867796666, 0.834405812437207],
              [31.363813824694265, 0.835249989168581],
              [31.361122366101835, 0.837771207897238],
              [31.359630014683276, 0.840441521217229],
              [31.35857265537304, 0.84387875094931],
              [31.3584617152321, 0.846697029694706],
              [31.36006318949981, 0.850456944406148],
              [31.359074931296174, 0.850671774391812],
              [31.357063091335327, 0.849745036942852],
              [31.35633438516335, 0.849827816573874],
              [31.356023815111765, 0.85011671621467],
              [31.35591411195093, 0.853117603062983],
              [31.354634192334146, 0.85257766221055],
              [31.353257410973498, 0.853107959819169],
              [31.353407608390693, 0.856028967869653],
              [31.352502918661305, 0.858943459844707],
              [31.351342688776327, 0.860672493317828],
              [31.349660324810547, 0.8622221312044],
              [31.346373825767156, 0.863429487237561],
              [31.34373174217603, 0.865558999438096],
              [31.34147450942901, 0.868742712402866],
              [31.34104902958121, 0.871275933538268],
              [31.339514198629466, 0.871546298759483],
              [31.336609347037935, 0.873338259632432],
              [31.333639408910802, 0.878952574943792],
              [31.331904408160934, 0.880424235367899],
              [31.331426093001383, 0.881516159425751],
              [31.322656749079286, 0.880615939260651],
              [31.320185384917977, 0.879943444595088],
              [31.318640206272505, 0.880048445266105],
              [31.316200822135336, 0.878760140721175],
              [31.31613468726579, 0.876699578099506],
              [31.317074207373672, 0.874593348417521],
              [31.316834574585116, 0.872390701772867],
              [31.317500866709462, 0.870795206263412],
              [31.31731268852205, 0.869935455148472],
              [31.31803675848881, 0.869174427209567],
              [31.321161680256967, 0.869102960977261],
              [31.32321233552296, 0.866181453658266],
              [31.324108366391293, 0.863827936426046],
              [31.32526144478832, 0.862627317120425],
              [31.32566869422572, 0.861562857657002],
              [31.324923792327503, 0.85958338720942],
              [31.324205460798773, 0.858859659140364],
              [31.322917406937073, 0.858654350685452],
              [31.321629927997147, 0.857138716863879],
              [31.320777092619213, 0.853917126337114],
              [31.32060245833137, 0.850149868483818],
              [31.320928485694044, 0.848757791800854],
              [31.32273249232908, 0.84733906361879],
              [31.325099194674966, 0.847252649748264],
              [31.325672874086752, 0.846890656575098],
              [31.327047175198878, 0.844186013299678],
              [31.325873297209796, 0.836938615145939],
              [31.32484652373837, 0.834708803597701],
              [31.325062180491994, 0.831968189839355],
              [31.326007416580044, 0.829275232895984],
              [31.325812998694655, 0.82588333533719],
              [31.32493897655078, 0.825351673231051],
              [31.322196313088835, 0.825242744041187],
              [31.327461879754857, 0.821538195002506],
              [31.327896449655018, 0.820424979550131],
              [31.32719200338562, 0.818895966254958],
              [31.327328050540476, 0.817804082882934],
              [31.329519169079212, 0.814679321922596],
              [31.334075937138273, 0.812633831629434],
              [31.338835356142308, 0.812403773762046],
              [31.341859260560135, 0.811534708660848],
              [31.343687457927448, 0.810581423066757],
              [31.343455441055884, 0.811281130703272],
              [31.34601002784002, 0.809706594558937],
              [31.3462290838187, 0.809466533884488],
              [31.34579260859183, 0.809219526318369],
              [31.345854867230894, 0.808758735614933],
              [31.347135721993926, 0.808318657948297],
              [31.34948648822663, 0.805270822766392],
              [31.35106321031501, 0.804153851834622],
              [31.350161666485757, 0.801365051558582],
              [31.350697645401723, 0.798481973165118],
              [31.349533703677974, 0.796519425244092],
              [31.34788857847397, 0.795688059011652],
              [31.348067071025977, 0.793617592923879],
              [31.3474024803108, 0.791188661229392],
              [31.348128130414153, 0.789502047011126],
              [31.350588967218645, 0.787840054399431],
              [31.358097970305565, 0.780685939861901],
              [31.35366398038623, 0.775621696401766],
              [31.351794593466508, 0.774256031748389],
              [31.35001872476112, 0.773873705927829],
              [31.347444322938436, 0.774334663087667],
              [31.343013503173765, 0.776301302110949],
              [31.34228042490131, 0.7752627337462],
              [31.34159199020355, 0.77298933312867],
              [31.340760211335873, 0.7725822348091],
              [31.34033286029736, 0.771289972852],
              [31.338706149658357, 0.770264583050317],
              [31.336173665023438, 0.766879578386809],
              [31.332401875402365, 0.765489097185969],
              [31.33331198736277, 0.763450924883637],
              [31.337056905678796, 0.76029394648015],
              [31.3373306187526, 0.759348912973002],
              [31.33594045878245, 0.75841519614203],
              [31.33583498758494, 0.754514957712299],
              [31.33423165021131, 0.751619101370223],
              [31.334327078243945, 0.750697926775392],
              [31.3337275938273, 0.749364361749471],
              [31.333727919915752, 0.748502835114953],
              [31.33513219511396, 0.745462965487303],
              [31.331814679040455, 0.740833008597342],
              [31.328683455590593, 0.738588077633715],
              [31.328136775942966, 0.736156103889629],
              [31.325702705340696, 0.730620564592853],
              [31.324794103448276, 0.729647039657216],
              [31.323057259355462, 0.728746732064249],
              [31.32151087067927, 0.726741959177961],
              [31.325057496676095, 0.724859513578661],
              [31.32997151843546, 0.723273219954454],
              [31.332612884272713, 0.721960141059434],
              [31.341933384147502, 0.715957591236992],
              [31.351107911381877, 0.7113857591783],
              [31.354515274255146, 0.711386988877137],
              [31.3619325746229, 0.70798021164816],
              [31.36589177167687, 0.706733601348693],
              [31.369545513686496, 0.704718164714989],
              [31.373721785035613, 0.703552430854055],
              [31.374837168326696, 0.703398308636874],
              [31.378058440697274, 0.704366614947191],
              [31.382785857219314, 0.707422743540902],
              [31.382917595155725, 0.709561915138271],
              [31.38427009056264, 0.711494403832512],
              [31.384546512057025, 0.712508461501763],
              [31.384812383736737, 0.716281277458743],
              [31.38545229234116, 0.71743924367946],
              [31.386389169605486, 0.718129157659202],
              [31.388810240687295, 0.726366612147068],
              [31.390149007141737, 0.728284368836183],
              [31.390953788940173, 0.730400881480611],
              [31.39248872768973, 0.732318728969668],
              [31.392569677574905, 0.733051364652887],
              [31.393239336584937, 0.733954840378721],
              [31.394792728527072, 0.734734293933835],
              [31.395485000827705, 0.736959912864507],
              [31.397135382074456, 0.738035194312502],
              [31.39824825726924, 0.740261253526866],
              [31.399116469109867, 0.74057500526272],
              [31.40222930045263, 0.74414249520409],
              [31.402986161622195, 0.744233166195111],
              [31.40619140984475, 0.742163347035478],
              [31.4070288076745, 0.743176560654442],
              [31.40716425026314, 0.745073098196508],
              [31.408728893604216, 0.745139690067067],
              [31.408846378870344, 0.747111288099569],
              [31.40912635589661, 0.755431714868147],
              [31.407659959501554, 0.759338103596231],
              [31.407765940942152, 0.762015114897704],
              [31.40710486533465, 0.764791321147423],
              [31.40749618315053, 0.766446487260498],
              [31.40438736997205, 0.801282067021021],
              [31.406963150708712, 0.803824393006758],
              [31.409406357177435, 0.807967429154656],
              [31.4100705068198, 0.808275182018533],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 139,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "BWANSWA",
        Population: 16604,
        Key: "KAKUMIROBWANSWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.29792938390376, 1.020062762053811],
            [31.294151436331386, 1.021437596847331],
            [31.28808867054626, 1.022953189894892],
            [31.285341566711864, 1.025856728433315],
            [31.282373020075102, 1.032708156779446],
            [31.281819711758995, 1.039879002688206],
            [31.28096569779144, 1.042224255948523],
            [31.27859549291427, 1.044905639782471],
            [31.27710682997826, 1.045295640458508],
            [31.274788113838262, 1.04717842173049],
            [31.27127935901717, 1.051752050098711],
            [31.26771969217738, 1.060801091620658],
            [31.26650953752218, 1.067357467422459],
            [31.26290632844224, 1.074195793204396],
            [31.262040245608816, 1.076725020491712],
            [31.261031425866673, 1.082714823204172],
            [31.262694161643477, 1.087554783871164],
            [31.26249027731165, 1.092896688748689],
            [31.2614446949148, 1.102128077000181],
            [31.26060929942981, 1.10600704927992],
            [31.256623865281313, 1.118143581389274],
            [31.255925210450574, 1.121788633710861],
            [31.254189667118286, 1.121449440065211],
            [31.252538261792143, 1.120302894460368],
            [31.249564954084367, 1.11956203998723],
            [31.24545592702415, 1.114829562933568],
            [31.24277777876928, 1.112597088265396],
            [31.23933966476721, 1.108849095111364],
            [31.233928755179804, 1.111942178149143],
            [31.231112374169015, 1.114045171274666],
            [31.22940298708285, 1.11438817121765],
            [31.22798324828533, 1.115197583312307],
            [31.228216110471596, 1.113717542155285],
            [31.227762196250104, 1.112456542795545],
            [31.227874308692495, 1.111177209035427],
            [31.226877652139294, 1.109785141136201],
            [31.22706426725809, 1.108048257685104],
            [31.228216669223695, 1.105004537297691],
            [31.227224245532117, 1.101601769667757],
            [31.227838785712905, 1.099492038779682],
            [31.227070962401918, 1.092943981833035],
            [31.228197833348823, 1.089288386607721],
            [31.228192359015477, 1.086290502379019],
            [31.228587702182114, 1.085100378255802],
            [31.22850583960859, 1.083451338871385],
            [31.22723622995629, 1.078615182527447],
            [31.226937108034686, 1.074277383618873],
            [31.227997200020017, 1.06778737229444],
            [31.22764821800685, 1.066069167945859],
            [31.226221228906663, 1.063538063698062],
            [31.225271457224768, 1.060443726681739],
            [31.22506082654514, 1.056931364733287],
            [31.22669043964083, 1.054826136815196],
            [31.226941132487145, 1.053561143056401],
            [31.22777035744447, 1.052267727289091],
            [31.22868482803066, 1.051786636595488],
            [31.229202361838887, 1.050555819449253],
            [31.22930783213807, 1.048890110470821],
            [31.23115960668833, 1.045419218189177],
            [31.231811034389672, 1.042759917115183],
            [31.231662070359356, 1.040934003338111],
            [31.2339999906835, 1.036564831738298],
            [31.235697880232348, 1.034298459558965],
            [31.240307621045407, 1.0322310060621],
            [31.240908579597452, 1.03145145681001],
            [31.240018931259197, 1.028799353614375],
            [31.2389406915085, 1.023076266417243],
            [31.240065284327862, 1.019267519650847],
            [31.24095108158849, 1.017995256243808],
            [31.245071410353294, 1.016090611416028],
            [31.24925810934625, 1.013173602225749],
            [31.251160818373133, 1.00697715636651],
            [31.256275536343406, 1.008235106273325],
            [31.255931353130492, 1.007186220424606],
            [31.256092777692082, 1.005184757444276],
            [31.256928157905715, 1.002344294661139],
            [31.25601613343206, 0.99851826058087],
            [31.25649813258257, 0.996775231746543],
            [31.255698410994153, 0.992836268357137],
            [31.256304537554033, 0.990449822779979],
            [31.259145461436685, 0.990711311121899],
            [31.262449775868742, 0.990195713873628],
            [31.267240564042492, 0.990364535995639],
            [31.269884587994685, 0.988869309346815],
            [31.272692590418778, 0.9897391971126],
            [31.273151045624033, 0.990589373169437],
            [31.27540906619357, 0.990128638603927],
            [31.27577599295283, 0.990498368568114],
            [31.27774008026983, 0.990499399679952],
            [31.280657840651983, 0.992126897960208],
            [31.28190641265866, 0.991425429605922],
            [31.28289857224556, 0.989615209474673],
            [31.284366930561212, 0.989856176237789],
            [31.28629455256587, 0.98939525834141],
            [31.29066334276183, 0.989305149194148],
            [31.292003442316172, 0.989102598509261],
            [31.292866472674238, 0.988530258389663],
            [31.293473433769016, 0.98616551249204],
            [31.293987451571205, 0.986073393125329],
            [31.294189821343462, 0.985186600605837],
            [31.29521836629263, 0.984004600323443],
            [31.29448543714053, 0.981417435836801],
            [31.29507418219797, 0.978757043085038],
            [31.29645195350205, 0.976651363596412],
            [31.295792616134637, 0.973713173553409],
            [31.298235235105157, 0.971201535905784],
            [31.299960835883898, 0.970943733094225],
            [31.3017235281007, 0.969928385422794],
            [31.30216443381855, 0.969208001992292],
            [31.302147819477366, 0.965715816829619],
            [31.30258900906287, 0.964422640083576],
            [31.300344664445213, 0.960794904310815],
            [31.29240478083904, 0.950433406586315],
            [31.290871529125564, 0.943932320443712],
            [31.289808310104736, 0.937199550690186],
            [31.29043256915862, 0.936867271476928],
            [31.29103887627985, 0.935703518390637],
            [31.292266579524153, 0.935394565174729],
            [31.29374368563404, 0.936051669725239],
            [31.295349549070195, 0.938183049947124],
            [31.295833610752645, 0.939512402336272],
            [31.297026992963175, 0.940361580478813],
            [31.303086198724834, 0.942453776165997],
            [31.306045917617325, 0.944576870239377],
            [31.31072387200148, 0.944381649735765],
            [31.31197430621573, 0.944885501987849],
            [31.313885736985707, 0.946539196405553],
            [31.31864529253364, 0.947866140244301],
            [31.3208756908065, 0.94926807003239],
            [31.321540581558967, 0.949240201829197],
            [31.32533151697374, 0.947018926484631],
            [31.327847713355926, 0.954602262008951],
            [31.32904045416936, 0.957104986588926],
            [31.329450775845036, 0.96332403559068],
            [31.329341175990496, 0.96642954004339],
            [31.328699000038263, 0.969811912179004],
            [31.326982257546565, 0.975865541639981],
            [31.326814109993364, 0.986119733041854],
            [31.32617699694611, 0.992013195478217],
            [31.32514991086096, 0.994684150104672],
            [31.323219591215484, 0.997265450812376],
            [31.323606711204032, 0.997266140614012],
            [31.32349522937897, 1.000008458448543],
            [31.322059568841336, 1.004869612253322],
            [31.315615180757202, 1.013436728821049],
            [31.31296197332788, 1.01494592164695],
            [31.30395528193131, 1.016254968277268],
            [31.29886345303449, 1.019098830155681],
            [31.29792938390376, 1.020062762053811],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 140,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KITAIHUKA",
        Population: 15074,
        Key: "KAKUMIROKITAIHUKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.256304537554033, 0.990449822779979],
            [31.255698410994153, 0.992836268357137],
            [31.25649813258257, 0.996775231746543],
            [31.25601613343206, 0.99851826058087],
            [31.256928157905715, 1.002344294661139],
            [31.256092777692082, 1.005184757444276],
            [31.255931353130492, 1.007186220424606],
            [31.256275536343406, 1.008235106273325],
            [31.251160818373133, 1.00697715636651],
            [31.24925810934625, 1.013173602225749],
            [31.245071410353294, 1.016090611416028],
            [31.24095108158849, 1.017995256243808],
            [31.240065284327862, 1.019267519650847],
            [31.2389406915085, 1.023076266417243],
            [31.240018931259197, 1.028799353614375],
            [31.240908579597452, 1.03145145681001],
            [31.240307621045407, 1.0322310060621],
            [31.235697880232348, 1.034298459558965],
            [31.2339999906835, 1.036564831738298],
            [31.231662070359356, 1.040934003338111],
            [31.231811034389672, 1.042759917115183],
            [31.23115960668833, 1.045419218189177],
            [31.22930783213807, 1.048890110470821],
            [31.229202361838887, 1.050555819449253],
            [31.22868482803066, 1.051786636595488],
            [31.22777035744447, 1.052267727289091],
            [31.226941132487145, 1.053561143056401],
            [31.22669043964083, 1.054826136815196],
            [31.22506082654514, 1.056931364733287],
            [31.225271457224768, 1.060443726681739],
            [31.22371778860153, 1.059535194949189],
            [31.222360850127203, 1.057095534453279],
            [31.222800738952145, 1.052602001379985],
            [31.221410656237104, 1.049519692469634],
            [31.219466412704755, 1.046931894220482],
            [31.216236731204784, 1.04530412902341],
            [31.21377684212293, 1.045709195480964],
            [31.210141460779415, 1.047406915860556],
            [31.208085527012845, 1.047590491837781],
            [31.20543530288858, 1.046518579169327],
            [31.20352559598564, 1.04271289989406],
            [31.203363491399344, 1.038588299136638],
            [31.20252329711413, 1.0376597795153],
            [31.201580747887103, 1.037375138397388],
            [31.20089657928862, 1.036278951049623],
            [31.20075055005436, 1.034837730910972],
            [31.198327528730047, 1.029660623534977],
            [31.197377901676926, 1.02641070517413],
            [31.19605443802333, 1.024789343279095],
            [31.193615105988428, 1.026316181641516],
            [31.19176010289303, 1.028292057909455],
            [31.190566611088023, 1.028993463516507],
            [31.188105387109648, 1.031837354510775],
            [31.184451348656015, 1.034181696698984],
            [31.181294274387213, 1.034124444714875],
            [31.179605865657862, 1.033643093473325],
            [31.17841240709051, 1.034289059323039],
            [31.177714231960117, 1.035471110481009],
            [31.17723420550997, 1.040329985948283],
            [31.17600864834087, 1.043374001585664],
            [31.173174963981086, 1.046553100157877],
            [31.16856687337319, 1.046662113188911],
            [31.16750245510147, 1.046347396914976],
            [31.16403502997, 1.043426184151461],
            [31.162070988467082, 1.043498929335846],
            [31.160841552372613, 1.042888505816288],
            [31.15825877106494, 1.042944868456851],
            [31.156416699218063, 1.0435844482394],
            [31.154820659757824, 1.043623973842652],
            [31.148536416136018, 1.046580216670299],
            [31.14391948071583, 1.045457942605497],
            [31.1359141377732, 1.045201607887727],
            [31.132018759731928, 1.043968628962624],
            [31.13186538856685, 1.043030620000595],
            [31.131356849589558, 1.042997827045563],
            [31.13112654221197, 1.042220474666845],
            [31.129831971072864, 1.041130939029019],
            [31.129233818857784, 1.039723925112042],
            [31.127836661011578, 1.038933639210871],
            [31.127851625147557, 1.037742297798058],
            [31.127495324559803, 1.037340183493112],
            [31.127809398939327, 1.036794933461172],
            [31.127167946130896, 1.036263466627074],
            [31.127296713338662, 1.03556021598907],
            [31.126555852960927, 1.034311008775092],
            [31.12557336643301, 1.033871254464931],
            [31.12482393882238, 1.031918492458352],
            [31.12394009360088, 1.031264191111344],
            [31.124017330748984, 1.030524372172027],
            [31.122547593519382, 1.029695292905661],
            [31.121978210749585, 1.027729346783987],
            [31.12279143042349, 1.025499194262237],
            [31.122067516763565, 1.025112270083221],
            [31.122781045898776, 1.024494297487833],
            [31.12186009845942, 1.0233232224136],
            [31.122595922881658, 1.022097912571123],
            [31.122081128935076, 1.020584754066454],
            [31.12223519090459, 1.01980080991059],
            [31.121248866773765, 1.017845663647886],
            [31.121633774211794, 1.016299907513971],
            [31.12086653211076, 1.014952242997995],
            [31.121547860236326, 1.013086419985764],
            [31.120714478774197, 1.012268769989598],
            [31.119919732055806, 1.010275285036903],
            [31.12096651100862, 1.008498758701821],
            [31.12067725258881, 1.006435589094106],
            [31.121855732647123, 1.003325736116962],
            [31.121411159107954, 1.000325979789225],
            [31.123194248471613, 0.999264523189663],
            [31.12440956125318, 0.997163698782215],
            [31.12585388963498, 0.997715363120546],
            [31.126426811767004, 0.997249111136068],
            [31.128774889342065, 0.992969459528865],
            [31.13063149503195, 0.991306492501925],
            [31.13342940937541, 0.990942352906027],
            [31.14086200445921, 0.986832066927697],
            [31.143442087227776, 0.986175200285517],
            [31.1487288721008, 0.985867297117918],
            [31.155633485071306, 0.983859612956866],
            [31.161683365421997, 0.983478959451768],
            [31.165389918488852, 0.982676393369734],
            [31.16778887394665, 0.981068468174581],
            [31.171552031656212, 0.97640735732094],
            [31.173187660769326, 0.975347606818057],
            [31.177441251013285, 0.970814739167887],
            [31.180512573901694, 0.96885968874076],
            [31.180949136265152, 0.967835847186939],
            [31.184037758909298, 0.967508351977692],
            [31.185490620387995, 0.968496642492879],
            [31.19032384497576, 0.96718257317274],
            [31.191595369836232, 0.96754900213429],
            [31.19344966775414, 0.965245805958935],
            [31.1934867573956, 0.963819420543153],
            [31.19565061925198, 0.960144839972018],
            [31.194888067255064, 0.959230071021514],
            [31.195215753806107, 0.957950137421858],
            [31.199037667623422, 0.95347994751369],
            [31.19943114678585, 0.95349469670641],
            [31.20117868711877, 0.953917206575998],
            [31.203970660903256, 0.956176464636653],
            [31.207845472914414, 0.95678170016611],
            [31.208301967995695, 0.958532047553144],
            [31.210393186688325, 0.960293958230394],
            [31.21596423534817, 0.963338628456238],
            [31.217911758629665, 0.963812728142972],
            [31.22054875236641, 0.965192176960691],
            [31.226313836229306, 0.972434634003527],
            [31.233232739599334, 0.979421000552761],
            [31.235835869544825, 0.986707945352099],
            [31.240093539936797, 0.988262249975149],
            [31.246407404606796, 0.989152496080147],
            [31.252574993005794, 0.989007967908582],
            [31.25619906455989, 0.989511141697505],
            [31.256304537554033, 0.990449822779979],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 141,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KIKWAYA",
        Population: 23162,
        Key: "KAKUMIROKIKWAYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.842754921292386, 0.199737938125393],
            [30.837706746026782, 0.19797597876634],
            [30.83189882869451, 0.197975204423197],
            [30.827314312574615, 0.199403038337611],
            [30.817683689110925, 0.204202372058808],
            [30.810355745961083, 0.206624262110715],
            [30.8073625711125, 0.20729285135711],
            [30.797800204339037, 0.208349250605615],
            [30.794538208641708, 0.210030336742148],
            [30.792201931336187, 0.210292177716325],
            [30.79184276961424, 0.210970169409128],
            [30.790875540971424, 0.211268368533209],
            [30.784445641814504, 0.209341798857526],
            [30.782026925217057, 0.209278166220671],
            [30.77888596672444, 0.208590634409509],
            [30.775771459125398, 0.205453136047128],
            [30.770461884891898, 0.204485052114587],
            [30.768539982460656, 0.202794216037199],
            [30.76610581484033, 0.196899514189709],
            [30.76433154962773, 0.194973663245883],
            [30.76285180786079, 0.194042299817773],
            [30.76055115504453, 0.193788857781588],
            [30.753880588239834, 0.194710170031993],
            [30.75342448392569, 0.192662057921099],
            [30.753810571749966, 0.191539665994554],
            [30.753296505438733, 0.18756787294081],
            [30.752439107517507, 0.185668240838755],
            [30.750381075286416, 0.183250407239097],
            [30.75003834464931, 0.18066011470467],
            [30.749180876659477, 0.179278540460998],
            [30.749867202112956, 0.177551793719013],
            [30.751754075638015, 0.177033978522178],
            [30.752280437190553, 0.173825251792526],
            [30.74626591003786, 0.170989398263901],
            [30.74282365839559, 0.166800208478056],
            [30.740987153408526, 0.165527288497098],
            [30.73983433552293, 0.165031092639669],
            [30.737301968567326, 0.165178667261858],
            [30.735623990176745, 0.164372589832938],
            [30.73553737821033, 0.160808063087138],
            [30.73422579477639, 0.158070413841339],
            [30.734643390110932, 0.156461578550505],
            [30.734011675040197, 0.152979601729318],
            [30.734620098592256, 0.15123871326786],
            [30.73668362042804, 0.148561462609667],
            [30.736969955729897, 0.147552938187188],
            [30.736588466381555, 0.146076086657426],
            [30.734727399657984, 0.145119538478548],
            [30.733661889933188, 0.141632055005004],
            [30.73263389924453, 0.129371587669803],
            [30.73023278962666, 0.126608471971622],
            [30.726288993289923, 0.111325899121867],
            [30.729720005211348, 0.104591619585975],
            [30.734458868965035, 0.097943738443067],
            [30.737953944240964, 0.094468761582681],
            [30.737457510960454, 0.092395873973013],
            [30.73572652478161, 0.090142379280204],
            [30.7353208985999, 0.088440405361983],
            [30.734221569101276, 0.0871776971523],
            [30.73426616237029, 0.085655953690222],
            [30.736247607833505, 0.083770315613167],
            [30.73728778327066, 0.081169141299856],
            [30.741671565450456, 0.080719572678063],
            [30.74333763846854, 0.079915083622521],
            [30.748807526945946, 0.078622631049526],
            [30.750827564932067, 0.078604663862426],
            [30.750763409949418, 0.079201321613426],
            [30.759553772652577, 0.0778909620179],
            [30.762273323360564, 0.076968991341026],
            [30.765170412609713, 0.075314752392632],
            [30.766095693522033, 0.07397681891362],
            [30.76607025682646, 0.072042166467683],
            [30.76258490132189, 0.066916076901629],
            [30.762559580508974, 0.065306883583658],
            [30.76073516504901, 0.057839432794257],
            [30.76075184317059, 0.054783779797203],
            [30.761655006662277, 0.055217753914369],
            [30.765373111165374, 0.055037093811189],
            [30.77081166999891, 0.052596385735803],
            [30.78064019052307, 0.054115563783254],
            [30.782445065829002, 0.053202539885103],
            [30.783799362358067, 0.053247794294622],
            [30.785510862281768, 0.054233278965485],
            [30.7894659953574, 0.054613135903566],
            [30.80027989318808, 0.05694603982782],
            [30.802210157138, 0.057994833174181],
            [30.802550257507935, 0.058537285967901],
            [30.802144839735348, 0.059739675843613],
            [30.79864664101721, 0.066610405570802],
            [30.796344246367582, 0.069150710053879],
            [30.79517439103434, 0.075876864607556],
            [30.79354874489896, 0.07794707433194],
            [30.791316429621297, 0.079140309894208],
            [30.79148336175389, 0.079881646563537],
            [30.799649748372474, 0.085324564652498],
            [30.804296569843824, 0.087322827004697],
            [30.809167454503275, 0.087558179945172],
            [30.81704550796679, 0.089393928158614],
            [30.819578853187725, 0.092684919115067],
            [30.819822815855957, 0.099854254576769],
            [30.828718365888975, 0.123731643902465],
            [30.835908548796702, 0.126779015813071],
            [30.839772609770534, 0.130287208443842],
            [30.841841813450458, 0.132728430391764],
            [30.84399550817449, 0.136489639156143],
            [30.844495490698694, 0.137737329936054],
            [30.84459417332758, 0.141850951312039],
            [30.845070734077396, 0.143417223835226],
            [30.84641052730619, 0.144952813492591],
            [30.84892825082437, 0.145797981724004],
            [30.853168295372157, 0.150645595473195],
            [30.854360896048412, 0.151134883653851],
            [30.86372549691544, 0.150468778889628],
            [30.868451928883896, 0.150780544419888],
            [30.869865418102005, 0.151136448513617],
            [30.870439537688302, 0.152381671724438],
            [30.870680107419698, 0.154516623528054],
            [30.866246519047298, 0.153695264495398],
            [30.863388514597833, 0.154166645654731],
            [30.856173000097424, 0.157750598645137],
            [30.852565122472935, 0.160768902084873],
            [30.850878195963833, 0.163362899261248],
            [30.850831029919835, 0.166240075331432],
            [30.85195505949551, 0.169872054402228],
            [30.852048350436082, 0.173503918704918],
            [30.85125163730554, 0.175579170993753],
            [30.840398237856895, 0.180404083543219],
            [30.839692265349836, 0.182928952145806],
            [30.840575195188062, 0.187064708577909],
            [30.84035385659027, 0.190889044111995],
            [30.84128140395207, 0.191378325877047],
            [30.84181134259605, 0.192356720482878],
            [30.842754921292386, 0.199737938125393],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 142,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "NKUNGU",
        Population: 24991,
        Key: "KIRUHURANKUNGU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.681524303256847, 0.057601040700095],
            [30.680930173697604, 0.058535096774684],
            [30.68161320772389, 0.058714512700888],
            [30.681518143508953, 0.059461948349041],
            [30.682426872962154, 0.059778904352425],
            [30.681577507776172, 0.060173514277601],
            [30.681838818709185, 0.060765499228542],
            [30.681191379527725, 0.061530849940011],
            [30.679849071016093, 0.061148099576359],
            [30.677140648637845, 0.061518705622686],
            [30.676998063544385, 0.062337890529872],
            [30.67605367456767, 0.062606924119441],
            [30.674271860811718, 0.061990954184827],
            [30.673553169058554, 0.062361649158438],
            [30.673790710569133, 0.063162911775177],
            [30.673131598678857, 0.062888985966355],
            [30.672466189598456, 0.063599351700725],
            [30.671563565994227, 0.063286664511674],
            [30.668920066658202, 0.064155996013841],
            [30.66694253335805, 0.06293536954979],
            [30.666214457803395, 0.059197064958184],
            [30.659746593147656, 0.057276838876936],
            [30.652378039858757, 0.053441184423507],
            [30.65112491968182, 0.051977651578575],
            [30.64833499764944, 0.050348515239593],
            [30.645359587883885, 0.047502177350411],
            [30.64366564104083, 0.050647912827724],
            [30.6428472919867, 0.053838875612012],
            [30.641987901602143, 0.055395629240899],
            [30.63879004471774, 0.059235360118296],
            [30.635788109498527, 0.061684955837925],
            [30.634433954903237, 0.061612575922423],
            [30.634241290529324, 0.062371891743241],
            [30.63495115723314, 0.063275884734846],
            [30.63485446706752, 0.06380017624656],
            [30.631026076397003, 0.068265535962202],
            [30.62869214369441, 0.069856376614522],
            [30.62778852116357, 0.070029543824508],
            [30.627567696402142, 0.068155191482464],
            [30.62650827635664, 0.067063044774941],
            [30.626206728085435, 0.06510348986369],
            [30.624922942119646, 0.063682181708697],
            [30.624104875136467, 0.063573667984228],
            [30.624165663233455, 0.062732995407643],
            [30.623479655783584, 0.061774773839485],
            [30.621205046025707, 0.060584658581791],
            [30.620841795172577, 0.060765384244279],
            [30.620699859561046, 0.060298807630924],
            [30.61953080821997, 0.060223094067372],
            [30.619363860815998, 0.058886428596178],
            [30.61881688741929, 0.059411819688218],
            [30.618304624925123, 0.059179191188507],
            [30.618294146975686, 0.058746303163802],
            [30.617728923405647, 0.059016887262565],
            [30.61675021788674, 0.058318862516754],
            [30.616508094069896, 0.057495000922474],
            [30.615990355445803, 0.057864870375198],
            [30.615923523483605, 0.058520584498846],
            [30.615284729688415, 0.058314593724758],
            [30.613920421435502, 0.055927458587607],
            [30.614157617993026, 0.053943099003486],
            [30.61373598832452, 0.052366839327554],
            [30.61396149600355, 0.051143684752598],
            [30.613422977550286, 0.049088244947499],
            [30.613535750254442, 0.04793654228405],
            [30.612475279180064, 0.047331227112076],
            [30.61027909324479, 0.048621558648966],
            [30.60832097074132, 0.047890112874802],
            [30.60793511019081, 0.049624203003339],
            [30.605999616249317, 0.047036758563486],
            [30.605156240131347, 0.046923238499175],
            [30.604496543437833, 0.047562113823859],
            [30.604062356219966, 0.04680550713406],
            [30.60539835586335, 0.045886283862431],
            [30.605264892263286, 0.044107041633597],
            [30.604367271376855, 0.043047784489551],
            [30.603770227682826, 0.042993121121617],
            [30.603870452719093, 0.042345819561884],
            [30.6033109909433, 0.042127230766559],
            [30.60508134938273, 0.039025264427107],
            [30.604025029423305, 0.039269023120868],
            [30.603177501292087, 0.038445154108776],
            [30.602647256322562, 0.03852500084477],
            [30.602217245372472, 0.037541420385532],
            [30.601060728224564, 0.037717924029464],
            [30.601307079513145, 0.037045407621672],
            [30.600760168100166, 0.035977761021572],
            [30.599831541861754, 0.03547816127683],
            [30.60010053159379, 0.034729370712291],
            [30.601056658856344, 0.033926573436438],
            [30.59990015877641, 0.033493604409044],
            [30.59942532638521, 0.03258555602979],
            [30.59792118368021, 0.032140101314393],
            [30.597127901215753, 0.032488951219741],
            [30.59731997449821, 0.031753386526188],
            [30.59681061446077, 0.031576836158769],
            [30.596881613707566, 0.030681543837729],
            [30.595958915451664, 0.030530204683413],
            [30.59499862270117, 0.031194294940626],
            [30.59339956041, 0.030942059724039],
            [30.592614687074903, 0.02897912521401],
            [30.59171288363252, 0.028096421860714],
            [30.591424869379395, 0.026789219660388],
            [30.591934234806747, 0.024788474994363],
            [30.59095726483297, 0.024595106359213],
            [30.5909197152541, 0.023220645466659],
            [30.59153765825319, 0.02173270938223],
            [30.59076282808298, 0.021539351522675],
            [30.592034522725072, 0.020127079615196],
            [30.59280692115581, 0.019988385133731],
            [30.592322612436696, 0.019715166149729],
            [30.59236021321954, 0.018151560448215],
            [30.591299471752265, 0.018494421323498],
            [30.591003304389613, 0.018164148539677],
            [30.589884374549822, 0.018348421741184],
            [30.58926646568668, 0.017916130888541],
            [30.58863981891077, 0.01910180818701],
            [30.5880890689966, 0.019227521115786],
            [30.587859425474, 0.020030334658296],
            [30.587128787924197, 0.019815957118599],
            [30.58703275263043, 0.020303530285584],
            [30.58641314684974, 0.020637652345976],
            [30.58637309186953, 0.0201143738446],
            [30.58592218430929, 0.02000928533586],
            [30.586185222702582, 0.019521716659557],
            [30.585224958698163, 0.019109784327961],
            [30.58461539338739, 0.01934515459727],
            [30.58389728464084, 0.01900468234387],
            [30.584085175367353, 0.018298544584226],
            [30.58312908134245, 0.018290123777163],
            [30.582947731249543, 0.017480545912908],
            [30.583379600813963, 0.017344403542918],
            [30.582966277866888, 0.016655069661905],
            [30.58337126624476, 0.016234754246],
            [30.58188494162342, 0.016020369515291],
            [30.582448589548452, 0.01507045054465],
            [30.58289114187823, 0.01552020016047],
            [30.585500578895306, 0.014654372478606],
            [30.584799177914732, 0.013574134907521],
            [30.585233396573628, 0.012695666126068],
            [30.584924447981106, 0.012035757445506],
            [30.586314750783398, 0.012149259579141],
            [30.585792875417397, 0.011064822373568],
            [30.583613479893113, 0.011321195262543],
            [30.583747094410153, 0.010152702694131],
            [30.58082086830475, 0.005820192800628],
            [30.57921145652319, 0.004691854011303],
            [30.579285923266983, 0.003215542015705],
            [30.580192630612483, 0.002255605897461],
            [30.579583767784282, 0.00170900799687],
            [30.579672969593666, 0.000166830622987],
            [30.58028849342971, -0.001465715471933],
            [30.58141812489949, -0.002761358300238],
            [30.580700740195066, -0.004105255030828],
            [30.5856149065832, -0.004637289442821],
            [30.58676661774434, -0.006048852666778],
            [30.587067062884405, -0.005645514496206],
            [30.58771807646238, -0.005897617696256],
            [30.58816877381683, -0.006855532600259],
            [30.58806864759525, -0.007914189068958],
            [30.590221882381826, -0.00982995867869],
            [30.590922959968914, -0.013006055608494],
            [30.59232511604137, -0.014367248465141],
            [30.593026130746388, -0.015728441313679],
            [30.59377733522464, -0.016333388361886],
            [30.596030760911457, -0.016787160630614],
            [30.59763317032538, -0.018753362487087],
            [30.597532980323436, -0.022181499580388],
            [30.598384250836133, -0.025559265366358],
            [30.599335644875445, -0.026718789953165],
            [30.599185391762692, -0.028785794314713],
            [30.60163907258764, -0.033575248677959],
            [30.60271571962532, -0.034936443126785],
            [30.60296597589045, -0.038062168252536],
            [30.601513569857616, -0.044515165009723],
            [30.60206439343362, -0.046330130520797],
            [30.603716867754976, -0.047640951742617],
            [30.60927536605197, -0.050615629185641],
            [30.60997638075699, -0.051472678220441],
            [30.610702459356755, -0.054295993022289],
            [30.613907279981227, -0.058026788927416],
            [30.615910386520884, -0.058430191570458],
            [30.619365650260047, -0.05827907974669],
            [30.619415651387058, -0.061001527842953],
            [30.621668825545623, -0.068866399760899],
            [30.621568512474475, -0.071387179255952],
            [30.6205668028978, -0.074059068592396],
            [30.61588426081747, -0.079806189949579],
            [30.61322982898444, -0.084998733482446],
            [30.611877736022752, -0.086006956518913],
            [30.609774250834924, -0.088830147066466],
            [30.608672291069137, -0.092762362774326],
            [30.609473557759863, -0.093518671378995],
            [30.611251222197517, -0.093922073690718],
            [30.613805092126068, -0.095585989375003],
            [30.61776098966804, -0.098711966661292],
            [30.6186623232915, -0.099921983853002],
            [30.624521140066104, -0.10340105286008],
            [30.626674937198036, -0.09805720987051],
            [30.637992562629318, -0.098713403065285],
            [30.64310067618562, -0.097302089834982],
            [30.64360118602089, -0.100831216764105],
            [30.64485302609857, -0.102545504155107],
            [30.647206578006976, -0.104411027073201],
            [30.650536339016114, -0.111570459605411],
            [30.651437422009625, -0.115301320059422],
            [30.652138500495, -0.116662638624876],
            [30.652188437841648, -0.11847760358016],
            [30.653640595041153, -0.119284406647912],
            [30.655031930906006, -0.127277602028281],
            [30.6600420607227, -0.1291480272089],
            [30.66919163904669, -0.130175634380535],
            [30.672642494752733, -0.128660296244601],
            [30.676758365178806, -0.128600830617599],
            [30.677915282077027, -0.128049631131632],
            [30.677771819329532, -0.126343584592531],
            [30.678293701882048, -0.125268925422256],
            [30.677962181321387, -0.122518519523094],
            [30.678782300954968, -0.121500268880815],
            [30.68003610924142, -0.121542225500113],
            [30.680606110950418, -0.121041749125641],
            [30.680033815842496, -0.119326379440266],
            [30.679377285710345, -0.118241538505269],
            [30.677876025699103, -0.117121796255426],
            [30.67764268740574, -0.116087099090995],
            [30.678492866465362, -0.114757869153868],
            [30.67852439823014, -0.112495608493414],
            [30.679918080494545, -0.110970003445626],
            [30.68040592318601, -0.109724917414792],
            [30.67947938283566, -0.107287213007164],
            [30.67839942640444, -0.106504985673652],
            [30.67856062818388, -0.105348264788366],
            [30.67950739230622, -0.105375689409285],
            [30.68045514996526, -0.103516841918152],
            [30.680563299938946, -0.101391371167052],
            [30.680033865249836, -0.099655176533439],
            [30.680779558563792, -0.097634970861645],
            [30.680274416116628, -0.097252631361671],
            [30.67952556163115, -0.094397568396477],
            [30.67865561783866, -0.09322034845579],
            [30.67908635103422, -0.090933287408249],
            [30.679948022241273, -0.089776236303154],
            [30.68059414628918, -0.086928712290684],
            [30.679967557005448, -0.08447886641966],
            [30.679212637095173, -0.083620033914679],
            [30.679126150892884, -0.08219172848128],
            [30.682841329583102, -0.080374919088514],
            [30.68790913483428, -0.074029164599857],
            [30.68785084405379, -0.072501413621657],
            [30.688425848480662, -0.071651687985294],
            [30.68791604647208, -0.070386072316697],
            [30.687967186662874, -0.068885445827764],
            [30.689282267238216, -0.065441289428989],
            [30.690143216199807, -0.064401733598427],
            [30.690800218845762, -0.060843777480004],
            [30.69038597512553, -0.060216247112077],
            [30.68869966306407, -0.060252338705284],
            [30.688085155222605, -0.05974607723485],
            [30.690325717932925, -0.058335935888208],
            [30.691169022185658, -0.056265819656954],
            [30.68986928842863, -0.055190016646198],
            [30.688749926499163, -0.055750451034797],
            [30.68782448838168, -0.055632896653959],
            [30.686646982995455, -0.053960467023502],
            [30.687131790279555, -0.052297137277109],
            [30.686776193072664, -0.050163702212338],
            [30.68776344336656, -0.047858552374961],
            [30.687463803117026, -0.046312714888094],
            [30.687797102341932, -0.043654985260683],
            [30.68687953526295, -0.04304928287902],
            [30.6846913191809, -0.039641173495275],
            [30.685467452806602, -0.035958709554783],
            [30.68513485247097, -0.035402603992751],
            [30.685212096805614, -0.034027312291294],
            [30.685895161374628, -0.033106477299375],
            [30.686055548382072, -0.03211387680045],
            [30.685693254234717, -0.031294671777241],
            [30.684315305064207, -0.030445550157958],
            [30.6842519855148, -0.027413381626397],
            [30.682893731906884, -0.02681146104609],
            [30.682464210538615, -0.025929060408983],
            [30.681053710913783, -0.025736196628682],
            [30.68073447391633, -0.024999890781602],
            [30.68093184546234, -0.023796101697628],
            [30.68286402372211, -0.022916791244738],
            [30.684160888260145, -0.01988394071689],
            [30.683860509595434, -0.018674265830542],
            [30.68407113937673, -0.017819155961692],
            [30.68358430459504, -0.016790234665383],
            [30.684229986671813, -0.015851703640692],
            [30.68546817415377, -0.01569444996292],
            [30.68656413137682, -0.014592058146013],
            [30.68521367514558, -0.012164490514452],
            [30.685192544075157, -0.010181402968679],
            [30.685692929942892, -0.00934417942426],
            [30.685627054686513, -0.00485558814096],
            [30.684491323655937, -0.003983809092935],
            [30.68491418221974, -0.002139077337195],
            [30.684350371699637, -0.001223806352499],
            [30.68457236966087, -0.000258869312066],
            [30.68355514617922, 0.000346743411468],
            [30.681826943879454, 0.003817327914972],
            [30.682759440060128, 0.004881688691433],
            [30.68459474489798, 0.005282327425118],
            [30.683328562318472, 0.007346549035863],
            [30.684583440498432, 0.008066399609237],
            [30.684497901120455, 0.009377114357071],
            [30.68391819491141, 0.010563449266254],
            [30.684274190970285, 0.011325308648172],
            [30.68397208933687, 0.013414070399679],
            [30.685741921363565, 0.014351818103983],
            [30.685033424590554, 0.015174309262621],
            [30.686026778936796, 0.017328380293924],
            [30.68562059130803, 0.018592829062779],
            [30.686609891557403, 0.020385638094009],
            [30.68646991427318, 0.022544422520769],
            [30.687720431132437, 0.023977670065416],
            [30.687484250569494, 0.024941533531336],
            [30.68571621876665, 0.025217807675565],
            [30.686060876290025, 0.025802559663577],
            [30.68573534120409, 0.026483686495613],
            [30.686571468816048, 0.027190539274089],
            [30.68522469028759, 0.02794232577364],
            [30.686469321385097, 0.028270067980772],
            [30.686035283287588, 0.028745565964731],
            [30.686333765608726, 0.030520537914019],
            [30.686801193187023, 0.02972872789772],
            [30.687764205137896, 0.030075739858198],
            [30.68719191721648, 0.031330465144377],
            [30.68780320639428, 0.033121566298667],
            [30.686947757817222, 0.038924026114641],
            [30.68737340924323, 0.039085399434868],
            [30.68835198809968, 0.038197953069233],
            [30.688888142187107, 0.03819796834058],
            [30.688990252787146, 0.03866062845561],
            [30.68781956830888, 0.042287662646257],
            [30.68496705256578, 0.042558768734805],
            [30.684630671221125, 0.043595494348248],
            [30.68381385109959, 0.043495793058588],
            [30.683871105224224, 0.044135233453781],
            [30.683249252756998, 0.044701171014412],
            [30.684171049104314, 0.045523210092943],
            [30.685779507773354, 0.045414027091037],
            [30.686092210425446, 0.046962650272404],
            [30.685198606805, 0.047450977888386],
            [30.68530070123536, 0.048267054818454],
            [30.684617720209673, 0.048973865199186],
            [30.68495596106698, 0.050233328806644],
            [30.6840687453665, 0.050554584194308],
            [30.684528286634944, 0.051017257706373],
            [30.684422609723228, 0.051856636881399],
            [30.683863484815646, 0.052596462990888],
            [30.682683594402363, 0.053015598758139],
            [30.682587851959383, 0.054439028107301],
            [30.681476653020912, 0.056308334203903],
            [30.680264393612973, 0.056498260420838],
            [30.680379223459116, 0.057911931292286],
            [30.681524303256847, 0.057601040700095],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 144,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "ENGARI",
        Population: 25006,
        Key: "KIRUHURAENGARI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.655031930906006, -0.127277602028281],
            [30.653640595041153, -0.119284406647912],
            [30.652188437841648, -0.11847760358016],
            [30.652138500495, -0.116662638624876],
            [30.651437422009625, -0.115301320059422],
            [30.650536339016114, -0.111570459605411],
            [30.647206578006976, -0.104411027073201],
            [30.64485302609857, -0.102545504155107],
            [30.64360118602089, -0.100831216764105],
            [30.64310067618562, -0.097302089834982],
            [30.637992562629318, -0.098713403065285],
            [30.626674937198036, -0.09805720987051],
            [30.624521140066104, -0.10340105286008],
            [30.6186623232915, -0.099921983853002],
            [30.61776098966804, -0.098711966661292],
            [30.613805092126068, -0.095585989375003],
            [30.611251222197517, -0.093922073690718],
            [30.609473557759863, -0.093518671378995],
            [30.608672291069137, -0.092762362774326],
            [30.609774250834924, -0.088830147066466],
            [30.611877736022752, -0.086006956518913],
            [30.61322982898444, -0.084998733482446],
            [30.61588426081747, -0.079806189949579],
            [30.6205668028978, -0.074059068592396],
            [30.621568512474475, -0.071387179255952],
            [30.621668825545623, -0.068866399760899],
            [30.619415651387058, -0.061001527842953],
            [30.619365650260047, -0.05827907974669],
            [30.615910386520884, -0.058430191570458],
            [30.613907279981227, -0.058026788927416],
            [30.610702459356755, -0.054295993022289],
            [30.60997638075699, -0.051472678220441],
            [30.60927536605197, -0.050615629185641],
            [30.603716867754976, -0.047640951742617],
            [30.60206439343362, -0.046330130520797],
            [30.601513569857616, -0.044515165009723],
            [30.60296597589045, -0.038062168252536],
            [30.60271571962532, -0.034936443126785],
            [30.60163907258764, -0.033575248677959],
            [30.599185391762692, -0.028785794314713],
            [30.599335644875445, -0.026718789953165],
            [30.598384250836133, -0.025559265366358],
            [30.597532980323436, -0.022181499580388],
            [30.59763317032538, -0.018753362487087],
            [30.596030760911457, -0.016787160630614],
            [30.59377733522464, -0.016333388361886],
            [30.593026130746388, -0.015728441313679],
            [30.59232511604137, -0.014367248465141],
            [30.590922959968914, -0.013006055608494],
            [30.590221882381826, -0.00982995867869],
            [30.58806864759525, -0.007914189068958],
            [30.58816877381683, -0.006855532600259],
            [30.58771807646238, -0.005897617696256],
            [30.587067062884405, -0.005645514496206],
            [30.58676661774434, -0.006048852666778],
            [30.5856149065832, -0.004637289442821],
            [30.580700740195066, -0.004105255030828],
            [30.58030122525224, -0.004506559416573],
            [30.58045247100338, -0.005103911230632],
            [30.581755519543805, -0.005158572817129],
            [30.58191064332201, -0.00552166915845],
            [30.581476290814155, -0.006833497824813],
            [30.58194166304709, -0.007551883246805],
            [30.58166243162248, -0.009055020721189],
            [30.580766580417198, -0.010089643657098],
            [30.580607573221997, -0.010964195792263],
            [30.57946739822575, -0.012322867987002],
            [30.57846100842643, -0.012891285054094],
            [30.577477911044085, -0.014450666918103],
            [30.578955451938565, -0.016476985850788],
            [30.57975821791752, -0.016836184388503],
            [30.579397547025884, -0.017386680054877],
            [30.57982800443866, -0.018612619845756],
            [30.578712860099472, -0.022970014624434],
            [30.57899026075753, -0.02389505920245],
            [30.577233456099112, -0.025117059829511],
            [30.577629002284993, -0.026401563419374],
            [30.57714423093351, -0.026838830014825],
            [30.57805943723991, -0.028349789859251],
            [30.579141420270386, -0.028892500682216],
            [30.578885433652072, -0.030434674256368],
            [30.575429987554898, -0.032882560573833],
            [30.576085859221944, -0.035571731575476],
            [30.575546235840886, -0.037697985926038],
            [30.573757931757015, -0.038256664248163],
            [30.572437278033643, -0.037956573110726],
            [30.571769218024844, -0.038799817885508],
            [30.57022246103941, -0.03853075994276],
            [30.570369727253812, -0.04223471775443],
            [30.56867555134036, -0.043750652217343],
            [30.568603588201245, -0.044459402105275],
            [30.568910903656587, -0.044644712814261],
            [30.569274077254597, -0.045224267928095],
            [30.568985478198222, -0.045866038537369],
            [30.56944329470131, -0.048749543377897],
            [30.57024855350513, -0.049111137605791],
            [30.570482963488633, -0.049635416668833],
            [30.569941255117815, -0.050882801521076],
            [30.571545630045552, -0.054634114250883],
            [30.57165576080444, -0.058123238294966],
            [30.572597484479736, -0.059488192615937],
            [30.57396308540834, -0.059434015250331],
            [30.57372048368778, -0.060310805523212],
            [30.57412184287188, -0.060699507228243],
            [30.57402022185366, -0.061838440101563],
            [30.574496098985552, -0.061675756196448],
            [30.57646197574658, -0.062498409494433],
            [30.577312393758053, -0.0632577405738],
            [30.57806345091258, -0.064740205107814],
            [30.577756837041512, -0.0663943671787],
            [30.57892220618822, -0.070109540537376],
            [30.577822713196227, -0.073327444399246],
            [30.575703829986118, -0.074294527610815],
            [30.57528191375504, -0.075379208255135],
            [30.57560506201728, -0.076952045536767],
            [30.574665965015868, -0.079157555734563],
            [30.57506406151888, -0.080088615508392],
            [30.576388791797008, -0.080929337173015],
            [30.57649002833627, -0.081887498152518],
            [30.576414083863817, -0.082673904100885],
            [30.574308985301737, -0.085304182799582],
            [30.575299800110677, -0.086407025269442],
            [30.57507833754538, -0.087717693603568],
            [30.5745100318556, -0.087446482654669],
            [30.574279479237937, -0.088296151370288],
            [30.574982522338836, -0.089869015089998],
            [30.574428706474606, -0.09117062290494],
            [30.57552898189924, -0.093819178999543],
            [30.57451077925392, -0.095355772148558],
            [30.57495330104099, -0.096802072993822],
            [30.57549860626622, -0.096955777214167],
            [30.575826130222154, -0.097787406658842],
            [30.57590651506706, -0.101773698042651],
            [30.575476912850412, -0.102144274070163],
            [30.572981654400873, -0.102487578183362],
            [30.57269459056531, -0.102849123453625],
            [30.570921113175196, -0.101601586495193],
            [30.5699644298555, -0.102098669370588],
            [30.57111582750462, -0.103671570184732],
            [30.5707320528422, -0.104702005282258],
            [30.57104059898946, -0.105958473153725],
            [30.570104600277496, -0.107440822854413],
            [30.56945103907735, -0.11205977909374],
            [30.5711616703302, -0.113099422517944],
            [30.573430125730056, -0.11893891982778],
            [30.577047471597613, -0.121578679950611],
            [30.577308804090187, -0.123540211564491],
            [30.58070365522818, -0.127653365483437],
            [30.5811129321632, -0.128720032263675],
            [30.584354279185447, -0.130193110160958],
            [30.58658490113878, -0.130620669399485],
            [30.58802320631661, -0.130320630177555],
            [30.590714064834405, -0.130909848912737],
            [30.591620352666695, -0.133150270927166],
            [30.591470259454063, -0.134406719530622],
            [30.589343189896777, -0.142207417891239],
            [30.58912788797767, -0.144503373416765],
            [30.5882663551112, -0.14707947819011],
            [30.588528046929884, -0.147200798862418],
            [30.597690107344743, -0.14660139726428],
            [30.60418286072377, -0.148880010424495],
            [30.605298483865017, -0.14893436640046],
            [30.608015641461066, -0.151161750373855],
            [30.609978200743775, -0.154388286181263],
            [30.615849156452793, -0.160223638524738],
            [30.619071661311953, -0.162686998797702],
            [30.621076167426832, -0.163347783371392],
            [30.625390799092653, -0.163878853523988],
            [30.629702624421547, -0.159091717152383],
            [30.62966390343952, -0.158482740780101],
            [30.63034613616856, -0.158292825078295],
            [30.635290878514034, -0.154206031247427],
            [30.64073108126456, -0.148875408370834],
            [30.641379700832303, -0.147098402935834],
            [30.640155216251667, -0.143797997826856],
            [30.640659757725945, -0.141767108210115],
            [30.641812651968326, -0.140534151766234],
            [30.64511416635163, -0.139099282425107],
            [30.647302793862092, -0.137295745465419],
            [30.648600294407338, -0.132739873101152],
            [30.65141039439765, -0.130850840532286],
            [30.65317829774141, -0.127949257225525],
            [30.655031930906006, -0.127277602028281],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 145,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "KANONI",
        Population: 16818,
        Key: "KIRUHURAKANONI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.80516647950036, -0.014141950100542],
            [30.799671550484426, -0.006130485271121],
            [30.794233826185764, -0.002396705177339],
            [30.79213430885655, 0.000993515144636],
            [30.789214377246342, 0.0035700702268],
            [30.786733073226415, 0.005115994469475],
            [30.783157800853512, 0.006609808337482],
            [30.781049868106727, -0.001266641618483],
            [30.778896776152283, -0.004711081551579],
            [30.77857909324025, -0.009403102617885],
            [30.77651423471131, -0.012775189484622],
            [30.77637292792049, -0.015089554116829],
            [30.77577294044728, -0.016364265253563],
            [30.773302164682505, -0.018750920866273],
            [30.772759082787587, -0.020213878425829],
            [30.76984953660039, -0.019765852688314],
            [30.76235217478126, -0.017019635632846],
            [30.76050012893977, -0.015011648624804],
            [30.759787814326796, -0.013051489699451],
            [30.758220706906908, -0.01056542915309],
            [30.75603625835915, -0.002677001105266],
            [30.755062607660346, -0.001175824638243],
            [30.753054857728987, -0.003237207583701],
            [30.749597081401976, -0.00482534186543],
            [30.746760760486854, -0.005362741015747],
            [30.741391761798997, -0.00446364869222],
            [30.740358659696383, -0.007128341966886],
            [30.739815706260554, -0.009906907466486],
            [30.739891096472462, -0.013125794744558],
            [30.736690002059785, -0.021354819609945],
            [30.736689984093513, -0.022667557282124],
            [30.735243232057044, -0.025331325072001],
            [30.73180724975715, -0.028387908067015],
            [30.73149312147873, -0.030438440891799],
            [30.729214535777405, -0.030794287779551],
            [30.72274608631838, -0.033732213975445],
            [30.71788937976909, -0.033403223127076],
            [30.71947024578585, -0.039934167039372],
            [30.72240393958623, -0.047650974242768],
            [30.719810712668437, -0.051205416954279],
            [30.718667055802108, -0.053452471750126],
            [30.71610062832419, -0.054372729774274],
            [30.713982338900497, -0.054256318945548],
            [30.713843718970693, -0.062054249442662],
            [30.711991116173706, -0.066439200267785],
            [30.705833349954037, -0.065629922040537],
            [30.703568169811696, -0.066569160350692],
            [30.69825420820637, -0.070339373431866],
            [30.69794955086595, -0.071525592465615],
            [30.698585267032954, -0.071889584143786],
            [30.6990412581594, -0.071625083500651],
            [30.699088182556586, -0.075673965006724],
            [30.699994776714355, -0.077040098321419],
            [30.699749170129135, -0.078423207040368],
            [30.701691080736726, -0.07933635264443],
            [30.702089787195796, -0.080177093189112],
            [30.703248233026606, -0.081063082710464],
            [30.7047439594157, -0.081206921707854],
            [30.70434052242835, -0.08285999890096],
            [30.705534788581154, -0.08336337473074],
            [30.70532181868855, -0.083950553398709],
            [30.70634016326764, -0.084761493167825],
            [30.70693258153627, -0.086476498199502],
            [30.707960217390383, -0.086793455808741],
            [30.70778427156221, -0.087501804438679],
            [30.709876553860138, -0.088415335208879],
            [30.70979318121859, -0.089216899177223],
            [30.71040416946079, -0.090037143571387],
            [30.710154092858716, -0.091817339914662],
            [30.708413344687678, -0.095275143971778],
            [30.71013021294354, -0.096907274546428],
            [30.709056338106805, -0.097687965996527],
            [30.7094142260177, -0.098468749954821],
            [30.710746538076798, -0.098869235382631],
            [30.71154189924284, -0.099770175088719],
            [30.71325201576101, -0.10055105871075],
            [30.71388806160972, -0.10491539073784],
            [30.71818511863533, -0.107677605769683],
            [30.72522048049713, -0.104584090818111],
            [30.72672581436818, -0.103537280354149],
            [30.730630366005116, -0.102311442193642],
            [30.738904971767663, -0.102672639818443],
            [30.7405885143231, -0.10335794906795],
            [30.74363328750327, -0.103718787355372],
            [30.746636859452956, -0.104809253168175],
            [30.74879581201633, -0.102528800009129],
            [30.7514889073392, -0.100852951468747],
            [30.75469230054068, -0.103865667053222],
            [30.755441680540592, -0.106080609687294],
            [30.759945183893223, -0.106614310454639],
            [30.769004891162925, -0.111189422829639],
            [30.770732397268347, -0.112704344223013],
            [30.777225307852568, -0.114516230910921],
            [30.781808127054884, -0.114658165340268],
            [30.779979033168896, -0.112699169038679],
            [30.779440953093488, -0.109344209398131],
            [30.778415734605844, -0.10715053816925],
            [30.77742499884864, -0.100980616245622],
            [30.779921056798795, -0.098560636692767],
            [30.784766525423866, -0.095532366315345],
            [30.787263891321057, -0.094402456123317],
            [30.788104751257922, -0.092739049726599],
            [30.79308162903606, -0.091130119716665],
            [30.79395441958969, -0.090379809105057],
            [30.795381132008767, -0.090461259250457],
            [30.79600528595973, -0.089828446323329],
            [30.79826029357981, -0.089503120044939],
            [30.801421867509877, -0.086890562681104],
            [30.80556356809359, -0.086239866052771],
            [30.80721584748051, -0.084947145987363],
            [30.809162597312532, -0.084721236110698],
            [30.810257188197998, -0.082171818241793],
            [30.811528448953794, -0.076765545570134],
            [30.811912524551843, -0.073167363848095],
            [30.811767619110014, -0.069099038996339],
            [30.80999504273012, -0.057942742592451],
            [30.809467321128235, -0.049480630715063],
            [30.8102614183647, -0.037067780159138],
            [30.810187335201533, -0.030061237458253],
            [30.808647338038586, -0.023922581783725],
            [30.80516647950036, -0.014141950100542],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 146,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "KAZO TOWN COUNCIL",
        Population: 12944,
        Key: "KIRUHURAKAZO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.913389921003283, 0.024763415593542],
            [30.907757162574967, 0.031571397758867],
            [30.906903666036996, 0.03353333509064],
            [30.906619893628662, 0.035151716259549],
            [30.90692064778913, 0.039111800914948],
            [30.90625823369189, 0.042176772841077],
            [30.905060360803237, 0.044455136905607],
            [30.90522786965426, 0.045702836261898],
            [30.904659766085427, 0.047972174845603],
            [30.903686719952837, 0.049210794870105],
            [30.902124626928853, 0.057311697984141],
            [30.902626371947665, 0.058685986714029],
            [30.90170075147217, 0.059834187543182],
            [30.90492919689027, 0.06938188952668],
            [30.903433823539107, 0.071126782110968],
            [30.90272256714155, 0.073115823050691],
            [30.900550262019784, 0.075014375783022],
            [30.896813415964942, 0.08105371957962],
            [30.896791680328306, 0.08337731028096],
            [30.896128653580043, 0.085881689288426],
            [30.89630923920666, 0.088503650275834],
            [30.89246463753852, 0.093638819091369],
            [30.893203164991498, 0.095790668430423],
            [30.893229899752647, 0.099027417688476],
            [30.891616565028258, 0.101775831538092],
            [30.88987167382711, 0.103502577593052],
            [30.88723755380095, 0.107281600343106],
            [30.887380912343882, 0.108022985824977],
            [30.886586029979895, 0.109351978014582],
            [30.887442226853604, 0.110066291866203],
            [30.887514016617843, 0.110834795570549],
            [30.887087104855503, 0.111530932909506],
            [30.887183008096898, 0.112579714896287],
            [30.88610583464645, 0.117064045483057],
            [30.886297399482483, 0.118573932416897],
            [30.885775068670654, 0.119215813238013],
            [30.886252261834393, 0.121557509401969],
            [30.885848928153308, 0.122136110273134],
            [30.88327119088594, 0.122307682712167],
            [30.881657561514135, 0.124820985165855],
            [30.879912655939968, 0.126529610861881],
            [30.88031854532803, 0.128943623270963],
            [30.88123497334323, 0.130779050056864],
            [30.8808803553, 0.132686695673928],
            [30.881214463008668, 0.134287003178444],
            [30.879991341172328, 0.135118677339703],
            [30.8799446781849, 0.135977579332087],
            [30.881126455060297, 0.142324553351604],
            [30.881887226596298, 0.142921339176845],
            [30.883168800011536, 0.1413211795756],
            [30.883762934960696, 0.1412217830882],
            [30.8842860167641, 0.141655806388548],
            [30.884358050870116, 0.142641297443068],
            [30.883290570241584, 0.144648328702787],
            [30.884788280110804, 0.145624915555962],
            [30.885952944080056, 0.145769686680753],
            [30.88607240833476, 0.146728060202671],
            [30.885562898278636, 0.14817459454817],
            [30.88637163086767, 0.149078788958586],
            [30.887322165219263, 0.149205458171031],
            [30.88775009746777, 0.149747970484461],
            [30.88758444363782, 0.150489328679222],
            [30.886420311471248, 0.15063387160093],
            [30.88575593814834, 0.151492714621312],
            [30.886967994537024, 0.152026264417786],
            [30.887077956412625, 0.15533533879678],
            [30.88565252858443, 0.155624509913596],
            [30.8837050079979, 0.156817739466748],
            [30.88422933756127, 0.158734516029985],
            [30.883897277113125, 0.159276949049083],
            [30.880976154336835, 0.160904043205429],
            [30.880822542423232, 0.161853344896181],
            [30.878636583807516, 0.162015850380365],
            [30.875450687092805, 0.159601537850545],
            [30.87255115262943, 0.15888698649744],
            [30.870680107419698, 0.154516623528054],
            [30.870439537688302, 0.152381671724438],
            [30.869865418102005, 0.151136448513617],
            [30.868451928883896, 0.150780544419888],
            [30.86372549691544, 0.150468778889628],
            [30.854360896048412, 0.151134883653851],
            [30.853168295372157, 0.150645595473195],
            [30.84892825082437, 0.145797981724004],
            [30.84641052730619, 0.144952813492591],
            [30.845070734077396, 0.143417223835226],
            [30.84459417332758, 0.141850951312039],
            [30.844495490698694, 0.137737329936054],
            [30.84399550817449, 0.136489639156143],
            [30.841841813450458, 0.132728430391764],
            [30.839772609770534, 0.130287208443842],
            [30.835908548796702, 0.126779015813071],
            [30.828718365888975, 0.123731643902465],
            [30.819822815855957, 0.099854254576769],
            [30.819578853187725, 0.092684919115067],
            [30.81704550796679, 0.089393928158614],
            [30.809167454503275, 0.087558179945172],
            [30.804296569843824, 0.087322827004697],
            [30.799649748372474, 0.085324564652498],
            [30.79148336175389, 0.079881646563537],
            [30.791316429621297, 0.079140309894208],
            [30.79354874489896, 0.07794707433194],
            [30.79517439103434, 0.075876864607556],
            [30.796344246367582, 0.069150710053879],
            [30.79864664101721, 0.066610405570802],
            [30.802144839735348, 0.059739675843613],
            [30.802550257507935, 0.058537285967901],
            [30.802210157138, 0.057994833174181],
            [30.80027989318808, 0.05694603982782],
            [30.7894659953574, 0.054613135903566],
            [30.785510862281768, 0.054233278965485],
            [30.783799362358067, 0.053247794294622],
            [30.782445065829002, 0.053202539885103],
            [30.78064019052307, 0.054115563783254],
            [30.77081166999891, 0.052596385735803],
            [30.765373111165374, 0.055037093811189],
            [30.761655006662277, 0.055217753914369],
            [30.76075184317059, 0.054783779797203],
            [30.762127140514362, 0.051845703490537],
            [30.762125789448163, 0.050435401158585],
            [30.76415206533566, 0.044920821610587],
            [30.765670714035853, 0.042931977308968],
            [30.767866912547515, 0.041322848033437],
            [30.768079661454568, 0.040075274369811],
            [30.769573503178183, 0.036920201361742],
            [30.76897217721523, 0.029127321165722],
            [30.770585390667073, 0.026568907860855],
            [30.772840517763065, 0.0245167660871],
            [30.773753557333006, 0.022753890764057],
            [30.777319169223354, 0.012031923435978],
            [30.781864627492986, 0.007358017826978],
            [30.783157800853512, 0.006609808337482],
            [30.786733073226415, 0.005115994469475],
            [30.789214377246342, 0.0035700702268],
            [30.79213430885655, 0.000993515144636],
            [30.794233826185764, -0.002396705177339],
            [30.799671550484426, -0.006130485271121],
            [30.80516647950036, -0.014141950100542],
            [30.814591228863875, -0.009466547032296],
            [30.82516841253233, -0.005533851211966],
            [30.82754751162909, -0.004180959652888],
            [30.831415369781617, -0.004180963246143],
            [30.837837967431923, -0.007048456585916],
            [30.83984852010696, -0.009409926220712],
            [30.84123816264755, -0.010255846355094],
            [30.84247275507176, -0.012404961425639],
            [30.84441642997051, -0.014475340943226],
            [30.844412278855597, -0.031390872346613],
            [30.84546241301601, -0.031879101239242],
            [30.847102876861968, -0.031933378338585],
            [30.849757672512723, -0.033804902940654],
            [30.854349159559202, -0.035622230359429],
            [30.855905135056084, -0.036869919072467],
            [30.856963641514945, -0.039645523136847],
            [30.857922284060272, -0.040540603368467],
            [30.858143199551574, -0.043994265369519],
            [30.85871398189659, -0.045377551908707],
            [30.857809548187067, -0.04792708392572],
            [30.85675247813437, -0.049337445600215],
            [30.852516505649756, -0.058107038085477],
            [30.850520401477738, -0.063513447659574],
            [30.85108758696834, -0.069851171779641],
            [30.851665047389172, -0.071993901822225],
            [30.856466878552702, -0.078783892863933],
            [30.857407623962658, -0.081366134456992],
            [30.85213772562033, -0.090256502909106],
            [30.850050176545647, -0.09844356572301],
            [30.851789289782865, -0.099469345924442],
            [30.852359269034004, -0.099415136271947],
            [30.853702628574506, -0.098122364582574],
            [30.854651621417048, -0.09792352278545],
            [30.857817260223783, -0.099786164178212],
            [30.858769320813046, -0.099939921385328],
            [30.8602626352256, -0.099478925544185],
            [30.864841597062078, -0.101233175397911],
            [30.866645298269937, -0.10093493698433],
            [30.86961107180739, -0.10167649419393],
            [30.87341015494177, -0.101233726962634],
            [30.875539932919644, -0.101541261125368],
            [30.877901485224, -0.102508810729449],
            [30.884749752266586, -0.106975578996712],
            [30.886379165936287, -0.107111306114426],
            [30.887985195560777, -0.108657453996108],
            [30.889244455722686, -0.108603292868321],
            [30.890558945206603, -0.109417088686013],
            [30.891057099659182, -0.109299588362563],
            [30.8916170680848, -0.108054300141794],
            [30.89334915110663, -0.108819992175945],
            [30.896253442149405, -0.108257917311206],
            [30.90518989876552, -0.104322585385258],
            [30.909881718646105, -0.099599749665888],
            [30.91691929934664, -0.095101935549302],
            [30.91658469217466, -0.085992961680864],
            [30.914797857734605, -0.077558657533771],
            [30.91502146098522, -0.073285335904768],
            [30.92742073168046, -0.06991218261343],
            [30.932559248717528, -0.067213424446874],
            [30.940626775739066, -0.060968212941168],
            [30.943230133856655, -0.057323670724232],
            [30.9430500162523, -0.055443036909543],
            [30.9415960435576, -0.052332722225631],
            [30.93942623754896, -0.04484632614358],
            [30.938712849449256, -0.043490088758196],
            [30.93709124663095, -0.042866187410949],
            [30.936585246292655, -0.042106692589769],
            [30.934100935611514, -0.040732333446279],
            [30.933713932403958, -0.039972844892863],
            [30.933994037889313, -0.039385158191767],
            [30.93368730813555, -0.038309221968779],
            [30.93552394607329, -0.036347271262014],
            [30.936056938989235, -0.034801196395926],
            [30.933908629665375, -0.029774118864605],
            [30.930702230700934, -0.026021878826206],
            [30.92696324396075, -0.011853968978666],
            [30.925684604443227, -0.009711153789155],
            [30.923114966386485, -0.008083696669843],
            [30.920215850538018, -0.002667918239457],
            [30.920069350586548, -0.001799948944588],
            [30.918858903978855, -0.000434707342379],
            [30.91760242500106, 0.002603179351936],
            [30.91769784405055, 0.003145659374911],
            [30.91700940665783, 0.003769508795885],
            [30.917235888110646, 0.004501857634379],
            [30.916808735599783, 0.00517091387247],
            [30.916738846670672, 0.006463824019923],
            [30.91578940017889, 0.007612066777053],
            [30.915647944267754, 0.008832643673621],
            [30.91353853109735, 0.014347827787601],
            [30.91385057438604, 0.017675034756009],
            [30.91486201361554, 0.019338649896658],
            [30.913389921003283, 0.024763415593542],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 147,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "RWEMIKOMA",
        Population: 23499,
        Key: "KIRUHURARWEMIKOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.020196470469802, -0.521598522884704],
              [31.018240342226218, -0.52041614720984],
              [31.016075163439627, -0.517950611034761],
              [31.015417308292456, -0.513589509256855],
              [31.015418611747947, -0.50932341645585],
              [31.01278254147929, -0.506952554726957],
              [31.005503407392137, -0.505425711893981],
              [31.001035231186368, -0.503071104026949],
              [30.998560903482936, -0.500613298095543],
              [30.996637182861566, -0.496183108579649],
              [30.995193799507454, -0.494833028027864],
              [30.994128705702643, -0.492963971063875],
              [30.995745436957122, -0.489365409144526],
              [30.995676940416708, -0.488500232772413],
              [30.992756159000248, -0.48969572288926],
              [30.991141634008077, -0.490343620770213],
              [30.98379393600686, -0.489292571007813],
              [30.97906978126761, -0.49362210904189],
              [30.977355594482887, -0.494046545451304],
              [30.973246747085724, -0.493475668422593],
              [30.96230382962069, -0.494069064479946],
              [30.95275805203559, -0.493116764344857],
              [30.942461237058872, -0.491368581556268],
              [30.93547176383676, -0.491127532899902],
              [30.93168523376016, -0.491084965098974],
              [30.926471857415503, -0.493144781760849],
              [30.916136235218538, -0.494940770638809],
              [30.916949195279276, -0.497055979531411],
              [30.922628547524756, -0.503505410134489],
              [30.928677939191928, -0.50623623467895],
              [30.930266624144927, -0.507460056925393],
              [30.931995074379763, -0.510095443874698],
              [30.932461083518206, -0.514377199454554],
              [30.933624286826813, -0.516468156570913],
              [30.94244110940661, -0.527018009938882],
              [30.945838900730532, -0.525353770497094],
              [30.94840329891424, -0.522702219973012],
              [30.950753603412902, -0.521484319404233],
              [30.95445520855914, -0.525499975043193],
              [30.959367245041758, -0.529946166824614],
              [30.960292320239876, -0.531953704790963],
              [30.961929518709795, -0.533889793208927],
              [30.964706223829413, -0.535396143966408],
              [30.970828861429922, -0.539842791219979],
              [30.973107365384543, -0.540560426996218],
              [30.975244043322125, -0.539485828238903],
              [30.97674069228103, -0.535758572297813],
              [30.977951837777997, -0.53403846960991],
              [30.97987492688374, -0.53282041136755],
              [30.982011327241878, -0.532606050266997],
              [30.985617881647944, -0.533999166430163],
              [30.99022061380515, -0.532778743916415],
              [30.993046267226312, -0.531073253560955],
              [31.002842345093963, -0.523681928487372],
              [31.020196470469802, -0.521598522884704],
            ],
          ],
          [
            [
              [30.875136641459388, -0.564143934831055],
              [30.877125150375676, -0.5593018331422],
              [30.878373297479193, -0.557544072621862],
              [30.878835206706714, -0.553179608930874],
              [30.880319122944762, -0.550368606232594],
              [30.880593175581744, -0.544123611904062],
              [30.88126102538478, -0.542581234393113],
              [30.88140991126165, -0.540864508449856],
              [30.88289361639562, -0.538600866051968],
              [30.88351237057343, -0.536063231582313],
              [30.882509582120072, -0.534340258089053],
              [30.88261270242651, -0.533879281579851],
              [30.880893735706135, -0.532554124497012],
              [30.880300440681797, -0.532927132895769],
              [30.878471682765735, -0.53240400452987],
              [30.874988017890573, -0.528894616895859],
              [30.873678806907265, -0.526829066292386],
              [30.87380285346822, -0.525435788624012],
              [30.872540064723886, -0.522356420698743],
              [30.8713080953803, -0.521031054558511],
              [30.87069068957374, -0.519612646265919],
              [30.867036033977495, -0.507845528645836],
              [30.864280057483032, -0.503517685138858],
              [30.863873554545624, -0.498457389218809],
              [30.861961973757, -0.494405867179913],
              [30.86149154041575, -0.494240168313034],
              [30.86109564748012, -0.490998999483467],
              [30.862949394730776, -0.48638221403491],
              [30.860717595984372, -0.486587303699399],
              [30.860042340470155, -0.487075303047725],
              [30.85295220742719, -0.496135308320736],
              [30.8508246330167, -0.500480068650133],
              [30.849142154964888, -0.502179209185689],
              [30.849407328653584, -0.502730793085804],
              [30.838785578665565, -0.509806274163777],
              [30.82865996461571, -0.510381472288711],
              [30.820905316316026, -0.511301001570066],
              [30.796616395474473, -0.536678714074971],
              [30.79462891872245, -0.546387591783703],
              [30.777799643034534, -0.56842208715671],
              [30.786103878828374, -0.588079414242344],
              [30.786414446185034, -0.603168198058468],
              [30.786095261289855, -0.604033720820978],
              [30.78588663115839, -0.604523564663968],
              [30.785231063121927, -0.604271848269077],
              [30.784852853522693, -0.604699152169122],
              [30.78675641145751, -0.607792743586459],
              [30.788261133575865, -0.60827740050927],
              [30.789376312051015, -0.606948324360927],
              [30.790422190891938, -0.607131052993094],
              [30.79134697952745, -0.608377575881553],
              [30.793256280391912, -0.609379540594161],
              [30.795147721850174, -0.610967591111267],
              [30.79559383779669, -0.611872992854172],
              [30.79747925515266, -0.612923572753435],
              [30.798757254171377, -0.614176189916036],
              [30.801603975780903, -0.612416085074065],
              [30.802044806938593, -0.610957853028966],
              [30.803608835831994, -0.611524257990161],
              [30.80535105005359, -0.611565834144729],
              [30.805837557848534, -0.612967873331499],
              [30.806976880343605, -0.613732125165981],
              [30.810212202365218, -0.612165022085257],
              [30.812635830052304, -0.61430792926481],
              [30.8135482955988, -0.61621163076005],
              [30.817336225250582, -0.614786190861293],
              [30.81811876206763, -0.615579421312569],
              [30.82090446291652, -0.616173791417098],
              [30.821585171204543, -0.616969576322431],
              [30.823548757261566, -0.616935524062549],
              [30.823932548991998, -0.617561174231853],
              [30.823648053439832, -0.618460006758092],
              [30.82973242730081, -0.62102734764675],
              [30.832086767031733, -0.620786290810683],
              [30.83323301643595, -0.619922383132838],
              [30.83398544621624, -0.620057848332933],
              [30.83454409591502, -0.620677288444767],
              [30.83418083877368, -0.623298567999663],
              [30.83548333844347, -0.622114117626162],
              [30.83598039964638, -0.620615013696573],
              [30.836569937017888, -0.62206113002925],
              [30.835939019651146, -0.622560640219101],
              [30.836597496432475, -0.623397003155935],
              [30.836866238229515, -0.622856482884547],
              [30.83789963228461, -0.623111507602691],
              [30.839051279665355, -0.624344119863179],
              [30.839210727035034, -0.623838128881843],
              [30.83974329774281, -0.62414640431968],
              [30.839963265511475, -0.623712710839915],
              [30.8403565093153, -0.624137205218703],
              [30.84077504069438, -0.623804197033274],
              [30.84075276427195, -0.624838304940083],
              [30.84121796762164, -0.624907648060944],
              [30.841804625892653, -0.625756558442403],
              [30.841392238091817, -0.626337882847606],
              [30.841941742042682, -0.626416690032822],
              [30.84186343500103, -0.627023298629328],
              [30.84270911619605, -0.626864375508927],
              [30.84366783419987, -0.627828708565697],
              [30.843435846972675, -0.630107446215664],
              [30.844703749825957, -0.629567338040062],
              [30.845852540564096, -0.630158740509375],
              [30.845970748974022, -0.631240057949637],
              [30.846913397914058, -0.631991681184569],
              [30.845548066480017, -0.634065641517873],
              [30.846037299763527, -0.636442122375793],
              [30.847115377817474, -0.636638211602134],
              [30.847402647367247, -0.634336731971112],
              [30.84827580623015, -0.634510723178255],
              [30.848711757739217, -0.633544837369046],
              [30.853181653320433, -0.629776473869439],
              [30.856434401760243, -0.624439535043245],
              [30.8566141250042, -0.622789593789044],
              [30.858075063235596, -0.620474621540347],
              [30.859948533896624, -0.619851424870072],
              [30.861629589017035, -0.618188220228187],
              [30.862690793116673, -0.616607956204503],
              [30.864950501620598, -0.614542869219506],
              [30.86544681003531, -0.613392211373586],
              [30.867031264821637, -0.612186523830853],
              [30.869352047985124, -0.608466337901592],
              [30.87095649657472, -0.607211112643902],
              [30.87446160064248, -0.606823775442351],
              [30.87514501465613, -0.60619611370378],
              [30.87737415349096, -0.602548998457559],
              [30.87704845491166, -0.599857730250809],
              [30.877524231432208, -0.598482442533595],
              [30.877108994175284, -0.596897499065813],
              [30.877444390966385, -0.593178006037226],
              [30.87555559235168, -0.582671536653619],
              [30.87583108858132, -0.579190825595636],
              [30.87554214008031, -0.569679503940532],
              [30.87593488352252, -0.567853351287641],
              [30.875136641459388, -0.564143934831055],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 148,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KANYARYERU",
        Population: 7485,
        Key: "KIRUHURAKANYARYERU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.73954358589977, -0.150337591174172],
            [30.73821762672631, -0.150077036619698],
            [30.736760425486512, -0.14920579413984],
            [30.736851635030565, -0.147922086151283],
            [30.735455082648834, -0.147769121533949],
            [30.73369417897776, -0.14792176725041],
            [30.73214569722696, -0.149083065823189],
            [30.73033927053057, -0.149113445844931],
            [30.728608593372165, -0.150656777663209],
            [30.72769781755674, -0.150412168153887],
            [30.727348841831784, -0.148792213876433],
            [30.726347133153407, -0.147080501367833],
            [30.72759220262879, -0.143917202092691],
            [30.727425653178468, -0.139424204798539],
            [30.723615576461672, -0.138415215545629],
            [30.724222930120185, -0.136734229949789],
            [30.724056034818503, -0.135817281708755],
            [30.72337295587647, -0.135618549772609],
            [30.72261404205643, -0.134701547590504],
            [30.7196236564768, -0.134074703112888],
            [30.71820149402465, -0.131800976231003],
            [30.71734619905949, -0.131609549342973],
            [30.715112850719233, -0.132039883445878],
            [30.70926828841157, -0.131560981156919],
            [30.70684503442365, -0.130316998298251],
            [30.702236188332595, -0.127015838988897],
            [30.694182567231618, -0.122999474625657],
            [30.690061968073927, -0.122796473804737],
            [30.688889776222595, -0.122188423544796],
            [30.682164327743966, -0.12070970468777],
            [30.680606110950418, -0.121041749125641],
            [30.68003610924142, -0.121542225500113],
            [30.678782300954968, -0.121500268880815],
            [30.677962181321387, -0.122518519523094],
            [30.678293701882048, -0.125268925422256],
            [30.677771819329532, -0.126343584592531],
            [30.677915282077027, -0.128049631131632],
            [30.679877757816403, -0.130106046566556],
            [30.678392259645133, -0.132292448607625],
            [30.677672354268015, -0.132715730942669],
            [30.67912779211492, -0.134665526145448],
            [30.678618989931238, -0.135603444643425],
            [30.678796115247398, -0.136328515088458],
            [30.677136725695018, -0.139302245384779],
            [30.677441089286322, -0.140109022638065],
            [30.676892206969615, -0.141238568956602],
            [30.678241000419266, -0.143314298785431],
            [30.678366666642653, -0.144160207287256],
            [30.677703482689235, -0.145558457507487],
            [30.678694586755682, -0.145850197029075],
            [30.679966812302094, -0.147187184040904],
            [30.68087082200678, -0.147377435809739],
            [30.680435465182427, -0.149948372260896],
            [30.680703825195458, -0.150490288076613],
            [30.67899461956898, -0.15194597148355],
            [30.679680400643417, -0.153148714367968],
            [30.681991472120345, -0.152888390713554],
            [30.68311255971346, -0.153154116816812],
            [30.684590247033338, -0.15428286118031],
            [30.68514451924173, -0.155888405222886],
            [30.683692364737187, -0.158759701100608],
            [30.683652229806935, -0.159887562121985],
            [30.682223187157984, -0.160468598262016],
            [30.680567207610416, -0.16289336164678],
            [30.682396848570402, -0.163650381439428],
            [30.68285049329733, -0.165778074618388],
            [30.680467638344336, -0.16537797384807],
            [30.680075949524255, -0.167615071293885],
            [30.679119108101077, -0.168799081668607],
            [30.67909409002041, -0.170473341780507],
            [30.67856024370492, -0.171960124192358],
            [30.676202054693036, -0.172946902892461],
            [30.675432464395858, -0.173908883662104],
            [30.67705813837901, -0.175171026051302],
            [30.676415850137374, -0.176789977491215],
            [30.6765476644306, -0.177852258075157],
            [30.675954026249805, -0.178715369594732],
            [30.676673463604665, -0.180270886504266],
            [30.67595365165235, -0.181238334911582],
            [30.67599077273484, -0.182724867630364],
            [30.675315081537665, -0.18459145389494],
            [30.674106507917358, -0.186681268331621],
            [30.673854914959115, -0.192274471198796],
            [30.675615019129577, -0.19439011381945],
            [30.67483898970847, -0.19591322729477],
            [30.675540891948952, -0.197379995936532],
            [30.674669899822515, -0.197699919142048],
            [30.67386392056985, -0.198699739867769],
            [30.673001522625707, -0.201120841128114],
            [30.671858330188414, -0.201290478838699],
            [30.67131400143189, -0.205892233322197],
            [30.671988698194014, -0.207284629131121],
            [30.671822516154666, -0.208832839264393],
            [30.67279570691602, -0.211784656452956],
            [30.672385835296293, -0.21520407882613],
            [30.67150855586117, -0.217304860392514],
            [30.672008988441355, -0.219659376142744],
            [30.6720294224191, -0.224031662145519],
            [30.67259447800418, -0.225451427750022],
            [30.673711772011856, -0.226476338229784],
            [30.672383744018315, -0.22873721826381],
            [30.672294720075328, -0.231933920133816],
            [30.673235000157952, -0.232880838162848],
            [30.673975808433426, -0.235788081008498],
            [30.67305158932977, -0.237408927998732],
            [30.67177253748552, -0.23740275213417],
            [30.66961296777954, -0.238641344848233],
            [30.669263702797085, -0.239709654296897],
            [30.669249106970344, -0.243462996885644],
            [30.6695002938901, -0.244376776471554],
            [30.67043570690052, -0.245206328929254],
            [30.669388307211843, -0.246007422969691],
            [30.669220512696537, -0.247356911784183],
            [30.66820111439358, -0.247722227149643],
            [30.66670679296962, -0.249043365227125],
            [30.66620388912408, -0.250294388536852],
            [30.663103803078606, -0.251432488295592],
            [30.662329400506444, -0.254241210770244],
            [30.658313011311602, -0.255456374088912],
            [30.655038461658133, -0.258253778825203],
            [30.654282014611894, -0.257037756092806],
            [30.65326351731916, -0.256524846572805],
            [30.65026593084423, -0.256670790800177],
            [30.64828683357716, -0.257388235659149],
            [30.648286703321443, -0.258106044291762],
            [30.649174132820942, -0.259175596317675],
            [30.650396346460546, -0.259673893884401],
            [30.649187774636857, -0.2641123631479],
            [30.647907298064577, -0.263936332052132],
            [30.646903137883783, -0.264610002958646],
            [30.644342139823426, -0.264536272721123],
            [30.644123800700374, -0.26491710762419],
            [30.64144652381132, -0.264169498087764],
            [30.639540312253153, -0.264227732553588],
            [30.63775662910311, -0.265762712377768],
            [30.636068550953794, -0.26604257499913],
            [30.63563890022814, -0.266474951934528],
            [30.63494924022833, -0.266103270813445],
            [30.634223174204994, -0.266291951817648],
            [30.633539594003008, -0.265761907495928],
            [30.632589647149615, -0.266066273199128],
            [30.630877607338423, -0.265103575221313],
            [30.63069032746631, -0.263629529193069],
            [30.63024268797708, -0.263209167896877],
            [30.62722228249728, -0.263710495288917],
            [30.626807887860096, -0.262844647073722],
            [30.626075878582824, -0.262427163024784],
            [30.62386424252301, -0.262813437234171],
            [30.619568392833134, -0.262817154423721],
            [30.6191547366111, -0.262916630116405],
            [30.618714540562316, -0.26462308318798],
            [30.61746818829274, -0.265825094313098],
            [30.618441686277936, -0.267452386506929],
            [30.618418023755023, -0.27085122728987],
            [30.61618623039854, -0.271971681575804],
            [30.615319693915907, -0.27442120499935],
            [30.612209416483527, -0.273823983985928],
            [30.611734584990653, -0.274158348382894],
            [30.610452576790784, -0.276860881602425],
            [30.611141245948858, -0.277819199408724],
            [30.6118772455426, -0.277819347629003],
            [30.611865326695412, -0.279193339657885],
            [30.61257769610561, -0.280196861755824],
            [30.612221608418565, -0.280965141181903],
            [30.612601509545467, -0.281778767863029],
            [30.612623438319883, -0.283649936718903],
            [30.611283842720418, -0.285882400492818],
            [30.611100491181045, -0.28988682837618],
            [30.61101096328318, -0.29064612142283],
            [30.61217435523798, -0.293114134284209],
            [30.612554362366104, -0.296052031097745],
            [30.61386024778619, -0.297399190412289],
            [30.61882247224541, -0.29926239322512],
            [30.621790232856277, -0.299787325571587],
            [30.62346421823543, -0.302671292797056],
            [30.624817574228402, -0.303819608412594],
            [30.63401797653621, -0.307762880565079],
            [30.638054292160696, -0.310222546130198],
            [30.64127151941758, -0.314688838629848],
            [30.643574596786806, -0.324443131444032],
            [30.644417492306093, -0.325817354734589],
            [30.647053053229964, -0.326423627780341],
            [30.653036231874175, -0.326397905837896],
            [30.660076237127676, -0.329834649249087],
            [30.66249805470947, -0.330242006912583],
            [30.66202316572442, -0.331887131602563],
            [30.66247425204938, -0.332438663664095],
            [30.662486141252163, -0.33439125541724],
            [30.663127216768153, -0.335467141165732],
            [30.66374451657353, -0.338576970437101],
            [30.666249378911765, -0.340837520454876],
            [30.67247024998354, -0.344048163206956],
            [30.674749566015176, -0.346082683765479],
            [30.675782371673744, -0.347719150656061],
            [30.676708428730485, -0.350991806010705],
            [30.679284554420203, -0.357293237097494],
            [30.679414958358418, -0.363196306775674],
            [30.67894008823797, -0.365157838287971],
            [30.67961666158073, -0.368367167380336],
            [30.679509677620302, -0.373528908176619],
            [30.68038802874553, -0.37819371864744],
            [30.680052940974903, -0.384586224837009],
            [30.68129153090213, -0.385318431386836],
            [30.68878025901306, -0.386372401708537],
            [30.691097186607333, -0.387089837443513],
            [30.694566075094404, -0.388393909845647],
            [30.696482448395077, -0.389830289148469],
            [30.69697400202698, -0.388521799154972],
            [30.697045749570393, -0.386768061059755],
            [30.69844293526441, -0.386226040729296],
            [30.699811979435495, -0.384418410744393],
            [30.700325153719643, -0.384156388849426],
            [30.701265927875674, -0.384644802656866],
            [30.70166524788409, -0.384102509109602],
            [30.701665855145233, -0.381806345260626],
            [30.701067233111235, -0.38100162441124],
            [30.702222628263375, -0.378479766540316],
            [30.70205191691836, -0.377241239479748],
            [30.700199432699023, -0.374546827721295],
            [30.700227702681016, -0.373866169883123],
            [30.701226375053704, -0.372250933528457],
            [30.702110216681987, -0.372079403843586],
            [30.704006586297897, -0.370552131948368],
            [30.70437755817088, -0.369467424488648],
            [30.7059745606251, -0.367741188391908],
            [30.70839820987178, -0.366765484425327],
            [30.711863391909993, -0.362345771065544],
            [30.71269148678667, -0.357265451847648],
            [30.71219316614573, -0.354743144407823],
            [30.712279311886547, -0.351868418575685],
            [30.713619736631, -0.350467532982522],
            [30.71537385083515, -0.347050801097832],
            [30.715431270249788, -0.345730960215785],
            [30.716286748471287, -0.345071237780838],
            [30.716428154076787, -0.341865946540805],
            [30.717029052441696, -0.340596558826988],
            [30.718398044510508, -0.338788858649459],
            [30.719766711389177, -0.33777668517198],
            [30.72157999492614, -0.334423216930645],
            [30.726511963228287, -0.332134654630078],
            [30.731989031939726, -0.330940184794071],
            [30.7379240770544, -0.33025692947821],
            [30.74035041406039, -0.328978148527193],
            [30.74227347621669, -0.327300495891057],
            [30.744625321326033, -0.327051803155972],
            [30.746383158148724, -0.326229766401526],
            [30.748462648437012, -0.326197001780882],
            [30.751370468960555, -0.327096854730041],
            [30.75244603352833, -0.324513076743672],
            [30.7542713652699, -0.321873699546933],
            [30.75449992811922, -0.319957195510182],
            [30.756824198542635, -0.317345038368509],
            [30.75767988517326, -0.315736037417852],
            [30.76023308316199, -0.30870316680407],
            [30.75991607308811, -0.306198913645733],
            [30.753169546539617, -0.302979142043379],
            [30.749736737987636, -0.300655069155515],
            [30.74849572081252, -0.299090838904169],
            [30.747448786451137, -0.296667822478937],
            [30.745070310785195, -0.288476834495872],
            [30.74664026227126, -0.287690638897185],
            [30.74669748315824, -0.286370765304024],
            [30.74883646168125, -0.283044348468708],
            [30.7490220913482, -0.281588893256075],
            [30.749877563281448, -0.280874873258933],
            [30.74831011809502, -0.277312688482741],
            [30.74845288913975, -0.276164595652844],
            [30.751062194104524, -0.273452989394538],
            [30.7514616308939, -0.272078933822059],
            [30.751034413704346, -0.269610844646695],
            [30.754670949383005, -0.2620628191451],
            [30.754943179338298, -0.258708896649339],
            [30.75635945692703, -0.256421933909985],
            [30.75628204730235, -0.255364197975161],
            [30.75670631622116, -0.254602669513997],
            [30.756212986619953, -0.253305196086739],
            [30.755619873055302, -0.248787830177935],
            [30.756214179582635, -0.246197146305867],
            [30.75859058912345, -0.240683814763209],
            [30.76063645547065, -0.238890523666337],
            [30.762748192582684, -0.237827975000351],
            [30.76429190158434, -0.235562704593475],
            [30.760860467454744, -0.232764015021294],
            [30.759072505628996, -0.230774848643274],
            [30.756505088207614, -0.225277904223856],
            [30.75616583405068, -0.220459338867521],
            [30.757667409370605, -0.216870536155009],
            [30.757775922263654, -0.211618095563201],
            [30.756734288860777, -0.209375935508766],
            [30.754720817559374, -0.207431972534029],
            [30.754861992297858, -0.203192065701488],
            [30.7540590008418, -0.201067472545797],
            [30.750374017223223, -0.195750512804549],
            [30.75001311905782, -0.193495979925564],
            [30.750538601159697, -0.19158049868757],
            [30.75037513562574, -0.189780884000552],
            [30.747643140556125, -0.185790638348067],
            [30.746669521298386, -0.181676415027497],
            [30.743248868748793, -0.176150672892058],
            [30.74300244469668, -0.175095013662003],
            [30.745315119666397, -0.169940182333849],
            [30.745378705117183, -0.168723031524858],
            [30.74378225063525, -0.166128849095775],
            [30.74454746883195, -0.163130399141424],
            [30.74371583099979, -0.161107625797826],
            [30.741552553946658, -0.16036588080344],
            [30.74019139608543, -0.15816278455531],
            [30.737454571672853, -0.156131763321088],
            [30.738381311449196, -0.15480076680375],
            [30.738417114703147, -0.15321134917731],
            [30.73954358589977, -0.150337591174172],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 149,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KASHONGI",
        Population: 25032,
        Key: "KIRUHURAKASHONGI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.011943279645326, -0.297170486911092],
            [31.01344164169147, -0.296881415632018],
            [31.0140129136183, -0.296212460878119],
            [31.017477182069864, -0.28951301092724],
            [31.02406815005555, -0.283627856399776],
            [31.02600696686527, -0.282470798212198],
            [31.02717224977372, -0.282226922946802],
            [31.02876690043855, -0.28031928898633],
            [31.03289381654933, -0.278963690774692],
            [31.039695186144222, -0.278458465371822],
            [31.04284743107007, -0.27647882627816],
            [31.046487011139217, -0.274806645202653],
            [31.04762927561685, -0.2732063291973],
            [31.05101508161823, -0.259472008579273],
            [31.052694089478123, -0.255502758137491],
            [31.053405161721045, -0.252428585450628],
            [31.055953429755505, -0.248812129377257],
            [31.05750119914227, -0.241551491609525],
            [31.057668229191247, -0.239517036523107],
            [31.057340905559595, -0.238079323245832],
            [31.05706902504897, -0.237663364633227],
            [31.053077978226575, -0.238141994568737],
            [31.050931004697528, -0.238828918637798],
            [31.048962992641073, -0.240447205992829],
            [31.04667285011362, -0.241061703917771],
            [31.044329229978995, -0.240627357942236],
            [31.03899464035979, -0.238561742227916],
            [31.037665414911984, -0.237330219187313],
            [31.028765356234572, -0.2325969791632],
            [31.023465997642496, -0.224541822266379],
            [31.0229665909384, -0.220816649207325],
            [31.02486765065842, -0.212963815622085],
            [31.02056794809429, -0.208533396833759],
            [31.019651807539994, -0.20541036842965],
            [31.023475402105213, -0.19858840783214],
            [31.026105781546523, -0.191382346713825],
            [31.023243524472498, -0.191418138988298],
            [31.020059558237346, -0.190016283532849],
            [31.017483217850263, -0.189907503539736],
            [31.012456020941507, -0.19195944098613],
            [31.009521758507574, -0.194798241252006],
            [31.007625470638338, -0.195629879646972],
            [31.003832895798194, -0.19591874291837],
            [31.002437699872544, -0.194905898326328],
            [31.000899194811314, -0.194516957902021],
            [30.996949976243503, -0.194679215164361],
            [30.995330061359642, -0.192933967435009],
            [30.99512513318545, -0.191252161791999],
            [30.99457182666598, -0.190474491870445],
            [30.994293208790715, -0.187192290227363],
            [30.994875850694108, -0.186484239190099],
            [30.99242008128615, -0.176212125451804],
            [30.98882050409491, -0.16986906572042],
            [30.985620676306777, -0.16735175914108],
            [30.982120756416535, -0.165438565859793],
            [30.98100881007975, -0.163311181663838],
            [30.977995945058453, -0.162682082337973],
            [30.974696460867648, -0.160356367681838],
            [30.97113323759765, -0.155240130302761],
            [30.968625955198032, -0.149393241360522],
            [30.967536607778857, -0.143554422200034],
            [30.967524114908187, -0.142134877358746],
            [30.96894906752762, -0.135254293824022],
            [30.969215053293365, -0.129051794530058],
            [30.96769886597705, -0.125588727592035],
            [30.96587135582092, -0.123210653688467],
            [30.96507143390818, -0.117396812208778],
            [30.96463869836783, -0.116429370882675],
            [30.9612012392376, -0.111139777528889],
            [30.95884077479307, -0.10896964853703],
            [30.95685212933285, -0.106455984456167],
            [30.956412095879145, -0.10179050729175],
            [30.95517438540258, -0.097549904120906],
            [30.955256637844947, -0.093417940725267],
            [30.95766903479435, -0.08398774720479],
            [30.957591696136603, -0.08064236794583],
            [30.956005888487436, -0.07736920481013],
            [30.951174776737215, -0.069982111914604],
            [30.94992724138639, -0.068689100299312],
            [30.947072844571103, -0.067097679296963],
            [30.946112489836835, -0.066012613980492],
            [30.944675045245067, -0.062088592914141],
            [30.944344211895594, -0.059629315175877],
            [30.9432301608061, -0.057323664436022],
            [30.94062673082331, -0.060968225517587],
            [30.93255929812487, -0.067213408277204],
            [30.927420794562526, -0.069912211359482],
            [30.91502151668077, -0.073285312548596],
            [30.914797920616664, -0.077558623397812],
            [30.91658472631065, -0.085992952697736],
            [30.916919348753982, -0.095101928362802],
            [30.90988175008714, -0.099599744276014],
            [30.905189877205952, -0.104322559334152],
            [30.8962534646073, -0.108257946057228],
            [30.893349099004336, -0.10882002361692],
            [30.891617034847144, -0.108054281277188],
            [30.891057131998547, -0.109299568599663],
            [30.890558988325733, -0.109417121025316],
            [30.889244500638473, -0.108603305444724],
            [30.887985174899544, -0.108657484538754],
            [30.88637915515649, -0.107111332165529],
            [30.88474969567274, -0.106975603251158],
            [30.877901444799793, -0.102508808034495],
            [30.875539998496663, -0.101541295261304],
            [30.873410149551887, -0.101233693724993],
            [30.869611117621474, -0.101676463651243],
            [30.866645274015415, -0.10093493339108],
            [30.86484162490985, -0.101233202347315],
            [30.86026260378457, -0.099478893204905],
            [30.8587692947619, -0.099939910605545],
            [30.85781722069791, -0.099786144415306],
            [30.854651642078313, -0.097923547039902],
            [30.853702656422286, -0.098122369074153],
            [30.852359253762653, -0.099415169509556],
            [30.85178924486711, -0.099469348619396],
            [30.85033102583606, -0.098510889862537],
            [30.848844173903665, -0.098393266429505],
            [30.84695111457956, -0.100653368579066],
            [30.843236019432673, -0.103853611681914],
            [30.842158883711473, -0.105688838891211],
            [30.835751930221853, -0.110886916624109],
            [30.816993142473915, -0.115559621112028],
            [30.813522136657724, -0.115450840742054],
            [30.812382539278175, -0.118289581202659],
            [30.810533553996866, -0.120160880177408],
            [30.808355419707237, -0.121137094300307],
            [30.807802955807503, -0.123180195480821],
            [30.803459741545968, -0.127899076560505],
            [30.7995825292364, -0.130240304829148],
            [30.799098140567203, -0.131903727057763],
            [30.800147765382828, -0.133702879753889],
            [30.799475151813844, -0.135583300877887],
            [30.799546736762213, -0.138313540026697],
            [30.79866905488186, -0.139850426287272],
            [30.79718234308664, -0.141043638724651],
            [30.79606534372638, -0.143764753079518],
            [30.792514752565893, -0.146747781751738],
            [30.789906269559634, -0.147407479864986],
            [30.763393756980133, -0.147314491065897],
            [30.75470999645347, -0.142260079665884],
            [30.75364703614743, -0.142983151160835],
            [30.75237030554988, -0.145089483640441],
            [30.749824845649012, -0.146590366887025],
            [30.748809046895396, -0.146678303580508],
            [30.74805530467648, -0.147828283483419],
            [30.747024347750777, -0.148282352495782],
            [30.74686644009349, -0.149460194367562],
            [30.74583716750894, -0.151444130307265],
            [30.744143141614146, -0.153316900845559],
            [30.74285419931861, -0.152519367698738],
            [30.741671090241656, -0.150829347923584],
            [30.739529309873266, -0.150359138090401],
            [30.738417083262114, -0.15321134917731],
            [30.73838129078793, -0.154800800041288],
            [30.737454622876818, -0.15613177499914],
            [30.74019139608543, -0.158162802521551],
            [30.74155248477638, -0.160365912244348],
            [30.74371588040713, -0.161107650950579],
            [30.744547523629176, -0.163130396446477],
            [30.74378227129652, -0.166128861672115],
            [30.74537874643968, -0.168723017151867],
            [30.745315161887227, -0.169940158977727],
            [30.743002421340492, -0.175094991204214],
            [30.743248896596572, -0.176150646841032],
            [30.746669513213543, -0.181676381790004],
            [30.747643202539894, -0.185790644636247],
            [30.750375203897722, -0.189780898373493],
            [30.750538584990018, -0.191580466348388],
            [30.750013070548807, -0.193495972739061],
            [30.750374081003617, -0.195750519991017],
            [30.754058998146846, -0.201067461766098],
            [30.75486200756921, -0.203192034260654],
            [30.75472080408465, -0.207431985110372],
            [30.756734293352363, -0.209375913051022],
            [30.75777591777207, -0.211618106342926],
            [30.757667418353737, -0.216870547833021],
            [30.756533435444723, -0.219003890164192],
            [30.75615291537859, -0.221688851149502],
            [30.756505082817732, -0.225277873681391],
            [30.758278272746946, -0.229644704374731],
            [30.7624174005557, -0.234147472854945],
            [30.767954251251016, -0.238144170269547],
            [30.771739247005115, -0.24157114208172],
            [30.777863651591776, -0.242069352284065],
            [30.781275705467458, -0.24360679071085],
            [30.784361418468407, -0.245876490231713],
            [30.78656874800477, -0.24824549359645],
            [30.793945039381494, -0.249467190859203],
            [30.799732154426746, -0.251800472416795],
            [30.80172599304762, -0.254504515164862],
            [30.80768547323634, -0.256795757778042],
            [30.809029437343018, -0.258291227412298],
            [30.80996901853634, -0.261310307382097],
            [30.811415306143772, -0.263571933419857],
            [30.812563465366285, -0.264777557632366],
            [30.813369843470962, -0.265023679016614],
            [30.81402940362056, -0.266130770642634],
            [30.815177844015768, -0.266647577517798],
            [30.82231173040296, -0.274572384336783],
            [30.828012663774803, -0.283830606368379],
            [30.82876093255871, -0.284440751674673],
            [30.829101730919618, -0.286595768910478],
            [30.83177351640731, -0.290871415096799],
            [30.832680253397218, -0.291151222325592],
            [30.83485459769466, -0.289644598960969],
            [30.837403567313345, -0.288613865364868],
            [30.840677084802554, -0.288091374981624],
            [30.84230626311361, -0.281814755734645],
            [30.843085832795275, -0.281030212561876],
            [30.84481817722683, -0.277050372709587],
            [30.847674679693153, -0.275134176166549],
            [30.85106301265544, -0.274176428567611],
            [30.859527669592744, -0.273924833097467],
            [30.86378596431383, -0.272908905774284],
            [30.865981643599273, -0.271176931208669],
            [30.86633788130497, -0.269803085580839],
            [30.866931330839538, -0.269295472994167],
            [30.871084916134482, -0.269206555135894],
            [30.87601007071518, -0.268281510774857],
            [30.87781989483999, -0.267594868537635],
            [30.88532588048586, -0.268462364810408],
            [30.890191661816164, -0.267955453744555],
            [30.891081555394493, -0.268523070494158],
            [30.892278419475073, -0.270692477887296],
            [30.89376906139966, -0.272213070543767],
            [30.898404789575586, -0.278804874107082],
            [30.89955196604118, -0.281037581353523],
            [30.901646724994336, -0.282824154314382],
            [30.90335268231275, -0.284951310948381],
            [30.905383857611785, -0.285892354600574],
            [30.911086054014913, -0.286029135772012],
            [30.915987486783887, -0.287653030503536],
            [30.919481511929245, -0.287735492112112],
            [30.921675506873523, -0.286999655385486],
            [30.924194719798425, -0.28524136527797],
            [30.925454325811714, -0.284832566813845],
            [30.932158144654966, -0.284302075960741],
            [30.939592405215286, -0.28790273115509],
            [30.94146132231613, -0.288025756574355],
            [30.94247712017142, -0.287698788310684],
            [30.943827540470043, -0.286510430025787],
            [30.94865135340858, -0.286085981353014],
            [30.95348807962933, -0.284796634646433],
            [30.955763624533414, -0.283079189201813],
            [30.95836396610825, -0.282343421347124],
            [30.967383894180553, -0.280995193060031],
            [30.969781132059538, -0.28001393550894],
            [30.971203418479224, -0.278909792496371],
            [30.974896336018364, -0.282968374380359],
            [30.980151620567646, -0.287354485465645],
            [30.981552010552278, -0.289380089809094],
            [30.98213409011029, -0.291071006501045],
            [30.98301977328489, -0.291803545290919],
            [30.99383127800363, -0.291760244360756],
            [31.00061524273989, -0.292249749764802],
            [31.0028978061813, -0.29270220012561],
            [31.00662974473976, -0.295108039161652],
            [31.011943279645326, -0.297170486911092],
          ],
          [
            [30.806032151803684, -0.245207812932502],
            [30.804281279619392, -0.245065698060349],
            [30.80345651389916, -0.242479555308148],
            [30.803083572020743, -0.24231624664424],
            [30.803742570723287, -0.238339762358739],
            [30.802512721403783, -0.229322787589931],
            [30.800373326960784, -0.21931036794428],
            [30.799757139269744, -0.218422095119382],
            [30.798892650945966, -0.212728711066497],
            [30.797604971681714, -0.209770466654074],
            [30.796499342298016, -0.200268107101263],
            [30.79658019067359, -0.198302843200998],
            [30.79754644105107, -0.196195814967554],
            [30.799217167342352, -0.193906598393686],
            [30.80288018805053, -0.191516321605678],
            [30.806523137700324, -0.189470419853825],
            [30.81896859347924, -0.184523606290149],
            [30.818682396517936, -0.180392569893291],
            [30.819481054501058, -0.173966557932521],
            [30.823015083422654, -0.169491704887321],
            [30.82439666358353, -0.170285447393173],
            [30.82878353057799, -0.174783880918676],
            [30.832848687512993, -0.177742482679366],
            [30.83671228585445, -0.181349411040433],
            [30.838966355633357, -0.18179547893294],
            [30.841381419680843, -0.181512089732862],
            [30.842669519356626, -0.181795899342399],
            [30.843796484626658, -0.182646978701256],
            [30.84476231369426, -0.184349067229672],
            [30.851765523055388, -0.189334199170124],
            [30.86061477122371, -0.197515910231966],
            [30.862305288299012, -0.19824550587638],
            [30.871080144283702, -0.199989139686503],
            [30.872770661359006, -0.200759299297439],
            [30.873293789874825, -0.201731930696891],
            [30.874441246614776, -0.202257160701398],
            [30.87590381618673, -0.205745970571353],
            [30.875561614657357, -0.208270571283143],
            [30.873737333046357, -0.21171299024734],
            [30.87253134477743, -0.212441182086133],
            [30.872084713197943, -0.21324039690017],
            [30.87204414887297, -0.214699236375724],
            [30.868500716386997, -0.224059613011877],
            [30.867534466009513, -0.224910479938447],
            [30.864314145853125, -0.22584205352873],
            [30.861053261371772, -0.229529187346483],
            [30.855461529002486, -0.230802468919259],
            [30.855135469300457, -0.23426944598348],
            [30.85352523915367, -0.235484898570847],
            [30.850465352717137, -0.240306634362719],
            [30.849599881636426, -0.240853619107156],
            [30.848110502743125, -0.241420675608187],
            [30.84662112474816, -0.241116515037901],
            [30.843924494554642, -0.239637045006045],
            [30.841931777929545, -0.24186540868546],
            [30.840422187840684, -0.242452747125183],
            [30.833841045627583, -0.242431482396131],
            [30.82838686778618, -0.243605737894867],
            [30.823802091154857, -0.244072156034514],
            [30.806032151803684, -0.245207812932502],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 150,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KENSHUNGA",
        Population: 25377,
        Key: "KIRUHURAKENSHUNGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.83671232897358, -0.181349432599888],
            [30.83284862103767, -0.177742486272603],
            [30.828783588070173, -0.17478389169839],
            [30.824396724668965, -0.170285434816836],
            [30.823015016947306, -0.16949167075148],
            [30.81948101228023, -0.173966588475082],
            [30.818682384839843, -0.180392582469655],
            [30.818968586292726, -0.184523584730698],
            [30.814070525799323, -0.186209352573789],
            [30.80495325628284, -0.19026038499418],
            [30.799217108053544, -0.193906586715657],
            [30.79754642488139, -0.196195828442198],
            [30.796580143062876, -0.198302811760155],
            [30.79649938451885, -0.200268085541831],
            [30.797604986953065, -0.209770494501664],
            [30.7988925880639, -0.212728737117466],
            [30.799757166219194, -0.218422119373694],
            [30.800373302706262, -0.219310372435832],
            [30.802512720505455, -0.229322804657806],
            [30.803742608452527, -0.238339728223045],
            [30.803083641191023, -0.242316244847628],
            [30.803456568696383, -0.242479549918314],
            [30.80428129219579, -0.245065696263738],
            [30.823802137867236, -0.244072171305726],
            [30.828386829158635, -0.243605745979635],
            [30.833841075271987, -0.242431471616463],
            [30.840422196823816, -0.242452780362545],
            [30.841931725827244, -0.241865442821146],
            [30.84392452958893, -0.239637014463611],
            [30.846621166968955, -0.241116515037901],
            [30.84811043626781, -0.241420670218352],
            [30.85046534193734, -0.240306664006862],
            [30.853525224780615, -0.235484920130229],
            [30.855135486368432, -0.234269480119185],
            [30.855461537985658, -0.230802478800647],
            [30.86105324340546, -0.229529179261707],
            [30.864314205141934, -0.225842057121958],
            [30.86753451901011, -0.224910492514777],
            [30.86850069662406, -0.224059644452668],
            [30.87204420995841, -0.214699258833461],
            [30.872084660197345, -0.213240422052848],
            [30.87253136004878, -0.212441200052318],
            [30.873737274655845, -0.211713002823647],
            [30.875561547283706, -0.208270577571314],
            [30.87590384403451, -0.205745994825685],
            [30.874441176546203, -0.202257191243909],
            [30.87329374945062, -0.201731941476622],
            [30.872770593087026, -0.200759311873788],
            [30.871080093079737, -0.199989149567911],
            [30.862305335909728, -0.198245522045931],
            [30.860614840393986, -0.197515890469147],
            [30.85176546556321, -0.189334209949864],
            [30.84476227057514, -0.184349061839817],
            [30.843796433422686, -0.182646995769148],
            [30.842669490610557, -0.181795886766036],
            [30.841381475376394, -0.181512076258206],
            [30.838966355633357, -0.181795447492067],
            [30.83671232897358, -0.181349432599888],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 152,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KIRUHURA TOWN COUNCIL",
        Population: 5589,
        Key: "KIRUHURAKIRUHURA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.09034734381957, -0.323687423222713],
            [31.089681376885373, -0.322014296245754],
            [31.08965987570905, -0.318388341853359],
            [31.08217985676478, -0.304760292047233],
            [31.078947064398985, -0.284270029855791],
            [31.07432741247338, -0.275064298822693],
            [31.07386519512372, -0.272885058468937],
            [31.074223156696473, -0.270588405629413],
            [31.073249527557234, -0.268400031396943],
            [31.07379733189559, -0.267134216577041],
            [31.07347768167308, -0.265018289182588],
            [31.072146554491816, -0.264113856132047],
            [31.07195663357277, -0.26348991450871],
            [31.072243974987742, -0.260270942212223],
            [31.071377222909476, -0.258471423134401],
            [31.071426098447454, -0.256364593222882],
            [31.071950370518604, -0.254691866849157],
            [31.07118495109932, -0.252820023429121],
            [31.07158697863, -0.252159995377897],
            [31.0706581502706, -0.250649821549011],
            [31.07067042934223, -0.249184992276147],
            [31.069636684045864, -0.247231725528882],
            [31.069278565267975, -0.243045150195431],
            [31.06843302510847, -0.242113686442528],
            [31.06943671996193, -0.238099100384342],
            [31.06990973595964, -0.237638011699068],
            [31.069873505107598, -0.235693947346645],
            [31.07045192582747, -0.234111639357438],
            [31.071128429999945, -0.23358728182219],
            [31.072153749098934, -0.229409938745538],
            [31.0727861657539, -0.229057368089701],
            [31.07350046564366, -0.227086270665325],
            [31.071292631254096, -0.227203522346361],
            [31.070661039252567, -0.227664593406474],
            [31.069524360499386, -0.227212334749997],
            [31.067962328560835, -0.22759189242596],
            [31.066962307816905, -0.227257206143883],
            [31.06632990733159, -0.227582637156613],
            [31.062677599931497, -0.230602226184197],
            [31.061307369984217, -0.232437581615096],
            [31.06069521393219, -0.232419415134606],
            [31.058023441020886, -0.234571074375093],
            [31.0581409613213, -0.235185961528852],
            [31.05748856882938, -0.235900193399417],
            [31.057634604351854, -0.237355998818163],
            [31.057068997201192, -0.237663349362007],
            [31.05764388394874, -0.239236753820885],
            [31.057501258431078, -0.241551517660443],
            [31.05595340999257, -0.248812105122997],
            [31.05340518058565, -0.252428566586205],
            [31.052694050850548, -0.255502768018861],
            [31.051015014244587, -0.25947199151147],
            [31.04762932412586, -0.273206356146474],
            [31.0464869976645, -0.27480661555859],
            [31.042847487663924, -0.276478795735815],
            [31.03969518794085, -0.2784584779481],
            [31.032893808464493, -0.27896369706283],
            [31.02876684564129, -0.280319303359211],
            [31.02717230546928, -0.282226888811226],
            [31.02600691206805, -0.282470823364711],
            [31.0240681132246, -0.283627856399776],
            [31.01747722249407, -0.289513004639107],
            [31.01401285343116, -0.296212433929032],
            [31.01268035272584, -0.297098296570682],
            [31.01194330300152, -0.297170503080556],
            [31.007889850216333, -0.295659785161642],
            [31.005132222618407, -0.294366308248922],
            [31.00289782863919, -0.292702213600191],
            [31.00061522746854, -0.292249718324179],
            [30.99383129327498, -0.291760257835338],
            [30.983019738250604, -0.291803539002788],
            [30.98454131815356, -0.296035329842917],
            [30.987721391988583, -0.3015242382771],
            [30.992413293615844, -0.307682536404835],
            [30.99491379104012, -0.312050181153865],
            [30.995560818793205, -0.314563910908534],
            [30.994633677469928, -0.315051990574374],
            [30.986615637739057, -0.316207787702185],
            [30.983062506142947, -0.315655556776615],
            [30.963784686196895, -0.316248549933989],
            [30.954732323552953, -0.318710400871446],
            [30.952168498494398, -0.32098690204331],
            [30.950187957634697, -0.324441325859248],
            [30.951111331423643, -0.327231945671678],
            [30.958105083321463, -0.33587046343369],
            [30.960743915909593, -0.340654642866815],
            [30.959950708903623, -0.346634007510887],
            [30.961546860653264, -0.350274880295611],
            [30.96501230140628, -0.354755633445847],
            [30.96698442774674, -0.359515993033097],
            [30.966723556988242, -0.360715284927392],
            [30.96694120710349, -0.364622175662128],
            [30.967691327315176, -0.368473808674615],
            [30.96746375261269, -0.372282424204377],
            [30.967874415648165, -0.373395164448415],
            [30.96886605780547, -0.374365391671722],
            [30.969616512190473, -0.376676446748519],
            [30.971041989426016, -0.378611444110582],
            [30.970114873255586, -0.380154239839784],
            [30.969508237350958, -0.383060703221227],
            [30.984431046359155, -0.382992457039139],
            [30.987739308886926, -0.41004304035337],
            [30.987916989361924, -0.422249419006417],
            [30.99105326224201, -0.456889148576591],
            [30.990942682325475, -0.46988209870857],
            [30.991667304756145, -0.47895117800965],
            [30.992880454394538, -0.48462586589576],
            [30.99244578927295, -0.487910962033316],
            [30.992756159000248, -0.48969572288926],
            [30.995676940416708, -0.488500232772413],
            [30.995745436957122, -0.489365409144526],
            [30.994128705702643, -0.492963971063875],
            [30.995193799507454, -0.494833028027864],
            [30.996637182861566, -0.496183108579649],
            [30.998560903482936, -0.500613298095543],
            [31.001035231186368, -0.503071104026949],
            [31.005503407392137, -0.505425711893981],
            [31.01278254147929, -0.506952554726957],
            [31.015418611747947, -0.50932341645585],
            [31.015417308292456, -0.513589509256855],
            [31.016075163439627, -0.517950611034761],
            [31.018240342226218, -0.52041614720984],
            [31.020196470469802, -0.521598522884704],
            [31.026304521226706, -0.522724927540092],
            [31.028086476916464, -0.523921664445063],
            [31.02945244435772, -0.525477124660075],
            [31.032599452105455, -0.531159972294264],
            [31.0334881760773, -0.538875618008536],
            [31.03235662760268, -0.547368125623179],
            [31.030869530430206, -0.552929865560836],
            [31.029442576364335, -0.556218878527037],
            [31.0294412881802, -0.560106453478603],
            [31.02997523331037, -0.56237937045604],
            [31.028607750411247, -0.56542915853948],
            [31.02890430404945, -0.56692448044038],
            [31.027952185069704, -0.571469624584402],
            [31.026941275846195, -0.574160671106207],
            [31.02491753410614, -0.585045151359792],
            [31.025390501594803, -0.591684085175144],
            [31.025092346260436, -0.594794031507415],
            [31.02526971142675, -0.59724625103773],
            [31.02582921003349, -0.597731824232559],
            [31.024886905148204, -0.599848334387894],
            [31.02479234398984, -0.600985713357395],
            [31.025009606931174, -0.6077470758068],
            [31.024346912559572, -0.617635997751308],
            [31.022682290320635, -0.620921230505082],
            [31.014015819668245, -0.63213404651088],
            [31.009806066311842, -0.643032530406702],
            [31.009334583738358, -0.64486482604103],
            [31.009772083044652, -0.649730549266609],
            [31.008229615514683, -0.661419888708687],
            [31.0072555470993, -0.664262995673894],
            [31.00631079699981, -0.672224408468463],
            [31.00252894984081, -0.689303577358749],
            [31.003040160407735, -0.689425442073849],
            [31.001239220621084, -0.698060366887811],
            [31.00494933550803, -0.694656611526887],
            [31.006327512850635, -0.693960974910139],
            [31.01627523981296, -0.692853020082552],
            [31.02001988414281, -0.692890759141292],
            [31.040731045176425, -0.695937510309748],
            [31.04753035223945, -0.695723330012431],
            [31.05290167127564, -0.694432539650141],
            [31.056644000646997, -0.692770341595239],
            [31.072795286348967, -0.680723730945183],
            [31.07894798696877, -0.676892298892451],
            [31.084400725709088, -0.67425411952335],
            [31.09280146212403, -0.671400073116896],
            [31.09102153483019, -0.664879889263761],
            [31.090996217610524, -0.663568745181922],
            [31.093528806450006, -0.655097097068294],
            [31.094798796988005, -0.635855568532064],
            [31.09625217230304, -0.629101514208358],
            [31.09863126780654, -0.621552034433772],
            [31.102791149393312, -0.612194711507307],
            [31.106125010313406, -0.607322062722467],
            [31.10840353942085, -0.604601111007065],
            [31.117724778609116, -0.596954459943142],
            [31.12243745198073, -0.591946566084885],
            [31.124869725952408, -0.588538385139293],
            [31.12581438442372, -0.584017463886352],
            [31.12439949113885, -0.575074003407548],
            [31.127232729035942, -0.569441479219223],
            [31.130972294291162, -0.565671981992262],
            [31.134922749839106, -0.559877002375302],
            [31.13634539378827, -0.557001932652763],
            [31.138725542117303, -0.550365466765516],
            [31.14070632462383, -0.538836845740696],
            [31.141417514546067, -0.537335995074408],
            [31.149059161071204, -0.527436696067946],
            [31.15167952160216, -0.522590638585845],
            [31.152792827988286, -0.519525529435069],
            [31.152944777120258, -0.509406891799791],
            [31.15265347054163, -0.505220086539788],
            [31.151877764514012, -0.502669848332843],
            [31.151946403886534, -0.501141668752106],
            [31.152932108179826, -0.495463182549337],
            [31.15466523234906, -0.490047148949664],
            [31.152820054127915, -0.477007200651766],
            [31.15317868135226, -0.474195044286299],
            [31.154691791938742, -0.470478925575334],
            [31.154740049435787, -0.4694752222683],
            [31.15294492264735, -0.440845838691927],
            [31.132337243042876, -0.420232827561099],
            [31.124179924018794, -0.403628921009188],
            [31.12467618482276, -0.391159466657509],
            [31.118002860190177, -0.377675714611596],
            [31.115364901662787, -0.375197522842779],
            [31.103237225813963, -0.339106870170106],
            [31.092305315406097, -0.327539623515149],
            [31.09034734381957, -0.323687423222713],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 153,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "NYAKASHASHARA",
        Population: 16255,
        Key: "KIRUHURANYAKASHASHARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.93547176383676, -0.491127532899902],
            [30.932527332473782, -0.485929276417684],
            [30.931729974352898, -0.482369422263145],
            [30.931845732158703, -0.4766855664103],
            [30.930820267532653, -0.473010824924888],
            [30.930024053865395, -0.465432072978444],
            [30.928316088812338, -0.455154657313221],
            [30.927806047851895, -0.443614516639258],
            [30.928378818168618, -0.434600846851174],
            [30.927696505489507, -0.426964743177112],
            [30.9264425588625, -0.424266000047493],
            [30.92695864997639, -0.413472516526746],
            [30.926559631801926, -0.412726044012971],
            [30.92370793981396, -0.413471665844346],
            [30.916039144404312, -0.413941577590825],
            [30.91297898937148, -0.415429009503345],
            [30.91143182724585, -0.415774701774581],
            [30.905106120983813, -0.415461534848149],
            [30.901118345825683, -0.414664448272666],
            [30.89709578520481, -0.415459404998591],
            [30.896132890034924, -0.416532053209883],
            [30.895581449316285, -0.421723371758984],
            [30.894102315708814, -0.424837849163196],
            [30.89172952997186, -0.427190660499911],
            [30.88664109401187, -0.428504425244797],
            [30.88409629347441, -0.431307093628556],
            [30.882032630603153, -0.434698247476395],
            [30.881516371504304, -0.43677467015696],
            [30.88161835634018, -0.440893226115234],
            [30.880689983426677, -0.441412102795426],
            [30.871580042366283, -0.439955911216245],
            [30.868382740640723, -0.44030108856118],
            [30.858034895067686, -0.440125075164738],
            [30.85109037354237, -0.440572989784239],
            [30.84587999577412, -0.440030097294796],
            [30.845507455442668, -0.440046555742009],
            [30.845417707457557, -0.441575000249536],
            [30.84562130253188, -0.45081556898253],
            [30.845272177686574, -0.468742738079507],
            [30.84449710317462, -0.470782642913089],
            [30.844254240044304, -0.472857978193124],
            [30.844670120494985, -0.473476423820449],
            [30.84386943770917, -0.47574121454442],
            [30.843318183840125, -0.479818115338182],
            [30.843716647754082, -0.484700662340131],
            [30.845564993434927, -0.489835350119051],
            [30.85295220742719, -0.496135308320736],
            [30.860042340470155, -0.487075303047725],
            [30.860717595984372, -0.486587303699399],
            [30.862949394730776, -0.48638221403491],
            [30.86109564748012, -0.490998999483467],
            [30.86149154041575, -0.494240168313034],
            [30.861961973757, -0.494405867179913],
            [30.863873554545624, -0.498457389218809],
            [30.864280057483032, -0.503517685138858],
            [30.867036033977495, -0.507845528645836],
            [30.87069068957374, -0.519612646265919],
            [30.8713080953803, -0.521031054558511],
            [30.872540064723886, -0.522356420698743],
            [30.87380285346822, -0.525435788624012],
            [30.873678806907265, -0.526829066292386],
            [30.874988017890573, -0.528894616895859],
            [30.878471682765735, -0.53240400452987],
            [30.880300440681797, -0.532927132895769],
            [30.880893735706135, -0.532554124497012],
            [30.88261270242651, -0.533879281579851],
            [30.882509582120072, -0.534340258089053],
            [30.88351237057343, -0.536063231582313],
            [30.88289361639562, -0.538600866051968],
            [30.88140991126165, -0.540864508449856],
            [30.88126102538478, -0.542581234393113],
            [30.880593175581744, -0.544123611904062],
            [30.880319122944762, -0.550368606232594],
            [30.878835206706714, -0.553179608930874],
            [30.878373297479193, -0.557544072621862],
            [30.877125150375676, -0.5593018331422],
            [30.875136641459388, -0.564143934831055],
            [30.880902770961274, -0.562952602712313],
            [30.8986531126662, -0.563210721143863],
            [30.9018533024754, -0.56296019580488],
            [30.907204552249834, -0.559941944774394],
            [30.910104834111536, -0.559439617360412],
            [30.91480478374542, -0.560095668820643],
            [30.917754498100564, -0.561254463408913],
            [30.922254586956793, -0.561558088382231],
            [30.929155123372528, -0.560956497534879],
            [30.934125418296237, -0.561683357820192],
            [30.939744685825623, -0.562785369629355],
            [30.941433031672876, -0.563588815445063],
            [30.946754686450305, -0.564989719593482],
            [30.956554771702443, -0.566553656964723],
            [30.96061757684804, -0.566531449899919],
            [30.962605335671093, -0.56564177671461],
            [30.964117791385693, -0.564040186240698],
            [30.964152195064468, -0.563046818860545],
            [30.960507757804546, -0.558702322462543],
            [30.955559338654652, -0.553113097173694],
            [30.949279542591803, -0.547100759664086],
            [30.94284717396617, -0.541995720751023],
            [30.9359487917105, -0.535155626952242],
            [30.935219446836392, -0.533992237127011],
            [30.94063356700262, -0.528117098807483],
            [30.94244110940661, -0.527018009938882],
            [30.933624286826813, -0.516468156570913],
            [30.932461083518206, -0.514377199454554],
            [30.931995074379763, -0.510095443874698],
            [30.930266624144927, -0.507460056925393],
            [30.928677939191928, -0.50623623467895],
            [30.922628547524756, -0.503505410134489],
            [30.916949195279276, -0.497055979531411],
            [30.916136235218538, -0.494940770638809],
            [30.926471857415503, -0.493144781760849],
            [30.93168523376016, -0.491084965098974],
            [30.93547176383676, -0.491127532899902],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 154,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "SANGA TOWN COUNCIL",
        Population: 9077,
        Key: "KIRUHURASANGA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.983019738250604, -0.291803539002788],
            [30.98213408741533, -0.291071002009517],
            [30.981552006060692, -0.289380101487041],
            [30.98015156038054, -0.287354515109676],
            [30.974896319848686, -0.282968383363387],
            [30.971203385241562, -0.278909800581116],
            [30.969781168890457, -0.280013929220802],
            [30.967383870824367, -0.280995176890578],
            [30.958363959820037, -0.282343387211549],
            [30.95576357332945, -0.283079173930649],
            [30.95348805178156, -0.284796667883682],
            [30.948651400120966, -0.286085992132678],
            [30.943827506334053, -0.28651044889019],
            [30.942477128256257, -0.287698754175158],
            [30.94146135375716, -0.288025786218385],
            [30.939592458215884, -0.287902743731324],
            [30.93215807817962, -0.284302049909946],
            [30.92545431143866, -0.284832571305375],
            [30.924194763815883, -0.285241358989868],
            [30.921675503280273, -0.286999667961755],
            [30.919481452640436, -0.287735494807036],
            [30.915987455342858, -0.287653055656038],
            [30.911086007302533, -0.286029136670331],
            [30.905383899832582, -0.28589237526155],
            [30.903352684109375, -0.284951283100949],
            [30.90164670253644, -0.282824125568659],
            [30.89955195076983, -0.281037553506082],
            [30.898404841677888, -0.278804892971498],
            [30.89060693231075, -0.268194438028594],
            [30.890191612408824, -0.267955419608938],
            [30.884524841068902, -0.268432336256697],
            [30.878086936126184, -0.267594920639332],
            [30.871084942185636, -0.269206574000292],
            [30.866931381145207, -0.269295454129736],
            [30.86633793071231, -0.269803102648628],
            [30.865981675938638, -0.271176956361206],
            [30.864557362021337, -0.272580488122418],
            [30.86193112022022, -0.273446068852417],
            [30.859527609405607, -0.273924814233077],
            [30.85106297941778, -0.274176450126928],
            [30.84729040646574, -0.275296848408061],
            [30.84515351922071, -0.276589312381364],
            [30.843085792371074, -0.281030246697455],
            [30.84230627030012, -0.281814724293993],
            [30.840677078514336, -0.288091387557857],
            [30.83740359695775, -0.288613848297107],
            [30.834854656983463, -0.289644627706709],
            [30.83268026148206, -0.291151208851009],
            [30.831773528085403, -0.290871384554458],
            [30.830562345757524, -0.289108193000207],
            [30.829101697681956, -0.286595743757974],
            [30.82876100083065, -0.284440753471312],
            [30.828012652096707, -0.283830639605631],
            [30.822311791488392, -0.274572370862215],
            [30.815177786523584, -0.266647602670378],
            [30.814029401823934, -0.26613079849011],
            [30.813369832691198, -0.265023680813222],
            [30.81256350040057, -0.264777538767928],
            [30.811415236973495, -0.263571936114786],
            [30.809968952061023, -0.261310311873636],
            [30.80902942746155, -0.258291243581782],
            [30.807685424727296, -0.256795756879754],
            [30.80172597687794, -0.254504544808974],
            [30.799732148138528, -0.251800464332033],
            [30.793945076212406, -0.249467185469338],
            [30.78656879651378, -0.248245477426921],
            [30.78436148135047, -0.245876488435103],
            [30.781275644382017, -0.243606807778673],
            [30.777863608472654, -0.242069363962089],
            [30.771739302700666, -0.241571137590175],
            [30.767954217115026, -0.23814419362557],
            [30.76429190158434, -0.235562704593475],
            [30.762748192582684, -0.237827975000351],
            [30.76063645547065, -0.238890523666337],
            [30.75859058912345, -0.240683814763209],
            [30.756214179582635, -0.246197146305867],
            [30.755619873055302, -0.248787830177935],
            [30.756212986619953, -0.253305196086739],
            [30.75670631622116, -0.254602669513997],
            [30.75628204730235, -0.255364197975161],
            [30.75635945692703, -0.256421933909985],
            [30.754943179338298, -0.258708896649339],
            [30.754670949383005, -0.2620628191451],
            [30.751034413704346, -0.269610844646695],
            [30.7514616308939, -0.272078933822059],
            [30.751062194104524, -0.273452989394538],
            [30.74845288913975, -0.276164595652844],
            [30.74831011809502, -0.277312688482741],
            [30.749877563281448, -0.280874873258933],
            [30.7490220913482, -0.281588893256075],
            [30.74883646168125, -0.283044348468708],
            [30.74669748315824, -0.286370765304024],
            [30.74664026227126, -0.287690638897185],
            [30.745070310785195, -0.288476834495872],
            [30.747448786451137, -0.296667822478937],
            [30.74849572081252, -0.299090838904169],
            [30.749736737987636, -0.300655069155515],
            [30.753169546539617, -0.302979142043379],
            [30.75991607308811, -0.306198913645733],
            [30.76023308316199, -0.30870316680407],
            [30.75767988517326, -0.315736037417852],
            [30.756824198542635, -0.317345038368509],
            [30.75449992811922, -0.319957195510182],
            [30.7542713652699, -0.321873699546933],
            [30.75244603352833, -0.324513076743672],
            [30.751370468960555, -0.327096854730041],
            [30.748462648437012, -0.326197001780882],
            [30.746383158148724, -0.326229766401526],
            [30.744625321326033, -0.327051803155972],
            [30.74227347621669, -0.327300495891057],
            [30.74035041406039, -0.328978148527193],
            [30.7379240770544, -0.33025692947821],
            [30.731989031939726, -0.330940184794071],
            [30.726511963228287, -0.332134654630078],
            [30.72157999492614, -0.334423216930645],
            [30.719766711389177, -0.33777668517198],
            [30.718398044510508, -0.338788858649459],
            [30.717029052441696, -0.340596558826988],
            [30.716428154076787, -0.341865946540805],
            [30.716286748471287, -0.345071237780838],
            [30.715431270249788, -0.345730960215785],
            [30.71537385083515, -0.347050801097832],
            [30.713619736631, -0.350467532982522],
            [30.712279311886547, -0.351868418575685],
            [30.71219316614573, -0.354743144407823],
            [30.71269148678667, -0.357265451847648],
            [30.711863391909993, -0.362345771065544],
            [30.70839820987178, -0.366765484425327],
            [30.7059745606251, -0.367741188391908],
            [30.70437755817088, -0.369467424488648],
            [30.704006586297897, -0.370552131948368],
            [30.702110216681987, -0.372079403843586],
            [30.701226375053704, -0.372250933528457],
            [30.700227702681016, -0.373866169883123],
            [30.700199432699023, -0.374546827721295],
            [30.70205191691836, -0.377241239479748],
            [30.702222628263375, -0.378479766540316],
            [30.701067233111235, -0.38100162441124],
            [30.701665855145233, -0.381806345260626],
            [30.70166524788409, -0.384102509109602],
            [30.701265927875674, -0.384644802656866],
            [30.700325153719643, -0.384156388849426],
            [30.699811979435495, -0.384418410744393],
            [30.69844293526441, -0.386226040729296],
            [30.697045749570393, -0.386768061059755],
            [30.69697400202698, -0.388521799154972],
            [30.696482448395077, -0.389830289148469],
            [30.69537607610464, -0.393574708530895],
            [30.69561790257911, -0.39534661050339],
            [30.69664399063598, -0.396296094524403],
            [30.696814731625402, -0.397878139763571],
            [30.696700504548847, -0.398447626461518],
            [30.695673925113496, -0.399279017772279],
            [30.6961433909692, -0.402325621735282],
            [30.695346394869343, -0.406999064099681],
            [30.69418278552225, -0.410108479149101],
            [30.69351796034677, -0.410280046683251],
            [30.692354533357687, -0.409773473615191],
            [30.68950508985289, -0.41056816673189],
            [30.686881413640222, -0.411814916289048],
            [30.683699760566927, -0.410548406099597],
            [30.682749934087777, -0.411361720735209],
            [30.680232966951085, -0.411885301964688],
            [30.67930692247076, -0.412463583753463],
            [30.67923569954349, -0.414226338793944],
            [30.682084603160792, -0.419108714054595],
            [30.68369900867702, -0.423276585825617],
            [30.686073170632998, -0.426025428756279],
            [30.690167841716672, -0.428468464892976],
            [30.69229408302727, -0.428034166737571],
            [30.696321700264868, -0.428447368548382],
            [30.7004253266536, -0.430649395428769],
            [30.70319102381776, -0.433958964222122],
            [30.704875832997736, -0.438118048034986],
            [30.705251568636694, -0.440600327404997],
            [30.70637096829537, -0.440349498240558],
            [30.708205837450326, -0.438559385502971],
            [30.713235261282648, -0.435876171619346],
            [30.71797591448039, -0.435911517506231],
            [30.721112297853253, -0.434436585642053],
            [30.724552615422738, -0.435776231545461],
            [30.725743578470215, -0.435707111776522],
            [30.728514680797403, -0.434656258733444],
            [30.73134461828416, -0.435612639587492],
            [30.731257366717248, -0.438844041594036],
            [30.73179194246471, -0.440199320528664],
            [30.736843829569054, -0.442499428097863],
            [30.77668649115863, -0.4802889920887],
            [30.787310446510666, -0.490197890620339],
            [30.799073106316865, -0.480085318827517],
            [30.803235629848892, -0.474278049368465],
            [30.80476006908941, -0.472924798896186],
            [30.80727041204921, -0.472293848197495],
            [30.81013904177184, -0.472655750950646],
            [30.811752487887336, -0.473378257480825],
            [30.81381361391626, -0.475905897006402],
            [30.81569595184744, -0.476808991555807],
            [30.819462074895746, -0.474012438312115],
            [30.822152354000185, -0.471396032279456],
            [30.824662807452757, -0.470494315892177],
            [30.82984064554644, -0.470312747339969],
            [30.831543842341972, -0.468622662496303],
            [30.83191734746408, -0.467589624516089],
            [30.83323519664714, -0.467519588798582],
            [30.835986983399106, -0.469140617338143],
            [30.83687292798343, -0.470397116065135],
            [30.8373277872326, -0.470291593626006],
            [30.838283823765316, -0.471160683433319],
            [30.840768149717842, -0.470292659890341],
            [30.84217908233064, -0.470950563810025],
            [30.84272731696201, -0.470598519645916],
            [30.844138301677077, -0.47109205626234],
            [30.84449710317462, -0.470782642913089],
            [30.845272177686574, -0.468742738079507],
            [30.84562130253188, -0.45081556898253],
            [30.845417707457557, -0.441575000249536],
            [30.845507455442668, -0.440046555742009],
            [30.84587999577412, -0.440030097294796],
            [30.845066469774736, -0.436926058831374],
            [30.846127704417082, -0.417527526363746],
            [30.836892312728963, -0.404902535088646],
            [30.832538069850695, -0.400516741220166],
            [30.82910811075477, -0.39453680749678],
            [30.828713188897968, -0.39055068716485],
            [30.823303265660744, -0.385500351387386],
            [30.82105966933973, -0.38523404465862],
            [30.819344264439476, -0.38390494167658],
            [30.805224212427053, -0.376992341468899],
            [30.798362462570324, -0.372473215154638],
            [30.7921610121767, -0.366359921341042],
            [30.788335057737214, -0.360645842040331],
            [30.7834554225886, -0.345763978091194],
            [30.786755347852214, -0.343506067538762],
            [30.794938542848048, -0.340717809484269],
            [30.803253334744824, -0.339789652363332],
            [30.807080876507417, -0.338993329597743],
            [30.810380747872095, -0.337133956225633],
            [30.817904183292356, -0.334212586243475],
            [30.82569180605116, -0.330361169149869],
            [30.838495804612787, -0.321328928417975],
            [30.851431657891844, -0.313093759151246],
            [30.852223063775696, -0.315485568458792],
            [30.85261756162767, -0.322527725614458],
            [30.851825226885815, -0.324653467695051],
            [30.849184889619572, -0.327974633658718],
            [30.848920218987416, -0.331296302466834],
            [30.854066344754937, -0.336745065195678],
            [30.861985361395398, -0.336481062974687],
            [30.86766043855842, -0.337412399495038],
            [30.873466510751115, -0.342994257098706],
            [30.875444507581975, -0.350966976143809],
            [30.87874240804292, -0.358541406559369],
            [30.881249632950365, -0.360667936565311],
            [30.886926475302914, -0.354158511347015],
            [30.889302362024214, -0.353494690569583],
            [30.891413714657325, -0.355355387519287],
            [30.8959010582163, -0.356153649228886],
            [30.90038805592389, -0.358546393908167],
            [30.910023285050027, -0.357751351905493],
            [30.915303146607197, -0.356158055380221],
            [30.922035215669474, -0.353103443074007],
            [30.940117605246147, -0.353638972528408],
            [30.947113228334718, -0.352976133553793],
            [30.952524843997946, -0.352977325595553],
            [30.95655027473614, -0.353913447531179],
            [30.95847079016859, -0.35346276774685],
            [30.959950708903623, -0.346634007510887],
            [30.960743915909593, -0.340654642866815],
            [30.958105083321463, -0.33587046343369],
            [30.951111331423643, -0.327231945671678],
            [30.950187957634697, -0.324441325859248],
            [30.952168498494398, -0.32098690204331],
            [30.954732323552953, -0.318710400871446],
            [30.963784686196895, -0.316248549933989],
            [30.983062506142947, -0.315655556776615],
            [30.986615637739057, -0.316207787702185],
            [30.994633677469928, -0.315051990574374],
            [30.995560818793205, -0.314563910908534],
            [30.99491379104012, -0.312050181153865],
            [30.992413293615844, -0.307682536404835],
            [30.987721391988583, -0.3015242382771],
            [30.98454131815356, -0.296035329842917],
            [30.983019738250604, -0.291803539002788],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 155,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KIKAATSI",
        Population: 18922,
        Key: "KIRUHURAKIKAATSI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.677915282077027, -0.128049631131632],
            [30.676758365178806, -0.128600830617599],
            [30.672642494752733, -0.128660296244601],
            [30.66919163904669, -0.130175634380535],
            [30.6600420607227, -0.1291480272089],
            [30.655031930906006, -0.127277602028281],
            [30.65317829774141, -0.127949257225525],
            [30.65141039439765, -0.130850840532286],
            [30.648600294407338, -0.132739873101152],
            [30.647302793862092, -0.137295745465419],
            [30.64511416635163, -0.139099282425107],
            [30.641812651968326, -0.140534151766234],
            [30.640659757725945, -0.141767108210115],
            [30.640155216251667, -0.143797997826856],
            [30.641379700832303, -0.147098402935834],
            [30.64073108126456, -0.148875408370834],
            [30.635290878514034, -0.154206031247427],
            [30.63034613616856, -0.158292825078295],
            [30.62966390343952, -0.158482740780101],
            [30.629702624421547, -0.159091717152383],
            [30.625390799092653, -0.163878853523988],
            [30.625851625850242, -0.165791359747482],
            [30.62890350919593, -0.171372408547236],
            [30.629772296856657, -0.174210873409211],
            [30.628881108806013, -0.181050570887605],
            [30.62792708360123, -0.181840063892663],
            [30.624534752237594, -0.186513297739001],
            [30.614314079362686, -0.192934965457626],
            [30.6128732544105, -0.197053107229331],
            [30.61087745746229, -0.199374588864835],
            [30.610214663377675, -0.201918555437647],
            [30.60891450112426, -0.203896678204528],
            [30.608344753638477, -0.20847386048418],
            [30.610368804398966, -0.210325378327257],
            [30.611730875846842, -0.21639887190003],
            [30.613746626174116, -0.219728132689135],
            [30.614762364740596, -0.222659390872268],
            [30.614535774591662, -0.227441670141987],
            [30.615108035563633, -0.229650237952436],
            [30.61641422102101, -0.231842689777372],
            [30.620398079524495, -0.233710823401046],
            [30.62175261500546, -0.236146879463142],
            [30.622632697184258, -0.235407325209436],
            [30.623404597948337, -0.235373238923637],
            [30.624994536051148, -0.234456694644709],
            [30.622675066224627, -0.244596929085511],
            [30.621664006982463, -0.247339251968574],
            [30.620797072546143, -0.248804367108093],
            [30.618655158328785, -0.250718687536175],
            [30.617432337428077, -0.252904907108602],
            [30.61806129916244, -0.25640607521077],
            [30.61709994370494, -0.261151618043309],
            [30.617690551868296, -0.262250600108157],
            [30.619568392833134, -0.262817154423721],
            [30.62386424252301, -0.262813437234171],
            [30.626075878582824, -0.262427163024784],
            [30.626807887860096, -0.262844647073722],
            [30.62722228249728, -0.263710495288917],
            [30.63024268797708, -0.263209167896877],
            [30.63069032746631, -0.263629529193069],
            [30.630877607338423, -0.265103575221313],
            [30.632589647149615, -0.266066273199128],
            [30.633539594003008, -0.265761907495928],
            [30.634223174204994, -0.266291951817648],
            [30.63494924022833, -0.266103270813445],
            [30.63563890022814, -0.266474951934528],
            [30.636068550953794, -0.26604257499913],
            [30.63775662910311, -0.265762712377768],
            [30.639540312253153, -0.264227732553588],
            [30.64144652381132, -0.264169498087764],
            [30.644123800700374, -0.26491710762419],
            [30.644342139823426, -0.264536272721123],
            [30.646903137883783, -0.264610002958646],
            [30.647907298064577, -0.263936332052132],
            [30.649187774636857, -0.2641123631479],
            [30.650396346460546, -0.259673893884401],
            [30.649174132820942, -0.259175596317675],
            [30.648286703321443, -0.258106044291762],
            [30.64828683357716, -0.257388235659149],
            [30.65026593084423, -0.256670790800177],
            [30.65326351731916, -0.256524846572805],
            [30.654282014611894, -0.257037756092806],
            [30.655038461658133, -0.258253778825203],
            [30.658313011311602, -0.255456374088912],
            [30.662329400506444, -0.254241210770244],
            [30.663103803078606, -0.251432488295592],
            [30.66620388912408, -0.250294388536852],
            [30.66670679296962, -0.249043365227125],
            [30.66820111439358, -0.247722227149643],
            [30.669220512696537, -0.247356911784183],
            [30.669388307211843, -0.246007422969691],
            [30.67043570690052, -0.245206328929254],
            [30.6695002938901, -0.244376776471554],
            [30.669249106970344, -0.243462996885644],
            [30.669263702797085, -0.239709654296897],
            [30.66961296777954, -0.238641344848233],
            [30.67177253748552, -0.23740275213417],
            [30.67305158932977, -0.237408927998732],
            [30.673975808433426, -0.235788081008498],
            [30.673235000157952, -0.232880838162848],
            [30.672294720075328, -0.231933920133816],
            [30.672383744018315, -0.22873721826381],
            [30.673711772011856, -0.226476338229784],
            [30.67259447800418, -0.225451427750022],
            [30.6720294224191, -0.224031662145519],
            [30.672008988441355, -0.219659376142744],
            [30.67150855586117, -0.217304860392514],
            [30.672385835296293, -0.21520407882613],
            [30.67279570691602, -0.211784656452956],
            [30.671822516154666, -0.208832839264393],
            [30.671988698194014, -0.207284629131121],
            [30.67131400143189, -0.205892233322197],
            [30.671858330188414, -0.201290478838699],
            [30.673001522625707, -0.201120841128114],
            [30.67386392056985, -0.198699739867769],
            [30.674669899822515, -0.197699919142048],
            [30.675540891948952, -0.197379995936532],
            [30.67483898970847, -0.19591322729477],
            [30.675615019129577, -0.19439011381945],
            [30.673854914959115, -0.192274471198796],
            [30.674106507917358, -0.186681268331621],
            [30.675315081537665, -0.18459145389494],
            [30.67599077273484, -0.182724867630364],
            [30.67595365165235, -0.181238334911582],
            [30.676673463604665, -0.180270886504266],
            [30.675954026249805, -0.178715369594732],
            [30.6765476644306, -0.177852258075157],
            [30.676415850137374, -0.176789977491215],
            [30.67705813837901, -0.175171026051302],
            [30.675432464395858, -0.173908883662104],
            [30.676202054693036, -0.172946902892461],
            [30.67856024370492, -0.171960124192358],
            [30.67909409002041, -0.170473341780507],
            [30.679119108101077, -0.168799081668607],
            [30.680075949524255, -0.167615071293885],
            [30.680467638344336, -0.16537797384807],
            [30.68285049329733, -0.165778074618388],
            [30.682396848570402, -0.163650381439428],
            [30.680567207610416, -0.16289336164678],
            [30.682223187157984, -0.160468598262016],
            [30.683652229806935, -0.159887562121985],
            [30.683692364737187, -0.158759701100608],
            [30.68514451924173, -0.155888405222886],
            [30.684590247033338, -0.15428286118031],
            [30.68311255971346, -0.153154116816812],
            [30.681991472120345, -0.152888390713554],
            [30.679680400643417, -0.153148714367968],
            [30.67899461956898, -0.15194597148355],
            [30.680703825195458, -0.150490288076613],
            [30.680435465182427, -0.149948372260896],
            [30.68087082200678, -0.147377435809739],
            [30.679966812302094, -0.147187184040904],
            [30.678694586755682, -0.145850197029075],
            [30.677703482689235, -0.145558457507487],
            [30.678366666642653, -0.144160207287256],
            [30.678241000419266, -0.143314298785431],
            [30.676892206969615, -0.141238568956602],
            [30.677441089286322, -0.140109022638065],
            [30.677136725695018, -0.139302245384779],
            [30.678796115247398, -0.136328515088458],
            [30.678618989931238, -0.135603444643425],
            [30.67912779211492, -0.134665526145448],
            [30.677672354268015, -0.132715730942669],
            [30.678392259645133, -0.132292448607625],
            [30.679877757816403, -0.130106046566556],
            [30.677915282077027, -0.128049631131632],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 156,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KITURA",
        Population: 15604,
        Key: "KIRUHURAKITURA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.76075184317059, 0.054783779797203],
            [30.76073516504901, 0.057839432794257],
            [30.762559580508974, 0.065306883583658],
            [30.76258490132189, 0.066916076901629],
            [30.76607025682646, 0.072042166467683],
            [30.766095693522033, 0.07397681891362],
            [30.765170412609713, 0.075314752392632],
            [30.762273323360564, 0.076968991341026],
            [30.759553772652577, 0.0778909620179],
            [30.750763409949418, 0.079201321613426],
            [30.750827564932067, 0.078604663862426],
            [30.748807526945946, 0.078622631049526],
            [30.74333763846854, 0.079915083622521],
            [30.741671565450456, 0.080719572678063],
            [30.73728778327066, 0.081169141299856],
            [30.73517104883071, 0.081098885928563],
            [30.733580546585884, 0.080565420131367],
            [30.732611530295642, 0.078965245479958],
            [30.732028882104068, 0.07551185068006],
            [30.72912347984525, 0.073794055024377],
            [30.722369659874985, 0.068080316956473],
            [30.720615192632913, 0.067979967125117],
            [30.720593047364535, 0.066868081745349],
            [30.719599630136234, 0.066331646847627],
            [30.71890039229884, 0.06512474398959],
            [30.715859084819012, 0.063744525649178],
            [30.715337380132926, 0.063945645740041],
            [30.714959933203364, 0.065063096244699],
            [30.713501881258974, 0.065284653888086],
            [30.712456998649728, 0.063202396301158],
            [30.710575639882222, 0.061727256581815],
            [30.710270506434707, 0.059173836333965],
            [30.709748505304574, 0.058544656640972],
            [30.70987653230054, 0.057514384759914],
            [30.7095213501153, 0.057195892625405],
            [30.708332878096112, 0.058614672195917],
            [30.707028689593574, 0.059028480913486],
            [30.70643437857465, 0.058997930125204],
            [30.706047063651706, 0.058218223409205],
            [30.704615217360775, 0.057553272808957],
            [30.704105369538116, 0.05790936660345],
            [30.703983261541556, 0.058912805813913],
            [30.702770026563208, 0.059319553774932],
            [30.701966860833988, 0.059056200213472],
            [30.70174036680478, 0.057692834102606],
            [30.701146518418227, 0.057944235591697],
            [30.699574789166213, 0.057545138568176],
            [30.697861079386882, 0.055781820189682],
            [30.697122933717935, 0.05611702637811],
            [30.696040729701878, 0.055647650577231],
            [30.695791598127514, 0.056053644875301],
            [30.6964790877976, 0.057597625307089],
            [30.696606635991547, 0.059899584860177],
            [30.694902767256153, 0.061273975933739],
            [30.69408048986928, 0.060611889197777],
            [30.69500273267929, 0.059720721401423],
            [30.694886209508848, 0.05917875191256],
            [30.69406484930185, 0.058754084366702],
            [30.69307567571497, 0.059077294441771],
            [30.692262782129507, 0.0584219782781],
            [30.691353611603496, 0.05833657189509],
            [30.69083734980972, 0.057070534586473],
            [30.690201834865338, 0.056699774898602],
            [30.689468978476764, 0.057465781435956],
            [30.688152708532, 0.056412669880405],
            [30.687285327633, 0.056670174526163],
            [30.68628766047509, 0.057333441694703],
            [30.685694665488054, 0.058789770820888],
            [30.685067449180252, 0.059119898818082],
            [30.68514128889997, 0.058397750727471],
            [30.684107851725777, 0.057494796106706],
            [30.683039385645365, 0.058255429812435],
            [30.681524303256847, 0.057601040700095],
            [30.680379223459116, 0.057911931292286],
            [30.680264393612973, 0.056498260420838],
            [30.681476653020912, 0.056308334203903],
            [30.682587851959383, 0.054439028107301],
            [30.682683594402363, 0.053015598758139],
            [30.683863484815646, 0.052596462990888],
            [30.684422609723228, 0.051856636881399],
            [30.684528286634944, 0.051017257706373],
            [30.6840687453665, 0.050554584194308],
            [30.68495596106698, 0.050233328806644],
            [30.684617720209673, 0.048973865199186],
            [30.68530070123536, 0.048267054818454],
            [30.685198606805, 0.047450977888386],
            [30.686092210425446, 0.046962650272404],
            [30.685779507773354, 0.045414027091037],
            [30.684171049104314, 0.045523210092943],
            [30.683249252756998, 0.044701171014412],
            [30.683871105224224, 0.044135233453781],
            [30.68381385109959, 0.043495793058588],
            [30.684630671221125, 0.043595494348248],
            [30.68496705256578, 0.042558768734805],
            [30.68781956830888, 0.042287662646257],
            [30.688990252787146, 0.03866062845561],
            [30.688888142187107, 0.03819796834058],
            [30.68835198809968, 0.038197953069233],
            [30.68737340924323, 0.039085399434868],
            [30.686947757817222, 0.038924026114641],
            [30.68780320639428, 0.033121566298667],
            [30.68719191721648, 0.031330465144377],
            [30.687764205137896, 0.030075739858198],
            [30.686801193187023, 0.02972872789772],
            [30.686333765608726, 0.030520537914019],
            [30.686035283287588, 0.028745565964731],
            [30.686469321385097, 0.028270067980772],
            [30.68522469028759, 0.02794232577364],
            [30.686571468816048, 0.027190539274089],
            [30.68573534120409, 0.026483686495613],
            [30.686060876290025, 0.025802559663577],
            [30.68571621876665, 0.025217807675565],
            [30.687484250569494, 0.024941533531336],
            [30.687720431132437, 0.023977670065416],
            [30.68646991427318, 0.022544422520769],
            [30.686609891557403, 0.020385638094009],
            [30.68562059130803, 0.018592829062779],
            [30.686026778936796, 0.017328380293924],
            [30.685033424590554, 0.015174309262621],
            [30.685741921363565, 0.014351818103983],
            [30.68397208933687, 0.013414070399679],
            [30.684274190970285, 0.011325308648172],
            [30.68391819491141, 0.010563449266254],
            [30.684497901120455, 0.009377114357071],
            [30.684583440498432, 0.008066399609237],
            [30.683328562318472, 0.007346549035863],
            [30.68459474489798, 0.005282327425118],
            [30.682759440060128, 0.004881688691433],
            [30.681826943879454, 0.003817327914972],
            [30.68355514617922, 0.000346743411468],
            [30.68457236966087, -0.000258869312066],
            [30.684350371699637, -0.001223806352499],
            [30.68491418221974, -0.002139077337195],
            [30.684491323655937, -0.003983809092935],
            [30.685627054686513, -0.00485558814096],
            [30.685692929942892, -0.00934417942426],
            [30.685192544075157, -0.010181402968679],
            [30.68521367514558, -0.012164490514452],
            [30.68656413137682, -0.014592058146013],
            [30.68546817415377, -0.01569444996292],
            [30.684229986671813, -0.015851703640692],
            [30.68358430459504, -0.016790234665383],
            [30.68407113937673, -0.017819155961692],
            [30.683860509595434, -0.018674265830542],
            [30.684160888260145, -0.01988394071689],
            [30.68286402372211, -0.022916791244738],
            [30.68093184546234, -0.023796101697628],
            [30.68073447391633, -0.024999890781602],
            [30.681053710913783, -0.025736196628682],
            [30.682464210538615, -0.025929060408983],
            [30.682893731906884, -0.02681146104609],
            [30.6842519855148, -0.027413381626397],
            [30.684315305064207, -0.030445550157958],
            [30.685693254234717, -0.031294671777241],
            [30.686055548382072, -0.03211387680045],
            [30.685895161374628, -0.033106477299375],
            [30.685212096805614, -0.034027312291294],
            [30.68513485247097, -0.035402603992751],
            [30.685467452806602, -0.035958709554783],
            [30.6846913191809, -0.039641173495275],
            [30.68687953526295, -0.04304928287902],
            [30.687797102341932, -0.043654985260683],
            [30.687463803117026, -0.046312714888094],
            [30.68776344336656, -0.047858552374961],
            [30.686776193072664, -0.050163702212338],
            [30.687131790279555, -0.052297137277109],
            [30.686646982995455, -0.053960467023502],
            [30.68782448838168, -0.055632896653959],
            [30.688749926499163, -0.055750451034797],
            [30.68986928842863, -0.055190016646198],
            [30.691169022185658, -0.056265819656954],
            [30.690325717932925, -0.058335935888208],
            [30.688085155222605, -0.05974607723485],
            [30.68869966306407, -0.060252338705284],
            [30.69038597512553, -0.060216247112077],
            [30.690800218845762, -0.060843777480004],
            [30.690143216199807, -0.064401733598427],
            [30.689282267238216, -0.065441289428989],
            [30.687967186662874, -0.068885445827764],
            [30.68791604647208, -0.070386072316697],
            [30.688425848480662, -0.071651687985294],
            [30.68785084405379, -0.072501413621657],
            [30.68790913483428, -0.074029164599857],
            [30.682841329583102, -0.080374919088514],
            [30.679126150892884, -0.08219172848128],
            [30.679212637095173, -0.083620033914679],
            [30.679967557005448, -0.08447886641966],
            [30.68059414628918, -0.086928712290684],
            [30.679948022241273, -0.089776236303154],
            [30.67908635103422, -0.090933287408249],
            [30.67865561783866, -0.09322034845579],
            [30.67952556163115, -0.094397568396477],
            [30.680274416116628, -0.097252631361671],
            [30.680779558563792, -0.097634970861645],
            [30.680033865249836, -0.099655176533439],
            [30.680563299938946, -0.101391371167052],
            [30.68045514996526, -0.103516841918152],
            [30.67950739230622, -0.105375689409285],
            [30.67856062818388, -0.105348264788366],
            [30.67839942640444, -0.106504985673652],
            [30.67947938283566, -0.107287213007164],
            [30.68040592318601, -0.109724917414792],
            [30.679918080494545, -0.110970003445626],
            [30.67852439823014, -0.112495608493414],
            [30.678492866465362, -0.114757869153868],
            [30.67764268740574, -0.116087099090995],
            [30.677876025699103, -0.117121796255426],
            [30.679377285710345, -0.118241538505269],
            [30.680033815842496, -0.119326379440266],
            [30.680606110950418, -0.121041749125641],
            [30.682164327743966, -0.12070970468777],
            [30.688889776222595, -0.122188423544796],
            [30.690061968073927, -0.122796473804737],
            [30.694182567231618, -0.122999474625657],
            [30.702236188332595, -0.127015838988897],
            [30.70684503442365, -0.130316998298251],
            [30.70926828841157, -0.131560981156919],
            [30.715112850719233, -0.132039883445878],
            [30.71734619905949, -0.131609549342973],
            [30.71820149402465, -0.131800976231003],
            [30.7196236564768, -0.134074703112888],
            [30.72261404205643, -0.134701547590504],
            [30.72337295587647, -0.135618549772609],
            [30.724056034818503, -0.135817281708755],
            [30.724222930120185, -0.136734229949789],
            [30.723615576461672, -0.138415215545629],
            [30.727425653178468, -0.139424204798539],
            [30.72759220262879, -0.143917202092691],
            [30.726347133153407, -0.147080501367833],
            [30.727348841831784, -0.148792213876433],
            [30.72769781755674, -0.150412168153887],
            [30.728608593372165, -0.150656777663209],
            [30.73033927053057, -0.149113445844931],
            [30.73214569722696, -0.149083065823189],
            [30.73369417897776, -0.14792176725041],
            [30.735455082648834, -0.147769121533949],
            [30.736851635030565, -0.147922086151283],
            [30.736760425486512, -0.14920579413984],
            [30.73821762672631, -0.150077036619698],
            [30.73954358589977, -0.150337591174172],
            [30.7416711576153, -0.150829347025291],
            [30.74285418853881, -0.15251935422403],
            [30.74414316856359, -0.153316875692831],
            [30.745837220509532, -0.15144414647689],
            [30.746866371821543, -0.149460169214829],
            [30.747024277682165, -0.148282360580595],
            [30.74805531725291, -0.147828249347542],
            [30.748809066658332, -0.146678275732822],
            [30.749824787258508, -0.146590371378562],
            [30.75237025704087, -0.145089458487703],
            [30.753647001113144, -0.142983182601768],
            [30.75471006113216, -0.142260056309731],
            [30.763393690504817, -0.147314478489546],
            [30.78990628932257, -0.147407499627857],
            [30.792514788498515, -0.146747792531501],
            [30.796065302403882, -0.143764736909888],
            [30.797182316137164, -0.141043618063447],
            [30.798669058475113, -0.13985039394804],
            [30.799546725982417, -0.138313567874359],
            [30.799475129355947, -0.135583290996446],
            [30.80014782287501, -0.133702899516771],
            [30.799098143262164, -0.131903720769567],
            [30.799582512168385, -0.130240286862885],
            [30.803459746037554, -0.127899090933523],
            [30.80780302497778, -0.12318022153191],
            [30.80835546821625, -0.121137070944168],
            [30.810533520759208, -0.120160848736412],
            [30.812382604855195, -0.118289567727931],
            [30.813522183370104, -0.115450871284726],
            [30.81699317121999, -0.115559622010324],
            [30.835751932916807, -0.110886913929156],
            [30.842158939407028, -0.105688862247363],
            [30.84323600505962, -0.103853633241442],
            [30.846951152308808, -0.100653397325096],
            [30.84884419725985, -0.098393287090741],
            [30.850050176545647, -0.09844356572301],
            [30.85213772562033, -0.090256502909106],
            [30.857407623962658, -0.081366134456992],
            [30.856466878552702, -0.078783892863933],
            [30.851665047389172, -0.071993901822225],
            [30.85108758696834, -0.069851171779641],
            [30.850520401477738, -0.063513447659574],
            [30.852516505649756, -0.058107038085477],
            [30.85675247813437, -0.049337445600215],
            [30.857809548187067, -0.04792708392572],
            [30.85871398189659, -0.045377551908707],
            [30.858143199551574, -0.043994265369519],
            [30.857922284060272, -0.040540603368467],
            [30.856963641514945, -0.039645523136847],
            [30.855905135056084, -0.036869919072467],
            [30.854349159559202, -0.035622230359429],
            [30.849757672512723, -0.033804902940654],
            [30.847102876861968, -0.031933378338585],
            [30.84546241301601, -0.031879101239242],
            [30.844412278855597, -0.031390872346613],
            [30.84441642997051, -0.014475340943226],
            [30.84247275507176, -0.012404961425639],
            [30.84123816264755, -0.010255846355094],
            [30.83984852010696, -0.009409926220712],
            [30.837837967431923, -0.007048456585916],
            [30.831415369781617, -0.004180963246143],
            [30.82754751162909, -0.004180959652888],
            [30.82516841253233, -0.005533851211966],
            [30.814591228863875, -0.009466547032296],
            [30.80516647950036, -0.014141950100542],
            [30.808647338038586, -0.023922581783725],
            [30.810187335201533, -0.030061237458253],
            [30.8102614183647, -0.037067780159138],
            [30.809467321128235, -0.049480630715063],
            [30.80999504273012, -0.057942742592451],
            [30.811767619110014, -0.069099038996339],
            [30.811912524551843, -0.073167363848095],
            [30.811528448953794, -0.076765545570134],
            [30.810257188197998, -0.082171818241793],
            [30.809162597312532, -0.084721236110698],
            [30.80721584748051, -0.084947145987363],
            [30.80556356809359, -0.086239866052771],
            [30.801421867509877, -0.086890562681104],
            [30.79826029357981, -0.089503120044939],
            [30.79600528595973, -0.089828446323329],
            [30.795381132008767, -0.090461259250457],
            [30.79395441958969, -0.090379809105057],
            [30.79308162903606, -0.091130119716665],
            [30.788104751257922, -0.092739049726599],
            [30.787263891321057, -0.094402456123317],
            [30.784766525423866, -0.095532366315345],
            [30.779921056798795, -0.098560636692767],
            [30.77742499884864, -0.100980616245622],
            [30.778415734605844, -0.10715053816925],
            [30.779440953093488, -0.109344209398131],
            [30.779979033168896, -0.112699169038679],
            [30.781808127054884, -0.114658165340268],
            [30.777225307852568, -0.114516230910921],
            [30.770732397268347, -0.112704344223013],
            [30.769004891162925, -0.111189422829639],
            [30.759945183893223, -0.106614310454639],
            [30.755441680540592, -0.106080609687294],
            [30.75469230054068, -0.103865667053222],
            [30.7514889073392, -0.100852951468747],
            [30.74879581201633, -0.102528800009129],
            [30.746636859452956, -0.104809253168175],
            [30.74363328750327, -0.103718787355372],
            [30.7405885143231, -0.10335794906795],
            [30.738904971767663, -0.102672639818443],
            [30.730630366005116, -0.102311442193642],
            [30.72672581436818, -0.103537280354149],
            [30.72522048049713, -0.104584090818111],
            [30.71818511863533, -0.107677605769683],
            [30.71388806160972, -0.10491539073784],
            [30.71325201576101, -0.10055105871075],
            [30.71154189924284, -0.099770175088719],
            [30.710746538076798, -0.098869235382631],
            [30.7094142260177, -0.098468749954821],
            [30.709056338106805, -0.097687965996527],
            [30.71013021294354, -0.096907274546428],
            [30.708413344687678, -0.095275143971778],
            [30.710154092858716, -0.091817339914662],
            [30.71040416946079, -0.090037143571387],
            [30.70979318121859, -0.089216899177223],
            [30.709876553860138, -0.088415335208879],
            [30.70778427156221, -0.087501804438679],
            [30.707960217390383, -0.086793455808741],
            [30.70693258153627, -0.086476498199502],
            [30.70634016326764, -0.084761493167825],
            [30.70532181868855, -0.083950553398709],
            [30.705534788581154, -0.08336337473074],
            [30.70434052242835, -0.08285999890096],
            [30.7047439594157, -0.081206921707854],
            [30.703248233026606, -0.081063082710464],
            [30.702089787195796, -0.080177093189112],
            [30.701691080736726, -0.07933635264443],
            [30.699749170129135, -0.078423207040368],
            [30.699994776714355, -0.077040098321419],
            [30.699088182556586, -0.075673965006724],
            [30.6990412581594, -0.071625083500651],
            [30.698585267032954, -0.071889584143786],
            [30.69794955086595, -0.071525592465615],
            [30.69825420820637, -0.070339373431866],
            [30.703568169811696, -0.066569160350692],
            [30.705833349954037, -0.065629922040537],
            [30.711991116173706, -0.066439200267785],
            [30.713843718970693, -0.062054249442662],
            [30.713982338900497, -0.054256318945548],
            [30.71610062832419, -0.054372729774274],
            [30.718667055802108, -0.053452471750126],
            [30.719810712668437, -0.051205416954279],
            [30.72240393958623, -0.047650974242768],
            [30.71947024578585, -0.039934167039372],
            [30.71788937976909, -0.033403223127076],
            [30.72274608631838, -0.033732213975445],
            [30.729214535777405, -0.030794287779551],
            [30.73149312147873, -0.030438440891799],
            [30.73180724975715, -0.028387908067015],
            [30.735243232057044, -0.025331325072001],
            [30.736689984093513, -0.022667557282124],
            [30.736690002059785, -0.021354819609945],
            [30.739891096472462, -0.013125794744558],
            [30.739815706260554, -0.009906907466486],
            [30.740358659696383, -0.007128341966886],
            [30.741391761798997, -0.00446364869222],
            [30.746760760486854, -0.005362741015747],
            [30.749597081401976, -0.00482534186543],
            [30.753054857728987, -0.003237207583701],
            [30.755062607660346, -0.001175824638243],
            [30.75603625835915, -0.002677001105266],
            [30.758220706906908, -0.01056542915309],
            [30.759787814326796, -0.013051489699451],
            [30.76050012893977, -0.015011648624804],
            [30.76235217478126, -0.017019635632846],
            [30.76984953660039, -0.019765852688314],
            [30.772759082787587, -0.020213878425829],
            [30.773302164682505, -0.018750920866273],
            [30.77577294044728, -0.016364265253563],
            [30.77637292792049, -0.015089554116829],
            [30.77651423471131, -0.012775189484622],
            [30.77857909324025, -0.009403102617885],
            [30.778896776152283, -0.004711081551579],
            [30.781049868106727, -0.001266641618483],
            [30.783157800853512, 0.006609808337482],
            [30.781864627492986, 0.007358017826978],
            [30.777319169223354, 0.012031923435978],
            [30.773753557333006, 0.022753890764057],
            [30.772840517763065, 0.0245167660871],
            [30.770585390667073, 0.026568907860855],
            [30.76897217721523, 0.029127321165722],
            [30.769573503178183, 0.036920201361742],
            [30.768079661454568, 0.040075274369811],
            [30.767866912547515, 0.041322848033437],
            [30.765670714035853, 0.042931977308968],
            [30.76415206533566, 0.044920821610587],
            [30.762125789448163, 0.050435401158585],
            [30.762127140514362, 0.051845703490537],
            [30.76075184317059, 0.054783779797203],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 157,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "KAZO",
        Population: 28824,
        Key: "KIRUHURAKAZO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.184183677590358, -0.286447543352108],
            [30.183790563143955, -0.286061013889235],
            [30.18285793760586, -0.286060785719982],
            [30.182448767570364, -0.284601834686991],
            [30.18071758376216, -0.284567334415773],
            [30.179605407456645, -0.283989004357765],
            [30.1784930757426, -0.284388351793151],
            [30.178163927632607, -0.286192706166058],
            [30.17716274357037, -0.286976248277784],
            [30.1761564813318, -0.288752908432892],
            [30.175938900386864, -0.290780875065685],
            [30.175274505504394, -0.290934326000221],
            [30.17475727892, -0.293380864852983],
            [30.174073759803456, -0.294286043939001],
            [30.174057144563974, -0.295197863210015],
            [30.173304855819193, -0.29596086588945],
            [30.172786465916495, -0.298204932405735],
            [30.170860040467804, -0.29913968682704],
            [30.170087067115258, -0.300737346515904],
            [30.170147593802493, -0.302198369626068],
            [30.169300611846943, -0.303025082142929],
            [30.168958053686417, -0.304480408808188],
            [30.17015623110395, -0.306095853201041],
            [30.170367520248654, -0.308633629227022],
            [30.169779156975217, -0.309697425648803],
            [30.168398167905796, -0.310730978827947],
            [30.16786990012825, -0.310143089511083],
            [30.16825368018055, -0.309203654989996],
            [30.167517136207735, -0.309180641385821],
            [30.16675768789012, -0.310026958808495],
            [30.167149639018255, -0.31042175450404],
            [30.16659973891034, -0.311069415925342],
            [30.16774582661781, -0.312000681122473],
            [30.167562195702377, -0.313459273685035],
            [30.166645722771424, -0.314420012849216],
            [30.166389806221716, -0.315273677059621],
            [30.166981608246044, -0.317290195264869],
            [30.16647014076095, -0.31762897530096],
            [30.166989857475325, -0.318302666355622],
            [30.166887346226645, -0.319173532716994],
            [30.166282186254044, -0.319289199794231],
            [30.16628625741893, -0.319988490530016],
            [30.167807254315264, -0.321263077553136],
            [30.168373677136195, -0.322554563256658],
            [30.166851877145987, -0.324205836280279],
            [30.16819415152163, -0.324532260857127],
            [30.168509327235665, -0.325158708019921],
            [30.17064938373702, -0.323724125104531],
            [30.17115602457412, -0.324009692276244],
            [30.17069522027442, -0.326051668400313],
            [30.16962508063262, -0.327874673466054],
            [30.16790326715114, -0.328504835791513],
            [30.167473322676397, -0.328966985347172],
            [30.16762593296843, -0.329714572535691],
            [30.1671102263335, -0.329954672961318],
            [30.167267621951037, -0.330950026572159],
            [30.165392129182344, -0.332523963552349],
            [30.164872241788053, -0.332485202798864],
            [30.164279483956246, -0.33394367115134],
            [30.164287518488152, -0.335655427515027],
            [30.164449232307305, -0.336431985263665],
            [30.16550772618974, -0.337658461747801],
            [30.166695095077763, -0.337888328549705],
            [30.16755026427879, -0.337142635597631],
            [30.167720950470986, -0.338204217417821],
            [30.169031464909747, -0.339648666952696],
            [30.16938936899029, -0.34075908993486],
            [30.168817199646494, -0.343694727423952],
            [30.16910549956387, -0.345736751548969],
            [30.16967649121634, -0.34662570273807],
            [30.170810263919574, -0.346896160753912],
            [30.170931276869833, -0.347445149773416],
            [30.170437693943718, -0.34821179204572],
            [30.17091350370193, -0.34900486759088],
            [30.17158862087562, -0.349013784102944],
            [30.171953106912234, -0.350436344059295],
            [30.172920739796943, -0.351732812354973],
            [30.17214148632226, -0.352630072236096],
            [30.1704130019515, -0.352951848959205],
            [30.168510307297662, -0.354908860636993],
            [30.168557150846475, -0.355992401156003],
            [30.168972513867526, -0.356433985550819],
            [30.171196781138566, -0.356838424409607],
            [30.170313705773236, -0.357587515864717],
            [30.16887687203586, -0.357726489717983],
            [30.16919683397376, -0.358667648825145],
            [30.168789801030325, -0.359425599141766],
            [30.169092441652896, -0.36039289493852],
            [30.170544127236887, -0.360854942337493],
            [30.172354768828622, -0.362833701004445],
            [30.174692318148526, -0.36458717890558],
            [30.17437933162882, -0.365422261000867],
            [30.17315992791944, -0.364932692708134],
            [30.173063659063693, -0.365587404820707],
            [30.17385983140845, -0.365988479150057],
            [30.172872988051406, -0.366397704607702],
            [30.17284680755076, -0.367086067711605],
            [30.17491494313384, -0.368707444865627],
            [30.175502860842887, -0.370781460753118],
            [30.176922039989975, -0.371766548781133],
            [30.176878633395457, -0.372176073105623],
            [30.17545037228085, -0.372541585384217],
            [30.17537236347987, -0.372890103679016],
            [30.176388322133604, -0.37339710656483],
            [30.177500974546216, -0.37486005637596],
            [30.177145926209942, -0.375408898182627],
            [30.175025451185146, -0.375077097277055],
            [30.17480017167818, -0.375826392019003],
            [30.176400765596927, -0.377892026924759],
            [30.176900784952053, -0.379642885104914],
            [30.178730027958352, -0.380828341425837],
            [30.17892511239368, -0.381717171481892],
            [30.179724193483302, -0.385097679886481],
            [30.18172736200673, -0.386429687768093],
            [30.180475898323166, -0.387698264156105],
            [30.178632293950404, -0.387527154281476],
            [30.178575293150683, -0.389203255315896],
            [30.1771920744627, -0.390651691388244],
            [30.176862443059107, -0.391793590580928],
            [30.174933774517125, -0.392806251138008],
            [30.17111450354338, -0.393770855534725],
            [30.171847331185866, -0.396229388125102],
            [30.171536825812943, -0.396541735654255],
            [30.170878435269874, -0.396446868645271],
            [30.170144980603304, -0.395565884939596],
            [30.16827306492605, -0.395622067831553],
            [30.167849680847816, -0.396067026908275],
            [30.167990497158492, -0.397014008200439],
            [30.166654530752798, -0.397704821193268],
            [30.164980368405555, -0.397060379020333],
            [30.16405847234522, -0.397344166168812],
            [30.163051700761905, -0.398309706958251],
            [30.162478186640115, -0.397523524873291],
            [30.162111304796614, -0.397580145220981],
            [30.160154730988676, -0.400085101379554],
            [30.15961693657754, -0.402576329956362],
            [30.16016182498448, -0.404555718583422],
            [30.15986044290158, -0.405417267656552],
            [30.159211427176817, -0.405521259419657],
            [30.157978838894003, -0.406581416409602],
            [30.156530305498354, -0.406448240927503],
            [30.156106735468853, -0.407215173538746],
            [30.156219235983453, -0.408323138329864],
            [30.15566391184786, -0.409298239240858],
            [30.15485464476122, -0.410226033268159],
            [30.15424863049078, -0.410227344774872],
            [30.153914185913866, -0.411796333320752],
            [30.154162753346252, -0.412422653078052],
            [30.1536318058942, -0.413725162016031],
            [30.15482945689897, -0.416017898959278],
            [30.15471107870746, -0.4173231587722],
            [30.153977374309267, -0.418113964225613],
            [30.152654534086494, -0.418100340738775],
            [30.152457467069343, -0.419797878580804],
            [30.152928853523107, -0.420252963654863],
            [30.152993915804185, -0.421357178952937],
            [30.152057207423155, -0.421956751337583],
            [30.152109085130796, -0.423367625798152],
            [30.151781452478712, -0.424043941695803],
            [30.151165875642068, -0.424116184926954],
            [30.15135550460862, -0.424861245141565],
            [30.150864119860007, -0.425424069986644],
            [30.1518853309632, -0.426466104887043],
            [30.150822182010977, -0.432536132779045],
            [30.149819471711073, -0.434586077176151],
            [30.1499497885127, -0.436391167139615],
            [30.150663115527003, -0.437584688909339],
            [30.150917935233753, -0.439250103214728],
            [30.150642054525154, -0.441495405590626],
            [30.150006539580765, -0.442339019821468],
            [30.151721515086308, -0.444236352237975],
            [30.150987623838553, -0.445528237995362],
            [30.150829807809437, -0.447016106602794],
            [30.15147775992891, -0.448077825385591],
            [30.150115291425713, -0.448973809036652],
            [30.150029602927376, -0.450331877989663],
            [30.149728533458237, -0.449896602869434],
            [30.149145645416436, -0.450252384931935],
            [30.148569445331965, -0.449975346759199],
            [30.148555008507042, -0.453340800165514],
            [30.146577901906642, -0.451836932552156],
            [30.14447754375431, -0.451806560558467],
            [30.140964214711826, -0.450121709244729],
            [30.140179133865875, -0.450507487811337],
            [30.137797831201734, -0.450650224797844],
            [30.136941376511523, -0.451337603341596],
            [30.136120794245574, -0.451319353734504],
            [30.134728763983002, -0.452997768542807],
            [30.136849812132912, -0.457349636386453],
            [30.139239676640084, -0.458203561114181],
            [30.140238199892455, -0.459236532193418],
            [30.14059439537732, -0.460727087454501],
            [30.1402186372805, -0.463606459877374],
            [30.14381227930268, -0.465205130987728],
            [30.14444529333728, -0.465842886838845],
            [30.145755760165333, -0.467376126334155],
            [30.145246936422122, -0.468471343651579],
            [30.145398189359778, -0.4692974588255],
            [30.146004452463547, -0.469854346191114],
            [30.145226008370944, -0.471267446390723],
            [30.14550007897423, -0.472048200546514],
            [30.146288585096354, -0.472849770565895],
            [30.1485283536959, -0.473922736515433],
            [30.147277732632084, -0.475145131011228],
            [30.146369410115696, -0.476779703000083],
            [30.14652121372064, -0.47723879806466],
            [30.14705305948796, -0.477545040182526],
            [30.150937821239204, -0.476865024726046],
            [30.15197438275397, -0.476131729267892],
            [30.152998443313223, -0.473522525583162],
            [30.155242325298516, -0.470477114632774],
            [30.159467783002704, -0.467293321487485],
            [30.161081559698232, -0.46502081084956],
            [30.163334308953672, -0.464149549125295],
            [30.167477789099966, -0.463524079875669],
            [30.169433001960275, -0.462856181829612],
            [30.17255413732951, -0.461086323791078],
            [30.178913057002564, -0.456227319633668],
            [30.182307666493738, -0.454168358846733],
            [30.18425992928665, -0.454696954950929],
            [30.186687464645207, -0.453020588631012],
            [30.18911348364759, -0.452285862421539],
            [30.191012562582408, -0.449364353978203],
            [30.19131771130128, -0.44761725614132],
            [30.194159178664677, -0.443915623789258],
            [30.19765566609224, -0.442096102841161],
            [30.198413317779256, -0.441180216769492],
            [30.19934165026862, -0.434455642852953],
            [30.201438825689873, -0.428872095399137],
            [30.202066549545798, -0.420618478302999],
            [30.203771675024264, -0.414822773091785],
            [30.208381147241063, -0.414354502576626],
            [30.209109639613967, -0.413514361657914],
            [30.209874765284166, -0.413406192042845],
            [30.210365446651924, -0.414816066445631],
            [30.2109155677454, -0.415096393649432],
            [30.213345499809172, -0.415449677398123],
            [30.215409390852535, -0.41493532006312],
            [30.21577936290062, -0.414162546600938],
            [30.217944221886974, -0.413478517116605],
            [30.217877904659417, -0.412921531209049],
            [30.21625521398133, -0.411312323650761],
            [30.216111756623718, -0.41045137706454],
            [30.217495043583646, -0.409431073324676],
            [30.21847238456163, -0.406837145056729],
            [30.21790494933937, -0.40621986348446],
            [30.21707282102706, -0.406858443575144],
            [30.2155005069718, -0.406454915242129],
            [30.215579388935218, -0.407179803267703],
            [30.21434026001881, -0.406784465583097],
            [30.21380860020275, -0.404955006170614],
            [30.21001898620977, -0.400841929689475],
            [30.210041727061196, -0.40031944725578],
            [30.210854030453497, -0.400478742513677],
            [30.211937440008658, -0.399684016068897],
            [30.211905689054912, -0.398763182611261],
            [30.212100549809733, -0.397137888293026],
            [30.212782658571275, -0.396679342580816],
            [30.212612114312883, -0.395309282798648],
            [30.214406982386553, -0.397174813553999],
            [30.2162935801288, -0.3981652972815],
            [30.217405062934887, -0.398203927499091],
            [30.21892443477891, -0.400069374957268],
            [30.22055845860261, -0.399993419759737],
            [30.221707564649435, -0.40117015527541],
            [30.22389214704616, -0.402423756666806],
            [30.22443409796213, -0.401085006954711],
            [30.225612152218986, -0.400932385129486],
            [30.225061454407115, -0.400023635654548],
            [30.224215898077922, -0.400185934811212],
            [30.224073496240774, -0.399889408163625],
            [30.224795819882637, -0.398923706764846],
            [30.2247868475096, -0.397336110271061],
            [30.225147927134678, -0.397097135402421],
            [30.22645881437427, -0.397451437704807],
            [30.227398998337172, -0.398417701608005],
            [30.227284832346022, -0.398914983436539],
            [30.228766748934234, -0.399192833699568],
            [30.231313173625747, -0.397969515987113],
            [30.232964874497597, -0.39804012994955],
            [30.232556081754517, -0.39677070803811],
            [30.235216733522584, -0.395952672307461],
            [30.234751548139247, -0.394976999385701],
            [30.23522673895822, -0.394412886942066],
            [30.23611975238554, -0.39440362014117],
            [30.236898422853606, -0.395436781244523],
            [30.237601375224667, -0.395609165636712],
            [30.239824661535437, -0.39483522794014],
            [30.24111661228885, -0.395046062918359],
            [30.24239941549771, -0.394185732640301],
            [30.243140174365845, -0.394960659418947],
            [30.244736844443413, -0.393000572826168],
            [30.24570586612354, -0.392991329379344],
            [30.24609564782025, -0.392149827136715],
            [30.24741644437576, -0.391318193471042],
            [30.24727436862705, -0.389998314233191],
            [30.247987090176842, -0.389357759283696],
            [30.24799698781466, -0.388124006435794],
            [30.249526941812693, -0.38529942346524],
            [30.248834961464514, -0.384862906893523],
            [30.248854562704018, -0.384244287023791],
            [30.24814959990332, -0.383951026012642],
            [30.247788019018326, -0.381899677247563],
            [30.248849115320116, -0.381020917102021],
            [30.2473683036597, -0.379581325807982],
            [30.248248788283735, -0.377081055368875],
            [30.249031323304152, -0.377537132725741],
            [30.249413036333, -0.377289802249572],
            [30.250285104641122, -0.374567367261368],
            [30.24986722004905, -0.373578696243055],
            [30.247781373281832, -0.37147466533551],
            [30.24741668063269, -0.369240910911575],
            [30.246077452444176, -0.367651893199923],
            [30.24608836068669, -0.366607043718644],
            [30.24531901922285, -0.365520240950564],
            [30.245035356408955, -0.364090547256959],
            [30.245009530742834, -0.361926203326416],
            [30.246876161631295, -0.352848273374991],
            [30.245901893789885, -0.352618757271083],
            [30.2448807114328, -0.35113261339003],
            [30.243683602112107, -0.351125457544829],
            [30.24264474180854, -0.349857881140936],
            [30.24129073274035, -0.349072372036933],
            [30.24165640365486, -0.347992455349244],
            [30.24114315840381, -0.347245819969732],
            [30.238700964336413, -0.346829478235705],
            [30.237181155911173, -0.345479426630783],
            [30.236368673754146, -0.345548554328213],
            [30.23585296352596, -0.344729048739531],
            [30.232990480974795, -0.342460363741123],
            [30.231304808513805, -0.341662470969067],
            [30.23011145594765, -0.339518870758737],
            [30.228224658779414, -0.338230553766466],
            [30.227577916690606, -0.338223052964529],
            [30.22646640244348, -0.337147339993351],
            [30.223872467653248, -0.336078523151112],
            [30.222890753676463, -0.336356001676672],
            [30.22222257598835, -0.337285126595043],
            [30.221619700431496, -0.336348559262796],
            [30.222208488608064, -0.335697639524116],
            [30.22158371481954, -0.335104899034875],
            [30.219723371239763, -0.335316524120903],
            [30.219853836263415, -0.336516315851728],
            [30.218698637842348, -0.335762482401364],
            [30.21780482132116, -0.335798806952731],
            [30.21792131574552, -0.334986812119922],
            [30.21712948316194, -0.334130666672778],
            [30.217057146323672, -0.332945525925034],
            [30.21621628189522, -0.332117755806866],
            [30.215189955784815, -0.331679408659014],
            [30.21433543247247, -0.330708049621202],
            [30.211639636813853, -0.330458969803574],
            [30.21020270605843, -0.329243322332804],
            [30.20891754746687, -0.328896575657188],
            [30.20810493056255, -0.329199113374238],
            [30.206831762683418, -0.32844777035257],
            [30.205614668542633, -0.328842535696544],
            [30.205356421763057, -0.327806691874857],
            [30.204048144129366, -0.327025514387434],
            [30.2032250097497, -0.327211193130442],
            [30.2019266782628, -0.328644973366427],
            [30.200000812464538, -0.328888768527674],
            [30.196755548787642, -0.330444161322418],
            [30.196164821148376, -0.329726926861235],
            [30.195568632650524, -0.329671475675113],
            [30.1922438501047, -0.332610017113664],
            [30.192027614836007, -0.332307193841146],
            [30.192803623595882, -0.330809545878985],
            [30.190229128348395, -0.329911160188686],
            [30.18969654506423, -0.32881682453993],
            [30.18842518908701, -0.328147208873998],
            [30.187517269015892, -0.32599496316602],
            [30.186600249010908, -0.326011446984663],
            [30.186004241074404, -0.325320776757337],
            [30.185033436238438, -0.325336441326771],
            [30.184717160088155, -0.324284665777424],
            [30.185302742177452, -0.324513224963316],
            [30.18641087606419, -0.323950506821613],
            [30.187671865483004, -0.323940232953923],
            [30.189496374367764, -0.321772817636995],
            [30.188473742129794, -0.319279066056853],
            [30.18851119648728, -0.318810994456789],
            [30.18895167550538, -0.318729752978198],
            [30.189081323062105, -0.317468686875047],
            [30.188135816581166, -0.317232482985888],
            [30.187339997274336, -0.31647470274919],
            [30.186883305461986, -0.316613798459932],
            [30.186604825028958, -0.315340419976277],
            [30.187465681464044, -0.314783328294006],
            [30.18741132350791, -0.313795426313106],
            [30.18816097479901, -0.313807179693983],
            [30.18850053887475, -0.313319102664912],
            [30.18865031138878, -0.312334670686209],
            [30.188173707519873, -0.311492454197099],
            [30.188925362054064, -0.311309592245394],
            [30.189394294310464, -0.310589668724424],
            [30.18844066166948, -0.309961460006571],
            [30.188881576370477, -0.308771106300966],
            [30.18983909332677, -0.309442591695419],
            [30.190251470347842, -0.308653494282975],
            [30.19103536182431, -0.308816423852242],
            [30.189977152707822, -0.306867539007273],
            [30.189989853089322, -0.304630103748969],
            [30.189153073300478, -0.304352684550618],
            [30.189448563333418, -0.303889573612943],
            [30.19063665267031, -0.303629525772589],
            [30.190071012281987, -0.303295797342326],
            [30.19022468528102, -0.302832076411844],
            [30.18966708750944, -0.302652937776925],
            [30.190330419684884, -0.301006061251784],
            [30.19114767998093, -0.300839601233958],
            [30.190785159458137, -0.299669267897379],
            [30.190140680225515, -0.29912653656882],
            [30.188840806331307, -0.299431176278554],
            [30.187868811227585, -0.298594030597428],
            [30.186625285057882, -0.2989518759138],
            [30.18624139630943, -0.298710638422027],
            [30.1863405245027, -0.297708271380689],
            [30.185533874208506, -0.296735242831976],
            [30.185854676071195, -0.295714027411121],
            [30.185259664366342, -0.294564919541954],
            [30.185084505462324, -0.290660547282366],
            [30.183823453161445, -0.290692148709042],
            [30.184183677590358, -0.286447543352108],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 158,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "BITOOMA",
        Population: 13411,
        Key: "BUSHENYIBITOOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.225629088157035, -0.574982543348253],
            [30.224399930540297, -0.575424193970463],
            [30.221823731188724, -0.575233166974786],
            [30.221753641935322, -0.573127786063844],
            [30.22065460888074, -0.571663007869374],
            [30.220015798915902, -0.569889160360398],
            [30.21732926758279, -0.568071526079004],
            [30.215928165234157, -0.56767493307293],
            [30.20998476309242, -0.570407771621834],
            [30.208128040621542, -0.570624852222787],
            [30.206083899039708, -0.567534900676664],
            [30.203713848672777, -0.565427649443277],
            [30.20250683183287, -0.561729691594191],
            [30.201473199724237, -0.560072899412745],
            [30.198187284585796, -0.562200200219548],
            [30.193789598282063, -0.564220092105213],
            [30.18957607020483, -0.565092820513057],
            [30.18232145473502, -0.565757824409622],
            [30.179043489686855, -0.566796251311232],
            [30.17815244267172, -0.567692388278726],
            [30.176654754362033, -0.570704130902389],
            [30.17444553027876, -0.571743062640405],
            [30.171586115474287, -0.575053058445065],
            [30.171760819830727, -0.578219764866595],
            [30.1674064098658, -0.580674351426824],
            [30.165539298378693, -0.58347118988417],
            [30.16507813565119, -0.585056447085587],
            [30.165222674580402, -0.586739578242783],
            [30.164713252559192, -0.587910137438009],
            [30.165503694550733, -0.591004013184325],
            [30.16516548693108, -0.592664218766227],
            [30.1620456352544, -0.592482291803694],
            [30.161395116648162, -0.593215670378387],
            [30.160785650152075, -0.592962098542598],
            [30.159779227115063, -0.595586566030789],
            [30.16155075246605, -0.598560363539551],
            [30.160361378538305, -0.60088984144057],
            [30.159942436629148, -0.605354092597106],
            [30.159509816971486, -0.606431934312509],
            [30.159831971696974, -0.610051523224782],
            [30.159538406753708, -0.610781467170323],
            [30.158519741476024, -0.611215874028475],
            [30.158287993200723, -0.611743911408865],
            [30.159490194172392, -0.614428822077035],
            [30.159473107317403, -0.617582210655419],
            [30.158870955802644, -0.61822500050475],
            [30.158746301980578, -0.620508427653544],
            [30.15910086881984, -0.621145513181157],
            [30.160319940152565, -0.6210995616647],
            [30.161012856545284, -0.623851017145531],
            [30.161336654289457, -0.624340510646633],
            [30.162925803671456, -0.624776320379624],
            [30.163203210617723, -0.625459982958465],
            [30.16291578206617, -0.627186994208074],
            [30.160158741068116, -0.627593355103032],
            [30.160948815648702, -0.628177207011571],
            [30.161981001469705, -0.631310975636652],
            [30.16301440989783, -0.632181455807486],
            [30.163630984762776, -0.633424515391427],
            [30.165513484390697, -0.633580889947023],
            [30.167380167381424, -0.634451822460093],
            [30.169895324412796, -0.634655152637266],
            [30.17253421000156, -0.634361452990831],
            [30.17505060041982, -0.632296774502492],
            [30.178423161660664, -0.632570611030741],
            [30.178798592770743, -0.635412301472746],
            [30.18020535989557, -0.636177877671749],
            [30.183126512316235, -0.632283847634441],
            [30.185745310676932, -0.630315348711117],
            [30.19033256126853, -0.629233466970928],
            [30.195875286047496, -0.630212392737553],
            [30.19939550426988, -0.628578693864141],
            [30.202668224953428, -0.626312295865569],
            [30.205118172380033, -0.625147898967608],
            [30.20707391434803, -0.622528352182225],
            [30.20793013547626, -0.62210409122201],
            [30.211161124024947, -0.621870854707303],
            [30.212976015546282, -0.622531485320987],
            [30.215912907349054, -0.625216907032713],
            [30.218143354130923, -0.625959093997411],
            [30.221472225807936, -0.624749956393477],
            [30.227135995876495, -0.620456944630411],
            [30.226011756095026, -0.619917748097295],
            [30.222674611832577, -0.614434127222029],
            [30.222160628166375, -0.612225801322718],
            [30.220957365386003, -0.610373497992323],
            [30.220609677845182, -0.607805833100235],
            [30.216892030584575, -0.598087044567455],
            [30.218884968195194, -0.597123670897709],
            [30.22070276846143, -0.596772164832747],
            [30.2245747202367, -0.596620502403348],
            [30.228145200097583, -0.59596112708439],
            [30.229339435707654, -0.589750735861955],
            [30.230853783274284, -0.585809384634051],
            [30.225991402067322, -0.579397337723775],
            [30.225629088157035, -0.574982543348253],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 159,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "BUMBAIRE",
        Population: 14221,
        Key: "BUSHENYIBUMBAIRE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.143441726044607, -0.588747077020086],
            [30.142364237285484, -0.589059673328057],
            [30.14013796766968, -0.58759729044886],
            [30.13564453802464, -0.586914408176308],
            [30.132940897378642, -0.585792076799839],
            [30.127571319277454, -0.587650874832254],
            [30.125802205004675, -0.586589076999941],
            [30.124638406113057, -0.584225246887908],
            [30.123212737536377, -0.583776709926184],
            [30.122346707703535, -0.584077441281667],
            [30.121782243209942, -0.586060836882374],
            [30.12100812540373, -0.586595059466201],
            [30.120461312805475, -0.587709845230206],
            [30.120260183606604, -0.589039888979528],
            [30.120778381269826, -0.591262973816089],
            [30.12330301552748, -0.596631587012972],
            [30.123063000954918, -0.601321071027575],
            [30.124571482522732, -0.602729327072243],
            [30.127520591413365, -0.607594334866786],
            [30.130159169778285, -0.610640843901248],
            [30.130433472146922, -0.614128854114984],
            [30.127315126046643, -0.624157011895447],
            [30.12785527673876, -0.626136169216627],
            [30.12684388242501, -0.629946997941958],
            [30.128591063431795, -0.631575397546373],
            [30.130285012071475, -0.634407809506106],
            [30.13040242277744, -0.636008848508686],
            [30.129475339844642, -0.637894681130342],
            [30.130150117455166, -0.640679315710208],
            [30.135545276880695, -0.644073464831427],
            [30.13632242829761, -0.652805937771013],
            [30.136399095913855, -0.653221876545527],
            [30.136914387527128, -0.65337554135163],
            [30.138789160745315, -0.65381033987878],
            [30.1418790311494, -0.653080189092658],
            [30.145236696526176, -0.654012815041285],
            [30.147844552508396, -0.655496214901813],
            [30.151050178921665, -0.655723948967809],
            [30.157029302570677, -0.66145626176563],
            [30.15766403777742, -0.663525899314608],
            [30.158646485677764, -0.664565621337863],
            [30.15880771710161, -0.666147039183554],
            [30.159779940377426, -0.666671697972719],
            [30.162692208459923, -0.661938429982445],
            [30.1629112653369, -0.66023975609491],
            [30.16567330905279, -0.657982287349104],
            [30.166574000380837, -0.65477495081382],
            [30.167814901673292, -0.652896121872477],
            [30.170075303676636, -0.651541964288768],
            [30.17154885425461, -0.651235562459647],
            [30.173731851124863, -0.648083138408326],
            [30.17433236770577, -0.645896699360779],
            [30.17504709699024, -0.645156124041676],
            [30.17773375318915, -0.644281099980504],
            [30.18020535989557, -0.636177877671749],
            [30.178798592770743, -0.635412301472746],
            [30.178423161660664, -0.632570611030741],
            [30.17505060041982, -0.632296774502492],
            [30.17253421000156, -0.634361452990831],
            [30.169895324412796, -0.634655152637266],
            [30.167380167381424, -0.634451822460093],
            [30.165513484390697, -0.633580889947023],
            [30.163630984762776, -0.633424515391427],
            [30.16301440989783, -0.632181455807486],
            [30.161981001469705, -0.631310975636652],
            [30.160948815648702, -0.628177207011571],
            [30.160158741068116, -0.627593355103032],
            [30.16291578206617, -0.627186994208074],
            [30.163203210617723, -0.625459982958465],
            [30.162925803671456, -0.624776320379624],
            [30.161336654289457, -0.624340510646633],
            [30.161012856545284, -0.623851017145531],
            [30.160319940152565, -0.6210995616647],
            [30.15910086881984, -0.621145513181157],
            [30.158746301980578, -0.620508427653544],
            [30.158870955802644, -0.61822500050475],
            [30.159473107317403, -0.617582210655419],
            [30.159490194172392, -0.614428822077035],
            [30.158287993200723, -0.611743911408865],
            [30.158519741476024, -0.611215874028475],
            [30.159538406753708, -0.610781467170323],
            [30.159831971696974, -0.610051523224782],
            [30.159509816971486, -0.606431934312509],
            [30.159942436629148, -0.605354092597106],
            [30.160361378538305, -0.60088984144057],
            [30.16155075246605, -0.598560363539551],
            [30.159779227115063, -0.595586566030789],
            [30.158820209073944, -0.595786222879622],
            [30.157501754426374, -0.594443543030266],
            [30.155701955500138, -0.593909611340616],
            [30.150859188109106, -0.594646481289469],
            [30.146848601132653, -0.59191045394108],
            [30.14630656487676, -0.590245636427765],
            [30.143441726044607, -0.588747077020086],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 160,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "IBAARE",
        Population: 11584,
        Key: "BUSHENYIIBAARE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.215409390852535, -0.41493532006312],
            [30.213345499809172, -0.415449677398123],
            [30.2109155677454, -0.415096393649432],
            [30.210365446651924, -0.414816066445631],
            [30.209874765284166, -0.413406192042845],
            [30.209109639613967, -0.413514361657914],
            [30.208381147241063, -0.414354502576626],
            [30.203771675024264, -0.414822773091785],
            [30.202066549545798, -0.420618478302999],
            [30.201438825689873, -0.428872095399137],
            [30.19934165026862, -0.434455642852953],
            [30.198413317779256, -0.441180216769492],
            [30.19765566609224, -0.442096102841161],
            [30.194159178664677, -0.443915623789258],
            [30.19131771130128, -0.44761725614132],
            [30.191012562582408, -0.449364353978203],
            [30.18911348364759, -0.452285862421539],
            [30.186687464645207, -0.453020588631012],
            [30.18425992928665, -0.454696954950929],
            [30.182307666493738, -0.454168358846733],
            [30.178913057002564, -0.456227319633668],
            [30.17255413732951, -0.461086323791078],
            [30.169433001960275, -0.462856181829612],
            [30.167477789099966, -0.463524079875669],
            [30.163334308953672, -0.464149549125295],
            [30.161081559698232, -0.46502081084956],
            [30.159467783002704, -0.467293321487485],
            [30.155242325298516, -0.470477114632774],
            [30.152998443313223, -0.473522525583162],
            [30.15197438275397, -0.476131729267892],
            [30.150937821239204, -0.476865024726046],
            [30.149897671853164, -0.478732058716578],
            [30.14893731083069, -0.484782486052594],
            [30.148422313864828, -0.485817764466279],
            [30.149039170800766, -0.487281193061102],
            [30.14679744207722, -0.490714273631801],
            [30.145578695036313, -0.493581848044971],
            [30.143980925420834, -0.497932392291207],
            [30.14378031904148, -0.500533480438954],
            [30.14260986273531, -0.505199780013908],
            [30.14060359951575, -0.509483172819973],
            [30.139645642384973, -0.513949807235031],
            [30.13875208278195, -0.514346591492976],
            [30.138489352510792, -0.514872935408036],
            [30.138722001796346, -0.51649951727991],
            [30.142116619372363, -0.517007064534914],
            [30.142854107474527, -0.516555596824174],
            [30.14441206285832, -0.516441680701839],
            [30.147316356596054, -0.518715970387867],
            [30.157244489505423, -0.52012992431993],
            [30.1570173181465, -0.524707745438773],
            [30.157471262012397, -0.525733418497557],
            [30.164023217961905, -0.521076299031765],
            [30.16738718232546, -0.519854513993104],
            [30.17265205459379, -0.516712164118153],
            [30.17351768737125, -0.514541651895686],
            [30.1736438099388, -0.511998492220595],
            [30.1744257098503, -0.510687883552457],
            [30.17566570743758, -0.510017231560427],
            [30.177432388174253, -0.505418150170132],
            [30.178732244102157, -0.506417997187598],
            [30.180677602443808, -0.506728584743931],
            [30.181629871442198, -0.508177907507031],
            [30.181023259792088, -0.510772695518701],
            [30.181578882168346, -0.51133251591025],
            [30.181806676958086, -0.512471765985067],
            [30.18159796507992, -0.513084207427868],
            [30.18018827932876, -0.513563236386912],
            [30.183105276142914, -0.518157031855737],
            [30.187617380864385, -0.518099593230184],
            [30.18852727812748, -0.516909241982391],
            [30.19033695403027, -0.516081895781754],
            [30.18878562192508, -0.514804756030521],
            [30.189627236446803, -0.513970756002911],
            [30.189875805675786, -0.512841177967994],
            [30.19272348039783, -0.510469014130795],
            [30.19348000559749, -0.509125643089406],
            [30.192701130313544, -0.507433222605406],
            [30.193198002870233, -0.50568549815412],
            [30.19397795882748, -0.504793963881232],
            [30.195738467239835, -0.50354617680273],
            [30.19953007998429, -0.503571621498743],
            [30.20093598472643, -0.502918182522573],
            [30.202341396293505, -0.503406322597562],
            [30.20261345467056, -0.502538393033755],
            [30.204858171190725, -0.501481050953548],
            [30.206335615965482, -0.499198566458955],
            [30.20722093801732, -0.500614001449555],
            [30.20942736025524, -0.506353625530212],
            [30.21015949799157, -0.506865266152174],
            [30.212982444788775, -0.507139983566363],
            [30.215051619722626, -0.502283295673696],
            [30.215217739778243, -0.500499695191936],
            [30.213694676756752, -0.498850910071044],
            [30.212597271449443, -0.496186813991225],
            [30.214415977217488, -0.49703187414784],
            [30.214935987680946, -0.496342385582942],
            [30.216199945133475, -0.496212114990708],
            [30.216684436210603, -0.495736672490864],
            [30.216791332136147, -0.494293070826553],
            [30.216342832959192, -0.493448641813047],
            [30.218186372653257, -0.491404065501628],
            [30.21834074454157, -0.489375494162339],
            [30.21997103227201, -0.488971905696324],
            [30.222275151686972, -0.487055977391012],
            [30.222854639605423, -0.485331971210248],
            [30.22268762033621, -0.484579026717306],
            [30.22188695372011, -0.4830662925613],
            [30.222242064938442, -0.481235166844309],
            [30.220400828524763, -0.477597034661568],
            [30.220743860097464, -0.476286862959006],
            [30.222441401100003, -0.474850722785861],
            [30.221479242548636, -0.472717690376535],
            [30.222652807025693, -0.471209040804756],
            [30.221587277537964, -0.469419362407401],
            [30.221859989888532, -0.468208561074202],
            [30.22273347483988, -0.467585380117715],
            [30.22286218814873, -0.466257044094086],
            [30.221210831331632, -0.464769963665814],
            [30.221519121459046, -0.461895073264518],
            [30.22124411570952, -0.46113646432978],
            [30.2178457656335, -0.459748704555076],
            [30.2162064049187, -0.457678685072503],
            [30.216362760287133, -0.454452681967249],
            [30.21559360297796, -0.453702348164421],
            [30.215366843945738, -0.452500394983513],
            [30.21491345254373, -0.452355635090348],
            [30.2140156133667, -0.447312881171208],
            [30.213259056726017, -0.446616777177789],
            [30.21257252735496, -0.444682691910052],
            [30.212653669479614, -0.44335434717394],
            [30.213322581989623, -0.442505161873298],
            [30.21310380808197, -0.442062287667169],
            [30.214712836282906, -0.441258636470218],
            [30.213004638566197, -0.439432609463727],
            [30.213238443085185, -0.439053160560232],
            [30.214381618454507, -0.439180099561511],
            [30.214518840605724, -0.438656028819349],
            [30.21259347966063, -0.435420220622678],
            [30.213125295783577, -0.433965529820213],
            [30.2141404432586, -0.433252014829892],
            [30.213657782948022, -0.432592167191205],
            [30.214634431324907, -0.429348393957302],
            [30.21557873316504, -0.428670994289371],
            [30.215774482353652, -0.429195186992405],
            [30.21617911230372, -0.42921340790838],
            [30.218076538338412, -0.428689976058338],
            [30.21827849398734, -0.427551436339371],
            [30.21965778254592, -0.42751579038468],
            [30.220389817874338, -0.427010004434158],
            [30.220186195850562, -0.425753840514684],
            [30.219161545996478, -0.425581774767284],
            [30.218249185552875, -0.424786223504546],
            [30.21841861140871, -0.422816303417539],
            [30.217714334920927, -0.422572062630049],
            [30.2177736434926, -0.421433471704888],
            [30.216553921779603, -0.420809510677841],
            [30.21604469918439, -0.419887596309391],
            [30.21514143328473, -0.419950530587947],
            [30.21466053187547, -0.419453347078744],
            [30.21491206195169, -0.41850459519899],
            [30.216410415014657, -0.418487054264353],
            [30.215409390852535, -0.41493532006312],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 161,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "KAKANJU",
        Population: 22844,
        Key: "BUSHENYIKAKANJU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.30764961515491, -0.53661819004264],
            [30.304172719085418, -0.536770287910228],
            [30.30210137741506, -0.536136765350822],
            [30.30145647956756, -0.535368315373849],
            [30.297494848977454, -0.53485144550554],
            [30.296320595492585, -0.532447031974151],
            [30.2946524491628, -0.531581189487215],
            [30.288320257064385, -0.529341872596836],
            [30.285873320790614, -0.529251222079813],
            [30.283680601454044, -0.530053847762171],
            [30.282742544701733, -0.532748309412046],
            [30.28293688443367, -0.533868996316331],
            [30.28241847117478, -0.53513395963441],
            [30.281657270244065, -0.535088435899593],
            [30.280803603026182, -0.535756800897516],
            [30.280546144069124, -0.536877284242178],
            [30.279762864345347, -0.537283604037575],
            [30.278865033253165, -0.538855652936072],
            [30.279157331571884, -0.539208229674794],
            [30.27576856562163, -0.537534857159902],
            [30.274669997894378, -0.536296291972342],
            [30.273995885037202, -0.534063844117742],
            [30.27418734117706, -0.53119015259418],
            [30.27389840076089, -0.53021402579201],
            [30.27113203614849, -0.528125254265469],
            [30.267142533530073, -0.526460693536076],
            [30.261909450843028, -0.526142099699088],
            [30.261102221135463, -0.526503221579404],
            [30.25557396911407, -0.52669959668413],
            [30.251670837713583, -0.525875518805075],
            [30.249474125365577, -0.526371575438266],
            [30.248878846861086, -0.526887650141703],
            [30.24842151904152, -0.52881105557458],
            [30.249079084032868, -0.535128101077677],
            [30.248747368537774, -0.536700362523561],
            [30.247235335031338, -0.537675657390831],
            [30.245545379403087, -0.535036143653933],
            [30.244919364142838, -0.533311399369688],
            [30.242877440501434, -0.5314999188076],
            [30.240338124178788, -0.530662941413219],
            [30.238188860844076, -0.531350318018708],
            [30.235062103817807, -0.533610591865924],
            [30.232375849165795, -0.533756880655247],
            [30.228754425845185, -0.53231663905494],
            [30.227106328115923, -0.532922273220328],
            [30.227072375391426, -0.538895498643042],
            [30.225102658332542, -0.54151523069049],
            [30.223742562280016, -0.542147171726199],
            [30.221104057576962, -0.545617427400237],
            [30.222318189073945, -0.548988843979989],
            [30.224215413885986, -0.551029419550217],
            [30.226270947003954, -0.552116142938359],
            [30.227807295210187, -0.554032272453005],
            [30.227978956074473, -0.555884871888287],
            [30.23001120216531, -0.562148258536897],
            [30.230010148441483, -0.56438935793585],
            [30.229201853332, -0.567517982636571],
            [30.229557799085235, -0.57196377939002],
            [30.225629088157035, -0.574982543348253],
            [30.225991402067322, -0.579397337723775],
            [30.230853783274284, -0.585809384634051],
            [30.229339435707654, -0.589750735861955],
            [30.228145200097583, -0.59596112708439],
            [30.2245747202367, -0.596620502403348],
            [30.22070276846143, -0.596772164832747],
            [30.218884968195194, -0.597123670897709],
            [30.216892030584575, -0.598087044567455],
            [30.220609677845182, -0.607805833100235],
            [30.220957365386003, -0.610373497992323],
            [30.222160628166375, -0.612225801322718],
            [30.222674611832577, -0.614434127222029],
            [30.226011756095026, -0.619917748097295],
            [30.227135995876495, -0.620456944630411],
            [30.228086432311702, -0.619774251526572],
            [30.23054631600367, -0.619269487134231],
            [30.23681065295877, -0.621242777043312],
            [30.23973499439869, -0.624199333508604],
            [30.241743654323447, -0.627516889703004],
            [30.242922368842034, -0.627625953907183],
            [30.245354554778864, -0.627319987205745],
            [30.247808210450952, -0.628080376239713],
            [30.249049286914875, -0.627764741577741],
            [30.2497657122186, -0.627313277192761],
            [30.25105849032037, -0.62521740916106],
            [30.26092716553772, -0.625068954329288],
            [30.26536026881985, -0.62450194358732],
            [30.272285257377618, -0.622490298199667],
            [30.275915177862544, -0.620097363806357],
            [30.27961194558098, -0.619764898815024],
            [30.288479493329973, -0.620392045156211],
            [30.288686741852537, -0.620537723590065],
            [30.289628128659587, -0.614329687905201],
            [30.289358380749434, -0.612115449589032],
            [30.289777837393263, -0.609756967060988],
            [30.29559231422374, -0.599954546263323],
            [30.296646841145883, -0.595662398607639],
            [30.2991465417645, -0.593115131828198],
            [30.300404071771162, -0.591037184406278],
            [30.299792347808772, -0.58959996881305],
            [30.297264376309865, -0.58765573895365],
            [30.29699496167467, -0.585513791466521],
            [30.298159802612023, -0.582161548992047],
            [30.302388106179045, -0.577608807704412],
            [30.30421621281652, -0.57675113799419],
            [30.30733097463881, -0.576571871191228],
            [30.30972336341189, -0.573970262976451],
            [30.309408228122024, -0.572352438576036],
            [30.307914954133643, -0.570462943412093],
            [30.307482481799674, -0.569296930359517],
            [30.305922771107856, -0.56362983143476],
            [30.305942240295018, -0.562464032592558],
            [30.307289186808426, -0.560124000330885],
            [30.308159101854848, -0.557413214042317],
            [30.308356982745607, -0.556256532332653],
            [30.307486526015108, -0.552397214530468],
            [30.30829129703374, -0.55134925439844],
            [30.309243124959323, -0.548286042407994],
            [30.307095610644495, -0.546387245948046],
            [30.306831640698235, -0.54571836830745],
            [30.307787717655124, -0.543802892767884],
            [30.307589848442426, -0.541778453154111],
            [30.30812058389207, -0.540594804890276],
            [30.307518965078327, -0.538687670015066],
            [30.30764961515491, -0.53661819004264],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 163,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "KYEIZOOBA",
        Population: 26640,
        Key: "BUSHENYIKYEIZOOBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.305693493199577, -0.433456872465679],
            [30.304131196258012, -0.433094825825692],
            [30.30440702755928, -0.431305545875177],
            [30.303122255243306, -0.428711398481582],
            [30.301692384347696, -0.427906578983886],
            [30.299622384760408, -0.427413524527357],
            [30.297495342152562, -0.427542247728191],
            [30.29461443515493, -0.42839209226269],
            [30.285428556808593, -0.42790987211587],
            [30.280937437630485, -0.432363564141956],
            [30.280011254809608, -0.432435528824899],
            [30.278498508040848, -0.431675872137514],
            [30.275810709184896, -0.431114611674089],
            [30.273425733309526, -0.429387684266249],
            [30.268603556203097, -0.427307452612688],
            [30.26767632504831, -0.427198678639261],
            [30.26573242646904, -0.428038424633193],
            [30.2644235137264, -0.427622256645914],
            [30.26239627394665, -0.426157548416452],
            [30.26001855376384, -0.425813298361525],
            [30.257077856697492, -0.424601305891728],
            [30.24989138473021, -0.423296761436333],
            [30.24559036343924, -0.421253595221302],
            [30.24296821076931, -0.418478369583837],
            [30.24027388834777, -0.416742359427223],
            [30.235738465158153, -0.415249705093943],
            [30.23186493055133, -0.413350638078339],
            [30.230487908442193, -0.412473597912743],
            [30.228154457236574, -0.410014806128668],
            [30.22567789901632, -0.409751884057783],
            [30.22423557118266, -0.408323592865853],
            [30.222384493725045, -0.405367971144333],
            [30.220418739134892, -0.403921435744673],
            [30.217199841909938, -0.403197405297418],
            [30.216123026887274, -0.402591584769961],
            [30.211905689054912, -0.398763182611261],
            [30.211937440008658, -0.399684016068897],
            [30.210854030453497, -0.400478742513677],
            [30.210041727061196, -0.40031944725578],
            [30.21001898620977, -0.400841929689475],
            [30.21380860020275, -0.404955006170614],
            [30.21434026001881, -0.406784465583097],
            [30.215579388935218, -0.407179803267703],
            [30.2155005069718, -0.406454915242129],
            [30.21707282102706, -0.406858443575144],
            [30.21790494933937, -0.40621986348446],
            [30.21847238456163, -0.406837145056729],
            [30.217495043583646, -0.409431073324676],
            [30.216111756623718, -0.41045137706454],
            [30.21625521398133, -0.411312323650761],
            [30.217877904659417, -0.412921531209049],
            [30.217944221886974, -0.413478517116605],
            [30.21577936290062, -0.414162546600938],
            [30.215409390852535, -0.41493532006312],
            [30.216410415014657, -0.418487054264353],
            [30.21491206195169, -0.41850459519899],
            [30.21466053187547, -0.419453347078744],
            [30.21514143328473, -0.419950530587947],
            [30.21604469918439, -0.419887596309391],
            [30.216553921779603, -0.420809510677841],
            [30.2177736434926, -0.421433471704888],
            [30.217714334920927, -0.422572062630049],
            [30.21841861140871, -0.422816303417539],
            [30.218249185552875, -0.424786223504546],
            [30.219161545996478, -0.425581774767284],
            [30.220186195850562, -0.425753840514684],
            [30.220389817874338, -0.427010004434158],
            [30.21965778254592, -0.42751579038468],
            [30.21827849398734, -0.427551436339371],
            [30.218076538338412, -0.428689976058338],
            [30.21617911230372, -0.42921340790838],
            [30.215774482353652, -0.429195186992405],
            [30.21557873316504, -0.428670994289371],
            [30.214634431324907, -0.429348393957302],
            [30.213657782948022, -0.432592167191205],
            [30.2141404432586, -0.433252014829892],
            [30.213125295783577, -0.433965529820213],
            [30.21259347966063, -0.435420220622678],
            [30.214518840605724, -0.438656028819349],
            [30.214381618454507, -0.439180099561511],
            [30.213238443085185, -0.439053160560232],
            [30.213004638566197, -0.439432609463727],
            [30.214712836282906, -0.441258636470218],
            [30.21310380808197, -0.442062287667169],
            [30.213322581989623, -0.442505161873298],
            [30.212653669479614, -0.44335434717394],
            [30.21257252735496, -0.444682691910052],
            [30.213259056726017, -0.446616777177789],
            [30.2140156133667, -0.447312881171208],
            [30.21491345254373, -0.452355635090348],
            [30.215366843945738, -0.452500394983513],
            [30.21559360297796, -0.453702348164421],
            [30.216362760287133, -0.454452681967249],
            [30.2162064049187, -0.457678685072503],
            [30.2178457656335, -0.459748704555076],
            [30.22124411570952, -0.46113646432978],
            [30.221519121459046, -0.461895073264518],
            [30.221210831331632, -0.464769963665814],
            [30.22286218814873, -0.466257044094086],
            [30.22273347483988, -0.467585380117715],
            [30.221859989888532, -0.468208561074202],
            [30.221587277537964, -0.469419362407401],
            [30.222652807025693, -0.471209040804756],
            [30.221479242548636, -0.472717690376535],
            [30.222441401100003, -0.474850722785861],
            [30.220743860097464, -0.476286862959006],
            [30.220400828524763, -0.477597034661568],
            [30.222242064938442, -0.481235166844309],
            [30.22188695372011, -0.4830662925613],
            [30.22268762033621, -0.484579026717306],
            [30.223828045962442, -0.484172173603048],
            [30.22856349521973, -0.48550121761708],
            [30.23085732173818, -0.487812307235352],
            [30.2331761330996, -0.488722578381211],
            [30.235251324050918, -0.488403944059583],
            [30.237921260805784, -0.486736586636289],
            [30.24131787892993, -0.485522768325298],
            [30.242853788758325, -0.485704004110655],
            [30.24338048807737, -0.486110530157834],
            [30.24422150701605, -0.485885112334985],
            [30.245667413737817, -0.486687104724245],
            [30.2475072047622, -0.484001653397364],
            [30.250052385286995, -0.483636997105745],
            [30.25083646451139, -0.485318973054403],
            [30.25701535281835, -0.483725487889459],
            [30.25769886744331, -0.482980429247819],
            [30.257699117174973, -0.48226842915255],
            [30.255862013011605, -0.477710706222401],
            [30.254212851677014, -0.474743342762159],
            [30.255388378074667, -0.475163555722439],
            [30.255833574146326, -0.475740254278492],
            [30.257042664297938, -0.475756753066535],
            [30.26063236810587, -0.477094072813313],
            [30.265134280542146, -0.471438945144629],
            [30.26524553329684, -0.469068777879511],
            [30.267821526934213, -0.467032895967008],
            [30.27124416565889, -0.463278913398977],
            [30.277499990178356, -0.458429714632893],
            [30.27804325263462, -0.458383718769249],
            [30.278979773267793, -0.460047508728535],
            [30.279867419261286, -0.460519531229143],
            [30.281716271591925, -0.462531228668265],
            [30.282037216286756, -0.46157549989487],
            [30.282875984945612, -0.46091793285536],
            [30.283690627550914, -0.45877068442935],
            [30.283370432051036, -0.457554041514279],
            [30.284000259761367, -0.455038137818464],
            [30.286627317232742, -0.45337572287557],
            [30.294139544373216, -0.445694647665392],
            [30.29522463108302, -0.445719832070663],
            [30.296001024321814, -0.447073214360336],
            [30.29724611266181, -0.447880516464525],
            [30.298393013344626, -0.447446492513422],
            [30.300589311569265, -0.443383038505087],
            [30.30118213857135, -0.440999873642367],
            [30.303748132162998, -0.437441810639168],
            [30.3058187668592, -0.436128482212576],
            [30.305693493199577, -0.433456872465679],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 164,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "RUHUMURO",
        Population: 13511,
        Key: "BUSHENYIRUHUMURO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.19033695403027, -0.516081895781754],
            [30.18852727812748, -0.516909241982391],
            [30.187617380864385, -0.518099593230184],
            [30.183105276142914, -0.518157031855737],
            [30.18018827932876, -0.513563236386912],
            [30.18159796507992, -0.513084207427868],
            [30.181806676958086, -0.512471765985067],
            [30.181578882168346, -0.51133251591025],
            [30.181023259792088, -0.510772695518701],
            [30.181629871442198, -0.508177907507031],
            [30.180677602443808, -0.506728584743931],
            [30.178732244102157, -0.506417997187598],
            [30.177432388174253, -0.505418150170132],
            [30.17566570743758, -0.510017231560427],
            [30.1744257098503, -0.510687883552457],
            [30.1736438099388, -0.511998492220595],
            [30.17351768737125, -0.514541651895686],
            [30.17265205459379, -0.516712164118153],
            [30.16738718232546, -0.519854513993104],
            [30.164023217961905, -0.521076299031765],
            [30.157471262012397, -0.525733418497557],
            [30.156292887056974, -0.526783958398862],
            [30.154600065802956, -0.529306913454514],
            [30.153804109053905, -0.531666131422234],
            [30.153354708866697, -0.533861361866155],
            [30.153557471202753, -0.536159484546252],
            [30.150699784756885, -0.545329727121271],
            [30.150230560548, -0.54861077479361],
            [30.15016664541555, -0.554135287330895],
            [30.14956274937253, -0.555020952372327],
            [30.1464217432692, -0.557001431416502],
            [30.145196229219263, -0.558311581963475],
            [30.144272032573504, -0.563935113595907],
            [30.14181464979129, -0.567725256021508],
            [30.14208461599203, -0.570167020678723],
            [30.144267010991058, -0.574186948203706],
            [30.144793427340826, -0.575900906727821],
            [30.14456349725565, -0.58383231814536],
            [30.14383720665347, -0.58478438851298],
            [30.14397916202793, -0.586402901030189],
            [30.143441726044607, -0.588747077020086],
            [30.14630656487676, -0.590245636427765],
            [30.146848601132653, -0.59191045394108],
            [30.150859188109106, -0.594646481289469],
            [30.155701955500138, -0.593909611340616],
            [30.157501754426374, -0.594443543030266],
            [30.158820209073944, -0.595786222879622],
            [30.159779227115063, -0.595586566030789],
            [30.160785650152075, -0.592962098542598],
            [30.161395116648162, -0.593215670378387],
            [30.1620456352544, -0.592482291803694],
            [30.16516548693108, -0.592664218766227],
            [30.165503694550733, -0.591004013184325],
            [30.164713252559192, -0.587910137438009],
            [30.165222674580402, -0.586739578242783],
            [30.16507813565119, -0.585056447085587],
            [30.165539298378693, -0.58347118988417],
            [30.1674064098658, -0.580674351426824],
            [30.171760819830727, -0.578219764866595],
            [30.171586115474287, -0.575053058445065],
            [30.17444553027876, -0.571743062640405],
            [30.176654754362033, -0.570704130902389],
            [30.17815244267172, -0.567692388278726],
            [30.179043489686855, -0.566796251311232],
            [30.18232145473502, -0.565757824409622],
            [30.18957607020483, -0.565092820513057],
            [30.193789598282063, -0.564220092105213],
            [30.198187284585796, -0.562200200219548],
            [30.201473199724237, -0.560072899412745],
            [30.204516087340632, -0.557115708787275],
            [30.20670883272835, -0.555635664003081],
            [30.206206018714393, -0.553995295033021],
            [30.20470155980242, -0.552340775105743],
            [30.20380403413741, -0.550248679487487],
            [30.203128886421016, -0.547001393455045],
            [30.20306792405089, -0.542664140684161],
            [30.19868962249269, -0.541748314227071],
            [30.19846617375228, -0.541065537059949],
            [30.199064235237515, -0.538959738818703],
            [30.19918017540133, -0.534675297144182],
            [30.19669681693438, -0.534647146067203],
            [30.19249178871638, -0.535571208986164],
            [30.190876894516638, -0.535360069199552],
            [30.184396608855423, -0.53832177002203],
            [30.183894545833038, -0.537668368781553],
            [30.183789384554295, -0.536638315913815],
            [30.184798089312103, -0.532851641744505],
            [30.18556303262429, -0.532402507102925],
            [30.18685608111899, -0.530040914372183],
            [30.18927991272364, -0.52701037997165],
            [30.189822250813492, -0.525117047417188],
            [30.19030696736776, -0.524619962156483],
            [30.18974691000893, -0.523634666501023],
            [30.18988017148808, -0.5230417878748],
            [30.191740763901187, -0.520175592787006],
            [30.19100165883151, -0.51921076101386],
            [30.191474304723275, -0.517038767485442],
            [30.19033695403027, -0.516081895781754],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 165,
        District: "BUSHENYI",
        County: "BUSHENYI-ISHAKA MUNICIPALITY",
        Subcounty: "CENTRAL DIVISON",
        Population: 16613,
        Key: "BUSHENYICENTRAL DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.32918970200686, -0.355026131650098],
            [30.327819417262354, -0.355737121944242],
            [30.325624702767527, -0.355851261480148],
            [30.32169201230265, -0.353655045777593],
            [30.32013864910659, -0.353625904086554],
            [30.319611501528186, -0.35312361166574],
            [30.319697301417627, -0.352090662074865],
            [30.31912763208525, -0.350770587443928],
            [30.318388657271292, -0.349703926244868],
            [30.3172606077347, -0.34913570837699],
            [30.315805669351086, -0.349643409667827],
            [30.31500338846243, -0.351974538151672],
            [30.31357768844468, -0.354066367518315],
            [30.311350968772903, -0.354065722540248],
            [30.307347597963133, -0.353153119864009],
            [30.29794612305034, -0.342684311535107],
            [30.2950552429564, -0.340623014642921],
            [30.289168104097534, -0.337133021993891],
            [30.28060574189836, -0.33324468770682],
            [30.275136667294593, -0.330170582152213],
            [30.273879813719343, -0.329714077572152],
            [30.272566770523053, -0.329962039922786],
            [30.27139833273129, -0.328157790854479],
            [30.270425338701003, -0.328375970089725],
            [30.268902976365407, -0.327936005835988],
            [30.26623145857565, -0.326291438339142],
            [30.26326283198885, -0.325513546718219],
            [30.258750322127188, -0.325123781185727],
            [30.256137546970496, -0.325930041174476],
            [30.252604615790187, -0.326108405074808],
            [30.248003372141365, -0.324642659339048],
            [30.24417421969951, -0.32245983651226],
            [30.23868239975277, -0.320904210723803],
            [30.23419970407704, -0.32039491884898],
            [30.231569326432354, -0.321302974700928],
            [30.229083873992465, -0.321625646268846],
            [30.227401024936427, -0.323303501966125],
            [30.226345842244157, -0.322787402885897],
            [30.224242680449823, -0.323410420443418],
            [30.223340440426213, -0.322917460704574],
            [30.22155097571902, -0.322963163565332],
            [30.219944418783403, -0.325333902728698],
            [30.219514677327908, -0.330799807405302],
            [30.217227814549556, -0.332054040272304],
            [30.21621628189522, -0.332117755806866],
            [30.217057146323672, -0.332945525925034],
            [30.21712948316194, -0.334130666672778],
            [30.21792131574552, -0.334986812119922],
            [30.21780482132116, -0.335798806952731],
            [30.218698637842348, -0.335762482401364],
            [30.219853836263415, -0.336516315851728],
            [30.219723371239763, -0.335316524120903],
            [30.22158371481954, -0.335104899034875],
            [30.222208488608064, -0.335697639524116],
            [30.221619700431496, -0.336348559262796],
            [30.22222257598835, -0.337285126595043],
            [30.222890753676463, -0.336356001676672],
            [30.223872467653248, -0.336078523151112],
            [30.22646640244348, -0.337147339993351],
            [30.227577916690606, -0.338223052964529],
            [30.228224658779414, -0.338230553766466],
            [30.23011145594765, -0.339518870758737],
            [30.231304808513805, -0.341662470969067],
            [30.232990480974795, -0.342460363741123],
            [30.23585296352596, -0.344729048739531],
            [30.236368673754146, -0.345548554328213],
            [30.237181155911173, -0.345479426630783],
            [30.238700964336413, -0.346829478235705],
            [30.24114315840381, -0.347245819969732],
            [30.24165640365486, -0.347992455349244],
            [30.24129073274035, -0.349072372036933],
            [30.24264474180854, -0.349857881140936],
            [30.243683602112107, -0.351125457544829],
            [30.2448807114328, -0.35113261339003],
            [30.245901893789885, -0.352618757271083],
            [30.246876161631295, -0.352848273374991],
            [30.245009530742834, -0.361926203326416],
            [30.245035356408955, -0.364090547256959],
            [30.24531901922285, -0.365520240950564],
            [30.24608836068669, -0.366607043718644],
            [30.246077452444176, -0.367651893199923],
            [30.24741668063269, -0.369240910911575],
            [30.247781373281832, -0.37147466533551],
            [30.24986722004905, -0.373578696243055],
            [30.250285104641122, -0.374567367261368],
            [30.249413036333, -0.377289802249572],
            [30.249031323304152, -0.377537132725741],
            [30.248248788283735, -0.377081055368875],
            [30.2473683036597, -0.379581325807982],
            [30.248849115320116, -0.381020917102021],
            [30.247788019018326, -0.381899677247563],
            [30.24814959990332, -0.383951026012642],
            [30.248854562704018, -0.384244287023791],
            [30.248834961464514, -0.384862906893523],
            [30.249526941812693, -0.38529942346524],
            [30.24799698781466, -0.388124006435794],
            [30.247987090176842, -0.389357759283696],
            [30.24727436862705, -0.389998314233191],
            [30.24741644437576, -0.391318193471042],
            [30.24609564782025, -0.392149827136715],
            [30.24570586612354, -0.392991329379344],
            [30.244736844443413, -0.393000572826168],
            [30.243140174365845, -0.394960659418947],
            [30.24239941549771, -0.394185732640301],
            [30.24111661228885, -0.395046062918359],
            [30.239824661535437, -0.39483522794014],
            [30.237601375224667, -0.395609165636712],
            [30.236898422853606, -0.395436781244523],
            [30.23611975238554, -0.39440362014117],
            [30.23522673895822, -0.394412886942066],
            [30.234751548139247, -0.394976999385701],
            [30.235216733522584, -0.395952672307461],
            [30.232556081754517, -0.39677070803811],
            [30.232964874497597, -0.39804012994955],
            [30.231313173625747, -0.397969515987113],
            [30.228766748934234, -0.399192833699568],
            [30.227284832346022, -0.398914983436539],
            [30.227398998337172, -0.398417701608005],
            [30.22645881437427, -0.397451437704807],
            [30.225147927134678, -0.397097135402421],
            [30.2247868475096, -0.397336110271061],
            [30.224795819882637, -0.398923706764846],
            [30.224073496240774, -0.399889408163625],
            [30.224215898077922, -0.400185934811212],
            [30.225061454407115, -0.400023635654548],
            [30.225612152218986, -0.400932385129486],
            [30.22443409796213, -0.401085006954711],
            [30.22389214704616, -0.402423756666806],
            [30.221707564649435, -0.40117015527541],
            [30.22055845860261, -0.399993419759737],
            [30.21892443477891, -0.400069374957268],
            [30.217405062934887, -0.398203927499091],
            [30.2162935801288, -0.3981652972815],
            [30.214406982386553, -0.397174813553999],
            [30.212612114312883, -0.395309282798648],
            [30.212782658571275, -0.396679342580816],
            [30.212100549809733, -0.397137888293026],
            [30.211905689054912, -0.398763182611261],
            [30.216123026887274, -0.402591584769961],
            [30.217199841909938, -0.403197405297418],
            [30.220418739134892, -0.403921435744673],
            [30.222384493725045, -0.405367971144333],
            [30.22423557118266, -0.408323592865853],
            [30.22567789901632, -0.409751884057783],
            [30.228154457236574, -0.410014806128668],
            [30.230487908442193, -0.412473597912743],
            [30.23186493055133, -0.413350638078339],
            [30.235738465158153, -0.415249705093943],
            [30.24027388834777, -0.416742359427223],
            [30.24296821076931, -0.418478369583837],
            [30.24559036343924, -0.421253595221302],
            [30.24989138473021, -0.423296761436333],
            [30.257077856697492, -0.424601305891728],
            [30.26001855376384, -0.425813298361525],
            [30.26239627394665, -0.426157548416452],
            [30.2644235137264, -0.427622256645914],
            [30.26573242646904, -0.428038424633193],
            [30.26767632504831, -0.427198678639261],
            [30.268603556203097, -0.427307452612688],
            [30.273425733309526, -0.429387684266249],
            [30.275810709184896, -0.431114611674089],
            [30.278498508040848, -0.431675872137514],
            [30.280011254809608, -0.432435528824899],
            [30.280937437630485, -0.432363564141956],
            [30.285428556808593, -0.42790987211587],
            [30.29461443515493, -0.42839209226269],
            [30.297495342152562, -0.427542247728191],
            [30.299622384760408, -0.427413524527357],
            [30.301692384347696, -0.427906578983886],
            [30.303122255243306, -0.428711398481582],
            [30.30440702755928, -0.431305545875177],
            [30.304131196258012, -0.433094825825692],
            [30.305693493199577, -0.433456872465679],
            [30.308180301197215, -0.434976022816928],
            [30.310285311724414, -0.437669891628626],
            [30.312970619552082, -0.442297967138024],
            [30.315588687582405, -0.44313938855561],
            [30.316376719394064, -0.443898812323288],
            [30.317003382339614, -0.445607100506109],
            [30.316775627974085, -0.449764200667062],
            [30.317238680756947, -0.45199659863567],
            [30.318329666703196, -0.453166428252106],
            [30.31812773530879, -0.453653180418711],
            [30.319549991185735, -0.455512992049077],
            [30.321195473020918, -0.456670390604141],
            [30.324498891832636, -0.456798146741257],
            [30.32846014602863, -0.457784703553975],
            [30.33180105153719, -0.45596038112837],
            [30.337400759149574, -0.456748720310078],
            [30.33844016742547, -0.45558326682912],
            [30.33902320279096, -0.453459665115368],
            [30.34319144589638, -0.45084934638819],
            [30.347780851546382, -0.449242331480282],
            [30.34908946604832, -0.449568160173678],
            [30.349570784275862, -0.450199331170925],
            [30.3500576567868, -0.448393654391341],
            [30.350195911102283, -0.445311864636453],
            [30.349374017296004, -0.440358923984443],
            [30.350097657868083, -0.437873832889515],
            [30.348993508907963, -0.435740643119806],
            [30.351391248945188, -0.433048255796737],
            [30.352389957250534, -0.433184120304882],
            [30.35264521533513, -0.432018346009904],
            [30.35480051085699, -0.430699650257605],
            [30.35458056913944, -0.4295337525163],
            [30.35553821455483, -0.428639333154963],
            [30.354562318067813, -0.428313609547987],
            [30.354392751176466, -0.427717099928102],
            [30.354981826813937, -0.426759309562938],
            [30.355046203680462, -0.425430800877513],
            [30.355801782954146, -0.424518258025436],
            [30.355275832830014, -0.423903562216501],
            [30.355287395944348, -0.421571766295484],
            [30.353879428670297, -0.42044161646554],
            [30.353922804722114, -0.419628249765444],
            [30.354395376053724, -0.419131294401754],
            [30.355393397147882, -0.419149792015125],
            [30.35550802577137, -0.418336426977373],
            [30.35215207707508, -0.416407409867166],
            [30.352601523974673, -0.4148596075445],
            [30.35372423572181, -0.413967436718015],
            [30.353398980011946, -0.413046393789887],
            [30.35400511645329, -0.412809350712242],
            [30.354454376503288, -0.411950739847053],
            [30.35327647496004, -0.410357254003718],
            [30.352356330614516, -0.409785242142739],
            [30.353243223819774, -0.409005873816632],
            [30.352334454840697, -0.407943528905034],
            [30.352144762992047, -0.404536829280478],
            [30.351415808885072, -0.402615749752823],
            [30.34681570879162, -0.398042714340267],
            [30.34423396144484, -0.399092683857061],
            [30.342145291272715, -0.402685056658788],
            [30.34190916101544, -0.403814894605549],
            [30.341168269196636, -0.404407780522381],
            [30.339866240244056, -0.404655944713833],
            [30.338822591920025, -0.40439571734691],
            [30.335310140531536, -0.402935909493972],
            [30.333953171514505, -0.399539084507739],
            [30.333403410645438, -0.399053063724215],
            [30.331888251001807, -0.39895088643154],
            [30.331091607041547, -0.398340501360331],
            [30.330541597339185, -0.398554983321056],
            [30.330160087329578, -0.398238448921628],
            [30.33014946205641, -0.396272558328621],
            [30.329420383083605, -0.395046416846169],
            [30.32727721122484, -0.393384812751178],
            [30.32736721343317, -0.392842485629995],
            [30.323799320720322, -0.389338732506955],
            [30.321072386758985, -0.38823070497814],
            [30.321140075713977, -0.387213794038026],
            [30.320209117449064, -0.385530068780922],
            [30.32028818087217, -0.383959582273606],
            [30.31995161177959, -0.383552678831559],
            [30.318896650971176, -0.383382883079454],
            [30.31850401622512, -0.382704816618462],
            [30.31720217502043, -0.382760936715417],
            [30.31675347641749, -0.382037687747654],
            [30.316921981500165, -0.381408368077656],
            [30.31580026957793, -0.379408169453722],
            [30.313897662060683, -0.378955647649322],
            [30.314767371392893, -0.377166491386527],
            [30.31700417016214, -0.376822897719801],
            [30.31803712943261, -0.375414270891004],
            [30.3203929962995, -0.376092772698557],
            [30.322647607762523, -0.375605442650684],
            [30.324864031842836, -0.376880391349293],
            [30.325504607895503, -0.376681784422586],
            [30.32617162226535, -0.37576761561593],
            [30.328507612109927, -0.370378900856917],
            [30.329698700023272, -0.365712873554648],
            [30.330115022445053, -0.362090629470649],
            [30.32918970200686, -0.355026131650098],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 166,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "BURERE",
        Population: 19221,
        Key: "BUHWEJUBURERE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.3840110397305, -0.322946527928858],
            [30.380834555563332, -0.318865529434982],
            [30.380448919591633, -0.31784415623196],
            [30.380055112544124, -0.315277314283136],
            [30.379932050536723, -0.303347358120496],
            [30.380227902590725, -0.300085664565961],
            [30.385058599319258, -0.297153817098561],
            [30.379138263219062, -0.296595777660392],
            [30.376606977835063, -0.296754628215808],
            [30.374734147672832, -0.297605621380092],
            [30.368650246325696, -0.297641800540043],
            [30.362114250743858, -0.29960435113279],
            [30.35921197282561, -0.301772682790346],
            [30.356949723886032, -0.305945624688996],
            [30.354235652901266, -0.308335223096263],
            [30.35110739658678, -0.309207081114601],
            [30.34868069216984, -0.309015032186637],
            [30.347196425588823, -0.306967497606379],
            [30.344094983985556, -0.304870596416646],
            [30.341588583731554, -0.30217495716045],
            [30.340271465777132, -0.301575741572267],
            [30.336616998827115, -0.302130962781195],
            [30.33580938913215, -0.303200213443323],
            [30.331771941630414, -0.306065332476466],
            [30.32987676318056, -0.308088882558451],
            [30.327217140881803, -0.300975696817551],
            [30.325900924835928, -0.299195039361958],
            [30.322680847224657, -0.297122579502967],
            [30.320769253859638, -0.294897691544587],
            [30.31715901905587, -0.288309122953463],
            [30.316904347571143, -0.287111299302762],
            [30.317202797552923, -0.28270531044621],
            [30.318222960322174, -0.281080007375619],
            [30.318223365462362, -0.279283360560038],
            [30.31603077188992, -0.276245676648262],
            [30.31576008254538, -0.273807314139551],
            [30.31465611324832, -0.270128228985274],
            [30.31067190799512, -0.263918671361035],
            [30.314086942480927, -0.260512329612612],
            [30.31537758259234, -0.257512204611797],
            [30.31527191825705, -0.256693207134832],
            [30.316858687103544, -0.254548260890933],
            [30.318975920108482, -0.252813523283004],
            [30.31958693260517, -0.252723275814536],
            [30.31837355479472, -0.251332967598106],
            [30.31986345291424, -0.24605323752514],
            [30.318199303189175, -0.243491346561704],
            [30.316296089309088, -0.242859948893243],
            [30.315379264238537, -0.240574246417665],
            [30.314271161792867, -0.239204257548727],
            [30.313866349484822, -0.23756506912519],
            [30.312895779109134, -0.236495229692494],
            [30.312223102658084, -0.236572052960923],
            [30.31119855611023, -0.237964709984364],
            [30.310380653518752, -0.238003028190577],
            [30.31024335051916, -0.236502413458618],
            [30.30958599034369, -0.236433029075301],
            [30.30791182440319, -0.237271494125936],
            [30.305397031189507, -0.237094014597624],
            [30.304663273790716, -0.236824537588346],
            [30.304418861066505, -0.235824102248008],
            [30.30316539773314, -0.23516976234579],
            [30.302630499490448, -0.23427700704001],
            [30.303012911408604, -0.23310739859076],
            [30.3029444624789, -0.231260518853803],
            [30.302157495170874, -0.229398114316223],
            [30.30250940659018, -0.227797562781141],
            [30.30150869414345, -0.224357591791619],
            [30.300637474743247, -0.223387828319319],
            [30.300989588283464, -0.220609901682049],
            [30.29969807321298, -0.218985969803462],
            [30.30008903170272, -0.216434202388106],
            [30.29979959811144, -0.216111708600278],
            [30.298764738005815, -0.216626192552877],
            [30.29853692075818, -0.216173493387578],
            [30.299227055966785, -0.214517998945254],
            [30.300646437234825, -0.213202782004774],
            [30.30075082326747, -0.212386359179391],
            [30.299589677100883, -0.211012813044833],
            [30.298845990623242, -0.208674090041038],
            [30.298032425996322, -0.208228741508233],
            [30.297115106852342, -0.206785700893054],
            [30.295857381911276, -0.206836470647243],
            [30.294002792939207, -0.205181072230353],
            [30.28405895837697, -0.211271710243327],
            [30.27728842165759, -0.215376008869559],
            [30.2761271524218, -0.215183090735878],
            [30.273332203417095, -0.216146152458163],
            [30.269094940951714, -0.218624944014964],
            [30.265366449229013, -0.218869381008818],
            [30.260534303517897, -0.220539501234914],
            [30.252380571466727, -0.222110421960822],
            [30.25064571534565, -0.222977639112978],
            [30.250124964670384, -0.224378255579648],
            [30.250991924259523, -0.226474970106293],
            [30.250817977182827, -0.229619765546106],
            [30.24908290995764, -0.230839408242281],
            [30.246654259789814, -0.230667240327868],
            [30.24491976928303, -0.229618635474566],
            [30.244052689319652, -0.228217763496018],
            [30.241971240704057, -0.226997398337076],
            [30.239195680038105, -0.226472738708534],
            [30.237510879841267, -0.226011544542238],
            [30.235226241291564, -0.2268786383948],
            [30.23224889655493, -0.228450461239415],
            [30.231019811701724, -0.229362933876693],
            [30.23053589913963, -0.230284584468913],
            [30.229955825519635, -0.231649014586385],
            [30.230152942842434, -0.2327967143261],
            [30.231940204880576, -0.234974913112419],
            [30.230902182705165, -0.241354625766481],
            [30.228125306007296, -0.252029654685054],
            [30.21963006592614, -0.257568060393584],
            [30.21569110342396, -0.259519839784321],
            [30.20862747158016, -0.265600031025442],
            [30.205821396042346, -0.267381039490903],
            [30.201000874531005, -0.269719243151402],
            [30.191065907238915, -0.272855707248206],
            [30.185008795450184, -0.276714050987608],
            [30.183931484557522, -0.277713949535299],
            [30.18408221198071, -0.27808876538207],
            [30.18830927407601, -0.281486096685882],
            [30.186290878210215, -0.283199349980281],
            [30.18563472626881, -0.283192959443392],
            [30.185430078368977, -0.284744621037309],
            [30.184183677590358, -0.286447543352108],
            [30.183823453161445, -0.290692148709042],
            [30.185084505462324, -0.290660547282366],
            [30.185259664366342, -0.294564919541954],
            [30.185854676071195, -0.295714027411121],
            [30.185533874208506, -0.296735242831976],
            [30.1863405245027, -0.297708271380689],
            [30.18624139630943, -0.298710638422027],
            [30.186625285057882, -0.2989518759138],
            [30.187868811227585, -0.298594030597428],
            [30.188840806331307, -0.299431176278554],
            [30.190140680225515, -0.29912653656882],
            [30.190785159458137, -0.299669267897379],
            [30.19114767998093, -0.300839601233958],
            [30.190330419684884, -0.301006061251784],
            [30.18966708750944, -0.302652937776925],
            [30.19022468528102, -0.302832076411844],
            [30.190071012281987, -0.303295797342326],
            [30.19063665267031, -0.303629525772589],
            [30.189448563333418, -0.303889573612943],
            [30.189153073300478, -0.304352684550618],
            [30.189989853089322, -0.304630103748969],
            [30.189977152707822, -0.306867539007273],
            [30.19103536182431, -0.308816423852242],
            [30.190251470347842, -0.308653494282975],
            [30.18983909332677, -0.309442591695419],
            [30.188881576370477, -0.308771106300966],
            [30.18844066166948, -0.309961460006571],
            [30.189394294310464, -0.310589668724424],
            [30.188925362054064, -0.311309592245394],
            [30.188173707519873, -0.311492454197099],
            [30.18865031138878, -0.312334670686209],
            [30.18850053887475, -0.313319102664912],
            [30.18816097479901, -0.313807179693983],
            [30.18741132350791, -0.313795426313106],
            [30.187465681464044, -0.314783328294006],
            [30.186604825028958, -0.315340419976277],
            [30.186883305461986, -0.316613798459932],
            [30.187339997274336, -0.31647470274919],
            [30.188135816581166, -0.317232482985888],
            [30.189081323062105, -0.317468686875047],
            [30.18895167550538, -0.318729752978198],
            [30.18851119648728, -0.318810994456789],
            [30.188473742129794, -0.319279066056853],
            [30.189496374367764, -0.321772817636995],
            [30.187671865483004, -0.323940232953923],
            [30.18641087606419, -0.323950506821613],
            [30.185302742177452, -0.324513224963316],
            [30.184717160088155, -0.324284665777424],
            [30.185033436238438, -0.325336441326771],
            [30.186004241074404, -0.325320776757337],
            [30.186600249010908, -0.326011446984663],
            [30.187517269015892, -0.32599496316602],
            [30.18842518908701, -0.328147208873998],
            [30.18969654506423, -0.32881682453993],
            [30.190229128348395, -0.329911160188686],
            [30.192803623595882, -0.330809545878985],
            [30.192027614836007, -0.332307193841146],
            [30.1922438501047, -0.332610017113664],
            [30.195568632650524, -0.329671475675113],
            [30.196164821148376, -0.329726926861235],
            [30.196755548787642, -0.330444161322418],
            [30.200000812464538, -0.328888768527674],
            [30.2019266782628, -0.328644973366427],
            [30.2032250097497, -0.327211193130442],
            [30.204048144129366, -0.327025514387434],
            [30.205356421763057, -0.327806691874857],
            [30.205614668542633, -0.328842535696544],
            [30.206831762683418, -0.32844777035257],
            [30.20810493056255, -0.329199113374238],
            [30.20891754746687, -0.328896575657188],
            [30.21020270605843, -0.329243322332804],
            [30.211639636813853, -0.330458969803574],
            [30.21433543247247, -0.330708049621202],
            [30.215189955784815, -0.331679408659014],
            [30.21621628189522, -0.332117755806866],
            [30.217227814549556, -0.332054040272304],
            [30.219514677327908, -0.330799807405302],
            [30.219944418783403, -0.325333902728698],
            [30.22155097571902, -0.322963163565332],
            [30.223340440426213, -0.322917460704574],
            [30.224242680449823, -0.323410420443418],
            [30.226345842244157, -0.322787402885897],
            [30.227401024936427, -0.323303501966125],
            [30.229083873992465, -0.321625646268846],
            [30.231569326432354, -0.321302974700928],
            [30.23419970407704, -0.32039491884898],
            [30.23868239975277, -0.320904210723803],
            [30.24417421969951, -0.32245983651226],
            [30.248003372141365, -0.324642659339048],
            [30.252604615790187, -0.326108405074808],
            [30.256137546970496, -0.325930041174476],
            [30.258750322127188, -0.325123781185727],
            [30.26326283198885, -0.325513546718219],
            [30.26623145857565, -0.326291438339142],
            [30.268902976365407, -0.327936005835988],
            [30.270425338701003, -0.328375970089725],
            [30.27139833273129, -0.328157790854479],
            [30.272566770523053, -0.329962039922786],
            [30.273879813719343, -0.329714077572152],
            [30.275136667294593, -0.330170582152213],
            [30.28060574189836, -0.33324468770682],
            [30.289168104097534, -0.337133021993891],
            [30.2950552429564, -0.340623014642921],
            [30.29794612305034, -0.342684311535107],
            [30.307347597963133, -0.353153119864009],
            [30.311350968772903, -0.354065722540248],
            [30.31357768844468, -0.354066367518315],
            [30.31500338846243, -0.351974538151672],
            [30.315805669351086, -0.349643409667827],
            [30.3172606077347, -0.34913570837699],
            [30.318388657271292, -0.349703926244868],
            [30.31912763208525, -0.350770587443928],
            [30.319697301417627, -0.352090662074865],
            [30.319611501528186, -0.35312361166574],
            [30.32013864910659, -0.353625904086554],
            [30.32169201230265, -0.353655045777593],
            [30.325624702767527, -0.355851261480148],
            [30.327819417262354, -0.355737121944242],
            [30.32918970200686, -0.355026131650098],
            [30.330133667877078, -0.354744627497937],
            [30.33436972570165, -0.355617212639005],
            [30.336529082506882, -0.357525656383852],
            [30.338230251804802, -0.357097397391567],
            [30.33923007761436, -0.352646176029182],
            [30.341053741184453, -0.351544117596737],
            [30.34249195203915, -0.349420703486765],
            [30.342131856967615, -0.346483397827135],
            [30.341387435668082, -0.345010069907344],
            [30.342348265611147, -0.335764928471892],
            [30.34620376923356, -0.335783817921317],
            [30.348116643596207, -0.335025793845322],
            [30.3495082229045, -0.332983938136255],
            [30.350549435895843, -0.329757142992034],
            [30.35211379806419, -0.326784182321268],
            [30.352906768813263, -0.32397369017188],
            [30.35562960286361, -0.319925535779916],
            [30.356049786244522, -0.318524808210152],
            [30.35683014374867, -0.317829107885857],
            [30.357302573146477, -0.31569277431228],
            [30.3624491498683, -0.317860446928975],
            [30.364529170162577, -0.317680686025541],
            [30.367057651904563, -0.319720602713614],
            [30.374014801946146, -0.318800529245743],
            [30.378047396748727, -0.319741487320451],
            [30.379553221099954, -0.321422906888005],
            [30.383332270006868, -0.323818903040257],
            [30.38438562193258, -0.325310421145687],
            [30.387021713760802, -0.325582240677459],
            [30.38617463119398, -0.324370946679801],
            [30.3840110397305, -0.322946527928858],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 167,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "ENGAJU",
        Population: 18981,
        Key: "BUHWEJUENGAJU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.505028644141, -0.373408798788246],
            [30.50600199390417, -0.370263602701872],
            [30.50660770364573, -0.363819164498393],
            [30.506572266006096, -0.358432079237689],
            [30.505385615770283, -0.349293618491027],
            [30.505361902043404, -0.347160476194863],
            [30.505970578920376, -0.344343913804556],
            [30.505931783378198, -0.342858186329974],
            [30.50457075307775, -0.338505694855084],
            [30.5035342292922, -0.332264245211362],
            [30.502456488106493, -0.328234267671541],
            [30.501553944452336, -0.327612254712059],
            [30.49989092840114, -0.328233627183254],
            [30.497657386923105, -0.33048106350048],
            [30.497609184223283, -0.33325517176714],
            [30.495898238560123, -0.335550558191143],
            [30.491432103326687, -0.33626685620024],
            [30.488880030926993, -0.336020539693502],
            [30.487482874877408, -0.332458976925679],
            [30.481718743228704, -0.335980603977616],
            [30.476436777817163, -0.336704435995339],
            [30.47322988837258, -0.338267188221993],
            [30.46924680152193, -0.338417464765656],
            [30.466967348946337, -0.337836834419658],
            [30.46403241816583, -0.335453778056622],
            [30.462220711172172, -0.335227925699628],
            [30.45742927351649, -0.335685358866645],
            [30.45621793667837, -0.335146978097942],
            [30.455435391776486, -0.329837855283203],
            [30.454536465637975, -0.32704550606844],
            [30.45202508961562, -0.3251921194205],
            [30.4437772455637, -0.323197569822161],
            [30.440578793096286, -0.323197977650788],
            [30.436801319834384, -0.32552861122241],
            [30.43433222751244, -0.326401599650423],
            [30.43662172325288, -0.331231983269222],
            [30.437069763390713, -0.334750804471206],
            [30.437124116855326, -0.338284767945693],
            [30.438925861532475, -0.344187217209977],
            [30.440294961399108, -0.346944252079383],
            [30.440078328176774, -0.34867050017817],
            [30.438598325000083, -0.351700758374626],
            [30.439342137241848, -0.354349320645938],
            [30.441599629601996, -0.357722859696697],
            [30.449217132107243, -0.363446477162609],
            [30.450358347352598, -0.36492089896596],
            [30.45204501694356, -0.368319303436172],
            [30.4518703485197, -0.371642226358678],
            [30.452365981401293, -0.374190815007615],
            [30.452340257244813, -0.377338887827263],
            [30.45374285708504, -0.379037619820586],
            [30.455023651660962, -0.379575630614065],
            [30.457975387225474, -0.382079489021697],
            [30.463853487235973, -0.38558729915186],
            [30.46630953512167, -0.388861070657614],
            [30.465961670612717, -0.390235143279812],
            [30.463726810407877, -0.394282036945543],
            [30.46348095498933, -0.39957216955348],
            [30.463059726867762, -0.400810302578904],
            [30.45996791969593, -0.407072950463935],
            [30.45582749921148, -0.412792928138483],
            [30.454725395715258, -0.415585428132261],
            [30.453763945036332, -0.420663085641201],
            [30.454748215618423, -0.422956106213838],
            [30.456550383402075, -0.424225497019975],
            [30.456451895707595, -0.425482997844654],
            [30.458554934432698, -0.425321000131518],
            [30.464424692687484, -0.42310851921374],
            [30.467066593920638, -0.419385544057784],
            [30.469987186690876, -0.416693027053244],
            [30.472595955361417, -0.415681555219818],
            [30.476124297947248, -0.413323634525249],
            [30.482754722635146, -0.411138410697933],
            [30.483908105561053, -0.409032789351654],
            [30.484698505331757, -0.403456242145147],
            [30.486780570191627, -0.399479909426966],
            [30.4882148581035, -0.394319312553866],
            [30.48947089151693, -0.393668912631626],
            [30.494056871890727, -0.393597983330763],
            [30.499512322644883, -0.389387600628306],
            [30.501537881676736, -0.388592797667449],
            [30.505028644141, -0.373408798788246],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 168,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "KARUNGU",
        Population: 15438,
        Key: "BUHWEJUKARUNGU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.3840110397305, -0.322946527928858],
            [30.38617463119398, -0.324370946679801],
            [30.387021713760802, -0.325582240677459],
            [30.38438562193258, -0.325310421145687],
            [30.383332270006868, -0.323818903040257],
            [30.379553221099954, -0.321422906888005],
            [30.378047396748727, -0.319741487320451],
            [30.374014801946146, -0.318800529245743],
            [30.367057651904563, -0.319720602713614],
            [30.364529170162577, -0.317680686025541],
            [30.3624491498683, -0.317860446928975],
            [30.357302573146477, -0.31569277431228],
            [30.35683014374867, -0.317829107885857],
            [30.356049786244522, -0.318524808210152],
            [30.35562960286361, -0.319925535779916],
            [30.352906768813263, -0.32397369017188],
            [30.35211379806419, -0.326784182321268],
            [30.350549435895843, -0.329757142992034],
            [30.3495082229045, -0.332983938136255],
            [30.348116643596207, -0.335025793845322],
            [30.34620376923356, -0.335783817921317],
            [30.342348265611147, -0.335764928471892],
            [30.341387435668082, -0.345010069907344],
            [30.342131856967615, -0.346483397827135],
            [30.34249195203915, -0.349420703486765],
            [30.341053741184453, -0.351544117596737],
            [30.33923007761436, -0.352646176029182],
            [30.338230251804802, -0.357097397391567],
            [30.336529082506882, -0.357525656383852],
            [30.33436972570165, -0.355617212639005],
            [30.330133667877078, -0.354744627497937],
            [30.32918970200686, -0.355026131650098],
            [30.330115022445053, -0.362090629470649],
            [30.329698700023272, -0.365712873554648],
            [30.328507612109927, -0.370378900856917],
            [30.32617162226535, -0.37576761561593],
            [30.325504607895503, -0.376681784422586],
            [30.324864031842836, -0.376880391349293],
            [30.322647607762523, -0.375605442650684],
            [30.3203929962995, -0.376092772698557],
            [30.31803712943261, -0.375414270891004],
            [30.31700417016214, -0.376822897719801],
            [30.314767371392893, -0.377166491386527],
            [30.313897662060683, -0.378955647649322],
            [30.31580026957793, -0.379408169453722],
            [30.316921981500165, -0.381408368077656],
            [30.31675347641749, -0.382037687747654],
            [30.31720217502043, -0.382760936715417],
            [30.31850401622512, -0.382704816618462],
            [30.318896650971176, -0.383382883079454],
            [30.31995161177959, -0.383552678831559],
            [30.32028818087217, -0.383959582273606],
            [30.320209117449064, -0.385530068780922],
            [30.321140075713977, -0.387213794038026],
            [30.321072386758985, -0.38823070497814],
            [30.323799320720322, -0.389338732506955],
            [30.32736721343317, -0.392842485629995],
            [30.32727721122484, -0.393384812751178],
            [30.329420383083605, -0.395046416846169],
            [30.33014946205641, -0.396272558328621],
            [30.330160087329578, -0.398238448921628],
            [30.330541597339185, -0.398554983321056],
            [30.331091607041547, -0.398340501360331],
            [30.331888251001807, -0.39895088643154],
            [30.333403410645438, -0.399053063724215],
            [30.333953171514505, -0.399539084507739],
            [30.335310140531536, -0.402935909493972],
            [30.338822591920025, -0.40439571734691],
            [30.339866240244056, -0.404655944713833],
            [30.341168269196636, -0.404407780522381],
            [30.34190916101544, -0.403814894605549],
            [30.342145291272715, -0.402685056658788],
            [30.34423396144484, -0.399092683857061],
            [30.34681570879162, -0.398042714340267],
            [30.351415808885072, -0.402615749752823],
            [30.352144762992047, -0.404536829280478],
            [30.352334454840697, -0.407943528905034],
            [30.353243223819774, -0.409005873816632],
            [30.352356330614516, -0.409785242142739],
            [30.35327647496004, -0.410357254003718],
            [30.354454376503288, -0.411950739847053],
            [30.35400511645329, -0.412809350712242],
            [30.353398980011946, -0.413046393789887],
            [30.35372423572181, -0.413967436718015],
            [30.352601523974673, -0.4148596075445],
            [30.35215207707508, -0.416407409867166],
            [30.35550802577137, -0.418336426977373],
            [30.355393397147882, -0.419149792015125],
            [30.354395376053724, -0.419131294401754],
            [30.353922804722114, -0.419628249765444],
            [30.353879428670297, -0.42044161646554],
            [30.355287395944348, -0.421571766295484],
            [30.355275832830014, -0.423903562216501],
            [30.355801782954146, -0.424518258025436],
            [30.355046203680462, -0.425430800877513],
            [30.354981826813937, -0.426759309562938],
            [30.354392751176466, -0.427717099928102],
            [30.354562318067813, -0.428313609547987],
            [30.35553821455483, -0.428639333154963],
            [30.35458056913944, -0.4295337525163],
            [30.35480051085699, -0.430699650257605],
            [30.35264521533513, -0.432018346009904],
            [30.352389957250534, -0.433184120304882],
            [30.351391248945188, -0.433048255796737],
            [30.348993508907963, -0.435740643119806],
            [30.350097657868083, -0.437873832889515],
            [30.349374017296004, -0.440358923984443],
            [30.350195911102283, -0.445311864636453],
            [30.3500576567868, -0.448393654391341],
            [30.349570784275862, -0.450199331170925],
            [30.350657206780454, -0.451728717670725],
            [30.35257767190724, -0.450934107895379],
            [30.353551993647542, -0.450952538059227],
            [30.360050615720336, -0.446390875709856],
            [30.361096335559445, -0.446427401897253],
            [30.364284519384835, -0.451769831384984],
            [30.365013113267377, -0.452511187905032],
            [30.365822002163274, -0.452701274471282],
            [30.3673808540657, -0.455449310694262],
            [30.368670235637413, -0.456651800559822],
            [30.37421443994163, -0.455849468753192],
            [30.375063670380314, -0.454656790742622],
            [30.3754318673574, -0.452370364306973],
            [30.378955421922775, -0.446849536169134],
            [30.384267901307883, -0.435225745468586],
            [30.383641675841847, -0.425359210715842],
            [30.382897183575412, -0.423840600122903],
            [30.383658048536212, -0.421689850235517],
            [30.38335703476262, -0.418671108764426],
            [30.383679997971857, -0.416809419583899],
            [30.38721476171535, -0.413448505184431],
            [30.388109520569255, -0.411894284885409],
            [30.39106065875413, -0.410512452851586],
            [30.39240735284096, -0.409048751109176],
            [30.39390292561815, -0.408760023760188],
            [30.39470165187325, -0.407015962780437],
            [30.397339328329586, -0.403892829605252],
            [30.399517735707065, -0.399661284753665],
            [30.399210513676532, -0.39685875160415],
            [30.399468534978972, -0.396235213560443],
            [30.40110172786103, -0.395015599974471],
            [30.402551728205527, -0.392855975313548],
            [30.403300363502083, -0.39063286134092],
            [30.403693864224074, -0.386385126055191],
            [30.401700876307782, -0.374861093907934],
            [30.397015505432627, -0.366707476904155],
            [30.395845210823193, -0.365649697225791],
            [30.394192157088483, -0.361392355069818],
            [30.39377854578223, -0.35868989696384],
            [30.394315924273375, -0.3562407715514],
            [30.393827479710687, -0.353746167347099],
            [30.392871030851275, -0.350383794496266],
            [30.390904472268954, -0.346966920649944],
            [30.39038589102511, -0.343288352163569],
            [30.390458972566744, -0.34011080700087],
            [30.391728105213613, -0.336346326987773],
            [30.393395186141476, -0.333998038963657],
            [30.39409968630976, -0.33060560655387],
            [30.39314761134748, -0.328558312519565],
            [30.39356950152741, -0.327388443115286],
            [30.39558209158153, -0.326318616427304],
            [30.39895286517495, -0.323150546459994],
            [30.392102064883247, -0.322254036636236],
            [30.38780630592321, -0.322252937115713],
            [30.3840110397305, -0.322946527928858],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 169,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "NYAKISHANA",
        Population: 17990,
        Key: "BUHWEJUNYAKISHANA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.45374285708504, -0.379037619820586],
            [30.452340257244813, -0.377338887827263],
            [30.452365981401293, -0.374190815007615],
            [30.4518703485197, -0.371642226358678],
            [30.45204501694356, -0.368319303436172],
            [30.450358347352598, -0.36492089896596],
            [30.449217132107243, -0.363446477162609],
            [30.441599629601996, -0.357722859696697],
            [30.439342137241848, -0.354349320645938],
            [30.438598325000083, -0.351700758374626],
            [30.440078328176774, -0.34867050017817],
            [30.440294961399108, -0.346944252079383],
            [30.438925861532475, -0.344187217209977],
            [30.437124116855326, -0.338284767945693],
            [30.437069763390713, -0.334750804471206],
            [30.43271078908587, -0.337729017797963],
            [30.4307004942273, -0.338446580452719],
            [30.42894876864347, -0.338822608662933],
            [30.42711828955533, -0.338524885229568],
            [30.42424447655348, -0.33927713296715],
            [30.423732527571367, -0.340188427260059],
            [30.423849906836303, -0.342837694328562],
            [30.424597173100345, -0.34545340021515],
            [30.424576985260938, -0.347355609148469],
            [30.42406484853097, -0.348762297316838],
            [30.423415147391626, -0.349475483530558],
            [30.419281244184546, -0.351772844122874],
            [30.41815815604329, -0.35626251305594],
            [30.41723269816287, -0.357569960430998],
            [30.414161567513904, -0.360006307205643],
            [30.41221196373427, -0.363869529325931],
            [30.411502698003382, -0.366405556621041],
            [30.41419906858377, -0.366505422983473],
            [30.415183091230823, -0.367100119769181],
            [30.412858728280945, -0.373511431824129],
            [30.41044292491998, -0.376165135825296],
            [30.41406419283207, -0.378190769542615],
            [30.41666518658379, -0.379212804533713],
            [30.418942925173823, -0.3795745858963],
            [30.427967475078223, -0.3797401453617],
            [30.432487986234133, -0.377909136763811],
            [30.435187719208656, -0.378337483689005],
            [30.438129919156445, -0.383863918334966],
            [30.440554635601647, -0.386767948772876],
            [30.442010494758446, -0.387623491899976],
            [30.447926415639014, -0.38612883713866],
            [30.44938277246248, -0.385335244773779],
            [30.452144237663305, -0.382282101323183],
            [30.45374285708504, -0.379037619820586],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 170,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "NSIIKA TOWN COUNCIL",
        Population: 2956,
        Key: "BUHWEJUNSIIKA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.49512911359028, -0.256032012381825],
            [30.49360539839185, -0.258163005885812],
            [30.490635689335118, -0.258298000640687],
            [30.486698352783577, -0.259653012760077],
            [30.483731240756317, -0.258061637424519],
            [30.48206667870452, -0.257853422628318],
            [30.478584872443655, -0.255565988124866],
            [30.471428485055227, -0.257064972975355],
            [30.468256537380277, -0.259369153431843],
            [30.46648615019474, -0.263770520978554],
            [30.463550892427453, -0.265884916077151],
            [30.46248247485609, -0.266056426871471],
            [30.45893677681896, -0.26512474559101],
            [30.454865263404997, -0.265846980631105],
            [30.45196555377015, -0.265719847030094],
            [30.44950483823824, -0.263260917497603],
            [30.447539669349663, -0.264598185747081],
            [30.44476728243159, -0.265501445575107],
            [30.444093108488946, -0.266143025327534],
            [30.443930791900275, -0.266902207614865],
            [30.44498072124478, -0.269930252376822],
            [30.44649034816459, -0.272253411631189],
            [30.448211011802517, -0.276302939090337],
            [30.4520889122216, -0.281582160464339],
            [30.453545117229755, -0.285035128117403],
            [30.444757845629514, -0.28816947262656],
            [30.44311744556391, -0.288033531394893],
            [30.440672412820227, -0.288502972444353],
            [30.439885691650602, -0.288032807361948],
            [30.43715787734031, -0.287806239836599],
            [30.43493519110417, -0.28893551833829],
            [30.43267584641794, -0.289025390944407],
            [30.42862079732651, -0.288527376666291],
            [30.424421222780587, -0.287008019494158],
            [30.422104658105678, -0.284585281635443],
            [30.421643952620627, -0.28283178181654],
            [30.40959632744339, -0.282783915669732],
            [30.412431958452377, -0.284266787875835],
            [30.41272037065919, -0.284881439052853],
            [30.412439698336872, -0.287945279321274],
            [30.412730403044275, -0.288966645465376],
            [30.41373721325517, -0.290620839562746],
            [30.41538430217636, -0.292022118732381],
            [30.419060974581928, -0.297463900580182],
            [30.420764440872055, -0.298322920027998],
            [30.42158467010008, -0.300618795683668],
            [30.423629845642846, -0.300917536196778],
            [30.425351428257272, -0.302906334607314],
            [30.426257078285687, -0.303430761932101],
            [30.428913861908153, -0.311457292859811],
            [30.43105459933252, -0.316302285437266],
            [30.43433222751244, -0.326401599650423],
            [30.436801319834384, -0.32552861122241],
            [30.440578793096286, -0.323197977650788],
            [30.4437772455637, -0.323197569822161],
            [30.45202508961562, -0.3251921194205],
            [30.454536465637975, -0.32704550606844],
            [30.455435391776486, -0.329837855283203],
            [30.45621793667837, -0.335146978097942],
            [30.45742927351649, -0.335685358866645],
            [30.462220711172172, -0.335227925699628],
            [30.46403241816583, -0.335453778056622],
            [30.466967348946337, -0.337836834419658],
            [30.46924680152193, -0.338417464765656],
            [30.47322988837258, -0.338267188221993],
            [30.476436777817163, -0.336704435995339],
            [30.481718743228704, -0.335980603977616],
            [30.487482874877408, -0.332458976925679],
            [30.488880030926993, -0.336020539693502],
            [30.491432103326687, -0.33626685620024],
            [30.495898238560123, -0.335550558191143],
            [30.497609184223283, -0.33325517176714],
            [30.497657386923105, -0.33048106350048],
            [30.49989092840114, -0.328233627183254],
            [30.501553944452336, -0.327612254712059],
            [30.502456488106493, -0.328234267671541],
            [30.5035342292922, -0.332264245211362],
            [30.50457075307775, -0.338505694855084],
            [30.505931783378198, -0.342858186329974],
            [30.505970578920376, -0.344343913804556],
            [30.507085884057975, -0.336224074671524],
            [30.50785537284552, -0.323660436465567],
            [30.506762256993753, -0.316049564449726],
            [30.505449497665072, -0.311086997492931],
            [30.501218073350767, -0.301170560271897],
            [30.500911540328044, -0.301206645098292],
            [30.50090392351275, -0.300140078369513],
            [30.499565877507177, -0.298892436098712],
            [30.498812942873688, -0.296478940746111],
            [30.499387293327004, -0.291932619844437],
            [30.499583416214776, -0.288696818338731],
            [30.501057415052106, -0.285352827754928],
            [30.503958952758545, -0.282696077674129],
            [30.512587979833288, -0.276245346970393],
            [30.51453667721282, -0.272514990899447],
            [30.514917639250054, -0.268162511354782],
            [30.515583111212546, -0.266536415797989],
            [30.51519865023725, -0.264494276929161],
            [30.506317052837254, -0.261148274548542],
            [30.503438148184383, -0.260930775810988],
            [30.49661493246008, -0.255958165314366],
            [30.49512911359028, -0.256032012381825],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 171,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "BITSYA",
        Population: 15822,
        Key: "BUHWEJUBITSYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.40959632744339, -0.282783915669732],
            [30.408554927602488, -0.281473169186624],
            [30.407252547408643, -0.277893823378501],
            [30.405129518473498, -0.281821168729881],
            [30.39959955336484, -0.281582585362335],
            [30.39932648438308, -0.281475594608619],
            [30.399539052728755, -0.280956265035303],
            [30.397004934058348, -0.280894583856056],
            [30.396519485377116, -0.280344569072458],
            [30.395654340384883, -0.28139841408714],
            [30.394045806257356, -0.281902120330499],
            [30.39305897188345, -0.283826700541424],
            [30.391212600699596, -0.283652740326554],
            [30.391646453744173, -0.285552150662947],
            [30.392459205395788, -0.287108990661474],
            [30.393517755872107, -0.288151582903955],
            [30.393587666360748, -0.289415769538738],
            [30.393023184799144, -0.290780778947166],
            [30.39409148019964, -0.293879083729897],
            [30.385058599319258, -0.297153817098561],
            [30.380227902590725, -0.300085664565961],
            [30.379932050536723, -0.303347358120496],
            [30.380055112544124, -0.315277314283136],
            [30.380448919591633, -0.31784415623196],
            [30.380834555563332, -0.318865529434982],
            [30.3840110397305, -0.322946527928858],
            [30.38780630592321, -0.322252937115713],
            [30.392102064883247, -0.322254036636236],
            [30.39895286517495, -0.323150546459994],
            [30.39558209158153, -0.326318616427304],
            [30.39356950152741, -0.327388443115286],
            [30.39314761134748, -0.328558312519565],
            [30.39409968630976, -0.33060560655387],
            [30.393395186141476, -0.333998038963657],
            [30.391728105213613, -0.336346326987773],
            [30.390458972566744, -0.34011080700087],
            [30.39038589102511, -0.343288352163569],
            [30.390904472268954, -0.346966920649944],
            [30.392871030851275, -0.350383794496266],
            [30.393827479710687, -0.353746167347099],
            [30.394315924273375, -0.3562407715514],
            [30.39377854578223, -0.35868989696384],
            [30.394192157088483, -0.361392355069818],
            [30.395845210823193, -0.365649697225791],
            [30.397015505432627, -0.366707476904155],
            [30.401700876307782, -0.374861093907934],
            [30.403693864224074, -0.386385126055191],
            [30.403300363502083, -0.39063286134092],
            [30.402551728205527, -0.392855975313548],
            [30.40110172786103, -0.395015599974471],
            [30.399468534978972, -0.396235213560443],
            [30.399210513676532, -0.39685875160415],
            [30.399517735707065, -0.399661284753665],
            [30.397339328329586, -0.403892829605252],
            [30.39470165187325, -0.407015962780437],
            [30.39390292561815, -0.408760023760188],
            [30.39240735284096, -0.409048751109176],
            [30.39106065875413, -0.410512452851586],
            [30.388109520569255, -0.411894284885409],
            [30.38721476171535, -0.413448505184431],
            [30.383679997971857, -0.416809419583899],
            [30.38335703476262, -0.418671108764426],
            [30.383658048536212, -0.421689850235517],
            [30.382897183575412, -0.423840600122903],
            [30.383641675841847, -0.425359210715842],
            [30.384267901307883, -0.435225745468586],
            [30.38553940820205, -0.433801215598212],
            [30.38646396147899, -0.433394831197472],
            [30.39023937670058, -0.432871935913746],
            [30.39372771371354, -0.434246901040453],
            [30.396023769850522, -0.437085604866486],
            [30.39685730402626, -0.437465487743304],
            [30.397520267892453, -0.437004783096748],
            [30.39914231268186, -0.433643224432845],
            [30.40088935534809, -0.431465674120676],
            [30.401731710979888, -0.428989556712419],
            [30.406631113556326, -0.432091258391807],
            [30.407869063883084, -0.432516468319479],
            [30.414942335548165, -0.433269043705858],
            [30.416862480874716, -0.432402043279741],
            [30.419149342754732, -0.428941227806368],
            [30.419919471142773, -0.428525735382264],
            [30.423508326941086, -0.428671554822438],
            [30.431489780985366, -0.425854322389174],
            [30.43396386883861, -0.42638840186875],
            [30.436847297407258, -0.425666304801478],
            [30.43842157697637, -0.426805646973024],
            [30.43997715990946, -0.42891207829222],
            [30.442003010893796, -0.430042539487025],
            [30.45715978971105, -0.429270309194915],
            [30.456668820882385, -0.42834823234647],
            [30.456451895707595, -0.425482997844654],
            [30.456550383402075, -0.424225497019975],
            [30.454748215618423, -0.422956106213838],
            [30.453763945036332, -0.420663085641201],
            [30.454725395715258, -0.415585428132261],
            [30.45582749921148, -0.412792928138483],
            [30.45996791969593, -0.407072950463935],
            [30.463059726867762, -0.400810302578904],
            [30.46348095498933, -0.39957216955348],
            [30.463726810407877, -0.394282036945543],
            [30.465961670612717, -0.390235143279812],
            [30.46630953512167, -0.388861070657614],
            [30.463853487235973, -0.38558729915186],
            [30.457975387225474, -0.382079489021697],
            [30.455023651660962, -0.379575630614065],
            [30.45374285708504, -0.379037619820586],
            [30.452144237663305, -0.382282101323183],
            [30.44938277246248, -0.385335244773779],
            [30.447926415639014, -0.38612883713866],
            [30.442010494758446, -0.387623491899976],
            [30.440554635601647, -0.386767948772876],
            [30.438129919156445, -0.383863918334966],
            [30.435187719208656, -0.378337483689005],
            [30.432487986234133, -0.377909136763811],
            [30.427967475078223, -0.3797401453617],
            [30.418942925173823, -0.3795745858963],
            [30.41666518658379, -0.379212804533713],
            [30.41406419283207, -0.378190769542615],
            [30.41044292491998, -0.376165135825296],
            [30.412858728280945, -0.373511431824129],
            [30.415183091230823, -0.367100119769181],
            [30.41419906858377, -0.366505422983473],
            [30.411502698003382, -0.366405556621041],
            [30.41221196373427, -0.363869529325931],
            [30.414161567513904, -0.360006307205643],
            [30.41723269816287, -0.357569960430998],
            [30.41815815604329, -0.35626251305594],
            [30.419281244184546, -0.351772844122874],
            [30.423415147391626, -0.349475483530558],
            [30.42406484853097, -0.348762297316838],
            [30.424576985260938, -0.347355609148469],
            [30.424597173100345, -0.34545340021515],
            [30.423849906836303, -0.342837694328562],
            [30.423732527571367, -0.340188427260059],
            [30.42424447655348, -0.33927713296715],
            [30.42711828955533, -0.338524885229568],
            [30.42894876864347, -0.338822608662933],
            [30.4307004942273, -0.338446580452719],
            [30.43271078908587, -0.337729017797963],
            [30.437069763390713, -0.334750804471206],
            [30.43662172325288, -0.331231983269222],
            [30.43433222751244, -0.326401599650423],
            [30.43105459933252, -0.316302285437266],
            [30.428913861908153, -0.311457292859811],
            [30.426257078285687, -0.303430761932101],
            [30.425351428257272, -0.302906334607314],
            [30.423629845642846, -0.300917536196778],
            [30.42158467010008, -0.300618795683668],
            [30.420764440872055, -0.298322920027998],
            [30.419060974581928, -0.297463900580182],
            [30.41538430217636, -0.292022118732381],
            [30.41373721325517, -0.290620839562746],
            [30.412730403044275, -0.288966645465376],
            [30.412439698336872, -0.287945279321274],
            [30.41272037065919, -0.284881439052853],
            [30.412431958452377, -0.284266787875835],
            [30.40959632744339, -0.282783915669732],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 172,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "RWENGWE",
        Population: 16965,
        Key: "BUHWEJURWENGWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.541590109442318, -0.394395601968913],
            [30.540684181834497, -0.393638848525297],
            [30.538828672987567, -0.39023412012245],
            [30.537526049350273, -0.385561337529683],
            [30.535847254391133, -0.38244592163692],
            [30.531161908668786, -0.382199831846998],
            [30.528178578457396, -0.381153253084108],
            [30.526742422049722, -0.379728882532059],
            [30.524953071428563, -0.376813709051481],
            [30.52256659985826, -0.375322330294806],
            [30.52024581669478, -0.376033647758443],
            [30.516400488289555, -0.37532058131245],
            [30.515074863289417, -0.373829511315071],
            [30.514213636748423, -0.371315116214899],
            [30.513154131362995, -0.371202241675818],
            [30.505028644141, -0.373408798788246],
            [30.501537881676736, -0.388592797667449],
            [30.499512322644883, -0.389387600628306],
            [30.494056871890727, -0.393597983330763],
            [30.48947089151693, -0.393668912631626],
            [30.4882148581035, -0.394319312553866],
            [30.486780570191627, -0.399479909426966],
            [30.484698505331757, -0.403456242145147],
            [30.483908105561053, -0.409032789351654],
            [30.482754722635146, -0.411138410697933],
            [30.476124297947248, -0.413323634525249],
            [30.472595955361417, -0.415681555219818],
            [30.469987186690876, -0.416693027053244],
            [30.467066593920638, -0.419385544057784],
            [30.464424692687484, -0.42310851921374],
            [30.458554934432698, -0.425321000131518],
            [30.456451895707595, -0.425482997844654],
            [30.456668820882385, -0.42834823234647],
            [30.45715978971105, -0.429270309194915],
            [30.457523551705563, -0.431376370638397],
            [30.458359117870433, -0.432108759770781],
            [30.45999940564663, -0.432244884799794],
            [30.461173559418523, -0.438635427460369],
            [30.462205145164933, -0.440488651251806],
            [30.463969407636856, -0.441591939277775],
            [30.46664544125756, -0.442089967530427],
            [30.4689100222236, -0.443437470289662],
            [30.472047715340135, -0.448156628581941],
            [30.475638898673356, -0.450977881443307],
            [30.476597508879358, -0.452496684158799],
            [30.478308239845177, -0.461553877249304],
            [30.478066992784036, -0.465413239521585],
            [30.47750356045471, -0.46672362257092],
            [30.474164026673584, -0.4711332057961],
            [30.47307529999027, -0.475326667098811],
            [30.479278802136026, -0.476359329345372],
            [30.48282671811359, -0.477725450656975],
            [30.48693380660944, -0.483773767920192],
            [30.49318362678954, -0.489852695953262],
            [30.4961470242831, -0.491820529797897],
            [30.4995149169794, -0.493008613884322],
            [30.5031189938319, -0.493145606383705],
            [30.50860979958069, -0.492096476690953],
            [30.514837791597717, -0.49177298641631],
            [30.51639962950016, -0.492407633536553],
            [30.52112049460881, -0.496482925327385],
            [30.52317160711726, -0.498783466217187],
            [30.525731941322626, -0.499360964916475],
            [30.527143832437826, -0.496253150290415],
            [30.52803499174237, -0.489691269204754],
            [30.529566940000358, -0.485542990472879],
            [30.530339110259032, -0.480463421718064],
            [30.532174847186546, -0.476129197902811],
            [30.53311598605857, -0.475630734555327],
            [30.53440103505564, -0.474124517273525],
            [30.53373390659977, -0.472298218352862],
            [30.53385472192067, -0.471207627802608],
            [30.5315356976585, -0.468898296824515],
            [30.52963408906786, -0.469406902294281],
            [30.527523709310206, -0.468317357794598],
            [30.52426307186556, -0.46575502911761],
            [30.522051243566263, -0.463188118250879],
            [30.519539495641375, -0.462329682029154],
            [30.514292203403166, -0.461702145662666],
            [30.508238608518774, -0.458328576551745],
            [30.5068381394824, -0.456176873643076],
            [30.50728925455347, -0.455508164655304],
            [30.5095447715183, -0.45443333555951],
            [30.51056579846686, -0.452779597932269],
            [30.512109843438463, -0.445205651044559],
            [30.509593616513577, -0.442258172058258],
            [30.505605693133425, -0.436083391684756],
            [30.501866818682643, -0.432801109367892],
            [30.49903411707978, -0.432402471763921],
            [30.493334296720576, -0.433078486835764],
            [30.491953993964042, -0.43269840880919],
            [30.49115179482206, -0.431532163735808],
            [30.492378065253455, -0.429733881653595],
            [30.493657575238498, -0.429020249488654],
            [30.494435434527855, -0.427818367780894],
            [30.494712711218416, -0.426299966974048],
            [30.495682378787222, -0.425414495107987],
            [30.495689936313703, -0.424591980736821],
            [30.497229610083124, -0.423652460318652],
            [30.497510183590762, -0.422775802179058],
            [30.498340356270692, -0.422486832793518],
            [30.498781622212988, -0.42052558332722],
            [30.50049152313549, -0.418058573783281],
            [30.50474686868751, -0.418232947407512],
            [30.507375931198606, -0.418783861389476],
            [30.510173046939812, -0.421159139921583],
            [30.512271625529557, -0.421055239988877],
            [30.51666802275086, -0.423290796785621],
            [30.51742421467556, -0.424041180350252],
            [30.52181616254127, -0.422115429037866],
            [30.52434912238495, -0.419903666738267],
            [30.524277934491934, -0.418364465344917],
            [30.527211935516146, -0.417560443354889],
            [30.53213843577313, -0.41548096579516],
            [30.533237661965483, -0.414471216730186],
            [30.534098206685144, -0.412763945646279],
            [30.537849102391057, -0.411971461648355],
            [30.538613868735155, -0.410985650725496],
            [30.539331400763302, -0.408196078451819],
            [30.5404994136519, -0.399476169831312],
            [30.541434509557014, -0.397443750107576],
            [30.541590109442318, -0.394395601968913],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 173,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "BUKIRO",
        Population: 14559,
        Key: "MBARARABUKIRO",
        Dist2: "Mbarara",
        "Sub Country": "Bukiiro",
        id2_original: "Mbarara Bukiiro",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.619568392833134, -0.262817154423721],
            [30.617690551868296, -0.262250600108157],
            [30.61709994370494, -0.261151618043309],
            [30.61806129916244, -0.25640607521077],
            [30.617432337428077, -0.252904907108602],
            [30.618655158328785, -0.250718687536175],
            [30.620797072546143, -0.248804367108093],
            [30.621664006982463, -0.247339251968574],
            [30.622675066224627, -0.244596929085511],
            [30.624994536051148, -0.234456694644709],
            [30.623404597948337, -0.235373238923637],
            [30.622632697184258, -0.235407325209436],
            [30.62175261500546, -0.236146879463142],
            [30.620398079524495, -0.233710823401046],
            [30.61641422102101, -0.231842689777372],
            [30.615108035563633, -0.229650237952436],
            [30.614535774591662, -0.227441670141987],
            [30.614762364740596, -0.222659390872268],
            [30.613746626174116, -0.219728132689135],
            [30.611730875846842, -0.21639887190003],
            [30.610368804398966, -0.210325378327257],
            [30.608344753638477, -0.20847386048418],
            [30.60603417443829, -0.212776054650534],
            [30.605940499018764, -0.214246341321813],
            [30.60539199848609, -0.214757773781823],
            [30.603415276364615, -0.219840157170769],
            [30.60082741508402, -0.221445970970643],
            [30.599148663244, -0.221244112947743],
            [30.597898388031567, -0.222510519593511],
            [30.59747063275115, -0.224442838563299],
            [30.595994453702637, -0.226212598513615],
            [30.596155594396613, -0.227186937779967],
            [30.59532429343269, -0.230881066377116],
            [30.594654585015324, -0.232764623175744],
            [30.594049617282202, -0.233332868469294],
            [30.5943074140058, -0.235005480727792],
            [30.59384737956228, -0.236954024138258],
            [30.592790688598626, -0.238001225287357],
            [30.590628609898086, -0.241865606313061],
            [30.589491604158134, -0.240988528700509],
            [30.588725721208142, -0.239332070529499],
            [30.58785473626822, -0.239169534372289],
            [30.58702420066893, -0.2382762744752],
            [30.583241369854672, -0.237140468778111],
            [30.57930732922188, -0.23698193545372],
            [30.577711176573914, -0.235360134410849],
            [30.575658779474615, -0.234470094701614],
            [30.573830871364834, -0.234667605627896],
            [30.56610586567291, -0.238390390970016],
            [30.552445349538978, -0.245067827946418],
            [30.53053433572984, -0.250484333693253],
            [30.52272951741986, -0.252212103447813],
            [30.52112260744638, -0.251759858178306],
            [30.51993078291452, -0.252202533787814],
            [30.517115144810496, -0.254823249550607],
            [30.51412160704252, -0.256793127537325],
            [30.512803048190378, -0.257543089277597],
            [30.508982365963323, -0.258513167420818],
            [30.506317052837254, -0.261148274548542],
            [30.51519865023725, -0.264494276929161],
            [30.515583111212546, -0.266536415797989],
            [30.514917639250054, -0.268162511354782],
            [30.51453667721282, -0.272514990899447],
            [30.512587979833288, -0.276245346970393],
            [30.503958952758545, -0.282696077674129],
            [30.501057415052106, -0.285352827754928],
            [30.499583416214776, -0.288696818338731],
            [30.499387293327004, -0.291932619844437],
            [30.500756352769464, -0.291878690186268],
            [30.500756562076923, -0.292204083602993],
            [30.50317825748785, -0.293759276097452],
            [30.508125144111855, -0.29568706753188],
            [30.50841284485297, -0.296241907259579],
            [30.511806508418168, -0.297046591136259],
            [30.511185047616404, -0.301555451606004],
            [30.512803222463546, -0.300397389164281],
            [30.512605159214782, -0.302684425084945],
            [30.51421341666117, -0.306210414612061],
            [30.515478764705772, -0.307962817508212],
            [30.51754307795733, -0.306591561642073],
            [30.51837850218839, -0.304210343111244],
            [30.522763586925343, -0.302883956987986],
            [30.5305422498875, -0.301578082549475],
            [30.537309532908925, -0.300974854209432],
            [30.544030758407438, -0.296878930925302],
            [30.54485979022695, -0.297523286504785],
            [30.548499656858677, -0.296625619294227],
            [30.55200157909368, -0.296734861053097],
            [30.555159135757798, -0.296021472616283],
            [30.555610259812035, -0.295614814300541],
            [30.559634364636846, -0.295100470057473],
            [30.56479819619865, -0.296620171983361],
            [30.566199073968477, -0.29637642188635],
            [30.571042387535172, -0.297127734865054],
            [30.57211075390261, -0.296983341606947],
            [30.573392788153598, -0.297480777900278],
            [30.57472224626505, -0.296667543106618],
            [30.575861945154234, -0.296884733065831],
            [30.57655047058184, -0.296405805386153],
            [30.578307309376246, -0.296695444405311],
            [30.582426536806544, -0.295828576354955],
            [30.586771267424247, -0.296091658849086],
            [30.590558104724696, -0.294808901440973],
            [30.59667744550809, -0.297133328599094],
            [30.598756736370387, -0.295994823550737],
            [30.600539785309845, -0.295886736104314],
            [30.601368251190724, -0.295154726682512],
            [30.60255546826347, -0.295679264869227],
            [30.60459720775024, -0.295010790635139],
            [30.605143278340094, -0.294179283270167],
            [30.605475734046966, -0.292407633807495],
            [30.604739632045288, -0.290897900683285],
            [30.60489398417066, -0.290102465299771],
            [30.6061522409144, -0.289741156738325],
            [30.606270959567414, -0.290961499687197],
            [30.609072690852535, -0.29163100900893],
            [30.60957117049526, -0.29161303664783],
            [30.60912011381471, -0.28959715145216],
            [30.610378460389963, -0.290175939361444],
            [30.611100491181045, -0.28988682837618],
            [30.611283842720418, -0.285882400492818],
            [30.612623438319883, -0.283649936718903],
            [30.612601509545467, -0.281778767863029],
            [30.612221608418565, -0.280965141181903],
            [30.61257769610561, -0.280196861755824],
            [30.611865326695412, -0.279193339657885],
            [30.6118772455426, -0.277819347629003],
            [30.611141245948858, -0.277819199408724],
            [30.610452576790784, -0.276860881602425],
            [30.611734584990653, -0.274158348382894],
            [30.612209416483527, -0.273823983985928],
            [30.615319693915907, -0.27442120499935],
            [30.61618623039854, -0.271971681575804],
            [30.618418023755023, -0.27085122728987],
            [30.618441686277936, -0.267452386506929],
            [30.61746818829274, -0.265825094313098],
            [30.618714540562316, -0.26462308318798],
            [30.6191547366111, -0.262916630116405],
            [30.619568392833134, -0.262817154423721],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 174,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "KAGONGI",
        Population: 20712,
        Key: "MBARARAKAGONGI",
        Dist2: "Mbarara",
        "Sub Country": "Kagongi",
        id2_original: "Mbarara Kagongi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "H",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.664781930589506, -0.517628088594177],
            [30.659027580695923, -0.516794311709696],
            [30.64979263636879, -0.511855231024324],
            [30.646292516154233, -0.508963102048927],
            [30.639481263294577, -0.505657579602413],
            [30.637713331204743, -0.505366041826035],
            [30.632597168743512, -0.505776361900335],
            [30.631365643167666, -0.49918269832174],
            [30.63040925539368, -0.497576735742238],
            [30.626182924527047, -0.496932967966025],
            [30.622908375771914, -0.497591038178827],
            [30.619281966801434, -0.496360090712821],
            [30.61731684013366, -0.500372144676871],
            [30.617197827731566, -0.502424058064773],
            [30.617624748477073, -0.503255845322658],
            [30.61718222040183, -0.505235325866093],
            [30.617295534790067, -0.507305405436913],
            [30.616696476174887, -0.507992182734786],
            [30.617009154572454, -0.510830690245279],
            [30.616581156746896, -0.511465593323579],
            [30.61690554198927, -0.512308725585883],
            [30.616716543640013, -0.513950120734438],
            [30.614758878378993, -0.515461876745503],
            [30.613368048265606, -0.517366967077126],
            [30.61085302957478, -0.519709830100825],
            [30.61230757629293, -0.521354666436746],
            [30.612930476195775, -0.523328046563335],
            [30.614564300593496, -0.524271402580683],
            [30.61491347574444, -0.526006627786787],
            [30.614835488503054, -0.529158969035357],
            [30.613589433575818, -0.530000264649968],
            [30.611771192236773, -0.532189896728825],
            [30.61185605518337, -0.533392466116686],
            [30.61136933448768, -0.534362895548024],
            [30.6115816818478, -0.536862536349319],
            [30.61106927113165, -0.538064870371207],
            [30.612067132325663, -0.53918190391453],
            [30.612850916004312, -0.542265860809955],
            [30.611323080233703, -0.543622404201475],
            [30.61097290525785, -0.54450698927821],
            [30.611194249245568, -0.545778329030852],
            [30.61085197046107, -0.548269158446983],
            [30.60946958900295, -0.548595008286514],
            [30.60913586577321, -0.551017121284411],
            [30.609476899492734, -0.55167865225071],
            [30.608437297180725, -0.555330137977982],
            [30.608769900211282, -0.557454085453344],
            [30.61005266569094, -0.557849235630079],
            [30.61092869017958, -0.55944245410485],
            [30.60997338128225, -0.560044768216972],
            [30.60942412167316, -0.561163851998117],
            [30.6084761052993, -0.561357188916792],
            [30.60503071314681, -0.568430348555804],
            [30.603847371406168, -0.568924932995838],
            [30.60380395223523, -0.570517769367619],
            [30.603233640607428, -0.570818880494557],
            [30.60231430564399, -0.570596071628407],
            [30.598963656109547, -0.57254626827166],
            [30.59705228911997, -0.575544607060184],
            [30.595565387780223, -0.575728136186273],
            [30.591878594954693, -0.583199985488404],
            [30.59355168201851, -0.58689352523823],
            [30.59336073432508, -0.588027893184593],
            [30.590540679204796, -0.590327892589428],
            [30.588448432839492, -0.593116975970692],
            [30.587203618485677, -0.593450562738236],
            [30.586448227858188, -0.594126845538568],
            [30.58538514807624, -0.59582265567933],
            [30.5882629415131, -0.599423165286271],
            [30.588854345583776, -0.60113226722813],
            [30.589919937055278, -0.601768587036663],
            [30.590708827656332, -0.603239336194868],
            [30.592208838111006, -0.60347844458361],
            [30.593155723505895, -0.604750564380733],
            [30.59611624100066, -0.605308249635178],
            [30.596747294911335, -0.606619972606157],
            [30.598760182307792, -0.607614388627815],
            [30.600176278436837, -0.610277218429532],
            [30.600939820377228, -0.610140086700808],
            [30.601483256208333, -0.611306407378627],
            [30.602820105657965, -0.612156706855318],
            [30.603355060494508, -0.613784032234701],
            [30.603784160552912, -0.613974050942876],
            [30.60478995387086, -0.61343214189437],
            [30.605864233847782, -0.614110577143827],
            [30.60580182878332, -0.615303747849438],
            [30.60719988584316, -0.617970998672649],
            [30.60846189125656, -0.61834218430025],
            [30.60842996692801, -0.617248401704782],
            [30.608738515770224, -0.617203343926401],
            [30.60993004745126, -0.617664891281818],
            [30.612208291792797, -0.617578076848626],
            [30.612062821310623, -0.613999120584636],
            [30.61330779466626, -0.612850279809586],
            [30.616510741405044, -0.611137379213392],
            [30.61808512787368, -0.608776065824672],
            [30.618291457419705, -0.606175955738761],
            [30.61993009768566, -0.602427829611613],
            [30.621793648251007, -0.594783564901731],
            [30.624240351861094, -0.591417519830952],
            [30.62586249277026, -0.590681391421502],
            [30.630564447443874, -0.589990699987702],
            [30.631605799674027, -0.589261896763076],
            [30.638267430038297, -0.586972836028089],
            [30.642952854812346, -0.586112985847766],
            [30.645173059901676, -0.586189688077611],
            [30.646772090751814, -0.586900664673559],
            [30.646827533872838, -0.589306247836098],
            [30.648709074100058, -0.590382349164378],
            [30.64956409867232, -0.588194150008526],
            [30.65112536704284, -0.586514264731901],
            [30.658569253949757, -0.592865127905126],
            [30.66450999168837, -0.591746362052567],
            [30.66587427029688, -0.590458288706366],
            [30.667580003036488, -0.589712294495715],
            [30.67146147605546, -0.588655557896772],
            [30.672862913475704, -0.588733053262249],
            [30.6745338823121, -0.587788621539001],
            [30.677421654235154, -0.585256910059317],
            [30.68057972473561, -0.584088628318909],
            [30.682661421286205, -0.582732909973036],
            [30.683561058890415, -0.5880829875523],
            [30.686041000166043, -0.590566901831853],
            [30.687569298569024, -0.589143011021639],
            [30.688857373990327, -0.586250769421378],
            [30.690215363493525, -0.585136884330073],
            [30.692867519893937, -0.583906337277989],
            [30.70134245894799, -0.583763695809895],
            [30.698392360113893, -0.590764491948203],
            [30.697129908237798, -0.596838795550777],
            [30.698525491337328, -0.599412219015268],
            [30.697890461483208, -0.603153486265963],
            [30.698254563939223, -0.60797525570826],
            [30.703144374305054, -0.611371882750781],
            [30.705719133657215, -0.613243411277301],
            [30.706507262486927, -0.614879774654122],
            [30.707807967322786, -0.614639309494868],
            [30.709318059569885, -0.617210778850606],
            [30.710709728709734, -0.618606835021597],
            [30.711582481534116, -0.618496248075017],
            [30.712873653448174, -0.62015071252457],
            [30.713710068521028, -0.622766574023182],
            [30.71416257598077, -0.623043030382891],
            [30.714024019831356, -0.622020449524231],
            [30.714854443141245, -0.621988520788981],
            [30.71475436902196, -0.622645043634706],
            [30.715299562856117, -0.622871311397011],
            [30.714768147381804, -0.6234696743569],
            [30.716414337987736, -0.624629816560203],
            [30.71769297750525, -0.626567786613743],
            [30.718795319055012, -0.627063220064673],
            [30.71994917179979, -0.626145410532411],
            [30.721709710754883, -0.62633274479119],
            [30.722451337395544, -0.625604741432178],
            [30.72302510124899, -0.625701861490099],
            [30.722067008472617, -0.624244793648727],
            [30.724288326574545, -0.622046425474702],
            [30.724662561128657, -0.622014297325405],
            [30.724854661360595, -0.622850342364102],
            [30.725296532767395, -0.6230048093273],
            [30.727021875729644, -0.622166005749486],
            [30.72704704203233, -0.621652957809509],
            [30.72630590587178, -0.621232862022065],
            [30.727286205001967, -0.620774043898956],
            [30.727657805695657, -0.619722483746975],
            [30.728645649775963, -0.618675361703311],
            [30.72991032498241, -0.618417968950077],
            [30.730266258159215, -0.616717294604471],
            [30.73231270481807, -0.613251460619511],
            [30.73504200404353, -0.611910562748338],
            [30.734748872986536, -0.611074403707651],
            [30.73396541898959, -0.610596338499731],
            [30.73405299125507, -0.610228646582359],
            [30.73452772393326, -0.609823400900124],
            [30.736197755826815, -0.61055642322832],
            [30.736669586946647, -0.609623153507856],
            [30.738046749192968, -0.608894558598592],
            [30.73861235903859, -0.607681600390611],
            [30.739808170293635, -0.60760038378177],
            [30.740492210433036, -0.606893496068821],
            [30.742246594131778, -0.607519688165269],
            [30.742873881406485, -0.608154837684529],
            [30.744968999685742, -0.607772268539889],
            [30.745021700250227, -0.608680621619415],
            [30.74555547919204, -0.608941713894617],
            [30.746027499856392, -0.607549558164107],
            [30.747392044366247, -0.607150965728283],
            [30.747941892371863, -0.606302581460886],
            [30.748600189490173, -0.606570528510791],
            [30.74929176739311, -0.606343527073709],
            [30.749340887272833, -0.605646273089774],
            [30.75052404935042, -0.60597678343449],
            [30.750099190238448, -0.60657378022992],
            [30.75028314993729, -0.607174174197119],
            [30.75082028229006, -0.60688209618909],
            [30.75190325706063, -0.60788831715752],
            [30.75333613551582, -0.608363511751988],
            [30.753579326531213, -0.60918080047322],
            [30.754241109112826, -0.609467092635468],
            [30.754306325005807, -0.610312595671678],
            [30.756095455539747, -0.610005326386555],
            [30.75674517734033, -0.609254412351074],
            [30.757211535025146, -0.610592727477359],
            [30.75776997541647, -0.610495647565014],
            [30.757772143051263, -0.609811158454563],
            [30.758156216852647, -0.609701313292395],
            [30.759229868008873, -0.610616385961767],
            [30.760532825819457, -0.608165356363934],
            [30.76169069044031, -0.607621386110368],
            [30.762594454904956, -0.606164280090142],
            [30.76362786153645, -0.605843929134765],
            [30.76498271771594, -0.606265658278395],
            [30.765073759275044, -0.605046191549491],
            [30.768108032946195, -0.605779307945636],
            [30.767837017513173, -0.604755027860735],
            [30.768549050055125, -0.604331008023056],
            [30.770880678579033, -0.605941217528253],
            [30.771799005632758, -0.605151117007866],
            [30.771996069056627, -0.604062122175203],
            [30.772979230219335, -0.604880389756901],
            [30.77342691462432, -0.604802449079339],
            [30.77485892620525, -0.603832468055429],
            [30.775324740409324, -0.603073422063967],
            [30.77701644326079, -0.60322077443661],
            [30.777722901756423, -0.602326350745989],
            [30.77805031162636, -0.603373130143987],
            [30.779427493635616, -0.602669643611974],
            [30.78094458735203, -0.603424604348438],
            [30.78314896143111, -0.603218061674827],
            [30.784191397927827, -0.604180274609748],
            [30.786053630664664, -0.603581852901959],
            [30.7856091173126, -0.60219149232632],
            [30.784542471218973, -0.601666706633973],
            [30.783760905480758, -0.600572485891501],
            [30.78282626951306, -0.598022679292305],
            [30.783895903403334, -0.594922213291441],
            [30.781943337878204, -0.590346925981668],
            [30.778188740214986, -0.585870382443035],
            [30.775505851550367, -0.584073612860835],
            [30.77408499794359, -0.582361819839417],
            [30.77291262373428, -0.580750200375139],
            [30.773042794110516, -0.57832851476569],
            [30.77214834876863, -0.57776776100574],
            [30.770280435085983, -0.575355301153831],
            [30.76749752440438, -0.574123330912976],
            [30.764605866369415, -0.571350226454782],
            [30.76027359897794, -0.570696511770118],
            [30.757892307991867, -0.569455392537467],
            [30.757153444568974, -0.568661383871888],
            [30.755543783055785, -0.568445791632119],
            [30.750438877383385, -0.565894698526374],
            [30.74164659857376, -0.557550582404499],
            [30.731036190714484, -0.559538544105947],
            [30.72660997751059, -0.568612657159097],
            [30.72164596720061, -0.569379448222351],
            [30.712482164054116, -0.569567999778404],
            [30.70370197387326, -0.565336401222829],
            [30.697590928133163, -0.570330797002684],
            [30.692822078615297, -0.560527459346724],
            [30.688623317943016, -0.557450851671389],
            [30.676980067594297, -0.552257329086111],
            [30.671447157808153, -0.543606974534344],
            [30.67045799410271, -0.538368216261807],
            [30.671250792375226, -0.53537987259375],
            [30.673694997770557, -0.532295878088096],
            [30.67627745209145, -0.53090913032202],
            [30.671008526624583, -0.524057696927847],
            [30.67000476349914, -0.523307019676237],
            [30.669617178183298, -0.522312494906772],
            [30.66638230801426, -0.518722498177512],
            [30.664781930589506, -0.517628088594177],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 175,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "KAKIIKA DIVISION",
        Population: 21676,
        Key: "MBARARAKAKIIKA DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Kakiika Division",
        id2_original: "Mbarara Kakiika Division",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.611100491181045, -0.28988682837618],
            [30.610378460389963, -0.290175939361444],
            [30.60912011381471, -0.28959715145216],
            [30.60957117049526, -0.29161303664783],
            [30.609072690852535, -0.29163100900893],
            [30.606270959567414, -0.290961499687197],
            [30.6061522409144, -0.289741156738325],
            [30.60489398417066, -0.290102465299771],
            [30.604739632045288, -0.290897900683285],
            [30.605475734046966, -0.292407633807495],
            [30.605143278340094, -0.294179283270167],
            [30.60459720775024, -0.295010790635139],
            [30.60255546826347, -0.295679264869227],
            [30.601368251190724, -0.295154726682512],
            [30.600539785309845, -0.295886736104314],
            [30.598756736370387, -0.295994823550737],
            [30.59667744550809, -0.297133328599094],
            [30.59632704775006, -0.300107193294761],
            [30.588848371787147, -0.312489364566702],
            [30.588646612869283, -0.314414684123169],
            [30.58703160009192, -0.315345357042281],
            [30.586960958374604, -0.316276385605654],
            [30.585560105757597, -0.318743777259409],
            [30.58439652066503, -0.322277850597727],
            [30.582449939716327, -0.326390243332854],
            [30.579268493255533, -0.33043904729856],
            [30.57853239394878, -0.330908907774224],
            [30.577677736787464, -0.330836385295664],
            [30.576442879360275, -0.332526413216877],
            [30.57619242366916, -0.336684383249505],
            [30.573411993236043, -0.340416871095613],
            [30.573411779437, -0.341275592311654],
            [30.57194992312737, -0.34461067718144],
            [30.571717413080698, -0.348108773354304],
            [30.571147149063616, -0.348542506094055],
            [30.572464641615493, -0.352420650161283],
            [30.571571095487233, -0.352772943880063],
            [30.566297918294133, -0.3684650781289],
            [30.56538055243777, -0.376866558491474],
            [30.56733933520301, -0.382225119757916],
            [30.567005508667002, -0.383232381806418],
            [30.56523513765115, -0.383335842055969],
            [30.565158054114953, -0.383723275859536],
            [30.565262816541686, -0.387682313136779],
            [30.566496860095267, -0.392974834003787],
            [30.569601786263505, -0.391301767260852],
            [30.57453878962278, -0.39048397712645],
            [30.57858045471479, -0.390444181785187],
            [30.578742595233695, -0.392587859652378],
            [30.57966180083975, -0.393966794129674],
            [30.581300089864442, -0.399321456748967],
            [30.58192255588099, -0.399263677614656],
            [30.58260350132425, -0.400121091503869],
            [30.585359349359596, -0.399930573357073],
            [30.590632430432976, -0.398147866792594],
            [30.591771870607328, -0.399692048608729],
            [30.593666970903772, -0.401307091099502],
            [30.59524067824606, -0.400651337001093],
            [30.59794749084331, -0.39803976254747],
            [30.601283363091305, -0.397507411281547],
            [30.60256550514014, -0.397652415640237],
            [30.607254752245748, -0.396469614342039],
            [30.60977139329399, -0.397573150208259],
            [30.613593855981964, -0.398505320263664],
            [30.614686046569016, -0.399129357587095],
            [30.616181719059185, -0.40080209038151],
            [30.621939469974446, -0.400360830732369],
            [30.625097200013396, -0.400886037686998],
            [30.62831440750731, -0.399992057946923],
            [30.630641209383217, -0.39980289801681],
            [30.633514188748464, -0.398203721789857],
            [30.639485671327698, -0.398313910073903],
            [30.641551301509445, -0.397952916419399],
            [30.64200241837714, -0.398287512818808],
            [30.642857256998134, -0.397862895720744],
            [30.64609812521833, -0.397773422980231],
            [30.64854381552879, -0.396011383893926],
            [30.65305516297047, -0.395343725183401],
            [30.654717154043947, -0.393979197773894],
            [30.654499420385367, -0.392672709826884],
            [30.6551579780151, -0.390884189739304],
            [30.65515106727563, -0.389426724050289],
            [30.656738249347182, -0.387542765745692],
            [30.65788620644875, -0.387543083742057],
            [30.65834698469733, -0.387057389239301],
            [30.658304191652135, -0.383082468015807],
            [30.66337948705614, -0.383496731212469],
            [30.665569906705574, -0.381648615377235],
            [30.66866331647189, -0.381086493565781],
            [30.671838885255774, -0.381747561711758],
            [30.673495544828008, -0.382668854266569],
            [30.677836768422875, -0.383276113511043],
            [30.680052940974903, -0.384586224837009],
            [30.68038802874553, -0.37819371864744],
            [30.679509677620302, -0.373528908176619],
            [30.67961666158073, -0.368367167380336],
            [30.67894008823797, -0.365157838287971],
            [30.679414958358418, -0.363196306775674],
            [30.679284554420203, -0.357293237097494],
            [30.676708428730485, -0.350991806010705],
            [30.675782371673744, -0.347719150656061],
            [30.674749566015176, -0.346082683765479],
            [30.67247024998354, -0.344048163206956],
            [30.666249378911765, -0.340837520454876],
            [30.66374451657353, -0.338576970437101],
            [30.663127216768153, -0.335467141165732],
            [30.662486141252163, -0.33439125541724],
            [30.66247425204938, -0.332438663664095],
            [30.66202316572442, -0.331887131602563],
            [30.66249805470947, -0.330242006912583],
            [30.660076237127676, -0.329834649249087],
            [30.653036231874175, -0.326397905837896],
            [30.647053053229964, -0.326423627780341],
            [30.644417492306093, -0.325817354734589],
            [30.643574596786806, -0.324443131444032],
            [30.64127151941758, -0.314688838629848],
            [30.638054292160696, -0.310222546130198],
            [30.63401797653621, -0.307762880565079],
            [30.624817574228402, -0.303819608412594],
            [30.62346421823543, -0.302671292797056],
            [30.621790232856277, -0.299787325571587],
            [30.61882247224541, -0.29926239322512],
            [30.61386024778619, -0.297399190412289],
            [30.612554362366104, -0.296052031097745],
            [30.61217435523798, -0.293114134284209],
            [30.61101096328318, -0.29064612142283],
            [30.611100491181045, -0.28988682837618],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 176,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "KASHARE",
        Population: 22911,
        Key: "MBARARAKASHARE",
        Dist2: "Mbarara",
        "Sub Country": "Kashare",
        id2_original: "Mbarara Kashare",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.680052940974903, -0.384586224837009],
            [30.677836768422875, -0.383276113511043],
            [30.673495544828008, -0.382668854266569],
            [30.671838885255774, -0.381747561711758],
            [30.66866331647189, -0.381086493565781],
            [30.665569906705574, -0.381648615377235],
            [30.66337948705614, -0.383496731212469],
            [30.658304191652135, -0.383082468015807],
            [30.65834698469733, -0.387057389239301],
            [30.65788620644875, -0.387543083742057],
            [30.656738249347182, -0.387542765745692],
            [30.65515106727563, -0.389426724050289],
            [30.6551579780151, -0.390884189739304],
            [30.654499420385367, -0.392672709826884],
            [30.654717154043947, -0.393979197773894],
            [30.654982833484176, -0.395181555285837],
            [30.65447220053395, -0.397938523060777],
            [30.654994429836172, -0.398869763341067],
            [30.65508597445182, -0.400493541896454],
            [30.65022830221361, -0.401807648828198],
            [30.64832747695387, -0.403210494325316],
            [30.644095336682277, -0.405219132110424],
            [30.63921961998494, -0.406547212119661],
            [30.637864790754897, -0.409574214412515],
            [30.637781020159697, -0.410552190604744],
            [30.63598937883454, -0.412186753507571],
            [30.633476975139505, -0.412950068147823],
            [30.628436670912436, -0.415592204844493],
            [30.62417900321542, -0.415224177440632],
            [30.623487536703554, -0.416489011570325],
            [30.621890222533935, -0.41763196621642],
            [30.621034393071174, -0.421601928211271],
            [30.619497107922097, -0.425788745387896],
            [30.619576186616552, -0.428214406870883],
            [30.6177869671494, -0.428852034784195],
            [30.614083197063316, -0.428823762000885],
            [30.611590028993426, -0.42987155717357],
            [30.609429395682188, -0.429943195800802],
            [30.6060099073492, -0.437951026460443],
            [30.60524986075362, -0.440752991571972],
            [30.598755784156168, -0.445785814026362],
            [30.59753545608037, -0.448799673268268],
            [30.597124839757246, -0.450656971835237],
            [30.598046255218893, -0.454062574764927],
            [30.597890950879336, -0.458757705986162],
            [30.599427231711918, -0.462576287592846],
            [30.601015415405005, -0.464434265297921],
            [30.604449249833074, -0.466382108795536],
            [30.60591201703439, -0.467925613777979],
            [30.60717011297969, -0.470339563842633],
            [30.608345227050613, -0.471686837630931],
            [30.60972190959658, -0.476044310039058],
            [30.610386662906826, -0.476830969874759],
            [30.615289421589154, -0.478188591529481],
            [30.616737560624404, -0.479554054933493],
            [30.617734525299742, -0.481226703216229],
            [30.61939759075828, -0.482523051188251],
            [30.61887260362813, -0.484049712448432],
            [30.61951030058037, -0.484506563112976],
            [30.620161277327394, -0.487531945106105],
            [30.620997283666778, -0.488374148024094],
            [30.620897797045693, -0.489130401366161],
            [30.62136529289597, -0.48988685673657],
            [30.620131521531945, -0.491541689526394],
            [30.620952871857444, -0.493739501016986],
            [30.619662584783956, -0.49486633541801],
            [30.619281966801434, -0.496360090712821],
            [30.622908375771914, -0.497591038178827],
            [30.626182924527047, -0.496932967966025],
            [30.63040925539368, -0.497576735742238],
            [30.631365643167666, -0.49918269832174],
            [30.632597168743512, -0.505776361900335],
            [30.637713331204743, -0.505366041826035],
            [30.639481263294577, -0.505657579602413],
            [30.646292516154233, -0.508963102048927],
            [30.64979263636879, -0.511855231024324],
            [30.659027580695923, -0.516794311709696],
            [30.664781930589506, -0.517628088594177],
            [30.6634540876489, -0.515820180438799],
            [30.661823802613416, -0.515478083493962],
            [30.65942791669893, -0.511542327052166],
            [30.659104533078114, -0.509666386857377],
            [30.659381814260225, -0.506538871566108],
            [30.662350911564243, -0.505497403646923],
            [30.667874237224652, -0.505221380063486],
            [30.674679379743715, -0.502719180112865],
            [30.686246821265613, -0.506338327818302],
            [30.68878879390658, -0.506208675441728],
            [30.690014236989615, -0.505699693677629],
            [30.69300655125215, -0.501338129973187],
            [30.698834482150648, -0.496621355005525],
            [30.704623797170054, -0.494655663185863],
            [30.707715707648145, -0.494203013578535],
            [30.71860467139891, -0.493798885536843],
            [30.72684034507532, -0.492592236795574],
            [30.736546590516262, -0.490413446954668],
            [30.742444316919084, -0.490439190829314],
            [30.74645449695872, -0.491319263165729],
            [30.749852275706218, -0.48932547689333],
            [30.753061006697124, -0.488305335081271],
            [30.757084722551426, -0.488541316626832],
            [30.763244411165847, -0.489602791075236],
            [30.766308132510325, -0.490856831037284],
            [30.768130702830682, -0.490666629634724],
            [30.771846159998635, -0.488700858806082],
            [30.77285596159943, -0.486675835765538],
            [30.773046133148434, -0.484738423468379],
            [30.77449069958379, -0.481230892810946],
            [30.774869791328612, -0.480637154274787],
            [30.77668649115863, -0.4802889920887],
            [30.736843829569054, -0.442499428097863],
            [30.73179194246471, -0.440199320528664],
            [30.731257366717248, -0.438844041594036],
            [30.73134461828416, -0.435612639587492],
            [30.728514680797403, -0.434656258733444],
            [30.725743578470215, -0.435707111776522],
            [30.724552615422738, -0.435776231545461],
            [30.721112297853253, -0.434436585642053],
            [30.71797591448039, -0.435911517506231],
            [30.713235261282648, -0.435876171619346],
            [30.708205837450326, -0.438559385502971],
            [30.70637096829537, -0.440349498240558],
            [30.705251568636694, -0.440600327404997],
            [30.704875832997736, -0.438118048034986],
            [30.70319102381776, -0.433958964222122],
            [30.7004253266536, -0.430649395428769],
            [30.696321700264868, -0.428447368548382],
            [30.69229408302727, -0.428034166737571],
            [30.690167841716672, -0.428468464892976],
            [30.686073170632998, -0.426025428756279],
            [30.68369900867702, -0.423276585825617],
            [30.682084603160792, -0.419108714054595],
            [30.67923569954349, -0.414226338793944],
            [30.67930692247076, -0.412463583753463],
            [30.680232966951085, -0.411885301964688],
            [30.682749934087777, -0.411361720735209],
            [30.683699760566927, -0.410548406099597],
            [30.686881413640222, -0.411814916289048],
            [30.68950508985289, -0.41056816673189],
            [30.692354533357687, -0.409773473615191],
            [30.69351796034677, -0.410280046683251],
            [30.69418278552225, -0.410108479149101],
            [30.695346394869343, -0.406999064099681],
            [30.6961433909692, -0.402325621735282],
            [30.695673925113496, -0.399279017772279],
            [30.696700504548847, -0.398447626461518],
            [30.696814731625402, -0.397878139763571],
            [30.69664399063598, -0.396296094524403],
            [30.69561790257911, -0.39534661050339],
            [30.69537607610464, -0.393574708530895],
            [30.696482448395077, -0.389830289148469],
            [30.694566075094404, -0.388393909845647],
            [30.691097186607333, -0.387089837443513],
            [30.68878025901306, -0.386372401708537],
            [30.68129153090213, -0.385318431386836],
            [30.680052940974903, -0.384586224837009],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 177,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "RUBAYA",
        Population: 18245,
        Key: "MBARARARUBAYA",
        Dist2: "Mbarara",
        "Sub Country": "Rubaya",
        id2_original: "Mbarara Rubaya",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "H",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.59667744550809, -0.297133328599094],
            [30.590558104724696, -0.294808901440973],
            [30.586771267424247, -0.296091658849086],
            [30.582426536806544, -0.295828576354955],
            [30.578307309376246, -0.296695444405311],
            [30.57655047058184, -0.296405805386153],
            [30.575861945154234, -0.296884733065831],
            [30.57472224626505, -0.296667543106618],
            [30.573392788153598, -0.297480777900278],
            [30.57211075390261, -0.296983341606947],
            [30.571042387535172, -0.297127734865054],
            [30.566199073968477, -0.29637642188635],
            [30.56479819619865, -0.296620171983361],
            [30.559634364636846, -0.295100470057473],
            [30.555610259812035, -0.295614814300541],
            [30.555159135757798, -0.296021472616283],
            [30.55200157909368, -0.296734861053097],
            [30.548499656858677, -0.296625619294227],
            [30.54485979022695, -0.297523286504785],
            [30.544030758407438, -0.296878930925302],
            [30.537309532908925, -0.300974854209432],
            [30.5305422498875, -0.301578082549475],
            [30.522763586925343, -0.302883956987986],
            [30.51837850218839, -0.304210343111244],
            [30.51754307795733, -0.306591561642073],
            [30.515478764705772, -0.307962817508212],
            [30.51421341666117, -0.306210414612061],
            [30.512605159214782, -0.302684425084945],
            [30.512803222463546, -0.300397389164281],
            [30.511185047616404, -0.301555451606004],
            [30.511806508418168, -0.297046591136259],
            [30.50841284485297, -0.296241907259579],
            [30.508125144111855, -0.29568706753188],
            [30.50317825748785, -0.293759276097452],
            [30.500756562076923, -0.292204083602993],
            [30.500756352769464, -0.291878690186268],
            [30.499387293327004, -0.291932619844437],
            [30.498812942873688, -0.296478940746111],
            [30.499565877507177, -0.298892436098712],
            [30.50090392351275, -0.300140078369513],
            [30.500911540328044, -0.301206645098292],
            [30.501218073350767, -0.301170560271897],
            [30.505449497665072, -0.311086997492931],
            [30.506762256993753, -0.316049564449726],
            [30.50785537284552, -0.323660436465567],
            [30.507085884057975, -0.336224074671524],
            [30.505970578920376, -0.344343913804556],
            [30.505361902043404, -0.347160476194863],
            [30.505385615770283, -0.349293618491027],
            [30.506572266006096, -0.358432079237689],
            [30.50660770364573, -0.363819164498393],
            [30.50600199390417, -0.370263602701872],
            [30.505028644141, -0.373408798788246],
            [30.513154131362995, -0.371202241675818],
            [30.514213636748423, -0.371315116214899],
            [30.515074863289417, -0.373829511315071],
            [30.516400488289555, -0.37532058131245],
            [30.52024581669478, -0.376033647758443],
            [30.52256659985826, -0.375322330294806],
            [30.524953071428563, -0.376813709051481],
            [30.526742422049722, -0.379728882532059],
            [30.528178578457396, -0.381153253084108],
            [30.531161908668786, -0.382199831846998],
            [30.535847254391133, -0.38244592163692],
            [30.537526049350273, -0.385561337529683],
            [30.538828672987567, -0.39023412012245],
            [30.540684181834497, -0.393638848525297],
            [30.541590109442318, -0.394395601968913],
            [30.543110371516764, -0.394587893475638],
            [30.543822385194108, -0.396884008929079],
            [30.54382176625488, -0.398988587809969],
            [30.54429504276401, -0.399451716486988],
            [30.545356409458723, -0.399751195840874],
            [30.550761029940855, -0.399483758614401],
            [30.554888609008295, -0.399754041634413],
            [30.556414512502744, -0.397212236469506],
            [30.55724190759182, -0.394897421321858],
            [30.558296924095785, -0.394094156055467],
            [30.55838267906944, -0.393290605952378],
            [30.559361880458372, -0.39176983788352],
            [30.562070366617014, -0.390890518223178],
            [30.562868454169912, -0.391340370561508],
            [30.56481650835572, -0.391264406301103],
            [30.56510229658357, -0.388777219348223],
            [30.564709112068563, -0.384923018999331],
            [30.565158054114953, -0.383723275859536],
            [30.56523513765115, -0.383335842055969],
            [30.567005508667002, -0.383232381806418],
            [30.56733933520301, -0.382225119757916],
            [30.56538055243777, -0.376866558491474],
            [30.566297918294133, -0.3684650781289],
            [30.571571095487233, -0.352772943880063],
            [30.572464641615493, -0.352420650161283],
            [30.571147149063616, -0.348542506094055],
            [30.571717413080698, -0.348108773354304],
            [30.57194992312737, -0.34461067718144],
            [30.573411779437, -0.341275592311654],
            [30.573411993236043, -0.340416871095613],
            [30.57619242366916, -0.336684383249505],
            [30.576442879360275, -0.332526413216877],
            [30.577677736787464, -0.330836385295664],
            [30.57853239394878, -0.330908907774224],
            [30.579268493255533, -0.33043904729856],
            [30.582449939716327, -0.326390243332854],
            [30.58439652066503, -0.322277850597727],
            [30.585560105757597, -0.318743777259409],
            [30.586960958374604, -0.316276385605654],
            [30.58703160009192, -0.315345357042281],
            [30.588646612869283, -0.314414684123169],
            [30.588848371787147, -0.312489364566702],
            [30.59632704775006, -0.300107193294761],
            [30.59667744550809, -0.297133328599094],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 178,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "RUBINDI",
        Population: 23860,
        Key: "MBARARARUBINDI",
        Dist2: "Mbarara",
        "Sub Country": "Rubindi",
        id2_original: "Mbarara Rubindi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "H",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.654717154043947, -0.393979197773894],
            [30.65305516297047, -0.395343725183401],
            [30.64854381552879, -0.396011383893926],
            [30.64609812521833, -0.397773422980231],
            [30.642857256998134, -0.397862895720744],
            [30.64200241837714, -0.398287512818808],
            [30.641551301509445, -0.397952916419399],
            [30.639485671327698, -0.398313910073903],
            [30.633514188748464, -0.398203721789857],
            [30.630641209383217, -0.39980289801681],
            [30.62831440750731, -0.399992057946923],
            [30.625097200013396, -0.400886037686998],
            [30.621939469974446, -0.400360830732369],
            [30.616181719059185, -0.40080209038151],
            [30.614686046569016, -0.399129357587095],
            [30.613593855981964, -0.398505320263664],
            [30.60977139329399, -0.397573150208259],
            [30.607254752245748, -0.396469614342039],
            [30.60256550514014, -0.397652415640237],
            [30.601283363091305, -0.397507411281547],
            [30.59794749084331, -0.39803976254747],
            [30.59524067824606, -0.400651337001093],
            [30.593666970903772, -0.401307091099502],
            [30.591771870607328, -0.399692048608729],
            [30.590632430432976, -0.398147866792594],
            [30.585359349359596, -0.399930573357073],
            [30.58260350132425, -0.400121091503869],
            [30.58192255588099, -0.399263677614656],
            [30.581300089864442, -0.399321456748967],
            [30.57966180083975, -0.393966794129674],
            [30.578742595233695, -0.392587859652378],
            [30.57858045471479, -0.390444181785187],
            [30.57453878962278, -0.39048397712645],
            [30.569601786263505, -0.391301767260852],
            [30.566496860095267, -0.392974834003787],
            [30.565262816541686, -0.387682313136779],
            [30.565158054114953, -0.383723275859536],
            [30.564709112068563, -0.384923018999331],
            [30.56510229658357, -0.388777219348223],
            [30.56481650835572, -0.391264406301103],
            [30.562868454169912, -0.391340370561508],
            [30.562070366617014, -0.390890518223178],
            [30.559361880458372, -0.39176983788352],
            [30.55838267906944, -0.393290605952378],
            [30.558296924095785, -0.394094156055467],
            [30.55724190759182, -0.394897421321858],
            [30.556414512502744, -0.397212236469506],
            [30.554888609008295, -0.399754041634413],
            [30.550761029940855, -0.399483758614401],
            [30.545356409458723, -0.399751195840874],
            [30.54429504276401, -0.399451716486988],
            [30.54382176625488, -0.398988587809969],
            [30.543822385194108, -0.396884008929079],
            [30.543110371516764, -0.394587893475638],
            [30.541590109442318, -0.394395601968913],
            [30.541434509557014, -0.397443750107576],
            [30.5404994136519, -0.399476169831312],
            [30.539331400763302, -0.408196078451819],
            [30.538613868735155, -0.410985650725496],
            [30.537849102391057, -0.411971461648355],
            [30.534098206685144, -0.412763945646279],
            [30.533237661965483, -0.414471216730186],
            [30.53213843577313, -0.41548096579516],
            [30.527211935516146, -0.417560443354889],
            [30.524277934491934, -0.418364465344917],
            [30.52434912238495, -0.419903666738267],
            [30.52181616254127, -0.422115429037866],
            [30.51742421467556, -0.424041180350252],
            [30.51666802275086, -0.423290796785621],
            [30.512271625529557, -0.421055239988877],
            [30.510173046939812, -0.421159139921583],
            [30.507375931198606, -0.418783861389476],
            [30.50474686868751, -0.418232947407512],
            [30.50049152313549, -0.418058573783281],
            [30.498781622212988, -0.42052558332722],
            [30.498340356270692, -0.422486832793518],
            [30.497510183590762, -0.422775802179058],
            [30.497229610083124, -0.423652460318652],
            [30.495689936313703, -0.424591980736821],
            [30.495682378787222, -0.425414495107987],
            [30.494712711218416, -0.426299966974048],
            [30.494435434527855, -0.427818367780894],
            [30.493657575238498, -0.429020249488654],
            [30.492378065253455, -0.429733881653595],
            [30.49115179482206, -0.431532163735808],
            [30.491953993964042, -0.43269840880919],
            [30.493334296720576, -0.433078486835764],
            [30.49903411707978, -0.432402471763921],
            [30.501866818682643, -0.432801109367892],
            [30.505605693133425, -0.436083391684756],
            [30.509593616513577, -0.442258172058258],
            [30.512109843438463, -0.445205651044559],
            [30.51056579846686, -0.452779597932269],
            [30.5095447715183, -0.45443333555951],
            [30.50728925455347, -0.455508164655304],
            [30.5068381394824, -0.456176873643076],
            [30.508238608518774, -0.458328576551745],
            [30.514292203403166, -0.461702145662666],
            [30.519539495641375, -0.462329682029154],
            [30.522051243566263, -0.463188118250879],
            [30.52426307186556, -0.46575502911761],
            [30.527523709310206, -0.468317357794598],
            [30.52963408906786, -0.469406902294281],
            [30.5315356976585, -0.468898296824515],
            [30.53385472192067, -0.471207627802608],
            [30.53373390659977, -0.472298218352862],
            [30.53440103505564, -0.474124517273525],
            [30.53311598605857, -0.475630734555327],
            [30.532174847186546, -0.476129197902811],
            [30.530339110259032, -0.480463421718064],
            [30.529566940000358, -0.485542990472879],
            [30.52803499174237, -0.489691269204754],
            [30.527143832437826, -0.496253150290415],
            [30.525731941322626, -0.499360964916475],
            [30.52429502044866, -0.50253175923053],
            [30.52318580049876, -0.503620185241999],
            [30.523515628633422, -0.504324073376585],
            [30.525629439057116, -0.505616306317334],
            [30.526009222504733, -0.506453488238028],
            [30.526888083873047, -0.506764723452634],
            [30.52783782591057, -0.508104348259694],
            [30.528384101316295, -0.508415457635668],
            [30.533040311979008, -0.508465072330214],
            [30.536673492450106, -0.512532103408815],
            [30.537836727199707, -0.514708866540594],
            [30.540425192148184, -0.517292751293685],
            [30.54211199379146, -0.517054250217236],
            [30.546078742083726, -0.518610308585358],
            [30.54878695784948, -0.518707022636041],
            [30.55152034081621, -0.515120713093282],
            [30.555297846417442, -0.514619933322218],
            [30.55745944811259, -0.515314323650069],
            [30.56047683255808, -0.514598004533997],
            [30.56221139762503, -0.51376160876883],
            [30.568556211951492, -0.50917213895096],
            [30.57211585453676, -0.505200532772846],
            [30.57601707522063, -0.506041926783246],
            [30.58076960504476, -0.503030248425954],
            [30.587280148659666, -0.500090941388156],
            [30.58939513497807, -0.498465400091357],
            [30.59134707976737, -0.496175335748969],
            [30.592922706809393, -0.495872690298376],
            [30.593277700348438, -0.496626983637659],
            [30.594520927379154, -0.497179455506019],
            [30.595353980956205, -0.498432759244072],
            [30.596304437154348, -0.498672889591537],
            [30.596744300826472, -0.49966046352818],
            [30.597910326641692, -0.500135161968326],
            [30.599772599802698, -0.504071141840719],
            [30.599781307172734, -0.505475214326367],
            [30.60194765556584, -0.509631541687725],
            [30.603283323730867, -0.511515481071551],
            [30.606430464429234, -0.513519687811261],
            [30.60871639655296, -0.515523578626693],
            [30.61085302957478, -0.519709830100825],
            [30.613368048265606, -0.517366967077126],
            [30.614758878378993, -0.515461876745503],
            [30.616716543640013, -0.513950120734438],
            [30.61690554198927, -0.512308725585883],
            [30.616581156746896, -0.511465593323579],
            [30.617009154572454, -0.510830690245279],
            [30.616696476174887, -0.507992182734786],
            [30.617295534790067, -0.507305405436913],
            [30.61718222040183, -0.505235325866093],
            [30.617624748477073, -0.503255845322658],
            [30.617197827731566, -0.502424058064773],
            [30.61731684013366, -0.500372144676871],
            [30.619281966801434, -0.496360090712821],
            [30.619662584783956, -0.49486633541801],
            [30.620952871857444, -0.493739501016986],
            [30.620131521531945, -0.491541689526394],
            [30.62136529289597, -0.48988685673657],
            [30.620897797045693, -0.489130401366161],
            [30.620997283666778, -0.488374148024094],
            [30.620161277327394, -0.487531945106105],
            [30.61951030058037, -0.484506563112976],
            [30.61887260362813, -0.484049712448432],
            [30.61939759075828, -0.482523051188251],
            [30.617734525299742, -0.481226703216229],
            [30.616737560624404, -0.479554054933493],
            [30.615289421589154, -0.478188591529481],
            [30.610386662906826, -0.476830969874759],
            [30.60972190959658, -0.476044310039058],
            [30.608345227050613, -0.471686837630931],
            [30.60717011297969, -0.470339563842633],
            [30.60591201703439, -0.467925613777979],
            [30.604449249833074, -0.466382108795536],
            [30.601015415405005, -0.464434265297921],
            [30.599427231711918, -0.462576287592846],
            [30.597890950879336, -0.458757705986162],
            [30.598046255218893, -0.454062574764927],
            [30.597124839757246, -0.450656971835237],
            [30.59753545608037, -0.448799673268268],
            [30.598755784156168, -0.445785814026362],
            [30.60524986075362, -0.440752991571972],
            [30.6060099073492, -0.437951026460443],
            [30.609429395682188, -0.429943195800802],
            [30.611590028993426, -0.42987155717357],
            [30.614083197063316, -0.428823762000885],
            [30.6177869671494, -0.428852034784195],
            [30.619576186616552, -0.428214406870883],
            [30.619497107922097, -0.425788745387896],
            [30.621034393071174, -0.421601928211271],
            [30.621890222533935, -0.41763196621642],
            [30.623487536703554, -0.416489011570325],
            [30.62417900321542, -0.415224177440632],
            [30.628436670912436, -0.415592204844493],
            [30.633476975139505, -0.412950068147823],
            [30.63598937883454, -0.412186753507571],
            [30.637781020159697, -0.410552190604744],
            [30.637864790754897, -0.409574214412515],
            [30.63921961998494, -0.406547212119661],
            [30.644095336682277, -0.405219132110424],
            [30.64832747695387, -0.403210494325316],
            [30.65022830221361, -0.401807648828198],
            [30.65508597445182, -0.400493541896454],
            [30.654994429836172, -0.398869763341067],
            [30.65447220053395, -0.397938523060777],
            [30.654982833484176, -0.395181555285837],
            [30.654717154043947, -0.393979197773894],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 179,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "RWANYAMAHEMBE",
        Population: 26841,
        Key: "MBARARARWANYAMAHEMBE",
        Dist2: "Mbarara",
        "Sub Country": "Rwanyamahembe",
        id2_original: "Mbarara Rwanyamahembe",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "H",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.698254563939223, -0.60797525570826],
            [30.697890461483208, -0.603153486265963],
            [30.698525491337328, -0.599412219015268],
            [30.697129908237798, -0.596838795550777],
            [30.698392360113893, -0.590764491948203],
            [30.70134245894799, -0.583763695809895],
            [30.692867519893937, -0.583906337277989],
            [30.690215363493525, -0.585136884330073],
            [30.688857373990327, -0.586250769421378],
            [30.687569298569024, -0.589143011021639],
            [30.686041000166043, -0.590566901831853],
            [30.683561058890415, -0.5880829875523],
            [30.682661421286205, -0.582732909973036],
            [30.68057972473561, -0.584088628318909],
            [30.677421654235154, -0.585256910059317],
            [30.6745338823121, -0.587788621539001],
            [30.672862913475704, -0.588733053262249],
            [30.67146147605546, -0.588655557896772],
            [30.667580003036488, -0.589712294495715],
            [30.66587427029688, -0.590458288706366],
            [30.66450999168837, -0.591746362052567],
            [30.658569253949757, -0.592865127905126],
            [30.660085162788334, -0.595680275013974],
            [30.662691062239848, -0.598466896239093],
            [30.66394900636987, -0.599122218280351],
            [30.662912641586136, -0.603995081037942],
            [30.660895534802773, -0.608255664300985],
            [30.66055275116508, -0.611905122861229],
            [30.658999835330036, -0.615291059877695],
            [30.660027067840613, -0.619279241370135],
            [30.659370895237938, -0.619613715805751],
            [30.659303107468304, -0.620424622446686],
            [30.660938938702365, -0.620772692912087],
            [30.661695960670382, -0.620288927300765],
            [30.66289305561799, -0.621047837912943],
            [30.66325043867568, -0.619826604972931],
            [30.663036524653723, -0.619379464144265],
            [30.663734609952574, -0.618812982766203],
            [30.663996904540802, -0.617424063349947],
            [30.664575796876214, -0.617416336490535],
            [30.66452844218599, -0.616897423330138],
            [30.665440619373285, -0.616370948538643],
            [30.666693385614003, -0.616770647847948],
            [30.666645528765535, -0.617409264464907],
            [30.66894539914922, -0.617019110148304],
            [30.669492759719812, -0.616580285204577],
            [30.67055520259622, -0.616995867588061],
            [30.67122175613031, -0.615998285130255],
            [30.671713431933096, -0.615966568348912],
            [30.671317313520326, -0.615080282346447],
            [30.67173798648306, -0.614194352807492],
            [30.67251486032053, -0.614817366894969],
            [30.672888173203155, -0.613420503090326],
            [30.673554117679487, -0.613835910558494],
            [30.674339348544063, -0.61346903448675],
            [30.67455394618397, -0.612335538641574],
            [30.675505955569232, -0.61139395579555],
            [30.67634603666675, -0.612567826109444],
            [30.6774483889963, -0.612392679009755],
            [30.679787320823475, -0.613407541143664],
            [30.679970185475955, -0.612305959706804],
            [30.68195281581705, -0.612043378273214],
            [30.68341177326324, -0.612459130781543],
            [30.6844826692865, -0.611677253027491],
            [30.687060022973213, -0.611510722946407],
            [30.689720792420598, -0.608999845084634],
            [30.691442495409305, -0.608681951050997],
            [30.692550843993352, -0.607774825899639],
            [30.69345701145136, -0.60831487341599],
            [30.694249396498886, -0.606196081366261],
            [30.69461182629184, -0.606300492096524],
            [30.694673428262437, -0.607572438764591],
            [30.695895189151138, -0.608261049397614],
            [30.697490307838212, -0.608776436807932],
            [30.698254563939223, -0.60797525570826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 180,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "KAKOBA DIVISION",
        Population: 55538,
        Key: "MBARARAKAKOBA DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Kakoba Division",
        id2_original: "Mbarara Kakoba Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.658569253949757, -0.592865127905126],
            [30.65112536704284, -0.586514264731901],
            [30.64956409867232, -0.588194150008526],
            [30.648709074100058, -0.590382349164378],
            [30.646827533872838, -0.589306247836098],
            [30.646772090751814, -0.586900664673559],
            [30.645173059901676, -0.586189688077611],
            [30.642952854812346, -0.586112985847766],
            [30.638267430038297, -0.586972836028089],
            [30.631605799674027, -0.589261896763076],
            [30.630564447443874, -0.589990699987702],
            [30.62586249277026, -0.590681391421502],
            [30.624240351861094, -0.591417519830952],
            [30.621793648251007, -0.594783564901731],
            [30.61993009768566, -0.602427829611613],
            [30.618291457419705, -0.606175955738761],
            [30.61808512787368, -0.608776065824672],
            [30.616510741405044, -0.611137379213392],
            [30.61330779466626, -0.612850279809586],
            [30.612062821310623, -0.613999120584636],
            [30.612208291792797, -0.617578076848626],
            [30.61330499821076, -0.619369644335356],
            [30.61416129300085, -0.619282864962322],
            [30.615653950744925, -0.620368274432345],
            [30.61660459019941, -0.620194370784703],
            [30.61716659869904, -0.619443297392938],
            [30.616624685512317, -0.61827672069099],
            [30.618817860294744, -0.619149372327593],
            [30.619289774957878, -0.618045475456793],
            [30.620184023568697, -0.61915967270753],
            [30.62294494349216, -0.619800137661825],
            [30.62341564542967, -0.621427462500656],
            [30.624820797383617, -0.620314297830754],
            [30.62598488104118, -0.620431044126159],
            [30.62636934471144, -0.621273830875401],
            [30.625358515437963, -0.62268741646096],
            [30.625829704262372, -0.623220316791951],
            [30.627840558771364, -0.623056576176455],
            [30.628090854562338, -0.622717705863403],
            [30.627254274199508, -0.621719750805359],
            [30.627441253135995, -0.621308464283238],
            [30.628524737251315, -0.620606520623802],
            [30.629342360466723, -0.620965242674259],
            [30.630037696920823, -0.620169112536965],
            [30.630982267357222, -0.621005896239542],
            [30.631486108145598, -0.622081348117954],
            [30.63225877876585, -0.622512991897536],
            [30.633251029980922, -0.62032312865074],
            [30.635258946998942, -0.619977299321215],
            [30.635939616659396, -0.619495565507598],
            [30.636175622949132, -0.617711283875196],
            [30.63699081352677, -0.616975903688425],
            [30.637897833485997, -0.617559828633701],
            [30.63817470234141, -0.618363350070605],
            [30.639325357982088, -0.618913558566442],
            [30.640065112533705, -0.617797585397987],
            [30.64042634307576, -0.617797746187086],
            [30.64129101645248, -0.619168140631237],
            [30.64280357188013, -0.618204732996852],
            [30.64365206120871, -0.618171283479352],
            [30.643316598840556, -0.616877234864341],
            [30.643644519851875, -0.616209288089312],
            [30.644299615374493, -0.616581681105701],
            [30.644584176503685, -0.619008928033259],
            [30.646062630984815, -0.619187181108441],
            [30.646777054842076, -0.618367181162162],
            [30.64739020712578, -0.6186042471261],
            [30.648196327413956, -0.619408010037555],
            [30.648913728288065, -0.62169742808644],
            [30.649589072735527, -0.62131419250302],
            [30.649685964123762, -0.62031898137215],
            [30.65036630410248, -0.619542500635699],
            [30.65174529711535, -0.620217944789844],
            [30.654697711806236, -0.618107369371674],
            [30.65525212684676, -0.618554267776608],
            [30.65483696953991, -0.619481372057455],
            [30.655516501933207, -0.620549756715803],
            [30.655796746657437, -0.619345861031244],
            [30.65725818614878, -0.618982389755306],
            [30.657995968898366, -0.619191478397806],
            [30.65811147158266, -0.619744991516341],
            [30.6571275962593, -0.619841653568242],
            [30.65672708598312, -0.62035609758415],
            [30.657913013075138, -0.621405288892082],
            [30.660938938702365, -0.620772692912087],
            [30.659303107468304, -0.620424622446686],
            [30.659370895237938, -0.619613715805751],
            [30.660027067840613, -0.619279241370135],
            [30.658999835330036, -0.615291059877695],
            [30.66055275116508, -0.611905122861229],
            [30.660895534802773, -0.608255664300985],
            [30.662912641586136, -0.603995081037942],
            [30.66394900636987, -0.599122218280351],
            [30.662691062239848, -0.598466896239093],
            [30.660085162788334, -0.595680275013974],
            [30.658569253949757, -0.592865127905126],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 181,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "KAMUKUZI DIVISION",
        Population: 34888,
        Key: "MBARARAKAMUKUZI DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Kamukuzi Division",
        id2_original: "Mbarara Kamukuzi Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.67000122234028, -0.637206984305478],
            [30.671341378488506, -0.636298257972209],
            [30.674818261981578, -0.635332888098243],
            [30.677753316729618, -0.632828433356485],
            [30.684753981163535, -0.629259381803937],
            [30.68769659433635, -0.628231277849909],
            [30.691798341449527, -0.623388695129657],
            [30.69416841696928, -0.618695153130074],
            [30.697560615382244, -0.61568143888676],
            [30.699352298928197, -0.614786627417383],
            [30.703144374305054, -0.611371882750781],
            [30.698254563939223, -0.60797525570826],
            [30.697490307838212, -0.608776436807932],
            [30.695895189151138, -0.608261049397614],
            [30.694673428262437, -0.607572438764591],
            [30.69461182629184, -0.606300492096524],
            [30.694249396498886, -0.606196081366261],
            [30.69345701145136, -0.60831487341599],
            [30.692550843993352, -0.607774825899639],
            [30.691442495409305, -0.608681951050997],
            [30.689720792420598, -0.608999845084634],
            [30.687060022973213, -0.611510722946407],
            [30.6844826692865, -0.611677253027491],
            [30.68341177326324, -0.612459130781543],
            [30.68195281581705, -0.612043378273214],
            [30.679970185475955, -0.612305959706804],
            [30.679787320823475, -0.613407541143664],
            [30.6774483889963, -0.612392679009755],
            [30.67634603666675, -0.612567826109444],
            [30.675505955569232, -0.61139395579555],
            [30.67455394618397, -0.612335538641574],
            [30.674339348544063, -0.61346903448675],
            [30.673554117679487, -0.613835910558494],
            [30.672888173203155, -0.613420503090326],
            [30.67251486032053, -0.614817366894969],
            [30.67173798648306, -0.614194352807492],
            [30.671317313520326, -0.615080282346447],
            [30.671713431933096, -0.615966568348912],
            [30.67122175613031, -0.615998285130255],
            [30.67055520259622, -0.616995867588061],
            [30.669492759719812, -0.616580285204577],
            [30.66894539914922, -0.617019110148304],
            [30.666645528765535, -0.617409264464907],
            [30.666693385614003, -0.616770647847948],
            [30.665440619373285, -0.616370948538643],
            [30.66452844218599, -0.616897423330138],
            [30.664575796876214, -0.617416336490535],
            [30.663996904540802, -0.617424063349947],
            [30.663734609952574, -0.618812982766203],
            [30.663036524653723, -0.619379464144265],
            [30.66325043867568, -0.619826604972931],
            [30.66289305561799, -0.621047837912943],
            [30.661695960670382, -0.620288927300765],
            [30.660938938702365, -0.620772692912087],
            [30.657913013075138, -0.621405288892082],
            [30.65672708598312, -0.62035609758415],
            [30.6571275962593, -0.619841653568242],
            [30.65811147158266, -0.619744991516341],
            [30.657995968898366, -0.619191478397806],
            [30.65725818614878, -0.618982389755306],
            [30.655796746657437, -0.619345861031244],
            [30.655516501933207, -0.620549756715803],
            [30.65483696953991, -0.619481372057455],
            [30.65525212684676, -0.618554267776608],
            [30.654697711806236, -0.618107369371674],
            [30.65174529711535, -0.620217944789844],
            [30.65036630410248, -0.619542500635699],
            [30.649685964123762, -0.62031898137215],
            [30.649589072735527, -0.62131419250302],
            [30.648913728288065, -0.62169742808644],
            [30.648196327413956, -0.619408010037555],
            [30.64739020712578, -0.6186042471261],
            [30.646777054842076, -0.618367181162162],
            [30.646062630984815, -0.619187181108441],
            [30.644584176503685, -0.619008928033259],
            [30.644299615374493, -0.616581681105701],
            [30.643644519851875, -0.616209288089312],
            [30.643316598840556, -0.616877234864341],
            [30.64365206120871, -0.618171283479352],
            [30.64280357188013, -0.618204732996852],
            [30.64129101645248, -0.619168140631237],
            [30.64042634307576, -0.617797746187086],
            [30.640065112533705, -0.617797585397987],
            [30.639325357982088, -0.618913558566442],
            [30.63817470234141, -0.618363350070605],
            [30.637897833485997, -0.617559828633701],
            [30.63699081352677, -0.616975903688425],
            [30.636175622949132, -0.617711283875196],
            [30.635939616659396, -0.619495565507598],
            [30.635258946998942, -0.619977299321215],
            [30.633251029980922, -0.62032312865074],
            [30.63225877876585, -0.622512991897536],
            [30.631486108145598, -0.622081348117954],
            [30.630982267357222, -0.621005896239542],
            [30.630037696920823, -0.620169112536965],
            [30.629342360466723, -0.620965242674259],
            [30.628524737251315, -0.620606520623802],
            [30.627441253135995, -0.621308464283238],
            [30.627254274199508, -0.621719750805359],
            [30.628090854562338, -0.622717705863403],
            [30.627840558771364, -0.623056576176455],
            [30.625829704262372, -0.623220316791951],
            [30.625358515437963, -0.62268741646096],
            [30.62636934471144, -0.621273830875401],
            [30.62598488104118, -0.620431044126159],
            [30.624820797383617, -0.620314297830754],
            [30.62341564542967, -0.621427462500656],
            [30.62294494349216, -0.619800137661825],
            [30.620184023568697, -0.61915967270753],
            [30.619289774957878, -0.618045475456793],
            [30.618817860294744, -0.619149372327593],
            [30.616624685512317, -0.61827672069099],
            [30.61716659869904, -0.619443297392938],
            [30.61660459019941, -0.620194370784703],
            [30.615653950744925, -0.620368274432345],
            [30.616159763335325, -0.624907201624808],
            [30.614965144144627, -0.62924518568539],
            [30.615472973452842, -0.632038627878251],
            [30.616617647212056, -0.634508484713824],
            [30.616560287086223, -0.637420998274952],
            [30.617666917193162, -0.636815143634319],
            [30.62402611714058, -0.636859397301374],
            [30.629025539039073, -0.635467624410256],
            [30.632630376764617, -0.636491399115163],
            [30.63499214107135, -0.636691772140718],
            [30.635775763951553, -0.640167404996126],
            [30.64110689236197, -0.640528621062607],
            [30.641512214913103, -0.638451220298605],
            [30.640312710683883, -0.636923298604295],
            [30.639723208346695, -0.634341040925426],
            [30.639889323910726, -0.631799398610906],
            [30.64082307054626, -0.632692720566608],
            [30.642490662615504, -0.633296199791636],
            [30.64445759669364, -0.633942866403445],
            [30.645783473222068, -0.633642110881604],
            [30.6474937981494, -0.634331714289455],
            [30.648177703541503, -0.635106952334173],
            [30.64873364212474, -0.635150257453224],
            [30.649887682617422, -0.636571484370234],
            [30.651469744291852, -0.637344777346337],
            [30.652196309778482, -0.638167720605689],
            [30.655189453186033, -0.639286162329548],
            [30.657706857802278, -0.64154036347906],
            [30.660767043377778, -0.641243455644408],
            [30.66541089861208, -0.638645053020639],
            [30.669260312555203, -0.637699658186034],
            [30.67000122234028, -0.637206984305478],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 182,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "NYAMITANGA DIVISION",
        Population: 23125,
        Key: "MBARARANYAMITANGA DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Nyamitanga Division",
        id2_original: "Mbarara Nyamitanga Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.55566764958227, -0.698110604135991],
            [30.553568815870978, -0.699008544554912],
            [30.548860621499397, -0.700126917614791],
            [30.54650758073237, -0.703253171585514],
            [30.54543547827171, -0.702854890371212],
            [30.53894589055576, -0.704053642186868],
            [30.535308647004623, -0.703798625233658],
            [30.531968947933528, -0.705224996255372],
            [30.52657470029798, -0.706722571774404],
            [30.52239611848194, -0.710381058293375],
            [30.52119679840736, -0.712079708988034],
            [30.520133859660923, -0.714537689994664],
            [30.518644148390965, -0.720357863962178],
            [30.51726298864163, -0.72306012330627],
            [30.51563182325716, -0.724367979495429],
            [30.511770464415694, -0.726169536709044],
            [30.510711023708954, -0.727426052927826],
            [30.50923919879464, -0.728134257205821],
            [30.5028667576799, -0.72270945072815],
            [30.50061632158632, -0.718300919114048],
            [30.499976230623883, -0.716130997460131],
            [30.50079318908601, -0.712424630912878],
            [30.50283493935254, -0.707496058445222],
            [30.5042615143294, -0.705674541130612],
            [30.504293347029783, -0.704234011172365],
            [30.502839283605272, -0.698746749143757],
            [30.502873480671514, -0.696948069091137],
            [30.5020502151378, -0.694841618534294],
            [30.500951317728813, -0.693388945408531],
            [30.500766731005932, -0.69238221061321],
            [30.49889988182688, -0.690331622891808],
            [30.49675148536643, -0.690894598402414],
            [30.493350658635173, -0.693243247540403],
            [30.49138908839761, -0.693749902466232],
            [30.488195210151613, -0.693296917051296],
            [30.484366708089993, -0.691978635991117],
            [30.482642283205987, -0.69242806715809],
            [30.480828086082372, -0.693639443833781],
            [30.479327523163768, -0.697478910762845],
            [30.47520149279186, -0.701241696517673],
            [30.47048486413806, -0.703562556798808],
            [30.46924071633419, -0.705190506256061],
            [30.469528691959752, -0.706114966059937],
            [30.471068848124485, -0.707324575942159],
            [30.471908272553517, -0.70742130814249],
            [30.473878049799538, -0.711613224713137],
            [30.47276850555782, -0.714358294210575],
            [30.472069375518277, -0.714735438721609],
            [30.471011480812145, -0.716536705119511],
            [30.465740822495075, -0.714070223288238],
            [30.463679588668327, -0.713620389095596],
            [30.461339292300256, -0.714067786348114],
            [30.45638074734045, -0.713840690113454],
            [30.451254091658388, -0.715408252315273],
            [30.448494810262005, -0.715333923417755],
            [30.446235143080585, -0.715545506883473],
            [30.442687010609024, -0.717739820652517],
            [30.430232409980494, -0.723481093305653],
            [30.42828830209377, -0.725242427536361],
            [30.427427470811498, -0.72728455990967],
            [30.427526118406096, -0.728233622613682],
            [30.429371969465397, -0.732283777478632],
            [30.427588167737742, -0.738466754064289],
            [30.429757891101346, -0.73837777703717],
            [30.43401427510584, -0.738938060021661],
            [30.43975635940252, -0.740183797366098],
            [30.44363455716397, -0.741453817382663],
            [30.446520854951622, -0.743569150677276],
            [30.45116752101444, -0.744465630572151],
            [30.45226246044628, -0.745759403293385],
            [30.454264113511808, -0.747148786879387],
            [30.458811967588332, -0.748376957747995],
            [30.46459221860649, -0.7491647614834],
            [30.465583697270425, -0.749707319956493],
            [30.46670318855727, -0.751786661376499],
            [30.46890147655028, -0.754162680669248],
            [30.468930042078014, -0.755471403478836],
            [30.46883306984141, -0.757781906965656],
            [30.467481228408012, -0.759445616203728],
            [30.466871098056902, -0.760971365626126],
            [30.46627097044651, -0.765130963646111],
            [30.462452270801275, -0.76965471258713],
            [30.462086407647323, -0.773389324586137],
            [30.4605143496119, -0.776286070776799],
            [30.458600461051297, -0.778210368910944],
            [30.45666598400272, -0.779022167046124],
            [30.454499168485686, -0.780947809482712],
            [30.453827187330656, -0.780707126457598],
            [30.4524497699628, -0.781230511776975],
            [30.451213525536797, -0.782856656804067],
            [30.450601317382436, -0.785462006803724],
            [30.451399899008774, -0.78737167484572],
            [30.450181817619484, -0.789264134619899],
            [30.450347231599277, -0.791192708652124],
            [30.453749816333552, -0.796795317909006],
            [30.4580715599615, -0.802465052148384],
            [30.453726872462887, -0.806710357228139],
            [30.451621110944114, -0.810948007693861],
            [30.449420720893325, -0.825272327884396],
            [30.448028155234848, -0.828606561951968],
            [30.446811256028475, -0.834082976876756],
            [30.453327638692752, -0.834014908858771],
            [30.461911702392545, -0.831986837796809],
            [30.46335977585077, -0.832060079600274],
            [30.465091757362966, -0.832874655083989],
            [30.471553540424264, -0.839142474983151],
            [30.474305179852504, -0.841087531688886],
            [30.479585611839862, -0.842473852645771],
            [30.487087443675854, -0.843705893411097],
            [30.493861322128105, -0.845746037627235],
            [30.505110654936544, -0.845934087523438],
            [30.50721949498177, -0.845501590443479],
            [30.50988740423902, -0.843569022966429],
            [30.512671373136033, -0.835345550775525],
            [30.515518189068654, -0.830204302489749],
            [30.517307858591753, -0.828623645223715],
            [30.52006801674383, -0.827902276412558],
            [30.532367431610385, -0.828054602201849],
            [30.540379842497682, -0.827327447841608],
            [30.54438595766065, -0.82633565204675],
            [30.541557121508475, -0.822745435196721],
            [30.536344078438773, -0.820392090209631],
            [30.533227556816836, -0.817624262969454],
            [30.53135639123286, -0.815489934400834],
            [30.529037497226405, -0.811782574788997],
            [30.528486168797205, -0.808907879717389],
            [30.535393391373606, -0.784124563274962],
            [30.537893089297263, -0.78026072404626],
            [30.538155160204987, -0.772266472445651],
            [30.53926964518077, -0.770466955190081],
            [30.543240364026577, -0.768924441802491],
            [30.553877272186725, -0.768669185138724],
            [30.556361971838413, -0.7679495115573],
            [30.555031927127054, -0.766226061305887],
            [30.555495090402694, -0.760734934619914],
            [30.554504588207507, -0.757955197484531],
            [30.553554185009954, -0.757555929464518],
            [30.551837376941233, -0.758272666652843],
            [30.550411753280265, -0.757713639178071],
            [30.549144154057572, -0.757898993018509],
            [30.548379387713474, -0.756090996673832],
            [30.54700711499726, -0.754575058775906],
            [30.54682279237906, -0.753644592537712],
            [30.551780642941143, -0.744759571339782],
            [30.55248456908599, -0.744569619752612],
            [30.55393516231858, -0.742878472608323],
            [30.556709334189083, -0.741240927295689],
            [30.557371831829652, -0.739972324641416],
            [30.558948278135258, -0.738651351500949],
            [30.560451535999686, -0.736618046827052],
            [30.56294455405089, -0.735437888182573],
            [30.564133657585742, -0.733923360604168],
            [30.56670884453599, -0.73286812692261],
            [30.570933482976656, -0.732227285247681],
            [30.575732197884495, -0.730390729546217],
            [30.57717044557014, -0.728999255904069],
            [30.5819228325621, -0.728833372055641],
            [30.582682589900173, -0.728244023366205],
            [30.58610331880656, -0.728739904522068],
            [30.586033438860614, -0.726089366711937],
            [30.58432872391222, -0.722743482491706],
            [30.581643482559873, -0.721087872424694],
            [30.58051737428264, -0.719812741928274],
            [30.577012475030788, -0.718183822138121],
            [30.575004737675822, -0.716582819223019],
            [30.57240558906367, -0.713716025304511],
            [30.571716037760016, -0.713652385502269],
            [30.57078370147945, -0.712901641647591],
            [30.56936713822644, -0.71089420388528],
            [30.56800727304094, -0.709974079072853],
            [30.56578022728071, -0.705175743562569],
            [30.56292979473078, -0.704217608276007],
            [30.562170366176105, -0.702638754904177],
            [30.561981144146337, -0.701012370203512],
            [30.56104870276291, -0.699975054379082],
            [30.55566764958227, -0.698110604135991],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 183,
        District: "MBARARA",
        County: "RWAMPARA",
        Subcounty: "BUGAMBA",
        Population: 34734,
        Key: "MBARARABUGAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.58610331880656, -0.728739904522068],
            [30.582682589900173, -0.728244023366205],
            [30.5819228325621, -0.728833372055641],
            [30.57717044557014, -0.728999255904069],
            [30.575732197884495, -0.730390729546217],
            [30.570933482976656, -0.732227285247681],
            [30.56670884453599, -0.73286812692261],
            [30.564133657585742, -0.733923360604168],
            [30.56294455405089, -0.735437888182573],
            [30.560451535999686, -0.736618046827052],
            [30.558948278135258, -0.738651351500949],
            [30.557371831829652, -0.739972324641416],
            [30.556709334189083, -0.741240927295689],
            [30.55393516231858, -0.742878472608323],
            [30.55248456908599, -0.744569619752612],
            [30.551780642941143, -0.744759571339782],
            [30.54682279237906, -0.753644592537712],
            [30.54700711499726, -0.754575058775906],
            [30.548379387713474, -0.756090996673832],
            [30.549144154057572, -0.757898993018509],
            [30.550411753280265, -0.757713639178071],
            [30.551837376941233, -0.758272666652843],
            [30.553554185009954, -0.757555929464518],
            [30.554504588207507, -0.757955197484531],
            [30.555495090402694, -0.760734934619914],
            [30.555031927127054, -0.766226061305887],
            [30.556361971838413, -0.7679495115573],
            [30.553877272186725, -0.768669185138724],
            [30.543240364026577, -0.768924441802491],
            [30.53926964518077, -0.770466955190081],
            [30.538155160204987, -0.772266472445651],
            [30.537893089297263, -0.78026072404626],
            [30.535393391373606, -0.784124563274962],
            [30.528486168797205, -0.808907879717389],
            [30.529037497226405, -0.811782574788997],
            [30.53135639123286, -0.815489934400834],
            [30.533227556816836, -0.817624262969454],
            [30.536344078438773, -0.820392090209631],
            [30.541557121508475, -0.822745435196721],
            [30.54438595766065, -0.82633565204675],
            [30.548540491576535, -0.826166803399711],
            [30.550171371296766, -0.827828589014245],
            [30.55568315270744, -0.828878271205083],
            [30.557246544695303, -0.827109871608838],
            [30.558347389651793, -0.826602791302918],
            [30.562271885684684, -0.82584098686609],
            [30.56579735635657, -0.826126210057235],
            [30.567141791180465, -0.822598475186548],
            [30.568022646808696, -0.821640868170978],
            [30.57075702421045, -0.820304745188326],
            [30.573940597881833, -0.819782411286357],
            [30.579985406344452, -0.819560104597438],
            [30.589530425751427, -0.820623476091893],
            [30.592751875988466, -0.819712455855879],
            [30.593693322084324, -0.8272331911567],
            [30.580375566231904, -0.837476685384878],
            [30.575882222825147, -0.841913562970304],
            [30.570668365881815, -0.844412651603385],
            [30.569945160094328, -0.846833821884227],
            [30.570505130316572, -0.849013637148632],
            [30.567855248450446, -0.854823854138006],
            [30.567772775022522, -0.858456233324453],
            [30.57685411552093, -0.858684005234065],
            [30.58076392409891, -0.857818735441533],
            [30.583068684910963, -0.858950299746886],
            [30.583769705904192, -0.859979945161309],
            [30.58835972779844, -0.861395493489951],
            [30.5905247394984, -0.861618854096636],
            [30.592429600888703, -0.861095369720207],
            [30.594754925035947, -0.861439912854996],
            [30.596258949163328, -0.860734544630585],
            [30.60293399676464, -0.862151412154772],
            [30.60337492404206, -0.862353497631316],
            [30.60345471330392, -0.862999330176716],
            [30.60302528176719, -0.864328569886046],
            [30.603254889357174, -0.866506500628443],
            [30.602914384745347, -0.867352882632638],
            [30.608234879797752, -0.867529132551524],
            [30.61021359797575, -0.866891591278042],
            [30.613113619326022, -0.867697412624709],
            [30.61483709469077, -0.867740819630802],
            [30.617191546711094, -0.867107581728656],
            [30.623203234289196, -0.866434331045294],
            [30.626584674478288, -0.865145781116904],
            [30.6308025099773, -0.864371119137247],
            [30.63026861694943, -0.863234720460407],
            [30.630982019422223, -0.862248582695735],
            [30.63047798908933, -0.860843135099128],
            [30.631696872674162, -0.858900624002509],
            [30.631459935729794, -0.857824204670258],
            [30.631787328531722, -0.856688342073778],
            [30.63416498493414, -0.853939335613966],
            [30.63564052887374, -0.851082386754909],
            [30.636540465616957, -0.846790080504372],
            [30.63612761338709, -0.845006256707876],
            [30.636756609257475, -0.842117434268206],
            [30.63755572897464, -0.840797686450309],
            [30.638924841417698, -0.83988009320679],
            [30.639990400549834, -0.838005621558864],
            [30.642341600668836, -0.837770891724061],
            [30.64806419601546, -0.838987262746921],
            [30.652303486876715, -0.837379758536428],
            [30.652354607304574, -0.836610226102323],
            [30.650606429167816, -0.832137740647444],
            [30.65098680730017, -0.830560820753432],
            [30.650656841723258, -0.82967347990145],
            [30.651196644767367, -0.827579153787912],
            [30.65097475011243, -0.826297746185851],
            [30.650563340576902, -0.821377759806817],
            [30.650163964872956, -0.820457378460531],
            [30.65091306100522, -0.816883036928395],
            [30.65088486648172, -0.812958110578003],
            [30.650477820063564, -0.810989286535837],
            [30.651938840041627, -0.807542137101503],
            [30.65179090817561, -0.806590927268421],
            [30.65258871186089, -0.802229207325765],
            [30.6532789997831, -0.80158778680255],
            [30.654115041156768, -0.799509137234391],
            [30.65397547350432, -0.798189262190043],
            [30.654941555896848, -0.79640899433856],
            [30.654740582106548, -0.790740988044697],
            [30.65626447786632, -0.789069504330703],
            [30.65681350301516, -0.787849453481919],
            [30.656591610156823, -0.786186021245414],
            [30.655195131436955, -0.784060905632108],
            [30.654578139753717, -0.783870724937695],
            [30.654881599639843, -0.782874532507768],
            [30.65358494081604, -0.781664806820422],
            [30.652906497180865, -0.779963227804944],
            [30.652823788394336, -0.777774875268992],
            [30.651975391592227, -0.777075174535601],
            [30.65206833847804, -0.776585969151908],
            [30.651319058191138, -0.775240551880958],
            [30.64907548792127, -0.774238924895825],
            [30.648348823619962, -0.773444492287719],
            [30.64811923130133, -0.771728356778623],
            [30.647252392086443, -0.769918417982662],
            [30.64709134930886, -0.768020940968198],
            [30.64616732334298, -0.767296764426953],
            [30.64102476298881, -0.76621548189455],
            [30.638967364070005, -0.766155504949411],
            [30.637496167078055, -0.764987709503223],
            [30.635333662576063, -0.765414077487019],
            [30.630289716578826, -0.763934468400703],
            [30.627987772883504, -0.764280554907711],
            [30.625535458396108, -0.762033824251917],
            [30.62309168688708, -0.761561829140707],
            [30.620083113117886, -0.759783001856217],
            [30.61823934974334, -0.757470989500483],
            [30.61189246030858, -0.754675103556056],
            [30.608636771682804, -0.750475376583561],
            [30.60060437867034, -0.743587833163457],
            [30.596302472538834, -0.738595781843755],
            [30.59476682322187, -0.737952522028739],
            [30.59359010655649, -0.735780332777841],
            [30.590209836872184, -0.732245334520926],
            [30.58610331880656, -0.728739904522068],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 184,
        District: "MBARARA",
        County: "RWAMPARA",
        Subcounty: "MWIZI",
        Population: 34602,
        Key: "MBARARAMWIZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.448494810262005, -0.715333923417755],
            [30.449707886238535, -0.712536671810059],
            [30.451801969658604, -0.70960277816327],
            [30.45250022384074, -0.705546567857206],
            [30.45315068136155, -0.704006647675808],
            [30.453203904745514, -0.701469741919008],
            [30.451010449688724, -0.698009677820018],
            [30.449796249919757, -0.697387694502233],
            [30.44831660337428, -0.697386889671356],
            [30.44751295345309, -0.698268483900973],
            [30.443303393234498, -0.700639767915708],
            [30.440809520885416, -0.701623570472739],
            [30.43783749058201, -0.701947313387908],
            [30.43270013776152, -0.702007754690151],
            [30.4290828529794, -0.701472508522744],
            [30.42751074014675, -0.700811856982121],
            [30.426552498250025, -0.698904279468728],
            [30.42622340763222, -0.696964459437449],
            [30.427113691079388, -0.693613277827052],
            [30.427898337140718, -0.692264984535462],
            [30.43045095841104, -0.689812843020074],
            [30.434471728689527, -0.687217999650788],
            [30.43680967596315, -0.686415759335882],
            [30.438192776073482, -0.685397778760097],
            [30.440004176741628, -0.683045639645485],
            [30.440589652829736, -0.680965456808874],
            [30.43849555593497, -0.67531601533928],
            [30.43588669743292, -0.672213890818735],
            [30.434716338144774, -0.671988470514914],
            [30.433415566833595, -0.670809503670587],
            [30.43229908669955, -0.67063837555539],
            [30.429289108863596, -0.668892629862854],
            [30.42577043843841, -0.668053585935973],
            [30.424715933974152, -0.667177078370456],
            [30.42401203837204, -0.664175970940635],
            [30.42178921828693, -0.661723990379994],
            [30.421959677205326, -0.659832062095138],
            [30.423220603742113, -0.65946851194424],
            [30.42319492719634, -0.658520357065696],
            [30.421231886416656, -0.654738807661832],
            [30.420331010933978, -0.653755527350409],
            [30.419296866785633, -0.655897023222088],
            [30.415093354025508, -0.660901936636344],
            [30.412686700005718, -0.662970392312983],
            [30.408943872069372, -0.667143995661463],
            [30.40715755326228, -0.669736959870577],
            [30.405840765887884, -0.673911816819329],
            [30.40369451460434, -0.675618848715271],
            [30.401001861252574, -0.676268138155433],
            [30.399087067190198, -0.677469155776819],
            [30.39863801644766, -0.678273291099559],
            [30.39902508343558, -0.680063014540672],
            [30.398149247593125, -0.681210359777011],
            [30.390909154288224, -0.685110801027457],
            [30.389992957140052, -0.688255484449732],
            [30.389106167241028, -0.68967394389801],
            [30.384157925059228, -0.69372684889447],
            [30.381647638693284, -0.695661910436092],
            [30.37965863839854, -0.698128124474982],
            [30.377031304246024, -0.704977300081669],
            [30.37529120465863, -0.705598315876723],
            [30.374839459868557, -0.706339346375156],
            [30.372413046505745, -0.707125672650602],
            [30.36153329677488, -0.707499062182534],
            [30.35975156566393, -0.708076456086876],
            [30.357204542694483, -0.710768217676509],
            [30.35514099211259, -0.712339580504557],
            [30.350374313822776, -0.712870050344498],
            [30.345720598679904, -0.715072525951608],
            [30.342033506715367, -0.714898671464002],
            [30.338298689954733, -0.717969252130446],
            [30.33499882218331, -0.719666369408966],
            [30.33401917253505, -0.718382474341813],
            [30.331455241475304, -0.716374657220634],
            [30.33044824890643, -0.71409663170644],
            [30.329701442579804, -0.713786085765221],
            [30.325431601812358, -0.714536538444005],
            [30.321298052541508, -0.715862616183216],
            [30.313928768922338, -0.717102123388406],
            [30.3140645546674, -0.717250118220168],
            [30.31565230357589, -0.718001151496374],
            [30.31924216638565, -0.717831555698458],
            [30.321622826754393, -0.718944552709281],
            [30.322535830391725, -0.720228400909578],
            [30.323338679913963, -0.720373471854861],
            [30.324057692365702, -0.722127150659476],
            [30.32508145917587, -0.723266468754711],
            [30.324170379729892, -0.723970848064567],
            [30.323265099807376, -0.727223774014747],
            [30.323639909283266, -0.730097888176644],
            [30.32442626214361, -0.731101510414496],
            [30.325478337563354, -0.731328074027008],
            [30.32617719451504, -0.732512393514081],
            [30.32788615759637, -0.733254485854446],
            [30.329103307432707, -0.735198263450867],
            [30.32953742188704, -0.737159649316427],
            [30.33116415767886, -0.738660845006225],
            [30.33299004278264, -0.741418371931228],
            [30.33509349652944, -0.743064464827511],
            [30.335770607064724, -0.745188684530343],
            [30.33698100875663, -0.745921361205995],
            [30.338412367262364, -0.748387376418139],
            [30.337577958127557, -0.749645664873427],
            [30.3350236659908, -0.75168964718495],
            [30.337002270981095, -0.753867527013607],
            [30.338721061631638, -0.754891355093544],
            [30.344224855222834, -0.756783301161819],
            [30.351015868140784, -0.765017364738799],
            [30.352083924589422, -0.766906886521714],
            [30.353604510955687, -0.774056583538405],
            [30.358438330228196, -0.778768226002087],
            [30.359587237747323, -0.780793382767091],
            [30.359837284704966, -0.785185845712534],
            [30.360421497761813, -0.786849146307782],
            [30.363172691625667, -0.789327217316121],
            [30.370937237563133, -0.794375214079099],
            [30.375629631467206, -0.799620118670324],
            [30.389272705911555, -0.807175477613877],
            [30.394876381382517, -0.810883551943536],
            [30.400305601330395, -0.814973288327627],
            [30.40497326371634, -0.812292029183185],
            [30.410006765001754, -0.811445696341335],
            [30.413258969960822, -0.811375481178894],
            [30.421624377432284, -0.813396340091971],
            [30.430261841484164, -0.816348313375759],
            [30.431661010658306, -0.81759647911016],
            [30.433011302497842, -0.82003765850534],
            [30.43501012048033, -0.826275303214191],
            [30.436075810766507, -0.828409011635334],
            [30.440024996096664, -0.831294774050643],
            [30.4436076229768, -0.833068603313797],
            [30.446811256028475, -0.834082976876756],
            [30.448028155234848, -0.828606561951968],
            [30.449420720893325, -0.825272327884396],
            [30.451621110944114, -0.810948007693861],
            [30.453726872462887, -0.806710357228139],
            [30.4580715599615, -0.802465052148384],
            [30.453749816333552, -0.796795317909006],
            [30.450347231599277, -0.791192708652124],
            [30.450181817619484, -0.789264134619899],
            [30.451399899008774, -0.78737167484572],
            [30.450601317382436, -0.785462006803724],
            [30.451213525536797, -0.782856656804067],
            [30.4524497699628, -0.781230511776975],
            [30.453827187330656, -0.780707126457598],
            [30.454499168485686, -0.780947809482712],
            [30.45666598400272, -0.779022167046124],
            [30.458600461051297, -0.778210368910944],
            [30.4605143496119, -0.776286070776799],
            [30.462086407647323, -0.773389324586137],
            [30.462452270801275, -0.76965471258713],
            [30.46627097044651, -0.765130963646111],
            [30.466871098056902, -0.760971365626126],
            [30.467481228408012, -0.759445616203728],
            [30.46883306984141, -0.757781906965656],
            [30.468930042078014, -0.755471403478836],
            [30.46890147655028, -0.754162680669248],
            [30.46670318855727, -0.751786661376499],
            [30.465583697270425, -0.749707319956493],
            [30.46459221860649, -0.7491647614834],
            [30.458811967588332, -0.748376957747995],
            [30.454264113511808, -0.747148786879387],
            [30.45226246044628, -0.745759403293385],
            [30.45116752101444, -0.744465630572151],
            [30.446520854951622, -0.743569150677276],
            [30.44363455716397, -0.741453817382663],
            [30.43975635940252, -0.740183797366098],
            [30.43401427510584, -0.738938060021661],
            [30.429757891101346, -0.73837777703717],
            [30.427588167737742, -0.738466754064289],
            [30.429371969465397, -0.732283777478632],
            [30.427526118406096, -0.728233622613682],
            [30.427427470811498, -0.72728455990967],
            [30.42828830209377, -0.725242427536361],
            [30.430232409980494, -0.723481093305653],
            [30.442687010609024, -0.717739820652517],
            [30.446235143080585, -0.715545506883473],
            [30.448494810262005, -0.715333923417755],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 185,
        District: "MBARARA",
        County: "RWAMPARA",
        Subcounty: "NDEIJA",
        Population: 31491,
        Key: "MBARARANDEIJA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.53564898632645, -0.615758457788424],
            [30.534620425207606, -0.615783905590708],
            [30.533008424481377, -0.614706968505001],
            [30.531834609374357, -0.616417683381658],
            [30.530190835236557, -0.616065606376135],
            [30.53047323412083, -0.614920573784657],
            [30.52915549004066, -0.613850233373681],
            [30.527509708168218, -0.610085942020314],
            [30.522695957259163, -0.605682321366301],
            [30.517849283993282, -0.604053499726016],
            [30.516555241961864, -0.604773746810154],
            [30.513952318628903, -0.604147396301668],
            [30.512653056487387, -0.604784678698141],
            [30.511226633325837, -0.606378719299072],
            [30.5098958070802, -0.606760832223767],
            [30.50466627453515, -0.605694328475765],
            [30.503148554692952, -0.604493258989733],
            [30.501976494893995, -0.604109994329067],
            [30.500880684994666, -0.602951320830033],
            [30.498516417981552, -0.602571078724483],
            [30.497714549419605, -0.602072193661591],
            [30.496361011068622, -0.603040515902962],
            [30.496493050838957, -0.604093777944637],
            [30.495927809302643, -0.604725437206954],
            [30.494211661495658, -0.605525074670136],
            [30.493681216201843, -0.606325260855297],
            [30.49240457902909, -0.606900415403278],
            [30.491134617237197, -0.608128556256436],
            [30.490820565315527, -0.60854266703965],
            [30.491064130030114, -0.60973640399198],
            [30.490303465393595, -0.610648818691404],
            [30.48658529531348, -0.612065376759315],
            [30.484548740004225, -0.61195207961452],
            [30.4818700644383, -0.61281443458868],
            [30.48073537365683, -0.614059704878034],
            [30.47948567606113, -0.614745661208781],
            [30.478917780901426, -0.615665897133032],
            [30.475922572267045, -0.617052810288477],
            [30.475670731373768, -0.617937180865821],
            [30.474963639565885, -0.618197033086452],
            [30.474659292144228, -0.618778485878004],
            [30.472956463657976, -0.618823588556159],
            [30.47097183995529, -0.619993484218397],
            [30.466846009907666, -0.620987843857649],
            [30.462601451325593, -0.621275030954069],
            [30.459608833432476, -0.622448578408515],
            [30.454709517992626, -0.622563707784694],
            [30.4523484615583, -0.624081004558967],
            [30.43997823788781, -0.630004069851863],
            [30.439215425379466, -0.631314238119722],
            [30.43459102495927, -0.634529553406778],
            [30.42768467105376, -0.641874135842434],
            [30.42241798957847, -0.648830827501065],
            [30.420331010933978, -0.653755527350409],
            [30.421231886416656, -0.654738807661832],
            [30.42319492719634, -0.658520357065696],
            [30.423220603742113, -0.65946851194424],
            [30.421959677205326, -0.659832062095138],
            [30.42178921828693, -0.661723990379994],
            [30.42401203837204, -0.664175970940635],
            [30.424715933974152, -0.667177078370456],
            [30.42577043843841, -0.668053585935973],
            [30.429289108863596, -0.668892629862854],
            [30.43229908669955, -0.67063837555539],
            [30.433415566833595, -0.670809503670587],
            [30.434716338144774, -0.671988470514914],
            [30.43588669743292, -0.672213890818735],
            [30.43849555593497, -0.67531601533928],
            [30.440589652829736, -0.680965456808874],
            [30.440004176741628, -0.683045639645485],
            [30.438192776073482, -0.685397778760097],
            [30.43680967596315, -0.686415759335882],
            [30.434471728689527, -0.687217999650788],
            [30.43045095841104, -0.689812843020074],
            [30.427898337140718, -0.692264984535462],
            [30.427113691079388, -0.693613277827052],
            [30.42622340763222, -0.696964459437449],
            [30.426552498250025, -0.698904279468728],
            [30.42751074014675, -0.700811856982121],
            [30.4290828529794, -0.701472508522744],
            [30.43270013776152, -0.702007754690151],
            [30.43783749058201, -0.701947313387908],
            [30.440809520885416, -0.701623570472739],
            [30.443303393234498, -0.700639767915708],
            [30.44751295345309, -0.698268483900973],
            [30.44831660337428, -0.697386889671356],
            [30.449796249919757, -0.697387694502233],
            [30.451010449688724, -0.698009677820018],
            [30.453203904745514, -0.701469741919008],
            [30.45315068136155, -0.704006647675808],
            [30.45250022384074, -0.705546567857206],
            [30.451801969658604, -0.70960277816327],
            [30.449707886238535, -0.712536671810059],
            [30.448494810262005, -0.715333923417755],
            [30.451254091658388, -0.715408252315273],
            [30.45638074734045, -0.713840690113454],
            [30.461339292300256, -0.714067786348114],
            [30.463679588668327, -0.713620389095596],
            [30.465740822495075, -0.714070223288238],
            [30.471011480812145, -0.716536705119511],
            [30.472069375518277, -0.714735438721609],
            [30.47276850555782, -0.714358294210575],
            [30.473878049799538, -0.711613224713137],
            [30.471908272553517, -0.70742130814249],
            [30.471068848124485, -0.707324575942159],
            [30.469528691959752, -0.706114966059937],
            [30.46924071633419, -0.705190506256061],
            [30.47048486413806, -0.703562556798808],
            [30.47520149279186, -0.701241696517673],
            [30.479327523163768, -0.697478910762845],
            [30.480828086082372, -0.693639443833781],
            [30.482642283205987, -0.69242806715809],
            [30.484366708089993, -0.691978635991117],
            [30.488195210151613, -0.693296917051296],
            [30.49138908839761, -0.693749902466232],
            [30.493350658635173, -0.693243247540403],
            [30.49675148536643, -0.690894598402414],
            [30.49889988182688, -0.690331622891808],
            [30.500766731005932, -0.69238221061321],
            [30.500951317728813, -0.693388945408531],
            [30.5020502151378, -0.694841618534294],
            [30.502873480671514, -0.696948069091137],
            [30.502839283605272, -0.698746749143757],
            [30.504293347029783, -0.704234011172365],
            [30.5042615143294, -0.705674541130612],
            [30.50283493935254, -0.707496058445222],
            [30.50079318908601, -0.712424630912878],
            [30.499976230623883, -0.716130997460131],
            [30.50061632158632, -0.718300919114048],
            [30.5028667576799, -0.72270945072815],
            [30.50923919879464, -0.728134257205821],
            [30.510711023708954, -0.727426052927826],
            [30.511770464415694, -0.726169536709044],
            [30.51563182325716, -0.724367979495429],
            [30.51726298864163, -0.72306012330627],
            [30.518644148390965, -0.720357863962178],
            [30.520133859660923, -0.714537689994664],
            [30.52119679840736, -0.712079708988034],
            [30.52239611848194, -0.710381058293375],
            [30.52657470029798, -0.706722571774404],
            [30.531968947933528, -0.705224996255372],
            [30.535308647004623, -0.703798625233658],
            [30.53894589055576, -0.704053642186868],
            [30.54543547827171, -0.702854890371212],
            [30.54650758073237, -0.703253171585514],
            [30.548860621499397, -0.700126917614791],
            [30.553568815870978, -0.699008544554912],
            [30.55566764958227, -0.698110604135991],
            [30.557754511445744, -0.696317090568167],
            [30.557181123986418, -0.691065102413175],
            [30.55340584890201, -0.68819777904246],
            [30.54790509341314, -0.684958985816194],
            [30.546715367345794, -0.683717077168495],
            [30.540767176285264, -0.680519643621566],
            [30.531624326342765, -0.67334034723574],
            [30.530557238278, -0.669393770273414],
            [30.525809467728266, -0.662612612783428],
            [30.525555490641256, -0.660425085992043],
            [30.52691848196396, -0.658392025032634],
            [30.52736385141046, -0.655960794936517],
            [30.529190434505217, -0.652364230661935],
            [30.531652590036547, -0.649554348863808],
            [30.53209549360758, -0.648415667153926],
            [30.532990928892904, -0.6474127874177],
            [30.53469787974801, -0.646898402678727],
            [30.5356214367933, -0.64488317566332],
            [30.537225358071836, -0.643311181928413],
            [30.538627998336267, -0.643411288363931],
            [30.539430030391586, -0.642625289533712],
            [30.54085308487082, -0.642282496904055],
            [30.542029512278695, -0.640728364251165],
            [30.540741930930835, -0.638522242084839],
            [30.54230683927493, -0.634880291664307],
            [30.541783613741057, -0.633207837016006],
            [30.54213033559293, -0.631906392234707],
            [30.541924527968078, -0.629791179300558],
            [30.54262878828621, -0.628652603695493],
            [30.542476213926793, -0.627296687202143],
            [30.536950797886735, -0.623931603825139],
            [30.536229111150416, -0.622729087744077],
            [30.534414050745788, -0.618281097028267],
            [30.53564898632645, -0.615758457788424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 186,
        District: "MBARARA",
        County: "RWAMPARA",
        Subcounty: "RUGANDO",
        Population: 26898,
        Key: "MBARARARUGANDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.525731941322626, -0.499360964916475],
            [30.52317160711726, -0.498783466217187],
            [30.52112049460881, -0.496482925327385],
            [30.51639962950016, -0.492407633536553],
            [30.514837791597717, -0.49177298641631],
            [30.50860979958069, -0.492096476690953],
            [30.5031189938319, -0.493145606383705],
            [30.4995149169794, -0.493008613884322],
            [30.4961470242831, -0.491820529797897],
            [30.49318362678954, -0.489852695953262],
            [30.48693380660944, -0.483773767920192],
            [30.48282671811359, -0.477725450656975],
            [30.479278802136026, -0.476359329345372],
            [30.47307529999027, -0.475326667098811],
            [30.471153991345446, -0.486325780308699],
            [30.469916756077673, -0.490618585003359],
            [30.469240528586305, -0.498536911366056],
            [30.46887344821511, -0.502485679225396],
            [30.46701888439589, -0.509001674185212],
            [30.464354301600128, -0.521464608488375],
            [30.460065924995103, -0.529109354503103],
            [30.457165291892142, -0.540975544253646],
            [30.45759116969362, -0.546769319781861],
            [30.45574356332629, -0.555183247869134],
            [30.454360200907875, -0.566932505596242],
            [30.4546053924714, -0.568930089071377],
            [30.45734357603502, -0.572908182316027],
            [30.45761148329715, -0.574598477195905],
            [30.456505205329815, -0.577725257582381],
            [30.452749232345905, -0.578256831959067],
            [30.451362370091168, -0.579512535377536],
            [30.450494128606106, -0.582684594787647],
            [30.448148525889653, -0.588350546540526],
            [30.448778278141496, -0.591423860700743],
            [30.44771906560682, -0.597677877047075],
            [30.44710330371724, -0.598391615236426],
            [30.44702311470507, -0.59918694823864],
            [30.44771924886316, -0.600931665598152],
            [30.447892992022243, -0.602902096776321],
            [30.4465599092086, -0.605802761646685],
            [30.44606222008332, -0.606308670799254],
            [30.44458778286814, -0.606380279585345],
            [30.444209060330895, -0.606877205136741],
            [30.44115047645152, -0.612714467696272],
            [30.440639260494677, -0.616004145400443],
            [30.442591268166044, -0.619674620715039],
            [30.442499615752546, -0.620650708855099],
            [30.441980816218077, -0.621870622057358],
            [30.438864680871724, -0.625014413667381],
            [30.43813503865524, -0.627083811810946],
            [30.438163826965155, -0.628466675298627],
            [30.439215425379466, -0.631314238119722],
            [30.43997823788781, -0.630004069851863],
            [30.4523484615583, -0.624081004558967],
            [30.454709517992626, -0.622563707784694],
            [30.459608833432476, -0.622448578408515],
            [30.462601451325593, -0.621275030954069],
            [30.466846009907666, -0.620987843857649],
            [30.47097183995529, -0.619993484218397],
            [30.472956463657976, -0.618823588556159],
            [30.474659292144228, -0.618778485878004],
            [30.474963639565885, -0.618197033086452],
            [30.475670731373768, -0.617937180865821],
            [30.475922572267045, -0.617052810288477],
            [30.478917780901426, -0.615665897133032],
            [30.47948567606113, -0.614745661208781],
            [30.48073537365683, -0.614059704878034],
            [30.4818700644383, -0.61281443458868],
            [30.484548740004225, -0.61195207961452],
            [30.48658529531348, -0.612065376759315],
            [30.490303465393595, -0.610648818691404],
            [30.491064130030114, -0.60973640399198],
            [30.490820565315527, -0.60854266703965],
            [30.491134617237197, -0.608128556256436],
            [30.49240457902909, -0.606900415403278],
            [30.493681216201843, -0.606325260855297],
            [30.494211661495658, -0.605525074670136],
            [30.495927809302643, -0.604725437206954],
            [30.496493050838957, -0.604093777944637],
            [30.496361011068622, -0.603040515902962],
            [30.497714549419605, -0.602072193661591],
            [30.498516417981552, -0.602571078724483],
            [30.500880684994666, -0.602951320830033],
            [30.501976494893995, -0.604109994329067],
            [30.503148554692952, -0.604493258989733],
            [30.50466627453515, -0.605694328475765],
            [30.5098958070802, -0.606760832223767],
            [30.511226633325837, -0.606378719299072],
            [30.512653056487387, -0.604784678698141],
            [30.513952318628903, -0.604147396301668],
            [30.516555241961864, -0.604773746810154],
            [30.517849283993282, -0.604053499726016],
            [30.522695957259163, -0.605682321366301],
            [30.527509708168218, -0.610085942020314],
            [30.52915549004066, -0.613850233373681],
            [30.53047323412083, -0.614920573784657],
            [30.530190835236557, -0.616065606376135],
            [30.531834609374357, -0.616417683381658],
            [30.533008424481377, -0.614706968505001],
            [30.534620425207606, -0.615783905590708],
            [30.53564898632645, -0.615758457788424],
            [30.538899029938936, -0.6154919942297],
            [30.540150715506382, -0.613122826542812],
            [30.5412460834346, -0.612331184756065],
            [30.543349235347442, -0.614217130977599],
            [30.545332894259534, -0.613224882789239],
            [30.54585583772239, -0.614420971252875],
            [30.546912491855135, -0.615272742488644],
            [30.548896060037357, -0.61449331201581],
            [30.54994359267671, -0.613267538643743],
            [30.54894753440144, -0.611980020117601],
            [30.55019050631064, -0.610833279949875],
            [30.54936127147184, -0.609791191833319],
            [30.548335888592497, -0.60654773683433],
            [30.54902373489373, -0.606031608142827],
            [30.549492083245216, -0.604932860123195],
            [30.550365591552755, -0.604540768240638],
            [30.55042826611181, -0.603881419926321],
            [30.551878910548403, -0.603238396609149],
            [30.552399415085265, -0.599924686103688],
            [30.55303450512649, -0.599753631993569],
            [30.553596406726633, -0.598686318433816],
            [30.554828611428785, -0.59827868250217],
            [30.555187559351726, -0.597697960487437],
            [30.556123192449366, -0.597886772489701],
            [30.556809558327046, -0.597494590274502],
            [30.5575901215454, -0.595673792222959],
            [30.55986749092783, -0.594638632233272],
            [30.560460449083923, -0.593869616001232],
            [30.561988968472487, -0.593462102775659],
            [30.563741365996112, -0.591239449987987],
            [30.56483516456754, -0.591024180187806],
            [30.56549928815875, -0.590323726424261],
            [30.567433360067177, -0.589759387976401],
            [30.568790078454246, -0.589948378106806],
            [30.570360997425883, -0.591261624618391],
            [30.57089505933701, -0.590875582489489],
            [30.571129364217644, -0.59001220092232],
            [30.572002871626854, -0.589635789933156],
            [30.573359282790122, -0.590546967478002],
            [30.574700648969, -0.590186460353352],
            [30.575729489463914, -0.59125449327306],
            [30.57770981293132, -0.591961849205431],
            [30.579377875717775, -0.593485460414912],
            [30.58237177371019, -0.594522962402671],
            [30.58354143680396, -0.594539175222375],
            [30.58538514807624, -0.59582265567933],
            [30.586448227858188, -0.594126845538568],
            [30.587203618485677, -0.593450562738236],
            [30.588448432839492, -0.593116975970692],
            [30.590540679204796, -0.590327892589428],
            [30.59336073432508, -0.588027893184593],
            [30.59355168201851, -0.58689352523823],
            [30.591878594954693, -0.583199985488404],
            [30.595565387780223, -0.575728136186273],
            [30.59705228911997, -0.575544607060184],
            [30.598963656109547, -0.57254626827166],
            [30.60231430564399, -0.570596071628407],
            [30.603233640607428, -0.570818880494557],
            [30.60380395223523, -0.570517769367619],
            [30.603847371406168, -0.568924932995838],
            [30.60503071314681, -0.568430348555804],
            [30.6084761052993, -0.561357188916792],
            [30.60942412167316, -0.561163851998117],
            [30.60997338128225, -0.560044768216972],
            [30.61092869017958, -0.55944245410485],
            [30.61005266569094, -0.557849235630079],
            [30.608769900211282, -0.557454085453344],
            [30.608437297180725, -0.555330137977982],
            [30.609476899492734, -0.55167865225071],
            [30.60913586577321, -0.551017121284411],
            [30.60946958900295, -0.548595008286514],
            [30.61085197046107, -0.548269158446983],
            [30.611194249245568, -0.545778329030852],
            [30.61097290525785, -0.54450698927821],
            [30.611323080233703, -0.543622404201475],
            [30.612850916004312, -0.542265860809955],
            [30.612067132325663, -0.53918190391453],
            [30.61106927113165, -0.538064870371207],
            [30.6115816818478, -0.536862536349319],
            [30.61136933448768, -0.534362895548024],
            [30.61185605518337, -0.533392466116686],
            [30.611771192236773, -0.532189896728825],
            [30.613589433575818, -0.530000264649968],
            [30.614835488503054, -0.529158969035357],
            [30.61491347574444, -0.526006627786787],
            [30.614564300593496, -0.524271402580683],
            [30.612930476195775, -0.523328046563335],
            [30.61230757629293, -0.521354666436746],
            [30.61085302957478, -0.519709830100825],
            [30.60871639655296, -0.515523578626693],
            [30.606430464429234, -0.513519687811261],
            [30.603283323730867, -0.511515481071551],
            [30.60194765556584, -0.509631541687725],
            [30.599781307172734, -0.505475214326367],
            [30.599772599802698, -0.504071141840719],
            [30.597910326641692, -0.500135161968326],
            [30.596744300826472, -0.49966046352818],
            [30.596304437154348, -0.498672889591537],
            [30.595353980956205, -0.498432759244072],
            [30.594520927379154, -0.497179455506019],
            [30.593277700348438, -0.496626983637659],
            [30.592922706809393, -0.495872690298376],
            [30.59134707976737, -0.496175335748969],
            [30.58939513497807, -0.498465400091357],
            [30.587280148659666, -0.500090941388156],
            [30.58076960504476, -0.503030248425954],
            [30.57601707522063, -0.506041926783246],
            [30.57211585453676, -0.505200532772846],
            [30.568556211951492, -0.50917213895096],
            [30.56221139762503, -0.51376160876883],
            [30.56047683255808, -0.514598004533997],
            [30.55745944811259, -0.515314323650069],
            [30.555297846417442, -0.514619933322218],
            [30.55152034081621, -0.515120713093282],
            [30.54878695784948, -0.518707022636041],
            [30.546078742083726, -0.518610308585358],
            [30.54211199379146, -0.517054250217236],
            [30.540425192148184, -0.517292751293685],
            [30.537836727199707, -0.514708866540594],
            [30.536673492450106, -0.512532103408815],
            [30.533040311979008, -0.508465072330214],
            [30.528384101316295, -0.508415457635668],
            [30.52783782591057, -0.508104348259694],
            [30.526888083873047, -0.506764723452634],
            [30.526009222504733, -0.506453488238028],
            [30.525629439057116, -0.505616306317334],
            [30.523515628633422, -0.504324073376585],
            [30.52318580049876, -0.503620185241999],
            [30.52429502044866, -0.50253175923053],
            [30.525731941322626, -0.499360964916475],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 187,
        District: "MBARARA",
        County: "KASHARI",
        Subcounty: "BUBAARE",
        Population: 22458,
        Key: "MBARARABUBAARE",
        Dist2: "Mbarara",
        "Sub Country": "Bubaare",
        id2_original: "Mbarara Bubaare",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.77668649115863, -0.4802889920887],
            [30.774869791328612, -0.480637154274787],
            [30.77449069958379, -0.481230892810946],
            [30.773046133148434, -0.484738423468379],
            [30.77285596159943, -0.486675835765538],
            [30.771846159998635, -0.488700858806082],
            [30.768130702830682, -0.490666629634724],
            [30.766308132510325, -0.490856831037284],
            [30.763244411165847, -0.489602791075236],
            [30.757084722551426, -0.488541316626832],
            [30.753061006697124, -0.488305335081271],
            [30.749852275706218, -0.48932547689333],
            [30.74645449695872, -0.491319263165729],
            [30.742444316919084, -0.490439190829314],
            [30.736546590516262, -0.490413446954668],
            [30.72684034507532, -0.492592236795574],
            [30.71860467139891, -0.493798885536843],
            [30.707715707648145, -0.494203013578535],
            [30.704623797170054, -0.494655663185863],
            [30.698834482150648, -0.496621355005525],
            [30.69300655125215, -0.501338129973187],
            [30.690014236989615, -0.505699693677629],
            [30.68878879390658, -0.506208675441728],
            [30.686246821265613, -0.506338327818302],
            [30.674679379743715, -0.502719180112865],
            [30.667874237224652, -0.505221380063486],
            [30.662350911564243, -0.505497403646923],
            [30.659381814260225, -0.506538871566108],
            [30.659104533078114, -0.509666386857377],
            [30.65942791669893, -0.511542327052166],
            [30.661823802613416, -0.515478083493962],
            [30.6634540876489, -0.515820180438799],
            [30.664781930589506, -0.517628088594177],
            [30.66638230801426, -0.518722498177512],
            [30.669617178183298, -0.522312494906772],
            [30.67000476349914, -0.523307019676237],
            [30.671008526624583, -0.524057696927847],
            [30.67627745209145, -0.53090913032202],
            [30.673694997770557, -0.532295878088096],
            [30.671250792375226, -0.53537987259375],
            [30.67045799410271, -0.538368216261807],
            [30.671447157808153, -0.543606974534344],
            [30.676980067594297, -0.552257329086111],
            [30.688623317943016, -0.557450851671389],
            [30.692822078615297, -0.560527459346724],
            [30.697590928133163, -0.570330797002684],
            [30.70370197387326, -0.565336401222829],
            [30.712482164054116, -0.569567999778404],
            [30.72164596720061, -0.569379448222351],
            [30.72660997751059, -0.568612657159097],
            [30.731036190714484, -0.559538544105947],
            [30.74164659857376, -0.557550582404499],
            [30.750438877383385, -0.565894698526374],
            [30.755543783055785, -0.568445791632119],
            [30.757153444568974, -0.568661383871888],
            [30.757892307991867, -0.569455392537467],
            [30.76027359897794, -0.570696511770118],
            [30.764605866369415, -0.571350226454782],
            [30.76749752440438, -0.574123330912976],
            [30.770280435085983, -0.575355301153831],
            [30.77214834876863, -0.57776776100574],
            [30.773042794110516, -0.57832851476569],
            [30.77291262373428, -0.580750200375139],
            [30.77408499794359, -0.582361819839417],
            [30.775505851550367, -0.584073612860835],
            [30.778188740214986, -0.585870382443035],
            [30.781943337878204, -0.590346925981668],
            [30.783895903403334, -0.594922213291441],
            [30.78282626951306, -0.598022679292305],
            [30.783760905480758, -0.600572485891501],
            [30.784542471218973, -0.601666706633973],
            [30.7856091173126, -0.60219149232632],
            [30.786053630664664, -0.603581852901959],
            [30.786095261289855, -0.604033720820978],
            [30.786414446185034, -0.603168198058468],
            [30.786103878828374, -0.588079414242344],
            [30.777799643034534, -0.56842208715671],
            [30.79462891872245, -0.546387591783703],
            [30.796616395474473, -0.536678714074971],
            [30.820905316316026, -0.511301001570066],
            [30.806821251712186, -0.512236425773472],
            [30.79426634789398, -0.511192441794893],
            [30.781753355873686, -0.511007311770653],
            [30.78303035955909, -0.50779836804755],
            [30.786049775095456, -0.504327838070076],
            [30.785611885920318, -0.502188300685459],
            [30.785879582078366, -0.501723178067789],
            [30.788303040882155, -0.4994110449896],
            [30.79122083629864, -0.495312053838352],
            [30.79330038767236, -0.493817753050318],
            [30.79145911173281, -0.493278941974317],
            [30.787310446510666, -0.490197890620339],
            [30.77668649115863, -0.4802889920887],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 188,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "BIHARWE DIVISION",
        Population: 21906,
        Key: "MBARARABIHARWE DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Biharwe Division",
        id2_original: "Mbarara Biharwe Division",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.157471262012397, -0.525733418497557],
            [30.1570173181465, -0.524707745438773],
            [30.157244489505423, -0.52012992431993],
            [30.147316356596054, -0.518715970387867],
            [30.14441206285832, -0.516441680701839],
            [30.142854107474527, -0.516555596824174],
            [30.142116619372363, -0.517007064534914],
            [30.138722001796346, -0.51649951727991],
            [30.138489352510792, -0.514872935408036],
            [30.13875208278195, -0.514346591492976],
            [30.137707061832153, -0.514571993965711],
            [30.13764692411546, -0.515545676288147],
            [30.136654901072454, -0.517588813157759],
            [30.134110808407474, -0.519018168325408],
            [30.133471062398094, -0.521019384128873],
            [30.133479983567163, -0.522003566330025],
            [30.135874764553854, -0.524100798088698],
            [30.135917706719404, -0.525970328395794],
            [30.13508468188846, -0.526680896346655],
            [30.134448780668485, -0.531723163902182],
            [30.133828599067687, -0.532653577176722],
            [30.132128338864835, -0.533348551181962],
            [30.131765646763792, -0.535498932797342],
            [30.13211706680462, -0.537098457717345],
            [30.131664398546437, -0.537595220391787],
            [30.130569219264437, -0.538471188291021],
            [30.127648133319095, -0.539530698894686],
            [30.126529932012982, -0.539010770750241],
            [30.12610161438719, -0.539512879804429],
            [30.124925744833106, -0.544314733333664],
            [30.125181552686666, -0.545209407729299],
            [30.124268169062, -0.552781027935579],
            [30.124738713794322, -0.554208924180156],
            [30.126521732191076, -0.556796765336988],
            [30.125998358435183, -0.560040993676491],
            [30.125432156599807, -0.561369963245295],
            [30.122946043898185, -0.564597131769899],
            [30.120492736772402, -0.569593490909907],
            [30.116340084827037, -0.574123907602426],
            [30.118581723719043, -0.579238508429259],
            [30.1190355768551, -0.582862980195371],
            [30.11978939004092, -0.585065729791753],
            [30.120394083787893, -0.585653934805829],
            [30.121160954884722, -0.584441375694848],
            [30.122346707703535, -0.584077441281667],
            [30.123212737536377, -0.583776709926184],
            [30.124638406113057, -0.584225246887908],
            [30.125802205004675, -0.586589076999941],
            [30.127571319277454, -0.587650874832254],
            [30.132940897378642, -0.585792076799839],
            [30.13564453802464, -0.586914408176308],
            [30.14013796766968, -0.58759729044886],
            [30.142364237285484, -0.589059673328057],
            [30.143441726044607, -0.588747077020086],
            [30.14397916202793, -0.586402901030189],
            [30.14383720665347, -0.58478438851298],
            [30.14456349725565, -0.58383231814536],
            [30.144793427340826, -0.575900906727821],
            [30.144267010991058, -0.574186948203706],
            [30.14208461599203, -0.570167020678723],
            [30.14181464979129, -0.567725256021508],
            [30.144272032573504, -0.563935113595907],
            [30.145196229219263, -0.558311581963475],
            [30.1464217432692, -0.557001431416502],
            [30.14956274937253, -0.555020952372327],
            [30.15016664541555, -0.554135287330895],
            [30.150230560548, -0.54861077479361],
            [30.150699784756885, -0.545329727121271],
            [30.153557471202753, -0.536159484546252],
            [30.153354708866697, -0.533861361866155],
            [30.153804109053905, -0.531666131422234],
            [30.154600065802956, -0.529306913454514],
            [30.156292887056974, -0.526783958398862],
            [30.157471262012397, -0.525733418497557],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 189,
        District: "BUSHENYI",
        County: "BUSHENYI-ISHAKA MUNICIPALITY",
        Subcounty: "ISHAKA DIVISON",
        Population: 16439,
        Key: "BUSHENYIISHAKA DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.753880588239834, 0.194710170031993],
            [30.749837336723022, 0.197683789088849],
            [30.74519731100678, 0.19950928593406],
            [30.742891138043092, 0.199807292135331],
            [30.73943480620705, 0.19942711663464],
            [30.736016022153283, 0.198486451456146],
            [30.729771681696377, 0.195737356155673],
            [30.727231916216116, 0.196071491555581],
            [30.722782297407477, 0.197345536766679],
            [30.721778237838, 0.199496952139948],
            [30.720632380997543, 0.200247121686117],
            [30.7202518842876, 0.201133001547199],
            [30.716348850803495, 0.202868146921829],
            [30.714644017277514, 0.204567440575962],
            [30.712429647644267, 0.205868891648542],
            [30.709178218829596, 0.204648005468505],
            [30.70809372141465, 0.203183357487883],
            [30.706572517007483, 0.202224890722465],
            [30.703152936148022, 0.201546394705407],
            [30.699540321707044, 0.201726674686751],
            [30.69740003972858, 0.202178365466984],
            [30.693052800116245, 0.205296523868275],
            [30.68650873586651, 0.208043696967187],
            [30.681266734705314, 0.208757062381762],
            [30.67261123338084, 0.208177208195587],
            [30.67069215345625, 0.210183759876248],
            [30.669273848369897, 0.210093145626379],
            [30.667540761031617, 0.20963185214426],
            [30.66503882899781, 0.208185105233109],
            [30.664234665240308, 0.205830783563523],
            [30.66428262270009, 0.203418572677794],
            [30.663822659223474, 0.201964784251671],
            [30.659935329188833, 0.199536028617901],
            [30.657365022785516, 0.197315147839167],
            [30.656460758857584, 0.195813381032683],
            [30.654443317900938, 0.195713524888558],
            [30.652015943340793, 0.194433743843312],
            [30.650068185599032, 0.194189395406384],
            [30.648948170594377, 0.19516552251567],
            [30.64795022316208, 0.195111141518713],
            [30.64581901147304, 0.196475826282438],
            [30.645203616994376, 0.195761605136934],
            [30.644695456207828, 0.193727609199111],
            [30.643785361315402, 0.193510528956914],
            [30.64399446216408, 0.191106011200423],
            [30.643263335032422, 0.189252781707],
            [30.643464110295064, 0.186107012545206],
            [30.641962237632804, 0.179489792637747],
            [30.632635445957767, 0.173992498463379],
            [30.629269551114646, 0.170629351504746],
            [30.625683443262755, 0.165666197104227],
            [30.623129058599527, 0.164391312443021],
            [30.62158245522603, 0.164188002072181],
            [30.620610121457435, 0.164591570349083],
            [30.61788867889746, 0.167843753537564],
            [30.615614335040892, 0.168919166137624],
            [30.614512149797996, 0.169036540400517],
            [30.613907508153286, 0.16863013085568],
            [30.612545533723498, 0.167418232391832],
            [30.610198939266947, 0.168547868887987],
            [30.607306600309016, 0.168362009157324],
            [30.60493342470322, 0.165236188845312],
            [30.604028680176608, 0.164152247474015],
            [30.60459904660163, 0.162454226481654],
            [30.60452951160874, 0.159869341663993],
            [30.603773033121463, 0.158721249760757],
            [30.60357600473188, 0.157158885093406],
            [30.602834497567134, 0.155818656688995],
            [30.603485253328643, 0.155390093606995],
            [30.603822829432634, 0.153869678966076],
            [30.605932983713114, 0.154028479873837],
            [30.60652990164301, 0.155536023489393],
            [30.607758999072605, 0.155689829770123],
            [30.608754991770823, 0.157016304129086],
            [30.610891944592883, 0.156539388533528],
            [30.610908398135614, 0.153150700535989],
            [30.613439071766923, 0.151954028444983],
            [30.61361587458789, 0.15135556661092],
            [30.612362746326106, 0.150522405432163],
            [30.613471393150853, 0.150263727454077],
            [30.613272087532028, 0.149728124072663],
            [30.61156422039532, 0.148814950159591],
            [30.61145333415327, 0.148111162921353],
            [30.612965574272238, 0.147627120817245],
            [30.614347705998732, 0.144125349171296],
            [30.6146049852927, 0.142152005483561],
            [30.61652498778715, 0.142127945979336],
            [30.617305259053012, 0.141072750339831],
            [30.61960980157447, 0.142573091269784],
            [30.62046951355589, 0.141360039678233],
            [30.620445468350677, 0.140826254270057],
            [30.619184267827784, 0.140243813544707],
            [30.619224587810972, 0.138763785110687],
            [30.618775163369268, 0.138348026249925],
            [30.61809190386585, 0.138391637533169],
            [30.61791529867428, 0.137081426917597],
            [30.61744940721509, 0.136579948331862],
            [30.618541954433326, 0.136652848206548],
            [30.618132309189033, 0.136030061458089],
            [30.618783045187573, 0.13579558565897],
            [30.61891036071787, 0.13524218995762],
            [30.619731010357466, 0.135666279824833],
            [30.62030949845098, 0.13490610239767],
            [30.622446104523327, 0.134850115052736],
            [30.623755721545116, 0.134018610663441],
            [30.62442332341313, 0.133331673530194],
            [30.62503351934123, 0.131695780196079],
            [30.624945040675644, 0.130642006128655],
            [30.626102069863265, 0.130741541898169],
            [30.626323699515222, 0.131557420244511],
            [30.62781312152765, 0.131696052384914],
            [30.62868065963181, 0.132569605980225],
            [30.629066380943442, 0.131437369706114],
            [30.630030377447873, 0.131744795741743],
            [30.630174929851844, 0.132270509111919],
            [30.630629088415077, 0.132130026450184],
            [30.630691905806273, 0.131365695114727],
            [30.631548766534973, 0.131259682511516],
            [30.631918364883898, 0.130693580071627],
            [30.631529888439267, 0.129947559005732],
            [30.63206309335763, 0.129391476319499],
            [30.63273031793323, 0.129976205308113],
            [30.634385724355642, 0.12940898803299],
            [30.634631675893914, 0.128975601417471],
            [30.635011438680266, 0.129157216052598],
            [30.63555784434174, 0.127847058845196],
            [30.635164213364035, 0.127693355685641],
            [30.634905866871446, 0.12830821952221],
            [30.63469825902278, 0.127766101076594],
            [30.633755812203685, 0.127277432247115],
            [30.634304751114247, 0.126286014400817],
            [30.633863008166557, 0.125153694304339],
            [30.63465284289696, 0.12529977259704],
            [30.634586078308413, 0.124628060737621],
            [30.63523676759457, 0.124967805467079],
            [30.636514226725836, 0.123657713625195],
            [30.636700083666515, 0.121463889888531],
            [30.63746208499618, 0.120491312149582],
            [30.63747062527958, 0.119152940287324],
            [30.636638753885443, 0.118489854777813],
            [30.636895695412907, 0.117967395720872],
            [30.636348280045063, 0.117976627687473],
            [30.63594440917144, 0.117227930187682],
            [30.637021160413685, 0.11427600661139],
            [30.6369248637102, 0.112998139463416],
            [30.63631577630315, 0.111963235538007],
            [30.637366863576048, 0.111138000664606],
            [30.638547814899713, 0.110992518777672],
            [30.638588085475593, 0.109730836403347],
            [30.63949943172121, 0.108501325283428],
            [30.639599301024617, 0.107027875228074],
            [30.639528355676717, 0.105428239866169],
            [30.639014235466593, 0.105031900238041],
            [30.63929546025279, 0.104392991627183],
            [30.638315450380105, 0.103228282857296],
            [30.638154902574215, 0.101578374963045],
            [30.63749161082294, 0.101287556625337],
            [30.638078921270854, 0.100488174941009],
            [30.63591624429231, 0.099096694761322],
            [30.633628215500732, 0.099033474121093],
            [30.63261787940236, 0.09804981135665],
            [30.63129018917539, 0.097574734417679],
            [30.630503072747015, 0.097960823476496],
            [30.630480219606188, 0.097225796027826],
            [30.629382163918653, 0.096813787008419],
            [30.629908332333383, 0.095552816434336],
            [30.629328087135182, 0.093959702270759],
            [30.627633012906433, 0.092997014994627],
            [30.626980076933734, 0.09369572010208],
            [30.626580905147367, 0.092303388941376],
            [30.625595563773473, 0.092164610189602],
            [30.626192684722614, 0.091210491883356],
            [30.625178116660916, 0.09107591454263],
            [30.62469803271858, 0.090096503273682],
            [30.62501120608789, 0.089604732854197],
            [30.62619281857158, 0.089209696494027],
            [30.62610934711539, 0.088717900011514],
            [30.625128198178906, 0.088305907062681],
            [30.62660656642175, 0.087564717876179],
            [30.6266772907841, 0.086960936619462],
            [30.625379324013227, 0.087113070628868],
            [30.625132510092275, 0.08618321655844],
            [30.62556258751769, 0.085720875761514],
            [30.625353861266504, 0.085161817950901],
            [30.62610999929228, 0.08497248563703],
            [30.626105451121973, 0.084359026799286],
            [30.62666078154581, 0.083926116554258],
            [30.625287211662286, 0.082711262299701],
            [30.625685483336767, 0.08164514102049],
            [30.625550373124785, 0.080676858726976],
            [30.62374674288383, 0.079672150659215],
            [30.62332513477492, 0.078175736682019],
            [30.62292432446145, 0.078003375291922],
            [30.62251095929357, 0.078356431734523],
            [30.62184295228537, 0.077927651875132],
            [30.621957454246438, 0.076507509227165],
            [30.622786722322857, 0.074850862778219],
            [30.623751226375447, 0.07429187309139],
            [30.623985093776497, 0.073274677402624],
            [30.6260268934504, 0.071009185544231],
            [30.62778852116357, 0.070029543824508],
            [30.62869214369441, 0.069856376614522],
            [30.631026076397003, 0.068265535962202],
            [30.63485446706752, 0.06380017624656],
            [30.63495115723314, 0.063275884734846],
            [30.634241290529324, 0.062371891743241],
            [30.634433954903237, 0.061612575922423],
            [30.635788109498527, 0.061684955837925],
            [30.63879004471774, 0.059235360118296],
            [30.641987901602143, 0.055395629240899],
            [30.6428472919867, 0.053838875612012],
            [30.64366564104083, 0.050647912827724],
            [30.645359587883885, 0.047502177350411],
            [30.64833499764944, 0.050348515239593],
            [30.65112491968182, 0.051977651578575],
            [30.652378039858757, 0.053441184423507],
            [30.659746593147656, 0.057276838876936],
            [30.666214457803395, 0.059197064958184],
            [30.66694253335805, 0.06293536954979],
            [30.668920066658202, 0.064155996013841],
            [30.671563565994227, 0.063286664511674],
            [30.672466189598456, 0.063599351700725],
            [30.673131598678857, 0.062888985966355],
            [30.673790710569133, 0.063162911775177],
            [30.673553169058554, 0.062361649158438],
            [30.674271860811718, 0.061990954184827],
            [30.67605367456767, 0.062606924119441],
            [30.676998063544385, 0.062337890529872],
            [30.677140648637845, 0.061518705622686],
            [30.679849071016093, 0.061148099576359],
            [30.681191379527725, 0.061530849940011],
            [30.681838818709185, 0.060765499228542],
            [30.681577507776172, 0.060173514277601],
            [30.682426872962154, 0.059778904352425],
            [30.681518143508953, 0.059461948349041],
            [30.68161320772389, 0.058714512700888],
            [30.680930173697604, 0.058535096774684],
            [30.681524303256847, 0.057601040700095],
            [30.683039385645365, 0.058255429812435],
            [30.684107851725777, 0.057494796106706],
            [30.68514128889997, 0.058397750727471],
            [30.685067449180252, 0.059119898818082],
            [30.685694665488054, 0.058789770820888],
            [30.68628766047509, 0.057333441694703],
            [30.687285327633, 0.056670174526163],
            [30.688152708532, 0.056412669880405],
            [30.689468978476764, 0.057465781435956],
            [30.690201834865338, 0.056699774898602],
            [30.69083734980972, 0.057070534586473],
            [30.691353611603496, 0.05833657189509],
            [30.692262782129507, 0.0584219782781],
            [30.69307567571497, 0.059077294441771],
            [30.69406484930185, 0.058754084366702],
            [30.694886209508848, 0.05917875191256],
            [30.69500273267929, 0.059720721401423],
            [30.69408048986928, 0.060611889197777],
            [30.694902767256153, 0.061273975933739],
            [30.696606635991547, 0.059899584860177],
            [30.6964790877976, 0.057597625307089],
            [30.695791598127514, 0.056053644875301],
            [30.696040729701878, 0.055647650577231],
            [30.697122933717935, 0.05611702637811],
            [30.697861079386882, 0.055781820189682],
            [30.699574789166213, 0.057545138568176],
            [30.701146518418227, 0.057944235591697],
            [30.70174036680478, 0.057692834102606],
            [30.701966860833988, 0.059056200213472],
            [30.702770026563208, 0.059319553774932],
            [30.703983261541556, 0.058912805813913],
            [30.704105369538116, 0.05790936660345],
            [30.704615217360775, 0.057553272808957],
            [30.706047063651706, 0.058218223409205],
            [30.70643437857465, 0.058997930125204],
            [30.707028689593574, 0.059028480913486],
            [30.708332878096112, 0.058614672195917],
            [30.7095213501153, 0.057195892625405],
            [30.70987653230054, 0.057514384759914],
            [30.709748505304574, 0.058544656640972],
            [30.710270506434707, 0.059173836333965],
            [30.710575639882222, 0.061727256581815],
            [30.712456998649728, 0.063202396301158],
            [30.713501881258974, 0.065284653888086],
            [30.714959933203364, 0.065063096244699],
            [30.715337380132926, 0.063945645740041],
            [30.715859084819012, 0.063744525649178],
            [30.71890039229884, 0.06512474398959],
            [30.719599630136234, 0.066331646847627],
            [30.720593047364535, 0.066868081745349],
            [30.720615192632913, 0.067979967125117],
            [30.722369659874985, 0.068080316956473],
            [30.72912347984525, 0.073794055024377],
            [30.732028882104068, 0.07551185068006],
            [30.732611530295642, 0.078965245479958],
            [30.733580546585884, 0.080565420131367],
            [30.73517104883071, 0.081098885928563],
            [30.73728778327066, 0.081169141299856],
            [30.736247607833505, 0.083770315613167],
            [30.73426616237029, 0.085655953690222],
            [30.734221569101276, 0.0871776971523],
            [30.7353208985999, 0.088440405361983],
            [30.73572652478161, 0.090142379280204],
            [30.737457510960454, 0.092395873973013],
            [30.737953944240964, 0.094468761582681],
            [30.734458868965035, 0.097943738443067],
            [30.729720005211348, 0.104591619585975],
            [30.726288993289923, 0.111325899121867],
            [30.73023278962666, 0.126608471971622],
            [30.73263389924453, 0.129371587669803],
            [30.733661889933188, 0.141632055005004],
            [30.734727399657984, 0.145119538478548],
            [30.736588466381555, 0.146076086657426],
            [30.736969955729897, 0.147552938187188],
            [30.73668362042804, 0.148561462609667],
            [30.734620098592256, 0.15123871326786],
            [30.734011675040197, 0.152979601729318],
            [30.734643390110932, 0.156461578550505],
            [30.73422579477639, 0.158070413841339],
            [30.73553737821033, 0.160808063087138],
            [30.735623990176745, 0.164372589832938],
            [30.737301968567326, 0.165178667261858],
            [30.73983433552293, 0.165031092639669],
            [30.740987153408526, 0.165527288497098],
            [30.74282365839559, 0.166800208478056],
            [30.74626591003786, 0.170989398263901],
            [30.752280437190553, 0.173825251792526],
            [30.751754075638015, 0.177033978522178],
            [30.749867202112956, 0.177551793719013],
            [30.749180876659477, 0.179278540460998],
            [30.75003834464931, 0.18066011470467],
            [30.750381075286416, 0.183250407239097],
            [30.752439107517507, 0.185668240838755],
            [30.753296505438733, 0.18756787294081],
            [30.753810571749966, 0.191539665994554],
            [30.75342448392569, 0.192662057921099],
            [30.753880588239834, 0.194710170031993],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 190,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "BUREMBA",
        Population: 21003,
        Key: "KIRUHURABUREMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.641512214913103, -0.638451220298605],
            [30.64110689236197, -0.640528621062607],
            [30.635775763951553, -0.640167404996126],
            [30.63499214107135, -0.636691772140718],
            [30.632630376764617, -0.636491399115163],
            [30.629025539039073, -0.635467624410256],
            [30.62402611714058, -0.636859397301374],
            [30.617666917193162, -0.636815143634319],
            [30.616560287086223, -0.637420998274952],
            [30.616617647212056, -0.634508484713824],
            [30.615472973452842, -0.632038627878251],
            [30.614965144144627, -0.62924518568539],
            [30.616159763335325, -0.624907201624808],
            [30.615653950744925, -0.620368274432345],
            [30.61416129300085, -0.619282864962322],
            [30.61330499821076, -0.619369644335356],
            [30.612208291792797, -0.617578076848626],
            [30.60993004745126, -0.617664891281818],
            [30.608738515770224, -0.617203343926401],
            [30.60842996692801, -0.617248401704782],
            [30.60846189125656, -0.61834218430025],
            [30.60719988584316, -0.617970998672649],
            [30.60580182878332, -0.615303747849438],
            [30.605864233847782, -0.614110577143827],
            [30.60478995387086, -0.61343214189437],
            [30.603784160552912, -0.613974050942876],
            [30.603355060494508, -0.613784032234701],
            [30.602820105657965, -0.612156706855318],
            [30.601483256208333, -0.611306407378627],
            [30.600939820377228, -0.610140086700808],
            [30.600176278436837, -0.610277218429532],
            [30.598760182307792, -0.607614388627815],
            [30.596747294911335, -0.606619972606157],
            [30.59611624100066, -0.605308249635178],
            [30.593155723505895, -0.604750564380733],
            [30.592208838111006, -0.60347844458361],
            [30.590708827656332, -0.603239336194868],
            [30.589919937055278, -0.601768587036663],
            [30.588854345583776, -0.60113226722813],
            [30.5882629415131, -0.599423165286271],
            [30.58538514807624, -0.59582265567933],
            [30.58354143680396, -0.594539175222375],
            [30.58237177371019, -0.594522962402671],
            [30.579377875717775, -0.593485460414912],
            [30.57770981293132, -0.591961849205431],
            [30.575729489463914, -0.59125449327306],
            [30.574700648969, -0.590186460353352],
            [30.573359282790122, -0.590546967478002],
            [30.572002871626854, -0.589635789933156],
            [30.571129364217644, -0.59001220092232],
            [30.57089505933701, -0.590875582489489],
            [30.570360997425883, -0.591261624618391],
            [30.568790078454246, -0.589948378106806],
            [30.567433360067177, -0.589759387976401],
            [30.56549928815875, -0.590323726424261],
            [30.56483516456754, -0.591024180187806],
            [30.563741365996112, -0.591239449987987],
            [30.561988968472487, -0.593462102775659],
            [30.560460449083923, -0.593869616001232],
            [30.55986749092783, -0.594638632233272],
            [30.5575901215454, -0.595673792222959],
            [30.556809558327046, -0.597494590274502],
            [30.556123192449366, -0.597886772489701],
            [30.555187559351726, -0.597697960487437],
            [30.554828611428785, -0.59827868250217],
            [30.553596406726633, -0.598686318433816],
            [30.55303450512649, -0.599753631993569],
            [30.552399415085265, -0.599924686103688],
            [30.551878910548403, -0.603238396609149],
            [30.55042826611181, -0.603881419926321],
            [30.550365591552755, -0.604540768240638],
            [30.549492083245216, -0.604932860123195],
            [30.54902373489373, -0.606031608142827],
            [30.548335888592497, -0.60654773683433],
            [30.54936127147184, -0.609791191833319],
            [30.55019050631064, -0.610833279949875],
            [30.54894753440144, -0.611980020117601],
            [30.54994359267671, -0.613267538643743],
            [30.548896060037357, -0.61449331201581],
            [30.546912491855135, -0.615272742488644],
            [30.54585583772239, -0.614420971252875],
            [30.545332894259534, -0.613224882789239],
            [30.543349235347442, -0.614217130977599],
            [30.5412460834346, -0.612331184756065],
            [30.540150715506382, -0.613122826542812],
            [30.538899029938936, -0.6154919942297],
            [30.53564898632645, -0.615758457788424],
            [30.534414050745788, -0.618281097028267],
            [30.536229111150416, -0.622729087744077],
            [30.536950797886735, -0.623931603825139],
            [30.542476213926793, -0.627296687202143],
            [30.54262878828621, -0.628652603695493],
            [30.541924527968078, -0.629791179300558],
            [30.54213033559293, -0.631906392234707],
            [30.541783613741057, -0.633207837016006],
            [30.54230683927493, -0.634880291664307],
            [30.540741930930835, -0.638522242084839],
            [30.542029512278695, -0.640728364251165],
            [30.54085308487082, -0.642282496904055],
            [30.539430030391586, -0.642625289533712],
            [30.538627998336267, -0.643411288363931],
            [30.537225358071836, -0.643311181928413],
            [30.5356214367933, -0.64488317566332],
            [30.53469787974801, -0.646898402678727],
            [30.532990928892904, -0.6474127874177],
            [30.53209549360758, -0.648415667153926],
            [30.531652590036547, -0.649554348863808],
            [30.529190434505217, -0.652364230661935],
            [30.52736385141046, -0.655960794936517],
            [30.52691848196396, -0.658392025032634],
            [30.525555490641256, -0.660425085992043],
            [30.525809467728266, -0.662612612783428],
            [30.530557238278, -0.669393770273414],
            [30.531624326342765, -0.67334034723574],
            [30.540767176285264, -0.680519643621566],
            [30.546715367345794, -0.683717077168495],
            [30.54790509341314, -0.684958985816194],
            [30.55340584890201, -0.68819777904246],
            [30.557181123986418, -0.691065102413175],
            [30.557754511445744, -0.696317090568167],
            [30.55566764958227, -0.698110604135991],
            [30.56104870276291, -0.699975054379082],
            [30.561981144146337, -0.701012370203512],
            [30.562170366176105, -0.702638754904177],
            [30.56292979473078, -0.704217608276007],
            [30.56578022728071, -0.705175743562569],
            [30.56800727304094, -0.709974079072853],
            [30.56936713822644, -0.71089420388528],
            [30.57078370147945, -0.712901641647591],
            [30.571716037760016, -0.713652385502269],
            [30.57240558906367, -0.713716025304511],
            [30.575004737675822, -0.716582819223019],
            [30.577012475030788, -0.718183822138121],
            [30.58051737428264, -0.719812741928274],
            [30.581643482559873, -0.721087872424694],
            [30.58432872391222, -0.722743482491706],
            [30.586033438860614, -0.726089366711937],
            [30.58610331880656, -0.728739904522068],
            [30.590209836872184, -0.732245334520926],
            [30.59359010655649, -0.735780332777841],
            [30.59476682322187, -0.737952522028739],
            [30.596302472538834, -0.738595781843755],
            [30.60060437867034, -0.743587833163457],
            [30.608636771682804, -0.750475376583561],
            [30.61189246030858, -0.754675103556056],
            [30.61823934974334, -0.757470989500483],
            [30.620083113117886, -0.759783001856217],
            [30.62309168688708, -0.761561829140707],
            [30.625535458396108, -0.762033824251917],
            [30.627987772883504, -0.764280554907711],
            [30.630289716578826, -0.763934468400703],
            [30.635333662576063, -0.765414077487019],
            [30.637496167078055, -0.764987709503223],
            [30.638967364070005, -0.766155504949411],
            [30.64102476298881, -0.76621548189455],
            [30.640628716441274, -0.765140436434383],
            [30.642008653583527, -0.762517915852055],
            [30.642481838464484, -0.760503191495215],
            [30.643691115465653, -0.759173202660994],
            [30.64406998891991, -0.756949319594733],
            [30.645260787575687, -0.754858942199869],
            [30.64529593146623, -0.753863786752537],
            [30.64519738088969, -0.751427647327765],
            [30.646598564985023, -0.747645164450378],
            [30.646436444229053, -0.746564150082927],
            [30.64607893361061, -0.745777830670352],
            [30.643883431293258, -0.744138887874177],
            [30.64108742586977, -0.739731813590614],
            [30.639707449201648, -0.738791307270294],
            [30.636022953368293, -0.73309596055968],
            [30.635917792089547, -0.732097116516858],
            [30.63697754361338, -0.727774002566538],
            [30.637889011131573, -0.727021113339339],
            [30.638671214673657, -0.7245485102657],
            [30.639745568312414, -0.723419018379991],
            [30.64117139589095, -0.720407089545297],
            [30.64291188534719, -0.718253625632576],
            [30.643178364288005, -0.71640319985587],
            [30.642485205350173, -0.713812053146476],
            [30.642283776114006, -0.70821913897785],
            [30.64081536300113, -0.703674607790879],
            [30.640849724459073, -0.702379931099565],
            [30.641415897548345, -0.699092267595772],
            [30.643246798844686, -0.697470872334987],
            [30.643836681169248, -0.695096212898809],
            [30.644875563032418, -0.693927878012814],
            [30.64456352513361, -0.692770108050332],
            [30.645280019607615, -0.69230760289131],
            [30.645541181420274, -0.684700945217887],
            [30.64774989705712, -0.68121112239281],
            [30.648100423274236, -0.678134146420664],
            [30.64807013837106, -0.675120868099119],
            [30.64513246503397, -0.669380413236762],
            [30.645397648604174, -0.667783408125374],
            [30.643272074741816, -0.664779088007256],
            [30.643841341628956, -0.662902928859659],
            [30.64458574406385, -0.662355427937281],
            [30.646967508462097, -0.658832005162121],
            [30.648285628038053, -0.65854938420671],
            [30.649159651080264, -0.657908765989178],
            [30.65019743071056, -0.655419672668676],
            [30.650069150389648, -0.654100003434854],
            [30.648501161722475, -0.650312716223249],
            [30.646872800878306, -0.64898517152381],
            [30.645048726778146, -0.646005062534751],
            [30.643509301842048, -0.644498676147413],
            [30.643150562328305, -0.640979204899401],
            [30.641512214913103, -0.638451220298605],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 191,
        District: "MBARARA",
        County: "MBARARA MUNICIPALITY",
        Subcounty: "NYAKAYOJO DIVISION",
        Population: 38185,
        Key: "MBARARANYAKAYOJO DIVISION",
        Dist2: "Mbarara",
        "Sub Country": "Nyakayojo Division",
        id2_original: "Mbarara Nyakayojo Division",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.237921260805784, -0.486736586636289],
            [30.235251324050918, -0.488403944059583],
            [30.2331761330996, -0.488722578381211],
            [30.23085732173818, -0.487812307235352],
            [30.22856349521973, -0.48550121761708],
            [30.223828045962442, -0.484172173603048],
            [30.22268762033621, -0.484579026717306],
            [30.222854639605423, -0.485331971210248],
            [30.222275151686972, -0.487055977391012],
            [30.21997103227201, -0.488971905696324],
            [30.21834074454157, -0.489375494162339],
            [30.218186372653257, -0.491404065501628],
            [30.216342832959192, -0.493448641813047],
            [30.216791332136147, -0.494293070826553],
            [30.216684436210603, -0.495736672490864],
            [30.216199945133475, -0.496212114990708],
            [30.214935987680946, -0.496342385582942],
            [30.214415977217488, -0.49703187414784],
            [30.212597271449443, -0.496186813991225],
            [30.213694676756752, -0.498850910071044],
            [30.215217739778243, -0.500499695191936],
            [30.215051619722626, -0.502283295673696],
            [30.212982444788775, -0.507139983566363],
            [30.21015949799157, -0.506865266152174],
            [30.20942736025524, -0.506353625530212],
            [30.20722093801732, -0.500614001449555],
            [30.206335615965482, -0.499198566458955],
            [30.204858171190725, -0.501481050953548],
            [30.20261345467056, -0.502538393033755],
            [30.202341396293505, -0.503406322597562],
            [30.20093598472643, -0.502918182522573],
            [30.19953007998429, -0.503571621498743],
            [30.195738467239835, -0.50354617680273],
            [30.19397795882748, -0.504793963881232],
            [30.193198002870233, -0.50568549815412],
            [30.192701130313544, -0.507433222605406],
            [30.19348000559749, -0.509125643089406],
            [30.19272348039783, -0.510469014130795],
            [30.189875805675786, -0.512841177967994],
            [30.189627236446803, -0.513970756002911],
            [30.18878562192508, -0.514804756030521],
            [30.19033695403027, -0.516081895781754],
            [30.191474304723275, -0.517038767485442],
            [30.19100165883151, -0.51921076101386],
            [30.191740763901187, -0.520175592787006],
            [30.18988017148808, -0.5230417878748],
            [30.18974691000893, -0.523634666501023],
            [30.19030696736776, -0.524619962156483],
            [30.189822250813492, -0.525117047417188],
            [30.18927991272364, -0.52701037997165],
            [30.18685608111899, -0.530040914372183],
            [30.18556303262429, -0.532402507102925],
            [30.184798089312103, -0.532851641744505],
            [30.183789384554295, -0.536638315913815],
            [30.183894545833038, -0.537668368781553],
            [30.184396608855423, -0.53832177002203],
            [30.190876894516638, -0.535360069199552],
            [30.19249178871638, -0.535571208986164],
            [30.19669681693438, -0.534647146067203],
            [30.19918017540133, -0.534675297144182],
            [30.199064235237515, -0.538959738818703],
            [30.19846617375228, -0.541065537059949],
            [30.19868962249269, -0.541748314227071],
            [30.20306792405089, -0.542664140684161],
            [30.203128886421016, -0.547001393455045],
            [30.20380403413741, -0.550248679487487],
            [30.20470155980242, -0.552340775105743],
            [30.206206018714393, -0.553995295033021],
            [30.20670883272835, -0.555635664003081],
            [30.204516087340632, -0.557115708787275],
            [30.201473199724237, -0.560072899412745],
            [30.20250683183287, -0.561729691594191],
            [30.203713848672777, -0.565427649443277],
            [30.206083899039708, -0.567534900676664],
            [30.208128040621542, -0.570624852222787],
            [30.20998476309242, -0.570407771621834],
            [30.215928165234157, -0.56767493307293],
            [30.21732926758279, -0.568071526079004],
            [30.220015798915902, -0.569889160360398],
            [30.22065460888074, -0.571663007869374],
            [30.221753641935322, -0.573127786063844],
            [30.221823731188724, -0.575233166974786],
            [30.224399930540297, -0.575424193970463],
            [30.225629088157035, -0.574982543348253],
            [30.229557799085235, -0.57196377939002],
            [30.229201853332, -0.567517982636571],
            [30.230010148441483, -0.56438935793585],
            [30.23001120216531, -0.562148258536897],
            [30.227978956074473, -0.555884871888287],
            [30.227807295210187, -0.554032272453005],
            [30.226270947003954, -0.552116142938359],
            [30.224215413885986, -0.551029419550217],
            [30.222318189073945, -0.548988843979989],
            [30.221104057576962, -0.545617427400237],
            [30.223742562280016, -0.542147171726199],
            [30.225102658332542, -0.54151523069049],
            [30.227072375391426, -0.538895498643042],
            [30.227106328115923, -0.532922273220328],
            [30.228754425845185, -0.53231663905494],
            [30.232375849165795, -0.533756880655247],
            [30.235062103817807, -0.533610591865924],
            [30.238188860844076, -0.531350318018708],
            [30.240338124178788, -0.530662941413219],
            [30.242877440501434, -0.5314999188076],
            [30.244919364142838, -0.533311399369688],
            [30.245545379403087, -0.535036143653933],
            [30.247235335031338, -0.537675657390831],
            [30.248747368537774, -0.536700362523561],
            [30.249079084032868, -0.535128101077677],
            [30.24842151904152, -0.52881105557458],
            [30.248878846861086, -0.526887650141703],
            [30.24683664384362, -0.524323256557677],
            [30.245420831582212, -0.523044283290655],
            [30.24471669882484, -0.522873831472561],
            [30.241677485317943, -0.518710093850122],
            [30.237219611890183, -0.513993952265122],
            [30.235902386137937, -0.510600864512069],
            [30.23346921025767, -0.509955039165448],
            [30.233697427255617, -0.502181083897655],
            [30.235334644590168, -0.502011299845225],
            [30.235898759639124, -0.501360893309324],
            [30.236012487252424, -0.499734327388163],
            [30.236528778690598, -0.499065825649795],
            [30.23817774059917, -0.497539307050614],
            [30.24033035375156, -0.496401576050664],
            [30.242126137208505, -0.491865858015297],
            [30.24042822430346, -0.49100666093318],
            [30.238382474737254, -0.488755660332914],
            [30.237921260805784, -0.486736586636289],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 192,
        District: "BUSHENYI",
        County: "BUSHENYI-ISHAKA MUNICIPALITY",
        Subcounty: "NYAKABIRIZI DIVISION",
        Population: 8165,
        Key: "BUSHENYINYAKABIRIZI DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.020196470469802, -0.521598522884704],
              [31.002842345093963, -0.523681928487372],
              [30.993046267226312, -0.531073253560955],
              [30.99022061380515, -0.532778743916415],
              [30.985617881647944, -0.533999166430163],
              [30.982011327241878, -0.532606050266997],
              [30.97987492688374, -0.53282041136755],
              [30.977951837777997, -0.53403846960991],
              [30.97674069228103, -0.535758572297813],
              [30.975244043322125, -0.539485828238903],
              [30.973107365384543, -0.540560426996218],
              [30.970828861429922, -0.539842791219979],
              [30.964706223829413, -0.535396143966408],
              [30.961929518709795, -0.533889793208927],
              [30.960292320239876, -0.531953704790963],
              [30.959367245041758, -0.529946166824614],
              [30.95445520855914, -0.525499975043193],
              [30.950753603412902, -0.521484319404233],
              [30.94840329891424, -0.522702219973012],
              [30.945838900730532, -0.525353770497094],
              [30.94244110940661, -0.527018009938882],
              [30.94063356700262, -0.528117098807483],
              [30.935219446836392, -0.533992237127011],
              [30.9359487917105, -0.535155626952242],
              [30.94284717396617, -0.541995720751023],
              [30.949279542591803, -0.547100759664086],
              [30.955559338654652, -0.553113097173694],
              [30.960507757804546, -0.558702322462543],
              [30.964152195064468, -0.563046818860545],
              [30.964117791385693, -0.564040186240698],
              [30.962605335671093, -0.56564177671461],
              [30.96061757684804, -0.566531449899919],
              [30.956554771702443, -0.566553656964723],
              [30.946754686450305, -0.564989719593482],
              [30.941433031672876, -0.563588815445063],
              [30.939744685825623, -0.562785369629355],
              [30.934125418296237, -0.561683357820192],
              [30.929155123372528, -0.560956497534879],
              [30.922254586956793, -0.561558088382231],
              [30.917754498100564, -0.561254463408913],
              [30.91480478374542, -0.560095668820643],
              [30.910104834111536, -0.559439617360412],
              [30.907204552249834, -0.559941944774394],
              [30.9018533024754, -0.56296019580488],
              [30.8986531126662, -0.563210721143863],
              [30.880902770961274, -0.562952602712313],
              [30.875136641459388, -0.564143934831055],
              [30.87593488352252, -0.567853351287641],
              [30.87554214008031, -0.569679503940532],
              [30.87583108858132, -0.579190825595636],
              [30.87555559235168, -0.582671536653619],
              [30.877444390966385, -0.593178006037226],
              [30.877108994175284, -0.596897499065813],
              [30.877524231432208, -0.598482442533595],
              [30.87704845491166, -0.599857730250809],
              [30.87737415349096, -0.602548998457559],
              [30.87514501465613, -0.60619611370378],
              [30.87446160064248, -0.606823775442351],
              [30.87095649657472, -0.607211112643902],
              [30.869352047985124, -0.608466337901592],
              [30.867031264821637, -0.612186523830853],
              [30.86544681003531, -0.613392211373586],
              [30.864950501620598, -0.614542869219506],
              [30.862690793116673, -0.616607956204503],
              [30.861629589017035, -0.618188220228187],
              [30.859948533896624, -0.619851424870072],
              [30.858075063235596, -0.620474621540347],
              [30.8566141250042, -0.622789593789044],
              [30.856434401760243, -0.624439535043245],
              [30.853181653320433, -0.629776473869439],
              [30.848711757739217, -0.633544837369046],
              [30.84827580623015, -0.634510723178255],
              [30.850630506185475, -0.636000847707387],
              [30.851661084920472, -0.635539222920533],
              [30.852403609876436, -0.637004281214128],
              [30.853593228145957, -0.637036210755679],
              [30.85481156196183, -0.635578254114813],
              [30.855129821592268, -0.636122168490104],
              [30.856700363271454, -0.635997022916563],
              [30.85699819072078, -0.636855551851196],
              [30.855979545206026, -0.638487362668277],
              [30.856997633765282, -0.638207826098509],
              [30.857506090995905, -0.639491642748854],
              [30.859116684062045, -0.640279381988429],
              [30.860900075259632, -0.641949346162508],
              [30.86082090224205, -0.642607698931937],
              [30.861749993807823, -0.642298336800485],
              [30.862667830381373, -0.642847950814009],
              [30.86395273744464, -0.645019666921258],
              [30.863810457778357, -0.646466968431239],
              [30.86449255665843, -0.646594033326333],
              [30.864193089783736, -0.64748134066647],
              [30.86463351041136, -0.648331984562116],
              [30.863357832639306, -0.649715418118554],
              [30.86380844645046, -0.650272448241102],
              [30.864874146618074, -0.650101671535771],
              [30.86559812495669, -0.65046646106301],
              [30.86580782138841, -0.650936679025611],
              [30.865309019250486, -0.65166543063808],
              [30.865434674694118, -0.652336342475033],
              [30.865981833143792, -0.652916623689332],
              [30.867129398579895, -0.652727957387417],
              [30.867464970542493, -0.653340852467479],
              [30.867424706254827, -0.654526281934746],
              [30.866887208287732, -0.654661195593487],
              [30.86710192720019, -0.655664934416623],
              [30.865548286424723, -0.656678481098886],
              [30.866487979009154, -0.657301733487771],
              [30.86579459459418, -0.657428679539634],
              [30.86532540452128, -0.658014042496856],
              [30.865547295582992, -0.659018561230941],
              [30.86516962227796, -0.658701458037967],
              [30.865018148354757, -0.658946432182882],
              [30.86554709436035, -0.65949397210606],
              [30.865389382535827, -0.660180609553532],
              [30.86596639559564, -0.660592906186321],
              [30.86645448532381, -0.660434620975301],
              [30.866585342911225, -0.661200618265893],
              [30.86714142881819, -0.661512516807625],
              [30.866532237206584, -0.662684935801349],
              [30.86740808023555, -0.663773479957462],
              [30.866611771346896, -0.665167474512458],
              [30.866961197127804, -0.665780579151209],
              [30.866509415506787, -0.666968913302518],
              [30.86520294438513, -0.666693662989348],
              [30.864510687355814, -0.665779515617718],
              [30.863753200958794, -0.667275509982949],
              [30.862761395308116, -0.666721464863389],
              [30.863748598889597, -0.667275507288174],
              [30.864019067248588, -0.66884202312664],
              [30.86530951152726, -0.670326535079313],
              [30.865238361363524, -0.6710869796255],
              [30.865813620013572, -0.671912061478534],
              [30.867294714643343, -0.672509082945824],
              [30.868740015900592, -0.674037650406221],
              [30.87039886197223, -0.674931234327758],
              [30.873018742802795, -0.6758658206302],
              [30.874088216792952, -0.675310454255679],
              [30.875627079383666, -0.676174362368],
              [30.876527342215326, -0.67865711071605],
              [30.877723116639487, -0.679449806600611],
              [30.87950230282323, -0.682595727030787],
              [30.88090826775251, -0.683776456970216],
              [30.881541566553064, -0.685994512918373],
              [30.882260411019836, -0.68689820713186],
              [30.883960945208873, -0.687529353083865],
              [30.888622748782545, -0.691358850795194],
              [30.89276898585847, -0.693992967858687],
              [30.89982141571066, -0.696916426479638],
              [30.908034500350954, -0.701621549414914],
              [30.915798089582648, -0.704852771567548],
              [30.92536247936211, -0.707533298859112],
              [30.94071743461587, -0.710460550390138],
              [30.951132547834025, -0.713202324910867],
              [30.956014908471193, -0.714264810211188],
              [30.966694105721633, -0.715128514480554],
              [30.973781606700832, -0.713151539895778],
              [30.976377180916476, -0.712257562572774],
              [30.98052728434137, -0.709818136323354],
              [30.990268884776945, -0.703457016302484],
              [30.999952428892342, -0.699003590714805],
              [31.001239220621084, -0.698060366887811],
              [31.003040160407735, -0.689425442073849],
              [31.00252894984081, -0.689303577358749],
              [31.00631079699981, -0.672224408468463],
              [31.0072555470993, -0.664262995673894],
              [31.008229615514683, -0.661419888708687],
              [31.009772083044652, -0.649730549266609],
              [31.009334583738358, -0.64486482604103],
              [31.009806066311842, -0.643032530406702],
              [31.014015819668245, -0.63213404651088],
              [31.022682290320635, -0.620921230505082],
              [31.024346912559572, -0.617635997751308],
              [31.025009606931174, -0.6077470758068],
              [31.02479234398984, -0.600985713357395],
              [31.024886905148204, -0.599848334387894],
              [31.02582921003349, -0.597731824232559],
              [31.02526971142675, -0.59724625103773],
              [31.025092346260436, -0.594794031507415],
              [31.025390501594803, -0.591684085175144],
              [31.02491753410614, -0.585045151359792],
              [31.026941275846195, -0.574160671106207],
              [31.027952185069704, -0.571469624584402],
              [31.02890430404945, -0.56692448044038],
              [31.028607750411247, -0.56542915853948],
              [31.02997523331037, -0.56237937045604],
              [31.0294412881802, -0.560106453478603],
              [31.029442576364335, -0.556218878527037],
              [31.030869530430206, -0.552929865560836],
              [31.03235662760268, -0.547368125623179],
              [31.0334881760773, -0.538875618008536],
              [31.032599452105455, -0.531159972294264],
              [31.02945244435772, -0.525477124660075],
              [31.028086476916464, -0.523921664445063],
              [31.026304521226706, -0.522724927540092],
              [31.020196470469802, -0.521598522884704],
            ],
          ],
          [
            [
              [30.84449710317462, -0.470782642913089],
              [30.844138301677077, -0.47109205626234],
              [30.84272731696201, -0.470598519645916],
              [30.84217908233064, -0.470950563810025],
              [30.840768149717842, -0.470292659890341],
              [30.838283823765316, -0.471160683433319],
              [30.8373277872326, -0.470291593626006],
              [30.83687292798343, -0.470397116065135],
              [30.835986983399106, -0.469140617338143],
              [30.83323519664714, -0.467519588798582],
              [30.83191734746408, -0.467589624516089],
              [30.831543842341972, -0.468622662496303],
              [30.82984064554644, -0.470312747339969],
              [30.824662807452757, -0.470494315892177],
              [30.822152354000185, -0.471396032279456],
              [30.819462074895746, -0.474012438312115],
              [30.81569595184744, -0.476808991555807],
              [30.81381361391626, -0.475905897006402],
              [30.811752487887336, -0.473378257480825],
              [30.81013904177184, -0.472655750950646],
              [30.80727041204921, -0.472293848197495],
              [30.80476006908941, -0.472924798896186],
              [30.803235629848892, -0.474278049368465],
              [30.799073106316865, -0.480085318827517],
              [30.787310446510666, -0.490197890620339],
              [30.79145911173281, -0.493278941974317],
              [30.79330038767236, -0.493817753050318],
              [30.79122083629864, -0.495312053838352],
              [30.788303040882155, -0.4994110449896],
              [30.785879582078366, -0.501723178067789],
              [30.785611885920318, -0.502188300685459],
              [30.786049775095456, -0.504327838070076],
              [30.78303035955909, -0.50779836804755],
              [30.781753355873686, -0.511007311770653],
              [30.79426634789398, -0.511192441794893],
              [30.806821251712186, -0.512236425773472],
              [30.820905316316026, -0.511301001570066],
              [30.82865996461571, -0.510381472288711],
              [30.838785578665565, -0.509806274163777],
              [30.849407328653584, -0.502730793085804],
              [30.849142154964888, -0.502179209185689],
              [30.8508246330167, -0.500480068650133],
              [30.85295220742719, -0.496135308320736],
              [30.845564993434927, -0.489835350119051],
              [30.843716647754082, -0.484700662340131],
              [30.843318183840125, -0.479818115338182],
              [30.84386943770917, -0.47574121454442],
              [30.844670120494985, -0.473476423820449],
              [30.844254240044304, -0.472857978193124],
              [30.84449710317462, -0.470782642913089],
            ],
          ],
          [
            [
              [30.959950708903623, -0.346634007510887],
              [30.95847079016859, -0.35346276774685],
              [30.95655027473614, -0.353913447531179],
              [30.952524843997946, -0.352977325595553],
              [30.947113228334718, -0.352976133553793],
              [30.940117605246147, -0.353638972528408],
              [30.922035215669474, -0.353103443074007],
              [30.915303146607197, -0.356158055380221],
              [30.910023285050027, -0.357751351905493],
              [30.90038805592389, -0.358546393908167],
              [30.8959010582163, -0.356153649228886],
              [30.891413714657325, -0.355355387519287],
              [30.889302362024214, -0.353494690569583],
              [30.886926475302914, -0.354158511347015],
              [30.881249632950365, -0.360667936565311],
              [30.87874240804292, -0.358541406559369],
              [30.875444507581975, -0.350966976143809],
              [30.873466510751115, -0.342994257098706],
              [30.86766043855842, -0.337412399495038],
              [30.861985361395398, -0.336481062974687],
              [30.854066344754937, -0.336745065195678],
              [30.848920218987416, -0.331296302466834],
              [30.849184889619572, -0.327974633658718],
              [30.851825226885815, -0.324653467695051],
              [30.85261756162767, -0.322527725614458],
              [30.852223063775696, -0.315485568458792],
              [30.851431657891844, -0.313093759151246],
              [30.838495804612787, -0.321328928417975],
              [30.82569180605116, -0.330361169149869],
              [30.817904183292356, -0.334212586243475],
              [30.810380747872095, -0.337133956225633],
              [30.807080876507417, -0.338993329597743],
              [30.803253334744824, -0.339789652363332],
              [30.794938542848048, -0.340717809484269],
              [30.786755347852214, -0.343506067538762],
              [30.7834554225886, -0.345763978091194],
              [30.788335057737214, -0.360645842040331],
              [30.7921610121767, -0.366359921341042],
              [30.798362462570324, -0.372473215154638],
              [30.805224212427053, -0.376992341468899],
              [30.819344264439476, -0.38390494167658],
              [30.82105966933973, -0.38523404465862],
              [30.823303265660744, -0.385500351387386],
              [30.828713188897968, -0.39055068716485],
              [30.82910811075477, -0.39453680749678],
              [30.832538069850695, -0.400516741220166],
              [30.836892312728963, -0.404902535088646],
              [30.846127704417082, -0.417527526363746],
              [30.845066469774736, -0.436926058831374],
              [30.84587999577412, -0.440030097294796],
              [30.85109037354237, -0.440572989784239],
              [30.858034895067686, -0.440125075164738],
              [30.868382740640723, -0.44030108856118],
              [30.871580042366283, -0.439955911216245],
              [30.880689983426677, -0.441412102795426],
              [30.88161835634018, -0.440893226115234],
              [30.881516371504304, -0.43677467015696],
              [30.882032630603153, -0.434698247476395],
              [30.88409629347441, -0.431307093628556],
              [30.88664109401187, -0.428504425244797],
              [30.89172952997186, -0.427190660499911],
              [30.894102315708814, -0.424837849163196],
              [30.895581449316285, -0.421723371758984],
              [30.896132890034924, -0.416532053209883],
              [30.89709578520481, -0.415459404998591],
              [30.901118345825683, -0.414664448272666],
              [30.905106120983813, -0.415461534848149],
              [30.91143182724585, -0.415774701774581],
              [30.91297898937148, -0.415429009503345],
              [30.916039144404312, -0.413941577590825],
              [30.92370793981396, -0.413471665844346],
              [30.926559631801926, -0.412726044012971],
              [30.92695864997639, -0.413472516526746],
              [30.9264425588625, -0.424266000047493],
              [30.927696505489507, -0.426964743177112],
              [30.928378818168618, -0.434600846851174],
              [30.927806047851895, -0.443614516639258],
              [30.928316088812338, -0.455154657313221],
              [30.930024053865395, -0.465432072978444],
              [30.930820267532653, -0.473010824924888],
              [30.931845732158703, -0.4766855664103],
              [30.931729974352898, -0.482369422263145],
              [30.932527332473782, -0.485929276417684],
              [30.93547176383676, -0.491127532899902],
              [30.942461237058872, -0.491368581556268],
              [30.95275805203559, -0.493116764344857],
              [30.96230382962069, -0.494069064479946],
              [30.973246747085724, -0.493475668422593],
              [30.977355594482887, -0.494046545451304],
              [30.97906978126761, -0.49362210904189],
              [30.98379393600686, -0.489292571007813],
              [30.991141634008077, -0.490343620770213],
              [30.992756159000248, -0.48969572288926],
              [30.99244578927295, -0.487910962033316],
              [30.992880454394538, -0.48462586589576],
              [30.991667304756145, -0.47895117800965],
              [30.990942682325475, -0.46988209870857],
              [30.99105326224201, -0.456889148576591],
              [30.987916989361924, -0.422249419006417],
              [30.987739308886926, -0.41004304035337],
              [30.984431046359155, -0.382992457039139],
              [30.969508237350958, -0.383060703221227],
              [30.970114873255586, -0.380154239839784],
              [30.971041989426016, -0.378611444110582],
              [30.969616512190473, -0.376676446748519],
              [30.96886605780547, -0.374365391671722],
              [30.967874415648165, -0.373395164448415],
              [30.96746375261269, -0.372282424204377],
              [30.967691327315176, -0.368473808674615],
              [30.96694120710349, -0.364622175662128],
              [30.966723556988242, -0.360715284927392],
              [30.96698442774674, -0.359515993033097],
              [30.96501230140628, -0.354755633445847],
              [30.961546860653264, -0.350274880295611],
              [30.959950708903623, -0.346634007510887],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 193,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "SANGA",
        Population: 7029,
        Key: "KIRUHURASANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.727844566281114, -1.123824132460184],
            [29.725971391165835, -1.123710180629914],
            [29.725825538899695, -1.124844906245848],
            [29.72517308622064, -1.125693970214418],
            [29.725195408457108, -1.127084773169572],
            [29.723977326169525, -1.12827233511433],
            [29.72308009694856, -1.130298337787404],
            [29.721700261315984, -1.129725672576535],
            [29.720739204099157, -1.13017625624238],
            [29.718966466022515, -1.129119653894215],
            [29.716176534108637, -1.128456664202408],
            [29.715334465937744, -1.127460234007159],
            [29.713784895428827, -1.127000459238489],
            [29.71397933936533, -1.127710706762731],
            [29.712876392351056, -1.128359426958944],
            [29.711584811703553, -1.126935634078068],
            [29.710144346077477, -1.127356081041672],
            [29.708582524344713, -1.126456370450408],
            [29.707454048108403, -1.126480606803452],
            [29.706887343216444, -1.127074538847326],
            [29.70595958744552, -1.126333237020203],
            [29.70378677926725, -1.126495557269638],
            [29.700724265258508, -1.130230646734121],
            [29.700435527861547, -1.131790537653383],
            [29.69890161319141, -1.134282427887875],
            [29.699856583423873, -1.138557255931252],
            [29.699421965913, -1.140674947626572],
            [29.70004775479781, -1.140548930882073],
            [29.700203789467714, -1.141003587709395],
            [29.70142095547373, -1.141348646598242],
            [29.70298167587195, -1.143159404396517],
            [29.704988311892343, -1.143598190741555],
            [29.705864671452602, -1.144486915386035],
            [29.709222536255403, -1.145589099681853],
            [29.710070225185063, -1.147908137287944],
            [29.71181342665514, -1.149265487495666],
            [29.711921704189617, -1.150333032505489],
            [29.713022954286306, -1.151404245094763],
            [29.71678837125876, -1.157480390181812],
            [29.72273649584397, -1.162418016439461],
            [29.72354359349919, -1.163669801594796],
            [29.7263689028656, -1.165303654998974],
            [29.72710917484684, -1.166350839668258],
            [29.72786850818009, -1.168215496197693],
            [29.727245740329582, -1.171346540382038],
            [29.725529292485298, -1.171635366516306],
            [29.724736775385438, -1.172245476117321],
            [29.722029307916333, -1.172076517714589],
            [29.720657765530426, -1.17351322469295],
            [29.72000908038566, -1.177416100536522],
            [29.71881817752532, -1.181453236013247],
            [29.719375710618177, -1.185621709822847],
            [29.720250492736795, -1.187417109131587],
            [29.723103941829486, -1.18944797234571],
            [29.728933725952395, -1.195612032562559],
            [29.731588475789067, -1.201490342782775],
            [29.733173141679487, -1.204030319269596],
            [29.735948612513926, -1.206548225778917],
            [29.739886378460177, -1.213391676024355],
            [29.741986358421762, -1.214569260191406],
            [29.74361828018772, -1.216639297751748],
            [29.748026183929476, -1.22085131041835],
            [29.750633958164993, -1.226917726989018],
            [29.75063055534669, -1.229737834605224],
            [29.751349128522243, -1.234086393715843],
            [29.750598767562064, -1.236717579842431],
            [29.751406815634844, -1.239681285868482],
            [29.751751779483737, -1.238835515085274],
            [29.754045968023213, -1.237761359361219],
            [29.75576784528509, -1.235955691242425],
            [29.756685053936263, -1.235918357861963],
            [29.757489020064398, -1.234726971092018],
            [29.761807131803643, -1.23488611918713],
            [29.76708266797269, -1.233392474907845],
            [29.772703079057408, -1.231129947141817],
            [29.77992701706027, -1.230177090398346],
            [29.783650692016433, -1.229059581271684],
            [29.782392838616254, -1.228462791625044],
            [29.782183123319932, -1.22505201017999],
            [29.78132863504187, -1.224741602704295],
            [29.781092257747932, -1.223811312300118],
            [29.779714536749484, -1.224168529390317],
            [29.779263651647142, -1.223929842210148],
            [29.77873080425826, -1.222701299740103],
            [29.77809017340833, -1.222247883103855],
            [29.778091205572597, -1.221365398294374],
            [29.776859280246473, -1.218908258356737],
            [29.77700375270037, -1.217191031719258],
            [29.776232726895365, -1.216582540616694],
            [29.77343177265296, -1.215627402888137],
            [29.77172135340253, -1.216223004489674],
            [29.769562047801266, -1.214862654083015],
            [29.768351028068427, -1.214838334071284],
            [29.768471599047547, -1.21326421211171],
            [29.767701306267842, -1.21201175967102],
            [29.76625339181143, -1.21151033073264],
            [29.765329393693328, -1.209721165768148],
            [29.764072091858733, -1.208671247500638],
            [29.76407368008017, -1.207287909618258],
            [29.76217378547505, -1.20750182643986],
            [29.760052291760744, -1.204269254290671],
            [29.759745065238626, -1.203005039551913],
            [29.758701605560784, -1.201835976203218],
            [29.75839410415418, -1.200810280730874],
            [29.757302272893263, -1.200404405009231],
            [29.75603464492447, -1.198006930583998],
            [29.755133380471275, -1.19710026770611],
            [29.75302015305419, -1.196980228681044],
            [29.752522078551653, -1.196479184066831],
            [29.752523011901236, -1.195668265633066],
            [29.75178788008006, -1.1948332279483],
            [29.752166395106467, -1.192946657166309],
            [29.753119101584417, -1.193545812199085],
            [29.754330411473113, -1.193307761789002],
            [29.75613700615446, -1.191638907074682],
            [29.756777904702354, -1.19182995626627],
            [29.758390483045282, -1.193667053957405],
            [29.759388010066008, -1.193500458017536],
            [29.760266185121466, -1.193858539494641],
            [29.7616912733865, -1.193549034655027],
            [29.76334297605501, -1.192369051512809],
            [29.764743949944556, -1.192393424714043],
            [29.76567064211019, -1.191869048776234],
            [29.767168991579933, -1.189794586234915],
            [29.770495231193156, -1.188221652429964],
            [29.77242966063102, -1.188973684104911],
            [29.774424579925203, -1.188735896449591],
            [29.780194362875353, -1.189191166104024],
            [29.784999844792186, -1.191923878160299],
            [29.787255396791306, -1.192234763594414],
            [29.788299522120763, -1.192855281479074],
            [29.790318038360837, -1.192784454788938],
            [29.79205222164378, -1.19218880944656],
            [29.79287874716366, -1.191336849205652],
            [29.786814655465154, -1.183051892336843],
            [29.782414349674053, -1.178983713690343],
            [29.779963371879802, -1.17300816120598],
            [29.778753581042295, -1.171886741606914],
            [29.777210464030393, -1.171552292418265],
            [29.775027528245584, -1.170072779655275],
            [29.771576883643593, -1.166171959277294],
            [29.769582668628605, -1.165789657077095],
            [29.768847330194923, -1.165097731860496],
            [29.765072405453484, -1.164547865454339],
            [29.76355375585496, -1.16359330426768],
            [29.76015035185717, -1.159954926830538],
            [29.756093604051525, -1.156638323065107],
            [29.754161909983694, -1.153477485862079],
            [29.751242122103925, -1.152689420530606],
            [29.750555786768977, -1.150638066718986],
            [29.751567816191642, -1.148074497033195],
            [29.75107130116443, -1.146142439255028],
            [29.75155921302617, -1.145128966748014],
            [29.74944714353748, -1.144007303496934],
            [29.749209824809082, -1.14281546480328],
            [29.747328881063233, -1.139334569054281],
            [29.745000843105526, -1.137498240650096],
            [29.744579664391292, -1.135702936262367],
            [29.74334043666023, -1.135221590400222],
            [29.743800687597744, -1.133134338943552],
            [29.74305834140651, -1.132563978919166],
            [29.7424555565795, -1.13101779134189],
            [29.742662248146594, -1.13017842974248],
            [29.740735263047476, -1.126901767855238],
            [29.74026114122368, -1.126945437292833],
            [29.73937676509782, -1.127941273094802],
            [29.73733708904125, -1.12728671219173],
            [29.736213620912626, -1.126124601386856],
            [29.735760060627356, -1.12664519754668],
            [29.733388496599183, -1.127090645218577],
            [29.732467845603836, -1.125997404749063],
            [29.73097904432727, -1.125833032217706],
            [29.72872652773551, -1.124825774919352],
            [29.728048703039565, -1.125004945297133],
            [29.727844566281114, -1.123824132460184],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 194,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "BUKIMBIRI",
        Population: 15377,
        Key: "KISOROBUKIMBIRI",
        Dist2: "Kisoro",
        "Sub Country": "Bukimbiri",
        id2_original: "Kisoro Bukimbiri",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.628312904565437, -1.150489167749904],
            [29.626935802506228, -1.150529463438198],
            [29.62583273242279, -1.149912392201624],
            [29.625018618925175, -1.15031801570095],
            [29.623310578413626, -1.148699758757685],
            [29.622122128852325, -1.149569411729043],
            [29.620725714811147, -1.148951235579345],
            [29.620475447766253, -1.14942708255826],
            [29.619214042427448, -1.148900227816327],
            [29.61871662369505, -1.149125394664921],
            [29.618479816108067, -1.151712660667447],
            [29.61782493438446, -1.151823726585999],
            [29.617732610929465, -1.152300149687537],
            [29.61737196429235, -1.152207995787902],
            [29.616918402210455, -1.152728479457996],
            [29.61615324420089, -1.152248868951801],
            [29.61548146606511, -1.151043121596321],
            [29.614106855034212, -1.150606658967845],
            [29.614036897833152, -1.151128552102601],
            [29.615500023462246, -1.15197400950946],
            [29.6145949591354, -1.152538214363599],
            [29.61452189196682, -1.153786593670937],
            [29.613397148230515, -1.152965102594118],
            [29.612966644105317, -1.153372153690929],
            [29.61149922003758, -1.153525609637366],
            [29.609992124570258, -1.155029733622039],
            [29.608741244791606, -1.157295326488231],
            [29.60756853101913, -1.157132037995249],
            [29.606691339618926, -1.156470401069761],
            [29.606099259116828, -1.157716840480898],
            [29.60569641591589, -1.156943438332658],
            [29.604387243560158, -1.157029368921311],
            [29.604787537342336, -1.158393016969616],
            [29.603270384337076, -1.159613301951705],
            [29.601941802083022, -1.158972667512744],
            [29.60248541757718, -1.158497955572853],
            [29.601901465930123, -1.157860106886672],
            [29.600322122557735, -1.157808809186741],
            [29.599180678241993, -1.158247241210679],
            [29.598824341721624, -1.15715620134098],
            [29.59736281958528, -1.155947519172757],
            [29.596208633565503, -1.154115671434558],
            [29.594700220269672, -1.153315468906439],
            [29.593848930892342, -1.151882036124138],
            [29.591929560811888, -1.152192725719543],
            [29.59172117412387, -1.153417865980173],
            [29.590524355857344, -1.153617724874672],
            [29.589144376494296, -1.1544298617084],
            [29.589636008279616, -1.15554409061343],
            [29.58934109496511, -1.155906225735988],
            [29.58875480590167, -1.155813242078724],
            [29.58826140982512, -1.155107622388136],
            [29.586519717524734, -1.156077317274029],
            [29.586257815500264, -1.156632539991553],
            [29.585259356926585, -1.155533348947582],
            [29.582076236006102, -1.160873544252066],
            [29.579629624024154, -1.163089190117302],
            [29.57853904052314, -1.164810462411001],
            [29.578556795724733, -1.168522294204993],
            [29.576741478401974, -1.170853782650328],
            [29.57865158236027, -1.172677098090564],
            [29.579979707371866, -1.176007933520967],
            [29.580042373846087, -1.17716596086607],
            [29.57878789631473, -1.180248711841299],
            [29.577303427612794, -1.181730105271569],
            [29.57734440606109, -1.182683744184139],
            [29.57672953260531, -1.183975437371383],
            [29.57535061415263, -1.184537784767151],
            [29.573411252963833, -1.18425806245096],
            [29.572662865602318, -1.185117904109238],
            [29.572161691912026, -1.186205706133847],
            [29.573123247693847, -1.18820708578731],
            [29.572831830622405, -1.190351306614511],
            [29.576410688171624, -1.192407984149628],
            [29.580484922582595, -1.197292941215557],
            [29.58259907436609, -1.198890071434964],
            [29.584201021147642, -1.204094910043134],
            [29.58643178144156, -1.204829820160774],
            [29.590211883173975, -1.207318657512954],
            [29.593111651199333, -1.209872300566905],
            [29.593509080254062, -1.211871602643293],
            [29.597065260732258, -1.213973701334652],
            [29.59884573240514, -1.214479887123693],
            [29.600464280053146, -1.215893573063222],
            [29.60179413791491, -1.216239164235143],
            [29.60333446386123, -1.217482286920097],
            [29.60488968387499, -1.217896831363025],
            [29.6057140210988, -1.219518842432767],
            [29.606939077906294, -1.218835407999962],
            [29.607532249861425, -1.217361991934716],
            [29.608869082243086, -1.216118405768065],
            [29.608787082227302, -1.214233767194766],
            [29.609422890920776, -1.21332807698961],
            [29.60868269619465, -1.212303654887436],
            [29.60915805949017, -1.211964913130355],
            [29.61219925018901, -1.21315696922815],
            [29.6123302919311, -1.214156368664541],
            [29.61332686224605, -1.215896907756852],
            [29.614048574135193, -1.21599044622568],
            [29.614518675998113, -1.216854948090281],
            [29.61649890424413, -1.218133798295752],
            [29.619658821680787, -1.217986844671663],
            [29.62083631179566, -1.217060482070948],
            [29.621716189158555, -1.217109219050315],
            [29.622801628906256, -1.216591157110769],
            [29.62363140902242, -1.2177748596203],
            [29.625691582837128, -1.218838341233871],
            [29.627699168376783, -1.21902756534992],
            [29.627876022401715, -1.219868245623952],
            [29.629048573579148, -1.220077014372795],
            [29.629110510621356, -1.221394032773312],
            [29.630100446877943, -1.222078880182566],
            [29.63050316341642, -1.222875012314653],
            [29.63036339184644, -1.223873422918449],
            [29.631036300062835, -1.224806801003397],
            [29.630689145222966, -1.226780666520463],
            [29.631367621197505, -1.22901950137839],
            [29.634121402209395, -1.228871023362014],
            [29.633981736640603, -1.229846732938831],
            [29.63506552258985, -1.229714615809099],
            [29.636596537498253, -1.230515042219228],
            [29.637063968669832, -1.231992527564097],
            [29.6395227186879, -1.232228891518116],
            [29.64042506201774, -1.23487726654989],
            [29.641926477437543, -1.237289527827593],
            [29.64302017629596, -1.240040796387114],
            [29.65316616593308, -1.241459472147685],
            [29.655186462634028, -1.243107842607862],
            [29.65745778994784, -1.247816863679309],
            [29.658573670905586, -1.247954129624433],
            [29.65998513262608, -1.244412022908139],
            [29.66289161915143, -1.23318494658586],
            [29.658139248329118, -1.227372726201639],
            [29.655562794754335, -1.223071953611131],
            [29.648127493944905, -1.212611577816772],
            [29.647179056261166, -1.21016736456314],
            [29.6460336899009, -1.208891648606067],
            [29.646178298000386, -1.206780771381594],
            [29.64559553033287, -1.205870434528423],
            [29.644536371697118, -1.205525892830801],
            [29.644338730656514, -1.204276459882253],
            [29.64271811329009, -1.200717271628954],
            [29.64178613274238, -1.1970812185974],
            [29.641838089501768, -1.192915334312868],
            [29.641424103598034, -1.189508250682309],
            [29.64389663736583, -1.186566076974546],
            [29.64237986434794, -1.185073309601379],
            [29.642360138242644, -1.184414846950983],
            [29.641185711382903, -1.184637487230575],
            [29.64066365365889, -1.185339323783112],
            [29.63996438797375, -1.185268608267373],
            [29.639583026186173, -1.18474499797394],
            [29.639510339004964, -1.178081290008378],
            [29.639043433347855, -1.176467606978307],
            [29.639768011761067, -1.17590272164265],
            [29.639860729576487, -1.175335489388653],
            [29.63837558084985, -1.174353696181861],
            [29.6377060727568, -1.17262573868971],
            [29.638115642542605, -1.169233115197302],
            [29.637621157707933, -1.168777212691134],
            [29.637830520864696, -1.16732497643493],
            [29.639030036772002, -1.166512123004235],
            [29.638944675260447, -1.165376639695299],
            [29.638160261862765, -1.164125019655356],
            [29.639114903311825, -1.159917096646099],
            [29.63817613419552, -1.157824898321173],
            [29.63671326638289, -1.156911328311765],
            [29.636247610282336, -1.155002535467613],
            [29.63563403579046, -1.155999187835031],
            [29.63398839405516, -1.155607112576955],
            [29.633183345457123, -1.156523609121251],
            [29.630656088118844, -1.156491508076915],
            [29.630410308158783, -1.15592302530401],
            [29.631269165842358, -1.155608367268156],
            [29.631566819018477, -1.154610530126378],
            [29.630781235116014, -1.153631380091862],
            [29.63107878049431, -1.152656247071583],
            [29.629702091660132, -1.152696542729241],
            [29.628312904565437, -1.150489167749904],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 195,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "BUSANZA",
        Population: 17864,
        Key: "KISOROBUSANZA",
        Dist2: "Kisoro",
        "Sub Country": "Busanza",
        id2_original: "Kisoro Busanza",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.7549901602689, -1.302432057282781],
            [29.74887147795058, -1.303478296153239],
            [29.74886644918163, -1.303938680310877],
            [29.74712343366282, -1.304441258095901],
            [29.74605708131828, -1.304127298318925],
            [29.74413985910965, -1.302759919597258],
            [29.742294460801283, -1.301153994756524],
            [29.739557860069183, -1.295915875092919],
            [29.737151352474783, -1.287061600415968],
            [29.730929591172554, -1.285763465935841],
            [29.725923899931715, -1.283859706724088],
            [29.720307440535926, -1.282384524695743],
            [29.718507811391277, -1.281399603255119],
            [29.710697707394175, -1.28156751745948],
            [29.710777716743262, -1.283107716289704],
            [29.710225654390456, -1.285821745631311],
            [29.703654424188198, -1.29271736395971],
            [29.70299364322815, -1.294882381419845],
            [29.704316623588102, -1.298845108634468],
            [29.70542908465956, -1.299612875548481],
            [29.708367482937067, -1.300434529060527],
            [29.708270928417043, -1.305316793168367],
            [29.709162409318512, -1.308805649586994],
            [29.7084948191286, -1.310092699804806],
            [29.70911344754225, -1.313616465099233],
            [29.70872430185275, -1.317101023424202],
            [29.712132169579217, -1.323905199275079],
            [29.712365062308184, -1.3254340420954],
            [29.711949745101187, -1.329778043784041],
            [29.70862397261192, -1.336010280595706],
            [29.708117145823564, -1.339136294298456],
            [29.70892623145053, -1.342374224936493],
            [29.709823318737648, -1.343833692188064],
            [29.71082943095753, -1.344469819863365],
            [29.722506693319556, -1.340943503113256],
            [29.727750752521068, -1.340205753463423],
            [29.735624598275784, -1.34016082214567],
            [29.744147911607865, -1.341108941836892],
            [29.748757835677267, -1.342190792591729],
            [29.748758885807845, -1.342488329058578],
            [29.750020628014862, -1.342842817406683],
            [29.751229771167065, -1.328918006382291],
            [29.752849477641796, -1.320433511833379],
            [29.752915566697258, -1.316170103494837],
            [29.752554302019206, -1.314830049102681],
            [29.75195110666212, -1.313449111627534],
            [29.750259575388863, -1.311579622446079],
            [29.751069158682483, -1.309307479195133],
            [29.753008101256334, -1.306955607591381],
            [29.75421898893683, -1.30622649995045],
            [29.7549901602689, -1.302432057282781],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 196,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "CHAHI",
        Population: 18809,
        Key: "KISOROCHAHI",
        Dist2: "Kisoro",
        "Sub Country": "Kanaba",
        id2_original: "Kisoro Kanaba",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.810761836511368, -1.281347399042173],
            [29.805907500616115, -1.273564613570942],
            [29.80448243391065, -1.270001924990345],
            [29.79610382210282, -1.256806590510007],
            [29.79577831127141, -1.255397036946025],
            [29.795420914738994, -1.255019211780564],
            [29.793710879967524, -1.254718538731046],
            [29.79206797090733, -1.25327928476016],
            [29.791745727248625, -1.251244536957667],
            [29.790962434050098, -1.250957995096991],
            [29.78948013657618, -1.249395109974463],
            [29.78931633597067, -1.247343838567462],
            [29.788700892084666, -1.245697839950175],
            [29.787609052738905, -1.245268060817776],
            [29.785794797224785, -1.243275740424869],
            [29.78525104428837, -1.24124816343685],
            [29.785824174829532, -1.238553219914585],
            [29.786204568233206, -1.238171752310003],
            [29.78580159657318, -1.237551470260516],
            [29.78648081725105, -1.235512461383605],
            [29.785604936492845, -1.233174691997569],
            [29.785559223922977, -1.231672047718335],
            [29.783969292108374, -1.230741203796881],
            [29.783650692016433, -1.229059581271684],
            [29.77992701706027, -1.230177090398346],
            [29.772703079057408, -1.231129947141817],
            [29.76708266797269, -1.233392474907845],
            [29.761807131803643, -1.23488611918713],
            [29.757489020064398, -1.234726971092018],
            [29.756685053936263, -1.235918357861963],
            [29.75576784528509, -1.235955691242425],
            [29.754045968023213, -1.237761359361219],
            [29.751751779483737, -1.238835515085274],
            [29.751406815634844, -1.239681285868482],
            [29.749585092425786, -1.243252855841777],
            [29.749694792891635, -1.244243153415478],
            [29.75112709462842, -1.244528599423334],
            [29.752229693096346, -1.245570084798397],
            [29.752252614509157, -1.246019248533919],
            [29.75135850334055, -1.247365565461037],
            [29.75135780804453, -1.247932907469177],
            [29.752202808316515, -1.248335817646776],
            [29.750484118277278, -1.251737702178297],
            [29.749863167718598, -1.254401397187284],
            [29.749893429265583, -1.256025156995216],
            [29.751213858410146, -1.258007735013381],
            [29.753985850967794, -1.260251945444223],
            [29.755080254105366, -1.262364161488452],
            [29.752849726475127, -1.265787412308838],
            [29.7502342464911, -1.267407821404864],
            [29.750779469969665, -1.270038941755765],
            [29.75438432925477, -1.277106697687284],
            [29.755222443940138, -1.277724776297317],
            [29.7570287331943, -1.27818171105693],
            [29.759603635378596, -1.278058333901989],
            [29.759375179428826, -1.27911802094301],
            [29.76005543945751, -1.28005414188833],
            [29.759847307891, -1.281363260221125],
            [29.7603424422076, -1.281737996599341],
            [29.761912417049892, -1.28126195739025],
            [29.762100714713213, -1.279308515110096],
            [29.76263795666047, -1.279039017634511],
            [29.76391486153119, -1.281742537344969],
            [29.764368923076375, -1.281930177185558],
            [29.763670368856936, -1.279102677948901],
            [29.762804334532547, -1.278103958761478],
            [29.763136229690698, -1.27689892047045],
            [29.764392714956703, -1.279415350260767],
            [29.765821771978636, -1.284564584957468],
            [29.764648568624345, -1.287404646007062],
            [29.764808211826722, -1.288744428485428],
            [29.763555761792983, -1.290447756085324],
            [29.764076779267885, -1.293066698986286],
            [29.76269916067741, -1.298057927589094],
            [29.763619651772647, -1.303661010199703],
            [29.762329643176862, -1.303172216035861],
            [29.757691671907676, -1.303003852422136],
            [29.7549901602689, -1.302432057282781],
            [29.75421898893683, -1.30622649995045],
            [29.753008101256334, -1.306955607591381],
            [29.751069158682483, -1.309307479195133],
            [29.750259575388863, -1.311579622446079],
            [29.75195110666212, -1.313449111627534],
            [29.752554302019206, -1.314830049102681],
            [29.752915566697258, -1.316170103494837],
            [29.752849477641796, -1.320433511833379],
            [29.756862760462408, -1.317653402367352],
            [29.76157850517396, -1.315522304281018],
            [29.763540778792358, -1.313332097286034],
            [29.76444832246939, -1.311561467760227],
            [29.766822057725612, -1.31162221388634],
            [29.76915150514, -1.312584257560633],
            [29.77291352019252, -1.312579632450847],
            [29.774203095800306, -1.31480307440886],
            [29.77610256101071, -1.314984456677334],
            [29.778873787305397, -1.31333606500036],
            [29.782881205923857, -1.308895875285342],
            [29.78590272800955, -1.30421096818257],
            [29.78682629673294, -1.303614063820984],
            [29.790394953912077, -1.302614238841856],
            [29.79098629150741, -1.302042506479887],
            [29.79243981953605, -1.296961306590158],
            [29.793585875802492, -1.295521548164035],
            [29.80618323130607, -1.297066728312788],
            [29.816217259417744, -1.295130139952605],
            [29.813832050878727, -1.290007450712412],
            [29.812593268712057, -1.285424173238949],
            [29.810761836511368, -1.281347399042173],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 197,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "KANABA",
        Population: 16112,
        Key: "KISOROKANABA",
        Dist2: "Kisoro",
        "Sub Country": "Kirundo",
        id2_original: "Kisoro Kirundo",
        drought: "N",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.687770557064876, -1.165740750341512],
            [29.688953913178533, -1.164588811188773],
            [29.691641560219203, -1.163045769114211],
            [29.692785348239546, -1.161560593654961],
            [29.692648618365098, -1.159761879809847],
            [29.693589334130618, -1.157213362058833],
            [29.693613780882767, -1.155724026084424],
            [29.693993531092723, -1.155580112915338],
            [29.693635495858132, -1.154870412949526],
            [29.693929175785758, -1.153745337924335],
            [29.692286008909093, -1.151695846704444],
            [29.691645873929204, -1.149404876182058],
            [29.692480242639803, -1.148499768390841],
            [29.692393142888168, -1.14775473223298],
            [29.693047669777226, -1.146685486089808],
            [29.694253785606943, -1.14539123139248],
            [29.694590626889013, -1.14261341729272],
            [29.69518114252586, -1.141734655999569],
            [29.696355492130483, -1.14153916660938],
            [29.69696706158268, -1.142068172844305],
            [29.698832475253905, -1.140694588990395],
            [29.699421965913, -1.140674947626572],
            [29.699856583423873, -1.138557255931252],
            [29.69890161319141, -1.134282427887875],
            [29.700435527861547, -1.131790537653383],
            [29.700724265258508, -1.130230646734121],
            [29.70378677926725, -1.126495557269638],
            [29.70595958744552, -1.126333237020203],
            [29.706887343216444, -1.127074538847326],
            [29.707454048108403, -1.126480606803452],
            [29.708582524344713, -1.126456370450408],
            [29.710144346077477, -1.127356081041672],
            [29.711584811703553, -1.126935634078068],
            [29.712876392351056, -1.128359426958944],
            [29.71397933936533, -1.127710706762731],
            [29.713784895428827, -1.127000459238489],
            [29.715334465937744, -1.127460234007159],
            [29.716176534108637, -1.128456664202408],
            [29.718966466022515, -1.129119653894215],
            [29.720739204099157, -1.13017625624238],
            [29.721700261315984, -1.129725672576535],
            [29.72308009694856, -1.130298337787404],
            [29.723977326169525, -1.12827233511433],
            [29.725195408457108, -1.127084773169572],
            [29.72517308622064, -1.125693970214418],
            [29.725825538899695, -1.124844906245848],
            [29.725971391165835, -1.123710180629914],
            [29.727844566281114, -1.123824132460184],
            [29.728546042720208, -1.121931526480278],
            [29.72824528047487, -1.116353399765578],
            [29.729498147326893, -1.113604939845359],
            [29.731305353760963, -1.113185788729117],
            [29.73318087797072, -1.109957060794688],
            [29.73368407107375, -1.107702539212025],
            [29.733180028164465, -1.106820863695353],
            [29.733579033762542, -1.105857325323022],
            [29.733133311278113, -1.10452176103156],
            [29.73389890946216, -1.103587937161696],
            [29.733846108286397, -1.102736268476951],
            [29.734947121227844, -1.102541600083061],
            [29.734840628645866, -1.10103697115091],
            [29.73685463354655, -1.098404746410235],
            [29.738055020819676, -1.098054320509102],
            [29.738086826570637, -1.097202962800835],
            [29.73890275197017, -1.097716807275532],
            [29.740260626489007, -1.096813495046636],
            [29.74163968238394, -1.09758480161433],
            [29.74237408477311, -1.097360392426013],
            [29.74301801513507, -1.098526409835924],
            [29.743789484707808, -1.096201855260219],
            [29.744608274834786, -1.096034502802671],
            [29.744641510703662, -1.094842587127933],
            [29.746927107755766, -1.094708937723111],
            [29.747267295262287, -1.094312813444296],
            [29.747782004767277, -1.092668502480494],
            [29.74938613355664, -1.091310689550937],
            [29.7496474301166, -1.089508293060922],
            [29.751387496466336, -1.085484570871273],
            [29.7515913709167, -1.083540821122591],
            [29.752471559096726, -1.081966935816053],
            [29.752574378467504, -1.080383916348883],
            [29.751627773346975, -1.078084456647133],
            [29.749448340991744, -1.076965387863895],
            [29.745867606861925, -1.078300114736862],
            [29.74454139616021, -1.078380479058344],
            [29.74451712008795, -1.077443777464903],
            [29.742856197111394, -1.076614721462081],
            [29.74063775810989, -1.074194246577352],
            [29.735233321782435, -1.07136498206025],
            [29.730564282279136, -1.071447523699743],
            [29.727746817001787, -1.070614314781882],
            [29.72624995065061, -1.071034659200457],
            [29.72148251597931, -1.071045871809132],
            [29.720187639413016, -1.070388436003781],
            [29.720194182741544, -1.068827477399814],
            [29.719592992424182, -1.067562330392866],
            [29.71749503816355, -1.065365183934262],
            [29.716503172325734, -1.065010056840308],
            [29.71641793568001, -1.064366071490838],
            [29.714952070189266, -1.064682822968569],
            [29.714445533556738, -1.064024511892633],
            [29.713542380844814, -1.064134793411896],
            [29.713348250420342, -1.063339420222109],
            [29.712790304102455, -1.063055020353938],
            [29.71287251432399, -1.06180794377311],
            [29.712202801415064, -1.060533945199506],
            [29.71310590022806, -1.059921559834158],
            [29.712350088290737, -1.059192151952119],
            [29.71122438605199, -1.05858404247067],
            [29.708618221597472, -1.058550323673935],
            [29.708341173079006, -1.057952208815051],
            [29.705488342027262, -1.056939863146346],
            [29.705086364802256, -1.057785696733352],
            [29.70331493557099, -1.057811589851239],
            [29.703481133780024, -1.058622478413616],
            [29.70317993315683, -1.058987057598669],
            [29.702100431273177, -1.058176173622403],
            [29.701614409466792, -1.058744704780914],
            [29.700943659902016, -1.058228775382622],
            [29.697919678229077, -1.05958019284956],
            [29.696403240282805, -1.059565462998035],
            [29.696246132126138, -1.059999651389822],
            [29.696887279507326, -1.060850424029144],
            [29.69628427369476, -1.061292219665929],
            [29.69335118176565, -1.060414540926027],
            [29.691733304260843, -1.058294988787832],
            [29.6902642398694, -1.058828944284432],
            [29.69038039652719, -1.058034697822092],
            [29.689903483637806, -1.057408611395193],
            [29.68868863798016, -1.05785833110941],
            [29.68704473897653, -1.059725532470724],
            [29.682794653060522, -1.06085963916417],
            [29.68322359052385, -1.059470541677336],
            [29.683031138152316, -1.058277869819111],
            [29.681148955629673, -1.056426362079639],
            [29.680816056155066, -1.055091280824331],
            [29.680112889086637, -1.05460628804796],
            [29.678274644062856, -1.055734887281698],
            [29.677733821430877, -1.056896535789812],
            [29.67292902852188, -1.059149650037757],
            [29.670652952713446, -1.05679502097666],
            [29.66990486089767, -1.056616822840191],
            [29.669935249107084, -1.05596625580432],
            [29.66877289380814, -1.055384458271204],
            [29.668356023414024, -1.056183448608447],
            [29.66695731507562, -1.055582363069149],
            [29.66604832690759, -1.056809090691951],
            [29.664242601795433, -1.056635834246505],
            [29.663424497981342, -1.057235912742027],
            [29.663145882801043, -1.056577548886718],
            [29.661812408321932, -1.056456040964159],
            [29.660856822743494, -1.055629578590864],
            [29.660094166542013, -1.055882250643618],
            [29.65841001492881, -1.05493802996635],
            [29.65728702021235, -1.053554320607083],
            [29.657852847450236, -1.052241557490617],
            [29.65733833108306, -1.051606868181737],
            [29.657340366665487, -1.050846919868883],
            [29.65862192840263, -1.050456403439506],
            [29.659688778413862, -1.049074926726541],
            [29.65848405676947, -1.048457965651248],
            [29.65854956281832, -1.047533018250302],
            [29.656925826501208, -1.047967062816551],
            [29.65702961156093, -1.046644680696625],
            [29.652661717883603, -1.046392557573703],
            [29.651336788179485, -1.047571240566211],
            [29.65064381788784, -1.048955477105171],
            [29.648631755144788, -1.048462927114076],
            [29.646185169213986, -1.046376087913286],
            [29.644550106937803, -1.045793799093598],
            [29.643672879604978, -1.043841892324353],
            [29.64279441349539, -1.043060565767688],
            [29.63889884141801, -1.043265756372783],
            [29.637767267790608, -1.040438040850609],
            [29.63359148781994, -1.037416740642958],
            [29.6332415553892, -1.037521051182487],
            [29.63264421435281, -1.039128749950159],
            [29.630819580602214, -1.039022110515132],
            [29.630007871894662, -1.037707926706987],
            [29.628637757830038, -1.036945118858995],
            [29.626739596973454, -1.034849406206753],
            [29.625662297758847, -1.034353385282476],
            [29.62374296361101, -1.034408433155997],
            [29.62259230976695, -1.031752047257684],
            [29.622147756889053, -1.031932389836434],
            [29.622163383981725, -1.032884640768568],
            [29.62167308349967, -1.033778118824832],
            [29.62128642255024, -1.032854588022963],
            [29.62034022795979, -1.033557809621089],
            [29.618231493915758, -1.033148333390181],
            [29.61863043034355, -1.032166549825078],
            [29.617875506840022, -1.030804862562946],
            [29.616247087605373, -1.030284495210178],
            [29.616553224471048, -1.029528222462281],
            [29.616317674525433, -1.028757124333003],
            [29.614314964142824, -1.027203782112563],
            [29.610004303928868, -1.026675777922071],
            [29.60801981677008, -1.02578862459379],
            [29.60552363664909, -1.026004844062592],
            [29.60481392086222, -1.026613143961922],
            [29.6047463864175, -1.027897801402652],
            [29.60409965780341, -1.028261071921235],
            [29.606134893487525, -1.031375233635362],
            [29.608200724891912, -1.036491083140118],
            [29.61080912974473, -1.039265780675827],
            [29.613212400709184, -1.039614853459745],
            [29.61676244569397, -1.038710644844377],
            [29.618422784765613, -1.040062540483644],
            [29.618509790194153, -1.041974297052874],
            [29.619331643576228, -1.044878525051911],
            [29.620119722998567, -1.046062225766119],
            [29.620835355988184, -1.04840479428955],
            [29.623542951916367, -1.052780689245542],
            [29.624313895076376, -1.053343074359864],
            [29.626972303751185, -1.053800003321111],
            [29.628300102674302, -1.055330785852642],
            [29.629304478450763, -1.054065382736426],
            [29.629957111691205, -1.054269218190014],
            [29.630917082844846, -1.055680125397694],
            [29.6306727204263, -1.05663570221662],
            [29.63093179006269, -1.058559619650377],
            [29.63220683721738, -1.059481019631825],
            [29.633261535717747, -1.061083210366712],
            [29.6346233250946, -1.069591748628074],
            [29.637195550299385, -1.072904199462709],
            [29.638172395407327, -1.075151545708205],
            [29.64066815511678, -1.077842639738899],
            [29.64228758850366, -1.078633021704052],
            [29.643655675070672, -1.081322871406508],
            [29.643512159322547, -1.082290524921294],
            [29.643878952232836, -1.083378219199926],
            [29.646019470468236, -1.08526841481662],
            [29.647387585781356, -1.087922453745535],
            [29.64785450850648, -1.089703277553731],
            [29.649768472525537, -1.092513257812711],
            [29.650067964553045, -1.095405063298411],
            [29.651096602927016, -1.097021626194004],
            [29.64821944819232, -1.099186986645278],
            [29.64619591575973, -1.101695146651506],
            [29.645557221677546, -1.103309291019532],
            [29.643547841303956, -1.104609676283623],
            [29.641229577016535, -1.108497091497861],
            [29.640491077411333, -1.112344879898196],
            [29.638286514686065, -1.114961300180267],
            [29.63711915936424, -1.117772221180542],
            [29.636611909469387, -1.118188100602126],
            [29.635258832852475, -1.117983337185923],
            [29.633884973711456, -1.118414180557292],
            [29.632716856618263, -1.119290778993054],
            [29.632277146558035, -1.120796650641662],
            [29.632707141338482, -1.121561061302062],
            [29.632489838871244, -1.123625189401781],
            [29.633733109919408, -1.125044680900722],
            [29.6334171203317, -1.126377335778061],
            [29.635101778594702, -1.128199805727559],
            [29.634693687435888, -1.13456939593993],
            [29.6341795133268, -1.136071597074524],
            [29.63355969195044, -1.135899028699465],
            [29.633191547973947, -1.136238215270722],
            [29.63332746397476, -1.137430635088311],
            [29.633777201928506, -1.13780122128808],
            [29.633099005330028, -1.138082514554256],
            [29.63295567373655, -1.138621169221695],
            [29.631092660363766, -1.138926466039115],
            [29.6302782019131, -1.138100455760384],
            [29.62869336803772, -1.139314886366849],
            [29.628410843389286, -1.142705112553656],
            [29.628547379227623, -1.143755642123147],
            [29.629137155551, -1.144353788265135],
            [29.62885130354275, -1.145232465229836],
            [29.629299438003716, -1.145971991084153],
            [29.631242805678667, -1.146660284410762],
            [29.631269184706998, -1.147086072406429],
            [29.63101237972346, -1.147766214889587],
            [29.629968349615396, -1.147847473656743],
            [29.628764618812802, -1.148992355776937],
            [29.628312904565437, -1.150489167749904],
            [29.629702091660132, -1.152696542729241],
            [29.63107878049431, -1.152656247071583],
            [29.630781235116014, -1.153631380091862],
            [29.631566819018477, -1.154610530126378],
            [29.631269165842358, -1.155608367268156],
            [29.630410308158783, -1.15592302530401],
            [29.630656088118844, -1.156491508076915],
            [29.633183345457123, -1.156523609121251],
            [29.63398839405516, -1.155607112576955],
            [29.63563403579046, -1.155999187835031],
            [29.636247610282336, -1.155002535467613],
            [29.63671326638289, -1.156911328311765],
            [29.63817613419552, -1.157824898321173],
            [29.639284321082854, -1.158142614249873],
            [29.63943535483158, -1.159370462504252],
            [29.64021283682849, -1.159509502220341],
            [29.64277538088945, -1.158760608775895],
            [29.64430185840735, -1.157335254744115],
            [29.645597507524776, -1.157705099202432],
            [29.648632210590648, -1.157417132051183],
            [29.649854089158634, -1.155684483104735],
            [29.649656689764853, -1.154978331687597],
            [29.650527516601255, -1.153536837200904],
            [29.651579903736387, -1.153307891355757],
            [29.651139212715904, -1.152018302769926],
            [29.6518869775449, -1.151497420198625],
            [29.653275341782823, -1.150823831390338],
            [29.656034950165985, -1.151087968121761],
            [29.65679805462678, -1.150490369453449],
            [29.657834626921346, -1.150752473738258],
            [29.660841586417956, -1.148116468675346],
            [29.663327776374697, -1.14749019013434],
            [29.665723405371008, -1.146065795060063],
            [29.666380302914106, -1.145007669903188],
            [29.667584759555485, -1.145147194415513],
            [29.66891233569642, -1.144304697940844],
            [29.66978088889687, -1.144827486769064],
            [29.671209362912226, -1.149049402595637],
            [29.675141165841612, -1.15103369208725],
            [29.674972455044728, -1.151877546353526],
            [29.67724271875328, -1.15339950723799],
            [29.678566528258255, -1.155825802461844],
            [29.681231603330758, -1.158775463872164],
            [29.681854939814826, -1.160372236275899],
            [29.683955995958136, -1.163167786388307],
            [29.687770557064876, -1.165740750341512],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 198,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "RUBUGURI TOWN COUNCIL",
        Population: 2170,
        Key: "KISORORUBUGURI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.699908464724803, -1.281907781503921],
            [29.700299623538868, -1.282614318149733],
            [29.6986056290851, -1.282492109623543],
            [29.697604876214164, -1.283724117617212],
            [29.698803068004754, -1.287542193649438],
            [29.699950621762756, -1.289758650796226],
            [29.69694066728299, -1.292286646056585],
            [29.69323395790928, -1.289834281454147],
            [29.691419501172536, -1.290412675891131],
            [29.687425311144963, -1.283640077962901],
            [29.684928769002912, -1.284349541902352],
            [29.68405598383917, -1.284085459540013],
            [29.679147574753664, -1.281311884945104],
            [29.67882366921167, -1.279598669554622],
            [29.675474347387233, -1.280800851547304],
            [29.675330084240827, -1.281516618175565],
            [29.675369830200573, -1.284286253527467],
            [29.67855575476303, -1.289883708606575],
            [29.678346940476928, -1.292497322842131],
            [29.67770332272869, -1.293688920197661],
            [29.67757646444088, -1.295138396055283],
            [29.680250545124153, -1.293022179040656],
            [29.6835879193553, -1.29399878689677],
            [29.687931637571705, -1.296707523880767],
            [29.690129895022018, -1.300055179285897],
            [29.69343315752691, -1.300565136502352],
            [29.700680273860716, -1.299310648641809],
            [29.701801869900294, -1.298573152474769],
            [29.702498797270746, -1.29752395327907],
            [29.70299364322815, -1.294882381419845],
            [29.703654424188198, -1.29271736395971],
            [29.710225654390456, -1.285821745631311],
            [29.710777716743262, -1.283107716289704],
            [29.710697707394175, -1.28156751745948],
            [29.70860155066244, -1.282903616340034],
            [29.70625294847124, -1.282227628317352],
            [29.703510116126044, -1.282132054439154],
            [29.699908464724803, -1.281907781503921],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 199,
        District: "KISORO",
        County: "KISORO MUNICIPALITY",
        Subcounty: "SOUTHERN",
        Population: 5601,
        Key: "KISOROSOUTHERN",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.673268100320808, -1.301032596295491],
            [29.672298259377126, -1.298179152862774],
            [29.67075400419977, -1.299200561464521],
            [29.668754109137232, -1.30203492665649],
            [29.66727997285768, -1.303414672372605],
            [29.665180167169265, -1.304428951671609],
            [29.658632309334052, -1.300568233095509],
            [29.654960222828034, -1.299290473177672],
            [29.648886553291973, -1.296106599710728],
            [29.64088127592636, -1.29257003194253],
            [29.63882601859121, -1.289769814026252],
            [29.637588833629074, -1.286984323479197],
            [29.63236329140053, -1.281571164605318],
            [29.627957038762244, -1.275743033325639],
            [29.62182183462924, -1.277691951935466],
            [29.619969406105454, -1.278712272181847],
            [29.608872460806868, -1.287006616734241],
            [29.59496219415934, -1.285773964597424],
            [29.598567446906536, -1.302331159429351],
            [29.60131356079747, -1.303940010371299],
            [29.602074807542305, -1.307272912368587],
            [29.606278518830088, -1.317540804969566],
            [29.58958298162672, -1.388350259225745],
            [29.592052370392704, -1.387236873483944],
            [29.595255147349913, -1.386722855407964],
            [29.608519470510917, -1.387855420185137],
            [29.612006842733262, -1.387342373935781],
            [29.615104320071172, -1.386362429318621],
            [29.619251623447347, -1.38726021116103],
            [29.626355127015017, -1.386843293184044],
            [29.630432987924767, -1.387167858187164],
            [29.637697823527557, -1.38839875850038],
            [29.640976212580544, -1.38638087172111],
            [29.636268642538084, -1.382377533404195],
            [29.63293765443027, -1.377973166178085],
            [29.625871119231494, -1.36140411414157],
            [29.625497921333235, -1.359230325160221],
            [29.625705668420782, -1.35707046947057],
            [29.62756031488503, -1.355334077786559],
            [29.62974514521676, -1.354219543329302],
            [29.631002578205397, -1.354009005597755],
            [29.63213918599167, -1.354302655593822],
            [29.63176852493575, -1.339030769282606],
            [29.634876409256226, -1.338540079066731],
            [29.63622650616136, -1.339093805711357],
            [29.636816842135158, -1.339979167812854],
            [29.64118755023426, -1.341557919823492],
            [29.642231356661817, -1.341418247630899],
            [29.642846703529734, -1.341850091303504],
            [29.649626379708852, -1.34273281029014],
            [29.651961517052253, -1.334611579394532],
            [29.657141426660978, -1.326786482400492],
            [29.663086512245577, -1.325123584757001],
            [29.667812490564827, -1.324259347234511],
            [29.670253284158715, -1.323333466394038],
            [29.673282909048257, -1.321183081593148],
            [29.675661550902557, -1.318612652492243],
            [29.675192685121477, -1.316677195260572],
            [29.676741408519064, -1.314080065212921],
            [29.676756495724284, -1.312922177936927],
            [29.675117187111756, -1.305515383376769],
            [29.673268100320808, -1.301032596295491],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 200,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "MURAMBA",
        Population: 36308,
        Key: "KISOROMURAMBA",
        Dist2: "Kisoro",
        "Sub Country": "Muramba",
        id2_original: "Kisoro Muramba",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.819197082606273, -1.310482445141168],
            [29.819139882380554, -1.30741426320363],
            [29.818251607566364, -1.304596125230772],
            [29.818843216452912, -1.300763611232544],
            [29.816217259417744, -1.295130139952605],
            [29.80618323130607, -1.297066728312788],
            [29.793585875802492, -1.295521548164035],
            [29.79243981953605, -1.296961306590158],
            [29.79098629150741, -1.302042506479887],
            [29.790394953912077, -1.302614238841856],
            [29.78682629673294, -1.303614063820984],
            [29.78590272800955, -1.30421096818257],
            [29.782881205923857, -1.308895875285342],
            [29.778873787305397, -1.31333606500036],
            [29.77610256101071, -1.314984456677334],
            [29.774203095800306, -1.31480307440886],
            [29.77291352019252, -1.312579632450847],
            [29.76915150514, -1.312584257560633],
            [29.766822057725612, -1.31162221388634],
            [29.76444832246939, -1.311561467760227],
            [29.763540778792358, -1.313332097286034],
            [29.76157850517396, -1.315522304281018],
            [29.756862760462408, -1.317653402367352],
            [29.752849477641796, -1.320433511833379],
            [29.751229771167065, -1.328918006382291],
            [29.750020628014862, -1.342842817406683],
            [29.755664332414913, -1.344727197151489],
            [29.759838403789903, -1.347163408030427],
            [29.76183778232114, -1.348767224020897],
            [29.767091730177277, -1.354566065935072],
            [29.771306479064965, -1.361839690196037],
            [29.773334813891076, -1.364937363813224],
            [29.77423917393873, -1.365621144203364],
            [29.782991729246515, -1.36730248820823],
            [29.794889045615488, -1.372266445026972],
            [29.795295938421738, -1.369833985505406],
            [29.793670624663026, -1.366615927005513],
            [29.793315968890525, -1.363617634968949],
            [29.79477067101723, -1.358773661224827],
            [29.793872061085697, -1.356346867414844],
            [29.79513922911705, -1.352191403283692],
            [29.794384107984154, -1.350072269506952],
            [29.794594811427316, -1.349241366210049],
            [29.797728169274325, -1.345919593020537],
            [29.802180394993897, -1.339651479247467],
            [29.803316624589428, -1.338769084251105],
            [29.80381123967981, -1.337676066274889],
            [29.80374189782473, -1.334842518493255],
            [29.80653258701836, -1.331960879253586],
            [29.80697654341493, -1.329966916685552],
            [29.807840003167705, -1.329144996286975],
            [29.813435819278258, -1.327460461131664],
            [29.817708392720807, -1.327465447239585],
            [29.817588097524496, -1.323659780379062],
            [29.81791358499968, -1.321737474014958],
            [29.818916854051714, -1.320179758441193],
            [29.819140143790314, -1.316218434475009],
            [29.81885110994934, -1.31503396326547],
            [29.817472646942495, -1.314542017265852],
            [29.819197082606273, -1.310482445141168],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 201,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "MURORA",
        Population: 19209,
        Key: "KISOROMURORA",
        Dist2: "Kisoro",
        "Sub Country": "Murora",
        id2_original: "Kisoro Murora",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.60409965780341, -1.028261071921235],
            [29.598457441013483, -1.029623069241086],
            [29.597786730974576, -1.029108461662047],
            [29.596946740606903, -1.027746711119503],
            [29.59793210982858, -1.026752953270318],
            [29.598462736582068, -1.024607904527341],
            [29.59591647807892, -1.018524190573416],
            [29.593697509071433, -1.015876272955202],
            [29.593102113785946, -1.015666282541226],
            [29.59274444596231, -1.014143279719209],
            [29.591771540865196, -1.013304808501599],
            [29.59138510090136, -1.01217195030631],
            [29.590043226276023, -1.011580517207795],
            [29.589126145185606, -1.011608098374177],
            [29.5871618090353, -1.009569525487398],
            [29.584449781717804, -1.008320027035913],
            [29.583820867594124, -1.007272697754377],
            [29.582419372681727, -1.020000083954048],
            [29.587069842211456, -1.044322271094481],
            [29.589713212190098, -1.052901916186411],
            [29.581962765311005, -1.104634451705608],
            [29.577847784217088, -1.110521792947768],
            [29.578440882510364, -1.113631316585664],
            [29.580269244269374, -1.114801535413016],
            [29.5800271824363, -1.118631607774963],
            [29.57931254747496, -1.120842409252096],
            [29.576745784027132, -1.124138874801953],
            [29.576597335629778, -1.125869335111811],
            [29.57718244790019, -1.127545775684146],
            [29.57564043222283, -1.128660958055047],
            [29.575890503434994, -1.129541588761333],
            [29.576677435708735, -1.130197190999898],
            [29.576221039442103, -1.131387342807402],
            [29.576235675693045, -1.134537292853363],
            [29.577186346588526, -1.136470485591701],
            [29.577046154606972, -1.13954890601218],
            [29.578166789449185, -1.141312464248571],
            [29.578385081859864, -1.143015934273721],
            [29.579145407831504, -1.143302538609116],
            [29.578748325526487, -1.143811858270108],
            [29.579478368391577, -1.144580757132267],
            [29.579922790115436, -1.146171556809624],
            [29.579719118684352, -1.14761805403783],
            [29.5821932442668, -1.149471801574012],
            [29.582528028406916, -1.150324386167138],
            [29.582242412655567, -1.15114627048989],
            [29.583872569232003, -1.152486086692219],
            [29.585259356926585, -1.155533348947582],
            [29.586257815500264, -1.156632539991553],
            [29.586519717524734, -1.156077317274029],
            [29.58826140982512, -1.155107622388136],
            [29.58875480590167, -1.155813242078724],
            [29.58934109496511, -1.155906225735988],
            [29.589636008279616, -1.15554409061343],
            [29.589144376494296, -1.1544298617084],
            [29.590524355857344, -1.153617724874672],
            [29.59172117412387, -1.153417865980173],
            [29.591929560811888, -1.152192725719543],
            [29.593848930892342, -1.151882036124138],
            [29.594700220269672, -1.153315468906439],
            [29.596208633565503, -1.154115671434558],
            [29.59736281958528, -1.155947519172757],
            [29.598824341721624, -1.15715620134098],
            [29.599180678241993, -1.158247241210679],
            [29.600322122557735, -1.157808809186741],
            [29.601901465930123, -1.157860106886672],
            [29.60248541757718, -1.158497955572853],
            [29.601941802083022, -1.158972667512744],
            [29.603270384337076, -1.159613301951705],
            [29.604787537342336, -1.158393016969616],
            [29.604387243560158, -1.157029368921311],
            [29.60569641591589, -1.156943438332658],
            [29.606099259116828, -1.157716840480898],
            [29.606691339618926, -1.156470401069761],
            [29.60756853101913, -1.157132037995249],
            [29.608741244791606, -1.157295326488231],
            [29.609992124570258, -1.155029733622039],
            [29.61149922003758, -1.153525609637366],
            [29.612966644105317, -1.153372153690929],
            [29.613397148230515, -1.152965102594118],
            [29.61452189196682, -1.153786593670937],
            [29.6145949591354, -1.152538214363599],
            [29.615500023462246, -1.15197400950946],
            [29.614036897833152, -1.151128552102601],
            [29.614106855034212, -1.150606658967845],
            [29.61548146606511, -1.151043121596321],
            [29.61615324420089, -1.152248868951801],
            [29.616918402210455, -1.152728479457996],
            [29.61737196429235, -1.152207995787902],
            [29.617732610929465, -1.152300149687537],
            [29.61782493438446, -1.151823726585999],
            [29.618479816108067, -1.151712660667447],
            [29.61871662369505, -1.149125394664921],
            [29.619214042427448, -1.148900227816327],
            [29.620475447766253, -1.14942708255826],
            [29.620725714811147, -1.148951235579345],
            [29.622122128852325, -1.149569411729043],
            [29.623310578413626, -1.148699758757685],
            [29.625018618925175, -1.15031801570095],
            [29.62583273242279, -1.149912392201624],
            [29.626935802506228, -1.150529463438198],
            [29.628312904565437, -1.150489167749904],
            [29.628764618812802, -1.148992355776937],
            [29.629968349615396, -1.147847473656743],
            [29.63101237972346, -1.147766214889587],
            [29.631269184706998, -1.147086072406429],
            [29.631242805678667, -1.146660284410762],
            [29.629299438003716, -1.145971991084153],
            [29.62885130354275, -1.145232465229836],
            [29.629137155551, -1.144353788265135],
            [29.628547379227623, -1.143755642123147],
            [29.628410843389286, -1.142705112553656],
            [29.62869336803772, -1.139314886366849],
            [29.6302782019131, -1.138100455760384],
            [29.631092660363766, -1.138926466039115],
            [29.63295567373655, -1.138621169221695],
            [29.633099005330028, -1.138082514554256],
            [29.633777201928506, -1.13780122128808],
            [29.63332746397476, -1.137430635088311],
            [29.633191547973947, -1.136238215270722],
            [29.63355969195044, -1.135899028699465],
            [29.6341795133268, -1.136071597074524],
            [29.634693687435888, -1.13456939593993],
            [29.635101778594702, -1.128199805727559],
            [29.6334171203317, -1.126377335778061],
            [29.633733109919408, -1.125044680900722],
            [29.632489838871244, -1.123625189401781],
            [29.632707141338482, -1.121561061302062],
            [29.632277146558035, -1.120796650641662],
            [29.632716856618263, -1.119290778993054],
            [29.633884973711456, -1.118414180557292],
            [29.635258832852475, -1.117983337185923],
            [29.636611909469387, -1.118188100602126],
            [29.63711915936424, -1.117772221180542],
            [29.638286514686065, -1.114961300180267],
            [29.640491077411333, -1.112344879898196],
            [29.641229577016535, -1.108497091497861],
            [29.643547841303956, -1.104609676283623],
            [29.645557221677546, -1.103309291019532],
            [29.64619591575973, -1.101695146651506],
            [29.64821944819232, -1.099186986645278],
            [29.651096602927016, -1.097021626194004],
            [29.650067964553045, -1.095405063298411],
            [29.649768472525537, -1.092513257812711],
            [29.64785450850648, -1.089703277553731],
            [29.647387585781356, -1.087922453745535],
            [29.646019470468236, -1.08526841481662],
            [29.643878952232836, -1.083378219199926],
            [29.643512159322547, -1.082290524921294],
            [29.643655675070672, -1.081322871406508],
            [29.64228758850366, -1.078633021704052],
            [29.64066815511678, -1.077842639738899],
            [29.638172395407327, -1.075151545708205],
            [29.637195550299385, -1.072904199462709],
            [29.6346233250946, -1.069591748628074],
            [29.633261535717747, -1.061083210366712],
            [29.63220683721738, -1.059481019631825],
            [29.63093179006269, -1.058559619650377],
            [29.6306727204263, -1.05663570221662],
            [29.630917082844846, -1.055680125397694],
            [29.629957111691205, -1.054269218190014],
            [29.629304478450763, -1.054065382736426],
            [29.628300102674302, -1.055330785852642],
            [29.626972303751185, -1.053800003321111],
            [29.624313895076376, -1.053343074359864],
            [29.623542951916367, -1.052780689245542],
            [29.620835355988184, -1.04840479428955],
            [29.620119722998567, -1.046062225766119],
            [29.619331643576228, -1.044878525051911],
            [29.618509790194153, -1.041974297052874],
            [29.618422784765613, -1.040062540483644],
            [29.61676244569397, -1.038710644844377],
            [29.613212400709184, -1.039614853459745],
            [29.61080912974473, -1.039265780675827],
            [29.608200724891912, -1.036491083140118],
            [29.606134893487525, -1.031375233635362],
            [29.60409965780341, -1.028261071921235],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 202,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYABWISHENYA",
        Population: 15186,
        Key: "KISORONYABWISHENYA",
        Dist2: "Kisoro",
        "Sub Country": "Nyabwishenya",
        id2_original: "Kisoro Nyabwishenya",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.7549901602689, -1.302432057282781],
            [29.757691671907676, -1.303003852422136],
            [29.762329643176862, -1.303172216035861],
            [29.763619651772647, -1.303661010199703],
            [29.76269916067741, -1.298057927589094],
            [29.764076779267885, -1.293066698986286],
            [29.763555761792983, -1.290447756085324],
            [29.764808211826722, -1.288744428485428],
            [29.764648568624345, -1.287404646007062],
            [29.765821771978636, -1.284564584957468],
            [29.764392714956703, -1.279415350260767],
            [29.763136229690698, -1.27689892047045],
            [29.762804334532547, -1.278103958761478],
            [29.763670368856936, -1.279102677948901],
            [29.764368923076375, -1.281930177185558],
            [29.76391486153119, -1.281742537344969],
            [29.76263795666047, -1.279039017634511],
            [29.762100714713213, -1.279308515110096],
            [29.761912417049892, -1.28126195739025],
            [29.7603424422076, -1.281737996599341],
            [29.759847307891, -1.281363260221125],
            [29.76005543945751, -1.28005414188833],
            [29.759375179428826, -1.27911802094301],
            [29.759603635378596, -1.278058333901989],
            [29.7570287331943, -1.27818171105693],
            [29.755222443940138, -1.277724776297317],
            [29.75438432925477, -1.277106697687284],
            [29.750779469969665, -1.270038941755765],
            [29.7502342464911, -1.267407821404864],
            [29.752849726475127, -1.265787412308838],
            [29.755080254105366, -1.262364161488452],
            [29.753985850967794, -1.260251945444223],
            [29.751213858410146, -1.258007735013381],
            [29.749893429265583, -1.256025156995216],
            [29.749863167718598, -1.254401397187284],
            [29.750484118277278, -1.251737702178297],
            [29.752202808316515, -1.248335817646776],
            [29.75135780804453, -1.247932907469177],
            [29.75135850334055, -1.247365565461037],
            [29.752252614509157, -1.246019248533919],
            [29.752229693096346, -1.245570084798397],
            [29.75112709462842, -1.244528599423334],
            [29.749694792891635, -1.244243153415478],
            [29.749585092425786, -1.243252855841777],
            [29.7489127267918, -1.242719376735589],
            [29.747970781232656, -1.242878522554461],
            [29.7474489319178, -1.243512321612404],
            [29.746862817127536, -1.243351173958419],
            [29.747059544581486, -1.242227973701871],
            [29.746587300236623, -1.241840190259486],
            [29.746325464687505, -1.23977298328795],
            [29.746710999149567, -1.239343019978173],
            [29.746107273786468, -1.238046515980606],
            [29.74504691140824, -1.237951713750295],
            [29.735743581033468, -1.231275336439493],
            [29.73378287407691, -1.230632214790869],
            [29.72523682348666, -1.226297431541527],
            [29.721426333544805, -1.223442560729234],
            [29.719765256956308, -1.223393311941593],
            [29.718087304616876, -1.225203435106912],
            [29.716393989289482, -1.22535600421726],
            [29.715516090915127, -1.224830487757448],
            [29.71370919170487, -1.222564521960781],
            [29.710379088437634, -1.220258826287052],
            [29.708440292289144, -1.219774733334956],
            [29.704085390047474, -1.216999745407603],
            [29.69851568975884, -1.215934409363622],
            [29.69700988067899, -1.214498359521806],
            [29.688099631512998, -1.213556720604744],
            [29.684710464015808, -1.214474868465525],
            [29.68344873258856, -1.215559328608321],
            [29.687769514120813, -1.222004747409204],
            [29.688184663342856, -1.227881994472266],
            [29.689001218461385, -1.230157746044979],
            [29.689712863829453, -1.231213615771928],
            [29.69119807453986, -1.231773530297711],
            [29.691525989262963, -1.23238451379263],
            [29.692176500682695, -1.234825928977058],
            [29.691898120860966, -1.235490049137419],
            [29.692389149876735, -1.236600533273648],
            [29.692696475213534, -1.241923093367173],
            [29.694655231029298, -1.247584486895255],
            [29.698344064827175, -1.251527565415965],
            [29.699384312129563, -1.252068947819621],
            [29.701620028428902, -1.260798231450444],
            [29.700346290119548, -1.261963096368117],
            [29.699581062939703, -1.263645320264118],
            [29.699058409632684, -1.263819928241403],
            [29.700284830082765, -1.265977623662106],
            [29.701100777940155, -1.271454114833219],
            [29.701738341941688, -1.27338744578689],
            [29.701826732572385, -1.275780192805375],
            [29.700728387627315, -1.276699019506133],
            [29.703510116126044, -1.282132054439154],
            [29.70625294847124, -1.282227628317352],
            [29.70860155066244, -1.282903616340034],
            [29.710697707394175, -1.28156751745948],
            [29.718507811391277, -1.281399603255119],
            [29.720307440535926, -1.282384524695743],
            [29.725923899931715, -1.283859706724088],
            [29.730929591172554, -1.285763465935841],
            [29.737151352474783, -1.287061600415968],
            [29.739557860069183, -1.295915875092919],
            [29.742294460801283, -1.301153994756524],
            [29.74413985910965, -1.302759919597258],
            [29.74605708131828, -1.304127298318925],
            [29.74712343366282, -1.304441258095901],
            [29.74886644918163, -1.303938680310877],
            [29.74887147795058, -1.303478296153239],
            [29.7549901602689, -1.302432057282781],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 203,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYAKABANDE",
        Population: 24879,
        Key: "KISORONYAKABANDE",
        Dist2: "Kisoro",
        "Sub Country": "Nyakabande",
        id2_original: "Kisoro Nyakabande",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.699058409632684, -1.263819928241403],
            [29.699581062939703, -1.263645320264118],
            [29.700346290119548, -1.261963096368117],
            [29.701620028428902, -1.260798231450444],
            [29.699384312129563, -1.252068947819621],
            [29.698344064827175, -1.251527565415965],
            [29.694655231029298, -1.247584486895255],
            [29.692696475213534, -1.241923093367173],
            [29.692389149876735, -1.236600533273648],
            [29.691898120860966, -1.235490049137419],
            [29.692176500682695, -1.234825928977058],
            [29.691525989262963, -1.23238451379263],
            [29.69119807453986, -1.231773530297711],
            [29.689712863829453, -1.231213615771928],
            [29.689001218461385, -1.230157746044979],
            [29.688184663342856, -1.227881994472266],
            [29.687769514120813, -1.222004747409204],
            [29.68344873258856, -1.215559328608321],
            [29.672692112238717, -1.227666174378505],
            [29.66870492368049, -1.231170246141734],
            [29.665446320919965, -1.233201289442918],
            [29.66289161915143, -1.23318494658586],
            [29.65998513262608, -1.244412022908139],
            [29.658573670905586, -1.247954129624433],
            [29.65734097841821, -1.251792437836066],
            [29.65530625926536, -1.254817390788142],
            [29.653481909382414, -1.267166333388928],
            [29.649616518003647, -1.267201143574082],
            [29.640829870732556, -1.2760886795125],
            [29.627957038762244, -1.275743033325639],
            [29.63236329140053, -1.281571164605318],
            [29.637588833629074, -1.286984323479197],
            [29.63882601859121, -1.289769814026252],
            [29.64088127592636, -1.29257003194253],
            [29.648886553291973, -1.296106599710728],
            [29.654960222828034, -1.299290473177672],
            [29.658632309334052, -1.300568233095509],
            [29.665180167169265, -1.304428951671609],
            [29.66727997285768, -1.303414672372605],
            [29.668754109137232, -1.30203492665649],
            [29.67075400419977, -1.299200561464521],
            [29.672298259377126, -1.298179152862774],
            [29.673268100320808, -1.301032596295491],
            [29.675230941674503, -1.298902899471808],
            [29.67757646444088, -1.295138396055283],
            [29.67770332272869, -1.293688920197661],
            [29.678346940476928, -1.292497322842131],
            [29.67855575476303, -1.289883708606575],
            [29.675369830200573, -1.284286253527467],
            [29.675330084240827, -1.281516618175565],
            [29.675474347387233, -1.280800851547304],
            [29.67882366921167, -1.279598669554622],
            [29.680484924564922, -1.278310762349412],
            [29.680691666437685, -1.276437261516858],
            [29.680059009034196, -1.273665640990664],
            [29.68025273881007, -1.272209900431062],
            [29.68248607008232, -1.270689351662714],
            [29.685617364499088, -1.269594328310259],
            [29.68872934423897, -1.268346545691665],
            [29.68978938412201, -1.266619116498664],
            [29.689934928266005, -1.265425837007421],
            [29.687486818792493, -1.254470858036675],
            [29.687324530051566, -1.253109441398178],
            [29.68776399577001, -1.252836307484334],
            [29.690427997355787, -1.254241879354474],
            [29.692082288968933, -1.256324532140923],
            [29.695043727236865, -1.262294096429797],
            [29.696041962130035, -1.263313963830018],
            [29.69607313546701, -1.264343530272886],
            [29.699058409632684, -1.263819928241403],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 204,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYAKINAMA",
        Population: 19676,
        Key: "KISORONYAKINAMA",
        Dist2: "Kisoro",
        "Sub Country": "Nyakinama",
        id2_original: "Kisoro Nyakinama",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.658573670905586, -1.247954129624433],
            [29.65745778994784, -1.247816863679309],
            [29.655186462634028, -1.243107842607862],
            [29.65316616593308, -1.241459472147685],
            [29.64302017629596, -1.240040796387114],
            [29.641926477437543, -1.237289527827593],
            [29.64042506201774, -1.23487726654989],
            [29.6395227186879, -1.232228891518116],
            [29.637063968669832, -1.231992527564097],
            [29.636596537498253, -1.230515042219228],
            [29.63506552258985, -1.229714615809099],
            [29.633981736640603, -1.229846732938831],
            [29.634121402209395, -1.228871023362014],
            [29.631367621197505, -1.22901950137839],
            [29.630689145222966, -1.226780666520463],
            [29.631036300062835, -1.224806801003397],
            [29.63036339184644, -1.223873422918449],
            [29.63050316341642, -1.222875012314653],
            [29.630100446877943, -1.222078880182566],
            [29.629110510621356, -1.221394032773312],
            [29.629048573579148, -1.220077014372795],
            [29.627876022401715, -1.219868245623952],
            [29.627699168376783, -1.21902756534992],
            [29.625691582837128, -1.218838341233871],
            [29.62363140902242, -1.2177748596203],
            [29.622801628906256, -1.216591157110769],
            [29.621716189158555, -1.217109219050315],
            [29.62083631179566, -1.217060482070948],
            [29.619658821680787, -1.217986844671663],
            [29.61649890424413, -1.218133798295752],
            [29.614518675998113, -1.216854948090281],
            [29.614048574135193, -1.21599044622568],
            [29.61332686224605, -1.215896907756852],
            [29.6123302919311, -1.214156368664541],
            [29.61219925018901, -1.21315696922815],
            [29.60915805949017, -1.211964913130355],
            [29.60868269619465, -1.212303654887436],
            [29.609422890920776, -1.21332807698961],
            [29.608787082227302, -1.214233767194766],
            [29.608869082243086, -1.216118405768065],
            [29.607532249861425, -1.217361991934716],
            [29.606939077906294, -1.218835407999962],
            [29.6057140210988, -1.219518842432767],
            [29.606995478631386, -1.2209187145734],
            [29.607329088673396, -1.222032414615837],
            [29.60707937499071, -1.222372002924942],
            [29.604595554789718, -1.222725812774627],
            [29.602578459684423, -1.224715981420343],
            [29.603879559779003, -1.229045753991466],
            [29.605946526653923, -1.231119550644571],
            [29.606548711406305, -1.232733725803917],
            [29.606190595323344, -1.234628033859731],
            [29.60473879834828, -1.236347894228516],
            [29.605207985726224, -1.237416705897475],
            [29.604636358066543, -1.239117218374533],
            [29.60512970114247, -1.239822881102787],
            [29.604173854154304, -1.244212179622678],
            [29.603086197364505, -1.245229639067691],
            [29.601846682172532, -1.244861662835753],
            [29.601304098842608, -1.24508661254669],
            [29.600699964746024, -1.24648050694211],
            [29.600808579148715, -1.247434425666187],
            [29.59960968397727, -1.248088211790266],
            [29.599221162616885, -1.249199142376466],
            [29.598589013659886, -1.249264831336265],
            [29.59761438918733, -1.25023730382575],
            [29.596216526163605, -1.249959522835505],
            [29.59571827289631, -1.250366255919958],
            [29.595069179916425, -1.251624929440217],
            [29.59415411913708, -1.256682922250681],
            [29.592097413717667, -1.271501104014636],
            [29.59496219415934, -1.285773964597424],
            [29.608872460806868, -1.287006616734241],
            [29.619969406105454, -1.278712272181847],
            [29.62182183462924, -1.277691951935466],
            [29.627957038762244, -1.275743033325639],
            [29.640829870732556, -1.2760886795125],
            [29.649616518003647, -1.267201143574082],
            [29.653481909382414, -1.267166333388928],
            [29.65530625926536, -1.254817390788142],
            [29.65734097841821, -1.251792437836066],
            [29.658573670905586, -1.247954129624433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 205,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYARUBUYE",
        Population: 18909,
        Key: "KISORONYARUBUYE",
        Dist2: "Kisoro",
        "Sub Country": "Nyarubuye",
        id2_original: "Kisoro Nyarubuye",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.70299364322815, -1.294882381419845],
            [29.702498797270746, -1.29752395327907],
            [29.701801869900294, -1.298573152474769],
            [29.700680273860716, -1.299310648641809],
            [29.69343315752691, -1.300565136502352],
            [29.690129895022018, -1.300055179285897],
            [29.687931637571705, -1.296707523880767],
            [29.6835879193553, -1.29399878689677],
            [29.680250545124153, -1.293022179040656],
            [29.67757646444088, -1.295138396055283],
            [29.675230941674503, -1.298902899471808],
            [29.673268100320808, -1.301032596295491],
            [29.675117187111756, -1.305515383376769],
            [29.676756495724284, -1.312922177936927],
            [29.676741408519064, -1.314080065212921],
            [29.675192685121477, -1.316677195260572],
            [29.675661550902557, -1.318612652492243],
            [29.673282909048257, -1.321183081593148],
            [29.670253284158715, -1.323333466394038],
            [29.667812490564827, -1.324259347234511],
            [29.663086512245577, -1.325123584757001],
            [29.657141426660978, -1.326786482400492],
            [29.651961517052253, -1.334611579394532],
            [29.649626379708852, -1.34273281029014],
            [29.642846703529734, -1.341850091303504],
            [29.642231356661817, -1.341418247630899],
            [29.64118755023426, -1.341557919823492],
            [29.636816842135158, -1.339979167812854],
            [29.63622650616136, -1.339093805711357],
            [29.634876409256226, -1.338540079066731],
            [29.63176852493575, -1.339030769282606],
            [29.63213918599167, -1.354302655593822],
            [29.631002578205397, -1.354009005597755],
            [29.62974514521676, -1.354219543329302],
            [29.62756031488503, -1.355334077786559],
            [29.625705668420782, -1.35707046947057],
            [29.625497921333235, -1.359230325160221],
            [29.625871119231494, -1.36140411414157],
            [29.63293765443027, -1.377973166178085],
            [29.636268642538084, -1.382377533404195],
            [29.640976212580544, -1.38638087172111],
            [29.64261655515397, -1.384977995937833],
            [29.643451019086, -1.383429073388215],
            [29.644210617422257, -1.383169078821206],
            [29.645110783235868, -1.383506446976998],
            [29.646009194639706, -1.384464534164472],
            [29.65287525910473, -1.384213813905758],
            [29.65714534601058, -1.383703356853373],
            [29.662741965214977, -1.38372276737807],
            [29.664985913675586, -1.38271584911918],
            [29.673405382659165, -1.382482358735863],
            [29.675458120219933, -1.382000024769594],
            [29.68064000073242, -1.377815897795837],
            [29.68484760352203, -1.370154535811767],
            [29.68796333552482, -1.366989839547315],
            [29.688512040873434, -1.36584571041614],
            [29.68829268395913, -1.363755876170957],
            [29.68865363063354, -1.361918727693353],
            [29.689913039017505, -1.361039649240473],
            [29.691359798240438, -1.360996862879641],
            [29.693497329577532, -1.359882050837522],
            [29.69494388488293, -1.359910874146075],
            [29.696441601040362, -1.358626722897621],
            [29.698506844048246, -1.35791752983053],
            [29.69980758661332, -1.35499723282931],
            [29.706400281160995, -1.350877327987758],
            [29.70808575239933, -1.350286167244263],
            [29.70958770501167, -1.347497834681908],
            [29.71002090767595, -1.345254969137444],
            [29.71082943095753, -1.344469819863365],
            [29.709823318737648, -1.343833692188064],
            [29.70892623145053, -1.342374224936493],
            [29.708117145823564, -1.339136294298456],
            [29.70862397261192, -1.336010280595706],
            [29.711949745101187, -1.329778043784041],
            [29.712365062308184, -1.3254340420954],
            [29.712132169579217, -1.323905199275079],
            [29.70872430185275, -1.317101023424202],
            [29.70911344754225, -1.313616465099233],
            [29.7084948191286, -1.310092699804806],
            [29.709162409318512, -1.308805649586994],
            [29.708270928417043, -1.305316793168367],
            [29.708367482937067, -1.300434529060527],
            [29.70542908465956, -1.299612875548481],
            [29.704316623588102, -1.298845108634468],
            [29.70299364322815, -1.294882381419845],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 206,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYARUSIZA",
        Population: 30308,
        Key: "KISORONYARUSIZA",
        Dist2: "Kisoro",
        "Sub Country": "Nyarusiza",
        id2_original: "Kisoro Nyarusiza",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.751406815634844, -1.239681285868482],
            [29.750598767562064, -1.236717579842431],
            [29.751349128522243, -1.234086393715843],
            [29.75063055534669, -1.229737834605224],
            [29.750633958164993, -1.226917726989018],
            [29.748026183929476, -1.22085131041835],
            [29.74361828018772, -1.216639297751748],
            [29.741986358421762, -1.214569260191406],
            [29.739886378460177, -1.213391676024355],
            [29.735948612513926, -1.206548225778917],
            [29.733173141679487, -1.204030319269596],
            [29.731588475789067, -1.201490342782775],
            [29.728933725952395, -1.195612032562559],
            [29.723103941829486, -1.18944797234571],
            [29.720250492736795, -1.187417109131587],
            [29.719375710618177, -1.185621709822847],
            [29.71881817752532, -1.181453236013247],
            [29.72000908038566, -1.177416100536522],
            [29.720657765530426, -1.17351322469295],
            [29.722029307916333, -1.172076517714589],
            [29.724736775385438, -1.172245476117321],
            [29.725529292485298, -1.171635366516306],
            [29.727245740329582, -1.171346540382038],
            [29.72786850818009, -1.168215496197693],
            [29.72710917484684, -1.166350839668258],
            [29.7263689028656, -1.165303654998974],
            [29.72354359349919, -1.163669801594796],
            [29.72273649584397, -1.162418016439461],
            [29.71678837125876, -1.157480390181812],
            [29.713022954286306, -1.151404245094763],
            [29.711921704189617, -1.150333032505489],
            [29.71181342665514, -1.149265487495666],
            [29.710070225185063, -1.147908137287944],
            [29.709222536255403, -1.145589099681853],
            [29.705864671452602, -1.144486915386035],
            [29.704988311892343, -1.143598190741555],
            [29.70298167587195, -1.143159404396517],
            [29.70142095547373, -1.141348646598242],
            [29.700203789467714, -1.141003587709395],
            [29.70004775479781, -1.140548930882073],
            [29.699421965913, -1.140674947626572],
            [29.698832475253905, -1.140694588990395],
            [29.69696706158268, -1.142068172844305],
            [29.696355492130483, -1.14153916660938],
            [29.69518114252586, -1.141734655999569],
            [29.694590626889013, -1.14261341729272],
            [29.694253785606943, -1.14539123139248],
            [29.693047669777226, -1.146685486089808],
            [29.692393142888168, -1.14775473223298],
            [29.692480242639803, -1.148499768390841],
            [29.691645873929204, -1.149404876182058],
            [29.692286008909093, -1.151695846704444],
            [29.693929175785758, -1.153745337924335],
            [29.693635495858132, -1.154870412949526],
            [29.693993531092723, -1.155580112915338],
            [29.693613780882767, -1.155724026084424],
            [29.693589334130618, -1.157213362058833],
            [29.692648618365098, -1.159761879809847],
            [29.692785348239546, -1.161560593654961],
            [29.691641560219203, -1.163045769114211],
            [29.688953913178533, -1.164588811188773],
            [29.687770557064876, -1.165740750341512],
            [29.687573645456247, -1.166490866084364],
            [29.688130641356608, -1.167110505951438],
            [29.688032795957557, -1.168871994872603],
            [29.68866265421059, -1.169346598188949],
            [29.688550112373484, -1.172424916552627],
            [29.68782340405472, -1.173475704544592],
            [29.685056048600558, -1.174664215353289],
            [29.6837390752749, -1.174441356929127],
            [29.682220610729345, -1.174889795980923],
            [29.681150902278915, -1.175939304114767],
            [29.67985166618854, -1.175789150002269],
            [29.679507634790905, -1.176024000098138],
            [29.679827431438817, -1.177223978887257],
            [29.679590837650842, -1.17765901745897],
            [29.678009164048618, -1.178116307019397],
            [29.676938746827446, -1.179329247545793],
            [29.671152939729236, -1.18132382976881],
            [29.668173040183923, -1.183646681042705],
            [29.666828317000828, -1.185675944773588],
            [29.666406006409318, -1.187309064109212],
            [29.666641048806813, -1.189316975901268],
            [29.671505694666585, -1.199924365314053],
            [29.673397050784885, -1.205071673990723],
            [29.673809928167575, -1.207697832122618],
            [29.67344380180723, -1.20885891140366],
            [29.672700508791685, -1.209564486896402],
            [29.667553550285895, -1.212006254230309],
            [29.66624083766963, -1.212882226285291],
            [29.664970284786282, -1.214439485488235],
            [29.664183342631073, -1.218950043915867],
            [29.663801153495132, -1.227921221179089],
            [29.66289161915143, -1.23318494658586],
            [29.665446320919965, -1.233201289442918],
            [29.66870492368049, -1.231170246141734],
            [29.672692112238717, -1.227666174378505],
            [29.68344873258856, -1.215559328608321],
            [29.684710464015808, -1.214474868465525],
            [29.688099631512998, -1.213556720604744],
            [29.69700988067899, -1.214498359521806],
            [29.69851568975884, -1.215934409363622],
            [29.704085390047474, -1.216999745407603],
            [29.708440292289144, -1.219774733334956],
            [29.710379088437634, -1.220258826287052],
            [29.71370919170487, -1.222564521960781],
            [29.715516090915127, -1.224830487757448],
            [29.716393989289482, -1.22535600421726],
            [29.718087304616876, -1.225203435106912],
            [29.719765256956308, -1.223393311941593],
            [29.721426333544805, -1.223442560729234],
            [29.72523682348666, -1.226297431541527],
            [29.73378287407691, -1.230632214790869],
            [29.735743581033468, -1.231275336439493],
            [29.74504691140824, -1.237951713750295],
            [29.746107273786468, -1.238046515980606],
            [29.746710999149567, -1.239343019978173],
            [29.746325464687505, -1.23977298328795],
            [29.746587300236623, -1.241840190259486],
            [29.747059544581486, -1.242227973701871],
            [29.746862817127536, -1.243351173958419],
            [29.7474489319178, -1.243512321612404],
            [29.747970781232656, -1.242878522554461],
            [29.7489127267918, -1.242719376735589],
            [29.749585092425786, -1.243252855841777],
            [29.751406815634844, -1.239681285868482],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 207,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "NYUNDO",
        Population: 13160,
        Key: "KISORONYUNDO",
        Dist2: "Kisoro",
        "Sub Country": "Nyundo",
        id2_original: "Kisoro Nyundo",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "VH",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.93877102608325, -1.168316284183653],
            [29.937174660534566, -1.167751564255654],
            [29.929571487954718, -1.167550771407883],
            [29.929945698254308, -1.168441476113559],
            [29.930036764067932, -1.172115089588797],
            [29.92885422362454, -1.178591234786291],
            [29.92710330562616, -1.183516636334646],
            [29.924914030430397, -1.187499637595721],
            [29.92207438934196, -1.188965795900494],
            [29.91843638132457, -1.192948335753677],
            [29.91724883726504, -1.193019526178421],
            [29.91473300470055, -1.191563611303013],
            [29.912811501121286, -1.189583103736126],
            [29.912207876369493, -1.187758090252808],
            [29.910974850607154, -1.185992503455164],
            [29.909811288870774, -1.185872869897641],
            [29.905634906130555, -1.182698979060041],
            [29.903747450497185, -1.182161674583524],
            [29.90180295992813, -1.179489440708251],
            [29.898481723032713, -1.176172728872013],
            [29.89831634768049, -1.175385506040981],
            [29.896490228116434, -1.173047259369761],
            [29.894592619723728, -1.172545107527012],
            [29.892989462911487, -1.173286797020551],
            [29.89062349089595, -1.17502433531647],
            [29.887188217366834, -1.178326971302601],
            [29.886783491297013, -1.179233278397538],
            [29.88713516735771, -1.183407759497519],
            [29.88640943999924, -1.184659834333968],
            [29.885482508881747, -1.185351283189655],
            [29.885146784205542, -1.188285151459193],
            [29.88325050891273, -1.192355165667589],
            [29.883321924079517, -1.200392962984187],
            [29.8852905442954, -1.208109201429412],
            [29.888389423903476, -1.211089210213062],
            [29.890317963986373, -1.213988933342198],
            [29.89418879825742, -1.217654065297475],
            [29.89627627097532, -1.220690834079031],
            [29.896921602709117, -1.222825420438322],
            [29.896942395114703, -1.224537475751259],
            [29.89862549030912, -1.226171327978111],
            [29.89966643290753, -1.229392473290813],
            [29.901436387105097, -1.232418693069234],
            [29.90229163266291, -1.234781546341359],
            [29.89800616210783, -1.23673620925573],
            [29.897229211015237, -1.236369936447756],
            [29.894557059014897, -1.236295750184762],
            [29.894669352917, -1.239840464201958],
            [29.890969379111286, -1.240719876767217],
            [29.887247268122035, -1.242099379552791],
            [29.88441712492108, -1.243636501513085],
            [29.886052640846493, -1.247180718914718],
            [29.888038156576258, -1.255206777220528],
            [29.889111324438847, -1.256577506056689],
            [29.89206187063394, -1.258532726674632],
            [29.90299907301713, -1.263440460779706],
            [29.9079663379234, -1.268363131713579],
            [29.91025746769936, -1.271744370749947],
            [29.913458908861717, -1.277398354888615],
            [29.915106157683056, -1.286521978407709],
            [29.917107057960383, -1.292413876214416],
            [29.92149915225148, -1.283894391848938],
            [29.930131372837042, -1.274985562145497],
            [29.93224044105433, -1.270718870228456],
            [29.93631487129803, -1.268352572808483],
            [29.93811325986929, -1.266779149080186],
            [29.93777573766419, -1.265357626600049],
            [29.93581409017154, -1.264477035019708],
            [29.93595417794854, -1.263836034708558],
            [29.938256975941698, -1.263873127900321],
            [29.940397572330546, -1.265001944546953],
            [29.939536145465237, -1.263132132424619],
            [29.93993121734069, -1.260806052984187],
            [29.94190192613963, -1.260915772691682],
            [29.94235567507109, -1.258411550720773],
            [29.94528936078662, -1.256845647944752],
            [29.94598339288693, -1.256948587170524],
            [29.94718988690736, -1.256433046787711],
            [29.94929122512166, -1.254547489314239],
            [29.9523303523903, -1.25277540189754],
            [29.953492004308384, -1.252417134292285],
            [29.955411943920733, -1.252913862057072],
            [29.96170971167911, -1.252696444487596],
            [29.964956572560578, -1.251865374405001],
            [29.963904350715445, -1.24967173426951],
            [29.962507533330736, -1.248115788915126],
            [29.960764891511054, -1.243216193447738],
            [29.957678233482426, -1.237152505613081],
            [29.959394208812903, -1.236419891805438],
            [29.963000261060685, -1.233632225499365],
            [29.964311915461565, -1.233520585399438],
            [29.967096528450636, -1.231542806420123],
            [29.968521375068843, -1.231772141823193],
            [29.971922147002875, -1.233634838092828],
            [29.974959008720365, -1.231512748548923],
            [29.975801292486963, -1.231495047742521],
            [29.976793304750174, -1.232922736086536],
            [29.97969809345964, -1.2354600326237],
            [29.987088103009043, -1.233679597952623],
            [29.99168202898154, -1.229423577482274],
            [29.998824848215936, -1.22696648803852],
            [30.000621545259495, -1.226913608259625],
            [30.002693035151868, -1.228600593845216],
            [30.00528000350705, -1.228890786243337],
            [30.00392252155197, -1.225219751069534],
            [30.00435420786009, -1.223068934163234],
            [30.006390567336634, -1.219808628071143],
            [30.008908511840335, -1.219023032578784],
            [30.00952724086533, -1.218282796913374],
            [30.01152086928041, -1.212679789582253],
            [30.012050072204207, -1.209262145406988],
            [30.011805581326577, -1.206907245875092],
            [30.013159513139655, -1.203128774963104],
            [30.012170853389083, -1.202365877249937],
            [30.011781600800067, -1.201158209826684],
            [30.00886826192572, -1.197903537335457],
            [30.005570184496673, -1.19610659919887],
            [30.006412779978668, -1.198824762941561],
            [30.00840918688294, -1.211205761237938],
            [30.008503894466692, -1.212121029643845],
            [30.00759338275595, -1.213276016022538],
            [30.006301037642146, -1.213515410962452],
            [30.0044335362862, -1.214572993649037],
            [30.000891334492145, -1.215436036533592],
            [29.99792546663156, -1.214421236719987],
            [29.99520047213296, -1.211961728416962],
            [29.994339040776097, -1.212008934203397],
            [29.99232661331702, -1.214318648804795],
            [29.986175333832026, -1.218281130017115],
            [29.984346252522435, -1.218678226713682],
            [29.982584229550543, -1.218210564440928],
            [29.977189353992628, -1.215610005539135],
            [29.976727282170028, -1.215077284306771],
            [29.977854580715018, -1.211752293537784],
            [29.977326436006674, -1.211197324349647],
            [29.972922832500156, -1.208753138560707],
            [29.97158023832428, -1.207554186590386],
            [29.970059850485708, -1.207752058553834],
            [29.96748365382906, -1.206418679711508],
            [29.965588887705906, -1.206483080027803],
            [29.9609450549295, -1.202175975688564],
            [29.958591027812293, -1.199179760482837],
            [29.954365296121928, -1.195338836209672],
            [29.952803366591347, -1.193274861840095],
            [29.949677174605387, -1.191275674584164],
            [29.947361499262602, -1.193490540972078],
            [29.94310775181349, -1.195126694018785],
            [29.944920473903395, -1.189496426910116],
            [29.94520920950373, -1.187368006984468],
            [29.94210929054485, -1.181510539038103],
            [29.941452097456036, -1.178094967560063],
            [29.94238008229736, -1.175612466132163],
            [29.94429974882186, -1.172842780987567],
            [29.93877102608325, -1.168316284183653],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 208,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "BUBAARE",
        Population: 33820,
        Key: "RUBANDABUBAARE",
        Dist2: "Kabale",
        "Sub Country": "Bubaare",
        id2_original: "Kabale Bubaare",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.080379704740217, -1.319466098889674],
            [30.079509527385714, -1.319520666053083],
            [30.076682285743146, -1.315767300087026],
            [30.07335836468167, -1.31273106123486],
            [30.0707068335087, -1.30734758514762],
            [30.069650538702064, -1.306274733231708],
            [30.067275409260546, -1.305816409701706],
            [30.06452442380583, -1.307270172322002],
            [30.059019143502837, -1.308503462401629],
            [30.053173848169912, -1.310410860055697],
            [30.0517178470793, -1.31060283999014],
            [30.049902283618135, -1.310146409506284],
            [30.04156918315755, -1.30295682969409],
            [30.038856443476057, -1.298417422808746],
            [30.037099715174417, -1.297511010976901],
            [30.036847580532054, -1.297566424613898],
            [30.037456874551598, -1.300733963690159],
            [30.037131556858, -1.303490292743612],
            [30.03660810135541, -1.304450522714772],
            [30.033788662479402, -1.305645395126704],
            [30.031272343028014, -1.311981677530581],
            [30.029645450929365, -1.312651374638186],
            [30.028371646144688, -1.314982363255864],
            [30.026730142049587, -1.315750479078097],
            [30.023770857043402, -1.314783633697623],
            [30.022015807693045, -1.313623956875906],
            [30.017826176598994, -1.312568470219857],
            [30.01522558080095, -1.312390691769562],
            [30.008635174262317, -1.310539092454938],
            [30.007656775967256, -1.310423159266034],
            [30.006961823093786, -1.311615133424275],
            [30.00990732255361, -1.317916360415018],
            [30.010843911458736, -1.322379258093708],
            [30.01355971888692, -1.326412180212879],
            [30.01405173874445, -1.32821463408929],
            [30.02073102908886, -1.342390576972189],
            [30.02149323074281, -1.345451824668775],
            [30.02252198769439, -1.346673626495065],
            [30.02276564224049, -1.347940614833268],
            [30.02418408566739, -1.349239867337549],
            [30.025083979291438, -1.350692036388851],
            [30.026239086084374, -1.353791134252906],
            [30.026604262925446, -1.358350587447917],
            [30.026399247614673, -1.363372326931961],
            [30.027078147594047, -1.366877764397849],
            [30.026489026142492, -1.367128941794516],
            [30.022443540515592, -1.374092751421948],
            [30.021825107934646, -1.376721404905477],
            [30.022072898324314, -1.377341274487903],
            [30.018503229642135, -1.392916557881054],
            [30.01708386813704, -1.396091024503899],
            [30.016856313197458, -1.398833558326506],
            [30.01691984295265, -1.401985097012647],
            [30.017938216277887, -1.404577266900593],
            [30.0186619592579, -1.408597764072715],
            [30.019743156262475, -1.410987567922208],
            [30.021708063741332, -1.413436809816248],
            [30.025033973672848, -1.41844458540472],
            [30.031082973674554, -1.419689950143888],
            [30.034009953466487, -1.421332254621761],
            [30.03647191496171, -1.421340964700986],
            [30.037256966163227, -1.425395522313581],
            [30.037785972355955, -1.425791311569757],
            [30.039855176035918, -1.425967452571029],
            [30.042508811961618, -1.428776507276362],
            [30.047031822230615, -1.430227553372794],
            [30.05160712522895, -1.432241520855519],
            [30.052797532219294, -1.432034703469698],
            [30.05409744563937, -1.430041518142934],
            [30.053985288281197, -1.425764189051383],
            [30.0554800624561, -1.42175984322902],
            [30.054343190565145, -1.420180123417707],
            [30.0534087046161, -1.417588162200784],
            [30.05335250511362, -1.415463567492343],
            [30.053958946083817, -1.412539371171062],
            [30.052718106775124, -1.407568711592129],
            [30.051778885806243, -1.405708319748537],
            [30.051652453319893, -1.403625689748732],
            [30.052142582223738, -1.401376406494318],
            [30.064460912915237, -1.393611343013458],
            [30.06992700421391, -1.391998441842367],
            [30.070625323973072, -1.385655732080344],
            [30.070557679933867, -1.383123086804997],
            [30.071215809965516, -1.380846193062971],
            [30.073130744165102, -1.378911323262628],
            [30.080477993907, -1.374083035343672],
            [30.08493182581432, -1.373254346850269],
            [30.086592793706668, -1.373836969519058],
            [30.088898321679977, -1.376433712657861],
            [30.090770823058797, -1.376749741265346],
            [30.09466713085637, -1.375609591597163],
            [30.096592189069213, -1.376460435214407],
            [30.098605692709977, -1.376608116938188],
            [30.098623341012054, -1.365127537074053],
            [30.09900200605712, -1.362793312825462],
            [30.09821984832915, -1.360412878326907],
            [30.09892926318036, -1.352297272587172],
            [30.09815543732663, -1.350803234879201],
            [30.096289033711972, -1.349530574049663],
            [30.094227627408685, -1.3459357743997],
            [30.094151250846593, -1.344753691950014],
            [30.09299057719385, -1.342498594881941],
            [30.092160362293125, -1.338879912381758],
            [30.08984188510496, -1.33391954418883],
            [30.089863858795123, -1.33266745120819],
            [30.088482955065665, -1.329848847886145],
            [30.08788379044926, -1.327286173662595],
            [30.08618813141727, -1.325563907319268],
            [30.085276197673423, -1.323788061490671],
            [30.08218367993419, -1.321751493883548],
            [30.080379704740217, -1.319466098889674],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 209,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "BUHARA",
        Population: 25699,
        Key: "KABALEBUHARA",
        Dist2: "Kabale",
        "Sub Country": "Buhara",
        id2_original: "Kabale Buhara",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.016005330145667, -1.254424709168911],
            [30.017624180525903, -1.25274661418205],
            [30.018308047290457, -1.252712965945898],
            [30.018147224600096, -1.252482666003928],
            [30.019598542773103, -1.250930767363325],
            [30.020147111577757, -1.24968845153305],
            [30.021239319232823, -1.248593571134383],
            [30.02084133591755, -1.247625109859762],
            [30.01977935836844, -1.246730460590198],
            [30.010234166484913, -1.244852632407426],
            [30.009580208229416, -1.244220419722138],
            [30.009314208090622, -1.238179987937782],
            [30.00528000350705, -1.228890786243337],
            [30.00497344622983, -1.237542559255272],
            [30.00428729504952, -1.24005023097911],
            [30.003038652974276, -1.242274053629657],
            [30.002072456495686, -1.243567632227674],
            [30.00068196864046, -1.243849154493979],
            [29.996403795998766, -1.244289414725016],
            [29.99244720226245, -1.244188676254398],
            [29.991876151321172, -1.244844042947777],
            [29.99224769362439, -1.245730735665852],
            [29.991703381037546, -1.247877589760703],
            [29.990583185471507, -1.250160129070785],
            [29.987468901552944, -1.248861237845517],
            [29.983300438360267, -1.248871919869466],
            [29.98198368512186, -1.247815274936425],
            [29.979917516849227, -1.248085579452831],
            [29.979217739124376, -1.245485669399697],
            [29.97687125605894, -1.246565209701769],
            [29.9775821073163, -1.2468728089545],
            [29.97683653886814, -1.247315057079144],
            [29.97615966728472, -1.246905249317487],
            [29.9733483806199, -1.24724286131838],
            [29.971825128952215, -1.246593464012026],
            [29.971146770656958, -1.247513020400998],
            [29.968199260767523, -1.248498100196785],
            [29.967181640230528, -1.24992853384226],
            [29.966669150462636, -1.250074927082487],
            [29.96756928214025, -1.251826501006607],
            [29.96936761950754, -1.252664860984062],
            [29.97017271391967, -1.253791618648827],
            [29.970633485880033, -1.256445949780385],
            [29.970622564162824, -1.259511715014868],
            [29.978288147197016, -1.254593239423441],
            [29.98054942146448, -1.253948426042795],
            [29.981783907887497, -1.255441218060293],
            [29.98437855594006, -1.256781988879177],
            [29.986506387268726, -1.258978655932565],
            [29.99731312283164, -1.262067968995385],
            [29.99839481750291, -1.260395276490655],
            [29.998958139339457, -1.258615680446852],
            [30.001867663068797, -1.258337441417561],
            [30.003988732778307, -1.257539665654922],
            [30.005421049786445, -1.256474354864852],
            [30.009542917365344, -1.255028058063502],
            [30.010915782071343, -1.25495068047905],
            [30.012601756366262, -1.255426335651049],
            [30.01472038175987, -1.254876084307554],
            [30.01526916616022, -1.255153065467838],
            [30.016005330145667, -1.254424709168911],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 210,
        District: "KABALE",
        County: "KABALE MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 15890,
        Key: "KABALECENTRAL DIVISION",
        Dist2: "Kabale",
        "Sub Country": "Central Division",
        id2_original: "Kabale Central Division",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.00528000350705, -1.228890786243337],
            [30.002693035151868, -1.228600593845216],
            [30.000621545259495, -1.226913608259625],
            [29.998824848215936, -1.22696648803852],
            [29.99168202898154, -1.229423577482274],
            [29.987088103009043, -1.233679597952623],
            [29.97969809345964, -1.2354600326237],
            [29.976793304750174, -1.232922736086536],
            [29.975801292486963, -1.231495047742521],
            [29.974959008720365, -1.231512748548923],
            [29.971922147002875, -1.233634838092828],
            [29.968521375068843, -1.231772141823193],
            [29.967096528450636, -1.231542806420123],
            [29.964311915461565, -1.233520585399438],
            [29.963000261060685, -1.233632225499365],
            [29.959394208812903, -1.236419891805438],
            [29.957678233482426, -1.237152505613081],
            [29.960764891511054, -1.243216193447738],
            [29.962507533330736, -1.248115788915126],
            [29.963904350715445, -1.24967173426951],
            [29.964956572560578, -1.251865374405001],
            [29.966669150462636, -1.250074927082487],
            [29.967181640230528, -1.24992853384226],
            [29.968199260767523, -1.248498100196785],
            [29.971146770656958, -1.247513020400998],
            [29.971825128952215, -1.246593464012026],
            [29.9733483806199, -1.24724286131838],
            [29.97615966728472, -1.246905249317487],
            [29.97683653886814, -1.247315057079144],
            [29.9775821073163, -1.2468728089545],
            [29.97687125605894, -1.246565209701769],
            [29.979217739124376, -1.245485669399697],
            [29.979917516849227, -1.248085579452831],
            [29.98198368512186, -1.247815274936425],
            [29.983300438360267, -1.248871919869466],
            [29.987468901552944, -1.248861237845517],
            [29.990583185471507, -1.250160129070785],
            [29.991703381037546, -1.247877589760703],
            [29.99224769362439, -1.245730735665852],
            [29.991876151321172, -1.244844042947777],
            [29.99244720226245, -1.244188676254398],
            [29.996403795998766, -1.244289414725016],
            [30.00068196864046, -1.243849154493979],
            [30.002072456495686, -1.243567632227674],
            [30.003038652974276, -1.242274053629657],
            [30.00428729504952, -1.24005023097911],
            [30.00497344622983, -1.237542559255272],
            [30.00528000350705, -1.228890786243337],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 211,
        District: "KABALE",
        County: "KABALE MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 12486,
        Key: "KABALENORTHERN DIVISION",
        Dist2: "Kabale",
        "Sub Country": "Northern  Division",
        id2_original: "Kabale Northern  Division",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.016005330145667, -1.254424709168911],
            [30.01526916616022, -1.255153065467838],
            [30.01472038175987, -1.254876084307554],
            [30.012601756366262, -1.255426335651049],
            [30.010915782071343, -1.25495068047905],
            [30.009542917365344, -1.255028058063502],
            [30.005421049786445, -1.256474354864852],
            [30.003988732778307, -1.257539665654922],
            [30.001867663068797, -1.258337441417561],
            [29.998958139339457, -1.258615680446852],
            [29.99839481750291, -1.260395276490655],
            [29.99731312283164, -1.262067968995385],
            [29.986506387268726, -1.258978655932565],
            [29.98437855594006, -1.256781988879177],
            [29.981783907887497, -1.255441218060293],
            [29.98054942146448, -1.253948426042795],
            [29.978288147197016, -1.254593239423441],
            [29.970622564162824, -1.259511715014868],
            [29.96908269635729, -1.260814950439043],
            [29.968263245968586, -1.260476431313466],
            [29.966607628442084, -1.26352506419947],
            [29.968504258569446, -1.26434055667514],
            [29.969408967163442, -1.265630384695759],
            [29.971099558798905, -1.267022135155755],
            [29.97176227023852, -1.272972395464675],
            [29.971452293973318, -1.276258173808883],
            [29.972281242249505, -1.28102252281053],
            [29.973114570711033, -1.28259965503085],
            [29.97440067702519, -1.283862094744799],
            [29.978540392332153, -1.285092892351963],
            [29.980766270282487, -1.286216361452957],
            [29.98166983172789, -1.287268193127265],
            [29.982806801535222, -1.294032026862809],
            [29.98347600869265, -1.295262384878636],
            [29.98362406183124, -1.296803402560651],
            [29.982864294611726, -1.300044370844351],
            [29.983081652774484, -1.301063283815283],
            [29.984351639719197, -1.304307016314996],
            [29.98684104384805, -1.307112473700808],
            [29.98827843633752, -1.306969627542959],
            [29.989451277670785, -1.306335846801315],
            [29.990039079497176, -1.304767798171507],
            [29.992359377570388, -1.303049670820051],
            [29.99337441814589, -1.301455982552291],
            [29.99546093505631, -1.300735069231302],
            [29.99684025954754, -1.301393011627368],
            [29.998903554109564, -1.300814504742591],
            [29.999990938709846, -1.299928371611501],
            [30.001012998720967, -1.297978841346124],
            [29.99837392179109, -1.294589832620847],
            [29.99791090673744, -1.290825644314187],
            [29.994716791336216, -1.281345581306667],
            [29.99451150653084, -1.275401520115143],
            [29.99979739578357, -1.275134043836783],
            [30.00523048657197, -1.276045117535721],
            [30.007886609034376, -1.2757603593283],
            [30.009281976538233, -1.27483678138069],
            [30.011329734737423, -1.27067189180992],
            [30.011605995433364, -1.26730000503617],
            [30.011007605164753, -1.266531654540824],
            [30.00967284070488, -1.266557523292615],
            [30.008964112166552, -1.266995361128146],
            [30.0085263218061, -1.268022341391236],
            [30.007642332854125, -1.267205454432894],
            [30.007643581512355, -1.266115393382525],
            [30.008272044681757, -1.264853946347519],
            [30.011578536630083, -1.264513544439533],
            [30.01385959180013, -1.263655602574569],
            [30.01497143662728, -1.262253571585746],
            [30.01529990381427, -1.260104989666187],
            [30.01663732728739, -1.256227609258273],
            [30.016005330145667, -1.254424709168911],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 212,
        District: "KABALE",
        County: "KABALE MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 20810,
        Key: "KABALESOUTHERN DIVISION",
        Dist2: "Kabale",
        "Sub Country": "Southern Division",
        id2_original: "Kabale Southern Division",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.006961823093786, -1.311615133424275],
            [30.005629657460045, -1.315327088049175],
            [30.0041006556762, -1.318191728070533],
            [30.001266929993925, -1.320854866054442],
            [29.991303832857025, -1.321452828725061],
            [29.988378754798585, -1.320066481313517],
            [29.987121997343028, -1.320475303834175],
            [29.985744394922232, -1.320291716288885],
            [29.977351915821377, -1.3234836497913],
            [29.97654742956869, -1.324222494712007],
            [29.97533653829493, -1.324180451313187],
            [29.971614729139606, -1.325667534381739],
            [29.970380508617925, -1.325744186864803],
            [29.968452317979704, -1.32428225085024],
            [29.967686663201818, -1.322625404557933],
            [29.96440395684557, -1.320790000675808],
            [29.95933736611667, -1.321298757432094],
            [29.95766826038615, -1.319266456344524],
            [29.95361060079049, -1.316473972752259],
            [29.94822633253947, -1.311161473702025],
            [29.946428505415263, -1.309639686424821],
            [29.944478253950287, -1.308628525570636],
            [29.939254000804176, -1.308177434717829],
            [29.93312326758633, -1.308806794640183],
            [29.938124430419833, -1.314218545403319],
            [29.94246425982937, -1.326176548782923],
            [29.948880306964615, -1.337876428482871],
            [29.951360649787173, -1.344375932242925],
            [29.9534857700003, -1.34780558780714],
            [29.9522968335521, -1.35390630653665],
            [29.952163478648153, -1.356444680008663],
            [29.95077038028869, -1.361894028307348],
            [29.95042121052766, -1.367172732974966],
            [29.952199359157255, -1.369765898296752],
            [29.952872963568005, -1.372344249147929],
            [29.952267178367926, -1.375572509052437],
            [29.950471252078874, -1.381260762784344],
            [29.948807573071022, -1.384078607511281],
            [29.948952862991806, -1.384884363149579],
            [29.954064411705744, -1.390328881542436],
            [29.9600394992242, -1.394927669578572],
            [29.96024201901511, -1.395788785322322],
            [29.960958880001726, -1.396453434691983],
            [29.970806193281632, -1.401746857872044],
            [29.971586765483128, -1.40429313969648],
            [29.972918410094014, -1.404903977580014],
            [29.974131996313623, -1.406039061592919],
            [29.974985266476125, -1.406502757105737],
            [29.980931827992723, -1.406725103965351],
            [29.981527637401566, -1.406932640254497],
            [29.982181150092668, -1.408417031848017],
            [29.985564308758907, -1.40633395075228],
            [29.987753414173092, -1.406149749205233],
            [29.990296835796602, -1.403409743864712],
            [29.990897454785443, -1.402018085847653],
            [29.988504703092964, -1.399161093316964],
            [29.988967221378257, -1.395383008251158],
            [29.989993958917093, -1.39133392592277],
            [29.99076929843206, -1.390228847659527],
            [29.99275111669614, -1.389810766332066],
            [29.99382096438542, -1.388378910662892],
            [29.99274364630621, -1.386563529269493],
            [29.99081022477809, -1.38450291515524],
            [29.989657103261948, -1.383990515675932],
            [29.991527392988548, -1.379582980407117],
            [29.991335298146492, -1.377756788676302],
            [29.992145477921458, -1.377562179125968],
            [29.993696342902687, -1.380922593244972],
            [29.99534890166567, -1.380696449669047],
            [29.99570576549711, -1.380305627107652],
            [29.99548196551543, -1.377925080693976],
            [29.99797633014128, -1.378123879643296],
            [29.99959298593727, -1.380701837995849],
            [30.000628404794995, -1.381746558899221],
            [30.001761793917638, -1.382171881761069],
            [30.00208401332184, -1.383574371245575],
            [30.004933099297165, -1.385110500040125],
            [30.004253705244416, -1.387868472469386],
            [30.004122208954797, -1.39088846951455],
            [30.006149161273676, -1.403678585540119],
            [30.007801688595627, -1.409592544067247],
            [30.010156694876496, -1.415378910945618],
            [30.012321954511457, -1.419751348207855],
            [30.012797945729346, -1.419751966059024],
            [30.01380879656239, -1.416672714955617],
            [30.021708063741332, -1.413436809816248],
            [30.019743156262475, -1.410987567922208],
            [30.0186619592579, -1.408597764072715],
            [30.017938216277887, -1.404577266900593],
            [30.01691984295265, -1.401985097012647],
            [30.016856313197458, -1.398833558326506],
            [30.01708386813704, -1.396091024503899],
            [30.018503229642135, -1.392916557881054],
            [30.022072898324314, -1.377341274487903],
            [30.021825107934646, -1.376721404905477],
            [30.022443540515592, -1.374092751421948],
            [30.026489026142492, -1.367128941794516],
            [30.027078147594047, -1.366877764397849],
            [30.026399247614673, -1.363372326931961],
            [30.026604262925446, -1.358350587447917],
            [30.026239086084374, -1.353791134252906],
            [30.025083979291438, -1.350692036388851],
            [30.02418408566739, -1.349239867337549],
            [30.02276564224049, -1.347940614833268],
            [30.02252198769439, -1.346673626495065],
            [30.02149323074281, -1.345451824668775],
            [30.02073102908886, -1.342390576972189],
            [30.01405173874445, -1.32821463408929],
            [30.01355971888692, -1.326412180212879],
            [30.010843911458736, -1.322379258093708],
            [30.00990732255361, -1.317916360415018],
            [30.006961823093786, -1.311615133424275],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 213,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "KAMUGANGUZI",
        Population: 20690,
        Key: "KABALEKAMUGANGUZI",
        Dist2: "Kabale",
        "Sub Country": "Kamuganguzi",
        id2_original: "Kabale Kamuganguzi",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.169386524924082, -1.27451741322826],
            [30.17507454411542, -1.271556206577067],
            [30.17646170820412, -1.27120909409258],
            [30.187460295165614, -1.270660339621877],
            [30.18773635643556, -1.273596573121518],
            [30.188858875943257, -1.277511932993506],
            [30.190736468973096, -1.281486113630261],
            [30.197764381106236, -1.280693552141343],
            [30.197529371048113, -1.273573011642036],
            [30.203859933602594, -1.272440345014881],
            [30.20506127039499, -1.272725768178649],
            [30.210761217416653, -1.276220267123134],
            [30.212950463866346, -1.270683673910081],
            [30.219295941149504, -1.264949811849645],
            [30.22043876348089, -1.261182594828095],
            [30.221116112968076, -1.260256160218063],
            [30.22433519704262, -1.25780442520396],
            [30.22633726782476, -1.255334571419666],
            [30.22796273070383, -1.254917812720006],
            [30.228162286952607, -1.254327503314324],
            [30.230517497151023, -1.253547325501048],
            [30.232287611248704, -1.251224192273725],
            [30.23309922832812, -1.249049474608119],
            [30.234932406853705, -1.246589091150092],
            [30.237179404196365, -1.244977975288703],
            [30.238440863434096, -1.243449339393788],
            [30.239817803796562, -1.24357056633249],
            [30.241483576777345, -1.241707689337657],
            [30.24271957506498, -1.241039734930507],
            [30.244661065260996, -1.23782630677042],
            [30.24569151104529, -1.233021785645647],
            [30.24713282647762, -1.230572826495164],
            [30.25057341623663, -1.227678177606333],
            [30.252689432024372, -1.225193767851857],
            [30.25361792531211, -1.222541319268439],
            [30.253357357285868, -1.221656829971394],
            [30.254070893607626, -1.220462211725278],
            [30.25592497862479, -1.218766355757103],
            [30.256459398065427, -1.218778627560243],
            [30.25919229953518, -1.21713109617534],
            [30.2612604324233, -1.215100723267233],
            [30.26292388685235, -1.214145676622173],
            [30.26370770107373, -1.214170043342065],
            [30.26461109812743, -1.213190631435975],
            [30.267545765701556, -1.211722444705835],
            [30.269731243718628, -1.211460822171967],
            [30.270349290922283, -1.210863648719154],
            [30.272272547114685, -1.211820835831006],
            [30.272985159069993, -1.211773454908968],
            [30.274767811852396, -1.210292617462705],
            [30.2757483454429, -1.21016297727178],
            [30.27756210957858, -1.206784502155624],
            [30.277316974608894, -1.20527368196134],
            [30.277959434428748, -1.202992620386144],
            [30.278094926424725, -1.198635329054047],
            [30.27867294829261, -1.197985643369238],
            [30.281500649872587, -1.196577079082187],
            [30.28318702571444, -1.19672145446486],
            [30.28602664344668, -1.195253127738065],
            [30.28962466565414, -1.192409038543408],
            [30.29086869038884, -1.190287152902311],
            [30.29225515109668, -1.189628752566112],
            [30.291241819116824, -1.186093620409625],
            [30.29329340234249, -1.180898349610745],
            [30.29278074728456, -1.179234082219428],
            [30.29299973858454, -1.177665387863392],
            [30.294452588385106, -1.175997971506599],
            [30.294922563585565, -1.173681069331676],
            [30.296313823093634, -1.172249698213649],
            [30.296146927791956, -1.171177329551204],
            [30.296783551257395, -1.168250148691979],
            [30.297346635040412, -1.167761157168459],
            [30.29693886817338, -1.16627557464716],
            [30.297463167194024, -1.164677188050408],
            [30.29727496475212, -1.16219129867521],
            [30.298033821079947, -1.161081320542714],
            [30.297280579222644, -1.159474212843524],
            [30.298793048411977, -1.15772982387572],
            [30.2989951504863, -1.155881708515413],
            [30.297745735859912, -1.156166278187626],
            [30.25720235960261, -1.156686001313264],
            [30.250560712261876, -1.164587009540562],
            [30.248328769785076, -1.164608361676558],
            [30.246285857996824, -1.165108100766273],
            [30.234928587217112, -1.175411738512896],
            [30.233169500837864, -1.176485606319828],
            [30.227922797894493, -1.18234911936007],
            [30.224821547632377, -1.183768057056093],
            [30.22175722890823, -1.184505622073019],
            [30.220710911689483, -1.185341203554664],
            [30.219160855192012, -1.188830053756949],
            [30.215662070772265, -1.193225111354289],
            [30.213546690991773, -1.194370207551808],
            [30.212905814003477, -1.194273808725931],
            [30.211194815339688, -1.195036852392799],
            [30.206279146968406, -1.195461342441523],
            [30.200071826982683, -1.194700816322931],
            [30.196370732977822, -1.193261894776721],
            [30.19111857276908, -1.189729164362042],
            [30.19010083994268, -1.188078282498343],
            [30.188962772394056, -1.181155523056168],
            [30.187055308584394, -1.173048412564868],
            [30.18716786299792, -1.170095889386051],
            [30.188903037122632, -1.162913536501328],
            [30.19336164267733, -1.153140297880457],
            [30.193054760209996, -1.152207517980776],
            [30.19232696492971, -1.152040027726099],
            [30.19148846037554, -1.151847078063931],
            [30.187331340209944, -1.152989838086273],
            [30.180877949210032, -1.15681955267523],
            [30.170033217605553, -1.160165895146708],
            [30.16656706359021, -1.160066186423021],
            [30.163446725924942, -1.159165966962179],
            [30.159195840508307, -1.159734747264359],
            [30.15667723125129, -1.16075980315553],
            [30.15200834985148, -1.162631023327693],
            [30.150508349278265, -1.164828740247508],
            [30.149367935330126, -1.165257715674834],
            [30.14567552264415, -1.165552164725307],
            [30.144629825262975, -1.166100794211416],
            [30.144010276076134, -1.167271509925771],
            [30.143625387502745, -1.169853022101775],
            [30.14407359023566, -1.171335806859474],
            [30.144983331191895, -1.173548294750715],
            [30.147304620106876, -1.176324339724159],
            [30.147833415195485, -1.179086256224632],
            [30.147282035562313, -1.181811029855259],
            [30.14443593648528, -1.18638582464991],
            [30.14376676166722, -1.188632280118281],
            [30.143847000086723, -1.190087692695865],
            [30.145600197110973, -1.191969573653794],
            [30.14910934180087, -1.194340651316857],
            [30.15101636543605, -1.196482671464562],
            [30.15821142350083, -1.207919169143558],
            [30.158609473291456, -1.210740750702796],
            [30.1591061320491, -1.211721548387646],
            [30.160325144093015, -1.213599802224907],
            [30.1631924290377, -1.216400494046904],
            [30.165052538157163, -1.224244493350677],
            [30.16459858081655, -1.225678387017161],
            [30.16379279380332, -1.226240071080859],
            [30.161477007069433, -1.231364530224502],
            [30.16353053245275, -1.237415701815199],
            [30.163705190995113, -1.239125314793051],
            [30.165053841612654, -1.241469942248979],
            [30.165051060428507, -1.242856574690307],
            [30.163248793830178, -1.247695617177711],
            [30.16322067296854, -1.249871173892849],
            [30.164415566145383, -1.252614219785236],
            [30.164283487747475, -1.25433270510967],
            [30.163965287405848, -1.255991929111791],
            [30.16200755477118, -1.260319027076404],
            [30.161829513173444, -1.264159600087757],
            [30.163238866547985, -1.266950219247649],
            [30.16786670841403, -1.271819945359571],
            [30.169386524924082, -1.27451741322826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 214,
        District: "RUKIGA",
        County: "RUKIGA",
        Subcounty: "KAMWEZI",
        Population: 26538,
        Key: "RUKIGAKAMWEZI",
        Dist2: "Kabale",
        "Sub Country": "Kamwezi",
        id2_original: "Kabale Kamwezi",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.970622564162824, -1.259511715014868],
            [29.970633485880033, -1.256445949780385],
            [29.97017271391967, -1.253791618648827],
            [29.96936761950754, -1.252664860984062],
            [29.96756928214025, -1.251826501006607],
            [29.966669150462636, -1.250074927082487],
            [29.964956572560578, -1.251865374405001],
            [29.96170971167911, -1.252696444487596],
            [29.955411943920733, -1.252913862057072],
            [29.953492004308384, -1.252417134292285],
            [29.9523303523903, -1.25277540189754],
            [29.94929122512166, -1.254547489314239],
            [29.94718988690736, -1.256433046787711],
            [29.94598339288693, -1.256948587170524],
            [29.94528936078662, -1.256845647944752],
            [29.94235567507109, -1.258411550720773],
            [29.94190192613963, -1.260915772691682],
            [29.93993121734069, -1.260806052984187],
            [29.939536145465237, -1.263132132424619],
            [29.940397572330546, -1.265001944546953],
            [29.938256975941698, -1.263873127900321],
            [29.93595417794854, -1.263836034708558],
            [29.93581409017154, -1.264477035019708],
            [29.93777573766419, -1.265357626600049],
            [29.93811325986929, -1.266779149080186],
            [29.93631487129803, -1.268352572808483],
            [29.93224044105433, -1.270718870228456],
            [29.930131372837042, -1.274985562145497],
            [29.92149915225148, -1.283894391848938],
            [29.917107057960383, -1.292413876214416],
            [29.92241498558193, -1.299334773880533],
            [29.93312326758633, -1.308806794640183],
            [29.939254000804176, -1.308177434717829],
            [29.944478253950287, -1.308628525570636],
            [29.946428505415263, -1.309639686424821],
            [29.94822633253947, -1.311161473702025],
            [29.95361060079049, -1.316473972752259],
            [29.95766826038615, -1.319266456344524],
            [29.95933736611667, -1.321298757432094],
            [29.96440395684557, -1.320790000675808],
            [29.967686663201818, -1.322625404557933],
            [29.968452317979704, -1.32428225085024],
            [29.970380508617925, -1.325744186864803],
            [29.971614729139606, -1.325667534381739],
            [29.97533653829493, -1.324180451313187],
            [29.97654742956869, -1.324222494712007],
            [29.977351915821377, -1.3234836497913],
            [29.985744394922232, -1.320291716288885],
            [29.987121997343028, -1.320475303834175],
            [29.988378754798585, -1.320066481313517],
            [29.991303832857025, -1.321452828725061],
            [30.001266929993925, -1.320854866054442],
            [30.0041006556762, -1.318191728070533],
            [30.005629657460045, -1.315327088049175],
            [30.006961823093786, -1.311615133424275],
            [30.007656775967256, -1.310423159266034],
            [30.008635174262317, -1.310539092454938],
            [30.01522558080095, -1.312390691769562],
            [30.017826176598994, -1.312568470219857],
            [30.022015807693045, -1.313623956875906],
            [30.023770857043402, -1.314783633697623],
            [30.026730142049587, -1.315750479078097],
            [30.028371646144688, -1.314982363255864],
            [30.029645450929365, -1.312651374638186],
            [30.031272343028014, -1.311981677530581],
            [30.033788662479402, -1.305645395126704],
            [30.02544083054648, -1.299405566272803],
            [30.02067583390287, -1.294254236725276],
            [30.014238148149047, -1.281598778196057],
            [30.012570421332505, -1.27507186437921],
            [30.012154809478123, -1.274609474050035],
            [30.011379705321726, -1.274592483028339],
            [30.009417542196072, -1.275385265534708],
            [30.009281976538233, -1.27483678138069],
            [30.007886609034376, -1.2757603593283],
            [30.00523048657197, -1.276045117535721],
            [29.99979739578357, -1.275134043836783],
            [29.99451150653084, -1.275401520115143],
            [29.994716791336216, -1.281345581306667],
            [29.99791090673744, -1.290825644314187],
            [29.99837392179109, -1.294589832620847],
            [30.001012998720967, -1.297978841346124],
            [29.999990938709846, -1.299928371611501],
            [29.998903554109564, -1.300814504742591],
            [29.99684025954754, -1.301393011627368],
            [29.99546093505631, -1.300735069231302],
            [29.99337441814589, -1.301455982552291],
            [29.992359377570388, -1.303049670820051],
            [29.990039079497176, -1.304767798171507],
            [29.989451277670785, -1.306335846801315],
            [29.98827843633752, -1.306969627542959],
            [29.98684104384805, -1.307112473700808],
            [29.984351639719197, -1.304307016314996],
            [29.983081652774484, -1.301063283815283],
            [29.982864294611726, -1.300044370844351],
            [29.98362406183124, -1.296803402560651],
            [29.98347600869265, -1.295262384878636],
            [29.982806801535222, -1.294032026862809],
            [29.98166983172789, -1.287268193127265],
            [29.980766270282487, -1.286216361452957],
            [29.978540392332153, -1.285092892351963],
            [29.97440067702519, -1.283862094744799],
            [29.973114570711033, -1.28259965503085],
            [29.972281242249505, -1.28102252281053],
            [29.971452293973318, -1.276258173808883],
            [29.97176227023852, -1.272972395464675],
            [29.971099558798905, -1.267022135155755],
            [29.969408967163442, -1.265630384695759],
            [29.968504258569446, -1.26434055667514],
            [29.966607628442084, -1.26352506419947],
            [29.968263245968586, -1.260476431313466],
            [29.96908269635729, -1.260814950439043],
            [29.970622564162824, -1.259511715014868],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 215,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "KITUMBA",
        Population: 18932,
        Key: "KABALEKITUMBA",
        Dist2: "Kabale",
        "Sub Country": "Kitumba",
        id2_original: "Kabale Kitumba",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.023946688785543, -1.202034259919844],
            [30.02252218891701, -1.201853113186352],
            [30.019890355103264, -1.200248180049394],
            [30.014315819183484, -1.192292898055718],
            [30.011945467880928, -1.190520977912504],
            [30.010284764093296, -1.19001689467445],
            [30.005628728602044, -1.191612606499072],
            [30.005570184496673, -1.19610659919887],
            [30.00886826192572, -1.197903537335457],
            [30.011781600800067, -1.201158209826684],
            [30.012170853389083, -1.202365877249937],
            [30.013159513139655, -1.203128774963104],
            [30.011805581326577, -1.206907245875092],
            [30.012050072204207, -1.209262145406988],
            [30.01152086928041, -1.212679789582253],
            [30.00952724086533, -1.218282796913374],
            [30.008908511840335, -1.219023032578784],
            [30.006390567336634, -1.219808628071143],
            [30.00435420786009, -1.223068934163234],
            [30.00392252155197, -1.225219751069534],
            [30.00528000350705, -1.228890786243337],
            [30.009314208090622, -1.238179987937782],
            [30.009580208229416, -1.244220419722138],
            [30.010234166484913, -1.244852632407426],
            [30.01977935836844, -1.246730460590198],
            [30.02084133591755, -1.247625109859762],
            [30.021239319232823, -1.248593571134383],
            [30.020147111577757, -1.24968845153305],
            [30.019598542773103, -1.250930767363325],
            [30.018147224600096, -1.252482666003928],
            [30.018308047290457, -1.252712965945898],
            [30.017624180525903, -1.25274661418205],
            [30.016005330145667, -1.254424709168911],
            [30.01663732728739, -1.256227609258273],
            [30.01529990381427, -1.260104989666187],
            [30.01497143662728, -1.262253571585746],
            [30.01385959180013, -1.263655602574569],
            [30.011578536630083, -1.264513544439533],
            [30.008272044681757, -1.264853946347519],
            [30.007643581512355, -1.266115393382525],
            [30.007642332854125, -1.267205454432894],
            [30.0085263218061, -1.268022341391236],
            [30.008964112166552, -1.266995361128146],
            [30.00967284070488, -1.266557523292615],
            [30.011007605164753, -1.266531654540824],
            [30.011605995433364, -1.26730000503617],
            [30.011329734737423, -1.27067189180992],
            [30.009281976538233, -1.27483678138069],
            [30.009417542196072, -1.275385265534708],
            [30.011379705321726, -1.274592483028339],
            [30.012154809478123, -1.274609474050035],
            [30.012570421332505, -1.27507186437921],
            [30.014238148149047, -1.281598778196057],
            [30.02067583390287, -1.294254236725276],
            [30.02544083054648, -1.299405566272803],
            [30.033788662479402, -1.305645395126704],
            [30.03660810135541, -1.304450522714772],
            [30.037131556858, -1.303490292743612],
            [30.037456874551598, -1.300733963690159],
            [30.036847580532054, -1.297566424613898],
            [30.037099715174417, -1.297511010976901],
            [30.038856443476057, -1.298417422808746],
            [30.04156918315755, -1.30295682969409],
            [30.049902283618135, -1.310146409506284],
            [30.0517178470793, -1.31060283999014],
            [30.053173848169912, -1.310410860055697],
            [30.059019143502837, -1.308503462401629],
            [30.06452442380583, -1.307270172322002],
            [30.067275409260546, -1.305816409701706],
            [30.069650538702064, -1.306274733231708],
            [30.0707068335087, -1.30734758514762],
            [30.07335836468167, -1.31273106123486],
            [30.076682285743146, -1.315767300087026],
            [30.079509527385714, -1.319520666053083],
            [30.080379704740217, -1.319466098889674],
            [30.081496260332713, -1.31847812678091],
            [30.085855146602675, -1.317254376514833],
            [30.090498865293057, -1.315047892465901],
            [30.09439304677836, -1.314217039324866],
            [30.09538227695913, -1.312644648920471],
            [30.098762357997213, -1.311263311490491],
            [30.098739398855194, -1.310475343121955],
            [30.099160850657242, -1.310195399793951],
            [30.09846911195585, -1.308983065467144],
            [30.099534910938182, -1.308564620821056],
            [30.100049950124873, -1.306765489101025],
            [30.101849774203924, -1.305308381730742],
            [30.10189951931113, -1.304084508275195],
            [30.100671558250326, -1.303601966645899],
            [30.10083353527583, -1.303170154037428],
            [30.10011337028562, -1.302958058271673],
            [30.095417533139077, -1.303847389308437],
            [30.09429832931311, -1.304772714274393],
            [30.091209610549235, -1.306239272470448],
            [30.088438602545136, -1.30617026116654],
            [30.085063009490185, -1.304324291830508],
            [30.083248578804593, -1.304510316147538],
            [30.078858034107384, -1.300419834611527],
            [30.078247081797798, -1.299290712068097],
            [30.07660093790429, -1.298581644762474],
            [30.073533950285434, -1.294730313921251],
            [30.07047247023759, -1.29221558852977],
            [30.068639983414773, -1.290014586018412],
            [30.067245315698514, -1.287153820646865],
            [30.064166907797464, -1.283736373848953],
            [30.0615255159091, -1.278116151255575],
            [30.059165227534365, -1.275322485259114],
            [30.055894083394154, -1.26616660101758],
            [30.056571908988403, -1.26294711366005],
            [30.05667453971299, -1.259992985163021],
            [30.05657990848602, -1.257263321499845],
            [30.05559751987445, -1.253348844430332],
            [30.055296569881218, -1.252630510432208],
            [30.05227476392791, -1.250476204183404],
            [30.05271593015719, -1.248307527431173],
            [30.052485787171303, -1.24591087086613],
            [30.053665600329474, -1.243663961032978],
            [30.054069761358956, -1.239981192756517],
            [30.053838515241875, -1.238117068459589],
            [30.052989265040285, -1.236755078463181],
            [30.04957124994437, -1.234398697804625],
            [30.04945486870774, -1.233836448752694],
            [30.05316310791238, -1.23073483172029],
            [30.053813732519817, -1.228635156662745],
            [30.053375860412693, -1.227244115167969],
            [30.052436759818015, -1.226710385868343],
            [30.04894154350661, -1.226202969276599],
            [30.043858537862516, -1.226314806368615],
            [30.04461144824149, -1.217233366949912],
            [30.044305684176646, -1.209826671833215],
            [30.04229579984818, -1.207954400424444],
            [30.03737625883971, -1.204756863447547],
            [30.02941592508605, -1.203448780403822],
            [30.02734827099995, -1.205632023249628],
            [30.027063838329884, -1.204752942270019],
            [30.023946688785543, -1.202034259919844],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 216,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "KYANAMIRA",
        Population: 19931,
        Key: "KABALEKYANAMIRA",
        Dist2: "Kabale",
        "Sub Country": "Kyanamira",
        id2_original: "Kabale Kyanamira",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.16379279380332, -1.226240071080859],
            [30.162214203219143, -1.224802820579704],
            [30.16062431003208, -1.224370503601328],
            [30.15728840185147, -1.224426160387043],
            [30.155483371137006, -1.224734728569878],
            [30.150943354861358, -1.227358912384325],
            [30.14758219863136, -1.228179549645267],
            [30.14475646346349, -1.228391183612259],
            [30.144232798653476, -1.229059936922692],
            [30.14411108322068, -1.230565948783314],
            [30.144295252226982, -1.239375972353596],
            [30.143114609025453, -1.242064051725613],
            [30.143135039409973, -1.24371367196882],
            [30.141465242875025, -1.247608438386325],
            [30.140556596066816, -1.250810849297189],
            [30.14046160102213, -1.2526231154718],
            [30.139004895652356, -1.254346751394017],
            [30.135310439299115, -1.254559509483949],
            [30.135627389185885, -1.257543382886354],
            [30.13777110272876, -1.261447914419902],
            [30.138722662956408, -1.265840934343911],
            [30.13779219068006, -1.269200512832024],
            [30.129808604035265, -1.277404528373279],
            [30.127038655144915, -1.277423318254736],
            [30.123301240456474, -1.275581662243532],
            [30.11898736696874, -1.274202366660457],
            [30.1126547077464, -1.273519735844653],
            [30.102790079439373, -1.273922586380078],
            [30.098027810080975, -1.274891374653155],
            [30.09410215971295, -1.276285024976327],
            [30.08891937280036, -1.279601913460283],
            [30.08855015623543, -1.280472966641646],
            [30.090518487193822, -1.283321635938751],
            [30.091037938006853, -1.285062582734688],
            [30.093025138976113, -1.287311764792077],
            [30.094001298669472, -1.287793436582567],
            [30.09451982960768, -1.289849315441654],
            [30.097231069102662, -1.292461363449348],
            [30.09694131391449, -1.294036152670753],
            [30.099308253415604, -1.297997709209274],
            [30.099454870148065, -1.30134671541888],
            [30.100987355598583, -1.302336802086317],
            [30.10083353527583, -1.303170154037428],
            [30.100671558250326, -1.303601966645899],
            [30.10189951931113, -1.304084508275195],
            [30.101849774203924, -1.305308381730742],
            [30.100049950124873, -1.306765489101025],
            [30.099534910938182, -1.308564620821056],
            [30.09846911195585, -1.308983065467144],
            [30.099160850657242, -1.310195399793951],
            [30.098739398855194, -1.310475343121955],
            [30.098762357997213, -1.311263311490491],
            [30.09538227695913, -1.312644648920471],
            [30.09439304677836, -1.314217039324866],
            [30.090498865293057, -1.315047892465901],
            [30.085855146602675, -1.317254376514833],
            [30.081496260332713, -1.31847812678091],
            [30.080379704740217, -1.319466098889674],
            [30.08218367993419, -1.321751493883548],
            [30.085276197673423, -1.323788061490671],
            [30.08618813141727, -1.325563907319268],
            [30.08788379044926, -1.327286173662595],
            [30.088482955065665, -1.329848847886145],
            [30.089863858795123, -1.33266745120819],
            [30.08984188510496, -1.33391954418883],
            [30.092160362293125, -1.338879912381758],
            [30.09299057719385, -1.342498594881941],
            [30.094151250846593, -1.344753691950014],
            [30.094227627408685, -1.3459357743997],
            [30.096289033711972, -1.349530574049663],
            [30.09815543732663, -1.350803234879201],
            [30.09892926318036, -1.352297272587172],
            [30.09821984832915, -1.360412878326907],
            [30.09900200605712, -1.362793312825462],
            [30.098623341012054, -1.365127537074053],
            [30.098605692709977, -1.376608116938188],
            [30.103323715549077, -1.372481109532614],
            [30.104553295374007, -1.372710477914174],
            [30.10951570578446, -1.375485296997403],
            [30.111191694406674, -1.375913177744199],
            [30.112624546810718, -1.377170341246901],
            [30.11439224893186, -1.380750144345266],
            [30.1187556222867, -1.385323854924743],
            [30.119258882763372, -1.385381873620007],
            [30.121453465205825, -1.383476016437039],
            [30.123325142829547, -1.383932725052118],
            [30.12383254004809, -1.383343549961657],
            [30.124951624398122, -1.376804997749871],
            [30.125394342916252, -1.371023865203166],
            [30.127626610583206, -1.367598546977255],
            [30.1280101247342, -1.364504518423235],
            [30.1290091959589, -1.363593426839659],
            [30.13267653936021, -1.363268385352465],
            [30.136909772881506, -1.361960385174544],
            [30.137838630885305, -1.361091249179331],
            [30.138462612359724, -1.35977082312798],
            [30.138790304300652, -1.356648427270526],
            [30.139595504714002, -1.355427105536684],
            [30.144997390724395, -1.350746273269041],
            [30.152393023727495, -1.35151733436382],
            [30.16982243151739, -1.345231260150344],
            [30.16243135117615, -1.33492071088387],
            [30.16458959317212, -1.327710032345609],
            [30.161896948803523, -1.317725097708777],
            [30.164645462094597, -1.3144841899671],
            [30.16555165740039, -1.312770693483553],
            [30.16702971302951, -1.306908402626641],
            [30.167653064784968, -1.30567233758817],
            [30.17439432271428, -1.301530271124184],
            [30.173323976460015, -1.300443242270642],
            [30.170945584337336, -1.282734773598083],
            [30.170931442159834, -1.280539734315092],
            [30.169386524924082, -1.27451741322826],
            [30.16786670841403, -1.271819945359571],
            [30.163238866547985, -1.266950219247649],
            [30.161829513173444, -1.264159600087757],
            [30.16200755477118, -1.260319027076404],
            [30.163965287405848, -1.255991929111791],
            [30.164283487747475, -1.25433270510967],
            [30.164415566145383, -1.252614219785236],
            [30.16322067296854, -1.249871173892849],
            [30.163248793830178, -1.247695617177711],
            [30.165051060428507, -1.242856574690307],
            [30.165053841612654, -1.241469942248979],
            [30.163705190995113, -1.239125314793051],
            [30.16353053245275, -1.237415701815199],
            [30.161477007069433, -1.231364530224502],
            [30.16379279380332, -1.226240071080859],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 217,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "MAZIBA",
        Population: 21072,
        Key: "KABALEMAZIBA",
        Dist2: "Kabale",
        "Sub Country": "Maziba",
        id2_original: "Kabale Maziba",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.10186907989771, -1.186827209716649],
            [30.099815318257487, -1.185793683300299],
            [30.09524016887106, -1.182345595121404],
            [30.088397885506563, -1.178858894056133],
            [30.084654474563603, -1.175005464782971],
            [30.076841133936526, -1.170394054382774],
            [30.075977058837776, -1.169564276615478],
            [30.073872506451394, -1.16492799434943],
            [30.07538429202283, -1.162742453459601],
            [30.075625019857714, -1.161045429437852],
            [30.074346898668118, -1.159083622677262],
            [30.072850214674926, -1.153571545559355],
            [30.07244985172247, -1.151921571073474],
            [30.072716270476178, -1.149220550229964],
            [30.074913042112986, -1.148804835133049],
            [30.076577405637092, -1.147492011552407],
            [30.078149911931835, -1.144577381038868],
            [30.0781480748771, -1.139425685120939],
            [30.079737135325885, -1.13408460732114],
            [30.079145155435135, -1.133295018810133],
            [30.07848063748349, -1.133198607119057],
            [30.07705295039233, -1.128762394995579],
            [30.07768056375548, -1.123384330912144],
            [30.079133568964604, -1.120852020284651],
            [30.082679105304955, -1.116257933261257],
            [30.082737659291826, -1.110767923713464],
            [30.084158475169364, -1.106430645448826],
            [30.084260644159908, -1.102653619016732],
            [30.082785461343036, -1.098169563970818],
            [30.08096164505934, -1.095992026550584],
            [30.079010602178627, -1.092057275896906],
            [30.07789684483822, -1.091245868099517],
            [30.074876795091274, -1.087450667225824],
            [30.07226456611028, -1.081650544492196],
            [30.071671403138282, -1.075207287135506],
            [30.069848984633165, -1.072288737672968],
            [30.064787090296587, -1.068876447721779],
            [30.05699137012381, -1.067516981428539],
            [30.05587641802407, -1.067109322133035],
            [30.05348235838455, -1.065218094962683],
            [30.051649851798828, -1.067654377354809],
            [30.051230722141746, -1.06962609691342],
            [30.049874248994747, -1.071393528223533],
            [30.048699202297477, -1.077655338210543],
            [30.047424067107865, -1.080343229900506],
            [30.045328869776824, -1.083591918936639],
            [30.042772339936732, -1.08601533228124],
            [30.042623465737957, -1.089385784107688],
            [30.041402226770437, -1.096986843514307],
            [30.039010786618288, -1.104059248713792],
            [30.03946785392643, -1.107083770369586],
            [30.040365666153974, -1.109307984455687],
            [30.04077025478154, -1.116058974420848],
            [30.03931724148757, -1.117470313536655],
            [30.03623488549084, -1.12168586817415],
            [30.035733856429314, -1.122976147515356],
            [30.034377910593378, -1.124432717338555],
            [30.02970938672308, -1.126399308814691],
            [30.02951504429619, -1.128670030177269],
            [30.028872293422182, -1.1296015378578],
            [30.027161358538788, -1.130483964559901],
            [30.017720491602475, -1.133410049828594],
            [30.016236605907128, -1.133028625214832],
            [30.015620711965173, -1.132358546499814],
            [30.01056923539094, -1.129890312533919],
            [30.009313608016033, -1.128597959750447],
            [30.00823610578218, -1.127269980715156],
            [30.007482708516317, -1.124089789523631],
            [30.006867461361377, -1.123085085043487],
            [30.006798725869103, -1.121818073045663],
            [30.00573475675502, -1.119641512239858],
            [30.004407469871587, -1.11858814748075],
            [30.001442520089245, -1.117389388027485],
            [30.000053612370575, -1.117359950444498],
            [29.996411313999374, -1.115550687252523],
            [29.992421971281075, -1.114810276162588],
            [29.989037759789305, -1.114606761831269],
            [29.98580695988681, -1.115393301703578],
            [29.983504817663796, -1.115499413949076],
            [29.983725345981217, -1.118839988870048],
            [29.98306912037798, -1.122912229389719],
            [29.98535291451131, -1.124698665344712],
            [29.986230610764718, -1.125748526048066],
            [29.98682281343765, -1.127299286171579],
            [29.988156170237474, -1.134761431559576],
            [29.988375467862937, -1.140975921492054],
            [29.992409993145078, -1.143958883176381],
            [29.996846586382066, -1.146089589365898],
            [30.000715663548455, -1.147392080545125],
            [30.002745485984658, -1.148725083463194],
            [30.00735218330556, -1.153501598943415],
            [30.01247701181432, -1.156266148712338],
            [30.015486158708665, -1.158996019830026],
            [30.015894630753184, -1.16250992571592],
            [30.0155835028478, -1.163776471596767],
            [30.015985215069833, -1.1647092396047],
            [30.01558049528822, -1.165282457346526],
            [30.015599050888735, -1.167888060956348],
            [30.02021334346535, -1.175328090624337],
            [30.023756395963964, -1.178308601945327],
            [30.025008915167977, -1.18113090007727],
            [30.027767119484345, -1.18485153874004],
            [30.02864898751394, -1.189024007669214],
            [30.03020863442536, -1.192587786122396],
            [30.02978148640609, -1.198408046631617],
            [30.028279311011566, -1.201681110177306],
            [30.0265334352569, -1.202192856706046],
            [30.023946688785543, -1.202034259919844],
            [30.027063838329884, -1.204752942270019],
            [30.02734827099995, -1.205632023249628],
            [30.02941592508605, -1.203448780403822],
            [30.03737625883971, -1.204756863447547],
            [30.04229579984818, -1.207954400424444],
            [30.044305684176646, -1.209826671833215],
            [30.04683572449566, -1.211055850643745],
            [30.051274272466735, -1.211467846325362],
            [30.054458222532205, -1.210085367568194],
            [30.059118913991572, -1.206093956814938],
            [30.063526885106974, -1.206405233116385],
            [30.06699704830346, -1.208093099114826],
            [30.076724137353924, -1.211332565133312],
            [30.078773107380425, -1.213618139911961],
            [30.080777622478468, -1.217353555963733],
            [30.08377312037038, -1.21742556303294],
            [30.089813874736095, -1.218879372379965],
            [30.093512604375125, -1.221298529424802],
            [30.102236642664213, -1.221703941286508],
            [30.10297146636323, -1.222278620050997],
            [30.105678401131378, -1.222066852680685],
            [30.107220943221503, -1.222379552444764],
            [30.108468987917078, -1.223465546071048],
            [30.1087905551444, -1.221042755422063],
            [30.107677361946, -1.213785775536634],
            [30.10503631680732, -1.210734416299627],
            [30.103947607192016, -1.209035723366724],
            [30.1037364060822, -1.207792321979135],
            [30.106893537843153, -1.20204674914316],
            [30.107030740231465, -1.198711959236254],
            [30.106034226510374, -1.192411412276557],
            [30.104638284983032, -1.189995143967089],
            [30.103879238212354, -1.189659541074522],
            [30.102839273879283, -1.187315445268938],
            [30.10186907989771, -1.186827209716649],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 218,
        District: "RUKIGA",
        County: "RUKIGA",
        Subcounty: "RWAMUCUCU",
        Population: 26514,
        Key: "RUKIGARWAMUCUCU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.794716084889004, -1.144660111043322],
            [29.793888131047805, -1.144205950565865],
            [29.7910856299065, -1.14463440728842],
            [29.78982888233242, -1.14298825550186],
            [29.78942525669887, -1.142940443202555],
            [29.788237724317444, -1.143154711633344],
            [29.787453347750706, -1.143846167974152],
            [29.787072357865654, -1.144823941826412],
            [29.786264667322353, -1.145109904712196],
            [29.785054185680377, -1.144608637071234],
            [29.783748014596014, -1.14475132214357],
            [29.783036469839253, -1.143987867828954],
            [29.781623686696964, -1.143903925321183],
            [29.780745673338245, -1.143378937686697],
            [29.778679634423057, -1.143521385712187],
            [29.77737661732364, -1.140778090606537],
            [29.774363320212704, -1.13858286633413],
            [29.77162992377125, -1.134665116916372],
            [29.77048618425992, -1.133775693184523],
            [29.769125445911936, -1.12954175042669],
            [29.768413784374186, -1.128897560716992],
            [29.766442660553583, -1.129135450395526],
            [29.76603604263181, -1.131830467162493],
            [29.7645637191525, -1.131949255158616],
            [29.76359144197776, -1.130756403771674],
            [29.75948536767987, -1.129085596392772],
            [29.75929604414049, -1.128489280194789],
            [29.758192404525126, -1.128023846401017],
            [29.756411499864274, -1.128047139692765],
            [29.755534686654784, -1.126425035185262],
            [29.753611631685033, -1.126162083537458],
            [29.753018832530728, -1.125398679999938],
            [29.75045126868398, -1.124381807039978],
            [29.74864914761272, -1.122753525762151],
            [29.74839966210213, -1.1215413299944],
            [29.747898297969023, -1.121237786321596],
            [29.745540885999826, -1.120780683447944],
            [29.745338252122856, -1.122547842966713],
            [29.74428342875669, -1.123708082568966],
            [29.74458293336063, -1.125071844310613],
            [29.742525572171072, -1.125473494329651],
            [29.740735263047476, -1.126901767855238],
            [29.742662248146594, -1.13017842974248],
            [29.7424555565795, -1.13101779134189],
            [29.74305834140651, -1.132563978919166],
            [29.743800687597744, -1.133134338943552],
            [29.74334043666023, -1.135221590400222],
            [29.744579664391292, -1.135702936262367],
            [29.745000843105526, -1.137498240650096],
            [29.747328881063233, -1.139334569054281],
            [29.749209824809082, -1.14281546480328],
            [29.74944714353748, -1.144007303496934],
            [29.75155921302617, -1.145128966748014],
            [29.75107130116443, -1.146142439255028],
            [29.751567816191642, -1.148074497033195],
            [29.750555786768977, -1.150638066718986],
            [29.751242122103925, -1.152689420530606],
            [29.754161909983694, -1.153477485862079],
            [29.756093604051525, -1.156638323065107],
            [29.76015035185717, -1.159954926830538],
            [29.76355375585496, -1.16359330426768],
            [29.765072405453484, -1.164547865454339],
            [29.768847330194923, -1.165097731860496],
            [29.769582668628605, -1.165789657077095],
            [29.771576883643593, -1.166171959277294],
            [29.775027528245584, -1.170072779655275],
            [29.777210464030393, -1.171552292418265],
            [29.778753581042295, -1.171886741606914],
            [29.779963371879802, -1.17300816120598],
            [29.782414349674053, -1.178983713690343],
            [29.786814655465154, -1.183051892336843],
            [29.79287874716366, -1.191336849205652],
            [29.79205222164378, -1.19218880944656],
            [29.790318038360837, -1.192784454788938],
            [29.788299522120763, -1.192855281479074],
            [29.787255396791306, -1.192234763594414],
            [29.784999844792186, -1.191923878160299],
            [29.780194362875353, -1.189191166104024],
            [29.774424579925203, -1.188735896449591],
            [29.77242966063102, -1.188973684104911],
            [29.770495231193156, -1.188221652429964],
            [29.767168991579933, -1.189794586234915],
            [29.76567064211019, -1.191869048776234],
            [29.764743949944556, -1.192393424714043],
            [29.76334297605501, -1.192369051512809],
            [29.7616912733865, -1.193549034655027],
            [29.760266185121466, -1.193858539494641],
            [29.759388010066008, -1.193500458017536],
            [29.758390483045282, -1.193667053957405],
            [29.756777904702354, -1.19182995626627],
            [29.75613700615446, -1.191638907074682],
            [29.754330411473113, -1.193307761789002],
            [29.753119101584417, -1.193545812199085],
            [29.752166395106467, -1.192946657166309],
            [29.75178788008006, -1.1948332279483],
            [29.752523011901236, -1.195668265633066],
            [29.752522078551653, -1.196479184066831],
            [29.75302015305419, -1.196980228681044],
            [29.755133380471275, -1.19710026770611],
            [29.75603464492447, -1.198006930583998],
            [29.757302272893263, -1.200404405009231],
            [29.75839410415418, -1.200810280730874],
            [29.758701605560784, -1.201835976203218],
            [29.759745065238626, -1.203005039551913],
            [29.760052291760744, -1.204269254290671],
            [29.76217378547505, -1.20750182643986],
            [29.76407368008017, -1.207287909618258],
            [29.764072091858733, -1.208671247500638],
            [29.765329393693328, -1.209721165768148],
            [29.76625339181143, -1.21151033073264],
            [29.767701306267842, -1.21201175967102],
            [29.768471599047547, -1.21326421211171],
            [29.768351028068427, -1.214838334071284],
            [29.769562047801266, -1.214862654083015],
            [29.77172135340253, -1.216223004489674],
            [29.77343177265296, -1.215627402888137],
            [29.776232726895365, -1.216582540616694],
            [29.77700375270037, -1.217191031719258],
            [29.776859280246473, -1.218908258356737],
            [29.778091205572597, -1.221365398294374],
            [29.77809017340833, -1.222247883103855],
            [29.77873080425826, -1.222701299740103],
            [29.779263651647142, -1.223929842210148],
            [29.779714536749484, -1.224168529390317],
            [29.781092257747932, -1.223811312300118],
            [29.78132863504187, -1.224741602704295],
            [29.782183123319932, -1.22505201017999],
            [29.782392838616254, -1.228462791625044],
            [29.783650692016433, -1.229059581271684],
            [29.783969292108374, -1.230741203796881],
            [29.785559223922977, -1.231672047718335],
            [29.785604936492845, -1.233174691997569],
            [29.78648081725105, -1.235512461383605],
            [29.78580159657318, -1.237551470260516],
            [29.786204568233206, -1.238171752310003],
            [29.785824174829532, -1.238553219914585],
            [29.78525104428837, -1.24124816343685],
            [29.785794797224785, -1.243275740424869],
            [29.787609052738905, -1.245268060817776],
            [29.788700892084666, -1.245697839950175],
            [29.78931633597067, -1.247343838567462],
            [29.78948013657618, -1.249395109974463],
            [29.790962434050098, -1.250957995096991],
            [29.791745727248625, -1.251244536957667],
            [29.79206797090733, -1.25327928476016],
            [29.793710879967524, -1.254718538731046],
            [29.795420914738994, -1.255019211780564],
            [29.79577831127141, -1.255397036946025],
            [29.79610382210282, -1.256806590510007],
            [29.80448243391065, -1.270001924990345],
            [29.805907500616115, -1.273564613570942],
            [29.810761836511368, -1.281347399042173],
            [29.81319177845661, -1.276919864878803],
            [29.81504739599966, -1.274789183353051],
            [29.817897541987016, -1.275298259206797],
            [29.822652613145067, -1.277482639028623],
            [29.823613352358294, -1.277324231759483],
            [29.82533054221101, -1.273000512978305],
            [29.829322734385368, -1.27095515166014],
            [29.836223590601374, -1.265885015592316],
            [29.839022287377468, -1.26527967903139],
            [29.842681515398503, -1.26304600581952],
            [29.84413112317924, -1.263513832600109],
            [29.844794366421503, -1.263131448972813],
            [29.848188115326625, -1.262974023342073],
            [29.849354372907158, -1.263846290973441],
            [29.85053338207316, -1.261682931277292],
            [29.849725796632757, -1.258259661582991],
            [29.848270773807478, -1.256297785844336],
            [29.847035299237685, -1.255971286295721],
            [29.84688857380907, -1.254786179123579],
            [29.84486190176455, -1.252281412415644],
            [29.84588884232264, -1.252411688209762],
            [29.845485629914094, -1.251982179605482],
            [29.845932851686708, -1.245291716853973],
            [29.848093768865603, -1.245411821977237],
            [29.84925954944071, -1.243623337109319],
            [29.851682365050813, -1.243194917368086],
            [29.853393243340328, -1.242336903855003],
            [29.856848125295496, -1.24275566821956],
            [29.857894495514866, -1.241515715936415],
            [29.858300116306665, -1.239893888873653],
            [29.85832756882176, -1.236697622130209],
            [29.858874928494057, -1.235696006491453],
            [29.86064591755081, -1.234205876061283],
            [29.866321698094694, -1.23298355501481],
            [29.868662555909843, -1.232885030847054],
            [29.873057203212962, -1.231884844457776],
            [29.873318821369782, -1.23155098548763],
            [29.88202306617989, -1.24159649324124],
            [29.88441712492108, -1.243636501513085],
            [29.887247268122035, -1.242099379552791],
            [29.890969379111286, -1.240719876767217],
            [29.894669352917, -1.239840464201958],
            [29.894557059014897, -1.236295750184762],
            [29.897229211015237, -1.236369936447756],
            [29.89800616210783, -1.23673620925573],
            [29.90229163266291, -1.234781546341359],
            [29.901436387105097, -1.232418693069234],
            [29.89966643290753, -1.229392473290813],
            [29.89862549030912, -1.226171327978111],
            [29.896942395114703, -1.224537475751259],
            [29.896921602709117, -1.222825420438322],
            [29.89627627097532, -1.220690834079031],
            [29.89418879825742, -1.217654065297475],
            [29.890317963986373, -1.213988933342198],
            [29.888389423903476, -1.211089210213062],
            [29.8852905442954, -1.208109201429412],
            [29.883321924079517, -1.200392962984187],
            [29.88325050891273, -1.192355165667589],
            [29.885146784205542, -1.188285151459193],
            [29.885482508881747, -1.185351283189655],
            [29.88640943999924, -1.184659834333968],
            [29.88713516735771, -1.183407759497519],
            [29.886783491297013, -1.179233278397538],
            [29.887188217366834, -1.178326971302601],
            [29.89062349089595, -1.17502433531647],
            [29.892989462911487, -1.173286797020551],
            [29.891290645402975, -1.173971121168037],
            [29.887689508736376, -1.176548350293593],
            [29.884249985277624, -1.176804617931839],
            [29.883555849871076, -1.175303113732205],
            [29.884096477568622, -1.171802027535703],
            [29.883451615653705, -1.169868183401253],
            [29.87705972062319, -1.167255841169506],
            [29.865640714023883, -1.163769759871404],
            [29.852725919950053, -1.158927054107374],
            [29.853080756283905, -1.168425267588584],
            [29.852789403891194, -1.174160743554665],
            [29.852171025209177, -1.175020413198569],
            [29.852026832131344, -1.176549797174409],
            [29.852499948740324, -1.178175478213725],
            [29.851976499525975, -1.17908305171435],
            [29.852211874300085, -1.180947454566823],
            [29.851877644420515, -1.182524418793579],
            [29.85254008187398, -1.1847238974663],
            [29.85396236290375, -1.186972046347277],
            [29.853959392175113, -1.189600956598728],
            [29.85566479163973, -1.19347458855748],
            [29.856042084957352, -1.195817148726021],
            [29.852429377091614, -1.198585292165534],
            [29.849147975089185, -1.202357556191368],
            [29.84843496338353, -1.202882508510416],
            [29.84729543786922, -1.202594396949199],
            [29.84639261573733, -1.202975733086781],
            [29.84505883583104, -1.206415640486447],
            [29.84339638751508, -1.206557096471752],
            [29.841067707261946, -1.207844920124702],
            [29.83909788869346, -1.210942300213506],
            [29.839123893124302, -1.21309322918402],
            [29.839611326183995, -1.214891179959343],
            [29.839479379838426, -1.218858907999379],
            [29.83867725974819, -1.219425560048238],
            [29.836866317220828, -1.219632536200335],
            [29.83238630571123, -1.217745216522622],
            [29.829904741179877, -1.217314177321487],
            [29.830157533389013, -1.213184097657253],
            [29.82922822443097, -1.212646429134431],
            [29.83033491652167, -1.209914943965521],
            [29.83032469998192, -1.208030680977844],
            [29.830921704150068, -1.20643413269805],
            [29.829736649322236, -1.201878100615779],
            [29.827422365469822, -1.19810690738443],
            [29.824007897820977, -1.195246194253013],
            [29.819902544870246, -1.190710547077659],
            [29.816798535881915, -1.185820485083929],
            [29.814326536611727, -1.183883378813489],
            [29.811720983011597, -1.182835431920247],
            [29.810099575127733, -1.180832620369101],
            [29.809692309520614, -1.179587121673763],
            [29.80981609646848, -1.177575209771442],
            [29.809012679210966, -1.175017532907241],
            [29.809455479475773, -1.174150967445931],
            [29.808640618579833, -1.171937887267036],
            [29.808751839893503, -1.171259919569592],
            [29.807750545338454, -1.167857184190586],
            [29.807154694607135, -1.167322921516129],
            [29.805943679365882, -1.163786561189004],
            [29.8062330797195, -1.161808191210313],
            [29.805958702790672, -1.1602404831399],
            [29.806434649092846, -1.159351720298499],
            [29.805719448192868, -1.156894210810809],
            [29.804792918622308, -1.155748186747732],
            [29.80515846826425, -1.154803715810112],
            [29.8049319140479, -1.153428067875953],
            [29.80350804030511, -1.152592810104983],
            [29.802037570050217, -1.150946579373058],
            [29.80154026809885, -1.149682293758885],
            [29.80018760470694, -1.148894768953681],
            [29.79959498162243, -1.147940519545262],
            [29.799013751870678, -1.147451379020575],
            [29.79794528309534, -1.147355634219961],
            [29.796711779429252, -1.146162667063947],
            [29.79590450570423, -1.146067003950574],
            [29.794716084889004, -1.144660111043322],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 219,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "MUKO",
        Population: 37717,
        Key: "RUBANDAMUKO",
        Dist2: "Kabale",
        "Sub Country": "Muko",
        id2_original: "Kabale Muko",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.04652477176175, -1.060832520979727],
            [30.043009646987, -1.061057073874464],
            [30.039689400035055, -1.059379981827174],
            [30.03538217497873, -1.058693816722451],
            [30.030016262902233, -1.059237554928464],
            [30.027681537885535, -1.057382288054174],
            [30.02481116093964, -1.05635113108195],
            [30.023603282615387, -1.054891578770903],
            [30.021884085926313, -1.053921487097032],
            [30.020177964216202, -1.052317955302366],
            [30.026346138316775, -1.041663428954494],
            [30.027348372509593, -1.038867694846426],
            [30.026989637487397, -1.03393097552026],
            [30.026115706971655, -1.031587341802963],
            [30.02443233868939, -1.030485860439118],
            [30.021099734512404, -1.029107647021503],
            [30.01366208101524, -1.026888231299876],
            [30.009687953961215, -1.025843981586208],
            [30.008078886234404, -1.025824956521601],
            [30.00632530832449, -1.02728959695393],
            [30.003638979112328, -1.028665561239811],
            [30.001803979701695, -1.030617592335387],
            [29.99936650448449, -1.031071161845855],
            [29.99607577257951, -1.033010952113907],
            [29.993185092809888, -1.033833116410847],
            [29.99211837125777, -1.032952902534337],
            [29.98970345543231, -1.032364497400124],
            [29.98789394661615, -1.030170219235788],
            [29.986591950901225, -1.027184096002263],
            [29.984651500055985, -1.026639551988133],
            [29.981741988903075, -1.024552834030312],
            [29.976596153291386, -1.02448967459819],
            [29.97531485745555, -1.023225153704855],
            [29.974175288822114, -1.022795584037542],
            [29.972286915110534, -1.023141231203098],
            [29.97190658369059, -1.023522871674493],
            [29.969959358649806, -1.023284030677711],
            [29.968559624435358, -1.021709380252994],
            [29.963539526013967, -1.018619416706972],
            [29.960073006384274, -1.01773629485047],
            [29.958601547982603, -1.016686468094862],
            [29.947027783219404, -1.012617592433685],
            [29.944843407435172, -1.012092480669298],
            [29.94253957817608, -1.012330709041292],
            [29.942342343173962, -1.013021853786984],
            [29.940469696268075, -1.013423839115001],
            [29.939391793385624, -1.013558794362034],
            [29.938371046711424, -1.013081549183476],
            [29.936612392421814, -1.014464874700344],
            [29.936421490542468, -1.015466746861302],
            [29.937085385063327, -1.016611864874821],
            [29.93666815085148, -1.018365120476393],
            [29.93481438832951, -1.019891550530618],
            [29.934230870568715, -1.021692478443571],
            [29.933893423822145, -1.027012011837049],
            [29.93114857655575, -1.029655969216818],
            [29.92873327714963, -1.031259514341305],
            [29.92772524163673, -1.033147341811345],
            [29.92663734230177, -1.033228406973787],
            [29.925114998830814, -1.032624702473156],
            [29.92438027843804, -1.03308934253176],
            [29.923966281754502, -1.034234678786955],
            [29.924665425268767, -1.035242092751572],
            [29.923912120529405, -1.038538402327637],
            [29.92441086337851, -1.039923156594182],
            [29.924347104552893, -1.041219255786962],
            [29.922844710867775, -1.043432593466375],
            [29.921716268767423, -1.04677887468879],
            [29.91956235665113, -1.050451301866211],
            [29.91811311268808, -1.0577412080649],
            [29.919116284722065, -1.058788901532364],
            [29.922296966716527, -1.06041160303999],
            [29.924029312944743, -1.061747765187113],
            [29.926640336386633, -1.062267738417535],
            [29.92782471747801, -1.065392908336877],
            [29.929623317153354, -1.068615219072174],
            [29.926759785369946, -1.073705973141226],
            [29.92852323756149, -1.079634156629859],
            [29.927771461754716, -1.083367236564247],
            [29.928682853814415, -1.086337300684309],
            [29.929154402863265, -1.08977244160716],
            [29.930043687383826, -1.091072711504772],
            [29.929994373468, -1.092909497292438],
            [29.929184559307355, -1.095247065040713],
            [29.927995904031825, -1.096463380617387],
            [29.92837477479112, -1.097584629169433],
            [29.93231852980535, -1.096130355264375],
            [29.934253381451416, -1.096810655992281],
            [29.936414657058116, -1.096691866579129],
            [29.93788659516017, -1.097193135237211],
            [29.940143412885533, -1.09652570060616],
            [29.944501497858255, -1.096395439101312],
            [29.946021044873746, -1.09680131163246],
            [29.948061537498905, -1.098733995686946],
            [29.95228780907676, -1.099832228299052],
            [29.954600798456823, -1.102421018192555],
            [29.955169227215773, -1.1039717196493],
            [29.956141837665474, -1.10509312614661],
            [29.955690206961442, -1.105498560993756],
            [29.956068425543847, -1.107263912725707],
            [29.955673253057082, -1.110543901723228],
            [29.95510165504181, -1.112165928793204],
            [29.955075934478586, -1.114098171737194],
            [29.955466486031508, -1.115422214789527],
            [29.95653367201262, -1.116949195718706],
            [29.95881237090168, -1.11819019776887],
            [29.95849324799027, -1.120487593188628],
            [29.96026592048988, -1.120607261827672],
            [29.962057118047277, -1.121776509676963],
            [29.964614528236357, -1.121195484670883],
            [29.966089944615206, -1.121860308224801],
            [29.968383637284656, -1.121411662364995],
            [29.969913304720144, -1.120590775506002],
            [29.971967430178026, -1.12242359118375],
            [29.972626516915483, -1.122318150101477],
            [29.9736276461805, -1.122823291698986],
            [29.97468201140587, -1.122824388331332],
            [29.976846518252636, -1.121999292272158],
            [29.98306912037798, -1.122912229389719],
            [29.983725345981217, -1.118839988870048],
            [29.983504817663796, -1.115499413949076],
            [29.98580695988681, -1.115393301703578],
            [29.989037759789305, -1.114606761831269],
            [29.992421971281075, -1.114810276162588],
            [29.996411313999374, -1.115550687252523],
            [30.000053612370575, -1.117359950444498],
            [30.001442520089245, -1.117389388027485],
            [30.004407469871587, -1.11858814748075],
            [30.00573475675502, -1.119641512239858],
            [30.006798725869103, -1.121818073045663],
            [30.006867461361377, -1.123085085043487],
            [30.007482708516317, -1.124089789523631],
            [30.00823610578218, -1.127269980715156],
            [30.009313608016033, -1.128597959750447],
            [30.01056923539094, -1.129890312533919],
            [30.015620711965173, -1.132358546499814],
            [30.016236605907128, -1.133028625214832],
            [30.017720491602475, -1.133410049828594],
            [30.027161358538788, -1.130483964559901],
            [30.028872293422182, -1.1296015378578],
            [30.02951504429619, -1.128670030177269],
            [30.02970938672308, -1.126399308814691],
            [30.034377910593378, -1.124432717338555],
            [30.035733856429314, -1.122976147515356],
            [30.03623488549084, -1.12168586817415],
            [30.03931724148757, -1.117470313536655],
            [30.04077025478154, -1.116058974420848],
            [30.040365666153974, -1.109307984455687],
            [30.03946785392643, -1.107083770369586],
            [30.039010786618288, -1.104059248713792],
            [30.041402226770437, -1.096986843514307],
            [30.042623465737957, -1.089385784107688],
            [30.042772339936732, -1.08601533228124],
            [30.045328869776824, -1.083591918936639],
            [30.047424067107865, -1.080343229900506],
            [30.048699202297477, -1.077655338210543],
            [30.049874248994747, -1.071393528223533],
            [30.051230722141746, -1.06962609691342],
            [30.051649851798828, -1.067654377354809],
            [30.05348235838455, -1.065218094962683],
            [30.050272089477886, -1.061901965064779],
            [30.048066319416886, -1.060871545190412],
            [30.04652477176175, -1.060832520979727],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 220,
        District: "RUKIGA",
        County: "RUKIGA",
        Subcounty: "KASHAMBYA",
        Population: 26058,
        Key: "RUKIGAKASHAMBYA",
        Dist2: "Kabale",
        "Sub Country": "Kashambya",
        id2_original: "Kabale Kashambya",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.91811311268808, -1.0577412080649],
            [29.917170820379255, -1.056832471657547],
            [29.913491738692105, -1.054875735174951],
            [29.909514424415477, -1.054362118802469],
            [29.90851762323347, -1.053741731380635],
            [29.904142395710174, -1.047264559369675],
            [29.902649888883047, -1.043519220708936],
            [29.900195519050296, -1.041358092635507],
            [29.899873681430087, -1.043895191302957],
            [29.90033196865038, -1.045453196697695],
            [29.900021225223924, -1.046531222644208],
            [29.896707818942875, -1.049042362866672],
            [29.894092564435994, -1.049996659141257],
            [29.89280362753034, -1.050059778545092],
            [29.89103116882977, -1.049165513821404],
            [29.887785177517525, -1.05014677115748],
            [29.887007492501336, -1.050863666140314],
            [29.886346999900454, -1.053236842276021],
            [29.88531262937668, -1.054698749448631],
            [29.88500970039487, -1.055986573143231],
            [29.883783449726412, -1.057365472659268],
            [29.88365458909384, -1.05825783002725],
            [29.88161288553969, -1.061549683844908],
            [29.877231104806366, -1.064848343110145],
            [29.876361068487405, -1.066494407058413],
            [29.8751079680734, -1.067293600203974],
            [29.87215475118694, -1.068017447463838],
            [29.869354385341072, -1.070145529918344],
            [29.871744217508855, -1.073588207618506],
            [29.876289740457207, -1.075700219071822],
            [29.87992175491504, -1.077060649943628],
            [29.88250989826665, -1.077395170135334],
            [29.885217495093137, -1.077014105673608],
            [29.884705607196498, -1.07833787771417],
            [29.882446734125743, -1.08119977742257],
            [29.879167356925976, -1.083393562376656],
            [29.87813273936546, -1.084979572024096],
            [29.874852113507426, -1.088413685208439],
            [29.86965881900095, -1.092837215825949],
            [29.86778173082431, -1.09383861638955],
            [29.8652378860943, -1.096676506405305],
            [29.86502318424982, -1.097630570463347],
            [29.86316928338726, -1.099204417041876],
            [29.867507860545317, -1.106194428976931],
            [29.876842327426143, -1.116083985060833],
            [29.876854248968257, -1.121496905137539],
            [29.87726099355249, -1.1245281602248],
            [29.879451167063554, -1.130742546364202],
            [29.880920559340097, -1.133581497474041],
            [29.884917282616787, -1.138150517975898],
            [29.885931047584574, -1.13254724028788],
            [29.889222149595458, -1.128980753713264],
            [29.890188712586664, -1.128459347847885],
            [29.894795765640414, -1.122702970200746],
            [29.89610216310021, -1.122405584316333],
            [29.89791431475993, -1.121033127303046],
            [29.900225437440827, -1.125039252529781],
            [29.903133891276656, -1.125580163956172],
            [29.90455903613557, -1.125282902308349],
            [29.9082119921193, -1.1235538535309],
            [29.909072703925652, -1.123674281873072],
            [29.90999240899499, -1.124153313338981],
            [29.910614143782905, -1.125707651610155],
            [29.91049179054627, -1.12914353545943],
            [29.91123020481148, -1.132640098061579],
            [29.91350956306395, -1.138618232310741],
            [29.91522865375183, -1.141070120811608],
            [29.917185793498412, -1.142984458180543],
            [29.92249475058927, -1.147292716257684],
            [29.92228600098186, -1.148188852961517],
            [29.921394566792838, -1.149024491034943],
            [29.917446734325484, -1.148811061901068],
            [29.91523636039866, -1.150859579821073],
            [29.91254397923641, -1.151637059355307],
            [29.91128134410398, -1.151579940737654],
            [29.9073913308016, -1.153660493079391],
            [29.901890207003458, -1.160410504742197],
            [29.90097673983546, -1.166012225194811],
            [29.899513803750853, -1.168269387503697],
            [29.89915743489112, -1.16841240728658],
            [29.89477101615601, -1.165416928885048],
            [29.89289557728621, -1.163090982785184],
            [29.892147618421074, -1.163018448891033],
            [29.890436684436008, -1.164056301941741],
            [29.890530729063105, -1.166780043886575],
            [29.892972309581147, -1.171601374187531],
            [29.894592619723728, -1.172545107527012],
            [29.896490228116434, -1.173047259369761],
            [29.89831634768049, -1.175385506040981],
            [29.898481723032713, -1.176172728872013],
            [29.90180295992813, -1.179489440708251],
            [29.903747450497185, -1.182161674583524],
            [29.905634906130555, -1.182698979060041],
            [29.909811288870774, -1.185872869897641],
            [29.910974850607154, -1.185992503455164],
            [29.912207876369493, -1.187758090252808],
            [29.912811501121286, -1.189583103736126],
            [29.91473300470055, -1.191563611303013],
            [29.91724883726504, -1.193019526178421],
            [29.91843638132457, -1.192948335753677],
            [29.92207438934196, -1.188965795900494],
            [29.924914030430397, -1.187499637595721],
            [29.92710330562616, -1.183516636334646],
            [29.92885422362454, -1.178591234786291],
            [29.930036764067932, -1.172115089588797],
            [29.929945698254308, -1.168441476113559],
            [29.929571487954718, -1.167550771407883],
            [29.937174660534566, -1.167751564255654],
            [29.93877102608325, -1.168316284183653],
            [29.94161482008323, -1.167463819966923],
            [29.942671785931367, -1.167597977056136],
            [29.946451874189055, -1.166750894210774],
            [29.95221242245811, -1.161386816139012],
            [29.956658024000795, -1.162950477496718],
            [29.95938927077376, -1.162951243601805],
            [29.96206129611164, -1.162796908896141],
            [29.966670499732174, -1.16119986572797],
            [29.967122257996998, -1.160722880094117],
            [29.966174814748314, -1.15826551549715],
            [29.964774039386427, -1.157811904149189],
            [29.964038521289662, -1.157119897045605],
            [29.964447617663332, -1.151991132428831],
            [29.965220614372033, -1.150905913659417],
            [29.96534188603709, -1.148472710283092],
            [29.964535146809645, -1.147756830276472],
            [29.964322988994056, -1.14620619610116],
            [29.96156180137266, -1.140706857545349],
            [29.96184776836524, -1.139776577602333],
            [29.96066101841645, -1.139060617288422],
            [29.959487017358164, -1.137473963972903],
            [29.956994641602346, -1.136185162220249],
            [29.95473121137818, -1.131640202480796],
            [29.955623892428843, -1.129600818447095],
            [29.957597280003963, -1.127478195038166],
            [29.958608150599936, -1.125065098365268],
            [29.95849324799027, -1.120487593188628],
            [29.95881237090168, -1.11819019776887],
            [29.95653367201262, -1.116949195718706],
            [29.955466486031508, -1.115422214789527],
            [29.955075934478586, -1.114098171737194],
            [29.95510165504181, -1.112165928793204],
            [29.955673253057082, -1.110543901723228],
            [29.956068425543847, -1.107263912725707],
            [29.955690206961442, -1.105498560993756],
            [29.956141837665474, -1.10509312614661],
            [29.955169227215773, -1.1039717196493],
            [29.954600798456823, -1.102421018192555],
            [29.95228780907676, -1.099832228299052],
            [29.948061537498905, -1.098733995686946],
            [29.946021044873746, -1.09680131163246],
            [29.944501497858255, -1.096395439101312],
            [29.940143412885533, -1.09652570060616],
            [29.93788659516017, -1.097193135237211],
            [29.936414657058116, -1.096691866579129],
            [29.934253381451416, -1.096810655992281],
            [29.93231852980535, -1.096130355264375],
            [29.92837477479112, -1.097584629169433],
            [29.927995904031825, -1.096463380617387],
            [29.929184559307355, -1.095247065040713],
            [29.929994373468, -1.092909497292438],
            [29.930043687383826, -1.091072711504772],
            [29.929154402863265, -1.08977244160716],
            [29.928682853814415, -1.086337300684309],
            [29.927771461754716, -1.083367236564247],
            [29.92852323756149, -1.079634156629859],
            [29.926759785369946, -1.073705973141226],
            [29.929623317153354, -1.068615219072174],
            [29.92782471747801, -1.065392908336877],
            [29.926640336386633, -1.062267738417535],
            [29.924029312944743, -1.061747765187113],
            [29.922296966716527, -1.06041160303999],
            [29.919116284722065, -1.058788901532364],
            [29.91811311268808, -1.0577412080649],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 221,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "HAMURWA",
        Population: 26985,
        Key: "RUBANDAHAMURWA",
        Dist2: "Kabale",
        "Sub Country": "Hamurwa",
        id2_original: "Kabale Hamurwa",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.876854248968257, -1.121496905137539],
            [29.876842327426143, -1.116083985060833],
            [29.867507860545317, -1.106194428976931],
            [29.86316928338726, -1.099204417041876],
            [29.86502318424982, -1.097630570463347],
            [29.8652378860943, -1.096676506405305],
            [29.86778173082431, -1.09383861638955],
            [29.86965881900095, -1.092837215825949],
            [29.874852113507426, -1.088413685208439],
            [29.87813273936546, -1.084979572024096],
            [29.879167356925976, -1.083393562376656],
            [29.882446734125743, -1.08119977742257],
            [29.884705607196498, -1.07833787771417],
            [29.885217495093137, -1.077014105673608],
            [29.88250989826665, -1.077395170135334],
            [29.87992175491504, -1.077060649943628],
            [29.876289740457207, -1.075700219071822],
            [29.871744217508855, -1.073588207618506],
            [29.869354385341072, -1.070145529918344],
            [29.866087234212298, -1.066848431939384],
            [29.865441819833464, -1.065042974407774],
            [29.864757102364358, -1.06466079918234],
            [29.863474166204817, -1.064898712828894],
            [29.86204859554445, -1.064520025141813],
            [29.859536696702612, -1.063173677255781],
            [29.85238330250068, -1.056839232126487],
            [29.851743369641742, -1.055598752744511],
            [29.85007058081859, -1.054226876979489],
            [29.850012658347374, -1.053154149258577],
            [29.848340911569924, -1.050338538232799],
            [29.846155052667186, -1.04859042431127],
            [29.845090660446616, -1.048401657897723],
            [29.843862600571132, -1.047422822365992],
            [29.84263260123298, -1.047558537816625],
            [29.84232270851111, -1.046779558192627],
            [29.839761700569284, -1.04510115253015],
            [29.839215074820586, -1.044224529966745],
            [29.838112203264807, -1.044736254670277],
            [29.83674889214184, -1.046730167180557],
            [29.834454284987444, -1.04859091021848],
            [29.832361711635365, -1.051413430599172],
            [29.831726531762595, -1.053684520170044],
            [29.830889643277597, -1.054669285208307],
            [29.83078124806383, -1.055582675629819],
            [29.828519793234985, -1.060063719049299],
            [29.82848145044371, -1.062539744637115],
            [29.829326958263852, -1.064824368521246],
            [29.830674971077524, -1.066159953936166],
            [29.831699190638602, -1.068841423114361],
            [29.831695190440623, -1.07025937780583],
            [29.831266428148798, -1.072263294653879],
            [29.825971449742042, -1.075980150335885],
            [29.82352075851037, -1.076455127994013],
            [29.821311393391582, -1.077504443442037],
            [29.818675020390707, -1.078170895204973],
            [29.80710958211187, -1.079855650825779],
            [29.801601303232506, -1.079419627616627],
            [29.792533535379743, -1.076948329175638],
            [29.78647897750136, -1.076750721244616],
            [29.784722316573372, -1.076366462856846],
            [29.780543050241075, -1.076672728013802],
            [29.776513197995065, -1.076408702271407],
            [29.774801145607448, -1.075224347629844],
            [29.77268385600866, -1.075369915541625],
            [29.771826670089805, -1.075886362996054],
            [29.769952451132166, -1.075688091258258],
            [29.767257486415204, -1.076549400320962],
            [29.765629622339397, -1.076160276592244],
            [29.75802137607484, -1.075973364760602],
            [29.756125576889126, -1.077014300573574],
            [29.75387282044717, -1.07966398258783],
            [29.752574378467504, -1.080383916348883],
            [29.752471559096726, -1.081966935816053],
            [29.7515913709167, -1.083540821122591],
            [29.751387496466336, -1.085484570871273],
            [29.7496474301166, -1.089508293060922],
            [29.74938613355664, -1.091310689550937],
            [29.747782004767277, -1.092668502480494],
            [29.747267295262287, -1.094312813444296],
            [29.746927107755766, -1.094708937723111],
            [29.744641510703662, -1.094842587127933],
            [29.744608274834786, -1.096034502802671],
            [29.743789484707808, -1.096201855260219],
            [29.74301801513507, -1.098526409835924],
            [29.74237408477311, -1.097360392426013],
            [29.74163968238394, -1.09758480161433],
            [29.740260626489007, -1.096813495046636],
            [29.73890275197017, -1.097716807275532],
            [29.738086826570637, -1.097202962800835],
            [29.738055020819676, -1.098054320509102],
            [29.73685463354655, -1.098404746410235],
            [29.734840628645866, -1.10103697115091],
            [29.734947121227844, -1.102541600083061],
            [29.733846108286397, -1.102736268476951],
            [29.73389890946216, -1.103587937161696],
            [29.733133311278113, -1.10452176103156],
            [29.733579033762542, -1.105857325323022],
            [29.733180028164465, -1.106820863695353],
            [29.73368407107375, -1.107702539212025],
            [29.73318087797072, -1.109957060794688],
            [29.731305353760963, -1.113185788729117],
            [29.729498147326893, -1.113604939845359],
            [29.72824528047487, -1.116353399765578],
            [29.728546042720208, -1.121931526480278],
            [29.727844566281114, -1.123824132460184],
            [29.728048703039565, -1.125004945297133],
            [29.72872652773551, -1.124825774919352],
            [29.73097904432727, -1.125833032217706],
            [29.732467845603836, -1.125997404749063],
            [29.733388496599183, -1.127090645218577],
            [29.735760060627356, -1.12664519754668],
            [29.736213620912626, -1.126124601386856],
            [29.73733708904125, -1.12728671219173],
            [29.73937676509782, -1.127941273094802],
            [29.74026114122368, -1.126945437292833],
            [29.740735263047476, -1.126901767855238],
            [29.742525572171072, -1.125473494329651],
            [29.74458293336063, -1.125071844310613],
            [29.74428342875669, -1.123708082568966],
            [29.745338252122856, -1.122547842966713],
            [29.745540885999826, -1.120780683447944],
            [29.747898297969023, -1.121237786321596],
            [29.74839966210213, -1.1215413299944],
            [29.74864914761272, -1.122753525762151],
            [29.75045126868398, -1.124381807039978],
            [29.753018832530728, -1.125398679999938],
            [29.753611631685033, -1.126162083537458],
            [29.755534686654784, -1.126425035185262],
            [29.756411499864274, -1.128047139692765],
            [29.758192404525126, -1.128023846401017],
            [29.75929604414049, -1.128489280194789],
            [29.75948536767987, -1.129085596392772],
            [29.76359144197776, -1.130756403771674],
            [29.7645637191525, -1.131949255158616],
            [29.76603604263181, -1.131830467162493],
            [29.766442660553583, -1.129135450395526],
            [29.768413784374186, -1.128897560716992],
            [29.769125445911936, -1.12954175042669],
            [29.77048618425992, -1.133775693184523],
            [29.77162992377125, -1.134665116916372],
            [29.774363320212704, -1.13858286633413],
            [29.77737661732364, -1.140778090606537],
            [29.778679634423057, -1.143521385712187],
            [29.780745673338245, -1.143378937686697],
            [29.781623686696964, -1.143903925321183],
            [29.783036469839253, -1.143987867828954],
            [29.783748014596014, -1.14475132214357],
            [29.785054185680377, -1.144608637071234],
            [29.786264667322353, -1.145109904712196],
            [29.787072357865654, -1.144823941826412],
            [29.787453347750706, -1.143846167974152],
            [29.788237724317444, -1.143154711633344],
            [29.78942525669887, -1.142940443202555],
            [29.78982888233242, -1.14298825550186],
            [29.7910856299065, -1.14463440728842],
            [29.793888131047805, -1.144205950565865],
            [29.794716084889004, -1.144660111043322],
            [29.795263053794127, -1.143280500136931],
            [29.795037384418357, -1.141215473526879],
            [29.794297991887774, -1.139895484724089],
            [29.79435637339807, -1.138633744948657],
            [29.795098044954518, -1.137888961301953],
            [29.795726876433204, -1.136111662143543],
            [29.797665179406586, -1.135482917392238],
            [29.79892289177125, -1.131870949027172],
            [29.801716400776577, -1.130899008696461],
            [29.80712839822384, -1.132683017466249],
            [29.80974983313985, -1.13274327455974],
            [29.81625123729506, -1.128506114950582],
            [29.81903391261809, -1.128102030488977],
            [29.821867640995293, -1.1262591529018],
            [29.8266644568646, -1.124256477564171],
            [29.83271870123096, -1.119988116678282],
            [29.83709668927714, -1.118470712443747],
            [29.84314680408814, -1.118088621248956],
            [29.849844982409685, -1.113529333048357],
            [29.852323836723826, -1.112560391819082],
            [29.857503015103944, -1.114217671785164],
            [29.85956138959313, -1.115288647143738],
            [29.86226446430049, -1.115323931671981],
            [29.864516411360388, -1.115941699152536],
            [29.865320225673248, -1.116590302505637],
            [29.86670149861032, -1.118923659965413],
            [29.86711949728842, -1.119247980640651],
            [29.867699185531155, -1.118827569334549],
            [29.86863179220461, -1.119411539823862],
            [29.87001389159174, -1.120967613134185],
            [29.871975478897287, -1.122297600590689],
            [29.87397055629493, -1.122396906459385],
            [29.876854248968257, -1.121496905137539],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 222,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "IKUMBA",
        Population: 18555,
        Key: "RUBANDAIKUMBA",
        Dist2: "Kabale",
        "Sub Country": "ikumba",
        id2_original: "Kabale ikumba",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.15667723125129, -1.16075980315553],
            [30.154538214100704, -1.161480148088065],
            [30.15323513681418, -1.159827809828549],
            [30.15222654973569, -1.159599490488449],
            [30.15161055787736, -1.15892935961101],
            [30.150594387221236, -1.156489621999085],
            [30.147054029668457, -1.157967694100404],
            [30.14477382969458, -1.158490950145884],
            [30.143572409358853, -1.159768570887731],
            [30.14043779476881, -1.160147365803258],
            [30.136504410804502, -1.156174127864794],
            [30.129511952480676, -1.156512492937928],
            [30.122450029232596, -1.155966194041109],
            [30.116471991646733, -1.154810968232709],
            [30.114643208577853, -1.155191296923011],
            [30.113240780315838, -1.156074163032949],
            [30.108448021238356, -1.158454380918756],
            [30.10443487586, -1.161050587403317],
            [30.10219716799566, -1.159785270740281],
            [30.101237753797495, -1.159635694161353],
            [30.100888934379427, -1.163919667641403],
            [30.10017229976825, -1.166965011757018],
            [30.101271811624883, -1.172196611706146],
            [30.10078901477038, -1.179726776501903],
            [30.101021147524637, -1.18492676643732],
            [30.10186907989771, -1.186827209716649],
            [30.102839273879283, -1.187315445268938],
            [30.103879238212354, -1.189659541074522],
            [30.104638284983032, -1.189995143967089],
            [30.106034226510374, -1.192411412276557],
            [30.107030740231465, -1.198711959236254],
            [30.106893537843153, -1.20204674914316],
            [30.1037364060822, -1.207792321979135],
            [30.103947607192016, -1.209035723366724],
            [30.10503631680732, -1.210734416299627],
            [30.107677361946, -1.213785775536634],
            [30.1087905551444, -1.221042755422063],
            [30.108468987917078, -1.223465546071048],
            [30.111512776543726, -1.231400656611923],
            [30.114650466067033, -1.234481575998049],
            [30.11626481139612, -1.235312030962783],
            [30.117234051366875, -1.235490765826348],
            [30.11967407779947, -1.23484296336616],
            [30.122146937655714, -1.232479143784953],
            [30.124469615366138, -1.231742401884704],
            [30.12738984252206, -1.233388111005192],
            [30.129946163953065, -1.23336172731122],
            [30.132151402211413, -1.23259523045836],
            [30.133274104975413, -1.233373477247195],
            [30.133811040597156, -1.230165705080205],
            [30.13278315141814, -1.222999186891453],
            [30.13304386676811, -1.221262397512335],
            [30.133691561071103, -1.22078539712652],
            [30.136324106350557, -1.220180240626219],
            [30.13787832564108, -1.219269937020554],
            [30.137446012308896, -1.218399559582445],
            [30.13761407811539, -1.215656552944982],
            [30.138497765233442, -1.213052849980705],
            [30.137535896837907, -1.21145856161781],
            [30.137468233934094, -1.210350131840566],
            [30.138116875959703, -1.208729845039992],
            [30.13943984823484, -1.20724881463422],
            [30.140282507497197, -1.204367966313457],
            [30.135250887284002, -1.19830826024341],
            [30.130286884160526, -1.193426293030373],
            [30.13132534740875, -1.191408498611942],
            [30.132752036471636, -1.189927721982256],
            [30.133560367513738, -1.18921133881775],
            [30.135793908991772, -1.188448625842115],
            [30.137267856625137, -1.187206963755085],
            [30.13826561900446, -1.187064554761869],
            [30.139357854507278, -1.187448214701863],
            [30.143847000086723, -1.190087692695865],
            [30.14376676166722, -1.188632280118281],
            [30.14443593648528, -1.18638582464991],
            [30.147282035562313, -1.181811029855259],
            [30.147833415195485, -1.179086256224632],
            [30.147304620106876, -1.176324339724159],
            [30.144983331191895, -1.173548294750715],
            [30.14407359023566, -1.171335806859474],
            [30.143625387502745, -1.169853022101775],
            [30.144010276076134, -1.167271509925771],
            [30.144629825262975, -1.166100794211416],
            [30.14567552264415, -1.165552164725307],
            [30.149367935330126, -1.165257715674834],
            [30.150508349278265, -1.164828740247508],
            [30.15200834985148, -1.162631023327693],
            [30.15667723125129, -1.16075980315553],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 223,
        District: "RUKIGA",
        County: "RUKIGA",
        Subcounty: "MUHANGA TOWN COUNCIL",
        Population: 11758,
        Key: "RUKIGAMUHANGA TOWN COUNCIL",
        Dist2: "Kabale",
        "Sub Country": "Muhanga T.C",
        id2_original: "Kabale Muhanga T.C",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.88441712492108, -1.243636501513085],
            [29.88202306617989, -1.24159649324124],
            [29.873318821369782, -1.23155098548763],
            [29.873057203212962, -1.231884844457776],
            [29.868662555909843, -1.232885030847054],
            [29.866321698094694, -1.23298355501481],
            [29.86064591755081, -1.234205876061283],
            [29.858874928494057, -1.235696006491453],
            [29.85832756882176, -1.236697622130209],
            [29.858300116306665, -1.239893888873653],
            [29.857894495514866, -1.241515715936415],
            [29.856848125295496, -1.24275566821956],
            [29.853393243340328, -1.242336903855003],
            [29.851682365050813, -1.243194917368086],
            [29.84925954944071, -1.243623337109319],
            [29.848093768865603, -1.245411821977237],
            [29.845932851686708, -1.245291716853973],
            [29.845485629914094, -1.251982179605482],
            [29.84588884232264, -1.252411688209762],
            [29.84486190176455, -1.252281412415644],
            [29.84688857380907, -1.254786179123579],
            [29.847035299237685, -1.255971286295721],
            [29.848270773807478, -1.256297785844336],
            [29.849725796632757, -1.258259661582991],
            [29.85053338207316, -1.261682931277292],
            [29.849354372907158, -1.263846290973441],
            [29.848188115326625, -1.262974023342073],
            [29.844794366421503, -1.263131448972813],
            [29.84413112317924, -1.263513832600109],
            [29.842681515398503, -1.26304600581952],
            [29.839022287377468, -1.26527967903139],
            [29.836223590601374, -1.265885015592316],
            [29.829322734385368, -1.27095515166014],
            [29.82533054221101, -1.273000512978305],
            [29.823613352358294, -1.277324231759483],
            [29.822652613145067, -1.277482639028623],
            [29.817897541987016, -1.275298259206797],
            [29.81504739599966, -1.274789183353051],
            [29.81319177845661, -1.276919864878803],
            [29.810761836511368, -1.281347399042173],
            [29.812593268712057, -1.285424173238949],
            [29.813832050878727, -1.290007450712412],
            [29.816217259417744, -1.295130139952605],
            [29.818843216452912, -1.300763611232544],
            [29.818251607566364, -1.304596125230772],
            [29.819139882380554, -1.30741426320363],
            [29.819197082606273, -1.310482445141168],
            [29.822476539756142, -1.30788569573409],
            [29.827886691165467, -1.314051446128308],
            [29.82982375715868, -1.314766218153915],
            [29.83181524668511, -1.314093431323093],
            [29.833839177071354, -1.31586314301454],
            [29.8349854282722, -1.317802738322459],
            [29.837740818166793, -1.31833604463824],
            [29.840082270666624, -1.319286196080495],
            [29.840677869869683, -1.319900165553682],
            [29.841254828132275, -1.321937145100043],
            [29.838512066753978, -1.324961018799653],
            [29.839287096350176, -1.325965499432375],
            [29.83922432117981, -1.328337294818543],
            [29.840036902151514, -1.329898912779406],
            [29.838465693922377, -1.331957188175385],
            [29.841680254979472, -1.334788891050733],
            [29.845364916102834, -1.336314211180129],
            [29.848709333125818, -1.338943791204061],
            [29.848003669639215, -1.340772972325362],
            [29.848433808150098, -1.341577393552648],
            [29.84952756090744, -1.342094331018383],
            [29.85000490408983, -1.342827410142127],
            [29.850144478030483, -1.345376209170475],
            [29.852642233796516, -1.346883051258868],
            [29.853782627981687, -1.347162644673481],
            [29.855258449500727, -1.348318232093481],
            [29.856022066899566, -1.349453220919987],
            [29.856706839165934, -1.351786203448285],
            [29.8563406903477, -1.355653440088128],
            [29.856974467052, -1.356990609188502],
            [29.858855406306294, -1.358595025772925],
            [29.859455530323437, -1.360489651856581],
            [29.860193300496594, -1.361031897170641],
            [29.86485660246016, -1.357335566073397],
            [29.868943510303154, -1.355100265924007],
            [29.878873596149948, -1.355572239847994],
            [29.882628256695224, -1.355028430677532],
            [29.882713968549744, -1.352419278318797],
            [29.882258662837884, -1.351211760415151],
            [29.881873428413115, -1.346339797843273],
            [29.88131945714032, -1.344089204255739],
            [29.877630704190853, -1.338117120318209],
            [29.878554874785465, -1.33766245152653],
            [29.879978536525837, -1.337490175559253],
            [29.88213529091168, -1.336532039181985],
            [29.88548822037033, -1.338177403286944],
            [29.894076601373403, -1.340143614234742],
            [29.896216481804966, -1.341106561055389],
            [29.90183386556717, -1.342501125639526],
            [29.909027678566968, -1.343672481754225],
            [29.909988247998605, -1.335401288642263],
            [29.909744239516286, -1.333552460887734],
            [29.9067754323681, -1.326498010096654],
            [29.90595212551189, -1.31866329507623],
            [29.906393246825417, -1.309293273353868],
            [29.907684155533094, -1.305208269814548],
            [29.913321454046844, -1.298459506156038],
            [29.913508364711387, -1.297628577478874],
            [29.917107057960383, -1.292413876214416],
            [29.915106157683056, -1.286521978407709],
            [29.913458908861717, -1.277398354888615],
            [29.91025746769936, -1.271744370749947],
            [29.9079663379234, -1.268363131713579],
            [29.90299907301713, -1.263440460779706],
            [29.89206187063394, -1.258532726674632],
            [29.889111324438847, -1.256577506056689],
            [29.888038156576258, -1.255206777220528],
            [29.886052640846493, -1.247180718914718],
            [29.88441712492108, -1.243636501513085],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 224,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "BUFUNDI",
        Population: 25591,
        Key: "RUBANDABUFUNDI",
        Dist2: "Kabale",
        "Sub Country": "Bufundi",
        id2_original: "Kabale Bufundi",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.9600394992242, -1.394927669578572],
            [29.954064411705744, -1.390328881542436],
            [29.948952862991806, -1.384884363149579],
            [29.948807573071022, -1.384078607511281],
            [29.950471252078874, -1.381260762784344],
            [29.952267178367926, -1.375572509052437],
            [29.952872963568005, -1.372344249147929],
            [29.952199359157255, -1.369765898296752],
            [29.950269817452828, -1.371342207025637],
            [29.946410486108984, -1.373077275094644],
            [29.942541029853555, -1.372892936245342],
            [29.939282972370396, -1.372132996351169],
            [29.937538551886494, -1.373357061250841],
            [29.935622696015425, -1.375678870360203],
            [29.935125196434658, -1.376904533777844],
            [29.935945813734893, -1.377860973],
            [29.93863660577741, -1.378990944830478],
            [29.941071349217804, -1.380904856670772],
            [29.94036229998092, -1.381345982743576],
            [29.93949597909395, -1.382884878985955],
            [29.938177687939785, -1.383282433830009],
            [29.93787952182562, -1.383752606995749],
            [29.935202646483514, -1.382822272971466],
            [29.930636409283018, -1.385639685676525],
            [29.932746340781314, -1.386683364460653],
            [29.93574703991872, -1.389225439956158],
            [29.94036383160847, -1.391199256969534],
            [29.939147535171646, -1.392224604095738],
            [29.938130035008893, -1.392347370235085],
            [29.9340642034391, -1.389611990813596],
            [29.929134241973337, -1.387620059666286],
            [29.9279337424108, -1.386222442713947],
            [29.92528356859218, -1.385412381368036],
            [29.921615199314825, -1.385283500027365],
            [29.91810094141431, -1.386395766816856],
            [29.918703887938058, -1.389887969980605],
            [29.91680012249242, -1.402680532341224],
            [29.919984142626493, -1.403281712162793],
            [29.925091831279637, -1.402272682873271],
            [29.92862414980893, -1.40272548673248],
            [29.94060752747706, -1.411017038097893],
            [29.94297900257202, -1.413798686570723],
            [29.942679612952443, -1.415710385114825],
            [29.942974623285004, -1.417144848132644],
            [29.94166333360015, -1.420937419215731],
            [29.94106519126654, -1.424252907848931],
            [29.94207083366754, -1.427122389941544],
            [29.944352431420032, -1.430501487388053],
            [29.944853509888866, -1.433250799308796],
            [29.9457718567055, -1.434775736374445],
            [29.94722036584665, -1.439498184183988],
            [29.94753563768044, -1.442266883641035],
            [29.94303254845118, -1.442618299188487],
            [29.94176108557443, -1.441993050717557],
            [29.938733212399697, -1.438879622501215],
            [29.93797348740098, -1.438620872518398],
            [29.936741478531523, -1.43939238526098],
            [29.936440065905916, -1.442384916302066],
            [29.938227231824335, -1.446577453820101],
            [29.935901392942426, -1.447152126744195],
            [29.93579490215707, -1.445678465557999],
            [29.934874080481805, -1.444831310315612],
            [29.934360404937742, -1.44368454677986],
            [29.931812063241427, -1.443244495807585],
            [29.93153834118448, -1.445154230091132],
            [29.93313409857373, -1.448212570045526],
            [29.932968723221478, -1.45020431520885],
            [29.934268398588024, -1.451625023984549],
            [29.935460931890628, -1.452063246743659],
            [29.93535165812454, -1.45266341863815],
            [29.93410253904387, -1.45397150621939],
            [29.934413136044935, -1.455845346364248],
            [29.935232537924595, -1.456416473326001],
            [29.93441010872241, -1.458862888986898],
            [29.93458039965589, -1.460048020067316],
            [29.9363396315622, -1.460751960926126],
            [29.93901932402104, -1.463313743494846],
            [29.941139613992902, -1.465439178137536],
            [29.942299121632384, -1.467427341122718],
            [29.958294454411156, -1.461436444098436],
            [29.958066262566028, -1.459996274148984],
            [29.959188134388388, -1.456235299452571],
            [29.959091870024228, -1.455599942076682],
            [29.957491497091056, -1.454083001539537],
            [29.957443854041664, -1.453398847503868],
            [29.95875823662603, -1.450908582430373],
            [29.96037349733839, -1.441235752891768],
            [29.957899727488787, -1.439229026081747],
            [29.957324889250252, -1.437878374942636],
            [29.958537482831474, -1.436176423262521],
            [29.95806604786869, -1.433358581375688],
            [29.95832865507065, -1.428978039116485],
            [29.958998267368262, -1.427583246133153],
            [29.96126132658822, -1.425389339326664],
            [29.96206060351058, -1.423038406654624],
            [29.963794296313377, -1.421386193531244],
            [29.963947574053687, -1.420278654496117],
            [29.964975033837995, -1.418293712881048],
            [29.961596957839596, -1.418136466956712],
            [29.954616482143386, -1.415224222444962],
            [29.953556700975145, -1.412892768751234],
            [29.952496707804492, -1.412298074376042],
            [29.950582932431626, -1.407661810038534],
            [29.955788348804568, -1.406459853921153],
            [29.960151440088378, -1.406506605226981],
            [29.961272361493165, -1.406856871343651],
            [29.9609078323374, -1.404948265578953],
            [29.959625127044884, -1.403571916565478],
            [29.959362273704517, -1.401868622192033],
            [29.958611754640856, -1.401182627786994],
            [29.95848282573634, -1.40046373772148],
            [29.958614700216675, -1.398895790328434],
            [29.960110218196608, -1.397198938746678],
            [29.9600394992242, -1.394927669578572],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 225,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "RYAKIRIMIRA TOWN COUNCIL",
        Population: 7198,
        Key: "KABALERYAKIRIMIRA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.909027678566968, -1.343672481754225],
            [29.90183386556717, -1.342501125639526],
            [29.896216481804966, -1.341106561055389],
            [29.894076601373403, -1.340143614234742],
            [29.88548822037033, -1.338177403286944],
            [29.88213529091168, -1.336532039181985],
            [29.879978536525837, -1.337490175559253],
            [29.878554874785465, -1.33766245152653],
            [29.877630704190853, -1.338117120318209],
            [29.88131945714032, -1.344089204255739],
            [29.881873428413115, -1.346339797843273],
            [29.882258662837884, -1.351211760415151],
            [29.882713968549744, -1.352419278318797],
            [29.882628256695224, -1.355028430677532],
            [29.878873596149948, -1.355572239847994],
            [29.878757489797795, -1.361330146185856],
            [29.879073631200775, -1.363463201720294],
            [29.878697172418054, -1.364413487411648],
            [29.87938621886851, -1.367956018595153],
            [29.8787458521233, -1.371480649845761],
            [29.879216424703394, -1.377028133208414],
            [29.879010191277125, -1.379139765131202],
            [29.87995555851918, -1.38132937233257],
            [29.879927077433106, -1.383357217437399],
            [29.88091184927511, -1.386625745430491],
            [29.880543185174105, -1.393184831394731],
            [29.880918903745048, -1.395400661198162],
            [29.88078319795, -1.397322239863239],
            [29.88121354576833, -1.398197877060918],
            [29.881692099879743, -1.402666271369116],
            [29.88120180299094, -1.405016281727528],
            [29.884794519748343, -1.410751870264217],
            [29.885489302840227, -1.412574999203055],
            [29.88530153518293, -1.413192431932205],
            [29.883632159059516, -1.414397324760263],
            [29.88361815791749, -1.417195864915988],
            [29.88319319729594, -1.417861771729684],
            [29.88324553044945, -1.422664051305658],
            [29.88532240933518, -1.42599905988418],
            [29.88835598321873, -1.427966262242574],
            [29.888360595169395, -1.429294342609746],
            [29.88725023076583, -1.430840698650977],
            [29.88882159979341, -1.436006713860708],
            [29.889092496648814, -1.438827757558911],
            [29.890536797182833, -1.441157583773369],
            [29.890922374764024, -1.44281607963304],
            [29.890286660393652, -1.447763635754811],
            [29.890529393268256, -1.449304166337046],
            [29.891690040869854, -1.451990971748486],
            [29.89476795110425, -1.456483848554753],
            [29.899086650341694, -1.459370574285481],
            [29.91039166162977, -1.477998899006551],
            [29.912943804996335, -1.481474346440106],
            [29.91621560221176, -1.480203363879315],
            [29.922825905535607, -1.479807440473153],
            [29.931629175232754, -1.471634724779824],
            [29.942299121632384, -1.467427341122718],
            [29.941139613992902, -1.465439178137536],
            [29.93901932402104, -1.463313743494846],
            [29.9363396315622, -1.460751960926126],
            [29.93458039965589, -1.460048020067316],
            [29.93441010872241, -1.458862888986898],
            [29.935232537924595, -1.456416473326001],
            [29.934413136044935, -1.455845346364248],
            [29.93199557378262, -1.454034993966532],
            [29.930249874097715, -1.450390081180553],
            [29.92461966329156, -1.442469165943599],
            [29.921599148217318, -1.437466073852008],
            [29.919088568102286, -1.42892698218216],
            [29.915759357760432, -1.423483861412903],
            [29.914726477541706, -1.420025692975142],
            [29.914465316627346, -1.416623466402924],
            [29.914784779101964, -1.412945971462688],
            [29.91680012249242, -1.402680532341224],
            [29.918703887938058, -1.389887969980605],
            [29.91810094141431, -1.386395766816856],
            [29.916107586087072, -1.384053100106353],
            [29.913277396173736, -1.382571318147138],
            [29.90851320621721, -1.381299585669594],
            [29.905848178755416, -1.379532481881949],
            [29.903299634039858, -1.377124546686957],
            [29.902090570837697, -1.37422454217525],
            [29.90203387636348, -1.371615980887269],
            [29.902959098885326, -1.368090015319733],
            [29.905964373142453, -1.362040976314252],
            [29.90678647535789, -1.359570840806898],
            [29.90734597037134, -1.350010561601216],
            [29.909027678566968, -1.343672481754225],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 226,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "BUTANDA",
        Population: 18131,
        Key: "KABALEBUTANDA",
        Dist2: "Kabale",
        "Sub Country": "Butanda",
        id2_original: "Kabale Butanda",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.108468987917078, -1.223465546071048],
            [30.107220943221503, -1.222379552444764],
            [30.105678401131378, -1.222066852680685],
            [30.10297146636323, -1.222278620050997],
            [30.102236642664213, -1.221703941286508],
            [30.093512604375125, -1.221298529424802],
            [30.089813874736095, -1.218879372379965],
            [30.08377312037038, -1.21742556303294],
            [30.080777622478468, -1.217353555963733],
            [30.078773107380425, -1.213618139911961],
            [30.076724137353924, -1.211332565133312],
            [30.06699704830346, -1.208093099114826],
            [30.063526885106974, -1.206405233116385],
            [30.059118913991572, -1.206093956814938],
            [30.054458222532205, -1.210085367568194],
            [30.051274272466735, -1.211467846325362],
            [30.04683572449566, -1.211055850643745],
            [30.044305684176646, -1.209826671833215],
            [30.04461144824149, -1.217233366949912],
            [30.043858537862516, -1.226314806368615],
            [30.04894154350661, -1.226202969276599],
            [30.052436759818015, -1.226710385868343],
            [30.053375860412693, -1.227244115167969],
            [30.053813732519817, -1.228635156662745],
            [30.05316310791238, -1.23073483172029],
            [30.04945486870774, -1.233836448752694],
            [30.04957124994437, -1.234398697804625],
            [30.052989265040285, -1.236755078463181],
            [30.053838515241875, -1.238117068459589],
            [30.054069761358956, -1.239981192756517],
            [30.053665600329474, -1.243663961032978],
            [30.052485787171303, -1.24591087086613],
            [30.05271593015719, -1.248307527431173],
            [30.05227476392791, -1.250476204183404],
            [30.055296569881218, -1.252630510432208],
            [30.05559751987445, -1.253348844430332],
            [30.05657990848602, -1.257263321499845],
            [30.05667453971299, -1.259992985163021],
            [30.056571908988403, -1.26294711366005],
            [30.055894083394154, -1.26616660101758],
            [30.059165227534365, -1.275322485259114],
            [30.0615255159091, -1.278116151255575],
            [30.064166907797464, -1.283736373848953],
            [30.067245315698514, -1.287153820646865],
            [30.068639983414773, -1.290014586018412],
            [30.07047247023759, -1.29221558852977],
            [30.073533950285434, -1.294730313921251],
            [30.07660093790429, -1.298581644762474],
            [30.078247081797798, -1.299290712068097],
            [30.078858034107384, -1.300419834611527],
            [30.083248578804593, -1.304510316147538],
            [30.085063009490185, -1.304324291830508],
            [30.088438602545136, -1.30617026116654],
            [30.091209610549235, -1.306239272470448],
            [30.09429832931311, -1.304772714274393],
            [30.095417533139077, -1.303847389308437],
            [30.10011337028562, -1.302958058271673],
            [30.10083353527583, -1.303170154037428],
            [30.100987355598583, -1.302336802086317],
            [30.099454870148065, -1.30134671541888],
            [30.099308253415604, -1.297997709209274],
            [30.09694131391449, -1.294036152670753],
            [30.097231069102662, -1.292461363449348],
            [30.09451982960768, -1.289849315441654],
            [30.094001298669472, -1.287793436582567],
            [30.093025138976113, -1.287311764792077],
            [30.091037938006853, -1.285062582734688],
            [30.090518487193822, -1.283321635938751],
            [30.08855015623543, -1.280472966641646],
            [30.08891937280036, -1.279601913460283],
            [30.09410215971295, -1.276285024976327],
            [30.098027810080975, -1.274891374653155],
            [30.102790079439373, -1.273922586380078],
            [30.1126547077464, -1.273519735844653],
            [30.11898736696874, -1.274202366660457],
            [30.123301240456474, -1.275581662243532],
            [30.127038655144915, -1.277423318254736],
            [30.129808604035265, -1.277404528373279],
            [30.13779219068006, -1.269200512832024],
            [30.138722662956408, -1.265840934343911],
            [30.13777110272876, -1.261447914419902],
            [30.135627389185885, -1.257543382886354],
            [30.135310439299115, -1.254559509483949],
            [30.13355740576824, -1.252644245982902],
            [30.13426787613994, -1.23944725136423],
            [30.133910066382494, -1.23472770574329],
            [30.133274104975413, -1.233373477247195],
            [30.132151402211413, -1.23259523045836],
            [30.129946163953065, -1.23336172731122],
            [30.12738984252206, -1.233388111005192],
            [30.124469615366138, -1.231742401884704],
            [30.122146937655714, -1.232479143784953],
            [30.11967407779947, -1.23484296336616],
            [30.117234051366875, -1.235490765826348],
            [30.11626481139612, -1.235312030962783],
            [30.114650466067033, -1.234481575998049],
            [30.111512776543726, -1.231400656611923],
            [30.108468987917078, -1.223465546071048],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 227,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "KAHARO",
        Population: 19400,
        Key: "KABALEKAHARO",
        Dist2: "Kabale",
        "Sub Country": "Kaharo",
        id2_original: "Kabale Kaharo",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.894592619723728, -1.172545107527012],
            [29.892972309581147, -1.171601374187531],
            [29.890530729063105, -1.166780043886575],
            [29.890436684436008, -1.164056301941741],
            [29.892147618421074, -1.163018448891033],
            [29.89289557728621, -1.163090982785184],
            [29.89477101615601, -1.165416928885048],
            [29.89915743489112, -1.16841240728658],
            [29.899513803750853, -1.168269387503697],
            [29.90097673983546, -1.166012225194811],
            [29.901890207003458, -1.160410504742197],
            [29.9073913308016, -1.153660493079391],
            [29.91128134410398, -1.151579940737654],
            [29.91254397923641, -1.151637059355307],
            [29.91523636039866, -1.150859579821073],
            [29.917446734325484, -1.148811061901068],
            [29.921394566792838, -1.149024491034943],
            [29.92228600098186, -1.148188852961517],
            [29.92249475058927, -1.147292716257684],
            [29.917185793498412, -1.142984458180543],
            [29.91522865375183, -1.141070120811608],
            [29.91350956306395, -1.138618232310741],
            [29.91123020481148, -1.132640098061579],
            [29.91049179054627, -1.12914353545943],
            [29.910614143782905, -1.125707651610155],
            [29.90999240899499, -1.124153313338981],
            [29.909072703925652, -1.123674281873072],
            [29.9082119921193, -1.1235538535309],
            [29.90455903613557, -1.125282902308349],
            [29.903133891276656, -1.125580163956172],
            [29.900225437440827, -1.125039252529781],
            [29.89791431475993, -1.121033127303046],
            [29.89610216310021, -1.122405584316333],
            [29.894795765640414, -1.122702970200746],
            [29.890188712586664, -1.128459347847885],
            [29.889222149595458, -1.128980753713264],
            [29.885931047584574, -1.13254724028788],
            [29.884917282616787, -1.138150517975898],
            [29.883598527033588, -1.142070602304438],
            [29.88268667234151, -1.142763602803113],
            [29.8819957960228, -1.144051697472035],
            [29.880260487150792, -1.14518981006402],
            [29.876785496408008, -1.145876194142211],
            [29.875852012080518, -1.146731002692636],
            [29.87585757444875, -1.151470736641138],
            [29.874898388422675, -1.15540269310478],
            [29.876222905800056, -1.163922471603054],
            [29.877141938031272, -1.164710514050717],
            [29.88059039074394, -1.165779146269397],
            [29.88261081500565, -1.168836896914339],
            [29.88343811577162, -1.169393365520475],
            [29.883451615653705, -1.169868183401253],
            [29.884096477568622, -1.171802027535703],
            [29.883555849871076, -1.175303113732205],
            [29.884249985277624, -1.176804617931839],
            [29.887689508736376, -1.176548350293593],
            [29.891290645402975, -1.173971121168037],
            [29.892989462911487, -1.173286797020551],
            [29.894592619723728, -1.172545107527012],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 228,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "HAMURWA TOWN COUNCIL",
        Population: 5100,
        Key: "RUBANDAHAMURWA TOWN COUNCIL",
        Dist2: "Kabale",
        "Sub Country": "Hamurwa T.C",
        id2_original: "Kabale Hamurwa T.C",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.98306912037798, -1.122912229389719],
            [29.976846518252636, -1.121999292272158],
            [29.97468201140587, -1.122824388331332],
            [29.9736276461805, -1.122823291698986],
            [29.972626516915483, -1.122318150101477],
            [29.971967430178026, -1.12242359118375],
            [29.969913304720144, -1.120590775506002],
            [29.968383637284656, -1.121411662364995],
            [29.966089944615206, -1.121860308224801],
            [29.964614528236357, -1.121195484670883],
            [29.962057118047277, -1.121776509676963],
            [29.96026592048988, -1.120607261827672],
            [29.95849324799027, -1.120487593188628],
            [29.958608150599936, -1.125065098365268],
            [29.957597280003963, -1.127478195038166],
            [29.955623892428843, -1.129600818447095],
            [29.95473121137818, -1.131640202480796],
            [29.956994641602346, -1.136185162220249],
            [29.959487017358164, -1.137473963972903],
            [29.96066101841645, -1.139060617288422],
            [29.96184776836524, -1.139776577602333],
            [29.96156180137266, -1.140706857545349],
            [29.964322988994056, -1.14620619610116],
            [29.964535146809645, -1.147756830276472],
            [29.96534188603709, -1.148472710283092],
            [29.965220614372033, -1.150905913659417],
            [29.964447617663332, -1.151991132428831],
            [29.964038521289662, -1.157119897045605],
            [29.964774039386427, -1.157811904149189],
            [29.966174814748314, -1.15826551549715],
            [29.967122257996998, -1.160722880094117],
            [29.966670499732174, -1.16119986572797],
            [29.96206129611164, -1.162796908896141],
            [29.95938927077376, -1.162951243601805],
            [29.956658024000795, -1.162950477496718],
            [29.95221242245811, -1.161386816139012],
            [29.946451874189055, -1.166750894210774],
            [29.942671785931367, -1.167597977056136],
            [29.94161482008323, -1.167463819966923],
            [29.93877102608325, -1.168316284183653],
            [29.94429974882186, -1.172842780987567],
            [29.94238008229736, -1.175612466132163],
            [29.941452097456036, -1.178094967560063],
            [29.94210929054485, -1.181510539038103],
            [29.94520920950373, -1.187368006984468],
            [29.944920473903395, -1.189496426910116],
            [29.94310775181349, -1.195126694018785],
            [29.947361499262602, -1.193490540972078],
            [29.949677174605387, -1.191275674584164],
            [29.952803366591347, -1.193274861840095],
            [29.954365296121928, -1.195338836209672],
            [29.958591027812293, -1.199179760482837],
            [29.9609450549295, -1.202175975688564],
            [29.965588887705906, -1.206483080027803],
            [29.96748365382906, -1.206418679711508],
            [29.970059850485708, -1.207752058553834],
            [29.97158023832428, -1.207554186590386],
            [29.972922832500156, -1.208753138560707],
            [29.977326436006674, -1.211197324349647],
            [29.977854580715018, -1.211752293537784],
            [29.976727282170028, -1.215077284306771],
            [29.977189353992628, -1.215610005539135],
            [29.982584229550543, -1.218210564440928],
            [29.984346252522435, -1.218678226713682],
            [29.986175333832026, -1.218281130017115],
            [29.99232661331702, -1.214318648804795],
            [29.994339040776097, -1.212008934203397],
            [29.99520047213296, -1.211961728416962],
            [29.99792546663156, -1.214421236719987],
            [30.000891334492145, -1.215436036533592],
            [30.0044335362862, -1.214572993649037],
            [30.006301037642146, -1.213515410962452],
            [30.00759338275595, -1.213276016022538],
            [30.008503894466692, -1.212121029643845],
            [30.00840918688294, -1.211205761237938],
            [30.006412779978668, -1.198824762941561],
            [30.005570184496673, -1.19610659919887],
            [30.005628728602044, -1.191612606499072],
            [30.010284764093296, -1.19001689467445],
            [30.011945467880928, -1.190520977912504],
            [30.014315819183484, -1.192292898055718],
            [30.019890355103264, -1.200248180049394],
            [30.02252218891701, -1.201853113186352],
            [30.023946688785543, -1.202034259919844],
            [30.0265334352569, -1.202192856706046],
            [30.028279311011566, -1.201681110177306],
            [30.02978148640609, -1.198408046631617],
            [30.03020863442536, -1.192587786122396],
            [30.02864898751394, -1.189024007669214],
            [30.027767119484345, -1.18485153874004],
            [30.025008915167977, -1.18113090007727],
            [30.023756395963964, -1.178308601945327],
            [30.02021334346535, -1.175328090624337],
            [30.015599050888735, -1.167888060956348],
            [30.01558049528822, -1.165282457346526],
            [30.015985215069833, -1.1647092396047],
            [30.0155835028478, -1.163776471596767],
            [30.015894630753184, -1.16250992571592],
            [30.015486158708665, -1.158996019830026],
            [30.01247701181432, -1.156266148712338],
            [30.00735218330556, -1.153501598943415],
            [30.002745485984658, -1.148725083463194],
            [30.000715663548455, -1.147392080545125],
            [29.996846586382066, -1.146089589365898],
            [29.992409993145078, -1.143958883176381],
            [29.988375467862937, -1.140975921492054],
            [29.988156170237474, -1.134761431559576],
            [29.98682281343765, -1.127299286171579],
            [29.986230610764718, -1.125748526048066],
            [29.98535291451131, -1.124698665344712],
            [29.98306912037798, -1.122912229389719],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 229,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "NYAMWERU",
        Population: 17360,
        Key: "RUBANDANYAMWERU",
        Dist2: "Kabale",
        "Sub Country": "Nyamweru",
        id2_original: "Kabale Nyamweru",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.012797945729346, -1.419751966059024],
            [30.012321954511457, -1.419751348207855],
            [30.010156694876496, -1.415378910945618],
            [30.007801688595627, -1.409592544067247],
            [30.006149161273676, -1.403678585540119],
            [30.004122208954797, -1.39088846951455],
            [30.004253705244416, -1.387868472469386],
            [30.004933099297165, -1.385110500040125],
            [30.00208401332184, -1.383574371245575],
            [30.001761793917638, -1.382171881761069],
            [30.000628404794995, -1.381746558899221],
            [29.99959298593727, -1.380701837995849],
            [29.99797633014128, -1.378123879643296],
            [29.99548196551543, -1.377925080693976],
            [29.99570576549711, -1.380305627107652],
            [29.99534890166567, -1.380696449669047],
            [29.993696342902687, -1.380922593244972],
            [29.992145477921458, -1.377562179125968],
            [29.991335298146492, -1.377756788676302],
            [29.991527392988548, -1.379582980407117],
            [29.989657103261948, -1.383990515675932],
            [29.99081022477809, -1.38450291515524],
            [29.99274364630621, -1.386563529269493],
            [29.99382096438542, -1.388378910662892],
            [29.99275111669614, -1.389810766332066],
            [29.99076929843206, -1.390228847659527],
            [29.989993958917093, -1.39133392592277],
            [29.988967221378257, -1.395383008251158],
            [29.988504703092964, -1.399161093316964],
            [29.990897454785443, -1.402018085847653],
            [29.990296835796602, -1.403409743864712],
            [29.987753414173092, -1.406149749205233],
            [29.985564308758907, -1.40633395075228],
            [29.982181150092668, -1.408417031848017],
            [29.98861684517979, -1.419943871705753],
            [29.99140388811171, -1.422930201127699],
            [29.986424058469566, -1.427759359158085],
            [29.98408049762375, -1.430819530165522],
            [29.984848348782517, -1.434215279796548],
            [29.984800976126014, -1.435701129321303],
            [29.983569502652458, -1.439437128798234],
            [29.982580047892892, -1.440487378552108],
            [29.98226048480696, -1.441675678528181],
            [29.980538653359176, -1.442989773088908],
            [29.984951032507702, -1.443157735301918],
            [29.987496550799072, -1.442383152569862],
            [29.98804482585464, -1.441832817770231],
            [29.988595521869886, -1.439434795711578],
            [29.989984152009114, -1.436648894587463],
            [29.990276657838667, -1.434639512749313],
            [29.99240493473172, -1.432729799297286],
            [29.993083641573286, -1.430947830653771],
            [29.997785638467693, -1.431343012779978],
            [30.002066329985446, -1.433218325492413],
            [30.003761318874236, -1.431569243048681],
            [30.006388461685606, -1.430590865249223],
            [30.008591153220124, -1.429158107882424],
            [30.009935908742584, -1.427148309972848],
            [30.012797945729346, -1.419751966059024],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 230,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "KATUNA TOWN COUNCIL",
        Population: 10068,
        Key: "KABALEKATUNA TOWN COUNCIL",
        Dist2: "Kabale",
        "Sub Country": "Katuna T.C",
        id2_original: "Kabale Katuna T.C",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.16379279380332, -1.226240071080859],
              [30.16459858081655, -1.225678387017161],
              [30.165052538157163, -1.224244493350677],
              [30.1631924290377, -1.216400494046904],
              [30.160325144093015, -1.213599802224907],
              [30.1591061320491, -1.211721548387646],
              [30.158609473291456, -1.210740750702796],
              [30.15821142350083, -1.207919169143558],
              [30.15101636543605, -1.196482671464562],
              [30.14910934180087, -1.194340651316857],
              [30.145600197110973, -1.191969573653794],
              [30.143847000086723, -1.190087692695865],
              [30.139357854507278, -1.187448214701863],
              [30.13826561900446, -1.187064554761869],
              [30.137267856625137, -1.187206963755085],
              [30.135793908991772, -1.188448625842115],
              [30.133560367513738, -1.18921133881775],
              [30.132752036471636, -1.189927721982256],
              [30.13132534740875, -1.191408498611942],
              [30.130286884160526, -1.193426293030373],
              [30.135250887284002, -1.19830826024341],
              [30.140282507497197, -1.204367966313457],
              [30.13943984823484, -1.20724881463422],
              [30.138116875959703, -1.208729845039992],
              [30.137468233934094, -1.210350131840566],
              [30.137535896837907, -1.21145856161781],
              [30.138497765233442, -1.213052849980705],
              [30.13761407811539, -1.215656552944982],
              [30.137446012308896, -1.218399559582445],
              [30.13787832564108, -1.219269937020554],
              [30.136324106350557, -1.220180240626219],
              [30.133691561071103, -1.22078539712652],
              [30.13304386676811, -1.221262397512335],
              [30.13278315141814, -1.222999186891453],
              [30.133811040597156, -1.230165705080205],
              [30.133274104975413, -1.233373477247195],
              [30.133910066382494, -1.23472770574329],
              [30.13426787613994, -1.23944725136423],
              [30.13355740576824, -1.252644245982902],
              [30.135310439299115, -1.254559509483949],
              [30.139004895652356, -1.254346751394017],
              [30.14046160102213, -1.2526231154718],
              [30.140556596066816, -1.250810849297189],
              [30.141465242875025, -1.247608438386325],
              [30.143135039409973, -1.24371367196882],
              [30.143114609025453, -1.242064051725613],
              [30.144295252226982, -1.239375972353596],
              [30.14411108322068, -1.230565948783314],
              [30.144232798653476, -1.229059936922692],
              [30.14475646346349, -1.228391183612259],
              [30.14758219863136, -1.228179549645267],
              [30.150943354861358, -1.227358912384325],
              [30.155483371137006, -1.224734728569878],
              [30.15728840185147, -1.224426160387043],
              [30.16062431003208, -1.224370503601328],
              [30.162214203219143, -1.224802820579704],
              [30.16379279380332, -1.226240071080859],
            ],
          ],
          [
            [
              [30.113240780315838, -1.156074163032949],
              [30.112386937028194, -1.155642827716713],
              [30.110047847995855, -1.149854666410582],
              [30.110492124192653, -1.147237436035921],
              [30.110189702758976, -1.144033610804971],
              [30.10897031881253, -1.142346760505695],
              [30.107524176732195, -1.141293174060585],
              [30.104981977715795, -1.136162252499095],
              [30.103678745919034, -1.134869761504125],
              [30.09929119979824, -1.132569592292842],
              [30.096721302128365, -1.129494624982487],
              [30.094303118231895, -1.127770545425533],
              [30.09236818483916, -1.127828041734747],
              [30.09001896550536, -1.127275440516888],
              [30.08831153045829, -1.126317192616555],
              [30.084912314406328, -1.122428475284933],
              [30.08315163172084, -1.118302639135441],
              [30.082679105304955, -1.116257933261257],
              [30.079133568964604, -1.120852020284651],
              [30.07768056375548, -1.123384330912144],
              [30.07705295039233, -1.128762394995579],
              [30.07848063748349, -1.133198607119057],
              [30.079145155435135, -1.133295018810133],
              [30.079737135325885, -1.13408460732114],
              [30.0781480748771, -1.139425685120939],
              [30.078149911931835, -1.144577381038868],
              [30.076577405637092, -1.147492011552407],
              [30.074913042112986, -1.148804835133049],
              [30.072716270476178, -1.149220550229964],
              [30.07244985172247, -1.151921571073474],
              [30.072850214674926, -1.153571545559355],
              [30.074346898668118, -1.159083622677262],
              [30.075625019857714, -1.161045429437852],
              [30.07538429202283, -1.162742453459601],
              [30.073872506451394, -1.16492799434943],
              [30.075977058837776, -1.169564276615478],
              [30.076841133936526, -1.170394054382774],
              [30.084654474563603, -1.175005464782971],
              [30.088397885506563, -1.178858894056133],
              [30.09524016887106, -1.182345595121404],
              [30.099815318257487, -1.185793683300299],
              [30.10186907989771, -1.186827209716649],
              [30.101021147524637, -1.18492676643732],
              [30.10078901477038, -1.179726776501903],
              [30.101271811624883, -1.172196611706146],
              [30.10017229976825, -1.166965011757018],
              [30.100888934379427, -1.163919667641403],
              [30.101237753797495, -1.159635694161353],
              [30.10219716799566, -1.159785270740281],
              [30.10443487586, -1.161050587403317],
              [30.108448021238356, -1.158454380918756],
              [30.113240780315838, -1.156074163032949],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 231,
        District: "RUKIGA",
        County: "RUKIGA",
        Subcounty: "BUKINDA",
        Population: 9858,
        Key: "RUKIGABUKINDA",
        Dist2: "Kabale",
        "Sub Country": "Bukinda",
        id2_original: "Kabale Bukinda",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.638414176966045, -0.835039177866253],
            [29.637309427931296, -0.834474908910318],
            [29.6365070805673, -0.834785243013527],
            [29.636444439245928, -0.835717316752203],
            [29.634560733180574, -0.837704939076389],
            [29.634373279035287, -0.840035118578064],
            [29.632674387864913, -0.842271382586968],
            [29.632981749134295, -0.843358980088856],
            [29.63131463317215, -0.844694213209701],
            [29.62992385066951, -0.847272362020053],
            [29.630107719638477, -0.848453120269869],
            [29.629334269280537, -0.850658725105711],
            [29.627588360288176, -0.853593994188644],
            [29.626038084601777, -0.861205382949139],
            [29.626451838740163, -0.863768852860148],
            [29.62716031754686, -0.864732372329582],
            [29.626603766312602, -0.865974903370172],
            [29.627588468984328, -0.868274562469903],
            [29.627585817157634, -0.870791228982723],
            [29.626874456555477, -0.872561862192269],
            [29.627459476299418, -0.873587471839511],
            [29.627596404701556, -0.875374064033554],
            [29.628396190968697, -0.877487223864573],
            [29.62975097258803, -0.879849234110294],
            [29.62971827570831, -0.881589139801749],
            [29.630118893782306, -0.881962184821891],
            [29.630118235317198, -0.882583589011957],
            [29.62820311157309, -0.885006069684875],
            [29.629652212703995, -0.885690354210676],
            [29.63108234860262, -0.889683597806617],
            [29.632161116562678, -0.890523052081056],
            [29.63228196871449, -0.892884445039806],
            [29.632990860746222, -0.893444077763449],
            [29.63422122390209, -0.896738158123612],
            [29.63602439240894, -0.898059596569728],
            [29.637324617544454, -0.899879728483951],
            [29.637993615394418, -0.903915206330845],
            [29.638609959392312, -0.904871632148489],
            [29.637896462596427, -0.906304743906276],
            [29.637894940850344, -0.907956350943851],
            [29.63843377730721, -0.909292784389844],
            [29.643952123605978, -0.91246494200919],
            [29.64607851403693, -0.914423525251869],
            [29.64829922038617, -0.914766510427384],
            [29.649811365283714, -0.914239116522541],
            [29.650784563231614, -0.91288806758396],
            [29.651802830555624, -0.91264005175126],
            [29.652173993769754, -0.911739201516277],
            [29.65544650604417, -0.909379560597765],
            [29.656300569419074, -0.906937842167174],
            [29.656030445114805, -0.905694867676523],
            [29.656648841763136, -0.904377785592281],
            [29.65603232978028, -0.903954897044881],
            [29.655909791490682, -0.903159414717839],
            [29.656280514530337, -0.902662479904135],
            [29.6573419719549, -0.902414469657576],
            [29.655937574585813, -0.900276056702955],
            [29.65685171010038, -0.899331979991024],
            [29.656840243105805, -0.898524132864929],
            [29.656298505090543, -0.897405295530899],
            [29.654521847664338, -0.897205513154429],
            [29.65476986083618, -0.896062237942061],
            [29.658052748652104, -0.895492232241586],
            [29.66081786550457, -0.894474539143247],
            [29.663696310220022, -0.89133161863642],
            [29.665300417449828, -0.891357300159034],
            [29.670707185803778, -0.889421204590078],
            [29.67178946707492, -0.889464812542155],
            [29.671596448764785, -0.888651081784151],
            [29.670511016203626, -0.888227959683275],
            [29.670637725371076, -0.885096032412991],
            [29.67090977027341, -0.884549317353135],
            [29.672069925598198, -0.884326183558825],
            [29.672414353152885, -0.883870853905474],
            [29.67009840202732, -0.881372646288933],
            [29.666172944797065, -0.87575356511214],
            [29.665002583712322, -0.874850820485694],
            [29.663900433503713, -0.874607382958585],
            [29.66276666978362, -0.871657438940191],
            [29.662837307009347, -0.869991932007729],
            [29.66094491603182, -0.867735591137212],
            [29.661324403933726, -0.867215303443658],
            [29.66242662151598, -0.867389330293405],
            [29.663322828454113, -0.866903987508254],
            [29.662600495829114, -0.865827980922483],
            [29.663290610376446, -0.864752648589276],
            [29.66262206168413, -0.861646797525085],
            [29.66090268892526, -0.858627187783382],
            [29.660420209176067, -0.85880045423849],
            [29.66024824378291, -0.858522779338279],
            [29.66062791314449, -0.85782898407016],
            [29.660284305751688, -0.856961357168661],
            [29.66087060110331, -0.856337060102027],
            [29.660355104674164, -0.855122366103488],
            [29.661148302696994, -0.854289979174008],
            [29.660907545217704, -0.853908180110536],
            [29.661563806753556, -0.852242952844754],
            [29.660565681454866, -0.851340323894031],
            [29.65801700738189, -0.850749237460914],
            [29.658156233674536, -0.849361365545728],
            [29.656624448011588, -0.848163544147446],
            [29.656178098503123, -0.846706005579163],
            [29.655695731941634, -0.846775173692054],
            [29.655593053606363, -0.846115855278464],
            [29.653046022552044, -0.843928668507845],
            [29.650635625252445, -0.842886595552328],
            [29.649601444273184, -0.843580080927264],
            [29.6496037727064, -0.841290001809156],
            [29.64770832835524, -0.842017776951276],
            [29.646642133215853, -0.840317074818652],
            [29.645712458643494, -0.839865566314558],
            [29.643610505981545, -0.840419762768741],
            [29.643473168845965, -0.839968624342646],
            [29.642026344046, -0.839933257877361],
            [29.640821475077885, -0.839099941621363],
            [29.640800001749334, -0.838271095624546],
            [29.63910090486476, -0.837260157035786],
            [29.638414176966045, -0.835039177866253],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 232,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "BUTOGOTA TOWN COUNCIL",
        Population: 10315,
        Key: "KANUNGUBUTOGOTA TOWN COUNCIL",
        Dist2: "Kanungu",
        "Sub Country": "Butogota T.C",
        id2_original: "Kanungu Butogota T.C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.821999798444946, -0.781146419316844],
            [29.821905265134355, -0.776558979053542],
            [29.82277698220122, -0.773043904408368],
            [29.82199678100393, -0.771403049718678],
            [29.82190947553809, -0.76870743465588],
            [29.82226999551274, -0.765093583588659],
            [29.824081574047316, -0.756499639728126],
            [29.819380753945907, -0.749870294529267],
            [29.818873942428905, -0.745347978286266],
            [29.81736203558492, -0.744100302198898],
            [29.81438787537594, -0.742842836741458],
            [29.80908016514668, -0.73951759402508],
            [29.807014215164674, -0.733938184285057],
            [29.806461857266168, -0.730653846264522],
            [29.80498244428263, -0.727489857814299],
            [29.80308829709871, -0.725147723945646],
            [29.802969270323562, -0.724415655565102],
            [29.80251390172964, -0.724918285643712],
            [29.800483463049126, -0.725598003428454],
            [29.79759622203043, -0.729288517848745],
            [29.7974887745393, -0.730148831093187],
            [29.796419534111124, -0.731331142422054],
            [29.796240923879797, -0.732083876430448],
            [29.796482276043832, -0.734524427006051],
            [29.79392207748409, -0.739122403236681],
            [29.789781650711422, -0.744258195638765],
            [29.788010390363443, -0.744801420313012],
            [29.78283451598695, -0.748708408697774],
            [29.782482032340827, -0.751231300574111],
            [29.78091654188845, -0.75297254909815],
            [29.782679731771907, -0.75543407094433],
            [29.78252656182945, -0.75729289519173],
            [29.78130029139805, -0.758522250671794],
            [29.780923209184476, -0.760141708017538],
            [29.7809172794053, -0.763230797887638],
            [29.782168183438436, -0.76688801820119],
            [29.78299758087227, -0.766956929877637],
            [29.783240792548927, -0.767777235547816],
            [29.7806830158472, -0.771882832329958],
            [29.780095109816244, -0.773508986346193],
            [29.78112462853917, -0.781216067311681],
            [29.780710210545795, -0.781729708550501],
            [29.779937764504346, -0.781729147155705],
            [29.779808561613645, -0.783834026803009],
            [29.778806168419013, -0.784598751154833],
            [29.77858467710764, -0.786610612189425],
            [29.77804474021453, -0.787326460618677],
            [29.778488143248886, -0.788693630049382],
            [29.778192787064945, -0.789513510222409],
            [29.77846277302862, -0.790541598105114],
            [29.77742795604212, -0.79118600785903],
            [29.777594600713876, -0.792208515526341],
            [29.776853420535872, -0.792907836471239],
            [29.777666219798203, -0.794526753383739],
            [29.7769595690631, -0.797057653594777],
            [29.778219245144992, -0.801022452336074],
            [29.778674683807516, -0.801799138799501],
            [29.779446463299024, -0.80212776333746],
            [29.77875062019513, -0.804680552240026],
            [29.779370316705663, -0.804899706073663],
            [29.779619248854033, -0.80555597286268],
            [29.779061942136618, -0.80681306849972],
            [29.779616020308897, -0.8079000972374],
            [29.77427051795566, -0.811834079915396],
            [29.771871419665686, -0.811914323753023],
            [29.77021332638225, -0.811393668442937],
            [29.766083813241995, -0.80902873958439],
            [29.762038411158393, -0.805400887766996],
            [29.759901368504792, -0.805022053523013],
            [29.758040557801092, -0.80525032972735],
            [29.74925257743011, -0.814195779812639],
            [29.74913270893352, -0.814953340559836],
            [29.751269155105778, -0.817065150040797],
            [29.75127943632419, -0.818893000320865],
            [29.75194478701411, -0.81939579438654],
            [29.75449761579526, -0.820179108908314],
            [29.755858423313523, -0.820012691491026],
            [29.757050656578794, -0.82085077594394],
            [29.758329071517508, -0.820237808695308],
            [29.75813709165985, -0.819037697842215],
            [29.758443010234892, -0.818786756643242],
            [29.76019100511535, -0.819402004703304],
            [29.760047695979758, -0.821662299769757],
            [29.760985171522048, -0.824955969556988],
            [29.760595352096097, -0.825513778959852],
            [29.759041126517356, -0.825205646569801],
            [29.758789738375015, -0.825958925205706],
            [29.75956295606927, -0.82808037756511],
            [29.762226180612323, -0.829198663131334],
            [29.76378844162127, -0.832450924090128],
            [29.76647896686411, -0.833820394796819],
            [29.769725393859275, -0.8348833465941],
            [29.770722032446173, -0.836363163629154],
            [29.771834083885857, -0.835638447670091],
            [29.77322243644568, -0.835611571138814],
            [29.773751845981938, -0.83466317761647],
            [29.773945721284875, -0.834914469015907],
            [29.774055062424647, -0.835779672063349],
            [29.773692823972848, -0.836421232626298],
            [29.77124537116778, -0.838456541045943],
            [29.769822032820898, -0.842111203328143],
            [29.77001464419425, -0.842976475743466],
            [29.771459037254733, -0.84269851856219],
            [29.772902061282746, -0.843090331168372],
            [29.773261176292305, -0.844011495868598],
            [29.773092180729485, -0.845211353910669],
            [29.77453285386639, -0.8460259598902],
            [29.772029467460147, -0.849005829849411],
            [29.772187022977835, -0.85065135524112],
            [29.77342413697303, -0.851754617075249],
            [29.775085704041672, -0.852360000256429],
            [29.775784390313486, -0.85360890636392],
            [29.77674646442319, -0.853388177061714],
            [29.777606706410626, -0.853992928540472],
            [29.77852597130549, -0.855121241538013],
            [29.779103489218507, -0.856853322584821],
            [29.780233366826657, -0.857850938231446],
            [29.781530835930873, -0.860207803208601],
            [29.781168702581958, -0.860972688079788],
            [29.78274945630932, -0.861920268558148],
            [29.783691284189178, -0.861820342289315],
            [29.785912930176217, -0.862869147617375],
            [29.78715225402704, -0.864259482928796],
            [29.787760301184974, -0.865739955177002],
            [29.788500709710146, -0.86616337892541],
            [29.788696549628597, -0.868378454175245],
            [29.790630173277663, -0.869886958899816],
            [29.794115180235885, -0.865794935676471],
            [29.797241983974533, -0.863309552408652],
            [29.79977926830801, -0.860043914172402],
            [29.80327753978972, -0.858670839207311],
            [29.805334927030422, -0.858385761214005],
            [29.80827427842045, -0.855240991591644],
            [29.811652259197416, -0.85274037400509],
            [29.811592009191294, -0.853371896903151],
            [29.812511378290754, -0.855175835957993],
            [29.812731220295287, -0.853898650942032],
            [29.814880088371247, -0.85147855575966],
            [29.81885411661059, -0.849838013127236],
            [29.820646605945377, -0.849505181694508],
            [29.822972224740003, -0.850491009260176],
            [29.824703622347286, -0.853017346919213],
            [29.827471872523457, -0.854337688784609],
            [29.830323672309238, -0.854314356740743],
            [29.83202847169926, -0.853387334535433],
            [29.83453982436543, -0.853302250159495],
            [29.834972067629003, -0.853650694945851],
            [29.835405926063462, -0.853215866961762],
            [29.8354670186893, -0.851533326281691],
            [29.83610177006569, -0.85164984825854],
            [29.838412510064288, -0.850839314179106],
            [29.840004072321154, -0.851296983169546],
            [29.839852306445458, -0.849107475638594],
            [29.840834136304938, -0.849181893784707],
            [29.84194934622115, -0.8485492824602],
            [29.843275940503485, -0.848484021622033],
            [29.844575409257505, -0.845392014197385],
            [29.844011260072566, -0.844571408888884],
            [29.84369677965451, -0.844035355228499],
            [29.842325936157916, -0.841251229311448],
            [29.84219652306146, -0.840682474648383],
            [29.842295197605534, -0.840288872548716],
            [29.842586272418846, -0.838905755661417],
            [29.84280621952624, -0.837735825244139],
            [29.84291706983567, -0.836686101399286],
            [29.84302641187374, -0.836423723389154],
            [29.843321487783324, -0.835767812868487],
            [29.843643688322928, -0.835128322595597],
            [29.843971923744594, -0.834220909349325],
            [29.843722781390436, -0.833652083604996],
            [29.843703657156322, -0.832317945241627],
            [29.843136420461757, -0.830299896554951],
            [29.842801026365585, -0.829348273548136],
            [29.84209581383326, -0.82831981016625],
            [29.841629145331382, -0.82772894840132],
            [29.841363827013886, -0.82707808893263],
            [29.84121020072727, -0.82643838617066],
            [29.840946952128185, -0.824425316030586],
            [29.84109492890999, -0.823192295560709],
            [29.84130287452523, -0.821611002258832],
            [29.840601416950776, -0.81984171378698],
            [29.84010436113778, -0.818444063681653],
            [29.83936310999287, -0.817322898088035],
            [29.837091671287954, -0.814220621111676],
            [29.835666192255786, -0.813137452844309],
            [29.835087550550334, -0.812949738224055],
            [29.83305160340052, -0.813714422127143],
            [29.832895766359975, -0.81376992971804],
            [29.830829009690873, -0.813289730691676],
            [29.829547998620985, -0.812529186626978],
            [29.828204911270003, -0.81184148308672],
            [29.826903688106253, -0.81047751365782],
            [29.826748412512764, -0.810347060786319],
            [29.826345995113243, -0.809915246068735],
            [29.8265738375137, -0.809332767425994],
            [29.82651225440771, -0.808750113545553],
            [29.826181947471003, -0.808188020871041],
            [29.826237109419335, -0.807710908385532],
            [29.826370874853357, -0.807727820185055],
            [29.82649035797266, -0.807826344799561],
            [29.82677329135454, -0.807815608304174],
            [29.826763150273308, -0.807421931997091],
            [29.826682372864642, -0.80701176601571],
            [29.82678266078297, -0.805798037711294],
            [29.82696986878985, -0.804649956842324],
            [29.826611980878983, -0.804048250002072],
            [29.82611857402263, -0.80321135491112],
            [29.825913540745585, -0.80234730264751],
            [29.82566450439261, -0.801723806269473],
            [29.825340794683353, -0.800345729481194],
            [29.825243769446146, -0.799897317150349],
            [29.82470716620107, -0.79888540688548],
            [29.823926334386446, -0.797583537524364],
            [29.822950293270665, -0.795964410727024],
            [29.822337334124768, -0.795061831007807],
            [29.822185813489146, -0.794646189982479],
            [29.82198162193351, -0.793333792935213],
            [29.82191796821078, -0.792502650619078],
            [29.821766061299606, -0.792294794952096],
            [29.821440703181803, -0.791758734307075],
            [29.821348976208153, -0.791359513485335],
            [29.821688721743534, -0.790102202038948],
            [29.821679598453514, -0.789183621768195],
            [29.821441053524772, -0.788767909193234],
            [29.821376873389276, -0.788210164814104],
            [29.821551693628415, -0.787816627653296],
            [29.82145021184908, -0.786848784320856],
            [29.821429193068063, -0.7864660536446],
            [29.82147832013433, -0.785693575207636],
            [29.821857612203463, -0.784344895779944],
            [29.821847716362306, -0.783830938684088],
            [29.821844418646894, -0.782731938266036],
            [29.821999798444946, -0.781146419316844],
          ],
          [
            [29.795708390901293, -0.823154401346763],
            [29.79529021884832, -0.821761349503895],
            [29.795585398962466, -0.819651402715982],
            [29.795292639807997, -0.818722688152691],
            [29.79326132437178, -0.817254618700487],
            [29.794890187374193, -0.815779882091442],
            [29.796841847397552, -0.815269017027321],
            [29.79804446698417, -0.814302127805632],
            [29.798454919813885, -0.81379003468099],
            [29.798640162306953, -0.811982532271315],
            [29.799886224420693, -0.809720408370116],
            [29.802418034420832, -0.808654923167707],
            [29.8031405116746, -0.806890540510645],
            [29.803169847058513, -0.805538393671818],
            [29.802350906014595, -0.804057442455467],
            [29.800315731415917, -0.80287448473553],
            [29.799835939426043, -0.801621562846275],
            [29.80009252072907, -0.798974353010385],
            [29.80055960964252, -0.798348435394899],
            [29.804039353371483, -0.796500787003093],
            [29.80446461403036, -0.795106252014522],
            [29.80334961521823, -0.794502543419734],
            [29.807807539849964, -0.791595473903729],
            [29.808855411154184, -0.791933924089687],
            [29.81145659534876, -0.789614702118319],
            [29.81221128529028, -0.789573052990475],
            [29.813426431883556, -0.790502510737878],
            [29.813927032448664, -0.793794837775951],
            [29.815057435571283, -0.795863711215538],
            [29.815766929474243, -0.800084717094682],
            [29.81647863413115, -0.801478022517986],
            [29.81576605182021, -0.801224237341624],
            [29.814675441369747, -0.801940854816902],
            [29.814884439810488, -0.802742908836447],
            [29.81396152595895, -0.803459665270877],
            [29.8116523993346, -0.807593858754201],
            [29.811902699617153, -0.80919782338918],
            [29.81051750463556, -0.811306934019477],
            [29.80854647423976, -0.81193842852154],
            [29.806825323714936, -0.814764748458811],
            [29.805148877850264, -0.814003748374071],
            [29.804351271794314, -0.815311437468264],
            [29.80275770988764, -0.815774409211207],
            [29.802839751225918, -0.818095685832905],
            [29.802126818572013, -0.818306136948862],
            [29.801287596263922, -0.819233939013647],
            [29.80103624315584, -0.818980507053152],
            [29.80015473624901, -0.820330332873092],
            [29.798561103375434, -0.820919896905271],
            [29.797595449479285, -0.82260729303881],
            [29.795708390901293, -0.823154401346763],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 233,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KAMBUGA",
        Population: 21988,
        Key: "KANUNGUKAMBUGA",
        Dist2: "Kanungu",
        "Sub Country": "Kambuga",
        id2_original: "Kanungu Kambuga",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.813551427963745, -0.791515501831405],
            [29.813426421103756, -0.790502500857351],
            [29.812211279002103, -0.789573070056832],
            [29.811456582772337, -0.789614692237789],
            [29.808855422832284, -0.791933916903863],
            [29.807807538951664, -0.791595473903729],
            [29.803349614319934, -0.794502542521524],
            [29.804464616725287, -0.795106245726948],
            [29.804039358761365, -0.796500796883606],
            [29.80055960245598, -0.798348432700236],
            [29.800092514440852, -0.798974338638729],
            [29.79983595559572, -0.80162155745692],
            [29.800315729619292, -0.802874475753275],
            [29.80235091050618, -0.804057452335962],
            [29.80316985693998, -0.805538378401977],
            [29.803140525149324, -0.806890536019504],
            [29.802418029929246, -0.808654915083672],
            [29.799886209149342, -0.809720419148838],
            [29.79864015422211, -0.811982543948238],
            [29.79845491891559, -0.813790040070328],
            [29.798044468780795, -0.814302116128716],
            [29.796841844702595, -0.815269026907789],
            [29.79489018467927, -0.815779867719879],
            [29.79326131179539, -0.817254635766729],
            [29.795292642502954, -0.818722690847374],
            [29.795585383691115, -0.819651404512426],
            [29.795290231424747, -0.821761346809248],
            [29.795708376528246, -0.823154402245001],
            [29.797595459360757, -0.822607277769],
            [29.798561088104044, -0.820919906785725],
            [29.800154728164166, -0.82033033377133],
            [29.8010362341727, -0.818980519628293],
            [29.801287588179083, -0.819233944402979],
            [29.802126834741692, -0.818306132457768],
            [29.802839737751167, -0.818095683138222],
            [29.802757717074147, -0.815774402923631],
            [29.80435125831959, -0.815311431180721],
            [29.80514887515531, -0.814003742086492],
            [29.806825309341914, -0.814764748458811],
            [29.808546485019523, -0.811938441096703],
            [29.810517495652423, -0.811306940307026],
            [29.81190269782053, -0.809197822490939],
            [29.81165239124976, -0.807593863245341],
            [29.813961524162316, -0.803459653593929],
            [29.814884450590284, -0.802742901650608],
            [29.814675438674822, -0.801940854816902],
            [29.815766068888223, -0.801224231952269],
            [29.816478617063137, -0.801478013535727],
            [29.81576694654225, -0.800084711705292],
            [29.8150574418595, -0.795863717503145],
            [29.813927022567196, -0.79379482699722],
            [29.813551427963745, -0.791515501831405],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 234,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KAMBUGA TOWN COUNCIL",
        Population: 5825,
        Key: "KANUNGUKAMBUGA TOWN COUNCIL",
        Dist2: "Kanungu",
        "Sub Country": "Kambuga T.C",
        id2_original: "Kanungu Kambuga T.C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.790630169684405, -0.869886962492657],
            [29.788696564899947, -0.868378459564509],
            [29.788500698930342, -0.866163378027215],
            [29.78776028771025, -0.865739938110939],
            [29.78715223785736, -0.864259489216293],
            [29.785912933769474, -0.862869153904875],
            [29.783691271612756, -0.86182035127147],
            [29.782749462597536, -0.861920282031379],
            [29.781168691802193, -0.860972672810128],
            [29.781530850303927, -0.860207802310405],
            [29.780233382996336, -0.857850924758233],
            [29.77910348023534, -0.856853328872331],
            [29.778525979390334, -0.855121228064757],
            [29.77760669293591, -0.85399292135476],
            [29.776746450050172, -0.853388182450999],
            [29.775784390313486, -0.853608920735378],
            [29.775085709431593, -0.852359984088537],
            [29.77342412439664, -0.851754618871678],
            [29.772187016689625, -0.850651360630442],
            [29.77173154119618, -0.851622423926059],
            [29.770889190954264, -0.852084873128817],
            [29.771126920212737, -0.85341398998276],
            [29.77026434170725, -0.853977111863686],
            [29.770082334047533, -0.854822653224156],
            [29.76787745781021, -0.855404839515661],
            [29.76694209600376, -0.857286752534695],
            [29.76845835249038, -0.860408920513519],
            [29.771399280423715, -0.862404640113411],
            [29.769934006922764, -0.863792817188374],
            [29.770240231823315, -0.8659173351225],
            [29.76981821677759, -0.866561331115334],
            [29.77027385396778, -0.869098743872189],
            [29.769670393607687, -0.870306386040293],
            [29.767443006487667, -0.872096638207368],
            [29.76794852892224, -0.874724699144894],
            [29.768808835588366, -0.875289182247562],
            [29.768742213831967, -0.876206151724056],
            [29.76768468743507, -0.876395712703657],
            [29.762937965219276, -0.875767692164522],
            [29.76071587366785, -0.874960496485527],
            [29.758691300087843, -0.875254595755305],
            [29.75860380867074, -0.879146893600113],
            [29.759582168338262, -0.880758491342787],
            [29.75977665988547, -0.883617836675121],
            [29.760385573917677, -0.884655291551846],
            [29.759016518068467, -0.887956326503746],
            [29.757751347890324, -0.889445283724644],
            [29.757496314384532, -0.891690142268665],
            [29.756350470120505, -0.89360202190818],
            [29.756467861063502, -0.894971304412022],
            [29.75600608927823, -0.895454163594783],
            [29.75532510969901, -0.895373059223011],
            [29.754161921661787, -0.89597614584891],
            [29.752956881115466, -0.897445002483496],
            [29.75129164173395, -0.898631574328043],
            [29.750496643487306, -0.900412856822289],
            [29.750171780341205, -0.902506617289182],
            [29.747475366641655, -0.902727884409983],
            [29.747025686180116, -0.903385457547557],
            [29.747243906725558, -0.904735765430097],
            [29.749593038922775, -0.905554107578563],
            [29.750352834888403, -0.906986785234449],
            [29.753255081365612, -0.90940794917446],
            [29.75598656439552, -0.915768420040657],
            [29.755895766279867, -0.919930765168065],
            [29.755000705592032, -0.922975088913121],
            [29.754912124518476, -0.926067185201474],
            [29.75301129297055, -0.929137499307516],
            [29.752369576057436, -0.929438967498016],
            [29.752586579385678, -0.931049956370201],
            [29.751799654298484, -0.933727219186736],
            [29.753058909070504, -0.935097497754638],
            [29.753008761518068, -0.937513648608133],
            [29.751980133025565, -0.938418824293141],
            [29.75156512304241, -0.940299438007516],
            [29.75266944178411, -0.939883382699702],
            [29.753248048455273, -0.938881056862294],
            [29.753624895310207, -0.938925954021229],
            [29.755488038938708, -0.940754960817185],
            [29.756002946971353, -0.940523648857896],
            [29.756889199677847, -0.940845323643267],
            [29.75826925629601, -0.942540212045002],
            [29.760771305110772, -0.942114517588132],
            [29.760555551339095, -0.943487108412574],
            [29.762841038796754, -0.944826225731612],
            [29.763548104553525, -0.946003508846507],
            [29.76468320496673, -0.946093646089845],
            [29.76563014785383, -0.947083944848436],
            [29.767013091657297, -0.947406072614129],
            [29.767494444020834, -0.946265482048419],
            [29.76884285658481, -0.946141865571021],
            [29.76976418940146, -0.946659689852871],
            [29.76993985136201, -0.947479955232118],
            [29.7697257900163, -0.948050272367763],
            [29.768181870808856, -0.948352000301619],
            [29.76885391574428, -0.949315323014768],
            [29.770378184304878, -0.949922827684242],
            [29.773202938512416, -0.952109289964472],
            [29.774570637905537, -0.951254730038429],
            [29.7752234310461, -0.951677554549613],
            [29.776654372733546, -0.950305039721712],
            [29.778601217786964, -0.949418206414018],
            [29.7791752107108, -0.949729702065212],
            [29.779173813830514, -0.950396106481472],
            [29.780481340472633, -0.95101149438808],
            [29.78186619409443, -0.951020867915011],
            [29.782562931920367, -0.95048369274608],
            [29.78355239117152, -0.950699667419734],
            [29.785449231504643, -0.951992018519207],
            [29.78657229449308, -0.952288785398754],
            [29.788869546287692, -0.954011725885616],
            [29.78985901362369, -0.954227703032785],
            [29.790365419102177, -0.955142393378702],
            [29.79167605481348, -0.955304885011973],
            [29.793768001141494, -0.95288665824218],
            [29.79911485545927, -0.949042488207053],
            [29.802863011303565, -0.944007010611456],
            [29.803125067838234, -0.943043276848019],
            [29.80525941913923, -0.941511645334865],
            [29.8059567759044, -0.940226714805888],
            [29.806590474455287, -0.937249116688817],
            [29.806259619546246, -0.935527989430005],
            [29.806781370046423, -0.934397699981619],
            [29.8060697103053, -0.933680039645138],
            [29.804640061293536, -0.924860059048413],
            [29.804921716372785, -0.920872303566351],
            [29.80624887659376, -0.915110495267497],
            [29.804815520234847, -0.911462923690468],
            [29.804952742386064, -0.909413338387262],
            [29.80372208548111, -0.907800780472288],
            [29.80381502607874, -0.905721464367074],
            [29.803049804288783, -0.904146427256375],
            [29.80132220655519, -0.903446927010389],
            [29.800672701248576, -0.902189472276822],
            [29.801527962976074, -0.899498098441733],
            [29.801291847091854, -0.897529903522195],
            [29.80012929326522, -0.896934843513993],
            [29.79943970692727, -0.895402589528339],
            [29.799555896822753, -0.89278487349122],
            [29.796693044165686, -0.892596889700741],
            [29.794829347174943, -0.891611377641796],
            [29.792932197821354, -0.888917778365966],
            [29.791825139218044, -0.888285640761858],
            [29.787178631258712, -0.888643900617275],
            [29.787110230838053, -0.885951814453943],
            [29.785500678919277, -0.878097202673452],
            [29.787913134259192, -0.872640797882472],
            [29.790630169684405, -0.869886962492657],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 235,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KANUNGU TOWN COUNCIL",
        Population: 15056,
        Key: "KANUNGUKANUNGU TOWN COUNCIL",
        Dist2: "Kanungu",
        "Sub Country": "Kanungu T.C",
        id2_original: "Kanungu Kanungu T.C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.629628748708782, -0.776525872887987],
            [29.62917153317862, -0.7757369010669],
            [29.628379167894035, -0.775805980569651],
            [29.627792355112785, -0.777054856512619],
            [29.626793461754513, -0.776950354325951],
            [29.62665534128803, -0.777297277826501],
            [29.627015855872767, -0.778529183024605],
            [29.62760157091276, -0.778425323110588],
            [29.62773906794846, -0.778737656461884],
            [29.62777188610072, -0.780437848204652],
            [29.628563755515245, -0.780889230394593],
            [29.62873479294874, -0.782138409331556],
            [29.62921686845604, -0.782346793665022],
            [29.62818271891781, -0.783075023147244],
            [29.62762913841219, -0.78557300837713],
            [29.62804214964384, -0.785954845395631],
            [29.628662781300616, -0.785365249372911],
            [29.629317025220352, -0.785643100024438],
            [29.629418394710257, -0.787690291550298],
            [29.628831971797844, -0.788522793851948],
            [29.627109771142482, -0.788313887954598],
            [29.62783216754788, -0.789355114544623],
            [29.627590258428377, -0.790153057119362],
            [29.62683219441463, -0.790360923672434],
            [29.627106595597944, -0.791575441588253],
            [29.626658539290425, -0.791818138715597],
            [29.625866702215234, -0.791332049216966],
            [29.62576278689979, -0.791921857274898],
            [29.62615858371566, -0.792286341715239],
            [29.625572662063167, -0.792598372225486],
            [29.626261316848186, -0.792910945242748],
            [29.62636358375509, -0.794021296588954],
            [29.62722458571724, -0.794229849194922],
            [29.62739607320668, -0.794993262017287],
            [29.628808894078208, -0.794542788566278],
            [29.631184093588338, -0.796313369829115],
            [29.63118371988918, -0.796695039686962],
            [29.631666196045114, -0.796487062071822],
            [29.632354817592475, -0.796834329765545],
            [29.632353706376467, -0.797979349866902],
            [29.631697450230497, -0.799748648779354],
            [29.63272947255813, -0.801206385070975],
            [29.631660247401303, -0.802559136953223],
            [29.631348197824433, -0.804606159308224],
            [29.63021089204718, -0.805126128345131],
            [29.629934649317516, -0.805785258643633],
            [29.63007216791278, -0.806062897734847],
            [29.630899305185388, -0.80568158175265],
            [29.631380727617493, -0.806549236994072],
            [29.631224665998143, -0.807607441728517],
            [29.631947493594883, -0.808197617516736],
            [29.632325300748846, -0.809342796115511],
            [29.63349626999306, -0.809620890364085],
            [29.634666039088053, -0.81111339791624],
            [29.634045110088937, -0.811980571445972],
            [29.634595796222715, -0.812466581245329],
            [29.634215836705334, -0.813507344503074],
            [29.63569619202159, -0.814444835924934],
            [29.635763328512663, -0.816214442951224],
            [29.63838100757248, -0.816631978825584],
            [29.637414958417622, -0.818123555019968],
            [29.638171619262902, -0.819338314374665],
            [29.63803198244022, -0.82117723511491],
            [29.638979477791196, -0.821021514677536],
            [29.639805654764736, -0.821611744190979],
            [29.639769469726755, -0.823346626363156],
            [29.639114427204728, -0.823866795083033],
            [29.638906864271817, -0.824734149094412],
            [29.639076872235975, -0.826954886148775],
            [29.63966176980905, -0.827683808277305],
            [29.6400385699516, -0.829800550340754],
            [29.63983138610773, -0.830286230123009],
            [29.63814290551318, -0.830771227197739],
            [29.639175779443697, -0.831361558558209],
            [29.638520548275448, -0.832055221125261],
            [29.638588671116736, -0.832818597149946],
            [29.63879452006408, -0.83365144676687],
            [29.639483005965815, -0.834137532070589],
            [29.638414176966045, -0.835039177866253],
            [29.63910090486476, -0.837260157035786],
            [29.640800001749334, -0.838271095624546],
            [29.640821475077885, -0.839099941621363],
            [29.642026344046, -0.839933257877361],
            [29.643473168845965, -0.839968624342646],
            [29.643610505981545, -0.840419762768741],
            [29.645712458643494, -0.839865566314558],
            [29.646642133215853, -0.840317074818652],
            [29.64770832835524, -0.842017776951276],
            [29.6496037727064, -0.841290001809156],
            [29.649601444273184, -0.843580080927264],
            [29.650635625252445, -0.842886595552328],
            [29.653046022552044, -0.843928668507845],
            [29.655593053606363, -0.846115855278464],
            [29.655695731941634, -0.846775173692054],
            [29.656178098503123, -0.846706005579163],
            [29.656624448011588, -0.848163544147446],
            [29.658156233674536, -0.849361365545728],
            [29.65801700738189, -0.850749237460914],
            [29.660565681454866, -0.851340323894031],
            [29.661563806753556, -0.852242952844754],
            [29.660907545217704, -0.853908180110536],
            [29.661148302696994, -0.854289979174008],
            [29.660355104674164, -0.855122366103488],
            [29.66087060110331, -0.856337060102027],
            [29.660284305751688, -0.856961357168661],
            [29.66062791314449, -0.85782898407016],
            [29.66024824378291, -0.858522779338279],
            [29.660420209176067, -0.85880045423849],
            [29.66090268892526, -0.858627187783382],
            [29.66262206168413, -0.861646797525085],
            [29.663290610376446, -0.864752648589276],
            [29.662600495829114, -0.865827980922483],
            [29.663322828454113, -0.866903987508254],
            [29.66242662151598, -0.867389330293405],
            [29.661324403933726, -0.867215303443658],
            [29.66094491603182, -0.867735591137212],
            [29.662837307009347, -0.869991932007729],
            [29.66276666978362, -0.871657438940191],
            [29.663900433503713, -0.874607382958585],
            [29.665002583712322, -0.874850820485694],
            [29.666172944797065, -0.87575356511214],
            [29.67009840202732, -0.881372646288933],
            [29.674013437901912, -0.87765019058077],
            [29.67762369157032, -0.875646044840427],
            [29.679098342584542, -0.872492913710013],
            [29.684893527195978, -0.869534764665754],
            [29.686271749454338, -0.868054337015458],
            [29.687341781298294, -0.86607178548704],
            [29.689242243638642, -0.864639601299393],
            [29.690715710673324, -0.862824674376222],
            [29.691618133953234, -0.862469506399106],
            [29.693901877780895, -0.856112699473408],
            [29.694269874433658, -0.852667599662543],
            [29.693295229299867, -0.849655331162571],
            [29.69377845734571, -0.848753365388839],
            [29.693719999478592, -0.846649069387062],
            [29.694719752524595, -0.843495431073094],
            [29.695670088348493, -0.842635924435321],
            [29.696145899005035, -0.841441443232986],
            [29.696337665063687, -0.839243016220882],
            [29.698304150882468, -0.836228760336595],
            [29.701027056798058, -0.834946077374397],
            [29.702542906347826, -0.834946752835788],
            [29.704161486335163, -0.835572075517937],
            [29.704401635655017, -0.836578481227822],
            [29.70481484451603, -0.836786868153153],
            [29.705675776409606, -0.837134258115277],
            [29.707019547378515, -0.836961351774747],
            [29.70804868162251, -0.837571770881345],
            [29.708349242645205, -0.838466549003131],
            [29.708018071529214, -0.838910567420551],
            [29.708634257423622, -0.840087876353449],
            [29.70875427234558, -0.841342689506532],
            [29.709525291862366, -0.842031493642584],
            [29.711218792242736, -0.846274031347738],
            [29.712497001467245, -0.846896438398916],
            [29.71425868218101, -0.8491180727985],
            [29.723677366119723, -0.850641746123362],
            [29.72676390646907, -0.850405392177979],
            [29.728083236974012, -0.849413054316753],
            [29.729275981380702, -0.847348187707572],
            [29.73146131926059, -0.844906211434906],
            [29.731401452835126, -0.839305473872885],
            [29.732174452238787, -0.838028812680394],
            [29.733443338747282, -0.836974454999937],
            [29.734383355623528, -0.834032200494166],
            [29.73419149164853, -0.832949435522418],
            [29.73482554952549, -0.832810909281627],
            [29.735874187092634, -0.831506598746336],
            [29.73606892837151, -0.829674457166023],
            [29.73498276278505, -0.827106092790219],
            [29.734848108917227, -0.823885764642204],
            [29.735180372384622, -0.822331290750545],
            [29.73479607759765, -0.820720991686705],
            [29.73416302942706, -0.819832371366217],
            [29.733847948036086, -0.817902853364912],
            [29.734566443058224, -0.815959889816336],
            [29.73558708193457, -0.815071963667356],
            [29.735452288827865, -0.810667941931674],
            [29.733965863595216, -0.809991038338728],
            [29.731790381132324, -0.808046878138903],
            [29.726927249832126, -0.806531923682462],
            [29.72568802928757, -0.805448742581751],
            [29.72513840945401, -0.803782873367238],
            [29.72219140621441, -0.801644106556628],
            [29.721364708217987, -0.801504972034475],
            [29.72056655418974, -0.800338700849883],
            [29.719106691241734, -0.799422008235975],
            [29.71840575918175, -0.797464616593726],
            [29.71711047028873, -0.797380808301976],
            [29.71791268290543, -0.794299719731864],
            [29.717306656058565, -0.793966350122758],
            [29.71530453137753, -0.79428629031062],
            [29.71467059207815, -0.795469729259866],
            [29.714888659909988, -0.797996020083329],
            [29.714557424115277, -0.798523334770219],
            [29.715162405323152, -0.799939364089014],
            [29.71480285822396, -0.801243952535936],
            [29.710363490989366, -0.803379682650353],
            [29.70763292513933, -0.805488342694288],
            [29.705151463914245, -0.806514443300704],
            [29.704848917614772, -0.805875828611927],
            [29.704160003216625, -0.805764511409038],
            [29.70326641576586, -0.803557206430073],
            [29.702027390155713, -0.802307492319332],
            [29.70172676714925, -0.799670168821422],
            [29.699689295558397, -0.797587333436915],
            [29.700132415623433, -0.795338952547161],
            [29.69952701759727, -0.79436710846109],
            [29.69787421359424, -0.793505886455355],
            [29.697683332376133, -0.791368285595633],
            [29.69677201038504, -0.793283360959725],
            [29.694896199612707, -0.795059227940756],
            [29.694398592234094, -0.796641340895688],
            [29.69161520724202, -0.796418131118901],
            [29.688514028845145, -0.797096978032336],
            [29.6878796044555, -0.797651907963345],
            [29.68597897143527, -0.796596258809342],
            [29.683250630712212, -0.796484103307191],
            [29.680661539637992, -0.794872993668685],
            [29.680137868539727, -0.794900538754148],
            [29.67850990654757, -0.796898555791155],
            [29.67693906572935, -0.796814627125315],
            [29.67572574091949, -0.797535871245623],
            [29.673217820716033, -0.797507070454645],
            [29.672542037890718, -0.798089738513582],
            [29.670923042881725, -0.797950274221207],
            [29.669061650069704, -0.79909456465088],
            [29.66692520299915, -0.799683556906669],
            [29.664583078559488, -0.799231495003564],
            [29.6605544875481, -0.797182595361703],
            [29.658213787836473, -0.795273200406609],
            [29.65731810820937, -0.795272832132811],
            [29.655253617091418, -0.792738983737535],
            [29.652156545792, -0.790334779795298],
            [29.65125148236348, -0.790082911654156],
            [29.650389546153416, -0.790819894831507],
            [29.646470869406954, -0.790948398267659],
            [29.641133092565116, -0.789124541583048],
            [29.639498173121076, -0.787692585630741],
            [29.63889729182415, -0.78565383837403],
            [29.636533016726194, -0.781445764035359],
            [29.635715534546293, -0.780751477555263],
            [29.63541523672995, -0.779580306972937],
            [29.634295251369707, -0.780013571914656],
            [29.63429629431374, -0.778929274560312],
            [29.633651924675593, -0.777324248159033],
            [29.631240516771328, -0.777366644738166],
            [29.62983068639136, -0.776954046960551],
            [29.629628748708782, -0.776525872887987],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 236,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KANYANTOROGO",
        Population: 18949,
        Key: "KANUNGUKANYANTOROGO",
        Dist2: "Kanungu",
        "Sub Country": "Kanyantorogo",
        id2_original: "Kanungu Kanyantorogo",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.74907809765247, -0.814425833086737],
            [29.75250212786752, -0.8112055558279],
            [29.756155183564264, -0.806900052726148],
            [29.758617406469202, -0.805119534463706],
            [29.762038397683636, -0.805400890461688],
            [29.766083822225127, -0.809028725212769],
            [29.770213339856976, -0.811393676526967],
            [29.771871428648858, -0.811914309381446],
            [29.77427051256574, -0.811834077220708],
            [29.779616027495443, -0.807900114303681],
            [29.779061936746736, -0.806813060415681],
            [29.779619263227087, -0.805555964778638],
            [29.779370320298916, -0.80489969260027],
            [29.778750621093426, -0.80468053786839],
            [29.77944647407882, -0.802127765133912],
            [29.778674674824344, -0.801799150476454],
            [29.778219254128164, -0.801022451437864],
            [29.77695956007996, -0.797057658984171],
            [29.777666227883042, -0.794526760569558],
            [29.776853434010597, -0.79290782120135],
            [29.777594600713876, -0.792208529897987],
            [29.777427960533707, -0.791186000673205],
            [29.778462772130293, -0.790541593613956],
            [29.7781927798784, -0.789513516509992],
            [29.778488127079203, -0.788693618372392],
            [29.778044728536436, -0.787326452534599],
            [29.778584660937963, -0.786610599614217],
            [29.77880615674092, -0.78459875205308],
            [29.779808554427138, -0.783834026803009],
            [29.779937750131293, -0.781729163323881],
            [29.78071019796937, -0.781729711245208],
            [29.78112461147119, -0.781216059227592],
            [29.780095099934776, -0.773508990837369],
            [29.780683007762356, -0.771882844006994],
            [29.783240797040513, -0.767777222074302],
            [29.782997587160487, -0.766956935267071],
            [29.782168167268757, -0.76688801820119],
            [29.78156782675765, -0.764379410199627],
            [29.780957692813292, -0.76342219392164],
            [29.78090694608459, -0.760254504928605],
            [29.778282524270228, -0.761397396271372],
            [29.773127903135062, -0.761667204789584],
            [29.77034537064417, -0.762451220950118],
            [29.76889007293445, -0.762545886912685],
            [29.766043297426037, -0.761703432440159],
            [29.761431541691785, -0.76165956349667],
            [29.75756170904227, -0.762264739120949],
            [29.751731121825447, -0.765004961906983],
            [29.749640953263395, -0.765529289614108],
            [29.748335118148944, -0.765166726879918],
            [29.74666738594252, -0.763474960768342],
            [29.74497352803268, -0.762994770313229],
            [29.743507520608134, -0.761810765341529],
            [29.741738545574236, -0.766445682442013],
            [29.736539816260287, -0.773470717111043],
            [29.73523221505798, -0.77596248508064],
            [29.734113700239842, -0.782291029654077],
            [29.730953780108234, -0.786689916072467],
            [29.728802795601446, -0.787966084201312],
            [29.727368085481373, -0.789575645282231],
            [29.725134228694692, -0.791046088829388],
            [29.72455565615955, -0.790823769794485],
            [29.71875303080258, -0.791890258459911],
            [29.71509522301799, -0.79161383371569],
            [29.71530453137753, -0.79428629031062],
            [29.717306656058565, -0.793966350122758],
            [29.71791268290543, -0.794299719731864],
            [29.71711047028873, -0.797380808301976],
            [29.71840575918175, -0.797464616593726],
            [29.719106691241734, -0.799422008235975],
            [29.72056655418974, -0.800338700849883],
            [29.721364708217987, -0.801504972034475],
            [29.72219140621441, -0.801644106556628],
            [29.72513840945401, -0.803782873367238],
            [29.72568802928757, -0.805448742581751],
            [29.726927249832126, -0.806531923682462],
            [29.731790381132324, -0.808046878138903],
            [29.733965863595216, -0.809991038338728],
            [29.735452288827865, -0.810667941931674],
            [29.73728487716032, -0.811061874816191],
            [29.7393253024118, -0.810174357180809],
            [29.742109012594018, -0.810203262974832],
            [29.745663099997607, -0.811648302706249],
            [29.747178818393333, -0.811843246302607],
            [29.747839394537515, -0.81278740922724],
            [29.747866041263784, -0.813731299769044],
            [29.74907809765247, -0.814425833086737],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 237,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KATETE",
        Population: 7276,
        Key: "KANUNGUKATETE",
        Dist2: "Kanungu",
        "Sub Country": "Katete",
        id2_original: "Kanungu Katete",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.73758894700251, -1.010412202030458],
            [29.73715344375276, -1.011622839226688],
            [29.73600498449295, -1.012406784468979],
            [29.735260821908216, -1.011342444165032],
            [29.73415964547336, -1.011161162735538],
            [29.733276479378194, -1.011557157465047],
            [29.731383038270124, -1.01110699287881],
            [29.73019665034236, -1.010215864430533],
            [29.72948960075528, -1.010656829128341],
            [29.72901117420462, -1.009103005739658],
            [29.72796460455929, -1.009043872528156],
            [29.726693301582667, -1.010037167887831],
            [29.725871686254155, -1.00887017427067],
            [29.724551479891772, -1.008366605554104],
            [29.724445868557083, -1.007257572462599],
            [29.720371312549254, -1.005196938521342],
            [29.719839265559315, -1.005416023654101],
            [29.719374677555614, -1.006362673312451],
            [29.719236323527113, -1.008352857171497],
            [29.718317709012553, -1.008704031461037],
            [29.71529585275357, -1.008278421718633],
            [29.712768395989308, -1.006606504930161],
            [29.712167403301276, -1.005384873978095],
            [29.71100952251077, -1.005602498662528],
            [29.70930687638249, -1.004321543624047],
            [29.707600351328814, -1.003982911011563],
            [29.706007211630308, -1.002868636462019],
            [29.705125949065255, -1.002810086953052],
            [29.705098040206, -1.00088912590707],
            [29.703322223602875, -0.999868868039567],
            [29.702804764354834, -0.999147670142925],
            [29.70085397749396, -1.000016505229391],
            [29.700558014947177, -0.999842325068381],
            [29.70045995485075, -0.999270537394004],
            [29.70095388722154, -0.998997393166743],
            [29.701152226253118, -0.998226929963713],
            [29.700807514830814, -0.997530697494311],
            [29.69944912647561, -0.998350176280742],
            [29.698042996256323, -0.997777586272845],
            [29.695575008862203, -0.997726363119854],
            [29.694564989869114, -0.996109997840315],
            [29.693122376371207, -0.995077527735871],
            [29.692725997447045, -0.996369878891258],
            [29.690900342311956, -0.995772186215002],
            [29.68932022549014, -0.996268366647358],
            [29.68808770817423, -0.994975025658004],
            [29.688089390718755, -0.993533293114599],
            [29.687719935201972, -0.992886775736258],
            [29.688905733834904, -0.991893194949386],
            [29.68732703455457, -0.991171361192556],
            [29.68725354607612, -0.990699030293115],
            [29.688389640924385, -0.990003703399395],
            [29.688637506772505, -0.989084131898953],
            [29.68703924577858, -0.986903023308541],
            [29.68414070844518, -0.984338460245627],
            [29.676191644955075, -0.980148494516545],
            [29.67558143106067, -0.978673471533477],
            [29.68121112353893, -0.976340243152198],
            [29.682286911787184, -0.974414436350949],
            [29.68238716017964, -0.973072196837032],
            [29.683424850876722, -0.972078509560669],
            [29.684683648406253, -0.971979819576121],
            [29.685809041624527, -0.969830319615158],
            [29.68606227221155, -0.964162957747333],
            [29.685373343440382, -0.962298250485958],
            [29.683081389010983, -0.959388613122499],
            [29.684755598968945, -0.951994492138026],
            [29.686263374460932, -0.949932174268385],
            [29.68699444230378, -0.947235545378627],
            [29.688870889083326, -0.946540592197019],
            [29.69496668681979, -0.94669315112254],
            [29.69664829620074, -0.943661454052523],
            [29.700168615932768, -0.940593469089571],
            [29.702617725231214, -0.935349796412464],
            [29.70174748319802, -0.929967593273613],
            [29.698515339415867, -0.929095830144203],
            [29.695867405097278, -0.924358995524042],
            [29.696758021819402, -0.922395718349345],
            [29.6944157779038, -0.920231840729086],
            [29.69290165042443, -0.916837970142737],
            [29.693101050366348, -0.915023469497961],
            [29.69251069462961, -0.913208540391667],
            [29.684594813109488, -0.907362877070849],
            [29.68496162308779, -0.898998530490556],
            [29.684122921802548, -0.898625241086008],
            [29.682543361936204, -0.898699002561595],
            [29.68022463591471, -0.89762894410273],
            [29.678991888630105, -0.896484872314534],
            [29.679535862552104, -0.895515723011743],
            [29.679598714977587, -0.894434455810203],
            [29.67868684501413, -0.893240846957854],
            [29.676268202976875, -0.893314184588584],
            [29.6761459961656, -0.892195545066364],
            [29.67530774493634, -0.891399686527276],
            [29.67422215427166, -0.891125705669116],
            [29.67254352280589, -0.891547423540781],
            [29.67178946707492, -0.889464812542155],
            [29.670707185803778, -0.889421204590078],
            [29.665300417449828, -0.891357300159034],
            [29.663696310220022, -0.89133161863642],
            [29.66081786550457, -0.894474539143247],
            [29.658052748652104, -0.895492232241586],
            [29.65476986083618, -0.896062237942061],
            [29.654521847664338, -0.897205513154429],
            [29.656298505090543, -0.897405295530899],
            [29.656840243105805, -0.898524132864929],
            [29.65685171010038, -0.899331979991024],
            [29.655937574585813, -0.900276056702955],
            [29.6573419719549, -0.902414469657576],
            [29.656280514530337, -0.902662479904135],
            [29.655909791490682, -0.903159414717839],
            [29.65603232978028, -0.903954897044881],
            [29.656648841763136, -0.904377785592281],
            [29.656030445114805, -0.905694867676523],
            [29.656300569419074, -0.906937842167174],
            [29.65544650604417, -0.909379560597765],
            [29.652173993769754, -0.911739201516277],
            [29.651802830555624, -0.91264005175126],
            [29.650784563231614, -0.91288806758396],
            [29.649811365283714, -0.914239116522541],
            [29.64829922038617, -0.914766510427384],
            [29.64607851403693, -0.914423525251869],
            [29.643952123605978, -0.91246494200919],
            [29.63843377730721, -0.909292784389844],
            [29.637894940850344, -0.907956350943851],
            [29.637896462596427, -0.906304743906276],
            [29.638609959392312, -0.904871632148489],
            [29.637993615394418, -0.903915206330845],
            [29.637324617544454, -0.899879728483951],
            [29.636750116174156, -0.900178965297801],
            [29.588110633892885, -0.89997896121653],
            [29.584579265781162, -0.902313396571539],
            [29.584036893555353, -0.901840863150587],
            [29.583148324992045, -0.90201435843611],
            [29.581640827079486, -0.90402677937085],
            [29.581343659891928, -0.904971093786739],
            [29.581496305218252, -0.911992662308517],
            [29.58095070804056, -0.914428121345778],
            [29.582093134214933, -0.918964758662284],
            [29.58364543111071, -0.9210783019682],
            [29.588012148893334, -0.922099814800732],
            [29.589170724081598, -0.923218941776441],
            [29.590525524565532, -0.925406953959413],
            [29.592701859529647, -0.932181198982602],
            [29.592379287087542, -0.933746880697107],
            [29.587895085835413, -0.938404603174859],
            [29.58646131625147, -0.940590993666237],
            [29.586386155109953, -0.941585144549296],
            [29.58685238703061, -0.943896927133483],
            [29.58833141643352, -0.945314530198075],
            [29.58986104254651, -0.945638553315186],
            [29.589465667040507, -0.946110556366009],
            [29.589191832694123, -0.948198221704034],
            [29.58988470057783, -0.951784863267221],
            [29.591208000738018, -0.954636859412752],
            [29.591513160236683, -0.957507805896719],
            [29.592473919212807, -0.958949969749097],
            [29.592701783172856, -0.964629498169309],
            [29.594254166306918, -0.966618850118898],
            [29.59343807292243, -0.968109651437511],
            [29.592803270342078, -0.972844159147553],
            [29.594008850775857, -0.975951790750785],
            [29.59467430567034, -0.976672996376758],
            [29.59923791889188, -0.978191996244509],
            [29.600347430794262, -0.97903775977217],
            [29.60096918175186, -0.98013803336928],
            [29.599786062793434, -0.98384147145967],
            [29.5978335511672, -0.986911219219537],
            [29.597031810166, -0.987069008241081],
            [29.593637675883627, -0.986481173231197],
            [29.590728554599522, -0.98110517334526],
            [29.58958241568808, -0.980107192430386],
            [29.585384092495353, -0.981782496214714],
            [29.588676800693978, -0.988369681481705],
            [29.588988075923087, -0.990950101512935],
            [29.586381261986595, -0.995736888653881],
            [29.58553753372904, -0.998150359309061],
            [29.583820867594124, -1.007272697754377],
            [29.584449781717804, -1.008320027035913],
            [29.5871618090353, -1.009569525487398],
            [29.589126145185606, -1.011608098374177],
            [29.590043226276023, -1.011580517207795],
            [29.59138510090136, -1.01217195030631],
            [29.591771540865196, -1.013304808501599],
            [29.59274444596231, -1.014143279719209],
            [29.593102113785946, -1.015666282541226],
            [29.593697509071433, -1.015876272955202],
            [29.59591647807892, -1.018524190573416],
            [29.598462736582068, -1.024607904527341],
            [29.59793210982858, -1.026752953270318],
            [29.596946740606903, -1.027746711119503],
            [29.597786730974576, -1.029108461662047],
            [29.598457441013483, -1.029623069241086],
            [29.60409965780341, -1.028261071921235],
            [29.6047463864175, -1.027897801402652],
            [29.60481392086222, -1.026613143961922],
            [29.60552363664909, -1.026004844062592],
            [29.60801981677008, -1.02578862459379],
            [29.610004303928868, -1.026675777922071],
            [29.614314964142824, -1.027203782112563],
            [29.616317674525433, -1.028757124333003],
            [29.616553224471048, -1.029528222462281],
            [29.616247087605373, -1.030284495210178],
            [29.617875506840022, -1.030804862562946],
            [29.61863043034355, -1.032166549825078],
            [29.618231493915758, -1.033148333390181],
            [29.62034022795979, -1.033557809621089],
            [29.62128642255024, -1.032854588022963],
            [29.62167308349967, -1.033778118824832],
            [29.622163383981725, -1.032884640768568],
            [29.622147756889053, -1.031932389836434],
            [29.62259230976695, -1.031752047257684],
            [29.62374296361101, -1.034408433155997],
            [29.625662297758847, -1.034353385282476],
            [29.626739596973454, -1.034849406206753],
            [29.628637757830038, -1.036945118858995],
            [29.630007871894662, -1.037707926706987],
            [29.630819580602214, -1.039022110515132],
            [29.63264421435281, -1.039128749950159],
            [29.6332415553892, -1.037521051182487],
            [29.63359148781994, -1.037416740642958],
            [29.637767267790608, -1.040438040850609],
            [29.63889884141801, -1.043265756372783],
            [29.64279441349539, -1.043060565767688],
            [29.643672879604978, -1.043841892324353],
            [29.644550106937803, -1.045793799093598],
            [29.646185169213986, -1.046376087913286],
            [29.648631755144788, -1.048462927114076],
            [29.65064381788784, -1.048955477105171],
            [29.651336788179485, -1.047571240566211],
            [29.652661717883603, -1.046392557573703],
            [29.65702961156093, -1.046644680696625],
            [29.656925826501208, -1.047967062816551],
            [29.65854956281832, -1.047533018250302],
            [29.65848405676947, -1.048457965651248],
            [29.659688778413862, -1.049074926726541],
            [29.65862192840263, -1.050456403439506],
            [29.657340366665487, -1.050846919868883],
            [29.65733833108306, -1.051606868181737],
            [29.657852847450236, -1.052241557490617],
            [29.65728702021235, -1.053554320607083],
            [29.65841001492881, -1.05493802996635],
            [29.660094166542013, -1.055882250643618],
            [29.660856822743494, -1.055629578590864],
            [29.661812408321932, -1.056456040964159],
            [29.663145882801043, -1.056577548886718],
            [29.663424497981342, -1.057235912742027],
            [29.664242601795433, -1.056635834246505],
            [29.66604832690759, -1.056809090691951],
            [29.66695731507562, -1.055582363069149],
            [29.668356023414024, -1.056183448608447],
            [29.66877289380814, -1.055384458271204],
            [29.669935249107084, -1.05596625580432],
            [29.66990486089767, -1.056616822840191],
            [29.670652952713446, -1.05679502097666],
            [29.67292902852188, -1.059149650037757],
            [29.677733821430877, -1.056896535789812],
            [29.678274644062856, -1.055734887281698],
            [29.680112889086637, -1.05460628804796],
            [29.680816056155066, -1.055091280824331],
            [29.681148955629673, -1.056426362079639],
            [29.683031138152316, -1.058277869819111],
            [29.68322359052385, -1.059470541677336],
            [29.682794653060522, -1.06085963916417],
            [29.68704473897653, -1.059725532470724],
            [29.68868863798016, -1.05785833110941],
            [29.689903483637806, -1.057408611395193],
            [29.69038039652719, -1.058034697822092],
            [29.6902642398694, -1.058828944284432],
            [29.691733304260843, -1.058294988787832],
            [29.69335118176565, -1.060414540926027],
            [29.69628427369476, -1.061292219665929],
            [29.696887279507326, -1.060850424029144],
            [29.696246132126138, -1.059999651389822],
            [29.696403240282805, -1.059565462998035],
            [29.697919678229077, -1.05958019284956],
            [29.700943659902016, -1.058228775382622],
            [29.701614409466792, -1.058744704780914],
            [29.702100431273177, -1.058176173622403],
            [29.70317993315683, -1.058987057598669],
            [29.703481133780024, -1.058622478413616],
            [29.70331493557099, -1.057811589851239],
            [29.705086364802256, -1.057785696733352],
            [29.705488342027262, -1.056939863146346],
            [29.708341173079006, -1.057952208815051],
            [29.708618221597472, -1.058550323673935],
            [29.71122438605199, -1.05858404247067],
            [29.712350088290737, -1.059192151952119],
            [29.71310590022806, -1.059921559834158],
            [29.712202801415064, -1.060533945199506],
            [29.71287251432399, -1.06180794377311],
            [29.712790304102455, -1.063055020353938],
            [29.713348250420342, -1.063339420222109],
            [29.713542380844814, -1.064134793411896],
            [29.714445533556738, -1.064024511892633],
            [29.714952070189266, -1.064682822968569],
            [29.71641793568001, -1.064366071490838],
            [29.716503172325734, -1.065010056840308],
            [29.71749503816355, -1.065365183934262],
            [29.719592992424182, -1.067562330392866],
            [29.720194182741544, -1.068827477399814],
            [29.720187639413016, -1.070388436003781],
            [29.72148251597931, -1.071045871809132],
            [29.72624995065061, -1.071034659200457],
            [29.727746817001787, -1.070614314781882],
            [29.730564282279136, -1.071447523699743],
            [29.735233321782435, -1.07136498206025],
            [29.74063775810989, -1.074194246577352],
            [29.742856197111394, -1.076614721462081],
            [29.74451712008795, -1.077443777464903],
            [29.74454139616021, -1.078380479058344],
            [29.745867606861925, -1.078300114736862],
            [29.749448340991744, -1.076965387863895],
            [29.751627773346975, -1.078084456647133],
            [29.752083198534752, -1.078687367333117],
            [29.75466818790139, -1.070280799785712],
            [29.758496245296953, -1.065273119838796],
            [29.759553353078896, -1.064808299537905],
            [29.7614763819975, -1.065094987756298],
            [29.765418663774685, -1.064451991299028],
            [29.765728813414732, -1.063021016888987],
            [29.763095702196647, -1.060516056518816],
            [29.76269304315031, -1.059538084335341],
            [29.76078378091346, -1.057402997880771],
            [29.75879398560966, -1.052727808962443],
            [29.757963704233582, -1.051964392213658],
            [29.757014165215338, -1.051725659347588],
            [29.75671835807712, -1.050735800788458],
            [29.755555805148813, -1.049829207154203],
            [29.754656035492225, -1.047348553086163],
            [29.754765850044134, -1.044403065622267],
            [29.754220639141998, -1.04349659320529],
            [29.754316816369577, -1.042304099371702],
            [29.755268265206148, -1.040634808615236],
            [29.755150269696937, -1.039919236991977],
            [29.755566597508608, -1.039120344898204],
            [29.75499956652824, -1.036282012007376],
            [29.755617780818564, -1.035423526407023],
            [29.75507348889296, -1.033586921078795],
            [29.753625571741626, -1.033109593554066],
            [29.75328297405519, -1.031404212183924],
            [29.75461297115584, -1.031094451389508],
            [29.75537384959136, -1.030021342151485],
            [29.75777266131876, -1.029377892108392],
            [29.760313801221415, -1.028877569890848],
            [29.76166678621018, -1.029331014803245],
            [29.76412529727639, -1.029322959113625],
            [29.764457170874934, -1.028914228717587],
            [29.76200114275218, -1.027375331855769],
            [29.761646740304624, -1.025586465983316],
            [29.76017470787944, -1.025466907694744],
            [29.758869646214457, -1.024584164054208],
            [29.75587786016132, -1.024583533537706],
            [29.750926336433793, -1.025453039030006],
            [29.750499185719562, -1.025214438887073],
            [29.74966886481761, -1.024474900572124],
            [29.749767030915223, -1.021255128600298],
            [29.748444030792303, -1.021012429783289],
            [29.7479635776424, -1.019946395666177],
            [29.746597744948442, -1.019808515336712],
            [29.745853755738548, -1.018519805691102],
            [29.745858155686825, -1.017455488955097],
            [29.744845672614932, -1.017141470367025],
            [29.74369858148926, -1.01740349008948],
            [29.743304821154176, -1.016692542444691],
            [29.7422012569973, -1.017087761373554],
            [29.742071408217924, -1.016510791569839],
            [29.742649355525618, -1.015315458395259],
            [29.742033750841195, -1.014958503273174],
            [29.741597193867623, -1.013936977097691],
            [29.740624030055745, -1.014776130764103],
            [29.740275814305534, -1.013710565230024],
            [29.739394281347526, -1.013707453054709],
            [29.73878705704639, -1.013005542032935],
            [29.739789493360156, -1.012059488001789],
            [29.738255366687603, -1.010558353161199],
            [29.73758894700251, -1.010412202030458],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 238,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KAYONZA",
        Population: 27588,
        Key: "KANUNGUKAYONZA",
        Dist2: "Kanungu",
        "Sub Country": "Kayonza",
        id2_original: "Kanungu Kayonza",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.751084200971917, -0.622004910483842],
            [29.750011129229055, -0.620075400385684],
            [29.747379740979664, -0.62042832778],
            [29.74666813423914, -0.621047463337492],
            [29.745933319523264, -0.621046056658377],
            [29.74533970649532, -0.622309763649616],
            [29.744653777198863, -0.620494703099204],
            [29.74543705782097, -0.619183627580704],
            [29.742949167353398, -0.617985609819119],
            [29.743044612454003, -0.617198247181231],
            [29.74181242212487, -0.616718583612232],
            [29.74052171913139, -0.615320015401086],
            [29.740499842459275, -0.613052802383871],
            [29.740120818088077, -0.612765701076934],
            [29.73924329520954, -0.61338451235448],
            [29.738770554994645, -0.611736929202184],
            [29.73972012275896, -0.609948872266969],
            [29.737160376051833, -0.609681471529538],
            [29.73712585110052, -0.608404642391734],
            [29.738263703053434, -0.608287486224869],
            [29.738074912215033, -0.607237069802853],
            [29.73909468691208, -0.606570789007651],
            [29.738906152093517, -0.605210129436757],
            [29.73961772918964, -0.604614861651808],
            [29.74056568896962, -0.604831452267265],
            [29.740733147514977, -0.602898708518661],
            [29.740449030153556, -0.602492461619804],
            [29.739619150324415, -0.602824997745222],
            [29.738695068662985, -0.602393671264431],
            [29.73922933000013, -0.60121337434528],
            [29.737049728761644, -0.59982507289011],
            [29.736101253348696, -0.60025284154231],
            [29.73631541889894, -0.599203187992568],
            [29.735343659153823, -0.599105886903021],
            [29.73515468416075, -0.598294125496571],
            [29.734609644836866, -0.59812603561445],
            [29.73418402485189, -0.596812664976858],
            [29.735891024216, -0.596338606580774],
            [29.73527549768503, -0.595382849008865],
            [29.733924020967617, -0.595881444540546],
            [29.7334501111462, -0.595689628665506],
            [29.733628892955743, -0.594413198674781],
            [29.734055922397403, -0.593936713853196],
            [29.73410486980061, -0.591979890904943],
            [29.73322822816936, -0.591500942824645],
            [29.73320544330048, -0.590331519794007],
            [29.731025809722663, -0.588990982788265],
            [29.731275489269358, -0.587977203024295],
            [29.73025666768481, -0.587450254747315],
            [29.729878496713148, -0.58606538661125],
            [29.727508150800475, -0.586132516895],
            [29.727698669099187, -0.584987365749852],
            [29.725992656983554, -0.584220483369578],
            [29.725115328141126, -0.58462453175098],
            [29.724191683060912, -0.583644340157142],
            [29.72450035946392, -0.582952853784887],
            [29.725353680830384, -0.582930589294671],
            [29.72510590301715, -0.581510186318437],
            [29.724584902610246, -0.580912586772896],
            [29.725155399290987, -0.578813580287241],
            [29.724421111886173, -0.578167854767936],
            [29.725298413779157, -0.57778767204992],
            [29.723068795243982, -0.575922098711414],
            [29.723531960316283, -0.575400673669226],
            [29.721780236529078, -0.572438186575564],
            [29.722894691860457, -0.571891392259357],
            [29.722705892038892, -0.570817126171858],
            [29.722990651695735, -0.570388105779879],
            [29.72389141309238, -0.570318196958448],
            [29.724864884128102, -0.568148335446438],
            [29.724343530683285, -0.568004175505711],
            [29.72339478397911, -0.568837657883205],
            [29.72347886718803, -0.567370149649058],
            [29.72215122547007, -0.567749500360759],
            [29.721558998542584, -0.567294971531921],
            [29.72155947554801, -0.566674488834659],
            [29.720563921227647, -0.566720364450536],
            [29.72061216435167, -0.565622687546737],
            [29.719877779928805, -0.565096297722393],
            [29.720186370093515, -0.564500259457391],
            [29.71968881841046, -0.564236829602294],
            [29.719570771697317, -0.563616131891226],
            [29.720211015373323, -0.563259354481749],
            [29.719998870134148, -0.561707764771902],
            [29.72053280178956, -0.560885442404463],
            [29.71939752620485, -0.557637765164064],
            [29.720061705491652, -0.556970788635185],
            [29.719161689696698, -0.556062265533561],
            [29.719127384832635, -0.554403626702608],
            [29.71810870608023, -0.553685804842987],
            [29.718914956624115, -0.553210011892858],
            [29.718939049440035, -0.552685041125941],
            [29.718038317687828, -0.552731092912812],
            [29.7187030314722, -0.551348190842387],
            [29.720457857142048, -0.550229813041614],
            [29.72090873865114, -0.549514709753519],
            [29.72185693828131, -0.549397146350136],
            [29.721632448393493, -0.548477947000251],
            [29.723008357489995, -0.546929291667665],
            [29.72277203229832, -0.545974272345469],
            [29.72526147235975, -0.545095881087725],
            [29.725404059249836, -0.544594983370712],
            [29.724503672450677, -0.544163763888101],
            [29.7253570908352, -0.543998289097409],
            [29.72552360075965, -0.543211064371486],
            [29.72448112204211, -0.542612525802833],
            [29.72458891807958, -0.541073455356079],
            [29.724921406125773, -0.540191082229764],
            [29.725822279811826, -0.539954093830236],
            [29.72627326732214, -0.539095794325428],
            [29.725948795841507, -0.538642424772168],
            [29.724905691896513, -0.538903014514566],
            [29.725570171220618, -0.537806467894328],
            [29.72462265880162, -0.536993328904707],
            [29.7244099925396, -0.536086086417707],
            [29.72305948690102, -0.535343805012995],
            [29.723060984392585, -0.53329145853252],
            [29.723796340792603, -0.532505278018411],
            [29.724625811888266, -0.532673843192017],
            [29.724544716475997, -0.530108255492085],
            [29.723217843715926, -0.529461483560799],
            [29.722673148446752, -0.528816145212181],
            [29.72288702204457, -0.528052873789357],
            [29.722294837337916, -0.527526770815744],
            [29.721654563119138, -0.527955160998572],
            [29.721560390032955, -0.527071996403311],
            [29.72217677715001, -0.526906077402255],
            [29.72198762608715, -0.526261390039584],
            [29.721537306923437, -0.526212834553265],
            [29.72115768427424, -0.526737157252206],
            [29.72016216049661, -0.526759209062173],
            [29.71954621265573, -0.526328519206967],
            [29.721087720785, -0.525161980158684],
            [29.72091056223118, -0.524314466012399],
            [29.721455802777687, -0.524196139486722],
            [29.721219227854384, -0.523575227460784],
            [29.722097109160725, -0.522335876183687],
            [29.72157604677007, -0.521786043816616],
            [29.721030357964207, -0.522524844219352],
            [29.720106217912296, -0.522165195285455],
            [29.721007305397357, -0.521617956232243],
            [29.721197479641358, -0.52085463542398],
            [29.7200602681872, -0.520136628170658],
            [29.720582360047167, -0.519254591609964],
            [29.721506222519643, -0.519996072771873],
            [29.722218006228296, -0.519018930065492],
            [29.72186274049973, -0.518636447590937],
            [29.721080401312044, -0.518849809387159],
            [29.721068935215765, -0.518312831980331],
            [29.722064626080048, -0.518052130885842],
            [29.720785419725566, -0.517023631489204],
            [29.721046492605012, -0.516546822437094],
            [29.72170975111862, -0.517120773144732],
            [29.722350185237516, -0.51647759029475],
            [29.721000006585676, -0.515258050066605],
            [29.72220017466991, -0.510761765252645],
            [29.722935257083755, -0.510333540985003],
            [29.723433935254143, -0.509021895362576],
            [29.724500417854394, -0.509214738074372],
            [29.72516484058461, -0.508142034697073],
            [29.725733407684146, -0.508572626077895],
            [29.726041700506492, -0.508334531597357],
            [29.7260896597629, -0.507547084092688],
            [29.725189555933056, -0.506710199644023],
            [29.725913077927483, -0.505864315217189],
            [29.727145791974422, -0.505604025927251],
            [29.72769184010642, -0.504340185833608],
            [29.729018871868316, -0.504796011960591],
            [29.73015690258599, -0.504368500532644],
            [29.731436647929634, -0.504657186313377],
            [29.73169841430848, -0.503178039846952],
            [29.73094023710699, -0.502723241239913],
            [29.731011711562584, -0.502198351549063],
            [29.73214962370264, -0.50193788784617],
            [29.732482630076795, -0.500267952161338],
            [29.73357302403329, -0.500174458171489],
            [29.733656897036422, -0.498850107905874],
            [29.735104054213043, -0.4969912484693],
            [29.735436588971655, -0.495989524400754],
            [29.738400555098785, -0.49437202530978],
            [29.738297725846504, -0.493369427715349],
            [29.739696555457478, -0.492846905151514],
            [29.74104715991074, -0.493517538243173],
            [29.741521352701476, -0.493327464472536],
            [29.74235021653603, -0.494402874104819],
            [29.74339295217175, -0.494691127351506],
            [29.745502302460057, -0.4950051460014],
            [29.746426968026405, -0.494648830854435],
            [29.746901958521097, -0.493289368333402],
            [29.746831765961428, -0.491952798255805],
            [29.74593186604913, -0.490757932848124],
            [29.74805480964432, -0.488530337816544],
            [29.748481337826064, -0.488722017852881],
            [29.7485757426776, -0.489318820619821],
            [29.749144598136304, -0.489343700350848],
            [29.75022423836054, -0.48767503615914],
            [29.75018226907045, -0.479620487513028],
            [29.74969772948431, -0.477579157011891],
            [29.7501484169573, -0.477078780424086],
            [29.74977108141884, -0.474214288235499],
            [29.750225454679445, -0.473785511870755],
            [29.75017573921665, -0.471661428745806],
            [29.748943189561402, -0.471635388366358],
            [29.748955420123988, -0.471074581027491],
            [29.748126320930826, -0.470309429075118],
            [29.74833993401719, -0.469880233868775],
            [29.747842454199358, -0.469449781935143],
            [29.748222031932773, -0.468949285288954],
            [29.74808019513596, -0.468376270935903],
            [29.747108307830057, -0.468470015087682],
            [29.746302757073742, -0.467943560620513],
            [29.745686040275018, -0.468610694642043],
            [29.74523582531587, -0.468395111571128],
            [29.744714103561776, -0.468776038410893],
            [29.743221170034893, -0.468248365891858],
            [29.742533567177073, -0.468581265021016],
            [29.74108850217676, -0.467361595669579],
            [29.741065385829547, -0.466478555016747],
            [29.740259582646647, -0.466333945420446],
            [29.739951938407945, -0.465593583837321],
            [29.73911085299394, -0.465031276776221],
            [29.73925333837439, -0.464625821143071],
            [29.73986961589697, -0.464626911661956],
            [29.739467070936698, -0.464005712905366],
            [29.73958643637672, -0.46271721788662],
            [29.738448862901496, -0.462476561676156],
            [29.73849666135946, -0.461880026972423],
            [29.737690952499648, -0.461592233168944],
            [29.737857448949352, -0.460709522365306],
            [29.736496253358908, -0.458093921645709],
            [29.736521425051475, -0.45585066886443],
            [29.735669241850466, -0.454130912852153],
            [29.735741227447445, -0.452770736328705],
            [29.733170576989373, -0.451107630082518],
            [29.733597770822733, -0.450249253501544],
            [29.732317744306393, -0.450390202900916],
            [29.731701765024482, -0.449935692752114],
            [29.730588860185293, -0.448215489788381],
            [29.730293617189087, -0.446604104130784],
            [29.729322285042024, -0.445862598793976],
            [29.72913328220121, -0.444907683464413],
            [29.728280480060967, -0.44414252872108],
            [29.727689243975245, -0.44206526908686],
            [29.726172354176366, -0.441967167892361],
            [29.72520028451249, -0.442395043380984],
            [29.72458505442553, -0.440771177426792],
            [29.72465678400266, -0.439792852034715],
            [29.723614270250795, -0.439194430862533],
            [29.72375834295438, -0.437632681800173],
            [29.716477538000795, -0.421745778728406],
            [29.682003004631547, -0.349084013088628],
            [29.675796176024303, -0.336749955539644],
            [29.662290263544033, -0.411495904019536],
            [29.65983116857292, -0.41899069475253],
            [29.65138881231252, -0.463217755398513],
            [29.6514359244576, -0.463647372307553],
            [29.652478500193197, -0.464031025701644],
            [29.65239501166902, -0.464830283552282],
            [29.653058086027997, -0.465642789228793],
            [29.653294365405586, -0.466717039934921],
            [29.654171034884648, -0.467100404812439],
            [29.654548621951392, -0.46951122823098],
            [29.656350782548497, -0.468178110999352],
            [29.656776990031673, -0.468775441051217],
            [29.658814778727848, -0.469494950406236],
            [29.660520468348288, -0.470643412336108],
            [29.661124007760126, -0.471873430254346],
            [29.661668917726637, -0.472184622158942],
            [29.662190518208156, -0.471923052405842],
            [29.662806305250587, -0.47256846103092],
            [29.66394476176972, -0.471377326395061],
            [29.665177375205353, -0.471140893318386],
            [29.666030353415394, -0.471524216632443],
            [29.666219585326637, -0.472073411807573],
            [29.666717357995246, -0.472002704218011],
            [29.667095864038526, -0.473053363195405],
            [29.668469778875064, -0.474153511203187],
            [29.670958161619417, -0.474515901627744],
            [29.670198442010616, -0.476399742254795],
            [29.670304163838086, -0.477772064413183],
            [29.67153555017505, -0.479349239931644],
            [29.670917373613975, -0.482187866599786],
            [29.67223146424585, -0.484111214307539],
            [29.672088815371996, -0.484755273463397],
            [29.674055198782845, -0.48595196794395],
            [29.674408587032477, -0.489030974961399],
            [29.674953143062766, -0.489867168181846],
            [29.674098653886404, -0.491655390496532],
            [29.674856777188964, -0.492110151240147],
            [29.676372198242355, -0.494212862340925],
            [29.674760460722542, -0.494281549463462],
            [29.674404334407917, -0.495139988871433],
            [29.673930267381344, -0.495210725863282],
            [29.674214161062284, -0.495951000694869],
            [29.6733015895146, -0.496056735628202],
            [29.67379904238295, -0.49643945029637],
            [29.673514382439112, -0.496796881910906],
            [29.671001139717582, -0.498080966230129],
            [29.670218208540113, -0.499201127458606],
            [29.66962551718366, -0.499438685999081],
            [29.6691031324729, -0.500797945141153],
            [29.668107313149527, -0.501321137193465],
            [29.669729717265042, -0.502910978311517],
            [29.67048701321921, -0.504535054307198],
            [29.67134020792325, -0.504608186911793],
            [29.6720034340975, -0.505182115330536],
            [29.67210726856457, -0.509155542333105],
            [29.67129947920659, -0.511874484745751],
            [29.67186787832113, -0.512472101941542],
            [29.672080320902673, -0.513689523661579],
            [29.67159231831109, -0.516635752035445],
            [29.6709992254077, -0.517422156419573],
            [29.671591596963925, -0.517638010081607],
            [29.673296113384627, -0.520385400044254],
            [29.673851596522034, -0.522450599751625],
            [29.67228536046797, -0.525120418652867],
            [29.671218364929675, -0.525715051418146],
            [29.670980303294538, -0.527146406997482],
            [29.671145792732826, -0.527719427020626],
            [29.671880242732716, -0.528126451668897],
            [29.671416218871023, -0.530643182917683],
            [29.67174606497199, -0.533316479122577],
            [29.67231419818523, -0.534272052873617],
            [29.672087749970068, -0.536001732914494],
            [29.67322401010833, -0.53791289470137],
            [29.6713038180694, -0.538410472045496],
            [29.671326440343204, -0.539866180515064],
            [29.669156379213025, -0.541711570282817],
            [29.668918374171778, -0.54304746155962],
            [29.66837287940203, -0.543523718827347],
            [29.667330137478096, -0.543378612402182],
            [29.666974259098506, -0.543855213683022],
            [29.668162856881864, -0.545562979386237],
            [29.66827921116901, -0.54842678759379],
            [29.668989833355983, -0.548976956221241],
            [29.670151222067688, -0.548955259309783],
            [29.669983019717264, -0.551985575279397],
            [29.669638315481507, -0.55335706912948],
            [29.66906904140785, -0.55392872669375],
            [29.669281519023688, -0.555026836061382],
            [29.668996491668867, -0.555837647879624],
            [29.669801484571394, -0.556960723488016],
            [29.670417409056043, -0.55736755393884],
            [29.671058024634615, -0.556485810210511],
            [29.6732633158936, -0.555105848165898],
            [29.674092446527794, -0.555656247031567],
            [29.676581096071782, -0.555684751031616],
            [29.67802596793432, -0.556904484421666],
            [29.67733753413489, -0.558335004422386],
            [29.677704510301485, -0.558848751669856],
            [29.677063552464787, -0.560183905215899],
            [29.67938543696281, -0.561333696404709],
            [29.681542618946736, -0.560908183064472],
            [29.681707854161814, -0.561791438818849],
            [29.680925459278576, -0.562100200083891],
            [29.680948264808688, -0.56326956154505],
            [29.681706813014376, -0.563151656174122],
            [29.68199091061286, -0.563581731673462],
            [29.68315251132698, -0.563297549001778],
            [29.683056976394827, -0.564251911584527],
            [29.681705995547485, -0.564225519462975],
            [29.68148015639009, -0.565096111780171],
            [29.68174065883935, -0.565382965823552],
            [29.68226251713734, -0.564835077642517],
            [29.683044182588564, -0.565480863049178],
            [29.68216649980988, -0.566409896715044],
            [29.680815955543757, -0.565810776615453],
            [29.681857435334702, -0.567626358159679],
            [29.68107481946591, -0.56822147627362],
            [29.679520007287334, -0.571261155735899],
            [29.679993444594874, -0.572025679211515],
            [29.67887886170274, -0.572811079287516],
            [29.679091483947335, -0.5736944275434],
            [29.678640935713236, -0.573979935550062],
            [29.677290399531916, -0.573380806356862],
            [29.676980548132548, -0.575599521895767],
            [29.676388267306166, -0.575264323470038],
            [29.675534488697213, -0.575930882892806],
            [29.67607845633096, -0.57743530422666],
            [29.675213296965683, -0.577493331548381],
            [29.67523602434238, -0.578734272077305],
            [29.673245012719676, -0.578825967422893],
            [29.673575862238835, -0.580067485247377],
            [29.672982785505084, -0.580758405165462],
            [29.673314099453247, -0.581403340810827],
            [29.671843752267552, -0.582474409758259],
            [29.671606008636026, -0.583404628172714],
            [29.672778134012002, -0.584802847032243],
            [29.670953127460585, -0.584775531585595],
            [29.670668260005886, -0.585347710623542],
            [29.670952210280678, -0.585944830022728],
            [29.672113586415954, -0.585947029881845],
            [29.672255488789823, -0.586329105599297],
            [29.670240615218248, -0.586635508483323],
            [29.6705953796869, -0.587590716025049],
            [29.669563277409196, -0.58896089800237],
            [29.66885032589068, -0.591345862342966],
            [29.667215113595848, -0.591104124197435],
            [29.6665979197917, -0.592296103455164],
            [29.665507409054218, -0.592604250445872],
            [29.66451217812734, -0.592315996482441],
            [29.664273904489825, -0.59389051328539],
            [29.662449084787966, -0.593648406063131],
            [29.661855970324982, -0.594363161612826],
            [29.662625364789424, -0.595498124482346],
            [29.662506532948715, -0.595903577832072],
            [29.660705647060958, -0.595375152659077],
            [29.659521684584494, -0.593988841186328],
            [29.659827924756403, -0.596327996255339],
            [29.65826489029802, -0.594773924701561],
            [29.657504985636255, -0.596586061065959],
            [29.65684123574416, -0.596727964728337],
            [29.6562726767295, -0.596392799904435],
            [29.6565577085759, -0.595629733137621],
            [29.65582319210066, -0.595341977870032],
            [29.653974231073878, -0.595672524768588],
            [29.652409111625698, -0.596719498565934],
            [29.65069155256541, -0.595749775707429],
            [29.649269715303376, -0.595460705383579],
            [29.649837588005184, -0.596654936554402],
            [29.649671098741997, -0.597370494764485],
            [29.64929180667286, -0.59746522684279],
            [29.64929115090268, -0.598276553611015],
            [29.651518513768213, -0.598948974172174],
            [29.651494292493208, -0.599593223229618],
            [29.65083056955056, -0.599711270663839],
            [29.65106637821097, -0.601191210534162],
            [29.651540092199657, -0.601573920272023],
            [29.6520380912437, -0.60124079840098],
            [29.65272498443245, -0.601790954751762],
            [29.652013677729222, -0.60212367775926],
            [29.651835173499116, -0.603042050140454],
            [29.65261572324275, -0.60500029468904],
            [29.652306867176698, -0.605906490601357],
            [29.653396832636805, -0.606266527798939],
            [29.65408496190736, -0.60528947319863],
            [29.65398949794211, -0.606100625437995],
            [29.655065556583324, -0.608978165469914],
            [29.655965564293407, -0.609767372555942],
            [29.655301363447073, -0.610458122574123],
            [29.65598856385963, -0.610626487841716],
            [29.656083019016837, -0.611056199485471],
            [29.655618894543803, -0.613429661788034],
            [29.656447776344667, -0.614242605735129],
            [29.656090935869422, -0.615840733326329],
            [29.65675461299795, -0.615794278736461],
            [29.656754100059942, -0.616414720909285],
            [29.657440950129555, -0.617012613908866],
            [29.65774826019497, -0.617991586861348],
            [29.65736807070887, -0.619160139804179],
            [29.658066756082317, -0.619770000049051],
            [29.65816093545671, -0.620533791894636],
            [29.65880101384275, -0.620367990581368],
            [29.65899007327745, -0.621036517110491],
            [29.65993799173493, -0.621205397646622],
            [29.66055286339405, -0.622853135959567],
            [29.661264059604502, -0.622663602630844],
            [29.661334195570323, -0.623833026753469],
            [29.66320616334984, -0.624385503689348],
            [29.661759331363363, -0.625623586065086],
            [29.661865562535585, -0.626136842912853],
            [29.66153306909947, -0.626947541949316],
            [29.661035220972405, -0.627089754708884],
            [29.66077330457488, -0.628521025493191],
            [29.659872286260097, -0.628948816100991],
            [29.659942414141074, -0.630118239719372],
            [29.657274825582352, -0.631509038536124],
            [29.65758146191135, -0.633275489499546],
            [29.65684655377064, -0.633464961361784],
            [29.65679871039693, -0.633989853501191],
            [29.65618225410963, -0.634251142142635],
            [29.655066594137473, -0.636253449175695],
            [29.65499444864035, -0.63749418308469],
            [29.653975227305523, -0.637563779346003],
            [29.653583754081115, -0.638028348446509],
            [29.654032691635948, -0.639675756265995],
            [29.651970626867556, -0.639719456580715],
            [29.651116227522703, -0.641077962195507],
            [29.651148487821203, -0.6449318702501],
            [29.65003306051269, -0.646647800360062],
            [29.65064831305752, -0.647794415880898],
            [29.648680001862058, -0.649079145442595],
            [29.64879825518777, -0.649365733636712],
            [29.64948567658588, -0.649271624984606],
            [29.64973332144848, -0.650691947917031],
            [29.65058601309595, -0.651337925160936],
            [29.65039572386762, -0.652125015819561],
            [29.651225045842967, -0.652389143821362],
            [29.651034535629094, -0.653438725638133],
            [29.65155540308535, -0.654084050395044],
            [29.651056704253662, -0.655204620174784],
            [29.651376170321537, -0.655789888177224],
            [29.65094950200261, -0.655836769977298],
            [29.650900967824427, -0.657149124253129],
            [29.649810538833652, -0.657337882909012],
            [29.648244797751314, -0.659005178116824],
            [29.648552647704257, -0.659316006973609],
            [29.648503473925608, -0.661344238534154],
            [29.647945691999393, -0.662261849499979],
            [29.646002976501332, -0.661351227859736],
            [29.645029934860297, -0.662828781488668],
            [29.645124134895926, -0.663520983164735],
            [29.644507919357114, -0.663495907476755],
            [29.644150998033496, -0.665093995476942],
            [29.643510212673334, -0.666071084573056],
            [29.64294121438246, -0.666260862408372],
            [29.64289297036014, -0.667215271248406],
            [29.641457101413376, -0.669419701069137],
            [29.641835920968678, -0.669873847477358],
            [29.640647931344787, -0.673188376256972],
            [29.640292650344872, -0.672925179056356],
            [29.63969983951247, -0.673234212325124],
            [29.63967538467549, -0.67409321814062],
            [29.638360119047174, -0.673911629084423],
            [29.63752967148277, -0.674936056149643],
            [29.635561965751823, -0.675504835278559],
            [29.63527645061182, -0.676745104932153],
            [29.63577364296874, -0.677342657571939],
            [29.63518054737039, -0.677985756025859],
            [29.636033952280222, -0.677796565204899],
            [29.63636525904184, -0.678369928678304],
            [29.63750300409527, -0.67827674937108],
            [29.63629275242198, -0.679944695886608],
            [29.63690791693192, -0.68113904936312],
            [29.63655167473464, -0.681949663164022],
            [29.637049034178222, -0.682356322331016],
            [29.636550736893508, -0.682999606953181],
            [29.636870130197817, -0.683632597528874],
            [29.63618226054036, -0.684227785118262],
            [29.63551890680532, -0.6839162482272],
            [29.634451846588327, -0.684486807530594],
            [29.634996328956785, -0.685203764622213],
            [29.6345696390783, -0.685274501891621],
            [29.634877068619666, -0.686038708658884],
            [29.63461537051277, -0.68713585462645],
            [29.635089654033308, -0.686850460614119],
            [29.63644020548598, -0.687306556386888],
            [29.635657250952345, -0.688211754023491],
            [29.634732734506322, -0.688400802510814],
            [29.634661286101878, -0.688782451145011],
            [29.63515879556411, -0.689022078289498],
            [29.63501603350252, -0.68964221051463],
            [29.634660706688518, -0.689426739147185],
            [29.63420995453684, -0.689903081232267],
            [29.634470325832055, -0.690285400738863],
            [29.633652275916894, -0.690677485988918],
            [29.63410229324667, -0.691012459576701],
            [29.63417245256868, -0.692062542399658],
            [29.635025519711935, -0.692255165767805],
            [29.634527017611312, -0.693113208852333],
            [29.63454952939234, -0.694425680618452],
            [29.634146196609553, -0.694878258120119],
            [29.63286656894519, -0.694613191055597],
            [29.632415985676804, -0.694898634005368],
            [29.632699292757845, -0.696116181018612],
            [29.632201355697525, -0.696353802900727],
            [29.63267491966756, -0.696855866543014],
            [29.63263851364403, -0.69779835045468],
            [29.6321406107197, -0.697988250099072],
            [29.632187516252277, -0.698537174294405],
            [29.63280319998844, -0.699134977511304],
            [29.632138566154104, -0.700231299446077],
            [29.63126198920155, -0.699823869315906],
            [29.63090586198863, -0.700491297379847],
            [29.63104743827405, -0.701183583464418],
            [29.630454862800253, -0.701230109118408],
            [29.630027436303212, -0.702112156240958],
            [29.629388226588063, -0.701323402951949],
            [29.627421124525, -0.701223975881026],
            [29.627690939808804, -0.704219230510891],
            [29.627335069514054, -0.704600307477071],
            [29.62593655611006, -0.704764502600073],
            [29.62581719875488, -0.705694886428547],
            [29.626527476887098, -0.706507646425519],
            [29.625745195191598, -0.706673092739213],
            [29.625602212144457, -0.707507979976716],
            [29.62607603752421, -0.707723701125934],
            [29.625885770753786, -0.708439176168954],
            [29.62692724515484, -0.709920750188628],
            [29.626251624924606, -0.710074479655764],
            [29.626132280145857, -0.710980994222964],
            [29.626629089820447, -0.711960356357836],
            [29.626368027720797, -0.712341620420932],
            [29.626770630173244, -0.712676510717148],
            [29.626745471955402, -0.714251359883309],
            [29.626294928212854, -0.71448907066406],
            [29.626270671005265, -0.715085577456133],
            [29.626863378531404, -0.714895887801662],
            [29.627596711027063, -0.716400695548636],
            [29.62687286204586, -0.71743722891623],
            [29.62611478186243, -0.717053880449631],
            [29.625497949181007, -0.717696901617464],
            [29.62549723412205, -0.718460495873645],
            [29.624999689625504, -0.718268576017349],
            [29.62462009482411, -0.718673463389834],
            [29.62514109343438, -0.719127904182638],
            [29.624926939562233, -0.720034225636061],
            [29.6256855749045, -0.719821023741563],
            [29.62468887702877, -0.721155264987479],
            [29.625091166867527, -0.721824225067517],
            [29.624485596364824, -0.723099611897967],
            [29.62481705224679, -0.723482082271943],
            [29.624555843721744, -0.724006515520211],
            [29.62536053568864, -0.72522513545418],
            [29.62649765281967, -0.72580015845673],
            [29.63149111439626, -0.722431816129677],
            [29.63302248413918, -0.720487525523063],
            [29.63511544107186, -0.72138073593549],
            [29.63688583185068, -0.722922188095255],
            [29.638251217183615, -0.727705746890843],
            [29.640907372883674, -0.729247878662469],
            [29.652263435429358, -0.726419230329154],
            [29.658143207204592, -0.72447811851831],
            [29.65935180148617, -0.723506271973891],
            [29.661851044862292, -0.719455017880904],
            [29.660563631499393, -0.718076020195697],
            [29.660162117805054, -0.71653554997638],
            [29.66072906434379, -0.711996497282796],
            [29.6625817345144, -0.711187223443918],
            [29.666447379218077, -0.710622591311364],
            [29.670479843764948, -0.709361208263914],
            [29.670695015428304, -0.710136295169148],
            [29.67173893324693, -0.71123590927958],
            [29.674716524121965, -0.712589108705961],
            [29.678503122470524, -0.715092279264484],
            [29.678851857446993, -0.716025418626102],
            [29.680994206448943, -0.717755485143593],
            [29.68342781441885, -0.720596270564975],
            [29.68645844092995, -0.725115111424619],
            [29.695690434291354, -0.73456373944191],
            [29.697754522964107, -0.732491788743753],
            [29.69853699240747, -0.732207017316781],
            [29.699778471316662, -0.733061755513565],
            [29.704265589398496, -0.734126377570134],
            [29.70501882945917, -0.732746890327086],
            [29.70599080929154, -0.732581827610124],
            [29.7075799380123, -0.731487308995565],
            [29.709170530986974, -0.728817758802625],
            [29.71035606551522, -0.728414480189879],
            [29.71240808262715, -0.726593028685888],
            [29.713640776911152, -0.72645235304285],
            [29.714909847574294, -0.725428760923399],
            [29.715373666620085, -0.723687604011801],
            [29.71606196836721, -0.722710561855761],
            [29.715103812708737, -0.720715945439894],
            [29.71674126360527, -0.718619189653209],
            [29.718661926361417, -0.717859413862081],
            [29.721176851627472, -0.715263262952812],
            [29.72203013526473, -0.71531271135559],
            [29.722943377853916, -0.714586682096588],
            [29.723133935678508, -0.713560895593831],
            [29.724296593709706, -0.712250685602361],
            [29.724321162632723, -0.711296153745068],
            [29.725555402917333, -0.709461068115768],
            [29.724857181972855, -0.708326088715071],
            [29.725924544922098, -0.707540705802151],
            [29.725759784915823, -0.706251688243871],
            [29.726376632868625, -0.705632443879436],
            [29.727137178029192, -0.703366829549961],
            [29.729625848234413, -0.703586595699893],
            [29.729994098212096, -0.702644676153264],
            [29.73148815193812, -0.701836273781516],
            [29.732296074246776, -0.699594595929014],
            [29.733576899365403, -0.698666434051507],
            [29.733790767573307, -0.698070242233047],
            [29.73348310626659, -0.697520738612754],
            [29.734432737811336, -0.695852091318561],
            [29.734504859053907, -0.694706732038937],
            [29.734126197602098, -0.694037762657232],
            [29.73436380109641, -0.693393887577297],
            [29.73656892077718, -0.692634599907189],
            [29.737304906896203, -0.691299631874517],
            [29.73802823844781, -0.69088343764646],
            [29.73980807411348, -0.68854821618573],
            [29.74004706101336, -0.686329251493449],
            [29.741459952851798, -0.683456321089469],
            [29.741556482218968, -0.681499584270264],
            [29.743074865916153, -0.679951359120145],
            [29.743146853309753, -0.678949169348017],
            [29.744321959295863, -0.676911031950315],
            [29.744560214967073, -0.675503467239463],
            [29.745413488722853, -0.675576741317119],
            [29.745415017655482, -0.673810730103906],
            [29.746457941039097, -0.673860516683602],
            [29.747002736919537, -0.674315029166279],
            [29.747287388778567, -0.67407693640465],
            [29.74698107135154, -0.671952337369473],
            [29.747789407783525, -0.669161708149499],
            [29.74696131380518, -0.667370196771089],
            [29.746726074676662, -0.66526960427978],
            [29.748045694439135, -0.660511106541411],
            [29.748781278112926, -0.659605669312402],
            [29.748830812116005, -0.657099921371312],
            [29.748276950437692, -0.653340081763079],
            [29.750374893918522, -0.65189966556474],
            [29.751275533144266, -0.650653373153021],
            [29.752028652830695, -0.648319962280064],
            [29.751733450258662, -0.646401500685389],
            [29.752919802253803, -0.645336554495674],
            [29.75318519602979, -0.644175102782731],
            [29.751895386859996, -0.641424755751451],
            [29.75084802400226, -0.640326412144823],
            [29.75106028692075, -0.639473982072104],
            [29.751801800373716, -0.638728459107416],
            [29.75083961936445, -0.636841550675807],
            [29.751115528819124, -0.635776018628858],
            [29.75331859674779, -0.634008334308365],
            [29.75358398693049, -0.632829828355018],
            [29.75042066847212, -0.626143738867506],
            [29.751084200971917, -0.622004910483842],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 239,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KIHIHI",
        Population: 17967,
        Key: "KANUNGUKIHIHI",
        Dist2: "Kanungu",
        "Sub Country": "Kihiihi",
        id2_original: "Kanungu Kihiihi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.714909847574294, -0.725428760923399],
            [29.713640776911152, -0.72645235304285],
            [29.71240808262715, -0.726593028685888],
            [29.71035606551522, -0.728414480189879],
            [29.709170530986974, -0.728817758802625],
            [29.7075799380123, -0.731487308995565],
            [29.70599080929154, -0.732581827610124],
            [29.70501882945917, -0.732746890327086],
            [29.704265589398496, -0.734126377570134],
            [29.699778471316662, -0.733061755513565],
            [29.69853699240747, -0.732207017316781],
            [29.697754522964107, -0.732491788743753],
            [29.695690434291354, -0.73456373944191],
            [29.68645844092995, -0.725115111424619],
            [29.68342781441885, -0.720596270564975],
            [29.680994206448943, -0.717755485143593],
            [29.678851857446993, -0.716025418626102],
            [29.678503122470524, -0.715092279264484],
            [29.674716524121965, -0.712589108705961],
            [29.67173893324693, -0.71123590927958],
            [29.670849296586773, -0.712779870961091],
            [29.671276197569377, -0.713339373846699],
            [29.671488120026364, -0.715748358497955],
            [29.673067250498008, -0.718373418239013],
            [29.67363669525154, -0.720176780605187],
            [29.672413785417614, -0.72259641841889],
            [29.672199336898053, -0.723813006904781],
            [29.67087041148755, -0.725528463232021],
            [29.6705962672224, -0.727210261746365],
            [29.66983746389514, -0.727566662968794],
            [29.670876647592234, -0.731530087774208],
            [29.670670956748374, -0.736027887151242],
            [29.669981806093322, -0.737911677223975],
            [29.66924645148996, -0.738530612687947],
            [29.667144974036777, -0.742571107520999],
            [29.667285464259002, -0.744384993819057],
            [29.665944208572906, -0.746565713018821],
            [29.666322532258203, -0.747521019761542],
            [29.665657931661528, -0.748498033131226],
            [29.6657989348218, -0.749763074510831],
            [29.66501506849815, -0.751527324800809],
            [29.664798952705407, -0.753221016013993],
            [29.664346460516988, -0.753955594711089],
            [29.662885984917967, -0.754348020289433],
            [29.66153970315787, -0.757331602910827],
            [29.66046768064725, -0.761737922003963],
            [29.660927874990886, -0.766925541960549],
            [29.660065015312707, -0.768660139917868],
            [29.657722253967503, -0.768902119779585],
            [29.655791381858144, -0.770740394697324],
            [29.655273726777374, -0.771711743944499],
            [29.654611633378664, -0.779553017782414],
            [29.653707027192606, -0.78275445243752],
            [29.652756145192996, -0.784426456960725],
            [29.652849811629387, -0.78605150490562],
            [29.651941843947522, -0.788651887496367],
            [29.652156545792, -0.790334779795298],
            [29.655253617091418, -0.792738983737535],
            [29.65731810820937, -0.795272832132811],
            [29.658213787836473, -0.795273200406609],
            [29.6605544875481, -0.797182595361703],
            [29.664583078559488, -0.799231495003564],
            [29.66692520299915, -0.799683556906669],
            [29.669061650069704, -0.79909456465088],
            [29.670923042881725, -0.797950274221207],
            [29.672542037890718, -0.798089738513582],
            [29.673217820716033, -0.797507070454645],
            [29.67572574091949, -0.797535871245623],
            [29.67693906572935, -0.796814627125315],
            [29.67850990654757, -0.796898555791155],
            [29.680137868539727, -0.794900538754148],
            [29.680661539637992, -0.794872993668685],
            [29.683250630712212, -0.796484103307191],
            [29.68597897143527, -0.796596258809342],
            [29.6878796044555, -0.797651907963345],
            [29.688514028845145, -0.797096978032336],
            [29.69161520724202, -0.796418131118901],
            [29.694398592234094, -0.796641340895688],
            [29.694896199612707, -0.795059227940756],
            [29.69677201038504, -0.793283360959725],
            [29.697683332376133, -0.791368285595633],
            [29.69787421359424, -0.793505886455355],
            [29.69952701759727, -0.79436710846109],
            [29.700132415623433, -0.795338952547161],
            [29.699689295558397, -0.797587333436915],
            [29.70172676714925, -0.799670168821422],
            [29.702027390155713, -0.802307492319332],
            [29.70326641576586, -0.803557206430073],
            [29.704160003216625, -0.805764511409038],
            [29.704848917614772, -0.805875828611927],
            [29.705151463914245, -0.806514443300704],
            [29.70763292513933, -0.805488342694288],
            [29.710363490989366, -0.803379682650353],
            [29.71480285822396, -0.801243952535936],
            [29.715162405323152, -0.799939364089014],
            [29.714557424115277, -0.798523334770219],
            [29.714888659909988, -0.797996020083329],
            [29.71467059207815, -0.795469729259866],
            [29.71530453137753, -0.79428629031062],
            [29.71509522301799, -0.79161383371569],
            [29.71533694708456, -0.790334323494519],
            [29.71616493416338, -0.789113187056532],
            [29.715408731458883, -0.787294584215562],
            [29.71659411327353, -0.78701743698846],
            [29.717806136424528, -0.787711924531041],
            [29.719489439129806, -0.785519506154463],
            [29.719242225458544, -0.784631075795843],
            [29.71772697508507, -0.783991986149987],
            [29.718004367658292, -0.782104383420725],
            [29.717123067363957, -0.781410032376808],
            [29.71841978996815, -0.779966986007852],
            [29.718530685193368, -0.77927301546145],
            [29.720323686567834, -0.777635829771187],
            [29.720779803458406, -0.776178568473392],
            [29.719431159129115, -0.774207062765191],
            [29.71857922565973, -0.77156948796002],
            [29.71780842533186, -0.770597580877074],
            [29.71824999580304, -0.769959248115415],
            [29.718210184266272, -0.768307481382716],
            [29.71967122490564, -0.767974907343951],
            [29.720112785495342, -0.767336572393616],
            [29.71986771789932, -0.764116260470482],
            [29.718546313184337, -0.762477903042891],
            [29.716786220691976, -0.758340941617495],
            [29.716705733439134, -0.75595351520071],
            [29.71626600092106, -0.754593093585996],
            [29.71425480954382, -0.753787309910468],
            [29.713439002721945, -0.752094129116291],
            [29.713441991416886, -0.748944044518472],
            [29.714011705665015, -0.748062235571122],
            [29.71368113731855, -0.746701291418915],
            [29.715332198589934, -0.742802859681418],
            [29.717846929819885, -0.740493155814297],
            [29.71763451328949, -0.739514278619537],
            [29.71835921926349, -0.737642404390042],
            [29.71776843503038, -0.735708177958774],
            [29.718291394662906, -0.734110334976099],
            [29.71802023549945, -0.732570527727544],
            [29.716268645561247, -0.729918014243511],
            [29.71619864074947, -0.728724655955252],
            [29.71522819074803, -0.727219229803786],
            [29.714909847574294, -0.725428760923399],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 240,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KIHIIHI TOWN COUNCIL",
        Population: 19812,
        Key: "KANUNGUKIHIIHI TOWN COUNCIL",
        Dist2: "Kanungu",
        "Sub Country": "Kihiihi T.C",
        id2_original: "Kanungu Kihiihi T.C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.821110168072998, -1.027300337281492],
            [29.82130201947161, -1.026186239622923],
            [29.824304625732353, -1.02507015482091],
            [29.826889836982872, -1.022878938005391],
            [29.827456513128716, -1.02121384319883],
            [29.828426312749894, -1.020036655759581],
            [29.82979884238428, -1.019753633373688],
            [29.82943706656485, -1.018250117454679],
            [29.82982959890297, -1.016499505116451],
            [29.829462490684037, -1.015970512971817],
            [29.829571377276242, -1.012005888501303],
            [29.82888957214526, -1.011053683473246],
            [29.828892537484013, -1.007987629079976],
            [29.829733785493087, -1.006984052566054],
            [29.831888273429485, -1.005664577058576],
            [29.833047719085236, -1.001436646324277],
            [29.832892039249852, -0.999480554013842],
            [29.83215760452135, -0.998634029548115],
            [29.829530626101683, -0.99979447281158],
            [29.826117212176666, -0.999579707541648],
            [29.823912053868355, -0.998996073742189],
            [29.82428088864928, -0.99772772475938],
            [29.82380950039888, -0.996405697389664],
            [29.823968565984558, -0.994819967479876],
            [29.82525374523738, -0.993159324078277],
            [29.82960360523538, -0.993545707761707],
            [29.830742260282204, -0.994529443999424],
            [29.833530561753822, -0.994622961597256],
            [29.834029664827366, -0.994224258602435],
            [29.83272492655588, -0.990309236781834],
            [29.83163260481478, -0.988825093667908],
            [29.82716376295739, -0.98712864572778],
            [29.826224086542645, -0.986236094345136],
            [29.82575566722429, -0.985125580781456],
            [29.82573362616047, -0.982714305680944],
            [29.82383888429184, -0.979655327778627],
            [29.822537965656938, -0.978343900774221],
            [29.8217234667821, -0.978197593729484],
            [29.82056801773104, -0.97659512555226],
            [29.8195091339798, -0.976421308826095],
            [29.817484908047778, -0.974654293154817],
            [29.81348432021878, -0.974177594738577],
            [29.813540798198993, -0.973158552005262],
            [29.813016671654903, -0.972703137687288],
            [29.811768005325128, -0.972374465427403],
            [29.811000684172395, -0.971327412213057],
            [29.810167552441925, -0.971435855620283],
            [29.80939346967, -0.969306021112223],
            [29.808633488651438, -0.969068769568491],
            [29.80760049614331, -0.96950460300829],
            [29.80667859918465, -0.968775877127916],
            [29.80604986562235, -0.966409602077258],
            [29.805179060345477, -0.967209529569827],
            [29.803459678603474, -0.966862250824859],
            [29.80213994295834, -0.965896603144205],
            [29.799874175317793, -0.965386418155997],
            [29.799080455373783, -0.964452722196875],
            [29.797357864849584, -0.963784787304655],
            [29.794536160422428, -0.960272488815918],
            [29.79289993033635, -0.960582046987879],
            [29.789410950129632, -0.959068425668715],
            [29.789636380553574, -0.956980536979692],
            [29.787163359000555, -0.955823244138798],
            [29.78623843561774, -0.954223039626637],
            [29.785617615314774, -0.955155472828233],
            [29.784513813104372, -0.954532517507642],
            [29.783146946449524, -0.95288751332005],
            [29.781025423090778, -0.952752362509513],
            [29.780481340472633, -0.95101149438808],
            [29.779173813830514, -0.950396106481472],
            [29.7791752107108, -0.949729702065212],
            [29.778601217786964, -0.949418206414018],
            [29.776654372733546, -0.950305039721712],
            [29.7752234310461, -0.951677554549613],
            [29.77577508915704, -0.952111559693787],
            [29.77579106299939, -0.95294951365158],
            [29.775168354437728, -0.953822561517049],
            [29.77520229009421, -0.954553559419351],
            [29.777614881079717, -0.958718647331065],
            [29.777982494151857, -0.961036677016535],
            [29.778582911918075, -0.96232086777273],
            [29.778065908115874, -0.96353275568742],
            [29.777239472427535, -0.964271900776217],
            [29.7748280959643, -0.963734900135507],
            [29.773477128591647, -0.965052997365229],
            [29.771892799569468, -0.967672368144244],
            [29.76921474024782, -0.96742037184449],
            [29.768289207807204, -0.968881463484606],
            [29.767866290852925, -0.971724716771374],
            [29.76724376105598, -0.972508596019257],
            [29.767861510917303, -0.97397108393566],
            [29.767309209612613, -0.975093769811065],
            [29.76764499537425, -0.975682406206353],
            [29.766260930473276, -0.975877263852285],
            [29.76581506425841, -0.977000049688364],
            [29.765460285416736, -0.97699972544369],
            [29.765218049310494, -0.978292056676248],
            [29.765608111281598, -0.978381554457417],
            [29.766100695281107, -0.980307467664126],
            [29.764769273452433, -0.980769791576815],
            [29.764430487317753, -0.981589578089964],
            [29.764735741139514, -0.984005591019087],
            [29.765427103446786, -0.984220171375883],
            [29.765529834782686, -0.985949604747081],
            [29.76714293684342, -0.986485935392877],
            [29.767127983487207, -0.987918417934564],
            [29.767859344180838, -0.989713439968524],
            [29.766883800731716, -0.991710325358784],
            [29.76740885703214, -0.992924817268969],
            [29.7697273584748, -0.992490225470611],
            [29.772545506471744, -0.995568813193564],
            [29.772928492413342, -0.997270837193117],
            [29.77374410430082, -0.998457058671969],
            [29.77522547201844, -0.998673614983878],
            [29.777806320151594, -1.001161722986386],
            [29.779662423683234, -1.001804066702514],
            [29.7794997756162, -1.003027571693234],
            [29.780995100458355, -1.003550064037201],
            [29.78102751886034, -1.0043913661288],
            [29.78239859142733, -1.005721549317784],
            [29.78450494403756, -1.009300794859078],
            [29.78659159479695, -1.010677752127332],
            [29.78798789205714, -1.010502280958562],
            [29.788652362398068, -1.010861439795936],
            [29.788428106970564, -1.011946272124418],
            [29.788821537623946, -1.012673220901315],
            [29.789776418024896, -1.012282212976122],
            [29.790863075888097, -1.013100672224458],
            [29.79222762758446, -1.013444265405522],
            [29.7929561091776, -1.014288194793613],
            [29.792822311404247, -1.015134122399466],
            [29.793799948826265, -1.015751717763041],
            [29.793546490067147, -1.017553526403661],
            [29.79385410376315, -1.018624556054731],
            [29.794671230210234, -1.018281211320396],
            [29.797432263321394, -1.018267634530951],
            [29.797857341622286, -1.018604655228354],
            [29.79824039044595, -1.020230246150473],
            [29.80128054448894, -1.021849773587403],
            [29.80217077942707, -1.02424739996286],
            [29.804251808529422, -1.025613814403415],
            [29.80339613447522, -1.026506824754043],
            [29.804744459004283, -1.026852343978796],
            [29.805047781448188, -1.02745971590637],
            [29.804662619786946, -1.027970793940404],
            [29.805554929833406, -1.028444917562797],
            [29.805306907678425, -1.029534522228535],
            [29.805672064756564, -1.030041576128063],
            [29.807433963760992, -1.029962088969389],
            [29.80985243242341, -1.028650000435667],
            [29.811095622623203, -1.029669407639815],
            [29.814282353872784, -1.029428823753572],
            [29.816491774687126, -1.028226453730686],
            [29.821110168072998, -1.027300337281492],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 241,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KINAABA",
        Population: 8478,
        Key: "KANUNGUKINAABA",
        Dist2: "Kanungu",
        "Sub Country": "Kinaaba",
        id2_original: "Kanungu Kinaaba",
        drought: "VL",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.74907809765247, -0.814425833086737],
            [29.747866041263784, -0.813731299769044],
            [29.747839394537515, -0.81278740922724],
            [29.747178818393333, -0.811843246302607],
            [29.745663099997607, -0.811648302706249],
            [29.742109012594018, -0.810203262974832],
            [29.7393253024118, -0.810174357180809],
            [29.73728487716032, -0.811061874816191],
            [29.735452288827865, -0.810667941931674],
            [29.73558708193457, -0.815071963667356],
            [29.734566443058224, -0.815959889816336],
            [29.733847948036086, -0.817902853364912],
            [29.73416302942706, -0.819832371366217],
            [29.73479607759765, -0.820720991686705],
            [29.735180372384622, -0.822331290750545],
            [29.734848108917227, -0.823885764642204],
            [29.73498276278505, -0.827106092790219],
            [29.73606892837151, -0.829674457166023],
            [29.735874187092634, -0.831506598746336],
            [29.73482554952549, -0.832810909281627],
            [29.73419149164853, -0.832949435522418],
            [29.734383355623528, -0.834032200494166],
            [29.733443338747282, -0.836974454999937],
            [29.732174452238787, -0.838028812680394],
            [29.731401452835126, -0.839305473872885],
            [29.73146131926059, -0.844906211434906],
            [29.729275981380702, -0.847348187707572],
            [29.728083236974012, -0.849413054316753],
            [29.72676390646907, -0.850405392177979],
            [29.723677366119723, -0.850641746123362],
            [29.71425868218101, -0.8491180727985],
            [29.712497001467245, -0.846896438398916],
            [29.711218792242736, -0.846274031347738],
            [29.709525291862366, -0.842031493642584],
            [29.70875427234558, -0.841342689506532],
            [29.708634257423622, -0.840087876353449],
            [29.708018071529214, -0.838910567420551],
            [29.708349242645205, -0.838466549003131],
            [29.70804868162251, -0.837571770881345],
            [29.707019547378515, -0.836961351774747],
            [29.705675776409606, -0.837134258115277],
            [29.70481484451603, -0.836786868153153],
            [29.704401635655017, -0.836578481227822],
            [29.704161486335163, -0.835572075517937],
            [29.702542906347826, -0.834946752835788],
            [29.701027056798058, -0.834946077374397],
            [29.698304150882468, -0.836228760336595],
            [29.696337665063687, -0.839243016220882],
            [29.696145899005035, -0.841441443232986],
            [29.695670088348493, -0.842635924435321],
            [29.694719752524595, -0.843495431073094],
            [29.693719999478592, -0.846649069387062],
            [29.69377845734571, -0.848753365388839],
            [29.693295229299867, -0.849655331162571],
            [29.694269874433658, -0.852667599662543],
            [29.693901877780895, -0.856112699473408],
            [29.691618133953234, -0.862469506399106],
            [29.690715710673324, -0.862824674376222],
            [29.689242243638642, -0.864639601299393],
            [29.687341781298294, -0.86607178548704],
            [29.686271749454338, -0.868054337015458],
            [29.684893527195978, -0.869534764665754],
            [29.679098342584542, -0.872492913710013],
            [29.67762369157032, -0.875646044840427],
            [29.674013437901912, -0.87765019058077],
            [29.67009840202732, -0.881372646288933],
            [29.672414353152885, -0.883870853905474],
            [29.674302186976966, -0.88223801038087],
            [29.674963024530904, -0.882815736434767],
            [29.678921500237703, -0.882073762121095],
            [29.67997921617908, -0.882651688501017],
            [29.682074378475804, -0.882119744125545],
            [29.687270414640516, -0.878691238161583],
            [29.68777423117437, -0.881844982935314],
            [29.690550426949237, -0.883689605326691],
            [29.700110323355645, -0.88203984126439],
            [29.700549396510354, -0.883861120919268],
            [29.70307938203212, -0.889236720042857],
            [29.722759453189365, -0.884338833026127],
            [29.725738124737703, -0.885244726270107],
            [29.72969520356425, -0.887302220374621],
            [29.72965163706959, -0.889933322693998],
            [29.730302468289587, -0.892071430009207],
            [29.7303001425513, -0.894291438984527],
            [29.72911614414222, -0.894578623231929],
            [29.728789003766874, -0.895154022799406],
            [29.72956396598946, -0.895688854824494],
            [29.730339747475565, -0.895442575844598],
            [29.730421032432357, -0.89577150769554],
            [29.72310726469771, -0.90292117067445],
            [29.721269466136626, -0.903906894355693],
            [29.723551186059993, -0.907690264732892],
            [29.734172662960166, -0.92213402809683],
            [29.741201144625162, -0.92998182789899],
            [29.740693689016137, -0.935605633044333],
            [29.743579986803788, -0.934521826151908],
            [29.746093627479, -0.935213850915327],
            [29.74827933276983, -0.937188394208693],
            [29.75109818684256, -0.938433476544837],
            [29.75156512304241, -0.940299438007516],
            [29.751980133025565, -0.938418824293141],
            [29.753008761518068, -0.937513648608133],
            [29.753058909070504, -0.935097497754638],
            [29.751799654298484, -0.933727219186736],
            [29.752586579385678, -0.931049956370201],
            [29.752369576057436, -0.929438967498016],
            [29.75301129297055, -0.929137499307516],
            [29.754912124518476, -0.926067185201474],
            [29.755000705592032, -0.922975088913121],
            [29.755895766279867, -0.919930765168065],
            [29.75598656439552, -0.915768420040657],
            [29.753255081365612, -0.90940794917446],
            [29.750352834888403, -0.906986785234449],
            [29.749593038922775, -0.905554107578563],
            [29.747243906725558, -0.904735765430097],
            [29.747025686180116, -0.903385457547557],
            [29.747475366641655, -0.902727884409983],
            [29.750171780341205, -0.902506617289182],
            [29.750496643487306, -0.900412856822289],
            [29.75129164173395, -0.898631574328043],
            [29.752956881115466, -0.897445002483496],
            [29.754161921661787, -0.89597614584891],
            [29.75532510969901, -0.895373059223011],
            [29.75600608927823, -0.895454163594783],
            [29.756467861063502, -0.894971304412022],
            [29.756350470120505, -0.89360202190818],
            [29.757496314384532, -0.891690142268665],
            [29.757751347890324, -0.889445283724644],
            [29.759016518068467, -0.887956326503746],
            [29.760385573917677, -0.884655291551846],
            [29.75977665988547, -0.883617836675121],
            [29.759582168338262, -0.880758491342787],
            [29.75860380867074, -0.879146893600113],
            [29.758691300087843, -0.875254595755305],
            [29.76071587366785, -0.874960496485527],
            [29.762937965219276, -0.875767692164522],
            [29.76768468743507, -0.876395712703657],
            [29.768742213831967, -0.876206151724056],
            [29.768808835588366, -0.875289182247562],
            [29.76794852892224, -0.874724699144894],
            [29.767443006487667, -0.872096638207368],
            [29.769670393607687, -0.870306386040293],
            [29.77027385396778, -0.869098743872189],
            [29.76981821677759, -0.866561331115334],
            [29.770240231823315, -0.8659173351225],
            [29.769934006922764, -0.863792817188374],
            [29.771399280423715, -0.862404640113411],
            [29.76845835249038, -0.860408920513519],
            [29.76694209600376, -0.857286752534695],
            [29.76787745781021, -0.855404839515661],
            [29.770082334047533, -0.854822653224156],
            [29.77026434170725, -0.853977111863686],
            [29.771126920212737, -0.85341398998276],
            [29.770889190954264, -0.852084873128817],
            [29.77173154119618, -0.851622423926059],
            [29.772187016689625, -0.850651360630442],
            [29.77202945937531, -0.849005842424423],
            [29.774532848476476, -0.84602594192585],
            [29.773092168153056, -0.845211360198198],
            [29.773261172699016, -0.844011512934724],
            [29.772902060384414, -0.843090315000442],
            [29.771459021983382, -0.842698509579991],
            [29.77001465407572, -0.842976462270201],
            [29.769822024736087, -0.842111209615677],
            [29.77124538733746, -0.838456540147709],
            [29.773692825769473, -0.836421231728063],
            [29.774055063322944, -0.835779657691858],
            [29.7739457230815, -0.834914472608781],
            [29.77375186035499, -0.834663165041412],
            [29.773222423869257, -0.835611580120996],
            [29.771834083885857, -0.835638432400365],
            [29.77072201537819, -0.836363150155867],
            [29.769725409130626, -0.83488333581548],
            [29.766478961474192, -0.833820409168351],
            [29.76378843892631, -0.83245094205454],
            [29.762226180612323, -0.829198658640219],
            [29.759562939899624, -0.82808038115799],
            [29.75878972669689, -0.825958918918146],
            [29.75904111034771, -0.825205646569801],
            [29.760595352994393, -0.825513791534973],
            [29.76098517960689, -0.82495596326946],
            [29.760047699573015, -0.821662307853766],
            [29.760191009606903, -0.819402009194396],
            [29.75844301652311, -0.818786760236131],
            [29.758137102439616, -0.819037684368868],
            [29.758329081398976, -0.820237791629045],
            [29.75705067005355, -0.820850772351054],
            [29.755858428703405, -0.820012682508775],
            [29.754497609507048, -0.82017910172254],
            [29.751528642458744, -0.819228056548215],
            [29.751114493061607, -0.818055690625396],
            [29.75126916678387, -0.817065141058539],
            [29.74913271522173, -0.814953327086476],
            [29.74907809765247, -0.814425833086737],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 242,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "KIRIMA",
        Population: 17655,
        Key: "KANUNGUKIRIMA",
        Dist2: "Kanungu",
        "Sub Country": "Kirima",
        id2_original: "Kanungu Kirima",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.75156512304241, -0.940299438007516],
            [29.75109818684256, -0.938433476544837],
            [29.74827933276983, -0.937188394208693],
            [29.746093627479, -0.935213850915327],
            [29.743579986803788, -0.934521826151908],
            [29.740693689016137, -0.935605633044333],
            [29.741201144625162, -0.92998182789899],
            [29.734172662960166, -0.92213402809683],
            [29.723551186059993, -0.907690264732892],
            [29.721269466136626, -0.903906894355693],
            [29.72310726469771, -0.90292117067445],
            [29.730421032432357, -0.89577150769554],
            [29.730339747475565, -0.895442575844598],
            [29.72956396598946, -0.895688854824494],
            [29.728789003766874, -0.895154022799406],
            [29.72911614414222, -0.894578623231929],
            [29.7303001425513, -0.894291438984527],
            [29.730302468289587, -0.892071430009207],
            [29.72965163706959, -0.889933322693998],
            [29.72969520356425, -0.887302220374621],
            [29.725738124737703, -0.885244726270107],
            [29.722759453189365, -0.884338833026127],
            [29.70307938203212, -0.889236720042857],
            [29.700549396510354, -0.883861120919268],
            [29.700110323355645, -0.88203984126439],
            [29.690550426949237, -0.883689605326691],
            [29.68777423117437, -0.881844982935314],
            [29.687270414640516, -0.878691238161583],
            [29.682074378475804, -0.882119744125545],
            [29.67997921617908, -0.882651688501017],
            [29.678921500237703, -0.882073762121095],
            [29.674963024530904, -0.882815736434767],
            [29.674302186976966, -0.88223801038087],
            [29.672414353152885, -0.883870853905474],
            [29.672069925598198, -0.884326183558825],
            [29.67090977027341, -0.884549317353135],
            [29.670637725371076, -0.885096032412991],
            [29.670511016203626, -0.888227959683275],
            [29.671596448764785, -0.888651081784151],
            [29.67178946707492, -0.889464812542155],
            [29.67254352280589, -0.891547423540781],
            [29.67422215427166, -0.891125705669116],
            [29.67530774493634, -0.891399686527276],
            [29.6761459961656, -0.892195545066364],
            [29.676268202976875, -0.893314184588584],
            [29.67868684501413, -0.893240846957854],
            [29.679598714977587, -0.894434455810203],
            [29.679535862552104, -0.895515723011743],
            [29.678991888630105, -0.896484872314534],
            [29.68022463591471, -0.89762894410273],
            [29.682543361936204, -0.898699002561595],
            [29.684122921802548, -0.898625241086008],
            [29.68496162308779, -0.898998530490556],
            [29.684594813109488, -0.907362877070849],
            [29.69251069462961, -0.913208540391667],
            [29.693101050366348, -0.915023469497961],
            [29.69290165042443, -0.916837970142737],
            [29.6944157779038, -0.920231840729086],
            [29.696758021819402, -0.922395718349345],
            [29.695867405097278, -0.924358995524042],
            [29.698515339415867, -0.929095830144203],
            [29.70174748319802, -0.929967593273613],
            [29.702617725231214, -0.935349796412464],
            [29.700168615932768, -0.940593469089571],
            [29.69664829620074, -0.943661454052523],
            [29.69496668681979, -0.94669315112254],
            [29.688870889083326, -0.946540592197019],
            [29.68699444230378, -0.947235545378627],
            [29.686263374460932, -0.949932174268385],
            [29.684755598968945, -0.951994492138026],
            [29.683081389010983, -0.959388613122499],
            [29.685373343440382, -0.962298250485958],
            [29.68606227221155, -0.964162957747333],
            [29.685809041624527, -0.969830319615158],
            [29.684683648406253, -0.971979819576121],
            [29.683424850876722, -0.972078509560669],
            [29.68238716017964, -0.973072196837032],
            [29.682286911787184, -0.974414436350949],
            [29.68121112353893, -0.976340243152198],
            [29.67558143106067, -0.978673471533477],
            [29.676191644955075, -0.980148494516545],
            [29.68414070844518, -0.984338460245627],
            [29.68703924577858, -0.986903023308541],
            [29.688637506772505, -0.989084131898953],
            [29.688389640924385, -0.990003703399395],
            [29.68725354607612, -0.990699030293115],
            [29.68732703455457, -0.991171361192556],
            [29.688905733834904, -0.991893194949386],
            [29.687719935201972, -0.992886775736258],
            [29.688089390718755, -0.993533293114599],
            [29.68808770817423, -0.994975025658004],
            [29.68932022549014, -0.996268366647358],
            [29.690900342311956, -0.995772186215002],
            [29.692725997447045, -0.996369878891258],
            [29.693122376371207, -0.995077527735871],
            [29.694564989869114, -0.996109997840315],
            [29.695575008862203, -0.997726363119854],
            [29.698042996256323, -0.997777586272845],
            [29.69944912647561, -0.998350176280742],
            [29.700807514830814, -0.997530697494311],
            [29.701152226253118, -0.998226929963713],
            [29.70095388722154, -0.998997393166743],
            [29.70045995485075, -0.999270537394004],
            [29.700558014947177, -0.999842325068381],
            [29.70085397749396, -1.000016505229391],
            [29.702804764354834, -0.999147670142925],
            [29.703322223602875, -0.999868868039567],
            [29.705098040206, -1.00088912590707],
            [29.705125949065255, -1.002810086953052],
            [29.706007211630308, -1.002868636462019],
            [29.707600351328814, -1.003982911011563],
            [29.70930687638249, -1.004321543624047],
            [29.71100952251077, -1.005602498662528],
            [29.712167403301276, -1.005384873978095],
            [29.712768395989308, -1.006606504930161],
            [29.71529585275357, -1.008278421718633],
            [29.718317709012553, -1.008704031461037],
            [29.719236323527113, -1.008352857171497],
            [29.719374677555614, -1.006362673312451],
            [29.719839265559315, -1.005416023654101],
            [29.720371312549254, -1.005196938521342],
            [29.724445868557083, -1.007257572462599],
            [29.724551479891772, -1.008366605554104],
            [29.725871686254155, -1.00887017427067],
            [29.726693301582667, -1.010037167887831],
            [29.72796460455929, -1.009043872528156],
            [29.72901117420462, -1.009103005739658],
            [29.72948960075528, -1.010656829128341],
            [29.73019665034236, -1.010215864430533],
            [29.731383038270124, -1.01110699287881],
            [29.733276479378194, -1.011557157465047],
            [29.73415964547336, -1.011161162735538],
            [29.735260821908216, -1.011342444165032],
            [29.73600498449295, -1.012406784468979],
            [29.73715344375276, -1.011622839226688],
            [29.73758894700251, -1.010412202030458],
            [29.738492551567035, -1.009676155124483],
            [29.7399929491956, -1.00658619625779],
            [29.74054157189918, -1.003921282570454],
            [29.741943937279096, -1.002224259479976],
            [29.74385404213572, -1.001525498588924],
            [29.74828818926021, -1.002071968031696],
            [29.749365568424857, -1.001690430121663],
            [29.751361183015057, -1.000216887041744],
            [29.752660429885193, -0.998221354966977],
            [29.753299376393965, -0.998061500665813],
            [29.754188726491545, -0.997039133893596],
            [29.75585948691882, -0.996824756457175],
            [29.75606348264172, -0.995416595985774],
            [29.7571101178641, -0.995399733559715],
            [29.758798002875608, -0.994153323934671],
            [29.76089291993226, -0.993353000493905],
            [29.76373176960491, -0.993070362009762],
            [29.764833968322563, -0.991966026623222],
            [29.764394013022272, -0.990325420208961],
            [29.765423684458803, -0.989951970857106],
            [29.767127983487207, -0.987918417934564],
            [29.76714293684342, -0.986485935392877],
            [29.765529834782686, -0.985949604747081],
            [29.765427103446786, -0.984220171375883],
            [29.764735741139514, -0.984005591019087],
            [29.764430487317753, -0.981589578089964],
            [29.764769273452433, -0.980769791576815],
            [29.766100695281107, -0.980307467664126],
            [29.765608111281598, -0.978381554457417],
            [29.765218049310494, -0.978292056676248],
            [29.765460285416736, -0.97699972544369],
            [29.76581506425841, -0.977000049688364],
            [29.766260930473276, -0.975877263852285],
            [29.76764499537425, -0.975682406206353],
            [29.767309209612613, -0.975093769811065],
            [29.767861510917303, -0.97397108393566],
            [29.76724376105598, -0.972508596019257],
            [29.767866290852925, -0.971724716771374],
            [29.768289207807204, -0.968881463484606],
            [29.76921474024782, -0.96742037184449],
            [29.771892799569468, -0.967672368144244],
            [29.773477128591647, -0.965052997365229],
            [29.7748280959643, -0.963734900135507],
            [29.777239472427535, -0.964271900776217],
            [29.778065908115874, -0.96353275568742],
            [29.778582911918075, -0.96232086777273],
            [29.777982494151857, -0.961036677016535],
            [29.777614881079717, -0.958718647331065],
            [29.77520229009421, -0.954553559419351],
            [29.775168354437728, -0.953822561517049],
            [29.77579106299939, -0.95294951365158],
            [29.77577508915704, -0.952111559693787],
            [29.7752234310461, -0.951677554549613],
            [29.774570637905537, -0.951254730038429],
            [29.773202938512416, -0.952109289964472],
            [29.770378184304878, -0.949922827684242],
            [29.76885391574428, -0.949315323014768],
            [29.768181870808856, -0.948352000301619],
            [29.7697257900163, -0.948050272367763],
            [29.76993985136201, -0.947479955232118],
            [29.76976418940146, -0.946659689852871],
            [29.76884285658481, -0.946141865571021],
            [29.767494444020834, -0.946265482048419],
            [29.767013091657297, -0.947406072614129],
            [29.76563014785383, -0.947083944848436],
            [29.76468320496673, -0.946093646089845],
            [29.763548104553525, -0.946003508846507],
            [29.762841038796754, -0.944826225731612],
            [29.760555551339095, -0.943487108412574],
            [29.760771305110772, -0.942114517588132],
            [29.75826925629601, -0.942540212045002],
            [29.756889199677847, -0.940845323643267],
            [29.756002946971353, -0.940523648857896],
            [29.755488038938708, -0.940754960817185],
            [29.753624895310207, -0.938925954021229],
            [29.753248048455273, -0.938881056862294],
            [29.75266944178411, -0.939883382699702],
            [29.75156512304241, -0.940299438007516],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 243,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "MPUNGU",
        Population: 11946,
        Key: "KANUNGUMPUNGU",
        Dist2: "Kanungu",
        "Sub Country": "Mpungu",
        id2_original: "Kanungu Mpungu",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.745413488722853, -0.675576741317119],
            [29.744560214967073, -0.675503467239463],
            [29.744321959295863, -0.676911031950315],
            [29.743146853309753, -0.678949169348017],
            [29.743074865916153, -0.679951359120145],
            [29.741556482218968, -0.681499584270264],
            [29.741459952851798, -0.683456321089469],
            [29.74004706101336, -0.686329251493449],
            [29.73980807411348, -0.68854821618573],
            [29.73802823844781, -0.69088343764646],
            [29.737304906896203, -0.691299631874517],
            [29.73656892077718, -0.692634599907189],
            [29.73436380109641, -0.693393887577297],
            [29.734126197602098, -0.694037762657232],
            [29.734504859053907, -0.694706732038937],
            [29.734432737811336, -0.695852091318561],
            [29.73348310626659, -0.697520738612754],
            [29.733790767573307, -0.698070242233047],
            [29.733576899365403, -0.698666434051507],
            [29.732296074246776, -0.699594595929014],
            [29.73148815193812, -0.701836273781516],
            [29.729994098212096, -0.702644676153264],
            [29.729625848234413, -0.703586595699893],
            [29.727137178029192, -0.703366829549961],
            [29.726376632868625, -0.705632443879436],
            [29.725759784915823, -0.706251688243871],
            [29.725924544922098, -0.707540705802151],
            [29.724857181972855, -0.708326088715071],
            [29.725555402917333, -0.709461068115768],
            [29.724321162632723, -0.711296153745068],
            [29.724296593709706, -0.712250685602361],
            [29.723133935678508, -0.713560895593831],
            [29.722943377853916, -0.714586682096588],
            [29.72203013526473, -0.71531271135559],
            [29.721176851627472, -0.715263262952812],
            [29.718661926361417, -0.717859413862081],
            [29.71674126360527, -0.718619189653209],
            [29.715103812708737, -0.720715945439894],
            [29.71606196836721, -0.722710561855761],
            [29.715373666620085, -0.723687604011801],
            [29.714909847574294, -0.725428760923399],
            [29.71522819074803, -0.727219229803786],
            [29.71619864074947, -0.728724655955252],
            [29.716268645561247, -0.729918014243511],
            [29.71802023549945, -0.732570527727544],
            [29.718291394662906, -0.734110334976099],
            [29.71776843503038, -0.735708177958774],
            [29.71835921926349, -0.737642404390042],
            [29.71763451328949, -0.739514278619537],
            [29.717846929819885, -0.740493155814297],
            [29.715332198589934, -0.742802859681418],
            [29.71368113731855, -0.746701291418915],
            [29.714011705665015, -0.748062235571122],
            [29.713441991416886, -0.748944044518472],
            [29.713439002721945, -0.752094129116291],
            [29.71425480954382, -0.753787309910468],
            [29.71626600092106, -0.754593093585996],
            [29.716705733439134, -0.75595351520071],
            [29.716786220691976, -0.758340941617495],
            [29.718546313184337, -0.762477903042891],
            [29.71986771789932, -0.764116260470482],
            [29.720112785495342, -0.767336572393616],
            [29.71967122490564, -0.767974907343951],
            [29.718210184266272, -0.768307481382716],
            [29.71824999580304, -0.769959248115415],
            [29.71780842533186, -0.770597580877074],
            [29.71857922565973, -0.77156948796002],
            [29.719431159129115, -0.774207062765191],
            [29.720779803458406, -0.776178568473392],
            [29.720323686567834, -0.777635829771187],
            [29.718530685193368, -0.77927301546145],
            [29.71841978996815, -0.779966986007852],
            [29.717123067363957, -0.781410032376808],
            [29.718004367658292, -0.782104383420725],
            [29.71772697508507, -0.783991986149987],
            [29.719242225458544, -0.784631075795843],
            [29.719489439129806, -0.785519506154463],
            [29.717806136424528, -0.787711924531041],
            [29.71659411327353, -0.78701743698846],
            [29.715408731458883, -0.787294584215562],
            [29.71616493416338, -0.789113187056532],
            [29.71533694708456, -0.790334323494519],
            [29.71509522301799, -0.79161383371569],
            [29.71875303080258, -0.791890258459911],
            [29.72455565615955, -0.790823769794485],
            [29.725134228694692, -0.791046088829388],
            [29.727368085481373, -0.789575645282231],
            [29.728802795601446, -0.787966084201312],
            [29.730953780108234, -0.786689916072467],
            [29.734113700239842, -0.782291029654077],
            [29.73523221505798, -0.77596248508064],
            [29.736539816260287, -0.773470717111043],
            [29.741738545574236, -0.766445682442013],
            [29.743507520608134, -0.761810765341529],
            [29.74497352803268, -0.762994770313229],
            [29.74666738594252, -0.763474960768342],
            [29.748335118148944, -0.765166726879918],
            [29.749640953263395, -0.765529289614108],
            [29.751731121825447, -0.765004961906983],
            [29.75756170904227, -0.762264739120949],
            [29.761431541691785, -0.76165956349667],
            [29.766043297426037, -0.761703432440159],
            [29.76659779690819, -0.750668196888019],
            [29.7673808197138, -0.749038582327315],
            [29.762992394142344, -0.743803843621737],
            [29.75960467113612, -0.742707953460326],
            [29.758821299784206, -0.742042897551351],
            [29.755150054999596, -0.74137571810283],
            [29.753710776946317, -0.734937544405732],
            [29.753712508898186, -0.732528819663121],
            [29.752930565867555, -0.729870348112614],
            [29.75268487394238, -0.72729532714747],
            [29.745878140506957, -0.725376615205762],
            [29.746893364338764, -0.717510649654076],
            [29.745463557223548, -0.712770555254157],
            [29.745560312966155, -0.710622887732606],
            [29.744816733388035, -0.707172901572573],
            [29.74480964029055, -0.701862914915622],
            [29.74654326931299, -0.698215019247296],
            [29.74793399342515, -0.693647617005554],
            [29.748207991264906, -0.691134513778744],
            [29.747804283884626, -0.68909528928375],
            [29.748614989174055, -0.688314247995327],
            [29.746795532414435, -0.683198651388184],
            [29.745413488722853, -0.675576741317119],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 244,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "NYAKINONI",
        Population: 8743,
        Key: "KANUNGUNYAKINONI",
        Dist2: "Kanungu",
        "Sub Country": "Nyakinoni",
        id2_original: "Kanungu Nyakinoni",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.80339582275983, -0.691891471629114],
            [29.803970075296764, -0.691236002546006],
            [29.803528319772653, -0.690129704353408],
            [29.80376392182053, -0.688867687918735],
            [29.804286469126364, -0.688557453793023],
            [29.804380149037442, -0.687724130640424],
            [29.805092698110688, -0.687294597077698],
            [29.80506810223823, -0.68681853139329],
            [29.803499213459133, -0.687011264560219],
            [29.802167054113603, -0.686608533838583],
            [29.80230812824075, -0.685679923885403],
            [29.801285550800035, -0.685562393135703],
            [29.800487849522685, -0.684861314482669],
            [29.79970030729288, -0.683148505604019],
            [29.797867148530237, -0.681746695113944],
            [29.797794517044547, -0.68098504678319],
            [29.797080865738458, -0.680771850298375],
            [29.796770596622473, -0.680081953285936],
            [29.796935228169662, -0.679034289523575],
            [29.79563741770562, -0.677857858357207],
            [29.796207261311167, -0.677404723227133],
            [29.796324457319763, -0.676428540037698],
            [29.79475365423081, -0.675502464789275],
            [29.794228134399685, -0.674074944079243],
            [29.79398527935421, -0.671123481959584],
            [29.793367315693846, -0.671243424871048],
            [29.793202156835594, -0.671981622230209],
            [29.792013661460206, -0.67215000972704],
            [29.79237107955219, -0.672601777306821],
            [29.79201472865876, -0.672768936869918],
            [29.78907693764239, -0.671904394884769],
            [29.788909604861157, -0.671380938518496],
            [29.789336038719775, -0.670499527081989],
            [29.789859561596018, -0.670760605432731],
            [29.78988210571638, -0.670046430790525],
            [29.788239196656182, -0.668668181317094],
            [29.788832851904953, -0.668238814935647],
            [29.78818954677044, -0.667454211397679],
            [29.787452179940814, -0.667264855787902],
            [29.787949821455417, -0.666311932670508],
            [29.786950832875714, -0.666075362959615],
            [29.78724536799948, -0.66453951356034],
            [29.786484182340114, -0.66432639989479],
            [29.786602191324043, -0.663826330586751],
            [29.785435828640612, -0.663042500642716],
            [29.784889410402744, -0.663281362845868],
            [29.784916264639843, -0.663686003393327],
            [29.784152611308382, -0.663425281274511],
            [29.784127104544236, -0.662425519692933],
            [29.783483976377813, -0.661736141080407],
            [29.78372119269824, -0.661426325607059],
            [29.78238782511865, -0.660309492171176],
            [29.782588246445073, -0.659345103275683],
            [29.779162193223996, -0.657969524927136],
            [29.7786856567287, -0.657375123711228],
            [29.7785882380294, -0.656042211100586],
            [29.777993149069463, -0.655638418783925],
            [29.77756324681552, -0.654520246548207],
            [29.77853621299803, -0.653471389850642],
            [29.779297602574974, -0.653803519414899],
            [29.780639609252646, -0.653051666740304],
            [29.78142220625683, -0.651907872041972],
            [29.78118237763554, -0.650717996481962],
            [29.781892150914558, -0.648717347911616],
            [29.78286473351648, -0.64745423663177],
            [29.78387362602218, -0.646560054917766],
            [29.785680606080817, -0.646581146017605],
            [29.78639307879727, -0.646127785261416],
            [29.786603972683256, -0.64436591354645],
            [29.78729225376912, -0.643674537424825],
            [29.787052956052143, -0.642794118167259],
            [29.787835542276532, -0.641650316663933],
            [29.7885023832715, -0.642292037311216],
            [29.78930887186895, -0.641219611358539],
            [29.789117875666516, -0.640767600209135],
            [29.790043736890496, -0.639980650614447],
            [29.79080497644879, -0.64021754582516],
            [29.79361888709253, -0.638225585588161],
            [29.79461800502964, -0.638533546680637],
            [29.795044257428582, -0.637556896880431],
            [29.795757861123985, -0.637746261692723],
            [29.795685107467428, -0.636936998862429],
            [29.796136764222616, -0.636888700332219],
            [29.796421059450456, -0.636316957048295],
            [29.797349191615506, -0.636815457126975],
            [29.797609597046712, -0.636172325527254],
            [29.798773890011727, -0.63576587817191],
            [29.798487787373517, -0.63531401834917],
            [29.797917542221036, -0.635529121088319],
            [29.797083933485148, -0.634697212771516],
            [29.799031981382743, -0.633813473802373],
            [29.79857923227615, -0.633242833242095],
            [29.797889911839516, -0.633339105199951],
            [29.79755466057548, -0.631982721034725],
            [29.798693409945404, -0.630576495612277],
            [29.79763541372966, -0.630590003659396],
            [29.79808609760939, -0.629994189879341],
            [29.796824682389115, -0.629258155677549],
            [29.797132885379913, -0.628757777506739],
            [29.796799351694723, -0.628377410586709],
            [29.79372990089536, -0.627025188571509],
            [29.79252546581355, -0.624896479971275],
            [29.793044650725278, -0.622705634117278],
            [29.79375736868178, -0.622395088686346],
            [29.79387388197078, -0.62106182745329],
            [29.79251448660416, -0.61870722488532],
            [29.79215735417642, -0.61842210365446],
            [29.791361653447208, -0.618863716654103],
            [29.7893610478173, -0.616914775080634],
            [29.788766796985488, -0.616987100539234],
            [29.788058268771447, -0.619654328061333],
            [29.78710860758233, -0.620417526172004],
            [29.786798214498845, -0.619680052509885],
            [29.78651316827939, -0.619823316433094],
            [29.785041077463728, -0.620944392204464],
            [29.78494690258092, -0.621468243615667],
            [29.7840423035814, -0.62082689317638],
            [29.78313972848621, -0.621328170365253],
            [29.78306764587118, -0.620899797062697],
            [29.782020308166235, -0.620211058708323],
            [29.781509961778614, -0.62067602818239],
            [29.780416558465916, -0.620820516410507],
            [29.78017753922671, -0.620106743465185],
            [29.77951166931057, -0.620012545352692],
            [29.77851454653171, -0.620823424984658],
            [29.77616004959562, -0.620398533307144],
            [29.77563871950699, -0.62137530668788],
            [29.775305831710483, -0.621352015640578],
            [29.77513759522408, -0.620328673625988],
            [29.77430534114764, -0.620258533685937],
            [29.773997736434776, -0.621092158185133],
            [29.772856832006486, -0.621260524913353],
            [29.772835203269402, -0.622474588490853],
            [29.771884791987013, -0.622809295374208],
            [29.77166055542411, -0.623726105723719],
            [29.770805283815143, -0.624084476341555],
            [29.76900371969934, -0.627110368013325],
            [29.768602779130195, -0.628943907103732],
            [29.76912624541255, -0.62918116302262],
            [29.768367001012514, -0.630063069429189],
            [29.767747971051897, -0.629564119570697],
            [29.766594948350427, -0.629601575260038],
            [29.76623690053945, -0.628792769271449],
            [29.76504870520133, -0.629104019458674],
            [29.76454817111154, -0.628390656347214],
            [29.76378733489681, -0.628368003096531],
            [29.763262689126492, -0.627464231822512],
            [29.762574565245824, -0.628227015600107],
            [29.762310020377793, -0.626513513649384],
            [29.75824269131645, -0.625472293635893],
            [29.75762245312177, -0.624283029067514],
            [29.75634880644058, -0.623320899694444],
            [29.756394666334167, -0.622368661809886],
            [29.755158055395512, -0.622180113857497],
            [29.753777404092638, -0.621206242013364],
            [29.751084200971917, -0.622004910483842],
            [29.75042066847212, -0.626143738867506],
            [29.75358398693049, -0.632829828355018],
            [29.75331859674779, -0.634008334308365],
            [29.751115528819124, -0.635776018628858],
            [29.75083961936445, -0.636841550675807],
            [29.751801800373716, -0.638728459107416],
            [29.75106028692075, -0.639473982072104],
            [29.75084802400226, -0.640326412144823],
            [29.751895386859996, -0.641424755751451],
            [29.75318519602979, -0.644175102782731],
            [29.752919802253803, -0.645336554495674],
            [29.751733450258662, -0.646401500685389],
            [29.752028652830695, -0.648319962280064],
            [29.751275533144266, -0.650653373153021],
            [29.750374893918522, -0.65189966556474],
            [29.748276950437692, -0.653340081763079],
            [29.748830812116005, -0.657099921371312],
            [29.748781278112926, -0.659605669312402],
            [29.748045694439135, -0.660511106541411],
            [29.746726074676662, -0.66526960427978],
            [29.74696131380518, -0.667370196771089],
            [29.747789407783525, -0.669161708149499],
            [29.74698107135154, -0.671952337369473],
            [29.747287388778567, -0.67407693640465],
            [29.747002736919537, -0.674315029166279],
            [29.746457941039097, -0.673860516683602],
            [29.745415017655482, -0.673810730103906],
            [29.745413488722853, -0.675576741317119],
            [29.746795532414435, -0.683198651388184],
            [29.748614989174055, -0.688314247995327],
            [29.747804283884626, -0.68909528928375],
            [29.748207991264906, -0.691134513778744],
            [29.74793399342515, -0.693647617005554],
            [29.74654326931299, -0.698215019247296],
            [29.74480964029055, -0.701862914915622],
            [29.744816733388035, -0.707172901572573],
            [29.745560312966155, -0.710622887732606],
            [29.745463557223548, -0.712770555254157],
            [29.746893364338764, -0.717510649654076],
            [29.745878140506957, -0.725376615205762],
            [29.75268487394238, -0.72729532714747],
            [29.752930565867555, -0.729870348112614],
            [29.753712508898186, -0.732528819663121],
            [29.753710776946317, -0.734937544405732],
            [29.755150054999596, -0.74137571810283],
            [29.758821299784206, -0.742042897551351],
            [29.75960467113612, -0.742707953460326],
            [29.762992394142344, -0.743803843621737],
            [29.7673808197138, -0.749038582327315],
            [29.76659779690819, -0.750668196888019],
            [29.766043297426037, -0.761703432440159],
            [29.76889007293445, -0.762545886912685],
            [29.77034537064417, -0.762451220950118],
            [29.773127903135062, -0.761667204789584],
            [29.778282524270228, -0.761397396271372],
            [29.78090694608459, -0.760254504928605],
            [29.781300286008136, -0.758522237198252],
            [29.782526571710918, -0.757292905970587],
            [29.782679723687103, -0.755434084417882],
            [29.780916526617098, -0.752972533828085],
            [29.782482044917252, -0.751231306861784],
            [29.7828345312583, -0.748708411392468],
            [29.788010389465114, -0.744801436481327],
            [29.789781666881108, -0.744258189351082],
            [29.794277936999038, -0.73864580037385],
            [29.796482272450575, -0.734524431497267],
            [29.79624093286297, -0.732083862956825],
            [29.796419531416163, -0.731331137032577],
            [29.797488760166246, -0.73014884546504],
            [29.797596206759078, -0.72928851695052],
            [29.80048346843904, -0.725597994446004],
            [29.80251390083131, -0.724918278457777],
            [29.802969259543797, -0.724415669038748],
            [29.802405938605514, -0.722327805775226],
            [29.803164458963458, -0.720946019012772],
            [29.802994063825423, -0.718589547580359],
            [29.80478342163312, -0.715170942199498],
            [29.804686471854378, -0.714076039427953],
            [29.803947160172207, -0.712744009396723],
            [29.802399457260755, -0.711413148496576],
            [29.802312680902634, -0.709306523918711],
            [29.801906993635487, -0.708426314175652],
            [29.802285321812338, -0.707187906786363],
            [29.801711225582235, -0.705141496089641],
            [29.80181246481645, -0.701749112296673],
            [29.80328390794677, -0.700175844296758],
            [29.804941711972706, -0.696340793561321],
            [29.804773664132483, -0.695388829236918],
            [29.803595100530877, -0.694426439639115],
            [29.802264574322543, -0.694975897809333],
            [29.801689478267537, -0.692358171654823],
            [29.80339582275983, -0.691891471629114],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 245,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "NYAMIRAMA",
        Population: 18814,
        Key: "KANUNGUNYAMIRAMA",
        Dist2: "Kanungu",
        "Sub Country": "Nyamirama",
        id2_original: "Kanungu Nyamirama",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.67173893324693, -0.71123590927958],
            [29.670695015428304, -0.710136295169148],
            [29.670479843764948, -0.709361208263914],
            [29.666447379218077, -0.710622591311364],
            [29.6625817345144, -0.711187223443918],
            [29.66072906434379, -0.711996497282796],
            [29.660162117805054, -0.71653554997638],
            [29.660563631499393, -0.718076020195697],
            [29.661851044862292, -0.719455017880904],
            [29.65935180148617, -0.723506271973891],
            [29.658143207204592, -0.72447811851831],
            [29.652263435429358, -0.726419230329154],
            [29.640907372883674, -0.729247878662469],
            [29.638251217183615, -0.727705746890843],
            [29.63688583185068, -0.722922188095255],
            [29.63511544107186, -0.72138073593549],
            [29.63302248413918, -0.720487525523063],
            [29.63149111439626, -0.722431816129677],
            [29.62649765281967, -0.72580015845673],
            [29.626947301840172, -0.726516943007527],
            [29.6281558583925, -0.726734175902152],
            [29.628226334819818, -0.727402466866035],
            [29.628676447371028, -0.727618152045629],
            [29.628486165329214, -0.728333626669919],
            [29.628936732427952, -0.728072061081204],
            [29.62936306208204, -0.728383143197041],
            [29.629599538190657, -0.728956328891316],
            [29.62930186076002, -0.730447104130526],
            [29.6307130565792, -0.732461938369694],
            [29.63023776245396, -0.733797243890554],
            [29.6290521794167, -0.734343644230127],
            [29.62957347267438, -0.734487887441301],
            [29.629027210743377, -0.735679870784614],
            [29.628696071068386, -0.734963326628108],
            [29.62812731083111, -0.734890564584647],
            [29.62791290632897, -0.736035511422267],
            [29.6289899198793, -0.737505259180238],
            [29.62915283833923, -0.740631550384043],
            [29.629579255129865, -0.740847187318791],
            [29.630124910698065, -0.740299482634225],
            [29.631284982479553, -0.741662030323557],
            [29.630975947648775, -0.742615882082108],
            [29.62979109045027, -0.742398675110216],
            [29.629506328996793, -0.742756016475954],
            [29.629505551055775, -0.743567334436703],
            [29.63070151682106, -0.744560090330459],
            [29.631008902344995, -0.745324323154907],
            [29.62996461801372, -0.746801617528014],
            [29.63074445898661, -0.749189466634913],
            [29.63043574575269, -0.749809236777013],
            [29.62941670857247, -0.749687814709979],
            [29.628430899176323, -0.751964618480266],
            [29.628991735374502, -0.753424476720052],
            [29.628828940882073, -0.754833999047571],
            [29.629689277192604, -0.755755979385105],
            [29.628827880870034, -0.755972503932891],
            [29.628342489681014, -0.75700240808936],
            [29.628341929132258, -0.757598767273848],
            [29.629041808366743, -0.757436386724781],
            [29.6297402098726, -0.758846248181367],
            [29.62893191566142, -0.759821795783712],
            [29.629200842511384, -0.760038760263992],
            [29.628931004769722, -0.76079766922547],
            [29.629899793786173, -0.760852255032392],
            [29.629360782157836, -0.761665269091189],
            [29.62995285457506, -0.761665502632531],
            [29.629952393739313, -0.762153436028602],
            [29.629198589536667, -0.762424217288792],
            [29.628982168316714, -0.763616859524323],
            [29.62930486113309, -0.763888052982492],
            [29.629735869213132, -0.763454507046966],
            [29.63054283481601, -0.763888537131395],
            [29.630918483318386, -0.765081417891154],
            [29.630110284328623, -0.765948532743911],
            [29.630216602637432, -0.767358165956359],
            [29.630592968893723, -0.767792034861605],
            [29.629892424007583, -0.768659196771695],
            [29.63053786084428, -0.76914738357239],
            [29.629837408484644, -0.769906116665532],
            [29.63015999709643, -0.770285749038774],
            [29.63080620917922, -0.769960710440639],
            [29.630911849260016, -0.772075142378625],
            [29.63042638620573, -0.773159244776805],
            [29.62907998586802, -0.773971932234251],
            [29.629725265499527, -0.774622762409863],
            [29.62950908772305, -0.775544334289632],
            [29.629939269353024, -0.775978221222824],
            [29.629628748708782, -0.776525872887987],
            [29.62983068639136, -0.776954046960551],
            [29.631240516771328, -0.777366644738166],
            [29.633651924675593, -0.777324248159033],
            [29.63429629431374, -0.778929274560312],
            [29.634295251369707, -0.780013571914656],
            [29.63541523672995, -0.779580306972937],
            [29.635715534546293, -0.780751477555263],
            [29.636533016726194, -0.781445764035359],
            [29.63889729182415, -0.78565383837403],
            [29.639498173121076, -0.787692585630741],
            [29.641133092565116, -0.789124541583048],
            [29.646470869406954, -0.790948398267659],
            [29.650389546153416, -0.790819894831507],
            [29.65125148236348, -0.790082911654156],
            [29.652156545792, -0.790334779795298],
            [29.651941843947522, -0.788651887496367],
            [29.652849811629387, -0.78605150490562],
            [29.652756145192996, -0.784426456960725],
            [29.653707027192606, -0.78275445243752],
            [29.654611633378664, -0.779553017782414],
            [29.655273726777374, -0.771711743944499],
            [29.655791381858144, -0.770740394697324],
            [29.657722253967503, -0.768902119779585],
            [29.660065015312707, -0.768660139917868],
            [29.660927874990886, -0.766925541960549],
            [29.66046768064725, -0.761737922003963],
            [29.66153970315787, -0.757331602910827],
            [29.662885984917967, -0.754348020289433],
            [29.664346460516988, -0.753955594711089],
            [29.664798952705407, -0.753221016013993],
            [29.66501506849815, -0.751527324800809],
            [29.6657989348218, -0.749763074510831],
            [29.665657931661528, -0.748498033131226],
            [29.666322532258203, -0.747521019761542],
            [29.665944208572906, -0.746565713018821],
            [29.667285464259002, -0.744384993819057],
            [29.667144974036777, -0.742571107520999],
            [29.66924645148996, -0.738530612687947],
            [29.669981806093322, -0.737911677223975],
            [29.670670956748374, -0.736027887151242],
            [29.670876647592234, -0.731530087774208],
            [29.66983746389514, -0.727566662968794],
            [29.6705962672224, -0.727210261746365],
            [29.67087041148755, -0.725528463232021],
            [29.672199336898053, -0.723813006904781],
            [29.672413785417614, -0.72259641841889],
            [29.67363669525154, -0.720176780605187],
            [29.673067250498008, -0.718373418239013],
            [29.671488120026364, -0.715748358497955],
            [29.671276197569377, -0.713339373846699],
            [29.670849296586773, -0.712779870961091],
            [29.67173893324693, -0.71123590927958],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 246,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "NYANGA",
        Population: 7423,
        Key: "KANUNGUNYANGA",
        Dist2: "Kanungu",
        "Sub Country": "Nyanga",
        id2_original: "Kanungu Nyanga",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.880796012417527, -0.886373113453319],
            [29.879414147490703, -0.884744164761898],
            [29.879167344349547, -0.883565426211168],
            [29.877806859326476, -0.882238498108269],
            [29.877471720351846, -0.881251212022846],
            [29.87599267477926, -0.880572396773811],
            [29.87556215717937, -0.879636585730928],
            [29.8741865984258, -0.878515904041596],
            [29.873281415521344, -0.876732659178285],
            [29.87137817289521, -0.875626294990579],
            [29.870435445801757, -0.874292351735968],
            [29.869454225000048, -0.873879094849654],
            [29.869324106726104, -0.872980369266813],
            [29.86765647423266, -0.871329123821878],
            [29.867658393932423, -0.870371566564746],
            [29.86651589050294, -0.86998766101097],
            [29.866269457467684, -0.86861743427856],
            [29.864925054983114, -0.866583433431299],
            [29.86382017838762, -0.865706048544208],
            [29.86334840296334, -0.863414920014505],
            [29.86257353326726, -0.862427316412023],
            [29.86097648410065, -0.862131458339921],
            [29.860288827343904, -0.861512200198999],
            [29.85974910604646, -0.860215412877998],
            [29.859846301065286, -0.859250568297867],
            [29.858503002610213, -0.856656798563793],
            [29.85846118154218, -0.855581363044604],
            [29.857123696983628, -0.853746271370072],
            [29.85526517698389, -0.852271708328769],
            [29.85412207168318, -0.852197183354548],
            [29.853054096082918, -0.851194636829387],
            [29.85053442861048, -0.85051507337348],
            [29.848918301023854, -0.848768176982564],
            [29.846809855339018, -0.847676465365851],
            [29.844620804722062, -0.845535971513661],
            [29.843041027463418, -0.848675337301393],
            [29.841949337237978, -0.848549295035247],
            [29.84083415157629, -0.849181886598987],
            [29.839852289377482, -0.849107485518977],
            [29.8400040579481, -0.85129696700165],
            [29.83841250736933, -0.850839312382677],
            [29.83610177276061, -0.851649841072824],
            [29.83546700251962, -0.851533310113796],
            [29.83540591977525, -0.853215869656421],
            [29.834972085595314, -0.853650687760139],
            [29.83453982706035, -0.853302235788035],
            [29.832028488767236, -0.85338734172118],
            [29.830323673207566, -0.854314363926487],
            [29.82747187791334, -0.85433770585069],
            [29.824703606177604, -0.853017356799586],
            [29.822972212163613, -0.850490996685135],
            [29.820646618521774, -0.849505194269518],
            [29.818854103135873, -0.849838010432607],
            [29.814880082083068, -0.851478570131093],
            [29.81273123466831, -0.85389865273846],
            [29.812511396257058, -0.855175848532985],
            [29.81159199571657, -0.853371894208492],
            [29.811652268180556, -0.852740376699749],
            [29.808274264047427, -0.855240990693413],
            [29.80533492792875, -0.858385745944368],
            [29.80327755326447, -0.858670823039446],
            [29.799779284477697, -0.860043928543803],
            [29.79724199744929, -0.863309547917609],
            [29.79411517484597, -0.865794921305092],
            [29.790630169684405, -0.869886962492657],
            [29.787913134259192, -0.872640797882472],
            [29.785500678919277, -0.878097202673452],
            [29.787110230838053, -0.885951814453943],
            [29.787178631258712, -0.888643900617275],
            [29.791825139218044, -0.888285640761858],
            [29.792932197821354, -0.888917778365966],
            [29.794829347174943, -0.891611377641796],
            [29.796693044165686, -0.892596889700741],
            [29.799555896822753, -0.89278487349122],
            [29.79943970692727, -0.895402589528339],
            [29.80012929326522, -0.896934843513993],
            [29.801291847091854, -0.897529903522195],
            [29.801527962976074, -0.899498098441733],
            [29.800672701248576, -0.902189472276822],
            [29.80132220655519, -0.903446927010389],
            [29.803049804288783, -0.904146427256375],
            [29.80381502607874, -0.905721464367074],
            [29.80372208548111, -0.907800780472288],
            [29.804952742386064, -0.909413338387262],
            [29.804815520234847, -0.911462923690468],
            [29.80624887659376, -0.915110495267497],
            [29.804921716372785, -0.920872303566351],
            [29.804640061293536, -0.924860059048413],
            [29.8060697103053, -0.933680039645138],
            [29.806781370046423, -0.934397699981619],
            [29.808016894921884, -0.933442812597512],
            [29.81148367326637, -0.933206967857742],
            [29.813051270268073, -0.93263478364152],
            [29.814144722089786, -0.931249548242198],
            [29.81509639460684, -0.929099363651894],
            [29.816711605911863, -0.928383808509338],
            [29.817425069470087, -0.927093822613528],
            [29.817321244884486, -0.926189346407766],
            [29.818467903022153, -0.92475409231138],
            [29.820303487236064, -0.92337078225823],
            [29.821641465868023, -0.923264340329701],
            [29.824504095742878, -0.923347405740609],
            [29.827416802203263, -0.925097725891365],
            [29.83207278379558, -0.924832715198839],
            [29.833436367108074, -0.925290990293353],
            [29.83491710331003, -0.927322475893494],
            [29.835235945048755, -0.928398370983128],
            [29.83742516904055, -0.930685919930508],
            [29.83926879587121, -0.931897553040829],
            [29.844347369227695, -0.934322001832792],
            [29.846219381922996, -0.934753831016684],
            [29.84969803779214, -0.934568519758291],
            [29.85134597202804, -0.934968528533578],
            [29.853142937667894, -0.931287101843157],
            [29.854120150186784, -0.927784220403],
            [29.85445150006753, -0.923890843718549],
            [29.85350492369308, -0.918223891103416],
            [29.85444875122278, -0.913775621461162],
            [29.857376976977985, -0.91347077560711],
            [29.861679413115514, -0.910986823806374],
            [29.86355578353827, -0.910474312552303],
            [29.864027121482998, -0.909966567085123],
            [29.864182408754587, -0.908773185180826],
            [29.86561778362794, -0.908301672061454],
            [29.86744534588637, -0.906510612904015],
            [29.87128102369048, -0.905553671051867],
            [29.872661412685304, -0.904287863756127],
            [29.87490647415855, -0.903081659918886],
            [29.8765524087446, -0.900976339894439],
            [29.878541042526724, -0.899733093005074],
            [29.879334879251726, -0.898584643127035],
            [29.880067914405014, -0.898511572368633],
            [29.88106659845583, -0.89754006581433],
            [29.88429230760561, -0.897041746998895],
            [29.885593109459517, -0.896067243640924],
            [29.885006441307034, -0.895443904290653],
            [29.884127422733535, -0.895222229841313],
            [29.88395442158285, -0.893793093679429],
            [29.883295600746738, -0.893409545332731],
            [29.88322407149392, -0.892540309890529],
            [29.882564952417134, -0.892304078035673],
            [29.882210999127224, -0.889747820503821],
            [29.880796012417527, -0.886373113453319],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 247,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "RUGYEYO",
        Population: 20731,
        Key: "KANUNGURUGYEYO",
        Dist2: "Kanungu",
        "Sub Country": "Rugyeyo",
        id2_original: "Kanungu Rugyeyo",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.85134597202804, -0.934968528533578],
            [29.84969803779214, -0.934568519758291],
            [29.846219381922996, -0.934753831016684],
            [29.844347369227695, -0.934322001832792],
            [29.83926879587121, -0.931897553040829],
            [29.83742516904055, -0.930685919930508],
            [29.835235945048755, -0.928398370983128],
            [29.83491710331003, -0.927322475893494],
            [29.833436367108074, -0.925290990293353],
            [29.83207278379558, -0.924832715198839],
            [29.827416802203263, -0.925097725891365],
            [29.824504095742878, -0.923347405740609],
            [29.821641465868023, -0.923264340329701],
            [29.820303487236064, -0.92337078225823],
            [29.818467903022153, -0.92475409231138],
            [29.817321244884486, -0.926189346407766],
            [29.817425069470087, -0.927093822613528],
            [29.816711605911863, -0.928383808509338],
            [29.81509639460684, -0.929099363651894],
            [29.814144722089786, -0.931249548242198],
            [29.813051270268073, -0.93263478364152],
            [29.81148367326637, -0.933206967857742],
            [29.808016894921884, -0.933442812597512],
            [29.806781370046423, -0.934397699981619],
            [29.806259619546246, -0.935527989430005],
            [29.806590474455287, -0.937249116688817],
            [29.8059567759044, -0.940226714805888],
            [29.80525941913923, -0.941511645334865],
            [29.803125067838234, -0.943043276848019],
            [29.802863011303565, -0.944007010611456],
            [29.79911485545927, -0.949042488207053],
            [29.793768001141494, -0.95288665824218],
            [29.79167605481348, -0.955304885011973],
            [29.790365419102177, -0.955142393378702],
            [29.78985901362369, -0.954227703032785],
            [29.788869546287692, -0.954011725885616],
            [29.78657229449308, -0.952288785398754],
            [29.785449231504643, -0.951992018519207],
            [29.78355239117152, -0.950699667419734],
            [29.782562931920367, -0.95048369274608],
            [29.78186619409443, -0.951020867915011],
            [29.780481340472633, -0.95101149438808],
            [29.781025423090778, -0.952752362509513],
            [29.783146946449524, -0.95288751332005],
            [29.784513813104372, -0.954532517507642],
            [29.785617615314774, -0.955155472828233],
            [29.78623843561774, -0.954223039626637],
            [29.787163359000555, -0.955823244138798],
            [29.789636380553574, -0.956980536979692],
            [29.789410950129632, -0.959068425668715],
            [29.79289993033635, -0.960582046987879],
            [29.794536160422428, -0.960272488815918],
            [29.797357864849584, -0.963784787304655],
            [29.799080455373783, -0.964452722196875],
            [29.799874175317793, -0.965386418155997],
            [29.80213994295834, -0.965896603144205],
            [29.803459678603474, -0.966862250824859],
            [29.805179060345477, -0.967209529569827],
            [29.80604986562235, -0.966409602077258],
            [29.80667859918465, -0.968775877127916],
            [29.80760049614331, -0.96950460300829],
            [29.808633488651438, -0.969068769568491],
            [29.80939346967, -0.969306021112223],
            [29.810167552441925, -0.971435855620283],
            [29.811000684172395, -0.971327412213057],
            [29.811768005325128, -0.972374465427403],
            [29.813016671654903, -0.972703137687288],
            [29.813540798198993, -0.973158552005262],
            [29.81348432021878, -0.974177594738577],
            [29.817484908047778, -0.974654293154817],
            [29.8195091339798, -0.976421308826095],
            [29.82056801773104, -0.97659512555226],
            [29.8217234667821, -0.978197593729484],
            [29.822537965656938, -0.978343900774221],
            [29.82383888429184, -0.979655327778627],
            [29.82573362616047, -0.982714305680944],
            [29.82575566722429, -0.985125580781456],
            [29.826224086542645, -0.986236094345136],
            [29.82716376295739, -0.98712864572778],
            [29.83163260481478, -0.988825093667908],
            [29.83272492655588, -0.990309236781834],
            [29.834029664827366, -0.994224258602435],
            [29.833530561753822, -0.994622961597256],
            [29.830742260282204, -0.994529443999424],
            [29.82960360523538, -0.993545707761707],
            [29.82525374523738, -0.993159324078277],
            [29.823968565984558, -0.994819967479876],
            [29.82380950039888, -0.996405697389664],
            [29.82428088864928, -0.99772772475938],
            [29.823912053868355, -0.998996073742189],
            [29.826117212176666, -0.999579707541648],
            [29.829530626101683, -0.99979447281158],
            [29.83215760452135, -0.998634029548115],
            [29.832892039249852, -0.999480554013842],
            [29.833047719085236, -1.001436646324277],
            [29.831888273429485, -1.005664577058576],
            [29.829733785493087, -1.006984052566054],
            [29.828892537484013, -1.007987629079976],
            [29.82888957214526, -1.011053683473246],
            [29.829571377276242, -1.012005888501303],
            [29.829462490684037, -1.015970512971817],
            [29.82982959890297, -1.016499505116451],
            [29.82943706656485, -1.018250117454679],
            [29.82979884238428, -1.019753633373688],
            [29.828426312749894, -1.020036655759581],
            [29.827456513128716, -1.02121384319883],
            [29.826889836982872, -1.022878938005391],
            [29.824304625732353, -1.02507015482091],
            [29.82130201947161, -1.026186239622923],
            [29.821110168072998, -1.027300337281492],
            [29.822798858873334, -1.028377420043601],
            [29.823972957848, -1.028650122586883],
            [29.827687863450368, -1.031836868601018],
            [29.829847779007693, -1.032839079333156],
            [29.831586025370683, -1.034256078559995],
            [29.831822206831923, -1.03573758541379],
            [29.832764209883248, -1.035186505093144],
            [29.834126271449655, -1.035040664952164],
            [29.834354110256854, -1.036106975156525],
            [29.835704931204084, -1.037691985123962],
            [29.835543826442724, -1.038957243953629],
            [29.83688573161076, -1.039865872379887],
            [29.838104323243137, -1.042257842890929],
            [29.839182134497417, -1.04302257242928],
            [29.839215074820586, -1.044224529966745],
            [29.839761700569284, -1.04510115253015],
            [29.84232270851111, -1.046779558192627],
            [29.84263260123298, -1.047558537816625],
            [29.843862600571132, -1.047422822365992],
            [29.845090660446616, -1.048401657897723],
            [29.846155052667186, -1.04859042431127],
            [29.848340911569924, -1.050338538232799],
            [29.850012658347374, -1.053154149258577],
            [29.85007058081859, -1.054226876979489],
            [29.851743369641742, -1.055598752744511],
            [29.85238330250068, -1.056839232126487],
            [29.859536696702612, -1.063173677255781],
            [29.86204859554445, -1.064520025141813],
            [29.863474166204817, -1.064898712828894],
            [29.864757102364358, -1.06466079918234],
            [29.865441819833464, -1.065042974407774],
            [29.866087234212298, -1.066848431939384],
            [29.869354385341072, -1.070145529918344],
            [29.87215475118694, -1.068017447463838],
            [29.8751079680734, -1.067293600203974],
            [29.876361068487405, -1.066494407058413],
            [29.877231104806366, -1.064848343110145],
            [29.88161288553969, -1.061549683844908],
            [29.88365458909384, -1.05825783002725],
            [29.883783449726412, -1.057365472659268],
            [29.88500970039487, -1.055986573143231],
            [29.88531262937668, -1.054698749448631],
            [29.886346999900454, -1.053236842276021],
            [29.887007492501336, -1.050863666140314],
            [29.887785177517525, -1.05014677115748],
            [29.89103116882977, -1.049165513821404],
            [29.89280362753034, -1.050059778545092],
            [29.894092564435994, -1.049996659141257],
            [29.896707818942875, -1.049042362866672],
            [29.900021225223924, -1.046531222644208],
            [29.90033196865038, -1.045453196697695],
            [29.899873681430087, -1.043895191302957],
            [29.900195519050296, -1.041358092635507],
            [29.899856331368678, -1.040488919326291],
            [29.899203590330423, -1.04006202942644],
            [29.898126400710296, -1.037472613879692],
            [29.89802978510487, -1.035958638149598],
            [29.894296803602344, -1.030662787349295],
            [29.894557276407195, -1.029365041985776],
            [29.893773183708074, -1.029057882992738],
            [29.8927711345682, -1.026649889039064],
            [29.893044402077642, -1.025119661136566],
            [29.89013488463652, -1.0220494696449],
            [29.889202316590612, -1.02213425172613],
            [29.88837827850576, -1.021027907992628],
            [29.886575316611413, -1.020380876923449],
            [29.88526217190548, -1.019135599569517],
            [29.885440143434632, -1.017654819728527],
            [29.88706255114341, -1.016886296504107],
            [29.886439601833217, -1.016130417590552],
            [29.886907658232218, -1.014746990393937],
            [29.887568687127295, -1.01412891880598],
            [29.888647671581356, -1.01407730520373],
            [29.890087763508276, -1.012492423662529],
            [29.891211039397426, -1.007109391304674],
            [29.890682721314203, -1.006891446071693],
            [29.88977865411734, -1.007492283031942],
            [29.88853241593379, -1.006698415345723],
            [29.887766463813527, -1.005209917179556],
            [29.88658038939782, -1.004368428477784],
            [29.885265223482516, -1.001964991449494],
            [29.883089373608644, -0.999390867285861],
            [29.879989591193716, -0.997433445350002],
            [29.877793690024397, -0.995378124253694],
            [29.87689036214101, -0.995219365593854],
            [29.875824034949282, -0.993174922776047],
            [29.874667409105225, -0.992028749272371],
            [29.872683224678724, -0.992046735339593],
            [29.872331076104185, -0.99135538407712],
            [29.870348620036268, -0.990563875606263],
            [29.869980378143428, -0.988194294448312],
            [29.867628218623725, -0.985724249008056],
            [29.866816480271734, -0.984055188673369],
            [29.866208454673355, -0.983600544679087],
            [29.86591661898701, -0.982257715140918],
            [29.865131788771045, -0.981802923599863],
            [29.863311991549956, -0.978405411130976],
            [29.862133973225685, -0.978088475105316],
            [29.85922538284593, -0.973989133871359],
            [29.858282943213382, -0.973751383265286],
            [29.858209470006283, -0.971322870983614],
            [29.856502310742055, -0.970413170811574],
            [29.855944753394645, -0.969103125213377],
            [29.85645013838696, -0.966860587381839],
            [29.858922325405075, -0.963899094325395],
            [29.85932736408859, -0.962393671345668],
            [29.858188743177756, -0.961149738341349],
            [29.855961252751463, -0.956176170030267],
            [29.855582809590256, -0.954550520840477],
            [29.855870084529908, -0.951969424517317],
            [29.855349254802924, -0.95024804137248],
            [29.852527790225928, -0.945632487818292],
            [29.851488942498783, -0.943177303499158],
            [29.850872873385335, -0.937701699205607],
            [29.85134597202804, -0.934968528533578],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 248,
        District: "KANUNGU",
        County: "KINKIIZI",
        Subcounty: "RUTENGA",
        Population: 13578,
        Key: "KANUNGURUTENGA",
        Dist2: "Kanungu",
        "Sub Country": "Rutenga",
        id2_original: "Kanungu Rutenga",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.821110168072998, -1.027300337281492],
            [29.816491774687126, -1.028226453730686],
            [29.814282353872784, -1.029428823753572],
            [29.811095622623203, -1.029669407639815],
            [29.80985243242341, -1.028650000435667],
            [29.807433963760992, -1.029962088969389],
            [29.805672064756564, -1.030041576128063],
            [29.805306907678425, -1.029534522228535],
            [29.805554929833406, -1.028444917562797],
            [29.804662619786946, -1.027970793940404],
            [29.805047781448188, -1.02745971590637],
            [29.804744459004283, -1.026852343978796],
            [29.80339613447522, -1.026506824754043],
            [29.804251808529422, -1.025613814403415],
            [29.80217077942707, -1.02424739996286],
            [29.80128054448894, -1.021849773587403],
            [29.79824039044595, -1.020230246150473],
            [29.797857341622286, -1.018604655228354],
            [29.797432263321394, -1.018267634530951],
            [29.794671230210234, -1.018281211320396],
            [29.79385410376315, -1.018624556054731],
            [29.793546490067147, -1.017553526403661],
            [29.793799948826265, -1.015751717763041],
            [29.792822311404247, -1.015134122399466],
            [29.7929561091776, -1.014288194793613],
            [29.79222762758446, -1.013444265405522],
            [29.790863075888097, -1.013100672224458],
            [29.789776418024896, -1.012282212976122],
            [29.788821537623946, -1.012673220901315],
            [29.788428106970564, -1.011946272124418],
            [29.788652362398068, -1.010861439795936],
            [29.78798789205714, -1.010502280958562],
            [29.78659159479695, -1.010677752127332],
            [29.78450494403756, -1.009300794859078],
            [29.78239859142733, -1.005721549317784],
            [29.78102751886034, -1.0043913661288],
            [29.780995100458355, -1.003550064037201],
            [29.7794997756162, -1.003027571693234],
            [29.779662423683234, -1.001804066702514],
            [29.777806320151594, -1.001161722986386],
            [29.77522547201844, -0.998673614983878],
            [29.77374410430082, -0.998457058671969],
            [29.772928492413342, -0.997270837193117],
            [29.772545506471744, -0.995568813193564],
            [29.7697273584748, -0.992490225470611],
            [29.76740885703214, -0.992924817268969],
            [29.766883800731716, -0.991710325358784],
            [29.767859344180838, -0.989713439968524],
            [29.767127983487207, -0.987918417934564],
            [29.765423684458803, -0.989951970857106],
            [29.764394013022272, -0.990325420208961],
            [29.764833968322563, -0.991966026623222],
            [29.76373176960491, -0.993070362009762],
            [29.76089291993226, -0.993353000493905],
            [29.758798002875608, -0.994153323934671],
            [29.7571101178641, -0.995399733559715],
            [29.75606348264172, -0.995416595985774],
            [29.75585948691882, -0.996824756457175],
            [29.754188726491545, -0.997039133893596],
            [29.753299376393965, -0.998061500665813],
            [29.752660429885193, -0.998221354966977],
            [29.751361183015057, -1.000216887041744],
            [29.749365568424857, -1.001690430121663],
            [29.74828818926021, -1.002071968031696],
            [29.74385404213572, -1.001525498588924],
            [29.741943937279096, -1.002224259479976],
            [29.74054157189918, -1.003921282570454],
            [29.7399929491956, -1.00658619625779],
            [29.738492551567035, -1.009676155124483],
            [29.73758894700251, -1.010412202030458],
            [29.738255366687603, -1.010558353161199],
            [29.739789493360156, -1.012059488001789],
            [29.73878705704639, -1.013005542032935],
            [29.739394281347526, -1.013707453054709],
            [29.740275814305534, -1.013710565230024],
            [29.740624030055745, -1.014776130764103],
            [29.741597193867623, -1.013936977097691],
            [29.742033750841195, -1.014958503273174],
            [29.742649355525618, -1.015315458395259],
            [29.742071408217924, -1.016510791569839],
            [29.7422012569973, -1.017087761373554],
            [29.743304821154176, -1.016692542444691],
            [29.74369858148926, -1.01740349008948],
            [29.744845672614932, -1.017141470367025],
            [29.745858155686825, -1.017455488955097],
            [29.745853755738548, -1.018519805691102],
            [29.746597744948442, -1.019808515336712],
            [29.7479635776424, -1.019946395666177],
            [29.748444030792303, -1.021012429783289],
            [29.749767030915223, -1.021255128600298],
            [29.74966886481761, -1.024474900572124],
            [29.750499185719562, -1.025214438887073],
            [29.750926336433793, -1.025453039030006],
            [29.75587786016132, -1.024583533537706],
            [29.758869646214457, -1.024584164054208],
            [29.76017470787944, -1.025466907694744],
            [29.761646740304624, -1.025586465983316],
            [29.76200114275218, -1.027375331855769],
            [29.764457170874934, -1.028914228717587],
            [29.76412529727639, -1.029322959113625],
            [29.76166678621018, -1.029331014803245],
            [29.760313801221415, -1.028877569890848],
            [29.75777266131876, -1.029377892108392],
            [29.75537384959136, -1.030021342151485],
            [29.75461297115584, -1.031094451389508],
            [29.75328297405519, -1.031404212183924],
            [29.753625571741626, -1.033109593554066],
            [29.75507348889296, -1.033586921078795],
            [29.755617780818564, -1.035423526407023],
            [29.75499956652824, -1.036282012007376],
            [29.755566597508608, -1.039120344898204],
            [29.755150269696937, -1.039919236991977],
            [29.755268265206148, -1.040634808615236],
            [29.754316816369577, -1.042304099371702],
            [29.754220639141998, -1.04349659320529],
            [29.754765850044134, -1.044403065622267],
            [29.754656035492225, -1.047348553086163],
            [29.755555805148813, -1.049829207154203],
            [29.75671835807712, -1.050735800788458],
            [29.757014165215338, -1.051725659347588],
            [29.757963704233582, -1.051964392213658],
            [29.75879398560966, -1.052727808962443],
            [29.76078378091346, -1.057402997880771],
            [29.76269304315031, -1.059538084335341],
            [29.763095702196647, -1.060516056518816],
            [29.765728813414732, -1.063021016888987],
            [29.765418663774685, -1.064451991299028],
            [29.7614763819975, -1.065094987756298],
            [29.759553353078896, -1.064808299537905],
            [29.758496245296953, -1.065273119838796],
            [29.75466818790139, -1.070280799785712],
            [29.752083198534752, -1.078687367333117],
            [29.751627773346975, -1.078084456647133],
            [29.752574378467504, -1.080383916348883],
            [29.75387282044717, -1.07966398258783],
            [29.756125576889126, -1.077014300573574],
            [29.75802137607484, -1.075973364760602],
            [29.765629622339397, -1.076160276592244],
            [29.767257486415204, -1.076549400320962],
            [29.769952451132166, -1.075688091258258],
            [29.771826670089805, -1.075886362996054],
            [29.77268385600866, -1.075369915541625],
            [29.774801145607448, -1.075224347629844],
            [29.776513197995065, -1.076408702271407],
            [29.780543050241075, -1.076672728013802],
            [29.784722316573372, -1.076366462856846],
            [29.78647897750136, -1.076750721244616],
            [29.792533535379743, -1.076948329175638],
            [29.801601303232506, -1.079419627616627],
            [29.80710958211187, -1.079855650825779],
            [29.818675020390707, -1.078170895204973],
            [29.821311393391582, -1.077504443442037],
            [29.82352075851037, -1.076455127994013],
            [29.825971449742042, -1.075980150335885],
            [29.831266428148798, -1.072263294653879],
            [29.831695190440623, -1.07025937780583],
            [29.831699190638602, -1.068841423114361],
            [29.830674971077524, -1.066159953936166],
            [29.829326958263852, -1.064824368521246],
            [29.82848145044371, -1.062539744637115],
            [29.828519793234985, -1.060063719049299],
            [29.83078124806383, -1.055582675629819],
            [29.830889643277597, -1.054669285208307],
            [29.831726531762595, -1.053684520170044],
            [29.832361711635365, -1.051413430599172],
            [29.834454284987444, -1.04859091021848],
            [29.83674889214184, -1.046730167180557],
            [29.838112203264807, -1.044736254670277],
            [29.839215074820586, -1.044224529966745],
            [29.839182134497417, -1.04302257242928],
            [29.838104323243137, -1.042257842890929],
            [29.83688573161076, -1.039865872379887],
            [29.835543826442724, -1.038957243953629],
            [29.835704931204084, -1.037691985123962],
            [29.834354110256854, -1.036106975156525],
            [29.834126271449655, -1.035040664952164],
            [29.832764209883248, -1.035186505093144],
            [29.831822206831923, -1.03573758541379],
            [29.831586025370683, -1.034256078559995],
            [29.829847779007693, -1.032839079333156],
            [29.827687863450368, -1.031836868601018],
            [29.823972957848, -1.028650122586883],
            [29.822798858873334, -1.028377420043601],
            [29.821110168072998, -1.027300337281492],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 249,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "RUHIJA",
        Population: 10199,
        Key: "RUBANDARUHIJA",
        Dist2: "Kabale",
        "Sub Country": "Ruhija",
        id2_original: "Kabale Ruhija",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.154722734408697, -0.706237945064132],
            [31.153139218361833, -0.70415752001367],
            [31.133837339735845, -0.689157337720343],
            [31.111452443054738, -0.679943345813809],
            [31.09970258693627, -0.676204236457136],
            [31.09280146212403, -0.671400073116896],
            [31.084400725709088, -0.67425411952335],
            [31.07894798696877, -0.676892298892451],
            [31.072795286348967, -0.680723730945183],
            [31.056644000646997, -0.692770341595239],
            [31.05290167127564, -0.694432539650141],
            [31.04753035223945, -0.695723330012431],
            [31.040731045176425, -0.695937510309748],
            [31.02001988414281, -0.692890759141292],
            [31.01627523981296, -0.692853020082552],
            [31.006327512850635, -0.693960974910139],
            [31.00494933550803, -0.694656611526887],
            [31.001239220621084, -0.698060366887811],
            [30.999952428892342, -0.699003590714805],
            [30.990268884776945, -0.703457016302484],
            [30.98052728434137, -0.709818136323354],
            [30.976377180916476, -0.712257562572774],
            [30.973781606700832, -0.713151539895778],
            [30.966694105721633, -0.715128514480554],
            [30.956014908471193, -0.714264810211188],
            [30.951132547834025, -0.713202324910867],
            [30.950494485267505, -0.718613117519523],
            [30.951021165721944, -0.729853621042635],
            [30.950275123861648, -0.733492982498782],
            [30.951018011736974, -0.736811879156212],
            [30.956332014664827, -0.743665559634718],
            [30.961965397422233, -0.749770074482462],
            [30.964834548167747, -0.754374609913711],
            [30.96695818885562, -0.761333933205143],
            [30.966849387603332, -0.766579390994087],
            [30.978331228661816, -0.773757327221023],
            [30.989069650940625, -0.77900802887048],
            [30.995184175855815, -0.779813850015726],
            [30.99858660787648, -0.781207167631186],
            [31.001756233406432, -0.781416777198957],
            [31.00340196048169, -0.78010936746246],
            [31.003537478528816, -0.778292928147014],
            [31.004103732466458, -0.776883373113517],
            [31.006474484417627, -0.775501781399648],
            [31.00889835914144, -0.77571982296379],
            [31.012669511857002, -0.774610003905678],
            [31.015713009429486, -0.774502986605623],
            [31.01676369335882, -0.773879898348532],
            [31.023255195384653, -0.772608660842105],
            [31.024925360228885, -0.771958742963143],
            [31.028777066672603, -0.771445400547133],
            [31.036562131029473, -0.768602195711562],
            [31.040953562363885, -0.765811620167752],
            [31.045344579574962, -0.763942855224961],
            [31.047526981760498, -0.762208637109887],
            [31.049871665500426, -0.758956171667777],
            [31.053077448220552, -0.757439303299617],
            [31.054316856513, -0.756409573504856],
            [31.054182837754094, -0.754945420895499],
            [31.05267559586138, -0.752585929605008],
            [31.05370065175399, -0.749007496088494],
            [31.056477276025237, -0.743396367991966],
            [31.060304326409348, -0.737704340790154],
            [31.062271256894196, -0.735915744435247],
            [31.06405547544014, -0.732416656199781],
            [31.06537276137953, -0.731572580911485],
            [31.06993599281706, -0.731143918222821],
            [31.072122844358226, -0.730235744123222],
            [31.082152096127537, -0.730240048500462],
            [31.089852632609464, -0.729501682469688],
            [31.091384387729644, -0.731952264220589],
            [31.088754061288924, -0.736339030693685],
            [31.088775562465255, -0.737287177071488],
            [31.089563522411673, -0.738654598640864],
            [31.090220425344654, -0.739162025524941],
            [31.097542369545017, -0.73917129177424],
            [31.10030251062912, -0.740958044528692],
            [31.10352560388478, -0.742209327936896],
            [31.105553263177782, -0.743638657358108],
            [31.108248537813537, -0.746998851041966],
            [31.112344785440516, -0.750224928896061],
            [31.11430796006917, -0.753318045441516],
            [31.116677134578698, -0.759088412734209],
            [31.1164977913221, -0.761806824780738],
            [31.11835504559563, -0.765511635701326],
            [31.119142497993888, -0.766872713178074],
            [31.120143841057953, -0.767645163616716],
            [31.12233499552931, -0.767693396122949],
            [31.12410828157825, -0.771216800023834],
            [31.12543456773845, -0.771233667958321],
            [31.12608922398492, -0.77216202134022],
            [31.12677374292637, -0.772009743776986],
            [31.12768368510519, -0.773104637569244],
            [31.13128570930729, -0.773943584888639],
            [31.132320318782924, -0.774540740245605],
            [31.133476387671514, -0.774478613945543],
            [31.13532962917064, -0.775300305038128],
            [31.13602033840272, -0.775983022277661],
            [31.136835408606082, -0.779297459054182],
            [31.13918321488995, -0.781219982704048],
            [31.146319760290385, -0.782852235708968],
            [31.14809538285737, -0.785290051278211],
            [31.149288606964447, -0.78579115361381],
            [31.149313107615512, -0.786617108193318],
            [31.150774165322826, -0.788695134584933],
            [31.152538813172, -0.790192634923357],
            [31.160939089649524, -0.792486382787238],
            [31.16345829269296, -0.792822459778673],
            [31.168307116525657, -0.792250405353212],
            [31.175057944207722, -0.790339354479758],
            [31.178576655057082, -0.787804796162878],
            [31.17958462050141, -0.786636892621005],
            [31.18271527531771, -0.780724631200658],
            [31.18894489508202, -0.77488946220647],
            [31.198286208023628, -0.77162445448086],
            [31.197879420320266, -0.769563751099681],
            [31.19995341381732, -0.75801693239299],
            [31.197186254195888, -0.753431059903566],
            [31.196181254090316, -0.750069990874666],
            [31.194835257096134, -0.747681377845943],
            [31.192436610658795, -0.745206758003411],
            [31.18997250937656, -0.741729480963022],
            [31.187400133254833, -0.739441566053668],
            [31.180986213330183, -0.735537769019117],
            [31.173622566639402, -0.731772986794453],
            [31.170528404084887, -0.729284981467962],
            [31.168432810596826, -0.726625572031543],
            [31.164917849315454, -0.720637912269464],
            [31.158930576150173, -0.714857245286148],
            [31.157835000711117, -0.713328601186461],
            [31.154722734408697, -0.706237945064132],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 250,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "RUSHASHA",
        Population: 13066,
        Key: "ISINGIRORUSHASHA",
        Dist2: "Isingiro",
        "Sub Country": "Rushasha",
        id2_original: "IsingiroRushasha",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.08552698669993, -0.865292754789151],
            [31.085345970780278, -0.863119110522706],
            [31.084199113216624, -0.861710716208233],
            [31.078270783907016, -0.858675789266904],
            [31.077063383486447, -0.857617163503715],
            [31.07545157140644, -0.849578589339393],
            [31.07355565633807, -0.845013967007652],
            [31.069383360034074, -0.841526979673319],
            [31.068511344726517, -0.84186627357275],
            [31.066794966052502, -0.843507433061209],
            [31.065443863034254, -0.845828224520271],
            [31.063080905764842, -0.846902839992578],
            [31.06048184159431, -0.849104586973867],
            [31.053384849015842, -0.85245257756994],
            [31.049279735915313, -0.855106114695144],
            [31.046647976661724, -0.856186612687306],
            [31.044120546846905, -0.856415153603935],
            [31.041894201772614, -0.858883574995865],
            [31.040239295711817, -0.859571902642758],
            [31.037727619652163, -0.862155027464452],
            [31.03213487398322, -0.86508112775337],
            [31.031563158288655, -0.867378082878383],
            [31.03070706022963, -0.867951948908444],
            [31.028880015400794, -0.870535397669264],
            [31.024486132563975, -0.872026297489151],
            [31.013645743415598, -0.872594877738103],
            [31.010451114178032, -0.871961446636846],
            [31.009191122787456, -0.869255295922724],
            [31.008302317068946, -0.864625686183613],
            [31.007447177512322, -0.863799885228015],
            [31.00719821482121, -0.862687326762152],
            [31.00538100923972, -0.860999788090172],
            [31.00402668037129, -0.860389035851989],
            [31.002600757571358, -0.860352402193774],
            [31.000497012770403, -0.861284296420733],
            [30.999011460700203, -0.860647310093657],
            [30.990371749961813, -0.860681329048291],
            [30.98933917067871, -0.861098981438041],
            [30.987342889538564, -0.861062040597497],
            [30.981675063576517, -0.860628421552666],
            [30.977184130349677, -0.859262437301184],
            [30.97383520288563, -0.855492831367476],
            [30.971939519582605, -0.848790086284699],
            [30.96951962349717, -0.846950697002102],
            [30.96918816042869, -0.84590935241325],
            [30.96933234901497, -0.842823408604509],
            [30.968764390973202, -0.838158200255408],
            [30.970145617197854, -0.834062729199206],
            [30.971585210559816, -0.822047865529756],
            [30.973080712370063, -0.818142644070154],
            [30.97330683539507, -0.814272100158455],
            [30.972938262922195, -0.810589919380702],
            [30.970997087136567, -0.803644429654329],
            [30.970675068056643, -0.799402990057739],
            [30.971092384015154, -0.79814479450868],
            [30.969706734486024, -0.797463640219594],
            [30.967122771893766, -0.793865166417089],
            [30.963038413469544, -0.793619895983323],
            [30.95850088642555, -0.793943900684412],
            [30.955537212250874, -0.794967786451637],
            [30.95512024214378, -0.795526863791166],
            [30.955860577007087, -0.796459371483916],
            [30.95812861558866, -0.797765498802372],
            [30.96340387058501, -0.803687244538504],
            [30.963912547902858, -0.804945895582107],
            [30.963494717209713, -0.807229442141943],
            [30.963679408137153, -0.808254894688323],
            [30.96585462559708, -0.810027066164142],
            [30.966409623644225, -0.811239136876956],
            [30.965812906038646, -0.813216312491652],
            [30.96371229006981, -0.81571278384259],
            [30.96122874116001, -0.820642544471054],
            [30.957977808215368, -0.833320626864541],
            [30.95791211441866, -0.837355056606131],
            [30.95695663214649, -0.842117342649932],
            [30.958365701653378, -0.848193594890553],
            [30.958535121221033, -0.858761843595172],
            [30.962906981858644, -0.863607937063025],
            [30.96500502684912, -0.866779526696437],
            [30.966445468220673, -0.872636852939343],
            [30.97064259216251, -0.877042561416492],
            [30.975103282707, -0.879422846913194],
            [30.978339129344754, -0.881802472504867],
            [30.977199669407465, -0.885676886480566],
            [30.970458295595453, -0.894215844181936],
            [30.96922961049253, -0.901172578649066],
            [30.969183743412458, -0.905003534192767],
            [30.96961962844617, -0.907821975357351],
            [30.971367568529402, -0.911169569232942],
            [30.975921824000643, -0.914692231915467],
            [30.97971919584439, -0.914717546807131],
            [30.985898659971454, -0.914027272234897],
            [30.9944539739889, -0.914701921705831],
            [30.9968537037945, -0.915827647384039],
            [30.997494919447668, -0.916665311794169],
            [30.998775581072923, -0.916651172324712],
            [31.002936515485185, -0.918127669638472],
            [31.005915361306702, -0.920813239778815],
            [31.008587037199916, -0.922419985886526],
            [31.00963089033986, -0.924112431077855],
            [31.008221692373887, -0.925910188280342],
            [31.007190741736387, -0.928241623864257],
            [31.00601065908362, -0.933079956634926],
            [31.007812847528506, -0.940257937837157],
            [31.00883969735675, -0.942921767418277],
            [31.009943243547312, -0.943517883216092],
            [31.009974652242892, -0.945145805533201],
            [31.007274815063806, -0.945473640597081],
            [31.00623756274461, -0.945041531604222],
            [31.003938938324225, -0.945389369436128],
            [31.003302919424968, -0.944931517319887],
            [31.0015101255613, -0.944999573411905],
            [30.99946369866538, -0.944429191104808],
            [30.99723644000444, -0.942992521723266],
            [30.995252498123058, -0.942535770476968],
            [30.993967827316723, -0.942661181673639],
            [30.99299611428399, -0.943417542427628],
            [30.991114943264343, -0.946009251891551],
            [30.983922824487173, -0.951028858226922],
            [30.98107762103051, -0.954120068348045],
            [30.98104216272961, -0.956651441051774],
            [30.981992352128124, -0.958978149545371],
            [30.982773741796542, -0.959389108024812],
            [30.984168198408714, -0.957474280062349],
            [30.9848140915896, -0.957132580780521],
            [30.988451087205664, -0.955903229779348],
            [30.991849486689034, -0.955905227354486],
            [30.993290697916798, -0.95677211108926],
            [30.99520688436787, -0.957195652576063],
            [31.001395544548522, -0.961931506592853],
            [31.00231226541447, -0.963403009695793],
            [31.001120164201538, -0.967952031282442],
            [30.998976907002813, -0.971782102778615],
            [30.99564487415432, -0.974448367997989],
            [30.9940803448993, -0.97656834796884],
            [30.990782309691056, -0.979200402952669],
            [30.988299280905803, -0.982859182620781],
            [30.985361428804, -0.986272124025971],
            [30.98375054468369, -0.987197394371107],
            [30.98231400020381, -0.989628749557642],
            [30.981395931864917, -0.99044918058052],
            [30.98063180781625, -0.991836104788805],
            [30.981324900278764, -0.995511925186913],
            [30.979788028354715, -0.999512723178718],
            [31.037586790765065, -0.999448454906599],
            [31.040826645685595, -1.000164714552211],
            [31.042520415560556, -1.001214602326273],
            [31.044289387001196, -1.001369376378643],
            [31.045746444510563, -1.000646887231371],
            [31.04758952696215, -1.000801703524926],
            [31.04866008791379, -0.999997602165419],
            [31.053060062226564, -0.999936932005775],
            [31.05368418473649, -0.999304359209669],
            [31.17509319948934, -0.999122192405854],
            [31.172074923016762, -0.996618447352297],
            [31.16974806993693, -0.993915969964904],
            [31.166644861347503, -0.991663261586624],
            [31.161304553053213, -0.982953672381448],
            [31.156197225522803, -0.977567660148196],
            [31.155794316744807, -0.975438089986725],
            [31.155224365341446, -0.974528616368811],
            [31.149807012138496, -0.971080405610053],
            [31.14832400409721, -0.967982143004663],
            [31.146805486551024, -0.966377301458107],
            [31.14474137182715, -0.965586805638802],
            [31.140582139722348, -0.965165834908068],
            [31.136246084135315, -0.962113015252018],
            [31.136408078228794, -0.96092358155679],
            [31.13780690334819, -0.960548920877756],
            [31.139684301443623, -0.956451538965604],
            [31.141404928250637, -0.954888194689319],
            [31.141446966710973, -0.953772365225083],
            [31.143167952844095, -0.95153116102982],
            [31.143117208810317, -0.949549710695926],
            [31.143490684288018, -0.948590485600742],
            [31.14279744001019, -0.946921546240176],
            [31.144631637225313, -0.946077819932351],
            [31.14509398572899, -0.944844807551409],
            [31.145928216099076, -0.943955126471688],
            [31.14640859558715, -0.943319577358205],
            [31.146156155517577, -0.942912526802112],
            [31.14193955520207, -0.937747538586224],
            [31.13933932591664, -0.93375330728945],
            [31.13411228889146, -0.928282632862562],
            [31.130426143751265, -0.923372301112128],
            [31.128583621848406, -0.919861715182765],
            [31.128255374748637, -0.919480063002443],
            [31.125232782769434, -0.918811824883601],
            [31.12109257967728, -0.914394484620889],
            [31.123746774355077, -0.911467390447147],
            [31.123564319334374, -0.91025096566921],
            [31.122653601011127, -0.909557001324225],
            [31.12129529440262, -0.907939983897981],
            [31.120392350099827, -0.907435781483847],
            [31.11439938790386, -0.907629227377472],
            [31.112716242403767, -0.905306275373726],
            [31.111886473965736, -0.904924973745008],
            [31.110921538721808, -0.906300508879569],
            [31.108590480628123, -0.905979850428602],
            [31.10522093952325, -0.907648983343026],
            [31.09879002077849, -0.908600184229988],
            [31.097001603506882, -0.910105753361475],
            [31.095669674130082, -0.913159921659416],
            [31.094380813581253, -0.914811221964458],
            [31.090594799137616, -0.918032473017094],
            [31.086018764012312, -0.919135918702738],
            [31.08198259032166, -0.918928545044903],
            [31.08251495801016, -0.914496520240303],
            [31.083890652409288, -0.910080522868403],
            [31.083326509512553, -0.898094162190203],
            [31.08176074866729, -0.892566835718587],
            [31.077885339276495, -0.887737974971225],
            [31.077874395101386, -0.880070181033382],
            [31.079203758889747, -0.873330424538491],
            [31.081213300061787, -0.870432415911658],
            [31.081714938181072, -0.868107524649819],
            [31.08552698669993, -0.865292754789151],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 251,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "MBAARE",
        Population: 33458,
        Key: "ISINGIROMBAARE",
        Dist2: "Isingiro",
        "Sub Country": "Mbaare",
        id2_original: "IsingiroMbaare",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.967122771893766, -0.793865166417089],
            [30.96114254511355, -0.787395264174076],
            [30.953823384792262, -0.782879946148608],
            [30.95289288017658, -0.780058537410371],
            [30.942408345153268, -0.770071637868309],
            [30.934971451630823, -0.760912511402909],
            [30.93234809072683, -0.759073560394519],
            [30.92841265141717, -0.757176557353807],
            [30.91791075645098, -0.75269458224338],
            [30.90913963386463, -0.759798399422897],
            [30.90457479713764, -0.764389138986613],
            [30.898350284295734, -0.768298772100803],
            [30.882026308260176, -0.783088277449555],
            [30.878915433448096, -0.786314367634225],
            [30.872860251240603, -0.795225753268964],
            [30.863479745701458, -0.805599954522979],
            [30.86973082442129, -0.814165097358934],
            [30.879590644944884, -0.815499354977233],
            [30.887383742037034, -0.817745669593719],
            [30.895058782534537, -0.820950294570642],
            [30.897696306277307, -0.822524855056659],
            [30.900548083605223, -0.824994612871078],
            [30.901902865224553, -0.826686038498458],
            [30.90346310951568, -0.830147640913265],
            [30.904542221530495, -0.832808354742826],
            [30.90673156948983, -0.843821762619077],
            [30.906806395559723, -0.855539260108343],
            [30.909017330933633, -0.860160554454952],
            [30.910065498681867, -0.868714169021024],
            [30.908831796488112, -0.874527012867304],
            [30.909141337070388, -0.876651882243381],
            [30.90840566626005, -0.879698372658187],
            [30.90557963105492, -0.882969710053442],
            [30.90503355597348, -0.884244215764217],
            [30.903014533083613, -0.885897615691028],
            [30.902326033707123, -0.887379984490282],
            [30.90308749065771, -0.89142184528327],
            [30.90403837086069, -0.894026262556347],
            [30.906106069862545, -0.896161180657937],
            [30.90779385875433, -0.899543576335992],
            [30.908246402146684, -0.902852935932046],
            [30.907510784336935, -0.906197773328145],
            [30.907606002163813, -0.907554015485899],
            [30.908057675986974, -0.908440321277014],
            [30.908936994597777, -0.909037554847618],
            [30.909626442595197, -0.910837167225915],
            [30.909604370090353, -0.916017796431016],
            [30.909390760597248, -0.917003168930014],
            [30.908559406632733, -0.917915848035735],
            [30.90775240869049, -0.921351049129721],
            [30.904879302662785, -0.926674640014905],
            [30.903810897667807, -0.929748022732947],
            [30.904452640632076, -0.930534992330298],
            [30.9041925657809, -0.935561759785706],
            [30.90397915571378, -0.937134806091397],
            [30.90314805237923, -0.938544736830416],
            [30.902650247371287, -0.943037923614106],
            [30.89723409970744, -0.94640700489188],
            [30.89471629354426, -0.949316728685226],
            [30.892070021108932, -0.950460256230471],
            [30.890844226784626, -0.950760943848154],
            [30.890155454320325, -0.951646553474375],
            [30.887171250946487, -0.952949704068092],
            [30.892105526122243, -0.955694253232813],
            [30.894287380335452, -0.956462621733542],
            [30.904920600911343, -0.958630785532028],
            [30.90765731483115, -0.95842327589533],
            [30.917565896806693, -0.956093364977008],
            [30.919782537380968, -0.956687425240375],
            [30.91648820951987, -0.962438185570565],
            [30.914059977966964, -0.968015128027103],
            [30.910661915351817, -0.973382256825934],
            [30.90837392069622, -0.976170038912581],
            [30.906882136114596, -0.979795071729708],
            [30.90677635499832, -0.982793397892318],
            [30.907467736170197, -0.985094926710555],
            [30.907428301925876, -0.992765213303364],
            [30.908672431763435, -0.99743792367135],
            [30.90952266562031, -0.999187864537688],
            [30.979788028354715, -0.999512723178718],
            [30.981324900278764, -0.995511925186913],
            [30.98063180781625, -0.991836104788805],
            [30.981395931864917, -0.99044918058052],
            [30.98231400020381, -0.989628749557642],
            [30.98375054468369, -0.987197394371107],
            [30.985361428804, -0.986272124025971],
            [30.988299280905803, -0.982859182620781],
            [30.990782309691056, -0.979200402952669],
            [30.9940803448993, -0.97656834796884],
            [30.99564487415432, -0.974448367997989],
            [30.998976907002813, -0.971782102778615],
            [31.001120164201538, -0.967952031282442],
            [31.00231226541447, -0.963403009695793],
            [31.001395544548522, -0.961931506592853],
            [30.99520688436787, -0.957195652576063],
            [30.993290697916798, -0.95677211108926],
            [30.991849486689034, -0.955905227354486],
            [30.988451087205664, -0.955903229779348],
            [30.9848140915896, -0.957132580780521],
            [30.984168198408714, -0.957474280062349],
            [30.982773741796542, -0.959389108024812],
            [30.981992352128124, -0.958978149545371],
            [30.98104216272961, -0.956651441051774],
            [30.98107762103051, -0.954120068348045],
            [30.983922824487173, -0.951028858226922],
            [30.991114943264343, -0.946009251891551],
            [30.99299611428399, -0.943417542427628],
            [30.993967827316723, -0.942661181673639],
            [30.995252498123058, -0.942535770476968],
            [30.99723644000444, -0.942992521723266],
            [30.99946369866538, -0.944429191104808],
            [31.0015101255613, -0.944999573411905],
            [31.003302919424968, -0.944931517319887],
            [31.003938938324225, -0.945389369436128],
            [31.00623756274461, -0.945041531604222],
            [31.007274815063806, -0.945473640597081],
            [31.009974652242892, -0.945145805533201],
            [31.009943243547312, -0.943517883216092],
            [31.00883969735675, -0.942921767418277],
            [31.007812847528506, -0.940257937837157],
            [31.00601065908362, -0.933079956634926],
            [31.007190741736387, -0.928241623864257],
            [31.008221692373887, -0.925910188280342],
            [31.00963089033986, -0.924112431077855],
            [31.008587037199916, -0.922419985886526],
            [31.005915361306702, -0.920813239778815],
            [31.002936515485185, -0.918127669638472],
            [30.998775581072923, -0.916651172324712],
            [30.997494919447668, -0.916665311794169],
            [30.9968537037945, -0.915827647384039],
            [30.9944539739889, -0.914701921705831],
            [30.985898659971454, -0.914027272234897],
            [30.97971919584439, -0.914717546807131],
            [30.975921824000643, -0.914692231915467],
            [30.971367568529402, -0.911169569232942],
            [30.96961962844617, -0.907821975357351],
            [30.969183743412458, -0.905003534192767],
            [30.96922961049253, -0.901172578649066],
            [30.970458295595453, -0.894215844181936],
            [30.977199669407465, -0.885676886480566],
            [30.978339129344754, -0.881802472504867],
            [30.975103282707, -0.879422846913194],
            [30.97064259216251, -0.877042561416492],
            [30.966445468220673, -0.872636852939343],
            [30.96500502684912, -0.866779526696437],
            [30.962906981858644, -0.863607937063025],
            [30.958535121221033, -0.858761843595172],
            [30.958365701653378, -0.848193594890553],
            [30.95695663214649, -0.842117342649932],
            [30.95791211441866, -0.837355056606131],
            [30.957977808215368, -0.833320626864541],
            [30.96122874116001, -0.820642544471054],
            [30.96371229006981, -0.81571278384259],
            [30.965812906038646, -0.813216312491652],
            [30.966409623644225, -0.811239136876956],
            [30.96585462559708, -0.810027066164142],
            [30.963679408137153, -0.808254894688323],
            [30.963494717209713, -0.807229442141943],
            [30.963912547902858, -0.804945895582107],
            [30.96340387058501, -0.803687244538504],
            [30.95812861558866, -0.797765498802372],
            [30.955860577007087, -0.796459371483916],
            [30.95512024214378, -0.795526863791166],
            [30.955537212250874, -0.794967786451637],
            [30.95850088642555, -0.793943900684412],
            [30.963038413469544, -0.793619895983323],
            [30.967122771893766, -0.793865166417089],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 252,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "KASHUMBA",
        Population: 50458,
        Key: "ISINGIROKASHUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.892070021108932, -0.950460256230471],
            [30.89471629354426, -0.949316728685226],
            [30.89723409970744, -0.94640700489188],
            [30.902650247371287, -0.943037923614106],
            [30.90314805237923, -0.938544736830416],
            [30.90397915571378, -0.937134806091397],
            [30.9041925657809, -0.935561759785706],
            [30.904452640632076, -0.930534992330298],
            [30.903810897667807, -0.929748022732947],
            [30.904879302662785, -0.926674640014905],
            [30.90775240869049, -0.921351049129721],
            [30.908559406632733, -0.917915848035735],
            [30.909390760597248, -0.917003168930014],
            [30.909604370090353, -0.916017796431016],
            [30.909626442595197, -0.910837167225915],
            [30.908936994597777, -0.909037554847618],
            [30.908057675986974, -0.908440321277014],
            [30.907606002163813, -0.907554015485899],
            [30.907510784336935, -0.906197773328145],
            [30.908246402146684, -0.902852935932046],
            [30.90779385875433, -0.899543576335992],
            [30.906106069862545, -0.896161180657937],
            [30.90403837086069, -0.894026262556347],
            [30.90308749065771, -0.89142184528327],
            [30.902326033707123, -0.887379984490282],
            [30.903014533083613, -0.885897615691028],
            [30.90503355597348, -0.884244215764217],
            [30.90557963105492, -0.882969710053442],
            [30.90840566626005, -0.879698372658187],
            [30.909141337070388, -0.876651882243381],
            [30.908831796488112, -0.874527012867304],
            [30.910065498681867, -0.868714169021024],
            [30.909017330933633, -0.860160554454952],
            [30.906806395559723, -0.855539260108343],
            [30.90673156948983, -0.843821762619077],
            [30.904542221530495, -0.832808354742826],
            [30.90346310951568, -0.830147640913265],
            [30.90016967996988, -0.83054663515072],
            [30.892587768716204, -0.828554760628404],
            [30.88824346749318, -0.828393414020867],
            [30.886464222918963, -0.832169309506516],
            [30.883224757867232, -0.833916837592445],
            [30.881881063255147, -0.835585872173444],
            [30.879747863594325, -0.836538863458822],
            [30.8776150493108, -0.836776242216683],
            [30.875878243845563, -0.835026034214694],
            [30.875799766123993, -0.834071846133263],
            [30.873825955442378, -0.832401027044351],
            [30.872404257419227, -0.832241234515307],
            [30.869875536725342, -0.834307167218],
            [30.866084849245638, -0.832953411045729],
            [30.86332045284201, -0.832633861954761],
            [30.853289158303735, -0.832469370843921],
            [30.854631037420624, -0.834139831514022],
            [30.855498475811814, -0.836764168350354],
            [30.854707828106076, -0.838194930233451],
            [30.853838927257613, -0.838273963638262],
            [30.85020357376187, -0.84184994216731],
            [30.848623833334138, -0.841849067302647],
            [30.848066557159417, -0.849799814675241],
            [30.84553380482657, -0.859101118015503],
            [30.843557079111868, -0.862757473639845],
            [30.84142768022303, -0.86478281327535],
            [30.836164497685772, -0.853389088750599],
            [30.831462375925504, -0.848076088363735],
            [30.82514489194323, -0.841853236832094],
            [30.819586702666665, -0.837687994169785],
            [30.81416865776095, -0.837972006603298],
            [30.809034958388747, -0.83973921477556],
            [30.807190901265077, -0.841267914617467],
            [30.80437430106537, -0.845477396057477],
            [30.80266119675058, -0.849399301722863],
            [30.80265583201168, -0.858871617068116],
            [30.801701552583687, -0.865472980293773],
            [30.79893833746468, -0.877144299870233],
            [30.793800735810887, -0.885465370176537],
            [30.793892504107042, -0.891014830142089],
            [30.79208283988235, -0.897232894938286],
            [30.78590030531364, -0.90430938021858],
            [30.779719490120375, -0.908515442431679],
            [30.77401157055057, -0.916548876288489],
            [30.77277308572624, -0.921140646872997],
            [30.77485954873777, -0.92860485128017],
            [30.77419036403821, -0.9347278255554],
            [30.772095879071234, -0.940084457886317],
            [30.77047607468015, -0.946302479506808],
            [30.76771741401963, -0.949745093481185],
            [30.763818388818304, -0.952804239331858],
            [30.762866654317484, -0.954717166633132],
            [30.76219640870762, -0.962275234403308],
            [30.766111382598474, -0.960677680766377],
            [30.76842383029442, -0.959283275269913],
            [30.7706432152219, -0.958819418805595],
            [30.774064311539227, -0.958821654399266],
            [30.775913136022094, -0.959474294996583],
            [30.778224994423244, -0.959010491551327],
            [30.783775551613136, -0.954640166550534],
            [30.78673465605797, -0.954176766637564],
            [30.787840192915166, -0.95438013138106],
            [30.788397625396744, -0.9556364043865],
            [30.787276582719414, -0.962774549082741],
            [30.787768568440963, -0.96366722794053],
            [30.78701258492539, -0.964790446264859],
            [30.790460044101366, -0.965519804426909],
            [30.792232565684007, -0.966611625099053],
            [30.795745800403385, -0.967208826289184],
            [30.796829760625833, -0.966713774159814],
            [30.79948958774047, -0.966748557365776],
            [30.800343665488423, -0.966286403982515],
            [30.802905111808098, -0.966122815286268],
            [30.809939199858785, -0.960694800248947],
            [30.81193411196642, -0.960190877555039],
            [30.812821166868456, -0.956974079891898],
            [30.814617453381942, -0.957241127931801],
            [30.825740881913422, -0.955320449753753],
            [30.828976836349028, -0.955854305355179],
            [30.8370342851714, -0.956311445554716],
            [30.840705945876, -0.957217836969002],
            [30.84225146228801, -0.957205518294224],
            [30.845092298135786, -0.95593097308017],
            [30.846890803488034, -0.952688075379882],
            [30.850059532499316, -0.951221374799469],
            [30.852437150274195, -0.949309371594683],
            [30.85714655108321, -0.942710745798368],
            [30.861805855543768, -0.940297825748733],
            [30.863517958237022, -0.938552806212192],
            [30.86560965483337, -0.937860442590343],
            [30.86622822575487, -0.936712716331557],
            [30.870434338239434, -0.937074068339983],
            [30.872549922835802, -0.936190359176803],
            [30.874190860093965, -0.934230003223686],
            [30.87419147633824, -0.933201488861335],
            [30.87633172418075, -0.930810886943858],
            [30.87656995559747, -0.929830351470313],
            [30.87782925438695, -0.930213815997184],
            [30.88272233282379, -0.934330850858263],
            [30.88630960489225, -0.936366148580954],
            [30.888780793882056, -0.936965622951294],
            [30.888827078678773, -0.939046620185402],
            [30.889870655137567, -0.942515537764729],
            [30.891366352780587, -0.945004046413548],
            [30.891460592342092, -0.946367500578637],
            [30.89088951175641, -0.947563112583634],
            [30.891910626739886, -0.948855375934993],
            [30.892070021108932, -0.950460256230471],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 253,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "NGARAMA",
        Population: 28006,
        Key: "ISINGIRONGARAMA",
        Dist2: "Isingiro",
        "Sub Country": "Ngarama",
        id2_original: "IsingiroNgarama",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.761683811141875, -0.865311609174917],
              [30.761604992060516, -0.863187668453041],
              [30.762912931927694, -0.861418406923036],
              [30.762224321160133, -0.860580821602547],
              [30.762628817261195, -0.859648204141338],
              [30.76229671818551, -0.858667313715784],
              [30.762939054037822, -0.857352124602232],
              [30.76255995510646, -0.855462270495077],
              [30.764414821657937, -0.852975736177084],
              [30.764011541875742, -0.851803449487301],
              [30.76501053225207, -0.850081832183957],
              [30.76505871429065, -0.848933726404262],
              [30.763182823568282, -0.846660295305745],
              [30.76491803003232, -0.845632764325025],
              [30.76667653520158, -0.845418504427852],
              [30.767484931820732, -0.844557870951829],
              [30.768080271410636, -0.842285862762911],
              [30.769292186763813, -0.842190880676204],
              [30.770742519484973, -0.840684783968381],
              [30.77022156668879, -0.837479269561882],
              [30.77083986272581, -0.836618519363147],
              [30.77001007542314, -0.833269314234634],
              [30.770106449381746, -0.830901337181023],
              [30.770962826816838, -0.829203535981374],
              [30.776380674093197, -0.82899131684321],
              [30.77816362242134, -0.827557142868064],
              [30.780542221156516, -0.823229015797411],
              [30.780804341471583, -0.821889659743675],
              [30.78356274790886, -0.818231476596995],
              [30.783919909981, -0.816892170069843],
              [30.787367482344674, -0.813090827790059],
              [30.787512244056106, -0.809048461028515],
              [30.787157502943643, -0.805914773015002],
              [30.784047901044346, -0.799909218667945],
              [30.777396615678917, -0.796078466894999],
              [30.775520364732106, -0.7943313194267],
              [30.771482064729163, -0.792080698376502],
              [30.769377523122543, -0.788552040227634],
              [30.76822883928393, -0.788084386524067],
              [30.768324507166717, -0.786912382638028],
              [30.769959420322575, -0.784376651842603],
              [30.77125049342196, -0.780647032048883],
              [30.769280771871493, -0.775886002344726],
              [30.766983356583506, -0.772978569596229],
              [30.7659516881921, -0.769210710889615],
              [30.771982554801493, -0.766550432799612],
              [30.772172864691047, -0.766129546856885],
              [30.771573721634205, -0.764684813798646],
              [30.764459961102652, -0.755245150098518],
              [30.760518602793578, -0.75208415059153],
              [30.759413568992922, -0.749970034914488],
              [30.75437770783323, -0.744966929001023],
              [30.751813489312607, -0.741023728340471],
              [30.747459021855498, -0.7375689157135],
              [30.74693906169771, -0.737906554556799],
              [30.746897545158518, -0.738711118635927],
              [30.74489270576869, -0.73914403197056],
              [30.744045973544804, -0.740336915900402],
              [30.74286103010804, -0.740770243165178],
              [30.74220298182306, -0.741773376155661],
              [30.740429174751245, -0.742920579394185],
              [30.73971463860458, -0.742694205899955],
              [30.738626795863507, -0.743407826835446],
              [30.73767560843669, -0.743325975642988],
              [30.73442466111903, -0.745566275575383],
              [30.731884812993737, -0.745962732304933],
              [30.730137078624708, -0.745799104567214],
              [30.729189173641984, -0.746169260834808],
              [30.726952020936515, -0.745707053014781],
              [30.725887892820623, -0.746429714238682],
              [30.72360816895384, -0.74663645383279],
              [30.721098364983206, -0.749491828970099],
              [30.718255206990435, -0.750629397489406],
              [30.717373222179877, -0.750249251392069],
              [30.716102974723714, -0.752589970776809],
              [30.71548711761271, -0.752589646512966],
              [30.715508804740303, -0.753520787552947],
              [30.71491317499451, -0.754288881234978],
              [30.71322627723151, -0.754550154246206],
              [30.712488202529435, -0.755363371591652],
              [30.71058634600376, -0.756148852123003],
              [30.70973126304102, -0.756121278939978],
              [30.709065029307187, -0.756672369798418],
              [30.705811246008157, -0.756598323634976],
              [30.705037564783165, -0.757348234663582],
              [30.70321765347605, -0.764000716856606],
              [30.70366487704529, -0.76579087992053],
              [30.70799334366481, -0.768532338220716],
              [30.709200638982452, -0.770377158729617],
              [30.709198086868735, -0.771480042732234],
              [30.710550179830417, -0.772294378769686],
              [30.71045297942175, -0.773270652675986],
              [30.71225397580228, -0.775088681327789],
              [30.71363164918998, -0.775044227772041],
              [30.714888047319395, -0.776120678263575],
              [30.715823427092122, -0.77740487800882],
              [30.717547959773988, -0.781564261458792],
              [30.71802235378734, -0.781871884250354],
              [30.71792514259887, -0.78285720203054],
              [30.718826779852893, -0.783219298866424],
              [30.719272302911328, -0.785805015111512],
              [30.71731581085005, -0.789718306657445],
              [30.715457813669826, -0.792085785049854],
              [30.712486745462044, -0.793015267384717],
              [30.712033629842843, -0.793828621967704],
              [30.708802040321235, -0.794423469632523],
              [30.704841691627053, -0.796961509924392],
              [30.703698298865437, -0.798371112060998],
              [30.699566507597602, -0.800610711118834],
              [30.699280908015933, -0.803476225881315],
              [30.699635153258335, -0.804335224482394],
              [30.701029411342844, -0.807500012095454],
              [30.703496238113612, -0.808956853680165],
              [30.70351109355348, -0.809723701265083],
              [30.704615808452232, -0.808905108690927],
              [30.706568304807092, -0.808430434972878],
              [30.70673363973514, -0.806754945178702],
              [30.708547460464676, -0.804816675798298],
              [30.71466856643759, -0.801918823995986],
              [30.720156546984814, -0.799832567504801],
              [30.726095496177702, -0.799835874779403],
              [30.72636086120758, -0.803083803079993],
              [30.72719483645612, -0.804616244597697],
              [30.726918389808883, -0.806087780402156],
              [30.727393615662177, -0.807045875256474],
              [30.727392659854733, -0.808769966132008],
              [30.728879509092174, -0.810298155105488],
              [30.729229186401366, -0.812181294206196],
              [30.72998874970334, -0.812789757187117],
              [30.72913044089039, -0.814554531594072],
              [30.730552493748093, -0.815143756047491],
              [30.73107809891914, -0.816007069939929],
              [30.730686581677276, -0.819262774681231],
              [30.728993885289118, -0.82035283695739],
              [30.728844171165527, -0.82280437836436],
              [30.728017256675134, -0.823983325068434],
              [30.728233164957047, -0.825421932161718],
              [30.72884909752654, -0.826069943640132],
              [30.728171571071293, -0.82655359479643],
              [30.72812356420418, -0.827610272674371],
              [30.729391476938886, -0.829999147913627],
              [30.731139062187562, -0.831530524650702],
              [30.73213426616499, -0.831927663024702],
              [30.7344471809849, -0.834648296806238],
              [30.736365935719377, -0.837440655112961],
              [30.73694897827137, -0.840038591989923],
              [30.738316871700604, -0.841374066971013],
              [30.73860220627923, -0.84102979959293],
              [30.739371830712393, -0.841460789061117],
              [30.74036924454538, -0.842451617254789],
              [30.74138037924604, -0.844375296524353],
              [30.742691643778045, -0.845021875813514],
              [30.743460907088476, -0.846084332340996],
              [30.744829227217426, -0.84668789213114],
              [30.746215437295312, -0.849233695733434],
              [30.749325765931662, -0.853469209585081],
              [30.7500372855356, -0.855765869002919],
              [30.74951366384471, -0.857248549665602],
              [30.749748908363113, -0.861314947966227],
              [30.75067469323027, -0.862894163759178],
              [30.754640871990652, -0.866388727894486],
              [30.756921312713047, -0.867586049570764],
              [30.75944016271856, -0.867444031424921],
              [30.761683811141875, -0.865311609174917],
            ],
          ],
          [
            [
              [30.915798089582648, -0.704852771567548],
              [30.908034500350954, -0.701621549414914],
              [30.89982141571066, -0.696916426479638],
              [30.89276898585847, -0.693992967858687],
              [30.888622748782545, -0.691358850795194],
              [30.883960945208873, -0.687529353083865],
              [30.882260411019836, -0.68689820713186],
              [30.881541566553064, -0.685994512918373],
              [30.88090826775251, -0.683776456970216],
              [30.87950230282323, -0.682595727030787],
              [30.877723116639487, -0.679449806600611],
              [30.876527342215326, -0.67865711071605],
              [30.875627079383666, -0.676174362368],
              [30.874088216792952, -0.675310454255679],
              [30.873018742802795, -0.6758658206302],
              [30.87039886197223, -0.674931234327758],
              [30.868740015900592, -0.674037650406221],
              [30.867294714643343, -0.672509082945824],
              [30.865813620013572, -0.671912061478534],
              [30.865238361363524, -0.6710869796255],
              [30.86530951152726, -0.670326535079313],
              [30.864019067248588, -0.66884202312664],
              [30.863748598889597, -0.667275507288174],
              [30.862761395308116, -0.666721464863389],
              [30.86112544369978, -0.667297235162959],
              [30.854432302232027, -0.671083380323032],
              [30.850130968327335, -0.672275507412601],
              [30.84754510400162, -0.673639541012703],
              [30.84390243103293, -0.676594295500438],
              [30.840327991398308, -0.685372428320013],
              [30.84005791650138, -0.693779258155914],
              [30.83924255793882, -0.697116470083269],
              [30.83855864895343, -0.697267267190105],
              [30.838191273934857, -0.698224138266915],
              [30.833036048233474, -0.701311140968637],
              [30.82768248080559, -0.700485938431393],
              [30.826865082169018, -0.700770989388737],
              [30.826056409767094, -0.701836157907551],
              [30.82512134620134, -0.701840010492749],
              [30.827490413811343, -0.710182600663247],
              [30.82799342096311, -0.714339019659349],
              [30.82641899407028, -0.714726979944758],
              [30.825735157848456, -0.716161880923651],
              [30.824519292602968, -0.716483723033895],
              [30.82416046505431, -0.717117946871031],
              [30.819644008893604, -0.720614139337574],
              [30.818128063224076, -0.724788032266875],
              [30.815495817981926, -0.724654361070016],
              [30.81249123003765, -0.725902524048233],
              [30.80982819054757, -0.729441409501142],
              [30.80749845836723, -0.731640919166775],
              [30.80687965208713, -0.733697742073066],
              [30.813052279136578, -0.744943256801049],
              [30.814373576952, -0.748519994167486],
              [30.811693719203156, -0.752624191840021],
              [30.810579627689467, -0.755054201024744],
              [30.81180935932968, -0.759629613633068],
              [30.811850467135386, -0.761297081277459],
              [30.81464411088801, -0.765839056757075],
              [30.821661101303906, -0.760766380069331],
              [30.82433208729102, -0.758150554976074],
              [30.82679412693965, -0.754638800394728],
              [30.828348944508146, -0.75086310558768],
              [30.832049687271745, -0.747668111757108],
              [30.8326611210783, -0.746192950992942],
              [30.833690883244675, -0.745631377259629],
              [30.834843344499088, -0.743928134828457],
              [30.8373745113055, -0.741733743111844],
              [30.840612266863218, -0.73600322773651],
              [30.84344612549617, -0.734747423528714],
              [30.845511355029302, -0.734549196014424],
              [30.852740215799926, -0.735059628881686],
              [30.85706520593928, -0.734678979328329],
              [30.8581793405721, -0.733989065179292],
              [30.859462575870637, -0.733893997086573],
              [30.86160054917883, -0.735330283366776],
              [30.8633104294401, -0.737531839025634],
              [30.865876708695996, -0.737772284623962],
              [30.869942453129198, -0.739325846630024],
              [30.87134100875399, -0.740262710472648],
              [30.87347949949181, -0.740646479136676],
              [30.879373019084156, -0.740075201905999],
              [30.882936883751285, -0.740303144759951],
              [30.887873544852436, -0.742091604612236],
              [30.90039529005688, -0.745164050317268],
              [30.909870419636448, -0.749314000213805],
              [30.91518938126465, -0.751193930277277],
              [30.91791075645098, -0.75269458224338],
              [30.916274674586955, -0.747314658367623],
              [30.916133035419477, -0.745305156525112],
              [30.91639207990301, -0.717212508706124],
              [30.915798089582648, -0.704852771567548],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 254,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "KABINGO",
        Population: 21845,
        Key: "ISINGIROKABINGO",
        Dist2: "Isingiro",
        "Sub Country": "Kabingo",
        id2_original: "IsingiroKabingo",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.786053630664664, -0.603581852901959],
            [30.784191397927827, -0.604180274609748],
            [30.78314896143111, -0.603218061674827],
            [30.78094458735203, -0.603424604348438],
            [30.779427493635616, -0.602669643611974],
            [30.77805031162636, -0.603373130143987],
            [30.777722901756423, -0.602326350745989],
            [30.77701644326079, -0.60322077443661],
            [30.775324740409324, -0.603073422063967],
            [30.77485892620525, -0.603832468055429],
            [30.77342691462432, -0.604802449079339],
            [30.772979230219335, -0.604880389756901],
            [30.771996069056627, -0.604062122175203],
            [30.771799005632758, -0.605151117007866],
            [30.770880678579033, -0.605941217528253],
            [30.768549050055125, -0.604331008023056],
            [30.767837017513173, -0.604755027860735],
            [30.768108032946195, -0.605779307945636],
            [30.765073759275044, -0.605046191549491],
            [30.76498271771594, -0.606265658278395],
            [30.76362786153645, -0.605843929134765],
            [30.762594454904956, -0.606164280090142],
            [30.76169069044031, -0.607621386110368],
            [30.760532825819457, -0.608165356363934],
            [30.759229868008873, -0.610616385961767],
            [30.758156216852647, -0.609701313292395],
            [30.757772143051263, -0.609811158454563],
            [30.75776997541647, -0.610495647565014],
            [30.757211535025146, -0.610592727477359],
            [30.75674517734033, -0.609254412351074],
            [30.756095455539747, -0.610005326386555],
            [30.754306325005807, -0.610312595671678],
            [30.754241109112826, -0.609467092635468],
            [30.753579326531213, -0.60918080047322],
            [30.75333613551582, -0.608363511751988],
            [30.75190325706063, -0.60788831715752],
            [30.75082028229006, -0.60688209618909],
            [30.75028314993729, -0.607174174197119],
            [30.750099190238448, -0.60657378022992],
            [30.75052404935042, -0.60597678343449],
            [30.749340887272833, -0.605646273089774],
            [30.74929176739311, -0.606343527073709],
            [30.748600189490173, -0.606570528510791],
            [30.747941892371863, -0.606302581460886],
            [30.747392044366247, -0.607150965728283],
            [30.746027499856392, -0.607549558164107],
            [30.74555547919204, -0.608941713894617],
            [30.745021700250227, -0.608680621619415],
            [30.744968999685742, -0.607772268539889],
            [30.742873881406485, -0.608154837684529],
            [30.742246594131778, -0.607519688165269],
            [30.740492210433036, -0.606893496068821],
            [30.739808170293635, -0.60760038378177],
            [30.73861235903859, -0.607681600390611],
            [30.738046749192968, -0.608894558598592],
            [30.736669586946647, -0.609623153507856],
            [30.736197755826815, -0.61055642322832],
            [30.73452772393326, -0.609823400900124],
            [30.73405299125507, -0.610228646582359],
            [30.73396541898959, -0.610596338499731],
            [30.734748872986536, -0.611074403707651],
            [30.73504200404353, -0.611910562748338],
            [30.73231270481807, -0.613251460619511],
            [30.730266258159215, -0.616717294604471],
            [30.72991032498241, -0.618417968950077],
            [30.728645649775963, -0.618675361703311],
            [30.727657805695657, -0.619722483746975],
            [30.727286205001967, -0.620774043898956],
            [30.72630590587178, -0.621232862022065],
            [30.72704704203233, -0.621652957809509],
            [30.727021875729644, -0.622166005749486],
            [30.725296532767395, -0.6230048093273],
            [30.724854661360595, -0.622850342364102],
            [30.724662561128657, -0.622014297325405],
            [30.724288326574545, -0.622046425474702],
            [30.722067008472617, -0.624244793648727],
            [30.72302510124899, -0.625701861490099],
            [30.722451337395544, -0.625604741432178],
            [30.721709710754883, -0.62633274479119],
            [30.71994917179979, -0.626145410532411],
            [30.718795319055012, -0.627063220064673],
            [30.71769297750525, -0.626567786613743],
            [30.716414337987736, -0.624629816560203],
            [30.714768147381804, -0.6234696743569],
            [30.715299562856117, -0.622871311397011],
            [30.71475436902196, -0.622645043634706],
            [30.714854443141245, -0.621988520788981],
            [30.714024019831356, -0.622020449524231],
            [30.71416257598077, -0.623043030382891],
            [30.713710068521028, -0.622766574023182],
            [30.712873653448174, -0.62015071252457],
            [30.711582481534116, -0.618496248075017],
            [30.710709728709734, -0.618606835021597],
            [30.709318059569885, -0.617210778850606],
            [30.707807967322786, -0.614639309494868],
            [30.706507262486927, -0.614879774654122],
            [30.705719133657215, -0.613243411277301],
            [30.703144374305054, -0.611371882750781],
            [30.699352298928197, -0.614786627417383],
            [30.697560615382244, -0.61568143888676],
            [30.69416841696928, -0.618695153130074],
            [30.691798341449527, -0.623388695129657],
            [30.68769659433635, -0.628231277849909],
            [30.684753981163535, -0.629259381803937],
            [30.677753316729618, -0.632828433356485],
            [30.674818261981578, -0.635332888098243],
            [30.671341378488506, -0.636298257972209],
            [30.67000122234028, -0.637206984305478],
            [30.670509252871117, -0.636802020956887],
            [30.671196864712112, -0.637227203233722],
            [30.682375110238834, -0.646697018614386],
            [30.68808189523644, -0.654362180319298],
            [30.68916814885778, -0.663203527245057],
            [30.69096405628222, -0.670449531174903],
            [30.69115086903041, -0.671263467604423],
            [30.693779272178077, -0.67192627364564],
            [30.69573519919905, -0.673370609387725],
            [30.697900569326784, -0.674093342099539],
            [30.699810346298303, -0.678409454475051],
            [30.701721701609788, -0.680872156287709],
            [30.708570351334743, -0.680391130717375],
            [30.709956657532313, -0.681160967605397],
            [30.709728407296716, -0.685092209026923],
            [30.70533939332876, -0.690588278084214],
            [30.708194649831775, -0.696800046664814],
            [30.710768910618974, -0.698852443346741],
            [30.710128703773847, -0.702963763380013],
            [30.711637625516172, -0.705207410370905],
            [30.710865395070357, -0.708045206084558],
            [30.711319132323755, -0.709090977103037],
            [30.71210304446149, -0.709887629151624],
            [30.711533271822848, -0.710065322932979],
            [30.715097592834134, -0.712370907727021],
            [30.719733093736302, -0.713559728772761],
            [30.724661869425894, -0.717616127850446],
            [30.72890186995623, -0.724154020584909],
            [30.73350594329817, -0.72938694995722],
            [30.741441673992824, -0.731966862449296],
            [30.742238317953085, -0.732317281901951],
            [30.747467682513147, -0.737563291827514],
            [30.749735190190407, -0.736597129487798],
            [30.751024145062324, -0.734994924963196],
            [30.752154764678913, -0.734934796685339],
            [30.752893325369552, -0.735117268131085],
            [30.754068610120385, -0.736180103096317],
            [30.75616438955971, -0.735346541534378],
            [30.75865180122523, -0.735135347034636],
            [30.760493087944553, -0.736435293394997],
            [30.762017829019026, -0.73664260563539],
            [30.762860711961885, -0.738644731467469],
            [30.76652744540714, -0.740212292243822],
            [30.768446624146442, -0.739634226055997],
            [30.76984075377187, -0.739986983924216],
            [30.772054419125894, -0.73946001860773],
            [30.773909680037793, -0.737876706015385],
            [30.775349899525498, -0.738090514265798],
            [30.777950012029937, -0.737767556284325],
            [30.779869355160915, -0.735945495979718],
            [30.77990625076627, -0.734745589319734],
            [30.780581704808178, -0.733532155716269],
            [30.781805912707703, -0.732581674909001],
            [30.784334465416627, -0.732410828406393],
            [30.78559467060621, -0.731451302961797],
            [30.78685518661289, -0.729857714333251],
            [30.78614326186876, -0.729221084986154],
            [30.7863517851007, -0.728842967083144],
            [30.788548042002873, -0.727376647772326],
            [30.791040920815224, -0.72656264830929],
            [30.792328215600513, -0.725403848145841],
            [30.793120774921178, -0.723909655220781],
            [30.794308601051693, -0.723765305677958],
            [30.795424111005197, -0.724309334973835],
            [30.799143308757994, -0.718151638928116],
            [30.800358489487227, -0.717255473556216],
            [30.80287938405836, -0.714303739271991],
            [30.803564504871034, -0.711640977819691],
            [30.805859688743862, -0.710274294540622],
            [30.806796080917916, -0.709042831989162],
            [30.808021800682063, -0.706701673160846],
            [30.80750928396472, -0.704818691166229],
            [30.808325500418377, -0.704675497966345],
            [30.81037841045572, -0.703288538288845],
            [30.811507363697455, -0.703695876496017],
            [30.812438502523754, -0.703500887612283],
            [30.813907813951896, -0.704702059140218],
            [30.815452911749023, -0.704806482188682],
            [30.81876219566126, -0.702474870500096],
            [30.819784276333653, -0.702682742095608],
            [30.82043821123292, -0.702212425849464],
            [30.82192350099503, -0.703154366142984],
            [30.82367078351146, -0.703003627611609],
            [30.82512134620134, -0.701840010492749],
            [30.826056409767094, -0.701836157907551],
            [30.826865082169018, -0.700770989388737],
            [30.82768248080559, -0.700485938431393],
            [30.833036048233474, -0.701311140968637],
            [30.838191273934857, -0.698224138266915],
            [30.83855864895343, -0.697267267190105],
            [30.83924255793882, -0.697116470083269],
            [30.84005791650138, -0.693779258155914],
            [30.840327991398308, -0.685372428320013],
            [30.84390243103293, -0.676594295500438],
            [30.84754510400162, -0.673639541012703],
            [30.850130968327335, -0.672275507412601],
            [30.854432302232027, -0.671083380323032],
            [30.86112544369978, -0.667297235162959],
            [30.862761395308116, -0.666721464863389],
            [30.863753200958794, -0.667275509982949],
            [30.864510687355814, -0.665779515617718],
            [30.86520294438513, -0.666693662989348],
            [30.866509415506787, -0.666968913302518],
            [30.866961197127804, -0.665780579151209],
            [30.866611771346896, -0.665167474512458],
            [30.86740808023555, -0.663773479957462],
            [30.866532237206584, -0.662684935801349],
            [30.86714142881819, -0.661512516807625],
            [30.866585342911225, -0.661200618265893],
            [30.86645448532381, -0.660434620975301],
            [30.86596639559564, -0.660592906186321],
            [30.865389382535827, -0.660180609553532],
            [30.86554709436035, -0.65949397210606],
            [30.865018148354757, -0.658946432182882],
            [30.86516962227796, -0.658701458037967],
            [30.865547295582992, -0.659018561230941],
            [30.86532540452128, -0.658014042496856],
            [30.86579459459418, -0.657428679539634],
            [30.866487979009154, -0.657301733487771],
            [30.865548286424723, -0.656678481098886],
            [30.86710192720019, -0.655664934416623],
            [30.866887208287732, -0.654661195593487],
            [30.867424706254827, -0.654526281934746],
            [30.867464970542493, -0.653340852467479],
            [30.867129398579895, -0.652727957387417],
            [30.865981833143792, -0.652916623689332],
            [30.865434674694118, -0.652336342475033],
            [30.865309019250486, -0.65166543063808],
            [30.86580782138841, -0.650936679025611],
            [30.86559812495669, -0.65046646106301],
            [30.864874146618074, -0.650101671535771],
            [30.86380844645046, -0.650272448241102],
            [30.863357832639306, -0.649715418118554],
            [30.86463351041136, -0.648331984562116],
            [30.864193089783736, -0.64748134066647],
            [30.86449255665843, -0.646594033326333],
            [30.863810457778357, -0.646466968431239],
            [30.86395273744464, -0.645019666921258],
            [30.862667830381373, -0.642847950814009],
            [30.861749993807823, -0.642298336800485],
            [30.86082090224205, -0.642607698931937],
            [30.860900075259632, -0.641949346162508],
            [30.859116684062045, -0.640279381988429],
            [30.857506090995905, -0.639491642748854],
            [30.856997633765282, -0.638207826098509],
            [30.855979545206026, -0.638487362668277],
            [30.85699819072078, -0.636855551851196],
            [30.856700363271454, -0.635997022916563],
            [30.855129821592268, -0.636122168490104],
            [30.85481156196183, -0.635578254114813],
            [30.853593228145957, -0.637036210755679],
            [30.852403609876436, -0.637004281214128],
            [30.851661084920472, -0.635539222920533],
            [30.850630506185475, -0.636000847707387],
            [30.84827580623015, -0.634510723178255],
            [30.847402647367247, -0.634336731971112],
            [30.847115377817474, -0.636638211602134],
            [30.846037299763527, -0.636442122375793],
            [30.845548066480017, -0.634065641517873],
            [30.846913397914058, -0.631991681184569],
            [30.845970748974022, -0.631240057949637],
            [30.845852540564096, -0.630158740509375],
            [30.844703749825957, -0.629567338040062],
            [30.843435846972675, -0.630107446215664],
            [30.84366783419987, -0.627828708565697],
            [30.84270911619605, -0.626864375508927],
            [30.84186343500103, -0.627023298629328],
            [30.841941742042682, -0.626416690032822],
            [30.841392238091817, -0.626337882847606],
            [30.841804625892653, -0.625756558442403],
            [30.84121796762164, -0.624907648060944],
            [30.84075276427195, -0.624838304940083],
            [30.84077504069438, -0.623804197033274],
            [30.8403565093153, -0.624137205218703],
            [30.839963265511475, -0.623712710839915],
            [30.83974329774281, -0.62414640431968],
            [30.839210727035034, -0.623838128881843],
            [30.839051279665355, -0.624344119863179],
            [30.83789963228461, -0.623111507602691],
            [30.836866238229515, -0.622856482884547],
            [30.836597496432475, -0.623397003155935],
            [30.835939019651146, -0.622560640219101],
            [30.836569937017888, -0.62206113002925],
            [30.83598039964638, -0.620615013696573],
            [30.83548333844347, -0.622114117626162],
            [30.83418083877368, -0.623298567999663],
            [30.83454409591502, -0.620677288444767],
            [30.83398544621624, -0.620057848332933],
            [30.83323301643595, -0.619922383132838],
            [30.832086767031733, -0.620786290810683],
            [30.82973242730081, -0.62102734764675],
            [30.823648053439832, -0.618460006758092],
            [30.823932548991998, -0.617561174231853],
            [30.823548757261566, -0.616935524062549],
            [30.821585171204543, -0.616969576322431],
            [30.82090446291652, -0.616173791417098],
            [30.81811876206763, -0.615579421312569],
            [30.817336225250582, -0.614786190861293],
            [30.8135482955988, -0.61621163076005],
            [30.812635830052304, -0.61430792926481],
            [30.810212202365218, -0.612165022085257],
            [30.806976880343605, -0.613732125165981],
            [30.805837557848534, -0.612967873331499],
            [30.80535105005359, -0.611565834144729],
            [30.803608835831994, -0.611524257990161],
            [30.802044806938593, -0.610957853028966],
            [30.801603975780903, -0.612416085074065],
            [30.798757254171377, -0.614176189916036],
            [30.79747925515266, -0.612923572753435],
            [30.79559383779669, -0.611872992854172],
            [30.795147721850174, -0.610967591111267],
            [30.793256280391912, -0.609379540594161],
            [30.79134697952745, -0.608377575881553],
            [30.790422190891938, -0.607131052993094],
            [30.789376312051015, -0.606948324360927],
            [30.788261133575865, -0.60827740050927],
            [30.78675641145751, -0.607792743586459],
            [30.784852853522693, -0.604699152169122],
            [30.785231063121927, -0.604271848269077],
            [30.78588663115839, -0.604523564663968],
            [30.786095261289855, -0.604033720820978],
            [30.786053630664664, -0.603581852901959],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 255,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "MASHA",
        Population: 26073,
        Key: "ISINGIROMASHA",
        Dist2: "Isingiro",
        "Sub Country": "Masha",
        id2_original: "IsingiroMasha",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.69096405628222, -0.670449531174903],
            [30.679289008267375, -0.673940418097668],
            [30.6787867359375, -0.672049417014555],
            [30.677364184514843, -0.670314223612634],
            [30.676411248966506, -0.670182593497828],
            [30.675721730002177, -0.671234653424261],
            [30.67529160855931, -0.676424632638511],
            [30.67357951844245, -0.679389626402867],
            [30.6744332476441, -0.682762460477811],
            [30.677472697407893, -0.686447297820309],
            [30.678375341673355, -0.686902178298326],
            [30.67989609332966, -0.686615903087999],
            [30.682201348215116, -0.685421124303828],
            [30.683697264148755, -0.687383130457835],
            [30.682293554889153, -0.691305001612389],
            [30.682220352074978, -0.695275357915103],
            [30.68162569700127, -0.696638391510518],
            [30.678726437422398, -0.697832856676958],
            [30.677846875368157, -0.698765220725522],
            [30.677727151500328, -0.70065467973274],
            [30.67810680020064, -0.701683339889726],
            [30.680933236054415, -0.703646021961184],
            [30.681408063954027, -0.704387717473402],
            [30.68135690939018, -0.711730518572525],
            [30.682021383324365, -0.713333360091974],
            [30.68242497751691, -0.71397935048277],
            [30.686131518007343, -0.713957306638951],
            [30.68762817235613, -0.714388587538739],
            [30.689099434026772, -0.718096641200031],
            [30.691118571901, -0.719006554938164],
            [30.695086212220318, -0.719558686069841],
            [30.700646184652722, -0.719322318427767],
            [30.702831806400262, -0.719945300342766],
            [30.703710537512855, -0.720735050196101],
            [30.704661027846996, -0.720568102523767],
            [30.707774850929816, -0.718082157003741],
            [30.708511915925488, -0.717077952515627],
            [30.71003592038141, -0.710285867545439],
            [30.711319132323755, -0.709090977103037],
            [30.710865395070357, -0.708045206084558],
            [30.711637625516172, -0.705207410370905],
            [30.710128703773847, -0.702963763380013],
            [30.710768910618974, -0.698852443346741],
            [30.708194649831775, -0.696800046664814],
            [30.70533939332876, -0.690588278084214],
            [30.709728407296716, -0.685092209026923],
            [30.709956657532313, -0.681160967605397],
            [30.708570351334743, -0.680391130717375],
            [30.701721701609788, -0.680872156287709],
            [30.699810346298303, -0.678409454475051],
            [30.697900569326784, -0.674093342099539],
            [30.69573519919905, -0.673370609387725],
            [30.693779272178077, -0.67192627364564],
            [30.69115086903041, -0.671263467604423],
            [30.69096405628222, -0.670449531174903],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 256,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "KABEREBERE TOWN COUNCIL",
        Population: 6743,
        Key: "ISINGIROKABEREBERE TOWN COUNCIL",
        Dist2: "Isingiro",
        "Sub Country": "Kaberebere T.C",
        id2_original: "IsingiroKaberebere T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.67000122234028, -0.637206984305478],
            [30.669260312555203, -0.637699658186034],
            [30.66541089861208, -0.638645053020639],
            [30.660767043377778, -0.641243455644408],
            [30.657706857802278, -0.64154036347906],
            [30.655189453186033, -0.639286162329548],
            [30.652196309778482, -0.638167720605689],
            [30.651469744291852, -0.637344777346337],
            [30.649887682617422, -0.636571484370234],
            [30.64873364212474, -0.635150257453224],
            [30.648177703541503, -0.635106952334173],
            [30.6474937981494, -0.634331714289455],
            [30.645783473222068, -0.633642110881604],
            [30.64445759669364, -0.633942866403445],
            [30.642490662615504, -0.633296199791636],
            [30.64082307054626, -0.632692720566608],
            [30.639889323910726, -0.631799398610906],
            [30.639723208346695, -0.634341040925426],
            [30.640312710683883, -0.636923298604295],
            [30.641512214913103, -0.638451220298605],
            [30.643150562328305, -0.640979204899401],
            [30.643509301842048, -0.644498676147413],
            [30.645048726778146, -0.646005062534751],
            [30.646872800878306, -0.64898517152381],
            [30.648501161722475, -0.650312716223249],
            [30.650069150389648, -0.654100003434854],
            [30.65019743071056, -0.655419672668676],
            [30.649159651080264, -0.657908765989178],
            [30.648285628038053, -0.65854938420671],
            [30.646967508462097, -0.658832005162121],
            [30.64458574406385, -0.662355427937281],
            [30.643841341628956, -0.662902928859659],
            [30.643272074741816, -0.664779088007256],
            [30.645397648604174, -0.667783408125374],
            [30.64513246503397, -0.669380413236762],
            [30.64807013837106, -0.675120868099119],
            [30.648100423274236, -0.678134146420664],
            [30.64774989705712, -0.68121112239281],
            [30.645541181420274, -0.684700945217887],
            [30.645280019607615, -0.69230760289131],
            [30.64456352513361, -0.692770108050332],
            [30.644875563032418, -0.693927878012814],
            [30.643836681169248, -0.695096212898809],
            [30.643246798844686, -0.697470872334987],
            [30.641415897548345, -0.699092267595772],
            [30.640849724459073, -0.702379931099565],
            [30.64081536300113, -0.703674607790879],
            [30.642283776114006, -0.70821913897785],
            [30.642485205350173, -0.713812053146476],
            [30.643178364288005, -0.71640319985587],
            [30.64291188534719, -0.718253625632576],
            [30.64117139589095, -0.720407089545297],
            [30.639745568312414, -0.723419018379991],
            [30.638671214673657, -0.7245485102657],
            [30.637889011131573, -0.727021113339339],
            [30.63697754361338, -0.727774002566538],
            [30.635917792089547, -0.732097116516858],
            [30.636022953368293, -0.73309596055968],
            [30.639707449201648, -0.738791307270294],
            [30.64108742586977, -0.739731813590614],
            [30.643883431293258, -0.744138887874177],
            [30.64607893361061, -0.745777830670352],
            [30.646436444229053, -0.746564150082927],
            [30.646598564985023, -0.747645164450378],
            [30.64519738088969, -0.751427647327765],
            [30.64529593146623, -0.753863786752537],
            [30.648929909641282, -0.754107845966253],
            [30.650639976752117, -0.755256813709117],
            [30.651407059851326, -0.758465882734054],
            [30.651181484798652, -0.760634401339235],
            [30.652302484356852, -0.762562696496035],
            [30.653262212067077, -0.766385458485494],
            [30.653415569757428, -0.77063247547286],
            [30.65705897844631, -0.774982055669466],
            [30.658152199401005, -0.777398740385488],
            [30.658542696156704, -0.777661115017326],
            [30.661720418202297, -0.776719114193364],
            [30.662294232361408, -0.775120270388932],
            [30.662997815349797, -0.774334186125803],
            [30.664769076596105, -0.773679770158187],
            [30.66763232181694, -0.776355371235848],
            [30.67065222963008, -0.778297021392082],
            [30.670035326880058, -0.774670175648395],
            [30.669455188581374, -0.773507033586736],
            [30.670028484412526, -0.767862736705096],
            [30.670998889498218, -0.766007240485886],
            [30.67147841468846, -0.762240400524019],
            [30.670384175044223, -0.759037919270273],
            [30.669849732247428, -0.758750616533406],
            [30.667749318399547, -0.754372520613467],
            [30.66713955905267, -0.749589145018499],
            [30.669836720150535, -0.744863508415447],
            [30.671407949939237, -0.743808765076434],
            [30.673178350599493, -0.739503080255706],
            [30.674791119385276, -0.739082979459209],
            [30.677528766654664, -0.739531291293797],
            [30.678792601936316, -0.739187669393787],
            [30.6806504769457, -0.739890779685395],
            [30.682535454127184, -0.741966954956098],
            [30.684940578316052, -0.743248691099635],
            [30.685624096534266, -0.745862876854027],
            [30.6919652187849, -0.74016342168254],
            [30.69399445911282, -0.739309898369953],
            [30.697841928203356, -0.738958481521118],
            [30.69976365636143, -0.737943396800679],
            [30.70062772696859, -0.736009847773918],
            [30.701881431050488, -0.734974776510916],
            [30.703465636105157, -0.734783525647796],
            [30.704363286635957, -0.735206762610351],
            [30.70706512526151, -0.734358960145964],
            [30.708430726190123, -0.734327968119385],
            [30.7089667194791, -0.734595554255998],
            [30.709337892574737, -0.735723458838533],
            [30.710973549535638, -0.735279560578284],
            [30.712298369645307, -0.736419401713739],
            [30.714080999969813, -0.7365607633005],
            [30.715560534225922, -0.738301477777583],
            [30.717714729311535, -0.739394935695675],
            [30.718714604528405, -0.739379846153737],
            [30.7209460861695, -0.740918089907639],
            [30.7220083332132, -0.740193004329402],
            [30.725410727504624, -0.740725329358183],
            [30.726813946284082, -0.74014086058014],
            [30.727333778881118, -0.739118995312073],
            [30.72828728126639, -0.738854198484155],
            [30.72871402324718, -0.737988334888326],
            [30.731062878763286, -0.737373135132806],
            [30.731815030065846, -0.736764920912648],
            [30.73350464972418, -0.736953044913986],
            [30.735356720718485, -0.737781064029663],
            [30.738395496745827, -0.737025762909985],
            [30.73858979335864, -0.735988115727063],
            [30.739388371391716, -0.73554377286372],
            [30.740016777967238, -0.734397109360531],
            [30.739940041180716, -0.73285215348865],
            [30.74096323037419, -0.732743434790788],
            [30.741441673992824, -0.731966862449296],
            [30.73350594329817, -0.72938694995722],
            [30.72890186995623, -0.724154020584909],
            [30.724661869425894, -0.717616127850446],
            [30.719733093736302, -0.713559728772761],
            [30.715097592834134, -0.712370907727021],
            [30.711533271822848, -0.710065322932979],
            [30.71210304446149, -0.709887629151624],
            [30.711319132323755, -0.709090977103037],
            [30.71003592038141, -0.710285867545439],
            [30.708511915925488, -0.717077952515627],
            [30.707774850929816, -0.718082157003741],
            [30.704661027846996, -0.720568102523767],
            [30.703710537512855, -0.720735050196101],
            [30.702831806400262, -0.719945300342766],
            [30.700646184652722, -0.719322318427767],
            [30.695086212220318, -0.719558686069841],
            [30.691118571901, -0.719006554938164],
            [30.689099434026772, -0.718096641200031],
            [30.68762817235613, -0.714388587538739],
            [30.686131518007343, -0.713957306638951],
            [30.68242497751691, -0.71397935048277],
            [30.682021383324365, -0.713333360091974],
            [30.68135690939018, -0.711730518572525],
            [30.681408063954027, -0.704387717473402],
            [30.680933236054415, -0.703646021961184],
            [30.67810680020064, -0.701683339889726],
            [30.677727151500328, -0.70065467973274],
            [30.677846875368157, -0.698765220725522],
            [30.678726437422398, -0.697832856676958],
            [30.68162569700127, -0.696638391510518],
            [30.682220352074978, -0.695275357915103],
            [30.682293554889153, -0.691305001612389],
            [30.683697264148755, -0.687383130457835],
            [30.682201348215116, -0.685421124303828],
            [30.67989609332966, -0.686615903087999],
            [30.678375341673355, -0.686902178298326],
            [30.677472697407893, -0.686447297820309],
            [30.6744332476441, -0.682762460477811],
            [30.67357951844245, -0.679389626402867],
            [30.67529160855931, -0.676424632638511],
            [30.675721730002177, -0.671234653424261],
            [30.676411248966506, -0.670182593497828],
            [30.677364184514843, -0.670314223612634],
            [30.6787867359375, -0.672049417014555],
            [30.679289008267375, -0.673940418097668],
            [30.69096405628222, -0.670449531174903],
            [30.68916814885778, -0.663203527245057],
            [30.68808189523644, -0.654362180319298],
            [30.682375110238834, -0.646697018614386],
            [30.671196864712112, -0.637227203233722],
            [30.670509252871117, -0.636802020956887],
            [30.67000122234028, -0.637206984305478],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 257,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "BIRERE",
        Population: 21229,
        Key: "ISINGIROBIRERE",
        Dist2: "Isingiro",
        "Sub Country": "Birere",
        id2_original: "IsingiroBirere",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.70351109355348, -0.809723701265083],
            [30.703496238113612, -0.808956853680165],
            [30.701029411342844, -0.807500012095454],
            [30.699635153258335, -0.804335224482394],
            [30.699280908015933, -0.803476225881315],
            [30.699566507597602, -0.800610711118834],
            [30.703698298865437, -0.798371112060998],
            [30.704841691627053, -0.796961509924392],
            [30.708802040321235, -0.794423469632523],
            [30.712033629842843, -0.793828621967704],
            [30.712486745462044, -0.793015267384717],
            [30.715457813669826, -0.792085785049854],
            [30.71731581085005, -0.789718306657445],
            [30.719272302911328, -0.785805015111512],
            [30.718826779852893, -0.783219298866424],
            [30.71792514259887, -0.78285720203054],
            [30.71802235378734, -0.781871884250354],
            [30.717547959773988, -0.781564261458792],
            [30.715823427092122, -0.77740487800882],
            [30.714888047319395, -0.776120678263575],
            [30.71363164918998, -0.775044227772041],
            [30.71225397580228, -0.775088681327789],
            [30.71045297942175, -0.773270652675986],
            [30.710550179830417, -0.772294378769686],
            [30.709198086868735, -0.771480042732234],
            [30.709200638982452, -0.770377158729617],
            [30.70799334366481, -0.768532338220716],
            [30.70366487704529, -0.76579087992053],
            [30.70321765347605, -0.764000716856606],
            [30.705037564783165, -0.757348234663582],
            [30.705811246008157, -0.756598323634976],
            [30.709065029307187, -0.756672369798418],
            [30.70973126304102, -0.756121278939978],
            [30.71058634600376, -0.756148852123003],
            [30.712488202529435, -0.755363371591652],
            [30.71322627723151, -0.754550154246206],
            [30.71491317499451, -0.754288881234978],
            [30.715508804740303, -0.753520787552947],
            [30.71548711761271, -0.752589646512966],
            [30.716102974723714, -0.752589970776809],
            [30.717373222179877, -0.750249251392069],
            [30.718255206990435, -0.750629397489406],
            [30.721098364983206, -0.749491828970099],
            [30.72360816895384, -0.74663645383279],
            [30.725887892820623, -0.746429714238682],
            [30.726952020936515, -0.745707053014781],
            [30.729189173641984, -0.746169260834808],
            [30.730137078624708, -0.745799104567214],
            [30.731884812993737, -0.745962732304933],
            [30.73442466111903, -0.745566275575383],
            [30.73767560843669, -0.743325975642988],
            [30.738626795863507, -0.743407826835446],
            [30.73971463860458, -0.742694205899955],
            [30.740429174751245, -0.742920579394185],
            [30.74220298182306, -0.741773376155661],
            [30.74286103010804, -0.740770243165178],
            [30.744045973544804, -0.740336915900402],
            [30.74489270576869, -0.73914403197056],
            [30.746897545158518, -0.738711118635927],
            [30.74693906169771, -0.737906554556799],
            [30.747459021855498, -0.7375689157135],
            [30.747467682513147, -0.737563291827514],
            [30.742238317953085, -0.732317281901951],
            [30.741441673992824, -0.731966862449296],
            [30.74096323037419, -0.732743434790788],
            [30.739940041180716, -0.73285215348865],
            [30.740016777967238, -0.734397109360531],
            [30.739388371391716, -0.73554377286372],
            [30.73858979335864, -0.735988115727063],
            [30.738395496745827, -0.737025762909985],
            [30.735356720718485, -0.737781064029663],
            [30.73350464972418, -0.736953044913986],
            [30.731815030065846, -0.736764920912648],
            [30.731062878763286, -0.737373135132806],
            [30.72871402324718, -0.737988334888326],
            [30.72828728126639, -0.738854198484155],
            [30.727333778881118, -0.739118995312073],
            [30.726813946284082, -0.74014086058014],
            [30.725410727504624, -0.740725329358183],
            [30.7220083332132, -0.740193004329402],
            [30.7209460861695, -0.740918089907639],
            [30.718714604528405, -0.739379846153737],
            [30.717714729311535, -0.739394935695675],
            [30.715560534225922, -0.738301477777583],
            [30.714080999969813, -0.7365607633005],
            [30.712298369645307, -0.736419401713739],
            [30.710973549535638, -0.735279560578284],
            [30.709337892574737, -0.735723458838533],
            [30.7089667194791, -0.734595554255998],
            [30.708430726190123, -0.734327968119385],
            [30.70706512526151, -0.734358960145964],
            [30.704363286635957, -0.735206762610351],
            [30.703465636105157, -0.734783525647796],
            [30.701881431050488, -0.734974776510916],
            [30.70062772696859, -0.736009847773918],
            [30.69976365636143, -0.737943396800679],
            [30.697841928203356, -0.738958481521118],
            [30.69399445911282, -0.739309898369953],
            [30.6919652187849, -0.74016342168254],
            [30.685624096534266, -0.745862876854027],
            [30.684940578316052, -0.743248691099635],
            [30.682535454127184, -0.741966954956098],
            [30.6806504769457, -0.739890779685395],
            [30.678792601936316, -0.739187669393787],
            [30.677528766654664, -0.739531291293797],
            [30.674791119385276, -0.739082979459209],
            [30.673178350599493, -0.739503080255706],
            [30.671407949939237, -0.743808765076434],
            [30.669836720150535, -0.744863508415447],
            [30.66713955905267, -0.749589145018499],
            [30.667749318399547, -0.754372520613467],
            [30.669849732247428, -0.758750616533406],
            [30.670384175044223, -0.759037919270273],
            [30.67147841468846, -0.762240400524019],
            [30.670998889498218, -0.766007240485886],
            [30.670028484412526, -0.767862736705096],
            [30.669455188581374, -0.773507033586736],
            [30.670035326880058, -0.774670175648395],
            [30.67065222963008, -0.778297021392082],
            [30.66763232181694, -0.776355371235848],
            [30.664769076596105, -0.773679770158187],
            [30.662997815349797, -0.774334186125803],
            [30.662294232361408, -0.775120270388932],
            [30.661720418202297, -0.776719114193364],
            [30.658542696156704, -0.777661115017326],
            [30.658152199401005, -0.777398740385488],
            [30.65705897844631, -0.774982055669466],
            [30.653415569757428, -0.77063247547286],
            [30.653262212067077, -0.766385458485494],
            [30.652302484356852, -0.762562696496035],
            [30.651181484798652, -0.760634401339235],
            [30.651407059851326, -0.758465882734054],
            [30.650639976752117, -0.755256813709117],
            [30.648929909641282, -0.754107845966253],
            [30.64529593146623, -0.753863786752537],
            [30.645260787575687, -0.754858942199869],
            [30.64406998891991, -0.756949319594733],
            [30.643691115465653, -0.759173202660994],
            [30.642481838464484, -0.760503191495215],
            [30.642008653583527, -0.762517915852055],
            [30.640628716441274, -0.765140436434383],
            [30.64102476298881, -0.76621548189455],
            [30.64616732334298, -0.767296764426953],
            [30.64709134930886, -0.768020940968198],
            [30.647252392086443, -0.769918417982662],
            [30.64811923130133, -0.771728356778623],
            [30.648348823619962, -0.773444492287719],
            [30.64907548792127, -0.774238924895825],
            [30.651319058191138, -0.775240551880958],
            [30.65206833847804, -0.776585969151908],
            [30.651975391592227, -0.777075174535601],
            [30.652823788394336, -0.777774875268992],
            [30.652906497180865, -0.779963227804944],
            [30.65358494081604, -0.781664806820422],
            [30.654881599639843, -0.782874532507768],
            [30.654578139753717, -0.783870724937695],
            [30.655195131436955, -0.784060905632108],
            [30.656591610156823, -0.786186021245414],
            [30.65681350301516, -0.787849453481919],
            [30.65626447786632, -0.789069504330703],
            [30.654740582106548, -0.790740988044697],
            [30.654941555896848, -0.79640899433856],
            [30.65397547350432, -0.798189262190043],
            [30.654115041156768, -0.799509137234391],
            [30.6532789997831, -0.80158778680255],
            [30.65258871186089, -0.802229207325765],
            [30.65179090817561, -0.806590927268421],
            [30.651938840041627, -0.807542137101503],
            [30.650477820063564, -0.810989286535837],
            [30.65088486648172, -0.812958110578003],
            [30.65091306100522, -0.816883036928395],
            [30.650163964872956, -0.820457378460531],
            [30.650563340576902, -0.821377759806817],
            [30.65097475011243, -0.826297746185851],
            [30.657948000658823, -0.828551618650078],
            [30.65707096556548, -0.83031471989545],
            [30.6568034553587, -0.831848144453154],
            [30.657912434560103, -0.83737389406232],
            [30.659024265912535, -0.840407722147768],
            [30.65893027428603, -0.842086095433076],
            [30.65967147782023, -0.844597789542409],
            [30.661949855112397, -0.844431660585129],
            [30.663384034328118, -0.846191133076067],
            [30.66555495694261, -0.847106283477406],
            [30.66766732916356, -0.848762491270717],
            [30.669019352954965, -0.848897500427173],
            [30.670714578998986, -0.848342596488463],
            [30.67268450895858, -0.848768653935651],
            [30.674894518169417, -0.848272797855346],
            [30.67829490292957, -0.846851902995772],
            [30.680753557726238, -0.843479440099092],
            [30.683438882621882, -0.843251003508597],
            [30.68393439692586, -0.842618684036317],
            [30.68216502842987, -0.839703766570275],
            [30.681252486526613, -0.83703857619051],
            [30.679178268450723, -0.834372701352219],
            [30.67935042428674, -0.83306923566094],
            [30.68049346580705, -0.832360617002811],
            [30.67872327445429, -0.830845134605386],
            [30.678115066497902, -0.828793577021074],
            [30.679106875741834, -0.826148686263975],
            [30.67861398541681, -0.82225686940103],
            [30.681856737404154, -0.822038921925075],
            [30.68556485803117, -0.822452622679573],
            [30.689526584741003, -0.821400562993481],
            [30.691329170241268, -0.820236205366832],
            [30.69257436548075, -0.820079581280212],
            [30.698499041342096, -0.816555659422747],
            [30.701789126460092, -0.811453845938527],
            [30.70351109355348, -0.809723701265083],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 258,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "NYAMUYANJA",
        Population: 15713,
        Key: "ISINGIRONYAMUYANJA",
        Dist2: "Isingiro",
        "Sub Country": "Nyamuyanja",
        id2_original: "IsingiroNyamuyanja",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.655260281752916, -0.928401588326048],
            [30.65521226410603, -0.931553189887889],
            [30.656164554664016, -0.933027435511999],
            [30.659226899789473, -0.935634007040654],
            [30.661686237305734, -0.935520824524191],
            [30.665686277162436, -0.937882773512912],
            [30.666075043762895, -0.941695423008471],
            [30.666643160806448, -0.94332299857741],
            [30.6683727006977, -0.944561748258459],
            [30.670612101886338, -0.945176338708093],
            [30.672798844731318, -0.944077588848477],
            [30.673512405307594, -0.942977845239477],
            [30.67474820057595, -0.942643824080216],
            [30.67788269838504, -0.94252361881384],
            [30.6843850565511, -0.941437688039908],
            [30.687085182987687, -0.940316768666794],
            [30.688996983863568, -0.94010423073709],
            [30.694325740721613, -0.938468721708405],
            [30.69708121865109, -0.937118809236146],
            [30.702953283779486, -0.9373969137909],
            [30.705937488949953, -0.936223983120314],
            [30.708480802775615, -0.938754688952397],
            [30.709948525982355, -0.939109943804898],
            [30.71243817624958, -0.938904191662569],
            [30.71434316250571, -0.940115216552374],
            [30.716377496281268, -0.94043627880686],
            [30.717071319972458, -0.940996265170949],
            [30.718903793320518, -0.941175987525388],
            [30.724512096911827, -0.940366430728014],
            [30.727648628506742, -0.940416319133538],
            [30.728066246299175, -0.94003992451096],
            [30.731257246343, -0.940149078479652],
            [30.73162265854268, -0.940722746183972],
            [30.73268441330958, -0.941048779887036],
            [30.73480891368517, -0.940167096258306],
            [30.73564067548483, -0.939145136866347],
            [30.735227296842233, -0.935752021845183],
            [30.736385488449834, -0.929664238016281],
            [30.737585882909507, -0.929804442079765],
            [30.738462420336194, -0.930966942337219],
            [30.739939645023693, -0.931432668075749],
            [30.742479842593628, -0.930318842158625],
            [30.74280334569039, -0.929854274048932],
            [30.743081146098724, -0.928646034524575],
            [30.742112492727873, -0.927111654532199],
            [30.742184984076346, -0.925631639109189],
            [30.74300917936639, -0.924209238006574],
            [30.74368443937219, -0.923812750747334],
            [30.745163828101198, -0.920839124085496],
            [30.744634174223165, -0.917262753279344],
            [30.747194488665567, -0.914763359538993],
            [30.747176538529565, -0.913811469562785],
            [30.7483641823021, -0.912244415602005],
            [30.749219457504324, -0.908437434454572],
            [30.7502038646303, -0.906422203694408],
            [30.75064027697511, -0.904572622067918],
            [30.749920062577562, -0.900434344565138],
            [30.748790794027144, -0.900388174166409],
            [30.7458081707899, -0.902477967281088],
            [30.744994995133446, -0.902613872706713],
            [30.744225144324847, -0.905750856265296],
            [30.743818402435576, -0.906068895576694],
            [30.74314105025347, -0.905704707490968],
            [30.742960755680986, -0.905068009016122],
            [30.742420234882964, -0.90256679784438],
            [30.742646848388116, -0.901339238633003],
            [30.744681386081254, -0.898384921892975],
            [30.74545094314074, -0.895702639584578],
            [30.746355207966996, -0.894339080721369],
            [30.748493652890733, -0.893181785413989],
            [30.75071687362445, -0.89044993894643],
            [30.757599741975177, -0.886851259070806],
            [30.75772508031353, -0.883652216501921],
            [30.759114880059247, -0.881447838956509],
            [30.75976511210291, -0.87762792036454],
            [30.760846533686365, -0.875112753947816],
            [30.761003502604147, -0.870547104959211],
            [30.76174581286277, -0.86750371763402],
            [30.761314223572715, -0.866851212136488],
            [30.761683811141875, -0.865311609174917],
            [30.75944016271856, -0.867444031424921],
            [30.756921312713047, -0.867586049570764],
            [30.754640871990652, -0.866388727894486],
            [30.75067469323027, -0.862894163759178],
            [30.749748908363113, -0.861314947966227],
            [30.74951366384471, -0.857248549665602],
            [30.7500372855356, -0.855765869002919],
            [30.749325765931662, -0.853469209585081],
            [30.746215437295312, -0.849233695733434],
            [30.744829227217426, -0.84668789213114],
            [30.743460907088476, -0.846084332340996],
            [30.742691643778045, -0.845021875813514],
            [30.74138037924604, -0.844375296524353],
            [30.74036924454538, -0.842451617254789],
            [30.739371830712393, -0.841460789061117],
            [30.73860220627923, -0.84102979959293],
            [30.738316871700604, -0.841374066971013],
            [30.73694897827137, -0.840038591989923],
            [30.736365935719377, -0.837440655112961],
            [30.7344471809849, -0.834648296806238],
            [30.73213426616499, -0.831927663024702],
            [30.731139062187562, -0.831530524650702],
            [30.729391476938886, -0.829999147913627],
            [30.72812356420418, -0.827610272674371],
            [30.728171571071293, -0.82655359479643],
            [30.72884909752654, -0.826069943640132],
            [30.728233164957047, -0.825421932161718],
            [30.728017256675134, -0.823983325068434],
            [30.728844171165527, -0.82280437836436],
            [30.728993885289118, -0.82035283695739],
            [30.730686581677276, -0.819262774681231],
            [30.73107809891914, -0.816007069939929],
            [30.730552493748093, -0.815143756047491],
            [30.72913044089039, -0.814554531594072],
            [30.72998874970334, -0.812789757187117],
            [30.729229186401366, -0.812181294206196],
            [30.728879509092174, -0.810298155105488],
            [30.727392659854733, -0.808769966132008],
            [30.727393615662177, -0.807045875256474],
            [30.726918389808883, -0.806087780402156],
            [30.72719483645612, -0.804616244597697],
            [30.72636086120758, -0.803083803079993],
            [30.726095496177702, -0.799835874779403],
            [30.720156546984814, -0.799832567504801],
            [30.71466856643759, -0.801918823995986],
            [30.708547460464676, -0.804816675798298],
            [30.70673363973514, -0.806754945178702],
            [30.706568304807092, -0.808430434972878],
            [30.704615808452232, -0.808905108690927],
            [30.70351109355348, -0.809723701265083],
            [30.701789126460092, -0.811453845938527],
            [30.698499041342096, -0.816555659422747],
            [30.69257436548075, -0.820079581280212],
            [30.691329170241268, -0.820236205366832],
            [30.689526584741003, -0.821400562993481],
            [30.68556485803117, -0.822452622679573],
            [30.681856737404154, -0.822038921925075],
            [30.67861398541681, -0.82225686940103],
            [30.679106875741834, -0.826148686263975],
            [30.678115066497902, -0.828793577021074],
            [30.67872327445429, -0.830845134605386],
            [30.68049346580705, -0.832360617002811],
            [30.67935042428674, -0.83306923566094],
            [30.679178268450723, -0.834372701352219],
            [30.681252486526613, -0.83703857619051],
            [30.68216502842987, -0.839703766570275],
            [30.68393439692586, -0.842618684036317],
            [30.683438882621882, -0.843251003508597],
            [30.680753557726238, -0.843479440099092],
            [30.67829490292957, -0.846851902995772],
            [30.674894518169417, -0.848272797855346],
            [30.67268450895858, -0.848768653935651],
            [30.670714578998986, -0.848342596488463],
            [30.669019352954965, -0.848897500427173],
            [30.66766732916356, -0.848762491270717],
            [30.66555495694261, -0.847106283477406],
            [30.663384034328118, -0.846191133076067],
            [30.661949855112397, -0.844431660585129],
            [30.65967147782023, -0.844597789542409],
            [30.65893027428603, -0.842086095433076],
            [30.659024265912535, -0.840407722147768],
            [30.657912434560103, -0.83737389406232],
            [30.6568034553587, -0.831848144453154],
            [30.65707096556548, -0.83031471989545],
            [30.657948000658823, -0.828551618650078],
            [30.65097475011243, -0.826297746185851],
            [30.651196644767367, -0.827579153787912],
            [30.650656841723258, -0.82967347990145],
            [30.65098680730017, -0.830560820753432],
            [30.650606429167816, -0.832137740647444],
            [30.652354607304574, -0.836610226102323],
            [30.652303486876715, -0.837379758536428],
            [30.64806419601546, -0.838987262746921],
            [30.642341600668836, -0.837770891724061],
            [30.639990400549834, -0.838005621558864],
            [30.638924841417698, -0.83988009320679],
            [30.63755572897464, -0.840797686450309],
            [30.636756609257475, -0.842117434268206],
            [30.63612761338709, -0.845006256707876],
            [30.636540465616957, -0.846790080504372],
            [30.63564052887374, -0.851082386754909],
            [30.63416498493414, -0.853939335613966],
            [30.631787328531722, -0.856688342073778],
            [30.631459935729794, -0.857824204670258],
            [30.631696872674162, -0.858900624002509],
            [30.63047798908933, -0.860843135099128],
            [30.630982019422223, -0.862248582695735],
            [30.63026861694943, -0.863234720460407],
            [30.6308025099773, -0.864371119137247],
            [30.626584674478288, -0.865145781116904],
            [30.627177553582673, -0.866939935767231],
            [30.62937365956786, -0.869631994299412],
            [30.635489867027548, -0.872774984330422],
            [30.638433401871858, -0.875398862725605],
            [30.643454801952075, -0.883119519570783],
            [30.648515322764617, -0.885164036645884],
            [30.65116211442617, -0.887822981324277],
            [30.65225239878819, -0.889963113522976],
            [30.65327018461522, -0.890591940947846],
            [30.654902840304743, -0.890247019653275],
            [30.656507473947308, -0.888962473154651],
            [30.6585861710232, -0.889501944421019],
            [30.66327884250667, -0.889534827780313],
            [30.6649774075886, -0.886447893742261],
            [30.66622182488706, -0.88535108757661],
            [30.666402342241728, -0.884486327805592],
            [30.667177631451057, -0.884041022177159],
            [30.670603327142626, -0.887589294687293],
            [30.6719818431501, -0.888434148561973],
            [30.672344648438838, -0.891814782789493],
            [30.67267853426362, -0.892268226129091],
            [30.673462353874882, -0.892268723735404],
            [30.673387813469265, -0.893660808594247],
            [30.674346208079562, -0.895198187571014],
            [30.674461656864935, -0.896590393474611],
            [30.675309694340907, -0.897341240033666],
            [30.67398959667471, -0.898859086901665],
            [30.673311738741102, -0.900820293075447],
            [30.671741420742393, -0.901940221578333],
            [30.669883805346135, -0.904045300326323],
            [30.669575861968433, -0.905057558421765],
            [30.668423039591282, -0.905879434028229],
            [30.66707920753694, -0.908075230736477],
            [30.66672683528192, -0.910316865845443],
            [30.66715473339444, -0.913006616675906],
            [30.66667269741298, -0.914394653482636],
            [30.666825537673738, -0.916863144899974],
            [30.662784689150328, -0.919222372219071],
            [30.661000334958754, -0.919664204696523],
            [30.66192186899802, -0.921523882400608],
            [30.661565302508922, -0.921762824011014],
            [30.658429982741357, -0.921122598458361],
            [30.657381461955232, -0.921548854131794],
            [30.656246399271236, -0.925526334367187],
            [30.655424157816945, -0.926769904668149],
            [30.655260281752916, -0.928401588326048],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 259,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "NYAKITUNDA",
        Population: 41554,
        Key: "ISINGIRONYAKITUNDA",
        Dist2: "Isingiro",
        "Sub Country": "Nyakitunda",
        id2_original: "IsingiroNyakitunda",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.91791075645098, -0.75269458224338],
            [30.91518938126465, -0.751193930277277],
            [30.909870419636448, -0.749314000213805],
            [30.90039529005688, -0.745164050317268],
            [30.887873544852436, -0.742091604612236],
            [30.882936883751285, -0.740303144759951],
            [30.879373019084156, -0.740075201905999],
            [30.87347949949181, -0.740646479136676],
            [30.87134100875399, -0.740262710472648],
            [30.869942453129198, -0.739325846630024],
            [30.865876708695996, -0.737772284623962],
            [30.8633104294401, -0.737531839025634],
            [30.86160054917883, -0.735330283366776],
            [30.859462575870637, -0.733893997086573],
            [30.8581793405721, -0.733989065179292],
            [30.85706520593928, -0.734678979328329],
            [30.852740215799926, -0.735059628881686],
            [30.845511355029302, -0.734549196014424],
            [30.84344612549617, -0.734747423528714],
            [30.840612266863218, -0.73600322773651],
            [30.8373745113055, -0.741733743111844],
            [30.834843344499088, -0.743928134828457],
            [30.833690883244675, -0.745631377259629],
            [30.8326611210783, -0.746192950992942],
            [30.832049687271745, -0.747668111757108],
            [30.828348944508146, -0.75086310558768],
            [30.82679412693965, -0.754638800394728],
            [30.82433208729102, -0.758150554976074],
            [30.821661101303906, -0.760766380069331],
            [30.81464411088801, -0.765839056757075],
            [30.811850467135386, -0.761297081277459],
            [30.81180935932968, -0.759629613633068],
            [30.810579627689467, -0.755054201024744],
            [30.811693719203156, -0.752624191840021],
            [30.814373576952, -0.748519994167486],
            [30.813052279136578, -0.744943256801049],
            [30.80687965208713, -0.733697742073066],
            [30.80749845836723, -0.731640919166775],
            [30.80982819054757, -0.729441409501142],
            [30.81249123003765, -0.725902524048233],
            [30.815495817981926, -0.724654361070016],
            [30.818128063224076, -0.724788032266875],
            [30.819644008893604, -0.720614139337574],
            [30.82416046505431, -0.717117946871031],
            [30.824519292602968, -0.716483723033895],
            [30.825735157848456, -0.716161880923651],
            [30.82641899407028, -0.714726979944758],
            [30.82799342096311, -0.714339019659349],
            [30.827490413811343, -0.710182600663247],
            [30.82512134620134, -0.701840010492749],
            [30.82367078351146, -0.703003627611609],
            [30.82192350099503, -0.703154366142984],
            [30.82043821123292, -0.702212425849464],
            [30.819784276333653, -0.702682742095608],
            [30.81876219566126, -0.702474870500096],
            [30.815452911749023, -0.704806482188682],
            [30.813907813951896, -0.704702059140218],
            [30.812438502523754, -0.703500887612283],
            [30.811507363697455, -0.703695876496017],
            [30.81037841045572, -0.703288538288845],
            [30.808325500418377, -0.704675497966345],
            [30.80750928396472, -0.704818691166229],
            [30.808021800682063, -0.706701673160846],
            [30.806796080917916, -0.709042831989162],
            [30.805859688743862, -0.710274294540622],
            [30.803564504871034, -0.711640977819691],
            [30.80287938405836, -0.714303739271991],
            [30.800358489487227, -0.717255473556216],
            [30.799143308757994, -0.718151638928116],
            [30.795424111005197, -0.724309334973835],
            [30.794308601051693, -0.723765305677958],
            [30.793120774921178, -0.723909655220781],
            [30.792328215600513, -0.725403848145841],
            [30.791040920815224, -0.72656264830929],
            [30.788548042002873, -0.727376647772326],
            [30.7863517851007, -0.728842967083144],
            [30.78614326186876, -0.729221084986154],
            [30.78685518661289, -0.729857714333251],
            [30.78559467060621, -0.731451302961797],
            [30.784334465416627, -0.732410828406393],
            [30.781805912707703, -0.732581674909001],
            [30.780581704808178, -0.733532155716269],
            [30.77990625076627, -0.734745589319734],
            [30.779869355160915, -0.735945495979718],
            [30.777950012029937, -0.737767556284325],
            [30.775349899525498, -0.738090514265798],
            [30.773909680037793, -0.737876706015385],
            [30.772054419125894, -0.73946001860773],
            [30.76984075377187, -0.739986983924216],
            [30.768446624146442, -0.739634226055997],
            [30.76652744540714, -0.740212292243822],
            [30.762860711961885, -0.738644731467469],
            [30.762017829019026, -0.73664260563539],
            [30.760493087944553, -0.736435293394997],
            [30.75865180122523, -0.735135347034636],
            [30.75616438955971, -0.735346541534378],
            [30.754068610120385, -0.736180103096317],
            [30.752893325369552, -0.735117268131085],
            [30.752154764678913, -0.734934796685339],
            [30.751024145062324, -0.734994924963196],
            [30.749735190190407, -0.736597129487798],
            [30.747467682513147, -0.737563291827514],
            [30.747459021855498, -0.7375689157135],
            [30.751813489312607, -0.741023728340471],
            [30.75437770783323, -0.744966929001023],
            [30.759413568992922, -0.749970034914488],
            [30.760518602793578, -0.75208415059153],
            [30.764459961102652, -0.755245150098518],
            [30.771573721634205, -0.764684813798646],
            [30.772172864691047, -0.766129546856885],
            [30.771982554801493, -0.766550432799612],
            [30.7659516881921, -0.769210710889615],
            [30.766983356583506, -0.772978569596229],
            [30.769280771871493, -0.775886002344726],
            [30.77125049342196, -0.780647032048883],
            [30.769959420322575, -0.784376651842603],
            [30.768324507166717, -0.786912382638028],
            [30.76822883928393, -0.788084386524067],
            [30.769377523122543, -0.788552040227634],
            [30.771482064729163, -0.792080698376502],
            [30.775520364732106, -0.7943313194267],
            [30.777396615678917, -0.796078466894999],
            [30.784047901044346, -0.799909218667945],
            [30.787157502943643, -0.805914773015002],
            [30.787512244056106, -0.809048461028515],
            [30.787367482344674, -0.813090827790059],
            [30.783919909981, -0.816892170069843],
            [30.78356274790886, -0.818231476596995],
            [30.780804341471583, -0.821889659743675],
            [30.780542221156516, -0.823229015797411],
            [30.77816362242134, -0.827557142868064],
            [30.776380674093197, -0.82899131684321],
            [30.770962826816838, -0.829203535981374],
            [30.770106449381746, -0.830901337181023],
            [30.77001007542314, -0.833269314234634],
            [30.77083986272581, -0.836618519363147],
            [30.77022156668879, -0.837479269561882],
            [30.770742519484973, -0.840684783968381],
            [30.769292186763813, -0.842190880676204],
            [30.768080271410636, -0.842285862762911],
            [30.767484931820732, -0.844557870951829],
            [30.76667653520158, -0.845418504427852],
            [30.76491803003232, -0.845632764325025],
            [30.763182823568282, -0.846660295305745],
            [30.76505871429065, -0.848933726404262],
            [30.76501053225207, -0.850081832183957],
            [30.764011541875742, -0.851803449487301],
            [30.764414821657937, -0.852975736177084],
            [30.76255995510646, -0.855462270495077],
            [30.762939054037822, -0.857352124602232],
            [30.76229671818551, -0.858667313715784],
            [30.762628817261195, -0.859648204141338],
            [30.762224321160133, -0.860580821602547],
            [30.762912931927694, -0.861418406923036],
            [30.761604992060516, -0.863187668453041],
            [30.761683811141875, -0.865311609174917],
            [30.761314223572715, -0.866851212136488],
            [30.76174581286277, -0.86750371763402],
            [30.761003502604147, -0.870547104959211],
            [30.760846533686365, -0.875112753947816],
            [30.75976511210291, -0.87762792036454],
            [30.759114880059247, -0.881447838956509],
            [30.75772508031353, -0.883652216501921],
            [30.757599741975177, -0.886851259070806],
            [30.75071687362445, -0.89044993894643],
            [30.748493652890733, -0.893181785413989],
            [30.746355207966996, -0.894339080721369],
            [30.74545094314074, -0.895702639584578],
            [30.744681386081254, -0.898384921892975],
            [30.742646848388116, -0.901339238633003],
            [30.742420234882964, -0.90256679784438],
            [30.742960755680986, -0.905068009016122],
            [30.74314105025347, -0.905704707490968],
            [30.743818402435576, -0.906068895576694],
            [30.744225144324847, -0.905750856265296],
            [30.744994995133446, -0.902613872706713],
            [30.7458081707899, -0.902477967281088],
            [30.748790794027144, -0.900388174166409],
            [30.749920062577562, -0.900434344565138],
            [30.75064027697511, -0.904572622067918],
            [30.7502038646303, -0.906422203694408],
            [30.753178359910873, -0.908265602049007],
            [30.764153837711703, -0.908462284121369],
            [30.76607648754126, -0.907071256709574],
            [30.765986208651825, -0.908065644221577],
            [30.766866017742775, -0.911121846878462],
            [30.76632943785392, -0.91393364376352],
            [30.766002269630796, -0.91433316714033],
            [30.763584627418442, -0.914641598538874],
            [30.763054280939315, -0.916699339214877],
            [30.761889572952636, -0.917272672103797],
            [30.761166415674197, -0.919552960882209],
            [30.76292725107329, -0.929878815485145],
            [30.762711342791413, -0.933131708002987],
            [30.76166269713943, -0.93803449839453],
            [30.76028381102608, -0.939086061708052],
            [30.758715295946143, -0.939396001714085],
            [30.756847944608847, -0.942051652102016],
            [30.755775565467076, -0.946026868147702],
            [30.754924797112626, -0.94743844436912],
            [30.75447521995732, -0.955646768604785],
            [30.754808483249647, -0.958919585795648],
            [30.7558802497404, -0.963089656933815],
            [30.76219640870762, -0.962275234403308],
            [30.762866654317484, -0.954717166633132],
            [30.763818388818304, -0.952804239331858],
            [30.76771741401963, -0.949745093481185],
            [30.77047607468015, -0.946302479506808],
            [30.772095879071234, -0.940084457886317],
            [30.77419036403821, -0.9347278255554],
            [30.77485954873777, -0.92860485128017],
            [30.77277308572624, -0.921140646872997],
            [30.77401157055057, -0.916548876288489],
            [30.779719490120375, -0.908515442431679],
            [30.78590030531364, -0.90430938021858],
            [30.79208283988235, -0.897232894938286],
            [30.793892504107042, -0.891014830142089],
            [30.793800735810887, -0.885465370176537],
            [30.79893833746468, -0.877144299870233],
            [30.801701552583687, -0.865472980293773],
            [30.80265583201168, -0.858871617068116],
            [30.80266119675058, -0.849399301722863],
            [30.80437430106537, -0.845477396057477],
            [30.807190901265077, -0.841267914617467],
            [30.809034958388747, -0.83973921477556],
            [30.81416865776095, -0.837972006603298],
            [30.819586702666665, -0.837687994169785],
            [30.82514489194323, -0.841853236832094],
            [30.831462375925504, -0.848076088363735],
            [30.836164497685772, -0.853389088750599],
            [30.84142768022303, -0.86478281327535],
            [30.843557079111868, -0.862757473639845],
            [30.84553380482657, -0.859101118015503],
            [30.848066557159417, -0.849799814675241],
            [30.848623833334138, -0.841849067302647],
            [30.85020357376187, -0.84184994216731],
            [30.853838927257613, -0.838273963638262],
            [30.854707828106076, -0.838194930233451],
            [30.855498475811814, -0.836764168350354],
            [30.854631037420624, -0.834139831514022],
            [30.853289158303735, -0.832469370843921],
            [30.86332045284201, -0.832633861954761],
            [30.866084849245638, -0.832953411045729],
            [30.869875536725342, -0.834307167218],
            [30.872404257419227, -0.832241234515307],
            [30.873825955442378, -0.832401027044351],
            [30.875799766123993, -0.834071846133263],
            [30.875878243845563, -0.835026034214694],
            [30.8776150493108, -0.836776242216683],
            [30.879747863594325, -0.836538863458822],
            [30.881881063255147, -0.835585872173444],
            [30.883224757867232, -0.833916837592445],
            [30.886464222918963, -0.832169309506516],
            [30.88824346749318, -0.828393414020867],
            [30.892587768716204, -0.828554760628404],
            [30.90016967996988, -0.83054663515072],
            [30.90346310951568, -0.830147640913265],
            [30.901902865224553, -0.826686038498458],
            [30.900548083605223, -0.824994612871078],
            [30.897696306277307, -0.822524855056659],
            [30.895058782534537, -0.820950294570642],
            [30.887383742037034, -0.817745669593719],
            [30.879590644944884, -0.815499354977233],
            [30.86973082442129, -0.814165097358934],
            [30.863479745701458, -0.805599954522979],
            [30.872860251240603, -0.795225753268964],
            [30.878915433448096, -0.786314367634225],
            [30.882026308260176, -0.783088277449555],
            [30.898350284295734, -0.768298772100803],
            [30.90457479713764, -0.764389138986613],
            [30.90913963386463, -0.759798399422897],
            [30.91791075645098, -0.75269458224338],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 260,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "ISINGIRO TOWN COUNCIL",
        Population: 27991,
        Key: "ISINGIROISINGIRO TOWN COUNCIL",
        Dist2: "Isingiro",
        "Sub Country": "Isingiro T.C",
        id2_original: "IsingiroIsingiro T.C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.60727802400152, -1.064805921209796],
            [30.610425758486308, -1.064579136659432],
            [30.612586142964215, -1.065985576212996],
            [30.61605367499521, -1.067377437997],
            [30.619654069653368, -1.068028736427057],
            [30.622341829881783, -1.067882011337288],
            [30.62516626788234, -1.068724877104595],
            [30.62903764563416, -1.068845395671525],
            [30.63053223924767, -1.069542597787628],
            [30.631669476752947, -1.070736697851506],
            [30.633140968392308, -1.071189816947745],
            [30.633735468057452, -1.070882933308509],
            [30.634117647311925, -1.070042551542391],
            [30.63381138917368, -1.069038924675299],
            [30.632245946332016, -1.068133758182698],
            [30.6321410734125, -1.067283960258757],
            [30.63314060996453, -1.066516372451137],
            [30.636180402884793, -1.066708549871336],
            [30.640101413454342, -1.065997445394927],
            [30.644327548488278, -1.06669674625777],
            [30.647667077777818, -1.065804387733655],
            [30.649329400329588, -1.06592317835554],
            [30.649951828616928, -1.063943971155216],
            [30.65842270459094, -1.062721040189343],
            [30.661376837758972, -1.059134516011323],
            [30.66152568231334, -1.056558305754101],
            [30.661739979017625, -1.056341514454833],
            [30.663519970990155, -1.056939482325449],
            [30.664280899731356, -1.056632705048277],
            [30.666343627456442, -1.053298590118647],
            [30.668295347666906, -1.051672898502426],
            [30.66893919897712, -1.050669966247762],
            [30.668893525034797, -1.045056229866843],
            [30.669527643098935, -1.043158347349067],
            [30.670717036789615, -1.042390849694159],
            [30.671242165853567, -1.041387822858443],
            [30.67233320030886, -1.037148965304036],
            [30.67542680500958, -1.034828015419388],
            [30.67681092560608, -1.032180363672336],
            [30.677977607191448, -1.03098796078049],
            [30.681010460626126, -1.029227409058482],
            [30.68234382371413, -1.027872402032584],
            [30.689743916852613, -1.022544238632915],
            [30.69284709579766, -1.021145290174396],
            [30.69434670919696, -1.019835579085207],
            [30.697134806751038, -1.016131199900113],
            [30.69853900020258, -1.015011248561006],
            [30.70221980665506, -1.015348356721276],
            [30.705535898000534, -1.014311120698397],
            [30.710952687959775, -1.013881051355943],
            [30.717971327682537, -1.014075869920735],
            [30.719659368102615, -1.013426177063916],
            [30.72265838559382, -1.010924181843364],
            [30.726320487325467, -1.009182011092857],
            [30.734341853517826, -1.007334391699097],
            [30.736981087652893, -1.006233327778621],
            [30.7398714314526, -1.004436333373102],
            [30.741844254885713, -1.003931449938501],
            [30.7425345068753, -1.003362392539123],
            [30.74441901693283, -1.001044355351121],
            [30.747439854502296, -0.998267070478991],
            [30.7485746899125, -0.996190629211958],
            [30.75215631966269, -0.992072132295121],
            [30.753935910986616, -0.991807702518867],
            [30.754196753897343, -0.989348913081481],
            [30.75600194002037, -0.987505910873793],
            [30.75595423858046, -0.986439119444917],
            [30.754932385181846, -0.985127580135731],
            [30.75652402199887, -0.984694719910854],
            [30.755811087548363, -0.983094098813858],
            [30.755192402540832, -0.978401750131749],
            [30.75804245151014, -0.974462072510325],
            [30.758350959928148, -0.972663249254184],
            [30.757780032056075, -0.968703196743268],
            [30.7558802497404, -0.963089656933815],
            [30.754808483249647, -0.958919585795648],
            [30.75447521995732, -0.955646768604785],
            [30.754924797112626, -0.94743844436912],
            [30.755775565467076, -0.946026868147702],
            [30.756847944608847, -0.942051652102016],
            [30.758715295946143, -0.939396001714085],
            [30.76028381102608, -0.939086061708052],
            [30.76166269713943, -0.93803449839453],
            [30.762711342791413, -0.933131708002987],
            [30.76292725107329, -0.929878815485145],
            [30.761166415674197, -0.919552960882209],
            [30.761889572952636, -0.917272672103797],
            [30.763054280939315, -0.916699339214877],
            [30.763584627418442, -0.914641598538874],
            [30.766002269630796, -0.91433316714033],
            [30.76632943785392, -0.91393364376352],
            [30.766866017742775, -0.911121846878462],
            [30.765986208651825, -0.908065644221577],
            [30.76607648754126, -0.907071256709574],
            [30.764153837711703, -0.908462284121369],
            [30.753178359910873, -0.908265602049007],
            [30.7502038646303, -0.906422203694408],
            [30.749219457504324, -0.908437434454572],
            [30.7483641823021, -0.912244415602005],
            [30.747176538529565, -0.913811469562785],
            [30.747194488665567, -0.914763359538993],
            [30.744634174223165, -0.917262753279344],
            [30.745163828101198, -0.920839124085496],
            [30.74368443937219, -0.923812750747334],
            [30.74300917936639, -0.924209238006574],
            [30.742184984076346, -0.925631639109189],
            [30.742112492727873, -0.927111654532199],
            [30.743081146098724, -0.928646034524575],
            [30.74280334569039, -0.929854274048932],
            [30.742479842593628, -0.930318842158625],
            [30.739939645023693, -0.931432668075749],
            [30.738462420336194, -0.930966942337219],
            [30.737585882909507, -0.929804442079765],
            [30.736385488449834, -0.929664238016281],
            [30.735227296842233, -0.935752021845183],
            [30.73564067548483, -0.939145136866347],
            [30.73480891368517, -0.940167096258306],
            [30.73268441330958, -0.941048779887036],
            [30.73162265854268, -0.940722746183972],
            [30.731257246343, -0.940149078479652],
            [30.728066246299175, -0.94003992451096],
            [30.727648628506742, -0.940416319133538],
            [30.724512096911827, -0.940366430728014],
            [30.718903793320518, -0.941175987525388],
            [30.717071319972458, -0.940996265170949],
            [30.716377496281268, -0.94043627880686],
            [30.71434316250571, -0.940115216552374],
            [30.71243817624958, -0.938904191662569],
            [30.709948525982355, -0.939109943804898],
            [30.708480802775615, -0.938754688952397],
            [30.705937488949953, -0.936223983120314],
            [30.702953283779486, -0.9373969137909],
            [30.69708121865109, -0.937118809236146],
            [30.694325740721613, -0.938468721708405],
            [30.688996983863568, -0.94010423073709],
            [30.687085182987687, -0.940316768666794],
            [30.6843850565511, -0.941437688039908],
            [30.67788269838504, -0.94252361881384],
            [30.67474820057595, -0.942643824080216],
            [30.673512405307594, -0.942977845239477],
            [30.672798844731318, -0.944077588848477],
            [30.670612101886338, -0.945176338708093],
            [30.6683727006977, -0.944561748258459],
            [30.666643160806448, -0.94332299857741],
            [30.666075043762895, -0.941695423008471],
            [30.665686277162436, -0.937882773512912],
            [30.661686237305734, -0.935520824524191],
            [30.659226899789473, -0.935634007040654],
            [30.656164554664016, -0.933027435511999],
            [30.65521226410603, -0.931553189887889],
            [30.655260281752916, -0.928401588326048],
            [30.650728236228776, -0.928172212965121],
            [30.649645320747048, -0.927348385302234],
            [30.648418888618874, -0.927162369467655],
            [30.64255078685747, -0.928825229371239],
            [30.6417361217943, -0.930043047206494],
            [30.638455516597535, -0.931306387022795],
            [30.640319413014232, -0.941513347412502],
            [30.638671665627935, -0.950253507767395],
            [30.63916209277245, -0.953743126419088],
            [30.63796895131041, -0.956038358011302],
            [30.63562726435027, -0.956958775632671],
            [30.634982713252448, -0.95829618475822],
            [30.63336685785534, -0.958647605927713],
            [30.632530935059286, -0.960563409565262],
            [30.631388896058798, -0.961376174447701],
            [30.62906579164861, -0.964447993236965],
            [30.629156856563906, -0.966075170925811],
            [30.631009953434297, -0.970840304245485],
            [30.63149677474126, -0.975794314671313],
            [30.632653842556465, -0.978597391734793],
            [30.630401785003787, -0.981732512307797],
            [30.62947420799761, -0.982238065585288],
            [30.62704432803613, -0.98521937169197],
            [30.626183871351355, -0.98744247318634],
            [30.624664193181818, -0.9872967512566],
            [30.623568340163366, -0.988642848144219],
            [30.624143508083577, -0.991400306590598],
            [30.62383082519445, -0.993054307035848],
            [30.62454219477971, -0.99350679500132],
            [30.623796237361045, -0.997474590937421],
            [30.622020041668907, -1.000284579154878],
            [30.62192068530354, -1.002056244529371],
            [30.622441478199608, -1.003440816910535],
            [30.622460750655698, -1.004614809271361],
            [30.621497092816142, -1.007304240813645],
            [30.62210586132125, -1.01036691691443],
            [30.621362427270228, -1.011626282830667],
            [30.622086788291142, -1.013258296519163],
            [30.62172930552044, -1.014731489700113],
            [30.621381291891176, -1.014855088375876],
            [30.621055068695767, -1.014188589033187],
            [30.620518877777386, -1.014050440801709],
            [30.62028326315308, -1.014965001564524],
            [30.620739428552703, -1.015554338604592],
            [30.620012237838623, -1.01580814106089],
            [30.62033087296485, -1.016544626679062],
            [30.617966773038358, -1.01837234179046],
            [30.618267827236156, -1.018899094395377],
            [30.617890470138136, -1.019657373476502],
            [30.618116184429663, -1.020157297446932],
            [30.61969436358544, -1.020091538615932],
            [30.619369881325046, -1.021287144860215],
            [30.619759593851477, -1.021813964350916],
            [30.619089748890215, -1.022451548155824],
            [30.619155478619533, -1.023491270392283],
            [30.61798924978507, -1.023981233040552],
            [30.6187465062134, -1.025039319694292],
            [30.618308363713346, -1.025264061064605],
            [30.61842661344577, -1.026254916487198],
            [30.617646922491563, -1.027484627572961],
            [30.618241205662706, -1.028323413045486],
            [30.618726107269943, -1.03080614065871],
            [30.61833526915441, -1.032754718777406],
            [30.61717465568881, -1.034314548458784],
            [30.617479282486496, -1.036321981397253],
            [30.616129194564532, -1.037536056875365],
            [30.617444179020147, -1.041063216339835],
            [30.618090877091504, -1.041436973245723],
            [30.617569555087716, -1.042214874597648],
            [30.618048559255104, -1.045256954661301],
            [30.619002673393094, -1.046020095513359],
            [30.618709559404074, -1.047592352835922],
            [30.620026500390374, -1.048506667743641],
            [30.62074341168266, -1.049936745285136],
            [30.621461211408747, -1.050191431483843],
            [30.621571347557516, -1.050620375904619],
            [30.62102635584434, -1.051390316347606],
            [30.622138319249107, -1.052090048930329],
            [30.621955743854127, -1.053551207572636],
            [30.622475589027587, -1.054734940031952],
            [30.621362120046385, -1.05602066201082],
            [30.619957770287986, -1.055924281067301],
            [30.618481571476526, -1.056931756332116],
            [30.616305078408967, -1.055421136548984],
            [30.615207645253882, -1.056373306716783],
            [30.614545250021276, -1.055896288029172],
            [30.6133452714816, -1.056816610108235],
            [30.611072687424684, -1.057172234826598],
            [30.607499452430833, -1.061696548451052],
            [30.606762981221575, -1.061795409037745],
            [30.60735462154916, -1.062636530445387],
            [30.60727802400152, -1.064805921209796],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 261,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "KIKAGATE",
        Population: 81274,
        Key: "ISINGIROKIKAGATE",
        Dist2: "Isingiro",
        "Sub Country": "Kikagate",
        id2_original: "IsingiroKikagate",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.655260281752916, -0.928401588326048],
            [30.655424157816945, -0.926769904668149],
            [30.656246399271236, -0.925526334367187],
            [30.657381461955232, -0.921548854131794],
            [30.658429982741357, -0.921122598458361],
            [30.661565302508922, -0.921762824011014],
            [30.66192186899802, -0.921523882400608],
            [30.661000334958754, -0.919664204696523],
            [30.662784689150328, -0.919222372219071],
            [30.666825537673738, -0.916863144899974],
            [30.66667269741298, -0.914394653482636],
            [30.66715473339444, -0.913006616675906],
            [30.66672683528192, -0.910316865845443],
            [30.66707920753694, -0.908075230736477],
            [30.668423039591282, -0.905879434028229],
            [30.669575861968433, -0.905057558421765],
            [30.669883805346135, -0.904045300326323],
            [30.671741420742393, -0.901940221578333],
            [30.673311738741102, -0.900820293075447],
            [30.67398959667471, -0.898859086901665],
            [30.675309694340907, -0.897341240033666],
            [30.674461656864935, -0.896590393474611],
            [30.674346208079562, -0.895198187571014],
            [30.673387813469265, -0.893660808594247],
            [30.673462353874882, -0.892268723735404],
            [30.67267853426362, -0.892268226129091],
            [30.672344648438838, -0.891814782789493],
            [30.6719818431501, -0.888434148561973],
            [30.670603327142626, -0.887589294687293],
            [30.667177631451057, -0.884041022177159],
            [30.666402342241728, -0.884486327805592],
            [30.66622182488706, -0.88535108757661],
            [30.6649774075886, -0.886447893742261],
            [30.66327884250667, -0.889534827780313],
            [30.6585861710232, -0.889501944421019],
            [30.656507473947308, -0.888962473154651],
            [30.654902840304743, -0.890247019653275],
            [30.65327018461522, -0.890591940947846],
            [30.65225239878819, -0.889963113522976],
            [30.65116211442617, -0.887822981324277],
            [30.648515322764617, -0.885164036645884],
            [30.643454801952075, -0.883119519570783],
            [30.638433401871858, -0.875398862725605],
            [30.635489867027548, -0.872774984330422],
            [30.62937365956786, -0.869631994299412],
            [30.627177553582673, -0.866939935767231],
            [30.626584674478288, -0.865145781116904],
            [30.623203234289196, -0.866434331045294],
            [30.617191546711094, -0.867107581728656],
            [30.61483709469077, -0.867740819630802],
            [30.613113619326022, -0.867697412624709],
            [30.61021359797575, -0.866891591278042],
            [30.608234879797752, -0.867529132551524],
            [30.602914384745347, -0.867352882632638],
            [30.60270310458378, -0.868874461242212],
            [30.6014767658804, -0.870247660063737],
            [30.601187794921493, -0.871919754364627],
            [30.59966225973632, -0.874259964952545],
            [30.598706582529744, -0.876727087580936],
            [30.598821832787422, -0.878182493979478],
            [30.59970909699695, -0.879602241795432],
            [30.60008287161362, -0.882260047933546],
            [30.600650828757058, -0.883173388731736],
            [30.60061904995557, -0.886563120324684],
            [30.600995488975354, -0.888118132277181],
            [30.59819346304282, -0.892916184952362],
            [30.59740796088702, -0.893629775576251],
            [30.597596741843983, -0.894181298285393],
            [30.59709561845936, -0.895157215022287],
            [30.596406815452358, -0.895183880053332],
            [30.5951562051683, -0.896719737730037],
            [30.591186222042683, -0.898271872031293],
            [30.587167098376113, -0.900519982960056],
            [30.584707844403177, -0.901006465663893],
            [30.581176364900344, -0.902828891017369],
            [30.576514920652773, -0.902680181704648],
            [30.574061815647966, -0.903187768313352],
            [30.57157848413046, -0.903047221890619],
            [30.570581538319693, -0.90381811053176],
            [30.56898544136728, -0.906532913484352],
            [30.5668643500982, -0.913992786706305],
            [30.56492585578367, -0.928403428732433],
            [30.57320856794333, -0.934785469961392],
            [30.5773398849007, -0.938854082279566],
            [30.579671790105706, -0.94342557766677],
            [30.579415061478993, -0.945373891774286],
            [30.576093118507757, -0.949297388815383],
            [30.574599938842503, -0.949996954556647],
            [30.573434257082038, -0.952005215643785],
            [30.574974839946528, -0.95459487169664],
            [30.575526953503328, -0.956337110440244],
            [30.576778681291568, -0.957335282484876],
            [30.577429903278706, -0.958560150108552],
            [30.577590547204313, -0.961943159692842],
            [30.57854234548549, -0.963711023598237],
            [30.57863138559816, -0.967516930563748],
            [30.581034814666072, -0.972387206194658],
            [30.581697735413137, -0.9756881249505],
            [30.58707369694277, -0.973589990095503],
            [30.59132242819936, -0.971231291019158],
            [30.59191712010395, -0.970245162338796],
            [30.59366995420883, -0.969469128226852],
            [30.595632850359745, -0.965613987493671],
            [30.597771781272044, -0.964838218186021],
            [30.598574805965757, -0.963224417522866],
            [30.600415821393888, -0.963763843352236],
            [30.60246588646672, -0.962659148030713],
            [30.60303074621907, -0.96185235910325],
            [30.605620974560413, -0.952706043692921],
            [30.605711205839135, -0.951061832634512],
            [30.60461350139286, -0.949327107293565],
            [30.603337188511922, -0.948190176595827],
            [30.60161476417605, -0.947949812250767],
            [30.598438041955358, -0.946273440036392],
            [30.59745782906339, -0.946452132789302],
            [30.59505246682099, -0.946002025031942],
            [30.591072189002205, -0.946776536633879],
            [30.590567625968397, -0.946297854712234],
            [30.590508803385262, -0.945460738953098],
            [30.591598256805657, -0.94269325437434],
            [30.593282429978423, -0.933778762163789],
            [30.594722681805465, -0.931051009056698],
            [30.595414522914787, -0.930605973231008],
            [30.59665935253995, -0.930523292418581],
            [30.598783363333727, -0.928396142555505],
            [30.60054253505293, -0.927896996284586],
            [30.60103151141826, -0.928131658453431],
            [30.60210831386451, -0.931111750505028],
            [30.601495043901508, -0.938072446230509],
            [30.601908759412357, -0.939854776105445],
            [30.602544639971022, -0.9403564158616],
            [30.603429894649246, -0.940245647844198],
            [30.60434330432509, -0.939410942282162],
            [30.60628751461979, -0.93342364958427],
            [30.607535509908026, -0.932527623434688],
            [30.606616225250225, -0.930434282909333],
            [30.607032885438553, -0.929149041141125],
            [30.606410555067598, -0.927115695523554],
            [30.605401225980675, -0.926427405674112],
            [30.605936901266055, -0.924813390463213],
            [30.60561084336065, -0.923856500200539],
            [30.60457227321291, -0.922480587363822],
            [30.603740684788082, -0.922480025091357],
            [30.60326752326332, -0.919430329689578],
            [30.603981267095904, -0.917995809392086],
            [30.6038331259224, -0.917457583669127],
            [30.602478260759735, -0.915632500738985],
            [30.602942815525783, -0.914046481160993],
            [30.605336877860257, -0.910338895145308],
            [30.608175015168882, -0.911644948735237],
            [30.610301470278525, -0.91148171945755],
            [30.61181255696069, -0.91435718413421],
            [30.614131289270365, -0.915240466704082],
            [30.615647789200395, -0.917014680264218],
            [30.61753318140354, -0.918397204164489],
            [30.621835415420122, -0.915840962308658],
            [30.627546951607272, -0.915168527116628],
            [30.628125645414986, -0.916333841729454],
            [30.628760363553713, -0.919911858068566],
            [30.629638793730685, -0.920858178484742],
            [30.629737809634587, -0.9219285102925],
            [30.63124245629446, -0.922663517232705],
            [30.632096335514724, -0.923774941978644],
            [30.633394626577417, -0.926897596053681],
            [30.63472638168105, -0.928699455706445],
            [30.63613752809289, -0.929023286350016],
            [30.638455516597535, -0.931306387022795],
            [30.6417361217943, -0.930043047206494],
            [30.64255078685747, -0.928825229371239],
            [30.648418888618874, -0.927162369467655],
            [30.649645320747048, -0.927348385302234],
            [30.650728236228776, -0.928172212965121],
            [30.655260281752916, -0.928401588326048],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 262,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "KABUYANDA",
        Population: 21193,
        Key: "ISINGIROKABUYANDA",
        Dist2: "Isingiro",
        "Sub Country": "Kabuyanda",
        id2_original: "IsingiroKabuyanda",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.638455516597535, -0.931306387022795],
            [30.63613752809289, -0.929023286350016],
            [30.63472638168105, -0.928699455706445],
            [30.633394626577417, -0.926897596053681],
            [30.632096335514724, -0.923774941978644],
            [30.63124245629446, -0.922663517232705],
            [30.629737809634587, -0.9219285102925],
            [30.629638793730685, -0.920858178484742],
            [30.628760363553713, -0.919911858068566],
            [30.628125645414986, -0.916333841729454],
            [30.627546951607272, -0.915168527116628],
            [30.621835415420122, -0.915840962308658],
            [30.61753318140354, -0.918397204164489],
            [30.615647789200395, -0.917014680264218],
            [30.614131289270365, -0.915240466704082],
            [30.61181255696069, -0.91435718413421],
            [30.610301470278525, -0.91148171945755],
            [30.608175015168882, -0.911644948735237],
            [30.605336877860257, -0.910338895145308],
            [30.602942815525783, -0.914046481160993],
            [30.602478260759735, -0.915632500738985],
            [30.6038331259224, -0.917457583669127],
            [30.603981267095904, -0.917995809392086],
            [30.60326752326332, -0.919430329689578],
            [30.603740684788082, -0.922480025091357],
            [30.60457227321291, -0.922480587363822],
            [30.60561084336065, -0.923856500200539],
            [30.605936901266055, -0.924813390463213],
            [30.605401225980675, -0.926427405674112],
            [30.606410555067598, -0.927115695523554],
            [30.607032885438553, -0.929149041141125],
            [30.606616225250225, -0.930434282909333],
            [30.607535509908026, -0.932527623434688],
            [30.60628751461979, -0.93342364958427],
            [30.60434330432509, -0.939410942282162],
            [30.603429894649246, -0.940245647844198],
            [30.602544639971022, -0.9403564158616],
            [30.601908759412357, -0.939854776105445],
            [30.601495043901508, -0.938072446230509],
            [30.60210831386451, -0.931111750505028],
            [30.60103151141826, -0.928131658453431],
            [30.60054253505293, -0.927896996284586],
            [30.598783363333727, -0.928396142555505],
            [30.59665935253995, -0.930523292418581],
            [30.595414522914787, -0.930605973231008],
            [30.594722681805465, -0.931051009056698],
            [30.593282429978423, -0.933778762163789],
            [30.591598256805657, -0.94269325437434],
            [30.590508803385262, -0.945460738953098],
            [30.590567625968397, -0.946297854712234],
            [30.591072189002205, -0.946776536633879],
            [30.59505246682099, -0.946002025031942],
            [30.59745782906339, -0.946452132789302],
            [30.598438041955358, -0.946273440036392],
            [30.60161476417605, -0.947949812250767],
            [30.603337188511922, -0.948190176595827],
            [30.60461350139286, -0.949327107293565],
            [30.605711205839135, -0.951061832634512],
            [30.605620974560413, -0.952706043692921],
            [30.60303074621907, -0.96185235910325],
            [30.60246588646672, -0.962659148030713],
            [30.600415821393888, -0.963763843352236],
            [30.598574805965757, -0.963224417522866],
            [30.597771781272044, -0.964838218186021],
            [30.595632850359745, -0.965613987493671],
            [30.59366995420883, -0.969469128226852],
            [30.59191712010395, -0.970245162338796],
            [30.59132242819936, -0.971231291019158],
            [30.58707369694277, -0.973589990095503],
            [30.581697735413137, -0.9756881249505],
            [30.580365353285433, -0.978270113134507],
            [30.57836786930114, -0.980612451349194],
            [30.578057051314524, -0.981766750161387],
            [30.58142947780808, -0.985326172772719],
            [30.582212083795397, -0.987359624888587],
            [30.58380345021953, -0.988102191305081],
            [30.58489689754966, -0.987409416500207],
            [30.588460521468267, -0.987890342569212],
            [30.59223708204185, -0.989638991518888],
            [30.594446530703966, -0.989951516377421],
            [30.596870596768902, -0.989187953587825],
            [30.598149565069857, -0.991648003292234],
            [30.602331838063378, -0.992260570585313],
            [30.606262642964516, -0.99461962306244],
            [30.608695288838724, -0.997071840193583],
            [30.611782137310207, -1.00122100813271],
            [30.61487116778951, -1.002354245573213],
            [30.622441478199608, -1.003440816910535],
            [30.62192068530354, -1.002056244529371],
            [30.622020041668907, -1.000284579154878],
            [30.623796237361045, -0.997474590937421],
            [30.62454219477971, -0.99350679500132],
            [30.62383082519445, -0.993054307035848],
            [30.624143508083577, -0.991400306590598],
            [30.623568340163366, -0.988642848144219],
            [30.624664193181818, -0.9872967512566],
            [30.626183871351355, -0.98744247318634],
            [30.62704432803613, -0.98521937169197],
            [30.62947420799761, -0.982238065585288],
            [30.630401785003787, -0.981732512307797],
            [30.632653842556465, -0.978597391734793],
            [30.63149677474126, -0.975794314671313],
            [30.631009953434297, -0.970840304245485],
            [30.629156856563906, -0.966075170925811],
            [30.62906579164861, -0.964447993236965],
            [30.631388896058798, -0.961376174447701],
            [30.632530935059286, -0.960563409565262],
            [30.63336685785534, -0.958647605927713],
            [30.634982713252448, -0.95829618475822],
            [30.63562726435027, -0.956958775632671],
            [30.63796895131041, -0.956038358011302],
            [30.63916209277245, -0.953743126419088],
            [30.638671665627935, -0.950253507767395],
            [30.640319413014232, -0.941513347412502],
            [30.638455516597535, -0.931306387022795],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 263,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "KABUYANDA TOWN COUNCIL",
        Population: 16376,
        Key: "ISINGIROKABUYANDA TOWN COUNCIL",
        Dist2: "Isingiro",
        "Sub Country": "Kabuyanda T.C",
        id2_original: "IsingiroKabuyanda T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.581697735413137, -0.9756881249505],
            [30.581034814666072, -0.972387206194658],
            [30.57863138559816, -0.967516930563748],
            [30.57854234548549, -0.963711023598237],
            [30.577590547204313, -0.961943159692842],
            [30.577429903278706, -0.958560150108552],
            [30.576778681291568, -0.957335282484876],
            [30.575526953503328, -0.956337110440244],
            [30.574974839946528, -0.95459487169664],
            [30.573434257082038, -0.952005215643785],
            [30.574599938842503, -0.949996954556647],
            [30.576093118507757, -0.949297388815383],
            [30.579415061478993, -0.945373891774286],
            [30.579671790105706, -0.94342557766677],
            [30.5773398849007, -0.938854082279566],
            [30.57320856794333, -0.934785469961392],
            [30.56492585578367, -0.928403428732433],
            [30.56316718532438, -0.930586032363884],
            [30.561313879146567, -0.930946308962462],
            [30.556611794217243, -0.930746047916728],
            [30.554455133256166, -0.930207137903277],
            [30.543099347391617, -0.930201455909682],
            [30.542405167069283, -0.930286478328899],
            [30.539573023320195, -0.932530120420425],
            [30.5357976826588, -0.938131596854267],
            [30.53433043825408, -0.939040560964365],
            [30.532516958884383, -0.94264872282872],
            [30.530852260288658, -0.94757372921824],
            [30.530264324613306, -0.953584163703978],
            [30.5298145713882, -0.954668504463751],
            [30.525502129815067, -0.95778379178153],
            [30.524378643720134, -0.959229190795897],
            [30.522804843851368, -0.962527219407737],
            [30.516202274123806, -0.966092715223988],
            [30.50991168659946, -0.97282195060547],
            [30.505859836408764, -0.978415307325724],
            [30.50586825002971, -0.980678510066616],
            [30.50527100331644, -0.982112522912671],
            [30.50316261602212, -0.984775936277125],
            [30.501653682601702, -0.989990109427076],
            [30.50248803424433, -0.995106626965214],
            [30.50452219823831, -1.000989845815072],
            [30.50707675986966, -1.004986048341742],
            [30.506967359441077, -1.006171758659644],
            [30.50491920867813, -1.008916229144373],
            [30.504619712159027, -1.015453453883088],
            [30.49685499015176, -1.022207105178534],
            [30.49612419000689, -1.02353139173362],
            [30.492511951061722, -1.026702961069395],
            [30.490633469598055, -1.029167543309475],
            [30.49007115207796, -1.031672512538713],
            [30.490082683751268, -1.033587653984791],
            [30.487461785129486, -1.03554005390109],
            [30.487106057666846, -1.038877585468286],
            [30.486201055323768, -1.039131693245222],
            [30.486235591953175, -1.039945250612106],
            [30.485161817727747, -1.040414376839888],
            [30.485564732793918, -1.041964736067909],
            [30.484504765674448, -1.043022960437192],
            [30.483462623825115, -1.047952775705439],
            [30.481325872225707, -1.050948513016168],
            [30.47908222739568, -1.051936752118363],
            [30.47834841340301, -1.053188399826648],
            [30.478686974958848, -1.056027664985446],
            [30.478104966367745, -1.057510268996062],
            [30.480230410872686, -1.057889200943295],
            [30.483200271744696, -1.057177577994538],
            [30.486003242704918, -1.057604671238965],
            [30.49010053147933, -1.058575130009463],
            [30.4927127056631, -1.060394010751867],
            [30.495064475313995, -1.060468232118057],
            [30.502566449083798, -1.068357821947154],
            [30.506143801954906, -1.070002234099418],
            [30.508156524959702, -1.072252755668141],
            [30.5099009140026, -1.073183474429682],
            [30.513853395251505, -1.072472733411261],
            [30.516122386047268, -1.073126189930505],
            [30.519179456265398, -1.073333863749015],
            [30.525245473053552, -1.075077259131088],
            [30.527451405709627, -1.076144355864187],
            [30.53271676037324, -1.074006043074867],
            [30.537276254819215, -1.074997695878742],
            [30.53969254866033, -1.074695665365157],
            [30.549041324805327, -1.068625294620331],
            [30.550516587572236, -1.06825248135266],
            [30.554074334712265, -1.068504660182256],
            [30.555433546822577, -1.06822071885222],
            [30.556710967326275, -1.066036120156192],
            [30.55903149806317, -1.064632642758059],
            [30.559753805535355, -1.064740872857734],
            [30.56256076321879, -1.066962254800576],
            [30.563829126907816, -1.067069661206129],
            [30.568240570910124, -1.064428415490232],
            [30.56950933165447, -1.064034226395353],
            [30.5743561845834, -1.063862788231022],
            [30.576023181069633, -1.063104765880319],
            [30.57776155319674, -1.06373907381408],
            [30.580122076031756, -1.062552656596999],
            [30.58670648541753, -1.061065646823586],
            [30.588440222237786, -1.06109412302578],
            [30.590338539401266, -1.061863945909253],
            [30.59197507850778, -1.062751075583357],
            [30.59387598012431, -1.064581138658602],
            [30.595680725174493, -1.065296251950102],
            [30.60173900746804, -1.064566574092348],
            [30.60727802400152, -1.064805921209796],
            [30.60735462154916, -1.062636530445387],
            [30.606762981221575, -1.061795409037745],
            [30.607499452430833, -1.061696548451052],
            [30.611072687424684, -1.057172234826598],
            [30.6133452714816, -1.056816610108235],
            [30.614545250021276, -1.055896288029172],
            [30.615207645253882, -1.056373306716783],
            [30.616305078408967, -1.055421136548984],
            [30.618481571476526, -1.056931756332116],
            [30.619957770287986, -1.055924281067301],
            [30.621362120046385, -1.05602066201082],
            [30.622475589027587, -1.054734940031952],
            [30.621955743854127, -1.053551207572636],
            [30.622138319249107, -1.052090048930329],
            [30.62102635584434, -1.051390316347606],
            [30.621571347557516, -1.050620375904619],
            [30.621461211408747, -1.050191431483843],
            [30.62074341168266, -1.049936745285136],
            [30.620026500390374, -1.048506667743641],
            [30.618709559404074, -1.047592352835922],
            [30.619002673393094, -1.046020095513359],
            [30.618048559255104, -1.045256954661301],
            [30.617569555087716, -1.042214874597648],
            [30.618090877091504, -1.041436973245723],
            [30.617444179020147, -1.041063216339835],
            [30.616129194564532, -1.037536056875365],
            [30.617479282486496, -1.036321981397253],
            [30.61717465568881, -1.034314548458784],
            [30.61833526915441, -1.032754718777406],
            [30.618726107269943, -1.03080614065871],
            [30.618241205662706, -1.028323413045486],
            [30.617646922491563, -1.027484627572961],
            [30.61842661344577, -1.026254916487198],
            [30.618308363713346, -1.025264061064605],
            [30.6187465062134, -1.025039319694292],
            [30.61798924978507, -1.023981233040552],
            [30.619155478619533, -1.023491270392283],
            [30.619089748890215, -1.022451548155824],
            [30.619759593851477, -1.021813964350916],
            [30.619369881325046, -1.021287144860215],
            [30.61969436358544, -1.020091538615932],
            [30.618116184429663, -1.020157297446932],
            [30.617890470138136, -1.019657373476502],
            [30.618267827236156, -1.018899094395377],
            [30.617966773038358, -1.01837234179046],
            [30.62033087296485, -1.016544626679062],
            [30.620012237838623, -1.01580814106089],
            [30.620739428552703, -1.015554338604592],
            [30.62028326315308, -1.014965001564524],
            [30.620518877777386, -1.014050440801709],
            [30.621055068695767, -1.014188589033187],
            [30.621381291891176, -1.014855088375876],
            [30.62172930552044, -1.014731489700113],
            [30.622086788291142, -1.013258296519163],
            [30.621362427270228, -1.011626282830667],
            [30.62210586132125, -1.01036691691443],
            [30.621497092816142, -1.007304240813645],
            [30.622460750655698, -1.004614809271361],
            [30.622441478199608, -1.003440816910535],
            [30.61487116778951, -1.002354245573213],
            [30.611782137310207, -1.00122100813271],
            [30.608695288838724, -0.997071840193583],
            [30.606262642964516, -0.99461962306244],
            [30.602331838063378, -0.992260570585313],
            [30.598149565069857, -0.991648003292234],
            [30.596870596768902, -0.989187953587825],
            [30.594446530703966, -0.989951516377421],
            [30.59223708204185, -0.989638991518888],
            [30.588460521468267, -0.987890342569212],
            [30.58489689754966, -0.987409416500207],
            [30.58380345021953, -0.988102191305081],
            [30.582212083795397, -0.987359624888587],
            [30.58142947780808, -0.985326172772719],
            [30.578057051314524, -0.981766750161387],
            [30.57836786930114, -0.980612451349194],
            [30.580365353285433, -0.978270113134507],
            [30.581697735413137, -0.9756881249505],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 264,
        District: "ISINGIRO",
        County: "ISINGIRO",
        Subcounty: "RUBOROGOTA",
        Population: 17563,
        Key: "ISINGIRORUBOROGOTA",
        Dist2: "Isingiro",
        "Sub Country": "Ruborogota",
        id2_original: "IsingiroRuborogota",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.11198715169244, -0.763213663145599],
            [30.10902461119167, -0.764313818359583],
            [30.107651848893635, -0.764362605114532],
            [30.10244425230951, -0.760854532959069],
            [30.10039720198277, -0.762444688979783],
            [30.09923744910321, -0.762349963731431],
            [30.098171719291162, -0.7583133531784],
            [30.09615969337905, -0.756881418274705],
            [30.094833964174313, -0.754947312583261],
            [30.09392267452255, -0.75424250793041],
            [30.08944924317239, -0.753073917019246],
            [30.08784179331139, -0.752115068837999],
            [30.086616230752437, -0.75223171041572],
            [30.08225477619904, -0.753981676833583],
            [30.081001055049168, -0.753637483885545],
            [30.07800873090517, -0.753662576152118],
            [30.076801841626015, -0.754185820164557],
            [30.075367541137723, -0.757338231000253],
            [30.073616377899274, -0.758656220856815],
            [30.073616515341527, -0.759297737750682],
            [30.0726345462432, -0.760914414765132],
            [30.070031485467986, -0.763135355864624],
            [30.067878078204863, -0.766142672764596],
            [30.066281099106863, -0.769240715509069],
            [30.065769424110904, -0.772856151142405],
            [30.066248121054453, -0.774743809210673],
            [30.065309689704684, -0.776349372837093],
            [30.065087219229643, -0.779214954629975],
            [30.064259046199517, -0.78046125792565],
            [30.062315524912663, -0.779919031194888],
            [30.06128326453147, -0.7782325256101],
            [30.05994802665946, -0.777780367062574],
            [30.059029251346416, -0.778157277984912],
            [30.05876604586649, -0.777589743255425],
            [30.057834801039004, -0.777570351312706],
            [30.057305459774692, -0.77707679584557],
            [30.055530581012736, -0.778862059838891],
            [30.053856318952512, -0.77813891991034],
            [30.052944846942736, -0.778769426938664],
            [30.052590990670847, -0.779775418257645],
            [30.053301227480567, -0.781131211354254],
            [30.05278079840216, -0.783500924926563],
            [30.052094524152682, -0.784074728511619],
            [30.052248516951916, -0.785185452287384],
            [30.05355068783834, -0.788863441359196],
            [30.05485266468862, -0.790964772096658],
            [30.054959297407812, -0.792051642450317],
            [30.056213776735767, -0.79279134152323],
            [30.05723167036061, -0.794415090953008],
            [30.056971547000426, -0.796111382481029],
            [30.05640362399298, -0.796923989128165],
            [30.05709014168594, -0.798237420690183],
            [30.056889165200683, -0.799850058693886],
            [30.055374485257396, -0.800185532374192],
            [30.054135429104544, -0.799076936029721],
            [30.05340176513052, -0.799220769264338],
            [30.052857536087014, -0.800224464256314],
            [30.05420671311729, -0.801418001166487],
            [30.054538185168905, -0.802444997430119],
            [30.054301625516953, -0.803472376978797],
            [30.054822451650676, -0.804690356384354],
            [30.05550885974915, -0.805143783887051],
            [30.054870032716334, -0.806911996439957],
            [30.055201520937633, -0.808177886187992],
            [30.056373192664406, -0.809335712707948],
            [30.056231277714147, -0.810148031090172],
            [30.057746051082194, -0.810624800166972],
            [30.057935554284658, -0.812129665129175],
            [30.057415037171367, -0.813635028045819],
            [30.056066036210893, -0.81416147841206],
            [30.054113809350604, -0.817236815004496],
            [30.05345105030028, -0.817371856678927],
            [30.05304891676841, -0.818790098933099],
            [30.05224421132676, -0.819331622610055],
            [30.052433699257875, -0.820271430987255],
            [30.051463377715514, -0.820794758260172],
            [30.047688422431342, -0.820755822084656],
            [30.04723886773393, -0.822002351680632],
            [30.047404608700475, -0.822743252515626],
            [30.046694556045423, -0.823176526365234],
            [30.046529051335785, -0.824341948425931],
            [30.04709192131976, -0.825968710435573],
            [30.050635911659537, -0.830134728986425],
            [30.050280992680683, -0.831329401358078],
            [30.05010410811302, -0.838412541783128],
            [30.05122876022119, -0.843846521096214],
            [30.05200987410683, -0.844897128658388],
            [30.051939036556778, -0.847023277437457],
            [30.051347528281536, -0.848551020509658],
            [30.052495387466756, -0.850115002417769],
            [30.05251914341443, -0.850783630161288],
            [30.05185656851874, -0.851216815582613],
            [30.05098095456017, -0.853321359697657],
            [30.049750336282788, -0.853817351657701],
            [30.04967936847703, -0.854558188089145],
            [30.048543219729837, -0.854756087385335],
            [30.048164631939894, -0.85520755553031],
            [30.04854330956138, -0.856111372809839],
            [30.049750469233427, -0.855850283255847],
            [30.050803715157983, -0.857513586777829],
            [30.050661747207094, -0.858299544300475],
            [30.05153749950625, -0.858609598948649],
            [30.05276829026018, -0.860090160520587],
            [30.05281569166275, -0.860641349545928],
            [30.05094600201077, -0.861263330314389],
            [30.051147389924434, -0.865284181347574],
            [30.05195215375656, -0.865980525283348],
            [30.05252013425619, -0.86564666410626],
            [30.053750960044407, -0.867264940456318],
            [30.05175137759559, -0.871889436141351],
            [30.05189339136056, -0.872323239826966],
            [30.0511833746381, -0.872611809915648],
            [30.05118329917961, -0.87325331492562],
            [30.050520634452383, -0.873966577885988],
            [30.05071011968853, -0.874852183071137],
            [30.0498580892011, -0.875068356300464],
            [30.050094812346455, -0.876884630039559],
            [30.04970433715035, -0.877995657360728],
            [30.050177747508446, -0.878258054079097],
            [30.049941061194, -0.878908405487238],
            [30.050580160416374, -0.879098652561982],
            [30.04994112048281, -0.879549908520971],
            [30.05005948609793, -0.87991141355147],
            [30.05027244790569, -0.880363345763732],
            [30.050745869043585, -0.880074593037534],
            [30.052213297602915, -0.881485260138941],
            [30.05266291877564, -0.881503689590634],
            [30.052497315251323, -0.882894989874395],
            [30.052899782956512, -0.883130228013462],
            [30.052213369468117, -0.883536268567658],
            [30.05242640224282, -0.883897849558769],
            [30.051787415309846, -0.884684084514021],
            [30.052544793909046, -0.884826966980854],
            [30.05377549662809, -0.884085678401766],
            [30.056982496565418, -0.883976254168425],
            [30.0628995978323, -0.885907703463996],
            [30.069929114356526, -0.887145714888577],
            [30.083443772834368, -0.886994227681997],
            [30.08385784587469, -0.884282513569853],
            [30.084875452936966, -0.881725724146644],
            [30.086993610308355, -0.878367941956605],
            [30.088460984070423, -0.87698144720467],
            [30.09118277068516, -0.875307491369581],
            [30.092129458450714, -0.874255763122854],
            [30.092271410231916, -0.873347866896534],
            [30.093892690555, -0.872976574325243],
            [30.095904404751714, -0.870896910754367],
            [30.095975214453986, -0.868006210806052],
            [30.096472196605152, -0.867169752398553],
            [30.096696889512216, -0.864864251549321],
            [30.098069521554535, -0.862784970647897],
            [30.097856416016334, -0.861566728059941],
            [30.09714629778423, -0.860850484285203],
            [30.097134378038746, -0.859787400389603],
            [30.09902764038209, -0.85670440934133],
            [30.1004240867626, -0.85665573956846],
            [30.101299675568352, -0.85469622133358],
            [30.102435683280028, -0.853572664262832],
            [30.104589503768153, -0.85309348597121],
            [30.10534692099493, -0.853331903851265],
            [30.106790638522327, -0.85227981113443],
            [30.107784609112844, -0.850893552966211],
            [30.109488684460707, -0.850008528741765],
            [30.11427304429029, -0.850076460849823],
            [30.11535069564449, -0.8494575115456],
            [30.115595185623782, -0.84895341800849],
            [30.120671921925506, -0.845904115805906],
            [30.125145186189037, -0.843846626187709],
            [30.12786698088861, -0.842124727800441],
            [30.12975354359657, -0.83813895321504],
            [30.126123793791557, -0.837145892751207],
            [30.123771683679195, -0.838339528245681],
            [30.12159225042566, -0.837051572527329],
            [30.122756673646396, -0.829732136433743],
            [30.122330295483298, -0.828177847167966],
            [30.12068804578654, -0.826261105919223],
            [30.122499547964292, -0.823994187271798],
            [30.12318967508806, -0.822058192397593],
            [30.123196706201806, -0.818181947644556],
            [30.125206574360618, -0.818181715902835],
            [30.128174810180287, -0.818877167334553],
            [30.12919617309876, -0.818710550457548],
            [30.130289667141266, -0.817300792798127],
            [30.132499574842498, -0.815652756413968],
            [30.133213051875448, -0.814266629072584],
            [30.135352297198096, -0.811781763691735],
            [30.13648998475935, -0.811273593695339],
            [30.137234229989083, -0.809799901333106],
            [30.134320998912596, -0.80721495105973],
            [30.131172870067385, -0.806189818917892],
            [30.129823559188143, -0.804924567190638],
            [30.127125291365854, -0.804830863288414],
            [30.124781859877412, -0.803399057406248],
            [30.1240242683775, -0.801942263237316],
            [30.123958995890636, -0.800346430098771],
            [30.12342900065281, -0.799047288220583],
            [30.118555566574592, -0.793130542531145],
            [30.117348073627557, -0.790431787716805],
            [30.115608218381904, -0.7889159815345],
            [30.115915503294538, -0.78607282710705],
            [30.114163936712526, -0.785572358057995],
            [30.113903401923906, -0.784258591937225],
            [30.11434117162313, -0.783553526249072],
            [30.11224038227946, -0.778858541463029],
            [30.111980576922882, -0.776895607941184],
            [30.11198715169244, -0.763213663145599],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 265,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "BWONGYERA",
        Population: 34885,
        Key: "NTUNGAMOBWONGYERA",
        Dist2: "Ntungamo",
        "Sub Country": "Bwongyera",
        id2_original: "Ntungamo Bwongyera",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.211335969416908, -0.845510251056384],
            [30.207560379922146, -0.841831241261841],
            [30.206400184173155, -0.839132222712119],
            [30.2060684875427, -0.836695459050075],
            [30.20675484353888, -0.835882660137802],
            [30.207973443256098, -0.832357748086544],
            [30.209133138643505, -0.830971211574797],
            [30.21254153008775, -0.829344189336434],
            [30.214908335739864, -0.827216153688306],
            [30.21733375287103, -0.82101442141003],
            [30.22115625328821, -0.818443313664903],
            [30.221771571410052, -0.817558866885526],
            [30.222141917157302, -0.81592582466373],
            [30.22840096752698, -0.813795978233653],
            [30.230839115582306, -0.812033133780712],
            [30.23332134396864, -0.808304927667295],
            [30.23412107723519, -0.805837991721653],
            [30.234074399874714, -0.803726140458239],
            [30.23334334550659, -0.801931515049487],
            [30.231520140077315, -0.80052438605754],
            [30.230466533928322, -0.799060408635926],
            [30.228742365064182, -0.798283685724938],
            [30.228851330708142, -0.797563021991109],
            [30.22765048529419, -0.795896178587245],
            [30.226809643323637, -0.792754921918239],
            [30.225010169587556, -0.789889133823491],
            [30.222619073490122, -0.787836121048648],
            [30.2210678958952, -0.783524673263686],
            [30.218108713296953, -0.781687128776009],
            [30.217528424979623, -0.779573081593647],
            [30.21584758994644, -0.778308026535522],
            [30.21298323530622, -0.777139408949558],
            [30.211775639951252, -0.774966107540556],
            [30.20719461917612, -0.770585271477795],
            [30.206318509347525, -0.768889586715076],
            [30.205347376626445, -0.765330388919402],
            [30.20371393311444, -0.764375918758835],
            [30.20077878763655, -0.764210850944585],
            [30.200303263542587, -0.768766886098103],
            [30.200500228151807, -0.773014413605295],
            [30.199524761957807, -0.774005999529399],
            [30.201532370853688, -0.783694401248243],
            [30.199908763893987, -0.79006363833563],
            [30.198614829660457, -0.792515989324984],
            [30.19792002950055, -0.795583047097524],
            [30.19692617838599, -0.797590679337157],
            [30.193088436253355, -0.802767384627123],
            [30.18886235242339, -0.800022088167723],
            [30.185336060691363, -0.797070281787324],
            [30.17706906635422, -0.786824928214928],
            [30.173415107850623, -0.783390423613038],
            [30.16372389661427, -0.780356404614739],
            [30.152049317520014, -0.775093756344747],
            [30.1480262547409, -0.774675645888416],
            [30.148022683039336, -0.78001343448517],
            [30.147171861684296, -0.781175779819538],
            [30.1465324498482, -0.783741375149562],
            [30.145273568775337, -0.784788679413258],
            [30.143861266231728, -0.787055987246546],
            [30.144895464279003, -0.788787467256727],
            [30.14506144599403, -0.792943162031667],
            [30.1463171479291, -0.796276265805021],
            [30.14398480704119, -0.799282453267796],
            [30.144012055638715, -0.802309991187446],
            [30.143518448458078, -0.802728764453973],
            [30.144689534483277, -0.803405134809934],
            [30.145653433071324, -0.80539636699285],
            [30.14673582124199, -0.806273921647549],
            [30.149184568519402, -0.805943883634978],
            [30.150596684213415, -0.806655790881647],
            [30.151537700914563, -0.807699130845887],
            [30.15290299551766, -0.808031851716976],
            [30.159706890276823, -0.8083446993132],
            [30.160954230693207, -0.809032800462935],
            [30.162318072720495, -0.811474594940458],
            [30.16276532234092, -0.811593395998797],
            [30.170463981343847, -0.811859485314309],
            [30.17387701977311, -0.813070463236638],
            [30.174629869066607, -0.813876713361235],
            [30.176086896931604, -0.817764164021562],
            [30.174626419535922, -0.818829528252439],
            [30.17347090400954, -0.821482849199136],
            [30.174153482589997, -0.821767706227286],
            [30.181523362690537, -0.820967208111096],
            [30.181145427975785, -0.822720579578913],
            [30.183146904971508, -0.822413926345698],
            [30.183074877153704, -0.824404495237816],
            [30.184368449366207, -0.826348641233049],
            [30.18611036265218, -0.826871235657344],
            [30.188230053447743, -0.82587742773132],
            [30.189289301915004, -0.82623364997103],
            [30.189947880206006, -0.827182038331241],
            [30.191501780594564, -0.827230538708151],
            [30.19272562737136, -0.82789495411083],
            [30.19467733949698, -0.831427357716517],
            [30.196465708259552, -0.832874219447094],
            [30.198747445250895, -0.835838121914264],
            [30.20072273186451, -0.839323174174588],
            [30.201732527177093, -0.843020826158131],
            [30.203450113186832, -0.84468094384015],
            [30.204459803396517, -0.846995297973967],
            [30.206888525429576, -0.846695414700181],
            [30.208139602837587, -0.845780991757957],
            [30.211335969416908, -0.845510251056384],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 266,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "IHUNGA",
        Population: 15289,
        Key: "NTUNGAMOIHUNGA",
        Dist2: "Ntungamo",
        "Sub Country": "ihunga",
        id2_original: "Ntungamo ihunga",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.168491725646, -0.733270806008254],
            [30.157653607438657, -0.732105183627835],
            [30.15237829495009, -0.732947922232102],
            [30.150111618214517, -0.732475992262119],
            [30.147211335454486, -0.733325887986585],
            [30.14521965997682, -0.732270423316026],
            [30.14377119395483, -0.732170656483241],
            [30.139387060533807, -0.732861028117662],
            [30.138528263935665, -0.734050985461773],
            [30.138567231954358, -0.740455074918252],
            [30.138038063166583, -0.746261174048752],
            [30.137560384912543, -0.747094503607175],
            [30.13579830175351, -0.748520210642979],
            [30.131011525455836, -0.755360996652464],
            [30.1238645299537, -0.7610043623275],
            [30.12204219589021, -0.761889635840515],
            [30.11567540967024, -0.762228709086969],
            [30.11198715169244, -0.763213663145599],
            [30.111980576922882, -0.776895607941184],
            [30.11224038227946, -0.778858541463029],
            [30.11434117162313, -0.783553526249072],
            [30.113903401923906, -0.784258591937225],
            [30.114163936712526, -0.785572358057995],
            [30.115915503294538, -0.78607282710705],
            [30.115608218381904, -0.7889159815345],
            [30.117348073627557, -0.790431787716805],
            [30.118555566574592, -0.793130542531145],
            [30.12342900065281, -0.799047288220583],
            [30.123580055062767, -0.798572475029707],
            [30.124175445856668, -0.798453042137665],
            [30.12734421888544, -0.801284711402592],
            [30.130554092533384, -0.802160430066074],
            [30.133533036271213, -0.802602686598564],
            [30.135933657205566, -0.802426252326979],
            [30.13628049673679, -0.802775881855591],
            [30.143518448458078, -0.802728764453973],
            [30.144012055638715, -0.802309991187446],
            [30.14398480704119, -0.799282453267796],
            [30.1463171479291, -0.796276265805021],
            [30.14506144599403, -0.792943162031667],
            [30.144895464279003, -0.788787467256727],
            [30.143861266231728, -0.787055987246546],
            [30.145273568775337, -0.784788679413258],
            [30.1465324498482, -0.783741375149562],
            [30.147171861684296, -0.781175779819538],
            [30.148022683039336, -0.78001343448517],
            [30.1480262547409, -0.774675645888416],
            [30.152049317520014, -0.775093756344747],
            [30.16372389661427, -0.780356404614739],
            [30.173415107850623, -0.783390423613038],
            [30.17706906635422, -0.786824928214928],
            [30.185336060691363, -0.797070281787324],
            [30.18886235242339, -0.800022088167723],
            [30.193088436253355, -0.802767384627123],
            [30.19692617838599, -0.797590679337157],
            [30.19792002950055, -0.795583047097524],
            [30.198614829660457, -0.792515989324984],
            [30.199908763893987, -0.79006363833563],
            [30.201532370853688, -0.783694401248243],
            [30.199524761957807, -0.774005999529399],
            [30.200500228151807, -0.773014413605295],
            [30.200303263542587, -0.768766886098103],
            [30.20077878763655, -0.764210850944585],
            [30.19991501437176, -0.763576491024153],
            [30.195262819178335, -0.758192331063854],
            [30.19210196569714, -0.753499951135323],
            [30.19170724865624, -0.752579188330368],
            [30.192381230359405, -0.751585951897065],
            [30.192742754650553, -0.749941249070679],
            [30.192701322553024, -0.748032956581705],
            [30.191627131509307, -0.745990367530525],
            [30.18921338888362, -0.74319240380657],
            [30.183417419144583, -0.73965677099264],
            [30.172206136276635, -0.736152550447698],
            [30.168491725646, -0.733270806008254],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 267,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "KIBATSI",
        Population: 19469,
        Key: "NTUNGAMOKIBATSI",
        Dist2: "Ntungamo",
        "Sub Country": "Kibatsi",
        id2_original: "Ntungamo Kibatsi",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.21607572879093, -0.92445776321305],
            [30.215519426389996, -0.924016093006105],
            [30.21498670386695, -0.921949739225677],
            [30.213885605585542, -0.915439785512407],
            [30.21337614314013, -0.907089777649492],
            [30.212287079588606, -0.904390636188026],
            [30.208770814851743, -0.889854482580156],
            [30.20774057388332, -0.883153414369586],
            [30.19875548786764, -0.862170131824079],
            [30.195441260526376, -0.859018582898608],
            [30.190150508693062, -0.855593605716791],
            [30.18417290140021, -0.847964186706827],
            [30.18071668814182, -0.844932266033134],
            [30.170597121550426, -0.840053232955282],
            [30.168848336152557, -0.839710400814427],
            [30.166791973889573, -0.840859573708667],
            [30.164461015508866, -0.840931198553185],
            [30.161912357605605, -0.839866147462105],
            [30.159703966260576, -0.838279715833636],
            [30.159156780861448, -0.837286561092419],
            [30.158175029155423, -0.837325695611836],
            [30.156110422154775, -0.840847913933704],
            [30.15493700949299, -0.845655683241319],
            [30.148286458051157, -0.852182275664891],
            [30.146381354115743, -0.855420723552708],
            [30.14202234387824, -0.858658445644929],
            [30.140386839630917, -0.86167658229146],
            [30.136560144979658, -0.865546730749717],
            [30.130003407297902, -0.867765149506309],
            [30.12738722213639, -0.868466741239101],
            [30.12710619408122, -0.866502926640679],
            [30.128576200805416, -0.861691132455122],
            [30.127443885169576, -0.859570025375103],
            [30.1259844067005, -0.859253376115653],
            [30.123978925913537, -0.85614865322348],
            [30.12222507940733, -0.851222422247792],
            [30.12038161517178, -0.849580748651911],
            [30.11535069564449, -0.8494575115456],
            [30.11427304429029, -0.850076460849823],
            [30.109488684460707, -0.850008528741765],
            [30.107784609112844, -0.850893552966211],
            [30.106790638522327, -0.85227981113443],
            [30.10534692099493, -0.853331903851265],
            [30.104589503768153, -0.85309348597121],
            [30.102435683280028, -0.853572664262832],
            [30.101299675568352, -0.85469622133358],
            [30.1004240867626, -0.85665573956846],
            [30.09902764038209, -0.85670440934133],
            [30.097134378038746, -0.859787400389603],
            [30.09714629778423, -0.860850484285203],
            [30.097856416016334, -0.861566728059941],
            [30.098069521554535, -0.862784970647897],
            [30.096696889512216, -0.864864251549321],
            [30.096472196605152, -0.867169752398553],
            [30.095975214453986, -0.868006210806052],
            [30.095904404751714, -0.870896910754367],
            [30.093892690555, -0.872976574325243],
            [30.092271410231916, -0.873347866896534],
            [30.092129458450714, -0.874255763122854],
            [30.09118277068516, -0.875307491369581],
            [30.088460984070423, -0.87698144720467],
            [30.086993610308355, -0.878367941956605],
            [30.084875452936966, -0.881725724146644],
            [30.08385784587469, -0.884282513569853],
            [30.083443772834368, -0.886994227681997],
            [30.08737635729806, -0.887327307311873],
            [30.089932633813277, -0.888353016191071],
            [30.092122062620973, -0.88982090041875],
            [30.095080801451456, -0.892757543770129],
            [30.103105740243706, -0.904380410142549],
            [30.104331695366454, -0.90532679931566],
            [30.11492788109811, -0.90498923120458],
            [30.12488615428193, -0.905866315773281],
            [30.1286754170336, -0.906593273613341],
            [30.13367734343511, -0.906393138747496],
            [30.13610872987129, -0.905567964157594],
            [30.140915498175637, -0.905224455353185],
            [30.14381670440375, -0.905222697569604],
            [30.145852364092693, -0.90593818638477],
            [30.148420757982755, -0.910081691429131],
            [30.14995938341823, -0.911609784143417],
            [30.152953743144693, -0.91338785996626],
            [30.155723202453256, -0.914317941736802],
            [30.16308472462837, -0.915484176383462],
            [30.168943319519123, -0.918646236361138],
            [30.17097900885244, -0.919194519945169],
            [30.1728016600212, -0.919336774113672],
            [30.174742635482552, -0.918977231962082],
            [30.18189107008577, -0.916320957942865],
            [30.184731570861924, -0.916295340369012],
            [30.186175528239524, -0.916796180476449],
            [30.192282810936874, -0.920328451057696],
            [30.202189409432258, -0.924611046148419],
            [30.2087628018794, -0.930026536550295],
            [30.21246470257139, -0.927882366443918],
            [30.214510474595492, -0.926574668802557],
            [30.21607572879093, -0.92445776321305],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 268,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "NYABIHOKO",
        Population: 22005,
        Key: "NTUNGAMONYABIHOKO",
        Dist2: "Ntungamo",
        "Sub Country": "Nyabihoko",
        id2_original: "Ntungamo Nyabihoko",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.158175029155423, -0.837325695611836],
            [30.159243249097425, -0.835027734544942],
            [30.159340768408036, -0.833631876345154],
            [30.154637504889052, -0.831999833252116],
            [30.150435317143977, -0.829701627456096],
            [30.147680651291545, -0.829173660245589],
            [30.14868019233513, -0.826329345631055],
            [30.14571150645952, -0.826183757337996],
            [30.143099644889475, -0.825249469928336],
            [30.140797865585817, -0.822450605271288],
            [30.13878000511593, -0.821182045997409],
            [30.13862762748754, -0.820874720775177],
            [30.139557324517803, -0.820166099941006],
            [30.14366633630667, -0.819834337577064],
            [30.143718593103358, -0.819070818935508],
            [30.139465548136805, -0.815599664174039],
            [30.13915745384212, -0.814667044092227],
            [30.13801827597582, -0.813494756781576],
            [30.137234229989083, -0.809799901333106],
            [30.13648998475935, -0.811273593695339],
            [30.135352297198096, -0.811781763691735],
            [30.133213051875448, -0.814266629072584],
            [30.132499574842498, -0.815652756413968],
            [30.130289667141266, -0.817300792798127],
            [30.12919617309876, -0.818710550457548],
            [30.128174810180287, -0.818877167334553],
            [30.125206574360618, -0.818181715902835],
            [30.123196706201806, -0.818181947644556],
            [30.12318967508806, -0.822058192397593],
            [30.122499547964292, -0.823994187271798],
            [30.12068804578654, -0.826261105919223],
            [30.122330295483298, -0.828177847167966],
            [30.122756673646396, -0.829732136433743],
            [30.12159225042566, -0.837051572527329],
            [30.123771683679195, -0.838339528245681],
            [30.126123793791557, -0.837145892751207],
            [30.12975354359657, -0.83813895321504],
            [30.12786698088861, -0.842124727800441],
            [30.125145186189037, -0.843846626187709],
            [30.120671921925506, -0.845904115805906],
            [30.115595185623782, -0.84895341800849],
            [30.11535069564449, -0.8494575115456],
            [30.12038161517178, -0.849580748651911],
            [30.12222507940733, -0.851222422247792],
            [30.123978925913537, -0.85614865322348],
            [30.1259844067005, -0.859253376115653],
            [30.127443885169576, -0.859570025375103],
            [30.128576200805416, -0.861691132455122],
            [30.12710619408122, -0.866502926640679],
            [30.12738722213639, -0.868466741239101],
            [30.130003407297902, -0.867765149506309],
            [30.136560144979658, -0.865546730749717],
            [30.140386839630917, -0.86167658229146],
            [30.14202234387824, -0.858658445644929],
            [30.146381354115743, -0.855420723552708],
            [30.148286458051157, -0.852182275664891],
            [30.15493700949299, -0.845655683241319],
            [30.156110422154775, -0.840847913933704],
            [30.158175029155423, -0.837325695611836],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 269,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "RWASHAMAIRE TOWN COUNCIL",
        Population: 7708,
        Key: "NTUNGAMORWASHAMAIRE TOWN COUNCIL",
        Dist2: "Ntungamo",
        "Sub Country": "Rwashamaire T.C",
        id2_original: "Ntungamo Rwashamaire T.C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.267201911272053, -0.873362412524252],
            [30.26520493214093, -0.872722868327673],
            [30.264170380157434, -0.871818703799135],
            [30.262052769860077, -0.873432508005903],
            [30.261602154252333, -0.87247577045229],
            [30.260627975344132, -0.872905441401354],
            [30.259701871575036, -0.872546112060332],
            [30.260700565507324, -0.869830038322393],
            [30.26051263615324, -0.868147231915303],
            [30.26468802445844, -0.868054223840713],
            [30.26407234790882, -0.865922754937897],
            [30.26605673355794, -0.864227555046225],
            [30.26506001412267, -0.862959591419866],
            [30.264367716669188, -0.860124555831895],
            [30.260732340715553, -0.860440640042458],
            [30.253861038174094, -0.858782467495574],
            [30.25071460804309, -0.858801982999369],
            [30.246574141744553, -0.855213587045502],
            [30.24510070345598, -0.85774585610416],
            [30.24476202152586, -0.862856647181238],
            [30.244056846722785, -0.864391728635901],
            [30.244172236219356, -0.867108632637168],
            [30.243070412997483, -0.876203256792456],
            [30.243238322497156, -0.878348145414226],
            [30.242548572665804, -0.879236391197337],
            [30.239312045105052, -0.880728489360672],
            [30.238332808681832, -0.882578338982051],
            [30.237900162074688, -0.885806683816033],
            [30.23879832554353, -0.887815430094319],
            [30.24114415912704, -0.889274030667206],
            [30.242824860311224, -0.890968380282436],
            [30.245993032367046, -0.891207004147234],
            [30.246540152189144, -0.891876778795777],
            [30.246263417182735, -0.895813996408268],
            [30.245093783733342, -0.89760700903728],
            [30.242907789184972, -0.898782179018009],
            [30.241958322930262, -0.899019872732552],
            [30.240473044846244, -0.897542081386487],
            [30.239391208241166, -0.897413592251368],
            [30.239159016198105, -0.898474538485226],
            [30.23852290567067, -0.899080850052892],
            [30.23955277204164, -0.90243145379441],
            [30.242129284006936, -0.906464615935643],
            [30.2432688759966, -0.90718278294591],
            [30.2443792727395, -0.908819069844526],
            [30.248637315932328, -0.913083089528256],
            [30.250792314111813, -0.914692328022975],
            [30.254128928368246, -0.906904155971236],
            [30.25780938537608, -0.902258822600935],
            [30.264981547180906, -0.897601735675436],
            [30.26720631391526, -0.895623628935449],
            [30.270358816657577, -0.891795537817665],
            [30.267710042414194, -0.888953012338588],
            [30.26647240470116, -0.885838966307055],
            [30.26621595634881, -0.881703572518281],
            [30.265369270837333, -0.881351649755264],
            [30.26566016059767, -0.877667264652684],
            [30.26618324689266, -0.876950340393838],
            [30.267201911272053, -0.873362412524252],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 270,
        District: "NTUNGAMO",
        County: "NTUNGAMO MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 7738,
        Key: "NTUNGAMOCENTRAL DIVISION",
        Dist2: "Ntungamo",
        "Sub Country": "Central Division",
        id2_original: "Ntungamo Central Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.250792314111813, -0.914692328022975],
            [30.25228677746962, -0.915696634954298],
            [30.254042502353062, -0.916274263198087],
            [30.25665088384972, -0.918288603713033],
            [30.2584069168553, -0.91862709123187],
            [30.262170104209265, -0.91780987839755],
            [30.2644725599443, -0.91776686090315],
            [30.26589760598853, -0.917076285122957],
            [30.269267549538633, -0.917537721082943],
            [30.278205910583125, -0.916229051381616],
            [30.282442983503948, -0.91613025741693],
            [30.282941111905412, -0.91639436337024],
            [30.284294782308734, -0.915847124862481],
            [30.288977274981725, -0.910762777255839],
            [30.292147617367263, -0.90956160101715],
            [30.29751268053584, -0.909094411946173],
            [30.298260271990028, -0.914843691024443],
            [30.2992879069458, -0.914888125914754],
            [30.300784958349947, -0.914148017390582],
            [30.299741065684135, -0.912425641208012],
            [30.29981341240388, -0.910967126242185],
            [30.29775190459095, -0.904103142832436],
            [30.29820488276793, -0.901855852379032],
            [30.297968258437255, -0.900612309382312],
            [30.298801641696006, -0.897887082834126],
            [30.2987674239685, -0.895184530354252],
            [30.298171860698062, -0.894435210303122],
            [30.297951158107505, -0.890572307046072],
            [30.298284888523757, -0.889425018377228],
            [30.299069195021918, -0.888613483727174],
            [30.302980233393523, -0.885440103585073],
            [30.30746761737667, -0.882520126973331],
            [30.30751122609213, -0.882115602484662],
            [30.309511142714236, -0.881765474381986],
            [30.30939915064609, -0.880991519124335],
            [30.307445119070398, -0.877106861578276],
            [30.304022635754247, -0.872449507656823],
            [30.302193065761173, -0.867226882299556],
            [30.298628869615722, -0.860535071972642],
            [30.296727190058167, -0.849410166550486],
            [30.29183832292336, -0.849689979864377],
            [30.289999692522326, -0.846819889637709],
            [30.28840932861805, -0.841559008344662],
            [30.28363802400452, -0.842077437507215],
            [30.281168270522542, -0.842738942868639],
            [30.278231088563903, -0.844601909666906],
            [30.27601907521167, -0.846588121755991],
            [30.273371858646964, -0.849808587555553],
            [30.27206761085565, -0.848942797494506],
            [30.27091640903927, -0.851231554411388],
            [30.271168249932547, -0.854905492028248],
            [30.270883207306348, -0.856288938235627],
            [30.27197189446379, -0.860503212323078],
            [30.267477072430076, -0.861385673318854],
            [30.266407731390593, -0.862030481166713],
            [30.266762918965746, -0.863584906875398],
            [30.2696590784586, -0.86597803274316],
            [30.26925329147844, -0.866663889022097],
            [30.269622825148666, -0.866890949056134],
            [30.269087510986022, -0.868552508816018],
            [30.267201911272053, -0.873362412524252],
            [30.26618324689266, -0.876950340393838],
            [30.26566016059767, -0.877667264652684],
            [30.265369270837333, -0.881351649755264],
            [30.26621595634881, -0.881703572518281],
            [30.26647240470116, -0.885838966307055],
            [30.267710042414194, -0.888953012338588],
            [30.270358816657577, -0.891795537817665],
            [30.26720631391526, -0.895623628935449],
            [30.264981547180906, -0.897601735675436],
            [30.25780938537608, -0.902258822600935],
            [30.254128928368246, -0.906904155971236],
            [30.250792314111813, -0.914692328022975],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 271,
        District: "NTUNGAMO",
        County: "NTUNGAMO MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 5748,
        Key: "NTUNGAMOEASTERN DIVISION",
        Dist2: "Ntungamo",
        "Sub Country": "Eastern Division",
        id2_original: "Ntungamo Eastern Division",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.505859836408764, -0.978415307325724],
            [30.505757874929074, -0.977259065484002],
            [30.506187818505524, -0.976255271270271],
            [30.505306663738285, -0.972392615968431],
            [30.50536175112643, -0.966205536564933],
            [30.506678203429235, -0.960630842005325],
            [30.504825018523963, -0.957677689520069],
            [30.504614448929804, -0.956346757900653],
            [30.506044640523974, -0.953047476652116],
            [30.506257887097686, -0.950652231225172],
            [30.50758252395102, -0.947033475407982],
            [30.504838179741206, -0.939259762664368],
            [30.50452475843687, -0.933776743019228],
            [30.50738452178768, -0.92716785655722],
            [30.5027789132249, -0.925343204347559],
            [30.50078288720633, -0.925867918184536],
            [30.49781153872419, -0.92818554221474],
            [30.494835864853957, -0.936625307562902],
            [30.492933357948015, -0.939278465770096],
            [30.48970232268692, -0.939252222320855],
            [30.48573429609201, -0.939942878199485],
            [30.483240190180986, -0.939319298593543],
            [30.478941832394845, -0.936853004544383],
            [30.474808069324983, -0.936802187354216],
            [30.474954174017736, -0.93180420168443],
            [30.47440819595435, -0.931182037088111],
            [30.473362464437145, -0.931755226622264],
            [30.47264991356727, -0.931515571619589],
            [30.469604366039306, -0.937970212788789],
            [30.466346128893097, -0.941952933409484],
            [30.46724654533666, -0.945449145078042],
            [30.468150785010074, -0.94498430053634],
            [30.470172176757355, -0.946538946708005],
            [30.473968600878493, -0.947873895237137],
            [30.474420045631263, -0.947802482656606],
            [30.474943298114578, -0.946989780135295],
            [30.47717667609924, -0.946752269264986],
            [30.477793768393756, -0.947589723330922],
            [30.478743966775436, -0.947733903871596],
            [30.48140505871798, -0.947401046329018],
            [30.482094460003022, -0.946803688997333],
            [30.482877893338706, -0.947593437356623],
            [30.483566968535264, -0.947450453202444],
            [30.48577595007342, -0.94812166967389],
            [30.48599644425485, -0.950325355920316],
            [30.486811362642936, -0.950291020745208],
            [30.48757348434684, -0.957087468292071],
            [30.487475064924308, -0.957875335282099],
            [30.483632156580505, -0.963530516504086],
            [30.480240115372695, -0.962194486349542],
            [30.476774539872387, -0.958030820008015],
            [30.47487465065719, -0.957048926062638],
            [30.473211954406256, -0.956593326357308],
            [30.468650878925384, -0.956543562135237],
            [30.467743388248945, -0.957852582339279],
            [30.467955914373817, -0.964265884712546],
            [30.468595141156946, -0.967279550453992],
            [30.468287773599315, -0.969156541279533],
            [30.46615458112504, -0.969129601963463],
            [30.463376448582434, -0.967118729120747],
            [30.46242604538488, -0.967261500482516],
            [30.460026085610593, -0.96661718128661],
            [30.45598760414794, -0.963620081141959],
            [30.452290983753187, -0.962886247798142],
            [30.448821170899667, -0.960901642393424],
            [30.447392753478194, -0.961794032524563],
            [30.44734100782289, -0.963223973817841],
            [30.445448252129342, -0.966542670349615],
            [30.444342197842513, -0.966515641194054],
            [30.443071927030154, -0.96497892201511],
            [30.439005048024754, -0.962774602075854],
            [30.436106543929007, -0.962362878747016],
            [30.428833622590346, -0.963022870339817],
            [30.424762808065694, -0.966142449666697],
            [30.423774574116578, -0.965672338257987],
            [30.423390863234523, -0.964650991807442],
            [30.423308568571354, -0.961419187812343],
            [30.42252724358163, -0.95787942384182],
            [30.420556749480028, -0.956132264696872],
            [30.4188465467236, -0.955772275432359],
            [30.409370841323923, -0.956165576775117],
            [30.409817234849847, -0.957394168711853],
            [30.41248410565462, -0.961943247715317],
            [30.41470877716755, -0.967329505833376],
            [30.41583432309943, -0.968970265420796],
            [30.41706751684672, -0.969953497821061],
            [30.417421454865313, -0.971652436142866],
            [30.41832181740995, -0.973017664387872],
            [30.42046821332226, -0.974612729629153],
            [30.422931392034684, -0.979114553617248],
            [30.429427602130943, -0.984574914921461],
            [30.42962957754281, -0.986469155554107],
            [30.42871133582904, -0.990154225090349],
            [30.430640094202523, -0.995070109668815],
            [30.430704652528732, -0.996388959815582],
            [30.42903641636744, -1.00271334602832],
            [30.42938860267119, -1.007312889354751],
            [30.43139022339738, -1.007306594035955],
            [30.43663945419996, -1.008721648286497],
            [30.44554362266979, -1.014898428881689],
            [30.447467284002382, -1.015784764283344],
            [30.44878775357111, -1.015914449844582],
            [30.452518422810073, -1.02077554661635],
            [30.45496367294606, -1.023049314069391],
            [30.45845379760645, -1.025921770405524],
            [30.46180258852657, -1.027263629036856],
            [30.46801168627821, -1.031824225965471],
            [30.47009607058816, -1.036901219093037],
            [30.470118521283748, -1.038551317081221],
            [30.471707898837845, -1.041589702031345],
            [30.47192079057701, -1.042761670336221],
            [30.47040489521315, -1.044664406782326],
            [30.46944534177613, -1.048522993686458],
            [30.467178197916567, -1.052771818981403],
            [30.46610823793785, -1.054515358910871],
            [30.466084141528672, -1.055166104984692],
            [30.468554504966743, -1.055475431392849],
            [30.468674407599295, -1.053631690199446],
            [30.469007342108213, -1.052945041511752],
            [30.469625098257755, -1.052773814701012],
            [30.47026608753545, -1.053370874315787],
            [30.47066872771718, -1.055504274995004],
            [30.472746284830947, -1.057331740376861],
            [30.478104966367745, -1.057510268996062],
            [30.478686974958848, -1.056027664985446],
            [30.47834841340301, -1.053188399826648],
            [30.47908222739568, -1.051936752118363],
            [30.481325872225707, -1.050948513016168],
            [30.483462623825115, -1.047952775705439],
            [30.484504765674448, -1.043022960437192],
            [30.485564732793918, -1.041964736067909],
            [30.485161817727747, -1.040414376839888],
            [30.486235591953175, -1.039945250612106],
            [30.486201055323768, -1.039131693245222],
            [30.487106057666846, -1.038877585468286],
            [30.487461785129486, -1.03554005390109],
            [30.490082683751268, -1.033587653984791],
            [30.49007115207796, -1.031672512538713],
            [30.490633469598055, -1.029167543309475],
            [30.492511951061722, -1.026702961069395],
            [30.49612419000689, -1.02353139173362],
            [30.49685499015176, -1.022207105178534],
            [30.504619712159027, -1.015453453883088],
            [30.50491920867813, -1.008916229144373],
            [30.506967359441077, -1.006171758659644],
            [30.50707675986966, -1.004986048341742],
            [30.50452219823831, -1.000989845815072],
            [30.50248803424433, -0.995106626965214],
            [30.501653682601702, -0.989990109427076],
            [30.50316261602212, -0.984775936277125],
            [30.50527100331644, -0.982112522912671],
            [30.50586825002971, -0.980678510066616],
            [30.505859836408764, -0.978415307325724],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 272,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "KITWE TOWN COUNCIL",
        Population: 18039,
        Key: "NTUNGAMOKITWE TOWN COUNCIL",
        Dist2: "Ntungamo",
        "Sub Country": "Kitwe T.C",
        id2_original: "Ntungamo Kitwe T.C",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.394876381382517, -0.810883551943536],
            [30.3940621546972, -0.810294255908818],
            [30.389747638015734, -0.812588149705564],
            [30.3867879146317, -0.815981246892886],
            [30.384452508692032, -0.816763186900251],
            [30.384238912673645, -0.820596048848031],
            [30.38286176659701, -0.823151951893787],
            [30.38111754464077, -0.825290735149855],
            [30.3740447859137, -0.825374955147359],
            [30.372028212729617, -0.826222628788493],
            [30.367351753142096, -0.827102956200099],
            [30.364925426915864, -0.828879958064667],
            [30.363761429496595, -0.830530789635694],
            [30.361526905261634, -0.827863773249308],
            [30.360103813951447, -0.826880329254196],
            [30.356223251824204, -0.826454053854131],
            [30.350276083944767, -0.827291281845508],
            [30.347979036067727, -0.828294095883632],
            [30.344624530065776, -0.827436496437796],
            [30.34060598581253, -0.827119927200587],
            [30.336952713621823, -0.828479134880476],
            [30.33577680005028, -0.828381218868967],
            [30.332521998061708, -0.829120278958291],
            [30.330098175440224, -0.830481596770859],
            [30.327532169272143, -0.831340670435305],
            [30.320453364883246, -0.831551057077216],
            [30.314254308499823, -0.830542552736695],
            [30.302356266292094, -0.826828210835794],
            [30.29509445441857, -0.825596389338751],
            [30.294210504992467, -0.825062291215806],
            [30.291507615338045, -0.833261213185861],
            [30.29188357016593, -0.841413087375799],
            [30.299495278537563, -0.840817986189724],
            [30.302890330898173, -0.840179085972774],
            [30.306912915773566, -0.840797054104411],
            [30.309994561202924, -0.842366060175708],
            [30.312534602466, -0.844711117666071],
            [30.315855481831896, -0.851480315364982],
            [30.31644772762399, -0.85380012478177],
            [30.316467883124037, -0.857593509020768],
            [30.316067244388776, -0.859835357838839],
            [30.31857030111331, -0.860120481532895],
            [30.32214285069258, -0.862197014458295],
            [30.325665570723082, -0.86225753429208],
            [30.325643343708, -0.864312234983096],
            [30.32752508425951, -0.868915883186299],
            [30.32756292219758, -0.872145609581334],
            [30.32797962999666, -0.873629230560835],
            [30.329245400249423, -0.874932428304181],
            [30.329410396512607, -0.87636929274881],
            [30.332093055208496, -0.876386346167718],
            [30.334359643010895, -0.875552004009102],
            [30.33631655009379, -0.875547551580164],
            [30.337907694634048, -0.874928946840119],
            [30.340494733057866, -0.875197288130348],
            [30.343626394885586, -0.876566916952747],
            [30.346628981383425, -0.876728479806597],
            [30.348330759739103, -0.879074876955152],
            [30.350500639409603, -0.880813280304078],
            [30.353703454994353, -0.88225482664585],
            [30.357434908462555, -0.888181941826262],
            [30.358517932640456, -0.894099892986526],
            [30.35550918639472, -0.894253944278826],
            [30.352421598609794, -0.895634821474597],
            [30.34739434510716, -0.901113500167372],
            [30.347179435751848, -0.902141485732031],
            [30.344780296139415, -0.903475909346184],
            [30.343330613798514, -0.904836204317206],
            [30.33921271677319, -0.904385269422841],
            [30.335816943963703, -0.905454536375544],
            [30.333404911730295, -0.907614038771877],
            [30.32941491144522, -0.909327812477533],
            [30.326644430752186, -0.911407495668054],
            [30.323437518849744, -0.914541650342363],
            [30.322029746510132, -0.916446290130664],
            [30.321345712658914, -0.922475102063405],
            [30.319728761317176, -0.925399487238453],
            [30.318037705252717, -0.926785916839755],
            [30.31559771744766, -0.93132290126575],
            [30.31563792154819, -0.935594684939143],
            [30.316087221124057, -0.936995526563],
            [30.318398236007138, -0.939643129156577],
            [30.32103081991416, -0.941418460400425],
            [30.324280213146412, -0.943482091103709],
            [30.32754245138889, -0.944792375526316],
            [30.33048878628195, -0.945392581374297],
            [30.33259737479889, -0.945711789271925],
            [30.34060926196838, -0.945381760843197],
            [30.348266656858765, -0.943855102758154],
            [30.35019111499698, -0.942519765562707],
            [30.351166187728857, -0.941086766312639],
            [30.351806412540288, -0.932226795922285],
            [30.357065086433117, -0.931651744503449],
            [30.35884522393275, -0.931822859920086],
            [30.366087602551758, -0.930020141388076],
            [30.368118427507827, -0.929055693304779],
            [30.373524721551313, -0.924367073920269],
            [30.37768936959898, -0.917868220081943],
            [30.38094626466216, -0.914570686481139],
            [30.381327527635058, -0.912944912945143],
            [30.383892451333196, -0.909966039840529],
            [30.386061959999466, -0.912039376869405],
            [30.388886058436857, -0.912667032820796],
            [30.390878549584777, -0.913914845314669],
            [30.393012188521777, -0.916215340352036],
            [30.39518035420668, -0.919388923584837],
            [30.395295997028164, -0.921852716667686],
            [30.39710618766559, -0.926556325806636],
            [30.39722149631378, -0.929283219220488],
            [30.395899722391267, -0.94222012811726],
            [30.396572058380812, -0.945582005782007],
            [30.399330129746506, -0.951555275672633],
            [30.400657036642567, -0.953519318813327],
            [30.40298173017249, -0.954634177415632],
            [30.403963765746127, -0.956394644009996],
            [30.40530152159587, -0.957330510401971],
            [30.40805980586231, -0.958102486564194],
            [30.409817234849847, -0.957394168711853],
            [30.409370841323923, -0.956165576775117],
            [30.408377287551694, -0.952475037915818],
            [30.40785590266584, -0.951780322011815],
            [30.407374254756594, -0.947796940809618],
            [30.4079225917959, -0.945932459995556],
            [30.407855324150812, -0.942775113052408],
            [30.409035731095397, -0.938508143477289],
            [30.411029441257188, -0.938799278032177],
            [30.41243055079233, -0.938395563742362],
            [30.4148771457063, -0.938769492997584],
            [30.41528361810101, -0.939576122051115],
            [30.417931284721636, -0.940446019723805],
            [30.41959335664348, -0.941563168437038],
            [30.421625421274644, -0.942060642124385],
            [30.422733062884575, -0.943363367885622],
            [30.425134435708827, -0.944171095264943],
            [30.428522604279415, -0.943119688871961],
            [30.42937347863509, -0.941917295770404],
            [30.432801715660606, -0.942064786390844],
            [30.43712783947383, -0.938767907683924],
            [30.438981575944688, -0.93778881244124],
            [30.444184577646134, -0.937433924816355],
            [30.4469646002441, -0.936790289860409],
            [30.44786793261908, -0.936001795628649],
            [30.4492485686506, -0.932200503019454],
            [30.449559415383323, -0.929402812370258],
            [30.450037983867794, -0.924596476473488],
            [30.449579398406822, -0.920103544615829],
            [30.450179541288573, -0.918372117441654],
            [30.4500060298948, -0.917378243855223],
            [30.450471924947248, -0.915507996663719],
            [30.450095179601917, -0.914213021090897],
            [30.453610197477143, -0.909041089273371],
            [30.454722239933655, -0.904454422998495],
            [30.457422197486988, -0.902063934803617],
            [30.45801577637897, -0.899941127946013],
            [30.458127360612, -0.89672930541251],
            [30.45961100555883, -0.892728996081162],
            [30.46022794334314, -0.889723226698652],
            [30.46098871577747, -0.888910672649017],
            [30.462723618610962, -0.88795530793657],
            [30.462947328761093, -0.887485280461342],
            [30.465597450477418, -0.886349086394808],
            [30.46669024383403, -0.88625555332105],
            [30.468720795702243, -0.884497003908822],
            [30.4743473036528, -0.885128699343247],
            [30.47653049905074, -0.883953312130102],
            [30.481051777367902, -0.883093339485249],
            [30.488700113646956, -0.883861834096764],
            [30.48403054503594, -0.878408610198074],
            [30.484773767084572, -0.876681218684507],
            [30.484154182863445, -0.873346933655376],
            [30.486326678428032, -0.869581228265598],
            [30.486637315853294, -0.866855179540988],
            [30.48843313703945, -0.861274041513876],
            [30.488151772116037, -0.856284851357519],
            [30.48560042286017, -0.854160425068937],
            [30.48554446051292, -0.852987298010063],
            [30.486825174240437, -0.847000452842067],
            [30.486234790655928, -0.844931026492833],
            [30.487087443675854, -0.843705893411097],
            [30.479585611839862, -0.842473852645771],
            [30.474305179852504, -0.841087531688886],
            [30.471553540424264, -0.839142474983151],
            [30.465091757362966, -0.832874655083989],
            [30.46335977585077, -0.832060079600274],
            [30.461911702392545, -0.831986837796809],
            [30.453327638692752, -0.834014908858771],
            [30.446811256028475, -0.834082976876756],
            [30.4436076229768, -0.833068603313797],
            [30.440024996096664, -0.831294774050643],
            [30.436075810766507, -0.828409011635334],
            [30.43501012048033, -0.826275303214191],
            [30.433011302497842, -0.82003765850534],
            [30.431661010658306, -0.81759647911016],
            [30.430261841484164, -0.816348313375759],
            [30.421624377432284, -0.813396340091971],
            [30.413258969960822, -0.811375481178894],
            [30.410006765001754, -0.811445696341335],
            [30.40497326371634, -0.812292029183185],
            [30.400305601330395, -0.814973288327627],
            [30.394876381382517, -0.810883551943536],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 273,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "NYAKYERA",
        Population: 38419,
        Key: "NTUNGAMONYAKYERA",
        Dist2: "Ntungamo",
        "Sub Country": "Nyakyera",
        id2_original: "Ntungamo Nyakyera",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.409817234849847, -0.957394168711853],
            [30.40805980586231, -0.958102486564194],
            [30.40530152159587, -0.957330510401971],
            [30.403963765746127, -0.956394644009996],
            [30.40298173017249, -0.954634177415632],
            [30.400657036642567, -0.953519318813327],
            [30.399330129746506, -0.951555275672633],
            [30.396572058380812, -0.945582005782007],
            [30.395899722391267, -0.94222012811726],
            [30.39722149631378, -0.929283219220488],
            [30.39710618766559, -0.926556325806636],
            [30.395295997028164, -0.921852716667686],
            [30.39518035420668, -0.919388923584837],
            [30.393012188521777, -0.916215340352036],
            [30.390878549584777, -0.913914845314669],
            [30.388886058436857, -0.912667032820796],
            [30.386061959999466, -0.912039376869405],
            [30.383892451333196, -0.909966039840529],
            [30.381327527635058, -0.912944912945143],
            [30.38094626466216, -0.914570686481139],
            [30.37768936959898, -0.917868220081943],
            [30.373524721551313, -0.924367073920269],
            [30.368118427507827, -0.929055693304779],
            [30.366087602551758, -0.930020141388076],
            [30.35884522393275, -0.931822859920086],
            [30.357065086433117, -0.931651744503449],
            [30.351806412540288, -0.932226795922285],
            [30.351166187728857, -0.941086766312639],
            [30.35019111499698, -0.942519765562707],
            [30.348266656858765, -0.943855102758154],
            [30.34060926196838, -0.945381760843197],
            [30.33259737479889, -0.945711789271925],
            [30.33048878628195, -0.945392581374297],
            [30.322324216955195, -0.95093995971831],
            [30.321407525733623, -0.952407434659194],
            [30.319990033622613, -0.953339412969913],
            [30.319048295574294, -0.955231689677249],
            [30.320265011524366, -0.956824691133732],
            [30.320497296992198, -0.959510202809456],
            [30.320424231620244, -0.960945035697973],
            [30.319638215628107, -0.963024115228928],
            [30.317224242135367, -0.966594528100885],
            [30.311081352915128, -0.971807260970575],
            [30.309036857397064, -0.974170641885055],
            [30.305717968697795, -0.979939362281873],
            [30.305431648667287, -0.981062816803378],
            [30.305628532428106, -0.98478220559166],
            [30.30638697193764, -0.987496158415106],
            [30.30762311575237, -0.988711303050833],
            [30.30805083510017, -0.990425005138805],
            [30.30950764647116, -0.991296779574367],
            [30.31040325602962, -0.99291636808596],
            [30.314516001216827, -0.99379142022265],
            [30.318846413587234, -0.993234577218318],
            [30.32530955130798, -0.994360597839113],
            [30.330621311142554, -0.996064330800024],
            [30.334621537848818, -0.995773905330786],
            [30.33621110674406, -0.996446969633196],
            [30.34046834953798, -0.996760493521592],
            [30.34216341927514, -0.997238475795945],
            [30.346489373306778, -0.996708052421547],
            [30.34695730034839, -0.997494800866574],
            [30.355022666023384, -0.997806866910535],
            [30.357753466333662, -0.999205849667694],
            [30.35873034108601, -0.999034561599174],
            [30.362615339992487, -1.000139519749206],
            [30.366812047116007, -1.000471396661627],
            [30.368500211503576, -1.001332371441059],
            [30.37085475245712, -1.00375290574146],
            [30.37242220842334, -1.004207666419099],
            [30.373696452484197, -1.005279278002315],
            [30.375095084465812, -1.007469783712839],
            [30.377804472532972, -1.009961270243437],
            [30.38201966698506, -1.011819903365263],
            [30.38385027004073, -1.013325229403831],
            [30.3861020589971, -1.018541969914838],
            [30.389110505205544, -1.021998360044146],
            [30.392814430700188, -1.024820459535801],
            [30.397373743686455, -1.027260445020969],
            [30.39857271521469, -1.028276831222962],
            [30.402017924110872, -1.032180852276527],
            [30.40428815637839, -1.03614007715303],
            [30.405472838405398, -1.040026920965253],
            [30.40706835594445, -1.041579876984172],
            [30.408276006096678, -1.044114961784421],
            [30.413999097313297, -1.047359801707151],
            [30.41903933955663, -1.049629190406242],
            [30.419409264892302, -1.050116948506579],
            [30.423108966508494, -1.051428872733431],
            [30.42792373341213, -1.053822919958881],
            [30.431142620755608, -1.053968957722327],
            [30.434763395492624, -1.052668673866638],
            [30.43541741303689, -1.052980731838329],
            [30.435392617738444, -1.054652776970519],
            [30.436295193731926, -1.054798134785568],
            [30.436961484059644, -1.052882355979296],
            [30.43748386966873, -1.05336204357252],
            [30.437840423581406, -1.052955618286236],
            [30.437545251552102, -1.049999879958967],
            [30.43847178741087, -1.049837955276338],
            [30.43925655384644, -1.048374409370828],
            [30.440063708993847, -1.04923370338151],
            [30.441964813629614, -1.048159715616136],
            [30.443009928902512, -1.048142495997236],
            [30.443341707279664, -1.04957081150631],
            [30.44407756943116, -1.050457165082854],
            [30.44457642277308, -1.050529881362824],
            [30.44519460562237, -1.049644638836477],
            [30.444719851384576, -1.049092915169263],
            [30.445100116329204, -1.048686505494385],
            [30.445670162055666, -1.04885869985261],
            [30.445669643727737, -1.049672143329187],
            [30.447641154722255, -1.050026253659558],
            [30.447191063730607, -1.047947080440963],
            [30.44758323943755, -1.047558755172588],
            [30.449008234277816, -1.047966644271624],
            [30.44903124821709, -1.049177794427085],
            [30.449648528259495, -1.049756750427454],
            [30.450219370791643, -1.048772044016174],
            [30.455871798731376, -1.050765098905568],
            [30.45656109221857, -1.050259515936341],
            [30.457427826330566, -1.050675988439046],
            [30.45992056680237, -1.05330818969004],
            [30.460664153567002, -1.05350764305379],
            [30.4628185175359, -1.053672096774104],
            [30.46395949921927, -1.052570390508613],
            [30.46621644899697, -1.052382382385697],
            [30.467178197916567, -1.052771818981403],
            [30.46944534177613, -1.048522993686458],
            [30.47040489521315, -1.044664406782326],
            [30.47192079057701, -1.042761670336221],
            [30.471707898837845, -1.041589702031345],
            [30.470118521283748, -1.038551317081221],
            [30.47009607058816, -1.036901219093037],
            [30.46801168627821, -1.031824225965471],
            [30.46180258852657, -1.027263629036856],
            [30.45845379760645, -1.025921770405524],
            [30.45496367294606, -1.023049314069391],
            [30.452518422810073, -1.02077554661635],
            [30.44878775357111, -1.015914449844582],
            [30.447467284002382, -1.015784764283344],
            [30.44554362266979, -1.014898428881689],
            [30.43663945419996, -1.008721648286497],
            [30.43139022339738, -1.007306594035955],
            [30.42938860267119, -1.007312889354751],
            [30.42903641636744, -1.00271334602832],
            [30.430704652528732, -0.996388959815582],
            [30.430640094202523, -0.995070109668815],
            [30.42871133582904, -0.990154225090349],
            [30.42962957754281, -0.986469155554107],
            [30.429427602130943, -0.984574914921461],
            [30.422931392034684, -0.979114553617248],
            [30.42046821332226, -0.974612729629153],
            [30.41832181740995, -0.973017664387872],
            [30.417421454865313, -0.971652436142866],
            [30.41706751684672, -0.969953497821061],
            [30.41583432309943, -0.968970265420796],
            [30.41470877716755, -0.967329505833376],
            [30.41248410565462, -0.961943247715317],
            [30.409817234849847, -0.957394168711853],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 274,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "RUHAAMA",
        Population: 42885,
        Key: "NTUNGAMORUHAAMA",
        Dist2: "Ntungamo",
        "Sub Country": "Ruhaama",
        id2_original: "Ntungamo Ruhaama",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.602914384745347, -0.867352882632638],
            [30.603254889357174, -0.866506500628443],
            [30.60302528176719, -0.864328569886046],
            [30.60345471330392, -0.862999330176716],
            [30.60337492404206, -0.862353497631316],
            [30.60293399676464, -0.862151412154772],
            [30.596258949163328, -0.860734544630585],
            [30.594754925035947, -0.861439912854996],
            [30.592429600888703, -0.861095369720207],
            [30.5905247394984, -0.861618854096636],
            [30.58835972779844, -0.861395493489951],
            [30.583769705904192, -0.859979945161309],
            [30.583068684910963, -0.858950299746886],
            [30.58076392409891, -0.857818735441533],
            [30.57685411552093, -0.858684005234065],
            [30.567772775022522, -0.858456233324453],
            [30.567855248450446, -0.854823854138006],
            [30.570505130316572, -0.849013637148632],
            [30.569945160094328, -0.846833821884227],
            [30.570668365881815, -0.844412651603385],
            [30.575882222825147, -0.841913562970304],
            [30.580375566231904, -0.837476685384878],
            [30.593693322084324, -0.8272331911567],
            [30.592751875988466, -0.819712455855879],
            [30.589530425751427, -0.820623476091893],
            [30.579985406344452, -0.819560104597438],
            [30.573940597881833, -0.819782411286357],
            [30.57075702421045, -0.820304745188326],
            [30.568022646808696, -0.821640868170978],
            [30.567141791180465, -0.822598475186548],
            [30.56579735635657, -0.826126210057235],
            [30.562271885684684, -0.82584098686609],
            [30.558347389651793, -0.826602791302918],
            [30.557246544695303, -0.827109871608838],
            [30.55568315270744, -0.828878271205083],
            [30.550171371296766, -0.827828589014245],
            [30.548540491576535, -0.826166803399711],
            [30.54438595766065, -0.82633565204675],
            [30.540379842497682, -0.827327447841608],
            [30.532367431610385, -0.828054602201849],
            [30.52006801674383, -0.827902276412558],
            [30.517307858591753, -0.828623645223715],
            [30.515518189068654, -0.830204302489749],
            [30.512671373136033, -0.835345550775525],
            [30.50988740423902, -0.843569022966429],
            [30.50721949498177, -0.845501590443479],
            [30.505110654936544, -0.845934087523438],
            [30.493861322128105, -0.845746037627235],
            [30.487087443675854, -0.843705893411097],
            [30.486234790655928, -0.844931026492833],
            [30.486825174240437, -0.847000452842067],
            [30.48554446051292, -0.852987298010063],
            [30.48560042286017, -0.854160425068937],
            [30.488151772116037, -0.856284851357519],
            [30.48843313703945, -0.861274041513876],
            [30.486637315853294, -0.866855179540988],
            [30.486326678428032, -0.869581228265598],
            [30.484154182863445, -0.873346933655376],
            [30.484773767084572, -0.876681218684507],
            [30.48403054503594, -0.878408610198074],
            [30.488700113646956, -0.883861834096764],
            [30.490626246244858, -0.886103316074507],
            [30.491427926160622, -0.887821185807593],
            [30.494931247072504, -0.888896470197134],
            [30.503495160662204, -0.893054310200825],
            [30.50460304571558, -0.896940929752524],
            [30.505129262639322, -0.900773927771293],
            [30.507716140264694, -0.907110210862851],
            [30.50940638604877, -0.909985863158486],
            [30.510144795822427, -0.912807633659835],
            [30.51008902122307, -0.917012864103356],
            [30.50738452178768, -0.92716785655722],
            [30.50452475843687, -0.933776743019228],
            [30.504838179741206, -0.939259762664368],
            [30.50758252395102, -0.947033475407982],
            [30.506257887097686, -0.950652231225172],
            [30.506044640523974, -0.953047476652116],
            [30.504614448929804, -0.956346757900653],
            [30.504825018523963, -0.957677689520069],
            [30.506678203429235, -0.960630842005325],
            [30.50536175112643, -0.966205536564933],
            [30.505306663738285, -0.972392615968431],
            [30.506187818505524, -0.976255271270271],
            [30.505757874929074, -0.977259065484002],
            [30.505859836408764, -0.978415307325724],
            [30.50991168659946, -0.97282195060547],
            [30.516202274123806, -0.966092715223988],
            [30.522804843851368, -0.962527219407737],
            [30.524378643720134, -0.959229190795897],
            [30.525502129815067, -0.95778379178153],
            [30.5298145713882, -0.954668504463751],
            [30.530264324613306, -0.953584163703978],
            [30.530852260288658, -0.94757372921824],
            [30.532516958884383, -0.94264872282872],
            [30.53433043825408, -0.939040560964365],
            [30.5357976826588, -0.938131596854267],
            [30.539573023320195, -0.932530120420425],
            [30.542405167069283, -0.930286478328899],
            [30.543099347391617, -0.930201455909682],
            [30.554455133256166, -0.930207137903277],
            [30.556611794217243, -0.930746047916728],
            [30.561313879146567, -0.930946308962462],
            [30.56316718532438, -0.930586032363884],
            [30.56492585578367, -0.928403428732433],
            [30.5668643500982, -0.913992786706305],
            [30.56898544136728, -0.906532913484352],
            [30.570581538319693, -0.90381811053176],
            [30.57157848413046, -0.903047221890619],
            [30.574061815647966, -0.903187768313352],
            [30.576514920652773, -0.902680181704648],
            [30.581176364900344, -0.902828891017369],
            [30.584707844403177, -0.901006465663893],
            [30.587167098376113, -0.900519982960056],
            [30.591186222042683, -0.898271872031293],
            [30.5951562051683, -0.896719737730037],
            [30.596406815452358, -0.895183880053332],
            [30.59709561845936, -0.895157215022287],
            [30.597596741843983, -0.894181298285393],
            [30.59740796088702, -0.893629775576251],
            [30.59819346304282, -0.892916184952362],
            [30.600995488975354, -0.888118132277181],
            [30.60061904995557, -0.886563120324684],
            [30.600650828757058, -0.883173388731736],
            [30.60008287161362, -0.882260047933546],
            [30.59970909699695, -0.879602241795432],
            [30.598821832787422, -0.878182493979478],
            [30.598706582529744, -0.876727087580936],
            [30.59966225973632, -0.874259964952545],
            [30.601187794921493, -0.871919754364627],
            [30.6014767658804, -0.870247660063737],
            [30.60270310458378, -0.868874461242212],
            [30.602914384745347, -0.867352882632638],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 275,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "RUKONI EAST",
        Population: 23602,
        Key: "NTUNGAMORUKONI EAST",
        Dist2: "Ntungamo",
        "Sub Country": "Rukoni East",
        id2_original: "Ntungamo Rukoni East",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.488700113646956, -0.883861834096764],
            [30.481051777367902, -0.883093339485249],
            [30.47653049905074, -0.883953312130102],
            [30.4743473036528, -0.885128699343247],
            [30.468720795702243, -0.884497003908822],
            [30.46669024383403, -0.88625555332105],
            [30.465597450477418, -0.886349086394808],
            [30.462947328761093, -0.887485280461342],
            [30.462723618610962, -0.88795530793657],
            [30.46098871577747, -0.888910672649017],
            [30.46022794334314, -0.889723226698652],
            [30.45961100555883, -0.892728996081162],
            [30.458127360612, -0.89672930541251],
            [30.45801577637897, -0.899941127946013],
            [30.457422197486988, -0.902063934803617],
            [30.454722239933655, -0.904454422998495],
            [30.453610197477143, -0.909041089273371],
            [30.450095179601917, -0.914213021090897],
            [30.450471924947248, -0.915507996663719],
            [30.4500060298948, -0.917378243855223],
            [30.450179541288573, -0.918372117441654],
            [30.449579398406822, -0.920103544615829],
            [30.450037983867794, -0.924596476473488],
            [30.449559415383323, -0.929402812370258],
            [30.4492485686506, -0.932200503019454],
            [30.44786793261908, -0.936001795628649],
            [30.4469646002441, -0.936790289860409],
            [30.444184577646134, -0.937433924816355],
            [30.438981575944688, -0.93778881244124],
            [30.43712783947383, -0.938767907683924],
            [30.432801715660606, -0.942064786390844],
            [30.42937347863509, -0.941917295770404],
            [30.428522604279415, -0.943119688871961],
            [30.425134435708827, -0.944171095264943],
            [30.422733062884575, -0.943363367885622],
            [30.421625421274644, -0.942060642124385],
            [30.41959335664348, -0.941563168437038],
            [30.417931284721636, -0.940446019723805],
            [30.41528361810101, -0.939576122051115],
            [30.4148771457063, -0.938769492997584],
            [30.41243055079233, -0.938395563742362],
            [30.411029441257188, -0.938799278032177],
            [30.409035731095397, -0.938508143477289],
            [30.407855324150812, -0.942775113052408],
            [30.4079225917959, -0.945932459995556],
            [30.407374254756594, -0.947796940809618],
            [30.40785590266584, -0.951780322011815],
            [30.408377287551694, -0.952475037915818],
            [30.409370841323923, -0.956165576775117],
            [30.4188465467236, -0.955772275432359],
            [30.420556749480028, -0.956132264696872],
            [30.42252724358163, -0.95787942384182],
            [30.423308568571354, -0.961419187812343],
            [30.423390863234523, -0.964650991807442],
            [30.423774574116578, -0.965672338257987],
            [30.424762808065694, -0.966142449666697],
            [30.428833622590346, -0.963022870339817],
            [30.436106543929007, -0.962362878747016],
            [30.439005048024754, -0.962774602075854],
            [30.443071927030154, -0.96497892201511],
            [30.444342197842513, -0.966515641194054],
            [30.445448252129342, -0.966542670349615],
            [30.44734100782289, -0.963223973817841],
            [30.447392753478194, -0.961794032524563],
            [30.448821170899667, -0.960901642393424],
            [30.452290983753187, -0.962886247798142],
            [30.45598760414794, -0.963620081141959],
            [30.460026085610593, -0.96661718128661],
            [30.46242604538488, -0.967261500482516],
            [30.463376448582434, -0.967118729120747],
            [30.46615458112504, -0.969129601963463],
            [30.468287773599315, -0.969156541279533],
            [30.468595141156946, -0.967279550453992],
            [30.467955914373817, -0.964265884712546],
            [30.467743388248945, -0.957852582339279],
            [30.468650878925384, -0.956543562135237],
            [30.473211954406256, -0.956593326357308],
            [30.47487465065719, -0.957048926062638],
            [30.476774539872387, -0.958030820008015],
            [30.480240115372695, -0.962194486349542],
            [30.483632156580505, -0.963530516504086],
            [30.487475064924308, -0.957875335282099],
            [30.48757348434684, -0.957087468292071],
            [30.486811362642936, -0.950291020745208],
            [30.48599644425485, -0.950325355920316],
            [30.48577595007342, -0.94812166967389],
            [30.483566968535264, -0.947450453202444],
            [30.482877893338706, -0.947593437356623],
            [30.482094460003022, -0.946803688997333],
            [30.48140505871798, -0.947401046329018],
            [30.478743966775436, -0.947733903871596],
            [30.477793768393756, -0.947589723330922],
            [30.47717667609924, -0.946752269264986],
            [30.474943298114578, -0.946989780135295],
            [30.474420045631263, -0.947802482656606],
            [30.473968600878493, -0.947873895237137],
            [30.470172176757355, -0.946538946708005],
            [30.468150785010074, -0.94498430053634],
            [30.46724654533666, -0.945449145078042],
            [30.466346128893097, -0.941952933409484],
            [30.469604366039306, -0.937970212788789],
            [30.47264991356727, -0.931515571619589],
            [30.473362464437145, -0.931755226622264],
            [30.47440819595435, -0.931182037088111],
            [30.474954174017736, -0.93180420168443],
            [30.474808069324983, -0.936802187354216],
            [30.478941832394845, -0.936853004544383],
            [30.483240190180986, -0.939319298593543],
            [30.48573429609201, -0.939942878199485],
            [30.48970232268692, -0.939252222320855],
            [30.492933357948015, -0.939278465770096],
            [30.494835864853957, -0.936625307562902],
            [30.49781153872419, -0.92818554221474],
            [30.50078288720633, -0.925867918184536],
            [30.5027789132249, -0.925343204347559],
            [30.50738452178768, -0.92716785655722],
            [30.51008902122307, -0.917012864103356],
            [30.510144795822427, -0.912807633659835],
            [30.50940638604877, -0.909985863158486],
            [30.507716140264694, -0.907110210862851],
            [30.505129262639322, -0.900773927771293],
            [30.50460304571558, -0.896940929752524],
            [30.503495160662204, -0.893054310200825],
            [30.494931247072504, -0.888896470197134],
            [30.491427926160622, -0.887821185807593],
            [30.490626246244858, -0.886103316074507],
            [30.488700113646956, -0.883861834096764],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 276,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "RUKONI WEST",
        Population: 16858,
        Key: "NTUNGAMORUKONI WEST",
        Dist2: "Ntungamo",
        "Sub Country": "Rukoni West",
        id2_original: "Ntungamo Rukoni West",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.31563792154819, -0.935594684939143],
            [30.31290468321023, -0.938376024412542],
            [30.308416916544754, -0.93951460650562],
            [30.305090157705283, -0.942305836465085],
            [30.302168855265972, -0.943591176701876],
            [30.300315481714474, -0.945070084264284],
            [30.29758643940718, -0.9445142787467],
            [30.29588831988964, -0.945240148138643],
            [30.29420116610677, -0.94667155857084],
            [30.292750514483675, -0.948773118603004],
            [30.29178526752439, -0.951796450833704],
            [30.291755937530354, -0.956125179772538],
            [30.291171491809855, -0.958360083764975],
            [30.28993413437122, -0.960273572031998],
            [30.286135633345154, -0.960475819964885],
            [30.28160440888117, -0.959659249240352],
            [30.273788480207752, -0.960824611911332],
            [30.272933478093385, -0.960656554462503],
            [30.268713331229137, -0.957941703420284],
            [30.26433052641642, -0.954404985214873],
            [30.259965365414157, -0.952625996901035],
            [30.254403365484173, -0.949445430612121],
            [30.2506071910947, -0.948217716967305],
            [30.247219183322525, -0.947886728609504],
            [30.243644627805207, -0.946909267049052],
            [30.239689616900442, -0.945305537489525],
            [30.23707733941041, -0.945710416833136],
            [30.23476443896356, -0.943163757841864],
            [30.23065449921502, -0.940554354526629],
            [30.221270664519434, -0.930178114466814],
            [30.219585153755222, -0.929005223604309],
            [30.21742433898427, -0.928166689949211],
            [30.21246470257139, -0.927882366443918],
            [30.2087628018794, -0.930026536550295],
            [30.203094208756095, -0.932574185930882],
            [30.20340207218376, -0.935751643704909],
            [30.20510646553526, -0.937064680404323],
            [30.20482242542895, -0.937709941042738],
            [30.20571020077983, -0.940086669240845],
            [30.205307817516307, -0.94118594041408],
            [30.204218968662115, -0.942142269083335],
            [30.204147981991714, -0.942835177059462],
            [30.20322481391696, -0.943576374473539],
            [30.203272192861675, -0.944603702863298],
            [30.206432516336857, -0.950491233065214],
            [30.20650355061794, -0.951303517104659],
            [30.205534781364392, -0.953874830832668],
            [30.206444479201505, -0.955496607345143],
            [30.206065775528863, -0.957479870396009],
            [30.21038595249494, -0.96219606087417],
            [30.212670353889404, -0.966626745186529],
            [30.213226713782518, -0.97177519932039],
            [30.21393686974387, -0.972491560127505],
            [30.214244649628196, -0.976648634911032],
            [30.213830416687728, -0.980794159299932],
            [30.212978236181673, -0.982156495273039],
            [30.213285968455292, -0.983207580647955],
            [30.214124870963143, -0.983594575355418],
            [30.21570050698834, -0.98440083813663],
            [30.21669473090377, -0.984352498841459],
            [30.217535091377318, -0.988162853598527],
            [30.21848197317898, -0.989309155083109],
            [30.218316264551767, -0.990026010627287],
            [30.219357829682668, -0.991506761672949],
            [30.220269210064266, -0.992067725820952],
            [30.22301517393658, -0.992305126628821],
            [30.22445918521307, -0.991898161888546],
            [30.225122007145462, -0.991300481875778],
            [30.22571380737316, -0.992160279740679],
            [30.22642397680923, -0.991514796798204],
            [30.22746555451656, -0.991466425272045],
            [30.228199394560345, -0.991919977798869],
            [30.230531112017466, -0.99061653775637],
            [30.23237755686318, -0.99078275513212],
            [30.234484400851855, -0.992167351116576],
            [30.23519457208452, -0.992023600900924],
            [30.23547864003864, -0.993074723573553],
            [30.23604677684513, -0.993289441664017],
            [30.235975761428655, -0.99448411375475],
            [30.237973995506227, -0.995615818528387],
            [30.239633161378094, -0.996190402870739],
            [30.240769439482662, -0.997671127800055],
            [30.241408597095514, -0.997575195983214],
            [30.242118780006308, -0.99838716508468],
            [30.24308935128033, -0.998434408396687],
            [30.24346811064852, -0.999700517947703],
            [30.24422564196129, -0.999007204871319],
            [30.244983160697675, -1.00027310762046],
            [30.24609577268608, -1.000702564404867],
            [30.246734936587142, -1.000391606089879],
            [30.247752859856398, -1.001418431272899],
            [30.248131625512798, -1.000868682472454],
            [30.250608312192142, -1.001261498900824],
            [30.25212846916373, -1.000499494374434],
            [30.254999889053646, -1.001007922549391],
            [30.257988495969027, -1.002640625966354],
            [30.259466965721508, -1.006014635204012],
            [30.2625166715509, -1.009756450244166],
            [30.26931663168911, -1.017443597135962],
            [30.27448010392478, -1.021401482227567],
            [30.27701850576248, -1.026182860702858],
            [30.278739089450333, -1.028418398178381],
            [30.284674542400158, -1.032364730924191],
            [30.289204415797947, -1.042931248660591],
            [30.293525333874122, -1.045992587395893],
            [30.29553053348839, -1.048873652499671],
            [30.299613423167127, -1.052747572155535],
            [30.30069387457005, -1.053190239265535],
            [30.304720149724616, -1.05282155658918],
            [30.30562247957973, -1.053228292657528],
            [30.307271860103214, -1.055416063725044],
            [30.309456584433782, -1.056205815553114],
            [30.31497884020065, -1.056554853217222],
            [30.324419454710405, -1.058291967370674],
            [30.330286597969376, -1.058031633292904],
            [30.333446120147308, -1.057459371037531],
            [30.336903859643407, -1.054843549502274],
            [30.339873706142395, -1.053745318645145],
            [30.343389245040473, -1.053627328717965],
            [30.345609732200785, -1.054333420692185],
            [30.347011509184206, -1.053808172116787],
            [30.347582203494333, -1.052828399697881],
            [30.348936444327844, -1.052350925996239],
            [30.35025481004221, -1.052267835068763],
            [30.352592518363934, -1.053469475598427],
            [30.353546488771496, -1.052486474174499],
            [30.358405540822005, -1.052187461982743],
            [30.359665519636124, -1.053221418113985],
            [30.3597534844654, -1.053826439861046],
            [30.36085350027687, -1.053766473984969],
            [30.362606528417864, -1.054671459661171],
            [30.363074541697728, -1.055433488983079],
            [30.36534853521133, -1.056119438351248],
            [30.36798758339513, -1.054455470290096],
            [30.36877458394082, -1.054828505271175],
            [30.369365592752747, -1.056455465241934],
            [30.37180859530389, -1.056031502834709],
            [30.372883605611154, -1.057110487959008],
            [30.37349755110723, -1.056993452008005],
            [30.375745588699, -1.058285510483692],
            [30.37607562075123, -1.058760448661176],
            [30.37590760704704, -1.059755523883931],
            [30.376627627408507, -1.061137884135525],
            [30.377921188841214, -1.062747711971328],
            [30.381008826931815, -1.063373951801978],
            [30.38231455155349, -1.064540942395644],
            [30.382076609394304, -1.065209537293802],
            [30.38509244514423, -1.066649124936852],
            [30.38623187723378, -1.067870205931944],
            [30.38613770684252, -1.066577714958992],
            [30.38677930068643, -1.066216748170195],
            [30.38780058814642, -1.066461641295437],
            [30.388845108734635, -1.067438619717144],
            [30.389724001543975, -1.06751167240851],
            [30.390936020203423, -1.066509502427864],
            [30.390792333775387, -1.068371181165904],
            [30.391480840338385, -1.068950192859524],
            [30.392193972418283, -1.06811027850512],
            [30.39294242535679, -1.067975348046337],
            [30.39327555120686, -1.06690012281813],
            [30.39838570034558, -1.062222821390696],
            [30.398979399611818, -1.062602916777622],
            [30.39830391143392, -1.063848688908496],
            [30.398823114311924, -1.064392315734304],
            [30.400356393873174, -1.063634406681946],
            [30.40207869424155, -1.063617788018174],
            [30.402625544569055, -1.062642150237454],
            [30.40181847565994, -1.061728635254867],
            [30.402579019023882, -1.061232190164636],
            [30.404691747875983, -1.063430199107531],
            [30.405143182747278, -1.063313086153614],
            [30.40561908503196, -1.061948752965608],
            [30.406141791339607, -1.061831700132294],
            [30.4073528676663, -1.062474418705574],
            [30.408611878096576, -1.062330871942701],
            [30.409395501875107, -1.062765356339395],
            [30.41071429428919, -1.06226937576483],
            [30.41323113117017, -1.063925453782006],
            [30.414899170600435, -1.062706722608554],
            [30.4164426792778, -1.063620863319737],
            [30.417987081778882, -1.062953344971918],
            [30.42026750543327, -1.063117944591585],
            [30.4216693300274, -1.062495493151397],
            [30.4229517927748, -1.063020777978251],
            [30.42204891045577, -1.063426734902264],
            [30.42204861131677, -1.063788258877327],
            [30.424153428706163, -1.064292964835223],
            [30.423826392535414, -1.064990128463946],
            [30.42696549960021, -1.064361783673613],
            [30.428295644922876, -1.064579813872263],
            [30.42846231295082, -1.063911130817817],
            [30.43033967780857, -1.062882352553159],
            [30.429627931829188, -1.061354309547746],
            [30.430531539986976, -1.059899920427166],
            [30.430437302222103, -1.058480850844292],
            [30.433323861419503, -1.058112687034788],
            [30.434725730031058, -1.057445025589378],
            [30.434536029199265, -1.056947767873965],
            [30.432841129243695, -1.056326586093979],
            [30.434763395492624, -1.052668673866638],
            [30.431142620755608, -1.053968957722327],
            [30.42792373341213, -1.053822919958881],
            [30.423108966508494, -1.051428872733431],
            [30.419409264892302, -1.050116948506579],
            [30.41903933955663, -1.049629190406242],
            [30.413999097313297, -1.047359801707151],
            [30.408276006096678, -1.044114961784421],
            [30.40706835594445, -1.041579876984172],
            [30.405472838405398, -1.040026920965253],
            [30.40428815637839, -1.03614007715303],
            [30.402017924110872, -1.032180852276527],
            [30.39857271521469, -1.028276831222962],
            [30.397373743686455, -1.027260445020969],
            [30.392814430700188, -1.024820459535801],
            [30.389110505205544, -1.021998360044146],
            [30.3861020589971, -1.018541969914838],
            [30.38385027004073, -1.013325229403831],
            [30.38201966698506, -1.011819903365263],
            [30.377804472532972, -1.009961270243437],
            [30.375095084465812, -1.007469783712839],
            [30.373696452484197, -1.005279278002315],
            [30.37242220842334, -1.004207666419099],
            [30.37085475245712, -1.00375290574146],
            [30.368500211503576, -1.001332371441059],
            [30.366812047116007, -1.000471396661627],
            [30.362615339992487, -1.000139519749206],
            [30.35873034108601, -0.999034561599174],
            [30.357753466333662, -0.999205849667694],
            [30.355022666023384, -0.997806866910535],
            [30.34695730034839, -0.997494800866574],
            [30.346489373306778, -0.996708052421547],
            [30.34216341927514, -0.997238475795945],
            [30.34046834953798, -0.996760493521592],
            [30.33621110674406, -0.996446969633196],
            [30.334621537848818, -0.995773905330786],
            [30.330621311142554, -0.996064330800024],
            [30.32530955130798, -0.994360597839113],
            [30.318846413587234, -0.993234577218318],
            [30.314516001216827, -0.99379142022265],
            [30.31040325602962, -0.99291636808596],
            [30.30950764647116, -0.991296779574367],
            [30.30805083510017, -0.990425005138805],
            [30.30762311575237, -0.988711303050833],
            [30.30638697193764, -0.987496158415106],
            [30.305628532428106, -0.98478220559166],
            [30.305431648667287, -0.981062816803378],
            [30.305717968697795, -0.979939362281873],
            [30.309036857397064, -0.974170641885055],
            [30.311081352915128, -0.971807260970575],
            [30.317224242135367, -0.966594528100885],
            [30.319638215628107, -0.963024115228928],
            [30.320424231620244, -0.960945035697973],
            [30.320497296992198, -0.959510202809456],
            [30.320265011524366, -0.956824691133732],
            [30.319048295574294, -0.955231689677249],
            [30.319990033622613, -0.953339412969913],
            [30.321407525733623, -0.952407434659194],
            [30.322324216955195, -0.95093995971831],
            [30.33048878628195, -0.945392581374297],
            [30.32754245138889, -0.944792375526316],
            [30.324280213146412, -0.943482091103709],
            [30.32103081991416, -0.941418460400425],
            [30.318398236007138, -0.939643129156577],
            [30.316087221124057, -0.936995526563],
            [30.31563792154819, -0.935594684939143],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 277,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "RWEIKINIRO",
        Population: 36651,
        Key: "NTUNGAMORWEIKINIRO",
        Dist2: "Ntungamo",
        "Sub Country": "Rweikiniro",
        id2_original: "Ntungamo Rweikiniro",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.27601907521167, -0.846588121755991],
            [30.275862921065823, -0.841775911012725],
            [30.276873566184662, -0.839481774479011],
            [30.27706138863919, -0.838089951766043],
            [30.276875484087768, -0.836697866278335],
            [30.27623814736, -0.835557588131403],
            [30.275535190497354, -0.834752383433326],
            [30.27447910050662, -0.835118696373338],
            [30.273931041046723, -0.83629876577591],
            [30.27121443681288, -0.836178825613536],
            [30.270188301145293, -0.8366599389597],
            [30.26956154207998, -0.836200421507831],
            [30.267186245551805, -0.83594602055412],
            [30.264856210639216, -0.833818094454999],
            [30.26141661621356, -0.827192568183845],
            [30.260537982118976, -0.826881125976878],
            [30.25747235634609, -0.829126552135369],
            [30.256639571365337, -0.831230062635464],
            [30.257944975288442, -0.8326655799145],
            [30.25827511693512, -0.836132781079035],
            [30.26021872985015, -0.83918508379484],
            [30.260051357543045, -0.842405642855169],
            [30.26081980608151, -0.844041645447858],
            [30.260584338780898, -0.845049058572273],
            [30.25795527986305, -0.846761984270929],
            [30.253455887201174, -0.848373142147654],
            [30.25185091489377, -0.850143849535734],
            [30.246956322795654, -0.852305378850002],
            [30.24723239933699, -0.854274846040351],
            [30.246574141744553, -0.855213587045502],
            [30.25071460804309, -0.858801982999369],
            [30.253861038174094, -0.858782467495574],
            [30.260732340715553, -0.860440640042458],
            [30.264367716669188, -0.860124555831895],
            [30.26506001412267, -0.862959591419866],
            [30.26605673355794, -0.864227555046225],
            [30.26407234790882, -0.865922754937897],
            [30.26468802445844, -0.868054223840713],
            [30.26051263615324, -0.868147231915303],
            [30.260700565507324, -0.869830038322393],
            [30.259701871575036, -0.872546112060332],
            [30.260627975344132, -0.872905441401354],
            [30.261602154252333, -0.87247577045229],
            [30.262052769860077, -0.873432508005903],
            [30.264170380157434, -0.871818703799135],
            [30.26520493214093, -0.872722868327673],
            [30.267201911272053, -0.873362412524252],
            [30.269087510986022, -0.868552508816018],
            [30.269622825148666, -0.866890949056134],
            [30.26925329147844, -0.866663889022097],
            [30.2696590784586, -0.86597803274316],
            [30.266762918965746, -0.863584906875398],
            [30.266407731390593, -0.862030481166713],
            [30.267477072430076, -0.861385673318854],
            [30.27197189446379, -0.860503212323078],
            [30.270883207306348, -0.856288938235627],
            [30.271168249932547, -0.854905492028248],
            [30.27091640903927, -0.851231554411388],
            [30.27206761085565, -0.848942797494506],
            [30.273371858646964, -0.849808587555553],
            [30.27601907521167, -0.846588121755991],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 278,
        District: "NTUNGAMO",
        County: "NTUNGAMO MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 5233,
        Key: "NTUNGAMOWESTERN DIVISION",
        Dist2: "Ntungamo",
        "Sub Country": "Western Division",
        id2_original: "Ntungamo Western Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.2989951504863, -1.155881708515413],
            [30.299181412567194, -1.155004257188129],
            [30.30033895469286, -1.154634131262365],
            [30.30092184632788, -1.153306218133431],
            [30.301991201740417, -1.152638482888901],
            [30.301920449530325, -1.151942549681267],
            [30.30266841827693, -1.15155563633751],
            [30.302824209503385, -1.150434193853717],
            [30.304345050092863, -1.149432504596386],
            [30.30546260730692, -1.147924345032143],
            [30.3062109865836, -1.147699122404551],
            [30.306520665506433, -1.1464342003718],
            [30.30730508968391, -1.14576618509815],
            [30.307281900573138, -1.14490762384784],
            [30.313719786651248, -1.143901514723448],
            [30.3142195472916, -1.14249216435024],
            [30.318603114773985, -1.141095491389512],
            [30.319173662658724, -1.140354962856029],
            [30.321906269481065, -1.138974802019496],
            [30.32214443442243, -1.13811647495093],
            [30.322619493189094, -1.138234404068878],
            [30.322999977322617, -1.137611179737375],
            [30.32474621420005, -1.137124788451838],
            [30.325649392064786, -1.136384563367235],
            [30.32807212592819, -1.136504302305183],
            [30.328428873876973, -1.135908164566862],
            [30.32985425229786, -1.135593178308281],
            [30.331851037392845, -1.133444120751331],
            [30.33356144855844, -1.133328216742589],
            [30.333728387877574, -1.132415588259418],
            [30.33651987297857, -1.131713244619619],
            [30.336710306835663, -1.131189246313966],
            [30.33794568438743, -1.130928298847925],
            [30.339750505794438, -1.13159873625136],
            [30.340938843066336, -1.130614742785421],
            [30.34200744479234, -1.131094714360396],
            [30.342838192394044, -1.132098642777572],
            [30.344679100024322, -1.131973812101839],
            [30.344965854839455, -1.129506828918835],
            [30.34463431361753, -1.128141856762547],
            [30.342344707384314, -1.124280737287191],
            [30.342702083255457, -1.122826022951218],
            [30.341777470689706, -1.120267562390338],
            [30.3421582521656, -1.11914725829223],
            [30.341909894040704, -1.117628729146059],
            [30.340581002766182, -1.115639269498423],
            [30.34093799775167, -1.114753918445891],
            [30.340107178284725, -1.113822301853992],
            [30.3405351419743, -1.113271402674521],
            [30.33981292702858, -1.109963023590815],
            [30.34021706470184, -1.109538625881825],
            [30.340217574046623, -1.108652951462585],
            [30.33891206951221, -1.107332298576891],
            [30.338794449498785, -1.105660256383821],
            [30.338402634914576, -1.105479153810035],
            [30.33998530115519, -1.10085337862536],
            [30.33927308266194, -1.100328565588824],
            [30.339345267684937, -1.098973005997449],
            [30.340010849241875, -1.098295789111192],
            [30.3396784878581, -1.09798821664478],
            [30.33960839141816, -1.096343330186682],
            [30.3410350948541, -1.094021963252179],
            [30.341012114152488, -1.092874179266552],
            [30.342378773296506, -1.091664367551428],
            [30.3431626468067, -1.091592763261778],
            [30.344066849649195, -1.089162470053103],
            [30.346609085496514, -1.0883513399031],
            [30.34801058759545, -1.08837065378996],
            [30.34883094977414, -1.086997668209948],
            [30.34880850087521, -1.085063609619351],
            [30.349475269106648, -1.08236196237467],
            [30.34894180727012, -1.080987784012592],
            [30.349488541714962, -1.080319482666361],
            [30.350224708395334, -1.080582217420002],
            [30.35122312115493, -1.079335906015868],
            [30.35041668555807, -1.077590947581764],
            [30.351272652463088, -1.07639873452767],
            [30.350561051112443, -1.074816536672937],
            [30.35088237040473, -1.073777495222811],
            [30.34900574396213, -1.073875274039378],
            [30.348792787544244, -1.072727317160473],
            [30.349434841325575, -1.071489729052262],
            [30.349388312187113, -1.070125015077708],
            [30.35095633948186, -1.069647384173907],
            [30.351597567711455, -1.06986484187081],
            [30.352572057436713, -1.068853476407864],
            [30.351040926645656, -1.067360948688357],
            [30.351326550481808, -1.066385136951409],
            [30.35284708205085, -1.065997834298117],
            [30.35199368073431, -1.063204481470886],
            [30.352255166838788, -1.063060105739634],
            [30.353916661143895, -1.064850981904656],
            [30.354486698785514, -1.064977999709852],
            [30.355557401670968, -1.06217726217818],
            [30.358729585602852, -1.060471873264424],
            [30.35972627449542, -1.061900676203735],
            [30.35953528188623, -1.063454987440717],
            [30.361459171390887, -1.063718732275686],
            [30.36136335348942, -1.065038147695448],
            [30.36447460379729, -1.065727686676296],
            [30.36566148490012, -1.067048209564589],
            [30.36590010169409, -1.065421629696866],
            [30.366612815159048, -1.065060733727177],
            [30.367954686191094, -1.065432431866924],
            [30.369308980923563, -1.065054009202612],
            [30.37030557369637, -1.066772031791507],
            [30.369924807491866, -1.067774891472921],
            [30.370352057919078, -1.068371748802473],
            [30.37144458088279, -1.068472102813625],
            [30.372085294377715, -1.069475843034047],
            [30.373344153891008, -1.069639604322845],
            [30.374437209555673, -1.069116354955094],
            [30.374794432713248, -1.067751960567954],
            [30.37232528918733, -1.065725387387001],
            [30.373560741299265, -1.065364936042089],
            [30.375770847528155, -1.063640614767311],
            [30.376627627408507, -1.061137884135525],
            [30.37590760704704, -1.059755523883931],
            [30.37607562075123, -1.058760448661176],
            [30.375745588699, -1.058285510483692],
            [30.37349755110723, -1.056993452008005],
            [30.372883605611154, -1.057110487959008],
            [30.37180859530389, -1.056031502834709],
            [30.369365592752747, -1.056455465241934],
            [30.36877458394082, -1.054828505271175],
            [30.36798758339513, -1.054455470290096],
            [30.36534853521133, -1.056119438351248],
            [30.363074541697728, -1.055433488983079],
            [30.362606528417864, -1.054671459661171],
            [30.36085350027687, -1.053766473984969],
            [30.3597534844654, -1.053826439861046],
            [30.359665519636124, -1.053221418113985],
            [30.358405540822005, -1.052187461982743],
            [30.353546488771496, -1.052486474174499],
            [30.352592518363934, -1.053469475598427],
            [30.35025481004221, -1.052267835068763],
            [30.348936444327844, -1.052350925996239],
            [30.347582203494333, -1.052828399697881],
            [30.347011509184206, -1.053808172116787],
            [30.345609732200785, -1.054333420692185],
            [30.343389245040473, -1.053627328717965],
            [30.339873706142395, -1.053745318645145],
            [30.336903859643407, -1.054843549502274],
            [30.333446120147308, -1.057459371037531],
            [30.330286597969376, -1.058031633292904],
            [30.324419454710405, -1.058291967370674],
            [30.31497884020065, -1.056554853217222],
            [30.309456584433782, -1.056205815553114],
            [30.307271860103214, -1.055416063725044],
            [30.30562247957973, -1.053228292657528],
            [30.304720149724616, -1.05282155658918],
            [30.30069387457005, -1.053190239265535],
            [30.299613423167127, -1.052747572155535],
            [30.29553053348839, -1.048873652499671],
            [30.293525333874122, -1.045992587395893],
            [30.289204415797947, -1.042931248660591],
            [30.284674542400158, -1.032364730924191],
            [30.278739089450333, -1.028418398178381],
            [30.27701850576248, -1.026182860702858],
            [30.27448010392478, -1.021401482227567],
            [30.26931663168911, -1.017443597135962],
            [30.2625166715509, -1.009756450244166],
            [30.259466965721508, -1.006014635204012],
            [30.257988495969027, -1.002640625966354],
            [30.254999889053646, -1.001007922549391],
            [30.25212846916373, -1.000499494374434],
            [30.250608312192142, -1.001261498900824],
            [30.248131625512798, -1.000868682472454],
            [30.247752859856398, -1.001418431272899],
            [30.246734936587142, -1.000391606089879],
            [30.24609577268608, -1.000702564404867],
            [30.244983160697675, -1.00027310762046],
            [30.24422564196129, -0.999007204871319],
            [30.24346811064852, -0.999700517947703],
            [30.24308935128033, -0.998434408396687],
            [30.242118780006308, -0.99838716508468],
            [30.241408597095514, -0.997575195983214],
            [30.240769439482662, -0.997671127800055],
            [30.239633161378094, -0.996190402870739],
            [30.237973995506227, -0.995615818528387],
            [30.235991845763817, -1.001702049850492],
            [30.23473256224572, -1.002578022078897],
            [30.234247361499488, -1.003941894843308],
            [30.234381819534608, -1.005712766944076],
            [30.233462598657205, -1.016111071820331],
            [30.233557992553845, -1.017779039828543],
            [30.231550774425134, -1.02460441153782],
            [30.231424178445373, -1.029331205215365],
            [30.23071612903339, -1.033725677427046],
            [30.23015078508911, -1.034407342778978],
            [30.230150515594545, -1.036277167287246],
            [30.22911407625065, -1.040340526838618],
            [30.225867223454024, -1.048655214330068],
            [30.21905394669004, -1.060009488055156],
            [30.217473100436216, -1.060766345351497],
            [30.213861696025923, -1.061505420668957],
            [30.212602153793036, -1.062197646838446],
            [30.207443932210204, -1.066400965219733],
            [30.202844235460315, -1.072841517928016],
            [30.20182623942753, -1.073370335237104],
            [30.2016416571962, -1.072685400133681],
            [30.200502689535654, -1.072336432555342],
            [30.199853790591877, -1.071680598442911],
            [30.199486329335013, -1.071873840755333],
            [30.19688275741842, -1.070661525582924],
            [30.19592122050121, -1.073422359222411],
            [30.193055892985573, -1.078040499082831],
            [30.191343468695422, -1.080453695851961],
            [30.188681385012778, -1.082363917658116],
            [30.18336023958014, -1.082908853396727],
            [30.182213753918983, -1.082717682929357],
            [30.180942466213743, -1.099400376295129],
            [30.180325116102726, -1.10255867479306],
            [30.178981822139242, -1.105138470056233],
            [30.178879654047027, -1.106108431317541],
            [30.179194860303834, -1.112273574290192],
            [30.181642421805012, -1.116692602083816],
            [30.180163619675874, -1.123098656878025],
            [30.177579218705766, -1.129086331970146],
            [30.177826370393262, -1.132922766881761],
            [30.177564612997557, -1.134905156266649],
            [30.180694409922772, -1.140969493524332],
            [30.18623503533888, -1.144283399540547],
            [30.188060216163503, -1.146989349524265],
            [30.189691033899972, -1.147762312492796],
            [30.190838115144135, -1.14910184467698],
            [30.191441515317084, -1.151302449698358],
            [30.19232696492971, -1.152040027726099],
            [30.193054760209996, -1.152207517980776],
            [30.19336164267733, -1.153140297880457],
            [30.188903037122632, -1.162913536501328],
            [30.18716786299792, -1.170095889386051],
            [30.187055308584394, -1.173048412564868],
            [30.188962772394056, -1.181155523056168],
            [30.19010083994268, -1.188078282498343],
            [30.19111857276908, -1.189729164362042],
            [30.196370732977822, -1.193261894776721],
            [30.200071826982683, -1.194700816322931],
            [30.206279146968406, -1.195461342441523],
            [30.211194815339688, -1.195036852392799],
            [30.212905814003477, -1.194273808725931],
            [30.213546690991773, -1.194370207551808],
            [30.215662070772265, -1.193225111354289],
            [30.219160855192012, -1.188830053756949],
            [30.220710911689483, -1.185341203554664],
            [30.22175722890823, -1.184505622073019],
            [30.224821547632377, -1.183768057056093],
            [30.227922797894493, -1.18234911936007],
            [30.233169500837864, -1.176485606319828],
            [30.234928587217112, -1.175411738512896],
            [30.246285857996824, -1.165108100766273],
            [30.248328769785076, -1.164608361676558],
            [30.250560712261876, -1.164587009540562],
            [30.25720235960261, -1.156686001313264],
            [30.297745735859912, -1.156166278187626],
            [30.2989951504863, -1.155881708515413],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 279,
        District: "NTUNGAMO",
        County: "RUSHENYI",
        Subcounty: "NGOMA",
        Population: 27482,
        Key: "NTUNGAMONGOMA",
        Dist2: "Ntungamo",
        "Sub Country": "Ngoma",
        id2_original: "Ntungamo Ngoma",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.182213753918983, -1.082717682929357],
            [30.18336023958014, -1.082908853396727],
            [30.188681385012778, -1.082363917658116],
            [30.191343468695422, -1.080453695851961],
            [30.193055892985573, -1.078040499082831],
            [30.19592122050121, -1.073422359222411],
            [30.19688275741842, -1.070661525582924],
            [30.199486329335013, -1.071873840755333],
            [30.199853790591877, -1.071680598442911],
            [30.200502689535654, -1.072336432555342],
            [30.2016416571962, -1.072685400133681],
            [30.20182623942753, -1.073370335237104],
            [30.202844235460315, -1.072841517928016],
            [30.207443932210204, -1.066400965219733],
            [30.212602153793036, -1.062197646838446],
            [30.213861696025923, -1.061505420668957],
            [30.217473100436216, -1.060766345351497],
            [30.21905394669004, -1.060009488055156],
            [30.225867223454024, -1.048655214330068],
            [30.22911407625065, -1.040340526838618],
            [30.230150515594545, -1.036277167287246],
            [30.23015078508911, -1.034407342778978],
            [30.23071612903339, -1.033725677427046],
            [30.231424178445373, -1.029331205215365],
            [30.231550774425134, -1.02460441153782],
            [30.233557992553845, -1.017779039828543],
            [30.233462598657205, -1.016111071820331],
            [30.220046840200535, -1.010519282524002],
            [30.21639323922642, -1.00863662334597],
            [30.21690063285172, -1.010944239897682],
            [30.218639688596785, -1.015286688975941],
            [30.218234372333832, -1.015863612293263],
            [30.216040707969583, -1.01688043053098],
            [30.213914022891217, -1.018474573680798],
            [30.20885369701311, -1.018538088907793],
            [30.20743627047912, -1.019182037817113],
            [30.20692939877501, -1.020166348335183],
            [30.21006829653235, -1.030736963611719],
            [30.20810208649637, -1.032443193211515],
            [30.2064032968356, -1.034718972339769],
            [30.20497097353928, -1.038643011021867],
            [30.204939706777473, -1.040350939291008],
            [30.199609887212457, -1.041784463219508],
            [30.198657353211054, -1.04172368517014],
            [30.194968064865648, -1.03947309479576],
            [30.189760878811626, -1.039255290079266],
            [30.18619875418121, -1.0383913938248],
            [30.183805342226997, -1.039103550063101],
            [30.18323929939344, -1.03961242391689],
            [30.181566895947512, -1.045693526082609],
            [30.181897120239224, -1.048787452931391],
            [30.181651444483727, -1.049400554528357],
            [30.18218975722282, -1.050486694030762],
            [30.182236920571857, -1.052566396374597],
            [30.182631486695776, -1.052684194134908],
            [30.182003224748986, -1.057080071689408],
            [30.176087517667465, -1.048025722872021],
            [30.171599558762512, -1.040201236370837],
            [30.168802521174726, -1.038940259604298],
            [30.16330096079535, -1.032822834144361],
            [30.161577712704375, -1.029135836098947],
            [30.160590252204727, -1.028001161091795],
            [30.159472547666976, -1.028216046627531],
            [30.158644150058045, -1.027650444276887],
            [30.15541712487639, -1.02398963453978],
            [30.151587883501282, -1.020644196038369],
            [30.151208114426726, -1.019724464306951],
            [30.16177858498507, -1.016274232312783],
            [30.161627563812733, -1.012969394086338],
            [30.16219484542309, -1.009510277317897],
            [30.165801891207597, -1.011975761011723],
            [30.164964997332717, -1.006932958894507],
            [30.1625884647227, -1.002954645955564],
            [30.160756958860215, -1.001673875802839],
            [30.159688175674493, -1.001452873707469],
            [30.15507130583133, -1.00150048702472],
            [30.151225788779918, -0.999380074771387],
            [30.15374080028426, -0.997729922603603],
            [30.156409219784596, -0.99664788967258],
            [30.160049824831468, -0.993806349773236],
            [30.165680194639442, -0.991073476541558],
            [30.167339378477617, -0.992371540793606],
            [30.16867116322569, -0.994696322238887],
            [30.17405228198335, -1.000845708869655],
            [30.174770421272605, -1.000897966675295],
            [30.175796883028635, -1.000330850610567],
            [30.176157647345068, -0.998368969776351],
            [30.1757997423662, -0.996974471272405],
            [30.176007086110182, -0.994444453719708],
            [30.178317500918634, -0.992122783394834],
            [30.183603601275443, -0.989390546482038],
            [30.190068771883656, -0.987640385761506],
            [30.191146619070594, -0.986970015112497],
            [30.186790761919738, -0.981492778162786],
            [30.187817733020527, -0.980305991049955],
            [30.192386231280587, -0.97685013547521],
            [30.19310429241642, -0.977005650768058],
            [30.196845678556727, -0.981191433099563],
            [30.19796745785261, -0.984687737439158],
            [30.198770873313492, -0.985632832905924],
            [30.199440871886694, -0.985835773613368],
            [30.200047219432122, -0.988074121330397],
            [30.20137218506886, -0.98971627373044],
            [30.201259629757004, -0.992136002817069],
            [30.201702184781734, -0.991607911198201],
            [30.20441082814553, -0.990775787044087],
            [30.205626618830856, -0.990804630329736],
            [30.20676051370496, -0.989637395450726],
            [30.20855716403614, -0.988971370606711],
            [30.20927636603239, -0.988054108943636],
            [30.211100880307068, -0.98710996264466],
            [30.21323020373741, -0.985136935604697],
            [30.214059887733814, -0.984275385363634],
            [30.214124870963143, -0.983594575355418],
            [30.213285968455292, -0.983207580647955],
            [30.212978236181673, -0.982156495273039],
            [30.213830416687728, -0.980794159299932],
            [30.214244649628196, -0.976648634911032],
            [30.21393686974387, -0.972491560127505],
            [30.213226713782518, -0.97177519932039],
            [30.212670353889404, -0.966626745186529],
            [30.21038595249494, -0.96219606087417],
            [30.206065775528863, -0.957479870396009],
            [30.206444479201505, -0.955496607345143],
            [30.205534781364392, -0.953874830832668],
            [30.20650355061794, -0.951303517104659],
            [30.206432516336857, -0.950491233065214],
            [30.203272192861675, -0.944603702863298],
            [30.20322481391696, -0.943576374473539],
            [30.204147981991714, -0.942835177059462],
            [30.204218968662115, -0.942142269083335],
            [30.205307817516307, -0.94118594041408],
            [30.20571020077983, -0.940086669240845],
            [30.20482242542895, -0.937709941042738],
            [30.20510646553526, -0.937064680404323],
            [30.20340207218376, -0.935751643704909],
            [30.203094208756095, -0.932574185930882],
            [30.2087628018794, -0.930026536550295],
            [30.202189409432258, -0.924611046148419],
            [30.192282810936874, -0.920328451057696],
            [30.186175528239524, -0.916796180476449],
            [30.184731570861924, -0.916295340369012],
            [30.18189107008577, -0.916320957942865],
            [30.174742635482552, -0.918977231962082],
            [30.1728016600212, -0.919336774113672],
            [30.17097900885244, -0.919194519945169],
            [30.168943319519123, -0.918646236361138],
            [30.16308472462837, -0.915484176383462],
            [30.155723202453256, -0.914317941736802],
            [30.152953743144693, -0.91338785996626],
            [30.14995938341823, -0.911609784143417],
            [30.148420757982755, -0.910081691429131],
            [30.145852364092693, -0.90593818638477],
            [30.14381670440375, -0.905222697569604],
            [30.140915498175637, -0.905224455353185],
            [30.14077356076749, -0.907072154014082],
            [30.141980875848095, -0.91020111546217],
            [30.14204010267309, -0.911311996174475],
            [30.143697086537145, -0.913532838609313],
            [30.143200137623673, -0.916543373014947],
            [30.141152776479835, -0.919017277298995],
            [30.13612307147482, -0.923571414677178],
            [30.13536566233292, -0.924527484961578],
            [30.134916001634284, -0.926940696071899],
            [30.133188134406094, -0.928136232074709],
            [30.133105312431837, -0.929247193431538],
            [30.134312543969113, -0.931826662884002],
            [30.134288914683893, -0.93371403816044],
            [30.13560269449871, -0.9385511211988],
            [30.134395563572735, -0.940749747698082],
            [30.134005035376006, -0.942601483228427],
            [30.132371820036052, -0.943725271594629],
            [30.13185110170015, -0.945851822035952],
            [30.130040384649924, -0.949782825623328],
            [30.130632147148415, -0.952267101266487],
            [30.130182422669417, -0.953581331708166],
            [30.130170597246995, -0.9577024445291],
            [30.128963419608638, -0.960426624352941],
            [30.128809564251597, -0.961680964035587],
            [30.12708162964979, -0.964883226382318],
            [30.12696327301785, -0.966077811597328],
            [30.125720576891457, -0.967977773324493],
            [30.125698569065303, -0.96868388392859],
            [30.126495534622425, -0.969946877287876],
            [30.125619568524257, -0.972241243794402],
            [30.122986587561883, -0.975468875281032],
            [30.122229127216016, -0.976783253945181],
            [30.121376942218344, -0.980008895187785],
            [30.120560300861566, -0.981048555444163],
            [30.1198501493918, -0.982984042646186],
            [30.118607455960365, -0.983976147688309],
            [30.118962400990373, -0.987702837241557],
            [30.11729355397465, -0.991203624747499],
            [30.117340842189527, -0.992732575222417],
            [30.11693840951866, -0.993807843446823],
            [30.11706849904653, -0.996519308106095],
            [30.11908032643097, -0.999767338838286],
            [30.120387933023164, -1.00376191086843],
            [30.120572420931367, -1.006136533962807],
            [30.119841080899004, -1.011144764747306],
            [30.121398288884475, -1.016622031305],
            [30.121229516103828, -1.019503750855156],
            [30.121908340624675, -1.020904254764896],
            [30.121526019436395, -1.021315544178906],
            [30.1222794364652, -1.026640998941743],
            [30.121443556788243, -1.029151467856143],
            [30.121166582829975, -1.031566472830226],
            [30.122533252753758, -1.036379385132122],
            [30.124852595019526, -1.041604779558213],
            [30.12584767592772, -1.052089126516041],
            [30.127006241234515, -1.049975838791233],
            [30.128262129120845, -1.048824439357243],
            [30.12965418902783, -1.047728086242517],
            [30.13104467508643, -1.047482586276655],
            [30.134122941053676, -1.048364244838514],
            [30.135678483562597, -1.047295505652458],
            [30.139072756185556, -1.046791426549776],
            [30.14029876251227, -1.047067229768449],
            [30.141822609763036, -1.048413796596354],
            [30.145472928293085, -1.049488210004565],
            [30.147756358608724, -1.052784362734856],
            [30.151167559983225, -1.053172219410694],
            [30.151636290118677, -1.054167845200882],
            [30.15562863590497, -1.056747007006224],
            [30.16262011776006, -1.06311336397225],
            [30.165202114838497, -1.066216878403355],
            [30.171597698351558, -1.075402586004715],
            [30.17575010595518, -1.080068590970849],
            [30.179322887299794, -1.082235643158117],
            [30.182213753918983, -1.082717682929357],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 280,
        District: "NTUNGAMO",
        County: "RUSHENYI",
        Subcounty: "RUBAARE",
        Population: 25414,
        Key: "NTUNGAMORUBAARE",
        Dist2: "Ntungamo",
        "Sub Country": "Rubaare",
        id2_original: "Ntungamo Rubaare",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.214124870963143, -0.983594575355418],
            [30.214059887733814, -0.984275385363634],
            [30.21323020373741, -0.985136935604697],
            [30.211100880307068, -0.98710996264466],
            [30.20927636603239, -0.988054108943636],
            [30.20855716403614, -0.988971370606711],
            [30.20676051370496, -0.989637395450726],
            [30.205626618830856, -0.990804630329736],
            [30.20441082814553, -0.990775787044087],
            [30.201702184781734, -0.991607911198201],
            [30.201259629757004, -0.992136002817069],
            [30.20137218506886, -0.98971627373044],
            [30.200047219432122, -0.988074121330397],
            [30.199440871886694, -0.985835773613368],
            [30.198770873313492, -0.985632832905924],
            [30.19796745785261, -0.984687737439158],
            [30.196845678556727, -0.981191433099563],
            [30.19310429241642, -0.977005650768058],
            [30.192386231280587, -0.97685013547521],
            [30.187817733020527, -0.980305991049955],
            [30.186790761919738, -0.981492778162786],
            [30.191146619070594, -0.986970015112497],
            [30.190068771883656, -0.987640385761506],
            [30.183603601275443, -0.989390546482038],
            [30.178317500918634, -0.992122783394834],
            [30.176007086110182, -0.994444453719708],
            [30.1757997423662, -0.996974471272405],
            [30.176157647345068, -0.998368969776351],
            [30.175796883028635, -1.000330850610567],
            [30.174770421272605, -1.000897966675295],
            [30.17405228198335, -1.000845708869655],
            [30.16867116322569, -0.994696322238887],
            [30.167339378477617, -0.992371540793606],
            [30.165680194639442, -0.991073476541558],
            [30.160049824831468, -0.993806349773236],
            [30.156409219784596, -0.99664788967258],
            [30.15374080028426, -0.997729922603603],
            [30.151225788779918, -0.999380074771387],
            [30.15507130583133, -1.00150048702472],
            [30.159688175674493, -1.001452873707469],
            [30.160756958860215, -1.001673875802839],
            [30.1625884647227, -1.002954645955564],
            [30.164964997332717, -1.006932958894507],
            [30.165801891207597, -1.011975761011723],
            [30.16219484542309, -1.009510277317897],
            [30.161627563812733, -1.012969394086338],
            [30.16177858498507, -1.016274232312783],
            [30.151208114426726, -1.019724464306951],
            [30.151587883501282, -1.020644196038369],
            [30.15541712487639, -1.02398963453978],
            [30.158644150058045, -1.027650444276887],
            [30.159472547666976, -1.028216046627531],
            [30.160590252204727, -1.028001161091795],
            [30.161577712704375, -1.029135836098947],
            [30.16330096079535, -1.032822834144361],
            [30.168802521174726, -1.038940259604298],
            [30.171599558762512, -1.040201236370837],
            [30.176087517667465, -1.048025722872021],
            [30.182003224748986, -1.057080071689408],
            [30.182631486695776, -1.052684194134908],
            [30.182236920571857, -1.052566396374597],
            [30.18218975722282, -1.050486694030762],
            [30.181651444483727, -1.049400554528357],
            [30.181897120239224, -1.048787452931391],
            [30.181566895947512, -1.045693526082609],
            [30.18323929939344, -1.03961242391689],
            [30.183805342226997, -1.039103550063101],
            [30.18619875418121, -1.0383913938248],
            [30.189760878811626, -1.039255290079266],
            [30.194968064865648, -1.03947309479576],
            [30.198657353211054, -1.04172368517014],
            [30.199609887212457, -1.041784463219508],
            [30.204939706777473, -1.040350939291008],
            [30.20497097353928, -1.038643011021867],
            [30.2064032968356, -1.034718972339769],
            [30.20810208649637, -1.032443193211515],
            [30.21006829653235, -1.030736963611719],
            [30.20692939877501, -1.020166348335183],
            [30.20743627047912, -1.019182037817113],
            [30.20885369701311, -1.018538088907793],
            [30.213914022891217, -1.018474573680798],
            [30.216040707969583, -1.01688043053098],
            [30.218234372333832, -1.015863612293263],
            [30.218639688596785, -1.015286688975941],
            [30.21690063285172, -1.010944239897682],
            [30.21639323922642, -1.00863662334597],
            [30.220046840200535, -1.010519282524002],
            [30.233462598657205, -1.016111071820331],
            [30.234381819534608, -1.005712766944076],
            [30.234247361499488, -1.003941894843308],
            [30.23473256224572, -1.002578022078897],
            [30.235991845763817, -1.001702049850492],
            [30.237973995506227, -0.995615818528387],
            [30.235975761428655, -0.99448411375475],
            [30.23604677684513, -0.993289441664017],
            [30.23547864003864, -0.993074723573553],
            [30.23519457208452, -0.992023600900924],
            [30.234484400851855, -0.992167351116576],
            [30.23237755686318, -0.99078275513212],
            [30.230531112017466, -0.99061653775637],
            [30.228199394560345, -0.991919977798869],
            [30.22746555451656, -0.991466425272045],
            [30.22642397680923, -0.991514796798204],
            [30.22571380737316, -0.992160279740679],
            [30.225122007145462, -0.991300481875778],
            [30.22445918521307, -0.991898161888546],
            [30.22301517393658, -0.992305126628821],
            [30.220269210064266, -0.992067725820952],
            [30.219357829682668, -0.991506761672949],
            [30.218316264551767, -0.990026010627287],
            [30.21848197317898, -0.989309155083109],
            [30.217535091377318, -0.988162853598527],
            [30.21669473090377, -0.984352498841459],
            [30.21570050698834, -0.98440083813663],
            [30.214124870963143, -0.983594575355418],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 281,
        District: "NTUNGAMO",
        County: "RUSHENYI",
        Subcounty: "RUBAARE TOWN COUNCIL",
        Population: 13332,
        Key: "NTUNGAMORUBAARE TOWN COUNCIL",
        Dist2: "Ntungamo",
        "Sub Country": "Rubaare T.C",
        id2_original: "Ntungamo Rubaare T.C",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.083443772834368, -0.886994227681997],
            [30.069929114356526, -0.887145714888577],
            [30.0628995978323, -0.885907703463996],
            [30.056982496565418, -0.883976254168425],
            [30.05377549662809, -0.884085678401766],
            [30.052544793909046, -0.884826966980854],
            [30.051787415309846, -0.884684084514021],
            [30.049174076909473, -0.885295719338038],
            [30.048795386711557, -0.88638868119072],
            [30.04775405334601, -0.886559516715205],
            [30.047825112779915, -0.88732756869028],
            [30.045316412838808, -0.890099368815481],
            [30.04467743309235, -0.890116925167257],
            [30.043659760453085, -0.89090810073382],
            [30.04339944126014, -0.892483119299127],
            [30.041364012438247, -0.893565697557913],
            [30.04076047392474, -0.895390315548912],
            [30.03943510674107, -0.895434416545101],
            [30.038228080917953, -0.89656283204489],
            [30.03668972857033, -0.896371843052868],
            [30.03619271767309, -0.895467925900599],
            [30.03460695404138, -0.894942599554282],
            [30.03066619940019, -0.892472815974611],
            [30.02962487591608, -0.892824339774585],
            [30.03061894262635, -0.894216551069985],
            [30.030287613406838, -0.896050406780155],
            [30.028299614733633, -0.895723524659223],
            [30.025932861183783, -0.894646423397325],
            [30.024867783548657, -0.894717837043237],
            [30.024276147712627, -0.8963888379963],
            [30.025175572416124, -0.897392461976403],
            [30.024051444025766, -0.900942315918414],
            [30.023601686309107, -0.901971941651854],
            [30.021732019115024, -0.902738381717629],
            [30.019956964283274, -0.904435502344638],
            [30.020454025486153, -0.905773095772506],
            [30.02221724321742, -0.90690392872594],
            [30.025223071735084, -0.906445624334254],
            [30.02628804336905, -0.90587329930169],
            [30.03065474228704, -0.906332645681133],
            [30.031696137636356, -0.906767188132393],
            [30.033826114141924, -0.906524993131646],
            [30.036831942659585, -0.90714185544215],
            [30.03716340213481, -0.910349606202945],
            [30.039340853704807, -0.912275893070798],
            [30.03937630841245, -0.913513741057386],
            [30.039968107741853, -0.913911777958234],
            [30.0398733381743, -0.914724865347281],
            [30.041932584029336, -0.916108954796717],
            [30.044914668277418, -0.916807137621732],
            [30.045802250490556, -0.919608791172099],
            [30.04582601003148, -0.92312351175933],
            [30.047399891646943, -0.92583211780852],
            [30.04934065330925, -0.92685800080259],
            [30.050003353070768, -0.926831449178837],
            [30.049837704630693, -0.927527026026725],
            [30.050169021273778, -0.927979066384177],
            [30.051494431576575, -0.927745259289272],
            [30.053955977151805, -0.929247176365805],
            [30.054381948378083, -0.930395015539671],
            [30.056500274632693, -0.931426816324978],
            [30.056879081611594, -0.932285488564414],
            [30.05761268539848, -0.932340316266647],
            [30.058180830289817, -0.933199148162204],
            [30.05799140344417, -0.934319368322555],
            [30.058464783259566, -0.935629888814248],
            [30.060168885556905, -0.937926299141015],
            [30.062476609911087, -0.938226412998216],
            [30.06403874425757, -0.93922161903485],
            [30.066381845165974, -0.942015531235627],
            [30.067967677069625, -0.942351181778683],
            [30.070062327326635, -0.944223283888986],
            [30.071707420191274, -0.944811978591895],
            [30.0754232762112, -0.948176313896241],
            [30.07587299080876, -0.949441660900502],
            [30.075139165137994, -0.950633717699114],
            [30.074216158759985, -0.955295224973958],
            [30.071127301655526, -0.958346555232874],
            [30.07020409854646, -0.959899852584017],
            [30.069056039935248, -0.967195957959823],
            [30.069801382906274, -0.972747864646974],
            [30.068830977820614, -0.974039081966156],
            [30.06844034901258, -0.977472193908906],
            [30.068866334611872, -0.978565851096145],
            [30.068014189140108, -0.979495749224059],
            [30.067990505057633, -0.980119170610257],
            [30.07027448514223, -0.98357270729582],
            [30.07115009371092, -0.986148576367944],
            [30.069859989893743, -0.990366972760962],
            [30.070498782790573, -0.993638361338041],
            [30.06981239804828, -0.995526151455026],
            [30.070226372273922, -0.997975119197909],
            [30.06998966978983, -1.000459645794422],
            [30.06736623342735, -1.002220544616343],
            [30.067477008278296, -1.00393982184991],
            [30.06700849014522, -1.004603520980287],
            [30.06406260261318, -1.007078140150879],
            [30.06119003198138, -1.00797041014261],
            [30.059977232685988, -1.010306571188835],
            [30.058232808608803, -1.011953427886027],
            [30.056940164355964, -1.012017010604303],
            [30.05569928731803, -1.013052040546383],
            [30.05364044480659, -1.01312669414634],
            [30.05109373804409, -1.015879603384714],
            [30.049695839087743, -1.015925419244552],
            [30.047893785390126, -1.016624347695433],
            [30.044402592632892, -1.019401483070582],
            [30.046994639164392, -1.023361301313936],
            [30.047096203588723, -1.027242460046711],
            [30.05043707316467, -1.031867095601151],
            [30.04955997698586, -1.037901383994845],
            [30.04989844332031, -1.041801110741003],
            [30.04855907409631, -1.043694509533496],
            [30.045636909274286, -1.045026487104235],
            [30.04599744991021, -1.048984251608893],
            [30.045159830196575, -1.052597541099091],
            [30.04652477176175, -1.060832520979727],
            [30.048066319416886, -1.060871545190412],
            [30.050272089477886, -1.061901965064779],
            [30.05348235838455, -1.065218094962683],
            [30.05587641802407, -1.067109322133035],
            [30.05699137012381, -1.067516981428539],
            [30.064787090296587, -1.068876447721779],
            [30.069848984633165, -1.072288737672968],
            [30.071671403138282, -1.075207287135506],
            [30.07226456611028, -1.081650544492196],
            [30.074876795091274, -1.087450667225824],
            [30.07789684483822, -1.091245868099517],
            [30.081556813969392, -1.089888262001039],
            [30.0808313102914, -1.086416537609781],
            [30.0824256474442, -1.083238526501641],
            [30.082403585719117, -1.081469426997431],
            [30.08259402496609, -1.081015388818946],
            [30.08343902523811, -1.080942463090339],
            [30.08531995730586, -1.07985859318398],
            [30.088854862084865, -1.079595410188033],
            [30.090686274522582, -1.080211843205853],
            [30.091784579043452, -1.081155396872135],
            [30.092392244417386, -1.084311299400557],
            [30.09383595924987, -1.086703281279776],
            [30.09848894675733, -1.086978288749113],
            [30.10078080237205, -1.086697232214531],
            [30.10518909508434, -1.085366180689482],
            [30.10694883723374, -1.083096709660863],
            [30.10927745280818, -1.082047034186636],
            [30.110110147059096, -1.080565593459297],
            [30.111462070239195, -1.080353018000211],
            [30.113094058480474, -1.075227419327156],
            [30.113240103884426, -1.072312698731246],
            [30.11394874079461, -1.069104122929019],
            [30.11554473713572, -1.064583751406689],
            [30.11699698237014, -1.062484398170652],
            [30.1226845407257, -1.059790853969467],
            [30.125868112600457, -1.053775962182654],
            [30.12584767592772, -1.052089126516041],
            [30.124852595019526, -1.041604779558213],
            [30.122533252753758, -1.036379385132122],
            [30.121166582829975, -1.031566472830226],
            [30.121443556788243, -1.029151467856143],
            [30.1222794364652, -1.026640998941743],
            [30.121526019436395, -1.021315544178906],
            [30.121908340624675, -1.020904254764896],
            [30.121229516103828, -1.019503750855156],
            [30.121398288884475, -1.016622031305],
            [30.119841080899004, -1.011144764747306],
            [30.120572420931367, -1.006136533962807],
            [30.120387933023164, -1.00376191086843],
            [30.11908032643097, -0.999767338838286],
            [30.11706849904653, -0.996519308106095],
            [30.11693840951866, -0.993807843446823],
            [30.117340842189527, -0.992732575222417],
            [30.11729355397465, -0.991203624747499],
            [30.118962400990373, -0.987702837241557],
            [30.118607455960365, -0.983976147688309],
            [30.1198501493918, -0.982984042646186],
            [30.120560300861566, -0.981048555444163],
            [30.121376942218344, -0.980008895187785],
            [30.122229127216016, -0.976783253945181],
            [30.122986587561883, -0.975468875281032],
            [30.125619568524257, -0.972241243794402],
            [30.126495534622425, -0.969946877287876],
            [30.125698569065303, -0.96868388392859],
            [30.125720576891457, -0.967977773324493],
            [30.12696327301785, -0.966077811597328],
            [30.12708162964979, -0.964883226382318],
            [30.128809564251597, -0.961680964035587],
            [30.128963419608638, -0.960426624352941],
            [30.130170597246995, -0.9577024445291],
            [30.130182422669417, -0.953581331708166],
            [30.130632147148415, -0.952267101266487],
            [30.130040384649924, -0.949782825623328],
            [30.13185110170015, -0.945851822035952],
            [30.132371820036052, -0.943725271594629],
            [30.134005035376006, -0.942601483228427],
            [30.134395563572735, -0.940749747698082],
            [30.13560269449871, -0.9385511211988],
            [30.134288914683893, -0.93371403816044],
            [30.134312543969113, -0.931826662884002],
            [30.133105312431837, -0.929247193431538],
            [30.133188134406094, -0.928136232074709],
            [30.134916001634284, -0.926940696071899],
            [30.13536566233292, -0.924527484961578],
            [30.13612307147482, -0.923571414677178],
            [30.141152776479835, -0.919017277298995],
            [30.143200137623673, -0.916543373014947],
            [30.143697086537145, -0.913532838609313],
            [30.14204010267309, -0.911311996174475],
            [30.141980875848095, -0.91020111546217],
            [30.14077356076749, -0.907072154014082],
            [30.140915498175637, -0.905224455353185],
            [30.13610872987129, -0.905567964157594],
            [30.13367734343511, -0.906393138747496],
            [30.1286754170336, -0.906593273613341],
            [30.12488615428193, -0.905866315773281],
            [30.11492788109811, -0.90498923120458],
            [30.104331695366454, -0.90532679931566],
            [30.103105740243706, -0.904380410142549],
            [30.095080801451456, -0.892757543770129],
            [30.092122062620973, -0.88982090041875],
            [30.089932633813277, -0.888353016191071],
            [30.08737635729806, -0.887327307311873],
            [30.083443772834368, -0.886994227681997],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 282,
        District: "NTUNGAMO",
        County: "RUSHENYI",
        Subcounty: "RUGARAMA",
        Population: 31150,
        Key: "NTUNGAMORUGARAMA",
        Dist2: "Ntungamo",
        "Sub Country": "Rugarama",
        id2_original: "Ntungamo Rugarama",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.394876381382517, -0.810883551943536],
            [30.389272705911555, -0.807175477613877],
            [30.375629631467206, -0.799620118670324],
            [30.370937237563133, -0.794375214079099],
            [30.363172691625667, -0.789327217316121],
            [30.360421497761813, -0.786849146307782],
            [30.359837284704966, -0.785185845712534],
            [30.359587237747323, -0.780793382767091],
            [30.358438330228196, -0.778768226002087],
            [30.353604510955687, -0.774056583538405],
            [30.352083924589422, -0.766906886521714],
            [30.351015868140784, -0.765017364738799],
            [30.344224855222834, -0.756783301161819],
            [30.338721061631638, -0.754891355093544],
            [30.337002270981095, -0.753867527013607],
            [30.3350236659908, -0.75168964718495],
            [30.337577958127557, -0.749645664873427],
            [30.338412367262364, -0.748387376418139],
            [30.33698100875663, -0.745921361205995],
            [30.335770607064724, -0.745188684530343],
            [30.33509349652944, -0.743064464827511],
            [30.33299004278264, -0.741418371931228],
            [30.33116415767886, -0.738660845006225],
            [30.32953742188704, -0.737159649316427],
            [30.329103307432707, -0.735198263450867],
            [30.32788615759637, -0.733254485854446],
            [30.32617719451504, -0.732512393514081],
            [30.325478337563354, -0.731328074027008],
            [30.32442626214361, -0.731101510414496],
            [30.323639909283266, -0.730097888176644],
            [30.323265099807376, -0.727223774014747],
            [30.324170379729892, -0.723970848064567],
            [30.32508145917587, -0.723266468754711],
            [30.324057692365702, -0.722127150659476],
            [30.323338679913963, -0.720373471854861],
            [30.322535830391725, -0.720228400909578],
            [30.321622826754393, -0.718944552709281],
            [30.31924216638565, -0.717831555698458],
            [30.31565230357589, -0.718001151496374],
            [30.3140645546674, -0.717250118220168],
            [30.31483874433885, -0.719392422816728],
            [30.313324724657296, -0.727832385654561],
            [30.31355800276352, -0.731149221444431],
            [30.31239315913125, -0.734465215826442],
            [30.311146272364066, -0.735856208110759],
            [30.308598856830823, -0.735917927161336],
            [30.303922937130753, -0.729860135994766],
            [30.302760303354074, -0.729470835026589],
            [30.29709784392755, -0.729584908226971],
            [30.29374606700741, -0.731887365338642],
            [30.292609606544865, -0.733956187741079],
            [30.291750799166923, -0.734759972859612],
            [30.286502959854722, -0.736148493092488],
            [30.282600035066768, -0.734085651298249],
            [30.279873018460428, -0.733641170814686],
            [30.2774096564917, -0.732130479917608],
            [30.27569290771179, -0.732102321828984],
            [30.274889550641415, -0.732851905573932],
            [30.274777575641252, -0.734776725062033],
            [30.273502841998546, -0.736565274267084],
            [30.27072046311959, -0.736084603894482],
            [30.26833906343737, -0.736390398407243],
            [30.2661510467813, -0.737473487502462],
            [30.263299745560506, -0.736640330390834],
            [30.260724371760666, -0.737171920185854],
            [30.255918939251142, -0.739672168630098],
            [30.25181917112657, -0.742904817082692],
            [30.24975593675165, -0.743653586100625],
            [30.248564761701758, -0.744601708458024],
            [30.246874198812403, -0.747194215311898],
            [30.24631921154502, -0.749145818531752],
            [30.245543555823048, -0.749786942500794],
            [30.239838988765875, -0.751229218458287],
            [30.23599050817237, -0.751000858489326],
            [30.233664812122598, -0.750918049916463],
            [30.229926854851712, -0.75274108580893],
            [30.225977745878385, -0.75532304972272],
            [30.22409531901399, -0.757210502622231],
            [30.222441022909255, -0.757957128693395],
            [30.222993649404064, -0.761906659206566],
            [30.222729762102812, -0.767071263489605],
            [30.223393187703085, -0.769582186459514],
            [30.225082675309082, -0.771300889986702],
            [30.231807557849073, -0.775291863443963],
            [30.23272312617655, -0.776486199742234],
            [30.233601117975702, -0.777753987769955],
            [30.23535543699572, -0.78284790264053],
            [30.235638581481716, -0.785717252572082],
            [30.23637363514945, -0.787630516113636],
            [30.23763149663447, -0.789137665622766],
            [30.242736774209405, -0.791269042002454],
            [30.245846265615928, -0.7943554898696],
            [30.24710319914125, -0.797273342471241],
            [30.247315970506193, -0.798779809408241],
            [30.24759564300358, -0.80733651159348],
            [30.2484481837341, -0.809581828328953],
            [30.24962017705774, -0.811169880117276],
            [30.253548810730795, -0.811369563671173],
            [30.256166731437432, -0.812031945428944],
            [30.257394773346604, -0.813685218147595],
            [30.258908157020908, -0.814815604130862],
            [30.259851221880904, -0.816288751236725],
            [30.26177422654502, -0.817700768284319],
            [30.265621100950813, -0.81925757127279],
            [30.270608880683223, -0.819691371859087],
            [30.27657278687134, -0.816802278507282],
            [30.28050999316717, -0.816890353860956],
            [30.285990571596432, -0.820826932611782],
            [30.288088877996657, -0.822931244228604],
            [30.2908432626764, -0.824391681198502],
            [30.29279059192178, -0.825038604199479],
            [30.294210504992467, -0.825062291215806],
            [30.29509445441857, -0.825596389338751],
            [30.302356266292094, -0.826828210835794],
            [30.314254308499823, -0.830542552736695],
            [30.320453364883246, -0.831551057077216],
            [30.327532169272143, -0.831340670435305],
            [30.330098175440224, -0.830481596770859],
            [30.332521998061708, -0.829120278958291],
            [30.33577680005028, -0.828381218868967],
            [30.336952713621823, -0.828479134880476],
            [30.34060598581253, -0.827119927200587],
            [30.344624530065776, -0.827436496437796],
            [30.347979036067727, -0.828294095883632],
            [30.350276083944767, -0.827291281845508],
            [30.356223251824204, -0.826454053854131],
            [30.360103813951447, -0.826880329254196],
            [30.361526905261634, -0.827863773249308],
            [30.363761429496595, -0.830530789635694],
            [30.364925426915864, -0.828879958064667],
            [30.367351753142096, -0.827102956200099],
            [30.372028212729617, -0.826222628788493],
            [30.3740447859137, -0.825374955147359],
            [30.38111754464077, -0.825290735149855],
            [30.38286176659701, -0.823151951893787],
            [30.384238912673645, -0.820596048848031],
            [30.384452508692032, -0.816763186900251],
            [30.3867879146317, -0.815981246892886],
            [30.389747638015734, -0.812588149705564],
            [30.3940621546972, -0.810294255908818],
            [30.394876381382517, -0.810883551943536],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 283,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "ITOJO",
        Population: 22275,
        Key: "NTUNGAMOITOJO",
        Dist2: "Ntungamo",
        "Sub Country": "itojo",
        id2_original: "Ntungamo itojo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.21265953547843, -0.759544802157532],
            [30.207737610341198, -0.7609784006109],
            [30.206151802692037, -0.761815795462477],
            [30.201193102323693, -0.762906590520223],
            [30.199915038626244, -0.763576477550627],
            [30.2010628466075, -0.764377872420687],
            [30.20371392952115, -0.764375907081779],
            [30.205347389202874, -0.765330423052313],
            [30.206318482398043, -0.768889607374448],
            [30.207194620074453, -0.770585305610698],
            [30.211775607611887, -0.774966088677676],
            [30.2129832101534, -0.777139391883116],
            [30.215847571980127, -0.778308005876162],
            [30.217528404318358, -0.779573110337093],
            [30.21810873036493, -0.781687112607866],
            [30.221067906674964, -0.783524698414153],
            [30.222619044744054, -0.787836135420343],
            [30.22501017767236, -0.789889152686304],
            [30.226809615475858, -0.792754926409395],
            [30.22765045295486, -0.795896201941182],
            [30.228851317233417, -0.797563047141491],
            [30.22874239650522, -0.798283664167467],
            [30.23046653033507, -0.799060421211129],
            [30.231520156246965, -0.800524392345106],
            [30.23334331496389, -0.801931521337084],
            [30.23423566543451, -0.804977353275159],
            [30.233321348460226, -0.808304930361985],
            [30.23083912097219, -0.812033127493131],
            [30.228400966628644, -0.813795963862083],
            [30.22214188481797, -0.815925808495688],
            [30.22177154086735, -0.817558892035784],
            [30.221156264966304, -0.818443292107539],
            [30.21733372232829, -0.82101445644072],
            [30.214908341129778, -0.827216120454077],
            [30.21254156152878, -0.829344202809779],
            [30.20847043888199, -0.831497267131581],
            [30.206754866895107, -0.835882686186179],
            [30.206068498322466, -0.836695434798173],
            [30.206400172495062, -0.839132205645971],
            [30.207560403278336, -0.841831211620636],
            [30.21137024283993, -0.845580639868105],
            [30.213134379547725, -0.851206073815662],
            [30.21300461520997, -0.854730237646453],
            [30.21392805457598, -0.857453372261817],
            [30.215585376206576, -0.860223732136437],
            [30.217775019711617, -0.860807641278705],
            [30.218745691596943, -0.86279009765018],
            [30.219455922118453, -0.863219696046009],
            [30.220426664072352, -0.865799391709805],
            [30.22103078110092, -0.870493884125356],
            [30.22307865967432, -0.873562678524783],
            [30.223433914623126, -0.875449903533309],
            [30.222617851781337, -0.881435488582974],
            [30.220700650234008, -0.884232145640955],
            [30.22060611692339, -0.885617982002032],
            [30.219765910960046, -0.887087885587923],
            [30.22000270147905, -0.887995636550712],
            [30.221399441608675, -0.889523851690478],
            [30.221837861688133, -0.89598644557081],
            [30.221388422873417, -0.899427272314931],
            [30.219577826197433, -0.903740967423495],
            [30.220749777300245, -0.906977656800085],
            [30.22060787133312, -0.908482988584059],
            [30.219566457119203, -0.910227746251218],
            [30.21890380945998, -0.913214686782382],
            [30.220004877198654, -0.918673430258815],
            [30.21908178817565, -0.92039425494139],
            [30.217921908633603, -0.920920613213296],
            [30.216856773506294, -0.92199641772866],
            [30.21597803880041, -0.924710170415151],
            [30.2151969249148, -0.925857477530979],
            [30.212464713351185, -0.927882352072749],
            [30.21742432640784, -0.928166688152819],
            [30.219585125009115, -0.929005239771865],
            [30.22127065912955, -0.930178088419098],
            [30.2306544749605, -0.940554352730244],
            [30.23476440752253, -0.943163746165351],
            [30.237077359173345, -0.945710404258423],
            [30.239689632171793, -0.945305515932895],
            [30.243644605347317, -0.946909281420143],
            [30.247219198593875, -0.947886697172775],
            [30.250607180314898, -0.94821769541066],
            [30.254403334043143, -0.949445411750072],
            [30.25996537978721, -0.95262599241007],
            [30.26433056055238, -0.954404971741985],
            [30.266144034532193, -0.956166617777545],
            [30.2729334736018, -0.960656583204537],
            [30.27514248658102, -0.960730052371007],
            [30.27818363505903, -0.959967363179615],
            [30.281604391813186, -0.95965924205485],
            [30.286135619870436, -0.960475822659465],
            [30.28993416042237, -0.960273589995783],
            [30.291171519657635, -0.95836009544147],
            [30.29175591597079, -0.956125146539473],
            [30.291785251354703, -0.951796428378909],
            [30.29275051897526, -0.948773100639158],
            [30.294201158021934, -0.946671541505158],
            [30.295888306414923, -0.94524011670189],
            [30.297586472644873, -0.944514264375599],
            [30.300315456561655, -0.945070091449816],
            [30.302168863350808, -0.943591159636212],
            [30.305090142433933, -0.942305831075931],
            [30.30841692732452, -0.939514622673093],
            [30.312904713752932, -0.938376019921592],
            [30.315637908073473, -0.935594702903023],
            [30.315597694091473, -0.931322868032481],
            [30.318037672913352, -0.926785919534361],
            [30.319728751435708, -0.925399467478095],
            [30.321345718947125, -0.922475129009392],
            [30.322029772561248, -0.916446315280265],
            [30.323437530527837, -0.914541638665755],
            [30.326644446023536, -0.911407477704052],
            [30.329414906055337, -0.909327789124283],
            [30.333404900052194, -0.907614047753921],
            [30.335816946658664, -0.905454501345598],
            [30.339212718569815, -0.904385288285097],
            [30.343330582357485, -0.904836214197442],
            [30.344780308715805, -0.903475927310259],
            [30.347179442040066, -0.90214146327692],
            [30.34739433612402, -0.901113510945837],
            [30.352421603101348, -0.895634812492556],
            [30.35550921064924, -0.894253961344726],
            [30.358517935335417, -0.89409986244751],
            [30.357434903971, -0.888181944520896],
            [30.353703456790985, -0.882254823951211],
            [30.35050061156183, -0.880813268627363],
            [30.348330759739103, -0.879074882344434],
            [30.34662901372275, -0.876728449267471],
            [30.343626394885586, -0.876566912461687],
            [30.34049471329493, -0.875197281842868],
            [30.337907705413844, -0.874928941450831],
            [30.336316564466845, -0.875547583915717],
            [30.334359641214263, -0.875552004907328],
            [30.332093079463018, -0.876386357844448],
            [30.32941041447891, -0.876369306221957],
            [30.32924542001236, -0.874932449861265],
            [30.327979637183166, -0.873629202716296],
            [30.32756290333297, -0.872145610479528],
            [30.32752507527637, -0.868915908336225],
            [30.325643315860226, -0.864312217917059],
            [30.32566556263824, -0.862257554951007],
            [30.322142833624596, -0.862196995595792],
            [30.31857027596046, -0.860120507581108],
            [30.31606727493151, -0.859835324604922],
            [30.31646786695436, -0.857593508122538],
            [30.31644772492907, -0.853800093344229],
            [30.315855469255506, -0.851480309975661],
            [30.3125345800081, -0.844711123055368],
            [30.309994593542253, -0.842366072750775],
            [30.306912950807853, -0.840797067577717],
            [30.30289032281337, -0.84017905094222],
            [30.299495252486448, -0.840817979902188],
            [30.291883574657483, -0.841413119711674],
            [30.291507615338045, -0.833261217676972],
            [30.29421049151774, -0.8250622822336],
            [30.29279059192178, -0.82503863384081],
            [30.290843283337665, -0.824391702755835],
            [30.288088894166343, -0.822931249617931],
            [30.285990556325082, -0.82082695237269],
            [30.280509990472208, -0.816890346675176],
            [30.276572773396584, -0.816802278507282],
            [30.270608871700052, -0.819691401500458],
            [30.265621117120492, -0.819257587440818],
            [30.261774222053432, -0.817700783554114],
            [30.259851195829757, -0.816288747643835],
            [30.25890817498722, -0.814815589759262],
            [30.257394794906165, -0.813685229824546],
            [30.2561666990981, -0.812031934650261],
            [30.253548811629123, -0.811369563671173],
            [30.249620156396475, -0.811169848679395],
            [30.24844820619196, -0.809581814855575],
            [30.247595648393496, -0.807336530456213],
            [30.247315977692708, -0.798779795036584],
            [30.247103189259782, -0.797273368519834],
            [30.24584624944625, -0.79435545843159],
            [30.242736745463297, -0.791269058170593],
            [30.237631507414235, -0.789137657538692],
            [30.23637365581072, -0.787630525095925],
            [30.235638580583387, -0.785717223828711],
            [30.23535547113171, -0.782847936773334],
            [30.233601089229595, -0.777753978787645],
            [30.232723127074877, -0.776486207826332],
            [30.23180754706931, -0.775291839191661],
            [30.225082674410746, -0.771300875614951],
            [30.223393210160943, -0.769582160410748],
            [30.222729789950588, -0.76707124372844],
            [30.222993670065296, -0.76190667178188],
            [30.22244099595978, -0.757957099051585],
            [30.21685396627103, -0.758236043749348],
            [30.21265953547843, -0.759544802157532],
          ],
          [
            [30.259261395251894, -0.918628871463913],
            [30.256650877561505, -0.918288608204042],
            [30.25404253469242, -0.916274253317883],
            [30.25228674962184, -0.915696669085895],
            [30.25059258269153, -0.914594829221533],
            [30.24437925836648, -0.908819042000252],
            [30.24326885713196, -0.907182769472876],
            [30.242129259752414, -0.906464628510495],
            [30.23955277922815, -0.902431485231542],
            [30.23852287512797, -0.899080832088796],
            [30.239158994638544, -0.898474543874446],
            [30.23939122261422, -0.897413609317286],
            [30.24047306101593, -0.897542094859557],
            [30.241958298675772, -0.899019852972049],
            [30.245093770258617, -0.897607004546245],
            [30.246263404606307, -0.895813962276451],
            [30.246540127934654, -0.891876802149138],
            [30.245992998231056, -0.891207006841866],
            [30.242824892650557, -0.890968350641616],
            [30.24114413038093, -0.889274037852884],
            [30.238798334526702, -0.887815433687143],
            [30.237900159379762, -0.885806676630348],
            [30.23833282485151, -0.88257831922146],
            [30.23931205857981, -0.880728500139197],
            [30.242548590632115, -0.879236419940026],
            [30.24323832788704, -0.878348175055147],
            [30.243070385149743, -0.876203277451273],
            [30.244172225439552, -0.867108606589036],
            [30.244056847621113, -0.864391724144827],
            [30.24476202511915, -0.862856621133043],
            [30.245100717829033, -0.857745853409537],
            [30.247232392150483, -0.854274813704616],
            [30.246956300337793, -0.852305405796466],
            [30.251850925673534, -0.850143863008974],
            [30.253455892591056, -0.848373113404698],
            [30.258881646838564, -0.846320546428436],
            [30.260705296933903, -0.844758840868203],
            [30.260819832132626, -0.844041670597948],
            [30.260051351254866, -0.842405650939136],
            [30.260218732545102, -0.839185116130733],
            [30.258275143884603, -0.836132784671907],
            [30.257944942050788, -0.832665585303814],
            [30.256639577653548, -0.831230046467485],
            [30.257472344667995, -0.829126525188711],
            [30.260537985712233, -0.826881111605321],
            [30.26141665034951, -0.827192542135411],
            [30.264856215130802, -0.833818114215842],
            [30.267186220398983, -0.835946052890041],
            [30.269561562741213, -0.836200431388247],
            [30.270188277789103, -0.836659927282816],
            [30.271214462863995, -0.836178818427758],
            [30.273931023978747, -0.836298744218643],
            [30.27447906726896, -0.835118708050193],
            [30.27553521924343, -0.834752403194164],
            [30.27623815095325, -0.835557572861676],
            [30.27687546342653, -0.836697890530271],
            [30.277061372469504, -0.838089920328375],
            [30.276873567981287, -0.839481808611336],
            [30.27586289321805, -0.841775915503826],
            [30.276019045567267, -0.846588117264896],
            [30.27823107688581, -0.844601933918792],
            [30.281168287590518, -0.842738973408036],
            [30.283638023106185, -0.842077450082283],
            [30.288409340296145, -0.841559010141096],
            [30.289999709590337, -0.846819899518097],
            [30.29183830765201, -0.849689982559039],
            [30.296727178380042, -0.849410132418247],
            [30.298628869615722, -0.860535089936891],
            [30.30219307564264, -0.867226848167476],
            [30.304022621381193, -0.872449528315661],
            [30.307445132545123, -0.877106890320981],
            [30.309544242937516, -0.88173449425848],
            [30.307511243160146, -0.882115601586438],
            [30.307467590427226, -0.882520145835699],
            [30.30298022441035, -0.885440095501198],
            [30.299069184242114, -0.888613504385923],
            [30.29828491277828, -0.889425048916282],
            [30.297951132954655, -0.890572298064019],
            [30.298171851714923, -0.894435216590535],
            [30.298767406900524, -0.89518451688114],
            [30.29880165517073, -0.897887062175429],
            [30.29796825664063, -0.90061234081946],
            [30.29820490702242, -0.901855862259276],
            [30.2977518893196, -0.904103126664768],
            [30.299813382759474, -0.91096714869724],
            [30.29974109622687, -0.91242567354324],
            [30.300784966434783, -0.914148044336598],
            [30.299287938386836, -0.914888147471569],
            [30.298260280074867, -0.914843658689236],
            [30.297512712875204, -0.909094397574929],
            [30.292147594909405, -0.909561602813551],
            [30.288098158491838, -0.91143056418056],
            [30.283700764140594, -0.916300287656872],
            [30.27820588183705, -0.916229063058219],
            [30.26926757469145, -0.917537698627962],
            [30.265897629344718, -0.917076318356359],
            [30.264472536588105, -0.917766879765369],
            [30.26217011229407, -0.917809895463339],
            [30.259261395251894, -0.918628871463913],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 284,
        District: "NTUNGAMO",
        County: "RUHAAMA",
        Subcounty: "NTUNGAMO",
        Population: 31169,
        Key: "NTUNGAMONTUNGAMO",
        Dist2: "Ntungamo",
        "Sub Country": "Ntungamo",
        id2_original: "Ntungamo Ntungamo",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.951132547834025, -0.713202324910867],
            [30.94071743461587, -0.710460550390138],
            [30.92536247936211, -0.707533298859112],
            [30.915798089582648, -0.704852771567548],
            [30.91639207990301, -0.717212508706124],
            [30.916133035419477, -0.745305156525112],
            [30.916274674586955, -0.747314658367623],
            [30.91791075645098, -0.75269458224338],
            [30.92841265141717, -0.757176557353807],
            [30.93234809072683, -0.759073560394519],
            [30.934971451630823, -0.760912511402909],
            [30.942408345153268, -0.770071637868309],
            [30.95289288017658, -0.780058537410371],
            [30.953823384792262, -0.782879946148608],
            [30.96114254511355, -0.787395264174076],
            [30.967122771893766, -0.793865166417089],
            [30.969706734486024, -0.797463640219594],
            [30.971092384015154, -0.79814479450868],
            [30.970675068056643, -0.799402990057739],
            [30.970997087136567, -0.803644429654329],
            [30.972938262922195, -0.810589919380702],
            [30.97330683539507, -0.814272100158455],
            [30.973080712370063, -0.818142644070154],
            [30.971585210559816, -0.822047865529756],
            [30.970145617197854, -0.834062729199206],
            [30.968764390973202, -0.838158200255408],
            [30.96933234901497, -0.842823408604509],
            [30.96918816042869, -0.84590935241325],
            [30.96951962349717, -0.846950697002102],
            [30.971939519582605, -0.848790086284699],
            [30.97383520288563, -0.855492831367476],
            [30.977184130349677, -0.859262437301184],
            [30.981675063576517, -0.860628421552666],
            [30.987342889538564, -0.861062040597497],
            [30.98933917067871, -0.861098981438041],
            [30.990371749961813, -0.860681329048291],
            [30.999011460700203, -0.860647310093657],
            [31.000497012770403, -0.861284296420733],
            [31.002600757571358, -0.860352402193774],
            [31.00402668037129, -0.860389035851989],
            [31.00538100923972, -0.860999788090172],
            [31.00719821482121, -0.862687326762152],
            [31.007447177512322, -0.863799885228015],
            [31.008302317068946, -0.864625686183613],
            [31.009191122787456, -0.869255295922724],
            [31.010451114178032, -0.871961446636846],
            [31.013645743415598, -0.872594877738103],
            [31.024486132563975, -0.872026297489151],
            [31.028880015400794, -0.870535397669264],
            [31.03070706022963, -0.867951948908444],
            [31.031563158288655, -0.867378082878383],
            [31.03213487398322, -0.86508112775337],
            [31.037727619652163, -0.862155027464452],
            [31.040239295711817, -0.859571902642758],
            [31.041894201772614, -0.858883574995865],
            [31.044120546846905, -0.856415153603935],
            [31.046647976661724, -0.856186612687306],
            [31.049279735915313, -0.855106114695144],
            [31.053384849015842, -0.85245257756994],
            [31.06048184159431, -0.849104586973867],
            [31.063080905764842, -0.846902839992578],
            [31.065443863034254, -0.845828224520271],
            [31.066794966052502, -0.843507433061209],
            [31.068511344726517, -0.84186627357275],
            [31.069383360034074, -0.841526979673319],
            [31.07355565633807, -0.845013967007652],
            [31.07545157140644, -0.849578589339393],
            [31.077063383486447, -0.857617163503715],
            [31.078270783907016, -0.858675789266904],
            [31.084199113216624, -0.861710716208233],
            [31.085345970780278, -0.863119110522706],
            [31.08552698669993, -0.865292754789151],
            [31.08850233717664, -0.86288969424924],
            [31.093184458845432, -0.861853851048153],
            [31.094682276512497, -0.860849777390849],
            [31.09646497870224, -0.860491803209163],
            [31.098390675617257, -0.859344392166423],
            [31.101957250501588, -0.856259907029662],
            [31.106928205687034, -0.853682807050986],
            [31.108850049727796, -0.852651557528136],
            [31.11403859304472, -0.848714210325274],
            [31.110721522535613, -0.846035694769905],
            [31.10986309963663, -0.844467434800449],
            [31.107814253577622, -0.842253406545653],
            [31.10725495170195, -0.840877198552966],
            [31.108894502859627, -0.836468800537736],
            [31.11079922321442, -0.833956065560334],
            [31.110948400145446, -0.832189685639332],
            [31.112492561898033, -0.829875576949958],
            [31.115777599382415, -0.826746724157919],
            [31.115853513312132, -0.824341389731666],
            [31.11501266146011, -0.822251477369686],
            [31.115102598989743, -0.821631483537928],
            [31.114644149174378, -0.821148432695333],
            [31.11471806345425, -0.819747758728121],
            [31.116010830776254, -0.819496579544405],
            [31.117095181765844, -0.81777904130211],
            [31.118014619137245, -0.817553406582825],
            [31.11900004764773, -0.816694843729277],
            [31.1194232349949, -0.815186073193976],
            [31.118919814618103, -0.812327314156045],
            [31.11928163535329, -0.81114292258077],
            [31.11918381690372, -0.809587587751546],
            [31.118166298774657, -0.808854675110669],
            [31.11654235135346, -0.805851846864429],
            [31.116346059582433, -0.804160818481752],
            [31.115263648953878, -0.802315673372813],
            [31.11381921187593, -0.801455983610531],
            [31.112900536275898, -0.80002685057104],
            [31.110783718292616, -0.798145067570035],
            [31.110193306860328, -0.796462901521886],
            [31.108026751854723, -0.795304490205054],
            [31.108258468688987, -0.791271702558587],
            [31.10722574657375, -0.788160653462447],
            [31.108639655305097, -0.78320608318846],
            [31.108082404283202, -0.781415437037201],
            [31.10695382384229, -0.780447396410277],
            [31.107807265583038, -0.778359005715291],
            [31.10774257610279, -0.776116464653197],
            [31.10849814639333, -0.775058854599761],
            [31.10856418334649, -0.774263152043474],
            [31.11288323023195, -0.770928438186294],
            [31.11835504559563, -0.765511635701326],
            [31.1164977913221, -0.761806824780738],
            [31.116677134578698, -0.759088412734209],
            [31.11430796006917, -0.753318045441516],
            [31.112344785440516, -0.750224928896061],
            [31.108248537813537, -0.746998851041966],
            [31.105553263177782, -0.743638657358108],
            [31.10352560388478, -0.742209327936896],
            [31.10030251062912, -0.740958044528692],
            [31.097542369545017, -0.73917129177424],
            [31.090220425344654, -0.739162025524941],
            [31.089563522411673, -0.738654598640864],
            [31.088775562465255, -0.737287177071488],
            [31.088754061288924, -0.736339030693685],
            [31.091384387729644, -0.731952264220589],
            [31.089852632609464, -0.729501682469688],
            [31.082152096127537, -0.730240048500462],
            [31.072122844358226, -0.730235744123222],
            [31.06993599281706, -0.731143918222821],
            [31.06537276137953, -0.731572580911485],
            [31.06405547544014, -0.732416656199781],
            [31.062271256894196, -0.735915744435247],
            [31.060304326409348, -0.737704340790154],
            [31.056477276025237, -0.743396367991966],
            [31.05370065175399, -0.749007496088494],
            [31.05267559586138, -0.752585929605008],
            [31.054182837754094, -0.754945420895499],
            [31.054316856513, -0.756409573504856],
            [31.053077448220552, -0.757439303299617],
            [31.049871665500426, -0.758956171667777],
            [31.047526981760498, -0.762208637109887],
            [31.045344579574962, -0.763942855224961],
            [31.040953562363885, -0.765811620167752],
            [31.036562131029473, -0.768602195711562],
            [31.028777066672603, -0.771445400547133],
            [31.024925360228885, -0.771958742963143],
            [31.023255195384653, -0.772608660842105],
            [31.01676369335882, -0.773879898348532],
            [31.015713009429486, -0.774502986605623],
            [31.012669511857002, -0.774610003905678],
            [31.00889835914144, -0.77571982296379],
            [31.006474484417627, -0.775501781399648],
            [31.004103732466458, -0.776883373113517],
            [31.003537478528816, -0.778292928147014],
            [31.00340196048169, -0.78010936746246],
            [31.001756233406432, -0.781416777198957],
            [30.99858660787648, -0.781207167631186],
            [30.995184175855815, -0.779813850015726],
            [30.989069650940625, -0.77900802887048],
            [30.978331228661816, -0.773757327221023],
            [30.966849387603332, -0.766579390994087],
            [30.96695818885562, -0.761333933205143],
            [30.964834548167747, -0.754374609913711],
            [30.961965397422233, -0.749770074482462],
            [30.956332014664827, -0.743665559634718],
            [30.951018011736974, -0.736811879156212],
            [30.950275123861648, -0.733492982498782],
            [30.951021165721944, -0.729853621042635],
            [30.950494485267505, -0.718613117519523],
            [30.951132547834025, -0.713202324910867],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 285,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "RUGAAGA",
        Population: 33015,
        Key: "ISINGIRORUGAAGA",
        Dist2: "Isingiro",
        "Sub Country": "Rugaaga",
        id2_original: "IsingiroRugaaga",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.122653601011127, -0.909557001324225],
              [31.124687171218692, -0.904824952524854],
              [31.12411929043207, -0.899848300308667],
              [31.124500375538517, -0.89826946035117],
              [31.124167909051852, -0.897719018798102],
              [31.12759354006476, -0.891596021903128],
              [31.130161884547476, -0.888726347058945],
              [31.13082814523079, -0.887195492655438],
              [31.131209466594164, -0.885114221126981],
              [31.13085329895705, -0.884420218779675],
              [31.13075940884018, -0.882051606901973],
              [31.132139160929466, -0.877190342115476],
              [31.12915436646417, -0.876562901055146],
              [31.11988742863821, -0.871414887740926],
              [31.118818586163684, -0.869978997758811],
              [31.11739434770491, -0.866270290479494],
              [31.111573377851546, -0.861961339376659],
              [31.109554363046524, -0.859448478130168],
              [31.106928205687034, -0.853682807050986],
              [31.101957250501588, -0.856259907029662],
              [31.098390675617257, -0.859344392166423],
              [31.09646497870224, -0.860491803209163],
              [31.094682276512497, -0.860849777390849],
              [31.093184458845432, -0.861853851048153],
              [31.08850233717664, -0.86288969424924],
              [31.08552698669993, -0.865292754789151],
              [31.081714938181072, -0.868107524649819],
              [31.081213300061787, -0.870432415911658],
              [31.079203758889747, -0.873330424538491],
              [31.077874395101386, -0.880070181033382],
              [31.077885339276495, -0.887737974971225],
              [31.08176074866729, -0.892566835718587],
              [31.083326509512553, -0.898094162190203],
              [31.083890652409288, -0.910080522868403],
              [31.08251495801016, -0.914496520240303],
              [31.08198259032166, -0.918928545044903],
              [31.086018764012312, -0.919135918702738],
              [31.090594799137616, -0.918032473017094],
              [31.094380813581253, -0.914811221964458],
              [31.095669674130082, -0.913159921659416],
              [31.097001603506882, -0.910105753361475],
              [31.09879002077849, -0.908600184229988],
              [31.10522093952325, -0.907648983343026],
              [31.108590480628123, -0.905979850428602],
              [31.110921538721808, -0.906300508879569],
              [31.111886473965736, -0.904924973745008],
              [31.112716242403767, -0.905306275373726],
              [31.11439938790386, -0.907629227377472],
              [31.120392350099827, -0.907435781483847],
              [31.12129529440262, -0.907939983897981],
              [31.122653601011127, -0.909557001324225],
            ],
          ],
          [
            [
              [31.198286208023628, -0.77162445448086],
              [31.18894489508202, -0.77488946220647],
              [31.18271527531771, -0.780724631200658],
              [31.17958462050141, -0.786636892621005],
              [31.178576655057082, -0.787804796162878],
              [31.175057944207722, -0.790339354479758],
              [31.168307116525657, -0.792250405353212],
              [31.16345829269296, -0.792822459778673],
              [31.160939089649524, -0.792486382787238],
              [31.152538813172, -0.790192634923357],
              [31.150774165322826, -0.788695134584933],
              [31.149313107615512, -0.786617108193318],
              [31.149288606964447, -0.78579115361381],
              [31.14809538285737, -0.785290051278211],
              [31.146319760290385, -0.782852235708968],
              [31.13918321488995, -0.781219982704048],
              [31.136835408606082, -0.779297459054182],
              [31.13602033840272, -0.775983022277661],
              [31.13532962917064, -0.775300305038128],
              [31.133476387671514, -0.774478613945543],
              [31.132320318782924, -0.774540740245605],
              [31.13128570930729, -0.773943584888639],
              [31.12768368510519, -0.773104637569244],
              [31.12677374292637, -0.772009743776986],
              [31.12608922398492, -0.77216202134022],
              [31.12543456773845, -0.771233667958321],
              [31.12410828157825, -0.771216800023834],
              [31.12233499552931, -0.767693396122949],
              [31.120143841057953, -0.767645163616716],
              [31.119142497993888, -0.766872713178074],
              [31.11835504559563, -0.765511635701326],
              [31.11288323023195, -0.770928438186294],
              [31.10856418334649, -0.774263152043474],
              [31.10849814639333, -0.775058854599761],
              [31.10774257610279, -0.776116464653197],
              [31.107807265583038, -0.778359005715291],
              [31.10695382384229, -0.780447396410277],
              [31.108082404283202, -0.781415437037201],
              [31.108639655305097, -0.78320608318846],
              [31.10722574657375, -0.788160653462447],
              [31.108258468688987, -0.791271702558587],
              [31.108026751854723, -0.795304490205054],
              [31.110193306860328, -0.796462901521886],
              [31.110783718292616, -0.798145067570035],
              [31.112900536275898, -0.80002685057104],
              [31.11381921187593, -0.801455983610531],
              [31.115263648953878, -0.802315673372813],
              [31.116346059582433, -0.804160818481752],
              [31.11654235135346, -0.805851846864429],
              [31.118166298774657, -0.808854675110669],
              [31.11918381690372, -0.809587587751546],
              [31.11928163535329, -0.81114292258077],
              [31.118919814618103, -0.812327314156045],
              [31.1194232349949, -0.815186073193976],
              [31.12777935927622, -0.819584338664303],
              [31.130024586937765, -0.821343711766463],
              [31.133375397270658, -0.822278271355151],
              [31.1397570389305, -0.822281260640554],
              [31.141610496923626, -0.823215119396142],
              [31.142144893008034, -0.824040708903695],
              [31.14494841553384, -0.825154743423967],
              [31.146209125576625, -0.822906372443941],
              [31.148349193756083, -0.820730183203931],
              [31.148397726137606, -0.818553019105434],
              [31.148755374198306, -0.818605913697108],
              [31.149391685050023, -0.819033362117351],
              [31.14972386048253, -0.820277623338159],
              [31.152004462901676, -0.822623349667778],
              [31.153192003367945, -0.824442216082948],
              [31.154521024898173, -0.828701522809718],
              [31.15523350030956, -0.829898117807346],
              [31.156089089023837, -0.829994218476621],
              [31.1590842500475, -0.829038608192197],
              [31.162316847478888, -0.828609459614025],
              [31.167166728628665, -0.825836369106962],
              [31.17315746569769, -0.823063783262749],
              [31.17743586651145, -0.82263508854018],
              [31.1820929431501, -0.823454943915344],
              [31.179855423033683, -0.833115591015512],
              [31.178428337813774, -0.835316078386962],
              [31.177096939341286, -0.836176777672798],
              [31.17536827081586, -0.838560537750085],
              [31.17429018288047, -0.840817012520822],
              [31.173529344869113, -0.84139086635027],
              [31.17129500748375, -0.841724771849646],
              [31.16844224200899, -0.843063250792773],
              [31.1660167395379, -0.845598194630054],
              [31.163164826564383, -0.84511833450079],
              [31.162260417109355, -0.847749689809192],
              [31.15997679185931, -0.851815899659414],
              [31.158500006447984, -0.858514267858236],
              [31.156453363058063, -0.863968231934508],
              [31.15645239557252, -0.865977951904022],
              [31.15768622173377, -0.870332949751611],
              [31.160774517391175, -0.873492601907974],
              [31.1712799705842, -0.873497748656378],
              [31.17441685072542, -0.874552001087395],
              [31.180879878851698, -0.878526793935854],
              [31.182685340757498, -0.880441723501565],
              [31.191001852029718, -0.885422328946561],
              [31.195468236096477, -0.889731149782401],
              [31.199222594807804, -0.891934166103798],
              [31.200791250024913, -0.892078490809752],
              [31.2039668197071, -0.893206947760525],
              [31.198695607129515, -0.900307937569564],
              [31.192822192731544, -0.905544751895173],
              [31.18809120001639, -0.90767176535294],
              [31.183359914450417, -0.910396900125359],
              [31.178937378949307, -0.913600681534408],
              [31.17639291887335, -0.916063713337512],
              [31.173564118653758, -0.916780030835263],
              [31.171067435476186, -0.918764561610879],
              [31.16902292019519, -0.91962482403456],
              [31.167714870733562, -0.921179300875095],
              [31.160393237350295, -0.923137386234525],
              [31.15685065377224, -0.925312741957779],
              [31.155447084649847, -0.927728455809972],
              [31.15413548504623, -0.936101588730915],
              [31.149260909209303, -0.940094506884906],
              [31.148785041958877, -0.94105125800464],
              [31.145928216099076, -0.943955126471688],
              [31.14509398572899, -0.944844807551409],
              [31.144631637225313, -0.946077819932351],
              [31.14279744001019, -0.946921546240176],
              [31.143490684288018, -0.948590485600742],
              [31.143117208810317, -0.949549710695926],
              [31.143167952844095, -0.95153116102982],
              [31.141446966710973, -0.953772365225083],
              [31.141404928250637, -0.954888194689319],
              [31.139684301443623, -0.956451538965604],
              [31.13780690334819, -0.960548920877756],
              [31.136408078228794, -0.96092358155679],
              [31.136246084135315, -0.962113015252018],
              [31.140582139722348, -0.965165834908068],
              [31.14474137182715, -0.965586805638802],
              [31.146805486551024, -0.966377301458107],
              [31.14832400409721, -0.967982143004663],
              [31.149807012138496, -0.971080405610053],
              [31.155224365341446, -0.974528616368811],
              [31.155794316744807, -0.975438089986725],
              [31.156197225522803, -0.977567660148196],
              [31.161304553053213, -0.982953672381448],
              [31.166644861347503, -0.991663261586624],
              [31.16974806993693, -0.993915969964904],
              [31.172074923016762, -0.996618447352297],
              [31.17509319948934, -0.999122192405854],
              [31.270800494088665, -0.999308781841387],
              [31.2647305498661, -0.986057357877558],
              [31.264322912356487, -0.984393210769129],
              [31.27084144828247, -0.949707013738378],
              [31.25109964130564, -0.932397624786352],
              [31.209893715305533, -0.901043267784906],
              [31.203490463773186, -0.88774711782493],
              [31.20338779891264, -0.885251244566016],
              [31.203477747222045, -0.883252822703668],
              [31.206184600243496, -0.880224771835364],
              [31.206274986930747, -0.877891767717602],
              [31.205990627024175, -0.876327473877887],
              [31.20539191426037, -0.875939416506048],
              [31.203729474927588, -0.873067506512804],
              [31.209605699255743, -0.868723887675185],
              [31.227062023266505, -0.855683148781791],
              [31.227649940077256, -0.847526667922081],
              [31.227430980218337, -0.845008689979327],
              [31.221741494078138, -0.837345691771139],
              [31.215344279224514, -0.834725282340981],
              [31.21280958922559, -0.834494540406832],
              [31.20597520025582, -0.829497079153166],
              [31.201937237121083, -0.828340056076804],
              [31.19968299306901, -0.825946231533137],
              [31.19813889419851, -0.826450708876017],
              [31.195551574602, -0.82464056691291],
              [31.19374014428948, -0.824059694630046],
              [31.192417587934333, -0.82226488064999],
              [31.19160874125923, -0.818302499143032],
              [31.192160916799757, -0.817476920127871],
              [31.192646007951513, -0.813765821238339],
              [31.193999275011272, -0.812394962174958],
              [31.193602260079867, -0.810803308085431],
              [31.19394518475308, -0.809296136884954],
              [31.19366164231343, -0.805491808950424],
              [31.193005996123524, -0.804694788234841],
              [31.193099218792145, -0.803488970823608],
              [31.193596668965565, -0.802664181923409],
              [31.194138935190185, -0.802510479089502],
              [31.194264452293258, -0.801609267011853],
              [31.193469861881727, -0.800156251049969],
              [31.194915781179883, -0.79750774592229],
              [31.194484364366367, -0.7954897031716],
              [31.19522572959731, -0.790116927619479],
              [31.199658978406532, -0.778770101511134],
              [31.199169864598947, -0.775456902984024],
              [31.198286208023628, -0.77162445448086],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 286,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "ENDIINZI",
        Population: 16753,
        Key: "ISINGIROENDIINZI",
        Dist2: "Isingiro",
        "Sub Country": "Endiizi",
        id2_original: "IsingiroEndiizi",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.145928216099076, -0.943955126471688],
            [31.148785041958877, -0.94105125800464],
            [31.149260909209303, -0.940094506884906],
            [31.15413548504623, -0.936101588730915],
            [31.155447084649847, -0.927728455809972],
            [31.15685065377224, -0.925312741957779],
            [31.160393237350295, -0.923137386234525],
            [31.167714870733562, -0.921179300875095],
            [31.16902292019519, -0.91962482403456],
            [31.171067435476186, -0.918764561610879],
            [31.173564118653758, -0.916780030835263],
            [31.17639291887335, -0.916063713337512],
            [31.178937378949307, -0.913600681534408],
            [31.183359914450417, -0.910396900125359],
            [31.18809120001639, -0.90767176535294],
            [31.192822192731544, -0.905544751895173],
            [31.198695607129515, -0.900307937569564],
            [31.2039668197071, -0.893206947760525],
            [31.200791250024913, -0.892078490809752],
            [31.199222594807804, -0.891934166103798],
            [31.195468236096477, -0.889731149782401],
            [31.191001852029718, -0.885422328946561],
            [31.182685340757498, -0.880441723501565],
            [31.180879878851698, -0.878526793935854],
            [31.17441685072542, -0.874552001087395],
            [31.1712799705842, -0.873497748656378],
            [31.160774517391175, -0.873492601907974],
            [31.15768622173377, -0.870332949751611],
            [31.15645239557252, -0.865977951904022],
            [31.156453363058063, -0.863968231934508],
            [31.158500006447984, -0.858514267858236],
            [31.15997679185931, -0.851815899659414],
            [31.162260417109355, -0.847749689809192],
            [31.163164826564383, -0.84511833450079],
            [31.1660167395379, -0.845598194630054],
            [31.16844224200899, -0.843063250792773],
            [31.17129500748375, -0.841724771849646],
            [31.173529344869113, -0.84139086635027],
            [31.17429018288047, -0.840817012520822],
            [31.17536827081586, -0.838560537750085],
            [31.177096939341286, -0.836176777672798],
            [31.178428337813774, -0.835316078386962],
            [31.179855423033683, -0.833115591015512],
            [31.1820929431501, -0.823454943915344],
            [31.17743586651145, -0.82263508854018],
            [31.17315746569769, -0.823063783262749],
            [31.167166728628665, -0.825836369106962],
            [31.162316847478888, -0.828609459614025],
            [31.1590842500475, -0.829038608192197],
            [31.156089089023837, -0.829994218476621],
            [31.15523350030956, -0.829898117807346],
            [31.154521024898173, -0.828701522809718],
            [31.153192003367945, -0.824442216082948],
            [31.152004462901676, -0.822623349667778],
            [31.14972386048253, -0.820277623338159],
            [31.149391685050023, -0.819033362117351],
            [31.148755374198306, -0.818605913697108],
            [31.148397726137606, -0.818553019105434],
            [31.148349193756083, -0.820730183203931],
            [31.146209125576625, -0.822906372443941],
            [31.14494841553384, -0.825154743423967],
            [31.142144893008034, -0.824040708903695],
            [31.141610496923626, -0.823215119396142],
            [31.1397570389305, -0.822281260640554],
            [31.133375397270658, -0.822278271355151],
            [31.130024586937765, -0.821343711766463],
            [31.12777935927622, -0.819584338664303],
            [31.1194232349949, -0.815186073193976],
            [31.11900004764773, -0.816694843729277],
            [31.118014619137245, -0.817553406582825],
            [31.117095181765844, -0.81777904130211],
            [31.116010830776254, -0.819496579544405],
            [31.11471806345425, -0.819747758728121],
            [31.114644149174378, -0.821148432695333],
            [31.115102598989743, -0.821631483537928],
            [31.11501266146011, -0.822251477369686],
            [31.115853513312132, -0.824341389731666],
            [31.115777599382415, -0.826746724157919],
            [31.112492561898033, -0.829875576949958],
            [31.110948400145446, -0.832189685639332],
            [31.11079922321442, -0.833956065560334],
            [31.108894502859627, -0.836468800537736],
            [31.10725495170195, -0.840877198552966],
            [31.107814253577622, -0.842253406545653],
            [31.10986309963663, -0.844467434800449],
            [31.110721522535613, -0.846035694769905],
            [31.11403859304472, -0.848714210325274],
            [31.108850049727796, -0.852651557528136],
            [31.106928205687034, -0.853682807050986],
            [31.109554363046524, -0.859448478130168],
            [31.111573377851546, -0.861961339376659],
            [31.11739434770491, -0.866270290479494],
            [31.118818586163684, -0.869978997758811],
            [31.11988742863821, -0.871414887740926],
            [31.12915436646417, -0.876562901055146],
            [31.132139160929466, -0.877190342115476],
            [31.13075940884018, -0.882051606901973],
            [31.13085329895705, -0.884420218779675],
            [31.131209466594164, -0.885114221126981],
            [31.13082814523079, -0.887195492655438],
            [31.130161884547476, -0.888726347058945],
            [31.12759354006476, -0.891596021903128],
            [31.124167909051852, -0.897719018798102],
            [31.124500375538517, -0.89826946035117],
            [31.12411929043207, -0.899848300308667],
            [31.124687171218692, -0.904824952524854],
            [31.122653601011127, -0.909557001324225],
            [31.123564319334374, -0.91025096566921],
            [31.123746774355077, -0.911467390447147],
            [31.12109257967728, -0.914394484620889],
            [31.125232782769434, -0.918811824883601],
            [31.128255374748637, -0.919480063002443],
            [31.128583621848406, -0.919861715182765],
            [31.130426143751265, -0.923372301112128],
            [31.13411228889146, -0.928282632862562],
            [31.13933932591664, -0.93375330728945],
            [31.14193955520207, -0.937747538586224],
            [31.146156155517577, -0.942912526802112],
            [31.14640859558715, -0.943319577358205],
            [31.145928216099076, -0.943955126471688],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 287,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "ENDIINZI TOWN COUNCIL",
        Population: 7298,
        Key: "ISINGIROENDIINZI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.91175003920518, -0.711868820605236],
            [29.911353433905553, -0.711499645996294],
            [29.910764299877602, -0.711603012554353],
            [29.911004449197456, -0.71077445060664],
            [29.910267895343168, -0.709756610041055],
            [29.910379344828893, -0.708445573481359],
            [29.909746647001242, -0.708312182958858],
            [29.908825750765818, -0.707346787789752],
            [29.908795317640614, -0.706913854356433],
            [29.909336178900137, -0.706567883766559],
            [29.908766755706168, -0.703639153960459],
            [29.90914199367844, -0.702903449641324],
            [29.908718450598414, -0.702352751019742],
            [29.91009553289466, -0.700934325921184],
            [29.911667785864484, -0.700788232159121],
            [29.912498678094952, -0.699380514605484],
            [29.91078500514657, -0.69879804003006],
            [29.911098922320935, -0.697879850351707],
            [29.910295253535136, -0.697459937953251],
            [29.90949496870304, -0.697603070292912],
            [29.909796687654158, -0.696051223244628],
            [29.909271837966227, -0.695871303068866],
            [29.909115120576732, -0.693890739891228],
            [29.908692112892584, -0.693689052354427],
            [29.9083284640858, -0.694393293341335],
            [29.907088051476865, -0.694758093032677],
            [29.90721264690845, -0.693866430567433],
            [29.90679670088075, -0.693250854815682],
            [29.907240435393433, -0.691993787668211],
            [29.90633635023025, -0.691669082043469],
            [29.905176577587763, -0.691765042969959],
            [29.903882494233844, -0.692941292866859],
            [29.90253542375293, -0.693469261488891],
            [29.90042424090141, -0.693505109727546],
            [29.89888340111875, -0.69396647938241],
            [29.898369119211875, -0.69293319873983],
            [29.89885015896166, -0.692212997434621],
            [29.898850851562752, -0.691142514490875],
            [29.898299869883235, -0.689335712262227],
            [29.8965215892013, -0.688006740922172],
            [29.897984742678204, -0.68587623303513],
            [29.897023903752007, -0.685994769818128],
            [29.89643119532754, -0.685469434937438],
            [29.89531579317185, -0.686847982340344],
            [29.894436179015308, -0.687269423603065],
            [29.89348608573652, -0.685992465804589],
            [29.890986039266522, -0.686310179831677],
            [29.890827178496746, -0.68598981776092],
            [29.891587909608585, -0.684842721582867],
            [29.891163941625397, -0.684507953261603],
            [29.890559176013195, -0.68498438835704],
            [29.890202278045766, -0.684799117778824],
            [29.888661909878614, -0.68210342138868],
            [29.88744061162232, -0.683388956727216],
            [29.88551639692752, -0.682315765373791],
            [29.885690629668453, -0.680591780436377],
            [29.88489616771601, -0.678460167105698],
            [29.887206970596704, -0.678884027198741],
            [29.888416027510623, -0.678614480561446],
            [29.89100342615884, -0.676789101345408],
            [29.890002605015994, -0.676093501656699],
            [29.88981117492726, -0.675175238449991],
            [29.88815586911615, -0.673917774932447],
            [29.887521123129645, -0.6718757217342],
            [29.886609644831662, -0.670957001419999],
            [29.885832038867218, -0.667078587471237],
            [29.884632970320926, -0.665483169726744],
            [29.885113382148333, -0.664867356812771],
            [29.88505526114946, -0.661847137597157],
            [29.88391625126812, -0.660155117058044],
            [29.88479295218817, -0.659098606606706],
            [29.88461339872583, -0.65836156876544],
            [29.885142696871014, -0.656308176728672],
            [29.884771070126178, -0.65566766421802],
            [29.88605616224242, -0.654007367114024],
            [29.885900585713298, -0.653300546782785],
            [29.886657163015258, -0.652431202012874],
            [29.886694175401598, -0.650776163136347],
            [29.887522753571876, -0.649906861047173],
            [29.887991641810853, -0.648493701499644],
            [29.888136509523434, -0.647080341246057],
            [29.8872488473603, -0.64644555485626],
            [29.88723752589278, -0.645322036844939],
            [29.885678123323064, -0.644197571821042],
            [29.885666622192492, -0.64337003403906],
            [29.88429888956171, -0.642798624731408],
            [29.88231892003049, -0.642594817900939],
            [29.88223526711461, -0.64201489301234],
            [29.88045266194289, -0.641072838525865],
            [29.87932659049661, -0.639875397984434],
            [29.879171171172647, -0.640468476324332],
            [29.87826180930549, -0.639905968441913],
            [29.878561728032754, -0.639687614186979],
            [29.87828940644932, -0.639312170531236],
            [29.877455801306713, -0.639374743278073],
            [29.876949594355885, -0.638822888632819],
            [29.87496501017908, -0.638467857861303],
            [29.874562348437824, -0.637635090384107],
            [29.87379742039698, -0.637561779819997],
            [29.87317764752963, -0.636770510002946],
            [29.872195783534195, -0.636447310724752],
            [29.871111615800952, -0.634334138693832],
            [29.8700554189107, -0.634442700627636],
            [29.869782326572754, -0.633744357161526],
            [29.86910809244297, -0.634117621145063],
            [29.868581989605264, -0.631806438279774],
            [29.867879210609043, -0.630911167843978],
            [29.864994264785892, -0.631469393799103],
            [29.863873838352806, -0.632569123511276],
            [29.864031535804305, -0.63635354676634],
            [29.863457357827528, -0.63795012710279],
            [29.864015870982385, -0.640218381206206],
            [29.8633506855825, -0.642687572102492],
            [29.85960151015036, -0.64565430168352],
            [29.858490455840656, -0.647268342149813],
            [29.858185689804085, -0.648937259358348],
            [29.856574504748153, -0.649648565301572],
            [29.85584197804132, -0.650883994437512],
            [29.844202205071035, -0.660033233644646],
            [29.840723820493075, -0.661240076831949],
            [29.839417429321493, -0.662197267639962],
            [29.836283614232002, -0.665576187592144],
            [29.833668632813, -0.665498093330172],
            [29.83230634936271, -0.666717574523298],
            [29.829499208422963, -0.667432013736582],
            [29.82741643658894, -0.672414587584987],
            [29.826045482599568, -0.673295055510074],
            [29.824084865474518, -0.673614704311746],
            [29.822759680648858, -0.677297349715014],
            [29.821909290485156, -0.682541836429663],
            [29.819920096154274, -0.682904555779326],
            [29.817501398421463, -0.685192557143871],
            [29.81681499032298, -0.687041029893832],
            [29.81668028255624, -0.689277856860275],
            [29.815664443378452, -0.690646256530493],
            [29.814094715572867, -0.690834809087189],
            [29.81232353876821, -0.689738106808041],
            [29.810090717739016, -0.690495033442107],
            [29.807795685681498, -0.690397805957339],
            [29.80550146749758, -0.691704190137905],
            [29.804674997673256, -0.691112226401445],
            [29.80339582275983, -0.691891471629114],
            [29.801689478267537, -0.692358171654823],
            [29.802264574322543, -0.694975897809333],
            [29.803595100530877, -0.694426439639115],
            [29.804773664132483, -0.695388829236918],
            [29.804941711972706, -0.696340793561321],
            [29.80328390794677, -0.700175844296758],
            [29.80181246481645, -0.701749112296673],
            [29.801711225582235, -0.705141496089641],
            [29.802285321812338, -0.707187906786363],
            [29.801906993635487, -0.708426314175652],
            [29.802312680902634, -0.709306523918711],
            [29.802399457260755, -0.711413148496576],
            [29.803947160172207, -0.712744009396723],
            [29.804686471854378, -0.714076039427953],
            [29.80478342163312, -0.715170942199498],
            [29.802994063825423, -0.718589547580359],
            [29.803164458963458, -0.720946019012772],
            [29.802405938605514, -0.722327805775226],
            [29.802969259543797, -0.724415669038748],
            [29.80308829440379, -0.725147739215774],
            [29.804982437096086, -0.727489842544179],
            [29.80646186355438, -0.730653833689152],
            [29.80701420168995, -0.733938168116703],
            [29.809080166045014, -0.739517578754968],
            [29.814387869087753, -0.742842824166089],
            [29.817362042771435, -0.744100313876009],
            [29.818873937039022, -0.745347970202109],
            [29.81938074316611, -0.749870305308143],
            [29.824081585725416, -0.756499637033436],
            [29.822269992817787, -0.765093569216887],
            [29.821909476436385, -0.768707444536459],
            [29.821996784597182, -0.771403051515142],
            [29.8227769875911, -0.773043888240159],
            [29.821905274117494, -0.776558982646467],
            [29.82206606087524, -0.780216918170236],
            [29.82303481036585, -0.780498970193686],
            [29.823349079679815, -0.781392657880168],
            [29.82456532401434, -0.782142927436454],
            [29.82745823250416, -0.780545555196387],
            [29.829850565581722, -0.778328135264293],
            [29.833171698272544, -0.778402694840458],
            [29.835290917452564, -0.77769816980419],
            [29.835977881608216, -0.777943669323857],
            [29.836349613455944, -0.778578017222887],
            [29.836664997579142, -0.777987419533097],
            [29.839160083552134, -0.777765583951809],
            [29.83965913362509, -0.778777329586477],
            [29.841164657040657, -0.779127421900111],
            [29.84171632054148, -0.780229239218521],
            [29.844488823342207, -0.781234588851042],
            [29.845769505628695, -0.780172639823686],
            [29.846736655219768, -0.780172385624042],
            [29.847271712464245, -0.780790933288765],
            [29.848136609521507, -0.780672072957853],
            [29.84793500601218, -0.777935540319879],
            [29.848957131600322, -0.777512762928124],
            [29.849739174343963, -0.776629958305157],
            [29.851171989018756, -0.776935674509015],
            [29.85311807319913, -0.778280792128928],
            [29.853971877859237, -0.778192149164397],
            [29.85509040166054, -0.777259111922323],
            [29.85623498468991, -0.777802364776853],
            [29.858473684294278, -0.777150760813799],
            [29.86213031977742, -0.775337320323432],
            [29.863854350301043, -0.775301651489431],
            [29.86481933315565, -0.776007723682298],
            [29.866161465597486, -0.775006113945063],
            [29.867301644187023, -0.775001207795838],
            [29.86761096108879, -0.773943815734598],
            [29.868141135989706, -0.773505353890243],
            [29.870375127523683, -0.772750829663116],
            [29.870684702241952, -0.77130958668723],
            [29.870202366223197, -0.770526043721203],
            [29.870136675121383, -0.768628792433815],
            [29.86920537280175, -0.767287913221866],
            [29.8684964340576, -0.76451923490039],
            [29.86765864276575, -0.763708430141732],
            [29.866447066077445, -0.760847328207478],
            [29.867532074633807, -0.760524794074643],
            [29.868608859113714, -0.755056532848716],
            [29.870767811677084, -0.752696909577452],
            [29.87037387078058, -0.752367791653597],
            [29.872707910382726, -0.748458622012857],
            [29.871941407595177, -0.747255667427448],
            [29.87283094364403, -0.744587064460616],
            [29.87798800460351, -0.743988510000377],
            [29.880761682400646, -0.740538723542576],
            [29.88126589868477, -0.739330740244275],
            [29.882354407077496, -0.733094910515064],
            [29.883491500852333, -0.731551384195305],
            [29.886888118078183, -0.728764282826847],
            [29.88720473199501, -0.727541881346526],
            [29.888452866522126, -0.72685551595766],
            [29.888100280468034, -0.726085100056948],
            [29.889325598685275, -0.724332322821566],
            [29.88774844989713, -0.724200899914789],
            [29.887454471728834, -0.723785989533607],
            [29.889268200830195, -0.722187649184757],
            [29.89028143758859, -0.720742791264681],
            [29.890293695998956, -0.72002002079989],
            [29.89148287768725, -0.719475788885833],
            [29.891742651602797, -0.718255536199037],
            [29.89127662180305, -0.716347108942518],
            [29.892779145743912, -0.717374307761525],
            [29.894262435856223, -0.716684578706427],
            [29.894430576222874, -0.717422264156812],
            [29.895062975809864, -0.717765457457326],
            [29.895686283547857, -0.717920684934453],
            [29.89626066813713, -0.717517322715027],
            [29.897203897388827, -0.718079772163956],
            [29.897831552074482, -0.717767343771406],
            [29.89831439384477, -0.718338093868683],
            [29.89951227751319, -0.71836232491721],
            [29.899971348962715, -0.718830940040593],
            [29.900140826920843, -0.717578348571175],
            [29.90043937481901, -0.717529340332809],
            [29.901104547642504, -0.718678670513887],
            [29.902279553017273, -0.719382767586828],
            [29.903965966588366, -0.719313671028067],
            [29.908228084539303, -0.717429693540087],
            [29.91049365185553, -0.714422002269651],
            [29.91175003920518, -0.711868820605236],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 288,
        District: "RUKUNGIRI",
        County: "RUJUMBURA",
        Subcounty: "BUGANGARI",
        Population: 29942,
        Key: "RUKUNGIRIBUGANGARI",
        Dist2: "Rukungiri",
        "Sub Country": "Bugangari",
        id2_original: "Rukungiri Bugangari",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.97613015133942, -0.803010382899012],
            [29.970772592696733, -0.800302875040083],
            [29.967418670599727, -0.79715304275112],
            [29.96263962340674, -0.794304462380795],
            [29.957329685355553, -0.79281875368465],
            [29.954922805858626, -0.792805476957553],
            [29.954139759696826, -0.794260387183611],
            [29.95234527969537, -0.795123721666203],
            [29.95215335283827, -0.797989868118663],
            [29.95042196690912, -0.800783175302899],
            [29.95061014779149, -0.803555964182234],
            [29.951108776554566, -0.804533746066783],
            [29.949776728600117, -0.805131159312285],
            [29.949287611199274, -0.807360204103414],
            [29.94563788196405, -0.811091352773361],
            [29.9459157066269, -0.814707801027772],
            [29.943887950315847, -0.816934043475277],
            [29.943379229878882, -0.820141581140889],
            [29.944121104454574, -0.82089604099839],
            [29.943656480518257, -0.822427713166568],
            [29.941337320610494, -0.823150046763705],
            [29.938261309414628, -0.822982951312084],
            [29.93478275236013, -0.823955866409842],
            [29.932367037034084, -0.823527151124091],
            [29.931497371719324, -0.823824689110553],
            [29.92991362839869, -0.825660098430201],
            [29.92965566548673, -0.826902288979162],
            [29.928628776132644, -0.826623773764127],
            [29.92846636072926, -0.828493106713941],
            [29.927939723393944, -0.829281577032254],
            [29.92699469391843, -0.82969148923453],
            [29.926242054830684, -0.831203817523278],
            [29.92554376561423, -0.831840857189358],
            [29.92477080932969, -0.831861865671173],
            [29.923857338568443, -0.833114706268476],
            [29.92333002659834, -0.83476228810466],
            [29.923597016680567, -0.836556377841579],
            [29.922248238502274, -0.837847871808223],
            [29.919960423509732, -0.837524933235567],
            [29.917414802810423, -0.838207686741942],
            [29.916019597003306, -0.837580851878478],
            [29.91461213548076, -0.837638769956741],
            [29.912605702479613, -0.838746967605831],
            [29.911608009270527, -0.839737898885021],
            [29.911173063874575, -0.841000818572657],
            [29.91058702094954, -0.846253205281437],
            [29.908470487732206, -0.847395801294808],
            [29.905053927907055, -0.847445825695943],
            [29.90516347655766, -0.849940224770899],
            [29.904819077749078, -0.851032690249743],
            [29.90264590754971, -0.85363138600547],
            [29.90345508480481, -0.855568547311093],
            [29.90350751228145, -0.85873616005298],
            [29.902144946760167, -0.861459987034142],
            [29.898280126709924, -0.86586927355727],
            [29.894978000573893, -0.871580962532046],
            [29.893352225979434, -0.872955430437874],
            [29.892114415789855, -0.872937097950874],
            [29.891356818900064, -0.87433824132045],
            [29.88937032221, -0.875340324554551],
            [29.888921686489116, -0.877338767723425],
            [29.88755475425725, -0.877545294932903],
            [29.887467830575407, -0.878713360166922],
            [29.88656409485687, -0.880114369338566],
            [29.884792781508292, -0.880770502195518],
            [29.884842384681654, -0.883150078422963],
            [29.885331544303295, -0.884123937586028],
            [29.88495844072813, -0.885023402407002],
            [29.880796012417527, -0.886373113453319],
            [29.882210999127224, -0.889747820503821],
            [29.882564952417134, -0.892304078035673],
            [29.88322407149392, -0.892540309890529],
            [29.883295600746738, -0.893409545332731],
            [29.88395442158285, -0.893793093679429],
            [29.884127422733535, -0.895222229841313],
            [29.885006441307034, -0.895443904290653],
            [29.885593109459517, -0.896067243640924],
            [29.885979855748907, -0.896280129997738],
            [29.885935452024412, -0.897184816711334],
            [29.886575247441137, -0.897134521713419],
            [29.886743076092394, -0.897761704195105],
            [29.88803904501009, -0.898203433309335],
            [29.888930204314633, -0.899543010467101],
            [29.889889261881656, -0.900221712642163],
            [29.88978750342121, -0.901102870818997],
            [29.890527081903024, -0.902510109505746],
            [29.893243112113424, -0.902974831161953],
            [29.893317147665872, -0.9025192244783],
            [29.893649418319807, -0.902537590052172],
            [29.898945018360724, -0.905121567974925],
            [29.900161872651342, -0.904542913992573],
            [29.90144743189151, -0.904724564835052],
            [29.903528821218295, -0.90723300864332],
            [29.906284520133326, -0.907202870350714],
            [29.907193530759216, -0.907886288454115],
            [29.909136115103234, -0.908184214130743],
            [29.91024912594361, -0.90964156705048],
            [29.912525336499314, -0.910190722367572],
            [29.913349177853135, -0.909763423429208],
            [29.914994068596858, -0.910305149699757],
            [29.915796164432574, -0.910968281329639],
            [29.91635255576672, -0.912171270568193],
            [29.91940626898063, -0.913352135812159],
            [29.92019260567133, -0.914871941235116],
            [29.920298869182915, -0.916374079310852],
            [29.922286916365135, -0.918175548186585],
            [29.923047757071448, -0.917500311048586],
            [29.925383893341454, -0.917149636642827],
            [29.92792357438009, -0.917798431736331],
            [29.928442803309242, -0.916322933983779],
            [29.929537006122565, -0.916071475585995],
            [29.93013963374438, -0.915182747429959],
            [29.929534138700163, -0.915206556933795],
            [29.930765013895716, -0.913882633131807],
            [29.93207054178636, -0.91518440730486],
            [29.933152437680242, -0.914981382506091],
            [29.935506771122956, -0.915796779824526],
            [29.936120667211693, -0.912933826447105],
            [29.93571019012745, -0.911033408141063],
            [29.935976968207267, -0.909943104252587],
            [29.93678873440703, -0.908873336531206],
            [29.937758920303768, -0.909101637084718],
            [29.937932212508606, -0.908526412177001],
            [29.939035703003622, -0.90831325707608],
            [29.939315828251935, -0.907149367111255],
            [29.940260063616755, -0.906628316996625],
            [29.94071201412102, -0.904903787825008],
            [29.941815326749605, -0.903832006638375],
            [29.942019146402746, -0.901779223900052],
            [29.942221473055874, -0.901520462090422],
            [29.94302958850231, -0.901909540726544],
            [29.94343534583803, -0.900060368181044],
            [29.943105513211787, -0.898987372991675],
            [29.943785443558763, -0.898858478817033],
            [29.944235312666525, -0.89916451781858],
            [29.944243914933693, -0.899903840783439],
            [29.945327929055036, -0.899941743216088],
            [29.951375295919583, -0.902476284047088],
            [29.954307910843276, -0.902683764639626],
            [29.956893792236997, -0.903505993777545],
            [29.959275922249535, -0.903033447038515],
            [29.96172527139817, -0.903572757250248],
            [29.961614488462388, -0.903800153646953],
            [29.962671041983793, -0.904301453573587],
            [29.964364669924944, -0.904707579810687],
            [29.966602931151463, -0.904650827733016],
            [29.96726914512236, -0.904521608609317],
            [29.96774242432645, -0.903851494061783],
            [29.969117596804388, -0.903874275197351],
            [29.970256089256143, -0.904286191301388],
            [29.97106150706179, -0.905392230719598],
            [29.975579618817548, -0.906755622873276],
            [29.979520134506906, -0.908809394409574],
            [29.981002644881535, -0.90874431785731],
            [29.9827918302127, -0.909641174536189],
            [29.987447439004157, -0.910142502396228],
            [29.99186083324897, -0.911428450712121],
            [29.99575930598638, -0.911288017782913],
            [29.99725035215282, -0.911641502335808],
            [29.99902073754173, -0.911312857549857],
            [30.004691992373235, -0.911957972868664],
            [30.00587543562348, -0.911190996732482],
            [30.00729532623627, -0.909403269541367],
            [30.00708242641224, -0.908562847755229],
            [30.007934319457416, -0.907298669054527],
            [30.0100051868173, -0.906568558664136],
            [30.010218309423514, -0.905087007810377],
            [30.009886914626986, -0.90422841616345],
            [30.01107022223163, -0.903795718317958],
            [30.011117606566227, -0.903127171900145],
            [30.01082169252849, -0.898988928682233],
            [30.01049024473137, -0.898365244919067],
            [30.011436997175615, -0.897363145459942],
            [30.00929503534754, -0.895491157987711],
            [30.00979200132903, -0.894172467125087],
            [30.010667736560137, -0.893576876630253],
            [30.010809732358805, -0.89261929006702],
            [30.011685327452735, -0.892376062088122],
            [30.011779946103314, -0.891734657382449],
            [30.010005001764334, -0.890377971024025],
            [30.011247461633822, -0.889096022186018],
            [30.011200126706534, -0.888309944455645],
            [30.009827359916912, -0.88787515280485],
            [30.00897525486932, -0.886112650250516],
            [30.006892587239893, -0.886372974231097],
            [30.005945915644016, -0.885540995697508],
            [30.007022675869433, -0.88170203478461],
            [30.005839186805133, -0.879749541851164],
            [30.005780031845337, -0.877418491941455],
            [30.00499887394227, -0.875312736918646],
            [30.005235407543108, -0.871473098125974],
            [30.00441873833851, -0.868499970595238],
            [30.00489209839097, -0.867370986102631],
            [30.003046072160203, -0.865797451570338],
            [30.002797441845757, -0.864523338403555],
            [30.00346012723422, -0.863566166554166],
            [30.00314503057189, -0.863000849953759],
            [30.002016332451696, -0.861965852900164],
            [30.002158311182345, -0.861179930264332],
            [30.001730987093275, -0.860668774712129],
            [30.00165344002637, -0.85952747607026],
            [30.000354683636353, -0.858700750645113],
            [29.999352719836462, -0.858609178584312],
            [29.998350178419813, -0.857659498156498],
            [29.998638384014086, -0.855653735829814],
            [29.998380775936713, -0.853741881790643],
            [29.998982717245646, -0.852352311528475],
            [29.999934663748842, -0.852000877361834],
            [29.999854147749932, -0.851594794800101],
            [29.9984589868586, -0.850803584035219],
            [29.99765937576296, -0.848389379212912],
            [29.995408053032175, -0.848143088156622],
            [29.995062354361398, -0.846114642685082],
            [29.99418760727706, -0.845291040177435],
            [29.9942535076863, -0.844256977892985],
            [29.993834357368016, -0.843666771530641],
            [29.99105176918157, -0.84169519531579],
            [29.98894119089626, -0.841491051835647],
            [29.987294913153747, -0.84088217288727],
            [29.9871402556012, -0.839331131495802],
            [29.98802425533294, -0.837348257983839],
            [29.987372935429452, -0.835400706860888],
            [29.98862063247702, -0.832049087177033],
            [29.988550722886668, -0.828574764916206],
            [29.986920452224204, -0.826279654200949],
            [29.986511118695336, -0.824034152778562],
            [29.985290619041294, -0.823400435281963],
            [29.983547899068196, -0.818977362372627],
            [29.982206599364673, -0.817352273601944],
            [29.98031111908086, -0.816651424477783],
            [29.97788461229328, -0.817420136211964],
            [29.97685494265338, -0.816202650166517],
            [29.97585797438475, -0.817334274093544],
            [29.974879653344807, -0.819527835922163],
            [29.975474278774076, -0.822675406163865],
            [29.97451336708435, -0.824680499178971],
            [29.97284732011738, -0.826592600078379],
            [29.97276634597765, -0.829570728795184],
            [29.973369114634977, -0.830857069265624],
            [29.975020481333576, -0.832576618366314],
            [29.974356335284465, -0.833465288829881],
            [29.97437748521949, -0.834970233202178],
            [29.976634231079654, -0.838241178639487],
            [29.976855487032456, -0.840455731036127],
            [29.97852072102408, -0.842997251527134],
            [29.979026174288343, -0.846454888294547],
            [29.97790234683361, -0.847063301992286],
            [29.975976098353048, -0.846992880871676],
            [29.973267378632425, -0.846080997260001],
            [29.96699245952329, -0.851469481980713],
            [29.964648277941574, -0.85257039115337],
            [29.96113565138166, -0.853459368734711],
            [29.961344163833836, -0.85136079334116],
            [29.959884629669205, -0.850859974948911],
            [29.959359494317034, -0.850301111056132],
            [29.959214327465453, -0.849242887183997],
            [29.956791642111092, -0.848241648593633],
            [29.955553425883025, -0.845341594554054],
            [29.956791754400495, -0.844170035801775],
            [29.95983119428286, -0.844481876344843],
            [29.962600582624486, -0.846462182716877],
            [29.96314192807594, -0.846432336753862],
            [29.963384816359113, -0.844891953128474],
            [29.962994958305586, -0.842042662986862],
            [29.96329711743118, -0.840196257219685],
            [29.963659116931087, -0.838743442994344],
            [29.96509307426296, -0.836491353932488],
            [29.964510094593027, -0.835197650796773],
            [29.958644034702257, -0.831519105571166],
            [29.957622951159852, -0.830401422468919],
            [29.95759433352985, -0.829637211529564],
            [29.958821132170634, -0.829020928503338],
            [29.960155836443374, -0.827196793418577],
            [29.958109328699077, -0.825926878443014],
            [29.9552687632442, -0.825297827511517],
            [29.95348461746179, -0.824298969386389],
            [29.95227131241487, -0.820783883472966],
            [29.952350163835554, -0.819758424232074],
            [29.95291068472509, -0.819830517433245],
            [29.953879383910024, -0.820969376421584],
            [29.955265501461408, -0.820733527288608],
            [29.956822377070218, -0.819458034083466],
            [29.95900576201268, -0.819630801064819],
            [29.96066556838334, -0.820579711965265],
            [29.961717242256146, -0.823350860584183],
            [29.964350576256447, -0.82332683492777],
            [29.964960135278996, -0.821464496707687],
            [29.963845690727414, -0.817556880912639],
            [29.96435505705307, -0.815917730765478],
            [29.96538025487948, -0.814506404724822],
            [29.975748640431522, -0.814212452657334],
            [29.975935012106902, -0.810317819955247],
            [29.978328262364336, -0.806721766497911],
            [29.97850627431766, -0.804860741001661],
            [29.977634922865118, -0.804729692425625],
            [29.97613015133942, -0.803010382899012],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 290,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "BUYANJA",
        Population: 31104,
        Key: "RUKUNGIRIBUYANJA",
        Dist2: "Rukungiri",
        "Sub Country": "Buyanja",
        id2_original: "Rukungiri Buyanja",
        drought: "VL",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.052944846942736, -0.778769426938664],
            [30.051406054420596, -0.777792096182776],
            [30.051365861998164, -0.777160027880044],
            [30.052050171632153, -0.776145741655256],
            [30.05046377468816, -0.774535923020928],
            [30.04768689170212, -0.775137215555992],
            [30.045070387638674, -0.777791413526054],
            [30.04483391961486, -0.779029070859224],
            [30.04393477788068, -0.780302403806749],
            [30.041437541340898, -0.780598800588209],
            [30.034681196206364, -0.783033509587083],
            [30.033355901786223, -0.782842830327617],
            [30.03069375162827, -0.785551469699529],
            [30.021333288401433, -0.783855231347438],
            [30.019664595895943, -0.787408759188444],
            [30.017673952582545, -0.789153780768643],
            [30.01535204562663, -0.796924052902389],
            [30.011372115455888, -0.804899519242538],
            [30.006378141839615, -0.801869151127809],
            [30.001572029305418, -0.80030258760722],
            [29.99782737958569, -0.799734576244777],
            [29.99561598157941, -0.796608541185316],
            [29.9933369673817, -0.79618007900144],
            [29.990417821797386, -0.794411007604262],
            [29.98808071265192, -0.793937210674499],
            [29.98662601322017, -0.792631745936216],
            [29.985093552024175, -0.790104100896887],
            [29.983651782044273, -0.790973446300738],
            [29.981784838542122, -0.793114523511261],
            [29.977545334780153, -0.796067851629667],
            [29.97673607847331, -0.797849377148068],
            [29.97675995030364, -0.799449917073285],
            [29.97591917121519, -0.802158839305629],
            [29.97613015133942, -0.803010382899012],
            [29.977634922865118, -0.804729692425625],
            [29.97850627431766, -0.804860741001661],
            [29.978328262364336, -0.806721766497911],
            [29.975935012106902, -0.810317819955247],
            [29.975748640431522, -0.814212452657334],
            [29.97685494265338, -0.816202650166517],
            [29.97788461229328, -0.817420136211964],
            [29.98031111908086, -0.816651424477783],
            [29.982206599364673, -0.817352273601944],
            [29.983547899068196, -0.818977362372627],
            [29.985290619041294, -0.823400435281963],
            [29.986511118695336, -0.824034152778562],
            [29.986920452224204, -0.826279654200949],
            [29.988550722886668, -0.828574764916206],
            [29.98862063247702, -0.832049087177033],
            [29.987372935429452, -0.835400706860888],
            [29.98802425533294, -0.837348257983839],
            [29.9871402556012, -0.839331131495802],
            [29.987294913153747, -0.84088217288727],
            [29.98894119089626, -0.841491051835647],
            [29.99105176918157, -0.84169519531579],
            [29.993834357368016, -0.843666771530641],
            [29.9942535076863, -0.844256977892985],
            [29.99418760727706, -0.845291040177435],
            [29.995062354361398, -0.846114642685082],
            [29.995408053032175, -0.848143088156622],
            [29.99765937576296, -0.848389379212912],
            [29.9984589868586, -0.850803584035219],
            [29.999854147749932, -0.851594794800101],
            [29.999934663748842, -0.852000877361834],
            [30.003304204853716, -0.852385621864396],
            [30.003830932020573, -0.851928372470087],
            [30.003950412444922, -0.85066397787452],
            [30.005137083342, -0.848565374013582],
            [30.005446897012128, -0.842617785818195],
            [30.006347855139808, -0.840597407957896],
            [30.006087431742298, -0.838472763781058],
            [30.00703013727619, -0.837425524608303],
            [30.010431530844407, -0.838793216005313],
            [30.014505177757147, -0.839103522820311],
            [30.017404163349898, -0.838459552774569],
            [30.020777338140064, -0.837114559265533],
            [30.024193541334068, -0.837381708570644],
            [30.023551714826475, -0.83661698161133],
            [30.02358131341677, -0.836087919499277],
            [30.023965244386048, -0.835646332243026],
            [30.02577198010294, -0.835207774632623],
            [30.02749399301041, -0.836267258927097],
            [30.030760547657838, -0.84141367031955],
            [30.03335749000766, -0.843914140732464],
            [30.034086185399808, -0.845648943017646],
            [30.0313675374987, -0.849615031780297],
            [30.02970289100524, -0.850664241950092],
            [30.028836225165225, -0.850378237301531],
            [30.02950233582985, -0.853713576323568],
            [30.028352831829384, -0.85394166648323],
            [30.02744086035629, -0.855919402701075],
            [30.025648053916225, -0.856965417099582],
            [30.022951568351477, -0.861376408243868],
            [30.02198537995776, -0.861159482426795],
            [30.019006508983423, -0.861745015396071],
            [30.016844330569874, -0.863506924898664],
            [30.015123706457814, -0.861164144156495],
            [30.012670624809207, -0.858752709653095],
            [30.01182492385128, -0.859652434730078],
            [30.009546533084357, -0.860679409565115],
            [30.00682934943715, -0.862734793750352],
            [30.00314503057189, -0.863000849953759],
            [30.00346012723422, -0.863566166554166],
            [30.002797441845757, -0.864523338403555],
            [30.003046072160203, -0.865797451570338],
            [30.00489209839097, -0.867370986102631],
            [30.00441873833851, -0.868499970595238],
            [30.005235407543108, -0.871473098125974],
            [30.00499887394227, -0.875312736918646],
            [30.005780031845337, -0.877418491941455],
            [30.005839186805133, -0.879749541851164],
            [30.007022675869433, -0.88170203478461],
            [30.005945915644016, -0.885540995697508],
            [30.006892587239893, -0.886372974231097],
            [30.00897525486932, -0.886112650250516],
            [30.009827359916912, -0.88787515280485],
            [30.011200126706534, -0.888309944455645],
            [30.011247461633822, -0.889096022186018],
            [30.010005001764334, -0.890377971024025],
            [30.011779946103314, -0.891734657382449],
            [30.011685327452735, -0.892376062088122],
            [30.010809732358805, -0.89261929006702],
            [30.010667736560137, -0.893576876630253],
            [30.00979200132903, -0.894172467125087],
            [30.00929503534754, -0.895491157987711],
            [30.011436997175615, -0.897363145459942],
            [30.01049024473137, -0.898365244919067],
            [30.01082169252849, -0.898988928682233],
            [30.011117606566227, -0.903127171900145],
            [30.01107022223163, -0.903795718317958],
            [30.009886914626986, -0.90422841616345],
            [30.010218309423514, -0.905087007810377],
            [30.0100051868173, -0.906568558664136],
            [30.011851250777315, -0.906353251353729],
            [30.012087879599544, -0.905449953743242],
            [30.015709070256513, -0.906022153094272],
            [30.01684506179851, -0.90566169344477],
            [30.017673419881568, -0.906258687653897],
            [30.018241359058702, -0.905464077987212],
            [30.01906981056656, -0.905943616021859],
            [30.0201111556102, -0.90556500637482],
            [30.020454025486153, -0.905773095772506],
            [30.019956964283274, -0.904435502344638],
            [30.021732019115024, -0.902738381717629],
            [30.023601686309107, -0.901971941651854],
            [30.024051444025766, -0.900942315918414],
            [30.025175572416124, -0.897392461976403],
            [30.024276147712627, -0.8963888379963],
            [30.024867783548657, -0.894717837043237],
            [30.025932861183783, -0.894646423397325],
            [30.028299614733633, -0.895723524659223],
            [30.030287613406838, -0.896050406780155],
            [30.03061894262635, -0.894216551069985],
            [30.02962487591608, -0.892824339774585],
            [30.03066619940019, -0.892472815974611],
            [30.03460695404138, -0.894942599554282],
            [30.03619271767309, -0.895467925900599],
            [30.03668972857033, -0.896371843052868],
            [30.038228080917953, -0.89656283204489],
            [30.03943510674107, -0.895434416545101],
            [30.04076047392474, -0.895390315548912],
            [30.041364012438247, -0.893565697557913],
            [30.04339944126014, -0.892483119299127],
            [30.043659760453085, -0.89090810073382],
            [30.04467743309235, -0.890116925167257],
            [30.045316412838808, -0.890099368815481],
            [30.047825112779915, -0.88732756869028],
            [30.04775405334601, -0.886559516715205],
            [30.048795386711557, -0.88638868119072],
            [30.049174076909473, -0.885295719338038],
            [30.051787415309846, -0.884684084514021],
            [30.05242640224282, -0.883897849558769],
            [30.052213369468117, -0.883536268567658],
            [30.052899782956512, -0.883130228013462],
            [30.052497315251323, -0.882894989874395],
            [30.05266291877564, -0.881503689590634],
            [30.052213297602915, -0.881485260138941],
            [30.050745869043585, -0.880074593037534],
            [30.05027244790569, -0.880363345763732],
            [30.05005948609793, -0.87991141355147],
            [30.04994112048281, -0.879549908520971],
            [30.050580160416374, -0.879098652561982],
            [30.049941061194, -0.878908405487238],
            [30.050177747508446, -0.878258054079097],
            [30.04970433715035, -0.877995657360728],
            [30.050094812346455, -0.876884630039559],
            [30.0498580892011, -0.875068356300464],
            [30.05071011968853, -0.874852183071137],
            [30.050520634452383, -0.873966577885988],
            [30.05118329917961, -0.87325331492562],
            [30.0511833746381, -0.872611809915648],
            [30.05189339136056, -0.872323239826966],
            [30.05175137759559, -0.871889436141351],
            [30.053750960044407, -0.867264940456318],
            [30.05252013425619, -0.86564666410626],
            [30.05195215375656, -0.865980525283348],
            [30.051147389924434, -0.865284181347574],
            [30.05094600201077, -0.861263330314389],
            [30.05281569166275, -0.860641349545928],
            [30.05276829026018, -0.860090160520587],
            [30.05153749950625, -0.858609598948649],
            [30.050661747207094, -0.858299544300475],
            [30.050803715157983, -0.857513586777829],
            [30.049750469233427, -0.855850283255847],
            [30.04854330956138, -0.856111372809839],
            [30.048164631939894, -0.85520755553031],
            [30.048543219729837, -0.854756087385335],
            [30.04967936847703, -0.854558188089145],
            [30.049750336282788, -0.853817351657701],
            [30.05098095456017, -0.853321359697657],
            [30.05185656851874, -0.851216815582613],
            [30.05251914341443, -0.850783630161288],
            [30.052495387466756, -0.850115002417769],
            [30.051347528281536, -0.848551020509658],
            [30.051939036556778, -0.847023277437457],
            [30.05200987410683, -0.844897128658388],
            [30.05122876022119, -0.843846521096214],
            [30.05010410811302, -0.838412541783128],
            [30.050280992680683, -0.831329401358078],
            [30.050635911659537, -0.830134728986425],
            [30.04709192131976, -0.825968710435573],
            [30.046529051335785, -0.824341948425931],
            [30.046694556045423, -0.823176526365234],
            [30.047404608700475, -0.822743252515626],
            [30.04723886773393, -0.822002351680632],
            [30.047688422431342, -0.820755822084656],
            [30.051463377715514, -0.820794758260172],
            [30.052433699257875, -0.820271430987255],
            [30.05224421132676, -0.819331622610055],
            [30.05304891676841, -0.818790098933099],
            [30.05345105030028, -0.817371856678927],
            [30.054113809350604, -0.817236815004496],
            [30.056066036210893, -0.81416147841206],
            [30.057415037171367, -0.813635028045819],
            [30.057935554284658, -0.812129665129175],
            [30.057746051082194, -0.810624800166972],
            [30.056231277714147, -0.810148031090172],
            [30.056373192664406, -0.809335712707948],
            [30.055201520937633, -0.808177886187992],
            [30.054870032716334, -0.806911996439957],
            [30.05550885974915, -0.805143783887051],
            [30.054822451650676, -0.804690356384354],
            [30.054301625516953, -0.803472376978797],
            [30.054538185168905, -0.802444997430119],
            [30.05420671311729, -0.801418001166487],
            [30.052857536087014, -0.800224464256314],
            [30.05340176513052, -0.799220769264338],
            [30.054135429104544, -0.799076936029721],
            [30.055374485257396, -0.800185532374192],
            [30.056889165200683, -0.799850058693886],
            [30.05709014168594, -0.798237420690183],
            [30.05640362399298, -0.796923989128165],
            [30.056971547000426, -0.796111382481029],
            [30.05723167036061, -0.794415090953008],
            [30.056213776735767, -0.79279134152323],
            [30.054959297407812, -0.792051642450317],
            [30.05485266468862, -0.790964772096658],
            [30.05355068783834, -0.788863441359196],
            [30.052248516951916, -0.785185452287384],
            [30.052094524152682, -0.784074728511619],
            [30.05278079840216, -0.783500924926563],
            [30.053301227480567, -0.781131211354254],
            [30.052590990670847, -0.779775418257645],
            [30.052944846942736, -0.778769426938664],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 291,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "KEBISONI",
        Population: 22442,
        Key: "RUKUNGIRIKEBISONI",
        Dist2: "Rukungiri",
        "Sub Country": "Kebisoni",
        id2_original: "Rukungiri Kebisoni",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.948719583088927, -0.749437002292594],
            [29.947595242696185, -0.750102906817355],
            [29.94406179408625, -0.750923393535131],
            [29.940645735521045, -0.750891604887458],
            [29.934953802370018, -0.748712646587426],
            [29.930262465783066, -0.748121527410435],
            [29.929954278063587, -0.750492504189998],
            [29.92913448901004, -0.75091862209417],
            [29.928700705135768, -0.751619992422302],
            [29.92876587431637, -0.752719962849733],
            [29.92758754158175, -0.754008695817597],
            [29.92858516112897, -0.755213630953548],
            [29.927767216316703, -0.75610312916188],
            [29.928027957717784, -0.757289816035923],
            [29.929289586737102, -0.758115657584179],
            [29.929891195669406, -0.75987502077499],
            [29.926497171879777, -0.764974473109048],
            [29.926244835116467, -0.767746631795575],
            [29.925241089059035, -0.770938298100551],
            [29.92573974836482, -0.773837015790199],
            [29.92361030186531, -0.775683689746574],
            [29.92323266179794, -0.778581762851766],
            [29.924441181519356, -0.780766912771924],
            [29.92452371782934, -0.783168980843855],
            [29.92396566191697, -0.783445057634358],
            [29.923818982302443, -0.784400154059454],
            [29.925059328436024, -0.785121149730844],
            [29.925537265404827, -0.786033366033875],
            [29.925669949267252, -0.790656394563862],
            [29.92674946821891, -0.791206901578598],
            [29.926205832961784, -0.792802693345016],
            [29.928749633674343, -0.794988864289027],
            [29.929374287088628, -0.796711548227477],
            [29.928746492265795, -0.799622979525884],
            [29.930418446554043, -0.800539486161779],
            [29.931183936041936, -0.804168854018759],
            [29.938669454472404, -0.810753411667542],
            [29.94005403320969, -0.814385395018031],
            [29.941734783801216, -0.816388789150163],
            [29.943379229878882, -0.820141581140889],
            [29.943887950315847, -0.816934043475277],
            [29.9459157066269, -0.814707801027772],
            [29.94563788196405, -0.811091352773361],
            [29.949287611199274, -0.807360204103414],
            [29.949776728600117, -0.805131159312285],
            [29.951108776554566, -0.804533746066783],
            [29.95061014779149, -0.803555964182234],
            [29.95042196690912, -0.800783175302899],
            [29.95215335283827, -0.797989868118663],
            [29.95234527969537, -0.795123721666203],
            [29.954139759696826, -0.794260387183611],
            [29.954922805858626, -0.792805476957553],
            [29.957329685355553, -0.79281875368465],
            [29.96263962340674, -0.794304462380795],
            [29.967418670599727, -0.79715304275112],
            [29.970772592696733, -0.800302875040083],
            [29.97613015133942, -0.803010382899012],
            [29.97591917121519, -0.802158839305629],
            [29.97675995030364, -0.799449917073285],
            [29.97673607847331, -0.797849377148068],
            [29.977545334780153, -0.796067851629667],
            [29.981784838542122, -0.793114523511261],
            [29.983651782044273, -0.790973446300738],
            [29.985093552024175, -0.790104100896887],
            [29.982795605831836, -0.788408283869734],
            [29.98063464643214, -0.785363584052818],
            [29.980893566948147, -0.784225532540277],
            [29.980514347642544, -0.783597374307162],
            [29.979239886189387, -0.783405356708655],
            [29.97709639453039, -0.784918912130076],
            [29.974615052781225, -0.784848862687494],
            [29.973381795253538, -0.7839334457283],
            [29.97198544948434, -0.783543419350664],
            [29.96993953552642, -0.781358010386907],
            [29.964842902439457, -0.778979308792263],
            [29.962881754410088, -0.776025829362701],
            [29.9620725124763, -0.775825626720405],
            [29.96116637556099, -0.776249903431597],
            [29.959774667793603, -0.777913703389921],
            [29.957363497044536, -0.779476591700209],
            [29.953479550963593, -0.780775031889887],
            [29.95242749979837, -0.780348202858633],
            [29.950587856097716, -0.777714402662542],
            [29.949391856196414, -0.777535394795951],
            [29.94913867861002, -0.776242791223951],
            [29.950390883403685, -0.773927087935233],
            [29.950075316922444, -0.770239652562539],
            [29.952243558964174, -0.7691911698017],
            [29.95289017978041, -0.766040482366767],
            [29.953816064360616, -0.764733855648164],
            [29.955681406166605, -0.764178789330861],
            [29.95381691416687, -0.762082694568668],
            [29.949472786318687, -0.752614462128368],
            [29.94864448123622, -0.752374677544861],
            [29.948719583088927, -0.749437002292594],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 292,
        District: "RUKUNGIRI",
        County: "RUKUNGIRI MUNICIPALITY",
        Subcounty: "EASTERN DIVISON",
        Population: 12285,
        Key: "RUKUNGIRIEASTERN DIVISON",
        Dist2: "Rukungiri",
        "Sub Country": "Eastern Division",
        id2_original: "Rukungiri Eastern Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.925669949267252, -0.790656394563862],
            [29.92443345870284, -0.791352196507012],
            [29.921228974048287, -0.790628185658347],
            [29.92071575754334, -0.790816098014496],
            [29.91942998001255, -0.792328768682524],
            [29.918259271279766, -0.79616339530424],
            [29.915396578522845, -0.798049601189061],
            [29.91237501421632, -0.797635855726572],
            [29.910814658534125, -0.798002593316994],
            [29.911052849526634, -0.796726280072055],
            [29.908900940653435, -0.79580526796978],
            [29.90582714649967, -0.795729281419392],
            [29.904300189281397, -0.79463224857186],
            [29.902134240638592, -0.792197692760076],
            [29.89931017813382, -0.791509781905528],
            [29.89581487019425, -0.787639010678559],
            [29.89502755254325, -0.787622137420372],
            [29.896073615538782, -0.789534136277839],
            [29.896066641018916, -0.791011002181915],
            [29.897165270729936, -0.793443034667569],
            [29.89646814123853, -0.796287659833951],
            [29.897069352217155, -0.797803976203961],
            [29.896801258105462, -0.800042581232997],
            [29.897919515107098, -0.801641132525821],
            [29.898263432418698, -0.804169590564726],
            [29.89752680580088, -0.805645986833871],
            [29.896554958020854, -0.80986017855543],
            [29.896449890166902, -0.814799772924965],
            [29.894776918985738, -0.816615002391164],
            [29.89258582559982, -0.81702122239854],
            [29.893192616014684, -0.818398424040247],
            [29.89272299025886, -0.819800284134243],
            [29.893519510251625, -0.821464455389434],
            [29.892869399480492, -0.822958861879639],
            [29.893527257322624, -0.823505083593775],
            [29.89736055279459, -0.823780938492346],
            [29.89813451968383, -0.824405210222753],
            [29.900589678237395, -0.825112835073977],
            [29.900775373481363, -0.826114756829676],
            [29.89986869757689, -0.827980147725214],
            [29.900069157530854, -0.83026325183421],
            [29.899508367146755, -0.833141937613852],
            [29.89808993809291, -0.836717910046509],
            [29.899042914065443, -0.837242143246209],
            [29.899618760213695, -0.839743663653285],
            [29.898972045972695, -0.841638329111334],
            [29.89924080483771, -0.842763051042753],
            [29.896783683465248, -0.846432854126995],
            [29.89702647742529, -0.847004388829531],
            [29.897728977943775, -0.84727701927554],
            [29.902185384422676, -0.847102194793163],
            [29.905053927907055, -0.847445825695943],
            [29.908470487732206, -0.847395801294808],
            [29.91058702094954, -0.846253205281437],
            [29.911173063874575, -0.841000818572657],
            [29.911608009270527, -0.839737898885021],
            [29.912605702479613, -0.838746967605831],
            [29.91461213548076, -0.837638769956741],
            [29.916019597003306, -0.837580851878478],
            [29.917414802810423, -0.838207686741942],
            [29.919960423509732, -0.837524933235567],
            [29.922248238502274, -0.837847871808223],
            [29.923597016680567, -0.836556377841579],
            [29.92333002659834, -0.83476228810466],
            [29.923857338568443, -0.833114706268476],
            [29.92477080932969, -0.831861865671173],
            [29.92554376561423, -0.831840857189358],
            [29.926242054830684, -0.831203817523278],
            [29.92699469391843, -0.82969148923453],
            [29.927939723393944, -0.829281577032254],
            [29.92846636072926, -0.828493106713941],
            [29.928628776132644, -0.826623773764127],
            [29.92965566548673, -0.826902288979162],
            [29.92991362839869, -0.825660098430201],
            [29.931497371719324, -0.823824689110553],
            [29.932367037034084, -0.823527151124091],
            [29.93478275236013, -0.823955866409842],
            [29.938261309414628, -0.822982951312084],
            [29.941337320610494, -0.823150046763705],
            [29.943656480518257, -0.822427713166568],
            [29.944121104454574, -0.82089604099839],
            [29.943379229878882, -0.820141581140889],
            [29.941734783801216, -0.816388789150163],
            [29.94005403320969, -0.814385395018031],
            [29.938669454472404, -0.810753411667542],
            [29.931183936041936, -0.804168854018759],
            [29.930418446554043, -0.800539486161779],
            [29.928746492265795, -0.799622979525884],
            [29.929374287088628, -0.796711548227477],
            [29.928749633674343, -0.794988864289027],
            [29.926205832961784, -0.792802693345016],
            [29.92674946821891, -0.791206901578598],
            [29.925669949267252, -0.790656394563862],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 293,
        District: "RUKUNGIRI",
        County: "RUKUNGIRI MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 9214,
        Key: "RUKUNGIRISOUTHERN DIVISION",
        Dist2: "Rukungiri",
        "Sub Country": "Southern Division",
        id2_original: "Rukungiri Southern Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.244930678484245, 1.213937362757878],
            [31.23959367419358, 1.217152433534481],
            [31.237039765637448, 1.218013294977411],
            [31.23052867225358, 1.217148595899365],
            [31.224877584600247, 1.217685149866599],
            [31.22438398191116, 1.215466677460355],
            [31.22703203929895, 1.208299603725548],
            [31.2300464575074, 1.202278283849633],
            [31.23321006701989, 1.192561751399562],
            [31.238759494129162, 1.183622722697417],
            [31.2406715573131, 1.178930916507176],
            [31.242915920795365, 1.171209159193869],
            [31.24578375101742, 1.164485506509725],
            [31.247602535837174, 1.156791865953991],
            [31.25158303374318, 1.155573499965123],
            [31.264355549049068, 1.153521288718408],
            [31.266423015387275, 1.15429922108312],
            [31.269761877228543, 1.157737956460081],
            [31.27098512752396, 1.15957605375181],
            [31.277278070431, 1.159340823270322],
            [31.278286057434894, 1.162057543691053],
            [31.27931308602786, 1.163647186680882],
            [31.281130173930066, 1.16407327390229],
            [31.282926745209494, 1.163766242794398],
            [31.28238907027428, 1.161699764390435],
            [31.282638599802322, 1.15887294886758],
            [31.28179499641059, 1.157514379986482],
            [31.28186068302078, 1.155130898395965],
            [31.28077971149331, 1.151656581192134],
            [31.28060712266936, 1.148653980828964],
            [31.283097561657403, 1.143509668624985],
            [31.283504182274136, 1.138853727653096],
            [31.288260536226414, 1.135623113275971],
            [31.293091451245573, 1.130452429951003],
            [31.299097160535453, 1.125337834471172],
            [31.30183476738064, 1.121163619444743],
            [31.30391168130069, 1.116693369099368],
            [31.30497891668914, 1.112277954548302],
            [31.303752767530288, 1.105680909297638],
            [31.30443286586222, 1.104110744956381],
            [31.306232575855244, 1.10281837994372],
            [31.309280084405465, 1.102358198955963],
            [31.31754010332441, 1.103453079240133],
            [31.324514835192755, 1.105138488917363],
            [31.330368701351826, 1.108800336503316],
            [31.332132108627576, 1.106805781101398],
            [31.332132698820736, 1.105752570731078],
            [31.332665665685536, 1.104662705655896],
            [31.33226338662657, 1.101835435760845],
            [31.330778282815725, 1.098564099809802],
            [31.32800787398793, 1.095846364427662],
            [31.327779386597097, 1.094090887399783],
            [31.325917644340436, 1.091392147476387],
            [31.321127732024095, 1.089116745084489],
            [31.31974281282527, 1.087258999468423],
            [31.318706031223254, 1.086565518867458],
            [31.317156178643348, 1.084208798423345],
            [31.317633667352833, 1.08383028198277],
            [31.31887277291306, 1.083803260104355],
            [31.319442198801987, 1.083147635934847],
            [31.319755958771164, 1.080080583145473],
            [31.32073783354636, 1.080478393333596],
            [31.321206107337655, 1.080164540042506],
            [31.32128044921565, 1.078501624157619],
            [31.321785700358994, 1.077707381882279],
            [31.321455662018554, 1.077005061236791],
            [31.321548656515077, 1.074797074503874],
            [31.322852606065755, 1.073679921183093],
            [31.323083005071478, 1.071961658161608],
            [31.322726440379036, 1.069402353884207],
            [31.321837204367487, 1.067434030122653],
            [31.322104332790264, 1.065678833065018],
            [31.321380320315658, 1.06368288669089],
            [31.322812521441136, 1.063000012503297],
            [31.325103319738737, 1.061074719150324],
            [31.32351572174722, 1.050293113570713],
            [31.321603611850875, 1.046087870189432],
            [31.318819897177107, 1.044597378451454],
            [31.311297272935526, 1.03666666605608],
            [31.310167144697417, 1.034651553992481],
            [31.3087750659258, 1.034344250904692],
            [31.308515483351407, 1.031585118833],
            [31.30877703862616, 1.030621801159828],
            [31.30834330595583, 1.028081544673683],
            [31.307865117458736, 1.027336798528748],
            [31.305603564713543, 1.025759023561509],
            [31.303210547119726, 1.025976710644143],
            [31.29942731475856, 1.022383631063762],
            [31.297209283592206, 1.020805885992607],
            [31.29792938390376, 1.020062762053811],
            [31.29886345303449, 1.019098830155681],
            [31.30395528193131, 1.016254968277268],
            [31.31296197332788, 1.01494592164695],
            [31.315615180757202, 1.013436728821049],
            [31.322059568841336, 1.004869612253322],
            [31.32349522937897, 1.000008458448543],
            [31.323606711204032, 0.997266140614012],
            [31.323219591215484, 0.997265450812376],
            [31.32514991086096, 0.994684150104672],
            [31.32617699694611, 0.992013195478217],
            [31.326814109993364, 0.986119733041854],
            [31.33276277626269, 0.983862488040143],
            [31.33541768599948, 0.981936883160399],
            [31.340030561932878, 0.979749487098094],
            [31.3405877967851, 0.979943959187059],
            [31.344011906051886, 0.979163535189782],
            [31.34477504285205, 0.979610910784321],
            [31.350598474987617, 0.985439995840172],
            [31.355818930955003, 0.989916642695704],
            [31.35788114574204, 0.992782870632566],
            [31.358083688889174, 0.996386145819367],
            [31.35641329497455, 1.001156451578833],
            [31.35664747858258, 1.003205762047894],
            [31.35635785814174, 1.005926639922021],
            [31.357514513630207, 1.010696546450233],
            [31.359536089532124, 1.015600561341932],
            [31.359729232708087, 1.017931129349938],
            [31.361401250776733, 1.018738803699375],
            [31.362338007666807, 1.018781229812663],
            [31.368011646627078, 1.023715014002194],
            [31.36943374260391, 1.025586641126721],
            [31.370924382731868, 1.035424238654735],
            [31.37220141695997, 1.037003471048167],
            [31.37350602317909, 1.041447536586542],
            [31.373985208806165, 1.041462402146697],
            [31.376946276968184, 1.043831805019687],
            [31.379355415728085, 1.046464020109091],
            [31.381460360678226, 1.047649050407665],
            [31.38340489167149, 1.050164097646915],
            [31.383068209391208, 1.055382004490168],
            [31.383444758903767, 1.057311577530675],
            [31.38554665407357, 1.064372447530703],
            [31.386278277075252, 1.067316117959055],
            [31.38620248621471, 1.068413859890609],
            [31.387597239270924, 1.07336209823324],
            [31.388717787874885, 1.074473269942417],
            [31.390883255919007, 1.075841790162546],
            [31.39918035010636, 1.076844008284617],
            [31.405993471461777, 1.077004375943326],
            [31.410071233556852, 1.078103083509872],
            [31.41545042722487, 1.078323785643511],
            [31.4180746720711, 1.079055747826714],
            [31.430928763387936, 1.078746196556334],
            [31.434505166739783, 1.083019964129913],
            [31.44010936862351, 1.085851267398753],
            [31.442504741599986, 1.087690251456392],
            [31.446011368312156, 1.092114137008764],
            [31.453596846775806, 1.093874483174723],
            [31.450794543263868, 1.101284000852474],
            [31.446496188172652, 1.103575534626916],
            [31.445838960049556, 1.10438559365195],
            [31.445865369620595, 1.105490828836925],
            [31.44320268676166, 1.106144888038379],
            [31.43920871861797, 1.108677275082813],
            [31.43781218599917, 1.11085991367065],
            [31.43627809256431, 1.111535618807045],
            [31.435696319331782, 1.113992433069694],
            [31.435151251261786, 1.114604841596579],
            [31.431954028588002, 1.118906328480755],
            [31.431011566497556, 1.119710727688754],
            [31.428892957273597, 1.119881417208954],
            [31.42757165496659, 1.121852271640417],
            [31.42615295102827, 1.122719715175646],
            [31.426262857208346, 1.128761093589306],
            [31.42368066878876, 1.132051652994032],
            [31.42272577221816, 1.136609241711467],
            [31.423029057831112, 1.143745026152017],
            [31.422628055278196, 1.147914029951695],
            [31.4213455799544, 1.152218195891719],
            [31.419741108008576, 1.155038966426783],
            [31.41605313479676, 1.158627317065445],
            [31.411515719143836, 1.160985191800961],
            [31.406859966621912, 1.162067804832325],
            [31.397679465590898, 1.162994072738511],
            [31.39209274312596, 1.162439198845231],
            [31.389623760398493, 1.161054088317377],
            [31.38632760177085, 1.158176291496746],
            [31.38324584225549, 1.156510478427196],
            [31.378073049998736, 1.157918313913913],
            [31.367437060815156, 1.162859017299747],
            [31.36074844326315, 1.168959532747808],
            [31.35918767255926, 1.16978157960756],
            [31.353986189010676, 1.170827559116975],
            [31.351513746871017, 1.172101235076732],
            [31.345662175907503, 1.178545787852767],
            [31.342035074335964, 1.186113028843466],
            [31.3331388909907, 1.192664151527782],
            [31.328232150076705, 1.193836796900709],
            [31.319468650593823, 1.197801460725426],
            [31.313583876100783, 1.197318514260288],
            [31.309245020464996, 1.197370077974475],
            [31.306336174065404, 1.197856606128994],
            [31.302726930103372, 1.197673486849443],
            [31.301934323171995, 1.19809802768293],
            [31.300673182836203, 1.20066554002974],
            [31.29766217463261, 1.203358554656844],
            [31.297113411791848, 1.207174481174167],
            [31.296391242660214, 1.207653319710292],
            [31.2936657370202, 1.207253689607203],
            [31.292442540623668, 1.20815823494809],
            [31.28975257862451, 1.205575793078427],
            [31.287519938156727, 1.202406849369599],
            [31.285695671817084, 1.200867477375252],
            [31.27716387569374, 1.197741566067468],
            [31.273932738923037, 1.197679239301851],
            [31.271327720718812, 1.198428078273058],
            [31.268035381727792, 1.198458574794356],
            [31.26002183447167, 1.201758835977732],
            [31.258386402089585, 1.20276138930392],
            [31.251886362475297, 1.208647390860857],
            [31.25061742745775, 1.209214311790161],
            [31.244930678484245, 1.213937362757878],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1599,
        District: "KAKUMIRO",
        County: "BUGANGAIZI",
        Subcounty: "KISIITA",
        Population: 58507,
        Key: "KAKUMIROKISIITA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.950148102020037, -0.744643061604566],
            [29.948355837264092, -0.742183126278538],
            [29.947103068328417, -0.73773221949059],
            [29.946566782188643, -0.737048798299389],
            [29.946496710901513, -0.73583556742622],
            [29.945808428019028, -0.735274379522379],
            [29.943097487663053, -0.734963359863032],
            [29.94268561459685, -0.733960940337288],
            [29.940881546876376, -0.735519541907388],
            [29.936152013025215, -0.736738706646768],
            [29.93482586790052, -0.736026980825924],
            [29.932907481475322, -0.734167082283889],
            [29.929026100084485, -0.733035438826397],
            [29.92817385400141, -0.733398641971296],
            [29.928054344830958, -0.734000639920214],
            [29.926456116176364, -0.735325481368786],
            [29.922475548201778, -0.737351767778387],
            [29.91677132789429, -0.738457212951873],
            [29.91574691429711, -0.739990302922361],
            [29.915555979180102, -0.74205431867226],
            [29.91410798297699, -0.742251705997592],
            [29.91082973585784, -0.747312464868272],
            [29.90855028058732, -0.750156310677041],
            [29.907416483629568, -0.750794875417568],
            [29.906694441160393, -0.752396517299506],
            [29.90508520994021, -0.753857965275113],
            [29.905072950631524, -0.755510350145266],
            [29.904240272550254, -0.756715554335917],
            [29.90447188607829, -0.758546752768731],
            [29.904748712712873, -0.759183345546743],
            [29.90626746831258, -0.760200439192895],
            [29.905390281403964, -0.761595410589144],
            [29.904860126265984, -0.764345322168173],
            [29.903784925515897, -0.765393950732481],
            [29.90120150011617, -0.765650730100095],
            [29.899890656894005, -0.76453486599129],
            [29.899500033475885, -0.765229891675484],
            [29.898578732100265, -0.765712075064304],
            [29.898572790642962, -0.767118334584766],
            [29.89603520447556, -0.768389112935132],
            [29.894796477106116, -0.77014912313824],
            [29.893934716067516, -0.770252844028721],
            [29.891855874362896, -0.769640987567962],
            [29.89077372963565, -0.7703234470257],
            [29.891767247475258, -0.771076448278768],
            [29.891824529447675, -0.772609364159017],
            [29.89369175322422, -0.774432922618001],
            [29.89491576888427, -0.777490400529893],
            [29.894299402428476, -0.781927859351294],
            [29.89502755254325, -0.787622137420372],
            [29.89581487019425, -0.787639010678559],
            [29.89931017813382, -0.791509781905528],
            [29.902134240638592, -0.792197692760076],
            [29.904300189281397, -0.79463224857186],
            [29.90582714649967, -0.795729281419392],
            [29.908900940653435, -0.79580526796978],
            [29.911052849526634, -0.796726280072055],
            [29.910814658534125, -0.798002593316994],
            [29.91237501421632, -0.797635855726572],
            [29.915396578522845, -0.798049601189061],
            [29.918259271279766, -0.79616339530424],
            [29.91942998001255, -0.792328768682524],
            [29.92071575754334, -0.790816098014496],
            [29.921228974048287, -0.790628185658347],
            [29.92443345870284, -0.791352196507012],
            [29.925669949267252, -0.790656394563862],
            [29.925537265404827, -0.786033366033875],
            [29.925059328436024, -0.785121149730844],
            [29.923818982302443, -0.784400154059454],
            [29.92396566191697, -0.783445057634358],
            [29.92452371782934, -0.783168980843855],
            [29.924441181519356, -0.780766912771924],
            [29.92323266179794, -0.778581762851766],
            [29.92361030186531, -0.775683689746574],
            [29.92573974836482, -0.773837015790199],
            [29.925241089059035, -0.770938298100551],
            [29.926244835116467, -0.767746631795575],
            [29.926497171879777, -0.764974473109048],
            [29.929891195669406, -0.75987502077499],
            [29.929289586737102, -0.758115657584179],
            [29.928027957717784, -0.757289816035923],
            [29.927767216316703, -0.75610312916188],
            [29.92858516112897, -0.755213630953548],
            [29.92758754158175, -0.754008695817597],
            [29.92876587431637, -0.752719962849733],
            [29.928700705135768, -0.751619992422302],
            [29.92913448901004, -0.75091862209417],
            [29.929954278063587, -0.750492504189998],
            [29.930262465783066, -0.748121527410435],
            [29.934953802370018, -0.748712646587426],
            [29.940645735521045, -0.750891604887458],
            [29.94406179408625, -0.750923393535131],
            [29.947595242696185, -0.750102906817355],
            [29.948719583088927, -0.749437002292594],
            [29.948822508460932, -0.746870542099009],
            [29.950148102020037, -0.744643061604566],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 294,
        District: "RUKUNGIRI",
        County: "RUKUNGIRI MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 13540,
        Key: "RUKUNGIRIWESTERN DIVISION",
        Dist2: "Rukungiri",
        "Sub Country": "Western Division",
        id2_original: "Rukungiri Western Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.844575409257505, -0.845392014197385],
            [29.84680986342386, -0.84767643392826],
            [29.84891830731207, -0.84876818776118],
            [29.850534433102066, -0.850515078762802],
            [29.85305410237113, -0.851194635931156],
            [29.854122079768022, -0.852197198624209],
            [29.855265185967063, -0.852271722700232],
            [29.85712368081394, -0.853746270471841],
            [29.85846118783039, -0.855581366637458],
            [29.85850301608494, -0.856656768024506],
            [29.85984631274338, -0.859250573687143],
            [29.85974911233468, -0.86021538144051],
            [29.8602888381237, -0.861512177743677],
            [29.860976470625925, -0.862131453848843],
            [29.86257354225043, -0.862427302938826],
            [29.86334840925155, -0.863414917319853],
            [29.863820164912894, -0.865706062017393],
            [29.864925057678075, -0.866583433431299],
            [29.86626944309463, -0.868617463021363],
            [29.866515882418096, -0.869987657418096],
            [29.867658392135798, -0.870371572852234],
            [29.867656462554567, -0.871329149870014],
            [29.869324100437893, -0.872980385434584],
            [29.86945421601691, -0.87387908766398],
            [29.87043545029331, -0.874292334669943],
            [29.871378189963192, -0.875626317445851],
            [29.873281425402812, -0.876732660076477],
            [29.87418658315445, -0.878515886975625],
            [29.87556216346755, -0.879636614473648],
            [29.875992688254016, -0.880572366234684],
            [29.877471714961963, -0.881251215615676],
            [29.877806863818062, -0.882238472958398],
            [29.879167355129344, -0.883565436091461],
            [29.879414146592406, -0.884744194402768],
            [29.880796007925973, -0.886373108962271],
            [29.884958436236584, -0.885023410490878],
            [29.885331552388138, -0.884123939382475],
            [29.884842391868162, -0.883150084710429],
            [29.884792774321753, -0.880770533632835],
            [29.886564104738337, -0.880114349577961],
            [29.8874678233889, -0.878713352981257],
            [29.887554742579155, -0.877545329064889],
            [29.888921690980702, -0.877338740777105],
            [29.88937032221, -0.875340294015381],
            [29.8913568269849, -0.874338227847262],
            [29.89211442926458, -0.872937088968779],
            [29.893352209809752, -0.872955403491556],
            [29.89497798530251, -0.871580930196425],
            [29.898280135693096, -0.865869284335838],
            [29.900549259439526, -0.863588805120894],
            [29.90253021981248, -0.860823991466325],
            [29.903507523959544, -0.858736134902987],
            [29.90356401900773, -0.856799710835766],
            [29.903304385229372, -0.855015139861575],
            [29.902645912939594, -0.853631396784038],
            [29.904819064274353, -0.851032675878309],
            [29.90516347655766, -0.849940220279842],
            [29.905053924313798, -0.847445844558485],
            [29.9021853862193, -0.847102206469983],
            [29.89772896985893, -0.847277007598721],
            [29.897026494493264, -0.847004384338436],
            [29.896783669092194, -0.846432823587627],
            [29.899240806634335, -0.842763042958787],
            [29.898972049565952, -0.84163830575763],
            [29.899618765603613, -0.839743695989174],
            [29.899042896997468, -0.837242155821292],
            [29.898089945279448, -0.83671789028568],
            [29.8997217565526, -0.832202299350242],
            [29.900069152140972, -0.830263265307519],
            [29.899868680508913, -0.82798017018073],
            [29.90077496115466, -0.826657608880766],
            [29.900589683627313, -0.825112807229088],
            [29.89813451070069, -0.824405176090297],
            [29.897360555489552, -0.823780911545652],
            [29.893527241152977, -0.823505059341792],
            [29.892869400378828, -0.822958827747204],
            [29.893519521031422, -0.821464479641463],
            [29.892723002835282, -0.819800311080931],
            [29.893192618709644, -0.818398450986944],
            [29.89258583458299, -0.817021220602095],
            [29.894776917189112, -0.816614985324886],
            [29.89644988837027, -0.814799799871686],
            [29.896554949037714, -0.809860194723462],
            [29.89752681388572, -0.805645970665788],
            [29.898263432418698, -0.804169580684231],
            [29.89791951151384, -0.801641141508113],
            [29.89680124912229, -0.800042577640058],
            [29.897069340539062, -0.797803954646487],
            [29.896468135848647, -0.796287632887107],
            [29.897165277018146, -0.79344305442861],
            [29.896066631137447, -0.791011028230548],
            [29.896073613742157, -0.789534141667243],
            [29.895054095963285, -0.787923994025867],
            [29.894472436816816, -0.784837588990126],
            [29.894299406021734, -0.78192788090885],
            [29.894915769782568, -0.777490404122817],
            [29.893691745139378, -0.774432903755085],
            [29.891824512379696, -0.772609348889055],
            [29.891767244780336, -0.771076457261092],
            [29.890773728737354, -0.770323413791045],
            [29.891855883346036, -0.76964096690856],
            [29.893934710677634, -0.770252818878175],
            [29.894796461834726, -0.770149100682375],
            [29.896035190102506, -0.768389122815711],
            [29.898572789744666, -0.767118330991833],
            [29.898578720422172, -0.765712102011344],
            [29.899500020001128, -0.765229862033724],
            [29.899890647012537, -0.764534852517767],
            [29.90120148484482, -0.76565069956012],
            [29.903784913837804, -0.765393930971308],
            [29.904860119977773, -0.764345311389333],
            [29.90539026613258, -0.76159537645617],
            [29.906267456634488, -0.760200444582303],
            [29.904748707322987, -0.759183332073203],
            [29.90447187889175, -0.758546777021127],
            [29.904240282431722, -0.756715566911247],
            [29.905072943444978, -0.755510315114025],
            [29.90508522521156, -0.753857979646923],
            [29.906694437567136, -0.752396519095978],
            [29.907416493511036, -0.750794848470402],
            [29.90855026531597, -0.750156326845337],
            [29.910829740349424, -0.747312490018952],
            [29.91410799465509, -0.74225168264336],
            [29.91555596660368, -0.742054351008909],
            [29.915746928670163, -0.739990293041717],
            [29.916528568968538, -0.738716475742998],
            [29.917756945050996, -0.738023847735219],
            [29.92247555628659, -0.737351781251994],
            [29.926456110786482, -0.735325475979314],
            [29.92819259645149, -0.73378421938716],
            [29.92817385759467, -0.733398607838103],
            [29.92772119113311, -0.733793131740475],
            [29.926465304145076, -0.72876297588383],
            [29.924606387988323, -0.727837575701472],
            [29.922794879522325, -0.726314352363381],
            [29.922701433173224, -0.725348319643677],
            [29.921854595846437, -0.724589444118119],
            [29.921667352805272, -0.722966220005129],
            [29.920581303999807, -0.721344819645618],
            [29.92054905627774, -0.718864892787609],
            [29.91982896494936, -0.71777170115692],
            [29.919957431221505, -0.715876614435899],
            [29.91830954908791, -0.715249808136622],
            [29.917450113787595, -0.715478439402757],
            [29.91644435191065, -0.714401246511959],
            [29.914212003395324, -0.713207141304237],
            [29.913682067446302, -0.711971141596728],
            [29.91230459168793, -0.711389106043062],
            [29.908228100708982, -0.71742966659272],
            [29.90396598006309, -0.719313664740349],
            [29.902279569186952, -0.719382787348206],
            [29.901104565608808, -0.718678648057759],
            [29.900439390988687, -0.717529315181963],
            [29.900140841293897, -0.717578368332561],
            [29.89997135435263, -0.718830928363384],
            [29.899512266733424, -0.718362297071656],
            [29.898314383963303, -0.718338086682738],
            [29.897831539498085, -0.717767350059126],
            [29.89720391176188, -0.718079771265697],
            [29.89626068071356, -0.71751731552908],
            [29.89568628534449, -0.717920683137967],
            [29.895062974013232, -0.717765455660839],
            [29.89443057442625, -0.717422298290126],
            [29.894262420584873, -0.716684544573108],
            [29.892779147540537, -0.717374297880832],
            [29.891276610124958, -0.71634714127932],
            [29.891742646212915, -0.718255560451653],
            [29.891482871399038, -0.719475769124455],
            [29.890293691507402, -0.720020049543694],
            [29.890281445673434, -0.720742784976999],
            [29.889268208915006, -0.722187624932162],
            [29.887454488796816, -0.723786007498482],
            [29.88774844181229, -0.724200883746433],
            [29.88932558161726, -0.724332321923307],
            [29.88810029394279, -0.726085089278049],
            [29.888452882691805, -0.726855543803196],
            [29.887204715825323, -0.72754185709396],
            [29.886888129756276, -0.728764309774113],
            [29.883491515225387, -0.731551386890044],
            [29.882354409772418, -0.733094889855489],
            [29.881653934056594, -0.738161671999015],
            [29.88076168958716, -0.7405387109672],
            [29.877720997453306, -0.74413742464199],
            [29.874482254647077, -0.744186266415713],
            [29.87283093376256, -0.744587035716969],
            [29.871941391425498, -0.747255648564413],
            [29.872707906789476, -0.748458656145935],
            [29.870373866289025, -0.7523678177025],
            [29.870767826948434, -0.752696937422825],
            [29.8686088519272, -0.75505656518527],
            [29.86753206654897, -0.760524791379922],
            [29.866447070569, -0.760847314733943],
            [29.867658638274165, -0.763708405889399],
            [29.868496422379508, -0.764519204360374],
            [29.869205389869727, -0.767287942863613],
            [29.870136690392766, -0.768628769079692],
            [29.870202379697915, -0.770526077854106],
            [29.870684697750367, -0.771309576806657],
            [29.870375129320312, -0.772750820680796],
            [29.867765383282766, -0.77374140423803],
            [29.867301628017337, -0.775001176357649],
            [29.866161469190743, -0.775006088794512],
            [29.86464493063313, -0.776021092082422],
            [29.86385434311453, -0.775301663166491],
            [29.86213031438754, -0.775337312239331],
            [29.85847367980273, -0.777150759915551],
            [29.856234980198323, -0.777802399807911],
            [29.854863821393042, -0.777302055525798],
            [29.853858971306117, -0.778232007329988],
            [29.852958901612265, -0.778231375872614],
            [29.851171990815388, -0.776935675407263],
            [29.84973917793722, -0.776629925070551],
            [29.84895711722727, -0.777512789875089],
            [29.84793500331722, -0.777935520558764],
            [29.848136597843382, -0.780672040621493],
            [29.84727172324404, -0.780790916222372],
            [29.84673666420294, -0.780172399097515],
            [29.845769502035438, -0.78017261018203],
            [29.84448880627423, -0.781234558311147],
            [29.84171631066001, -0.780229240116735],
            [29.8411646534474, -0.779127432678879],
            [29.83965913362509, -0.778777332281186],
            [29.839160077263955, -0.77776555790306],
            [29.836665006562313, -0.777987449174768],
            [29.836349613455944, -0.778578036983999],
            [29.835977865438537, -0.777943660341514],
            [29.835290934520547, -0.777698190463553],
            [29.833171683001193, -0.778402671486389],
            [29.82985054761542, -0.778328146043097],
            [29.827458221724395, -0.780545586634501],
            [29.82456533120085, -0.782142895100104],
            [29.823349096747794, -0.781392661473089],
            [29.822975593422317, -0.78047506105595],
            [29.822066049197147, -0.780216889426794],
            [29.821999798444946, -0.781146419316844],
            [29.821844418646894, -0.782731938266036],
            [29.821847716362306, -0.783830938684088],
            [29.821857612203463, -0.784344895779944],
            [29.82147832013433, -0.785693575207636],
            [29.821429193068063, -0.7864660536446],
            [29.82145021184908, -0.786848784320856],
            [29.821551693628415, -0.787816627653296],
            [29.821376873389276, -0.788210164814104],
            [29.821441053524772, -0.788767909193234],
            [29.821679598453514, -0.789183621768195],
            [29.821688721743534, -0.790102202038948],
            [29.821348976208153, -0.791359513485335],
            [29.821440703181803, -0.791758734307075],
            [29.821766061299606, -0.792294794952096],
            [29.82191796821078, -0.792502650619078],
            [29.82198162193351, -0.793333792935213],
            [29.822185813489146, -0.794646189982479],
            [29.822337334124768, -0.795061831007807],
            [29.822950293270665, -0.795964410727024],
            [29.823926334386446, -0.797583537524364],
            [29.82470716620107, -0.79888540688548],
            [29.825243769446146, -0.799897317150349],
            [29.825340794683353, -0.800345729481194],
            [29.82566450439261, -0.801723806269473],
            [29.825913540745585, -0.80234730264751],
            [29.82611857402263, -0.80321135491112],
            [29.826611980878983, -0.804048250002072],
            [29.82696986878985, -0.804649991873156],
            [29.82678266078297, -0.805798037711294],
            [29.826682372864642, -0.80701176601571],
            [29.826763150273308, -0.807421931997091],
            [29.82677329135454, -0.807815608304174],
            [29.82649035797266, -0.807826344799561],
            [29.826370874853357, -0.807727820185055],
            [29.826237109419335, -0.807710908385532],
            [29.826181947471003, -0.808188020871041],
            [29.82651225440771, -0.808750113545553],
            [29.8265738375137, -0.809332767425994],
            [29.826345995113243, -0.809915211037915],
            [29.826748412512764, -0.810347060786319],
            [29.826903688106253, -0.81047751365782],
            [29.828204911270003, -0.81184148308672],
            [29.829547998620985, -0.812529186626978],
            [29.830829009690873, -0.813289730691676],
            [29.832895766359975, -0.81376992971804],
            [29.83305160340052, -0.813714422127143],
            [29.835087550550334, -0.812949738224055],
            [29.835666192255786, -0.813137452844309],
            [29.837091671287954, -0.814220656142426],
            [29.83936310999287, -0.817322898088035],
            [29.84010436113778, -0.818444063681653],
            [29.840601416950776, -0.81984171378698],
            [29.84130287452523, -0.821611002258832],
            [29.84109492890999, -0.823192295560709],
            [29.840946952128185, -0.824425316030586],
            [29.84121020072727, -0.82643838617066],
            [29.841363827013886, -0.82707808893263],
            [29.841629145331382, -0.82772894840132],
            [29.84209581383326, -0.82831981016625],
            [29.842801026365585, -0.829348273548136],
            [29.843136420461757, -0.830299896554951],
            [29.843703657156322, -0.832317945241627],
            [29.843722781390436, -0.833652083604996],
            [29.843971923744594, -0.834220909349325],
            [29.843643688322928, -0.835128322595597],
            [29.843321487783324, -0.835767812868487],
            [29.84302641187374, -0.836423723389154],
            [29.84291706983567, -0.836686101399286],
            [29.84280621952624, -0.837735825244139],
            [29.842586272418846, -0.838905755661417],
            [29.842295197605534, -0.840288872548716],
            [29.84219652306146, -0.840682474648383],
            [29.842325936157916, -0.841251229311448],
            [29.84369677965451, -0.844035355228499],
            [29.844011260072566, -0.844571408888884],
            [29.844575409257505, -0.845392014197385],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 295,
        District: "RUKUNGIRI",
        County: "RUJUMBURA",
        Subcounty: "NYAKAGYEME",
        Population: 31848,
        Key: "RUKUNGIRINYAKAGYEME",
        Dist2: "Rukungiri",
        "Sub Country": "Nyakagyeme",
        id2_original: "Rukungiri Nyakagyeme",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.003378289813508, -0.730249076734068],
            [30.000889144399487, -0.730189278047489],
            [29.999168747561196, -0.728815584157265],
            [29.997614980123277, -0.729443384736373],
            [29.996221808101986, -0.727812085367098],
            [29.995211613937425, -0.727243209296903],
            [29.995138417411432, -0.72650534040183],
            [29.99440606946932, -0.725606975980267],
            [29.992711924996907, -0.724793855578897],
            [29.992544613775237, -0.723043406091762],
            [29.99110343039525, -0.722338315228798],
            [29.99060552297937, -0.719889287620125],
            [29.98951839978881, -0.719243403157406],
            [29.98904904712087, -0.717944640224068],
            [29.989320598848092, -0.716086510972257],
            [29.988728503074643, -0.712285775577356],
            [29.987951216012135, -0.710214502777959],
            [29.98781499099086, -0.71063228608252],
            [29.98681404408385, -0.708800263210413],
            [29.982156309878427, -0.706090302890194],
            [29.981294609925264, -0.700633119083137],
            [29.97718410423809, -0.69858350864772],
            [29.97612945514507, -0.697141315644829],
            [29.972875366418855, -0.6950658978872],
            [29.970802583850794, -0.698931661674464],
            [29.96893198240883, -0.70045488689104],
            [29.96729552954057, -0.700579665235357],
            [29.966985702395725, -0.699866504670149],
            [29.966392371438772, -0.699721564225597],
            [29.96054743094036, -0.700663494241506],
            [29.95981338248741, -0.701258351832159],
            [29.959635384008806, -0.702507881105447],
            [29.96084866390288, -0.702939336432714],
            [29.96129271552087, -0.710625745053758],
            [29.96105671641764, -0.71170224628031],
            [29.960290397784725, -0.712519996774616],
            [29.959617655756656, -0.714162526996957],
            [29.958391555106846, -0.71544945123214],
            [29.96017429772079, -0.720007707666252],
            [29.96018637197651, -0.723410433865094],
            [29.95931731571952, -0.725915289880419],
            [29.959049302456194, -0.728073161428604],
            [29.960617674703993, -0.731919302332687],
            [29.957572084955203, -0.736730850630787],
            [29.95366462906495, -0.738204013270532],
            [29.952570292402697, -0.741360915106253],
            [29.950818144610697, -0.74276684296028],
            [29.950148102020037, -0.744643061604566],
            [29.948822508460932, -0.746870542099009],
            [29.948719583088927, -0.749437002292594],
            [29.94864448123622, -0.752374677544861],
            [29.949472786318687, -0.752614462128368],
            [29.95381691416687, -0.762082694568668],
            [29.955681406166605, -0.764178789330861],
            [29.953816064360616, -0.764733855648164],
            [29.95289017978041, -0.766040482366767],
            [29.952243558964174, -0.7691911698017],
            [29.950075316922444, -0.770239652562539],
            [29.950390883403685, -0.773927087935233],
            [29.94913867861002, -0.776242791223951],
            [29.949391856196414, -0.777535394795951],
            [29.950587856097716, -0.777714402662542],
            [29.95242749979837, -0.780348202858633],
            [29.953479550963593, -0.780775031889887],
            [29.957363497044536, -0.779476591700209],
            [29.959774667793603, -0.777913703389921],
            [29.96116637556099, -0.776249903431597],
            [29.9620725124763, -0.775825626720405],
            [29.962881754410088, -0.776025829362701],
            [29.964842902439457, -0.778979308792263],
            [29.96993953552642, -0.781358010386907],
            [29.97198544948434, -0.783543419350664],
            [29.973381795253538, -0.7839334457283],
            [29.974615052781225, -0.784848862687494],
            [29.97709639453039, -0.784918912130076],
            [29.979239886189387, -0.783405356708655],
            [29.980514347642544, -0.783597374307162],
            [29.980893566948147, -0.784225532540277],
            [29.98063464643214, -0.785363584052818],
            [29.982795605831836, -0.788408283869734],
            [29.985093552024175, -0.790104100896887],
            [29.98662601322017, -0.792631745936216],
            [29.98808071265192, -0.793937210674499],
            [29.990417821797386, -0.794411007604262],
            [29.9933369673817, -0.79618007900144],
            [29.99561598157941, -0.796608541185316],
            [29.99782737958569, -0.799734576244777],
            [30.001572029305418, -0.80030258760722],
            [30.006378141839615, -0.801869151127809],
            [30.011372115455888, -0.804899519242538],
            [30.01535204562663, -0.796924052902389],
            [30.017673952582545, -0.789153780768643],
            [30.019664595895943, -0.787408759188444],
            [30.021333288401433, -0.783855231347438],
            [30.03069375162827, -0.785551469699529],
            [30.033355901786223, -0.782842830327617],
            [30.034681196206364, -0.783033509587083],
            [30.041437541340898, -0.780598800588209],
            [30.04393477788068, -0.780302403806749],
            [30.04483391961486, -0.779029070859224],
            [30.045070387638674, -0.777791413526054],
            [30.04768689170212, -0.775137215555992],
            [30.04687484343136, -0.774123073461974],
            [30.045467504079685, -0.773617679774853],
            [30.04476007899681, -0.772658601732492],
            [30.044636887632024, -0.771550233419549],
            [30.043752331843113, -0.770511328850919],
            [30.042086452861103, -0.769785319436078],
            [30.041785367222275, -0.766651058460116],
            [30.040874390184232, -0.765806547834455],
            [30.040635082585794, -0.764918508563323],
            [30.04103502333008, -0.763484446135576],
            [30.040038857256988, -0.762138941197308],
            [30.040545894251135, -0.759725646773223],
            [30.03961418229969, -0.759640285578934],
            [30.03895967427524, -0.760631496443587],
            [30.038358333040897, -0.760359033572681],
            [30.038042649778703, -0.759270601130621],
            [30.03677174385746, -0.760043638585054],
            [30.036293424206328, -0.758584912552319],
            [30.037052637165335, -0.757453362501824],
            [30.036909569676567, -0.755444777033551],
            [30.035061805205714, -0.753784639450251],
            [30.033837847037844, -0.754405979059117],
            [30.03204015376261, -0.754537466643088],
            [30.03149235750909, -0.75502744792541],
            [30.030597396534265, -0.753936019421013],
            [30.028337386196387, -0.753787914424329],
            [30.02659443625457, -0.752677458238524],
            [30.025949900428092, -0.750902414285232],
            [30.025117131617023, -0.751048634876311],
            [30.02404770254262, -0.750650238411934],
            [30.022885439770143, -0.74952886513678],
            [30.02286605682127, -0.745144832487138],
            [30.022216558701164, -0.743555271078365],
            [30.022399647034156, -0.743064301347888],
            [30.02288983882009, -0.743562737246247],
            [30.0233548795747, -0.743215473297063],
            [30.022065496206363, -0.741541819757632],
            [30.01989377678617, -0.742955281091051],
            [30.019481252441413, -0.742248519940655],
            [30.018965722774578, -0.742479822099794],
            [30.018468913099948, -0.743257304320142],
            [30.018939867464084, -0.744136286572524],
            [30.018618323592957, -0.744873336950666],
            [30.017584519906112, -0.745253014632605],
            [30.017495033330754, -0.74429689898202],
            [30.01550752962928, -0.745800382761558],
            [30.013782351957033, -0.745112439282549],
            [30.013247637869018, -0.745538719392181],
            [30.012708688224418, -0.7453439972898],
            [30.010922511351133, -0.745857855697061],
            [30.00838499525234, -0.744714883031421],
            [30.00663786724612, -0.746844680002673],
            [30.006121955795315, -0.746640330632371],
            [30.005660349300047, -0.744126606245183],
            [30.00383357306751, -0.744404306865889],
            [30.003329309172635, -0.743529802391531],
            [30.003693995533595, -0.738290162639401],
            [30.003414065219715, -0.736813734023867],
            [30.003733704662423, -0.735544080960468],
            [30.0026314367745, -0.73311103305627],
            [30.0029346352509, -0.731811716295375],
            [30.00365685828142, -0.731190265720753],
            [30.003378289813508, -0.730249076734068],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 296,
        District: "RUKUNGIRI",
        County: "RUJUMBURA",
        Subcounty: "BUHUNGA",
        Population: 22088,
        Key: "RUKUNGIRIBUHUNGA",
        Dist2: "Rukungiri",
        "Sub Country": "Buhunga",
        id2_original: "Rukungiri Buhunga",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.900195519050296, -1.041358092635507],
            [29.902649888883047, -1.043519220708936],
            [29.904142395710174, -1.047264559369675],
            [29.90851762323347, -1.053741731380635],
            [29.909514424415477, -1.054362118802469],
            [29.913491738692105, -1.054875735174951],
            [29.917170820379255, -1.056832471657547],
            [29.91811311268808, -1.0577412080649],
            [29.91956235665113, -1.050451301866211],
            [29.921716268767423, -1.04677887468879],
            [29.922844710867775, -1.043432593466375],
            [29.924347104552893, -1.041219255786962],
            [29.92441086337851, -1.039923156594182],
            [29.923912120529405, -1.038538402327637],
            [29.924665425268767, -1.035242092751572],
            [29.923966281754502, -1.034234678786955],
            [29.92438027843804, -1.03308934253176],
            [29.925114998830814, -1.032624702473156],
            [29.92663734230177, -1.033228406973787],
            [29.92772524163673, -1.033147341811345],
            [29.92873327714963, -1.031259514341305],
            [29.93114857655575, -1.029655969216818],
            [29.933893423822145, -1.027012011837049],
            [29.934230870568715, -1.021692478443571],
            [29.93481438832951, -1.019891550530618],
            [29.93666815085148, -1.018365120476393],
            [29.937085385063327, -1.016611864874821],
            [29.936421490542468, -1.015466746861302],
            [29.936612392421814, -1.014464874700344],
            [29.938371046711424, -1.013081549183476],
            [29.939391793385624, -1.013558794362034],
            [29.940469696268075, -1.013423839115001],
            [29.93943232177797, -1.012942191961369],
            [29.935390667465725, -1.008516382713823],
            [29.92978636676732, -1.004001736809283],
            [29.92857207806518, -1.002742173042208],
            [29.928642125996078, -1.002104290759598],
            [29.930321167093627, -0.99565664708108],
            [29.933167817736212, -0.989667229440238],
            [29.93388654452367, -0.987245979726811],
            [29.935835918334615, -0.990598233725267],
            [29.937826641598086, -0.992531422315967],
            [29.938761297328718, -0.992637524376982],
            [29.939366236315767, -0.990162006931796],
            [29.939581345097096, -0.983563450622587],
            [29.938979268142532, -0.979934417779481],
            [29.942261655596845, -0.980623728045778],
            [29.942768167076522, -0.97534485028791],
            [29.94482792047968, -0.972840491854935],
            [29.94571925675235, -0.968152822797979],
            [29.946196048369185, -0.967601351178596],
            [29.94823434371515, -0.967142719703865],
            [29.949359000314903, -0.966266330389204],
            [29.95354897187042, -0.965964768399825],
            [29.959249540526276, -0.968435415782448],
            [29.96313133244718, -0.971102532428594],
            [29.96665058947224, -0.974248897189032],
            [29.969472865227917, -0.975613393259945],
            [29.972517174877414, -0.968811734544241],
            [29.9742161963035, -0.963342545455495],
            [29.97449677699765, -0.96098224317477],
            [29.973934454087672, -0.95937734533703],
            [29.970768810789387, -0.957114871169355],
            [29.970266693868073, -0.955729582650735],
            [29.96858313604129, -0.954681016258629],
            [29.96852387867355, -0.953373807395238],
            [29.967672733026692, -0.952049012348705],
            [29.96770169381315, -0.949617123591861],
            [29.966917465468406, -0.948515317693449],
            [29.965978193295552, -0.948200368383568],
            [29.96553660485807, -0.946659770690208],
            [29.965538370945932, -0.944623048148479],
            [29.96615655110026, -0.943735267589315],
            [29.966354926064458, -0.939381644972413],
            [29.965732325300614, -0.937611211449168],
            [29.96587620666301, -0.934172886049588],
            [29.958507759375344, -0.926728692659594],
            [29.958880937510703, -0.925591626181842],
            [29.958403178408286, -0.924654543198077],
            [29.958948780077563, -0.923972578882868],
            [29.958777351876964, -0.922339944689628],
            [29.956931297798416, -0.920331207631634],
            [29.955123452662182, -0.920302896386516],
            [29.9510050777331, -0.917355556217821],
            [29.94862811483007, -0.914396338507517],
            [29.94567907690634, -0.912005335033294],
            [29.945508655717152, -0.911429310291075],
            [29.943779125707373, -0.910879723127622],
            [29.940260063616755, -0.906628316996625],
            [29.939315828251935, -0.907149367111255],
            [29.939035703003622, -0.90831325707608],
            [29.937932212508606, -0.908526412177001],
            [29.937758920303768, -0.909101637084718],
            [29.93678873440703, -0.908873336531206],
            [29.935976968207267, -0.909943104252587],
            [29.93571019012745, -0.911033408141063],
            [29.936120667211693, -0.912933826447105],
            [29.935506771122956, -0.915796779824526],
            [29.933152437680242, -0.914981382506091],
            [29.93207054178636, -0.91518440730486],
            [29.930765013895716, -0.913882633131807],
            [29.929534138700163, -0.915206556933795],
            [29.93013963374438, -0.915182747429959],
            [29.929537006122565, -0.916071475585995],
            [29.928442803309242, -0.916322933983779],
            [29.92792357438009, -0.917798431736331],
            [29.925383893341454, -0.917149636642827],
            [29.923047757071448, -0.917500311048586],
            [29.922286916365135, -0.918175548186585],
            [29.920298869182915, -0.916374079310852],
            [29.92019260567133, -0.914871941235116],
            [29.91940626898063, -0.913352135812159],
            [29.91635255576672, -0.912171270568193],
            [29.915796164432574, -0.910968281329639],
            [29.914994068596858, -0.910305149699757],
            [29.913349177853135, -0.909763423429208],
            [29.912525336499314, -0.910190722367572],
            [29.91024912594361, -0.90964156705048],
            [29.909136115103234, -0.908184214130743],
            [29.907193530759216, -0.907886288454115],
            [29.906284520133326, -0.907202870350714],
            [29.903528821218295, -0.90723300864332],
            [29.90144743189151, -0.904724564835052],
            [29.900161872651342, -0.904542913992573],
            [29.898945018360724, -0.905121567974925],
            [29.893649418319807, -0.902537590052172],
            [29.893317147665872, -0.9025192244783],
            [29.893243112113424, -0.902974831161953],
            [29.890527081903024, -0.902510109505746],
            [29.88978750342121, -0.901102870818997],
            [29.889889261881656, -0.900221712642163],
            [29.888930204314633, -0.899543010467101],
            [29.88803904501009, -0.898203433309335],
            [29.886743076092394, -0.897761704195105],
            [29.886575247441137, -0.897134521713419],
            [29.885935452024412, -0.897184816711334],
            [29.885979855748907, -0.896280129997738],
            [29.885593109459517, -0.896067243640924],
            [29.88429230760561, -0.897041746998895],
            [29.88106659845583, -0.89754006581433],
            [29.880067914405014, -0.898511572368633],
            [29.879334879251726, -0.898584643127035],
            [29.878541042526724, -0.899733093005074],
            [29.8765524087446, -0.900976339894439],
            [29.87490647415855, -0.903081659918886],
            [29.872661412685304, -0.904287863756127],
            [29.87128102369048, -0.905553671051867],
            [29.86744534588637, -0.906510612904015],
            [29.86561778362794, -0.908301672061454],
            [29.864182408754587, -0.908773185180826],
            [29.864027121482998, -0.909966567085123],
            [29.86355578353827, -0.910474312552303],
            [29.861679413115514, -0.910986823806374],
            [29.857376976977985, -0.91347077560711],
            [29.85444875122278, -0.913775621461162],
            [29.85350492369308, -0.918223891103416],
            [29.85445150006753, -0.923890843718549],
            [29.854120150186784, -0.927784220403],
            [29.853142937667894, -0.931287101843157],
            [29.85134597202804, -0.934968528533578],
            [29.850872873385335, -0.937701699205607],
            [29.851488942498783, -0.943177303499158],
            [29.852527790225928, -0.945632487818292],
            [29.855349254802924, -0.95024804137248],
            [29.855870084529908, -0.951969424517317],
            [29.855582809590256, -0.954550520840477],
            [29.855961252751463, -0.956176170030267],
            [29.858188743177756, -0.961149738341349],
            [29.85932736408859, -0.962393671345668],
            [29.858922325405075, -0.963899094325395],
            [29.85645013838696, -0.966860587381839],
            [29.855944753394645, -0.969103125213377],
            [29.856502310742055, -0.970413170811574],
            [29.858209470006283, -0.971322870983614],
            [29.858282943213382, -0.973751383265286],
            [29.85922538284593, -0.973989133871359],
            [29.862133973225685, -0.978088475105316],
            [29.863311991549956, -0.978405411130976],
            [29.865131788771045, -0.981802923599863],
            [29.86591661898701, -0.982257715140918],
            [29.866208454673355, -0.983600544679087],
            [29.866816480271734, -0.984055188673369],
            [29.867628218623725, -0.985724249008056],
            [29.869980378143428, -0.988194294448312],
            [29.870348620036268, -0.990563875606263],
            [29.872331076104185, -0.99135538407712],
            [29.872683224678724, -0.992046735339593],
            [29.874667409105225, -0.992028749272371],
            [29.875824034949282, -0.993174922776047],
            [29.87689036214101, -0.995219365593854],
            [29.877793690024397, -0.995378124253694],
            [29.879989591193716, -0.997433445350002],
            [29.883089373608644, -0.999390867285861],
            [29.885265223482516, -1.001964991449494],
            [29.88658038939782, -1.004368428477784],
            [29.887766463813527, -1.005209917179556],
            [29.88853241593379, -1.006698415345723],
            [29.88977865411734, -1.007492283031942],
            [29.890682721314203, -1.006891446071693],
            [29.891211039397426, -1.007109391304674],
            [29.890087763508276, -1.012492423662529],
            [29.888647671581356, -1.01407730520373],
            [29.887568687127295, -1.01412891880598],
            [29.886907658232218, -1.014746990393937],
            [29.886439601833217, -1.016130417590552],
            [29.88706255114341, -1.016886296504107],
            [29.885440143434632, -1.017654819728527],
            [29.88526217190548, -1.019135599569517],
            [29.886575316611413, -1.020380876923449],
            [29.88837827850576, -1.021027907992628],
            [29.889202316590612, -1.02213425172613],
            [29.89013488463652, -1.0220494696449],
            [29.893044402077642, -1.025119661136566],
            [29.8927711345682, -1.026649889039064],
            [29.893773183708074, -1.029057882992738],
            [29.894557276407195, -1.029365041985776],
            [29.894296803602344, -1.030662787349295],
            [29.89802978510487, -1.035958638149598],
            [29.898126400710296, -1.037472613879692],
            [29.899203590330423, -1.04006202942644],
            [29.899856331368678, -1.040488919326291],
            [29.900195519050296, -1.041358092635507],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 297,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "NYAKISHENYI",
        Population: 34133,
        Key: "RUKUNGIRINYAKISHENYI",
        Dist2: "Rukungiri",
        "Sub Country": "Nyakishenyi",
        id2_original: "Rukungiri Nyakishenyi",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.00314503057189, -0.863000849953759],
            [30.00682934943715, -0.862734793750352],
            [30.009546533084357, -0.860679409565115],
            [30.01182492385128, -0.859652434730078],
            [30.012670624809207, -0.858752709653095],
            [30.015123706457814, -0.861164144156495],
            [30.016844330569874, -0.863506924898664],
            [30.019006508983423, -0.861745015396071],
            [30.02198537995776, -0.861159482426795],
            [30.022951568351477, -0.861376408243868],
            [30.025648053916225, -0.856965417099582],
            [30.02744086035629, -0.855919402701075],
            [30.028352831829384, -0.85394166648323],
            [30.02950233582985, -0.853713576323568],
            [30.028836225165225, -0.850378237301531],
            [30.02970289100524, -0.850664241950092],
            [30.0313675374987, -0.849615031780297],
            [30.034086185399808, -0.845648943017646],
            [30.03335749000766, -0.843914140732464],
            [30.030760547657838, -0.84141367031955],
            [30.02749399301041, -0.836267258927097],
            [30.02577198010294, -0.835207774632623],
            [30.023965244386048, -0.835646332243026],
            [30.02358131341677, -0.836087919499277],
            [30.023551714826475, -0.83661698161133],
            [30.024193541334068, -0.837381708570644],
            [30.020777338140064, -0.837114559265533],
            [30.017404163349898, -0.838459552774569],
            [30.014505177757147, -0.839103522820311],
            [30.010431530844407, -0.838793216005313],
            [30.00703013727619, -0.837425524608303],
            [30.006087431742298, -0.838472763781058],
            [30.006347855139808, -0.840597407957896],
            [30.005446897012128, -0.842617785818195],
            [30.005137083342, -0.848565374013582],
            [30.003950412444922, -0.85066397787452],
            [30.003830932020573, -0.851928372470087],
            [30.003304204853716, -0.852385621864396],
            [29.999934663748842, -0.852000877361834],
            [29.998982717245646, -0.852352311528475],
            [29.998380775936713, -0.853741881790643],
            [29.998638384014086, -0.855653735829814],
            [29.998350178419813, -0.857659498156498],
            [29.999352719836462, -0.858609178584312],
            [30.000354683636353, -0.858700750645113],
            [30.00165344002637, -0.85952747607026],
            [30.001730987093275, -0.860668774712129],
            [30.002158311182345, -0.861179930264332],
            [30.002016332451696, -0.861965852900164],
            [30.00314503057189, -0.863000849953759],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 298,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "KEBISONI TOWN COUNCIL",
        Population: 3506,
        Key: "RUKUNGIRIKEBISONI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.975748640431522, -0.814212452657334],
            [29.96538025487948, -0.814506404724822],
            [29.96435505705307, -0.815917730765478],
            [29.963845690727414, -0.817556880912639],
            [29.964960135278996, -0.821464496707687],
            [29.964350576256447, -0.82332683492777],
            [29.961717242256146, -0.823350860584183],
            [29.96066556838334, -0.820579711965265],
            [29.95900576201268, -0.819630801064819],
            [29.956822377070218, -0.819458034083466],
            [29.955265501461408, -0.820733527288608],
            [29.953879383910024, -0.820969376421584],
            [29.95291068472509, -0.819830517433245],
            [29.952350163835554, -0.819758424232074],
            [29.95227131241487, -0.820783883472966],
            [29.95348461746179, -0.824298969386389],
            [29.9552687632442, -0.825297827511517],
            [29.958109328699077, -0.825926878443014],
            [29.960155836443374, -0.827196793418577],
            [29.958821132170634, -0.829020928503338],
            [29.95759433352985, -0.829637211529564],
            [29.957622951159852, -0.830401422468919],
            [29.958644034702257, -0.831519105571166],
            [29.964510094593027, -0.835197650796773],
            [29.96509307426296, -0.836491353932488],
            [29.963659116931087, -0.838743442994344],
            [29.96329711743118, -0.840196257219685],
            [29.962994958305586, -0.842042662986862],
            [29.963384816359113, -0.844891953128474],
            [29.96314192807594, -0.846432336753862],
            [29.962600582624486, -0.846462182716877],
            [29.95983119428286, -0.844481876344843],
            [29.956791754400495, -0.844170035801775],
            [29.955553425883025, -0.845341594554054],
            [29.956791642111092, -0.848241648593633],
            [29.959214327465453, -0.849242887183997],
            [29.959359494317034, -0.850301111056132],
            [29.959884629669205, -0.850859974948911],
            [29.961344163833836, -0.85136079334116],
            [29.96113565138166, -0.853459368734711],
            [29.964648277941574, -0.85257039115337],
            [29.96699245952329, -0.851469481980713],
            [29.973267378632425, -0.846080997260001],
            [29.975976098353048, -0.846992880871676],
            [29.97790234683361, -0.847063301992286],
            [29.979026174288343, -0.846454888294547],
            [29.97852072102408, -0.842997251527134],
            [29.976855487032456, -0.840455731036127],
            [29.976634231079654, -0.838241178639487],
            [29.97437748521949, -0.834970233202178],
            [29.974356335284465, -0.833465288829881],
            [29.975020481333576, -0.832576618366314],
            [29.973369114634977, -0.830857069265624],
            [29.97276634597765, -0.829570728795184],
            [29.97284732011738, -0.826592600078379],
            [29.97451336708435, -0.824680499178971],
            [29.975474278774076, -0.822675406163865],
            [29.974879653344807, -0.819527835922163],
            [29.97585797438475, -0.817334274093544],
            [29.97685494265338, -0.816202650166517],
            [29.975748640431522, -0.814212452657334],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 299,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "BUYANJA TOWN COUNCIL",
        Population: 5031,
        Key: "RUKUNGIRIBUYANJA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.762571555950046, 0.463445652330967],
            [30.757355710136668, 0.467684597532706],
            [30.757013622693318, 0.469438318020288],
            [30.75597985673572, 0.471390700958692],
            [30.747940971598705, 0.471785845687337],
            [30.737005124773262, 0.472921321636177],
            [30.733425299738503, 0.469973025818214],
            [30.729257856133668, 0.468751227773119],
            [30.72690942552068, 0.467105143268091],
            [30.72517382649284, 0.467295275258257],
            [30.721801921022145, 0.466873126018392],
            [30.718482558910733, 0.465661543635905],
            [30.708183605943656, 0.465421324092428],
            [30.704236826301834, 0.464525320932894],
            [30.696995954157586, 0.465286059340199],
            [30.69581974324368, 0.465101467023593],
            [30.69412136501134, 0.463022051230751],
            [30.691142153575505, 0.460968534216077],
            [30.689260988844108, 0.458310149999863],
            [30.68981291914456, 0.448889731103636],
            [30.690676637612132, 0.445311228648451],
            [30.69015451251447, 0.443205900524526],
            [30.687567540566008, 0.440626263695257],
            [30.685842609930496, 0.439823129757641],
            [30.67926918783895, 0.432493756861251],
            [30.676374558177024, 0.431932388663453],
            [30.67238876649905, 0.430475738919767],
            [30.670680982007376, 0.429037878431889],
            [30.669353034862205, 0.427048709069784],
            [30.66909252612474, 0.425990971232762],
            [30.668143403026484, 0.4258550832412],
            [30.667408119390025, 0.425203992398882],
            [30.666343981392664, 0.416977453094493],
            [30.664542976028994, 0.411444564828337],
            [30.66226667564175, 0.407592947786222],
            [30.658779464217815, 0.405485660076541],
            [30.657784020390224, 0.403008478997629],
            [30.65672857, 0.401788304084248],
            [30.66395942772546, 0.400737406975247],
            [30.665203801006502, 0.398199921109662],
            [30.667120311749393, 0.396034840142319],
            [30.667255084194828, 0.394884387974964],
            [30.66873421420905, 0.394208048060437],
            [30.669810158764193, 0.392956346211762],
            [30.670551260788752, 0.387068732007554],
            [30.669289116136465, 0.380449118810707],
            [30.672371864697, 0.376815281967515],
            [30.674295234975396, 0.373389701909165],
            [30.677776725927615, 0.372260267725552],
            [30.686386265848853, 0.37397765023248],
            [30.688940856226285, 0.3738768173875],
            [30.693310763028173, 0.372930502756597],
            [30.70030300126475, 0.370022223235505],
            [30.702555202547863, 0.369515232732241],
            [30.702581856460636, 0.368308623586413],
            [30.705144987121475, 0.36696141644705],
            [30.711718447840596, 0.365805994612805],
            [30.713071255861234, 0.364893295195461],
            [30.717081286780523, 0.365445775721799],
            [30.72064070658361, 0.365238769461155],
            [30.724794317929707, 0.362925554594914],
            [30.72579171289809, 0.360964091767253],
            [30.72861597393055, 0.359437015606066],
            [30.728165469713876, 0.358749846655989],
            [30.727976541433186, 0.356200466720213],
            [30.72830968345294, 0.353732577892476],
            [30.724134851204912, 0.34992562991808],
            [30.721858551715965, 0.345522516234886],
            [30.727201059984413, 0.336284747637577],
            [30.72774815195874, 0.33255127906342],
            [30.7277734691784, 0.323248971503083],
            [30.73421272069573, 0.325300591039959],
            [30.73762094325672, 0.3307429485886],
            [30.73928375269542, 0.332250236220046],
            [30.742276449640244, 0.336520492047435],
            [30.74377304020864, 0.337609165755874],
            [30.746766674994674, 0.337861021138186],
            [30.74876218088873, 0.339117250919709],
            [30.749593412682366, 0.340624359397145],
            [30.750674412955913, 0.340875768246192],
            [30.751588861982533, 0.342131746111703],
            [30.753833847098964, 0.343388044505579],
            [30.75466499984089, 0.345230030990671],
            [30.754664442885392, 0.347574123916357],
            [30.756576535713723, 0.349918680680636],
            [30.757324483799096, 0.351928090737895],
            [30.757449029823345, 0.352723440459585],
            [30.756783353943273, 0.354397632016169],
            [30.758113141736466, 0.357495517594495],
            [30.75819599515176, 0.358751305491411],
            [30.75836220953047, 0.35916993645238],
            [30.760108366457825, 0.359923833608736],
            [30.760690191792627, 0.3610960292053],
            [30.760772895189266, 0.36293784599637],
            [30.76135478071117, 0.363858889894259],
            [30.761105199979156, 0.364277417315581],
            [30.761604072185687, 0.364612415664229],
            [30.761603675130335, 0.366203058036569],
            [30.761021246127655, 0.367458680337793],
            [30.760023124422222, 0.368295604571992],
            [30.75985665761689, 0.36888158776077],
            [30.760272432964673, 0.368965413212126],
            [30.760272326963484, 0.369384003275518],
            [30.759523705141692, 0.370137271667239],
            [30.75873312840286, 0.372355593134327],
            [30.757319316689557, 0.372773817430851],
            [30.756487403972923, 0.374029366938177],
            [30.757567265182715, 0.378717843639011],
            [30.757483932965364, 0.379387565247793],
            [30.756569030289544, 0.379973348274201],
            [30.756401662474026, 0.383991754713007],
            [30.75872875001414, 0.389182881096979],
            [30.758769647614095, 0.391736288388522],
            [30.75918533313034, 0.392154988735437],
            [30.759766729070456, 0.394834120343685],
            [30.758185929529013, 0.397680094762378],
            [30.756271866695243, 0.402786348187886],
            [30.756936609225694, 0.404712042205744],
            [30.757934244044264, 0.405716935432803],
            [30.762674156131897, 0.406388012199594],
            [30.764586344181662, 0.408146629246877],
            [30.766581294916843, 0.411328487519442],
            [30.767495256158274, 0.414175171194103],
            [30.767994077160836, 0.41467762441617],
            [30.77032239629123, 0.415264318503178],
            [30.771569565129404, 0.416101861376818],
            [30.77273336132606, 0.41769284881547],
            [30.772649818902966, 0.419032323366207],
            [30.774228914340313, 0.422381528849891],
            [30.773895959170154, 0.423469776727876],
            [30.774228264858376, 0.42464193467795],
            [30.775974420887405, 0.425395914866801],
            [30.77713797094569, 0.427824102465794],
            [30.777386063169285, 0.432596154699097],
            [30.779440551546557, 0.434224797729383],
            [30.77988008014709, 0.435359623819856],
            [30.78042894000591, 0.438361458305555],
            [30.780203963231227, 0.440529924924258],
            [30.781284196343524, 0.444105586614868],
            [30.781284848520414, 0.444108925552475],
            [30.78114984700458, 0.445262732765789],
            [30.779673875466898, 0.447061343485239],
            [30.777887103908903, 0.447919643187805],
            [30.775733500813047, 0.449853644960134],
            [30.771906756754436, 0.450449132359232],
            [30.769742705353536, 0.451696043366037],
            [30.76523479576445, 0.455301767967216],
            [30.764683095432716, 0.460192459801946],
            [30.762571555950046, 0.463445652330967],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 300,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "BWIZI",
        Population: 28764,
        Key: "KAMWENGEBWIZI",
        Dist2: "Kamwenge",
        "Sub Country": "Bwizi",
        id2_original: "Kamwenge Bwizi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.55862484870036, 0.344703992484819],
            [30.558265985219087, 0.34532947987332],
            [30.55827132121188, 0.347140751349924],
            [30.55857883429654, 0.347485557048477],
            [30.558137550387972, 0.348233321570491],
            [30.55829907466257, 0.352001974877635],
            [30.558635552126976, 0.352545446250532],
            [30.55793316569453, 0.353024368575801],
            [30.558251268119772, 0.357207904194219],
            [30.560003085331736, 0.360702379985765],
            [30.55982865945303, 0.361859209207227],
            [30.560252277093245, 0.362087195279891],
            [30.560141850788643, 0.362659761007129],
            [30.560844009048996, 0.363045579684592],
            [30.561186171950833, 0.364015581664846],
            [30.563362560813836, 0.364191462856165],
            [30.564540181184427, 0.366248463353375],
            [30.565334600017746, 0.368842904411346],
            [30.56446397889551, 0.369006261455957],
            [30.563842718418066, 0.369911727369254],
            [30.562861343106125, 0.371822059005416],
            [30.56281456962592, 0.373060725170624],
            [30.561937820196817, 0.374392642382425],
            [30.558895776996764, 0.377383302266531],
            [30.557798344740046, 0.379194260119154],
            [30.55352555210857, 0.383370628536686],
            [30.553444054251067, 0.384223652287404],
            [30.552358337822252, 0.38563144585665],
            [30.552044456580507, 0.38728486173014],
            [30.551365372446526, 0.387419047204113],
            [30.55044015980618, 0.389102448699932],
            [30.549151588514885, 0.37867318756506],
            [30.547119291220042, 0.376899007632474],
            [30.542851044962244, 0.374646682314113],
            [30.540005007868974, 0.375123392759743],
            [30.538581870744746, 0.375805131150233],
            [30.533025393657113, 0.37648569182158],
            [30.530654056004376, 0.375666432456153],
            [30.529841187571773, 0.374984084111818],
            [30.52909579070182, 0.375052065359675],
            [30.528486476919344, 0.373141883540831],
            [30.525166864177976, 0.371094515272214],
            [30.523473059268735, 0.370480102941707],
            [30.52015291202976, 0.370342799218207],
            [30.516222600303763, 0.371569490401675],
            [30.516493206104972, 0.373070246212496],
            [30.51574742116285, 0.374638941696804],
            [30.510989134036084, 0.375453844422954],
            [30.51022921230634, 0.36529266189316],
            [30.51141459232432, 0.360046338937637],
            [30.51053323723277, 0.357136482330367],
            [30.507005971726954, 0.352251113425016],
            [30.506298905071887, 0.348616838511506],
            [30.498167086523747, 0.346393473619436],
            [30.494506443656118, 0.347304934317801],
            [30.488469708352987, 0.351369686016602],
            [30.475051344782003, 0.354123644803603],
            [30.469851437776725, 0.354262422880106],
            [30.46423408994711, 0.352998909007269],
            [30.458848275695487, 0.354025671917936],
            [30.451255793067528, 0.360158001813578],
            [30.4472804892205, 0.370765144095922],
            [30.446196089721905, 0.371992598772719],
            [30.44355340156456, 0.372810310716803],
            [30.438878602063678, 0.371922207372064],
            [30.435221149113644, 0.367555735917754],
            [30.4333249959917, 0.364144722659408],
            [30.43102163565316, 0.36318912399096],
            [30.428684703475824, 0.361176292979868],
            [30.427533051603458, 0.360698462510453],
            [30.425026006359072, 0.361175235683792],
            [30.42123116506949, 0.363493227244218],
            [30.41791164665122, 0.362128096554545],
            [30.4147625817615, 0.357045719215155],
            [30.4127979770149, 0.35629485088268],
            [30.407377943239148, 0.355543001547569],
            [30.405887198906623, 0.356088239664948],
            [30.401551105590343, 0.356018790454685],
            [30.399653930185607, 0.35642749175529],
            [30.39674068653269, 0.356085620228167],
            [30.39220227015654, 0.352605797521886],
            [30.391390061985664, 0.349809046937414],
            [30.39030622752738, 0.34912666879809],
            [30.388207004845576, 0.34523829444296],
            [30.384482368692087, 0.344313164129368],
            [30.383979178283976, 0.340649682457483],
            [30.384281235899966, 0.339539782273062],
            [30.38342306991915, 0.337027479859363],
            [30.383411999979884, 0.335029507417236],
            [30.380719579291803, 0.334386156666517],
            [30.378792817873194, 0.335016570101675],
            [30.378375187504332, 0.33432710062868],
            [30.379525229595696, 0.330378223382024],
            [30.37933976252383, 0.329513558054295],
            [30.378075068452752, 0.328157877989635],
            [30.378899523355887, 0.326510656050608],
            [30.378098971724153, 0.325517305208717],
            [30.378052733639848, 0.324804569983795],
            [30.380351517960346, 0.321697230987442],
            [30.3795161197804, 0.320797346118266],
            [30.377554756155366, 0.320633258825851],
            [30.3774041149704, 0.319710186910032],
            [30.37649902189748, 0.319043965323217],
            [30.375211274361288, 0.317045675794352],
            [30.373488926382205, 0.312576126159326],
            [30.371887691066355, 0.311068492470836],
            [30.369450780889455, 0.309776805017274],
            [30.369102742107373, 0.309227574082742],
            [30.36906839592078, 0.307323090602194],
            [30.369521387572483, 0.305851031641106],
            [30.372127390330228, 0.303859572101033],
            [30.372319255203564, 0.30235239262121],
            [30.374699001985658, 0.300115502597158],
            [30.377280923605614, 0.301740204651691],
            [30.378882454467167, 0.302096958427157],
            [30.38027579806671, 0.299480083487908],
            [30.381529542572796, 0.298218514748843],
            [30.382318702668407, 0.298405650150692],
            [30.38436067032727, 0.301257048872279],
            [30.385103352488425, 0.301677856147183],
            [30.38566054152656, 0.301257365973171],
            [30.385661146092733, 0.298733611624859],
            [30.384965087393137, 0.297471565801207],
            [30.388448657046908, 0.289924490660675],
            [30.38865694941183, 0.283760902448966],
            [30.390464993075753, 0.284122833724104],
            [30.392090948231598, 0.285171604773928],
            [30.395124549962926, 0.286247818019388],
            [30.40003919155982, 0.289376091458777],
            [30.405013121965485, 0.290410525997024],
            [30.40826293650761, 0.290113865672895],
            [30.412037654636514, 0.291205284037879],
            [30.42081656920966, 0.297003380955077],
            [30.42831746679777, 0.286379695344723],
            [30.431154677045054, 0.281153854291312],
            [30.43178803513441, 0.277398588875321],
            [30.434730136267554, 0.27496931655031],
            [30.437608103079256, 0.271289104377916],
            [30.44379178299993, 0.261117367433878],
            [30.44428771951211, 0.259103986948918],
            [30.44246395712733, 0.256628281150776],
            [30.444431406838437, 0.253484357928102],
            [30.45041264781658, 0.247540237359363],
            [30.45485825115589, 0.240979254575539],
            [30.456827996062547, 0.239540183210781],
            [30.457542133357194, 0.236252690223036],
            [30.461243466313952, 0.230703796073724],
            [30.464286477897872, 0.226555710053038],
            [30.465092447269104, 0.22598517829544],
            [30.467053915098706, 0.226309389434126],
            [30.468940154413175, 0.227291159499552],
            [30.47035268063726, 0.228575949496661],
            [30.473244296451426, 0.229468683602513],
            [30.47589443793065, 0.229791638828155],
            [30.47929710620825, 0.22888508606865],
            [30.479786012505013, 0.228692948740998],
            [30.482106874720237, 0.224516164782224],
            [30.484309601289073, 0.222244192677313],
            [30.48961072327405, 0.224397681498707],
            [30.497455364798856, 0.22658697207883],
            [30.50461115121439, 0.227655513307258],
            [30.507049547204755, 0.227335757807458],
            [30.51107833225221, 0.226109083754911],
            [30.517545092878493, 0.227177507340237],
            [30.522025609241325, 0.229367485603747],
            [30.53130599933868, 0.232022052225688],
            [30.534395144802343, 0.235727564715044],
            [30.535215729763216, 0.23942662547273],
            [30.53572926517013, 0.240289366199885],
            [30.536169529490863, 0.243923099032714],
            [30.53687057294195, 0.244583070901896],
            [30.53707074902829, 0.24543276878059],
            [30.53635715521439, 0.248144314600341],
            [30.533936534188523, 0.250023948806674],
            [30.533675311290427, 0.250792205853244],
            [30.533817486752145, 0.251198984263544],
            [30.53509854363609, 0.251533670859601],
            [30.535322359787447, 0.256369538399],
            [30.534942658984832, 0.256776215125324],
            [30.532760041203627, 0.256061712185162],
            [30.532119386099215, 0.256558727990766],
            [30.5303273899395, 0.258456542693122],
            [30.529828617445983, 0.260128637063946],
            [30.528381156638808, 0.260652603686739],
            [30.528784085179705, 0.261972359741882],
            [30.52823794811453, 0.263355198284314],
            [30.528973186835234, 0.264123651257825],
            [30.53045577177002, 0.264756672923304],
            [30.52967251270751, 0.265588091645263],
            [30.52957664090711, 0.268643216148389],
            [30.530122058421746, 0.269456828398781],
            [30.529148707760278, 0.270966119632073],
            [30.52906545818796, 0.27193326286051],
            [30.529468614002624, 0.27209604653524],
            [30.52982483464034, 0.271282621309202],
            [30.530203831163767, 0.272954894503473],
            [30.53105751634792, 0.274175323652465],
            [30.531793032648064, 0.274265866507864],
            [30.53191150156941, 0.274627447736365],
            [30.530724791146493, 0.27601014830251],
            [30.531684785656317, 0.278703944189552],
            [30.53170747440544, 0.281542163459262],
            [30.52980890840867, 0.28302413033329],
            [30.529571361508204, 0.283855657379298],
            [30.530578769098735, 0.286495231619509],
            [30.529747712476563, 0.288366099675508],
            [30.529865443881057, 0.290797584413093],
            [30.529960221533422, 0.291059733687995],
            [30.530553566863432, 0.290770621827055],
            [30.530719804598334, 0.290156013187328],
            [30.531977096551465, 0.290698626377205],
            [30.532760127441914, 0.290346283804513],
            [30.53311632831669, 0.289677483168343],
            [30.532499965454154, 0.288077460253742],
            [30.533283205652065, 0.287408753805953],
            [30.535299192236277, 0.2892169811889],
            [30.53591640670169, 0.288195718372234],
            [30.536343573585604, 0.288268123464599],
            [30.537220613170533, 0.290437661956534],
            [30.535831867148616, 0.292434956609324],
            [30.53621106848791, 0.293718570373622],
            [30.53711268777565, 0.293818199415612],
            [30.537064286548144, 0.296349090111162],
            [30.53607884905452, 0.29841878244371],
            [30.533777306906106, 0.298825010369057],
            [30.532899878350666, 0.297839568267718],
            [30.532330454258364, 0.297794244382354],
            [30.531713180504138, 0.29904147176193],
            [30.530835139297675, 0.299538409404068],
            [30.531522992785455, 0.300089940488063],
            [30.532732797996022, 0.300307151938924],
            [30.532684530617477, 0.302810916890882],
            [30.533680343652666, 0.304483347156003],
            [30.534676744186033, 0.304818018767262],
            [30.534700169553677, 0.305441709326287],
            [30.535364331772467, 0.305911887142806],
            [30.534533557221316, 0.307041558146799],
            [30.53446209624045, 0.307873122920716],
            [30.536027263299335, 0.309880131323792],
            [30.537771422373513, 0.308958572095417],
            [30.538387897525425, 0.309989156458083],
            [30.53962162038044, 0.309944253029085],
            [30.53957387941466, 0.310730632083333],
            [30.540285717920536, 0.310703682122808],
            [30.540380386876752, 0.31141778284236],
            [30.54116305125455, 0.31208685253476],
            [30.54128190465486, 0.311372802165457],
            [30.54213617733722, 0.311183186776972],
            [30.542278925924087, 0.310270284599486],
            [30.543227731917064, 0.310776690725467],
            [30.542966445238573, 0.311662448867847],
            [30.54351198672074, 0.311870474946696],
            [30.54353558366663, 0.312349544769667],
            [30.54486443361865, 0.311680975448145],
            [30.545196564135367, 0.312015497715109],
            [30.54498266628309, 0.313018774300539],
            [30.545717940936377, 0.313570327147807],
            [30.54686862262821, 0.313507328341889],
            [30.547034405815584, 0.31427568360306],
            [30.546346144492656, 0.314844976046428],
            [30.546298399933626, 0.315631358326711],
            [30.54703367638357, 0.316182913730769],
            [30.546867394631246, 0.31692407091876],
            [30.547609893536055, 0.317180952817649],
            [30.547578633062493, 0.318262015521298],
            [30.551018439490566, 0.319428880261212],
            [30.551493148812572, 0.319004161590018],
            [30.551896292050806, 0.319817771964553],
            [30.552340139751223, 0.319782159708158],
            [30.55263171402785, 0.319763715786008],
            [30.55285672224356, 0.321020196678451],
            [30.55432767130051, 0.321065749531421],
            [30.555134025150664, 0.321834266823077],
            [30.554801589206733, 0.32276520766405],
            [30.555204110810813, 0.32498891389271],
            [30.554966592656424, 0.325585434136713],
            [30.555915413022454, 0.326055698177441],
            [30.556613731883314, 0.330295193480306],
            [30.557728511506486, 0.331371121895792],
            [30.55775213091027, 0.33173269133714],
            [30.556802847013532, 0.331994586273487],
            [30.556399125260228, 0.332970704378998],
            [30.55509396478057, 0.333621187724776],
            [30.554915615959, 0.334895649049329],
            [30.555341973460827, 0.336540867283267],
            [30.55439280454849, 0.336902187705328],
            [30.554226202995896, 0.338312237049945],
            [30.55621875433096, 0.339505903805258],
            [30.5557914482082, 0.339957745755116],
            [30.556158550138953, 0.341783731494207],
            [30.557819026652822, 0.342434975109739],
            [30.557984980520107, 0.343031595802661],
            [30.558554427968595, 0.343031743123744],
            [30.558340524726407, 0.343962713404043],
            [30.55862484870036, 0.344703992484819],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 301,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "KAHUNGE",
        Population: 36400,
        Key: "KAMWENGEKAHUNGE",
        Dist2: "Kamwenge",
        "Sub Country": "Kahunge",
        id2_original: "Kamwenge Kahunge",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.53950880635382, 0.234586865727152],
              [30.538545392856008, 0.2350111400665],
              [30.538605131720715, 0.236728550724921],
              [30.537532741799147, 0.239177909292727],
              [30.53572926517013, 0.240289366199885],
              [30.535215729763216, 0.23942662547273],
              [30.534395144802343, 0.235727564715044],
              [30.53130599933868, 0.232022052225688],
              [30.522025609241325, 0.229367485603747],
              [30.517545092878493, 0.227177507340237],
              [30.51107833225221, 0.226109083754911],
              [30.507049547204755, 0.227335757807458],
              [30.50461115121439, 0.227655513307258],
              [30.497455364798856, 0.22658697207883],
              [30.48961072327405, 0.224397681498707],
              [30.484309601289073, 0.222244192677313],
              [30.487846079916423, 0.218343810205944],
              [30.489334376339826, 0.213110710715196],
              [30.490411860607363, 0.210751811103536],
              [30.493369977803656, 0.194907570979713],
              [30.49335213816043, 0.185489311745761],
              [30.491865186515057, 0.182108650723096],
              [30.49119236004532, 0.179270428713683],
              [30.4927122529122, 0.175763652644946],
              [30.494745010144452, 0.173359652626144],
              [30.495385481094257, 0.171139960624354],
              [30.49784546988909, 0.172990011049872],
              [30.498593707231958, 0.173076974759341],
              [30.499092686338003, 0.172571609134018],
              [30.499944520094378, 0.173061548959658],
              [30.500728030685178, 0.171305975734066],
              [30.504081232333345, 0.172321193204692],
              [30.504330488773544, 0.17349309225877],
              [30.505006960606654, 0.173538720177739],
              [30.506658603088034, 0.172740031705295],
              [30.508155135265955, 0.172907643100095],
              [30.508903465135294, 0.17240549881431],
              [30.50865427247546, 0.170815200433889],
              [30.510649753216697, 0.170313182755076],
              [30.51314393368788, 0.171234226714586],
              [30.513975076548302, 0.173661764552376],
              [30.515055912430185, 0.173327105914059],
              [30.516220126343455, 0.172071716007309],
              [30.51646931990159, 0.173745818628906],
              [30.51929594350325, 0.175420234612756],
              [30.519711765563418, 0.174666986389217],
              [30.519545637422965, 0.173662512845554],
              [30.522622078911866, 0.172491053076129],
              [30.523370284813705, 0.173160806955598],
              [30.52336990931792, 0.176006745496885],
              [30.524700188489557, 0.176509139417043],
              [30.525780837521836, 0.177764841639187],
              [30.52420080244672, 0.180024581348908],
              [30.524782378948153, 0.183456592897231],
              [30.525364266266717, 0.184126284394378],
              [30.526445102148564, 0.184377511337578],
              [30.52577971372943, 0.186135170089229],
              [30.526112033790675, 0.188060439022616],
              [30.526693857328844, 0.188813872637859],
              [30.52868940274877, 0.188563019455069],
              [30.530352189729573, 0.189232960488363],
              [30.530352064863738, 0.190153631590695],
              [30.528689090135046, 0.190906751604595],
              [30.528689028151277, 0.191325278858719],
              [30.530185561227494, 0.191409207987595],
              [30.532596550516878, 0.192748777194875],
              [30.53284580605878, 0.194171840629922],
              [30.534508718803707, 0.193753502989144],
              [30.535256984892648, 0.194507061219563],
              [30.536919834755516, 0.194507248966374],
              [30.537169215163242, 0.195009516597874],
              [30.53592168789723, 0.197436741277902],
              [30.53575518426102, 0.198524896424624],
              [30.535256297681467, 0.198943360607743],
              [30.534839913275917, 0.202877391426475],
              [30.536918334568995, 0.204133280374011],
              [30.53999465209037, 0.204384883411542],
              [30.542488708594092, 0.206645311297546],
              [30.543403289673055, 0.206645435264239],
              [30.544484064469458, 0.207231571384325],
              [30.545398897076712, 0.206143478804876],
              [30.548641593368497, 0.205641773856358],
              [30.548641469400994, 0.206395144692438],
              [30.54722774931587, 0.208068998748651],
              [30.54780957465067, 0.20932470133685],
              [30.5473937525905, 0.209994266032541],
              [30.546153312133786, 0.210465113022543],
              [30.546040331020507, 0.211074648157926],
              [30.547208316959658, 0.211850881599782],
              [30.546990515927426, 0.212114186787211],
              [30.544490615882825, 0.211756268985582],
              [30.544254401183924, 0.212993198413715],
              [30.544294297162317, 0.213535544424667],
              [30.54351269728811, 0.214683366849343],
              [30.54415368027763, 0.216418957188195],
              [30.543913000951754, 0.217774764832333],
              [30.540856999728838, 0.22078423104606],
              [30.539013628019756, 0.220603141011307],
              [30.538858550055632, 0.220955633718614],
              [30.54056109287761, 0.222682362417232],
              [30.54083127287743, 0.22444500528314],
              [30.541512316237046, 0.225638265101699],
              [30.540960779398684, 0.229253755308085],
              [30.53950880635382, 0.234586865727152],
            ],
          ],
          [
            [
              [30.461243466313952, 0.230703796073724],
              [30.457542133357194, 0.236252690223036],
              [30.456827996062547, 0.239540183210781],
              [30.45485825115589, 0.240979254575539],
              [30.45041264781658, 0.247540237359363],
              [30.444431406838437, 0.253484357928102],
              [30.44246395712733, 0.256628281150776],
              [30.44428771951211, 0.259103986948918],
              [30.44379178299993, 0.261117367433878],
              [30.437608103079256, 0.271289104377916],
              [30.434730136267554, 0.27496931655031],
              [30.43178803513441, 0.277398588875321],
              [30.431154677045054, 0.281153854291312],
              [30.42831746679777, 0.286379695344723],
              [30.42081656920966, 0.297003380955077],
              [30.412037654636514, 0.291205284037879],
              [30.40826293650761, 0.290113865672895],
              [30.405013121965485, 0.290410525997024],
              [30.40003919155982, 0.289376091458777],
              [30.395124549962926, 0.286247818019388],
              [30.392090948231598, 0.285171604773928],
              [30.390464993075753, 0.284122833724104],
              [30.38865694941183, 0.283760902448966],
              [30.38868409739804, 0.280308433874351],
              [30.386450041185334, 0.27808460982451],
              [30.38542800003882, 0.276240654225899],
              [30.38440623108186, 0.276330804506419],
              [30.38381222279516, 0.277388100269002],
              [30.38276681646811, 0.277812644479127],
              [30.379202422693286, 0.278119126284386],
              [30.37720650177758, 0.278697094616551],
              [30.373107843072354, 0.280820043447628],
              [30.371278130247177, 0.280864814045268],
              [30.369804746755825, 0.280123381342325],
              [30.368877974640117, 0.280123169342477],
              [30.365991048930066, 0.281405866420878],
              [30.36051353824749, 0.278684264131122],
              [30.358089688676525, 0.277987810305854],
              [30.353919521379755, 0.277769957038582],
              [30.34919056694195, 0.27616018587435],
              [30.342692369772315, 0.280406359847772],
              [30.34138556717229, 0.28069525996965],
              [30.33785627237226, 0.276437771052671],
              [30.33659688464957, 0.275479507931397],
              [30.33422065477181, 0.275316292217907],
              [30.33166628178668, 0.275812771858528],
              [30.32978901933687, 0.274881485682864],
              [30.32807836293121, 0.275974627531652],
              [30.323705983965674, 0.274111919488842],
              [30.32201919220383, 0.275159874873887],
              [30.319642960529443, 0.274508639717706],
              [30.31707685375009, 0.275538313664993],
              [30.31544912082829, 0.274724578756923],
              [30.314165978954556, 0.274724285909502],
              [30.313191877301506, 0.275799505692129],
              [30.312621685149622, 0.275871673709088],
              [30.311575941954356, 0.274317013299102],
              [30.30922339256578, 0.273231998264709],
              [30.30846306300088, 0.273042041774879],
              [30.307536460666796, 0.273737702686249],
              [30.306823640302323, 0.27373753919471],
              [30.305242827286154, 0.268260588342905],
              [30.303745743542652, 0.267853576023568],
              [30.302058744270017, 0.268088166697622],
              [30.297829225282417, 0.267563058641976],
              [30.294290816175504, 0.266631783509527],
              [30.29464948112909, 0.266017062221741],
              [30.294435506021667, 0.26513263001982],
              [30.292249496201947, 0.264987383874116],
              [30.29184550495405, 0.26458077298928],
              [30.291631435523534, 0.26307496729698],
              [30.288589918736246, 0.262092552171647],
              [30.28788882408119, 0.261028459398233],
              [30.288173803825288, 0.260072757039163],
              [30.289266599876854, 0.258783147938644],
              [30.289480259675603, 0.257564490524723],
              [30.288255892774284, 0.253130251791979],
              [30.28846960916688, 0.252293974211043],
              [30.289301147286064, 0.251792793691891],
              [30.28960989106268, 0.250884897627548],
              [30.288925880567685, 0.246926382019806],
              [30.29002497650433, 0.243382149239727],
              [30.290922440185568, 0.242403558515461],
              [30.289133676164244, 0.240608924675179],
              [30.28892648423557, 0.239449047226429],
              [30.289347445557468, 0.238102575936169],
              [30.28888686763321, 0.236063047595996],
              [30.289356047824644, 0.234873144727631],
              [30.28900634176938, 0.233699707740165],
              [30.289735403674168, 0.232247139442413],
              [30.289604794021745, 0.229707100853029],
              [30.290723001616072, 0.225189179207123],
              [30.28790334265281, 0.218710640872322],
              [30.288287550303195, 0.214600511320497],
              [30.286052979355855, 0.210924272995692],
              [30.28862990724114, 0.210159888206519],
              [30.289295546290255, 0.206728752566419],
              [30.290376259102935, 0.206561640959331],
              [30.292038482840024, 0.2084867233756],
              [30.292454117152328, 0.208403043165721],
              [30.29544737015433, 0.204888662596192],
              [30.296777525358465, 0.204386831844983],
              [30.298772818351804, 0.202880775358927],
              [30.29985340629865, 0.20380144481075],
              [30.30068467402491, 0.203801693642505],
              [30.30176551170338, 0.203048636194666],
              [30.302264334502567, 0.202462874516739],
              [30.302015078960668, 0.201626010997946],
              [30.300269602057977, 0.200202947301749],
              [30.300602233834645, 0.19961718731821],
              [30.300644298346132, 0.196813618687568],
              [30.304634448649853, 0.196897987062761],
              [30.30563222180898, 0.195726526129794],
              [30.30812627651604, 0.194387893196839],
              [30.315358747615765, 0.19330105200927],
              [30.31918351987234, 0.188447725803922],
              [30.31943321379209, 0.186271729460942],
              [30.320015289756846, 0.185351246799475],
              [30.321843953349777, 0.186606949305847],
              [30.322010395900588, 0.185267879085546],
              [30.324088941161165, 0.183426978289038],
              [30.322758849737426, 0.183928996510976],
              [30.319350460988105, 0.183593650851973],
              [30.31818674833474, 0.183258742663963],
              [30.317854303407675, 0.182505497457279],
              [30.319683344293058, 0.181668818911659],
              [30.32109687573196, 0.179242031309918],
              [30.322510218524677, 0.178489034768622],
              [30.322925976804452, 0.177652170986616],
              [30.322094958809856, 0.17564353587982],
              [30.322843288679195, 0.174555629947103],
              [30.32375768380689, 0.174890537395785],
              [30.323757808672717, 0.174053673452044],
              [30.324506011879595, 0.173802695199535],
              [30.325586662708506, 0.174305025398676],
              [30.326334865915385, 0.174054048946098],
              [30.326916878099784, 0.173300864448037],
              [30.32633517852911, 0.171961794152974],
              [30.329328306665314, 0.168949308975973],
              [30.331489540949477, 0.170037587129728],
              [30.33198842752903, 0.169368083769992],
              [30.333401647252536, 0.169284653102301],
              [30.33414978937398, 0.169786921436751],
              [30.334482169622394, 0.170707529740445],
              [30.336809848253964, 0.170624223045524],
              [30.33830631665149, 0.169871164175717],
              [30.339387091447932, 0.169871289939291],
              [30.33913783680437, 0.168448539901593],
              [30.339719911870787, 0.167611674778327],
              [30.34071755926576, 0.167277140900168],
              [30.341881772280733, 0.164013302923823],
              [30.343212051452365, 0.16326018002071],
              [30.343627934597976, 0.161251668287058],
              [30.342381031661144, 0.160916761503078],
              [30.342879919138987, 0.160247257836156],
              [30.344791898779622, 0.160331249986521],
              [30.345540165766895, 0.159661807385691],
              [30.34695350945791, 0.159243532747913],
              [30.348846352288007, 0.157595824897652],
              [30.350318317339543, 0.157641204919143],
              [30.35112296259402, 0.157108090046686],
              [30.35398113053689, 0.156602353911648],
              [30.354955133375256, 0.156765157676761],
              [30.357346733427523, 0.155491156399466],
              [30.359721053486986, 0.15557280038159],
              [30.360201191328244, 0.156693534368818],
              [30.36077027945063, 0.156567079897117],
              [30.360416358500053, 0.15451547997684],
              [30.362020325592674, 0.152346636653952],
              [30.36201567770939, 0.151370564830556],
              [30.36503609307066, 0.152545845447891],
              [30.374347133685514, 0.148642688004461],
              [30.378525923012393, 0.148787802264929],
              [30.380008769356934, 0.146094710469349],
              [30.381525174963876, 0.145471280781884],
              [30.382564982091754, 0.14448627942959],
              [30.385808545257806, 0.145146427663667],
              [30.387160926578698, 0.144974867960541],
              [30.39316239761704, 0.146441994433287],
              [30.395294557028752, 0.148008206452075],
              [30.396534454903016, 0.149857914018006],
              [30.39785238583278, 0.149930089810837],
              [30.398869469177246, 0.150688943527356],
              [30.40221861133863, 0.150300405540965],
              [30.402683870383836, 0.149587118698483],
              [30.406251632840966, 0.147298875702928],
              [30.408577293856453, 0.144969377475123],
              [30.409810799319143, 0.14450907320912],
              [30.41279661966052, 0.141016500702114],
              [30.414189064046457, 0.139965379758197],
              [30.412753378356005, 0.142627988045081],
              [30.412580164304615, 0.143640230803116],
              [30.413408256486328, 0.148032829191848],
              [30.414237997974915, 0.150265332737969],
              [30.414472426823018, 0.154639791088403],
              [30.415331330320683, 0.158288719793093],
              [30.415074553184922, 0.161906482728099],
              [30.416143938241863, 0.164636125704996],
              [30.41567961883446, 0.166823280710022],
              [30.412675307571295, 0.16852806471489],
              [30.409116274942082, 0.171804339955105],
              [30.40736972275597, 0.174152000792482],
              [30.407944285211702, 0.175173378728038],
              [30.41277370723089, 0.179837703046906],
              [30.412743213918546, 0.180541322081643],
              [30.41132113860298, 0.183921967230106],
              [30.405819385085803, 0.189625018169937],
              [30.40556196385799, 0.195129153534034],
              [30.41149041264354, 0.193312824364064],
              [30.4134117823738, 0.194244479783165],
              [30.413469791083305, 0.196476892576423],
              [30.412146645433317, 0.197814316217145],
              [30.412104797415804, 0.198998294951065],
              [30.41289279329484, 0.200836248512122],
              [30.415383367928477, 0.203267605456842],
              [30.415611637028682, 0.204788488505785],
              [30.415084518196394, 0.206460373636821],
              [30.415511039191593, 0.208940733399495],
              [30.417935557109132, 0.210368771154622],
              [30.42176516589518, 0.210777103897551],
              [30.42401673117108, 0.212846638388789],
              [30.42619478551063, 0.216946073149338],
              [30.426251971363328, 0.220467895257266],
              [30.427685720286004, 0.223168855750033],
              [30.428213284682688, 0.223347535591769],
              [30.429939234007744, 0.2227136253496],
              [30.43148175633493, 0.220387359193093],
              [30.43263050395398, 0.219701688278251],
              [30.436001580279655, 0.21999787052847],
              [30.43776847032376, 0.219132996889727],
              [30.440189166808107, 0.21870639097365],
              [30.441283063295888, 0.219487365300313],
              [30.447970434884585, 0.220902540086774],
              [30.450529187156693, 0.220319101211043],
              [30.45165108233527, 0.220425453767507],
              [30.452099515036874, 0.219856116522615],
              [30.453655193191423, 0.220001000235853],
              [30.45693735516859, 0.226301321727492],
              [30.458068181397714, 0.22694324921491],
              [30.461243466313952, 0.230703796073724],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 302,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "KAMWENGE",
        Population: 22010,
        Key: "KAMWENGEKAMWENGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.414189064046457, 0.139965379758197],
            [30.41279661966052, 0.141016500702114],
            [30.409810799319143, 0.14450907320912],
            [30.408577293856453, 0.144969377475123],
            [30.406251632840966, 0.147298875702928],
            [30.402683870383836, 0.149587118698483],
            [30.40221861133863, 0.150300405540965],
            [30.398869469177246, 0.150688943527356],
            [30.39785238583278, 0.149930089810837],
            [30.396534454903016, 0.149857914018006],
            [30.395294557028752, 0.148008206452075],
            [30.39316239761704, 0.146441994433287],
            [30.387160926578698, 0.144974867960541],
            [30.385808545257806, 0.145146427663667],
            [30.382564982091754, 0.14448627942959],
            [30.381525174963876, 0.145471280781884],
            [30.380008769356934, 0.146094710469349],
            [30.378525923012393, 0.148787802264929],
            [30.374347133685514, 0.148642688004461],
            [30.36503609307066, 0.152545845447891],
            [30.36201567770939, 0.151370564830556],
            [30.362020325592674, 0.152346636653952],
            [30.360416358500053, 0.15451547997684],
            [30.36077027945063, 0.156567079897117],
            [30.360201191328244, 0.156693534368818],
            [30.359721053486986, 0.15557280038159],
            [30.357346733427523, 0.155491156399466],
            [30.354955133375256, 0.156765157676761],
            [30.35398113053689, 0.156602353911648],
            [30.35112296259402, 0.157108090046686],
            [30.350318317339543, 0.157641204919143],
            [30.348846352288007, 0.157595824897652],
            [30.34695350945791, 0.159243532747913],
            [30.345540165766895, 0.159661807385691],
            [30.344791898779622, 0.160331249986521],
            [30.342879919138987, 0.160247257836156],
            [30.342381031661144, 0.160916761503078],
            [30.343627934597976, 0.161251668287058],
            [30.343212051452365, 0.16326018002071],
            [30.341881772280733, 0.164013302923823],
            [30.34071755926576, 0.167277140900168],
            [30.339719911870787, 0.167611674778327],
            [30.33913783680437, 0.168448539901593],
            [30.339387091447932, 0.169871289939291],
            [30.33830631665149, 0.169871164175717],
            [30.336809848253964, 0.170624223045524],
            [30.334482169622394, 0.170707529740445],
            [30.33414978937398, 0.169786921436751],
            [30.333401647252536, 0.169284653102301],
            [30.33198842752903, 0.169368083769992],
            [30.331489540949477, 0.170037587129728],
            [30.329328306665314, 0.168949308975973],
            [30.32633517852911, 0.171961794152974],
            [30.326916878099784, 0.173300864448037],
            [30.326334865915385, 0.174054048946098],
            [30.325586662708506, 0.174305025398676],
            [30.324506011879595, 0.173802695199535],
            [30.323757808672717, 0.174053673452044],
            [30.32375768380689, 0.174890537395785],
            [30.322843288679195, 0.174555629947103],
            [30.322094958809856, 0.17564353587982],
            [30.322925976804452, 0.177652170986616],
            [30.322510218524677, 0.178489034768622],
            [30.32109687573196, 0.179242031309918],
            [30.319683344293058, 0.181668818911659],
            [30.317854303407675, 0.182505497457279],
            [30.31818674833474, 0.183258742663963],
            [30.319350460988105, 0.183593650851973],
            [30.322758849737426, 0.183928996510976],
            [30.324088941161165, 0.183426978289038],
            [30.322010395900588, 0.185267879085546],
            [30.321843953349777, 0.186606949305847],
            [30.320015289756846, 0.185351246799475],
            [30.31943321379209, 0.186271729460942],
            [30.31918351987234, 0.188447725803922],
            [30.315358747615765, 0.19330105200927],
            [30.30812627651604, 0.194387893196839],
            [30.30563222180898, 0.195726526129794],
            [30.304634448649853, 0.196897987062761],
            [30.300644298346132, 0.196813618687568],
            [30.300602233834645, 0.19961718731821],
            [30.300269602057977, 0.200202947301749],
            [30.302015078960668, 0.201626010997946],
            [30.302264334502567, 0.202462874516739],
            [30.30176551170338, 0.203048636194666],
            [30.30068467402491, 0.203801693642505],
            [30.29985340629865, 0.20380144481075],
            [30.298772818351804, 0.202880775358927],
            [30.296777525358465, 0.204386831844983],
            [30.29544737015433, 0.204888662596192],
            [30.292454117152328, 0.208403043165721],
            [30.292038482840024, 0.2084867233756],
            [30.290376259102935, 0.206561640959331],
            [30.289295546290255, 0.206728752566419],
            [30.28862990724114, 0.210159888206519],
            [30.286052979355855, 0.210924272995692],
            [30.26870155341746, 0.186418461300023],
            [30.267175317546382, 0.1849311473585],
            [30.265792990885483, 0.181246614642138],
            [30.266178522652588, 0.17744522978316],
            [30.26569783055079, 0.176189464657613],
            [30.266247043447528, 0.174369852919377],
            [30.26759036436046, 0.172320179011323],
            [30.266963581938953, 0.162790094433728],
            [30.26754147804271, 0.162015106578275],
            [30.268302459784508, 0.157309266997279],
            [30.26812974878965, 0.155933033360958],
            [30.267640272062696, 0.155330307351361],
            [30.26504675588738, 0.154039051209911],
            [30.266413381793736, 0.149412883855743],
            [30.266335849998182, 0.148083605395452],
            [30.265158050862873, 0.1450034459732],
            [30.26521139012949, 0.142376190151424],
            [30.263779504312694, 0.134684879396452],
            [30.264371017079522, 0.131793117789685],
            [30.26571202033904, 0.129271951283869],
            [30.26443571554291, 0.126289610348163],
            [30.26592885298737, 0.122756312017212],
            [30.26597172957586, 0.121807433625112],
            [30.265219940294365, 0.120515067146422],
            [30.266361988278025, 0.118436679118222],
            [30.266823016258233, 0.115617185936589],
            [30.266632786318723, 0.114577913606648],
            [30.267874755708057, 0.114740701484902],
            [30.269096751057035, 0.114054009090885],
            [30.27001818717991, 0.113222694490678],
            [30.270298809196596, 0.112120205952326],
            [30.26949768623631, 0.110285616035615],
            [30.26916752482669, 0.107185892203706],
            [30.26669384750352, 0.103444351586238],
            [30.266794186625823, 0.101203186985568],
            [30.266213320691755, 0.100236179025799],
            [30.26665422820624, 0.099332518339524],
            [30.266644282059406, 0.097507046459106],
            [30.26489187555261, 0.092635969979272],
            [30.26433121991581, 0.089626614889428],
            [30.263470027510813, 0.087936636137284],
            [30.264101173947946, 0.086210623228438],
            [30.261697514013015, 0.083309582770114],
            [30.260896381171253, 0.083083601018822],
            [30.26077624587506, 0.082134714265455],
            [30.2589034660185, 0.079080098573051],
            [30.258372820400368, 0.075682178296188],
            [30.259214261547218, 0.075058686044718],
            [30.258693407565723, 0.074127848942916],
            [30.258974022395858, 0.07253736686549],
            [30.257742164443382, 0.069970803930241],
            [30.257562027974387, 0.068398369748802],
            [30.255739204329114, 0.066825839396188],
            [30.255088382990582, 0.064919015548963],
            [30.25452769591275, 0.061304225785292],
            [30.255354064227443, 0.059063119034141],
            [30.255834721294953, 0.059081217382544],
            [30.256011063280173, 0.058304052898675],
            [30.255818959454984, 0.05449950625816],
            [30.25743763556204, 0.051987321938649],
            [30.25849531557084, 0.05190603791356],
            [30.26020988683452, 0.053388174861622],
            [30.260851039605623, 0.05259295417287],
            [30.261852607248493, 0.0527466289036],
            [30.26151604354583, 0.051571809966889],
            [30.261756478529925, 0.05079464269043],
            [30.26438466967521, 0.049683214210508],
            [30.266227658701993, 0.049538703183244],
            [30.268927808494805, 0.051680591412079],
            [30.26948870038854, 0.051689654511275],
            [30.271523914513093, 0.050117305143984],
            [30.276644052917774, 0.05013560561595],
            [30.277669827462596, 0.04875297853432],
            [30.278423098066003, 0.046828114128934],
            [30.27980934317817, 0.045210533590015],
            [30.283543382896077, 0.043873189572788],
            [30.287157264859893, 0.041586932894896],
            [30.288791905826205, 0.040195272194345],
            [30.28983353563583, 0.038586694429564],
            [30.290434484306367, 0.040502593861686],
            [30.289937643190715, 0.041550887105283],
            [30.289937592885078, 0.042933572716465],
            [30.28847125577879, 0.044406573097623],
            [30.288359004995854, 0.045509101157549],
            [30.287429474153928, 0.046150701084385],
            [30.287365323662836, 0.047424935737223],
            [30.287701773279466, 0.048247329618451],
            [30.288799552285898, 0.049133016964822],
            [30.28846300295629, 0.050678355822491],
            [30.287741755496146, 0.051319961090329],
            [30.287757685321072, 0.05264842242332],
            [30.290618109831925, 0.056579721407767],
            [30.290321527447613, 0.058034690504599],
            [30.29197223029119, 0.058504707682791],
            [30.293863133658625, 0.060357428060587],
            [30.29528950292125, 0.059282075183036],
            [30.296331084221826, 0.059227905902065],
            [30.29755704653109, 0.060429919368823],
            [30.29845443116058, 0.060556487430224],
            [30.30047388434349, 0.058459952740346],
            [30.303270352399355, 0.057086431165855],
            [30.304295991298574, 0.059038532157875],
            [30.30418369739648, 0.060701383807793],
            [30.305056967650483, 0.063403574784575],
            [30.30555375307059, 0.063819317536775],
            [30.306467301985318, 0.063430764076602],
            [30.306755586631343, 0.065174976849508],
            [30.307300471445036, 0.065807617669993],
            [30.308374191771538, 0.065626932449224],
            [30.309399974401195, 0.064867856526343],
            [30.31085026849478, 0.065310766099791],
            [30.312885496992386, 0.065057834815458],
            [30.31400738408609, 0.063928230112456],
            [30.314440089083746, 0.064072851596445],
            [30.31520946288692, 0.063521615137132],
            [30.317570929851282, 0.063711528752571],
            [30.320679451975632, 0.06381110963512],
            [30.321299389234653, 0.064380500133476],
            [30.322263951677723, 0.06748941994915],
            [30.324852513644252, 0.070191758782129],
            [30.32466606201883, 0.070878592161601],
            [30.325074312179467, 0.071872733558926],
            [30.32610083771589, 0.073056699580026],
            [30.327480861994694, 0.073716518801513],
            [30.328460805392062, 0.075108347565948],
            [30.331307494662223, 0.077169072923236],
            [30.33968460358854, 0.079085577392763],
            [30.341019442608577, 0.080215358687789],
            [30.343847870925636, 0.080938555675266],
            [30.348850524962494, 0.084562973791587],
            [30.355437643667184, 0.084464027165635],
            [30.3577118788276, 0.083506195929673],
            [30.35826295033863, 0.082087320098026],
            [30.36173313689131, 0.082964215042909],
            [30.363916707785005, 0.082864951307946],
            [30.36820621806393, 0.083823248784689],
            [30.368989208530177, 0.083741963914767],
            [30.369768881518105, 0.082955734057202],
            [30.37133569518888, 0.082946804812645],
            [30.373871969815987, 0.082178768499988],
            [30.375442108151642, 0.082856710172159],
            [30.37645118391365, 0.085342175205765],
            [30.37803435051588, 0.086273182732266],
            [30.378984534524506, 0.086408818304709],
            [30.381613257472438, 0.085776357447947],
            [30.38412414211632, 0.086341293818151],
            [30.384956035070022, 0.08686487358844],
            [30.385059974639983, 0.087702486940254],
            [30.385787929820353, 0.088330745450784],
            [30.386931890317236, 0.088330807434476],
            [30.38765984459931, 0.08937784024974],
            [30.387555655297685, 0.091471780924773],
            [30.38849148782135, 0.093984685283501],
            [30.387867349141708, 0.095450370905026],
            [30.385995309496955, 0.096706635215802],
            [30.385579173924732, 0.097544187250696],
            [30.3856829257468, 0.100371063553949],
            [30.387970727264616, 0.102674612515635],
            [30.388490613760577, 0.104768679029567],
            [30.389218504262256, 0.105501614134285],
            [30.388282233360737, 0.108956561903646],
            [30.389946021963066, 0.111155368659643],
            [30.390049898650968, 0.112097723858739],
            [30.39056984713066, 0.112411820991621],
            [30.390465781796575, 0.113877630623665],
            [30.391505554788495, 0.115238822594971],
            [30.39244157685665, 0.115657725026171],
            [30.399097537054836, 0.115239511601384],
            [30.402113477907662, 0.115763277755137],
            [30.405233421212515, 0.115763590368222],
            [30.4062732570865, 0.117438943107146],
            [30.406792892952467, 0.12131291666577],
            [30.40783285369228, 0.122045852249885],
            [30.408144672402134, 0.123825820362172],
            [30.408456554892375, 0.123930560984533],
            [30.408248425122498, 0.126233985004226],
            [30.40876837539885, 0.126548081975718],
            [30.409080256990762, 0.127909275108507],
            [30.410536164656577, 0.12906111183255],
            [30.411717474408018, 0.137941138219609],
            [30.41288589064018, 0.138054741535872],
            [30.414189064046457, 0.139965379758197],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 303,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "KANARA",
        Population: 13671,
        Key: "KAMWENGEKANARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.409853564516563, -0.060954281875633],
            [30.40727312062527, -0.060042131248011],
            [30.405752660921465, -0.05902156029622],
            [30.397155336291416, -0.050222074717098],
            [30.394156657465086, -0.048351058945768],
            [30.391326950845386, -0.045757213065381],
            [30.390271039619407, -0.046267420947925],
            [30.388974071775106, -0.047596352200793],
            [30.389046060965367, -0.050264285637748],
            [30.385878196133362, -0.055153987033484],
            [30.38110555033509, -0.056046706291374],
            [30.38059838667852, -0.063530206619225],
            [30.380133725012957, -0.065039643044362],
            [30.37947905259683, -0.065507329932286],
            [30.378730652658888, -0.065322772075763],
            [30.376712575695034, -0.066804046282188],
            [30.37447399376995, -0.069014960340075],
            [30.37331241910698, -0.071034587186007],
            [30.37125977137769, -0.0728007077792],
            [30.37373436049085, -0.078199190773931],
            [30.373713172826577, -0.079368483554697],
            [30.37489560098056, -0.081898485435527],
            [30.374494218440237, -0.084215788785595],
            [30.374633064745506, -0.088616843256315],
            [30.37614626785843, -0.090235114048714],
            [30.377302412205516, -0.090891595750076],
            [30.372497752247156, -0.096471968647588],
            [30.37216264381526, -0.098204029406884],
            [30.36969952618827, -0.098480809819709],
            [30.36834792729999, -0.099501175881914],
            [30.366954144424273, -0.099862483132285],
            [30.366193831029058, -0.100946669862045],
            [30.36338522134379, -0.100818889202557],
            [30.362362863990295, -0.100216294847403],
            [30.359682849934593, -0.100506938921783],
            [30.357937187978933, -0.098749279927864],
            [30.356856663812486, -0.096489479482582],
            [30.35465348988263, -0.098372376138367],
            [30.34924974525794, -0.100547997256989],
            [30.34517609385358, -0.102807360843321],
            [30.34376287413007, -0.102890917504855],
            [30.3405208021674, -0.101970059571942],
            [30.33719554081952, -0.102471890928641],
            [30.33661352863516, -0.102974033992402],
            [30.33478430179851, -0.107325778512986],
            [30.33378665350521, -0.108413681309773],
            [30.332872007747554, -0.110422193841457],
            [30.332539063357167, -0.115108843822486],
            [30.33029445104157, -0.116364047326672],
            [30.329130175144563, -0.120632109283917],
            [30.32821565604933, -0.121803755930639],
            [30.324142190596273, -0.123058709398938],
            [30.322146770940478, -0.125652855471098],
            [30.321065997042364, -0.126238616706586],
            [30.319486587194667, -0.125736285404032],
            [30.317408603381143, -0.123225382431783],
            [30.315247244231145, -0.123141515012366],
            [30.310591640829532, -0.126488595682619],
            [30.30733474846132, -0.130265468371851],
            [30.307805916624456, -0.130021511722872],
            [30.31138998530064, -0.130708724729622],
            [30.31257088272537, -0.131847552856898],
            [30.314509220733036, -0.132832829618794],
            [30.315362733440683, -0.132742547378568],
            [30.315945602617845, -0.132055771007817],
            [30.316800649648002, -0.132064899663473],
            [30.318276039077368, -0.133836381617675],
            [30.321974982515442, -0.133493359063218],
            [30.324370055454622, -0.135608372787266],
            [30.325528537218048, -0.135283151223791],
            [30.326199382902548, -0.135671834092683],
            [30.32773569876946, -0.138310934919938],
            [30.328669111231708, -0.138790023924839],
            [30.33316670726302, -0.140218446993712],
            [30.335038585211063, -0.139956570006514],
            [30.336398139579472, -0.140354373366848],
            [30.336323370103425, -0.141682877935189],
            [30.337143553517397, -0.142514422480147],
            [30.33903942007676, -0.142270625854798],
            [30.341144705488436, -0.143301145694206],
            [30.341895340434792, -0.142695715417667],
            [30.34413334204819, -0.14232543100296],
            [30.34542237866681, -0.141222994013509],
            [30.348048116513056, -0.140563545452223],
            [30.348943150251447, -0.143193587148132],
            [30.34883673761954, -0.143988883832869],
            [30.34992158537746, -0.145064483606229],
            [30.350356879319744, -0.147125108862881],
            [30.351706714815123, -0.149212957281605],
            [30.356541957917333, -0.152286335656939],
            [30.378073177499093, -0.144172982188472],
            [30.37975235424224, -0.149153014702509],
            [30.380066853524895, -0.152641652229817],
            [30.380949363849915, -0.15444028766759],
            [30.38350990915933, -0.156510267955619],
            [30.383955965817044, -0.15772139542423],
            [30.384952740049567, -0.157685367727945],
            [30.385203440980728, -0.15855303368205],
            [30.386832582460872, -0.159493177192894],
            [30.387137927910807, -0.160830820916925],
            [30.388733806572596, -0.161924607963226],
            [30.389645025257455, -0.164057667838921],
            [30.38982245869575, -0.166335240655211],
            [30.391265047939164, -0.168278580281936],
            [30.39169928366604, -0.171830536507638],
            [30.392558765678732, -0.17368342552931],
            [30.395186257036407, -0.175464258143492],
            [30.39740555931885, -0.176187600662216],
            [30.399104083976617, -0.178564820769688],
            [30.403275894292044, -0.178068316231866],
            [30.40453735083482, -0.178267328936032],
            [30.40911211933558, -0.179280227488855],
            [30.413677407016813, -0.182001326842958],
            [30.415705000732817, -0.182607166468437],
            [30.42163496767116, -0.182951460218848],
            [30.428634223546727, -0.181786532656078],
            [30.431937101572665, -0.180377039895636],
            [30.43474595919296, -0.177711157677784],
            [30.439104503204803, -0.171583824305877],
            [30.441678246562407, -0.166748692111349],
            [30.452726259729168, -0.161607292828552],
            [30.45626234040287, -0.160007938595946],
            [30.458457354934986, -0.158363221286761],
            [30.462147203829115, -0.154296383471256],
            [30.4657019613759, -0.152651807648062],
            [30.465412220560783, -0.151964851309482],
            [30.463295169015524, -0.150184036382515],
            [30.460463184268253, -0.149008718806899],
            [30.458180045905067, -0.147227896453518],
            [30.454729220741733, -0.146739435531813],
            [30.451804928709148, -0.145744889665914],
            [30.448056568947276, -0.142879324203376],
            [30.44408551862314, -0.143303687020179],
            [30.43515458125613, -0.140844304064541],
            [30.430803810366445, -0.138954849023986],
            [30.42936355584445, -0.137942417416868],
            [30.42766148284132, -0.133468341948774],
            [30.425994888800354, -0.133187986592497],
            [30.42569089531495, -0.131949728763215],
            [30.424119488558127, -0.130901143362021],
            [30.423382762227295, -0.130864916197762],
            [30.421599603693398, -0.129174605595689],
            [30.421597279751737, -0.127131989072838],
            [30.423044348893477, -0.125830639722526],
            [30.42345762243318, -0.124140547978358],
            [30.422719513595155, -0.119368341452781],
            [30.42396154137497, -0.11597011442636],
            [30.423946614968195, -0.115003031478487],
            [30.42219863086754, -0.11018555288133],
            [30.420193701646173, -0.106425525332377],
            [30.41630860033176, -0.101616943170825],
            [30.417512037385297, -0.09184685402539],
            [30.419411587935624, -0.08643315992627],
            [30.417015553799125, -0.081950106172233],
            [30.415393979726925, -0.072243103267786],
            [30.414488040441004, -0.070471590968836],
            [30.41182534051406, -0.067958867510572],
            [30.409943733811517, -0.064497199299904],
            [30.409489189871028, -0.062734758799488],
            [30.409853564516563, -0.060954281875633],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 304,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "KICHECHE",
        Population: 26338,
        Key: "KAMWENGEKICHECHE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.317570929851282, 0.063711528752571],
            [30.31520946288692, 0.063521615137132],
            [30.314440089083746, 0.064072851596445],
            [30.31400738408609, 0.063928230112456],
            [30.312885496992386, 0.065057834815458],
            [30.31085026849478, 0.065310766099791],
            [30.309399974401195, 0.064867856526343],
            [30.308374191771538, 0.065626932449224],
            [30.307300471445036, 0.065807617669993],
            [30.306755586631343, 0.065174976849508],
            [30.306467301985318, 0.063430764076602],
            [30.30555375307059, 0.063819317536775],
            [30.305056967650483, 0.063403574784575],
            [30.30418369739648, 0.060701383807793],
            [30.304295991298574, 0.059038532157875],
            [30.303270352399355, 0.057086431165855],
            [30.30047388434349, 0.058459952740346],
            [30.29845443116058, 0.060556487430224],
            [30.29755704653109, 0.060429919368823],
            [30.296331084221826, 0.059227905902065],
            [30.29528950292125, 0.059282075183036],
            [30.293863133658625, 0.060357428060587],
            [30.29197223029119, 0.058504707682791],
            [30.290321527447613, 0.058034690504599],
            [30.290618109831925, 0.056579721407767],
            [30.287757685321072, 0.05264842242332],
            [30.287741755496146, 0.051319961090329],
            [30.28846300295629, 0.050678355822491],
            [30.288799552285898, 0.049133016964822],
            [30.287701773279466, 0.048247329618451],
            [30.287365323662836, 0.047424935737223],
            [30.287429474153928, 0.046150701084385],
            [30.288359004995854, 0.045509101157549],
            [30.28847125577879, 0.044406573097623],
            [30.289937592885078, 0.042933572716465],
            [30.289937643190715, 0.041550887105283],
            [30.290434484306367, 0.040502593861686],
            [30.28983353563583, 0.038586694429564],
            [30.288791905826205, 0.040195272194345],
            [30.287157264859893, 0.041586932894896],
            [30.283543382896077, 0.043873189572788],
            [30.27980934317817, 0.045210533590015],
            [30.278423098066003, 0.046828114128934],
            [30.277669827462596, 0.04875297853432],
            [30.276644052917774, 0.05013560561595],
            [30.271523914513093, 0.050117305143984],
            [30.26948870038854, 0.051689654511275],
            [30.268927808494805, 0.051680591412079],
            [30.266227658701993, 0.049538703183244],
            [30.26438466967521, 0.049683214210508],
            [30.261756478529925, 0.05079464269043],
            [30.26151604354583, 0.051571809966889],
            [30.261852607248493, 0.0527466289036],
            [30.260851039605623, 0.05259295417287],
            [30.26020988683452, 0.053388174861622],
            [30.25849531557084, 0.05190603791356],
            [30.25743763556204, 0.051987321938649],
            [30.255818959454984, 0.05449950625816],
            [30.256011063280173, 0.058304052898675],
            [30.255834721294953, 0.059081217382544],
            [30.255354064227443, 0.059063119034141],
            [30.254681058992986, 0.05737318404128],
            [30.254609094955576, 0.054779591853249],
            [30.25682868919051, 0.050948048829326],
            [30.257165365182612, 0.049592526621662],
            [30.257221438920933, 0.046971823865014],
            [30.25668677693521, 0.043537774912965],
            [30.250750748165284, 0.023963693179134],
            [30.248949536189116, 0.019499447424969],
            [30.246953953938277, 0.012910422762406],
            [30.22032315749036, -0.069828198281638],
            [30.217576165047074, -0.077147694835496],
            [30.215992643610324, -0.078385607191027],
            [30.215204357575452, -0.093395334651183],
            [30.214720619286524, -0.095338163396736],
            [30.21191913054652, -0.101853305719143],
            [30.212248592168557, -0.103389550849906],
            [30.213422726177512, -0.103977029219188],
            [30.21619048497521, -0.103615804659754],
            [30.217068239619127, -0.10292006239891],
            [30.217883088836935, -0.103118937403251],
            [30.22206361730219, -0.1076647275445],
            [30.224443493441704, -0.108478239520339],
            [30.22589828539993, -0.110620062686032],
            [30.228277486904656, -0.11120766578207],
            [30.228180545210748, -0.111505868163936],
            [30.22863677888231, -0.111605314172356],
            [30.230140385293076, -0.113692931975564],
            [30.23141093368484, -0.11379245612978],
            [30.232423326925193, -0.114840811335852],
            [30.232034193812122, -0.115590822233303],
            [30.233305825572117, -0.116115074368136],
            [30.234563484037864, -0.117570111235817],
            [30.23450042769484, -0.118428595196245],
            [30.23518943731438, -0.120461930118207],
            [30.236006321216315, -0.12143798073732],
            [30.235975398509293, -0.122124770865068],
            [30.238524724759134, -0.125667443177913],
            [30.238784513946058, -0.125305999703695],
            [30.240413553916568, -0.125495940829076],
            [30.241481466634735, -0.122604277893795],
            [30.24272029641215, -0.123029133334702],
            [30.243895800351915, -0.124176928763622],
            [30.24608154786357, -0.124104858894185],
            [30.25062415488052, -0.119839925406719],
            [30.25134868747965, -0.118710388012647],
            [30.254193113893617, -0.118412448911836],
            [30.25593519246959, -0.117436633543393],
            [30.259074463027787, -0.117003164088313],
            [30.263549174477216, -0.114626872589986],
            [30.266358908853213, -0.115142244913937],
            [30.26830325030195, -0.114211617296471],
            [30.274741793048538, -0.11292895764291],
            [30.276697372421463, -0.113489436115865],
            [30.279355845774965, -0.116535178729775],
            [30.280444070300035, -0.117050395610782],
            [30.28324422773678, -0.115405908899348],
            [30.28363018710197, -0.115794540859827],
            [30.283968871727016, -0.117746590291157],
            [30.28461515747167, -0.118090062209285],
            [30.28675801581838, -0.118478864812121],
            [30.2874381896088, -0.117927665116663],
            [30.289434850736317, -0.118849646345373],
            [30.29084693319267, -0.118027400359641],
            [30.291869005780217, -0.118108833365557],
            [30.292264723544346, -0.119139109855115],
            [30.293547409073895, -0.119166344918989],
            [30.294583284275813, -0.120133425027715],
            [30.29788585417961, -0.121832744499354],
            [30.298583688848503, -0.123621516993427],
            [30.300152381794867, -0.119071201857926],
            [30.300456249516138, -0.11286270612102],
            [30.301939540526742, -0.106925719890342],
            [30.302445384558172, -0.102684961989409],
            [30.301737910966295, -0.100038643389749],
            [30.301010179466402, -0.099467092953117],
            [30.299912153423264, -0.097238289778834],
            [30.299423230956858, -0.090753854545651],
            [30.30051847761251, -0.085539446819452],
            [30.300146409794863, -0.076023209920224],
            [30.30038095272903, -0.07613905386219],
            [30.300526518432594, -0.074186653510491],
            [30.301234298350014, -0.072558228424594],
            [30.305581619709017, -0.070692522462179],
            [30.313755622244557, -0.064754193664484],
            [30.316872525650496, -0.06188968536538],
            [30.31633589815093, -0.061103510824305],
            [30.315192096655828, -0.056991461321072],
            [30.315137901294744, -0.055012278761246],
            [30.314145730029747, -0.053801232624947],
            [30.311659191526672, -0.052689536499872],
            [30.311480588481885, -0.050330787892614],
            [30.310955732505782, -0.050177132918993],
            [30.309953956453754, -0.050647034275705],
            [30.30956041351093, -0.04976136222091],
            [30.310495218361886, -0.047249025003379],
            [30.311570316704035, -0.047682856339487],
            [30.312229846310927, -0.047339461965458],
            [30.31211730986368, -0.044655371321886],
            [30.311341714328837, -0.042865954747366],
            [30.312110947096535, -0.041935135976191],
            [30.31221771186807, -0.041157929068094],
            [30.311159199121, -0.039485991363581],
            [30.310578844328315, -0.037651398407171],
            [30.308261472067976, -0.035961355991111],
            [30.306218832469284, -0.035916114147359],
            [30.3055130629815, -0.03479547233201],
            [30.304120286218897, -0.03378326073258],
            [30.300990756093324, -0.034090446776646],
            [30.299578619738046, -0.033358394507063],
            [30.30125109864247, -0.027104662139207],
            [30.30407730542581, -0.023300029581752],
            [30.30756959951762, -0.020353931159728],
            [30.30816979899325, -0.019233314350742],
            [30.308854622463546, -0.01360308401507],
            [30.308750010055462, -0.010674996666417],
            [30.309766655022077, -0.00578581876647],
            [30.313928948585392, 0.002962317717267],
            [30.315648283615012, 0.005040917769884],
            [30.318138568092817, 0.014340389737301],
            [30.319253126730437, 0.021416674901175],
            [30.32123244408476, 0.018389187286671],
            [30.32357250509422, 0.016337734411033],
            [30.32665888284849, 0.016410082924447],
            [30.328483876823515, 0.015804602277212],
            [30.33308077352465, 0.016527670593652],
            [30.33450796564408, 0.017115130136591],
            [30.334328810135386, 0.019320275756872],
            [30.335332384614595, 0.02067591877798],
            [30.335407699368016, 0.022389826065539],
            [30.336122563399783, 0.024498798884764],
            [30.337221513809332, 0.025944825840628],
            [30.337703850726417, 0.027481215202337],
            [30.33779860951418, 0.029894235279913],
            [30.33716261666607, 0.030924494967853],
            [30.33716805596509, 0.032036109658476],
            [30.33470000658721, 0.034629800566118],
            [30.333279093691587, 0.035343718538771],
            [30.331872396635365, 0.038985777191311],
            [30.33180782663107, 0.04034139571565],
            [30.332520564350542, 0.042917103008669],
            [30.334287269341704, 0.044968679342629],
            [30.335272259474337, 0.047390768327084],
            [30.334483767725267, 0.048800584735549],
            [30.33401884285335, 0.050824963514271],
            [30.33153810926365, 0.050806779823443],
            [30.330782186833513, 0.051593006605744],
            [30.32905185372989, 0.052126139440519],
            [30.328140416754405, 0.055099417998494],
            [30.327394748593267, 0.055515105117732],
            [30.326712025384047, 0.056689939249364],
            [30.32597411148046, 0.056283219117309],
            [30.325239673158666, 0.056572381277162],
            [30.32388182019936, 0.055587236207866],
            [30.323146408103817, 0.055704687282611],
            [30.322501929769523, 0.054954552149347],
            [30.32167072672199, 0.054882213547677],
            [30.32192661811888, 0.053815812275576],
            [30.320145829340653, 0.053734392607345],
            [30.3182146679738, 0.056897384401075],
            [30.317104719490185, 0.060548425055043],
            [30.317570929851282, 0.063711528752571],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 305,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "MAHYORO",
        Population: 29107,
        Key: "KAMWENGEMAHYORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.53950880635382, 0.234586865727152],
              [30.541422672456523, 0.234895752438409],
              [30.54435477983209, 0.236473639766855],
              [30.54676967230136, 0.236589844841761],
              [30.548148604228796, 0.242262827006883],
              [30.548492441590323, 0.248514477207752],
              [30.546881733539784, 0.252566121574985],
              [30.546766074548653, 0.25603919793403],
              [30.550560099269642, 0.260439207504114],
              [30.567232609957355, 0.270977722142527],
              [30.578386431189863, 0.276073994422022],
              [30.579304204881346, 0.286725280098982],
              [30.573784058358726, 0.287650270015445],
              [30.577692371241774, 0.295292108706778],
              [30.576311516021327, 0.299228068167957],
              [30.57148099536256, 0.301773968261696],
              [30.56641980440681, 0.307329858412166],
              [30.55767932155815, 0.310106331886408],
              [30.554228806313585, 0.312652476432123],
              [30.55040469521707, 0.314590722520684],
              [30.547609893536055, 0.317180952817649],
              [30.546867394631246, 0.31692407091876],
              [30.54703367638357, 0.316182913730769],
              [30.546298399933626, 0.315631358326711],
              [30.546346144492656, 0.314844976046428],
              [30.547034405815584, 0.31427568360306],
              [30.54686862262821, 0.313507328341889],
              [30.545717940936377, 0.313570327147807],
              [30.54498266628309, 0.313018774300539],
              [30.545196564135367, 0.312015497715109],
              [30.54486443361865, 0.311680975448145],
              [30.54353558366663, 0.312349544769667],
              [30.54351198672074, 0.311870474946696],
              [30.542966445238573, 0.311662448867847],
              [30.543227731917064, 0.310776690725467],
              [30.542278925924087, 0.310270284599486],
              [30.54213617733722, 0.311183186776972],
              [30.54128190465486, 0.311372802165457],
              [30.54116305125455, 0.31208685253476],
              [30.540380386876752, 0.31141778284236],
              [30.540285717920536, 0.310703682122808],
              [30.53957387941466, 0.310730632083333],
              [30.53962162038044, 0.309944253029085],
              [30.538387897525425, 0.309989156458083],
              [30.537771422373513, 0.308958572095417],
              [30.536027263299335, 0.309880131323792],
              [30.53446209624045, 0.307873122920716],
              [30.534533557221316, 0.307041558146799],
              [30.535364331772467, 0.305911887142806],
              [30.534700169553677, 0.305441709326287],
              [30.534676744186033, 0.304818018767262],
              [30.533680343652666, 0.304483347156003],
              [30.532684530617477, 0.302810916890882],
              [30.532732797996022, 0.300307151938924],
              [30.531522992785455, 0.300089940488063],
              [30.530835139297675, 0.299538409404068],
              [30.531713180504138, 0.29904147176193],
              [30.532330454258364, 0.297794244382354],
              [30.532899878350666, 0.297839568267718],
              [30.533777306906106, 0.298825010369057],
              [30.53607884905452, 0.29841878244371],
              [30.537064286548144, 0.296349090111162],
              [30.53711268777565, 0.293818199415612],
              [30.53621106848791, 0.293718570373622],
              [30.535831867148616, 0.292434956609324],
              [30.537220613170533, 0.290437661956534],
              [30.536343573585604, 0.288268123464599],
              [30.53591640670169, 0.288195718372234],
              [30.535299192236277, 0.2892169811889],
              [30.533283205652065, 0.287408753805953],
              [30.532499965454154, 0.288077460253742],
              [30.53311632831669, 0.289677483168343],
              [30.532760127441914, 0.290346283804513],
              [30.531977096551465, 0.290698626377205],
              [30.530719804598334, 0.290156013187328],
              [30.530553566863432, 0.290770621827055],
              [30.529960221533422, 0.291059733687995],
              [30.529865443881057, 0.290797584413093],
              [30.529747712476563, 0.288366099675508],
              [30.530578769098735, 0.286495231619509],
              [30.529571361508204, 0.283855657379298],
              [30.52980890840867, 0.28302413033329],
              [30.53170747440544, 0.281542163459262],
              [30.531684785656317, 0.278703944189552],
              [30.530724791146493, 0.27601014830251],
              [30.53191150156941, 0.274627447736365],
              [30.531793032648064, 0.274265866507864],
              [30.53105751634792, 0.274175323652465],
              [30.530203831163767, 0.272954894503473],
              [30.52982483464034, 0.271282621309202],
              [30.529468614002624, 0.27209604653524],
              [30.52906545818796, 0.27193326286051],
              [30.529148707760278, 0.270966119632073],
              [30.530122058421746, 0.269456828398781],
              [30.52957664090711, 0.268643216148389],
              [30.52967251270751, 0.265588091645263],
              [30.53045577177002, 0.264756672923304],
              [30.528973186835234, 0.264123651257825],
              [30.52823794811453, 0.263355198284314],
              [30.528784085179705, 0.261972359741882],
              [30.528381156638808, 0.260652603686739],
              [30.529828617445983, 0.260128637063946],
              [30.5303273899395, 0.258456542693122],
              [30.532119386099215, 0.256558727990766],
              [30.532760041203627, 0.256061712185162],
              [30.534942658984832, 0.256776215125324],
              [30.535322359787447, 0.256369538399],
              [30.53509854363609, 0.251533670859601],
              [30.533817486752145, 0.251198984263544],
              [30.533675311290427, 0.250792205853244],
              [30.533936534188523, 0.250023948806674],
              [30.53635715521439, 0.248144314600341],
              [30.53707074902829, 0.24543276878059],
              [30.53687057294195, 0.244583070901896],
              [30.536169529490863, 0.243923099032714],
              [30.53572926517013, 0.240289366199885],
              [30.537532741799147, 0.239177909292727],
              [30.538605131720715, 0.236728550724921],
              [30.538545392856008, 0.2350111400665],
              [30.53950880635382, 0.234586865727152],
            ],
          ],
          [
            [
              [30.7277734691784, 0.323248971503083],
              [30.72774815195874, 0.33255127906342],
              [30.727201059984413, 0.336284747637577],
              [30.721858551715965, 0.345522516234886],
              [30.724134851204912, 0.34992562991808],
              [30.72830968345294, 0.353732577892476],
              [30.727976541433186, 0.356200466720213],
              [30.728165469713876, 0.358749846655989],
              [30.72861597393055, 0.359437015606066],
              [30.72579171289809, 0.360964091767253],
              [30.724794317929707, 0.362925554594914],
              [30.72064070658361, 0.365238769461155],
              [30.717081286780523, 0.365445775721799],
              [30.713071255861234, 0.364893295195461],
              [30.711718447840596, 0.365805994612805],
              [30.705144987121475, 0.36696141644705],
              [30.702581856460636, 0.368308623586413],
              [30.702555202547863, 0.369515232732241],
              [30.70030300126475, 0.370022223235505],
              [30.693310763028173, 0.372930502756597],
              [30.688940856226285, 0.3738768173875],
              [30.686386265848853, 0.37397765023248],
              [30.677776725927615, 0.372260267725552],
              [30.674295234975396, 0.373389701909165],
              [30.672371864697, 0.376815281967515],
              [30.669289116136465, 0.380449118810707],
              [30.670551260788752, 0.387068732007554],
              [30.669810158764193, 0.392956346211762],
              [30.66873421420905, 0.394208048060437],
              [30.667255084194828, 0.394884387974964],
              [30.667120311749393, 0.396034840142319],
              [30.665203801006502, 0.398199921109662],
              [30.66395942772546, 0.400737406975247],
              [30.65672857, 0.401788304084248],
              [30.653941533356285, 0.399554186617105],
              [30.65328571648647, 0.397718936081273],
              [30.651759597396378, 0.396877803515972],
              [30.651143122244434, 0.395829021262067],
              [30.65066866804398, 0.395648091404907],
              [30.64879365587393, 0.396650957396391],
              [30.645069816526064, 0.39342272615235],
              [30.642649823422605, 0.392635584226331],
              [30.642033722868156, 0.390764202761622],
              [30.64189244572174, 0.388233064798207],
              [30.641418199930403, 0.387319927564412],
              [30.63921236339405, 0.385339628453206],
              [30.639710900528996, 0.384670836145416],
              [30.63942685233782, 0.382917070307785],
              [30.63918985520631, 0.382510221612251],
              [30.63631919349448, 0.381316193089861],
              [30.6356079532666, 0.379978134392785],
              [30.63579876351777, 0.377410942828199],
              [30.63333163581138, 0.376126641150001],
              [30.630057709588726, 0.375122348939754],
              [30.62740132032669, 0.37231032169489],
              [30.626001588807164, 0.371622934545466],
              [30.624625611438685, 0.371306176368916],
              [30.619429022810085, 0.371928482870436],
              [30.618551274454376, 0.371539544793035],
              [30.617270593066223, 0.370083839192331],
              [30.615775987774576, 0.369559142368372],
              [30.614922494829898, 0.36766966330701],
              [30.61074694572625, 0.366538601579626],
              [30.60875475281896, 0.364269168253056],
              [30.60776554509609, 0.364133310692525],
              [30.602038249763925, 0.368533940656001],
              [30.598929543484967, 0.369554537700001],
              [30.595274397408545, 0.372590748242012],
              [30.594187602103094, 0.372699557972668],
              [30.591724781818478, 0.370926531141],
              [30.59107339543964, 0.368304954942598],
              [30.590029963609574, 0.366921656929646],
              [30.580292137894833, 0.361820864485656],
              [30.576663028588616, 0.359026767570964],
              [30.563618232123503, 0.347136812309684],
              [30.559336538984184, 0.344758411439702],
              [30.55862484870036, 0.344703992484819],
              [30.558340524726407, 0.343962713404043],
              [30.558554427968595, 0.343031743123744],
              [30.557984980520107, 0.343031595802661],
              [30.557819026652822, 0.342434975109739],
              [30.556158550138953, 0.341783731494207],
              [30.5557914482082, 0.339957745755116],
              [30.55621875433096, 0.339505903805258],
              [30.554226202995896, 0.338312237049945],
              [30.55439280454849, 0.336902187705328],
              [30.555341973460827, 0.336540867283267],
              [30.554915615959, 0.334895649049329],
              [30.55509396478057, 0.333621187724776],
              [30.556399125260228, 0.332970704378998],
              [30.556802847013532, 0.331994586273487],
              [30.55775213091027, 0.33173269133714],
              [30.557728511506486, 0.331371121895792],
              [30.556613731883314, 0.330295193480306],
              [30.555915413022454, 0.326055698177441],
              [30.554966592656424, 0.325585434136713],
              [30.555204110810813, 0.32498891389271],
              [30.554801589206733, 0.32276520766405],
              [30.555134025150664, 0.321834266823077],
              [30.55432767130051, 0.321065749531421],
              [30.55285672224356, 0.321020196678451],
              [30.55263171402785, 0.319763715786008],
              [30.552340139751223, 0.319782159708158],
              [30.55325705375498, 0.318853204740127],
              [30.554809366820468, 0.319490317783447],
              [30.55572940157151, 0.319258998903278],
              [30.557626599434137, 0.320359280543881],
              [30.559350802434267, 0.323543401325469],
              [30.56348966613835, 0.327943725831055],
              [30.56486947661814, 0.328638696042474],
              [30.56762938503856, 0.328870921991947],
              [30.57015963915662, 0.327713829153488],
              [30.572230292717467, 0.324935806347296],
              [30.57429999765734, 0.32609403495796],
              [30.575909144435897, 0.32956760340113],
              [30.577978795476845, 0.33095738724478],
              [30.58234770425046, 0.335357845017931],
              [30.596378399943273, 0.332814320209061],
              [30.601668575956513, 0.332352530152557],
              [30.60787995902224, 0.327028399729145],
              [30.61179129473622, 0.321703670009906],
              [30.619842449063395, 0.317537637802605],
              [30.623292114501712, 0.319390867742318],
              [30.628122313563583, 0.319160448059554],
              [30.6313431116237, 0.316150995278067],
              [30.63318396535508, 0.312678100494057],
              [30.642155085263056, 0.309206808929044],
              [30.644225992148783, 0.305502370796959],
              [30.646067180951746, 0.300408529917323],
              [30.64376837327506, 0.294387557616494],
              [30.651819213191885, 0.292073705614039],
              [30.658260153541956, 0.289064805822561],
              [30.66240234640248, 0.279340171140191],
              [30.663784193362993, 0.270309616586798],
              [30.66654566575037, 0.263363348612813],
              [30.667697102925324, 0.255953632460676],
              [30.671378353145567, 0.250165286590394],
              [30.675749628081636, 0.244377030692487],
              [30.678510946857074, 0.237662212104632],
              [30.679431816143047, 0.232799558368801],
              [30.673222657305935, 0.225388550658356],
              [30.6705772113207, 0.22724060720461],
              [30.668277011255316, 0.227703350015068],
              [30.667357561307515, 0.223998231597724],
              [30.66540240414276, 0.224345254424065],
              [30.664022630493914, 0.222492550728363],
              [30.65482354691295, 0.213923404621387],
              [30.651833350877837, 0.21438605352392],
              [30.649533827243864, 0.210680773709575],
              [30.646314020923814, 0.208596265910692],
              [30.6440134480576, 0.21183770609958],
              [30.639412903298087, 0.214384105091722],
              [30.636882097614443, 0.219014813598228],
              [30.631821436664747, 0.222255761094501],
              [30.63067099212815, 0.224802671256476],
              [30.630440645224656, 0.226886620761824],
              [30.63112914639777, 0.235917356465745],
              [30.632508585873335, 0.239390914158673],
              [30.628367866249885, 0.242863494511801],
              [30.61939819622279, 0.239851706343756],
              [30.620088611705754, 0.237536303520406],
              [30.61870926296004, 0.233599673080237],
              [30.616639464595362, 0.232210003393576],
              [30.61249912675591, 0.23383015101689],
              [30.609509288250276, 0.232671878277579],
              [30.605139951878613, 0.228503223368132],
              [30.58880992748623, 0.228500439511199],
              [30.586050215796842, 0.226879139650817],
              [30.589271344436977, 0.219933269559213],
              [30.593411368764414, 0.21970240243366],
              [30.591341821928026, 0.216923490563273],
              [30.589272782639767, 0.21090292647423],
              [30.588813179387557, 0.208355834314812],
              [30.593643017326734, 0.209282779937185],
              [30.59605831583449, 0.207314996480539],
              [30.59916331835955, 0.207315477076073],
              [30.60433844264277, 0.206621627369094],
              [30.6027290955399, 0.20222193797853],
              [30.60434005242377, 0.195738785366949],
              [30.605031103015648, 0.188329287167198],
              [30.609632137356975, 0.180920309533103],
              [30.61216332931617, 0.171890154729873],
              [30.613907508153286, 0.16863013085568],
              [30.614512149797996, 0.169036540400517],
              [30.615614335040892, 0.168919166137624],
              [30.61788867889746, 0.167843753537564],
              [30.620610121457435, 0.164591570349083],
              [30.62158245522603, 0.164188002072181],
              [30.623129058599527, 0.164391312443021],
              [30.625683443262755, 0.165666197104227],
              [30.629269551114646, 0.170629351504746],
              [30.632635445957767, 0.173992498463379],
              [30.641962237632804, 0.179489792637747],
              [30.643464110295064, 0.186107012545206],
              [30.643263335032422, 0.189252781707],
              [30.64399446216408, 0.191106011200423],
              [30.643785361315402, 0.193510528956914],
              [30.644695456207828, 0.193727609199111],
              [30.645203616994376, 0.195761605136934],
              [30.64581901147304, 0.196475826282438],
              [30.64795022316208, 0.195111141518713],
              [30.648948170594377, 0.19516552251567],
              [30.650068185599032, 0.194189395406384],
              [30.652015943340793, 0.194433743843312],
              [30.654443317900938, 0.195713524888558],
              [30.656460758857584, 0.195813381032683],
              [30.657365022785516, 0.197315147839167],
              [30.659935329188833, 0.199536028617901],
              [30.663822659223474, 0.201964784251671],
              [30.66428262270009, 0.203418572677794],
              [30.664234665240308, 0.205830783563523],
              [30.66503882899781, 0.208185105233109],
              [30.667540761031617, 0.20963185214426],
              [30.669273848369897, 0.210093145626379],
              [30.67069215345625, 0.210183759876248],
              [30.67261123338084, 0.208177208195587],
              [30.681266734705314, 0.208757062381762],
              [30.68650873586651, 0.208043696967187],
              [30.693052800116245, 0.205296523868275],
              [30.69740003972858, 0.202178365466984],
              [30.699540321707044, 0.201726674686751],
              [30.703152936148022, 0.201546394705407],
              [30.706572517007483, 0.202224890722465],
              [30.70809372141465, 0.203183357487883],
              [30.709178218829596, 0.204648005468505],
              [30.712429647644267, 0.205868891648542],
              [30.714644017277514, 0.204567440575962],
              [30.716348850803495, 0.202868146921829],
              [30.7202518842876, 0.201133001547199],
              [30.720632380997543, 0.200247121686117],
              [30.721778237838, 0.199496952139948],
              [30.722782297407477, 0.197345536766679],
              [30.727231916216116, 0.196071491555581],
              [30.729771681696377, 0.195737356155673],
              [30.736016022153283, 0.198486451456146],
              [30.73943480620705, 0.19942711663464],
              [30.742891138043092, 0.199807292135331],
              [30.74519731100678, 0.19950928593406],
              [30.749837336723022, 0.197683789088849],
              [30.753880588239834, 0.194710170031993],
              [30.76055115504453, 0.193788857781588],
              [30.76285180786079, 0.194042299817773],
              [30.76433154962773, 0.194973663245883],
              [30.76610581484033, 0.196899514189709],
              [30.768539982460656, 0.202794216037199],
              [30.76923028026434, 0.205081547619583],
              [30.771981318719654, 0.207540944649994],
              [30.773122993902454, 0.210831840572277],
              [30.771409674890293, 0.212504075401665],
              [30.77120186761561, 0.213498495464668],
              [30.77208388027397, 0.216319250292484],
              [30.771442788588303, 0.219166899958884],
              [30.772239072324126, 0.220034905099655],
              [30.77283526441527, 0.225549682019869],
              [30.77735159481185, 0.227792429848161],
              [30.778603176174702, 0.227873990841232],
              [30.778194599925584, 0.229573541307661],
              [30.778655409615197, 0.230342057318146],
              [30.77943690348821, 0.230667639176614],
              [30.779791040034457, 0.231662152340019],
              [30.78163396348422, 0.231373149604538],
              [30.782256716961676, 0.232892057129756],
              [30.786980515069743, 0.236499996112789],
              [30.7860455934378, 0.23916680621254],
              [30.786045424554512, 0.240206469495929],
              [30.787090303570505, 0.241318630592367],
              [30.788348421973694, 0.244365509903733],
              [30.788918765042528, 0.248786443192192],
              [30.788437558206088, 0.250015877520699],
              [30.78943925340971, 0.251733757879682],
              [30.789855736629942, 0.254021095148119],
              [30.792829134169267, 0.256552978830579],
              [30.793758576077977, 0.259003144004171],
              [30.797373293474998, 0.261887741122993],
              [30.797789814424476, 0.263903874468615],
              [30.7930842997274, 0.26412000054331],
              [30.78994165779193, 0.266506143798718],
              [30.787288218597286, 0.267762296509728],
              [30.781829341668637, 0.267471995617615],
              [30.779596083159916, 0.267805596630134],
              [30.77609777035572, 0.269179592500238],
              [30.77354834349454, 0.27109570016202],
              [30.767752415078032, 0.273445128327034],
              [30.766598040412067, 0.274312791265667],
              [30.76295055067684, 0.275405987064862],
              [30.761624216007597, 0.276236001006782],
              [30.761176430991306, 0.276966179093592],
              [30.758826865806114, 0.278205859399565],
              [30.754748836911403, 0.279265923569186],
              [30.745495162710593, 0.280250954960307],
              [30.74259337886575, 0.28169773900737],
              [30.741181388037568, 0.284000065177985],
              [30.73966504621102, 0.28523658989311],
              [30.7391548130111, 0.287815400740286],
              [30.738014478114707, 0.288952525925297],
              [30.73692304121418, 0.288735351083609],
              [30.73595042357797, 0.287975774045067],
              [30.733757564104188, 0.284945939987725],
              [30.7316933523623, 0.280827181375161],
              [30.730190613724098, 0.279392702196912],
              [30.72623096661415, 0.276957767367549],
              [30.725159488482607, 0.275733901588483],
              [30.723290507601366, 0.275838799343997],
              [30.72004906715436, 0.276732881252976],
              [30.71859818825749, 0.277522049185405],
              [30.718035886008778, 0.279113999597068],
              [30.715291131268863, 0.279837119526849],
              [30.713052650853378, 0.281429552014275],
              [30.71520779006838, 0.284880205681218],
              [30.716574282125734, 0.286224436062654],
              [30.717256401667072, 0.289816167800147],
              [30.718679386077703, 0.291995130996815],
              [30.719816984705737, 0.296217109597605],
              [30.72005270263631, 0.300936111304023],
              [30.720408188452097, 0.301867321687394],
              [30.72119080521922, 0.303322951236273],
              [30.72413244461825, 0.305664983313502],
              [30.725986854825567, 0.30986002462685],
              [30.72429123621778, 0.311730968648847],
              [30.723791721715827, 0.315012438350283],
              [30.7244081160194, 0.316856769268731],
              [30.726519391397353, 0.318574874140383],
              [30.72772879056943, 0.320780951222975],
              [30.7277734691784, 0.323248971503083],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 306,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "NKOMA",
        Population: 72141,
        Key: "KAMWENGENKOMA",
        Dist2: "Kamwenge",
        "Sub Country": "Nkoma",
        id2_original: "Kamwenge Nkoma",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.85281840695888, 0.397059637029748],
            [30.852362784141715, 0.400614090166752],
            [30.846065275996427, 0.401342369770236],
            [30.835858079647405, 0.403643860519959],
            [30.83275512348457, 0.408120465579716],
            [30.831130172645214, 0.408770961368721],
            [30.827931261138687, 0.410912755213544],
            [30.826702823072498, 0.412729616520171],
            [30.825563213116556, 0.41348872710224],
            [30.825300437031316, 0.415540572836699],
            [30.82313919915389, 0.418497098957918],
            [30.823233747735863, 0.419241176081383],
            [30.822551100883462, 0.420710007875228],
            [30.818892331901516, 0.425058800798117],
            [30.814478891842647, 0.426174592579194],
            [30.81335840701908, 0.42591572952555],
            [30.812828029098917, 0.425037983812548],
            [30.81123212169102, 0.424958248846588],
            [30.809947596411753, 0.429956521932832],
            [30.80938490698916, 0.430910341456684],
            [30.80874591286968, 0.430474009711661],
            [30.806082938058253, 0.430983058920317],
            [30.79590548762326, 0.430774507449758],
            [30.793838625851258, 0.431908663932609],
            [30.788568015144904, 0.439373497564809],
            [30.784629851244976, 0.443237063945921],
            [30.78377205087848, 0.443746621618985],
            [30.781284196343524, 0.444105586614868],
            [30.780203963231227, 0.440529924924258],
            [30.78042894000591, 0.438361458305555],
            [30.77988008014709, 0.435359623819856],
            [30.779440551546557, 0.434224797729383],
            [30.777386063169285, 0.432596154699097],
            [30.77713797094569, 0.427824102465794],
            [30.775974420887405, 0.425395914866801],
            [30.774228264858376, 0.42464193467795],
            [30.773895959170154, 0.423469776727876],
            [30.774228914340313, 0.422381528849891],
            [30.772649818902966, 0.419032323366207],
            [30.77273336132606, 0.41769284881547],
            [30.771569565129404, 0.416101861376818],
            [30.77032239629123, 0.415264318503178],
            [30.767994077160836, 0.41467762441617],
            [30.767495256158274, 0.414175171194103],
            [30.766581294916843, 0.411328487519442],
            [30.764586344181662, 0.408146629246877],
            [30.762674156131897, 0.406388012199594],
            [30.757934244044264, 0.405716935432803],
            [30.756936609225694, 0.404712042205744],
            [30.756271866695243, 0.402786348187886],
            [30.758185929529013, 0.397680094762378],
            [30.759766729070456, 0.394834120343685],
            [30.75918533313034, 0.392154988735437],
            [30.758769647614095, 0.391736288388522],
            [30.75872875001414, 0.389182881096979],
            [30.756401662474026, 0.383991754713007],
            [30.756569030289544, 0.379973348274201],
            [30.757483932965364, 0.379387565247793],
            [30.757567265182715, 0.378717843639011],
            [30.756487403972923, 0.374029366938177],
            [30.757319316689557, 0.372773817430851],
            [30.75873312840286, 0.372355593134327],
            [30.759523705141692, 0.370137271667239],
            [30.760272326963484, 0.369384003275518],
            [30.760272432964673, 0.368965413212126],
            [30.75985665761689, 0.36888158776077],
            [30.760023124422222, 0.368295604571992],
            [30.761021246127655, 0.367458680337793],
            [30.761603675130335, 0.366203058036569],
            [30.761604072185687, 0.364612415664229],
            [30.761105199979156, 0.364277417315581],
            [30.76135478071117, 0.363858889894259],
            [30.760772895189266, 0.36293784599637],
            [30.760690191792627, 0.3610960292053],
            [30.760108366457825, 0.359923833608736],
            [30.75836220953047, 0.35916993645238],
            [30.75819599515176, 0.358751305491411],
            [30.758113141736466, 0.357495517594495],
            [30.756783353943273, 0.354397632016169],
            [30.757449029823345, 0.352723440459585],
            [30.757324483799096, 0.351928090737895],
            [30.756576535713723, 0.349918680680636],
            [30.754664442885392, 0.347574123916357],
            [30.75466499984089, 0.345230030990671],
            [30.753833847098964, 0.343388044505579],
            [30.751588861982533, 0.342131746111703],
            [30.750674412955913, 0.340875768246192],
            [30.749593412682366, 0.340624359397145],
            [30.74876218088873, 0.339117250919709],
            [30.746766674994674, 0.337861021138186],
            [30.74377304020864, 0.337609165755874],
            [30.742276449640244, 0.336520492047435],
            [30.73928375269542, 0.332250236220046],
            [30.73762094325672, 0.3307429485886],
            [30.73421272069573, 0.325300591039959],
            [30.7277734691784, 0.323248971503083],
            [30.72772879056943, 0.320780951222975],
            [30.726519391397353, 0.318574874140383],
            [30.7244081160194, 0.316856769268731],
            [30.723791721715827, 0.315012438350283],
            [30.72429123621778, 0.311730968648847],
            [30.725986854825567, 0.30986002462685],
            [30.72413244461825, 0.305664983313502],
            [30.72119080521922, 0.303322951236273],
            [30.720408188452097, 0.301867321687394],
            [30.72005270263631, 0.300936111304023],
            [30.719816984705737, 0.296217109597605],
            [30.718679386077703, 0.291995130996815],
            [30.717256401667072, 0.289816167800147],
            [30.716574282125734, 0.286224436062654],
            [30.71520779006838, 0.284880205681218],
            [30.713052650853378, 0.281429552014275],
            [30.715291131268863, 0.279837119526849],
            [30.718035886008778, 0.279113999597068],
            [30.71859818825749, 0.277522049185405],
            [30.72004906715436, 0.276732881252976],
            [30.723290507601366, 0.275838799343997],
            [30.725159488482607, 0.275733901588483],
            [30.72623096661415, 0.276957767367549],
            [30.730190613724098, 0.279392702196912],
            [30.7316933523623, 0.280827181375161],
            [30.733757564104188, 0.284945939987725],
            [30.73595042357797, 0.287975774045067],
            [30.73692304121418, 0.288735351083609],
            [30.738014478114707, 0.288952525925297],
            [30.7391548130111, 0.287815400740286],
            [30.73966504621102, 0.28523658989311],
            [30.741181388037568, 0.284000065177985],
            [30.74259337886575, 0.28169773900737],
            [30.745495162710593, 0.280250954960307],
            [30.754748836911403, 0.279265923569186],
            [30.758826865806114, 0.278205859399565],
            [30.761176430991306, 0.276966179093592],
            [30.761624216007597, 0.276236001006782],
            [30.76295055067684, 0.275405987064862],
            [30.766598040412067, 0.274312791265667],
            [30.767752415078032, 0.273445128327034],
            [30.77354834349454, 0.27109570016202],
            [30.77609777035572, 0.269179592500238],
            [30.779596083159916, 0.267805596630134],
            [30.781829341668637, 0.267471995617615],
            [30.787288218597286, 0.267762296509728],
            [30.78994165779193, 0.266506143798718],
            [30.7930842997274, 0.26412000054331],
            [30.797789814424476, 0.263903874468615],
            [30.798751747498702, 0.267429892937253],
            [30.799853850994932, 0.268632498466524],
            [30.801807645415355, 0.269220498631821],
            [30.80203292582065, 0.269591205895363],
            [30.801506581336092, 0.271236506810887],
            [30.802332978396883, 0.273126155469422],
            [30.802497928845984, 0.275738934790734],
            [30.803901025454568, 0.279111363971291],
            [30.805659341977638, 0.280540123679101],
            [30.80579106104941, 0.282230754215008],
            [30.808285190316656, 0.282972568563256],
            [30.811397365889235, 0.284736104215268],
            [30.81012818922491, 0.286977951462183],
            [30.811546710805224, 0.291046545691465],
            [30.81433475805363, 0.292068696673105],
            [30.818541882939517, 0.297873688516112],
            [30.82051435602966, 0.299881134453871],
            [30.821074814935425, 0.303931509973728],
            [30.822928828985685, 0.306752611095918],
            [30.823489079482325, 0.310378079055859],
            [30.823372026305837, 0.313216858845844],
            [30.821960489126855, 0.316245219031657],
            [30.822104183639695, 0.318207096066883],
            [30.82511070386016, 0.321923504953497],
            [30.83118165509417, 0.326951516870969],
            [30.83104021265772, 0.328886221845793],
            [30.83382036910469, 0.331445392462743],
            [30.84373724702186, 0.33327385191748],
            [30.847229561774935, 0.335155139152682],
            [30.85044912465154, 0.337560747402495],
            [30.852174698480805, 0.344287601232846],
            [30.85252216144278, 0.349730334425675],
            [30.8535220510327, 0.354178717664979],
            [30.85411988165092, 0.361709979555647],
            [30.859813390446952, 0.371403290296139],
            [30.859494983492823, 0.375498782578384],
            [30.858582424521558, 0.379051661977791],
            [30.854405714794567, 0.386854612663239],
            [30.85281840695888, 0.397059637029748],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 307,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "BIGULI",
        Population: 34231,
        Key: "KAMWENGEBIGULI",
        Dist2: "Kamwenge",
        "Sub Country": "Biguli",
        id2_original: "Kamwenge Biguli",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.613907508153286, 0.16863013085568],
            [30.61216332931617, 0.171890154729873],
            [30.609632137356975, 0.180920309533103],
            [30.605031103015648, 0.188329287167198],
            [30.60434005242377, 0.195738785366949],
            [30.6027290955399, 0.20222193797853],
            [30.60433844264277, 0.206621627369094],
            [30.59916331835955, 0.207315477076073],
            [30.59605831583449, 0.207314996480539],
            [30.593643017326734, 0.209282779937185],
            [30.588813179387557, 0.208355834314812],
            [30.589272782639767, 0.21090292647423],
            [30.591341821928026, 0.216923490563273],
            [30.593411368764414, 0.21970240243366],
            [30.589271344436977, 0.219933269559213],
            [30.586050215796842, 0.226879139650817],
            [30.58880992748623, 0.228500439511199],
            [30.605139951878613, 0.228503223368132],
            [30.609509288250276, 0.232671878277579],
            [30.61249912675591, 0.23383015101689],
            [30.616639464595362, 0.232210003393576],
            [30.61870926296004, 0.233599673080237],
            [30.620088611705754, 0.237536303520406],
            [30.61939819622279, 0.239851706343756],
            [30.628367866249885, 0.242863494511801],
            [30.632508585873335, 0.239390914158673],
            [30.63112914639777, 0.235917356465745],
            [30.630440645224656, 0.226886620761824],
            [30.63067099212815, 0.224802671256476],
            [30.631821436664747, 0.222255761094501],
            [30.636882097614443, 0.219014813598228],
            [30.639412903298087, 0.214384105091722],
            [30.6440134480576, 0.21183770609958],
            [30.646314020923814, 0.208596265910692],
            [30.649533827243864, 0.210680773709575],
            [30.651833350877837, 0.21438605352392],
            [30.65482354691295, 0.213923404621387],
            [30.664022630493914, 0.222492550728363],
            [30.66540240414276, 0.224345254424065],
            [30.667357561307515, 0.223998231597724],
            [30.668277011255316, 0.227703350015068],
            [30.6705772113207, 0.22724060720461],
            [30.673222657305935, 0.225388550658356],
            [30.679431816143047, 0.232799558368801],
            [30.678510946857074, 0.237662212104632],
            [30.675749628081636, 0.244377030692487],
            [30.671378353145567, 0.250165286590394],
            [30.667697102925324, 0.255953632460676],
            [30.66654566575037, 0.263363348612813],
            [30.663784193362993, 0.270309616586798],
            [30.66240234640248, 0.279340171140191],
            [30.658260153541956, 0.289064805822561],
            [30.651819213191885, 0.292073705614039],
            [30.64376837327506, 0.294387557616494],
            [30.646067180951746, 0.300408529917323],
            [30.644225992148783, 0.305502370796959],
            [30.642155085263056, 0.309206808929044],
            [30.63318396535508, 0.312678100494057],
            [30.6313431116237, 0.316150995278067],
            [30.628122313563583, 0.319160448059554],
            [30.623292114501712, 0.319390867742318],
            [30.619842449063395, 0.317537637802605],
            [30.61179129473622, 0.321703670009906],
            [30.60787995902224, 0.327028399729145],
            [30.601668575956513, 0.332352530152557],
            [30.596378399943273, 0.332814320209061],
            [30.58234770425046, 0.335357845017931],
            [30.577978795476845, 0.33095738724478],
            [30.575909144435897, 0.32956760340113],
            [30.57429999765734, 0.32609403495796],
            [30.572230292717467, 0.324935806347296],
            [30.57015963915662, 0.327713829153488],
            [30.56762938503856, 0.328870921991947],
            [30.56486947661814, 0.328638696042474],
            [30.56348966613835, 0.327943725831055],
            [30.559350802434267, 0.323543401325469],
            [30.557626599434137, 0.320359280543881],
            [30.55572940157151, 0.319258998903278],
            [30.554809366820468, 0.319490317783447],
            [30.55325705375498, 0.318853204740127],
            [30.552340139751223, 0.319782159708158],
            [30.551896292050806, 0.319817771964553],
            [30.551493148812572, 0.319004161590018],
            [30.551018439490566, 0.319428880261212],
            [30.547578633062493, 0.318262015521298],
            [30.547609893536055, 0.317180952817649],
            [30.55040469521707, 0.314590722520684],
            [30.554228806313585, 0.312652476432123],
            [30.55767932155815, 0.310106331886408],
            [30.56641980440681, 0.307329858412166],
            [30.57148099536256, 0.301773968261696],
            [30.576311516021327, 0.299228068167957],
            [30.577692371241774, 0.295292108706778],
            [30.573784058358726, 0.287650270015445],
            [30.579304204881346, 0.286725280098982],
            [30.578386431189863, 0.276073994422022],
            [30.567232609957355, 0.270977722142527],
            [30.550560099269642, 0.260439207504114],
            [30.546766074548653, 0.25603919793403],
            [30.546881733539784, 0.252566121574985],
            [30.548492441590323, 0.248514477207752],
            [30.548148604228796, 0.242262827006883],
            [30.54676967230136, 0.236589844841761],
            [30.54435477983209, 0.236473639766855],
            [30.541422672456523, 0.234895752438409],
            [30.53950880635382, 0.234586865727152],
            [30.540960779398684, 0.229253755308085],
            [30.541512316237046, 0.225638265101699],
            [30.54083127287743, 0.22444500528314],
            [30.54056109287761, 0.222682362417232],
            [30.538858550055632, 0.220955633718614],
            [30.539013628019756, 0.220603141011307],
            [30.540856999728838, 0.22078423104606],
            [30.543913000951754, 0.217774764832333],
            [30.54415368027763, 0.216418957188195],
            [30.54351269728811, 0.214683366849343],
            [30.544294297162317, 0.213535544424667],
            [30.544254401183924, 0.212993198413715],
            [30.553690933749007, 0.21612224037376],
            [30.555744651371803, 0.216113538455482],
            [30.56354302247298, 0.20972473732265],
            [30.563803424310898, 0.208186043068087],
            [30.5633333763469, 0.205073110696454],
            [30.56635118839048, 0.19579419582517],
            [30.566922979543534, 0.192799838044914],
            [30.566654230559987, 0.191936994009791],
            [30.56546116096315, 0.191547712159593],
            [30.56466148429052, 0.190634716295017],
            [30.56426744727429, 0.189170879155906],
            [30.564982740700742, 0.187952625599265],
            [30.56857930404418, 0.185212458712061],
            [30.56827723924168, 0.182167216990441],
            [30.566899664668664, 0.179189501682318],
            [30.564782662530746, 0.176380872280775],
            [30.5610005494704, 0.172529870001928],
            [30.560249683657023, 0.169463516775315],
            [30.561271647548423, 0.167691984719231],
            [30.56163257625656, 0.165775740805031],
            [30.562193653203227, 0.165350973298035],
            [30.562524554824655, 0.163443762579318],
            [30.56400743979677, 0.161084736814857],
            [30.564378386516935, 0.159783149546133],
            [30.566902310207183, 0.158245323245608],
            [30.570378169620863, 0.153033324385008],
            [30.57097322354652, 0.153745787361784],
            [30.57161505005408, 0.153827214857368],
            [30.572593963982143, 0.155436302775196],
            [30.57329524997835, 0.155725639180051],
            [30.575577866420357, 0.155210673754373],
            [30.57779959595072, 0.15593407180959],
            [30.578132033691283, 0.158799542128793],
            [30.578753496289675, 0.159088871300516],
            [30.582213782509577, 0.159432778300374],
            [30.583416062533022, 0.158528997552032],
            [30.58578046609006, 0.158203867051633],
            [30.58798428680693, 0.159840239056995],
            [30.588945999793903, 0.159858433463965],
            [30.589777442691624, 0.160518401564274],
            [30.592602788888946, 0.159650969253854],
            [30.595352918249237, 0.160166540930167],
            [30.599201463521464, 0.161522906324583],
            [30.603400248448235, 0.163611511495603],
            [30.603382368380807, 0.164126752492543],
            [30.60493342470322, 0.165236188845312],
            [30.607306600309016, 0.168362009157324],
            [30.610198939266947, 0.168547868887987],
            [30.612545533723498, 0.167418232391832],
            [30.613907508153286, 0.16863013085568],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 308,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "BIHANGA",
        Population: 14308,
        Key: "KAMWENGEBIHANGA",
        Dist2: "Kamwenge",
        "Sub Country": "Rwamwanja Refugee",
        id2_original: "Kamwenge Rwamwanja Refugee",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.150208321854823, 0.707702592327131],
            [30.148048715317962, 0.708207297392151],
            [30.1425106105745, 0.708531619218569],
            [30.140799901168243, 0.709725943011964],
            [30.139500002121217, 0.711466966009416],
            [30.13475538825137, 0.712180352949792],
            [30.131041346828315, 0.71156652939461],
            [30.130333547147956, 0.712218848175449],
            [30.12877127446095, 0.712395890638843],
            [30.127237572691527, 0.714026829945169],
            [30.125910712507842, 0.714827108255738],
            [30.124319026283477, 0.714915112947024],
            [30.122925980026316, 0.716516700304236],
            [30.12340821633206, 0.719301553709857],
            [30.121251353250067, 0.721864247226882],
            [30.120751553083874, 0.723549397550266],
            [30.120216741079474, 0.724266275874694],
            [30.117544407619448, 0.725125222051697],
            [30.117971003174812, 0.726524075057472],
            [30.117363362055396, 0.729715309675385],
            [30.115581942659873, 0.730072764337927],
            [30.11447468373224, 0.731245929785526],
            [30.113323117199833, 0.729612806739331],
            [30.111803970832984, 0.728368646458167],
            [30.111281393882745, 0.724936576573714],
            [30.11022578449069, 0.722541321039399],
            [30.108625984682675, 0.721481330289391],
            [30.106915997521913, 0.721575859697302],
            [30.104160423472685, 0.722673811107873],
            [30.100835216922064, 0.723245432785153],
            [30.099031617223844, 0.721188271866141],
            [30.096799659475653, 0.72051743975158],
            [30.09518602291731, 0.718508224103418],
            [30.091766642382172, 0.717836634374434],
            [30.08821924563083, 0.714758514645613],
            [30.086824154808085, 0.712690417358487],
            [30.08406342353085, 0.709857463344845],
            [30.083209503886383, 0.708231270697214],
            [30.080044464255945, 0.704313902196264],
            [30.077468149920005, 0.699047529434942],
            [30.07705539201327, 0.697527072164449],
            [30.077341903384923, 0.69649426837298],
            [30.07633532583771, 0.694261352192794],
            [30.07638657921624, 0.692874662508484],
            [30.077492427788865, 0.690651664893872],
            [30.078546333076822, 0.688981791762086],
            [30.07980636129831, 0.688348553976838],
            [30.082675718656365, 0.68806854325231],
            [30.084355846715404, 0.687083326722684],
            [30.085755625845607, 0.686802402402937],
            [30.08701608795339, 0.685464686782634],
            [30.090585822212553, 0.684269278935401],
            [30.09394651581018, 0.681594335455807],
            [30.097026270285852, 0.680609947581201],
            [30.098356544067602, 0.679554041572101],
            [30.101366494055817, 0.678287806857348],
            [30.105886754581736, 0.67680312306871],
            [30.106244455643033, 0.67595674447106],
            [30.106437109237188, 0.6714623274811],
            [30.109336283476125, 0.668356133219002],
            [30.111521394082246, 0.66797491772883],
            [30.113232118759893, 0.666589315461166],
            [30.11541701197368, 0.666590610744147],
            [30.119519426535103, 0.664382339616729],
            [30.126854787972544, 0.661224383410767],
            [30.131963800742444, 0.668240389575224],
            [30.132659079704357, 0.672973258963743],
            [30.133456200670047, 0.674063623395211],
            [30.134310677269983, 0.674523051099547],
            [30.136618358505032, 0.674782547411528],
            [30.13818493591889, 0.675557888786497],
            [30.139650695408445, 0.678226179560643],
            [30.14078974122237, 0.679288075405251],
            [30.144532471242364, 0.685973193831512],
            [30.14622503647652, 0.690477282224575],
            [30.148246706701535, 0.692600982914073],
            [30.149242894334147, 0.694322513989775],
            [30.150097305357093, 0.694896679415081],
            [30.1499248854164, 0.697334540632622],
            [30.150896222953342, 0.698829774250257],
            [30.15119534487495, 0.698790687866331],
            [30.153374099002107, 0.702768019937596],
            [30.15337364714954, 0.703509818887869],
            [30.15127967332394, 0.705526204593709],
            [30.150208321854823, 0.707702592327131],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 309,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "BUKONZO",
        Population: 10687,
        Key: "BUNDIBUGYOBUKONZO",
        Dist2: "Bundibugyo",
        "Sub Country": "Bukonzo",
        id2_original: "Bundibugyo Bukonzo",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.126854787972544, 0.661224383410767],
            [30.119519426535103, 0.664382339616729],
            [30.11541701197368, 0.666590610744147],
            [30.113232118759893, 0.666589315461166],
            [30.111521394082246, 0.66797491772883],
            [30.109336283476125, 0.668356133219002],
            [30.106437109237188, 0.6714623274811],
            [30.106244455643033, 0.67595674447106],
            [30.105886754581736, 0.67680312306871],
            [30.101366494055817, 0.678287806857348],
            [30.098356544067602, 0.679554041572101],
            [30.097026270285852, 0.680609947581201],
            [30.09394651581018, 0.681594335455807],
            [30.090585822212553, 0.684269278935401],
            [30.08701608795339, 0.685464686782634],
            [30.085755625845607, 0.686802402402937],
            [30.084355846715404, 0.687083326722684],
            [30.082675718656365, 0.68806854325231],
            [30.07980636129831, 0.688348553976838],
            [30.078546333076822, 0.688981791762086],
            [30.077492427788865, 0.690651664893872],
            [30.077564274146987, 0.690034305698458],
            [30.07561783782702, 0.686312625768723],
            [30.07022799732627, 0.681878568341479],
            [30.0686218167848, 0.681352491054427],
            [30.065131964313935, 0.679557375883926],
            [30.063031324988913, 0.677834840638974],
            [30.06271140257691, 0.676723007917571],
            [30.057422896531776, 0.674568222447893],
            [30.052829917383587, 0.670943660556183],
            [30.050304095553138, 0.665455719961563],
            [30.04691521821181, 0.660832049661417],
            [30.04578392575706, 0.65921357257486],
            [30.04425449098525, 0.655375780262396],
            [30.04275245662621, 0.652864365794036],
            [30.040981598723498, 0.648166262287906],
            [30.039913058981224, 0.647565486773395],
            [30.039160030922964, 0.646170263889854],
            [30.03827692142165, 0.645682068642424],
            [30.03035940406941, 0.637932028968306],
            [30.02856683568288, 0.635485774652451],
            [30.029094939068727, 0.634954761022083],
            [30.031431977247287, 0.634353701005094],
            [30.033341804524476, 0.633350777195632],
            [30.03388443097353, 0.631256967708539],
            [30.03588043094098, 0.629049243494384],
            [30.036621581474552, 0.628619369827057],
            [30.038416660652302, 0.628964640767853],
            [30.039244113233558, 0.627100475459656],
            [30.037877076797116, 0.625694041223569],
            [30.03779237914055, 0.62428834408356],
            [30.03824891913763, 0.623227193886908],
            [30.03910410181338, 0.622711318320684],
            [30.040386183675075, 0.623171037232311],
            [30.043849393012927, 0.621595225585866],
            [30.045188442436697, 0.62211234715112],
            [30.047805594185448, 0.615874637379787],
            [30.05137645044042, 0.614485084819308],
            [30.052018005656752, 0.613796951962077],
            [30.051989824607976, 0.613223193154976],
            [30.04953961577165, 0.612303841600338],
            [30.04993904178126, 0.611443452844247],
            [30.054983792668967, 0.609925836276842],
            [30.056295113794853, 0.609065945676948],
            [30.05675148580697, 0.608291642495461],
            [30.05685331074273, 0.604447609147595],
            [30.057309617177822, 0.603788052424385],
            [30.057197007068744, 0.60123482583153],
            [30.05907902879294, 0.598940869116232],
            [30.061202320934477, 0.598425649647874],
            [30.062148693391347, 0.596450220699515],
            [30.064795182320644, 0.595754912894814],
            [30.067445645396763, 0.593978185044783],
            [30.075552300337144, 0.591433358980501],
            [30.076065612961848, 0.590313231963833],
            [30.079256666904598, 0.590080005757615],
            [30.08033553906925, 0.589032458508156],
            [30.082170744194123, 0.588192216037656],
            [30.082534064217498, 0.587516429257218],
            [30.090050677831492, 0.581400006436177],
            [30.09157532817613, 0.581053675205898],
            [30.09298538852478, 0.579262322448725],
            [30.09445944665088, 0.579974183816426],
            [30.09436526907315, 0.582238830659272],
            [30.094835502988406, 0.583368489923889],
            [30.094723817245743, 0.585593694234757],
            [30.094096570395244, 0.587410658192463],
            [30.09472028327343, 0.592380747180848],
            [30.094351169116443, 0.593715706027842],
            [30.09302373850257, 0.595903173612041],
            [30.095360471253915, 0.600985433098419],
            [30.095724663541475, 0.608885322642397],
            [30.09660848450846, 0.609590474647562],
            [30.100863329698864, 0.610297460816136],
            [30.10565153162293, 0.612562432034469],
            [30.10826713467612, 0.612897664128184],
            [30.11029274491197, 0.614196858064846],
            [30.119569229134445, 0.623592581762107],
            [30.120250189849063, 0.62437977906598],
            [30.12097410530562, 0.629112577192499],
            [30.12282474708031, 0.631436809391128],
            [30.124260673519256, 0.636600261920684],
            [30.12656602811772, 0.6409611507903],
            [30.126435754435214, 0.644632293886925],
            [30.12780186021702, 0.647243079542792],
            [30.12778579384817, 0.650455410700526],
            [30.126485396236152, 0.657538970123135],
            [30.12582905385189, 0.659345520066371],
            [30.126854787972544, 0.661224383410767],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 310,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "HARUGALE",
        Population: 12600,
        Key: "BUNDIBUGYOHARUGALE",
        Dist2: "Bundibugyo",
        "Sub Country": "Harugale",
        id2_original: "Bundibugyo Harugale",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.001749647796682, 0.633159720797829],
            [30.00115937200999, 0.63323670530951],
            [30.001114926962995, 0.632877075060146],
            [29.998582321055533, 0.63341432822034],
            [29.993629220784662, 0.635913099387796],
            [29.991662613693304, 0.636107429841326],
            [29.987720939177247, 0.636176157504049],
            [29.983176853533347, 0.635276422572485],
            [29.981009250193832, 0.63401927781343],
            [29.97874521989504, 0.634086099395644],
            [29.977430894802854, 0.632522094182428],
            [29.97713551166943, 0.629681286046654],
            [29.978858930440325, 0.62857594159177],
            [29.97966305646858, 0.624857266349786],
            [29.980358795367945, 0.625287950558149],
            [29.981043462531414, 0.62391145670623],
            [29.980716148781234, 0.623251507148247],
            [29.981087124247473, 0.62230510975264],
            [29.98171416089219, 0.622047303975286],
            [29.98236903453096, 0.622936926755678],
            [29.98325218176152, 0.623281663604644],
            [29.985047940065613, 0.622278717009706],
            [29.98655992416471, 0.619210252989146],
            [29.987728855131543, 0.618092194116354],
            [29.98892689780178, 0.6158841023811],
            [29.990736885419988, 0.614909828756058],
            [29.991278680927394, 0.614221686970907],
            [29.991279389698175, 0.61295952307049],
            [29.992763429005393, 0.608858333385384],
            [29.993521003437323, 0.604441182059391],
            [29.995231046293636, 0.603839741310325],
            [29.99548791415924, 0.603094057917787],
            [29.99305505897757, 0.596753188951682],
            [29.99462299284752, 0.595463204361708],
            [29.995022751233794, 0.593943087057694],
            [29.995649691758786, 0.593857375316393],
            [29.997301928924873, 0.594747539908334],
            [29.998014354030623, 0.594661874889383],
            [29.99835674959611, 0.593830178485395],
            [29.998015396076354, 0.592739934608447],
            [29.99872866110689, 0.591105239845655],
            [30.001449710204778, 0.591565699820412],
            [30.00310283939795, 0.590820772900215],
            [30.00404300000463, 0.591165516287922],
            [30.00612340926945, 0.590707676526388],
            [30.0072625619829, 0.591941794488769],
            [30.007946514985743, 0.591827424394684],
            [30.008802612146443, 0.589533011936678],
            [30.00857514164852, 0.588614937325119],
            [30.00697941210705, 0.588585384311783],
            [30.007435937731074, 0.587466881689223],
            [30.008006091255382, 0.587008214318868],
            [30.008263039969357, 0.586090402484827],
            [30.009231594525524, 0.586635960312245],
            [30.010742375780474, 0.585661452413726],
            [30.012451938936433, 0.585977921328905],
            [30.012794128787714, 0.585519129875475],
            [30.01223947210037, 0.583625550172907],
            [30.01295303088002, 0.581417104088972],
            [30.016572861487653, 0.579726556127052],
            [30.017485400695982, 0.578436164282536],
            [30.022188869929163, 0.57522579487279],
            [30.024568193604765, 0.575370483713226],
            [30.025822262402638, 0.574883476736581],
            [30.026648358527808, 0.575428953903087],
            [30.029099527663195, 0.57442621862891],
            [30.028017723397447, 0.572417595521991],
            [30.027989940302355, 0.571040630290931],
            [30.028417571615268, 0.570667928795655],
            [30.03175180174293, 0.570268060872829],
            [30.03564242050982, 0.568491515426109],
            [30.0378032262976, 0.567031237289739],
            [30.039135434152175, 0.564104251880262],
            [30.040962173553794, 0.558195706588856],
            [30.042274004922735, 0.556188295027668],
            [30.041306911925542, 0.552630637191723],
            [30.041649079318933, 0.552200506995535],
            [30.043216396046276, 0.552143922946926],
            [30.044342465695966, 0.551197821620863],
            [30.045198246649683, 0.549390975207853],
            [30.043916045312073, 0.549132150128552],
            [30.04405206192419, 0.548356442847807],
            [30.045584703681566, 0.546384982296459],
            [30.045905833429334, 0.545273521181259],
            [30.04870320968196, 0.542854442933197],
            [30.04873932015975, 0.541850414872166],
            [30.04970169610342, 0.540559972468916],
            [30.04945268580159, 0.539878532700189],
            [30.051555101994243, 0.538194196915025],
            [30.05401455179991, 0.534788799726908],
            [30.055439663421133, 0.534179889731824],
            [30.05978694794922, 0.530882956334906],
            [30.065332618303998, 0.52521767785791],
            [30.068358954461303, 0.527461060939243],
            [30.071489397275194, 0.531136985393903],
            [30.070803533555758, 0.533663885701835],
            [30.071028338752253, 0.540786200405303],
            [30.072625667294925, 0.541246478433317],
            [30.073537218356442, 0.544003912297638],
            [30.07432476777276, 0.544185712333811],
            [30.07604598656953, 0.547451389361462],
            [30.07604497686316, 0.549519130159723],
            [30.071933818100756, 0.555950055068562],
            [30.072389570275313, 0.557328775502794],
            [30.073986097520773, 0.559397332082315],
            [30.073528506494828, 0.561694583526873],
            [30.073527123987596, 0.564451577623215],
            [30.074439326327678, 0.565830537689769],
            [30.07622210487424, 0.566209241746884],
            [30.084668094819925, 0.57082479920022],
            [30.08513038583145, 0.572402871072717],
            [30.085341809723452, 0.576921341249788],
            [30.085697253318447, 0.578427637010125],
            [30.086121594102494, 0.578665245458618],
            [30.09298538852478, 0.579262322448725],
            [30.09157532817613, 0.581053675205898],
            [30.090050677831492, 0.581400006436177],
            [30.082534064217498, 0.587516429257218],
            [30.082170744194123, 0.588192216037656],
            [30.08033553906925, 0.589032458508156],
            [30.079256666904598, 0.590080005757615],
            [30.076065612961848, 0.590313231963833],
            [30.075552300337144, 0.591433358980501],
            [30.067445645396763, 0.593978185044783],
            [30.064795182320644, 0.595754912894814],
            [30.062148693391347, 0.596450220699515],
            [30.061202320934477, 0.598425649647874],
            [30.05907902879294, 0.598940869116232],
            [30.057197007068744, 0.60123482583153],
            [30.057309617177822, 0.603788052424385],
            [30.05685331074273, 0.604447609147595],
            [30.05675148580697, 0.608291642495461],
            [30.056295113794853, 0.609065945676948],
            [30.054983792668967, 0.609925836276842],
            [30.04993904178126, 0.611443452844247],
            [30.04953961577165, 0.612303841600338],
            [30.051989824607976, 0.613223193154976],
            [30.052018005656752, 0.613796951962077],
            [30.05137645044042, 0.614485084819308],
            [30.047805594185448, 0.615874637379787],
            [30.045188442436697, 0.62211234715112],
            [30.043849393012927, 0.621595225585866],
            [30.040386183675075, 0.623171037232311],
            [30.03910410181338, 0.622711318320684],
            [30.03824891913763, 0.623227193886908],
            [30.03779237914055, 0.62428834408356],
            [30.037877076797116, 0.625694041223569],
            [30.039244113233558, 0.627100475459656],
            [30.038416660652302, 0.628964640767853],
            [30.036621581474552, 0.628619369827057],
            [30.03588043094098, 0.629049243494384],
            [30.03388443097353, 0.631256967708539],
            [30.033341804524476, 0.633350777195632],
            [30.031431977247287, 0.634353701005094],
            [30.029094939068727, 0.634954761022083],
            [30.02856683568288, 0.635485774652451],
            [30.028104830335636, 0.633749476347148],
            [30.02594615175844, 0.63158723931729],
            [30.02446819045238, 0.631102298880177],
            [30.020338168865663, 0.627765126931865],
            [30.01683101214747, 0.625562516842614],
            [30.012072115064615, 0.62394171556071],
            [30.00942523896144, 0.619732838919815],
            [30.00369937734047, 0.616631492498512],
            [30.003442757409875, 0.616918204649575],
            [30.003869623358163, 0.617922453843264],
            [30.006233392704612, 0.620333418249227],
            [30.00704446091341, 0.622198468051442],
            [30.006985645516814, 0.62541125944386],
            [30.006158422005953, 0.626902449221562],
            [30.006043143900495, 0.629168568503418],
            [30.004390087470853, 0.629712640746266],
            [30.003719469060123, 0.631404714535072],
            [30.002037604557632, 0.632493794483896],
            [30.001749647796682, 0.633159720797829],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 311,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "NDUGUTO",
        Population: 11406,
        Key: "BUNDIBUGYONDUGUTO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.16439387272958, 0.732604526181768],
            [30.166913506964356, 0.733991346712895],
            [30.167119386454438, 0.734703608210185],
            [30.166779324712074, 0.736424368088709],
            [30.168133102913217, 0.739748510981673],
            [30.168102473056983, 0.741558487499951],
            [30.166721647480934, 0.743864492758382],
            [30.16590014983171, 0.743480873481293],
            [30.16384195410725, 0.747018853026577],
            [30.162856595665346, 0.7502575816538],
            [30.16309364220422, 0.752297341961266],
            [30.162510123545093, 0.756136211232867],
            [30.161496257067665, 0.757365301162917],
            [30.1605254109092, 0.761143917667103],
            [30.159064540949753, 0.762462684234705],
            [30.15939148639066, 0.76369265982131],
            [30.159093072341495, 0.764382324973301],
            [30.155903598535346, 0.766359793218953],
            [30.15354898930982, 0.767467988622927],
            [30.149123757066228, 0.76830483518383],
            [30.147632510575463, 0.770493374050331],
            [30.142983164838135, 0.772319837406801],
            [30.142299192072382, 0.770339792191535],
            [30.139588060375257, 0.769948037254679],
            [30.136519601315957, 0.772776370036764],
            [30.135385656136183, 0.771804778509606],
            [30.134731144518472, 0.770334654292518],
            [30.134091759631858, 0.762274656542248],
            [30.132750088924098, 0.758804088552944],
            [30.131748003851634, 0.757513363820495],
            [30.126570535863824, 0.758610771884309],
            [30.12429059909633, 0.758580551613857],
            [30.12235203022161, 0.759497293538391],
            [30.119358253501762, 0.76318149193968],
            [30.11322860455048, 0.766619977737092],
            [30.110900562101186, 0.767526862517484],
            [30.10586542498365, 0.770804100147408],
            [30.10490346136669, 0.770982741818708],
            [30.10362139567467, 0.770408092114896],
            [30.10230468016551, 0.768398999802282],
            [30.101522583522943, 0.765995811343699],
            [30.10088648287702, 0.760756090774812],
            [30.101933795429115, 0.760114756439428],
            [30.104543691485308, 0.755797585729106],
            [30.10469366162874, 0.754298054035722],
            [30.105737223714485, 0.753159034920244],
            [30.106125464800503, 0.751779632664497],
            [30.105649347818456, 0.750879533465086],
            [30.106157949677808, 0.747700649559325],
            [30.10875985252463, 0.745084351338824],
            [30.111553162103966, 0.738152378800401],
            [30.113105861445007, 0.736694156586642],
            [30.113405506186123, 0.735342896471178],
            [30.11269411773623, 0.733656972681651],
            [30.11447468373224, 0.731245929785526],
            [30.115581942659873, 0.730072764337927],
            [30.117363362055396, 0.729715309675385],
            [30.117971003174812, 0.726524075057472],
            [30.117544407619448, 0.725125222051697],
            [30.120216741079474, 0.724266275874694],
            [30.120751553083874, 0.723549397550266],
            [30.121251353250067, 0.721864247226882],
            [30.12340821633206, 0.719301553709857],
            [30.122925980026316, 0.716516700304236],
            [30.124319026283477, 0.714915112947024],
            [30.125910712507842, 0.714827108255738],
            [30.127237572691527, 0.714026829945169],
            [30.12877127446095, 0.712395890638843],
            [30.130333547147956, 0.712218848175449],
            [30.131041346828315, 0.71156652939461],
            [30.13475538825137, 0.712180352949792],
            [30.139500002121217, 0.711466966009416],
            [30.140799901168243, 0.709725943011964],
            [30.1425106105745, 0.708531619218569],
            [30.148048715317962, 0.708207297392151],
            [30.150208321854823, 0.707702592327131],
            [30.15027568202641, 0.708522410394416],
            [30.153325570213845, 0.70982986382769],
            [30.15460449629394, 0.715112225700042],
            [30.156549541123535, 0.715647536761744],
            [30.15710926520741, 0.716152312816708],
            [30.1574318951417, 0.71873395657148],
            [30.15787354286799, 0.719505704019247],
            [30.16039227160092, 0.721821701900148],
            [30.160686112326992, 0.723275806896329],
            [30.15991858366342, 0.725144638479747],
            [30.159961020077443, 0.727963496765472],
            [30.16343720288461, 0.731081266731057],
            [30.16439387272958, 0.732604526181768],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 312,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "NGAMBA",
        Population: 10504,
        Key: "BUNDIBUGYONGAMBA",
        Dist2: "Bundibugyo",
        "Sub Country": "Ngamba",
        id2_original: "Bundibugyo Ngamba",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.156282558227815, 0.885772946227834],
            [30.15569982649292, 0.884895889187423],
            [30.153196900922424, 0.884893949057836],
            [30.149769157970304, 0.886360985851686],
            [30.148756003856906, 0.886450178782836],
            [30.14647561972839, 0.887678147168198],
            [30.145522154174035, 0.887647410508293],
            [30.144482018262753, 0.884077350213969],
            [30.14361805994499, 0.883896716917987],
            [30.14257412505835, 0.885275612950697],
            [30.14191710264945, 0.887224686198512],
            [30.140337638902825, 0.887553382555],
            [30.139473913248715, 0.887072810969463],
            [30.139745471264177, 0.882663968810257],
            [30.137987788951698, 0.882272686629361],
            [30.133293175310598, 0.884488544583532],
            [30.13329213416316, 0.885838246842511],
            [30.13418437593764, 0.887968477453536],
            [30.13427269739806, 0.889348243230599],
            [30.133526744470977, 0.890697360779828],
            [30.132513208573585, 0.891296431393254],
            [30.131112669468596, 0.891445295660141],
            [30.130397888081863, 0.891024826284028],
            [30.127927440202164, 0.887633643682166],
            [30.127212775596416, 0.887063211824589],
            [30.12622945992347, 0.887122426161719],
            [30.1255437803587, 0.887601778873289],
            [30.125304597626094, 0.888651353042744],
            [30.12667262670092, 0.891981675834859],
            [30.126374035683632, 0.892791257042878],
            [30.125509435070445, 0.893450423589338],
            [30.123202161670513, 0.890989162090214],
            [30.121771932347094, 0.891018026859608],
            [30.120788316636855, 0.891467145432796],
            [30.11899896960895, 0.893505256374771],
            [30.116495367607072, 0.894463045701602],
            [30.115154720080405, 0.894252031100323],
            [30.114559392168573, 0.893501735407026],
            [30.11459015138222, 0.892272050691752],
            [30.116379957449237, 0.889634090433542],
            [30.11614315615047, 0.887624376875523],
            [30.111794594218043, 0.885551441856479],
            [30.110751748089555, 0.885550620894365],
            [30.11024475511286, 0.886150077673443],
            [30.110333442187603, 0.887049930926642],
            [30.11192481759488, 0.890500361581238],
            [30.11105797209181, 0.894038825762656],
            [30.11010434663734, 0.894248016120067],
            [30.10941937584328, 0.893827573112395],
            [30.108229527605065, 0.891307236818581],
            [30.105010480361432, 0.892744327563524],
            [30.103758998711566, 0.892833309261887],
            [30.102686975302642, 0.892052649411432],
            [30.103583118460413, 0.889144079860008],
            [30.10301780326224, 0.888123883498972],
            [30.10233260249949, 0.888003370116412],
            [30.100483950493135, 0.88971147904957],
            [30.098353372116353, 0.88997971867427],
            [30.09674619085162, 0.887729009064317],
            [30.096153660293613, 0.883409631948521],
            [30.095230266741687, 0.883078986112012],
            [30.092816790915638, 0.883167057259544],
            [30.092071468605848, 0.883736321147453],
            [30.090757997811505, 0.886914461453359],
            [30.0897743605417, 0.88742354755605],
            [30.08847886503618, 0.886672712446523],
            [30.08892802088158, 0.88382380934215],
            [30.08845282377439, 0.881873940291526],
            [30.087738328950227, 0.881123571128196],
            [30.086606495709695, 0.880642802002595],
            [30.08285215496468, 0.880879771132994],
            [30.08139267829223, 0.880278775769563],
            [30.0791895052607, 0.878177596041576],
            [30.078474526244605, 0.878057063474155],
            [30.07795246402904, 0.878896425167655],
            [30.07807044786012, 0.880426106337742],
            [30.077294331302433, 0.88228498939505],
            [30.07643012055805, 0.882494245987061],
            [30.07514928106641, 0.882073342657563],
            [30.073333243294773, 0.880242400090608],
            [30.072351313722322, 0.878592074917084],
            [30.071546768180824, 0.878711403866333],
            [30.070919228479536, 0.881080254097767],
            [30.070233366556725, 0.881829500508711],
            [30.069339932717863, 0.881318931593864],
            [30.067525081620733, 0.877988416891414],
            [30.064948385500795, 0.877326558355239],
            [30.064084914968223, 0.87660607711896],
            [30.064087396115035, 0.873426975026706],
            [30.06166138519749, 0.870575868389043],
            [30.06056139903039, 0.867485882730176],
            [30.061516342313407, 0.865507194117407],
            [30.061845606306054, 0.863528014946104],
            [30.061160641800242, 0.863137590364277],
            [30.05952245338686, 0.862506490340241],
            [30.05849411864348, 0.863075523821054],
            [30.058106103034604, 0.863974962245682],
            [30.05798574405789, 0.865504428520213],
            [30.058936061017153, 0.869494030758732],
            [30.058666771247825, 0.870963396369924],
            [30.057891564683498, 0.871682578977028],
            [30.056908125941384, 0.871981715672054],
            [30.055791644010714, 0.870961127487689],
            [30.054958440415014, 0.869640852464318],
            [30.0545723319295, 0.868081002240604],
            [30.053708935957086, 0.867270557876542],
            [30.05239795708933, 0.867329508452448],
            [30.05066935324262, 0.868047935457166],
            [30.049715015424113, 0.869246829377308],
            [30.04947427680943, 0.872305737284007],
            [30.048728914075472, 0.872964950576484],
            [30.047328980435033, 0.87248398189849],
            [30.04470905289205, 0.870022640070163],
            [30.044292714300582, 0.869032606730024],
            [30.044398231312183, 0.867443166446457],
            [30.044011357462008, 0.866873032412056],
            [30.041597816058935, 0.867201028154156],
            [30.039395170338477, 0.864530099253003],
            [30.037250319528432, 0.864168518193611],
            [30.034239476614843, 0.866355467980567],
            [30.033196895489358, 0.866114716459037],
            [30.032601730172598, 0.865214524940725],
            [30.034020088259542, 0.86113690672058],
            [30.033365611676114, 0.859876782576139],
            [30.036466861938237, 0.856341406564212],
            [30.04053811394244, 0.850589168134621],
            [30.044983424430963, 0.842551256596259],
            [30.045879290009296, 0.839796195979685],
            [30.048668867088626, 0.834639192448608],
            [30.049683659729126, 0.832236580834815],
            [30.05014848219311, 0.828216236254019],
            [30.051580456943118, 0.825669362692019],
            [30.05432348601938, 0.822879508401312],
            [30.056396732118117, 0.819465704013149],
            [30.057799383162305, 0.816141741587319],
            [30.06210708971561, 0.81263016597347],
            [30.06377887961219, 0.808104667301401],
            [30.06638900563711, 0.803634048845815],
            [30.06971327344826, 0.795974414298931],
            [30.070762036779538, 0.792094670335501],
            [30.07331114204382, 0.789637163257127],
            [30.074832186550903, 0.787418849011137],
            [30.07483333998771, 0.785769298760092],
            [30.073065780698705, 0.77833008263214],
            [30.072680844514604, 0.774880756530958],
            [30.074038709152013, 0.771612595997934],
            [30.076662985439278, 0.768075377576382],
            [30.080095004372144, 0.765515678657549],
            [30.092250847795057, 0.759808251278611],
            [30.09618265880928, 0.761340537934303],
            [30.097523644102488, 0.76098154174238],
            [30.098715256631934, 0.761222293250274],
            [30.0991923087602, 0.760712744595117],
            [30.10088648287702, 0.760756090774812],
            [30.101522583522943, 0.765995811343699],
            [30.10230468016551, 0.768398999802282],
            [30.10362139567467, 0.770408092114896],
            [30.10490346136669, 0.770982741818708],
            [30.10586542498365, 0.770804100147408],
            [30.110900562101186, 0.767526862517484],
            [30.11322860455048, 0.766619977737092],
            [30.119358253501762, 0.76318149193968],
            [30.12235203022161, 0.759497293538391],
            [30.12429059909633, 0.758580551613857],
            [30.126570535863824, 0.758610771884309],
            [30.131748003851634, 0.757513363820495],
            [30.132750088924098, 0.758804088552944],
            [30.134091759631858, 0.762274656542248],
            [30.13326895852714, 0.76318880088272],
            [30.13293552365664, 0.764599126643232],
            [30.13162860337733, 0.765626271158845],
            [30.127139294304506, 0.766555625495499],
            [30.123838086246675, 0.766577292717417],
            [30.12242390352917, 0.766072636484809],
            [30.12278714360251, 0.769409606912718],
            [30.122358144155417, 0.771647048654343],
            [30.121414922988563, 0.773128778492966],
            [30.120233607847236, 0.773610781342343],
            [30.117410260401428, 0.776420344008128],
            [30.115289514085408, 0.779179858900877],
            [30.11649506936637, 0.781124667735563],
            [30.11629518163926, 0.781698303676367],
            [30.11680756001605, 0.782588011043948],
            [30.116435550588914, 0.784796786846401],
            [30.1141261140458, 0.786229611483677],
            [30.11386914467056, 0.786917960649805],
            [30.11406675606676, 0.789643524521798],
            [30.11500763263073, 0.789070410644886],
            [30.117612241203172, 0.789105708392811],
            [30.12003426719413, 0.789728995593922],
            [30.1210786880693, 0.790542578073793],
            [30.12307322917274, 0.791165568643554],
            [30.124878171852288, 0.791214648809193],
            [30.128867304364796, 0.792412819598723],
            [30.1293893036983, 0.793130412287912],
            [30.132285461394524, 0.795045052992072],
            [30.13527213423708, 0.798862215537613],
            [30.135659491380856, 0.804060620381977],
            [30.135213212839297, 0.805967201592592],
            [30.143719299179175, 0.805981594772551],
            [30.149747573250682, 0.812106310379729],
            [30.155944775511326, 0.815100063719075],
            [30.157209593549908, 0.817260536199569],
            [30.15765496838629, 0.819480414217848],
            [30.158488649885715, 0.82035083930899],
            [30.159827423526703, 0.82326122695652],
            [30.162164459908603, 0.82605236543713],
            [30.163713087186466, 0.827163268193003],
            [30.164608441623418, 0.828976109059038],
            [30.16405696497216, 0.829306543988464],
            [30.16547985505973, 0.832320022825649],
            [30.165241009195363, 0.83418469760709],
            [30.164669337518227, 0.836479478571818],
            [30.163099713917205, 0.839347324586067],
            [30.16300398315232, 0.840351401143278],
            [30.162528864198574, 0.840494501745336],
            [30.16086433089285, 0.843218816764793],
            [30.160626196494185, 0.844079337361786],
            [30.16093277712759, 0.847068091285932],
            [30.160552239993482, 0.847785056203413],
            [30.16083549766718, 0.850176088318608],
            [30.15959975450109, 0.851131496724286],
            [30.157747344841912, 0.856523117241155],
            [30.15866846116456, 0.860003118186748],
            [30.15866779281802, 0.86090293997618],
            [30.158071123721452, 0.861892294592426],
            [30.158427857297173, 0.863002343682608],
            [30.157935608369282, 0.863811810804614],
            [30.15781539222468, 0.865191446259395],
            [30.158855334998183, 0.869121455161055],
            [30.159106308118897, 0.872181041318944],
            [30.157794708515276, 0.872899896744641],
            [30.157195668764704, 0.877008620753438],
            [30.15910152638665, 0.878509786335403],
            [30.159041317703025, 0.879319579768899],
            [30.158325374794643, 0.880398815148405],
            [30.157401354218646, 0.880818020153681],
            [30.157698432473016, 0.881988016410375],
            [30.157310502204094, 0.882737567131331],
            [30.15784581546841, 0.884087711945452],
            [30.157011047007497, 0.884686947103562],
            [30.157038113247015, 0.885579684210218],
            [30.156282558227815, 0.885772946227834],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 313,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "NTOTORO",
        Population: 10499,
        Key: "BUNDIBUGYONTOTORO",
        Dist2: "Bundibugyo",
        "Sub Country": "Ntotoro",
        id2_original: "Bundibugyo Ntotoro",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.018070508474835, 0.482547238367774],
            [30.016973971838425, 0.489480435118304],
            [30.016401263505433, 0.495743327859667],
            [30.016464898363555, 0.499430727228037],
            [30.01568640845687, 0.501205325429382],
            [30.017199113903132, 0.503626422004073],
            [30.01739562935471, 0.508028527142546],
            [30.017766438632616, 0.509238427509371],
            [30.019599996247244, 0.511032178843571],
            [30.019991119128687, 0.512514485456034],
            [30.02098779095327, 0.513949271860667],
            [30.02335018767396, 0.514703404105761],
            [30.023727517822532, 0.515207984488597],
            [30.023812508329886, 0.516269420470306],
            [30.023479872959967, 0.516670872040215],
            [30.02139933523606, 0.517453977042548],
            [30.021845004719857, 0.519070185832352],
            [30.0214834444961, 0.520380022052488],
            [30.020266734834276, 0.522291857868915],
            [30.021684983326736, 0.52768186286534],
            [30.021741118150523, 0.529139713570146],
            [30.021028630162718, 0.529347342205157],
            [30.0189986972337, 0.528578997378801],
            [30.018008323497597, 0.528908407244522],
            [30.018054580446535, 0.530487605872603],
            [30.01598200988089, 0.541628350480748],
            [30.014199183723612, 0.545399687441219],
            [30.012964497874602, 0.547067457939714],
            [30.012422035817252, 0.554475396038486],
            [30.010754865956184, 0.556648084108484],
            [30.009683915135696, 0.556459274330314],
            [30.009139641176436, 0.556955314987235],
            [30.006912542415613, 0.556971284481787],
            [30.006334294172294, 0.557415961858729],
            [30.00740420474364, 0.559641389114168],
            [30.005379137090234, 0.563525313016298],
            [30.002879072653926, 0.56540659036522],
            [30.003235503497432, 0.566536325716932],
            [30.004424911561166, 0.567769185075389],
            [30.004424165959477, 0.569206792462973],
            [30.003335689007788, 0.57004482440843],
            [30.0017885762895, 0.570146695505188],
            [30.00138066928529, 0.569941107363333],
            [30.00099038363371, 0.56853752666649],
            [30.00003819997524, 0.568827970030338],
            [29.99801568982544, 0.567748704492472],
            [29.997285880522327, 0.565403664694798],
            [29.99665687836377, 0.565369106391816],
            [29.99629962825671, 0.565831004790948],
            [29.99617979120118, 0.567439682130545],
            [29.993916985306132, 0.570775765297161],
            [29.99432367239822, 0.573308887242918],
            [29.995700032448966, 0.574610301125374],
            [29.995886480481133, 0.575671484097832],
            [29.994831905948303, 0.576697776278145],
            [29.994746116838662, 0.578186669023571],
            [29.993605083052987, 0.581951186085907],
            [29.990408860204106, 0.582189058477476],
            [29.99067990797646, 0.583986192460865],
            [29.989454404706287, 0.586723792976026],
            [29.988569946833756, 0.587527675573285],
            [29.988398178171625, 0.590796382242059],
            [29.98565824468986, 0.596048903908087],
            [29.98589427074253, 0.59966010902093],
            [29.985570819748105, 0.600464290656838],
            [29.985240495743383, 0.600826649333602],
            [29.98254664673398, 0.596997008133612],
            [29.980719953146444, 0.595447174791165],
            [29.97906965095147, 0.597756648722743],
            [29.97886506323878, 0.598817601840373],
            [29.98047770715873, 0.603148345492464],
            [29.980171092389334, 0.60424347027084],
            [29.98083290012377, 0.606417322236276],
            [29.980134861537298, 0.608248126063907],
            [29.980372435387206, 0.609018391552564],
            [29.979079167703585, 0.611225361494612],
            [29.97970712332486, 0.613108259397923],
            [29.978975797665548, 0.613655488895475],
            [29.979110785706656, 0.615452535312614],
            [29.978549103295478, 0.616633077933167],
            [29.979119238853475, 0.618006057878733],
            [29.978760506526246, 0.618917713032256],
            [29.974483805324965, 0.617988302811697],
            [29.96968771439608, 0.616370870389751],
            [29.96674840163363, 0.6141564936884],
            [29.96547692977375, 0.612238855793458],
            [29.966897221933475, 0.610006896552687],
            [29.967396923284994, 0.608142664401559],
            [29.969713725115138, 0.605239631159677],
            [29.97026640640717, 0.60416425764043],
            [29.9702317655732, 0.602407284480095],
            [29.971229730971775, 0.601224590092437],
            [29.97258474794971, 0.598464417922436],
            [29.97146578666889, 0.592977787677119],
            [29.969935089764085, 0.591363410895642],
            [29.970362916909735, 0.590610667224016],
            [29.97018663690825, 0.587275944029491],
            [29.97139817496901, 0.586308489444704],
            [29.97134554087988, 0.584838355585651],
            [29.970527676017685, 0.582327973966123],
            [29.96917469192721, 0.581394977926124],
            [29.9680718410327, 0.578956160798066],
            [29.968464077825075, 0.578131682351378],
            [29.967930650124533, 0.576553725242985],
            [29.9681988879667, 0.574474213202179],
            [29.96933892731735, 0.57397283921542],
            [29.96987442832959, 0.571642474302339],
            [29.97076489593137, 0.571607094119089],
            [29.971976662164227, 0.570173490025045],
            [29.971871030168266, 0.567842777737752],
            [29.971301330293198, 0.567483913005749],
            [29.97033943943976, 0.567877821092418],
            [29.969663073607833, 0.567160339533349],
            [29.969610378433295, 0.565761919629332],
            [29.971285316924938, 0.564041706116504],
            [29.971570893150375, 0.562822744928496],
            [29.97313936331456, 0.560349484653947],
            [29.97442150087181, 0.560565292779198],
            [29.975702396059006, 0.563183478354103],
            [29.976913281942878, 0.563435109456147],
            [29.977484062491264, 0.561714300599816],
            [29.978089830623297, 0.561212628178305],
            [29.977307302789427, 0.559132544707405],
            [29.977592764030504, 0.558128713414015],
            [29.979267092566083, 0.557591736770458],
            [29.98101223619381, 0.55787949574267],
            [29.981137323003882, 0.557054858887969],
            [29.97964276981453, 0.55429313280632],
            [29.97900270041166, 0.552213125044276],
            [29.979752097479548, 0.54941670267306],
            [29.978561631200428, 0.543965908087529],
            [29.977351048947142, 0.543104739162365],
            [29.97539177300679, 0.54367744868749],
            [29.975036471345643, 0.541920306963498],
            [29.975429642385933, 0.539159564700862],
            [29.97530640071548, 0.536290993042595],
            [29.977373282250404, 0.534176496942446],
            [29.97979616882738, 0.53242073403141],
            [29.979939167145908, 0.531345109810672],
            [29.977553706180274, 0.529407679467321],
            [29.97710911108154, 0.528116628110266],
            [29.97700390758199, 0.524710215702201],
            [29.97768185714377, 0.522200596420512],
            [29.977540142517796, 0.520622843721699],
            [29.978181470460406, 0.520192877457302],
            [29.979107502364297, 0.520265039742658],
            [29.9797669996318, 0.519082093411096],
            [29.97939081393689, 0.51691661415587],
            [29.97289218108433, 0.509834634651177],
            [29.955958069307815, 0.48988718910108],
            [29.933985112168216, 0.461923142010025],
            [29.91913129916372, 0.443918397703603],
            [29.913181604323416, 0.43602902542165],
            [29.915681388485357, 0.424236305253211],
            [29.91697445045478, 0.42106900180742],
            [29.917869103307467, 0.420235727244834],
            [29.919194343828682, 0.419435960652291],
            [29.927525160771804, 0.418689003625425],
            [29.92984415538953, 0.417789589410354],
            [29.93236246550759, 0.41542302149106],
            [29.934136839416336, 0.409571497078224],
            [29.93486592467736, 0.408604748523543],
            [29.936555522776132, 0.407838434968187],
            [29.942584537059414, 0.406573604856555],
            [29.94583165036746, 0.404007180502268],
            [29.951778767941228, 0.400391350248999],
            [29.953037534928058, 0.40025843966217],
            [29.953832379562797, 0.400625555084442],
            [29.958037822802453, 0.404228586356295],
            [29.966091459174777, 0.40921499808028],
            [29.97414367081904, 0.415894045206782],
            [29.977895825064653, 0.420135636952535],
            [29.980157795526498, 0.422930608229206],
            [29.981713222152724, 0.425583958511519],
            [29.989548310992827, 0.441136513229784],
            [29.99213790063204, 0.449456385344581],
            [29.995409105857707, 0.462997366332771],
            [29.998596621336528, 0.472063421084101],
            [29.999878388787874, 0.473211413685833],
            [30.000733608294578, 0.47232253132824],
            [30.003040827795584, 0.474302864477941],
            [30.00823969455175, 0.477632710911817],
            [30.018070508474835, 0.482547238367774],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 314,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "401110",
        Population: 7758,
        Key: "BUNDIBUGYO401110",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.205987095686385, 0.836197276840958],
            [30.2038920474757, 0.838083425305429],
            [30.20282119996148, 0.837973023387457],
            [30.201713114583786, 0.839178148646479],
            [30.20076934185134, 0.83904956501114],
            [30.200479637867172, 0.838044419238923],
            [30.198517951746943, 0.839943242477056],
            [30.19414324524649, 0.840323771038864],
            [30.191801896052894, 0.840121084397762],
            [30.190168757069728, 0.83948039930594],
            [30.189714443097934, 0.840229196695692],
            [30.188952348343506, 0.839881486344098],
            [30.188371068286077, 0.840502291097282],
            [30.182034778971666, 0.842708501358409],
            [30.180837475614908, 0.841794062208837],
            [30.18005697258366, 0.841811762499227],
            [30.17829517329224, 0.843418342415895],
            [30.177134110668987, 0.842595287250112],
            [30.176899297341922, 0.841005520746571],
            [30.17584743033135, 0.839780581344171],
            [30.175703631613942, 0.837825459441739],
            [30.17520505495316, 0.836745333585873],
            [30.17475445282013, 0.832608346206939],
            [30.172480237422654, 0.82740855994913],
            [30.17258107870319, 0.825983483491825],
            [30.171810561344646, 0.824731357419737],
            [30.164828076117125, 0.81692461032709],
            [30.162091077431374, 0.811605804979433],
            [30.160658340011697, 0.809960402560856],
            [30.160025792202685, 0.808068695148931],
            [30.15842728327373, 0.807885072611345],
            [30.156619324949755, 0.806753378672132],
            [30.156904723308774, 0.804905840063414],
            [30.15919322102094, 0.802678398164289],
            [30.15866818717841, 0.800759583356278],
            [30.158895137551777, 0.797334773203525],
            [30.158761636222465, 0.796849671506791],
            [30.156113179982697, 0.794673589556388],
            [30.1542822032279, 0.791456644440352],
            [30.15225636392166, 0.789574623994714],
            [30.153848332217017, 0.788916696525674],
            [30.15617161898521, 0.788845218066063],
            [30.16140069877932, 0.790316296021938],
            [30.15927561090553, 0.788427130536542],
            [30.15675512416958, 0.784880837914687],
            [30.157827576074876, 0.782542898265321],
            [30.15788265627654, 0.781611119512091],
            [30.156849740125196, 0.779162114323378],
            [30.1567617501431, 0.775051102848164],
            [30.1562680684023, 0.774026684944436],
            [30.148665438404898, 0.777018842771774],
            [30.146473170022606, 0.778811093240436],
            [30.14450627367371, 0.781145179756959],
            [30.141803962534354, 0.782712160107508],
            [30.144719084564535, 0.788471875875489],
            [30.145650704887807, 0.792200194328992],
            [30.143830728901964, 0.791036620590442],
            [30.1387960139926, 0.790602774738374],
            [30.138226606069985, 0.789741698361915],
            [30.137561672198352, 0.789645605720639],
            [30.13680226520324, 0.788784398902501],
            [30.134664311657982, 0.789452325489005],
            [30.13390461091379, 0.789021458900787],
            [30.132764255356122, 0.7895466315553],
            [30.131624328294876, 0.789450206564405],
            [30.13057844675902, 0.790740486832519],
            [30.129010529957085, 0.791360987480132],
            [30.128867304364796, 0.792412819598723],
            [30.124878171852288, 0.791214648809193],
            [30.12307322917274, 0.791165568643554],
            [30.1210786880693, 0.790542578073793],
            [30.12003426719413, 0.789728995593922],
            [30.117612241203172, 0.789105708392811],
            [30.11500763263073, 0.789070410644886],
            [30.11406675606676, 0.789643524521798],
            [30.11386914467056, 0.786917960649805],
            [30.1141261140458, 0.786229611483677],
            [30.116435550588914, 0.784796786846401],
            [30.11680756001605, 0.782588011043948],
            [30.11629518163926, 0.781698303676367],
            [30.11649506936637, 0.781124667735563],
            [30.115289514085408, 0.779179858900877],
            [30.117410260401428, 0.776420344008128],
            [30.120233607847236, 0.773610781342343],
            [30.121414922988563, 0.773128778492966],
            [30.122358144155417, 0.771647048654343],
            [30.12278714360251, 0.769409606912718],
            [30.12242390352917, 0.766072636484809],
            [30.123838086246675, 0.766577292717417],
            [30.127139294304506, 0.766555625495499],
            [30.13162860337733, 0.765626271158845],
            [30.13293552365664, 0.764599126643232],
            [30.13326895852714, 0.76318880088272],
            [30.134091759631858, 0.762274656542248],
            [30.134731144518472, 0.770334654292518],
            [30.135385656136183, 0.771804778509606],
            [30.136519601315957, 0.772776370036764],
            [30.139588060375257, 0.769948037254679],
            [30.142299192072382, 0.770339792191535],
            [30.142983164838135, 0.772319837406801],
            [30.147632510575463, 0.770493374050331],
            [30.149123757066228, 0.76830483518383],
            [30.15354898930982, 0.767467988622927],
            [30.155903598535346, 0.766359793218953],
            [30.159093072341495, 0.764382324973301],
            [30.15939148639066, 0.76369265982131],
            [30.159064540949753, 0.762462684234705],
            [30.1605254109092, 0.761143917667103],
            [30.161496257067665, 0.757365301162917],
            [30.162510123545093, 0.756136211232867],
            [30.16309364220422, 0.752297341961266],
            [30.162856595665346, 0.7502575816538],
            [30.16384195410725, 0.747018853026577],
            [30.16590014983171, 0.743480873481293],
            [30.166721647480934, 0.743864492758382],
            [30.168356822046526, 0.745822024936384],
            [30.169695911894458, 0.748522387973425],
            [30.173030509433104, 0.752513824463908],
            [30.17511108488622, 0.754299260368611],
            [30.175151258444046, 0.757380387948226],
            [30.174245718908406, 0.761119136233515],
            [30.174483668254133, 0.762045553415404],
            [30.175369303818023, 0.762697954625606],
            [30.177516034801954, 0.763111050507328],
            [30.179662343577675, 0.764175962584101],
            [30.182471631490987, 0.767642749161937],
            [30.18677011054967, 0.771007869015355],
            [30.189319913804926, 0.77028889645108],
            [30.19189298701934, 0.770221998669243],
            [30.19306863199461, 0.770394313204134],
            [30.19385195124426, 0.771183884242152],
            [30.194430339624766, 0.772659450563227],
            [30.193270080993706, 0.77499151675882],
            [30.192842491003297, 0.777392683603077],
            [30.191681970962453, 0.780102111544174],
            [30.193297472423335, 0.785043334186755],
            [30.194659595075183, 0.786656665371638],
            [30.195270731539374, 0.790087735148599],
            [30.196887735881702, 0.792764753037916],
            [30.196136159500956, 0.795440149690154],
            [30.195522134953094, 0.796297392140084],
            [30.194328885693203, 0.796948394891749],
            [30.193680475432917, 0.798251595627885],
            [30.191567319881067, 0.798524588696578],
            [30.18866983447487, 0.799517470093919],
            [30.187851421640307, 0.800237336757045],
            [30.187833466114423, 0.8015752700041],
            [30.18926433503831, 0.80229669742466],
            [30.18963865044079, 0.803120309721569],
            [30.189704145709836, 0.806996975823426],
            [30.192462746183224, 0.809743418214725],
            [30.19329636030903, 0.811699471898124],
            [30.191590371549587, 0.814545707436526],
            [30.19186193944649, 0.816089688599224],
            [30.19402398131611, 0.819041572778414],
            [30.19709076232244, 0.819695568358605],
            [30.198555407901022, 0.820863028605191],
            [30.201414521769866, 0.826079674078164],
            [30.202042429780434, 0.829750942488695],
            [30.204153641377992, 0.83229115401863],
            [30.204901694566225, 0.834727473099456],
            [30.205987095686385, 0.836197276840958],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 315,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "KASITU",
        Population: 8195,
        Key: "BUNDIBUGYOKASITU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.99202781389061, 0.658774647929787],
            [29.99157003511677, 0.657049897482851],
            [29.99219483405811, 0.655345874608053],
            [29.993151553310426, 0.654163219151257],
            [29.99231252503844, 0.652914768788702],
            [29.99271316018042, 0.651667069957445],
            [29.986734860286504, 0.651522558340118],
            [29.98277742932036, 0.65186148783966],
            [29.984228590288215, 0.653581348166296],
            [29.984256241330975, 0.654986944762432],
            [29.98270158905251, 0.657754128510839],
            [29.98187295428834, 0.661511391293581],
            [29.982727338361816, 0.662286420374767],
            [29.98261281753614, 0.66317559330771],
            [29.983381452025835, 0.664380849411869],
            [29.983437340711255, 0.666188058876603],
            [29.984633859838745, 0.666647765778712],
            [29.986143161568446, 0.668197711722079],
            [29.984971408094967, 0.67212821630129],
            [29.984056076024423, 0.672888441393327],
            [29.984878882519023, 0.673773812796953],
            [29.983745796128673, 0.674306193050803],
            [29.984628706203967, 0.675023881035263],
            [29.984742279307035, 0.6756837151448],
            [29.986480973031004, 0.674910300542525],
            [29.986901093529823, 0.676420979444849],
            [29.98543904228579, 0.676781243431524],
            [29.984517432788035, 0.67806643436036],
            [29.983894049591587, 0.677438105882932],
            [29.98312153437986, 0.677796438551304],
            [29.98220119240498, 0.677048320874544],
            [29.982200355175113, 0.678393889558929],
            [29.98312086513495, 0.678872896955411],
            [29.983090900930335, 0.679291497745954],
            [29.983862838525333, 0.679860116474805],
            [29.983862595980213, 0.680248836828006],
            [29.9825855321077, 0.679949014682353],
            [29.98393489059766, 0.683388551615842],
            [29.982419880074342, 0.683596900122189],
            [29.98149860115662, 0.684343851751234],
            [29.97980580415715, 0.683864349962262],
            [29.979430073009777, 0.684317648865201],
            [29.979405832870132, 0.683064160692121],
            [29.977610050311515, 0.681839065927678],
            [29.97695765332801, 0.680413752294315],
            [29.97748500931557, 0.678660363287526],
            [29.977086266025555, 0.677874590104947],
            [29.977994272334957, 0.676815621355524],
            [29.977141844792204, 0.676047830893975],
            [29.976180046465274, 0.676065491441298],
            [29.97645313520993, 0.674640765361694],
            [29.975509643650177, 0.674402689682794],
            [29.974893046327363, 0.673762925070251],
            [29.975274695575816, 0.672849768892329],
            [29.97451292331658, 0.672209915148917],
            [29.97540242522944, 0.671717238371581],
            [29.97545736259897, 0.670913484621536],
            [29.97422516508329, 0.668008119001824],
            [29.974589054638592, 0.666455574348425],
            [29.973282706586136, 0.666089405373515],
            [29.974173120289016, 0.664098757844608],
            [29.973756077418358, 0.663550462098792],
            [29.97203226518537, 0.663330181213323],
            [29.971814772275277, 0.662891618030678],
            [29.971942323164182, 0.662033107890367],
            [29.97277772134409, 0.660974088112412],
            [29.97305173086194, 0.657996592974917],
            [29.974134540342504, 0.656957685193516],
            [29.97257315878422, 0.654160047406708],
            [29.973046019373395, 0.652424888164105],
            [29.97202974541098, 0.652515608531856],
            [29.970747783923528, 0.649609298871284],
            [29.96928475890574, 0.653002599455074],
            [29.966809708956813, 0.650871325416254],
            [29.96459415624235, 0.652483672799577],
            [29.962678960633035, 0.654509968695359],
            [29.96079606125478, 0.654006702404011],
            [29.957734858786363, 0.655036520441526],
            [29.95670295503635, 0.653350666822155],
            [29.957701234845274, 0.651737768186627],
            [29.957630603009427, 0.650733763593204],
            [29.95601261052029, 0.64635837890609],
            [29.955053983246312, 0.641230433583295],
            [29.955607124475755, 0.639437981634343],
            [29.95503927153691, 0.635995494976404],
            [29.9556457655077, 0.634310638409626],
            [29.955432985159614, 0.632732861134084],
            [29.95833797868499, 0.629077292596797],
            [29.959621766447405, 0.626424718694978],
            [29.959658256014244, 0.624918794592275],
            [29.96095924202279, 0.623306040642318],
            [29.96163740628191, 0.620832379764016],
            [29.96306344137124, 0.618538426909705],
            [29.963313176613486, 0.617821452247545],
            [29.96238833587568, 0.615669562047796],
            [29.964133881050344, 0.61520443853248],
            [29.96525674551109, 0.61362742084766],
            [29.96547692977375, 0.612238855793458],
            [29.96674840163363, 0.6141564936884],
            [29.96968771439608, 0.616370870389751],
            [29.974483805324965, 0.617988302811697],
            [29.978760506526246, 0.618917713032256],
            [29.978343402570154, 0.621130179840307],
            [29.979040947083213, 0.621967824824357],
            [29.978713494094144, 0.623223495741678],
            [29.979544733972624, 0.624001416748979],
            [29.97966305646858, 0.624857266349786],
            [29.978858930440325, 0.62857594159177],
            [29.97713551166943, 0.629681286046654],
            [29.977430894802854, 0.632522094182428],
            [29.97874521989504, 0.634086099395644],
            [29.981009250193832, 0.63401927781343],
            [29.983176853533347, 0.635276422572485],
            [29.987720939177247, 0.636176157504049],
            [29.991662613693304, 0.636107429841326],
            [29.993629220784662, 0.635913099387796],
            [29.998582321055533, 0.63341432822034],
            [30.001114926962995, 0.632877075060146],
            [30.00115937200999, 0.63323670530951],
            [30.001749647796682, 0.633159720797829],
            [30.000982491933936, 0.633841407901756],
            [30.000853281856728, 0.635533792938707],
            [30.001593683195352, 0.636366116116833],
            [30.00142090752181, 0.639464079661177],
            [30.000537411744936, 0.639693043266182],
            [29.999551070546136, 0.645228806614448],
            [30.00037647676517, 0.646864387443631],
            [30.000118490497012, 0.649445950733691],
            [29.998065756529503, 0.651223230285757],
            [29.997537565108747, 0.65294405286374],
            [29.996711177929416, 0.652972238370302],
            [29.996596905038746, 0.653459825691832],
            [29.9960557302672, 0.653057900643438],
            [29.995286249564504, 0.653229548557733],
            [29.994543771320924, 0.655896859739429],
            [29.994059091597574, 0.656326848783412],
            [29.99414414768195, 0.657044039954052],
            [29.992803912482017, 0.658620930292385],
            [29.99202781389061, 0.658774647929787],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 316,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "BUBANDI",
        Population: 17057,
        Key: "BUNDIBUGYOBUBANDI",
        Dist2: "Bundibugyo",
        "Sub Country": "Bubandi",
        id2_original: "Bundibugyo Bubandi",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.027049259571125, 0.855321440236081],
            [30.020393904837476, 0.855850370382712],
            [30.019067443505772, 0.856712876812894],
            [30.017039521904692, 0.857025299283824],
            [30.014622460004027, 0.856316859247696],
            [30.013531369853183, 0.855373951692189],
            [30.01322063810482, 0.853803626924176],
            [30.014001482495868, 0.852548174682867],
            [30.013848416758005, 0.848779860087421],
            [30.01158806146704, 0.847129513168116],
            [30.010417713857017, 0.847835135390777],
            [30.010338456397808, 0.849483653240232],
            [30.0112727222596, 0.851525483957114],
            [30.01158333363372, 0.853252813267276],
            [30.01095876825432, 0.854115865497786],
            [30.00994475355487, 0.854350579074099],
            [30.007761912991484, 0.853328314581509],
            [30.005889986534427, 0.853640856790572],
            [30.005032316423648, 0.853404670995536],
            [30.004253244408677, 0.85238351375175],
            [30.004254339455002, 0.850970453747499],
            [30.003553069628442, 0.850184870180248],
            [30.001135431907674, 0.850261475462488],
            [30.000278069919034, 0.849632778742301],
            [30.001332218650436, 0.847906536450759],
            [30.001411599178848, 0.846101025710248],
            [30.000632403196345, 0.845236882151398],
            [29.996654753848098, 0.845704792381342],
            [29.99376806708994, 0.847272585676108],
            [29.991818183934203, 0.847585065500346],
            [29.9896354421855, 0.846484318382823],
            [29.98815378251546, 0.846404653697804],
            [29.987217047184945, 0.847581450176947],
            [29.986125071295227, 0.847816097682783],
            [29.985501860575315, 0.846952085645818],
            [29.987297282011163, 0.844676934196473],
            [29.988236433809803, 0.84036004829433],
            [29.990265796308563, 0.83808506096258],
            [29.990266818591355, 0.836750520803438],
            [29.989409341618387, 0.836278842367051],
            [29.987303385165212, 0.836748221361534],
            [29.985742601884922, 0.838160046994025],
            [29.984650873031914, 0.838080695617328],
            [29.984808348599557, 0.836118269442663],
            [29.98387235078589, 0.836353047880262],
            [29.983638516622506, 0.836195862145039],
            [29.983950816829328, 0.835725093538595],
            [29.983092985021806, 0.835724427059554],
            [29.9839515381765, 0.834783071117687],
            [29.983328081318184, 0.834233073943692],
            [29.98356257484501, 0.833526739668977],
            [29.982705463486326, 0.832584053835156],
            [29.98301794066128, 0.831877779445609],
            [29.98247216921042, 0.831720353706766],
            [29.98294097300774, 0.830543188677087],
            [29.982006054969048, 0.829364940940267],
            [29.979666344302526, 0.829598641016593],
            [29.979043008716786, 0.828891646618219],
            [29.978498432025233, 0.827164193361327],
            [29.977680194362176, 0.82637854842788],
            [29.97822650031064, 0.825829458187091],
            [29.97822709499535, 0.825044443541693],
            [29.97643441342112, 0.823787045506671],
            [29.97635696427057, 0.823080474035025],
            [29.9770595321627, 0.822138995623874],
            [29.976591627578976, 0.822138637232964],
            [29.976358150945067, 0.821510447099319],
            [29.97503313590099, 0.820567418883122],
            [29.97503461452794, 0.818604888823999],
            [29.973554400247167, 0.816641230533176],
            [29.97371107451757, 0.815699335629139],
            [29.972930708928573, 0.816405252699567],
            [29.97230707600043, 0.816090773654009],
            [29.97215163960853, 0.815384146032952],
            [29.971138443274295, 0.814598365847902],
            [29.971450906076203, 0.813892093661978],
            [29.971139502388013, 0.813185348886125],
            [29.97020381988303, 0.813027636774475],
            [29.97082797922391, 0.812635606521897],
            [29.970594675964833, 0.81177191914438],
            [29.971263222860525, 0.811476177613265],
            [29.990426105162587, 0.783711772142396],
            [30.012501173800516, 0.750088168523275],
            [30.012725563077026, 0.749000409884724],
            [30.015268203166233, 0.74584885623881],
            [30.01667575631692, 0.743416557725024],
            [30.01670185866415, 0.741281262767656],
            [30.014670528854882, 0.736003681348316],
            [30.011170704186032, 0.732103142822106],
            [30.011160835294323, 0.728391187858637],
            [30.01440567316975, 0.726270469594389],
            [30.017933615106983, 0.724981704320953],
            [30.022429030028782, 0.722523921157638],
            [30.030846450853513, 0.721677018144183],
            [30.031210720396153, 0.721277634580027],
            [30.030140485532957, 0.719843566082794],
            [30.031719993297042, 0.717379496023931],
            [30.034987056390932, 0.714141282592531],
            [30.042016020451243, 0.714158007923863],
            [30.042678909757278, 0.713181387702014],
            [30.046073015293583, 0.710419954151883],
            [30.050468656133425, 0.71071311296875],
            [30.04900613866373, 0.712288797276444],
            [30.050777291213898, 0.714419621020971],
            [30.050711702520054, 0.715323167828841],
            [30.054876454772316, 0.716786145963172],
            [30.058242916452375, 0.720394351543196],
            [30.061383631501542, 0.721512527203923],
            [30.0619839154188, 0.722340564431539],
            [30.061280804944218, 0.724657908233361],
            [30.059836166643656, 0.724521673445823],
            [30.058525221013554, 0.725467826421842],
            [30.058003480394852, 0.726955647594965],
            [30.058707413726204, 0.729458934211994],
            [30.059646464913534, 0.732063846533033],
            [30.059091361763496, 0.733179602136222],
            [30.059594381491653, 0.7346342810378],
            [30.05660257567558, 0.736999820812643],
            [30.056805677574804, 0.738259635030597],
            [30.05566339153761, 0.745040245092862],
            [30.0546094610968, 0.747012609367758],
            [30.05332040561357, 0.747779043349401],
            [30.05382799956318, 0.748619771411217],
            [30.05375522255043, 0.748893761124747],
            [30.053247333953404, 0.748491493055764],
            [30.052956824180402, 0.748692256571452],
            [30.05348263955724, 0.749423383201377],
            [30.053355293484245, 0.749880026043538],
            [30.051994022435313, 0.750080060126091],
            [30.053227443456375, 0.751085706959344],
            [30.05319058019038, 0.751926066108593],
            [30.05224673649104, 0.752108113782042],
            [30.052517521057034, 0.754245794581227],
            [30.051101977391866, 0.754190018526447],
            [30.05079288506891, 0.755030187549135],
            [30.050030427395086, 0.755358509433596],
            [30.049575514247024, 0.757130305342021],
            [30.049176570632717, 0.756655032927041],
            [30.048722773192218, 0.756782605028197],
            [30.04824993236601, 0.758225540668517],
            [30.047215386670732, 0.758352711211675],
            [30.045799126149983, 0.759356534508774],
            [30.045091413606205, 0.759246430487043],
            [30.04461906865003, 0.759958598067403],
            [30.043675329155253, 0.759994483504339],
            [30.043220883131145, 0.761072041718491],
            [30.04247697566795, 0.760815759700299],
            [30.041496327093093, 0.761746799269303],
            [30.041132246196643, 0.763372489159265],
            [30.04018755269104, 0.764796812957759],
            [30.039026576306036, 0.764046975980668],
            [30.03853601800748, 0.764850469040497],
            [30.038735347880827, 0.765289062018404],
            [30.037065087815172, 0.766183075373566],
            [30.036992041307858, 0.766840705478319],
            [30.035630869971904, 0.766912828345036],
            [30.035339790667013, 0.767935683235697],
            [30.03484983783297, 0.767862264233688],
            [30.03468603632909, 0.768538098598389],
            [30.033870187286382, 0.767350048609175],
            [30.03359788726251, 0.767459470663321],
            [30.033179655920726, 0.768646654724077],
            [30.034121620344514, 0.770277135871936],
            [30.033863104070367, 0.770974000205857],
            [30.033340587307276, 0.771033025853574],
            [30.032859882629047, 0.770196255279362],
            [30.0322209612731, 0.771007511518247],
            [30.03087106020073, 0.769644837399897],
            [30.030785637603707, 0.770646716973377],
            [30.030310380309412, 0.771086241723383],
            [30.02841100133726, 0.77047292305721],
            [30.026149972309877, 0.770853814704001],
            [30.025943701154326, 0.773779683351339],
            [30.025171739304813, 0.774018189453759],
            [30.024149501427267, 0.775583261910838],
            [30.02343725328961, 0.775331749482135],
            [30.02331762643987, 0.776598645910977],
            [30.02208222104032, 0.777362733833423],
            [30.021807887230654, 0.779119574943359],
            [30.02098847457119, 0.779298278241956],
            [30.020786292546827, 0.77976428646731],
            [30.021913442869796, 0.780972307857881],
            [30.02117646860397, 0.782107279319382],
            [30.02098564218311, 0.783302404128766],
            [30.02010671613608, 0.783684255726213],
            [30.019215218166632, 0.786405991654776],
            [30.02091437613668, 0.788032775108414],
            [30.020210856928653, 0.788864167129155],
            [30.019991641948195, 0.789896714884008],
            [30.021092977384836, 0.790662480070422],
            [30.020645949648294, 0.791465372537187],
            [30.02094894420712, 0.792823409207037],
            [30.021642013313446, 0.793321143173738],
            [30.0212997201559, 0.793779875076045],
            [30.021973922844612, 0.79409591516799],
            [30.021783474614466, 0.794746000277062],
            [30.022476944369433, 0.794689131610688],
            [30.021896753968452, 0.795730979071572],
            [30.021838897972554, 0.796926198770003],
            [30.022283902703066, 0.798934567799863],
            [30.02159977902034, 0.799201804978852],
            [30.022093043044556, 0.800148815521163],
            [30.02257621180159, 0.800119526112626],
            [30.022468273830317, 0.801601574592689],
            [30.022871115234626, 0.8027971348072],
            [30.022633386874446, 0.803143586376913],
            [30.02183792060555, 0.803035427265834],
            [30.022121866388755, 0.804446045903116],
            [30.021266038722626, 0.805700440915627],
            [30.021715758710062, 0.807732719109775],
            [30.02099056495087, 0.808951349352791],
            [30.02019467108385, 0.809428863199387],
            [30.02192750060567, 0.810446123374251],
            [30.02200967758955, 0.811725116225797],
            [30.021534436464904, 0.812119198112713],
            [30.022079980641994, 0.813004100588807],
            [30.02285149782545, 0.813387159336645],
            [30.0231350169089, 0.815359557142114],
            [30.023858703295062, 0.816196782966477],
            [30.024939250817706, 0.816161734260418],
            [30.024011818440265, 0.817882222063414],
            [30.024450275350667, 0.819065864334722],
            [30.025376330610754, 0.819209990579708],
            [30.02528068518583, 0.820094416335694],
            [30.025600986686904, 0.820489094721043],
            [30.02557664413936, 0.821289905514613],
            [30.02511315567357, 0.821839379023943],
            [30.023546052745235, 0.821503525393257],
            [30.02226303663566, 0.822363148017169],
            [30.021537396413773, 0.824155494536186],
            [30.021440574195815, 0.826605709625555],
            [30.021772398387025, 0.827466550034554],
            [30.022733581368012, 0.828268105846854],
            [30.022922424308707, 0.829786235391431],
            [30.023889129233723, 0.831086787441015],
            [30.025010990276307, 0.831437290241054],
            [30.026815960803635, 0.831259374273106],
            [30.0284890541557, 0.832766688095131],
            [30.028203008111344, 0.834188841994542],
            [30.028935935466812, 0.838504328098168],
            [30.028494468301908, 0.841312873145445],
            [30.028789626856486, 0.843536303582007],
            [30.028432149475698, 0.845185499616837],
            [30.02856127421295, 0.847133890180014],
            [30.027049259571125, 0.855321440236081],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 317,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "401210",
        Population: 11767,
        Key: "BUNDIBUGYO401210",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.080044464255945, 0.704313902196264],
            [30.080007141052537, 0.705898618757805],
            [30.079427645049247, 0.706685899944354],
            [30.079636217688567, 0.708029205616186],
            [30.079016090884988, 0.712246987524098],
            [30.079007345785712, 0.715916481250992],
            [30.07834227716678, 0.717843732304722],
            [30.075086937985677, 0.719897576619252],
            [30.07290751281699, 0.722128844747541],
            [30.06996763681086, 0.722126928793249],
            [30.06761392859559, 0.724932636878243],
            [30.065395861496622, 0.725810559214858],
            [30.06465597129938, 0.726926204986462],
            [30.06166505661206, 0.72793889659042],
            [30.06032002261187, 0.729629110738012],
            [30.059010108247733, 0.728985627767728],
            [30.058707413726204, 0.729458934211994],
            [30.058003480394852, 0.726955647594965],
            [30.058525221013554, 0.725467826421842],
            [30.059836166643656, 0.724521673445823],
            [30.061280804944218, 0.724657908233361],
            [30.0619839154188, 0.722340564431539],
            [30.061383631501542, 0.721512527203923],
            [30.058242916452375, 0.720394351543196],
            [30.054876454772316, 0.716786145963172],
            [30.050711702520054, 0.715323167828841],
            [30.050777291213898, 0.714419621020971],
            [30.04900613866373, 0.712288797276444],
            [30.050468656133425, 0.71071311296875],
            [30.05186214526002, 0.709419646380252],
            [30.054124300774806, 0.709134231264316],
            [30.05604866728488, 0.707880405659161],
            [30.05547987740316, 0.706051230040695],
            [30.05551703801153, 0.703612843391589],
            [30.05647943192147, 0.702645262709025],
            [30.05922569313612, 0.697232286688298],
            [30.06122084599228, 0.696695658469572],
            [30.06282471966011, 0.695262301863781],
            [30.063039029839118, 0.694330096112312],
            [30.06455395592077, 0.69271737989909],
            [30.064412641045106, 0.69081674977115],
            [30.06601780828695, 0.687267679200271],
            [30.06637540963527, 0.685008761501986],
            [30.06715939723149, 0.684507215797384],
            [30.067480518894413, 0.683646789001792],
            [30.06723134150597, 0.683359759065798],
            [30.06773030983222, 0.68292975532619],
            [30.067909030556322, 0.681925802905232],
            [30.068300783156758, 0.682069481849095],
            [30.0686218167848, 0.681352491054427],
            [30.07022799732627, 0.681878568341479],
            [30.07561783782702, 0.686312625768723],
            [30.077564274146987, 0.690034305698458],
            [30.077492427788865, 0.690651664893872],
            [30.07638657921624, 0.692874662508484],
            [30.07633532583771, 0.694261352192794],
            [30.077341903384923, 0.69649426837298],
            [30.07705539201327, 0.697527072164449],
            [30.077468149920005, 0.699047529434942],
            [30.080044464255945, 0.704313902196264],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 318,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "BUNDIBUGYO TOWN COUNCIL",
        Population: 18952,
        Key: "BUNDIBUGYOBUNDIBUGYO TOWN COUNCIL",
        Dist2: "Bundibugyo",
        "Sub Country": "Bundibugyo  TC",
        id2_original: "Bundibugyo Bundibugyo  TC",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.050468656133425, 0.71071311296875],
            [30.046073015293583, 0.710419954151883],
            [30.042678909757278, 0.713181387702014],
            [30.042016020451243, 0.714158007923863],
            [30.034987056390932, 0.714141282592531],
            [30.031719993297042, 0.717379496023931],
            [30.030140485532957, 0.719843566082794],
            [30.029380218850157, 0.71707874476765],
            [30.02877515050569, 0.716325327397623],
            [30.0268167234733, 0.715212442928905],
            [30.026710995357618, 0.713455328377906],
            [30.02888548069057, 0.710946681220947],
            [30.029046603418234, 0.709655893268518],
            [30.02609184592109, 0.706892903645436],
            [30.02534532166548, 0.704525790672106],
            [30.024668939663876, 0.703879911243404],
            [30.023457862438853, 0.703843270829583],
            [30.021961156886093, 0.704846325744856],
            [30.021961466804893, 0.704360099958777],
            [30.020761781115997, 0.703112947046016],
            [30.015383988819817, 0.700530775385833],
            [30.01354055961856, 0.699139509174502],
            [30.013969047924235, 0.697490332893617],
            [30.014503464669914, 0.69731138737271],
            [30.01667148303113, 0.692320044547994],
            [30.016719186267657, 0.690468930295563],
            [30.01607956063252, 0.688006294491669],
            [30.015367723024973, 0.687097449020074],
            [30.01323122744541, 0.685948655413287],
            [30.01183036225201, 0.685637005454457],
            [30.008838069549014, 0.685969784071089],
            [30.004375015537022, 0.684353295066176],
            [30.003182466064732, 0.683111221881714],
            [30.002268857861228, 0.681068475514686],
            [30.00250836578395, 0.679707180977507],
            [30.003822478873754, 0.677345490660368],
            [30.00560764424401, 0.675975526936437],
            [30.00864996592179, 0.674984209693932],
            [30.00962618400567, 0.674974021708985],
            [30.011050577873004, 0.675634685810898],
            [30.012247533581757, 0.675434628733347],
            [30.014671366084706, 0.672710953717122],
            [30.01638156973947, 0.671994857097293],
            [30.01766454183162, 0.67093426033127],
            [30.018832954470533, 0.670820235107726],
            [30.020315226791627, 0.670046619423816],
            [30.023394722552496, 0.666907356824951],
            [30.025317407416342, 0.668256794391421],
            [30.03475274791704, 0.669772228912115],
            [30.035185736782314, 0.66609387419004],
            [30.036261051618425, 0.66556925037128],
            [30.037614669021153, 0.665522260872491],
            [30.040489112640337, 0.663802798102391],
            [30.043680092921225, 0.662905746686077],
            [30.04556896609608, 0.661293247267194],
            [30.04691521821181, 0.660832049661417],
            [30.050304095553138, 0.665455719961563],
            [30.052829917383587, 0.670943660556183],
            [30.057422896531776, 0.674568222447893],
            [30.06271140257691, 0.676723007917571],
            [30.063031324988913, 0.677834840638974],
            [30.065131964313935, 0.679557375883926],
            [30.0686218167848, 0.681352491054427],
            [30.068300783156758, 0.682069481849095],
            [30.067909030556322, 0.681925802905232],
            [30.06773030983222, 0.68292975532619],
            [30.06723134150597, 0.683359759065798],
            [30.067480518894413, 0.683646789001792],
            [30.06715939723149, 0.684507215797384],
            [30.06637540963527, 0.685008761501986],
            [30.06601780828695, 0.687267679200271],
            [30.064412641045106, 0.69081674977115],
            [30.06455395592077, 0.69271737989909],
            [30.063039029839118, 0.694330096112312],
            [30.06282471966011, 0.695262301863781],
            [30.06122084599228, 0.696695658469572],
            [30.05922569313612, 0.697232286688298],
            [30.05647943192147, 0.702645262709025],
            [30.05551703801153, 0.703612843391589],
            [30.05547987740316, 0.706051230040695],
            [30.05604866728488, 0.707880405659161],
            [30.054124300774806, 0.709134231264316],
            [30.05186214526002, 0.709419646380252],
            [30.050468656133425, 0.71071311296875],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 319,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "BUSARU",
        Population: 14840,
        Key: "BUNDIBUGYOBUSARU",
        Dist2: "Bundibugyo",
        "Sub Country": "Busaru",
        id2_original: "Bundibugyo Busaru",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.10088648287702, 0.760756090774812],
            [30.0991923087602, 0.760712744595117],
            [30.098715256631934, 0.761222293250274],
            [30.097523644102488, 0.76098154174238],
            [30.09618265880928, 0.761340537934303],
            [30.092250847795057, 0.759808251278611],
            [30.080095004372144, 0.765515678657549],
            [30.078979956152676, 0.761197845960899],
            [30.078615279673215, 0.755898375119702],
            [30.074770213576077, 0.750381514280924],
            [30.073278121770613, 0.74627826664033],
            [30.073245308109936, 0.745094461022467],
            [30.07091303369732, 0.740797459843341],
            [30.067624276289322, 0.739432297110199],
            [30.058885158879928, 0.739139577595766],
            [30.056805677574804, 0.738259635030597],
            [30.05660257567558, 0.736999820812643],
            [30.059594381491653, 0.7346342810378],
            [30.059091361763496, 0.733179602136222],
            [30.059646464913534, 0.732063846533033],
            [30.058707413726204, 0.729458934211994],
            [30.059010108247733, 0.728985627767728],
            [30.06032002261187, 0.729629110738012],
            [30.06166505661206, 0.72793889659042],
            [30.06465597129938, 0.726926204986462],
            [30.065395861496622, 0.725810559214858],
            [30.06761392859559, 0.724932636878243],
            [30.06996763681086, 0.722126928793249],
            [30.07290751281699, 0.722128844747541],
            [30.075086937985677, 0.719897576619252],
            [30.07834227716678, 0.717843732304722],
            [30.079007345785712, 0.715916481250992],
            [30.079016090884988, 0.712246987524098],
            [30.079636217688567, 0.708029205616186],
            [30.079427645049247, 0.706685899944354],
            [30.080007141052537, 0.705898618757805],
            [30.080044464255945, 0.704313902196264],
            [30.083209503886383, 0.708231270697214],
            [30.08406342353085, 0.709857463344845],
            [30.086824154808085, 0.712690417358487],
            [30.08821924563083, 0.714758514645613],
            [30.091766642382172, 0.717836634374434],
            [30.09518602291731, 0.718508224103418],
            [30.096799659475653, 0.72051743975158],
            [30.099031617223844, 0.721188271866141],
            [30.100835216922064, 0.723245432785153],
            [30.104160423472685, 0.722673811107873],
            [30.106915997521913, 0.721575859697302],
            [30.108625984682675, 0.721481330289391],
            [30.11022578449069, 0.722541321039399],
            [30.111281393882745, 0.724936576573714],
            [30.111803970832984, 0.728368646458167],
            [30.113323117199833, 0.729612806739331],
            [30.11447468373224, 0.731245929785526],
            [30.11269411773623, 0.733656972681651],
            [30.113405506186123, 0.735342896471178],
            [30.113105861445007, 0.736694156586642],
            [30.111553162103966, 0.738152378800401],
            [30.10875985252463, 0.745084351338824],
            [30.106157949677808, 0.747700649559325],
            [30.105649347818456, 0.750879533465086],
            [30.106125464800503, 0.751779632664497],
            [30.105737223714485, 0.753159034920244],
            [30.10469366162874, 0.754298054035722],
            [30.104543691485308, 0.755797585729106],
            [30.101933795429115, 0.760114756439428],
            [30.10088648287702, 0.760756090774812],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 320,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "KIRUMYA",
        Population: 11166,
        Key: "BUNDIBUGYOKIRUMYA",
        Dist2: "Bundibugyo",
        "Sub Country": "Kirumya",
        id2_original: "Bundibugyo Kirumya",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.971263222860525, 0.811476177613265],
            [29.970284032251357, 0.810044662401892],
            [29.970051135030804, 0.808631471389836],
            [29.970754385642557, 0.806747979434248],
            [29.97020914509602, 0.805884058162435],
            [29.970054166844903, 0.804549426410701],
            [29.970483481600645, 0.804000242472349],
            [29.970015583305106, 0.803999891265631],
            [29.969938006593832, 0.803450327303382],
            [29.970250635584062, 0.802508549697539],
            [29.96954896151561, 0.802272522537294],
            [29.969549715202138, 0.801252011432583],
            [29.970251678528093, 0.801095534819189],
            [29.970096696683687, 0.799760903300849],
            [29.969473641372307, 0.798661426550777],
            [29.968615366695346, 0.799288792960152],
            [29.967836289290453, 0.79826770175595],
            [29.968148278680218, 0.798189433751606],
            [29.967915194610075, 0.797011748735823],
            [29.967213464846097, 0.796854225524812],
            [29.967213925681843, 0.796226220103783],
            [29.968851507732417, 0.796305937886301],
            [29.96955433254272, 0.794971945251059],
            [29.96869726789645, 0.793950799083431],
            [29.967605738469427, 0.793635987757801],
            [29.967841292008295, 0.791438140910971],
            [29.96737351049374, 0.791280794438808],
            [29.966904984275867, 0.792143955286473],
            [29.965736505161605, 0.790416077677524],
            [29.966985369120735, 0.788846985782996],
            [29.96745332311179, 0.788768829879141],
            [29.967220799590397, 0.786806141722306],
            [29.966675206904263, 0.786413236783364],
            [29.966128987194086, 0.786883839565362],
            [29.965271350320965, 0.786647706419452],
            [29.96503791590788, 0.785941031504627],
            [29.96652043616398, 0.784764609516577],
            [29.965585440870175, 0.783664915909024],
            [29.96605350535401, 0.783429757162281],
            [29.965040301833277, 0.782644010387562],
            [29.965898617832735, 0.781938132426449],
            [29.96437943193998, 0.779896008608854],
            [29.962975413659933, 0.780365987851586],
            [29.963209755371487, 0.779816655194523],
            [29.962274535498842, 0.779030969722188],
            [29.962041830517773, 0.77730379360589],
            [29.962354321167446, 0.776519016677133],
            [29.96180934652225, 0.775262616975901],
            [29.962121837171928, 0.774477839668519],
            [29.963290780715155, 0.775577692866328],
            [29.963914862800912, 0.775264143972104],
            [29.96360344024812, 0.774557414148548],
            [29.964773451888227, 0.774165759304308],
            [29.964228753025804, 0.772516855078187],
            [29.96524313693286, 0.77165408182512],
            [29.964229592052295, 0.77133934787052],
            [29.96469804371001, 0.770554680320979],
            [29.96384102128457, 0.769455056669239],
            [29.9641537850221, 0.768277774970562],
            [29.963842469368792, 0.76741404693438],
            [29.964778420470072, 0.767179216038805],
            [29.965481035972918, 0.766080712515575],
            [29.9660265217595, 0.766630607448598],
            [29.965637887211415, 0.764824814543573],
            [29.966730023899544, 0.764276091576151],
            [29.966808282432154, 0.76388364354466],
            [29.966575275617117, 0.762548966064745],
            [29.965483913276756, 0.761998684367733],
            [29.965251510129605, 0.759800503092283],
            [29.966967829514804, 0.758781213163782],
            [29.96876119830025, 0.75909648787986],
            [29.96876152708365, 0.75862548320244],
            [29.968020915539242, 0.7583109557849],
            [29.969347873639276, 0.756506374709027],
            [29.969270328368996, 0.7558783138921],
            [29.9701280236326, 0.756035920369411],
            [29.970830574456755, 0.755015903779771],
            [29.970909319876252, 0.753916945347368],
            [29.972001289477724, 0.753603709254362],
            [29.972079761809372, 0.752897255219507],
            [29.970754444033037, 0.752346816901835],
            [29.970443058311158, 0.751561589886023],
            [29.971535461798958, 0.750620343248389],
            [29.97138025537575, 0.749521220229568],
            [29.972394566519235, 0.748736918790456],
            [29.972785018359147, 0.747952180666983],
            [29.97262943194856, 0.747402564514083],
            [29.9740330603598, 0.74748204428025],
            [29.974813152860943, 0.747090080678756],
            [29.975576807989025, 0.745810860721631],
            [29.975165457742342, 0.745154218189746],
            [29.975771698388254, 0.744114804276051],
            [29.975843696561622, 0.743003307276171],
            [29.9755598675594, 0.741353717508434],
            [29.974990447060353, 0.740636196980758],
            [29.97495563374984, 0.739452913525587],
            [29.975455472543608, 0.737732152122526],
            [29.97396007044634, 0.736834716933702],
            [29.97371289450432, 0.733643335577051],
            [29.974069860743725, 0.732496178451814],
            [29.9731795746016, 0.732208719485244],
            [29.973287373334024, 0.730810397309272],
            [29.97268281074106, 0.729375734501386],
            [29.973608861509593, 0.729448077155101],
            [29.973965341760408, 0.729018043545691],
            [29.972754482826012, 0.728730370574841],
            [29.971989368833903, 0.727690019557091],
            [29.971490316964328, 0.728263379598606],
            [29.97106329650584, 0.727653533831269],
            [29.971350095338398, 0.724892799784099],
            [29.970887095556098, 0.724820774137322],
            [29.970281164828986, 0.725429918758981],
            [29.969996883075865, 0.72442575361832],
            [29.968857171610285, 0.724281558589819],
            [29.968644485585298, 0.722739600281937],
            [29.969071769250167, 0.72295502519302],
            [29.96999817395492, 0.722489521112442],
            [29.969464771407203, 0.721162482379054],
            [29.969359081020766, 0.719405459937048],
            [29.96818341807918, 0.71976323159526],
            [29.968041417788967, 0.719046013024692],
            [29.968504724795075, 0.71865190731545],
            [29.968380533605348, 0.717934701145776],
            [29.969129668365188, 0.716214107588853],
            [29.968631216570234, 0.71589106899711],
            [29.967562484588512, 0.716141347040379],
            [29.967670050657258, 0.715065736115168],
            [29.96688705030951, 0.714132954958442],
            [29.968133804126055, 0.713990362973052],
            [29.967884802807372, 0.713488210455923],
            [29.968419133314796, 0.713416854720443],
            [29.968277411502314, 0.712269364625311],
            [29.969381173288546, 0.712915509663664],
            [29.96973757358932, 0.712593041226126],
            [29.9697379499834, 0.712019343269569],
            [29.970272352356027, 0.711840417169982],
            [29.96998822241821, 0.710585261097689],
            [29.97070107063043, 0.709868610581928],
            [29.97023832866466, 0.70940217279251],
            [29.97102255431445, 0.708470430659858],
            [29.97171686579079, 0.708865308835391],
            [29.971824144398663, 0.708219967161268],
            [29.9710767308109, 0.707323067785729],
            [29.97146879602506, 0.706928908076411],
            [29.971362335782445, 0.706319281333138],
            [29.970650237663474, 0.705888538628739],
            [29.971505370931887, 0.705458827072242],
            [29.971470357297047, 0.704526541606906],
            [29.970997442808983, 0.704498225256659],
            [29.971631595907375, 0.703056543381302],
            [29.972807738549303, 0.701945769299818],
            [29.973626950884476, 0.701982161812102],
            [29.974161884161425, 0.700978534995922],
            [29.97615767931301, 0.699222875608436],
            [29.979790964886963, 0.699010102117691],
            [29.98110924076978, 0.698437255822481],
            [29.982851986793992, 0.6968973234217],
            [29.983917925913502, 0.697293962245052],
            [29.988664600518618, 0.700860515080733],
            [29.990617596336758, 0.701578922160878],
            [29.990370680007906, 0.697797840249436],
            [29.990684082447572, 0.696357257566134],
            [29.99112188538445, 0.695957119085765],
            [29.995181156557702, 0.692796397121893],
            [29.996215311485848, 0.692877144372113],
            [29.999038735288448, 0.694080226498228],
            [30.000059581675657, 0.69408326347933],
            [30.007921037865962, 0.687159801989634],
            [30.008838069549014, 0.685969784071089],
            [30.01183036225201, 0.685637005454457],
            [30.01323122744541, 0.685948655413287],
            [30.015367723024973, 0.687097449020074],
            [30.01607956063252, 0.688006294491669],
            [30.016719186267657, 0.690468930295563],
            [30.01667148303113, 0.692320044547994],
            [30.014503464669914, 0.69731138737271],
            [30.013969047924235, 0.697490332893617],
            [30.01354055961856, 0.699139509174502],
            [30.015383988819817, 0.700530775385833],
            [30.020761781115997, 0.703112947046016],
            [30.021961466804893, 0.704360099958777],
            [30.021961156886093, 0.704846325744856],
            [30.023457862438853, 0.703843270829583],
            [30.024668939663876, 0.703879911243404],
            [30.02534532166548, 0.704525790672106],
            [30.02609184592109, 0.706892903645436],
            [30.029046603418234, 0.709655893268518],
            [30.02888548069057, 0.710946681220947],
            [30.026710995357618, 0.713455328377906],
            [30.0268167234733, 0.715212442928905],
            [30.02877515050569, 0.716325327397623],
            [30.029380218850157, 0.71707874476765],
            [30.030140485532957, 0.719843566082794],
            [30.031210720396153, 0.721277634580027],
            [30.030846450853513, 0.721677018144183],
            [30.022429030028782, 0.722523921157638],
            [30.017933615106983, 0.724981704320953],
            [30.01440567316975, 0.726270469594389],
            [30.011160835294323, 0.728391187858637],
            [30.011170704186032, 0.732103142822106],
            [30.014670528854882, 0.736003681348316],
            [30.01670185866415, 0.741281262767656],
            [30.01667575631692, 0.743416557725024],
            [30.015268203166233, 0.74584885623881],
            [30.012725563077026, 0.749000409884724],
            [30.012501173800516, 0.750088168523275],
            [29.990426105162587, 0.783711772142396],
            [29.971263222860525, 0.811476177613265],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 321,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "KISUBBA",
        Population: 16876,
        Key: "BUNDIBUGYOKISUBBA",
        Dist2: "Bundibugyo",
        "Sub Country": "Kisubba",
        id2_original: "Bundibugyo Kisubba",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.04691521821181, 0.660832049661417],
            [30.04556896609608, 0.661293247267194],
            [30.043680092921225, 0.662905746686077],
            [30.040489112640337, 0.663802798102391],
            [30.037614669021153, 0.665522260872491],
            [30.036261051618425, 0.66556925037128],
            [30.035185736782314, 0.66609387419004],
            [30.03475274791704, 0.669772228912115],
            [30.025317407416342, 0.668256794391421],
            [30.023394722552496, 0.666907356824951],
            [30.020315226791627, 0.670046619423816],
            [30.018832954470533, 0.670820235107726],
            [30.01766454183162, 0.67093426033127],
            [30.01638156973947, 0.671994857097293],
            [30.014671366084706, 0.672710953717122],
            [30.012247533581757, 0.675434628733347],
            [30.011050577873004, 0.675634685810898],
            [30.00962618400567, 0.674974021708985],
            [30.00864996592179, 0.674984209693932],
            [30.008242018493377, 0.670420858015805],
            [30.006826589812604, 0.667718436495262],
            [30.008418932705446, 0.667329637892376],
            [30.01100420234645, 0.667367374455906],
            [30.01229627976232, 0.668307976914636],
            [30.01369700122528, 0.667730494660742],
            [30.013844095861465, 0.665911715343935],
            [30.0123034555048, 0.663989141996188],
            [30.01010096339627, 0.663289829798324],
            [30.008164768768847, 0.664407192532978],
            [30.002613218940528, 0.662283319597548],
            [30.001841878725205, 0.663021928803556],
            [29.998590415774544, 0.664568574799837],
            [29.996994662876883, 0.66456759300729],
            [29.996452585298453, 0.665657316157152],
            [29.995084746666482, 0.665742529084664],
            [29.993003946634524, 0.666773925618628],
            [29.992177884645344, 0.666773415410093],
            [29.992813607100565, 0.666136551163196],
            [29.99210184944306, 0.665103432541493],
            [29.99227325788075, 0.664386399728832],
            [29.99310007894634, 0.6636410834562],
            [29.99446756633705, 0.664129580564632],
            [29.994524853699353, 0.663641959254852],
            [29.993300573036294, 0.661948758122297],
            [29.993899325325994, 0.661375415183929],
            [29.99378555189861, 0.661031118354371],
            [29.992474777846756, 0.661001628626251],
            [29.992446802512145, 0.660141044984907],
            [29.991806227357774, 0.659194030121044],
            [29.99202781389061, 0.658774647929787],
            [29.992803912482017, 0.658620930292385],
            [29.99414414768195, 0.657044039954052],
            [29.994059091597574, 0.656326848783412],
            [29.994543771320924, 0.655896859739429],
            [29.995286249564504, 0.653229548557733],
            [29.9960557302672, 0.653057900643438],
            [29.996596905038746, 0.653459825691832],
            [29.996711177929416, 0.652972238370302],
            [29.997537565108747, 0.65294405286374],
            [29.998065756529503, 0.651223230285757],
            [30.000118490497012, 0.649445950733691],
            [30.00037647676517, 0.646864387443631],
            [29.999551070546136, 0.645228806614448],
            [30.000537411744936, 0.639693043266182],
            [30.00142090752181, 0.639464079661177],
            [30.001593683195352, 0.636366116116833],
            [30.000853281856728, 0.635533792938707],
            [30.000982491933936, 0.633841407901756],
            [30.001749647796682, 0.633159720797829],
            [30.002037604557632, 0.632493794483896],
            [30.003719469060123, 0.631404714535072],
            [30.004390087470853, 0.629712640746266],
            [30.006043143900495, 0.629168568503418],
            [30.006158422005953, 0.626902449221562],
            [30.006985645516814, 0.62541125944386],
            [30.00704446091341, 0.622198468051442],
            [30.006233392704612, 0.620333418249227],
            [30.003869623358163, 0.617922453843264],
            [30.003442757409875, 0.616918204649575],
            [30.00369937734047, 0.616631492498512],
            [30.00942523896144, 0.619732838919815],
            [30.012072115064615, 0.62394171556071],
            [30.01683101214747, 0.625562516842614],
            [30.020338168865663, 0.627765126931865],
            [30.02446819045238, 0.631102298880177],
            [30.02594615175844, 0.63158723931729],
            [30.028104830335636, 0.633749476347148],
            [30.02856683568288, 0.635485774652451],
            [30.03035940406941, 0.637932028968306],
            [30.03827692142165, 0.645682068642424],
            [30.039160030922964, 0.646170263889854],
            [30.039913058981224, 0.647565486773395],
            [30.040981598723498, 0.648166262287906],
            [30.04275245662621, 0.652864365794036],
            [30.04425449098525, 0.655375780262396],
            [30.04578392575706, 0.65921357257486],
            [30.04691521821181, 0.660832049661417],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 322,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "MIRAMBI",
        Population: 13159,
        Key: "BUNDIBUGYOMIRAMBI",
        Dist2: "Bundibugyo",
        "Sub Country": "Mirambi",
        id2_original: "Bundibugyo Mirambi",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.008838069549014, 0.685969784071089],
            [30.007921037865962, 0.687159801989634],
            [30.000059581675657, 0.69408326347933],
            [29.999038735288448, 0.694080226498228],
            [29.996215311485848, 0.692877144372113],
            [29.995181156557702, 0.692796397121893],
            [29.99112188538445, 0.695957119085765],
            [29.990684082447572, 0.696357257566134],
            [29.990370680007906, 0.697797840249436],
            [29.990617596336758, 0.701578922160878],
            [29.988664600518618, 0.700860515080733],
            [29.983917925913502, 0.697293962245052],
            [29.982851986793992, 0.6968973234217],
            [29.98110924076978, 0.698437255822481],
            [29.979790964886963, 0.699010102117691],
            [29.97615767931301, 0.699222875608436],
            [29.974161884161425, 0.700978534995922],
            [29.973626950884476, 0.701982161812102],
            [29.972807738549303, 0.701945769299818],
            [29.971631595907375, 0.703056543381302],
            [29.970997442808983, 0.704498225256659],
            [29.97036628738868, 0.704346534626438],
            [29.97015315579929, 0.703449989311678],
            [29.968658302572685, 0.701692058284006],
            [29.971742197383474, 0.697247904539686],
            [29.97142915786317, 0.695295835300804],
            [29.971809041922093, 0.694205091243474],
            [29.973531278510073, 0.695073344372931],
            [29.973799068092916, 0.694355886646863],
            [29.972284694475142, 0.693577472705184],
            [29.972314743121387, 0.693039268541391],
            [29.973562834529382, 0.692172938191434],
            [29.97445402976654, 0.692024005688553],
            [29.97433571176217, 0.691246494104931],
            [29.975494521410706, 0.690649215366058],
            [29.97543538082396, 0.690230556282799],
            [29.97448525251089, 0.689631920160206],
            [29.974663890589955, 0.688974204241477],
            [29.97605991027074, 0.689034902609441],
            [29.9760605543628, 0.68801825649384],
            [29.976476684545105, 0.687570002516809],
            [29.977664083077563, 0.688736919731583],
            [29.978079835967463, 0.688886693998009],
            [29.978377096579813, 0.688528066632305],
            [29.97817064755784, 0.686195620511309],
            [29.979430073009777, 0.684317648865201],
            [29.97980580415715, 0.683864349962262],
            [29.98149860115662, 0.684343851751234],
            [29.982419880074342, 0.683596900122189],
            [29.98393489059766, 0.683388551615842],
            [29.9825855321077, 0.679949014682353],
            [29.983862595980213, 0.680248836828006],
            [29.983862838525333, 0.679860116474805],
            [29.983090900930335, 0.679291497745954],
            [29.98312086513495, 0.678872896955411],
            [29.982200355175113, 0.678393889558929],
            [29.98220119240498, 0.677048320874544],
            [29.98312153437986, 0.677796438551304],
            [29.983894049591587, 0.677438105882932],
            [29.984517432788035, 0.67806643436036],
            [29.98543904228579, 0.676781243431524],
            [29.986901093529823, 0.676420979444849],
            [29.986480973031004, 0.674910300542525],
            [29.984742279307035, 0.6756837151448],
            [29.984628706203967, 0.675023881035263],
            [29.983745796128673, 0.674306193050803],
            [29.984878882519023, 0.673773812796953],
            [29.984056076024423, 0.672888441393327],
            [29.984971408094967, 0.67212821630129],
            [29.986143161568446, 0.668197711722079],
            [29.984633859838745, 0.666647765778712],
            [29.983437340711255, 0.666188058876603],
            [29.983381452025835, 0.664380849411869],
            [29.98261281753614, 0.66317559330771],
            [29.982727338361816, 0.662286420374767],
            [29.98187295428834, 0.661511391293581],
            [29.98270158905251, 0.657754128510839],
            [29.984256241330975, 0.654986944762432],
            [29.984228590288215, 0.653581348166296],
            [29.98277742932036, 0.65186148783966],
            [29.986734860286504, 0.651522558340118],
            [29.99271316018042, 0.651667069957445],
            [29.99231252503844, 0.652914768788702],
            [29.993151553310426, 0.654163219151257],
            [29.99219483405811, 0.655345874608053],
            [29.99157003511677, 0.657049897482851],
            [29.99202781389061, 0.658774647929787],
            [29.991806227357774, 0.659194030121044],
            [29.992446802512145, 0.660141044984907],
            [29.992474777846756, 0.661001628626251],
            [29.99378555189861, 0.661031118354371],
            [29.993899325325994, 0.661375415183929],
            [29.993300573036294, 0.661948758122297],
            [29.994524853699353, 0.663641959254852],
            [29.99446756633705, 0.664129580564632],
            [29.99310007894634, 0.6636410834562],
            [29.99227325788075, 0.664386399728832],
            [29.99210184944306, 0.665103432541493],
            [29.992813607100565, 0.666136551163196],
            [29.992177884645344, 0.666773415410093],
            [29.993003946634524, 0.666773925618628],
            [29.995084746666482, 0.665742529084664],
            [29.996452585298453, 0.665657316157152],
            [29.996994662876883, 0.66456759300729],
            [29.998590415774544, 0.664568574799837],
            [30.001841878725205, 0.663021928803556],
            [30.002613218940528, 0.662283319597548],
            [30.008164768768847, 0.664407192532978],
            [30.01010096339627, 0.663289829798324],
            [30.0123034555048, 0.663989141996188],
            [30.013844095861465, 0.665911715343935],
            [30.01369700122528, 0.667730494660742],
            [30.01229627976232, 0.668307976914636],
            [30.01100420234645, 0.667367374455906],
            [30.008418932705446, 0.667329637892376],
            [30.006826589812604, 0.667718436495262],
            [30.008242018493377, 0.670420858015805],
            [30.00864996592179, 0.674984209693932],
            [30.00560764424401, 0.675975526936437],
            [30.003822478873754, 0.677345490660368],
            [30.00250836578395, 0.679707180977507],
            [30.002268857861228, 0.681068475514686],
            [30.003182466064732, 0.683111221881714],
            [30.004375015537022, 0.684353295066176],
            [30.008838069549014, 0.685969784071089],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 323,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "NYAHUKA TOWN COUNCIL",
        Population: 16696,
        Key: "BUNDIBUGYONYAHUKA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.17520505495316, 0.836745333585873],
            [30.174252537121408, 0.836472335031684],
            [30.173089532340526, 0.838353417408016],
            [30.171148386199263, 0.836981665905584],
            [30.170149569197775, 0.837711781710781],
            [30.168751804090427, 0.837930013956781],
            [30.16800938783062, 0.835481148730597],
            [30.16755852967772, 0.831424645089976],
            [30.16696055083748, 0.83003561029794],
            [30.165708243635876, 0.82831728077477],
            [30.164608441623418, 0.828976109059038],
            [30.163713087186466, 0.827163268193003],
            [30.162164459908603, 0.82605236543713],
            [30.159827423526703, 0.82326122695652],
            [30.158488649885715, 0.82035083930899],
            [30.15765496838629, 0.819480414217848],
            [30.157209593549908, 0.817260536199569],
            [30.155944775511326, 0.815100063719075],
            [30.149747573250682, 0.812106310379729],
            [30.143719299179175, 0.805981594772551],
            [30.135213212839297, 0.805967201592592],
            [30.135659491380856, 0.804060620381977],
            [30.13527213423708, 0.798862215537613],
            [30.132285461394524, 0.795045052992072],
            [30.1293893036983, 0.793130412287912],
            [30.128867304364796, 0.792412819598723],
            [30.129010529957085, 0.791360987480132],
            [30.13057844675902, 0.790740486832519],
            [30.131624328294876, 0.789450206564405],
            [30.132764255356122, 0.7895466315553],
            [30.13390461091379, 0.789021458900787],
            [30.134664311657982, 0.789452325489005],
            [30.13680226520324, 0.788784398902501],
            [30.137561672198352, 0.789645605720639],
            [30.138226606069985, 0.789741698361915],
            [30.1387960139926, 0.790602774738374],
            [30.143830728901964, 0.791036620590442],
            [30.145650704887807, 0.792200194328992],
            [30.144719084564535, 0.788471875875489],
            [30.141803962534354, 0.782712160107508],
            [30.14450627367371, 0.781145179756959],
            [30.146473170022606, 0.778811093240436],
            [30.148665438404898, 0.777018842771774],
            [30.1562680684023, 0.774026684944436],
            [30.1567617501431, 0.775051102848164],
            [30.156849740125196, 0.779162114323378],
            [30.15788265627654, 0.781611119512091],
            [30.157827576074876, 0.782542898265321],
            [30.15675512416958, 0.784880837914687],
            [30.15927561090553, 0.788427130536542],
            [30.16140069877932, 0.790316296021938],
            [30.15617161898521, 0.788845218066063],
            [30.153848332217017, 0.788916696525674],
            [30.15225636392166, 0.789574623994714],
            [30.1542822032279, 0.791456644440352],
            [30.156113179982697, 0.794673589556388],
            [30.158761636222465, 0.796849671506791],
            [30.158895137551777, 0.797334773203525],
            [30.15866818717841, 0.800759583356278],
            [30.15919322102094, 0.802678398164289],
            [30.156904723308774, 0.804905840063414],
            [30.156619324949755, 0.806753378672132],
            [30.15842728327373, 0.807885072611345],
            [30.160025792202685, 0.808068695148931],
            [30.160658340011697, 0.809960402560856],
            [30.162091077431374, 0.811605804979433],
            [30.164828076117125, 0.81692461032709],
            [30.171810561344646, 0.824731357419737],
            [30.17258107870319, 0.825983483491825],
            [30.172480237422654, 0.82740855994913],
            [30.17475445282013, 0.832608346206939],
            [30.17520505495316, 0.836745333585873],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 324,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "SINDILA",
        Population: 7577,
        Key: "BUNDIBUGYOSINDILA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [29.77378772649104, 0.047983992179044],
              [29.773785408837593, 0.050220373308616],
              [29.768945910415866, 0.055099314692309],
              [29.76719407523759, 0.056554951274174],
              [29.7621775557043, 0.05822552940366],
              [29.761810349568982, 0.056059893553421],
              [29.75838122590629, 0.054716776287356],
              [29.7570776635295, 0.055027930101225],
              [29.755436991274376, 0.052765418956423],
              [29.75439283989377, 0.052361304809415],
              [29.754129964993876, 0.051336739816449],
              [29.75360738984027, 0.050884428369411],
              [29.75391354557055, 0.049835445356092],
              [29.752871492654464, 0.044557412764787],
              [29.753296729058818, 0.04377047084336],
              [29.753341334005924, 0.042364251189861],
              [29.754299065659563, 0.04106434530083],
              [29.754463281286768, 0.040182336457424],
              [29.755552414906933, 0.039370883066963],
              [29.756332186709514, 0.038011567062017],
              [29.755854630626374, 0.036370469351255],
              [29.755839273926597, 0.035301141995665],
              [29.757073807960325, 0.03649502253683],
              [29.75847360146358, 0.03687491011114],
              [29.760503916176567, 0.038314754691365],
              [29.76076638234301, 0.039124825585195],
              [29.761668166920757, 0.039481396481985],
              [29.7621683335996, 0.040577234859962],
              [29.76361651575398, 0.041433755806127],
              [29.764141401374488, 0.043030068818824],
              [29.767840361880538, 0.042930940653442],
              [29.768983056651212, 0.045170140855826],
              [29.77095297852596, 0.046049982007355],
              [29.772532900413374, 0.047561818278216],
              [29.77378772649104, 0.047983992179044],
            ],
          ],
          [
            [
              [29.80844956668184, 0.063350050497728],
              [29.803497362929644, 0.062963089746093],
              [29.799653812290376, 0.061965903779457],
              [29.797683470004085, 0.060895339849903],
              [29.796471247427096, 0.05946649382194],
              [29.796398163190506, 0.058489356380894],
              [29.794000988193588, 0.057419233456251],
              [29.793121842059332, 0.056538248007912],
              [29.791355327510985, 0.056599629861364],
              [29.790882062679948, 0.057100629930161],
              [29.789458568924534, 0.056744554995269],
              [29.787966640612474, 0.057747105792977],
              [29.786123313819115, 0.057393215563743],
              [29.784956567555056, 0.058489007834768],
              [29.784030948876225, 0.058084764369463],
              [29.782656078232165, 0.058324492255747],
              [29.781028435141913, 0.056835143758969],
              [29.781666165331814, 0.055405824216292],
              [29.780830074550767, 0.05233207004901],
              [29.778979280062472, 0.051738106024721],
              [29.777732232496874, 0.050678758267567],
              [29.776641260923647, 0.050584539404085],
              [29.774964144915742, 0.048803750397472],
              [29.775896050903295, 0.047454782252289],
              [29.775140146439465, 0.045091515834962],
              [29.77679464556348, 0.042280122189808],
              [29.77648305951728, 0.041522953100548],
              [29.774312855554992, 0.039627165170089],
              [29.774246506886406, 0.038884520912493],
              [29.775622875920355, 0.033508538898103],
              [29.77497993280687, 0.032174504987746],
              [29.77529575081636, 0.030041040638489],
              [29.774503973928304, 0.025465748059593],
              [29.775565511302936, 0.022375540158654],
              [29.775532967136826, 0.02138863039828],
              [29.774857199582865, 0.019947870218566],
              [29.773545390671785, 0.018507101043068],
              [29.773068388849158, 0.017106371562948],
              [29.77175657814145, 0.015705629496211],
              [29.771577715483538, 0.014394954304248],
              [29.769987643531753, 0.012493957518716],
              [29.770410043954737, 0.010317851668283],
              [29.77036041383193, 0.004114681951411],
              [29.768670947785502, 0.001113144689314],
              [29.768504414504886, -0.002770071958506],
              [29.765112444264016, -0.007950039933277],
              [29.773065260915367, -0.004545816692673],
              [29.773658404124426, -0.003426179881493],
              [29.77635241483057, 0.00893686351669],
              [29.778733474949593, 0.016999037264309],
              [29.77881192482338, 0.020872941764694],
              [29.779675695393216, 0.023363329363009],
              [29.77951858723655, 0.025181691811352],
              [29.779849472688323, 0.026420648125582],
              [29.78156814925284, 0.026168598849688],
              [29.78593234636278, 0.026664563156928],
              [29.789111635968542, 0.033394426825325],
              [29.791692463440462, 0.037336337744924],
              [29.798265084234796, 0.045254524974066],
              [29.80175815986088, 0.048849965108766],
              [29.804962613972737, 0.050419784851725],
              [29.806453352017048, 0.054744258434321],
              [29.806949821230173, 0.059927793741309],
              [29.80844956668184, 0.063350050497728],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 325,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "BWERA",
        Population: 17509,
        Key: "KASESEBWERA",
        Dist2: "Kasese",
        "Sub Country": "Bwera",
        id2_original: "Kasese Bwera",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.208237590170445, 0.248365686154425],
            [30.206479721008396, 0.252000919653734],
            [30.20619689991592, 0.253694209509582],
            [30.20314965277545, 0.255781693934812],
            [30.199737109317923, 0.260075201329885],
            [30.196736860236495, 0.261757232546191],
            [30.195884217098037, 0.263259861089968],
            [30.19557795267161, 0.265215467276573],
            [30.195008675004704, 0.265477935119903],
            [30.193753449176732, 0.267743788722023],
            [30.192674424298467, 0.268447565228545],
            [30.19267549868356, 0.269377632002266],
            [30.19219695714855, 0.270011287600714],
            [30.197749880500925, 0.273572145966035],
            [30.204659023675386, 0.279275067411855],
            [30.20012353580707, 0.28596523041884],
            [30.19549725970457, 0.290445443063551],
            [30.19220959644461, 0.298821284207941],
            [30.18730682967741, 0.307646019516702],
            [30.185504805624227, 0.309124952038773],
            [30.179275611661346, 0.309662787117385],
            [30.174828287149936, 0.308412212990919],
            [30.17031939031237, 0.30650922144507],
            [30.164010935297025, 0.297759120729106],
            [30.159508934825872, 0.296152118253482],
            [30.156901832530178, 0.29579188695279],
            [30.154438242389357, 0.292914840254689],
            [30.153974716194355, 0.28989449719561],
            [30.153117729701496, 0.289211131434327],
            [30.149975007815982, 0.288527188022459],
            [30.14910025534176, 0.287502249284035],
            [30.148243920127506, 0.284230138859865],
            [30.14788736890979, 0.281821072611321],
            [30.148389987989344, 0.278724226112049],
            [30.148167188730895, 0.27462080207621],
            [30.14858603811358, 0.273752080058264],
            [30.148923905271705, 0.268302956020519],
            [30.148018095343165, 0.264821509933182],
            [30.14834009286352, 0.262397005100361],
            [30.14957911218543, 0.260242519809846],
            [30.15425403834877, 0.254904163601017],
            [30.155672925543403, 0.251885789985034],
            [30.156276383208574, 0.251582196485233],
            [30.158004201927746, 0.251913917761372],
            [30.158552577594588, 0.252659549049717],
            [30.16074652672482, 0.253571216979205],
            [30.16339279826182, 0.25554603584257],
            [30.163584989223597, 0.254634898053192],
            [30.164654594367757, 0.254856031446022],
            [30.166163320277345, 0.253779515387398],
            [30.16657457440431, 0.254469897130229],
            [30.167726525415638, 0.25441493245495],
            [30.168302409293137, 0.254801623722349],
            [30.168686572926063, 0.253973359142991],
            [30.16994804653685, 0.254774381682394],
            [30.17134697855576, 0.254112012744155],
            [30.17234798834483, 0.254484994966296],
            [30.173527651484385, 0.253159887822262],
            [30.17418569348112, 0.254126450325402],
            [30.17520055169864, 0.253905782242831],
            [30.175419799916764, 0.254678961779285],
            [30.177092930099747, 0.254375605497768],
            [30.177943035497506, 0.255038480168956],
            [30.178875573000713, 0.255011075536038],
            [30.17934167286903, 0.25575670215431],
            [30.18263326446173, 0.254404451015544],
            [30.182496442959117, 0.252968593448409],
            [30.18277078754858, 0.252637309674456],
            [30.182277243250006, 0.251946899986498],
            [30.182359717576258, 0.251063330077249],
            [30.182908137260554, 0.251670916840379],
            [30.184471491519204, 0.251726483392731],
            [30.187374139543355, 0.253228259727548],
            [30.189351456349513, 0.253320572399178],
            [30.199755756546605, 0.251454705215265],
            [30.208237590170445, 0.248365686154425],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 326,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "HIMA TOWN COUNCIL",
        Population: 13135,
        Key: "KASESEHIMA TOWN COUNCIL",
        Dist2: "Kasese",
        "Sub Country": "Hima Town Council",
        id2_original: "Kasese Hima Town Council",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.847289306867427, 0.151482464879756],
            [29.846684537661936, 0.153791494377128],
            [29.845253158494963, 0.155746913004026],
            [29.838303468961843, 0.161883190404076],
            [29.834484916640303, 0.165814618829442],
            [29.829132066068002, 0.169236064338915],
            [29.824265098063233, 0.171274067717788],
            [29.82354502829442, 0.171951434827768],
            [29.82470286416917, 0.164844304919988],
            [29.82802217148335, 0.152102671253473],
            [29.828099023254204, 0.150032823489683],
            [29.828532955350525, 0.149181442691645],
            [29.82817584987227, 0.14819050096371],
            [29.828733696477176, 0.147507963283267],
            [29.828227309863294, 0.145210482727703],
            [29.827377967135206, 0.144975478812978],
            [29.826010736662667, 0.146362530620989],
            [29.82420255914977, 0.14672926663615],
            [29.82412257585184, 0.145180530297358],
            [29.82090381247582, 0.144277262787851],
            [29.818600405424892, 0.140878560316062],
            [29.815592935685196, 0.141024929568916],
            [29.81434247182654, 0.141766082337203],
            [29.81346401380179, 0.141193452106814],
            [29.812549025785977, 0.141222684095685],
            [29.812162735840754, 0.140371206846444],
            [29.809461548493825, 0.140165309108772],
            [29.80876177795549, 0.139196358579996],
            [29.809370730615235, 0.137845914380332],
            [29.80895903182221, 0.136187055984045],
            [29.807592249608987, 0.134506051367958],
            [29.807406466330136, 0.133529835954624],
            [29.805715419248816, 0.130527625737236],
            [29.805584332590968, 0.129375263566588],
            [29.802755692271525, 0.128273926422214],
            [29.802803169132584, 0.127532612445721],
            [29.803525025650497, 0.126908822053522],
            [29.80333552514299, 0.126453738439565],
            [29.801447313128197, 0.125932374581238],
            [29.801509439714927, 0.124706642477697],
            [29.800627377649224, 0.123803735332464],
            [29.80176499154861, 0.121579929504361],
            [29.802031445336635, 0.118644052961116],
            [29.80074101363435, 0.118548475114555],
            [29.79991730343458, 0.117388702235405],
            [29.79908873155248, 0.117819949257221],
            [29.797593812748843, 0.117320847234453],
            [29.79481442525976, 0.114773219534641],
            [29.794477440247256, 0.112199424632178],
            [29.793125242182676, 0.111914708638982],
            [29.792564896464643, 0.110330262222517],
            [29.79168778770944, 0.110474108283593],
            [29.790903544093343, 0.109592992870445],
            [29.789670597382752, 0.109665679918596],
            [29.788953551343162, 0.10675858862231],
            [29.788408660241295, 0.107021290588538],
            [29.786629346496774, 0.106593988801475],
            [29.785749410743367, 0.105283951810881],
            [29.785251113458646, 0.105117596677073],
            [29.783532174586043, 0.105250341401239],
            [29.78393269474369, 0.103915242297309],
            [29.783479921382618, 0.10277164119015],
            [29.780518919695908, 0.104371387180442],
            [29.779592258073013, 0.10341892391523],
            [29.7790954439068, 0.104015248878306],
            [29.778478825922754, 0.103968177234965],
            [29.777658753001564, 0.102956029986547],
            [29.776626528552985, 0.102587596446926],
            [29.77622006064985, 0.100871945417679],
            [29.777996798924434, 0.099988369251483],
            [29.778493092067798, 0.099129860512004],
            [29.777423412363436, 0.097796196661104],
            [29.778070785069577, 0.095376409116992],
            [29.776431519576178, 0.093804970365732],
            [29.77633391043403, 0.092398853680944],
            [29.77471854551707, 0.090922734013571],
            [29.773466263468283, 0.087170118075028],
            [29.772824375875288, 0.086336560600285],
            [29.769365137091004, 0.087769990763132],
            [29.766661903381824, 0.087772641688423],
            [29.765786368475, 0.088703021233289],
            [29.763912567233938, 0.088442688876718],
            [29.76310521176225, 0.087871468830009],
            [29.76246698929561, 0.088896943015737],
            [29.760422651881036, 0.089052425932581],
            [29.758560608688754, 0.086004996397155],
            [29.757123418320194, 0.084683647047027],
            [29.756337481379802, 0.082944581484625],
            [29.752209014776827, 0.081661646648731],
            [29.75163851899439, 0.080947204646189],
            [29.75023982592734, 0.081115417608184],
            [29.74978166087792, 0.080594012580238],
            [29.75082278763097, 0.0794728209781],
            [29.75109164171741, 0.077530136049615],
            [29.750567196271376, 0.076124484099462],
            [29.75105054199654, 0.074729756506369],
            [29.754722924048302, 0.07320075958988],
            [29.754292701095792, 0.071485179089067],
            [29.754836954393827, 0.070912636488172],
            [29.755117672530233, 0.068981844869454],
            [29.75711992387372, 0.066561572286631],
            [29.758022784633187, 0.064527759966487],
            [29.757691345819236, 0.06387257502363],
            [29.758439342413578, 0.063985394369938],
            [29.7621775557043, 0.05822552940366],
            [29.76719407523759, 0.056554951274174],
            [29.768945910415866, 0.055099314692309],
            [29.773785408837593, 0.050220373308616],
            [29.77378772649104, 0.047983992179044],
            [29.774964144915742, 0.048803750397472],
            [29.776641260923647, 0.050584539404085],
            [29.777732232496874, 0.050678758267567],
            [29.778979280062472, 0.051738106024721],
            [29.780830074550767, 0.05233207004901],
            [29.781666165331814, 0.055405824216292],
            [29.781028435141913, 0.056835143758969],
            [29.782656078232165, 0.058324492255747],
            [29.784030948876225, 0.058084764369463],
            [29.784956567555056, 0.058489007834768],
            [29.786123313819115, 0.057393215563743],
            [29.787966640612474, 0.057747105792977],
            [29.789458568924534, 0.056744554995269],
            [29.790882062679948, 0.057100629930161],
            [29.791355327510985, 0.056599629861364],
            [29.793121842059332, 0.056538248007912],
            [29.794000988193588, 0.057419233456251],
            [29.796398163190506, 0.058489356380894],
            [29.796471247427096, 0.05946649382194],
            [29.797683470004085, 0.060895339849903],
            [29.799653812290376, 0.061965903779457],
            [29.803497362929644, 0.062963089746093],
            [29.80844956668184, 0.063350050497728],
            [29.81165057395793, 0.074629119228889],
            [29.81184753227894, 0.077004690358186],
            [29.811379086909398, 0.078269402132785],
            [29.810091053708934, 0.079534288142252],
            [29.80817465076389, 0.082127351680942],
            [29.808174612136312, 0.082601720949628],
            [29.809274041347912, 0.082918061448594],
            [29.812186127072437, 0.085195304412731],
            [29.813495065866196, 0.093616792430016],
            [29.819742474968084, 0.110311769538349],
            [29.819896589039928, 0.111236512428113],
            [29.819501446197574, 0.112221799826371],
            [29.820644959333436, 0.116319985052813],
            [29.824104684106317, 0.119061858500823],
            [29.82684187592984, 0.118779550954473],
            [29.82532570208825, 0.120559920827603],
            [29.825451990844165, 0.120899079010182],
            [29.826378352429764, 0.121436189500665],
            [29.828280418262896, 0.120687456162491],
            [29.829122517874858, 0.121591957918946],
            [29.830420879904448, 0.121917140131032],
            [29.8309822317356, 0.12290640129169],
            [29.831719167373883, 0.122948884320312],
            [29.832532979935845, 0.125563292754174],
            [29.834364922379585, 0.124447137771822],
            [29.834463091172154, 0.125196114447439],
            [29.835277145380932, 0.125846260489311],
            [29.835613911204543, 0.126793115735258],
            [29.836856084511453, 0.127542234276895],
            [29.83723490676171, 0.128898901656075],
            [29.838266536525545, 0.129605607186818],
            [29.840715977302356, 0.129535258500174],
            [29.841558279035226, 0.128899454118592],
            [29.84219649790861, 0.132488939280131],
            [29.843263251800085, 0.132941291016156],
            [29.844069997315707, 0.135866623333682],
            [29.84376104692659, 0.136912316853822],
            [29.84425895703743, 0.139837616349485],
            [29.846020116728344, 0.143399014143137],
            [29.845893620461634, 0.144529520596574],
            [29.847289306867427, 0.151482464879756],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 327,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "IHANDIRO",
        Population: 13261,
        Key: "KASESEIHANDIRO",
        Dist2: "Kasese",
        "Sub Country": "Ihandiro",
        id2_original: "Kasese Ihandiro",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.74981314862528, -0.023613359231661],
            [29.751329970152177, -0.020369809779686],
            [29.753223793942574, -0.012612198265164],
            [29.75508197617577, -0.011158858914058],
            [29.756595902432515, -0.010628740616608],
            [29.759755425508782, -0.00711663691883],
            [29.760644042581102, -0.002577372550481],
            [29.761038964437905, 0.00298902912219],
            [29.76197823122087, 0.004914364011469],
            [29.758654345193687, 0.02071557670022],
            [29.758318289937478, 0.025439321423187],
            [29.756584569286908, 0.023208348429734],
            [29.755065632227506, 0.022542601635861],
            [29.751297327171386, 0.023499875071398],
            [29.749355681566833, 0.024860401295778],
            [29.748617945529638, 0.023550344216439],
            [29.748876601940992, 0.02247757888564],
            [29.7500588800763, 0.020831837554961],
            [29.7493755217582, 0.018827699869498],
            [29.748203332601825, 0.018892757655465],
            [29.747084387490684, 0.017368621223557],
            [29.745175560038398, 0.016573393941374],
            [29.741423672592425, 0.018561283824929],
            [29.740567994944936, 0.018296204473006],
            [29.739975632371856, 0.016639560249172],
            [29.738922512211456, 0.015314237134514],
            [29.736026392244476, 0.013591290034009],
            [29.733788437343467, 0.015314144608049],
            [29.733393511893414, 0.015247871400309],
            [29.732932770475784, 0.014784008352995],
            [29.732603717587182, 0.011338231811596],
            [29.731738942700858, 0.010270847321784],
            [29.731155666586847, 0.010344240577622],
            [29.728588665983786, 0.00875385693255],
            [29.728494637526367, 0.007687358173607],
            [29.728750410345643, 0.007089088284221],
            [29.727557152102616, 0.006470216431427],
            [29.727991074317437, 0.005778556785738],
            [29.727629488042556, 0.004868471778719],
            [29.726833975061236, 0.004759259098448],
            [29.727123252345653, 0.003849179479918],
            [29.726617026530217, 0.003193910583699],
            [29.727882618916563, 0.001810598472306],
            [29.727846459031433, 0.001373754037997],
            [29.726653203483327, -0.000592027501456],
            [29.725857689603714, -0.000227996012355],
            [29.725387618283527, -0.000555625071211],
            [29.72665320438166, -0.001065269874544],
            [29.726725527745174, -0.00219377575482],
            [29.726219284861763, -0.002230171896827],
            [29.72560457939094, -0.001574919169413],
            [29.725170661667672, -0.002448594563032],
            [29.725411120007994, -0.00380530037166],
            [29.72664044381306, -0.004099690865988],
            [29.728054316611754, -0.003788870185151],
            [29.728168629028303, -0.004625799990382],
            [29.72942416297841, -0.004844585575383],
            [29.73011172720866, -0.006094009179219],
            [29.729900617727008, -0.00680015595498],
            [29.730298420480896, -0.008982569797783],
            [29.73128873582652, -0.009028311113156],
            [29.731152492838973, -0.010974912693405],
            [29.731391711504166, -0.011191162331068],
            [29.731670866571985, -0.010707563289824],
            [29.732399445183177, -0.010564741941922],
            [29.732858551666993, -0.012397729987774],
            [29.731894539891208, -0.012050299373031],
            [29.732092988517234, -0.013027288188008],
            [29.73131521995775, -0.014539754638601],
            [29.731763386758047, -0.01497187032706],
            [29.73184243221484, -0.015825509666328],
            [29.73251005384579, -0.015712350690909],
            [29.732837977552034, -0.016082014602624],
            [29.733125970245602, -0.017151516395529],
            [29.732315410483267, -0.021038718652764],
            [29.733645607009937, -0.021177750001538],
            [29.73390878643871, -0.021851080378667],
            [29.735456548638933, -0.022678072960024],
            [29.73568735727647, -0.02350324375343],
            [29.736516426825226, -0.022661354415585],
            [29.73705960843312, -0.022790199766671],
            [29.73758891106989, -0.023923738813719],
            [29.737910112682886, -0.022588062673912],
            [29.738398643483865, -0.022289883107895],
            [29.738537797911242, -0.023174764017267],
            [29.738899359033333, -0.023301257578649],
            [29.74036031523104, -0.022741614388357],
            [29.74129280781846, -0.023180008381459],
            [29.74110193288856, -0.023847460174611],
            [29.74166865844175, -0.024463824778995],
            [29.74170901615421, -0.025926000747449],
            [29.742441387452516, -0.025509174412781],
            [29.74298036045331, -0.025942474949765],
            [29.743246060554803, -0.026433134706708],
            [29.74289837211565, -0.027494413248974],
            [29.743686237738945, -0.027443719526696],
            [29.744041072276172, -0.02805734335394],
            [29.744374885337457, -0.028000775548951],
            [29.744334936358435, -0.028700630443235],
            [29.746080539025282, -0.027261600496627],
            [29.746906896560205, -0.025521362753324],
            [29.74981314862528, -0.023613359231661],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 328,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "ISANGO",
        Population: 8229,
        Key: "KASESEISANGO",
        Dist2: "Kasese",
        "Sub Country": "Isango",
        id2_original: "Kasese Isango",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.74978166087792, 0.080594012580238],
            [29.748431194765214, 0.081167350061008],
            [29.74640918048548, 0.083898256233923],
            [29.746340017395116, 0.084899317937537],
            [29.74491940094354, 0.085973212241581],
            [29.742944426943648, 0.088513389798544],
            [29.741023997749476, 0.088634435841792],
            [29.739078218996287, 0.087921352219032],
            [29.738061966593467, 0.089638319923252],
            [29.73720521276429, 0.088042350653584],
            [29.736374405873747, 0.087590341391387],
            [29.736044642417813, 0.088710815905695],
            [29.735055097826695, 0.088820617749408],
            [29.73341126978997, 0.088022240093034],
            [29.732771194997184, 0.088094361250458],
            [29.732198278255066, 0.086140631072224],
            [29.733191921858836, 0.084995672027307],
            [29.733083882377926, 0.084316541023923],
            [29.73177860960886, 0.083745835649521],
            [29.73127841687886, 0.082602345278095],
            [29.730233272859863, 0.081673894266883],
            [29.729850361478423, 0.079886804684891],
            [29.729232826314473, 0.079363097261434],
            [29.727808713619826, 0.078649517600664],
            [29.723397515755916, 0.078224895143529],
            [29.723501276561123, 0.076735247219414],
            [29.720961467063372, 0.075379303476478],
            [29.718258982549138, 0.075691815414141],
            [29.71764149230094, 0.075191941121111],
            [29.71714025662692, 0.073524154623693],
            [29.718348638007786, 0.073070138365777],
            [29.718179644241584, 0.071545020315099],
            [29.71865279318993, 0.070996399832627],
            [29.717866629874067, 0.069138235158604],
            [29.717899199193035, 0.067624839985759],
            [29.719485642849406, 0.066503121645432],
            [29.719388475678365, 0.065335417651818],
            [29.71974363001586, 0.065072904044651],
            [29.720597806578493, 0.065358041707536],
            [29.72064181773919, 0.063642046803218],
            [29.721257416135426, 0.063188608966559],
            [29.719937618506492, 0.061271401363597],
            [29.719107625489652, 0.061224574909519],
            [29.719058170538315, 0.060199824121109],
            [29.719509105047997, 0.060413861093738],
            [29.720478719616207, 0.059125924713803],
            [29.718864058080143, 0.057983583577658],
            [29.718055689308763, 0.056888107503723],
            [29.71852839179445, 0.056124985447709],
            [29.718383413589052, 0.05476666600052],
            [29.71691269539916, 0.054458335588998],
            [29.716578827540648, 0.05350537351415],
            [29.718130329427428, 0.05270540702928],
            [29.718200088100794, 0.052014189639404],
            [29.717156351741878, 0.051800763490225],
            [29.717343519324587, 0.050537447938612],
            [29.718221751872196, 0.050989374011016],
            [29.71817313594735, 0.050393600767961],
            [29.719344198616326, 0.04906970552347],
            [29.71863180584994, 0.048546110972003],
            [29.71957196016841, 0.04439827985341],
            [29.7190471967188, 0.042849698838538],
            [29.719418474917298, 0.042040399634609],
            [29.72004374547419, 0.043182327826502],
            [29.721586282174393, 0.043824230505851],
            [29.723834467988212, 0.041629314500514],
            [29.73138590748912, 0.036482534160281],
            [29.732877197099047, 0.037079213913667],
            [29.73484183059172, 0.038827246139791],
            [29.73726226656461, 0.03994017676716],
            [29.741390927203692, 0.038308032599621],
            [29.742223419333662, 0.038517594236943],
            [29.742847759235918, 0.039303346841496],
            [29.74362823531769, 0.039146231535103],
            [29.746438025389242, 0.036789156951836],
            [29.750696838438255, 0.034871946796314],
            [29.751930482241526, 0.035745985842228],
            [29.755854630626374, 0.036370469351255],
            [29.756332186709514, 0.038011567062017],
            [29.755552414906933, 0.039370883066963],
            [29.754463281286768, 0.040182336457424],
            [29.754299065659563, 0.04106434530083],
            [29.753341334005924, 0.042364251189861],
            [29.753296729058818, 0.04377047084336],
            [29.752871492654464, 0.044557412764787],
            [29.75391354557055, 0.049835445356092],
            [29.75360738984027, 0.050884428369411],
            [29.754129964993876, 0.051336739816449],
            [29.75439283989377, 0.052361304809415],
            [29.755436991274376, 0.052765418956423],
            [29.7570776635295, 0.055027930101225],
            [29.75838122590629, 0.054716776287356],
            [29.761810349568982, 0.056059893553421],
            [29.7621775557043, 0.05822552940366],
            [29.758439342413578, 0.063985394369938],
            [29.757691345819236, 0.06387257502363],
            [29.758022784633187, 0.064527759966487],
            [29.75711992387372, 0.066561572286631],
            [29.755117672530233, 0.068981844869454],
            [29.754836954393827, 0.070912636488172],
            [29.754292701095792, 0.071485179089067],
            [29.754722924048302, 0.07320075958988],
            [29.75105054199654, 0.074729756506369],
            [29.750567196271376, 0.076124484099462],
            [29.75109164171741, 0.077530136049615],
            [29.75082278763097, 0.0794728209781],
            [29.74978166087792, 0.080594012580238],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 329,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KARAMBI",
        Population: 25792,
        Key: "KASESEKARAMBI",
        Dist2: "Kasese",
        "Sub Country": "Karambi",
        id2_original: "Kasese Karambi",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.870807613332378, 0.00971672603877],
            [29.870616679113677, 0.009121021740903],
            [29.871445775611917, 0.008667254848571],
            [29.871492137663715, 0.008142809408218],
            [29.870946058989016, 0.007833519458905],
            [29.870359754654224, 0.005247923746492],
            [29.86955022885278, 0.003675598916282],
            [29.869359190429513, 0.003032216527721],
            [29.870401288261387, 0.002363697480552],
            [29.86930648627181, 0.000457983589737],
            [29.870823751566466, 0.000217998661557],
            [29.8704175756158, -0.001259410180451],
            [29.871091173738336, -0.002368518738703],
            [29.871515633998296, -0.004343046272421],
            [29.871401468007143, -0.00522850217016],
            [29.870033825207905, -0.006084380137753],
            [29.870111514208613, -0.006536709728319],
            [29.870773088381064, -0.006791419838902],
            [29.870218633814666, -0.008056634922185],
            [29.870847003559273, -0.009284648071165],
            [29.870550393327186, -0.010794732210205],
            [29.87117965779383, -0.011256909127139],
            [29.87029253461982, -0.011852299908928],
            [29.870809988478005, -0.014903718742048],
            [29.87024023111072, -0.015543769257683],
            [29.87121657046717, -0.016206158176676],
            [29.870883896469664, -0.016541064473984],
            [29.87129048474704, -0.017062042400617],
            [29.87062513675208, -0.017657434065482],
            [29.870477268666423, -0.018736590043311],
            [29.87097801475863, -0.019825690364134],
            [29.8715861454599, -0.020076254736178],
            [29.87195574291049, -0.022122943801264],
            [29.871456719787016, -0.02322069846725],
            [29.871826332508963, -0.024113805243128],
            [29.87119793491658, -0.025230164001076],
            [29.873317765849322, -0.025218685329511],
            [29.874154990304234, -0.025788415690878],
            [29.873179631009783, -0.028407246097756],
            [29.873848127599807, -0.02866493319495],
            [29.874169099244085, -0.029294631467315],
            [29.874400237563318, -0.028689804847105],
            [29.874643819345877, -0.028319804098738],
            [29.87506889225686, -0.02846852017576],
            [29.874988816432424, -0.029111887212817],
            [29.87605744420958, -0.029054137225586],
            [29.87606832640092, -0.028266668756135],
            [29.875293304889563, -0.02768381402151],
            [29.87579746727476, -0.027260748893842],
            [29.87792878855831, -0.027574774728371],
            [29.8782194276887, -0.027148928416483],
            [29.876308552975892, -0.026336557739065],
            [29.876456841473086, -0.025908871673381],
            [29.878024686409823, -0.025785990239827],
            [29.877185411101138, -0.024701093179885],
            [29.878823448597544, -0.024650721053314],
            [29.878845192318988, -0.023075780460822],
            [29.880059148644506, -0.022805102816038],
            [29.879598473702156, -0.020078284928593],
            [29.88087569477986, -0.020381237247707],
            [29.88131362348087, -0.019599295162972],
            [29.881609199752067, -0.018815510630073],
            [29.88069478575976, -0.018016053187636],
            [29.88007297551333, -0.016647575916134],
            [29.880432810073433, -0.01636583191537],
            [29.88148760110026, -0.017310303496292],
            [29.88254931723962, -0.017753666085719],
            [29.88333423279554, -0.017620625598458],
            [29.88341232603812, -0.017120422111689],
            [29.882363465688826, -0.015746413906897],
            [29.883950086313295, -0.014263334949573],
            [29.884107262741942, -0.013191346605725],
            [29.88596674753229, -0.012571001527236],
            [29.885900508458185, -0.012212141647608],
            [29.88497917114995, -0.011913803961847],
            [29.886267255554383, -0.011429264385731],
            [29.886008237122002, -0.009564272055756],
            [29.887450538006185, -0.00822251153268],
            [29.887459426835928, -0.007578207477686],
            [29.88718557542157, -0.006787046840129],
            [29.88647381237418, -0.006777829227077],
            [29.885984465902943, -0.00612708694442],
            [29.888050566801894, -0.006010613181979],
            [29.88862590540205, -0.005588453509616],
            [29.887855795878615, -0.004647668577585],
            [29.888365885348104, -0.003795040712833],
            [29.889718237922917, -0.003812545284402],
            [29.8910887158052, -0.002969496154696],
            [29.892063073478116, -0.001483508402736],
            [29.8922445852678, 0.000292129435432],
            [29.893336565649065, 0.000815367545705],
            [29.89464467619613, 0.002649394978294],
            [29.894692886082492, 0.003030730714257],
            [29.894005824908792, 0.003365179782231],
            [29.894268005410993, 0.004008492101922],
            [29.89517002983889, 0.004412757334908],
            [29.896614964583527, 0.003576928863959],
            [29.897184335675203, 0.003671669685219],
            [29.898316552496393, 0.006471290816516],
            [29.898696628794763, 0.006780762226446],
            [29.899620422096994, 0.006231528672018],
            [29.90040498102174, 0.007184173159655],
            [29.90040629885025, 0.007827769342804],
            [29.899932569590217, 0.008114312152749],
            [29.89891187142506, 0.007662495501731],
            [29.89858253556718, 0.008973873207622],
            [29.898943179509335, 0.011381005991315],
            [29.900152185219316, 0.011141351647824],
            [29.900427569159554, 0.012440172689007],
            [29.901660541022995, 0.012319689747578],
            [29.902848844158907, 0.013557953554759],
            [29.902494907936973, 0.014440285088678],
            [29.90430026294326, 0.015892432355797],
            [29.905130500301876, 0.015986909967208],
            [29.905155574976394, 0.016654314178778],
            [29.90596273461538, 0.017058694379683],
            [29.90679525728811, 0.018273501351985],
            [29.907851266430438, 0.018594195400259],
            [29.907757318821393, 0.019047190620778],
            [29.908920078362232, 0.019379690326376],
            [29.9086430837427, 0.02312239403712],
            [29.90778877961927, 0.022861081328521],
            [29.907671267403703, 0.023385623749885],
            [29.908218805840754, 0.024410037257947],
            [29.909166375751887, 0.023884635152803],
            [29.910281166154856, 0.023954981318244],
            [29.90961924523269, 0.025004502731828],
            [29.91015563557706, 0.026374576234501],
            [29.9108175026003, 0.025301209953379],
            [29.911315972361564, 0.025515221870675],
            [29.911983778147142, 0.027373821622408],
            [29.912625506738358, 0.028064431958985],
            [29.913033496387566, 0.030447717792449],
            [29.912251454542254, 0.030734575872927],
            [29.912505074099784, 0.033010752838637],
            [29.910774341245858, 0.033274761368263],
            [29.910728108551442, 0.033870733269836],
            [29.911773296587867, 0.034703955580942],
            [29.913314536120833, 0.034559333134817],
            [29.913197739862543, 0.035441426476959],
            [29.91194213674216, 0.036110166380057],
            [29.9120140091514, 0.036467646384102],
            [29.912772632815575, 0.036323840509167],
            [29.913025465448918, 0.0382186277909],
            [29.912270831202914, 0.040340914218758],
            [29.911180192006377, 0.040485055158435],
            [29.910870251673796, 0.039674920497485],
            [29.91018267935868, 0.039770971937815],
            [29.910232608620486, 0.041010451787489],
            [29.91106568555373, 0.042511327819397],
            [29.91198854370971, 0.041485381971968],
            [29.912320751481584, 0.041580382381586],
            [29.912086903843434, 0.043225389455723],
            [29.909929340075507, 0.043513656951185],
            [29.908671819950314, 0.043228903664102],
            [29.907909603923315, 0.047484591038143],
            [29.906892075912783, 0.048605973782699],
            [29.9073444333539, 0.049487478569916],
            [29.907107948262077, 0.049821441524435],
            [29.907430478483384, 0.051699244023054],
            [29.907030266447872, 0.052479342490021],
            [29.90822628970537, 0.053992386846335],
            [29.907130468127946, 0.055148979826416],
            [29.908009528023946, 0.055934708886793],
            [29.907063370264414, 0.057175191858301],
            [29.908287609604976, 0.058616092431651],
            [29.907173871129203, 0.059070126787941],
            [29.9074838402079, 0.059904101586948],
            [29.907248206718954, 0.060667131065246],
            [29.908126406028934, 0.061023797964536],
            [29.907891758890205, 0.062287391766036],
            [29.90841455323274, 0.062811285334295],
            [29.909196741503443, 0.062595952103108],
            [29.909839111491745, 0.063620303095183],
            [29.91062078592611, 0.063142770660423],
            [29.910895870727384, 0.064322432171792],
            [29.913057331386984, 0.065988849963743],
            [29.91320085971153, 0.066608469702665],
            [29.912656528260055, 0.067181114763291],
            [29.914176765181683, 0.068395272359917],
            [29.9139265466458, 0.068816090548033],
            [29.912329908907598, 0.069898870489151],
            [29.908489029857993, 0.07045096836043],
            [29.906365918277853, 0.070178975765223],
            [29.90565506612215, 0.070489572532264],
            [29.904849905234677, 0.071086297767254],
            [29.903834580791553, 0.07332798069304],
            [29.902792883608285, 0.074234824728872],
            [29.90061310630003, 0.075127764634122],
            [29.899843417188173, 0.077168317440762],
            [29.90094923342144, 0.078704695666622],
            [29.900666997132234, 0.079896813704054],
            [29.899198320812978, 0.080756403568124],
            [29.89943811709491, 0.082091022949828],
            [29.897417647019115, 0.085751971808559],
            [29.89661778798844, 0.089042231863031],
            [29.895517994060853, 0.09055694408187],
            [29.894570260656305, 0.091010775088639],
            [29.89227729831717, 0.094803057481565],
            [29.89293225909252, 0.096220695844833],
            [29.892393888861285, 0.099844393784871],
            [29.89360510622349, 0.100725175300437],
            [29.894271746894137, 0.102059379817359],
            [29.891491952468233, 0.105530313462321],
            [29.889047736293136, 0.110836323601986],
            [29.886441568245363, 0.118240066169661],
            [29.88386292188296, 0.121508129121877],
            [29.880751276316403, 0.121557757336444],
            [29.880017902498206, 0.122488073891057],
            [29.87717530595249, 0.124159323622014],
            [29.87553136382973, 0.126365738790209],
            [29.874670213645565, 0.128354373947441],
            [29.87330896595279, 0.128468404006578],
            [29.872287928224466, 0.129362843491112],
            [29.870453143511142, 0.136347848575253],
            [29.86702084789717, 0.142761607537615],
            [29.864193982648718, 0.145844597848041],
            [29.86149959734508, 0.147975930989892],
            [29.855789780533406, 0.149802277051109],
            [29.849787020412634, 0.151247896712992],
            [29.847289306867427, 0.151482464879756],
            [29.845893620461634, 0.144529520596574],
            [29.846020116728344, 0.143399014143137],
            [29.84425895703743, 0.139837616349485],
            [29.84376104692659, 0.136912316853822],
            [29.844069997315707, 0.135866623333682],
            [29.843263251800085, 0.132941291016156],
            [29.851040830495712, 0.118493025823986],
            [29.86005872568052, 0.105940932679489],
            [29.86293875592242, 0.105816186543919],
            [29.865591233021433, 0.105184781564049],
            [29.866218775417643, 0.104323463037834],
            [29.867388464562595, 0.100906755979268],
            [29.867474163840694, 0.09947112278939],
            [29.868757737804067, 0.098006892610142],
            [29.86901455626233, 0.096599983783753],
            [29.87004140968383, 0.095451571052583],
            [29.871039670628146, 0.095078394331387],
            [29.871182386875645, 0.093872466092388],
            [29.87180988345781, 0.093413116778632],
            [29.871011538088414, 0.090800164437063],
            [29.87136813691684, 0.089780887773981],
            [29.87233789791044, 0.089149291152539],
            [29.872651760287557, 0.087627529804053],
            [29.87382127246438, 0.085732572711728],
            [29.873151228077127, 0.083392408249954],
            [29.873664679042378, 0.082416208256026],
            [29.8780570572011, 0.08037793383164],
            [29.882130704113866, 0.079802192450439],
            [29.88428892365194, 0.08007694191268],
            [29.88551537015317, 0.079617625669069],
            [29.886228463605462, 0.078784992400774],
            [29.886285600050815, 0.077521610147068],
            [29.885030827872043, 0.075425440909517],
            [29.886742394271096, 0.071262132068682],
            [29.88813445956796, 0.070946334065303],
            [29.887990191031673, 0.069949806724438],
            [29.88668485178726, 0.069450547713449],
            [29.882416913651593, 0.069860048924694],
            [29.880735492018538, 0.071053545217178],
            [29.880142432352805, 0.070958795485351],
            [29.878038932791927, 0.068589188846797],
            [29.876913601557415, 0.068125378215911],
            [29.876556432298766, 0.064475709815283],
            [29.87778549918566, 0.062502114144459],
            [29.878189605417884, 0.0595231765875],
            [29.879451135622524, 0.057253577014283],
            [29.879590715851393, 0.055894763520082],
            [29.88018168962903, 0.054940714507054],
            [29.87863925623505, 0.048542214081692],
            [29.879233483710646, 0.043309525641247],
            [29.87899379342991, 0.042046450684728],
            [29.880092837264282, 0.040197994987311],
            [29.879514739039582, 0.035765031020849],
            [29.88143956818203, 0.031818115522315],
            [29.88134277650681, 0.030864757010123],
            [29.878217178307228, 0.027375985663702],
            [29.877616377858676, 0.02346745487554],
            [29.876723551280957, 0.0217402570267],
            [29.87494318830419, 0.020884013499852],
            [29.874396046024195, 0.020050318578904],
            [29.874347014179353, 0.01926377442367],
            [29.873132747935102, 0.016905263932538],
            [29.87387631853005, 0.015205505056395],
            [29.873401032489646, 0.014723965859689],
            [29.872927224177868, 0.014962827885719],
            [29.872381149096427, 0.014653533452178],
            [29.87237954201039, 0.013866947952517],
            [29.871118720576526, 0.01193754284103],
            [29.8711861157824, 0.010102088018562],
            [29.870807613332378, 0.00971672603877],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 330,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KISINGA TOWN COUNCIL",
        Population: 16041,
        Key: "KASESEKISINGA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.74978166087792, 0.080594012580238],
            [29.75023982592734, 0.081115417608184],
            [29.75163851899439, 0.080947204646189],
            [29.752209014776827, 0.081661646648731],
            [29.756337481379802, 0.082944581484625],
            [29.757123418320194, 0.084683647047027],
            [29.758560608688754, 0.086004996397155],
            [29.760422651881036, 0.089052425932581],
            [29.76246698929561, 0.088896943015737],
            [29.76310521176225, 0.087871468830009],
            [29.763912567233938, 0.088442688876718],
            [29.765786368475, 0.088703021233289],
            [29.766661903381824, 0.087772641688423],
            [29.769365137091004, 0.087769990763132],
            [29.772824375875288, 0.086336560600285],
            [29.773466263468283, 0.087170118075028],
            [29.77471854551707, 0.090922734013571],
            [29.77633391043403, 0.092398853680944],
            [29.776431519576178, 0.093804970365732],
            [29.778070785069577, 0.095376409116992],
            [29.777423412363436, 0.097796196661104],
            [29.778493092067798, 0.099129860512004],
            [29.777996798924434, 0.099988369251483],
            [29.77622006064985, 0.100871945417679],
            [29.776626528552985, 0.102587596446926],
            [29.777658753001564, 0.102956029986547],
            [29.778478825922754, 0.103968177234965],
            [29.7790954439068, 0.104015248878306],
            [29.779592258073013, 0.10341892391523],
            [29.780518919695908, 0.104371387180442],
            [29.783479921382618, 0.10277164119015],
            [29.78393269474369, 0.103915242297309],
            [29.783532174586043, 0.105250341401239],
            [29.785251113458646, 0.105117596677073],
            [29.785749410743367, 0.105283951810881],
            [29.786629346496774, 0.106593988801475],
            [29.788408660241295, 0.107021290588538],
            [29.788953551343162, 0.10675858862231],
            [29.789670597382752, 0.109665679918596],
            [29.790903544093343, 0.109592992870445],
            [29.79168778770944, 0.110474108283593],
            [29.792564896464643, 0.110330262222517],
            [29.793125242182676, 0.111914708638982],
            [29.794477440247256, 0.112199424632178],
            [29.79481442525976, 0.114773219534641],
            [29.797593812748843, 0.117320847234453],
            [29.79908873155248, 0.117819949257221],
            [29.79991730343458, 0.117388702235405],
            [29.80074101363435, 0.118548475114555],
            [29.802031445336635, 0.118644052961116],
            [29.80176499154861, 0.121579929504361],
            [29.800627377649224, 0.123803735332464],
            [29.801509439714927, 0.124706642477697],
            [29.801447313128197, 0.125932374581238],
            [29.80333552514299, 0.126453738439565],
            [29.803525025650497, 0.126908822053522],
            [29.802803169132584, 0.127532612445721],
            [29.802755692271525, 0.128273926422214],
            [29.805584332590968, 0.129375263566588],
            [29.805715419248816, 0.130527625737236],
            [29.807406466330136, 0.133529835954624],
            [29.807592249608987, 0.134506051367958],
            [29.80895903182221, 0.136187055984045],
            [29.809370730615235, 0.137845914380332],
            [29.80876177795549, 0.139196358579996],
            [29.809461548493825, 0.140165309108772],
            [29.812162735840754, 0.140371206846444],
            [29.812549025785977, 0.141222684095685],
            [29.81346401380179, 0.141193452106814],
            [29.81434247182654, 0.141766082337203],
            [29.815592935685196, 0.141024929568916],
            [29.818600405424892, 0.140878560316062],
            [29.82090381247582, 0.144277262787851],
            [29.82412257585184, 0.145180530297358],
            [29.82420255914977, 0.14672926663615],
            [29.826010736662667, 0.146362530620989],
            [29.827377967135206, 0.144975478812978],
            [29.828227309863294, 0.145210482727703],
            [29.828733696477176, 0.147507963283267],
            [29.82817584987227, 0.14819050096371],
            [29.828532955350525, 0.149181442691645],
            [29.828099023254204, 0.150032823489683],
            [29.82802217148335, 0.152102671253473],
            [29.82470286416917, 0.164844304919988],
            [29.82354502829442, 0.171951434827768],
            [29.822405896242202, 0.170893228650884],
            [29.82180986045792, 0.169201479351335],
            [29.821228259701932, 0.168880236017327],
            [29.81989528648277, 0.166235754453113],
            [29.816382213460127, 0.164427484755657],
            [29.815241336879616, 0.16304610427161],
            [29.814553771751036, 0.163118227018652],
            [29.81268291608583, 0.164454676647305],
            [29.811627952582455, 0.164610564249098],
            [29.80883006069686, 0.164779941794468],
            [29.807927681434375, 0.164113396395692],
            [29.806151103059907, 0.165139901525138],
            [29.805342817831892, 0.164068073880537],
            [29.802998413468032, 0.165786287880636],
            [29.799194145257808, 0.166707368884929],
            [29.798864585719414, 0.167994726450778],
            [29.798248170754615, 0.168066783603115],
            [29.79786741173662, 0.167352096906181],
            [29.797061830437595, 0.167710341713452],
            [29.79376477888457, 0.167236627951789],
            [29.79262839298218, 0.168214871138364],
            [29.79194061225794, 0.168167822078066],
            [29.791799597419573, 0.168835307871809],
            [29.791254726978934, 0.169121813505896],
            [29.790779744569086, 0.168740899836674],
            [29.789334640941192, 0.169481056304517],
            [29.787219445315333, 0.166980376522075],
            [29.785677917423165, 0.166886426616828],
            [29.784797425612595, 0.16524267375639],
            [29.78448970232214, 0.165528956661613],
            [29.78394340266189, 0.165052772490809],
            [29.78368546849604, 0.166635025166269],
            [29.782951891658595, 0.167446053097386],
            [29.781743511176064, 0.16797149611738],
            [29.780154429167716, 0.167806092729141],
            [29.779679138635725, 0.167258335648133],
            [29.779820384341114, 0.166710022497055],
            [29.776892223264564, 0.166915266906681],
            [29.775845166732342, 0.164961825631957],
            [29.77484931866286, 0.165010396439682],
            [29.773424473841278, 0.163915318687106],
            [29.773636543621958, 0.163200110819736],
            [29.77320876857861, 0.162699997367466],
            [29.77098246572515, 0.164132043547838],
            [29.76932123013484, 0.163418537090445],
            [29.768996080426195, 0.160761361656053],
            [29.769704707454917, 0.159306855645938],
            [29.769748249695063, 0.157257106516847],
            [29.770528191279226, 0.15589786175286],
            [29.76906666554963, 0.154218921126756],
            [29.769562687401766, 0.153193607513893],
            [29.769394031402108, 0.15178756851267],
            [29.76873002549018, 0.151764341754178],
            [29.768444158210578, 0.151073422932472],
            [29.767779933109722, 0.150931035962837],
            [29.767752138336498, 0.148786018216809],
            [29.76724115863659, 0.148178729479582],
            [29.765461444243464, 0.147513027069724],
            [29.76515054181522, 0.146130956474908],
            [29.76339354401899, 0.144940902768356],
            [29.76239797981716, 0.1451324930417],
            [29.76163577007837, 0.143345670551938],
            [29.759736082984112, 0.141941245195921],
            [29.758550154095467, 0.141775517313735],
            [29.75737326764847, 0.140144012812031],
            [29.755973234295027, 0.139620976584832],
            [29.752811870570742, 0.135643737564285],
            [29.750782073287354, 0.134394376712561],
            [29.749922810463584, 0.131463680393224],
            [29.74468192680661, 0.131206427826213],
            [29.743708446787718, 0.130540003591419],
            [29.744038768995786, 0.129681705076366],
            [29.74266108482828, 0.128443669855693],
            [29.742780144841127, 0.126236609875108],
            [29.741544425031222, 0.127300731793133],
            [29.73959642025276, 0.125419754892481],
            [29.736513960051465, 0.1254703209386],
            [29.73549219738268, 0.124351138636942],
            [29.7365538524366, 0.121561667694075],
            [29.73854541831982, 0.121440617286746],
            [29.73772476418863, 0.120094827199745],
            [29.739266588524846, 0.120379359854603],
            [29.73988295857389, 0.12030728278848],
            [29.739906023717133, 0.119973593529978],
            [29.738836316164996, 0.118592289450433],
            [29.73762788807175, 0.119046270069343],
            [29.737224045045906, 0.118665319631531],
            [29.7365089142145, 0.116711695520799],
            [29.73743835163166, 0.113004771712287],
            [29.73727177253693, 0.112695101474924],
            [29.735944273651114, 0.112887027061807],
            [29.73549046722744, 0.11119532564825],
            [29.73404039501774, 0.109313909278763],
            [29.734593291007105, 0.107084990014129],
            [29.733808953067914, 0.106132428017273],
            [29.733897390411, 0.102843391313014],
            [29.73399135957961, 0.102390480337786],
            [29.73502247730376, 0.102210734024176],
            [29.735258284167546, 0.101543179025493],
            [29.734544747845785, 0.100423720918434],
            [29.734398943190328, 0.098612555646087],
            [29.7338753322792, 0.097612074634927],
            [29.73475182748509, 0.097182234985766],
            [29.73422886425927, 0.096515417401317],
            [29.734462727168772, 0.094846888020884],
            [29.733673792550267, 0.091558700004154],
            [29.734324436920666, 0.090831162563632],
            [29.735055097826695, 0.088820617749408],
            [29.736044642417813, 0.088710815905695],
            [29.736374405873747, 0.087590341391387],
            [29.73720521276429, 0.088042350653584],
            [29.738061966593467, 0.089638319923252],
            [29.739078218996287, 0.087921352219032],
            [29.741023997749476, 0.088634435841792],
            [29.742944426943648, 0.088513389798544],
            [29.74491940094354, 0.085973212241581],
            [29.746340017395116, 0.084899317937537],
            [29.74640918048548, 0.083898256233923],
            [29.748431194765214, 0.081167350061008],
            [29.74978166087792, 0.080594012580238],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 331,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KITHOLHU",
        Population: 16871,
        Key: "KASESEKITHOLHU",
        Dist2: "Kasese",
        "Sub Country": "Kitholhu",
        id2_original: "Kasese Kitholhu",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.900659343486, 0.321449644821671],
            [29.900068108298605, 0.32232854352377],
            [29.89356341002124, 0.327951121539643],
            [29.88865066925947, 0.331787646650029],
            [29.88638287861293, 0.334714459255071],
            [29.882751150717674, 0.342377879209835],
            [29.881456841886614, 0.344210035803058],
            [29.87964742829188, 0.345776922578718],
            [29.875090131125102, 0.347942218891761],
            [29.864491943048677, 0.350090541357481],
            [29.85640683689534, 0.315172992711451],
            [29.85933599330521, 0.313060147390076],
            [29.86037616964066, 0.311678746760922],
            [29.86066774212063, 0.310206399149642],
            [29.861375086355125, 0.309187762227399],
            [29.864591930929677, 0.30754181914029],
            [29.86563227794508, 0.305567236323017],
            [29.8666314452895, 0.302182998767059],
            [29.86793479925713, 0.301569271995221],
            [29.86865621919382, 0.299810916804606],
            [29.870819795385952, 0.296845708977075],
            [29.872650758666023, 0.293447714803198],
            [29.87446730308749, 0.29201066446296],
            [29.875576362238938, 0.292164505244513],
            [29.878182939918492, 0.291474365512671],
            [29.88306424773016, 0.286932718261675],
            [29.88653072963057, 0.285007597789531],
            [29.887196694768143, 0.283172408037347],
            [29.887862156849167, 0.283172589494811],
            [29.88851404808117, 0.282098071961554],
            [29.88784878362954, 0.281372115326033],
            [29.887959819890206, 0.28089760215913],
            [29.88877856510143, 0.277987768085554],
            [29.890179601873033, 0.275008277832083],
            [29.889223568035277, 0.272788835619918],
            [29.887269205879583, 0.271078575769425],
            [29.886368488500395, 0.2693755712898],
            [29.888646045630708, 0.253792998069237],
            [29.889464782757056, 0.250597002912253],
            [29.88972944081282, 0.247348186529151],
            [29.889455018968235, 0.24634301878408],
            [29.89012776279293, 0.245034399245476],
            [29.890822631224776, 0.244899168996917],
            [29.89240893384564, 0.242789701268901],
            [29.892252255083683, 0.241875775151496],
            [29.890325104694565, 0.23973163767612],
            [29.89043746147873, 0.238501859253386],
            [29.88918837653405, 0.23623377276227],
            [29.88839280965381, 0.235624337484096],
            [29.887659425055844, 0.232544031099917],
            [29.886219654725792, 0.231020566420917],
            [29.88608538533689, 0.230027666573861],
            [29.88738038317576, 0.22736527891023],
            [29.887229642277816, 0.224804100465091],
            [29.88764513196136, 0.220934276431518],
            [29.88822819966618, 0.219501520848669],
            [29.889646072662856, 0.218655625750102],
            [29.891433709298486, 0.218215981766986],
            [29.89296402711421, 0.21559873468755],
            [29.895272845616418, 0.214922260442199],
            [29.897441772174396, 0.213286720901861],
            [29.89887637898817, 0.212869565931553],
            [29.89907824660222, 0.212170075987829],
            [29.89796336906263, 0.210996447647956],
            [29.897459303695488, 0.209676280724134],
            [29.8968261396422, 0.209484346167947],
            [29.89377282348364, 0.206245611201436],
            [29.893202128275213, 0.201766298229987],
            [29.89432889861084, 0.199408456044261],
            [29.89415553364247, 0.19760319631432],
            [29.893550564112683, 0.1964184072053],
            [29.893780805913245, 0.193778316112009],
            [29.894296391275642, 0.19346249361762],
            [29.894503935343945, 0.192300433262602],
            [29.896762891059662, 0.188419620365631],
            [29.898180473900513, 0.189096835023703],
            [29.898785696755212, 0.188927702938929],
            [29.89906615797341, 0.187359459520529],
            [29.899777829392658, 0.187280614809426],
            [29.900416762426673, 0.186581201031386],
            [29.89989032002579, 0.184899989455146],
            [29.90149861969301, 0.184584358139325],
            [29.901868619588875, 0.183659246395449],
            [29.903286568942367, 0.182294282146396],
            [29.903203101977727, 0.178886888588322],
            [29.90362387106018, 0.175930892112054],
            [29.904660793697715, 0.174441742063543],
            [29.905321968119853, 0.174769056988809],
            [29.90547894063093, 0.174351618101864],
            [29.904745294623215, 0.17168877041637],
            [29.905866030975034, 0.171655105303893],
            [29.906443540803206, 0.169624303727444],
            [29.90791757018324, 0.167898280142944],
            [29.907895483305374, 0.165856090279131],
            [29.909533079728963, 0.164497174869982],
            [29.90975501301148, 0.162721105894878],
            [29.910890700922923, 0.161313680542071],
            [29.912929919737003, 0.161121113050191],
            [29.914019669601405, 0.160500349989468],
            [29.9144692808927, 0.159975528405159],
            [29.91465492852596, 0.157830009415114],
            [29.915471073114407, 0.156744668978443],
            [29.916323393757644, 0.155981093050632],
            [29.917271760474442, 0.155837199644535],
            [29.91821400337596, 0.154393610476629],
            [29.920063538426227, 0.154225045818179],
            [29.92165999650141, 0.15192327562768],
            [29.92282286024681, 0.152327428046111],
            [29.923650831155953, 0.151230143369904],
            [29.92497780093412, 0.150632978678634],
            [29.926045769347837, 0.15101338962895],
            [29.926162429960527, 0.150012107511933],
            [29.926588688647673, 0.149677991962733],
            [29.92834451683738, 0.150105438556611],
            [29.928686606077356, 0.149163534837168],
            [29.928257426068917, 0.147972062857191],
            [29.927354479071198, 0.147067077886763],
            [29.928419113836892, 0.145707353683172],
            [29.928462072172117, 0.143371238321526],
            [29.92895892227091, 0.142751002958596],
            [29.930368876618374, 0.14214182580608],
            [29.930580176542875, 0.141021272538476],
            [29.931812101869003, 0.140328823560181],
            [29.933300735160614, 0.137466918950746],
            [29.93422494528109, 0.13708465635182],
            [29.93437568438241, 0.135308604018088],
            [29.936506447812164, 0.133375750148528],
            [29.938071694821094, 0.133350436590724],
            [29.93913727910605, 0.132491276690262],
            [29.940204804650367, 0.132633288278481],
            [29.94041636598459, 0.131655742389611],
            [29.94010566298234, 0.13041647657702],
            [29.941908210753358, 0.130462441454353],
            [29.94230831768594, 0.12886493823774],
            [29.945042448050987, 0.126204425113197],
            [29.947079546841014, 0.124891403933792],
            [29.948147265523108, 0.125128769707923],
            [29.94912177680793, 0.124514157323735],
            [29.949565699966836, 0.122767460084302],
            [29.95044184123647, 0.122051488267188],
            [29.950712803668896, 0.121133466911301],
            [29.950970729749915, 0.119607590140446],
            [29.950612521140453, 0.118344518455015],
            [29.951524335408354, 0.11645428021575],
            [29.951508482838545, 0.115626130443676],
            [29.95009402074498, 0.113923073609141],
            [29.9485040197601, 0.113424005653793],
            [29.947100288940927, 0.111136917298411],
            [29.94548499858416, 0.109827399729261],
            [29.94529303309952, 0.1086833613623],
            [29.942052202608572, 0.106886748346202],
            [29.94195370862585, 0.105027492212323],
            [29.941122184879752, 0.104289328011926],
            [29.94019360804864, 0.102430888291375],
            [29.940531821058176, 0.099534276953563],
            [29.93889384464721, 0.098749222435769],
            [29.93808421823446, 0.097081382172054],
            [29.936444738942015, 0.095533535021911],
            [29.936205193290046, 0.094318051432002],
            [29.93290556806373, 0.092771839988149],
            [29.932476896501747, 0.091866431883538],
            [29.9300566635481, 0.091272869020983],
            [29.92993686242519, 0.090653211918917],
            [29.929011307526718, 0.090344235864038],
            [29.92851148669925, 0.08943889866528],
            [29.926897661494685, 0.088868391895409],
            [29.92625483246726, 0.087605641479436],
            [29.924569575926263, 0.08689218593496],
            [29.923879460480595, 0.085700999659776],
            [29.922266336860293, 0.085488052462654],
            [29.921553774312326, 0.084940502953128],
            [29.921457169486665, 0.084058610729791],
            [29.920152361146595, 0.083845369774867],
            [29.919275735684998, 0.078280233110048],
            [29.917685352017784, 0.077566692956611],
            [29.916329198671022, 0.075375023906176],
            [29.915332654407223, 0.075137646093731],
            [29.915379377581758, 0.074780041458227],
            [29.91459580680385, 0.074304078490891],
            [29.915306010375875, 0.073659771373635],
            [29.915422466172696, 0.072586983473784],
            [29.91470942482267, 0.07180106063201],
            [29.9139265466458, 0.068816090548033],
            [29.914176765181683, 0.068395272359917],
            [29.912656528260055, 0.067181114763291],
            [29.91320085971153, 0.066608469702665],
            [29.913057331386984, 0.065988849963743],
            [29.910895870727384, 0.064322432171792],
            [29.91062078592611, 0.063142770660423],
            [29.909839111491745, 0.063620303095183],
            [29.909196741503443, 0.062595952103108],
            [29.90841455323274, 0.062811285334295],
            [29.907891758890205, 0.062287391766036],
            [29.908126406028934, 0.061023797964536],
            [29.907248206718954, 0.060667131065246],
            [29.9074838402079, 0.059904101586948],
            [29.907173871129203, 0.059070126787941],
            [29.908287609604976, 0.058616092431651],
            [29.907063370264414, 0.057175191858301],
            [29.908009528023946, 0.055934708886793],
            [29.907130468127946, 0.055148979826416],
            [29.90822628970537, 0.053992386846335],
            [29.913629605833712, 0.053535430232154],
            [29.92054528515019, 0.05585090778877],
            [29.93766294250218, 0.063711761416109],
            [29.941079098983767, 0.06579255023768],
            [29.943314331091177, 0.06766096930301],
            [29.94445310022403, 0.067661044761447],
            [29.94576365688359, 0.068790809279215],
            [29.946308724055292, 0.069869129088838],
            [29.951622876103464, 0.071610394260589],
            [29.95558745226935, 0.072459893522435],
            [29.955291227414513, 0.085537934058226],
            [29.955797267278687, 0.086557044649287],
            [29.957043733634325, 0.086840595747478],
            [29.959456346179394, 0.086642522844195],
            [29.961622690080926, 0.08748536888138],
            [29.965367276918588, 0.087235308739686],
            [29.966174176944445, 0.086098744474479],
            [29.967389958646596, 0.085792857684605],
            [29.967617969930338, 0.085142649720538],
            [29.9682258535949, 0.085104449803558],
            [29.968681848314567, 0.084071774627788],
            [29.969555682710595, 0.08399534963889],
            [29.972405255572802, 0.082427380591634],
            [29.97495099215477, 0.079520672390595],
            [29.97691131732736, 0.078402214330123],
            [29.97900325646883, 0.080831662551164],
            [29.980304354766783, 0.085133247963129],
            [29.983694536461933, 0.090434006195305],
            [29.985048407189538, 0.091433891830995],
            [29.985633633546012, 0.093543042640176],
            [29.98776166160571, 0.094698782982604],
            [29.98950544698073, 0.096519095997178],
            [29.99008267563621, 0.098116213826867],
            [29.985784108542614, 0.099452286942897],
            [29.983803464376642, 0.100457735574397],
            [29.98261864490738, 0.110641966266761],
            [29.982719951515246, 0.112443339221004],
            [29.984826856589358, 0.112536922831993],
            [29.986484017421503, 0.113175232993595],
            [29.989250395508627, 0.112648459238948],
            [29.988385818251658, 0.114233687960834],
            [29.98514133970233, 0.115412584266704],
            [29.983694276848798, 0.116669165770188],
            [29.979607904401718, 0.125008857479591],
            [29.97793353903523, 0.12903591594937],
            [29.97558204067555, 0.137633227173303],
            [29.975477892696468, 0.141388691357002],
            [29.97431400576997, 0.146444006652946],
            [29.974605715692157, 0.153733568521252],
            [29.976877556842346, 0.160643134846526],
            [29.976805204732724, 0.169925794979515],
            [29.978306418929883, 0.171218729946825],
            [29.976017909539618, 0.175386132029416],
            [29.976017348990897, 0.178786157392915],
            [29.97385385544376, 0.183926323138489],
            [29.973253927259357, 0.186513339061282],
            [29.972850194726288, 0.186227637684798],
            [29.97223474814536, 0.186871817957202],
            [29.972118310314848, 0.188016177470298],
            [29.970719129462612, 0.188088941514697],
            [29.97103049092997, 0.189709676735073],
            [29.969883362973388, 0.191391310053724],
            [29.968744972031278, 0.191416157315827],
            [29.96810541287149, 0.19184581551983],
            [29.9674918015487, 0.193467367848584],
            [29.96775460278673, 0.194492189695702],
            [29.9668534838606, 0.194564498269441],
            [29.965314493709133, 0.195972323518479],
            [29.964968645918, 0.197832228517135],
            [29.964163550607548, 0.198524249641496],
            [29.964663303163025, 0.199429657953168],
            [29.964521804132726, 0.19985887847509],
            [29.96314851991351, 0.20109967245885],
            [29.962408025150058, 0.204640303362387],
            [29.96312162255725, 0.205760072233729],
            [29.96345796257944, 0.20807208983118],
            [29.96322336215309, 0.209454913064382],
            [29.963889744108943, 0.210693924956434],
            [29.96358253285817, 0.211290143547638],
            [29.962220050880255, 0.211970728615364],
            [29.96264988396392, 0.213543678613091],
            [29.962082259197143, 0.214402342560951],
            [29.962347520022426, 0.216762100395142],
            [29.962076604302414, 0.21775161810957],
            [29.95987676941047, 0.220924002475993],
            [29.95584046007419, 0.224968042639914],
            [29.947493537236337, 0.227697557723858],
            [29.94524943875708, 0.22914324275109],
            [29.94002545869882, 0.230839254631624],
            [29.934931866409094, 0.233551162661384],
            [29.930301105916715, 0.237087809088771],
            [29.922413648888785, 0.243829816123682],
            [29.91500031458301, 0.256431903313161],
            [29.908807940766994, 0.261758012275734],
            [29.9082355845736, 0.26274522617711],
            [29.90786712349184, 0.265460368753084],
            [29.90792702854488, 0.270952571392485],
            [29.90667764985111, 0.282409712616741],
            [29.904918795237183, 0.288539075277886],
            [29.902567637339015, 0.293701466675348],
            [29.89943890581572, 0.302813015326061],
            [29.899437405629204, 0.307996608946079],
            [29.900431166013934, 0.312413357444077],
            [29.900825002705872, 0.314126829608802],
            [29.900659343486, 0.321449644821671],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 332,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KYARUMBA",
        Population: 42074,
        Key: "KASESEKYARUMBA",
        Dist2: "Kasese",
        "Sub Country": "Kyarumba",
        id2_original: "Kasese Kyarumba",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.9139265466458, 0.068816090548033],
            [29.91470942482267, 0.07180106063201],
            [29.915422466172696, 0.072586983473784],
            [29.915306010375875, 0.073659771373635],
            [29.91459580680385, 0.074304078490891],
            [29.915379377581758, 0.074780041458227],
            [29.915332654407223, 0.075137646093731],
            [29.916329198671022, 0.075375023906176],
            [29.917685352017784, 0.077566692956611],
            [29.919275735684998, 0.078280233110048],
            [29.920152361146595, 0.083845369774867],
            [29.921457169486665, 0.084058610729791],
            [29.921553774312326, 0.084940502953128],
            [29.922266336860293, 0.085488052462654],
            [29.923879460480595, 0.085700999659776],
            [29.924569575926263, 0.08689218593496],
            [29.92625483246726, 0.087605641479436],
            [29.926897661494685, 0.088868391895409],
            [29.92851148669925, 0.08943889866528],
            [29.929011307526718, 0.090344235864038],
            [29.92993686242519, 0.090653211918917],
            [29.9300566635481, 0.091272869020983],
            [29.932476896501747, 0.091866431883538],
            [29.93290556806373, 0.092771839988149],
            [29.936205193290046, 0.094318051432002],
            [29.936444738942015, 0.095533535021911],
            [29.93808421823446, 0.097081382172054],
            [29.93889384464721, 0.098749222435769],
            [29.940531821058176, 0.099534276953563],
            [29.94019360804864, 0.102430888291375],
            [29.941122184879752, 0.104289328011926],
            [29.94195370862585, 0.105027492212323],
            [29.942052202608572, 0.106886748346202],
            [29.94529303309952, 0.1086833613623],
            [29.94548499858416, 0.109827399729261],
            [29.947100288940927, 0.111136917298411],
            [29.9485040197601, 0.113424005653793],
            [29.95009402074498, 0.113923073609141],
            [29.951508482838545, 0.115626130443676],
            [29.951524335408354, 0.11645428021575],
            [29.950612521140453, 0.118344518455015],
            [29.950970729749915, 0.119607590140446],
            [29.950712803668896, 0.121133466911301],
            [29.95044184123647, 0.122051488267188],
            [29.949565699966836, 0.122767460084302],
            [29.94912177680793, 0.124514157323735],
            [29.948147265523108, 0.125128769707923],
            [29.947079546841014, 0.124891403933792],
            [29.945042448050987, 0.126204425113197],
            [29.94230831768594, 0.12886493823774],
            [29.941908210753358, 0.130462441454353],
            [29.94010566298234, 0.13041647657702],
            [29.94041636598459, 0.131655742389611],
            [29.940204804650367, 0.132633288278481],
            [29.93913727910605, 0.132491276690262],
            [29.938071694821094, 0.133350436590724],
            [29.936506447812164, 0.133375750148528],
            [29.93437568438241, 0.135308604018088],
            [29.93422494528109, 0.13708465635182],
            [29.933300735160614, 0.137466918950746],
            [29.931812101869003, 0.140328823560181],
            [29.930580176542875, 0.141021272538476],
            [29.930368876618374, 0.14214182580608],
            [29.92895892227091, 0.142751002958596],
            [29.928462072172117, 0.143371238321526],
            [29.928419113836892, 0.145707353683172],
            [29.927354479071198, 0.147067077886763],
            [29.928257426068917, 0.147972062857191],
            [29.928686606077356, 0.149163534837168],
            [29.92834451683738, 0.150105438556611],
            [29.926588688647673, 0.149677991962733],
            [29.926162429960527, 0.150012107511933],
            [29.926045769347837, 0.15101338962895],
            [29.92497780093412, 0.150632978678634],
            [29.923650831155953, 0.151230143369904],
            [29.92282286024681, 0.152327428046111],
            [29.92165999650141, 0.15192327562768],
            [29.920063538426227, 0.154225045818179],
            [29.91821400337596, 0.154393610476629],
            [29.917271760474442, 0.155837199644535],
            [29.916323393757644, 0.155981093050632],
            [29.915471073114407, 0.156744668978443],
            [29.91465492852596, 0.157830009415114],
            [29.9144692808927, 0.159975528405159],
            [29.914019669601405, 0.160500349989468],
            [29.912929919737003, 0.161121113050191],
            [29.910890700922923, 0.161313680542071],
            [29.90975501301148, 0.162721105894878],
            [29.909533079728963, 0.164497174869982],
            [29.907895483305374, 0.165856090279131],
            [29.90791757018324, 0.167898280142944],
            [29.906443540803206, 0.169624303727444],
            [29.905866030975034, 0.171655105303893],
            [29.904745294623215, 0.17168877041637],
            [29.90547894063093, 0.174351618101864],
            [29.905321968119853, 0.174769056988809],
            [29.904660793697715, 0.174441742063543],
            [29.90362387106018, 0.175930892112054],
            [29.903203101977727, 0.178886888588322],
            [29.903286568942367, 0.182294282146396],
            [29.901868619588875, 0.183659246395449],
            [29.90149861969301, 0.184584358139325],
            [29.89989032002579, 0.184899989455146],
            [29.900416762426673, 0.186581201031386],
            [29.899777829392658, 0.187280614809426],
            [29.89906615797341, 0.187359459520529],
            [29.898785696755212, 0.188927702938929],
            [29.898180473900513, 0.189096835023703],
            [29.896762891059662, 0.188419620365631],
            [29.894503935343945, 0.192300433262602],
            [29.894296391275642, 0.19346249361762],
            [29.893780805913245, 0.193778316112009],
            [29.893550564112683, 0.1964184072053],
            [29.89415553364247, 0.19760319631432],
            [29.89432889861084, 0.199408456044261],
            [29.893202128275213, 0.201766298229987],
            [29.89377282348364, 0.206245611201436],
            [29.8968261396422, 0.209484346167947],
            [29.897459303695488, 0.209676280724134],
            [29.89796336906263, 0.210996447647956],
            [29.89907824660222, 0.212170075987829],
            [29.89887637898817, 0.212869565931553],
            [29.897441772174396, 0.213286720901861],
            [29.895272845616418, 0.214922260442199],
            [29.89296402711421, 0.21559873468755],
            [29.891433709298486, 0.218215981766986],
            [29.889646072662856, 0.218655625750102],
            [29.88822819966618, 0.219501520848669],
            [29.88764513196136, 0.220934276431518],
            [29.887229642277816, 0.224804100465091],
            [29.88738038317576, 0.22736527891023],
            [29.88608538533689, 0.230027666573861],
            [29.886219654725792, 0.231020566420917],
            [29.887659425055844, 0.232544031099917],
            [29.88839280965381, 0.235624337484096],
            [29.88918837653405, 0.23623377276227],
            [29.89043746147873, 0.238501859253386],
            [29.890325104694565, 0.23973163767612],
            [29.892252255083683, 0.241875775151496],
            [29.89240893384564, 0.242789701268901],
            [29.890822631224776, 0.244899168996917],
            [29.89012776279293, 0.245034399245476],
            [29.889455018968235, 0.24634301878408],
            [29.88972944081282, 0.247348186529151],
            [29.889464782757056, 0.250597002912253],
            [29.888646045630708, 0.253792998069237],
            [29.886368488500395, 0.2693755712898],
            [29.887269205879583, 0.271078575769425],
            [29.889223568035277, 0.272788835619918],
            [29.890179601873033, 0.275008277832083],
            [29.88877856510143, 0.277987768085554],
            [29.887959819890206, 0.28089760215913],
            [29.88784878362954, 0.281372115326033],
            [29.88851404808117, 0.282098071961554],
            [29.887862156849167, 0.283172589494811],
            [29.887196694768143, 0.283172408037347],
            [29.88653072963057, 0.285007597789531],
            [29.88306424773016, 0.286932718261675],
            [29.878182939918492, 0.291474365512671],
            [29.875576362238938, 0.292164505244513],
            [29.87446730308749, 0.29201066446296],
            [29.872650758666023, 0.293447714803198],
            [29.870819795385952, 0.296845708977075],
            [29.86865621919382, 0.299810916804606],
            [29.86793479925713, 0.301569271995221],
            [29.8666314452895, 0.302182998767059],
            [29.86563227794508, 0.305567236323017],
            [29.864591930929677, 0.30754181914029],
            [29.861375086355125, 0.309187762227399],
            [29.86066774212063, 0.310206399149642],
            [29.86037616964066, 0.311678746760922],
            [29.85933599330521, 0.313060147390076],
            [29.85640683689534, 0.315172992711451],
            [29.8436175329751, 0.260254077415076],
            [29.824022092100776, 0.172822420316972],
            [29.82354502829442, 0.171951434827768],
            [29.824265098063233, 0.171274067717788],
            [29.829132066068002, 0.169236064338915],
            [29.834484916640303, 0.165814618829442],
            [29.838303468961843, 0.161883190404076],
            [29.845253158494963, 0.155746913004026],
            [29.846684537661936, 0.153791494377128],
            [29.847289306867427, 0.151482464879756],
            [29.849787020412634, 0.151247896712992],
            [29.855789780533406, 0.149802277051109],
            [29.86149959734508, 0.147975930989892],
            [29.864193982648718, 0.145844597848041],
            [29.86702084789717, 0.142761607537615],
            [29.870453143511142, 0.136347848575253],
            [29.872287928224466, 0.129362843491112],
            [29.87330896595279, 0.128468404006578],
            [29.874670213645565, 0.128354373947441],
            [29.87553136382973, 0.126365738790209],
            [29.87717530595249, 0.124159323622014],
            [29.880017902498206, 0.122488073891057],
            [29.880751276316403, 0.121557757336444],
            [29.88386292188296, 0.121508129121877],
            [29.886441568245363, 0.118240066169661],
            [29.889047736293136, 0.110836323601986],
            [29.891491952468233, 0.105530313462321],
            [29.894271746894137, 0.102059379817359],
            [29.89360510622349, 0.100725175300437],
            [29.892393888861285, 0.099844393784871],
            [29.89293225909252, 0.096220695844833],
            [29.89227729831717, 0.094803057481565],
            [29.894570260656305, 0.091010775088639],
            [29.895517994060853, 0.09055694408187],
            [29.89661778798844, 0.089042231863031],
            [29.897417647019115, 0.085751971808559],
            [29.89943811709491, 0.082091022949828],
            [29.899198320812978, 0.080756403568124],
            [29.900666997132234, 0.079896813704054],
            [29.90094923342144, 0.078704695666622],
            [29.899843417188173, 0.077168317440762],
            [29.90061310630003, 0.075127764634122],
            [29.902792883608285, 0.074234824728872],
            [29.903834580791553, 0.07332798069304],
            [29.904849905234677, 0.071086297767254],
            [29.90565506612215, 0.070489572532264],
            [29.906365918277853, 0.070178975765223],
            [29.908489029857993, 0.07045096836043],
            [29.912329908907598, 0.069898870489151],
            [29.9139265466458, 0.068816090548033],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 333,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KYONDO",
        Population: 23965,
        Key: "KASESEKYONDO",
        Dist2: "Kasese",
        "Sub Country": "Kyondo",
        id2_original: "Kasese Kyondo",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.765112444264016, -0.007950039933277],
            [29.768504414504886, -0.002770071958506],
            [29.768670947785502, 0.001113144689314],
            [29.77036041383193, 0.004114681951411],
            [29.770410043954737, 0.010317851668283],
            [29.769987643531753, 0.012493957518716],
            [29.771577715483538, 0.014394954304248],
            [29.77175657814145, 0.015705629496211],
            [29.773068388849158, 0.017106371562948],
            [29.773545390671785, 0.018507101043068],
            [29.774857199582865, 0.019947870218566],
            [29.775532967136826, 0.02138863039828],
            [29.775565511302936, 0.022375540158654],
            [29.774503973928304, 0.025465748059593],
            [29.77529575081636, 0.030041040638489],
            [29.77497993280687, 0.032174504987746],
            [29.775622875920355, 0.033508538898103],
            [29.774246506886406, 0.038884520912493],
            [29.774312855554992, 0.039627165170089],
            [29.77648305951728, 0.041522953100548],
            [29.77679464556348, 0.042280122189808],
            [29.775140146439465, 0.045091515834962],
            [29.775896050903295, 0.047454782252289],
            [29.774964144915742, 0.048803750397472],
            [29.77378772649104, 0.047983992179044],
            [29.772532900413374, 0.047561818278216],
            [29.77095297852596, 0.046049982007355],
            [29.768983056651212, 0.045170140855826],
            [29.767840361880538, 0.042930940653442],
            [29.764141401374488, 0.043030068818824],
            [29.76361651575398, 0.041433755806127],
            [29.7621683335996, 0.040577234859962],
            [29.761668166920757, 0.039481396481985],
            [29.76076638234301, 0.039124825585195],
            [29.760503916176567, 0.038314754691365],
            [29.75847360146358, 0.03687491011114],
            [29.757073807960325, 0.03649502253683],
            [29.755839273926597, 0.035301141995665],
            [29.755854630626374, 0.036370469351255],
            [29.751930482241526, 0.035745985842228],
            [29.750696838438255, 0.034871946796314],
            [29.746438025389242, 0.036789156951836],
            [29.74362823531769, 0.039146231535103],
            [29.742847759235918, 0.039303346841496],
            [29.742223419333662, 0.038517594236943],
            [29.741390927203692, 0.038308032599621],
            [29.73726226656461, 0.03994017676716],
            [29.73484183059172, 0.038827246139791],
            [29.732877197099047, 0.037079213913667],
            [29.73138590748912, 0.036482534160281],
            [29.723834467988212, 0.041629314500514],
            [29.721586282174393, 0.043824230505851],
            [29.72004374547419, 0.043182327826502],
            [29.719418474917298, 0.042040399634609],
            [29.71974311438289, 0.041073447927247],
            [29.718265295908967, 0.037237919241531],
            [29.715985355548188, 0.035428995592435],
            [29.715830012581048, 0.034821430943978],
            [29.71741448443539, 0.032746362524373],
            [29.71767334206933, 0.031768958819247],
            [29.719593283478307, 0.031433308754252],
            [29.71937747760436, 0.03024189672171],
            [29.720136048267946, 0.030145787779459],
            [29.720897607626473, 0.031527286891848],
            [29.721631176379034, 0.030787712112614],
            [29.72143647462604, 0.028309321658955],
            [29.719691392083778, 0.027179079467307],
            [29.719547869149146, 0.026559581552558],
            [29.71997279743136, 0.02562967351467],
            [29.720447363921217, 0.025796003759291],
            [29.720614591599556, 0.026415472931787],
            [29.720946699658416, 0.026486629376157],
            [29.72108809717908, 0.026057497023541],
            [29.721555616385544, 0.02274426531655],
            [29.720985429623575, 0.022196715243517],
            [29.721126250425833, 0.02148158985398],
            [29.72214603859763, 0.021575843781882],
            [29.722809035701488, 0.021122333833769],
            [29.723303789132427, 0.019548854762727],
            [29.724773653922806, 0.019428145450034],
            [29.72451219836103, 0.019118598597058],
            [29.725127294599027, 0.018426805135583],
            [29.725649827531804, 0.018855241316286],
            [29.72633518100812, 0.017734381952419],
            [29.72801768780604, 0.017232128510568],
            [29.728097382744803, 0.01666317785533],
            [29.725839462786578, 0.014497124189846],
            [29.725297089662437, 0.013259397579932],
            [29.7232721783159, 0.011876048669585],
            [29.722982917201126, 0.011038767637539],
            [29.724736661299403, 0.01011050972422],
            [29.725568352132157, 0.008836406716284],
            [29.72611073873102, 0.009273256535189],
            [29.726291546241512, 0.008508790237633],
            [29.727737938951837, 0.007671531655087],
            [29.728494637526367, 0.007687358173607],
            [29.728588665983786, 0.00875385693255],
            [29.731155666586847, 0.010344240577622],
            [29.731738942700858, 0.010270847321784],
            [29.732603717587182, 0.011338231811596],
            [29.732932770475784, 0.014784008352995],
            [29.733393511893414, 0.015247871400309],
            [29.733788437343467, 0.015314144608049],
            [29.736026392244476, 0.013591290034009],
            [29.738922512211456, 0.015314237134514],
            [29.739975632371856, 0.016639560249172],
            [29.740567994944936, 0.018296204473006],
            [29.741423672592425, 0.018561283824929],
            [29.745175560038398, 0.016573393941374],
            [29.747084387490684, 0.017368621223557],
            [29.748203332601825, 0.018892757655465],
            [29.7493755217582, 0.018827699869498],
            [29.7500588800763, 0.020831837554961],
            [29.748876601940992, 0.02247757888564],
            [29.748617945529638, 0.023550344216439],
            [29.749355681566833, 0.024860401295778],
            [29.751297327171386, 0.023499875071398],
            [29.755065632227506, 0.022542601635861],
            [29.756584569286908, 0.023208348429734],
            [29.758318289937478, 0.025439321423187],
            [29.758654345193687, 0.02071557670022],
            [29.76197823122087, 0.004914364011469],
            [29.761038964437905, 0.00298902912219],
            [29.760644042581102, -0.002577372550481],
            [29.759755425508782, -0.00711663691883],
            [29.756595902432515, -0.010628740616608],
            [29.75508197617577, -0.011158858914058],
            [29.753223793942574, -0.012612198265164],
            [29.751329970152177, -0.020369809779686],
            [29.74981314862528, -0.023613359231661],
            [29.75969348038177, -0.014922429750457],
            [29.765112444264016, -0.007950039933277],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 334,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "MPONDWE-LHUBIRIHA",
        Population: 51351,
        Key: "KASESEMPONDWE-LHUBIRIHA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.874400237563318, -0.028689804847105],
            [29.874169099244085, -0.029294631467315],
            [29.873848127599807, -0.02866493319495],
            [29.873179631009783, -0.028407246097756],
            [29.874154990304234, -0.025788415690878],
            [29.873317765849322, -0.025218685329511],
            [29.87119793491658, -0.025230164001076],
            [29.871826332508963, -0.024113805243128],
            [29.871456719787016, -0.02322069846725],
            [29.87195574291049, -0.022122943801264],
            [29.8715861454599, -0.020076254736178],
            [29.87097801475863, -0.019825690364134],
            [29.870477268666423, -0.018736590043311],
            [29.87062513675208, -0.017657434065482],
            [29.87129048474704, -0.017062042400617],
            [29.870883896469664, -0.016541064473984],
            [29.87121657046717, -0.016206158176676],
            [29.87024023111072, -0.015543769257683],
            [29.870809988478005, -0.014903718742048],
            [29.87029253461982, -0.011852299908928],
            [29.87117965779383, -0.011256909127139],
            [29.870550393327186, -0.010794732210205],
            [29.870847003559273, -0.009284648071165],
            [29.870218633814666, -0.008056634922185],
            [29.870773088381064, -0.006791419838902],
            [29.870111514208613, -0.006536709728319],
            [29.870033825207905, -0.006084380137753],
            [29.871401468007143, -0.00522850217016],
            [29.871515633998296, -0.004343046272421],
            [29.871091173738336, -0.002368518738703],
            [29.8704175756158, -0.001259410180451],
            [29.870823751566466, 0.000217998661557],
            [29.86930648627181, 0.000457983589737],
            [29.870401288261387, 0.002363697480552],
            [29.869359190429513, 0.003032216527721],
            [29.86955022885278, 0.003675598916282],
            [29.81895192517873, -0.007439415970828],
            [29.815485322005742, -0.009366411828929],
            [29.81574367388818, -0.011813447773726],
            [29.817349810412225, -0.013905065265537],
            [29.818496806316436, -0.014163544700976],
            [29.81861327918123, -0.014500037426206],
            [29.819056665147574, -0.020763951873413],
            [29.81864420458321, -0.022129002039104],
            [29.809981832943436, -0.030010717111932],
            [29.79844399360509, -0.049868614737096],
            [29.792963487939353, -0.05754765474801],
            [29.78964530890916, -0.064310685808546],
            [29.789907634938455, -0.065044955677539],
            [29.789372347725255, -0.066530171697035],
            [29.789237708230456, -0.072969118402521],
            [29.78960200382428, -0.077267667427693],
            [29.79023870993472, -0.078296100936398],
            [29.790955814364782, -0.081167977982749],
            [29.795513487925685, -0.089830165696693],
            [29.797798567548195, -0.101888763963995],
            [29.797785456636625, -0.102832634903128],
            [29.79605959983804, -0.107195319107817],
            [29.7946979488017, -0.11258291738409],
            [29.79149392498289, -0.11764193228979],
            [29.79127757832313, -0.12013621698549],
            [29.7917100623352, -0.121694944144249],
            [29.79235274942881, -0.123378225931871],
            [29.793637504676806, -0.12461311101002],
            [29.797331314243035, -0.122438286676783],
            [29.79846746478682, -0.121295905307361],
            [29.801555634680096, -0.121305765193806],
            [29.802146899511897, -0.120156267338556],
            [29.803076327945885, -0.119726832251182],
            [29.804795075477305, -0.120236512768],
            [29.80763896469871, -0.120395439662719],
            [29.808625248405328, -0.121321905188344],
            [29.809274304554293, -0.12254850791362],
            [29.809419517219997, -0.125169369868654],
            [29.8100088722335, -0.126334280763777],
            [29.811929882637653, -0.128628126757031],
            [29.81363135376953, -0.131467273644921],
            [29.815849065135616, -0.133110267258911],
            [29.816785995400533, -0.135406507534446],
            [29.81782603698872, -0.136820957551773],
            [29.81897860424433, -0.143200780834454],
            [29.817486163892557, -0.147094524921545],
            [29.816620128669864, -0.153060758835922],
            [29.81684021411785, -0.153252877246081],
            [29.817150149958845, -0.15273921790635],
            [29.81791403775058, -0.150069315626331],
            [29.819007237145716, -0.149839987299506],
            [29.82026920842316, -0.148364275880238],
            [29.822005349135107, -0.147625643991819],
            [29.822326901989374, -0.148452101176012],
            [29.82278268380833, -0.148336243147447],
            [29.823531443970676, -0.148924648458556],
            [29.82337117733748, -0.1495620809402],
            [29.824129690508887, -0.149450189864291],
            [29.824300715365922, -0.150213760634805],
            [29.824846904533395, -0.150129551951],
            [29.824959931460754, -0.150709641538217],
            [29.826700905108964, -0.151798292562918],
            [29.828675008641337, -0.151367315635526],
            [29.830191978390285, -0.150062421080156],
            [29.832416056116806, -0.151248758194374],
            [29.833267095762437, -0.151016257939686],
            [29.834466134664357, -0.151884648206245],
            [29.836529371734198, -0.151576646619705],
            [29.8379611946689, -0.152036962416825],
            [29.838934605517508, -0.151714694737467],
            [29.839063328707827, -0.15116820564503],
            [29.83842405341569, -0.149241250523823],
            [29.838819726264035, -0.149094152792898],
            [29.839507361461216, -0.147549987231275],
            [29.83906625002916, -0.144437912491774],
            [29.839324636047586, -0.144365159964602],
            [29.839492280544206, -0.145372326282178],
            [29.839853864124162, -0.145498874243505],
            [29.839867428684965, -0.144524522386225],
            [29.84045974903722, -0.14547634097559],
            [29.842344745083338, -0.144922359803595],
            [29.84235111144374, -0.144465635311659],
            [29.841622858921028, -0.144577927059908],
            [29.841664573987874, -0.143756209229718],
            [29.84116307870072, -0.142805578137606],
            [29.84137965622751, -0.142473419005806],
            [29.842519859969862, -0.143219222291329],
            [29.84266258160728, -0.141667926421308],
            [29.841854102343124, -0.141017827509775],
            [29.843766832975334, -0.140646922334265],
            [29.842989058127603, -0.139966760464683],
            [29.843568065447368, -0.139700244588353],
            [29.843765813387495, -0.138545567899145],
            [29.844286820082598, -0.138095560863886],
            [29.843813042313524, -0.137328018247631],
            [29.844591154927794, -0.136896598177849],
            [29.84457910402827, -0.135586915688486],
            [29.845187960568293, -0.135351240637493],
            [29.84639447974154, -0.133509296031429],
            [29.845434624470563, -0.132857220609823],
            [29.844692103107857, -0.1307309498902],
            [29.845564097754156, -0.131168704073053],
            [29.846652054581288, -0.129142473837917],
            [29.845380827063153, -0.128706954622763],
            [29.846195779587227, -0.126941608684336],
            [29.84545650653256, -0.127127577457352],
            [29.845715359674944, -0.126160110429382],
            [29.8448651788187, -0.126532126138554],
            [29.84449568108108, -0.125452948460982],
            [29.845345773902448, -0.125825164504053],
            [29.845419743877876, -0.125453058055198],
            [29.843978274833646, -0.12489471511606],
            [29.842370655191054, -0.122792083748037],
            [29.842851242189965, -0.122122334639573],
            [29.84244485962679, -0.12033614289996],
            [29.84355373282698, -0.12029905603523],
            [29.84329519409498, -0.118512881244229],
            [29.843960623836608, -0.117545458821362],
            [29.84394234581553, -0.115703490503352],
            [29.84464471518001, -0.114922127570254],
            [29.847269000450407, -0.115368951385207],
            [29.847343037799483, -0.11432703530957],
            [29.846899563798264, -0.113619970053431],
            [29.847528011696284, -0.112801382747038],
            [29.847380369087762, -0.110791945113347],
            [29.846789058441885, -0.109936018423788],
            [29.84678913749363, -0.109154575386389],
            [29.84867439944106, -0.107443036299403],
            [29.849746306068983, -0.107517568489044],
            [29.84982032455346, -0.106587283787809],
            [29.849228963601934, -0.106215111509016],
            [29.850042223700015, -0.105322111281369],
            [29.850005346060964, -0.1044662419304],
            [29.85044888114766, -0.104615131152724],
            [29.850744504131242, -0.105433818394666],
            [29.851483899356776, -0.103945422047944],
            [29.851520957557174, -0.102940711939035],
            [29.8525559416303, -0.102643117632319],
            [29.851595150314818, -0.100112630320331],
            [29.852630084980603, -0.100335996972307],
            [29.853554263660058, -0.099108095263566],
            [29.854182576810814, -0.099703542653469],
            [29.854330473642577, -0.099182591540227],
            [29.85373921599729, -0.097582432968473],
            [29.85610486372101, -0.097247740940317],
            [29.856955089493013, -0.096354734177398],
            [29.857657392382134, -0.09624316088176],
            [29.857768310963515, -0.095908263126481],
            [29.856844286794296, -0.095387214936571],
            [29.857805373655523, -0.094754699439345],
            [29.857823980460005, -0.093322040306137],
            [29.85834145947098, -0.093359298781443],
            [29.859302410686617, -0.09432689443568],
            [29.862481656274955, -0.089229118046894],
            [29.863701737314045, -0.085470794946954],
            [29.864293178215643, -0.085061508583685],
            [29.864847616612362, -0.085173186118243],
            [29.86484765973152, -0.08461500595276],
            [29.865716370137132, -0.08362895237933],
            [29.865457727200535, -0.082326504381071],
            [29.865901374576634, -0.081098536484276],
            [29.86560575249135, -0.079982148183106],
            [29.864090262267684, -0.08005645944586],
            [29.863461923964106, -0.079572655151034],
            [29.864607815838852, -0.079126192882986],
            [29.863720840886888, -0.077153886018812],
            [29.86531044301979, -0.074400296061653],
            [29.865125667650688, -0.073804892290971],
            [29.864164641874925, -0.073581551533143],
            [29.864090758137745, -0.072986152243132],
            [29.865144223251196, -0.072707133944752],
            [29.86521819143, -0.072074530046818],
            [29.863222268717692, -0.070809185680849],
            [29.863665859499903, -0.070288245855965],
            [29.865181303011187, -0.070920950389774],
            [29.866253247368363, -0.070734958843876],
            [29.866253271622885, -0.070362836511101],
            [29.865218338753724, -0.069804587878554],
            [29.864922718465067, -0.068464930372297],
            [29.865551091802967, -0.068427759010691],
            [29.866290308263714, -0.069172048619586],
            [29.866290390010416, -0.06786962174643],
            [29.86695576136157, -0.067311479085848],
            [29.8664753055167, -0.066232295040323],
            [29.866586259132404, -0.065153144208939],
            [29.866918931333235, -0.065115953081906],
            [29.867251547838553, -0.065971855646455],
            [29.86806473876635, -0.065934694164415],
            [29.86776914363055, -0.064074062524708],
            [29.868785759851058, -0.061822777983722],
            [29.870005625294485, -0.060408775733729],
            [29.869451250678157, -0.059031889119865],
            [29.870560175980643, -0.058548187916485],
            [29.86941440717507, -0.056761936489181],
            [29.870038167663967, -0.056636376328458],
            [29.870629539395285, -0.057417866221089],
            [29.87136883490782, -0.056859724347982],
            [29.87092531958406, -0.05596659906418],
            [29.871627672778853, -0.054999112160189],
            [29.870740633148166, -0.053398935775713],
            [29.872071357884195, -0.052357052186631],
            [29.8724040696109, -0.051501181752901],
            [29.873993537894833, -0.050533730711402],
            [29.87366091689797, -0.049454554428703],
            [29.874954660688687, -0.048859212362959],
            [29.873660979780034, -0.048003267323335],
            [29.874437241864815, -0.047277656996658],
            [29.87406765249907, -0.046207783612272],
            [29.875453806881364, -0.045556619326108],
            [29.874206317344623, -0.044905349931231],
            [29.87402152400921, -0.044300641096107],
            [29.87477005240624, -0.043798301541043],
            [29.87480703604648, -0.043314540035713],
            [29.87362420005737, -0.043463341428287],
            [29.872700175888124, -0.041900382862116],
            [29.87358729996043, -0.041825993393299],
            [29.873772095092477, -0.042384185698865],
            [29.874807054012784, -0.042830776730667],
            [29.87521368181603, -0.04204932978445],
            [29.873956948615024, -0.041416668057239],
            [29.87436361055423, -0.039593272640832],
            [29.872552395837378, -0.039853693280798],
            [29.872256709971705, -0.039258283764156],
            [29.87340261172791, -0.038179163012586],
            [29.872885178530993, -0.036541796905864],
            [29.87358750926789, -0.035685929883876],
            [29.87366146307367, -0.034792835777115],
            [29.87580541736504, -0.032188021037376],
            [29.875435794761593, -0.031741462290914],
            [29.874992232725454, -0.031815876022663],
            [29.87451168255746, -0.032634536662729],
            [29.873994199953202, -0.032522884175805],
            [29.874733524211834, -0.030476217739101],
            [29.874400237563318, -0.028689804847105],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 335,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "NYAKATONZI",
        Population: 4997,
        Key: "KASESENYAKATONZI",
        Dist2: "Kasese",
        "Sub Country": "Nyakatonzi",
        id2_original: "Kasese Nyakatonzi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.816620128669864, -0.153060758835922],
            [29.817486163892557, -0.147094524921545],
            [29.81897860424433, -0.143200780834454],
            [29.81782603698872, -0.136820957551773],
            [29.816785995400533, -0.135406507534446],
            [29.815849065135616, -0.133110267258911],
            [29.81363135376953, -0.131467273644921],
            [29.811929882637653, -0.128628126757031],
            [29.8100088722335, -0.126334280763777],
            [29.809419517219997, -0.125169369868654],
            [29.809274304554293, -0.12254850791362],
            [29.808625248405328, -0.121321905188344],
            [29.80763896469871, -0.120395439662719],
            [29.804795075477305, -0.120236512768],
            [29.803076327945885, -0.119726832251182],
            [29.802146899511897, -0.120156267338556],
            [29.801555634680096, -0.121305765193806],
            [29.79846746478682, -0.121295905307361],
            [29.797331314243035, -0.122438286676783],
            [29.793637504676806, -0.12461311101002],
            [29.79235274942881, -0.123378225931871],
            [29.7917100623352, -0.121694944144249],
            [29.79127757832313, -0.12013621698549],
            [29.79149392498289, -0.11764193228979],
            [29.7946979488017, -0.11258291738409],
            [29.79605959983804, -0.107195319107817],
            [29.797785456636625, -0.102832634903128],
            [29.797798567548195, -0.101888763963995],
            [29.795513487925685, -0.089830165696693],
            [29.790955814364782, -0.081167977982749],
            [29.79023870993472, -0.078296100936398],
            [29.78960200382428, -0.077267667427693],
            [29.789237708230456, -0.072969118402521],
            [29.789372347725255, -0.066530171697035],
            [29.789907634938455, -0.065044955677539],
            [29.78964530890916, -0.064310685808546],
            [29.792963487939353, -0.05754765474801],
            [29.79844399360509, -0.049868614737096],
            [29.809981832943436, -0.030010717111932],
            [29.81864420458321, -0.022129002039104],
            [29.819056665147574, -0.020763951873413],
            [29.81861327918123, -0.014500037426206],
            [29.818496806316436, -0.014163544700976],
            [29.817349810412225, -0.013905065265537],
            [29.81574367388818, -0.011813447773726],
            [29.815485322005742, -0.009366411828929],
            [29.81496917339967, -0.0086971912051],
            [29.814972500759488, -0.006260979040119],
            [29.813227163095647, -0.002049113756504],
            [29.812951635424973, 0.002360619852398],
            [29.81357696886392, 0.006650229830039],
            [29.814695798092405, 0.008746509611942],
            [29.81467476044678, 0.01005744983445],
            [29.813834210428684, 0.010689958107215],
            [29.813764820962888, 0.011548087240913],
            [29.813161653453548, 0.012299520773278],
            [29.81347138268205, 0.013014234768956],
            [29.812856382563808, 0.013777605110192],
            [29.813497577555744, 0.014229788264636],
            [29.813000270214463, 0.014564001963973],
            [29.81191054640117, 0.02094095860023],
            [29.81260163023071, 0.02260867451651],
            [29.81352660391919, 0.022679211125424],
            [29.814052365397103, 0.024680784069825],
            [29.815772595148765, 0.025167606229057],
            [29.815514590016008, 0.02657412976702],
            [29.816464822533643, 0.027407368304548],
            [29.81701511161207, 0.029814119940482],
            [29.81630135160983, 0.031070129820379],
            [29.816996932405672, 0.032555153452236],
            [29.817094585565282, 0.033937485270267],
            [29.81742757846468, 0.03443766713142],
            [29.818874310738178, 0.034531506925651],
            [29.818559725217234, 0.037284770865275],
            [29.818062210365124, 0.037523634645049],
            [29.81744839692138, 0.038882858131282],
            [29.81832910792088, 0.040526563602411],
            [29.81732278639351, 0.041278399404702],
            [29.81784837000499, 0.043208493946654],
            [29.81853755299941, 0.043946672639778],
            [29.81832799939983, 0.045877512714817],
            [29.819197825513033, 0.048009853768675],
            [29.82007705608892, 0.048914689599779],
            [29.827830336254426, 0.05425776882578],
            [29.829463989073925, 0.055983394857029],
            [29.83049358954355, 0.056194042503706],
            [29.832440987959174, 0.057622187929509],
            [29.83330169617224, 0.05783164709968],
            [29.831814462455842, 0.064340049021732],
            [29.83164106963973, 0.067122323661563],
            [29.830981727780724, 0.068467099802171],
            [29.82818581668033, 0.069953293083475],
            [29.827682934394392, 0.073653409510047],
            [29.82721898149961, 0.074768549320579],
            [29.826485076777093, 0.075388985510248],
            [29.82617952830795, 0.076771735855209],
            [29.8245918701293, 0.077369191335419],
            [29.82309542149471, 0.078965129597409],
            [29.822342268570626, 0.078649771823636],
            [29.8203946312031, 0.078807742213853],
            [29.819106635731913, 0.079408512445334],
            [29.814959712343107, 0.084057032391522],
            [29.813106225603907, 0.085353490372551],
            [29.812186127072437, 0.085195304412731],
            [29.809274041347912, 0.082918061448594],
            [29.808174612136312, 0.082601720949628],
            [29.80817465076389, 0.082127351680942],
            [29.810091053708934, 0.079534288142252],
            [29.811379086909398, 0.078269402132785],
            [29.81184753227894, 0.077004690358186],
            [29.81165057395793, 0.074629119228889],
            [29.80844956668184, 0.063350050497728],
            [29.806949821230173, 0.059927793741309],
            [29.806453352017048, 0.054744258434321],
            [29.804962613972737, 0.050419784851725],
            [29.80175815986088, 0.048849965108766],
            [29.798265084234796, 0.045254524974066],
            [29.791692463440462, 0.037336337744924],
            [29.789111635968542, 0.033394426825325],
            [29.78593234636278, 0.026664563156928],
            [29.78156814925284, 0.026168598849688],
            [29.779849472688323, 0.026420648125582],
            [29.77951858723655, 0.025181691811352],
            [29.779675695393216, 0.023363329363009],
            [29.77881192482338, 0.020872941764694],
            [29.778733474949593, 0.016999037264309],
            [29.77635241483057, 0.00893686351669],
            [29.773658404124426, -0.003426179881493],
            [29.773065260915367, -0.004545816692673],
            [29.765112444264016, -0.007950039933277],
            [29.75969348038177, -0.014922429750457],
            [29.74981314862528, -0.023613359231661],
            [29.746906896560205, -0.025521362753324],
            [29.746080539025282, -0.027261600496627],
            [29.744334936358435, -0.028700630443235],
            [29.743849767053263, -0.028755239022492],
            [29.743814872894376, -0.02908975093043],
            [29.744244006190442, -0.029847661232028],
            [29.742733017424662, -0.02964536245394],
            [29.743016806002714, -0.02882687157253],
            [29.7425942816122, -0.028730036790361],
            [29.740715827996304, -0.031019960715778],
            [29.740498459952047, -0.031413009526827],
            [29.742000617380256, -0.032254665241137],
            [29.740038494678807, -0.034025830969675],
            [29.739349399719305, -0.03569169706689],
            [29.73823655866051, -0.035159598076365],
            [29.738255465502284, -0.03598201634025],
            [29.73894662838357, -0.036356398143454],
            [29.738139826274097, -0.037777122095509],
            [29.73717959550733, -0.03715565154515],
            [29.736720918418193, -0.037484662143122],
            [29.736744450685396, -0.037972177742114],
            [29.736264757510195, -0.037630999468084],
            [29.73431086427506, -0.037712232305055],
            [29.733384287093752, -0.036847591450697],
            [29.73217516280619, -0.03671010342646],
            [29.73140999761012, -0.037309193357722],
            [29.730545139180425, -0.040738906417546],
            [29.728035268734473, -0.040523635993636],
            [29.72799951937945, -0.040919032061008],
            [29.728806705967877, -0.041660319844343],
            [29.728498114006534, -0.042082631221374],
            [29.729375938718995, -0.042094010178004],
            [29.729713491466796, -0.04395589204681],
            [29.730254975258806, -0.04420652463188],
            [29.730477887704993, -0.048883600715719],
            [29.730121330199065, -0.050584207027589],
            [29.729417957416427, -0.0510927350249],
            [29.729008013033134, -0.052274988424697],
            [29.728984416985575, -0.053979917337393],
            [29.7295319724906, -0.054885322615472],
            [29.729746739013773, -0.056867412126389],
            [29.729255259942054, -0.05737868621961],
            [29.728228192721513, -0.05721308637138],
            [29.728007026600253, -0.057880131845768],
            [29.72660829041408, -0.058318718786393],
            [29.727008885131884, -0.059998704914387],
            [29.72562987684767, -0.061198808546944],
            [29.72490875515165, -0.068451890436938],
            [29.726427625735727, -0.070268223321688],
            [29.72607624611907, -0.072684474858271],
            [29.727209918210992, -0.076079242286717],
            [29.726798267028677, -0.077383257143311],
            [29.727213173705575, -0.078028119363466],
            [29.72835666887516, -0.078530211561687],
            [29.72863262324559, -0.079371196464261],
            [29.69933447988581, -0.210557686482693],
            [29.69936918809343, -0.210555151454068],
            [29.75049612695601, -0.183631711376825],
            [29.750495198098008, -0.183292081668543],
            [29.814736404638204, -0.151955947239702],
            [29.816620128669864, -0.153060758835922],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 336,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "NYAKIYUMBU",
        Population: 30513,
        Key: "KASESENYAKIYUMBU",
        Dist2: "Kasese",
        "Sub Country": "Nyakiyumbu",
        id2_original: "Kasese Nyakiyumbu",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.121184575186803, 0.261319780018269],
            [30.121093752816623, 0.261959751120347],
            [30.11967120139393, 0.263104717388918],
            [30.119151635596538, 0.265298715058443],
            [30.11590782539378, 0.271714134787724],
            [30.11529364813235, 0.274194294057419],
            [30.11403698410162, 0.275148424180995],
            [30.113505516525013, 0.277330477611951],
            [30.112273345958815, 0.278952297576975],
            [30.112251185419083, 0.280335386603543],
            [30.110663105032263, 0.282004977083397],
            [30.110228549505127, 0.285951611230436],
            [30.109802387836027, 0.286834017107089],
            [30.108226305348147, 0.288634741947197],
            [30.10759965138573, 0.290602185387509],
            [30.10650875347436, 0.291246259261939],
            [30.105893249401248, 0.292581766363024],
            [30.10527670238411, 0.292987283943844],
            [30.104279836523414, 0.292844423137879],
            [30.10301070567317, 0.293261988755988],
            [30.10265533574004, 0.293786672556877],
            [30.101817701653353, 0.298091056315578],
            [30.100929947862042, 0.300010843115298],
            [30.10086099138418, 0.302013917519612],
            [30.10128899100637, 0.302776906250849],
            [30.101303129590622, 0.304815737977008],
            [30.103408011658704, 0.309047985505163],
            [30.10338573254136, 0.310359521930988],
            [30.10414675470735, 0.311837834246026],
            [30.103733453319833, 0.313638283681082],
            [30.10302213673517, 0.314186881981143],
            [30.101840052635936, 0.318240926098714],
            [30.100628185791802, 0.318605409201464],
            [30.094678455917172, 0.317204145166275],
            [30.093788564135476, 0.317763716030642],
            [30.09067436915012, 0.318210682984508],
            [30.088709070904127, 0.319889581271102],
            [30.086891317350307, 0.324143687332128],
            [30.085204059362837, 0.325803989815893],
            [30.084944109377496, 0.327334088741277],
            [30.081792454644813, 0.329161893193065],
            [30.08145856882, 0.329982858932556],
            [30.078862919145905, 0.332072063767468],
            [30.077194099079666, 0.334049576232327],
            [30.073665796917993, 0.334461056919028],
            [30.070902111980107, 0.335284192510843],
            [30.068838821909672, 0.336429122382203],
            [30.067937045416766, 0.336405426131813],
            [30.06587369785415, 0.337502650767932],
            [30.065376660905763, 0.338694991732711],
            [30.063929807359692, 0.339339049160687],
            [30.06128637988887, 0.341640546177735],
            [30.056610695547445, 0.340830574803978],
            [30.05175793439887, 0.340843285740368],
            [30.048343191865552, 0.343037565899036],
            [30.047251854678002, 0.343252344739992],
            [30.04513926506476, 0.342656558580771],
            [30.040950986833543, 0.342669150939214],
            [30.03808302635578, 0.345769411003076],
            [30.03654144636134, 0.346556527438647],
            [30.03299831391266, 0.350717952544415],
            [30.030673993183576, 0.351815143195633],
            [30.029679868082827, 0.354175899703758],
            [30.02736800519012, 0.355833427570754],
            [30.02670492005135, 0.357097274324755],
            [30.02475969915199, 0.35764597798293],
            [30.022365176880097, 0.359673084621108],
            [30.021796723866625, 0.360674625288407],
            [30.02024340019644, 0.361569006153009],
            [30.017799948487642, 0.362189298450563],
            [30.01563986045377, 0.361498119708501],
            [30.014547241370334, 0.360472975466577],
            [30.012791292806384, 0.360473212617117],
            [30.010775404138517, 0.361498796126452],
            [30.010098655624297, 0.361057771615395],
            [30.007939118257674, 0.360867323571483],
            [30.00447482644992, 0.360987029792794],
            [30.00288630858355, 0.362250979138617],
            [29.998510869956135, 0.36335015454874],
            [29.996612150347453, 0.365026443480596],
            [29.988729118420622, 0.364679283103115],
            [29.98613402480366, 0.363716448707477],
            [29.985075565955547, 0.362598158473708],
            [29.980640231258263, 0.362304170018224],
            [29.976386522436695, 0.359462416767482],
            [29.974469671232267, 0.357544393079238],
            [29.971338442392515, 0.357484849409825],
            [29.970125250533325, 0.355768566864623],
            [29.961889005528366, 0.350306238099506],
            [29.961166776209623, 0.347667203836305],
            [29.9597981901793, 0.347315779478973],
            [29.958371845171197, 0.345917923170208],
            [29.95642206801669, 0.3460472818059],
            [29.954311383730154, 0.344649209718517],
            [29.952193718635577, 0.344908500137404],
            [29.95008962618661, 0.343087977550812],
            [29.94885654472872, 0.343016084870628],
            [29.947771654749978, 0.343899654603839],
            [29.942923540586392, 0.342799681899454],
            [29.940483177285554, 0.342811887989038],
            [29.939850253980758, 0.34357860609233],
            [29.938797971050185, 0.34344178165892],
            [29.93832012660785, 0.343779588843323],
            [29.937907065968858, 0.343389490767198],
            [29.93670628074205, 0.343324109859902],
            [29.93372323978819, 0.344532014032841],
            [29.931812508805816, 0.34382945881679],
            [29.930870323396487, 0.342659284918905],
            [29.928875364576463, 0.342925103332077],
            [29.928190692023072, 0.343990761895007],
            [29.924723617234573, 0.344802038229909],
            [29.92295434036672, 0.345932330088174],
            [29.921288835982203, 0.345606812607944],
            [29.91910006833456, 0.346301517458866],
            [29.916865696813208, 0.3483025354845],
            [29.91563150234268, 0.351727218651083],
            [29.915650311268074, 0.353423515709028],
            [29.9147588213835, 0.355178006898274],
            [29.914525958298906, 0.356516761905494],
            [29.914880105624956, 0.359253046949086],
            [29.914201636836953, 0.361053091485676],
            [29.91235465929029, 0.362833234788166],
            [29.911805474241362, 0.364126390211346],
            [29.910268813421403, 0.364658787556708],
            [29.907582503972176, 0.366659594086845],
            [29.90596205369241, 0.366808502066195],
            [29.9050318895382, 0.368354979290444],
            [29.90488222572028, 0.371714983874225],
            [29.90437836157575, 0.372624684079206],
            [29.90173710712961, 0.374995927246898],
            [29.90030402116358, 0.374735446542509],
            [29.89858646120496, 0.375683694111588],
            [29.896830694100686, 0.375137144773651],
            [29.893421602868806, 0.376461729778652],
            [29.892136614058863, 0.377286644739799],
            [29.889850230082537, 0.380275378581785],
            [29.881908424081644, 0.38393791449713],
            [29.88034557198124, 0.385536092746815],
            [29.87727894458682, 0.386100356699299],
            [29.87254725747395, 0.38515312444991],
            [29.864491943048677, 0.350090541357481],
            [29.875090131125102, 0.347942218891761],
            [29.87964742829188, 0.345776922578718],
            [29.881456841886614, 0.344210035803058],
            [29.882751150717674, 0.342377879209835],
            [29.88638287861293, 0.334714459255071],
            [29.88865066925947, 0.331787646650029],
            [29.89356341002124, 0.327951121539643],
            [29.900068108298605, 0.32232854352377],
            [29.900659343486, 0.321449644821671],
            [29.904828630433816, 0.317954042754306],
            [29.912512690016776, 0.313266402888302],
            [29.917069362854413, 0.312671234772576],
            [29.92148266726768, 0.313289659025053],
            [29.927938123494446, 0.317817067053046],
            [29.93104312242622, 0.320574436265314],
            [29.932207662427942, 0.321047912863152],
            [29.93380132045437, 0.32145981448892],
            [29.94050365617908, 0.320597889113641],
            [29.944426831688475, 0.320640220660309],
            [29.946143063937118, 0.321175579426317],
            [29.947654814474234, 0.322245717469965],
            [29.950003793957844, 0.325105770254251],
            [29.952005956368158, 0.326134931895453],
            [29.956583230270226, 0.32560149305976],
            [29.958953706438574, 0.324985090724365],
            [29.960547825300754, 0.323998169770313],
            [29.96377733791744, 0.320666645088878],
            [29.965801182963755, 0.31760216190002],
            [29.96741877210933, 0.306103372890963],
            [29.96991376555589, 0.298657325032642],
            [29.97083526635746, 0.291437091300538],
            [29.971407833654936, 0.28987383351362],
            [29.973206473754484, 0.288105199879048],
            [29.977845515815503, 0.285987608072125],
            [29.981728681260474, 0.283232074307951],
            [29.984918270050954, 0.275909474378018],
            [29.988985217328345, 0.273668227774878],
            [29.99086551608384, 0.272228692968528],
            [29.99205110091773, 0.270583269119891],
            [29.99254201225418, 0.268608516406982],
            [29.992338315670242, 0.265975302689162],
            [29.991399314788584, 0.261984176955902],
            [29.99148164268944, 0.259556751180659],
            [29.99250358052969, 0.258569563978522],
            [29.993893166476393, 0.258281895807934],
            [30.00085339594276, 0.261129570021988],
            [30.00178058667338, 0.262679210579178],
            [30.002254781260714, 0.262345284241828],
            [30.002206176115624, 0.261343855515747],
            [30.003629999552743, 0.261438900775273],
            [30.00448219443188, 0.259650415757236],
            [30.00579892700902, 0.259471275561525],
            [30.006246386835198, 0.256514521440416],
            [30.0066018780409, 0.256132935299323],
            [30.006411308538215, 0.255489199101413],
            [30.006980938344718, 0.255608283082553],
            [30.007454475365275, 0.254702103050678],
            [30.0091161717913, 0.255297800558538],
            [30.008758676444202, 0.253938777937486],
            [30.010668032105887, 0.253234925161877],
            [30.016116607154856, 0.247182827988142],
            [30.01996485777967, 0.244891840607771],
            [30.028432405495536, 0.24214482985704],
            [30.03399650927996, 0.241285690561329],
            [30.042952082045296, 0.238733089890424],
            [30.048832735067815, 0.236081415292705],
            [30.050976866327314, 0.236153042751945],
            [30.052365039224053, 0.236619215907859],
            [30.053884824293107, 0.239443739127767],
            [30.056598888091333, 0.24654682217887],
            [30.05731063047745, 0.247442889636825],
            [30.080351884814167, 0.247187021284869],
            [30.08462573925428, 0.248174685456906],
            [30.096142373860378, 0.248320458201383],
            [30.097459958938725, 0.248705875850292],
            [30.099336054477003, 0.249964849206698],
            [30.10083840594132, 0.252022982961989],
            [30.101402641364526, 0.255214730575324],
            [30.102749950797328, 0.257372373367914],
            [30.10368387889258, 0.262550385435813],
            [30.107418490837304, 0.269166194275618],
            [30.109851040591828, 0.267017829418359],
            [30.11022909298587, 0.265586973254759],
            [30.111023224358284, 0.264835625010462],
            [30.112559206950202, 0.259159862486409],
            [30.113436538487623, 0.258539645892584],
            [30.113791283193308, 0.257490321872468],
            [30.114846236815215, 0.256548143247879],
            [30.11602955879288, 0.253757835658961],
            [30.11699801094115, 0.252618692271149],
            [30.117637618609944, 0.259134788068374],
            [30.11884985196673, 0.260827591895484],
            [30.121184575186803, 0.261319780018269],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 337,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "BUGOYE",
        Population: 35531,
        Key: "KASESEBUGOYE",
        Dist2: "Kasese",
        "Sub Country": "Bugoye",
        id2_original: "Kasese Bugoye",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.127103937513215, 0.419245044123433],
            [30.12236911707663, 0.420611323414551],
            [30.11318732965811, 0.415554992214393],
            [30.105799147281974, 0.412679651723631],
            [30.095791209839387, 0.413006344341866],
            [30.089133447620757, 0.414865275765361],
            [30.085884974263372, 0.414899608475389],
            [30.082142404143525, 0.414329473472348],
            [30.080287308521655, 0.413397595389329],
            [30.08034241297781, 0.407583831015098],
            [30.07981284623636, 0.406890251219012],
            [30.072872456961353, 0.406354328020306],
            [30.069005034491752, 0.405766199604345],
            [30.065394632601325, 0.404713987009808],
            [30.066966235190886, 0.403071939809078],
            [30.06818562273059, 0.400778897346632],
            [30.07014659379186, 0.398912815854313],
            [30.076029952540036, 0.395618938175707],
            [30.078448258607377, 0.39347255632291],
            [30.080927360856517, 0.392744978492247],
            [30.08173362936675, 0.392196429743644],
            [30.08234927357704, 0.390884851782258],
            [30.083250843457442, 0.390693980393825],
            [30.083819587525074, 0.389930846029851],
            [30.085835884926347, 0.3891436929967],
            [30.088517237471827, 0.388928752663633],
            [30.08937546184315, 0.38711444533076],
            [30.090310413119497, 0.386625681330026],
            [30.09232380896241, 0.386413026195137],
            [30.094799641343947, 0.386854265023153],
            [30.09921154887693, 0.386308740449938],
            [30.09979627577009, 0.380655071911377],
            [30.098518667518498, 0.375148321372866],
            [30.098754340533315, 0.374906067998256],
            [30.100296130733536, 0.374214320722339],
            [30.101340414166486, 0.374333409635303],
            [30.102194263742348, 0.37388021743849],
            [30.106702361079332, 0.373116521044942],
            [30.108980732981614, 0.373283123554842],
            [30.112183163189137, 0.372066516884257],
            [30.11485077061246, 0.370027283339997],
            [30.11561015245472, 0.370003329364146],
            [30.11582456683833, 0.370790227228388],
            [30.11684516529047, 0.370933156077393],
            [30.118457380714045, 0.369502142754157],
            [30.1181007046305, 0.368834499049404],
            [30.118289625724643, 0.367952158778282],
            [30.119571341073694, 0.368166584008946],
            [30.121993208062833, 0.369358554532355],
            [30.122894375497967, 0.368762265217181],
            [30.123784247516735, 0.368702523996384],
            [30.12423445528937, 0.368058597960783],
            [30.127106177013246, 0.368248951531421],
            [30.128363567781026, 0.367891062022245],
            [30.12950331158596, 0.368487067534007],
            [30.130784513996996, 0.368200725573034],
            [30.132196863252993, 0.36849859807051],
            [30.133145272190617, 0.367687667869509],
            [30.134426507839315, 0.367425165782047],
            [30.136086282768986, 0.366065659926019],
            [30.139859780985766, 0.366208176532514],
            [30.14333435850352, 0.364192593812263],
            [30.144613104022266, 0.361593087709588],
            [30.146440050934714, 0.361211257410926],
            [30.146653233728035, 0.360829668738216],
            [30.146260269300278, 0.359530072949674],
            [30.14901249802335, 0.358193459025079],
            [30.149310719833068, 0.360948502713182],
            [30.150899498210862, 0.36345685339368],
            [30.151014639772395, 0.368249278511444],
            [30.151806332218822, 0.369783198197894],
            [30.152987710242204, 0.370655942684163],
            [30.157049483223542, 0.372175402078248],
            [30.16207936968827, 0.377063022080108],
            [30.16757797820361, 0.381390539609205],
            [30.17123736342984, 0.385754116114121],
            [30.171782297650864, 0.385936504116997],
            [30.17155113507711, 0.386396351147731],
            [30.172645183380162, 0.388637866905155],
            [30.17231419821544, 0.389854134375722],
            [30.171626599849176, 0.390474261173983],
            [30.16929997494143, 0.389663750737809],
            [30.167650576451607, 0.389675893882967],
            [30.167673116080415, 0.388531219570773],
            [30.167055172182987, 0.387672793009303],
            [30.166556444605224, 0.387338997463839],
            [30.165203949198304, 0.387577653716542],
            [30.165297746788703, 0.38650450494948],
            [30.16498905601268, 0.386337613443442],
            [30.164087171721928, 0.386290046035449],
            [30.160387052389154, 0.388317555698809],
            [30.158951505937544, 0.388568145768054],
            [30.157171519354897, 0.388496836445419],
            [30.155485758859022, 0.387757797740073],
            [30.152922259888946, 0.387352735983823],
            [30.1504067543112, 0.387448460967293],
            [30.149066428381428, 0.387961345031363],
            [30.14768907659059, 0.387103036987044],
            [30.146549869978177, 0.387031640517504],
            [30.144604412821884, 0.387580378244468],
            [30.14315780900747, 0.388582136706822],
            [30.141851957723343, 0.38800997960406],
            [30.141331170217157, 0.389273930436584],
            [30.14126157324053, 0.390800140825294],
            [30.140170373495245, 0.391253368060275],
            [30.140277601797443, 0.391670673380287],
            [30.139163765405293, 0.393173163876468],
            [30.138643625584418, 0.395057122713225],
            [30.136131108701647, 0.398014433362608],
            [30.135702038287686, 0.397883582524646],
            [30.134546960240826, 0.399347597088817],
            [30.13375969738708, 0.399743525313353],
            [30.13297120294309, 0.403639260361545],
            [30.13303616551115, 0.405422209165209],
            [30.13100154157976, 0.40885524814627],
            [30.13077109675992, 0.411265405852292],
            [30.128346919303883, 0.41785492753353],
            [30.127103937513215, 0.419245044123433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 338,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "BUHUHIRA",
        Population: 18290,
        Key: "KASESEBUHUHIRA",
        Dist2: "Kasese",
        "Sub Country": "Buhuhira",
        id2_original: "Kasese Buhuhira",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.16086560021235, 0.438468249595079],
            [30.159834325283036, 0.439553391586807],
            [30.159218787073936, 0.441055817264271],
            [30.160074321889283, 0.442224259869874],
            [30.15491954804051, 0.44927152762611],
            [30.153745494879928, 0.44997510332326],
            [30.15191767121174, 0.449545995824639],
            [30.15056638044563, 0.451000776095708],
            [30.149047729050483, 0.451215517098286],
            [30.147767411479983, 0.452455650396205],
            [30.146178177656353, 0.453290416136544],
            [30.143321359881355, 0.456235710530735],
            [30.13966776968704, 0.457404466905992],
            [30.138401694007058, 0.461065037103062],
            [30.139162099030447, 0.462066547993189],
            [30.13890289195184, 0.463950467428534],
            [30.137479108938923, 0.464093637121506],
            [30.13805083990487, 0.466311350844486],
            [30.137328681553004, 0.468016433118781],
            [30.137140977676093, 0.470234197704232],
            [30.13507887697508, 0.472905139935849],
            [30.134831445911523, 0.474705580680456],
            [30.133765712506218, 0.476994919310803],
            [30.130517623627785, 0.480309769391184],
            [30.128110311142887, 0.481847985768603],
            [30.12576023122303, 0.481204238041653],
            [30.125260357394975, 0.479630397380016],
            [30.123004773954825, 0.478533562219498],
            [30.121153128761947, 0.477937487910907],
            [30.119646699844566, 0.478497950650364],
            [30.116347000058095, 0.477472722025518],
            [30.11537557448627, 0.479094315954242],
            [30.11262252380469, 0.478903679451819],
            [30.112077813264204, 0.48007216076714],
            [30.111532216086484, 0.480310645217812],
            [30.10698402244678, 0.476555084341794],
            [30.104301256851375, 0.475386761424718],
            [30.103018078146714, 0.473646063969012],
            [30.09975446188856, 0.473061993016204],
            [30.097214045129697, 0.471845976873639],
            [30.096004329750645, 0.472442187348816],
            [30.094603471743756, 0.471703031910062],
            [30.09393906967481, 0.471774605449248],
            [30.091971793338576, 0.474278509290121],
            [30.089397142682532, 0.474457473611982],
            [30.08880441180017, 0.47502980117506],
            [30.08768906264511, 0.475029851478968],
            [30.085575710362196, 0.473694592895534],
            [30.083391756786174, 0.472955486097438],
            [30.082702664521598, 0.472025540414211],
            [30.082321224580603, 0.470213296408115],
            [30.08128845575298, 0.469724508962827],
            [30.079889825567996, 0.471274540146566],
            [30.07806177193112, 0.470463877505013],
            [30.07336514516546, 0.472610196237595],
            [30.07255798552648, 0.472276397219361],
            [30.071773672740107, 0.471036475780969],
            [30.071121384452745, 0.471358423786243],
            [30.070410826944464, 0.472765325516268],
            [30.069034334841344, 0.472646159066418],
            [30.06822803219516, 0.473218489473963],
            [30.066586652965892, 0.469093329809999],
            [30.06717916555762, 0.468306408595331],
            [30.06549208633491, 0.466017347373093],
            [30.062669055096105, 0.466947460038208],
            [30.061648504254645, 0.466804437721969],
            [30.059784645567156, 0.465743419674466],
            [30.058266198089584, 0.466053485401486],
            [30.057909294732273, 0.465075848814032],
            [30.05453867654738, 0.464122219677824],
            [30.053611563071875, 0.4624292750016],
            [30.052270139400818, 0.461749770097635],
            [30.05101048308186, 0.459723014463311],
            [30.04996618527586, 0.459556158666826],
            [30.04920728133732, 0.460033097520979],
            [30.04790222146897, 0.46012854673078],
            [30.04688052707216, 0.45879328980877],
            [30.04524394215157, 0.459604110092394],
            [30.04417439899114, 0.457863498560192],
            [30.042476969379738, 0.457112474330214],
            [30.04164514559631, 0.455801063667676],
            [30.03775205286912, 0.454370606379415],
            [30.03748883750773, 0.45212923255554],
            [30.036264856881964, 0.450185970041852],
            [30.035858649490294, 0.447324644251364],
            [30.032663238718424, 0.443497802031888],
            [30.032234150338116, 0.44149489087127],
            [30.030809562434666, 0.440684276977162],
            [30.029383387208156, 0.438252239837589],
            [30.027223917215185, 0.438180863589446],
            [30.026119496963844, 0.43716755578477],
            [30.023864835195184, 0.436810043886591],
            [30.02210732356261, 0.435260294575888],
            [30.021845233790255, 0.434187321990201],
            [30.019660243558413, 0.432279943250928],
            [30.015494563346476, 0.43109997134603],
            [30.01428486323877, 0.431600790381754],
            [30.007153217249904, 0.430587952398712],
            [30.0048503707477, 0.429443621686243],
            [30.00321083935299, 0.427202412832096],
            [30.00114568348168, 0.426463422591913],
            [29.999859296893163, 0.427415216906265],
            [29.99931430697658, 0.428619063237811],
            [29.996454544524095, 0.42919367337363],
            [29.993542513596825, 0.430501015001772],
            [29.989904621462085, 0.426678732916675],
            [29.985953740112684, 0.42557803518393],
            [29.9839778974419, 0.426048310010641],
            [29.981713222152724, 0.425583958511519],
            [29.980157795526498, 0.422930608229206],
            [29.977895825064653, 0.420135636952535],
            [29.97885288657509, 0.418583571174908],
            [29.98092630065878, 0.418077940945223],
            [29.98174979885617, 0.417280233914859],
            [29.984676961904416, 0.416621468251545],
            [29.986613887760445, 0.414258837194916],
            [29.986835280257175, 0.413345789098594],
            [29.989382044511853, 0.410814564691087],
            [29.990708555250862, 0.410155163398367],
            [29.991440173760967, 0.410447025736954],
            [29.993521410374143, 0.409473297556402],
            [29.99525256543627, 0.407026142232388],
            [29.997463201671184, 0.406535878361026],
            [30.00395458511941, 0.406107629894604],
            [30.020181805412356, 0.406188646016245],
            [30.023885299715662, 0.405609270553023],
            [30.034530113050298, 0.405163605037984],
            [30.038158768707277, 0.405783186320355],
            [30.042402234937978, 0.404548274430208],
            [30.052671331498296, 0.399377182383994],
            [30.055968686681876, 0.398279951881754],
            [30.058433397920144, 0.398074019872389],
            [30.06097977230598, 0.402003019511024],
            [30.06341612193412, 0.404137375488513],
            [30.065394632601325, 0.404713987009808],
            [30.069005034491752, 0.405766199604345],
            [30.072872456961353, 0.406354328020306],
            [30.07981284623636, 0.406890251219012],
            [30.08034241297781, 0.407583831015098],
            [30.080287308521655, 0.413397595389329],
            [30.082142404143525, 0.414329473472348],
            [30.085884974263372, 0.414899608475389],
            [30.089133447620757, 0.414865275765361],
            [30.095791209839387, 0.413006344341866],
            [30.105799147281974, 0.412679651723631],
            [30.11318732965811, 0.415554992214393],
            [30.12236911707663, 0.420611323414551],
            [30.127103937513215, 0.419245044123433],
            [30.13064280296432, 0.419005805808169],
            [30.134212455476806, 0.420471119040017],
            [30.136130330760633, 0.420416670023408],
            [30.14119724488305, 0.421526665800756],
            [30.14180518514147, 0.423291397742145],
            [30.1416165919324, 0.424531455711317],
            [30.142864318624373, 0.426307922234005],
            [30.144337196364223, 0.427786292531146],
            [30.14599827385101, 0.427619201560708],
            [30.14663978774488, 0.428358392008408],
            [30.14683077676081, 0.429479187684168],
            [30.14628601681295, 0.430552348677773],
            [30.14672950967881, 0.434975913225607],
            [30.149530959791246, 0.436024928324263],
            [30.14946074477372, 0.437002668524088],
            [30.15090793608633, 0.436525597918016],
            [30.152569195931132, 0.436525449700296],
            [30.15292636518978, 0.437717765944758],
            [30.15426754182414, 0.438015736507853],
            [30.15429208828926, 0.438826539332395],
            [30.155858518379432, 0.438921792992358],
            [30.156238951308985, 0.439637168699322],
            [30.15673730339096, 0.439613284097334],
            [30.15742624384022, 0.440304786816027],
            [30.15778222642441, 0.440304758070769],
            [30.158018882196114, 0.439637013295332],
            [30.159062888947954, 0.439422300700727],
            [30.159868696622414, 0.438325259055631],
            [30.16086560021235, 0.438468249595079],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 339,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "BWESUMBU",
        Population: 21135,
        Key: "KASESEBWESUMBU",
        Dist2: "Kasese",
        "Sub Country": "Bwesumbu",
        id2_original: "Kasese Bwesumbu",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.28892648423557, 0.239449047226429],
            [30.25061875600566, 0.245202813853735],
            [30.245203748303897, 0.24539991140384],
            [30.238107426766927, 0.244451591979289],
            [30.234787131305968, 0.244694776287547],
            [30.23236470915796, 0.244378660221566],
            [30.22971405743565, 0.245181465586495],
            [30.226279758578585, 0.245568077176455],
            [30.225367817648223, 0.245338351320253],
            [30.22511152111114, 0.244362788931506],
            [30.22234734120152, 0.242985017511179],
            [30.22240472558187, 0.241120085809545],
            [30.221777916210925, 0.240230520777928],
            [30.22055229526146, 0.24091886227133],
            [30.219925299939213, 0.240947424851574],
            [30.219554894004865, 0.240516977526384],
            [30.21861418003597, 0.241635743851031],
            [30.216590732045002, 0.241549248536206],
            [30.21573586827119, 0.240975242734951],
            [30.21515153214517, 0.241448526727994],
            [30.214980641137103, 0.240932049423102],
            [30.214182690128098, 0.240788428044507],
            [30.213584124687987, 0.241161288471763],
            [30.21372648969419, 0.241792525422413],
            [30.21315657152849, 0.241476802747097],
            [30.21270050224866, 0.241849692799592],
            [30.212386848280673, 0.242624288773196],
            [30.212871136338556, 0.243599888118608],
            [30.212073141312096, 0.24365710309843],
            [30.211388941272578, 0.24468984188669],
            [30.211332080610035, 0.244029932005923],
            [30.21104707661141, 0.244087253882469],
            [30.210191584915222, 0.246525819761959],
            [30.209308455650973, 0.246897742197851],
            [30.20957125329578, 0.247194708097227],
            [30.208237590170445, 0.248365686154425],
            [30.199755756546605, 0.251454705215265],
            [30.189351456349513, 0.253320572399178],
            [30.187374139543355, 0.253228259727548],
            [30.184471491519204, 0.251726483392731],
            [30.182908137260554, 0.251670916840379],
            [30.182359717576258, 0.251063330077249],
            [30.182277243250006, 0.251946899986498],
            [30.18277078754858, 0.252637309674456],
            [30.182496442959117, 0.252968593448409],
            [30.18263326446173, 0.254404451015544],
            [30.17934167286903, 0.25575670215431],
            [30.178875573000713, 0.255011075536038],
            [30.177943035497506, 0.255038480168956],
            [30.177092930099747, 0.254375605497768],
            [30.175419799916764, 0.254678961779285],
            [30.17520055169864, 0.253905782242831],
            [30.17418569348112, 0.254126450325402],
            [30.173527651484385, 0.253159887822262],
            [30.17234798834483, 0.254484994966296],
            [30.17134697855576, 0.254112012744155],
            [30.16994804653685, 0.254774381682394],
            [30.168686572926063, 0.253973359142991],
            [30.168302409293137, 0.254801623722349],
            [30.167726525415638, 0.25441493245495],
            [30.16657457440431, 0.254469897130229],
            [30.166163320277345, 0.253779515387398],
            [30.164654594367757, 0.254856031446022],
            [30.163584989223597, 0.254634898053192],
            [30.16339279826182, 0.25554603584257],
            [30.16074652672482, 0.253571216979205],
            [30.158552577594588, 0.252659549049717],
            [30.158004201927746, 0.251913917761372],
            [30.156276383208574, 0.251582196485233],
            [30.155672925543403, 0.251885789985034],
            [30.15430162031276, 0.251719813466121],
            [30.151943229179892, 0.250311113211218],
            [30.15039365777268, 0.250131298257213],
            [30.147130258906852, 0.248418679969996],
            [30.146143140665334, 0.247314015832437],
            [30.144963756003513, 0.247507036834589],
            [30.14480039108089, 0.246979274332435],
            [30.144004039971414, 0.246512826649975],
            [30.142303549799834, 0.246733342144752],
            [30.139945098479863, 0.245683608443523],
            [30.13764129976347, 0.245600272500514],
            [30.135885785984076, 0.246649103409785],
            [30.135538807214033, 0.247589141186907],
            [30.13454197998092, 0.248187894160944],
            [30.133523498857866, 0.249881257273181],
            [30.13274038622071, 0.249905308537844],
            [30.13016707135952, 0.251229438655579],
            [30.128483835129593, 0.252684497717505],
            [30.125199144394895, 0.254485728882652],
            [30.12306605971844, 0.256847050167162],
            [30.12280719399966, 0.258730984200388],
            [30.121184575186803, 0.261319780018269],
            [30.11884985196673, 0.260827591895484],
            [30.117637618609944, 0.259134788068374],
            [30.11699801094115, 0.252618692271149],
            [30.117750361669696, 0.251419385595018],
            [30.11779480492006, 0.248820125206225],
            [30.118353030614006, 0.246966269542873],
            [30.12060598648195, 0.244524409651557],
            [30.121195778076707, 0.24309132767705],
            [30.123491365293102, 0.240278435595625],
            [30.125367200319918, 0.238211096874898],
            [30.126413782541707, 0.237931673826368],
            [30.12658303322604, 0.237386572716492],
            [30.128707263208742, 0.235498549254572],
            [30.129753840938942, 0.235219113575068],
            [30.130725989654565, 0.233360717808778],
            [30.131820063110435, 0.233081529121296],
            [30.132518098103645, 0.231399737723479],
            [30.134277449485943, 0.23107651753347],
            [30.1356608514302, 0.23001545677094],
            [30.137540985793994, 0.227164742380384],
            [30.138873233174433, 0.226768090785595],
            [30.140138267706984, 0.225635191988959],
            [30.1428601010341, 0.220889754460341],
            [30.144460874615902, 0.219658690733229],
            [30.144542158674366, 0.217831258574045],
            [30.146377341341342, 0.216677561446823],
            [30.146523886208605, 0.215942428576441],
            [30.14747364082252, 0.215994805375283],
            [30.148441518048976, 0.212747643828916],
            [30.14827930386824, 0.212010920762724],
            [30.148604944955363, 0.211098675233764],
            [30.14944012125142, 0.210390829137753],
            [30.14997370076724, 0.208375820799401],
            [30.149527780653482, 0.207400248737638],
            [30.15053233788963, 0.206123551605894],
            [30.149716697256043, 0.201098674436722],
            [30.149959796643262, 0.20007917368545],
            [30.150508660095365, 0.199607228655391],
            [30.15264738439513, 0.199404597803494],
            [30.153213125394764, 0.198018804793483],
            [30.154048293605985, 0.197310949138431],
            [30.15434042753304, 0.196007785205162],
            [30.15554229433142, 0.195080287262543],
            [30.1560953115934, 0.193848724762848],
            [30.15747648930901, 0.193191156335726],
            [30.15837330889819, 0.19206817874573],
            [30.159229118598017, 0.191930147987423],
            [30.15957161836807, 0.190104038571854],
            [30.160597571677645, 0.189254715769267],
            [30.161150330224793, 0.188070623168115],
            [30.164670379563923, 0.185014551904734],
            [30.165271277030527, 0.183712000587725],
            [30.167937717542294, 0.18039039598109],
            [30.16955446945804, 0.18009008617596],
            [30.17022700217865, 0.17871667753541],
            [30.171720852885432, 0.179175379336809],
            [30.17182855729473, 0.176849530121072],
            [30.17113197936891, 0.176098178289824],
            [30.17187085087664, 0.17562718841508],
            [30.171613598532083, 0.174889970561457],
            [30.172186608699, 0.174346910053241],
            [30.176401545334578, 0.172350696440105],
            [30.17664215549018, 0.171782201972747],
            [30.175645773821422, 0.171563445216729],
            [30.17647939243878, 0.171140415169857],
            [30.176744017256883, 0.170524553609789],
            [30.177739757528514, 0.170861998858913],
            [30.17837206728396, 0.170331113048917],
            [30.1793940168023, 0.170217652736323],
            [30.179920421473973, 0.169508179019202],
            [30.180821543993353, 0.169773918380087],
            [30.181608824813402, 0.169136998561273],
            [30.182939543261217, 0.169025112981503],
            [30.18382493358503, 0.167818946667409],
            [30.18537096024013, 0.167423304258258],
            [30.18619473601693, 0.162264250629798],
            [30.187955951403396, 0.161608558549761],
            [30.189011082891724, 0.159762293441278],
            [30.191655479644748, 0.158797554164719],
            [30.192017554603144, 0.157731137616571],
            [30.191505479856914, 0.155805641945305],
            [30.1916431466742, 0.154512561361084],
            [30.193057898025256, 0.152050894339522],
            [30.193446173247267, 0.150533561571181],
            [30.195666527456915, 0.148432095761759],
            [30.195830778118406, 0.146616876084259],
            [30.197849003304313, 0.146745855770078],
            [30.198449881906285, 0.1454432579269],
            [30.201580571756878, 0.146290100594124],
            [30.204510657024745, 0.14471449480241],
            [30.205126781833716, 0.14497876394148],
            [30.206923061160687, 0.144430043274904],
            [30.208976774291866, 0.142398910271421],
            [30.21171608613947, 0.140964741728795],
            [30.22209195914942, 0.139510123011022],
            [30.23470445845203, 0.139550606367572],
            [30.24759596819373, 0.138536053869799],
            [30.25058788270595, 0.138717469008728],
            [30.250655362353484, 0.139168876501613],
            [30.25065914426083, 0.138606904687359],
            [30.256126477929563, 0.138437293375958],
            [30.264825684089217, 0.139306368639736],
            [30.26521139012949, 0.142376190151424],
            [30.265158050862873, 0.1450034459732],
            [30.266335849998182, 0.148083605395452],
            [30.266413381793736, 0.149412883855743],
            [30.26504675588738, 0.154039051209911],
            [30.267640272062696, 0.155330307351361],
            [30.26812974878965, 0.155933033360958],
            [30.268302459784508, 0.157309266997279],
            [30.26754147804271, 0.162015106578275],
            [30.266963581938953, 0.162790094433728],
            [30.26759036436046, 0.172320179011323],
            [30.266247043447528, 0.174369852919377],
            [30.26569783055079, 0.176189464657613],
            [30.266178522652588, 0.17744522978316],
            [30.265792990885483, 0.181246614642138],
            [30.267175317546382, 0.1849311473585],
            [30.26870155341746, 0.186418461300023],
            [30.286052979355855, 0.210924272995692],
            [30.288287550303195, 0.214600511320497],
            [30.28790334265281, 0.218710640872322],
            [30.290723001616072, 0.225189179207123],
            [30.289604794021745, 0.229707100853029],
            [30.289735403674168, 0.232247139442413],
            [30.28900634176938, 0.233699707740165],
            [30.289356047824644, 0.234873144727631],
            [30.28888686763321, 0.236063047595996],
            [30.289347445557468, 0.238102575936169],
            [30.28892648423557, 0.239449047226429],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 340,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "KARUSANDARA",
        Population: 11957,
        Key: "KASESEKARUSANDARA",
        Dist2: "Kasese",
        "Sub Country": "Karusandara",
        id2_original: "Kasese Karusandara",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.88502541192921, -0.111937288648873],
            [29.881667414175737, -0.110576860987874],
            [29.880586625006277, -0.110654467198958],
            [29.876572113290365, -0.11259700922875],
            [29.864201347037422, -0.11098306672198],
            [29.863159174645386, -0.111099534876466],
            [29.860804520504114, -0.112459339083725],
            [29.859337455762482, -0.115529006589399],
            [29.859624323765317, -0.120583297634476],
            [29.858404785308633, -0.122245310129071],
            [29.85727903725584, -0.125595363431085],
            [29.857238010298502, -0.131130378450191],
            [29.85427891124358, -0.133099712981126],
            [29.853360269779508, -0.135955028987012],
            [29.858369530925312, -0.140398315225417],
            [29.86035670764004, -0.145236470007059],
            [29.86128297220759, -0.145974910633866],
            [29.86386899733175, -0.146597005415246],
            [29.86491101521355, -0.14764633571737],
            [29.865798752835214, -0.147879609454584],
            [29.86830779144119, -0.147025067412558],
            [29.86904112753014, -0.147336040680029],
            [29.87206057181258, -0.149668496802577],
            [29.87204845623432, -0.150825064771164],
            [29.880472515609007, -0.151387700134816],
            [29.898311435692523, -0.150022084167266],
            [29.901291720615095, -0.150124131535187],
            [29.902950504702996, -0.149303162203099],
            [29.903607028546933, -0.146932786481993],
            [29.906734054169466, -0.143863254836755],
            [29.909474714388317, -0.143552738762457],
            [29.911944982604965, -0.144718880363617],
            [29.91287143222548, -0.144446982752378],
            [29.914801693480445, -0.142659655357321],
            [29.917774095686383, -0.141455369504176],
            [29.921113342904935, -0.139221312806611],
            [29.921692372682564, -0.139065941551566],
            [29.923390714982283, -0.139804519818006],
            [29.927868672044887, -0.137823184374481],
            [29.926479806547018, -0.131566389000655],
            [29.91590332625942, -0.130515865024052],
            [29.909572823892084, -0.130787119602034],
            [29.908762166213396, -0.131214484794886],
            [29.906831719905465, -0.134750534384128],
            [29.903646928118583, -0.136984593298495],
            [29.899555209797235, -0.137877850294563],
            [29.89723920567108, -0.137955274067963],
            [29.89395872354348, -0.133952290922297],
            [29.890832850459457, -0.128122947848634],
            [29.88818065992305, -0.127192593764223],
            [29.88984928864814, -0.12180814059763],
            [29.889811182113768, -0.11733927793049],
            [29.88811317308901, -0.113841728625891],
            [29.88502541192921, -0.111937288648873],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 341,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "KATWE KABATORO TOWN COUNCIL",
        Population: 6403,
        Key: "KASESEKATWE KABATORO TOWN COUNCIL",
        Dist2: "Kasese",
        "Sub Country": "Katwe-Kabatoro Town Council",
        id2_original: "Kasese Katwe-Kabatoro Town Council",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.05222281435503, 0.198193165849553],
              [30.0491182897337, 0.198139552019126],
              [30.047629135419236, 0.19894363998209],
              [30.045232241594974, 0.198687271326596],
              [30.042399332481292, 0.199673918278936],
              [30.043833385034553, 0.202251781622993],
              [30.044123328868917, 0.20546926429605],
              [30.043614408107654, 0.208028484098122],
              [30.042733997145458, 0.209322882260534],
              [30.04085527044171, 0.209787900141959],
              [30.039820165994335, 0.21174533925814],
              [30.040062787477833, 0.21354598097916],
              [30.03801535267217, 0.214461106342035],
              [30.036940943337864, 0.215499929688665],
              [30.036053123969495, 0.217156863114858],
              [30.036036093708354, 0.218094346267634],
              [30.035536599867672, 0.218234181502639],
              [30.033955113115013, 0.220789485253139],
              [30.03283529214647, 0.221448296691523],
              [30.032469925760832, 0.223107917198268],
              [30.032064902348708, 0.223343183287299],
              [30.03031212034609, 0.222503345701754],
              [30.02953108910548, 0.224172681295076],
              [30.02945357707286, 0.225311600667975],
              [30.0286655784989, 0.226090801384568],
              [30.02760824703644, 0.228340235236531],
              [30.023810531137944, 0.227964519644352],
              [30.019968250716506, 0.229214459718794],
              [30.01882887701747, 0.229113614753301],
              [30.017805105715716, 0.229583021152763],
              [30.016167424850458, 0.229408376587775],
              [30.013807146357223, 0.231372074329879],
              [30.010982257402354, 0.228250476285878],
              [30.013127064194936, 0.225098465335124],
              [30.014145609098385, 0.222862441829497],
              [30.01423850388193, 0.221185283616608],
              [30.01724824456265, 0.212349647082561],
              [30.017310240893668, 0.21082777302819],
              [30.018358347556468, 0.208618991340137],
              [30.016848887723313, 0.207519577462798],
              [30.014203803759113, 0.204413943726057],
              [30.015393283688084, 0.203885260689545],
              [30.016074719611463, 0.203046164944835],
              [30.01749172214062, 0.20015773357283],
              [30.01752731249389, 0.197997979274602],
              [30.0158402476442, 0.193835554637841],
              [30.01682443917455, 0.191918045951822],
              [30.016826534944105, 0.189366478156957],
              [30.017381823147083, 0.187707852169315],
              [30.018626837825217, 0.1858628750934],
              [30.024571066417046, 0.184564247659421],
              [30.0278109159477, 0.184901340514279],
              [30.02932740509797, 0.185526273632699],
              [30.030058264531657, 0.186503202525305],
              [30.031053215184134, 0.186959300823946],
              [30.03159292480348, 0.188148874990802],
              [30.033507035247933, 0.189891438157419],
              [30.036220280680958, 0.190985392382818],
              [30.039641578220905, 0.190718176509279],
              [30.040261500208572, 0.190270375103351],
              [30.04356537356786, 0.189765193213552],
              [30.045938000303, 0.190180912377284],
              [30.047852264359385, 0.191899770728185],
              [30.04941539763248, 0.191444259156011],
              [30.053855647012686, 0.195043526617525],
              [30.052772528511685, 0.197672690469566],
              [30.05222281435503, 0.198193165849553],
            ],
          ],
          [
            [
              [30.025824579157753, 0.179771210077004],
              [30.019479049772333, 0.179850280297242],
              [30.018162371992414, 0.180422708221675],
              [30.017434786917917, 0.181443749842115],
              [30.015763306940134, 0.186964137327703],
              [30.014074255017032, 0.188992963392789],
              [30.014146582872137, 0.190747891715917],
              [30.011957638256405, 0.194907536843954],
              [30.010692910049368, 0.198843819789154],
              [30.010119753457058, 0.198962098453267],
              [30.009287663772323, 0.200671586534692],
              [30.008143814666514, 0.201543640487779],
              [30.006271810056056, 0.204299644612961],
              [30.00586352935268, 0.20716204852412],
              [30.00382934559577, 0.209757441169755],
              [29.995857595153193, 0.2164016440812],
              [29.99284456035028, 0.218375956184923],
              [29.991022483204993, 0.220773701072459],
              [29.989663617844396, 0.222952782018975],
              [29.9932475535699, 0.224247512181902],
              [29.99190420391087, 0.225687949636399],
              [29.991359482590585, 0.22611752156464],
              [29.988774816617433, 0.226429649555874],
              [29.986288537727482, 0.228648792404881],
              [29.98549424196337, 0.228780587681737],
              [29.981348516028856, 0.231430227193839],
              [29.97902927257777, 0.234197485242369],
              [29.978794593099675, 0.235556483812716],
              [29.979141576361336, 0.237236811368484],
              [29.978314392376355, 0.238834698348143],
              [29.97665886827462, 0.241156661290702],
              [29.97589611236016, 0.241777998895295],
              [29.974733995114743, 0.241960531341335],
              [29.97418904023248, 0.242984069797064],
              [29.973934245678546, 0.245579725523758],
              [29.97422450931314, 0.246713131136575],
              [29.972081474896637, 0.248686833542272],
              [29.971100897288682, 0.249015638089448],
              [29.967558797004262, 0.255028784748132],
              [29.965488563854997, 0.256271295131071],
              [29.964798300187304, 0.257477578500524],
              [29.96120266121028, 0.259524002534635],
              [29.960439770548486, 0.26069370118564],
              [29.959404687660676, 0.26118699602659],
              [29.95875063508209, 0.262795422608983],
              [29.935414284174556, 0.280684764179814],
              [29.926823987065003, 0.288670335441988],
              [29.920757367507292, 0.296967219759102],
              [29.91843339262959, 0.296710660763886],
              [29.91661738450236, 0.297953095818848],
              [29.916453673728366, 0.299031492513359],
              [29.915255008525637, 0.300200984208241],
              [29.915290928560577, 0.301590174603991],
              [29.913184050435913, 0.304112016702388],
              [29.912965897264122, 0.305062442402688],
              [29.911186327499756, 0.305866180614206],
              [29.90893424748922, 0.308205177671523],
              [29.90820804402362, 0.308022177324543],
              [29.903504653842184, 0.311036734798583],
              [29.900431166013934, 0.312413357444077],
              [29.899437405629204, 0.307996608946079],
              [29.89943890581572, 0.302813015326061],
              [29.902567637339015, 0.293701466675348],
              [29.904918795237183, 0.288539075277886],
              [29.90667764985111, 0.282409712616741],
              [29.90792702854488, 0.270952571392485],
              [29.90786712349184, 0.265460368753084],
              [29.9082355845736, 0.26274522617711],
              [29.908807940766994, 0.261758012275734],
              [29.91500031458301, 0.256431903313161],
              [29.922413648888785, 0.243829816123682],
              [29.930301105916715, 0.237087809088771],
              [29.934931866409094, 0.233551162661384],
              [29.94002545869882, 0.230839254631624],
              [29.94524943875708, 0.22914324275109],
              [29.947493537236337, 0.227697557723858],
              [29.95584046007419, 0.224968042639914],
              [29.95987676941047, 0.220924002475993],
              [29.962076604302414, 0.21775161810957],
              [29.962347520022426, 0.216762100395142],
              [29.962082259197143, 0.214402342560951],
              [29.96264988396392, 0.213543678613091],
              [29.962220050880255, 0.211970728615364],
              [29.96358253285817, 0.211290143547638],
              [29.963889744108943, 0.210693924956434],
              [29.96322336215309, 0.209454913064382],
              [29.96345796257944, 0.20807208983118],
              [29.96312162255725, 0.205760072233729],
              [29.962408025150058, 0.204640303362387],
              [29.96314851991351, 0.20109967245885],
              [29.964521804132726, 0.19985887847509],
              [29.964663303163025, 0.199429657953168],
              [29.964163550607548, 0.198524249641496],
              [29.964968645918, 0.197832228517135],
              [29.965314493709133, 0.195972323518479],
              [29.9668534838606, 0.194564498269441],
              [29.96775460278673, 0.194492189695702],
              [29.9674918015487, 0.193467367848584],
              [29.96810541287149, 0.19184581551983],
              [29.968744972031278, 0.191416157315827],
              [29.969883362973388, 0.191391310053724],
              [29.97103049092997, 0.189709676735073],
              [29.970719129462612, 0.188088941514697],
              [29.972118310314848, 0.188016177470298],
              [29.97223474814536, 0.186871817957202],
              [29.972850194726288, 0.186227637684798],
              [29.973253927259357, 0.186513339061282],
              [29.97385385544376, 0.183926323138489],
              [29.976017348990897, 0.178786157392915],
              [29.976017909539618, 0.175386132029416],
              [29.978306418929883, 0.171218729946825],
              [29.988074507988237, 0.175351560527659],
              [29.990961008795164, 0.173741026138892],
              [29.992855175742015, 0.172083370697222],
              [29.993184727195572, 0.170964296751704],
              [29.9943941605036, 0.170490115947553],
              [29.995556201392198, 0.170819342547264],
              [29.99842479158899, 0.172940288627164],
              [30.00165713300051, 0.171368723674424],
              [30.008938391603323, 0.171753774015017],
              [30.019397600423837, 0.170695180655053],
              [30.023319724904354, 0.170951730275114],
              [30.026378070730168, 0.170426372675411],
              [30.02798459891968, 0.171218490097704],
              [30.026516069025813, 0.174623474893944],
              [30.026949519625123, 0.176561316914349],
              [30.025824579157753, 0.179771210077004],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 342,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "KILEMBE",
        Population: 13302,
        Key: "KASESEKILEMBE",
        Dist2: "Kasese",
        "Sub Country": "Kilembe",
        id2_original: "Kasese Kilembe",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.28291241342704, 0.339467524856772],
            [30.28096641458659, 0.339401223165772],
            [30.279398136661918, 0.338539456547436],
            [30.27775863850484, 0.338346772178952],
            [30.276523015713025, 0.337533106720883],
            [30.275192440995646, 0.337699187960527],
            [30.274337024757912, 0.337196539869527],
            [30.273790442128345, 0.336287906958017],
            [30.273089490305424, 0.336060243647827],
            [30.26978682428187, 0.336391812398315],
            [30.268765203546895, 0.337394616754003],
            [30.268099906755907, 0.337298416939375],
            [30.26747032518398, 0.338098439042131],
            [30.266282283457794, 0.337810581611823],
            [30.266068381113932, 0.337117345765242],
            [30.264405184501356, 0.337354811297233],
            [30.26353786648442, 0.336649021678798],
            [30.262041075591732, 0.33781867888505],
            [30.260401626842025, 0.337888884597172],
            [30.259748208474015, 0.33773294336758],
            [30.259130358001386, 0.336800360037822],
            [30.25760970336314, 0.336751174532418],
            [30.256136592959646, 0.336941022101944],
            [30.255590164840306, 0.337657470024927],
            [30.254473455635907, 0.337823737210481],
            [30.253927074228958, 0.33904204258623],
            [30.2521688160964, 0.338968745833637],
            [30.250779682900593, 0.339823475135567],
            [30.24765524801932, 0.338641555483209],
            [30.24682529363002, 0.339309480733342],
            [30.246897088784145, 0.339857998581293],
            [30.246257189162858, 0.340692835862603],
            [30.245118177484883, 0.340883834974692],
            [30.244618845340945, 0.34004920252218],
            [30.24371786745033, 0.340884079312112],
            [30.242602459006427, 0.34095583367016],
            [30.24038474853867, 0.34223215980002],
            [30.23898453013225, 0.342303952774855],
            [30.238843635668164, 0.343687214050073],
            [30.237609893948505, 0.344069019915185],
            [30.236946239277874, 0.344879987228555],
            [30.235925926489944, 0.345094815434447],
            [30.23486143904794, 0.348338433296502],
            [30.23356885408395, 0.349161444632009],
            [30.23202849220501, 0.3513081022718],
            [30.229348099060264, 0.352691775445819],
            [30.228376180313337, 0.353765135811057],
            [30.224340886971643, 0.353217304169931],
            [30.22262202715078, 0.354898918274192],
            [30.22209988947673, 0.354899002714199],
            [30.221696985190352, 0.35542373631947],
            [30.220581197657406, 0.355137740689278],
            [30.218802713956233, 0.356545097814194],
            [30.217772437055192, 0.358512767930502],
            [30.21701319804504, 0.358727529348518],
            [30.215652118337257, 0.362054606848725],
            [30.21521542032817, 0.364260641616697],
            [30.215667880177232, 0.365691470730676],
            [30.216380116636756, 0.365905999319648],
            [30.2158112054825, 0.366549989289462],
            [30.21621569260043, 0.367503870056992],
            [30.21386728624193, 0.368625104296312],
            [30.214688689568064, 0.371069434835513],
            [30.214095673919786, 0.371355706636822],
            [30.213383292831498, 0.370998091233276],
            [30.212766403556195, 0.371165123168888],
            [30.210869894701403, 0.373192516906196],
            [30.205376455092225, 0.373944565086973],
            [30.203502900887866, 0.375232646217226],
            [30.201556713401263, 0.375161387088566],
            [30.19931640221923, 0.377486909906692],
            [30.19915122539467, 0.378393151073342],
            [30.197348884236185, 0.379681207291904],
            [30.1955216175235, 0.379848406144638],
            [30.193221653715046, 0.381875816727003],
            [30.191205057174745, 0.382543843007351],
            [30.190446491002746, 0.383378624262057],
            [30.19022300183816, 0.385250708928748],
            [30.18910930827815, 0.386920207946463],
            [30.188016742195305, 0.386109532781562],
            [30.185999419816277, 0.386085963320305],
            [30.18206089120036, 0.387135804085738],
            [30.180550378541678, 0.38714654679299],
            [30.178133016603688, 0.38702901929331],
            [30.177469250541947, 0.387744537113525],
            [30.175642638701085, 0.388507905231894],
            [30.171782297650864, 0.385936504116997],
            [30.17123736342984, 0.385754116114121],
            [30.16757797820361, 0.381390539609205],
            [30.16207936968827, 0.377063022080108],
            [30.157049483223542, 0.372175402078248],
            [30.152987710242204, 0.370655942684163],
            [30.151806332218822, 0.369783198197894],
            [30.151014639772395, 0.368249278511444],
            [30.150899498210862, 0.36345685339368],
            [30.149310719833068, 0.360948502713182],
            [30.14901249802335, 0.358193459025079],
            [30.150966786517216, 0.355534964475479],
            [30.150870908428633, 0.354652634589123],
            [30.149456593658762, 0.352542400121072],
            [30.14940832897521, 0.351803151810968],
            [30.150284570856154, 0.350086021119335],
            [30.14995056645372, 0.348464475380366],
            [30.151538703434426, 0.346699535716433],
            [30.15235577418592, 0.345137411874168],
            [30.152303473371774, 0.340678020210522],
            [30.152598921183888, 0.339569075820052],
            [30.154139038721045, 0.337303334232043],
            [30.154066929156574, 0.336468704166134],
            [30.15276012835318, 0.335061954908814],
            [30.152545067182597, 0.333702704861277],
            [30.151155616881514, 0.332665612909642],
            [30.15115341780569, 0.33066245908325],
            [30.150511068478618, 0.329207911328919],
            [30.15069778600538, 0.326346228394653],
            [30.149403064847625, 0.325142196352555],
            [30.147836240397055, 0.324665547146729],
            [30.14681212234562, 0.321351013151911],
            [30.14880454791656, 0.320396756773305],
            [30.150001437149957, 0.318977628462672],
            [30.151140551235894, 0.318953568358948],
            [30.15204149409219, 0.318166439842384],
            [30.15256164109958, 0.316401654661001],
            [30.153391682625493, 0.315876854284405],
            [30.154315476826024, 0.314302761113291],
            [30.15494179931008, 0.311977552541764],
            [30.156032829273787, 0.311405004496159],
            [30.157219965498165, 0.311881712704434],
            [30.157646908701565, 0.311667000564066],
            [30.159234561490333, 0.309520440358879],
            [30.160183100683675, 0.308852528415652],
            [30.16020417695684, 0.306467796228404],
            [30.160689816979225, 0.305692660013484],
            [30.160403121452934, 0.303975720836624],
            [30.162781811816277, 0.299288705419156],
            [30.164010935297025, 0.297759120729106],
            [30.17031939031237, 0.30650922144507],
            [30.174828287149936, 0.308412212990919],
            [30.179275611661346, 0.309662787117385],
            [30.185504805624227, 0.309124952038773],
            [30.18730682967741, 0.307646019516702],
            [30.19220959644461, 0.298821284207941],
            [30.19549725970457, 0.290445443063551],
            [30.20012353580707, 0.28596523041884],
            [30.204659023675386, 0.279275067411855],
            [30.197749880500925, 0.273572145966035],
            [30.19219695714855, 0.270011287600714],
            [30.19267549868356, 0.269377632002266],
            [30.192674424298467, 0.268447565228545],
            [30.193753449176732, 0.267743788722023],
            [30.195008675004704, 0.265477935119903],
            [30.19557795267161, 0.265215467276573],
            [30.195884217098037, 0.263259861089968],
            [30.196736860236495, 0.261757232546191],
            [30.199737109317923, 0.260075201329885],
            [30.20314965277545, 0.255781693934812],
            [30.20619689991592, 0.253694209509582],
            [30.206479721008396, 0.252000919653734],
            [30.208237590170445, 0.248365686154425],
            [30.20957125329578, 0.247194708097227],
            [30.209308455650973, 0.246897742197851],
            [30.210191584915222, 0.246525819761959],
            [30.21104707661141, 0.244087253882469],
            [30.211332080610035, 0.244029932005923],
            [30.211388941272578, 0.24468984188669],
            [30.212073141312096, 0.24365710309843],
            [30.212871136338556, 0.243599888118608],
            [30.212386848280673, 0.242624288773196],
            [30.21270050224866, 0.241849692799592],
            [30.21315657152849, 0.241476802747097],
            [30.21372648969419, 0.241792525422413],
            [30.213584124687987, 0.241161288471763],
            [30.214182690128098, 0.240788428044507],
            [30.214980641137103, 0.240932049423102],
            [30.21515153214517, 0.241448526727994],
            [30.21573586827119, 0.240975242734951],
            [30.216590732045002, 0.241549248536206],
            [30.21861418003597, 0.241635743851031],
            [30.219554894004865, 0.240516977526384],
            [30.219925299939213, 0.240947424851574],
            [30.22055229526146, 0.24091886227133],
            [30.221777916210925, 0.240230520777928],
            [30.22240472558187, 0.241120085809545],
            [30.22234734120152, 0.242985017511179],
            [30.22511152111114, 0.244362788931506],
            [30.225367817648223, 0.245338351320253],
            [30.226279758578585, 0.245568077176455],
            [30.22971405743565, 0.245181465586495],
            [30.23236470915796, 0.244378660221566],
            [30.234787131305968, 0.244694776287547],
            [30.238107426766927, 0.244451591979289],
            [30.245203748303897, 0.24539991140384],
            [30.25061875600566, 0.245202813853735],
            [30.28892648423557, 0.239449047226429],
            [30.289133676164244, 0.240608924675179],
            [30.290922440185568, 0.242403558515461],
            [30.29002497650433, 0.243382149239727],
            [30.288925880567685, 0.246926382019806],
            [30.28960989106268, 0.250884897627548],
            [30.289301147286064, 0.251792793691891],
            [30.28846960916688, 0.252293974211043],
            [30.288255892774284, 0.253130251791979],
            [30.289480259675603, 0.257564490524723],
            [30.289266599876854, 0.258783147938644],
            [30.288173803825288, 0.260072757039163],
            [30.28788882408119, 0.261028459398233],
            [30.288589918736246, 0.262092552171647],
            [30.291631435523534, 0.26307496729698],
            [30.29184550495405, 0.26458077298928],
            [30.292249496201947, 0.264987383874116],
            [30.294435506021667, 0.26513263001982],
            [30.29464948112909, 0.266017062221741],
            [30.294290816175504, 0.266631783509527],
            [30.29342651290466, 0.270879440362704],
            [30.29216728059053, 0.271451934773215],
            [30.292583294890182, 0.272922066842187],
            [30.293319941270934, 0.273352874194275],
            [30.293367604981594, 0.274380569275174],
            [30.29379537104177, 0.274882804394527],
            [30.293771953758966, 0.27732046331045],
            [30.294164131262537, 0.2782170064625],
            [30.29392663466775, 0.279005464635132],
            [30.294354400727926, 0.279579401332774],
            [30.294425861708795, 0.280846098769489],
            [30.295352720062755, 0.282304725987723],
            [30.297188849554036, 0.283540359766184],
            [30.29702260463259, 0.284137683591461],
            [30.297616771022774, 0.285213653493158],
            [30.296215487214432, 0.289872722311832],
            [30.294172027453893, 0.28970366333435],
            [30.29549094563213, 0.291126781278868],
            [30.29496820518853, 0.291198027540715],
            [30.294302839227257, 0.290623874931023],
            [30.294065466599932, 0.292487775063325],
            [30.294873439214257, 0.293324940967987],
            [30.295253542462106, 0.29277559961114],
            [30.29582380827582, 0.292823890613596],
            [30.295443722095985, 0.293492727893319],
            [30.29400627930084, 0.294220393228882],
            [30.293103372727288, 0.294219607213352],
            [30.293008370496082, 0.294554108460391],
            [30.293911293239315, 0.294650491026374],
            [30.293840108939555, 0.295439087303931],
            [30.294743025394574, 0.295487672938359],
            [30.294624258232556, 0.295798258618191],
            [30.294030293064985, 0.296299607075506],
            [30.293590632412137, 0.295546420179889],
            [30.293162935522204, 0.29554603570608],
            [30.29340065310258, 0.296478302950777],
            [30.292497803122913, 0.296931595748326],
            [30.29323448813121, 0.297768699335637],
            [30.292866343256424, 0.298927467223134],
            [30.292581261104388, 0.299309598150955],
            [30.291274421673446, 0.299332349471712],
            [30.29052600736248, 0.299797724326938],
            [30.291809262423925, 0.301256672483365],
            [30.291144086007172, 0.3022837335432],
            [30.291286703439997, 0.302809632317973],
            [30.29292615039308, 0.302357001812739],
            [30.292332304701485, 0.303814296749],
            [30.293163951516785, 0.303982323361033],
            [30.292724472323584, 0.304806443240305],
            [30.294031446501823, 0.305930834138707],
            [30.293128669285686, 0.307148885518656],
            [30.293616142769576, 0.310435407797628],
            [30.292974705232528, 0.311366890439855],
            [30.293141105562473, 0.312107898851318],
            [30.292547135005048, 0.312513653752404],
            [30.292582892444916, 0.313648871066407],
            [30.292107761813075, 0.314365417661407],
            [30.290753392520447, 0.314364218428567],
            [30.290741632675076, 0.315523295332096],
            [30.28922111817401, 0.317194858525164],
            [30.288995561087646, 0.318760019446711],
            [30.28821150342281, 0.319237298637824],
            [30.287558209920668, 0.320443601386206],
            [30.286560297522655, 0.320801186355897],
            [30.286394079550693, 0.321852588572551],
            [30.285776300943297, 0.321828133223091],
            [30.285182217198138, 0.321182339142635],
            [30.284611997198475, 0.321564209657736],
            [30.284873512049064, 0.323022259195573],
            [30.28382812099336, 0.323833879513464],
            [30.28375695465991, 0.324933149173412],
            [30.282628397575223, 0.325756644874178],
            [30.2835316769496, 0.329700712658656],
            [30.28450607594502, 0.331876375355802],
            [30.284256642536697, 0.332389967710437],
            [30.28283101258755, 0.332555975376639],
            [30.282213321116743, 0.333511355271269],
            [30.28271257241228, 0.33661862770578],
            [30.281999851760816, 0.337765106987485],
            [30.28291241342704, 0.339467524856772],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 343,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "KITSWAMBA",
        Population: 29707,
        Key: "KASESEKITSWAMBA",
        Dist2: "Kasese",
        "Sub Country": "Kitswamba",
        id2_original: "Kasese Kitswamba",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.16086560021235, 0.438468249595079],
            [30.159868696622414, 0.438325259055631],
            [30.159062888947954, 0.439422300700727],
            [30.158018882196114, 0.439637013295332],
            [30.15778222642441, 0.440304758070769],
            [30.15742624384022, 0.440304786816027],
            [30.15673730339096, 0.439613284097334],
            [30.156238951308985, 0.439637168699322],
            [30.155858518379432, 0.438921792992358],
            [30.15429208828926, 0.438826539332395],
            [30.15426754182414, 0.438015736507853],
            [30.15292636518978, 0.437717765944758],
            [30.152569195931132, 0.436525449700296],
            [30.15090793608633, 0.436525597918016],
            [30.14946074477372, 0.437002668524088],
            [30.149530959791246, 0.436024928324263],
            [30.14672950967881, 0.434975913225607],
            [30.14628601681295, 0.430552348677773],
            [30.14683077676081, 0.429479187684168],
            [30.14663978774488, 0.428358392008408],
            [30.14599827385101, 0.427619201560708],
            [30.144337196364223, 0.427786292531146],
            [30.142864318624373, 0.426307922234005],
            [30.1416165919324, 0.424531455711317],
            [30.14180518514147, 0.423291397742145],
            [30.14119724488305, 0.421526665800756],
            [30.136130330760633, 0.420416670023408],
            [30.134212455476806, 0.420471119040017],
            [30.13064280296432, 0.419005805808169],
            [30.127103937513215, 0.419245044123433],
            [30.128346919303883, 0.41785492753353],
            [30.13077109675992, 0.411265405852292],
            [30.13100154157976, 0.40885524814627],
            [30.13303616551115, 0.405422209165209],
            [30.13297120294309, 0.403639260361545],
            [30.13375969738708, 0.399743525313353],
            [30.134546960240826, 0.399347597088817],
            [30.135702038287686, 0.397883582524646],
            [30.136131108701647, 0.398014433362608],
            [30.138643625584418, 0.395057122713225],
            [30.139163765405293, 0.393173163876468],
            [30.140277601797443, 0.391670673380287],
            [30.140170373495245, 0.391253368060275],
            [30.14126157324053, 0.390800140825294],
            [30.141331170217157, 0.389273930436584],
            [30.141851957723343, 0.38800997960406],
            [30.14315780900747, 0.388582136706822],
            [30.144604412821884, 0.387580378244468],
            [30.146549869978177, 0.387031640517504],
            [30.14768907659059, 0.387103036987044],
            [30.149066428381428, 0.387961345031363],
            [30.1504067543112, 0.387448460967293],
            [30.152922259888946, 0.387352735983823],
            [30.155485758859022, 0.387757797740073],
            [30.157171519354897, 0.388496836445419],
            [30.158951505937544, 0.388568145768054],
            [30.160387052389154, 0.388317555698809],
            [30.164087171721928, 0.386290046035449],
            [30.16498905601268, 0.386337613443442],
            [30.165297746788703, 0.38650450494948],
            [30.165203949198304, 0.387577653716542],
            [30.166556444605224, 0.387338997463839],
            [30.167055172182987, 0.387672793009303],
            [30.167673116080415, 0.388531219570773],
            [30.167650576451607, 0.389675893882967],
            [30.16929997494143, 0.389663750737809],
            [30.171626599849176, 0.390474261173983],
            [30.17231419821544, 0.389854134375722],
            [30.172645183380162, 0.388637866905155],
            [30.17155113507711, 0.386396351147731],
            [30.171782297650864, 0.385936504116997],
            [30.175642638701085, 0.388507905231894],
            [30.177469250541947, 0.387744537113525],
            [30.178133016603688, 0.38702901929331],
            [30.180550378541678, 0.38714654679299],
            [30.18059483526677, 0.387897522091655],
            [30.178959111830558, 0.38963862633863],
            [30.17976627146951, 0.389876989682357],
            [30.181145437857253, 0.392428510345049],
            [30.180125867077752, 0.39333485322576],
            [30.18126603488749, 0.394288610661113],
            [30.18069779028318, 0.395576459655098],
            [30.181861449935912, 0.396291736901186],
            [30.181458960671193, 0.397221850008644],
            [30.183634927326025, 0.401478393823809],
            [30.18370827476897, 0.403553134723815],
            [30.182973523833457, 0.404483282939207],
            [30.182536300309966, 0.40625999471101],
            [30.18257572646948, 0.409968306926815],
            [30.18219669042018, 0.410636083013258],
            [30.18039427919309, 0.411876363958552],
            [30.179863004754253, 0.413092291118218],
            [30.178628692604406, 0.414320952276349],
            [30.178559300443688, 0.416085676857139],
            [30.179059425800002, 0.417778806320365],
            [30.17620254244801, 0.420628893089726],
            [30.176313382875975, 0.424599503920765],
            [30.175768258212127, 0.425314991466154],
            [30.174871514081428, 0.425410469868149],
            [30.173419617393353, 0.426197587017683],
            [30.171321512215776, 0.428403683799083],
            [30.16911440097001, 0.428427757975692],
            [30.169045513662457, 0.430717115708178],
            [30.168666351849033, 0.431265634857831],
            [30.166779835853458, 0.431492378480211],
            [30.165286182776033, 0.432971050497843],
            [30.163530651030367, 0.433638937795105],
            [30.162145861188964, 0.437180386048489],
            [30.16086560021235, 0.438468249595079],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 344,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "KYABARUNGIRA",
        Population: 16360,
        Key: "KASESEKYABARUNGIRA",
        Dist2: "Kasese",
        "Sub Country": "Kyabarungira",
        id2_original: "Kasese Kyabarungira",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.69954844241681, -0.210556206967397],
            [29.885767516473624, -0.209154704387755],
            [29.888466252318175, -0.208885632004555],
            [29.89715801413908, -0.203380679282941],
            [29.904100727355708, -0.200608973444978],
            [29.90735978735873, -0.198169500773284],
            [29.90718180864306, -0.195730729322488],
            [29.90342235917902, -0.186316156306789],
            [29.90610340899224, -0.182970791865189],
            [29.90818932582807, -0.182130028722226],
            [29.91735691357687, -0.182676595107356],
            [29.919586139548283, -0.182416506304899],
            [29.921324238587545, -0.181556092587887],
            [29.92305068827421, -0.179355371194342],
            [29.924857706062088, -0.17788663284218],
            [29.927144198734535, -0.176789711591174],
            [29.93108134663988, -0.177831190886612],
            [29.94065486060769, -0.184017463940737],
            [29.94687302775047, -0.186520381815775],
            [29.954522883978978, -0.188432800376205],
            [29.956102795984922, -0.188057615632881],
            [29.960076156775994, -0.18542949593929],
            [29.960818108606805, -0.184342680241068],
            [29.961699440342166, -0.181948120795328],
            [29.963713912366803, -0.173217942241601],
            [29.9648814419618, -0.172014906804839],
            [29.967427604345225, -0.170753762229606],
            [29.971000653387815, -0.170770044121818],
            [29.973868103622493, -0.171447286384348],
            [29.97559764081878, -0.171195759229232],
            [29.980557745253915, -0.172737907199315],
            [29.983460145343038, -0.173080528478377],
            [29.987221279148233, -0.172642461633906],
            [29.98877480314271, -0.171992730195358],
            [29.990609612110525, -0.16854447776245],
            [29.9915939698292, -0.165267886666586],
            [29.992852734121076, -0.162954312990684],
            [29.99930642695491, -0.155104190545971],
            [30.000931957207623, -0.153870555718649],
            [30.005058733181226, -0.148627079828912],
            [30.008797268967143, -0.145210264437776],
            [30.01154232374436, -0.143347389023707],
            [30.016658089150237, -0.140946367643566],
            [30.019595298956617, -0.139838635934287],
            [30.037314849108565, -0.135027329708931],
            [30.04725316352337, -0.13012043574366],
            [30.048190780101173, -0.128987999933594],
            [30.049222438611114, -0.125684593772039],
            [30.050628863477815, -0.124080263079378],
            [30.05747360553126, -0.117474010567187],
            [30.061786641789144, -0.113982238333359],
            [30.06516192043371, -0.112661156002615],
            [30.06797448989275, -0.11218954138636],
            [30.070505914515625, -0.112472931466087],
            [30.07510781483289, -0.113891424227582],
            [30.076227621428412, -0.114618918024073],
            [30.08012771292996, -0.115461227042274],
            [30.08190848284355, -0.114604741738941],
            [30.084392324604135, -0.110871126067598],
            [30.087772797307686, -0.103148996780595],
            [30.09153715965802, -0.097905931102911],
            [30.093679641610645, -0.096713840592424],
            [30.09572106309381, -0.097423789820711],
            [30.099837451847772, -0.100151997130914],
            [30.102892987743395, -0.101574561620659],
            [30.1065794490906, -0.101504520986255],
            [30.116566469261805, -0.095271906447981],
            [30.12184491327742, -0.091302902357756],
            [30.123769413636463, -0.087826285420944],
            [30.12544294716301, -0.086376630806334],
            [30.134011752079402, -0.080969059736923],
            [30.138041959159963, -0.07933089897758],
            [30.14917292725162, -0.077370467840264],
            [30.15614160806818, -0.072514376300827],
            [30.159927445543687, -0.075913093631179],
            [30.165737299643727, -0.072931390987802],
            [30.169484397272615, -0.072861070025963],
            [30.174760315225658, -0.073836723168335],
            [30.179171184306195, -0.0733081216533],
            [30.18050251540503, -0.074004736732736],
            [30.183008674910546, -0.073146284897152],
            [30.18352001213993, -0.072171192288077],
            [30.184879977936774, -0.072198141725213],
            [30.186185762745552, -0.074720721258914],
            [30.18688701011422, -0.077183787314244],
            [30.184676593068232, -0.081556192626201],
            [30.183942781770522, -0.082023596372073],
            [30.18351678449313, -0.085077443780932],
            [30.18279658806185, -0.085560007436766],
            [30.183906990194664, -0.088070374464073],
            [30.1844520142472, -0.08849510910432],
            [30.18816360057459, -0.086233743142723],
            [30.18928144165627, -0.086139700418649],
            [30.18970126391442, -0.084830127075298],
            [30.191030349225038, -0.084583370916194],
            [30.193910011157698, -0.081974189082044],
            [30.195599826648763, -0.080965691057971],
            [30.202060116710047, -0.078149755631542],
            [30.20962884428863, -0.077472510973492],
            [30.21143740538215, -0.07688958932462],
            [30.215310408186326, -0.077490898572233],
            [30.215992706492383, -0.078385563173611],
            [30.217576127317827, -0.077147714598414],
            [30.22032314760889, -0.069828135399621],
            [30.247175897102256, 0.013554174342475],
            [30.16195118189386, 0.012688141837431],
            [30.1570934018578, 0.013384476301776],
            [30.144763181963516, 0.01902659854065],
            [30.135412562475576, 0.021834675346132],
            [30.12106001029792, 0.024395153971653],
            [30.039704367764326, 0.024409191045024],
            [30.039858624668273, 0.016323511385734],
            [30.036404040953784, 0.015543381185518],
            [30.027178342985874, 0.011536473821173],
            [30.023590134872865, 0.010836068187274],
            [30.01943514640945, 0.013441182452532],
            [30.018775867432552, 0.014594956111022],
            [30.01475043220277, 0.017957182098389],
            [30.010616076244794, 0.022283131370721],
            [30.009133856025993, 0.024341396094978],
            [30.00570748480131, 0.018252081923448],
            [30.004243090751014, 0.019716195618975],
            [30.003640377789246, 0.020929622760414],
            [30.001942000455205, 0.021536406845398],
            [29.999673333052932, 0.025869373652668],
            [29.996700189736856, 0.029325220895375],
            [29.9947108426924, 0.032992872774175],
            [29.993707958119327, 0.035776807931935],
            [29.98354506488349, 0.056809589396638],
            [29.982758897974374, 0.061080374727312],
            [29.980384959698906, 0.06437452274733],
            [29.979662938789293, 0.067128418726586],
            [29.978560818225095, 0.072597891707516],
            [29.978408525936665, 0.077187717440046],
            [29.974950994849724, 0.079520667899014],
            [29.97240525287784, 0.082427417422544],
            [29.969555628811666, 0.083995396351223],
            [29.968681877060675, 0.084071753068247],
            [29.968225841018473, 0.085104394108066],
            [29.96761793489605, 0.085142712602532],
            [29.967389987392703, 0.085792867566062],
            [29.966174173351188, 0.086098715728438],
            [29.96536723379946, 0.087235363536845],
            [29.961622662233147, 0.087485347321841],
            [29.95945631922995, 0.086642476131866],
            [29.95704378124504, 0.086840526577281],
            [29.955797228651143, 0.086556996140333],
            [29.955291223821263, 0.085537970889099],
            [29.955587387590658, 0.072459915980311],
            [29.951622869815246, 0.071610447261143],
            [29.946308773462633, 0.069869121004003],
            [29.94576360837458, 0.068790862279772],
            [29.944453049918362, 0.067661091473797],
            [29.943314295158554, 0.067660951336714],
            [29.941079034305073, 0.065792596950032],
            [29.93766290926452, 0.063711735364976],
            [29.92054523125126, 0.05585091946686],
            [29.91362960673201, 0.053535372739999],
            [29.90822624029803, 0.053992390439588],
            [29.90703021793886, 0.052479290387744],
            [29.90743052968735, 0.051699300616881],
            [29.90710797880481, 0.049821401100248],
            [29.90734448815112, 0.049487481264873],
            [29.90689210196393, 0.048606009715303],
            [29.90790958416038, 0.047484659310066],
            [29.90867188912059, 0.04322889288434],
            [29.909929390381176, 0.043513686595581],
            [29.912086891267045, 0.043225383167512],
            [29.912320733515276, 0.041580343754021],
            [29.91198849699733, 0.041485319089921],
            [29.911065619078407, 0.042511363752005],
            [29.91023257178957, 0.041010475143674],
            [29.910182743139075, 0.039770941395121],
            [29.910870235504117, 0.039674933073874],
            [29.911180154277137, 0.040485101870839],
            [29.912270764727598, 0.040340950151366],
            [29.912884426356058, 0.038838518197381],
            [29.9127726983926, 0.036323797390048],
            [29.91201404328739, 0.036467667943661],
            [29.911942178064663, 0.036110166380057],
            [29.913197713811396, 0.035441483070799],
            [29.913314494798335, 0.03455930977863],
            [29.911773322639014, 0.034704022954579],
            [29.910728048364305, 0.033870695540598],
            [29.9107743681953, 0.03327471914744],
            [29.9125050282857, 0.03301069893972],
            [29.912251395253445, 0.030734592940903],
            [29.913033490997684, 0.03044769353793],
            [29.91279248917662, 0.02851715765416],
            [29.911316024463858, 0.025515241633609],
            [29.91081745948117, 0.025301189292114],
            [29.910155653543367, 0.026374535810303],
            [29.909619190435468, 0.025004465002587],
            [29.910281136510452, 0.023954980419947],
            [29.90916638383673, 0.023884658508993],
            [29.908218801349168, 0.024410032766362],
            [29.907671250335728, 0.023385673157221],
            [29.90778873290689, 0.022861140617324],
            [29.908643115183732, 0.023122354511251],
            [29.908920048717828, 0.019379748716884],
            [29.90775729187195, 0.019047231044945],
            [29.90785133470242, 0.018594143297963],
            [29.906795252796524, 0.018273557047535],
            [29.90596276695474, 0.017058726719044],
            [29.90515554623032, 0.016654343823181],
            [29.905130562285642, 0.015986924340261],
            [29.904300322232068, 0.015892460203573],
            [29.902494848648164, 0.014440277902168],
            [29.902848841463978, 0.013557963436226],
            [29.901779284828827, 0.012414857266565],
            [29.900427600600583, 0.012440122383337],
            [29.900152211270463, 0.011141355241079],
            [29.89894313459358, 0.01138095299072],
            [29.89858254544864, 0.008973889377303],
            [29.898911833695813, 0.007662489213518],
            [29.899932544437398, 0.008114313949377],
            [29.900406265612588, 0.007827834919825],
            [29.9004050025813, 0.007184136328741],
            [29.899620379876165, 0.006231500824241],
            [29.898696659337496, 0.006780736175297],
            [29.898316559682907, 0.006471238714218],
            [29.89718440215055, 0.003671723584145],
            [29.89661495380373, 0.00357697916963],
            [29.89517007026309, 0.004412693554514],
            [29.894267964986785, 0.004008450779422],
            [29.89400576921324, 0.003365173494017],
            [29.89469284026841, 0.003030691188385],
            [29.894644695959066, 0.002649328502975],
            [29.893336524326564, 0.000815361257491],
            [29.89224464994649, 0.000292092604518],
            [29.89206302227415, -0.001483483249917],
            [29.89108877150075, -0.002969493459738],
            [29.889718279245415, -0.00381250575853],
            [29.88836589343294, -0.003795100899938],
            [29.88785581833651, -0.004647658696116],
            [29.888625843418282, -0.005588503815287],
            [29.888050500326578, -0.006010570961149],
            [29.88598451531028, -0.00612707167307],
            [29.886473816865767, -0.006777788802874],
            [29.887185591591248, -0.006787052230011],
            [29.887459436717396, -0.007578272156377],
            [29.887450594600065, -0.008222532193913],
            [29.886008237122002, -0.009564250496192],
            [29.886267204350418, -0.011429237436285],
            [29.884979104674628, -0.011913766232603],
            [29.88590043928791, -0.012212174885267],
            [29.88596669004011, -0.012570939543471],
            [29.88410731753916, -0.013191338520884],
            [29.88395011236444, -0.014263281050649],
            [29.882363462993865, -0.015746483975467],
            [29.883412386225256, -0.017120484993749],
            [29.88333420494777, -0.017620594157428],
            [29.882549301968268, -0.017753657102548],
            [29.881487605591847, -0.017310254088953],
            [29.880432786717243, -0.016365900187313],
            [29.880073039293727, -0.016647606458834],
            [29.880694842353613, -0.0180159930005],
            [29.881609158429566, -0.018815493562063],
            [29.881313557005555, -0.01959927360341],
            [29.880875628304544, -0.020381229162867],
            [29.879598476397117, -0.020078328946049],
            [29.88005914415292, -0.022805136053695],
            [29.87884515458974, -0.023075753511344],
            [29.878823399190203, -0.024650753392673],
            [29.877185376965148, -0.024701142587221],
            [29.87802474030875, -0.025785999222997],
            [29.876456899863598, -0.025908815079503],
            [29.876308536806206, -0.026336497551932],
            [29.878219422298816, -0.027148911348507],
            [29.87792873286276, -0.027574769338489],
            [29.875797479851183, -0.02726077943654],
            [29.875293300397978, -0.027683830191189],
            [29.87606837850322, -0.028266612162292],
            [29.876057429836525, -0.029054182141335],
            [29.875342707738604, -0.02925967173597],
            [29.874988855958296, -0.029111870144808],
            [29.875068861714123, -0.028468451903789],
            [29.874426286011616, -0.028603340215188],
            [29.87473353768656, -0.030476186298074],
            [29.873920282080064, -0.032001918885789],
            [29.873994252055496, -0.032522941667977],
            [29.87451162596361, -0.03263452947622],
            [29.87499222464061, -0.031815939803047],
            [29.87543576781215, -0.031741407493699],
            [29.875805480247106, -0.032188038105351],
            [29.873661454988827, -0.034792871709726],
            [29.87358748411507, -0.035685993664258],
            [29.872885113852302, -0.036541778939559],
            [29.873402627897597, -0.038179098333909],
            [29.87225671446329, -0.039258339459697],
            [29.872552456024483, -0.039853754366219],
            [29.874363544078907, -0.039593242996435],
            [29.873956916275667, -0.041416682430289],
            [29.875213715053686, -0.042049292055215],
            [29.874807087250446, -0.042830826137993],
            [29.87377206005819, -0.04238419558033],
            [29.87358734397789, -0.041825977223622],
            [29.872700116599315, -0.041900368489066],
            [29.87362425844785, -0.043463296512545],
            [29.874807087250446, -0.043314513086274],
            [29.874770031744976, -0.043798340168607],
            [29.87402148268671, -0.044300694096687],
            [29.87420633890419, -0.044905372389085],
            [29.875453874255008, -0.045556650767129],
            [29.8740676614822, -0.046207789002153],
            [29.87443723377998, -0.047277626453967],
            [29.87366103367896, -0.048003296069399],
            [29.87495460768809, -0.048859222244424],
            [29.873660893541775, -0.049454496038247],
            [29.873993550471262, -0.050533736999612],
            [29.872404093865423, -0.051501250024819],
            [29.872071295900426, -0.052357036016957],
            [29.870740666385828, -0.053398940267297],
            [29.871627612591716, -0.054999063651168],
            [29.87092538246612, -0.055966577504627],
            [29.87136878550048, -0.056859698296845],
            [29.870629499869413, -0.057417917425031],
            [29.870038155985874, -0.056636383514964],
            [29.869414388310464, -0.056761866420608],
            [29.87056016160759, -0.058548249900219],
            [29.869451303678755, -0.059031935832223],
            [29.870005592056824, -0.060408744292715],
            [29.868785707748764, -0.061822747441005],
            [29.86776920830924, -0.064074008625816],
            [29.868064669596073, -0.065934642960481],
            [29.867251554126764, -0.065971838578488],
            [29.866918896298948, -0.065115913556059],
            [29.866586239369468, -0.065153109174675],
            [29.866475353127417, -0.06623234983751],
            [29.86695581166724, -0.067311450339761],
            [29.86629035677276, -0.067869668458779],
            [29.86629035677276, -0.069172084552177],
            [29.865551071141695, -0.068427746434274],
            [29.864922671752687, -0.068464942948714],
            [29.8652182731767, -0.06980455464092],
            [29.866253301267292, -0.070362772730755],
            [29.866253301267292, -0.070735011844431],
            [29.865181358706746, -0.070920990813912],
            [29.863665872076332, -0.070288240466086],
            [29.863222328904797, -0.070809122798834],
            [29.86521813303952, -0.072074483334473],
            [29.865144162165763, -0.072707092622285],
            [29.86409074735795, -0.072986131581882],
            [29.86416457809453, -0.073581546143264],
            [29.865125634413026, -0.073804861748295],
            [29.865310491528835, -0.074400275400404],
            [29.863720893887486, -0.077153890510393],
            [29.864607840093374, -0.079126252171738],
            [29.863461926659067, -0.07957260215049],
            [29.86409032604808, -0.080056428004859],
            [29.86560581267849, -0.079982176929152],
            [29.865901414102503, -0.081098472703946],
            [29.865457730793793, -0.082326497194568],
            [29.865716417747844, -0.08362891195517],
            [29.864847718122004, -0.084614952952222],
            [29.864847577984822, -0.085173170846909],
            [29.864293149469567, -0.085061443006735],
            [29.863701804687697, -0.085470737454837],
            [29.86248164010527, -0.089229059656487],
            [29.859302446619232, -0.094326852214907],
            [29.858341529539587, -0.093359339205558],
            [29.85782401549429, -0.093322003475271],
            [29.857805347604376, -0.094754674286561],
            [29.856844290387553, -0.095387283208422],
            [29.857768292098907, -0.095908305347218],
            [29.857657406755187, -0.096243208492405],
            [29.85695503649242, -0.096354796161077],
            [29.856104864619308, -0.097247775974554],
            [29.853739207912447, -0.097582397934237],
            [29.854330411658815, -0.099182659812071],
            [29.854182610946804, -0.09970354175514],
            [29.85355421065946, -0.099108128501175],
            [29.852630068810925, -0.100336011345339],
            [29.851595181755847, -0.100112695897252],
            [29.852555957799986, -0.102643133801975],
            [29.85152093060773, -0.102940700260958],
            [29.85148387510226, -0.103945407674914],
            [29.850744449334016, -0.105433801326683],
            [29.85044884701167, -0.10461507276231],
            [29.85000530384014, -0.104466289541034],
            [29.85004221920843, -0.105322073552188],
            [29.849228963601934, -0.106215054016934],
            [29.84982030748548, -0.106587292770931],
            [29.849746336611723, -0.107517608913175],
            [29.848674394051177, -0.107443076723501],
            [29.846789194985806, -0.109154645454869],
            [29.846789054848628, -0.109936037288359],
            [29.84738039873217, -0.110791962181293],
            [29.847528059307, -0.112801377357166],
            [29.846899519780806, -0.113619965561854],
            [29.84734306295234, -0.114326966139431],
            [29.847268951941395, -0.115369009775567],
            [29.844644748417664, -0.114922098824205],
            [29.843942378154896, -0.11570349140168],
            [29.843960624734937, -0.117545455228115],
            [29.84329516984046, -0.118512826447123],
            [29.843553715759, -0.120299065916676],
            [29.842444857830166, -0.120336121340443],
            [29.842851205359047, -0.122122361588958],
            [29.84237060668205, -0.12279202535766],
            [29.84397831076626, -0.124894780692926],
            [29.845419685487396, -0.125452997868204],
            [29.84534571461364, -0.125825096232272],
            [29.844495683776042, -0.125452997868204],
            [29.84486511593663, -0.126532096494222],
            [29.845715427946924, -0.126160138277091],
            [29.84545645982018, -0.127127509185541],
            [29.846195745451237, -0.126941670667917],
            [29.84538080550359, -0.128706996843486],
            [29.846232520682346, -0.128832479493661],
            [29.846556194458987, -0.129506635553425],
            [29.8460376985551, -0.129774023803171],
            [29.84615026823998, -0.130384596348462],
            [29.845755852134708, -0.130440319599503],
            [29.845564117517092, -0.131168654665842],
            [29.844692050107266, -0.13073100828056],
            [29.844655836323206, -0.131156864308632],
            [29.845340801727346, -0.131988084927472],
            [29.84543456338513, -0.132857202643563],
            [29.846394497707852, -0.13350932118418],
            [29.845187947991864, -0.1353512837565],
            [29.844579059112515, -0.135586950722674],
            [29.844591129774976, -0.136896661958061],
            [29.843813104297293, -0.137327993094884],
            [29.84428682547248, -0.138095629135633],
            [29.84376580260769, -0.138545627187781],
            [29.84356803310801, -0.13970024009678],
            [29.84298904105962, -0.139966786515754],
            [29.84376678536462, -0.140646977131323],
            [29.84185407539368, -0.141017812238471],
            [29.84266255914939, -0.14166796594706],
            [29.84251981146085, -0.143219239359253],
            [29.841379652634252, -0.142473358818853],
            [29.841163074209135, -0.142805594307237],
            [29.8416645874626, -0.143756261331853],
            [29.841622899345197, -0.144577936941344],
            [29.84235109617239, -0.144465647888045],
            [29.842344780117624, -0.144922383159711],
            [29.84045972208777, -0.145476389484443],
            [29.839867395447303, -0.144524458606034],
            [29.839853920718042, -0.145498847294145],
            [29.839492348816187, -0.145372381977552],
            [29.83932461628465, -0.144365149184871],
            [29.839066210503287, -0.144437855898104],
            [29.839507366851098, -0.147549946807206],
            [29.838819735247203, -0.149094202200071],
            [29.838424055212315, -0.149241300829324],
            [29.838952376888788, -0.150435915036585],
            [29.838934550720285, -0.151714746839582],
            [29.837415836443075, -0.152060316735362],
            [29.836529311547057, -0.151576631348407],
            [29.83446613376603, -0.151884584426076],
            [29.833267164034417, -0.151016309143476],
            [29.832416010302715, -0.151248747414612],
            [29.830191978390285, -0.150062413893671],
            [29.828674948454232, -0.151367352466312],
            [29.82670090061738, -0.15179826202029],
            [29.824959993444523, -0.150709619978728],
            [29.824846861414265, -0.150129507035399],
            [29.824300714467622, -0.150213723804017],
            [29.824129753390945, -0.149450158423366],
            [29.823371238422922, -0.149562026143163],
            [29.82353139097008, -0.148924645763607],
            [29.82278270177464, -0.14833625123226],
            [29.82232694690513, -0.148452049073889],
            [29.822005377881183, -0.147625601771129],
            [29.82087883481936, -0.148067739403869],
            [29.819007250620434, -0.149839941485577],
            [29.81791397307189, -0.150069291371892],
            [29.816840206033007, -0.153252826042297],
            [29.814736463927012, -0.151955887951102],
            [29.750495130724357, -0.183292078075306],
            [29.750496112582955, -0.183631751800786],
            [29.69954844241681, -0.210556206967397],
          ],
          [
            [29.880472509320796, -0.15138770552468],
            [29.872048417606784, -0.150824996499421],
            [29.872060628406427, -0.149668560582754],
            [29.869041166157682, -0.147336036188458],
            [29.86830777616984, -0.147025135684279],
            [29.865798809429062, -0.147879655268516],
            [29.86491102150176, -0.147646375243111],
            [29.86386897577218, -0.146597034161226],
            [29.86128295064802, -0.145974952854559],
            [29.860356703148454, -0.145236512227754],
            [29.858369461755036, -0.14039825683508],
            [29.85336023115196, -0.135954977783188],
            [29.854278898667157, -0.133099747117024],
            [29.857238005806916, -0.131130336229471],
            [29.857278991441756, -0.125595323905308],
            [29.858404832919348, -0.122245318213893],
            [29.859624295917538, -0.120583297634476],
            [29.85933725633649, -0.116850244195913],
            [29.85960773278032, -0.114440939663981],
            [29.86080445762205, -0.112459316625874],
            [29.86315916656055, -0.111099494452372],
            [29.866478581672553, -0.111177535445863],
            [29.87657213664656, -0.112597011025374],
            [29.880586623209645, -0.11065440791026],
            [29.881667408785855, -0.110576928361398],
            [29.886955257264184, -0.112870154038571],
            [29.888113242259287, -0.113841736710716],
            [29.88942534402115, -0.116056921149262],
            [29.890042654606294, -0.118738246506425],
            [29.889849236545846, -0.12180809208873],
            [29.888180615905593, -0.127192636883244],
            [29.890832891781955, -0.128122952340208],
            [29.893958747798003, -0.133952301702032],
            [29.897239142789015, -0.137955267779768],
            [29.899555252018065, -0.137877788310976],
            [29.90364693800005, -0.136984528619989],
            [29.90683174685494, -0.134750537079078],
            [29.908762141958874, -0.131214553066653],
            [29.910537858848986, -0.130554011883595],
            [29.920805602546476, -0.130866175632508],
            [29.926479866734155, -0.131566439306193],
            [29.92663412453643, -0.131916219895322],
            [29.927868606467868, -0.137823187967725],
            [29.92339078505089, -0.13980452880115],
            [29.92169240771685, -0.139065946941433],
            [29.921113275531287, -0.139221327179622],
            [29.917774068736932, -0.141455318300364],
            [29.914801627903426, -0.142659618526521],
            [29.91287137293667, -0.144446979159134],
            [29.911944985299925, -0.14471885970245],
            [29.909474758405775, -0.143552737864163],
            [29.906734055067794, -0.143863217107629],
            [29.903607075259313, -0.146932778397179],
            [29.902564468082687, -0.149730599821143],
            [29.901291667614498, -0.150124172857545],
            [29.898311366522254, -0.150022129981195],
            [29.880472509320796, -0.15138770552468],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 345,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "LAKE KATWE",
        Population: 19636,
        Key: "KASESELAKE KATWE",
        Dist2: "Kasese",
        "Sub Country": "L. Katwe",
        id2_original: "Kasese L. Katwe",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.026378070730168, 0.170426372675411],
            [30.023319724904354, 0.170951730275114],
            [30.019397600423837, 0.170695180655053],
            [30.008938391603323, 0.171753774015017],
            [30.00165713300051, 0.171368723674424],
            [29.99842479158899, 0.172940288627164],
            [29.995556201392198, 0.170819342547264],
            [29.9943941605036, 0.170490115947553],
            [29.993184727195572, 0.170964296751704],
            [29.992855175742015, 0.172083370697222],
            [29.990961008795164, 0.173741026138892],
            [29.988074507988237, 0.175351560527659],
            [29.978306418929883, 0.171218729946825],
            [29.976805204732724, 0.169925794979515],
            [29.976877556842346, 0.160643134846526],
            [29.974605715692157, 0.153733568521252],
            [29.97431400576997, 0.146444006652946],
            [29.975477892696468, 0.141388691357002],
            [29.97558204067555, 0.137633227173303],
            [29.97793353903523, 0.12903591594937],
            [29.979607904401718, 0.125008857479591],
            [29.983694276848798, 0.116669165770188],
            [29.98514133970233, 0.115412584266704],
            [29.988385818251658, 0.114233687960834],
            [29.989250395508627, 0.112648459238948],
            [29.986484017421503, 0.113175232993595],
            [29.984826856589358, 0.112536922831993],
            [29.982719951515246, 0.112443339221004],
            [29.98261864490738, 0.110641966266761],
            [29.983803464376642, 0.100457735574397],
            [29.985784108542614, 0.099452286942897],
            [29.987274191715105, 0.100776178868452],
            [29.98845742296293, 0.102585421629105],
            [29.990648805606387, 0.103732890882224],
            [29.993805256444375, 0.104482609207673],
            [29.99503160502922, 0.10571896204635],
            [29.992947312347443, 0.108665178595324],
            [29.993979200826114, 0.110528516444241],
            [29.996784131011967, 0.112382079626412],
            [30.000421855161743, 0.11410336243476],
            [30.003456372276318, 0.114278107766655],
            [30.00309435750502, 0.11760972865304],
            [30.00757934568134, 0.117710769146518],
            [30.010877608163355, 0.117282690474408],
            [30.013679204701184, 0.118389817703181],
            [30.0148844222156, 0.123674116824086],
            [30.018181832196404, 0.130743879308431],
            [30.019245387187155, 0.133993070731451],
            [30.020060341507854, 0.139884333994948],
            [30.022471114303233, 0.146382789361156],
            [30.02699191920823, 0.153756328155374],
            [30.03160165912299, 0.159112640631307],
            [30.032419443136817, 0.160572024488036],
            [30.0316568911399, 0.160188038429199],
            [30.02736329891636, 0.160219035575242],
            [30.027652224061182, 0.160886781246999],
            [30.02651577886998, 0.164096883631878],
            [30.025981387277124, 0.167098017595084],
            [30.026378070730168, 0.170426372675411],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 346,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "MAHANGO",
        Population: 19875,
        Key: "KASESEMAHANGO",
        Dist2: "Kasese",
        "Sub Country": "Mahango",
        id2_original: "Kasese Mahango",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.977895825064653, 0.420135636952535],
            [29.97414367081904, 0.415894045206782],
            [29.966091459174777, 0.40921499808028],
            [29.958037822802453, 0.404228586356295],
            [29.953832379562797, 0.400625555084442],
            [29.953037534928058, 0.40025843966217],
            [29.951778767941228, 0.400391350248999],
            [29.94583165036746, 0.404007180502268],
            [29.942584537059414, 0.406573604856555],
            [29.936555522776132, 0.407838434968187],
            [29.93486592467736, 0.408604748523543],
            [29.934136839416336, 0.409571497078224],
            [29.93236246550759, 0.41542302149106],
            [29.92984415538953, 0.417789589410354],
            [29.927525160771804, 0.418689003625425],
            [29.919194343828682, 0.419435960652291],
            [29.917869103307467, 0.420235727244834],
            [29.91697445045478, 0.42106900180742],
            [29.915681388485357, 0.424236305253211],
            [29.913181604323416, 0.43602902542165],
            [29.87254725747395, 0.38515312444991],
            [29.87727894458682, 0.386100356699299],
            [29.88034557198124, 0.385536092746815],
            [29.881908424081644, 0.38393791449713],
            [29.889850230082537, 0.380275378581785],
            [29.892136614058863, 0.377286644739799],
            [29.893421602868806, 0.376461729778652],
            [29.896830694100686, 0.375137144773651],
            [29.89858646120496, 0.375683694111588],
            [29.90030402116358, 0.374735446542509],
            [29.90173710712961, 0.374995927246898],
            [29.90437836157575, 0.372624684079206],
            [29.90488222572028, 0.371714983874225],
            [29.9050318895382, 0.368354979290444],
            [29.90596205369241, 0.366808502066195],
            [29.907582503972176, 0.366659594086845],
            [29.910268813421403, 0.364658787556708],
            [29.911805474241362, 0.364126390211346],
            [29.91235465929029, 0.362833234788166],
            [29.914201636836953, 0.361053091485676],
            [29.914880105624956, 0.359253046949086],
            [29.914525958298906, 0.356516761905494],
            [29.9147588213835, 0.355178006898274],
            [29.915650311268074, 0.353423515709028],
            [29.91563150234268, 0.351727218651083],
            [29.916865696813208, 0.3483025354845],
            [29.91910006833456, 0.346301517458866],
            [29.921288835982203, 0.345606812607944],
            [29.92295434036672, 0.345932330088174],
            [29.924723617234573, 0.344802038229909],
            [29.928190692023072, 0.343990761895007],
            [29.928875364576463, 0.342925103332077],
            [29.930870323396487, 0.342659284918905],
            [29.931812508805816, 0.34382945881679],
            [29.93372323978819, 0.344532014032841],
            [29.93670628074205, 0.343324109859902],
            [29.937907065968858, 0.343389490767198],
            [29.93832012660785, 0.343779588843323],
            [29.938797971050185, 0.34344178165892],
            [29.939850253980758, 0.34357860609233],
            [29.940483177285554, 0.342811887989038],
            [29.942923540586392, 0.342799681899454],
            [29.947771654749978, 0.343899654603839],
            [29.94885654472872, 0.343016084870628],
            [29.95008962618661, 0.343087977550812],
            [29.952193718635577, 0.344908500137404],
            [29.954311383730154, 0.344649209718517],
            [29.95642206801669, 0.3460472818059],
            [29.958371845171197, 0.345917923170208],
            [29.9597981901793, 0.347315779478973],
            [29.961166776209623, 0.347667203836305],
            [29.961889005528366, 0.350306238099506],
            [29.970125250533325, 0.355768566864623],
            [29.971338442392515, 0.357484849409825],
            [29.974469671232267, 0.357544393079238],
            [29.976386522436695, 0.359462416767482],
            [29.980640231258263, 0.362304170018224],
            [29.985075565955547, 0.362598158473708],
            [29.98613402480366, 0.363716448707477],
            [29.988729118420622, 0.364679283103115],
            [29.996612150347453, 0.365026443480596],
            [29.998510869956135, 0.36335015454874],
            [30.00288630858355, 0.362250979138617],
            [30.00447482644992, 0.360987029792794],
            [30.007939118257674, 0.360867323571483],
            [30.010098655624297, 0.361057771615395],
            [30.010775404138517, 0.361498796126452],
            [30.012791292806384, 0.360473212617117],
            [30.014547241370334, 0.360472975466577],
            [30.01563986045377, 0.361498119708501],
            [30.017799948487642, 0.362189298450563],
            [30.02024340019644, 0.361569006153009],
            [30.021796723866625, 0.360674625288407],
            [30.022365176880097, 0.359673084621108],
            [30.02475969915199, 0.35764597798293],
            [30.02670492005135, 0.357097274324755],
            [30.02736800519012, 0.355833427570754],
            [30.029679868082827, 0.354175899703758],
            [30.030673993183576, 0.351815143195633],
            [30.03299831391266, 0.350717952544415],
            [30.03654144636134, 0.346556527438647],
            [30.03808302635578, 0.345769411003076],
            [30.040950986833543, 0.342669150939214],
            [30.04513926506476, 0.342656558580771],
            [30.047251854678002, 0.343252344739992],
            [30.048343191865552, 0.343037565899036],
            [30.05175793439887, 0.340843285740368],
            [30.056610695547445, 0.340830574803978],
            [30.06128637988887, 0.341640546177735],
            [30.063929807359692, 0.339339049160687],
            [30.065376660905763, 0.338694991732711],
            [30.06587369785415, 0.337502650767932],
            [30.067937045416766, 0.336405426131813],
            [30.068838821909672, 0.336429122382203],
            [30.070902111980107, 0.335284192510843],
            [30.073665796917993, 0.334461056919028],
            [30.077194099079666, 0.334049576232327],
            [30.078862919145905, 0.332072063767468],
            [30.08145856882, 0.329982858932556],
            [30.081792454644813, 0.329161893193065],
            [30.084944109377496, 0.327334088741277],
            [30.085204059362837, 0.325803989815893],
            [30.086891317350307, 0.324143687332128],
            [30.088709070904127, 0.319889581271102],
            [30.09067436915012, 0.318210682984508],
            [30.093788564135476, 0.317763716030642],
            [30.094678455917172, 0.317204145166275],
            [30.100628185791802, 0.318605409201464],
            [30.101840052635936, 0.318240926098714],
            [30.10302213673517, 0.314186881981143],
            [30.103733453319833, 0.313638283681082],
            [30.10414675470735, 0.311837834246026],
            [30.10338573254136, 0.310359521930988],
            [30.103408011658704, 0.309047985505163],
            [30.101303129590622, 0.304815737977008],
            [30.10128899100637, 0.302776906250849],
            [30.10086099138418, 0.302013917519612],
            [30.100929947862042, 0.300010843115298],
            [30.101817701653353, 0.298091056315578],
            [30.10265533574004, 0.293786672556877],
            [30.10301070567317, 0.293261988755988],
            [30.104279836523414, 0.292844423137879],
            [30.10527670238411, 0.292987283943844],
            [30.105893249401248, 0.292581766363024],
            [30.10650875347436, 0.291246259261939],
            [30.10759965138573, 0.290602185387509],
            [30.108226305348147, 0.288634741947197],
            [30.109802387836027, 0.286834017107089],
            [30.110228549505127, 0.285951611230436],
            [30.110663105032263, 0.282004977083397],
            [30.112251185419083, 0.280335386603543],
            [30.112273345958815, 0.278952297576975],
            [30.113505516525013, 0.277330477611951],
            [30.11403698410162, 0.275148424180995],
            [30.11529364813235, 0.274194294057419],
            [30.11590782539378, 0.271714134787724],
            [30.119151635596538, 0.265298715058443],
            [30.11967120139393, 0.263104717388918],
            [30.121093752816623, 0.261959751120347],
            [30.121184575186803, 0.261319780018269],
            [30.12280719399966, 0.258730984200388],
            [30.12306605971844, 0.256847050167162],
            [30.125199144394895, 0.254485728882652],
            [30.128483835129593, 0.252684497717505],
            [30.13016707135952, 0.251229438655579],
            [30.13274038622071, 0.249905308537844],
            [30.133523498857866, 0.249881257273181],
            [30.13454197998092, 0.248187894160944],
            [30.135538807214033, 0.247589141186907],
            [30.135885785984076, 0.246649103409785],
            [30.13764129976347, 0.245600272500514],
            [30.139945098479863, 0.245683608443523],
            [30.142303549799834, 0.246733342144752],
            [30.144004039971414, 0.246512826649975],
            [30.14480039108089, 0.246979274332435],
            [30.144963756003513, 0.247507036834589],
            [30.146143140665334, 0.247314015832437],
            [30.147130258906852, 0.248418679969996],
            [30.15039365777268, 0.250131298257213],
            [30.151943229179892, 0.250311113211218],
            [30.15430162031276, 0.251719813466121],
            [30.155672925543403, 0.251885789985034],
            [30.15425403834877, 0.254904163601017],
            [30.14957911218543, 0.260242519809846],
            [30.14834009286352, 0.262397005100361],
            [30.148018095343165, 0.264821509933182],
            [30.148923905271705, 0.268302956020519],
            [30.14858603811358, 0.273752080058264],
            [30.148167188730895, 0.27462080207621],
            [30.148389987989344, 0.278724226112049],
            [30.14788736890979, 0.281821072611321],
            [30.148243920127506, 0.284230138859865],
            [30.14910025534176, 0.287502249284035],
            [30.149975007815982, 0.288527188022459],
            [30.153117729701496, 0.289211131434327],
            [30.153974716194355, 0.28989449719561],
            [30.154438242389357, 0.292914840254689],
            [30.156901832530178, 0.29579188695279],
            [30.159508934825872, 0.296152118253482],
            [30.164010935297025, 0.297759120729106],
            [30.162781811816277, 0.299288705419156],
            [30.160403121452934, 0.303975720836624],
            [30.160689816979225, 0.305692660013484],
            [30.16020417695684, 0.306467796228404],
            [30.160183100683675, 0.308852528415652],
            [30.159234561490333, 0.309520440358879],
            [30.157646908701565, 0.311667000564066],
            [30.157219965498165, 0.311881712704434],
            [30.156032829273787, 0.311405004496159],
            [30.15494179931008, 0.311977552541764],
            [30.154315476826024, 0.314302761113291],
            [30.153391682625493, 0.315876854284405],
            [30.15256164109958, 0.316401654661001],
            [30.15204149409219, 0.318166439842384],
            [30.151140551235894, 0.318953568358948],
            [30.150001437149957, 0.318977628462672],
            [30.14880454791656, 0.320396756773305],
            [30.14681212234562, 0.321351013151911],
            [30.147836240397055, 0.324665547146729],
            [30.149403064847625, 0.325142196352555],
            [30.15069778600538, 0.326346228394653],
            [30.150511068478618, 0.329207911328919],
            [30.15115341780569, 0.33066245908325],
            [30.151155616881514, 0.332665612909642],
            [30.152545067182597, 0.333702704861277],
            [30.15276012835318, 0.335061954908814],
            [30.154066929156574, 0.336468704166134],
            [30.154139038721045, 0.337303334232043],
            [30.152598921183888, 0.339569075820052],
            [30.152303473371774, 0.340678020210522],
            [30.15235577418592, 0.345137411874168],
            [30.151538703434426, 0.346699535716433],
            [30.14995056645372, 0.348464475380366],
            [30.150284570856154, 0.350086021119335],
            [30.14940832897521, 0.351803151810968],
            [30.149456593658762, 0.352542400121072],
            [30.150870908428633, 0.354652634589123],
            [30.150966786517216, 0.355534964475479],
            [30.14901249802335, 0.358193459025079],
            [30.146260269300278, 0.359530072949674],
            [30.146653233728035, 0.360829668738216],
            [30.146440050934714, 0.361211257410926],
            [30.144613104022266, 0.361593087709588],
            [30.14333435850352, 0.364192593812263],
            [30.139859780985766, 0.366208176532514],
            [30.136086282768986, 0.366065659926019],
            [30.134426507839315, 0.367425165782047],
            [30.133145272190617, 0.367687667869509],
            [30.132196863252993, 0.36849859807051],
            [30.130784513996996, 0.368200725573034],
            [30.12950331158596, 0.368487067534007],
            [30.128363567781026, 0.367891062022245],
            [30.127106177013246, 0.368248951531421],
            [30.12423445528937, 0.368058597960783],
            [30.123784247516735, 0.368702523996384],
            [30.122894375497967, 0.368762265217181],
            [30.121993208062833, 0.369358554532355],
            [30.119571341073694, 0.368166584008946],
            [30.118289625724643, 0.367952158778282],
            [30.1181007046305, 0.368834499049404],
            [30.118457380714045, 0.369502142754157],
            [30.11684516529047, 0.370933156077393],
            [30.11582456683833, 0.370790227228388],
            [30.11561015245472, 0.370003329364146],
            [30.11485077061246, 0.370027283339997],
            [30.112183163189137, 0.372066516884257],
            [30.108980732981614, 0.373283123554842],
            [30.106702361079332, 0.373116521044942],
            [30.102194263742348, 0.37388021743849],
            [30.101340414166486, 0.374333409635303],
            [30.100296130733536, 0.374214320722339],
            [30.098754340533315, 0.374906067998256],
            [30.098518667518498, 0.375148321372866],
            [30.09979627577009, 0.380655071911377],
            [30.09921154887693, 0.386308740449938],
            [30.094799641343947, 0.386854265023153],
            [30.09232380896241, 0.386413026195137],
            [30.090310413119497, 0.386625681330026],
            [30.08937546184315, 0.38711444533076],
            [30.088517237471827, 0.388928752663633],
            [30.085835884926347, 0.3891436929967],
            [30.083819587525074, 0.389930846029851],
            [30.083250843457442, 0.390693980393825],
            [30.08234927357704, 0.390884851782258],
            [30.08173362936675, 0.392196429743644],
            [30.080927360856517, 0.392744978492247],
            [30.078448258607377, 0.39347255632291],
            [30.076029952540036, 0.395618938175707],
            [30.07014659379186, 0.398912815854313],
            [30.06818562273059, 0.400778897346632],
            [30.066966235190886, 0.403071939809078],
            [30.065394632601325, 0.404713987009808],
            [30.06341612193412, 0.404137375488513],
            [30.06097977230598, 0.402003019511024],
            [30.058433397920144, 0.398074019872389],
            [30.055968686681876, 0.398279951881754],
            [30.052671331498296, 0.399377182383994],
            [30.042402234937978, 0.404548274430208],
            [30.038158768707277, 0.405783186320355],
            [30.034530113050298, 0.405163605037984],
            [30.023885299715662, 0.405609270553023],
            [30.020181805412356, 0.406188646016245],
            [30.00395458511941, 0.406107629894604],
            [29.997463201671184, 0.406535878361026],
            [29.99525256543627, 0.407026142232388],
            [29.993521410374143, 0.409473297556402],
            [29.991440173760967, 0.410447025736954],
            [29.990708555250862, 0.410155163398367],
            [29.989382044511853, 0.410814564691087],
            [29.986835280257175, 0.413345789098594],
            [29.986613887760445, 0.414258837194916],
            [29.984676961904416, 0.416621468251545],
            [29.98174979885617, 0.417280233914859],
            [29.98092630065878, 0.418077940945223],
            [29.97885288657509, 0.418583571174908],
            [29.977895825064653, 0.420135636952535],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 347,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "MALIBA",
        Population: 46652,
        Key: "KASESEMALIBA",
        Dist2: "Kasese",
        "Sub Country": "Maliba",
        id2_original: "Kasese Maliba",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.26521139012949, 0.142376190151424],
            [30.264825684089217, 0.139306368639736],
            [30.256126477929563, 0.138437293375958],
            [30.25065914426083, 0.138606904687359],
            [30.250655362353484, 0.139168876501613],
            [30.25058788270595, 0.138717469008728],
            [30.24759596819373, 0.138536053869799],
            [30.23470445845203, 0.139550606367572],
            [30.22209195914942, 0.139510123011022],
            [30.21171608613947, 0.140964741728795],
            [30.208976774291866, 0.142398910271421],
            [30.206923061160687, 0.144430043274904],
            [30.205126781833716, 0.14497876394148],
            [30.204510657024745, 0.14471449480241],
            [30.201580571756878, 0.146290100594124],
            [30.198449881906285, 0.1454432579269],
            [30.197849003304313, 0.146745855770078],
            [30.195830778118406, 0.146616876084259],
            [30.195666527456915, 0.148432095761759],
            [30.193446173247267, 0.150533561571181],
            [30.193057898025256, 0.152050894339522],
            [30.1916431466742, 0.154512561361084],
            [30.191505479856914, 0.155805641945305],
            [30.192017554603144, 0.157731137616571],
            [30.191655479644748, 0.158797554164719],
            [30.189011082891724, 0.159762293441278],
            [30.138862840564915, 0.170491201107609],
            [30.13724805416299, 0.170060612645653],
            [30.13686818717207, 0.169438948858074],
            [30.13324659227321, 0.169808965997018],
            [30.13160771125877, 0.17174523736322],
            [30.12982642750884, 0.173107705086648],
            [30.129754785068293, 0.175713617617276],
            [30.12829414417924, 0.176705547036049],
            [30.126798053074157, 0.176657499973204],
            [30.12660797584825, 0.177326880904917],
            [30.126275539005988, 0.17708775231666],
            [30.12482689242261, 0.177422224937335],
            [30.124019283626005, 0.178593566719147],
            [30.123306855825298, 0.178665171082458],
            [30.122475811779555, 0.177876095654675],
            [30.12202460328369, 0.177899930539252],
            [30.12048059873629, 0.180529499412867],
            [30.11864586792192, 0.180968324245592],
            [30.10140807976525, 0.174150725190663],
            [30.095034492400256, 0.166338875223518],
            [30.083439670228493, 0.150879542014424],
            [30.074644993815344, 0.150771207363153],
            [30.073242152328337, 0.151487236713859],
            [30.068200154776967, 0.138378410777519],
            [30.067895333943174, 0.12231899247582],
            [30.06746491066635, 0.120667108468136],
            [30.06393020621167, 0.115545775406723],
            [30.06381298594855, 0.113368651574393],
            [30.062222710079197, 0.113393238415576],
            [30.059155290370665, 0.112397062598208],
            [30.042544057361773, 0.109253859706221],
            [30.042631284674197, 0.113534215248267],
            [30.041228415339372, 0.115872810012247],
            [30.038291589113623, 0.11675503465175],
            [30.03439055977091, 0.11679873939616],
            [30.032111231162844, 0.117592772089447],
            [30.03105911262398, 0.119048842838777],
            [30.030971249304343, 0.120902160224767],
            [30.032023021093533, 0.122534971231585],
            [30.03299121093371, 0.123200650072584],
            [30.035003521611763, 0.1229765820117],
            [30.036493616462355, 0.124609451282201],
            [30.03991239692286, 0.125448263758014],
            [30.04273139921765, 0.127685742482512],
            [30.04280483828876, 0.129464186671383],
            [30.04043701843869, 0.136833143163853],
            [30.040874966902635, 0.139745596798928],
            [30.042715576292238, 0.142349341387088],
            [30.046660162248124, 0.144644490213821],
            [30.05348577467758, 0.147132147139935],
            [30.05652161950216, 0.15082369933664],
            [30.058493956048405, 0.151750660460407],
            [30.062637490093632, 0.157438466705657],
            [30.062411893481386, 0.159663050649213],
            [30.049175792691663, 0.160725262998423],
            [30.04291336914812, 0.161084598474851],
            [30.032419443136817, 0.160572024488036],
            [30.03160165912299, 0.159112640631307],
            [30.02699191920823, 0.153756328155374],
            [30.022471114303233, 0.146382789361156],
            [30.020060341507854, 0.139884333994948],
            [30.019245387187155, 0.133993070731451],
            [30.018181832196404, 0.130743879308431],
            [30.0148844222156, 0.123674116824086],
            [30.013679204701184, 0.118389817703181],
            [30.010877608163355, 0.117282690474408],
            [30.00757934568134, 0.117710769146518],
            [30.00309435750502, 0.11760972865304],
            [30.003456372276318, 0.114278107766655],
            [30.000421855161743, 0.11410336243476],
            [29.996784131011967, 0.112382079626412],
            [29.993979200826114, 0.110528516444241],
            [29.992947312347443, 0.108665178595324],
            [29.99503160502922, 0.10571896204635],
            [29.993805256444375, 0.104482609207673],
            [29.990648805606387, 0.103732890882224],
            [29.98845742296293, 0.102585421629105],
            [29.987274191715105, 0.100776178868452],
            [29.985784108542614, 0.099452286942897],
            [29.99008267563621, 0.098116213826867],
            [29.98950544698073, 0.096519095997178],
            [29.98776166160571, 0.094698782982604],
            [29.985633633546012, 0.093543042640176],
            [29.985048407189538, 0.091433891830995],
            [29.983694536461933, 0.090434006195305],
            [29.980304354766783, 0.085133247963129],
            [29.97900325646883, 0.080831662551164],
            [29.97691131732736, 0.078402214330123],
            [29.978408516055197, 0.077187752474301],
            [29.978560812835212, 0.072597890809186],
            [29.97966297023033, 0.067128366624323],
            [29.980385009106246, 0.064374483221482],
            [29.982758902465957, 0.061080382812148],
            [29.98354502984917, 0.056809578616878],
            [29.993707995848567, 0.035776863627478],
            [29.99471089748962, 0.032992936554559],
            [29.996700169075623, 0.029325223590299],
            [29.999673320476504, 0.025869416771791],
            [30.001941944759647, 0.021536336776796],
            [30.003640384077457, 0.020929646116604],
            [30.00424307637796, 0.019716201907188],
            [30.005707472224888, 0.018252137618999],
            [30.009133920704684, 0.024341346687642],
            [30.010616060973444, 0.022283153828613],
            [30.014750484305072, 0.017957233302354],
            [30.018775888992113, 0.014594998331851],
            [30.01943509969707, 0.013441179757574],
            [30.023590066600924, 0.010836129272709],
            [30.02717829627349, 0.011536413634036],
            [30.03640408497124, 0.015543338964689],
            [30.039858589633987, 0.016323573369498],
            [30.039704297695714, 0.024409207214704],
            [30.12105998245014, 0.024395183616054],
            [30.135412629849228, 0.021834731041681],
            [30.14476323226919, 0.019026568896247],
            [30.157093363230228, 0.013384438572532],
            [30.161951117215168, 0.012688181363302],
            [30.24717595728936, 0.01355424351275],
            [30.246953953938277, 0.012910422762406],
            [30.248949536189116, 0.019499447424969],
            [30.250750748165284, 0.023963693179134],
            [30.25668677693521, 0.043537774912965],
            [30.257221438920933, 0.046971823865014],
            [30.257165365182612, 0.049592526621662],
            [30.25682868919051, 0.050948048829326],
            [30.254609094955576, 0.054779591853249],
            [30.254681058992986, 0.05737318404128],
            [30.255354064227443, 0.059063119034141],
            [30.25452769591275, 0.061304225785292],
            [30.255088382990582, 0.064919015548963],
            [30.255739204329114, 0.066825839396188],
            [30.257562027974387, 0.068398369748802],
            [30.257742164443382, 0.069970803930241],
            [30.258974022395858, 0.07253736686549],
            [30.258693407565723, 0.074127848942916],
            [30.259214261547218, 0.075058686044718],
            [30.258372820400368, 0.075682178296188],
            [30.2589034660185, 0.079080098573051],
            [30.26077624587506, 0.082134714265455],
            [30.260896381171253, 0.083083601018822],
            [30.261697514013015, 0.083309582770114],
            [30.264101173947946, 0.086210623228438],
            [30.263470027510813, 0.087936636137284],
            [30.26433121991581, 0.089626614889428],
            [30.26489187555261, 0.092635969979272],
            [30.266644282059406, 0.097507046459106],
            [30.26665422820624, 0.099332518339524],
            [30.266213320691755, 0.100236179025799],
            [30.266794186625823, 0.101203186985568],
            [30.26669384750352, 0.103444351586238],
            [30.26916752482669, 0.107185892203706],
            [30.26949768623631, 0.110285616035615],
            [30.270298809196596, 0.112120205952326],
            [30.27001818717991, 0.113222694490678],
            [30.269096751057035, 0.114054009090885],
            [30.267874755708057, 0.114740701484902],
            [30.266632786318723, 0.114577913606648],
            [30.266823016258233, 0.115617185936589],
            [30.266361988278025, 0.118436679118222],
            [30.265219940294365, 0.120515067146422],
            [30.26597172957586, 0.121807433625112],
            [30.26592885298737, 0.122756312017212],
            [30.26443571554291, 0.126289610348163],
            [30.26571202033904, 0.129271951283869],
            [30.264371017079522, 0.131793117789685],
            [30.263779504312694, 0.134684879396452],
            [30.26521139012949, 0.142376190151424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 348,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "MUHOKYA",
        Population: 19222,
        Key: "KASESEMUHOKYA",
        Dist2: "Kasese",
        "Sub Country": "Muhokya",
        id2_original: "Kasese Muhokya",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.059084119545663, 0.178346828555388],
              [30.05214238100112, 0.180719844289225],
              [30.050273387543495, 0.181794622842782],
              [30.045200216655118, 0.185870125357925],
              [30.04301959043891, 0.184697606362523],
              [30.03772534236249, 0.1838978745383],
              [30.03701349307681, 0.183449805261756],
              [30.035856930114818, 0.181613029321276],
              [30.034922539387228, 0.1815680760536],
              [30.03381002441684, 0.182418988337433],
              [30.03231945615412, 0.182351544964251],
              [30.029828188919385, 0.179663457688735],
              [30.025824579157753, 0.179771210077004],
              [30.026949519625123, 0.176561316914349],
              [30.026516069025813, 0.174623474893944],
              [30.02798459891968, 0.171218490097704],
              [30.026378070730168, 0.170426372675411],
              [30.025981387277124, 0.167098017595084],
              [30.02651577886998, 0.164096883631878],
              [30.027652224061182, 0.160886781246999],
              [30.02736329891636, 0.160219035575242],
              [30.0316568911399, 0.160188038429199],
              [30.032419443136817, 0.160572024488036],
              [30.04291336914812, 0.161084598474851],
              [30.049175792691663, 0.160725262998423],
              [30.04973148603486, 0.161446286623368],
              [30.051010643880307, 0.162062412570275],
              [30.051989290110406, 0.163809575732524],
              [30.052968107918716, 0.164392061634883],
              [30.053501869792537, 0.165646416284352],
              [30.055948767438732, 0.168065745155105],
              [30.05643798185763, 0.169633663233384],
              [30.056615134123234, 0.174964361500086],
              [30.058283515811624, 0.176330894746704],
              [30.059084119545663, 0.178346828555388],
            ],
          ],
          [
            [
              [30.099336054477003, 0.249964849206698],
              [30.097459958938725, 0.248705875850292],
              [30.096142373860378, 0.248320458201383],
              [30.08462573925428, 0.248174685456906],
              [30.080351884814167, 0.247187021284869],
              [30.05731063047745, 0.247442889636825],
              [30.056598888091333, 0.24654682217887],
              [30.053884824293107, 0.239443739127767],
              [30.052365039224053, 0.236619215907859],
              [30.050976866327314, 0.236153042751945],
              [30.048832735067815, 0.236081415292705],
              [30.042952082045296, 0.238733089890424],
              [30.03399650927996, 0.241285690561329],
              [30.028432405495536, 0.24214482985704],
              [30.01996485777967, 0.244891840607771],
              [30.016116607154856, 0.247182827988142],
              [30.010668032105887, 0.253234925161877],
              [30.008758676444202, 0.253938777937486],
              [30.00915711071376, 0.253092859783128],
              [30.00818079651016, 0.250112599104444],
              [30.0085122290359, 0.24944488320718],
              [30.00850797371642, 0.247421986933412],
              [30.007974872104324, 0.246502862629056],
              [30.008936839314508, 0.244324203945983],
              [30.008444835626655, 0.243111147028779],
              [30.008547816694215, 0.241663821343819],
              [30.010234277875984, 0.239453319576614],
              [30.010430030657886, 0.238409972277074],
              [30.011455103618477, 0.2377032324208],
              [30.011678530799294, 0.235947966299524],
              [30.012704657483745, 0.235051347421999],
              [30.012797791219153, 0.233236057833593],
              [30.013807146357223, 0.231372074329879],
              [30.016167424850458, 0.229408376587775],
              [30.017805105715716, 0.229583021152763],
              [30.01882887701747, 0.229113614753301],
              [30.019968250716506, 0.229214459718794],
              [30.023810531137944, 0.227964519644352],
              [30.02760824703644, 0.228340235236531],
              [30.0286655784989, 0.226090801384568],
              [30.02945357707286, 0.225311600667975],
              [30.02953108910548, 0.224172681295076],
              [30.03031212034609, 0.222503345701754],
              [30.032064902348708, 0.223343183287299],
              [30.032469925760832, 0.223107917198268],
              [30.03283529214647, 0.221448296691523],
              [30.033955113115013, 0.220789485253139],
              [30.035536599867672, 0.218234181502639],
              [30.036036093708354, 0.218094346267634],
              [30.036053123969495, 0.217156863114858],
              [30.036940943337864, 0.215499929688665],
              [30.03801535267217, 0.214461106342035],
              [30.040062787477833, 0.21354598097916],
              [30.039820165994335, 0.21174533925814],
              [30.04085527044171, 0.209787900141959],
              [30.042733997145458, 0.209322882260534],
              [30.043614408107654, 0.208028484098122],
              [30.044123328868917, 0.20546926429605],
              [30.043833385034553, 0.202251781622993],
              [30.042399332481292, 0.199673918278936],
              [30.045232241594974, 0.198687271326596],
              [30.047629135419236, 0.19894363998209],
              [30.0491182897337, 0.198139552019126],
              [30.05222281435503, 0.198193165849553],
              [30.054098301733845, 0.202198780453042],
              [30.053830862493964, 0.204725192716752],
              [30.051124511630793, 0.21010012189597],
              [30.048845825318153, 0.21275156045656],
              [30.04838284709545, 0.213898225019464],
              [30.06925395496203, 0.214223999478583],
              [30.083598854391752, 0.219005487357096],
              [30.088589369494194, 0.222001970967699],
              [30.09865591841583, 0.227043674685658],
              [30.10343871248187, 0.230572449070324],
              [30.108591114778278, 0.232370176183968],
              [30.106746906737662, 0.237040780889574],
              [30.102684680107092, 0.245383430164487],
              [30.099336054477003, 0.249964849206698],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 349,
        District: "KASESE",
        County: "BUSONGORA",
        Subcounty: "RUKOKI",
        Population: 13999,
        Key: "KASESERUKOKI",
        Dist2: "Kasese",
        "Sub Country": "Rukoki",
        id2_original: "Kasese Rukoki",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.008758676444202, 0.253938777937486],
            [30.0091161717913, 0.255297800558538],
            [30.007454475365275, 0.254702103050678],
            [30.006980938344718, 0.255608283082553],
            [30.006411308538215, 0.255489199101413],
            [30.0066018780409, 0.256132935299323],
            [30.006246386835198, 0.256514521440416],
            [30.00579892700902, 0.259471275561525],
            [30.00448219443188, 0.259650415757236],
            [30.003629999552743, 0.261438900775273],
            [30.002206176115624, 0.261343855515747],
            [30.002254781260714, 0.262345284241828],
            [30.00178058667338, 0.262679210579178],
            [30.00085339594276, 0.261129570021988],
            [29.993893166476393, 0.258281895807934],
            [29.99250358052969, 0.258569563978522],
            [29.99148164268944, 0.259556751180659],
            [29.991399314788584, 0.261984176955902],
            [29.992338315670242, 0.265975302689162],
            [29.99254201225418, 0.268608516406982],
            [29.99205110091773, 0.270583269119891],
            [29.99086551608384, 0.272228692968528],
            [29.988985217328345, 0.273668227774878],
            [29.984918270050954, 0.275909474378018],
            [29.981728681260474, 0.283232074307951],
            [29.977845515815503, 0.285987608072125],
            [29.973206473754484, 0.288105199879048],
            [29.971407833654936, 0.28987383351362],
            [29.97083526635746, 0.291437091300538],
            [29.96991376555589, 0.298657325032642],
            [29.96741877210933, 0.306103372890963],
            [29.965801182963755, 0.31760216190002],
            [29.96377733791744, 0.320666645088878],
            [29.960547825300754, 0.323998169770313],
            [29.958953706438574, 0.324985090724365],
            [29.956583230270226, 0.32560149305976],
            [29.952005956368158, 0.326134931895453],
            [29.950003793957844, 0.325105770254251],
            [29.947654814474234, 0.322245717469965],
            [29.946143063937118, 0.321175579426317],
            [29.944426831688475, 0.320640220660309],
            [29.94050365617908, 0.320597889113641],
            [29.93380132045437, 0.32145981448892],
            [29.932207662427942, 0.321047912863152],
            [29.93104312242622, 0.320574436265314],
            [29.927938123494446, 0.317817067053046],
            [29.92148266726768, 0.313289659025053],
            [29.917069362854413, 0.312671234772576],
            [29.912512690016776, 0.313266402888302],
            [29.904828630433816, 0.317954042754306],
            [29.900659343486, 0.321449644821671],
            [29.900825002705872, 0.314126829608802],
            [29.900431166013934, 0.312413357444077],
            [29.903504653842184, 0.311036734798583],
            [29.90820804402362, 0.308022177324543],
            [29.90893424748922, 0.308205177671523],
            [29.911186327499756, 0.305866180614206],
            [29.912965897264122, 0.305062442402688],
            [29.913184050435913, 0.304112016702388],
            [29.915290928560577, 0.301590174603991],
            [29.915255008525637, 0.300200984208241],
            [29.916453673728366, 0.299031492513359],
            [29.91661738450236, 0.297953095818848],
            [29.91843339262959, 0.296710660763886],
            [29.920757367507292, 0.296967219759102],
            [29.926823987065003, 0.288670335441988],
            [29.935414284174556, 0.280684764179814],
            [29.95875063508209, 0.262795422608983],
            [29.959404687660676, 0.26118699602659],
            [29.960439770548486, 0.26069370118564],
            [29.96120266121028, 0.259524002534635],
            [29.964798300187304, 0.257477578500524],
            [29.965488563854997, 0.256271295131071],
            [29.967558797004262, 0.255028784748132],
            [29.971100897288682, 0.249015638089448],
            [29.972081474896637, 0.248686833542272],
            [29.97422450931314, 0.246713131136575],
            [29.973934245678546, 0.245579725523758],
            [29.97418904023248, 0.242984069797064],
            [29.974733995114743, 0.241960531341335],
            [29.97589611236016, 0.241777998895295],
            [29.97665886827462, 0.241156661290702],
            [29.978314392376355, 0.238834698348143],
            [29.979141576361336, 0.237236811368484],
            [29.978794593099675, 0.235556483812716],
            [29.97902927257777, 0.234197485242369],
            [29.981348516028856, 0.231430227193839],
            [29.98549424196337, 0.228780587681737],
            [29.986288537727482, 0.228648792404881],
            [29.988774816617433, 0.226429649555874],
            [29.991359482590585, 0.22611752156464],
            [29.99190420391087, 0.225687949636399],
            [29.9932475535699, 0.224247512181902],
            [29.989663617844396, 0.222952782018975],
            [29.991022483204993, 0.220773701072459],
            [29.99284456035028, 0.218375956184923],
            [29.995857595153193, 0.2164016440812],
            [30.00382934559577, 0.209757441169755],
            [30.00586352935268, 0.20716204852412],
            [30.006271810056056, 0.204299644612961],
            [30.008143814666514, 0.201543640487779],
            [30.009287663772323, 0.200671586534692],
            [30.010119753457058, 0.198962098453267],
            [30.010692910049368, 0.198843819789154],
            [30.011957638256405, 0.194907536843954],
            [30.014146582872137, 0.190747891715917],
            [30.014074255017032, 0.188992963392789],
            [30.015763306940134, 0.186964137327703],
            [30.017434786917917, 0.181443749842115],
            [30.018162371992414, 0.180422708221675],
            [30.019479049772333, 0.179850280297242],
            [30.025824579157753, 0.179771210077004],
            [30.029828188919385, 0.179663457688735],
            [30.03231945615412, 0.182351544964251],
            [30.03381002441684, 0.182418988337433],
            [30.034922539387228, 0.1815680760536],
            [30.035856930114818, 0.181613029321276],
            [30.03701349307681, 0.183449805261756],
            [30.03772534236249, 0.1838978745383],
            [30.04301959043891, 0.184697606362523],
            [30.045200216655118, 0.185870125357925],
            [30.050273387543495, 0.181794622842782],
            [30.05214238100112, 0.180719844289225],
            [30.059084119545663, 0.178346828555388],
            [30.06242987146517, 0.184728809181754],
            [30.06475883558595, 0.188044299977159],
            [30.063913680803697, 0.193221039522069],
            [30.063930138838018, 0.194027201021075],
            [30.062256697837974, 0.194006778838481],
            [30.061204888319544, 0.193087514696985],
            [30.060680468924698, 0.193440854224083],
            [30.05775873259905, 0.193544500352228],
            [30.05551973744894, 0.194743526980798],
            [30.053855647012686, 0.195043526617525],
            [30.04941539763248, 0.191444259156011],
            [30.047852264359385, 0.191899770728185],
            [30.045938000303, 0.190180912377284],
            [30.04356537356786, 0.189765193213552],
            [30.040261500208572, 0.190270375103351],
            [30.039641578220905, 0.190718176509279],
            [30.036220280680958, 0.190985392382818],
            [30.033507035247933, 0.189891438157419],
            [30.03159292480348, 0.188148874990802],
            [30.031053215184134, 0.186959300823946],
            [30.030058264531657, 0.186503202525305],
            [30.02932740509797, 0.185526273632699],
            [30.0278109159477, 0.184901340514279],
            [30.024571066417046, 0.184564247659421],
            [30.018626837825217, 0.1858628750934],
            [30.017381823147083, 0.187707852169315],
            [30.016826534944105, 0.189366478156957],
            [30.01682443917455, 0.191918045951822],
            [30.0158402476442, 0.193835554637841],
            [30.01752731249389, 0.197997979274602],
            [30.01749172214062, 0.20015773357283],
            [30.016074719611463, 0.203046164944835],
            [30.015393283688084, 0.203885260689545],
            [30.014203803759113, 0.204413943726057],
            [30.016848887723313, 0.207519577462798],
            [30.018358347556468, 0.208618991340137],
            [30.017310240893668, 0.21082777302819],
            [30.01724824456265, 0.212349647082561],
            [30.01423850388193, 0.221185283616608],
            [30.014145609098385, 0.222862441829497],
            [30.013127064194936, 0.225098465335124],
            [30.010982257402354, 0.228250476285878],
            [30.013807146357223, 0.231372074329879],
            [30.012797791219153, 0.233236057833593],
            [30.012704657483745, 0.235051347421999],
            [30.011678530799294, 0.235947966299524],
            [30.011455103618477, 0.2377032324208],
            [30.010430030657886, 0.238409972277074],
            [30.010234277875984, 0.239453319576614],
            [30.008547816694215, 0.241663821343819],
            [30.008444835626655, 0.243111147028779],
            [30.008936839314508, 0.244324203945983],
            [30.007974872104324, 0.246502862629056],
            [30.00850797371642, 0.247421986933412],
            [30.0085122290359, 0.24944488320718],
            [30.00818079651016, 0.250112599104444],
            [30.00915711071376, 0.253092859783128],
            [30.008758676444202, 0.253938777937486],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 350,
        District: "KASESE",
        County: "KASESE MUNICIPALITY",
        Subcounty: "BULEMBIA DIVISION",
        Population: 13251,
        Key: "KASESEBULEMBIA DIVISION",
        Dist2: "Kasese",
        "Sub Country": "Bulembia Division",
        id2_original: "Kasese Bulembia Division",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.095034492400256, 0.166338875223518],
            [30.093254870533595, 0.169611221619273],
            [30.092093154835144, 0.170341935903619],
            [30.091763926775084, 0.17103379819737],
            [30.086294581778418, 0.17187103417509],
            [30.076674432670956, 0.18117858197266],
            [30.07429583124082, 0.182211532456011],
            [30.075638554774113, 0.183604726124259],
            [30.07392842118793, 0.184357030753452],
            [30.072247129810616, 0.18632345238497],
            [30.070712393181974, 0.194479584608249],
            [30.069158584421583, 0.193767401643727],
            [30.066955106861144, 0.193622335334073],
            [30.065422342034594, 0.193011217619727],
            [30.063913680803697, 0.193221039522069],
            [30.06475883558595, 0.188044299977159],
            [30.06242987146517, 0.184728809181754],
            [30.059084119545663, 0.178346828555388],
            [30.058283515811624, 0.176330894746704],
            [30.056615134123234, 0.174964361500086],
            [30.05643798185763, 0.169633663233384],
            [30.055948767438732, 0.168065745155105],
            [30.053501869792537, 0.165646416284352],
            [30.052968107918716, 0.164392061634883],
            [30.051989290110406, 0.163809575732524],
            [30.051010643880307, 0.162062412570275],
            [30.04973148603486, 0.161446286623368],
            [30.049175792691663, 0.160725262998423],
            [30.062411893481386, 0.159663050649213],
            [30.062637490093632, 0.157438466705657],
            [30.058493956048405, 0.151750660460407],
            [30.05652161950216, 0.15082369933664],
            [30.05348577467758, 0.147132147139935],
            [30.046660162248124, 0.144644490213821],
            [30.042715576292238, 0.142349341387088],
            [30.040874966902635, 0.139745596798928],
            [30.04043701843869, 0.136833143163853],
            [30.04280483828876, 0.129464186671383],
            [30.04273139921765, 0.127685742482512],
            [30.03991239692286, 0.125448263758014],
            [30.036493616462355, 0.124609451282201],
            [30.035003521611763, 0.1229765820117],
            [30.03299121093371, 0.123200650072584],
            [30.032023021093533, 0.122534971231585],
            [30.030971249304343, 0.120902160224767],
            [30.03105911262398, 0.119048842838777],
            [30.032111231162844, 0.117592772089447],
            [30.03439055977091, 0.11679873939616],
            [30.038291589113623, 0.11675503465175],
            [30.041228415339372, 0.115872810012247],
            [30.042631284674197, 0.113534215248267],
            [30.042544057361773, 0.109253859706221],
            [30.059155290370665, 0.112397062598208],
            [30.062222710079197, 0.113393238415576],
            [30.06381298594855, 0.113368651574393],
            [30.06393020621167, 0.115545775406723],
            [30.06746491066635, 0.120667108468136],
            [30.067895333943174, 0.12231899247582],
            [30.068200154776967, 0.138378410777519],
            [30.073242152328337, 0.151487236713859],
            [30.074644993815344, 0.150771207363153],
            [30.083439670228493, 0.150879542014424],
            [30.095034492400256, 0.166338875223518],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 351,
        District: "KASESE",
        County: "KASESE MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 31711,
        Key: "KASESECENTRAL DIVISION",
        Dist2: "Kasese",
        "Sub Country": "Central Division",
        id2_original: "Kasese Central Division",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.11699801094115, 0.252618692271149],
            [30.11602955879288, 0.253757835658961],
            [30.114846236815215, 0.256548143247879],
            [30.113791283193308, 0.257490321872468],
            [30.113436538487623, 0.258539645892584],
            [30.112559206950202, 0.259159862486409],
            [30.111023224358284, 0.264835625010462],
            [30.11022909298587, 0.265586973254759],
            [30.109851040591828, 0.267017829418359],
            [30.107418490837304, 0.269166194275618],
            [30.10368387889258, 0.262550385435813],
            [30.102749950797328, 0.257372373367914],
            [30.101402641364526, 0.255214730575324],
            [30.10083840594132, 0.252022982961989],
            [30.099336054477003, 0.249964849206698],
            [30.102684680107092, 0.245383430164487],
            [30.106746906737662, 0.237040780889574],
            [30.108591114778278, 0.232370176183968],
            [30.10343871248187, 0.230572449070324],
            [30.09865591841583, 0.227043674685658],
            [30.088589369494194, 0.222001970967699],
            [30.083598854391752, 0.219005487357096],
            [30.06925395496203, 0.214223999478583],
            [30.04838284709545, 0.213898225019464],
            [30.048845825318153, 0.21275156045656],
            [30.051124511630793, 0.21010012189597],
            [30.053830862493964, 0.204725192716752],
            [30.054098301733845, 0.202198780453042],
            [30.05222281435503, 0.198193165849553],
            [30.052772528511685, 0.197672690469566],
            [30.053855647012686, 0.195043526617525],
            [30.05551973744894, 0.194743526980798],
            [30.05775873259905, 0.193544500352228],
            [30.060680468924698, 0.193440854224083],
            [30.061204888319544, 0.193087514696985],
            [30.062256697837974, 0.194006778838481],
            [30.063930138838018, 0.194027201021075],
            [30.063913680803697, 0.193221039522069],
            [30.065422342034594, 0.193011217619727],
            [30.066955106861144, 0.193622335334073],
            [30.069158584421583, 0.193767401643727],
            [30.070712393181974, 0.194479584608249],
            [30.072247129810616, 0.18632345238497],
            [30.07392842118793, 0.184357030753452],
            [30.075638554774113, 0.183604726124259],
            [30.07429583124082, 0.182211532456011],
            [30.076674432670956, 0.18117858197266],
            [30.086294581778418, 0.17187103417509],
            [30.091763926775084, 0.17103379819737],
            [30.092093154835144, 0.170341935903619],
            [30.093254870533595, 0.169611221619273],
            [30.095034492400256, 0.166338875223518],
            [30.10140807976525, 0.174150725190663],
            [30.11864586792192, 0.180968324245592],
            [30.12048059873629, 0.180529499412867],
            [30.12202460328369, 0.177899930539252],
            [30.122475811779555, 0.177876095654675],
            [30.123306855825298, 0.178665171082458],
            [30.124019283626005, 0.178593566719147],
            [30.12482689242261, 0.177422224937335],
            [30.126275539005988, 0.17708775231666],
            [30.12660797584825, 0.177326880904917],
            [30.126798053074157, 0.176657499973204],
            [30.12829414417924, 0.176705547036049],
            [30.129754785068293, 0.175713617617276],
            [30.12982642750884, 0.173107705086648],
            [30.13160771125877, 0.17174523736322],
            [30.13324659227321, 0.169808965997018],
            [30.13686818717207, 0.169438948858074],
            [30.13724805416299, 0.170060612645653],
            [30.138862840564915, 0.170491201107609],
            [30.189011082891724, 0.159762293441278],
            [30.187955951403396, 0.161608558549761],
            [30.18619473601693, 0.162264250629798],
            [30.18537096024013, 0.167423304258258],
            [30.18382493358503, 0.167818946667409],
            [30.182939543261217, 0.169025112981503],
            [30.181608824813402, 0.169136998561273],
            [30.180821543993353, 0.169773918380087],
            [30.179920421473973, 0.169508179019202],
            [30.1793940168023, 0.170217652736323],
            [30.17837206728396, 0.170331113048917],
            [30.177739757528514, 0.170861998858913],
            [30.176744017256883, 0.170524553609789],
            [30.17647939243878, 0.171140415169857],
            [30.175645773821422, 0.171563445216729],
            [30.17664215549018, 0.171782201972747],
            [30.176401545334578, 0.172350696440105],
            [30.172186608699, 0.174346910053241],
            [30.171613598532083, 0.174889970561457],
            [30.17187085087664, 0.17562718841508],
            [30.17113197936891, 0.176098178289824],
            [30.17182855729473, 0.176849530121072],
            [30.171720852885432, 0.179175379336809],
            [30.17022700217865, 0.17871667753541],
            [30.16955446945804, 0.18009008617596],
            [30.167937717542294, 0.18039039598109],
            [30.165271277030527, 0.183712000587725],
            [30.164670379563923, 0.185014551904734],
            [30.161150330224793, 0.188070623168115],
            [30.160597571677645, 0.189254715769267],
            [30.15957161836807, 0.190104038571854],
            [30.159229118598017, 0.191930147987423],
            [30.15837330889819, 0.19206817874573],
            [30.15747648930901, 0.193191156335726],
            [30.1560953115934, 0.193848724762848],
            [30.15554229433142, 0.195080287262543],
            [30.15434042753304, 0.196007785205162],
            [30.154048293605985, 0.197310949138431],
            [30.153213125394764, 0.198018804793483],
            [30.15264738439513, 0.199404597803494],
            [30.150508660095365, 0.199607228655391],
            [30.149959796643262, 0.20007917368545],
            [30.149716697256043, 0.201098674436722],
            [30.15053233788963, 0.206123551605894],
            [30.149527780653482, 0.207400248737638],
            [30.14997370076724, 0.208375820799401],
            [30.14944012125142, 0.210390829137753],
            [30.148604944955363, 0.211098675233764],
            [30.14827930386824, 0.212010920762724],
            [30.148441518048976, 0.212747643828916],
            [30.14747364082252, 0.215994805375283],
            [30.146523886208605, 0.215942428576441],
            [30.146377341341342, 0.216677561446823],
            [30.144542158674366, 0.217831258574045],
            [30.144460874615902, 0.219658690733229],
            [30.1428601010341, 0.220889754460341],
            [30.140138267706984, 0.225635191988959],
            [30.138873233174433, 0.226768090785595],
            [30.137540985793994, 0.227164742380384],
            [30.1356608514302, 0.23001545677094],
            [30.134277449485943, 0.23107651753347],
            [30.132518098103645, 0.231399737723479],
            [30.131820063110435, 0.233081529121296],
            [30.130725989654565, 0.233360717808778],
            [30.129753840938942, 0.235219113575068],
            [30.128707263208742, 0.235498549254572],
            [30.12658303322604, 0.237386572716492],
            [30.126413782541707, 0.237931673826368],
            [30.125367200319918, 0.238211096874898],
            [30.123491365293102, 0.240278435595625],
            [30.121195778076707, 0.24309132767705],
            [30.12060598648195, 0.244524409651557],
            [30.118353030614006, 0.246966269542873],
            [30.11779480492006, 0.248820125206225],
            [30.117750361669696, 0.251419385595018],
            [30.11699801094115, 0.252618692271149],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 352,
        District: "KASESE",
        County: "KASESE MUNICIPALITY",
        Subcounty: "NYAMWAMBA DIVISION",
        Population: 56103,
        Key: "KASESENYAMWAMBA DIVISION",
        Dist2: "Kasese",
        "Sub Country": "Nyamwamba Division",
        id2_original: "Kasese Nyamwamba Division",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.86955022885278, 0.003675598916282],
            [29.870359754654224, 0.005247923746492],
            [29.870946058989016, 0.007833519458905],
            [29.871492137663715, 0.008142809408218],
            [29.871445775611917, 0.008667254848571],
            [29.870616679113677, 0.009121021740903],
            [29.870807613332378, 0.00971672603877],
            [29.869882981003695, 0.00983687929956],
            [29.868629003833984, 0.011268378816458],
            [29.868464598662264, 0.012055143987237],
            [29.868963051355514, 0.01226914514099],
            [29.868172413531244, 0.014141113769037],
            [29.869645064895657, 0.015283693517626],
            [29.868674312161957, 0.016047467194775],
            [29.868604229196738, 0.016571935077416],
            [29.86934187091084, 0.017786808528205],
            [29.86846543050221, 0.018288292112408],
            [29.86840951037576, 0.019944953389],
            [29.86781649562578, 0.019874073622433],
            [29.867296848081715, 0.02089956692963],
            [29.867702033190586, 0.021900255950358],
            [29.86822390855659, 0.021971220157664],
            [29.868889716489, 0.022852461994057],
            [29.86836962787209, 0.02366342772809],
            [29.86877370535824, 0.024115891131037],
            [29.868563164510157, 0.025546282016833],
            [29.868956367889805, 0.026487398333957],
            [29.86881601061825, 0.027440986851906],
            [29.86813006515214, 0.028323637209585],
            [29.868652028553022, 0.028442273203003],
            [29.868867393354193, 0.029395489802603],
            [29.868109145185805, 0.029706161322504],
            [29.867496070157213, 0.031446825702309],
            [29.866428761106892, 0.031376431032274],
            [29.86554102438356, 0.032152020159706],
            [29.865806073206457, 0.034225481506138],
            [29.865381362316544, 0.035298547661606],
            [29.864692864736686, 0.034917881241543],
            [29.864646732653608, 0.035561503359628],
            [29.865240324121984, 0.03591842820706],
            [29.865383962939273, 0.036585684090123],
            [29.865076240547122, 0.036872041791035],
            [29.865551307398604, 0.037252920205292],
            [29.864604400444154, 0.038088163694468],
            [29.864593284690834, 0.038457637095131],
            [29.86499648901451, 0.038481056169316],
            [29.864737542447358, 0.039434767641605],
            [29.863645366233357, 0.038792319649555],
            [29.86319516295231, 0.038983473013157],
            [29.862864839845916, 0.039818067901851],
            [29.86205877884651, 0.039938078303184],
            [29.86239169628746, 0.040390618889422],
            [29.86191859764475, 0.040987006662878],
            [29.86222827746591, 0.041677929514221],
            [29.86035577698542, 0.042156570634123],
            [29.860522781881574, 0.042656957263131],
            [29.86019164040996, 0.043086350950444],
            [29.858888481376727, 0.043659748126944],
            [29.858535974374416, 0.045257113917927],
            [29.854531122242726, 0.046715201325255],
            [29.853730118758417, 0.049361794426976],
            [29.85093795902263, 0.051584928957985],
            [29.850939775416133, 0.052490681919091],
            [29.84999224143761, 0.053016038932461],
            [29.84987457830506, 0.053469033981802],
            [29.850535728472682, 0.053755201173456],
            [29.85060811022671, 0.054374863272119],
            [29.849739244412536, 0.058666163601041],
            [29.848364990012822, 0.059263452218841],
            [29.847964502194536, 0.060598646241274],
            [29.846139636678597, 0.061172545416278],
            [29.844644393583113, 0.06055433596631],
            [29.844290340580194, 0.061388937766356],
            [29.844684312917725, 0.062735248381013],
            [29.84387868849955, 0.06306975384177],
            [29.843122389675326, 0.064357638922237],
            [29.841250338352477, 0.065050754298967],
            [29.841205939119572, 0.066576266918099],
            [29.840495266626924, 0.066958347098469],
            [29.840165778055432, 0.0682219542271],
            [29.839383870059095, 0.068556437193311],
            [29.839522072272317, 0.072477233688504],
            [29.836870466539153, 0.074696570073046],
            [29.836790645836263, 0.076305538486474],
            [29.835725210671622, 0.07716466579244],
            [29.83610787860962, 0.078808931582152],
            [29.835019476218125, 0.080049443610344],
            [29.834142478853988, 0.080264830658626],
            [29.83451369596705, 0.082111701248118],
            [29.83425532432167, 0.083375236073191],
            [29.83515904566716, 0.084685289165561],
            [29.83404462357347, 0.084757889130847],
            [29.833737930650624, 0.085568591728057],
            [29.83255086539315, 0.084878538131186],
            [29.831875513759183, 0.085129472348162],
            [29.830051123452034, 0.085941670630825],
            [29.828370339622854, 0.087421114260608],
            [29.828075482003868, 0.088219880001584],
            [29.82905169020627, 0.090221072499928],
            [29.82807987656223, 0.090460379800861],
            [29.82861716432357, 0.092354749152741],
            [29.828477026240936, 0.093451310398776],
            [29.82762295567949, 0.093261460698647],
            [29.826909148066544, 0.092046568120531],
            [29.82638964245625, 0.093167326364582],
            [29.825273824380602, 0.092524871879842],
            [29.82496638136452, 0.092954198649611],
            [29.825133736603608, 0.093645260003356],
            [29.82425664761134, 0.093812956377891],
            [29.823571003979154, 0.094862376751779],
            [29.821318975172584, 0.095269771155499],
            [29.821202779887226, 0.096485468510529],
            [29.820197302776222, 0.097690116560186],
            [29.82062639295316, 0.098833779829427],
            [29.82020080440921, 0.099477743363053],
            [29.820316058260147, 0.101356499520641],
            [29.81984326594299, 0.102119678236777],
            [29.820321822749353, 0.104312032893111],
            [29.81989952742923, 0.106648276595035],
            [29.82070848549541, 0.108029923501563],
            [29.819742474968084, 0.110311769538349],
            [29.813495065866196, 0.093616792430016],
            [29.812186127072437, 0.085195304412731],
            [29.813106225603907, 0.085353490372551],
            [29.814959712343107, 0.084057032391522],
            [29.819106635731913, 0.079408512445334],
            [29.8203946312031, 0.078807742213853],
            [29.822342268570626, 0.078649771823636],
            [29.82309542149471, 0.078965129597409],
            [29.8245918701293, 0.077369191335419],
            [29.82617952830795, 0.076771735855209],
            [29.826485076777093, 0.075388985510248],
            [29.82721898149961, 0.074768549320579],
            [29.827682934394392, 0.073653409510047],
            [29.82818581668033, 0.069953293083475],
            [29.830981727780724, 0.068467099802171],
            [29.83164106963973, 0.067122323661563],
            [29.831814462455842, 0.064340049021732],
            [29.83330169617224, 0.05783164709968],
            [29.832440987959174, 0.057622187929509],
            [29.83049358954355, 0.056194042503706],
            [29.829463989073925, 0.055983394857029],
            [29.827830336254426, 0.05425776882578],
            [29.82007705608892, 0.048914689599779],
            [29.819197825513033, 0.048009853768675],
            [29.81832799939983, 0.045877512714817],
            [29.81853755299941, 0.043946672639778],
            [29.81784837000499, 0.043208493946654],
            [29.81732278639351, 0.041278399404702],
            [29.81832910792088, 0.040526563602411],
            [29.81744839692138, 0.038882858131282],
            [29.818062210365124, 0.037523634645049],
            [29.818559725217234, 0.037284770865275],
            [29.818874310738178, 0.034531506925651],
            [29.81742757846468, 0.03443766713142],
            [29.817094585565282, 0.033937485270267],
            [29.816996932405672, 0.032555153452236],
            [29.81630135160983, 0.031070129820379],
            [29.81701511161207, 0.029814119940482],
            [29.816464822533643, 0.027407368304548],
            [29.815514590016008, 0.02657412976702],
            [29.815772595148765, 0.025167606229057],
            [29.814052365397103, 0.024680784069825],
            [29.81352660391919, 0.022679211125424],
            [29.81260163023071, 0.02260867451651],
            [29.81191054640117, 0.02094095860023],
            [29.813000270214463, 0.014564001963973],
            [29.813497577555744, 0.014229788264636],
            [29.812856382563808, 0.013777605110192],
            [29.81347138268205, 0.013014234768956],
            [29.813161653453548, 0.012299520773278],
            [29.813764820962888, 0.011548087240913],
            [29.813834210428684, 0.010689958107215],
            [29.81467476044678, 0.01005744983445],
            [29.814695798092405, 0.008746509611942],
            [29.81357696886392, 0.006650229830039],
            [29.812951635424973, 0.002360619852398],
            [29.813227163095647, -0.002049113756504],
            [29.814972500759488, -0.006260979040119],
            [29.81496917339967, -0.0086971912051],
            [29.815485322005742, -0.009366411828929],
            [29.81895192517873, -0.007439415970828],
            [29.86955022885278, 0.003675598916282],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 353,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "MUNKUNYU",
        Population: 33641,
        Key: "KASESEMUNKUNYU",
        Dist2: "Kasese",
        "Sub Country": "Munkunyu",
        id2_original: "Kasese Munkunyu",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.491759117039543, 1.019253724609503],
            [30.488941817950554, 1.021740168706669],
            [30.487872133754607, 1.022456762943901],
            [30.486660290266663, 1.022671035400177],
            [30.48648285862503, 1.021702354748015],
            [30.483561036061133, 1.021126094429106],
            [30.483419325926743, 1.02004982926189],
            [30.48249303351142, 1.019690379538987],
            [30.481923731589994, 1.018542031888811],
            [30.48085450014499, 1.018684677081877],
            [30.480426350504153, 1.019330029806498],
            [30.4790006909106, 1.019544133614617],
            [30.478502049571095, 1.01918502154839],
            [30.477432372561694, 1.019901608271492],
            [30.476363592969264, 1.01947030288958],
            [30.47565163498747, 1.018465335069559],
            [30.4732284789159, 1.018248187279967],
            [30.472444856933993, 1.017745366403498],
            [30.470875592659112, 1.019322468985111],
            [30.46802317123914, 1.021185516631249],
            [30.461323043573394, 1.021682376697839],
            [30.459326480362254, 1.02282865922709],
            [30.456937205149945, 1.024871399337161],
            [30.455297350361715, 1.025587505167589],
            [30.452304044359085, 1.025369873745082],
            [30.447028529749605, 1.027015688050844],
            [30.439827465548838, 1.030166481950064],
            [30.433837757949114, 1.033676919419844],
            [30.43269601359608, 1.035397766033261],
            [30.429375893306553, 1.042748460103075],
            [30.428373395907357, 1.048486876680607],
            [30.422053090316798, 1.063869896272657],
            [30.416559126091453, 1.071039241604311],
            [30.413632615220102, 1.076202005856584],
            [30.412794452924054, 1.078721410143143],
            [30.412964699840074, 1.117096206716741],
            [30.415696059800773, 1.119429742505048],
            [30.4173404753357, 1.119672963438264],
            [30.418725700859994, 1.120816789711428],
            [30.419479460146924, 1.120832758701233],
            [30.420193490542086, 1.122125190369312],
            [30.421028766551125, 1.122211219894323],
            [30.423484376058973, 1.126451618382785],
            [30.425486736996938, 1.127423760486004],
            [30.425850407363317, 1.128672499166831],
            [30.428579080463035, 1.130830628783569],
            [30.433579295573903, 1.130307203332185],
            [30.43537029909519, 1.1316359668522],
            [30.43620088769511, 1.13129669262215],
            [30.438412816605712, 1.131746836853688],
            [30.44111249298635, 1.136150221931566],
            [30.43979223631833, 1.138455851666836],
            [30.44037665329272, 1.14141561888149],
            [30.441617179987688, 1.141639329539916],
            [30.44258285724002, 1.141345947696405],
            [30.443097560456795, 1.141647924710682],
            [30.44345784327622, 1.142589508894702],
            [30.444755061750474, 1.143072592318354],
            [30.44552316084427, 1.145605142182223],
            [30.4468418149178, 1.145591751876656],
            [30.447276568074304, 1.145965433796076],
            [30.447586682680058, 1.147238369198411],
            [30.448486490065857, 1.148292636041426],
            [30.447961302611386, 1.149479532715849],
            [30.448525894665767, 1.150643543540984],
            [30.448575744875832, 1.152722587702336],
            [30.451652582521792, 1.151060795975567],
            [30.451967646844754, 1.152782684507685],
            [30.45245543923055, 1.153084938736231],
            [30.45401110121541, 1.152596519396471],
            [30.453209169771366, 1.155534947623601],
            [30.45144316726277, 1.156474486673603],
            [30.450435902504342, 1.157878953285579],
            [30.450830117386992, 1.159458244068058],
            [30.45035900132615, 1.160668224334385],
            [30.45027298134949, 1.16263048624572],
            [30.449791957769325, 1.162942569459891],
            [30.44915019773712, 1.164544192103728],
            [30.44961733965117, 1.165413814172082],
            [30.449377124754292, 1.168039310311215],
            [30.45101973467549, 1.169334196834652],
            [30.45244024063426, 1.171233925062539],
            [30.45186953195111, 1.173177475210726],
            [30.45440898481768, 1.17770077131483],
            [30.459459324124794, 1.182931221319349],
            [30.46167830930196, 1.19012814678276],
            [30.46511405264999, 1.197832682933807],
            [30.467104330349073, 1.201369084306247],
            [30.467565338566377, 1.204129314207834],
            [30.469599816072375, 1.206790917398446],
            [30.470158337312068, 1.208628540316245],
            [30.47015194939211, 1.210495500707177],
            [30.464627765840604, 1.207455626464718],
            [30.459635252884983, 1.201361946065827],
            [30.453487137266396, 1.19909644471918],
            [30.4516542632697, 1.198855039419363],
            [30.44952260601623, 1.200814356390368],
            [30.443329399461966, 1.201786780011427],
            [30.44216724987719, 1.20134953228125],
            [30.441264101656852, 1.199988067047627],
            [30.439346086235854, 1.199345781282041],
            [30.43839586629461, 1.198599196839723],
            [30.438225300476656, 1.197773837279514],
            [30.436929381864637, 1.197408841694006],
            [30.433018797142264, 1.197909181114956],
            [30.429599112078243, 1.195320723827686],
            [30.427089581195492, 1.194731691892297],
            [30.42581253798421, 1.193633946547029],
            [30.424731667966345, 1.193243148307993],
            [30.422754744622285, 1.190911881618089],
            [30.421160484724627, 1.190337232153641],
            [30.42032727034913, 1.190440175727992],
            [30.41862235507645, 1.19204066980117],
            [30.41851479978751, 1.194499342851105],
            [30.417643346825326, 1.196020509050411],
            [30.41569543547165, 1.197552549730426],
            [30.41370841147053, 1.197974340542465],
            [30.41099981841237, 1.197635425462726],
            [30.407461745275366, 1.196513268596842],
            [30.406243653106316, 1.19342999059217],
            [30.40540214458581, 1.192776839624071],
            [30.40272731740255, 1.191835015381521],
            [30.39994260739543, 1.189464663937793],
            [30.398351489804625, 1.189173547648583],
            [30.39683678381019, 1.190937484360187],
            [30.39605636881386, 1.190945375253342],
            [30.394000514099034, 1.18999729407005],
            [30.391743565219663, 1.187893384286053],
            [30.390705296905843, 1.18770301380232],
            [30.38856646929978, 1.189000642130916],
            [30.38604212609629, 1.191956254520873],
            [30.3844627108587, 1.192728363562487],
            [30.38112709912213, 1.19288018636343],
            [30.37839115505851, 1.19249427379404],
            [30.377371664229088, 1.19278812001921],
            [30.375407004685268, 1.195241819511356],
            [30.373343464883174, 1.196042420473551],
            [30.37275121909111, 1.19848226447316],
            [30.371605224808395, 1.199509901652526],
            [30.368909156960264, 1.200305053383006],
            [30.366449736799, 1.201818523082592],
            [30.36338792976437, 1.202392870170999],
            [30.360696391221907, 1.202372735275117],
            [30.356686070146758, 1.196210413733222],
            [30.355377141234506, 1.193423517838266],
            [30.354721463603564, 1.192532207718879],
            [30.351854238846023, 1.19121424848739],
            [30.35054842439281, 1.188710890938134],
            [30.347887426773358, 1.186563828075389],
            [30.34744442977753, 1.185434085642955],
            [30.347919057352822, 1.18331447408377],
            [30.341995318434318, 1.176911653869596],
            [30.3396665510446, 1.16948015613679],
            [30.339841421589377, 1.168249671785706],
            [30.34141168658749, 1.166650656721799],
            [30.341421561767422, 1.163874125268172],
            [30.339283181522376, 1.160304097765527],
            [30.339455690396285, 1.155186646391855],
            [30.33898472974397, 1.153962694224862],
            [30.337357787339617, 1.151628041193532],
            [30.336302363000534, 1.151095242109037],
            [30.333855197656337, 1.151261760638316],
            [30.331413741105795, 1.151948052546643],
            [30.327912727965856, 1.151723524493943],
            [30.327017378918818, 1.15228785693268],
            [30.32555512735047, 1.156366805997464],
            [30.323517064668156, 1.157025373131495],
            [30.321711569524687, 1.15680732460539],
            [30.320748738135162, 1.154903117557402],
            [30.319552292669496, 1.153781019856598],
            [30.31582115540828, 1.153428842964931],
            [30.314869756877375, 1.152564193774389],
            [30.314115273548353, 1.152477300251565],
            [30.313044377525127, 1.152984318158387],
            [30.31227129188318, 1.153653724747648],
            [30.312829777190252, 1.157948496532517],
            [30.3123633287756, 1.159583583684762],
            [30.309940215823186, 1.163164148062932],
            [30.308838519263777, 1.163317040351534],
            [30.308549779171894, 1.163981554182195],
            [30.308941275752495, 1.165324426039759],
            [30.309733040962456, 1.166356096418228],
            [30.309221148574203, 1.167530874262843],
            [30.308149213200196, 1.167943369515649],
            [30.307042068358594, 1.167600117296975],
            [30.30484380821336, 1.165921037230348],
            [30.30194801074157, 1.164438030472225],
            [30.300170758630617, 1.164337811761671],
            [30.298357459822302, 1.167085182308289],
            [30.296135204777503, 1.168123611356888],
            [30.294805109760475, 1.171988427588342],
            [30.29325503529672, 1.172972806435137],
            [30.290174422031622, 1.173039293881214],
            [30.289140516835143, 1.172010068865106],
            [30.28773271754605, 1.168787203471288],
            [30.28302905787005, 1.165633012538034],
            [30.280575246789393, 1.165185180938346],
            [30.276649793152426, 1.165508284816005],
            [30.274643355659695, 1.1665917547226],
            [30.274125633205244, 1.166006280477141],
            [30.273364154695088, 1.162824190501876],
            [30.26911543691326, 1.161886458801173],
            [30.268848666019956, 1.159644503033149],
            [30.269770485723498, 1.157815872095839],
            [30.268820541565027, 1.155852536273922],
            [30.26911933200834, 1.153652135051887],
            [30.26881635002594, 1.153017238339966],
            [30.266769300597527, 1.152848870656533],
            [30.26446764885463, 1.151548927277599],
            [30.26311611195012, 1.147321395510617],
            [30.261700080499754, 1.14579988404659],
            [30.26072986316199, 1.145667904804089],
            [30.258153233517376, 1.146284587165931],
            [30.257261669072644, 1.145962795073647],
            [30.256908085888604, 1.144395131266547],
            [30.25708425719391, 1.143282857745144],
            [30.25627937029258, 1.143503625963404],
            [30.255269852559472, 1.144695194032332],
            [30.253566663848744, 1.143979916628897],
            [30.25122367163652, 1.143814535614362],
            [30.25011322368962, 1.143164173501272],
            [30.247740470291994, 1.142739187857281],
            [30.24708978280247, 1.142296823204137],
            [30.24596300617866, 1.140158111795751],
            [30.2409408039029, 1.137385312336037],
            [30.237923812021172, 1.134651374489374],
            [30.23621479593924, 1.132175957356419],
            [30.236260245302727, 1.128962209798089],
            [30.23549943963073, 1.127067904276172],
            [30.234655737424287, 1.126202225983489],
            [30.234621565510896, 1.125541013948445],
            [30.23626616879372, 1.123374335482882],
            [30.236251892767214, 1.122074984174673],
            [30.23778116135069, 1.117983858109623],
            [30.240016477001426, 1.114476256824143],
            [30.23983063353544, 1.112257176838248],
            [30.240798343675237, 1.108504105129101],
            [30.24088701008875, 1.106460659751668],
            [30.25297247589902, 1.103657012875725],
            [30.259243847561123, 1.100326854613745],
            [30.25996514083535, 1.099457262415791],
            [30.259678334816286, 1.09793403841944],
            [30.262557078670707, 1.095779829402079],
            [30.26271489559815, 1.094950164094225],
            [30.26371308467724, 1.094405928395553],
            [30.264113100879978, 1.093373372036249],
            [30.2651591980115, 1.092354901938245],
            [30.268046634862934, 1.086338204227058],
            [30.27139618036788, 1.081968987202338],
            [30.272004268848317, 1.080645456550112],
            [30.274441861744844, 1.078992159280856],
            [30.275237233690653, 1.077451120792076],
            [30.28001703816342, 1.073515111960354],
            [30.286433462591074, 1.070555934481288],
            [30.289094306598617, 1.070223561038304],
            [30.291802287005762, 1.070321619295652],
            [30.29730991909811, 1.074343569734149],
            [30.299525565237374, 1.07651331687456],
            [30.303429755751573, 1.082767312274055],
            [30.3041434259223, 1.083039783711979],
            [30.30641199630652, 1.082091519808182],
            [30.307396868759827, 1.08251184827398],
            [30.30760477574753, 1.083585583353809],
            [30.30719273469638, 1.083998588060471],
            [30.304722195188504, 1.084410981965813],
            [30.304432434610447, 1.084801227330558],
            [30.304789246339617, 1.086045584799527],
            [30.30603937602499, 1.086075925336543],
            [30.30883871060493, 1.084369178267406],
            [30.30967681091724, 1.084812520722423],
            [30.310201345296484, 1.085710907486198],
            [30.31128423742202, 1.086130243887623],
            [30.312836271111436, 1.085759451811805],
            [30.314047420201693, 1.084477644780554],
            [30.315458360899303, 1.085754335926642],
            [30.318734202330162, 1.085032506539227],
            [30.318362578280254, 1.086886753420346],
            [30.31855642663374, 1.088907390104829],
            [30.32009990117512, 1.088870195790199],
            [30.32246295815758, 1.087598204201748],
            [30.322887339365757, 1.089412091904596],
            [30.32409275630617, 1.089830190137179],
            [30.325141859200645, 1.091626974779197],
            [30.327373344434992, 1.091754939915892],
            [30.328446925522613, 1.094659615742724],
            [30.330381085465913, 1.09227307669473],
            [30.331238002788464, 1.092199819819793],
            [30.333132865031335, 1.092912161210887],
            [30.33236323341166, 1.094232539361717],
            [30.33254782372783, 1.095414117559787],
            [30.33531479919462, 1.097430162554586],
            [30.337638387796705, 1.097019255974484],
            [30.33841008913479, 1.099216953419183],
            [30.338847122215462, 1.098846718015152],
            [30.33909363160753, 1.096757025617552],
            [30.339762832476744, 1.097438788392056],
            [30.340078251634257, 1.09937215193387],
            [30.340790526721356, 1.099515542464025],
            [30.3498634194628, 1.094691350123827],
            [30.351574378600713, 1.094118987865916],
            [30.357706880601345, 1.090298503128208],
            [30.35913339449274, 1.089008508665124],
            [30.353100278501874, 1.087855386837784],
            [30.351722998576278, 1.087184628761098],
            [30.346782078562352, 1.086749833484541],
            [30.342839983634722, 1.08512032805657],
            [30.338970740280036, 1.081697506333431],
            [30.3376417016818, 1.080213799388822],
            [30.336598151274114, 1.078252112778261],
            [30.335889137071508, 1.074043021115718],
            [30.33696580746541, 1.066703750106396],
            [30.33821187047746, 1.064933013564163],
            [30.34016540438649, 1.06400215488421],
            [30.341706853226913, 1.061593181786969],
            [30.342278984841503, 1.059269445958504],
            [30.34537451103861, 1.056330959247755],
            [30.348597135373687, 1.054784241101139],
            [30.352220659853778, 1.05111446500916],
            [30.35427441520579, 1.049652803152163],
            [30.357400633242897, 1.048347104259284],
            [30.365391723515245, 1.037871659128078],
            [30.37858589543908, 1.026404700001851],
            [30.39997918409885, 1.010998467240357],
            [30.412456869633523, 1.004193268636745],
            [30.423865807915124, 0.997028339575048],
            [30.445967441532655, 0.987360621870512],
            [30.461581919173643, 0.978445282430518],
            [30.475359661858864, 0.997636594609701],
            [30.480107231185993, 1.002901456772477],
            [30.488179489634142, 1.01008211259986],
            [30.491759117039543, 1.019253724609503],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 354,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "BUTUNGAMA",
        Population: 9988,
        Key: "NTOROKOBUTUNGAMA",
        Dist2: "Ntoroko",
        "Sub Country": "Butungama",
        id2_original: "Ntoroko Butungama",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.26244738449304, 1.038364864643582],
            [30.260714538801572, 1.038034035307217],
            [30.257663417227253, 1.040746825322168],
            [30.255354697539726, 1.041242862308956],
            [30.25371028469976, 1.040976064500131],
            [30.253139501456413, 1.040462072211521],
            [30.253771148255204, 1.039179759579415],
            [30.25244281663107, 1.038295434478073],
            [30.2496918572275, 1.04016636143469],
            [30.246983219253586, 1.039780446784795],
            [30.24495664153219, 1.039021357850707],
            [30.243350376549067, 1.039770147499619],
            [30.24203145837082, 1.039736309043841],
            [30.23755855433172, 1.037974326903586],
            [30.23574750670147, 1.036840141859674],
            [30.233643373828333, 1.036761915001132],
            [30.22762311272917, 1.039805217342448],
            [30.225495380215218, 1.039680026282821],
            [30.22284532138096, 1.038501995098976],
            [30.22172914577584, 1.037331999385738],
            [30.221121558555314, 1.035920570177768],
            [30.222113941822723, 1.033193384661065],
            [30.22305485072605, 1.033112932947343],
            [30.22368543032625, 1.03416973219033],
            [30.224139673331145, 1.036315156215976],
            [30.22514588526404, 1.037273630137443],
            [30.227042600731327, 1.037242523882266],
            [30.227405957585656, 1.036033859756405],
            [30.22634020351911, 1.032122620353409],
            [30.22728738535804, 1.028958786054622],
            [30.22721945745122, 1.027683615520542],
            [30.226294747867414, 1.026795204134326],
            [30.22575820391115, 1.026942428734485],
            [30.224590041902196, 1.028371926832256],
            [30.223515649635864, 1.028548252983646],
            [30.22294018796654, 1.027609034112074],
            [30.224801874527675, 1.02441226746706],
            [30.224601253775266, 1.023303842556094],
            [30.22279936626598, 1.020959499570034],
            [30.222144743257203, 1.018946067957624],
            [30.220198128172477, 1.015681755387201],
            [30.220619457803686, 1.014850528344589],
            [30.221104014457833, 1.014869215760541],
            [30.223657949963407, 1.017087751493643],
            [30.22499956677224, 1.016743315314454],
            [30.225227856533717, 1.015488762009072],
            [30.224792386521628, 1.013827495896153],
            [30.22753617018272, 1.011318705390581],
            [30.22756514893549, 1.010290633062201],
            [30.226719574639993, 1.009259669180269],
            [30.22376099481133, 1.006950762550289],
            [30.223156518456655, 1.005822830437586],
            [30.223169786573383, 1.003377313064479],
            [30.22507168531989, 1.002601857920201],
            [30.22941286399897, 1.003408152888379],
            [30.231208719321113, 1.002775530464194],
            [30.231628997923416, 1.001849791146393],
            [30.231349731464526, 1.000931180407553],
            [30.230481427097434, 1.000278479625408],
            [30.224764412085353, 0.999155459148617],
            [30.223898641865677, 0.993687116355406],
            [30.22488807865894, 0.992452889902797],
            [30.227922890420956, 0.990740086146336],
            [30.227889208089387, 0.990259753289829],
            [30.225812893345637, 0.986964486802236],
            [30.225029302804764, 0.986586444667306],
            [30.22421108670127, 0.98686021505469],
            [30.222947277470766, 0.990152652375171],
            [30.22192439280621, 0.99063208886253],
            [30.221174830448287, 0.990322688840204],
            [30.220289882993907, 0.988881034208056],
            [30.22017382425247, 0.985004217460833],
            [30.219492513194886, 0.984591957039097],
            [30.218810661351558, 0.984831531983275],
            [30.217206462493582, 0.987609059873761],
            [30.215468049942267, 0.98784773911354],
            [30.21475271788825, 0.987366833696535],
            [30.21458319321773, 0.986303171489835],
            [30.21547031100183, 0.985137479005108],
            [30.215642009595356, 0.98359380381628],
            [30.211792147392913, 0.981840898793813],
            [30.210668056731794, 0.981085198640414],
            [30.210293749414156, 0.980364437665808],
            [30.210448344084675, 0.978889368072223],
            [30.214300505075922, 0.97786339098627],
            [30.215596629402146, 0.976663727109888],
            [30.215495429693803, 0.975394279211581],
            [30.214575827032398, 0.974638755447015],
            [30.20653297583339, 0.973945888934241],
            [30.20530567952591, 0.97435654291375],
            [30.202985935713233, 0.976961910071759],
            [30.20220179181015, 0.977270011659918],
            [30.20114581860041, 0.976582989279285],
            [30.20195015573275, 0.972466859117274],
            [30.20205658722929, 0.967389553243934],
            [30.200184475719304, 0.964471927253069],
            [30.197935637728623, 0.963783925044013],
            [30.197730837115223, 0.964161127239989],
            [30.19892254576439, 0.96556869009062],
            [30.19902417127416, 0.966323521582234],
            [30.198580317285533, 0.967283736006699],
            [30.196943655109816, 0.968174341563044],
            [30.195272145487635, 0.969991191118192],
            [30.194044606635043, 0.970710599849773],
            [30.19172699182955, 0.970777268630136],
            [30.19114811476553, 0.970159267865775],
            [30.191148824434602, 0.969301608320802],
            [30.194184784243543, 0.96604503403743],
            [30.19461190531337, 0.964707436633436],
            [30.194408119796222, 0.963849605055261],
            [30.193556613924926, 0.963197073076814],
            [30.18789884460248, 0.963466811602721],
            [30.18663802766017, 0.963225616604326],
            [30.18568436806971, 0.962470083838613],
            [30.18527618079114, 0.961509169265296],
            [30.185856213986963, 0.960720608811855],
            [30.19032085981364, 0.960758627355768],
            [30.19107110309453, 0.960210347601026],
            [30.191992821288427, 0.958358564926342],
            [30.191960701127147, 0.955957088860052],
            [30.191415759719607, 0.955510655940745],
            [30.18698303822148, 0.958114268118323],
            [30.18568845001439, 0.957495682130167],
            [30.185826177917107, 0.955780484891705],
            [30.189493088330483, 0.951906899624418],
            [30.189766519333265, 0.9509465470552],
            [30.188541480492127, 0.948612709569587],
            [30.187689584751983, 0.948440477624675],
            [30.186257669290782, 0.949056815268457],
            [30.18410784181409, 0.952382747874539],
            [30.18311884250035, 0.953170973423132],
            [30.181959799289864, 0.953513076386638],
            [30.180903534127633, 0.953203448416065],
            [30.180052931961516, 0.951453135141349],
            [30.180394637620864, 0.950355623184816],
            [30.182782883363867, 0.947201424840891],
            [30.183209926280277, 0.945932447420877],
            [30.183347333484438, 0.944594619435397],
            [30.182529911491642, 0.943942133206364],
            [30.18130301852776, 0.943906822529986],
            [30.177245260117417, 0.946510752438896],
            [30.175745556886575, 0.946681048874579],
            [30.174587472178462, 0.945856753114891],
            [30.174417902592193, 0.944827436495992],
            [30.177315145453278, 0.944383838632757],
            [30.177452302925772, 0.943354771275383],
            [30.175136184713583, 0.9416375757245],
            [30.174694102202704, 0.940436506948221],
            [30.17595708588147, 0.937967511018495],
            [30.174406820076538, 0.937451657881204],
            [30.17396432164566, 0.936765179016684],
            [30.173931811615535, 0.934809716755],
            [30.17284334364702, 0.932167280531269],
            [30.17322075374564, 0.929011445416317],
            [30.17116078654343, 0.926608373675574],
            [30.170855289278258, 0.92506436591208],
            [30.171128696924885, 0.924104023940408],
            [30.171640178783033, 0.923761376486243],
            [30.17637788640496, 0.923147675998689],
            [30.177093881415637, 0.922770884323997],
            [30.17716250461851, 0.922187737698627],
            [30.176345379069758, 0.921157903974045],
            [30.174471020873263, 0.921053484723953],
            [30.171641430136223, 0.922183309577928],
            [30.170073803490084, 0.922079132871606],
            [30.16891631616167, 0.920500139173944],
            [30.16913887018005, 0.919196698977613],
            [30.172650630764064, 0.917346993675793],
            [30.173435456488445, 0.916112608676164],
            [30.173709826230727, 0.913917250696998],
            [30.173132714356232, 0.91103509855672],
            [30.172485747688615, 0.910314162257714],
            [30.17153125086829, 0.910622157474721],
            [30.170642306809224, 0.914257868263225],
            [30.169483489075883, 0.914359862569285],
            [30.168563720226118, 0.913844543121095],
            [30.16825807473892, 0.912472071033444],
            [30.168838329818588, 0.911340443119046],
            [30.17011728733975, 0.91014075629166],
            [30.170663674136588, 0.908734651404166],
            [30.17066479792899, 0.907293808879924],
            [30.16998383182449, 0.90646993150019],
            [30.168518641866868, 0.906125716793794],
            [30.167495963814808, 0.906467966232352],
            [30.16623284628707, 0.909211421644375],
            [30.165175711555644, 0.91003391786274],
            [30.16405068485002, 0.910513302596892],
            [30.162278672612132, 0.910306060476484],
            [30.161904786604367, 0.909036458142674],
            [30.1647016454274, 0.906122700628299],
            [30.165179866263852, 0.904716547472402],
            [30.16342817571434, 0.900289743541478],
            [30.16261078426425, 0.899602989873409],
            [30.161622194582286, 0.899945268668636],
            [30.159745709175194, 0.902619619414735],
            [30.159200935752615, 0.90196738506308],
            [30.159508722823457, 0.900595409668156],
            [30.158862693997005, 0.898673796240734],
            [30.155862563493166, 0.900077956820471],
            [30.15497709860919, 0.899288235629078],
            [30.155080350967935, 0.897984714121444],
            [30.154603844117045, 0.89719531762778],
            [30.153752166667537, 0.896782983955203],
            [30.151519565725593, 0.897261502771922],
            [30.148963638655054, 0.897190880494341],
            [30.14913486203978, 0.896127555440261],
            [30.150089467556217, 0.895648033179792],
            [30.153088540742974, 0.89558177794644],
            [30.153702508696952, 0.894896153337076],
            [30.153771703228344, 0.893558301729354],
            [30.15244423219027, 0.891430336029888],
            [30.152513053920835, 0.890572758844096],
            [30.15559959516847, 0.887556295441959],
            [30.15628200666223, 0.886493359223056],
            [30.156282558227815, 0.885772946227834],
            [30.157038113247015, 0.885579684210218],
            [30.171497863184136, 0.887671534564785],
            [30.17666101382294, 0.887709827843914],
            [30.183205129276647, 0.886857216882315],
            [30.186137235753918, 0.885315689197612],
            [30.19706662009917, 0.876301865006366],
            [30.20021284182105, 0.878372866840537],
            [30.20121524310049, 0.879678234803263],
            [30.202536586730027, 0.882818117585891],
            [30.208137405558382, 0.888990944525205],
            [30.209110860424456, 0.889493781515522],
            [30.21067719708983, 0.891216443400559],
            [30.214904390339147, 0.892128229887207],
            [30.241673669274608, 0.891789959057251],
            [30.245972863392275, 0.892889193855997],
            [30.24375345600694, 0.894766886262982],
            [30.240948044324075, 0.898207775231853],
            [30.239950213672802, 0.898493931625799],
            [30.236427854765058, 0.907672592597485],
            [30.233813342266618, 0.909918087530426],
            [30.232815291528084, 0.910491146651628],
            [30.22982212925589, 0.910919197298603],
            [30.222839583841232, 0.910005205938237],
            [30.219846337127446, 0.910576702174437],
            [30.220104162597117, 0.921947279956837],
            [30.22051235436728, 0.923839404788305],
            [30.22165585313012, 0.925220673952646],
            [30.22229690079833, 0.92825184984162],
            [30.221224160533794, 0.930094204012766],
            [30.22136586437997, 0.931127205775038],
            [30.22230583454383, 0.931931312653066],
            [30.224414998880878, 0.932019067344131],
            [30.224984723908804, 0.93244989262731],
            [30.22498395674755, 0.933425401066623],
            [30.222646110085233, 0.934169511527638],
            [30.219682376621787, 0.933421169664914],
            [30.217773691103307, 0.932128537727627],
            [30.21617738843669, 0.932299410608093],
            [30.21586326734478, 0.933045130874869],
            [30.216147141262756, 0.934508610098931],
            [30.218767922205284, 0.936404332660361],
            [30.220149106209103, 0.93794042595075],
            [30.22014792402619, 0.939432374102069],
            [30.219605795243794, 0.940149221292529],
            [30.218750588313558, 0.94029198928208],
            [30.21781037470625, 0.939803481119449],
            [30.215732111516655, 0.936703155941434],
            [30.21462020021419, 0.93707524946658],
            [30.214181271688243, 0.93799877269231],
            [30.214959684339817, 0.940288935421404],
            [30.216896770994328, 0.941696367010303],
            [30.218975301881855, 0.944452407603859],
            [30.222865264878585, 0.945359328472878],
            [30.223406345327035, 0.945962286285767],
            [30.222522080592285, 0.946793620257883],
            [30.220041682972496, 0.947566277813796],
            [30.214740287001344, 0.947332446877652],
            [30.213970474820314, 0.947618732251754],
            [30.213598600140486, 0.94928251834879],
            [30.217514440007275, 0.953431589813497],
            [30.217456230973493, 0.954923488187902],
            [30.215916620086123, 0.955467362266505],
            [30.21568796830359, 0.956241836714807],
            [30.216086525642343, 0.956844680352711],
            [30.218650884300143, 0.957994432546327],
            [30.22095962554727, 0.958025015906097],
            [30.221386873279517, 0.958398353828221],
            [30.221342410266214, 0.960507131733855],
            [30.222454249703482, 0.960249822115176],
            [30.22319645126596, 0.958873244607485],
            [30.223994962823685, 0.95835745296757],
            [30.224593464483437, 0.95844401688966],
            [30.22479203707699, 0.959620529198379],
            [30.22330834990934, 0.961484253508006],
            [30.223136632451205, 0.962344853898725],
            [30.22396073521475, 0.96541551315244],
            [30.223788451817978, 0.96696470705817],
            [30.224044795965767, 0.967194450801558],
            [30.224928871156006, 0.966621352469126],
            [30.226796070678024, 0.966350323497883],
            [30.22807788753671, 0.967384275495683],
            [30.23015853216014, 0.967529449497043],
            [30.229643572025193, 0.969853041041428],
            [30.231553409183853, 0.969739852463545],
            [30.233603682665816, 0.972180336007743],
            [30.235338011475857, 0.972203972669718],
            [30.234769348256595, 0.972500520429935],
            [30.237994988236096, 0.975280198921641],
            [30.238705920341836, 0.977313120928414],
            [30.23680350326744, 0.979941615825281],
            [30.23639479676261, 0.981756527935998],
            [30.240056196910025, 0.980156445239904],
            [30.253274978181043, 0.977251308761624],
            [30.25363892702515, 0.973715925593954],
            [30.25189805937817, 0.969768460605463],
            [30.249572313022764, 0.967184268052154],
            [30.249003892348618, 0.965127541567828],
            [30.255486992431603, 0.96032565712053],
            [30.260083471416152, 0.955001118793887],
            [30.260441197630268, 0.953208138769311],
            [30.262124582980544, 0.951143641714463],
            [30.2668864723516, 0.949024212693248],
            [30.270835083658277, 0.948066162287913],
            [30.27530972953071, 0.946050847201777],
            [30.279497982609108, 0.942126380932435],
            [30.286248044028213, 0.937014794645579],
            [30.287388564875876, 0.936585292963945],
            [30.289611500843677, 0.933771352945111],
            [30.305259377846948, 0.928377210351518],
            [30.32593254463563, 0.919306677239739],
            [30.332825472320884, 0.913812197105624],
            [30.338768203421125, 0.90831693521495],
            [30.346482193971042, 0.899503721202415],
            [30.35227739205724, 0.890741466323335],
            [30.359973733406754, 0.88062115605959],
            [30.361595638058947, 0.876184834500312],
            [30.36294675814521, 0.877164635344981],
            [30.363379237665693, 0.880851638325035],
            [30.366031861190063, 0.884004241442978],
            [30.3744106867969, 0.890372582681321],
            [30.377376004888532, 0.891234898851791],
            [30.380808039092777, 0.88993830325139],
            [30.38351001965211, 0.892064969210512],
            [30.38906534330293, 0.892823136178251],
            [30.39888362842273, 0.895876111808381],
            [30.400187401903604, 0.89680817142677],
            [30.40246120317773, 0.899483230461222],
            [30.415267059455385, 0.90399499105181],
            [30.411459561801728, 0.908778797148734],
            [30.40076210000493, 0.91881449702794],
            [30.397906940519974, 0.924910198271],
            [30.390060882351943, 0.933871676046395],
            [30.381857087189996, 0.944626199908398],
            [30.367241908047447, 0.951788752435746],
            [30.33658925525786, 0.962525268542255],
            [30.32910390840563, 0.965747422257805],
            [30.30783249597711, 0.973727576857085],
            [30.304148028889824, 0.979399441441195],
            [30.301584002608656, 0.97979002842687],
            [30.300228264283543, 0.981315402189215],
            [30.298035853069116, 0.986001168493409],
            [30.294776510995113, 0.990089111447454],
            [30.28886205167349, 1.006463616697886],
            [30.28749383574907, 1.009265714802372],
            [30.28582277618283, 1.010239725364928],
            [30.284525044770568, 1.012119597474754],
            [30.281560996896733, 1.020489936659644],
            [30.28034549097739, 1.023398704788461],
            [30.279254105280835, 1.02491125120974],
            [30.271449356141133, 1.030750828660865],
            [30.265196735013948, 1.036623528831074],
            [30.26244738449304, 1.038364864643582],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 355,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "BWERAMULE",
        Population: 6262,
        Key: "NTOROKOBWERAMULE",
        Dist2: "Ntoroko",
        "Sub Country": "Bweramule",
        id2_original: "Ntoroko Bweramule",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.550470387217178, 1.206360111760132],
            [30.550234523759546, 1.306819955956562],
            [30.520881885001376, 1.273269640173986],
            [30.509592987692873, 1.250174962114363],
            [30.501026827416666, 1.239783393222902],
            [30.500604390162742, 1.239686668211893],
            [30.489005142889877, 1.225140191104689],
            [30.47621322217723, 1.209826130269853],
            [30.472976276899892, 1.211631250168005],
            [30.470493306505116, 1.211018296878677],
            [30.47015194939211, 1.210495500707177],
            [30.470158337312068, 1.208628540316245],
            [30.469599816072375, 1.206790917398446],
            [30.467565338566377, 1.204129314207834],
            [30.467104330349073, 1.201369084306247],
            [30.46511405264999, 1.197832682933807],
            [30.46167830930196, 1.19012814678276],
            [30.459459324124794, 1.182931221319349],
            [30.45440898481768, 1.17770077131483],
            [30.45186953195111, 1.173177475210726],
            [30.45244024063426, 1.171233925062539],
            [30.45101973467549, 1.169334196834652],
            [30.449377124754292, 1.168039310311215],
            [30.44961733965117, 1.165413814172082],
            [30.44915019773712, 1.164544192103728],
            [30.449791957769325, 1.162942569459891],
            [30.45027298134949, 1.16263048624572],
            [30.45035900132615, 1.160668224334385],
            [30.450830117386992, 1.159458244068058],
            [30.450435902504342, 1.157878953285579],
            [30.45144316726277, 1.156474486673603],
            [30.453209169771366, 1.155534947623601],
            [30.45401110121541, 1.152596519396471],
            [30.45245543923055, 1.153084938736231],
            [30.451967646844754, 1.152782684507685],
            [30.451652582521792, 1.151060795975567],
            [30.448575744875832, 1.152722587702336],
            [30.448525894665767, 1.150643543540984],
            [30.447961302611386, 1.149479532715849],
            [30.448486490065857, 1.148292636041426],
            [30.447586682680058, 1.147238369198411],
            [30.447276568074304, 1.145965433796076],
            [30.4468418149178, 1.145591751876656],
            [30.44552316084427, 1.145605142182223],
            [30.444755061750474, 1.143072592318354],
            [30.44345784327622, 1.142589508894702],
            [30.443097560456795, 1.141647924710682],
            [30.44258285724002, 1.141345947696405],
            [30.441617179987688, 1.141639329539916],
            [30.44037665329272, 1.14141561888149],
            [30.43979223631833, 1.138455851666836],
            [30.44111249298635, 1.136150221931566],
            [30.438412816605712, 1.131746836853688],
            [30.43620088769511, 1.13129669262215],
            [30.43537029909519, 1.1316359668522],
            [30.433579295573903, 1.130307203332185],
            [30.428579080463035, 1.130830628783569],
            [30.425850407363317, 1.128672499166831],
            [30.425486736996938, 1.127423760486004],
            [30.423484376058973, 1.126451618382785],
            [30.421028766551125, 1.122211219894323],
            [30.420193490542086, 1.122125190369312],
            [30.419479460146924, 1.120832758701233],
            [30.418725700859994, 1.120816789711428],
            [30.4173404753357, 1.119672963438264],
            [30.415696059800773, 1.119429742505048],
            [30.412964699840074, 1.117096206716741],
            [30.412794452924054, 1.078721410143143],
            [30.413632615220102, 1.076202005856584],
            [30.416559126091453, 1.071039241604311],
            [30.422053090316798, 1.063869896272657],
            [30.428373395907357, 1.048486876680607],
            [30.429375893306553, 1.042748460103075],
            [30.43269601359608, 1.035397766033261],
            [30.433837757949114, 1.033676919419844],
            [30.439827465548838, 1.030166481950064],
            [30.447028529749605, 1.027015688050844],
            [30.452304044359085, 1.025369873745082],
            [30.455297350361715, 1.025587505167589],
            [30.456937205149945, 1.024871399337161],
            [30.459326480362254, 1.02282865922709],
            [30.461323043573394, 1.021682376697839],
            [30.46802317123914, 1.021185516631249],
            [30.470875592659112, 1.019322468985111],
            [30.472444856933993, 1.017745366403498],
            [30.4732284789159, 1.018248187279967],
            [30.47565163498747, 1.018465335069559],
            [30.476363592969264, 1.01947030288958],
            [30.477432372561694, 1.019901608271492],
            [30.478502049571095, 1.01918502154839],
            [30.4790006909106, 1.019544133614617],
            [30.480426350504153, 1.019330029806498],
            [30.48085450014499, 1.018684677081877],
            [30.481923731589994, 1.018542031888811],
            [30.48249303351142, 1.019690379538987],
            [30.483419325926743, 1.02004982926189],
            [30.483561036061133, 1.021126094429106],
            [30.48648285862503, 1.021702354748015],
            [30.486660290266663, 1.022671035400177],
            [30.487872133754607, 1.022456762943901],
            [30.488941817950554, 1.021740168706669],
            [30.491759117039543, 1.019253724609503],
            [30.4921656792658, 1.019509497366476],
            [30.49299571180851, 1.019122861677473],
            [30.494022820351557, 1.019514057391179],
            [30.495040702298308, 1.019078226062595],
            [30.496563542537626, 1.020480522012317],
            [30.49886180403861, 1.021425839768789],
            [30.499657778754003, 1.022811962206796],
            [30.49960523000483, 1.025341150222427],
            [30.502564089209557, 1.027744785441367],
            [30.502561096023022, 1.02849458010787],
            [30.503602364709884, 1.029472518839972],
            [30.503896187469643, 1.030673103729303],
            [30.50552825386434, 1.033264943599387],
            [30.550796742464964, 1.084469761679589],
            [30.550470387217178, 1.206360111760132],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 356,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "KANARA",
        Population: 7962,
        Key: "NTOROKOKANARA",
        Dist2: "Ntoroko",
        "Sub Country": "Kanara",
        id2_original: "Ntoroko Kanara",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.543512547269465, 0.975887031613996],
            [30.54380566215678, 0.976687506551792],
            [30.545895562122567, 0.976598257522625],
            [30.546160241737894, 0.976975094524914],
            [30.546261986723582, 0.977732489581016],
            [30.54577193956644, 0.978731998116213],
            [30.546722393069626, 0.978747426226601],
            [30.546989383151853, 0.979384912416036],
            [30.545926757019142, 0.981455711926607],
            [30.54697413155497, 0.981683581969332],
            [30.54805407540976, 0.982906405495959],
            [30.552454003908448, 0.983436885867611],
            [30.553081328912363, 0.984521464071249],
            [30.55278678750039, 0.986135373987308],
            [30.549708443379696, 0.988626536268922],
            [30.544050678548842, 0.990926803597683],
            [30.542350529737057, 0.992102674927199],
            [30.53912141956564, 0.996348602816164],
            [30.538295988193756, 1.009212018252778],
            [30.540293834199115, 1.013717047356729],
            [30.542338035968097, 1.02064041024021],
            [30.544121740677696, 1.022670384225356],
            [30.544370648571583, 1.025782921205929],
            [30.54709420307081, 1.030833831236831],
            [30.549958814629193, 1.033279543339915],
            [30.551007952557924, 1.036975659271144],
            [30.550796742464964, 1.084469761679589],
            [30.50552825386434, 1.033264943599387],
            [30.503896187469643, 1.030673103729303],
            [30.503602364709884, 1.029472518839972],
            [30.502561096023022, 1.02849458010787],
            [30.502564089209557, 1.027744785441367],
            [30.49960523000483, 1.025341150222427],
            [30.499657778754003, 1.022811962206796],
            [30.49886180403861, 1.021425839768789],
            [30.496563542537626, 1.020480522012317],
            [30.495040702298308, 1.019078226062595],
            [30.494022820351557, 1.019514057391179],
            [30.49299571180851, 1.019122861677473],
            [30.4921656792658, 1.019509497366476],
            [30.491759117039543, 1.019253724609503],
            [30.488179489634142, 1.01008211259986],
            [30.480107231185993, 1.002901456772477],
            [30.475359661858864, 0.997636594609701],
            [30.461581919173643, 0.978445282430518],
            [30.492313957881525, 0.961927091097282],
            [30.50728885749812, 0.951893878544998],
            [30.51086227934157, 0.94830207608233],
            [30.519244726955634, 0.9543810906487],
            [30.52771264208245, 0.962233677911375],
            [30.52962255559793, 0.964622207577507],
            [30.530015685315718, 0.966087935069669],
            [30.530990926032548, 0.966221643762351],
            [30.532305685011032, 0.967134353089077],
            [30.535900372672167, 0.967956151266623],
            [30.537537215409262, 0.970358910469975],
            [30.538679381970503, 0.97056225448858],
            [30.540112935958785, 0.971473927935476],
            [30.54172097691124, 0.973308253512818],
            [30.542809327200438, 0.975478844237415],
            [30.543512547269465, 0.975887031613996],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 357,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "KANARA TOWN COUNCIL",
        Population: 7988,
        Key: "NTOROKOKANARA TOWN COUNCIL",
        Dist2: "Ntoroko",
        "Sub Country": "Kanara TC",
        id2_original: "Ntoroko Kanara TC",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.34124054225451, 0.837806377672065],
            [30.333935109089072, 0.841578452078031],
            [30.322494464769512, 0.844752099744741],
            [30.313009513010613, 0.849290543862309],
            [30.29314000602459, 0.853670018257628],
            [30.2872691545201, 0.855483823167712],
            [30.28335612188857, 0.855481025227527],
            [30.27634127036136, 0.856395038080407],
            [30.269574255037874, 0.85816497380279],
            [30.257279535665315, 0.860402901581524],
            [30.25804212539148, 0.862671858628125],
            [30.25908608273598, 0.864298515676536],
            [30.26046292518206, 0.865447211466628],
            [30.260890546613506, 0.865351882343773],
            [30.26245669014107, 0.867504952675986],
            [30.2622171561672, 0.870278370818702],
            [30.26297412962621, 0.874582781867673],
            [30.262090641934144, 0.880918357298361],
            [30.262586277510696, 0.885246489452538],
            [30.26438865819509, 0.889121307614848],
            [30.258325629203547, 0.890200545532352],
            [30.257326795134077, 0.891825687914198],
            [30.255331471598037, 0.891919826237961],
            [30.25485712250048, 0.890963062898919],
            [30.254334664127857, 0.8908192088096],
            [30.2525763763509, 0.891583006890605],
            [30.251007757066393, 0.892825147261961],
            [30.25040330047466, 0.894065046189901],
            [30.245972863392275, 0.892889193855997],
            [30.241673669274608, 0.891789959057251],
            [30.214904390339147, 0.892128229887207],
            [30.21067719708983, 0.891216443400559],
            [30.209110860424456, 0.889493781515522],
            [30.208137405558382, 0.888990944525205],
            [30.202536586730027, 0.882818117585891],
            [30.20121524310049, 0.879678234803263],
            [30.20021284182105, 0.878372866840537],
            [30.19706662009917, 0.876301865006366],
            [30.196985031511826, 0.875118802497352],
            [30.196225403531166, 0.874544413902104],
            [30.195182181008555, 0.872057098050759],
            [30.198515718535123, 0.869420363015206],
            [30.199016240048522, 0.867071663112281],
            [30.200347569350733, 0.865399025043852],
            [30.200871793811178, 0.863104148084551],
            [30.202060537121593, 0.861527033300619],
            [30.201634964747324, 0.858848903023358],
            [30.20315758130613, 0.855407119185741],
            [30.20215001740874, 0.85112931316079],
            [30.200471307789517, 0.849873488186583],
            [30.198905739183733, 0.84705107725736],
            [30.200950679367857, 0.843848757658696],
            [30.20365901550785, 0.842942180879573],
            [30.205620235402453, 0.842793567104649],
            [30.206334072659804, 0.838919834345913],
            [30.205449694737318, 0.838067329217609],
            [30.205987095686385, 0.836197276840958],
            [30.204901694566225, 0.834727473099456],
            [30.204153641377992, 0.83229115401863],
            [30.202042429780434, 0.829750942488695],
            [30.201414521769866, 0.826079674078164],
            [30.198555407901022, 0.820863028605191],
            [30.19709076232244, 0.819695568358605],
            [30.19402398131611, 0.819041572778414],
            [30.19186193944649, 0.816089688599224],
            [30.191590371549587, 0.814545707436526],
            [30.19329636030903, 0.811699471898124],
            [30.192462746183224, 0.809743418214725],
            [30.189704145709836, 0.806996975823426],
            [30.18963865044079, 0.803120309721569],
            [30.18926433503831, 0.80229669742466],
            [30.187833466114423, 0.8015752700041],
            [30.187851421640307, 0.800237336757045],
            [30.18866983447487, 0.799517470093919],
            [30.191567319881067, 0.798524588696578],
            [30.193680475432917, 0.798251595627885],
            [30.194328885693203, 0.796948394891749],
            [30.195522134953094, 0.796297392140084],
            [30.196136159500956, 0.795440149690154],
            [30.196887735881702, 0.792764753037916],
            [30.195270731539374, 0.790087735148599],
            [30.194659595075183, 0.786656665371638],
            [30.193297472423335, 0.785043334186755],
            [30.191681970962453, 0.780102111544174],
            [30.192842491003297, 0.777392683603077],
            [30.193270080993706, 0.77499151675882],
            [30.194430339624766, 0.772659450563227],
            [30.19385195124426, 0.771183884242152],
            [30.19306863199461, 0.770394313204134],
            [30.19189298701934, 0.770221998669243],
            [30.189319913804926, 0.77028889645108],
            [30.18677011054967, 0.771007869015355],
            [30.189061566414075, 0.767369330115666],
            [30.18951051834193, 0.765247196175922],
            [30.192571585164753, 0.76251288213899],
            [30.19387767719737, 0.762227228794353],
            [30.196163290419154, 0.762716926261697],
            [30.197673440158447, 0.76173751420489],
            [30.200040673408644, 0.760921311421679],
            [30.204585351940626, 0.760814716848216],
            [30.204550038268497, 0.760312634284164],
            [30.20524686053606, 0.759914793779209],
            [30.2052350369103, 0.763221238864552],
            [30.207852192252307, 0.76588142470716],
            [30.208534144706984, 0.767706241776661],
            [30.21043403571881, 0.768938282696186],
            [30.210966103370044, 0.770631358069716],
            [30.21211436859375, 0.77079726279024],
            [30.212411861869757, 0.773071565509578],
            [30.213844921784624, 0.774642441800728],
            [30.21407895178075, 0.77699147002903],
            [30.215595064536906, 0.779098070365431],
            [30.217206660122947, 0.783632795159057],
            [30.217683635894385, 0.788099088757725],
            [30.21934199597746, 0.79446011647474],
            [30.22524890406081, 0.805247337734634],
            [30.226147730486343, 0.810747157324424],
            [30.228356937501644, 0.810342222045874],
            [30.230305510913638, 0.809004630307452],
            [30.233734391132913, 0.809432964497668],
            [30.235416837743728, 0.810741699707187],
            [30.23858446991206, 0.811077450940762],
            [30.24000383501041, 0.812418123804376],
            [30.241316025705487, 0.812350412910107],
            [30.243768483025022, 0.814444889818415],
            [30.2453702330755, 0.814583228968697],
            [30.24686920148445, 0.815510581882689],
            [30.250828115569135, 0.815872621945863],
            [30.251802476835312, 0.816799398801133],
            [30.254038771649682, 0.817768268006019],
            [30.25309704168621, 0.812677282362089],
            [30.252294877578514, 0.810837232259888],
            [30.25192035017365, 0.800837953709559],
            [30.251693018016248, 0.799804884125263],
            [30.250797981582934, 0.798647981873845],
            [30.250697735885435, 0.795288635569428],
            [30.2509330028617, 0.793190342140842],
            [30.251503692680245, 0.792234322555626],
            [30.255163194687462, 0.789750118369454],
            [30.25578160660714, 0.788459381493013],
            [30.25634030032338, 0.781908919239056],
            [30.25886097840051, 0.781581368281659],
            [30.260272706920645, 0.780549255013681],
            [30.261297545420952, 0.782680585474982],
            [30.264311961832735, 0.782876270585591],
            [30.265017955899367, 0.78216651589605],
            [30.266107735408212, 0.783071150871741],
            [30.26799443196514, 0.783032728125792],
            [30.27248841856565, 0.787608235508323],
            [30.27451081013783, 0.787658045977279],
            [30.277646000548014, 0.779565134035729],
            [30.278371381156774, 0.774766782421939],
            [30.28066893029376, 0.766385258179095],
            [30.29586333594497, 0.773522032288432],
            [30.301951925599557, 0.779051101801576],
            [30.300872550378358, 0.780187025009253],
            [30.30077033018388, 0.783016866257553],
            [30.30010308045543, 0.784590909597684],
            [30.299472991335374, 0.785270241693654],
            [30.29751045630719, 0.7854250589748],
            [30.29646418580083, 0.789072701131621],
            [30.295632132048716, 0.78988304382464],
            [30.294753727024563, 0.790049131922998],
            [30.293432641211524, 0.792302471220539],
            [30.293474627569598, 0.795451983853452],
            [30.29477817647163, 0.796455472274039],
            [30.29495382675409, 0.797803723801847],
            [30.296114981903806, 0.798807065238194],
            [30.296312522333103, 0.801205177853284],
            [30.295242092535503, 0.802611751506938],
            [30.296164580585614, 0.804378350145791],
            [30.296256799836048, 0.805929324282996],
            [30.295506764964287, 0.807324313682909],
            [30.295433847814355, 0.808302473714176],
            [30.29849016524429, 0.811288212311019],
            [30.30222557040142, 0.812735742432549],
            [30.30388458445801, 0.814049809332732],
            [30.30521393207672, 0.813884215333525],
            [30.306162164944553, 0.814505592729867],
            [30.308537357268165, 0.813434446379145],
            [30.310375615766663, 0.814044852031038],
            [30.310895903809527, 0.815095245643467],
            [30.312009768049457, 0.816003123142888],
            [30.315352599545964, 0.818034815906014],
            [30.315290386720978, 0.81966915520256],
            [30.315787785690432, 0.820242340231501],
            [30.317637645930816, 0.821007842824337],
            [30.320389881840427, 0.82148801487935],
            [30.321954438943227, 0.82253954369276],
            [30.32510943451045, 0.823425775037468],
            [30.32571278437776, 0.824488196081579],
            [30.326780830944926, 0.824465488124133],
            [30.327039967954935, 0.825563338360935],
            [30.32853509965931, 0.825612675900519],
            [30.331237886007468, 0.827238090057624],
            [30.334429492414134, 0.827563644195879],
            [30.334836712207135, 0.828037755159913],
            [30.335713089733705, 0.829628176323394],
            [30.33511824062392, 0.830486514530388],
            [30.335519730063734, 0.831608378825726],
            [30.335208749482042, 0.832991947393549],
            [30.33439915990024, 0.834494278126601],
            [30.33647331509404, 0.835940078830975],
            [30.338681400113558, 0.835465266408413],
            [30.34124054225451, 0.837806377672065],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 358,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "KARUGUTU",
        Population: 6252,
        Key: "NTOROKOKARUGUTU",
        Dist2: "Ntoroko",
        "Sub Country": "Karugutu SC",
        id2_original: "Ntoroko Karugutu SC",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.20524686053606, 0.759914793779209],
            [30.20753815739865, 0.757345004604019],
            [30.208060684941547, 0.757345344137524],
            [30.211621376759087, 0.760455867923251],
            [30.216811584654238, 0.761078508119704],
            [30.218462346786623, 0.764407385739299],
            [30.219314185034584, 0.764682402036916],
            [30.21972264270608, 0.765471736097707],
            [30.222142084243956, 0.765919316751706],
            [30.222823010822584, 0.766983290374356],
            [30.22585593702079, 0.767396968797826],
            [30.227388866239078, 0.768495813312177],
            [30.228819309361505, 0.769971975195367],
            [30.229280085813457, 0.771216041914399],
            [30.232446888836797, 0.773130660292155],
            [30.23540895233214, 0.777729845076146],
            [30.23564709481564, 0.778381849561464],
            [30.234597764647436, 0.783521674069402],
            [30.236827647287324, 0.784310739643485],
            [30.23810968063998, 0.785409183642169],
            [30.241701067890784, 0.785928095185041],
            [30.24574185982034, 0.785801662015959],
            [30.246447848497084, 0.785091923092221],
            [30.247987169228587, 0.785092947075508],
            [30.24856496561933, 0.784253992095597],
            [30.249655108047545, 0.784577539428334],
            [30.25036097006183, 0.784061490380596],
            [30.25119468659554, 0.784191173402615],
            [30.25260666574566, 0.782771685007927],
            [30.253953450562328, 0.78296627157728],
            [30.25634030032338, 0.781908919239056],
            [30.25578160660714, 0.788459381493013],
            [30.255163194687462, 0.789750118369454],
            [30.251503692680245, 0.792234322555626],
            [30.2509330028617, 0.793190342140842],
            [30.250697735885435, 0.795288635569428],
            [30.250797981582934, 0.798647981873845],
            [30.251693018016248, 0.799804884125263],
            [30.25192035017365, 0.800837953709559],
            [30.252294877578514, 0.810837232259888],
            [30.25309704168621, 0.812677282362089],
            [30.254038771649682, 0.817768268006019],
            [30.251802476835312, 0.816799398801133],
            [30.250828115569135, 0.815872621945863],
            [30.24686920148445, 0.815510581882689],
            [30.2453702330755, 0.814583228968697],
            [30.243768483025022, 0.814444889818415],
            [30.241316025705487, 0.812350412910107],
            [30.24000383501041, 0.812418123804376],
            [30.23858446991206, 0.811077450940762],
            [30.235416837743728, 0.810741699707187],
            [30.233734391132913, 0.809432964497668],
            [30.230305510913638, 0.809004630307452],
            [30.228356937501644, 0.810342222045874],
            [30.226147730486343, 0.810747157324424],
            [30.22524890406081, 0.805247337734634],
            [30.21934199597746, 0.79446011647474],
            [30.217683635894385, 0.788099088757725],
            [30.217206660122947, 0.783632795159057],
            [30.215595064536906, 0.779098070365431],
            [30.21407895178075, 0.77699147002903],
            [30.213844921784624, 0.774642441800728],
            [30.212411861869757, 0.773071565509578],
            [30.21211436859375, 0.77079726279024],
            [30.210966103370044, 0.770631358069716],
            [30.21043403571881, 0.768938282696186],
            [30.208534144706984, 0.767706241776661],
            [30.207852192252307, 0.76588142470716],
            [30.2052350369103, 0.763221238864552],
            [30.20524686053606, 0.759914793779209],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 359,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "KARUGUTU TOWN COUNCIL",
        Population: 10483,
        Key: "NTOROKOKARUGUTU TOWN COUNCIL",
        Dist2: "Ntoroko",
        "Sub Country": "Karugutu TC",
        id2_original: "Ntoroko Karugutu TC",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.346482193971042, 0.899503721202415],
            [30.338768203421125, 0.90831693521495],
            [30.332825472320884, 0.913812197105624],
            [30.32593254463563, 0.919306677239739],
            [30.305259377846948, 0.928377210351518],
            [30.289611500843677, 0.933771352945111],
            [30.287388564875876, 0.936585292963945],
            [30.286248044028213, 0.937014794645579],
            [30.279497982609108, 0.942126380932435],
            [30.27530972953071, 0.946050847201777],
            [30.270835083658277, 0.948066162287913],
            [30.2668864723516, 0.949024212693248],
            [30.262124582980544, 0.951143641714463],
            [30.260441197630268, 0.953208138769311],
            [30.260083471416152, 0.955001118793887],
            [30.255486992431603, 0.96032565712053],
            [30.249003892348618, 0.965127541567828],
            [30.249572313022764, 0.967184268052154],
            [30.25189805937817, 0.969768460605463],
            [30.25363892702515, 0.973715925593954],
            [30.253274978181043, 0.977251308761624],
            [30.240056196910025, 0.980156445239904],
            [30.23639479676261, 0.981756527935998],
            [30.23680350326744, 0.979941615825281],
            [30.238705920341836, 0.977313120928414],
            [30.237994988236096, 0.975280198921641],
            [30.234769348256595, 0.972500520429935],
            [30.235338011475857, 0.972203972669718],
            [30.233603682665816, 0.972180336007743],
            [30.231553409183853, 0.969739852463545],
            [30.229643572025193, 0.969853041041428],
            [30.23015853216014, 0.967529449497043],
            [30.22807788753671, 0.967384275495683],
            [30.226796070678024, 0.966350323497883],
            [30.224928871156006, 0.966621352469126],
            [30.224044795965767, 0.967194450801558],
            [30.223788451817978, 0.96696470705817],
            [30.22396073521475, 0.96541551315244],
            [30.223136632451205, 0.962344853898725],
            [30.22330834990934, 0.961484253508006],
            [30.22479203707699, 0.959620529198379],
            [30.224593464483437, 0.95844401688966],
            [30.223994962823685, 0.95835745296757],
            [30.22319645126596, 0.958873244607485],
            [30.222454249703482, 0.960249822115176],
            [30.221342410266214, 0.960507131733855],
            [30.221386873279517, 0.958398353828221],
            [30.22095962554727, 0.958025015906097],
            [30.218650884300143, 0.957994432546327],
            [30.216086525642343, 0.956844680352711],
            [30.21568796830359, 0.956241836714807],
            [30.215916620086123, 0.955467362266505],
            [30.217456230973493, 0.954923488187902],
            [30.217514440007275, 0.953431589813497],
            [30.213598600140486, 0.94928251834879],
            [30.213970474820314, 0.947618732251754],
            [30.214740287001344, 0.947332446877652],
            [30.220041682972496, 0.947566277813796],
            [30.222522080592285, 0.946793620257883],
            [30.223406345327035, 0.945962286285767],
            [30.222865264878585, 0.945359328472878],
            [30.218975301881855, 0.944452407603859],
            [30.216896770994328, 0.941696367010303],
            [30.214959684339817, 0.940288935421404],
            [30.214181271688243, 0.93799877269231],
            [30.21462020021419, 0.93707524946658],
            [30.215732111516655, 0.936703155941434],
            [30.21781037470625, 0.939803481119449],
            [30.218750588313558, 0.94029198928208],
            [30.219605795243794, 0.940149221292529],
            [30.22014792402619, 0.939432374102069],
            [30.220149106209103, 0.93794042595075],
            [30.218767922205284, 0.936404332660361],
            [30.216147141262756, 0.934508610098931],
            [30.21586326734478, 0.933045130874869],
            [30.21617738843669, 0.932299410608093],
            [30.217773691103307, 0.932128537727627],
            [30.219682376621787, 0.933421169664914],
            [30.222646110085233, 0.934169511527638],
            [30.22498395674755, 0.933425401066623],
            [30.224984723908804, 0.93244989262731],
            [30.224414998880878, 0.932019067344131],
            [30.22230583454383, 0.931931312653066],
            [30.22136586437997, 0.931127205775038],
            [30.221224160533794, 0.930094204012766],
            [30.22229690079833, 0.92825184984162],
            [30.22165585313012, 0.925220673952646],
            [30.22051235436728, 0.923839404788305],
            [30.220104162597117, 0.921947279956837],
            [30.219846337127446, 0.910576702174437],
            [30.222839583841232, 0.910005205938237],
            [30.22982212925589, 0.910919197298603],
            [30.232815291528084, 0.910491146651628],
            [30.233813342266618, 0.909918087530426],
            [30.236427854765058, 0.907672592597485],
            [30.239950213672802, 0.898493931625799],
            [30.240948044324075, 0.898207775231853],
            [30.24375345600694, 0.894766886262982],
            [30.245972863392275, 0.892889193855997],
            [30.25040330047466, 0.894065046189901],
            [30.251007757066393, 0.892825147261961],
            [30.2525763763509, 0.891583006890605],
            [30.254334664127857, 0.8908192088096],
            [30.25485712250048, 0.890963062898919],
            [30.255331471598037, 0.891919826237961],
            [30.257326795134077, 0.891825687914198],
            [30.258325629203547, 0.890200545532352],
            [30.26438865819509, 0.889121307614848],
            [30.262586277510696, 0.885246489452538],
            [30.262090641934144, 0.880918357298361],
            [30.26297412962621, 0.874582781867673],
            [30.2622171561672, 0.870278370818702],
            [30.26245669014107, 0.867504952675986],
            [30.260890546613506, 0.865351882343773],
            [30.26046292518206, 0.865447211466628],
            [30.25908608273598, 0.864298515676536],
            [30.25804212539148, 0.862671858628125],
            [30.257279535665315, 0.860402901581524],
            [30.269574255037874, 0.85816497380279],
            [30.27634127036136, 0.856395038080407],
            [30.28335612188857, 0.855481025227527],
            [30.2872691545201, 0.855483823167712],
            [30.29314000602459, 0.853670018257628],
            [30.313009513010613, 0.849290543862309],
            [30.322494464769512, 0.844752099744741],
            [30.333935109089072, 0.841578452078031],
            [30.34124054225451, 0.837806377672065],
            [30.341927389629177, 0.838618374974148],
            [30.341569481955347, 0.839691709779117],
            [30.342018734818826, 0.840646623151506],
            [30.341980287822985, 0.842257165588916],
            [30.341480319671835, 0.843139452915834],
            [30.340602166175938, 0.84313850978694],
            [30.340695360098486, 0.844116888255143],
            [30.341193439092578, 0.844308312834281],
            [30.341287359752172, 0.84488107481489],
            [30.34183307550748, 0.844977114936237],
            [30.341783952932797, 0.845907610769744],
            [30.34114217134099, 0.846455704774034],
            [30.34147304511467, 0.84724346727513],
            [30.34092602320892, 0.847887108916964],
            [30.3415296524523, 0.848782528689285],
            [30.340435313095092, 0.850236823914086],
            [30.34081500132128, 0.850261108990229],
            [30.341359071363, 0.851287697411156],
            [30.34059839145513, 0.851954957866688],
            [30.33955418078572, 0.851906102102946],
            [30.339908153838596, 0.853051782713691],
            [30.33910098431814, 0.853170203472595],
            [30.33981878763748, 0.856594976229674],
            [30.341645785753897, 0.856883306792224],
            [30.34202307278335, 0.858267637925122],
            [30.3430674568276, 0.858221061910125],
            [30.34425186486846, 0.85951084473603],
            [30.344202696479698, 0.86046521427891],
            [30.34312115631866, 0.861382651727755],
            [30.343618550796528, 0.861955852189586],
            [30.34375904461201, 0.863029741885419],
            [30.343377468127095, 0.86405531369909],
            [30.342711793145387, 0.86467495675927],
            [30.342448078320675, 0.866154018651527],
            [30.341366832807058, 0.866904425835927],
            [30.34226535739863, 0.868790405664671],
            [30.343498036411287, 0.869626899642023],
            [30.34290395356443, 0.870031862908092],
            [30.342997744866615, 0.870676205807893],
            [30.3421785864304, 0.870854256485802],
            [30.341820959030926, 0.871760552701375],
            [30.342008940487307, 0.872810620854212],
            [30.341343576322668, 0.873263233869128],
            [30.34162547843858, 0.874886062675407],
            [30.34217037403207, 0.875435463004305],
            [30.341954200747146, 0.876866864342312],
            [30.3430985079937, 0.880650042466761],
            [30.34371438486768, 0.881318819317744],
            [30.345043037190333, 0.881582770602082],
            [30.345112393418475, 0.882608852928254],
            [30.34448156588324, 0.883646081738214],
            [30.345549263904065, 0.883838175287406],
            [30.346021668149046, 0.885103315084244],
            [30.345568653141186, 0.886248117956723],
            [30.346302914494846, 0.887084054732429],
            [30.345708948428978, 0.887417447828668],
            [30.346467157969826, 0.888134112284438],
            [30.345492800296906, 0.888824972905004],
            [30.345953486917317, 0.890006594821472],
            [30.345524672523194, 0.890888959949254],
            [30.346140306852014, 0.89170090906994],
            [30.345474013829374, 0.892654583285863],
            [30.346043253767036, 0.892869965955729],
            [30.346207971552484, 0.893657561579507],
            [30.345636091466186, 0.89489765962806],
            [30.346443158578705, 0.894850853229782],
            [30.346727323550834, 0.895209084601855],
            [30.345583222916773, 0.897880173841431],
            [30.34565322233867, 0.898548352059747],
            [30.346482193971042, 0.899503721202415],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 360,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "KIBUUKU TOWN COUNCIL",
        Population: 2174,
        Key: "NTOROKOKIBUUKU TOWN COUNCIL",
        Dist2: "Ntoroko",
        "Sub Country": "Kibuuku TC",
        id2_original: "Ntoroko Kibuuku TC",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.461581919173643, 0.978445282430518],
            [30.445967441532655, 0.987360621870512],
            [30.423865807915124, 0.997028339575048],
            [30.412456869633523, 1.004193268636745],
            [30.39997918409885, 1.010998467240357],
            [30.37858589543908, 1.026404700001851],
            [30.365391723515245, 1.037871659128078],
            [30.357400633242897, 1.048347104259284],
            [30.35427441520579, 1.049652803152163],
            [30.352220659853778, 1.05111446500916],
            [30.348597135373687, 1.054784241101139],
            [30.34537451103861, 1.056330959247755],
            [30.342278984841503, 1.059269445958504],
            [30.341706853226913, 1.061593181786969],
            [30.34016540438649, 1.06400215488421],
            [30.33821187047746, 1.064933013564163],
            [30.33696580746541, 1.066703750106396],
            [30.335889137071508, 1.074043021115718],
            [30.336598151274114, 1.078252112778261],
            [30.3376417016818, 1.080213799388822],
            [30.338970740280036, 1.081697506333431],
            [30.342839983634722, 1.08512032805657],
            [30.346782078562352, 1.086749833484541],
            [30.351722998576278, 1.087184628761098],
            [30.353100278501874, 1.087855386837784],
            [30.35913339449274, 1.089008508665124],
            [30.357706880601345, 1.090298503128208],
            [30.351574378600713, 1.094118987865916],
            [30.3498634194628, 1.094691350123827],
            [30.340790526721356, 1.099515542464025],
            [30.340078251634257, 1.09937215193387],
            [30.339762832476744, 1.097438788392056],
            [30.33909363160753, 1.096757025617552],
            [30.338847122215462, 1.098846718015152],
            [30.33841008913479, 1.099216953419183],
            [30.337638387796705, 1.097019255974484],
            [30.33531479919462, 1.097430162554586],
            [30.33254782372783, 1.095414117559787],
            [30.33236323341166, 1.094232539361717],
            [30.333132865031335, 1.092912161210887],
            [30.331238002788464, 1.092199819819793],
            [30.330381085465913, 1.09227307669473],
            [30.328446925522613, 1.094659615742724],
            [30.327373344434992, 1.091754939915892],
            [30.325141859200645, 1.091626974779197],
            [30.32409275630617, 1.089830190137179],
            [30.322887339365757, 1.089412091904596],
            [30.32246295815758, 1.087598204201748],
            [30.32009990117512, 1.088870195790199],
            [30.31855642663374, 1.088907390104829],
            [30.318362578280254, 1.086886753420346],
            [30.318734202330162, 1.085032506539227],
            [30.315458360899303, 1.085754335926642],
            [30.314047420201693, 1.084477644780554],
            [30.312836271111436, 1.085759451811805],
            [30.31128423742202, 1.086130243887623],
            [30.310201345296484, 1.085710907486198],
            [30.30967681091724, 1.084812520722423],
            [30.30883871060493, 1.084369178267406],
            [30.30603937602499, 1.086075925336543],
            [30.304789246339617, 1.086045584799527],
            [30.304432434610447, 1.084801227330558],
            [30.304722195188504, 1.084410981965813],
            [30.30719273469638, 1.083998588060471],
            [30.30760477574753, 1.083585583353809],
            [30.307396868759827, 1.08251184827398],
            [30.30641199630652, 1.082091519808182],
            [30.3041434259223, 1.083039783711979],
            [30.303429755751573, 1.082767312274055],
            [30.299525565237374, 1.07651331687456],
            [30.29730991909811, 1.074343569734149],
            [30.291802287005762, 1.070321619295652],
            [30.289094306598617, 1.070223561038304],
            [30.286433462591074, 1.070555934481288],
            [30.28001703816342, 1.073515111960354],
            [30.275237233690653, 1.077451120792076],
            [30.274441861744844, 1.078992159280856],
            [30.272004268848317, 1.080645456550112],
            [30.27139618036788, 1.081968987202338],
            [30.268046634862934, 1.086338204227058],
            [30.2651591980115, 1.092354901938245],
            [30.264113100879978, 1.093373372036249],
            [30.26371308467724, 1.094405928395553],
            [30.26271489559815, 1.094950164094225],
            [30.262557078670707, 1.095779829402079],
            [30.259678334816286, 1.09793403841944],
            [30.25996514083535, 1.099457262415791],
            [30.259243847561123, 1.100326854613745],
            [30.25297247589902, 1.103657012875725],
            [30.24088701008875, 1.106460659751668],
            [30.240773470223342, 1.105019340576692],
            [30.23952838098505, 1.101913149016018],
            [30.23941717943435, 1.100366696531387],
            [30.24054374136078, 1.097590903648566],
            [30.24026479919371, 1.096695899275911],
            [30.238789423239062, 1.095895695370013],
            [30.238237775907926, 1.094672665881665],
            [30.238515800895094, 1.093039573929466],
            [30.238281305571643, 1.091293538433818],
            [30.23759064844186, 1.090887060701113],
            [30.235712661949922, 1.091402244504688],
            [30.234940300350097, 1.089685289349003],
            [30.23220404726604, 1.088011848743529],
            [30.23234030552498, 1.084501848244549],
            [30.231660623113005, 1.083870811207311],
            [30.230721768656732, 1.084140214450298],
            [30.22995944573024, 1.085778206165273],
            [30.22925963027612, 1.085761660372454],
            [30.22871604801962, 1.085271005991344],
            [30.22857474572035, 1.084658132489346],
            [30.229681123400695, 1.082496864354797],
            [30.229643549567303, 1.081528545372759],
            [30.228348727798235, 1.080017717636377],
            [30.227572981346448, 1.077993667417789],
            [30.228157416287146, 1.076085769991242],
            [30.229998822482376, 1.074696730579702],
            [30.230632855206558, 1.073627088860316],
            [30.23046413003662, 1.072967247444502],
            [30.229165349392115, 1.072318856502222],
            [30.226688437235634, 1.072202207336488],
            [30.225874228516624, 1.071572536543231],
            [30.22630554561713, 1.070422262450073],
            [30.229630426977636, 1.06934895025864],
            [30.22975271284065, 1.068237235999155],
            [30.229343914707655, 1.067768846860904],
            [30.22844768441333, 1.067021880018594],
            [30.225857159627907, 1.06636297306444],
            [30.225052889869186, 1.065414245025502],
            [30.22561990647653, 1.059489942868383],
            [30.228437771504158, 1.056366202250549],
            [30.22794355796071, 1.055473399748451],
            [30.226862633145622, 1.05505908886677],
            [30.22368515095019, 1.05485508371213],
            [30.222763323161843, 1.054226513223381],
            [30.22238901225094, 1.053226176584303],
            [30.224106333257673, 1.050349884742972],
            [30.22390416919962, 1.049099708887075],
            [30.22195472891336, 1.046792264538058],
            [30.221775810559894, 1.045211079046255],
            [30.225945661649682, 1.045121451976425],
            [30.227475368611046, 1.044751507324414],
            [30.228731062461268, 1.043935425555437],
            [30.229231310886785, 1.042938003770566],
            [30.228755649350596, 1.041288947254751],
            [30.22762311272917, 1.039805217342448],
            [30.233643373828333, 1.036761915001132],
            [30.23574750670147, 1.036840141859674],
            [30.23755855433172, 1.037974326903586],
            [30.24203145837082, 1.039736309043841],
            [30.243350376549067, 1.039770147499619],
            [30.24495664153219, 1.039021357850707],
            [30.246983219253586, 1.039780446784795],
            [30.2496918572275, 1.04016636143469],
            [30.25244281663107, 1.038295434478073],
            [30.253771148255204, 1.039179759579415],
            [30.253139501456413, 1.040462072211521],
            [30.25371028469976, 1.040976064500131],
            [30.255354697539726, 1.041242862308956],
            [30.257663417227253, 1.040746825322168],
            [30.260714538801572, 1.038034035307217],
            [30.26244738449304, 1.038364864643582],
            [30.263319097068347, 1.03957793338991],
            [30.262363658813634, 1.041065636001702],
            [30.26033871063614, 1.042326320014439],
            [30.259739184896972, 1.043387407616448],
            [30.259652573828856, 1.044649791825595],
            [30.260819655164532, 1.046515818208765],
            [30.261046396230444, 1.04800801824333],
            [30.260988961544452, 1.048495736178952],
            [30.259163713346215, 1.049555737610386],
            [30.259134330351586, 1.050559940227007],
            [30.263661275241535, 1.05368415461755],
            [30.265497316697907, 1.053587660433033],
            [30.27321049427248, 1.054839501481414],
            [30.277860645798604, 1.05448769638411],
            [30.277648548170152, 1.053415356759615],
            [30.276868243666595, 1.052485470925596],
            [30.277065277446052, 1.046450092257337],
            [30.277523870093564, 1.045154920329968],
            [30.278306156280618, 1.038264325538463],
            [30.279876286531437, 1.035539878758232],
            [30.286297024669082, 1.027296224556975],
            [30.279254105280835, 1.02491125120974],
            [30.28034549097739, 1.023398704788461],
            [30.281560996896733, 1.020489936659644],
            [30.284525044770568, 1.012119597474754],
            [30.28582277618283, 1.010239725364928],
            [30.28749383574907, 1.009265714802372],
            [30.28886205167349, 1.006463616697886],
            [30.294776510995113, 0.990089111447454],
            [30.298035853069116, 0.986001168493409],
            [30.300228264283543, 0.981315402189215],
            [30.301584002608656, 0.97979002842687],
            [30.304148028889824, 0.979399441441195],
            [30.30783249597711, 0.973727576857085],
            [30.32910390840563, 0.965747422257805],
            [30.33658925525786, 0.962525268542255],
            [30.367241908047447, 0.951788752435746],
            [30.381857087189996, 0.944626199908398],
            [30.390060882351943, 0.933871676046395],
            [30.397906940519974, 0.924910198271],
            [30.40076210000493, 0.91881449702794],
            [30.411459561801728, 0.908778797148734],
            [30.415267059455385, 0.90399499105181],
            [30.424638039259236, 0.908432379371598],
            [30.439945643416024, 0.910644544257041],
            [30.44159183492028, 0.912591172532942],
            [30.443370458758633, 0.913476070502726],
            [30.44745230010343, 0.913934016516955],
            [30.450217831977547, 0.913805868381146],
            [30.452922800333525, 0.914357721258337],
            [30.456199694589884, 0.913669356192405],
            [30.459166684446238, 0.91372038748582],
            [30.46349625060368, 0.91504958737871],
            [30.468868114018942, 0.917573108370329],
            [30.47572349751524, 0.92013408160076],
            [30.477516477330177, 0.919670753469551],
            [30.480862926342333, 0.919936971726591],
            [30.482141604487424, 0.921680403470013],
            [30.485662137120197, 0.924154168562886],
            [30.48765148326632, 0.926709753261116],
            [30.488526546557633, 0.928500485242798],
            [30.491760447444477, 0.931976209002741],
            [30.49549029921655, 0.936860454175387],
            [30.49831034355707, 0.939488592097718],
            [30.502314952245275, 0.942017147086385],
            [30.50539176743334, 0.943388396946275],
            [30.51086227934157, 0.94830207608233],
            [30.50728885749812, 0.951893878544998],
            [30.492313957881525, 0.961927091097282],
            [30.461581919173643, 0.978445282430518],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 361,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "RWEBISENGO",
        Population: 4536,
        Key: "NTOROKORWEBISENGO",
        Dist2: "Ntoroko",
        "Sub Country": "Rwebisengo SC",
        id2_original: "Ntoroko Rwebisengo SC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.279254105280835, 1.02491125120974],
            [30.286297024669082, 1.027296224556975],
            [30.279876286531437, 1.035539878758232],
            [30.278306156280618, 1.038264325538463],
            [30.277523870093564, 1.045154920329968],
            [30.277065277446052, 1.046450092257337],
            [30.276868243666595, 1.052485470925596],
            [30.277648548170152, 1.053415356759615],
            [30.277860645798604, 1.05448769638411],
            [30.27321049427248, 1.054839501481414],
            [30.265497316697907, 1.053587660433033],
            [30.263661275241535, 1.05368415461755],
            [30.259134330351586, 1.050559940227007],
            [30.259163713346215, 1.049555737610386],
            [30.260988961544452, 1.048495736178952],
            [30.261046396230444, 1.04800801824333],
            [30.260819655164532, 1.046515818208765],
            [30.259652573828856, 1.044649791825595],
            [30.259739184896972, 1.043387407616448],
            [30.26033871063614, 1.042326320014439],
            [30.262363658813634, 1.041065636001702],
            [30.263319097068347, 1.03957793338991],
            [30.26244738449304, 1.038364864643582],
            [30.265196735013948, 1.036623528831074],
            [30.271449356141133, 1.030750828660865],
            [30.279254105280835, 1.02491125120974],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 362,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "RWEBISENGO TOWN COUNCIL",
        Population: 3144,
        Key: "NTOROKORWEBISENGO TOWN COUNCIL",
        Dist2: "Ntoroko",
        "Sub Country": "Rwebisengo TC",
        id2_original: "Ntoroko Rwebisengo TC",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.215765027645734, 1.501662142441825],
            [31.209870911572054, 1.502905952408671],
            [31.205671143888324, 1.50280263409198],
            [31.204011719301658, 1.501982549438345],
            [31.19263046440214, 1.493156130350316],
            [31.18833202217437, 1.490723880798203],
            [31.18533821760679, 1.490613560113471],
            [31.183749473364944, 1.491107010978248],
            [31.180550857404167, 1.494789756774975],
            [31.177676401208554, 1.495180632475794],
            [31.17679309138295, 1.496270924310502],
            [31.175980273256016, 1.495959425626572],
            [31.17416440436764, 1.496719085525531],
            [31.172008790842177, 1.49674264837828],
            [31.17154977149495, 1.497472374689083],
            [31.170842591652146, 1.496938306524559],
            [31.169632215113033, 1.49720370220641],
            [31.169178648539585, 1.496911533292757],
            [31.168258016408842, 1.497405526038029],
            [31.166619814520732, 1.496744455171973],
            [31.165802982721097, 1.498635841364451],
            [31.16328939235156, 1.499066358935919],
            [31.162063954658407, 1.501328369463539],
            [31.16102240210394, 1.501776991218803],
            [31.15962206242498, 1.503628773691886],
            [31.158547186865004, 1.50379426002044],
            [31.157058099025868, 1.504974433416221],
            [31.151535230607948, 1.50543563906741],
            [31.1485159731751, 1.508838091078594],
            [31.147358414879754, 1.509020136200543],
            [31.146613565982136, 1.509967971758333],
            [31.14563818243317, 1.509800732996122],
            [31.14530681817937, 1.510599162954837],
            [31.14363648445189, 1.511030362443051],
            [31.14297458778424, 1.511645467409336],
            [31.141949363008347, 1.511761061900138],
            [31.140759389904304, 1.511177640303329],
            [31.14039465683096, 1.51232547442599],
            [31.139931513318253, 1.512541391902184],
            [31.13905548074474, 1.512207837907724],
            [31.137812538479977, 1.512903344265083],
            [31.136905756574315, 1.512522136039107],
            [31.133945985579565, 1.51268596936728],
            [31.133184114505614, 1.514199528241978],
            [31.13384471220936, 1.515098650360024],
            [31.13384415615222, 1.515747601624799],
            [31.132630985852593, 1.516393076534383],
            [31.13179333829119, 1.516411410116376],
            [31.130323651367227, 1.514246961583894],
            [31.127944029450955, 1.512730674611618],
            [31.127465610985137, 1.51148227876859],
            [31.126457927611803, 1.510433099727359],
            [31.125052469332342, 1.51049843574207],
            [31.124539885241354, 1.510934478180177],
            [31.12369650103855, 1.510696932140869],
            [31.12288492617993, 1.512326914821793],
            [31.122215028218037, 1.512634164516286],
            [31.121666474684734, 1.5160281793116],
            [31.12046702345615, 1.516867431876432],
            [31.119903797739322, 1.51809827320704],
            [31.12062948377529, 1.520195508041612],
            [31.119355084305866, 1.521658677660746],
            [31.116630821035905, 1.52230664723955],
            [31.11681913846217, 1.519301939474789],
            [31.115001455875248, 1.518069010081468],
            [31.112944965153208, 1.515762617996731],
            [31.112203659211076, 1.51261708541148],
            [31.109914385354518, 1.511824696160007],
            [31.109719652160486, 1.508165187081134],
            [31.111621515872677, 1.507050635300962],
            [31.113423706114215, 1.507068850425249],
            [31.114249845358508, 1.507718516207083],
            [31.115157421374875, 1.509799260270542],
            [31.117306730523673, 1.509934255324322],
            [31.117175735494, 1.508453213793066],
            [31.11777174792209, 1.507538554346346],
            [31.11742586509664, 1.505990766066992],
            [31.116427438862324, 1.503801786207842],
            [31.11462582803414, 1.502518186985088],
            [31.119108942324782, 1.500309791420249],
            [31.120317118889737, 1.498913105811124],
            [31.122027948670244, 1.498951746192684],
            [31.12322743044156, 1.498532910785521],
            [31.1249932568804, 1.496320375868588],
            [31.12555625083191, 1.496496854378784],
            [31.126337312615256, 1.496062796350812],
            [31.127765686019266, 1.496853339632876],
            [31.130630591326774, 1.494810645375909],
            [31.13093494234165, 1.494375035253579],
            [31.13076326081614, 1.493632249948567],
            [31.13132724291442, 1.493372126052612],
            [31.130591477780985, 1.492933122961981],
            [31.131415874293612, 1.492499207911312],
            [31.13072335405795, 1.492104012302124],
            [31.132113590384915, 1.4905804261905],
            [31.1322888085777, 1.489751443957943],
            [31.13159618593407, 1.489399908291084],
            [31.13194553445986, 1.488222214905826],
            [31.131295961779593, 1.488001803171533],
            [31.131038777707015, 1.486734812437367],
            [31.131560203915367, 1.486125270848724],
            [31.133859342172084, 1.485128557777646],
            [31.13416388183319, 1.484605618396521],
            [31.133927534183616, 1.48370981089523],
            [31.131848702360468, 1.483091813667227],
            [31.13133148655584, 1.481823982270648],
            [31.135150174522977, 1.479609705492505],
            [31.137188316257035, 1.479048732035132],
            [31.137147704321354, 1.477826108966939],
            [31.131651335306014, 1.473917081069773],
            [31.130876794393295, 1.472992458128905],
            [31.12906040448207, 1.466643600623602],
            [31.129067696107246, 1.463374337550494],
            [31.127008401743193, 1.460224128780928],
            [31.12451555437187, 1.458707159029213],
            [31.124188217265495, 1.456247158772747],
            [31.122293037917313, 1.454131359341666],
            [31.12207369986765, 1.452985005523915],
            [31.122158960767894, 1.452063180289654],
            [31.124933574609543, 1.451597141144412],
            [31.127015666418895, 1.450737659995151],
            [31.12818410061736, 1.449148710516463],
            [31.12859052090978, 1.4472359595236],
            [31.130398239383588, 1.44503432697821],
            [31.131179797036967, 1.442801448920477],
            [31.129535394078463, 1.440155562213926],
            [31.12968441021104, 1.435489631698185],
            [31.128907342337467, 1.429437555066631],
            [31.12822027038396, 1.426585194240558],
            [31.126134175681745, 1.421167420474931],
            [31.125588863269968, 1.418738839871736],
            [31.125690717850134, 1.416573617059961],
            [31.126611281708897, 1.414173520214058],
            [31.12725035577845, 1.413644667005902],
            [31.128998472829775, 1.413287024495538],
            [31.129746644595624, 1.413596796883235],
            [31.13309416350129, 1.417435695599584],
            [31.134340717891817, 1.418138264833087],
            [31.135062020149178, 1.418056756014877],
            [31.136353959224493, 1.41704099064221],
            [31.13674612594833, 1.415281861426706],
            [31.139252438167414, 1.410679350597235],
            [31.139355624050843, 1.407899380431177],
            [31.140133068318544, 1.407510670095367],
            [31.144349870754965, 1.407049154336673],
            [31.14679523048543, 1.404933322106288],
            [31.147716371062597, 1.402253745771785],
            [31.148152716932085, 1.399307168812411],
            [31.149744628633595, 1.39602476467947],
            [31.149319655435626, 1.39218125701321],
            [31.150219134936346, 1.387097640396665],
            [31.149619183395753, 1.38399580790361],
            [31.150011872040736, 1.382774564767931],
            [31.152706217818466, 1.379333933607594],
            [31.153578633774636, 1.376717055620417],
            [31.15701033290727, 1.372973122892165],
            [31.15770455724703, 1.372582378991877],
            [31.160347216658298, 1.372983725357568],
            [31.165412266776475, 1.375444833268215],
            [31.168249615364317, 1.375999603086322],
            [31.169158355597283, 1.376613743259099],
            [31.172797496390288, 1.377149232445199],
            [31.173402787516935, 1.377806074864111],
            [31.17617756395365, 1.377247274093988],
            [31.179823595723185, 1.374595484553336],
            [31.181688961783703, 1.373728159127531],
            [31.185500624027004, 1.374657122679046],
            [31.186627657568977, 1.374529711772583],
            [31.186927158579625, 1.376320782103234],
            [31.188440274555997, 1.378028381323692],
            [31.189263494275625, 1.378118314393717],
            [31.190214647566453, 1.379169215050576],
            [31.191643258125733, 1.379872324695109],
            [31.192117795869493, 1.380878052441184],
            [31.19447531922979, 1.381488675473295],
            [31.19607138024959, 1.381201472343434],
            [31.19721124083552, 1.379475923281059],
            [31.199241006677873, 1.379847664110658],
            [31.200732040267933, 1.377818783248344],
            [31.202739466805763, 1.377338039691143],
            [31.204436778737882, 1.374932320478827],
            [31.20591003916003, 1.375545829592644],
            [31.206487886754747, 1.376619256424932],
            [31.20697120193717, 1.376693840873408],
            [31.210587806694623, 1.375451003814091],
            [31.211678266228137, 1.374212363625485],
            [31.215228722641328, 1.375636124673051],
            [31.216897890355572, 1.375081240717224],
            [31.217310765043337, 1.374181421972301],
            [31.2224533262958, 1.371530790216212],
            [31.223903010433325, 1.37187631977301],
            [31.224576475605193, 1.373461490936277],
            [31.225083491039776, 1.373755346907918],
            [31.227187734405685, 1.373226168506988],
            [31.22993088744945, 1.373490526921395],
            [31.232157044775846, 1.366812138686878],
            [31.231900690746585, 1.362330048813644],
            [31.232377340429615, 1.35985953462006],
            [31.23710328910446, 1.354175321740898],
            [31.261092268760855, 1.376146859160027],
            [31.269390692454845, 1.383091895608755],
            [31.277749343697035, 1.388979685527601],
            [31.27493521386434, 1.392464520861375],
            [31.27262322880076, 1.394202280211165],
            [31.27019398574482, 1.402122608562446],
            [31.26900986157158, 1.402915828490014],
            [31.267168410460563, 1.403443855236892],
            [31.267832932005494, 1.406686937071855],
            [31.26935147919605, 1.407821634058595],
            [31.269753819340444, 1.412000655287979],
            [31.272164760120784, 1.41789726407585],
            [31.27136868748904, 1.422972293977198],
            [31.27179276776163, 1.430760632526695],
            [31.275427050465566, 1.435289768078764],
            [31.276937679905203, 1.438377842560368],
            [31.279695983036245, 1.442423736370497],
            [31.281147732400594, 1.44685138677034],
            [31.28260146434681, 1.44864974187437],
            [31.282590361169884, 1.45240231380421],
            [31.283935802106896, 1.455273946258073],
            [31.288292627641624, 1.459496875955754],
            [31.288964741747286, 1.460572068881218],
            [31.28642713581695, 1.462498132529009],
            [31.284854895423546, 1.464327451522367],
            [31.28313480041918, 1.464891921987841],
            [31.281902107033506, 1.465964323972047],
            [31.27864158457318, 1.469988949024707],
            [31.2771922894062, 1.473191234501413],
            [31.276364874554194, 1.474039286058862],
            [31.27174941416771, 1.476797888831283],
            [31.2650830829196, 1.47784199936861],
            [31.261504350236212, 1.477621744651491],
            [31.259306744962792, 1.477033890354885],
            [31.255041322109903, 1.478070405358678],
            [31.254476770479727, 1.479280008857854],
            [31.252878972118143, 1.480450977278326],
            [31.251618785793198, 1.482321770714588],
            [31.25009968254544, 1.483232885431678],
            [31.249402795599188, 1.484802534840566],
            [31.24753877072337, 1.484971227598117],
            [31.24719061336367, 1.485625062216922],
            [31.245585016727116, 1.486536847286436],
            [31.24384641912286, 1.488801760517508],
            [31.24276434536252, 1.488143353263017],
            [31.24128857145419, 1.489142872157753],
            [31.240509114960265, 1.488834728335004],
            [31.239423117358797, 1.48996648630622],
            [31.238643860290857, 1.489571019940762],
            [31.237471945120664, 1.490353196091503],
            [31.236432447013218, 1.49004422896143],
            [31.23573756869991, 1.4906969440526],
            [31.231770158349278, 1.491491974829966],
            [31.23090201028905, 1.492100466955933],
            [31.230639854939668, 1.493060201300572],
            [31.22994632050605, 1.493101641781296],
            [31.228951032985325, 1.492399843044534],
            [31.228168321895108, 1.493576215916028],
            [31.22244367749135, 1.495260661278607],
            [31.220593385161294, 1.497027243509292],
            [31.220007580289785, 1.497099220699253],
            [31.21938689832737, 1.498177495332361],
            [31.216228861962907, 1.5005004231013],
            [31.215765027645734, 1.501662142441825],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 363,
        District: "HOIMA",
        County: "BUHAGUZI",
        Subcounty: "BUGAMBE",
        Population: 30045,
        Key: "HOIMABUGAMBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.510111623794376, 1.337973329378742],
            [31.504003511952, 1.345082392852052],
            [31.500603373330257, 1.351275901149737],
            [31.496078432581697, 1.356520486450002],
            [31.494812720719406, 1.359825989299337],
            [31.493151405179045, 1.361355961868393],
            [31.492274670123003, 1.362907932372534],
            [31.488449518777387, 1.364228365685551],
            [31.484301523698473, 1.364536131950587],
            [31.481669900090484, 1.366705202226902],
            [31.481027053995046, 1.36792975844412],
            [31.47954234005304, 1.377852776447055],
            [31.47822670342053, 1.382519496852269],
            [31.47327136005641, 1.384405338099155],
            [31.47131284768406, 1.383612942638075],
            [31.46716004751668, 1.383473054656871],
            [31.46554676219963, 1.384718455057368],
            [31.464847804636598, 1.386566309639252],
            [31.465080170054538, 1.39008284613875],
            [31.46134117882276, 1.394188275131589],
            [31.460496564826325, 1.399118649798046],
            [31.46011558482278, 1.399843531148839],
            [31.45760105751037, 1.401795930722169],
            [31.45663569107513, 1.403910098122262],
            [31.454356775692105, 1.404918914766544],
            [31.451635723899262, 1.405545033620257],
            [31.448059707721296, 1.405346668044045],
            [31.44445207264196, 1.403952956451443],
            [31.443933463550337, 1.403138908496492],
            [31.439649241653527, 1.400454363907395],
            [31.434002253012814, 1.400073931429885],
            [31.431216543180756, 1.396425433540058],
            [31.426849638548564, 1.39233515136607],
            [31.423503802187437, 1.390714138128226],
            [31.41882272166608, 1.389764449350402],
            [31.417232064911012, 1.388390385067687],
            [31.41431016239704, 1.384092623427435],
            [31.411748786145974, 1.381594556955868],
            [31.410633749604635, 1.379305283857256],
            [31.41066987535378, 1.378139792287608],
            [31.40767200051961, 1.374111257681647],
            [31.406508164797085, 1.369524723753721],
            [31.406288564439365, 1.3654980641606],
            [31.40562373567063, 1.362533659971585],
            [31.404901644692412, 1.362141710969349],
            [31.40128410568708, 1.362449948983318],
            [31.401672035956, 1.362069394571285],
            [31.404405533008767, 1.36184849838366],
            [31.405378472241868, 1.36089249461828],
            [31.406049400571366, 1.357302431132548],
            [31.408109083905956, 1.352648092708429],
            [31.408680495071664, 1.346673851011843],
            [31.40761853548886, 1.344470745771466],
            [31.404973977937395, 1.341353307355428],
            [31.404602352989222, 1.339649329268497],
            [31.404858214741704, 1.336596708367774],
            [31.404525823713527, 1.330409976610036],
            [31.40721861271089, 1.327482840242439],
            [31.410355543157745, 1.326903285061309],
            [31.412156422757292, 1.323751681348862],
            [31.41268755795724, 1.321735626672081],
            [31.41248966089677, 1.317587222119425],
            [31.411183103536853, 1.311712715193749],
            [31.412042644838355, 1.307335328132005],
            [31.413735988013528, 1.303909753966192],
            [31.4157074082782, 1.296644617499662],
            [31.41632587050352, 1.290503316264882],
            [31.416204544939568, 1.289192175633148],
            [31.41437962193144, 1.285822522478369],
            [31.413756657349907, 1.283224984393446],
            [31.41635307238866, 1.279678037470946],
            [31.418406658857386, 1.268961749803531],
            [31.428137178573927, 1.269647634723897],
            [31.43877513955957, 1.269515194485872],
            [31.442223920157314, 1.270436957494038],
            [31.44566179969911, 1.272191965496891],
            [31.449327209925936, 1.27419949006811],
            [31.451279914689948, 1.275959356884483],
            [31.45513505898629, 1.280214116157875],
            [31.456589582348247, 1.282523589482844],
            [31.45697157924471, 1.283381091289642],
            [31.457276938169368, 1.287708161292547],
            [31.45701922049748, 1.289711710446283],
            [31.45584893576952, 1.293136162385759],
            [31.455690410969662, 1.297309332521911],
            [31.457705821733768, 1.300797811161288],
            [31.462909937346147, 1.306471582881953],
            [31.464927062095807, 1.30812920326928],
            [31.469805021886433, 1.310478320258242],
            [31.474145600490917, 1.311505329680947],
            [31.481401562535343, 1.314182658166957],
            [31.49100622199235, 1.320538472754086],
            [31.50025213654574, 1.325726752538321],
            [31.502647249909085, 1.328127799320329],
            [31.507673053530844, 1.335436742700907],
            [31.510111623794376, 1.337973329378742],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 364,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "BUHANIKA",
        Population: 14172,
        Key: "HOIMABUHANIKA",
        Dist2: "Hoima",
        "Sub Country": "Buhanika",
        id2_original: "Hoima Buhanika",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.350327196348214, 1.372307558105646],
            [31.34768195338223, 1.372087004121916],
            [31.346987229579153, 1.371519281603904],
            [31.346687498599746, 1.370271146002993],
            [31.345279344476133, 1.369022240115275],
            [31.34323209023185, 1.368283403382674],
            [31.341925699060234, 1.369312975877838],
            [31.340684532764765, 1.371108362591435],
            [31.33792325710846, 1.370558101686671],
            [31.335172065041238, 1.369015182270656],
            [31.333117215541197, 1.365695415571525],
            [31.331784094099984, 1.364635643342845],
            [31.32608301520107, 1.363676805505651],
            [31.323922520230383, 1.363732012898403],
            [31.321819384487195, 1.362350270461275],
            [31.31940534811239, 1.362301302767288],
            [31.31837139350857, 1.363302684098473],
            [31.317881589794837, 1.365249832231104],
            [31.31536325991388, 1.365698254339536],
            [31.31293424682664, 1.366803289206686],
            [31.311543905396803, 1.366584497607775],
            [31.30828034124094, 1.368555456014659],
            [31.307274525465097, 1.368239177561863],
            [31.306287468309012, 1.368819156667635],
            [31.303788944483394, 1.369229341460721],
            [31.301900019206236, 1.368357235517571],
            [31.300887279216166, 1.367401898903264],
            [31.299624507539846, 1.367400996353508],
            [31.29843610918248, 1.36884938353522],
            [31.296144728776557, 1.369695069313217],
            [31.29463051775386, 1.372225453185353],
            [31.29110311211086, 1.37631054246731],
            [31.290135914010776, 1.376892568080964],
            [31.28917573624461, 1.378795473248048],
            [31.287841160430958, 1.379834413312145],
            [31.285866585283042, 1.382631271317523],
            [31.28162952763357, 1.383658632000804],
            [31.27929995894661, 1.38375146557],
            [31.277749343697035, 1.388979685527601],
            [31.269390692454845, 1.383091895608755],
            [31.261092268760855, 1.376146859160027],
            [31.23710328910446, 1.354175321740898],
            [31.23811764606204, 1.352618601153033],
            [31.238317261599626, 1.350048345929007],
            [31.235817910425684, 1.344968641791775],
            [31.236069086565642, 1.337689940565548],
            [31.237265990172094, 1.335681694327084],
            [31.2375089808632, 1.332259277313935],
            [31.242511822647945, 1.32735667787933],
            [31.24405691056361, 1.324636917843295],
            [31.244756246317355, 1.321816713977173],
            [31.243903139648193, 1.318628391298608],
            [31.24370437661182, 1.314226541000457],
            [31.240486917589617, 1.307663582268848],
            [31.239241398956615, 1.30643016065669],
            [31.237883581929925, 1.305839113214384],
            [31.23966329183147, 1.30363704396303],
            [31.239984922839177, 1.302366578035792],
            [31.241737646451252, 1.29980113644271],
            [31.244236832335236, 1.298383719488584],
            [31.244489151132235, 1.297099061172662],
            [31.242984598795456, 1.293727102336649],
            [31.24276861236013, 1.290904048233912],
            [31.242299852580242, 1.28958920768717],
            [31.24266339269091, 1.28816517060662],
            [31.244372124905222, 1.286731324702835],
            [31.243962790478022, 1.283516452299862],
            [31.244574664459066, 1.282707962014118],
            [31.24454955115697, 1.281450380401042],
            [31.245078615740216, 1.280446018524172],
            [31.24778860837355, 1.277673925434097],
            [31.25149201015039, 1.272471184656527],
            [31.25203950816324, 1.269862476039735],
            [31.251767574652014, 1.268471925165494],
            [31.25332971349005, 1.265992642521631],
            [31.253603433750403, 1.264722616809692],
            [31.25488338121496, 1.263418942378207],
            [31.255371717081534, 1.259994845124141],
            [31.256156901233723, 1.25896547274571],
            [31.256285866070822, 1.257377791401963],
            [31.256934442519444, 1.256605800673523],
            [31.255938106664804, 1.254588237006795],
            [31.256450270344253, 1.253781823069807],
            [31.259538505814522, 1.251655426254112],
            [31.260485908639033, 1.250308599606648],
            [31.260674230556877, 1.249210159391022],
            [31.259689769531935, 1.244327276072233],
            [31.260055409903714, 1.242618658861461],
            [31.256519878998972, 1.239847562823619],
            [31.25604222679611, 1.238942359079541],
            [31.255594204624582, 1.232960039871517],
            [31.255373004367343, 1.232187467205391],
            [31.25455487719706, 1.231465993955306],
            [31.255247675910457, 1.228230839746381],
            [31.254583748151976, 1.226410907679446],
            [31.254900090777575, 1.225115155392202],
            [31.254269791451733, 1.224033343137284],
            [31.25203665601222, 1.222572848345929],
            [31.251108306454874, 1.220881484265653],
            [31.24952248443269, 1.22057147327293],
            [31.248397432574215, 1.219781144954533],
            [31.244930678484245, 1.213937362757878],
            [31.25061742745775, 1.209214311790161],
            [31.251886362475297, 1.208647390860857],
            [31.258386402089585, 1.20276138930392],
            [31.26002183447167, 1.201758835977732],
            [31.268035381727792, 1.198458574794356],
            [31.271327720718812, 1.198428078273058],
            [31.273932738923037, 1.197679239301851],
            [31.27716387569374, 1.197741566067468],
            [31.285695671817084, 1.200867477375252],
            [31.287519938156727, 1.202406849369599],
            [31.28975257862451, 1.205575793078427],
            [31.292442540623668, 1.20815823494809],
            [31.292423572696453, 1.209423035558213],
            [31.29335268941502, 1.210545595754464],
            [31.29807563771683, 1.214608705334077],
            [31.299957653152852, 1.2168542852831],
            [31.30280320695248, 1.217814049652237],
            [31.304793813434966, 1.219356638944859],
            [31.30687656909927, 1.222287697257691],
            [31.30863274853028, 1.22366125062614],
            [31.31136938699159, 1.227815346700084],
            [31.31337156736821, 1.229992755472815],
            [31.31541557420275, 1.234321528873781],
            [31.318340755567494, 1.236704782729613],
            [31.32302151628862, 1.238640096343472],
            [31.337031996294282, 1.238687073541027],
            [31.34185391288925, 1.238227733921781],
            [31.349297275180028, 1.239264410630423],
            [31.35882111590591, 1.237791023791522],
            [31.368961067966, 1.238891382623668],
            [31.369798447829478, 1.239224819460106],
            [31.37037349537544, 1.240223075751778],
            [31.372823488616127, 1.246933654505335],
            [31.37462648374814, 1.249674701597278],
            [31.377074650713865, 1.255244717443134],
            [31.37814447414866, 1.25685259114936],
            [31.383129301118718, 1.261611156222603],
            [31.392077611004986, 1.267147463502275],
            [31.39972183928825, 1.270215414644489],
            [31.402455072236332, 1.27056692792516],
            [31.418406658857386, 1.268961749803531],
            [31.41635307238866, 1.279678037470946],
            [31.413756657349907, 1.283224984393446],
            [31.41437962193144, 1.285822522478369],
            [31.416204544939568, 1.289192175633148],
            [31.41632587050352, 1.290503316264882],
            [31.4157074082782, 1.296644617499662],
            [31.413735988013528, 1.303909753966192],
            [31.412042644838355, 1.307335328132005],
            [31.411183103536853, 1.311712715193749],
            [31.41248966089677, 1.317587222119425],
            [31.41268755795724, 1.321735626672081],
            [31.412156422757292, 1.323751681348862],
            [31.410355543157745, 1.326903285061309],
            [31.40721861271089, 1.327482840242439],
            [31.404525823713527, 1.330409976610036],
            [31.404858214741704, 1.336596708367774],
            [31.404602352989222, 1.339649329268497],
            [31.404973977937395, 1.341353307355428],
            [31.40761853548886, 1.344470745771466],
            [31.408680495071664, 1.346673851011843],
            [31.408109083905956, 1.352648092708429],
            [31.406049400571366, 1.357302431132548],
            [31.405378472241868, 1.36089249461828],
            [31.404405533008767, 1.36184849838366],
            [31.401672035956, 1.362069394571285],
            [31.40128410568708, 1.362449948983318],
            [31.399404787891875, 1.36233164107643],
            [31.396681766093636, 1.36283312746995],
            [31.391238145253457, 1.360201067682362],
            [31.389903287368814, 1.362157485418367],
            [31.388735792808106, 1.36310739533753],
            [31.38307027821129, 1.359971868738189],
            [31.38151480577098, 1.359467508847879],
            [31.37884737172249, 1.359969011104137],
            [31.378124059933818, 1.361422519916216],
            [31.376678746100172, 1.362372228959377],
            [31.374954277198704, 1.362656149241687],
            [31.371223271091495, 1.361725201715114],
            [31.3649335145088, 1.358916752242785],
            [31.362777956678887, 1.356595125406462],
            [31.35973412313649, 1.358995321047203],
            [31.35878247128071, 1.362893390068314],
            [31.356891014551064, 1.366247434197018],
            [31.35137761617287, 1.370376515192176],
            [31.350327196348214, 1.372307558105646],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 365,
        District: "HOIMA",
        County: "BUHAGUZI",
        Subcounty: "BUHIMBA",
        Population: 39307,
        Key: "HOIMABUHIMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.226130570029888, 1.538793279224146],
            [31.225422375090805, 1.539179710000756],
            [31.223823121458487, 1.539180687913128],
            [31.22154862219339, 1.538273528066908],
            [31.220199271788278, 1.538365581178231],
            [31.219338488116726, 1.539509728013908],
            [31.219125231661515, 1.541439856476939],
            [31.219990741369795, 1.542565489603297],
            [31.219487082041134, 1.543749873978748],
            [31.220960158308646, 1.545994269375445],
            [31.22305257176058, 1.551101376748667],
            [31.223170479234906, 1.552472663076395],
            [31.222415821632683, 1.553244147458024],
            [31.218249509006792, 1.552535050620962],
            [31.21754778553103, 1.553279951026196],
            [31.21689995917569, 1.552853400829882],
            [31.21638392465568, 1.553012712410131],
            [31.215986506380712, 1.553691308127804],
            [31.2122035480057, 1.553315336132641],
            [31.21158266212571, 1.553821489012706],
            [31.211195936497592, 1.556003582378534],
            [31.210421450382107, 1.556755070066461],
            [31.210472933729356, 1.558445788646569],
            [31.212940674086806, 1.565463544609173],
            [31.21047170303743, 1.567691248618184],
            [31.209901549513123, 1.569261619416256],
            [31.208657227436053, 1.570272286645454],
            [31.20587950452522, 1.570016949297269],
            [31.203722842665847, 1.570547576131752],
            [31.203483651848398, 1.571812041663824],
            [31.20396507517884, 1.573456534638328],
            [31.205630310068763, 1.575241836110114],
            [31.20511989540916, 1.576552660360246],
            [31.205674455976787, 1.577751254009903],
            [31.20567311838531, 1.579308799552396],
            [31.204499332922694, 1.580963501052014],
            [31.203354358227855, 1.581712058667528],
            [31.203257269210262, 1.583175595207636],
            [31.199581785275857, 1.58851394696881],
            [31.19501364005369, 1.590477888259941],
            [31.196194142219706, 1.595574802733476],
            [31.195630134070235, 1.597637708423262],
            [31.196008630232047, 1.599718088239648],
            [31.195792546778666, 1.600999204866955],
            [31.19554417877227, 1.601381711712857],
            [31.192980843295558, 1.601762163047144],
            [31.193540959943203, 1.604142228540273],
            [31.192482454382674, 1.604407531759038],
            [31.191754146164378, 1.605255539211715],
            [31.192149986099377, 1.606404073641819],
            [31.19190078086315, 1.607735077731533],
            [31.19107290517544, 1.608982362245708],
            [31.19052926093514, 1.608908476209039],
            [31.189997244487902, 1.609946537872678],
            [31.186887701877417, 1.610925528489764],
            [31.183779210295796, 1.610723053709697],
            [31.18224276596984, 1.611170567458587],
            [31.181859294039675, 1.612751435544203],
            [31.182436051079616, 1.614981746468431],
            [31.181019729473427, 1.616440627618272],
            [31.171441189431583, 1.637648134632405],
            [31.15873307614508, 1.651660676663737],
            [31.142872049586117, 1.666799800790887],
            [31.107918837239637, 1.697113295076544],
            [31.091860105859713, 1.712290587068986],
            [31.075111821379476, 1.727367644037777],
            [31.05236122683444, 1.746471591709318],
            [31.050783110560726, 1.747073581932435],
            [31.03800958824343, 1.76037155414278],
            [31.028802697404284, 1.746783794405856],
            [30.778390581777877, 1.546937077845209],
            [30.889500859159288, 1.54693635137302],
            [30.949779491878353, 1.529165158865867],
            [30.950899583239828, 1.528036619952785],
            [30.951997201447806, 1.52786477317605],
            [30.953850592067287, 1.525880348566691],
            [30.954406041967037, 1.524499531761512],
            [30.956829021070483, 1.522556333837176],
            [30.956863751735995, 1.519052056736724],
            [30.957191795816517, 1.518243157417175],
            [30.959175841902464, 1.516768460545916],
            [30.961186933566694, 1.516167122487194],
            [30.962749898854796, 1.514401223881631],
            [30.96511870775, 1.5147653113813],
            [30.96684071167433, 1.514326251529849],
            [30.97217930508473, 1.514772615724387],
            [30.97386039973105, 1.514051076898616],
            [30.974714473885715, 1.514126996651615],
            [30.976148058416726, 1.512808548463567],
            [30.978617572946842, 1.508881523032719],
            [30.980630656176068, 1.508195749752244],
            [30.982352011516763, 1.506771276842556],
            [30.986571890683038, 1.506262829233881],
            [30.991392078021093, 1.50347361980813],
            [30.993413745551155, 1.503435552434341],
            [30.994683639071066, 1.502000690968398],
            [30.994559220607602, 1.501223610669108],
            [30.995151253498953, 1.500308117534591],
            [30.995223188790295, 1.499268076631028],
            [30.994562490475243, 1.498042304683515],
            [30.99451826102392, 1.496886979040162],
            [30.993767793164185, 1.495433916918548],
            [30.991658656674918, 1.494132686652769],
            [30.990409193539495, 1.490641112895825],
            [30.99171498194153, 1.485645628517992],
            [30.99125290203412, 1.482031344670228],
            [30.98840948622485, 1.479601222835593],
            [30.98755937723384, 1.479356497360752],
            [30.98586246595033, 1.479739882752087],
            [30.98379095090517, 1.476834772181213],
            [30.98237454306069, 1.476408133296992],
            [30.982348786564884, 1.475478475309248],
            [30.9832879850759, 1.474965098438419],
            [30.98347473584033, 1.473083093332011],
            [30.981634903493443, 1.471450223179547],
            [30.980995986629082, 1.470309427967463],
            [30.981663198628254, 1.467199682093229],
            [30.98229019754372, 1.46681990728194],
            [30.98438465645958, 1.462658962992229],
            [30.984520567070508, 1.460916557824108],
            [30.984159524276336, 1.46009182027154],
            [30.984998359410547, 1.458787826742722],
            [30.984848159298423, 1.457081095304608],
            [30.983054137437755, 1.453492613120194],
            [30.98237292788981, 1.451112096953757],
            [30.981633025116178, 1.450222377236905],
            [30.98076832389168, 1.447556126499314],
            [30.982047611992837, 1.443686172214382],
            [30.98220645210138, 1.437918325710633],
            [30.98311820079226, 1.436545614514778],
            [30.983186054138923, 1.433647351437872],
            [30.98258508750207, 1.432915669070712],
            [30.983354833207777, 1.429484479229278],
            [30.982973868475543, 1.426463325248891],
            [30.98480268388379, 1.425519834023109],
            [30.986300242836062, 1.425525979292074],
            [30.989088136472564, 1.426265513755527],
            [30.98897586951991, 1.424967871517878],
            [30.9900437642718, 1.425048641007255],
            [30.990205426886952, 1.424235886441198],
            [30.99158839943653, 1.423042867210509],
            [30.993384904240642, 1.422464625711001],
            [30.9925485242021, 1.41960193777783],
            [30.992613762552978, 1.417829744920302],
            [30.995306512024467, 1.416540014171226],
            [30.997509031980805, 1.417913665882527],
            [30.9981326586207, 1.416661017975444],
            [30.99806415848703, 1.413492149855027],
            [30.99856904760932, 1.413250314333804],
            [30.999409274233898, 1.413917092483113],
            [31.000408398459186, 1.411856570648888],
            [31.001861668671328, 1.410719872094109],
            [31.003462704561187, 1.408168184769784],
            [31.0058564875196, 1.407786372355826],
            [31.007286406924255, 1.406086419985461],
            [31.008579291027246, 1.406200213034278],
            [31.009499374287333, 1.405497019643846],
            [31.010732250031023, 1.40542798063598],
            [31.01155996941191, 1.402800692702437],
            [31.01127144850895, 1.402117901901692],
            [31.01238598738363, 1.400928300954934],
            [31.013041989306387, 1.399420624525132],
            [31.01487122512617, 1.397490614905315],
            [31.018645537216592, 1.395871314203865],
            [31.020770769719153, 1.396681827269534],
            [31.021402588096112, 1.395174062798007],
            [31.022638162378954, 1.388493484976339],
            [31.02391835238866, 1.388887271553404],
            [31.02573930304659, 1.390658694275128],
            [31.026705436643077, 1.390978395810355],
            [31.029237839531294, 1.393470516264048],
            [31.030929046512735, 1.39381692181778],
            [31.034980381968797, 1.392624633293549],
            [31.036892879937326, 1.391291466097716],
            [31.038033365750664, 1.389298288973495],
            [31.041276851661603, 1.387263199878011],
            [31.04417949519417, 1.386322859336691],
            [31.044927817876996, 1.386763610812071],
            [31.048598682674232, 1.393630642098629],
            [31.051253509766017, 1.395441291623609],
            [31.05336831103145, 1.395533370368691],
            [31.059630321349996, 1.394823045961851],
            [31.06305271393627, 1.393872173414006],
            [31.06551707034001, 1.394391533326248],
            [31.067378925784404, 1.394105320515626],
            [31.068415444180047, 1.395399347352647],
            [31.0712888340754, 1.396772360424797],
            [31.072554635769198, 1.398225439944392],
            [31.07606157419676, 1.39731134833522],
            [31.08058211769203, 1.397131097490554],
            [31.082828963219413, 1.397649752613364],
            [31.088617020597383, 1.400443380793114],
            [31.090969625681513, 1.402630438431185],
            [31.092411383084947, 1.402830679358027],
            [31.094631242322897, 1.402334872575717],
            [31.09714699224239, 1.39973038707899],
            [31.097785126674108, 1.39962067713641],
            [31.105851010677025, 1.401854053185062],
            [31.107511210509788, 1.403619750074238],
            [31.11097881260938, 1.409568635456619],
            [31.112753038296113, 1.41621065051676],
            [31.11457322538607, 1.420882881303706],
            [31.11673383623942, 1.422119307448837],
            [31.11906493924889, 1.421512085107232],
            [31.121536024034132, 1.420318516664379],
            [31.124337086972684, 1.420411359556266],
            [31.126134175681745, 1.421167420474931],
            [31.12822027038396, 1.426585194240558],
            [31.128907342337467, 1.429437555066631],
            [31.12968441021104, 1.435489631698185],
            [31.129535394078463, 1.440155562213926],
            [31.131179797036967, 1.442801448920477],
            [31.130398239383588, 1.44503432697821],
            [31.12859052090978, 1.4472359595236],
            [31.12818410061736, 1.449148710516463],
            [31.127015666418895, 1.450737659995151],
            [31.124933574609543, 1.451597141144412],
            [31.122158960767894, 1.452063180289654],
            [31.12207369986765, 1.452985005523915],
            [31.122293037917313, 1.454131359341666],
            [31.124188217265495, 1.456247158772747],
            [31.12451555437187, 1.458707159029213],
            [31.127008401743193, 1.460224128780928],
            [31.129067696107246, 1.463374337550494],
            [31.12906040448207, 1.466643600623602],
            [31.130876794393295, 1.472992458128905],
            [31.131651335306014, 1.473917081069773],
            [31.137147704321354, 1.477826108966939],
            [31.137188316257035, 1.479048732035132],
            [31.135150174522977, 1.479609705492505],
            [31.13133148655584, 1.481823982270648],
            [31.131848702360468, 1.483091813667227],
            [31.133927534183616, 1.48370981089523],
            [31.13416388183319, 1.484605618396521],
            [31.133859342172084, 1.485128557777646],
            [31.131560203915367, 1.486125270848724],
            [31.131038777707015, 1.486734812437367],
            [31.131295961779593, 1.488001803171533],
            [31.13194553445986, 1.488222214905826],
            [31.13159618593407, 1.489399908291084],
            [31.1322888085777, 1.489751443957943],
            [31.132113590384915, 1.4905804261905],
            [31.13072335405795, 1.492104012302124],
            [31.131415874293612, 1.492499207911312],
            [31.130591477780985, 1.492933122961981],
            [31.13132724291442, 1.493372126052612],
            [31.13076326081614, 1.493632249948567],
            [31.13093494234165, 1.494375035253579],
            [31.130630591326774, 1.494810645375909],
            [31.127765686019266, 1.496853339632876],
            [31.126337312615256, 1.496062796350812],
            [31.12555625083191, 1.496496854378784],
            [31.1249932568804, 1.496320375868588],
            [31.12322743044156, 1.498532910785521],
            [31.122027948670244, 1.498951746192684],
            [31.120317118889737, 1.498913105811124],
            [31.119108942324782, 1.500309791420249],
            [31.11462582803414, 1.502518186985088],
            [31.116427438862324, 1.503801786207842],
            [31.11742586509664, 1.505990766066992],
            [31.11777174792209, 1.507538554346346],
            [31.117175735494, 1.508453213793066],
            [31.117306730523673, 1.509934255324322],
            [31.115157421374875, 1.509799260270542],
            [31.114249845358508, 1.507718516207083],
            [31.113423706114215, 1.507068850425249],
            [31.111621515872677, 1.507050635300962],
            [31.109719652160486, 1.508165187081134],
            [31.109914385354518, 1.511824696160007],
            [31.112203659211076, 1.51261708541148],
            [31.112944965153208, 1.515762617996731],
            [31.115001455875248, 1.518069010081468],
            [31.11681913846217, 1.519301939474789],
            [31.116630821035905, 1.52230664723955],
            [31.119355084305866, 1.521658677660746],
            [31.12062948377529, 1.520195508041612],
            [31.119903797739322, 1.51809827320704],
            [31.12046702345615, 1.516867431876432],
            [31.121666474684734, 1.5160281793116],
            [31.122215028218037, 1.512634164516286],
            [31.12288492617993, 1.512326914821793],
            [31.12369650103855, 1.510696932140869],
            [31.124539885241354, 1.510934478180177],
            [31.125052469332342, 1.51049843574207],
            [31.126457927611803, 1.510433099727359],
            [31.127465610985137, 1.51148227876859],
            [31.127944029450955, 1.512730674611618],
            [31.130323651367227, 1.514246961583894],
            [31.13179333829119, 1.516411410116376],
            [31.132630985852593, 1.516393076534383],
            [31.13384415615222, 1.515747601624799],
            [31.13384471220936, 1.515098650360024],
            [31.133184114505614, 1.514199528241978],
            [31.133945985579565, 1.51268596936728],
            [31.136905756574315, 1.512522136039107],
            [31.137812538479977, 1.512903344265083],
            [31.13905548074474, 1.512207837907724],
            [31.139931513318253, 1.512541391902184],
            [31.14039465683096, 1.51232547442599],
            [31.140759389904304, 1.511177640303329],
            [31.141949363008347, 1.511761061900138],
            [31.14297458778424, 1.511645467409336],
            [31.14363648445189, 1.511030362443051],
            [31.14530681817937, 1.510599162954837],
            [31.14563818243317, 1.509800732996122],
            [31.146613565982136, 1.509967971758333],
            [31.147358414879754, 1.509020136200543],
            [31.1485159731751, 1.508838091078594],
            [31.151535230607948, 1.50543563906741],
            [31.157058099025868, 1.504974433416221],
            [31.158547186865004, 1.50379426002044],
            [31.15962206242498, 1.503628773691886],
            [31.16102240210394, 1.501776991218803],
            [31.162063954658407, 1.501328369463539],
            [31.16328939235156, 1.499066358935919],
            [31.165802982721097, 1.498635841364451],
            [31.166619814520732, 1.496744455171973],
            [31.168258016408842, 1.497405526038029],
            [31.169178648539585, 1.496911533292757],
            [31.169632215113033, 1.49720370220641],
            [31.170842591652146, 1.496938306524559],
            [31.17154977149495, 1.497472374689083],
            [31.172008790842177, 1.49674264837828],
            [31.17416440436764, 1.496719085525531],
            [31.175980273256016, 1.495959425626572],
            [31.17679309138295, 1.496270924310502],
            [31.177676401208554, 1.495180632475794],
            [31.180550857404167, 1.494789756774975],
            [31.183749473364944, 1.491107010978248],
            [31.18533821760679, 1.490613560113471],
            [31.18833202217437, 1.490723880798203],
            [31.19263046440214, 1.493156130350316],
            [31.204011719301658, 1.501982549438345],
            [31.205671143888324, 1.50280263409198],
            [31.209870911572054, 1.502905952408671],
            [31.215765027645734, 1.501662142441825],
            [31.219619562884276, 1.503313361646762],
            [31.220029035652033, 1.504045884849679],
            [31.223038222072244, 1.504268013754847],
            [31.22523337853817, 1.505121816752954],
            [31.226515449620106, 1.506414182562791],
            [31.226653562001786, 1.507379453113449],
            [31.227380434712217, 1.508205426644187],
            [31.2272998998487, 1.509643113634434],
            [31.225902592882143, 1.511791936127576],
            [31.226581882730322, 1.51419540551663],
            [31.2260389885833, 1.514860583037955],
            [31.226209911930727, 1.51613872590625],
            [31.224786104663263, 1.518327457158117],
            [31.22500786816422, 1.530182427533137],
            [31.225454331758716, 1.534176553551583],
            [31.225465601123975, 1.536546189444738],
            [31.22502818985256, 1.537610823673319],
            [31.226130570029888, 1.538793279224146],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 366,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "BUSERUKA",
        Population: 42505,
        Key: "HOIMABUSERUKA",
        Dist2: "Hoima",
        "Sub Country": "Buseruka",
        id2_original: "Hoima Buseruka",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.088617020597383, 1.400443380793114],
            [31.082828963219413, 1.397649752613364],
            [31.08058211769203, 1.397131097490554],
            [31.07606157419676, 1.39731134833522],
            [31.072554635769198, 1.398225439944392],
            [31.0712888340754, 1.396772360424797],
            [31.068415444180047, 1.395399347352647],
            [31.067378925784404, 1.394105320515626],
            [31.06551707034001, 1.394391533326248],
            [31.06305271393627, 1.393872173414006],
            [31.059630321349996, 1.394823045961851],
            [31.05336831103145, 1.395533370368691],
            [31.051253509766017, 1.395441291623609],
            [31.048598682674232, 1.393630642098629],
            [31.044927817876996, 1.386763610812071],
            [31.04417949519417, 1.386322859336691],
            [31.041276851661603, 1.387263199878011],
            [31.038033365750664, 1.389298288973495],
            [31.036892879937326, 1.391291466097716],
            [31.034980381968797, 1.392624633293549],
            [31.030929046512735, 1.39381692181778],
            [31.029237839531294, 1.393470516264048],
            [31.026705436643077, 1.390978395810355],
            [31.02573930304659, 1.390658694275128],
            [31.02391835238866, 1.388887271553404],
            [31.022638162378954, 1.388493484976339],
            [31.021402588096112, 1.395174062798007],
            [31.020770769719153, 1.396681827269534],
            [31.018645537216592, 1.395871314203865],
            [31.01487122512617, 1.397490614905315],
            [31.013041989306387, 1.399420624525132],
            [31.01238598738363, 1.400928300954934],
            [31.01127144850895, 1.402117901901692],
            [31.01155996941191, 1.402800692702437],
            [31.010732250031023, 1.40542798063598],
            [31.009499374287333, 1.405497019643846],
            [31.008579291027246, 1.406200213034278],
            [31.007286406924255, 1.406086419985461],
            [31.0058564875196, 1.407786372355826],
            [31.003462704561187, 1.408168184769784],
            [31.001861668671328, 1.410719872094109],
            [31.000408398459186, 1.411856570648888],
            [30.999409274233898, 1.413917092483113],
            [30.99856904760932, 1.413250314333804],
            [30.99806415848703, 1.413492149855027],
            [30.9981326586207, 1.416661017975444],
            [30.997509031980805, 1.417913665882527],
            [30.995306512024467, 1.416540014171226],
            [30.992613762552978, 1.417829744920302],
            [30.9925485242021, 1.41960193777783],
            [30.993384904240642, 1.422464625711001],
            [30.99158839943653, 1.423042867210509],
            [30.990205426886952, 1.424235886441198],
            [30.9900437642718, 1.425048641007255],
            [30.98897586951991, 1.424967871517878],
            [30.989088136472564, 1.426265513755527],
            [30.986300242836062, 1.425525979292074],
            [30.98480268388379, 1.425519834023109],
            [30.982973868475543, 1.426463325248891],
            [30.983354833207777, 1.429484479229278],
            [30.98258508750207, 1.432915669070712],
            [30.983186054138923, 1.433647351437872],
            [30.98311820079226, 1.436545614514778],
            [30.98220645210138, 1.437918325710633],
            [30.982047611992837, 1.443686172214382],
            [30.98076832389168, 1.447556126499314],
            [30.981633025116178, 1.450222377236905],
            [30.98237292788981, 1.451112096953757],
            [30.983054137437755, 1.453492613120194],
            [30.984848159298423, 1.457081095304608],
            [30.984998359410547, 1.458787826742722],
            [30.984159524276336, 1.46009182027154],
            [30.984520567070508, 1.460916557824108],
            [30.98438465645958, 1.462658962992229],
            [30.98229019754372, 1.46681990728194],
            [30.981663198628254, 1.467199682093229],
            [30.980995986629082, 1.470309427967463],
            [30.981634903493443, 1.471450223179547],
            [30.98347473584033, 1.473083093332011],
            [30.9832879850759, 1.474965098438419],
            [30.982348786564884, 1.475478475309248],
            [30.98237454306069, 1.476408133296992],
            [30.98379095090517, 1.476834772181213],
            [30.98586246595033, 1.479739882752087],
            [30.98755937723384, 1.479356497360752],
            [30.98840948622485, 1.479601222835593],
            [30.99125290203412, 1.482031344670228],
            [30.99171498194153, 1.485645628517992],
            [30.990409193539495, 1.490641112895825],
            [30.991658656674918, 1.494132686652769],
            [30.993767793164185, 1.495433916918548],
            [30.99451826102392, 1.496886979040162],
            [30.994562490475243, 1.498042304683515],
            [30.995223188790295, 1.499268076631028],
            [30.995151253498953, 1.500308117534591],
            [30.994559220607602, 1.501223610669108],
            [30.994683639071066, 1.502000690968398],
            [30.993413745551155, 1.503435552434341],
            [30.991392078021093, 1.50347361980813],
            [30.986571890683038, 1.506262829233881],
            [30.982352011516763, 1.506771276842556],
            [30.980630656176068, 1.508195749752244],
            [30.978617572946842, 1.508881523032719],
            [30.976148058416726, 1.512808548463567],
            [30.974714473885715, 1.514126996651615],
            [30.97386039973105, 1.514051076898616],
            [30.97217930508473, 1.514772615724387],
            [30.96684071167433, 1.514326251529849],
            [30.96511870775, 1.5147653113813],
            [30.962749898854796, 1.514401223881631],
            [30.961186933566694, 1.516167122487194],
            [30.959175841902464, 1.516768460545916],
            [30.957191795816517, 1.518243157417175],
            [30.956863751735995, 1.519052056736724],
            [30.956829021070483, 1.522556333837176],
            [30.954406041967037, 1.524499531761512],
            [30.953850592067287, 1.525880348566691],
            [30.951997201447806, 1.52786477317605],
            [30.950899583239828, 1.528036619952785],
            [30.949779491878353, 1.529165158865867],
            [30.889500859159288, 1.54693635137302],
            [30.778390581777877, 1.546937077845209],
            [30.75797784197996, 1.530533311844041],
            [30.68339897137214, 1.453717569581496],
            [30.637714136095212, 1.406097871852594],
            [30.62266585489969, 1.389601752133083],
            [30.645835036519397, 1.387860637865858],
            [30.751623739073445, 1.384571034272797],
            [30.77409122147188, 1.385181992226432],
            [30.838126543132105, 1.385202195719591],
            [30.846368752950532, 1.384448206661974],
            [30.858783764824476, 1.382128947599147],
            [30.877323502881985, 1.381174576515641],
            [30.89294298593576, 1.376014767663987],
            [30.89566860206855, 1.376358737546853],
            [30.898866140949316, 1.377867747931],
            [30.900485009295853, 1.377764079989559],
            [30.901186562091738, 1.37825873972718],
            [30.902727566266094, 1.378434810664592],
            [30.901519665483914, 1.374184309225349],
            [30.90000589912731, 1.370813608236376],
            [30.899100528474918, 1.365824016877456],
            [30.899220591007587, 1.364756987478914],
            [30.898779064553867, 1.364324593780941],
            [30.89880606341973, 1.363170973570385],
            [30.89943958230757, 1.362509830813257],
            [30.900539698730384, 1.362225349225326],
            [30.90086896721462, 1.361360173777892],
            [30.89876189415555, 1.357947747854348],
            [30.899118866683132, 1.35691429266186],
            [30.89894592122801, 1.356178373616471],
            [30.896852514239345, 1.355229577265243],
            [30.896403025118957, 1.354121351662438],
            [30.89665063494724, 1.350650236819311],
            [30.89738043706384, 1.348921521701239],
            [30.898398681929958, 1.348072119634536],
            [30.899422787405, 1.345955997980239],
            [30.898385268286166, 1.344580951282737],
            [30.897458765665053, 1.340491765246551],
            [30.896583667339453, 1.340302824900391],
            [30.896225916870815, 1.33933746195581],
            [30.89463275561274, 1.33834383905529],
            [30.893589896907827, 1.336180416563596],
            [30.893541655580435, 1.335193984140611],
            [30.897029987203513, 1.333415789596206],
            [30.897859798760713, 1.332491677797122],
            [30.898194974566255, 1.331373264022469],
            [30.8971706040882, 1.329435489845231],
            [30.895921989860728, 1.324888510010982],
            [30.89617965992187, 1.31589982772032],
            [30.898033825787444, 1.312845503504904],
            [30.898487600770054, 1.309702846638156],
            [30.899464119789553, 1.307585620725276],
            [30.902436620810203, 1.3054999507339],
            [30.902478130162848, 1.304740793732687],
            [30.903863220939847, 1.303449308733635],
            [30.904752871973063, 1.304032684417623],
            [30.905068477980137, 1.305785336064596],
            [30.90548527111914, 1.306259383217023],
            [30.907733812665775, 1.307690245405398],
            [30.90946419877002, 1.307898723300725],
            [30.91186712478139, 1.308826382683113],
            [30.913343738614508, 1.30870530251304],
            [30.914736906144242, 1.30910313258866],
            [30.915616614623882, 1.309095084886419],
            [30.91684733171598, 1.308306800609653],
            [30.917651722747244, 1.307452462198496],
            [30.918798062881304, 1.304170761025759],
            [30.92038898913096, 1.302208297149256],
            [30.922585900904952, 1.301779909592119],
            [30.92525261540286, 1.300573985322632],
            [30.92650173448353, 1.298997834181713],
            [30.93394952277374, 1.292566194418063],
            [30.946376264848656, 1.280575348110937],
            [30.94936896808173, 1.276603719340145],
            [30.954996809132144, 1.262585256858625],
            [30.95839545924549, 1.250373951750699],
            [30.95872029364549, 1.24623912925389],
            [30.95838145271358, 1.24539592285843],
            [30.959118778220677, 1.242221597162323],
            [30.959191345027644, 1.238595591629228],
            [30.958047147375527, 1.235348133047766],
            [30.95633611367745, 1.232088517305205],
            [30.955892957679797, 1.229329374881183],
            [30.95645066863911, 1.226557941672394],
            [30.957623690533755, 1.223871926666601],
            [30.95738115708514, 1.2197820152248],
            [30.957885244910184, 1.219049448746127],
            [30.960219869315576, 1.217559794026573],
            [30.959922032883117, 1.214995967332301],
            [30.960243505787336, 1.213738437758481],
            [30.962023074653374, 1.21215114341511],
            [30.963565791016666, 1.211882418634417],
            [30.962932600912232, 1.210026735031599],
            [30.964165276331638, 1.207157557077992],
            [30.964686651336017, 1.204349483068976],
            [30.964273022063434, 1.203250724911712],
            [30.96118262973817, 1.202274303392785],
            [30.960215552910622, 1.201566284926755],
            [30.95980984228728, 1.199210030669876],
            [30.959204630212383, 1.198526397130876],
            [30.95833181360761, 1.193484254129275],
            [30.958567208144654, 1.191726168510115],
            [30.960081434438703, 1.190138875742115],
            [30.96007845652353, 1.189235424647952],
            [30.959232055777996, 1.188551817368573],
            [30.957207163296065, 1.188869448976529],
            [30.95645868250978, 1.188625343922182],
            [30.956391339406174, 1.186488823157045],
            [30.95433709986223, 1.185219319272538],
            [30.953969931456154, 1.179932971594222],
            [30.949120723144535, 1.179493950193585],
            [30.9476426621255, 1.177418626963882],
            [30.94771599519542, 1.174061233813159],
            [30.94732687915029, 1.173084573852777],
            [30.941502731057465, 1.169544679459492],
            [30.93815792596227, 1.168189870793308],
            [30.93834158831874, 1.165381870401361],
            [30.937540203948725, 1.163721576993555],
            [30.937631105370613, 1.162036778014984],
            [30.937109951351815, 1.161243281370629],
            [30.93339241548228, 1.160218163683652],
            [30.929379589005862, 1.157410628677335],
            [30.927235374203033, 1.158094536357552],
            [30.92577387901617, 1.157374389050712],
            [30.925233682509933, 1.154468823613505],
            [30.924579848221974, 1.153663125507766],
            [30.922865962372875, 1.153199390563918],
            [30.920714010380518, 1.151539268746104],
            [30.917768348325616, 1.146888170989493],
            [30.91719225603899, 1.144068076782098],
            [30.91533537636296, 1.144117117712915],
            [30.91511735254855, 1.1438241456726],
            [30.91494085245984, 1.141504556900028],
            [30.914289761626748, 1.141529049096101],
            [30.912870640870132, 1.142676805083148],
            [30.912094850400894, 1.141456051214231],
            [30.91018497281803, 1.140064505217097],
            [30.908668309394624, 1.137244533646062],
            [30.908615950189965, 1.13599928882498],
            [30.910346886961467, 1.134338750200092],
            [30.911069751389125, 1.134143326770958],
            [30.912759256063097, 1.134533801786405],
            [30.913358540155446, 1.133434966015238],
            [30.913552563680405, 1.130126466025504],
            [30.906371650488094, 1.123541564246068],
            [30.909277248579613, 1.121610239131584],
            [30.912429933679935, 1.1213205044185],
            [30.914696423565978, 1.119676787734391],
            [30.91607429548137, 1.120093325225253],
            [30.918021631913263, 1.1200273359174],
            [30.9197412813532, 1.11843937080605],
            [30.921043892414104, 1.118240325891506],
            [30.921555692275856, 1.118866401489161],
            [30.921460524754686, 1.119742691726474],
            [30.92246086799381, 1.119759645985793],
            [30.9226850156235, 1.120205336308086],
            [30.922153538165457, 1.12084741101272],
            [30.92274195264283, 1.121562330378381],
            [30.922692300960463, 1.123324181401946],
            [30.925870817116788, 1.123383295353702],
            [30.929655433781807, 1.121973240734821],
            [30.933116271567325, 1.122105620731224],
            [30.940247138716845, 1.123206813017451],
            [30.94241628356542, 1.124645488139778],
            [30.943157191553873, 1.124608182903692],
            [30.94423634578955, 1.125565908647152],
            [30.94747030506687, 1.126469575827452],
            [30.94963610009777, 1.126387815295408],
            [30.94971949879043, 1.125485464765904],
            [30.95056098305641, 1.125458294174742],
            [30.950809682541138, 1.124889257404149],
            [30.951264882251806, 1.124917347698218],
            [30.952064090003887, 1.12616740592556],
            [30.954256741068477, 1.127140790253322],
            [30.955043584409005, 1.126349999937115],
            [30.9556091421523, 1.126378166559144],
            [30.956545347476794, 1.128250171685905],
            [30.961152528091326, 1.129297588166083],
            [30.96185572390583, 1.129770118863407],
            [30.962462814357995, 1.129590065008417],
            [30.96345550395091, 1.130340468659381],
            [30.96453151587971, 1.130299579915716],
            [30.965785083417643, 1.132799474754867],
            [30.966460615613, 1.133383055346837],
            [30.96939848837607, 1.133954354663675],
            [30.970088476260944, 1.133593874734103],
            [30.970959305792338, 1.131067708181258],
            [30.972630194678665, 1.128583750261396],
            [30.973416714625674, 1.128264985625552],
            [30.97421690513467, 1.128126713204475],
            [30.977515317635337, 1.131665730316022],
            [30.979596795895343, 1.132187805618059],
            [30.979913061265854, 1.132665711211318],
            [30.985153837124983, 1.132632741398752],
            [30.989039235781735, 1.130871330706553],
            [30.990612689799107, 1.131072900330049],
            [30.99174849628817, 1.130452236850785],
            [30.99302305835263, 1.130813971873029],
            [30.996111846286784, 1.128851513929636],
            [30.9985336881231, 1.128452165413834],
            [31.001620058690825, 1.134853095635429],
            [31.003645754266632, 1.135611625182041],
            [31.003355706227712, 1.136671849151638],
            [31.00394702585673, 1.136683958753216],
            [31.003981698131767, 1.137288308908188],
            [31.00477579626649, 1.13724823038346],
            [31.005352012520678, 1.1377570625287],
            [31.00731952601214, 1.136753091167901],
            [31.01093182783936, 1.136545135276646],
            [31.013391408799077, 1.1371989630047],
            [31.016735094593457, 1.136852004954219],
            [31.019025369173253, 1.137142080309897],
            [31.020406097731247, 1.136595909743045],
            [31.022479991515286, 1.136782084874439],
            [31.02399012598322, 1.135977632904031],
            [31.027306719486937, 1.137413541720555],
            [31.02996817345055, 1.137286057275442],
            [31.031396466006193, 1.13792985712349],
            [31.03218366238461, 1.137119324177987],
            [31.033273599996946, 1.137340659594226],
            [31.0366785931145, 1.136770859041577],
            [31.037017175331616, 1.136322077169528],
            [31.039375063407906, 1.136777856438464],
            [31.039864473659506, 1.137493634997106],
            [31.0419293654261, 1.137650555014852],
            [31.043912031699808, 1.140418870717736],
            [31.04653161698466, 1.141743190994861],
            [31.046969146833693, 1.143681491988949],
            [31.046510516456937, 1.144224423430404],
            [31.047188405831573, 1.145060249473378],
            [31.047827615546726, 1.145230943787696],
            [31.048452623795562, 1.14647006830948],
            [31.04909214432777, 1.146617014941596],
            [31.04955528424725, 1.147522581377726],
            [31.04998352551623, 1.147478090457814],
            [31.050333017772452, 1.149783827855978],
            [31.04991080689399, 1.150267646535844],
            [31.050279231144806, 1.151148807718381],
            [31.04995998336756, 1.15193016351895],
            [31.051121284044385, 1.153932904946192],
            [31.052045571419985, 1.154105596178007],
            [31.05253656360484, 1.154702664189287],
            [31.05267792159963, 1.156579539410658],
            [31.053902247178446, 1.158309650588329],
            [31.055149029741067, 1.159244451075846],
            [31.056878834635324, 1.159589004805371],
            [31.057135097934747, 1.159970722263858],
            [31.05813445572202, 1.159858999231925],
            [31.05833784238719, 1.160644025093372],
            [31.05997230638537, 1.161011651634428],
            [31.060786978635086, 1.160494954207639],
            [31.0616387378313, 1.160762123027777],
            [31.06401336870783, 1.159069082826774],
            [31.065588246554938, 1.158557703780915],
            [31.067050889788757, 1.155765974262462],
            [31.068231462921673, 1.156320380638536],
            [31.068334059510274, 1.155751207167436],
            [31.0694477791214, 1.155972710890249],
            [31.071012157459467, 1.154463944955421],
            [31.07104474743967, 1.153799297764307],
            [31.07158673249159, 1.154135525563619],
            [31.072969359189784, 1.153789011445352],
            [31.073865072952845, 1.152536762979814],
            [31.076269813561087, 1.151259438962075],
            [31.076759139371088, 1.15019430578938],
            [31.07848097710709, 1.149351498250098],
            [31.080001824883116, 1.145752784015725],
            [31.083108115592278, 1.143530517064713],
            [31.0832845069848, 1.142771887215208],
            [31.084345562862424, 1.141592011193503],
            [31.085666836423357, 1.142308472037908],
            [31.08721231151287, 1.144179636972449],
            [31.088023902541174, 1.147196018530282],
            [31.090548746106283, 1.150048306872865],
            [31.09198077385689, 1.150174864774626],
            [31.092337270277383, 1.150888519497066],
            [31.09464808034459, 1.15167343646952],
            [31.097305720061485, 1.150447939797749],
            [31.102264057510467, 1.154703106968789],
            [31.104941488909713, 1.154877054641645],
            [31.105482072589833, 1.157367645875539],
            [31.105012353409244, 1.163217772720993],
            [31.106388011875755, 1.167869739131397],
            [31.107333878581127, 1.168208803343598],
            [31.114584909772947, 1.167879551187157],
            [31.11842609963965, 1.169366788110925],
            [31.11910087635184, 1.170440088824484],
            [31.118924590960468, 1.172979702254561],
            [31.11709709158414, 1.177300613255764],
            [31.1160559720176, 1.181009529337349],
            [31.117148918087814, 1.18248672632675],
            [31.118892952296168, 1.183919063955269],
            [31.12629054632156, 1.187255250409877],
            [31.130277982814818, 1.192044290126399],
            [31.1527237753907, 1.190823946565921],
            [31.15760548474931, 1.189112672951789],
            [31.162578437787932, 1.188196646913885],
            [31.169199416690617, 1.183378154646548],
            [31.174601674603544, 1.181065969273782],
            [31.182398693740218, 1.180841460608647],
            [31.186029958104807, 1.182298401397961],
            [31.191159796517915, 1.185751441885358],
            [31.20000044511402, 1.190801589633073],
            [31.202353957496552, 1.192504056124976],
            [31.20562500821196, 1.195792127112756],
            [31.208700070786918, 1.20042056664507],
            [31.214456150835748, 1.214305498626345],
            [31.216763177198946, 1.21682696200041],
            [31.220568540455467, 1.217826359180436],
            [31.220604279030724, 1.221044477999552],
            [31.221726690740567, 1.225991818319431],
            [31.2220012617055, 1.22947275880081],
            [31.22124233261411, 1.231153534149874],
            [31.221024890009687, 1.234108593122536],
            [31.218710767854052, 1.234804850413488],
            [31.214488441676945, 1.237838767986317],
            [31.208818497487442, 1.244735845750404],
            [31.203229593014687, 1.245750091580936],
            [31.18740455116939, 1.243304933288836],
            [31.177722898007687, 1.242988976763089],
            [31.17381807957108, 1.242482578135861],
            [31.172895979593214, 1.244639101162379],
            [31.17137358851151, 1.246551933947883],
            [31.170283457761435, 1.251096896320164],
            [31.168613026117566, 1.254137529106882],
            [31.16517032172439, 1.255887249331523],
            [31.16095967634091, 1.260135489973516],
            [31.15823733995722, 1.262222745293919],
            [31.15723550551468, 1.263840325814834],
            [31.157604875691543, 1.266230603824251],
            [31.156627756597445, 1.269273357307693],
            [31.15656887562383, 1.270893870196072],
            [31.157436800901877, 1.27359307594598],
            [31.159095288545732, 1.276224907566802],
            [31.15920351038463, 1.27751062177921],
            [31.15801685475893, 1.281265259669685],
            [31.157901191276213, 1.28350034954803],
            [31.160177029929383, 1.289277714911343],
            [31.160368326169152, 1.290619577272653],
            [31.159807951705012, 1.293300363127799],
            [31.15842967015785, 1.295852838469713],
            [31.15708986974251, 1.299872441627919],
            [31.156912259336124, 1.302344957580167],
            [31.15443669375426, 1.302001763132724],
            [31.150308937718655, 1.299809252429023],
            [31.144474857852018, 1.297932734570936],
            [31.141821269537033, 1.293760925164274],
            [31.1378870366648, 1.291876405360965],
            [31.134946583940234, 1.292174543267178],
            [31.1322938032107, 1.294136174323095],
            [31.130436167153178, 1.293878851972879],
            [31.12369252150184, 1.289400809525303],
            [31.11519227780455, 1.282835554580348],
            [31.113781039764536, 1.281350176836544],
            [31.111640612258974, 1.283662664922504],
            [31.11222765051736, 1.287981598666052],
            [31.110161914334427, 1.294262118328918],
            [31.110027924321564, 1.298550842257691],
            [31.110580248982448, 1.299642328219775],
            [31.111965609254042, 1.300261428769148],
            [31.1125187864161, 1.300961735694498],
            [31.112969220564203, 1.304302263662211],
            [31.114794182199873, 1.306850785302689],
            [31.114790457784704, 1.308583199422839],
            [31.11746132968575, 1.311120423359356],
            [31.117571185560163, 1.311623728049078],
            [31.11490645454237, 1.319117841633223],
            [31.112039934064022, 1.330132015778312],
            [31.10723146345221, 1.341363518401315],
            [31.098817304410307, 1.365352993310649],
            [31.0965101971987, 1.380350509182937],
            [31.090241674992694, 1.393183710628696],
            [31.08929266059059, 1.395918962871665],
            [31.088617020597383, 1.400443380793114],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 367,
        District: "HOIMA",
        County: "BUHAGUZI",
        Subcounty: "KABWOYA",
        Population: 66830,
        Key: "HOIMAKABWOYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.221548588057406, 1.538273571170496],
            [31.22382315110289, 1.53918068252519],
            [31.225422432582988, 1.539179700122853],
            [31.22709091308606, 1.538637677975358],
            [31.228241318096785, 1.539304156306601],
            [31.22864654273156, 1.540382025541143],
            [31.229299084343836, 1.539850948412233],
            [31.229959907524716, 1.540530334978998],
            [31.233260935021164, 1.539807592514061],
            [31.236514661726346, 1.540422716191421],
            [31.237347287705315, 1.541315374376213],
            [31.237881363989494, 1.543292775856512],
            [31.238807190179188, 1.543519799246035],
            [31.239295789252107, 1.544571990149626],
            [31.243031939112633, 1.54562011084855],
            [31.24433996970962, 1.547431661679105],
            [31.24619134181465, 1.548271981321264],
            [31.24693118889276, 1.54941747609131],
            [31.248623670583584, 1.550270844485492],
            [31.25094988585958, 1.552669028259626],
            [31.251572390503704, 1.551587656832547],
            [31.256044036003104, 1.551345481690566],
            [31.256683944607524, 1.550041436765956],
            [31.258261190413716, 1.551025994404168],
            [31.25948275816461, 1.550686584345598],
            [31.260769033362063, 1.551377752613923],
            [31.262780277739893, 1.550282910729732],
            [31.264452126026953, 1.550473312588629],
            [31.265090070914184, 1.551551597309741],
            [31.265728997660016, 1.551306334887632],
            [31.26776705046086, 1.551846810164541],
            [31.26953209895865, 1.55307719044853],
            [31.27050761366166, 1.554798655375643],
            [31.27154165899532, 1.554024284540338],
            [31.274331769673925, 1.553752363026679],
            [31.27604221856876, 1.552770612862148],
            [31.277676871213167, 1.552639703646302],
            [31.28028774014482, 1.553398080077787],
            [31.282494368096952, 1.554600537524362],
            [31.283470583485865, 1.555603333792194],
            [31.284653833598334, 1.556001393093449],
            [31.2868690224951, 1.558158658562871],
            [31.288248357766093, 1.560097739973989],
            [31.288603613613198, 1.562215714559951],
            [31.29175726170751, 1.565564901405333],
            [31.296429483941854, 1.573056145705681],
            [31.299742441963584, 1.576868754802354],
            [31.302315133393996, 1.578364444036559],
            [31.308880695226804, 1.579513851017236],
            [31.316639893493385, 1.580030607127083],
            [31.324668305172512, 1.584490024298215],
            [31.32628372847995, 1.584945043621479],
            [31.32703592739322, 1.584227227446033],
            [31.327883150995554, 1.581921121140041],
            [31.33963171174337, 1.574688919112164],
            [31.343352561497962, 1.573841033801716],
            [31.347288305336512, 1.574345303165301],
            [31.351063054008154, 1.576716941330889],
            [31.355394337744407, 1.578471359565985],
            [31.362414951964162, 1.587591953315548],
            [31.367250133980935, 1.588342599907751],
            [31.369228111947155, 1.589305392480278],
            [31.37029261555884, 1.59134041533388],
            [31.377648834978853, 1.596659190065361],
            [31.377938121246437, 1.597706583318245],
            [31.377839868012238, 1.603328404304181],
            [31.37448718648862, 1.60429567967478],
            [31.372888185282893, 1.609384037267996],
            [31.372529560753478, 1.609915938964425],
            [31.370106496310076, 1.61090958789941],
            [31.36782702127662, 1.6137144492239],
            [31.36770673057186, 1.614933148058308],
            [31.368737267086026, 1.616813667993059],
            [31.374132071677035, 1.621839138298961],
            [31.374651129027974, 1.623410138530622],
            [31.37497255791474, 1.626671956422447],
            [31.373306463337055, 1.630335602439252],
            [31.373977813874752, 1.633262922651357],
            [31.375323602459776, 1.635650206596549],
            [31.37548473776387, 1.636723115600091],
            [31.373314885042845, 1.641047154567444],
            [31.37304904031262, 1.642806568392289],
            [31.375067301431116, 1.646661980460677],
            [31.376573102426118, 1.651426831883851],
            [31.378882053879, 1.65442413274815],
            [31.379341457705188, 1.655969432614796],
            [31.379866550836525, 1.660381680935382],
            [31.378473180287543, 1.664251369276383],
            [31.38081399318691, 1.670098469805064],
            [31.38044287668515, 1.675376629153436],
            [31.380790412410697, 1.678029171999108],
            [31.383739693777873, 1.680280309181379],
            [31.38430857977931, 1.683259046351096],
            [31.385645946658546, 1.685517614128483],
            [31.38591642400071, 1.688487644191681],
            [31.386700484360464, 1.689226327634471],
            [31.388243902307988, 1.689648212213011],
            [31.388704008616735, 1.690283773986726],
            [31.38945873359258, 1.695631608629138],
            [31.390402526087954, 1.699246021167599],
            [31.390400701609618, 1.701443539654062],
            [31.38997301909274, 1.702727423647349],
            [31.383906303415305, 1.705652391364303],
            [31.38150780160671, 1.707703288977941],
            [31.37952813929933, 1.708587876413268],
            [31.376526502320754, 1.70790714380459],
            [31.376133770556642, 1.708404224768526],
            [31.375918455162818, 1.710610571874641],
            [31.37446753584178, 1.711703642041069],
            [31.375531478006412, 1.714489980753751],
            [31.373977813874752, 1.71591752202575],
            [31.37503431709052, 1.717256954635715],
            [31.375887014127876, 1.717565190682586],
            [31.374018378199725, 1.718350302053065],
            [31.373249055600514, 1.720474983528198],
            [31.374834441939804, 1.721742440090633],
            [31.37415958258261, 1.722736593802863],
            [31.37516485308108, 1.724329119601924],
            [31.375557164433648, 1.724293343335201],
            [31.37606962545547, 1.723389401553623],
            [31.37697411665717, 1.723218378624838],
            [31.377450925341986, 1.72395129672674],
            [31.37816719164389, 1.724159919511957],
            [31.378661265050155, 1.725091780483603],
            [31.378395139147234, 1.726963636994943],
            [31.376688199071893, 1.728300677001092],
            [31.375153062692977, 1.728254098094251],
            [31.374538418307587, 1.728696738185465],
            [31.374196778225258, 1.729248108329478],
            [31.374264011734386, 1.730378628439825],
            [31.373666070623397, 1.731336721354679],
            [31.37502098249844, 1.732983815471714],
            [31.375789883787775, 1.731673154726731],
            [31.37770020783333, 1.731837583578326],
            [31.377824287631945, 1.736477081517316],
            [31.378812434444473, 1.738024419635036],
            [31.37823105557237, 1.73963362726934],
            [31.378323132888994, 1.741569024586402],
            [31.377468610474974, 1.74338614950011],
            [31.37620577591655, 1.743936674027464],
            [31.37405683777199, 1.743500631678081],
            [31.374106665524156, 1.744992967736905],
            [31.37271652262198, 1.744883116113595],
            [31.371521904329615, 1.745343429237823],
            [31.369859459606943, 1.747042140248363],
            [31.369743801514108, 1.748606586295965],
            [31.368365589137223, 1.748388285082793],
            [31.367605529965214, 1.749056797169365],
            [31.36843759449713, 1.749871498224035],
            [31.36986367001067, 1.75003550437497],
            [31.36981664859543, 1.750822285829311],
            [31.36900914759665, 1.751753010376211],
            [31.37038862300483, 1.75385240102624],
            [31.368868364523635, 1.755053895658115],
            [31.36875186470939, 1.756048593904554],
            [31.367692694395547, 1.755848672540867],
            [31.367122685499996, 1.756327502021292],
            [31.365698014053258, 1.758713791924075],
            [31.36715075785263, 1.764276786483399],
            [31.366248933749013, 1.766211316105902],
            [31.368578237432963, 1.767090685451112],
            [31.368697825655165, 1.768691451300234],
            [31.368175398723576, 1.769414530580192],
            [31.36805735470536, 1.770816075917364],
            [31.36577029968753, 1.772469027246605],
            [31.361991620886517, 1.771823671949402],
            [31.358523983752637, 1.774931476521985],
            [31.357288238789923, 1.774641067501496],
            [31.35569653639587, 1.77562537303542],
            [31.355554630428752, 1.776366828386518],
            [31.355150528688075, 1.776556366213685],
            [31.3541522758286, 1.776121313777166],
            [31.352703322021412, 1.777033366756161],
            [31.352681144413676, 1.779610851084471],
            [31.351660433672095, 1.781952216992616],
            [31.351210012998745, 1.783769442562267],
            [31.351518949014842, 1.784004855902591],
            [31.350521117465238, 1.784311537518436],
            [31.349333797086224, 1.78544090194617],
            [31.3466608878061, 1.786098598313747],
            [31.345889179281492, 1.7872554582677],
            [31.34565112573121, 1.78667646765665],
            [31.34346513118284, 1.786900516177186],
            [31.34329810113386, 1.785842281721454],
            [31.34367834092564, 1.785634647199144],
            [31.3424890559311, 1.783535573545597],
            [31.335716600410258, 1.783411833992447],
            [31.33476621158576, 1.783700277968472],
            [31.333863263689704, 1.783437226940829],
            [31.332557619018107, 1.785633524850311],
            [31.333032883498948, 1.785588770965563],
            [31.333245812967387, 1.786233280134725],
            [31.331726957654663, 1.787929849128113],
            [31.3303487461761, 1.78802805452562],
            [31.329695783253957, 1.788687714522757],
            [31.328436597652214, 1.789039149158539],
            [31.326488095207083, 1.78899215066324],
            [31.32556156743316, 1.789615334056109],
            [31.322900308403955, 1.789784667387821],
            [31.321094975855566, 1.791311338749281],
            [31.308682924828787, 1.798426012224845],
            [31.25069793716849, 1.810352950827343],
            [31.10002449642171, 1.851894388223156],
            [31.03800958195521, 1.760371524512367],
            [31.05078306384834, 1.747073566668183],
            [31.05236129151313, 1.746471553997599],
            [31.075111827667687, 1.727367695218477],
            [31.091860074418683, 1.712290653514621],
            [31.107918863290784, 1.697113319320427],
            [31.142872030721517, 1.666799823239279],
            [31.158733050093932, 1.651660717969068],
            [31.171441122956267, 1.637648142713944],
            [31.181019690845883, 1.616440595291812],
            [31.18243608162235, 1.614981693488889],
            [31.181859334463844, 1.612751387952349],
            [31.18224280280075, 1.611170557581025],
            [31.18377920310929, 1.610723121056725],
            [31.1868876542667, 1.61092558326533],
            [31.18999722921655, 1.609946525301216],
            [31.1905291998497, 1.608908539066312],
            [31.191072961769287, 1.608982339796669],
            [31.19190081499914, 1.607735015772167],
            [31.192149957353305, 1.606404067356078],
            [31.19175413718124, 1.605255517660613],
            [31.19248247414561, 1.604407503922178],
            [31.19354094287522, 1.604142183642121],
            [31.192980898991117, 1.601762158557314],
            [31.19554418595881, 1.601381646161447],
            [31.195792485693225, 1.600999169846345],
            [31.19600864280847, 1.599718026280039],
            [31.195630087357856, 1.597637692259867],
            [31.19619420061018, 1.595574754243241],
            [31.19501361849413, 1.590477943934037],
            [31.199581831988237, 1.588513916437846],
            [31.20325720453157, 1.583175617656957],
            [31.203354334871662, 1.581712062259413],
            [31.204499266447378, 1.58096351721554],
            [31.205673111198802, 1.579308860614628],
            [31.205674515265596, 1.577751296214727],
            [31.20511994571483, 1.576552639706801],
            [31.205630301085623, 1.57524187651904],
            [31.203965049127685, 1.57345658761894],
            [31.203483608729268, 1.57181202639822],
            [31.203722785173664, 1.570547561764097],
            [31.205879443439787, 1.570016913378141],
            [31.208657202283234, 1.570272275869737],
            [31.20990150998725, 1.569261629294019],
            [31.210471659019973, 1.567691289027257],
            [31.21294062288284, 1.565463598487982],
            [31.210472922051263, 1.558445732971617],
            [31.210421409957934, 1.556755138313208],
            [31.211195925717796, 1.55600363805355],
            [31.21158262259984, 1.553821535707912],
            [31.212203583039987, 1.553315296621293],
            [31.21598647314305, 1.553691327883474],
            [31.216383977656278, 1.553012647755198],
            [31.216899947497595, 1.552853395441979],
            [31.21754771636075, 1.553279938454391],
            [31.218249525176475, 1.552535031763282],
            [31.222415883616446, 1.553244160029829],
            [31.22317046845511, 1.552472593931509],
            [31.223052564574072, 1.551101341727218],
            [31.2209601915463, 1.545994319662804],
            [31.21955306509537, 1.543949571509728],
            [31.219977659204297, 1.542325894254246],
            [31.21907260655555, 1.541173520645489],
            [31.21924567328325, 1.539722704534657],
            [31.220027207580436, 1.5384986302897],
            [31.221548588057406, 1.538273571170496],
          ],
          [
            [31.303438167636326, 1.608298205567935],
            [31.297697511660928, 1.609361588244763],
            [31.293355280156312, 1.611815966327441],
            [31.29233962243821, 1.613233199706358],
            [31.292420190539417, 1.617856140878139],
            [31.29062327879849, 1.621021577561698],
            [31.29681056545504, 1.625195945193504],
            [31.297360924602074, 1.629951587996677],
            [31.299270826439418, 1.630716530549383],
            [31.30406600557828, 1.631303005016885],
            [31.311517670997237, 1.631548538086065],
            [31.315352495401832, 1.631208580057557],
            [31.31692145874109, 1.633539603578242],
            [31.31745707922924, 1.63582825286667],
            [31.31878855136359, 1.637899147103862],
            [31.319924639025306, 1.638877910464794],
            [31.32019202795951, 1.640583870512525],
            [31.324411162422432, 1.637883152849454],
            [31.326945955727627, 1.634733876999812],
            [31.326155157104907, 1.62862780994244],
            [31.326565715935853, 1.619672959773429],
            [31.325710210764907, 1.616811984322473],
            [31.323872734699012, 1.61408541850813],
            [31.320505736724723, 1.61060975356134],
            [31.318937474969697, 1.609823757909738],
            [31.31640113746053, 1.609727086149045],
            [31.313696366733915, 1.608836140948619],
            [31.30801213663647, 1.609691728943289],
            [31.305598615894628, 1.608583589355157],
            [31.303438167636326, 1.608298205567935],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 368,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "KIGOROBYA",
        Population: 67121,
        Key: "HOIMAKIGOROBYA",
        Dist2: "Hoima",
        "Sub Country": "Kigorobya",
        id2_original: "Hoima Kigorobya",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.326400774469892, 1.631623467614],
            [31.326945981778778, 1.634733807857688],
            [31.324411146252753, 1.637883160033027],
            [31.31998519625524, 1.640666868654828],
            [31.31992467765285, 1.638877861077664],
            [31.31878858280462, 1.637899214449984],
            [31.31745702622865, 1.635828310335421],
            [31.316921488385486, 1.633539661047058],
            [31.31535243431639, 1.631208536057936],
            [31.31151768267533, 1.631548525514738],
            [31.304066019951335, 1.631302987955825],
            [31.299270873151805, 1.630716462305054],
            [31.297360867109894, 1.629951588894611],
            [31.296810602285955, 1.625195894908068],
            [31.290623299459753, 1.62102154433734],
            [31.29242025252315, 1.617856081612965],
            [31.29233957213254, 1.613233150318601],
            [31.293355328665324, 1.611815952858049],
            [31.29769749099966, 1.609361645714265],
            [31.30229212664123, 1.608316139652994],
            [31.30559867338681, 1.608583616293983],
            [31.308012079144287, 1.60969172714737],
            [31.314372640039377, 1.60891237156444],
            [31.316401136562234, 1.609727088842939],
            [31.318937518088827, 1.609823737256626],
            [31.320505723249997, 1.61060970866333],
            [31.32387269517314, 1.614085374508138],
            [31.326040223952507, 1.617644297502113],
            [31.326626585779508, 1.621004290116916],
            [31.326155200224036, 1.62862778928952],
            [31.326400774469892, 1.631623467614],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 369,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "KIGOROBYA TOWN COUNCIL",
        Population: 5845,
        Key: "HOIMAKIGOROBYA TOWN COUNCIL",
        Dist2: "Hoima",
        "Sub Country": "Kigorobya T.C",
        id2_original: "Hoima Kigorobya T.C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.444401006112994, 1.607472515524053],
            [31.44024684320135, 1.611856989622908],
            [31.438017810367715, 1.615060310648089],
            [31.43651394793711, 1.615947863332541],
            [31.435067055763465, 1.616060186205327],
            [31.428764539510496, 1.614192771281887],
            [31.42161506465817, 1.614196644178198],
            [31.418441195486793, 1.612170934316096],
            [31.40632350261571, 1.610176008118844],
            [31.40365672343908, 1.608491058035329],
            [31.4017700421535, 1.606362363295565],
            [31.400229790767344, 1.605756075255246],
            [31.395965020989674, 1.605242187403675],
            [31.39047118522345, 1.602637933945586],
            [31.38867337157396, 1.601105467301904],
            [31.387633085644033, 1.600778498624168],
            [31.385739463076252, 1.601017321302838],
            [31.383315859643655, 1.602766338287828],
            [31.38191708752486, 1.602782385799434],
            [31.380552852035482, 1.602283478833209],
            [31.377839806926804, 1.603328448304406],
            [31.377938052974457, 1.597706586910103],
            [31.37764889247103, 1.596659225984028],
            [31.370292620050424, 1.591340473701838],
            [31.369228109252195, 1.58930545264423],
            [31.36725016901522, 1.588342581050393],
            [31.362414900760196, 1.587592004499861],
            [31.355394351219125, 1.578471293115892],
            [31.35106312317843, 1.576716917085551],
            [31.34728835923544, 1.574345278021977],
            [31.34335255610808, 1.573841068822787],
            [31.33963176115071, 1.574688940663586],
            [31.32788319860627, 1.581921146283307],
            [31.327035865409457, 1.584227204098769],
            [31.32628375003951, 1.584945086724109],
            [31.324668309664098, 1.584489983889469],
            [31.316639871035495, 1.580030669087282],
            [31.308880729362794, 1.579513811506382],
            [31.302315183699633, 1.578364508690711],
            [31.29974242399728, 1.576868698229935],
            [31.296429424653045, 1.573056113378506],
            [31.291757294046867, 1.565564925650801],
            [31.288603639664345, 1.56221572533571],
            [31.28824838651217, 1.560097807322664],
            [31.286869049444547, 1.558158669338683],
            [31.28465383449663, 1.556001415543062],
            [31.283470525993682, 1.555603390365187],
            [31.282494374385163, 1.554600500707004],
            [31.280287788653858, 1.553398076485853],
            [31.277676911637368, 1.552639641685292],
            [31.276042276060945, 1.55277064878157],
            [31.274331800216665, 1.553752418701755],
            [31.27154161228291, 1.554024272866537],
            [31.27050766037404, 1.554798614966356],
            [31.269532107043485, 1.553077254205494],
            [31.267767074715383, 1.551846829920228],
            [31.265729064135336, 1.551306291784309],
            [31.265090086185534, 1.551551556900359],
            [31.264452190705644, 1.550473321568478],
            [31.262780255282003, 1.550282867626387],
            [31.260769095345825, 1.551377815472937],
            [31.25948271684211, 1.550686639122753],
            [31.258261251499157, 1.551025953994809],
            [31.256683910471533, 1.550041476277365],
            [31.256044067444133, 1.551345532875766],
            [31.251572456979023, 1.551587602953382],
            [31.25094994155513, 1.55266908393473],
            [31.248623704719574, 1.550270859751253],
            [31.24693116643487, 1.54941743837586],
            [31.24619131666183, 1.548271931931962],
            [31.244340029896758, 1.547431690414695],
            [31.243031910366525, 1.545620080316961],
            [31.239295758709375, 1.544571920106478],
            [31.23880717760276, 1.543519815409849],
            [31.237881380159173, 1.543292728263069],
            [31.237347263450793, 1.541315361804337],
            [31.23651461411563, 1.540422723375334],
            [31.233260960173983, 1.539807627535696],
            [31.229959907524716, 1.540530400532317],
            [31.229299056496057, 1.539850907104656],
            [31.228646478052838, 1.540381988723538],
            [31.227990142855123, 1.539024433853004],
            [31.227090942730463, 1.538637616911947],
            [31.226130570029888, 1.538793279224146],
            [31.22502818985256, 1.537610823673319],
            [31.225465601123975, 1.536546189444738],
            [31.225454331758716, 1.534176553551583],
            [31.22500786816422, 1.530182427533137],
            [31.224786104663263, 1.518327457158117],
            [31.226209911930727, 1.51613872590625],
            [31.2260389885833, 1.514860583037955],
            [31.226581882730322, 1.51419540551663],
            [31.225902592882143, 1.511791936127576],
            [31.2272998998487, 1.509643113634434],
            [31.227380434712217, 1.508205426644187],
            [31.226653562001786, 1.507379453113449],
            [31.226515449620106, 1.506414182562791],
            [31.22523337853817, 1.505121816752954],
            [31.223038222072244, 1.504268013754847],
            [31.220029035652033, 1.504045884849679],
            [31.219619562884276, 1.503313361646762],
            [31.215765027645734, 1.501662142441825],
            [31.216228861962907, 1.5005004231013],
            [31.21938689832737, 1.498177495332361],
            [31.220007580289785, 1.497099220699253],
            [31.220593385161294, 1.497027243509292],
            [31.22244367749135, 1.495260661278607],
            [31.228168321895108, 1.493576215916028],
            [31.228951032985325, 1.492399843044534],
            [31.22994632050605, 1.493101641781296],
            [31.230639854939668, 1.493060201300572],
            [31.23090201028905, 1.492100466955933],
            [31.231770158349278, 1.491491974829966],
            [31.23573756869991, 1.4906969440526],
            [31.236432447013218, 1.49004422896143],
            [31.237471945120664, 1.490353196091503],
            [31.238643860290857, 1.489571019940762],
            [31.239423117358797, 1.48996648630622],
            [31.240509114960265, 1.488834728335004],
            [31.24128857145419, 1.489142872157753],
            [31.24276434536252, 1.488143353263017],
            [31.24384641912286, 1.488801760517508],
            [31.245585016727116, 1.486536847286436],
            [31.24719061336367, 1.485625062216922],
            [31.24753877072337, 1.484971227598117],
            [31.249402795599188, 1.484802534840566],
            [31.25009968254544, 1.483232885431678],
            [31.251618785793198, 1.482321770714588],
            [31.252878972118143, 1.480450977278326],
            [31.254476770479727, 1.479280008857854],
            [31.255041322109903, 1.478070405358678],
            [31.259306744962792, 1.477033890354885],
            [31.261504350236212, 1.477621744651491],
            [31.2650830829196, 1.47784199936861],
            [31.27174941416771, 1.476797888831283],
            [31.27337802743847, 1.477196217663078],
            [31.278213690952214, 1.479780846636463],
            [31.281990738412695, 1.478687174602775],
            [31.283287818546366, 1.477686098313993],
            [31.28795481258577, 1.479778995826128],
            [31.290693790260093, 1.479227790130731],
            [31.293957817946623, 1.480861661246454],
            [31.295880681575223, 1.483292778494376],
            [31.29672712454158, 1.483519756978244],
            [31.297705087153716, 1.484745314307451],
            [31.299354299692247, 1.485012023457168],
            [31.300568466223517, 1.486422028245082],
            [31.295910790408605, 1.490339271526687],
            [31.28966649935904, 1.49310099251988],
            [31.288146196860424, 1.494524702044843],
            [31.285527523365552, 1.499284544297156],
            [31.289379820002427, 1.502195024983009],
            [31.292262752701014, 1.503315590497877],
            [31.29269596794175, 1.506246065278759],
            [31.29397913496831, 1.506063530512121],
            [31.295679367323423, 1.507189884372603],
            [31.299421586201973, 1.507486315636565],
            [31.3009749898222, 1.509933225314458],
            [31.30340340912303, 1.512185172326442],
            [31.30447055467998, 1.514108771708483],
            [31.308790014790436, 1.514178739504858],
            [31.311038443149368, 1.51475297104654],
            [31.315136696714365, 1.509610657094275],
            [31.31696261236088, 1.50914612342771],
            [31.319521908113774, 1.509740554194238],
            [31.321122815544513, 1.509435598489547],
            [31.322804057514514, 1.507879262558932],
            [31.32380439087221, 1.50583646276205],
            [31.325856255270523, 1.503987514472473],
            [31.327959519472802, 1.504122273710953],
            [31.330134086552423, 1.506167535648121],
            [31.331404320533867, 1.505809059239638],
            [31.33181481738104, 1.505276845696755],
            [31.33163148021469, 1.502827064353304],
            [31.332459980231558, 1.500584417309663],
            [31.33387126588225, 1.497383659530523],
            [31.335261287511887, 1.496053395991849],
            [31.337589945307123, 1.495522644728116],
            [31.341260667272255, 1.495864934411945],
            [31.344231081506475, 1.495128305465765],
            [31.345633691228173, 1.494650091135246],
            [31.34756624139047, 1.493120521549322],
            [31.352971899426752, 1.490854676132744],
            [31.359117505152447, 1.489760944921152],
            [31.365388623489626, 1.487411733540057],
            [31.36534229737041, 1.490497094331594],
            [31.36799190884365, 1.490810201229821],
            [31.37119271040554, 1.492301551295907],
            [31.372068389042802, 1.492160026615984],
            [31.379939463494868, 1.493603872830463],
            [31.38388881321672, 1.494763614817686],
            [31.384927930438458, 1.4977483739892],
            [31.385909685737744, 1.503139024532997],
            [31.38952659682071, 1.503685285206407],
            [31.39271425333507, 1.50526123118081],
            [31.397274110700412, 1.505621049299068],
            [31.39643414279063, 1.506729633671665],
            [31.39459214280895, 1.507730411171716],
            [31.394272115294022, 1.50858105183917],
            [31.395151499481845, 1.513573527645196],
            [31.396146633390668, 1.514462965974927],
            [31.399940951860774, 1.515770477301034],
            [31.40054176758068, 1.516338179057561],
            [31.400597172972464, 1.517642904552598],
            [31.400022526973398, 1.519807494265489],
            [31.40019082903683, 1.52088540203327],
            [31.40126013055044, 1.523117401197763],
            [31.403597325035868, 1.525813607651906],
            [31.403886697541704, 1.528319200367039],
            [31.40553686858264, 1.53268830160788],
            [31.406785345367886, 1.534003380032907],
            [31.407986158442473, 1.536254396713909],
            [31.409582462905714, 1.537257748524647],
            [31.4107745784917, 1.538572788218401],
            [31.411974776220312, 1.541655786294221],
            [31.41397375050969, 1.544408487020384],
            [31.416189256511736, 1.546546824844675],
            [31.417999742694935, 1.550112461216822],
            [31.41905118120913, 1.551115411373745],
            [31.420843403744247, 1.553981419231556],
            [31.42125570620516, 1.555399880193764],
            [31.42408076943316, 1.559023020121399],
            [31.42437991560929, 1.56100865660851],
            [31.42666088813434, 1.563572507429318],
            [31.429853532095116, 1.56561705967252],
            [31.432504197292186, 1.576349775417908],
            [31.433048650016204, 1.576936358856489],
            [31.434326072316523, 1.577277686335778],
            [31.43637301215049, 1.578754122707377],
            [31.437894531866338, 1.579322540351179],
            [31.438465224379808, 1.58250910563918],
            [31.439976013719594, 1.584864399484047],
            [31.441121450148472, 1.585829619096251],
            [31.44189714898958, 1.591247588702454],
            [31.442034476243695, 1.596022173425646],
            [31.444527432311165, 1.604060337884038],
            [31.444401006112994, 1.607472515524053],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 370,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "KITOBA",
        Population: 34810,
        Key: "HOIMAKITOBA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Kitabona",
        id2_original: "KyankwanziKitabona",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.126134175681745, 1.421167420474931],
            [31.124337086972684, 1.420411359556266],
            [31.121536024034132, 1.420318516664379],
            [31.11906493924889, 1.421512085107232],
            [31.11673383623942, 1.422119307448837],
            [31.11457322538607, 1.420882881303706],
            [31.112753038296113, 1.41621065051676],
            [31.11097881260938, 1.409568635456619],
            [31.107511210509788, 1.403619750074238],
            [31.105851010677025, 1.401854053185062],
            [31.097785126674108, 1.39962067713641],
            [31.09714699224239, 1.39973038707899],
            [31.094631242322897, 1.402334872575717],
            [31.092411383084947, 1.402830679358027],
            [31.090969625681513, 1.402630438431185],
            [31.088617020597383, 1.400443380793114],
            [31.08929266059059, 1.395918962871665],
            [31.090241674992694, 1.393183710628696],
            [31.0965101971987, 1.380350509182937],
            [31.098817304410307, 1.365352993310649],
            [31.10723146345221, 1.341363518401315],
            [31.112039934064022, 1.330132015778312],
            [31.11490645454237, 1.319117841633223],
            [31.117571185560163, 1.311623728049078],
            [31.11746132968575, 1.311120423359356],
            [31.114790457784704, 1.308583199422839],
            [31.114794182199873, 1.306850785302689],
            [31.112969220564203, 1.304302263662211],
            [31.1125187864161, 1.300961735694498],
            [31.111965609254042, 1.300261428769148],
            [31.110580248982448, 1.299642328219775],
            [31.110027924321564, 1.298550842257691],
            [31.110161914334427, 1.294262118328918],
            [31.11222765051736, 1.287981598666052],
            [31.111640612258974, 1.283662664922504],
            [31.113781039764536, 1.281350176836544],
            [31.11519227780455, 1.282835554580348],
            [31.12369252150184, 1.289400809525303],
            [31.130436167153178, 1.293878851972879],
            [31.1322938032107, 1.294136174323095],
            [31.134946583940234, 1.292174543267178],
            [31.1378870366648, 1.291876405360965],
            [31.141821269537033, 1.293760925164274],
            [31.144474857852018, 1.297932734570936],
            [31.150308937718655, 1.299809252429023],
            [31.15443669375426, 1.302001763132724],
            [31.156912259336124, 1.302344957580167],
            [31.15708986974251, 1.299872441627919],
            [31.15842967015785, 1.295852838469713],
            [31.159807951705012, 1.293300363127799],
            [31.160368326169152, 1.290619577272653],
            [31.160177029929383, 1.289277714911343],
            [31.157901191276213, 1.28350034954803],
            [31.15801685475893, 1.281265259669685],
            [31.15920351038463, 1.27751062177921],
            [31.159095288545732, 1.276224907566802],
            [31.157436800901877, 1.27359307594598],
            [31.15656887562383, 1.270893870196072],
            [31.156627756597445, 1.269273357307693],
            [31.157604875691543, 1.266230603824251],
            [31.15723550551468, 1.263840325814834],
            [31.15823733995722, 1.262222745293919],
            [31.16095967634091, 1.260135489973516],
            [31.16517032172439, 1.255887249331523],
            [31.168613026117566, 1.254137529106882],
            [31.170283457761435, 1.251096896320164],
            [31.17137358851151, 1.246551933947883],
            [31.172895979593214, 1.244639101162379],
            [31.17381807957108, 1.242482578135861],
            [31.177722898007687, 1.242988976763089],
            [31.18740455116939, 1.243304933288836],
            [31.203229593014687, 1.245750091580936],
            [31.208818497487442, 1.244735845750404],
            [31.214488441676945, 1.237838767986317],
            [31.218710767854052, 1.234804850413488],
            [31.221024890009687, 1.234108593122536],
            [31.22124233261411, 1.231153534149874],
            [31.2220012617055, 1.22947275880081],
            [31.221726690740567, 1.225991818319431],
            [31.220604279030724, 1.221044477999552],
            [31.220568540455467, 1.217826359180436],
            [31.224877584600247, 1.217685149866599],
            [31.23052867225358, 1.217148595899365],
            [31.237039765637448, 1.218013294977411],
            [31.23959367419358, 1.217152433534481],
            [31.244930678484245, 1.213937362757878],
            [31.248397432574215, 1.219781144954533],
            [31.24952248443269, 1.22057147327293],
            [31.251108306454874, 1.220881484265653],
            [31.25203665601222, 1.222572848345929],
            [31.254269791451733, 1.224033343137284],
            [31.254900090777575, 1.225115155392202],
            [31.254583748151976, 1.226410907679446],
            [31.255247675910457, 1.228230839746381],
            [31.25455487719706, 1.231465993955306],
            [31.255373004367343, 1.232187467205391],
            [31.255594204624582, 1.232960039871517],
            [31.25604222679611, 1.238942359079541],
            [31.256519878998972, 1.239847562823619],
            [31.260055409903714, 1.242618658861461],
            [31.259689769531935, 1.244327276072233],
            [31.260674230556877, 1.249210159391022],
            [31.260485908639033, 1.250308599606648],
            [31.259538505814522, 1.251655426254112],
            [31.256450270344253, 1.253781823069807],
            [31.255938106664804, 1.254588237006795],
            [31.256934442519444, 1.256605800673523],
            [31.256285866070822, 1.257377791401963],
            [31.256156901233723, 1.25896547274571],
            [31.255371717081534, 1.259994845124141],
            [31.25488338121496, 1.263418942378207],
            [31.253603433750403, 1.264722616809692],
            [31.25332971349005, 1.265992642521631],
            [31.251767574652014, 1.268471925165494],
            [31.25203950816324, 1.269862476039735],
            [31.25149201015039, 1.272471184656527],
            [31.24778860837355, 1.277673925434097],
            [31.245078615740216, 1.280446018524172],
            [31.24454955115697, 1.281450380401042],
            [31.244574664459066, 1.282707962014118],
            [31.243962790478022, 1.283516452299862],
            [31.244372124905222, 1.286731324702835],
            [31.24266339269091, 1.28816517060662],
            [31.242299852580242, 1.28958920768717],
            [31.24276861236013, 1.290904048233912],
            [31.242984598795456, 1.293727102336649],
            [31.244489151132235, 1.297099061172662],
            [31.244236832335236, 1.298383719488584],
            [31.241737646451252, 1.29980113644271],
            [31.239984922839177, 1.302366578035792],
            [31.23966329183147, 1.30363704396303],
            [31.237883581929925, 1.305839113214384],
            [31.239241398956615, 1.30643016065669],
            [31.240486917589617, 1.307663582268848],
            [31.24370437661182, 1.314226541000457],
            [31.243903139648193, 1.318628391298608],
            [31.244756246317355, 1.321816713977173],
            [31.24405691056361, 1.324636917843295],
            [31.242511822647945, 1.32735667787933],
            [31.2375089808632, 1.332259277313935],
            [31.237265990172094, 1.335681694327084],
            [31.236069086565642, 1.337689940565548],
            [31.235817910425684, 1.344968641791775],
            [31.238317261599626, 1.350048345929007],
            [31.23811764606204, 1.352618601153033],
            [31.23710328910446, 1.354175321740898],
            [31.232377340429615, 1.35985953462006],
            [31.231900690746585, 1.362330048813644],
            [31.232157044775846, 1.366812138686878],
            [31.22993088744945, 1.373490526921395],
            [31.227187734405685, 1.373226168506988],
            [31.225083491039776, 1.373755346907918],
            [31.224576475605193, 1.373461490936277],
            [31.223903010433325, 1.37187631977301],
            [31.2224533262958, 1.371530790216212],
            [31.217310765043337, 1.374181421972301],
            [31.216897890355572, 1.375081240717224],
            [31.215228722641328, 1.375636124673051],
            [31.211678266228137, 1.374212363625485],
            [31.210587806694623, 1.375451003814091],
            [31.20697120193717, 1.376693840873408],
            [31.206487886754747, 1.376619256424932],
            [31.20591003916003, 1.375545829592644],
            [31.204436778737882, 1.374932320478827],
            [31.202739466805763, 1.377338039691143],
            [31.200732040267933, 1.377818783248344],
            [31.199241006677873, 1.379847664110658],
            [31.19721124083552, 1.379475923281059],
            [31.19607138024959, 1.381201472343434],
            [31.19447531922979, 1.381488675473295],
            [31.192117795869493, 1.380878052441184],
            [31.191643258125733, 1.379872324695109],
            [31.190214647566453, 1.379169215050576],
            [31.189263494275625, 1.378118314393717],
            [31.188440274555997, 1.378028381323692],
            [31.186927158579625, 1.376320782103234],
            [31.186627657568977, 1.374529711772583],
            [31.185500624027004, 1.374657122679046],
            [31.181688961783703, 1.373728159127531],
            [31.179823595723185, 1.374595484553336],
            [31.17617756395365, 1.377247274093988],
            [31.173402787516935, 1.377806074864111],
            [31.172797496390288, 1.377149232445199],
            [31.169158355597283, 1.376613743259099],
            [31.168249615364317, 1.375999603086322],
            [31.165412266776475, 1.375444833268215],
            [31.160347216658298, 1.372983725357568],
            [31.15770455724703, 1.372582378991877],
            [31.15701033290727, 1.372973122892165],
            [31.153578633774636, 1.376717055620417],
            [31.152706217818466, 1.379333933607594],
            [31.150011872040736, 1.382774564767931],
            [31.149619183395753, 1.38399580790361],
            [31.150219134936346, 1.387097640396665],
            [31.149319655435626, 1.39218125701321],
            [31.149744628633595, 1.39602476467947],
            [31.148152716932085, 1.399307168812411],
            [31.147716371062597, 1.402253745771785],
            [31.14679523048543, 1.404933322106288],
            [31.144349870754965, 1.407049154336673],
            [31.140133068318544, 1.407510670095367],
            [31.139355624050843, 1.407899380431177],
            [31.139252438167414, 1.410679350597235],
            [31.13674612594833, 1.415281861426706],
            [31.136353959224493, 1.41704099064221],
            [31.135062020149178, 1.418056756014877],
            [31.134340717891817, 1.418138264833087],
            [31.13309416350129, 1.417435695599584],
            [31.129746644595624, 1.413596796883235],
            [31.128998472829775, 1.413287024495538],
            [31.12725035577845, 1.413644667005902],
            [31.126611281708897, 1.414173520214058],
            [31.125690717850134, 1.416573617059961],
            [31.125588863269968, 1.418738839871736],
            [31.126134175681745, 1.421167420474931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 371,
        District: "HOIMA",
        County: "BUHAGUZI",
        Subcounty: "KIZIRANFUMBI",
        Population: 35184,
        Key: "HOIMAKIZIRANFUMBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.48247420398516, 1.559192600565636],
            [31.479782449847022, 1.565667679698805],
            [31.479097639851414, 1.568201032158271],
            [31.479116677847234, 1.570068099024196],
            [31.478116669679693, 1.571462537205188],
            [31.47748336728586, 1.573247046572196],
            [31.479912018352007, 1.574002708160878],
            [31.483557299129973, 1.573929747582551],
            [31.48617935388355, 1.57271201764297],
            [31.487719268401463, 1.573885516858282],
            [31.488019088314047, 1.575020295590988],
            [31.487687199444146, 1.579265175972891],
            [31.488850301243083, 1.581837636596542],
            [31.489195469009548, 1.585213189598731],
            [31.488769062100374, 1.590214415997939],
            [31.488260752193476, 1.591556597725331],
            [31.486633825958837, 1.593739413083696],
            [31.48402004918058, 1.596403681762031],
            [31.48244151788524, 1.596648326466539],
            [31.477209234698805, 1.595651687562758],
            [31.47399448319886, 1.597918382069185],
            [31.472585030111343, 1.598200965650062],
            [31.470413496642426, 1.599948426169887],
            [31.464155681456283, 1.601002616234503],
            [31.462473527696297, 1.601615890947639],
            [31.46143942576875, 1.602503828422198],
            [31.460084569589256, 1.605150051036125],
            [31.457785940677326, 1.613468265663415],
            [31.45350228831237, 1.612878810188834],
            [31.450910616378355, 1.611118293606503],
            [31.44855443869437, 1.608554334674515],
            [31.446535077139632, 1.607212982108254],
            [31.444401006112994, 1.607472515524053],
            [31.444527432311165, 1.604060337884038],
            [31.442034476243695, 1.596022173425646],
            [31.44189714898958, 1.591247588702454],
            [31.441121450148472, 1.585829619096251],
            [31.439976013719594, 1.584864399484047],
            [31.438465224379808, 1.58250910563918],
            [31.437894531866338, 1.579322540351179],
            [31.43637301215049, 1.578754122707377],
            [31.434326072316523, 1.577277686335778],
            [31.433048650016204, 1.576936358856489],
            [31.432504197292186, 1.576349775417908],
            [31.429853532095116, 1.56561705967252],
            [31.42666088813434, 1.563572507429318],
            [31.42437991560929, 1.56100865660851],
            [31.42408076943316, 1.559023020121399],
            [31.42125570620516, 1.555399880193764],
            [31.420843403744247, 1.553981419231556],
            [31.41905118120913, 1.551115411373745],
            [31.417999742694935, 1.550112461216822],
            [31.416189256511736, 1.546546824844675],
            [31.41397375050969, 1.544408487020384],
            [31.411974776220312, 1.541655786294221],
            [31.4107745784917, 1.538572788218401],
            [31.409582462905714, 1.537257748524647],
            [31.407986158442473, 1.536254396713909],
            [31.406785345367886, 1.534003380032907],
            [31.40553686858264, 1.53268830160788],
            [31.403886697541704, 1.528319200367039],
            [31.403597325035868, 1.525813607651906],
            [31.40126013055044, 1.523117401197763],
            [31.40019082903683, 1.52088540203327],
            [31.400022526973398, 1.519807494265489],
            [31.400597172972464, 1.517642904552598],
            [31.40054176758068, 1.516338179057561],
            [31.399940951860774, 1.515770477301034],
            [31.396146633390668, 1.514462965974927],
            [31.395151499481845, 1.513573527645196],
            [31.394272115294022, 1.50858105183917],
            [31.39459214280895, 1.507730411171716],
            [31.39643414279063, 1.506729633671665],
            [31.397274110700412, 1.505621049299068],
            [31.39875714658947, 1.503129296432214],
            [31.399360403031988, 1.500350199953568],
            [31.39876157977541, 1.49703930196974],
            [31.396847728045728, 1.493522399967004],
            [31.395082012099703, 1.492991665153755],
            [31.393353421727685, 1.493084934299995],
            [31.391813829704958, 1.491646761377494],
            [31.391373701928156, 1.489727236257901],
            [31.392126096674126, 1.488536561384067],
            [31.39252184228603, 1.486891821900728],
            [31.39142582128262, 1.482627176501486],
            [31.390937506077314, 1.482381009149292],
            [31.388243953511953, 1.483303548379543],
            [31.390093140015917, 1.481015289201461],
            [31.38951011812515, 1.47757862548744],
            [31.388427341882277, 1.475625293971027],
            [31.38671671601935, 1.473901216682587],
            [31.388314996776206, 1.473155823841227],
            [31.390126216882972, 1.471554086265539],
            [31.391947078607686, 1.473024979866421],
            [31.392037511109027, 1.470401960794781],
            [31.39304329544383, 1.467812647637336],
            [31.393873690007645, 1.466857027874425],
            [31.39598748156674, 1.465683928489012],
            [31.39850386479848, 1.463627689384139],
            [31.398795901707448, 1.460753836896914],
            [31.40100048239906, 1.457172283436719],
            [31.401188029070813, 1.455693540568806],
            [31.400562900447728, 1.451784560269348],
            [31.401157800761485, 1.452093184263326],
            [31.40303308601938, 1.457131924406695],
            [31.404529269650958, 1.462886855969006],
            [31.405719629928885, 1.463814080170314],
            [31.407313346345795, 1.464287357537305],
            [31.412424004829276, 1.463846622695903],
            [31.41775939754235, 1.462773495892256],
            [31.42400069271043, 1.462883958948431],
            [31.424121541268953, 1.463215646227813],
            [31.424680914111534, 1.463190454006235],
            [31.428927715786887, 1.462067576424757],
            [31.43075929620957, 1.460687104780731],
            [31.433226118488783, 1.459870017407939],
            [31.43541457172607, 1.457159197419599],
            [31.435338887765077, 1.455270365830266],
            [31.434502184333056, 1.453852829379046],
            [31.434283086133547, 1.451601346604842],
            [31.436349708953717, 1.450358528984915],
            [31.436616371150834, 1.449460959310408],
            [31.434198950822363, 1.442802417895343],
            [31.434584721541334, 1.439212970169518],
            [31.434181563031718, 1.433217061060192],
            [31.43061212880985, 1.424843962997373],
            [31.432817421865458, 1.415193922532525],
            [31.434002253012814, 1.400073931429885],
            [31.439649241653527, 1.400454363907395],
            [31.443933463550337, 1.403138908496492],
            [31.44445207264196, 1.403952956451443],
            [31.448059707721296, 1.405346668044045],
            [31.451635723899262, 1.405545033620257],
            [31.454356775692105, 1.404918914766544],
            [31.45663569107513, 1.403910098122262],
            [31.45760105751037, 1.401795930722169],
            [31.46011558482278, 1.399843531148839],
            [31.460496564826325, 1.399118649798046],
            [31.46134117882276, 1.394188275131589],
            [31.465080170054538, 1.39008284613875],
            [31.464847804636598, 1.386566309639252],
            [31.46554676219963, 1.384718455057368],
            [31.46716004751668, 1.383473054656871],
            [31.47131284768406, 1.383612942638075],
            [31.47327136005641, 1.384405338099155],
            [31.47822670342053, 1.382519496852269],
            [31.47954234005304, 1.377852776447055],
            [31.481027053995046, 1.36792975844412],
            [31.481669900090484, 1.366705202226902],
            [31.484301523698473, 1.364536131950587],
            [31.488449518777387, 1.364228365685551],
            [31.492274670123003, 1.362907932372534],
            [31.493151405179045, 1.361355961868393],
            [31.494812720719406, 1.359825989299337],
            [31.496078432581697, 1.356520486450002],
            [31.500603373330257, 1.351275901149737],
            [31.504003511952, 1.345082392852052],
            [31.510111623794376, 1.337973329378742],
            [31.5141536248563, 1.345979048676871],
            [31.51657922973532, 1.348598223186776],
            [31.524704168985025, 1.357033834773286],
            [31.52908041340124, 1.360445978200674],
            [31.530872317932747, 1.361556055401149],
            [31.532553840177115, 1.362026465436947],
            [31.536030882672037, 1.362436840880257],
            [31.54000627455395, 1.362014312869015],
            [31.545163142375653, 1.363923398636577],
            [31.54937262084757, 1.364673972564821],
            [31.556113499687882, 1.363648101684244],
            [31.559273639008417, 1.363758954723475],
            [31.56162146146197, 1.365076987054233],
            [31.564684030267934, 1.365375710642244],
            [31.569794059032382, 1.363643641015889],
            [31.57285756567952, 1.362074817964445],
            [31.577614211584283, 1.361898488978944],
            [31.58017889722886, 1.358503078514162],
            [31.58300254291534, 1.357096717167118],
            [31.583042595200595, 1.359461217022506],
            [31.581859570565268, 1.362637696777258],
            [31.583611196436088, 1.363203526487111],
            [31.584312659400425, 1.364087045060515],
            [31.582796895190608, 1.3690559541428],
            [31.581256998639006, 1.370454897724121],
            [31.581040764268643, 1.371527752086251],
            [31.581788218280582, 1.374326707821375],
            [31.581523648259733, 1.376356447503787],
            [31.580556999928568, 1.377549866782926],
            [31.58058671080827, 1.378897718625204],
            [31.580036772072816, 1.38003730274127],
            [31.580072426206446, 1.380936086512094],
            [31.581008442884713, 1.382058988298953],
            [31.581345576119272, 1.387122185955088],
            [31.580203470643458, 1.388998966689634],
            [31.580332784026904, 1.39270021317577],
            [31.5808125176263, 1.394171947696329],
            [31.57977688676616, 1.39608553114048],
            [31.580238932537608, 1.397994392887317],
            [31.57934481957238, 1.399094186984934],
            [31.576464817178223, 1.399365086582244],
            [31.575285795435832, 1.400437622516026],
            [31.573785858642974, 1.405997645562026],
            [31.57398505376902, 1.407111247821218],
            [31.574986428274116, 1.408684154090897],
            [31.576096600438238, 1.412811541733907],
            [31.5780382002287, 1.416086584369471],
            [31.578899417786516, 1.421061872157675],
            [31.582207819553137, 1.426139021652371],
            [31.58684414510874, 1.431469404914713],
            [31.588213606098137, 1.433968945503051],
            [31.587917187207196, 1.439296011177491],
            [31.58719253243716, 1.440161537715673],
            [31.582753882058157, 1.442339316999491],
            [31.579453815759067, 1.442013865275364],
            [31.577585731396507, 1.444850645792555],
            [31.575905953680433, 1.44603500024245],
            [31.572374432855103, 1.447030425883186],
            [31.569067426172104, 1.449021573100999],
            [31.567518399143967, 1.449309268033572],
            [31.565750623360962, 1.449062292385178],
            [31.561513654644703, 1.447684778971147],
            [31.559493031855304, 1.447682817676778],
            [31.555155593761075, 1.448502519131671],
            [31.553421567683287, 1.449296111026691],
            [31.55068125241752, 1.451578062560751],
            [31.54429350221372, 1.462690401864815],
            [31.54281789718868, 1.46729321634246],
            [31.53322222537606, 1.475610738007313],
            [31.529993387394157, 1.479765740216372],
            [31.529605623313568, 1.486580783467816],
            [31.526806232139744, 1.491509498615271],
            [31.52609661337093, 1.493923520390817],
            [31.522631727776755, 1.497054571709061],
            [31.521700078707408, 1.497293677278285],
            [31.515305684563778, 1.502507075053633],
            [31.50743957959185, 1.506929401988886],
            [31.505994675389985, 1.509773668968941],
            [31.50458119156176, 1.514346232962154],
            [31.503377271214614, 1.515832475285583],
            [31.498889134443232, 1.517004333843162],
            [31.496767387404013, 1.519157149625579],
            [31.49615589341031, 1.518992583121377],
            [31.494607526643907, 1.517452708108149],
            [31.491304528243695, 1.517860733340967],
            [31.48868502290891, 1.517520355363856],
            [31.485544863916914, 1.518318306539247],
            [31.48270991562752, 1.519957668474349],
            [31.483809617926973, 1.521681895411872],
            [31.485721029832337, 1.528782184461269],
            [31.483903642791134, 1.532945872282421],
            [31.483645632268495, 1.537428677697874],
            [31.480452161857613, 1.541478514057181],
            [31.47931005009359, 1.542093197236907],
            [31.478737746900833, 1.544144499801994],
            [31.478807610677094, 1.54622703062086],
            [31.48135402189385, 1.549039714546504],
            [31.482768874754548, 1.551923393984758],
            [31.48368567557061, 1.552785764570005],
            [31.483113936519825, 1.554057415692311],
            [31.482958038393843, 1.558232541918892],
            [31.48247420398516, 1.559192600565636],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 372,
        District: "HOIMA",
        County: "BUGAHYA",
        Subcounty: "KYABIGAMBIRE",
        Population: 40979,
        Key: "HOIMAKYABIGAMBIRE",
        Dist2: "Hoima",
        "Sub Country": "Kyabigambire",
        id2_original: "Hoima Kyabigambire",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.906371650488094, 1.123541564246068],
            [30.913552563680405, 1.130126466025504],
            [30.913358540155446, 1.133434966015238],
            [30.912759256063097, 1.134533801786405],
            [30.911069751389125, 1.134143326770958],
            [30.910346886961467, 1.134338750200092],
            [30.908615950189965, 1.13599928882498],
            [30.908668309394624, 1.137244533646062],
            [30.91018497281803, 1.140064505217097],
            [30.912094850400894, 1.141456051214231],
            [30.912870640870132, 1.142676805083148],
            [30.914289761626748, 1.141529049096101],
            [30.91494085245984, 1.141504556900028],
            [30.91511735254855, 1.1438241456726],
            [30.91533537636296, 1.144117117712915],
            [30.91719225603899, 1.144068076782098],
            [30.917768348325616, 1.146888170989493],
            [30.920714010380518, 1.151539268746104],
            [30.922865962372875, 1.153199390563918],
            [30.924579848221974, 1.153663125507766],
            [30.925233682509933, 1.154468823613505],
            [30.92577387901617, 1.157374389050712],
            [30.927235374203033, 1.158094536357552],
            [30.929379589005862, 1.157410628677335],
            [30.93339241548228, 1.160218163683652],
            [30.937109951351815, 1.161243281370629],
            [30.937631105370613, 1.162036778014984],
            [30.937540203948725, 1.163721576993555],
            [30.93834158831874, 1.165381870401361],
            [30.93815792596227, 1.168189870793308],
            [30.941502731057465, 1.169544679459492],
            [30.94732687915029, 1.173084573852777],
            [30.94771599519542, 1.174061233813159],
            [30.9476426621255, 1.177418626963882],
            [30.949120723144535, 1.179493950193585],
            [30.953969931456154, 1.179932971594222],
            [30.95433709986223, 1.185219319272538],
            [30.956391339406174, 1.186488823157045],
            [30.95645868250978, 1.188625343922182],
            [30.957207163296065, 1.188869448976529],
            [30.959232055777996, 1.188551817368573],
            [30.96007845652353, 1.189235424647952],
            [30.960081434438703, 1.190138875742115],
            [30.958567208144654, 1.191726168510115],
            [30.95833181360761, 1.193484254129275],
            [30.959204630212383, 1.198526397130876],
            [30.95980984228728, 1.199210030669876],
            [30.960215552910622, 1.201566284926755],
            [30.96118262973817, 1.202274303392785],
            [30.964273022063434, 1.203250724911712],
            [30.964686651336017, 1.204349483068976],
            [30.964165276331638, 1.207157557077992],
            [30.962932600912232, 1.210026735031599],
            [30.963565791016666, 1.211882418634417],
            [30.962023074653374, 1.21215114341511],
            [30.960243505787336, 1.213738437758481],
            [30.959922032883117, 1.214995967332301],
            [30.960219869315576, 1.217559794026573],
            [30.957885244910184, 1.219049448746127],
            [30.95738115708514, 1.2197820152248],
            [30.957623690533755, 1.223871926666601],
            [30.95645066863911, 1.226557941672394],
            [30.955892957679797, 1.229329374881183],
            [30.95633611367745, 1.232088517305205],
            [30.958047147375527, 1.235348133047766],
            [30.959191345027644, 1.238595591629228],
            [30.959118778220677, 1.242221597162323],
            [30.95838145271358, 1.24539592285843],
            [30.95872029364549, 1.24623912925389],
            [30.95839545924549, 1.250373951750699],
            [30.954996809132144, 1.262585256858625],
            [30.94936896808173, 1.276603719340145],
            [30.946376264848656, 1.280575348110937],
            [30.93394952277374, 1.292566194418063],
            [30.92650173448353, 1.298997834181713],
            [30.92525261540286, 1.300573985322632],
            [30.922585900904952, 1.301779909592119],
            [30.92038898913096, 1.302208297149256],
            [30.918798062881304, 1.304170761025759],
            [30.917651722747244, 1.307452462198496],
            [30.91684733171598, 1.308306800609653],
            [30.915616614623882, 1.309095084886419],
            [30.914736906144242, 1.30910313258866],
            [30.913343738614508, 1.30870530251304],
            [30.91186712478139, 1.308826382683113],
            [30.90946419877002, 1.307898723300725],
            [30.907733812665775, 1.307690245405398],
            [30.90548527111914, 1.306259383217023],
            [30.905068477980137, 1.305785336064596],
            [30.904752871973063, 1.304032684417623],
            [30.903863220939847, 1.303449308733635],
            [30.902478130162848, 1.304740793732687],
            [30.902436620810203, 1.3054999507339],
            [30.899464119789553, 1.307585620725276],
            [30.898487600770054, 1.309702846638156],
            [30.898033825787444, 1.312845503504904],
            [30.89617965992187, 1.31589982772032],
            [30.895921989860728, 1.324888510010982],
            [30.8971706040882, 1.329435489845231],
            [30.898194974566255, 1.331373264022469],
            [30.897859798760713, 1.332491677797122],
            [30.897029987203513, 1.333415789596206],
            [30.893541655580435, 1.335193984140611],
            [30.893589896907827, 1.336180416563596],
            [30.89463275561274, 1.33834383905529],
            [30.896225916870815, 1.33933746195581],
            [30.896583667339453, 1.340302824900391],
            [30.897458765665053, 1.340491765246551],
            [30.898385268286166, 1.344580951282737],
            [30.899422787405, 1.345955997980239],
            [30.898398681929958, 1.348072119634536],
            [30.89738043706384, 1.348921521701239],
            [30.89665063494724, 1.350650236819311],
            [30.896403025118957, 1.354121351662438],
            [30.896852514239345, 1.355229577265243],
            [30.89894592122801, 1.356178373616471],
            [30.899118866683132, 1.35691429266186],
            [30.89876189415555, 1.357947747854348],
            [30.90086896721462, 1.361360173777892],
            [30.900539698730384, 1.362225349225326],
            [30.89943958230757, 1.362509830813257],
            [30.89880606341973, 1.363170973570385],
            [30.898779064553867, 1.364324593780941],
            [30.899220591007587, 1.364756987478914],
            [30.899100528474918, 1.365824016877456],
            [30.90000589912731, 1.370813608236376],
            [30.901519665483914, 1.374184309225349],
            [30.902727566266094, 1.378434810664592],
            [30.901186562091738, 1.37825873972718],
            [30.900485009295853, 1.377764079989559],
            [30.898866140949316, 1.377867747931],
            [30.89566860206855, 1.376358737546853],
            [30.89294298593576, 1.376014767663987],
            [30.877323502881985, 1.381174576515641],
            [30.858783764824476, 1.382128947599147],
            [30.846368752950532, 1.384448206661974],
            [30.838126543132105, 1.385202195719591],
            [30.77409122147188, 1.385181992226432],
            [30.751623739073445, 1.384571034272797],
            [30.645835036519397, 1.387860637865858],
            [30.62266585489969, 1.389601752133083],
            [30.550234523759546, 1.306819955956562],
            [30.550470387217178, 1.206360111760132],
            [30.5625027410346, 1.194476139918966],
            [30.600091878122644, 1.163570163048935],
            [30.616177414332363, 1.150966726315912],
            [30.64432952568022, 1.131745276784424],
            [30.64964800940466, 1.127487450384903],
            [30.66235218268037, 1.120159144782479],
            [30.666053735724343, 1.118783278259996],
            [30.66698646636533, 1.118936143268703],
            [30.6678103535332, 1.118301273956296],
            [30.668229363714335, 1.117018843238651],
            [30.669245416691165, 1.114218790874374],
            [30.671566686741542, 1.112576179428238],
            [30.672843980582776, 1.110592897413252],
            [30.6775944721295, 1.108320328046578],
            [30.68097486847626, 1.107899539756301],
            [30.686234705687397, 1.108965573107006],
            [30.687505241502738, 1.108669513295451],
            [30.690378892807843, 1.108940810295274],
            [30.691164848612843, 1.108455795588935],
            [30.692320695617582, 1.108834293647773],
            [30.69351777619213, 1.108238044287723],
            [30.698202198446353, 1.108496149341492],
            [30.699174833150575, 1.108011691413682],
            [30.700481072506882, 1.108128186507083],
            [30.701117241424793, 1.107755185918216],
            [30.70163887783893, 1.108019260101106],
            [30.702500704454515, 1.107234490310245],
            [30.70451809061394, 1.106903223836094],
            [30.705193992016866, 1.105930407622248],
            [30.70680130353728, 1.105447891969596],
            [30.70777947545691, 1.10357610135871],
            [30.709089605416715, 1.102717718109315],
            [30.709391569607906, 1.101893735521885],
            [30.711468771887155, 1.100606491693869],
            [30.71225921387869, 1.098996584232321],
            [30.712855959332046, 1.099148397631123],
            [30.713422699258253, 1.097462814816153],
            [30.714168190451293, 1.097765068489909],
            [30.71417296589536, 1.096565210258694],
            [30.714846926038966, 1.096079827090698],
            [30.71601294287101, 1.093908621915851],
            [30.718478938700166, 1.093428703570842],
            [30.718970252481878, 1.091930369694463],
            [30.720491014917947, 1.089741492159675],
            [30.721238440183768, 1.089556292146664],
            [30.723713082297557, 1.086901614270733],
            [30.730410382066772, 1.083284861406277],
            [30.733175064134638, 1.082805817969901],
            [30.737907336949085, 1.080439174472704],
            [30.740642266814756, 1.078047701398053],
            [30.74195937578601, 1.075426940431339],
            [30.744919796262693, 1.072661159751248],
            [30.74660341337829, 1.071766337516812],
            [30.750663915243496, 1.070995480635291],
            [30.753653350405564, 1.070939988819276],
            [30.756961691086747, 1.072553391583795],
            [30.757830903650603, 1.072532831851395],
            [30.759013674961015, 1.071718757589805],
            [30.759952156616457, 1.072288460142175],
            [30.760463313284458, 1.073728855501163],
            [30.759738605513824, 1.075849161336446],
            [30.758224586730606, 1.0775683122438],
            [30.75839303072785, 1.07845325575447],
            [30.75909362951288, 1.078843805462074],
            [30.76005796288555, 1.078770462936959],
            [30.76179263305539, 1.080020080684028],
            [30.764391108829386, 1.079680926296922],
            [30.764764461237878, 1.080039542819692],
            [30.764710264080165, 1.081882837958521],
            [30.767103392166728, 1.083640437249747],
            [30.766262923895333, 1.08435518053095],
            [30.765560637175888, 1.086924164214473],
            [30.76587804071186, 1.088657725998362],
            [30.76714644572335, 1.090821031225466],
            [30.768279699200356, 1.091587695886753],
            [30.770256407847082, 1.091884783981465],
            [30.772300059847105, 1.093318877578042],
            [30.776433037789435, 1.10110815308445],
            [30.777602781731574, 1.102452624954051],
            [30.777736938831065, 1.104340077286332],
            [30.77973317415713, 1.10572330996726],
            [30.78077196798535, 1.10947006314664],
            [30.783039230422528, 1.111715752808795],
            [30.783198231329514, 1.112905527725593],
            [30.78400944955692, 1.113424698181491],
            [30.786912362584083, 1.11728053381505],
            [30.78798505703453, 1.117013606157618],
            [30.78956141261027, 1.118531589550371],
            [30.790649634440378, 1.119028064711747],
            [30.793473697843478, 1.119280343459325],
            [30.79451188890218, 1.120858124965318],
            [30.795042671962538, 1.121032472556539],
            [30.800929093965813, 1.120161468279988],
            [30.802770424702587, 1.120287929592189],
            [30.803844498067015, 1.11915176338215],
            [30.804150231589126, 1.118196931156032],
            [30.805686857374766, 1.11790247635727],
            [30.808199561107134, 1.115511520046007],
            [30.80801620866943, 1.115016298101186],
            [30.80851366962265, 1.114493659288369],
            [30.808017809467255, 1.112856032704869],
            [30.807068861540472, 1.112843950846939],
            [30.80765017663218, 1.112139253855273],
            [30.807476625712543, 1.111400289720295],
            [30.8083013734665, 1.111321318410716],
            [30.80865209551635, 1.110628021229471],
            [30.809228130310824, 1.110787629945285],
            [30.8094885761662, 1.109957826913865],
            [30.811952837348517, 1.107935834788602],
            [30.813319889056338, 1.10780041482428],
            [30.813728030520824, 1.105833731873973],
            [30.814507573253046, 1.10577746200464],
            [30.816519056582703, 1.10764317436212],
            [30.817421259775394, 1.107109903770109],
            [30.818166830020186, 1.107167307076385],
            [30.81979283817662, 1.108237286251463],
            [30.820545286821513, 1.110113026663806],
            [30.822839291206392, 1.112323785143026],
            [30.823232764978936, 1.11319223741553],
            [30.82400525054626, 1.11357966962022],
            [30.82403600796328, 1.114471166136279],
            [30.825594876035353, 1.114676986914067],
            [30.82634172188785, 1.116399413518414],
            [30.83008555144573, 1.119229501330052],
            [30.830319719782405, 1.120735584971971],
            [30.831736443833858, 1.122024669303865],
            [30.83336554938139, 1.121966985168401],
            [30.833569918803484, 1.123752603493466],
            [30.834893637578585, 1.124284058617599],
            [30.836448080549587, 1.125734297684113],
            [30.837386904463155, 1.125230412192755],
            [30.837852300052283, 1.126093619986009],
            [30.83850464403519, 1.126162797560172],
            [30.839484956640135, 1.127397351536822],
            [30.842166193302923, 1.129244835865719],
            [30.842646029310256, 1.130231006888473],
            [30.844174790345612, 1.13057506294259],
            [30.84632713310511, 1.13233425451111],
            [30.846512602871933, 1.133165735209789],
            [30.847213898749615, 1.132817832730603],
            [30.8482903274967, 1.133352091088061],
            [30.849554385560566, 1.135001895721619],
            [30.849103194132677, 1.135683041589428],
            [30.850448106860295, 1.135313442172526],
            [30.850380467312675, 1.136239912752761],
            [30.85140683025403, 1.136577601188905],
            [30.851478571509226, 1.137644559942296],
            [30.852694706249302, 1.137886930611616],
            [30.853224277482344, 1.138527471881174],
            [30.85356889278489, 1.140290934642463],
            [30.85461715126299, 1.14120140061666],
            [30.853791393802666, 1.141200779105804],
            [30.85378558080448, 1.141515231258327],
            [30.854231593444734, 1.141976022207642],
            [30.85554830805556, 1.142021935861717],
            [30.855944010548342, 1.142611841062864],
            [30.85684769326629, 1.142865209894585],
            [30.8566124963586, 1.14402178594353],
            [30.858988011177367, 1.145814861356858],
            [30.862251103717686, 1.147024616602486],
            [30.86305518752515, 1.146166077284638],
            [30.864142184053215, 1.147514576299363],
            [30.865564845070356, 1.147661646820507],
            [30.867053798162235, 1.148701606220861],
            [30.869771558527844, 1.147973656235587],
            [30.872705486788522, 1.149183163581194],
            [30.873397885751615, 1.14845930113016],
            [30.874145516731677, 1.14849355509416],
            [30.874703784646456, 1.148067205973672],
            [30.875307862149153, 1.148567027011994],
            [30.876243534772666, 1.148337898446526],
            [30.87820561615162, 1.143375367594445],
            [30.8811972036771, 1.14207482624195],
            [30.88270356432253, 1.14223317764009],
            [30.883800257265808, 1.143608537272311],
            [30.885151938799083, 1.143661311763753],
            [30.88635670715586, 1.144229364077387],
            [30.88710460763048, 1.143904225298686],
            [30.887572854472328, 1.144356434174121],
            [30.888331758410867, 1.144388063833517],
            [30.888744462418714, 1.144691246724565],
            [30.888904137062152, 1.145692017951379],
            [30.890467823697424, 1.145630660912442],
            [30.8909993532578, 1.143626346417944],
            [30.892132237527203, 1.143312720781998],
            [30.892724371029892, 1.142358535078395],
            [30.893823860428633, 1.141932575734834],
            [30.89362948476408, 1.140685803411702],
            [30.896129649811694, 1.139985717903869],
            [30.899107145465308, 1.135063151497436],
            [30.897892010550166, 1.133383238567325],
            [30.89750234114286, 1.132136322441962],
            [30.897703835057712, 1.13126607412506],
            [30.90126615462253, 1.127730931108232],
            [30.903068887446484, 1.126996614294677],
            [30.906371650488094, 1.123541564246068],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 373,
        District: "HOIMA",
        County: "BUHAGUZI",
        Subcounty: "KYANGWALI",
        Population: 96089,
        Key: "HOIMAKYANGWALI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.397274110700412, 1.505621049299068],
            [31.39271425333507, 1.50526123118081],
            [31.38952659682071, 1.503685285206407],
            [31.385909685737744, 1.503139024532997],
            [31.384927930438458, 1.4977483739892],
            [31.38388881321672, 1.494763614817686],
            [31.379939463494868, 1.493603872830463],
            [31.372068389042802, 1.492160026615984],
            [31.37119271040554, 1.492301551295907],
            [31.36799190884365, 1.490810201229821],
            [31.36534229737041, 1.490497094331594],
            [31.365388623489626, 1.487411733540057],
            [31.359117505152447, 1.489760944921152],
            [31.352971899426752, 1.490854676132744],
            [31.34756624139047, 1.493120521549322],
            [31.345633691228173, 1.494650091135246],
            [31.344231081506475, 1.495128305465765],
            [31.341260667272255, 1.495864934411945],
            [31.337589945307123, 1.495522644728116],
            [31.335261287511887, 1.496053395991849],
            [31.33387126588225, 1.497383659530523],
            [31.332459980231558, 1.500584417309663],
            [31.33163148021469, 1.502827064353304],
            [31.33181481738104, 1.505276845696755],
            [31.331404320533867, 1.505809059239638],
            [31.330134086552423, 1.506167535648121],
            [31.327959519472802, 1.504122273710953],
            [31.325856255270523, 1.503987514472473],
            [31.32380439087221, 1.50583646276205],
            [31.322804057514514, 1.507879262558932],
            [31.321122815544513, 1.509435598489547],
            [31.319521908113774, 1.509740554194238],
            [31.31696261236088, 1.50914612342771],
            [31.315136696714365, 1.509610657094275],
            [31.311038443149368, 1.51475297104654],
            [31.308790014790436, 1.514178739504858],
            [31.30447055467998, 1.514108771708483],
            [31.30340340912303, 1.512185172326442],
            [31.3009749898222, 1.509933225314458],
            [31.299421586201973, 1.507486315636565],
            [31.295679367323423, 1.507189884372603],
            [31.29397913496831, 1.506063530512121],
            [31.29269596794175, 1.506246065278759],
            [31.292262752701014, 1.503315590497877],
            [31.289379820002427, 1.502195024983009],
            [31.285527523365552, 1.499284544297156],
            [31.288146196860424, 1.494524702044843],
            [31.28966649935904, 1.49310099251988],
            [31.295910790408605, 1.490339271526687],
            [31.300568466223517, 1.486422028245082],
            [31.299354299692247, 1.485012023457168],
            [31.297705087153716, 1.484745314307451],
            [31.29672712454158, 1.483519756978244],
            [31.295880681575223, 1.483292778494376],
            [31.293957817946623, 1.480861661246454],
            [31.290693790260093, 1.479227790130731],
            [31.292943973927052, 1.478260825235602],
            [31.298216864557617, 1.474228156302049],
            [31.299984643933872, 1.471884987390689],
            [31.30104341629404, 1.469020034107644],
            [31.302457210939323, 1.469220213541212],
            [31.306622711488206, 1.468199918056061],
            [31.306962326767874, 1.46737164318559],
            [31.308948645591514, 1.466300936441413],
            [31.309270558670214, 1.465236631180762],
            [31.313109095811885, 1.469843559638989],
            [31.318650980666025, 1.470358281126767],
            [31.323655911932153, 1.47261920750991],
            [31.326324688961968, 1.472784724901968],
            [31.329642156526432, 1.473582309787896],
            [31.33018700630583, 1.472806735335817],
            [31.330208661992362, 1.47171602243709],
            [31.328042842706974, 1.462108257756386],
            [31.326295203559404, 1.458680036903135],
            [31.324781290777373, 1.457786783749505],
            [31.32741460950629, 1.455511711976751],
            [31.3284233133658, 1.45546254149116],
            [31.332320197881778, 1.451712773791934],
            [31.33465998400676, 1.447756736201714],
            [31.33414003732369, 1.44649883676892],
            [31.338099440091895, 1.446038800702038],
            [31.337939354918348, 1.445639165997491],
            [31.3392853087934, 1.445749576010574],
            [31.340740554400824, 1.445073313136908],
            [31.341279609148316, 1.444193173029622],
            [31.342569367114148, 1.443271903692357],
            [31.34737649025301, 1.441778145650583],
            [31.351592970194243, 1.43788049429913],
            [31.35301653850985, 1.435784668865427],
            [31.359004587819527, 1.432776842831132],
            [31.35957612834265, 1.431287813262771],
            [31.360569285957826, 1.43031775294704],
            [31.36188091790081, 1.430998407992399],
            [31.365650422207796, 1.434895151496709],
            [31.365451260319443, 1.435926803276794],
            [31.36703409813827, 1.438219451223093],
            [31.36769793606524, 1.440696206763012],
            [31.369498985446334, 1.44254154720983],
            [31.36970880225233, 1.443556715778961],
            [31.370913998207154, 1.443118160900523],
            [31.37156376043194, 1.44407249845825],
            [31.374758540586487, 1.445829013886454],
            [31.376615977218016, 1.454513178408289],
            [31.38056537634718, 1.458104177028757],
            [31.382560561542668, 1.460862142102453],
            [31.38599461426133, 1.467983482564888],
            [31.390126216882972, 1.471554086265539],
            [31.388314996776206, 1.473155823841227],
            [31.38671671601935, 1.473901216682587],
            [31.388427341882277, 1.475625293971027],
            [31.38951011812515, 1.47757862548744],
            [31.390093140015917, 1.481015289201461],
            [31.388243953511953, 1.483303548379543],
            [31.390937506077314, 1.482381009149292],
            [31.39142582128262, 1.482627176501486],
            [31.39252184228603, 1.486891821900728],
            [31.392126096674126, 1.488536561384067],
            [31.391373701928156, 1.489727236257901],
            [31.391813829704958, 1.491646761377494],
            [31.393353421727685, 1.493084934299995],
            [31.395082012099703, 1.492991665153755],
            [31.396847728045728, 1.493522399967004],
            [31.39876157977541, 1.49703930196974],
            [31.399360403031988, 1.500350199953568],
            [31.39875714658947, 1.503129296432214],
            [31.397274110700412, 1.505621049299068],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 374,
        District: "HOIMA",
        County: "HOIMA MUNICIPALITY",
        Subcounty: "BUJUMBURA DIVISION",
        Population: 22199,
        Key: "HOIMABUJUMBURA DIVISION",
        Dist2: "Hoima",
        "Sub Country": "Bujumbura Division",
        id2_original: "Hoima Bujumbura Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.33414003732369, 1.44649883676892],
            [31.33465998400676, 1.447756736201714],
            [31.332320197881778, 1.451712773791934],
            [31.3284233133658, 1.45546254149116],
            [31.32741460950629, 1.455511711976751],
            [31.324781290777373, 1.457786783749505],
            [31.326295203559404, 1.458680036903135],
            [31.328042842706974, 1.462108257756386],
            [31.330208661992362, 1.47171602243709],
            [31.33018700630583, 1.472806735335817],
            [31.329642156526432, 1.473582309787896],
            [31.326324688961968, 1.472784724901968],
            [31.323655911932153, 1.47261920750991],
            [31.318650980666025, 1.470358281126767],
            [31.313109095811885, 1.469843559638989],
            [31.309270558670214, 1.465236631180762],
            [31.308948645591514, 1.466300936441413],
            [31.306962326767874, 1.46737164318559],
            [31.306622711488206, 1.468199918056061],
            [31.302457210939323, 1.469220213541212],
            [31.30104341629404, 1.469020034107644],
            [31.299984643933872, 1.471884987390689],
            [31.298216864557617, 1.474228156302049],
            [31.292943973927052, 1.478260825235602],
            [31.290693790260093, 1.479227790130731],
            [31.28795481258577, 1.479778995826128],
            [31.283287818546366, 1.477686098313993],
            [31.281990738412695, 1.478687174602775],
            [31.278213690952214, 1.479780846636463],
            [31.27337802743847, 1.477196217663078],
            [31.27174941416771, 1.476797888831283],
            [31.276364874554194, 1.474039286058862],
            [31.2771922894062, 1.473191234501413],
            [31.27864158457318, 1.469988949024707],
            [31.281902107033506, 1.465964323972047],
            [31.28313480041918, 1.464891921987841],
            [31.284854895423546, 1.464327451522367],
            [31.28642713581695, 1.462498132529009],
            [31.288964741747286, 1.460572068881218],
            [31.288292627641624, 1.459496875955754],
            [31.283935802106896, 1.455273946258073],
            [31.282590361169884, 1.45240231380421],
            [31.28260146434681, 1.44864974187437],
            [31.281147732400594, 1.44685138677034],
            [31.279695983036245, 1.442423736370497],
            [31.276937679905203, 1.438377842560368],
            [31.275427050465566, 1.435289768078764],
            [31.27179276776163, 1.430760632526695],
            [31.27136868748904, 1.422972293977198],
            [31.272164760120784, 1.41789726407585],
            [31.269753819340444, 1.412000655287979],
            [31.26935147919605, 1.407821634058595],
            [31.267832932005494, 1.406686937071855],
            [31.267168410460563, 1.403443855236892],
            [31.26900986157158, 1.402915828490014],
            [31.27019398574482, 1.402122608562446],
            [31.27262322880076, 1.394202280211165],
            [31.27493521386434, 1.392464520861375],
            [31.277749343697035, 1.388979685527601],
            [31.27929995894661, 1.38375146557],
            [31.28162952763357, 1.383658632000804],
            [31.285866585283042, 1.382631271317523],
            [31.287841160430958, 1.379834413312145],
            [31.28917573624461, 1.378795473248048],
            [31.290135914010776, 1.376892568080964],
            [31.29110311211086, 1.37631054246731],
            [31.29463051775386, 1.372225453185353],
            [31.296144728776557, 1.369695069313217],
            [31.29843610918248, 1.36884938353522],
            [31.299624507539846, 1.367400996353508],
            [31.300887279216166, 1.367401898903264],
            [31.301900019206236, 1.368357235517571],
            [31.303788944483394, 1.369229341460721],
            [31.306287468309012, 1.368819156667635],
            [31.307274525465097, 1.368239177561863],
            [31.30828034124094, 1.368555456014659],
            [31.311543905396803, 1.366584497607775],
            [31.31293424682664, 1.366803289206686],
            [31.31536325991388, 1.365698254339536],
            [31.317881589794837, 1.365249832231104],
            [31.31837139350857, 1.363302684098473],
            [31.31940534811239, 1.362301302767288],
            [31.321819384487195, 1.362350270461275],
            [31.323922520230383, 1.363732012898403],
            [31.32608301520107, 1.363676805505651],
            [31.331784094099984, 1.364635643342845],
            [31.333117215541197, 1.365695415571525],
            [31.335172065041238, 1.369015182270656],
            [31.33792325710846, 1.370558101686671],
            [31.340684532764765, 1.371108362591435],
            [31.341925699060234, 1.369312975877838],
            [31.34323209023185, 1.368283403382674],
            [31.345279344476133, 1.369022240115275],
            [31.346687498599746, 1.370271146002993],
            [31.346987229579153, 1.371519281603904],
            [31.34768195338223, 1.372087004121916],
            [31.350327196348214, 1.372307558105646],
            [31.352181001989347, 1.372685738226607],
            [31.352631512494238, 1.37323438393502],
            [31.355586631114118, 1.378804860618914],
            [31.356007184600905, 1.381934438090531],
            [31.36271753239963, 1.390684121682343],
            [31.36351280373412, 1.390992183580767],
            [31.3648954879245, 1.390436424921754],
            [31.367064827707512, 1.387272779398514],
            [31.372404190974127, 1.39192787126175],
            [31.37401190044822, 1.394393851191412],
            [31.376180809039855, 1.394817908222882],
            [31.379644206125604, 1.393522162199264],
            [31.378793001189933, 1.396075369720245],
            [31.37577749152845, 1.39810894877215],
            [31.376030321466832, 1.399884716490563],
            [31.37684105729896, 1.401241956341737],
            [31.376162876870165, 1.403828049080079],
            [31.373483827605074, 1.402537635241419],
            [31.369475007614774, 1.399254250471125],
            [31.367934673583623, 1.398931731089201],
            [31.36320896655559, 1.399958904166267],
            [31.361837750258125, 1.399598684856643],
            [31.36069159787196, 1.399786957767536],
            [31.35724259898359, 1.402006221757235],
            [31.356772047064723, 1.403253822450116],
            [31.355024269576564, 1.404065628843319],
            [31.347049320233264, 1.403785790643138],
            [31.345536206053524, 1.404853010817626],
            [31.341646773062838, 1.405568731231574],
            [31.340331263092782, 1.406153934093826],
            [31.33850739111353, 1.408308125164431],
            [31.337406123050542, 1.411436587533951],
            [31.337122174572375, 1.41444273602864],
            [31.336529294569694, 1.415964391529051],
            [31.334236714912887, 1.416737952223551],
            [31.33273206735472, 1.419081433088458],
            [31.33315319486494, 1.421284503199162],
            [31.334185562145663, 1.422570987586909],
            [31.334297157158456, 1.424140420534756],
            [31.334152534685913, 1.425364919895892],
            [31.33312642956106, 1.426276642229656],
            [31.333044907449036, 1.428129122019303],
            [31.33227298692202, 1.430444706410324],
            [31.330205425362415, 1.431785645202081],
            [31.325565261305627, 1.431422983692217],
            [31.32402416819805, 1.432178159122903],
            [31.32622012775785, 1.435110481981813],
            [31.327786437473748, 1.438429953573741],
            [31.32906307105325, 1.439659903538025],
            [31.330753385109308, 1.440398556959233],
            [31.33128641305954, 1.44369836566748],
            [31.33267611938049, 1.4444557066769],
            [31.33414003732369, 1.44649883676892],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 375,
        District: "HOIMA",
        County: "HOIMA MUNICIPALITY",
        Subcounty: "BUSIISI DIVISION",
        Population: 19287,
        Key: "HOIMABUSIISI DIVISION",
        Dist2: "Hoima",
        "Sub Country": "Busiisi Division",
        id2_original: "Hoima Busiisi Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.374758540586487, 1.445829013886454],
            [31.37156376043194, 1.44407249845825],
            [31.370913998207154, 1.443118160900523],
            [31.36970880225233, 1.443556715778961],
            [31.369498985446334, 1.44254154720983],
            [31.36769793606524, 1.440696206763012],
            [31.36703409813827, 1.438219451223093],
            [31.365451260319443, 1.435926803276794],
            [31.365650422207796, 1.434895151496709],
            [31.36188091790081, 1.430998407992399],
            [31.360569285957826, 1.43031775294704],
            [31.35957612834265, 1.431287813262771],
            [31.359004587819527, 1.432776842831132],
            [31.35301653850985, 1.435784668865427],
            [31.351592970194243, 1.43788049429913],
            [31.34737649025301, 1.441778145650583],
            [31.342569367114148, 1.443271903692357],
            [31.341279609148316, 1.444193173029622],
            [31.340740554400824, 1.445073313136908],
            [31.3392853087934, 1.445749576010574],
            [31.337939354918348, 1.445639165997491],
            [31.338099440091895, 1.446038800702038],
            [31.33414003732369, 1.44649883676892],
            [31.33267611938049, 1.4444557066769],
            [31.33128641305954, 1.44369836566748],
            [31.330753385109308, 1.440398556959233],
            [31.32906307105325, 1.439659903538025],
            [31.327786437473748, 1.438429953573741],
            [31.32622012775785, 1.435110481981813],
            [31.32402416819805, 1.432178159122903],
            [31.325565261305627, 1.431422983692217],
            [31.330205425362415, 1.431785645202081],
            [31.33227298692202, 1.430444706410324],
            [31.333044907449036, 1.428129122019303],
            [31.33312642956106, 1.426276642229656],
            [31.334152534685913, 1.425364919895892],
            [31.334297157158456, 1.424140420534756],
            [31.334185562145663, 1.422570987586909],
            [31.33315319486494, 1.421284503199162],
            [31.33273206735472, 1.419081433088458],
            [31.334236714912887, 1.416737952223551],
            [31.336529294569694, 1.415964391529051],
            [31.337122174572375, 1.41444273602864],
            [31.337406123050542, 1.411436587533951],
            [31.33850739111353, 1.408308125164431],
            [31.340331263092782, 1.406153934093826],
            [31.341646773062838, 1.405568731231574],
            [31.345536206053524, 1.404853010817626],
            [31.347049320233264, 1.403785790643138],
            [31.355024269576564, 1.404065628843319],
            [31.356772047064723, 1.403253822450116],
            [31.35724259898359, 1.402006221757235],
            [31.36069159787196, 1.399786957767536],
            [31.361837750258125, 1.399598684856643],
            [31.36320896655559, 1.399958904166267],
            [31.367934673583623, 1.398931731089201],
            [31.369475007614774, 1.399254250471125],
            [31.373483827605074, 1.402537635241419],
            [31.376162876870165, 1.403828049080079],
            [31.375611526881364, 1.404940513652544],
            [31.375448718015917, 1.407552615047439],
            [31.37443858853008, 1.409465152111483],
            [31.3749114545091, 1.41681134459678],
            [31.374625412058034, 1.419437449252825],
            [31.371530731175593, 1.421974675635633],
            [31.367821253194155, 1.42150245094668],
            [31.365029018898216, 1.421682704395151],
            [31.363765412686988, 1.423152964898587],
            [31.36377066064486, 1.427421604953297],
            [31.362967944971583, 1.428461143955631],
            [31.36440583782271, 1.429460687568955],
            [31.364885418708504, 1.429394464617672],
            [31.365778839970936, 1.428696147422285],
            [31.36607717676501, 1.427714490565543],
            [31.366730741558378, 1.427140814959162],
            [31.369682963111483, 1.426285868661429],
            [31.371552621322433, 1.424689579564926],
            [31.372362916980048, 1.424623589067999],
            [31.373007376449735, 1.425239799944366],
            [31.373427484372126, 1.427445155062904],
            [31.37329328595017, 1.430157695196117],
            [31.373722380618656, 1.431339578694197],
            [31.37546628726625, 1.432214526832268],
            [31.376506995404352, 1.433696405651154],
            [31.378452624138895, 1.434609559733264],
            [31.378875259920513, 1.435166809336962],
            [31.378472995234574, 1.436216833853212],
            [31.377108173145317, 1.437424017189663],
            [31.37689979633877, 1.440548001956653],
            [31.375404537971935, 1.441934299745763],
            [31.374758540586487, 1.445829013886454],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 376,
        District: "HOIMA",
        County: "HOIMA MUNICIPALITY",
        Subcounty: "KAHOORA DIVISON",
        Population: 35458,
        Key: "HOIMAKAHOORA DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.435338887765077, 1.455270365830266],
            [31.43541457172607, 1.457159197419599],
            [31.433226118488783, 1.459870017407939],
            [31.43075929620957, 1.460687104780731],
            [31.428927715786887, 1.462067576424757],
            [31.424680914111534, 1.463190454006235],
            [31.424121541268953, 1.463215646227813],
            [31.42400069271043, 1.462883958948431],
            [31.41775939754235, 1.462773495892256],
            [31.412424004829276, 1.463846622695903],
            [31.407313346345795, 1.464287357537305],
            [31.405719629928885, 1.463814080170314],
            [31.404529269650958, 1.462886855969006],
            [31.40303308601938, 1.457131924406695],
            [31.401157800761485, 1.452093184263326],
            [31.400562900447728, 1.451784560269348],
            [31.401188029070813, 1.455693540568806],
            [31.40100048239906, 1.457172283436719],
            [31.398795901707448, 1.460753836896914],
            [31.39850386479848, 1.463627689384139],
            [31.39598748156674, 1.465683928489012],
            [31.393873690007645, 1.466857027874425],
            [31.39304329544383, 1.467812647637336],
            [31.392037511109027, 1.470401960794781],
            [31.391947078607686, 1.473024979866421],
            [31.390126216882972, 1.471554086265539],
            [31.38599461426133, 1.467983482564888],
            [31.382560561542668, 1.460862142102453],
            [31.38056537634718, 1.458104177028757],
            [31.376615977218016, 1.454513178408289],
            [31.374758540586487, 1.445829013886454],
            [31.375404537971935, 1.441934299745763],
            [31.37689979633877, 1.440548001956653],
            [31.377108173145317, 1.437424017189663],
            [31.378472995234574, 1.436216833853212],
            [31.378875259920513, 1.435166809336962],
            [31.378452624138895, 1.434609559733264],
            [31.376506995404352, 1.433696405651154],
            [31.37546628726625, 1.432214526832268],
            [31.373722380618656, 1.431339578694197],
            [31.37329328595017, 1.430157695196117],
            [31.373427484372126, 1.427445155062904],
            [31.373007376449735, 1.425239799944366],
            [31.372362916980048, 1.424623589067999],
            [31.371552621322433, 1.424689579564926],
            [31.369682963111483, 1.426285868661429],
            [31.366730741558378, 1.427140814959162],
            [31.36607717676501, 1.427714490565543],
            [31.365778839970936, 1.428696147422285],
            [31.364885418708504, 1.429394464617672],
            [31.36440583782271, 1.429460687568955],
            [31.362967944971583, 1.428461143955631],
            [31.36377066064486, 1.427421604953297],
            [31.363765412686988, 1.423152964898587],
            [31.365029018898216, 1.421682704395151],
            [31.367821253194155, 1.42150245094668],
            [31.371530731175593, 1.421974675635633],
            [31.374625412058034, 1.419437449252825],
            [31.3749114545091, 1.41681134459678],
            [31.37443858853008, 1.409465152111483],
            [31.375448718015917, 1.407552615047439],
            [31.375611526881364, 1.404940513652544],
            [31.376162876870165, 1.403828049080079],
            [31.37684105729896, 1.401241956341737],
            [31.376030321466832, 1.399884716490563],
            [31.37577749152845, 1.39810894877215],
            [31.378793001189933, 1.396075369720245],
            [31.379644206125604, 1.393522162199264],
            [31.376180809039855, 1.394817908222882],
            [31.37401190044822, 1.394393851191412],
            [31.372404190974127, 1.39192787126175],
            [31.367064827707512, 1.387272779398514],
            [31.3648954879245, 1.390436424921754],
            [31.36351280373412, 1.390992183580767],
            [31.36271753239963, 1.390684121682343],
            [31.356007184600905, 1.381934438090531],
            [31.355586631114118, 1.378804860618914],
            [31.352631512494238, 1.37323438393502],
            [31.352181001989347, 1.372685738226607],
            [31.350327196348214, 1.372307558105646],
            [31.35137761617287, 1.370376515192176],
            [31.356891014551064, 1.366247434197018],
            [31.35878247128071, 1.362893390068314],
            [31.35973412313649, 1.358995321047203],
            [31.362777956678887, 1.356595125406462],
            [31.3649335145088, 1.358916752242785],
            [31.371223271091495, 1.361725201715114],
            [31.374954277198704, 1.362656149241687],
            [31.376678746100172, 1.362372228959377],
            [31.378124059933818, 1.361422519916216],
            [31.37884737172249, 1.359969011104137],
            [31.38151480577098, 1.359467508847879],
            [31.38307027821129, 1.359971868738189],
            [31.388735792808106, 1.36310739533753],
            [31.389903287368814, 1.362157485418367],
            [31.391238145253457, 1.360201067682362],
            [31.396681766093636, 1.36283312746995],
            [31.399404787891875, 1.36233164107643],
            [31.40128410568708, 1.362449948983318],
            [31.404901644692412, 1.362141710969349],
            [31.40562373567063, 1.362533659971585],
            [31.406288564439365, 1.3654980641606],
            [31.406508164797085, 1.369524723753721],
            [31.40767200051961, 1.374111257681647],
            [31.41066987535378, 1.378139792287608],
            [31.410633749604635, 1.379305283857256],
            [31.411748786145974, 1.381594556955868],
            [31.41431016239704, 1.384092623427435],
            [31.417232064911012, 1.388390385067687],
            [31.41882272166608, 1.389764449350402],
            [31.423503802187437, 1.390714138128226],
            [31.426849638548564, 1.39233515136607],
            [31.431216543180756, 1.396425433540058],
            [31.434002253012814, 1.400073931429885],
            [31.432817421865458, 1.415193922532525],
            [31.43061212880985, 1.424843962997373],
            [31.434181563031718, 1.433217061060192],
            [31.434584721541334, 1.439212970169518],
            [31.434198950822363, 1.442802417895343],
            [31.436616371150834, 1.449460959310408],
            [31.436349708953717, 1.450358528984915],
            [31.434283086133547, 1.451601346604842],
            [31.434502184333056, 1.453852829379046],
            [31.435338887765077, 1.455270365830266],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 377,
        District: "HOIMA",
        County: "HOIMA MUNICIPALITY",
        Subcounty: "MPARO DIVISON",
        Population: 23155,
        Key: "HOIMAMPARO DIVISON",
        Dist2: "Hoima",
        "Sub Country": "Mparo Division",
        id2_original: "Hoima Mparo Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.628369000882515, 1.656916698149002],
            [31.62657211159948, 1.657805321510348],
            [31.625479761112306, 1.657349129691152],
            [31.623826257321646, 1.657928247598374],
            [31.62313550676706, 1.658498315009308],
            [31.619937128859807, 1.663828634265372],
            [31.61733133001964, 1.665000864934188],
            [31.614400208994223, 1.667971906674747],
            [31.610740328796297, 1.667627244303938],
            [31.608599320979042, 1.668288309190391],
            [31.606965239663158, 1.670631503820854],
            [31.606762854619515, 1.675589249389324],
            [31.609008643728146, 1.681943625901574],
            [31.60674577854429, 1.682157364241716],
            [31.605024620832957, 1.682866403203428],
            [31.587528461929242, 1.696735940046418],
            [31.585220203077455, 1.697730174952182],
            [31.582914720019907, 1.697604035012335],
            [31.574571431765676, 1.692703983148357],
            [31.569364531375932, 1.686799348266769],
            [31.562357511361352, 1.68847290564678],
            [31.548635346544447, 1.688847247052892],
            [31.548199368085935, 1.692087854131382],
            [31.546817408835985, 1.693394746429995],
            [31.547099180696218, 1.694778199195835],
            [31.54897041006059, 1.697429865265526],
            [31.54837377060843, 1.698381572496982],
            [31.537369266444152, 1.697871381996372],
            [31.538271790335376, 1.688696645258447],
            [31.5382509440309, 1.687528518828448],
            [31.537680999814047, 1.687312259702055],
            [31.510073166018735, 1.686787274753527],
            [31.50073101045741, 1.685998375647632],
            [31.496392830354708, 1.687795437993424],
            [31.485325021014052, 1.690187044179758],
            [31.480279617051124, 1.691756992613164],
            [31.46907705592626, 1.6915120408015],
            [31.462586662421476, 1.690837942321641],
            [31.45678093248691, 1.689731558479792],
            [31.452127981810357, 1.689531086911621],
            [31.451164783908215, 1.689987704941453],
            [31.446990629888198, 1.687444646282747],
            [31.44336261652664, 1.682168815519445],
            [31.442588748452085, 1.681898559779937],
            [31.43093385234403, 1.680840553055713],
            [31.426662603018197, 1.679578800213738],
            [31.42106783524159, 1.676668195107299],
            [31.415276764914122, 1.67726266553239],
            [31.41185428878452, 1.675701990930279],
            [31.40905585251985, 1.675579857927152],
            [31.40535013668286, 1.674558214016332],
            [31.402967989602313, 1.675095516484422],
            [31.40269811952129, 1.677462086885799],
            [31.403232838999227, 1.678900562637181],
            [31.40424384793572, 1.680399349423604],
            [31.405434125568647, 1.681119348243017],
            [31.406773700506843, 1.681300202734366],
            [31.409808559879576, 1.683579602005435],
            [31.410953186028074, 1.685527892694312],
            [31.410683287200975, 1.687924384588588],
            [31.408865647733187, 1.689840277398899],
            [31.407568109458694, 1.692865085843872],
            [31.406912615982392, 1.693493676886079],
            [31.40533562439945, 1.692383887837234],
            [31.400184686356916, 1.692918867851787],
            [31.396359493688827, 1.692346468673624],
            [31.39260724422179, 1.693601605422234],
            [31.3896813028823, 1.696251444935358],
            [31.388704005023484, 1.690283782965988],
            [31.3882439391389, 1.689648249925851],
            [31.3867004735807, 1.689226392285054],
            [31.385916381779875, 1.688487590316159],
            [31.38564589006469, 1.685517617720184],
            [31.384308650746213, 1.683259153204489],
            [31.383739647065493, 1.68028035677162],
            [31.380790361206728, 1.678029138775702],
            [31.380442840752536, 1.675376633643102],
            [31.380813932101468, 1.670098420418712],
            [31.378473179389214, 1.664251424948443],
            [31.379866610125326, 1.660381566897218],
            [31.379341387636575, 1.655969489185011],
            [31.378882063760468, 1.65442416686991],
            [31.37657308984969, 1.651426784292914],
            [31.375067314905834, 1.64666197058329],
            [31.373049038515994, 1.642806530678552],
            [31.373314860788323, 1.64104722191346],
            [31.375484743153752, 1.63672310482469],
            [31.375323565628864, 1.635650141046247],
            [31.3739778821467, 1.633262965752966],
            [31.373306451658962, 1.63033561052082],
            [31.37497256150799, 1.62667200760578],
            [31.374651069739166, 1.623410189714038],
            [31.374132043829256, 1.621839076340025],
            [31.36873720330563, 1.616813649135964],
            [31.367706708113964, 1.614933134588938],
            [31.36782708236206, 1.613714438448376],
            [31.370106552005627, 1.610909644470893],
            [31.372529576024828, 1.609915973086941],
            [31.372888209537415, 1.609384106410987],
            [31.374487155945886, 1.604295649144017],
            [31.377839806926804, 1.603328448304406],
            [31.380552852035482, 1.602283478833209],
            [31.38191708752486, 1.602782385799434],
            [31.383315859643655, 1.602766338287828],
            [31.385739463076252, 1.601017321302838],
            [31.387633085644033, 1.600778498624168],
            [31.38867337157396, 1.601105467301904],
            [31.39047118522345, 1.602637933945586],
            [31.395965020989674, 1.605242187403675],
            [31.400229790767344, 1.605756075255246],
            [31.4017700421535, 1.606362363295565],
            [31.40365672343908, 1.608491058035329],
            [31.40632350261571, 1.610176008118844],
            [31.418441195486793, 1.612170934316096],
            [31.42161506465817, 1.614196644178198],
            [31.428764539510496, 1.614192771281887],
            [31.435067055763465, 1.616060186205327],
            [31.43651394793711, 1.615947863332541],
            [31.438017810367715, 1.615060310648089],
            [31.44024684320135, 1.611856989622908],
            [31.444401006112994, 1.607472515524053],
            [31.446535077139632, 1.607212982108254],
            [31.44855443869437, 1.608554334674515],
            [31.450910616378355, 1.611118293606503],
            [31.45350228831237, 1.612878810188834],
            [31.457785940677326, 1.613468265663415],
            [31.460084569589256, 1.605150051036125],
            [31.46143942576875, 1.602503828422198],
            [31.462473527696297, 1.601615890947639],
            [31.464155681456283, 1.601002616234503],
            [31.470413496642426, 1.599948426169887],
            [31.472585030111343, 1.598200965650062],
            [31.47399448319886, 1.597918382069185],
            [31.477209234698805, 1.595651687562758],
            [31.48244151788524, 1.596648326466539],
            [31.48402004918058, 1.596403681762031],
            [31.486633825958837, 1.593739413083696],
            [31.488260752193476, 1.591556597725331],
            [31.488769062100374, 1.590214415997939],
            [31.489195469009548, 1.585213189598731],
            [31.488850301243083, 1.581837636596542],
            [31.487687199444146, 1.579265175972891],
            [31.488019088314047, 1.575020295590988],
            [31.487719268401463, 1.573885516858282],
            [31.48617935388355, 1.57271201764297],
            [31.483557299129973, 1.573929747582551],
            [31.479912018352007, 1.574002708160878],
            [31.47748336728586, 1.573247046572196],
            [31.478116669679693, 1.571462537205188],
            [31.479116677847234, 1.570068099024196],
            [31.479097639851414, 1.568201032158271],
            [31.479782449847022, 1.565667679698805],
            [31.48247420398516, 1.559192600565636],
            [31.487529190277225, 1.558985326397009],
            [31.49009761291339, 1.558441589678033],
            [31.495406682293687, 1.555889769184266],
            [31.496862121937248, 1.555574942225228],
            [31.500882068460633, 1.556630411064758],
            [31.50228673622264, 1.558247616360978],
            [31.506871742822685, 1.559190991380661],
            [31.51095368388046, 1.561729960450629],
            [31.5206476448599, 1.558385947956585],
            [31.522571961962598, 1.558773081872881],
            [31.52508803797054, 1.560163172350875],
            [31.529283463198166, 1.560068416361934],
            [31.531188639897113, 1.558572343182844],
            [31.534169236535103, 1.554695686178414],
            [31.540790681663417, 1.551080655718748],
            [31.543251601112903, 1.55015497279734],
            [31.54378109059924, 1.551022885576089],
            [31.54464623469317, 1.550492314878536],
            [31.547646891609773, 1.54623608413774],
            [31.553099519857323, 1.544719458777865],
            [31.55562429335382, 1.5448602328896],
            [31.556825261836938, 1.54286449412284],
            [31.557501426446255, 1.538068187024294],
            [31.559361057661995, 1.538473550286328],
            [31.5608832520126, 1.541010494087919],
            [31.56173528070341, 1.545877981684977],
            [31.562264938174696, 1.546679268200635],
            [31.568759603168647, 1.552033188008655],
            [31.570389290824494, 1.556305004169828],
            [31.571147755486855, 1.557189257722182],
            [31.574600910880058, 1.559356816448079],
            [31.582548668219722, 1.570405455871377],
            [31.58489927994219, 1.571461289914537],
            [31.587833319593948, 1.572077845614471],
            [31.589002290984983, 1.573143309612133],
            [31.589564696539963, 1.576458469041895],
            [31.589458715099365, 1.580939745167466],
            [31.588392413060497, 1.584452699201961],
            [31.588698226532646, 1.590639632261968],
            [31.59340130859195, 1.596887266361368],
            [31.598006250604787, 1.599523141788354],
            [31.59890577951285, 1.605926381023779],
            [31.60106732461411, 1.611427515143815],
            [31.603606287000535, 1.613246760686544],
            [31.605613893201458, 1.613646057970275],
            [31.607108610782507, 1.614794732244188],
            [31.606059420751446, 1.616150406735299],
            [31.603981056950552, 1.62038744647731],
            [31.6016571485482, 1.622966996031193],
            [31.601272450417664, 1.62475369834595],
            [31.606103246859238, 1.627402206910416],
            [31.606599271406303, 1.62869095215833],
            [31.608472048567904, 1.630770456126144],
            [31.612080590945673, 1.632640579220684],
            [31.6148387045322, 1.632338887548125],
            [31.6187070145373, 1.630049962206863],
            [31.620137251945557, 1.628409356968684],
            [31.622276278977612, 1.627303109718819],
            [31.625152840824217, 1.627168607131874],
            [31.626150215131336, 1.627576818342966],
            [31.628450897592028, 1.629657595858811],
            [31.629374227363527, 1.631185993889644],
            [31.62995123772841, 1.633392773448713],
            [31.630321279845067, 1.637613279868196],
            [31.632578626678157, 1.641478798467123],
            [31.630804366855433, 1.642787697157931],
            [31.628764794105134, 1.645725699984533],
            [31.628990878502567, 1.65534523662958],
            [31.628369000882515, 1.656916698149002],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 378,
        District: "MASINDI",
        County: "BUJENJE",
        Subcounty: "BUDONGO",
        Population: 51935,
        Key: "MASINDIBUDONGO",
        Dist2: "Masindi",
        "Sub Country": "Budongo",
        id2_original: "Masindi Budongo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.72433585020846, 1.590941564482249],
            [31.722433463676765, 1.591790769099742],
            [31.721406895021207, 1.593647263628082],
            [31.717045984846912, 1.598187928982077],
            [31.716757964305575, 1.599355224973011],
            [31.714122087174722, 1.60319762129151],
            [31.709506819926016, 1.60473373389487],
            [31.706792101255946, 1.606752171366576],
            [31.70391883981968, 1.61045079930178],
            [31.70091878926591, 1.612492217086339],
            [31.698614299745042, 1.616907672482888],
            [31.696277256176636, 1.620023782320877],
            [31.694780214653957, 1.624751482195189],
            [31.693708169685447, 1.6257257397372],
            [31.69261441243655, 1.625841727514324],
            [31.691803678401048, 1.626888276047703],
            [31.69118717270641, 1.631189439328641],
            [31.689829064625556, 1.632496619773804],
            [31.68956408317634, 1.633950021556313],
            [31.68873002348617, 1.634805780318674],
            [31.687029272803137, 1.635265666073031],
            [31.68574615069233, 1.635047330553682],
            [31.68091481166834, 1.637440880056512],
            [31.67906009154226, 1.637673818649457],
            [31.675289241558954, 1.638961951195234],
            [31.67379229974929, 1.638695320849173],
            [31.67257905309285, 1.639073155739131],
            [31.671084479242264, 1.637829133179099],
            [31.667721149089292, 1.637711942842507],
            [31.65862528013783, 1.639127366638757],
            [31.65374692239356, 1.641306122420718],
            [31.650315351720014, 1.644824122853134],
            [31.645555995598038, 1.642056663869322],
            [31.64430106801077, 1.640026653881064],
            [31.643853426724874, 1.638380458087125],
            [31.639385648472814, 1.642789308073174],
            [31.638600346641304, 1.643144551666804],
            [31.637133760701726, 1.640184207708624],
            [31.63432603765366, 1.641320142960888],
            [31.632578626678157, 1.641478798467123],
            [31.630321279845067, 1.637613279868196],
            [31.62995123772841, 1.633392773448713],
            [31.629374227363527, 1.631185993889644],
            [31.628450897592028, 1.629657595858811],
            [31.626150215131336, 1.627576818342966],
            [31.625152840824217, 1.627168607131874],
            [31.622276278977612, 1.627303109718819],
            [31.620137251945557, 1.628409356968684],
            [31.6187070145373, 1.630049962206863],
            [31.6148387045322, 1.632338887548125],
            [31.612080590945673, 1.632640579220684],
            [31.608472048567904, 1.630770456126144],
            [31.606599271406303, 1.62869095215833],
            [31.606103246859238, 1.627402206910416],
            [31.601272450417664, 1.62475369834595],
            [31.6016571485482, 1.622966996031193],
            [31.603981056950552, 1.62038744647731],
            [31.606059420751446, 1.616150406735299],
            [31.607108610782507, 1.614794732244188],
            [31.605613893201458, 1.613646057970275],
            [31.603606287000535, 1.613246760686544],
            [31.60106732461411, 1.611427515143815],
            [31.59890577951285, 1.605926381023779],
            [31.598006250604787, 1.599523141788354],
            [31.59340130859195, 1.596887266361368],
            [31.588698226532646, 1.590639632261968],
            [31.588392413060497, 1.584452699201961],
            [31.589458715099365, 1.580939745167466],
            [31.589564696539963, 1.576458469041895],
            [31.589002290984983, 1.573143309612133],
            [31.587833319593948, 1.572077845614471],
            [31.58489927994219, 1.571461289914537],
            [31.582548668219722, 1.570405455871377],
            [31.574600910880058, 1.559356816448079],
            [31.571147755486855, 1.557189257722182],
            [31.570389290824494, 1.556305004169828],
            [31.568759603168647, 1.552033188008655],
            [31.562264938174696, 1.546679268200635],
            [31.56173528070341, 1.545877981684977],
            [31.5608832520126, 1.541010494087919],
            [31.559361057661995, 1.538473550286328],
            [31.557501426446255, 1.538068187024294],
            [31.556825261836938, 1.54286449412284],
            [31.55562429335382, 1.5448602328896],
            [31.553099519857323, 1.544719458777865],
            [31.547646891609773, 1.54623608413774],
            [31.54464623469317, 1.550492314878536],
            [31.54378109059924, 1.551022885576089],
            [31.543251601112903, 1.55015497279734],
            [31.540790681663417, 1.551080655718748],
            [31.534169236535103, 1.554695686178414],
            [31.531188639897113, 1.558572343182844],
            [31.529283463198166, 1.560068416361934],
            [31.52508803797054, 1.560163172350875],
            [31.522571961962598, 1.558773081872881],
            [31.5206476448599, 1.558385947956585],
            [31.51095368388046, 1.561729960450629],
            [31.506871742822685, 1.559190991380661],
            [31.50228673622264, 1.558247616360978],
            [31.500882068460633, 1.556630411064758],
            [31.496862121937248, 1.555574942225228],
            [31.495406682293687, 1.555889769184266],
            [31.49009761291339, 1.558441589678033],
            [31.487529190277225, 1.558985326397009],
            [31.48247420398516, 1.559192600565636],
            [31.482958038393843, 1.558232541918892],
            [31.483113936519825, 1.554057415692311],
            [31.48368567557061, 1.552785764570005],
            [31.482768874754548, 1.551923393984758],
            [31.48135402189385, 1.549039714546504],
            [31.478807610677094, 1.54622703062086],
            [31.478737746900833, 1.544144499801994],
            [31.47931005009359, 1.542093197236907],
            [31.480452161857613, 1.541478514057181],
            [31.483645632268495, 1.537428677697874],
            [31.483903642791134, 1.532945872282421],
            [31.485721029832337, 1.528782184461269],
            [31.483809617926973, 1.521681895411872],
            [31.48270991562752, 1.519957668474349],
            [31.485544863916914, 1.518318306539247],
            [31.48868502290891, 1.517520355363856],
            [31.491304528243695, 1.517860733340967],
            [31.494607526643907, 1.517452708108149],
            [31.49615589341031, 1.518992583121377],
            [31.496767387404013, 1.519157149625579],
            [31.498889134443232, 1.517004333843162],
            [31.503377271214614, 1.515832475285583],
            [31.50458119156176, 1.514346232962154],
            [31.505994675389985, 1.509773668968941],
            [31.50743957959185, 1.506929401988886],
            [31.515305684563778, 1.502507075053633],
            [31.521700078707408, 1.497293677278285],
            [31.522631727776755, 1.497054571709061],
            [31.52609661337093, 1.493923520390817],
            [31.526806232139744, 1.491509498615271],
            [31.529605623313568, 1.486580783467816],
            [31.529993387394157, 1.479765740216372],
            [31.53322222537606, 1.475610738007313],
            [31.54281789718868, 1.46729321634246],
            [31.54429350221372, 1.462690401864815],
            [31.55068125241752, 1.451578062560751],
            [31.553421567683287, 1.449296111026691],
            [31.555155593761075, 1.448502519131671],
            [31.559493031855304, 1.447682817676778],
            [31.561513654644703, 1.447684778971147],
            [31.565750623360962, 1.449062292385178],
            [31.567518399143967, 1.449309268033572],
            [31.569067426172104, 1.449021573100999],
            [31.572374432855103, 1.447030425883186],
            [31.575905953680433, 1.44603500024245],
            [31.577585731396507, 1.444850645792555],
            [31.579453815759067, 1.442013865275364],
            [31.582753882058157, 1.442339316999491],
            [31.58719253243716, 1.440161537715673],
            [31.587917187207196, 1.439296011177491],
            [31.588213606098137, 1.433968945503051],
            [31.58684414510874, 1.431469404914713],
            [31.582207819553137, 1.426139021652371],
            [31.578899417786516, 1.421061872157675],
            [31.5780382002287, 1.416086584369471],
            [31.576096600438238, 1.412811541733907],
            [31.574986428274116, 1.408684154090897],
            [31.57398505376902, 1.407111247821218],
            [31.573785858642974, 1.405997645562026],
            [31.575285795435832, 1.400437622516026],
            [31.576464817178223, 1.399365086582244],
            [31.57934481957238, 1.399094186984934],
            [31.580238932537608, 1.397994392887317],
            [31.57977688676616, 1.39608553114048],
            [31.5808125176263, 1.394171947696329],
            [31.580332784026904, 1.39270021317577],
            [31.580203470643458, 1.388998966689634],
            [31.581345576119272, 1.387122185955088],
            [31.581008442884713, 1.382058988298953],
            [31.580072426206446, 1.380936086512094],
            [31.580036772072816, 1.38003730274127],
            [31.58058671080827, 1.378897718625204],
            [31.580556999928568, 1.377549866782926],
            [31.581523648259733, 1.376356447503787],
            [31.581788218280582, 1.374326707821375],
            [31.581040764268643, 1.371527752086251],
            [31.581256998639006, 1.370454897724121],
            [31.582796895190608, 1.3690559541428],
            [31.584312659400425, 1.364087045060515],
            [31.583611196436088, 1.363203526487111],
            [31.581859570565268, 1.362637696777258],
            [31.583042595200595, 1.359461217022506],
            [31.58300254291534, 1.357096717167118],
            [31.589264027719423, 1.354575349225205],
            [31.592570345394574, 1.351721157477351],
            [31.597178125185373, 1.350219031433903],
            [31.600974950853445, 1.347122794746786],
            [31.60240132909924, 1.347117127045948],
            [31.60435697943907, 1.345735201805971],
            [31.606185526251057, 1.345876450758221],
            [31.607620592103945, 1.343412323037232],
            [31.6104013710834, 1.341650722684826],
            [31.612569851178655, 1.341252535017092],
            [31.613873656998862, 1.341529000203865],
            [31.61678231475226, 1.343586912909832],
            [31.61944774915091, 1.343360447015567],
            [31.621169020948276, 1.342625646454065],
            [31.622379004025294, 1.342806372885541],
            [31.623275254980886, 1.341541088213366],
            [31.623655547773254, 1.341545878513686],
            [31.624786736921738, 1.342292981145862],
            [31.62746971182461, 1.342539549508623],
            [31.628438778420524, 1.34386380980341],
            [31.634060894507666, 1.344762047573482],
            [31.63502072911738, 1.345885230265699],
            [31.63615660836997, 1.346277794378768],
            [31.640771797465227, 1.345118423329985],
            [31.64384514335967, 1.346410081486367],
            [31.645966124135967, 1.34601125068019],
            [31.64700319499549, 1.346686251523253],
            [31.648498359937527, 1.346699262720232],
            [31.649727694522387, 1.34737850045241],
            [31.651395147352748, 1.3471442675287],
            [31.65190562399611, 1.346276252397186],
            [31.654740422266862, 1.34672102737769],
            [31.660790271176523, 1.344038074543091],
            [31.6621429642128, 1.344219718695634],
            [31.664394507929142, 1.342728007419205],
            [31.66329767934027, 1.344988284330474],
            [31.663292681114022, 1.348073331126447],
            [31.66372589635476, 1.34947359175418],
            [31.662910378790375, 1.351827396804201],
            [31.66343119144938, 1.35379615622979],
            [31.664641091881368, 1.35488704036301],
            [31.66594377121421, 1.357054756056615],
            [31.66767574913315, 1.357312950147167],
            [31.670384819196705, 1.361897917811814],
            [31.673565539818743, 1.364065628108664],
            [31.67565985141088, 1.367496281359441],
            [31.676666434348007, 1.367780821595646],
            [31.677148439786738, 1.369087137440061],
            [31.678631851171616, 1.37016965911583],
            [31.67904068344057, 1.371616883435438],
            [31.68119522707249, 1.372282313705504],
            [31.681681594730254, 1.373257721749495],
            [31.682416247749384, 1.373432459441069],
            [31.68283256208636, 1.374312412552071],
            [31.683801165151575, 1.374773781145799],
            [31.68516882052724, 1.378325318858798],
            [31.688479512099498, 1.383260685668452],
            [31.688676486590186, 1.38544994421747],
            [31.68790629981167, 1.387969834670717],
            [31.686929691858957, 1.394423342231239],
            [31.68931185421085, 1.40396887071765],
            [31.690506697980357, 1.407104523264779],
            [31.692964151729477, 1.408146781687286],
            [31.702142117714775, 1.407864081909788],
            [31.703762817726197, 1.408440732124303],
            [31.704858606065965, 1.409856710714706],
            [31.70480969279874, 1.412087680095913],
            [31.706309606235365, 1.41554297229138],
            [31.70797725759342, 1.417439059658953],
            [31.708763481096387, 1.418255135773261],
            [31.71343526674951, 1.419337278318133],
            [31.708665749783364, 1.42252516787058],
            [31.706758319211364, 1.423123821763201],
            [31.70575653148124, 1.424130802549901],
            [31.70639982763262, 1.424754887551438],
            [31.706470914016002, 1.425522582915167],
            [31.7061807456028, 1.432839132294099],
            [31.704604165448256, 1.438547666734053],
            [31.704578479021016, 1.44181018469828],
            [31.70571844381151, 1.449391431299371],
            [31.70668973194111, 1.451527192024368],
            [31.71158906355064, 1.45880147670954],
            [31.714471061103016, 1.465599199272489],
            [31.715563794272523, 1.469622037922891],
            [31.717362204403347, 1.473130312935131],
            [31.71736171212657, 1.473989367032798],
            [31.71582323940466, 1.477195607011693],
            [31.71354665874306, 1.478885732248322],
            [31.713318373473168, 1.479970365656955],
            [31.713031610573232, 1.481881687807305],
            [31.713800332199515, 1.487577090879737],
            [31.71275858650723, 1.492646821978418],
            [31.71346110499202, 1.495256226908178],
            [31.71443215327144, 1.497034352145935],
            [31.718006930672637, 1.498196235865432],
            [31.72311640248162, 1.498663822395954],
            [31.73033216761202, 1.498005058892714],
            [31.734252936534787, 1.49856458532542],
            [31.738063885515764, 1.500351530800382],
            [31.739225461077027, 1.501713718562123],
            [31.740745822864486, 1.502099483369794],
            [31.7397692158101, 1.502978766347036],
            [31.739196011607085, 1.504145273434353],
            [31.73774414636004, 1.504951672571],
            [31.737123446431347, 1.506094196483305],
            [31.735397030880637, 1.507412351505045],
            [31.734512794891995, 1.50943618129386],
            [31.733464957723758, 1.510267566309062],
            [31.72961035511157, 1.511901446643327],
            [31.725177088336068, 1.511948333151965],
            [31.723582150210373, 1.512945011563737],
            [31.720300142743405, 1.51367461122196],
            [31.71839620122796, 1.514670404309042],
            [31.716070356057866, 1.518180026225793],
            [31.713474940844048, 1.520079717339335],
            [31.710642939927098, 1.521501919444784],
            [31.707373472043212, 1.521957372595377],
            [31.70302619739659, 1.520824391992407],
            [31.70164995861836, 1.51979533176335],
            [31.699843211223406, 1.519885485500782],
            [31.698748004093634, 1.520645177456887],
            [31.698103165534906, 1.521930651755523],
            [31.692211931256644, 1.525382230615016],
            [31.69113928621357, 1.52664260398486],
            [31.690928155172323, 1.530492021144982],
            [31.696889539789456, 1.537601440556725],
            [31.69805316530619, 1.543099761999791],
            [31.69881053492226, 1.544484615828917],
            [31.704513826371713, 1.550186799235563],
            [31.706433301555066, 1.552695479319111],
            [31.708051443164553, 1.556979328916859],
            [31.709381453739923, 1.562478150502795],
            [31.71185308020928, 1.567718050598602],
            [31.71391524648728, 1.570203326428613],
            [31.715339279231884, 1.571137189182662],
            [31.71624188397148, 1.571425873684517],
            [31.718595856291426, 1.571146623334945],
            [31.720056263618503, 1.571782591600899],
            [31.71819185606039, 1.581134166263948],
            [31.718302899507595, 1.584424317904508],
            [31.720872790889253, 1.58832951648294],
            [31.72239056463037, 1.589835806956772],
            [31.72433585020846, 1.590941564482249],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 379,
        District: "MASINDI",
        County: "BUJENJE",
        Subcounty: "BWIJANGA",
        Population: 52084,
        Key: "MASINDIBWIJANGA",
        Dist2: "Masindi",
        "Sub Country": "Bwijanga",
        id2_original: "Masindi Bwijanga",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.90595824315982, 1.774247434929675],
            [31.905381482526586, 1.773757196151984],
            [31.898634954181468, 1.772706327587679],
            [31.89705929120683, 1.771404768675283],
            [31.89497881726332, 1.770705630514854],
            [31.882967736450123, 1.768541270663625],
            [31.87649344255189, 1.766923158383742],
            [31.871144695483796, 1.762818438376054],
            [31.86909808083998, 1.76156543226173],
            [31.86668837614148, 1.760755531041432],
            [31.861289648607645, 1.759956784873475],
            [31.858207923228246, 1.758834828675681],
            [31.852357224528838, 1.758572737556296],
            [31.85044452174444, 1.759346974564328],
            [31.84843139629442, 1.760982725319646],
            [31.8481454939805, 1.761786688690405],
            [31.847658355568225, 1.764945508377837],
            [31.847799646189365, 1.767243145044844],
            [31.848696957156996, 1.770029481580772],
            [31.849609501755246, 1.771264983983259],
            [31.849254107567592, 1.777312065209018],
            [31.848707795330913, 1.777989194662939],
            [31.84423875674249, 1.775606756309647],
            [31.842522749970986, 1.774106194083347],
            [31.840644145438144, 1.773616049546135],
            [31.832300701775385, 1.776414127097248],
            [31.829125793253237, 1.776738077171809],
            [31.824121426129118, 1.775724367431071],
            [31.823085117939264, 1.775202143718208],
            [31.818714376602472, 1.771189878506626],
            [31.81213844821129, 1.770892274136701],
            [31.80985504933668, 1.770238854371124],
            [31.805062503159913, 1.767367205328457],
            [31.801111332552974, 1.765897766230836],
            [31.798730297586776, 1.765961414862851],
            [31.794972934010826, 1.765372221151973],
            [31.790535998515683, 1.763706877114094],
            [31.786356745658132, 1.764323469550482],
            [31.78024881168218, 1.766829389227184],
            [31.77607042839383, 1.766142099675645],
            [31.773555941505652, 1.764904876201265],
            [31.77130570573636, 1.763218832688125],
            [31.770382782003352, 1.762143593900042],
            [31.76989298817109, 1.760807247774355],
            [31.766387123230295, 1.756727380540547],
            [31.7679634994673, 1.754817754940582],
            [31.770985114977787, 1.753386963909149],
            [31.776230492906112, 1.749797577108675],
            [31.777471311553533, 1.749516175458382],
            [31.78090112871565, 1.750777551756764],
            [31.784515033137357, 1.750986151825328],
            [31.785487453144203, 1.748685619185447],
            [31.78618091750925, 1.743986043218525],
            [31.78565376813422, 1.741695386993325],
            [31.783035716273545, 1.736298969927524],
            [31.78282086441042, 1.734876884349554],
            [31.783523069383197, 1.73334684627077],
            [31.783491634636466, 1.731892314476039],
            [31.784367276442808, 1.7290598398421],
            [31.7850798749234, 1.728137661148086],
            [31.787353703146966, 1.719439298466666],
            [31.786897545832222, 1.716884789001095],
            [31.789438638124196, 1.712852698312602],
            [31.790090886885682, 1.712420430839959],
            [31.790947707190174, 1.7095615052279],
            [31.790475280487332, 1.70487972801403],
            [31.79196067984392, 1.702141349374604],
            [31.792278595419607, 1.70051824983023],
            [31.79258441967156, 1.695170248205759],
            [31.793523148363665, 1.691257524272982],
            [31.793439864655365, 1.686170162426495],
            [31.79375728436101, 1.685329723874805],
            [31.793426603725145, 1.684314953307686],
            [31.794491268135275, 1.681739884174329],
            [31.795347690486118, 1.681261972528078],
            [31.7966562196481, 1.678966988777976],
            [31.79852367518996, 1.677808006426984],
            [31.79928497044377, 1.676780104204429],
            [31.798690397116797, 1.675225639310793],
            [31.800450810307726, 1.674006833624699],
            [31.801878215327868, 1.672381395732546],
            [31.803067625188234, 1.672238383791377],
            [31.803448299764636, 1.671401622571758],
            [31.804411673736578, 1.671796532606937],
            [31.805030230285027, 1.670935954416245],
            [31.806314794191838, 1.670792970205724],
            [31.807718370500776, 1.66959792289394],
            [31.809978211955364, 1.669790062783464],
            [31.81088213272687, 1.670053424961222],
            [31.811904929356547, 1.671297204623788],
            [31.813822873810643, 1.674586840974915],
            [31.81381940451702, 1.673595069849219],
            [31.81328481259987, 1.671008957290328],
            [31.81168299068412, 1.667565143131262],
            [31.80794423840424, 1.661484110676426],
            [31.806077433242642, 1.654166957094684],
            [31.80431587649634, 1.649647173461024],
            [31.801270616429285, 1.646148706442166],
            [31.799722336799434, 1.642597355032167],
            [31.7943775827428, 1.640173381158793],
            [31.790582110835853, 1.639633133824573],
            [31.78849751991341, 1.638932543405187],
            [31.787588669187627, 1.638931988473457],
            [31.78395242456314, 1.640328405457629],
            [31.78261584909965, 1.640381380748012],
            [31.78069067230922, 1.641294693354738],
            [31.77994361265768, 1.638981102625385],
            [31.778393878655393, 1.637904276184283],
            [31.774705654813584, 1.636879927981848],
            [31.770376362642327, 1.635102069556524],
            [31.766956383829225, 1.632571662408168],
            [31.76540643692619, 1.631871389193589],
            [31.7634284409937, 1.631762577290063],
            [31.760740954751434, 1.632422022520169],
            [31.75595986209456, 1.631176808746191],
            [31.755234485079058, 1.630376625359452],
            [31.754844880350447, 1.628635492823155],
            [31.754970814271804, 1.626071891876239],
            [31.755806319351237, 1.624455964572989],
            [31.757192338986265, 1.623077334932631],
            [31.764060191997007, 1.617915049562426],
            [31.76730952055057, 1.613712874203786],
            [31.76762886085428, 1.612781702164864],
            [31.768675567043566, 1.61168217210092],
            [31.768723290043035, 1.609554109264078],
            [31.76954420199069, 1.605884057359399],
            [31.771613968016002, 1.601317795501039],
            [31.772315947511636, 1.597336852948546],
            [31.772791737506907, 1.596571870902537],
            [31.774980172777887, 1.595759687840376],
            [31.781652358346715, 1.596108815544871],
            [31.785529835659332, 1.592356139948729],
            [31.787016644472605, 1.590144874559083],
            [31.78673125599502, 1.589236101544352],
            [31.785779836802885, 1.588279311870058],
            [31.77958366850313, 1.58324379710607],
            [31.777466776857988, 1.581067119987762],
            [31.771615822138745, 1.571548388335233],
            [31.771116420824526, 1.569467969448024],
            [31.77147334753806, 1.567124825809126],
            [31.77200865271757, 1.565176258337856],
            [31.77329317081029, 1.564172435750957],
            [31.772508349577496, 1.5617332317976],
            [31.77188992418309, 1.561398257696005],
            [31.772270562826844, 1.5601789166739],
            [31.780072530782434, 1.55975124719112],
            [31.787981580614794, 1.558594292579866],
            [31.79310762903575, 1.557316783952089],
            [31.811161900445715, 1.549814652938607],
            [31.81703723544175, 1.548310154762063],
            [31.82794351511793, 1.544093282096824],
            [31.83597156657262, 1.541764438606064],
            [31.84100250676118, 1.538406409259677],
            [31.847888799489738, 1.535192406398232],
            [31.852669950537123, 1.533998274940753],
            [31.85670181051781, 1.533796247083048],
            [31.85734404665715, 1.534322494514436],
            [31.858580961226387, 1.536809708852669],
            [31.86125695891443, 1.544617755254878],
            [31.865788354058306, 1.55101558315264],
            [31.86813136423687, 1.5558345548359],
            [31.880488749185353, 1.577036334908309],
            [31.88202301509675, 1.580898600028685],
            [31.883081523352235, 1.585932419736954],
            [31.884187570452557, 1.59500740066829],
            [31.885043898480273, 1.597088022007011],
            [31.888219537332763, 1.600735599257952],
            [31.890848026718714, 1.60667859145426],
            [31.892584508790467, 1.609644229510905],
            [31.894879969344405, 1.616280574713907],
            [31.895272433410582, 1.619066452107438],
            [31.89082376232458, 1.635684011692201],
            [31.890240835655245, 1.640908624711106],
            [31.89070457025941, 1.646205269764485],
            [31.892536178529863, 1.65031880056983],
            [31.89759107139716, 1.656908243148889],
            [31.903601982830832, 1.666311005219219],
            [31.903871036343258, 1.667813093455304],
            [31.9058096716933, 1.671152016911485],
            [31.908378812083384, 1.673713372397981],
            [31.91069809056876, 1.677550024791122],
            [31.91405215549791, 1.686090998547946],
            [31.91457552745714, 1.689049220920122],
            [31.913754495135244, 1.696999884926679],
            [31.913575429458085, 1.713227676099286],
            [31.914586445581097, 1.717181202302459],
            [31.91961743787195, 1.728391653796263],
            [31.913027540678073, 1.736158071907148],
            [31.910220791403763, 1.738833951756801],
            [31.913278087997362, 1.751363944151136],
            [31.913138832958644, 1.757010719657592],
            [31.9139762900772, 1.763454159751952],
            [31.91406628240406, 1.765132199269064],
            [31.913671291376982, 1.766504864567008],
            [31.912912801561774, 1.767236630867368],
            [31.90803001961473, 1.768698167497255],
            [31.90738492234121, 1.769424463005675],
            [31.90595824315982, 1.774247434929675],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 382,
        District: "MASINDI",
        County: "BURULI",
        Subcounty: "MIIRYA",
        Population: 20246,
        Key: "MASINDIMIIRYA",
        Dist2: "Masindi",
        "Sub Country": "Miirya",
        id2_original: "Masindi Miirya",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.725563011768642, 1.699518583044527],
            [31.722491086110676, 1.701702774305288],
            [31.718493135735326, 1.703431278587066],
            [31.716187063382943, 1.703495992455936],
            [31.71129919517477, 1.704590128007583],
            [31.710206999197798, 1.704038604391279],
            [31.70923210433235, 1.704131075578364],
            [31.707826714324877, 1.705295051686228],
            [31.699821981338307, 1.707500360779393],
            [31.69849242261551, 1.706805081534545],
            [31.695604847423525, 1.706498556084964],
            [31.69468004531325, 1.705542242054253],
            [31.693610891123328, 1.705300690607687],
            [31.693472495772365, 1.703559997865156],
            [31.692880576967017, 1.702580832139976],
            [31.68741149248181, 1.698309344656311],
            [31.684632464318863, 1.697371380072092],
            [31.68599388269152, 1.694729279489034],
            [31.6866130581792, 1.694278173126285],
            [31.687845617715908, 1.690860910323335],
            [31.690705766443944, 1.68777027901708],
            [31.691460449198992, 1.68535282752849],
            [31.69377260943403, 1.682761199282384],
            [31.696911261951335, 1.677537742900802],
            [31.69696152179317, 1.676417453337124],
            [31.69484953045789, 1.674885517256997],
            [31.692497067307606, 1.674497146582174],
            [31.69199929913058, 1.673899709448504],
            [31.69145792044146, 1.671681052145904],
            [31.6919377977713, 1.669846860688913],
            [31.691347716919037, 1.668104877323853],
            [31.691375645541235, 1.666388537451027],
            [31.69539360948279, 1.666161970383227],
            [31.69801027614127, 1.66543064579623],
            [31.698583768703493, 1.664192713379164],
            [31.69816113202358, 1.662022091964334],
            [31.69847332353425, 1.660711853649688],
            [31.69921139374474, 1.660237238605335],
            [31.7004586793639, 1.660538895525625],
            [31.701172459129108, 1.660278772735303],
            [31.703720262734564, 1.658522143615562],
            [31.704710604131343, 1.658308950447263],
            [31.70599957427461, 1.657152471953919],
            [31.7061037321352, 1.655906816555796],
            [31.706484426474503, 1.655764913274103],
            [31.709428426646113, 1.65729926441688],
            [31.713883006850047, 1.658397017613863],
            [31.716321332771837, 1.652730393858577],
            [31.71788831083431, 1.651283626265611],
            [31.719713214079494, 1.652022891194308],
            [31.720264596407628, 1.653134290634161],
            [31.72071039075725, 1.659948923206434],
            [31.723498170307717, 1.664889871060712],
            [31.723785373382135, 1.667547968331452],
            [31.727195071875162, 1.671107922105177],
            [31.72836271286123, 1.673891188972252],
            [31.736620377295814, 1.672892086774541],
            [31.738073360945382, 1.672270936545544],
            [31.739002819023774, 1.671296232162197],
            [31.742072667776785, 1.669946355343184],
            [31.74366624854809, 1.669593409878089],
            [31.744654354936458, 1.669855638889732],
            [31.745848139592255, 1.671745355818082],
            [31.74584609412833, 1.672603588254166],
            [31.744219140944246, 1.676961490672157],
            [31.741035924802333, 1.680969172367219],
            [31.74100889359711, 1.682327952625187],
            [31.74041063358422, 1.683971125294107],
            [31.743527534295197, 1.690542574639708],
            [31.74538881212285, 1.697059680198477],
            [31.74678634905814, 1.699161666047851],
            [31.742906704110762, 1.701857425600691],
            [31.743302900676944, 1.699419464333301],
            [31.73505429665031, 1.695890971565083],
            [31.732419634940037, 1.695784588480039],
            [31.72955827258802, 1.696521651088488],
            [31.725563011768642, 1.699518583044527],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 383,
        District: "MASINDI",
        County: "MASINDI MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 40826,
        Key: "MASINDICENTRAL DIVISION",
        Dist2: "Masindi",
        "Sub Country": "Central Div.",
        id2_original: "Masindi Central Div.",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.73822919529096, 1.72602970726322],
            [31.73534601196242, 1.728786600659789],
            [31.733779108460073, 1.732822785288084],
            [31.73391937769675, 1.733800620080766],
            [31.735458192676784, 1.73645135301169],
            [31.735216192827444, 1.738214738936729],
            [31.73455916682526, 1.739559733586582],
            [31.732080669142306, 1.742079412613695],
            [31.731337399482946, 1.744675723938835],
            [31.72944770704454, 1.746922032058547],
            [31.72659558476356, 1.747786936379784],
            [31.717449845839067, 1.753347860595493],
            [31.71303702921102, 1.757711899385596],
            [31.710824915247454, 1.759051285298022],
            [31.707113884078936, 1.7625903455336],
            [31.705294362640622, 1.763248305925443],
            [31.703177326366713, 1.76475497539994],
            [31.70113091833543, 1.768580306316933],
            [31.698145850782282, 1.770003574856893],
            [31.695863031321004, 1.769167675401283],
            [31.693318915299802, 1.767327902976914],
            [31.691131708924118, 1.764986014849061],
            [31.690240454398154, 1.763109840517739],
            [31.684165829054642, 1.757817084807154],
            [31.68278652522468, 1.757721929743818],
            [31.681502941379804, 1.755666595892963],
            [31.679680866929473, 1.754266547614667],
            [31.674716668871596, 1.752159338557104],
            [31.67173923520172, 1.749369851539912],
            [31.664526981585766, 1.747944719386857],
            [31.662519872153208, 1.747066651957959],
            [31.661424003863374, 1.748496909973845],
            [31.660711381128262, 1.747549385945369],
            [31.586212399495306, 1.767433078876374],
            [31.58499011758375, 1.766729632947033],
            [31.584634163745676, 1.764626270160763],
            [31.585276536428943, 1.763813402746606],
            [31.587678933332587, 1.762330776218436],
            [31.58846408245049, 1.761278833594658],
            [31.588702193492963, 1.760418233716205],
            [31.58797634486192, 1.757331812429958],
            [31.574085790845, 1.759194895927852],
            [31.569329775557595, 1.75893321968512],
            [31.567713046998044, 1.757953630913894],
            [31.56545414248629, 1.757284954098669],
            [31.55613245863196, 1.756618057566061],
            [31.556682315620716, 1.746833254209837],
            [31.556213938523154, 1.745504446680309],
            [31.554369009135335, 1.744064882356142],
            [31.551035160791674, 1.742893809610913],
            [31.54838640092135, 1.741363729541988],
            [31.54462264942541, 1.737825409519647],
            [31.54253952635012, 1.736415621868797],
            [31.538549781186592, 1.736412517818853],
            [31.536525561542785, 1.735841679630563],
            [31.52963614896523, 1.731551880975716],
            [31.52737533912674, 1.728943527754334],
            [31.52490410522118, 1.728941593664121],
            [31.523861665131175, 1.729390192099971],
            [31.522743727031443, 1.731216925534173],
            [31.519585915245784, 1.733491455538464],
            [31.51169593035869, 1.733365353872821],
            [31.51211485160661, 1.730699215745833],
            [31.513009278982157, 1.72914197222456],
            [31.514886476753276, 1.727285888699588],
            [31.515155778200736, 1.72554837659641],
            [31.516020317728486, 1.724140905399706],
            [31.515206027262778, 1.718357858874714],
            [31.514552211839455, 1.716799394873571],
            [31.509641583016894, 1.714188958944446],
            [31.507751363267413, 1.713678143198825],
            [31.506174488465458, 1.712238789093999],
            [31.50632428253909, 1.711040500687396],
            [31.50567042848816, 1.709541943242007],
            [31.505850225393985, 1.708044076920184],
            [31.504689465502945, 1.707533835102623],
            [31.503693116173586, 1.70615487029048],
            [31.502980306588878, 1.703907247061886],
            [31.503102521484955, 1.699862681269875],
            [31.502523394689305, 1.697974713831613],
            [31.500769204128343, 1.695336819939487],
            [31.497971280801714, 1.693866573463877],
            [31.49256733136108, 1.693622698528273],
            [31.487475771958856, 1.694547431348778],
            [31.484287196468003, 1.698230036708025],
            [31.483274373832934, 1.698918320654847],
            [31.48199395924438, 1.699156976210162],
            [31.478793680502, 1.698764962129411],
            [31.47483509250577, 1.697233852672407],
            [31.47161911390715, 1.697890415225363],
            [31.46853973941885, 1.695221515069833],
            [31.467378838492344, 1.69492098410487],
            [31.46285326622812, 1.695097125914662],
            [31.455307600199525, 1.692993883945041],
            [31.45355171361931, 1.692123639977085],
            [31.451164783908215, 1.689987704941453],
            [31.452127981810357, 1.689531086911621],
            [31.45678093248691, 1.689731558479792],
            [31.462586662421476, 1.690837942321641],
            [31.46907705592626, 1.6915120408015],
            [31.480279617051124, 1.691756992613164],
            [31.485325021014052, 1.690187044179758],
            [31.496392830354708, 1.687795437993424],
            [31.50073101045741, 1.685998375647632],
            [31.510073166018735, 1.686787274753527],
            [31.537680999814047, 1.687312259702055],
            [31.5382509440309, 1.687528518828448],
            [31.538271790335376, 1.688696645258447],
            [31.537369266444152, 1.697871381996372],
            [31.54837377060843, 1.698381572496982],
            [31.54897041006059, 1.697429865265526],
            [31.547099180696218, 1.694778199195835],
            [31.546817408835985, 1.693394746429995],
            [31.548199368085935, 1.692087854131382],
            [31.548635346544447, 1.688847247052892],
            [31.562357511361352, 1.68847290564678],
            [31.569364531375932, 1.686799348266769],
            [31.574571431765676, 1.692703983148357],
            [31.582914720019907, 1.697604035012335],
            [31.585220203077455, 1.697730174952182],
            [31.587528461929242, 1.696735940046418],
            [31.605024620832957, 1.682866403203428],
            [31.60674577854429, 1.682157364241716],
            [31.609008643728146, 1.681943625901574],
            [31.606762854619515, 1.675589249389324],
            [31.606965239663158, 1.670631503820854],
            [31.608599320979042, 1.668288309190391],
            [31.610740328796297, 1.667627244303938],
            [31.614400208994223, 1.667971906674747],
            [31.61733133001964, 1.665000864934188],
            [31.619937128859807, 1.663828634265372],
            [31.62313550676706, 1.658498315009308],
            [31.623826257321646, 1.657928247598374],
            [31.625479761112306, 1.657349129691152],
            [31.62657211159948, 1.657805321510348],
            [31.628369000882515, 1.656916698149002],
            [31.629509993345682, 1.65692010672804],
            [31.63181389447005, 1.657689808801865],
            [31.632860101196016, 1.657573727691022],
            [31.634527729197874, 1.656076850493918],
            [31.63773941654439, 1.655013647865877],
            [31.641632206539292, 1.652462554030024],
            [31.64578937790886, 1.653595302673648],
            [31.647355651692166, 1.654672686341672],
            [31.64865928054428, 1.656226068372531],
            [31.64933428273358, 1.657241222503947],
            [31.649875852763877, 1.659364462258175],
            [31.650989432237854, 1.660869610568167],
            [31.651647642219583, 1.668774119537417],
            [31.65668845938466, 1.668240778822298],
            [31.661488343898977, 1.66904169046872],
            [31.663255904984613, 1.670441502891283],
            [31.666628712363835, 1.671571920962417],
            [31.669097275578093, 1.673081086272405],
            [31.67244014660047, 1.671863277754814],
            [31.677581889487747, 1.668946282267228],
            [31.68029195757958, 1.668906623206485],
            [31.68225700160236, 1.66730328017172],
            [31.68385118693985, 1.666688165893017],
            [31.686491259203077, 1.666099973324844],
            [31.691375645541235, 1.666388537451027],
            [31.691347716919037, 1.668104877323853],
            [31.6919377977713, 1.669846860688913],
            [31.69145792044146, 1.671681052145904],
            [31.69199929913058, 1.673899709448504],
            [31.692497067307606, 1.674497146582174],
            [31.69484953045789, 1.674885517256997],
            [31.69696152179317, 1.676417453337124],
            [31.696911261951335, 1.677537742900802],
            [31.69377260943403, 1.682761199282384],
            [31.691460449198992, 1.68535282752849],
            [31.690705766443944, 1.68777027901708],
            [31.687845617715908, 1.690860910323335],
            [31.6866130581792, 1.694278173126285],
            [31.68599388269152, 1.694729279489034],
            [31.684632464318863, 1.697371380072092],
            [31.68741149248181, 1.698309344656311],
            [31.692880576967017, 1.702580832139976],
            [31.693472495772365, 1.703559997865156],
            [31.693610891123328, 1.705300690607687],
            [31.69468004531325, 1.705542242054253],
            [31.695604847423525, 1.706498556084964],
            [31.69849242261551, 1.706805081534545],
            [31.699821981338307, 1.707500360779393],
            [31.707826714324877, 1.705295051686228],
            [31.70923210433235, 1.704131075578364],
            [31.710206999197798, 1.704038604391279],
            [31.71129919517477, 1.704590128007583],
            [31.716187063382943, 1.703495992455936],
            [31.718493135735326, 1.703431278587066],
            [31.722491086110676, 1.701702774305288],
            [31.725563011768642, 1.699518583044527],
            [31.72896911879713, 1.706608947777785],
            [31.73052796081809, 1.710809306482115],
            [31.731363265573236, 1.714375775179159],
            [31.734349220661883, 1.718270414881386],
            [31.737557406375412, 1.723655681820381],
            [31.73822919529096, 1.72602970726322],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 384,
        District: "MASINDI",
        County: "MASINDI MUNICIPALITY",
        Subcounty: "KARUJUBU DIVISION",
        Population: 27824,
        Key: "MASINDIKARUJUBU DIVISION",
        Dist2: "Masindi",
        "Sub Country": "Karujubu Div.",
        id2_original: "Masindi Karujubu Div.",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.744654354936458, 1.669855638889732],
            [31.74366624854809, 1.669593409878089],
            [31.742072667776785, 1.669946355343184],
            [31.739002819023774, 1.671296232162197],
            [31.738073360945382, 1.672270936545544],
            [31.736620377295814, 1.672892086774541],
            [31.72836271286123, 1.673891188972252],
            [31.727195071875162, 1.671107922105177],
            [31.723785373382135, 1.667547968331452],
            [31.723498170307717, 1.664889871060712],
            [31.72071039075725, 1.659948923206434],
            [31.720264596407628, 1.653134290634161],
            [31.719713214079494, 1.652022891194308],
            [31.71788831083431, 1.651283626265611],
            [31.716321332771837, 1.652730393858577],
            [31.713883006850047, 1.658397017613863],
            [31.709428426646113, 1.65729926441688],
            [31.706484426474503, 1.655764913274103],
            [31.7061037321352, 1.655906816555796],
            [31.70599957427461, 1.657152471953919],
            [31.704710604131343, 1.658308950447263],
            [31.703720262734564, 1.658522143615562],
            [31.701172459129108, 1.660278772735303],
            [31.7004586793639, 1.660538895525625],
            [31.69921139374474, 1.660237238605335],
            [31.69847332353425, 1.660711853649688],
            [31.69816113202358, 1.662022091964334],
            [31.698583768703493, 1.664192713379164],
            [31.69801027614127, 1.66543064579623],
            [31.69539360948279, 1.666161970383227],
            [31.691375645541235, 1.666388537451027],
            [31.686491259203077, 1.666099973324844],
            [31.68385118693985, 1.666688165893017],
            [31.68225700160236, 1.66730328017172],
            [31.68029195757958, 1.668906623206485],
            [31.677581889487747, 1.668946282267228],
            [31.67244014660047, 1.671863277754814],
            [31.669097275578093, 1.673081086272405],
            [31.666628712363835, 1.671571920962417],
            [31.663255904984613, 1.670441502891283],
            [31.661488343898977, 1.66904169046872],
            [31.65668845938466, 1.668240778822298],
            [31.651647642219583, 1.668774119537417],
            [31.650989432237854, 1.660869610568167],
            [31.649875852763877, 1.659364462258175],
            [31.64933428273358, 1.657241222503947],
            [31.64865928054428, 1.656226068372531],
            [31.647355651692166, 1.654672686341672],
            [31.64578937790886, 1.653595302673648],
            [31.641632206539292, 1.652462554030024],
            [31.63773941654439, 1.655013647865877],
            [31.634527729197874, 1.656076850493918],
            [31.632860101196016, 1.657573727691022],
            [31.63181389447005, 1.657689808801865],
            [31.629509993345682, 1.65692010672804],
            [31.628369000882515, 1.656916698149002],
            [31.628990878502567, 1.65534523662958],
            [31.628764794105134, 1.645725699984533],
            [31.630804366855433, 1.642787697157931],
            [31.632578626678157, 1.641478798467123],
            [31.63432603765366, 1.641320142960888],
            [31.637133760701726, 1.640184207708624],
            [31.638600346641304, 1.643144551666804],
            [31.639385648472814, 1.642789308073174],
            [31.643853426724874, 1.638380458087125],
            [31.64430106801077, 1.640026653881064],
            [31.645555995598038, 1.642056663869322],
            [31.650315351720014, 1.644824122853134],
            [31.65374692239356, 1.641306122420718],
            [31.65862528013783, 1.639127366638757],
            [31.667721149089292, 1.637711942842507],
            [31.671084479242264, 1.637829133179099],
            [31.67257905309285, 1.639073155739131],
            [31.67379229974929, 1.638695320849173],
            [31.675289241558954, 1.638961951195234],
            [31.67906009154226, 1.637673818649457],
            [31.68091481166834, 1.637440880056512],
            [31.68574615069233, 1.635047330553682],
            [31.687029272803137, 1.635265666073031],
            [31.68873002348617, 1.634805780318674],
            [31.68956408317634, 1.633950021556313],
            [31.689829064625556, 1.632496619773804],
            [31.69118717270641, 1.631189439328641],
            [31.691803678401048, 1.626888276047703],
            [31.69261441243655, 1.625841727514324],
            [31.693708169685447, 1.6257257397372],
            [31.694780214653957, 1.624751482195189],
            [31.696277256176636, 1.620023782320877],
            [31.698614299745042, 1.616907672482888],
            [31.70091878926591, 1.612492217086339],
            [31.70391883981968, 1.61045079930178],
            [31.706792101255946, 1.606752171366576],
            [31.709506819926016, 1.60473373389487],
            [31.714122087174722, 1.60319762129151],
            [31.716757964305575, 1.599355224973011],
            [31.717045984846912, 1.598187928982077],
            [31.721406895021207, 1.593647263628082],
            [31.722433463676765, 1.591790769099742],
            [31.72433585020846, 1.590941564482249],
            [31.729340032279644, 1.591345940536051],
            [31.73183672983026, 1.591043246897272],
            [31.7335465382263, 1.591763409791382],
            [31.73552519352223, 1.589385185169239],
            [31.738083197497726, 1.588284027111347],
            [31.741174794463802, 1.587720814765775],
            [31.74350345136074, 1.58810897590401],
            [31.748261166260686, 1.5866446786774],
            [31.74640260314179, 1.593540908316728],
            [31.746566601376696, 1.599584742203795],
            [31.747583750298187, 1.601709413033224],
            [31.747628696605094, 1.60280614951398],
            [31.74643724756905, 1.609036789463254],
            [31.748283852314856, 1.612236680230101],
            [31.749516745126552, 1.613599109976994],
            [31.75239823602913, 1.613920661909405],
            [31.75691938319225, 1.613081085407531],
            [31.7583150857677, 1.612351892941929],
            [31.762333841125024, 1.611680465079133],
            [31.764454569474733, 1.611794078555913],
            [31.76629601070429, 1.612300624834931],
            [31.76730952055057, 1.613712874203786],
            [31.764060191997007, 1.617915049562426],
            [31.757192338986265, 1.623077334932631],
            [31.755806319351237, 1.624455964572989],
            [31.754970814271804, 1.626071891876239],
            [31.754844880350447, 1.628635492823155],
            [31.755234485079058, 1.630376625359452],
            [31.75595986209456, 1.631176808746191],
            [31.760740954751434, 1.632422022520169],
            [31.759075524927074, 1.636342785764878],
            [31.758039621877412, 1.649290137833653],
            [31.757206863846104, 1.651417940460486],
            [31.75717079828407, 1.655590394097505],
            [31.75634962851992, 1.660766779616159],
            [31.756657943800153, 1.670068285763977],
            [31.7546012707201, 1.67107190959496],
            [31.750292502358135, 1.668526351615154],
            [31.748189757382114, 1.668087200583343],
            [31.74474447482407, 1.669161255787177],
            [31.74445424083388, 1.669416454931202],
            [31.744654354936458, 1.669855638889732],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 385,
        District: "MASINDI",
        County: "MASINDI MUNICIPALITY",
        Subcounty: "NYANGAHYA DIVISION",
        Population: 13041,
        Key: "MASINDINYANGAHYA DIVISION",
        Dist2: "Masindi",
        "Sub Country": "Nyangahya Div.",
        id2_original: "Masindi Nyangahya Div.",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.760740954751434, 1.632422022520169],
            [31.7634284409937, 1.631762577290063],
            [31.76540643692619, 1.631871389193589],
            [31.766956383829225, 1.632571662408168],
            [31.770376362642327, 1.635102069556524],
            [31.774705654813584, 1.636879927981848],
            [31.778393878655393, 1.637904276184283],
            [31.77994361265768, 1.638981102625385],
            [31.78069067230922, 1.641294693354738],
            [31.78261584909965, 1.640381380748012],
            [31.78395242456314, 1.640328405457629],
            [31.787588669187627, 1.638931988473457],
            [31.78849751991341, 1.638932543405187],
            [31.790582110835853, 1.639633133824573],
            [31.7943775827428, 1.640173381158793],
            [31.799722336799434, 1.642597355032167],
            [31.801270616429285, 1.646148706442166],
            [31.80431587649634, 1.649647173461024],
            [31.806077433242642, 1.654166957094684],
            [31.80794423840424, 1.661484110676426],
            [31.81168299068412, 1.667565143131262],
            [31.81328481259987, 1.671008957290328],
            [31.81381940451702, 1.673595069849219],
            [31.813822873810643, 1.674586840974915],
            [31.811904929356547, 1.671297204623788],
            [31.81088213272687, 1.670053424961222],
            [31.809978211955364, 1.669790062783464],
            [31.807718370500776, 1.66959792289394],
            [31.806314794191838, 1.670792970205724],
            [31.805030230285027, 1.670935954416245],
            [31.804411673736578, 1.671796532606937],
            [31.803448299764636, 1.671401622571758],
            [31.803067625188234, 1.672238383791377],
            [31.801878215327868, 1.672381395732546],
            [31.800450810307726, 1.674006833624699],
            [31.798690397116797, 1.675225639310793],
            [31.79928497044377, 1.676780104204429],
            [31.79852367518996, 1.677808006426984],
            [31.7966562196481, 1.678966988777976],
            [31.795347690486118, 1.681261972528078],
            [31.794491268135275, 1.681739884174329],
            [31.793426603725145, 1.684314953307686],
            [31.79375728436101, 1.685329723874805],
            [31.793439864655365, 1.686170162426495],
            [31.793523148363665, 1.691257524272982],
            [31.79258441967156, 1.695170248205759],
            [31.792278595419607, 1.70051824983023],
            [31.79196067984392, 1.702141349374604],
            [31.790475280487332, 1.70487972801403],
            [31.790947707190174, 1.7095615052279],
            [31.790090886885682, 1.712420430839959],
            [31.789438638124196, 1.712852698312602],
            [31.786897545832222, 1.716884789001095],
            [31.787353703146966, 1.719439298466666],
            [31.7850798749234, 1.728137661148086],
            [31.784367276442808, 1.7290598398421],
            [31.783491634636466, 1.731892314476039],
            [31.783523069383197, 1.73334684627077],
            [31.78282086441042, 1.734876884349554],
            [31.783035716273545, 1.736298969927524],
            [31.78565376813422, 1.741695386993325],
            [31.78618091750925, 1.743986043218525],
            [31.785487453144203, 1.748685619185447],
            [31.784515033137357, 1.750986151825328],
            [31.78090112871565, 1.750777551756764],
            [31.777471311553533, 1.749516175458382],
            [31.776230492906112, 1.749797577108675],
            [31.770985114977787, 1.753386963909149],
            [31.7679634994673, 1.754817754940582],
            [31.766387123230295, 1.756727380540547],
            [31.762523544651774, 1.753047630623628],
            [31.75920580579609, 1.750750957874928],
            [31.752712339154737, 1.74509472030803],
            [31.749123431254123, 1.739036212169425],
            [31.746584404189004, 1.737097717184584],
            [31.745209906345814, 1.735305696080836],
            [31.73941091018262, 1.72972205188443],
            [31.73822919529096, 1.72602970726322],
            [31.737557406375412, 1.723655681820381],
            [31.734349220661883, 1.718270414881386],
            [31.731363265573236, 1.714375775179159],
            [31.73052796081809, 1.710809306482115],
            [31.72896911879713, 1.706608947777785],
            [31.725563011768642, 1.699518583044527],
            [31.72955827258802, 1.696521651088488],
            [31.732419634940037, 1.695784588480039],
            [31.73505429665031, 1.695890971565083],
            [31.743302900676944, 1.699419464333301],
            [31.742906704110762, 1.701857425600691],
            [31.74678634905814, 1.699161666047851],
            [31.74538881212285, 1.697059680198477],
            [31.743527534295197, 1.690542574639708],
            [31.74041063358422, 1.683971125294107],
            [31.74100889359711, 1.682327952625187],
            [31.741035924802333, 1.680969172367219],
            [31.744219140944246, 1.676961490672157],
            [31.74584609412833, 1.672603588254166],
            [31.745848139592255, 1.671745355818082],
            [31.744654354936458, 1.669855638889732],
            [31.74445424083388, 1.669416454931202],
            [31.74474447482407, 1.669161255787177],
            [31.748189757382114, 1.668087200583343],
            [31.750292502358135, 1.668526351615154],
            [31.7546012707201, 1.67107190959496],
            [31.756657943800153, 1.670068285763977],
            [31.75634962851992, 1.660766779616159],
            [31.75717079828407, 1.655590394097505],
            [31.757206863846104, 1.651417940460486],
            [31.758039621877412, 1.649290137833653],
            [31.759075524927074, 1.636342785764878],
            [31.760740954751434, 1.632422022520169],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 386,
        District: "MASINDI",
        County: "MASINDI MUNICIPALITY",
        Subcounty: "KIGULYA DIVISION",
        Population: 12747,
        Key: "MASINDIKIGULYA DIVISION",
        Dist2: "Masindi",
        "Sub Country": "Kigulya Div.",
        id2_original: "Masindi Kigulya Div.",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.560111221830706, -0.199279815379244],
            [30.5593245779162, -0.199187448465189],
            [30.55415715309327, -0.203072983080892],
            [30.55240600153292, -0.203530074461],
            [30.55013339052655, -0.200302077584516],
            [30.548351899265796, -0.198986448938853],
            [30.5462615276845, -0.198077344057553],
            [30.544194815931117, -0.197837884276446],
            [30.542389343245546, -0.198124605938783],
            [30.538808547131964, -0.199724220036069],
            [30.540008186108473, -0.203195845788436],
            [30.543570832660038, -0.207836015926057],
            [30.543807863927565, -0.211255987137815],
            [30.54185950251792, -0.213790735157881],
            [30.540504884391993, -0.217234361115892],
            [30.53879400250919, -0.220199610889833],
            [30.539411082227307, -0.223667466349301],
            [30.53926824830052, -0.225485025379824],
            [30.53824652156432, -0.226895868845163],
            [30.538222580563716, -0.227995979294892],
            [30.536773076987537, -0.230435113944425],
            [30.53648767144201, -0.232420051136584],
            [30.53819708457929, -0.238136159163062],
            [30.538220396759236, -0.240647294077522],
            [30.53748369558126, -0.242201670248913],
            [30.536271953602952, -0.243349394265007],
            [30.53261341458969, -0.244353176147056],
            [30.53152047750265, -0.24535742327717],
            [30.53053433572984, -0.250484333693253],
            [30.552445349538978, -0.245067827946418],
            [30.56610586567291, -0.238390390970016],
            [30.566192353671823, -0.234066829968413],
            [30.567882761152646, -0.23199582792259],
            [30.566864586355138, -0.228091665284417],
            [30.566948936363662, -0.225110231377931],
            [30.56627223276519, -0.223280517289055],
            [30.563200283751037, -0.220070390986576],
            [30.562060340520105, -0.217893854527135],
            [30.559827817731612, -0.21501796987216],
            [30.560921026109884, -0.211675526264108],
            [30.56381699965147, -0.208953458849191],
            [30.563958431308123, -0.20753140190933],
            [30.563602486453213, -0.204948378621115],
            [30.561037617552298, -0.199925634572528],
            [30.560111221830706, -0.199279815379244],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 387,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "IGORORA TOWN COUNCIL",
        Population: 5880,
        Key: "IBANDAIGORORA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.591424869379395, 0.026789219660388],
              [30.591977210209926, 0.028662302928111],
              [30.590688150235106, 0.030488211144785],
              [30.586459999381685, 0.030072301107782],
              [30.58550824152468, 0.03049712332946],
              [30.58476746289361, 0.031762601442932],
              [30.582885537289165, 0.033281145693891],
              [30.581458327203425, 0.033733070069763],
              [30.577846779961, 0.033723932408271],
              [30.57562073043246, 0.035061673643922],
              [30.574813070431855, 0.034989336819199],
              [30.57453358298741, 0.034388911078183],
              [30.572945619381578, 0.034423210546174],
              [30.57076008746558, 0.033538253365973],
              [30.570636839506907, 0.030093045001464],
              [30.571283933735312, 0.028428330453204],
              [30.57344579953514, 0.02541494294539],
              [30.573374546963432, 0.024673540954367],
              [30.57211547634605, 0.024625682313732],
              [30.56810078406876, 0.02075119669553],
              [30.567245575341857, 0.020416356881506],
              [30.56540791601965, 0.02253706262422],
              [30.563442234193037, 0.023235465870988],
              [30.55960648991358, 0.026038115873266],
              [30.554993229501257, 0.027383526121344],
              [30.55337208572207, 0.024840541343348],
              [30.551655853473452, 0.02500384875837],
              [30.550687676209666, 0.025653621699426],
              [30.548029659200353, 0.029357278170391],
              [30.54804569143322, 0.038072700996912],
              [30.550140215926067, 0.052757034085103],
              [30.548916793154103, 0.052328570214111],
              [30.546613932278877, 0.051760371658263],
              [30.54395382488985, 0.049331263396749],
              [30.53801489186664, 0.046528349113052],
              [30.535068744721507, 0.044296349845289],
              [30.529849767381045, 0.041409157245102],
              [30.527400538606685, 0.041174243367737],
              [30.524222126654923, 0.039729032302253],
              [30.5185829308993, 0.040141736209815],
              [30.517660193117557, 0.039006271351446],
              [30.517736207658576, 0.036865387072782],
              [30.51943950686205, 0.035042233206507],
              [30.519653393934558, 0.031670195357096],
              [30.519059563514315, 0.029756964638247],
              [30.519225881199294, 0.028465548549161],
              [30.518917076337207, 0.027939407147618],
              [30.517412789901773, 0.027262299385823],
              [30.513764494377718, 0.020839255842102],
              [30.511227705914305, 0.013963091041267],
              [30.5092051256959, 0.011899939364044],
              [30.510226221814733, 0.01117671113337],
              [30.50971008668342, 0.009497422128179],
              [30.51225774835503, 0.00724541310873],
              [30.516584509073834, 0.010211598039837],
              [30.518057333813086, 0.009063684073655],
              [30.519221349198666, 0.006959157759116],
              [30.523822264064083, 0.002168032733751],
              [30.527659237238836, 0.002131704863655],
              [30.533113188704768, -0.001384409853898],
              [30.540797038081944, -0.002984298593915],
              [30.541647746249257, -0.003680298901819],
              [30.543787847666405, -0.003137961711261],
              [30.544688921676748, -0.003336819070449],
              [30.545349821214412, -0.004005705527932],
              [30.54659222359172, -0.003680129120235],
              [30.548131640442975, -0.008035784126328],
              [30.549081811875176, -0.015869085142465],
              [30.549234034095033, -0.023526398726264],
              [30.548488998347818, -0.025562364553769],
              [30.548653766438935, -0.039748036157512],
              [30.550364126400552, -0.041374354723468],
              [30.558583533383786, -0.044005342492028],
              [30.561196587916548, -0.046731841712021],
              [30.563619681106058, -0.04692324927897],
              [30.567563210643183, -0.045536247338535],
              [30.568910903656587, -0.044644712814261],
              [30.568603588201245, -0.044459402105275],
              [30.56867555134036, -0.043750652217343],
              [30.570369727253812, -0.04223471775443],
              [30.57022246103941, -0.03853075994276],
              [30.571769218024844, -0.038799817885508],
              [30.572437278033643, -0.037956573110726],
              [30.573757931757015, -0.038256664248163],
              [30.575546235840886, -0.037697985926038],
              [30.576085859221944, -0.035571731575476],
              [30.575429987554898, -0.032882560573833],
              [30.578885433652072, -0.030434674256368],
              [30.579141420270386, -0.028892500682216],
              [30.57805943723991, -0.028349789859251],
              [30.57714423093351, -0.026838830014825],
              [30.577629002284993, -0.026401563419374],
              [30.577233456099112, -0.025117059829511],
              [30.57899026075753, -0.02389505920245],
              [30.578712860099472, -0.022970014624434],
              [30.57982800443866, -0.018612619845756],
              [30.579397547025884, -0.017386680054877],
              [30.57975821791752, -0.016836184388503],
              [30.578955451938565, -0.016476985850788],
              [30.577477911044085, -0.014450666918103],
              [30.57846100842643, -0.012891285054094],
              [30.57946739822575, -0.012322867987002],
              [30.580607573221997, -0.010964195792263],
              [30.580766580417198, -0.010089643657098],
              [30.58166243162248, -0.009055020721189],
              [30.58194166304709, -0.007551883246805],
              [30.581476290814155, -0.006833497824813],
              [30.58191064332201, -0.00552166915845],
              [30.581755519543805, -0.005158572817129],
              [30.58045247100338, -0.005103911230632],
              [30.58030122525224, -0.004506559416573],
              [30.580700740195066, -0.004105255030828],
              [30.58141812489949, -0.002761358300238],
              [30.58028849342971, -0.001465715471933],
              [30.579672969593666, 0.000166830622987],
              [30.579583767784282, 0.00170900799687],
              [30.580192630612483, 0.002255605897461],
              [30.579285923266983, 0.003215542015705],
              [30.57921145652319, 0.004691854011303],
              [30.58082086830475, 0.005820192800628],
              [30.583747094410153, 0.010152702694131],
              [30.583613479893113, 0.011321195262543],
              [30.585792875417397, 0.011064822373568],
              [30.586314750783398, 0.012149259579141],
              [30.584924447981106, 0.012035757445506],
              [30.585233396573628, 0.012695666126068],
              [30.584799177914732, 0.013574134907521],
              [30.585500578895306, 0.014654372478606],
              [30.58289114187823, 0.01552020016047],
              [30.582448589548452, 0.01507045054465],
              [30.58188494162342, 0.016020369515291],
              [30.58337126624476, 0.016234754246],
              [30.582966277866888, 0.016655069661905],
              [30.583379600813963, 0.017344403542918],
              [30.582947731249543, 0.017480545912908],
              [30.58312908134245, 0.018290123777163],
              [30.584085175367353, 0.018298544584226],
              [30.58389728464084, 0.01900468234387],
              [30.58461539338739, 0.01934515459727],
              [30.585224958698163, 0.019109784327961],
              [30.586185222702582, 0.019521716659557],
              [30.58592218430929, 0.02000928533586],
              [30.58637309186953, 0.0201143738446],
              [30.58641314684974, 0.020637652345976],
              [30.58703275263043, 0.020303530285584],
              [30.587128787924197, 0.019815957118599],
              [30.587859425474, 0.020030334658296],
              [30.5880890689966, 0.019227521115786],
              [30.58863981891077, 0.01910180818701],
              [30.58926646568668, 0.017916130888541],
              [30.589884374549822, 0.018348421741184],
              [30.591003304389613, 0.018164148539677],
              [30.591299471752265, 0.018494421323498],
              [30.59236021321954, 0.018151560448215],
              [30.592322612436696, 0.019715166149729],
              [30.59280692115581, 0.019988385133731],
              [30.592034522725072, 0.020127079615196],
              [30.59076282808298, 0.021539351522675],
              [30.59153765825319, 0.02173270938223],
              [30.5909197152541, 0.023220645466659],
              [30.59095726483297, 0.024595106359213],
              [30.591934234806747, 0.024788474994363],
              [30.591424869379395, 0.026789219660388],
            ],
          ],
          [
            [
              [30.45609940577326, 0.032099625030703],
              [30.454892393424903, 0.034149932305894],
              [30.452309899578104, 0.034430969293871],
              [30.452309836696035, 0.03541469531414],
              [30.453286982739616, 0.036820136246347],
              [30.453426484815033, 0.038576793200767],
              [30.456497427716073, 0.042582129417309],
              [30.456985939652416, 0.044549644136537],
              [30.456357737892763, 0.045954958247214],
              [30.456148296582587, 0.047571192194997],
              [30.45642749027795, 0.048203511611053],
              [30.457474386910057, 0.04841436859117],
              [30.45824221650925, 0.048133330754282],
              [30.459009922140954, 0.048625288452672],
              [30.459637998136476, 0.051225185272541],
              [30.459358804441113, 0.052490011776171],
              [30.461243158191813, 0.055230583647289],
              [30.46096384052895, 0.057900724814852],
              [30.461382600080093, 0.05916555027819],
              [30.459567809170064, 0.060641107784344],
              [30.45935836785989, 0.061414041172529],
              [30.459637498673192, 0.062678867452619],
              [30.46061458183467, 0.064013999405701],
              [30.46047495309679, 0.065138339084312],
              [30.458660163983428, 0.065981389460263],
              [30.454918040326266, 0.06606527228917],
              [30.45433073616654, 0.065092649900145],
              [30.453737353107286, 0.06513781087526],
              [30.452938917906348, 0.064496044965498],
              [30.45226900197818, 0.063402370144505],
              [30.45197493308001, 0.061504302942056],
              [30.448735330586057, 0.060956951667163],
              [30.445220150115762, 0.058689475768758],
              [30.444513755400532, 0.057716882888872],
              [30.444556367884342, 0.05637884203816],
              [30.443572106285426, 0.054878064231287],
              [30.442739920480932, 0.054071737695026],
              [30.4415969445376, 0.053911445081851],
              [30.44145202023114, 0.05324957295814],
              [30.440378983522596, 0.052332896498728],
              [30.438009409262758, 0.051132902278532],
              [30.437364673112, 0.049717701419601],
              [30.4358885713186, 0.04884997049868],
              [30.43523971459562, 0.04721402485516],
              [30.434004721522776, 0.047123594181095],
              [30.43379845485881, 0.048642006094099],
              [30.43344298700933, 0.048786603361527],
              [30.43180108136729, 0.047991175105516],
              [30.431029932493118, 0.045623136856892],
              [30.43031788737474, 0.045668300541798],
              [30.42930252340572, 0.046798034950029],
              [30.42772149120063, 0.046318950092443],
              [30.42776431029694, 0.045369943180645],
              [30.428521819151854, 0.044909024937928],
              [30.428516528074848, 0.04381540545908],
              [30.429249632398413, 0.04321891260436],
              [30.427557110283423, 0.041808896661361],
              [30.42776476125121, 0.040570674465071],
              [30.428745463725, 0.039621698922892],
              [30.428117239507454, 0.037371172607599],
              [30.42714274888387, 0.037145187072628],
              [30.42626657078332, 0.037597068310498],
              [30.425601246144552, 0.037461473935638],
              [30.42531090974639, 0.036340734223018],
              [30.424858806528512, 0.036132842548282],
              [30.423727432327098, 0.037804863862071],
              [30.423396511841037, 0.038112150503895],
              [30.42296825799563, 0.037922335627824],
              [30.422561199899377, 0.037217347825875],
              [30.421657416570124, 0.036864832812388],
              [30.422791576447246, 0.035762215701294],
              [30.422959593744732, 0.03403620381443],
              [30.425434179264627, 0.033676865187092],
              [30.426360584867684, 0.032839920249255],
              [30.42735827448348, 0.031094263955248],
              [30.42792841004148, 0.028989890623015],
              [30.428688552756817, 0.027650753327953],
              [30.429755619261986, 0.026767510975601],
              [30.431043964177846, 0.023321351991593],
              [30.432111421450184, 0.021616806057619],
              [30.43471877437583, 0.018411654150786],
              [30.440971398197938, 0.012146675126116],
              [30.443356763043823, 0.008055346738059],
              [30.444413787282436, 0.004737742650811],
              [30.446219197984274, 0.004806737755975],
              [30.446921860199502, 0.002854466882716],
              [30.44789441046209, 0.002682743136573],
              [30.448255200829642, 0.003631768317026],
              [30.44971900289018, 0.004390994748889],
              [30.45020281214601, 0.006243855354283],
              [30.451033541781413, 0.006216745995803],
              [30.451884476324185, 0.005448493294058],
              [30.45241683502955, 0.005466572787392],
              [30.45295718245273, 0.006325220260628],
              [30.452614739276534, 0.009154220778444],
              [30.454604160881146, 0.010573261563916],
              [30.455207617647982, 0.012643054496115],
              [30.455000969200015, 0.014062074602847],
              [30.45553371957085, 0.016195136746894],
              [30.455149333155703, 0.017713576971437],
              [30.45592543803533, 0.021102978733954],
              [30.45590550441917, 0.021862201521057],
              [30.45487989696098, 0.023326396929807],
              [30.454765269235786, 0.024185038943904],
              [30.45591118356839, 0.025486588972127],
              [30.45589166497389, 0.026336194819709],
              [30.455062048351135, 0.02662540380129],
              [30.45490279861082, 0.028026346988771],
              [30.453981841289988, 0.029056697423818],
              [30.453890640729064, 0.029843032213979],
              [30.455152153865722, 0.030493826512813],
              [30.45525033253973, 0.031162668857429],
              [30.45609940577326, 0.032099625030703],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 388,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "ISHONGORORO",
        Population: 14698,
        Key: "IBANDAISHONGORORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.47211210657971, 0.104365810448413],
            [30.46980994279713, 0.104519272986693],
            [30.46780674373097, 0.102675261098231],
            [30.465024358563802, 0.101698881972166],
            [30.46288871368882, 0.101924668670792],
            [30.461683116187025, 0.100541693788329],
            [30.460316310617618, 0.097703524794637],
            [30.459414446089827, 0.097775761814793],
            [30.458566211882793, 0.099113377349529],
            [30.457615830244805, 0.09895061094801],
            [30.457299345685367, 0.097332715155486],
            [30.454816616937414, 0.094476398150526],
            [30.453899335522703, 0.096284000033564],
            [30.453362530156678, 0.095732618479534],
            [30.452990753393195, 0.092460707099338],
            [30.453223029877886, 0.088926728419734],
            [30.452883241223375, 0.087390184403036],
            [30.453153900923514, 0.084443700109462],
            [30.45281800197417, 0.081253139982769],
            [30.452284669495057, 0.078948326625956],
            [30.450590776550893, 0.074790584975711],
            [30.45191895366479, 0.074519514975571],
            [30.453155070530038, 0.074844969834988],
            [30.45336303590818, 0.073660958047153],
            [30.454641858682038, 0.072983157262406],
            [30.455309827062703, 0.07367011277064],
            [30.45609273398565, 0.073543622896489],
            [30.45530067951816, 0.071772054952563],
            [30.45561581031647, 0.070660353816326],
            [30.453974441866965, 0.069982383205625],
            [30.454138176895487, 0.069458167218098],
            [30.454967109002023, 0.069051487609639],
            [30.455291663127657, 0.06743363820192],
            [30.454918040326266, 0.06606527228917],
            [30.458660163983428, 0.065981389460263],
            [30.46047495309679, 0.065138339084312],
            [30.46061458183467, 0.064013999405701],
            [30.459637498673192, 0.062678867452619],
            [30.45935836785989, 0.061414041172529],
            [30.459567809170064, 0.060641107784344],
            [30.461382600080093, 0.05916555027819],
            [30.46096384052895, 0.057900724814852],
            [30.461243158191813, 0.055230583647289],
            [30.459358804441113, 0.052490011776171],
            [30.459637998136476, 0.051225185272541],
            [30.459009922140954, 0.048625288452672],
            [30.45824221650925, 0.048133330754282],
            [30.457474386910057, 0.04841436859117],
            [30.45642749027795, 0.048203511611053],
            [30.456148296582587, 0.047571192194997],
            [30.456357737892763, 0.045954958247214],
            [30.456985939652416, 0.044549644136537],
            [30.456497427716073, 0.042582129417309],
            [30.453426484815033, 0.038576793200767],
            [30.453286982739616, 0.036820136246347],
            [30.452309836696035, 0.03541469531414],
            [30.452309899578104, 0.034430969293871],
            [30.454892393424903, 0.034149932305894],
            [30.45609940577326, 0.032099625030703],
            [30.456856369350767, 0.03187674316196],
            [30.45752338461891, 0.032346756916178],
            [30.457853474163322, 0.031894846907095],
            [30.459348437882745, 0.0317231573232],
            [30.46194537124939, 0.028740550671134],
            [30.463816361661898, 0.025369262719374],
            [30.464667315967613, 0.024601014578312],
            [30.469084737359847, 0.024908416243208],
            [30.471240870111494, 0.024013652979263],
            [30.473049404255576, 0.022450032049598],
            [30.474649643339777, 0.019539664997888],
            [30.47837933700836, 0.017560291153582],
            [30.481651701959017, 0.016755911836454],
            [30.485901410582645, 0.016755975616845],
            [30.492339254439926, 0.017533393798584],
            [30.50053447428418, 0.017931223482903],
            [30.50052353909221, 0.017479289169861],
            [30.5092051256959, 0.011899939364044],
            [30.511227705914305, 0.013963091041267],
            [30.513764494377718, 0.020839255842102],
            [30.517412789901773, 0.027262299385823],
            [30.518917076337207, 0.027939407147618],
            [30.519225881199294, 0.028465548549161],
            [30.519059563514315, 0.029756964638247],
            [30.519653393934558, 0.031670195357096],
            [30.51943950686205, 0.035042233206507],
            [30.517736207658576, 0.036865387072782],
            [30.517660193117557, 0.039006271351446],
            [30.5185829308993, 0.040141736209815],
            [30.524222126654923, 0.039729032302253],
            [30.527400538606685, 0.041174243367737],
            [30.529849767381045, 0.041409157245102],
            [30.535068744721507, 0.044296349845289],
            [30.53801489186664, 0.046528349113052],
            [30.54395382488985, 0.049331263396749],
            [30.546613932278877, 0.051760371658263],
            [30.548916793154103, 0.052328570214111],
            [30.550661689745127, 0.056456347744957],
            [30.552870509586544, 0.060388428903844],
            [30.553724382518627, 0.064754330208322],
            [30.544743474567312, 0.064943693152281],
            [30.54244370838822, 0.065223784083907],
            [30.541778855364996, 0.065672253323871],
            [30.539406358885536, 0.065531817092622],
            [30.534292332618072, 0.066862725094971],
            [30.53454644265575, 0.069158086115307],
            [30.533738587720745, 0.072267050537568],
            [30.534340156228847, 0.074064886975636],
            [30.535662585921546, 0.075567497670295],
            [30.535971324308278, 0.076978530542396],
            [30.534165883063707, 0.077480647007598],
            [30.532889649234516, 0.075862087334092],
            [30.531811959252774, 0.075898178017296],
            [30.527459579480414, 0.077723770426344],
            [30.525010184517697, 0.079802557166074],
            [30.52145177082772, 0.08051640180968],
            [30.517027711783868, 0.084809550287931],
            [30.516123701180845, 0.087051110302032],
            [30.511098170646942, 0.086164967304079],
            [30.503365631683053, 0.086715802829662],
            [30.502610850113363, 0.087456924659367],
            [30.49821046347389, 0.088839536246543],
            [30.494968883787994, 0.091433399554845],
            [30.49465637157872, 0.092843405079697],
            [30.491336645649618, 0.095563785747037],
            [30.49078985910251, 0.096937614203421],
            [30.48964771140587, 0.098275240551417],
            [30.487480287729372, 0.098971043098681],
            [30.485428254447765, 0.096846816217597],
            [30.484526374648592, 0.09690097826361],
            [30.483638672959547, 0.0949756954761],
            [30.483043893918367, 0.094722570338813],
            [30.48145502840399, 0.095111109132356],
            [30.48008851658366, 0.097280255415177],
            [30.478773750418668, 0.097867658436096],
            [30.478469135299076, 0.098699179162185],
            [30.477405303627258, 0.099657179773503],
            [30.476193841024983, 0.099521505624464],
            [30.475460131236872, 0.100000488404535],
            [30.474480672031472, 0.103688119820129],
            [30.472557005308996, 0.103561421639653],
            [30.47211210657971, 0.104365810448413],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 389,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "ISHONGORORO TOWN COUNCIL",
        Population: 22258,
        Key: "IBANDAISHONGORORO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.5022457936465, -0.124951727458367],
            [30.4963809698376, -0.122663644719989],
            [30.493718087552676, -0.122176819134344],
            [30.48340910399714, -0.116460298017409],
            [30.480270216121234, -0.115230396414639],
            [30.479641283132953, -0.117126178228245],
            [30.478318336010656, -0.118459716364458],
            [30.476805131999406, -0.119209873590228],
            [30.473812055067174, -0.119544404577609],
            [30.47153175987187, -0.118228910015895],
            [30.465997216050205, -0.116076135175456],
            [30.464096870490845, -0.116219452101411],
            [30.461816532176414, -0.115573569225054],
            [30.459150612687505, -0.116101627514261],
            [30.450699368495723, -0.11894445343801],
            [30.444425707926282, -0.118584466039369],
            [30.444388532944867, -0.113788667043396],
            [30.446782044612057, -0.109925013183504],
            [30.4506517137682, -0.107985579144702],
            [30.455500407345184, -0.106327791492846],
            [30.459836144928577, -0.106437645381272],
            [30.465524112017615, -0.103997735352382],
            [30.467637709540607, -0.102699497605662],
            [30.47110346380567, -0.09958671782575],
            [30.476636176860747, -0.095519816868269],
            [30.48176464624138, -0.094346914262958],
            [30.48693965284532, -0.094660153681495],
            [30.491757180271797, -0.095865060510006],
            [30.493155846389403, -0.095849517880711],
            [30.497103580042044, -0.092891834989665],
            [30.499155184827266, -0.090444781473732],
            [30.498969179664535, -0.089726401425584],
            [30.500537156653614, -0.087215447011777],
            [30.500869983364677, -0.083054283632029],
            [30.49984863392093, -0.081308438419384],
            [30.497236803791914, -0.078917860292007],
            [30.494367019734142, -0.079220303895553],
            [30.492965355938463, -0.081587777359571],
            [30.490661317371877, -0.078885281122498],
            [30.487834644362877, -0.076756714240494],
            [30.48500793631959, -0.075345593326293],
            [30.482585027284717, -0.074508449537283],
            [30.48087467900119, -0.075034472875323],
            [30.474223483467306, -0.074603642130713],
            [30.472917029413626, -0.074029625435216],
            [30.472204452492598, -0.073096927004061],
            [30.47225210901675, -0.070275039732937],
            [30.47013799316583, -0.070083614279349],
            [30.469544178016946, -0.069294411648387],
            [30.467715160487785, -0.068218176814016],
            [30.46564870295765, -0.065085309770698],
            [30.46344643812286, -0.063978147665072],
            [30.472186659561757, -0.053464510068022],
            [30.47436368892359, -0.051515225110051],
            [30.4737540274931, -0.051212852306918],
            [30.470571097913762, -0.047338616651078],
            [30.461805873665554, -0.045855636049713],
            [30.460214347341303, -0.045999067310092],
            [30.458860322103426, -0.04738603780042],
            [30.457720153395393, -0.046716405067332],
            [30.456508761760023, -0.044898897334528],
            [30.453397061396206, -0.042913933753231],
            [30.453373324313137, -0.04236391162675],
            [30.451330568831786, -0.039757229513928],
            [30.44995293496993, -0.036457069622085],
            [30.44665121846567, -0.03404168263836],
            [30.444323372747405, -0.033156815286212],
            [30.443093267408067, -0.030223547736285],
            [30.441209965584576, -0.028828417572939],
            [30.438712769468964, -0.025413056483505],
            [30.435677773552342, -0.019785737794245],
            [30.435784558086777, -0.020274409600835],
            [30.433114061681522, -0.023419669896305],
            [30.431459031653187, -0.026149178173595],
            [30.430725484460186, -0.028417750995422],
            [30.430349305053497, -0.032927800622397],
            [30.429108127978232, -0.033488138161473],
            [30.425365539892073, -0.039706296846176],
            [30.42544070103359, -0.040610114987738],
            [30.424298109569218, -0.042128489305919],
            [30.422253968885673, -0.043556450882327],
            [30.420260513845427, -0.043628690681637],
            [30.419059316291918, -0.044261320051234],
            [30.41708030885636, -0.044514321491937],
            [30.414438896306727, -0.045689183670553],
            [30.409190620413302, -0.047207395290598],
            [30.410053093815897, -0.049240985439013],
            [30.410146172754082, -0.054510169255783],
            [30.41149650681442, -0.056616091480907],
            [30.411603502452966, -0.05739336917557],
            [30.411430217434674, -0.058477928019807],
            [30.409853564516563, -0.060954281875633],
            [30.409489189871028, -0.062734758799488],
            [30.409943733811517, -0.064497199299904],
            [30.41182534051406, -0.067958867510572],
            [30.414488040441004, -0.070471590968836],
            [30.415393979726925, -0.072243103267786],
            [30.417015553799125, -0.081950106172233],
            [30.419411587935624, -0.08643315992627],
            [30.417512037385297, -0.09184685402539],
            [30.41630860033176, -0.101616943170825],
            [30.420193701646173, -0.106425525332377],
            [30.42219863086754, -0.11018555288133],
            [30.423946614968195, -0.115003031478487],
            [30.42396154137497, -0.11597011442636],
            [30.422719513595155, -0.119368341452781],
            [30.42345762243318, -0.124140547978358],
            [30.423044348893477, -0.125830639722526],
            [30.421597279751737, -0.127131989072838],
            [30.421599603693398, -0.129174605595689],
            [30.423382762227295, -0.130864916197762],
            [30.424119488558127, -0.130901143362021],
            [30.42569089531495, -0.131949728763215],
            [30.425994888800354, -0.133187986592497],
            [30.42766148284132, -0.133468341948774],
            [30.42936355584445, -0.137942417416868],
            [30.430803810366445, -0.138954849023986],
            [30.43515458125613, -0.140844304064541],
            [30.44408551862314, -0.143303687020179],
            [30.448056568947276, -0.142879324203376],
            [30.451804928709148, -0.145744889665914],
            [30.454729220741733, -0.146739435531813],
            [30.458180045905067, -0.147227896453518],
            [30.460463184268253, -0.149008718806899],
            [30.463295169015524, -0.150184036382515],
            [30.465412220560783, -0.151964851309482],
            [30.4657019613759, -0.152651807648062],
            [30.462147203829115, -0.154296383471256],
            [30.458457354934986, -0.158363221286761],
            [30.45626234040287, -0.160007938595946],
            [30.452726259729168, -0.161607292828552],
            [30.450927028538167, -0.17058213536439],
            [30.45018370497992, -0.177875968992828],
            [30.451108574463834, -0.180903938716973],
            [30.453876885725446, -0.185676575364196],
            [30.4569659494424, -0.188903717152912],
            [30.458424210694247, -0.189536616345064],
            [30.458873127587815, -0.18939206742636],
            [30.46261114145255, -0.187693388472529],
            [30.46370947651615, -0.186449156570812],
            [30.466102653111726, -0.184161254729442],
            [30.46790813478047, -0.183013625116096],
            [30.470853799530325, -0.182057466773308],
            [30.478526662511566, -0.180647580573806],
            [30.482874141974055, -0.177634949467068],
            [30.486176695708206, -0.172541589369992],
            [30.48586802559342, -0.17146539274614],
            [30.48724589301722, -0.17067639067761],
            [30.48710393225288, -0.16618042744754],
            [30.488155250392833, -0.164008662246064],
            [30.48992318068607, -0.162289774359589],
            [30.49190293013003, -0.158204560548382],
            [30.49410890141365, -0.155710160366564],
            [30.495949515294843, -0.154951130758271],
            [30.498295662390372, -0.154635051594212],
            [30.50073560348301, -0.154852264336036],
            [30.501184166440357, -0.155430792529543],
            [30.505621952640055, -0.154057427080918],
            [30.507101257825774, -0.152846408996491],
            [30.50810042876345, -0.150461861885796],
            [30.506709287832997, -0.148867106169017],
            [30.50435767628559, -0.147718926537715],
            [30.502718618303057, -0.147455680608604],
            [30.499036535344537, -0.148220546814512],
            [30.491363916705037, -0.146760892620302],
            [30.489962313096463, -0.147478176145442],
            [30.486731364971952, -0.150371481798209],
            [30.481909107017184, -0.151136196087911],
            [30.48008874026417, -0.150294120050533],
            [30.481743078589734, -0.148888214710287],
            [30.48721056317544, -0.141818069480134],
            [30.491555164435766, -0.135234036870808],
            [30.49276658481721, -0.135903773057769],
            [30.493289283938314, -0.134947237038801],
            [30.49548249285674, -0.133807652674929],
            [30.500700864732686, -0.131966756284271],
            [30.501034201686846, -0.131137599987843],
            [30.502031497840548, -0.130260809720844],
            [30.5022457936465, -0.124951727458367],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 390,
        District: "IBANDA",
        County: "IBANDA MUNICIPALITY",
        Subcounty: "KAGANGO DIVISION",
        Population: 35219,
        Key: "IBANDAKAGANGO DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.30733474846132, -0.130265468371851],
            [30.306316283507943, -0.130428032474876],
            [30.305760069141893, -0.129777290069172],
            [30.303323841684627, -0.12852085470747],
            [30.30158809892635, -0.127128937503343],
            [30.30140140655244, -0.12579140589708],
            [30.30016864579308, -0.12437243315061],
            [30.298977427624063, -0.124110233501911],
            [30.298583688848503, -0.123621516993427],
            [30.29788585417961, -0.121832744499354],
            [30.294583284275813, -0.120133425027715],
            [30.293547409073895, -0.119166344918989],
            [30.292264723544346, -0.119139109855115],
            [30.291869005780217, -0.118108833365557],
            [30.29084693319267, -0.118027400359641],
            [30.289434850736317, -0.118849646345373],
            [30.2874381896088, -0.117927665116663],
            [30.28675801581838, -0.118478864812121],
            [30.28461515747167, -0.118090062209285],
            [30.283968871727016, -0.117746590291157],
            [30.28363018710197, -0.115794540859827],
            [30.28324422773678, -0.115405908899348],
            [30.280444070300035, -0.117050395610782],
            [30.279355845774965, -0.116535178729775],
            [30.276697372421463, -0.113489436115865],
            [30.274741793048538, -0.11292895764291],
            [30.26830325030195, -0.114211617296471],
            [30.266358908853213, -0.115142244913937],
            [30.263549174477216, -0.114626872589986],
            [30.259074463027787, -0.117003164088313],
            [30.25593519246959, -0.117436633543393],
            [30.254193113893617, -0.118412448911836],
            [30.25134868747965, -0.118710388012647],
            [30.25062415488052, -0.119839925406719],
            [30.24608154786357, -0.124104858894185],
            [30.246210625888406, -0.125053738102615],
            [30.246894384855146, -0.124918256310456],
            [30.248152723345566, -0.126644424258121],
            [30.251594071282657, -0.127738245287175],
            [30.251825652471325, -0.12891306266238],
            [30.2528748793333, -0.129202354484292],
            [30.253207305395765, -0.131660422599899],
            [30.254823874055173, -0.133214944063012],
            [30.255461924045303, -0.133016202224249],
            [30.255518800877525, -0.133630717385161],
            [30.256069416044397, -0.133928995873984],
            [30.256277120012818, -0.13663105424141],
            [30.258178481566762, -0.137534960747693],
            [30.258505149428267, -0.138700760393413],
            [30.258984513820057, -0.13900807135304],
            [30.259312190489638, -0.138691815894353],
            [30.260311054203505, -0.140345689379061],
            [30.260248853056584, -0.140942120421774],
            [30.2606512596763, -0.140860834812443],
            [30.26157901095568, -0.142523740675744],
            [30.262907909416707, -0.142894411361646],
            [30.264351116701025, -0.144467014221253],
            [30.265443913650916, -0.147602974182538],
            [30.266304909324855, -0.148018780485992],
            [30.26706143991443, -0.149347309757819],
            [30.268179745425105, -0.150287294674501],
            [30.268281935975185, -0.150757231422329],
            [30.26736202249672, -0.152700070363639],
            [30.267454838228485, -0.154109852571351],
            [30.26914569576529, -0.155989763557618],
            [30.270199438458175, -0.155031975244758],
            [30.27080646512994, -0.155131460603119],
            [30.272708598336724, -0.159957476829874],
            [30.274226711641017, -0.161412640357929],
            [30.275720944131802, -0.162090617760726],
            [30.276112384118548, -0.16438608247298],
            [30.277154672393248, -0.164232593361431],
            [30.27867389871017, -0.165760063472301],
            [30.281012486482595, -0.166528534830966],
            [30.28182253510351, -0.168254731910604],
            [30.281477257742605, -0.168968614585787],
            [30.280462005164686, -0.16933899465152],
            [30.27998284109718, -0.170622193760279],
            [30.281061969281676, -0.172863544105241],
            [30.281201200065905, -0.174201053970227],
            [30.281283459694787, -0.175701223619603],
            [30.28059609309387, -0.177336837783855],
            [30.281661176118913, -0.178656408957768],
            [30.281769470721372, -0.179533023848613],
            [30.28372281328922, -0.17994901903329],
            [30.28375943670505, -0.180798512960406],
            [30.285403730967406, -0.183509894161297],
            [30.285442206709355, -0.186031258016781],
            [30.28641371672281, -0.187459273492769],
            [30.284431452894367, -0.189031427247346],
            [30.283480126228703, -0.190477217343945],
            [30.283532626468865, -0.194688519860349],
            [30.284495379704946, -0.195538163089122],
            [30.284884445444373, -0.200020638021719],
            [30.285399169322414, -0.201078066312698],
            [30.28516425628234, -0.204349465760118],
            [30.286320544359857, -0.206997540222293],
            [30.285454180353767, -0.209338007992344],
            [30.28405895837697, -0.211271710243327],
            [30.294002792939207, -0.205181072230353],
            [30.296198001507435, -0.204667619159306],
            [30.30151322434741, -0.201333764791784],
            [30.302486186038372, -0.198975202099316],
            [30.307204077723462, -0.19538816417418],
            [30.309513827778623, -0.194267905914498],
            [30.31063109393852, -0.192026827728863],
            [30.311983901959167, -0.190427432985941],
            [30.312735933785778, -0.189921458790983],
            [30.31439972508306, -0.190039201226353],
            [30.314665575203207, -0.188783051607807],
            [30.31529921985517, -0.1883041686109],
            [30.31577554344972, -0.188394614996586],
            [30.316797682512618, -0.190021496427804],
            [30.318945602865977, -0.191512995162775],
            [30.320402940649704, -0.195209512759903],
            [30.321445309772805, -0.196610473968163],
            [30.323839396361766, -0.196330695317817],
            [30.327947427190338, -0.194017762476489],
            [30.3345617504751, -0.192563763021497],
            [30.34003219680627, -0.193161088995739],
            [30.342542184033213, -0.191932371305265],
            [30.345725674161265, -0.192050350880761],
            [30.34794252044975, -0.192601986120909],
            [30.34914196808508, -0.193406517216326],
            [30.349960698024912, -0.192593259935538],
            [30.354533841473327, -0.192747605798355],
            [30.35635565631056, -0.193642613787515],
            [30.358123380889563, -0.195106989529569],
            [30.360349172601637, -0.197809603683258],
            [30.364199380655457, -0.212026529782221],
            [30.365282998619787, -0.218452530718318],
            [30.36652544052293, -0.221290594128881],
            [30.367811404903282, -0.22308933029763],
            [30.37114622342748, -0.226108535786848],
            [30.37279318748284, -0.228223670770469],
            [30.378204861536577, -0.236638857404052],
            [30.386980696684937, -0.227421874124042],
            [30.389759200231744, -0.223545116739376],
            [30.392413773100287, -0.221665699941284],
            [30.39461042795614, -0.219352374655799],
            [30.395151780594105, -0.217481615228761],
            [30.39562958820553, -0.212230655260149],
            [30.395086946485126, -0.197688527673766],
            [30.39550424717225, -0.19315154804335],
            [30.39636897983778, -0.190684320990363],
            [30.39898838276466, -0.187286439454623],
            [30.40453735083482, -0.178267328936032],
            [30.403275894292044, -0.178068316231866],
            [30.399104083976617, -0.178564820769688],
            [30.39740555931885, -0.176187600662216],
            [30.395186257036407, -0.175464258143492],
            [30.392558765678732, -0.17368342552931],
            [30.39169928366604, -0.171830536507638],
            [30.391265047939164, -0.168278580281936],
            [30.38982245869575, -0.166335240655211],
            [30.389645025257455, -0.164057667838921],
            [30.388733806572596, -0.161924607963226],
            [30.387137927910807, -0.160830820916925],
            [30.386832582460872, -0.159493177192894],
            [30.385203440980728, -0.15855303368205],
            [30.384952740049567, -0.157685367727945],
            [30.383955965817044, -0.15772139542423],
            [30.38350990915933, -0.156510267955619],
            [30.380949363849915, -0.15444028766759],
            [30.380066853524895, -0.152641652229817],
            [30.37975235424224, -0.149153014702509],
            [30.378073177499093, -0.144172982188472],
            [30.356541957917333, -0.152286335656939],
            [30.351706714815123, -0.149212957281605],
            [30.350356879319744, -0.147125108862881],
            [30.34992158537746, -0.145064483606229],
            [30.34883673761954, -0.143988883832869],
            [30.348943150251447, -0.143193587148132],
            [30.348048116513056, -0.140563545452223],
            [30.34542237866681, -0.141222994013509],
            [30.34413334204819, -0.14232543100296],
            [30.341895340434792, -0.142695715417667],
            [30.341144705488436, -0.143301145694206],
            [30.33903942007676, -0.142270625854798],
            [30.337143553517397, -0.142514422480147],
            [30.336323370103425, -0.141682877935189],
            [30.336398139579472, -0.140354373366848],
            [30.335038585211063, -0.139956570006514],
            [30.33316670726302, -0.140218446993712],
            [30.328669111231708, -0.138790023924839],
            [30.32773569876946, -0.138310934919938],
            [30.326199382902548, -0.135671834092683],
            [30.325528537218048, -0.135283151223791],
            [30.324370055454622, -0.135608372787266],
            [30.321974982515442, -0.133493359063218],
            [30.318276039077368, -0.133836381617675],
            [30.316800649648002, -0.132064899663473],
            [30.315945602617845, -0.132055771007817],
            [30.315362733440683, -0.132742547378568],
            [30.314509220733036, -0.132832829618794],
            [30.31257088272537, -0.131847552856898],
            [30.31138998530064, -0.130708724729622],
            [30.307805916624456, -0.130021511722872],
            [30.30733474846132, -0.130265468371851],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 391,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "KICUZI",
        Population: 16510,
        Key: "IBANDAKICUZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.444413787282436, 0.004737742650811],
            [30.443356763043823, 0.008055346738059],
            [30.440971398197938, 0.012146675126116],
            [30.43471877437583, 0.018411654150786],
            [30.432111421450184, 0.021616806057619],
            [30.431043964177846, 0.023321351991593],
            [30.429755619261986, 0.026767510975601],
            [30.428688552756817, 0.027650753327953],
            [30.42792841004148, 0.028989890623015],
            [30.42735827448348, 0.031094263955248],
            [30.426360584867684, 0.032839920249255],
            [30.425434179264627, 0.033676865187092],
            [30.422959593744732, 0.03403620381443],
            [30.422407402034516, 0.033432283621569],
            [30.422219969448797, 0.032334682662348],
            [30.418407571485304, 0.030059037484431],
            [30.415426707149347, 0.02649648658872],
            [30.413792821666192, 0.025298294920549],
            [30.410605714022488, 0.024160995537464],
            [30.407177282960866, 0.024553017597077],
            [30.406412283953117, 0.0243647729515],
            [30.405562815460907, 0.023009052708589],
            [30.404640733449313, 0.018905779633114],
            [30.401566297898423, 0.013998101081804],
            [30.396479926266966, 0.008304126170326],
            [30.39361347316223, 0.006713425411518],
            [30.38925342447229, 0.001896194444092],
            [30.386710165443848, 0.000423011277404],
            [30.38468703545652, -0.002704093395898],
            [30.384797569558973, -0.003788637521503],
            [30.38499029681495, -0.006075217321911],
            [30.386234492229562, -0.009148096963209],
            [30.386609840694607, -0.012193863626948],
            [30.388406836877166, -0.014724485984224],
            [30.38915795511716, -0.018059475949681],
            [30.39006774727733, -0.018990391046799],
            [30.394387534374562, -0.02134030912417],
            [30.39604772163093, -0.025994875471538],
            [30.402648305183412, -0.036560409994769],
            [30.405275601606686, -0.042326731265638],
            [30.409190620413302, -0.047207395290598],
            [30.414438896306727, -0.045689183670553],
            [30.41708030885636, -0.044514321491937],
            [30.419059316291918, -0.044261320051234],
            [30.420260513845427, -0.043628690681637],
            [30.422253968885673, -0.043556450882327],
            [30.424298109569218, -0.042128489305919],
            [30.42544070103359, -0.040610114987738],
            [30.425365539892073, -0.039706296846176],
            [30.429108127978232, -0.033488138161473],
            [30.430349305053497, -0.032927800622397],
            [30.430725484460186, -0.028417750995422],
            [30.431459031653187, -0.026149178173595],
            [30.433114061681522, -0.023419669896305],
            [30.435784558086777, -0.020274409600835],
            [30.435677773552342, -0.019785737794245],
            [30.434900707475354, -0.01755389245409],
            [30.43565291177854, -0.013540927785647],
            [30.435051138454533, -0.01164289543407],
            [30.435276859034303, -0.008994697053982],
            [30.43512634630843, -0.008081836258906],
            [30.434261402538812, -0.007286468811811],
            [30.43347151121453, -0.005551129408057],
            [30.433509106607488, -0.003960404386581],
            [30.434562305819632, -0.002478137457749],
            [30.438398740005226, -0.002216027024374],
            [30.439000528600552, -0.001836420545126],
            [30.441761183521002, 0.0010287138324],
            [30.443035033221467, 0.004210191730458],
            [30.444413787282436, 0.004737742650811],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 392,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "KIJONGO",
        Population: 10699,
        Key: "IBANDAKIJONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.416727936722204, 0.317022553512939],
            [32.41740475171175, 0.320070490164943],
            [32.41266900421379, 0.318061810182348],
            [32.40920195457811, 0.317491657342518],
            [32.40770710763967, 0.317681553784765],
            [32.404352836098, 0.314216411855468],
            [32.40131162833118, 0.311845960285744],
            [32.395899341626425, 0.310723837326444],
            [32.392965646029424, 0.309221891422998],
            [32.38965175914969, 0.306905709672798],
            [32.385833443085055, 0.305883196259852],
            [32.38199578359745, 0.304326918536797],
            [32.37741759161715, 0.301609715385657],
            [32.37523149016926, 0.305066077833111],
            [32.372996432335064, 0.306310634623288],
            [32.37009554500886, 0.309039202804402],
            [32.36788416317225, 0.311935363789787],
            [32.366814094497386, 0.314089565355867],
            [32.36072757006963, 0.310163639968719],
            [32.354416881842496, 0.303827062528041],
            [32.35181799733502, 0.297150564342684],
            [32.34983391082487, 0.293846697194917],
            [32.34843656433244, 0.287040488692696],
            [32.34820377041815, 0.284128422074768],
            [32.34617400367746, 0.278930528062372],
            [32.34481521197873, 0.277012539705338],
            [32.34401800926633, 0.276134958779237],
            [32.34182173799114, 0.275483470354326],
            [32.33983689060795, 0.275501450825212],
            [32.33725806009091, 0.276342653147193],
            [32.339453342320965, 0.274515335682983],
            [32.34188895622892, 0.273628890098951],
            [32.342449796020354, 0.272959462384844],
            [32.343789724894776, 0.265342170594375],
            [32.344742630798706, 0.263849508105895],
            [32.34513898457005, 0.261669261448178],
            [32.34584307959818, 0.260230864289266],
            [32.3460122934516, 0.257145929231993],
            [32.349125773378, 0.251356164570484],
            [32.35150868761976, 0.248488458648575],
            [32.354176281568364, 0.241233081193118],
            [32.35706357738429, 0.237659744453768],
            [32.35798981500239, 0.235796151404648],
            [32.358286172807894, 0.233805875146805],
            [32.35999703582606, 0.231652819818822],
            [32.36030571222906, 0.230485797381091],
            [32.36120965635673, 0.230956272721879],
            [32.36317276001847, 0.233670397752887],
            [32.3642668164064, 0.23422230458798],
            [32.365265418710514, 0.234222350401682],
            [32.37116164582511, 0.232340886854954],
            [32.3746675556817, 0.229509393128027],
            [32.377507645029446, 0.226505977911],
            [32.380821346856244, 0.220046694502488],
            [32.38177068465187, 0.216174694426549],
            [32.38178196839014, 0.214989562647956],
            [32.37956919865643, 0.212221144861487],
            [32.377666377340134, 0.211433994286873],
            [32.376714716501176, 0.210285010106961],
            [32.37768894122346, 0.209018496443107],
            [32.37760502869446, 0.207661470820492],
            [32.37838887076359, 0.205969748447394],
            [32.378268009628634, 0.202179500032121],
            [32.381897257275405, 0.201653887345211],
            [32.38302639557008, 0.200949268456553],
            [32.385071508230745, 0.201236743746548],
            [32.39025763957116, 0.205898667014735],
            [32.39404270539384, 0.214240468177549],
            [32.396565355273005, 0.218375737895914],
            [32.39699358306726, 0.218782156129176],
            [32.40014438350214, 0.219010261867956],
            [32.4002421705107, 0.224267934325151],
            [32.400647377179176, 0.226179943210875],
            [32.40944070072946, 0.220886967907053],
            [32.4106676592704, 0.22124834128629],
            [32.41078425520437, 0.222809016728644],
            [32.409398485301, 0.227162764305689],
            [32.40886673295848, 0.233627099316209],
            [32.40822602215847, 0.236231799180355],
            [32.41171236221659, 0.24166988761299],
            [32.413568515155546, 0.247246469440373],
            [32.41579185356858, 0.249760078388185],
            [32.419993858057346, 0.258410563791338],
            [32.421189498632515, 0.265466951536825],
            [32.42552171571835, 0.276544318987887],
            [32.426865619637894, 0.282348738410751],
            [32.42693989144728, 0.285837562541791],
            [32.426603878411875, 0.28725740485513],
            [32.42479165488695, 0.290974739785453],
            [32.42227509019549, 0.29447853599056],
            [32.421415763591334, 0.296696110048002],
            [32.419779461640054, 0.305999421329308],
            [32.41720613689739, 0.313795717362867],
            [32.416727936722204, 0.317022553512939],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1672,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "KIRINGENTE",
        Population: 22725,
        Key: "MPIGIKIRINGENTE",
        Dist2: "Mpigi",
        "Sub Country": "Kiringente",
        id2_original: "MpigiKiringente",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.997734010612536, 0.657597735835258],
            [31.99122757319679, 0.658830152060193],
            [31.990339314552276, 0.658589215569997],
            [31.988733361284574, 0.659414331849977],
            [31.986786080548235, 0.658622878609493],
            [31.985057452447005, 0.657691649409819],
            [31.983234751870903, 0.655291197733188],
            [31.978093379987858, 0.650631175417051],
            [31.976867547035983, 0.64897516134043],
            [31.977422763373756, 0.646791395893507],
            [31.975570112067757, 0.64613971412984],
            [31.968508175344923, 0.646843846977097],
            [31.966607151557522, 0.646581126255928],
            [31.9648748277872, 0.645269119549579],
            [31.962756088307525, 0.64130660055868],
            [31.959911382517525, 0.637723863588617],
            [31.958033992506927, 0.63745697357554],
            [31.957414674187138, 0.637958544693512],
            [31.954513255956613, 0.63852783644501],
            [31.952934024873638, 0.637867248281742],
            [31.95145832822043, 0.638653849675715],
            [31.950318021171842, 0.638409377573776],
            [31.94706049908459, 0.638718233321658],
            [31.944470517779916, 0.638212701851394],
            [31.941033991999273, 0.638888233414283],
            [31.937801864386767, 0.638525037468409],
            [31.936496627550326, 0.63754715705082],
            [31.934742877163835, 0.635152519272133],
            [31.933867667447156, 0.633216462112613],
            [31.931685068530555, 0.631254523540987],
            [31.92956994476993, 0.631014669946302],
            [31.914962519884927, 0.625593230208022],
            [31.914254032993384, 0.623560818316624],
            [31.913352415502267, 0.62277063237189],
            [31.909553169772813, 0.622618596099486],
            [31.90940518400787, 0.624081433928175],
            [31.90955318953575, 0.62261606299994],
            [31.90717442012069, 0.621710996339998],
            [31.905462635431043, 0.621783002850025],
            [31.903230479155166, 0.620724190326682],
            [31.90218569805556, 0.614880467215301],
            [31.901594935382004, 0.61330639753675],
            [31.900173064882313, 0.611415558149816],
            [31.895999629514538, 0.606774271165084],
            [31.882873668466836, 0.594512089779809],
            [31.88034521097937, 0.591996672335275],
            [31.884531135624524, 0.590999829952595],
            [31.88692302673095, 0.589701700326403],
            [31.896732286477114, 0.582718124468174],
            [31.899864856501598, 0.579725241959038],
            [31.904896492884475, 0.572567193481339],
            [31.907022527582573, 0.571673927246421],
            [31.91327766758579, 0.57033895240307],
            [31.914256629124534, 0.56992158344657],
            [31.91483273488594, 0.56883886336293],
            [31.915718611198322, 0.564339704170767],
            [31.914082148448593, 0.559750973858501],
            [31.914246897675074, 0.55810665722698],
            [31.915477434205783, 0.555254181801551],
            [31.917398402389114, 0.553959463809528],
            [31.918383707830387, 0.552143083959395],
            [31.918824928856928, 0.548558038917235],
            [31.918013567797352, 0.543601271387303],
            [31.919576689392347, 0.542093099159876],
            [31.91803006356092, 0.540428406574986],
            [31.914373959880425, 0.533506736749357],
            [31.918033932604846, 0.530178834000921],
            [31.91908386733927, 0.528365088862946],
            [31.919017930997416, 0.525928677965891],
            [31.91797365025939, 0.519800490637112],
            [31.918360031832787, 0.517054234048213],
            [31.919182475407993, 0.515992551170794],
            [31.92184902910749, 0.51408566117472],
            [31.92382470199669, 0.512870417857412],
            [31.926822103418683, 0.511847771711857],
            [31.929657678732152, 0.508746844766531],
            [31.930149629419383, 0.506633698512452],
            [31.929425100413503, 0.497226509285503],
            [31.929754429084877, 0.496260965340251],
            [31.93201330395223, 0.494274848280811],
            [31.933297415108168, 0.492432164722655],
            [31.93492669762379, 0.487753399650453],
            [31.935616682813748, 0.484378860482018],
            [31.93533174439214, 0.482129056878856],
            [31.934464319475715, 0.48001078822443],
            [31.934393295076102, 0.478048215789384],
            [31.93546377517934, 0.47390786092321],
            [31.938876316840243, 0.467769405551095],
            [31.941254109786584, 0.465352460616155],
            [31.943346718172958, 0.462217462746591],
            [31.9444404296078, 0.461571409998103],
            [31.945831562453407, 0.459309887161106],
            [31.952132714165487, 0.452729026157364],
            [31.95300091522634, 0.449701528937043],
            [31.95328705559379, 0.443670256329991],
            [31.95453629504871, 0.435903911690866],
            [31.9556660980967, 0.432134501161457],
            [31.958305598133077, 0.428090046676878],
            [31.961272698482244, 0.430459074743272],
            [31.964101694534573, 0.431608284813531],
            [31.966782834179305, 0.431833689075634],
            [31.965145956407955, 0.444676338317408],
            [31.96507409927003, 0.448505747230548],
            [31.96327850086606, 0.452945225927278],
            [31.96255193987102, 0.462889643880281],
            [31.962670304587803, 0.466336139931999],
            [31.965605403353273, 0.473432979183365],
            [31.96987192574404, 0.48014708481787],
            [31.970703652509414, 0.482684202335115],
            [31.969312438815436, 0.485328687985648],
            [31.966601680817433, 0.488343939676749],
            [31.964199884886675, 0.491981519031586],
            [31.963892296343523, 0.4970828147923],
            [31.964789110542792, 0.499042115517305],
            [31.963025110378922, 0.50369188599766],
            [31.96118828289666, 0.506627149151762],
            [31.960668685658238, 0.510507824302176],
            [31.958460482061128, 0.514768191582755],
            [31.95760376955442, 0.515196870082956],
            [31.9563391186025, 0.517368614520204],
            [31.95296013979726, 0.518940080981225],
            [31.951319619357413, 0.519080971461333],
            [31.948064960200973, 0.518168510957306],
            [31.942347820323093, 0.518243660940194],
            [31.938705848040346, 0.520507411378921],
            [31.93772712814842, 0.522369037012565],
            [31.937389653554032, 0.524494364977357],
            [31.93761132632512, 0.526119604137915],
            [31.939737869469678, 0.528796522350608],
            [31.938832966839577, 0.534203002379496],
            [31.940109129701867, 0.534417349950276],
            [31.94159785731657, 0.535434699771529],
            [31.94494673986486, 0.542073145775528],
            [31.94788344391974, 0.54659225552642],
            [31.94785577041909, 0.548359752988039],
            [31.946855160380295, 0.549361470500376],
            [31.94734833187804, 0.552085167770523],
            [31.947152101192415, 0.55347461269268],
            [31.95016236469265, 0.553050189288795],
            [31.95278152327775, 0.55143640042012],
            [31.958062983836086, 0.54953338666585],
            [31.960253806829115, 0.545349227764428],
            [31.96034097754766, 0.53815972289189],
            [31.96084191498101, 0.537372236908928],
            [31.96215028064962, 0.536944225554541],
            [31.963481636901275, 0.5368745391112],
            [31.967945861418084, 0.539054767387433],
            [31.971108039914334, 0.538796705398956],
            [31.97742823591044, 0.54016755729633],
            [31.982152078934295, 0.543208072217734],
            [31.9854072016214, 0.546808100083316],
            [31.98687539015547, 0.54550236920819],
            [31.990633786793975, 0.543989687217995],
            [31.992376583123896, 0.541685607436578],
            [31.992904269691454, 0.538730981270338],
            [31.994073307557805, 0.539940935892247],
            [31.99368628638394, 0.543745423839227],
            [31.993025111063464, 0.545331445520582],
            [31.999105455082095, 0.551488948531866],
            [32.00842244434074, 0.558409408344029],
            [32.009919489456664, 0.560684260858442],
            [32.0122001673343, 0.562337863102768],
            [32.01291309369996, 0.563582927273257],
            [32.01315115713172, 0.565425666059736],
            [32.01388552987648, 0.566038953736375],
            [32.0143385996816, 0.564876651450081],
            [32.01730721638697, 0.563587865971767],
            [32.01956358854794, 0.563351114749741],
            [32.02166534358052, 0.56236044835608],
            [32.02228265596229, 0.561547583089558],
            [32.02261435169445, 0.558748349949136],
            [32.023587876629094, 0.55769659394366],
            [32.02821957945422, 0.557893201587544],
            [32.03875403834946, 0.559209072135141],
            [32.04546442926732, 0.560544587602864],
            [32.05494100782947, 0.558712666969514],
            [32.06038058804751, 0.559723722069911],
            [32.06457281617102, 0.559524990971236],
            [32.068635520705314, 0.562999150264959],
            [32.071260466237455, 0.56399511545515],
            [32.07479966226856, 0.564286189633384],
            [32.079194165841244, 0.565296073321186],
            [32.07955231426356, 0.57137435220703],
            [32.07849725194551, 0.577726220527382],
            [32.07868804962028, 0.580286798578058],
            [32.080355091920566, 0.586491451413905],
            [32.073071481528345, 0.594097151526647],
            [32.06671598713146, 0.598279340931379],
            [32.059579281830906, 0.604640896074014],
            [32.0574947825366, 0.606054014465765],
            [32.05545536429653, 0.606645286610275],
            [32.0538463765198, 0.606711967510565],
            [32.04932505418518, 0.605896402186543],
            [32.044995818607774, 0.60317474731228],
            [32.042706685786726, 0.602236137926378],
            [32.040711958732025, 0.600590135020563],
            [32.03698381914889, 0.599706969765841],
            [32.03410580831973, 0.59990919101444],
            [32.02755703150802, 0.601682509823384],
            [32.017280150147464, 0.602641139848208],
            [32.01491219375347, 0.603334762530687],
            [32.01364420286531, 0.604164872053918],
            [32.0078974626005, 0.608514930424755],
            [32.006401519717414, 0.610396214198448],
            [32.005119855572325, 0.613679662071516],
            [32.00470523994956, 0.617442707699389],
            [32.005584635815474, 0.620312027022816],
            [32.00551420520228, 0.622666252504427],
            [32.00711924039175, 0.628587807622534],
            [32.0071202474032, 0.632151921897043],
            [32.005991076769156, 0.638953540467984],
            [32.00488024164838, 0.641274902794512],
            [32.00450405864843, 0.64313209340118],
            [32.002761124876294, 0.645608099770316],
            [32.00083166222361, 0.654204750051196],
            [31.999329506592034, 0.656067913809101],
            [31.997918518283708, 0.657008407028023],
            [31.997734010612536, 0.657597735835258],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1675,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "KALANGAALO",
        Population: 30632,
        Key: "MITYANAKALANGAALO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.079194165841244, 0.565296073321186],
            [32.07479966226856, 0.564286189633384],
            [32.071260466237455, 0.56399511545515],
            [32.068635520705314, 0.562999150264959],
            [32.06457281617102, 0.559524990971236],
            [32.06038058804751, 0.559723722069911],
            [32.05494100782947, 0.558712666969514],
            [32.04546442926732, 0.560544587602864],
            [32.03875403834946, 0.559209072135141],
            [32.02821957945422, 0.557893201587544],
            [32.023587876629094, 0.55769659394366],
            [32.02261435169445, 0.558748349949136],
            [32.02228265596229, 0.561547583089558],
            [32.02166534358052, 0.56236044835608],
            [32.01956358854794, 0.563351114749741],
            [32.01730721638697, 0.563587865971767],
            [32.0143385996816, 0.564876651450081],
            [32.01388552987648, 0.566038953736375],
            [32.01315115713172, 0.565425666059736],
            [32.01291309369996, 0.563582927273257],
            [32.0122001673343, 0.562337863102768],
            [32.009919489456664, 0.560684260858442],
            [32.00842244434074, 0.558409408344029],
            [31.999105455082095, 0.551488948531866],
            [31.993025111063464, 0.545331445520582],
            [31.99368628638394, 0.543745423839227],
            [31.994073307557805, 0.539940935892247],
            [31.992904269691454, 0.538730981270338],
            [31.992376583123896, 0.541685607436578],
            [31.990633786793975, 0.543989687217995],
            [31.98687539015547, 0.54550236920819],
            [31.9854072016214, 0.546808100083316],
            [31.982152078934295, 0.543208072217734],
            [31.97742823591044, 0.54016755729633],
            [31.971108039914334, 0.538796705398956],
            [31.967945861418084, 0.539054767387433],
            [31.963481636901275, 0.5368745391112],
            [31.96215028064962, 0.536944225554541],
            [31.96084191498101, 0.537372236908928],
            [31.96034097754766, 0.53815972289189],
            [31.960253806829115, 0.545349227764428],
            [31.958062983836086, 0.54953338666585],
            [31.95278152327775, 0.55143640042012],
            [31.95016236469265, 0.553050189288795],
            [31.947152101192415, 0.55347461269268],
            [31.94734833187804, 0.552085167770523],
            [31.946855160380295, 0.549361470500376],
            [31.94785577041909, 0.548359752988039],
            [31.94788344391974, 0.54659225552642],
            [31.94494673986486, 0.542073145775528],
            [31.94159785731657, 0.535434699771529],
            [31.940109129701867, 0.534417349950276],
            [31.938832966839577, 0.534203002379496],
            [31.939737869469678, 0.528796522350608],
            [31.93761132632512, 0.526119604137915],
            [31.937389653554032, 0.524494364977357],
            [31.93772712814842, 0.522369037012565],
            [31.938705848040346, 0.520507411378921],
            [31.942347820323093, 0.518243660940194],
            [31.948064960200973, 0.518168510957306],
            [31.951319619357413, 0.519080971461333],
            [31.95296013979726, 0.518940080981225],
            [31.9563391186025, 0.517368614520204],
            [31.95760376955442, 0.515196870082956],
            [31.958460482061128, 0.514768191582755],
            [31.960668685658238, 0.510507824302176],
            [31.96118828289666, 0.506627149151762],
            [31.963025110378922, 0.50369188599766],
            [31.964789110542792, 0.499042115517305],
            [31.963892296343523, 0.4970828147923],
            [31.964199884886675, 0.491981519031586],
            [31.966601680817433, 0.488343939676749],
            [31.969312438815436, 0.485328687985648],
            [31.970703652509414, 0.482684202335115],
            [31.96987192574404, 0.48014708481787],
            [31.965605403353273, 0.473432979183365],
            [31.962670304587803, 0.466336139931999],
            [31.96255193987102, 0.462889643880281],
            [31.96327850086606, 0.452945225927278],
            [31.96507409927003, 0.448505747230548],
            [31.965145956407955, 0.444676338317408],
            [31.966782834179305, 0.431833689075634],
            [31.96926083599223, 0.430795240878791],
            [31.977000133880352, 0.425375258676123],
            [31.979211270476874, 0.424513929162912],
            [31.984251590873594, 0.423461498080342],
            [31.988899474153648, 0.423665559194029],
            [31.99208512742488, 0.424695150311947],
            [31.99736266234543, 0.427926946816575],
            [32.00435682656998, 0.433089560950216],
            [32.00830295044163, 0.436656281929798],
            [32.014376434026424, 0.443897207082052],
            [32.01828661001535, 0.449653925981321],
            [32.02090118898915, 0.454489011389399],
            [32.02197098996605, 0.455039647838829],
            [32.024705060143994, 0.455303298648139],
            [32.02567989661897, 0.454824741664786],
            [32.02710638625584, 0.454801009821011],
            [32.02777215286574, 0.454274538173291],
            [32.040099709255195, 0.452397356941568],
            [32.04729165914909, 0.452218806172903],
            [32.049241285386614, 0.45166857104339],
            [32.054816500432764, 0.451896692016257],
            [32.05999962960349, 0.450700638488618],
            [32.07384875242118, 0.449900625401257],
            [32.074823526014086, 0.449972559372834],
            [32.076368735202294, 0.451337034725675],
            [32.078698222142556, 0.45514294814295],
            [32.07938765756355, 0.455502063490731],
            [32.081272926697515, 0.459188922114218],
            [32.080663147587714, 0.459680594686036],
            [32.078639946633444, 0.457675636287692],
            [32.076455927480396, 0.457449014737852],
            [32.071571272545974, 0.459549525720119],
            [32.06720610615387, 0.459605407217902],
            [32.0682388103028, 0.463623389871283],
            [32.0724575791514, 0.473628241104452],
            [32.073472797593325, 0.47446962201135],
            [32.07606485220967, 0.475410316237272],
            [32.07769800197259, 0.478699624378748],
            [32.079944021049954, 0.47996759874113],
            [32.07708509672562, 0.480995048447978],
            [32.0713334202183, 0.481542439114698],
            [32.07109509178356, 0.482261891445506],
            [32.071707382582886, 0.484488957661157],
            [32.07230417744359, 0.485561418749183],
            [32.07489041007858, 0.48765171584078],
            [32.07999539570102, 0.487618162285216],
            [32.0810799344385, 0.487963508876977],
            [32.08204034307169, 0.489098316509987],
            [32.08322903338151, 0.489720780478851],
            [32.087413266499, 0.491420728637223],
            [32.091978005309606, 0.492498422908792],
            [32.0951399511422, 0.493911015373413],
            [32.10196383700968, 0.499768455782491],
            [32.10393619242053, 0.502570277508216],
            [32.104483612279964, 0.505968760060131],
            [32.10423520474769, 0.509019413415412],
            [32.10179018637705, 0.513563208540254],
            [32.10070067097292, 0.516760432228543],
            [32.09610536788308, 0.522173087555787],
            [32.09535634900593, 0.524125883391776],
            [32.09441952653883, 0.53030994289187],
            [32.09356781585166, 0.532322340415978],
            [32.0928118907266, 0.533531833692015],
            [32.08830958752319, 0.536493221001912],
            [32.08745853979268, 0.537897809957578],
            [32.08808561416667, 0.554703128057328],
            [32.08162748185868, 0.561003589456378],
            [32.07976362945941, 0.563334564090645],
            [32.079194165841244, 0.565296073321186],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1676,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "BULERA",
        Population: 30025,
        Key: "MITYANABULERA",
        Dist2: "Mityana",
        "Sub Country": "Bulera",
        id2_original: "Mityana Bulera",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.588528046929884, -0.147200798862418],
            [30.5882663551112, -0.14707947819011],
            [30.58912788797767, -0.144503373416765],
            [30.589343189896777, -0.142207417891239],
            [30.591470259454063, -0.134406719530622],
            [30.591620352666695, -0.133150270927166],
            [30.590714064834405, -0.130909848912737],
            [30.58802320631661, -0.130320630177555],
            [30.58658490113878, -0.130620669399485],
            [30.584354279185447, -0.130193110160958],
            [30.5811129321632, -0.128720032263675],
            [30.58070365522818, -0.127653365483437],
            [30.577308804090187, -0.123540211564491],
            [30.577047471597613, -0.121578679950611],
            [30.573430125730056, -0.11893891982778],
            [30.5711616703302, -0.113099422517944],
            [30.56945103907735, -0.11205977909374],
            [30.567928877066077, -0.113777092273786],
            [30.566050339906884, -0.114219853932925],
            [30.56068344597176, -0.118332194493922],
            [30.553998427070763, -0.120482909326978],
            [30.553947877073096, -0.121007169454214],
            [30.554941236809213, -0.122169764680475],
            [30.556057513923975, -0.124920188582053],
            [30.556413604305984, -0.12762271324537],
            [30.556152178388643, -0.128818481980304],
            [30.554702885916587, -0.130827274190577],
            [30.55201793382177, -0.136495055981903],
            [30.551827570931586, -0.139651919861223],
            [30.553299231454197, -0.15098816232844],
            [30.55040057733981, -0.155029601006154],
            [30.549616333723748, -0.157708074357372],
            [30.546171430254745, -0.160529722089066],
            [30.535378749732782, -0.167309667859651],
            [30.534102850076877, -0.166818049842296],
            [30.53065804452426, -0.166546270194709],
            [30.531886814967073, -0.16927291756264],
            [30.531121173663905, -0.172228538690165],
            [30.531701856341662, -0.176359389172539],
            [30.52982955079557, -0.179748723559499],
            [30.529822375053087, -0.180968971927668],
            [30.533237204722997, -0.187613030109802],
            [30.533296695652677, -0.191581118521669],
            [30.537464112308065, -0.19546845602552],
            [30.538808547131964, -0.199724220036069],
            [30.542389343245546, -0.198124605938783],
            [30.544194815931117, -0.197837884276446],
            [30.5462615276845, -0.198077344057553],
            [30.548351899265796, -0.198986448938853],
            [30.55013339052655, -0.200302077584516],
            [30.55240600153292, -0.203530074461],
            [30.55415715309327, -0.203072983080892],
            [30.5593245779162, -0.199187448465189],
            [30.560111221830706, -0.199279815379244],
            [30.561037991251453, -0.197342736734535],
            [30.56153725242849, -0.194544606090463],
            [30.567417569481094, -0.189415432479233],
            [30.568700598167105, -0.18805248897516],
            [30.56998375082064, -0.185828372781483],
            [30.574581039187237, -0.181846971902384],
            [30.5762203262402, -0.181631990865043],
            [30.57814468197048, -0.180627704548609],
            [30.581066933929062, -0.178834425434733],
            [30.581851076035512, -0.177830014099249],
            [30.583775992314553, -0.172592536191932],
            [30.585629408086845, -0.169507557387764],
            [30.585772036299435, -0.168072620830707],
            [30.586627430977597, -0.166852977090771],
            [30.586556366153783, -0.165130940867375],
            [30.58741188569778, -0.162691656543676],
            [30.588979983061098, -0.161041551376524],
            [30.588837541698073, -0.1607545138256],
            [30.586628118188774, -0.160969495097145],
            [30.58563047169214, -0.160538908225094],
            [30.580499045955893, -0.160251308323926],
            [30.57743460236595, -0.15953349701986],
            [30.57600938384518, -0.158170117475043],
            [30.5761520120578, -0.15781139908798],
            [30.581212249002697, -0.156161731007672],
            [30.584063248389562, -0.154440068479461],
            [30.587056938871147, -0.150637654393534],
            [30.588528046929884, -0.147200798862418],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 393,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "KIKYENKYE",
        Population: 11814,
        Key: "IBANDAKIKYENKYE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.538808547131964, -0.199724220036069],
            [30.537464112308065, -0.19546845602552],
            [30.533296695652677, -0.191581118521669],
            [30.533237204722997, -0.187613030109802],
            [30.529822375053087, -0.180968971927668],
            [30.52982955079557, -0.179748723559499],
            [30.531701856341662, -0.176359389172539],
            [30.531121173663905, -0.172228538690165],
            [30.531886814967073, -0.16927291756264],
            [30.53065804452426, -0.166546270194709],
            [30.534102850076877, -0.166818049842296],
            [30.535378749732782, -0.167309667859651],
            [30.546171430254745, -0.160529722089066],
            [30.549616333723748, -0.157708074357372],
            [30.55040057733981, -0.155029601006154],
            [30.553299231454197, -0.15098816232844],
            [30.551827570931586, -0.139651919861223],
            [30.55201793382177, -0.136495055981903],
            [30.554702885916587, -0.130827274190577],
            [30.556152178388643, -0.128818481980304],
            [30.556413604305984, -0.12762271324537],
            [30.556057513923975, -0.124920188582053],
            [30.554941236809213, -0.122169764680475],
            [30.553947877073096, -0.121007169454214],
            [30.553998427070763, -0.120482909326978],
            [30.56068344597176, -0.118332194493922],
            [30.566050339906884, -0.114219853932925],
            [30.567928877066077, -0.113777092273786],
            [30.56945103907735, -0.11205977909374],
            [30.570104600277496, -0.107440822854413],
            [30.57104059898946, -0.105958473153725],
            [30.5707320528422, -0.104702005282258],
            [30.57111582750462, -0.103671570184732],
            [30.5699644298555, -0.102098669370588],
            [30.570921113175196, -0.101601586495193],
            [30.57269459056531, -0.102849123453625],
            [30.572981654400873, -0.102487578183362],
            [30.575476912850412, -0.102144274070163],
            [30.57590651506706, -0.101773698042651],
            [30.575826130222154, -0.097787406658842],
            [30.57549860626622, -0.096955777214167],
            [30.57495330104099, -0.096802072993822],
            [30.57451077925392, -0.095355772148558],
            [30.57552898189924, -0.093819178999543],
            [30.574428706474606, -0.09117062290494],
            [30.574982522338836, -0.089869015089998],
            [30.574279479237937, -0.088296151370288],
            [30.5745100318556, -0.087446482654669],
            [30.57507833754538, -0.087717693603568],
            [30.575299800110677, -0.086407025269442],
            [30.574308985301737, -0.085304182799582],
            [30.576414083863817, -0.082673904100885],
            [30.57649002833627, -0.081887498152518],
            [30.576388791797008, -0.080929337173015],
            [30.57506406151888, -0.080088615508392],
            [30.574665965015868, -0.079157555734563],
            [30.57560506201728, -0.076952045536767],
            [30.57528191375504, -0.075379208255135],
            [30.575703829986118, -0.074294527610815],
            [30.577822713196227, -0.073327444399246],
            [30.57892220618822, -0.070109540537376],
            [30.577756837041512, -0.0663943671787],
            [30.57806345091258, -0.064740205107814],
            [30.577312393758053, -0.0632577405738],
            [30.57646197574658, -0.062498409494433],
            [30.57597212082888, -0.064640678125967],
            [30.574732319972664, -0.065517422497912],
            [30.57285619478998, -0.065553490731311],
            [30.569445209909485, -0.064152262617844],
            [30.564656810356087, -0.066836662291355],
            [30.563480790783355, -0.068951758515762],
            [30.562205366336215, -0.069810409855588],
            [30.556715623294398, -0.07061461163682],
            [30.552991277296734, -0.072033551630928],
            [30.548858903022246, -0.072177960190073],
            [30.544429724479603, -0.074347085298946],
            [30.540091256017732, -0.075214590324852],
            [30.53877809065057, -0.076443815137005],
            [30.538246026592617, -0.078079834428081],
            [30.537219626820356, -0.079001747588533],
            [30.535410713587233, -0.079733795689288],
            [30.52904846655436, -0.085563501879312],
            [30.52663580460192, -0.090037587338572],
            [30.52404056096631, -0.091230543153423],
            [30.518536623644717, -0.092450411521275],
            [30.517562903775644, -0.092359956679683],
            [30.51550925711978, -0.094456815802281],
            [30.51274224841533, -0.098623493516777],
            [30.511366187503558, -0.102446787548158],
            [30.511383060559538, -0.105619392949603],
            [30.51419843545721, -0.115711367814036],
            [30.515457274309238, -0.117792091660817],
            [30.51678747622576, -0.118748815163047],
            [30.51808555708266, -0.118909418319085],
            [30.518614499494994, -0.119367986618998],
            [30.515786624540176, -0.119356852923532],
            [30.51405254815675, -0.118854481966144],
            [30.510893268523905, -0.117275809393756],
            [30.508731742287246, -0.11521893034154],
            [30.507448902247464, -0.116079758971877],
            [30.506831109267015, -0.117992902430982],
            [30.50512060288, -0.119738541765347],
            [30.504336312551523, -0.123947496882955],
            [30.50371860670766, -0.124808376442446],
            [30.5022457936465, -0.124951727458367],
            [30.502031497840548, -0.130260809720844],
            [30.501034201686846, -0.131137599987843],
            [30.500700864732686, -0.131966756284271],
            [30.49548249285674, -0.133807652674929],
            [30.493289283938314, -0.134947237038801],
            [30.49276658481721, -0.135903773057769],
            [30.491555164435766, -0.135234036870808],
            [30.48721056317544, -0.141818069480134],
            [30.481743078589734, -0.148888214710287],
            [30.48008874026417, -0.150294120050533],
            [30.481909107017184, -0.151136196087911],
            [30.486731364971952, -0.150371481798209],
            [30.489962313096463, -0.147478176145442],
            [30.491363916705037, -0.146760892620302],
            [30.499036535344537, -0.148220546814512],
            [30.502718618303057, -0.147455680608604],
            [30.50435767628559, -0.147718926537715],
            [30.506709287832997, -0.148867106169017],
            [30.50810042876345, -0.150461861885796],
            [30.507101257825774, -0.152846408996491],
            [30.505621952640055, -0.154057427080918],
            [30.501184166440357, -0.155430792529543],
            [30.50073560348301, -0.154852264336036],
            [30.498295662390372, -0.154635051594212],
            [30.495949515294843, -0.154951130758271],
            [30.49410890141365, -0.155710160366564],
            [30.49190293013003, -0.158204560548382],
            [30.48992318068607, -0.162289774359589],
            [30.488155250392833, -0.164008662246064],
            [30.48710393225288, -0.16618042744754],
            [30.48724589301722, -0.17067639067761],
            [30.48586802559342, -0.17146539274614],
            [30.486176695708206, -0.172541589369992],
            [30.482874141974055, -0.177634949467068],
            [30.478526662511566, -0.180647580573806],
            [30.470853799530325, -0.182057466773308],
            [30.46790813478047, -0.183013625116096],
            [30.466102653111726, -0.184161254729442],
            [30.46370947651615, -0.186449156570812],
            [30.464185475818883, -0.18893188008229],
            [30.464110128726137, -0.190992630068854],
            [30.46171943237902, -0.201594334800499],
            [30.459977235225434, -0.206465761696896],
            [30.456526188178216, -0.212373830462211],
            [30.458166791263064, -0.21476520998349],
            [30.4599481334035, -0.216104694604434],
            [30.462062108218902, -0.217013783178325],
            [30.46334459522079, -0.218472760631466],
            [30.465338810235746, -0.225264726040495],
            [30.467072052982598, -0.230023956561647],
            [30.468259419175695, -0.232032963073666],
            [30.47189311977131, -0.236099043682155],
            [30.474957067491257, -0.238204062228725],
            [30.480895628611936, -0.238611691717892],
            [30.482487031867013, -0.239472903577092],
            [30.48395936971934, -0.241960284306836],
            [30.484503267284552, -0.243691677144405],
            [30.485692105816398, -0.243732574374383],
            [30.4860255927892, -0.244328208599099],
            [30.487355724637144, -0.245045894881033],
            [30.488994149307427, -0.248561650892734],
            [30.490110394981162, -0.249781510190592],
            [30.489919679053084, -0.253368670424238],
            [30.490738833896042, -0.254124678865083],
            [30.49448899567836, -0.255341288467974],
            [30.49512911359028, -0.256032012381825],
            [30.49661493246008, -0.255958165314366],
            [30.503438148184383, -0.260930775810988],
            [30.506317052837254, -0.261148274548542],
            [30.508982365963323, -0.258513167420818],
            [30.512803048190378, -0.257543089277597],
            [30.51412160704252, -0.256793127537325],
            [30.517115144810496, -0.254823249550607],
            [30.51993078291452, -0.252202533787814],
            [30.52112260744638, -0.251759858178306],
            [30.52272951741986, -0.252212103447813],
            [30.53053433572984, -0.250484333693253],
            [30.53152047750265, -0.24535742327717],
            [30.53261341458969, -0.244353176147056],
            [30.536271953602952, -0.243349394265007],
            [30.53748369558126, -0.242201670248913],
            [30.538220396759236, -0.240647294077522],
            [30.53819708457929, -0.238136159163062],
            [30.53648767144201, -0.232420051136584],
            [30.536773076987537, -0.230435113944425],
            [30.538222580563716, -0.227995979294892],
            [30.53824652156432, -0.226895868845163],
            [30.53926824830052, -0.225485025379824],
            [30.539411082227307, -0.223667466349301],
            [30.53879400250919, -0.220199610889833],
            [30.540504884391993, -0.217234361115892],
            [30.54185950251792, -0.213790735157881],
            [30.543807863927565, -0.211255987137815],
            [30.543570832660038, -0.207836015926057],
            [30.540008186108473, -0.203195845788436],
            [30.538808547131964, -0.199724220036069],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 394,
        District: "IBANDA",
        County: "IBANDA MUNICIPALITY",
        Subcounty: "BUFUNDA DIVISION",
        Population: 38047,
        Key: "IBANDABUFUNDA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.613471393150853, 0.150263727454077],
            [30.61236274542781, 0.150522413516975],
            [30.613615895249154, 0.151355563017677],
            [30.61343903942759, 0.15195402754669],
            [30.61090838735585, 0.153150713112336],
            [30.610891965254147, 0.156539384940286],
            [30.60875502680514, 0.157016296942603],
            [30.607759019733876, 0.155689812702174],
            [30.606529871998607, 0.155536011811341],
            [30.605932983713114, 0.154028496941754],
            [30.603822855483752, 0.153869678067783],
            [30.603485284769672, 0.155390107081669],
            [30.602834497567134, 0.155818664773806],
            [30.603576028986403, 0.157158868923785],
            [30.603773026833252, 0.158721265032083],
            [30.604529506218856, 0.159869349748802],
            [30.604599055584803, 0.162454241752943],
            [30.60402869544796, 0.164152260948682],
            [30.604933397753744, 0.165236200523359],
            [30.603382399821875, 0.164126750695923],
            [30.603400225990345, 0.16361151958041],
            [30.599201443758528, 0.161522909917823],
            [30.595352935317212, 0.160166529252084],
            [30.59260275654962, 0.159650982728525],
            [30.589777414843883, 0.160518415038944],
            [30.588945981827592, 0.159858436158913],
            [30.58798429309514, 0.159840224684031],
            [30.585780473276603, 0.15820385806853],
            [30.583416079600998, 0.158529004738515],
            [30.582213811255684, 0.159432790876752],
            [30.578753472035153, 0.159088870402222],
            [30.578132020216557, 0.15879955111193],
            [30.577896212454476, 0.156259504178137],
            [30.577405999108972, 0.155671881497004],
            [30.575577857437217, 0.155210689923995],
            [30.57329522482553, 0.155725640078378],
            [30.572564922347315, 0.155409196211244],
            [30.571615024002934, 0.153827219348938],
            [30.570973219953263, 0.153745774785404],
            [30.569431135105628, 0.152416834355237],
            [30.56487007938769, 0.153058109713601],
            [30.563747887765075, 0.151575543492396],
            [30.564061876804644, 0.150029885110451],
            [30.56324735726857, 0.150409457047722],
            [30.562826623220406, 0.150147262176038],
            [30.562174993398155, 0.148664766723178],
            [30.560854469930497, 0.148131323743907],
            [30.560539357996785, 0.147516646370034],
            [30.55921574612121, 0.148140166730012],
            [30.55798814258989, 0.147254206224698],
            [30.55424616805309, 0.146539696680862],
            [30.55398951668145, 0.145843679772815],
            [30.553508356557398, 0.146901197328878],
            [30.552969086214265, 0.146521484296367],
            [30.551120592311406, 0.146964184294545],
            [30.549940781848157, 0.146710972505376],
            [30.54781002021506, 0.145445264756783],
            [30.54693844328538, 0.144161624824288],
            [30.546171927921403, 0.143944591639305],
            [30.545541914259843, 0.142525398062328],
            [30.54666817704731, 0.141947039311719],
            [30.546047426812947, 0.139045454633531],
            [30.544274306952303, 0.137861155153341],
            [30.544855474720332, 0.137336976221921],
            [30.544034077682415, 0.135709872248406],
            [30.542007323891195, 0.134055502574556],
            [30.542321313829092, 0.132790074417705],
            [30.540958892038244, 0.131886041971631],
            [30.5394562495198, 0.131967241373216],
            [30.53836879664754, 0.13169595716374],
            [30.537753239573835, 0.131072227060814],
            [30.53713220906511, 0.131234870210153],
            [30.535712029194755, 0.129842731271336],
            [30.53547937901091, 0.129047267930833],
            [30.53453762209795, 0.12909235875213],
            [30.534459159647803, 0.128043859470328],
            [30.53309519455131, 0.127799665645402],
            [30.531422362609, 0.126515989740436],
            [30.530981767708237, 0.124617776848576],
            [30.52871787215675, 0.122782656849077],
            [30.52839728588973, 0.123108014217829],
            [30.527380505277513, 0.122999444981321],
            [30.527014722971927, 0.12345137377913],
            [30.5259529565269, 0.122827572510112],
            [30.52491098086593, 0.1228275024417],
            [30.52417990673487, 0.120558664985607],
            [30.52325829094894, 0.119952970052886],
            [30.522218350870354, 0.120133650504358],
            [30.521675431570518, 0.119627436576769],
            [30.520513446377475, 0.11982618839945],
            [30.518000479438754, 0.121344478004195],
            [30.516228833713487, 0.121534106544846],
            [30.51549839109809, 0.121118250382703],
            [30.515383925967974, 0.122374625912825],
            [30.514990702825383, 0.122564429617318],
            [30.5146968549128, 0.121796091521955],
            [30.513886055300304, 0.122663735449622],
            [30.511671286815083, 0.121868096719081],
            [30.511607422886566, 0.1212715601194],
            [30.510944423986082, 0.121289561419041],
            [30.510225070174553, 0.120584456458632],
            [30.510345289912376, 0.11951791960572],
            [30.509519541435225, 0.11989745698489],
            [30.509436587408654, 0.118469348978644],
            [30.507252208031172, 0.11879453212627],
            [30.5049337119784, 0.115820588356591],
            [30.504485607161836, 0.114645482052176],
            [30.502170971169857, 0.113569680666025],
            [30.501262760942875, 0.112159574544218],
            [30.50066025818689, 0.112014896653002],
            [30.49890938510427, 0.108345040263394],
            [30.497563316244886, 0.102424591111285],
            [30.494846122716183, 0.097733321869257],
            [30.492232656755053, 0.097344449831102],
            [30.489647684456394, 0.098275222585135],
            [30.490789877967117, 0.096937612406796],
            [30.49133665732775, 0.095563788441958],
            [30.49465635361241, 0.092843405977992],
            [30.49496886941494, 0.091433403148096],
            [30.49821045359242, 0.088839520975211],
            [30.502610865384714, 0.087456924659367],
            [30.50336566042916, 0.086715815406041],
            [30.51109819040988, 0.086164966405783],
            [30.516123702977477, 0.087051104013826],
            [30.51702770280073, 0.084809563762672],
            [30.52145176543784, 0.080516393724848],
            [30.525010216857055, 0.079802549081241],
            [30.527459599243354, 0.077723758748259],
            [30.531811936794917, 0.075898179813922],
            [30.532889634861462, 0.075862072062722],
            [30.534165874080575, 0.077480652397476],
            [30.53597134766447, 0.07697854311881],
            [30.535662551785556, 0.075567487788836],
            [30.53434013287266, 0.074064881585724],
            [30.533738612873563, 0.072267059520732],
            [30.53454646511361, 0.069158083420351],
            [30.53429233980458, 0.06686271431518],
            [30.539406350800697, 0.065531804516204],
            [30.5417788850094, 0.065672237154201],
            [30.542443709286555, 0.06522378138895],
            [30.544743466482473, 0.064943689559028],
            [30.553724373535456, 0.06475434188641],
            [30.552870482637093, 0.060388427107217],
            [30.55066167986366, 0.05645633427024],
            [30.54891677249287, 0.052328577400618],
            [30.550140235689003, 0.05275703139018],
            [30.548045686941634, 0.038072704590166],
            [30.548029686149796, 0.029357293441739],
            [30.55068764656526, 0.025653637869106],
            [30.551655861558295, 0.025003833486987],
            [30.553372065060838, 0.024840557513028],
            [30.555016894719092, 0.027377420273036],
            [30.559606513269806, 0.026038123958106],
            [30.563442249464387, 0.023235450599638],
            [30.565407945664056, 0.022537045556243],
            [30.56724556186714, 0.020416355084879],
            [30.568100786763686, 0.020751187712393],
            [30.572115483532563, 0.024625698483411],
            [30.573374528997128, 0.024673526581314],
            [30.5734458327728, 0.025414952826858],
            [30.571283910379126, 0.028428343927925],
            [30.570636843100164, 0.030093034221667],
            [30.570760080279072, 0.033538247976091],
            [30.572945653517532, 0.034423194376496],
            [30.574533565919428, 0.034388911078183],
            [30.574813096483002, 0.034989343107411],
            [30.5756207385173, 0.035061664660786],
            [30.57784680511385, 0.033723946781322],
            [30.581458313728668, 0.033733070069763],
            [30.582885512136315, 0.033281140304009],
            [30.584767482656545, 0.031762602341262],
            [30.58550824152468, 0.030497135905851],
            [30.586459964347398, 0.030072295717901],
            [30.59068815203173, 0.030488222822879],
            [30.591977234464448, 0.028662292148347],
            [30.59142484063332, 0.026789234931737],
            [30.59171286297129, 0.028096423657341],
            [30.5926146879732, 0.028979123417383],
            [30.5933995909527, 0.030942047147615],
            [30.594998592158436, 0.031194277872651],
            [30.595958946892733, 0.030530191208692],
            [30.59688161550419, 0.03068153575289],
            [30.596810592002882, 0.031576833463812],
            [30.597319964616748, 0.031753373051434],
            [30.597127879656192, 0.032488938643317],
            [30.597921204341482, 0.032140104907681],
            [30.599425320995326, 0.0325855434534],
            [30.59990016506459, 0.03349361339218],
            [30.60105667592432, 0.033926559063387],
            [30.60010053159379, 0.034729358135867],
            [30.599831528386996, 0.035478153191991],
            [30.600760161811955, 0.035977770004741],
            [30.60130708130977, 0.037045396841875],
            [30.601060746190875, 0.037717940199108],
            [30.602217257050565, 0.037541434758582],
            [30.602647255424266, 0.038524984675093],
            [30.603177471647683, 0.038445154108776],
            [30.604025046491284, 0.039269006951191],
            [30.605081338602965, 0.039025268918692],
            [30.603311025977586, 0.042127228071602],
            [30.603870437447743, 0.042345806985462],
            [30.60377021959799, 0.042993120223286],
            [30.60436724802066, 0.043047790777763],
            [30.605264861720546, 0.044107030853802],
            [30.605398345981882, 0.045886291048939],
            [30.604062382271113, 0.046805519710448],
            [30.604496521878264, 0.047562103942394],
            [30.605156222165043, 0.04692324838064],
            [30.605999585706584, 0.047036765749993],
            [30.607935103902598, 0.049624193121874],
            [30.608270849240036, 0.047906938314191],
            [30.609819811589478, 0.04857530530992],
            [30.61077595592002, 0.048566918641465],
            [30.61210784846594, 0.047457324483669],
            [30.61282600931475, 0.047360650520827],
            [30.613535748457817, 0.047936553962141],
            [30.613422968567154, 0.04908825752392],
            [30.613961466359147, 0.051143679362684],
            [30.61392041065573, 0.055927451401067],
            [30.615284726993487, 0.058314582944965],
            [30.61592351270381, 0.058520598871892],
            [30.615990324903063, 0.057864864086988],
            [30.61650812012105, 0.057495010803938],
            [30.616750243937894, 0.058318863415084],
            [30.6177289162191, 0.059016882771015],
            [30.618294153263864, 0.058746300468845],
            [30.618304609653773, 0.059179175917164],
            [30.618816860469813, 0.059411825078131],
            [30.6193638500362, 0.058886416019758],
            [30.619530810016602, 0.060223080592656],
            [30.62069988381557, 0.060298805834297],
            [30.62084178888436, 0.060765368074607],
            [30.62120504512738, 0.060584652293582],
            [30.62331384025685, 0.061630136179462],
            [30.624165696471117, 0.062732993611017],
            [30.624104849085352, 0.063573654509513],
            [30.62492294750953, 0.063682188895236],
            [30.626206696644406, 0.065103491660316],
            [30.626508263780213, 0.067063045673237],
            [30.62756771436842, 0.068155199567299],
            [30.627788503197298, 0.070029554604299],
            [30.6260268934504, 0.071009172967814],
            [30.62406028456241, 0.073169584481676],
            [30.623751207510807, 0.074291881176224],
            [30.622786711543085, 0.074850871761349],
            [30.622069884692426, 0.076174657658699],
            [30.62184299001461, 0.077868822159889],
            [30.62242331516289, 0.078339630559484],
            [30.623325139266505, 0.078175723207308],
            [30.623746715934388, 0.079672153354137],
            [30.62565472412312, 0.08080715294134],
            [30.625287186509468, 0.082711263197997],
            [30.626660767172755, 0.083926128232341],
            [30.626105425070858, 0.084359038477369],
            [30.62610998761418, 0.084972489230281],
            [30.625353858571543, 0.085161801781238],
            [30.625562576737924, 0.085720862286806],
            [30.62513250829565, 0.086183212965189],
            [30.625379333894696, 0.087113073323822],
            [30.62666897777446, 0.086872669159526],
            [30.62660658708302, 0.087564722367726],
            [30.625128226924982, 0.088305901672805],
            [30.626109355200224, 0.088717898214888],
            [30.62619280060527, 0.089209690205822],
            [30.6249151573194, 0.089671970772592],
            [30.62471366879443, 0.09047490913417],
            [30.62528669513102, 0.091130573365292],
            [30.626159253919297, 0.091134818797971],
            [30.626196800803243, 0.091622435392118],
            [30.625595561078512, 0.092164617376103],
            [30.62658090065578, 0.092303399721161],
            [30.626980089510162, 0.093695716508796],
            [30.62763298236373, 0.092997031164287],
            [30.629328061084028, 0.09395970137243],
            [30.62990831706203, 0.095552804756257],
            [30.62938217110516, 0.096813778025261],
            [30.630480220504523, 0.097225809502563],
            [30.63050309969649, 0.097960812696713],
            [30.631290178395595, 0.097574748790678],
            [30.63261786053776, 0.098049802373525],
            [30.63347792735369, 0.098974609405037],
            [30.635916221834453, 0.099096688473152],
            [30.637306504873806, 0.100256917500682],
            [30.63803301735984, 0.100408297767021],
            [30.637491642263978, 0.101287557523633],
            [30.638154921438822, 0.101578386641122],
            [30.638315425227287, 0.103228265789346],
            [30.639295430608385, 0.104392986237309],
            [30.639014215703657, 0.105031911916117],
            [30.63952836106663, 0.105428222798219],
            [30.639520079498023, 0.108364094394822],
            [30.63858807739075, 0.10973082921685],
            [30.63854779423844, 0.11099250350635],
            [30.637366859982794, 0.111137988088204],
            [30.6363157610318, 0.111963243622832],
            [30.63692486101524, 0.112998128683672],
            [30.63702114963392, 0.114276015594544],
            [30.63594443432426, 0.117227922102859],
            [30.636348254892244, 0.117976645653744],
            [30.636895665768503, 0.117967381347849],
            [30.63663873322421, 0.118489842201414],
            [30.637470657618945, 0.119152944778866],
            [30.637462095775945, 0.120491326522604],
            [30.63670007198842, 0.121463890786859],
            [30.636514233014015, 0.123657704642078],
            [30.63523679993393, 0.124967803670456],
            [30.6345860828, 0.124628058940997],
            [30.634652824930647, 0.125299758224021],
            [30.633863009963186, 0.125153677236368],
            [30.634304727758053, 0.126286008112653],
            [30.633734297552635, 0.127094735131391],
            [30.63490589741418, 0.128308230301981],
            [30.63516423312697, 0.127693341312623],
            [30.635477520582306, 0.127758083632598],
            [30.635485450909616, 0.12855877519515],
            [30.634955164617626, 0.129197665290432],
            [30.634631701046732, 0.128975613095537],
            [30.634385717169135, 0.129408979049841],
            [30.63273029008545, 0.129976214291261],
            [30.6320630807812, 0.129391469132974],
            [30.631547391214283, 0.129792411371553],
            [30.63194250980208, 0.130483305671042],
            [30.63172551006713, 0.131041347553704],
            [30.630691886043337, 0.131365687029908],
            [30.630367159441164, 0.132319829184488],
            [30.630030361278227, 0.131744802928234],
            [30.629066356688952, 0.131437376892605],
            [30.628988666789915, 0.13239200952331],
            [30.628495856414933, 0.132545319193197],
            [30.627813136799002, 0.13169606316465],
            [30.62632368783713, 0.131557421142839],
            [30.62610205638854, 0.130741535609973],
            [30.62494505504866, 0.130642018705048],
            [30.625033552578884, 0.131695781992735],
            [30.62442332970134, 0.133331659157179],
            [30.623755699087226, 0.134018622341505],
            [30.622446124286263, 0.134850123137554],
            [30.62030946700995, 0.13490609251623],
            [30.61973103640858, 0.135666289706274],
            [30.618910340954933, 0.135242188160997],
            [30.618783032611177, 0.135795597337033],
            [30.618132315477244, 0.136030071339529],
            [30.618541961619837, 0.136652854494743],
            [30.617449385655522, 0.136579936653799],
            [30.61791531664056, 0.137081413442913],
            [30.61809189128946, 0.138391651007852],
            [30.61877517235244, 0.138348034334742],
            [30.61922461116716, 0.138763784212359],
            [30.61918425704798, 0.140243824324473],
            [30.62044547733385, 0.140826254270057],
            [30.62046947941993, 0.141360047763049],
            [30.619609833913835, 0.142573085879885],
            [30.617305233900193, 0.141072763814513],
            [30.61652496353263, 0.142127929809705],
            [30.61460495475, 0.142152001890283],
            [30.614347671862742, 0.144125341984776],
            [30.612965599425056, 0.14762711093581],
            [30.611453341339818, 0.148111146751726],
            [30.61156422758183, 0.14881495285454],
            [30.613272079447185, 0.149728108801364],
            [30.613471393150853, 0.150263727454077],
          ],
          [
            [30.578276873556128, 0.088240527753888],
            [30.577065270816664, 0.088718774969571],
            [30.5752121452002, 0.090871115085682],
            [30.574404433097335, 0.091253705285347],
            [30.573739118340033, 0.09302345417523],
            [30.56920171436521, 0.093812391338341],
            [30.56822760372899, 0.094649367624598],
            [30.567875155117154, 0.096243769938666],
            [30.569773477670484, 0.097140539741805],
            [30.575275518648535, 0.101166285149546],
            [30.57198038589698, 0.103976954659152],
            [30.570934901416507, 0.106368468935475],
            [30.57079229386515, 0.107875179985388],
            [30.569628062883872, 0.110027517955105],
            [30.56782251923139, 0.110697007738173],
            [30.565351730890196, 0.112992760361957],
            [30.56497135096124, 0.116317046669562],
            [30.568795928283382, 0.117345790702655],
            [30.571218852589602, 0.11954627217101],
            [30.573879129760208, 0.123923198409678],
            [30.575304082379642, 0.128850060377638],
            [30.576250682110288, 0.130320591550113],
            [30.574785024130374, 0.13959809207091],
            [30.573787192580767, 0.140458963003031],
            [30.57473737119951, 0.140961316462996],
            [30.57849085585006, 0.141057358652413],
            [30.581603026931056, 0.14017280193414],
            [30.583849095415747, 0.141245337741698],
            [30.58554775392244, 0.140568269678075],
            [30.588398782055414, 0.138105173707802],
            [30.593647960755725, 0.13534293214262],
            [30.594408370270695, 0.133955846444458],
            [30.595335179217322, 0.130368454562908],
            [30.59792499433363, 0.126685546336397],
            [30.600728369535744, 0.125418258302802],
            [30.60161791187281, 0.124480257679896],
            [30.59985068765539, 0.123080889650437],
            [30.60245881942039, 0.115555024442063],
            [30.602839130179063, 0.113067712948495],
            [30.604478625641157, 0.109647770239564],
            [30.602839620659214, 0.107184215052027],
            [30.602507173935486, 0.105868781915736],
            [30.600868029714658, 0.104433620563376],
            [30.59749499595997, 0.099960965287146],
            [30.594620387050785, 0.100175999180317],
            [30.59345636717362, 0.09979323301045],
            [30.58941815879881, 0.094196491572234],
            [30.586519969113414, 0.093789688246588],
            [30.584429561599503, 0.091613171078462],
            [30.5819114015001, 0.091373819767735],
            [30.58098494379478, 0.090847604407609],
            [30.579726039365724, 0.088503705971321],
            [30.578276873556128, 0.088240527753888],
          ],
          [
            [30.564705295126892, 0.117732838011529],
            [30.560685404299065, 0.120061082958515],
            [30.559613953116965, 0.121325564916615],
            [30.55937842562928, 0.124222343884414],
            [30.56051851438727, 0.1264944445992],
            [30.561040870351956, 0.129029581944364],
            [30.56032804369927, 0.130607981627382],
            [30.565435386501026, 0.132593498407859],
            [30.56933133766745, 0.132976579440454],
            [30.570851947389908, 0.130848174339487],
            [30.570234776941952, 0.125897487693105],
            [30.568880776856894, 0.124318877516109],
            [30.56702793151482, 0.123122928013744],
            [30.564106020916043, 0.122118185330672],
            [30.564705295126892, 0.117732838011529],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 395,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "NYAMAREBE",
        Population: 23238,
        Key: "IBANDANYAMAREBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.46370947651615, -0.186449156570812],
            [30.46261114145255, -0.187693388472529],
            [30.458873127587815, -0.18939206742636],
            [30.458424210694247, -0.189536616345064],
            [30.4569659494424, -0.188903717152912],
            [30.453876885725446, -0.185676575364196],
            [30.451108574463834, -0.180903938716973],
            [30.45018370497992, -0.177875968992828],
            [30.450927028538167, -0.17058213536439],
            [30.452726259729168, -0.161607292828552],
            [30.441678246562407, -0.166748692111349],
            [30.439104503204803, -0.171583824305877],
            [30.43474595919296, -0.177711157677784],
            [30.431937101572665, -0.180377039895636],
            [30.428634223546727, -0.181786532656078],
            [30.42163496767116, -0.182951460218848],
            [30.415705000732817, -0.182607166468437],
            [30.413677407016813, -0.182001326842958],
            [30.40911211933558, -0.179280227488855],
            [30.40453735083482, -0.178267328936032],
            [30.39898838276466, -0.187286439454623],
            [30.39636897983778, -0.190684320990363],
            [30.39550424717225, -0.19315154804335],
            [30.395086946485126, -0.197688527673766],
            [30.39562958820553, -0.212230655260149],
            [30.395151780594105, -0.217481615228761],
            [30.39461042795614, -0.219352374655799],
            [30.392413773100287, -0.221665699941284],
            [30.389759200231744, -0.223545116739376],
            [30.386980696684937, -0.227421874124042],
            [30.378204861536577, -0.236638857404052],
            [30.38116409174554, -0.243056274831792],
            [30.38483646750909, -0.252488538430683],
            [30.38668382594142, -0.25615121134114],
            [30.387909096547915, -0.257659472032895],
            [30.391035775420765, -0.257545389839822],
            [30.39440629209602, -0.259286318831366],
            [30.395184438846282, -0.259345227049386],
            [30.401233876327545, -0.258309040823355],
            [30.40195643173473, -0.258560417425414],
            [30.404475856662042, -0.260892735248059],
            [30.40599259913723, -0.264571517745596],
            [30.40938078926738, -0.269398535567874],
            [30.409315201471866, -0.270446933328783],
            [30.40730869121557, -0.275128201540505],
            [30.407252547408643, -0.277893823378501],
            [30.408554927602488, -0.281473169186624],
            [30.40959632744339, -0.282783915669732],
            [30.421643952620627, -0.28283178181654],
            [30.422104658105678, -0.284585281635443],
            [30.424421222780587, -0.287008019494158],
            [30.42862079732651, -0.288527376666291],
            [30.43267584641794, -0.289025390944407],
            [30.43493519110417, -0.28893551833829],
            [30.43715787734031, -0.287806239836599],
            [30.439885691650602, -0.288032807361948],
            [30.440672412820227, -0.288502972444353],
            [30.44311744556391, -0.288033531394893],
            [30.444757845629514, -0.28816947262656],
            [30.453545117229755, -0.285035128117403],
            [30.4520889122216, -0.281582160464339],
            [30.448211011802517, -0.276302939090337],
            [30.44649034816459, -0.272253411631189],
            [30.44498072124478, -0.269930252376822],
            [30.443930791900275, -0.266902207614865],
            [30.444093108488946, -0.266143025327534],
            [30.44476728243159, -0.265501445575107],
            [30.447539669349663, -0.264598185747081],
            [30.44950483823824, -0.263260917497603],
            [30.45196555377015, -0.265719847030094],
            [30.454865263404997, -0.265846980631105],
            [30.45893677681896, -0.26512474559101],
            [30.46248247485609, -0.266056426871471],
            [30.463550892427453, -0.265884916077151],
            [30.46648615019474, -0.263770520978554],
            [30.468256537380277, -0.259369153431843],
            [30.471428485055227, -0.257064972975355],
            [30.478584872443655, -0.255565988124866],
            [30.48206667870452, -0.257853422628318],
            [30.483731240756317, -0.258061637424519],
            [30.486698352783577, -0.259653012760077],
            [30.490635689335118, -0.258298000640687],
            [30.49360539839185, -0.258163005885812],
            [30.49512911359028, -0.256032012381825],
            [30.49448899567836, -0.255341288467974],
            [30.490738833896042, -0.254124678865083],
            [30.489919679053084, -0.253368670424238],
            [30.490110394981162, -0.249781510190592],
            [30.488994149307427, -0.248561650892734],
            [30.487355724637144, -0.245045894881033],
            [30.4860255927892, -0.244328208599099],
            [30.485692105816398, -0.243732574374383],
            [30.484503267284552, -0.243691677144405],
            [30.48395936971934, -0.241960284306836],
            [30.482487031867013, -0.239472903577092],
            [30.480895628611936, -0.238611691717892],
            [30.474957067491257, -0.238204062228725],
            [30.47189311977131, -0.236099043682155],
            [30.468259419175695, -0.232032963073666],
            [30.467072052982598, -0.230023956561647],
            [30.465338810235746, -0.225264726040495],
            [30.46334459522079, -0.218472760631466],
            [30.462062108218902, -0.217013783178325],
            [30.4599481334035, -0.216104694604434],
            [30.458166791263064, -0.21476520998349],
            [30.456526188178216, -0.212373830462211],
            [30.459977235225434, -0.206465761696896],
            [30.46171943237902, -0.201594334800499],
            [30.464110128726137, -0.190992630068854],
            [30.464185475818883, -0.18893188008229],
            [30.46370947651615, -0.186449156570812],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 396,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "RUKIRI",
        Population: 24298,
        Key: "IBANDARUKIRI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.56410605325537, 0.122118168262732],
              [30.56702794678617, 0.123122915437381],
              [30.568880804704673, 0.124318894584047],
              [30.570234751789094, 0.125897485896482],
              [30.57085193122023, 0.130848182424307],
              [30.569331332277535, 0.132976564169111],
              [30.56543538290777, 0.132593512780874],
              [30.560328052682404, 0.130607973542563],
              [30.561040883826674, 0.129029590927513],
              [30.56051849821759, 0.12649444998907],
              [30.559378431019162, 0.124222327714771],
              [30.55961394952371, 0.121325573001437],
              [30.560685389027714, 0.120061077568611],
              [30.564705286143752, 0.117732835316577],
              [30.56410605325537, 0.122118168262732],
            ],
          ],
          [
            [
              [30.58554775122752, 0.140568267881453],
              [30.583849091822458, 0.141245321572066],
              [30.581603008964745, 0.14017280193414],
              [30.57849084596859, 0.141057373923717],
              [30.574737377487693, 0.140961307479852],
              [30.57378718449593, 0.140458965697947],
              [30.574785033113514, 0.139598089375994],
              [30.576250683008585, 0.130320578075425],
              [30.575304064413338, 0.128850054089441],
              [30.57387916299787, 0.123923181341739],
              [30.571218880437375, 0.119546279357504],
              [30.568795958826083, 0.117345777227927],
              [30.564971332994936, 0.116317046669562],
              [30.565351716517142, 0.112992753175461],
              [30.567822533604446, 0.110697023907824],
              [30.569628046714218, 0.110027525141601],
              [30.570792270508964, 0.107875171900595],
              [30.570934928365954, 0.106368468037179],
              [30.57198038499868, 0.103976938489497],
              [30.5752755105637, 0.101166280657967],
              [30.569773493840163, 0.097140531656976],
              [30.567875126371046, 0.096243766345416],
              [30.568227631576768, 0.094649370319519],
              [30.56920168651743, 0.093812376965306],
              [30.573739150679366, 0.093023470344889],
              [30.574404444775432, 0.091253720556679],
              [30.575212180234487, 0.090871116882307],
              [30.577065304952622, 0.088718784851028],
              [30.5782769014039, 0.088240543025254],
              [30.579726011517945, 0.088503719446028],
              [30.580984933014975, 0.090847602610984],
              [30.581911389822, 0.091373825157644],
              [30.58442953734498, 0.091613165688553],
              [30.586519940367346, 0.093789703517918],
              [30.58941818754492, 0.094196490673938],
              [30.593456371665205, 0.099793247383482],
              [30.59462040950868, 0.100176000078613],
              [30.59749496182398, 0.099960968880395],
              [30.600868052172547, 0.104433637631359],
              [30.60250714518941, 0.105868768441036],
              [30.602839632337314, 0.107184213255402],
              [30.604478641810836, 0.109647767544645],
              [30.602839150840296, 0.113067719236663],
              [30.602458833793406, 0.115555021747111],
              [30.59985066879075, 0.123080901328506],
              [30.60161793882226, 0.124480249595075],
              [30.600728402773406, 0.12541824752303],
              [30.597925008706685, 0.126685562506038],
              [30.595335193590337, 0.130368466240974],
              [30.594408337931338, 0.133955856325899],
              [30.593647991298464, 0.135342937532488],
              [30.58839877127565, 0.138105177301047],
              [30.58554775122752, 0.140568267881453],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 397,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "RUSHANGO TOWN COUNCIL",
        Population: 3917,
        Key: "IBANDARUSHANGO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.5092051256959, 0.011899939364044],
            [30.50052353909221, 0.017479289169861],
            [30.50053447428418, 0.017931223482903],
            [30.492339254439926, 0.017533393798584],
            [30.485901410582645, 0.016755975616845],
            [30.481651701959017, 0.016755911836454],
            [30.47837933700836, 0.017560291153582],
            [30.474649643339777, 0.019539664997888],
            [30.473049404255576, 0.022450032049598],
            [30.471240870111494, 0.024013652979263],
            [30.469084737359847, 0.024908416243208],
            [30.464667315967613, 0.024601014578312],
            [30.463816361661898, 0.025369262719374],
            [30.46194537124939, 0.028740550671134],
            [30.459348437882745, 0.0317231573232],
            [30.457853474163322, 0.031894846907095],
            [30.45752338461891, 0.032346756916178],
            [30.456856369350767, 0.03187674316196],
            [30.45609940577326, 0.032099625030703],
            [30.45525033253973, 0.031162668857429],
            [30.455152153865722, 0.030493826512813],
            [30.453890640729064, 0.029843032213979],
            [30.453981841289988, 0.029056697423818],
            [30.45490279861082, 0.028026346988771],
            [30.455062048351135, 0.02662540380129],
            [30.45589166497389, 0.026336194819709],
            [30.45591118356839, 0.025486588972127],
            [30.454765269235786, 0.024185038943904],
            [30.45487989696098, 0.023326396929807],
            [30.45590550441917, 0.021862201521057],
            [30.45592543803533, 0.021102978733954],
            [30.455149333155703, 0.017713576971437],
            [30.45553371957085, 0.016195136746894],
            [30.455000969200015, 0.014062074602847],
            [30.455207617647982, 0.012643054496115],
            [30.454604160881146, 0.010573261563916],
            [30.452614739276534, 0.009154220778444],
            [30.45295718245273, 0.006325220260628],
            [30.45241683502955, 0.005466572787392],
            [30.451884476324185, 0.005448493294058],
            [30.451033541781413, 0.006216745995803],
            [30.45020281214601, 0.006243855354283],
            [30.44971900289018, 0.004390994748889],
            [30.448255200829642, 0.003631768317026],
            [30.44789441046209, 0.002682743136573],
            [30.446921860199502, 0.002854466882716],
            [30.446219197984274, 0.004806737755975],
            [30.444413787282436, 0.004737742650811],
            [30.443035033221467, 0.004210191730458],
            [30.441761183521002, 0.0010287138324],
            [30.439000528600552, -0.001836420545126],
            [30.438398740005226, -0.002216027024374],
            [30.434562305819632, -0.002478137457749],
            [30.433509106607488, -0.003960404386581],
            [30.43347151121453, -0.005551129408057],
            [30.434261402538812, -0.007286468811811],
            [30.43512634630843, -0.008081836258906],
            [30.435276859034303, -0.008994697053982],
            [30.435051138454533, -0.01164289543407],
            [30.43565291177854, -0.013540927785647],
            [30.434900707475354, -0.01755389245409],
            [30.435677773552342, -0.019785737794245],
            [30.438712769468964, -0.025413056483505],
            [30.441209965584576, -0.028828417572939],
            [30.443093267408067, -0.030223547736285],
            [30.444323372747405, -0.033156815286212],
            [30.44665121846567, -0.03404168263836],
            [30.44995293496993, -0.036457069622085],
            [30.451330568831786, -0.039757229513928],
            [30.453373324313137, -0.04236391162675],
            [30.453397061396206, -0.042913933753231],
            [30.456508761760023, -0.044898897334528],
            [30.457720153395393, -0.046716405067332],
            [30.458860322103426, -0.04738603780042],
            [30.460214347341303, -0.045999067310092],
            [30.461805873665554, -0.045855636049713],
            [30.470571097913762, -0.047338616651078],
            [30.4737540274931, -0.051212852306918],
            [30.47436368892359, -0.051515225110051],
            [30.472186659561757, -0.053464510068022],
            [30.46344643812286, -0.063978147665072],
            [30.46564870295765, -0.065085309770698],
            [30.467715160487785, -0.068218176814016],
            [30.469544178016946, -0.069294411648387],
            [30.47013799316583, -0.070083614279349],
            [30.47225210901675, -0.070275039732937],
            [30.472204452492598, -0.073096927004061],
            [30.472917029413626, -0.074029625435216],
            [30.474223483467306, -0.074603642130713],
            [30.48087467900119, -0.075034472875323],
            [30.482585027284717, -0.074508449537283],
            [30.48500793631959, -0.075345593326293],
            [30.487834644362877, -0.076756714240494],
            [30.490661317371877, -0.078885281122498],
            [30.492965355938463, -0.081587777359571],
            [30.494367019734142, -0.079220303895553],
            [30.497236803791914, -0.078917860292007],
            [30.49984863392093, -0.081308438419384],
            [30.500869983364677, -0.083054283632029],
            [30.500537156653614, -0.087215447011777],
            [30.498969179664535, -0.089726401425584],
            [30.499155184827266, -0.090444781473732],
            [30.497103580042044, -0.092891834989665],
            [30.493155846389403, -0.095849517880711],
            [30.491757180271797, -0.095865060510006],
            [30.48693965284532, -0.094660153681495],
            [30.48176464624138, -0.094346914262958],
            [30.476636176860747, -0.095519816868269],
            [30.47110346380567, -0.09958671782575],
            [30.467637709540607, -0.102699497605662],
            [30.465524112017615, -0.103997735352382],
            [30.459836144928577, -0.106437645381272],
            [30.455500407345184, -0.106327791492846],
            [30.4506517137682, -0.107985579144702],
            [30.446782044612057, -0.109925013183504],
            [30.444388532944867, -0.113788667043396],
            [30.444425707926282, -0.118584466039369],
            [30.450699368495723, -0.11894445343801],
            [30.459150612687505, -0.116101627514261],
            [30.461816532176414, -0.115573569225054],
            [30.464096870490845, -0.116219452101411],
            [30.465997216050205, -0.116076135175456],
            [30.47153175987187, -0.118228910015895],
            [30.473812055067174, -0.119544404577609],
            [30.476805131999406, -0.119209873590228],
            [30.478318336010656, -0.118459716364458],
            [30.479641283132953, -0.117126178228245],
            [30.480270216121234, -0.115230396414639],
            [30.48340910399714, -0.116460298017409],
            [30.493718087552676, -0.122176819134344],
            [30.4963809698376, -0.122663644719989],
            [30.5022457936465, -0.124951727458367],
            [30.50371860670766, -0.124808376442446],
            [30.504336312551523, -0.123947496882955],
            [30.50512060288, -0.119738541765347],
            [30.506831109267015, -0.117992902430982],
            [30.507448902247464, -0.116079758971877],
            [30.508731742287246, -0.11521893034154],
            [30.510893268523905, -0.117275809393756],
            [30.51405254815675, -0.118854481966144],
            [30.515786624540176, -0.119356852923532],
            [30.518614499494994, -0.119367986618998],
            [30.51808555708266, -0.118909418319085],
            [30.51678747622576, -0.118748815163047],
            [30.515457274309238, -0.117792091660817],
            [30.51419843545721, -0.115711367814036],
            [30.511383060559538, -0.105619392949603],
            [30.511366187503558, -0.102446787548158],
            [30.51274224841533, -0.098623493516777],
            [30.51550925711978, -0.094456815802281],
            [30.517562903775644, -0.092359956679683],
            [30.518536623644717, -0.092450411521275],
            [30.52404056096631, -0.091230543153423],
            [30.52663580460192, -0.090037587338572],
            [30.52904846655436, -0.085563501879312],
            [30.535410713587233, -0.079733795689288],
            [30.537219626820356, -0.079001747588533],
            [30.538246026592617, -0.078079834428081],
            [30.53877809065057, -0.076443815137005],
            [30.540091256017732, -0.075214590324852],
            [30.544429724479603, -0.074347085298946],
            [30.548858903022246, -0.072177960190073],
            [30.552991277296734, -0.072033551630928],
            [30.556715623294398, -0.07061461163682],
            [30.562205366336215, -0.069810409855588],
            [30.563480790783355, -0.068951758515762],
            [30.564656810356087, -0.066836662291355],
            [30.569445209909485, -0.064152262617844],
            [30.57285619478998, -0.065553490731311],
            [30.574732319972664, -0.065517422497912],
            [30.57597212082888, -0.064640678125967],
            [30.57646197574658, -0.062498409494433],
            [30.574496098985552, -0.061675756196448],
            [30.57402022185366, -0.061838440101563],
            [30.57412184287188, -0.060699507228243],
            [30.57372048368778, -0.060310805523212],
            [30.57396308540834, -0.059434015250331],
            [30.572597484479736, -0.059488192615937],
            [30.57165576080444, -0.058123238294966],
            [30.571545630045552, -0.054634114250883],
            [30.569941255117815, -0.050882801521076],
            [30.570482963488633, -0.049635416668833],
            [30.57024855350513, -0.049111137605791],
            [30.56944329470131, -0.048749543377897],
            [30.568985478198222, -0.045866038537369],
            [30.569274077254597, -0.045224267928095],
            [30.568910903656587, -0.044644712814261],
            [30.567563210643183, -0.045536247338535],
            [30.563619681106058, -0.04692324927897],
            [30.561196587916548, -0.046731841712021],
            [30.558583533383786, -0.044005342492028],
            [30.550364126400552, -0.041374354723468],
            [30.548653766438935, -0.039748036157512],
            [30.548488998347818, -0.025562364553769],
            [30.549234034095033, -0.023526398726264],
            [30.549081811875176, -0.015869085142465],
            [30.548131640442975, -0.008035784126328],
            [30.54659222359172, -0.003680129120235],
            [30.545349821214412, -0.004005705527932],
            [30.544688921676748, -0.003336819070449],
            [30.543787847666405, -0.003137961711261],
            [30.541647746249257, -0.003680298901819],
            [30.540797038081944, -0.002984298593915],
            [30.533113188704768, -0.001384409853898],
            [30.527659237238836, 0.002131704863655],
            [30.523822264064083, 0.002168032733751],
            [30.519221349198666, 0.006959157759116],
            [30.518057333813086, 0.009063684073655],
            [30.516584509073834, 0.010211598039837],
            [30.51225774835503, 0.00724541310873],
            [30.50971008668342, 0.009497422128179],
            [30.510226221814733, 0.01117671113337],
            [30.5092051256959, 0.011899939364044],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 398,
        District: "IBANDA",
        County: "IBANDA MUNICIPALITY",
        Subcounty: "BISHESHE DIVISION",
        Population: 31539,
        Key: "IBANDABISHESHE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.23812797393244, 0.669361822074127],
            [30.236155717336267, 0.669341851193266],
            [30.235472387764236, 0.668079025393733],
            [30.233269104239934, 0.666585804184357],
            [30.23290926249332, 0.66448154468244],
            [30.231408739100594, 0.663486051822321],
            [30.232207325218518, 0.662510986882374],
            [30.230707771107994, 0.659774873746381],
            [30.229301999316522, 0.659238505461825],
            [30.226793367647325, 0.66015522125569],
            [30.224151285852827, 0.66187521705938],
            [30.22177657592452, 0.661166150406932],
            [30.219040278823005, 0.661489769387512],
            [30.218128445690496, 0.661125828616781],
            [30.215162978478514, 0.663534210868536],
            [30.212636187365867, 0.662997202534323],
            [30.209158691221745, 0.663664678819174],
            [30.203946418008258, 0.666936855500408],
            [30.201761687389507, 0.66571002843503],
            [30.1997859543132, 0.665487889156903],
            [30.19833647319492, 0.663781837322018],
            [30.197054634776666, 0.664819355872358],
            [30.195411086116007, 0.664970914811427],
            [30.194617826109408, 0.665606490213489],
            [30.193434026227983, 0.667174808481656],
            [30.191879743157095, 0.670405676628507],
            [30.190722810089195, 0.669299993455591],
            [30.18954540800923, 0.669088354030979],
            [30.188666796372583, 0.668297283198643],
            [30.186431826573234, 0.668545958573635],
            [30.183807747017028, 0.666883924061544],
            [30.183297079032517, 0.667019776060543],
            [30.18171581326541, 0.668129938442527],
            [30.184752498014813, 0.671519807626728],
            [30.185601619757346, 0.673285717269174],
            [30.184868095022207, 0.673598014767246],
            [30.17940467710979, 0.67450542018897],
            [30.173360817268108, 0.672307143898965],
            [30.17274856419803, 0.669657705130578],
            [30.171568339611454, 0.667527287980039],
            [30.17077463583709, 0.662133363063619],
            [30.170556545547363, 0.659118431113255],
            [30.170859778159716, 0.657348442808477],
            [30.170311035081895, 0.655992848318239],
            [30.171355835046143, 0.654693482530256],
            [30.17031257748925, 0.65325463058515],
            [30.167235703910702, 0.651271107397472],
            [30.166074828137006, 0.649547714333481],
            [30.17052141333491, 0.646523458086608],
            [30.17186632696086, 0.643472166944904],
            [30.17102569429776, 0.638923890720776],
            [30.17161133387927, 0.637673843102036],
            [30.1730943985144, 0.635723737202962],
            [30.17617300494315, 0.634635207668289],
            [30.17757029035015, 0.633172776114939],
            [30.180561939859388, 0.634723702463764],
            [30.18212932396038, 0.634954083733929],
            [30.18218605706214, 0.635441851533318],
            [30.184122922731063, 0.637537330988275],
            [30.18557591266884, 0.641054159228814],
            [30.18688633278451, 0.642145132465298],
            [30.187655924878314, 0.641973414111413],
            [30.19145956157285, 0.644098637628331],
            [30.194896304745782, 0.644771685627952],
            [30.198849635800972, 0.644863654712075],
            [30.20333855410666, 0.643998379400586],
            [30.205359629646928, 0.644388504747065],
            [30.20842378577603, 0.64286172651006],
            [30.212974900737017, 0.641694096906872],
            [30.214635909053566, 0.640535220572595],
            [30.21584212010468, 0.639075033646944],
            [30.219014511547392, 0.638336685023278],
            [30.22083173868845, 0.637846073607794],
            [30.22281131745253, 0.639853904436711],
            [30.225831466014128, 0.641663124040068],
            [30.229164155531105, 0.645280086385342],
            [30.23107291471141, 0.646801795925167],
            [30.233371048651644, 0.647467661994752],
            [30.23773693728925, 0.647884233582718],
            [30.237581539524893, 0.64867222573209],
            [30.23951337911979, 0.653178608408566],
            [30.24027151140552, 0.65394264322257],
            [30.243121488509626, 0.655422324321905],
            [30.243926111306237, 0.661932988351632],
            [30.242782111283482, 0.66485025134652],
            [30.24284474092676, 0.667827136939627],
            [30.242476459508044, 0.667904149666572],
            [30.242048352986362, 0.668936820369804],
            [30.240850860085086, 0.669682133146116],
            [30.239796198415636, 0.669853678982761],
            [30.238827489349234, 0.669250602959474],
            [30.23812797393244, 0.669361822074127],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 399,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "BUKUUKU",
        Population: 11026,
        Key: "KABAROLEBUKUUKU",
        Dist2: "Kabarole",
        "Sub Country": "Bukuuku",
        id2_original: "Kabarole Bukuuku",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.329523914818413, 0.727238990249882],
            [30.328584153962048, 0.726258911001948],
            [30.32717127649666, 0.723641996589552],
            [30.31889472588153, 0.717915475114824],
            [30.311745984952797, 0.715355244167532],
            [30.304893837188143, 0.715506862576974],
            [30.301948502120016, 0.717297129663134],
            [30.300546989241283, 0.719040437620818],
            [30.299122969073135, 0.711059981495076],
            [30.296510753566864, 0.708119981528132],
            [30.29444989074432, 0.703097706478206],
            [30.295716106561482, 0.700572545720676],
            [30.29712650377835, 0.69469944454276],
            [30.300894420762262, 0.69111893453193],
            [30.300357923518405, 0.688494100190739],
            [30.30073112590825, 0.687161221225706],
            [30.30011077542417, 0.68645266127592],
            [30.29506299272236, 0.684741758156559],
            [30.294022719368854, 0.683919204372202],
            [30.293394354115797, 0.680272605473385],
            [30.29437924094216, 0.679937001459708],
            [30.294691795372234, 0.677517250909584],
            [30.296630808913022, 0.673823011021183],
            [30.297365417016398, 0.668698778546745],
            [30.298548058071063, 0.667773676438588],
            [30.302253153172227, 0.667407072806639],
            [30.302839427862615, 0.666737021732442],
            [30.303814172709416, 0.666484373286294],
            [30.3058344065283, 0.667282463369962],
            [30.30764095180234, 0.667275598910131],
            [30.3092808389299, 0.665593252634403],
            [30.309870754492152, 0.661532835344986],
            [30.308779134335293, 0.660943966910311],
            [30.306237928855616, 0.660999719833283],
            [30.30567681777295, 0.660655090623115],
            [30.305708642388527, 0.659969059563736],
            [30.307468258773795, 0.658547174497086],
            [30.307680827119462, 0.657920280733629],
            [30.30757685970176, 0.655656752198465],
            [30.30652578680189, 0.652323021322803],
            [30.306872202328247, 0.651598666774399],
            [30.307179503410563, 0.651346537651334],
            [30.307903864431477, 0.651985845252232],
            [30.308588889124422, 0.651702715497026],
            [30.310216351653295, 0.651931552794855],
            [30.31186962278028, 0.649699767777613],
            [30.313408906680895, 0.649139845202353],
            [30.31441656400309, 0.64937490035542],
            [30.31543301762852, 0.650351697900433],
            [30.317262070192, 0.649423048758462],
            [30.318144199631323, 0.649405021627071],
            [30.317791149148267, 0.648049695371394],
            [30.318517381359904, 0.647444203988937],
            [30.319394941967715, 0.647379922854447],
            [30.32052929947419, 0.648240788940784],
            [30.32217426837133, 0.647904040168366],
            [30.32343994699596, 0.645060894285035],
            [30.325598898661006, 0.644474069255322],
            [30.325962625621234, 0.643003489702521],
            [30.325581708499715, 0.642203150106866],
            [30.324176243932044, 0.641397645396705],
            [30.322619963906277, 0.639061167216477],
            [30.32089465058847, 0.634869960774473],
            [30.319621820475877, 0.63523467144439],
            [30.317048100474462, 0.636921458968245],
            [30.314258864754933, 0.637807994585875],
            [30.31197860728887, 0.640429742490946],
            [30.30811646511651, 0.636979235935282],
            [30.308313678559028, 0.635016975416047],
            [30.30665048194648, 0.632400047520779],
            [30.305296140501632, 0.632580372427978],
            [30.304347660597095, 0.633242542205712],
            [30.301199073611095, 0.632512318412903],
            [30.300662598825106, 0.631867905358697],
            [30.299104595830634, 0.632443666155417],
            [30.298063506806834, 0.633309560516957],
            [30.296663234501516, 0.633425878950688],
            [30.29638355391926, 0.633087334480236],
            [30.29741403833113, 0.631758269949474],
            [30.29757030476638, 0.629344547735424],
            [30.29528179896937, 0.628486730777403],
            [30.294240521299383, 0.626628601616498],
            [30.29406958986711, 0.625531101934604],
            [30.292119259350393, 0.622910706482257],
            [30.291110460269458, 0.620939242465374],
            [30.29142000085177, 0.619447363828566],
            [30.292384601024047, 0.618424503813089],
            [30.29554492000767, 0.61599503162031],
            [30.297112453229015, 0.615350676726693],
            [30.302904885402416, 0.614180347080317],
            [30.30545295311255, 0.615520087419117],
            [30.30798684091594, 0.61744369039925],
            [30.309827137691823, 0.617985661020108],
            [30.31141256265869, 0.619552823471419],
            [30.319325812115014, 0.623073829097928],
            [30.32122278809376, 0.622789893808617],
            [30.322355372325866, 0.621480280332363],
            [30.324974526419414, 0.616910257714929],
            [30.330892187336694, 0.610846428741703],
            [30.336738908295978, 0.609382244370227],
            [30.340617806743367, 0.609725737102013],
            [30.344043660538418, 0.611607039315912],
            [30.347823398453173, 0.614442636473413],
            [30.349408939302702, 0.614699681790794],
            [30.35563143722345, 0.617251191710157],
            [30.35776905569712, 0.617323822573635],
            [30.363030093057482, 0.614614365613002],
            [30.368683104003868, 0.609838346223215],
            [30.368980072663728, 0.607365585449343],
            [30.371117737849822, 0.605980742986797],
            [30.37152153416328, 0.605216348126551],
            [30.371616598378218, 0.603376659429043],
            [30.37264978851574, 0.602863409377137],
            [30.373647413452815, 0.600928528853721],
            [30.374930014540766, 0.599710550254431],
            [30.37547634654038, 0.598086087913802],
            [30.37787528762513, 0.596510180893695],
            [30.37898550201005, 0.59477126223849],
            [30.383274259500737, 0.593948094896295],
            [30.383758772137465, 0.593748830523689],
            [30.38433178949089, 0.592640795549962],
            [30.385212694526498, 0.592330889753962],
            [30.386929468459222, 0.593839013839943],
            [30.387743367259468, 0.595546205108988],
            [30.38701559174215, 0.597961976248383],
            [30.38952491421578, 0.599758654199146],
            [30.39080080758347, 0.602308396212204],
            [30.397241781171207, 0.606127493442994],
            [30.400602464887363, 0.609207534621498],
            [30.40260335438492, 0.610046612413491],
            [30.40399573499047, 0.611127155170448],
            [30.407262501640314, 0.609791006790864],
            [30.41086451775754, 0.610485811571034],
            [30.41343826650503, 0.611846837201193],
            [30.413983449559392, 0.616934323982899],
            [30.414224629246842, 0.617389348174771],
            [30.41471974649547, 0.617321505952991],
            [30.41492940519794, 0.620270451834719],
            [30.412898626055963, 0.62221067004676],
            [30.412390509286872, 0.623538617769137],
            [30.412592146033862, 0.626297291303568],
            [30.411069311184427, 0.62721605745767],
            [30.408430642988, 0.627010396001237],
            [30.40761810872868, 0.628236018872946],
            [30.405689875869626, 0.62803071137158],
            [30.40457301395162, 0.628949663161283],
            [30.405180787123378, 0.631299856066764],
            [30.404824778488074, 0.632883294615737],
            [30.406143095693395, 0.635029513330692],
            [30.40401172769746, 0.635130595438124],
            [30.403097595776146, 0.636560495059316],
            [30.401879959951245, 0.63604902228605],
            [30.401371631179707, 0.63778563780201],
            [30.400153732148432, 0.637785015308057],
            [30.397311221841, 0.639316074366421],
            [30.396701505613255, 0.640848291722456],
            [30.39659877248073, 0.643300266289153],
            [30.398424403361297, 0.645651084122486],
            [30.39811908755577, 0.64728562283646],
            [30.397002012737055, 0.648613225470326],
            [30.396493604015475, 0.650451992831131],
            [30.39679745197381, 0.651678160738861],
            [30.39831870489002, 0.653824492812888],
            [30.400246191249053, 0.655460192121396],
            [30.403899087943973, 0.656994648437411],
            [30.403695306918415, 0.658527070630686],
            [30.40450665180831, 0.659651358192984],
            [30.408363130102803, 0.660062062262323],
            [30.40856525553332, 0.661696879236241],
            [30.41008641682136, 0.664047579768989],
            [30.408844412397737, 0.665296551921605],
            [30.406531998837774, 0.667224114562708],
            [30.405938126196705, 0.668275129555817],
            [30.406163441636256, 0.673041961868424],
            [30.4074933974144, 0.675431930381739],
            [30.404951859558064, 0.675741320097749],
            [30.40230336379242, 0.676851077182413],
            [30.39524875552567, 0.678615740809408],
            [30.388158361072946, 0.682590461480297],
            [30.38585433418446, 0.683353898873729],
            [30.38292092874332, 0.683436076299951],
            [30.37798055490507, 0.682645163202014],
            [30.376602873432525, 0.683409055101954],
            [30.374132633961985, 0.68369453914443],
            [30.373526917033885, 0.68418403579194],
            [30.36844413327367, 0.682700170328607],
            [30.362684204842147, 0.683832194362215],
            [30.36194778483686, 0.685169805343018],
            [30.360688866034753, 0.685933745346473],
            [30.359239994872567, 0.686148050043725],
            [30.35587894823705, 0.688117484431013],
            [30.354121160821673, 0.689741271343468],
            [30.353527204637306, 0.691509006735289],
            [30.349930542479147, 0.695940518545703],
            [30.348265601338305, 0.697020390696565],
            [30.346151548369455, 0.699162700151847],
            [30.341602449227956, 0.705527597775077],
            [30.329523914818413, 0.727238990249882],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 400,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "BUSORO",
        Population: 25984,
        Key: "KABAROLEBUSORO",
        Dist2: "Kabarole",
        "Sub Country": "Busoro",
        id2_original: "Kabarole Busoro",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.38906534330293, 0.892823136178251],
            [30.38351001965211, 0.892064969210512],
            [30.380808039092777, 0.88993830325139],
            [30.377376004888532, 0.891234898851791],
            [30.3744106867969, 0.890372582681321],
            [30.366031861190063, 0.884004241442978],
            [30.363379237665693, 0.880851638325035],
            [30.36294675814521, 0.877164635344981],
            [30.361595638058947, 0.876184834500312],
            [30.359973733406754, 0.88062115605959],
            [30.35227739205724, 0.890741466323335],
            [30.346482193971042, 0.899503721202415],
            [30.34565322233867, 0.898548352059747],
            [30.345583222916773, 0.897880173841431],
            [30.346727323550834, 0.895209084601855],
            [30.346443158578705, 0.894850853229782],
            [30.345636091466186, 0.89489765962806],
            [30.346207971552484, 0.893657561579507],
            [30.346043253767036, 0.892869965955729],
            [30.345474013829374, 0.892654583285863],
            [30.346140306852014, 0.89170090906994],
            [30.345524672523194, 0.890888959949254],
            [30.345953486917317, 0.890006594821472],
            [30.345492800296906, 0.888824972905004],
            [30.346467157969826, 0.888134112284438],
            [30.345708948428978, 0.887417447828668],
            [30.346302914494846, 0.887084054732429],
            [30.345568653141186, 0.886248117956723],
            [30.346021668149046, 0.885103315084244],
            [30.345549263904065, 0.883838175287406],
            [30.34448156588324, 0.883646081738214],
            [30.345112393418475, 0.882608852928254],
            [30.345043037190333, 0.881582770602082],
            [30.34371438486768, 0.881318819317744],
            [30.3430985079937, 0.880650042466761],
            [30.341954200747146, 0.876866864342312],
            [30.34217037403207, 0.875435463004305],
            [30.34162547843858, 0.874886062675407],
            [30.341343576322668, 0.873263233869128],
            [30.342008940487307, 0.872810620854212],
            [30.341820959030926, 0.871760552701375],
            [30.3421785864304, 0.870854256485802],
            [30.342997744866615, 0.870676205807893],
            [30.34290395356443, 0.870031862908092],
            [30.343498036411287, 0.869626899642023],
            [30.34226535739863, 0.868790405664671],
            [30.341366832807058, 0.866904425835927],
            [30.342448078320675, 0.866154018651527],
            [30.342711793145387, 0.86467495675927],
            [30.343377468127095, 0.86405531369909],
            [30.34375904461201, 0.863029741885419],
            [30.343618550796528, 0.861955852189586],
            [30.34312115631866, 0.861382651727755],
            [30.344202696479698, 0.86046521427891],
            [30.34425186486846, 0.85951084473603],
            [30.3430674568276, 0.858221061910125],
            [30.34202307278335, 0.858267637925122],
            [30.341645785753897, 0.856883306792224],
            [30.33981878763748, 0.856594976229674],
            [30.33910098431814, 0.853170203472595],
            [30.339908153838596, 0.853051782713691],
            [30.33955418078572, 0.851906102102946],
            [30.34059839145513, 0.851954957866688],
            [30.341359071363, 0.851287697411156],
            [30.34081500132128, 0.850261108990229],
            [30.340435313095092, 0.850236823914086],
            [30.3415296524523, 0.848782528689285],
            [30.34092602320892, 0.847887108916964],
            [30.34147304511467, 0.84724346727513],
            [30.34114217134099, 0.846455704774034],
            [30.341783952932797, 0.845907610769744],
            [30.34183307550748, 0.844977114936237],
            [30.341287359752172, 0.84488107481489],
            [30.341193439092578, 0.844308312834281],
            [30.340695360098486, 0.844116888255143],
            [30.340602166175938, 0.84313850978694],
            [30.341480319671835, 0.843139452915834],
            [30.341980287822985, 0.842257165588916],
            [30.342018734818826, 0.840646623151506],
            [30.341569481955347, 0.839691709779117],
            [30.341927389629177, 0.838618374974148],
            [30.34124054225451, 0.837806377672065],
            [30.338681400113558, 0.835465266408413],
            [30.33647331509404, 0.835940078830975],
            [30.33439915990024, 0.834494278126601],
            [30.335208749482042, 0.832991947393549],
            [30.335519730063734, 0.831608378825726],
            [30.33511824062392, 0.830486514530388],
            [30.335713089733705, 0.829628176323394],
            [30.334836712207135, 0.828037755159913],
            [30.335332541819792, 0.827432552346691],
            [30.335110414501177, 0.826100378991552],
            [30.335467955662356, 0.825037997001331],
            [30.335469711868715, 0.822403886011836],
            [30.33606603960545, 0.81997970693543],
            [30.33722594430032, 0.819666189269005],
            [30.340020191720818, 0.821059959522438],
            [30.341150929915027, 0.819893323902315],
            [30.34125594656501, 0.818471565492836],
            [30.342133937465828, 0.817289790453664],
            [30.346314291657922, 0.813565881808843],
            [30.346626931427945, 0.812937489131602],
            [30.346241324202353, 0.81147049813538],
            [30.346687223654868, 0.810885552291324],
            [30.34670096967532, 0.809799890554384],
            [30.346299331115194, 0.808749602455091],
            [30.347215809436022, 0.807309732778475],
            [30.347399884119227, 0.803692310538273],
            [30.348482887635864, 0.80189197777837],
            [30.349647513875837, 0.800938767174098],
            [30.350744352346176, 0.798005055360354],
            [30.3522984719237, 0.79734189256103],
            [30.35238722547376, 0.794976462443784],
            [30.35348323749403, 0.79354568159882],
            [30.355174110302187, 0.793974775511114],
            [30.35687789369759, 0.793143600089243],
            [30.358041013462863, 0.793049371352436],
            [30.35882320263187, 0.793646711715105],
            [30.35963020506569, 0.793623689204855],
            [30.360960257861862, 0.793076277809098],
            [30.36217049156884, 0.793196858793703],
            [30.366338263957083, 0.791781464903114],
            [30.367714648262343, 0.791902195929765],
            [30.37159758463692, 0.790510368452048],
            [30.375037573423004, 0.791372940221404],
            [30.375751452002856, 0.791049288323454],
            [30.378324823457937, 0.791328635944467],
            [30.382697114388588, 0.790513306561685],
            [30.38842993435977, 0.787807618402721],
            [30.39187116012599, 0.787978188753298],
            [30.393090774939456, 0.787699612487095],
            [30.395267849217042, 0.786688575912399],
            [30.396206591383873, 0.785727744806256],
            [30.39919838642018, 0.785014967154589],
            [30.4005747545558, 0.78515955090012],
            [30.40398791964748, 0.784651564446084],
            [30.407888574392743, 0.783114941448068],
            [30.412032758818235, 0.782927962905751],
            [30.417339413527028, 0.78059842512727],
            [30.42129842552806, 0.779536473244632],
            [30.4265066805773, 0.778998232749473],
            [30.43207958246156, 0.780228441588493],
            [30.43083075263842, 0.781837874505505],
            [30.43072266015691, 0.78258943204616],
            [30.431357983760147, 0.785835341179679],
            [30.430819459916975, 0.788471572273654],
            [30.431196133397105, 0.790285484044094],
            [30.43368224250547, 0.793867381449963],
            [30.43579212100318, 0.795372877748209],
            [30.438534468258105, 0.801794671016775],
            [30.439617666709186, 0.8068307581669],
            [30.44013858267445, 0.807571031237306],
            [30.441763268510794, 0.808276653312566],
            [30.443444441310493, 0.810640777799972],
            [30.443652480350533, 0.81388629921473],
            [30.443293083269978, 0.815842644610933],
            [30.441200311390237, 0.81817898260814],
            [30.44108844957777, 0.8211020188165],
            [30.44356040033895, 0.825984483212835],
            [30.445668386086364, 0.828587704693],
            [30.448849707681298, 0.834186999745167],
            [30.448587862250715, 0.834844577625846],
            [30.443972550086254, 0.834694723101622],
            [30.441051964502524, 0.828475482712345],
            [30.43673785565618, 0.825055097354642],
            [30.43550140821093, 0.823185507692749],
            [30.433181300580532, 0.822444272801007],
            [30.430473461208898, 0.823221169823325],
            [30.427876118210474, 0.824578341668325],
            [30.427363264624894, 0.823861574614341],
            [30.427571767195598, 0.824737656652168],
            [30.424553644334924, 0.82687698068356],
            [30.424236031491496, 0.827351283050858],
            [30.425371905354172, 0.829998068251943],
            [30.424567986836745, 0.832842995510275],
            [30.423273667225928, 0.832521374215789],
            [30.420142071873524, 0.830728408111168],
            [30.416312822413612, 0.831232000097626],
            [30.413874613272814, 0.83372205765249],
            [30.412634940875687, 0.836835819318169],
            [30.41363720111965, 0.841858759976533],
            [30.413444529559197, 0.843789563304965],
            [30.414746244999723, 0.845914668961915],
            [30.416571706098704, 0.847157445923361],
            [30.41947278656269, 0.850871105644478],
            [30.421986308660244, 0.852257810234071],
            [30.423431164353136, 0.853977440610537],
            [30.423299161413684, 0.854536684813126],
            [30.420507891908354, 0.856478767879739],
            [30.419373794015012, 0.856516050086233],
            [30.41793771396413, 0.855906226784483],
            [30.415746354676898, 0.854154308221617],
            [30.415142181054474, 0.853164526749412],
            [30.413630476331413, 0.852592710020342],
            [30.409485617271134, 0.851844182685031],
            [30.408338642028166, 0.851904168243911],
            [30.40678807079605, 0.852930530775125],
            [30.40591739577489, 0.854756456551825],
            [30.405902931102187, 0.862550033934138],
            [30.405338330962973, 0.865668350555073],
            [30.40381289189755, 0.867927314540194],
            [30.403796629695965, 0.870229767687263],
            [30.402711040827906, 0.871589333861813],
            [30.403314592816173, 0.873057469903155],
            [30.404629738070206, 0.874024932843484],
            [30.404593818035266, 0.87454397826993],
            [30.403489922400063, 0.876655285561578],
            [30.400589471655113, 0.879696070547462],
            [30.398508249414952, 0.88087593218721],
            [30.396356314490603, 0.881465075586849],
            [30.390984055816613, 0.884826250210717],
            [30.3899151783078, 0.887689294821171],
            [30.38861650186785, 0.888619103809891],
            [30.38847288820338, 0.890552067752851],
            [30.38905882961881, 0.891733804984485],
            [30.38906534330293, 0.892823136178251],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 401,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KIJURA TOWN COUNCIL",
        Population: 10732,
        Key: "KABAROLEKIJURA TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Kijura TC",
        id2_original: "Kabarole Kijura TC",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.27448547225693, 0.69323757509463],
            [30.273265859240094, 0.6949803522271],
            [30.273788243052515, 0.695984041405166],
            [30.2736931626679, 0.696700711119485],
            [30.271436635098397, 0.698921354273515],
            [30.27020167346662, 0.6985623369302],
            [30.268182908393214, 0.698704612307263],
            [30.258552125029418, 0.700192632555743],
            [30.254395972349364, 0.699664827269904],
            [30.25091682510177, 0.698241483447022],
            [30.249611076225577, 0.698403854450316],
            [30.247758685431037, 0.697972367266793],
            [30.244738808160633, 0.695675226978565],
            [30.241237115894318, 0.688701043611177],
            [30.241767651019643, 0.683049052102754],
            [30.24145513791207, 0.681298668706505],
            [30.241028298014935, 0.680093353002091],
            [30.23897770293611, 0.677395143364198],
            [30.238818662503252, 0.67625176300849],
            [30.23938717929712, 0.67492891054737],
            [30.239556827935132, 0.673005875439941],
            [30.23809728388907, 0.670629396610904],
            [30.23812797393244, 0.669361822074127],
            [30.238827489349234, 0.669250602959474],
            [30.239796198415636, 0.669853678982761],
            [30.240850860085086, 0.669682133146116],
            [30.242048352986362, 0.668936820369804],
            [30.242476459508044, 0.667904149666572],
            [30.24284474092676, 0.667827136939627],
            [30.242782111283482, 0.66485025134652],
            [30.243926111306237, 0.661932988351632],
            [30.243121488509626, 0.655422324321905],
            [30.24027151140552, 0.65394264322257],
            [30.23951337911979, 0.653178608408566],
            [30.237581539524893, 0.64867222573209],
            [30.23773693728925, 0.647884233582718],
            [30.233371048651644, 0.647467661994752],
            [30.23107291471141, 0.646801795925167],
            [30.229164155531105, 0.645280086385342],
            [30.225831466014128, 0.641663124040068],
            [30.22281131745253, 0.639853904436711],
            [30.22083173868845, 0.637846073607794],
            [30.219014511547392, 0.638336685023278],
            [30.220133975884792, 0.631436504880738],
            [30.221781078280706, 0.628201373833377],
            [30.222600874520797, 0.627414542695494],
            [30.234371476332427, 0.623926129816374],
            [30.23510410544723, 0.623420270839398],
            [30.23613144395896, 0.620953327221842],
            [30.240814330094054, 0.617125903760235],
            [30.2440585346572, 0.617414114187549],
            [30.25148300358093, 0.606657749137937],
            [30.253371317105394, 0.601438562397981],
            [30.254238393475518, 0.595980007751912],
            [30.25656586729121, 0.594523729522626],
            [30.25713591750926, 0.592899437220464],
            [30.257848412683614, 0.592469724146491],
            [30.25960585963746, 0.592542181976068],
            [30.263524554350226, 0.591158268167728],
            [30.264676451462638, 0.589713390382325],
            [30.26479524018425, 0.588447244183321],
            [30.265222747529627, 0.587874059402169],
            [30.270091429519994, 0.586442755395137],
            [30.27113644957146, 0.585033659811448],
            [30.272217071654296, 0.584305455984071],
            [30.272763352449946, 0.582824466920359],
            [30.27494833998686, 0.581559211146438],
            [30.276753313209145, 0.581703343796848],
            [30.277204581892114, 0.580652333951633],
            [30.27801207660269, 0.580270427621658],
            [30.278724563692204, 0.580509638505059],
            [30.279270769927656, 0.581489399475081],
            [30.281028271678757, 0.580964557030445],
            [30.283177600590495, 0.582171973402763],
            [30.285552558453794, 0.582913618302368],
            [30.28564756876981, 0.582483621505484],
            [30.28659757221709, 0.582101772788552],
            [30.28735759994803, 0.580692531496157],
            [30.288307592615507, 0.580334575720742],
            [30.288260109466226, 0.579593932951058],
            [30.290802621096315, 0.575883094035563],
            [30.29131222727216, 0.576509885185072],
            [30.293747032696356, 0.577707082893139],
            [30.295856218592963, 0.581282271210759],
            [30.297554901354218, 0.582849426217415],
            [30.298375929184527, 0.584045956966829],
            [30.299126125753034, 0.587421216435397],
            [30.303457854155347, 0.589473684047446],
            [30.306841068517144, 0.594131739297105],
            [30.307010861783958, 0.596837477793733],
            [30.30638794301647, 0.597890988053781],
            [30.301673800899405, 0.60197587622405],
            [30.30105086236898, 0.603969237943159],
            [30.30103653424021, 0.608084665247207],
            [30.302904885402416, 0.614180347080317],
            [30.297112453229015, 0.615350676726693],
            [30.29554492000767, 0.61599503162031],
            [30.292384601024047, 0.618424503813089],
            [30.29142000085177, 0.619447363828566],
            [30.291110460269458, 0.620939242465374],
            [30.292119259350393, 0.622910706482257],
            [30.288898510697624, 0.621317600510819],
            [30.28759723273658, 0.621178080586103],
            [30.286012632423184, 0.621318797894678],
            [30.286158610453484, 0.621988413895759],
            [30.28502412538622, 0.622365319375918],
            [30.283594828514087, 0.621927984193923],
            [30.282220712454897, 0.622256910793987],
            [30.279506786098896, 0.618597219116946],
            [30.27825939627514, 0.61851555444048],
            [30.276126414904947, 0.619054560684539],
            [30.27361829168225, 0.618769697273812],
            [30.270298793026917, 0.620331439376642],
            [30.269594272197363, 0.617976198717335],
            [30.26844422381778, 0.617155739571572],
            [30.267158339387503, 0.615346326436687],
            [30.264569729810262, 0.614764128609653],
            [30.26261280386272, 0.613332398681223],
            [30.26133353462617, 0.613051248387385],
            [30.26034404393398, 0.613205290756729],
            [30.257467191033214, 0.615455928053707],
            [30.256343991500888, 0.618183948089365],
            [30.254400412721818, 0.618618379496715],
            [30.253404956317834, 0.620987313882757],
            [30.251280552061967, 0.62320700275045],
            [30.25117480598001, 0.624045818738198],
            [30.252478872311638, 0.625650507867385],
            [30.25369517324005, 0.628725486813235],
            [30.255265405898808, 0.62917341462216],
            [30.256578959338178, 0.630151266978255],
            [30.25729245972732, 0.631608157114304],
            [30.257035672710096, 0.632336275511516],
            [30.2598837714369, 0.631987496188261],
            [30.261545650220967, 0.632315638873003],
            [30.26259521215453, 0.633633376197927],
            [30.264193766897566, 0.641799659398804],
            [30.263065343661818, 0.645104594553702],
            [30.261661292144115, 0.64744910129119],
            [30.263999473878016, 0.650144949579993],
            [30.26542570569842, 0.652630728253193],
            [30.265437719767036, 0.653660246555138],
            [30.262749768197477, 0.6538926471485],
            [30.26163802757489, 0.654518629686168],
            [30.259185832563446, 0.654769403180886],
            [30.256672898862387, 0.655991721006439],
            [30.251431190551973, 0.656955547343697],
            [30.253496372474398, 0.660443044816388],
            [30.25499367900008, 0.660755603623525],
            [30.25806989680848, 0.660622476759867],
            [30.26017262022493, 0.662422802470793],
            [30.263037418632916, 0.6635319598414],
            [30.2643633391788, 0.663230853961792],
            [30.264653781578147, 0.66253325642603],
            [30.2666679724301, 0.663605391292591],
            [30.267606333711257, 0.66342407491795],
            [30.266110517490656, 0.664218312881308],
            [30.26342125258414, 0.668651259107878],
            [30.263408980699026, 0.671359590623089],
            [30.262111200777753, 0.673854665462542],
            [30.260278974466388, 0.67537091116593],
            [30.258155622137725, 0.675826517579396],
            [30.25611241031221, 0.677872866358565],
            [30.25605498371103, 0.679112762631495],
            [30.254773642959442, 0.680882187964421],
            [30.252739266963047, 0.681631497925909],
            [30.25285134616781, 0.68402984108374],
            [30.25173217827445, 0.68560357165518],
            [30.250889314196193, 0.685798860394936],
            [30.247939976235134, 0.685299546028624],
            [30.247161277020993, 0.686653216425351],
            [30.245331845368472, 0.688417097672134],
            [30.244434436484486, 0.690238755509704],
            [30.24341576941017, 0.691061645049143],
            [30.243119245416338, 0.692165292289702],
            [30.24918470704565, 0.692484233812321],
            [30.253280139900667, 0.691380315374469],
            [30.253543241176025, 0.690974193230302],
            [30.2564146224384, 0.693730052950212],
            [30.25736627788747, 0.694006082299744],
            [30.259828936475348, 0.694294974563605],
            [30.262363415370185, 0.693841331682294],
            [30.2673242591188, 0.694754490154976],
            [30.270204101612805, 0.693762073746056],
            [30.272964233713775, 0.694051134895717],
            [30.27448547225693, 0.69323757509463],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 402,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KARAMBI",
        Population: 25984,
        Key: "KABAROLEKARAMBI",
        Dist2: "Kabarole",
        "Sub Country": "Karambi",
        id2_original: "Kabarole Karambi",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.186479172280286, 0.71671501034896],
            [30.185813762301557, 0.718165182662008],
            [30.186268894638577, 0.719599998128108],
            [30.186069120099173, 0.72003023204167],
            [30.184786644775375, 0.719943358338429],
            [30.183503441816203, 0.721032791195328],
            [30.18185019404541, 0.721376040813652],
            [30.17991140418514, 0.722579820669122],
            [30.17818586000028, 0.724615749177475],
            [30.17670345742347, 0.725217313551313],
            [30.1718972325999, 0.731440039904314],
            [30.17016663089998, 0.732325795438787],
            [30.168845074369766, 0.731982958945538],
            [30.16770851419417, 0.732520484876849],
            [30.16631399290331, 0.73157477441858],
            [30.16439387272958, 0.732604526181768],
            [30.16343720288461, 0.731081266731057],
            [30.159961020077443, 0.727963496765472],
            [30.15991858366342, 0.725144638479747],
            [30.160686112326992, 0.723275806896329],
            [30.16039227160092, 0.721821701900148],
            [30.15787354286799, 0.719505704019247],
            [30.1574318951417, 0.71873395657148],
            [30.15710926520741, 0.716152312816708],
            [30.156549541123535, 0.715647536761744],
            [30.15460449629394, 0.715112225700042],
            [30.153325570213845, 0.70982986382769],
            [30.15027568202641, 0.708522410394416],
            [30.150208321854823, 0.707702592327131],
            [30.15127967332394, 0.705526204593709],
            [30.15337364714954, 0.703509818887869],
            [30.153374099002107, 0.702768019937596],
            [30.15119534487495, 0.698790687866331],
            [30.150896222953342, 0.698829774250257],
            [30.1499248854164, 0.697334540632622],
            [30.150097305357093, 0.694896679415081],
            [30.149242894334147, 0.694322513989775],
            [30.148246706701535, 0.692600982914073],
            [30.14622503647652, 0.690477282224575],
            [30.144532471242364, 0.685973193831512],
            [30.14078974122237, 0.679288075405251],
            [30.139650695408445, 0.678226179560643],
            [30.13818493591889, 0.675557888786497],
            [30.136618358505032, 0.674782547411528],
            [30.134310677269983, 0.674523051099547],
            [30.133456200670047, 0.674063623395211],
            [30.132659079704357, 0.672973258963743],
            [30.131963800742444, 0.668240389575224],
            [30.126854787972544, 0.661224383410767],
            [30.12582905385189, 0.659345520066371],
            [30.126485396236152, 0.657538970123135],
            [30.12778579384817, 0.650455410700526],
            [30.12780186021702, 0.647243079542792],
            [30.126435754435214, 0.644632293886925],
            [30.12656602811772, 0.6409611507903],
            [30.124260673519256, 0.636600261920684],
            [30.12282474708031, 0.631436809391128],
            [30.12097410530562, 0.629112577192499],
            [30.120250189849063, 0.62437977906598],
            [30.119569229134445, 0.623592581762107],
            [30.121597847828212, 0.621610370290244],
            [30.122965444813367, 0.621032828844612],
            [30.127458729829645, 0.619237157757202],
            [30.135057487189858, 0.617743060829748],
            [30.139062404000203, 0.61619602073987],
            [30.139888798366073, 0.616368610359268],
            [30.142027390613503, 0.614160684088446],
            [30.144449890914927, 0.614018546435452],
            [30.1483605043834, 0.612015006603688],
            [30.149707548813172, 0.613499720974323],
            [30.15093370605686, 0.616611742384171],
            [30.150827460511593, 0.617357559540687],
            [30.15218150730903, 0.618828732907739],
            [30.152688827272456, 0.620214205322394],
            [30.154064363568125, 0.621088694484907],
            [30.155079723943864, 0.622517069109965],
            [30.156875568486242, 0.629081775818138],
            [30.15776365106096, 0.630978928148752],
            [30.159794652086823, 0.633302934049918],
            [30.160153727570517, 0.634773582850399],
            [30.16131745549519, 0.635861083848254],
            [30.160956940910452, 0.63701167119723],
            [30.162838538629817, 0.641530631741342],
            [30.16304920703866, 0.643384800512998],
            [30.164995757444697, 0.645282569171321],
            [30.166074828137006, 0.649547714333481],
            [30.167235703910702, 0.651271107397472],
            [30.17031257748925, 0.65325463058515],
            [30.171355835046143, 0.654693482530256],
            [30.170311035081895, 0.655992848318239],
            [30.170859778159716, 0.657348442808477],
            [30.170556545547363, 0.659118431113255],
            [30.17077463583709, 0.662133363063619],
            [30.171568339611454, 0.667527287980039],
            [30.17274856419803, 0.669657705130578],
            [30.173360817268108, 0.672307143898965],
            [30.173858282712885, 0.673764556297988],
            [30.175319513795067, 0.675860467043587],
            [30.175374328993716, 0.678323602212837],
            [30.176639364424595, 0.67925863069964],
            [30.17697640692931, 0.680023241738111],
            [30.17686280238521, 0.681920049603333],
            [30.17863174238482, 0.68681900566968],
            [30.179503339975767, 0.687244201622746],
            [30.182146946211308, 0.687359026800189],
            [30.18169583922508, 0.689255639537778],
            [30.181976562751366, 0.690133470716136],
            [30.18312895303888, 0.691323252253792],
            [30.182733785942006, 0.693729510407536],
            [30.18397183238849, 0.696751225042825],
            [30.184784434021452, 0.698996070578908],
            [30.185845695613274, 0.699907243821919],
            [30.185569319932977, 0.701728134615002],
            [30.18655157200062, 0.70323308676872],
            [30.184269458615162, 0.705211103963577],
            [30.183324818110158, 0.706556522738751],
            [30.183009416918946, 0.707862738044281],
            [30.183441668267367, 0.708417237393536],
            [30.18340171749175, 0.709446505744824],
            [30.18418795267281, 0.709922047256298],
            [30.184737749474465, 0.711189208567768],
            [30.186506370572136, 0.712932182002926],
            [30.18678117150576, 0.713724117599009],
            [30.186111365172042, 0.715782291506447],
            [30.186479172280286, 0.71671501034896],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 403,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KARANGURA",
        Population: 12340,
        Key: "KABAROLEKARANGURA",
        Dist2: "Kabarole",
        "Sub Country": "Karangura",
        id2_original: "Kabarole Karangura",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.38865694941183, 0.283760902448966],
            [30.388448657046908, 0.289924490660675],
            [30.384965087393137, 0.297471565801207],
            [30.385661146092733, 0.298733611624859],
            [30.38566054152656, 0.301257365973171],
            [30.385103352488425, 0.301677856147183],
            [30.38436067032727, 0.301257048872279],
            [30.382318702668407, 0.298405650150692],
            [30.381529542572796, 0.298218514748843],
            [30.38027579806671, 0.299480083487908],
            [30.378882454467167, 0.302096958427157],
            [30.377280923605614, 0.301740204651691],
            [30.374699001985658, 0.300115502597158],
            [30.372319255203564, 0.30235239262121],
            [30.372127390330228, 0.303859572101033],
            [30.369521387572483, 0.305851031641106],
            [30.36906839592078, 0.307323090602194],
            [30.369102742107373, 0.309227574082742],
            [30.369450780889455, 0.309776805017274],
            [30.371887691066355, 0.311068492470836],
            [30.373488926382205, 0.312576126159326],
            [30.375211274361288, 0.317045675794352],
            [30.37649902189748, 0.319043965323217],
            [30.3774041149704, 0.319710186910032],
            [30.377554756155366, 0.320633258825851],
            [30.3795161197804, 0.320797346118266],
            [30.380351517960346, 0.321697230987442],
            [30.378052733639848, 0.324804569983795],
            [30.378098971724153, 0.325517305208717],
            [30.378899523355887, 0.326510656050608],
            [30.378075068452752, 0.328157877989635],
            [30.37933976252383, 0.329513558054295],
            [30.379525229595696, 0.330378223382024],
            [30.378375187504332, 0.33432710062868],
            [30.378792817873194, 0.335016570101675],
            [30.380719579291803, 0.334386156666517],
            [30.383411999979884, 0.335029507417236],
            [30.38342306991915, 0.337027479859363],
            [30.384281235899966, 0.339539782273062],
            [30.383979178283976, 0.340649682457483],
            [30.384482368692087, 0.344313164129368],
            [30.383327332866052, 0.348360835967324],
            [30.382044262857548, 0.349674203342329],
            [30.381272203989987, 0.352218901345948],
            [30.380749477919398, 0.352792056073752],
            [30.37801687648697, 0.353912881603337],
            [30.37777937270564, 0.355322789182872],
            [30.37793390090081, 0.356243104431102],
            [30.381094492972256, 0.358181923085614],
            [30.384207654895043, 0.361435246974665],
            [30.385764349044145, 0.364364496442168],
            [30.387784312470107, 0.366134996772391],
            [30.39191923436672, 0.368552773446345],
            [30.392691595068214, 0.369473664056888],
            [30.392667975664466, 0.371385713330272],
            [30.3909216660235, 0.37505284687724],
            [30.390185213678855, 0.378015856992435],
            [30.38767857806621, 0.383331415257317],
            [30.387749976165015, 0.385147931406588],
            [30.387215467791165, 0.387764556509482],
            [30.384863238202858, 0.39266197251644],
            [30.38195240652648, 0.394702728682523],
            [30.379433594250184, 0.395584686230375],
            [30.378934612449207, 0.396325118396901],
            [30.378815903677673, 0.398380452966956],
            [30.379552688398977, 0.401249213166957],
            [30.378851742864235, 0.4023599221604],
            [30.377212140502625, 0.402884167812978],
            [30.37621410323882, 0.402715914823214],
            [30.37042780476216, 0.400404041337429],
            [30.368788205993766, 0.401071693350099],
            [30.36800408185362, 0.401883551009607],
            [30.36584183067654, 0.404821226110657],
            [30.365604264911475, 0.406016013019647],
            [30.365639990012006, 0.408035616463372],
            [30.366543038519335, 0.410020202170429],
            [30.366305426041848, 0.41061748207637],
            [30.361469881105712, 0.41332550836217],
            [30.359117528448202, 0.417027769095823],
            [30.358404715270243, 0.419369294867876],
            [30.358891881530294, 0.420242112298122],
            [30.36202859278823, 0.4228024634508],
            [30.36343066262243, 0.425671839169191],
            [30.366793161833794, 0.429869592613311],
            [30.367149625016626, 0.431232259797167],
            [30.366781340902953, 0.43337096903291],
            [30.367755659948333, 0.435283942043341],
            [30.375174819828743, 0.443632404255338],
            [30.378667984388045, 0.4463126994996],
            [30.378763061179406, 0.448726736796026],
            [30.37718287878057, 0.455285856610969],
            [30.37794328829551, 0.45597972304057],
            [30.379297777064053, 0.456052760946299],
            [30.37987997070813, 0.461132195673794],
            [30.379547294015705, 0.461801077505321],
            [30.377099714548184, 0.463758488472451],
            [30.376529400225426, 0.464761724589107],
            [30.376434351281873, 0.465263534827143],
            [30.37758684307899, 0.465945856417319],
            [30.3782522063453, 0.467165445168854],
            [30.377705635393855, 0.469196435880154],
            [30.374509499681526, 0.472790234052776],
            [30.37443820488902, 0.473841781314382],
            [30.37569761776453, 0.475802882660831],
            [30.372964843855566, 0.479002772741735],
            [30.371146969927466, 0.479132400495749],
            [30.37026773935155, 0.479585601762871],
            [30.37017266525514, 0.481378035255963],
            [30.371931047355236, 0.484845365871359],
            [30.37070724100264, 0.486170587559213],
            [30.370612161516316, 0.487126501575397],
            [30.369827959222757, 0.488511919429466],
            [30.369871160103074, 0.48960575001774],
            [30.367216887271862, 0.491727290800897],
            [30.365605395890416, 0.494323527971068],
            [30.36436533362442, 0.494696062511704],
            [30.363439484976862, 0.493375730061722],
            [30.361696665290754, 0.493108394153039],
            [30.359668859572363, 0.491842177500354],
            [30.357733437496112, 0.491747934224124],
            [30.357333667431735, 0.491302008061858],
            [30.352876655488327, 0.492486528755536],
            [30.347707389119048, 0.495358813892981],
            [30.345522400683826, 0.497332828081383],
            [30.342463161932606, 0.49698997111305],
            [30.342525574183615, 0.497275848292629],
            [30.341145971214647, 0.49650885422453],
            [30.336395656636025, 0.495968902549455],
            [30.331644662032733, 0.497162548052295],
            [30.322202465589793, 0.498653144471118],
            [30.319529697345175, 0.50020628696403],
            [30.317865616790353, 0.503672754418015],
            [30.316796370073963, 0.504628765618518],
            [30.313529747154586, 0.50630119291447],
            [30.312994827352362, 0.507496534281599],
            [30.311866350217716, 0.508093841977271],
            [30.310737599995228, 0.509348708421613],
            [30.31002501049777, 0.509408185322652],
            [30.30421292049099, 0.505356753607321],
            [30.302389432990726, 0.503749159468404],
            [30.29993955832765, 0.50053448471712],
            [30.2998830498047, 0.499329343622786],
            [30.300572181595115, 0.497871912803439],
            [30.30017308796216, 0.496968793228619],
            [30.300537210181112, 0.496925027157587],
            [30.301083808082033, 0.494894183051341],
            [30.301856223580778, 0.490342231127361],
            [30.304356718310096, 0.483743260423932],
            [30.303670356923995, 0.482959538769796],
            [30.300267332015252, 0.481304738010349],
            [30.296300923286182, 0.480882760298493],
            [30.292455134045213, 0.482033330400822],
            [30.284712558204653, 0.486417096157055],
            [30.276717001508736, 0.485273672639614],
            [30.27070260640839, 0.485531583176677],
            [30.2707649027767, 0.484825406918653],
            [30.27266579990164, 0.484086517806977],
            [30.27387760296542, 0.484063866697217],
            [30.27497063617222, 0.48334804811311],
            [30.273283627018085, 0.482796642264796],
            [30.272214464743357, 0.480214513588303],
            [30.27324810583512, 0.478817523245413],
            [30.27301052210371, 0.478076429992009],
            [30.27187002820553, 0.477095425629241],
            [30.268971229462373, 0.476160413281034],
            [30.267379336625474, 0.473171502898895],
            [30.26575175641732, 0.47203467237749],
            [30.263399434302507, 0.472605817099559],
            [30.2607824325724, 0.472018532894495],
            [30.259764077213507, 0.471526683322672],
            [30.259015734767747, 0.46659095568536],
            [30.257281254142463, 0.46505972009445],
            [30.257340741478888, 0.460220413573513],
            [30.25857632025327, 0.45828591333054],
            [30.257198222860744, 0.457591482999616],
            [30.257245752722433, 0.456444418483942],
            [30.256449795973356, 0.455260661459301],
            [30.257138895424436, 0.450959696512001],
            [30.256818141172456, 0.448868298857039],
            [30.257293359839213, 0.447482687227349],
            [30.256057827777244, 0.446621116807089],
            [30.256913206285727, 0.445474867104467],
            [30.25667738684552, 0.442845478461143],
            [30.259099180172825, 0.440577933965389],
            [30.259491216640917, 0.434185580206876],
            [30.259942662291984, 0.433421288520553],
            [30.25987137738095, 0.433014945420748],
            [30.257792329063793, 0.431638743125574],
            [30.257887359142742, 0.430228850216557],
            [30.2568656575594, 0.429941063260367],
            [30.257317090634068, 0.428818298600326],
            [30.256342913522538, 0.428889032659294],
            [30.255962733917865, 0.427383080571096],
            [30.25534495800543, 0.426952305449041],
            [30.255047925565137, 0.424239590302144],
            [30.254572714084894, 0.424263015925915],
            [30.253622266869883, 0.421704997217578],
            [30.254121222619744, 0.421179726955049],
            [30.25404991165752, 0.418981041714592],
            [30.253432130355172, 0.41814400398712],
            [30.251745126590947, 0.417258135046617],
            [30.251427527222244, 0.415771193945776],
            [30.251792604350346, 0.41496396928114],
            [30.252624208944844, 0.414462921005579],
            [30.253717148726842, 0.412886722395692],
            [30.254857631845262, 0.412553263837204],
            [30.254453677428284, 0.411166776069334],
            [30.257281134666517, 0.410333097128652],
            [30.257494979518228, 0.410548387235475],
            [30.257091070017037, 0.411217138818758],
            [30.257566288683783, 0.411360987728836],
            [30.25811276261721, 0.410787969852375],
            [30.258374141822163, 0.411505166309521],
            [30.25889687507926, 0.411672953800532],
            [30.260088065400506, 0.410325189461994],
            [30.263328146696512, 0.409586172480033],
            [30.26477750833884, 0.4085360561003],
            [30.266369455074667, 0.408418100419736],
            [30.266488232118153, 0.407510086585746],
            [30.2693038531542, 0.407142380397895],
            [30.271157196162964, 0.407669944033828],
            [30.274507407319525, 0.406310969228544],
            [30.27536284511682, 0.408104175943593],
            [30.27772705373946, 0.408691975413939],
            [30.278178529034964, 0.409457165124168],
            [30.27903393449289, 0.409912061253296],
            [30.280269479131288, 0.409196302819402],
            [30.28333464406844, 0.409820632164745],
            [30.284712726189614, 0.408244657211067],
            [30.285556190342493, 0.406536719162977],
            [30.28662540561782, 0.405653498895944],
            [30.28871634134113, 0.404842954916681],
            [30.289928146201532, 0.404820220022654],
            [30.29161521644111, 0.405945087418609],
            [30.29310982802093, 0.404657760163756],
            [30.293218947276788, 0.40201527672137],
            [30.294240647961807, 0.401275394822149],
            [30.29391978411538, 0.398753762207018],
            [30.29460880541302, 0.397583377281556],
            [30.294632505665174, 0.396006072282528],
            [30.294133451998967, 0.394284887232444],
            [30.294620444884174, 0.391931316160799],
            [30.293253915995866, 0.386134548497538],
            [30.29208958889486, 0.38532089630823],
            [30.291709325746897, 0.383671514296915],
            [30.29047370295505, 0.382523206470279],
            [30.289190599708853, 0.38237860877874],
            [30.286885873032794, 0.384049341717434],
            [30.284652314486742, 0.383139086664099],
            [30.284497776410102, 0.381215095332883],
            [30.283737328267584, 0.379374184236671],
            [30.285424243098593, 0.377511675023238],
            [30.28504397276412, 0.375814515648103],
            [30.285566585646944, 0.373711926143056],
            [30.282893311650824, 0.370447257628258],
            [30.282215984621537, 0.368140419319827],
            [30.280980378897706, 0.367326713349088],
            [30.28094467625503, 0.366358786792035],
            [30.28001790593598, 0.364804522783982],
            [30.28084947190291, 0.363873248276183],
            [30.28074250321384, 0.363287637553458],
            [30.27953062918316, 0.362067686058122],
            [30.27803377361175, 0.363093924245906],
            [30.277035799230003, 0.362638926798081],
            [30.276417963130427, 0.361730213704196],
            [30.275918823225968, 0.359244311902984],
            [30.274766340411986, 0.357964671573452],
            [30.27291296326724, 0.357126521105696],
            [30.274142217003728, 0.3544997918653],
            [30.275555614593664, 0.352584767460993],
            [30.277810465906846, 0.351991462092264],
            [30.27846462987654, 0.348767219993398],
            [30.277558960085187, 0.347324444468969],
            [30.278128032936184, 0.346857916579871],
            [30.279160463997297, 0.347155205875836],
            [30.280446112170672, 0.346222190481394],
            [30.280614839137233, 0.345691904873129],
            [30.279582795250036, 0.34403695782411],
            [30.279751562640765, 0.343358177855336],
            [30.282365105857007, 0.341110304331767],
            [30.283208321176566, 0.339901378361406],
            [30.28291241342704, 0.339467524856772],
            [30.281999851760816, 0.337765106987485],
            [30.28271257241228, 0.33661862770578],
            [30.282213321116743, 0.333511355271269],
            [30.28283101258755, 0.332555975376639],
            [30.284256642536697, 0.332389967710437],
            [30.28450607594502, 0.331876375355802],
            [30.2835316769496, 0.329700712658656],
            [30.282628397575223, 0.325756644874178],
            [30.28375695465991, 0.324933149173412],
            [30.28382812099336, 0.323833879513464],
            [30.284873512049064, 0.323022259195573],
            [30.284611997198475, 0.321564209657736],
            [30.285182217198138, 0.321182339142635],
            [30.285776300943297, 0.321828133223091],
            [30.286394079550693, 0.321852588572551],
            [30.286560297522655, 0.320801186355897],
            [30.287558209920668, 0.320443601386206],
            [30.28821150342281, 0.319237298637824],
            [30.288995561087646, 0.318760019446711],
            [30.28922111817401, 0.317194858525164],
            [30.290741632675076, 0.315523295332096],
            [30.290753392520447, 0.314364218428567],
            [30.292107761813075, 0.314365417661407],
            [30.292582892444916, 0.313648871066407],
            [30.292547135005048, 0.312513653752404],
            [30.293141105562473, 0.312107898851318],
            [30.292974705232528, 0.311366890439855],
            [30.293616142769576, 0.310435407797628],
            [30.293128669285686, 0.307148885518656],
            [30.294031446501823, 0.305930834138707],
            [30.292724472323584, 0.304806443240305],
            [30.293163951516785, 0.303982323361033],
            [30.292332304701485, 0.303814296749],
            [30.29292615039308, 0.302357001812739],
            [30.291286703439997, 0.302809632317973],
            [30.291144086007172, 0.3022837335432],
            [30.291809262423925, 0.301256672483365],
            [30.29052600736248, 0.299797724326938],
            [30.291274421673446, 0.299332349471712],
            [30.292581261104388, 0.299309598150955],
            [30.292866343256424, 0.298927467223134],
            [30.29323448813121, 0.297768699335637],
            [30.292497803122913, 0.296931595748326],
            [30.29340065310258, 0.296478302950777],
            [30.293162935522204, 0.29554603570608],
            [30.293590632412137, 0.295546420179889],
            [30.294030293064985, 0.296299607075506],
            [30.294624258232556, 0.295798258618191],
            [30.294743025394574, 0.295487672938359],
            [30.293840108939555, 0.295439087303931],
            [30.293911293239315, 0.294650491026374],
            [30.293008370496082, 0.294554108460391],
            [30.293103372727288, 0.294219607213352],
            [30.29400627930084, 0.294220393228882],
            [30.295443722095985, 0.293492727893319],
            [30.29582380827582, 0.292823890613596],
            [30.295253542462106, 0.29277559961114],
            [30.294873439214257, 0.293324940967987],
            [30.294065466599932, 0.292487775063325],
            [30.294302839227257, 0.290623874931023],
            [30.29496820518853, 0.291198027540715],
            [30.29549094563213, 0.291126781278868],
            [30.294172027453893, 0.28970366333435],
            [30.296215487214432, 0.289872722311832],
            [30.297616771022774, 0.285213653493158],
            [30.29702260463259, 0.284137683591461],
            [30.297188849554036, 0.283540359766184],
            [30.295352720062755, 0.282304725987723],
            [30.294425861708795, 0.280846098769489],
            [30.294354400727926, 0.279579401332774],
            [30.29392663466775, 0.279005464635132],
            [30.294164131262537, 0.2782170064625],
            [30.293771953758966, 0.27732046331045],
            [30.29379537104177, 0.274882804394527],
            [30.293367604981594, 0.274380569275174],
            [30.293319941270934, 0.273352874194275],
            [30.292583294890182, 0.272922066842187],
            [30.29216728059053, 0.271451934773215],
            [30.29342651290466, 0.270879440362704],
            [30.294290816175504, 0.266631783509527],
            [30.297829225282417, 0.267563058641976],
            [30.302058744270017, 0.268088166697622],
            [30.303745743542652, 0.267853576023568],
            [30.305242827286154, 0.268260588342905],
            [30.306823640302323, 0.27373753919471],
            [30.307536460666796, 0.273737702686249],
            [30.30846306300088, 0.273042041774879],
            [30.30922339256578, 0.273231998264709],
            [30.311575941954356, 0.274317013299102],
            [30.312621685149622, 0.275871673709088],
            [30.313191877301506, 0.275799505692129],
            [30.314165978954556, 0.274724285909502],
            [30.31544912082829, 0.274724578756923],
            [30.31707685375009, 0.275538313664993],
            [30.319642960529443, 0.274508639717706],
            [30.32201919220383, 0.275159874873887],
            [30.323705983965674, 0.274111919488842],
            [30.32807836293121, 0.275974627531652],
            [30.32978901933687, 0.274881485682864],
            [30.33166628178668, 0.275812771858528],
            [30.33422065477181, 0.275316292217907],
            [30.33659688464957, 0.275479507931397],
            [30.33785627237226, 0.276437771052671],
            [30.34138556717229, 0.28069525996965],
            [30.342692369772315, 0.280406359847772],
            [30.34919056694195, 0.27616018587435],
            [30.353919521379755, 0.277769957038582],
            [30.358089688676525, 0.277987810305854],
            [30.36051353824749, 0.278684264131122],
            [30.365991048930066, 0.281405866420878],
            [30.368877974640117, 0.280123169342477],
            [30.369804746755825, 0.280123381342325],
            [30.371278130247177, 0.280864814045268],
            [30.373107843072354, 0.280820043447628],
            [30.37720650177758, 0.278697094616551],
            [30.379202422693286, 0.278119126284386],
            [30.38276681646811, 0.277812644479127],
            [30.38381222279516, 0.277388100269002],
            [30.38440623108186, 0.276330804506419],
            [30.38542800003882, 0.276240654225899],
            [30.386450041185334, 0.27808460982451],
            [30.38868409739804, 0.280308433874351],
            [30.38865694941183, 0.283760902448966],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 404,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KASENDA",
        Population: 24090,
        Key: "KABAROLEKASENDA",
        Dist2: "Kabarole",
        "Sub Country": "Kasenda",
        id2_original: "Kabarole Kasenda",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.329523914818413, 0.727238990249882],
            [30.329523778274492, 0.728232740539318],
            [30.331518736196216, 0.729356740265498],
            [30.332326027887536, 0.731340203888419],
            [30.331672304092354, 0.735461197543789],
            [30.333405748960153, 0.738376975806463],
            [30.333203430391865, 0.741494746589381],
            [30.334913416654295, 0.742331912532745],
            [30.336148520219915, 0.742189239699445],
            [30.336955899946126, 0.743408185233085],
            [30.33878473332068, 0.743648110431896],
            [30.339354552671704, 0.745201415276037],
            [30.3406727099769, 0.745644147526535],
            [30.340838830032485, 0.74662381201691],
            [30.34252517533163, 0.746815881562962],
            [30.343273677677484, 0.747328998751197],
            [30.34410159199281, 0.748952348733796],
            [30.342895563299674, 0.749023767679359],
            [30.34201860186819, 0.748330923016633],
            [30.33976331217713, 0.748686548265176],
            [30.33898080680111, 0.748280133009221],
            [30.33848075331, 0.749257916000204],
            [30.337271441274513, 0.748612446275389],
            [30.335395334956463, 0.749302504557914],
            [30.333211953607258, 0.74925256609186],
            [30.33134417826516, 0.752030400933808],
            [30.32934729076221, 0.753961056893387],
            [30.328834626721143, 0.755380216234192],
            [30.32771810975619, 0.755999442961451],
            [30.324871424079287, 0.755233014913349],
            [30.31938599834075, 0.75704077897221],
            [30.31117590509035, 0.756149540172591],
            [30.308301337503668, 0.757840644460721],
            [30.30781394396985, 0.758353131586392],
            [30.308402205733653, 0.761312371050401],
            [30.307365718779046, 0.76370921519955],
            [30.305844977004252, 0.76478133816075],
            [30.305151401248096, 0.767882402653671],
            [30.303806748133606, 0.770064174440772],
            [30.302526246408465, 0.769442494862839],
            [30.30162168783316, 0.771016304330394],
            [30.302378417848683, 0.77259183513003],
            [30.3015099787343, 0.773867422785586],
            [30.302242944717346, 0.775466797020594],
            [30.30259395332977, 0.778354195680845],
            [30.301951925599557, 0.779051101801576],
            [30.29586333594497, 0.773522032288432],
            [30.28066893029376, 0.766385258179095],
            [30.269791004142903, 0.76107843626081],
            [30.258020899997923, 0.746300359728828],
            [30.254941267693162, 0.742953846602161],
            [30.248059533914635, 0.736599717320231],
            [30.245890661255583, 0.739942907269298],
            [30.243915590237638, 0.741347343596755],
            [30.243192508417646, 0.742655620212052],
            [30.242806242726946, 0.744351880220842],
            [30.24309457498368, 0.745273022014613],
            [30.244152628691637, 0.747309498883529],
            [30.245242804357506, 0.748220569903993],
            [30.244459427615674, 0.748128038742825],
            [30.24186871867561, 0.748984090687128],
            [30.2256113940409, 0.750105861123147],
            [30.221043672823537, 0.751543837110114],
            [30.2184747453342, 0.752802692343498],
            [30.21198730369344, 0.748452261585061],
            [30.210062874301304, 0.745979044327856],
            [30.205263320367013, 0.742359677127607],
            [30.204926177250986, 0.741320105364245],
            [30.201223960352024, 0.736631564456528],
            [30.197877067572104, 0.733449540836503],
            [30.194410874030893, 0.731152088633367],
            [30.19322992989374, 0.729626857047709],
            [30.193123775976638, 0.728808549121147],
            [30.19180108397589, 0.726655571552681],
            [30.1917395727351, 0.725113604172269],
            [30.191155166540508, 0.724344873079738],
            [30.191256785762068, 0.723475349935646],
            [30.189929251841928, 0.719410016731268],
            [30.190262377691997, 0.718406053264477],
            [30.18940797026234, 0.717401352118093],
            [30.187698393631656, 0.716635208465746],
            [30.186479172280286, 0.71671501034896],
            [30.186111365172042, 0.715782291506447],
            [30.18678117150576, 0.713724117599009],
            [30.186506370572136, 0.712932182002926],
            [30.184737749474465, 0.711189208567768],
            [30.18418795267281, 0.709922047256298],
            [30.18340171749175, 0.709446505744824],
            [30.183441668267367, 0.708417237393536],
            [30.183009416918946, 0.707862738044281],
            [30.183324818110158, 0.706556522738751],
            [30.184269458615162, 0.705211103963577],
            [30.18655157200062, 0.70323308676872],
            [30.185569319932977, 0.701728134615002],
            [30.185845695613274, 0.699907243821919],
            [30.184784434021452, 0.698996070578908],
            [30.18397183238849, 0.696751225042825],
            [30.186527699271924, 0.696083095813656],
            [30.190802861659108, 0.695970905411627],
            [30.197144758257533, 0.697360388638636],
            [30.19955039718107, 0.693598278857554],
            [30.201670757221507, 0.691940152276062],
            [30.20719506204556, 0.69152766607955],
            [30.209476767595874, 0.686055011014258],
            [30.21232935430584, 0.681781713456072],
            [30.213883393034987, 0.680520201436016],
            [30.217731615812028, 0.679546936397995],
            [30.219930104129357, 0.679822120413159],
            [30.219969002079473, 0.679490876483918],
            [30.220681652662357, 0.679290453078687],
            [30.223417798846928, 0.679263349218214],
            [30.224244140212168, 0.679608126229088],
            [30.2255260478007, 0.680756533307364],
            [30.226522181534424, 0.683224582110156],
            [30.22674861357986, 0.68595040520606],
            [30.22731824697962, 0.686639333959582],
            [30.228372836783837, 0.686582570797879],
            [30.229572186502818, 0.682623834219501],
            [30.230856307540225, 0.679927577897644],
            [30.23319434374706, 0.678350887525539],
            [30.238818662503252, 0.67625176300849],
            [30.23897770293611, 0.677395143364198],
            [30.241028298014935, 0.680093353002091],
            [30.24145513791207, 0.681298668706505],
            [30.241767651019643, 0.683049052102754],
            [30.241237115894318, 0.688701043611177],
            [30.244738808160633, 0.695675226978565],
            [30.247758685431037, 0.697972367266793],
            [30.249611076225577, 0.698403854450316],
            [30.25091682510177, 0.698241483447022],
            [30.254395972349364, 0.699664827269904],
            [30.258552125029418, 0.700192632555743],
            [30.268182908393214, 0.698704612307263],
            [30.27020167346662, 0.6985623369302],
            [30.271436635098397, 0.698921354273515],
            [30.2736931626679, 0.696700711119485],
            [30.273788243052515, 0.695984041405166],
            [30.273265859240094, 0.6949803522271],
            [30.27448547225693, 0.69323757509463],
            [30.275773256624074, 0.692088515291231],
            [30.27692860416546, 0.689897361175241],
            [30.277013078141515, 0.687813379020061],
            [30.277967898355328, 0.686621325827972],
            [30.27813692535919, 0.685514553186518],
            [30.282702863420717, 0.683369761095029],
            [30.28496438382658, 0.68332663335087],
            [30.285903853628792, 0.681257414696999],
            [30.287406944406587, 0.681378364298267],
            [30.289496150872985, 0.682169992612762],
            [30.29009017173608, 0.681559796778727],
            [30.291832956387868, 0.681225422561304],
            [30.293394354115797, 0.680272605473385],
            [30.294022719368854, 0.683919204372202],
            [30.29506299272236, 0.684741758156559],
            [30.30011077542417, 0.68645266127592],
            [30.30073112590825, 0.687161221225706],
            [30.300357923518405, 0.688494100190739],
            [30.300894420762262, 0.69111893453193],
            [30.29712650377835, 0.69469944454276],
            [30.295716106561482, 0.700572545720676],
            [30.29444989074432, 0.703097706478206],
            [30.296510753566864, 0.708119981528132],
            [30.299122969073135, 0.711059981495076],
            [30.300546989241283, 0.719040437620818],
            [30.301948502120016, 0.717297129663134],
            [30.304893837188143, 0.715506862576974],
            [30.311745984952797, 0.715355244167532],
            [30.31889472588153, 0.717915475114824],
            [30.32717127649666, 0.723641996589552],
            [30.328584153962048, 0.726258911001948],
            [30.329523914818413, 0.727238990249882],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 405,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KICWAMBA",
        Population: 35111,
        Key: "KABAROLEKICWAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.20842378577603, 0.64286172651006],
            [30.205359629646928, 0.644388504747065],
            [30.20333855410666, 0.643998379400586],
            [30.198849635800972, 0.644863654712075],
            [30.194896304745782, 0.644771685627952],
            [30.19145956157285, 0.644098637628331],
            [30.187655924878314, 0.641973414111413],
            [30.18688633278451, 0.642145132465298],
            [30.18557591266884, 0.641054159228814],
            [30.184122922731063, 0.637537330988275],
            [30.18218605706214, 0.635441851533318],
            [30.18212932396038, 0.634954083733929],
            [30.180561939859388, 0.634723702463764],
            [30.17757029035015, 0.633172776114939],
            [30.17617300494315, 0.634635207668289],
            [30.1730943985144, 0.635723737202962],
            [30.17161133387927, 0.637673843102036],
            [30.17102569429776, 0.638923890720776],
            [30.17186632696086, 0.643472166944904],
            [30.17052141333491, 0.646523458086608],
            [30.166074828137006, 0.649547714333481],
            [30.164995757444697, 0.645282569171321],
            [30.16304920703866, 0.643384800512998],
            [30.162838538629817, 0.641530631741342],
            [30.160956940910452, 0.63701167119723],
            [30.16131745549519, 0.635861083848254],
            [30.160153727570517, 0.634773582850399],
            [30.159794652086823, 0.633302934049918],
            [30.15776365106096, 0.630978928148752],
            [30.156875568486242, 0.629081775818138],
            [30.155079723943864, 0.622517069109965],
            [30.154064363568125, 0.621088694484907],
            [30.152688827272456, 0.620214205322394],
            [30.15218150730903, 0.618828732907739],
            [30.150827460511593, 0.617357559540687],
            [30.15093370605686, 0.616611742384171],
            [30.149707548813172, 0.613499720974323],
            [30.1483605043834, 0.612015006603688],
            [30.149937778037344, 0.610743487659719],
            [30.155371408713233, 0.609538226197768],
            [30.156828358424782, 0.608419214040703],
            [30.159847684129602, 0.606541815471776],
            [30.165101964362396, 0.605824335278878],
            [30.175272315411735, 0.602674008284504],
            [30.175820878826503, 0.599948492848527],
            [30.17770426509163, 0.595272952354619],
            [30.18584362769149, 0.590084182702158],
            [30.18776853858061, 0.587761242329881],
            [30.193069938145026, 0.586989293198743],
            [30.197002662745895, 0.587593791694831],
            [30.200179464018362, 0.589546379957068],
            [30.20850021354208, 0.592304952286197],
            [30.20962525551906, 0.593198870088086],
            [30.207841980204165, 0.595806841693846],
            [30.206482199460254, 0.595947531818011],
            [30.203387337118166, 0.599320388370242],
            [30.201424958396846, 0.59973089148969],
            [30.197674219896125, 0.601318778653235],
            [30.199338723557414, 0.602528123663026],
            [30.19644898881547, 0.604460741786218],
            [30.19798835895434, 0.605202274107851],
            [30.19794546439951, 0.609097936469796],
            [30.20069412231935, 0.612163271368711],
            [30.196975641422167, 0.613637815555929],
            [30.193203237353387, 0.615792917867426],
            [30.19543358082902, 0.618026491566084],
            [30.20055514665669, 0.621581986994311],
            [30.20272652651368, 0.624349762744737],
            [30.205187887934304, 0.631724676796587],
            [30.205470700043616, 0.635798950307816],
            [30.204938005368337, 0.638919177553532],
            [30.205428552887128, 0.640039493780798],
            [30.20842378577603, 0.64286172651006],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 406,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "MUGUSU",
        Population: 13387,
        Key: "KABAROLEMUGUSU",
        Dist2: "Kabarole",
        "Sub Country": "Mugusu",
        id2_original: "Kabarole Mugusu",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.4454839188394, 0.602093796951325],
            [30.44470232794833, 0.604602447625792],
            [30.443312783324156, 0.604757181002534],
            [30.442101372824144, 0.604374364594873],
            [30.44148380172758, 0.605234293668063],
            [30.441151257985794, 0.604230604416528],
            [30.437707108203355, 0.604396415211599],
            [30.436566992495884, 0.602078223719132],
            [30.43587814636972, 0.602603597735856],
            [30.435711901448304, 0.601791138896243],
            [30.434405494107004, 0.601910056702469],
            [30.431685811346675, 0.601108490131218],
            [30.431210753478332, 0.601896772250792],
            [30.42935803300206, 0.602493341920121],
            [30.428930468164495, 0.603066620397399],
            [30.428550408934107, 0.604786811179812],
            [30.429357991679563, 0.605384485398221],
            [30.42923922361924, 0.605742841078234],
            [30.42847913570113, 0.605766419638292],
            [30.427220269899653, 0.604403939081786],
            [30.425225016432186, 0.606314588568976],
            [30.42402549782992, 0.606660539148786],
            [30.423312920010595, 0.607353157955631],
            [30.421293941138185, 0.607734592621579],
            [30.420391316635623, 0.609574019341223],
            [30.419607461091736, 0.610266600046928],
            [30.417873523947197, 0.610743723903233],
            [30.41642459619113, 0.61172273483311],
            [30.414546474951894, 0.610675404618787],
            [30.41388472201472, 0.610765173555184],
            [30.41343826650503, 0.611846837201193],
            [30.41086451775754, 0.610485811571034],
            [30.407262501640314, 0.609791006790864],
            [30.40399573499047, 0.611127155170448],
            [30.40260335438492, 0.610046612413491],
            [30.400602464887363, 0.609207534621498],
            [30.397241781171207, 0.606127493442994],
            [30.39080080758347, 0.602308396212204],
            [30.38952491421578, 0.599758654199146],
            [30.38701559174215, 0.597961976248383],
            [30.387743367259468, 0.595546205108988],
            [30.386929468459222, 0.593839013839943],
            [30.385212694526498, 0.592330889753962],
            [30.38433178949089, 0.592640795549962],
            [30.383758772137465, 0.593748830523689],
            [30.383274259500737, 0.593948094896295],
            [30.37898550201005, 0.59477126223849],
            [30.37365945177595, 0.592028498845129],
            [30.37161684451662, 0.590379039946555],
            [30.3698711088991, 0.590031857713403],
            [30.363220694899525, 0.590865288343736],
            [30.36014491277402, 0.589968022322355],
            [30.3537320699294, 0.589917519019361],
            [30.352544515988438, 0.589534735712456],
            [30.350775088203637, 0.588184066950811],
            [30.346761248427523, 0.580632431001943],
            [30.346666254281192, 0.579676702180608],
            [30.347877601899107, 0.574994337633983],
            [30.351131503775754, 0.568879259508472],
            [30.352378426475553, 0.567959912296747],
            [30.35334418996614, 0.56631813380052],
            [30.354044816598947, 0.563924116054582],
            [30.354326055758204, 0.560778735745659],
            [30.35251113189754, 0.552139503440925],
            [30.349201229944363, 0.549368096169326],
            [30.347056016214964, 0.549320184929261],
            [30.34528430491271, 0.548333489248577],
            [30.34374600197242, 0.546830478792761],
            [30.343250304412102, 0.544995956118694],
            [30.341284161749776, 0.54671200628301],
            [30.338721146073304, 0.5474144532213],
            [30.335156772959717, 0.550254820087591],
            [30.332552498560556, 0.551302133655173],
            [30.331058082813463, 0.552763823303656],
            [30.33013791690838, 0.557164300855165],
            [30.328725520041676, 0.559067486422213],
            [30.327628059937147, 0.561536444515028],
            [30.327174703569458, 0.563978104882751],
            [30.326365681722883, 0.565012418916994],
            [30.32658415469494, 0.566737004927102],
            [30.32615841343739, 0.568709615636883],
            [30.321114992056295, 0.56932805904061],
            [30.31607035615292, 0.568692879050972],
            [30.31859574050385, 0.567382219719696],
            [30.318357565680984, 0.566743410500026],
            [30.318828617063136, 0.564539846290426],
            [30.31560897154153, 0.562772487511295],
            [30.31502012138123, 0.561847897016752],
            [30.313829820392083, 0.557584463456057],
            [30.313146685754493, 0.553031559995956],
            [30.31145001072792, 0.54720899633039],
            [30.30758454119574, 0.549331772663853],
            [30.305911102890626, 0.552779918567829],
            [30.30408739081152, 0.555179518239149],
            [30.300798122262112, 0.555909164783393],
            [30.300126392635374, 0.556433085183326],
            [30.300249141130756, 0.557716130477248],
            [30.29939963401097, 0.55742602969995],
            [30.29823532307964, 0.556294253508469],
            [30.295207219037852, 0.555327162897509],
            [30.290493249397326, 0.555035271744405],
            [30.28817712669352, 0.555448060573242],
            [30.285134972102394, 0.555294896928013],
            [30.282818770346875, 0.555900816234101],
            [30.279160148688614, 0.55534729679052],
            [30.275589214280235, 0.552149542546385],
            [30.273529687252505, 0.551606153482811],
            [30.270007897876663, 0.549772504496043],
            [30.26862065293959, 0.548006195868207],
            [30.268422466621615, 0.546468211015687],
            [30.26748817830193, 0.545414078698334],
            [30.266907795661506, 0.543377542556786],
            [30.266200015744076, 0.543177900061649],
            [30.265860269310366, 0.542095541569794],
            [30.26639817151935, 0.540187611293782],
            [30.265435567403586, 0.538706291267822],
            [30.26503922081879, 0.538905490161991],
            [30.264388055425503, 0.538534993705765],
            [30.264303122410364, 0.538905197324157],
            [30.26368028718621, 0.538876462387561],
            [30.263000807793507, 0.538278123707053],
            [30.2616277185087, 0.537978537095706],
            [30.261486155698005, 0.537437372681537],
            [30.26032540389184, 0.538063459180129],
            [30.25774910842051, 0.537920037789673],
            [30.257890651468273, 0.536666998760968],
            [30.256163680758718, 0.536837187004785],
            [30.255937189424472, 0.536267504923452],
            [30.25497460596997, 0.535669059990861],
            [30.253275959141337, 0.535867736187408],
            [30.253219332939103, 0.535440528684894],
            [30.252511561106516, 0.535126967453218],
            [30.252313366703707, 0.533959238049868],
            [30.250869514429006, 0.533474520966591],
            [30.25071379327112, 0.533033028007841],
            [30.24911459533436, 0.533088759770916],
            [30.248352585021557, 0.532051148933948],
            [30.247940225068465, 0.532528105020466],
            [30.247651805675147, 0.532341267102101],
            [30.247652000609584, 0.531905615554761],
            [30.247982179087213, 0.530868497672786],
            [30.248682865907117, 0.530785831960037],
            [30.24891049540686, 0.528649163595893],
            [30.25136487152782, 0.527992442194904],
            [30.251166675328346, 0.526938629174905],
            [30.251591315251357, 0.525628736833718],
            [30.25201597673394, 0.52562890840471],
            [30.252780395430026, 0.526768376880513],
            [30.253573077819887, 0.526056700465258],
            [30.25459227579852, 0.526427332413008],
            [30.25483289314063, 0.524875294872114],
            [30.256106855130493, 0.523736608451079],
            [30.255200897878236, 0.523166672748737],
            [30.25588032606697, 0.521686007082663],
            [30.256673030016398, 0.521572387484499],
            [30.25800360114052, 0.520063484963946],
            [30.258116836477008, 0.519436978052443],
            [30.25740903679668, 0.518582328108751],
            [30.25789031460003, 0.518155318838558],
            [30.258598090025867, 0.518411904016617],
            [30.258767954259586, 0.518070216826431],
            [30.25879623951292, 0.51738671483521],
            [30.25804599982529, 0.517315234310535],
            [30.258017669656162, 0.516717147768681],
            [30.260197573626908, 0.515350959956996],
            [30.259829473667878, 0.513328775630847],
            [30.262235904007188, 0.513329680198018],
            [30.26274548053863, 0.512589399258182],
            [30.264076126222882, 0.513558215006189],
            [30.26563317520653, 0.511736101204196],
            [30.26653905430534, 0.509429576059031],
            [30.26771394110253, 0.508732263887641],
            [30.26646819429743, 0.506966054080594],
            [30.26765717745804, 0.504830517606256],
            [30.26884624326365, 0.504973356766585],
            [30.270049327279263, 0.501314145873212],
            [30.27061539975723, 0.497925254547517],
            [30.27251327494957, 0.497052184292159],
            [30.272938600287137, 0.495474393104902],
            [30.27262976039076, 0.494303050737972],
            [30.272035757493974, 0.493776662940353],
            [30.271501241933617, 0.49139822307389],
            [30.27207159308729, 0.48917626048675],
            [30.271952860061262, 0.487216474480105],
            [30.27055099953451, 0.486259091784078],
            [30.27070260640839, 0.485531583176677],
            [30.276717001508736, 0.485273672639614],
            [30.284712558204653, 0.486417096157055],
            [30.292455134045213, 0.482033330400822],
            [30.296300923286182, 0.480882760298493],
            [30.300267332015252, 0.481304738010349],
            [30.303670356923995, 0.482959538769796],
            [30.304356718310096, 0.483743260423932],
            [30.301856223580778, 0.490342231127361],
            [30.301083808082033, 0.494894183051341],
            [30.300537210181112, 0.496925027157587],
            [30.30017308796216, 0.496968793228619],
            [30.300572181595115, 0.497871912803439],
            [30.2998830498047, 0.499329343622786],
            [30.29993955832765, 0.50053448471712],
            [30.302389432990726, 0.503749159468404],
            [30.30421292049099, 0.505356753607321],
            [30.31002501049777, 0.509408185322652],
            [30.310737599995228, 0.509348708421613],
            [30.311866350217716, 0.508093841977271],
            [30.312994827352362, 0.507496534281599],
            [30.313529747154586, 0.50630119291447],
            [30.316796370073963, 0.504628765618518],
            [30.317865616790353, 0.503672754418015],
            [30.319529697345175, 0.50020628696403],
            [30.322202465589793, 0.498653144471118],
            [30.331644662032733, 0.497162548052295],
            [30.336395656636025, 0.495968902549455],
            [30.341145971214647, 0.49650885422453],
            [30.342525574183615, 0.497275848292629],
            [30.342463161932606, 0.49698997111305],
            [30.345522400683826, 0.497332828081383],
            [30.347707389119048, 0.495358813892981],
            [30.352876655488327, 0.492486528755536],
            [30.357333667431735, 0.491302008061858],
            [30.357733437496112, 0.491747934224124],
            [30.359668859572363, 0.491842177500354],
            [30.361696665290754, 0.493108394153039],
            [30.363439484976862, 0.493375730061722],
            [30.36436533362442, 0.494696062511704],
            [30.365605395890416, 0.494323527971068],
            [30.367216887271862, 0.491727290800897],
            [30.369871160103074, 0.48960575001774],
            [30.370350685293307, 0.490878599112656],
            [30.37201406965378, 0.491692895575313],
            [30.373190270686226, 0.49368979368792],
            [30.37398000660194, 0.497712900830044],
            [30.377281485052666, 0.498621970518108],
            [30.37799409790631, 0.499984108820012],
            [30.37903920419606, 0.500820723749933],
            [30.382768192687127, 0.501323767359917],
            [30.384122004125956, 0.500750806050548],
            [30.38663973572895, 0.502256937421114],
            [30.389632477589565, 0.502998672962299],
            [30.39261343535029, 0.505544319031463],
            [30.39323108639693, 0.507503771723927],
            [30.394323734226475, 0.508794379042349],
            [30.394181331490994, 0.510681882146444],
            [30.394882048853635, 0.511434774252402],
            [30.395262147609934, 0.512940176430551],
            [30.398777470014043, 0.51432722639237],
            [30.39892005959909, 0.515856440363987],
            [30.402423561072382, 0.518139500153275],
            [30.410285589489543, 0.521320134830126],
            [30.4125064781968, 0.522766492654904],
            [30.415095584542367, 0.525658535392572],
            [30.415048130139166, 0.527139916045986],
            [30.415523219448538, 0.528024153174494],
            [30.417435330243183, 0.529565981013382],
            [30.417316754422313, 0.53420129385808],
            [30.419300139348227, 0.536244924961175],
            [30.421366604064875, 0.536747457330847],
            [30.424216819222504, 0.535171528235769],
            [30.42566574248699, 0.536032236569993],
            [30.42730474387571, 0.538374422448133],
            [30.428124296672323, 0.541086670781232],
            [30.42786314384283, 0.544981266633402],
            [30.428540188801097, 0.548195223297261],
            [30.428373977117346, 0.549867720633647],
            [30.428896549575995, 0.550632521775922],
            [30.44203193934089, 0.558904829028571],
            [30.447293222839658, 0.560830326216005],
            [30.448314608216023, 0.561547539972502],
            [30.449526046563776, 0.563340066904074],
            [30.45414602996771, 0.564930817228934],
            [30.454526070333497, 0.565313275221597],
            [30.454409942421787, 0.565850718256771],
            [30.452787626341156, 0.567211684719074],
            [30.45361990287548, 0.569768661816142],
            [30.456576196491767, 0.570469057042897],
            [30.45725059321659, 0.571068564712119],
            [30.46014718210415, 0.572188382049275],
            [30.462270195767914, 0.57262875285186],
            [30.46426829419989, 0.572488986464097],
            [30.4648330111201, 0.573942338450372],
            [30.464738014278808, 0.575758289311325],
            [30.462113307698505, 0.577346229111283],
            [30.461163201843323, 0.578468887342277],
            [30.45826534273793, 0.580212033834497],
            [30.456911427992868, 0.581573463980802],
            [30.45631759847092, 0.581597118098524],
            [30.454322303680957, 0.578012184653087],
            [30.453870996370444, 0.578059792042001],
            [30.452243951558156, 0.581296813288467],
            [30.452885289382223, 0.582587364372021],
            [30.448728520457898, 0.582537898502979],
            [30.44799217860603, 0.582752653023472],
            [30.44754088117698, 0.584018857100971],
            [30.44594942402297, 0.584161581203328],
            [30.445569386352147, 0.58463930916641],
            [30.446163214077462, 0.585236904723307],
            [30.447552758701637, 0.585297194703008],
            [30.44807531499064, 0.585799189288501],
            [30.447766539772957, 0.587662801136951],
            [30.446745173261224, 0.588618151327589],
            [30.447624029239655, 0.590291099548234],
            [30.446602643863322, 0.591580969468003],
            [30.446709535297273, 0.592572614372024],
            [30.445070584214225, 0.592786986743165],
            [30.447184596758873, 0.594125927509693],
            [30.445723756443822, 0.59972849042449],
            [30.4454839188394, 0.602093796951325],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 407,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "RUTEETE",
        Population: 18095,
        Key: "KABAROLERUTEETE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.297365417016398, 0.668698778546745],
            [30.29134764964044, 0.672426123853671],
            [30.291300499766155, 0.674396615695637],
            [30.29084133758675, 0.674921856566866],
            [30.28937198573441, 0.675141399466152],
            [30.28734737173021, 0.674589331393957],
            [30.28667868290071, 0.673381156677317],
            [30.286848047671104, 0.671626767171397],
            [30.28527459545039, 0.670576788583232],
            [30.284420956978582, 0.671597358349518],
            [30.28385002910651, 0.67154970420076],
            [30.284160307205635, 0.669217019936957],
            [30.280931051507114, 0.66746700882712],
            [30.280682224461636, 0.666520742712965],
            [30.28134540841509, 0.663885476186371],
            [30.280683790225176, 0.663672712812054],
            [30.280924263836848, 0.662369509884949],
            [30.27896391261314, 0.659903830031516],
            [30.278126948669655, 0.656883194600036],
            [30.278611473882773, 0.656445007218398],
            [30.27953762166933, 0.656545741274786],
            [30.279969219942522, 0.656221011728187],
            [30.28018012640493, 0.656737430065401],
            [30.2804429159649, 0.656157492427139],
            [30.28107941905609, 0.656291474550062],
            [30.281287296399356, 0.656829152809153],
            [30.282503209255548, 0.656681004300767],
            [30.282995656711137, 0.655417847411436],
            [30.283064736258165, 0.654035577765833],
            [30.281216684326445, 0.652858371725284],
            [30.28002380337583, 0.651188818050008],
            [30.281688404953496, 0.64625242217323],
            [30.28171642789879, 0.644515743057961],
            [30.282476461019645, 0.642042952823432],
            [30.281722995481836, 0.638714480393621],
            [30.282736505328085, 0.635692182227721],
            [30.282629791760552, 0.632857622331069],
            [30.283168595878053, 0.631432236345726],
            [30.282135101211683, 0.627558365126811],
            [30.282491603022088, 0.625279523066027],
            [30.282220712454897, 0.622256910793987],
            [30.283594828514087, 0.621927984193923],
            [30.28502412538622, 0.622365319375918],
            [30.286158610453484, 0.621988413895759],
            [30.286012632423184, 0.621318797894678],
            [30.28759723273658, 0.621178080586103],
            [30.288898510697624, 0.621317600510819],
            [30.292119259350393, 0.622910706482257],
            [30.29406958986711, 0.625531101934604],
            [30.294240521299383, 0.626628601616498],
            [30.29528179896937, 0.628486730777403],
            [30.29757030476638, 0.629344547735424],
            [30.29741403833113, 0.631758269949474],
            [30.29638355391926, 0.633087334480236],
            [30.296663234501516, 0.633425878950688],
            [30.298063506806834, 0.633309560516957],
            [30.299104595830634, 0.632443666155417],
            [30.300662598825106, 0.631867905358697],
            [30.301199073611095, 0.632512318412903],
            [30.304347660597095, 0.633242542205712],
            [30.305296140501632, 0.632580372427978],
            [30.30665048194648, 0.632400047520779],
            [30.308313678559028, 0.635016975416047],
            [30.30811646511651, 0.636979235935282],
            [30.31197860728887, 0.640429742490946],
            [30.314258864754933, 0.637807994585875],
            [30.317048100474462, 0.636921458968245],
            [30.319621820475877, 0.63523467144439],
            [30.32089465058847, 0.634869960774473],
            [30.322619963906277, 0.639061167216477],
            [30.324176243932044, 0.641397645396705],
            [30.325581708499715, 0.642203150106866],
            [30.325962625621234, 0.643003489702521],
            [30.325598898661006, 0.644474069255322],
            [30.32343994699596, 0.645060894285035],
            [30.32217426837133, 0.647904040168366],
            [30.32052929947419, 0.648240788940784],
            [30.319394941967715, 0.647379922854447],
            [30.318517381359904, 0.647444203988937],
            [30.317791149148267, 0.648049695371394],
            [30.318144199631323, 0.649405021627071],
            [30.317262070192, 0.649423048758462],
            [30.31543301762852, 0.650351697900433],
            [30.31441656400309, 0.64937490035542],
            [30.313408906680895, 0.649139845202353],
            [30.31186962278028, 0.649699767777613],
            [30.310216351653295, 0.651931552794855],
            [30.308588889124422, 0.651702715497026],
            [30.307903864431477, 0.651985845252232],
            [30.307179503410563, 0.651346537651334],
            [30.306872202328247, 0.651598666774399],
            [30.30652578680189, 0.652323021322803],
            [30.30757685970176, 0.655656752198465],
            [30.307680827119462, 0.657920280733629],
            [30.307468258773795, 0.658547174497086],
            [30.305708642388527, 0.659969059563736],
            [30.30567681777295, 0.660655090623115],
            [30.306237928855616, 0.660999719833283],
            [30.308779134335293, 0.660943966910311],
            [30.309870754492152, 0.661532835344986],
            [30.3092808389299, 0.665593252634403],
            [30.30764095180234, 0.667275598910131],
            [30.3058344065283, 0.667282463369962],
            [30.303814172709416, 0.666484373286294],
            [30.302839427862615, 0.666737021732442],
            [30.302253153172227, 0.667407072806639],
            [30.298548058071063, 0.667773676438588],
            [30.297365417016398, 0.668698778546745],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 408,
        District: "KABAROLE",
        County: "FORT PORTAL MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 18524,
        Key: "KABAROLEEASTERN DIVISION",
        Dist2: "Kabarole",
        "Sub Country": "East Division",
        id2_original: "Kabarole East Division",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.278126948669655, 0.656883194600036],
            [30.276131779643848, 0.656018452218804],
            [30.27544031403031, 0.657099266542562],
            [30.2739559944487, 0.657077188303149],
            [30.27305724437998, 0.65653305879394],
            [30.27304256051833, 0.655798081174257],
            [30.271320316743836, 0.654752326424147],
            [30.269050530040712, 0.654912630197914],
            [30.26699109643778, 0.65385284179727],
            [30.265437719767036, 0.653660246555138],
            [30.26542570569842, 0.652630728253193],
            [30.263999473878016, 0.650144949579993],
            [30.261661292144115, 0.64744910129119],
            [30.263065343661818, 0.645104594553702],
            [30.264193766897566, 0.641799659398804],
            [30.26259521215453, 0.633633376197927],
            [30.261545650220967, 0.632315638873003],
            [30.2598837714369, 0.631987496188261],
            [30.257035672710096, 0.632336275511516],
            [30.25729245972732, 0.631608157114304],
            [30.256578959338178, 0.630151266978255],
            [30.255265405898808, 0.62917341462216],
            [30.25369517324005, 0.628725486813235],
            [30.252478872311638, 0.625650507867385],
            [30.25117480598001, 0.624045818738198],
            [30.251280552061967, 0.62320700275045],
            [30.253404956317834, 0.620987313882757],
            [30.254400412721818, 0.618618379496715],
            [30.256343991500888, 0.618183948089365],
            [30.257467191033214, 0.615455928053707],
            [30.26034404393398, 0.613205290756729],
            [30.26133353462617, 0.613051248387385],
            [30.26261280386272, 0.613332398681223],
            [30.264569729810262, 0.614764128609653],
            [30.267158339387503, 0.615346326436687],
            [30.26844422381778, 0.617155739571572],
            [30.269594272197363, 0.617976198717335],
            [30.270298793026917, 0.620331439376642],
            [30.27361829168225, 0.618769697273812],
            [30.276126414904947, 0.619054560684539],
            [30.27825939627514, 0.61851555444048],
            [30.279506786098896, 0.618597219116946],
            [30.282220712454897, 0.622256910793987],
            [30.282491603022088, 0.625279523066027],
            [30.282135101211683, 0.627558365126811],
            [30.283168595878053, 0.631432236345726],
            [30.282629791760552, 0.632857622331069],
            [30.282736505328085, 0.635692182227721],
            [30.281722995481836, 0.638714480393621],
            [30.282476461019645, 0.642042952823432],
            [30.28171642789879, 0.644515743057961],
            [30.281688404953496, 0.64625242217323],
            [30.28002380337583, 0.651188818050008],
            [30.281216684326445, 0.652858371725284],
            [30.283064736258165, 0.654035577765833],
            [30.282995656711137, 0.655417847411436],
            [30.282503209255548, 0.656681004300767],
            [30.281287296399356, 0.656829152809153],
            [30.28107941905609, 0.656291474550062],
            [30.2804429159649, 0.656157492427139],
            [30.28018012640493, 0.656737430065401],
            [30.279969219942522, 0.656221011728187],
            [30.27953762166933, 0.656545741274786],
            [30.278611473882773, 0.656445007218398],
            [30.278126948669655, 0.656883194600036],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 409,
        District: "KABAROLE",
        County: "FORT PORTAL MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 16627,
        Key: "KABAROLESOUTHERN DIVISION",
        Dist2: "Kabarole",
        "Sub Country": "South Division",
        id2_original: "Kabarole South Division",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.27448547225693, 0.69323757509463],
            [30.272964233713775, 0.694051134895717],
            [30.270204101612805, 0.693762073746056],
            [30.2673242591188, 0.694754490154976],
            [30.262363415370185, 0.693841331682294],
            [30.259828936475348, 0.694294974563605],
            [30.25736627788747, 0.694006082299744],
            [30.2564146224384, 0.693730052950212],
            [30.253543241176025, 0.690974193230302],
            [30.253280139900667, 0.691380315374469],
            [30.24918470704565, 0.692484233812321],
            [30.243119245416338, 0.692165292289702],
            [30.24341576941017, 0.691061645049143],
            [30.244434436484486, 0.690238755509704],
            [30.245331845368472, 0.688417097672134],
            [30.247161277020993, 0.686653216425351],
            [30.247939976235134, 0.685299546028624],
            [30.250889314196193, 0.685798860394936],
            [30.25173217827445, 0.68560357165518],
            [30.25285134616781, 0.68402984108374],
            [30.252739266963047, 0.681631497925909],
            [30.254773642959442, 0.680882187964421],
            [30.25605498371103, 0.679112762631495],
            [30.25611241031221, 0.677872866358565],
            [30.258155622137725, 0.675826517579396],
            [30.260278974466388, 0.67537091116593],
            [30.262111200777753, 0.673854665462542],
            [30.263408980699026, 0.671359590623089],
            [30.26342125258414, 0.668651259107878],
            [30.266110517490656, 0.664218312881308],
            [30.267606333711257, 0.66342407491795],
            [30.2666679724301, 0.663605391292591],
            [30.264653781578147, 0.66253325642603],
            [30.2643633391788, 0.663230853961792],
            [30.263037418632916, 0.6635319598414],
            [30.26017262022493, 0.662422802470793],
            [30.25806989680848, 0.660622476759867],
            [30.25499367900008, 0.660755603623525],
            [30.253496372474398, 0.660443044816388],
            [30.251431190551973, 0.656955547343697],
            [30.256672898862387, 0.655991721006439],
            [30.259185832563446, 0.654769403180886],
            [30.26163802757489, 0.654518629686168],
            [30.262749768197477, 0.6538926471485],
            [30.265437719767036, 0.653660246555138],
            [30.26699109643778, 0.65385284179727],
            [30.269050530040712, 0.654912630197914],
            [30.271320316743836, 0.654752326424147],
            [30.27304256051833, 0.655798081174257],
            [30.27305724437998, 0.65653305879394],
            [30.2739559944487, 0.657077188303149],
            [30.27544031403031, 0.657099266542562],
            [30.276131779643848, 0.656018452218804],
            [30.278126948669655, 0.656883194600036],
            [30.27896391261314, 0.659903830031516],
            [30.280924263836848, 0.662369509884949],
            [30.280683790225176, 0.663672712812054],
            [30.28134540841509, 0.663885476186371],
            [30.280682224461636, 0.666520742712965],
            [30.280931051507114, 0.66746700882712],
            [30.284160307205635, 0.669217019936957],
            [30.28385002910651, 0.67154970420076],
            [30.284420956978582, 0.671597358349518],
            [30.28527459545039, 0.670576788583232],
            [30.286848047671104, 0.671626767171397],
            [30.28667868290071, 0.673381156677317],
            [30.28734737173021, 0.674589331393957],
            [30.28937198573441, 0.675141399466152],
            [30.29084133758675, 0.674921856566866],
            [30.291300499766155, 0.674396615695637],
            [30.29134764964044, 0.672426123853671],
            [30.297365417016398, 0.668698778546745],
            [30.296630808913022, 0.673823011021183],
            [30.294691795372234, 0.677517250909584],
            [30.29437924094216, 0.679937001459708],
            [30.293394354115797, 0.680272605473385],
            [30.291832956387868, 0.681225422561304],
            [30.29009017173608, 0.681559796778727],
            [30.289496150872985, 0.682169992612762],
            [30.287406944406587, 0.681378364298267],
            [30.285903853628792, 0.681257414696999],
            [30.28496438382658, 0.68332663335087],
            [30.282702863420717, 0.683369761095029],
            [30.27813692535919, 0.685514553186518],
            [30.277967898355328, 0.686621325827972],
            [30.277013078141515, 0.687813379020061],
            [30.27692860416546, 0.689897361175241],
            [30.275773256624074, 0.692088515291231],
            [30.27448547225693, 0.69323757509463],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 410,
        District: "KABAROLE",
        County: "FORT PORTAL MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 18635,
        Key: "KABAROLEWESTERN DIVISION",
        Dist2: "Kabarole",
        "Sub Country": "West Division",
        id2_original: "Kabarole West Division",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.206728641478673, 0.526844477137917],
            [30.20693472039475, 0.52512438544654],
            [30.20768308799333, 0.525400979472095],
            [30.208589552793722, 0.524106330581051],
            [30.209416312773875, 0.523532880849646],
            [30.21021420179911, 0.523791459087058],
            [30.210527974344714, 0.523189089272078],
            [30.21189577345082, 0.523677453267566],
            [30.21249504047516, 0.521956252230906],
            [30.21411991046614, 0.521153629999321],
            [30.214262759664315, 0.520379026760189],
            [30.215488916009683, 0.518916322414744],
            [30.215432328434986, 0.517969484765969],
            [30.216259295027672, 0.516936968253483],
            [30.216302385415215, 0.516162324075767],
            [30.217613865542926, 0.515101326436334],
            [30.218013461334124, 0.513753015830289],
            [30.21767192725299, 0.512662593752802],
            [30.218555860509408, 0.511687479133676],
            [30.21961064884128, 0.51105673241681],
            [30.220379829506683, 0.511831736525591],
            [30.22109242349572, 0.511631205518321],
            [30.2215489302551, 0.510483753102968],
            [30.224485135744988, 0.508964391978797],
            [30.225881710584616, 0.508850232287555],
            [30.228062595515627, 0.507473988350694],
            [30.22854694465894, 0.507847186870705],
            [30.229430745863024, 0.507187671459886],
            [30.229629787377167, 0.508278030687867],
            [30.230655760449682, 0.508393244969839],
            [30.231853281198738, 0.507246103681111],
            [30.232594252967584, 0.507361185036017],
            [30.232680278334126, 0.506127482586558],
            [30.23369296981518, 0.503976046271062],
            [30.23571716610277, 0.502456251548345],
            [30.236344218917164, 0.502370448669579],
            [30.236430980902263, 0.49938654167608],
            [30.23717268928963, 0.497751426322249],
            [30.23925338691365, 0.497408007051468],
            [30.240535542437208, 0.498326689289845],
            [30.240934654036472, 0.498097323035054],
            [30.241862162770698, 0.494780356377094],
            [30.241719888494305, 0.494235152307133],
            [30.23992439159997, 0.494090941236936],
            [30.23958252424384, 0.493746491446968],
            [30.239383904039602, 0.491623216722488],
            [30.239398533103998, 0.490690735041379],
            [30.240453654710834, 0.489256581318235],
            [30.24102437147882, 0.487564003919582],
            [30.24025563098793, 0.485641329108418],
            [30.239914637692582, 0.483145001046837],
            [30.24000032798754, 0.482685963868879],
            [30.24075163397543, 0.482287356883341],
            [30.243563359018093, 0.483442076817193],
            [30.244083342532075, 0.481224096397235],
            [30.245317806497198, 0.481510198819454],
            [30.24659901789141, 0.481056986002271],
            [30.248094467599394, 0.481247687121071],
            [30.249280249164315, 0.480293648791538],
            [30.250262103278278, 0.477109733499014],
            [30.251751313288324, 0.475606619214081],
            [30.25230814928853, 0.475641822977115],
            [30.253949701892644, 0.477482829518108],
            [30.256144198096838, 0.477279763413634],
            [30.257403036948904, 0.477743027381104],
            [30.257845376377958, 0.47623779777501],
            [30.2607824325724, 0.472018532894495],
            [30.263399434302507, 0.472605817099559],
            [30.26575175641732, 0.47203467237749],
            [30.267379336625474, 0.473171502898895],
            [30.268971229462373, 0.476160413281034],
            [30.27187002820553, 0.477095425629241],
            [30.27301052210371, 0.478076429992009],
            [30.27324810583512, 0.478817523245413],
            [30.272214464743357, 0.480214513588303],
            [30.273283627018085, 0.482796642264796],
            [30.27497063617222, 0.48334804811311],
            [30.27387760296542, 0.484063866697217],
            [30.27266579990164, 0.484086517806977],
            [30.2707649027767, 0.484825406918653],
            [30.27070260640839, 0.485531583176677],
            [30.27055099953451, 0.486259091784078],
            [30.271952860061262, 0.487216474480105],
            [30.27207159308729, 0.48917626048675],
            [30.271501241933617, 0.49139822307389],
            [30.272035757493974, 0.493776662940353],
            [30.27262976039076, 0.494303050737972],
            [30.272938600287137, 0.495474393104902],
            [30.27251327494957, 0.497052184292159],
            [30.27061539975723, 0.497925254547517],
            [30.270049327279263, 0.501314145873212],
            [30.26884624326365, 0.504973356766585],
            [30.26765717745804, 0.504830517606256],
            [30.26646819429743, 0.506966054080594],
            [30.26771394110253, 0.508732263887641],
            [30.26653905430534, 0.509429576059031],
            [30.26563317520653, 0.511736101204196],
            [30.264076126222882, 0.513558215006189],
            [30.26274548053863, 0.512589399258182],
            [30.262235904007188, 0.513329680198018],
            [30.259829473667878, 0.513328775630847],
            [30.260197573626908, 0.515350959956996],
            [30.258017669656162, 0.516717147768681],
            [30.25804599982529, 0.517315234310535],
            [30.25879623951292, 0.51738671483521],
            [30.258767954259586, 0.518070216826431],
            [30.258598090025867, 0.518411904016617],
            [30.25789031460003, 0.518155318838558],
            [30.25740903679668, 0.518582328108751],
            [30.258116836477008, 0.519436978052443],
            [30.25800360114052, 0.520063484963946],
            [30.256673030016398, 0.521572387484499],
            [30.25588032606697, 0.521686007082663],
            [30.255200897878236, 0.523166672748737],
            [30.256106855130493, 0.523736608451079],
            [30.25483289314063, 0.524875294872114],
            [30.25459227579852, 0.526427332413008],
            [30.253573077819887, 0.526056700465258],
            [30.252780395430026, 0.526768376880513],
            [30.25201597673394, 0.52562890840471],
            [30.251591315251357, 0.525628736833718],
            [30.251166675328346, 0.526938629174905],
            [30.25136487152782, 0.527992442194904],
            [30.24891049540686, 0.528649163595893],
            [30.248682865907117, 0.530785831960037],
            [30.247982179087213, 0.530868497672786],
            [30.247652000609584, 0.531905615554761],
            [30.247651805675147, 0.532341267102101],
            [30.247940225068465, 0.532528105020466],
            [30.248352585021557, 0.532051148933948],
            [30.24911459533436, 0.533088759770916],
            [30.25071379327112, 0.533033028007841],
            [30.250869514429006, 0.533474520966591],
            [30.252313366703707, 0.533959238049868],
            [30.252511561106516, 0.535126967453218],
            [30.253219332939103, 0.535440528684894],
            [30.253275959141337, 0.535867736187408],
            [30.25497460596997, 0.535669059990861],
            [30.255937189424472, 0.536267504923452],
            [30.256163680758718, 0.536837187004785],
            [30.257890651468273, 0.536666998760968],
            [30.25774910842051, 0.537920037789673],
            [30.26032540389184, 0.538063459180129],
            [30.261486155698005, 0.537437372681537],
            [30.2616277185087, 0.537978537095706],
            [30.263000807793507, 0.538278123707053],
            [30.26368028718621, 0.538876462387561],
            [30.264303122410364, 0.538905197324157],
            [30.264388055425503, 0.538534993705765],
            [30.26503922081879, 0.538905490161991],
            [30.265435567403586, 0.538706291267822],
            [30.26639817151935, 0.540187611293782],
            [30.265860269310366, 0.542095541569794],
            [30.266200015744076, 0.543177900061649],
            [30.266907795661506, 0.543377542556786],
            [30.26748817830193, 0.545414078698334],
            [30.268422466621615, 0.546468211015687],
            [30.26862065293959, 0.548006195868207],
            [30.270007897876663, 0.549772504496043],
            [30.269979596453638, 0.551310399569733],
            [30.270489204426113, 0.552250443819305],
            [30.27048919634127, 0.555724978392831],
            [30.272966435484527, 0.557363589861052],
            [30.273532659777803, 0.559328935819537],
            [30.274948232189008, 0.559956074599002],
            [30.276816778285646, 0.561637165074594],
            [30.277269752869344, 0.563573991265107],
            [30.280044286760944, 0.56388842951346],
            [30.281389089894088, 0.563618433263638],
            [30.285607529959275, 0.564702432563746],
            [30.286881543153115, 0.565699758343633],
            [30.289514542081797, 0.565586939035297],
            [30.29025065845653, 0.565872043221589],
            [30.29163791686832, 0.567467515962803],
            [30.292529718468327, 0.571127618821843],
            [30.290802621096315, 0.575883094035563],
            [30.288260109466226, 0.579593932951058],
            [30.288307592615507, 0.580334575720742],
            [30.28735759994803, 0.580692531496157],
            [30.28659757221709, 0.582101772788552],
            [30.28564756876981, 0.582483621505484],
            [30.285552558453794, 0.582913618302368],
            [30.283177600590495, 0.582171973402763],
            [30.281028271678757, 0.580964557030445],
            [30.279270769927656, 0.581489399475081],
            [30.278724563692204, 0.580509638505059],
            [30.27801207660269, 0.580270427621658],
            [30.277204581892114, 0.580652333951633],
            [30.276753313209145, 0.581703343796848],
            [30.27494833998686, 0.581559211146438],
            [30.272763352449946, 0.582824466920359],
            [30.272217071654296, 0.584305455984071],
            [30.27113644957146, 0.585033659811448],
            [30.270091429519994, 0.586442755395137],
            [30.265222747529627, 0.587874059402169],
            [30.26479524018425, 0.588447244183321],
            [30.264676451462638, 0.589713390382325],
            [30.263524554350226, 0.591158268167728],
            [30.25960585963746, 0.592542181976068],
            [30.257848412683614, 0.592469724146491],
            [30.25713591750926, 0.592899437220464],
            [30.25656586729121, 0.594523729522626],
            [30.254238393475518, 0.595980007751912],
            [30.245313354446647, 0.595945821518224],
            [30.244577918994917, 0.596074195504546],
            [30.24387397129051, 0.597168180900872],
            [30.242818593663806, 0.597714814659986],
            [30.240741043736545, 0.59636192827718],
            [30.24003750835884, 0.596619063380285],
            [30.23666552922631, 0.594364302411856],
            [30.235866785004898, 0.593237389579436],
            [30.233149280659127, 0.592914146345639],
            [30.229649621280316, 0.590273114434116],
            [30.227475533901043, 0.590207650486642],
            [30.225269736890564, 0.589627190816307],
            [30.2238408218024, 0.590099296953497],
            [30.222381369384504, 0.58967240691821],
            [30.22047172446529, 0.589843585301714],
            [30.218386869438167, 0.588279908547147],
            [30.21747785252406, 0.586944110311013],
            [30.22070028372136, 0.585648540704359],
            [30.2236947719069, 0.585421125201539],
            [30.222292965279077, 0.584161382685955],
            [30.222104500529095, 0.58202473634687],
            [30.22999042143786, 0.577984446088616],
            [30.231848612654186, 0.576115864508835],
            [30.235261077958267, 0.573790198422172],
            [30.234390522413086, 0.571233513253594],
            [30.23423984080396, 0.569287630560445],
            [30.235000010468735, 0.564900388277788],
            [30.235682749847605, 0.563908735845241],
            [30.23663041587847, 0.563756578485365],
            [30.236896447458292, 0.562268731189553],
            [30.2356458389709, 0.561810293550242],
            [30.235305083729113, 0.561008914414105],
            [30.235950633753507, 0.558491113424506],
            [30.235837406501858, 0.55746092400389],
            [30.23360194622239, 0.555628512851361],
            [30.232464962042, 0.555360902034696],
            [30.231025144101228, 0.554253782150046],
            [30.229281794409136, 0.553795122012572],
            [30.22333131803452, 0.553029247840137],
            [30.222535224741513, 0.553295939828487],
            [30.221284648593453, 0.552799361697214],
            [30.221777872193467, 0.551769471308439],
            [30.221551022431406, 0.550548478380253],
            [30.22181685907679, 0.549442174130087],
            [30.219581827293702, 0.546732283929029],
            [30.217421669191225, 0.546044524597119],
            [30.21673967810901, 0.54547191770018],
            [30.216020646792675, 0.543029817643329],
            [30.21524196644313, 0.542424435099331],
            [30.21342075437545, 0.538777496674248],
            [30.211363896242467, 0.536077494408098],
            [30.210859494905375, 0.533212483869901],
            [30.209683693623237, 0.532667399854934],
            [30.209390024475415, 0.531909638935512],
            [30.207344122195597, 0.530985346406372],
            [30.207380065586758, 0.529517464178792],
            [30.206227867538725, 0.528794827301845],
            [30.206322205914915, 0.528226651786276],
            [30.207133958639922, 0.527599613012477],
            [30.206728641478673, 0.526844477137917],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 411,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "BUHEESI",
        Population: 22139,
        Key: "BUNYANGABUBUHEESI",
        Dist2: "Kabarole",
        "Sub Country": "Buheesi",
        id2_original: "Kabarole Buheesi",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.138682422923228, 0.510778401390661],
            [30.13372903249653, 0.510516687627228],
            [30.13207650697124, 0.509683957209142],
            [30.1305374781922, 0.509941461667741],
            [30.12791625977015, 0.508591889690225],
            [30.12637731363611, 0.508677265803847],
            [30.125151415107208, 0.50976689807196],
            [30.12299836806852, 0.510812815379866],
            [30.12171511749864, 0.512677007542805],
            [30.121244007726006, 0.514656327996066],
            [30.120189253530086, 0.515401760326077],
            [30.119732810551064, 0.516463030992149],
            [30.11810829539464, 0.516749183083763],
            [30.116911020783952, 0.517523220851833],
            [30.116626050023022, 0.517523089703173],
            [30.116512495784562, 0.516547621006926],
            [30.11483051719604, 0.517895219584223],
            [30.112579030971915, 0.518238453619505],
            [30.106978156447973, 0.520588318399021],
            [30.105301459055013, 0.522224563375088],
            [30.105509444196127, 0.525558868810718],
            [30.104753419358055, 0.525888428848553],
            [30.09894732291084, 0.526111190871671],
            [30.098505431741135, 0.526498274766019],
            [30.098989548220768, 0.527230054575773],
            [30.095854159282926, 0.528662987181346],
            [30.095154998700654, 0.530742552088393],
            [30.091976684665273, 0.532562736273631],
            [30.090793524384345, 0.533666664070502],
            [30.090166013429165, 0.534871262375515],
            [30.089211204893445, 0.535186373146521],
            [30.0883564228663, 0.534899081089291],
            [30.085962294954836, 0.535658163004418],
            [30.084451508310007, 0.536575449177589],
            [30.083795546811416, 0.537679618786796],
            [30.082670327866314, 0.536804092725708],
            [30.081686992430466, 0.537190903772126],
            [30.07969240281799, 0.536759620884344],
            [30.075103007947785, 0.53964051576309],
            [30.07508724520952, 0.542781812012237],
            [30.07432476777276, 0.544185712333811],
            [30.073537218356442, 0.544003912297638],
            [30.072625667294925, 0.541246478433317],
            [30.071028338752253, 0.540786200405303],
            [30.070803533555758, 0.533663885701835],
            [30.071489397275194, 0.531136985393903],
            [30.068358954461303, 0.527461060939243],
            [30.065332618303998, 0.52521767785791],
            [30.062136509541148, 0.522402109810047],
            [30.060144778367935, 0.521370978268632],
            [30.05460597653183, 0.521020068616826],
            [30.051374893660018, 0.520209605195041],
            [30.050044114126766, 0.515733794754863],
            [30.048447877935498, 0.512976112991542],
            [30.043201481317634, 0.507459835050246],
            [30.04228998056175, 0.504472763048685],
            [30.038867996708927, 0.49838823593165],
            [30.038608095232625, 0.495030222434938],
            [30.037796744054518, 0.493279957931248],
            [30.032555114795883, 0.489720462486828],
            [30.018070508474835, 0.482547238367774],
            [30.00823969455175, 0.477632710911817],
            [30.003040827795584, 0.474302864477941],
            [30.000733608294578, 0.47232253132824],
            [29.999878388787874, 0.473211413685833],
            [29.998596621336528, 0.472063421084101],
            [29.995409105857707, 0.462997366332771],
            [29.99213790063204, 0.449456385344581],
            [29.989548310992827, 0.441136513229784],
            [29.981713222152724, 0.425583958511519],
            [29.9839778974419, 0.426048310010641],
            [29.985953740112684, 0.42557803518393],
            [29.989904621462085, 0.426678732916675],
            [29.993542513596825, 0.430501015001772],
            [29.996454544524095, 0.42919367337363],
            [29.99931430697658, 0.428619063237811],
            [29.999859296893163, 0.427415216906265],
            [30.00114568348168, 0.426463422591913],
            [30.00321083935299, 0.427202412832096],
            [30.0048503707477, 0.429443621686243],
            [30.007153217249904, 0.430587952398712],
            [30.01428486323877, 0.431600790381754],
            [30.015494563346476, 0.43109997134603],
            [30.019660243558413, 0.432279943250928],
            [30.021845233790255, 0.434187321990201],
            [30.02210732356261, 0.435260294575888],
            [30.023864835195184, 0.436810043886591],
            [30.026119496963844, 0.43716755578477],
            [30.027223917215185, 0.438180863589446],
            [30.029383387208156, 0.438252239837589],
            [30.030809562434666, 0.440684276977162],
            [30.032234150338116, 0.44149489087127],
            [30.032663238718424, 0.443497802031888],
            [30.035858649490294, 0.447324644251364],
            [30.036264856881964, 0.450185970041852],
            [30.03748883750773, 0.45212923255554],
            [30.03775205286912, 0.454370606379415],
            [30.04164514559631, 0.455801063667676],
            [30.042476969379738, 0.457112474330214],
            [30.04417439899114, 0.457863498560192],
            [30.04524394215157, 0.459604110092394],
            [30.04688052707216, 0.45879328980877],
            [30.04790222146897, 0.46012854673078],
            [30.04920728133732, 0.460033097520979],
            [30.04996618527586, 0.459556158666826],
            [30.05101048308186, 0.459723014463311],
            [30.052270139400818, 0.461749770097635],
            [30.053611563071875, 0.4624292750016],
            [30.05453867654738, 0.464122219677824],
            [30.057909294732273, 0.465075848814032],
            [30.058266198089584, 0.466053485401486],
            [30.059784645567156, 0.465743419674466],
            [30.061648504254645, 0.466804437721969],
            [30.062669055096105, 0.466947460038208],
            [30.06549208633491, 0.466017347373093],
            [30.06717916555762, 0.468306408595331],
            [30.066586652965892, 0.469093329809999],
            [30.06822803219516, 0.473218489473963],
            [30.069034334841344, 0.472646159066418],
            [30.070410826944464, 0.472765325516268],
            [30.071121384452745, 0.471358423786243],
            [30.071773672740107, 0.471036475780969],
            [30.07255798552648, 0.472276397219361],
            [30.07336514516546, 0.472610196237595],
            [30.07806177193112, 0.470463877505013],
            [30.079889825567996, 0.471274540146566],
            [30.08128845575298, 0.469724508962827],
            [30.082321224580603, 0.470213296408115],
            [30.082702664521598, 0.472025540414211],
            [30.083391756786174, 0.472955486097438],
            [30.085575710362196, 0.473694592895534],
            [30.08768906264511, 0.475029851478968],
            [30.08880441180017, 0.47502980117506],
            [30.089397142682532, 0.474457473611982],
            [30.091971793338576, 0.474278509290121],
            [30.09393906967481, 0.471774605449248],
            [30.094603471743756, 0.471703031910062],
            [30.096004329750645, 0.472442187348816],
            [30.097214045129697, 0.471845976873639],
            [30.09975446188856, 0.473061993016204],
            [30.103018078146714, 0.473646063969012],
            [30.104301256851375, 0.475386761424718],
            [30.10698402244678, 0.476555084341794],
            [30.111532216086484, 0.480310645217812],
            [30.112077813264204, 0.48007216076714],
            [30.11262252380469, 0.478903679451819],
            [30.11537557448627, 0.479094315954242],
            [30.116347000058095, 0.477472722025518],
            [30.119646699844566, 0.478497950650364],
            [30.121153128761947, 0.477937487910907],
            [30.123004773954825, 0.478533562219498],
            [30.125260357394975, 0.479630397380016],
            [30.12576023122303, 0.481204238041653],
            [30.128110311142887, 0.481847985768603],
            [30.130517623627785, 0.480309769391184],
            [30.133765712506218, 0.476994919310803],
            [30.134831445911523, 0.474705580680456],
            [30.13507887697508, 0.472905139935849],
            [30.137140977676093, 0.470234197704232],
            [30.137328681553004, 0.468016433118781],
            [30.13805083990487, 0.466311350844486],
            [30.137479108938923, 0.464093637121506],
            [30.13890289195184, 0.463950467428534],
            [30.139162099030447, 0.462066547993189],
            [30.138401694007058, 0.461065037103062],
            [30.13966776968704, 0.457404466905992],
            [30.143321359881355, 0.456235710530735],
            [30.146178177656353, 0.453290416136544],
            [30.147767411479983, 0.452455650396205],
            [30.149047729050483, 0.451215517098286],
            [30.15056638044563, 0.451000776095708],
            [30.15191767121174, 0.449545995824639],
            [30.153745494879928, 0.44997510332326],
            [30.15491954804051, 0.44927152762611],
            [30.160074321889283, 0.442224259869874],
            [30.159218787073936, 0.441055817264271],
            [30.159834325283036, 0.439553391586807],
            [30.16086560021235, 0.438468249595079],
            [30.162145861188964, 0.437180386048489],
            [30.163530651030367, 0.433638937795105],
            [30.165286182776033, 0.432971050497843],
            [30.166779835853458, 0.431492378480211],
            [30.168666351849033, 0.431265634857831],
            [30.169045513662457, 0.430717115708178],
            [30.16911440097001, 0.428427757975692],
            [30.171321512215776, 0.428403683799083],
            [30.173419617393353, 0.426197587017683],
            [30.174871514081428, 0.425410469868149],
            [30.17473918146028, 0.426796172704568],
            [30.17414639667902, 0.427320882052665],
            [30.174551230546665, 0.428680153255656],
            [30.17381693685364, 0.430087225820308],
            [30.17396167071726, 0.432400417375364],
            [30.17278715672093, 0.432650927912113],
            [30.17247966968739, 0.433676400960938],
            [30.171530525029567, 0.433843420833707],
            [30.170630129247236, 0.435274352804389],
            [30.17079721948335, 0.436228236335909],
            [30.16972949002146, 0.436466809380311],
            [30.170741145744998, 0.439483423868025],
            [30.17044438639256, 0.440995156728531],
            [30.17209702151233, 0.442583472867165],
            [30.173450245452962, 0.443036456380123],
            [30.173404348728457, 0.444610397673037],
            [30.17412975628669, 0.446172350078112],
            [30.1730153458711, 0.447197894030106],
            [30.172992265456504, 0.447865628241903],
            [30.175463327783856, 0.450727122698687],
            [30.177353561906386, 0.454220631068986],
            [30.180714936427012, 0.457427897815179],
            [30.183080642541213, 0.461756067981559],
            [30.18371255883456, 0.464796605023912],
            [30.18357173084579, 0.466394412612378],
            [30.18265256117235, 0.468438806861191],
            [30.177977866774324, 0.47184547563069],
            [30.176359213125124, 0.475077227896897],
            [30.176072691872005, 0.477782761179674],
            [30.174335328552967, 0.480463742405319],
            [30.171908204622778, 0.483168367193194],
            [30.171043912131733, 0.485318209513795],
            [30.16938608115635, 0.485413675443418],
            [30.16531467194695, 0.484114194811281],
            [30.16434188542749, 0.484376560877094],
            [30.160784062828935, 0.48652299472875],
            [30.1603593267862, 0.489074662035418],
            [30.159315026285277, 0.490933026037942],
            [30.15743318961401, 0.493083946509664],
            [30.153870405620196, 0.494086546841966],
            [30.153015118739848, 0.494860788528033],
            [30.151403542018446, 0.49810202823271],
            [30.15128885500444, 0.499708597023816],
            [30.152313295551103, 0.503180491254828],
            [30.152212849529292, 0.504787075866957],
            [30.151613612149323, 0.506536878282381],
            [30.14978846815568, 0.50931896368294],
            [30.145598469650686, 0.51089500257156],
            [30.141452227184843, 0.510233283992433],
            [30.138682422923228, 0.510778401390661],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 412,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KABONERO",
        Population: 19354,
        Key: "BUNYANGABUKABONERO",
        Dist2: "Kabarole",
        "Sub Country": "Kabonero",
        id2_original: "Kabarole Kabonero",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.1483605043834, 0.612015006603688],
            [30.144449890914927, 0.614018546435452],
            [30.142027390613503, 0.614160684088446],
            [30.139888798366073, 0.616368610359268],
            [30.139062404000203, 0.61619602073987],
            [30.135057487189858, 0.617743060829748],
            [30.127458729829645, 0.619237157757202],
            [30.122965444813367, 0.621032828844612],
            [30.121597847828212, 0.621610370290244],
            [30.119569229134445, 0.623592581762107],
            [30.11029274491197, 0.614196858064846],
            [30.10826713467612, 0.612897664128184],
            [30.10565153162293, 0.612562432034469],
            [30.100863329698864, 0.610297460816136],
            [30.09660848450846, 0.609590474647562],
            [30.095724663541475, 0.608885322642397],
            [30.095360471253915, 0.600985433098419],
            [30.09302373850257, 0.595903173612041],
            [30.094351169116443, 0.593715706027842],
            [30.09472028327343, 0.592380747180848],
            [30.094096570395244, 0.587410658192463],
            [30.094723817245743, 0.585593694234757],
            [30.094835502988406, 0.583368489923889],
            [30.09436526907315, 0.582238830659272],
            [30.09445944665088, 0.579974183816426],
            [30.09298538852478, 0.579262322448725],
            [30.086121594102494, 0.578665245458618],
            [30.08891651525942, 0.575899795567944],
            [30.090353120824737, 0.575521679617618],
            [30.093335672196776, 0.573562829153241],
            [30.094359683348696, 0.57194630802829],
            [30.105013628058195, 0.564176571738082],
            [30.10665386912198, 0.562327741373684],
            [30.108040521170967, 0.561564207412046],
            [30.109768711792675, 0.55984832143591],
            [30.11647780823821, 0.55963460446248],
            [30.116752504967238, 0.558680462999373],
            [30.11997964692988, 0.555360598418374],
            [30.123662669526198, 0.554088927447196],
            [30.127654944345558, 0.551318018727246],
            [30.128683231478256, 0.551389512330384],
            [30.129542292181075, 0.550788398328243],
            [30.131130861251414, 0.550786940429919],
            [30.132241250807837, 0.551813819975598],
            [30.134549645305214, 0.551757568284557],
            [30.13546173715252, 0.551471120494263],
            [30.13833932487521, 0.549322785432502],
            [30.140069935558273, 0.548912129579257],
            [30.1422224633707, 0.549489265245041],
            [30.14291759231397, 0.548995806502134],
            [30.14359874796299, 0.549229317327481],
            [30.144660884513918, 0.550574054930492],
            [30.150165575522042, 0.550521855340928],
            [30.152279146993877, 0.548772499162974],
            [30.15403608280634, 0.548685691751772],
            [30.156952784973118, 0.546903923501508],
            [30.158697589935976, 0.545341051669078],
            [30.160290496072502, 0.542657525787105],
            [30.160801454212844, 0.542503483301278],
            [30.165568412777056, 0.543712327801229],
            [30.163467353938817, 0.545284323831628],
            [30.159980360805513, 0.556684248574906],
            [30.159286376315915, 0.560565751796345],
            [30.157925618204995, 0.563152975735516],
            [30.158773943141874, 0.56714319422953],
            [30.15859110184558, 0.571077494420794],
            [30.15822224011518, 0.572167528699832],
            [30.156540537309432, 0.572654410149818],
            [30.15554240482423, 0.574002318647061],
            [30.15350427027668, 0.574890688048666],
            [30.152020812179412, 0.577902343350411],
            [30.149319501763255, 0.579865844457984],
            [30.14754781830878, 0.582374793536898],
            [30.1473397918452, 0.584535967863756],
            [30.149512401495812, 0.584901639498452],
            [30.151115750547532, 0.585657613214772],
            [30.152175661971448, 0.586882022016195],
            [30.15282128206448, 0.588939486890457],
            [30.15393335326707, 0.589330658262644],
            [30.15682934118171, 0.591467414993283],
            [30.157889442150182, 0.592327277821223],
            [30.15807017689714, 0.592978366161168],
            [30.162647631360596, 0.594907694604163],
            [30.16156036264297, 0.596573679359283],
            [30.16047364189767, 0.597172028176232],
            [30.16049864740194, 0.598838591627162],
            [30.158712749904723, 0.600920838799544],
            [30.15798633174179, 0.605034741363005],
            [30.156828358424782, 0.608419214040703],
            [30.155371408713233, 0.609538226197768],
            [30.149937778037344, 0.610743487659719],
            [30.1483605043834, 0.612015006603688],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 413,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KYAMUKUBE TOWN COUNCIL",
        Population: 11511,
        Key: "BUNYANGABUKYAMUKUBE TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Ruteete",
        id2_original: "Kabarole Ruteete",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.2607824325724, 0.472018532894495],
            [30.257845376377958, 0.47623779777501],
            [30.257403036948904, 0.477743027381104],
            [30.256144198096838, 0.477279763413634],
            [30.253949701892644, 0.477482829518108],
            [30.25230814928853, 0.475641822977115],
            [30.251751313288324, 0.475606619214081],
            [30.250262103278278, 0.477109733499014],
            [30.249280249164315, 0.480293648791538],
            [30.248094467599394, 0.481247687121071],
            [30.24659901789141, 0.481056986002271],
            [30.245317806497198, 0.481510198819454],
            [30.244083342532075, 0.481224096397235],
            [30.243563359018093, 0.483442076817193],
            [30.24075163397543, 0.482287356883341],
            [30.240533593991337, 0.479709917055492],
            [30.240913010926338, 0.479376009688509],
            [30.239890783828553, 0.477682806417698],
            [30.24038709403986, 0.475536369785584],
            [30.23969841859361, 0.475154839668969],
            [30.239177234032077, 0.476132676059507],
            [30.23853648011295, 0.476204270213472],
            [30.23695733526826, 0.475357744144873],
            [30.236220193017473, 0.473950709096385],
            [30.234584889992803, 0.473590623640492],
            [30.233370530323718, 0.472353038875239],
            [30.2320172192465, 0.471876163735041],
            [30.227022121837795, 0.472794683256885],
            [30.22417265407848, 0.471363959017706],
            [30.220421649676425, 0.470291042977302],
            [30.218342828633034, 0.468132900300344],
            [30.217673805630252, 0.463601751961107],
            [30.218206012520337, 0.461777305261771],
            [30.219795627229665, 0.461228675203127],
            [30.22064873389879, 0.459916942809721],
            [30.220456645344946, 0.457675199720398],
            [30.22122553315956, 0.455206820835614],
            [30.221506743572743, 0.451605673859622],
            [30.219792095952272, 0.444108089246067],
            [30.217684428208496, 0.440801495568718],
            [30.216543073724225, 0.440261635718788],
            [30.2135845028787, 0.439861810074014],
            [30.210346510165746, 0.440176760006121],
            [30.21116252180353, 0.441293098415659],
            [30.21121813201118, 0.442383436595172],
            [30.208839529682784, 0.44627666826832],
            [30.20584034510492, 0.449365269333326],
            [30.205438651747528, 0.451153915241057],
            [30.201855277469075, 0.451511938469208],
            [30.19991022096138, 0.452585270553917],
            [30.199151886554734, 0.453730028881955],
            [30.196340339378498, 0.454576862063065],
            [30.194085863561096, 0.4547678235066],
            [30.190908374179116, 0.457534430120313],
            [30.188262386509773, 0.457785030530314],
            [30.184440646067298, 0.457069882964723],
            [30.180714936427012, 0.457427897815179],
            [30.177353561906386, 0.454220631068986],
            [30.175463327783856, 0.450727122698687],
            [30.172992265456504, 0.447865628241903],
            [30.1730153458711, 0.447197894030106],
            [30.17412975628669, 0.446172350078112],
            [30.173404348728457, 0.444610397673037],
            [30.173450245452962, 0.443036456380123],
            [30.17209702151233, 0.442583472867165],
            [30.17044438639256, 0.440995156728531],
            [30.170741145744998, 0.439483423868025],
            [30.16972949002146, 0.436466809380311],
            [30.17079721948335, 0.436228236335909],
            [30.170630129247236, 0.435274352804389],
            [30.171530525029567, 0.433843420833707],
            [30.17247966968739, 0.433676400960938],
            [30.17278715672093, 0.432650927912113],
            [30.17396167071726, 0.432400417375364],
            [30.17381693685364, 0.430087225820308],
            [30.174551230546665, 0.428680153255656],
            [30.17414639667902, 0.427320882052665],
            [30.17473918146028, 0.426796172704568],
            [30.174871514081428, 0.425410469868149],
            [30.175768258212127, 0.425314991466154],
            [30.176313382875975, 0.424599503920765],
            [30.17620254244801, 0.420628893089726],
            [30.179059425800002, 0.417778806320365],
            [30.178559300443688, 0.416085676857139],
            [30.178628692604406, 0.414320952276349],
            [30.179863004754253, 0.413092291118218],
            [30.18170017179968, 0.413919755387129],
            [30.188297599570596, 0.413543812157443],
            [30.19351651223233, 0.414932860540365],
            [30.195019705418062, 0.41493340131197],
            [30.198778173023513, 0.413589606179325],
            [30.201199935808045, 0.413758616201579],
            [30.2038719710274, 0.414684363400923],
            [30.205291637061418, 0.41476894385734],
            [30.209008112918877, 0.414181767350911],
            [30.210928796336287, 0.414434670627323],
            [30.212348677067606, 0.413930742394642],
            [30.214520550998035, 0.412334132687827],
            [30.21674685474982, 0.411811767775283],
            [30.21516267125468, 0.415896881113406],
            [30.21533117993064, 0.418198147600457],
            [30.214963910014927, 0.419334412423114],
            [30.215019874158802, 0.420669700656664],
            [30.21600100333234, 0.421645343511742],
            [30.21603274709954, 0.426758015126495],
            [30.219183055257613, 0.432792450753901],
            [30.223100215647907, 0.437157394338055],
            [30.227841070966555, 0.441310024868487],
            [30.230149761908013, 0.439973019126442],
            [30.232982770734708, 0.439375559137763],
            [30.23557066435466, 0.439622982921962],
            [30.23871772600129, 0.440962050299317],
            [30.24088594378849, 0.441244526152195],
            [30.25005041438327, 0.437128642797599],
            [30.25151923802625, 0.437270019134326],
            [30.253267386518605, 0.438678988186772],
            [30.25667738684552, 0.442845478461143],
            [30.256913206285727, 0.445474867104467],
            [30.256057827777244, 0.446621116807089],
            [30.257293359839213, 0.447482687227349],
            [30.256818141172456, 0.448868298857039],
            [30.257138895424436, 0.450959696512001],
            [30.256449795973356, 0.455260661459301],
            [30.257245752722433, 0.456444418483942],
            [30.257198222860744, 0.457591482999616],
            [30.25857632025327, 0.45828591333054],
            [30.257340741478888, 0.460220413573513],
            [30.257281254142463, 0.46505972009445],
            [30.259015734767747, 0.46659095568536],
            [30.259764077213507, 0.471526683322672],
            [30.2607824325724, 0.472018532894495],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 414,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KIBIITO",
        Population: 18797,
        Key: "BUNYANGABUKIBIITO",
        Dist2: "Kabarole",
        "Sub Country": "Kibiito",
        id2_original: "Kabarole Kibiito",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.234584889992803, 0.473590623640492],
            [30.233360391039117, 0.474105927275206],
            [30.23262451990445, 0.473986730306737],
            [30.232198391473016, 0.475107649196445],
            [30.231011752915297, 0.475155425350369],
            [30.23084513698965, 0.474678464167643],
            [30.230085660824294, 0.47467851716642],
            [30.230181129281092, 0.47522702490417],
            [30.230679545143463, 0.475226996159085],
            [30.230205523032645, 0.475894801398776],
            [30.230467975724363, 0.477301852220025],
            [30.22966108557997, 0.477373441870404],
            [30.22890392796633, 0.479758353416024],
            [30.228120817125838, 0.479877662570008],
            [30.228193288711374, 0.481165464528141],
            [30.227694989630027, 0.481284742217629],
            [30.227850360444908, 0.482417545103893],
            [30.226973231926767, 0.483466934112823],
            [30.227139834377688, 0.483943895581809],
            [30.226429072951834, 0.485231760548294],
            [30.225361248268552, 0.485446461876225],
            [30.22514706295537, 0.484850259717787],
            [30.225076175997977, 0.485184144359136],
            [30.224221490090592, 0.484898011550031],
            [30.2213737884191, 0.485279748626276],
            [30.221089612667164, 0.485923674725048],
            [30.219417175983608, 0.486746539610502],
            [30.219014699295286, 0.487772048],
            [30.217922638065616, 0.48746207936724],
            [30.21768606404061, 0.488249091807075],
            [30.21569277698532, 0.488606920003485],
            [30.214329752424955, 0.49033600423385],
            [30.214044515762648, 0.489882899802395],
            [30.21366513745526, 0.490264491074232],
            [30.21311908303505, 0.490073732719746],
            [30.21295331422073, 0.490455311404778],
            [30.21181410581173, 0.490455367098291],
            [30.21164750964902, 0.489978412377958],
            [30.21129198969724, 0.490479243443707],
            [30.209653652163507, 0.489740036061855],
            [30.20834819703643, 0.489644711223932],
            [30.207801851562095, 0.4891439268065],
            [30.207871775525494, 0.487832267077491],
            [30.207254364329046, 0.487474575378888],
            [30.206259422659702, 0.489406332201103],
            [30.20602162692591, 0.488929376507868],
            [30.20554692748538, 0.488905552257301],
            [30.20559377013586, 0.488261656086762],
            [30.205142786218836, 0.488213977937513],
            [30.205023594153655, 0.487665479329002],
            [30.202722207413803, 0.488452583369884],
            [30.20281653411189, 0.487832536562319],
            [30.20212773918969, 0.487284058583208],
            [30.200680900915003, 0.488214216880699],
            [30.19901788306718, 0.486473387055512],
            [30.197569658691975, 0.485972662587057],
            [30.19571908159598, 0.486616655991032],
            [30.194604699926487, 0.487737567417252],
            [30.19139976521595, 0.486759963549658],
            [30.19040303679752, 0.486831561185154],
            [30.187925224529113, 0.48922838422944],
            [30.185694436387447, 0.48937158393854],
            [30.182730207053936, 0.491875731034739],
            [30.180676550516605, 0.491100776663799],
            [30.176476118079595, 0.491410987664592],
            [30.17502767721042, 0.490647945361924],
            [30.175287602042943, 0.489455546404941],
            [30.17633019484652, 0.487738466598266],
            [30.1763861769567, 0.486738612264182],
            [30.173611701455613, 0.486629690973966],
            [30.171043912131733, 0.485318209513795],
            [30.171908204622778, 0.483168367193194],
            [30.174335328552967, 0.480463742405319],
            [30.176072691872005, 0.477782761179674],
            [30.176359213125124, 0.475077227896897],
            [30.177977866774324, 0.47184547563069],
            [30.18265256117235, 0.468438806861191],
            [30.18357173084579, 0.466394412612378],
            [30.18371255883456, 0.464796605023912],
            [30.183080642541213, 0.461756067981559],
            [30.180714936427012, 0.457427897815179],
            [30.184440646067298, 0.457069882964723],
            [30.188262386509773, 0.457785030530314],
            [30.190908374179116, 0.457534430120313],
            [30.194085863561096, 0.4547678235066],
            [30.196340339378498, 0.454576862063065],
            [30.199151886554734, 0.453730028881955],
            [30.19991022096138, 0.452585270553917],
            [30.201855277469075, 0.451511938469208],
            [30.205438651747528, 0.451153915241057],
            [30.20584034510492, 0.449365269333326],
            [30.208839529682784, 0.44627666826832],
            [30.21121813201118, 0.442383436595172],
            [30.21116252180353, 0.441293098415659],
            [30.210346510165746, 0.440176760006121],
            [30.2135845028787, 0.439861810074014],
            [30.216543073724225, 0.440261635718788],
            [30.217684428208496, 0.440801495568718],
            [30.219792095952272, 0.444108089246067],
            [30.221506743572743, 0.451605673859622],
            [30.22122553315956, 0.455206820835614],
            [30.220456645344946, 0.457675199720398],
            [30.22064873389879, 0.459916942809721],
            [30.219795627229665, 0.461228675203127],
            [30.218206012520337, 0.461777305261771],
            [30.217673805630252, 0.463601751961107],
            [30.218342828633034, 0.468132900300344],
            [30.220421649676425, 0.470291042977302],
            [30.22417265407848, 0.471363959017706],
            [30.227022121837795, 0.472794683256885],
            [30.2320172192465, 0.471876163735041],
            [30.233370530323718, 0.472353038875239],
            [30.234584889992803, 0.473590623640492],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 415,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KIBIITO TOWN COUNCIL",
        Population: 12788,
        Key: "BUNYANGABUKIBIITO TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Kibiito TC",
        id2_original: "Kabarole Kibiito TC",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.196496602220495, 0.542129855677645],
            [30.195285847490663, 0.542634528150654],
            [30.19398829035157, 0.544355365893454],
            [30.193332654941422, 0.544641955053154],
            [30.1897231387899, 0.543528937804312],
            [30.187351702322484, 0.5442225389043],
            [30.186006220062975, 0.5456647799431],
            [30.183990410446892, 0.545927951922454],
            [30.183119328488914, 0.545426311401597],
            [30.18013193070593, 0.545487547677778],
            [30.178763251250835, 0.544359140443895],
            [30.176402137324363, 0.539287549197834],
            [30.175964575135975, 0.539297352976563],
            [30.17505236650768, 0.539784657529942],
            [30.17442485824742, 0.540903289687504],
            [30.17198828404047, 0.540643921685178],
            [30.170477398580957, 0.541532609620056],
            [30.169137257704122, 0.542966483870194],
            [30.168823908265022, 0.542650730336755],
            [30.1680258791026, 0.542765118470055],
            [30.165568412777056, 0.543712327801229],
            [30.160801454212844, 0.542503483301278],
            [30.160290496072502, 0.542657525787105],
            [30.15688323470887, 0.542127556093451],
            [30.15326118616081, 0.542909029305989],
            [30.152430380168596, 0.541126185908323],
            [30.149373018896334, 0.539126235086193],
            [30.149348017883646, 0.535210248426832],
            [30.147607907516456, 0.527296473195407],
            [30.14849990674582, 0.523675592036057],
            [30.14827326988447, 0.520691771302366],
            [30.147214354692167, 0.518741210216302],
            [30.14606429193957, 0.51856940457613],
            [30.14469600325161, 0.519343386428592],
            [30.143898569672235, 0.51816676470383],
            [30.143157726362475, 0.517908215878812],
            [30.141275751350655, 0.514000435145669],
            [30.139331016439858, 0.513046597373184],
            [30.138682422923228, 0.510778401390661],
            [30.141452227184843, 0.510233283992433],
            [30.145598469650686, 0.51089500257156],
            [30.14978846815568, 0.50931896368294],
            [30.151613612149323, 0.506536878282381],
            [30.152212849529292, 0.504787075866957],
            [30.152313295551103, 0.503180491254828],
            [30.15128885500444, 0.499708597023816],
            [30.151403542018446, 0.49810202823271],
            [30.153015118739848, 0.494860788528033],
            [30.153870405620196, 0.494086546841966],
            [30.15743318961401, 0.493083946509664],
            [30.159315026285277, 0.490933026037942],
            [30.1603593267862, 0.489074662035418],
            [30.160784062828935, 0.48652299472875],
            [30.16434188542749, 0.484376560877094],
            [30.16531467194695, 0.484114194811281],
            [30.16938608115635, 0.485413675443418],
            [30.171043912131733, 0.485318209513795],
            [30.173611701455613, 0.486629690973966],
            [30.1763861769567, 0.486738612264182],
            [30.17633019484652, 0.487738466598266],
            [30.175287602042943, 0.489455546404941],
            [30.17502767721042, 0.490647945361924],
            [30.176476118079595, 0.491410987664592],
            [30.180676550516605, 0.491100776663799],
            [30.182730207053936, 0.491875731034739],
            [30.185694436387447, 0.48937158393854],
            [30.187925224529113, 0.48922838422944],
            [30.19040303679752, 0.486831561185154],
            [30.19139976521595, 0.486759963549658],
            [30.194604699926487, 0.487737567417252],
            [30.19571908159598, 0.486616655991032],
            [30.197569658691975, 0.485972662587057],
            [30.19901788306718, 0.486473387055512],
            [30.200680900915003, 0.488214216880699],
            [30.20212773918969, 0.487284058583208],
            [30.20281653411189, 0.487832536562319],
            [30.202722207413803, 0.488452583369884],
            [30.205023594153655, 0.487665479329002],
            [30.205142786218836, 0.488213977937513],
            [30.20559377013586, 0.488261656086762],
            [30.20554692748538, 0.488905552257301],
            [30.20602162692591, 0.488929376507868],
            [30.206259422659702, 0.489406332201103],
            [30.207254364329046, 0.487474575378888],
            [30.207871775525494, 0.487832267077491],
            [30.207801851562095, 0.4891439268065],
            [30.20834819703643, 0.489644711223932],
            [30.209653652163507, 0.489740036061855],
            [30.21129198969724, 0.490479243443707],
            [30.21164750964902, 0.489978412377958],
            [30.21181410581173, 0.490455367098291],
            [30.21295331422073, 0.490455311404778],
            [30.21311908303505, 0.490073732719746],
            [30.21366513745526, 0.490264491074232],
            [30.214044515762648, 0.489882899802395],
            [30.214329752424955, 0.49033600423385],
            [30.21569277698532, 0.488606920003485],
            [30.21768606404061, 0.488249091807075],
            [30.217922638065616, 0.48746207936724],
            [30.219014699295286, 0.487772048],
            [30.219417175983608, 0.486746539610502],
            [30.221089612667164, 0.485923674725048],
            [30.2213737884191, 0.485279748626276],
            [30.224221490090592, 0.484898011550031],
            [30.225076175997977, 0.485184144359136],
            [30.22514706295537, 0.484850259717787],
            [30.225361248268552, 0.485446461876225],
            [30.226429072951834, 0.485231760548294],
            [30.227139834377688, 0.483943895581809],
            [30.226973231926767, 0.483466934112823],
            [30.227850360444908, 0.482417545103893],
            [30.227694989630027, 0.481284742217629],
            [30.228193288711374, 0.481165464528141],
            [30.228120817125838, 0.479877662570008],
            [30.22890392796633, 0.479758353416024],
            [30.22966108557997, 0.477373441870404],
            [30.230467975724363, 0.477301852220025],
            [30.230205523032645, 0.475894801398776],
            [30.230679545143463, 0.475226996159085],
            [30.230181129281092, 0.47522702490417],
            [30.230085660824294, 0.47467851716642],
            [30.23084513698965, 0.474678464167643],
            [30.231011752915297, 0.475155425350369],
            [30.232198391473016, 0.475107649196445],
            [30.23262451990445, 0.473986730306737],
            [30.233360391039117, 0.474105927275206],
            [30.234584889992803, 0.473590623640492],
            [30.236220193017473, 0.473950709096385],
            [30.23695733526826, 0.475357744144873],
            [30.23853648011295, 0.476204270213472],
            [30.239177234032077, 0.476132676059507],
            [30.23969841859361, 0.475154839668969],
            [30.24038709403986, 0.475536369785584],
            [30.239890783828553, 0.477682806417698],
            [30.240913010926338, 0.479376009688509],
            [30.240533593991337, 0.479709917055492],
            [30.24075163397543, 0.482287356883341],
            [30.24000032798754, 0.482685963868879],
            [30.239914637692582, 0.483145001046837],
            [30.24025563098793, 0.485641329108418],
            [30.24102437147882, 0.487564003919582],
            [30.240453654710834, 0.489256581318235],
            [30.239398533103998, 0.490690735041379],
            [30.239383904039602, 0.491623216722488],
            [30.23958252424384, 0.493746491446968],
            [30.23992439159997, 0.494090941236936],
            [30.241719888494305, 0.494235152307133],
            [30.241862162770698, 0.494780356377094],
            [30.240934654036472, 0.498097323035054],
            [30.240535542437208, 0.498326689289845],
            [30.23925338691365, 0.497408007051468],
            [30.23717268928963, 0.497751426322249],
            [30.236430980902263, 0.49938654167608],
            [30.236344218917164, 0.502370448669579],
            [30.23571716610277, 0.502456251548345],
            [30.23369296981518, 0.503976046271062],
            [30.232680278334126, 0.506127482586558],
            [30.232594252967584, 0.507361185036017],
            [30.231853281198738, 0.507246103681111],
            [30.230655760449682, 0.508393244969839],
            [30.229629787377167, 0.508278030687867],
            [30.229430745863024, 0.507187671459886],
            [30.22854694465894, 0.507847186870705],
            [30.228062595515627, 0.507473988350694],
            [30.225881710584616, 0.508850232287555],
            [30.224485135744988, 0.508964391978797],
            [30.2215489302551, 0.510483753102968],
            [30.22109242349572, 0.511631205518321],
            [30.220379829506683, 0.511831736525591],
            [30.21961064884128, 0.51105673241681],
            [30.218555860509408, 0.511687479133676],
            [30.21767192725299, 0.512662593752802],
            [30.218013461334124, 0.513753015830289],
            [30.217613865542926, 0.515101326436334],
            [30.216302385415215, 0.516162324075767],
            [30.216259295027672, 0.516936968253483],
            [30.215432328434986, 0.517969484765969],
            [30.215488916009683, 0.518916322414744],
            [30.214262759664315, 0.520379026760189],
            [30.21411991046614, 0.521153629999321],
            [30.21249504047516, 0.521956252230906],
            [30.21189577345082, 0.523677453267566],
            [30.210527974344714, 0.523189089272078],
            [30.21021420179911, 0.523791459087058],
            [30.209416312773875, 0.523532880849646],
            [30.208589552793722, 0.524106330581051],
            [30.20768308799333, 0.525400979472095],
            [30.20693472039475, 0.52512438544654],
            [30.206728641478673, 0.526844477137917],
            [30.204455257022843, 0.528063812109972],
            [30.202089754826222, 0.528034039612664],
            [30.201177568655787, 0.528463997254065],
            [30.202031709285837, 0.530357986328365],
            [30.20224436027651, 0.532796808255742],
            [30.203298252089745, 0.534145768708637],
            [30.20178677374215, 0.536268190307982],
            [30.20175789021081, 0.53710022193106],
            [30.20080246093923, 0.538591706335714],
            [30.199918830415058, 0.538878195161087],
            [30.196496602220495, 0.542129855677645],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 416,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KISOMORO",
        Population: 23490,
        Key: "BUNYANGABUKISOMORO",
        Dist2: "Kabarole",
        "Sub Country": "Kisomoro",
        id2_original: "Kabarole Kisomoro",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.196496602220495, 0.542129855677645],
            [30.19632533212335, 0.544270391797169],
            [30.197365159014197, 0.545188987252472],
            [30.19910358144695, 0.545361955417136],
            [30.199529356840493, 0.549063271374044],
            [30.198815389327393, 0.552161542583031],
            [30.19520843606935, 0.555746154281201],
            [30.195435725107597, 0.557266879117903],
            [30.19440900733172, 0.558758302809216],
            [30.194593381153894, 0.5605945989126],
            [30.194137055854192, 0.561282953009451],
            [30.194022402077845, 0.562631361799849],
            [30.194818734322684, 0.566103331952328],
            [30.194675594968686, 0.567423032673302],
            [30.193562775469452, 0.57011940513969],
            [30.191823246312243, 0.572241657573477],
            [30.1911859230592, 0.572600534584789],
            [30.189685826366258, 0.572068449463672],
            [30.187376388026493, 0.573989573091128],
            [30.183585124726676, 0.575565663406316],
            [30.182303218934777, 0.574388718545332],
            [30.17993786675677, 0.574129317883748],
            [30.178029130932654, 0.572607781830575],
            [30.176803654611952, 0.572578475757937],
            [30.176034541320206, 0.571832149520657],
            [30.174609697396924, 0.571544527776297],
            [30.174239997538354, 0.569937701120303],
            [30.17321382414156, 0.570310158333204],
            [30.172272794863986, 0.571428614938197],
            [30.165320840678017, 0.567523302198718],
            [30.163810174407434, 0.567924209611566],
            [30.16280343965503, 0.569871754566142],
            [30.160132233580693, 0.571049572575451],
            [30.15859110184558, 0.571077494420794],
            [30.158773943141874, 0.56714319422953],
            [30.157925618204995, 0.563152975735516],
            [30.159286376315915, 0.560565751796345],
            [30.159980360805513, 0.556684248574906],
            [30.163467353938817, 0.545284323831628],
            [30.165568412777056, 0.543712327801229],
            [30.1680258791026, 0.542765118470055],
            [30.168823908265022, 0.542650730336755],
            [30.169137257704122, 0.542966483870194],
            [30.170477398580957, 0.541532609620056],
            [30.17198828404047, 0.540643921685178],
            [30.17442485824742, 0.540903289687504],
            [30.17505236650768, 0.539784657529942],
            [30.175964575135975, 0.539297352976563],
            [30.176402137324363, 0.539287549197834],
            [30.178763251250835, 0.544359140443895],
            [30.18013193070593, 0.545487547677778],
            [30.183119328488914, 0.545426311401597],
            [30.183990410446892, 0.545927951922454],
            [30.186006220062975, 0.5456647799431],
            [30.187351702322484, 0.5442225389043],
            [30.1897231387899, 0.543528937804312],
            [30.193332654941422, 0.544641955053154],
            [30.19398829035157, 0.544355365893454],
            [30.195285847490663, 0.542634528150654],
            [30.196496602220495, 0.542129855677645],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 417,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "RUBONA TOWN COUNCIL",
        Population: 5602,
        Key: "BUNYANGABURUBONA TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Rubona TC",
        id2_original: "Kabarole Rubona TC",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.274142217003728, 0.3544997918653],
            [30.27291296326724, 0.357126521105696],
            [30.274766340411986, 0.357964671573452],
            [30.275918823225968, 0.359244311902984],
            [30.276417963130427, 0.361730213704196],
            [30.277035799230003, 0.362638926798081],
            [30.27803377361175, 0.363093924245906],
            [30.27953062918316, 0.362067686058122],
            [30.28074250321384, 0.363287637553458],
            [30.28084947190291, 0.363873248276183],
            [30.28001790593598, 0.364804522783982],
            [30.28094467625503, 0.366358786792035],
            [30.280980378897706, 0.367326713349088],
            [30.282215984621537, 0.368140419319827],
            [30.282893311650824, 0.370447257628258],
            [30.285566585646944, 0.373711926143056],
            [30.28504397276412, 0.375814515648103],
            [30.285424243098593, 0.377511675023238],
            [30.283737328267584, 0.379374184236671],
            [30.284497776410102, 0.381215095332883],
            [30.284652314486742, 0.383139086664099],
            [30.286885873032794, 0.384049341717434],
            [30.289190599708853, 0.38237860877874],
            [30.29047370295505, 0.382523206470279],
            [30.291709325746897, 0.383671514296915],
            [30.29208958889486, 0.38532089630823],
            [30.293253915995866, 0.386134548497538],
            [30.294620444884174, 0.391931316160799],
            [30.294133451998967, 0.394284887232444],
            [30.294632505665174, 0.396006072282528],
            [30.29460880541302, 0.397583377281556],
            [30.29391978411538, 0.398753762207018],
            [30.294240647961807, 0.401275394822149],
            [30.293218947276788, 0.40201527672137],
            [30.29310982802093, 0.404657760163756],
            [30.29161521644111, 0.405945087418609],
            [30.289928146201532, 0.404820220022654],
            [30.28871634134113, 0.404842954916681],
            [30.28662540561782, 0.405653498895944],
            [30.285556190342493, 0.406536719162977],
            [30.284712726189614, 0.408244657211067],
            [30.28333464406844, 0.409820632164745],
            [30.280269479131288, 0.409196302819402],
            [30.27903393449289, 0.409912061253296],
            [30.278178529034964, 0.409457165124168],
            [30.27772705373946, 0.408691975413939],
            [30.27536284511682, 0.408104175943593],
            [30.274507407319525, 0.406310969228544],
            [30.271157196162964, 0.407669944033828],
            [30.2693038531542, 0.407142380397895],
            [30.266488232118153, 0.407510086585746],
            [30.266369455074667, 0.408418100419736],
            [30.26477750833884, 0.4085360561003],
            [30.263328146696512, 0.409586172480033],
            [30.260088065400506, 0.410325189461994],
            [30.25889687507926, 0.411672953800532],
            [30.258374141822163, 0.411505166309521],
            [30.25811276261721, 0.410787969852375],
            [30.257566288683783, 0.411360987728836],
            [30.257091070017037, 0.411217138818758],
            [30.257494979518228, 0.410548387235475],
            [30.257281134666517, 0.410333097128652],
            [30.254453677428284, 0.411166776069334],
            [30.254857631845262, 0.412553263837204],
            [30.253717148726842, 0.412886722395692],
            [30.252624208944844, 0.414462921005579],
            [30.251792604350346, 0.41496396928114],
            [30.251427527222244, 0.415771193945776],
            [30.251745126590947, 0.417258135046617],
            [30.253432130355172, 0.41814400398712],
            [30.25404991165752, 0.418981041714592],
            [30.254121222619744, 0.421179726955049],
            [30.253622266869883, 0.421704997217578],
            [30.254572714084894, 0.424263015925915],
            [30.255047925565137, 0.424239590302144],
            [30.25534495800543, 0.426952305449041],
            [30.255962733917865, 0.427383080571096],
            [30.256342913522538, 0.428889032659294],
            [30.257317090634068, 0.428818298600326],
            [30.2568656575594, 0.429941063260367],
            [30.257887359142742, 0.430228850216557],
            [30.257792329063793, 0.431638743125574],
            [30.25987137738095, 0.433014945420748],
            [30.259942662291984, 0.433421288520553],
            [30.259491216640917, 0.434185580206876],
            [30.259099180172825, 0.440577933965389],
            [30.25667738684552, 0.442845478461143],
            [30.253267386518605, 0.438678988186772],
            [30.25151923802625, 0.437270019134326],
            [30.25005041438327, 0.437128642797599],
            [30.24088594378849, 0.441244526152195],
            [30.23871772600129, 0.440962050299317],
            [30.23557066435466, 0.439622982921962],
            [30.232982770734708, 0.439375559137763],
            [30.230149761908013, 0.439973019126442],
            [30.227841070966555, 0.441310024868487],
            [30.223100215647907, 0.437157394338055],
            [30.219183055257613, 0.432792450753901],
            [30.21603274709954, 0.426758015126495],
            [30.21600100333234, 0.421645343511742],
            [30.215019874158802, 0.420669700656664],
            [30.214963910014927, 0.419334412423114],
            [30.21533117993064, 0.418198147600457],
            [30.21516267125468, 0.415896881113406],
            [30.21674685474982, 0.411811767775283],
            [30.222056131640947, 0.410785747477509],
            [30.22635995298063, 0.410904365164556],
            [30.230838555931882, 0.410203328931277],
            [30.233340253505375, 0.407920709580246],
            [30.23619073546265, 0.406165161949876],
            [30.237172093706587, 0.406076936130611],
            [30.240265033654016, 0.401914911322988],
            [30.242588519848166, 0.399577421875216],
            [30.242955411573135, 0.398635335678776],
            [30.242905222698234, 0.396035809401365],
            [30.244124783612776, 0.393424180490497],
            [30.24527731763072, 0.392479558608458],
            [30.2412724861603, 0.389417969271762],
            [30.237981550337746, 0.385829174942794],
            [30.23610524010213, 0.384565463441878],
            [30.234607734150455, 0.382419287182064],
            [30.23451073137115, 0.380463710722488],
            [30.23499606237306, 0.379330827101505],
            [30.23786405608848, 0.375753069509355],
            [30.240220343366946, 0.370851768621277],
            [30.24569850353146, 0.36677273008796],
            [30.247796356282453, 0.364351717267359],
            [30.250738018139415, 0.363359155486889],
            [30.251838015984582, 0.364109114160669],
            [30.252384481833158, 0.363846744916496],
            [30.25250321575752, 0.362819243808135],
            [30.251873485963575, 0.361396727981633],
            [30.252609776611475, 0.357239168551704],
            [30.254427242704427, 0.354600116490315],
            [30.25742090623653, 0.352906114799101],
            [30.25939309995064, 0.35422232914034],
            [30.26295708050043, 0.35343697940237],
            [30.274142217003728, 0.3544997918653],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 418,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "RWIMI",
        Population: 17020,
        Key: "BUNYANGABURWIMI",
        Dist2: "Kabarole",
        "Sub Country": "Rwimi",
        id2_original: "Kabarole Rwimi",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.180550378541678, 0.38714654679299],
            [30.18206089120036, 0.387135804085738],
            [30.185999419816277, 0.386085963320305],
            [30.188016742195305, 0.386109532781562],
            [30.18910930827815, 0.386920207946463],
            [30.19022300183816, 0.385250708928748],
            [30.190446491002746, 0.383378624262057],
            [30.191205057174745, 0.382543843007351],
            [30.193221653715046, 0.381875816727003],
            [30.1955216175235, 0.379848406144638],
            [30.197348884236185, 0.379681207291904],
            [30.19915122539467, 0.378393151073342],
            [30.19931640221923, 0.377486909906692],
            [30.201556713401263, 0.375161387088566],
            [30.203502900887866, 0.375232646217226],
            [30.205376455092225, 0.373944565086973],
            [30.210869894701403, 0.373192516906196],
            [30.212766403556195, 0.371165123168888],
            [30.213383292831498, 0.370998091233276],
            [30.214095673919786, 0.371355706636822],
            [30.214688689568064, 0.371069434835513],
            [30.21386728624193, 0.368625104296312],
            [30.21621569260043, 0.367503870056992],
            [30.2158112054825, 0.366549989289462],
            [30.216380116636756, 0.365905999319648],
            [30.215667880177232, 0.365691470730676],
            [30.21521542032817, 0.364260641616697],
            [30.215652118337257, 0.362054606848725],
            [30.21701319804504, 0.358727529348518],
            [30.217772437055192, 0.358512767930502],
            [30.218802713956233, 0.356545097814194],
            [30.220581197657406, 0.355137740689278],
            [30.221696985190352, 0.35542373631947],
            [30.22209988947673, 0.354899002714199],
            [30.22262202715078, 0.354898918274192],
            [30.224340886971643, 0.353217304169931],
            [30.228376180313337, 0.353765135811057],
            [30.229348099060264, 0.352691775445819],
            [30.23202849220501, 0.3513081022718],
            [30.23356885408395, 0.349161444632009],
            [30.23486143904794, 0.348338433296502],
            [30.235925926489944, 0.345094815434447],
            [30.236946239277874, 0.344879987228555],
            [30.237609893948505, 0.344069019915185],
            [30.238843635668164, 0.343687214050073],
            [30.23898453013225, 0.342303952774855],
            [30.24038474853867, 0.34223215980002],
            [30.242602459006427, 0.34095583367016],
            [30.24371786745033, 0.340884079312112],
            [30.244618845340945, 0.34004920252218],
            [30.245118177484883, 0.340883834974692],
            [30.246257189162858, 0.340692835862603],
            [30.246897088784145, 0.339857998581293],
            [30.24682529363002, 0.339309480733342],
            [30.24765524801932, 0.338641555483209],
            [30.250779682900593, 0.339823475135567],
            [30.2521688160964, 0.338968745833637],
            [30.253927074228958, 0.33904204258623],
            [30.254473455635907, 0.337823737210481],
            [30.255590164840306, 0.337657470024927],
            [30.256136592959646, 0.336941022101944],
            [30.25760970336314, 0.336751174532418],
            [30.259130358001386, 0.336800360037822],
            [30.259748208474015, 0.33773294336758],
            [30.260401626842025, 0.337888884597172],
            [30.262041075591732, 0.33781867888505],
            [30.26353786648442, 0.336649021678798],
            [30.264405184501356, 0.337354811297233],
            [30.266068381113932, 0.337117345765242],
            [30.266282283457794, 0.337810581611823],
            [30.26747032518398, 0.338098439042131],
            [30.268099906755907, 0.337298416939375],
            [30.268765203546895, 0.337394616754003],
            [30.26978682428187, 0.336391812398315],
            [30.273089490305424, 0.336060243647827],
            [30.273790442128345, 0.336287906958017],
            [30.274337024757912, 0.337196539869527],
            [30.275192440995646, 0.337699187960527],
            [30.276523015713025, 0.337533106720883],
            [30.27775863850484, 0.338346772178952],
            [30.279398136661918, 0.338539456547436],
            [30.28096641458659, 0.339401223165772],
            [30.28291241342704, 0.339467524856772],
            [30.283208321176566, 0.339901378361406],
            [30.282365105857007, 0.341110304331767],
            [30.279751562640765, 0.343358177855336],
            [30.279582795250036, 0.34403695782411],
            [30.280614839137233, 0.345691904873129],
            [30.280446112170672, 0.346222190481394],
            [30.279160463997297, 0.347155205875836],
            [30.278128032936184, 0.346857916579871],
            [30.277558960085187, 0.347324444468969],
            [30.27846462987654, 0.348767219993398],
            [30.277810465906846, 0.351991462092264],
            [30.275555614593664, 0.352584767460993],
            [30.274142217003728, 0.3544997918653],
            [30.26295708050043, 0.35343697940237],
            [30.25939309995064, 0.35422232914034],
            [30.25742090623653, 0.352906114799101],
            [30.254427242704427, 0.354600116490315],
            [30.252609776611475, 0.357239168551704],
            [30.251873485963575, 0.361396727981633],
            [30.25250321575752, 0.362819243808135],
            [30.252384481833158, 0.363846744916496],
            [30.251838015984582, 0.364109114160669],
            [30.250738018139415, 0.363359155486889],
            [30.247796356282453, 0.364351717267359],
            [30.24569850353146, 0.36677273008796],
            [30.240220343366946, 0.370851768621277],
            [30.23786405608848, 0.375753069509355],
            [30.23499606237306, 0.379330827101505],
            [30.23451073137115, 0.380463710722488],
            [30.234607734150455, 0.382419287182064],
            [30.23610524010213, 0.384565463441878],
            [30.237981550337746, 0.385829174942794],
            [30.2412724861603, 0.389417969271762],
            [30.24527731763072, 0.392479558608458],
            [30.244124783612776, 0.393424180490497],
            [30.242905222698234, 0.396035809401365],
            [30.242955411573135, 0.398635335678776],
            [30.242588519848166, 0.399577421875216],
            [30.240265033654016, 0.401914911322988],
            [30.237172093706587, 0.406076936130611],
            [30.23619073546265, 0.406165161949876],
            [30.233340253505375, 0.407920709580246],
            [30.230838555931882, 0.410203328931277],
            [30.22635995298063, 0.410904365164556],
            [30.222056131640947, 0.410785747477509],
            [30.21674685474982, 0.411811767775283],
            [30.214520550998035, 0.412334132687827],
            [30.212348677067606, 0.413930742394642],
            [30.210928796336287, 0.414434670627323],
            [30.209008112918877, 0.414181767350911],
            [30.205291637061418, 0.41476894385734],
            [30.2038719710274, 0.414684363400923],
            [30.201199935808045, 0.413758616201579],
            [30.198778173023513, 0.413589606179325],
            [30.195019705418062, 0.41493340131197],
            [30.19351651223233, 0.414932860540365],
            [30.188297599570596, 0.413543812157443],
            [30.18170017179968, 0.413919755387129],
            [30.179863004754253, 0.413092291118218],
            [30.18039427919309, 0.411876363958552],
            [30.18219669042018, 0.410636083013258],
            [30.18257572646948, 0.409968306926815],
            [30.182536300309966, 0.40625999471101],
            [30.182973523833457, 0.404483282939207],
            [30.18370827476897, 0.403553134723815],
            [30.183634927326025, 0.401478393823809],
            [30.181458960671193, 0.397221850008644],
            [30.181861449935912, 0.396291736901186],
            [30.18069779028318, 0.395576459655098],
            [30.18126603488749, 0.394288610661113],
            [30.180125867077752, 0.39333485322576],
            [30.181145437857253, 0.392428510345049],
            [30.17976627146951, 0.389876989682357],
            [30.178959111830558, 0.38963862633863],
            [30.18059483526677, 0.387897522091655],
            [30.180550378541678, 0.38714654679299],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 419,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "RWIMI TOWN COUNCIL",
        Population: 16216,
        Key: "BUNYANGABURWIMI TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Rwimi TC",
        id2_original: "Kabarole Rwimi TC",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.160290496072502, 0.542657525787105],
            [30.158697589935976, 0.545341051669078],
            [30.156952784973118, 0.546903923501508],
            [30.15403608280634, 0.548685691751772],
            [30.152279146993877, 0.548772499162974],
            [30.150165575522042, 0.550521855340928],
            [30.144660884513918, 0.550574054930492],
            [30.14359874796299, 0.549229317327481],
            [30.14291759231397, 0.548995806502134],
            [30.1422224633707, 0.549489265245041],
            [30.140069935558273, 0.548912129579257],
            [30.13833932487521, 0.549322785432502],
            [30.13546173715252, 0.551471120494263],
            [30.134549645305214, 0.551757568284557],
            [30.132241250807837, 0.551813819975598],
            [30.131130861251414, 0.550786940429919],
            [30.129542292181075, 0.550788398328243],
            [30.128683231478256, 0.551389512330384],
            [30.127654944345558, 0.551318018727246],
            [30.123662669526198, 0.554088927447196],
            [30.11997964692988, 0.555360598418374],
            [30.116752504967238, 0.558680462999373],
            [30.11647780823821, 0.55963460446248],
            [30.109768711792675, 0.55984832143591],
            [30.108040521170967, 0.561564207412046],
            [30.10665386912198, 0.562327741373684],
            [30.105013628058195, 0.564176571738082],
            [30.094359683348696, 0.57194630802829],
            [30.093335672196776, 0.573562829153241],
            [30.090353120824737, 0.575521679617618],
            [30.08891651525942, 0.575899795567944],
            [30.086121594102494, 0.578665245458618],
            [30.085697253318447, 0.578427637010125],
            [30.085341809723452, 0.576921341249788],
            [30.08513038583145, 0.572402871072717],
            [30.084668094819925, 0.57082479920022],
            [30.07622210487424, 0.566209241746884],
            [30.074439326327678, 0.565830537689769],
            [30.073527123987596, 0.564451577623215],
            [30.073528506494828, 0.561694583526873],
            [30.073986097520773, 0.559397332082315],
            [30.072389570275313, 0.557328775502794],
            [30.071933818100756, 0.555950055068562],
            [30.07604497686316, 0.549519130159723],
            [30.07604598656953, 0.547451389361462],
            [30.07432476777276, 0.544185712333811],
            [30.07508724520952, 0.542781812012237],
            [30.075103007947785, 0.53964051576309],
            [30.07969240281799, 0.536759620884344],
            [30.081686992430466, 0.537190903772126],
            [30.082670327866314, 0.536804092725708],
            [30.083795546811416, 0.537679618786796],
            [30.084451508310007, 0.536575449177589],
            [30.085962294954836, 0.535658163004418],
            [30.0883564228663, 0.534899081089291],
            [30.089211204893445, 0.535186373146521],
            [30.090166013429165, 0.534871262375515],
            [30.090793524384345, 0.533666664070502],
            [30.091976684665273, 0.532562736273631],
            [30.095154998700654, 0.530742552088393],
            [30.095854159282926, 0.528662987181346],
            [30.098989548220768, 0.527230054575773],
            [30.098505431741135, 0.526498274766019],
            [30.09894732291084, 0.526111190871671],
            [30.104753419358055, 0.525888428848553],
            [30.105509444196127, 0.525558868810718],
            [30.105301459055013, 0.522224563375088],
            [30.106978156447973, 0.520588318399021],
            [30.112579030971915, 0.518238453619505],
            [30.11483051719604, 0.517895219584223],
            [30.116512495784562, 0.516547621006926],
            [30.116626050023022, 0.517523089703173],
            [30.116911020783952, 0.517523220851833],
            [30.11810829539464, 0.516749183083763],
            [30.119732810551064, 0.516463030992149],
            [30.120189253530086, 0.515401760326077],
            [30.121244007726006, 0.514656327996066],
            [30.12171511749864, 0.512677007542805],
            [30.12299836806852, 0.510812815379866],
            [30.125151415107208, 0.50976689807196],
            [30.12637731363611, 0.508677265803847],
            [30.12791625977015, 0.508591889690225],
            [30.1305374781922, 0.509941461667741],
            [30.13207650697124, 0.509683957209142],
            [30.13372903249653, 0.510516687627228],
            [30.138682422923228, 0.510778401390661],
            [30.139331016439858, 0.513046597373184],
            [30.141275751350655, 0.514000435145669],
            [30.143157726362475, 0.517908215878812],
            [30.143898569672235, 0.51816676470383],
            [30.14469600325161, 0.519343386428592],
            [30.14606429193957, 0.51856940457613],
            [30.147214354692167, 0.518741210216302],
            [30.14827326988447, 0.520691771302366],
            [30.14849990674582, 0.523675592036057],
            [30.147607907516456, 0.527296473195407],
            [30.149348017883646, 0.535210248426832],
            [30.149373018896334, 0.539126235086193],
            [30.152430380168596, 0.541126185908323],
            [30.15326118616081, 0.542909029305989],
            [30.15688323470887, 0.542127556093451],
            [30.160290496072502, 0.542657525787105],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 420,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "KATEBWA",
        Population: 9347,
        Key: "BUNYANGABUKATEBWA",
        Dist2: "Kabarole",
        "Sub Country": "Kateebwa",
        id2_original: "Kabarole Kateebwa",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.20962525551906, 0.593198870088086],
            [30.21143545424136, 0.592937653099571],
            [30.216908899148976, 0.590300848446584],
            [30.22047172446529, 0.589843585301714],
            [30.222381369384504, 0.58967240691821],
            [30.2238408218024, 0.590099296953497],
            [30.225269736890564, 0.589627190816307],
            [30.227475533901043, 0.590207650486642],
            [30.229649621280316, 0.590273114434116],
            [30.233149280659127, 0.592914146345639],
            [30.235866785004898, 0.593237389579436],
            [30.23666552922631, 0.594364302411856],
            [30.24003750835884, 0.596619063380285],
            [30.240741043736545, 0.59636192827718],
            [30.242818593663806, 0.597714814659986],
            [30.24387397129051, 0.597168180900872],
            [30.244577918994917, 0.596074195504546],
            [30.245313354446647, 0.595945821518224],
            [30.254238393475518, 0.595980007751912],
            [30.253371317105394, 0.601438562397981],
            [30.25148300358093, 0.606657749137937],
            [30.2440585346572, 0.617414114187549],
            [30.240814330094054, 0.617125903760235],
            [30.23613144395896, 0.620953327221842],
            [30.23510410544723, 0.623420270839398],
            [30.234371476332427, 0.623926129816374],
            [30.222600874520797, 0.627414542695494],
            [30.221781078280706, 0.628201373833377],
            [30.220133975884792, 0.631436504880738],
            [30.219014511547392, 0.638336685023278],
            [30.21584212010468, 0.639075033646944],
            [30.214635909053566, 0.640535220572595],
            [30.212974900737017, 0.641694096906872],
            [30.20842378577603, 0.64286172651006],
            [30.205428552887128, 0.640039493780798],
            [30.204938005368337, 0.638919177553532],
            [30.205470700043616, 0.635798950307816],
            [30.205187887934304, 0.631724676796587],
            [30.20272652651368, 0.624349762744737],
            [30.20055514665669, 0.621581986994311],
            [30.19543358082902, 0.618026491566084],
            [30.193203237353387, 0.615792917867426],
            [30.196975641422167, 0.613637815555929],
            [30.20069412231935, 0.612163271368711],
            [30.19794546439951, 0.609097936469796],
            [30.19798835895434, 0.605202274107851],
            [30.19644898881547, 0.604460741786218],
            [30.199338723557414, 0.602528123663026],
            [30.197674219896125, 0.601318778653235],
            [30.201424958396846, 0.59973089148969],
            [30.203387337118166, 0.599320388370242],
            [30.206482199460254, 0.595947531818011],
            [30.207841980204165, 0.595806841693846],
            [30.20962525551906, 0.593198870088086],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 421,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "MUGUSU TOWN COUNCIL",
        Population: 10315,
        Key: "KABAROLEMUGUSU TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.270007897876663, 0.549772504496043],
            [30.273529687252505, 0.551606153482811],
            [30.275589214280235, 0.552149542546385],
            [30.279160148688614, 0.55534729679052],
            [30.282818770346875, 0.555900816234101],
            [30.285134972102394, 0.555294896928013],
            [30.28817712669352, 0.555448060573242],
            [30.290493249397326, 0.555035271744405],
            [30.295207219037852, 0.555327162897509],
            [30.29823532307964, 0.556294253508469],
            [30.29939963401097, 0.55742602969995],
            [30.300249141130756, 0.557716130477248],
            [30.300126392635374, 0.556433085183326],
            [30.300798122262112, 0.555909164783393],
            [30.30408739081152, 0.555179518239149],
            [30.305911102890626, 0.552779918567829],
            [30.30758454119574, 0.549331772663853],
            [30.31145001072792, 0.54720899633039],
            [30.313146685754493, 0.553031559995956],
            [30.313829820392083, 0.557584463456057],
            [30.31502012138123, 0.561847897016752],
            [30.31560897154153, 0.562772487511295],
            [30.318828617063136, 0.564539846290426],
            [30.318357565680984, 0.566743410500026],
            [30.31859574050385, 0.567382219719696],
            [30.31607035615292, 0.568692879050972],
            [30.321114992056295, 0.56932805904061],
            [30.32615841343739, 0.568709615636883],
            [30.32658415469494, 0.566737004927102],
            [30.326365681722883, 0.565012418916994],
            [30.327174703569458, 0.563978104882751],
            [30.327628059937147, 0.561536444515028],
            [30.328725520041676, 0.559067486422213],
            [30.33013791690838, 0.557164300855165],
            [30.331058082813463, 0.552763823303656],
            [30.332552498560556, 0.551302133655173],
            [30.335156772959717, 0.550254820087591],
            [30.338721146073304, 0.5474144532213],
            [30.341284161749776, 0.54671200628301],
            [30.343250304412102, 0.544995956118694],
            [30.34374600197242, 0.546830478792761],
            [30.34528430491271, 0.548333489248577],
            [30.347056016214964, 0.549320184929261],
            [30.349201229944363, 0.549368096169326],
            [30.35251113189754, 0.552139503440925],
            [30.354326055758204, 0.560778735745659],
            [30.354044816598947, 0.563924116054582],
            [30.35334418996614, 0.56631813380052],
            [30.352378426475553, 0.567959912296747],
            [30.351131503775754, 0.568879259508472],
            [30.347877601899107, 0.574994337633983],
            [30.346666254281192, 0.579676702180608],
            [30.346761248427523, 0.580632431001943],
            [30.350775088203637, 0.588184066950811],
            [30.352544515988438, 0.589534735712456],
            [30.3537320699294, 0.589917519019361],
            [30.36014491277402, 0.589968022322355],
            [30.363220694899525, 0.590865288343736],
            [30.3698711088991, 0.590031857713403],
            [30.37161684451662, 0.590379039946555],
            [30.37365945177595, 0.592028498845129],
            [30.37898550201005, 0.59477126223849],
            [30.37787528762513, 0.596510180893695],
            [30.37547634654038, 0.598086087913802],
            [30.374930014540766, 0.599710550254431],
            [30.373647413452815, 0.600928528853721],
            [30.37264978851574, 0.602863409377137],
            [30.371616598378218, 0.603376659429043],
            [30.37152153416328, 0.605216348126551],
            [30.371117737849822, 0.605980742986797],
            [30.368980072663728, 0.607365585449343],
            [30.368683104003868, 0.609838346223215],
            [30.363030093057482, 0.614614365613002],
            [30.35776905569712, 0.617323822573635],
            [30.35563143722345, 0.617251191710157],
            [30.349408939302702, 0.614699681790794],
            [30.347823398453173, 0.614442636473413],
            [30.344043660538418, 0.611607039315912],
            [30.340617806743367, 0.609725737102013],
            [30.336738908295978, 0.609382244370227],
            [30.330892187336694, 0.610846428741703],
            [30.324974526419414, 0.616910257714929],
            [30.322355372325866, 0.621480280332363],
            [30.32122278809376, 0.622789893808617],
            [30.319325812115014, 0.623073829097928],
            [30.31141256265869, 0.619552823471419],
            [30.309827137691823, 0.617985661020108],
            [30.30798684091594, 0.61744369039925],
            [30.30545295311255, 0.615520087419117],
            [30.302904885402416, 0.614180347080317],
            [30.30103653424021, 0.608084665247207],
            [30.30105086236898, 0.603969237943159],
            [30.301673800899405, 0.60197587622405],
            [30.30638794301647, 0.597890988053781],
            [30.307010861783958, 0.596837477793733],
            [30.306841068517144, 0.594131739297105],
            [30.303457854155347, 0.589473684047446],
            [30.299126125753034, 0.587421216435397],
            [30.298375929184527, 0.584045956966829],
            [30.297554901354218, 0.582849426217415],
            [30.295856218592963, 0.581282271210759],
            [30.293747032696356, 0.577707082893139],
            [30.29131222727216, 0.576509885185072],
            [30.290802621096315, 0.575883094035563],
            [30.292529718468327, 0.571127618821843],
            [30.29163791686832, 0.567467515962803],
            [30.29025065845653, 0.565872043221589],
            [30.289514542081797, 0.565586939035297],
            [30.286881543153115, 0.565699758343633],
            [30.285607529959275, 0.564702432563746],
            [30.281389089894088, 0.563618433263638],
            [30.280044286760944, 0.56388842951346],
            [30.277269752869344, 0.563573991265107],
            [30.276816778285646, 0.561637165074594],
            [30.274948232189008, 0.559956074599002],
            [30.273532659777803, 0.559328935819537],
            [30.272966435484527, 0.557363589861052],
            [30.27048919634127, 0.555724978392831],
            [30.270489204426113, 0.552250443819305],
            [30.269979596453638, 0.551310399569733],
            [30.270007897876663, 0.549772504496043],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 422,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KIKO TOWN COUNCIL",
        Population: 12021,
        Key: "KABAROLEKIKO TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Kiko TC",
        id2_original: "Kabarole Kiko TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.561326674749456, 0.940502070639019],
            [30.560987547254978, 0.942486234193725],
            [30.56206459044971, 0.943377310543671],
            [30.562203789792875, 0.944335806849563],
            [30.560307730994065, 0.944849967670992],
            [30.557685148031094, 0.946484201862251],
            [30.556722951750483, 0.947819586933992],
            [30.55562478018029, 0.951229593251567],
            [30.55331103172377, 0.952861111892119],
            [30.552900685793574, 0.954807785977389],
            [30.551456839807088, 0.955412777440243],
            [30.551207582468564, 0.960782171583773],
            [30.55073961590108, 0.961591917601678],
            [30.54860536880468, 0.962037029390682],
            [30.548685047573763, 0.962984182670748],
            [30.54802493765521, 0.963558645065799],
            [30.545483474359035, 0.963628154057855],
            [30.544175650374545, 0.964836195466818],
            [30.544503486045905, 0.968042836200163],
            [30.54273307819914, 0.97361632579532],
            [30.543512547269465, 0.975887031613996],
            [30.542809327200438, 0.975478844237415],
            [30.54172097691124, 0.973308253512818],
            [30.540112935958785, 0.971473927935476],
            [30.538679381970503, 0.97056225448858],
            [30.537537215409262, 0.970358910469975],
            [30.535900372672167, 0.967956151266623],
            [30.532305685011032, 0.967134353089077],
            [30.530990926032548, 0.966221643762351],
            [30.530015685315718, 0.966087935069669],
            [30.52962255559793, 0.964622207577507],
            [30.52771264208245, 0.962233677911375],
            [30.519244726955634, 0.9543810906487],
            [30.51086227934157, 0.94830207608233],
            [30.50539176743334, 0.943388396946275],
            [30.502314952245275, 0.942017147086385],
            [30.49831034355707, 0.939488592097718],
            [30.49549029921655, 0.936860454175387],
            [30.491760447444477, 0.931976209002741],
            [30.488526546557633, 0.928500485242798],
            [30.48765148326632, 0.926709753261116],
            [30.485662137120197, 0.924154168562886],
            [30.482141604487424, 0.921680403470013],
            [30.480862926342333, 0.919936971726591],
            [30.477516477330177, 0.919670753469551],
            [30.47572349751524, 0.92013408160076],
            [30.468868114018942, 0.917573108370329],
            [30.46349625060368, 0.91504958737871],
            [30.459166684446238, 0.91372038748582],
            [30.456199694589884, 0.913669356192405],
            [30.452922800333525, 0.914357721258337],
            [30.450217831977547, 0.913805868381146],
            [30.44745230010343, 0.913934016516955],
            [30.443370458758633, 0.913476070502726],
            [30.44159183492028, 0.912591172532942],
            [30.439945643416024, 0.910644544257041],
            [30.424638039259236, 0.908432379371598],
            [30.415267059455385, 0.90399499105181],
            [30.40246120317773, 0.899483230461222],
            [30.400187401903604, 0.89680817142677],
            [30.39888362842273, 0.895876111808381],
            [30.38906534330293, 0.892823136178251],
            [30.38905882961881, 0.891733804984485],
            [30.38847288820338, 0.890552067752851],
            [30.38861650186785, 0.888619103809891],
            [30.3899151783078, 0.887689294821171],
            [30.390984055816613, 0.884826250210717],
            [30.396356314490603, 0.881465075586849],
            [30.398508249414952, 0.88087593218721],
            [30.400589471655113, 0.879696070547462],
            [30.403489922400063, 0.876655285561578],
            [30.404593818035266, 0.87454397826993],
            [30.404629738070206, 0.874024932843484],
            [30.403314592816173, 0.873057469903155],
            [30.402711040827906, 0.871589333861813],
            [30.403796629695965, 0.870229767687263],
            [30.40381289189755, 0.867927314540194],
            [30.405338330962973, 0.865668350555073],
            [30.405902931102187, 0.862550033934138],
            [30.40591739577489, 0.854756456551825],
            [30.40678807079605, 0.852930530775125],
            [30.408338642028166, 0.851904168243911],
            [30.409485617271134, 0.851844182685031],
            [30.413630476331413, 0.852592710020342],
            [30.415142181054474, 0.853164526749412],
            [30.415746354676898, 0.854154308221617],
            [30.41793771396413, 0.855906226784483],
            [30.419373794015012, 0.856516050086233],
            [30.420507891908354, 0.856478767879739],
            [30.423299161413684, 0.854536684813126],
            [30.423431164353136, 0.853977440610537],
            [30.421986308660244, 0.852257810234071],
            [30.41947278656269, 0.850871105644478],
            [30.416571706098704, 0.847157445923361],
            [30.414746244999723, 0.845914668961915],
            [30.413444529559197, 0.843789563304965],
            [30.41363720111965, 0.841858759976533],
            [30.412634940875687, 0.836835819318169],
            [30.413874613272814, 0.83372205765249],
            [30.416312822413612, 0.831232000097626],
            [30.420142071873524, 0.830728408111168],
            [30.423273667225928, 0.832521374215789],
            [30.424567986836745, 0.832842995510275],
            [30.425371905354172, 0.829998068251943],
            [30.424236031491496, 0.827351283050858],
            [30.424553644334924, 0.82687698068356],
            [30.427571767195598, 0.824737656652168],
            [30.427363264624894, 0.823861574614341],
            [30.427876118210474, 0.824578341668325],
            [30.430473461208898, 0.823221169823325],
            [30.433181300580532, 0.822444272801007],
            [30.43550140821093, 0.823185507692749],
            [30.43673785565618, 0.825055097354642],
            [30.441051964502524, 0.828475482712345],
            [30.443972550086254, 0.834694723101622],
            [30.448587862250715, 0.834844577625846],
            [30.448849707681298, 0.834186999745167],
            [30.445668386086364, 0.828587704693],
            [30.44356040033895, 0.825984483212835],
            [30.44108844957777, 0.8211020188165],
            [30.441200311390237, 0.81817898260814],
            [30.443293083269978, 0.815842644610933],
            [30.443652480350533, 0.81388629921473],
            [30.443444441310493, 0.810640777799972],
            [30.441763268510794, 0.808276653312566],
            [30.44013858267445, 0.807571031237306],
            [30.439617666709186, 0.8068307581669],
            [30.438534468258105, 0.801794671016775],
            [30.43579212100318, 0.795372877748209],
            [30.43368224250547, 0.793867381449963],
            [30.431196133397105, 0.790285484044094],
            [30.430819459916975, 0.788471572273654],
            [30.431357983760147, 0.785835341179679],
            [30.43072266015691, 0.78258943204616],
            [30.43083075263842, 0.781837874505505],
            [30.43207958246156, 0.780228441588493],
            [30.4265066805773, 0.778998232749473],
            [30.42129842552806, 0.779536473244632],
            [30.417339413527028, 0.78059842512727],
            [30.412032758818235, 0.782927962905751],
            [30.407888574392743, 0.783114941448068],
            [30.40398791964748, 0.784651564446084],
            [30.4005747545558, 0.78515955090012],
            [30.39919838642018, 0.785014967154589],
            [30.396206591383873, 0.785727744806256],
            [30.395267849217042, 0.786688575912399],
            [30.393090774939456, 0.787699612487095],
            [30.39187116012599, 0.787978188753298],
            [30.38842993435977, 0.787807618402721],
            [30.382697114388588, 0.790513306561685],
            [30.378324823457937, 0.791328635944467],
            [30.375751452002856, 0.791049288323454],
            [30.375037573423004, 0.791372940221404],
            [30.37159758463692, 0.790510368452048],
            [30.367714648262343, 0.791902195929765],
            [30.366338263957083, 0.791781464903114],
            [30.36217049156884, 0.793196858793703],
            [30.360960257861862, 0.793076277809098],
            [30.35963020506569, 0.793623689204855],
            [30.35882320263187, 0.793646711715105],
            [30.358041013462863, 0.793049371352436],
            [30.35687789369759, 0.793143600089243],
            [30.355174110302187, 0.793974775511114],
            [30.35348323749403, 0.79354568159882],
            [30.35238722547376, 0.794976462443784],
            [30.3522984719237, 0.79734189256103],
            [30.350744352346176, 0.798005055360354],
            [30.349647513875837, 0.800938767174098],
            [30.348482887635864, 0.80189197777837],
            [30.347399884119227, 0.803692310538273],
            [30.347215809436022, 0.807309732778475],
            [30.346299331115194, 0.808749602455091],
            [30.34670096967532, 0.809799890554384],
            [30.346687223654868, 0.810885552291324],
            [30.346241324202353, 0.81147049813538],
            [30.346626931427945, 0.812937489131602],
            [30.346314291657922, 0.813565881808843],
            [30.342133937465828, 0.817289790453664],
            [30.34125594656501, 0.818471565492836],
            [30.341150929915027, 0.819893323902315],
            [30.340020191720818, 0.821059959522438],
            [30.33722594430032, 0.819666189269005],
            [30.33606603960545, 0.81997970693543],
            [30.335469711868715, 0.822403886011836],
            [30.335467955662356, 0.825037997001331],
            [30.335110414501177, 0.826100378991552],
            [30.335332541819792, 0.827432552346691],
            [30.334836712207135, 0.828037755159913],
            [30.334429492414134, 0.827563644195879],
            [30.331237886007468, 0.827238090057624],
            [30.32853509965931, 0.825612675900519],
            [30.327039967954935, 0.825563338360935],
            [30.326780830944926, 0.824465488124133],
            [30.32571278437776, 0.824488196081579],
            [30.32510943451045, 0.823425775037468],
            [30.321954438943227, 0.82253954369276],
            [30.320389881840427, 0.82148801487935],
            [30.317637645930816, 0.821007842824337],
            [30.315787785690432, 0.820242340231501],
            [30.315290386720978, 0.81966915520256],
            [30.315352599545964, 0.818034815906014],
            [30.312009768049457, 0.816003123142888],
            [30.310895903809527, 0.815095245643467],
            [30.310375615766663, 0.814044852031038],
            [30.308537357268165, 0.813434446379145],
            [30.306162164944553, 0.814505592729867],
            [30.30521393207672, 0.813884215333525],
            [30.30388458445801, 0.814049809332732],
            [30.30222557040142, 0.812735742432549],
            [30.29849016524429, 0.811288212311019],
            [30.295433847814355, 0.808302473714176],
            [30.295506764964287, 0.807324313682909],
            [30.296256799836048, 0.805929324282996],
            [30.296164580585614, 0.804378350145791],
            [30.295242092535503, 0.802611751506938],
            [30.296312522333103, 0.801205177853284],
            [30.296114981903806, 0.798807065238194],
            [30.29495382675409, 0.797803723801847],
            [30.29477817647163, 0.796455472274039],
            [30.293474627569598, 0.795451983853452],
            [30.293432641211524, 0.792302471220539],
            [30.294753727024563, 0.790049131922998],
            [30.295632132048716, 0.78988304382464],
            [30.29646418580083, 0.789072701131621],
            [30.29751045630719, 0.7854250589748],
            [30.299472991335374, 0.785270241693654],
            [30.30010308045543, 0.784590909597684],
            [30.30077033018388, 0.783016866257553],
            [30.300872550378358, 0.780187025009253],
            [30.301951925599557, 0.779051101801576],
            [30.30259395332977, 0.778354195680845],
            [30.302242944717346, 0.775466797020594],
            [30.3015099787343, 0.773867422785586],
            [30.302378417848683, 0.77259183513003],
            [30.30162168783316, 0.771016304330394],
            [30.302526246408465, 0.769442494862839],
            [30.303806748133606, 0.770064174440772],
            [30.305151401248096, 0.767882402653671],
            [30.305844977004252, 0.76478133816075],
            [30.307365718779046, 0.76370921519955],
            [30.308402205733653, 0.761312371050401],
            [30.30781394396985, 0.758353131586392],
            [30.308301337503668, 0.757840644460721],
            [30.31117590509035, 0.756149540172591],
            [30.31938599834075, 0.75704077897221],
            [30.324871424079287, 0.755233014913349],
            [30.32771810975619, 0.755999442961451],
            [30.328834626721143, 0.755380216234192],
            [30.32934729076221, 0.753961056893387],
            [30.33134417826516, 0.752030400933808],
            [30.333211953607258, 0.74925256609186],
            [30.335395334956463, 0.749302504557914],
            [30.337271441274513, 0.748612446275389],
            [30.33848075331, 0.749257916000204],
            [30.33898080680111, 0.748280133009221],
            [30.33976331217713, 0.748686548265176],
            [30.34201860186819, 0.748330923016633],
            [30.342895563299674, 0.749023767679359],
            [30.34410159199281, 0.748952348733796],
            [30.343273677677484, 0.747328998751197],
            [30.34252517533163, 0.746815881562962],
            [30.340838830032485, 0.74662381201691],
            [30.3406727099769, 0.745644147526535],
            [30.339354552671704, 0.745201415276037],
            [30.33878473332068, 0.743648110431896],
            [30.336955899946126, 0.743408185233085],
            [30.336148520219915, 0.742189239699445],
            [30.334913416654295, 0.742331912532745],
            [30.333203430391865, 0.741494746589381],
            [30.333405748960153, 0.738376975806463],
            [30.331672304092354, 0.735461197543789],
            [30.332326027887536, 0.731340203888419],
            [30.331518736196216, 0.729356740265498],
            [30.329523778274492, 0.728232740539318],
            [30.329523914818413, 0.727238990249882],
            [30.341602449227956, 0.705527597775077],
            [30.346151548369455, 0.699162700151847],
            [30.348265601338305, 0.697020390696565],
            [30.349930542479147, 0.695940518545703],
            [30.353527204637306, 0.691509006735289],
            [30.354121160821673, 0.689741271343468],
            [30.35587894823705, 0.688117484431013],
            [30.359239994872567, 0.686148050043725],
            [30.360688866034753, 0.685933745346473],
            [30.36194778483686, 0.685169805343018],
            [30.362684204842147, 0.683832194362215],
            [30.36844413327367, 0.682700170328607],
            [30.373526917033885, 0.68418403579194],
            [30.374132633961985, 0.68369453914443],
            [30.376602873432525, 0.683409055101954],
            [30.37798055490507, 0.682645163202014],
            [30.38292092874332, 0.683436076299951],
            [30.38585433418446, 0.683353898873729],
            [30.388158361072946, 0.682590461480297],
            [30.39524875552567, 0.678615740809408],
            [30.40230336379242, 0.676851077182413],
            [30.404951859558064, 0.675741320097749],
            [30.4074933974144, 0.675431930381739],
            [30.406163441636256, 0.673041961868424],
            [30.405938126196705, 0.668275129555817],
            [30.406531998837774, 0.667224114562708],
            [30.408844412397737, 0.665296551921605],
            [30.40754777872675, 0.666600457409853],
            [30.407750432366658, 0.667213574445879],
            [30.41109962393538, 0.667317533914935],
            [30.411199984617244, 0.669463137038052],
            [30.411910010322845, 0.670280868753855],
            [30.41444742940362, 0.67007788314923],
            [30.420433351502737, 0.674167873752781],
            [30.422867243340253, 0.67784731826334],
            [30.42428630570639, 0.681321866058582],
            [30.42509529880685, 0.686839514530641],
            [30.428137802842645, 0.69113233911566],
            [30.429605331114946, 0.698744865516694],
            [30.43092230444061, 0.703241113509479],
            [30.433658992309258, 0.709883762201143],
            [30.435178531239913, 0.715095349466993],
            [30.434996784989952, 0.723115662615406],
            [30.431480876884272, 0.726984657250128],
            [30.431207583323715, 0.728143359099531],
            [30.431302447214332, 0.729481462133342],
            [30.433095224010017, 0.734822672804936],
            [30.433118704174888, 0.737116494228721],
            [30.432500929160746, 0.738740943817457],
            [30.430469716132464, 0.741284567393015],
            [30.42954308235735, 0.743338941732824],
            [30.42963770999106, 0.746445182813415],
            [30.43023625297328, 0.747296681912983],
            [30.430281603522076, 0.748561427220428],
            [30.42966065565836, 0.750851583886946],
            [30.424986276569012, 0.757063030095914],
            [30.42486587986306, 0.758088992530966],
            [30.42581114559551, 0.760547725145187],
            [30.42444069017109, 0.763922847030602],
            [30.42460366342827, 0.765808117949324],
            [30.42607483436907, 0.766048217068307],
            [30.430967416037547, 0.764191881111587],
            [30.43738694504284, 0.764711362040476],
            [30.44168795914726, 0.765951993643451],
            [30.44491330717427, 0.766703342016774],
            [30.445877518376072, 0.767675128724842],
            [30.448771257807547, 0.768712822266041],
            [30.451727781392552, 0.772340445581955],
            [30.451983974623364, 0.774153519977575],
            [30.456983265367818, 0.776778818825097],
            [30.458429485601602, 0.778398377037376],
            [30.461802729562077, 0.784308643172063],
            [30.469153147661967, 0.79455140617442],
            [30.473529013887475, 0.804306799197986],
            [30.475779856917875, 0.804955679066603],
            [30.477226240645027, 0.806332497681506],
            [30.47907226507917, 0.811513521325344],
            [30.48300681236175, 0.819771440386516],
            [30.485939023043585, 0.823698698143396],
            [30.485937645926263, 0.825883967685448],
            [30.488508339503465, 0.829365859820556],
            [30.492603952919854, 0.837138376451249],
            [30.493085134603476, 0.839081149084415],
            [30.492119411537058, 0.840456444221754],
            [30.487093409387647, 0.841707689533075],
            [30.482991886853313, 0.84324279559253],
            [30.480660056208457, 0.843484069514368],
            [30.47945375263088, 0.843887965766223],
            [30.479212072581774, 0.84461622007104],
            [30.479372403893695, 0.845344748195721],
            [30.481300701431433, 0.847450343727568],
            [30.481299651300862, 0.849069049930534],
            [30.4822635418041, 0.850526532817189],
            [30.481617829184593, 0.854330077307103],
            [30.481857937181953, 0.856029883150765],
            [30.483142259441973, 0.859268161620697],
            [30.483301785863397, 0.861210733608792],
            [30.485108490139222, 0.864813584254987],
            [30.48767893308646, 0.868538351197363],
            [30.4872764779577, 0.869185577612354],
            [30.488160541469867, 0.869752730133073],
            [30.489767167575728, 0.871939076685389],
            [30.491294085268102, 0.873073204763373],
            [30.491051903060757, 0.874529908698424],
            [30.492498576943767, 0.875421185051308],
            [30.494705390847166, 0.881857113246303],
            [30.497436805605094, 0.885339243805393],
            [30.502938477375572, 0.894286528493066],
            [30.50534645641041, 0.90043940325203],
            [30.505909346157328, 0.900358852284781],
            [30.5069558816667, 0.898498023847018],
            [30.50776026371482, 0.898012952786972],
            [30.51113636341957, 0.899391215687408],
            [30.513867454784013, 0.903359032396805],
            [30.514911127362566, 0.905706953896815],
            [30.516196462023917, 0.907407534807668],
            [30.517964788474174, 0.908299078052924],
            [30.518968870501553, 0.909756663560627],
            [30.519771195407664, 0.912286526877384],
            [30.521679319479087, 0.914513649828905],
            [30.522582219764423, 0.916942425444081],
            [30.523887440431196, 0.918966795779283],
            [30.52760317248362, 0.923421014914538],
            [30.529010167780545, 0.923624344620933],
            [30.52961265436685, 0.924434159458364],
            [30.52941108050195, 0.925243392078718],
            [30.5305154899735, 0.92696412106854],
            [30.5331280261783, 0.927977696633046],
            [30.537801475511344, 0.928335095673331],
            [30.542525877287257, 0.92773137674832],
            [30.546145086260733, 0.92651981496304],
            [30.549660375427177, 0.930265738962942],
            [30.558801279618795, 0.938366174808255],
            [30.56080989911934, 0.940694628214252],
            [30.561326674749456, 0.940502070639019],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 423,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "HAKIBAALE",
        Population: 36375,
        Key: "KABAROLEHAKIBAALE",
        Dist2: "Kabarole",
        "Sub Country": "Hakibaale",
        id2_original: "Kabarole Hakibaale",
        drought: "N",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.23812797393244, 0.669361822074127],
            [30.23809728388907, 0.670629396610904],
            [30.239556827935132, 0.673005875439941],
            [30.23938717929712, 0.67492891054737],
            [30.238818662503252, 0.67625176300849],
            [30.23319434374706, 0.678350887525539],
            [30.230856307540225, 0.679927577897644],
            [30.229572186502818, 0.682623834219501],
            [30.228372836783837, 0.686582570797879],
            [30.22731824697962, 0.686639333959582],
            [30.22674861357986, 0.68595040520606],
            [30.226522181534424, 0.683224582110156],
            [30.2255260478007, 0.680756533307364],
            [30.224244140212168, 0.679608126229088],
            [30.223417798846928, 0.679263349218214],
            [30.220681652662357, 0.679290453078687],
            [30.219969002079473, 0.679490876483918],
            [30.219930104129357, 0.679822120413159],
            [30.217731615812028, 0.679546936397995],
            [30.213883393034987, 0.680520201436016],
            [30.21232935430584, 0.681781713456072],
            [30.209476767595874, 0.686055011014258],
            [30.20719506204556, 0.69152766607955],
            [30.201670757221507, 0.691940152276062],
            [30.19955039718107, 0.693598278857554],
            [30.197144758257533, 0.697360388638636],
            [30.190802861659108, 0.695970905411627],
            [30.186527699271924, 0.696083095813656],
            [30.18397183238849, 0.696751225042825],
            [30.182733785942006, 0.693729510407536],
            [30.18312895303888, 0.691323252253792],
            [30.181976562751366, 0.690133470716136],
            [30.18169583922508, 0.689255639537778],
            [30.182146946211308, 0.687359026800189],
            [30.179503339975767, 0.687244201622746],
            [30.17863174238482, 0.68681900566968],
            [30.17686280238521, 0.681920049603333],
            [30.17697640692931, 0.680023241738111],
            [30.176639364424595, 0.67925863069964],
            [30.175374328993716, 0.678323602212837],
            [30.175319513795067, 0.675860467043587],
            [30.173858282712885, 0.673764556297988],
            [30.173360817268108, 0.672307143898965],
            [30.17940467710979, 0.67450542018897],
            [30.184868095022207, 0.673598014767246],
            [30.185601619757346, 0.673285717269174],
            [30.184752498014813, 0.671519807626728],
            [30.18171581326541, 0.668129938442527],
            [30.183297079032517, 0.667019776060543],
            [30.183807747017028, 0.666883924061544],
            [30.186431826573234, 0.668545958573635],
            [30.188666796372583, 0.668297283198643],
            [30.18954540800923, 0.669088354030979],
            [30.190722810089195, 0.669299993455591],
            [30.191879743157095, 0.670405676628507],
            [30.193434026227983, 0.667174808481656],
            [30.194617826109408, 0.665606490213489],
            [30.195411086116007, 0.664970914811427],
            [30.197054634776666, 0.664819355872358],
            [30.19833647319492, 0.663781837322018],
            [30.1997859543132, 0.665487889156903],
            [30.201761687389507, 0.66571002843503],
            [30.203946418008258, 0.666936855500408],
            [30.209158691221745, 0.663664678819174],
            [30.212636187365867, 0.662997202534323],
            [30.215162978478514, 0.663534210868536],
            [30.218128445690496, 0.661125828616781],
            [30.219040278823005, 0.661489769387512],
            [30.22177657592452, 0.661166150406932],
            [30.224151285852827, 0.66187521705938],
            [30.226793367647325, 0.66015522125569],
            [30.229301999316522, 0.659238505461825],
            [30.230707771107994, 0.659774873746381],
            [30.232207325218518, 0.662510986882374],
            [30.231408739100594, 0.663486051822321],
            [30.23290926249332, 0.66448154468244],
            [30.233269104239934, 0.666585804184357],
            [30.235472387764236, 0.668079025393733],
            [30.236155717336267, 0.669341851193266],
            [30.23812797393244, 0.669361822074127],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 424,
        District: "KABAROLE",
        County: "BURAHYA",
        Subcounty: "KARAGO TOWN COUNCIL",
        Population: 9743,
        Key: "KABAROLEKARAGO TOWN COUNCIL",
        Dist2: "Kabarole",
        "Sub Country": "Karago TC",
        id2_original: "Kabarole Karago TC",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.239195680038105, -0.226472738708534],
            [30.233911883860017, -0.222939125035093],
            [30.232083655051674, -0.223329402337222],
            [30.23130026303846, -0.222690710398107],
            [30.23001717236869, -0.220783876214141],
            [30.229331157732304, -0.21810492565007],
            [30.228503077228684, -0.217150759106321],
            [30.22760018143493, -0.216977836451744],
            [30.22638452909016, -0.213313909123841],
            [30.225556448586538, -0.212262063740261],
            [30.225124001405383, -0.210413975871594],
            [30.223482839568444, -0.208072182357038],
            [30.222990077702473, -0.205747322527135],
            [30.22148741991264, -0.205462472177836],
            [30.22049058549302, -0.205896622462343],
            [30.216294492817152, -0.208591950432668],
            [30.213749935723136, -0.211377390927802],
            [30.210967626014423, -0.212335496019068],
            [30.207649426322995, -0.214791278909865],
            [30.203379395112734, -0.215719135930528],
            [30.20230774630127, -0.218025556476302],
            [30.200254200256715, -0.220487528690765],
            [30.196846876011023, -0.222314181691014],
            [30.195388593199578, -0.223557072326477],
            [30.192502153478124, -0.224876019931283],
            [30.18580725580395, -0.224680036892244],
            [30.183739148068643, -0.225548334557396],
            [30.18406677982243, -0.223757116632989],
            [30.183650770014374, -0.221061042148171],
            [30.18411240525571, -0.218491017858571],
            [30.183547267923963, -0.21739748950652],
            [30.18371133443081, -0.215195807197335],
            [30.18116771517797, -0.212836325800466],
            [30.180334820602734, -0.211218655204956],
            [30.179516741043166, -0.210529528980217],
            [30.179457427081584, -0.209331323672922],
            [30.17834183987296, -0.208087994398407],
            [30.17762234233096, -0.206526289787652],
            [30.17727794082746, -0.206992966030724],
            [30.174854512566363, -0.20790738570734],
            [30.172425584819074, -0.211698739470935],
            [30.167762792200296, -0.212187884966204],
            [30.16637251185586, -0.211527694220941],
            [30.166084693435465, -0.210444849861378],
            [30.164585409717834, -0.208564889762348],
            [30.16214248082855, -0.207727651069273],
            [30.16058325882022, -0.207727403135903],
            [30.154654064433014, -0.209401004625992],
            [30.150199964827756, -0.208955232111769],
            [30.145835182016246, -0.209109468226324],
            [30.14047306262686, -0.20526174491697],
            [30.138333594522, -0.203198054731841],
            [30.137285207584842, -0.205905242640161],
            [30.137719225919415, -0.213134106276583],
            [30.139168439339727, -0.218772835277743],
            [30.141185458088202, -0.221359267125065],
            [30.14161375595103, -0.222480976023195],
            [30.141441595623462, -0.226421022203251],
            [30.141212535107485, -0.229095628828472],
            [30.14015529347657, -0.230360842735561],
            [30.13628983652078, -0.232827976338207],
            [30.136015443422306, -0.23262890592359],
            [30.137621208043818, -0.237079441353545],
            [30.138301977417253, -0.237630776729972],
            [30.13852312197898, -0.239781387737597],
            [30.141580026907075, -0.239709736042851],
            [30.14371242347399, -0.240451133392688],
            [30.144751765274574, -0.242520602559101],
            [30.14413709932962, -0.243758410586477],
            [30.145188513589293, -0.244409226917662],
            [30.145345365726122, -0.245466477752292],
            [30.14602354345996, -0.245005783673761],
            [30.14784803976833, -0.246081461432757],
            [30.14861840531157, -0.245403920548179],
            [30.14948340477673, -0.245548681829287],
            [30.149976718208286, -0.245205415350972],
            [30.151988400065644, -0.247166674633016],
            [30.15316337849097, -0.247817524933828],
            [30.153842346742287, -0.247627912112519],
            [30.154947505408778, -0.251459463545498],
            [30.156275994238058, -0.251739871754483],
            [30.157190486383815, -0.252625611926531],
            [30.16006464703367, -0.252815997219193],
            [30.160956656144503, -0.253267999909214],
            [30.161346080311734, -0.254099413097879],
            [30.16065422932094, -0.256114325985819],
            [30.160780304277814, -0.256783029676636],
            [30.161717242627574, -0.257641673892126],
            [30.163000656690834, -0.257560633197861],
            [30.164151262924175, -0.256178350971265],
            [30.165363843030672, -0.256142473515693],
            [30.166422053045455, -0.257218015612395],
            [30.166291688633112, -0.259477039093267],
            [30.167159578876866, -0.26056157834058],
            [30.170408398983973, -0.261872561549866],
            [30.173261959467727, -0.264023834218604],
            [30.173070083814633, -0.2672135908526],
            [30.174063771435826, -0.268930709808384],
            [30.178087546578936, -0.269320198849206],
            [30.178688518605703, -0.269907697726949],
            [30.17903756080598, -0.272519271323366],
            [30.179736366553705, -0.273359811804267],
            [30.18031376768573, -0.273974416839449],
            [30.182200788534505, -0.274706802200097],
            [30.1838038968377, -0.277516212899459],
            [30.185008795450184, -0.276714050987608],
            [30.191065907238915, -0.272855707248206],
            [30.201000874531005, -0.269719243151402],
            [30.205821396042346, -0.267381039490903],
            [30.20862747158016, -0.265600031025442],
            [30.21569110342396, -0.259519839784321],
            [30.21963006592614, -0.257568060393584],
            [30.228125306007296, -0.252029654685054],
            [30.230902182705165, -0.241354625766481],
            [30.231940204880576, -0.234974913112419],
            [30.230152942842434, -0.2327967143261],
            [30.229955825519635, -0.231649014586385],
            [30.23053589913963, -0.230284584468913],
            [30.231019811701724, -0.229362933876693],
            [30.23224889655493, -0.228450461239415],
            [30.235226241291564, -0.2268786383948],
            [30.237510879841267, -0.226011544542238],
            [30.239195680038105, -0.226472738708534],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 425,
        District: "RUBIRIZI",
        County: "KATERERA",
        Subcounty: "KATANDA",
        Population: 18828,
        Key: "RUBIRIZIKATANDA",
        Dist2: "Rubirizi",
        "Sub Country": "Katanda",
        id2_original: "Rubirizi Katanda",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.222990077702473, -0.205747322527135],
            [30.227453801857695, -0.203561263770876],
            [30.225059124177278, -0.199666544951866],
            [30.226502592871316, -0.197755588307047],
            [30.226919478536814, -0.195913312634229],
            [30.225610324147393, -0.195089321566984],
            [30.222962702442526, -0.191140606027873],
            [30.21902036586808, -0.189102973178606],
            [30.21635730661506, -0.188713194498779],
            [30.21565804003159, -0.188967674158462],
            [30.214691080883366, -0.188113748357592],
            [30.214155694855485, -0.186885479463392],
            [30.212995357172655, -0.186076489749488],
            [30.212935980329004, -0.185402424451648],
            [30.211686203681563, -0.185222563807878],
            [30.210570490708808, -0.184533376316512],
            [30.20993072673312, -0.184668052841509],
            [30.209291148708722, -0.183874184289622],
            [30.207282730430755, -0.183349604095014],
            [30.205854573520714, -0.182375813727041],
            [30.204084158487404, -0.182090965679426],
            [30.20368246243509, -0.182585172228695],
            [30.20174848215484, -0.181955852555993],
            [30.200201011008744, -0.182884208187804],
            [30.195961041919443, -0.181820175292411],
            [30.194413693842545, -0.182463933518189],
            [30.193625239822754, -0.182373940749148],
            [30.19133418820021, -0.181355155737894],
            [30.18962352640466, -0.180051770523393],
            [30.186410143038923, -0.179047796731974],
            [30.185874631246914, -0.178208930640295],
            [30.18575587755959, -0.176860988077965],
            [30.183687893791824, -0.176740811133097],
            [30.18043007256557, -0.174598562031863],
            [30.17973105661206, -0.173310362292066],
            [30.17845165352654, -0.17262123633673],
            [30.17799057973225, -0.171782433737057],
            [30.178095082545887, -0.169261718314865],
            [30.177634009649893, -0.168437851792516],
            [30.178244148984106, -0.167289202528087],
            [30.17864584413816, -0.167244330972552],
            [30.178497216077755, -0.166495397916705],
            [30.179122042866876, -0.166046188267258],
            [30.179092416428805, -0.165536921091673],
            [30.17742625447751, -0.164787797529129],
            [30.178884537288916, -0.162361636598956],
            [30.178497903288932, -0.161545332676526],
            [30.17918216890547, -0.1613957206567],
            [30.179941310897576, -0.159343838244891],
            [30.177663990922493, -0.155022056083717],
            [30.176991640559887, -0.155931919454149],
            [30.177313186227646, -0.156432343886881],
            [30.17675756744464, -0.157256429189687],
            [30.173015038647257, -0.158403862711564],
            [30.172839515027295, -0.159139695088385],
            [30.165231302898693, -0.163621021920763],
            [30.14819470861961, -0.170305084478552],
            [30.146704938060843, -0.171812398705268],
            [30.14648044008818, -0.174519671451432],
            [30.14528463242639, -0.178580445091518],
            [30.144317942772727, -0.187261449355226],
            [30.144632234544556, -0.187258336709374],
            [30.14663938709624, -0.187345442283793],
            [30.149177878765457, -0.186805616066032],
            [30.151835438532345, -0.186922417991336],
            [30.15376110580292, -0.187698162094357],
            [30.155417331488888, -0.187620919072317],
            [30.158190765842576, -0.18634178061476],
            [30.160386190904767, -0.186419648866566],
            [30.16381401650192, -0.187428436290697],
            [30.166240384050614, -0.188669639020109],
            [30.17167044122832, -0.193362476662082],
            [30.17255639838907, -0.193168680615065],
            [30.172899342825215, -0.192597355331802],
            [30.174178872573194, -0.192462741749819],
            [30.175190581297294, -0.191699059472194],
            [30.176172791144108, -0.190036706618535],
            [30.17653011131974, -0.188074752701258],
            [30.177692685807607, -0.187102880485781],
            [30.18258998812293, -0.191109404118387],
            [30.187064054582006, -0.19372368448206],
            [30.18538029283764, -0.196119720024084],
            [30.1852762436732, -0.199071163152287],
            [30.18582638093635, -0.201198099359657],
            [30.184635978437598, -0.202336188597594],
            [30.183014192363014, -0.202920071914618],
            [30.181080150099035, -0.202904699141594],
            [30.17997912547946, -0.203518646166061],
            [30.17762234233096, -0.206526289787652],
            [30.17834183987296, -0.208087994398407],
            [30.179457427081584, -0.209331323672922],
            [30.179516741043166, -0.210529528980217],
            [30.180334820602734, -0.211218655204956],
            [30.18116771517797, -0.212836325800466],
            [30.18371133443081, -0.215195807197335],
            [30.183547267923963, -0.21739748950652],
            [30.18411240525571, -0.218491017858571],
            [30.183650770014374, -0.221061042148171],
            [30.18406677982243, -0.223757116632989],
            [30.183739148068643, -0.225548334557396],
            [30.18580725580395, -0.224680036892244],
            [30.192502153478124, -0.224876019931283],
            [30.195388593199578, -0.223557072326477],
            [30.196846876011023, -0.222314181691014],
            [30.200254200256715, -0.220487528690765],
            [30.20230774630127, -0.218025556476302],
            [30.203379395112734, -0.215719135930528],
            [30.207649426322995, -0.214791278909865],
            [30.210967626014423, -0.212335496019068],
            [30.213749935723136, -0.211377390927802],
            [30.216294492817152, -0.208591950432668],
            [30.22049058549302, -0.205896622462343],
            [30.22148741991264, -0.205462472177836],
            [30.222990077702473, -0.205747322527135],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 426,
        District: "RUBIRIZI",
        County: "KATERERA",
        Subcounty: "KATERERA",
        Population: 10489,
        Key: "RUBIRIZIKATERERA",
        Dist2: "Rubirizi",
        "Sub Country": "Katerera",
        id2_original: "Rubirizi Katerera",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.17762234233096, -0.206526289787652],
            [30.17997912547946, -0.203518646166061],
            [30.181080150099035, -0.202904699141594],
            [30.183014192363014, -0.202920071914618],
            [30.184635978437598, -0.202336188597594],
            [30.18582638093635, -0.201198099359657],
            [30.1852762436732, -0.199071163152287],
            [30.18538029283764, -0.196119720024084],
            [30.187064054582006, -0.19372368448206],
            [30.18258998812293, -0.191109404118387],
            [30.177692685807607, -0.187102880485781],
            [30.17653011131974, -0.188074752701258],
            [30.176172791144108, -0.190036706618535],
            [30.175190581297294, -0.191699059472194],
            [30.174178872573194, -0.192462741749819],
            [30.172899342825215, -0.192597355331802],
            [30.17255639838907, -0.193168680615065],
            [30.17167044122832, -0.193362476662082],
            [30.166240384050614, -0.188669639020109],
            [30.16381401650192, -0.187428436290697],
            [30.160386190904767, -0.186419648866566],
            [30.158190765842576, -0.18634178061476],
            [30.155417331488888, -0.187620919072317],
            [30.15376110580292, -0.187698162094357],
            [30.151835438532345, -0.186922417991336],
            [30.149177878765457, -0.186805616066032],
            [30.14663938709624, -0.187345442283793],
            [30.144632234544556, -0.187258336709374],
            [30.14325571010208, -0.194361411014664],
            [30.141248801892132, -0.197529567238083],
            [30.139760298856235, -0.201405756232344],
            [30.138333594522, -0.203198054731841],
            [30.14047306262686, -0.20526174491697],
            [30.145835182016246, -0.209109468226324],
            [30.150199964827756, -0.208955232111769],
            [30.154654064433014, -0.209401004625992],
            [30.16058325882022, -0.207727403135903],
            [30.16214248082855, -0.207727651069273],
            [30.164585409717834, -0.208564889762348],
            [30.166084693435465, -0.210444849861378],
            [30.16637251185586, -0.211527694220941],
            [30.167762792200296, -0.212187884966204],
            [30.172425584819074, -0.211698739470935],
            [30.174854512566363, -0.20790738570734],
            [30.17727794082746, -0.206992966030724],
            [30.17762234233096, -0.206526289787652],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 427,
        District: "RUBIRIZI",
        County: "KATERERA",
        Subcounty: "KATERERA TOWN COUNCIL",
        Population: 9070,
        Key: "RUBIRIZIKATERERA TOWN COUNCIL",
        Dist2: "Rubirizi",
        "Sub Country": "Katerera T.C",
        id2_original: "Rubirizi Katerera T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.67605435722683, -0.336100344650577],
            [29.70711638127457, -0.335444707922649],
            [29.74351825457745, -0.333946397491923],
            [29.789917848783222, -0.331187014357451],
            [29.8070227276003, -0.321294881007475],
            [29.827682123215684, -0.305913918204727],
            [29.842344124347484, -0.298766821889459],
            [29.858731560967954, -0.312262192990777],
            [29.86121466880495, -0.312679589878632],
            [29.86245591864375, -0.313929929940801],
            [29.864525286715374, -0.313930549769028],
            [29.866180967123974, -0.313306058423691],
            [29.86721540681803, -0.314139684307328],
            [29.86866421779311, -0.313306800421034],
            [29.870733718815405, -0.312890758197379],
            [29.87099457250593, -0.313196937205439],
            [29.873144143064486, -0.310553606387108],
            [29.87616789207375, -0.312237033349932],
            [29.87720250154942, -0.312237340569211],
            [29.88090431600315, -0.308512814759951],
            [29.886635100391874, -0.306431336827481],
            [29.89419721726828, -0.301465969862928],
            [29.89881345739241, -0.300746182223335],
            [29.90693298069925, -0.294899511507233],
            [29.91083538715928, -0.285205689128534],
            [29.915891011255216, -0.278356473655186],
            [29.927752668998973, -0.266581264601481],
            [29.939930434908085, -0.264180525688981],
            [29.955175430981132, -0.249561166323209],
            [29.96281972304479, -0.233457375731315],
            [29.994363616885625, -0.207584146145157],
            [30.0014136060152, -0.202524913579433],
            [30.00502324703255, -0.198481496378755],
            [30.025603511851177, -0.170783644554793],
            [30.02659532199344, -0.170033885188725],
            [30.032380119385273, -0.167712738408341],
            [30.042379994448176, -0.160467997291448],
            [30.048991072119815, -0.158309513017614],
            [30.061387284949802, -0.153486369213155],
            [30.06725512619975, -0.148824890883005],
            [30.069321104927834, -0.148409532852465],
            [30.077172274509813, -0.144001236527345],
            [30.082296222669623, -0.140342492284549],
            [30.087350522648837, -0.138489400900168],
            [30.08956885295415, -0.136936966554854],
            [30.095353866839957, -0.134859461099051],
            [30.107089023825417, -0.13202361859255],
            [30.11436168285602, -0.129530572001326],
            [30.11940285485562, -0.128537195919687],
            [30.125766325393908, -0.128040929173213],
            [30.132377923190106, -0.126207362597046],
            [30.142048121933612, -0.115970602210585],
            [30.14270907267528, -0.117551972491774],
            [30.14155163655084, -0.121798782868478],
            [30.138327728523215, -0.129786260622574],
            [30.137418181603085, -0.134195718426446],
            [30.13882286463645, -0.136527166170613],
            [30.14030998786007, -0.140186923408113],
            [30.13981389054948, -0.141849487062624],
            [30.136011878907258, -0.145589914610578],
            [30.136011659718335, -0.147342893006364],
            [30.137085838185623, -0.149086973481434],
            [30.137333531557232, -0.151083956540885],
            [30.135265921488593, -0.162731045713406],
            [30.133778058053192, -0.163977798055981],
            [30.13328191403018, -0.16672465599109],
            [30.134790925604015, -0.169625416735204],
            [30.139014143808204, -0.172824778383859],
            [30.141251645958345, -0.173340164663574],
            [30.142096806130446, -0.172969814319408],
            [30.14447861813941, -0.170656944932942],
            [30.14819470861961, -0.170305084478552],
            [30.165231302898693, -0.163621021920763],
            [30.172839515027295, -0.159139695088385],
            [30.173015038647257, -0.158403862711564],
            [30.17675756744464, -0.157256429189687],
            [30.177313186227646, -0.156432343886881],
            [30.176991640559887, -0.155931919454149],
            [30.177663990922493, -0.155022056083717],
            [30.17740115554847, -0.154460257143811],
            [30.17819059142689, -0.154254321807206],
            [30.178746256922278, -0.153047585987585],
            [30.179331044002573, -0.152753316914625],
            [30.182021467735776, -0.148161895107467],
            [30.183015507496602, -0.148456363667732],
            [30.183074076754792, -0.147691076161514],
            [30.18425828626799, -0.146970079918333],
            [30.184755561269913, -0.145027465050326],
            [30.18756256566577, -0.143408907258384],
            [30.188293434082624, -0.14399768819315],
            [30.18896596141332, -0.143497381155074],
            [30.18905375466435, -0.142820394903871],
            [30.190895805849998, -0.142173058335732],
            [30.19098356406674, -0.141790417623736],
            [30.190515778958932, -0.141643186893989],
            [30.190340422425592, -0.141054474170774],
            [30.19086687919953, -0.139523932770959],
            [30.191393141039054, -0.139671168903942],
            [30.19206580311705, -0.137993473018014],
            [30.19376157893003, -0.138111407099452],
            [30.193907640503653, -0.139200509682666],
            [30.19592505001927, -0.1392007468372],
            [30.195954326114375, -0.138876968910998],
            [30.197767095815035, -0.138671135838751],
            [30.198571249691064, -0.137685163121558],
            [30.200501064483305, -0.136714034981407],
            [30.200852266233536, -0.133623410508509],
            [30.201671006953173, -0.13291706172152],
            [30.202519166600016, -0.130562361702505],
            [30.202256099460644, -0.129855894251401],
            [30.2034842186249, -0.128708064039346],
            [30.203630475132965, -0.128089944725932],
            [30.20468309493174, -0.127589662511396],
            [30.203733278334063, -0.123571685763912],
            [30.20379188711816, -0.122276552565194],
            [30.202856312410994, -0.121864368719092],
            [30.202797973121495, -0.120510352798216],
            [30.20323659981348, -0.119921696173122],
            [30.202856547769606, -0.119509569783298],
            [30.203032044440118, -0.118803147849645],
            [30.20124866312401, -0.117448963793083],
            [30.200605413685047, -0.117596076984441],
            [30.19934838224334, -0.115535510378829],
            [30.198295900785112, -0.114681797273115],
            [30.19070900837319, -0.1113991026961],
            [30.189832041551792, -0.109632941776326],
            [30.18974441359076, -0.108691025774512],
            [30.19027076077025, -0.107925773910798],
            [30.193253287887767, -0.104717659298271],
            [30.194232951010743, -0.102377682958701],
            [30.196747623850214, -0.099699329561161],
            [30.196776916115002, -0.099022333231564],
            [30.198238967359035, -0.097050318474101],
            [30.198356047484975, -0.095431411088959],
            [30.19926251498028, -0.09422465192171],
            [30.201806367795108, -0.092193842229419],
            [30.20199654203907, -0.090501348316636],
            [30.200885754529036, -0.087027945472543],
            [30.19995021305953, -0.086027092233328],
            [30.19942411740833, -0.083348478882434],
            [30.19698311540532, -0.080399090932388],
            [30.193909997682972, -0.08197417291238],
            [30.19103040671722, -0.084583301745993],
            [30.189701313321752, -0.084830101024177],
            [30.189281471300674, -0.086139703113604],
            [30.18816355116725, -0.086233803329794],
            [30.184452027721925, -0.088495050713878],
            [30.18390701983907, -0.088070396921941],
            [30.182796617706256, -0.085560003843515],
            [30.183516826713923, -0.08507740964498],
            [30.183942800635158, -0.082023588287241],
            [30.184676600254747, -0.081556231253704],
            [30.186886940943943, -0.077183805280536],
            [30.186185744779245, -0.074720671851615],
            [30.18487999680138, -0.072198204607227],
            [30.183520008546672, -0.072171223729084],
            [30.183008684792014, -0.073146306456698],
            [30.180502542354475, -0.074004712478234],
            [30.17917111513592, -0.073308177348808],
            [30.174760286479586, -0.07383666208295],
            [30.16948446105301, -0.072861029601793],
            [30.16573736342412, -0.072931374818134],
            [30.159927456323484, -0.075913033444093],
            [30.156141547881074, -0.072514432894632],
            [30.149172907488683, -0.077370439094217],
            [30.138041964549846, -0.079330863943326],
            [30.13401177992718, -0.080969026499297],
            [30.125442998366974, -0.086376647874326],
            [30.123769452264007, -0.087826250386699],
            [30.121844915074046, -0.091302843967318],
            [30.116566453990416, -0.095271903753027],
            [30.106579502091197, -0.101504464392494],
            [30.10289304433725, -0.101574561620659],
            [30.099837503950074, -0.100152064504461],
            [30.09572111878936, -0.097423810481914],
            [30.093679650593785, -0.096713861253661],
            [30.091537115640563, -0.097905945475944],
            [30.08777279012118, -0.10314906595076],
            [30.084392264416998, -0.110871082948551],
            [30.081908449605887, -0.114604730060868],
            [30.080127703946822, -0.115461164160338],
            [30.07622757561433, -0.114618887481433],
            [30.075107751052496, -0.113891414346133],
            [30.070505880379635, -0.112472921584638],
            [30.0679745348085, -0.112189513538637],
            [30.065161859348276, -0.112661162290816],
            [30.061786585195257, -0.113982227553616],
            [30.057473564208763, -0.117474047398057],
            [30.050628879647494, -0.124080261282754],
            [30.04922240896671, -0.125684641382638],
            [30.04819075943991, -0.128987979272413],
            [30.04725310064131, -0.130120486947496],
            [30.037314788921428, -0.135027277606777],
            [30.01959523876948, -0.13983861617141],
            [30.01665814035421, -0.140946384711526],
            [30.011542368660116, -0.143347459092095],
            [30.00879725369576, -0.145210218623838],
            [30.00505877001214, -0.148627138219193],
            [30.000931895223854, -0.153870544040595],
            [29.999306452107728, -0.155104226478456],
            [29.992852740409287, -0.162954261786923],
            [29.99159401923654, -0.165267850734118],
            [29.990609568093067, -0.16854448135569],
            [29.988774783379775, -0.171992706839272],
            [29.987221291724662, -0.172642453549102],
            [29.983460086952558, -0.173080532969942],
            [29.98055771830447, -0.172737952114866],
            [29.97559770819243, -0.171195787076884],
            [29.973868091046064, -0.171447269316446],
            [29.9710006884221, -0.170770113291788],
            [29.967427575599118, -0.170753790077259],
            [29.964881406029185, -0.172014901414981],
            [29.963713904281967, -0.173217921580428],
            [29.96169944842701, -0.181948091151074],
            [29.960076170250716, -0.185429428565994],
            [29.957475447790213, -0.18734462302462],
            [29.954522879487392, -0.188432837206954],
            [29.94687309063253, -0.186520346781674],
            [29.94065484264138, -0.184017503466405],
            [29.93108135831797, -0.177831144174455],
            [29.92714416639517, -0.176789722370888],
            [29.924857768045857, -0.177886659791529],
            [29.923050671206234, -0.17935535053321],
            [29.921324207146515, -0.181556046774032],
            [29.9195861754809, -0.182416508101518],
            [29.917356884830795, -0.18267662475161],
            [29.908189392303385, -0.182130080824261],
            [29.906103433246763, -0.182970732576683],
            [29.903422301686838, -0.186316198527396],
            [29.90718186433861, -0.19573070776305],
            [29.907359751426107, -0.198169526824277],
            [29.904100757898448, -0.200608912359917],
            [29.8971580392919, -0.203380637960702],
            [29.8884662846575, -0.208885563733062],
            [29.86695910129781, -0.209486282922743],
            [29.83298743494315, -0.209375016538338],
            [29.69936918809343, -0.210555151454068],
            [29.69933447988581, -0.210557686482693],
            [29.67605435722683, -0.336100344650577],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 428,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "KATUNGURU",
        Population: 3805,
        Key: "RUBIRIZIKATUNGURU",
        Dist2: "Rubirizi",
        "Sub Country": "Katunguru",
        id2_original: "Rubirizi Katunguru",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.134654404138697, -0.232468769966776],
            [30.131742244752342, -0.231549436252353],
            [30.130807287187785, -0.231883219634514],
            [30.12839498366315, -0.231579183720016],
            [30.126736322644447, -0.231851970196606],
            [30.12387182157884, -0.230788877519275],
            [30.12341974710707, -0.229301195856692],
            [30.1243853318329, -0.226265588820793],
            [30.123149366782965, -0.224030970448042],
            [30.122727981456237, -0.219871774042743],
            [30.12031592945988, -0.217806956626282],
            [30.11880920769169, -0.21225113131827],
            [30.117090920097713, -0.209215024060436],
            [30.11666934792139, -0.205617465601317],
            [30.11799687645164, -0.201792551331357],
            [30.121494767047643, -0.202552170091465],
            [30.12167602102086, -0.200943187797797],
            [30.12408857427712, -0.200245373575242],
            [30.125355789020855, -0.195892191568733],
            [30.126954200033463, -0.194860283936709],
            [30.12885399223061, -0.19501239658002],
            [30.129216124681225, -0.19331235814109],
            [30.128975056384842, -0.192037283161723],
            [30.128221289911405, -0.191369277197659],
            [30.12273310544661, -0.190700461830014],
            [30.120924065551034, -0.189501005525371],
            [30.119054962498932, -0.186252352902639],
            [30.117728183163624, -0.185553914649058],
            [30.114290543472016, -0.185553350510039],
            [30.112933451385782, -0.186099554771077],
            [30.110460395696805, -0.188315295982215],
            [30.10976681904236, -0.188315171117093],
            [30.1092543077149, -0.187768657007866],
            [30.108953301127816, -0.18430777368639],
            [30.1059008581317, -0.185841076689413],
            [30.100488989143557, -0.185788206621375],
            [30.10088118371514, -0.183407730186091],
            [30.099647656692856, -0.180463298396498],
            [30.09741435686164, -0.178984493661198],
            [30.097291103513083, -0.177742226660725],
            [30.096279456772713, -0.176375470736589],
            [30.095613380244075, -0.174569068681377],
            [30.093503331964754, -0.173711580397558],
            [30.093565333685685, -0.171661759993658],
            [30.091702667062584, -0.167338263808147],
            [30.09108615507973, -0.163995121096956],
            [30.090654331329393, -0.163373926036528],
            [30.09100002730525, -0.162330455302311],
            [30.090617581251102, -0.161435970411586],
            [30.091148467617728, -0.15980855200696],
            [30.090852399069753, -0.158583596047623],
            [30.091173467732077, -0.157043168146759],
            [30.091728792766002, -0.156819689701909],
            [30.0912229684975, -0.156359980368749],
            [30.091358908752802, -0.154861734341182],
            [30.09023619610737, -0.152985774929933],
            [30.09087789864743, -0.152700113482646],
            [30.090310511934177, -0.150793092044326],
            [30.090458950450056, -0.14781154073887],
            [30.089977690612987, -0.147786669166351],
            [30.088965668376833, -0.148904633163297],
            [30.08849684661321, -0.148780332798548],
            [30.088608034689187, -0.147190222133163],
            [30.08813933689306, -0.145505557687692],
            [30.087547074931287, -0.145170087415689],
            [30.086770057363378, -0.142474134960879],
            [30.087350522648837, -0.138489400900168],
            [30.082296222669623, -0.140342492284549],
            [30.077172274509813, -0.144001236527345],
            [30.069321104927834, -0.148409532852465],
            [30.06725512619975, -0.148824890883005],
            [30.061387284949802, -0.153486369213155],
            [30.048991072119815, -0.158309513017614],
            [30.042379994448176, -0.160467997291448],
            [30.032380119385273, -0.167712738408341],
            [30.02659532199344, -0.170033885188725],
            [30.025603511851177, -0.170783644554793],
            [30.00502324703255, -0.198481496378755],
            [30.0014136060152, -0.202524913579433],
            [29.994363616885625, -0.207584146145157],
            [29.96281972304479, -0.233457375731315],
            [29.955175430981132, -0.249561166323209],
            [29.939930434908085, -0.264180525688981],
            [29.927752668998973, -0.266581264601481],
            [29.915891011255216, -0.278356473655186],
            [29.91083538715928, -0.285205689128534],
            [29.90693298069925, -0.294899511507233],
            [29.89881345739241, -0.300746182223335],
            [29.89419721726828, -0.301465969862928],
            [29.886635100391874, -0.306431336827481],
            [29.88090431600315, -0.308512814759951],
            [29.87720250154942, -0.312237340569211],
            [29.87616789207375, -0.312237033349932],
            [29.873144143064486, -0.310553606387108],
            [29.87099457250593, -0.313196937205439],
            [29.870733718815405, -0.312890758197379],
            [29.86866421779311, -0.313306800421034],
            [29.86721540681803, -0.314139684307328],
            [29.866180967123974, -0.313306058423691],
            [29.864525286715374, -0.313930549769028],
            [29.86245591864375, -0.313929929940801],
            [29.86121466880495, -0.312679589878632],
            [29.858731560967954, -0.312262192990777],
            [29.842344124347484, -0.298766821889459],
            [29.827682123215684, -0.305913918204727],
            [29.8070227276003, -0.321294881007475],
            [29.789917848783222, -0.331187014357451],
            [29.74351825457745, -0.333946397491923],
            [29.70711638127457, -0.335444707922649],
            [29.67605435722683, -0.336100344650577],
            [29.675972457822386, -0.336541842836819],
            [29.750643298847315, -0.355716576073057],
            [29.819641692976354, -0.374273855297749],
            [29.840862257166574, -0.386526065822307],
            [29.84473064442679, -0.387416848178557],
            [29.846444107169425, -0.385853722647919],
            [29.848041143759637, -0.385211519013673],
            [29.8494012182526, -0.385535472923317],
            [29.851870282726768, -0.387339143885887],
            [29.856916541885866, -0.388319307373385],
            [29.859247554165464, -0.389644621556192],
            [29.86133291314749, -0.390121502743244],
            [29.86408838029717, -0.395048658987829],
            [29.864309435027348, -0.397115895368216],
            [29.86364526023213, -0.400330354333734],
            [29.864229094199906, -0.402487595664187],
            [29.862968336546444, -0.404050383003384],
            [29.863489767246342, -0.405783358792572],
            [29.86252716133399, -0.406515345187124],
            [29.86212443311738, -0.407562891815616],
            [29.86178628748149, -0.412681987282801],
            [29.86057922213254, -0.412809278848906],
            [29.86061120125835, -0.413206483784935],
            [29.862009694899406, -0.415263814561542],
            [29.86194133939447, -0.416771532342604],
            [29.862699761836033, -0.417556402840046],
            [29.863424863068754, -0.417673229232701],
            [29.865638930868048, -0.419856359132455],
            [29.867343775173822, -0.42286142187064],
            [29.869238217903455, -0.424476041060715],
            [29.86909232341649, -0.425541454099679],
            [29.872354528421305, -0.425891153196701],
            [29.87305089793797, -0.426314961237711],
            [29.873754749522654, -0.428354783576748],
            [29.873458378242425, -0.429510589209267],
            [29.874305384452466, -0.429871092757608],
            [29.875429007091324, -0.431296705804943],
            [29.874155046898085, -0.433229638435872],
            [29.874678986592617, -0.435513354363011],
            [29.873536991609587, -0.436642688119357],
            [29.873332115537657, -0.438042183035257],
            [29.87204082774094, -0.439514684320182],
            [29.87222875799332, -0.444209125120067],
            [29.87265494032368, -0.444940091007799],
            [29.87410938822715, -0.446085614078636],
            [29.875710222894387, -0.446228918869397],
            [29.87665343148482, -0.44780815758222],
            [29.87849604052423, -0.44801448890809],
            [29.88016782053934, -0.447200767653156],
            [29.881169513946368, -0.448355650530318],
            [29.882136208091616, -0.448472325535998],
            [29.882379831196648, -0.448923557924034],
            [29.88355564415688, -0.448552567785085],
            [29.884618377189145, -0.449851861859257],
            [29.88633995531202, -0.450004113520626],
            [29.887674219410247, -0.45127613443198],
            [29.88891377861967, -0.451627351330627],
            [29.889940488310703, -0.451653706183928],
            [29.89054202447948, -0.451165755567752],
            [29.891620005515378, -0.449278094108946],
            [29.891284567401744, -0.448547050501689],
            [29.891765572117272, -0.448122380461012],
            [29.892840038045463, -0.448672333795763],
            [29.89347168484422, -0.448184357828121],
            [29.893957061660213, -0.44867153342139],
            [29.89552530455063, -0.448300256715862],
            [29.896493540204865, -0.448750976192198],
            [29.897216313902707, -0.448380300445256],
            [29.900235827355424, -0.448459395581898],
            [29.90383335818444, -0.449440904255288],
            [29.904405824870608, -0.449196730804795],
            [29.90480237447468, -0.446840057434532],
            [29.91179142998021, -0.430620075246079],
            [29.91605472382584, -0.422310805510719],
            [29.92077206394534, -0.414235865178559],
            [29.931774177692635, -0.39756992802891],
            [29.93827167417637, -0.389276677421339],
            [29.945674167613305, -0.380829125637747],
            [29.96157328902851, -0.365476694206589],
            [29.969918952428326, -0.358544856920828],
            [29.984498493606896, -0.348230972519435],
            [29.9954119975346, -0.341558553907431],
            [30.0005632356144, -0.339071280440149],
            [30.01529766161935, -0.329210607128575],
            [30.02591958857547, -0.3172332672031],
            [30.03129955838788, -0.312139002556492],
            [30.03624661479351, -0.306601842713322],
            [30.040733864927684, -0.302537242670051],
            [30.044337858236887, -0.299276506464029],
            [30.049002678353283, -0.292925968439002],
            [30.052303063554305, -0.290198176871077],
            [30.059144831285828, -0.28835674294201],
            [30.065152279714095, -0.287463785704393],
            [30.070911780547494, -0.284501636039281],
            [30.073513216270364, -0.283119868014576],
            [30.078977766060024, -0.279263080435078],
            [30.082950328248806, -0.274890862189887],
            [30.08682467942422, -0.272452200269474],
            [30.088696995750077, -0.271838231156571],
            [30.08988675505508, -0.270692160785526],
            [30.09067756625422, -0.264673472747996],
            [30.091604739018532, -0.262353496554069],
            [30.094989394278038, -0.256459685231647],
            [30.094738172323993, -0.255342733842917],
            [30.095061319687904, -0.252397717840372],
            [30.09584910086957, -0.252459853705526],
            [30.097880345338883, -0.251506109015628],
            [30.102526719449216, -0.246415086359778],
            [30.104318645540317, -0.245331189118154],
            [30.106568351303565, -0.244735315089934],
            [30.112370246330187, -0.244711881851169],
            [30.114400778435503, -0.244102681409183],
            [30.117108019529134, -0.243959815540529],
            [30.123128264458618, -0.242813541444174],
            [30.126441397651845, -0.241200487908514],
            [30.13156133752884, -0.239902608933203],
            [30.134245640141724, -0.234683894642297],
            [30.134654404138697, -0.232468769966776],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 429,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "KICHWAMBA",
        Population: 16641,
        Key: "RUBIRIZIKICHWAMBA",
        Dist2: "Rubirizi",
        "Sub Country": "Kichwamba",
        id2_original: "Rubirizi Kichwamba",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.14819470861961, -0.170305084478552],
            [30.14447861813941, -0.170656944932942],
            [30.142096806130446, -0.172969814319408],
            [30.141251645958345, -0.173340164663574],
            [30.139014143808204, -0.172824778383859],
            [30.134790925604015, -0.169625416735204],
            [30.13328191403018, -0.16672465599109],
            [30.133778058053192, -0.163977798055981],
            [30.135265921488593, -0.162731045713406],
            [30.137333531557232, -0.151083956540885],
            [30.137085838185623, -0.149086973481434],
            [30.136011659718335, -0.147342893006364],
            [30.136011878907258, -0.145589914610578],
            [30.13981389054948, -0.141849487062624],
            [30.14030998786007, -0.140186923408113],
            [30.13882286463645, -0.136527166170613],
            [30.137418181603085, -0.134195718426446],
            [30.138327728523215, -0.129786260622574],
            [30.14155163655084, -0.121798782868478],
            [30.14270907267528, -0.117551972491774],
            [30.142048121933612, -0.115970602210585],
            [30.132377923190106, -0.126207362597046],
            [30.125766325393908, -0.128040929173213],
            [30.11940285485562, -0.128537195919687],
            [30.11436168285602, -0.129530572001326],
            [30.107089023825417, -0.13202361859255],
            [30.095353866839957, -0.134859461099051],
            [30.08956885295415, -0.136936966554854],
            [30.087350522648837, -0.138489400900168],
            [30.086770057363378, -0.142474134960879],
            [30.087547074931287, -0.145170087415689],
            [30.08813933689306, -0.145505557687692],
            [30.088608034689187, -0.147190222133163],
            [30.08849684661321, -0.148780332798548],
            [30.088965668376833, -0.148904633163297],
            [30.089977690612987, -0.147786669166351],
            [30.090458950450056, -0.14781154073887],
            [30.090310511934177, -0.150793092044326],
            [30.09087789864743, -0.152700113482646],
            [30.09023619610737, -0.152985774929933],
            [30.091358908752802, -0.154861734341182],
            [30.0912229684975, -0.156359980368749],
            [30.091728792766002, -0.156819689701909],
            [30.091173467732077, -0.157043168146759],
            [30.090852399069753, -0.158583596047623],
            [30.091148467617728, -0.15980855200696],
            [30.090617581251102, -0.161435970411586],
            [30.09100002730525, -0.162330455302311],
            [30.090654331329393, -0.163373926036528],
            [30.09108615507973, -0.163995121096956],
            [30.091702667062584, -0.167338263808147],
            [30.093565333685685, -0.171661759993658],
            [30.093503331964754, -0.173711580397558],
            [30.095613380244075, -0.174569068681377],
            [30.096279456772713, -0.176375470736589],
            [30.097291103513083, -0.177742226660725],
            [30.09741435686164, -0.178984493661198],
            [30.099647656692856, -0.180463298396498],
            [30.10088118371514, -0.183407730186091],
            [30.100488989143557, -0.185788206621375],
            [30.1059008581317, -0.185841076689413],
            [30.108953301127816, -0.18430777368639],
            [30.1092543077149, -0.187768657007866],
            [30.10976681904236, -0.188315171117093],
            [30.110460395696805, -0.188315295982215],
            [30.112933451385782, -0.186099554771077],
            [30.114290543472016, -0.185553350510039],
            [30.117728183163624, -0.185553914649058],
            [30.119054962498932, -0.186252352902639],
            [30.120924065551034, -0.189501005525371],
            [30.12273310544661, -0.190700461830014],
            [30.128221289911405, -0.191369277197659],
            [30.128975056384842, -0.192037283161723],
            [30.129216124681225, -0.19331235814109],
            [30.12885399223061, -0.19501239658002],
            [30.126954200033463, -0.194860283936709],
            [30.125355789020855, -0.195892191568733],
            [30.12408857427712, -0.200245373575242],
            [30.12167602102086, -0.200943187797797],
            [30.121494767047643, -0.202552170091465],
            [30.11799687645164, -0.201792551331357],
            [30.11666934792139, -0.205617465601317],
            [30.117090920097713, -0.209215024060436],
            [30.11880920769169, -0.21225113131827],
            [30.12031592945988, -0.217806956626282],
            [30.122727981456237, -0.219871774042743],
            [30.123149366782965, -0.224030970448042],
            [30.1243853318329, -0.226265588820793],
            [30.12341974710707, -0.229301195856692],
            [30.12387182157884, -0.230788877519275],
            [30.126736322644447, -0.231851970196606],
            [30.12839498366315, -0.231579183720016],
            [30.130807287187785, -0.231883219634514],
            [30.131742244752342, -0.231549436252353],
            [30.134654404138697, -0.232468769966776],
            [30.136015443422306, -0.23262890592359],
            [30.13628983652078, -0.232827976338207],
            [30.14015529347657, -0.230360842735561],
            [30.141212535107485, -0.229095628828472],
            [30.141441595623462, -0.226421022203251],
            [30.14161375595103, -0.222480976023195],
            [30.141185458088202, -0.221359267125065],
            [30.139168439339727, -0.218772835277743],
            [30.137719225919415, -0.213134106276583],
            [30.137285207584842, -0.205905242640161],
            [30.138333594522, -0.203198054731841],
            [30.139760298856235, -0.201405756232344],
            [30.141248801892132, -0.197529567238083],
            [30.14325571010208, -0.194361411014664],
            [30.144632234544556, -0.187258336709374],
            [30.144317942772727, -0.187261449355226],
            [30.14528463242639, -0.178580445091518],
            [30.14648044008818, -0.174519671451432],
            [30.146704938060843, -0.171812398705268],
            [30.14819470861961, -0.170305084478552],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 430,
        District: "RUBIRIZI",
        County: "KATERERA",
        Subcounty: "KIRUGU",
        Population: 11302,
        Key: "RUBIRIZIKIRUGU",
        Dist2: "Rubirizi",
        "Sub Country": "Kirugu",
        id2_original: "Rubirizi Kirugu",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.215992643610324, -0.078385607191027],
            [30.21531037584696, -0.077490939894695],
            [30.210624751646883, -0.076957483932589],
            [30.20962879577962, -0.077472503786988],
            [30.20206013467636, -0.078149755631542],
            [30.19698311540532, -0.080399090932388],
            [30.19942411740833, -0.083348478882434],
            [30.19995021305953, -0.086027092233328],
            [30.200885754529036, -0.087027945472543],
            [30.20199654203907, -0.090501348316636],
            [30.201806367795108, -0.092193842229419],
            [30.19926251498028, -0.09422465192171],
            [30.198356047484975, -0.095431411088959],
            [30.198238967359035, -0.097050318474101],
            [30.196776916115002, -0.099022333231564],
            [30.196747623850214, -0.099699329561161],
            [30.194232951010743, -0.102377682958701],
            [30.193253287887767, -0.104717659298271],
            [30.19027076077025, -0.107925773910798],
            [30.18974441359076, -0.108691025774512],
            [30.189832041551792, -0.109632941776326],
            [30.19070900837319, -0.1113991026961],
            [30.198295900785112, -0.114681797273115],
            [30.19934838224334, -0.115535510378829],
            [30.200605413685047, -0.117596076984441],
            [30.20124866312401, -0.117448963793083],
            [30.203032044440118, -0.118803147849645],
            [30.202856547769606, -0.119509569783298],
            [30.20323659981348, -0.119921696173122],
            [30.202797973121495, -0.120510352798216],
            [30.202856312410994, -0.121864368719092],
            [30.20379188711816, -0.122276552565194],
            [30.203733278334063, -0.123571685763912],
            [30.20468309493174, -0.127589662511396],
            [30.203630475132965, -0.128089944725932],
            [30.2034842186249, -0.128708064039346],
            [30.202256099460644, -0.129855894251401],
            [30.202519166600016, -0.130562361702505],
            [30.201671006953173, -0.13291706172152],
            [30.200852266233536, -0.133623410508509],
            [30.200501064483305, -0.136714034981407],
            [30.198571249691064, -0.137685163121558],
            [30.197767095815035, -0.138671135838751],
            [30.195954326114375, -0.138876968910998],
            [30.19592505001927, -0.1392007468372],
            [30.193907640503653, -0.139200509682666],
            [30.19376157893003, -0.138111407099452],
            [30.19206580311705, -0.137993473018014],
            [30.191393141039054, -0.139671168903942],
            [30.19086687919953, -0.139523932770959],
            [30.190340422425592, -0.141054474170774],
            [30.190515778958932, -0.141643186893989],
            [30.19098356406674, -0.141790417623736],
            [30.190895805849998, -0.142173058335732],
            [30.18905375466435, -0.142820394903871],
            [30.18896596141332, -0.143497381155074],
            [30.188293434082624, -0.14399768819315],
            [30.18756256566577, -0.143408907258384],
            [30.184755561269913, -0.145027465050326],
            [30.18425828626799, -0.146970079918333],
            [30.183074076754792, -0.147691076161514],
            [30.183015507496602, -0.148456363667732],
            [30.182021467735776, -0.148161895107467],
            [30.179331044002573, -0.152753316914625],
            [30.178746256922278, -0.153047585987585],
            [30.17819059142689, -0.154254321807206],
            [30.17740115554847, -0.154460257143811],
            [30.177663990922493, -0.155022056083717],
            [30.179941310897576, -0.159343838244891],
            [30.17918216890547, -0.1613957206567],
            [30.178497903288932, -0.161545332676526],
            [30.178884537288916, -0.162361636598956],
            [30.17742625447751, -0.164787797529129],
            [30.179092416428805, -0.165536921091673],
            [30.179122042866876, -0.166046188267258],
            [30.178497216077755, -0.166495397916705],
            [30.17864584413816, -0.167244330972552],
            [30.178244148984106, -0.167289202528087],
            [30.177634009649893, -0.168437851792516],
            [30.178095082545887, -0.169261718314865],
            [30.17799057973225, -0.171782433737057],
            [30.17845165352654, -0.17262123633673],
            [30.17973105661206, -0.173310362292066],
            [30.18043007256557, -0.174598562031863],
            [30.183687893791824, -0.176740811133097],
            [30.18575587755959, -0.176860988077965],
            [30.185874631246914, -0.178208930640295],
            [30.186410143038923, -0.179047796731974],
            [30.18962352640466, -0.180051770523393],
            [30.19133418820021, -0.181355155737894],
            [30.193625239822754, -0.182373940749148],
            [30.194413693842545, -0.182463933518189],
            [30.195961041919443, -0.181820175292411],
            [30.200201011008744, -0.182884208187804],
            [30.20174848215484, -0.181955852555993],
            [30.20368246243509, -0.182585172228695],
            [30.204084158487404, -0.182090965679426],
            [30.205854573520714, -0.182375813727041],
            [30.207282730430755, -0.183349604095014],
            [30.209291148708722, -0.183874184289622],
            [30.20993072673312, -0.184668052841509],
            [30.210570490708808, -0.184533376316512],
            [30.211686203681563, -0.185222563807878],
            [30.212935980329004, -0.185402424451648],
            [30.212995357172655, -0.186076489749488],
            [30.214155694855485, -0.186885479463392],
            [30.214691080883366, -0.188113748357592],
            [30.21565804003159, -0.188967674158462],
            [30.21635730661506, -0.188713194498779],
            [30.21902036586808, -0.189102973178606],
            [30.222962702442526, -0.191140606027873],
            [30.225610324147393, -0.195089321566984],
            [30.226919478536814, -0.195913312634229],
            [30.226502592871316, -0.197755588307047],
            [30.225059124177278, -0.199666544951866],
            [30.227453801857695, -0.203561263770876],
            [30.222990077702473, -0.205747322527135],
            [30.223482839568444, -0.208072182357038],
            [30.225124001405383, -0.210413975871594],
            [30.225556448586538, -0.212262063740261],
            [30.22638452909016, -0.213313909123841],
            [30.22760018143493, -0.216977836451744],
            [30.228503077228684, -0.217150759106321],
            [30.229331157732304, -0.21810492565007],
            [30.23001717236869, -0.220783876214141],
            [30.23130026303846, -0.222690710398107],
            [30.232083655051674, -0.223329402337222],
            [30.233911883860017, -0.222939125035093],
            [30.239195680038105, -0.226472738708534],
            [30.241971240704057, -0.226997398337076],
            [30.244052689319652, -0.228217763496018],
            [30.24491976928303, -0.229618635474566],
            [30.246654259789814, -0.230667240327868],
            [30.24908290995764, -0.230839408242281],
            [30.250817977182827, -0.229619765546106],
            [30.250991924259523, -0.226474970106293],
            [30.250124964670384, -0.224378255579648],
            [30.25064571534565, -0.222977639112978],
            [30.252380571466727, -0.222110421960822],
            [30.260534303517897, -0.220539501234914],
            [30.265366449229013, -0.218869381008818],
            [30.269094940951714, -0.218624944014964],
            [30.273332203417095, -0.216146152458163],
            [30.2761271524218, -0.215183090735878],
            [30.27728842165759, -0.215376008869559],
            [30.28405895837697, -0.211271710243327],
            [30.285454180353767, -0.209338007992344],
            [30.286320544359857, -0.206997540222293],
            [30.28516425628234, -0.204349465760118],
            [30.285399169322414, -0.201078066312698],
            [30.284884445444373, -0.200020638021719],
            [30.284495379704946, -0.195538163089122],
            [30.283532626468865, -0.194688519860349],
            [30.283480126228703, -0.190477217343945],
            [30.284431452894367, -0.189031427247346],
            [30.28641371672281, -0.187459273492769],
            [30.285442206709355, -0.186031258016781],
            [30.285403730967406, -0.183509894161297],
            [30.28375943670505, -0.180798512960406],
            [30.28372281328922, -0.17994901903329],
            [30.281769470721372, -0.179533023848613],
            [30.281661176118913, -0.178656408957768],
            [30.28059609309387, -0.177336837783855],
            [30.281283459694787, -0.175701223619603],
            [30.281201200065905, -0.174201053970227],
            [30.281061969281676, -0.172863544105241],
            [30.27998284109718, -0.170622193760279],
            [30.280462005164686, -0.16933899465152],
            [30.281477257742605, -0.168968614585787],
            [30.28182253510351, -0.168254731910604],
            [30.281012486482595, -0.166528534830966],
            [30.27867389871017, -0.165760063472301],
            [30.277154672393248, -0.164232593361431],
            [30.276112384118548, -0.16438608247298],
            [30.275720944131802, -0.162090617760726],
            [30.274226711641017, -0.161412640357929],
            [30.272708598336724, -0.159957476829874],
            [30.27080646512994, -0.155131460603119],
            [30.270199438458175, -0.155031975244758],
            [30.26914569576529, -0.155989763557618],
            [30.267454838228485, -0.154109852571351],
            [30.26736202249672, -0.152700070363639],
            [30.268281935975185, -0.150757231422329],
            [30.268179745425105, -0.150287294674501],
            [30.26706143991443, -0.149347309757819],
            [30.266304909324855, -0.148018780485992],
            [30.265443913650916, -0.147602974182538],
            [30.264351116701025, -0.144467014221253],
            [30.262907909416707, -0.142894411361646],
            [30.26157901095568, -0.142523740675744],
            [30.2606512596763, -0.140860834812443],
            [30.260248853056584, -0.140942120421774],
            [30.260311054203505, -0.140345689379061],
            [30.259312190489638, -0.138691815894353],
            [30.258984513820057, -0.13900807135304],
            [30.258505149428267, -0.138700760393413],
            [30.258178481566762, -0.137534960747693],
            [30.256277120012818, -0.13663105424141],
            [30.256069416044397, -0.133928995873984],
            [30.255518800877525, -0.133630717385161],
            [30.255461924045303, -0.133016202224249],
            [30.254823874055173, -0.133214944063012],
            [30.253207305395765, -0.131660422599899],
            [30.2528748793333, -0.129202354484292],
            [30.251825652471325, -0.12891306266238],
            [30.251594071282657, -0.127738245287175],
            [30.248152723345566, -0.126644424258121],
            [30.246894384855146, -0.124918256310456],
            [30.246210625888406, -0.125053738102615],
            [30.24608154786357, -0.124104858894185],
            [30.243895800351915, -0.124176928763622],
            [30.24272029641215, -0.123029133334702],
            [30.241481466634735, -0.122604277893795],
            [30.240413553916568, -0.125495940829076],
            [30.238784513946058, -0.125305999703695],
            [30.238524724759134, -0.125667443177913],
            [30.235975398509293, -0.122124770865068],
            [30.236006321216315, -0.12143798073732],
            [30.23518943731438, -0.120461930118207],
            [30.23450042769484, -0.118428595196245],
            [30.234563484037864, -0.117570111235817],
            [30.233305825572117, -0.116115074368136],
            [30.232034193812122, -0.115590822233303],
            [30.232423326925193, -0.114840811335852],
            [30.23141093368484, -0.11379245612978],
            [30.230140385293076, -0.113692931975564],
            [30.22863677888231, -0.111605314172356],
            [30.228180545210748, -0.111505868163936],
            [30.228277486904656, -0.11120766578207],
            [30.22589828539993, -0.110620062686032],
            [30.224443493441704, -0.108478239520339],
            [30.22206361730219, -0.1076647275445],
            [30.217883088836935, -0.103118937403251],
            [30.217068239619127, -0.10292006239891],
            [30.21619048497521, -0.103615804659754],
            [30.213422726177512, -0.103977029219188],
            [30.212248592168557, -0.103389550849906],
            [30.21191913054652, -0.101853305719143],
            [30.214720619286524, -0.095338163396736],
            [30.215204357575452, -0.093395334651183],
            [30.215992643610324, -0.078385607191027],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 431,
        District: "RUBIRIZI",
        County: "KATERERA",
        Subcounty: "KYABAKARA",
        Population: 12761,
        Key: "RUBIRIZIKYABAKARA",
        Dist2: "Rubirizi",
        "Sub Country": "Kyabakara",
        id2_original: "Rubirizi Kyabakara",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.136015443422306, -0.23262890592359],
            [30.134654404138697, -0.232468769966776],
            [30.134245640141724, -0.234683894642297],
            [30.13156133752884, -0.239902608933203],
            [30.126441397651845, -0.241200487908514],
            [30.123128264458618, -0.242813541444174],
            [30.117108019529134, -0.243959815540529],
            [30.114400778435503, -0.244102681409183],
            [30.112370246330187, -0.244711881851169],
            [30.106568351303565, -0.244735315089934],
            [30.104318645540317, -0.245331189118154],
            [30.102526719449216, -0.246415086359778],
            [30.097880345338883, -0.251506109015628],
            [30.09584910086957, -0.252459853705526],
            [30.095061319687904, -0.252397717840372],
            [30.094738172323993, -0.255342733842917],
            [30.094989394278038, -0.256459685231647],
            [30.091604739018532, -0.262353496554069],
            [30.09067756625422, -0.264673472747996],
            [30.08988675505508, -0.270692160785526],
            [30.09275650857015, -0.272160870031632],
            [30.09538869093027, -0.276096398145102],
            [30.096458214327733, -0.276966507873155],
            [30.098432945782545, -0.277505460191629],
            [30.103452931914497, -0.27555994484688],
            [30.105057530522775, -0.275560319440003],
            [30.10286879431617, -0.273920838335062],
            [30.10184814645665, -0.272523021747257],
            [30.101776583067842, -0.271801711457982],
            [30.102260468680498, -0.271011970927979],
            [30.102887543952757, -0.270444081209539],
            [30.10450870569825, -0.270011619973682],
            [30.104294138601073, -0.268302956020519],
            [30.102664538980108, -0.266643541430947],
            [30.10062262072862, -0.265858547214218],
            [30.098384008260798, -0.263964589157848],
            [30.098052750008193, -0.263279272580025],
            [30.100650370586056, -0.262170871868316],
            [30.09930740271102, -0.260096742708441],
            [30.098609449464504, -0.257296050576223],
            [30.099147023788383, -0.256466623749418],
            [30.102747978096968, -0.253744424841616],
            [30.103983818281115, -0.254457047755138],
            [30.10469995881886, -0.256011600167398],
            [30.10536278703946, -0.255831429563142],
            [30.106508312401555, -0.259695275365202],
            [30.1106730296195, -0.259813452916244],
            [30.113717909699215, -0.261049531859476],
            [30.114344673256117, -0.261707848178727],
            [30.11429898494074, -0.265790613750298],
            [30.11243569398855, -0.267322981107827],
            [30.110268084360786, -0.268305270055303],
            [30.109139183221345, -0.269729582645758],
            [30.109254998519333, -0.272196614491786],
            [30.110015765563787, -0.274409421034616],
            [30.10913780879895, -0.275594002280298],
            [30.109513380944506, -0.277893363446463],
            [30.108478113003763, -0.278846082934471],
            [30.11073525502091, -0.280189044709688],
            [30.11308051008939, -0.283100746708857],
            [30.114036979610034, -0.282139053506338],
            [30.115656953782704, -0.282019500869003],
            [30.116276529918995, -0.281539979681183],
            [30.115848581500803, -0.277798495281432],
            [30.116230153494136, -0.276263631965471],
            [30.127023080154505, -0.272284917887422],
            [30.130835351455577, -0.270079299193778],
            [30.13133567623791, -0.270199349612301],
            [30.13362203865464, -0.272957983774668],
            [30.1357182097594, -0.274613400043316],
            [30.143365256057724, -0.276246192275236],
            [30.148979192984193, -0.276974128192663],
            [30.14962433158022, -0.278373881901617],
            [30.151014174445063, -0.27978213340572],
            [30.154257685508853, -0.281444923799961],
            [30.160600826273928, -0.2835067425249],
            [30.165031611004313, -0.286611282621359],
            [30.16676514839855, -0.28874540579891],
            [30.167511791231803, -0.289016881311971],
            [30.16792742554408, -0.291836073763769],
            [30.16908120193208, -0.292960160566744],
            [30.1698944072329, -0.294693696725193],
            [30.171124184687194, -0.29492261227708],
            [30.172051455367857, -0.294313290380463],
            [30.174073759803456, -0.294286043939001],
            [30.17475727892, -0.293380864852983],
            [30.175274505504394, -0.290934326000221],
            [30.175938900386864, -0.290780875065685],
            [30.1761564813318, -0.288752908432892],
            [30.17716274357037, -0.286976248277784],
            [30.178163927632607, -0.286192706166058],
            [30.1784930757426, -0.284388351793151],
            [30.179605407456645, -0.283989004357765],
            [30.18071758376216, -0.284567334415773],
            [30.182448767570364, -0.284601834686991],
            [30.18285793760586, -0.286060785719982],
            [30.183790563143955, -0.286061013889235],
            [30.184183677590358, -0.286447543352108],
            [30.185430078368977, -0.284744621037309],
            [30.18563472626881, -0.283192959443392],
            [30.186290878210215, -0.283199349980281],
            [30.18830927407601, -0.281486096685882],
            [30.18408221198071, -0.27808876538207],
            [30.183931484557522, -0.277713949535299],
            [30.185008795450184, -0.276714050987608],
            [30.1838038968377, -0.277516212899459],
            [30.182200788534505, -0.274706802200097],
            [30.18031376768573, -0.273974416839449],
            [30.179736366553705, -0.273359811804267],
            [30.17903756080598, -0.272519271323366],
            [30.178688518605703, -0.269907697726949],
            [30.178087546578936, -0.269320198849206],
            [30.174063771435826, -0.268930709808384],
            [30.173070083814633, -0.2672135908526],
            [30.173261959467727, -0.264023834218604],
            [30.170408398983973, -0.261872561549866],
            [30.167159578876866, -0.26056157834058],
            [30.166291688633112, -0.259477039093267],
            [30.166422053045455, -0.257218015612395],
            [30.165363843030672, -0.256142473515693],
            [30.164151262924175, -0.256178350971265],
            [30.163000656690834, -0.257560633197861],
            [30.161717242627574, -0.257641673892126],
            [30.160780304277814, -0.256783029676636],
            [30.16065422932094, -0.256114325985819],
            [30.161346080311734, -0.254099413097879],
            [30.160956656144503, -0.253267999909214],
            [30.16006464703367, -0.252815997219193],
            [30.157190486383815, -0.252625611926531],
            [30.156275994238058, -0.251739871754483],
            [30.154947505408778, -0.251459463545498],
            [30.153842346742287, -0.247627912112519],
            [30.15316337849097, -0.247817524933828],
            [30.151988400065644, -0.247166674633016],
            [30.149976718208286, -0.245205415350972],
            [30.14948340477673, -0.245548681829287],
            [30.14861840531157, -0.245403920548179],
            [30.14784803976833, -0.246081461432757],
            [30.14602354345996, -0.245005783673761],
            [30.145345365726122, -0.245466477752292],
            [30.145188513589293, -0.244409226917662],
            [30.14413709932962, -0.243758410586477],
            [30.144751765274574, -0.242520602559101],
            [30.14371242347399, -0.240451133392688],
            [30.141580026907075, -0.239709736042851],
            [30.13852312197898, -0.239781387737597],
            [30.138301977417253, -0.237630776729972],
            [30.137621208043818, -0.237079441353545],
            [30.136015443422306, -0.23262890592359],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 432,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "MAGAMBO",
        Population: 11557,
        Key: "RUBIRIZIMAGAMBO",
        Dist2: "Rubirizi",
        "Sub Country": "Magambo",
        id2_original: "Rubirizi Magambo",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.11308051008939, -0.283100746708857],
            [30.11073525502091, -0.280189044709688],
            [30.108478113003763, -0.278846082934471],
            [30.109513380944506, -0.277893363446463],
            [30.10913780879895, -0.275594002280298],
            [30.110015765563787, -0.274409421034616],
            [30.109254998519333, -0.272196614491786],
            [30.109139183221345, -0.269729582645758],
            [30.110268084360786, -0.268305270055303],
            [30.11243569398855, -0.267322981107827],
            [30.11429898494074, -0.265790613750298],
            [30.114344673256117, -0.261707848178727],
            [30.113717909699215, -0.261049531859476],
            [30.1106730296195, -0.259813452916244],
            [30.106508312401555, -0.259695275365202],
            [30.10536278703946, -0.255831429563142],
            [30.10469995881886, -0.256011600167398],
            [30.103983818281115, -0.254457047755138],
            [30.102747978096968, -0.253744424841616],
            [30.099147023788383, -0.256466623749418],
            [30.098609449464504, -0.257296050576223],
            [30.09930740271102, -0.260096742708441],
            [30.100650370586056, -0.262170871868316],
            [30.098052750008193, -0.263279272580025],
            [30.098384008260798, -0.263964589157848],
            [30.10062262072862, -0.265858547214218],
            [30.102664538980108, -0.266643541430947],
            [30.104294138601073, -0.268302956020519],
            [30.10450870569825, -0.270011619973682],
            [30.102887543952757, -0.270444081209539],
            [30.102260468680498, -0.271011970927979],
            [30.101776583067842, -0.271801711457982],
            [30.10184814645665, -0.272523021747257],
            [30.10286879431617, -0.273920838335062],
            [30.105057530522775, -0.275560319440003],
            [30.10583911063401, -0.276264630880431],
            [30.10559179365652, -0.278128467754979],
            [30.10012411144145, -0.281021393008495],
            [30.098681563520568, -0.281398995290119],
            [30.09719779460621, -0.281232947304591],
            [30.094988276773815, -0.283111970123016],
            [30.096442880984146, -0.286987379162825],
            [30.095714761412072, -0.288522556367584],
            [30.097812621349604, -0.290387016489689],
            [30.09970503747995, -0.291215818445141],
            [30.099374718865143, -0.295689112070247],
            [30.100115047440237, -0.296559160125005],
            [30.103200802662016, -0.296725644461878],
            [30.10460020988973, -0.294903554770779],
            [30.1069044478823, -0.294199993656043],
            [30.108755676256862, -0.294987423069407],
            [30.11220787853755, -0.295222650992929],
            [30.11270776314537, -0.295996397378116],
            [30.113805475676486, -0.296414173979326],
            [30.115757143784677, -0.295972648035518],
            [30.114428864262855, -0.291337993134893],
            [30.11091691233769, -0.287604072937423],
            [30.11308051008939, -0.283100746708857],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 433,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "RUBIRIZIRI TOWN COUNCIL",
        Population: 8204,
        Key: "RUBIRIZIRUBIRIZIRI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.167517136207735, -0.309180641385821],
            [30.167385595002354, -0.309465631349762],
            [30.15857003725048, -0.306942191529678],
            [30.146521832659875, -0.305719121310158],
            [30.139103662722896, -0.305970157329612],
            [30.13054411225056, -0.305118498278321],
            [30.126107018651958, -0.306771457480433],
            [30.12400032737686, -0.306929936888418],
            [30.12275823761331, -0.307435639802778],
            [30.121013948283416, -0.305916963450114],
            [30.11949129040211, -0.305336075237589],
            [30.117386031939912, -0.303276800935178],
            [30.11598752482413, -0.304159241369841],
            [30.115898522440702, -0.305305329036917],
            [30.11492243910413, -0.306495849315081],
            [30.114950751306946, -0.307724991071252],
            [30.11287926860112, -0.307923035292146],
            [30.107997847601712, -0.303353812425345],
            [30.107258143355743, -0.303105334711095],
            [30.105531417886265, -0.305339203126999],
            [30.103904006561358, -0.304991233060896],
            [30.102868108901585, -0.305437754998587],
            [30.100352240404504, -0.307869916879727],
            [30.098773956145834, -0.308217074787014],
            [30.09694935203965, -0.30742214460655],
            [30.094730490830017, -0.305733416896085],
            [30.0916603447346, -0.30585102894622],
            [30.083485241762848, -0.308212887800057],
            [30.079540379125827, -0.310779096378405],
            [30.062727049432524, -0.310909970904395],
            [30.05732404322298, -0.311613223715046],
            [30.05044642372846, -0.310084340552018],
            [30.04484666670874, -0.307959501874387],
            [30.043067196657383, -0.306124859387574],
            [30.040733864927684, -0.302537242670051],
            [30.03624661479351, -0.306601842713322],
            [30.03129955838788, -0.312139002556492],
            [30.02591958857547, -0.3172332672031],
            [30.01529766161935, -0.329210607128575],
            [30.0005632356144, -0.339071280440149],
            [29.9954119975346, -0.341558553907431],
            [29.984498493606896, -0.348230972519435],
            [29.969918952428326, -0.358544856920828],
            [29.96157328902851, -0.365476694206589],
            [29.945674167613305, -0.380829125637747],
            [29.93827167417637, -0.389276677421339],
            [29.931774177692635, -0.39756992802891],
            [29.92077206394534, -0.414235865178559],
            [29.91605472382584, -0.422310805510719],
            [29.91179142998021, -0.430620075246079],
            [29.90480237447468, -0.446840057434532],
            [29.904405824870608, -0.449196730804795],
            [29.905353483714965, -0.448952286961517],
            [29.906552359123474, -0.447091593331508],
            [29.907305527318947, -0.446720891450315],
            [29.909055226303458, -0.446439755154037],
            [29.911321408965662, -0.446826345068709],
            [29.9151283658335, -0.444169258187528],
            [29.916760036969503, -0.444438933310517],
            [29.91757310392977, -0.444004981019542],
            [29.91887373151051, -0.44449157659542],
            [29.92053212033969, -0.444020899586703],
            [29.922465612834714, -0.444290355532771],
            [29.928774890706872, -0.447319376691092],
            [29.929861669842644, -0.447282479515201],
            [29.930371926398756, -0.446641083952572],
            [29.931730409975355, -0.446603990946488],
            [29.935510670709583, -0.447919433886744],
            [29.936513813099165, -0.448870402646846],
            [29.939288806928182, -0.44445497853539],
            [29.94227451138687, -0.434544293242557],
            [29.947436593030467, -0.421552338956719],
            [29.953391299571777, -0.411511186663289],
            [29.960045695803014, -0.402439360018399],
            [29.97028804772068, -0.393721001111998],
            [29.976940819797903, -0.389053973131643],
            [29.98175477642116, -0.387205576437471],
            [29.9934884745426, -0.386375592451876],
            [30.0005465431198, -0.386554551650035],
            [30.00529140402634, -0.385226869976608],
            [30.010023866385314, -0.383515146263242],
            [30.017189969951847, -0.378148906267333],
            [30.021526104590627, -0.376049941050139],
            [30.042014522061347, -0.367533954915223],
            [30.048625783887594, -0.365202003960152],
            [30.057722866463042, -0.360986160240862],
            [30.067914265039473, -0.358048228535074],
            [30.07643481245879, -0.354356745079788],
            [30.083821403918574, -0.351994295325209],
            [30.08895195469571, -0.351489997814353],
            [30.092386687439046, -0.355138265295306],
            [30.09343835232871, -0.355562141582786],
            [30.09548459147674, -0.355175602154482],
            [30.097269661625564, -0.355302661917631],
            [30.099530599024813, -0.357505777053631],
            [30.102390598632535, -0.358231835202322],
            [30.10631561299335, -0.361815224076481],
            [30.112694570487132, -0.366575113755422],
            [30.118776431760256, -0.369287821758059],
            [30.123756039518508, -0.372343557760301],
            [30.13191530878509, -0.373575103956588],
            [30.137472753358292, -0.372799822209589],
            [30.13952102808874, -0.371942068704515],
            [30.147234467971376, -0.372613233496425],
            [30.151369385376405, -0.373391675465946],
            [30.15484040556566, -0.373239186090058],
            [30.15608051005246, -0.373555851672641],
            [30.16075273588006, -0.377876648101566],
            [30.163435258032024, -0.379621508365331],
            [30.16577666381947, -0.380616258361072],
            [30.169985758710794, -0.381647771877873],
            [30.173530399430838, -0.381712191332474],
            [30.175201841679378, -0.382309134621564],
            [30.17892511239368, -0.381717171481892],
            [30.178730027958352, -0.380828341425837],
            [30.176900784952053, -0.379642885104914],
            [30.176400765596927, -0.377892026924759],
            [30.17480017167818, -0.375826392019003],
            [30.175025451185146, -0.375077097277055],
            [30.177145926209942, -0.375408898182627],
            [30.177500974546216, -0.37486005637596],
            [30.176388322133604, -0.37339710656483],
            [30.17537236347987, -0.372890103679016],
            [30.17545037228085, -0.372541585384217],
            [30.176878633395457, -0.372176073105623],
            [30.176922039989975, -0.371766548781133],
            [30.175502860842887, -0.370781460753118],
            [30.17491494313384, -0.368707444865627],
            [30.17284680755076, -0.367086067711605],
            [30.172872988051406, -0.366397704607702],
            [30.17385983140845, -0.365988479150057],
            [30.173063659063693, -0.365587404820707],
            [30.17315992791944, -0.364932692708134],
            [30.17437933162882, -0.365422261000867],
            [30.174692318148526, -0.36458717890558],
            [30.172354768828622, -0.362833701004445],
            [30.170544127236887, -0.360854942337493],
            [30.169092441652896, -0.36039289493852],
            [30.168789801030325, -0.359425599141766],
            [30.16919683397376, -0.358667648825145],
            [30.16887687203586, -0.357726489717983],
            [30.170313705773236, -0.357587515864717],
            [30.171196781138566, -0.356838424409607],
            [30.168972513867526, -0.356433985550819],
            [30.168557150846475, -0.355992401156003],
            [30.168510307297662, -0.354908860636993],
            [30.1704130019515, -0.352951848959205],
            [30.17214148632226, -0.352630072236096],
            [30.172920739796943, -0.351732812354973],
            [30.171953106912234, -0.350436344059295],
            [30.17158862087562, -0.349013784102944],
            [30.17091350370193, -0.34900486759088],
            [30.170437693943718, -0.34821179204572],
            [30.170931276869833, -0.347445149773416],
            [30.170810263919574, -0.346896160753912],
            [30.16967649121634, -0.34662570273807],
            [30.16910549956387, -0.345736751548969],
            [30.168817199646494, -0.343694727423952],
            [30.16938936899029, -0.34075908993486],
            [30.169031464909747, -0.339648666952696],
            [30.167720950470986, -0.338204217417821],
            [30.16755026427879, -0.337142635597631],
            [30.166695095077763, -0.337888328549705],
            [30.16550772618974, -0.337658461747801],
            [30.164449232307305, -0.336431985263665],
            [30.164287518488152, -0.335655427515027],
            [30.164279483956246, -0.33394367115134],
            [30.164872241788053, -0.332485202798864],
            [30.165392129182344, -0.332523963552349],
            [30.167267621951037, -0.330950026572159],
            [30.1671102263335, -0.329954672961318],
            [30.16762593296843, -0.329714572535691],
            [30.167473322676397, -0.328966985347172],
            [30.16790326715114, -0.328504835791513],
            [30.16962508063262, -0.327874673466054],
            [30.17069522027442, -0.326051668400313],
            [30.17115602457412, -0.324009692276244],
            [30.17064938373702, -0.323724125104531],
            [30.168509327235665, -0.325158708019921],
            [30.16819415152163, -0.324532260857127],
            [30.166851877145987, -0.324205836280279],
            [30.168373677136195, -0.322554563256658],
            [30.167807254315264, -0.321263077553136],
            [30.16628625741893, -0.319988490530016],
            [30.166282186254044, -0.319289199794231],
            [30.166887346226645, -0.319173532716994],
            [30.166989857475325, -0.318302666355622],
            [30.16647014076095, -0.31762897530096],
            [30.166981608246044, -0.317290195264869],
            [30.166389806221716, -0.315273677059621],
            [30.166645722771424, -0.314420012849216],
            [30.167562195702377, -0.313459273685035],
            [30.16774582661781, -0.312000681122473],
            [30.16659973891034, -0.311069415925342],
            [30.167149639018255, -0.31042175450404],
            [30.16675768789012, -0.310026958808495],
            [30.167517136207735, -0.309180641385821],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 434,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "RUTOTO",
        Population: 13251,
        Key: "RUBIRIZIRUTOTO",
        Dist2: "Rubirizi",
        "Sub Country": "Rutoto",
        id2_original: "Rubirizi Rutoto",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.174073759803456, -0.294286043939001],
            [30.172051455367857, -0.294313290380463],
            [30.171124184687194, -0.29492261227708],
            [30.1698944072329, -0.294693696725193],
            [30.16908120193208, -0.292960160566744],
            [30.16792742554408, -0.291836073763769],
            [30.167511791231803, -0.289016881311971],
            [30.16676514839855, -0.28874540579891],
            [30.165031611004313, -0.286611282621359],
            [30.160600826273928, -0.2835067425249],
            [30.154257685508853, -0.281444923799961],
            [30.151014174445063, -0.27978213340572],
            [30.14962433158022, -0.278373881901617],
            [30.148979192984193, -0.276974128192663],
            [30.143365256057724, -0.276246192275236],
            [30.1357182097594, -0.274613400043316],
            [30.13362203865464, -0.272957983774668],
            [30.13133567623791, -0.270199349612301],
            [30.130835351455577, -0.270079299193778],
            [30.127023080154505, -0.272284917887422],
            [30.116230153494136, -0.276263631965471],
            [30.115848581500803, -0.277798495281432],
            [30.116276529918995, -0.281539979681183],
            [30.115656953782704, -0.282019500869003],
            [30.114036979610034, -0.282139053506338],
            [30.11308051008939, -0.283100746708857],
            [30.11091691233769, -0.287604072937423],
            [30.114428864262855, -0.291337993134893],
            [30.115757143784677, -0.295972648035518],
            [30.113805475676486, -0.296414173979326],
            [30.11270776314537, -0.295996397378116],
            [30.11220787853755, -0.295222650992929],
            [30.108755676256862, -0.294987423069407],
            [30.1069044478823, -0.294199993656043],
            [30.10460020988973, -0.294903554770779],
            [30.103200802662016, -0.296725644461878],
            [30.100115047440237, -0.296559160125005],
            [30.099374718865143, -0.295689112070247],
            [30.09970503747995, -0.291215818445141],
            [30.097812621349604, -0.290387016489689],
            [30.095714761412072, -0.288522556367584],
            [30.096442880984146, -0.286987379162825],
            [30.094988276773815, -0.283111970123016],
            [30.09719779460621, -0.281232947304591],
            [30.098681563520568, -0.281398995290119],
            [30.10012411144145, -0.281021393008495],
            [30.10559179365652, -0.278128467754979],
            [30.10583911063401, -0.276264630880431],
            [30.105057530522775, -0.275560319440003],
            [30.103452931914497, -0.27555994484688],
            [30.098432945782545, -0.277505460191629],
            [30.096458214327733, -0.276966507873155],
            [30.09538869093027, -0.276096398145102],
            [30.09275650857015, -0.272160870031632],
            [30.08988675505508, -0.270692160785526],
            [30.088696995750077, -0.271838231156571],
            [30.08682467942422, -0.272452200269474],
            [30.082950328248806, -0.274890862189887],
            [30.078977766060024, -0.279263080435078],
            [30.073513216270364, -0.283119868014576],
            [30.070911780547494, -0.284501636039281],
            [30.065152279714095, -0.287463785704393],
            [30.059144831285828, -0.28835674294201],
            [30.052303063554305, -0.290198176871077],
            [30.049002678353283, -0.292925968439002],
            [30.044337858236887, -0.299276506464029],
            [30.040733864927684, -0.302537242670051],
            [30.043067196657383, -0.306124859387574],
            [30.04484666670874, -0.307959501874387],
            [30.05044642372846, -0.310084340552018],
            [30.05732404322298, -0.311613223715046],
            [30.062727049432524, -0.310909970904395],
            [30.079540379125827, -0.310779096378405],
            [30.083485241762848, -0.308212887800057],
            [30.0916603447346, -0.30585102894622],
            [30.094730490830017, -0.305733416896085],
            [30.09694935203965, -0.30742214460655],
            [30.098773956145834, -0.308217074787014],
            [30.100352240404504, -0.307869916879727],
            [30.102868108901585, -0.305437754998587],
            [30.103904006561358, -0.304991233060896],
            [30.105531417886265, -0.305339203126999],
            [30.107258143355743, -0.303105334711095],
            [30.107997847601712, -0.303353812425345],
            [30.11287926860112, -0.307923035292146],
            [30.114950751306946, -0.307724991071252],
            [30.11492243910413, -0.306495849315081],
            [30.115898522440702, -0.305305329036917],
            [30.11598752482413, -0.304159241369841],
            [30.117386031939912, -0.303276800935178],
            [30.11949129040211, -0.305336075237589],
            [30.121013948283416, -0.305916963450114],
            [30.12275823761331, -0.307435639802778],
            [30.12400032737686, -0.306929936888418],
            [30.126107018651958, -0.306771457480433],
            [30.13054411225056, -0.305118498278321],
            [30.139103662722896, -0.305970157329612],
            [30.146521832659875, -0.305719121310158],
            [30.15857003725048, -0.306942191529678],
            [30.167385595002354, -0.309465631349762],
            [30.167517136207735, -0.309180641385821],
            [30.16825368018055, -0.309203654989996],
            [30.16786990012825, -0.310143089511083],
            [30.168398167905796, -0.310730978827947],
            [30.169779156975217, -0.309697425648803],
            [30.170367520248654, -0.308633629227022],
            [30.17015623110395, -0.306095853201041],
            [30.168958053686417, -0.304480408808188],
            [30.169300611846943, -0.303025082142929],
            [30.170147593802493, -0.302198369626068],
            [30.170087067115258, -0.300737346515904],
            [30.170860040467804, -0.29913968682704],
            [30.172786465916495, -0.298204932405735],
            [30.173304855819193, -0.29596086588945],
            [30.174057144563974, -0.295197863210015],
            [30.174073759803456, -0.294286043939001],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 435,
        District: "RUBIRIZI",
        County: "BUNYARUGURU",
        Subcounty: "RYERU",
        Population: 13241,
        Key: "RUBIRIZIRYERU",
        Dist2: "Rubirizi",
        "Sub Country": "Ryeru",
        id2_original: "Rubirizi Ryeru",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.53163938120859, 0.479757340151887],
            [30.530378001920937, 0.479504528054929],
            [30.527874338833588, 0.480615096020806],
            [30.526474964843576, 0.479659736227452],
            [30.525336059166793, 0.479755255235216],
            [30.525098276907727, 0.480830014879228],
            [30.524623608908225, 0.481116631136198],
            [30.522464837804566, 0.480495618002343],
            [30.52232177211239, 0.481904746507257],
            [30.521218456788883, 0.482036095317401],
            [30.521312881403315, 0.482991443998463],
            [30.5192482231987, 0.483946762003629],
            [30.518179998765113, 0.485069271918402],
            [30.51865416999628, 0.485761906534763],
            [30.519531944403106, 0.48592911382849],
            [30.519602814292487, 0.486550099516864],
            [30.517028096262823, 0.487421798571008],
            [30.515366695382514, 0.488568173480837],
            [30.51427523871905, 0.488663690566538],
            [30.511666762899296, 0.485940910080508],
            [30.510575105911517, 0.486466327450156],
            [30.509626113068975, 0.486394657948139],
            [30.509388762899544, 0.486585716433535],
            [30.509957713579674, 0.487493300083228],
            [30.508996650972964, 0.487815713523452],
            [30.506480459980704, 0.490299533070493],
            [30.50569613012635, 0.492998359994955],
            [30.5037975551464, 0.493977514284369],
            [30.502539177130082, 0.495768739349486],
            [30.500627782292725, 0.497516615563768],
            [30.49901259434389, 0.49825683264705],
            [30.496756198826734, 0.500836772437674],
            [30.49612695502135, 0.503763699037597],
            [30.49752853257878, 0.505245656090199],
            [30.49683972687678, 0.505938381120019],
            [30.49688730524748, 0.506894196162062],
            [30.499048869213382, 0.506847134367656],
            [30.49980912691305, 0.508687316657443],
            [30.500750341243588, 0.508390063262342],
            [30.5010459956682, 0.509262548118624],
            [30.503503185312642, 0.508755600300437],
            [30.502929633461612, 0.50965895628734],
            [30.50343511726861, 0.512393638138024],
            [30.50535399237733, 0.512456917427364],
            [30.504723523269902, 0.514285434855834],
            [30.503984911375298, 0.514141597015586],
            [30.503719715228712, 0.515228203849827],
            [30.504409029377133, 0.515347663273274],
            [30.503882948098987, 0.515905503457676],
            [30.5040600060415, 0.5168910033311],
            [30.504752122933596, 0.517577686180369],
            [30.50424278625235, 0.519035588638901],
            [30.50437016017312, 0.519922717569847],
            [30.505285233528863, 0.520928765829188],
            [30.50430254577829, 0.523659423036295],
            [30.506517086091456, 0.523819716210067],
            [30.506820522621393, 0.525495065058344],
            [30.506083728916913, 0.525721113892781],
            [30.50618613865595, 0.526534403481231],
            [30.505570258188722, 0.526340535463477],
            [30.50554907591433, 0.527031202039051],
            [30.506811162176135, 0.528577888904921],
            [30.50742437285032, 0.528229199300144],
            [30.506511448264735, 0.53014560045311],
            [30.506592423302735, 0.531600223968789],
            [30.507773779766588, 0.531741633367344],
            [30.508196533227494, 0.532676442804101],
            [30.507957021711515, 0.53398486407539],
            [30.50860019209873, 0.534721157735605],
            [30.508554290882678, 0.535387296845427],
            [30.50692914241396, 0.537529617517428],
            [30.50720214492036, 0.538021345321619],
            [30.506911840861598, 0.539009451183498],
            [30.50814204142236, 0.539076591889599],
            [30.50735665604756, 0.539426232153028],
            [30.507259967678596, 0.539772039455118],
            [30.508049002908383, 0.540162252082046],
            [30.50704565480463, 0.541203643281821],
            [30.50722061518095, 0.541769911455954],
            [30.505638469963188, 0.542654203067908],
            [30.505194276411387, 0.542360724942604],
            [30.50460492588947, 0.542561298975911],
            [30.50475627674347, 0.543324980001555],
            [30.50402080985071, 0.543822310774703],
            [30.503929108029872, 0.545179240972896],
            [30.50324148900237, 0.545405020497423],
            [30.503637477159398, 0.545896060482543],
            [30.502090572850232, 0.546447220138853],
            [30.50169921640685, 0.546893314881284],
            [30.501824995817973, 0.547459840325869],
            [30.500842476950687, 0.547310567799417],
            [30.500772623055894, 0.54776801486743],
            [30.499997992311673, 0.548159419885416],
            [30.499882640544353, 0.548926671737999],
            [30.49928165594116, 0.549494066519416],
            [30.49965406422031, 0.550806418598485],
            [30.499156330179236, 0.551894646635605],
            [30.498776026607064, 0.551443179691554],
            [30.498075253548905, 0.551594580125059],
            [30.496763806658855, 0.552648326891698],
            [30.49608890148757, 0.553994362625354],
            [30.49320681949357, 0.556276659934579],
            [30.493014463241753, 0.557929666069393],
            [30.48976613990302, 0.557184433843654],
            [30.488644755865888, 0.555922194233273],
            [30.4881128193687, 0.555966805165095],
            [30.486331553585078, 0.559160632790446],
            [30.484928748928983, 0.560364060918912],
            [30.48437194886136, 0.561513528694374],
            [30.483136768938948, 0.561847585316313],
            [30.482263678348026, 0.562819505759881],
            [30.480977594491726, 0.562959868833887],
            [30.480739543636393, 0.563394338693297],
            [30.48103069211153, 0.564174331448366],
            [30.479835109926874, 0.564546435113187],
            [30.47852355523901, 0.566626759186378],
            [30.477184506713577, 0.56710929436977],
            [30.474098495471917, 0.565422780811525],
            [30.473928787545102, 0.565847454836503],
            [30.474918474070023, 0.568339495621948],
            [30.473320808659103, 0.569195869488135],
            [30.47262721314005, 0.570181584343276],
            [30.469834739892214, 0.572425433829965],
            [30.46937907036266, 0.572061161795017],
            [30.469778793714646, 0.571147376284855],
            [30.469398322157517, 0.571116866522085],
            [30.468587652800743, 0.572762397523422],
            [30.468854529695236, 0.574105020573463],
            [30.465591002370324, 0.571965362142672],
            [30.465580363622394, 0.571087610745007],
            [30.46477566446899, 0.571350582169946],
            [30.46426829419989, 0.572488986464097],
            [30.462270195767914, 0.57262875285186],
            [30.46014718210415, 0.572188382049275],
            [30.45725059321659, 0.571068564712119],
            [30.456576196491767, 0.570469057042897],
            [30.45361990287548, 0.569768661816142],
            [30.452787626341156, 0.567211684719074],
            [30.454409942421787, 0.565850718256771],
            [30.454526070333497, 0.565313275221597],
            [30.45414602996771, 0.564930817228934],
            [30.449526046563776, 0.563340066904074],
            [30.448314608216023, 0.561547539972502],
            [30.447293222839658, 0.560830326216005],
            [30.44203193934089, 0.558904829028571],
            [30.428896549575995, 0.550632521775922],
            [30.428373977117346, 0.549867720633647],
            [30.428540188801097, 0.548195223297261],
            [30.42786314384283, 0.544981266633402],
            [30.428124296672323, 0.541086670781232],
            [30.42730474387571, 0.538374422448133],
            [30.42566574248699, 0.536032236569993],
            [30.424216819222504, 0.535171528235769],
            [30.421366604064875, 0.536747457330847],
            [30.419300139348227, 0.536244924961175],
            [30.417316754422313, 0.53420129385808],
            [30.417435330243183, 0.529565981013382],
            [30.415523219448538, 0.528024153174494],
            [30.415048130139166, 0.527139916045986],
            [30.415095584542367, 0.525658535392572],
            [30.4125064781968, 0.522766492654904],
            [30.410285589489543, 0.521320134830126],
            [30.402423561072382, 0.518139500153275],
            [30.39892005959909, 0.515856440363987],
            [30.398777470014043, 0.51432722639237],
            [30.395262147609934, 0.512940176430551],
            [30.394882048853635, 0.511434774252402],
            [30.394181331490994, 0.510681882146444],
            [30.394323734226475, 0.508794379042349],
            [30.39323108639693, 0.507503771723927],
            [30.39261343535029, 0.505544319031463],
            [30.389632477589565, 0.502998672962299],
            [30.38663973572895, 0.502256937421114],
            [30.384122004125956, 0.500750806050548],
            [30.382768192687127, 0.501323767359917],
            [30.37903920419606, 0.500820723749933],
            [30.37799409790631, 0.499984108820012],
            [30.377281485052666, 0.498621970518108],
            [30.37398000660194, 0.497712900830044],
            [30.373190270686226, 0.49368979368792],
            [30.37201406965378, 0.491692895575313],
            [30.370350685293307, 0.490878599112656],
            [30.369871160103074, 0.48960575001774],
            [30.369827959222757, 0.488511919429466],
            [30.370612161516316, 0.487126501575397],
            [30.37070724100264, 0.486170587559213],
            [30.371931047355236, 0.484845365871359],
            [30.37017266525514, 0.481378035255963],
            [30.37026773935155, 0.479585601762871],
            [30.371146969927466, 0.479132400495749],
            [30.372964843855566, 0.479002772741735],
            [30.37569761776453, 0.475802882660831],
            [30.37443820488902, 0.473841781314382],
            [30.374509499681526, 0.472790234052776],
            [30.377705635393855, 0.469196435880154],
            [30.3782522063453, 0.467165445168854],
            [30.37758684307899, 0.465945856417319],
            [30.376434351281873, 0.465263534827143],
            [30.376529400225426, 0.464761724589107],
            [30.377099714548184, 0.463758488472451],
            [30.379547294015705, 0.461801077505321],
            [30.37987997070813, 0.461132195673794],
            [30.379297777064053, 0.456052760946299],
            [30.37794328829551, 0.45597972304057],
            [30.37718287878057, 0.455285856610969],
            [30.378763061179406, 0.448726736796026],
            [30.378667984388045, 0.4463126994996],
            [30.375174819828743, 0.443632404255338],
            [30.367755659948333, 0.435283942043341],
            [30.366781340902953, 0.43337096903291],
            [30.367149625016626, 0.431232259797167],
            [30.366793161833794, 0.429869592613311],
            [30.36343066262243, 0.425671839169191],
            [30.36202859278823, 0.4228024634508],
            [30.358891881530294, 0.420242112298122],
            [30.358404715270243, 0.419369294867876],
            [30.359117528448202, 0.417027769095823],
            [30.361469881105712, 0.41332550836217],
            [30.366305426041848, 0.41061748207637],
            [30.366543038519335, 0.410020202170429],
            [30.365639990012006, 0.408035616463372],
            [30.365604264911475, 0.406016013019647],
            [30.36584183067654, 0.404821226110657],
            [30.36800408185362, 0.401883551009607],
            [30.368788205993766, 0.401071693350099],
            [30.37042780476216, 0.400404041337429],
            [30.37621410323882, 0.402715914823214],
            [30.377212140502625, 0.402884167812978],
            [30.378851742864235, 0.4023599221604],
            [30.379552688398977, 0.401249213166957],
            [30.378815903677673, 0.398380452966956],
            [30.378934612449207, 0.396325118396901],
            [30.379433594250184, 0.395584686230375],
            [30.38195240652648, 0.394702728682523],
            [30.384863238202858, 0.39266197251644],
            [30.387215467791165, 0.387764556509482],
            [30.387749976165015, 0.385147931406588],
            [30.38767857806621, 0.383331415257317],
            [30.390185213678855, 0.378015856992435],
            [30.3909216660235, 0.37505284687724],
            [30.392667975664466, 0.371385713330272],
            [30.392691595068214, 0.369473664056888],
            [30.39191923436672, 0.368552773446345],
            [30.387784312470107, 0.366134996772391],
            [30.385764349044145, 0.364364496442168],
            [30.384207654895043, 0.361435246974665],
            [30.381094492972256, 0.358181923085614],
            [30.37793390090081, 0.356243104431102],
            [30.37777937270564, 0.355322789182872],
            [30.37801687648697, 0.353912881603337],
            [30.380749477919398, 0.352792056073752],
            [30.381272203989987, 0.352218901345948],
            [30.382044262857548, 0.349674203342329],
            [30.383327332866052, 0.348360835967324],
            [30.384482368692087, 0.344313164129368],
            [30.388207004845576, 0.34523829444296],
            [30.39030622752738, 0.34912666879809],
            [30.391390061985664, 0.349809046937414],
            [30.39220227015654, 0.352605797521886],
            [30.39674068653269, 0.356085620228167],
            [30.399653930185607, 0.35642749175529],
            [30.401551105590343, 0.356018790454685],
            [30.405887198906623, 0.356088239664948],
            [30.407377943239148, 0.355543001547569],
            [30.4127979770149, 0.35629485088268],
            [30.4147625817615, 0.357045719215155],
            [30.41791164665122, 0.362128096554545],
            [30.42123116506949, 0.363493227244218],
            [30.425026006359072, 0.361175235683792],
            [30.427533051603458, 0.360698462510453],
            [30.428684703475824, 0.361176292979868],
            [30.43102163565316, 0.36318912399096],
            [30.4333249959917, 0.364144722659408],
            [30.435221149113644, 0.367555735917754],
            [30.438878602063678, 0.371922207372064],
            [30.44355340156456, 0.372810310716803],
            [30.446196089721905, 0.371992598772719],
            [30.4472804892205, 0.370765144095922],
            [30.451255793067528, 0.360158001813578],
            [30.458848275695487, 0.354025671917936],
            [30.46423408994711, 0.352998909007269],
            [30.469851437776725, 0.354262422880106],
            [30.475051344782003, 0.354123644803603],
            [30.488469708352987, 0.351369686016602],
            [30.494506443656118, 0.347304934317801],
            [30.498167086523747, 0.346393473619436],
            [30.506298905071887, 0.348616838511506],
            [30.507005971726954, 0.352251113425016],
            [30.51053323723277, 0.357136482330367],
            [30.51141459232432, 0.360046338937637],
            [30.51022921230634, 0.36529266189316],
            [30.510989134036084, 0.375453844422954],
            [30.51574742116285, 0.374638941696804],
            [30.516493206104972, 0.373070246212496],
            [30.516222600303763, 0.371569490401675],
            [30.52015291202976, 0.370342799218207],
            [30.523473059268735, 0.370480102941707],
            [30.525166864177976, 0.371094515272214],
            [30.528486476919344, 0.373141883540831],
            [30.52909579070182, 0.375052065359675],
            [30.529841187571773, 0.374984084111818],
            [30.530654056004376, 0.375666432456153],
            [30.533025393657113, 0.37648569182158],
            [30.538581870744746, 0.375805131150233],
            [30.540005007868974, 0.375123392759743],
            [30.542851044962244, 0.374646682314113],
            [30.547119291220042, 0.376899007632474],
            [30.549151588514885, 0.37867318756506],
            [30.55044015980618, 0.389102448699932],
            [30.54980405736359, 0.389390615304811],
            [30.5494714121122, 0.390393848551713],
            [30.547596659555282, 0.391441818532777],
            [30.548438044108284, 0.393656626663486],
            [30.54815283080221, 0.394605637476622],
            [30.548461073318908, 0.395012484691109],
            [30.548128748766054, 0.395392023751346],
            [30.548413193114246, 0.396088113457426],
            [30.547772339482144, 0.396566988488673],
            [30.547154634536575, 0.398428837753338],
            [30.54849444034183, 0.400282239046531],
            [30.54740277347258, 0.400923677972598],
            [30.547355090897284, 0.401330417978568],
            [30.548114079277482, 0.401782599922432],
            [30.547995260911467, 0.402216436000292],
            [30.54695143651763, 0.401908791251504],
            [30.546168016656676, 0.402929959200674],
            [30.54623858740709, 0.404312947739562],
            [30.54533696452609, 0.404656153117796],
            [30.545005248132693, 0.403480982931273],
            [30.54291674414886, 0.404790994064338],
            [30.54156525844832, 0.40264834431809],
            [30.539264312781235, 0.401788940075821],
            [30.537580432459258, 0.400260845291796],
            [30.535883685567452, 0.400938247391478],
            [30.535575263387692, 0.400676024796418],
            [30.53624014605536, 0.399600595151035],
            [30.535908001165584, 0.399383559369264],
            [30.534436472695276, 0.400838377837774],
            [30.53370015958951, 0.402447079051207],
            [30.533438403092138, 0.404209585664255],
            [30.531611425636953, 0.404570579042714],
            [30.529926021772262, 0.406242252531833],
            [30.529058992114525, 0.408637287370553],
            [30.528251864814898, 0.409667467037273],
            [30.52760984786449, 0.412984531118504],
            [30.528237943622944, 0.414286326720647],
            [30.52835525820916, 0.417323426463034],
            [30.527002058523045, 0.418968068592104],
            [30.527879507739755, 0.420071091141156],
            [30.5270125643203, 0.42211359652442],
            [30.5260157218158, 0.422800228503207],
            [30.526038929791177, 0.423930093232218],
            [30.525005833078456, 0.426108121781647],
            [30.525169560022135, 0.427825557695989],
            [30.5265707746602, 0.428286997701253],
            [30.527139331878235, 0.430149189862566],
            [30.528159023031982, 0.431270344591458],
            [30.528823696392152, 0.43048418104854],
            [30.529084396470772, 0.431225455251617],
            [30.528810780415018, 0.432671585879692],
            [30.52975940045673, 0.433620981885149],
            [30.53037620349375, 0.43379292438578],
            [30.530590033074073, 0.433286817263852],
            [30.531040769954394, 0.433341199715885],
            [30.531373455629993, 0.432310875857279],
            [30.532013592406514, 0.433214976552909],
            [30.533223567398657, 0.433332881554274],
            [30.533910815421958, 0.435177046506977],
            [30.534918922800095, 0.435692599014406],
            [30.537291890895062, 0.435042582467776],
            [30.53795656964512, 0.434256414824388],
            [30.53702914804751, 0.438820769622565],
            [30.537408002637093, 0.440321359345297],
            [30.53828551024431, 0.441234586588327],
            [30.53997037062826, 0.440539152146125],
            [30.540598915544333, 0.440855726155591],
            [30.54064565578691, 0.442482754066801],
            [30.541736502494278, 0.443531640554824],
            [30.54202089294355, 0.44432716558969],
            [30.54095238194738, 0.44613459682798],
            [30.542019799693843, 0.446758647392313],
            [30.542565890046642, 0.445710312013355],
            [30.542969371051452, 0.445710448553149],
            [30.54341962733313, 0.446804316352877],
            [30.54439255848136, 0.446379814191146],
            [30.544617755343324, 0.446723371623448],
            [30.54400028934962, 0.448088048799181],
            [30.544759063930776, 0.449136829389104],
            [30.54482949813723, 0.45078194877704],
            [30.545588452381434, 0.4512883915638],
            [30.546371868649143, 0.450402837315018],
            [30.547083600255494, 0.450330768604549],
            [30.547657974963332, 0.454665151998046],
            [30.54574046349721, 0.455883247033639],
            [30.545929831952336, 0.456814728216063],
            [30.54649902517762, 0.457316291087037],
            [30.546190323621794, 0.457865625702864],
            [30.544315622268847, 0.458510510116097],
            [30.54284462290626, 0.45843886727434],
            [30.543828250294595, 0.460552612417445],
            [30.54382769872901, 0.461699050168707],
            [30.542973484437162, 0.46181847551059],
            [30.542996780447424, 0.462726073189919],
            [30.54226114826463, 0.462941041108341],
            [30.54256926501717, 0.463633668058266],
            [30.54203452667463, 0.465484688263357],
            [30.540444568808876, 0.466057908559626],
            [30.54015879585237, 0.468231367639396],
            [30.53939947689214, 0.468398546613974],
            [30.539493881743674, 0.469425556981674],
            [30.53828337225392, 0.470380915494969],
            [30.53755839588703, 0.473067866899606],
            [30.535730833628598, 0.474357587071443],
            [30.535599448730114, 0.476160830983226],
            [30.53479265290882, 0.476375783217697],
            [30.533938039764962, 0.477307250009281],
            [30.533747754129895, 0.478262606537419],
            [30.53275123142566, 0.478310364703772],
            [30.53256077870396, 0.479600086589381],
            [30.53163938120859, 0.479757340151887],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 436,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "BUSIRIBA",
        Population: 28044,
        Key: "KAMWENGEBUSIRIBA",
        Dist2: "Kamwenge",
        "Sub Country": "Busiriba",
        id2_original: "Kamwenge Busiriba",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.936513813099165, -0.448870402646846],
            [29.935510670709583, -0.447919433886744],
            [29.931730409975355, -0.446603990946488],
            [29.930371926398756, -0.446641083952572],
            [29.929861669842644, -0.447282479515201],
            [29.928774890706872, -0.447319376691092],
            [29.922465612834714, -0.444290355532771],
            [29.92053212033969, -0.444020899586703],
            [29.91887373151051, -0.44449157659542],
            [29.91757310392977, -0.444004981019542],
            [29.916760036969503, -0.444438933310517],
            [29.9151283658335, -0.444169258187528],
            [29.911321408965662, -0.446826345068709],
            [29.909055226303458, -0.446439755154037],
            [29.907305527318947, -0.446720891450315],
            [29.906552359123474, -0.447091593331508],
            [29.905353483714965, -0.448952286961517],
            [29.904405824870608, -0.449196730804795],
            [29.90383335818444, -0.449440904255288],
            [29.900235827355424, -0.448459395581898],
            [29.897216313902707, -0.448380300445256],
            [29.896493540204865, -0.448750976192198],
            [29.89552530455063, -0.448300256715862],
            [29.893957061660213, -0.44867153342139],
            [29.89347168484422, -0.448184357828121],
            [29.892840038045463, -0.448672333795763],
            [29.891765572117272, -0.448122380461012],
            [29.891284567401744, -0.448547050501689],
            [29.891620005515378, -0.449278094108946],
            [29.89054202447948, -0.451165755567752],
            [29.889940488310703, -0.451653706183928],
            [29.88891377861967, -0.451627351330627],
            [29.887674219410247, -0.45127613443198],
            [29.88633995531202, -0.450004113520626],
            [29.884618377189145, -0.449851861859257],
            [29.88355564415688, -0.448552567785085],
            [29.882379831196648, -0.448923557924034],
            [29.882136208091616, -0.448472325535998],
            [29.881169513946368, -0.448355650530318],
            [29.88016782053934, -0.447200767653156],
            [29.87849604052423, -0.44801448890809],
            [29.87665343148482, -0.44780815758222],
            [29.875710222894387, -0.446228918869397],
            [29.87410938822715, -0.446085614078636],
            [29.87265494032368, -0.444940091007799],
            [29.87222875799332, -0.444209125120067],
            [29.87204082774094, -0.439514684320182],
            [29.873332115537657, -0.438042183035257],
            [29.873536991609587, -0.436642688119357],
            [29.874678986592617, -0.435513354363011],
            [29.874155046898085, -0.433229638435872],
            [29.875429007091324, -0.431296705804943],
            [29.874305384452466, -0.429871092757608],
            [29.873458378242425, -0.429510589209267],
            [29.873754749522654, -0.428354783576748],
            [29.87305089793797, -0.426314961237711],
            [29.872354528421305, -0.425891153196701],
            [29.86909232341649, -0.425541454099679],
            [29.869238217903455, -0.424476041060715],
            [29.867343775173822, -0.42286142187064],
            [29.865638930868048, -0.419856359132455],
            [29.863424863068754, -0.417673229232701],
            [29.862699761836033, -0.417556402840046],
            [29.86194133939447, -0.416771532342604],
            [29.862009694899406, -0.415263814561542],
            [29.86061120125835, -0.413206483784935],
            [29.86057922213254, -0.412809278848906],
            [29.86178628748149, -0.412681987282801],
            [29.86212443311738, -0.407562891815616],
            [29.86252716133399, -0.406515345187124],
            [29.863489767246342, -0.405783358792572],
            [29.862968336546444, -0.404050383003384],
            [29.864229094199906, -0.402487595664187],
            [29.86364526023213, -0.400330354333734],
            [29.864309435027348, -0.397115895368216],
            [29.86408838029717, -0.395048658987829],
            [29.86133291314749, -0.390121502743244],
            [29.859247554165464, -0.389644621556192],
            [29.856916541885866, -0.388319307373385],
            [29.851870282726768, -0.387339143885887],
            [29.8494012182526, -0.385535472923317],
            [29.848041143759637, -0.385211519013673],
            [29.846444107169425, -0.385853722647919],
            [29.84473064442679, -0.387416848178557],
            [29.840862257166574, -0.386526065822307],
            [29.819641692976354, -0.374273855297749],
            [29.750643298847315, -0.355716576073057],
            [29.675972457822386, -0.336541842836819],
            [29.675796176024303, -0.336749955539644],
            [29.682003004631547, -0.349084013088628],
            [29.716477538000795, -0.421745778728406],
            [29.72375834295438, -0.437632681800173],
            [29.723614270250795, -0.439194430862533],
            [29.72465678400266, -0.439792852034715],
            [29.72458505442553, -0.440771177426792],
            [29.72520028451249, -0.442395043380984],
            [29.726172354176366, -0.441967167892361],
            [29.727689243975245, -0.44206526908686],
            [29.728280480060967, -0.44414252872108],
            [29.72913328220121, -0.444907683464413],
            [29.729322285042024, -0.445862598793976],
            [29.730293617189087, -0.446604104130784],
            [29.730588860185293, -0.448215489788381],
            [29.731701765024482, -0.449935692752114],
            [29.732317744306393, -0.450390202900916],
            [29.733597770822733, -0.450249253501544],
            [29.733170576989373, -0.451107630082518],
            [29.735741227447445, -0.452770736328705],
            [29.735669241850466, -0.454130912852153],
            [29.736521425051475, -0.45585066886443],
            [29.736496253358908, -0.458093921645709],
            [29.737857448949352, -0.460709522365306],
            [29.737690952499648, -0.461592233168944],
            [29.73849666135946, -0.461880026972423],
            [29.738448862901496, -0.462476561676156],
            [29.73958643637672, -0.46271721788662],
            [29.739467070936698, -0.464005712905366],
            [29.73986961589697, -0.464626911661956],
            [29.73925333837439, -0.464625821143071],
            [29.73911085299394, -0.465031276776221],
            [29.739951938407945, -0.465593583837321],
            [29.740259582646647, -0.466333945420446],
            [29.741065385829547, -0.466478555016747],
            [29.74108850217676, -0.467361595669579],
            [29.742533567177073, -0.468581265021016],
            [29.743221170034893, -0.468248365891858],
            [29.744714103561776, -0.468776038410893],
            [29.74523582531587, -0.468395111571128],
            [29.745686040275018, -0.468610694642043],
            [29.746302757073742, -0.467943560620513],
            [29.747108307830057, -0.468470015087682],
            [29.74808019513596, -0.468376270935903],
            [29.748222031932773, -0.468949285288954],
            [29.747842454199358, -0.469449781935143],
            [29.74833993401719, -0.469880233868775],
            [29.748126320930826, -0.470309429075118],
            [29.748955420123988, -0.471074581027491],
            [29.748943189561402, -0.471635388366358],
            [29.75017573921665, -0.471661428745806],
            [29.750225454679445, -0.473785511870755],
            [29.74977108141884, -0.474214288235499],
            [29.7501484169573, -0.477078780424086],
            [29.74969772948431, -0.477579157011891],
            [29.75018226907045, -0.479620487513028],
            [29.75022423836054, -0.48767503615914],
            [29.749144598136304, -0.489343700350848],
            [29.7485757426776, -0.489318820619821],
            [29.748481337826064, -0.488722017852881],
            [29.74805480964432, -0.488530337816544],
            [29.74593186604913, -0.490757932848124],
            [29.746831765961428, -0.491952798255805],
            [29.746901958521097, -0.493289368333402],
            [29.746426968026405, -0.494648830854435],
            [29.745502302460057, -0.4950051460014],
            [29.74339295217175, -0.494691127351506],
            [29.74235021653603, -0.494402874104819],
            [29.741521352701476, -0.493327464472536],
            [29.74104715991074, -0.493517538243173],
            [29.739696555457478, -0.492846905151514],
            [29.738297725846504, -0.493369427715349],
            [29.738400555098785, -0.49437202530978],
            [29.735436588971655, -0.495989524400754],
            [29.735104054213043, -0.4969912484693],
            [29.733656897036422, -0.498850107905874],
            [29.73357302403329, -0.500174458171489],
            [29.732482630076795, -0.500267952161338],
            [29.73214962370264, -0.50193788784617],
            [29.731011711562584, -0.502198351549063],
            [29.73094023710699, -0.502723241239913],
            [29.73169841430848, -0.503178039846952],
            [29.731436647929634, -0.504657186313377],
            [29.73015690258599, -0.504368500532644],
            [29.729018871868316, -0.504796011960591],
            [29.72769184010642, -0.504340185833608],
            [29.727145791974422, -0.505604025927251],
            [29.725913077927483, -0.505864315217189],
            [29.725189555933056, -0.506710199644023],
            [29.7260896597629, -0.507547084092688],
            [29.726041700506492, -0.508334531597357],
            [29.725733407684146, -0.508572626077895],
            [29.72516484058461, -0.508142034697073],
            [29.724500417854394, -0.509214738074372],
            [29.723433935254143, -0.509021895362576],
            [29.722935257083755, -0.510333540985003],
            [29.72220017466991, -0.510761765252645],
            [29.721000006585676, -0.515258050066605],
            [29.722350185237516, -0.51647759029475],
            [29.72170975111862, -0.517120773144732],
            [29.721046492605012, -0.516546822437094],
            [29.720785419725566, -0.517023631489204],
            [29.722064626080048, -0.518052130885842],
            [29.721068935215765, -0.518312831980331],
            [29.721080401312044, -0.518849809387159],
            [29.72186274049973, -0.518636447590937],
            [29.722218006228296, -0.519018930065492],
            [29.721506222519643, -0.519996072771873],
            [29.720582360047167, -0.519254591609964],
            [29.7200602681872, -0.520136628170658],
            [29.721197479641358, -0.52085463542398],
            [29.721007305397357, -0.521617956232243],
            [29.720106217912296, -0.522165195285455],
            [29.721030357964207, -0.522524844219352],
            [29.72157604677007, -0.521786043816616],
            [29.722097109160725, -0.522335876183687],
            [29.721219227854384, -0.523575227460784],
            [29.721455802777687, -0.524196139486722],
            [29.72091056223118, -0.524314466012399],
            [29.721087720785, -0.525161980158684],
            [29.71954621265573, -0.526328519206967],
            [29.72016216049661, -0.526759209062173],
            [29.72115768427424, -0.526737157252206],
            [29.721537306923437, -0.526212834553265],
            [29.72198762608715, -0.526261390039584],
            [29.72217677715001, -0.526906077402255],
            [29.721560390032955, -0.527071996403311],
            [29.721654563119138, -0.527955160998572],
            [29.722294837337916, -0.527526770815744],
            [29.72288702204457, -0.528052873789357],
            [29.722673148446752, -0.528816145212181],
            [29.723217843715926, -0.529461483560799],
            [29.724544716475997, -0.530108255492085],
            [29.724625811888266, -0.532673843192017],
            [29.723796340792603, -0.532505278018411],
            [29.723060984392585, -0.53329145853252],
            [29.72305948690102, -0.535343805012995],
            [29.7244099925396, -0.536086086417707],
            [29.72462265880162, -0.536993328904707],
            [29.725570171220618, -0.537806467894328],
            [29.724905691896513, -0.538903014514566],
            [29.725948795841507, -0.538642424772168],
            [29.72627326732214, -0.539095794325428],
            [29.725822279811826, -0.539954093830236],
            [29.724921406125773, -0.540191082229764],
            [29.72458891807958, -0.541073455356079],
            [29.72448112204211, -0.542612525802833],
            [29.72552360075965, -0.543211064371486],
            [29.7253570908352, -0.543998289097409],
            [29.724503672450677, -0.544163763888101],
            [29.725404059249836, -0.544594983370712],
            [29.72526147235975, -0.545095881087725],
            [29.72277203229832, -0.545974272345469],
            [29.723008357489995, -0.546929291667665],
            [29.721632448393493, -0.548477947000251],
            [29.72185693828131, -0.549397146350136],
            [29.72090873865114, -0.549514709753519],
            [29.720457857142048, -0.550229813041614],
            [29.7187030314722, -0.551348190842387],
            [29.718038317687828, -0.552731092912812],
            [29.718939049440035, -0.552685041125941],
            [29.718914956624115, -0.553210011892858],
            [29.71810870608023, -0.553685804842987],
            [29.719127384832635, -0.554403626702608],
            [29.719161689696698, -0.556062265533561],
            [29.720061705491652, -0.556970788635185],
            [29.71939752620485, -0.557637765164064],
            [29.72053280178956, -0.560885442404463],
            [29.719998870134148, -0.561707764771902],
            [29.720211015373323, -0.563259354481749],
            [29.719570771697317, -0.563616131891226],
            [29.71968881841046, -0.564236829602294],
            [29.720186370093515, -0.564500259457391],
            [29.719877779928805, -0.565096297722393],
            [29.72061216435167, -0.565622687546737],
            [29.720563921227647, -0.566720364450536],
            [29.72155947554801, -0.566674488834659],
            [29.721558998542584, -0.567294971531921],
            [29.72215122547007, -0.567749500360759],
            [29.72347886718803, -0.567370149649058],
            [29.72339478397911, -0.568837657883205],
            [29.724343530683285, -0.568004175505711],
            [29.724864884128102, -0.568148335446438],
            [29.72389141309238, -0.570318196958448],
            [29.722990651695735, -0.570388105779879],
            [29.722705892038892, -0.570817126171858],
            [29.722894691860457, -0.571891392259357],
            [29.721780236529078, -0.572438186575564],
            [29.723531960316283, -0.575400673669226],
            [29.723068795243982, -0.575922098711414],
            [29.725298413779157, -0.57778767204992],
            [29.724421111886173, -0.578167854767936],
            [29.725155399290987, -0.578813580287241],
            [29.724584902610246, -0.580912586772896],
            [29.72510590301715, -0.581510186318437],
            [29.725353680830384, -0.582930589294671],
            [29.72450035946392, -0.582952853784887],
            [29.724191683060912, -0.583644340157142],
            [29.725115328141126, -0.58462453175098],
            [29.725992656983554, -0.584220483369578],
            [29.727698669099187, -0.584987365749852],
            [29.727508150800475, -0.586132516895],
            [29.729878496713148, -0.58606538661125],
            [29.73025666768481, -0.587450254747315],
            [29.731275489269358, -0.587977203024295],
            [29.731025809722663, -0.588990982788265],
            [29.73320544330048, -0.590331519794007],
            [29.73322822816936, -0.591500942824645],
            [29.73410486980061, -0.591979890904943],
            [29.734055922397403, -0.593936713853196],
            [29.733628892955743, -0.594413198674781],
            [29.7334501111462, -0.595689628665506],
            [29.733924020967617, -0.595881444540546],
            [29.73527549768503, -0.595382849008865],
            [29.735891024216, -0.596338606580774],
            [29.73418402485189, -0.596812664976858],
            [29.734609644836866, -0.59812603561445],
            [29.73515468416075, -0.598294125496571],
            [29.735343659153823, -0.599105886903021],
            [29.73631541889894, -0.599203187992568],
            [29.736101253348696, -0.60025284154231],
            [29.737049728761644, -0.59982507289011],
            [29.73922933000013, -0.60121337434528],
            [29.738695068662985, -0.602393671264431],
            [29.739619150324415, -0.602824997745222],
            [29.740449030153556, -0.602492461619804],
            [29.740733147514977, -0.602898708518661],
            [29.74056568896962, -0.604831452267265],
            [29.73961772918964, -0.604614861651808],
            [29.738906152093517, -0.605210129436757],
            [29.73909468691208, -0.606570789007651],
            [29.738074912215033, -0.607237069802853],
            [29.738263703053434, -0.608287486224869],
            [29.73712585110052, -0.608404642391734],
            [29.737160376051833, -0.609681471529538],
            [29.73972012275896, -0.609948872266969],
            [29.738770554994645, -0.611736929202184],
            [29.73924329520954, -0.61338451235448],
            [29.740120818088077, -0.612765701076934],
            [29.740499842459275, -0.613052802383871],
            [29.74052171913139, -0.615320015401086],
            [29.74181242212487, -0.616718583612232],
            [29.743044612454003, -0.617198247181231],
            [29.742949167353398, -0.617985609819119],
            [29.74543705782097, -0.619183627580704],
            [29.744653777198863, -0.620494703099204],
            [29.74533970649532, -0.622309763649616],
            [29.745933319523264, -0.621046056658377],
            [29.74666813423914, -0.621047463337492],
            [29.747379740979664, -0.62042832778],
            [29.750011129229055, -0.620075400385684],
            [29.751084200971917, -0.622004910483842],
            [29.753777404092638, -0.621206242013364],
            [29.755158055395512, -0.622180113857497],
            [29.756394666334167, -0.622368661809886],
            [29.75634880644058, -0.623320899694444],
            [29.75762245312177, -0.624283029067514],
            [29.75824269131645, -0.625472293635893],
            [29.762310020377793, -0.626513513649384],
            [29.762574565245824, -0.628227015600107],
            [29.763262689126492, -0.627464231822512],
            [29.76378733489681, -0.628368003096531],
            [29.76454817111154, -0.628390656347214],
            [29.76504870520133, -0.629104019458674],
            [29.76623690053945, -0.628792769271449],
            [29.766594948350427, -0.629601575260038],
            [29.767747971051897, -0.629564119570697],
            [29.768367001012514, -0.630063069429189],
            [29.76912624541255, -0.62918116302262],
            [29.768602779130195, -0.628943907103732],
            [29.76900371969934, -0.627110368013325],
            [29.770805283815143, -0.624084476341555],
            [29.77166055542411, -0.623726105723719],
            [29.771884791987013, -0.622809295374208],
            [29.772835203269402, -0.622474588490853],
            [29.772856832006486, -0.621260524913353],
            [29.773997736434776, -0.621092158185133],
            [29.77430534114764, -0.620258533685937],
            [29.77513759522408, -0.620328673625988],
            [29.775305831710483, -0.621352015640578],
            [29.77563871950699, -0.62137530668788],
            [29.77616004959562, -0.620398533307144],
            [29.77851454653171, -0.620823424984658],
            [29.77951166931057, -0.620012545352692],
            [29.78017753922671, -0.620106743465185],
            [29.780416558465916, -0.620820516410507],
            [29.781509961778614, -0.62067602818239],
            [29.782020308166235, -0.620211058708323],
            [29.78306764587118, -0.620899797062697],
            [29.78313972848621, -0.621328170365253],
            [29.7840423035814, -0.62082689317638],
            [29.78494690258092, -0.621468243615667],
            [29.785041077463728, -0.620944392204464],
            [29.78651316827939, -0.619823316433094],
            [29.786798214498845, -0.619680052509885],
            [29.78710860758233, -0.620417526172004],
            [29.788058268771447, -0.619654328061333],
            [29.788766796985488, -0.616987100539234],
            [29.7893610478173, -0.616914775080634],
            [29.791361653447208, -0.618863716654103],
            [29.79215735417642, -0.61842210365446],
            [29.79251448660416, -0.61870722488532],
            [29.79387388197078, -0.62106182745329],
            [29.79375736868178, -0.622395088686346],
            [29.793044650725278, -0.622705634117278],
            [29.79252546581355, -0.624896479971275],
            [29.79372990089536, -0.627025188571509],
            [29.796799351694723, -0.628377410586709],
            [29.797132885379913, -0.628757777506739],
            [29.796824682389115, -0.629258155677549],
            [29.79808609760939, -0.629994189879341],
            [29.79763541372966, -0.630590003659396],
            [29.798693409945404, -0.630576495612277],
            [29.79755466057548, -0.631982721034725],
            [29.797889911839516, -0.633339105199951],
            [29.79857923227615, -0.633242833242095],
            [29.799031981382743, -0.633813473802373],
            [29.797083933485148, -0.634697212771516],
            [29.797917542221036, -0.635529121088319],
            [29.798487787373517, -0.63531401834917],
            [29.798773890011727, -0.63576587817191],
            [29.797609597046712, -0.636172325527254],
            [29.797349191615506, -0.636815457126975],
            [29.796421059450456, -0.636316957048295],
            [29.796136764222616, -0.636888700332219],
            [29.795685107467428, -0.636936998862429],
            [29.795757861123985, -0.637746261692723],
            [29.795044257428582, -0.637556896880431],
            [29.79461800502964, -0.638533546680637],
            [29.79361888709253, -0.638225585588161],
            [29.79080497644879, -0.64021754582516],
            [29.790043736890496, -0.639980650614447],
            [29.789117875666516, -0.640767600209135],
            [29.78930887186895, -0.641219611358539],
            [29.7885023832715, -0.642292037311216],
            [29.787835542276532, -0.641650316663933],
            [29.787052956052143, -0.642794118167259],
            [29.78729225376912, -0.643674537424825],
            [29.786603972683256, -0.64436591354645],
            [29.78639307879727, -0.646127785261416],
            [29.785680606080817, -0.646581146017605],
            [29.78387362602218, -0.646560054917766],
            [29.78286473351648, -0.64745423663177],
            [29.781892150914558, -0.648717347911616],
            [29.78118237763554, -0.650717996481962],
            [29.78142220625683, -0.651907872041972],
            [29.780639609252646, -0.653051666740304],
            [29.779297602574974, -0.653803519414899],
            [29.77853621299803, -0.653471389850642],
            [29.77756324681552, -0.654520246548207],
            [29.777993149069463, -0.655638418783925],
            [29.7785882380294, -0.656042211100586],
            [29.7786856567287, -0.657375123711228],
            [29.779162193223996, -0.657969524927136],
            [29.782588246445073, -0.659345103275683],
            [29.78238782511865, -0.660309492171176],
            [29.78372119269824, -0.661426325607059],
            [29.783483976377813, -0.661736141080407],
            [29.784127104544236, -0.662425519692933],
            [29.784152611308382, -0.663425281274511],
            [29.784916264639843, -0.663686003393327],
            [29.784889410402744, -0.663281362845868],
            [29.785435828640612, -0.663042500642716],
            [29.786602191324043, -0.663826330586751],
            [29.786484182340114, -0.66432639989479],
            [29.78724536799948, -0.66453951356034],
            [29.786950832875714, -0.666075362959615],
            [29.787949821455417, -0.666311932670508],
            [29.787452179940814, -0.667264855787902],
            [29.78818954677044, -0.667454211397679],
            [29.788832851904953, -0.668238814935647],
            [29.788239196656182, -0.668668181317094],
            [29.78988210571638, -0.670046430790525],
            [29.789859561596018, -0.670760605432731],
            [29.789336038719775, -0.670499527081989],
            [29.788909604861157, -0.671380938518496],
            [29.78907693764239, -0.671904394884769],
            [29.79201472865876, -0.672768936869918],
            [29.79237107955219, -0.672601777306821],
            [29.792013661460206, -0.67215000972704],
            [29.793202156835594, -0.671981622230209],
            [29.793367315693846, -0.671243424871048],
            [29.79398527935421, -0.671123481959584],
            [29.794228134399685, -0.674074944079243],
            [29.79475365423081, -0.675502464789275],
            [29.796324457319763, -0.676428540037698],
            [29.796207261311167, -0.677404723227133],
            [29.79563741770562, -0.677857858357207],
            [29.796935228169662, -0.679034289523575],
            [29.796770596622473, -0.680081953285936],
            [29.797080865738458, -0.680771850298375],
            [29.797794517044547, -0.68098504678319],
            [29.797867148530237, -0.681746695113944],
            [29.79970030729288, -0.683148505604019],
            [29.800487849522685, -0.684861314482669],
            [29.801285550800035, -0.685562393135703],
            [29.80230812824075, -0.685679923885403],
            [29.802167054113603, -0.686608533838583],
            [29.803499213459133, -0.687011264560219],
            [29.80506810223823, -0.68681853139329],
            [29.805092698110688, -0.687294597077698],
            [29.804380149037442, -0.687724130640424],
            [29.804286469126364, -0.688557453793023],
            [29.80376392182053, -0.688867687918735],
            [29.803528319772653, -0.690129704353408],
            [29.803970075296764, -0.691236002546006],
            [29.80339582275983, -0.691891471629114],
            [29.804674997673256, -0.691112226401445],
            [29.80550146749758, -0.691704190137905],
            [29.807795685681498, -0.690397805957339],
            [29.810090717739016, -0.690495033442107],
            [29.81232353876821, -0.689738106808041],
            [29.814094715572867, -0.690834809087189],
            [29.815664443378452, -0.690646256530493],
            [29.81668028255624, -0.689277856860275],
            [29.81681499032298, -0.687041029893832],
            [29.817501398421463, -0.685192557143871],
            [29.819920096154274, -0.682904555779326],
            [29.821909290485156, -0.682541836429663],
            [29.822759680648858, -0.677297349715014],
            [29.824084865474518, -0.673614704311746],
            [29.826045482599568, -0.673295055510074],
            [29.82741643658894, -0.672414587584987],
            [29.829499208422963, -0.667432013736582],
            [29.83230634936271, -0.666717574523298],
            [29.833668632813, -0.665498093330172],
            [29.836283614232002, -0.665576187592144],
            [29.839417429321493, -0.662197267639962],
            [29.840723820493075, -0.661240076831949],
            [29.844202205071035, -0.660033233644646],
            [29.85584197804132, -0.650883994437512],
            [29.856574504748153, -0.649648565301572],
            [29.858185689804085, -0.648937259358348],
            [29.858490455840656, -0.647268342149813],
            [29.85960151015036, -0.64565430168352],
            [29.8633506855825, -0.642687572102492],
            [29.864015870982385, -0.640218381206206],
            [29.863457357827528, -0.63795012710279],
            [29.864031535804305, -0.63635354676634],
            [29.863873838352806, -0.632569123511276],
            [29.864994264785892, -0.631469393799103],
            [29.867879210609043, -0.630911167843978],
            [29.867364924210555, -0.629303141491905],
            [29.86669700523727, -0.629475071358451],
            [29.86637058351414, -0.629119754298937],
            [29.866436598907736, -0.627962371649971],
            [29.865705380147944, -0.627225391292473],
            [29.865209756249488, -0.625778314340944],
            [29.865406624738956, -0.624272468201644],
            [29.86462321386113, -0.62341708560195],
            [29.864166751119207, -0.622022646673914],
            [29.864663749440027, -0.621141724309925],
            [29.864743096730745, -0.619510859329623],
            [29.865723852205125, -0.618038357620616],
            [29.865594043849946, -0.616591500919731],
            [29.866353028636862, -0.614527000494526],
            [29.865929490048387, -0.612557947900843],
            [29.86730560216413, -0.610986194163081],
            [29.86766310739273, -0.608677618720877],
            [29.869524272032653, -0.606948553418467],
            [29.870712386522367, -0.607244939501054],
            [29.871741169525098, -0.605995546394654],
            [29.872196491406644, -0.603594821160093],
            [29.872611962225548, -0.603826724546459],
            [29.873113252696793, -0.603184312043364],
            [29.87388868473826, -0.604084541082003],
            [29.87341672965093, -0.604954387049036],
            [29.87450696999549, -0.604974792939842],
            [29.875517945694323, -0.60620145568578],
            [29.877835187698945, -0.60755741798094],
            [29.878786946454287, -0.609283385872361],
            [29.88020091447441, -0.61001590255127],
            [29.881841213030413, -0.610016856508017],
            [29.88426153222231, -0.61125423978931],
            [29.885134612033468, -0.609437467873416],
            [29.886156189649284, -0.609297081711076],
            [29.887886855129597, -0.608054144009408],
            [29.889008681137867, -0.605467394371818],
            [29.890607694021693, -0.603950702237094],
            [29.891746061607613, -0.601231261512729],
            [29.895413307092575, -0.598795214351255],
            [29.896282339993373, -0.597706859612707],
            [29.896922374361957, -0.596067672291947],
            [29.896650487563118, -0.591583299573632],
            [29.89997897925276, -0.590062609008112],
            [29.901860997383704, -0.588689648060747],
            [29.902576054553215, -0.588937191816156],
            [29.903384656886537, -0.5884107376772],
            [29.905195830280924, -0.585551496281567],
            [29.90414887885156, -0.582605543536908],
            [29.904267550792188, -0.582077825837271],
            [29.90529965666315, -0.581227128269806],
            [29.907316855972976, -0.580996212033605],
            [29.908978185886383, -0.582388729280273],
            [29.910748186796333, -0.581924244305301],
            [29.9113632704579, -0.581180031124352],
            [29.911444271547076, -0.580149209782868],
            [29.913578538406412, -0.574867306078821],
            [29.915944064857563, -0.57252455707522],
            [29.916159364081707, -0.57183949467892],
            [29.915783822478886, -0.570721371412328],
            [29.916214464944602, -0.569261091145385],
            [29.919260674530957, -0.566792468690646],
            [29.9216071063924, -0.566685533979159],
            [29.924461482546462, -0.565124983127361],
            [29.92606922076663, -0.562486645691817],
            [29.926428152519886, -0.56113449646256],
            [29.92631124936208, -0.559419302928614],
            [29.92670358496913, -0.559453065397436],
            [29.923949249696737, -0.557501623844496],
            [29.92280679387796, -0.555813335222217],
            [29.922780171406178, -0.554532012402705],
            [29.920665220122068, -0.552770746297357],
            [29.92055646378557, -0.551904427038684],
            [29.919535332632442, -0.551335128146335],
            [29.919696325104393, -0.549196754894461],
            [29.91938601915749, -0.548312226201216],
            [29.917841682233433, -0.547201112176713],
            [29.9187648556981, -0.546389773692303],
            [29.918787410598227, -0.545848399833346],
            [29.921277471395552, -0.545724096604199],
            [29.922414491508526, -0.545102416035652],
            [29.925749699901534, -0.546296195053781],
            [29.926883184245593, -0.544131525704806],
            [29.927713438672196, -0.544159268921158],
            [29.928046984035507, -0.544818238765348],
            [29.92861638297499, -0.544890886729011],
            [29.92975204753021, -0.543673660662473],
            [29.930937718602355, -0.543557315205478],
            [29.93598404962665, -0.541079968749753],
            [29.936715787612698, -0.539600724855789],
            [29.938184872665406, -0.538907105261428],
            [29.937584443221088, -0.53572137019668],
            [29.934568254433227, -0.534040612897081],
            [29.92584321003106, -0.52017387887208],
            [29.92462772028136, -0.517637383083122],
            [29.934152924649833, -0.493514661046039],
            [29.944560754327654, -0.466936274587747],
            [29.94427358988078, -0.464923086347884],
            [29.944604746623742, -0.463415068390948],
            [29.94382874594871, -0.46276555555388],
            [29.94331587709178, -0.461547052071214],
            [29.94415062129817, -0.459280267064628],
            [29.943335622960046, -0.458025867454689],
            [29.94139639292529, -0.457106329150944],
            [29.938781524693958, -0.453189779227457],
            [29.93775220270207, -0.452585601123635],
            [29.93729520456421, -0.451710154562304],
            [29.93754109142379, -0.449561173292469],
            [29.936513813099165, -0.448870402646846],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 437,
        District: "RUKUNGIRI",
        County: "RUJUMBURA",
        Subcounty: "BWAMBARA",
        Population: 28875,
        Key: "RUKUNGIRIBWAMBARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.020454025486153, -0.905773095772506],
            [30.0201111556102, -0.90556500637482],
            [30.01906981056656, -0.905943616021859],
            [30.018241359058702, -0.905464077987212],
            [30.017673419881568, -0.906258687653897],
            [30.01684506179851, -0.90566169344477],
            [30.015709070256513, -0.906022153094272],
            [30.012087879599544, -0.905449953743242],
            [30.011851250777315, -0.906353251353729],
            [30.0100051868173, -0.906568558664136],
            [30.007934319457416, -0.907298669054527],
            [30.00708242641224, -0.908562847755229],
            [30.00729532623627, -0.909403269541367],
            [30.00587543562348, -0.911190996732482],
            [30.004691992373235, -0.911957972868664],
            [29.99902073754173, -0.911312857549857],
            [29.99725035215282, -0.911641502335808],
            [29.99575930598638, -0.911288017782913],
            [29.99186083324897, -0.911428450712121],
            [29.987447439004157, -0.910142502396228],
            [29.9827918302127, -0.909641174536189],
            [29.981002644881535, -0.90874431785731],
            [29.979520134506906, -0.908809394409574],
            [29.975579618817548, -0.906755622873276],
            [29.97106150706179, -0.905392230719598],
            [29.970256089256143, -0.904286191301388],
            [29.969117596804388, -0.903874275197351],
            [29.96774242432645, -0.903851494061783],
            [29.96726914512236, -0.904521608609317],
            [29.966602931151463, -0.904650827733016],
            [29.964364669924944, -0.904707579810687],
            [29.962671041983793, -0.904301453573587],
            [29.961614488462388, -0.903800153646953],
            [29.96172527139817, -0.903572757250248],
            [29.959275922249535, -0.903033447038515],
            [29.956893792236997, -0.903505993777545],
            [29.954307910843276, -0.902683764639626],
            [29.951375295919583, -0.902476284047088],
            [29.945327929055036, -0.899941743216088],
            [29.944243914933693, -0.899903840783439],
            [29.944235312666525, -0.89916451781858],
            [29.943785443558763, -0.898858478817033],
            [29.943105513211787, -0.898987372991675],
            [29.94343534583803, -0.900060368181044],
            [29.94302958850231, -0.901909540726544],
            [29.942221473055874, -0.901520462090422],
            [29.942019146402746, -0.901779223900052],
            [29.941815326749605, -0.903832006638375],
            [29.94071201412102, -0.904903787825008],
            [29.940260063616755, -0.906628316996625],
            [29.943779125707373, -0.910879723127622],
            [29.945508655717152, -0.911429310291075],
            [29.94567907690634, -0.912005335033294],
            [29.94862811483007, -0.914396338507517],
            [29.9510050777331, -0.917355556217821],
            [29.955123452662182, -0.920302896386516],
            [29.956931297798416, -0.920331207631634],
            [29.958777351876964, -0.922339944689628],
            [29.958948780077563, -0.923972578882868],
            [29.958403178408286, -0.924654543198077],
            [29.958880937510703, -0.925591626181842],
            [29.958507759375344, -0.926728692659594],
            [29.96587620666301, -0.934172886049588],
            [29.965732325300614, -0.937611211449168],
            [29.966354926064458, -0.939381644972413],
            [29.96615655110026, -0.943735267589315],
            [29.965538370945932, -0.944623048148479],
            [29.96553660485807, -0.946659770690208],
            [29.965978193295552, -0.948200368383568],
            [29.966917465468406, -0.948515317693449],
            [29.96770169381315, -0.949617123591861],
            [29.967672733026692, -0.952049012348705],
            [29.96852387867355, -0.953373807395238],
            [29.96858313604129, -0.954681016258629],
            [29.970266693868073, -0.955729582650735],
            [29.970768810789387, -0.957114871169355],
            [29.973934454087672, -0.95937734533703],
            [29.97449677699765, -0.96098224317477],
            [29.9742161963035, -0.963342545455495],
            [29.972517174877414, -0.968811734544241],
            [29.969472865227917, -0.975613393259945],
            [29.96665058947224, -0.974248897189032],
            [29.96313133244718, -0.971102532428594],
            [29.959249540526276, -0.968435415782448],
            [29.95354897187042, -0.965964768399825],
            [29.949359000314903, -0.966266330389204],
            [29.94823434371515, -0.967142719703865],
            [29.946196048369185, -0.967601351178596],
            [29.94571925675235, -0.968152822797979],
            [29.94482792047968, -0.972840491854935],
            [29.942768167076522, -0.97534485028791],
            [29.942261655596845, -0.980623728045778],
            [29.938979268142532, -0.979934417779481],
            [29.939581345097096, -0.983563450622587],
            [29.939366236315767, -0.990162006931796],
            [29.938761297328718, -0.992637524376982],
            [29.937826641598086, -0.992531422315967],
            [29.935835918334615, -0.990598233725267],
            [29.93388654452367, -0.987245979726811],
            [29.933167817736212, -0.989667229440238],
            [29.930321167093627, -0.99565664708108],
            [29.928642125996078, -1.002104290759598],
            [29.92857207806518, -1.002742173042208],
            [29.92978636676732, -1.004001736809283],
            [29.935390667465725, -1.008516382713823],
            [29.93943232177797, -1.012942191961369],
            [29.940469696268075, -1.013423839115001],
            [29.942342343173962, -1.013021853786984],
            [29.94253957817608, -1.012330709041292],
            [29.944843407435172, -1.012092480669298],
            [29.947027783219404, -1.012617592433685],
            [29.958601547982603, -1.016686468094862],
            [29.960073006384274, -1.01773629485047],
            [29.963539526013967, -1.018619416706972],
            [29.968559624435358, -1.021709380252994],
            [29.969959358649806, -1.023284030677711],
            [29.97190658369059, -1.023522871674493],
            [29.972286915110534, -1.023141231203098],
            [29.974175288822114, -1.022795584037542],
            [29.97531485745555, -1.023225153704855],
            [29.976596153291386, -1.02448967459819],
            [29.981741988903075, -1.024552834030312],
            [29.984651500055985, -1.026639551988133],
            [29.986591950901225, -1.027184096002263],
            [29.98789394661615, -1.030170219235788],
            [29.98970345543231, -1.032364497400124],
            [29.99211837125777, -1.032952902534337],
            [29.993185092809888, -1.033833116410847],
            [29.99607577257951, -1.033010952113907],
            [29.99936650448449, -1.031071161845855],
            [30.001803979701695, -1.030617592335387],
            [30.003638979112328, -1.028665561239811],
            [30.00632530832449, -1.02728959695393],
            [30.008078886234404, -1.025824956521601],
            [30.009687953961215, -1.025843981586208],
            [30.01366208101524, -1.026888231299876],
            [30.021099734512404, -1.029107647021503],
            [30.02443233868939, -1.030485860439118],
            [30.026115706971655, -1.031587341802963],
            [30.026989637487397, -1.03393097552026],
            [30.027348372509593, -1.038867694846426],
            [30.026346138316775, -1.041663428954494],
            [30.020177964216202, -1.052317955302366],
            [30.021884085926313, -1.053921487097032],
            [30.023603282615387, -1.054891578770903],
            [30.02481116093964, -1.05635113108195],
            [30.027681537885535, -1.057382288054174],
            [30.030016262902233, -1.059237554928464],
            [30.03538217497873, -1.058693816722451],
            [30.039689400035055, -1.059379981827174],
            [30.043009646987, -1.061057073874464],
            [30.04652477176175, -1.060832520979727],
            [30.045159830196575, -1.052597541099091],
            [30.04599744991021, -1.048984251608893],
            [30.045636909274286, -1.045026487104235],
            [30.04855907409631, -1.043694509533496],
            [30.04989844332031, -1.041801110741003],
            [30.04955997698586, -1.037901383994845],
            [30.05043707316467, -1.031867095601151],
            [30.047096203588723, -1.027242460046711],
            [30.046994639164392, -1.023361301313936],
            [30.044402592632892, -1.019401483070582],
            [30.047893785390126, -1.016624347695433],
            [30.049695839087743, -1.015925419244552],
            [30.05109373804409, -1.015879603384714],
            [30.05364044480659, -1.01312669414634],
            [30.05569928731803, -1.013052040546383],
            [30.056940164355964, -1.012017010604303],
            [30.058232808608803, -1.011953427886027],
            [30.059977232685988, -1.010306571188835],
            [30.06119003198138, -1.00797041014261],
            [30.06406260261318, -1.007078140150879],
            [30.06700849014522, -1.004603520980287],
            [30.067477008278296, -1.00393982184991],
            [30.06736623342735, -1.002220544616343],
            [30.06998966978983, -1.000459645794422],
            [30.070226372273922, -0.997975119197909],
            [30.06981239804828, -0.995526151455026],
            [30.070498782790573, -0.993638361338041],
            [30.069859989893743, -0.990366972760962],
            [30.07115009371092, -0.986148576367944],
            [30.07027448514223, -0.98357270729582],
            [30.067990505057633, -0.980119170610257],
            [30.068014189140108, -0.979495749224059],
            [30.068866334611872, -0.978565851096145],
            [30.06844034901258, -0.977472193908906],
            [30.068830977820614, -0.974039081966156],
            [30.069801382906274, -0.972747864646974],
            [30.069056039935248, -0.967195957959823],
            [30.07020409854646, -0.959899852584017],
            [30.071127301655526, -0.958346555232874],
            [30.074216158759985, -0.955295224973958],
            [30.075139165137994, -0.950633717699114],
            [30.07587299080876, -0.949441660900502],
            [30.0754232762112, -0.948176313896241],
            [30.071707420191274, -0.944811978591895],
            [30.070062327326635, -0.944223283888986],
            [30.067967677069625, -0.942351181778683],
            [30.066381845165974, -0.942015531235627],
            [30.06403874425757, -0.93922161903485],
            [30.062476609911087, -0.938226412998216],
            [30.060168885556905, -0.937926299141015],
            [30.058464783259566, -0.935629888814248],
            [30.05799140344417, -0.934319368322555],
            [30.058180830289817, -0.933199148162204],
            [30.05761268539848, -0.932340316266647],
            [30.056879081611594, -0.932285488564414],
            [30.056500274632693, -0.931426816324978],
            [30.054381948378083, -0.930395015539671],
            [30.053955977151805, -0.929247176365805],
            [30.051494431576575, -0.927745259289272],
            [30.050169021273778, -0.927979066384177],
            [30.049837704630693, -0.927527026026725],
            [30.050003353070768, -0.926831449178837],
            [30.04934065330925, -0.92685800080259],
            [30.047399891646943, -0.92583211780852],
            [30.04582601003148, -0.92312351175933],
            [30.045802250490556, -0.919608791172099],
            [30.044914668277418, -0.916807137621732],
            [30.041932584029336, -0.916108954796717],
            [30.0398733381743, -0.914724865347281],
            [30.039968107741853, -0.913911777958234],
            [30.03937630841245, -0.913513741057386],
            [30.039340853704807, -0.912275893070798],
            [30.03716340213481, -0.910349606202945],
            [30.036831942659585, -0.90714185544215],
            [30.033826114141924, -0.906524993131646],
            [30.031696137636356, -0.906767188132393],
            [30.03065474228704, -0.906332645681133],
            [30.02628804336905, -0.90587329930169],
            [30.025223071735084, -0.906445624334254],
            [30.02221724321742, -0.90690392872594],
            [30.020454025486153, -0.905773095772506],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 438,
        District: "RUKUNGIRI",
        County: "RUBABO",
        Subcounty: "NYARUSHANJE",
        Population: 44883,
        Key: "RUKUNGIRINYARUSHANJE",
        Dist2: "Rukungiri",
        "Sub Country": "Nyarushanje",
        id2_original: "Rukungiri Nyarushanje",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.182213753918983, -1.082717682929357],
            [30.179322887299794, -1.082235643158117],
            [30.17575010595518, -1.080068590970849],
            [30.171597698351558, -1.075402586004715],
            [30.165202114838497, -1.066216878403355],
            [30.16262011776006, -1.06311336397225],
            [30.15562863590497, -1.056747007006224],
            [30.151636290118677, -1.054167845200882],
            [30.151167559983225, -1.053172219410694],
            [30.147756358608724, -1.052784362734856],
            [30.145472928293085, -1.049488210004565],
            [30.141822609763036, -1.048413796596354],
            [30.14029876251227, -1.047067229768449],
            [30.139072756185556, -1.046791426549776],
            [30.135678483562597, -1.047295505652458],
            [30.134122941053676, -1.048364244838514],
            [30.13104467508643, -1.047482586276655],
            [30.12965418902783, -1.047728086242517],
            [30.128262129120845, -1.048824439357243],
            [30.127006241234515, -1.049975838791233],
            [30.12584767592772, -1.052089126516041],
            [30.125868112600457, -1.053775962182654],
            [30.1226845407257, -1.059790853969467],
            [30.11699698237014, -1.062484398170652],
            [30.11554473713572, -1.064583751406689],
            [30.11394874079461, -1.069104122929019],
            [30.113240103884426, -1.072312698731246],
            [30.113094058480474, -1.075227419327156],
            [30.111462070239195, -1.080353018000211],
            [30.110110147059096, -1.080565593459297],
            [30.10927745280818, -1.082047034186636],
            [30.10694883723374, -1.083096709660863],
            [30.10518909508434, -1.085366180689482],
            [30.10078080237205, -1.086697232214531],
            [30.09848894675733, -1.086978288749113],
            [30.09383595924987, -1.086703281279776],
            [30.092392244417386, -1.084311299400557],
            [30.091784579043452, -1.081155396872135],
            [30.090686274522582, -1.080211843205853],
            [30.088854862084865, -1.079595410188033],
            [30.08531995730586, -1.07985859318398],
            [30.08343902523811, -1.080942463090339],
            [30.08259402496609, -1.081015388818946],
            [30.082403585719117, -1.081469426997431],
            [30.0824256474442, -1.083238526501641],
            [30.0808313102914, -1.086416537609781],
            [30.081556813969392, -1.089888262001039],
            [30.07789684483822, -1.091245868099517],
            [30.079010602178627, -1.092057275896906],
            [30.08096164505934, -1.095992026550584],
            [30.082785461343036, -1.098169563970818],
            [30.084260644159908, -1.102653619016732],
            [30.084158475169364, -1.106430645448826],
            [30.082737659291826, -1.110767923713464],
            [30.082679105304955, -1.116257933261257],
            [30.08315163172084, -1.118302639135441],
            [30.084912314406328, -1.122428475284933],
            [30.08831153045829, -1.126317192616555],
            [30.09001896550536, -1.127275440516888],
            [30.09236818483916, -1.127828041734747],
            [30.094303118231895, -1.127770545425533],
            [30.096721302128365, -1.129494624982487],
            [30.09929119979824, -1.132569592292842],
            [30.103678745919034, -1.134869761504125],
            [30.104981977715795, -1.136162252499095],
            [30.107524176732195, -1.141293174060585],
            [30.10897031881253, -1.142346760505695],
            [30.110189702758976, -1.144033610804971],
            [30.110492124192653, -1.147237436035921],
            [30.110047847995855, -1.149854666410582],
            [30.112386937028194, -1.155642827716713],
            [30.113240780315838, -1.156074163032949],
            [30.114643208577853, -1.155191296923011],
            [30.116471991646733, -1.154810968232709],
            [30.122450029232596, -1.155966194041109],
            [30.129511952480676, -1.156512492937928],
            [30.136504410804502, -1.156174127864794],
            [30.14043779476881, -1.160147365803258],
            [30.143572409358853, -1.159768570887731],
            [30.14477382969458, -1.158490950145884],
            [30.147054029668457, -1.157967694100404],
            [30.150594387221236, -1.156489621999085],
            [30.15161055787736, -1.15892935961101],
            [30.15222654973569, -1.159599490488449],
            [30.15323513681418, -1.159827809828549],
            [30.154538214100704, -1.161480148088065],
            [30.15667723125129, -1.16075980315553],
            [30.159195840508307, -1.159734747264359],
            [30.163446725924942, -1.159165966962179],
            [30.16656706359021, -1.160066186423021],
            [30.170033217605553, -1.160165895146708],
            [30.180877949210032, -1.15681955267523],
            [30.187331340209944, -1.152989838086273],
            [30.19148846037554, -1.151847078063931],
            [30.19232696492971, -1.152040027726099],
            [30.191441515317084, -1.151302449698358],
            [30.190838115144135, -1.14910184467698],
            [30.189691033899972, -1.147762312492796],
            [30.188060216163503, -1.146989349524265],
            [30.18623503533888, -1.144283399540547],
            [30.180694409922772, -1.140969493524332],
            [30.177564612997557, -1.134905156266649],
            [30.177826370393262, -1.132922766881761],
            [30.177579218705766, -1.129086331970146],
            [30.180163619675874, -1.123098656878025],
            [30.181642421805012, -1.116692602083816],
            [30.179194860303834, -1.112273574290192],
            [30.178879654047027, -1.106108431317541],
            [30.178981822139242, -1.105138470056233],
            [30.180325116102726, -1.10255867479306],
            [30.180942466213743, -1.099400376295129],
            [30.182213753918983, -1.082717682929357],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 439,
        District: "NTUNGAMO",
        County: "RUSHENYI",
        Subcounty: "KAYONZA",
        Population: 27616,
        Key: "NTUNGAMOKAYONZA",
        Dist2: "Ntungamo",
        "Sub Country": "Kayonza",
        id2_original: "Ntungamo Kayonza",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.385058599319258, -0.297153817098561],
            [30.39409148019964, -0.293879083729897],
            [30.393023184799144, -0.290780778947166],
            [30.393587666360748, -0.289415769538738],
            [30.393517755872107, -0.288151582903955],
            [30.392459205395788, -0.287108990661474],
            [30.391646453744173, -0.285552150662947],
            [30.391212600699596, -0.283652740326554],
            [30.39305897188345, -0.283826700541424],
            [30.394045806257356, -0.281902120330499],
            [30.395654340384883, -0.28139841408714],
            [30.396519485377116, -0.280344569072458],
            [30.397004934058348, -0.280894583856056],
            [30.399539052728755, -0.280956265035303],
            [30.39932648438308, -0.281475594608619],
            [30.39959955336484, -0.281582585362335],
            [30.405129518473498, -0.281821168729881],
            [30.407252547408643, -0.277893823378501],
            [30.40730869121557, -0.275128201540505],
            [30.409315201471866, -0.270446933328783],
            [30.40938078926738, -0.269398535567874],
            [30.40599259913723, -0.264571517745596],
            [30.404475856662042, -0.260892735248059],
            [30.40195643173473, -0.258560417425414],
            [30.401233876327545, -0.258309040823355],
            [30.395184438846282, -0.259345227049386],
            [30.39440629209602, -0.259286318831366],
            [30.391035775420765, -0.257545389839822],
            [30.387909096547915, -0.257659472032895],
            [30.38668382594142, -0.25615121134114],
            [30.38483646750909, -0.252488538430683],
            [30.38116409174554, -0.243056274831792],
            [30.378204861536577, -0.236638857404052],
            [30.37279318748284, -0.228223670770469],
            [30.37114622342748, -0.226108535786848],
            [30.367811404903282, -0.22308933029763],
            [30.36652544052293, -0.221290594128881],
            [30.365282998619787, -0.218452530718318],
            [30.364199380655457, -0.212026529782221],
            [30.360349172601637, -0.197809603683258],
            [30.358123380889563, -0.195106989529569],
            [30.35635565631056, -0.193642613787515],
            [30.354533841473327, -0.192747605798355],
            [30.349960698024912, -0.192593259935538],
            [30.34914196808508, -0.193406517216326],
            [30.34794252044975, -0.192601986120909],
            [30.345725674161265, -0.192050350880761],
            [30.342542184033213, -0.191932371305265],
            [30.34003219680627, -0.193161088995739],
            [30.3345617504751, -0.192563763021497],
            [30.327947427190338, -0.194017762476489],
            [30.323839396361766, -0.196330695317817],
            [30.321445309772805, -0.196610473968163],
            [30.320402940649704, -0.195209512759903],
            [30.318945602865977, -0.191512995162775],
            [30.316797682512618, -0.190021496427804],
            [30.31577554344972, -0.188394614996586],
            [30.31529921985517, -0.1883041686109],
            [30.314665575203207, -0.188783051607807],
            [30.31439972508306, -0.190039201226353],
            [30.312735933785778, -0.189921458790983],
            [30.311983901959167, -0.190427432985941],
            [30.31063109393852, -0.192026827728863],
            [30.309513827778623, -0.194267905914498],
            [30.307204077723462, -0.19538816417418],
            [30.302486186038372, -0.198975202099316],
            [30.30151322434741, -0.201333764791784],
            [30.296198001507435, -0.204667619159306],
            [30.294002792939207, -0.205181072230353],
            [30.295857381911276, -0.206836470647243],
            [30.297115106852342, -0.206785700893054],
            [30.298032425996322, -0.208228741508233],
            [30.298845990623242, -0.208674090041038],
            [30.299589677100883, -0.211012813044833],
            [30.30075082326747, -0.212386359179391],
            [30.300646437234825, -0.213202782004774],
            [30.299227055966785, -0.214517998945254],
            [30.29853692075818, -0.216173493387578],
            [30.298764738005815, -0.216626192552877],
            [30.29979959811144, -0.216111708600278],
            [30.30008903170272, -0.216434202388106],
            [30.29969807321298, -0.218985969803462],
            [30.300989588283464, -0.220609901682049],
            [30.300637474743247, -0.223387828319319],
            [30.30150869414345, -0.224357591791619],
            [30.30250940659018, -0.227797562781141],
            [30.302157495170874, -0.229398114316223],
            [30.3029444624789, -0.231260518853803],
            [30.303012911408604, -0.23310739859076],
            [30.302630499490448, -0.23427700704001],
            [30.30316539773314, -0.23516976234579],
            [30.304418861066505, -0.235824102248008],
            [30.304663273790716, -0.236824537588346],
            [30.305397031189507, -0.237094014597624],
            [30.30791182440319, -0.237271494125936],
            [30.30958599034369, -0.236433029075301],
            [30.31024335051916, -0.236502413458618],
            [30.310380653518752, -0.238003028190577],
            [30.31119855611023, -0.237964709984364],
            [30.312223102658084, -0.236572052960923],
            [30.312895779109134, -0.236495229692494],
            [30.313866349484822, -0.23756506912519],
            [30.314271161792867, -0.239204257548727],
            [30.315379264238537, -0.240574246417665],
            [30.316296089309088, -0.242859948893243],
            [30.318199303189175, -0.243491346561704],
            [30.31986345291424, -0.24605323752514],
            [30.31837355479472, -0.251332967598106],
            [30.31958693260517, -0.252723275814536],
            [30.318975920108482, -0.252813523283004],
            [30.316858687103544, -0.254548260890933],
            [30.31527191825705, -0.256693207134832],
            [30.31537758259234, -0.257512204611797],
            [30.314086942480927, -0.260512329612612],
            [30.31067190799512, -0.263918671361035],
            [30.31465611324832, -0.270128228985274],
            [30.31576008254538, -0.273807314139551],
            [30.31603077188992, -0.276245676648262],
            [30.318223365462362, -0.279283360560038],
            [30.318222960322174, -0.281080007375619],
            [30.317202797552923, -0.28270531044621],
            [30.316904347571143, -0.287111299302762],
            [30.31715901905587, -0.288309122953463],
            [30.320769253859638, -0.294897691544587],
            [30.322680847224657, -0.297122579502967],
            [30.325900924835928, -0.299195039361958],
            [30.327217140881803, -0.300975696817551],
            [30.32987676318056, -0.308088882558451],
            [30.331771941630414, -0.306065332476466],
            [30.33580938913215, -0.303200213443323],
            [30.336616998827115, -0.302130962781195],
            [30.340271465777132, -0.301575741572267],
            [30.341588583731554, -0.30217495716045],
            [30.344094983985556, -0.304870596416646],
            [30.347196425588823, -0.306967497606379],
            [30.34868069216984, -0.309015032186637],
            [30.35110739658678, -0.309207081114601],
            [30.354235652901266, -0.308335223096263],
            [30.356949723886032, -0.305945624688996],
            [30.35921197282561, -0.301772682790346],
            [30.362114250743858, -0.29960435113279],
            [30.368650246325696, -0.297641800540043],
            [30.374734147672832, -0.297605621380092],
            [30.376606977835063, -0.296754628215808],
            [30.379138263219062, -0.296595777660392],
            [30.385058599319258, -0.297153817098561],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 440,
        District: "BUHWEJU",
        County: "BUHWEJU",
        Subcounty: "BIHANGA",
        Population: 13347,
        Key: "BUHWEJUBIHANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.381613257472438, 0.085776357447947],
            [30.378984534524506, 0.086408818304709],
            [30.37803435051588, 0.086273182732266],
            [30.37645118391365, 0.085342175205765],
            [30.375442108151642, 0.082856710172159],
            [30.373871969815987, 0.082178768499988],
            [30.37133569518888, 0.082946804812645],
            [30.369768881518105, 0.082955734057202],
            [30.368989208530177, 0.083741963914767],
            [30.36820621806393, 0.083823248784689],
            [30.363916707785005, 0.082864951307946],
            [30.36173313689131, 0.082964215042909],
            [30.35826295033863, 0.082087320098026],
            [30.3577118788276, 0.083506195929673],
            [30.355437643667184, 0.084464027165635],
            [30.348850524962494, 0.084562973791587],
            [30.343847870925636, 0.080938555675266],
            [30.341019442608577, 0.080215358687789],
            [30.33968460358854, 0.079085577392763],
            [30.331307494662223, 0.077169072923236],
            [30.328460805392062, 0.075108347565948],
            [30.327480861994694, 0.073716518801513],
            [30.32610083771589, 0.073056699580026],
            [30.325074312179467, 0.071872733558926],
            [30.32466606201883, 0.070878592161601],
            [30.324852513644252, 0.070191758782129],
            [30.322263951677723, 0.06748941994915],
            [30.321299389234653, 0.064380500133476],
            [30.320679451975632, 0.06381110963512],
            [30.317570929851282, 0.063711528752571],
            [30.317104719490185, 0.060548425055043],
            [30.3182146679738, 0.056897384401075],
            [30.320145829340653, 0.053734392607345],
            [30.32192661811888, 0.053815812275576],
            [30.32167072672199, 0.054882213547677],
            [30.322501929769523, 0.054954552149347],
            [30.323146408103817, 0.055704687282611],
            [30.32388182019936, 0.055587236207866],
            [30.325239673158666, 0.056572381277162],
            [30.32597411148046, 0.056283219117309],
            [30.326712025384047, 0.056689939249364],
            [30.327394748593267, 0.055515105117732],
            [30.328140416754405, 0.055099417998494],
            [30.32905185372989, 0.052126139440519],
            [30.330782186833513, 0.051593006605744],
            [30.33153810926365, 0.050806779823443],
            [30.33401884285335, 0.050824963514271],
            [30.334483767725267, 0.048800584735549],
            [30.335272259474337, 0.047390768327084],
            [30.334287269341704, 0.044968679342629],
            [30.332520564350542, 0.042917103008669],
            [30.33180782663107, 0.04034139571565],
            [30.331872396635365, 0.038985777191311],
            [30.333279093691587, 0.035343718538771],
            [30.33470000658721, 0.034629800566118],
            [30.33716805596509, 0.032036109658476],
            [30.33716261666607, 0.030924494967853],
            [30.33779860951418, 0.029894235279913],
            [30.337703850726417, 0.027481215202337],
            [30.337221513809332, 0.025944825840628],
            [30.336122563399783, 0.024498798884764],
            [30.335407699368016, 0.022389826065539],
            [30.335332384614595, 0.02067591877798],
            [30.334328810135386, 0.019320275756872],
            [30.33450796564408, 0.017115130136591],
            [30.33308077352465, 0.016527670593652],
            [30.328483876823515, 0.015804602277212],
            [30.32665888284849, 0.016410082924447],
            [30.32357250509422, 0.016337734411033],
            [30.32123244408476, 0.018389187286671],
            [30.319253126730437, 0.021416674901175],
            [30.318138568092817, 0.014340389737301],
            [30.315648283615012, 0.005040917769884],
            [30.313928948585392, 0.002962317717267],
            [30.309766655022077, -0.00578581876647],
            [30.308750010055462, -0.010674996666417],
            [30.308854622463546, -0.01360308401507],
            [30.30816979899325, -0.019233314350742],
            [30.30756959951762, -0.020353931159728],
            [30.30407730542581, -0.023300029581752],
            [30.30125109864247, -0.027104662139207],
            [30.299578619738046, -0.033358394507063],
            [30.300990756093324, -0.034090446776646],
            [30.304120286218897, -0.03378326073258],
            [30.3055130629815, -0.03479547233201],
            [30.306218832469284, -0.035916114147359],
            [30.308261472067976, -0.035961355991111],
            [30.310578844328315, -0.037651398407171],
            [30.311159199121, -0.039485991363581],
            [30.312723881089617, -0.037796057679275],
            [30.314208167433573, -0.037036963459753],
            [30.315464790141796, -0.036928550302265],
            [30.3169737181723, -0.03777810575055],
            [30.320233080009274, -0.035871310681348],
            [30.322301365611, -0.037588473231686],
            [30.323299667877823, -0.036106366507156],
            [30.323843476509783, -0.035961782690782],
            [30.324415750956476, -0.036115434998154],
            [30.32577632042117, -0.038115040383518],
            [30.32749075963251, -0.039455304920747],
            [30.328983309578764, -0.041303223442847],
            [30.329890973630043, -0.041384476937455],
            [30.332553514555137, -0.039861584080326],
            [30.335357182608043, -0.040653619487698],
            [30.336123697971985, -0.039435257223307],
            [30.33733391640758, -0.039821116783196],
            [30.33838281897774, -0.038623066308853],
            [30.340137658122313, -0.038521586349141],
            [30.341005004885325, -0.038095175043731],
            [30.342174966219794, -0.035597506032625],
            [30.34550308241365, -0.03691752348445],
            [30.35206446528376, -0.032929162468139],
            [30.353728632076805, -0.033052475085062],
            [30.357469052528195, -0.031543277799791],
            [30.358395523708275, -0.031579450255859],
            [30.36024307168513, -0.028208437271559],
            [30.363852605802958, -0.028217549780711],
            [30.366343802070784, -0.027322865592057],
            [30.369293237948195, -0.027657320910234],
            [30.37090527730197, -0.024403759831299],
            [30.378591779404175, -0.015483567762841],
            [30.38183235297695, -0.010829112532173],
            [30.382653652098515, -0.008641959188792],
            [30.384148249305294, -0.006255971830761],
            [30.3845885405755, -0.003298492448917],
            [30.384797569558973, -0.003788637521503],
            [30.38468703545652, -0.002704093395898],
            [30.386710165443848, 0.000423011277404],
            [30.38925342447229, 0.001896194444092],
            [30.39361347316223, 0.006713425411518],
            [30.396479926266966, 0.008304126170326],
            [30.401566297898423, 0.013998101081804],
            [30.404640733449313, 0.018905779633114],
            [30.405562815460907, 0.023009052708589],
            [30.406412283953117, 0.0243647729515],
            [30.407177282960866, 0.024553017597077],
            [30.404918756639855, 0.031595147414755],
            [30.40431389490789, 0.036593147291987],
            [30.401224293100075, 0.043226929167677],
            [30.400626159749635, 0.047176503136793],
            [30.40070455213121, 0.051108027039908],
            [30.39959163291896, 0.054135698613046],
            [30.39846074650274, 0.055915623289352],
            [30.398199001683462, 0.058256925506596],
            [30.394648480591588, 0.064958189256728],
            [30.394406171721776, 0.069507029245424],
            [30.392873063738772, 0.070887840310375],
            [30.390373783531697, 0.071589376394311],
            [30.388453167487935, 0.072870736788912],
            [30.388724189209167, 0.07493139308139],
            [30.3879694624367, 0.075961664597616],
            [30.38500020163928, 0.078049224363197],
            [30.38166033637982, 0.084511062902753],
            [30.381613257472438, 0.085776357447947],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 441,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "NTARA",
        Population: 28716,
        Key: "KAMWENGENTARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.477170614267692, 0.130767751974964],
            [30.47039540451218, 0.132265156963741],
            [30.466452854138726, 0.134734519263527],
            [30.465887427549443, 0.13563830367037],
            [30.46574436814551, 0.138006359313399],
            [30.46411426456968, 0.139705405394303],
            [30.462539803540885, 0.143085600106506],
            [30.46116706190409, 0.143971207738826],
            [30.460685225348616, 0.144983454030544],
            [30.459597803019083, 0.145959475830759],
            [30.459034971662653, 0.147432669440483],
            [30.458855575405497, 0.149647054089909],
            [30.45831289146423, 0.15033390719589],
            [30.455483262997976, 0.151906245426401],
            [30.455111050551565, 0.153505991941801],
            [30.453922342275437, 0.155656975806511],
            [30.452952499535126, 0.156398000523224],
            [30.452343608859152, 0.158160402232251],
            [30.450284155493286, 0.159407433331075],
            [30.449695828152464, 0.160500995875647],
            [30.447029291520977, 0.161413524296665],
            [30.4399092661386, 0.161873558706039],
            [30.435807712163236, 0.160562484417156],
            [30.433736256406846, 0.159287830300077],
            [30.432239254410078, 0.15900745460507],
            [30.429248787982072, 0.159867733685915],
            [30.42730525232213, 0.161474764003115],
            [30.42631167160046, 0.161846477303238],
            [30.42187659831293, 0.161625719896671],
            [30.416871922168344, 0.160652264388875],
            [30.416247505010965, 0.160322586667864],
            [30.415331330320683, 0.158288719793093],
            [30.414472426823018, 0.154639791088403],
            [30.414237997974915, 0.150265332737969],
            [30.413408256486328, 0.148032829191848],
            [30.412580164304615, 0.143640230803116],
            [30.412753378356005, 0.142627988045081],
            [30.414189064046457, 0.139965379758197],
            [30.41288589064018, 0.138054741535872],
            [30.411717474408018, 0.137941138219609],
            [30.410536164656577, 0.12906111183255],
            [30.409080256990762, 0.127909275108507],
            [30.40876837539885, 0.126548081975718],
            [30.408248425122498, 0.126233985004226],
            [30.408456554892375, 0.123930560984533],
            [30.408144672402134, 0.123825820362172],
            [30.40783285369228, 0.122045852249885],
            [30.406792892952467, 0.12131291666577],
            [30.4062732570865, 0.117438943107146],
            [30.405233421212515, 0.115763590368222],
            [30.402113477907662, 0.115763277755137],
            [30.399097537054836, 0.115239511601384],
            [30.39244157685665, 0.115657725026171],
            [30.391505554788495, 0.115238822594971],
            [30.390465781796575, 0.113877630623665],
            [30.39056984713066, 0.112411820991621],
            [30.390049898650968, 0.112097723858739],
            [30.389946021963066, 0.111155368659643],
            [30.388282233360737, 0.108956561903646],
            [30.389218504262256, 0.105501614134285],
            [30.388490613760577, 0.104768679029567],
            [30.387970727264616, 0.102674612515635],
            [30.3856829257468, 0.100371063553949],
            [30.385579173924732, 0.097544187250696],
            [30.385995309496955, 0.096706635215802],
            [30.387867349141708, 0.095450370905026],
            [30.38849148782135, 0.093984685283501],
            [30.387555655297685, 0.091471780924773],
            [30.38765984459931, 0.08937784024974],
            [30.386931890317236, 0.088330807434476],
            [30.385787929820353, 0.088330745450784],
            [30.385059974639983, 0.087702486940254],
            [30.384956035070022, 0.08686487358844],
            [30.38412414211632, 0.086341293818151],
            [30.381613257472438, 0.085776357447947],
            [30.38166033637982, 0.084511062902753],
            [30.38500020163928, 0.078049224363197],
            [30.3879694624367, 0.075961664597616],
            [30.388724189209167, 0.07493139308139],
            [30.388453167487935, 0.072870736788912],
            [30.390373783531697, 0.071589376394311],
            [30.392873063738772, 0.070887840310375],
            [30.394406171721776, 0.069507029245424],
            [30.394648480591588, 0.064958189256728],
            [30.398199001683462, 0.058256925506596],
            [30.39846074650274, 0.055915623289352],
            [30.39959163291896, 0.054135698613046],
            [30.40070455213121, 0.051108027039908],
            [30.400626159749635, 0.047176503136793],
            [30.401224293100075, 0.043226929167677],
            [30.40431389490789, 0.036593147291987],
            [30.404918756639855, 0.031595147414755],
            [30.407177282960866, 0.024553017597077],
            [30.410605714022488, 0.024160995537464],
            [30.413792821666192, 0.025298294920549],
            [30.415426707149347, 0.02649648658872],
            [30.418407571485304, 0.030059037484431],
            [30.422219969448797, 0.032334682662348],
            [30.422407402034516, 0.033432283621569],
            [30.422959593744732, 0.03403620381443],
            [30.422791576447246, 0.035762215701294],
            [30.421657416570124, 0.036864832812388],
            [30.422561199899377, 0.037217347825875],
            [30.42296825799563, 0.037922335627824],
            [30.423396511841037, 0.038112150503895],
            [30.423727432327098, 0.037804863862071],
            [30.424858806528512, 0.036132842548282],
            [30.42531090974639, 0.036340734223018],
            [30.425601246144552, 0.037461473935638],
            [30.42626657078332, 0.037597068310498],
            [30.42714274888387, 0.037145187072628],
            [30.428117239507454, 0.037371172607599],
            [30.428745463725, 0.039621698922892],
            [30.42776476125121, 0.040570674465071],
            [30.427557110283423, 0.041808896661361],
            [30.429249632398413, 0.04321891260436],
            [30.428516528074848, 0.04381540545908],
            [30.428521819151854, 0.044909024937928],
            [30.42776431029694, 0.045369943180645],
            [30.42772149120063, 0.046318950092443],
            [30.42930252340572, 0.046798034950029],
            [30.43031788737474, 0.045668300541798],
            [30.431029932493118, 0.045623136856892],
            [30.43180108136729, 0.047991175105516],
            [30.43344298700933, 0.048786603361527],
            [30.43379845485881, 0.048642006094099],
            [30.434004721522776, 0.047123594181095],
            [30.43523971459562, 0.04721402485516],
            [30.4358885713186, 0.04884997049868],
            [30.437364673112, 0.049717701419601],
            [30.438009409262758, 0.051132902278532],
            [30.440378983522596, 0.052332896498728],
            [30.44145202023114, 0.05324957295814],
            [30.4415969445376, 0.053911445081851],
            [30.442739920480932, 0.054071737695026],
            [30.443572106285426, 0.054878064231287],
            [30.444556367884342, 0.05637884203816],
            [30.444513755400532, 0.057716882888872],
            [30.445220150115762, 0.058689475768758],
            [30.448735330586057, 0.060956951667163],
            [30.45197493308001, 0.061504302942056],
            [30.45226900197818, 0.063402370144505],
            [30.452938917906348, 0.064496044965498],
            [30.453737353107286, 0.06513781087526],
            [30.45433073616654, 0.065092649900145],
            [30.454918040326266, 0.06606527228917],
            [30.455291663127657, 0.06743363820192],
            [30.454967109002023, 0.069051487609639],
            [30.454138176895487, 0.069458167218098],
            [30.453974441866965, 0.069982383205625],
            [30.45561581031647, 0.070660353816326],
            [30.45530067951816, 0.071772054952563],
            [30.45609273398565, 0.073543622896489],
            [30.455309827062703, 0.07367011277064],
            [30.454641858682038, 0.072983157262406],
            [30.45336303590818, 0.073660958047153],
            [30.453155070530038, 0.074844969834988],
            [30.45191895366479, 0.074519514975571],
            [30.450590776550893, 0.074790584975711],
            [30.452284669495057, 0.078948326625956],
            [30.45281800197417, 0.081253139982769],
            [30.453153900923514, 0.084443700109462],
            [30.452883241223375, 0.087390184403036],
            [30.453223029877886, 0.088926728419734],
            [30.452990753393195, 0.092460707099338],
            [30.453362530156678, 0.095732618479534],
            [30.453899335522703, 0.096284000033564],
            [30.454816616937414, 0.094476398150526],
            [30.457299345685367, 0.097332715155486],
            [30.457615830244805, 0.09895061094801],
            [30.458566211882793, 0.099113377349529],
            [30.459414446089827, 0.097775761814793],
            [30.460316310617618, 0.097703524794637],
            [30.461683116187025, 0.100541693788329],
            [30.46288871368882, 0.101924668670792],
            [30.465024358563802, 0.101698881972166],
            [30.46780674373097, 0.102675261098231],
            [30.46980994279713, 0.104519272986693],
            [30.47211210657971, 0.104365810448413],
            [30.474751506004775, 0.10768316094159],
            [30.47591389184646, 0.107511528227728],
            [30.47660501340524, 0.108053898595572],
            [30.4764979117655, 0.110476212134085],
            [30.4772510188755, 0.111578500410284],
            [30.476615963868557, 0.112817198455281],
            [30.47669700628024, 0.114859910378737],
            [30.47890338809396, 0.114534724490722],
            [30.479550534424636, 0.115791139845094],
            [30.479554663979993, 0.116667878487083],
            [30.477958690096777, 0.118050625353712],
            [30.477612010465702, 0.120020991235381],
            [30.47590983146138, 0.121521222936022],
            [30.47577019463866, 0.122099673789658],
            [30.475702096051926, 0.122759478571346],
            [30.477079414605107, 0.125308475454708],
            [30.477603473775552, 0.125661030120526],
            [30.478765593715888, 0.125417104868726],
            [30.479410116965937, 0.126149290248038],
            [30.47740219365974, 0.128246027514328],
            [30.477739469726398, 0.12926741480324],
            [30.477170614267692, 0.130767751974964],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 442,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "NYABBANI",
        Population: 21953,
        Key: "KAMWENGENYABBANI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.484309601289073, 0.222244192677313],
            [30.482106874720237, 0.224516164782224],
            [30.479786012505013, 0.228692948740998],
            [30.47929710620825, 0.22888508606865],
            [30.47589443793065, 0.229791638828155],
            [30.473244296451426, 0.229468683602513],
            [30.47035268063726, 0.228575949496661],
            [30.468940154413175, 0.227291159499552],
            [30.467053915098706, 0.226309389434126],
            [30.465092447269104, 0.22598517829544],
            [30.464286477897872, 0.226555710053038],
            [30.461243466313952, 0.230703796073724],
            [30.458068181397714, 0.22694324921491],
            [30.45693735516859, 0.226301321727492],
            [30.453655193191423, 0.220001000235853],
            [30.452099515036874, 0.219856116522615],
            [30.45165108233527, 0.220425453767507],
            [30.450529187156693, 0.220319101211043],
            [30.447970434884585, 0.220902540086774],
            [30.441283063295888, 0.219487365300313],
            [30.440189166808107, 0.21870639097365],
            [30.43776847032376, 0.219132996889727],
            [30.436001580279655, 0.21999787052847],
            [30.43263050395398, 0.219701688278251],
            [30.43148175633493, 0.220387359193093],
            [30.429939234007744, 0.2227136253496],
            [30.428213284682688, 0.223347535591769],
            [30.427685720286004, 0.223168855750033],
            [30.426251971363328, 0.220467895257266],
            [30.42619478551063, 0.216946073149338],
            [30.42401673117108, 0.212846638388789],
            [30.42176516589518, 0.210777103897551],
            [30.417935557109132, 0.210368771154622],
            [30.415511039191593, 0.208940733399495],
            [30.415084518196394, 0.206460373636821],
            [30.415611637028682, 0.204788488505785],
            [30.415383367928477, 0.203267605456842],
            [30.41289279329484, 0.200836248512122],
            [30.412104797415804, 0.198998294951065],
            [30.412146645433317, 0.197814316217145],
            [30.413469791083305, 0.196476892576423],
            [30.4134117823738, 0.194244479783165],
            [30.41149041264354, 0.193312824364064],
            [30.40556196385799, 0.195129153534034],
            [30.405819385085803, 0.189625018169937],
            [30.41132113860298, 0.183921967230106],
            [30.412743213918546, 0.180541322081643],
            [30.41277370723089, 0.179837703046906],
            [30.407944285211702, 0.175173378728038],
            [30.40736972275597, 0.174152000792482],
            [30.409116274942082, 0.171804339955105],
            [30.412675307571295, 0.16852806471489],
            [30.41567961883446, 0.166823280710022],
            [30.416143938241863, 0.164636125704996],
            [30.415074553184922, 0.161906482728099],
            [30.415331330320683, 0.158288719793093],
            [30.416247505010965, 0.160322586667864],
            [30.416871922168344, 0.160652264388875],
            [30.42187659831293, 0.161625719896671],
            [30.42631167160046, 0.161846477303238],
            [30.42730525232213, 0.161474764003115],
            [30.429248787982072, 0.159867733685915],
            [30.432239254410078, 0.15900745460507],
            [30.433736256406846, 0.159287830300077],
            [30.435807712163236, 0.160562484417156],
            [30.4399092661386, 0.161873558706039],
            [30.447029291520977, 0.161413524296665],
            [30.449695828152464, 0.160500995875647],
            [30.450284155493286, 0.159407433331075],
            [30.452343608859152, 0.158160402232251],
            [30.452952499535126, 0.156398000523224],
            [30.453922342275437, 0.155656975806511],
            [30.455111050551565, 0.153505991941801],
            [30.455483262997976, 0.151906245426401],
            [30.45831289146423, 0.15033390719589],
            [30.458855575405497, 0.149647054089909],
            [30.459034971662653, 0.147432669440483],
            [30.459597803019083, 0.145959475830759],
            [30.460685225348616, 0.144983454030544],
            [30.46116706190409, 0.143971207738826],
            [30.462539803540885, 0.143085600106506],
            [30.46411426456968, 0.139705405394303],
            [30.46574436814551, 0.138006359313399],
            [30.465887427549443, 0.13563830367037],
            [30.466452854138726, 0.134734519263527],
            [30.47039540451218, 0.132265156963741],
            [30.477170614267692, 0.130767751974964],
            [30.478763003872924, 0.13028887301776],
            [30.479599663287527, 0.131491085225456],
            [30.47856006367048, 0.132548484847797],
            [30.47868368802323, 0.133560813374721],
            [30.478121688506747, 0.135187689321084],
            [30.477082909949875, 0.136425855358599],
            [30.477018922053862, 0.137917204474859],
            [30.477142262539004, 0.138920493955266],
            [30.4791854366353, 0.139218989770142],
            [30.479544358507056, 0.139779418268757],
            [30.479553270692996, 0.141659435571197],
            [30.481188613243532, 0.143539635976849],
            [30.48165044970753, 0.145790288576801],
            [30.480607543391898, 0.148655387444887],
            [30.484341840027977, 0.150083918589486],
            [30.484892886386188, 0.151150535844883],
            [30.484043210383145, 0.152198908328861],
            [30.48404635807991, 0.152867762773102],
            [30.485001274413445, 0.153952506929707],
            [30.48761511137881, 0.154413791056212],
            [30.489430262513235, 0.154197084059606],
            [30.491760013558206, 0.154830069741365],
            [30.492145782480552, 0.156086486602206],
            [30.49075134652965, 0.157396915289041],
            [30.49039913147979, 0.158237462118523],
            [30.49068746822811, 0.158942509354977],
            [30.49161416129204, 0.159105320288286],
            [30.491782174097942, 0.159484963029759],
            [30.491526297972438, 0.160605720161976],
            [30.490363473752904, 0.160723076507623],
            [30.490211487789985, 0.161193066023177],
            [30.49107429985742, 0.162892434589155],
            [30.491928632726918, 0.162847350123814],
            [30.492540962153818, 0.161798946732822],
            [30.494675715900048, 0.161356323399565],
            [30.49534065605989, 0.161401601005236],
            [30.496476054713806, 0.163019664264878],
            [30.49638490715348, 0.163824092448184],
            [30.493966877767242, 0.164573989493188],
            [30.493860628628713, 0.167195181657716],
            [30.493244608922602, 0.1674572218036],
            [30.494688278839323, 0.169865582069053],
            [30.49558624018722, 0.170432552158906],
            [30.495385481094257, 0.171139960624354],
            [30.494745010144452, 0.173359652626144],
            [30.4927122529122, 0.175763652644946],
            [30.49119236004532, 0.179270428713683],
            [30.491865186515057, 0.182108650723096],
            [30.49335213816043, 0.185489311745761],
            [30.493369977803656, 0.194907570979713],
            [30.490411860607363, 0.210751811103536],
            [30.489334376339826, 0.213110710715196],
            [30.487846079916423, 0.218343810205944],
            [30.484309601289073, 0.222244192677313],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 443,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "KAMWENGE TOWN COUNCIL",
        Population: 19286,
        Key: "KAMWENGEKAMWENGE TOWN COUNCIL",
        Dist2: "Kamwenge",
        "Sub Country": "Kamwenge T.C",
        id2_original: "Kamwenge Kamwenge T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.570378169620863, 0.153033324385008],
            [30.566902310207183, 0.158245323245608],
            [30.564378386516935, 0.159783149546133],
            [30.56400743979677, 0.161084736814857],
            [30.562524554824655, 0.163443762579318],
            [30.562193653203227, 0.165350973298035],
            [30.56163257625656, 0.165775740805031],
            [30.561271647548423, 0.167691984719231],
            [30.560249683657023, 0.169463516775315],
            [30.5610005494704, 0.172529870001928],
            [30.564782662530746, 0.176380872280775],
            [30.566899664668664, 0.179189501682318],
            [30.56827723924168, 0.182167216990441],
            [30.56857930404418, 0.185212458712061],
            [30.564982740700742, 0.187952625599265],
            [30.56426744727429, 0.189170879155906],
            [30.56466148429052, 0.190634716295017],
            [30.56546116096315, 0.191547712159593],
            [30.566654230559987, 0.191936994009791],
            [30.566922979543534, 0.192799838044914],
            [30.56635118839048, 0.19579419582517],
            [30.5633333763469, 0.205073110696454],
            [30.563803424310898, 0.208186043068087],
            [30.56354302247298, 0.20972473732265],
            [30.555744651371803, 0.216113538455482],
            [30.553690933749007, 0.21612224037376],
            [30.544254401183924, 0.212993198413715],
            [30.544490615882825, 0.211756268985582],
            [30.546990515927426, 0.212114186787211],
            [30.547208316959658, 0.211850881599782],
            [30.546040331020507, 0.211074648157926],
            [30.546153312133786, 0.210465113022543],
            [30.5473937525905, 0.209994266032541],
            [30.54780957465067, 0.20932470133685],
            [30.54722774931587, 0.208068998748651],
            [30.548641469400994, 0.206395144692438],
            [30.548641593368497, 0.205641773856358],
            [30.545398897076712, 0.206143478804876],
            [30.544484064469458, 0.207231571384325],
            [30.543403289673055, 0.206645435264239],
            [30.542488708594092, 0.206645311297546],
            [30.53999465209037, 0.204384883411542],
            [30.536918334568995, 0.204133280374011],
            [30.534839913275917, 0.202877391426475],
            [30.535256297681467, 0.198943360607743],
            [30.53575518426102, 0.198524896424624],
            [30.53592168789723, 0.197436741277902],
            [30.537169215163242, 0.195009516597874],
            [30.536919834755516, 0.194507248966374],
            [30.535256984892648, 0.194507061219563],
            [30.534508718803707, 0.193753502989144],
            [30.53284580605878, 0.194171840629922],
            [30.532596550516878, 0.192748777194875],
            [30.530185561227494, 0.191409207987595],
            [30.528689028151277, 0.191325278858719],
            [30.528689090135046, 0.190906751604595],
            [30.530352064863738, 0.190153631590695],
            [30.530352189729573, 0.189232960488363],
            [30.52868940274877, 0.188563019455069],
            [30.526693857328844, 0.188813872637859],
            [30.526112033790675, 0.188060439022616],
            [30.52577971372943, 0.186135170089229],
            [30.526445102148564, 0.184377511337578],
            [30.525364266266717, 0.184126284394378],
            [30.524782378948153, 0.183456592897231],
            [30.52420080244672, 0.180024581348908],
            [30.525780837521836, 0.177764841639187],
            [30.524700188489557, 0.176509139417043],
            [30.52336990931792, 0.176006745496885],
            [30.523370284813705, 0.173160806955598],
            [30.522622078911866, 0.172491053076129],
            [30.519545637422965, 0.173662512845554],
            [30.519711765563418, 0.174666986389217],
            [30.51929594350325, 0.175420234612756],
            [30.51646931990159, 0.173745818628906],
            [30.516220126343455, 0.172071716007309],
            [30.515055912430185, 0.173327105914059],
            [30.513975076548302, 0.173661764552376],
            [30.51314393368788, 0.171234226714586],
            [30.510649753216697, 0.170313182755076],
            [30.50865427247546, 0.170815200433889],
            [30.508903465135294, 0.17240549881431],
            [30.508155135265955, 0.172907643100095],
            [30.506658603088034, 0.172740031705295],
            [30.505006960606654, 0.173538720177739],
            [30.504330488773544, 0.17349309225877],
            [30.504081232333345, 0.172321193204692],
            [30.500728030685178, 0.171305975734066],
            [30.499944520094378, 0.173061548959658],
            [30.499092686338003, 0.172571609134018],
            [30.498593707231958, 0.173076974759341],
            [30.49784546988909, 0.172990011049872],
            [30.495385481094257, 0.171139960624354],
            [30.49558624018722, 0.170432552158906],
            [30.494688278839323, 0.169865582069053],
            [30.493244608922602, 0.1674572218036],
            [30.493860628628713, 0.167195181657716],
            [30.493966877767242, 0.164573989493188],
            [30.49638490715348, 0.163824092448184],
            [30.496476054713806, 0.163019664264878],
            [30.49534065605989, 0.161401601005236],
            [30.494675715900048, 0.161356323399565],
            [30.492540962153818, 0.161798946732822],
            [30.491928632726918, 0.162847350123814],
            [30.49107429985742, 0.162892434589155],
            [30.490211487789985, 0.161193066023177],
            [30.490363473752904, 0.160723076507623],
            [30.491526297972438, 0.160605720161976],
            [30.491782174097942, 0.159484963029759],
            [30.49161416129204, 0.159105320288286],
            [30.49068746822811, 0.158942509354977],
            [30.49039913147979, 0.158237462118523],
            [30.49075134652965, 0.157396915289041],
            [30.492145782480552, 0.156086486602206],
            [30.491760013558206, 0.154830069741365],
            [30.489430262513235, 0.154197084059606],
            [30.48761511137881, 0.154413791056212],
            [30.485001274413445, 0.153952506929707],
            [30.48404635807991, 0.152867762773102],
            [30.484043210383145, 0.152198908328861],
            [30.484892886386188, 0.151150535844883],
            [30.484341840027977, 0.150083918589486],
            [30.480607543391898, 0.148655387444887],
            [30.48165044970753, 0.145790288576801],
            [30.481188613243532, 0.143539635976849],
            [30.479553270692996, 0.141659435571197],
            [30.479544358507056, 0.139779418268757],
            [30.4791854366353, 0.139218989770142],
            [30.477142262539004, 0.138920493955266],
            [30.477018922053862, 0.137917204474859],
            [30.477082909949875, 0.136425855358599],
            [30.478121688506747, 0.135187689321084],
            [30.47868368802323, 0.133560813374721],
            [30.47856006367048, 0.132548484847797],
            [30.479599663287527, 0.131491085225456],
            [30.478763003872924, 0.13028887301776],
            [30.477170614267692, 0.130767751974964],
            [30.477739469726398, 0.12926741480324],
            [30.47740219365974, 0.128246027514328],
            [30.479410116965937, 0.126149290248038],
            [30.478765593715888, 0.125417104868726],
            [30.477603473775552, 0.125661030120526],
            [30.477079414605107, 0.125308475454708],
            [30.475702096051926, 0.122759478571346],
            [30.47577019463866, 0.122099673789658],
            [30.47590983146138, 0.121521222936022],
            [30.477612010465702, 0.120020991235381],
            [30.477958690096777, 0.118050625353712],
            [30.479554663979993, 0.116667878487083],
            [30.479550534424636, 0.115791139845094],
            [30.47890338809396, 0.114534724490722],
            [30.47669700628024, 0.114859910378737],
            [30.476615963868557, 0.112817198455281],
            [30.4772510188755, 0.111578500410284],
            [30.4764979117655, 0.110476212134085],
            [30.47660501340524, 0.108053898595572],
            [30.47591389184646, 0.107511528227728],
            [30.474751506004775, 0.10768316094159],
            [30.47211210657971, 0.104365810448413],
            [30.472557005308996, 0.103561421639653],
            [30.474480672031472, 0.103688119820129],
            [30.475460131236872, 0.100000488404535],
            [30.476193841024983, 0.099521505624464],
            [30.477405303627258, 0.099657179773503],
            [30.478469135299076, 0.098699179162185],
            [30.478773750418668, 0.097867658436096],
            [30.48008851658366, 0.097280255415177],
            [30.48145502840399, 0.095111109132356],
            [30.483043893918367, 0.094722570338813],
            [30.483638672959547, 0.0949756954761],
            [30.484526374648592, 0.09690097826361],
            [30.485428254447765, 0.096846816217597],
            [30.487480287729372, 0.098971043098681],
            [30.48964771140587, 0.098275240551417],
            [30.492232641483703, 0.09734446240751],
            [30.49484609127515, 0.097733325462506],
            [30.497563303668464, 0.102424601891033],
            [30.498909404867206, 0.108345041161689],
            [30.500660257288562, 0.112014896653002],
            [30.501262766332793, 0.112159569154346],
            [30.502170983746286, 0.113569685157601],
            [30.504485585602275, 0.114645498221825],
            [30.504933689520502, 0.115820571288648],
            [30.507252188268236, 0.118794524041447],
            [30.509436599086747, 0.118469331910703],
            [30.50951951718073, 0.119897462374761],
            [30.51034527014944, 0.119517911520897],
            [30.510225087242528, 0.120584473526572],
            [30.510944405121442, 0.121289564113993],
            [30.511607395937123, 0.121271549339626],
            [30.511671310171277, 0.121868113787054],
            [30.513886066080076, 0.12266373634795],
            [30.514696858506056, 0.12179609062366],
            [30.51499068485907, 0.122564415244297],
            [30.515383924171342, 0.122374638489222],
            [30.515498374928445, 0.121118257569231],
            [30.51622880496742, 0.121534111036421],
            [30.518000496506737, 0.121344464529502],
            [30.520513445479178, 0.119826179416332],
            [30.52167545672337, 0.119627433881817],
            [30.522218319429324, 0.120133658589181],
            [30.523258280169138, 0.119952979036037],
            [30.52417990942983, 0.120558667680559],
            [30.524911012306962, 0.122827488068679],
            [30.52595292508587, 0.122827587781428],
            [30.527014699615737, 0.123451371084212],
            [30.527380471141523, 0.12299946204926],
            [30.528397262533538, 0.123108025895898],
            [30.528717848800557, 0.122782656849077],
            [30.53098177579308, 0.124617767865426],
            [30.531422376083725, 0.126515978062369],
            [30.533095182873215, 0.127799667442025],
            [30.534459177614075, 0.128043853182164],
            [30.534537636471004, 0.129092374921736],
            [30.535479396078884, 0.12904727421903],
            [30.535712054347606, 0.129842723186516],
            [30.53713219289543, 0.131234861227005],
            [30.53775326652328, 0.131072223467568],
            [30.5383687885627, 0.131695973333378],
            [30.539456278265877, 0.131967252152986],
            [30.5409589171911, 0.131886053649695],
            [30.542321311134135, 0.132790089689015],
            [30.542007358027178, 0.134055513354325],
            [30.544034083072297, 0.135709856078771],
            [30.544855446872553, 0.137336960052286],
            [30.544274315037146, 0.13786115964488],
            [30.546047445677555, 0.139045456430153],
            [30.546668196810245, 0.141947042006669],
            [30.545541892700275, 0.142525414231959],
            [30.54617191714164, 0.143944606012279],
            [30.546938435200538, 0.14416162662091],
            [30.54781005345272, 0.145445262061833],
            [30.549940772865018, 0.146710963522234],
            [30.551120581531602, 0.146964188786082],
            [30.55296909070582, 0.14652148339804],
            [30.553508323319736, 0.146901183854199],
            [30.55398949512189, 0.145843668993051],
            [30.55424615008678, 0.146539704765676],
            [30.557988175827578, 0.147254210716269],
            [30.55921576139256, 0.148140179306363],
            [30.560539332843966, 0.1475166310987],
            [30.560854498676573, 0.148131325540529],
            [30.562174998788038, 0.148664781096183],
            [30.562826623220406, 0.150147269362524],
            [30.563247326725836, 0.150409451657825],
            [30.564061901059166, 0.150029902178404],
            [30.56374789315499, 0.151575555170451],
            [30.564870054234838, 0.153058100730462],
            [30.569431146783728, 0.152416851423155],
            [30.570378169620863, 0.153033324385008],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 444,
        District: "KAMWENGE",
        County: "KIBALE",
        Subcounty: "KABAMBIRO",
        Population: 15484,
        Key: "KAMWENGEKABAMBIRO",
        Dist2: "Kamwenge",
        "Sub Country": "Kabambiro",
        id2_original: "Kamwenge Kabambiro",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.409190620413302, -0.047207395290598],
            [30.405275601606686, -0.042326731265638],
            [30.402648305183412, -0.036560409994769],
            [30.39604772163093, -0.025994875471538],
            [30.394387534374562, -0.02134030912417],
            [30.39006774727733, -0.018990391046799],
            [30.38915795511716, -0.018059475949681],
            [30.388406836877166, -0.014724485984224],
            [30.386609840694607, -0.012193863626948],
            [30.386234492229562, -0.009148096963209],
            [30.38499029681495, -0.006075217321911],
            [30.384797569558973, -0.003788637521503],
            [30.3845885405755, -0.003298492448917],
            [30.384148249305294, -0.006255971830761],
            [30.382653652098515, -0.008641959188792],
            [30.38183235297695, -0.010829112532173],
            [30.378591779404175, -0.015483567762841],
            [30.37090527730197, -0.024403759831299],
            [30.369293237948195, -0.027657320910234],
            [30.366343802070784, -0.027322865592057],
            [30.363852605802958, -0.028217549780711],
            [30.36024307168513, -0.028208437271559],
            [30.358395523708275, -0.031579450255859],
            [30.357469052528195, -0.031543277799791],
            [30.353728632076805, -0.033052475085062],
            [30.35206446528376, -0.032929162468139],
            [30.34550308241365, -0.03691752348445],
            [30.342174966219794, -0.035597506032625],
            [30.341005004885325, -0.038095175043731],
            [30.340137658122313, -0.038521586349141],
            [30.33838281897774, -0.038623066308853],
            [30.33733391640758, -0.039821116783196],
            [30.336123697971985, -0.039435257223307],
            [30.335357182608043, -0.040653619487698],
            [30.332553514555137, -0.039861584080326],
            [30.329890973630043, -0.041384476937455],
            [30.328983309578764, -0.041303223442847],
            [30.32749075963251, -0.039455304920747],
            [30.32577632042117, -0.038115040383518],
            [30.324415750956476, -0.036115434998154],
            [30.323843476509783, -0.035961782690782],
            [30.323299667877823, -0.036106366507156],
            [30.322301365611, -0.037588473231686],
            [30.320233080009274, -0.035871310681348],
            [30.3169737181723, -0.03777810575055],
            [30.315464790141796, -0.036928550302265],
            [30.314208167433573, -0.037036963459753],
            [30.312723881089617, -0.037796057679275],
            [30.311159199121, -0.039485991363581],
            [30.31221771186807, -0.041157929068094],
            [30.312110947096535, -0.041935135976191],
            [30.311341714328837, -0.042865954747366],
            [30.31211730986368, -0.044655371321886],
            [30.312229846310927, -0.047339461965458],
            [30.311570316704035, -0.047682856339487],
            [30.310495218361886, -0.047249025003379],
            [30.30956041351093, -0.04976136222091],
            [30.309953956453754, -0.050647034275705],
            [30.310955732505782, -0.050177132918993],
            [30.311480588481885, -0.050330787892614],
            [30.311659191526672, -0.052689536499872],
            [30.314145730029747, -0.053801232624947],
            [30.315137901294744, -0.055012278761246],
            [30.315192096655828, -0.056991461321072],
            [30.31633589815093, -0.061103510824305],
            [30.316872525650496, -0.06188968536538],
            [30.313755622244557, -0.064754193664484],
            [30.305581619709017, -0.070692522462179],
            [30.301234298350014, -0.072558228424594],
            [30.300526518432594, -0.074186653510491],
            [30.30038095272903, -0.07613905386219],
            [30.300146409794863, -0.076023209920224],
            [30.30051847761251, -0.085539446819452],
            [30.299423230956858, -0.090753854545651],
            [30.299912153423264, -0.097238289778834],
            [30.301010179466402, -0.099467092953117],
            [30.301737910966295, -0.100038643389749],
            [30.302445384558172, -0.102684961989409],
            [30.301939540526742, -0.106925719890342],
            [30.300456249516138, -0.11286270612102],
            [30.300152381794867, -0.119071201857926],
            [30.298583688848503, -0.123621516993427],
            [30.298977427624063, -0.124110233501911],
            [30.30016864579308, -0.12437243315061],
            [30.30140140655244, -0.12579140589708],
            [30.30158809892635, -0.127128937503343],
            [30.303323841684627, -0.12852085470747],
            [30.305760069141893, -0.129777290069172],
            [30.306316283507943, -0.130428032474876],
            [30.30733474846132, -0.130265468371851],
            [30.310591640829532, -0.126488595682619],
            [30.315247244231145, -0.123141515012366],
            [30.317408603381143, -0.123225382431783],
            [30.319486587194667, -0.125736285404032],
            [30.321065997042364, -0.126238616706586],
            [30.322146770940478, -0.125652855471098],
            [30.324142190596273, -0.123058709398938],
            [30.32821565604933, -0.121803755930639],
            [30.329130175144563, -0.120632109283917],
            [30.33029445104157, -0.116364047326672],
            [30.332539063357167, -0.115108843822486],
            [30.332872007747554, -0.110422193841457],
            [30.33378665350521, -0.108413681309773],
            [30.33478430179851, -0.107325778512986],
            [30.33661352863516, -0.102974033992402],
            [30.33719554081952, -0.102471890928641],
            [30.3405208021674, -0.101970059571942],
            [30.34376287413007, -0.102890917504855],
            [30.34517609385358, -0.102807360843321],
            [30.34924974525794, -0.100547997256989],
            [30.35465348988263, -0.098372376138367],
            [30.356856663812486, -0.096489479482582],
            [30.357937187978933, -0.098749279927864],
            [30.359682849934593, -0.100506938921783],
            [30.362362863990295, -0.100216294847403],
            [30.36338522134379, -0.100818889202557],
            [30.366193831029058, -0.100946669862045],
            [30.366954144424273, -0.099862483132285],
            [30.36834792729999, -0.099501175881914],
            [30.36969952618827, -0.098480809819709],
            [30.37216264381526, -0.098204029406884],
            [30.372497752247156, -0.096471968647588],
            [30.377302412205516, -0.090891595750076],
            [30.37614626785843, -0.090235114048714],
            [30.374633064745506, -0.088616843256315],
            [30.374494218440237, -0.084215788785595],
            [30.37489560098056, -0.081898485435527],
            [30.373713172826577, -0.079368483554697],
            [30.37373436049085, -0.078199190773931],
            [30.37125977137769, -0.0728007077792],
            [30.37331241910698, -0.071034587186007],
            [30.37447399376995, -0.069014960340075],
            [30.376712575695034, -0.066804046282188],
            [30.378730652658888, -0.065322772075763],
            [30.37947905259683, -0.065507329932286],
            [30.380133725012957, -0.065039643044362],
            [30.38059838667852, -0.063530206619225],
            [30.38110555033509, -0.056046706291374],
            [30.385878196133362, -0.055153987033484],
            [30.389046060965367, -0.050264285637748],
            [30.388974071775106, -0.047596352200793],
            [30.390271039619407, -0.046267420947925],
            [30.391326950845386, -0.045757213065381],
            [30.394156657465086, -0.048351058945768],
            [30.397155336291416, -0.050222074717098],
            [30.405752660921465, -0.05902156029622],
            [30.40727312062527, -0.060042131248011],
            [30.409853564516563, -0.060954281875633],
            [30.411430217434674, -0.058477928019807],
            [30.411603502452966, -0.05739336917557],
            [30.41149650681442, -0.056616091480907],
            [30.410146172754082, -0.054510169255783],
            [30.410053093815897, -0.049240985439013],
            [30.409190620413302, -0.047207395290598],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 445,
        District: "KAMWENGE",
        County: "KITAGWENDA",
        Subcounty: "BUHANDA",
        Population: 24001,
        Key: "KAMWENGEBUHANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.625390799092653, -0.163878853523988],
            [30.621076167426832, -0.163347783371392],
            [30.619071661311953, -0.162686998797702],
            [30.615849156452793, -0.160223638524738],
            [30.609978200743775, -0.154388286181263],
            [30.608015641461066, -0.151161750373855],
            [30.605298483865017, -0.14893436640046],
            [30.60418286072377, -0.148880010424495],
            [30.597690107344743, -0.14660139726428],
            [30.588528046929884, -0.147200798862418],
            [30.587056938871147, -0.150637654393534],
            [30.584063248389562, -0.154440068479461],
            [30.581212249002697, -0.156161731007672],
            [30.5761520120578, -0.15781139908798],
            [30.57600938384518, -0.158170117475043],
            [30.57743460236595, -0.15953349701986],
            [30.580499045955893, -0.160251308323926],
            [30.58563047169214, -0.160538908225094],
            [30.586628118188774, -0.160969495097145],
            [30.588837541698073, -0.1607545138256],
            [30.588979983061098, -0.161041551376524],
            [30.58741188569778, -0.162691656543676],
            [30.586556366153783, -0.165130940867375],
            [30.586627430977597, -0.166852977090771],
            [30.585772036299435, -0.168072620830707],
            [30.585629408086845, -0.169507557387764],
            [30.583775992314553, -0.172592536191932],
            [30.581851076035512, -0.177830014099249],
            [30.581066933929062, -0.178834425434733],
            [30.57814468197048, -0.180627704548609],
            [30.5762203262402, -0.181631990865043],
            [30.574581039187237, -0.181846971902384],
            [30.56998375082064, -0.185828372781483],
            [30.568700598167105, -0.18805248897516],
            [30.567417569481094, -0.189415432479233],
            [30.56153725242849, -0.194544606090463],
            [30.561037991251453, -0.197342736734535],
            [30.560111221830706, -0.199279815379244],
            [30.561037617552298, -0.199925634572528],
            [30.563602486453213, -0.204948378621115],
            [30.563958431308123, -0.20753140190933],
            [30.56381699965147, -0.208953458849191],
            [30.560921026109884, -0.211675526264108],
            [30.559827817731612, -0.21501796987216],
            [30.562060340520105, -0.217893854527135],
            [30.563200283751037, -0.220070390986576],
            [30.56627223276519, -0.223280517289055],
            [30.566948936363662, -0.225110231377931],
            [30.566864586355138, -0.228091665284417],
            [30.567882761152646, -0.23199582792259],
            [30.566192353671823, -0.234066829968413],
            [30.56610586567291, -0.238390390970016],
            [30.573830871364834, -0.234667605627896],
            [30.575658779474615, -0.234470094701614],
            [30.577711176573914, -0.235360134410849],
            [30.57930732922188, -0.23698193545372],
            [30.583241369854672, -0.237140468778111],
            [30.58702420066893, -0.2382762744752],
            [30.58785473626822, -0.239169534372289],
            [30.588725721208142, -0.239332070529499],
            [30.589491604158134, -0.240988528700509],
            [30.590628609898086, -0.241865606313061],
            [30.592790688598626, -0.238001225287357],
            [30.59384737956228, -0.236954024138258],
            [30.5943074140058, -0.235005480727792],
            [30.594049617282202, -0.233332868469294],
            [30.594654585015324, -0.232764623175744],
            [30.59532429343269, -0.230881066377116],
            [30.596155594396613, -0.227186937779967],
            [30.595994453702637, -0.226212598513615],
            [30.59747063275115, -0.224442838563299],
            [30.597898388031567, -0.222510519593511],
            [30.599148663244, -0.221244112947743],
            [30.60082741508402, -0.221445970970643],
            [30.603415276364615, -0.219840157170769],
            [30.60539199848609, -0.214757773781823],
            [30.605940499018764, -0.214246341321813],
            [30.60603417443829, -0.212776054650534],
            [30.608344753638477, -0.20847386048418],
            [30.60891450112426, -0.203896678204528],
            [30.610214663377675, -0.201918555437647],
            [30.61087745746229, -0.199374588864835],
            [30.6128732544105, -0.197053107229331],
            [30.614314079362686, -0.192934965457626],
            [30.624534752237594, -0.186513297739001],
            [30.62792708360123, -0.181840063892663],
            [30.628881108806013, -0.181050570887605],
            [30.629772296856657, -0.174210873409211],
            [30.62890350919593, -0.171372408547236],
            [30.625851625850242, -0.165791359747482],
            [30.625390799092653, -0.163878853523988],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 446,
        District: "IBANDA",
        County: "IBANDA",
        Subcounty: "KEIHANGARA",
        Population: 11508,
        Key: "IBANDAKEIHANGARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.687770557064876, -1.165740750341512],
            [29.683955995958136, -1.163167786388307],
            [29.681854939814826, -1.160372236275899],
            [29.681231603330758, -1.158775463872164],
            [29.678566528258255, -1.155825802461844],
            [29.67724271875328, -1.15339950723799],
            [29.674972455044728, -1.151877546353526],
            [29.675141165841612, -1.15103369208725],
            [29.671209362912226, -1.149049402595637],
            [29.66978088889687, -1.144827486769064],
            [29.66891233569642, -1.144304697940844],
            [29.667584759555485, -1.145147194415513],
            [29.666380302914106, -1.145007669903188],
            [29.665723405371008, -1.146065795060063],
            [29.663327776374697, -1.14749019013434],
            [29.660841586417956, -1.148116468675346],
            [29.657834626921346, -1.150752473738258],
            [29.65679805462678, -1.150490369453449],
            [29.656034950165985, -1.151087968121761],
            [29.653275341782823, -1.150823831390338],
            [29.6518869775449, -1.151497420198625],
            [29.651139212715904, -1.152018302769926],
            [29.651579903736387, -1.153307891355757],
            [29.650527516601255, -1.153536837200904],
            [29.649656689764853, -1.154978331687597],
            [29.649854089158634, -1.155684483104735],
            [29.648632210590648, -1.157417132051183],
            [29.645597507524776, -1.157705099202432],
            [29.64430185840735, -1.157335254744115],
            [29.64277538088945, -1.158760608775895],
            [29.64021283682849, -1.159509502220341],
            [29.63943535483158, -1.159370462504252],
            [29.639284321082854, -1.158142614249873],
            [29.63817613419552, -1.157824898321173],
            [29.639114903311825, -1.159917096646099],
            [29.638160261862765, -1.164125019655356],
            [29.638944675260447, -1.165376639695299],
            [29.639030036772002, -1.166512123004235],
            [29.637830520864696, -1.16732497643493],
            [29.637621157707933, -1.168777212691134],
            [29.638115642542605, -1.169233115197302],
            [29.6377060727568, -1.17262573868971],
            [29.63837558084985, -1.174353696181861],
            [29.639860729576487, -1.175335489388653],
            [29.639768011761067, -1.17590272164265],
            [29.639043433347855, -1.176467606978307],
            [29.639510339004964, -1.178081290008378],
            [29.639583026186173, -1.18474499797394],
            [29.63996438797375, -1.185268608267373],
            [29.64066365365889, -1.185339323783112],
            [29.641185711382903, -1.184637487230575],
            [29.642360138242644, -1.184414846950983],
            [29.64237986434794, -1.185073309601379],
            [29.64389663736583, -1.186566076974546],
            [29.641424103598034, -1.189508250682309],
            [29.641838089501768, -1.192915334312868],
            [29.64178613274238, -1.1970812185974],
            [29.64271811329009, -1.200717271628954],
            [29.644338730656514, -1.204276459882253],
            [29.644536371697118, -1.205525892830801],
            [29.64559553033287, -1.205870434528423],
            [29.646178298000386, -1.206780771381594],
            [29.6460336899009, -1.208891648606067],
            [29.647179056261166, -1.21016736456314],
            [29.648127493944905, -1.212611577816772],
            [29.655562794754335, -1.223071953611131],
            [29.658139248329118, -1.227372726201639],
            [29.66289161915143, -1.23318494658586],
            [29.663801153495132, -1.227921221179089],
            [29.664183342631073, -1.218950043915867],
            [29.664970284786282, -1.214439485488235],
            [29.66624083766963, -1.212882226285291],
            [29.667553550285895, -1.212006254230309],
            [29.672700508791685, -1.209564486896402],
            [29.67344380180723, -1.20885891140366],
            [29.673809928167575, -1.207697832122618],
            [29.673397050784885, -1.205071673990723],
            [29.671505694666585, -1.199924365314053],
            [29.666641048806813, -1.189316975901268],
            [29.666406006409318, -1.187309064109212],
            [29.666828317000828, -1.185675944773588],
            [29.668173040183923, -1.183646681042705],
            [29.671152939729236, -1.18132382976881],
            [29.676938746827446, -1.179329247545793],
            [29.678009164048618, -1.178116307019397],
            [29.679590837650842, -1.17765901745897],
            [29.679827431438817, -1.177223978887257],
            [29.679507634790905, -1.176024000098138],
            [29.67985166618854, -1.175789150002269],
            [29.681150902278915, -1.175939304114767],
            [29.682220610729345, -1.174889795980923],
            [29.6837390752749, -1.174441356929127],
            [29.685056048600558, -1.174664215353289],
            [29.68782340405472, -1.173475704544592],
            [29.688550112373484, -1.172424916552627],
            [29.68866265421059, -1.169346598188949],
            [29.688032795957557, -1.168871994872603],
            [29.688130641356608, -1.167110505951438],
            [29.687573645456247, -1.166490866084364],
            [29.687770557064876, -1.165740750341512],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 447,
        District: "KISORO",
        County: "BUFUMBIRA",
        Subcounty: "KIRUNDO",
        Population: 17879,
        Key: "KISOROKIRUNDO",
        Dist2: "Kisoro",
        "Sub Country": "Kisoro TC",
        id2_original: "Kisoro Kisoro TC",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.703510116126044, -1.282132054439154],
            [29.700728387627315, -1.276699019506133],
            [29.701826732572385, -1.275780192805375],
            [29.701738341941688, -1.27338744578689],
            [29.701100777940155, -1.271454114833219],
            [29.700284830082765, -1.265977623662106],
            [29.699058409632684, -1.263819928241403],
            [29.69607313546701, -1.264343530272886],
            [29.696041962130035, -1.263313963830018],
            [29.695043727236865, -1.262294096429797],
            [29.692082288968933, -1.256324532140923],
            [29.690427997355787, -1.254241879354474],
            [29.68776399577001, -1.252836307484334],
            [29.687324530051566, -1.253109441398178],
            [29.687486818792493, -1.254470858036675],
            [29.689934928266005, -1.265425837007421],
            [29.68978938412201, -1.266619116498664],
            [29.68872934423897, -1.268346545691665],
            [29.685617364499088, -1.269594328310259],
            [29.687242645918477, -1.271579759094047],
            [29.69032546005599, -1.280196467770566],
            [29.694520510686157, -1.27986417495616],
            [29.69504146527897, -1.279620957485504],
            [29.69515250513292, -1.27891265257034],
            [29.698450482848994, -1.278628420962348],
            [29.69876684613586, -1.280298104733454],
            [29.699908464724803, -1.281907781503921],
            [29.703510116126044, -1.282132054439154],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 448,
        District: "KISORO",
        County: "KISORO MUNICIPALITY",
        Subcounty: "NORTHERN",
        Population: 5342,
        Key: "KISORONORTHERN",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.699908464724803, -1.281907781503921],
            [29.69876684613586, -1.280298104733454],
            [29.698450482848994, -1.278628420962348],
            [29.69515250513292, -1.27891265257034],
            [29.69504146527897, -1.279620957485504],
            [29.694520510686157, -1.27986417495616],
            [29.69032546005599, -1.280196467770566],
            [29.687242645918477, -1.271579759094047],
            [29.685617364499088, -1.269594328310259],
            [29.68248607008232, -1.270689351662714],
            [29.68025273881007, -1.272209900431062],
            [29.680059009034196, -1.273665640990664],
            [29.680691666437685, -1.276437261516858],
            [29.680484924564922, -1.278310762349412],
            [29.67882366921167, -1.279598669554622],
            [29.679147574753664, -1.281311884945104],
            [29.68405598383917, -1.284085459540013],
            [29.684928769002912, -1.284349541902352],
            [29.687425311144963, -1.283640077962901],
            [29.691419501172536, -1.290412675891131],
            [29.69323395790928, -1.289834281454147],
            [29.69694066728299, -1.292286646056585],
            [29.699950621762756, -1.289758650796226],
            [29.698803068004754, -1.287542193649438],
            [29.697604876214164, -1.283724117617212],
            [29.6986056290851, -1.282492109623543],
            [29.700299623538868, -1.282614318149733],
            [29.699908464724803, -1.281907781503921],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 449,
        District: "KISORO",
        County: "KISORO MUNICIPALITY",
        Subcounty: "CENTRAL",
        Population: 4916,
        Key: "KISOROCENTRAL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.143518448458078, -0.802728764453973],
            [30.13628049673679, -0.802775881855591],
            [30.135933657205566, -0.802426252326979],
            [30.133533036271213, -0.802602686598564],
            [30.130554092533384, -0.802160430066074],
            [30.12734421888544, -0.801284711402592],
            [30.124175445856668, -0.798453042137665],
            [30.123580055062767, -0.798572475029707],
            [30.12342900065281, -0.799047288220583],
            [30.123958995890636, -0.800346430098771],
            [30.1240242683775, -0.801942263237316],
            [30.124781859877412, -0.803399057406248],
            [30.127125291365854, -0.804830863288414],
            [30.129823559188143, -0.804924567190638],
            [30.131172870067385, -0.806189818917892],
            [30.134320998912596, -0.80721495105973],
            [30.137234229989083, -0.809799901333106],
            [30.13801827597582, -0.813494756781576],
            [30.13915745384212, -0.814667044092227],
            [30.139465548136805, -0.815599664174039],
            [30.143718593103358, -0.819070818935508],
            [30.14366633630667, -0.819834337577064],
            [30.139557324517803, -0.820166099941006],
            [30.13862762748754, -0.820874720775177],
            [30.13878000511593, -0.821182045997409],
            [30.140797865585817, -0.822450605271288],
            [30.143099644889475, -0.825249469928336],
            [30.14571150645952, -0.826183757337996],
            [30.14868019233513, -0.826329345631055],
            [30.147680651291545, -0.829173660245589],
            [30.150435317143977, -0.829701627456096],
            [30.154637504889052, -0.831999833252116],
            [30.159340768408036, -0.833631876345154],
            [30.159243249097425, -0.835027734544942],
            [30.158175029155423, -0.837325695611836],
            [30.159156780861448, -0.837286561092419],
            [30.159703966260576, -0.838279715833636],
            [30.161912357605605, -0.839866147462105],
            [30.164461015508866, -0.840931198553185],
            [30.166791973889573, -0.840859573708667],
            [30.168848336152557, -0.839710400814427],
            [30.170597121550426, -0.840053232955282],
            [30.18071668814182, -0.844932266033134],
            [30.18417290140021, -0.847964186706827],
            [30.190150508693062, -0.855593605716791],
            [30.195441260526376, -0.859018582898608],
            [30.19875548786764, -0.862170131824079],
            [30.20774057388332, -0.883153414369586],
            [30.208770814851743, -0.889854482580156],
            [30.212287079588606, -0.904390636188026],
            [30.21337614314013, -0.907089777649492],
            [30.213885605585542, -0.915439785512407],
            [30.21498670386695, -0.921949739225677],
            [30.215519426389996, -0.924016093006105],
            [30.21607572879093, -0.92445776321305],
            [30.217259146888356, -0.921398824341715],
            [30.219081802548704, -0.920394235181004],
            [30.220004895164966, -0.918673421276832],
            [30.218903833714503, -0.913214703848192],
            [30.219566440949524, -0.910227749844053],
            [30.220607873129783, -0.908482959841599],
            [30.22074979796151, -0.906977655901867],
            [30.219577835180605, -0.903740976405548],
            [30.22138839143235, -0.899427268722085],
            [30.221837885044355, -0.895986477906184],
            [30.221399435320464, -0.889523871451033],
            [30.220002694292543, -0.887995657209498],
            [30.219765905570164, -0.88708789636643],
            [30.22060611422843, -0.885617984696669],
            [30.220700678980084, -0.884232160012298],
            [30.222617820340304, -0.881435517325646],
            [30.223433920911305, -0.87544993856354],
            [30.223078665962532, -0.873562671339075],
            [30.2210307873891, -0.870493849095112],
            [30.22042669551339, -0.865799396200878],
            [30.21945590684707, -0.863219669997816],
            [30.21874572303798, -0.862790071601985],
            [30.21777499725372, -0.860807655650103],
            [30.215585355545343, -0.860223749202492],
            [30.213525571599444, -0.85654571273535],
            [30.213004605328504, -0.854730252916138],
            [30.21313440290392, -0.851206066629945],
            [30.211335969416908, -0.845510251056384],
            [30.208139602837587, -0.845780991757957],
            [30.206888525429576, -0.846695414700181],
            [30.204459803396517, -0.846995297973967],
            [30.203450113186832, -0.84468094384015],
            [30.201732527177093, -0.843020826158131],
            [30.20072273186451, -0.839323174174588],
            [30.198747445250895, -0.835838121914264],
            [30.196465708259552, -0.832874219447094],
            [30.19467733949698, -0.831427357716517],
            [30.19272562737136, -0.82789495411083],
            [30.191501780594564, -0.827230538708151],
            [30.189947880206006, -0.827182038331241],
            [30.189289301915004, -0.82623364997103],
            [30.188230053447743, -0.82587742773132],
            [30.18611036265218, -0.826871235657344],
            [30.184368449366207, -0.826348641233049],
            [30.183074877153704, -0.824404495237816],
            [30.183146904971508, -0.822413926345698],
            [30.181145427975785, -0.822720579578913],
            [30.181523362690537, -0.820967208111096],
            [30.174153482589997, -0.821767706227286],
            [30.17347090400954, -0.821482849199136],
            [30.174626419535922, -0.818829528252439],
            [30.176086896931604, -0.817764164021562],
            [30.174629869066607, -0.813876713361235],
            [30.17387701977311, -0.813070463236638],
            [30.170463981343847, -0.811859485314309],
            [30.16276532234092, -0.811593395998797],
            [30.162318072720495, -0.811474594940458],
            [30.160954230693207, -0.809032800462935],
            [30.159706890276823, -0.8083446993132],
            [30.15290299551766, -0.808031851716976],
            [30.151537700914563, -0.807699130845887],
            [30.150596684213415, -0.806655790881647],
            [30.149184568519402, -0.805943883634978],
            [30.14673582124199, -0.806273921647549],
            [30.145653433071324, -0.80539636699285],
            [30.144689534483277, -0.803405134809934],
            [30.143518448458078, -0.802728764453973],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 450,
        District: "NTUNGAMO",
        County: "KAJARA",
        Subcounty: "KAGARAMA TOWN COUNCIL",
        Population: 10874,
        Key: "NTUNGAMOKAGARAMA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.870807613332378, 0.00971672603877],
            [29.8711861157824, 0.010102088018562],
            [29.871118720576526, 0.01193754284103],
            [29.87237954201039, 0.013866947952517],
            [29.872381149096427, 0.014653533452178],
            [29.872927224177868, 0.014962827885719],
            [29.873401032489646, 0.014723965859689],
            [29.87387631853005, 0.015205505056395],
            [29.873132747935102, 0.016905263932538],
            [29.874347014179353, 0.01926377442367],
            [29.874396046024195, 0.020050318578904],
            [29.87494318830419, 0.020884013499852],
            [29.876723551280957, 0.0217402570267],
            [29.877616377858676, 0.02346745487554],
            [29.878217178307228, 0.027375985663702],
            [29.88134277650681, 0.030864757010123],
            [29.88143956818203, 0.031818115522315],
            [29.879514739039582, 0.035765031020849],
            [29.880092837264282, 0.040197994987311],
            [29.87899379342991, 0.042046450684728],
            [29.879233483710646, 0.043309525641247],
            [29.87863925623505, 0.048542214081692],
            [29.88018168962903, 0.054940714507054],
            [29.879590715851393, 0.055894763520082],
            [29.879451135622524, 0.057253577014283],
            [29.878189605417884, 0.0595231765875],
            [29.87778549918566, 0.062502114144459],
            [29.876556432298766, 0.064475709815283],
            [29.876913601557415, 0.068125378215911],
            [29.878038932791927, 0.068589188846797],
            [29.880142432352805, 0.070958795485351],
            [29.880735492018538, 0.071053545217178],
            [29.882416913651593, 0.069860048924694],
            [29.88668485178726, 0.069450547713449],
            [29.887990191031673, 0.069949806724438],
            [29.88813445956796, 0.070946334065303],
            [29.886742394271096, 0.071262132068682],
            [29.885030827872043, 0.075425440909517],
            [29.886285600050815, 0.077521610147068],
            [29.886228463605462, 0.078784992400774],
            [29.88551537015317, 0.079617625669069],
            [29.88428892365194, 0.08007694191268],
            [29.882130704113866, 0.079802192450439],
            [29.8780570572011, 0.08037793383164],
            [29.873664679042378, 0.082416208256026],
            [29.873151228077127, 0.083392408249954],
            [29.87382127246438, 0.085732572711728],
            [29.872651760287557, 0.087627529804053],
            [29.87233789791044, 0.089149291152539],
            [29.87136813691684, 0.089780887773981],
            [29.871011538088414, 0.090800164437063],
            [29.87180988345781, 0.093413116778632],
            [29.871182386875645, 0.093872466092388],
            [29.871039670628146, 0.095078394331387],
            [29.87004140968383, 0.095451571052583],
            [29.86901455626233, 0.096599983783753],
            [29.868757737804067, 0.098006892610142],
            [29.867474163840694, 0.09947112278939],
            [29.867388464562595, 0.100906755979268],
            [29.866218775417643, 0.104323463037834],
            [29.865591233021433, 0.105184781564049],
            [29.86293875592242, 0.105816186543919],
            [29.86005872568052, 0.105940932679489],
            [29.851040830495712, 0.118493025823986],
            [29.843263251800085, 0.132941291016156],
            [29.84219649790861, 0.132488939280131],
            [29.841558279035226, 0.128899454118592],
            [29.840715977302356, 0.129535258500174],
            [29.838266536525545, 0.129605607186818],
            [29.83723490676171, 0.128898901656075],
            [29.836856084511453, 0.127542234276895],
            [29.835613911204543, 0.126793115735258],
            [29.835277145380932, 0.125846260489311],
            [29.834463091172154, 0.125196114447439],
            [29.834364922379585, 0.124447137771822],
            [29.832532979935845, 0.125563292754174],
            [29.831719167373883, 0.122948884320312],
            [29.8309822317356, 0.12290640129169],
            [29.830420879904448, 0.121917140131032],
            [29.829122517874858, 0.121591957918946],
            [29.828280418262896, 0.120687456162491],
            [29.826378352429764, 0.121436189500665],
            [29.825451990844165, 0.120899079010182],
            [29.82532570208825, 0.120559920827603],
            [29.82684187592984, 0.118779550954473],
            [29.824104684106317, 0.119061858500823],
            [29.820644959333436, 0.116319985052813],
            [29.819501446197574, 0.112221799826371],
            [29.819896589039928, 0.111236512428113],
            [29.819742474968084, 0.110311769538349],
            [29.82070848549541, 0.108029923501563],
            [29.81989952742923, 0.106648276595035],
            [29.820321822749353, 0.104312032893111],
            [29.81984326594299, 0.102119678236777],
            [29.820316058260147, 0.101356499520641],
            [29.82020080440921, 0.099477743363053],
            [29.82062639295316, 0.098833779829427],
            [29.820197302776222, 0.097690116560186],
            [29.821202779887226, 0.096485468510529],
            [29.821318975172584, 0.095269771155499],
            [29.823571003979154, 0.094862376751779],
            [29.82425664761134, 0.093812956377891],
            [29.825133736603608, 0.093645260003356],
            [29.82496638136452, 0.092954198649611],
            [29.825273824380602, 0.092524871879842],
            [29.82638964245625, 0.093167326364582],
            [29.826909148066544, 0.092046568120531],
            [29.82762295567949, 0.093261460698647],
            [29.828477026240936, 0.093451310398776],
            [29.82861716432357, 0.092354749152741],
            [29.82807987656223, 0.090460379800861],
            [29.82905169020627, 0.090221072499928],
            [29.828075482003868, 0.088219880001584],
            [29.828370339622854, 0.087421114260608],
            [29.830051123452034, 0.085941670630825],
            [29.831875513759183, 0.085129472348162],
            [29.83255086539315, 0.084878538131186],
            [29.833737930650624, 0.085568591728057],
            [29.83404462357347, 0.084757889130847],
            [29.83515904566716, 0.084685289165561],
            [29.83425532432167, 0.083375236073191],
            [29.83451369596705, 0.082111701248118],
            [29.834142478853988, 0.080264830658626],
            [29.835019476218125, 0.080049443610344],
            [29.83610787860962, 0.078808931582152],
            [29.835725210671622, 0.07716466579244],
            [29.836790645836263, 0.076305538486474],
            [29.836870466539153, 0.074696570073046],
            [29.839522072272317, 0.072477233688504],
            [29.839383870059095, 0.068556437193311],
            [29.840165778055432, 0.0682219542271],
            [29.840495266626924, 0.066958347098469],
            [29.841205939119572, 0.066576266918099],
            [29.841250338352477, 0.065050754298967],
            [29.843122389675326, 0.064357638922237],
            [29.84387868849955, 0.06306975384177],
            [29.844684312917725, 0.062735248381013],
            [29.844290340580194, 0.061388937766356],
            [29.844644393583113, 0.06055433596631],
            [29.846139636678597, 0.061172545416278],
            [29.847964502194536, 0.060598646241274],
            [29.848364990012822, 0.059263452218841],
            [29.849739244412536, 0.058666163601041],
            [29.85060811022671, 0.054374863272119],
            [29.850535728472682, 0.053755201173456],
            [29.84987457830506, 0.053469033981802],
            [29.84999224143761, 0.053016038932461],
            [29.850939775416133, 0.052490681919091],
            [29.85093795902263, 0.051584928957985],
            [29.853730118758417, 0.049361794426976],
            [29.854531122242726, 0.046715201325255],
            [29.858535974374416, 0.045257113917927],
            [29.858888481376727, 0.043659748126944],
            [29.86019164040996, 0.043086350950444],
            [29.860522781881574, 0.042656957263131],
            [29.86035577698542, 0.042156570634123],
            [29.86222827746591, 0.041677929514221],
            [29.86191859764475, 0.040987006662878],
            [29.86239169628746, 0.040390618889422],
            [29.86205877884651, 0.039938078303184],
            [29.862864839845916, 0.039818067901851],
            [29.86319516295231, 0.038983473013157],
            [29.863645366233357, 0.038792319649555],
            [29.864737542447358, 0.039434767641605],
            [29.86499648901451, 0.038481056169316],
            [29.864593284690834, 0.038457637095131],
            [29.864604400444154, 0.038088163694468],
            [29.865551307398604, 0.037252920205292],
            [29.865076240547122, 0.036872041791035],
            [29.865383962939273, 0.036585684090123],
            [29.865240324121984, 0.03591842820706],
            [29.864646732653608, 0.035561503359628],
            [29.864692864736686, 0.034917881241543],
            [29.865381362316544, 0.035298547661606],
            [29.865806073206457, 0.034225481506138],
            [29.86554102438356, 0.032152020159706],
            [29.866428761106892, 0.031376431032274],
            [29.867496070157213, 0.031446825702309],
            [29.868109145185805, 0.029706161322504],
            [29.868867393354193, 0.029395489802603],
            [29.868652028553022, 0.028442273203003],
            [29.86813006515214, 0.028323637209585],
            [29.86881601061825, 0.027440986851906],
            [29.868956367889805, 0.026487398333957],
            [29.868563164510157, 0.025546282016833],
            [29.86877370535824, 0.024115891131037],
            [29.86836962787209, 0.02366342772809],
            [29.868889716489, 0.022852461994057],
            [29.86822390855659, 0.021971220157664],
            [29.867702033190586, 0.021900255950358],
            [29.867296848081715, 0.02089956692963],
            [29.86781649562578, 0.019874073622433],
            [29.86840951037576, 0.019944953389],
            [29.86846543050221, 0.018288292112408],
            [29.86934187091084, 0.017786808528205],
            [29.868604229196738, 0.016571935077416],
            [29.868674312161957, 0.016047467194775],
            [29.869645064895657, 0.015283693517626],
            [29.868172413531244, 0.014141113769037],
            [29.868963051355514, 0.01226914514099],
            [29.868464598662264, 0.012055143987237],
            [29.868629003833984, 0.011268378816458],
            [29.869882981003695, 0.00983687929956],
            [29.870807613332378, 0.00971672603877],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 451,
        District: "KASESE",
        County: "BUKONZO",
        Subcounty: "KISINGA",
        Population: 24474,
        Key: "KASESEKISINGA",
        Dist2: "Kasese",
        "Sub Country": "Kisinga",
        id2_original: "Kasese Kisinga",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.20962525551906, 0.593198870088086],
            [30.20850021354208, 0.592304952286197],
            [30.200179464018362, 0.589546379957068],
            [30.197002662745895, 0.587593791694831],
            [30.193069938145026, 0.586989293198743],
            [30.18776853858061, 0.587761242329881],
            [30.18584362769149, 0.590084182702158],
            [30.17770426509163, 0.595272952354619],
            [30.175820878826503, 0.599948492848527],
            [30.175272315411735, 0.602674008284504],
            [30.165101964362396, 0.605824335278878],
            [30.159847684129602, 0.606541815471776],
            [30.156828358424782, 0.608419214040703],
            [30.15798633174179, 0.605034741363005],
            [30.158712749904723, 0.600920838799544],
            [30.16049864740194, 0.598838591627162],
            [30.16047364189767, 0.597172028176232],
            [30.16156036264297, 0.596573679359283],
            [30.162647631360596, 0.594907694604163],
            [30.15807017689714, 0.592978366161168],
            [30.157889442150182, 0.592327277821223],
            [30.15682934118171, 0.591467414993283],
            [30.15393335326707, 0.589330658262644],
            [30.15282128206448, 0.588939486890457],
            [30.152175661971448, 0.586882022016195],
            [30.151115750547532, 0.585657613214772],
            [30.149512401495812, 0.584901639498452],
            [30.1473397918452, 0.584535967863756],
            [30.14754781830878, 0.582374793536898],
            [30.149319501763255, 0.579865844457984],
            [30.152020812179412, 0.577902343350411],
            [30.15350427027668, 0.574890688048666],
            [30.15554240482423, 0.574002318647061],
            [30.156540537309432, 0.572654410149818],
            [30.15822224011518, 0.572167528699832],
            [30.15859110184558, 0.571077494420794],
            [30.160132233580693, 0.571049572575451],
            [30.16280343965503, 0.569871754566142],
            [30.163810174407434, 0.567924209611566],
            [30.165320840678017, 0.567523302198718],
            [30.172272794863986, 0.571428614938197],
            [30.17321382414156, 0.570310158333204],
            [30.174239997538354, 0.569937701120303],
            [30.174609697396924, 0.571544527776297],
            [30.176034541320206, 0.571832149520657],
            [30.176803654611952, 0.572578475757937],
            [30.178029130932654, 0.572607781830575],
            [30.17993786675677, 0.574129317883748],
            [30.182303218934777, 0.574388718545332],
            [30.183585124726676, 0.575565663406316],
            [30.187376388026493, 0.573989573091128],
            [30.189685826366258, 0.572068449463672],
            [30.1911859230592, 0.572600534584789],
            [30.191823246312243, 0.572241657573477],
            [30.193562775469452, 0.57011940513969],
            [30.194675594968686, 0.567423032673302],
            [30.194818734322684, 0.566103331952328],
            [30.194022402077845, 0.562631361799849],
            [30.194137055854192, 0.561282953009451],
            [30.194593381153894, 0.5605945989126],
            [30.19440900733172, 0.558758302809216],
            [30.195435725107597, 0.557266879117903],
            [30.19520843606935, 0.555746154281201],
            [30.198815389327393, 0.552161542583031],
            [30.199529356840493, 0.549063271374044],
            [30.19910358144695, 0.545361955417136],
            [30.197365159014197, 0.545188987252472],
            [30.19632533212335, 0.544270391797169],
            [30.196496602220495, 0.542129855677645],
            [30.199918830415058, 0.538878195161087],
            [30.20080246093923, 0.538591706335714],
            [30.20175789021081, 0.53710022193106],
            [30.20178677374215, 0.536268190307982],
            [30.203298252089745, 0.534145768708637],
            [30.20224436027651, 0.532796808255742],
            [30.202031709285837, 0.530357986328365],
            [30.201177568655787, 0.528463997254065],
            [30.202089754826222, 0.528034039612664],
            [30.204455257022843, 0.528063812109972],
            [30.206728641478673, 0.526844477137917],
            [30.207133958639922, 0.527599613012477],
            [30.206322205914915, 0.528226651786276],
            [30.206227867538725, 0.528794827301845],
            [30.207380065586758, 0.529517464178792],
            [30.207344122195597, 0.530985346406372],
            [30.209390024475415, 0.531909638935512],
            [30.209683693623237, 0.532667399854934],
            [30.210859494905375, 0.533212483869901],
            [30.211363896242467, 0.536077494408098],
            [30.21342075437545, 0.538777496674248],
            [30.21524196644313, 0.542424435099331],
            [30.216020646792675, 0.543029817643329],
            [30.21673967810901, 0.54547191770018],
            [30.217421669191225, 0.546044524597119],
            [30.219581827293702, 0.546732283929029],
            [30.22181685907679, 0.549442174130087],
            [30.221551022431406, 0.550548478380253],
            [30.221777872193467, 0.551769471308439],
            [30.221284648593453, 0.552799361697214],
            [30.222535224741513, 0.553295939828487],
            [30.22333131803452, 0.553029247840137],
            [30.229281794409136, 0.553795122012572],
            [30.231025144101228, 0.554253782150046],
            [30.232464962042, 0.555360902034696],
            [30.23360194622239, 0.555628512851361],
            [30.235837406501858, 0.55746092400389],
            [30.235950633753507, 0.558491113424506],
            [30.235305083729113, 0.561008914414105],
            [30.2356458389709, 0.561810293550242],
            [30.236896447458292, 0.562268731189553],
            [30.23663041587847, 0.563756578485365],
            [30.235682749847605, 0.563908735845241],
            [30.235000010468735, 0.564900388277788],
            [30.23423984080396, 0.569287630560445],
            [30.234390522413086, 0.571233513253594],
            [30.235261077958267, 0.573790198422172],
            [30.231848612654186, 0.576115864508835],
            [30.22999042143786, 0.577984446088616],
            [30.222104500529095, 0.58202473634687],
            [30.222292965279077, 0.584161382685955],
            [30.2236947719069, 0.585421125201539],
            [30.22070028372136, 0.585648540704359],
            [30.21747785252406, 0.586944110311013],
            [30.218386869438167, 0.588279908547147],
            [30.22047172446529, 0.589843585301714],
            [30.216908899148976, 0.590300848446584],
            [30.21143545424136, 0.592937653099571],
            [30.20962525551906, 0.593198870088086],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 452,
        District: "BUNYANGABU",
        County: "BUNYANGABU",
        Subcounty: "BUHEESI TOWN COUNCIL",
        Population: 13983,
        Key: "BUNYANGABUBUHEESI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.876854248968257, -1.121496905137539],
            [29.87397055629493, -1.122396906459385],
            [29.871975478897287, -1.122297600590689],
            [29.87001389159174, -1.120967613134185],
            [29.86863179220461, -1.119411539823862],
            [29.867699185531155, -1.118827569334549],
            [29.86711949728842, -1.119247980640651],
            [29.86670149861032, -1.118923659965413],
            [29.865320225673248, -1.116590302505637],
            [29.864516411360388, -1.115941699152536],
            [29.86226446430049, -1.115323931671981],
            [29.85956138959313, -1.115288647143738],
            [29.857503015103944, -1.114217671785164],
            [29.852323836723826, -1.112560391819082],
            [29.849844982409685, -1.113529333048357],
            [29.84314680408814, -1.118088621248956],
            [29.83709668927714, -1.118470712443747],
            [29.83271870123096, -1.119988116678282],
            [29.8266644568646, -1.124256477564171],
            [29.821867640995293, -1.1262591529018],
            [29.81903391261809, -1.128102030488977],
            [29.81625123729506, -1.128506114950582],
            [29.80974983313985, -1.13274327455974],
            [29.80712839822384, -1.132683017466249],
            [29.801716400776577, -1.130899008696461],
            [29.79892289177125, -1.131870949027172],
            [29.797665179406586, -1.135482917392238],
            [29.795726876433204, -1.136111662143543],
            [29.795098044954518, -1.137888961301953],
            [29.79435637339807, -1.138633744948657],
            [29.794297991887774, -1.139895484724089],
            [29.795037384418357, -1.141215473526879],
            [29.795263053794127, -1.143280500136931],
            [29.794716084889004, -1.144660111043322],
            [29.79590450570423, -1.146067003950574],
            [29.796711779429252, -1.146162667063947],
            [29.79794528309534, -1.147355634219961],
            [29.799013751870678, -1.147451379020575],
            [29.79959498162243, -1.147940519545262],
            [29.80018760470694, -1.148894768953681],
            [29.80154026809885, -1.149682293758885],
            [29.802037570050217, -1.150946579373058],
            [29.80350804030511, -1.152592810104983],
            [29.8049319140479, -1.153428067875953],
            [29.80515846826425, -1.154803715810112],
            [29.804792918622308, -1.155748186747732],
            [29.805719448192868, -1.156894210810809],
            [29.806434649092846, -1.159351720298499],
            [29.805958702790672, -1.1602404831399],
            [29.8062330797195, -1.161808191210313],
            [29.805943679365882, -1.163786561189004],
            [29.807154694607135, -1.167322921516129],
            [29.807750545338454, -1.167857184190586],
            [29.808751839893503, -1.171259919569592],
            [29.808640618579833, -1.171937887267036],
            [29.809455479475773, -1.174150967445931],
            [29.809012679210966, -1.175017532907241],
            [29.80981609646848, -1.177575209771442],
            [29.809692309520614, -1.179587121673763],
            [29.810099575127733, -1.180832620369101],
            [29.811720983011597, -1.182835431920247],
            [29.814326536611727, -1.183883378813489],
            [29.816798535881915, -1.185820485083929],
            [29.819902544870246, -1.190710547077659],
            [29.824007897820977, -1.195246194253013],
            [29.827422365469822, -1.19810690738443],
            [29.829736649322236, -1.201878100615779],
            [29.830921704150068, -1.20643413269805],
            [29.83032469998192, -1.208030680977844],
            [29.83033491652167, -1.209914943965521],
            [29.82922822443097, -1.212646429134431],
            [29.830157533389013, -1.213184097657253],
            [29.829904741179877, -1.217314177321487],
            [29.83238630571123, -1.217745216522622],
            [29.836866317220828, -1.219632536200335],
            [29.83867725974819, -1.219425560048238],
            [29.839479379838426, -1.218858907999379],
            [29.839611326183995, -1.214891179959343],
            [29.839123893124302, -1.21309322918402],
            [29.83909788869346, -1.210942300213506],
            [29.841067707261946, -1.207844920124702],
            [29.84339638751508, -1.206557096471752],
            [29.84505883583104, -1.206415640486447],
            [29.84639261573733, -1.202975733086781],
            [29.84729543786922, -1.202594396949199],
            [29.84843496338353, -1.202882508510416],
            [29.849147975089185, -1.202357556191368],
            [29.852429377091614, -1.198585292165534],
            [29.856042084957352, -1.195817148726021],
            [29.85566479163973, -1.19347458855748],
            [29.853959392175113, -1.189600956598728],
            [29.85396236290375, -1.186972046347277],
            [29.85254008187398, -1.1847238974663],
            [29.851877644420515, -1.182524418793579],
            [29.852211874300085, -1.180947454566823],
            [29.851976499525975, -1.17908305171435],
            [29.852499948740324, -1.178175478213725],
            [29.852026832131344, -1.176549797174409],
            [29.852171025209177, -1.175020413198569],
            [29.852789403891194, -1.174160743554665],
            [29.853080756283905, -1.168425267588584],
            [29.852725919950053, -1.158927054107374],
            [29.865640714023883, -1.163769759871404],
            [29.87705972062319, -1.167255841169506],
            [29.883451615653705, -1.169868183401253],
            [29.88343811577162, -1.169393365520475],
            [29.88261081500565, -1.168836896914339],
            [29.88059039074394, -1.165779146269397],
            [29.877141938031272, -1.164710514050717],
            [29.876222905800056, -1.163922471603054],
            [29.874898388422675, -1.15540269310478],
            [29.87585757444875, -1.151470736641138],
            [29.875852012080518, -1.146731002692636],
            [29.876785496408008, -1.145876194142211],
            [29.880260487150792, -1.14518981006402],
            [29.8819957960228, -1.144051697472035],
            [29.88268667234151, -1.142763602803113],
            [29.883598527033588, -1.142070602304438],
            [29.884917282616787, -1.138150517975898],
            [29.880920559340097, -1.133581497474041],
            [29.879451167063554, -1.130742546364202],
            [29.87726099355249, -1.1245281602248],
            [29.876854248968257, -1.121496905137539],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 453,
        District: "RUBANDA",
        County: "RUBANDA",
        Subcounty: "RUBANDA TOWN COUNCIL",
        Population: 21569,
        Key: "RUBANDARUBANDA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [29.934413136044935, -1.455845346364248],
              [29.93410253904387, -1.45397150621939],
              [29.93535165812454, -1.45266341863815],
              [29.935460931890628, -1.452063246743659],
              [29.934268398588024, -1.451625023984549],
              [29.932968723221478, -1.45020431520885],
              [29.93313409857373, -1.448212570045526],
              [29.93153834118448, -1.445154230091132],
              [29.931812063241427, -1.443244495807585],
              [29.934360404937742, -1.44368454677986],
              [29.934874080481805, -1.444831310315612],
              [29.93579490215707, -1.445678465557999],
              [29.935901392942426, -1.447152126744195],
              [29.938227231824335, -1.446577453820101],
              [29.936440065905916, -1.442384916302066],
              [29.936741478531523, -1.43939238526098],
              [29.93797348740098, -1.438620872518398],
              [29.938733212399697, -1.438879622501215],
              [29.94176108557443, -1.441993050717557],
              [29.94303254845118, -1.442618299188487],
              [29.94753563768044, -1.442266883641035],
              [29.94722036584665, -1.439498184183988],
              [29.9457718567055, -1.434775736374445],
              [29.944853509888866, -1.433250799308796],
              [29.944352431420032, -1.430501487388053],
              [29.94207083366754, -1.427122389941544],
              [29.94106519126654, -1.424252907848931],
              [29.94166333360015, -1.420937419215731],
              [29.942974623285004, -1.417144848132644],
              [29.942679612952443, -1.415710385114825],
              [29.94297900257202, -1.413798686570723],
              [29.94060752747706, -1.411017038097893],
              [29.92862414980893, -1.40272548673248],
              [29.925091831279637, -1.402272682873271],
              [29.919984142626493, -1.403281712162793],
              [29.91680012249242, -1.402680532341224],
              [29.914784779101964, -1.412945971462688],
              [29.914465316627346, -1.416623466402924],
              [29.914726477541706, -1.420025692975142],
              [29.915759357760432, -1.423483861412903],
              [29.919088568102286, -1.42892698218216],
              [29.921599148217318, -1.437466073852008],
              [29.92461966329156, -1.442469165943599],
              [29.930249874097715, -1.450390081180553],
              [29.93199557378262, -1.454034993966532],
              [29.934413136044935, -1.455845346364248],
            ],
          ],
          [
            [
              [29.982181150092668, -1.408417031848017],
              [29.981527637401566, -1.406932640254497],
              [29.980931827992723, -1.406725103965351],
              [29.974985266476125, -1.406502757105737],
              [29.974131996313623, -1.406039061592919],
              [29.972918410094014, -1.404903977580014],
              [29.971586765483128, -1.40429313969648],
              [29.970806193281632, -1.401746857872044],
              [29.960958880001726, -1.396453434691983],
              [29.96024201901511, -1.395788785322322],
              [29.9600394992242, -1.394927669578572],
              [29.960110218196608, -1.397198938746678],
              [29.958614700216675, -1.398895790328434],
              [29.95848282573634, -1.40046373772148],
              [29.958611754640856, -1.401182627786994],
              [29.959362273704517, -1.401868622192033],
              [29.959625127044884, -1.403571916565478],
              [29.9609078323374, -1.404948265578953],
              [29.961272361493165, -1.406856871343651],
              [29.960151440088378, -1.406506605226981],
              [29.955788348804568, -1.406459853921153],
              [29.950582932431626, -1.407661810038534],
              [29.952496707804492, -1.412298074376042],
              [29.953556700975145, -1.412892768751234],
              [29.954616482143386, -1.415224222444962],
              [29.961596957839596, -1.418136466956712],
              [29.964975033837995, -1.418293712881048],
              [29.963947574053687, -1.420278654496117],
              [29.963794296313377, -1.421386193531244],
              [29.96206060351058, -1.423038406654624],
              [29.96126132658822, -1.425389339326664],
              [29.958998267368262, -1.427583246133153],
              [29.95832865507065, -1.428978039116485],
              [29.95806604786869, -1.433358581375688],
              [29.958537482831474, -1.436176423262521],
              [29.957324889250252, -1.437878374942636],
              [29.957899727488787, -1.439229026081747],
              [29.96037349733839, -1.441235752891768],
              [29.95875823662603, -1.450908582430373],
              [29.957443854041664, -1.453398847503868],
              [29.957491497091056, -1.454083001539537],
              [29.959091870024228, -1.455599942076682],
              [29.959188134388388, -1.456235299452571],
              [29.958066262566028, -1.459996274148984],
              [29.958294454411156, -1.461436444098436],
              [29.961425588029478, -1.461841509045372],
              [29.971753704802257, -1.458630514461215],
              [29.976265976610392, -1.459037913878298],
              [29.976696769993087, -1.456628660478306],
              [29.982707805394288, -1.451099968198473],
              [29.983560817740287, -1.450621910554247],
              [29.98668132518715, -1.450193294614696],
              [29.993032518450434, -1.446892566782315],
              [29.99374184257184, -1.446059323363317],
              [29.99793538852387, -1.436814538546912],
              [29.99903152900323, -1.435826366344699],
              [30.00076871894746, -1.435245424983187],
              [30.002066329985446, -1.433218325492413],
              [29.997785638467693, -1.431343012779978],
              [29.993083641573286, -1.430947830653771],
              [29.99240493473172, -1.432729799297286],
              [29.990276657838667, -1.434639512749313],
              [29.989984152009114, -1.436648894587463],
              [29.988595521869886, -1.439434795711578],
              [29.98804482585464, -1.441832817770231],
              [29.987496550799072, -1.442383152569862],
              [29.984951032507702, -1.443157735301918],
              [29.980538653359176, -1.442989773088908],
              [29.98226048480696, -1.441675678528181],
              [29.982580047892892, -1.440487378552108],
              [29.983569502652458, -1.439437128798234],
              [29.984800976126014, -1.435701129321303],
              [29.984848348782517, -1.434215279796548],
              [29.98408049762375, -1.430819530165522],
              [29.986424058469566, -1.427759359158085],
              [29.99140388811171, -1.422930201127699],
              [29.98861684517979, -1.419943871705753],
              [29.982181150092668, -1.408417031848017],
            ],
          ],
          [
            [
              [29.91810094141431, -1.386395766816856],
              [29.921615199314825, -1.385283500027365],
              [29.92528356859218, -1.385412381368036],
              [29.9279337424108, -1.386222442713947],
              [29.929134241973337, -1.387620059666286],
              [29.9340642034391, -1.389611990813596],
              [29.938130035008893, -1.392347370235085],
              [29.939147535171646, -1.392224604095738],
              [29.94036383160847, -1.391199256969534],
              [29.93574703991872, -1.389225439956158],
              [29.932746340781314, -1.386683364460653],
              [29.930636409283018, -1.385639685676525],
              [29.935202646483514, -1.382822272971466],
              [29.93787952182562, -1.383752606995749],
              [29.938177687939785, -1.383282433830009],
              [29.93949597909395, -1.382884878985955],
              [29.94036229998092, -1.381345982743576],
              [29.941071349217804, -1.380904856670772],
              [29.93863660577741, -1.378990944830478],
              [29.935945813734893, -1.377860973],
              [29.935125196434658, -1.376904533777844],
              [29.935622696015425, -1.375678870360203],
              [29.937538551886494, -1.373357061250841],
              [29.939282972370396, -1.372132996351169],
              [29.942541029853555, -1.372892936245342],
              [29.946410486108984, -1.373077275094644],
              [29.950269817452828, -1.371342207025637],
              [29.952199359157255, -1.369765898296752],
              [29.95042121052766, -1.367172732974966],
              [29.95077038028869, -1.361894028307348],
              [29.952163478648153, -1.356444680008663],
              [29.9522968335521, -1.35390630653665],
              [29.9534857700003, -1.34780558780714],
              [29.951360649787173, -1.344375932242925],
              [29.948880306964615, -1.337876428482871],
              [29.94246425982937, -1.326176548782923],
              [29.938124430419833, -1.314218545403319],
              [29.93312326758633, -1.308806794640183],
              [29.92241498558193, -1.299334773880533],
              [29.917107057960383, -1.292413876214416],
              [29.913508364711387, -1.297628577478874],
              [29.913321454046844, -1.298459506156038],
              [29.907684155533094, -1.305208269814548],
              [29.906393246825417, -1.309293273353868],
              [29.90595212551189, -1.31866329507623],
              [29.9067754323681, -1.326498010096654],
              [29.909744239516286, -1.333552460887734],
              [29.909988247998605, -1.335401288642263],
              [29.909027678566968, -1.343672481754225],
              [29.90734597037134, -1.350010561601216],
              [29.90678647535789, -1.359570840806898],
              [29.905964373142453, -1.362040976314252],
              [29.902959098885326, -1.368090015319733],
              [29.90203387636348, -1.371615980887269],
              [29.902090570837697, -1.37422454217525],
              [29.903299634039858, -1.377124546686957],
              [29.905848178755416, -1.379532481881949],
              [29.90851320621721, -1.381299585669594],
              [29.913277396173736, -1.382571318147138],
              [29.916107586087072, -1.384053100106353],
              [29.91810094141431, -1.386395766816856],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 454,
        District: "KABALE",
        County: "NDORWA",
        Subcounty: "RUBAYA",
        Population: 20302,
        Key: "KABALERUBAYA",
        Dist2: "Kabale",
        "Sub Country": "Rubaya",
        id2_original: "Kabale Rubaya",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.892070021108932, -0.950460256230471],
            [30.891910626739886, -0.948855375934993],
            [30.89088951175641, -0.947563112583634],
            [30.891460592342092, -0.946367500578637],
            [30.891366352780587, -0.945004046413548],
            [30.889870655137567, -0.942515537764729],
            [30.888827078678773, -0.939046620185402],
            [30.888780793882056, -0.936965622951294],
            [30.88630960489225, -0.936366148580954],
            [30.88272233282379, -0.934330850858263],
            [30.87782925438695, -0.930213815997184],
            [30.87656995559747, -0.929830351470313],
            [30.87633172418075, -0.930810886943858],
            [30.87419147633824, -0.933201488861335],
            [30.874190860093965, -0.934230003223686],
            [30.872549922835802, -0.936190359176803],
            [30.870434338239434, -0.937074068339983],
            [30.86622822575487, -0.936712716331557],
            [30.86560965483337, -0.937860442590343],
            [30.863517958237022, -0.938552806212192],
            [30.861805855543768, -0.940297825748733],
            [30.85714655108321, -0.942710745798368],
            [30.852437150274195, -0.949309371594683],
            [30.850059532499316, -0.951221374799469],
            [30.846890803488034, -0.952688075379882],
            [30.845092298135786, -0.95593097308017],
            [30.84225146228801, -0.957205518294224],
            [30.840705945876, -0.957217836969002],
            [30.8370342851714, -0.956311445554716],
            [30.828976836349028, -0.955854305355179],
            [30.825740881913422, -0.955320449753753],
            [30.814617453381942, -0.957241127931801],
            [30.812821166868456, -0.956974079891898],
            [30.81193411196642, -0.960190877555039],
            [30.809939199858785, -0.960694800248947],
            [30.802905111808098, -0.966122815286268],
            [30.800343665488423, -0.966286403982515],
            [30.79948958774047, -0.966748557365776],
            [30.796829760625833, -0.966713774159814],
            [30.795745800403385, -0.967208826289184],
            [30.792232565684007, -0.966611625099053],
            [30.790460044101366, -0.965519804426909],
            [30.78701258492539, -0.964790446264859],
            [30.787768568440963, -0.96366722794053],
            [30.787276582719414, -0.962774549082741],
            [30.788397625396744, -0.9556364043865],
            [30.787840192915166, -0.95438013138106],
            [30.78673465605797, -0.954176766637564],
            [30.783775551613136, -0.954640166550534],
            [30.778224994423244, -0.959010491551327],
            [30.775913136022094, -0.959474294996583],
            [30.774064311539227, -0.958821654399266],
            [30.7706432152219, -0.958819418805595],
            [30.76842383029442, -0.959283275269913],
            [30.766111382598474, -0.960677680766377],
            [30.76219640870762, -0.962275234403308],
            [30.7558802497404, -0.963089656933815],
            [30.757780032056075, -0.968703196743268],
            [30.758350959928148, -0.972663249254184],
            [30.75804245151014, -0.974462072510325],
            [30.755192402540832, -0.978401750131749],
            [30.755811087548363, -0.983094098813858],
            [30.75652402199887, -0.984694719910854],
            [30.754932385181846, -0.985127580135731],
            [30.75595423858046, -0.986439119444917],
            [30.75600194002037, -0.987505910873793],
            [30.754196753897343, -0.989348913081481],
            [30.753935910986616, -0.991807702518867],
            [30.754980991225228, -0.990497567390603],
            [30.757308711179327, -0.988745323472744],
            [30.760301954299855, -0.987933720257029],
            [30.76289113430732, -0.985937549344446],
            [30.76701882207095, -0.984904611710346],
            [30.770244322811568, -0.986284997671372],
            [30.774532043646403, -0.98642452757764],
            [30.776908295982064, -0.988541591644894],
            [30.781394122286535, -0.989976160673146],
            [30.78345834840148, -0.9916020909869],
            [30.786264299971805, -0.991986060542703],
            [30.791068747029453, -0.994960832620161],
            [30.79658102071691, -0.997396451146239],
            [30.79912336166711, -0.999043548775562],
            [30.90952266562031, -0.999187864537688],
            [30.908672431763435, -0.99743792367135],
            [30.907428301925876, -0.992765213303364],
            [30.907467736170197, -0.985094926710555],
            [30.90677635499832, -0.982793397892318],
            [30.906882136114596, -0.979795071729708],
            [30.90837392069622, -0.976170038912581],
            [30.910661915351817, -0.973382256825934],
            [30.914059977966964, -0.968015128027103],
            [30.91648820951987, -0.962438185570565],
            [30.919782537380968, -0.956687425240375],
            [30.917565896806693, -0.956093364977008],
            [30.90765731483115, -0.95842327589533],
            [30.904920600911343, -0.958630785532028],
            [30.894287380335452, -0.956462621733542],
            [30.892105526122243, -0.955694253232813],
            [30.887171250946487, -0.952949704068092],
            [30.890155454320325, -0.951646553474375],
            [30.890844226784626, -0.950760943848154],
            [30.892070021108932, -0.950460256230471],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 455,
        District: "ISINGIRO",
        County: "BUKANGA",
        Subcounty: "KAKAMBA",
        Population: 6752,
        Key: "ISINGIROKAKAMBA",
        Dist2: "Isingiro",
        "Sub Country": "Kashumba",
        id2_original: "IsingiroKashumba",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.160154730988676, -0.400085101379554],
            [30.159536962262745, -0.40025740213334],
            [30.158397357696654, -0.399548061154106],
            [30.156015810690743, -0.399314030556854],
            [30.15521900233878, -0.398856672509644],
            [30.152577388566527, -0.400366926551081],
            [30.15228967614732, -0.401635460393681],
            [30.14941794274538, -0.39863078851686],
            [30.147166204992942, -0.398238225246521],
            [30.145285367248285, -0.397211478309609],
            [30.14368209904494, -0.397472111933617],
            [30.14215277746086, -0.398292457026671],
            [30.139159841564144, -0.39749852985209],
            [30.13863133573303, -0.398356530510862],
            [30.13778794344538, -0.398664064004496],
            [30.134127476647553, -0.398830694759369],
            [30.133822045857695, -0.397739207873843],
            [30.13116317724547, -0.395658134330335],
            [30.12798613522451, -0.391328844546933],
            [30.126522324180833, -0.390320921416292],
            [30.127152278553623, -0.383352034724847],
            [30.127912647644386, -0.382085306382149],
            [30.126013262384063, -0.380602543185939],
            [30.12406579300153, -0.380912662621866],
            [30.122783460509844, -0.38067318244608],
            [30.119933198639824, -0.382082634851884],
            [30.112000665049276, -0.383992370943477],
            [30.10881846220703, -0.383871770332633],
            [30.10831987296982, -0.383513028083272],
            [30.107559767983727, -0.384014774423479],
            [30.102855377977388, -0.390802145818342],
            [30.10271229521727, -0.392547146264414],
            [30.100146690596123, -0.394960636063311],
            [30.099006222749097, -0.396609662832247],
            [30.098958253611222, -0.39797221535944],
            [30.09957550760251, -0.398522241419348],
            [30.099765158128665, -0.399478498207961],
            [30.097793004838756, -0.40256150722174],
            [30.097103684402086, -0.404354112910737],
            [30.097063641998304, -0.406240899703043],
            [30.096194867812297, -0.407166188745018],
            [30.095857234216158, -0.408492762895633],
            [30.09586068913673, -0.41265984169051],
            [30.090108801525325, -0.423821433294077],
            [30.0881377055525, -0.424504315656612],
            [30.0870453649468, -0.425549444393739],
            [30.086818128010854, -0.427841505940928],
            [30.084516054958122, -0.432223515385563],
            [30.08456327849427, -0.432940665850903],
            [30.090785078424034, -0.433229913312493],
            [30.09653153841448, -0.434618590762488],
            [30.10275327905544, -0.435242507548166],
            [30.106172707201296, -0.436032682357269],
            [30.106148640436523, -0.436869343548201],
            [30.10743018420739, -0.439116897751231],
            [30.1074258480395, -0.440067059183603],
            [30.106351034463298, -0.442543813430479],
            [30.10494085643536, -0.44444617800531],
            [30.103072614867607, -0.444895836839615],
            [30.101908761178766, -0.446201519287535],
            [30.10196416926547, -0.447541459508702],
            [30.10151620368779, -0.448881200963494],
            [30.101806373897627, -0.450581548921743],
            [30.10045203155447, -0.452697853793477],
            [30.10113372798928, -0.454342058817323],
            [30.100707790000687, -0.45652629013706],
            [30.100920131072595, -0.457010548433063],
            [30.10278730274684, -0.459252009668549],
            [30.105549586312897, -0.460930848414559],
            [30.106208703593055, -0.463070491300491],
            [30.107808041667028, -0.463746737096867],
            [30.108675781892142, -0.465678900310551],
            [30.10804846587136, -0.466567906577731],
            [30.107149459782775, -0.469809038488141],
            [30.1057243867891, -0.470238734941924],
            [30.10531055539559, -0.471730226585304],
            [30.104455441890117, -0.472160156474661],
            [30.103358522571405, -0.471557297769062],
            [30.103174486515776, -0.468631272560278],
            [30.101793663634655, -0.465389213075336],
            [30.100881787383024, -0.465259752146184],
            [30.10028146124494, -0.469849215186722],
            [30.098912708128015, -0.471942700589524],
            [30.100336606125293, -0.474338550626359],
            [30.099481126107168, -0.475657731592571],
            [30.09956604654595, -0.477034680062207],
            [30.096987180096292, -0.476603306932972],
            [30.09596080278188, -0.477707267591035],
            [30.09966490793958, -0.479143118818929],
            [30.100090722858997, -0.48307323808819],
            [30.101030417240047, -0.484809125537016],
            [30.104363098672152, -0.488511022943382],
            [30.10456154280663, -0.490949400826129],
            [30.10595803589955, -0.490734863161208],
            [30.10889394404707, -0.489301839486951],
            [30.114037616515578, -0.489863435818258],
            [30.115505657725926, -0.488960457983231],
            [30.116148186716046, -0.485848292613683],
            [30.115795212589774, -0.478074212128784],
            [30.1191887144582, -0.472711325131082],
            [30.12105576755483, -0.471693739153383],
            [30.122082198768158, -0.47048934208818],
            [30.124547603505853, -0.469758859384818],
            [30.126214531720105, -0.470318930235781],
            [30.129121850983733, -0.469143985009233],
            [30.131116717277287, -0.469216520638099],
            [30.134141547858153, -0.47039958634893],
            [30.13526667068353, -0.470170019729956],
            [30.13630348911647, -0.470957853392309],
            [30.136426313070316, -0.471515282291196],
            [30.137630402300747, -0.471630792741041],
            [30.138250366509244, -0.470964288705573],
            [30.137586913959527, -0.470255197811638],
            [30.13747784590764, -0.467206943260458],
            [30.13918269919655, -0.466672686190845],
            [30.14173941588624, -0.467289428318549],
            [30.143384464733426, -0.465877012708453],
            [30.14444529333728, -0.465842886838845],
            [30.14381227930268, -0.465205130987728],
            [30.1402186372805, -0.463606459877374],
            [30.14059439537732, -0.460727087454501],
            [30.140238199892455, -0.459236532193418],
            [30.139239676640084, -0.458203561114181],
            [30.136849812132912, -0.457349636386453],
            [30.134728763983002, -0.452997768542807],
            [30.136120794245574, -0.451319353734504],
            [30.136941376511523, -0.451337603341596],
            [30.137797831201734, -0.450650224797844],
            [30.140179133865875, -0.450507487811337],
            [30.140964214711826, -0.450121709244729],
            [30.14447754375431, -0.451806560558467],
            [30.146577901906642, -0.451836932552156],
            [30.148555008507042, -0.453340800165514],
            [30.148569445331965, -0.449975346759199],
            [30.149145645416436, -0.450252384931935],
            [30.149728533458237, -0.449896602869434],
            [30.150029602927376, -0.450331877989663],
            [30.150115291425713, -0.448973809036652],
            [30.15147775992891, -0.448077825385591],
            [30.150829807809437, -0.447016106602794],
            [30.150987623838553, -0.445528237995362],
            [30.151721515086308, -0.444236352237975],
            [30.150006539580765, -0.442339019821468],
            [30.150642054525154, -0.441495405590626],
            [30.150917935233753, -0.439250103214728],
            [30.150663115527003, -0.437584688909339],
            [30.1499497885127, -0.436391167139615],
            [30.149819471711073, -0.434586077176151],
            [30.150822182010977, -0.432536132779045],
            [30.1518853309632, -0.426466104887043],
            [30.150864119860007, -0.425424069986644],
            [30.15135550460862, -0.424861245141565],
            [30.151165875642068, -0.424116184926954],
            [30.151781452478712, -0.424043941695803],
            [30.152109085130796, -0.423367625798152],
            [30.152057207423155, -0.421956751337583],
            [30.152993915804185, -0.421357178952937],
            [30.152928853523107, -0.420252963654863],
            [30.152457467069343, -0.419797878580804],
            [30.152654534086494, -0.418100340738775],
            [30.153977374309267, -0.418113964225613],
            [30.15471107870746, -0.4173231587722],
            [30.15482945689897, -0.416017898959278],
            [30.1536318058942, -0.413725162016031],
            [30.154162753346252, -0.412422653078052],
            [30.153914185913866, -0.411796333320752],
            [30.15424863049078, -0.410227344774872],
            [30.15485464476122, -0.410226033268159],
            [30.15566391184786, -0.409298239240858],
            [30.156219235983453, -0.408323138329864],
            [30.156106735468853, -0.407215173538746],
            [30.156530305498354, -0.406448240927503],
            [30.157978838894003, -0.406581416409602],
            [30.159211427176817, -0.405521259419657],
            [30.15986044290158, -0.405417267656552],
            [30.16016182498448, -0.404555718583422],
            [30.15961693657754, -0.402576329956362],
            [30.160154730988676, -0.400085101379554],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 456,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "KYAMUHUNGA TOWN COUNCIL",
        Population: 14853,
        Key: "BUSHENYIKYAMUHUNGA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.050730265307074, -0.66330949799175],
            [30.047020879852138, -0.662647704919699],
            [30.04557434251308, -0.663414645934524],
            [30.042045818467525, -0.664084539367106],
            [30.039292526139164, -0.665876622332572],
            [30.03785567892706, -0.665418833132333],
            [30.036269563155756, -0.664221710979673],
            [30.034639624869953, -0.664738583002518],
            [30.033159715118057, -0.663122715723829],
            [30.03235886704228, -0.660948228234461],
            [30.031064139596307, -0.659208250409103],
            [30.02976816439043, -0.659580160645358],
            [30.02936723010946, -0.662690301079657],
            [30.027503975089857, -0.664206854741509],
            [30.02802567797932, -0.66511975921996],
            [30.027788898240075, -0.665605669208711],
            [30.025827435800355, -0.666566667770677],
            [30.025984602347535, -0.667390076037979],
            [30.025432170787127, -0.668431281162023],
            [30.023247538084764, -0.668622022732934],
            [30.022457313485532, -0.668176451841704],
            [30.02177548679498, -0.668359040867735],
            [30.019787451290817, -0.667854571421275],
            [30.01820800820546, -0.668082363306422],
            [30.016874230095798, -0.669699120924285],
            [30.015826320164035, -0.669902499979837],
            [30.01367252752369, -0.671545205746835],
            [30.011741711109885, -0.670388821794325],
            [30.01132160678072, -0.669919621597094],
            [30.01144739427672, -0.668581497099983],
            [30.010487022474443, -0.668264314575459],
            [30.008011171228297, -0.667323603419631],
            [30.00691007564185, -0.669248989695281],
            [30.0072861759968, -0.670609805696588],
            [30.00598291096238, -0.672737393804939],
            [30.00591905422041, -0.676325656869203],
            [30.007250218232585, -0.677816435446812],
            [30.00589228711986, -0.67975253102969],
            [30.006298279814224, -0.68142898078477],
            [30.005116740094067, -0.684858411335057],
            [30.00536778777494, -0.686291484536945],
            [30.00764212624159, -0.686414683231421],
            [30.00751306258977, -0.687924179123161],
            [30.008009506650076, -0.689476739349002],
            [30.00917008777636, -0.689544234770041],
            [30.0112915716092, -0.690830769656983],
            [30.011855387519187, -0.690697598705007],
            [30.01369501055861, -0.69198395991751],
            [30.01452419778666, -0.691717429441995],
            [30.016196328144733, -0.692394767245665],
            [30.017054580363805, -0.692318076482869],
            [30.018124167541693, -0.692036554237705],
            [30.018795306076974, -0.691549355220511],
            [30.019101024327735, -0.69071885668975],
            [30.019824630763825, -0.690516018359738],
            [30.019819310042383, -0.692937177985508],
            [30.019058322910713, -0.697669493987375],
            [30.019212704680488, -0.700516897452021],
            [30.019859887842074, -0.702941339525046],
            [30.021099497357167, -0.703121553156682],
            [30.020891947898985, -0.705357503889545],
            [30.02244740147469, -0.70670057101185],
            [30.02395231762912, -0.707124521996357],
            [30.024536564821926, -0.708100776115849],
            [30.025645629363257, -0.708824157466746],
            [30.025936243340855, -0.710023692809751],
            [30.024907298641377, -0.711376398556257],
            [30.024601172555467, -0.713082128857041],
            [30.024971942307513, -0.714279199205548],
            [30.025433693431545, -0.71318196707049],
            [30.03296342065207, -0.716151101982312],
            [30.035480683334473, -0.714423366704499],
            [30.040391629262313, -0.714286795667558],
            [30.04330227319083, -0.721543351346907],
            [30.043631134738245, -0.722853705988968],
            [30.043422156060412, -0.72400649306411],
            [30.043904477706146, -0.724407890250164],
            [30.04567417049396, -0.723997456733825],
            [30.047424399484523, -0.724108723061367],
            [30.049460829029652, -0.723342200579671],
            [30.05341737335859, -0.723864954128568],
            [30.055357507996852, -0.723042764745705],
            [30.057752085065967, -0.723697993995808],
            [30.059873354201468, -0.717749554931431],
            [30.062701136629848, -0.717046583107779],
            [30.066888014387523, -0.715004508120386],
            [30.068458404251473, -0.713750767647269],
            [30.071920521237924, -0.715420632829657],
            [30.072771524052644, -0.713641986512936],
            [30.074309939282372, -0.712501755198409],
            [30.074144959188875, -0.710584012535484],
            [30.073151653351644, -0.71080952172971],
            [30.07071662424697, -0.709879607811817],
            [30.06964231911722, -0.707296169784251],
            [30.068601934372612, -0.70718839183968],
            [30.067519326114695, -0.706229118888687],
            [30.06679449976645, -0.704735420046278],
            [30.065695068758217, -0.704520489216113],
            [30.065614055092617, -0.702364933056255],
            [30.063299187335286, -0.698538837850686],
            [30.06415211793462, -0.695393103106244],
            [30.06280743427739, -0.688814515988494],
            [30.061220730109593, -0.687431124887405],
            [30.059702002357653, -0.687041666753552],
            [30.059317100309546, -0.684863912224852],
            [30.057994835008554, -0.682423558257801],
            [30.05697477824049, -0.682088625387866],
            [30.05457555508472, -0.682267858921675],
            [30.05410506784458, -0.680839992583392],
            [30.054042494795123, -0.678093223839208],
            [30.054490367846334, -0.675391941960493],
            [30.050227977705852, -0.671486113236317],
            [30.05002012910869, -0.669624723042732],
            [30.051982903088707, -0.668505532646246],
            [30.05058574075091, -0.667230717630614],
            [30.051209975550282, -0.665062627522332],
            [30.050730265307074, -0.66330949799175],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 457,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KABIRA",
        Population: 11040,
        Key: "MITOOMAKABIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.92670358496913, -0.559453065397436],
            [29.92631124936208, -0.559419302928614],
            [29.926428152519886, -0.56113449646256],
            [29.92606922076663, -0.562486645691817],
            [29.924461482546462, -0.565124983127361],
            [29.9216071063924, -0.566685533979159],
            [29.919260674530957, -0.566792468690646],
            [29.916214464944602, -0.569261091145385],
            [29.915783822478886, -0.570721371412328],
            [29.916159364081707, -0.57183949467892],
            [29.915944064857563, -0.57252455707522],
            [29.913578538406412, -0.574867306078821],
            [29.911444271547076, -0.580149209782868],
            [29.9113632704579, -0.581180031124352],
            [29.910748186796333, -0.581924244305301],
            [29.908978185886383, -0.582388729280273],
            [29.907316855972976, -0.580996212033605],
            [29.90529965666315, -0.581227128269806],
            [29.904267550792188, -0.582077825837271],
            [29.90414887885156, -0.582605543536908],
            [29.905195830280924, -0.585551496281567],
            [29.903384656886537, -0.5884107376772],
            [29.902576054553215, -0.588937191816156],
            [29.901860997383704, -0.588689648060747],
            [29.89997897925276, -0.590062609008112],
            [29.896650487563118, -0.591583299573632],
            [29.896922374361957, -0.596067672291947],
            [29.896282339993373, -0.597706859612707],
            [29.895413307092575, -0.598795214351255],
            [29.891746061607613, -0.601231261512729],
            [29.890607694021693, -0.603950702237094],
            [29.889008681137867, -0.605467394371818],
            [29.887886855129597, -0.608054144009408],
            [29.886156189649284, -0.609297081711076],
            [29.885134612033468, -0.609437467873416],
            [29.88426153222231, -0.61125423978931],
            [29.885359857404413, -0.612651361960778],
            [29.88744598175107, -0.613483785774705],
            [29.888169221674506, -0.615616036326705],
            [29.890441950360195, -0.615193493191714],
            [29.893216003653112, -0.617033678180764],
            [29.8927510275772, -0.616933790414555],
            [29.89247775467787, -0.617594558179982],
            [29.89208004355215, -0.620037833243845],
            [29.89553453923173, -0.621224224330056],
            [29.895329427801226, -0.622551830062869],
            [29.895861425383856, -0.623449762580863],
            [29.89571816475728, -0.624889608268096],
            [29.898264743958993, -0.622110986283673],
            [29.898908673422657, -0.62219863512825],
            [29.899304522340795, -0.62296558760735],
            [29.89988030291206, -0.623115530020641],
            [29.901992393061985, -0.622131883458524],
            [29.901998084787625, -0.622992110594858],
            [29.902753366718933, -0.62354670572099],
            [29.902771277329062, -0.624407571290486],
            [29.90418085707907, -0.624560712373373],
            [29.904829695835737, -0.625475122262165],
            [29.904740920726077, -0.626421749940379],
            [29.90571123238697, -0.626665843540656],
            [29.905296136165553, -0.62704584139971],
            [29.90510341879101, -0.62834229845221],
            [29.906812062970445, -0.629016535111239],
            [29.906387323334425, -0.63106026656283],
            [29.90830965785533, -0.630569575410457],
            [29.908764653648394, -0.631340414336263],
            [29.909578440159233, -0.631617566395151],
            [29.91051024284052, -0.633895376279518],
            [29.913208277100832, -0.637053064803536],
            [29.914124177804933, -0.640964398895115],
            [29.91521984666878, -0.641563483766697],
            [29.917839103170238, -0.641671039497945],
            [29.919194805562725, -0.642345087579822],
            [29.919824328744166, -0.643264181441999],
            [29.919622295840163, -0.645049594194931],
            [29.920764987915838, -0.646778133113418],
            [29.922071453647614, -0.646953469488602],
            [29.923050366677348, -0.646068890964532],
            [29.925298181486934, -0.64605155547997],
            [29.92579474681978, -0.644075794015763],
            [29.926624635632095, -0.643876818969152],
            [29.9276586261685, -0.644902403782254],
            [29.930497133583064, -0.645289578280927],
            [29.930486844279777, -0.646426474057477],
            [29.931674173641962, -0.645456042610424],
            [29.936206206589674, -0.646453063395759],
            [29.93508024383954, -0.647223138215894],
            [29.93488076933743, -0.647901285211517],
            [29.935477688165623, -0.648379517668539],
            [29.937789868163637, -0.648511950503952],
            [29.937559480835976, -0.649667949699252],
            [29.937987600832408, -0.650739567233917],
            [29.939016863535493, -0.649642803877688],
            [29.9400239171898, -0.651264924692818],
            [29.941784593587112, -0.651805530910432],
            [29.942343649324375, -0.651590057877455],
            [29.94309927441214, -0.648574756684881],
            [29.94508945419487, -0.64818035774932],
            [29.94480225471371, -0.64423752725746],
            [29.945640709860545, -0.643747116718993],
            [29.945915627575154, -0.642719428849719],
            [29.946601780552097, -0.642075514707887],
            [29.946973074021976, -0.637972438972969],
            [29.947404421665215, -0.638287271766077],
            [29.95010897499953, -0.635170162896771],
            [29.95090890050552, -0.632238242046023],
            [29.95140580899483, -0.631670203573721],
            [29.95413308701088, -0.6315011769583],
            [29.95489099381948, -0.630978485306171],
            [29.956710465850442, -0.627930142033319],
            [29.957693047599793, -0.627127913754725],
            [29.96458394509251, -0.62727836536343],
            [29.966318425717823, -0.627629920629495],
            [29.96704906057271, -0.626540600727264],
            [29.972672088449837, -0.621925424146187],
            [29.971802027876354, -0.615598026144879],
            [29.9725591450658, -0.61386144729805],
            [29.973618956776743, -0.613114134043513],
            [29.973488053375235, -0.611088282787691],
            [29.974390863829033, -0.610538417520773],
            [29.973036905964808, -0.608307759159929],
            [29.974551670349722, -0.605877884452365],
            [29.974063930066226, -0.604644935572919],
            [29.97448491294772, -0.602186744093996],
            [29.97407942959814, -0.601480153900532],
            [29.973384767778796, -0.601237386787382],
            [29.972926011637952, -0.597310579493032],
            [29.97114689372616, -0.59255896070995],
            [29.971629483968165, -0.590613264115516],
            [29.97394116360456, -0.590081291178589],
            [29.97299540739196, -0.588840207634417],
            [29.97311183893426, -0.586776886015081],
            [29.972445065312936, -0.586431050061815],
            [29.97206581456627, -0.585126845281978],
            [29.97266509237041, -0.583904415881378],
            [29.97214219382331, -0.583616924997024],
            [29.97056125953457, -0.580890007880436],
            [29.969508516666586, -0.580424515822428],
            [29.969836852699565, -0.581366917797884],
            [29.969156849589062, -0.581688924783048],
            [29.967939610819514, -0.577894480796671],
            [29.967311483620023, -0.577949935469639],
            [29.96708932036879, -0.578861069097834],
            [29.966257602586587, -0.579641694828988],
            [29.965093549471728, -0.580068799415278],
            [29.96548252627797, -0.57811632822987],
            [29.965206377871436, -0.576312274806105],
            [29.9655761684598, -0.575698773538636],
            [29.964767698178818, -0.573834394215985],
            [29.96370319007558, -0.574390449511887],
            [29.962998520125677, -0.573930904368801],
            [29.961947617905718, -0.574779112126243],
            [29.960004521521984, -0.574408645770154],
            [29.95928086028864, -0.573177557426754],
            [29.9588936684349, -0.573525206000965],
            [29.956861853535365, -0.573565865306761],
            [29.956640500564546, -0.57395534270826],
            [29.955817986022407, -0.573741070226096],
            [29.955437235089214, -0.575429599759193],
            [29.956721917573677, -0.576821703372244],
            [29.954785538791647, -0.576681599337636],
            [29.95423155673909, -0.57705654342059],
            [29.95403110037838, -0.578156438660238],
            [29.951460063644724, -0.579212476582623],
            [29.949548287921665, -0.578800826657648],
            [29.94800210945129, -0.579211093247747],
            [29.947277022591617, -0.57853383851469],
            [29.947021205754886, -0.577135444737778],
            [29.945446678250743, -0.576716012052921],
            [29.944624346066615, -0.57590511602061],
            [29.943129254786438, -0.575841969442433],
            [29.941820616029986, -0.574523171618906],
            [29.939272409080996, -0.575109600950688],
            [29.935773136876065, -0.572320092754805],
            [29.935038075123455, -0.568864226044903],
            [29.93510867282332, -0.566121358463493],
            [29.934235877778104, -0.563395527106968],
            [29.928699690039483, -0.559758982855366],
            [29.92670358496913, -0.559453065397436],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 458,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KANYABWANGA",
        Population: 18362,
        Key: "MITOOMAKANYABWANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [30.010487022474443, -0.668264314575459],
              [30.012391231687854, -0.667243870769365],
              [30.014007130204085, -0.663047238040277],
              [30.01460287403588, -0.662570273523793],
              [30.014341446321914, -0.661558527246133],
              [30.016264060218855, -0.644789039980287],
              [30.019106065673114, -0.638330888554496],
              [30.0203371968885, -0.637485913706056],
              [30.01979774778062, -0.637036905110482],
              [30.019889145970904, -0.636270083152459],
              [30.019225721268963, -0.635201070229696],
              [30.019481121287374, -0.634003558258415],
              [30.02004996596631, -0.633397254985085],
              [30.01975536526553, -0.632311840128986],
              [30.018489779167364, -0.631200053007989],
              [30.016774957273757, -0.630529744726271],
              [30.016043432188425, -0.629103378998485],
              [30.01450241633597, -0.627802656291584],
              [30.012941577360127, -0.627481652704384],
              [30.01172737938783, -0.626179478901627],
              [30.010708812924815, -0.625767542386587],
              [30.008466457177224, -0.629922077487254],
              [30.00657108199634, -0.630663656559596],
              [30.006032858190494, -0.633605160043682],
              [30.00271950670664, -0.637162101859589],
              [30.000079773108283, -0.63765976557678],
              [29.998005891002336, -0.638711365229758],
              [29.9969837842788, -0.637196979488583],
              [29.993904363976416, -0.639062188537411],
              [29.992128942632018, -0.640657834741461],
              [29.987311419697118, -0.642827607049951],
              [29.98652549084157, -0.642698483251759],
              [29.98672771957831, -0.641208592415015],
              [29.98643325092987, -0.640228284513951],
              [29.9853297685197, -0.639760641769088],
              [29.98256307242897, -0.639621613686434],
              [29.981701297017352, -0.636142858110801],
              [29.979973313906473, -0.636825070303335],
              [29.977016511843733, -0.636860548870444],
              [29.976337536405904, -0.636476386498197],
              [29.9752364902268, -0.639057417881722],
              [29.974148307024226, -0.639813619304891],
              [29.971326680750487, -0.638980458608128],
              [29.96772676938596, -0.639548634608334],
              [29.967894616901862, -0.638885664392273],
              [29.96879938029308, -0.63805455247512],
              [29.969113756506562, -0.634986632189387],
              [29.969792365431744, -0.634032921488914],
              [29.971640986895363, -0.632778344554701],
              [29.97287419052416, -0.630186483298838],
              [29.97255139260488, -0.629092733705763],
              [29.966318425717823, -0.627629920629495],
              [29.96458394509251, -0.62727836536343],
              [29.957693047599793, -0.627127913754725],
              [29.956710465850442, -0.627930142033319],
              [29.95489099381948, -0.630978485306171],
              [29.95413308701088, -0.6315011769583],
              [29.95140580899483, -0.631670203573721],
              [29.95090890050552, -0.632238242046023],
              [29.95010897499953, -0.635170162896771],
              [29.947404421665215, -0.638287271766077],
              [29.946973074021976, -0.637972438972969],
              [29.946601780552097, -0.642075514707887],
              [29.945915627575154, -0.642719428849719],
              [29.945640709860545, -0.643747116718993],
              [29.94480225471371, -0.64423752725746],
              [29.94508945419487, -0.64818035774932],
              [29.946790970242503, -0.647060116967212],
              [29.948782566668456, -0.65024362765142],
              [29.9497130209785, -0.650604578016397],
              [29.949736043002574, -0.651877607962402],
              [29.950414359077, -0.651890912048905],
              [29.951337772391827, -0.65127005823301],
              [29.951042572514744, -0.648355372499732],
              [29.951962783335585, -0.647537479989951],
              [29.95284595032909, -0.647491716443742],
              [29.954276835422654, -0.648837739593971],
              [29.957945237937707, -0.650462694669776],
              [29.959078699823845, -0.652619917730056],
              [29.9600540986442, -0.653079573786653],
              [29.96038238616814, -0.653869792801134],
              [29.961750088256185, -0.654479153101825],
              [29.9619294144448, -0.656080655576015],
              [29.966117998103194, -0.656873230243456],
              [29.96782661982473, -0.654909884227482],
              [29.96895726100092, -0.655997764475549],
              [29.969884173253767, -0.655498348260964],
              [29.970180347802966, -0.654802298236678],
              [29.97204201909272, -0.654350449985048],
              [29.974123328469435, -0.657232197680519],
              [29.975697211881524, -0.658102509937289],
              [29.977400999768516, -0.658143433583484],
              [29.978102992738876, -0.660347669831793],
              [29.980488425856695, -0.659398809091643],
              [29.982198421102296, -0.660365903522673],
              [29.987415687152154, -0.659865304742537],
              [29.987937840995883, -0.659956016891089],
              [29.988794276821455, -0.661120863958714],
              [29.991441986561203, -0.662413675299214],
              [29.995780117256572, -0.661244511519172],
              [29.99703735620907, -0.661263696459263],
              [29.998844181757466, -0.663097183720233],
              [30.000571460589153, -0.662873152599273],
              [30.001411999827457, -0.66363890159475],
              [30.002165097954318, -0.663478983453272],
              [30.00249622684951, -0.663885754645411],
              [30.003256859146664, -0.663651310089639],
              [30.005273845555774, -0.664131385158797],
              [30.008011171228297, -0.667323603419631],
              [30.010487022474443, -0.668264314575459],
            ],
          ],
          [
            [
              [30.008062173078578, -0.614007165434347],
              [30.010047704079692, -0.610969666999864],
              [30.009834058653965, -0.608831319875083],
              [30.01024579158299, -0.608090600980282],
              [30.01021020751796, -0.606384993679926],
              [30.0099872070369, -0.605913098239113],
              [30.009300986686274, -0.606043397871381],
              [30.00718883275596, -0.602513890644371],
              [30.008691243509087, -0.60195466278114],
              [30.009308224412525, -0.601099945826502],
              [30.00724315927109, -0.594256560679786],
              [30.006049481514818, -0.592448931055994],
              [30.00454589756192, -0.587198843881755],
              [30.001301000397707, -0.578511668325356],
              [29.99929550433936, -0.576529589631583],
              [29.99859211359043, -0.576557204241928],
              [29.99605441693025, -0.576997481287698],
              [29.9956876617492, -0.579410945606184],
              [29.994523324766725, -0.58046857772256],
              [29.990619393865654, -0.579657105537319],
              [29.990635774644858, -0.581361652144775],
              [29.988985249667703, -0.582438842802466],
              [29.984439471597803, -0.582273652053138],
              [29.983022347796073, -0.582483512814953],
              [29.98254655690247, -0.583019386757067],
              [29.980150365560768, -0.582338365140589],
              [29.97773431965469, -0.583236993262449],
              [29.975852023944313, -0.581914812481291],
              [29.97548105476628, -0.582058217524815],
              [29.975509178322884, -0.582824126476473],
              [29.97493863492973, -0.582708935178099],
              [29.974472346415187, -0.583263956595257],
              [29.97266509237041, -0.583904415881378],
              [29.97206581456627, -0.585126845281978],
              [29.972445065312936, -0.586431050061815],
              [29.97311183893426, -0.586776886015081],
              [29.97299540739196, -0.588840207634417],
              [29.97394116360456, -0.590081291178589],
              [29.971629483968165, -0.590613264115516],
              [29.97114689372616, -0.59255896070995],
              [29.972926011637952, -0.597310579493032],
              [29.973384767778796, -0.601237386787382],
              [29.97407942959814, -0.601480153900532],
              [29.97448491294772, -0.602186744093996],
              [29.974063930066226, -0.604644935572919],
              [29.974551670349722, -0.605877884452365],
              [29.973036905964808, -0.608307759159929],
              [29.974390863829033, -0.610538417520773],
              [29.976408896775464, -0.611978479594792],
              [29.978290903228313, -0.609787901490775],
              [29.98232464517952, -0.608529806585134],
              [29.983936320715603, -0.607442465239269],
              [29.983628495017186, -0.609601121775979],
              [29.984030888162177, -0.610958012021713],
              [29.985242556478653, -0.609916280540301],
              [29.985764538744174, -0.610681515510558],
              [29.988515836812624, -0.610649974757507],
              [29.989847010706267, -0.611747054434919],
              [29.99110916164676, -0.613557924874396],
              [29.994258584065996, -0.61544466652472],
              [29.9948372904501, -0.616985875308235],
              [29.995802576036972, -0.618175747846441],
              [29.996697091447434, -0.618467456951033],
              [29.998916593155897, -0.621276688248346],
              [30.000001559491434, -0.620927597389913],
              [30.002204906796123, -0.617096150588936],
              [30.00600345902619, -0.614371070911318],
              [30.008062173078578, -0.614007165434347],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 459,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KASHENSHERO",
        Population: 12091,
        Key: "MITOOMAKASHENSHERO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.008062173078578, -0.614007165434347],
            [30.00600345902619, -0.614371070911318],
            [30.002204906796123, -0.617096150588936],
            [30.000001559491434, -0.620927597389913],
            [29.998916593155897, -0.621276688248346],
            [29.996697091447434, -0.618467456951033],
            [29.995802576036972, -0.618175747846441],
            [29.9948372904501, -0.616985875308235],
            [29.994258584065996, -0.61544466652472],
            [29.99110916164676, -0.613557924874396],
            [29.989847010706267, -0.611747054434919],
            [29.988515836812624, -0.610649974757507],
            [29.985764538744174, -0.610681515510558],
            [29.985242556478653, -0.609916280540301],
            [29.984030888162177, -0.610958012021713],
            [29.983628495017186, -0.609601121775979],
            [29.983936320715603, -0.607442465239269],
            [29.98232464517952, -0.608529806585134],
            [29.978290903228313, -0.609787901490775],
            [29.976408896775464, -0.611978479594792],
            [29.974390863829033, -0.610538417520773],
            [29.973488053375235, -0.611088282787691],
            [29.973618956776743, -0.613114134043513],
            [29.9725591450658, -0.61386144729805],
            [29.971802027876354, -0.615598026144879],
            [29.972672088449837, -0.621925424146187],
            [29.96704906057271, -0.626540600727264],
            [29.966318425717823, -0.627629920629495],
            [29.97255139260488, -0.629092733705763],
            [29.97287419052416, -0.630186483298838],
            [29.971640986895363, -0.632778344554701],
            [29.969792365431744, -0.634032921488914],
            [29.969113756506562, -0.634986632189387],
            [29.96879938029308, -0.63805455247512],
            [29.967894616901862, -0.638885664392273],
            [29.96772676938596, -0.639548634608334],
            [29.971326680750487, -0.638980458608128],
            [29.974148307024226, -0.639813619304891],
            [29.9752364902268, -0.639057417881722],
            [29.976337536405904, -0.636476386498197],
            [29.977016511843733, -0.636860548870444],
            [29.979973313906473, -0.636825070303335],
            [29.981701297017352, -0.636142858110801],
            [29.98256307242897, -0.639621613686434],
            [29.9853297685197, -0.639760641769088],
            [29.98643325092987, -0.640228284513951],
            [29.98672771957831, -0.641208592415015],
            [29.98652549084157, -0.642698483251759],
            [29.987311419697118, -0.642827607049951],
            [29.992128942632018, -0.640657834741461],
            [29.993904363976416, -0.639062188537411],
            [29.9969837842788, -0.637196979488583],
            [29.998005891002336, -0.638711365229758],
            [30.000079773108283, -0.63765976557678],
            [30.00271950670664, -0.637162101859589],
            [30.006032858190494, -0.633605160043682],
            [30.00657108199634, -0.630663656559596],
            [30.008466457177224, -0.629922077487254],
            [30.010708812924815, -0.625767542386587],
            [30.009901611963365, -0.625283975749738],
            [30.009855600254497, -0.624814132713203],
            [30.010665644383863, -0.623974345826754],
            [30.010596821755, -0.623170196458926],
            [30.00839635085581, -0.621580537198749],
            [30.00958162936419, -0.620211162906782],
            [30.00973703790835, -0.619329017705411],
            [30.008062173078578, -0.614007165434347],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 460,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KASHENSHERO TOWN COUNCIL",
        Population: 5756,
        Key: "MITOOMAKASHENSHERO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.071920521237924, -0.715420632829657],
            [30.068458404251473, -0.713750767647269],
            [30.066888014387523, -0.715004508120386],
            [30.062701136629848, -0.717046583107779],
            [30.059873354201468, -0.717749554931431],
            [30.057752085065967, -0.723697993995808],
            [30.055357507996852, -0.723042764745705],
            [30.05341737335859, -0.723864954128568],
            [30.049460829029652, -0.723342200579671],
            [30.047424399484523, -0.724108723061367],
            [30.04567417049396, -0.723997456733825],
            [30.043904477706146, -0.724407890250164],
            [30.043422156060412, -0.72400649306411],
            [30.043631134738245, -0.722853705988968],
            [30.04330227319083, -0.721543351346907],
            [30.040391629262313, -0.714286795667558],
            [30.035480683334473, -0.714423366704499],
            [30.03296342065207, -0.716151101982312],
            [30.025433693431545, -0.71318196707049],
            [30.024971942307513, -0.714279199205548],
            [30.024601172555467, -0.713082128857041],
            [30.024907298641377, -0.711376398556257],
            [30.025936243340855, -0.710023692809751],
            [30.025645629363257, -0.708824157466746],
            [30.024536564821926, -0.708100776115849],
            [30.02395231762912, -0.707124521996357],
            [30.02244740147469, -0.70670057101185],
            [30.020891947898985, -0.705357503889545],
            [30.01985588045762, -0.706238934034135],
            [30.019022897847467, -0.708813707266452],
            [30.018367380116647, -0.709222704050638],
            [30.01729415835513, -0.709153773514724],
            [30.01612975220238, -0.710347161174927],
            [30.0138468491978, -0.711608055307404],
            [30.01259746421583, -0.713248435454885],
            [30.011525675267187, -0.713225462821531],
            [30.011754387236863, -0.715382438542971],
            [30.010814958757113, -0.715455925783879],
            [30.01031333141762, -0.716622865680936],
            [30.0070070559633, -0.719086823867163],
            [30.006293736135508, -0.720311732830141],
            [30.005141662953307, -0.721109927911325],
            [30.004428381753087, -0.723474966385598],
            [30.005342012414488, -0.724819539052648],
            [30.004976372941037, -0.72585688341333],
            [30.005280348460133, -0.726609261734292],
            [30.004413163393856, -0.727957194694159],
            [30.004372288251794, -0.729088304977127],
            [30.003378289813508, -0.730249076734068],
            [30.00365685828142, -0.731190265720753],
            [30.0029346352509, -0.731811716295375],
            [30.0026314367745, -0.73311103305627],
            [30.003733704662423, -0.735544080960468],
            [30.003414065219715, -0.736813734023867],
            [30.003693995533595, -0.738290162639401],
            [30.003329309172635, -0.743529802391531],
            [30.00383357306751, -0.744404306865889],
            [30.005660349300047, -0.744126606245183],
            [30.006121955795315, -0.746640330632371],
            [30.00663786724612, -0.746844680002673],
            [30.00838499525234, -0.744714883031421],
            [30.010922511351133, -0.745857855697061],
            [30.012708688224418, -0.7453439972898],
            [30.013247637869018, -0.745538719392181],
            [30.013782351957033, -0.745112439282549],
            [30.01550752962928, -0.745800382761558],
            [30.017495033330754, -0.74429689898202],
            [30.017584519906112, -0.745253014632605],
            [30.018618323592957, -0.744873336950666],
            [30.018939867464084, -0.744136286572524],
            [30.018468913099948, -0.743257304320142],
            [30.018965722774578, -0.742479822099794],
            [30.019481252441413, -0.742248519940655],
            [30.01989377678617, -0.742955281091051],
            [30.022065496206363, -0.741541819757632],
            [30.0233548795747, -0.743215473297063],
            [30.02288983882009, -0.743562737246247],
            [30.022399647034156, -0.743064301347888],
            [30.022216558701164, -0.743555271078365],
            [30.02286605682127, -0.745144832487138],
            [30.022885439770143, -0.74952886513678],
            [30.02404770254262, -0.750650238411934],
            [30.025117131617023, -0.751048634876311],
            [30.025949900428092, -0.750902414285232],
            [30.02659443625457, -0.752677458238524],
            [30.028337386196387, -0.753787914424329],
            [30.030597396534265, -0.753936019421013],
            [30.03149235750909, -0.75502744792541],
            [30.03204015376261, -0.754537466643088],
            [30.033837847037844, -0.754405979059117],
            [30.035061805205714, -0.753784639450251],
            [30.036909569676567, -0.755444777033551],
            [30.037052637165335, -0.757453362501824],
            [30.036293424206328, -0.758584912552319],
            [30.03677174385746, -0.760043638585054],
            [30.038042649778703, -0.759270601130621],
            [30.038358333040897, -0.760359033572681],
            [30.03895967427524, -0.760631496443587],
            [30.03961418229969, -0.759640285578934],
            [30.040545894251135, -0.759725646773223],
            [30.040038857256988, -0.762138941197308],
            [30.04103502333008, -0.763484446135576],
            [30.040635082585794, -0.764918508563323],
            [30.040874390184232, -0.765806547834455],
            [30.041785367222275, -0.766651058460116],
            [30.042086452861103, -0.769785319436078],
            [30.043752331843113, -0.770511328850919],
            [30.044636887632024, -0.771550233419549],
            [30.04476007899681, -0.772658601732492],
            [30.045467504079685, -0.773617679774853],
            [30.04687484343136, -0.774123073461974],
            [30.04768689170212, -0.775137215555992],
            [30.05046377468816, -0.774535923020928],
            [30.052050171632153, -0.776145741655256],
            [30.051365861998164, -0.777160027880044],
            [30.051406054420596, -0.777792096182776],
            [30.052944846942736, -0.778769426938664],
            [30.053856318952512, -0.77813891991034],
            [30.055530581012736, -0.778862059838891],
            [30.057305459774692, -0.77707679584557],
            [30.057834801039004, -0.777570351312706],
            [30.05876604586649, -0.777589743255425],
            [30.059029251346416, -0.778157277984912],
            [30.05994802665946, -0.777780367062574],
            [30.06128326453147, -0.7782325256101],
            [30.062315524912663, -0.779919031194888],
            [30.064259046199517, -0.78046125792565],
            [30.065087219229643, -0.779214954629975],
            [30.065309689704684, -0.776349372837093],
            [30.066248121054453, -0.774743809210673],
            [30.065769424110904, -0.772856151142405],
            [30.066281099106863, -0.769240715509069],
            [30.067878078204863, -0.766142672764596],
            [30.070031485467986, -0.763135355864624],
            [30.0726345462432, -0.760914414765132],
            [30.073616515341527, -0.759297737750682],
            [30.073616377899274, -0.758656220856815],
            [30.075367541137723, -0.757338231000253],
            [30.076801841626015, -0.754185820164557],
            [30.076502999978736, -0.752884509226137],
            [30.075015230866434, -0.75188057125557],
            [30.072545722624536, -0.75175241335956],
            [30.07244804071885, -0.748897147484083],
            [30.071015279044655, -0.747640260964749],
            [30.07042571113044, -0.746329729451934],
            [30.07037741320916, -0.74228926769557],
            [30.070917474069766, -0.739232043373797],
            [30.07002961697219, -0.738120112196585],
            [30.070919753993966, -0.735735374008358],
            [30.070058864321226, -0.734555697486115],
            [30.071513576329366, -0.733526627038785],
            [30.071549136139907, -0.732939962013418],
            [30.07374175845842, -0.730510862265641],
            [30.07312633792864, -0.729896049522294],
            [30.07238443370854, -0.727943908785172],
            [30.07316100211884, -0.725938019924221],
            [30.074815965671817, -0.72420084332546],
            [30.075143794156634, -0.72106857454752],
            [30.075121565344926, -0.720401152150604],
            [30.071920521237924, -0.715420632829657],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 461,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "MAYANGA",
        Population: 11230,
        Key: "MITOOMAMAYANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.05383824934056, -0.567348104276235],
            [30.052754017826928, -0.566967422300166],
            [30.049703110949977, -0.562836748089798],
            [30.050323756081447, -0.561807041805244],
            [30.050069197784445, -0.559611342799497],
            [30.049446338305803, -0.55747870621154],
            [30.048477168403625, -0.55604161333947],
            [30.04646138214373, -0.551233855870861],
            [30.044683227225963, -0.550275236954068],
            [30.0429329461331, -0.547952318279975],
            [30.040347292013177, -0.547038484100942],
            [30.03749386627668, -0.548274890334355],
            [30.037052844676165, -0.548807746539524],
            [30.03661905631031, -0.550885616701843],
            [30.035454202796533, -0.551282582728064],
            [30.0348859456158, -0.550758260344679],
            [30.033295163096607, -0.550658080360322],
            [30.03280117682693, -0.549103792515709],
            [30.032017880933473, -0.548985946147913],
            [30.02967813433433, -0.546405746808336],
            [30.028951630831465, -0.546147399482117],
            [30.02604646662621, -0.549136567840204],
            [30.02626255906273, -0.552280881818704],
            [30.024119690834553, -0.554150063027931],
            [30.02131470135989, -0.558973356444092],
            [30.019886430363776, -0.56006586683837],
            [30.0152028381529, -0.561870474187507],
            [30.015557354686525, -0.562412754735294],
            [30.013245136959263, -0.565275652913737],
            [30.00855300266832, -0.565986989631189],
            [30.007048239227498, -0.564681975325052],
            [30.005168182118823, -0.564999736220189],
            [30.004013262175484, -0.567357943041163],
            [30.001441992778183, -0.569497870870669],
            [30.00089823535015, -0.571423140877105],
            [29.99883073307935, -0.573195902801769],
            [29.99859211359043, -0.576557204241928],
            [29.99929550433936, -0.576529589631583],
            [30.001301000397707, -0.578511668325356],
            [30.00454589756192, -0.587198843881755],
            [30.006049481514818, -0.592448931055994],
            [30.00724315927109, -0.594256560679786],
            [30.009308224412525, -0.601099945826502],
            [30.008691243509087, -0.60195466278114],
            [30.00718883275596, -0.602513890644371],
            [30.009300986686274, -0.606043397871381],
            [30.0099872070369, -0.605913098239113],
            [30.01021020751796, -0.606384993679926],
            [30.01024579158299, -0.608090600980282],
            [30.009834058653965, -0.608831319875083],
            [30.010047704079692, -0.610969666999864],
            [30.008062173078578, -0.614007165434347],
            [30.00973703790835, -0.619329017705411],
            [30.00958162936419, -0.620211162906782],
            [30.00839635085581, -0.621580537198749],
            [30.010596821755, -0.623170196458926],
            [30.010665644383863, -0.623974345826754],
            [30.009855600254497, -0.624814132713203],
            [30.009901611963365, -0.625283975749738],
            [30.010708812924815, -0.625767542386587],
            [30.01172737938783, -0.626179478901627],
            [30.012941577360127, -0.627481652704384],
            [30.01450241633597, -0.627802656291584],
            [30.016043432188425, -0.629103378998485],
            [30.016774957273757, -0.630529744726271],
            [30.018489779167364, -0.631200053007989],
            [30.01975536526553, -0.632311840128986],
            [30.02004996596631, -0.633397254985085],
            [30.019481121287374, -0.634003558258415],
            [30.019225721268963, -0.635201070229696],
            [30.019889145970904, -0.636270083152459],
            [30.01979774778062, -0.637036905110482],
            [30.0203371968885, -0.637485913706056],
            [30.019106065673114, -0.638330888554496],
            [30.016264060218855, -0.644789039980287],
            [30.014341446321914, -0.661558527246133],
            [30.01460287403588, -0.662570273523793],
            [30.014007130204085, -0.663047238040277],
            [30.012391231687854, -0.667243870769365],
            [30.010487022474443, -0.668264314575459],
            [30.01144739427672, -0.668581497099983],
            [30.01132160678072, -0.669919621597094],
            [30.011741711109885, -0.670388821794325],
            [30.01367252752369, -0.671545205746835],
            [30.015826320164035, -0.669902499979837],
            [30.016874230095798, -0.669699120924285],
            [30.01820800820546, -0.668082363306422],
            [30.019787451290817, -0.667854571421275],
            [30.02177548679498, -0.668359040867735],
            [30.022457313485532, -0.668176451841704],
            [30.023247538084764, -0.668622022732934],
            [30.025432170787127, -0.668431281162023],
            [30.025984602347535, -0.667390076037979],
            [30.025827435800355, -0.666566667770677],
            [30.027788898240075, -0.665605669208711],
            [30.02802567797932, -0.66511975921996],
            [30.027503975089857, -0.664206854741509],
            [30.02936723010946, -0.662690301079657],
            [30.02976816439043, -0.659580160645358],
            [30.031064139596307, -0.659208250409103],
            [30.03235886704228, -0.660948228234461],
            [30.033159715118057, -0.663122715723829],
            [30.034639624869953, -0.664738583002518],
            [30.036269563155756, -0.664221710979673],
            [30.03785567892706, -0.665418833132333],
            [30.039292526139164, -0.665876622332572],
            [30.042045818467525, -0.664084539367106],
            [30.04557434251308, -0.663414645934524],
            [30.047020879852138, -0.662647704919699],
            [30.050730265307074, -0.66330949799175],
            [30.05189467415478, -0.660942950983326],
            [30.05393803150739, -0.660618897211414],
            [30.05577146605281, -0.659074949242393],
            [30.058758077809937, -0.658216791457335],
            [30.060968278361923, -0.652281686227322],
            [30.06176436626505, -0.648234410412222],
            [30.061411736193495, -0.645075429003411],
            [30.060516567707847, -0.642703205398133],
            [30.06277141003789, -0.637218093083576],
            [30.062022472009083, -0.634308649661464],
            [30.06050039893102, -0.634433713534201],
            [30.058374089348476, -0.633865810939694],
            [30.055352021985414, -0.631954140177664],
            [30.052740049922594, -0.631527864284233],
            [30.0486871253468, -0.631890334029011],
            [30.04794797446304, -0.630013568063447],
            [30.042645877805978, -0.626544923161947],
            [30.04176702901406, -0.626544425525044],
            [30.040715801603948, -0.627703116356464],
            [30.037210504398416, -0.627721463344998],
            [30.035823929604543, -0.626044665996889],
            [30.035411247156297, -0.630325702964796],
            [30.03436575279433, -0.630318282431303],
            [30.031129672594595, -0.628790274800133],
            [30.030205007926575, -0.627366902502349],
            [30.028986427074006, -0.626919168563068],
            [30.028795609636287, -0.626217854435136],
            [30.027307160499316, -0.625749537628891],
            [30.026009405730825, -0.62620252021082],
            [30.024727873638085, -0.62481393779039],
            [30.02587283395987, -0.619886943974255],
            [30.025536562209695, -0.618543569465039],
            [30.03310483524071, -0.619533589869044],
            [30.033007177589557, -0.616866573378175],
            [30.032250054111895, -0.615605982064102],
            [30.03290798292093, -0.613509837221104],
            [30.031933106021786, -0.609487639536739],
            [30.03268479559027, -0.609965191035974],
            [30.0340870423926, -0.610076997103821],
            [30.0356489557535, -0.609137289438452],
            [30.03680609633223, -0.606560362846426],
            [30.03830709044217, -0.604943891718314],
            [30.038802183436275, -0.602688081411436],
            [30.03837835469197, -0.599721726480931],
            [30.039365138760207, -0.596491103507588],
            [30.038928448835964, -0.595321769562017],
            [30.04270537412554, -0.593017747990508],
            [30.044054052590855, -0.591706773612677],
            [30.04749794545512, -0.588255679566117],
            [30.05301922385499, -0.585312257766005],
            [30.05678401829499, -0.581634699876996],
            [30.056033630385336, -0.580850223541114],
            [30.055438571069764, -0.579167018762045],
            [30.055478192163676, -0.57567260693526],
            [30.05341193495786, -0.575972576988377],
            [30.053015198504227, -0.575603871318888],
            [30.05458141479532, -0.572886481001965],
            [30.053966901563978, -0.571756751385424],
            [30.0545362672658, -0.569272335701088],
            [30.05383824934056, -0.567348104276235],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 462,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "MITOOMA",
        Population: 18496,
        Key: "MITOOMAMITOOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.062022472009083, -0.634308649661464],
            [30.061600000619194, -0.629171361197241],
            [30.062170133482244, -0.626516053933132],
            [30.062009252401364, -0.623560631478093],
            [30.062656243323502, -0.621672601011843],
            [30.064764906400633, -0.620747159798764],
            [30.06735471433047, -0.617810893165254],
            [30.06961868623875, -0.616508217542024],
            [30.071044035913538, -0.616373472658523],
            [30.07206113902094, -0.61573251683939],
            [30.07106553708986, -0.615262125014188],
            [30.06915562087946, -0.615197825516572],
            [30.06837171233498, -0.614348064582887],
            [30.06835232848778, -0.611556110435715],
            [30.066699181328296, -0.610227000063835],
            [30.06782101003149, -0.606242996849071],
            [30.066924424004316, -0.605501606595633],
            [30.065919732919173, -0.603413884448374],
            [30.064854559164292, -0.602708548392805],
            [30.064779086307382, -0.599853325154074],
            [30.06305278843603, -0.599472910365677],
            [30.060671113869322, -0.597574203628466],
            [30.059799527956475, -0.597826726076975],
            [30.058341301738917, -0.597057939347904],
            [30.058347565691374, -0.595024992086232],
            [30.053169875819712, -0.59353139689556],
            [30.050679375746235, -0.591370074243475],
            [30.04934896362393, -0.591318255889675],
            [30.047023005266105, -0.592073434668059],
            [30.044054052590855, -0.591706773612677],
            [30.04270537412554, -0.593017747990508],
            [30.038928448835964, -0.595321769562017],
            [30.039365138760207, -0.596491103507588],
            [30.03837835469197, -0.599721726480931],
            [30.038802183436275, -0.602688081411436],
            [30.03830709044217, -0.604943891718314],
            [30.03680609633223, -0.606560362846426],
            [30.0356489557535, -0.609137289438452],
            [30.0340870423926, -0.610076997103821],
            [30.03268479559027, -0.609965191035974],
            [30.031933106021786, -0.609487639536739],
            [30.03290798292093, -0.613509837221104],
            [30.032250054111895, -0.615605982064102],
            [30.033007177589557, -0.616866573378175],
            [30.03310483524071, -0.619533589869044],
            [30.025536562209695, -0.618543569465039],
            [30.02587283395987, -0.619886943974255],
            [30.024727873638085, -0.62481393779039],
            [30.026009405730825, -0.62620252021082],
            [30.027307160499316, -0.625749537628891],
            [30.028795609636287, -0.626217854435136],
            [30.028986427074006, -0.626919168563068],
            [30.030205007926575, -0.627366902502349],
            [30.031129672594595, -0.628790274800133],
            [30.03436575279433, -0.630318282431303],
            [30.035411247156297, -0.630325702964796],
            [30.035823929604543, -0.626044665996889],
            [30.037210504398416, -0.627721463344998],
            [30.040715801603948, -0.627703116356464],
            [30.04176702901406, -0.626544425525044],
            [30.042645877805978, -0.626544923161947],
            [30.04794797446304, -0.630013568063447],
            [30.0486871253468, -0.631890334029011],
            [30.052740049922594, -0.631527864284233],
            [30.055352021985414, -0.631954140177664],
            [30.058374089348476, -0.633865810939694],
            [30.06050039893102, -0.634433713534201],
            [30.062022472009083, -0.634308649661464],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 463,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "MITOOMA TOWN COUNCIL",
        Population: 5640,
        Key: "MITOOMAMITOOMA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.008011171228297, -0.667323603419631],
            [30.005273845555774, -0.664131385158797],
            [30.003256859146664, -0.663651310089639],
            [30.00249622684951, -0.663885754645411],
            [30.002165097954318, -0.663478983453272],
            [30.001411999827457, -0.66363890159475],
            [30.000571460589153, -0.662873152599273],
            [29.998844181757466, -0.663097183720233],
            [29.99703735620907, -0.661263696459263],
            [29.995780117256572, -0.661244511519172],
            [29.991441986561203, -0.662413675299214],
            [29.988794276821455, -0.661120863958714],
            [29.987937840995883, -0.659956016891089],
            [29.987415687152154, -0.659865304742537],
            [29.982198421102296, -0.660365903522673],
            [29.980488425856695, -0.659398809091643],
            [29.978102992738876, -0.660347669831793],
            [29.977400999768516, -0.658143433583484],
            [29.975697211881524, -0.658102509937289],
            [29.974123328469435, -0.657232197680519],
            [29.97204201909272, -0.654350449985048],
            [29.970180347802966, -0.654802298236678],
            [29.969884173253767, -0.655498348260964],
            [29.96895726100092, -0.655997764475549],
            [29.96782661982473, -0.654909884227482],
            [29.966117998103194, -0.656873230243456],
            [29.9619294144448, -0.656080655576015],
            [29.961750088256185, -0.654479153101825],
            [29.96038238616814, -0.653869792801134],
            [29.9600540986442, -0.653079573786653],
            [29.959078699823845, -0.652619917730056],
            [29.957945237937707, -0.650462694669776],
            [29.954276835422654, -0.648837739593971],
            [29.95284595032909, -0.647491716443742],
            [29.951962783335585, -0.647537479989951],
            [29.951042572514744, -0.648355372499732],
            [29.951337772391827, -0.65127005823301],
            [29.950414359077, -0.651890912048905],
            [29.949736043002574, -0.651877607962402],
            [29.9497130209785, -0.650604578016397],
            [29.948782566668456, -0.65024362765142],
            [29.946790970242503, -0.647060116967212],
            [29.94508945419487, -0.64818035774932],
            [29.94309927441214, -0.648574756684881],
            [29.942343649324375, -0.651590057877455],
            [29.945160462424838, -0.653571741309399],
            [29.945815850798244, -0.65267977937342],
            [29.946582500011157, -0.652692305567292],
            [29.947078958444518, -0.653851974979451],
            [29.948282170020885, -0.65493630914009],
            [29.948964430597698, -0.65472315194698],
            [29.95081737924607, -0.655528747955464],
            [29.953201527773043, -0.655011666580168],
            [29.95365629988563, -0.655731466476072],
            [29.953348278354483, -0.656655803720701],
            [29.953660102454243, -0.657272572499304],
            [29.955435992719195, -0.657722296111407],
            [29.95637462259662, -0.657284724108856],
            [29.956873408564864, -0.657855825471341],
            [29.957841903832257, -0.657749231218653],
            [29.957926958119973, -0.658873452485509],
            [29.95914204003455, -0.659320584485196],
            [29.95904201981416, -0.660160524557081],
            [29.959576087115206, -0.660719766820025],
            [29.959714168954147, -0.661644120206292],
            [29.958371702339058, -0.662025160127292],
            [29.958693638773948, -0.663521106225685],
            [29.95712923348643, -0.665357852416683],
            [29.957841586726946, -0.666031241592557],
            [29.957742490873034, -0.667035782954134],
            [29.959279327762793, -0.668357009016816],
            [29.960890119356634, -0.671761604910771],
            [29.9632412368306, -0.675151319771365],
            [29.96570909217241, -0.677877922621394],
            [29.971196879581854, -0.686843650077046],
            [29.97202469777739, -0.690806308513257],
            [29.972023388033715, -0.692879643302504],
            [29.972875366418855, -0.6950658978872],
            [29.97612945514507, -0.697141315644829],
            [29.97718410423809, -0.69858350864772],
            [29.981294609925264, -0.700633119083137],
            [29.982156309878427, -0.706090302890194],
            [29.98681404408385, -0.708800263210413],
            [29.98781499099086, -0.71063228608252],
            [29.987951216012135, -0.710214502777959],
            [29.988728503074643, -0.712285775577356],
            [29.989320598848092, -0.716086510972257],
            [29.98904904712087, -0.717944640224068],
            [29.98951839978881, -0.719243403157406],
            [29.99060552297937, -0.719889287620125],
            [29.99110343039525, -0.722338315228798],
            [29.992544613775237, -0.723043406091762],
            [29.992711924996907, -0.724793855578897],
            [29.99440606946932, -0.725606975980267],
            [29.995138417411432, -0.72650534040183],
            [29.995211613937425, -0.727243209296903],
            [29.996221808101986, -0.727812085367098],
            [29.997614980123277, -0.729443384736373],
            [29.999168747561196, -0.728815584157265],
            [30.000889144399487, -0.730189278047489],
            [30.003378289813508, -0.730249076734068],
            [30.004372288251794, -0.729088304977127],
            [30.004413163393856, -0.727957194694159],
            [30.005280348460133, -0.726609261734292],
            [30.004976372941037, -0.72585688341333],
            [30.005342012414488, -0.724819539052648],
            [30.004428381753087, -0.723474966385598],
            [30.005141662953307, -0.721109927911325],
            [30.006293736135508, -0.720311732830141],
            [30.0070070559633, -0.719086823867163],
            [30.01031333141762, -0.716622865680936],
            [30.010814958757113, -0.715455925783879],
            [30.011754387236863, -0.715382438542971],
            [30.011525675267187, -0.713225462821531],
            [30.01259746421583, -0.713248435454885],
            [30.0138468491978, -0.711608055307404],
            [30.01612975220238, -0.710347161174927],
            [30.01729415835513, -0.709153773514724],
            [30.018367380116647, -0.709222704050638],
            [30.019022897847467, -0.708813707266452],
            [30.01985588045762, -0.706238934034135],
            [30.020891947898985, -0.705357503889545],
            [30.021099497357167, -0.703121553156682],
            [30.019859887842074, -0.702941339525046],
            [30.019212704680488, -0.700516897452021],
            [30.019058322910713, -0.697669493987375],
            [30.019819310042383, -0.692937177985508],
            [30.019824630763825, -0.690516018359738],
            [30.019101024327735, -0.69071885668975],
            [30.018795306076974, -0.691549355220511],
            [30.018124167541693, -0.692036554237705],
            [30.017054580363805, -0.692318076482869],
            [30.016196328144733, -0.692394767245665],
            [30.01452419778666, -0.691717429441995],
            [30.01369501055861, -0.69198395991751],
            [30.011855387519187, -0.690697598705007],
            [30.0112915716092, -0.690830769656983],
            [30.00917008777636, -0.689544234770041],
            [30.008009506650076, -0.689476739349002],
            [30.00751306258977, -0.687924179123161],
            [30.00764212624159, -0.686414683231421],
            [30.00536778777494, -0.686291484536945],
            [30.005116740094067, -0.684858411335057],
            [30.006298279814224, -0.68142898078477],
            [30.00589228711986, -0.67975253102969],
            [30.007250218232585, -0.677816435446812],
            [30.00591905422041, -0.676325656869203],
            [30.00598291096238, -0.672737393804939],
            [30.0072861759968, -0.670609805696588],
            [30.00691007564185, -0.669248989695281],
            [30.008011171228297, -0.667323603419631],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 464,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "RUREHE",
        Population: 12151,
        Key: "MITOOMARUREHE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.979430073009777, 0.684317648865201],
            [29.97817064755784, 0.686195620511309],
            [29.978377096579813, 0.688528066632305],
            [29.978079835967463, 0.688886693998009],
            [29.977664083077563, 0.688736919731583],
            [29.976476684545105, 0.687570002516809],
            [29.9760605543628, 0.68801825649384],
            [29.97605991027074, 0.689034902609441],
            [29.974663890589955, 0.688974204241477],
            [29.97448525251089, 0.689631920160206],
            [29.97543538082396, 0.690230556282799],
            [29.975494521410706, 0.690649215366058],
            [29.97433571176217, 0.691246494104931],
            [29.97445402976654, 0.692024005688553],
            [29.973562834529382, 0.692172938191434],
            [29.972314743121387, 0.693039268541391],
            [29.972284694475142, 0.693577472705184],
            [29.973799068092916, 0.694355886646863],
            [29.973531278510073, 0.695073344372931],
            [29.971809041922093, 0.694205091243474],
            [29.97142915786317, 0.695295835300804],
            [29.970711134456575, 0.694307023680125],
            [29.971388808235545, 0.692873212733616],
            [29.970320428393418, 0.692585673146948],
            [29.970570764608592, 0.691008161450664],
            [29.969502589582337, 0.690397918238624],
            [29.96953916538746, 0.688891982896109],
            [29.968916725422027, 0.68749319220893],
            [29.967954815703987, 0.687815279718222],
            [29.96770580450387, 0.687313134276427],
            [29.967777451436, 0.686667770782619],
            [29.967243466779962, 0.686201297456738],
            [29.96767172781187, 0.684874896039432],
            [29.967137765613757, 0.684372569740535],
            [29.96653371865376, 0.682041539037196],
            [29.96475236303863, 0.682721667283847],
            [29.963719719975106, 0.682254880084325],
            [29.96354293601878, 0.680175120881082],
            [29.962047299461197, 0.679636329548187],
            [29.962387043199985, 0.6774493340391],
            [29.96213836617315, 0.676409354258618],
            [29.963314913955276, 0.674581445630669],
            [29.963315338858404, 0.673900180848046],
            [29.963102452509094, 0.672573377229383],
            [29.961251543934765, 0.670564282196129],
            [29.962055416638105, 0.666584779276001],
            [29.961842368592084, 0.665508969397923],
            [29.959921006048333, 0.662209032987734],
            [29.958943849224994, 0.658371855592916],
            [29.959157886316152, 0.657834149654015],
            [29.957841124992903, 0.656004691828959],
            [29.957734858786363, 0.655036520441526],
            [29.96079606125478, 0.654006702404011],
            [29.962678960633035, 0.654509968695359],
            [29.96459415624235, 0.652483672799577],
            [29.966809708956813, 0.650871325416254],
            [29.96928475890574, 0.653002599455074],
            [29.970747783923528, 0.649609298871284],
            [29.97202974541098, 0.652515608531856],
            [29.973046019373395, 0.652424888164105],
            [29.97257315878422, 0.654160047406708],
            [29.974134540342504, 0.656957685193516],
            [29.97305173086194, 0.657996592974917],
            [29.97277772134409, 0.660974088112412],
            [29.971942323164182, 0.662033107890367],
            [29.971814772275277, 0.662891618030678],
            [29.97203226518537, 0.663330181213323],
            [29.973756077418358, 0.663550462098792],
            [29.974173120289016, 0.664098757844608],
            [29.973282706586136, 0.666089405373515],
            [29.974589054638592, 0.666455574348425],
            [29.97422516508329, 0.668008119001824],
            [29.97545736259897, 0.670913484621536],
            [29.97540242522944, 0.671717238371581],
            [29.97451292331658, 0.672209915148917],
            [29.975274695575816, 0.672849768892329],
            [29.974893046327363, 0.673762925070251],
            [29.975509643650177, 0.674402689682794],
            [29.97645313520993, 0.674640765361694],
            [29.976180046465274, 0.676065491441298],
            [29.977141844792204, 0.676047830893975],
            [29.977994272334957, 0.676815621355524],
            [29.977086266025555, 0.677874590104947],
            [29.97748500931557, 0.678660363287526],
            [29.97695765332801, 0.680413752294315],
            [29.977610050311515, 0.681839065927678],
            [29.979405832870132, 0.683064160692121],
            [29.979430073009777, 0.684317648865201],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 465,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "401205",
        Population: 4582,
        Key: "BUNDIBUGYO401205",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.065332618303998, 0.52521767785791],
            [30.05978694794922, 0.530882956334906],
            [30.055439663421133, 0.534179889731824],
            [30.05401455179991, 0.534788799726908],
            [30.051555101994243, 0.538194196915025],
            [30.04945268580159, 0.539878532700189],
            [30.04970169610342, 0.540559972468916],
            [30.04873932015975, 0.541850414872166],
            [30.04870320968196, 0.542854442933197],
            [30.045905833429334, 0.545273521181259],
            [30.045584703681566, 0.546384982296459],
            [30.04405206192419, 0.548356442847807],
            [30.043916045312073, 0.549132150128552],
            [30.045198246649683, 0.549390975207853],
            [30.044342465695966, 0.551197821620863],
            [30.043216396046276, 0.552143922946926],
            [30.041649079318933, 0.552200506995535],
            [30.041306911925542, 0.552630637191723],
            [30.042274004922735, 0.556188295027668],
            [30.040962173553794, 0.558195706588856],
            [30.039135434152175, 0.564104251880262],
            [30.0378032262976, 0.567031237289739],
            [30.03564242050982, 0.568491515426109],
            [30.03175180174293, 0.570268060872829],
            [30.028417571615268, 0.570667928795655],
            [30.027989940302355, 0.571040630290931],
            [30.028017723397447, 0.572417595521991],
            [30.029099527663195, 0.57442621862891],
            [30.026648358527808, 0.575428953903087],
            [30.025822262402638, 0.574883476736581],
            [30.024568193604765, 0.575370483713226],
            [30.022188869929163, 0.57522579487279],
            [30.017485400695982, 0.578436164282536],
            [30.016572861487653, 0.579726556127052],
            [30.01295303088002, 0.581417104088972],
            [30.01223947210037, 0.583625550172907],
            [30.012794128787714, 0.585519129875475],
            [30.012451938936433, 0.585977921328905],
            [30.010742375780474, 0.585661452413726],
            [30.009231594525524, 0.586635960312245],
            [30.008263039969357, 0.586090402484827],
            [30.008006091255382, 0.587008214318868],
            [30.007435937731074, 0.587466881689223],
            [30.00697941210705, 0.588585384311783],
            [30.00857514164852, 0.588614937325119],
            [30.008802612146443, 0.589533011936678],
            [30.007946514985743, 0.591827424394684],
            [30.0072625619829, 0.591941794488769],
            [30.00612340926945, 0.590707676526388],
            [30.00404300000463, 0.591165516287922],
            [30.00310283939795, 0.590820772900215],
            [30.001449710204778, 0.591565699820412],
            [29.99872866110689, 0.591105239845655],
            [29.998015396076354, 0.592739934608447],
            [29.99835674959611, 0.593830178485395],
            [29.998014354030623, 0.594661874889383],
            [29.997301928924873, 0.594747539908334],
            [29.995649691758786, 0.593857375316393],
            [29.995022751233794, 0.593943087057694],
            [29.99462299284752, 0.595463204361708],
            [29.99305505897757, 0.596753188951682],
            [29.99548791415924, 0.603094057917787],
            [29.995231046293636, 0.603839741310325],
            [29.993521003437323, 0.604441182059391],
            [29.992763429005393, 0.608858333385384],
            [29.991279389698175, 0.61295952307049],
            [29.991278680927394, 0.614221686970907],
            [29.990736885419988, 0.614909828756058],
            [29.98892689780178, 0.6158841023811],
            [29.987728855131543, 0.618092194116354],
            [29.98655992416471, 0.619210252989146],
            [29.985047940065613, 0.622278717009706],
            [29.98325218176152, 0.623281663604644],
            [29.98236903453096, 0.622936926755678],
            [29.98171416089219, 0.622047303975286],
            [29.981087124247473, 0.62230510975264],
            [29.980716148781234, 0.623251507148247],
            [29.981043462531414, 0.62391145670623],
            [29.980358795367945, 0.625287950558149],
            [29.97966305646858, 0.624857266349786],
            [29.979544733972624, 0.624001416748979],
            [29.978713494094144, 0.623223495741678],
            [29.979040947083213, 0.621967824824357],
            [29.978343402570154, 0.621130179840307],
            [29.978760506526246, 0.618917713032256],
            [29.979119238853475, 0.618006057878733],
            [29.978549103295478, 0.616633077933167],
            [29.979110785706656, 0.615452535312614],
            [29.978975797665548, 0.613655488895475],
            [29.97970712332486, 0.613108259397923],
            [29.979079167703585, 0.611225361494612],
            [29.980372435387206, 0.609018391552564],
            [29.980134861537298, 0.608248126063907],
            [29.98083290012377, 0.606417322236276],
            [29.980171092389334, 0.60424347027084],
            [29.98047770715873, 0.603148345492464],
            [29.97886506323878, 0.598817601840373],
            [29.97906965095147, 0.597756648722743],
            [29.980719953146444, 0.595447174791165],
            [29.98254664673398, 0.596997008133612],
            [29.985240495743383, 0.600826649333602],
            [29.985570819748105, 0.600464290656838],
            [29.98589427074253, 0.59966010902093],
            [29.98565824468986, 0.596048903908087],
            [29.988398178171625, 0.590796382242059],
            [29.988569946833756, 0.587527675573285],
            [29.989454404706287, 0.586723792976026],
            [29.99067990797646, 0.583986192460865],
            [29.990408860204106, 0.582189058477476],
            [29.993605083052987, 0.581951186085907],
            [29.994746116838662, 0.578186669023571],
            [29.994831905948303, 0.576697776278145],
            [29.995886480481133, 0.575671484097832],
            [29.995700032448966, 0.574610301125374],
            [29.99432367239822, 0.573308887242918],
            [29.993916985306132, 0.570775765297161],
            [29.99617979120118, 0.567439682130545],
            [29.99629962825671, 0.565831004790948],
            [29.99665687836377, 0.565369106391816],
            [29.997285880522327, 0.565403664694798],
            [29.99801568982544, 0.567748704492472],
            [30.00003819997524, 0.568827970030338],
            [30.00099038363371, 0.56853752666649],
            [30.00138066928529, 0.569941107363333],
            [30.0017885762895, 0.570146695505188],
            [30.003335689007788, 0.57004482440843],
            [30.004424165959477, 0.569206792462973],
            [30.004424911561166, 0.567769185075389],
            [30.003235503497432, 0.566536325716932],
            [30.002879072653926, 0.56540659036522],
            [30.005379137090234, 0.563525313016298],
            [30.00740420474364, 0.559641389114168],
            [30.006334294172294, 0.557415961858729],
            [30.006912542415613, 0.556971284481787],
            [30.009139641176436, 0.556955314987235],
            [30.009683915135696, 0.556459274330314],
            [30.010754865956184, 0.556648084108484],
            [30.012422035817252, 0.554475396038486],
            [30.012964497874602, 0.547067457939714],
            [30.014199183723612, 0.545399687441219],
            [30.01598200988089, 0.541628350480748],
            [30.018054580446535, 0.530487605872603],
            [30.018008323497597, 0.528908407244522],
            [30.0189986972337, 0.528578997378801],
            [30.021028630162718, 0.529347342205157],
            [30.021741118150523, 0.529139713570146],
            [30.021684983326736, 0.52768186286534],
            [30.020266734834276, 0.522291857868915],
            [30.0214834444961, 0.520380022052488],
            [30.021845004719857, 0.519070185832352],
            [30.02139933523606, 0.517453977042548],
            [30.023479872959967, 0.516670872040215],
            [30.023812508329886, 0.516269420470306],
            [30.023727517822532, 0.515207984488597],
            [30.02335018767396, 0.514703404105761],
            [30.02098779095327, 0.513949271860667],
            [30.019991119128687, 0.512514485456034],
            [30.019599996247244, 0.511032178843571],
            [30.017766438632616, 0.509238427509371],
            [30.01739562935471, 0.508028527142546],
            [30.017199113903132, 0.503626422004073],
            [30.01568640845687, 0.501205325429382],
            [30.016464898363555, 0.499430727228037],
            [30.016401263505433, 0.495743327859667],
            [30.016973971838425, 0.489480435118304],
            [30.018070508474835, 0.482547238367774],
            [30.032555114795883, 0.489720462486828],
            [30.037796744054518, 0.493279957931248],
            [30.038608095232625, 0.495030222434938],
            [30.038867996708927, 0.49838823593165],
            [30.04228998056175, 0.504472763048685],
            [30.043201481317634, 0.507459835050246],
            [30.048447877935498, 0.512976112991542],
            [30.050044114126766, 0.515733794754863],
            [30.051374893660018, 0.520209605195041],
            [30.05460597653183, 0.521020068616826],
            [30.060144778367935, 0.521370978268632],
            [30.062136509541148, 0.522402109810047],
            [30.065332618303998, 0.52521767785791],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 466,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "401109",
        Population: 3291,
        Key: "BUNDIBUGYO401109",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.033365611676114, 0.859876782576139],
            [30.031660582317407, 0.859234929489173],
            [30.028108991332022, 0.863235898018107],
            [30.02748398128656, 0.864648495404507],
            [30.02545579288587, 0.865274927958818],
            [30.023506824215122, 0.864331326501981],
            [30.02327457557817, 0.862133010453012],
            [30.024992025942318, 0.859936230877358],
            [30.02733289184231, 0.858367972974552],
            [30.027879965850325, 0.856876806411546],
            [30.02764709378259, 0.855463533385586],
            [30.027049259571125, 0.855321440236081],
            [30.02856127421295, 0.847133890180014],
            [30.028432149475698, 0.845185499616837],
            [30.028789626856486, 0.843536303582007],
            [30.028494468301908, 0.841312873145445],
            [30.028935935466812, 0.838504328098168],
            [30.028203008111344, 0.834188841994542],
            [30.0284890541557, 0.832766688095131],
            [30.026815960803635, 0.831259374273106],
            [30.025010990276307, 0.831437290241054],
            [30.023889129233723, 0.831086787441015],
            [30.022922424308707, 0.829786235391431],
            [30.022733581368012, 0.828268105846854],
            [30.021772398387025, 0.827466550034554],
            [30.021440574195815, 0.826605709625555],
            [30.021537396413773, 0.824155494536186],
            [30.02226303663566, 0.822363148017169],
            [30.023546052745235, 0.821503525393257],
            [30.02511315567357, 0.821839379023943],
            [30.02557664413936, 0.821289905514613],
            [30.025600986686904, 0.820489094721043],
            [30.02528068518583, 0.820094416335694],
            [30.025376330610754, 0.819209990579708],
            [30.024450275350667, 0.819065864334722],
            [30.024011818440265, 0.817882222063414],
            [30.024939250817706, 0.816161734260418],
            [30.023858703295062, 0.816196782966477],
            [30.0231350169089, 0.815359557142114],
            [30.02285149782545, 0.813387159336645],
            [30.022079980641994, 0.813004100588807],
            [30.021534436464904, 0.812119198112713],
            [30.02200967758955, 0.811725116225797],
            [30.02192750060567, 0.810446123374251],
            [30.02019467108385, 0.809428863199387],
            [30.02099056495087, 0.808951349352791],
            [30.021715758710062, 0.807732719109775],
            [30.021266038722626, 0.805700440915627],
            [30.022121866388755, 0.804446045903116],
            [30.02183792060555, 0.803035427265834],
            [30.022633386874446, 0.803143586376913],
            [30.022871115234626, 0.8027971348072],
            [30.022468273830317, 0.801601574592689],
            [30.02257621180159, 0.800119526112626],
            [30.022093043044556, 0.800148815521163],
            [30.02159977902034, 0.799201804978852],
            [30.022283902703066, 0.798934567799863],
            [30.021838897972554, 0.796926198770003],
            [30.021896753968452, 0.795730979071572],
            [30.022476944369433, 0.794689131610688],
            [30.021783474614466, 0.794746000277062],
            [30.021973922844612, 0.79409591516799],
            [30.0212997201559, 0.793779875076045],
            [30.021642013313446, 0.793321143173738],
            [30.02094894420712, 0.792823409207037],
            [30.020645949648294, 0.791465372537187],
            [30.021092977384836, 0.790662480070422],
            [30.019991641948195, 0.789896714884008],
            [30.020210856928653, 0.788864167129155],
            [30.02091437613668, 0.788032775108414],
            [30.019215218166632, 0.786405991654776],
            [30.02010671613608, 0.783684255726213],
            [30.02098564218311, 0.783302404128766],
            [30.02117646860397, 0.782107279319382],
            [30.021913442869796, 0.780972307857881],
            [30.020786292546827, 0.77976428646731],
            [30.02098847457119, 0.779298278241956],
            [30.021807887230654, 0.779119574943359],
            [30.02208222104032, 0.777362733833423],
            [30.02331762643987, 0.776598645910977],
            [30.02343725328961, 0.775331749482135],
            [30.024149501427267, 0.775583261910838],
            [30.025171739304813, 0.774018189453759],
            [30.025943701154326, 0.773779683351339],
            [30.026149972309877, 0.770853814704001],
            [30.02841100133726, 0.77047292305721],
            [30.030310380309412, 0.771086241723383],
            [30.030785637603707, 0.770646716973377],
            [30.03087106020073, 0.769644837399897],
            [30.0322209612731, 0.771007511518247],
            [30.032859882629047, 0.770196255279362],
            [30.033340587307276, 0.771033025853574],
            [30.033863104070367, 0.770974000205857],
            [30.034121620344514, 0.770277135871936],
            [30.033179655920726, 0.768646654724077],
            [30.03359788726251, 0.767459470663321],
            [30.033870187286382, 0.767350048609175],
            [30.03468603632909, 0.768538098598389],
            [30.03484983783297, 0.767862264233688],
            [30.035339790667013, 0.767935683235697],
            [30.035630869971904, 0.766912828345036],
            [30.036992041307858, 0.766840705478319],
            [30.037065087815172, 0.766183075373566],
            [30.038735347880827, 0.765289062018404],
            [30.03853601800748, 0.764850469040497],
            [30.039026576306036, 0.764046975980668],
            [30.04018755269104, 0.764796812957759],
            [30.041132246196643, 0.763372489159265],
            [30.041496327093093, 0.761746799269303],
            [30.04247697566795, 0.760815759700299],
            [30.043220883131145, 0.761072041718491],
            [30.043675329155253, 0.759994483504339],
            [30.04461906865003, 0.759958598067403],
            [30.045091413606205, 0.759246430487043],
            [30.045799126149983, 0.759356534508774],
            [30.047215386670732, 0.758352711211675],
            [30.04824993236601, 0.758225540668517],
            [30.048722773192218, 0.756782605028197],
            [30.049176570632717, 0.756655032927041],
            [30.049575514247024, 0.757130305342021],
            [30.050030427395086, 0.755358509433596],
            [30.05079288506891, 0.755030187549135],
            [30.051101977391866, 0.754190018526447],
            [30.052517521057034, 0.754245794581227],
            [30.05224673649104, 0.752108113782042],
            [30.05319058019038, 0.751926066108593],
            [30.053227443456375, 0.751085706959344],
            [30.051994022435313, 0.750080060126091],
            [30.053355293484245, 0.749880026043538],
            [30.05348263955724, 0.749423383201377],
            [30.052956824180402, 0.748692256571452],
            [30.053247333953404, 0.748491493055764],
            [30.05375522255043, 0.748893761124747],
            [30.05382799956318, 0.748619771411217],
            [30.05332040561357, 0.747779043349401],
            [30.0546094610968, 0.747012609367758],
            [30.05566339153761, 0.745040245092862],
            [30.056805677574804, 0.738259635030597],
            [30.058885158879928, 0.739139577595766],
            [30.067624276289322, 0.739432297110199],
            [30.07091303369732, 0.740797459843341],
            [30.073245308109936, 0.745094461022467],
            [30.073278121770613, 0.74627826664033],
            [30.074770213576077, 0.750381514280924],
            [30.078615279673215, 0.755898375119702],
            [30.078979956152676, 0.761197845960899],
            [30.080095004372144, 0.765515678657549],
            [30.076662985439278, 0.768075377576382],
            [30.074038709152013, 0.771612595997934],
            [30.072680844514604, 0.774880756530958],
            [30.073065780698705, 0.77833008263214],
            [30.07483333998771, 0.785769298760092],
            [30.074832186550903, 0.787418849011137],
            [30.07331114204382, 0.789637163257127],
            [30.070762036779538, 0.792094670335501],
            [30.06971327344826, 0.795974414298931],
            [30.06638900563711, 0.803634048845815],
            [30.06377887961219, 0.808104667301401],
            [30.06210708971561, 0.81263016597347],
            [30.057799383162305, 0.816141741587319],
            [30.056396732118117, 0.819465704013149],
            [30.05432348601938, 0.822879508401312],
            [30.051580456943118, 0.825669362692019],
            [30.05014848219311, 0.828216236254019],
            [30.049683659729126, 0.832236580834815],
            [30.048668867088626, 0.834639192448608],
            [30.045879290009296, 0.839796195979685],
            [30.044983424430963, 0.842551256596259],
            [30.04053811394244, 0.850589168134621],
            [30.036466861938237, 0.856341406564212],
            [30.033365611676114, 0.859876782576139],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 467,
        District: "BUNDIBUGYO",
        County: "BWAMBA",
        Subcounty: "BUBUKWANGA",
        Population: 11340,
        Key: "BUNDIBUGYOBUBUKWANGA",
        Dist2: "Bundibugyo",
        "Sub Country": "Bubukwanga",
        id2_original: "Bundibugyo Bubukwanga",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.19706662009917, 0.876301865006366],
            [30.186137235753918, 0.885315689197612],
            [30.183205129276647, 0.886857216882315],
            [30.17666101382294, 0.887709827843914],
            [30.171497863184136, 0.887671534564785],
            [30.157038113247015, 0.885579684210218],
            [30.157011047007497, 0.884686947103562],
            [30.15784581546841, 0.884087711945452],
            [30.157310502204094, 0.882737567131331],
            [30.157698432473016, 0.881988016410375],
            [30.157401354218646, 0.880818020153681],
            [30.158325374794643, 0.880398815148405],
            [30.159041317703025, 0.879319579768899],
            [30.15910152638665, 0.878509786335403],
            [30.157195668764704, 0.877008620753438],
            [30.157794708515276, 0.872899896744641],
            [30.159106308118897, 0.872181041318944],
            [30.158855334998183, 0.869121455161055],
            [30.15781539222468, 0.865191446259395],
            [30.157935608369282, 0.863811810804614],
            [30.158427857297173, 0.863002343682608],
            [30.158071123721452, 0.861892294592426],
            [30.15866779281802, 0.86090293997618],
            [30.15866846116456, 0.860003118186748],
            [30.157747344841912, 0.856523117241155],
            [30.15959975450109, 0.851131496724286],
            [30.16083549766718, 0.850176088318608],
            [30.160552239993482, 0.847785056203413],
            [30.16093277712759, 0.847068091285932],
            [30.160626196494185, 0.844079337361786],
            [30.16086433089285, 0.843218816764793],
            [30.162528864198574, 0.840494501745336],
            [30.16300398315232, 0.840351401143278],
            [30.163099713917205, 0.839347324586067],
            [30.164669337518227, 0.836479478571818],
            [30.165241009195363, 0.83418469760709],
            [30.16547985505973, 0.832320022825649],
            [30.16405696497216, 0.829306543988464],
            [30.164608441623418, 0.828976109059038],
            [30.165708243635876, 0.82831728077477],
            [30.16696055083748, 0.83003561029794],
            [30.16755852967772, 0.831424645089976],
            [30.16800938783062, 0.835481148730597],
            [30.168751804090427, 0.837930013956781],
            [30.170149569197775, 0.837711781710781],
            [30.171148386199263, 0.836981665905584],
            [30.173089532340526, 0.838353417408016],
            [30.174252537121408, 0.836472335031684],
            [30.17520505495316, 0.836745333585873],
            [30.175703631613942, 0.837825459441739],
            [30.17584743033135, 0.839780581344171],
            [30.176899297341922, 0.841005520746571],
            [30.177134110668987, 0.842595287250112],
            [30.17829517329224, 0.843418342415895],
            [30.18005697258366, 0.841811762499227],
            [30.180837475614908, 0.841794062208837],
            [30.182034778971666, 0.842708501358409],
            [30.188371068286077, 0.840502291097282],
            [30.188952348343506, 0.839881486344098],
            [30.189714443097934, 0.840229196695692],
            [30.190168757069728, 0.83948039930594],
            [30.191801896052894, 0.840121084397762],
            [30.19414324524649, 0.840323771038864],
            [30.198517951746943, 0.839943242477056],
            [30.200479637867172, 0.838044419238923],
            [30.20076934185134, 0.83904956501114],
            [30.201713114583786, 0.839178148646479],
            [30.20282119996148, 0.837973023387457],
            [30.2038920474757, 0.838083425305429],
            [30.205987095686385, 0.836197276840958],
            [30.205449694737318, 0.838067329217609],
            [30.206334072659804, 0.838919834345913],
            [30.205620235402453, 0.842793567104649],
            [30.20365901550785, 0.842942180879573],
            [30.200950679367857, 0.843848757658696],
            [30.198905739183733, 0.84705107725736],
            [30.200471307789517, 0.849873488186583],
            [30.20215001740874, 0.85112931316079],
            [30.20315758130613, 0.855407119185741],
            [30.201634964747324, 0.858848903023358],
            [30.202060537121593, 0.861527033300619],
            [30.200871793811178, 0.863104148084551],
            [30.200347569350733, 0.865399025043852],
            [30.199016240048522, 0.867071663112281],
            [30.198515718535123, 0.869420363015206],
            [30.195182181008555, 0.872057098050759],
            [30.196225403531166, 0.874544413902104],
            [30.196985031511826, 0.875118802497352],
            [30.19706662009917, 0.876301865006366],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 468,
        District: "BUNDIBUGYO",
        County: "BUGHENDERA",
        Subcounty: "NTANDI TOWN COUNCIL",
        Population: 5435,
        Key: "BUNDIBUGYONTANDI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.186985965830985, 0.716491315899281],
            [30.189407977448887, 0.717401350321606],
            [30.190262394760012, 0.718406051467991],
            [30.189929246452046, 0.719410014934782],
            [30.191256787558693, 0.72347534185145],
            [30.19115516564218, 0.724344865893768],
            [30.191739561955334, 0.725113600579302],
            [30.191801075891046, 0.726655579636871],
            [30.193123775078302, 0.728808555408851],
            [30.19322992360556, 0.729626850760006],
            [30.19441085696288, 0.731152090429848],
            [30.197877055894008, 0.733449537243543],
            [30.2012239468773, 0.736631557270578],
            [30.20492616377626, 0.741320109855421],
            [30.2052633131805, 0.742359682517038],
            [30.210062877894554, 0.745979043429636],
            [30.211987308185027, 0.748452270567466],
            [30.218474758808924, 0.752802690547025],
            [30.221043659348812, 0.751543842499533],
            [30.225611382362807, 0.750105853937219],
            [30.24186871328573, 0.748984090687128],
            [30.244459440192102, 0.748128045030468],
            [30.245242798967624, 0.748220570802247],
            [30.244152644861316, 0.747309507865903],
            [30.24309456240729, 0.745273013930457],
            [30.24280625979496, 0.744351879322587],
            [30.24319250033281, 0.742655627397958],
            [30.24391557406795, 0.741347337309101],
            [30.245890673832005, 0.739942907269298],
            [30.248059543796103, 0.736599715523752],
            [30.254941271286413, 0.742953853788067],
            [30.258020913472677, 0.746300357034098],
            [30.269791019414253, 0.761078435362592],
            [30.28066891502237, 0.766385252789694],
            [30.278371368580377, 0.774766776134301],
            [30.27764601402274, 0.779565127748098],
            [30.274510823612555, 0.787658051366653],
            [30.27248842126061, 0.787608227424246],
            [30.267994423880296, 0.783032723634626],
            [30.266107750679563, 0.783071143685902],
            [30.265017946916227, 0.782166508710176],
            [30.264311962731064, 0.782876269687345],
            [30.261297553505795, 0.782680589067902],
            [30.260272701530763, 0.78054925321722],
            [30.25886097840051, 0.781581360197571],
            [30.257032941831618, 0.781677007501422],
            [30.25395343978253, 0.782966267984361],
            [30.25260666844059, 0.782771692193766],
            [30.25119469917197, 0.784191178791992],
            [30.25036098623151, 0.78406149666822],
            [30.249655106250913, 0.784577541224794],
            [30.248564952144612, 0.78425398490976],
            [30.247987152160604, 0.78509295336313],
            [30.246447840412248, 0.785091918601057],
            [30.245741855328752, 0.785801661117713],
            [30.2417010508228, 0.785928097879746],
            [30.238109685131565, 0.785409176456334],
            [30.236827655372167, 0.784310737847026],
            [30.234597762850804, 0.783521680357027],
            [30.23564710739207, 0.778381846866754],
            [30.23244689512501, 0.773130657597442],
            [30.229280087610082, 0.77121603383029],
            [30.22824039277161, 0.769251129637819],
            [30.22585592713932, 0.767396976881942],
            [30.223265936851508, 0.767189418189169],
            [30.222142095922056, 0.765919310464055],
            [30.219722644502713, 0.765471736995924],
            [30.21931419222113, 0.764682394851012],
            [30.21846233600686, 0.764407380349897],
            [30.216811576569395, 0.761078505424984],
            [30.21162138484393, 0.760455862533843],
            [30.2080606876365, 0.757345350425188],
            [30.207538155602023, 0.757344999214607],
            [30.204550029285326, 0.760312636080634],
            [30.20458536541535, 0.760814718644685],
            [30.20004066173055, 0.760921314116366],
            [30.197673425785393, 0.761737516001358],
            [30.196163273351146, 0.762716926261697],
            [30.19387769246872, 0.762227229692604],
            [30.192571591452964, 0.762512875851334],
            [30.18951051205372, 0.765247195277705],
            [30.18906156461745, 0.7673693283192],
            [30.186770124024388, 0.771007861829496],
            [30.182471615321305, 0.767642746467254],
            [30.17966234447597, 0.764175962584101],
            [30.177516038395204, 0.763111044219672],
            [30.175369310106234, 0.762697960913262],
            [30.17448366286425, 0.76204554712778],
            [30.174245714416852, 0.761119136233515],
            [30.175151258444046, 0.757380385253536],
            [30.175111079496336, 0.754299256775634],
            [30.173030496856676, 0.752513816379765],
            [30.169695922674254, 0.748522393362847],
            [30.168356836419573, 0.745822026732859],
            [30.1667216573624, 0.743864497249589],
            [30.168102465870437, 0.741558493787637],
            [30.16813309931996, 0.739748504693984],
            [30.16677931033902, 0.736424365393973],
            [30.167119372081384, 0.734703601922489],
            [30.16691349618459, 0.733991341323455],
            [30.164393861949815, 0.732604523487031],
            [30.166313975835333, 0.731574772622099],
            [30.16770850521103, 0.732520488469811],
            [30.16884508514953, 0.73198296433498],
            [30.1701666255101, 0.732325787354607],
            [30.17189721643022, 0.731440036311352],
            [30.176703448440332, 0.725217319839022],
            [30.17818584472893, 0.724615742889765],
            [30.179911416761563, 0.722579817076119],
            [30.181850198536996, 0.721376047101366],
            [30.183503449901046, 0.721032784907613],
            [30.18478663669054, 0.719943365524405],
            [30.18606912279413, 0.720030224855727],
            [30.186268891943623, 0.719599997229848],
            [30.185813769488103, 0.718165174577803],
            [30.186242012553706, 0.716931754168246],
            [30.186985965830985, 0.716491315899281],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 469,
        District: "NTOROKO",
        County: "NTOROKO",
        Subcounty: "NOMBE",
        Population: 8216,
        Key: "NTOROKONOMBE",
        Dist2: "Ntoroko",
        "Sub Country": "Nombe",
        id2_original: "Ntoroko Nombe",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.336734613450623, -0.671215026582184],
            [30.33422940975259, -0.66801143984771],
            [30.33226483015881, -0.661538558130189],
            [30.333908461464507, -0.654737428837919],
            [30.336272358371716, -0.650446146073739],
            [30.322394550550374, -0.652869898158682],
            [30.322375411044916, -0.653369701783675],
            [30.31948750347627, -0.653838099606783],
            [30.314195015199502, -0.653582216780639],
            [30.311883944620867, -0.652424200099205],
            [30.309468657791175, -0.652061413826986],
            [30.302808337170642, -0.651723459848169],
            [30.294594893204238, -0.652613722451448],
            [30.292905594244434, -0.652404954941945],
            [30.291292511048333, -0.656832292214773],
            [30.28577396622187, -0.668023936360526],
            [30.291126805116075, -0.673898071749654],
            [30.29197799118711, -0.676804161448739],
            [30.291517076394605, -0.679907626821726],
            [30.292500147725804, -0.681559098837132],
            [30.292433149575277, -0.684068456905526],
            [30.294062742908, -0.686086492013004],
            [30.296204201679533, -0.68791450406662],
            [30.297634369917517, -0.687451443316595],
            [30.298920452875482, -0.68767239410187],
            [30.299639523717694, -0.688806185614571],
            [30.299610396742906, -0.689918031707951],
            [30.301922198550173, -0.687465115589313],
            [30.302863052656278, -0.687025684178819],
            [30.30508653030817, -0.686634801386161],
            [30.30915086977628, -0.686884079444352],
            [30.313096486099795, -0.681689318388433],
            [30.319328280685436, -0.675752295848817],
            [30.31980807716687, -0.678123927901735],
            [30.322189272931514, -0.680428388411431],
            [30.321018597436417, -0.681785128608972],
            [30.318298642486532, -0.682202058398789],
            [30.31686098499405, -0.68328922207823],
            [30.31610602645623, -0.688297229742038],
            [30.314773116119134, -0.693198298235446],
            [30.314671811307893, -0.695938477723921],
            [30.313360289857716, -0.696568987411677],
            [30.31092846055207, -0.695958944327774],
            [30.31052888721873, -0.69688647257575],
            [30.310004908896655, -0.699382504225587],
            [30.309485329624536, -0.710766176861244],
            [30.308792232670434, -0.71395933397916],
            [30.311701256936484, -0.716239724640813],
            [30.313928768922338, -0.717102123388406],
            [30.321298052541508, -0.715862616183216],
            [30.325431601812358, -0.714536538444005],
            [30.329701442579804, -0.713786085765221],
            [30.329995135982188, -0.7089186341388],
            [30.32955934886479, -0.704592293314126],
            [30.32995958605312, -0.702507431083297],
            [30.329248531776503, -0.699771534676269],
            [30.327948341675285, -0.697121388893638],
            [30.328709740235393, -0.694816744216627],
            [30.328635348950097, -0.69191861673759],
            [30.32906387229006, -0.690187658552517],
            [30.329083760990464, -0.688590374670662],
            [30.328524059364486, -0.687011894233949],
            [30.3286199338598, -0.685452913406797],
            [30.329047899346, -0.684716674493591],
            [30.32880251374637, -0.681722805211842],
            [30.329061404617963, -0.679616444941708],
            [30.33283589457481, -0.677447071341084],
            [30.332945719008187, -0.676265608675811],
            [30.33488277152671, -0.672931704866756],
            [30.336734613450623, -0.671215026582184],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 470,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "SHUUKU",
        Population: 5405,
        Key: "SHEEMASHUUKU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.123885015195842, 0.80869258397951],
            [31.121962164143664, 0.811666586079144],
            [31.121206080016815, 0.815269315237833],
            [31.121365599251693, 0.820373231115279],
            [31.120148860843763, 0.82629024513503],
            [31.120638959204907, 0.829628649685904],
            [31.119619285119143, 0.83087050754752],
            [31.11746306882413, 0.835190945585618],
            [31.118286598462554, 0.839578280909012],
            [31.118311802494485, 0.841033163421232],
            [31.1176959301121, 0.842465193822571],
            [31.116426279137297, 0.843039598017079],
            [31.110539069311507, 0.843978943556431],
            [31.104235528979075, 0.844060282569205],
            [31.096083507320216, 0.847555153976132],
            [31.091620816227586, 0.84842068745779],
            [31.088501363402884, 0.851096795040638],
            [31.08752939614694, 0.852577044238036],
            [31.085884140687227, 0.857468985029531],
            [31.07915180213032, 0.868116730426405],
            [31.07810817087427, 0.869167756189618],
            [31.077501628394433, 0.86848481506273],
            [31.076218199958124, 0.866642482821314],
            [31.074982605912382, 0.865618799749907],
            [31.071443217641804, 0.863763875860787],
            [31.068425484649964, 0.861216492057516],
            [31.06538590373213, 0.855783243177289],
            [31.065123407921277, 0.854424168964369],
            [31.062841281959425, 0.851470219416125],
            [31.062388708922665, 0.849968339843794],
            [31.06146191075581, 0.84908729899815],
            [31.06033088150745, 0.848965101112788],
            [31.057928099226515, 0.844698133031579],
            [31.05536216851696, 0.843022166299459],
            [31.053129518167676, 0.840245873922107],
            [31.05122876387487, 0.839144421423587],
            [31.048329715400058, 0.838281705389014],
            [31.044574780868626, 0.838040574860777],
            [31.043007002407244, 0.836460819857006],
            [31.040821949293303, 0.833588878543799],
            [31.040110223975162, 0.831052614631204],
            [31.04039648022527, 0.828899628212509],
            [31.038877035617748, 0.82569310090324],
            [31.039352849867548, 0.824688545453718],
            [31.041825122225585, 0.823445744320385],
            [31.043205047689707, 0.820384194827697],
            [31.04320563069636, 0.819188011051471],
            [31.039881485056043, 0.812822678027719],
            [31.04012225780671, 0.80636340924224],
            [31.038697453409302, 0.803970352177613],
            [31.038177510319485, 0.801616033358605],
            [31.038461647443842, 0.800094609276323],
            [31.041413612078784, 0.789521769447229],
            [31.042840031647078, 0.788517653280411],
            [31.048686611570854, 0.788137646191671],
            [31.04678547549405, 0.787849660973131],
            [31.045882551852518, 0.787466453428358],
            [31.04541201251008, 0.786545923415668],
            [31.044017408574184, 0.786448811208873],
            [31.04173629950525, 0.785574516506724],
            [31.041689281683265, 0.784474004823506],
            [31.039362999033617, 0.778539839653275],
            [31.042121107230226, 0.775765987646225],
            [31.0432636672536, 0.771843034286262],
            [31.044880548526727, 0.77007342984542],
            [31.044453224437657, 0.769068435060515],
            [31.045023864848858, 0.768494529735126],
            [31.04549994230504, 0.76682008919251],
            [31.040153773401816, 0.764377405338331],
            [31.039346492490285, 0.762726301147582],
            [31.03863336130872, 0.763084827416886],
            [31.035472462013434, 0.763250834828774],
            [31.033380677382166, 0.764158964377611],
            [31.03193170111709, 0.762579339905709],
            [31.029032331943746, 0.762530151619185],
            [31.028391024662405, 0.76174037957738],
            [31.026347481358535, 0.761117424195649],
            [31.023781701565962, 0.759178439379378],
            [31.021260714468358, 0.759394061926807],
            [31.021724026864348, 0.755996119484218],
            [31.022957535920327, 0.755016320561868],
            [31.024761806660045, 0.754989611475972],
            [31.025922691416874, 0.75265048056519],
            [31.027323148775157, 0.752409759121611],
            [31.030433636413324, 0.752834120783915],
            [31.032415500491453, 0.752353974060934],
            [31.035191526484738, 0.750751610878115],
            [31.037803370986797, 0.751081359486926],
            [31.041696042404087, 0.750264260953571],
            [31.043630016396122, 0.74937872637879],
            [31.05140633834864, 0.747209536572745],
            [31.055664888191306, 0.747171978509679],
            [31.05691603656619, 0.744307674262953],
            [31.06031384046651, 0.74343141999857],
            [31.062454438651987, 0.742002998630938],
            [31.06305009534723, 0.741168300090987],
            [31.061617336367945, 0.739552827506959],
            [31.06131179239036, 0.738238412297197],
            [31.062649048776812, 0.730179821352143],
            [31.063435072853796, 0.729178342115242],
            [31.064309047386992, 0.726158682338974],
            [31.064269324783442, 0.722910080667333],
            [31.063370978058288, 0.721236074621582],
            [31.064813985916615, 0.718575955342529],
            [31.065033287135336, 0.716235600797572],
            [31.066482266095374, 0.711067436937778],
            [31.068813761668608, 0.709233318629117],
            [31.067599068724572, 0.705779106978561],
            [31.068177105863807, 0.702364657294201],
            [31.066873982763227, 0.701143605139816],
            [31.067291435265627, 0.70034433320151],
            [31.06902795596496, 0.699058279672087],
            [31.07623920616275, 0.696708763022384],
            [31.080943548558377, 0.693895444921628],
            [31.082007642538283, 0.696317956480152],
            [31.082867586285047, 0.699907827683267],
            [31.084445355809052, 0.703475122278905],
            [31.084809368433522, 0.70617985812229],
            [31.084654354249793, 0.71144407690407],
            [31.08590447405366, 0.716978907537176],
            [31.087844217026458, 0.720107512493761],
            [31.088901939256047, 0.722670460658392],
            [31.0899463044357, 0.726848106351137],
            [31.090817293867175, 0.728053900409091],
            [31.091842227588916, 0.728438332126162],
            [31.092086727449708, 0.729470766760176],
            [31.09271326193618, 0.729625016548931],
            [31.09336974355929, 0.729177398062316],
            [31.09574783025475, 0.730346969876119],
            [31.096418737024685, 0.733177935897804],
            [31.09804691640917, 0.735512849111717],
            [31.098224942735555, 0.736535583807137],
            [31.097499667229656, 0.737948070347451],
            [31.0975924515204, 0.73886551541738],
            [31.098012452543298, 0.741971697663075],
            [31.099352657200495, 0.746456651529597],
            [31.101631407293524, 0.750406948794987],
            [31.1021562084724, 0.752767354772131],
            [31.104341459215707, 0.753717888723093],
            [31.10522133478197, 0.75507598687174],
            [31.104771439623057, 0.756221556327946],
            [31.102861445259247, 0.757393318066962],
            [31.10190650287456, 0.75749275737061],
            [31.098375763583533, 0.756270113225643],
            [31.094224104276563, 0.752598724104076],
            [31.09188520928034, 0.751543586501685],
            [31.0906375436738, 0.7515654630883],
            [31.08925603717476, 0.751968550965888],
            [31.08784061568049, 0.753504222255113],
            [31.083762415207538, 0.755902170171476],
            [31.081990888958245, 0.755900250638776],
            [31.081136642327007, 0.756330928363413],
            [31.07871833536133, 0.759530777993362],
            [31.07477128263169, 0.761723354414203],
            [31.073652456098134, 0.762885503539995],
            [31.069374449644766, 0.762741313360645],
            [31.06822420004257, 0.764065350284221],
            [31.06236839621743, 0.767188960089452],
            [31.061171943565252, 0.769599750532053],
            [31.059657456759783, 0.774419927877887],
            [31.05606370514316, 0.777406901726851],
            [31.05552716567847, 0.779616316200774],
            [31.052456814767183, 0.781022089662376],
            [31.052313687989574, 0.782170366614834],
            [31.051005431915446, 0.78460998173776],
            [31.05119499081343, 0.785830185334914],
            [31.050205306085132, 0.78721020534173],
            [31.052525098406882, 0.78751744237734],
            [31.055269995978907, 0.786305993429513],
            [31.055492251756615, 0.787596032149951],
            [31.056828486758604, 0.78871802687916],
            [31.05665780954954, 0.789470337695433],
            [31.058976270568028, 0.793486512551082],
            [31.05977335290614, 0.793750419449837],
            [31.061721011833228, 0.795593868956683],
            [31.062528813767603, 0.796120580341568],
            [31.064572546616, 0.796456485475766],
            [31.066450219595918, 0.796146363992525],
            [31.07350757041924, 0.798772385553902],
            [31.077213754278482, 0.801692889284223],
            [31.079874054805288, 0.804971769000215],
            [31.08567194244743, 0.807390878524651],
            [31.08744397354995, 0.808774445584022],
            [31.08827931333938, 0.808744688261767],
            [31.090091363489467, 0.807684545451625],
            [31.089014354430724, 0.806047286560183],
            [31.088000540953892, 0.80330338365719],
            [31.090965344310845, 0.802818615010188],
            [31.09457766140945, 0.803436974261324],
            [31.096865826744956, 0.800788861083288],
            [31.097955790408445, 0.798664411362462],
            [31.097943284961353, 0.798044308828808],
            [31.096968397282414, 0.796614791058965],
            [31.092461195565765, 0.792898168829652],
            [31.090584437070827, 0.792463656686221],
            [31.08939657321107, 0.791458280116433],
            [31.089243144553777, 0.787984797033845],
            [31.0953037157547, 0.788925035694174],
            [31.096492240774488, 0.788494945122282],
            [31.099676920272, 0.788592112971718],
            [31.10290948805895, 0.787923715574465],
            [31.10557068151113, 0.789408262815464],
            [31.10742355020943, 0.791466631855058],
            [31.10814344480677, 0.791634214544019],
            [31.110024901490668, 0.794996150721158],
            [31.110808836086257, 0.795424228586137],
            [31.11396659666795, 0.795466935768575],
            [31.115034139280247, 0.794630456605237],
            [31.116862929535642, 0.795247691608196],
            [31.12122579803727, 0.801227444911876],
            [31.123854957566458, 0.806709081746896],
            [31.123885015195842, 0.80869258397951],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 471,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "BWAMIRAMIRA",
        Population: 10417,
        Key: "KIBAALEBWAMIRAMIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19334630310599, 0.855838802270837],
            [31.19188529211103, 0.85813918696191],
            [31.19048509256925, 0.858809239673299],
            [31.190271979844507, 0.85938202644498],
            [31.189417039713874, 0.859216400226896],
            [31.187841946271124, 0.863035206615598],
            [31.186537010370273, 0.863991331282192],
            [31.185136426349562, 0.864279743921369],
            [31.18463860427361, 0.865067640188524],
            [31.1841665395918, 0.867859070171628],
            [31.183431639535968, 0.869005116953005],
            [31.18461034956297, 0.872390276918992],
            [31.182879455910598, 0.874778178603535],
            [31.18157384268003, 0.875066432333561],
            [31.180980776726084, 0.875592098324748],
            [31.180386805270334, 0.875211390034941],
            [31.179318606887893, 0.875475422589595],
            [31.177513593241404, 0.874977335238505],
            [31.175638592749486, 0.875719657671183],
            [31.174878561425256, 0.875482317252794],
            [31.172659066005004, 0.876010506258358],
            [31.172661255199362, 0.878204880061485],
            [31.172163330715474, 0.87889735840743],
            [31.17097644062947, 0.879185419603386],
            [31.168886585579433, 0.878759322452204],
            [31.16722523141154, 0.879453598910727],
            [31.16701237111338, 0.880288745892416],
            [31.16734601259641, 0.881528525068562],
            [31.168367883063052, 0.88243331599733],
            [31.168297077852362, 0.882862759453849],
            [31.167407668465966, 0.883842060038768],
            [31.16728994424798, 0.884844020361035],
            [31.166815288824868, 0.885059420552371],
            [31.166130601898494, 0.888972180977659],
            [31.16369925049657, 0.891361112147737],
            [31.16284805993395, 0.894987896965814],
            [31.163372389497294, 0.896990641817927],
            [31.163056562504664, 0.901785338873051],
            [31.162346033742484, 0.903599166231775],
            [31.162075155751687, 0.905817797540858],
            [31.16136387420131, 0.906868366184106],
            [31.160106681062857, 0.90811058308706],
            [31.15816052591558, 0.908948370551246],
            [31.155468148346625, 0.911528469054922],
            [31.153782731905505, 0.911912669381285],
            [31.15178981046454, 0.913489918069312],
            [31.147160257307853, 0.913926303664936],
            [31.144117310402656, 0.916285676630772],
            [31.140930087774592, 0.912793980102071],
            [31.13964861317403, 0.908917454429773],
            [31.13798589356688, 0.906906887405805],
            [31.13361433027161, 0.903555120124697],
            [31.133424872883232, 0.902215223783177],
            [31.12943360507529, 0.898863666847641],
            [31.12620152237857, 0.895305164759467],
            [31.126818867099704, 0.89943650945105],
            [31.12624731489851, 0.901637300476089],
            [31.125295895706348, 0.903024447037297],
            [31.12239537938437, 0.904697671730101],
            [31.121111779369844, 0.904984097973125],
            [31.11369980601171, 0.898185602145562],
            [31.112511531621877, 0.897993584793576],
            [31.111132698509127, 0.898614906341559],
            [31.10904109084599, 0.898757360722192],
            [31.105096347684913, 0.897511218162108],
            [31.10110361023319, 0.89717418375874],
            [31.088839404834168, 0.897789766814173],
            [31.085517324420746, 0.887548414569276],
            [31.07829905388901, 0.874147085014552],
            [31.077160098804885, 0.870510021395105],
            [31.077501628394433, 0.86848481506273],
            [31.07810817087427, 0.869167756189618],
            [31.07915180213032, 0.868116730426405],
            [31.085884140687227, 0.857468985029531],
            [31.08752939614694, 0.852577044238036],
            [31.088501363402884, 0.851096795040638],
            [31.091620816227586, 0.84842068745779],
            [31.096083507320216, 0.847555153976132],
            [31.104235528979075, 0.844060282569205],
            [31.110539069311507, 0.843978943556431],
            [31.116426279137297, 0.843039598017079],
            [31.1176959301121, 0.842465193822571],
            [31.118311802494485, 0.841033163421232],
            [31.118286598462554, 0.839578280909012],
            [31.11746306882413, 0.835190945585618],
            [31.119619285119143, 0.83087050754752],
            [31.120638959204907, 0.829628649685904],
            [31.120148860843763, 0.82629024513503],
            [31.121365599251693, 0.820373231115279],
            [31.121206080016815, 0.815269315237833],
            [31.121962164143664, 0.811666586079144],
            [31.123885015195842, 0.80869258397951],
            [31.12588990668797, 0.810062360139025],
            [31.127148573961822, 0.810370442492703],
            [31.13232405397789, 0.809980654851718],
            [31.139246246080155, 0.811162297299642],
            [31.142475446083118, 0.811348007164215],
            [31.14467250428254, 0.812179339668498],
            [31.146597284017613, 0.813750502016389],
            [31.148917902789393, 0.819304263622308],
            [31.15107994286239, 0.820708100388372],
            [31.156731194907458, 0.821128514599633],
            [31.166287318389696, 0.820684087291195],
            [31.16806827155959, 0.820895938600964],
            [31.17031314708157, 0.822013428564668],
            [31.173827969124062, 0.82281883525798],
            [31.17798232068193, 0.822120553313143],
            [31.180535040766937, 0.82242658769346],
            [31.181011329327198, 0.823809253158121],
            [31.18063290862388, 0.825240974543663],
            [31.181084644430808, 0.825836561326438],
            [31.183007829656272, 0.825809666764049],
            [31.183388139516655, 0.82621455018085],
            [31.184551685981653, 0.826331970235358],
            [31.18559742378707, 0.827332104222552],
            [31.18940904919942, 0.828113193187981],
            [31.193139839710966, 0.831088812928902],
            [31.19634671118924, 0.832538726038525],
            [31.198046082059967, 0.835200108326278],
            [31.198073728611167, 0.837998165441257],
            [31.197623383396284, 0.838762148405665],
            [31.196317902218052, 0.839169697304509],
            [31.19589117730528, 0.839814382215525],
            [31.1963666331273, 0.840386086755057],
            [31.196319927919042, 0.841149431517719],
            [31.19252151672449, 0.841704022107532],
            [31.19196444536568, 0.842587431434182],
            [31.19232159845465, 0.843564807629732],
            [31.1912776860259, 0.844353574924779],
            [31.190922311601188, 0.845117403049168],
            [31.190947853399656, 0.846882424414882],
            [31.19042712158903, 0.848481339546718],
            [31.19063005909655, 0.849578220172373],
            [31.193409419636158, 0.85090957804184],
            [31.194194535516367, 0.852458737534321],
            [31.194267536209626, 0.854199835170379],
            [31.19334630310599, 0.855838802270837],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 472,
        District: "KIBAALE",
        County: "BUYANJA",
        Subcounty: "KYEBANDO",
        Population: 13335,
        Key: "KIBAALEKYEBANDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.093216377784096, 3.445451427718685],
            [31.092678798968635, 3.447974552093572],
            [31.092944769462992, 3.449780851805523],
            [31.090210949915036, 3.453838296546398],
            [31.08975798161952, 3.455673235888582],
            [31.090235540397614, 3.456516888546555],
            [31.09020275458468, 3.457931333790083],
            [31.09095043227713, 3.458504670661365],
            [31.0922916861666, 3.461817943035233],
            [31.092239629694205, 3.472832979799732],
            [31.09145757078091, 3.474456575374274],
            [31.089208334836517, 3.475806324679313],
            [31.090407399789584, 3.490194638510054],
            [31.09124619270296, 3.495414983303302],
            [31.09324967563674, 3.520646363195546],
            [31.093791189971455, 3.52207018378855],
            [31.093441029368655, 3.522863019303885],
            [31.094280875107565, 3.525211899413478],
            [31.093508138011956, 3.525517109978495],
            [31.093007856348784, 3.526460792548602],
            [31.092512424689808, 3.529634009225985],
            [31.08978011700647, 3.532292458705804],
            [31.089650835962352, 3.535730944882249],
            [31.090222967576906, 3.53644066066127],
            [31.088959982101507, 3.537892904476676],
            [31.088859407620607, 3.538733256278699],
            [31.086410761852857, 3.543630503933886],
            [31.087063657401355, 3.545352011205617],
            [31.086750414861775, 3.547497291408601],
            [31.08732004736323, 3.550482170762504],
            [31.08762164594007, 3.551183051880677],
            [31.08911343321666, 3.551840216544352],
            [31.089536397781686, 3.553237975608917],
            [31.089168360704715, 3.553747964812968],
            [31.088098593863773, 3.553654538555297],
            [31.088918296679065, 3.555437362613197],
            [31.087054890742518, 3.556833434233665],
            [31.08715075266141, 3.558494912156346],
            [31.0876159227734, 3.559022662447187],
            [31.087971876611473, 3.561336978174213],
            [31.08949091428221, 3.562711044180324],
            [31.089860298832093, 3.564390122073869],
            [31.089419763220103, 3.566075463071345],
            [31.089785240098518, 3.566812937699456],
            [31.09200329462106, 3.568706836065129],
            [31.091089523822475, 3.578903991238145],
            [31.09201512633166, 3.580747936026819],
            [31.09738260596836, 3.587100053574352],
            [31.09962242038203, 3.590996324156802],
            [31.100337746147808, 3.722908626542679],
            [31.100893709883895, 3.723566824182394],
            [31.101261304989727, 3.727054509928692],
            [31.10067102381315, 3.728504157621359],
            [31.100496538645633, 3.730517053628913],
            [31.099935163458287, 3.730939305639524],
            [31.100618009736678, 3.732411654781165],
            [31.100776620774823, 3.734675103035952],
            [31.100465049999972, 3.735840887522798],
            [31.097421227237373, 3.736645616290896],
            [31.094357959542098, 3.739308054286529],
            [31.09361789147843, 3.738419304453422],
            [31.093286002608497, 3.735211413681456],
            [31.092305603765297, 3.734238747840904],
            [31.09077206189599, 3.734761318618715],
            [31.090131180416115, 3.736683765519252],
            [31.08969629700393, 3.740200622787365],
            [31.08882652838291, 3.741528026350465],
            [31.08750661397302, 3.741417410509477],
            [31.086339290092223, 3.73988784657491],
            [31.084706563435766, 3.739422493551501],
            [31.08355068588835, 3.741020719041018],
            [31.082101069124477, 3.741425044257938],
            [31.08095282096875, 3.742622758484525],
            [31.080186050483263, 3.742847807612518],
            [31.077588183767034, 3.742634205505794],
            [31.07613093850974, 3.743427596662192],
            [31.073048595089432, 3.743446671128987],
            [31.07146164478323, 3.742657096858704],
            [31.06958095795555, 3.742535037723461],
            [31.067894822862193, 3.740841454934162],
            [31.065930210030785, 3.740067137768905],
            [31.06491166243238, 3.739052513993824],
            [31.064732367684833, 3.738102734023306],
            [31.06314541737863, 3.737431405080676],
            [31.063103454376783, 3.735497516289544],
            [31.061054916439915, 3.735890398736856],
            [31.060723029366645, 3.734532480988842],
            [31.059021636388184, 3.733586515722816],
            [31.058869044960755, 3.733144048269029],
            [31.0594412619153, 3.732568077401085],
            [31.06134483601979, 3.731622110018925],
            [31.062340493646424, 3.730096357587114],
            [31.06330181766285, 3.73008109975359],
            [31.063709999551545, 3.729573786723122],
            [31.0634086309434, 3.728696481410043],
            [31.063782479221956, 3.728192982719428],
            [31.063591739937653, 3.727632269171938],
            [31.061337202136492, 3.726396412606806],
            [31.0607039482517, 3.725057566707646],
            [31.061756825866976, 3.72262780781841],
            [31.06108923927032, 3.722101423627876],
            [31.060707758006817, 3.719160538509695],
            [31.05896821717152, 3.718134472845809],
            [31.056656459381678, 3.717650049417084],
            [31.055721836888733, 3.716364604681425],
            [31.054836807687654, 3.716582024775769],
            [31.053486373015975, 3.714182782045689],
            [31.05361989051497, 3.713511451884111],
            [31.05311633898416, 3.712740947380551],
            [31.05101439530535, 3.713686915324071],
            [31.04863397029521, 3.712687550633162],
            [31.047386536454027, 3.711085512246204],
            [31.044887852728326, 3.708945648493521],
            [31.04250742771819, 3.707908140515957],
            [31.040333000775746, 3.704738394122498],
            [31.03649151356668, 3.702751106157013],
            [31.033927977765654, 3.698982503538046],
            [31.03345875984498, 3.69853240701885],
            [31.03174210808312, 3.698265401929398],
            [31.030494673343608, 3.696606148642913],
            [31.026916407784174, 3.69546946747263],
            [31.026290782392767, 3.694698963397585],
            [31.024959424344456, 3.695149060966055],
            [31.022819331012176, 3.693299089384259],
            [31.02128960338958, 3.693547025801349],
            [31.02101875414489, 3.693104558001215],
            [31.020099390435345, 3.693047342985926],
            [31.019157141245646, 3.693997123954111],
            [31.018195815432552, 3.694111556547909],
            [31.01600994575002, 3.693390640194028],
            [31.01524699040954, 3.69353558710724],
            [31.013976668393212, 3.694889691698627],
            [31.010772252010636, 3.694943096691321],
            [31.010097036022263, 3.694607431548218],
            [31.007739497390606, 3.690606150624227],
            [31.006568357466506, 3.687295272529328],
            [31.005099664079243, 3.684850258005288],
            [31.005202663113103, 3.683702130144246],
            [31.004824998791243, 3.682744721848356],
            [31.003733970624168, 3.681341032493588],
            [31.005835911608017, 3.677526652478385],
            [31.00818200210969, 3.676504397915087],
            [31.01054716474315, 3.674337830167789],
            [31.010016908095558, 3.67290743876124],
            [31.00836892175737, 3.671450347241299],
            [31.007518224369825, 3.669928412339162],
            [31.008170551284763, 3.669505016036296],
            [31.00821632763502, 3.667372778874888],
            [31.009440871504427, 3.666243722576378],
            [31.00994823638365, 3.664916318180276],
            [31.009898643091752, 3.663569843695019],
            [31.011001113100594, 3.661555851754946],
            [31.01084470562986, 3.659412171755871],
            [31.011725918787608, 3.657531682279746],
            [31.012710130979187, 3.656604788332126],
            [31.013045829604245, 3.653919465679285],
            [31.012267614582036, 3.652912471982469],
            [31.01227905732213, 3.652279285219443],
            [31.01327471584706, 3.652580619939991],
            [31.01364093383557, 3.650494155056696],
            [31.012893235481858, 3.649182009867064],
            [31.01419789021002, 3.649311698460571],
            [31.014678551769087, 3.648361917477931],
            [31.015449138297914, 3.648274186498946],
            [31.0159221713636, 3.648815826991087],
            [31.015441509804525, 3.64976560839034],
            [31.0159259865086, 3.649929625416701],
            [31.01778378336454, 3.646904822785973],
            [31.01971406168748, 3.646420396458026],
            [31.01997346819208, 3.647560894593526],
            [31.021003459428872, 3.648041504823852],
            [31.020911904033433, 3.646748430805439],
            [31.021926634690168, 3.645684219089138],
            [31.02362039827691, 3.645462984121924],
            [31.023925579335113, 3.645081545817459],
            [31.024322315788783, 3.644051663559737],
            [31.023101585267717, 3.642892094208304],
            [31.023154991907987, 3.641907985691861],
            [31.02611144452606, 3.639371421716021],
            [31.026107630279387, 3.638738235279417],
            [31.025344674040575, 3.639260805704586],
            [31.025028045750695, 3.638700092605697],
            [31.027217731476572, 3.638227107538891],
            [31.02824772001841, 3.636827230294624],
            [31.02844990294107, 3.635545599326733],
            [31.02811801676609, 3.634206754035179],
            [31.027179579128145, 3.632791620014357],
            [31.027473316547947, 3.632005858036106],
            [31.02866734195223, 3.631395557955911],
            [31.028442268159466, 3.62844704386165],
            [31.029834662239768, 3.626993765714511],
            [31.031856495059827, 3.626093570870978],
            [31.03296278201033, 3.62653985238257],
            [31.034118660456073, 3.625330693851879],
            [31.035430942779325, 3.622332592247761],
            [31.0360565663741, 3.621916825340104],
            [31.03596119673195, 3.620860242424089],
            [31.037487106514615, 3.618464812976015],
            [31.03702933223233, 3.616691127288895],
            [31.038250060956766, 3.616027425118233],
            [31.03990185794838, 3.611968926844944],
            [31.041725322092482, 3.60986720414745],
            [31.041809247197882, 3.609081441997658],
            [31.04128662173863, 3.608818251040228],
            [31.041244656940126, 3.606800444891418],
            [31.041687167947398, 3.602154533457232],
            [31.040176513354908, 3.599366225342498],
            [31.039146522118145, 3.598443146595132],
            [31.0388604113951, 3.597123372513721],
            [31.037708347196034, 3.597066157668061],
            [31.03559114203887, 3.593858269008138],
            [31.035552992385405, 3.592610967183048],
            [31.036724130512873, 3.592404990192489],
            [31.037193348433547, 3.591901491981497],
            [31.036502870966817, 3.589593794645296],
            [31.035755173511433, 3.588968237201156],
            [31.034828182206837, 3.589879873870309],
            [31.034111004114912, 3.589643382984539],
            [31.033618896222496, 3.588781333568792],
            [31.033332785499443, 3.58622188795472],
            [31.029994848922925, 3.582861424167992],
            [31.028770303256856, 3.580759703397304],
            [31.028579562175924, 3.579142408028603],
            [31.02689342798089, 3.57847870809724],
            [31.026092323885244, 3.577311508614137],
            [31.02465033651308, 3.576918628398293],
            [31.025016554501597, 3.57571710098446],
            [31.023299900943105, 3.573371259558692],
            [31.022239391241154, 3.573062295628282],
            [31.022002875606628, 3.573550536538303],
            [31.02099195739997, 3.573241572668297],
            [31.01959574637807, 3.57177303913834],
            [31.019405007093766, 3.571029236010673],
            [31.019984853439993, 3.569957395429511],
            [31.019523264012737, 3.569205962789328],
            [31.019836075360978, 3.568427830469317],
            [31.018703085090348, 3.568424017341761],
            [31.018081275742244, 3.567764129959601],
            [31.01784475831109, 3.566154463060606],
            [31.016589695078192, 3.56598663211959],
            [31.015792405229217, 3.565353445729086],
            [31.015193484056255, 3.564205318594598],
            [31.01546433240262, 3.563263167338488],
            [31.016139549289324, 3.56310296306577],
            [31.015880143683024, 3.56246214748914],
            [31.014792929762653, 3.561924321610991],
            [31.01424360008496, 3.559662396449967],
            [31.012175987321356, 3.558392210327994],
            [31.01217217127802, 3.557453874365867],
            [31.009467487687996, 3.552273952497456],
            [31.00978792752962, 3.550366764241526],
            [31.00811323876964, 3.549371212159056],
            [31.00670176716765, 3.54635404282776],
            [31.00680095105651, 3.544954166345603],
            [31.00459981899729, 3.541612773111354],
            [31.00269624219784, 3.540624851538425],
            [31.00167006610608, 3.540720211287287],
            [30.999774120494973, 3.54130381287989],
            [30.998728871373075, 3.542333695458136],
            [30.993990914917827, 3.544687168852897],
            [30.989588655290973, 3.542612151264995],
            [30.98766218941811, 3.540087035353693],
            [30.983504075715796, 3.53839345553743],
            [30.98229860397816, 3.536711315988039],
            [30.980589578913058, 3.532687150251909],
            [30.980311098480026, 3.530760890197049],
            [30.980646797105084, 3.527610215534755],
            [30.98004024654041, 3.527118160349093],
            [30.977156270897755, 3.526328586757391],
            [30.9754968427178, 3.528910921550898],
            [30.974154038336174, 3.526694769406286],
            [30.976935007758446, 3.517971287531619],
            [30.977884887238186, 3.516434093338495],
            [30.97715244856624, 3.515530087016869],
            [30.974848319269814, 3.514927417741074],
            [30.973005779400644, 3.513325380747137],
            [30.971338720032353, 3.513584759649803],
            [30.970362135435856, 3.513039303800051],
            [30.96789778621862, 3.512737969751303],
            [30.965902654023726, 3.510495117846315],
            [30.962213760038747, 3.508992256793865],
            [30.958719417788082, 3.506951567848916],
            [30.955984218427822, 3.504334907304059],
            [30.955614183497676, 3.503655948584048],
            [30.96125242973407, 3.501645767767213],
            [30.966684676106098, 3.499002401189147],
            [30.968511956293536, 3.49910157323187],
            [30.97001116545098, 3.499727130480565],
            [30.97051853302512, 3.501367312259101],
            [30.971609561192203, 3.50266038503718],
            [30.97374964643967, 3.493063411869815],
            [30.97380686732662, 3.490812929878459],
            [30.97462704355408, 3.488970585240262],
            [30.975477496599847, 3.488050448543649],
            [30.978762172063195, 3.487753983342941],
            [30.984703448791, 3.486011392545489],
            [30.985780893532667, 3.485881724840704],
            [30.986830576738768, 3.486451518206962],
            [30.98859197448325, 3.485914163064116],
            [30.989826466296147, 3.486061996955558],
            [30.990866496206237, 3.4849951468841],
            [30.993990976901596, 3.485912542811778],
            [30.997788938938495, 3.485168349052797],
            [30.999167964290688, 3.485303281110284],
            [30.999720859381764, 3.48475011998609],
            [31.003336087920196, 3.483451165580647],
            [31.004876006929695, 3.482042189588655],
            [31.007347123155974, 3.481334715380629],
            [31.008867456197322, 3.481344039722591],
            [31.00932133448623, 3.479544638177566],
            [31.010731761347497, 3.479527669797446],
            [31.01132178740253, 3.477612854643503],
            [31.01255531532311, 3.476697351554773],
            [31.013533882501466, 3.474214520868105],
            [31.013237983735074, 3.473225922814563],
            [31.015305083560634, 3.471675997059625],
            [31.015096352817864, 3.467980614559482],
            [31.017477093136648, 3.464860222936506],
            [31.018225471515034, 3.465067635980802],
            [31.019050196811065, 3.465928218411326],
            [31.026723939243, 3.468400212207681],
            [31.029003289410614, 3.469569052920452],
            [31.03011969947605, 3.469450724918679],
            [31.031477900981663, 3.468559224039608],
            [31.0317086997377, 3.469681184927103],
            [31.03234385535598, 3.469987726295087],
            [31.03290211338929, 3.469903717433803],
            [31.033313725045733, 3.468996036584822],
            [31.03401407589576, 3.468521935132586],
            [31.035093845477387, 3.46904234237913],
            [31.036140788821875, 3.468356023419539],
            [31.03703696162405, 3.468840555910606],
            [31.038640345710053, 3.468950368320144],
            [31.04028091286228, 3.468158808925274],
            [31.042590865936727, 3.468206201524673],
            [31.04176932157508, 3.465784072067746],
            [31.043508330607736, 3.465212745460205],
            [31.04407496632941, 3.464489923728312],
            [31.044958342630338, 3.464328501850018],
            [31.046984569110457, 3.46493603575675],
            [31.04738856125669, 3.464290951844108],
            [31.048272376833786, 3.463916585996135],
            [31.04871579963108, 3.464712484356807],
            [31.04986153430063, 3.464076031675306],
            [31.05056625275958, 3.464915059881791],
            [31.0520931147564, 3.464449745578527],
            [31.05302485635225, 3.464820770211121],
            [31.054714096921543, 3.464405472318517],
            [31.055602830774824, 3.465081623183051],
            [31.056190160087368, 3.46460016614956],
            [31.055812627817883, 3.46266871251592],
            [31.057444439091036, 3.462700467373987],
            [31.059284866122628, 3.46089424515883],
            [31.0601117446804, 3.460725591863218],
            [31.06045964691859, 3.459867437391288],
            [31.06246312895404, 3.45987630912276],
            [31.062983011856748, 3.459191202999635],
            [31.06224944310415, 3.45863604491921],
            [31.06330426916527, 3.457538004230936],
            [31.065015515764088, 3.457627818399692],
            [31.06535392819961, 3.45705243656647],
            [31.064974266922867, 3.456157296040853],
            [31.065604635418985, 3.455349401853659],
            [31.065231650421435, 3.454645925705155],
            [31.06564857651111, 3.454582895173731],
            [31.066374866214954, 3.455244506169557],
            [31.06718107992793, 3.454813170496846],
            [31.068113158391995, 3.455020921996085],
            [31.06896975681264, 3.454128308201008],
            [31.069647317403906, 3.454434912887473],
            [31.070481672639787, 3.454060414921021],
            [31.0709634121772, 3.453387074472385],
            [31.071931473558298, 3.453268381292115],
            [31.07193929788442, 3.452892196201879],
            [31.071134649934983, 3.452549844676132],
            [31.071241562030206, 3.452081584969393],
            [31.07334338353811, 3.450247449291794],
            [31.074487321577134, 3.45049111499351],
            [31.07490960971071, 3.451272770900685],
            [31.078695369032808, 3.451649571758734],
            [31.080311742757807, 3.452334278025893],
            [31.08082981106361, 3.451157032037094],
            [31.08146597638826, 3.450973769990172],
            [31.081731097076393, 3.450428641925546],
            [31.082913877369943, 3.451250348368808],
            [31.083842544930892, 3.450261248408391],
            [31.086062508373406, 3.452008028078307],
            [31.087090879049402, 3.451952923174194],
            [31.0886979471264, 3.449945429809175],
            [31.088380048618696, 3.449539157737992],
            [31.08889419308338, 3.448751744561883],
            [31.08859136381458, 3.448140408191757],
            [31.090071174751767, 3.44538964925564],
            [31.090982323368053, 3.445058813932581],
            [31.093216377784096, 3.445451427718685],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 473,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "LUDARA",
        Population: 31656,
        Key: "KOBOKOLUDARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.093216377784096, 3.445451427718685],
            [31.090982323368053, 3.445058813932581],
            [31.090071174751767, 3.44538964925564],
            [31.08859136381458, 3.448140408191757],
            [31.08889419308338, 3.448751744561883],
            [31.088380048618696, 3.449539157737992],
            [31.0886979471264, 3.449945429809175],
            [31.087090879049402, 3.451952923174194],
            [31.086062508373406, 3.452008028078307],
            [31.083842544930892, 3.450261248408391],
            [31.082913877369943, 3.451250348368808],
            [31.081731097076393, 3.450428641925546],
            [31.08146597638826, 3.450973769990172],
            [31.08082981106361, 3.451157032037094],
            [31.080311742757807, 3.452334278025893],
            [31.078695369032808, 3.451649571758734],
            [31.07490960971071, 3.451272770900685],
            [31.074487321577134, 3.45049111499351],
            [31.07334338353811, 3.450247449291794],
            [31.071241562030206, 3.452081584969393],
            [31.071134649934983, 3.452549844676132],
            [31.07193929788442, 3.452892196201879],
            [31.071931473558298, 3.453268381292115],
            [31.0709634121772, 3.453387074472385],
            [31.070481672639787, 3.454060414921021],
            [31.069647317403906, 3.454434912887473],
            [31.06896975681264, 3.454128308201008],
            [31.068113158391995, 3.455020921996085],
            [31.06718107992793, 3.454813170496846],
            [31.066374866214954, 3.455244506169557],
            [31.06564857651111, 3.454582895173731],
            [31.065231650421435, 3.454645925705155],
            [31.065604635418985, 3.455349401853659],
            [31.064974266922867, 3.456157296040853],
            [31.06535392819961, 3.45705243656647],
            [31.065015515764088, 3.457627818399692],
            [31.06330426916527, 3.457538004230936],
            [31.06224944310415, 3.45863604491921],
            [31.062983011856748, 3.459191202999635],
            [31.06246312895404, 3.45987630912276],
            [31.06045964691859, 3.459867437391288],
            [31.0601117446804, 3.460725591863218],
            [31.059284866122628, 3.46089424515883],
            [31.057444439091036, 3.462700467373987],
            [31.055812627817883, 3.46266871251592],
            [31.056190160087368, 3.46460016614956],
            [31.055602830774824, 3.465081623183051],
            [31.054714096921543, 3.464405472318517],
            [31.05302485635225, 3.464820770211121],
            [31.0520931147564, 3.464449745578527],
            [31.05056625275958, 3.464915059881791],
            [31.04986153430063, 3.464076031675306],
            [31.04871579963108, 3.464712484356807],
            [31.048272376833786, 3.463916585996135],
            [31.04738856125669, 3.464290951844108],
            [31.046984569110457, 3.46493603575675],
            [31.044958342630338, 3.464328501850018],
            [31.04407496632941, 3.464489923728312],
            [31.043508330607736, 3.465212745460205],
            [31.04176932157508, 3.465784072067746],
            [31.042590865936727, 3.468206201524673],
            [31.04028091286228, 3.468158808925274],
            [31.038640345710053, 3.468950368320144],
            [31.03703696162405, 3.468840555910606],
            [31.036140788821875, 3.468356023419539],
            [31.035093845477387, 3.46904234237913],
            [31.03401407589576, 3.468521935132586],
            [31.033313725045733, 3.468996036584822],
            [31.03290211338929, 3.469903717433803],
            [31.03234385535598, 3.469987726295087],
            [31.0317086997377, 3.469681184927103],
            [31.031477900981663, 3.468559224039608],
            [31.03011969947605, 3.469450724918679],
            [31.029003289410614, 3.469569052920452],
            [31.026723939243, 3.468400212207681],
            [31.019050196811065, 3.465928218411326],
            [31.018225471515034, 3.465067635980802],
            [31.017477093136648, 3.464860222936506],
            [31.016588599133534, 3.464091779063152],
            [31.01575481612447, 3.464189393673076],
            [31.013178279006354, 3.463275436893994],
            [31.01052652505117, 3.461435641519537],
            [31.009376541350317, 3.461329499231721],
            [31.00889118878884, 3.460720997289635],
            [31.00660715121206, 3.459945715578701],
            [31.00504843765019, 3.457853295746551],
            [31.004452155727503, 3.457958061123606],
            [31.003820796389622, 3.459566829651588],
            [31.002245427164098, 3.45697427919207],
            [31.001217331372548, 3.456732763601753],
            [31.000404621043426, 3.457046536408102],
            [30.99980568100583, 3.453520455320872],
            [30.99999314054103, 3.451899872573328],
            [30.997802321141254, 3.448500977536743],
            [30.99685857176504, 3.444180005230632],
            [30.998717454684137, 3.436779135443859],
            [30.99805857276258, 3.43423502549559],
            [30.99841608877094, 3.427174521292578],
            [30.99819280801548, 3.424648074300692],
            [30.99863987437957, 3.423370402717931],
            [31.00032034020515, 3.424036541351238],
            [31.001849511770605, 3.423568941971906],
            [31.002122486429236, 3.424025832820452],
            [31.003512923978825, 3.424412632013754],
            [31.00427416623207, 3.42555269664821],
            [31.00731170977086, 3.426731510314372],
            [31.011000274074142, 3.429013226148036],
            [31.011541529694053, 3.428717384528166],
            [31.011987665403513, 3.429102206379714],
            [31.01291895694338, 3.428896711619921],
            [31.013604528710367, 3.429260022300836],
            [31.01431951131972, 3.428544581846123],
            [31.015563155168714, 3.428492550395428],
            [31.017206015719896, 3.429267529529898],
            [31.01855816258051, 3.4293249680799],
            [31.02082663055676, 3.428232948161493],
            [31.022674047379603, 3.426184142757356],
            [31.02284178889428, 3.42550919005954],
            [31.02400825039239, 3.424542118912091],
            [31.026042106264228, 3.424528884351531],
            [31.0285138746674, 3.422980443088293],
            [31.034690010536348, 3.42070853907734],
            [31.037031545681213, 3.419303400333999],
            [31.040330919379205, 3.419675722164554],
            [31.041489356226915, 3.418646739396614],
            [31.04277064936779, 3.419243082724018],
            [31.044193565506475, 3.41779063639907],
            [31.045115216326725, 3.417971149203503],
            [31.045117027330342, 3.417077806691402],
            [31.046665469555233, 3.416677313439681],
            [31.04849915473065, 3.41851407822086],
            [31.04967673737196, 3.418717106547621],
            [31.051340950877453, 3.417620583772279],
            [31.05145729168988, 3.41619897315779],
            [31.054375955777246, 3.415292790658103],
            [31.057233385304933, 3.414963259510087],
            [31.05947801558681, 3.414002030624154],
            [31.05996650596358, 3.413385989343483],
            [31.060921494162354, 3.413133065389455],
            [31.061689738783244, 3.410801065626417],
            [31.064385945870256, 3.408640516932696],
            [31.066027506559212, 3.40804157727628],
            [31.06853985994858, 3.408427018990618],
            [31.06982202176035, 3.40809754825938],
            [31.0704671217288, 3.406930543127706],
            [31.072162520249368, 3.405697740901553],
            [31.072669475496806, 3.404578772472409],
            [31.072747391771284, 3.402412913713289],
            [31.07358994323585, 3.401738384605672],
            [31.07433661930673, 3.401687053843785],
            [31.07583889351593, 3.402387418729716],
            [31.07688051793564, 3.402072528590543],
            [31.077140438276576, 3.403562849669528],
            [31.078524536415213, 3.405530892837827],
            [31.08257481635079, 3.406818162522649],
            [31.088923701842134, 3.407981814929621],
            [31.0901589976472, 3.41534494298601],
            [31.09042308437444, 3.420370531348378],
            [31.092459734006823, 3.423081556401872],
            [31.093810650175477, 3.424209064176582],
            [31.095170960925373, 3.426807494753858],
            [31.09579546791426, 3.428254926467805],
            [31.095913608950536, 3.430714909098253],
            [31.09686675380633, 3.432329720833256],
            [31.09641044647294, 3.433423967067312],
            [31.097386251331784, 3.433722526032319],
            [31.09737315658989, 3.43460091037076],
            [31.098216716862495, 3.434343734478567],
            [31.099056628178392, 3.434863302306387],
            [31.09971875930635, 3.436118463008486],
            [31.10108757261041, 3.436679974797827],
            [31.101738975158895, 3.436504103255595],
            [31.10256215625098, 3.437902313939938],
            [31.102209033902685, 3.438862803253999],
            [31.101124323586998, 3.438669832981482],
            [31.09764341114984, 3.443010400636583],
            [31.096585231677754, 3.443117306264662],
            [31.095719218912933, 3.442079792474603],
            [31.094660525604507, 3.44244563847212],
            [31.094496243501986, 3.443208510774849],
            [31.09327326539609, 3.444337225943883],
            [31.093216377784096, 3.445451427718685],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 474,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "ABUKU",
        Population: 14555,
        Key: "KOBOKOABUKU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.973781910331386, 3.414525755029235],
            [30.972868376688037, 3.416917019728787],
            [30.972803530002636, 3.423287027302362],
            [30.974184481342842, 3.423775266437563],
            [30.97530602797504, 3.425018753073689],
            [30.971575174581442, 3.429325185979645],
            [30.970144631746006, 3.428363965222779],
            [30.964231721119944, 3.429767658629375],
            [30.957952591607047, 3.43046950949174],
            [30.95421792037348, 3.430465697596085],
            [30.95357703709697, 3.429168810180482],
            [30.953271851547186, 3.426178339252463],
            [30.948994322099214, 3.422941242397105],
            [30.948738303141575, 3.419969201939288],
            [30.949849487706988, 3.417363540515074],
            [30.952017525831106, 3.416617589292294],
            [30.9543075003736, 3.414867123931354],
            [30.954646704224903, 3.413114188497386],
            [30.959007506601377, 3.412473055456117],
            [30.95905787693599, 3.412946167014444],
            [30.959966291978844, 3.412896017833379],
            [30.959986846330864, 3.413472682592691],
            [30.961589163218317, 3.413414557997282],
            [30.96214368156511, 3.412667284627969],
            [30.963219331472843, 3.412283877483738],
            [30.964785753478147, 3.410070873727757],
            [30.967142267132044, 3.411754222723025],
            [30.971729973169538, 3.416016195804079],
            [30.973781910331386, 3.414525755029235],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 475,
        District: "KOBOKO",
        County: "KOBOKO MUNICIPALITY",
        Subcounty: "NORTHERN DIVISON",
        Population: 19155,
        Key: "KOBOKONORTHERN DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.019157141245646, 3.693997123954111],
            [31.01852388825915, 3.695259683508834],
            [31.0177113423217, 3.69887571375779],
            [31.016795796452122, 3.700077243715699],
            [31.014464965632207, 3.70113764254912],
            [31.01268727694003, 3.701377948953956],
            [31.00968123103007, 3.703231738643876],
            [31.008384208388545, 3.706187883069425],
            [31.003859879392706, 3.707976829833065],
            [31.000712684795378, 3.708293425437941],
            [31.000716499940417, 3.708701563881677],
            [30.99352563610969, 3.707519111912512],
            [30.99135883945726, 3.706824896953228],
            [30.988837268454745, 3.705905634586627],
            [30.98301972387755, 3.702827436232576],
            [30.97935371716935, 3.699829337810537],
            [30.97363535558269, 3.693466961214643],
            [30.968534982809206, 3.681737754351457],
            [30.96735073197351, 3.675899825151823],
            [30.96737346474009, 3.673008699542837],
            [30.96638328593839, 3.672559390427718],
            [30.966182506184197, 3.671895137803368],
            [30.96407322596446, 3.671355212770726],
            [30.96082958195003, 3.671510345395827],
            [30.958487536562117, 3.669554240502722],
            [30.95599466403797, 3.668695075098698],
            [30.95555434491999, 3.666628187348686],
            [30.95482174544959, 3.665898482102872],
            [30.95553333422381, 3.664006846878875],
            [30.952271920634733, 3.661732940909265],
            [30.95213707991735, 3.660131466054598],
            [30.950622789842907, 3.658895240283257],
            [30.951063422472906, 3.657155058749535],
            [30.94957443614341, 3.655953804422961],
            [30.94965153495096, 3.65389292601305],
            [30.94810748908106, 3.653554763943209],
            [30.947744557129862, 3.651812946708625],
            [30.946699912574147, 3.650525422028782],
            [30.947629977015385, 3.649126040853671],
            [30.94743729467513, 3.646817219863725],
            [30.94781232423827, 3.645358367325464],
            [30.948392919779444, 3.644787451391704],
            [30.948488084605685, 3.643269763659406],
            [30.94950468735147, 3.642020907178828],
            [30.949826639956044, 3.640547381875596],
            [30.948980745860315, 3.638850303691809],
            [30.949857462051757, 3.637594079876141],
            [30.949226691110375, 3.633191346047828],
            [30.94785983793028, 3.632593653499039],
            [30.945360388839923, 3.629784959046918],
            [30.942250070983334, 3.628588706596926],
            [30.940364216147824, 3.626375987092739],
            [30.94062056119395, 3.625187431218298],
            [30.940321543476905, 3.624854714581556],
            [30.939483569827043, 3.624922293217739],
            [30.940100632477158, 3.623973935313533],
            [30.93914237171583, 3.622852098896741],
            [30.939918888023822, 3.622768934999264],
            [30.940181133204714, 3.622368005707707],
            [30.939314254463955, 3.619042805683961],
            [30.936506246649945, 3.619149431054299],
            [30.936397519957854, 3.619838199517039],
            [30.93580874076446, 3.619556940459543],
            [30.93473593312627, 3.62006048162926],
            [30.93229993833265, 3.619161334200213],
            [30.931115047896487, 3.619575286913366],
            [30.930549797376997, 3.618269139323768],
            [30.929578738317822, 3.618799821684038],
            [30.92886280798583, 3.618207724694713],
            [30.929328655427565, 3.617478571005988],
            [30.929177383625273, 3.616990272927834],
            [30.928290885678734, 3.617332675827292],
            [30.926704021610785, 3.615740803645754],
            [30.927164796266112, 3.61414406500119],
            [30.92687484255028, 3.611818462057979],
            [30.92619150219849, 3.610774022553981],
            [30.92600389713623, 3.609510663686843],
            [30.924690862923104, 3.608962298038657],
            [30.92438949521329, 3.607469056960201],
            [30.924923470886156, 3.606647173090256],
            [30.923594640697047, 3.604924051459299],
            [30.92403168455751, 3.604134285577506],
            [30.923907872456862, 3.603565129529511],
            [30.92354281958325, 3.602934305535702],
            [30.92276863440342, 3.603153435967868],
            [30.92108320358925, 3.599394194803021],
            [30.92035810864474, 3.599515258617589],
            [30.91948855921264, 3.598695099686176],
            [30.91915993661708, 3.599954318998185],
            [30.917174216969745, 3.599327958184529],
            [30.91643425041572, 3.598827179427628],
            [30.91655750735753, 3.598344746381515],
            [30.915246366793028, 3.598325372955671],
            [30.911138930649162, 3.596008717438903],
            [30.90923739482205, 3.594188028527851],
            [30.90831096226955, 3.59236313026581],
            [30.90856186891491, 3.590431126250456],
            [30.90747644623522, 3.587859614046999],
            [30.908227448592523, 3.587084090406348],
            [30.907211631872595, 3.586132692263479],
            [30.905835831472245, 3.585908627577754],
            [30.905267554528567, 3.585121889040115],
            [30.905409651836838, 3.583518628043016],
            [30.903377742614207, 3.574587873899382],
            [30.901982146039956, 3.572334742976541],
            [30.900102748294714, 3.57154499913278],
            [30.900194708830345, 3.570215418986182],
            [30.89948963913013, 3.568844443027214],
            [30.897728445303226, 3.566900882755169],
            [30.896181405348468, 3.566098671834902],
            [30.89608943133811, 3.564558007100913],
            [30.89541888928417, 3.562938581603783],
            [30.89307002478492, 3.561334795897219],
            [30.892569187962874, 3.559745001249761],
            [30.890340156027563, 3.558774998457206],
            [30.889083804610564, 3.55667666455639],
            [30.88729381618553, 3.552486535598123],
            [30.88688798339128, 3.547860497073443],
            [30.885368955602047, 3.545823935315544],
            [30.88518211770104, 3.544232925955322],
            [30.884398500210718, 3.543346142542448],
            [30.88305134977973, 3.539013804941215],
            [30.881588671511622, 3.538376609267365],
            [30.882055541236156, 3.537217636436655],
            [30.881844597044502, 3.535758126370289],
            [30.880623796454838, 3.533447195841116],
            [30.880579823921686, 3.531844559517954],
            [30.879279897026873, 3.527321270225738],
            [30.879260421551507, 3.525778215056869],
            [30.877562523917817, 3.523896731173345],
            [30.877363235367007, 3.522544886704872],
            [30.875002515800922, 3.519011519683188],
            [30.87455895915467, 3.515147689890429],
            [30.873681821653353, 3.51351923596028],
            [30.873532068902257, 3.511318405549688],
            [30.872501413810472, 3.509151440187439],
            [30.870364521175553, 3.506659049328967],
            [30.869811153570637, 3.503978935732704],
            [30.870052892908525, 3.50235304555111],
            [30.86858056853092, 3.500747156562673],
            [30.866314780229107, 3.493163782459968],
            [30.86441402952956, 3.490671280023446],
            [30.863719165589302, 3.488012526475246],
            [30.863001813224237, 3.487034403245852],
            [30.863061362544393, 3.485494696947014],
            [30.862306297107086, 3.484430390938001],
            [30.8620528401446, 3.481948401066659],
            [30.86357112233217, 3.480834602698797],
            [30.866589663807765, 3.481037944993634],
            [30.87045900687543, 3.480598270509779],
            [30.87106217168981, 3.479672804851129],
            [30.875023882229957, 3.480506970070921],
            [30.87719743600995, 3.482574853843059],
            [30.87873511731608, 3.481579739581054],
            [30.879593825879304, 3.486126185655928],
            [30.880499140836147, 3.488466264151991],
            [30.882632068307405, 3.49008558983139],
            [30.884126555021403, 3.492438964708411],
            [30.889032856659213, 3.494070539784029],
            [30.890915949175223, 3.495647440955339],
            [30.89305668839621, 3.499114495616172],
            [30.89587470523911, 3.499792029281948],
            [30.903141863885224, 3.500265007629708],
            [30.90539640078809, 3.501298702380091],
            [30.912255381138763, 3.505605127048215],
            [30.93031837069856, 3.505036771863943],
            [30.93338164019046, 3.506177268371761],
            [30.936605130501473, 3.506467158112862],
            [30.937493974847563, 3.506142935365239],
            [30.93804711697534, 3.505238928047949],
            [30.94012794216011, 3.500687698633434],
            [30.94058012981962, 3.502027221776009],
            [30.941198124022716, 3.502198867825034],
            [30.946641816728093, 3.501016407361571],
            [30.94814171219845, 3.500305521387597],
            [30.95171205461708, 3.500711171747783],
            [30.957023804570184, 3.499312394037085],
            [30.959478552593648, 3.495928019621843],
            [30.960402467168414, 3.491012394701988],
            [30.964839295764044, 3.4869557067749],
            [30.968250091998318, 3.486188112993208],
            [30.973549883578357, 3.488237566172975],
            [30.975477496599847, 3.488050448543649],
            [30.97462704355408, 3.488970585240262],
            [30.97380686732662, 3.490812929878459],
            [30.97374964643967, 3.493063411869815],
            [30.971609561192203, 3.50266038503718],
            [30.97051853302512, 3.501367312259101],
            [30.97001116545098, 3.499727130480565],
            [30.968511956293536, 3.49910157323187],
            [30.966684676106098, 3.499002401189147],
            [30.96125242973407, 3.501645767767213],
            [30.955614183497676, 3.503655948584048],
            [30.955984218427822, 3.504334907304059],
            [30.958719417788082, 3.506951567848916],
            [30.962213760038747, 3.508992256793865],
            [30.965902654023726, 3.510495117846315],
            [30.96789778621862, 3.512737969751303],
            [30.970362135435856, 3.513039303800051],
            [30.971338720032353, 3.513584759649803],
            [30.973005779400644, 3.513325380747137],
            [30.974848319269814, 3.514927417741074],
            [30.97715244856624, 3.515530087016869],
            [30.977884887238186, 3.516434093338495],
            [30.976935007758446, 3.517971287531619],
            [30.974154038336174, 3.526694769406286],
            [30.9754968427178, 3.528910921550898],
            [30.977156270897755, 3.526328586757391],
            [30.98004024654041, 3.527118160349093],
            [30.980646797105084, 3.527610215534755],
            [30.980311098480026, 3.530760890197049],
            [30.980589578913058, 3.532687150251909],
            [30.98229860397816, 3.536711315988039],
            [30.983504075715796, 3.53839345553743],
            [30.98766218941811, 3.540087035353693],
            [30.989588655290973, 3.542612151264995],
            [30.993990914917827, 3.544687168852897],
            [30.998728871373075, 3.542333695458136],
            [30.999774120494973, 3.54130381287989],
            [31.00167006610608, 3.540720211287287],
            [31.00269624219784, 3.540624851538425],
            [31.00459981899729, 3.541612773111354],
            [31.00680095105651, 3.544954166345603],
            [31.00670176716765, 3.54635404282776],
            [31.00811323876964, 3.549371212159056],
            [31.00978792752962, 3.550366764241526],
            [31.009467487687996, 3.552273952497456],
            [31.01217217127802, 3.557453874365867],
            [31.012175987321356, 3.558392210327994],
            [31.01424360008496, 3.559662396449967],
            [31.014792929762653, 3.561924321610991],
            [31.015880143683024, 3.56246214748914],
            [31.016139549289324, 3.56310296306577],
            [31.01546433240262, 3.563263167338488],
            [31.015193484056255, 3.564205318594598],
            [31.015792405229217, 3.565353445729086],
            [31.016589695078192, 3.56598663211959],
            [31.01784475831109, 3.566154463060606],
            [31.018081275742244, 3.567764129959601],
            [31.018703085090348, 3.568424017341761],
            [31.019836075360978, 3.568427830469317],
            [31.019523264012737, 3.569205962789328],
            [31.019984853439993, 3.569957395429511],
            [31.019405007093766, 3.571029236010673],
            [31.01959574637807, 3.57177303913834],
            [31.02099195739997, 3.573241572668297],
            [31.022002875606628, 3.573550536538303],
            [31.022239391241154, 3.573062295628282],
            [31.023299900943105, 3.573371259558692],
            [31.025016554501597, 3.57571710098446],
            [31.02465033651308, 3.576918628398293],
            [31.026092323885244, 3.577311508614137],
            [31.02689342798089, 3.57847870809724],
            [31.028579562175924, 3.579142408028603],
            [31.028770303256856, 3.580759703397304],
            [31.029994848922925, 3.582861424167992],
            [31.033332785499443, 3.58622188795472],
            [31.033618896222496, 3.588781333568792],
            [31.034111004114912, 3.589643382984539],
            [31.034828182206837, 3.589879873870309],
            [31.035755173511433, 3.588968237201156],
            [31.036502870966817, 3.589593794645296],
            [31.037193348433547, 3.591901491981497],
            [31.036724130512873, 3.592404990192489],
            [31.035552992385405, 3.592610967183048],
            [31.03559114203887, 3.593858269008138],
            [31.037708347196034, 3.597066157668061],
            [31.0388604113951, 3.597123372513721],
            [31.039146522118145, 3.598443146595132],
            [31.040176513354908, 3.599366225342498],
            [31.041687167947398, 3.602154533457232],
            [31.041244656940126, 3.606800444891418],
            [31.04128662173863, 3.608818251040228],
            [31.041809247197882, 3.609081441997658],
            [31.041725322092482, 3.60986720414745],
            [31.03990185794838, 3.611968926844944],
            [31.038250060956766, 3.616027425118233],
            [31.03702933223233, 3.616691127288895],
            [31.037487106514615, 3.618464812976015],
            [31.03596119673195, 3.620860242424089],
            [31.0360565663741, 3.621916825340104],
            [31.035430942779325, 3.622332592247761],
            [31.034118660456073, 3.625330693851879],
            [31.03296278201033, 3.62653985238257],
            [31.031856495059827, 3.626093570870978],
            [31.029834662239768, 3.626993765714511],
            [31.028442268159466, 3.62844704386165],
            [31.02866734195223, 3.631395557955911],
            [31.027473316547947, 3.632005858036106],
            [31.027179579128145, 3.632791620014357],
            [31.02811801676609, 3.634206754035179],
            [31.02844990294107, 3.635545599326733],
            [31.02824772001841, 3.636827230294624],
            [31.027217731476572, 3.638227107538891],
            [31.025028045750695, 3.638700092605697],
            [31.025344674040575, 3.639260805704586],
            [31.026107630279387, 3.638738235279417],
            [31.02611144452606, 3.639371421716021],
            [31.023154991907987, 3.641907985691861],
            [31.023101585267717, 3.642892094208304],
            [31.024322315788783, 3.644051663559737],
            [31.023925579335113, 3.645081545817459],
            [31.02362039827691, 3.645462984121924],
            [31.021926634690168, 3.645684219089138],
            [31.020911904033433, 3.646748430805439],
            [31.021003459428872, 3.648041504823852],
            [31.01997346819208, 3.647560894593526],
            [31.01971406168748, 3.646420396458026],
            [31.01778378336454, 3.646904822785973],
            [31.0159259865086, 3.649929625416701],
            [31.015441509804525, 3.64976560839034],
            [31.0159221713636, 3.648815826991087],
            [31.015449138297914, 3.648274186498946],
            [31.014678551769087, 3.648361917477931],
            [31.01419789021002, 3.649311698460571],
            [31.012893235481858, 3.649182009867064],
            [31.01364093383557, 3.650494155056696],
            [31.01327471584706, 3.652580619939991],
            [31.01227905732213, 3.652279285219443],
            [31.012267614582036, 3.652912471982469],
            [31.013045829604245, 3.653919465679285],
            [31.012710130979187, 3.656604788332126],
            [31.011725918787608, 3.657531682279746],
            [31.01084470562986, 3.659412171755871],
            [31.011001113100594, 3.661555851754946],
            [31.009898643091752, 3.663569843695019],
            [31.00994823638365, 3.664916318180276],
            [31.009440871504427, 3.666243722576378],
            [31.00821632763502, 3.667372778874888],
            [31.008170551284763, 3.669505016036296],
            [31.007518224369825, 3.669928412339162],
            [31.00836892175737, 3.671450347241299],
            [31.010016908095558, 3.67290743876124],
            [31.01054716474315, 3.674337830167789],
            [31.00818200210969, 3.676504397915087],
            [31.005835911608017, 3.677526652478385],
            [31.003733970624168, 3.681341032493588],
            [31.004824998791243, 3.682744721848356],
            [31.005202663113103, 3.683702130144246],
            [31.005099664079243, 3.684850258005288],
            [31.006568357466506, 3.687295272529328],
            [31.007739497390606, 3.690606150624227],
            [31.010097036022263, 3.694607431548218],
            [31.010772252010636, 3.694943096691321],
            [31.013976668393212, 3.694889691698627],
            [31.01524699040954, 3.69353558710724],
            [31.01600994575002, 3.693390640194028],
            [31.018195815432552, 3.694111556547909],
            [31.019157141245646, 3.693997123954111],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 476,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "KULUBA",
        Population: 40481,
        Key: "KOBOKOKULUBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.08406141765323, 3.391285659121113],
            [31.083500989290197, 3.393635909927589],
            [31.082513959981885, 3.393778598290166],
            [31.08135608368293, 3.392919513934817],
            [31.080388736462496, 3.393512584853566],
            [31.082010412942633, 3.395300104604011],
            [31.085214947902823, 3.3971381315384],
            [31.087396405060684, 3.400146370183398],
            [31.087391634108233, 3.402564127799884],
            [31.088668304518645, 3.406958373069739],
            [31.089776075485993, 3.407439162429239],
            [31.088923701842134, 3.407981814929621],
            [31.08257481635079, 3.406818162522649],
            [31.078524536415213, 3.405530892837827],
            [31.077140438276576, 3.403562849669528],
            [31.07688051793564, 3.402072528590543],
            [31.07583889351593, 3.402387418729716],
            [31.07433661930673, 3.401687053843785],
            [31.07358994323585, 3.401738384605672],
            [31.072747391771284, 3.402412913713289],
            [31.072669475496806, 3.404578772472409],
            [31.072162520249368, 3.405697740901553],
            [31.0704671217288, 3.406930543127706],
            [31.06982202176035, 3.40809754825938],
            [31.06853985994858, 3.408427018990618],
            [31.066027506559212, 3.40804157727628],
            [31.064385945870256, 3.408640516932696],
            [31.061689738783244, 3.410801065626417],
            [31.060921494162354, 3.413133065389455],
            [31.05996650596358, 3.413385989343483],
            [31.05947801558681, 3.414002030624154],
            [31.057233385304933, 3.414963259510087],
            [31.054375955777246, 3.415292790658103],
            [31.05145729168988, 3.41619897315779],
            [31.051340950877453, 3.417620583772279],
            [31.04967673737196, 3.418717106547621],
            [31.04849915473065, 3.41851407822086],
            [31.046665469555233, 3.416677313439681],
            [31.045117027330342, 3.417077806691402],
            [31.045115216326725, 3.417971149203503],
            [31.044193565506475, 3.41779063639907],
            [31.04277064936779, 3.419243082724018],
            [31.041489356226915, 3.418646739396614],
            [31.040330919379205, 3.419675722164554],
            [31.037031545681213, 3.419303400333999],
            [31.034690010536348, 3.42070853907734],
            [31.0285138746674, 3.422980443088293],
            [31.026042106264228, 3.424528884351531],
            [31.02400825039239, 3.424542118912091],
            [31.02284178889428, 3.42550919005954],
            [31.022674047379603, 3.426184142757356],
            [31.02082663055676, 3.428232948161493],
            [31.01855816258051, 3.4293249680799],
            [31.017206015719896, 3.429267529529898],
            [31.015563155168714, 3.428492550395428],
            [31.01431951131972, 3.428544581846123],
            [31.013604528710367, 3.429260022300836],
            [31.01291895694338, 3.428896711619921],
            [31.011987665403513, 3.429102206379714],
            [31.011541529694053, 3.428717384528166],
            [31.011000274074142, 3.429013226148036],
            [31.00731170977086, 3.426731510314372],
            [31.00427416623207, 3.42555269664821],
            [31.003512923978825, 3.424412632013754],
            [31.002122486429236, 3.424025832820452],
            [31.001849511770605, 3.423568941971906],
            [31.00032034020515, 3.424036541351238],
            [30.99863987437957, 3.423370402717931],
            [30.998138749198322, 3.422839746172354],
            [30.996798539151207, 3.422552771136408],
            [30.995595419202978, 3.421376342069434],
            [30.992157453422926, 3.420717193271628],
            [30.987850214891917, 3.418738343487624],
            [30.984254872358928, 3.416620789680982],
            [30.982821386642595, 3.41488632898858],
            [30.979774855459382, 3.409593503999886],
            [30.981165020819446, 3.405383093961362],
            [30.982396638023438, 3.404186061218902],
            [30.983645951140215, 3.403951256871114],
            [30.983850339426915, 3.403392573930323],
            [30.981054070797036, 3.402147758139288],
            [30.979455188168927, 3.40023643724127],
            [30.976205794038346, 3.397528725777755],
            [30.973022581489722, 3.39856271608762],
            [30.971321485853636, 3.398373286089671],
            [30.969772324976496, 3.39869166932416],
            [30.969542777573622, 3.398369150345053],
            [30.970378430875105, 3.396563477346361],
            [30.972039558667568, 3.394420870973562],
            [30.97310576638335, 3.393280699488039],
            [30.974487813668176, 3.392557357972847],
            [30.977582022935106, 3.39247410453414],
            [30.98020113121454, 3.392999924667487],
            [30.982397682764127, 3.3913339935238],
            [30.9845682927649, 3.39038802605228],
            [30.98708986286912, 3.390746576127817],
            [30.98879125584758, 3.391753570113758],
            [30.99072916356224, 3.390273590875295],
            [30.992430555642372, 3.389987511841034],
            [30.994013690803534, 3.390399463112698],
            [30.995661674446765, 3.38703899624724],
            [30.995455673684145, 3.384948718234432],
            [30.99586766981951, 3.384590166907922],
            [30.996161407239313, 3.382644834322919],
            [30.9979238335548, 3.380108274447202],
            [31.000750587412178, 3.379707762262847],
            [31.002397625129397, 3.376459087379474],
            [30.999552473775033, 3.374658786349191],
            [30.997833990348298, 3.372678573232922],
            [30.996516172606263, 3.369843788893955],
            [30.994650742765387, 3.367841242832282],
            [30.9934185686059, 3.367314860241906],
            [30.992993541509005, 3.363969807825325],
            [30.991048113098785, 3.360808036627419],
            [30.991697466590125, 3.357555942940605],
            [30.993408374524076, 3.355513576348925],
            [30.9941586267881, 3.353422903281341],
            [30.99412429227964, 3.352312920373701],
            [30.993235447035254, 3.349963265599002],
            [30.99164468068571, 3.347411449777265],
            [30.988741629318, 3.344077687016409],
            [30.987258137084773, 3.339626174561509],
            [30.986938183231715, 3.33828964934841],
            [30.98867673861513, 3.338307382492608],
            [30.993937717585013, 3.33647023638029],
            [30.99837044357473, 3.33439710614916],
            [31.004123047143388, 3.332760682598524],
            [31.0070827974769, 3.332714332593055],
            [31.008287251423326, 3.331747771622834],
            [31.009187181878325, 3.33155117040118],
            [31.012091221392847, 3.331557066842092],
            [31.01425595910663, 3.332255152286562],
            [31.019041989802616, 3.331523303327666],
            [31.023223435447807, 3.332960851032283],
            [31.03154047762434, 3.333780196530392],
            [31.03436890234815, 3.33294157709641],
            [31.037023985459776, 3.332651703942721],
            [31.03865097457651, 3.331796452448916],
            [31.041722881369836, 3.3325878215674],
            [31.04242168891418, 3.332201841322773],
            [31.04356099434127, 3.330340513299795],
            [31.045678517502047, 3.329046496313961],
            [31.04520389352, 3.326700339887599],
            [31.04532363804906, 3.324093625890456],
            [31.045927338259347, 3.322292993599433],
            [31.04947986978083, 3.32487170250193],
            [31.04976735402793, 3.324424255905365],
            [31.050467876456178, 3.32445764748959],
            [31.05883160587466, 3.362652040391999],
            [31.06425186422926, 3.375527512682859],
            [31.06597224849112, 3.374786124122326],
            [31.067062228324254, 3.371564927453966],
            [31.0684961730797, 3.370482483213977],
            [31.07215366016572, 3.373623190426711],
            [31.075780418580838, 3.375550518977465],
            [31.078390042447513, 3.376483761617969],
            [31.08081092218814, 3.376232554256067],
            [31.080330636124856, 3.377543679864754],
            [31.08085412037353, 3.378374701384164],
            [31.080711504737337, 3.379048878221312],
            [31.081564678780108, 3.381610375930424],
            [31.080834896426445, 3.381797270509381],
            [31.08086185486814, 3.382158764211288],
            [31.08187860134436, 3.382917811319892],
            [31.081604911626748, 3.384189863724018],
            [31.082682739949043, 3.384640205466825],
            [31.08209648591989, 3.38747160172517],
            [31.083450561463398, 3.388336190656726],
            [31.083504201665647, 3.389198193502568],
            [31.084998869839325, 3.388923135138728],
            [31.08532870875378, 3.390035914461082],
            [31.08406141765323, 3.391285659121113],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 477,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "LOBULE",
        Population: 33679,
        Key: "KOBOKOLOBULE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.965932198715098, 3.289696798513638],
            [30.963322397880326, 3.292249772381406],
            [30.961777590239056, 3.292816229689747],
            [30.959253032338225, 3.291185136334297],
            [30.957255689389406, 3.287792475199046],
            [30.952609116751383, 3.288493786910184],
            [30.949616442264382, 3.287563463434706],
            [30.94527826306004, 3.287364927039582],
            [30.94466871661388, 3.286896547479272],
            [30.94445648962801, 3.285657116366477],
            [30.94235787600397, 3.287010252120357],
            [30.941472800090512, 3.285426201019991],
            [30.940124467476608, 3.285391703216701],
            [30.940458429658214, 3.280390398793348],
            [30.938365713473985, 3.277753770012598],
            [30.93849019122629, 3.276691832365688],
            [30.93693198341591, 3.273798729958986],
            [30.93505922152566, 3.271751386909812],
            [30.93515228609079, 3.270103132875018],
            [30.934666949698965, 3.269102104994848],
            [30.93531275843819, 3.265303817539793],
            [30.935519558701433, 3.264996557022357],
            [30.936393035567942, 3.265623575659697],
            [30.93814374246223, 3.265050818671374],
            [30.93954259992098, 3.260661538477327],
            [30.941331055820132, 3.260635917848675],
            [30.942916517617913, 3.260059871020369],
            [30.943437519821433, 3.257175155682992],
            [30.942693901615776, 3.254819286420279],
            [30.944064754095542, 3.254626722051575],
            [30.94482088762974, 3.255605174996094],
            [30.945871094553677, 3.255363104687623],
            [30.94594355805441, 3.253178886292899],
            [30.946605851777402, 3.252506177019391],
            [30.94813993712745, 3.253300610959491],
            [30.949199327528525, 3.253322311566774],
            [30.94988816377322, 3.253939173286368],
            [30.952950295099637, 3.253710969041443],
            [30.954303187561933, 3.252785668039214],
            [30.95434301437005, 3.252316825688375],
            [30.953518475923584, 3.251510172924697],
            [30.95514412116066, 3.250282575347406],
            [30.956070563594636, 3.248754616711608],
            [30.956140801070056, 3.247660611239455],
            [30.958291965239926, 3.246101919940197],
            [30.959268221951348, 3.243958596977462],
            [30.959046358737403, 3.243117997932404],
            [30.95994031898903, 3.243237040357577],
            [30.9618374431898, 3.242332353450022],
            [30.96345527488052, 3.240638481751069],
            [30.966495691231593, 3.24590166769633],
            [30.966016981711622, 3.247121852564452],
            [30.967844670632505, 3.25020609921864],
            [30.96782218220767, 3.250567892154076],
            [30.969271816937855, 3.250634642597926],
            [30.9715438979382, 3.251518873452333],
            [30.970335805814866, 3.255097439571499],
            [30.967879829794406, 3.257289521994394],
            [30.965967994782535, 3.260920278359697],
            [30.965625952254978, 3.262420451773408],
            [30.965624735037746, 3.264002689048148],
            [30.96821442618659, 3.265644447305726],
            [30.96882742126511, 3.266540790461716],
            [30.967734953098653, 3.268383012110569],
            [30.967254667035338, 3.272495865420799],
            [30.966504242294764, 3.273253811371513],
            [30.966094269165396, 3.274419312688033],
            [30.966162047951897, 3.274961933813105],
            [30.96875079227644, 3.277498803915927],
            [30.969566673658505, 3.280384673345337],
            [30.968678284758283, 3.283330353721358],
            [30.968949619093205, 3.284831779649348],
            [30.969494718604235, 3.285384419091403],
            [30.96704371835213, 3.286590950945981],
            [30.967060792630733, 3.287458958610806],
            [30.96575741890016, 3.288893867198497],
            [30.965932198715098, 3.289696798513638],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 478,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "MARACHA TOWN COUNCIL",
        Population: 9291,
        Key: "MARACHAMARACHA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.967844670632505, 3.25020609921864],
            [30.966016981711622, 3.247121852564452],
            [30.966495691231593, 3.24590166769633],
            [30.96345527488052, 3.240638481751069],
            [30.9618374431898, 3.242332353450022],
            [30.95994031898903, 3.243237040357577],
            [30.959046358737403, 3.243117997932404],
            [30.959268221951348, 3.243958596977462],
            [30.958291965239926, 3.246101919940197],
            [30.956140801070056, 3.247660611239455],
            [30.956070563594636, 3.248754616711608],
            [30.95514412116066, 3.250282575347406],
            [30.953518475923584, 3.251510172924697],
            [30.95434301437005, 3.252316825688375],
            [30.954303187561933, 3.252785668039214],
            [30.952950295099637, 3.253710969041443],
            [30.94988816377322, 3.253939173286368],
            [30.949199327528525, 3.253322311566774],
            [30.94813993712745, 3.253300610959491],
            [30.946605851777402, 3.252506177019391],
            [30.94594355805441, 3.253178886292899],
            [30.945871094553677, 3.255363104687623],
            [30.94482088762974, 3.255605174996094],
            [30.944064754095542, 3.254626722051575],
            [30.942693901615776, 3.254819286420279],
            [30.943437519821433, 3.257175155682992],
            [30.942916517617913, 3.260059871020369],
            [30.941331055820132, 3.260635917848675],
            [30.93954259992098, 3.260661538477327],
            [30.93814374246223, 3.265050818671374],
            [30.936393035567942, 3.265623575659697],
            [30.935519558701433, 3.264996557022357],
            [30.93531275843819, 3.265303817539793],
            [30.93246837963497, 3.26432366103078],
            [30.929209458870837, 3.262387814161137],
            [30.92776488884222, 3.260135194830985],
            [30.927235181065257, 3.257299666423156],
            [30.926389812483965, 3.256512405172901],
            [30.924751826191564, 3.256420289988778],
            [30.923289399451708, 3.256821450352219],
            [30.922715136134983, 3.254631721184801],
            [30.919898120913604, 3.250610846844578],
            [30.91830193862123, 3.247462768304823],
            [30.91953974701418, 3.246973848768433],
            [30.919749567413394, 3.246504143615577],
            [30.917856920415993, 3.240876655961967],
            [30.917327318640258, 3.24033309357457],
            [30.917856008626007, 3.23761281352585],
            [30.919594744570812, 3.231757756953922],
            [30.92186355750015, 3.229095294269699],
            [30.922619488913426, 3.226438753954165],
            [30.924283082581354, 3.223775030648676],
            [30.92148267092136, 3.218308439815019],
            [30.925717556444486, 3.213064199636835],
            [30.927003457044446, 3.211999966999589],
            [30.928818329701176, 3.209562551025551],
            [30.93035014770342, 3.20647440049195],
            [30.931675019915392, 3.20522498586209],
            [30.929316777004544, 3.200247748285626],
            [30.930423804166832, 3.198673265002898],
            [30.931856147226117, 3.199046017743356],
            [30.93303884217971, 3.198367111731785],
            [30.93340999820733, 3.196771661013416],
            [30.932869192643366, 3.196050331067079],
            [30.932948375542416, 3.195193991022966],
            [30.934383289580033, 3.194281999992462],
            [30.934423248440492, 3.193668906830053],
            [30.93332055564947, 3.193082700292138],
            [30.9321808100479, 3.191659389386345],
            [30.931604862390007, 3.189147130527947],
            [30.932360011370644, 3.188178848504961],
            [30.93230092108957, 3.187915968744939],
            [30.933311757549564, 3.188596100586475],
            [30.936186215541763, 3.188285458789932],
            [30.93664005879635, 3.188060343189266],
            [30.936791077273732, 3.186614051460556],
            [30.937849917905837, 3.185775349696176],
            [30.938379204372925, 3.18577641524547],
            [30.939136266765153, 3.186998505388905],
            [30.941708811770166, 3.188820972106431],
            [30.943985047478687, 3.189114869065157],
            [30.94428081059948, 3.188663399524911],
            [30.946398946411268, 3.188739982523805],
            [30.948668839115584, 3.190109770888931],
            [30.949199940179543, 3.195427117234546],
            [30.950712680660125, 3.195050419426489],
            [30.95216640092821, 3.195803763779997],
            [30.95411711053397, 3.195274236551199],
            [30.958353463904253, 3.195273673286223],
            [30.960843941519865, 3.194853704457738],
            [30.961608182349494, 3.195307298768957],
            [30.962894206018692, 3.19515616167799],
            [30.963272512635978, 3.195464322314237],
            [30.961381780846757, 3.197359235933403],
            [30.96176034617884, 3.197821101397841],
            [30.964256218177724, 3.196524125228642],
            [30.96493714834961, 3.196606855114507],
            [30.96554349140345, 3.199872004771628],
            [30.965014117799775, 3.200476720635665],
            [30.96433302593115, 3.200475361810699],
            [30.9647877378566, 3.202374959710618],
            [30.963653490842898, 3.204660161104348],
            [30.96456161483162, 3.205421453086688],
            [30.966603984935723, 3.205036754029179],
            [30.966679814423777, 3.205498016896229],
            [30.96486457884772, 3.207013341264137],
            [30.965244037105183, 3.210431743367734],
            [30.96584963365904, 3.211653544019529],
            [30.963958449118916, 3.212336899723247],
            [30.9638073084707, 3.212716334797151],
            [30.963612081203266, 3.217742946929115],
            [30.963884641738563, 3.218927913987494],
            [30.965972629191096, 3.218660863474625],
            [30.96679031798353, 3.220660650357803],
            [30.966608879855706, 3.221573468112735],
            [30.96769868361904, 3.22257924909296],
            [30.968516582617223, 3.225040150464769],
            [30.969151997848634, 3.225403083371098],
            [30.969061433294925, 3.226135253943287],
            [30.969969339891357, 3.22658914737764],
            [30.970514707998646, 3.228416607359678],
            [30.971331847920457, 3.229421843436969],
            [30.970333851979145, 3.231155789763819],
            [30.970425146863125, 3.232882883612438],
            [30.968973878995786, 3.237355457834953],
            [30.96897461651264, 3.240085961205389],
            [30.970156065502927, 3.244193141647583],
            [30.970065591679088, 3.245015726065906],
            [30.96764876334037, 3.24718982118969],
            [30.967844670632505, 3.25020609921864],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 479,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "NYADRI",
        Population: 19188,
        Key: "MARACHANYADRI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.917992328868678, 3.369305658900939],
            [30.91242299778765, 3.365731610750448],
            [30.911667938638516, 3.364382867778947],
            [30.91053791999486, 3.359570595920067],
            [30.905098452066223, 3.358193689352521],
            [30.90358676081792, 3.357430984745393],
            [30.902327471909906, 3.356035954034629],
            [30.900902309983014, 3.352407439886775],
            [30.8977541919176, 3.349145895769446],
            [30.896623359400266, 3.345264879859704],
            [30.895071169403984, 3.34281143111569],
            [30.8927619816942, 3.341251406419854],
            [30.889213036247337, 3.339833359872058],
            [30.888206230528027, 3.338438882526335],
            [30.888460680128876, 3.335528253036406],
            [30.891404396432865, 3.332316025034754],
            [30.891596163389845, 3.329260599968839],
            [30.89140671139135, 3.328193360827343],
            [30.88899338468562, 3.327103255687905],
            [30.888279745955924, 3.326387487938124],
            [30.88811249941295, 3.325455911309047],
            [30.890130916838338, 3.323344673290863],
            [30.89097251608868, 3.32165582472683],
            [30.891688504811146, 3.319677394941803],
            [30.89198541328391, 3.316341921282603],
            [30.893417036792655, 3.312538744198578],
            [30.893443708671743, 3.311592826094552],
            [30.891028613183227, 3.313221374851219],
            [30.888798973088484, 3.313703465936588],
            [30.887658627412286, 3.313289889626201],
            [30.88655147807913, 3.312454431985197],
            [30.883967380739577, 3.307482852368938],
            [30.882882530286704, 3.306290409785262],
            [30.878266253331628, 3.305166121479311],
            [30.875676750829005, 3.302758693935699],
            [30.87475460503702, 3.30100400394255],
            [30.874684423257147, 3.298569537737663],
            [30.87525225373813, 3.294805680412405],
            [30.876312249603707, 3.292481826918439],
            [30.876259752058502, 3.291854200923239],
            [30.86939966408507, 3.286955823953106],
            [30.867152955101613, 3.283316595287789],
            [30.86756300728273, 3.282160252124148],
            [30.87139951333352, 3.277765585954949],
            [30.871723315569255, 3.278122692813698],
            [30.87384476616443, 3.27779180344529],
            [30.880485293306016, 3.274975358734083],
            [30.88154387252841, 3.273807266170264],
            [30.88300571446499, 3.269775797775766],
            [30.8851155579284, 3.270436147632886],
            [30.887764064473814, 3.270499629525502],
            [30.887429148281388, 3.271206413397889],
            [30.888942595736093, 3.271001869332587],
            [30.89063714355207, 3.270025622388375],
            [30.89100237339377, 3.26865875704396],
            [30.890704217161083, 3.266105462860682],
            [30.889055608290406, 3.262785332690708],
            [30.888809052185948, 3.261133532995129],
            [30.8896528253593, 3.258999407921772],
            [30.88979958222895, 3.257133049705754],
            [30.89033643251073, 3.256595709550492],
            [30.895319889549977, 3.25697435944745],
            [30.899485925494766, 3.256578629660373],
            [30.899464990257073, 3.254879134300722],
            [30.898127388019233, 3.248463049092291],
            [30.900660661374943, 3.246455516921418],
            [30.904358810702313, 3.248652693526795],
            [30.906606117963772, 3.247941411241442],
            [30.90988751277969, 3.249529345765129],
            [30.91324135043507, 3.249576096954243],
            [30.91383426726866, 3.249915427992363],
            [30.915349890442997, 3.248993774671458],
            [30.915886204430542, 3.247990535628177],
            [30.91674810560632, 3.248106595379247],
            [30.91830193862123, 3.247462768304823],
            [30.919898120913604, 3.250610846844578],
            [30.922715136134983, 3.254631721184801],
            [30.923289399451708, 3.256821450352219],
            [30.924751826191564, 3.256420289988778],
            [30.926389812483965, 3.256512405172901],
            [30.927235181065257, 3.257299666423156],
            [30.92776488884222, 3.260135194830985],
            [30.929209458870837, 3.262387814161137],
            [30.93246837963497, 3.26432366103078],
            [30.93531275843819, 3.265303817539793],
            [30.934666949698965, 3.269102104994848],
            [30.93515228609079, 3.270103132875018],
            [30.93505922152566, 3.271751386909812],
            [30.93693198341591, 3.273798729958986],
            [30.93849019122629, 3.276691832365688],
            [30.938365713473985, 3.277753770012598],
            [30.940458429658214, 3.280390398793348],
            [30.940124467476608, 3.285391703216701],
            [30.941472800090512, 3.285426201019991],
            [30.94235787600397, 3.287010252120357],
            [30.94445648962801, 3.285657116366477],
            [30.94466871661388, 3.286896547479272],
            [30.94527826306004, 3.287364927039582],
            [30.949616442264382, 3.287563463434706],
            [30.952609116751383, 3.288493786910184],
            [30.957255689389406, 3.287792475199046],
            [30.959253032338225, 3.291185136334297],
            [30.961777590239056, 3.292816229689747],
            [30.963322397880326, 3.292249772381406],
            [30.965932198715098, 3.289696798513638],
            [30.966260676681884, 3.290115484947223],
            [30.96592383090823, 3.290838103799528],
            [30.9659215725436, 3.293749422605848],
            [30.966929345748483, 3.294465759213161],
            [30.967768733346567, 3.295733275246965],
            [30.969637274951623, 3.296605081984364],
            [30.96988825256392, 3.298160717270488],
            [30.969214900579754, 3.299850075833744],
            [30.96721373799438, 3.300876682613465],
            [30.96589360080228, 3.302935400380313],
            [30.967275919378334, 3.305970833297013],
            [30.968805306539466, 3.307826961740909],
            [30.970084432943874, 3.308687817579919],
            [30.972426987676577, 3.311501369769825],
            [30.973629524618193, 3.311854934660303],
            [30.97501360748545, 3.312949511104586],
            [30.97467938119917, 3.31570935549275],
            [30.972710202231152, 3.320132959798054],
            [30.970254690639656, 3.322386516062345],
            [30.96880681750575, 3.32608843318937],
            [30.968846917401716, 3.327135716301849],
            [30.970451666926973, 3.329833885856912],
            [30.96627960418493, 3.32987572868813],
            [30.965683984320638, 3.328915116989299],
            [30.96543375859824, 3.326556435518373],
            [30.964071055634736, 3.326509669104893],
            [30.96427289899423, 3.327586638564189],
            [30.963434892106715, 3.327548281500221],
            [30.963445882095904, 3.325746730913399],
            [30.962112529787664, 3.325604816409734],
            [30.961834288306527, 3.326241380080893],
            [30.962928804631833, 3.329121778135221],
            [30.96187201665015, 3.329156199085907],
            [30.961428841787864, 3.328488842086595],
            [30.96036457173816, 3.328618451185362],
            [30.95996955915155, 3.329335329345479],
            [30.95762856030092, 3.328965396052089],
            [30.95721971096395, 3.331296187635603],
            [30.955941029225603, 3.331483545619859],
            [30.95571282570242, 3.332106349529156],
            [30.95450215631255, 3.332324250451331],
            [30.951592543649998, 3.334780879418752],
            [30.951078391100477, 3.334688592121341],
            [30.951428123206888, 3.333822815818346],
            [30.95043789230293, 3.333516705548567],
            [30.94783925662878, 3.335555914630759],
            [30.94698459138266, 3.335531319173279],
            [30.947693518448677, 3.33288768056211],
            [30.94661367700182, 3.332026512209032],
            [30.94415322287966, 3.333354720088833],
            [30.94364002164607, 3.334282813269775],
            [30.94058083409881, 3.336989418185794],
            [30.939401409012852, 3.338784411484134],
            [30.939028943241524, 3.340861892643698],
            [30.938449562222626, 3.341520679609991],
            [30.937309988199274, 3.341861839230259],
            [30.936704196711013, 3.343108872840472],
            [30.937276976010907, 3.344940942383316],
            [30.936719106948104, 3.346803053429355],
            [30.937881442484112, 3.348242495184413],
            [30.93743307266458, 3.3495105708096],
            [30.936441064892954, 3.348766651483349],
            [30.934089235953248, 3.349984037720354],
            [30.93427397898299, 3.350446315280151],
            [30.932278088610015, 3.350194809755684],
            [30.93185225841925, 3.351780180215505],
            [30.932267217198444, 3.353157388169653],
            [30.930667345525187, 3.354455666227234],
            [30.931142669294868, 3.355828337215546],
            [30.929907492965715, 3.357261359139703],
            [30.928100786893232, 3.357727650802408],
            [30.92767933778611, 3.359073883047385],
            [30.92650190067186, 3.360427542284079],
            [30.926500739150214, 3.361774670264693],
            [30.924860437899294, 3.363977201672689],
            [30.92334684312087, 3.365022733270783],
            [30.92158048847267, 3.36713457023836],
            [30.92023559371133, 3.367637988592845],
            [30.917992328868678, 3.369305658900939],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 480,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "OLEBA",
        Population: 32115,
        Key: "MARACHAOLEBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.91830193862123, 3.247462768304823],
            [30.91674810560632, 3.248106595379247],
            [30.915886204430542, 3.247990535628177],
            [30.915349890442997, 3.248993774671458],
            [30.91383426726866, 3.249915427992363],
            [30.91324135043507, 3.249576096954243],
            [30.90988751277969, 3.249529345765129],
            [30.906606117963772, 3.247941411241442],
            [30.904358810702313, 3.248652693526795],
            [30.900660661374943, 3.246455516921418],
            [30.898127388019233, 3.248463049092291],
            [30.899464990257073, 3.254879134300722],
            [30.899485925494766, 3.256578629660373],
            [30.895319889549977, 3.25697435944745],
            [30.89033643251073, 3.256595709550492],
            [30.88979958222895, 3.257133049705754],
            [30.8896528253593, 3.258999407921772],
            [30.888809052185948, 3.261133532995129],
            [30.889055608290406, 3.262785332690708],
            [30.890704217161083, 3.266105462860682],
            [30.89100237339377, 3.26865875704396],
            [30.89063714355207, 3.270025622388375],
            [30.888942595736093, 3.271001869332587],
            [30.887429148281388, 3.271206413397889],
            [30.887764064473814, 3.270499629525502],
            [30.8851155579284, 3.270436147632886],
            [30.88300571446499, 3.269775797775766],
            [30.88154387252841, 3.273807266170264],
            [30.880485293306016, 3.274975358734083],
            [30.87384476616443, 3.27779180344529],
            [30.871723315569255, 3.278122692813698],
            [30.87139951333352, 3.277765585954949],
            [30.865881709617167, 3.273432271003895],
            [30.856983144838065, 3.272174599194807],
            [30.852899621847065, 3.270411916477821],
            [30.846629159280067, 3.266962942171651],
            [30.843565029202114, 3.26732699902268],
            [30.84268992638496, 3.267026766882732],
            [30.84203403315835, 3.266220732187124],
            [30.838975329803027, 3.260572758202517],
            [30.83854321859182, 3.2556085113358],
            [30.836870677703665, 3.248327192727098],
            [30.83771319862547, 3.247090438688335],
            [30.838636405327794, 3.24432598686076],
            [30.842092579060346, 3.240048130835958],
            [30.842156980181393, 3.238874414670866],
            [30.8466521139305, 3.237483484104088],
            [30.849578437952285, 3.237125911696665],
            [30.85100763690806, 3.235917501608414],
            [30.85186778816566, 3.233903252887266],
            [30.852550125997592, 3.234273133480098],
            [30.853598385373992, 3.233749108877745],
            [30.86080932834794, 3.228467420639728],
            [30.860705244149216, 3.223986211426777],
            [30.861845405670774, 3.222062933551029],
            [30.861971459068084, 3.221059536010494],
            [30.865381138696463, 3.221036894764925],
            [30.876986993976544, 3.217005817640545],
            [30.88029514601151, 3.217237715509842],
            [30.884334970455527, 3.215166737547198],
            [30.88244453151709, 3.211284246264553],
            [30.881310022195336, 3.210902162994801],
            [30.87903992377682, 3.208619124538191],
            [30.877082675334083, 3.20824436352046],
            [30.877110472802237, 3.206761718050978],
            [30.87650516550591, 3.20546760986032],
            [30.876731831113364, 3.203641825437768],
            [30.876428772774148, 3.201896306088357],
            [30.87763886005573, 3.200379957941557],
            [30.878621529839958, 3.197642614100879],
            [30.878544847850698, 3.193353067119262],
            [30.879355731006513, 3.191586974601247],
            [30.880318769906875, 3.1919339712229],
            [30.88098795730136, 3.191187561724486],
            [30.883091835951284, 3.192548906800036],
            [30.885230360825062, 3.191686307805738],
            [30.88590922846507, 3.190994356570437],
            [30.89113196884824, 3.189404527077766],
            [30.893170225566656, 3.187735254455054],
            [30.8939381342176, 3.190378270207676],
            [30.90124337244861, 3.191098802289752],
            [30.903772590809147, 3.192052982852722],
            [30.907479387319448, 3.192810985321788],
            [30.909976411856842, 3.195926223611617],
            [30.911760129142877, 3.19717549979738],
            [30.911718425754124, 3.194395889939875],
            [30.912142817742104, 3.192756678554696],
            [30.915137459539547, 3.18574261365327],
            [30.91632737425311, 3.185745035356295],
            [30.922373816751218, 3.189161627511783],
            [30.923288484068436, 3.18916348414459],
            [30.92669224739236, 3.187714758814522],
            [30.92888625042149, 3.187791529341459],
            [30.931080089957206, 3.18893515685031],
            [30.931609625257654, 3.18824909566275],
            [30.932360011370644, 3.188178848504961],
            [30.931604862390007, 3.189147130527947],
            [30.9321808100479, 3.191659389386345],
            [30.93332055564947, 3.193082700292138],
            [30.934423248440492, 3.193668906830053],
            [30.934383289580033, 3.194281999992462],
            [30.932948375542416, 3.195193991022966],
            [30.932869192643366, 3.196050331067079],
            [30.93340999820733, 3.196771661013416],
            [30.93303884217971, 3.198367111731785],
            [30.931856147226117, 3.199046017743356],
            [30.930423804166832, 3.198673265002898],
            [30.929316777004544, 3.200247748285626],
            [30.931675019915392, 3.20522498586209],
            [30.93035014770342, 3.20647440049195],
            [30.928818329701176, 3.209562551025551],
            [30.927003457044446, 3.211999966999589],
            [30.925717556444486, 3.213064199636835],
            [30.92148267092136, 3.218308439815019],
            [30.924283082581354, 3.223775030648676],
            [30.922619488913426, 3.226438753954165],
            [30.92186355750015, 3.229095294269699],
            [30.919594744570812, 3.231757756953922],
            [30.917856008626007, 3.23761281352585],
            [30.917327318640258, 3.24033309357457],
            [30.917856920415993, 3.240876655961967],
            [30.919749567413394, 3.246504143615577],
            [30.91953974701418, 3.246973848768433],
            [30.91830193862123, 3.247462768304823],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 481,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "OLUFFE",
        Population: 23570,
        Key: "MARACHAOLUFFE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.983107466822908, 3.323820309621951],
            [30.98196402914554, 3.323935499622559],
            [30.98034952211967, 3.324881532361536],
            [30.979802224431147, 3.326227581886208],
            [30.979926738116063, 3.328171748840056],
            [30.97741297347336, 3.32747880813756],
            [30.975194820136135, 3.329385415575029],
            [30.975439178063088, 3.330749596683527],
            [30.973872381460303, 3.330389451576556],
            [30.97350752980934, 3.330615726281355],
            [30.97287826354606, 3.331844775450711],
            [30.973357154525715, 3.332871059347077],
            [30.973115803260015, 3.33328800029812],
            [30.97142780955236, 3.331936979612804],
            [30.971686557591852, 3.330143254443882],
            [30.970451666926973, 3.329833885856912],
            [30.968846917401716, 3.327135716301849],
            [30.96880681750575, 3.32608843318937],
            [30.970254690639656, 3.322386516062345],
            [30.972710202231152, 3.320132959798054],
            [30.97467938119917, 3.31570935549275],
            [30.97501360748545, 3.312949511104586],
            [30.973629524618193, 3.311854934660303],
            [30.972426987676577, 3.311501369769825],
            [30.970084432943874, 3.308687817579919],
            [30.968805306539466, 3.307826961740909],
            [30.967275919378334, 3.305970833297013],
            [30.96589360080228, 3.302935400380313],
            [30.96721373799438, 3.300876682613465],
            [30.969214900579754, 3.299850075833744],
            [30.96988825256392, 3.298160717270488],
            [30.969637274951623, 3.296605081984364],
            [30.967768733346567, 3.295733275246965],
            [30.966929345748483, 3.294465759213161],
            [30.9659215725436, 3.293749422605848],
            [30.96592383090823, 3.290838103799528],
            [30.966260676681884, 3.290115484947223],
            [30.965932198715098, 3.289696798513638],
            [30.96575741890016, 3.288893867198497],
            [30.967060792630733, 3.287458958610806],
            [30.96704371835213, 3.286590950945981],
            [30.969494718604235, 3.285384419091403],
            [30.968949619093205, 3.284831779649348],
            [30.968678284758283, 3.283330353721358],
            [30.969566673658505, 3.280384673345337],
            [30.96875079227644, 3.277498803915927],
            [30.966162047951897, 3.274961933813105],
            [30.966094269165396, 3.274419312688033],
            [30.966504242294764, 3.273253811371513],
            [30.967254667035338, 3.272495865420799],
            [30.967734953098653, 3.268383012110569],
            [30.96882742126511, 3.266540790461716],
            [30.96821442618659, 3.265644447305726],
            [30.965624735037746, 3.264002689048148],
            [30.965625952254978, 3.262420451773408],
            [30.965967994782535, 3.260920278359697],
            [30.967879829794406, 3.257289521994394],
            [30.970335805814866, 3.255097439571499],
            [30.9715438979382, 3.251518873452333],
            [30.969271816937855, 3.250634642597926],
            [30.96782218220767, 3.250567892154076],
            [30.967844670632505, 3.25020609921864],
            [30.96764876334037, 3.24718982118969],
            [30.970065591679088, 3.245015726065906],
            [30.970156065502927, 3.244193141647583],
            [30.96897461651264, 3.240085961205389],
            [30.968973878995786, 3.237355457834953],
            [30.970425146863125, 3.232882883612438],
            [30.970333851979145, 3.231155789763819],
            [30.971331847920457, 3.229421843436969],
            [30.970514707998646, 3.228416607359678],
            [30.969969339891357, 3.22658914737764],
            [30.969061433294925, 3.226135253943287],
            [30.969151997848634, 3.225403083371098],
            [30.968516582617223, 3.225040150464769],
            [30.96769868361904, 3.22257924909296],
            [30.966608879855706, 3.221573468112735],
            [30.96679031798353, 3.220660650357803],
            [30.965972629191096, 3.218660863474625],
            [30.963884641738563, 3.218927913987494],
            [30.963612081203266, 3.217742946929115],
            [30.9638073084707, 3.212716334797151],
            [30.963958449118916, 3.212336899723247],
            [30.96584963365904, 3.211653544019529],
            [30.965244037105183, 3.210431743367734],
            [30.96486457884772, 3.207013341264137],
            [30.966679814423777, 3.205498016896229],
            [30.966603984935723, 3.205036754029179],
            [30.96456161483162, 3.205421453086688],
            [30.963653490842898, 3.204660161104348],
            [30.9647877378566, 3.202374959710618],
            [30.96433302593115, 3.200475361810699],
            [30.965014117799775, 3.200476720635665],
            [30.96554349140345, 3.199872004771628],
            [30.96493714834961, 3.196606855114507],
            [30.964256218177724, 3.196524125228642],
            [30.96176034617884, 3.197821101397841],
            [30.961381780846757, 3.197359235933403],
            [30.963272512635978, 3.195464322314237],
            [30.962894206018692, 3.19515616167799],
            [30.961608182349494, 3.195307298768957],
            [30.960843941519865, 3.194853704457738],
            [30.960773949284487, 3.194283959761778],
            [30.96258917497911, 3.19375414024996],
            [30.965010042143344, 3.19413870272587],
            [30.96576641193447, 3.193453063873984],
            [30.965084891569465, 3.191245608740305],
            [30.96478124932533, 3.188279430558113],
            [30.966370192993125, 3.188888362516442],
            [30.967655561790473, 3.187064553220232],
            [30.968259078744413, 3.181903109350665],
            [30.966670062313053, 3.180760744983407],
            [30.966291579626002, 3.17953940624523],
            [30.972176684699065, 3.17797254837908],
            [30.974776545675223, 3.17734675567561],
            [30.975374935943858, 3.180623305487111],
            [30.978978229465422, 3.186284839994844],
            [30.981776799579062, 3.185534393811625],
            [30.98451336168359, 3.186449300438777],
            [30.987885674989442, 3.186798478324644],
            [30.98843767805343, 3.186988554892312],
            [30.989656272380724, 3.188880866920002],
            [30.991644439038893, 3.190159690047609],
            [30.994039217330656, 3.189291075172886],
            [30.99575519445773, 3.189247189579717],
            [30.99789953322805, 3.187897558459047],
            [30.99886183371323, 3.187789974073054],
            [30.99819639588673, 3.191023411476496],
            [30.99865048438139, 3.1915553437512],
            [30.999068359091993, 3.19362857591852],
            [31.000591493080428, 3.194507290026382],
            [31.002479627840106, 3.194383271179364],
            [31.003295796683084, 3.194749755116584],
            [31.002252178901752, 3.197926674743472],
            [31.0013995528313, 3.198262324130023],
            [30.998151688531678, 3.20226484844545],
            [30.998276716951235, 3.204779759630275],
            [30.996689022840002, 3.20774410613494],
            [30.99604749996299, 3.212342334063247],
            [30.996334905158356, 3.215203722168249],
            [30.99829155801805, 3.217836450442202],
            [31.000200681016043, 3.219053540686579],
            [31.000596133777165, 3.219688624903848],
            [31.00176962189744, 3.223641600659057],
            [31.001752084986467, 3.225868029530938],
            [31.0026994204373, 3.226943373610827],
            [31.00294592354116, 3.229011292537617],
            [31.00385300368752, 3.230444383073034],
            [31.00489343155126, 3.231122331386345],
            [31.005552816529388, 3.231097127061128],
            [31.007717326071074, 3.23013394324196],
            [31.008389330582297, 3.230400324354457],
            [31.009286776297223, 3.23001776035065],
            [31.010169408793118, 3.23047009505293],
            [31.010563666794898, 3.231160018586968],
            [31.010890854780953, 3.232432935702517],
            [31.01057192860057, 3.236270038446123],
            [31.011340051050553, 3.238566260879151],
            [31.009993903139428, 3.240585963217468],
            [31.01040558037289, 3.241139873651618],
            [31.00997189082172, 3.241790881569925],
            [31.01016571851394, 3.243013127042099],
            [31.012936738196128, 3.243377019451105],
            [31.014035389466713, 3.244426126596906],
            [31.013798018636045, 3.245196045443922],
            [31.014602922605317, 3.245691472664044],
            [31.014935441194282, 3.246521779737961],
            [31.017157346794416, 3.246091585261502],
            [31.018740233122287, 3.247355872726504],
            [31.020154160718246, 3.247694913027407],
            [31.02137021460992, 3.24901784849306],
            [31.025776764590542, 3.252249833201375],
            [31.027341831936422, 3.253871784491952],
            [31.025391416978078, 3.258501110103802],
            [31.024658739354262, 3.262238332789249],
            [31.02356335705299, 3.263517134480938],
            [31.02306072629534, 3.26502665285685],
            [31.025211802430263, 3.266852895319895],
            [31.026710626210477, 3.270354405822652],
            [31.02829627395949, 3.271422838011903],
            [31.025854803934223, 3.271752495417757],
            [31.023817954875856, 3.269645416885072],
            [31.020446157203004, 3.267930887223642],
            [31.019165931260677, 3.267928349125361],
            [31.014082238405404, 3.269363512634876],
            [31.013598727390242, 3.269976058722721],
            [31.012644979764897, 3.269670023840029],
            [31.011434218746853, 3.269854772842302],
            [31.010755916147186, 3.271514469314496],
            [31.00958948968336, 3.27282226421714],
            [31.00949439402739, 3.273828060516978],
            [31.008142673866537, 3.274667581904651],
            [31.007142234507654, 3.274431630905],
            [31.006256696860152, 3.274944549306969],
            [31.00613896904891, 3.275622768137548],
            [31.006743332215848, 3.276045087320638],
            [31.007012024605544, 3.277064122319508],
            [31.007544099443287, 3.277314980074943],
            [31.008570059041073, 3.279172644409396],
            [31.00784203558873, 3.279260399738204],
            [31.006760557411425, 3.278544538304408],
            [31.00580193193407, 3.278542618159236],
            [31.004753093144313, 3.279272054230745],
            [31.004887708384587, 3.283001381729207],
            [31.00664197170909, 3.284628558517724],
            [31.00813158326603, 3.285434454627767],
            [31.010403652588284, 3.285563904336007],
            [31.012536356379034, 3.284354886993665],
            [31.0144187922266, 3.284019642839371],
            [31.015355632660004, 3.284242686050608],
            [31.015258471777173, 3.286474111808666],
            [31.01322772856781, 3.289361377684159],
            [31.012377801934772, 3.289334365901428],
            [31.01187927737629, 3.289902824808883],
            [31.011552154068927, 3.289762968791208],
            [31.01159156316046, 3.288940498170616],
            [31.011201455375268, 3.288813169917211],
            [31.009154160706785, 3.289340558549335],
            [31.007672536071034, 3.290362606799385],
            [31.0079289907116, 3.291210979492639],
            [31.005484987437217, 3.291762868337509],
            [31.005187670231017, 3.292464598766151],
            [31.00585329490708, 3.293351758538174],
            [31.006001401046305, 3.294857951273896],
            [31.002293137587138, 3.295259819078849],
            [31.00160813535209, 3.294678584290921],
            [31.000296218643154, 3.295663255276519],
            [31.001292015508632, 3.296793627660854],
            [31.00108818956732, 3.297341726105484],
            [30.998952609371024, 3.296898604134018],
            [30.99720501424088, 3.297396564452471],
            [30.99634376344537, 3.299165719452289],
            [30.996810155266143, 3.299887559566181],
            [30.998214171749588, 3.299639656253257],
            [30.99843105200863, 3.300360991110208],
            [30.996351811452, 3.302926934370586],
            [30.995490075566256, 3.304931157924601],
            [30.996204785087755, 3.306249027817741],
            [30.99825963548613, 3.308071110720667],
            [30.998406483085617, 3.309474737274503],
            [30.9957595054728, 3.311909446661413],
            [30.994038495085153, 3.315494300968274],
            [30.991392166055977, 3.31759407122336],
            [30.990222358333448, 3.319314089026427],
            [30.987952123371006, 3.320521812757396],
            [30.987598394659873, 3.321361196076814],
            [30.988244902288404, 3.323767557807582],
            [30.98804471182901, 3.324472383765525],
            [30.983107466822908, 3.323820309621951],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 482,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "YIVU",
        Population: 25271,
        Key: "MARACHAYIVU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.975477496599847, 3.488050448543649],
            [30.973549883578357, 3.488237566172975],
            [30.968250091998318, 3.486188112993208],
            [30.964839295764044, 3.4869557067749],
            [30.960402467168414, 3.491012394701988],
            [30.959478552593648, 3.495928019621843],
            [30.957023804570184, 3.499312394037085],
            [30.95171205461708, 3.500711171747783],
            [30.94814171219845, 3.500305521387597],
            [30.946641816728093, 3.501016407361571],
            [30.941198124022716, 3.502198867825034],
            [30.94058012981962, 3.502027221776009],
            [30.94012794216011, 3.500687698633434],
            [30.94070297443473, 3.49833862860373],
            [30.940376189792268, 3.497484196270275],
            [30.938855341117918, 3.495868277150859],
            [30.93826711798169, 3.4930564117515],
            [30.940362869573207, 3.487566367079032],
            [30.942350819737406, 3.480155956057553],
            [30.942719347294528, 3.470432172410771],
            [30.94370638109442, 3.466689237250044],
            [30.94254645573829, 3.463082139809965],
            [30.941129350801194, 3.462000488336444],
            [30.93947345479693, 3.461406651969347],
            [30.93741429428185, 3.459757969148926],
            [30.937913978565387, 3.45503028156819],
            [30.936884160703464, 3.449463111444831],
            [30.936696946408375, 3.445492778648604],
            [30.93578868677405, 3.441914356766859],
            [30.938103439547024, 3.425474048879468],
            [30.945517625455707, 3.42555357811437],
            [30.948831318299334, 3.423648201454738],
            [30.948994322099214, 3.422941242397105],
            [30.953271851547186, 3.426178339252463],
            [30.95357703709697, 3.429168810180482],
            [30.95421792037348, 3.430465697596085],
            [30.957952591607047, 3.43046950949174],
            [30.964231721119944, 3.429767658629375],
            [30.970144631746006, 3.428363965222779],
            [30.971575174581442, 3.429325185979645],
            [30.97530602797504, 3.425018753073689],
            [30.974184481342842, 3.423775266437563],
            [30.972803530002636, 3.423287027302362],
            [30.972868376688037, 3.416917019728787],
            [30.973781910331386, 3.414525755029235],
            [30.974886393464793, 3.413705313653954],
            [30.974256953826675, 3.413022540827011],
            [30.974985323130404, 3.410137181137912],
            [30.974345392966416, 3.407636563444508],
            [30.972817745842, 3.405830489035906],
            [30.969578797321567, 3.400198180779925],
            [30.969542777573622, 3.398369150345053],
            [30.969772324976496, 3.39869166932416],
            [30.971321485853636, 3.398373286089671],
            [30.973022581489722, 3.39856271608762],
            [30.976205794038346, 3.397528725777755],
            [30.979455188168927, 3.40023643724127],
            [30.981054070797036, 3.402147758139288],
            [30.983850339426915, 3.403392573930323],
            [30.983645951140215, 3.403951256871114],
            [30.982396638023438, 3.404186061218902],
            [30.981165020819446, 3.405383093961362],
            [30.979774855459382, 3.409593503999886],
            [30.982821386642595, 3.41488632898858],
            [30.984254872358928, 3.416620789680982],
            [30.987850214891917, 3.418738343487624],
            [30.992157453422926, 3.420717193271628],
            [30.995595419202978, 3.421376342069434],
            [30.996798539151207, 3.422552771136408],
            [30.998138749198322, 3.422839746172354],
            [30.99863987437957, 3.423370402717931],
            [30.99819280801548, 3.424648074300692],
            [30.99841608877094, 3.427174521292578],
            [30.99805857276258, 3.43423502549559],
            [30.998717454684137, 3.436779135443859],
            [30.99685857176504, 3.444180005230632],
            [30.997802321141254, 3.448500977536743],
            [30.99999314054103, 3.451899872573328],
            [30.99980568100583, 3.453520455320872],
            [31.000404621043426, 3.457046536408102],
            [31.001217331372548, 3.456732763601753],
            [31.002245427164098, 3.45697427919207],
            [31.003820796389622, 3.459566829651588],
            [31.004452155727503, 3.457958061123606],
            [31.00504843765019, 3.457853295746551],
            [31.00660715121206, 3.459945715578701],
            [31.00889118878884, 3.460720997289635],
            [31.009376541350317, 3.461329499231721],
            [31.01052652505117, 3.461435641519537],
            [31.013178279006354, 3.463275436893994],
            [31.01575481612447, 3.464189393673076],
            [31.016588599133534, 3.464091779063152],
            [31.017477093136648, 3.464860222936506],
            [31.015096352817864, 3.467980614559482],
            [31.015305083560634, 3.471675997059625],
            [31.013237983735074, 3.473225922814563],
            [31.013533882501466, 3.474214520868105],
            [31.01255531532311, 3.476697351554773],
            [31.01132178740253, 3.477612854643503],
            [31.010731761347497, 3.479527669797446],
            [31.00932133448623, 3.479544638177566],
            [31.008867456197322, 3.481344039722591],
            [31.007347123155974, 3.481334715380629],
            [31.004876006929695, 3.482042189588655],
            [31.003336087920196, 3.483451165580647],
            [30.999720859381764, 3.48475011998609],
            [30.999167964290688, 3.485303281110284],
            [30.997788938938495, 3.485168349052797],
            [30.993990976901596, 3.485912542811778],
            [30.990866496206237, 3.4849951468841],
            [30.989826466296147, 3.486061996955558],
            [30.98859197448325, 3.485914163064116],
            [30.986830576738768, 3.486451518206962],
            [30.985780893532667, 3.485881724840704],
            [30.984703448791, 3.486011392545489],
            [30.978762172063195, 3.487753983342941],
            [30.975477496599847, 3.488050448543649],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 483,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "MIDIA",
        Population: 21654,
        Key: "KOBOKOMIDIA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.045927338259347, 3.322292993599433],
            [31.04532363804906, 3.324093625890456],
            [31.04520389352, 3.326700339887599],
            [31.045678517502047, 3.329046496313961],
            [31.04356099434127, 3.330340513299795],
            [31.04242168891418, 3.332201841322773],
            [31.041722881369836, 3.3325878215674],
            [31.03865097457651, 3.331796452448916],
            [31.037023985459776, 3.332651703942721],
            [31.03436890234815, 3.33294157709641],
            [31.03154047762434, 3.333780196530392],
            [31.023223435447807, 3.332960851032283],
            [31.019041989802616, 3.331523303327666],
            [31.01425595910663, 3.332255152286562],
            [31.012091221392847, 3.331557066842092],
            [31.009187181878325, 3.33155117040118],
            [31.008287251423326, 3.331747771622834],
            [31.0070827974769, 3.332714332593055],
            [31.004123047143388, 3.332760682598524],
            [30.99837044357473, 3.33439710614916],
            [30.993937717585013, 3.33647023638029],
            [30.98867673861513, 3.338307382492608],
            [30.986938183231715, 3.33828964934841],
            [30.987258137084773, 3.339626174561509],
            [30.983107466822908, 3.323820309621951],
            [30.98804471182901, 3.324472383765525],
            [30.988244902288404, 3.323767557807582],
            [30.987598394659873, 3.321361196076814],
            [30.987952123371006, 3.320521812757396],
            [30.990222358333448, 3.319314089026427],
            [30.991392166055977, 3.31759407122336],
            [30.994038495085153, 3.315494300968274],
            [30.9957595054728, 3.311909446661413],
            [30.998406483085617, 3.309474737274503],
            [30.99825963548613, 3.308071110720667],
            [30.996204785087755, 3.306249027817741],
            [30.995490075566256, 3.304931157924601],
            [30.996351811452, 3.302926934370586],
            [30.99843105200863, 3.300360991110208],
            [30.998214171749588, 3.299639656253257],
            [30.996810155266143, 3.299887559566181],
            [30.99634376344537, 3.299165719452289],
            [30.99720501424088, 3.297396564452471],
            [30.998952609371024, 3.296898604134018],
            [31.00108818956732, 3.297341726105484],
            [31.001292015508632, 3.296793627660854],
            [31.000296218643154, 3.295663255276519],
            [31.00160813535209, 3.294678584290921],
            [31.002293137587138, 3.295259819078849],
            [31.006001401046305, 3.294857951273896],
            [31.00585329490708, 3.293351758538174],
            [31.005187670231017, 3.292464598766151],
            [31.005484987437217, 3.291762868337509],
            [31.0079289907116, 3.291210979492639],
            [31.007672536071034, 3.290362606799385],
            [31.009154160706785, 3.289340558549335],
            [31.011201455375268, 3.288813169917211],
            [31.01159156316046, 3.288940498170616],
            [31.011552154068927, 3.289762968791208],
            [31.01187927737629, 3.289902824808883],
            [31.012377801934772, 3.289334365901428],
            [31.01322772856781, 3.289361377684159],
            [31.015258471777173, 3.286474111808666],
            [31.015355632660004, 3.284242686050608],
            [31.0144187922266, 3.284019642839371],
            [31.012536356379034, 3.284354886993665],
            [31.010403652588284, 3.285563904336007],
            [31.00813158326603, 3.285434454627767],
            [31.00664197170909, 3.284628558517724],
            [31.004887708384587, 3.283001381729207],
            [31.004753093144313, 3.279272054230745],
            [31.00580193193407, 3.278542618159236],
            [31.006760557411425, 3.278544538304408],
            [31.00784203558873, 3.279260399738204],
            [31.008570059041073, 3.279172644409396],
            [31.007544099443287, 3.277314980074943],
            [31.007012024605544, 3.277064122319508],
            [31.006743332215848, 3.276045087320638],
            [31.00613896904891, 3.275622768137548],
            [31.006256696860152, 3.274944549306969],
            [31.007142234507654, 3.274431630905],
            [31.008142673866537, 3.274667581904651],
            [31.00949439402739, 3.273828060516978],
            [31.00958948968336, 3.27282226421714],
            [31.010755916147186, 3.271514469314496],
            [31.011434218746853, 3.269854772842302],
            [31.012644979764897, 3.269670023840029],
            [31.013598727390242, 3.269976058722721],
            [31.014082238405404, 3.269363512634876],
            [31.019165931260677, 3.267928349125361],
            [31.020446157203004, 3.267930887223642],
            [31.023817954875856, 3.269645416885072],
            [31.025854803934223, 3.271752495417757],
            [31.02829627395949, 3.271422838011903],
            [31.02923372884055, 3.271661178931671],
            [31.031367546542263, 3.273341446144542],
            [31.03210745829907, 3.275816306941074],
            [31.032560466120454, 3.27597992598443],
            [31.032671728756586, 3.277037849205618],
            [31.034943250106505, 3.277274455185505],
            [31.03673995253998, 3.27475146683078],
            [31.037677318487823, 3.274798119987298],
            [31.0393489853152, 3.273519896792834],
            [31.040383956811905, 3.274140285078397],
            [31.042773470077776, 3.273950152183923],
            [31.044889016944936, 3.27200116170333],
            [31.049424118537665, 3.271066233691439],
            [31.049457948192952, 3.270317763125572],
            [31.050439805001847, 3.26935968307158],
            [31.05308937694921, 3.267835149793309],
            [31.055881413615793, 3.272445735067773],
            [31.056425435148505, 3.272768621815098],
            [31.0565156313929, 3.270998708826938],
            [31.057261766677996, 3.270284167034817],
            [31.05886354547459, 3.270840553488752],
            [31.060981197094446, 3.272553298823969],
            [31.062648340006074, 3.272800628604125],
            [31.063019280438024, 3.273549891924418],
            [31.064048345511743, 3.273443133646143],
            [31.066243493892834, 3.272351971139671],
            [31.069947464303265, 3.274263056518727],
            [31.070739272632355, 3.275061953012639],
            [31.072714738010724, 3.274951865794884],
            [31.07281032324851, 3.275765689766023],
            [31.067706095804155, 3.286590292667025],
            [31.068589113677298, 3.28646240807407],
            [31.07029193946863, 3.287066245265837],
            [31.071598100671523, 3.286801881790878],
            [31.0722056627392, 3.287325742432469],
            [31.073069253646015, 3.287049396382166],
            [31.07373216181666, 3.2875622437365],
            [31.072941875233692, 3.289996182617886],
            [31.071822248301213, 3.29107273168147],
            [31.071686150840726, 3.29279620163311],
            [31.07108090822309, 3.293402428631491],
            [31.071241434469414, 3.293896302045952],
            [31.07008950501765, 3.294505706742385],
            [31.07008793925411, 3.295317526499558],
            [31.069607701699876, 3.295618121427863],
            [31.06810402701713, 3.296485845901093],
            [31.066079561234947, 3.29608722601002],
            [31.064986485807353, 3.296500613085369],
            [31.063704783034698, 3.29844803829831],
            [31.063048268173933, 3.298429081166611],
            [31.061633731520207, 3.299345310729417],
            [31.061208256163994, 3.301100001858831],
            [31.05927681362441, 3.304057208810282],
            [31.05767412752939, 3.303717643226247],
            [31.055500014099, 3.304969792086862],
            [31.05439189638194, 3.30517340904709],
            [31.052249490786135, 3.310669621644531],
            [31.049388361996098, 3.311997334522103],
            [31.04779393141853, 3.31393692076507],
            [31.047524466477697, 3.318327959101053],
            [31.04689508702672, 3.32062910406663],
            [31.045927338259347, 3.322292993599433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 484,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "TARA",
        Population: 16951,
        Key: "MARACHATARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.879355731006513, 3.191586974601247],
            [30.878544847850698, 3.193353067119262],
            [30.878621529839958, 3.197642614100879],
            [30.87763886005573, 3.200379957941557],
            [30.876428772774148, 3.201896306088357],
            [30.876731831113364, 3.203641825437768],
            [30.87650516550591, 3.20546760986032],
            [30.877110472802237, 3.206761718050978],
            [30.877082675334083, 3.20824436352046],
            [30.87903992377682, 3.208619124538191],
            [30.881310022195336, 3.210902162994801],
            [30.88244453151709, 3.211284246264553],
            [30.884334970455527, 3.215166737547198],
            [30.88029514601151, 3.217237715509842],
            [30.876986993976544, 3.217005817640545],
            [30.865381138696463, 3.221036894764925],
            [30.861971459068084, 3.221059536010494],
            [30.861845405670774, 3.222062933551029],
            [30.860705244149216, 3.223986211426777],
            [30.86080932834794, 3.228467420639728],
            [30.853598385373992, 3.233749108877745],
            [30.852550125997592, 3.234273133480098],
            [30.85186778816566, 3.233903252887266],
            [30.85100763690806, 3.235917501608414],
            [30.849578437952285, 3.237125911696665],
            [30.8466521139305, 3.237483484104088],
            [30.842156980181393, 3.238874414670866],
            [30.84178930243053, 3.23639505222388],
            [30.84080573702596, 3.235027806747559],
            [30.839897790903663, 3.234121797672407],
            [30.836636983677426, 3.233048016395112],
            [30.83339147745545, 3.229406727274212],
            [30.830402658537654, 3.224355659741505],
            [30.829115923402792, 3.219037032384163],
            [30.827375320758826, 3.215010243506816],
            [30.8278286402956, 3.211584832172568],
            [30.830550302044507, 3.202387312886689],
            [30.830398882918526, 3.201482930491399],
            [30.82525408486098, 3.195252052163045],
            [30.822680794254275, 3.186965417789915],
            [30.815454652684036, 3.173931681441296],
            [30.81378940970927, 3.167626907711392],
            [30.81038408870664, 3.158732874547314],
            [30.80947567276546, 3.1549339459474],
            [30.80901998167634, 3.144979410392593],
            [30.809775322896456, 3.139656158539706],
            [30.802936895999466, 3.133223402386836],
            [30.81091144918575, 3.131848005482619],
            [30.812504021148992, 3.132474872345463],
            [30.813870270661237, 3.131460011402585],
            [30.815980168023575, 3.131266543971868],
            [30.819724569808265, 3.129549894679184],
            [30.820519401866623, 3.125814128253767],
            [30.819436898711597, 3.123628786092923],
            [30.818929089166314, 3.120142249738515],
            [30.820958059999636, 3.118559031197374],
            [30.823018727887746, 3.118252734107179],
            [30.83005655113343, 3.11857794053736],
            [30.832117867605174, 3.117961035366545],
            [30.834059423378218, 3.118101527501929],
            [30.837516189100523, 3.121851426416276],
            [30.840686431773083, 3.123842974284651],
            [30.84361613256199, 3.124048363056112],
            [30.846263873742807, 3.125682059781626],
            [30.85076471089568, 3.126973630547204],
            [30.85352593534802, 3.128607305674463],
            [30.855976245693988, 3.129256257124689],
            [30.85933451473865, 3.132667198603387],
            [30.862740800531896, 3.133274552238556],
            [30.868002242134146, 3.133323659681757],
            [30.86637476882548, 3.138083273847415],
            [30.866783892148593, 3.139241339065465],
            [30.867979968406683, 3.139994183157558],
            [30.864223727724845, 3.144199487892546],
            [30.86347919144095, 3.146268300526285],
            [30.863476056320614, 3.147805786915901],
            [30.86221520344569, 3.148819967328603],
            [30.86447305333531, 3.150212011837115],
            [30.864946937105543, 3.151217649081989],
            [30.86175050045762, 3.154966561876556],
            [30.863602637028947, 3.156931868171433],
            [30.86464607784219, 3.158704139841233],
            [30.86478406086645, 3.161048632175632],
            [30.8637182367313, 3.166236781791324],
            [30.866142536358247, 3.168601880475637],
            [30.867525756842817, 3.16889861932411],
            [30.86976892826071, 3.168041234204674],
            [30.871015558109722, 3.168416052027065],
            [30.87109472304243, 3.167828467778279],
            [30.8716214870402, 3.167574866192559],
            [30.873295549674474, 3.168616678223742],
            [30.874912746256282, 3.168874707755417],
            [30.876454844578635, 3.170353568937577],
            [30.875515300216236, 3.170589672332642],
            [30.87464043096106, 3.173370418275603],
            [30.874635539634326, 3.175760583454354],
            [30.873949954392625, 3.177424450817284],
            [30.877527708810675, 3.181604870982712],
            [30.879916002164393, 3.18190796712566],
            [30.879550212672257, 3.18233181418424],
            [30.880173865363343, 3.182169224976008],
            [30.880583765729146, 3.183570358092557],
            [30.8804032537644, 3.186058127426825],
            [30.880045146664575, 3.189603478223757],
            [30.879355731006513, 3.191586974601247],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 485,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "OLUVU",
        Population: 29686,
        Key: "MARACHAOLUVU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.969542777573622, 3.398369150345053],
            [30.969578797321567, 3.400198180779925],
            [30.972817745842, 3.405830489035906],
            [30.969170141122415, 3.4046559288977],
            [30.966199557106602, 3.404794635944093],
            [30.965567946240434, 3.40206241793533],
            [30.964154103984434, 3.399606464450509],
            [30.962689704544257, 3.398322505744397],
            [30.962646830650684, 3.395833210988706],
            [30.96223275132215, 3.394770760641706],
            [30.961889420610454, 3.394824161444914],
            [30.96257045947848, 3.39355269334813],
            [30.963790603399676, 3.392865047698398],
            [30.963482023116427, 3.392085102656978],
            [30.963838559062793, 3.391128440474576],
            [30.96231095865079, 3.390501775207407],
            [30.96191538102384, 3.388942355060787],
            [30.96107543018204, 3.387960897453861],
            [30.962140551834654, 3.387228389906733],
            [30.964135236668533, 3.387009951536629],
            [30.967108035929844, 3.385279514188928],
            [30.96783785601276, 3.385949017758978],
            [30.968591646740684, 3.385750216969938],
            [30.969233253161022, 3.386219145756881],
            [30.97093956351733, 3.386155941241033],
            [30.971741427587723, 3.38415372385152],
            [30.972784152443648, 3.383532478506038],
            [30.972719763000693, 3.382530391056803],
            [30.973298371468484, 3.38132926144311],
            [30.97254546378444, 3.381105025140641],
            [30.972369172104887, 3.380637076719428],
            [30.973234489573663, 3.380082253378518],
            [30.973501865033143, 3.379370314085307],
            [30.972462663369775, 3.378299383897891],
            [30.97268785035024, 3.376563137961929],
            [30.970496629403563, 3.375400730099452],
            [30.97041044952678, 3.374220472672224],
            [30.968992629530703, 3.374083904493907],
            [30.968418750692898, 3.373013952222036],
            [30.967843204581943, 3.372745557570543],
            [30.966292258752343, 3.372697768367644],
            [30.964850989134096, 3.37318458035221],
            [30.963763128426717, 3.374206505666692],
            [30.962722970057538, 3.373603146976684],
            [30.962189886411753, 3.374225458646566],
            [30.960285118446212, 3.373842932111002],
            [30.958400277808657, 3.374529185142999],
            [30.95616450132221, 3.373500255586126],
            [30.9557861929083, 3.374278744900441],
            [30.955033162155082, 3.374121295718976],
            [30.95199598962049, 3.374871892691556],
            [30.949708247391488, 3.377494352066353],
            [30.946936492887403, 3.378468140470671],
            [30.94556023973615, 3.379645272931257],
            [30.94423083282863, 3.379620179989474],
            [30.94258863972572, 3.380819003480581],
            [30.940549064280496, 3.381326755022921],
            [30.939238380958443, 3.382927048740957],
            [30.938103020932104, 3.383443300364103],
            [30.93337392186553, 3.383949396926816],
            [30.93270252012387, 3.38259910813284],
            [30.931222383996534, 3.381214490707378],
            [30.928155298461334, 3.380402030805203],
            [30.924752514301037, 3.380405847382833],
            [30.92228816328717, 3.377743414961289],
            [30.918164384093348, 3.37682415395081],
            [30.91888918888203, 3.372079069662348],
            [30.91871752262787, 3.370084150676324],
            [30.917992328868678, 3.369305658900939],
            [30.92023559371133, 3.367637988592845],
            [30.92158048847267, 3.36713457023836],
            [30.92334684312087, 3.365022733270783],
            [30.924860437899294, 3.363977201672689],
            [30.926500739150214, 3.361774670264693],
            [30.92650190067186, 3.360427542284079],
            [30.92767933778611, 3.359073883047385],
            [30.928100786893232, 3.357727650802408],
            [30.929907492965715, 3.357261359139703],
            [30.931142669294868, 3.355828337215546],
            [30.930667345525187, 3.354455666227234],
            [30.932267217198444, 3.353157388169653],
            [30.93185225841925, 3.351780180215505],
            [30.932278088610015, 3.350194809755684],
            [30.93427397898299, 3.350446315280151],
            [30.934089235953248, 3.349984037720354],
            [30.936441064892954, 3.348766651483349],
            [30.93743307266458, 3.3495105708096],
            [30.937881442484112, 3.348242495184413],
            [30.936719106948104, 3.346803053429355],
            [30.937276976010907, 3.344940942383316],
            [30.936704196711013, 3.343108872840472],
            [30.937309988199274, 3.341861839230259],
            [30.938449562222626, 3.341520679609991],
            [30.939028943241524, 3.340861892643698],
            [30.939401409012852, 3.338784411484134],
            [30.94058083409881, 3.336989418185794],
            [30.94364002164607, 3.334282813269775],
            [30.94415322287966, 3.333354720088833],
            [30.94661367700182, 3.332026512209032],
            [30.947693518448677, 3.33288768056211],
            [30.94698459138266, 3.335531319173279],
            [30.94783925662878, 3.335555914630759],
            [30.95043789230293, 3.333516705548567],
            [30.951428123206888, 3.333822815818346],
            [30.951078391100477, 3.334688592121341],
            [30.951592543649998, 3.334780879418752],
            [30.95450215631255, 3.332324250451331],
            [30.95571282570242, 3.332106349529156],
            [30.955941029225603, 3.331483545619859],
            [30.95721971096395, 3.331296187635603],
            [30.95762856030092, 3.328965396052089],
            [30.95996955915155, 3.329335329345479],
            [30.96036457173816, 3.328618451185362],
            [30.961428841787864, 3.328488842086595],
            [30.96187201665015, 3.329156199085907],
            [30.962928804631833, 3.329121778135221],
            [30.961834288306527, 3.326241380080893],
            [30.962112529787664, 3.325604816409734],
            [30.963445882095904, 3.325746730913399],
            [30.963434892106715, 3.327548281500221],
            [30.96427289899423, 3.327586638564189],
            [30.964071055634736, 3.326509669104893],
            [30.96543375859824, 3.326556435518373],
            [30.965683984320638, 3.328915116989299],
            [30.96627960418493, 3.32987572868813],
            [30.970451666926973, 3.329833885856912],
            [30.971686557591852, 3.330143254443882],
            [30.97142780955236, 3.331936979612804],
            [30.973115803260015, 3.33328800029812],
            [30.973357154525715, 3.332871059347077],
            [30.97287826354606, 3.331844775450711],
            [30.97350752980934, 3.330615726281355],
            [30.973872381460303, 3.330389451576556],
            [30.975439178063088, 3.330749596683527],
            [30.975194820136135, 3.329385415575029],
            [30.97741297347336, 3.32747880813756],
            [30.979926738116063, 3.328171748840056],
            [30.979802224431147, 3.326227581886208],
            [30.98034952211967, 3.324881532361536],
            [30.98196402914554, 3.323935499622559],
            [30.983107466822908, 3.323820309621951],
            [30.987258137084773, 3.339626174561509],
            [30.988741629318, 3.344077687016409],
            [30.99164468068571, 3.347411449777265],
            [30.993235447035254, 3.349963265599002],
            [30.99412429227964, 3.352312920373701],
            [30.9941586267881, 3.353422903281341],
            [30.993408374524076, 3.355513576348925],
            [30.991697466590125, 3.357555942940605],
            [30.991048113098785, 3.360808036627419],
            [30.992993541509005, 3.363969807825325],
            [30.9934185686059, 3.367314860241906],
            [30.994650742765387, 3.367841242832282],
            [30.996516172606263, 3.369843788893955],
            [30.997833990348298, 3.372678573232922],
            [30.999552473775033, 3.374658786349191],
            [31.002397625129397, 3.376459087379474],
            [31.000750587412178, 3.379707762262847],
            [30.9979238335548, 3.380108274447202],
            [30.996161407239313, 3.382644834322919],
            [30.99586766981951, 3.384590166907922],
            [30.995455673684145, 3.384948718234432],
            [30.995661674446765, 3.38703899624724],
            [30.994013690803534, 3.390399463112698],
            [30.992430555642372, 3.389987511841034],
            [30.99072916356224, 3.390273590875295],
            [30.98879125584758, 3.391753570113758],
            [30.98708986286912, 3.390746576127817],
            [30.9845682927649, 3.39038802605228],
            [30.982397682764127, 3.3913339935238],
            [30.98020113121454, 3.392999924667487],
            [30.977582022935106, 3.39247410453414],
            [30.974487813668176, 3.392557357972847],
            [30.97310576638335, 3.393280699488039],
            [30.972039558667568, 3.394420870973562],
            [30.970378430875105, 3.396563477346361],
            [30.969542777573622, 3.398369150345053],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 486,
        District: "KOBOKO",
        County: "KOBOKO",
        Subcounty: "DRANYA",
        Population: 12872,
        Key: "KOBOKODRANYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.4593816882455, 2.246666966349925],
            [32.45794837500575, 2.246273162154903],
            [32.439747537168955, 2.247052789659129],
            [32.43857404186217, 2.24880020236157],
            [32.43672735806462, 2.256232530742648],
            [32.435401955846665, 2.251682948651621],
            [32.4348822157761, 2.247750048966782],
            [32.43282141673395, 2.241260294894151],
            [32.42878454774725, 2.233917687743624],
            [32.420447990569436, 2.225131395039923],
            [32.419666291880546, 2.224694121424945],
            [32.41679954233181, 2.224430803722268],
            [32.414513633564276, 2.223552673470517],
            [32.425154750331515, 2.2130292983238],
            [32.431347275962814, 2.205767136306412],
            [32.431619231931926, 2.204510962127876],
            [32.43145665662843, 2.20369158748488],
            [32.43047981062218, 2.202434934004228],
            [32.42689739843938, 2.199538651747056],
            [32.41837347604953, 2.198279055845892],
            [32.417776394626266, 2.197841856003548],
            [32.41712590925768, 2.195110567495576],
            [32.41734114829469, 2.189232441754157],
            [32.417020153294224, 2.187791356268058],
            [32.415771874138336, 2.186479970683479],
            [32.409679085758114, 2.184945215996126],
            [32.40988196128187, 2.18785281728442],
            [32.40890697029666, 2.191611600500532],
            [32.39854437977654, 2.206337313396587],
            [32.396904124339706, 2.212479993166017],
            [32.39251123773453, 2.221682556536944],
            [32.39133948785434, 2.223363919745971],
            [32.388753219286734, 2.224995874145915],
            [32.38295693783233, 2.226572592439599],
            [32.37988599223633, 2.226850210013126],
            [32.375934021230485, 2.226136569660884],
            [32.37108321391767, 2.226065192231875],
            [32.366962358740096, 2.22666391264553],
            [32.36417123206691, 2.22854240179481],
            [32.362270415790306, 2.230559864835581],
            [32.35620744429097, 2.239938494754203],
            [32.35585093080251, 2.239114869744337],
            [32.35650591223906, 2.237937501748131],
            [32.356183335305374, 2.236987265706402],
            [32.355447971718874, 2.236814291362235],
            [32.353920635411555, 2.237296451876306],
            [32.35359107497483, 2.236985413894248],
            [32.35413284173616, 2.235286048981858],
            [32.35387875774963, 2.234596935135744],
            [32.347501006693285, 2.233883000527432],
            [32.34694581011844, 2.23245694707997],
            [32.34588374543275, 2.231712518807619],
            [32.34617970258965, 2.230744709337521],
            [32.34734956241448, 2.23033005778546],
            [32.34716446365186, 2.229185706755928],
            [32.3460995504084, 2.228701681883861],
            [32.34310461037028, 2.228553786510392],
            [32.342113631169674, 2.227833733372145],
            [32.34205574912266, 2.224423776111509],
            [32.34002909594275, 2.220544560375472],
            [32.33868116577411, 2.219844660757777],
            [32.33737148587025, 2.219997487746753],
            [32.33463811547991, 2.222030373159634],
            [32.334140042774, 2.221907077836322],
            [32.33401055781232, 2.220698316350103],
            [32.33442593879971, 2.219684328574548],
            [32.336887136726936, 2.216441270158064],
            [32.33580182004844, 2.215649248814847],
            [32.33534511476136, 2.213916382547175],
            [32.333742091798094, 2.212622059940608],
            [32.333188960450116, 2.213184830621354],
            [32.333435783354204, 2.214536818309786],
            [32.33283483827689, 2.215122793259147],
            [32.33188340022014, 2.215137090035352],
            [32.33014842731805, 2.213948005673681],
            [32.329826907701445, 2.212903077721903],
            [32.330009400451424, 2.211436953725131],
            [32.329456039134726, 2.20984518280939],
            [32.33100765780249, 2.207137719262472],
            [32.32968239572171, 2.203277255995932],
            [32.32967181087271, 2.202069658843106],
            [32.32872066836168, 2.199882070570227],
            [32.32930536291548, 2.196431095321584],
            [32.328500491285524, 2.196091698098836],
            [32.32677667006937, 2.193884649740129],
            [32.32601240139197, 2.192006686747449],
            [32.32505813633699, 2.192281394292561],
            [32.32394518568375, 2.191844243862532],
            [32.32413617020809, 2.193953317792793],
            [32.32377379341573, 2.194470616662361],
            [32.322773778959984, 2.19457913794025],
            [32.32195344912062, 2.191303725253586],
            [32.321138782260824, 2.189685706829466],
            [32.31677023460993, 2.186848825037034],
            [32.317311112937475, 2.184143230027225],
            [32.32145561177331, 2.171576516125264],
            [32.32209047004922, 2.166380068862029],
            [32.321173909083356, 2.155586516158505],
            [32.318451735294744, 2.146811312723325],
            [32.31878130201968, 2.140587717041594],
            [32.32098195707347, 2.13614643033765],
            [32.32898209697398, 2.129797122222945],
            [32.33174910837336, 2.126841152479955],
            [32.33276973557164, 2.124838709081609],
            [32.33260431440533, 2.122564156199713],
            [32.32873426077023, 2.112191373623353],
            [32.32857850817132, 2.10793994401509],
            [32.32909798773046, 2.106098306070274],
            [32.330175958884894, 2.103196730081033],
            [32.33243724662708, 2.099726728252571],
            [32.33920781029594, 2.093803199475347],
            [32.341821338240834, 2.090739130908345],
            [32.343366060542145, 2.083189718919749],
            [32.34476371336012, 2.081498757956568],
            [32.3515879459773, 2.077185668295326],
            [32.352446608726446, 2.075856381183276],
            [32.352774369837654, 2.074426783682512],
            [32.36134585442855, 2.074250876843974],
            [32.37069094658255, 2.073194254890523],
            [32.3844413966528, 2.07376707301378],
            [32.388723395219294, 2.073619615969465],
            [32.4043885001131, 2.071973574250171],
            [32.40781245936124, 2.072007078355196],
            [32.423485559261046, 2.075108092470582],
            [32.43217410690987, 2.075394253439262],
            [32.435687912957775, 2.07605418337197],
            [32.440412098239754, 2.077759514662675],
            [32.43700791899584, 2.095649576588653],
            [32.43666671998632, 2.111770104873376],
            [32.43973150044451, 2.119719932748843],
            [32.440041814476245, 2.121806516963095],
            [32.439480399763035, 2.126429836888405],
            [32.43729968461361, 2.132351391064198],
            [32.43749105451521, 2.135537780441738],
            [32.43888362286865, 2.138700404062777],
            [32.434095030177474, 2.141684208949896],
            [32.43061732382756, 2.144396694067948],
            [32.426960833871476, 2.148243897562722],
            [32.42367526188949, 2.152970764393135],
            [32.42134385165622, 2.158523802702344],
            [32.42007602515976, 2.15990508775208],
            [32.4219540817203, 2.163492072689428],
            [32.422955133730206, 2.166654778389877],
            [32.433071292113375, 2.159921489209613],
            [32.434164774477786, 2.159601083998369],
            [32.437945418792644, 2.161160746238431],
            [32.44122538259232, 2.161528613052321],
            [32.44432340610593, 2.161117279852713],
            [32.44894549066931, 2.161417110006443],
            [32.4538187756272, 2.162393126958423],
            [32.46025750252839, 2.166419661637021],
            [32.46449859091854, 2.168384123921228],
            [32.466449003181964, 2.170689146482357],
            [32.46737887179043, 2.180162831432185],
            [32.46949753491328, 2.186564502544545],
            [32.46949696448309, 2.188186066505015],
            [32.46881751653142, 2.190319463168881],
            [32.46703497244517, 2.193049882518278],
            [32.465900184645655, 2.195835719941318],
            [32.46662842369367, 2.199899766905734],
            [32.46631317341941, 2.201594074709377],
            [32.46567499676686, 2.202602129699925],
            [32.46237100393166, 2.205419541177442],
            [32.46200615677225, 2.206473523597483],
            [32.462064649673685, 2.215009597651309],
            [32.46429363309995, 2.230922253355615],
            [32.46249160725011, 2.235459880744359],
            [32.4593816882455, 2.246666966349925],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 487,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "ABER",
        Population: 33366,
        Key: "OYAMABER",
        Dist2: "Oyam",
        "Sub Country": "Aber",
        id2_original: "Oyam Aber",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.57900360265698, 2.614207248799939],
            [32.56189630827007, 2.617027102006164],
            [32.55741965556129, 2.617213275700862],
            [32.55409120249922, 2.616854632151044],
            [32.549146602087596, 2.617437784463029],
            [32.54669031884326, 2.618119311526902],
            [32.54214540405437, 2.620223776888908],
            [32.52095744242077, 2.619743817886446],
            [32.51352410892182, 2.604261691440698],
            [32.514174570035884, 2.60298395009108],
            [32.51371891218442, 2.598915617925971],
            [32.51694292621328, 2.595301739907727],
            [32.51968080434968, 2.594496693892606],
            [32.52128086377083, 2.591742612481364],
            [32.52162080064736, 2.590445485453726],
            [32.52131391458674, 2.585397457565189],
            [32.514716834463876, 2.582312557498829],
            [32.51063870226293, 2.572013956788639],
            [32.50619500874192, 2.572792922177122],
            [32.501250560145564, 2.575376625135215],
            [32.50147483713263, 2.573931225848995],
            [32.50271333902498, 2.571681681597093],
            [32.502689855266816, 2.570867832262261],
            [32.50159559765628, 2.569407277753888],
            [32.500458427524656, 2.568653330164862],
            [32.50112728613574, 2.566882166531903],
            [32.50282467981455, 2.566404896584235],
            [32.51341537863644, 2.566135889448976],
            [32.51443378250437, 2.565931449444609],
            [32.51666446913644, 2.563805557737481],
            [32.52045232871964, 2.56303975825298],
            [32.52219253340997, 2.56215204059253],
            [32.52591424554721, 2.559272948707399],
            [32.5293331230258, 2.554531693556283],
            [32.527942764527964, 2.550004615803992],
            [32.52809463909978, 2.546037943016296],
            [32.528968963975935, 2.542391162611291],
            [32.53392705887977, 2.533558086530132],
            [32.5344818332464, 2.531683925822637],
            [32.53542349314131, 2.526956826030833],
            [32.53557569200494, 2.520694626625448],
            [32.5309392757195, 2.514589653721497],
            [32.530519832550425, 2.510758635677181],
            [32.53164730986014, 2.499566755872953],
            [32.53144605040559, 2.497237708974446],
            [32.53066651036833, 2.496317960696731],
            [32.52519108467552, 2.49261572128691],
            [32.523968297012466, 2.488655570588606],
            [32.52415920877328, 2.48755516663121],
            [32.5257304322738, 2.485259336293793],
            [32.536165016475735, 2.477860671525998],
            [32.537831645550995, 2.475014617938283],
            [32.538344210777375, 2.472921533215179],
            [32.53855848322717, 2.472562784901227],
            [32.539295874311286, 2.472563191459185],
            [32.53962949603139, 2.471438939747025],
            [32.53932146641543, 2.469261664754836],
            [32.53856097605208, 2.468041105047372],
            [32.538895103523686, 2.466007718903381],
            [32.538063877119924, 2.463638764549763],
            [32.53744608952936, 2.462442201146398],
            [32.536435456088654, 2.461927267683398],
            [32.53603174511512, 2.460730835571174],
            [32.535104346873666, 2.46025182875978],
            [32.534986365737545, 2.458529214843477],
            [32.53398785595986, 2.457595615657283],
            [32.53408332800995, 2.456997562930912],
            [32.53339409920149, 2.455968440109596],
            [32.533264740902254, 2.453300808672275],
            [32.532670555647464, 2.452463131628363],
            [32.53141026691454, 2.45176861765611],
            [32.53171439604557, 2.450801579418772],
            [32.53433558392488, 2.45246405963559],
            [32.53589335066245, 2.452883596920542],
            [32.54036508599336, 2.453005694447143],
            [32.5434563514811, 2.454729955204091],
            [32.5471901675185, 2.455880372092248],
            [32.548188475175195, 2.457196752620556],
            [32.55059987679128, 2.462593000288495],
            [32.55338150467866, 2.465154414770413],
            [32.556484864185066, 2.466603523878963],
            [32.560742159979576, 2.467514952528632],
            [32.56568969428893, 2.467637233596917],
            [32.57079073001907, 2.46987688706343],
            [32.57253004268231, 2.471195452582398],
            [32.57309454041359, 2.472201374567004],
            [32.573510593340785, 2.486415808885286],
            [32.57466618791891, 2.489821692462237],
            [32.57744106047535, 2.49354538644671],
            [32.58250833122895, 2.497206353440605],
            [32.584020288378596, 2.504398602059413],
            [32.58759475226775, 2.506980316655937],
            [32.58818256128065, 2.510364864690273],
            [32.587449235073194, 2.514031413501723],
            [32.5891296425083, 2.514031947484881],
            [32.5897809767848, 2.515233836194011],
            [32.592003907362724, 2.527251348431665],
            [32.59363263831276, 2.529054384430308],
            [32.59965844830543, 2.533593665426756],
            [32.60505689825986, 2.541826129128982],
            [32.60334622837947, 2.541895943908826],
            [32.601371339719506, 2.542596764946002],
            [32.59593321567056, 2.546305220532696],
            [32.59817661346389, 2.549513709467576],
            [32.602461372553265, 2.553227210190595],
            [32.610175571512315, 2.556693485826519],
            [32.612090285624646, 2.557935368817021],
            [32.61390476032769, 2.559187509005449],
            [32.61799988506057, 2.563412859163217],
            [32.62002024105033, 2.569880014650057],
            [32.613684296688966, 2.573593459910094],
            [32.612879098072284, 2.574456392167621],
            [32.612603393433474, 2.575722150485995],
            [32.615177348793466, 2.581348671753489],
            [32.6156637371125, 2.58502233586206],
            [32.614078250161896, 2.585163891014637],
            [32.61199196771175, 2.586423650321189],
            [32.610879159890615, 2.588269039338951],
            [32.61122666148017, 2.590070831891014],
            [32.610892825062734, 2.590546207529468],
            [32.61089264629797, 2.592306489585603],
            [32.61130983379739, 2.592697173563904],
            [32.611226083863436, 2.595547240822212],
            [32.611587583001764, 2.596524752551348],
            [32.61249155497723, 2.596872962525288],
            [32.61281100128214, 2.600937984523505],
            [32.61397899081459, 2.603507186651815],
            [32.61470210048231, 2.604512222262638],
            [32.61539748724204, 2.604595237766018],
            [32.61553647009124, 2.605517125155662],
            [32.618729511107375, 2.607893056247124],
            [32.57900360265698, 2.614207248799939],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 488,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "ABOK",
        Population: 17543,
        Key: "OYAMABOK",
        Dist2: "Oyam",
        "Sub Country": "Abok",
        id2_original: "Oyam Abok",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.46992737428516, 2.419197358274956],
            [32.46886116926434, 2.419662673770288],
            [32.467981890179416, 2.418848692634644],
            [32.466006605362395, 2.419278212675251],
            [32.46543589488262, 2.41903862472138],
            [32.464910623884855, 2.42049779176479],
            [32.46388640791704, 2.421406380574182],
            [32.462411881768645, 2.420950934735837],
            [32.46022194361618, 2.421787054458481],
            [32.457926940304745, 2.421055977018509],
            [32.45744996722822, 2.42194095278855],
            [32.4563318072446, 2.42189244939891],
            [32.45618685958195, 2.423615017829444],
            [32.45566288215821, 2.424045374634754],
            [32.45242630519011, 2.424713387749316],
            [32.450691098726075, 2.423444292240192],
            [32.448526207400356, 2.423299464336638],
            [32.445793411931824, 2.420737787829501],
            [32.44460377569599, 2.420761005609517],
            [32.44365330242987, 2.419827340717454],
            [32.4425355323151, 2.419467782105967],
            [32.44225126313837, 2.418510590657588],
            [32.441562156500765, 2.41784025709987],
            [32.44115984869573, 2.416165214713054],
            [32.439562099741494, 2.413728352478396],
            [32.4385686995812, 2.411962760571615],
            [32.434765431195906, 2.412330424870978],
            [32.43400144548779, 2.411361881947212],
            [32.433600015336786, 2.409016921785148],
            [32.43434107244559, 2.406289840737809],
            [32.43264472979564, 2.402592313096989],
            [32.43281281895837, 2.401396128141438],
            [32.43457557854881, 2.399698459506402],
            [32.43481620846734, 2.39759314646096],
            [32.43317544997393, 2.396922238964763],
            [32.432033272632886, 2.397065112163436],
            [32.43132098137614, 2.395940179074442],
            [32.43003617222922, 2.395987256315742],
            [32.42775333929325, 2.395100635563796],
            [32.426482021045274, 2.393915547417394],
            [32.42633973778574, 2.393556575239838],
            [32.427293275205294, 2.392097685422242],
            [32.42736570007845, 2.391284254179118],
            [32.42646305221973, 2.390183131506185],
            [32.425300708598876, 2.387526688450353],
            [32.42261655600465, 2.384223329391864],
            [32.42272696973286, 2.38162746321653],
            [32.422062091556775, 2.380646111319507],
            [32.422206223549175, 2.379569552100897],
            [32.421756486493756, 2.377798775931747],
            [32.42280505578892, 2.376435649778496],
            [32.424079489394295, 2.37251142504625],
            [32.42620054742571, 2.372358374723648],
            [32.42567829027574, 2.37147281580568],
            [32.42577462111522, 2.370563698417659],
            [32.42658502996058, 2.369391822594598],
            [32.42801347702648, 2.368627063636144],
            [32.4288717966192, 2.367192035690561],
            [32.4308715605277, 2.366164423722887],
            [32.43118228778447, 2.365040101769447],
            [32.4298756343048, 2.363603788408822],
            [32.429449205836065, 2.362191917491696],
            [32.42987114901659, 2.357825734233791],
            [32.430657659980426, 2.35672561888645],
            [32.43106455997323, 2.354811812112023],
            [32.42753621828569, 2.351232831598292],
            [32.42639426821841, 2.351232144965667],
            [32.423564375647445, 2.350297359390571],
            [32.42366107120295, 2.34910112644335],
            [32.423305295231295, 2.348263523750157],
            [32.42380766368089, 2.346110511320768],
            [32.422978558199546, 2.343334644589828],
            [32.423160447281646, 2.34064311841119],
            [32.42355585782194, 2.339891425702613],
            [32.42242580144902, 2.338417592375407],
            [32.42340302205277, 2.337006562138257],
            [32.41926671675061, 2.334491900715896],
            [32.415197840790334, 2.330533336175972],
            [32.41526582978262, 2.328448280560904],
            [32.41648008434878, 2.327707317214238],
            [32.41645808191253, 2.326319618568147],
            [32.4173648817845, 2.324166848053388],
            [32.41538008201202, 2.322861716741718],
            [32.41321498676873, 2.32300397732588],
            [32.41167085016899, 2.321280400353341],
            [32.41276648579515, 2.320276183284748],
            [32.41267188061933, 2.319845467474127],
            [32.409723517330356, 2.318599558081948],
            [32.4097247821583, 2.317618609781615],
            [32.41124885488617, 2.316447175232137],
            [32.41122663954918, 2.315226956133828],
            [32.41020425434791, 2.31477175633319],
            [32.406991642634985, 2.315511516521757],
            [32.40649375588034, 2.314195301953079],
            [32.406768930513124, 2.312963305519437],
            [32.40745939450513, 2.312533058716522],
            [32.40738997359827, 2.311025707927599],
            [32.40543960086075, 2.310713491153519],
            [32.40408477881722, 2.309779578054972],
            [32.404110521838305, 2.308272286276851],
            [32.40308915622491, 2.307027534478628],
            [32.40405600847361, 2.304432192922317],
            [32.405461487414335, 2.302973587926707],
            [32.40522835124189, 2.299288903742068],
            [32.404539281435206, 2.298642498197033],
            [32.405016091018354, 2.297853242244044],
            [32.40613473339728, 2.297447185498536],
            [32.40637321364732, 2.296992734885494],
            [32.405913649022686, 2.293630921980718],
            [32.404820340931416, 2.292840721681837],
            [32.40406064647543, 2.291620055997155],
            [32.403180128613705, 2.291858777247784],
            [32.40282207990439, 2.292791665361626],
            [32.40163221998808, 2.293078056840717],
            [32.399731129725325, 2.291473885931412],
            [32.39804296264284, 2.290779025444231],
            [32.39749886475333, 2.288410067407085],
            [32.39611959775432, 2.288002495527377],
            [32.396780234983936, 2.28634879923354],
            [32.396560913103926, 2.285451179044732],
            [32.39801719896048, 2.283110877136364],
            [32.4017574451387, 2.278997937765276],
            [32.40862132310432, 2.278511567855812],
            [32.41154524413271, 2.280212025771022],
            [32.41420878218778, 2.280907455068717],
            [32.417919756762444, 2.281053200746621],
            [32.42002560182455, 2.280683595416172],
            [32.42333475278611, 2.278795416576602],
            [32.429265839923644, 2.272889233494629],
            [32.432157760266655, 2.271706585268495],
            [32.43401263220801, 2.272257947055258],
            [32.436104198548655, 2.273766471454324],
            [32.441548369157786, 2.276640692913718],
            [32.44436762387915, 2.276486785752548],
            [32.447795961515986, 2.274383275232512],
            [32.45017896648762, 2.271154645210661],
            [32.45105999189748, 2.270509147051113],
            [32.45239507256433, 2.268213026446798],
            [32.45390778789206, 2.266551030554229],
            [32.45517398035303, 2.262269024877601],
            [32.45742103069629, 2.260424906606062],
            [32.4589177092996, 2.258722803423002],
            [32.459914222122364, 2.258667730110318],
            [32.47940473527992, 2.264584029930482],
            [32.48243626190295, 2.266433046568488],
            [32.484001103771696, 2.268124998585886],
            [32.4867822393823, 2.273433460639681],
            [32.48807094811585, 2.286104504762574],
            [32.48854591705094, 2.286731923654294],
            [32.48929943289443, 2.287373755924808],
            [32.492719812356164, 2.288658101779263],
            [32.50664418524858, 2.292033779872503],
            [32.510046617269246, 2.296361336968412],
            [32.51605056496285, 2.302304459762306],
            [32.53613854222598, 2.31083371904744],
            [32.53944947275013, 2.313044620291649],
            [32.53816986215378, 2.315682788583325],
            [32.53569325901777, 2.318930732693703],
            [32.54946713355736, 2.316748581175629],
            [32.55627907183157, 2.314407995811673],
            [32.56107946389402, 2.322713508796453],
            [32.56321988061981, 2.32084026207039],
            [32.56546945522904, 2.319339759674962],
            [32.56610851492551, 2.319334907360858],
            [32.57420446913424, 2.326853810193501],
            [32.57227686509588, 2.327929277388069],
            [32.56971330593867, 2.330374222635298],
            [32.567938781112936, 2.33123298549881],
            [32.5668212885776, 2.332422454341258],
            [32.56695257376311, 2.332885199714102],
            [32.56820108917589, 2.333017789757692],
            [32.568858023549936, 2.333679000297088],
            [32.569119727945015, 2.337446827312589],
            [32.56990746600755, 2.340157204028416],
            [32.5678019227794, 2.34894795865495],
            [32.57085677236215, 2.351754709104346],
            [32.569484414305975, 2.36102469468799],
            [32.566581424023695, 2.36346347335263],
            [32.56501040893234, 2.365831174373374],
            [32.56449616026309, 2.371393321058173],
            [32.56574037633894, 2.380066559769588],
            [32.563859727240505, 2.383199666697225],
            [32.56133720761702, 2.385710394967378],
            [32.5591362911535, 2.387228428403612],
            [32.557513810681165, 2.389822131720129],
            [32.55742147644638, 2.391581745056774],
            [32.556850408437114, 2.392012079668322],
            [32.557325857970895, 2.392490824341641],
            [32.55630143449224, 2.395648286140829],
            [32.555254665420925, 2.396054441815369],
            [32.55436224577999, 2.396951134023655],
            [32.55345836992427, 2.397022420287192],
            [32.55131647816481, 2.399318008313613],
            [32.55057782225274, 2.401781817615841],
            [32.55089050604023, 2.406023795995107],
            [32.547756966733544, 2.404341497835089],
            [32.54673426891855, 2.404441615786954],
            [32.54638425474115, 2.400462835901435],
            [32.54696571715655, 2.396403786435195],
            [32.55095323090492, 2.389301428182113],
            [32.55236737679148, 2.384126353139814],
            [32.55297517331946, 2.376515462863624],
            [32.55257190970694, 2.375602001990164],
            [32.55085724232357, 2.374180704729468],
            [32.55107884682268, 2.361160191030661],
            [32.538753588323736, 2.360105718905964],
            [32.534497756783125, 2.358915059214194],
            [32.53426148549037, 2.358360008087109],
            [32.53512925715651, 2.356061119822418],
            [32.53552437664264, 2.352969254445766],
            [32.53513059834124, 2.352017737749149],
            [32.534621161048655, 2.351801551792815],
            [32.53167985761954, 2.352917467149977],
            [32.529254968697764, 2.355222740434534],
            [32.52858836934961, 2.356084233681576],
            [32.52733629660829, 2.359516299129636],
            [32.52170639931418, 2.356158027133705],
            [32.51948749498539, 2.354330605853908],
            [32.51504352927483, 2.353504296676167],
            [32.512504697144145, 2.352405757618784],
            [32.50925086713269, 2.351972837384602],
            [32.50803730696423, 2.352753635893562],
            [32.50753133537204, 2.357117119959358],
            [32.508841733928115, 2.360364963684598],
            [32.50879046976982, 2.362699001033818],
            [32.503003501149934, 2.371431584340252],
            [32.50115240392942, 2.375544937984455],
            [32.49357028067332, 2.378019760582568],
            [32.48974068805695, 2.377347711729769],
            [32.48707730990196, 2.37634134586087],
            [32.484347235430434, 2.381113035763563],
            [32.48186978069151, 2.383660798462873],
            [32.48379584591577, 2.38979117667045],
            [32.48036522206656, 2.396032427201887],
            [32.47458872061638, 2.404377147506008],
            [32.46992737428516, 2.419197358274956],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 489,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "ACABA",
        Population: 28092,
        Key: "OYAMACABA",
        Dist2: "Oyam",
        "Sub Country": "Acaba",
        id2_original: "Oyam Acaba",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.786315675642065, 2.587357104985875],
            [32.78594849016802, 2.603585513369266],
            [32.77872427638237, 2.606206150964407],
            [32.77780117747787, 2.604840416505013],
            [32.777203760983014, 2.604621820171164],
            [32.77524842954509, 2.604785339371449],
            [32.77361914792776, 2.604020327384033],
            [32.77269578132532, 2.604184027037312],
            [32.76818788521095, 2.603309238988684],
            [32.76568928682521, 2.604182735696627],
            [32.76329951484453, 2.603963796446517],
            [32.76205020352439, 2.604455163683423],
            [32.75156730343489, 2.606091807815605],
            [32.746480639850944, 2.606364120523959],
            [32.74349130799514, 2.605839135246669],
            [32.739041936223245, 2.605733338773092],
            [32.73175927355363, 2.606972824479221],
            [32.72529375799233, 2.606936462415578],
            [32.71394410582453, 2.607965193428361],
            [32.69957002192785, 2.609971929229915],
            [32.69766686823489, 2.605314724975368],
            [32.697068654036045, 2.60406336340376],
            [32.69719055362348, 2.603067078766097],
            [32.69927729690933, 2.598418120243009],
            [32.70218297135767, 2.594206153434932],
            [32.709882234926845, 2.585416090299709],
            [32.71381031523769, 2.584647902354888],
            [32.71996291434785, 2.584474491185269],
            [32.72427350089995, 2.583007184974681],
            [32.72503843612733, 2.582028515037533],
            [32.72528534886296, 2.58052248031305],
            [32.724701619099754, 2.575490903752074],
            [32.72606706192487, 2.574252832956489],
            [32.72804854601566, 2.571238105837587],
            [32.72851746300071, 2.568990302304177],
            [32.72851774147845, 2.567671172620486],
            [32.72736739755315, 2.564467323860899],
            [32.72518612185498, 2.562999658985003],
            [32.72537389310557, 2.561142150533423],
            [32.72438375742299, 2.559849728019656],
            [32.723434499577415, 2.555178725206803],
            [32.722551644299344, 2.552944090994206],
            [32.72167451128961, 2.545915697093372],
            [32.71986772077553, 2.542734084431598],
            [32.717922985864696, 2.534553379881083],
            [32.71792030349526, 2.532491499947572],
            [32.71964612346294, 2.522580484339229],
            [32.71954305346217, 2.516952149059244],
            [32.720837698263104, 2.507653662990001],
            [32.71988639405533, 2.506083778939248],
            [32.716079915091214, 2.504306954616621],
            [32.71295947052646, 2.501564659563416],
            [32.71269320358802, 2.50068404984794],
            [32.71365701773444, 2.497618438400333],
            [32.7136894945269, 2.494908432683511],
            [32.71326202401244, 2.49323351742804],
            [32.71332390895238, 2.487503569355277],
            [32.714086678341594, 2.483747717162982],
            [32.71307899317163, 2.475959784140907],
            [32.71333147366537, 2.469488248218958],
            [32.71631761201036, 2.46739610342194],
            [32.718149472707395, 2.466750899549969],
            [32.72117037854881, 2.46682394119169],
            [32.72383481222423, 2.466107309937454],
            [32.72577334067475, 2.466359330406576],
            [32.73040087531695, 2.464661743556485],
            [32.736947957007736, 2.466576547335444],
            [32.74062482165279, 2.467105597299447],
            [32.74705886922966, 2.470540957146571],
            [32.74864778774464, 2.471830938183597],
            [32.75076813341206, 2.471940706197312],
            [32.75143429258573, 2.471161596948717],
            [32.75290229786345, 2.470833773529291],
            [32.75574296931953, 2.47124442626318],
            [32.757135916762, 2.472577586123955],
            [32.76287866491371, 2.472120658875856],
            [32.76554254702354, 2.473091764272681],
            [32.77418048718252, 2.473547130471591],
            [32.77856349052293, 2.474994259563318],
            [32.78105784975887, 2.476843942838764],
            [32.78527335053646, 2.480918354881157],
            [32.788935992155594, 2.482320845515062],
            [32.79005974145688, 2.48210367603909],
            [32.79081596841587, 2.48284277852561],
            [32.791982862901946, 2.483103780403677],
            [32.795147826175594, 2.488809670327297],
            [32.79547171464958, 2.490483304243339],
            [32.79648722773896, 2.491548464058968],
            [32.797243589445245, 2.491461645882124],
            [32.799123467789165, 2.492744285881496],
            [32.802658218057935, 2.497777492873539],
            [32.80253593399158, 2.49966718350331],
            [32.80296493972685, 2.501985118241543],
            [32.800877107682844, 2.5014037406287],
            [32.7995065974612, 2.501726584530025],
            [32.79852067397902, 2.502569043481352],
            [32.798307762476895, 2.517332079404444],
            [32.79669557579943, 2.519788473212577],
            [32.794333462946355, 2.527588209355323],
            [32.79116856794468, 2.533937354197396],
            [32.79125316049836, 2.540570741287529],
            [32.79218155586975, 2.546756083957802],
            [32.79381097043775, 2.549039450204097],
            [32.79449755819932, 2.550926038386083],
            [32.79534224406095, 2.555443093176556],
            [32.79696676011571, 2.559843717108053],
            [32.797221251039055, 2.562517764096367],
            [32.79579544771507, 2.566607697834697],
            [32.79048066864282, 2.571828777051304],
            [32.78739503828687, 2.575892202955282],
            [32.78639505706881, 2.579650086340199],
            [32.786315675642065, 2.587357104985875],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 490,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "ALEKA",
        Population: 29558,
        Key: "OYAMALEKA",
        Dist2: "Oyam",
        "Sub Country": "Aleka",
        id2_original: "Oyam Aleka",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.69336205425681, 2.46993490021872],
            [32.69113893143945, 2.470616309591704],
            [32.690044291146606, 2.471620661425883],
            [32.68831948447859, 2.472206060305841],
            [32.68420451326615, 2.471821431183841],
            [32.68061352217237, 2.469929773808826],
            [32.67634347119917, 2.470609696957101],
            [32.67258433075556, 2.472426273858782],
            [32.669658730775936, 2.47199428840699],
            [32.667766266136546, 2.470637972072659],
            [32.66792117881068, 2.474433803716322],
            [32.668966768394036, 2.476731054706485],
            [32.671534164255824, 2.480273069635431],
            [32.67190190219379, 2.482390571933873],
            [32.67059254478512, 2.484758510953714],
            [32.667023473482615, 2.486957935128894],
            [32.66528620897823, 2.488703631795553],
            [32.66452460021237, 2.489612419241134],
            [32.663810102693276, 2.491549977186744],
            [32.66369221049033, 2.497998893092633],
            [32.66481857838069, 2.499604135105707],
            [32.66529124942531, 2.502481495501476],
            [32.6666957051849, 2.505064345569756],
            [32.66636184810619, 2.506741212948203],
            [32.65711754872369, 2.514136158554332],
            [32.64456857109144, 2.523350479163789],
            [32.641870497305256, 2.524862512986808],
            [32.63748963914174, 2.526586096379839],
            [32.636655141073724, 2.527481205627957],
            [32.6347359075372, 2.528265836602905],
            [32.63049417056341, 2.529123061945028],
            [32.626071357482864, 2.533291485736143],
            [32.623053430454924, 2.534203131908888],
            [32.621606959591176, 2.535545995415699],
            [32.61882551316348, 2.535772793577538],
            [32.615278972506616, 2.538110019019876],
            [32.61458355340751, 2.538753471876495],
            [32.61355420895773, 2.540906123367142],
            [32.611996495220794, 2.541969701998177],
            [32.60982690750278, 2.54261487240931],
            [32.60505689825986, 2.541826129128982],
            [32.59965844830543, 2.533593665426756],
            [32.59363263831276, 2.529054384430308],
            [32.592003907362724, 2.527251348431665],
            [32.5897809767848, 2.515233836194011],
            [32.5891296425083, 2.514031947484881],
            [32.587449235073194, 2.514031413501723],
            [32.58818256128065, 2.510364864690273],
            [32.58759475226775, 2.506980316655937],
            [32.584020288378596, 2.504398602059413],
            [32.58250833122895, 2.497206353440605],
            [32.57744106047535, 2.49354538644671],
            [32.57466618791891, 2.489821692462237],
            [32.573510593340785, 2.486415808885286],
            [32.57309454041359, 2.472201374567004],
            [32.57253004268231, 2.471195452582398],
            [32.57079073001907, 2.46987688706343],
            [32.56568969428893, 2.467637233596917],
            [32.560742159979576, 2.467514952528632],
            [32.556484864185066, 2.466603523878963],
            [32.55338150467866, 2.465154414770413],
            [32.55059987679128, 2.462593000288495],
            [32.548188475175195, 2.457196752620556],
            [32.5471901675185, 2.455880372092248],
            [32.5434563514811, 2.454729955204091],
            [32.54036508599336, 2.453005694447143],
            [32.53589335066245, 2.452883596920542],
            [32.53433558392488, 2.45246405963559],
            [32.53171439604557, 2.450801579418772],
            [32.52977072653666, 2.448705400695181],
            [32.52881933159905, 2.44860917217454],
            [32.52827252978056, 2.448106459960745],
            [32.52786909818308, 2.446431531443363],
            [32.52687088754443, 2.444995522764772],
            [32.526967540879106, 2.442268211800255],
            [32.52569549230083, 2.44137033523695],
            [32.52507787988172, 2.439886688081372],
            [32.52272381054373, 2.438569533957335],
            [32.519988917508975, 2.437706714059293],
            [32.51876468715159, 2.436378224130483],
            [32.51455621838604, 2.433504936230972],
            [32.514390777456796, 2.43161482494411],
            [32.513487638219594, 2.430346330065339],
            [32.510776869441834, 2.42893326158674],
            [32.506735691236685, 2.424720294993956],
            [32.50545130160301, 2.424671706440333],
            [32.504215050888796, 2.423618333237749],
            [32.50302155279557, 2.423432781650786],
            [32.50456187425031, 2.422607177301777],
            [32.504681481337144, 2.4214110359751],
            [32.50629898334616, 2.421268417531825],
            [32.50789728386596, 2.419103200009272],
            [32.50965812285835, 2.417836230845114],
            [32.51165610181434, 2.417837363509727],
            [32.5127745456656, 2.416904957615406],
            [32.51353556064505, 2.417120712408106],
            [32.515153644762364, 2.415925413498114],
            [32.51661670750942, 2.415459716174112],
            [32.518757406306214, 2.415437006298088],
            [32.52044582222207, 2.416083911368951],
            [32.521897249091225, 2.415151680183798],
            [32.52275338218454, 2.415415331258961],
            [32.523728940905016, 2.414769918441407],
            [32.52484654842471, 2.415344726275039],
            [32.52560774666048, 2.415225535087845],
            [32.526892821708735, 2.414030037953519],
            [32.52820067893088, 2.414652796879501],
            [32.529080991078374, 2.414198721976848],
            [32.529568194169336, 2.414928684804797],
            [32.5314712724038, 2.414499104151774],
            [32.53377829068219, 2.414811398113328],
            [32.534586736708654, 2.415290322371223],
            [32.535324180793395, 2.415123266579895],
            [32.53658417667552, 2.416296249446543],
            [32.53744056848363, 2.416081394732078],
            [32.537844504934306, 2.416847197960997],
            [32.53934284452256, 2.417135107667611],
            [32.54910934446118, 2.412415380445049],
            [32.55067934535458, 2.412129133739162],
            [32.55172699297829, 2.410096131577903],
            [32.55108565156097, 2.408468938202649],
            [32.55089050604023, 2.406023795995107],
            [32.55057782225274, 2.401781817615841],
            [32.55131647816481, 2.399318008313613],
            [32.55345836992427, 2.397022420287192],
            [32.55436224577999, 2.396951134023655],
            [32.555254665420925, 2.396054441815369],
            [32.55630143449224, 2.395648286140829],
            [32.557325857970895, 2.392490824341641],
            [32.556850408437114, 2.392012079668322],
            [32.55742147644638, 2.391581745056774],
            [32.557513810681165, 2.389822131720129],
            [32.5591362911535, 2.387228428403612],
            [32.56133720761702, 2.385710394967378],
            [32.563859727240505, 2.383199666697225],
            [32.56574037633894, 2.380066559769588],
            [32.56449616026309, 2.371393321058173],
            [32.56501040893234, 2.365831174373374],
            [32.566581424023695, 2.36346347335263],
            [32.569484414305975, 2.36102469468799],
            [32.57085677236215, 2.351754709104346],
            [32.5678019227794, 2.34894795865495],
            [32.56990746600755, 2.340157204028416],
            [32.569119727945015, 2.337446827312589],
            [32.568858023549936, 2.333679000297088],
            [32.56820108917589, 2.333017789757692],
            [32.56695257376311, 2.332885199714102],
            [32.5668212885776, 2.332422454341258],
            [32.567938781112936, 2.33123298549881],
            [32.56971330593867, 2.330374222635298],
            [32.57227686509588, 2.327929277388069],
            [32.57420446913424, 2.326853810193501],
            [32.5751687854389, 2.326145433369028],
            [32.578323160270294, 2.325683680295548],
            [32.58279218628232, 2.323900291200811],
            [32.583208010139124, 2.326790456683968],
            [32.58599056778283, 2.327174649095975],
            [32.59108044104727, 2.327057580257587],
            [32.59317320214725, 2.327561036869647],
            [32.595361480213036, 2.327298949680913],
            [32.59727595627184, 2.327598955786724],
            [32.605102356606515, 2.324731859662095],
            [32.61162995473709, 2.327163378254224],
            [32.614507134624596, 2.328672014223154],
            [32.61769441654147, 2.328266832458445],
            [32.620929812224944, 2.326713288599597],
            [32.62084532387587, 2.329356910165748],
            [32.62148679644721, 2.33084053383793],
            [32.62317449371082, 2.332946703953764],
            [32.624029367366134, 2.33584197957927],
            [32.62377264143434, 2.336568665508888],
            [32.62254196296983, 2.337695428451289],
            [32.617761187418225, 2.337908451763915],
            [32.61592958184273, 2.338338213323132],
            [32.61440645414251, 2.340275368601707],
            [32.6166039632962, 2.345623562150479],
            [32.61662649214521, 2.348255269780009],
            [32.61709981446839, 2.34925262385526],
            [32.614653060552634, 2.360793867453181],
            [32.615966419057564, 2.364231494165622],
            [32.61662337229622, 2.364958789113742],
            [32.617477618029135, 2.365157331679918],
            [32.62049968090061, 2.368264923706269],
            [32.624770999396716, 2.368993207430904],
            [32.62822715875622, 2.370805320611563],
            [32.62943573686812, 2.373026650032383],
            [32.63253670056762, 2.376147463146748],
            [32.634008600940426, 2.376676667797357],
            [32.637057121891985, 2.3793744114882],
            [32.64043736642348, 2.381158501531857],
            [32.64317591739804, 2.387384576265712],
            [32.64853613415564, 2.394767824025451],
            [32.65093735067304, 2.397209243683087],
            [32.65608692686956, 2.397199660764402],
            [32.656610423694666, 2.396721408685034],
            [32.65818026648458, 2.396722130298731],
            [32.66003580138263, 2.396148790154943],
            [32.66115430721762, 2.394857363484248],
            [32.66177172110903, 2.397106564550529],
            [32.66364945697101, 2.40005014933209],
            [32.66551585878904, 2.401761613404783],
            [32.66817943637002, 2.402695883060392],
            [32.67667792655584, 2.4138127066279],
            [32.680405236993955, 2.417075471316914],
            [32.681772256362414, 2.417185795781332],
            [32.68526473730379, 2.416162104817841],
            [32.688272001329324, 2.415918870600506],
            [32.69127913240414, 2.416261066796427],
            [32.69351056284126, 2.415041917400025],
            [32.694431667485816, 2.417091150024842],
            [32.69549855792122, 2.417920759754974],
            [32.6958371679861, 2.422018884723533],
            [32.69525498152854, 2.422652974666041],
            [32.69401269054237, 2.427358762934304],
            [32.69669619006138, 2.429417689754966],
            [32.69733832469108, 2.43304492706387],
            [32.69646469421267, 2.435532831454511],
            [32.695106250161906, 2.436996110994528],
            [32.69505758123646, 2.437727893319775],
            [32.69675492101632, 2.439094295069899],
            [32.69816111950758, 2.440997280371198],
            [32.70155588171236, 2.443437357619739],
            [32.70301049849912, 2.44577942646132],
            [32.70635570334459, 2.453146903158006],
            [32.706549423239, 2.454512961615562],
            [32.70591859390713, 2.455732480957431],
            [32.707227917179814, 2.457147574692954],
            [32.70732477892364, 2.457830603397249],
            [32.70705868985167, 2.458911922695295],
            [32.698491548615166, 2.464925453132407],
            [32.69770613988417, 2.465953877977083],
            [32.695422140036634, 2.467005563881181],
            [32.69470778714628, 2.468727825789875],
            [32.69336205425681, 2.46993490021872],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 491,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "ICEME",
        Population: 46755,
        Key: "OYAMICEME",
        Dist2: "Oyam",
        "Sub Country": "Iceme",
        id2_original: "Oyam Iceme",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.396560913103926, 2.285451179044732],
            [32.39568337854729, 2.284999584381553],
            [32.39575620586568, 2.28387512325888],
            [32.394474146461874, 2.281888524654274],
            [32.3932966150245, 2.28185192399598],
            [32.39199161534328, 2.2792193202913],
            [32.39111146668913, 2.279170940299445],
            [32.39011026735554, 2.280749414001167],
            [32.38920645348355, 2.280605308214509],
            [32.38870759295516, 2.28005471258402],
            [32.38918502776571, 2.278786958445822],
            [32.388900272600424, 2.278236500351002],
            [32.386405399528144, 2.275914196286555],
            [32.38600123580373, 2.275722549170734],
            [32.38476338878324, 2.276343851813289],
            [32.383765047888886, 2.275721180320377],
            [32.38276922766718, 2.273160539245259],
            [32.38157954651559, 2.273327284355077],
            [32.380664520770566, 2.272668778123915],
            [32.38073893720872, 2.270324119990147],
            [32.37995399021176, 2.27025186685941],
            [32.37776338820432, 2.271781745682815],
            [32.37728795034861, 2.271518271315236],
            [32.37740723763521, 2.270291053827098],
            [32.37677784381114, 2.270477204700116],
            [32.37684746055074, 2.271817069298933],
            [32.37511075479847, 2.271887774873191],
            [32.37549013669915, 2.272845030760674],
            [32.37497621322006, 2.274722857211815],
            [32.37407215949788, 2.274770143169613],
            [32.37273809213068, 2.276204848478681],
            [32.372310721329235, 2.277229125732079],
            [32.37259183921591, 2.278884401531009],
            [32.371710605396935, 2.279673393260622],
            [32.371303427824735, 2.281778578162573],
            [32.37054144895296, 2.282328392218821],
            [32.3704926210257, 2.283285377273713],
            [32.37121695330054, 2.284230881368315],
            [32.37066835125819, 2.285331112376721],
            [32.37055055158175, 2.2870932470715],
            [32.371401992774324, 2.288250468035719],
            [32.37156632877578, 2.289925352628354],
            [32.37123000761822, 2.292413385093341],
            [32.37070540945862, 2.293346155260667],
            [32.37116781545448, 2.294482897927152],
            [32.37221326490069, 2.295464499474023],
            [32.372114125029285, 2.298502962058169],
            [32.37273079601396, 2.299914944435088],
            [32.37158464632272, 2.303144167662964],
            [32.370118106197225, 2.305787003844699],
            [32.369757955430146, 2.308298941899416],
            [32.36825654989183, 2.310307735175774],
            [32.36506493090878, 2.313176768791701],
            [32.362923499086726, 2.313438589323029],
            [32.361197556948184, 2.314334688451607],
            [32.357791827212104, 2.315156092034399],
            [32.3527437453713, 2.320250496374908],
            [32.35155914509096, 2.320688882768229],
            [32.348797516396765, 2.324678233985831],
            [32.33709577045165, 2.323378430265218],
            [32.334664638238685, 2.323377279571759],
            [32.31399370196686, 2.325738166708318],
            [32.30991647886095, 2.324494002014821],
            [32.30848264908989, 2.324681410507246],
            [32.30374394523629, 2.32699911853831],
            [32.30162459759718, 2.326809952005077],
            [32.295514822074914, 2.328437199117361],
            [32.29370719163602, 2.328185470990324],
            [32.29264787938836, 2.327369784449199],
            [32.295192713163516, 2.322400084664633],
            [32.29158941515037, 2.324861089948998],
            [32.286976727863156, 2.324482527401872],
            [32.28386020624122, 2.323916604653275],
            [32.281493274824946, 2.320278573537046],
            [32.279213936335424, 2.322306572351705],
            [32.277793494157045, 2.322608892575541],
            [32.26625894175431, 2.322819375334611],
            [32.25988923151806, 2.322729445280164],
            [32.258138123076826, 2.322370978023294],
            [32.25711934730639, 2.321643357571648],
            [32.25488645710692, 2.32123509958364],
            [32.2526823956416, 2.318962840912125],
            [32.248806769756804, 2.319020192658097],
            [32.241914755658165, 2.320171840644994],
            [32.234907993460084, 2.320101136562132],
            [32.23901419621706, 2.311232688238373],
            [32.23982998956422, 2.308193820170699],
            [32.23966303856699, 2.307166680229841],
            [32.24250409001043, 2.30315037539273],
            [32.24350519142767, 2.299883731582717],
            [32.24410151826608, 2.294312949062784],
            [32.243847944522635, 2.292900762780951],
            [32.243177055718974, 2.291902142836979],
            [32.243396380293916, 2.291674124538185],
            [32.24204938167821, 2.289520640927275],
            [32.24265665538671, 2.28639259853032],
            [32.24590298446549, 2.284606232229855],
            [32.24765430760406, 2.282939656816616],
            [32.24866764317717, 2.281146292096995],
            [32.249083975480424, 2.278206701652397],
            [32.25057134035087, 2.275777098529656],
            [32.2506518815026, 2.274995821395854],
            [32.25209570233627, 2.273840042995297],
            [32.251930879447926, 2.272619759712428],
            [32.253623853415554, 2.269749977008538],
            [32.25429484822037, 2.266209557179935],
            [32.254202117828555, 2.264462983126257],
            [32.255466528930285, 2.261856061712817],
            [32.254945002110624, 2.260539828414323],
            [32.25513623367167, 2.259870072820288],
            [32.25674376168608, 2.258567280439836],
            [32.25648367246189, 2.25741870397926],
            [32.257125958008565, 2.25741915907167],
            [32.25819742625864, 2.256702157680681],
            [32.25867425021481, 2.255936892755511],
            [32.25899192414367, 2.253818361235201],
            [32.260913465452184, 2.25368951590497],
            [32.2618421015721, 2.253044187701831],
            [32.262833285588584, 2.250161919843823],
            [32.26775940406157, 2.248753747654235],
            [32.27087617002528, 2.246733897739055],
            [32.27321096511056, 2.24573863803414],
            [32.277995561197045, 2.241003478090821],
            [32.28261779667741, 2.239143329981811],
            [32.28417929950823, 2.237714544771276],
            [32.289660457350855, 2.229091510682144],
            [32.2901379487553, 2.226752297572978],
            [32.290843121761746, 2.225338712586001],
            [32.29319710126824, 2.223207467541003],
            [32.29527963864195, 2.221973236588406],
            [32.29659441199349, 2.220269714428347],
            [32.29725486506846, 2.218595243382991],
            [32.29659041718543, 2.216292089028795],
            [32.2969809947895, 2.215372578843549],
            [32.2983501566399, 2.214131280479659],
            [32.301274984068385, 2.214160184636074],
            [32.30325539557071, 2.213564172737774],
            [32.30404840494735, 2.212814375097499],
            [32.30724306023606, 2.208832818631639],
            [32.31008220725109, 2.203652097127112],
            [32.316873229152215, 2.194828725000413],
            [32.31725695081404, 2.193447450407321],
            [32.31677023460993, 2.186848825037034],
            [32.321138782260824, 2.189685706829466],
            [32.32195344912062, 2.191303725253586],
            [32.322773778959984, 2.19457913794025],
            [32.32377379341573, 2.194470616662361],
            [32.32413617020809, 2.193953317792793],
            [32.32394518568375, 2.191844243862532],
            [32.32505813633699, 2.192281394292561],
            [32.32601240139197, 2.192006686747449],
            [32.32677667006937, 2.193884649740129],
            [32.328500491285524, 2.196091698098836],
            [32.32930536291548, 2.196431095321584],
            [32.32872066836168, 2.199882070570227],
            [32.32967181087271, 2.202069658843106],
            [32.32968239572171, 2.203277255995932],
            [32.33100765780249, 2.207137719262472],
            [32.329456039134726, 2.20984518280939],
            [32.330009400451424, 2.211436953725131],
            [32.329826907701445, 2.212903077721903],
            [32.33014842731805, 2.213948005673681],
            [32.33188340022014, 2.215137090035352],
            [32.33283483827689, 2.215122793259147],
            [32.333435783354204, 2.214536818309786],
            [32.333188960450116, 2.213184830621354],
            [32.333742091798094, 2.212622059940608],
            [32.33534511476136, 2.213916382547175],
            [32.33580182004844, 2.215649248814847],
            [32.336887136726936, 2.216441270158064],
            [32.33442593879971, 2.219684328574548],
            [32.33401055781232, 2.220698316350103],
            [32.334140042774, 2.221907077836322],
            [32.33463811547991, 2.222030373159634],
            [32.33737148587025, 2.219997487746753],
            [32.33868116577411, 2.219844660757777],
            [32.34002909594275, 2.220544560375472],
            [32.34205574912266, 2.224423776111509],
            [32.342113631169674, 2.227833733372145],
            [32.34310461037028, 2.228553786510392],
            [32.3460995504084, 2.228701681883861],
            [32.34716446365186, 2.229185706755928],
            [32.34734956241448, 2.23033005778546],
            [32.34617970258965, 2.230744709337521],
            [32.34588374543275, 2.231712518807619],
            [32.34694581011844, 2.23245694707997],
            [32.347501006693285, 2.233883000527432],
            [32.35387875774963, 2.234596935135744],
            [32.35413284173616, 2.235286048981858],
            [32.35359107497483, 2.236985413894248],
            [32.353920635411555, 2.237296451876306],
            [32.355447971718874, 2.236814291362235],
            [32.356183335305374, 2.236987265706402],
            [32.35650591223906, 2.237937501748131],
            [32.35585093080251, 2.239114869744337],
            [32.35620744429097, 2.239938494754203],
            [32.362270415790306, 2.230559864835581],
            [32.36417123206691, 2.22854240179481],
            [32.366962358740096, 2.22666391264553],
            [32.37108321391767, 2.226065192231875],
            [32.375934021230485, 2.226136569660884],
            [32.37988599223633, 2.226850210013126],
            [32.38295693783233, 2.226572592439599],
            [32.388753219286734, 2.224995874145915],
            [32.39133948785434, 2.223363919745971],
            [32.39251123773453, 2.221682556536944],
            [32.396904124339706, 2.212479993166017],
            [32.39854437977654, 2.206337313396587],
            [32.40890697029666, 2.191611600500532],
            [32.40988196128187, 2.18785281728442],
            [32.409679085758114, 2.184945215996126],
            [32.415771874138336, 2.186479970683479],
            [32.417020153294224, 2.187791356268058],
            [32.41734114829469, 2.189232441754157],
            [32.41712590925768, 2.195110567495576],
            [32.417776394626266, 2.197841856003548],
            [32.41837347604953, 2.198279055845892],
            [32.42689739843938, 2.199538651747056],
            [32.43047981062218, 2.202434934004228],
            [32.43145665662843, 2.20369158748488],
            [32.431619231931926, 2.204510962127876],
            [32.431347275962814, 2.205767136306412],
            [32.425154750331515, 2.2130292983238],
            [32.414513633564276, 2.223552673470517],
            [32.41679954233181, 2.224430803722268],
            [32.419666291880546, 2.224694121424945],
            [32.420447990569436, 2.225131395039923],
            [32.42878454774725, 2.233917687743624],
            [32.43282141673395, 2.241260294894151],
            [32.4348822157761, 2.247750048966782],
            [32.435401955846665, 2.251682948651621],
            [32.43672735806462, 2.256232530742648],
            [32.43857404186217, 2.24880020236157],
            [32.439747537168955, 2.247052789659129],
            [32.45794837500575, 2.246273162154903],
            [32.4593816882455, 2.246666966349925],
            [32.45742103069629, 2.260424906606062],
            [32.45517398035303, 2.262269024877601],
            [32.45390778789206, 2.266551030554229],
            [32.45239507256433, 2.268213026446798],
            [32.45105999189748, 2.270509147051113],
            [32.45017896648762, 2.271154645210661],
            [32.447795961515986, 2.274383275232512],
            [32.44436762387915, 2.276486785752548],
            [32.441548369157786, 2.276640692913718],
            [32.436104198548655, 2.273766471454324],
            [32.43401263220801, 2.272257947055258],
            [32.432157760266655, 2.271706585268495],
            [32.429265839923644, 2.272889233494629],
            [32.42333475278611, 2.278795416576602],
            [32.42002560182455, 2.280683595416172],
            [32.417919756762444, 2.281053200746621],
            [32.41420878218778, 2.280907455068717],
            [32.41154524413271, 2.280212025771022],
            [32.40862132310432, 2.278511567855812],
            [32.4017574451387, 2.278997937765276],
            [32.39801719896048, 2.283110877136364],
            [32.396560913103926, 2.285451179044732],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 492,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "KAMDINI",
        Population: 40796,
        Key: "OYAMKAMDINI",
        Dist2: "Oyam",
        "Sub Country": "Kamdini",
        id2_original: "Oyam Kamdini",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.6544618969785, 2.27487595312427],
            [32.654224151550345, 2.275792616355227],
            [32.654483686514034, 2.277020757289367],
            [32.654035258303985, 2.278201517982095],
            [32.65436356469256, 2.279075517741834],
            [32.655043506717625, 2.29276247643294],
            [32.65797241249751, 2.295562119150067],
            [32.65973659412106, 2.298088830752647],
            [32.66251811061737, 2.30409796671547],
            [32.65729056424743, 2.308466506005049],
            [32.6460534943409, 2.322426576662337],
            [32.626280312804475, 2.322257421904905],
            [32.623961204999006, 2.325304452865595],
            [32.620929812224944, 2.326713288599597],
            [32.61769441654147, 2.328266832458445],
            [32.614507134624596, 2.328672014223154],
            [32.61162995473709, 2.327163378254224],
            [32.605102356606515, 2.324731859662095],
            [32.59727595627184, 2.327598955786724],
            [32.595361480213036, 2.327298949680913],
            [32.59317320214725, 2.327561036869647],
            [32.59108044104727, 2.327057580257587],
            [32.58599056778283, 2.327174649095975],
            [32.583208010139124, 2.326790456683968],
            [32.58279218628232, 2.323900291200811],
            [32.578323160270294, 2.325683680295548],
            [32.5751687854389, 2.326145433369028],
            [32.57420446913424, 2.326853810193501],
            [32.56610851492551, 2.319334907360858],
            [32.56546945522904, 2.319339759674962],
            [32.56321988061981, 2.32084026207039],
            [32.56107946389402, 2.322713508796453],
            [32.55627907183157, 2.314407995811673],
            [32.54946713355736, 2.316748581175629],
            [32.53569325901777, 2.318930732693703],
            [32.53816986215378, 2.315682788583325],
            [32.53944947275013, 2.313044620291649],
            [32.53613854222598, 2.31083371904744],
            [32.51605056496285, 2.302304459762306],
            [32.510046617269246, 2.296361336968412],
            [32.50664418524858, 2.292033779872503],
            [32.492719812356164, 2.288658101779263],
            [32.48929943289443, 2.287373755924808],
            [32.48854591705094, 2.286731923654294],
            [32.48807094811585, 2.286104504762574],
            [32.4867822393823, 2.273433460639681],
            [32.484001103771696, 2.268124998585886],
            [32.48243626190295, 2.266433046568488],
            [32.47940473527992, 2.264584029930482],
            [32.459914222122364, 2.258667730110318],
            [32.4589177092996, 2.258722803423002],
            [32.45742103069629, 2.260424906606062],
            [32.4593816882455, 2.246666966349925],
            [32.46249160725011, 2.235459880744359],
            [32.46429363309995, 2.230922253355615],
            [32.462064649673685, 2.215009597651309],
            [32.46200615677225, 2.206473523597483],
            [32.46237100393166, 2.205419541177442],
            [32.46567499676686, 2.202602129699925],
            [32.46631317341941, 2.201594074709377],
            [32.46662842369367, 2.199899766905734],
            [32.465900184645655, 2.195835719941318],
            [32.46703497244517, 2.193049882518278],
            [32.46881751653142, 2.190319463168881],
            [32.46949696448309, 2.188186066505015],
            [32.46949753491328, 2.186564502544545],
            [32.46737887179043, 2.180162831432185],
            [32.466449003181964, 2.170689146482357],
            [32.46449859091854, 2.168384123921228],
            [32.46025750252839, 2.166419661637021],
            [32.4538187756272, 2.162393126958423],
            [32.44894549066931, 2.161417110006443],
            [32.44432340610593, 2.161117279852713],
            [32.44122538259232, 2.161528613052321],
            [32.437945418792644, 2.161160746238431],
            [32.434164774477786, 2.159601083998369],
            [32.433071292113375, 2.159921489209613],
            [32.422955133730206, 2.166654778389877],
            [32.4219540817203, 2.163492072689428],
            [32.42007602515976, 2.15990508775208],
            [32.42134385165622, 2.158523802702344],
            [32.42367526188949, 2.152970764393135],
            [32.426960833871476, 2.148243897562722],
            [32.43061732382756, 2.144396694067948],
            [32.434095030177474, 2.141684208949896],
            [32.43888362286865, 2.138700404062777],
            [32.43749105451521, 2.135537780441738],
            [32.43729968461361, 2.132351391064198],
            [32.439480399763035, 2.126429836888405],
            [32.440041814476245, 2.121806516963095],
            [32.43973150044451, 2.119719932748843],
            [32.43666671998632, 2.111770104873376],
            [32.43700791899584, 2.095649576588653],
            [32.440412098239754, 2.077759514662675],
            [32.45621219207297, 2.082329444654028],
            [32.46202671831081, 2.085606202243812],
            [32.46530187702201, 2.088408335535102],
            [32.46876086337971, 2.092905140765795],
            [32.474907027857505, 2.099606421357263],
            [32.47525141319136, 2.100746267661963],
            [32.47747581520969, 2.10176237176378],
            [32.477651699952425, 2.103089988751847],
            [32.47911443391608, 2.104169708415618],
            [32.47983902221076, 2.105336935997834],
            [32.48240068232948, 2.105953813602774],
            [32.48664112483095, 2.108564062391678],
            [32.492438959472466, 2.108999355985832],
            [32.49575056193644, 2.106237707620158],
            [32.497958620006514, 2.105466018452903],
            [32.50075717035722, 2.105383279321392],
            [32.50661729507887, 2.107398149676144],
            [32.5103733534027, 2.110363991794034],
            [32.514331435647435, 2.115542164134463],
            [32.517754706786064, 2.118197065542006],
            [32.52272322035057, 2.122861037777404],
            [32.53036617122949, 2.131842103571567],
            [32.53926912787201, 2.145510922412559],
            [32.54148004887286, 2.147854846682031],
            [32.54893307793444, 2.154061469046386],
            [32.552451584866226, 2.15829485891895],
            [32.553236108756685, 2.15977772622278],
            [32.55410381394747, 2.163185934982605],
            [32.554495937552154, 2.173984533227055],
            [32.55499514842355, 2.177237266423941],
            [32.55769342612728, 2.185883353471411],
            [32.55758634964035, 2.191611511632372],
            [32.56122381148208, 2.196275403285789],
            [32.56269781391266, 2.198858484329289],
            [32.56442133329487, 2.210661616960634],
            [32.56581211040763, 2.215552700050804],
            [32.56714349181213, 2.217418253045043],
            [32.569188124772445, 2.219331650671054],
            [32.5702580110893, 2.219451249722021],
            [32.57441866792217, 2.218422848550908],
            [32.57677381613685, 2.218590973300425],
            [32.57879328908266, 2.219786155199174],
            [32.58082605439972, 2.222118098599486],
            [32.58420212266344, 2.228695340984818],
            [32.587114591070296, 2.233323326494266],
            [32.600321917024836, 2.242567301840734],
            [32.60528174567716, 2.246954416290859],
            [32.605771723664056, 2.247815684137116],
            [32.606936895181406, 2.248222955863781],
            [32.60767316876133, 2.250328664006676],
            [32.608885542255294, 2.251525473486181],
            [32.609955606438575, 2.251884850681961],
            [32.61085890827085, 2.252842265186908],
            [32.612690167096666, 2.252914905161697],
            [32.61633990172178, 2.254962190336108],
            [32.61824288203989, 2.254245352896065],
            [32.62166769109429, 2.254151257173158],
            [32.622452285951645, 2.254677971610367],
            [32.623046276272, 2.255946252229383],
            [32.624662956322545, 2.257191080567404],
            [32.626839095453924, 2.257227988835461],
            [32.62779006459008, 2.257994017851357],
            [32.630906151427425, 2.256918849971691],
            [32.632237642426375, 2.257732907994813],
            [32.633759618486415, 2.258044627336498],
            [32.63416398882335, 2.257925194801196],
            [32.63509226831209, 2.256298742699736],
            [32.63678104355406, 2.255916725050431],
            [32.637446725722306, 2.256467294861611],
            [32.639694314156415, 2.256288890435407],
            [32.64047881199573, 2.257054836467661],
            [32.64178666921788, 2.257533924034571],
            [32.643236518645395, 2.25959209797905],
            [32.647705638980554, 2.264355135723628],
            [32.64988054652168, 2.267215111948258],
            [32.6544618969785, 2.27487595312427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 493,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "LORO",
        Population: 55160,
        Key: "OYAMLORO",
        Dist2: "Oyam",
        "Sub Country": "Loro",
        id2_original: "Oyam Loro",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.29706146766928, 2.504522943861697],
            [32.293246992800796, 2.507583232511089],
            [32.29091722289122, 2.510544787887106],
            [32.28336204460209, 2.511448601782151],
            [32.27670591552066, 2.510465271748642],
            [32.26465658623931, 2.510267358193122],
            [32.255435759835166, 2.51593921183126],
            [32.2534309015807, 2.516762348526947],
            [32.251479183166865, 2.516931905309795],
            [32.247999615507695, 2.517953988555995],
            [32.24596338628689, 2.517526097860554],
            [32.2383293413057, 2.512827860707558],
            [32.23443769486613, 2.51393159185543],
            [32.234220879285786, 2.513232350109238],
            [32.23252733758292, 2.511876813066407],
            [32.22857678950847, 2.506936976733898],
            [32.22749232443289, 2.504139877665527],
            [32.227971541500956, 2.501868041129198],
            [32.23012430467203, 2.497958641039317],
            [32.230299150063985, 2.496123568444242],
            [32.22891105981221, 2.492496093640356],
            [32.22852214768469, 2.486849976761514],
            [32.228336960887184, 2.478477616587244],
            [32.23007152954739, 2.469590278345544],
            [32.230094877659944, 2.462039969498932],
            [32.22973707329238, 2.459107592151246],
            [32.22888583242409, 2.457443410482132],
            [32.22857237967875, 2.453629334653958],
            [32.229709102449384, 2.44365381181081],
            [32.22859670605665, 2.438618008027755],
            [32.229416623569286, 2.435070885268208],
            [32.2314981907625, 2.431600533051875],
            [32.233228132200686, 2.424636647864128],
            [32.23374159125078, 2.420711373105475],
            [32.25212995779298, 2.421587625273564],
            [32.25415112675808, 2.41791335704712],
            [32.25495438411547, 2.417240825177843],
            [32.25804815320786, 2.412383628012638],
            [32.259958743154755, 2.410803309467808],
            [32.2667270215095, 2.408080250202771],
            [32.272884834441584, 2.407089594682839],
            [32.27670528849658, 2.405849167558451],
            [32.2797587088597, 2.405730338139199],
            [32.279071937841834, 2.408714450764587],
            [32.27893692285128, 2.416553270345823],
            [32.27794691832271, 2.421160333592831],
            [32.27174354912763, 2.429187356006391],
            [32.26780319064349, 2.437694860745586],
            [32.27322426646498, 2.438079655855073],
            [32.27592564245813, 2.438659665570858],
            [32.28238923921799, 2.43857703527721],
            [32.293125495658636, 2.441010361435997],
            [32.29426588535225, 2.440781584139846],
            [32.297322527972305, 2.43887851506563],
            [32.298295201304065, 2.436877506887527],
            [32.2989592063177, 2.436361001940608],
            [32.30017982993921, 2.435974003866288],
            [32.30298442864673, 2.436427711560948],
            [32.30492221329219, 2.436245668279839],
            [32.30808090632514, 2.435116691184923],
            [32.30989059929593, 2.434978759160132],
            [32.313975988986094, 2.436127765056932],
            [32.31692082459094, 2.437849632327227],
            [32.31967528742412, 2.440240427246116],
            [32.31844263536091, 2.434983138980521],
            [32.31858579357955, 2.433740727867939],
            [32.32021046234788, 2.431294897076747],
            [32.324816317049034, 2.429644422663228],
            [32.32564125255085, 2.428406539950126],
            [32.325727548310326, 2.427092912592409],
            [32.32852357439508, 2.417736795093119],
            [32.33035505151149, 2.413030593773263],
            [32.33846306650121, 2.397622948009844],
            [32.342630789482115, 2.396140166688227],
            [32.34386047620654, 2.392469807726775],
            [32.34621707520039, 2.389412870526109],
            [32.34670014783771, 2.386581155143322],
            [32.3478143291829, 2.384794223343123],
            [32.350054296310184, 2.38326032771948],
            [32.35202276830405, 2.382953283436252],
            [32.3535981087835, 2.381502133512056],
            [32.35622389244383, 2.378599577767426],
            [32.35699009609238, 2.37699405137129],
            [32.3596159857539, 2.373827504000288],
            [32.3615857387454, 2.370704641037581],
            [32.362308852904704, 2.367647188845385],
            [32.36456369074317, 2.362786568858649],
            [32.37106359740681, 2.352780227844885],
            [32.372880480493116, 2.349019305734936],
            [32.37712428988027, 2.346645375769474],
            [32.38066757414423, 2.345811015395419],
            [32.38294188296648, 2.346164004237302],
            [32.388452000697235, 2.348674278079562],
            [32.402984745039404, 2.34883977030182],
            [32.405954727183996, 2.347902256334488],
            [32.41206498240665, 2.344576418549604],
            [32.42355585782194, 2.339891425702613],
            [32.423160447281646, 2.34064311841119],
            [32.422978558199546, 2.343334644589828],
            [32.42380766368089, 2.346110511320768],
            [32.423305295231295, 2.348263523750157],
            [32.42366107120295, 2.34910112644335],
            [32.423564375647445, 2.350297359390571],
            [32.42639426821841, 2.351232144965667],
            [32.42753621828569, 2.351232831598292],
            [32.43106455997323, 2.354811812112023],
            [32.430657659980426, 2.35672561888645],
            [32.42987114901659, 2.357825734233791],
            [32.429449205836065, 2.362191917491696],
            [32.4298756343048, 2.363603788408822],
            [32.43118228778447, 2.365040101769447],
            [32.4308715605277, 2.366164423722887],
            [32.4288717966192, 2.367192035690561],
            [32.42801347702648, 2.368627063636144],
            [32.42658502996058, 2.369391822594598],
            [32.42577462111522, 2.370563698417659],
            [32.42567829027574, 2.37147281580568],
            [32.42620054742571, 2.372358374723648],
            [32.424079489394295, 2.37251142504625],
            [32.42280505578892, 2.376435649778496],
            [32.421756486493756, 2.377798775931747],
            [32.422206223549175, 2.379569552100897],
            [32.422062091556775, 2.380646111319507],
            [32.42272696973286, 2.38162746321653],
            [32.42261655600465, 2.384223329391864],
            [32.425300708598876, 2.387526688450353],
            [32.42646305221973, 2.390183131506185],
            [32.42736570007845, 2.391284254179118],
            [32.427293275205294, 2.392097685422242],
            [32.42633973778574, 2.393556575239838],
            [32.426482021045274, 2.393915547417394],
            [32.42775333929325, 2.395100635563796],
            [32.43003617222922, 2.395987256315742],
            [32.43132098137614, 2.395940179074442],
            [32.432033272632886, 2.397065112163436],
            [32.43317544997393, 2.396922238964763],
            [32.43481620846734, 2.39759314646096],
            [32.43457557854881, 2.399698459506402],
            [32.43281281895837, 2.401396128141438],
            [32.43264472979564, 2.402592313096989],
            [32.43434107244559, 2.406289840737809],
            [32.433600015336786, 2.409016921785148],
            [32.43400144548779, 2.411361881947212],
            [32.434765431195906, 2.412330424870978],
            [32.4385686995812, 2.411962760571615],
            [32.439562099741494, 2.413728352478396],
            [32.4365935620879, 2.421519884575243],
            [32.4366747832643, 2.423110990406682],
            [32.43750583988647, 2.424403476268048],
            [32.43736123538024, 2.425838929798331],
            [32.438286719311805, 2.427705685215529],
            [32.43719002996182, 2.429451599397102],
            [32.43535732933996, 2.430000789726317],
            [32.43471240094972, 2.431962303483262],
            [32.43491353913173, 2.432811783844338],
            [32.4337943191361, 2.433576731256668],
            [32.434125245910344, 2.435251725155223],
            [32.43288649428638, 2.436447260975739],
            [32.43186293947862, 2.436829442913286],
            [32.431789790563336, 2.438193166532084],
            [32.4306459387626, 2.439604078479558],
            [32.42979824893464, 2.441960242953021],
            [32.42582210695946, 2.444135040487474],
            [32.42508493147101, 2.445838457527975],
            [32.42403334653142, 2.447459599861538],
            [32.42320023995377, 2.44774619538296],
            [32.42212646393172, 2.450138095441353],
            [32.420209001872934, 2.451799735531446],
            [32.418710048735335, 2.451822731095168],
            [32.417709764785016, 2.452587731402166],
            [32.4154486117901, 2.453256245504954],
            [32.414637466326184, 2.454930522880304],
            [32.41487413736928, 2.455887696509678],
            [32.413586107762065, 2.458351228519432],
            [32.41384653834609, 2.459332337493414],
            [32.41345303672576, 2.460037893808308],
            [32.410642121963484, 2.462620090893412],
            [32.408166082969444, 2.463838737649089],
            [32.40799905561543, 2.464197516139818],
            [32.40864035032034, 2.465035316849751],
            [32.40733100638639, 2.465608699529553],
            [32.40578196139192, 2.467521766214677],
            [32.40537618878484, 2.468502455591345],
            [32.40545793278075, 2.469662890835359],
            [32.40362155355781, 2.472939522278229],
            [32.40331003398697, 2.474614115945192],
            [32.3995089125752, 2.479265198181249],
            [32.39546021816608, 2.482205438645018],
            [32.39362705221692, 2.483041652019196],
            [32.389486999143415, 2.483110750169711],
            [32.385313104736525, 2.481804112255176],
            [32.379321370537546, 2.478785598540106],
            [32.376396247563285, 2.47775488699844],
            [32.3701044859409, 2.476709985556757],
            [32.36348143731977, 2.476198708557855],
            [32.36171651368782, 2.482350636211422],
            [32.36069477527356, 2.4843102018368],
            [32.35725991676606, 2.486921938536954],
            [32.352155009297036, 2.488786148590318],
            [32.3483499811121, 2.489250942666551],
            [32.34380297145194, 2.488875329078894],
            [32.33897831319873, 2.487006186661184],
            [32.336751355473424, 2.486538382578599],
            [32.329512524301485, 2.487468058308861],
            [32.32542787751805, 2.490359367664616],
            [32.32366377943784, 2.492131833918733],
            [32.320786414497356, 2.493250370921451],
            [32.315727360633666, 2.496094463720898],
            [32.31173619253873, 2.497585733092846],
            [32.30718768089543, 2.500103378857101],
            [32.30061436121182, 2.502426155511306],
            [32.29706146766928, 2.504522943861697],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 494,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "MINAKULU",
        Population: 37988,
        Key: "OYAMMINAKULU",
        Dist2: "Oyam",
        "Sub Country": "Minakulu",
        id2_original: "Oyam Minakulu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.42355585782194, 2.339891425702613],
            [32.41206498240665, 2.344576418549604],
            [32.405954727183996, 2.347902256334488],
            [32.402984745039404, 2.34883977030182],
            [32.388452000697235, 2.348674278079562],
            [32.38294188296648, 2.346164004237302],
            [32.38066757414423, 2.345811015395419],
            [32.37712428988027, 2.346645375769474],
            [32.372880480493116, 2.349019305734936],
            [32.37106359740681, 2.352780227844885],
            [32.36456369074317, 2.362786568858649],
            [32.362308852904704, 2.367647188845385],
            [32.3615857387454, 2.370704641037581],
            [32.3596159857539, 2.373827504000288],
            [32.35699009609238, 2.37699405137129],
            [32.35622389244383, 2.378599577767426],
            [32.3535981087835, 2.381502133512056],
            [32.35202276830405, 2.382953283436252],
            [32.350054296310184, 2.38326032771948],
            [32.3478143291829, 2.384794223343123],
            [32.34670014783771, 2.386581155143322],
            [32.34621707520039, 2.389412870526109],
            [32.34386047620654, 2.392469807726775],
            [32.342630789482115, 2.396140166688227],
            [32.33846306650121, 2.397622948009844],
            [32.33035505151149, 2.413030593773263],
            [32.32852357439508, 2.417736795093119],
            [32.325727548310326, 2.427092912592409],
            [32.32564125255085, 2.428406539950126],
            [32.324816317049034, 2.429644422663228],
            [32.32021046234788, 2.431294897076747],
            [32.31858579357955, 2.433740727867939],
            [32.31844263536091, 2.434983138980521],
            [32.31967528742412, 2.440240427246116],
            [32.31692082459094, 2.437849632327227],
            [32.313975988986094, 2.436127765056932],
            [32.30989059929593, 2.434978759160132],
            [32.30808090632514, 2.435116691184923],
            [32.30492221329219, 2.436245668279839],
            [32.30298442864673, 2.436427711560948],
            [32.30017982993921, 2.435974003866288],
            [32.2989592063177, 2.436361001940608],
            [32.298295201304065, 2.436877506887527],
            [32.297322527972305, 2.43887851506563],
            [32.29426588535225, 2.440781584139846],
            [32.293125495658636, 2.441010361435997],
            [32.28238923921799, 2.43857703527721],
            [32.27592564245813, 2.438659665570858],
            [32.27322426646498, 2.438079655855073],
            [32.26780319064349, 2.437694860745586],
            [32.27174354912763, 2.429187356006391],
            [32.27794691832271, 2.421160333592831],
            [32.27893692285128, 2.416553270345823],
            [32.279071937841834, 2.408714450764587],
            [32.2797587088597, 2.405730338139199],
            [32.27670528849658, 2.405849167558451],
            [32.272884834441584, 2.407089594682839],
            [32.2667270215095, 2.408080250202771],
            [32.259958743154755, 2.410803309467808],
            [32.25804815320786, 2.412383628012638],
            [32.25495438411547, 2.417240825177843],
            [32.25415112675808, 2.41791335704712],
            [32.25212995779298, 2.421587625273564],
            [32.23374159125078, 2.420711373105475],
            [32.23232418807298, 2.414738529558625],
            [32.23058734667513, 2.412535026920853],
            [32.228867048651516, 2.411421060813558],
            [32.228032767077465, 2.408613941807064],
            [32.22795536014774, 2.406818753734223],
            [32.22814268313901, 2.405568201399181],
            [32.22996294209417, 2.401843538691959],
            [32.230259120236596, 2.396921059611222],
            [32.23181000947235, 2.386796757656899],
            [32.231130064752314, 2.381875981960378],
            [32.23147879703382, 2.378421023582903],
            [32.23193819996172, 2.377625196718506],
            [32.23028433864158, 2.371236639140406],
            [32.23105175681237, 2.367717228136006],
            [32.23127246389455, 2.36408751267823],
            [32.232586029910316, 2.361668353807218],
            [32.23248772008226, 2.36068979529997],
            [32.23376120776163, 2.357518756112723],
            [32.23322967909959, 2.355292687903184],
            [32.23350425725103, 2.354050304157417],
            [32.23325807933729, 2.349438854136534],
            [32.23139855681769, 2.345994593838513],
            [32.231007574073466, 2.344032011310984],
            [32.231103763877435, 2.336688082492214],
            [32.23152791691355, 2.335600771388482],
            [32.232121340397, 2.329587339577242],
            [32.23258454679177, 2.328989561310649],
            [32.23327061712371, 2.325274406522478],
            [32.234907993460084, 2.320101136562132],
            [32.241914755658165, 2.320171840644994],
            [32.248806769756804, 2.319020192658097],
            [32.2526823956416, 2.318962840912125],
            [32.25488645710692, 2.32123509958364],
            [32.25711934730639, 2.321643357571648],
            [32.258138123076826, 2.322370978023294],
            [32.25988923151806, 2.322729445280164],
            [32.26625894175431, 2.322819375334611],
            [32.277793494157045, 2.322608892575541],
            [32.279213936335424, 2.322306572351705],
            [32.281493274824946, 2.320278573537046],
            [32.28386020624122, 2.323916604653275],
            [32.286976727863156, 2.324482527401872],
            [32.29158941515037, 2.324861089948998],
            [32.295192713163516, 2.322400084664633],
            [32.29264787938836, 2.327369784449199],
            [32.29370719163602, 2.328185470990324],
            [32.295514822074914, 2.328437199117361],
            [32.30162459759718, 2.326809952005077],
            [32.30374394523629, 2.32699911853831],
            [32.30848264908989, 2.324681410507246],
            [32.30991647886095, 2.324494002014821],
            [32.31399370196686, 2.325738166708318],
            [32.334664638238685, 2.323377279571759],
            [32.33709577045165, 2.323378430265218],
            [32.348797516396765, 2.324678233985831],
            [32.35155914509096, 2.320688882768229],
            [32.3527437453713, 2.320250496374908],
            [32.357791827212104, 2.315156092034399],
            [32.361197556948184, 2.314334688451607],
            [32.362923499086726, 2.313438589323029],
            [32.36506493090878, 2.313176768791701],
            [32.36825654989183, 2.310307735175774],
            [32.369757955430146, 2.308298941899416],
            [32.370118106197225, 2.305787003844699],
            [32.37158464632272, 2.303144167662964],
            [32.37273079601396, 2.299914944435088],
            [32.372114125029285, 2.298502962058169],
            [32.37221326490069, 2.295464499474023],
            [32.37116781545448, 2.294482897927152],
            [32.37070540945862, 2.293346155260667],
            [32.37123000761822, 2.292413385093341],
            [32.37156632877578, 2.289925352628354],
            [32.371401992774324, 2.288250468035719],
            [32.37055055158175, 2.2870932470715],
            [32.37066835125819, 2.285331112376721],
            [32.37121695330054, 2.284230881368315],
            [32.3704926210257, 2.283285377273713],
            [32.37054144895296, 2.282328392218821],
            [32.371303427824735, 2.281778578162573],
            [32.371710605396935, 2.279673393260622],
            [32.37259183921591, 2.278884401531009],
            [32.372310721329235, 2.277229125732079],
            [32.37273809213068, 2.276204848478681],
            [32.37407215949788, 2.274770143169613],
            [32.37497621322006, 2.274722857211815],
            [32.37549013669915, 2.272845030760674],
            [32.37511075479847, 2.271887774873191],
            [32.37684746055074, 2.271817069298933],
            [32.37677784381114, 2.270477204700116],
            [32.37740723763521, 2.270291053827098],
            [32.37728795034861, 2.271518271315236],
            [32.37776338820432, 2.271781745682815],
            [32.37995399021176, 2.27025186685941],
            [32.38073893720872, 2.270324119990147],
            [32.380664520770566, 2.272668778123915],
            [32.38157954651559, 2.273327284355077],
            [32.38276922766718, 2.273160539245259],
            [32.383765047888886, 2.275721180320377],
            [32.38476338878324, 2.276343851813289],
            [32.38600123580373, 2.275722549170734],
            [32.386405399528144, 2.275914196286555],
            [32.388900272600424, 2.278236500351002],
            [32.38918502776571, 2.278786958445822],
            [32.38870759295516, 2.28005471258402],
            [32.38920645348355, 2.280605308214509],
            [32.39011026735554, 2.280749414001167],
            [32.39111146668913, 2.279170940299445],
            [32.39199161534328, 2.2792193202913],
            [32.3932966150245, 2.28185192399598],
            [32.394474146461874, 2.281888524654274],
            [32.39575620586568, 2.28387512325888],
            [32.39568337854729, 2.284999584381553],
            [32.396560913103926, 2.285451179044732],
            [32.396780234983936, 2.28634879923354],
            [32.39611959775432, 2.288002495527377],
            [32.39749886475333, 2.288410067407085],
            [32.39804296264284, 2.290779025444231],
            [32.399731129725325, 2.291473885931412],
            [32.40163221998808, 2.293078056840717],
            [32.40282207990439, 2.292791665361626],
            [32.403180128613705, 2.291858777247784],
            [32.40406064647543, 2.291620055997155],
            [32.404820340931416, 2.292840721681837],
            [32.405913649022686, 2.293630921980718],
            [32.40637321364732, 2.296992734885494],
            [32.40613473339728, 2.297447185498536],
            [32.405016091018354, 2.297853242244044],
            [32.404539281435206, 2.298642498197033],
            [32.40522835124189, 2.299288903742068],
            [32.405461487414335, 2.302973587926707],
            [32.40405600847361, 2.304432192922317],
            [32.40308915622491, 2.307027534478628],
            [32.404110521838305, 2.308272286276851],
            [32.40408477881722, 2.309779578054972],
            [32.40543960086075, 2.310713491153519],
            [32.40738997359827, 2.311025707927599],
            [32.40745939450513, 2.312533058716522],
            [32.406768930513124, 2.312963305519437],
            [32.40649375588034, 2.314195301953079],
            [32.406991642634985, 2.315511516521757],
            [32.41020425434791, 2.31477175633319],
            [32.41122663954918, 2.315226956133828],
            [32.41124885488617, 2.316447175232137],
            [32.4097247821583, 2.317618609781615],
            [32.409723517330356, 2.318599558081948],
            [32.41267188061933, 2.319845467474127],
            [32.41276648579515, 2.320276183284748],
            [32.41167085016899, 2.321280400353341],
            [32.41321498676873, 2.32300397732588],
            [32.41538008201202, 2.322861716741718],
            [32.4173648817845, 2.324166848053388],
            [32.41645808191253, 2.326319618568147],
            [32.41648008434878, 2.327707317214238],
            [32.41526582978262, 2.328448280560904],
            [32.415197840790334, 2.330533336175972],
            [32.41926671675061, 2.334491900715896],
            [32.42340302205277, 2.337006562138257],
            [32.42242580144902, 2.338417592375407],
            [32.42355585782194, 2.339891425702613],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 495,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "MYENE",
        Population: 27618,
        Key: "OYAMMYENE",
        Dist2: "Oyam",
        "Sub Country": "Myene",
        id2_original: "Oyam Myene",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.50302155279557, 2.423432781650786],
            [32.504215050888796, 2.423618333237749],
            [32.50545130160301, 2.424671706440333],
            [32.506735691236685, 2.424720294993956],
            [32.510776869441834, 2.42893326158674],
            [32.513487638219594, 2.430346330065339],
            [32.514390777456796, 2.43161482494411],
            [32.51455621838604, 2.433504936230972],
            [32.51876468715159, 2.436378224130483],
            [32.519988917508975, 2.437706714059293],
            [32.52272381054373, 2.438569533957335],
            [32.52507787988172, 2.439886688081372],
            [32.52569549230083, 2.44137033523695],
            [32.526967540879106, 2.442268211800255],
            [32.52687088754443, 2.444995522764772],
            [32.52786909818308, 2.446431531443363],
            [32.52827252978056, 2.448106459960745],
            [32.52881933159905, 2.44860917217454],
            [32.52977072653666, 2.448705400695181],
            [32.53171439604557, 2.450801579418772],
            [32.53141026691454, 2.45176861765611],
            [32.532670555647464, 2.452463131628363],
            [32.533264740902254, 2.453300808672275],
            [32.53339409920149, 2.455968440109596],
            [32.53408332800995, 2.456997562930912],
            [32.53398785595986, 2.457595615657283],
            [32.534986365737545, 2.458529214843477],
            [32.535104346873666, 2.46025182875978],
            [32.53603174511512, 2.460730835571174],
            [32.536435456088654, 2.461927267683398],
            [32.53744608952936, 2.462442201146398],
            [32.538063877119924, 2.463638764549763],
            [32.538895103523686, 2.466007718903381],
            [32.53856097605208, 2.468041105047372],
            [32.53932146641543, 2.469261664754836],
            [32.53962949603139, 2.471438939747025],
            [32.539295874311286, 2.472563191459185],
            [32.53855848322717, 2.472562784901227],
            [32.538344210777375, 2.472921533215179],
            [32.537831645550995, 2.475014617938283],
            [32.536165016475735, 2.477860671525998],
            [32.5257304322738, 2.485259336293793],
            [32.52415920877328, 2.48755516663121],
            [32.523968297012466, 2.488655570588606],
            [32.52519108467552, 2.49261572128691],
            [32.53066651036833, 2.496317960696731],
            [32.53144605040559, 2.497237708974446],
            [32.53164730986014, 2.499566755872953],
            [32.530519832550425, 2.510758635677181],
            [32.5309392757195, 2.514589653721497],
            [32.53557569200494, 2.520694626625448],
            [32.53542349314131, 2.526956826030833],
            [32.5344818332464, 2.531683925822637],
            [32.53392705887977, 2.533558086530132],
            [32.528968963975935, 2.542391162611291],
            [32.52809463909978, 2.546037943016296],
            [32.527942764527964, 2.550004615803992],
            [32.5293331230258, 2.554531693556283],
            [32.52591424554721, 2.559272948707399],
            [32.52219253340997, 2.56215204059253],
            [32.52045232871964, 2.56303975825298],
            [32.51666446913644, 2.563805557737481],
            [32.51443378250437, 2.565931449444609],
            [32.51341537863644, 2.566135889448976],
            [32.50282467981455, 2.566404896584235],
            [32.50112728613574, 2.566882166531903],
            [32.500458427524656, 2.568653330164862],
            [32.50159559765628, 2.569407277753888],
            [32.502689855266816, 2.570867832262261],
            [32.50271333902498, 2.571681681597093],
            [32.50147483713263, 2.573931225848995],
            [32.501250560145564, 2.575376625135215],
            [32.50619500874192, 2.572792922177122],
            [32.51063870226293, 2.572013956788639],
            [32.514716834463876, 2.582312557498829],
            [32.52131391458674, 2.585397457565189],
            [32.52162080064736, 2.590445485453726],
            [32.52128086377083, 2.591742612481364],
            [32.51968080434968, 2.594496693892606],
            [32.51694292621328, 2.595301739907727],
            [32.51371891218442, 2.598915617925971],
            [32.514174570035884, 2.60298395009108],
            [32.51352410892182, 2.604261691440698],
            [32.52095744242077, 2.619743817886446],
            [32.49565390321189, 2.615373249608522],
            [32.4908104333383, 2.615143878473337],
            [32.48024878962593, 2.613793612005377],
            [32.47373363585698, 2.597582035415971],
            [32.47018333485233, 2.589856658069167],
            [32.46290190197634, 2.580707899290447],
            [32.46160389747625, 2.578068670281096],
            [32.459132918692205, 2.578349415660473],
            [32.458279934193946, 2.577516465698507],
            [32.45868955698035, 2.57264919212117],
            [32.45829555050686, 2.570714858653661],
            [32.45656509343571, 2.56674330428162],
            [32.458336580159155, 2.564015728082471],
            [32.45861724259997, 2.562914268889579],
            [32.4583381755671, 2.560224245985777],
            [32.4540856111992, 2.557097021021345],
            [32.451895122379455, 2.556788660020304],
            [32.45128397962704, 2.556327267976542],
            [32.45036770073221, 2.554636083542186],
            [32.450031267285254, 2.552775686734333],
            [32.452013053209974, 2.548987989977243],
            [32.45056243392624, 2.545938813058995],
            [32.451174295330844, 2.544683789986686],
            [32.45089450425585, 2.543735797212482],
            [32.45176092934738, 2.54283953434256],
            [32.452003407100435, 2.541674018977526],
            [32.45215707650622, 2.539701483566442],
            [32.45182665278852, 2.538010552813271],
            [32.45056670631373, 2.53584528304252],
            [32.447995008420015, 2.533564168461889],
            [32.4459074683285, 2.530873373491688],
            [32.44452090611105, 2.526991632411266],
            [32.445426461816346, 2.523905045741239],
            [32.44763174139723, 2.519205061828313],
            [32.44778529851357, 2.517488713755353],
            [32.44745473016711, 2.516156433146596],
            [32.44636021204517, 2.514362697500386],
            [32.440237030963914, 2.508019589463867],
            [32.43841699928252, 2.505290484027392],
            [32.439563686166295, 2.501263323237465],
            [32.44105179124851, 2.500383775912367],
            [32.44149020234483, 2.498403545926057],
            [32.44136563565932, 2.496292441341677],
            [32.43979716998672, 2.494832009154355],
            [32.43972781016533, 2.493276806647178],
            [32.44018174953964, 2.491841541439456],
            [32.43969484648597, 2.491183292249409],
            [32.44017195071653, 2.490226554228633],
            [32.440388915417195, 2.488049449262296],
            [32.43984269750365, 2.487259571794454],
            [32.439702333045545, 2.485417212086484],
            [32.44013131991621, 2.484867184776256],
            [32.44006093062551, 2.484101513790027],
            [32.438757538928634, 2.480081208586117],
            [32.437723769377754, 2.479135517610212],
            [32.43734463092052, 2.477939006763073],
            [32.43653673017143, 2.477125042180004],
            [32.4376357335816, 2.473632565016406],
            [32.43671055148396, 2.471526543635904],
            [32.43535551025154, 2.470640468862715],
            [32.43461054996281, 2.467158827890958],
            [32.43442055628023, 2.466895533394756],
            [32.432944405079496, 2.467660253119622],
            [32.43120759871592, 2.467611335848091],
            [32.43106372184507, 2.468472573938059],
            [32.430587681219805, 2.468615829063787],
            [32.429232802582426, 2.467610124247013],
            [32.42894933919452, 2.466030854229664],
            [32.42752296723694, 2.465120802201028],
            [32.4296427002533, 2.463447319323868],
            [32.42983350241967, 2.463088547810927],
            [32.429359391375634, 2.46174842650848],
            [32.42999109746323, 2.460827673510108],
            [32.429497214499776, 2.458877148618779],
            [32.42811502977272, 2.458098997420778],
            [32.42764114061257, 2.456591397739224],
            [32.42709435226881, 2.456256102719104],
            [32.427095418569024, 2.455442634640797],
            [32.42635893927493, 2.454604777645684],
            [32.42650284579018, 2.453719622316471],
            [32.42567082527572, 2.453168821708144],
            [32.42566218707594, 2.450668584322682],
            [32.424996904658, 2.449974339564973],
            [32.424833186697455, 2.447797001713229],
            [32.42542934285598, 2.446768569170299],
            [32.42508493147101, 2.445838457527975],
            [32.42582210695946, 2.444135040487474],
            [32.42979824893464, 2.441960242953021],
            [32.4306459387626, 2.439604078479558],
            [32.431789790563336, 2.438193166532084],
            [32.43186293947862, 2.436829442913286],
            [32.43288649428638, 2.436447260975739],
            [32.434125245910344, 2.435251725155223],
            [32.4337943191361, 2.433576731256668],
            [32.43491353913173, 2.432811783844338],
            [32.43471240094972, 2.431962303483262],
            [32.43535732933996, 2.430000789726317],
            [32.43719002996182, 2.429451599397102],
            [32.438286719311805, 2.427705685215529],
            [32.43736123538024, 2.425838929798331],
            [32.43750583988647, 2.424403476268048],
            [32.4366747832643, 2.423110990406682],
            [32.4365935620879, 2.421519884575243],
            [32.439562099741494, 2.413728352478396],
            [32.44115984869573, 2.416165214713054],
            [32.441562156500765, 2.41784025709987],
            [32.44225126313837, 2.418510590657588],
            [32.4425355323151, 2.419467782105967],
            [32.44365330242987, 2.419827340717454],
            [32.44460377569599, 2.420761005609517],
            [32.445793411931824, 2.420737787829501],
            [32.448526207400356, 2.423299464336638],
            [32.450691098726075, 2.423444292240192],
            [32.45242630519011, 2.424713387749316],
            [32.45566288215821, 2.424045374634754],
            [32.45618685958195, 2.423615017829444],
            [32.4563318072446, 2.42189244939891],
            [32.45744996722822, 2.42194095278855],
            [32.457926940304745, 2.421055977018509],
            [32.46022194361618, 2.421787054458481],
            [32.462411881768645, 2.420950934735837],
            [32.46388640791704, 2.421406380574182],
            [32.464910623884855, 2.42049779176479],
            [32.46543589488262, 2.41903862472138],
            [32.466006605362395, 2.419278212675251],
            [32.467981890179416, 2.418848692634644],
            [32.46886116926434, 2.419662673770288],
            [32.46992737428516, 2.419197358274956],
            [32.470787748324945, 2.420118374038006],
            [32.47225109673625, 2.420011552809674],
            [32.47353493031275, 2.42075398525799],
            [32.47548624448473, 2.420467998794086],
            [32.47629385597628, 2.421521197636925],
            [32.4773647978136, 2.421282549775911],
            [32.47852998011077, 2.421785654338299],
            [32.47917300227598, 2.42128358281369],
            [32.48221788415232, 2.421692048222922],
            [32.48348168709461, 2.419443734102888],
            [32.48379101387788, 2.419419989459306],
            [32.484241660926656, 2.420544758660794],
            [32.48496691217803, 2.420868165141403],
            [32.48603842983545, 2.420174924601764],
            [32.48829835752833, 2.420439382463353],
            [32.48901124796138, 2.42113363526283],
            [32.49043934558265, 2.420679843450501],
            [32.49307699149628, 2.423313169343845],
            [32.49662054615313, 2.424511443271733],
            [32.49994074369778, 2.423568209899457],
            [32.50302155279557, 2.423432781650786],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 496,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "NGAI",
        Population: 28921,
        Key: "OYAMNGAI",
        Dist2: "Oyam",
        "Sub Country": "Ngai",
        id2_original: "Oyam Ngai",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.65850978020892, 2.603783082291302],
            [32.65687876663972, 2.602555569995801],
            [32.656393894676896, 2.60161055920205],
            [32.618729511107375, 2.607893056247124],
            [32.61553647009124, 2.605517125155662],
            [32.61539748724204, 2.604595237766018],
            [32.61470210048231, 2.604512222262638],
            [32.61397899081459, 2.603507186651815],
            [32.61281100128214, 2.600937984523505],
            [32.61249155497723, 2.596872962525288],
            [32.611587583001764, 2.596524752551348],
            [32.611226083863436, 2.595547240822212],
            [32.61130983379739, 2.592697173563904],
            [32.61089264629797, 2.592306489585603],
            [32.610892825062734, 2.590546207529468],
            [32.61122666148017, 2.590070831891014],
            [32.610879159890615, 2.588269039338951],
            [32.61199196771175, 2.586423650321189],
            [32.614078250161896, 2.585163891014637],
            [32.6156637371125, 2.58502233586206],
            [32.615177348793466, 2.581348671753489],
            [32.612603393433474, 2.575722150485995],
            [32.612879098072284, 2.574456392167621],
            [32.613684296688966, 2.573593459910094],
            [32.62002024105033, 2.569880014650057],
            [32.61799988506057, 2.563412859163217],
            [32.61390476032769, 2.559187509005449],
            [32.612090285624646, 2.557935368817021],
            [32.610175571512315, 2.556693485826519],
            [32.602461372553265, 2.553227210190595],
            [32.59817661346389, 2.549513709467576],
            [32.59593321567056, 2.546305220532696],
            [32.601371339719506, 2.542596764946002],
            [32.60334622837947, 2.541895943908826],
            [32.60505689825986, 2.541826129128982],
            [32.60982690750278, 2.54261487240931],
            [32.611996495220794, 2.541969701998177],
            [32.61355420895773, 2.540906123367142],
            [32.61458355340751, 2.538753471876495],
            [32.615278972506616, 2.538110019019876],
            [32.61882551316348, 2.535772793577538],
            [32.621606959591176, 2.535545995415699],
            [32.623053430454924, 2.534203131908888],
            [32.626071357482864, 2.533291485736143],
            [32.63049417056341, 2.529123061945028],
            [32.6347359075372, 2.528265836602905],
            [32.636655141073724, 2.527481205627957],
            [32.63748963914174, 2.526586096379839],
            [32.641870497305256, 2.524862512986808],
            [32.64456857109144, 2.523350479163789],
            [32.65711754872369, 2.514136158554332],
            [32.66636184810619, 2.506741212948203],
            [32.6666957051849, 2.505064345569756],
            [32.66529124942531, 2.502481495501476],
            [32.66481857838069, 2.499604135105707],
            [32.66369221049033, 2.497998893092633],
            [32.663810102693276, 2.491549977186744],
            [32.66452460021237, 2.489612419241134],
            [32.66528620897823, 2.488703631795553],
            [32.667023473482615, 2.486957935128894],
            [32.67059254478512, 2.484758510953714],
            [32.67190190219379, 2.482390571933873],
            [32.671534164255824, 2.480273069635431],
            [32.668966768394036, 2.476731054706485],
            [32.66792117881068, 2.474433803716322],
            [32.667766266136546, 2.470637972072659],
            [32.669658730775936, 2.47199428840699],
            [32.67258433075556, 2.472426273858782],
            [32.67634347119917, 2.470609696957101],
            [32.68061352217237, 2.469929773808826],
            [32.68420451326615, 2.471821431183841],
            [32.68831948447859, 2.472206060305841],
            [32.690044291146606, 2.471620661425883],
            [32.69113893143945, 2.470616309591704],
            [32.69336205425681, 2.46993490021872],
            [32.695348286842155, 2.470078612004429],
            [32.6972984242211, 2.470988610380001],
            [32.70088988782869, 2.471851464435767],
            [32.703601492937985, 2.47211580889801],
            [32.70638405597161, 2.473313238635838],
            [32.71333147366537, 2.469488248218958],
            [32.71307899317163, 2.475959784140907],
            [32.714086678341594, 2.483747717162982],
            [32.71332390895238, 2.487503569355277],
            [32.71326202401244, 2.49323351742804],
            [32.7136894945269, 2.494908432683511],
            [32.71365701773444, 2.497618438400333],
            [32.71269320358802, 2.50068404984794],
            [32.71295947052646, 2.501564659563416],
            [32.716079915091214, 2.504306954616621],
            [32.71988639405533, 2.506083778939248],
            [32.720837698263104, 2.507653662990001],
            [32.71954305346217, 2.516952149059244],
            [32.71964612346294, 2.522580484339229],
            [32.71792030349526, 2.532491499947572],
            [32.717922985864696, 2.534553379881083],
            [32.71986772077553, 2.542734084431598],
            [32.72167451128961, 2.545915697093372],
            [32.722551644299344, 2.552944090994206],
            [32.723434499577415, 2.555178725206803],
            [32.72438375742299, 2.559849728019656],
            [32.72537389310557, 2.561142150533423],
            [32.72518612185498, 2.562999658985003],
            [32.72736739755315, 2.564467323860899],
            [32.72851774147845, 2.567671172620486],
            [32.72851746300071, 2.568990302304177],
            [32.72804854601566, 2.571238105837587],
            [32.72606706192487, 2.574252832956489],
            [32.724701619099754, 2.575490903752074],
            [32.72528534886296, 2.58052248031305],
            [32.72503843612733, 2.582028515037533],
            [32.72427350089995, 2.583007184974681],
            [32.71996291434785, 2.584474491185269],
            [32.71381031523769, 2.584647902354888],
            [32.709882234926845, 2.585416090299709],
            [32.70218297135767, 2.594206153434932],
            [32.69927729690933, 2.598418120243009],
            [32.69719055362348, 2.603067078766097],
            [32.697068654036045, 2.60406336340376],
            [32.69766686823489, 2.605314724975368],
            [32.69393890561988, 2.605699043354708],
            [32.68915497159175, 2.604747850126372],
            [32.683456491518946, 2.60534401119154],
            [32.66627007711509, 2.605400839999481],
            [32.65850978020892, 2.603783082291302],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 497,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "OTWAL",
        Population: 26120,
        Key: "OYAMOTWAL",
        Dist2: "Oyam",
        "Sub Country": "Otwal",
        id2_original: "Oyam Otwal",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.50302155279557, 2.423432781650786],
            [32.49994074369778, 2.423568209899457],
            [32.49662054615313, 2.424511443271733],
            [32.49307699149628, 2.423313169343845],
            [32.49043934558265, 2.420679843450501],
            [32.48901124796138, 2.42113363526283],
            [32.48829835752833, 2.420439382463353],
            [32.48603842983545, 2.420174924601764],
            [32.48496691217803, 2.420868165141403],
            [32.484241660926656, 2.420544758660794],
            [32.48379101387788, 2.419419989459306],
            [32.48348168709461, 2.419443734102888],
            [32.48221788415232, 2.421692048222922],
            [32.47917300227598, 2.42128358281369],
            [32.47852998011077, 2.421785654338299],
            [32.4773647978136, 2.421282549775911],
            [32.47629385597628, 2.421521197636925],
            [32.47548624448473, 2.420467998794086],
            [32.47353493031275, 2.42075398525799],
            [32.47225109673625, 2.420011552809674],
            [32.470787748324945, 2.420118374038006],
            [32.46992737428516, 2.419197358274956],
            [32.47458872061638, 2.404377147506008],
            [32.48036522206656, 2.396032427201887],
            [32.48379584591577, 2.38979117667045],
            [32.48186978069151, 2.383660798462873],
            [32.484347235430434, 2.381113035763563],
            [32.48707730990196, 2.37634134586087],
            [32.48974068805695, 2.377347711729769],
            [32.49357028067332, 2.378019760582568],
            [32.50115240392942, 2.375544937984455],
            [32.503003501149934, 2.371431584340252],
            [32.50879046976982, 2.362699001033818],
            [32.508841733928115, 2.360364963684598],
            [32.50753133537204, 2.357117119959358],
            [32.50803730696423, 2.352753635893562],
            [32.50925086713269, 2.351972837384602],
            [32.512504697144145, 2.352405757618784],
            [32.51504352927483, 2.353504296676167],
            [32.51948749498539, 2.354330605853908],
            [32.52170639931418, 2.356158027133705],
            [32.52733629660829, 2.359516299129636],
            [32.52858836934961, 2.356084233681576],
            [32.529254968697764, 2.355222740434534],
            [32.53167985761954, 2.352917467149977],
            [32.534621161048655, 2.351801551792815],
            [32.53513059834124, 2.352017737749149],
            [32.53552437664264, 2.352969254445766],
            [32.53512925715651, 2.356061119822418],
            [32.53426148549037, 2.358360008087109],
            [32.534497756783125, 2.358915059214194],
            [32.538753588323736, 2.360105718905964],
            [32.55107884682268, 2.361160191030661],
            [32.55085724232357, 2.374180704729468],
            [32.55257190970694, 2.375602001990164],
            [32.55297517331946, 2.376515462863624],
            [32.55236737679148, 2.384126353139814],
            [32.55095323090492, 2.389301428182113],
            [32.54696571715655, 2.396403786435195],
            [32.54638425474115, 2.400462835901435],
            [32.54673426891855, 2.404441615786954],
            [32.547756966733544, 2.404341497835089],
            [32.55089050604023, 2.406023795995107],
            [32.55108565156097, 2.408468938202649],
            [32.55172699297829, 2.410096131577903],
            [32.55067934535458, 2.412129133739162],
            [32.54910934446118, 2.412415380445049],
            [32.53934284452256, 2.417135107667611],
            [32.537844504934306, 2.416847197960997],
            [32.53744056848363, 2.416081394732078],
            [32.53658417667552, 2.416296249446543],
            [32.535324180793395, 2.415123266579895],
            [32.534586736708654, 2.415290322371223],
            [32.53377829068219, 2.414811398113328],
            [32.5314712724038, 2.414499104151774],
            [32.529568194169336, 2.414928684804797],
            [32.529080991078374, 2.414198721976848],
            [32.52820067893088, 2.414652796879501],
            [32.526892821708735, 2.414030037953519],
            [32.52560774666048, 2.415225535087845],
            [32.52484654842471, 2.415344726275039],
            [32.523728940905016, 2.414769918441407],
            [32.52275338218454, 2.415415331258961],
            [32.521897249091225, 2.415151680183798],
            [32.52044582222207, 2.416083911368951],
            [32.518757406306214, 2.415437006298088],
            [32.51661670750942, 2.415459716174112],
            [32.515153644762364, 2.415925413498114],
            [32.51353556064505, 2.417120712408106],
            [32.5127745456656, 2.416904957615406],
            [32.51165610181434, 2.417837363509727],
            [32.50965812285835, 2.417836230845114],
            [32.50789728386596, 2.419103200009272],
            [32.50629898334616, 2.421268417531825],
            [32.504681481337144, 2.4214110359751],
            [32.50456187425031, 2.422607177301777],
            [32.50302155279557, 2.423432781650786],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 498,
        District: "OYAM",
        County: "OYAM",
        Subcounty: "OYAM TOWN COUNCIL",
        Population: 11727,
        Key: "OYAMOYAM TOWN COUNCIL",
        Dist2: "Oyam",
        "Sub Country": "Oyam T/C",
        id2_original: "Oyam Oyam T/C",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.47029713163591, 3.126306792832965],
            [32.4669833938765, 3.126944193529893],
            [32.466082543546634, 3.128300872484099],
            [32.464281716049385, 3.129295186771946],
            [32.46175904371233, 3.133636736171853],
            [32.4549686632083, 3.140732851056576],
            [32.45232188861476, 3.141098367324251],
            [32.44972108261089, 3.140821813933571],
            [32.44748558729714, 3.140040950996266],
            [32.44488563469281, 3.138159172608303],
            [32.443428705642525, 3.132012717630809],
            [32.44365792246537, 3.129994856363057],
            [32.44571294713688, 3.126831383315845],
            [32.444346024786476, 3.123069869233251],
            [32.44492282674221, 3.121642706719725],
            [32.444103230826435, 3.120733461342411],
            [32.44435616137613, 3.119592295483002],
            [32.44378877196795, 3.118915668772962],
            [32.444356717433294, 3.11853553916076],
            [32.44494647129881, 3.116654822772157],
            [32.445956487596916, 3.115323843622458],
            [32.44524210955374, 3.11426670627793],
            [32.44444531737145, 3.10997584838525],
            [32.44474001778525, 3.109363084973458],
            [32.44545143498125, 3.109219779599698],
            [32.44451506436676, 3.108968458298345],
            [32.4437555378957, 3.107870640384009],
            [32.44415236238426, 3.107249258322378],
            [32.443564472522986, 3.105579270130742],
            [32.44379624774776, 3.104670581378817],
            [32.443333715089416, 3.104543525363912],
            [32.44398626748149, 3.103191221842744],
            [32.444197390437864, 3.101563925306817],
            [32.44235142169928, 3.100646724158606],
            [32.442406100354, 3.100318038116678],
            [32.44067625862883, 3.098947476104882],
            [32.4402547394531, 3.097235195455887],
            [32.4406776689838, 3.096262972822113],
            [32.44061049296686, 3.094441308786427],
            [32.441142555228176, 3.093236301462573],
            [32.44260132941807, 3.09179894716997],
            [32.442383671217975, 3.091100312495087],
            [32.44290199464535, 3.090100744293979],
            [32.443406248658725, 3.089950348144117],
            [32.44637870476362, 3.086253863427223],
            [32.44734714343713, 3.084377955026655],
            [32.446966081686845, 3.083460092267006],
            [32.447402794068985, 3.082159155480394],
            [32.4469948484372, 3.080529062968092],
            [32.44771802008869, 3.078625629319276],
            [32.44759618877324, 3.077064169586688],
            [32.4458799852707, 3.07572101924049],
            [32.445594189856294, 3.075036047308907],
            [32.445130908003044, 3.075022107589504],
            [32.44476341440682, 3.074227519960506],
            [32.444041107832966, 3.074459983319675],
            [32.44292441210325, 3.07321302020484],
            [32.44158910955255, 3.073102748219649],
            [32.43886467560267, 3.07159470091607],
            [32.43866085684786, 3.070498877007181],
            [32.43374470248802, 3.06507247970491],
            [32.43351368813629, 3.063880765449957],
            [32.43207008738987, 3.062455566714279],
            [32.43207058505653, 3.061510513966044],
            [32.43035414260213, 3.060701507239338],
            [32.42956438422852, 3.059673853989892],
            [32.42790234913762, 3.059056624851658],
            [32.427330673867225, 3.057905816829381],
            [32.42392486058782, 3.056671306825363],
            [32.422902985629634, 3.056547486974791],
            [32.42130831160862, 3.057382106335339],
            [32.42024548784651, 3.057395226393147],
            [32.419555549368965, 3.056950332911737],
            [32.418485719645965, 3.055873797370515],
            [32.417015721006614, 3.052510644518276],
            [32.41701684569734, 3.050425988061962],
            [32.41367529879169, 3.044035699712779],
            [32.406785987723744, 3.041543773462967],
            [32.405783011522495, 3.040601763960537],
            [32.40203679154764, 3.040330694960269],
            [32.39267235327568, 3.037702816255203],
            [32.392806639732555, 3.03682868435784],
            [32.394412854410014, 3.03568639521949],
            [32.395617261644055, 3.035283592458622],
            [32.39755714565232, 3.035620914708391],
            [32.4015726473117, 3.032798789269635],
            [32.40409605626731, 3.030391629810618],
            [32.405299610101814, 3.028227584676836],
            [32.40713120579584, 3.026172120167561],
            [32.41079329225614, 3.024063532095858],
            [32.41511916813436, 3.022316075349938],
            [32.41599896375059, 3.021468705772413],
            [32.41644837920914, 3.020025804753556],
            [32.41811858178262, 3.017681595708719],
            [32.41822684314738, 3.016581258523083],
            [32.41950249127504, 3.013749773708127],
            [32.42296723763033, 3.011406514593748],
            [32.42392296334595, 3.01026284858516],
            [32.42266763241508, 3.008734870070239],
            [32.42282900038282, 3.007697828833497],
            [32.42198545897485, 3.006208968342939],
            [32.42211061405686, 3.003684311298754],
            [32.42189963572922, 3.003318130785976],
            [32.42139015082596, 3.003527332851346],
            [32.42096193830305, 3.00318175107295],
            [32.42113449568597, 3.002942808887323],
            [32.420494135228964, 3.002303573357584],
            [32.41859648820869, 3.003408654374268],
            [32.41704174520039, 3.002681773314857],
            [32.41668893905908, 3.002143997658125],
            [32.41317990396362, 3.001554082382756],
            [32.41034325785838, 3.001857797829656],
            [32.40912426827232, 3.001233175149883],
            [32.40639609643255, 3.003025699238667],
            [32.40586565113875, 3.003041111101983],
            [32.405754952644585, 3.002434803031514],
            [32.40398651839651, 3.001510933591586],
            [32.40358812095787, 3.00230226541163],
            [32.40200785142245, 3.002409116877284],
            [32.40120181467756, 3.003072809482608],
            [32.40026022215635, 3.003178137628401],
            [32.398766674181815, 3.001945983741773],
            [32.39666786203009, 2.999843962047101],
            [32.396225739095, 2.998869497509941],
            [32.39385090879249, 2.99967647370379],
            [32.39026274739186, 2.998021291555286],
            [32.388563678355055, 2.995814164023791],
            [32.38916345741911, 2.99503258513852],
            [32.38923292054677, 2.994145862387336],
            [32.388632027571745, 2.99411179722723],
            [32.38746378381612, 2.99273143833498],
            [32.386544394953766, 2.992414417401839],
            [32.386437629283904, 2.991882711798252],
            [32.3865466137925, 2.986714716366465],
            [32.386201624790786, 2.984996564490557],
            [32.386972044232955, 2.984622344229215],
            [32.38725560823217, 2.983189228529316],
            [32.38619707572219, 2.981673283592644],
            [32.386224715086854, 2.981014287804142],
            [32.38506842970429, 2.981088600849764],
            [32.3842109886639, 2.9804602980962],
            [32.3835228638849, 2.978370513859744],
            [32.38137578794792, 2.977665021069967],
            [32.37967198658621, 2.973549921095426],
            [32.38028398633138, 2.971959251817836],
            [32.380024320213685, 2.971181453429379],
            [32.38049074796707, 2.969510022086209],
            [32.37871218790908, 2.968995197986632],
            [32.37875371522804, 2.968572659338868],
            [32.37581986691743, 2.969089629521098],
            [32.37499876901851, 2.968546544471507],
            [32.371619327580895, 2.968473840892775],
            [32.36985959800792, 2.96774148049171],
            [32.36901452676901, 2.968094876483888],
            [32.368029087478725, 2.967669653337059],
            [32.36500153320592, 2.967856647046407],
            [32.36223344831975, 2.965755353207848],
            [32.36059077371983, 2.965542071062059],
            [32.35939443695031, 2.964574102629379],
            [32.358080216062696, 2.964549745112091],
            [32.352352838983826, 2.966386566493444],
            [32.35087363800271, 2.967565294254875],
            [32.34742102519194, 2.972234460012479],
            [32.34580156665224, 2.972445825543396],
            [32.339982653042576, 2.970271883623623],
            [32.33808160500065, 2.97043588400663],
            [32.335055944376435, 2.969497723617977],
            [32.33478492984174, 2.96867020029184],
            [32.33188220007092, 2.965138681757506],
            [32.33093638456952, 2.962419175723837],
            [32.330876760689165, 2.960528507321639],
            [32.3294762862629, 2.959443024714388],
            [32.32820305729833, 2.957426179547569],
            [32.32643139989497, 2.956341542578134],
            [32.32032082846538, 2.955982982600482],
            [32.31357129615397, 2.958247164112207],
            [32.31214452893766, 2.958880654974447],
            [32.31071858637478, 2.960144432009172],
            [32.3079342491685, 2.959735292012199],
            [32.306019262866606, 2.958192590616735],
            [32.305904306358045, 2.957619864801331],
            [32.3051621479147, 2.957764779067455],
            [32.30296613265935, 2.959660528073769],
            [32.30099750795187, 2.960782258446348],
            [32.30031341660851, 2.961671894976085],
            [32.29944245771973, 2.9615735836809],
            [32.29872743648281, 2.960629791752892],
            [32.297442128770925, 2.960260237204383],
            [32.296898203357976, 2.959144158143457],
            [32.29578398428349, 2.958602334943517],
            [32.29450993425874, 2.95589790511652],
            [32.29236855903058, 2.955902713680213],
            [32.29165337070702, 2.954815659274688],
            [32.289539625860314, 2.954104165861081],
            [32.289872607979945, 2.951236635144876],
            [32.29094052968128, 2.94909992178931],
            [32.29216639137923, 2.947664743309458],
            [32.29336544016262, 2.947576116154901],
            [32.29542206922521, 2.948287711534479],
            [32.2974494392607, 2.948455049788337],
            [32.29873238979326, 2.947019741290276],
            [32.29910416026857, 2.947477282380656],
            [32.29910620573246, 2.949052952778237],
            [32.29984880614691, 2.949251821288982],
            [32.30152852816746, 2.945552371159514],
            [32.30061317543566, 2.9442365888723],
            [32.30131034714786, 2.94244448063247],
            [32.30036625551351, 2.940985520472143],
            [32.30104988063125, 2.939752090513994],
            [32.30239167530651, 2.939663123613716],
            [32.302189578622105, 2.937944658289281],
            [32.301104067907495, 2.937517379029825],
            [32.30107481157533, 2.936973116752075],
            [32.30221546986521, 2.935910550037215],
            [32.30358558931972, 2.935649619736755],
            [32.30601277792859, 2.93590198776928],
            [32.30745564025983, 2.936686568096509],
            [32.3082546647556, 2.93636962081731],
            [32.3091693176998, 2.937141079316501],
            [32.31011128302188, 2.936967054808531],
            [32.31088117964457, 2.936220442369615],
            [32.312993442271036, 2.935814586962157],
            [32.31484565789411, 2.933060114125003],
            [32.31470158339389, 2.932057731869889],
            [32.31644247978698, 2.931509459410447],
            [32.31691181987853, 2.930176233612698],
            [32.31839522677179, 2.929227456572509],
            [32.31865124213621, 2.928510656383237],
            [32.319449870474934, 2.927907219579571],
            [32.31844729492229, 2.925417050339487],
            [32.31921730203775, 2.924756385674393],
            [32.320512785865176, 2.922046130252209],
            [32.320426078677336, 2.921244165500374],
            [32.319454090760125, 2.920300963858463],
            [32.319052337215595, 2.918754835558872],
            [32.32010753877254, 2.917864325074516],
            [32.31993509457732, 2.917005253656507],
            [32.31894598656743, 2.913899108691175],
            [32.31757293860512, 2.911925466365585],
            [32.31779940658318, 2.910463861134811],
            [32.31896982965172, 2.910346609047993],
            [32.31848359674126, 2.909688792972046],
            [32.31902495566744, 2.90885674847567],
            [32.32139359118778, 2.908049192203154],
            [32.32297649278699, 2.906799365429969],
            [32.326715768784716, 2.906160561693623],
            [32.32851269220371, 2.904838614542341],
            [32.329340619095426, 2.904808076077929],
            [32.33334895758871, 2.902549975988838],
            [32.33585748684997, 2.899622045383706],
            [32.33800485653604, 2.893529235024685],
            [32.34000217882359, 2.892636537075472],
            [32.34119943546796, 2.89125863815617],
            [32.3447969267711, 2.891364957493773],
            [32.345365994232225, 2.889931207125161],
            [32.3466631138918, 2.888510096126554],
            [32.34745941289898, 2.886216342979626],
            [32.34748540475343, 2.884325458238484],
            [32.34853973494452, 2.882833280110505],
            [32.34875097019033, 2.880698439318906],
            [32.3494057513026, 2.879321779288385],
            [32.34906116923771, 2.877861478669195],
            [32.349801408879586, 2.876341371719297],
            [32.35015381886385, 2.873060249215588],
            [32.351631977799265, 2.868329751963937],
            [32.35331458251353, 2.866979361119743],
            [32.357354143751174, 2.866812437842163],
            [32.3594945928163, 2.866234497734161],
            [32.363634222783304, 2.866167590573946],
            [32.36332387102232, 2.868861330544781],
            [32.362215925781804, 2.872874763144952],
            [32.36264526928365, 2.873675944827833],
            [32.362317991466085, 2.874435902987471],
            [32.3632050742159, 2.875923596326841],
            [32.36334935353198, 2.877040573563474],
            [32.362999325879855, 2.882040645112246],
            [32.36231604571517, 2.883446035773537],
            [32.36249063508728, 2.885852148771964],
            [32.36170747753438, 2.887300734592471],
            [32.361765722500756, 2.88813142405612],
            [32.36305345656222, 2.890305766853508],
            [32.363455281073655, 2.891851882975996],
            [32.3658697252836, 2.893264419122123],
            [32.36815925516004, 2.897269979123773],
            [32.37136906412928, 2.90611509183105],
            [32.372202221910904, 2.909894838553482],
            [32.37357533904349, 2.911839782640214],
            [32.373890899236486, 2.912927722159811],
            [32.37367851594375, 2.914203096659034],
            [32.374188735668945, 2.915688077724432],
            [32.37294325296856, 2.919361638007319],
            [32.37321717804478, 2.921323466199152],
            [32.37224915079964, 2.923302503612227],
            [32.37268243790558, 2.926968572954504],
            [32.37318940752607, 2.927189696345174],
            [32.37670639630503, 2.925263452891124],
            [32.38215035491175, 2.923028105998477],
            [32.38654306634546, 2.920419087833456],
            [32.38877077416401, 2.918306285620423],
            [32.39316845058628, 2.906370655007506],
            [32.395953907093414, 2.902081926935701],
            [32.39818110107563, 2.900839574113473],
            [32.40739718796833, 2.899476565557389],
            [32.4170455073448, 2.899481604037577],
            [32.42539458613932, 2.900356382905655],
            [32.42625986857384, 2.901538198349342],
            [32.42663017299854, 2.903092828457885],
            [32.426586187889, 2.908174477684997],
            [32.42866776316702, 2.909871227175288],
            [32.431078437147725, 2.9127326233181],
            [32.43435563054308, 2.91351534839139],
            [32.44032657503143, 2.913447962246477],
            [32.443494227861024, 2.913033374667481],
            [32.4467980428298, 2.914002277786171],
            [32.44788521812262, 2.915546763654758],
            [32.45344349363747, 2.919014382800327],
            [32.45427284705385, 2.919957838518597],
            [32.45553292108943, 2.922590572936209],
            [32.45518241104196, 2.927017761530197],
            [32.4560970909356, 2.927731812035084],
            [32.456269319535146, 2.928361689510093],
            [32.45578661880037, 2.930225061396936],
            [32.45674556856954, 2.931927408922819],
            [32.4562895639684, 2.932501490967841],
            [32.4567474244889, 2.933216633380646],
            [32.45637732218511, 2.933962406311224],
            [32.456807217252546, 2.935078715172792],
            [32.45584086985701, 2.938146520725869],
            [32.45688501405111, 2.939533524643212],
            [32.45717276958944, 2.941079912224444],
            [32.45928934053599, 2.943653305617089],
            [32.46063489106748, 2.946142592705044],
            [32.46112056792077, 2.946341973995908],
            [32.46230476665417, 2.945837771904175],
            [32.46410342831325, 2.94574751452206],
            [32.466500328425724, 2.944710378114963],
            [32.46884173241655, 2.944790708848136],
            [32.47095556170485, 2.945444563228894],
            [32.47227116779466, 2.946959832924244],
            [32.473044957715764, 2.948934786973236],
            [32.476716503436, 2.950687902022075],
            [32.477462880367916, 2.95343646769838],
            [32.48051060181886, 2.958141983278506],
            [32.48373901759258, 2.959480731448012],
            [32.484711527430974, 2.960653022578392],
            [32.48783911899215, 2.961376035240986],
            [32.48841139254054, 2.962205492821756],
            [32.48852160235117, 2.964435244768096],
            [32.489865447880234, 2.965205743614713],
            [32.49444126740984, 2.966657349728942],
            [32.4994562571122, 2.967415901997549],
            [32.50052156202113, 2.968424730404054],
            [32.50183716541598, 2.97048613104217],
            [32.503088450334786, 2.976183848336838],
            [32.50243518288376, 2.979006919528401],
            [32.50253344959268, 2.983544516033104],
            [32.504573149005445, 2.990229470839738],
            [32.50632421432754, 2.987752854005294],
            [32.50853896843971, 2.986568997619218],
            [32.51161024012416, 2.986749900433836],
            [32.51428889502882, 2.986392051862287],
            [32.51575302227951, 2.986679939579176],
            [32.5209656143949, 2.990272696328405],
            [32.524018610753195, 2.991440926772763],
            [32.52591149939738, 2.991298132273705],
            [32.52551840381558, 2.991872436519894],
            [32.526482871037224, 2.991406092721391],
            [32.52758986945343, 2.991693809572588],
            [32.528411527901106, 2.99111969003369],
            [32.53019679298437, 2.992089885934013],
            [32.530589871498194, 2.991551486976384],
            [32.53183980085924, 2.991659743439187],
            [32.53285786875723, 2.991103658112246],
            [32.535000434253185, 2.991714947727158],
            [32.53725067361574, 2.991033716374099],
            [32.539749834346864, 2.992937719705798],
            [32.54042768868721, 2.994625528579564],
            [32.54198113003669, 2.99489546698557],
            [32.54383844898887, 2.994393584508381],
            [32.54523113861489, 2.994753209395577],
            [32.54901620264093, 2.996226882555717],
            [32.55115886784989, 2.996622718652957],
            [32.55129296296558, 2.997019058769697],
            [32.553427060941665, 2.998219440745355],
            [32.55378328247772, 3.000481585161949],
            [32.5545328969379, 3.001415415784894],
            [32.5549247043356, 3.004000718950872],
            [32.55595142750135, 3.004700923552383],
            [32.55249056366472, 3.011717463997877],
            [32.551228154907754, 3.012937700884431],
            [32.54778523851216, 3.018812680604239],
            [32.546689425917876, 3.020176598233033],
            [32.54309315183193, 3.022592662228785],
            [32.53841201202177, 3.028538878221396],
            [32.53593546727623, 3.029279846472692],
            [32.533016764561324, 3.033910279242131],
            [32.5335394313431, 3.036591388492366],
            [32.530978681217775, 3.039307054490067],
            [32.52816874202587, 3.040095731300333],
            [32.527835198459215, 3.040550369237391],
            [32.52804803719778, 3.043901562356422],
            [32.523723833982615, 3.049919646052726],
            [32.52180513045211, 3.054382926521149],
            [32.5174571928488, 3.060065858988811],
            [32.5175149446401, 3.064003429077244],
            [32.516800134507285, 3.065128097369968],
            [32.514989641137575, 3.067090055703147],
            [32.5132749872289, 3.067711622722431],
            [32.51203712583538, 3.067064768469213],
            [32.51146562483816, 3.067160258048928],
            [32.51001254686547, 3.068547897367725],
            [32.50648535771647, 3.075535665927823],
            [32.502840022141285, 3.0804409103922],
            [32.50054038981116, 3.084473085147411],
            [32.499797737294415, 3.086739580271816],
            [32.49759720351319, 3.088686074733201],
            [32.495132211102195, 3.089842385001123],
            [32.49143934746198, 3.095403310827102],
            [32.48650396196851, 3.100290906542712],
            [32.485434881440476, 3.103066014363125],
            [32.48524308663572, 3.107487683047863],
            [32.484159630368175, 3.109658072676054],
            [32.475164813801335, 3.119653094856728],
            [32.47093788375837, 3.122448664775144],
            [32.47043605609459, 3.123673534662246],
            [32.47029713163591, 3.126306792832965],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 499,
        District: "GULU",
        County: "ASWA",
        Subcounty: "AWACH",
        Population: 18907,
        Key: "GULUAWACH",
        Dist2: "Gulu",
        "Sub Country": "Awach",
        id2_original: "Gulu Awach",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.289539625860314, 2.954104165861081],
            [32.288085239042275, 2.955453910423564],
            [32.28768772913917, 2.957173709637728],
            [32.28694692984687, 2.958378621525078],
            [32.284464010656066, 2.959214965828906],
            [32.281634868178344, 2.957244524625955],
            [32.28086423044559, 2.957446791750329],
            [32.27986430312642, 2.956961989518201],
            [32.279236611609825, 2.957307163267537],
            [32.278322338653, 2.956822186933253],
            [32.277180242160355, 2.956796086142591],
            [32.27665159798869, 2.956133424236227],
            [32.27857464667023, 2.9531832594464],
            [32.278486539008846, 2.951264001907939],
            [32.27937104808538, 2.950803652582413],
            [32.27988394119683, 2.950000358301739],
            [32.27961133035586, 2.948926638380318],
            [32.28072388036054, 2.948179303691292],
            [32.28146392776294, 2.946401434728449],
            [32.28206288217359, 2.945913081329771],
            [32.2819762729021, 2.945168411780958],
            [32.28243220743467, 2.944479825774478],
            [32.284758043621615, 2.943629499375798],
            [32.285782683594235, 2.941134781716235],
            [32.28765028556149, 2.939196817908599],
            [32.288133730999625, 2.937706011497414],
            [32.28790436505647, 2.936961658539361],
            [32.28824393542038, 2.934611723934766],
            [32.28748424455765, 2.932221269585528],
            [32.2874536209896, 2.930617015847691],
            [32.28619623830663, 2.929731727171218],
            [32.28445460080347, 2.929706978634946],
            [32.282968443268764, 2.928535712665691],
            [32.27825651999046, 2.927744084050828],
            [32.276999521786415, 2.927145281476162],
            [32.27581280507528, 2.925701179591138],
            [32.273784272619814, 2.924588414074029],
            [32.27124374446984, 2.924966506018413],
            [32.26007087985166, 2.928701306248214],
            [32.25605189632227, 2.933981511756916],
            [32.252958887204564, 2.936110566535509],
            [32.24903377582572, 2.93269208453036],
            [32.2455818115986, 2.936383652021644],
            [32.24266390568935, 2.937894208822868],
            [32.23848075414347, 2.938246608624188],
            [32.236940258415565, 2.93925039382647],
            [32.23405900826147, 2.939967317213179],
            [32.23345991820523, 2.940569591999793],
            [32.23266105540623, 2.943408966858613],
            [32.23160562208394, 2.94168807338757],
            [32.22872445726985, 2.940225231241369],
            [32.22948054229502, 2.937256791810347],
            [32.22879593352203, 2.936367648015603],
            [32.22882448557504, 2.935794029981271],
            [32.230108195184044, 2.935564638486962],
            [32.23056469026533, 2.93395852977895],
            [32.2292953078868, 2.932481412998218],
            [32.229067182517035, 2.930186926633867],
            [32.2300941985336, 2.928838964602902],
            [32.23043656804794, 2.927462295065978],
            [32.23030829581187, 2.92475193942306],
            [32.230679187734815, 2.923518676376432],
            [32.230137213462655, 2.922772948526528],
            [32.22962373375129, 2.922686888826187],
            [32.22876797615377, 2.921654343262491],
            [32.22463170588593, 2.920076734974872],
            [32.223989894649726, 2.919230622779191],
            [32.221622214038504, 2.919029758152296],
            [32.22059529414169, 2.918456091766908],
            [32.22093764299479, 2.917595684943503],
            [32.219910798556434, 2.915215125802086],
            [32.2193688359624, 2.914440715831158],
            [32.2181422259678, 2.914125172588774],
            [32.217200906534394, 2.912949211703404],
            [32.215739960218166, 2.913287063017314],
            [32.21168109508339, 2.912905923994646],
            [32.21076829087206, 2.912246219107149],
            [32.20959882361099, 2.91035322737252],
            [32.20734524700719, 2.910582554939858],
            [32.206004538395085, 2.910266993570541],
            [32.204835000167115, 2.909721996758208],
            [32.20082730217263, 2.906351774279273],
            [32.19994294221645, 2.907183468039968],
            [32.19347561205828, 2.908159262776096],
            [32.19269682750418, 2.907688764113441],
            [32.191242140648846, 2.905566298921155],
            [32.191613108030246, 2.903702085902211],
            [32.1923263083821, 2.902784349887564],
            [32.1918556729199, 2.902139005354891],
            [32.19205541062839, 2.901307271992802],
            [32.19345323502455, 2.900332224057573],
            [32.19416648568207, 2.898611428748742],
            [32.195307567078444, 2.897636358752221],
            [32.195792569296955, 2.896546519550578],
            [32.195821156384255, 2.895542698014817],
            [32.19529349856277, 2.894467141527375],
            [32.19609225266565, 2.893864887800383],
            [32.19617788636672, 2.892889751813104],
            [32.195693023387065, 2.891685130216877],
            [32.19768986417764, 2.890767468794923],
            [32.19806077496519, 2.889304778448826],
            [32.19761874006502, 2.88736880145682],
            [32.199016597698865, 2.885246508118205],
            [32.19995816416897, 2.88108784862123],
            [32.20333869885625, 2.875251496842056],
            [32.203405150831074, 2.87398016429162],
            [32.206129484169644, 2.870065364406853],
            [32.20735607350298, 2.869749930835578],
            [32.20826891095201, 2.868832185345751],
            [32.21062245747053, 2.863081789409602],
            [32.210793660193985, 2.86164774867507],
            [32.21019470039346, 2.860213685510907],
            [32.21039439498282, 2.859496679274963],
            [32.2082693879574, 2.857388553832827],
            [32.20775608790912, 2.853717382516792],
            [32.20798438306048, 2.851164801659375],
            [32.20734262751982, 2.849888482638979],
            [32.2088260290232, 2.846676287693546],
            [32.21157897460189, 2.836652441933397],
            [32.212449002836046, 2.835433529548473],
            [32.21239211522402, 2.830242297160412],
            [32.234926433177904, 2.772766019473416],
            [32.23611012076992, 2.769625436666353],
            [32.236452393266205, 2.768220065212821],
            [32.23611944348593, 2.768003437118845],
            [32.24395172958236, 2.766214428564399],
            [32.24727810214622, 2.765827735370829],
            [32.24685673209087, 2.767533268123313],
            [32.24651990518183, 2.774087016830114],
            [32.24527683266132, 2.77783703277413],
            [32.24528847662403, 2.780115070733927],
            [32.24484700047598, 2.780559007885729],
            [32.24456819664946, 2.783245924529589],
            [32.246055312686536, 2.786213197144367],
            [32.24698476268009, 2.787124406022634],
            [32.24682211461306, 2.787965527150759],
            [32.248425415155765, 2.789460842445528],
            [32.248765265794034, 2.790352740881543],
            [32.25072763643052, 2.791178905242344],
            [32.25100846775463, 2.788524427093503],
            [32.25223696870288, 2.788151821777674],
            [32.25392383951647, 2.78565405294829],
            [32.25342493227566, 2.78411709211319],
            [32.25371753602159, 2.783424874969893],
            [32.255413084560765, 2.783540885610978],
            [32.26697834227822, 2.786706319408236],
            [32.26580365221213, 2.791543054818889],
            [32.265429696135755, 2.791567885295381],
            [32.26557890001622, 2.792169531151397],
            [32.2651048177183, 2.792845977599937],
            [32.26547863725076, 2.793046728812715],
            [32.26530614903811, 2.794664784613614],
            [32.267050406028645, 2.796866783461661],
            [32.26781097813866, 2.79997343438441],
            [32.26832531843608, 2.800344705337319],
            [32.267641298059615, 2.801205700771142],
            [32.267985470492725, 2.802436817392722],
            [32.26747422848474, 2.804443364961354],
            [32.26663343232826, 2.805490920218781],
            [32.26680606247474, 2.806521883713253],
            [32.26595075133991, 2.807383258618364],
            [32.26606858694897, 2.81019055149742],
            [32.265543378833264, 2.812440635261045],
            [32.262067444859426, 2.817777066857057],
            [32.261414846653274, 2.820872562560743],
            [32.26027522322261, 2.822651315072576],
            [32.26002225045205, 2.825159157849156],
            [32.260991440117174, 2.824597808059229],
            [32.26338933286801, 2.824477839348525],
            [32.26455820724095, 2.823243331157719],
            [32.26572920073969, 2.823641778817234],
            [32.26744174630238, 2.823380095147781],
            [32.26865305619105, 2.821844672371413],
            [32.270177926622914, 2.821123812946957],
            [32.270877565108904, 2.820120753573673],
            [32.27181585182991, 2.817196494844958],
            [32.27161395636812, 2.815621280693489],
            [32.27212565382194, 2.813958509815242],
            [32.27469204357061, 2.811718137946844],
            [32.27644674347633, 2.810954990980862],
            [32.2762463562859, 2.810525713583542],
            [32.27698739722502, 2.809607287589745],
            [32.276642684904424, 2.807975095836315],
            [32.27843826893538, 2.805736452230191],
            [32.27906165123353, 2.802285672658414],
            [32.290483133589746, 2.803269396584781],
            [32.293736206321405, 2.802922842845813],
            [32.307549592360466, 2.800083758461523],
            [32.3154547183517, 2.798117529169059],
            [32.31991454920847, 2.792248595816422],
            [32.32208894201492, 2.78798657129938],
            [32.3247672205255, 2.788520403817381],
            [32.32561905158691, 2.788021466326377],
            [32.32817510891321, 2.785525792308172],
            [32.33037674672393, 2.782316434642679],
            [32.332064804211974, 2.773613124814952],
            [32.34584034063486, 2.774626857426244],
            [32.352611437903, 2.776275754058002],
            [32.3626000049731, 2.779518150859508],
            [32.35882910737909, 2.782672730587246],
            [32.35622175984335, 2.784244068037733],
            [32.348367090425015, 2.787061732922828],
            [32.339451277094135, 2.792575817902863],
            [32.33148468208297, 2.801383654331702],
            [32.32668982274435, 2.804555274936323],
            [32.322211882749755, 2.809216126963717],
            [32.31725198852041, 2.816848378677313],
            [32.31443915495669, 2.816421049542407],
            [32.31313806294695, 2.815352619248727],
            [32.312144813703604, 2.815076504442096],
            [32.310773247063175, 2.81734876905514],
            [32.311422444247654, 2.820173283542369],
            [32.309672142493554, 2.825682731585902],
            [32.30973922867899, 2.828093612301409],
            [32.309361819478674, 2.82909216074156],
            [32.308505113260175, 2.829608257963319],
            [32.30655062983191, 2.832775613477355],
            [32.30701067415689, 2.83482159700687],
            [32.30954331509868, 2.839385296841873],
            [32.30997375454515, 2.841045944362699],
            [32.31171828642016, 2.843333863729505],
            [32.31094891710857, 2.844424274962172],
            [32.31137882565072, 2.845683837509065],
            [32.31122349975156, 2.846959065700489],
            [32.31016951451356, 2.848709040629177],
            [32.31117044974248, 2.849995959630626],
            [32.31111794950231, 2.853462574632571],
            [32.31246174742066, 2.854949247292784],
            [32.312434229328574, 2.85572282571001],
            [32.31179272531621, 2.856368890969684],
            [32.31268042161533, 2.858372274053114],
            [32.312982560079696, 2.8601621397933],
            [32.31141338114474, 2.860939225423481],
            [32.31098628522776, 2.861799667119796],
            [32.30904489474476, 2.861775437472327],
            [32.308648388259805, 2.864182832487264],
            [32.30625277902643, 2.866107740718901],
            [32.30542920537058, 2.869404217048751],
            [32.30637391324923, 2.871350187838387],
            [32.306175725134594, 2.872611173374514],
            [32.30683403303271, 2.873870220494589],
            [32.30685117198999, 2.876033160417244],
            [32.307223263163834, 2.876748536869846],
            [32.3082523318308, 2.877720259465918],
            [32.31152342566537, 2.879331477817195],
            [32.31263867959904, 2.880704085273422],
            [32.313865949855376, 2.880414803862438],
            [32.31640737272735, 2.880781447318028],
            [32.319482601490606, 2.885372570386307],
            [32.31865643978841, 2.886720948613693],
            [32.31591727436621, 2.887959080456741],
            [32.31561983139587, 2.889721663418238],
            [32.313993397437976, 2.890412929622479],
            [32.311029036052126, 2.894086706712874],
            [32.31020191045766, 2.894718857583731],
            [32.30881766409699, 2.895051453353035],
            [32.30770598455984, 2.896400467833091],
            [32.30662111164911, 2.896431574431731],
            [32.30630823113059, 2.897320390040774],
            [32.307879658548686, 2.898204937131992],
            [32.307909309241246, 2.899035688584917],
            [32.30862382113342, 2.899607041193443],
            [32.30879576317036, 2.900093680525677],
            [32.308212874230264, 2.901914193289292],
            [32.30878489984362, 2.902686414710884],
            [32.3099842836986, 2.902884234590012],
            [32.309328901613405, 2.903859780042728],
            [32.30964427944838, 2.90486176667944],
            [32.311243476486844, 2.905144630742444],
            [32.31311230016289, 2.904209307945528],
            [32.313626432051144, 2.904380027004306],
            [32.31422769962366, 2.905667859273116],
            [32.314970353937, 2.905924015573681],
            [32.31848359674126, 2.909688792972046],
            [32.31896982965172, 2.910346609047993],
            [32.31779940658318, 2.910463861134811],
            [32.31757293860512, 2.911925466365585],
            [32.31894598656743, 2.913899108691175],
            [32.31993509457732, 2.917005253656507],
            [32.32010753877254, 2.917864325074516],
            [32.319052337215595, 2.918754835558872],
            [32.319454090760125, 2.920300963858463],
            [32.320426078677336, 2.921244165500374],
            [32.320512785865176, 2.922046130252209],
            [32.31921730203775, 2.924756385674393],
            [32.31844729492229, 2.925417050339487],
            [32.319449870474934, 2.927907219579571],
            [32.31865124213621, 2.928510656383237],
            [32.31839522677179, 2.929227456572509],
            [32.31691181987853, 2.930176233612698],
            [32.31644247978698, 2.931509459410447],
            [32.31470158339389, 2.932057731869889],
            [32.31484565789411, 2.933060114125003],
            [32.312993442271036, 2.935814586962157],
            [32.31088117964457, 2.936220442369615],
            [32.31011128302188, 2.936967054808531],
            [32.3091693176998, 2.937141079316501],
            [32.3082546647556, 2.93636962081731],
            [32.30745564025983, 2.936686568096509],
            [32.30601277792859, 2.93590198776928],
            [32.30358558931972, 2.935649619736755],
            [32.30221546986521, 2.935910550037215],
            [32.30107481157533, 2.936973116752075],
            [32.301104067907495, 2.937517379029825],
            [32.302189578622105, 2.937944658289281],
            [32.30239167530651, 2.939663123613716],
            [32.30104988063125, 2.939752090513994],
            [32.30036625551351, 2.940985520472143],
            [32.30131034714786, 2.94244448063247],
            [32.30061317543566, 2.9442365888723],
            [32.30152852816746, 2.945552371159514],
            [32.29984880614691, 2.949251821288982],
            [32.29910620573246, 2.949052952778237],
            [32.29910416026857, 2.947477282380656],
            [32.29873238979326, 2.947019741290276],
            [32.2974494392607, 2.948455049788337],
            [32.29542206922521, 2.948287711534479],
            [32.29336544016262, 2.947576116154901],
            [32.29216639137923, 2.947664743309458],
            [32.29094052968128, 2.94909992178931],
            [32.289872607979945, 2.951236635144876],
            [32.289539625860314, 2.954104165861081],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 500,
        District: "GULU",
        County: "ASWA",
        Subcounty: "BUNGATIRA",
        Population: 32871,
        Key: "GULUBUNGATIRA",
        Dist2: "Gulu",
        "Sub Country": "Bungatira",
        id2_original: "Gulu Bungatira",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.62788025634293, 2.890232447219659],
            [32.624455324219326, 2.894989492183563],
            [32.62401711614229, 2.896841335963199],
            [32.62064740705246, 2.901334918992916],
            [32.61013728890817, 2.919469594687328],
            [32.60625380366294, 2.92492585099602],
            [32.605091175276144, 2.927864217738675],
            [32.602513838657444, 2.931290580619704],
            [32.599139779925004, 2.934775568097729],
            [32.59416471584544, 2.942943462960331],
            [32.589793316941865, 2.948303020993696],
            [32.58920012612212, 2.94983193117066],
            [32.58751256091082, 2.951048540551496],
            [32.5860618419141, 2.951189876151076],
            [32.58546773481276, 2.951738778582327],
            [32.582816769578386, 2.955883234511457],
            [32.57961176749421, 2.959247690877408],
            [32.57812294375978, 2.961419013360236],
            [32.577693124150834, 2.962891499398001],
            [32.57834359065478, 2.964783268110669],
            [32.57624100827384, 2.968052478157191],
            [32.5756504468229, 2.970930271316564],
            [32.57257739288095, 2.975896280830709],
            [32.570857277215346, 2.977546172933187],
            [32.566168354401526, 2.986555737655441],
            [32.55926954544611, 2.997052232135288],
            [32.55904361106729, 2.998267823263834],
            [32.55595142750135, 3.004700923552383],
            [32.5549247043356, 3.004000718950872],
            [32.5545328969379, 3.001415415784894],
            [32.55378328247772, 3.000481585161949],
            [32.553427060941665, 2.998219440745355],
            [32.55129296296558, 2.997019058769697],
            [32.55115886784989, 2.996622718652957],
            [32.54901620264093, 2.996226882555717],
            [32.54523113861489, 2.994753209395577],
            [32.54383844898887, 2.994393584508381],
            [32.54198113003669, 2.99489546698557],
            [32.54042768868721, 2.994625528579564],
            [32.539749834346864, 2.992937719705798],
            [32.53725067361574, 2.991033716374099],
            [32.535000434253185, 2.991714947727158],
            [32.53285786875723, 2.991103658112246],
            [32.53183980085924, 2.991659743439187],
            [32.530589871498194, 2.991551486976384],
            [32.53019679298437, 2.992089885934013],
            [32.528411527901106, 2.99111969003369],
            [32.52758986945343, 2.991693809572588],
            [32.526482871037224, 2.991406092721391],
            [32.52551840381558, 2.991872436519894],
            [32.52591149939738, 2.991298132273705],
            [32.524018610753195, 2.991440926772763],
            [32.5209656143949, 2.990272696328405],
            [32.51575302227951, 2.986679939579176],
            [32.51428889502882, 2.986392051862287],
            [32.51161024012416, 2.986749900433836],
            [32.50853896843971, 2.986568997619218],
            [32.50632421432754, 2.987752854005294],
            [32.504573149005445, 2.990229470839738],
            [32.50253344959268, 2.983544516033104],
            [32.50243518288376, 2.979006919528401],
            [32.503088450334786, 2.976183848336838],
            [32.50183716541598, 2.97048613104217],
            [32.50052156202113, 2.968424730404054],
            [32.4994562571122, 2.967415901997549],
            [32.49444126740984, 2.966657349728942],
            [32.489865447880234, 2.965205743614713],
            [32.48852160235117, 2.964435244768096],
            [32.48841139254054, 2.962205492821756],
            [32.48783911899215, 2.961376035240986],
            [32.484711527430974, 2.960653022578392],
            [32.48373901759258, 2.959480731448012],
            [32.48051060181886, 2.958141983278506],
            [32.477462880367916, 2.95343646769838],
            [32.476716503436, 2.950687902022075],
            [32.473044957715764, 2.948934786973236],
            [32.47227116779466, 2.946959832924244],
            [32.47095556170485, 2.945444563228894],
            [32.46884173241655, 2.944790708848136],
            [32.466500328425724, 2.944710378114963],
            [32.46410342831325, 2.94574751452206],
            [32.46230476665417, 2.945837771904175],
            [32.46112056792077, 2.946341973995908],
            [32.46063489106748, 2.946142592705044],
            [32.45928934053599, 2.943653305617089],
            [32.45717276958944, 2.941079912224444],
            [32.45688501405111, 2.939533524643212],
            [32.45584086985701, 2.938146520725869],
            [32.456807217252546, 2.935078715172792],
            [32.45637732218511, 2.933962406311224],
            [32.4567474244889, 2.933216633380646],
            [32.4562895639684, 2.932501490967841],
            [32.45674556856954, 2.931927408922819],
            [32.45578661880037, 2.930225061396936],
            [32.456269319535146, 2.928361689510093],
            [32.4560970909356, 2.927731812035084],
            [32.45518241104196, 2.927017761530197],
            [32.45553292108943, 2.922590572936209],
            [32.45427284705385, 2.919957838518597],
            [32.45344349363747, 2.919014382800327],
            [32.44788521812262, 2.915546763654758],
            [32.4467980428298, 2.914002277786171],
            [32.443494227861024, 2.913033374667481],
            [32.44032657503143, 2.913447962246477],
            [32.43435563054308, 2.91351534839139],
            [32.431078437147725, 2.9127326233181],
            [32.42866776316702, 2.909871227175288],
            [32.426586187889, 2.908174477684997],
            [32.42663017299854, 2.903092828457885],
            [32.42625986857384, 2.901538198349342],
            [32.42539458613932, 2.900356382905655],
            [32.4170455073448, 2.899481604037577],
            [32.40739718796833, 2.899476565557389],
            [32.39818110107563, 2.900839574113473],
            [32.395953907093414, 2.902081926935701],
            [32.39316845058628, 2.906370655007506],
            [32.38877077416401, 2.918306285620423],
            [32.38654306634546, 2.920419087833456],
            [32.38215035491175, 2.923028105998477],
            [32.37670639630503, 2.925263452891124],
            [32.37318940752607, 2.927189696345174],
            [32.37268243790558, 2.926968572954504],
            [32.37224915079964, 2.923302503612227],
            [32.37321717804478, 2.921323466199152],
            [32.37294325296856, 2.919361638007319],
            [32.374188735668945, 2.915688077724432],
            [32.376629412481805, 2.914855279565795],
            [32.378627698661674, 2.914650087187428],
            [32.37951152142532, 2.913731253891976],
            [32.38047957202662, 2.911780868234411],
            [32.38096177689133, 2.909487805525954],
            [32.382672024563554, 2.907449735875047],
            [32.38427855275306, 2.902675904449462],
            [32.38534656698087, 2.900768242380231],
            [32.385285578559596, 2.897960770609258],
            [32.38400617098249, 2.89153201892699],
            [32.38423096270423, 2.888924417265515],
            [32.38740639763915, 2.883201484774197],
            [32.38973242606555, 2.882608731576888],
            [32.39035928933546, 2.88171913825743],
            [32.392494489544376, 2.877359447610256],
            [32.392647175294904, 2.87425065130574],
            [32.3937876224807, 2.873130652306449],
            [32.39424297939653, 2.872098217652129],
            [32.39364959813394, 2.866298138216416],
            [32.394374984132575, 2.864674900628191],
            [32.40090726787571, 2.855687631256183],
            [32.397917820137216, 2.852485228418615],
            [32.40730896801754, 2.844793323685744],
            [32.41359478728435, 2.8382034189233],
            [32.42664348962432, 2.829362704069921],
            [32.43229326034747, 2.822989674871885],
            [32.43264436867291, 2.818451075974032],
            [32.43440066129162, 2.815581888670839],
            [32.436602858752764, 2.809913438640304],
            [32.4374248262209, 2.803609138374689],
            [32.4385966659326, 2.799586929919991],
            [32.43873913244848, 2.795234872725093],
            [32.43932542869843, 2.792412150793001],
            [32.44138471857089, 2.791895587599646],
            [32.44229787132857, 2.790578623596466],
            [32.44351494390978, 2.789802876224125],
            [32.44393645500067, 2.789073801552344],
            [32.44425712930258, 2.789153958380204],
            [32.445056813161784, 2.78938122937263],
            [32.44571558998044, 2.790869417806591],
            [32.44725757421677, 2.791123542251171],
            [32.450701435640035, 2.79370803280509],
            [32.45295689241773, 2.793788538346167],
            [32.45404071789285, 2.79309834031897],
            [32.454548473539205, 2.788914274769568],
            [32.45597176966526, 2.78610317593315],
            [32.4607091422156, 2.784974377631471],
            [32.46159164625241, 2.78328191165715],
            [32.46378994682184, 2.783333889672064],
            [32.46450706831989, 2.785652773464403],
            [32.46626466619071, 2.786923412437608],
            [32.46974744173377, 2.786829013362836],
            [32.47163031506085, 2.785936296652007],
            [32.47240124923769, 2.786020371102402],
            [32.47360155296749, 2.786876941919129],
            [32.475126783623786, 2.785455080625332],
            [32.47772579030213, 2.786193639712866],
            [32.47958070446432, 2.785702080250296],
            [32.48149608871985, 2.787473688485398],
            [32.482699511400334, 2.790421673920268],
            [32.48401346369165, 2.790905515062768],
            [32.48425990121853, 2.793440415209463],
            [32.48500377993562, 2.794527287798634],
            [32.48614606776943, 2.794753693702948],
            [32.48742977198855, 2.79409161956408],
            [32.488400384585034, 2.794060593647929],
            [32.490458359323945, 2.795717252962475],
            [32.49242774220951, 2.79539728239935],
            [32.49342956407562, 2.797142466508559],
            [32.4958723806755, 2.798411405339283],
            [32.496073814403246, 2.799470951369321],
            [32.49767426189658, 2.800613023898194],
            [32.4993581682697, 2.800293744650828],
            [32.50120510179891, 2.800902936324081],
            [32.50204691394996, 2.803265905422714],
            [32.50362937088312, 2.805629201727843],
            [32.5052251372555, 2.806746991687753],
            [32.50632356754053, 2.806208159084579],
            [32.507344884644915, 2.806876289905966],
            [32.508366461362435, 2.80690240310721],
            [32.509106814192045, 2.807621773839141],
            [32.50946331510413, 2.810138623123411],
            [32.51005063902679, 2.81036999758637],
            [32.51114892378472, 2.810190702232911],
            [32.512145445590654, 2.809061170750673],
            [32.513780379407756, 2.808137351213057],
            [32.51536311212369, 2.809909975312376],
            [32.515950479165475, 2.810038627171153],
            [32.51625711549443, 2.809653541870665],
            [32.51554439124972, 2.803849423722407],
            [32.514791696466425, 2.802089987056895],
            [32.51509883585192, 2.800472230414752],
            [32.51614628404964, 2.799702247191027],
            [32.516683151399405, 2.798392759710839],
            [32.518317574973416, 2.798650242704723],
            [32.518101119617505, 2.797122155573163],
            [32.519838448800584, 2.795556345322701],
            [32.520247679921525, 2.794067035883966],
            [32.521397565706025, 2.792578028723147],
            [32.52134712260788, 2.791011481153454],
            [32.52196045904619, 2.790035875137929],
            [32.524599026631314, 2.791170434309176],
            [32.5305541841269, 2.790796927198461],
            [32.53418153183681, 2.788923690524579],
            [32.54045423031059, 2.781825444217796],
            [32.542191080691616, 2.781363868366526],
            [32.54431068165564, 2.781775589045804],
            [32.54529412758429, 2.781326556828989],
            [32.54789992732279, 2.7792474156532],
            [32.548794399614124, 2.777681235276749],
            [32.56188131448969, 2.783014964631513],
            [32.56359238861194, 2.783195361482978],
            [32.565111527792276, 2.78444145601345],
            [32.56991272025364, 2.785085243264353],
            [32.572134915111334, 2.784366991946106],
            [32.57315680893413, 2.783494220254584],
            [32.57420377653314, 2.783931169208713],
            [32.577204669706646, 2.783919416064247],
            [32.58088154872472, 2.786206342128748],
            [32.58164739035221, 2.787182490569252],
            [32.58474990723886, 2.788737285657979],
            [32.58625623195168, 2.790201632274728],
            [32.59069948350158, 2.792077906791301],
            [32.59564010437651, 2.795918919772318],
            [32.59931757538436, 2.796690615630732],
            [32.600185934548705, 2.796690913516184],
            [32.60143773420218, 2.795664105485984],
            [32.60477109476066, 2.794445392472512],
            [32.60985345271941, 2.794626871445162],
            [32.613749096662, 2.792124273023389],
            [32.61574144318119, 2.791380180733659],
            [32.61801457071885, 2.791859906697434],
            [32.6193930867263, 2.79307632274769],
            [32.622266316721536, 2.793090096403411],
            [32.62553462308374, 2.795582206650213],
            [32.62538091684708, 2.7970716559305],
            [32.62591679694833, 2.798509964900711],
            [32.62686152458992, 2.799306379005579],
            [32.62730812293175, 2.80042364114569],
            [32.62873808186224, 2.801322937083062],
            [32.62784361765574, 2.803094640178618],
            [32.62807328363624, 2.803711063943049],
            [32.63072874493861, 2.805971838220047],
            [32.63109850408594, 2.807782463586623],
            [32.63247735516501, 2.808810142072562],
            [32.63247677664997, 2.810659180832765],
            [32.633535872403634, 2.813291825797628],
            [32.63290924898395, 2.816129377013486],
            [32.634619573911245, 2.818954833857764],
            [32.63446596648924, 2.820110428281236],
            [32.638768328964936, 2.824028139831127],
            [32.64055618029787, 2.823977337193597],
            [32.643288832036006, 2.824594534986426],
            [32.643722725504745, 2.825570549089788],
            [32.64462944632498, 2.825455258601552],
            [32.64478237282398, 2.826508226750795],
            [32.6461355716118, 2.828023833612587],
            [32.647693363502185, 2.828640650626323],
            [32.64802518589677, 2.829308462620713],
            [32.648407914021895, 2.830592630829103],
            [32.64778154482543, 2.832634082780411],
            [32.64818995039463, 2.833456007454725],
            [32.64852189406179, 2.833738597591543],
            [32.64954391185207, 2.832480539217098],
            [32.65000326627095, 2.833713370545834],
            [32.65112695808006, 2.834073242371124],
            [32.65281216251876, 2.835717343901247],
            [32.653961450923596, 2.835897460753716],
            [32.653603436350274, 2.837361165855385],
            [32.65970907063909, 2.839931956589734],
            [32.657962113312784, 2.843334195696944],
            [32.65826108521574, 2.845019656105261],
            [32.65777807995212, 2.846031486538928],
            [32.65626596829223, 2.847622339808464],
            [32.65328568336967, 2.852052234047878],
            [32.649520508044, 2.856264846361127],
            [32.646981443249636, 2.860009855972676],
            [32.64569446197637, 2.863402359458682],
            [32.64285921185304, 2.866307871846312],
            [32.639571224301235, 2.872338778552971],
            [32.63858704085576, 2.872963301072272],
            [32.636696997176045, 2.872834298248669],
            [32.6345123492023, 2.875465895186125],
            [32.6345370160417, 2.87609097852832],
            [32.63544982474462, 2.877388503770502],
            [32.63527192867396, 2.878648990079941],
            [32.62788025634293, 2.890232447219659],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 501,
        District: "GULU",
        County: "ASWA",
        Subcounty: "PAICHO",
        Population: 24488,
        Key: "GULUPAICHO",
        Dist2: "Gulu",
        "Sub Country": "Paicho",
        id2_original: "Gulu Paicho",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.38675845629944, 3.284608730291863],
            [32.386071826317085, 3.285833815981743],
            [32.38437552139638, 3.286924240027685],
            [32.38288714322631, 3.290676436010802],
            [32.376443870849776, 3.29649356939141],
            [32.369945509288435, 3.298921311789718],
            [32.36834502137091, 3.299073485330173],
            [32.36579228062464, 3.298650588474803],
            [32.36312468757436, 3.299070139270302],
            [32.36012815841652, 3.300925434911804],
            [32.359406767225906, 3.299726340763814],
            [32.359436028049664, 3.298663622060488],
            [32.359922045364456, 3.298376709151329],
            [32.35906511905874, 3.297715528475968],
            [32.35998087423578, 3.295762974654259],
            [32.35992415910033, 3.295073593211322],
            [32.35923871938572, 3.294383806820124],
            [32.359182152472265, 3.293464641841872],
            [32.36004008578942, 3.292546070614988],
            [32.36095413326911, 3.293264727295038],
            [32.36132605286473, 3.292633064253936],
            [32.36087015606142, 3.290507290391792],
            [32.360269957484114, 3.290593072585784],
            [32.36018508645272, 3.289243048330984],
            [32.35958522025204, 3.288811819282496],
            [32.360128406351514, 3.288496221820126],
            [32.3598717711496, 3.287605648848658],
            [32.36045857494768, 3.286112446615717],
            [32.359830588783694, 3.284963133425472],
            [32.35968907538037, 3.28280883622268],
            [32.360946760795564, 3.282407530203177],
            [32.36140441111035, 3.281775919478164],
            [32.36134770765297, 3.281057814151353],
            [32.361862424344466, 3.280569857133229],
            [32.36149178484814, 3.279190931067582],
            [32.36222044700263, 3.279306285882587],
            [32.36213511513547, 3.278674331500058],
            [32.3627356856153, 3.277985371425236],
            [32.363507307003346, 3.277957141418554],
            [32.36342206406941, 3.277181570618909],
            [32.36390801311223, 3.276980822331081],
            [32.36362354271289, 3.274912604468992],
            [32.36436667493001, 3.274740738730024],
            [32.36431011610139, 3.273792852905739],
            [32.363538952854164, 3.273103012351984],
            [32.36455492857588, 3.270777119150879],
            [32.364156705410444, 3.26781842076427],
            [32.3622722016411, 3.26526089396943],
            [32.36084329194285, 3.26531742465202],
            [32.35947210169654, 3.264483589586647],
            [32.35904318579277, 3.264885432829554],
            [32.35752885529413, 3.264453619295971],
            [32.356527983845616, 3.26548699515604],
            [32.355813454885464, 3.265630148721503],
            [32.35587017271587, 3.266319528947143],
            [32.355498865771295, 3.26600333963984],
            [32.35504135020381, 3.266433886146602],
            [32.35418443198293, 3.265801431271667],
            [32.35415545143357, 3.266433313952571],
            [32.35278363865476, 3.266576041376647],
            [32.35194086171307, 3.266173376393203],
            [32.350768505470064, 3.267235354781553],
            [32.34911145602899, 3.266544931244738],
            [32.34739766450299, 3.265222571273354],
            [32.34545384138218, 3.266082979573721],
            [32.34548282911808, 3.265451102053477],
            [32.34496837832793, 3.265536932135779],
            [32.34385429220412, 3.264875581749623],
            [32.34234129839865, 3.262404440141755],
            [32.33955595238429, 3.260966475657091],
            [32.33724123554394, 3.260907497196699],
            [32.3344987472535, 3.259498270516072],
            [32.331244007248685, 3.254871765648337],
            [32.33030123344282, 3.254469022435865],
            [32.32748864961076, 3.25107787741521],
            [32.326404651659104, 3.24817617292682],
            [32.32924965658807, 3.245736655397738],
            [32.330945347061125, 3.244876789368108],
            [32.33891321049345, 3.233450861417938],
            [32.338289412275344, 3.233271230549605],
            [32.33680130000658, 3.234358698046085],
            [32.333399111429365, 3.234568046979555],
            [32.33157827395914, 3.233884924149979],
            [32.331012915641836, 3.233077615410811],
            [32.329380211443265, 3.234162658835994],
            [32.32811128001901, 3.233633782028693],
            [32.2881668357145, 3.170345653438291],
            [32.286890834548956, 3.166564610284021],
            [32.28515901293687, 3.164867411111036],
            [32.281948938066314, 3.157016310820725],
            [32.281845029937394, 3.155999078892306],
            [32.28075042018729, 3.155134568473168],
            [32.280328548871964, 3.154003813448439],
            [32.28062129365341, 3.153054563307516],
            [32.28054495661719, 3.147395512888861],
            [32.2799280323076, 3.141259019246168],
            [32.27670910184496, 3.141503425284203],
            [32.27413892569736, 3.139419263272007],
            [32.27199621287771, 3.13898693220755],
            [32.26942602864527, 3.136938666369699],
            [32.267318994213745, 3.136578159118769],
            [32.266748250496306, 3.135536572436323],
            [32.265212337973, 3.135679102824982],
            [32.26435609348857, 3.134314190260224],
            [32.265179780332126, 3.131155325455293],
            [32.26412781181194, 3.130466693914069],
            [32.26573422411876, 3.129952973002342],
            [32.265877387727286, 3.129522239127774],
            [32.26573552487929, 3.128086027718464],
            [32.26505738756962, 3.127403394939388],
            [32.26523654397662, 3.126577756503813],
            [32.26727274984126, 3.12604064586712],
            [32.266774040229805, 3.124137445752229],
            [32.26747219020735, 3.121714494007759],
            [32.26840185310165, 3.120207227229866],
            [32.268117246158376, 3.118591399796481],
            [32.26840461003124, 3.116222012299999],
            [32.27015472044419, 3.116187330298512],
            [32.2704411644422, 3.11514634677891],
            [32.27136988141048, 3.115003381253076],
            [32.2726553615989, 3.115435109562281],
            [32.27362003633137, 3.114933139017382],
            [32.273638373641255, 3.114233045882126],
            [32.27456738435866, 3.11365924118484],
            [32.277281503852436, 3.114091954041855],
            [32.278603608354985, 3.113195289592771],
            [32.27871160920832, 3.111938759881873],
            [32.27921170761522, 3.111831394585252],
            [32.2798185357593, 3.112334454657599],
            [32.28149808709993, 3.111007196150461],
            [32.283997813769695, 3.111583354202193],
            [32.286105685431046, 3.110651312957107],
            [32.2876057057672, 3.110724137917229],
            [32.28869532178264, 3.110311992600957],
            [32.291194262426544, 3.112072932625846],
            [32.29553497038845, 3.111990215746984],
            [32.29657977574258, 3.110693685947478],
            [32.29655228729486, 3.10858791247909],
            [32.29721126892942, 3.105859719486487],
            [32.29781163818664, 3.105343113477715],
            [32.297669324384366, 3.104510070070103],
            [32.29847034493669, 3.103017037365913],
            [32.299928211828146, 3.102012721831538],
            [32.30258561528814, 3.101784705546554],
            [32.30405858016458, 3.09953096385306],
            [32.30531653956594, 3.098354172140559],
            [32.3124038087798, 3.095001409612687],
            [32.31277465578696, 3.093186081656557],
            [32.312345968953586, 3.091952400956606],
            [32.312592419955145, 3.090349141342907],
            [32.31388125894444, 3.089733278160096],
            [32.318235954573616, 3.092017892374082],
            [32.32602634594011, 3.094613043159157],
            [32.32743758398012, 3.094490601029412],
            [32.32792776139298, 3.095539310177962],
            [32.328970366772985, 3.096218347773191],
            [32.32952193774733, 3.097205423922698],
            [32.33044055316023, 3.099919500726996],
            [32.331912149902486, 3.101400521599667],
            [32.332525547426265, 3.101647593821987],
            [32.33313944620996, 3.101092949374133],
            [32.334796308801444, 3.100662304155056],
            [32.33627114217367, 3.096963015080517],
            [32.33688429984727, 3.094088337078508],
            [32.33790965218392, 3.093283296528106],
            [32.33799333654082, 3.092583500309865],
            [32.337429597885986, 3.09167951776446],
            [32.338308230183905, 3.088780564899944],
            [32.3382820398018, 3.087426113544755],
            [32.33703487815013, 3.085567809298826],
            [32.337818881916036, 3.084782930741316],
            [32.337530861374695, 3.083968153220783],
            [32.33779499301769, 3.082545991695356],
            [32.33890283405361, 3.081113666863624],
            [32.33826092040947, 3.080571064901094],
            [32.3369994297307, 3.077370603279491],
            [32.33736857622702, 3.075418247612346],
            [32.33623560931262, 3.073948699313116],
            [32.33688210885628, 3.072726325713854],
            [32.336397736356766, 3.07138843813346],
            [32.33731902785092, 3.068828697370023],
            [32.33729542731177, 3.065810508356589],
            [32.33664405530599, 3.064965621873994],
            [32.33609066254826, 3.062685749686814],
            [32.33525501643331, 3.061204717103803],
            [32.33521008000784, 3.06006556924671],
            [32.33624665859062, 3.057084617548206],
            [32.3363203851226, 3.055514215182731],
            [32.33635023434285, 3.053677120639381],
            [32.33534384813679, 3.049610455962251],
            [32.33522572327019, 3.045014513845615],
            [32.33582984389202, 3.042691296063845],
            [32.33624929155271, 3.033933434953347],
            [32.33571874205433, 3.0287624472406],
            [32.334285948939105, 3.02646585161598],
            [32.33228008636815, 3.024695908454178],
            [32.33373617100205, 3.022569120536853],
            [32.338216093578474, 3.019766208584009],
            [32.34608122836987, 3.01626988350308],
            [32.3494227609025, 3.016784696159038],
            [32.352203619832, 3.015464709245792],
            [32.35363359493218, 3.013481565035474],
            [32.35615011650451, 3.011371374379215],
            [32.35809091409943, 3.01058145485496],
            [32.359725726643944, 3.01082617701742],
            [32.36117721549687, 3.010487546298828],
            [32.3627725893055, 3.007963095618443],
            [32.363772566930336, 3.007230119254697],
            [32.36478469426935, 3.00574779065836],
            [32.36709784624449, 3.00428702586748],
            [32.36927446417792, 3.003815324610263],
            [32.370448767968455, 3.00422163496539],
            [32.37223705588265, 3.00317528849734],
            [32.373554349906875, 3.003680688885071],
            [32.3785888510172, 3.00233749742067],
            [32.3802632451298, 3.003114752534403],
            [32.38378096873064, 3.003910441211864],
            [32.38460464928601, 3.005133042568643],
            [32.38839026667431, 3.00650135866886],
            [32.391397135441075, 3.006103782228096],
            [32.392031786206154, 3.005606526650621],
            [32.395164711065156, 3.005609999245628],
            [32.39628865440258, 3.004661425105474],
            [32.39728720819765, 3.002525992327942],
            [32.398766674181815, 3.001945983741773],
            [32.40026022215635, 3.003178137628401],
            [32.40120181467756, 3.003072809482608],
            [32.40200785142245, 3.002409116877284],
            [32.40358812095787, 3.00230226541163],
            [32.40398651839651, 3.001510933591586],
            [32.405754952644585, 3.002434803031514],
            [32.40586565113875, 3.003041111101983],
            [32.40639609643255, 3.003025699238667],
            [32.40912426827232, 3.001233175149883],
            [32.41034325785838, 3.001857797829656],
            [32.41317990396362, 3.001554082382756],
            [32.41668893905908, 3.002143997658125],
            [32.41704174520039, 3.002681773314857],
            [32.41859648820869, 3.003408654374268],
            [32.420494135228964, 3.002303573357584],
            [32.42113449568597, 3.002942808887323],
            [32.42096193830305, 3.00318175107295],
            [32.42139015082596, 3.003527332851346],
            [32.42189963572922, 3.003318130785976],
            [32.42211061405686, 3.003684311298754],
            [32.42198545897485, 3.006208968342939],
            [32.42282900038282, 3.007697828833497],
            [32.42266763241508, 3.008734870070239],
            [32.42392296334595, 3.01026284858516],
            [32.42296723763033, 3.011406514593748],
            [32.41950249127504, 3.013749773708127],
            [32.41822684314738, 3.016581258523083],
            [32.41811858178262, 3.017681595708719],
            [32.41644837920914, 3.020025804753556],
            [32.41599896375059, 3.021468705772413],
            [32.41511916813436, 3.022316075349938],
            [32.41079329225614, 3.024063532095858],
            [32.40713120579584, 3.026172120167561],
            [32.405299610101814, 3.028227584676836],
            [32.40409605626731, 3.030391629810618],
            [32.4015726473117, 3.032798789269635],
            [32.39755714565232, 3.035620914708391],
            [32.395617261644055, 3.035283592458622],
            [32.394412854410014, 3.03568639521949],
            [32.392806639732555, 3.03682868435784],
            [32.39267235327568, 3.037702816255203],
            [32.40203679154764, 3.040330694960269],
            [32.405783011522495, 3.040601763960537],
            [32.406785987723744, 3.041543773462967],
            [32.41367529879169, 3.044035699712779],
            [32.41701684569734, 3.050425988061962],
            [32.417015721006614, 3.052510644518276],
            [32.418485719645965, 3.055873797370515],
            [32.419555549368965, 3.056950332911737],
            [32.42024548784651, 3.057395226393147],
            [32.42130831160862, 3.057382106335339],
            [32.422902985629634, 3.056547486974791],
            [32.42392486058782, 3.056671306825363],
            [32.427330673867225, 3.057905816829381],
            [32.42790234913762, 3.059056624851658],
            [32.42956438422852, 3.059673853989892],
            [32.43035414260213, 3.060701507239338],
            [32.43207058505653, 3.061510513966044],
            [32.43207008738987, 3.062455566714279],
            [32.43351368813629, 3.063880765449957],
            [32.43374470248802, 3.06507247970491],
            [32.43866085684786, 3.070498877007181],
            [32.43886467560267, 3.07159470091607],
            [32.44158910955255, 3.073102748219649],
            [32.44292441210325, 3.07321302020484],
            [32.444041107832966, 3.074459983319675],
            [32.44476341440682, 3.074227519960506],
            [32.445130908003044, 3.075022107589504],
            [32.445594189856294, 3.075036047308907],
            [32.4458799852707, 3.07572101924049],
            [32.44759618877324, 3.077064169586688],
            [32.44771802008869, 3.078625629319276],
            [32.4469948484372, 3.080529062968092],
            [32.447402794068985, 3.082159155480394],
            [32.446966081686845, 3.083460092267006],
            [32.44734714343713, 3.084377955026655],
            [32.44637870476362, 3.086253863427223],
            [32.443406248658725, 3.089950348144117],
            [32.44290199464535, 3.090100744293979],
            [32.442383671217975, 3.091100312495087],
            [32.44260132941807, 3.09179894716997],
            [32.441142555228176, 3.093236301462573],
            [32.44061049296686, 3.094441308786427],
            [32.4406776689838, 3.096262972822113],
            [32.4402547394531, 3.097235195455887],
            [32.44067625862883, 3.098947476104882],
            [32.442406100354, 3.100318038116678],
            [32.44235142169928, 3.100646724158606],
            [32.444197390437864, 3.101563925306817],
            [32.44398626748149, 3.103191221842744],
            [32.443333715089416, 3.104543525363912],
            [32.44379624774776, 3.104670581378817],
            [32.443564472522986, 3.105579270130742],
            [32.44415236238426, 3.107249258322378],
            [32.4437555378957, 3.107870640384009],
            [32.44451506436676, 3.108968458298345],
            [32.44545143498125, 3.109219779599698],
            [32.44474001778525, 3.109363084973458],
            [32.44444531737145, 3.10997584838525],
            [32.44524210955374, 3.11426670627793],
            [32.445956487596916, 3.115323843622458],
            [32.44494647129881, 3.116654822772157],
            [32.444356717433294, 3.11853553916076],
            [32.44378877196795, 3.118915668772962],
            [32.44435616137613, 3.119592295483002],
            [32.444103230826435, 3.120733461342411],
            [32.44492282674221, 3.121642706719725],
            [32.444346024786476, 3.123069869233251],
            [32.44571294713688, 3.126831383315845],
            [32.44365792246537, 3.129994856363057],
            [32.443428705642525, 3.132012717630809],
            [32.44488563469281, 3.138159172608303],
            [32.44748558729714, 3.140040950996266],
            [32.44972108261089, 3.140821813933571],
            [32.45232188861476, 3.141098367324251],
            [32.4549686632083, 3.140732851056576],
            [32.46175904371233, 3.133636736171853],
            [32.464281716049385, 3.129295186771946],
            [32.466082543546634, 3.128300872484099],
            [32.4669833938765, 3.126944193529893],
            [32.47029713163591, 3.126306792832965],
            [32.476128932476634, 3.128615350655616],
            [32.48260754906804, 3.129677210488085],
            [32.4919951899255, 3.1326971216192],
            [32.49749624455337, 3.132352572750611],
            [32.50058903717707, 3.131476371310201],
            [32.50058949262291, 3.131914905360278],
            [32.50361399711536, 3.131126456340138],
            [32.504756899396824, 3.131294555575957],
            [32.51265121057035, 3.129993743216839],
            [32.517413774576184, 3.129660845170527],
            [32.52041483483632, 3.12803456008359],
            [32.52143860613809, 3.128370143297373],
            [32.52178360052967, 3.128980672925347],
            [32.52118698712869, 3.131876600103999],
            [32.51873307184347, 3.13462815714641],
            [32.51752960873882, 3.13669809201428],
            [32.51626717393067, 3.137535268251582],
            [32.51486066911393, 3.140957510515937],
            [32.514752414037346, 3.143339118824561],
            [32.51356102159516, 3.145014103998328],
            [32.51353626043266, 3.147048686104275],
            [32.515417268857234, 3.147432544789518],
            [32.516202700046094, 3.148270682925909],
            [32.515761129574955, 3.15050852363107],
            [32.51758032402648, 3.155859136300193],
            [32.51705545547395, 3.157989218017133],
            [32.516388522850846, 3.158371894071787],
            [32.51348395063535, 3.157125843898146],
            [32.51231703369137, 3.157340716769205],
            [32.51062524280502, 3.159661734525275],
            [32.51044573874998, 3.16161245832279],
            [32.50873460084734, 3.163482312460423],
            [32.50744062079972, 3.164131890689429],
            [32.50461381663667, 3.163865635877897],
            [32.502792717756726, 3.164635357016343],
            [32.5005518406361, 3.166821077851611],
            [32.49757466747768, 3.173845656179282],
            [32.495030634999765, 3.177648380304082],
            [32.49491492121138, 3.179592910955215],
            [32.496914438981506, 3.184147398959053],
            [32.49635061229172, 3.185480072309396],
            [32.495666124791335, 3.186073280107623],
            [32.49404415186716, 3.18650596466157],
            [32.49148938811489, 3.186488053041516],
            [32.49046401152372, 3.187293258535426],
            [32.49016157841194, 3.188110374563082],
            [32.489878251567966, 3.191478728672836],
            [32.49025165428213, 3.193733562212812],
            [32.49173006025422, 3.196224220143036],
            [32.491880965543864, 3.198076427484489],
            [32.49120106843455, 3.199878677817046],
            [32.48943713564432, 3.201638883073484],
            [32.48779189096441, 3.20425940436547],
            [32.48378445976956, 3.206127686833957],
            [32.48215494908184, 3.208518755253465],
            [32.478425645282094, 3.212567742101515],
            [32.47669903659361, 3.213506438263757],
            [32.474833191731044, 3.213700765680249],
            [32.47012150470964, 3.215528916091068],
            [32.46814648489566, 3.216922893880752],
            [32.46726852992746, 3.218298704878333],
            [32.4681731001809, 3.221988893053919],
            [32.46758301483706, 3.222704537212233],
            [32.45968204624898, 3.226092175340428],
            [32.45849012919065, 3.228248624404751],
            [32.45845691128809, 3.230303308886231],
            [32.45779763680273, 3.23082435939569],
            [32.45545602260616, 3.230290005347151],
            [32.45142487498946, 3.230634458698682],
            [32.448368250335726, 3.230342152205781],
            [32.44637924105782, 3.231107198208028],
            [32.44633480768892, 3.232363778609101],
            [32.44791605908297, 3.233707679969337],
            [32.44801268906145, 3.235184213400105],
            [32.44736969743895, 3.236189111822202],
            [32.44483524010367, 3.237888124714003],
            [32.440510584137606, 3.238493631482119],
            [32.437451532235976, 3.240582910241855],
            [32.43607045513164, 3.241019472208764],
            [32.431511844627906, 3.24118585211979],
            [32.42791985281092, 3.243435521798684],
            [32.42642043883758, 3.245224138251773],
            [32.423429447793474, 3.247162505128554],
            [32.41935051878684, 3.24757411325704],
            [32.41626713332077, 3.247190822099955],
            [32.41465323714934, 3.247572932972629],
            [32.408553929695074, 3.25243312171503],
            [32.40428491268273, 3.254919923772723],
            [32.403083588466764, 3.25673833343795],
            [32.40117758711438, 3.258154200771728],
            [32.397671644020136, 3.258879744037364],
            [32.39637567600077, 3.259644905655583],
            [32.39549824205542, 3.261406053912127],
            [32.39545922642601, 3.262937921597613],
            [32.39166423242282, 3.269082328478826],
            [32.38865037116984, 3.275131441700573],
            [32.388211284540446, 3.276605617594306],
            [32.38870508036731, 3.279171830074648],
            [32.38836120347991, 3.280703508284894],
            [32.38694993310057, 3.283038763855697],
            [32.38675845629944, 3.284608730291863],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 502,
        District: "GULU",
        County: "ASWA",
        Subcounty: "PALARO",
        Population: 13555,
        Key: "GULUPALARO",
        Dist2: "Gulu",
        "Sub Country": "Palaro",
        id2_original: "Gulu Palaro",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.26412781181194, 3.130466693914069],
            [32.262840866471294, 3.130417667064619],
            [32.26157027675699, 3.134204511270641],
            [32.260855363317916, 3.135029767864099],
            [32.25889077743596, 3.135279691728648],
            [32.25831898179132, 3.135746017706215],
            [32.258424382920225, 3.13822338476578],
            [32.25588806876725, 3.138831920068572],
            [32.25510116074806, 3.140446977192991],
            [32.25435126152189, 3.140231022682938],
            [32.25335221365342, 3.138794197197573],
            [32.251602329615935, 3.138469816867744],
            [32.2496388396786, 3.137175903047961],
            [32.24899591542975, 3.137211345882141],
            [32.24792346891434, 3.138538968608235],
            [32.2459944895553, 3.138932501528025],
            [32.24552968326096, 3.139614313238361],
            [32.24527791423292, 3.142055509988191],
            [32.24420594651956, 3.142700979151386],
            [32.243241623926686, 3.142664372243799],
            [32.24320492325573, 3.144028646024914],
            [32.242245351852404, 3.145174010838761],
            [32.24049596997317, 3.144114515892232],
            [32.24050830384202, 3.14297595876922],
            [32.24155250103667, 3.139937032927542],
            [32.240766405992794, 3.137818684321267],
            [32.24106377619963, 3.135627045356801],
            [32.24327880609458, 3.135433440562896],
            [32.24364007077263, 3.135033402390123],
            [32.24554107928868, 3.130875344786754],
            [32.24486011947239, 3.12893586717594],
            [32.244989342126, 3.127988137044391],
            [32.24829497169164, 3.128160136838633],
            [32.25068481823251, 3.125873816807622],
            [32.25185014785334, 3.126016488439708],
            [32.2523934210894, 3.125471156702588],
            [32.25250883124724, 3.123891518865979],
            [32.25436791449065, 3.121279129217694],
            [32.252626090137895, 3.119698166509652],
            [32.25259877506505, 3.117917371906441],
            [32.25345684851939, 3.116654207439363],
            [32.25337224518592, 3.115074428082286],
            [32.25213154421779, 3.111942825940296],
            [32.2536188147651, 3.109818445962044],
            [32.25321934473803, 3.109042662053048],
            [32.252476277199655, 3.10930063184775],
            [32.252077173685194, 3.10800784997013],
            [32.25069963594309, 3.107128143413701],
            [32.24921480072852, 3.106913190272416],
            [32.248919617021116, 3.105605814933569],
            [32.249223841373535, 3.103876816063504],
            [32.248449988570336, 3.102826086167261],
            [32.248628581733676, 3.101712738398157],
            [32.24820497846649, 3.100178854130589],
            [32.24779641030224, 3.10055474934168],
            [32.245136834715865, 3.100056447627475],
            [32.24413296109765, 3.100474443594355],
            [32.24394749582241, 3.10002205213489],
            [32.243952432963226, 3.097365200797587],
            [32.24329858160724, 3.096220660249371],
            [32.243908793705025, 3.093699711952654],
            [32.242956614538144, 3.093738612415007],
            [32.24270773089881, 3.09255026888977],
            [32.24206997286117, 3.092117542727916],
            [32.24193722521836, 3.091191187503844],
            [32.24076200334959, 3.089852194695351],
            [32.240579627380626, 3.089115167610021],
            [32.24118419626177, 3.087116053438697],
            [32.240676945468614, 3.085616997900398],
            [32.240834575546465, 3.084242519364545],
            [32.24164758860784, 3.083870259353513],
            [32.24210809466686, 3.083091552800574],
            [32.2417361553083, 3.082281662720118],
            [32.23970188171988, 3.081172186438622],
            [32.239150061013866, 3.081594239873347],
            [32.238451160044725, 3.081315159224658],
            [32.237888891932, 3.080503556283428],
            [32.23790863780027, 3.078677119991927],
            [32.239168599546396, 3.077680223994843],
            [32.23960915492129, 3.076545510628669],
            [32.239436260670125, 3.074930837406836],
            [32.237573707234795, 3.072245378234891],
            [32.235317906402315, 3.071821853566433],
            [32.23405139593777, 3.070126208534087],
            [32.23321843937877, 3.070142459056253],
            [32.23265694920707, 3.069259694560622],
            [32.23165159786019, 3.068716920617608],
            [32.231860663674574, 3.066987074134361],
            [32.233440113048154, 3.066147243341158],
            [32.23387553814448, 3.065486926414831],
            [32.234432291499694, 3.062408028481548],
            [32.23379609024242, 3.061832989274095],
            [32.2315198545339, 3.061100893551317],
            [32.230943994910895, 3.061546447320766],
            [32.23088948424116, 3.062186462344722],
            [32.23162821022179, 3.064280647531361],
            [32.22989069329082, 3.064336223077112],
            [32.22847341857211, 3.06558077367393],
            [32.227210436689965, 3.0657592135128],
            [32.22678579586866, 3.065423283938947],
            [32.227020236394885, 3.062448255003223],
            [32.22793815202018, 3.061175498033132],
            [32.227814914841304, 3.059371500320807],
            [32.226279407458144, 3.055052132765269],
            [32.22548167024818, 3.05071566366188],
            [32.22613187444411, 3.045597501816399],
            [32.22703843266926, 3.044273861385661],
            [32.22636783851305, 3.042480138806782],
            [32.227127454815616, 3.039343763639504],
            [32.22663606288045, 3.038580245009137],
            [32.226405671061244, 3.035684060186064],
            [32.225961341863815, 3.034968411223046],
            [32.227147308481705, 3.034208080327491],
            [32.22733282496092, 3.032454299547698],
            [32.22810283746626, 3.031654650624112],
            [32.2274782307644, 3.02890913096885],
            [32.228222396942385, 3.028299020325389],
            [32.228469275542025, 3.02747095570261],
            [32.22810068061126, 3.026352709619669],
            [32.228519739301404, 3.025004302806785],
            [32.228254604240256, 3.019818613495429],
            [32.23011053619365, 3.017605360935362],
            [32.23049684680014, 3.015983851547709],
            [32.230172244165466, 3.015198100474691],
            [32.22924622483799, 3.015023744713484],
            [32.22883108190416, 3.013810192461058],
            [32.229320007963864, 3.010398565371031],
            [32.2278709032397, 3.009092707745828],
            [32.226111479992205, 3.008982043461179],
            [32.22635969708162, 3.005829215866083],
            [32.22677103654854, 3.005192399656667],
            [32.22810378069732, 3.005156904895284],
            [32.22832378529692, 3.004613263551846],
            [32.22838395175972, 3.002348326997621],
            [32.22773962164745, 3.000326166283253],
            [32.225060622688, 2.999448145954195],
            [32.22462323297618, 2.998092051886526],
            [32.22272160462256, 2.997932671137041],
            [32.22211435786354, 2.996883444382934],
            [32.22159737112934, 2.997388836914514],
            [32.220836359743146, 2.99735828933085],
            [32.217729618079716, 2.998635141178713],
            [32.21641015911565, 2.999643355139925],
            [32.21591666332612, 3.00127575430425],
            [32.21425369578393, 3.001047323724114],
            [32.21359143709525, 3.000685544316739],
            [32.213008761055875, 2.999565375172805],
            [32.212366702782965, 2.999535888003873],
            [32.211563460696915, 3.000109867669892],
            [32.21107252420765, 3.001505066669155],
            [32.20960091039741, 3.001183467770728],
            [32.208123475504124, 2.999201253883607],
            [32.20705706117585, 2.99881211904825],
            [32.207050220504954, 2.997246402025423],
            [32.206631942450784, 2.996507751572531],
            [32.20683297912315, 2.994239345333998],
            [32.20476455068928, 2.994750527998147],
            [32.20344219196352, 2.994034550684818],
            [32.202018052319396, 2.994136704005971],
            [32.20191646094562, 2.992466325741889],
            [32.20286588228457, 2.992398220434709],
            [32.2031372866881, 2.990557417189983],
            [32.20286606104929, 2.990148327055],
            [32.199899249059364, 2.98852884918767],
            [32.198678671251905, 2.987165177303522],
            [32.19630513003179, 2.987164988016548],
            [32.19616946915252, 2.98757404158575],
            [32.195355749117034, 2.986755832026093],
            [32.19393164540552, 2.986483004764118],
            [32.19237197962946, 2.985426101365837],
            [32.19277891735147, 2.984880708065726],
            [32.19250771147563, 2.984267080398331],
            [32.191761756751916, 2.984164744047586],
            [32.19064287811606, 2.983278330983393],
            [32.190337907263654, 2.981062503323737],
            [32.18955802047668, 2.981198791593449],
            [32.189473269819516, 2.980909027502447],
            [32.1898463985475, 2.979272779066808],
            [32.188964879064244, 2.9783863844886],
            [32.18947354829725, 2.977772824966968],
            [32.18886329218205, 2.976818269979663],
            [32.188321105009145, 2.973034325574431],
            [32.18715138621982, 2.972062681979074],
            [32.18635944583839, 2.966626978022707],
            [32.186844701381816, 2.963300070355773],
            [32.18630275046585, 2.962496966341226],
            [32.18648831006423, 2.960905210001348],
            [32.188257084773795, 2.959872855923207],
            [32.18857098937174, 2.958582261033015],
            [32.18811462185121, 2.957721805292092],
            [32.18911317564631, 2.956459938154965],
            [32.189213263240326, 2.953405455981695],
            [32.188329026353315, 2.952172116041221],
            [32.18872861765296, 2.949476177093762],
            [32.1884149358372, 2.948070800742169],
            [32.1878444481396, 2.94746846093186],
            [32.18808706782651, 2.945618575648367],
            [32.18777329977249, 2.945360426923379],
            [32.18880043436665, 2.943123425539321],
            [32.188287009452544, 2.942406364229188],
            [32.18834414410124, 2.941373869163594],
            [32.1890003292803, 2.940456138829183],
            [32.18995601277509, 2.939982980257079],
            [32.189785245734555, 2.934763094303241],
            [32.18833045108138, 2.933931240641968],
            [32.18880125722345, 2.932396863031469],
            [32.18788851409755, 2.931048808565293],
            [32.18777451070148, 2.929700809892172],
            [32.19075578017763, 2.926130294434583],
            [32.19049915934873, 2.924524158733204],
            [32.19149766373646, 2.923262279159768],
            [32.19078462328477, 2.921656109746148],
            [32.191526396350824, 2.920308173345441],
            [32.190442487332376, 2.919074836336186],
            [32.19067072858484, 2.918759362577448],
            [32.19158355076248, 2.918874147522815],
            [32.19251072712005, 2.917712646495494],
            [32.19228265295425, 2.915848390769897],
            [32.19159808280883, 2.915045283108319],
            [32.19251104692029, 2.913123741448169],
            [32.1920832224696, 2.91206252119665],
            [32.19285344877399, 2.911747093918002],
            [32.19350964024127, 2.910341778756643],
            [32.19347561205828, 2.908159262776096],
            [32.19994294221645, 2.907183468039968],
            [32.20082730217263, 2.906351774279273],
            [32.204835000167115, 2.909721996758208],
            [32.206004538395085, 2.910266993570541],
            [32.20734524700719, 2.910582554939858],
            [32.20959882361099, 2.91035322737252],
            [32.21076829087206, 2.912246219107149],
            [32.21168109508339, 2.912905923994646],
            [32.215739960218166, 2.913287063017314],
            [32.217200906534394, 2.912949211703404],
            [32.2181422259678, 2.914125172588774],
            [32.2193688359624, 2.914440715831158],
            [32.219910798556434, 2.915215125802086],
            [32.22093764299479, 2.917595684943503],
            [32.22059529414169, 2.918456091766908],
            [32.221622214038504, 2.919029758152296],
            [32.223989894649726, 2.919230622779191],
            [32.22463170588593, 2.920076734974872],
            [32.22876797615377, 2.921654343262491],
            [32.22962373375129, 2.922686888826187],
            [32.230137213462655, 2.922772948526528],
            [32.230679187734815, 2.923518676376432],
            [32.23030829581187, 2.92475193942306],
            [32.23043656804794, 2.927462295065978],
            [32.2300941985336, 2.928838964602902],
            [32.229067182517035, 2.930186926633867],
            [32.2292953078868, 2.932481412998218],
            [32.23056469026533, 2.93395852977895],
            [32.230108195184044, 2.935564638486962],
            [32.22882448557504, 2.935794029981271],
            [32.22879593352203, 2.936367648015603],
            [32.22948054229502, 2.937256791810347],
            [32.22872445726985, 2.940225231241369],
            [32.23160562208394, 2.94168807338757],
            [32.23266105540623, 2.943408966858613],
            [32.23345991820523, 2.940569591999793],
            [32.23405900826147, 2.939967317213179],
            [32.236940258415565, 2.93925039382647],
            [32.23848075414347, 2.938246608624188],
            [32.24266390568935, 2.937894208822868],
            [32.2455818115986, 2.936383652021644],
            [32.24903377582572, 2.93269208453036],
            [32.252958887204564, 2.936110566535509],
            [32.25605189632227, 2.933981511756916],
            [32.26007087985166, 2.928701306248214],
            [32.27124374446984, 2.924966506018413],
            [32.273784272619814, 2.924588414074029],
            [32.27581280507528, 2.925701179591138],
            [32.276999521786415, 2.927145281476162],
            [32.27825651999046, 2.927744084050828],
            [32.282968443268764, 2.928535712665691],
            [32.28445460080347, 2.929706978634946],
            [32.28619623830663, 2.929731727171218],
            [32.2874536209896, 2.930617015847691],
            [32.28748424455765, 2.932221269585528],
            [32.28824393542038, 2.934611723934766],
            [32.28790436505647, 2.936961658539361],
            [32.288133730999625, 2.937706011497414],
            [32.28765028556149, 2.939196817908599],
            [32.285782683594235, 2.941134781716235],
            [32.284758043621615, 2.943629499375798],
            [32.28243220743467, 2.944479825774478],
            [32.2819762729021, 2.945168411780958],
            [32.28206288217359, 2.945913081329771],
            [32.28146392776294, 2.946401434728449],
            [32.28072388036054, 2.948179303691292],
            [32.27961133035586, 2.948926638380318],
            [32.27988394119683, 2.950000358301739],
            [32.27937104808538, 2.950803652582413],
            [32.278486539008846, 2.951264001907939],
            [32.27857464667023, 2.9531832594464],
            [32.27665159798869, 2.956133424236227],
            [32.277180242160355, 2.956796086142591],
            [32.278322338653, 2.956822186933253],
            [32.279236611609825, 2.957307163267537],
            [32.27986430312642, 2.956961989518201],
            [32.28086423044559, 2.957446791750329],
            [32.281634868178344, 2.957244524625955],
            [32.284464010656066, 2.959214965828906],
            [32.28694692984687, 2.958378621525078],
            [32.28768772913917, 2.957173709637728],
            [32.288085239042275, 2.955453910423564],
            [32.289539625860314, 2.954104165861081],
            [32.29165337070702, 2.954815659274688],
            [32.29236855903058, 2.955902713680213],
            [32.29450993425874, 2.95589790511652],
            [32.29578398428349, 2.958602334943517],
            [32.296898203357976, 2.959144158143457],
            [32.297442128770925, 2.960260237204383],
            [32.29872743648281, 2.960629791752892],
            [32.29944245771973, 2.9615735836809],
            [32.30031341660851, 2.961671894976085],
            [32.30099750795187, 2.960782258446348],
            [32.30296613265935, 2.959660528073769],
            [32.3051621479147, 2.957764779067455],
            [32.305904306358045, 2.957619864801331],
            [32.306019262866606, 2.958192590616735],
            [32.3079342491685, 2.959735292012199],
            [32.31071858637478, 2.960144432009172],
            [32.31214452893766, 2.958880654974447],
            [32.31357129615397, 2.958247164112207],
            [32.32032082846538, 2.955982982600482],
            [32.32643139989497, 2.956341542578134],
            [32.32820305729833, 2.957426179547569],
            [32.3294762862629, 2.959443024714388],
            [32.330876760689165, 2.960528507321639],
            [32.33093638456952, 2.962419175723837],
            [32.33188220007092, 2.965138681757506],
            [32.33478492984174, 2.96867020029184],
            [32.335055944376435, 2.969497723617977],
            [32.33808160500065, 2.97043588400663],
            [32.339982653042576, 2.970271883623623],
            [32.34580156665224, 2.972445825543396],
            [32.34742102519194, 2.972234460012479],
            [32.35087363800271, 2.967565294254875],
            [32.352352838983826, 2.966386566493444],
            [32.358080216062696, 2.964549745112091],
            [32.35939443695031, 2.964574102629379],
            [32.36059077371983, 2.965542071062059],
            [32.36223344831975, 2.965755353207848],
            [32.36500153320592, 2.967856647046407],
            [32.368029087478725, 2.967669653337059],
            [32.36901452676901, 2.968094876483888],
            [32.36985959800792, 2.96774148049171],
            [32.371619327580895, 2.968473840892775],
            [32.37499876901851, 2.968546544471507],
            [32.37581986691743, 2.969089629521098],
            [32.37875371522804, 2.968572659338868],
            [32.37871218790908, 2.968995197986632],
            [32.38049074796707, 2.969510022086209],
            [32.380024320213685, 2.971181453429379],
            [32.38028398633138, 2.971959251817836],
            [32.37967198658621, 2.973549921095426],
            [32.38137578794792, 2.977665021069967],
            [32.3835228638849, 2.978370513859744],
            [32.3842109886639, 2.9804602980962],
            [32.38506842970429, 2.981088600849764],
            [32.386224715086854, 2.981014287804142],
            [32.38619707572219, 2.981673283592644],
            [32.38725560823217, 2.983189228529316],
            [32.386972044232955, 2.984622344229215],
            [32.386201624790786, 2.984996564490557],
            [32.3865466137925, 2.986714716366465],
            [32.386437629283904, 2.991882711798252],
            [32.386544394953766, 2.992414417401839],
            [32.38746378381612, 2.99273143833498],
            [32.388632027571745, 2.99411179722723],
            [32.38923292054677, 2.994145862387336],
            [32.38916345741911, 2.99503258513852],
            [32.388563678355055, 2.995814164023791],
            [32.39026274739186, 2.998021291555286],
            [32.39385090879249, 2.99967647370379],
            [32.396225739095, 2.998869497509941],
            [32.39666786203009, 2.999843962047101],
            [32.398766674181815, 3.001945983741773],
            [32.39728720819765, 3.002525992327942],
            [32.39628865440258, 3.004661425105474],
            [32.395164711065156, 3.005609999245628],
            [32.392031786206154, 3.005606526650621],
            [32.391397135441075, 3.006103782228096],
            [32.38839026667431, 3.00650135866886],
            [32.38460464928601, 3.005133042568643],
            [32.38378096873064, 3.003910441211864],
            [32.3802632451298, 3.003114752534403],
            [32.3785888510172, 3.00233749742067],
            [32.373554349906875, 3.003680688885071],
            [32.37223705588265, 3.00317528849734],
            [32.370448767968455, 3.00422163496539],
            [32.36927446417792, 3.003815324610263],
            [32.36709784624449, 3.00428702586748],
            [32.36478469426935, 3.00574779065836],
            [32.363772566930336, 3.007230119254697],
            [32.3627725893055, 3.007963095618443],
            [32.36117721549687, 3.010487546298828],
            [32.359725726643944, 3.01082617701742],
            [32.35809091409943, 3.01058145485496],
            [32.35615011650451, 3.011371374379215],
            [32.35363359493218, 3.013481565035474],
            [32.352203619832, 3.015464709245792],
            [32.3494227609025, 3.016784696159038],
            [32.34608122836987, 3.01626988350308],
            [32.338216093578474, 3.019766208584009],
            [32.33373617100205, 3.022569120536853],
            [32.33228008636815, 3.024695908454178],
            [32.334285948939105, 3.02646585161598],
            [32.33571874205433, 3.0287624472406],
            [32.33624929155271, 3.033933434953347],
            [32.33582984389202, 3.042691296063845],
            [32.33522572327019, 3.045014513845615],
            [32.33534384813679, 3.049610455962251],
            [32.33635023434285, 3.053677120639381],
            [32.3363203851226, 3.055514215182731],
            [32.33624665859062, 3.057084617548206],
            [32.33521008000784, 3.06006556924671],
            [32.33525501643331, 3.061204717103803],
            [32.33609066254826, 3.062685749686814],
            [32.33664405530599, 3.064965621873994],
            [32.33729542731177, 3.065810508356589],
            [32.33731902785092, 3.068828697370023],
            [32.336397736356766, 3.07138843813346],
            [32.33688210885628, 3.072726325713854],
            [32.33623560931262, 3.073948699313116],
            [32.33736857622702, 3.075418247612346],
            [32.3369994297307, 3.077370603279491],
            [32.33826092040947, 3.080571064901094],
            [32.33890283405361, 3.081113666863624],
            [32.33779499301769, 3.082545991695356],
            [32.337530861374695, 3.083968153220783],
            [32.337818881916036, 3.084782930741316],
            [32.33703487815013, 3.085567809298826],
            [32.3382820398018, 3.087426113544755],
            [32.338308230183905, 3.088780564899944],
            [32.337429597885986, 3.09167951776446],
            [32.33799333654082, 3.092583500309865],
            [32.33790965218392, 3.093283296528106],
            [32.33688429984727, 3.094088337078508],
            [32.33627114217367, 3.096963015080517],
            [32.334796308801444, 3.100662304155056],
            [32.33313944620996, 3.101092949374133],
            [32.332525547426265, 3.101647593821987],
            [32.331912149902486, 3.101400521599667],
            [32.33044055316023, 3.099919500726996],
            [32.32952193774733, 3.097205423922698],
            [32.328970366772985, 3.096218347773191],
            [32.32792776139298, 3.095539310177962],
            [32.32743758398012, 3.094490601029412],
            [32.32602634594011, 3.094613043159157],
            [32.318235954573616, 3.092017892374082],
            [32.31388125894444, 3.089733278160096],
            [32.312592419955145, 3.090349141342907],
            [32.312345968953586, 3.091952400956606],
            [32.31277465578696, 3.093186081656557],
            [32.3124038087798, 3.095001409612687],
            [32.30531653956594, 3.098354172140559],
            [32.30405858016458, 3.09953096385306],
            [32.30258561528814, 3.101784705546554],
            [32.299928211828146, 3.102012721831538],
            [32.29847034493669, 3.103017037365913],
            [32.297669324384366, 3.104510070070103],
            [32.29781163818664, 3.105343113477715],
            [32.29721126892942, 3.105859719486487],
            [32.29655228729486, 3.10858791247909],
            [32.29657977574258, 3.110693685947478],
            [32.29553497038845, 3.111990215746984],
            [32.291194262426544, 3.112072932625846],
            [32.28869532178264, 3.110311992600957],
            [32.2876057057672, 3.110724137917229],
            [32.286105685431046, 3.110651312957107],
            [32.283997813769695, 3.111583354202193],
            [32.28149808709993, 3.111007196150461],
            [32.2798185357593, 3.112334454657599],
            [32.27921170761522, 3.111831394585252],
            [32.27871160920832, 3.111938759881873],
            [32.278603608354985, 3.113195289592771],
            [32.277281503852436, 3.114091954041855],
            [32.27456738435866, 3.11365924118484],
            [32.273638373641255, 3.114233045882126],
            [32.27362003633137, 3.114933139017382],
            [32.2726553615989, 3.115435109562281],
            [32.27136988141048, 3.115003381253076],
            [32.2704411644422, 3.11514634677891],
            [32.27015472044419, 3.116187330298512],
            [32.26840461003124, 3.116222012299999],
            [32.268117246158376, 3.118591399796481],
            [32.26840185310165, 3.120207227229866],
            [32.26747219020735, 3.121714494007759],
            [32.266774040229805, 3.124137445752229],
            [32.26727274984126, 3.12604064586712],
            [32.26523654397662, 3.126577756503813],
            [32.26505738756962, 3.127403394939388],
            [32.26573552487929, 3.128086027718464],
            [32.265877387727286, 3.129522239127774],
            [32.26573422411876, 3.129952973002342],
            [32.26412781181194, 3.130466693914069],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 503,
        District: "GULU",
        County: "ASWA",
        Subcounty: "PATIKO",
        Population: 18352,
        Key: "GULUPATIKO",
        Dist2: "Gulu",
        "Sub Country": "Patiko",
        id2_original: "Gulu Patiko",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.44425712930258, 2.789153958380204],
            [32.44393645500067, 2.789073801552344],
            [32.44351494390978, 2.789802876224125],
            [32.44229787132857, 2.790578623596466],
            [32.44138471857089, 2.791895587599646],
            [32.43932542869843, 2.792412150793001],
            [32.43873913244848, 2.795234872725093],
            [32.4385966659326, 2.799586929919991],
            [32.4374248262209, 2.803609138374689],
            [32.436602858752764, 2.809913438640304],
            [32.43440066129162, 2.815581888670839],
            [32.43264436867291, 2.818451075974032],
            [32.43229326034747, 2.822989674871885],
            [32.42664348962432, 2.829362704069921],
            [32.41359478728435, 2.8382034189233],
            [32.40730896801754, 2.844793323685744],
            [32.397917820137216, 2.852485228418615],
            [32.40090726787571, 2.855687631256183],
            [32.394374984132575, 2.864674900628191],
            [32.39364959813394, 2.866298138216416],
            [32.39424297939653, 2.872098217652129],
            [32.3937876224807, 2.873130652306449],
            [32.392647175294904, 2.87425065130574],
            [32.392494489544376, 2.877359447610256],
            [32.39035928933546, 2.88171913825743],
            [32.38973242606555, 2.882608731576888],
            [32.38740639763915, 2.883201484774197],
            [32.38423096270423, 2.888924417265515],
            [32.38400617098249, 2.89153201892699],
            [32.385285578559596, 2.897960770609258],
            [32.38534656698087, 2.900768242380231],
            [32.38427855275306, 2.902675904449462],
            [32.382672024563554, 2.907449735875047],
            [32.38096177689133, 2.909487805525954],
            [32.38047957202662, 2.911780868234411],
            [32.37951152142532, 2.913731253891976],
            [32.378627698661674, 2.914650087187428],
            [32.376629412481805, 2.914855279565795],
            [32.374188735668945, 2.915688077724432],
            [32.37367851594375, 2.914203096659034],
            [32.373890899236486, 2.912927722159811],
            [32.37357533904349, 2.911839782640214],
            [32.372202221910904, 2.909894838553482],
            [32.37136906412928, 2.90611509183105],
            [32.36815925516004, 2.897269979123773],
            [32.3658697252836, 2.893264419122123],
            [32.363455281073655, 2.891851882975996],
            [32.36305345656222, 2.890305766853508],
            [32.361765722500756, 2.88813142405612],
            [32.36170747753438, 2.887300734592471],
            [32.36249063508728, 2.885852148771964],
            [32.36231604571517, 2.883446035773537],
            [32.362999325879855, 2.882040645112246],
            [32.36334935353198, 2.877040573563474],
            [32.3632050742159, 2.875923596326841],
            [32.362317991466085, 2.874435902987471],
            [32.36264526928365, 2.873675944827833],
            [32.362215925781804, 2.872874763144952],
            [32.36332387102232, 2.868861330544781],
            [32.363634222783304, 2.866167590573946],
            [32.3594945928163, 2.866234497734161],
            [32.357354143751174, 2.866812437842163],
            [32.35331458251353, 2.866979361119743],
            [32.351631977799265, 2.868329751963937],
            [32.35015381886385, 2.873060249215588],
            [32.349801408879586, 2.876341371719297],
            [32.34906116923771, 2.877861478669195],
            [32.3494057513026, 2.879321779288385],
            [32.34875097019033, 2.880698439318906],
            [32.34853973494452, 2.882833280110505],
            [32.34748540475343, 2.884325458238484],
            [32.34745941289898, 2.886216342979626],
            [32.3466631138918, 2.888510096126554],
            [32.345365994232225, 2.889931207125161],
            [32.3447969267711, 2.891364957493773],
            [32.34119943546796, 2.89125863815617],
            [32.34000217882359, 2.892636537075472],
            [32.33800485653604, 2.893529235024685],
            [32.33585748684997, 2.899622045383706],
            [32.33334895758871, 2.902549975988838],
            [32.329340619095426, 2.904808076077929],
            [32.32851269220371, 2.904838614542341],
            [32.326715768784716, 2.906160561693623],
            [32.32297649278699, 2.906799365429969],
            [32.32139359118778, 2.908049192203154],
            [32.31902495566744, 2.90885674847567],
            [32.31848359674126, 2.909688792972046],
            [32.314970353937, 2.905924015573681],
            [32.31422769962366, 2.905667859273116],
            [32.313626432051144, 2.904380027004306],
            [32.31311230016289, 2.904209307945528],
            [32.311243476486844, 2.905144630742444],
            [32.30964427944838, 2.90486176667944],
            [32.309328901613405, 2.903859780042728],
            [32.3099842836986, 2.902884234590012],
            [32.30878489984362, 2.902686414710884],
            [32.308212874230264, 2.901914193289292],
            [32.30879576317036, 2.900093680525677],
            [32.30862382113342, 2.899607041193443],
            [32.307909309241246, 2.899035688584917],
            [32.307879658548686, 2.898204937131992],
            [32.30630823113059, 2.897320390040774],
            [32.30662111164911, 2.896431574431731],
            [32.30770598455984, 2.896400467833091],
            [32.30881766409699, 2.895051453353035],
            [32.31020191045766, 2.894718857583731],
            [32.311029036052126, 2.894086706712874],
            [32.313993397437976, 2.890412929622479],
            [32.31561983139587, 2.889721663418238],
            [32.31591727436621, 2.887959080456741],
            [32.31865643978841, 2.886720948613693],
            [32.319482601490606, 2.885372570386307],
            [32.31640737272735, 2.880781447318028],
            [32.313865949855376, 2.880414803862438],
            [32.31263867959904, 2.880704085273422],
            [32.31152342566537, 2.879331477817195],
            [32.3082523318308, 2.877720259465918],
            [32.307223263163834, 2.876748536869846],
            [32.30685117198999, 2.876033160417244],
            [32.30683403303271, 2.873870220494589],
            [32.306175725134594, 2.872611173374514],
            [32.30637391324923, 2.871350187838387],
            [32.30542920537058, 2.869404217048751],
            [32.30625277902643, 2.866107740718901],
            [32.308648388259805, 2.864182832487264],
            [32.30904489474476, 2.861775437472327],
            [32.31098628522776, 2.861799667119796],
            [32.31141338114474, 2.860939225423481],
            [32.312982560079696, 2.8601621397933],
            [32.31268042161533, 2.858372274053114],
            [32.31179272531621, 2.856368890969684],
            [32.312434229328574, 2.85572282571001],
            [32.31246174742066, 2.854949247292784],
            [32.31111794950231, 2.853462574632571],
            [32.31117044974248, 2.849995959630626],
            [32.31016951451356, 2.848709040629177],
            [32.31122349975156, 2.846959065700489],
            [32.31137882565072, 2.845683837509065],
            [32.31094891710857, 2.844424274962172],
            [32.31171828642016, 2.843333863729505],
            [32.30997375454515, 2.841045944362699],
            [32.30954331509868, 2.839385296841873],
            [32.30701067415689, 2.83482159700687],
            [32.30655062983191, 2.832775613477355],
            [32.308505113260175, 2.829608257963319],
            [32.309361819478674, 2.82909216074156],
            [32.30973922867899, 2.828093612301409],
            [32.309672142493554, 2.825682731585902],
            [32.311422444247654, 2.820173283542369],
            [32.310773247063175, 2.81734876905514],
            [32.312144813703604, 2.815076504442096],
            [32.31313806294695, 2.815352619248727],
            [32.31443915495669, 2.816421049542407],
            [32.31725198852041, 2.816848378677313],
            [32.322211882749755, 2.809216126963717],
            [32.32668982274435, 2.804555274936323],
            [32.33148468208297, 2.801383654331702],
            [32.339451277094135, 2.792575817902863],
            [32.348367090425015, 2.787061732922828],
            [32.35622175984335, 2.784244068037733],
            [32.35882910737909, 2.782672730587246],
            [32.3626000049731, 2.779518150859508],
            [32.36994162856641, 2.780327892235787],
            [32.375127338596926, 2.779511825187444],
            [32.38160218945066, 2.775600302130924],
            [32.38297761525352, 2.775583659725918],
            [32.38398771509499, 2.776854502458164],
            [32.38470953388366, 2.777145237247094],
            [32.38535855859159, 2.778597362346159],
            [32.38853333146811, 2.782301076306149],
            [32.38979541054341, 2.783050539925712],
            [32.39046907693789, 2.783020576966465],
            [32.392018300697096, 2.782187809353156],
            [32.3933317508302, 2.782356598526659],
            [32.394815062502076, 2.78152226383378],
            [32.39644228518079, 2.781518415498828],
            [32.3981965332339, 2.78049720746847],
            [32.40216464606709, 2.780459149385082],
            [32.403962015948814, 2.779652708215091],
            [32.40636800701194, 2.775220675247251],
            [32.40839112621951, 2.772580123493864],
            [32.411046644115736, 2.772974901518207],
            [32.41315135819885, 2.77748216111546],
            [32.41635228821983, 2.779967021360991],
            [32.41700819042958, 2.779478422946527],
            [32.42020629884227, 2.779986477505637],
            [32.42171665609238, 2.778120656539578],
            [32.422686834802604, 2.777803198903897],
            [32.42321321791467, 2.776584339093424],
            [32.42646453623657, 2.774399204945289],
            [32.42803445179005, 2.774252192988542],
            [32.4298202037602, 2.775293619930499],
            [32.43182299588951, 2.778354313660214],
            [32.437079347637344, 2.78077690419589],
            [32.438524740522766, 2.783337566625254],
            [32.43806884551608, 2.783940295190229],
            [32.43841259124943, 2.784741662145194],
            [32.439583685359445, 2.785168590999648],
            [32.43984215851446, 2.786227998235567],
            [32.44181377820512, 2.787455185346448],
            [32.44332670104369, 2.787365605457362],
            [32.44415606344323, 2.788366335838958],
            [32.44425712930258, 2.789153958380204],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 504,
        District: "GULU",
        County: "ASWA",
        Subcounty: "UNYAMA",
        Population: 17134,
        Key: "GULUUNYAMA",
        Dist2: "Gulu",
        "Sub Country": "Unyama",
        id2_original: "Gulu Unyama",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.290483133589746, 2.803269396584781],
            [32.27906165123353, 2.802285672658414],
            [32.27843826893538, 2.805736452230191],
            [32.276642684904424, 2.807975095836315],
            [32.27698739722502, 2.809607287589745],
            [32.2762463562859, 2.810525713583542],
            [32.27644674347633, 2.810954990980862],
            [32.27469204357061, 2.811718137946844],
            [32.27212565382194, 2.813958509815242],
            [32.27161395636812, 2.815621280693489],
            [32.27181585182991, 2.817196494844958],
            [32.270877565108904, 2.820120753573673],
            [32.270177926622914, 2.821123812946957],
            [32.26865305619105, 2.821844672371413],
            [32.26744174630238, 2.823380095147781],
            [32.26572920073969, 2.823641778817234],
            [32.26455820724095, 2.823243331157719],
            [32.26338933286801, 2.824477839348525],
            [32.260991440117174, 2.824597808059229],
            [32.26002225045205, 2.825159157849156],
            [32.26027522322261, 2.822651315072576],
            [32.261414846653274, 2.820872562560743],
            [32.262067444859426, 2.817777066857057],
            [32.265543378833264, 2.812440635261045],
            [32.26606858694897, 2.81019055149742],
            [32.26595075133991, 2.807383258618364],
            [32.26680606247474, 2.806521883713253],
            [32.26663343232826, 2.805490920218781],
            [32.26747422848474, 2.804443364961354],
            [32.267985470492725, 2.802436817392722],
            [32.267641298059615, 2.801205700771142],
            [32.26832531843608, 2.800344705337319],
            [32.26781097813866, 2.79997343438441],
            [32.267050406028645, 2.796866783461661],
            [32.26530614903811, 2.794664784613614],
            [32.26547863725076, 2.793046728812715],
            [32.2651048177183, 2.792845977599937],
            [32.26557890001622, 2.792169531151397],
            [32.265429696135755, 2.791567885295381],
            [32.26580365221213, 2.791543054818889],
            [32.26697834227822, 2.786706319408236],
            [32.255413084560765, 2.783540885610978],
            [32.25371753602159, 2.783424874969893],
            [32.25342493227566, 2.78411709211319],
            [32.25392383951647, 2.78565405294829],
            [32.25223696870288, 2.788151821777674],
            [32.25100846775463, 2.788524427093503],
            [32.25072763643052, 2.791178905242344],
            [32.248765265794034, 2.790352740881543],
            [32.248425415155765, 2.789460842445528],
            [32.24682211461306, 2.787965527150759],
            [32.24698476268009, 2.787124406022634],
            [32.246055312686536, 2.786213197144367],
            [32.24456819664946, 2.783245924529589],
            [32.24484700047598, 2.780559007885729],
            [32.24528847662403, 2.780115070733927],
            [32.24527683266132, 2.77783703277413],
            [32.24651990518183, 2.774087016830114],
            [32.24685673209087, 2.767533268123313],
            [32.24727810214622, 2.765827735370829],
            [32.24781961198937, 2.7657821568051],
            [32.2529853371998, 2.765475712529603],
            [32.25897974298844, 2.766041366985005],
            [32.26712911910878, 2.765137241043064],
            [32.27045598574607, 2.764357075850357],
            [32.27405614953718, 2.762521056444312],
            [32.2776412782254, 2.761920083694045],
            [32.27898415896385, 2.761289008950182],
            [32.28359993735394, 2.763091677805299],
            [32.28627154048365, 2.764822977793777],
            [32.29028618515024, 2.770830395143631],
            [32.29806162046559, 2.771756357950196],
            [32.29741391628112, 2.777366988816761],
            [32.2955858851021, 2.777141597959538],
            [32.29506261195752, 2.781017918300524],
            [32.29290946700248, 2.786768242423523],
            [32.29353108770436, 2.795994692189713],
            [32.290483133589746, 2.803269396584781],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 505,
        District: "GULU",
        County: "GULU MUNICIPALITY",
        Subcounty: "BAR DEGE DIVISION",
        Population: 40322,
        Key: "GULUBAR DEGE DIVISION",
        Dist2: "Gulu",
        "Sub Country": "Bar-Dege Div",
        id2_original: "Gulu Bar-Dege Div",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.332064804211974, 2.773613124814952],
            [32.33037674672393, 2.782316434642679],
            [32.32817510891321, 2.785525792308172],
            [32.32561905158691, 2.788021466326377],
            [32.3247672205255, 2.788520403817381],
            [32.32208894201492, 2.78798657129938],
            [32.31991454920847, 2.792248595816422],
            [32.3154547183517, 2.798117529169059],
            [32.307549592360466, 2.800083758461523],
            [32.293736206321405, 2.802922842845813],
            [32.290483133589746, 2.803269396584781],
            [32.29353108770436, 2.795994692189713],
            [32.29290946700248, 2.786768242423523],
            [32.29506261195752, 2.781017918300524],
            [32.2955858851021, 2.777141597959538],
            [32.29741391628112, 2.777366988816761],
            [32.29806162046559, 2.771756357950196],
            [32.29812809489827, 2.771762476395744],
            [32.318309344237385, 2.774208869567675],
            [32.32295101207395, 2.774297719187036],
            [32.332064804211974, 2.773613124814952],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 506,
        District: "GULU",
        County: "GULU MUNICIPALITY",
        Subcounty: "LAROO DIVISION",
        Population: 27313,
        Key: "GULULAROO DIVISION",
        Dist2: "Gulu",
        "Sub Country": "Laroo",
        id2_original: "Gulu Laroo",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.30665914272496, 2.738937285977563],
            [32.30445330349368, 2.750579796453716],
            [32.30031018357179, 2.762063825728182],
            [32.29854157954209, 2.768583503163967],
            [32.29812809489827, 2.771762476395744],
            [32.29806162046559, 2.771756357950196],
            [32.29028618515024, 2.770830395143631],
            [32.28627154048365, 2.764822977793777],
            [32.28359993735394, 2.763091677805299],
            [32.27898415896385, 2.761289008950182],
            [32.2776412782254, 2.761920083694045],
            [32.27405614953718, 2.762521056444312],
            [32.27045598574607, 2.764357075850357],
            [32.26712911910878, 2.765137241043064],
            [32.25897974298844, 2.766041366985005],
            [32.2529853371998, 2.765475712529603],
            [32.24781961198937, 2.7657821568051],
            [32.24775341064451, 2.764006714317205],
            [32.24620456058447, 2.760558952121989],
            [32.247817657255325, 2.759939738607994],
            [32.24962061825138, 2.760265272001836],
            [32.253828398907416, 2.757481200096054],
            [32.255209751794524, 2.757808914540977],
            [32.258856981018326, 2.7572902967199],
            [32.268715978685144, 2.757418337895585],
            [32.272197790335895, 2.756558113584473],
            [32.27299392674803, 2.754149830887924],
            [32.274418679043144, 2.752198504334713],
            [32.27903902267152, 2.749036660809355],
            [32.28036451741594, 2.7475868836316],
            [32.28080962545272, 2.746222017336373],
            [32.28036700215601, 2.742239206525817],
            [32.280881478099026, 2.741665063199322],
            [32.280768002912346, 2.740372479255874],
            [32.28174024954435, 2.738534823045637],
            [32.28311188894827, 2.737538648374196],
            [32.28388798843802, 2.738021321272709],
            [32.2858061026737, 2.738266642063421],
            [32.29082023448497, 2.738355103147921],
            [32.299064928145164, 2.7365897358757],
            [32.30081321048649, 2.736615181248927],
            [32.30497090557385, 2.737556123099262],
            [32.30665914272496, 2.738937285977563],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 507,
        District: "GULU",
        County: "GULU MUNICIPALITY",
        Subcounty: "LAYIBI DIVISION",
        Population: 37205,
        Key: "GULULAYIBI DIVISION",
        Dist2: "Gulu",
        "Sub Country": "Layibi Div",
        id2_original: "Gulu Layibi Div",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.332064804211974, 2.773613124814952],
            [32.32295101207395, 2.774297719187036],
            [32.318309344237385, 2.774208869567675],
            [32.29812809489827, 2.771762476395744],
            [32.29854157954209, 2.768583503163967],
            [32.30031018357179, 2.762063825728182],
            [32.30445330349368, 2.750579796453716],
            [32.30665914272496, 2.738937285977563],
            [32.31091339233235, 2.742605364007922],
            [32.312559991671726, 2.743240076371377],
            [32.316585921873205, 2.743201509230313],
            [32.32189206723724, 2.744512956428969],
            [32.3260869579673, 2.743198001739795],
            [32.32776249114365, 2.74307685557755],
            [32.33015396633009, 2.74362759342999],
            [32.33086487687626, 2.748616836182459],
            [32.33441325997778, 2.75488273153176],
            [32.33605708352292, 2.756612180733108],
            [32.33620130894011, 2.757700501297495],
            [32.3357374072493, 2.762901364837449],
            [32.332344334775584, 2.765860062171865],
            [32.332064804211974, 2.773613124814952],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 508,
        District: "GULU",
        County: "GULU MUNICIPALITY",
        Subcounty: "PECE DIVISION",
        Population: 45466,
        Key: "GULUPECE DIVISION",
        Dist2: "Gulu",
        "Sub Country": "Pece Div",
        id2_original: "Gulu Pece Div",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.28029278694051, 2.643192506993266],
            [32.27867066309936, 2.643620778049291],
            [32.277191638188036, 2.642618399547553],
            [32.273861887958695, 2.6437324176108],
            [32.271500779422105, 2.642758120281996],
            [32.270904537025324, 2.640554428618825],
            [32.26918367665633, 2.639537589342402],
            [32.26858718722285, 2.637763128811634],
            [32.267876044911326, 2.637419324586811],
            [32.267316748425536, 2.636512700633899],
            [32.26733848136721, 2.632182503462543],
            [32.26500791555031, 2.627688610835057],
            [32.2635002685174, 2.627029581594377],
            [32.26298873006536, 2.625970528773011],
            [32.25905003436278, 2.622405661498039],
            [32.25720090894429, 2.621832265067654],
            [32.25609118683615, 2.621888826608771],
            [32.25066502655016, 2.618762539959147],
            [32.254065509226656, 2.613765631675026],
            [32.2554780893497, 2.610136580232624],
            [32.257600539769776, 2.6080269236338],
            [32.25870149971063, 2.605492229856273],
            [32.25879255025291, 2.601717188799083],
            [32.261117528548766, 2.595050727151299],
            [32.26294255665975, 2.594041840464334],
            [32.25946528150118, 2.59077205637083],
            [32.263620164861734, 2.58838434880489],
            [32.26499824608458, 2.58666512452856],
            [32.265221258243734, 2.585123947693129],
            [32.26427798497461, 2.583905991669111],
            [32.263235725445995, 2.581023798991173],
            [32.26395033255956, 2.574492966054971],
            [32.261557095776844, 2.570123801037282],
            [32.26246697417531, 2.566812750664676],
            [32.262654386998086, 2.564293421750796],
            [32.26152958307465, 2.560915180049545],
            [32.26193713165105, 2.556019553831485],
            [32.26706259077717, 2.545680667701666],
            [32.27171424608307, 2.541271525352104],
            [32.272076001241246, 2.539918498084653],
            [32.27130425139414, 2.531105494284427],
            [32.271885162243954, 2.529070457586021],
            [32.27386670113197, 2.526266063135506],
            [32.276810673455834, 2.523814272881364],
            [32.28153748541167, 2.521770554536947],
            [32.28511496135198, 2.521035385958323],
            [32.287478745969786, 2.519298382861946],
            [32.28838765328941, 2.517527559803775],
            [32.28973591583475, 2.512434368554442],
            [32.29153132738912, 2.509816877866402],
            [32.294497515948265, 2.506616899177704],
            [32.29706146766928, 2.504522943861697],
            [32.30061436121182, 2.502426155511306],
            [32.30718768089543, 2.500103378857101],
            [32.31173619253873, 2.497585733092846],
            [32.315727360633666, 2.496094463720898],
            [32.320786414497356, 2.493250370921451],
            [32.32366377943784, 2.492131833918733],
            [32.32542787751805, 2.490359367664616],
            [32.329512524301485, 2.487468058308861],
            [32.336751355473424, 2.486538382578599],
            [32.33897831319873, 2.487006186661184],
            [32.34380297145194, 2.488875329078894],
            [32.3483499811121, 2.489250942666551],
            [32.352155009297036, 2.488786148590318],
            [32.35725991676606, 2.486921938536954],
            [32.36069477527356, 2.4843102018368],
            [32.36171651368782, 2.482350636211422],
            [32.36348143731977, 2.476198708557855],
            [32.3701044859409, 2.476709985556757],
            [32.376396247563285, 2.47775488699844],
            [32.379321370537546, 2.478785598540106],
            [32.385313104736525, 2.481804112255176],
            [32.389486999143415, 2.483110750169711],
            [32.39362705221692, 2.483041652019196],
            [32.39546021816608, 2.482205438645018],
            [32.3995089125752, 2.479265198181249],
            [32.40331003398697, 2.474614115945192],
            [32.40362155355781, 2.472939522278229],
            [32.40545793278075, 2.469662890835359],
            [32.40537618878484, 2.468502455591345],
            [32.40578196139192, 2.467521766214677],
            [32.40733100638639, 2.465608699529553],
            [32.40864035032034, 2.465035316849751],
            [32.40799905561543, 2.464197516139818],
            [32.408166082969444, 2.463838737649089],
            [32.410642121963484, 2.462620090893412],
            [32.41345303672576, 2.460037893808308],
            [32.41384653834609, 2.459332337493414],
            [32.413586107762065, 2.458351228519432],
            [32.41487413736928, 2.455887696509678],
            [32.414637466326184, 2.454930522880304],
            [32.4154486117901, 2.453256245504954],
            [32.417709764785016, 2.452587731402166],
            [32.418710048735335, 2.451822731095168],
            [32.420209001872934, 2.451799735531446],
            [32.42212646393172, 2.450138095441353],
            [32.42320023995377, 2.44774619538296],
            [32.42403334653142, 2.447459599861538],
            [32.42508493147101, 2.445838457527975],
            [32.42542934285598, 2.446768569170299],
            [32.424833186697455, 2.447797001713229],
            [32.424996904658, 2.449974339564973],
            [32.42566218707594, 2.450668584322682],
            [32.42567082527572, 2.453168821708144],
            [32.42650284579018, 2.453719622316471],
            [32.42635893927493, 2.454604777645684],
            [32.427095418569024, 2.455442634640797],
            [32.42709435226881, 2.456256102719104],
            [32.42764114061257, 2.456591397739224],
            [32.42811502977272, 2.458098997420778],
            [32.429497214499776, 2.458877148618779],
            [32.42999109746323, 2.460827673510108],
            [32.429359391375634, 2.46174842650848],
            [32.42983350241967, 2.463088547810927],
            [32.4296427002533, 2.463447319323868],
            [32.42752296723694, 2.465120802201028],
            [32.42894933919452, 2.466030854229664],
            [32.429232802582426, 2.467610124247013],
            [32.430587681219805, 2.468615829063787],
            [32.43106372184507, 2.468472573938059],
            [32.43120759871592, 2.467611335848091],
            [32.432944405079496, 2.467660253119622],
            [32.43442055628023, 2.466895533394756],
            [32.43461054996281, 2.467158827890958],
            [32.43535551025154, 2.470640468862715],
            [32.43671055148396, 2.471526543635904],
            [32.4376357335816, 2.473632565016406],
            [32.43653673017143, 2.477125042180004],
            [32.43734463092052, 2.477939006763073],
            [32.437723769377754, 2.479135517610212],
            [32.438757538928634, 2.480081208586117],
            [32.44006093062551, 2.484101513790027],
            [32.44013131991621, 2.484867184776256],
            [32.439702333045545, 2.485417212086484],
            [32.43984269750365, 2.487259571794454],
            [32.440388915417195, 2.488049449262296],
            [32.44017195071653, 2.490226554228633],
            [32.43969484648597, 2.491183292249409],
            [32.44018174953964, 2.491841541439456],
            [32.43972781016533, 2.493276806647178],
            [32.43979716998672, 2.494832009154355],
            [32.44136563565932, 2.496292441341677],
            [32.44149020234483, 2.498403545926057],
            [32.44105179124851, 2.500383775912367],
            [32.439563686166295, 2.501263323237465],
            [32.43841699928252, 2.505290484027392],
            [32.437627431351764, 2.505187669592891],
            [32.43665921186718, 2.50590455604209],
            [32.43676062357791, 2.507031793805325],
            [32.43591995767715, 2.507287608077679],
            [32.435231824813314, 2.508235179626459],
            [32.43523131816348, 2.509413614226558],
            [32.43413581997958, 2.509951114475771],
            [32.43270881201475, 2.511385104328148],
            [32.43209770968655, 2.510898095365246],
            [32.43165153534955, 2.511884190123026],
            [32.43040307653062, 2.51270342277012],
            [32.43004596745907, 2.513881690901379],
            [32.42892492298511, 2.514598512453196],
            [32.42915328730675, 2.516596817677859],
            [32.42854203316323, 2.516468460940208],
            [32.427267936426105, 2.517671934989429],
            [32.426223558670024, 2.517799563778156],
            [32.42619780127588, 2.51843999961556],
            [32.42522999501633, 2.518183399569132],
            [32.4226443525745, 2.518861120565555],
            [32.42119254751459, 2.518706766793626],
            [32.42019888235126, 2.519321159170102],
            [32.419969341236595, 2.520012737046647],
            [32.419026929451825, 2.519935468691657],
            [32.41780374114014, 2.521190198048945],
            [32.41663215026177, 2.52095910485452],
            [32.416173417477076, 2.521522496135853],
            [32.41520552318264, 2.521470817632879],
            [32.41469638233409, 2.520830139180907],
            [32.41407200110937, 2.521559969869805],
            [32.41346081254287, 2.521277893750789],
            [32.41198328242816, 2.521712727645583],
            [32.41147432932753, 2.520636536734554],
            [32.411092206666915, 2.520764456005289],
            [32.410812226945694, 2.520303210845381],
            [32.409742008252174, 2.521224965993655],
            [32.40757745918459, 2.52007117158482],
            [32.406685707890254, 2.52063434965839],
            [32.4059726476756, 2.520326611758613],
            [32.40505558544981, 2.520531136171227],
            [32.40439171608181, 2.52406610010903],
            [32.40267041553837, 2.525531632104808],
            [32.40255010417234, 2.526526056610649],
            [32.40347835132175, 2.527882579047897],
            [32.40371733462834, 2.529449734643596],
            [32.403086812520314, 2.532282180612276],
            [32.40388049293845, 2.533051010191603],
            [32.40373045631971, 2.533533104571021],
            [32.40477895105471, 2.534015762361285],
            [32.404508524018226, 2.535673097447642],
            [32.405646764043354, 2.536487276899193],
            [32.40540656621449, 2.537572043107035],
            [32.40429792747458, 2.537541396619372],
            [32.40148056730012, 2.539227677487305],
            [32.401420465516054, 2.539619416015569],
            [32.40007193257783, 2.53998040927762],
            [32.39966669177337, 2.541562339898419],
            [32.400025827444196, 2.542496708575381],
            [32.39918678839241, 2.542616861116171],
            [32.399036595466804, 2.543430444784788],
            [32.39942577619059, 2.544153885604722],
            [32.39930558340221, 2.544907213107097],
            [32.39903575733865, 2.545238573577179],
            [32.397627419958695, 2.54532831827582],
            [32.396503372416745, 2.546186654989057],
            [32.396263011992765, 2.547602903931199],
            [32.3971311699345, 2.549290900985782],
            [32.397010428275486, 2.551189387756099],
            [32.39584146676592, 2.551972359351391],
            [32.39570622180665, 2.552861291989067],
            [32.39456743291086, 2.553192250160335],
            [32.394147482193624, 2.554186518757702],
            [32.39447661503227, 2.555181136580075],
            [32.39369747654194, 2.555331444906915],
            [32.393247455618905, 2.556536660586521],
            [32.39248320760273, 2.556882841659482],
            [32.39203284531986, 2.55881130807466],
            [32.3906545107721, 2.558780510428666],
            [32.389515452381715, 2.559684027691927],
            [32.38890038758478, 2.561386387295445],
            [32.38912403036131, 2.563661727057062],
            [32.38723588302517, 2.564534741310955],
            [32.38485267683091, 2.566748542487298],
            [32.385690507648626, 2.569189920022775],
            [32.386859004729196, 2.569401430216233],
            [32.387278108335096, 2.570245424541238],
            [32.38829664874696, 2.570758221564143],
            [32.38941941349469, 2.572642221938623],
            [32.39176023627552, 2.573272102116034],
            [32.3931349146801, 2.575014768656096],
            [32.39484147386974, 2.575220528190065],
            [32.39513397700436, 2.576130104789854],
            [32.39577071275921, 2.576284114254101],
            [32.39592283257109, 2.57779564073879],
            [32.39768001452195, 2.578693103215053],
            [32.39951255793863, 2.581844976312926],
            [32.3991813158557, 2.582049761957162],
            [32.39971563827829, 2.583330913041819],
            [32.40017416445044, 2.583279893025061],
            [32.40336041060976, 2.585118438547894],
            [32.40498492846115, 2.587143155055313],
            [32.40526826428829, 2.588155268004295],
            [32.406570896908754, 2.588843507291499],
            [32.40703439345935, 2.590841728483614],
            [32.408427151357344, 2.59190624911379],
            [32.40791082937643, 2.592554715575244],
            [32.40790865725008, 2.593799701796358],
            [32.40611169610181, 2.59532247509029],
            [32.404339454793536, 2.598150812367367],
            [32.4036933585934, 2.598441231667493],
            [32.40320566861555, 2.599690724169696],
            [32.40351705433743, 2.600721095246005],
            [32.403087865345846, 2.602293452596823],
            [32.40253780174452, 2.602759933208175],
            [32.40285163896882, 2.603521231671869],
            [32.40458625703636, 2.604807394454612],
            [32.4053538872096, 2.60627915780942],
            [32.40448500612408, 2.613826996361562],
            [32.40122475136172, 2.61569830018721],
            [32.398984986355394, 2.61641069264437],
            [32.397322056542485, 2.61638759590804],
            [32.39488225199374, 2.618103201804153],
            [32.39073649731313, 2.617030975988619],
            [32.3899608379979, 2.616250239505859],
            [32.3882759398847, 2.615803495475052],
            [32.38752248512669, 2.614955880995511],
            [32.387212474725494, 2.614130778526913],
            [32.38741343234612, 2.611232406817776],
            [32.38530799152594, 2.609291628055381],
            [32.3847545817002, 2.607440790324656],
            [32.38504364069402, 2.605768741565412],
            [32.386020130069085, 2.603896362245254],
            [32.386502651140816, 2.599475055129443],
            [32.37612184009179, 2.596794808587908],
            [32.37226489287668, 2.596157161479279],
            [32.37113121898812, 2.5929909485816],
            [32.37133807225196, 2.592082877329219],
            [32.37053871358293, 2.591122401040869],
            [32.36941656148619, 2.590745600207152],
            [32.36763717228321, 2.588980251064969],
            [32.36305894796357, 2.586136651845541],
            [32.36040125614435, 2.586550470905721],
            [32.35918783970635, 2.588106727694915],
            [32.359522795424645, 2.589015068325752],
            [32.3594451576279, 2.589482094969483],
            [32.35890325252601, 2.589637508139815],
            [32.35913385634764, 2.591431761511198],
            [32.358573028234304, 2.592276864748682],
            [32.35757942235981, 2.592635006474],
            [32.35751470233682, 2.594697191537547],
            [32.35810054134432, 2.594748727993678],
            [32.35835497297886, 2.59533806820584],
            [32.35797264729899, 2.595798983958357],
            [32.35858386191663, 2.596055476049846],
            [32.35868502030248, 2.597515732485224],
            [32.358659321298816, 2.597951217149381],
            [32.35797141660707, 2.598232668859318],
            [32.357868778695966, 2.599718435595783],
            [32.35590733691748, 2.599794282160752],
            [32.355664858266124, 2.600754823649412],
            [32.35311739063058, 2.601137771310476],
            [32.35250553371752, 2.602136548624967],
            [32.35283654583172, 2.602392889564661],
            [32.35265806765277, 2.602725827955199],
            [32.35176652027598, 2.602725366697479],
            [32.351944545704065, 2.603289043267643],
            [32.350696172225085, 2.603698280932476],
            [32.34993142654222, 2.604773828586763],
            [32.348523160129204, 2.605564125778131],
            [32.348754848217396, 2.606576204226237],
            [32.348186450899476, 2.608080882484078],
            [32.348572959135296, 2.609067104375576],
            [32.347926647339534, 2.611557751912752],
            [32.34623642670827, 2.612010955015582],
            [32.34466192615357, 2.613229670928642],
            [32.34381091166075, 2.612398899462514],
            [32.343372077457936, 2.612813830740626],
            [32.342804600913176, 2.612528108061389],
            [32.34203023517197, 2.613150442943758],
            [32.34125571402218, 2.614084158714076],
            [32.341668248248446, 2.614629275962084],
            [32.34089388789712, 2.615251608007792],
            [32.341280580287574, 2.615874567012832],
            [32.34079019536386, 2.616185678473903],
            [32.34117692817852, 2.616730784040075],
            [32.340737860413725, 2.617586821904317],
            [32.34009267241036, 2.617871913472109],
            [32.33965331538806, 2.619272850415292],
            [32.33900821901287, 2.619402247652412],
            [32.33838832127969, 2.620647412814721],
            [32.336685595201374, 2.620361083499795],
            [32.33652369183769, 2.62127491613781],
            [32.336016011649825, 2.620911035769555],
            [32.33444448721368, 2.622178784557404],
            [32.3351577270914, 2.623663189480443],
            [32.33506207088667, 2.624524818622134],
            [32.333514980626276, 2.624595802619663],
            [32.331206657994095, 2.623924362867695],
            [32.33034968677263, 2.624187193648754],
            [32.32983817077849, 2.623815917077822],
            [32.32648114140889, 2.62589650096767],
            [32.324886479065995, 2.625919572402112],
            [32.32414833968524, 2.626493630115358],
            [32.323017744323174, 2.626600723333952],
            [32.322898315102755, 2.627390542828719],
            [32.32087532884586, 2.627245822910223],
            [32.31918472732894, 2.628609230310102],
            [32.31842304040962, 2.628728488094839],
            [32.31877969852689, 2.629374945188936],
            [32.31768446983755, 2.630092415246334],
            [32.31674434516346, 2.630079929253919],
            [32.315029747848655, 2.631802355199727],
            [32.31379216942443, 2.63168199304909],
            [32.31319681456315, 2.632280049100751],
            [32.31317267323822, 2.632902366976771],
            [32.311720693905144, 2.633140914916209],
            [32.31155340154808, 2.634385475015938],
            [32.31077929362337, 2.635426241362477],
            [32.311444909316265, 2.636910627831033],
            [32.31006364985396, 2.638369927642274],
            [32.309325710797516, 2.638561004037121],
            [32.30894402471811, 2.640140537624903],
            [32.30792059118293, 2.640116027085477],
            [32.30706341514555, 2.640737877106517],
            [32.30634993092609, 2.639756113170761],
            [32.30477947638345, 2.639013223707984],
            [32.30368447406954, 2.639299837692272],
            [32.303018221471106, 2.638988305743732],
            [32.30254191853779, 2.639490681527377],
            [32.29950813265183, 2.638016930995648],
            [32.2973886790115, 2.640098122923147],
            [32.295794817067524, 2.638685015097225],
            [32.29448596541035, 2.638325229988411],
            [32.29245055275811, 2.63910197824775],
            [32.29235509238615, 2.639556692388689],
            [32.291236750044526, 2.639029470457313],
            [32.29066543410024, 2.639196693959925],
            [32.290284892474546, 2.638717769736828],
            [32.28926070255787, 2.64003363042679],
            [32.28772594706462, 2.639326648187486],
            [32.286535838314954, 2.639445638429342],
            [32.28573776603341, 2.640749665742276],
            [32.28492833186013, 2.641108227046054],
            [32.284070811768, 2.642304508373935],
            [32.28044121826985, 2.642218620231656],
            [32.28029278694051, 2.643192506993266],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 509,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "BOBI",
        Population: 28912,
        Key: "OMOROBOBI",
        Dist2: "Gulu",
        "Sub Country": "Bobi",
        id2_original: "Gulu Bobi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.47958070446432, 2.785702080250296],
            [32.47772579030213, 2.786193639712866],
            [32.475126783623786, 2.785455080625332],
            [32.47360155296749, 2.786876941919129],
            [32.47240124923769, 2.786020371102402],
            [32.47163031506085, 2.785936296652007],
            [32.46974744173377, 2.786829013362836],
            [32.46626466619071, 2.786923412437608],
            [32.46450706831989, 2.785652773464403],
            [32.46378994682184, 2.783333889672064],
            [32.46159164625241, 2.78328191165715],
            [32.4607091422156, 2.784974377631471],
            [32.45597176966526, 2.78610317593315],
            [32.454548473539205, 2.788914274769568],
            [32.45404071789285, 2.79309834031897],
            [32.45295689241773, 2.793788538346167],
            [32.450701435640035, 2.79370803280509],
            [32.44725757421677, 2.791123542251171],
            [32.44571558998044, 2.790869417806591],
            [32.445056813161784, 2.78938122937263],
            [32.44425712930258, 2.789153958380204],
            [32.44415606344323, 2.788366335838958],
            [32.44332670104369, 2.787365605457362],
            [32.44181377820512, 2.787455185346448],
            [32.43984215851446, 2.786227998235567],
            [32.439583685359445, 2.785168590999648],
            [32.43841259124943, 2.784741662145194],
            [32.43806884551608, 2.783940295190229],
            [32.438524740522766, 2.783337566625254],
            [32.437079347637344, 2.78077690419589],
            [32.43182299588951, 2.778354313660214],
            [32.4298202037602, 2.775293619930499],
            [32.42803445179005, 2.774252192988542],
            [32.42646453623657, 2.774399204945289],
            [32.42321321791467, 2.776584339093424],
            [32.422686834802604, 2.777803198903897],
            [32.42171665609238, 2.778120656539578],
            [32.42020629884227, 2.779986477505637],
            [32.41700819042958, 2.779478422946527],
            [32.41635228821983, 2.779967021360991],
            [32.41315135819885, 2.77748216111546],
            [32.411046644115736, 2.772974901518207],
            [32.40839112621951, 2.772580123493864],
            [32.40636800701194, 2.775220675247251],
            [32.403962015948814, 2.779652708215091],
            [32.40216464606709, 2.780459149385082],
            [32.3981965332339, 2.78049720746847],
            [32.39644228518079, 2.781518415498828],
            [32.394815062502076, 2.78152226383378],
            [32.3933317508302, 2.782356598526659],
            [32.392018300697096, 2.782187809353156],
            [32.39046907693789, 2.783020576966465],
            [32.38979541054341, 2.783050539925712],
            [32.38853333146811, 2.782301076306149],
            [32.38535855859159, 2.778597362346159],
            [32.38470953388366, 2.777145237247094],
            [32.38398771509499, 2.776854502458164],
            [32.38297761525352, 2.775583659725918],
            [32.38160218945066, 2.775600302130924],
            [32.375127338596926, 2.779511825187444],
            [32.36994162856641, 2.780327892235787],
            [32.3626000049731, 2.779518150859508],
            [32.352611437903, 2.776275754058002],
            [32.34584034063486, 2.774626857426244],
            [32.332064804211974, 2.773613124814952],
            [32.332344334775584, 2.765860062171865],
            [32.3357374072493, 2.762901364837449],
            [32.33620130894011, 2.757700501297495],
            [32.33605708352292, 2.756612180733108],
            [32.33441325997778, 2.75488273153176],
            [32.33086487687626, 2.748616836182459],
            [32.33015396633009, 2.74362759342999],
            [32.32776249114365, 2.74307685557755],
            [32.3260869579673, 2.743198001739795],
            [32.32189206723724, 2.744512956428969],
            [32.316585921873205, 2.743201509230313],
            [32.312559991671726, 2.743240076371377],
            [32.31091339233235, 2.742605364007922],
            [32.30665914272496, 2.738937285977563],
            [32.30497090557385, 2.737556123099262],
            [32.30081321048649, 2.736615181248927],
            [32.299064928145164, 2.7365897358757],
            [32.29082023448497, 2.738355103147921],
            [32.2858061026737, 2.738266642063421],
            [32.28388798843802, 2.738021321272709],
            [32.28311188894827, 2.737538648374196],
            [32.282956581015455, 2.734528763833773],
            [32.282300438955524, 2.733178407137566],
            [32.280987089433715, 2.732229778323654],
            [32.28081607266149, 2.731626498637788],
            [32.28197393279076, 2.729860772416875],
            [32.28206045941725, 2.728453409686506],
            [32.282574947038356, 2.727850538169524],
            [32.28249090784689, 2.725064415852522],
            [32.28362245452485, 2.719478538886655],
            [32.28659830087163, 2.710432702131536],
            [32.29024392121273, 2.703785585799153],
            [32.29055963950924, 2.701143285643296],
            [32.29294867307474, 2.69412200146852],
            [32.292049945463916, 2.692412473718124],
            [32.28888101253502, 2.689854309918103],
            [32.28859616574159, 2.688532898666882],
            [32.28886879005728, 2.686307073784692],
            [32.28701397381145, 2.683347548327522],
            [32.288258983099695, 2.678910630477105],
            [32.28988814254615, 2.676958446567131],
            [32.28980366318021, 2.674861645699206],
            [32.28920496029785, 2.672965598186354],
            [32.28633577990792, 2.670737927887106],
            [32.28482216177331, 2.670478544687939],
            [32.28319510707959, 2.668811682072953],
            [32.28196717656152, 2.66843756532193],
            [32.281667655787906, 2.667791135794439],
            [32.28161251809409, 2.664344393982122],
            [32.281155829875, 2.663855835731781],
            [32.28110688516674, 2.662336302029739],
            [32.2807087680025, 2.661906841293124],
            [32.28124972268682, 2.661363478442265],
            [32.28144947566667, 2.660362080760943],
            [32.28258797081334, 2.659819059118651],
            [32.28227551609628, 2.658874595132091],
            [32.282873401511715, 2.658274026766641],
            [32.28256108783013, 2.657100638794362],
            [32.2830168983952, 2.656156613326486],
            [32.282476418021346, 2.655898769601912],
            [32.282448903522514, 2.654267703255491],
            [32.281567005848544, 2.653952424138597],
            [32.28171070036139, 2.651491638184194],
            [32.28235193577749, 2.649732188655707],
            [32.280874123591786, 2.64661231891056],
            [32.281699769661, 2.645782969551993],
            [32.28093212241979, 2.644723769369447],
            [32.28145907955537, 2.64373686492282],
            [32.28029278694051, 2.643192506993266],
            [32.28044121826985, 2.642218620231656],
            [32.284070811768, 2.642304508373935],
            [32.28492833186013, 2.641108227046054],
            [32.28573776603341, 2.640749665742276],
            [32.286535838314954, 2.639445638429342],
            [32.28772594706462, 2.639326648187486],
            [32.28926070255787, 2.64003363042679],
            [32.290284892474546, 2.638717769736828],
            [32.29066543410024, 2.639196693959925],
            [32.291236750044526, 2.639029470457313],
            [32.29235509238615, 2.639556692388689],
            [32.29245055275811, 2.63910197824775],
            [32.29448596541035, 2.638325229988411],
            [32.295794817067524, 2.638685015097225],
            [32.2973886790115, 2.640098122923147],
            [32.29950813265183, 2.638016930995648],
            [32.30254191853779, 2.639490681527377],
            [32.303018221471106, 2.638988305743732],
            [32.30368447406954, 2.639299837692272],
            [32.30477947638345, 2.639013223707984],
            [32.30634993092609, 2.639756113170761],
            [32.30706341514555, 2.640737877106517],
            [32.30792059118293, 2.640116027085477],
            [32.30894402471811, 2.640140537624903],
            [32.309325710797516, 2.638561004037121],
            [32.31006364985396, 2.638369927642274],
            [32.311444909316265, 2.636910627831033],
            [32.31077929362337, 2.635426241362477],
            [32.31155340154808, 2.634385475015938],
            [32.311720693905144, 2.633140914916209],
            [32.31317267323822, 2.632902366976771],
            [32.31319681456315, 2.632280049100751],
            [32.31379216942443, 2.63168199304909],
            [32.315029747848655, 2.631802355199727],
            [32.31674434516346, 2.630079929253919],
            [32.31768446983755, 2.630092415246334],
            [32.31877969852689, 2.629374945188936],
            [32.31842304040962, 2.628728488094839],
            [32.31918472732894, 2.628609230310102],
            [32.32087532884586, 2.627245822910223],
            [32.322898315102755, 2.627390542828719],
            [32.323017744323174, 2.626600723333952],
            [32.32414833968524, 2.626493630115358],
            [32.324886479065995, 2.625919572402112],
            [32.32648114140889, 2.62589650096767],
            [32.32983817077849, 2.623815917077822],
            [32.33034968677263, 2.624187193648754],
            [32.331206657994095, 2.623924362867695],
            [32.333514980626276, 2.624595802619663],
            [32.33506207088667, 2.624524818622134],
            [32.3351577270914, 2.623663189480443],
            [32.33444448721368, 2.622178784557404],
            [32.336016011649825, 2.620911035769555],
            [32.33652369183769, 2.62127491613781],
            [32.3364676100145, 2.622084122292514],
            [32.336824403777364, 2.622491222566782],
            [32.33638327168407, 2.624034843890924],
            [32.33778690458686, 2.625208443473004],
            [32.33849999893748, 2.62698007811075],
            [32.33852357432381, 2.62741093558335],
            [32.33730912751817, 2.628535260990277],
            [32.33735628996889, 2.6293730391761],
            [32.3383910728194, 2.630438740407785],
            [32.339224157837485, 2.630343434458069],
            [32.33969980589895, 2.631037823645243],
            [32.34086612097167, 2.630918767091837],
            [32.34131800589895, 2.63154134229472],
            [32.34253166398376, 2.631901019885268],
            [32.342793159071384, 2.632523494092437],
            [32.34411367714915, 2.633349980726051],
            [32.34401791134999, 2.634427039209635],
            [32.3450648663726, 2.634978116861128],
            [32.345040389077724, 2.636270632081977],
            [32.34384957335393, 2.637730089682652],
            [32.3442059323322, 2.638974940425191],
            [32.343574621503365, 2.640087620200672],
            [32.343788224708256, 2.641236652867929],
            [32.343383087210064, 2.642217799146992],
            [32.343668415500474, 2.642768474020136],
            [32.34231068740703, 2.644778362861565],
            [32.3424650503122, 2.645436676481804],
            [32.34322618117431, 2.646394514175107],
            [32.34424953745441, 2.646586548609619],
            [32.34689057720321, 2.648311324290976],
            [32.35191238601688, 2.648840572993759],
            [32.35243578941717, 2.649271684919675],
            [32.352768151699244, 2.650923431993291],
            [32.353552901965166, 2.652264258449222],
            [32.35509920350474, 2.653796965115037],
            [32.35756219177435, 2.654695845749633],
            [32.36098825308023, 2.657330578294272],
            [32.362035356324874, 2.65764229138101],
            [32.365521086426895, 2.660001787770657],
            [32.36640118836863, 2.661103291039182],
            [32.36667434089371, 2.662216451639556],
            [32.36643481141139, 2.665160437631551],
            [32.36709403828603, 2.667295439659231],
            [32.36974509874178, 2.672796184366856],
            [32.37136618323217, 2.674239265492584],
            [32.372277301305715, 2.674859757703194],
            [32.37442182333235, 2.674914784172217],
            [32.37633762440617, 2.676681493065487],
            [32.377731359671166, 2.677113534757763],
            [32.37810618801166, 2.678057248917884],
            [32.379419143173074, 2.679217102152418],
            [32.382420666065585, 2.680943933685653],
            [32.385034659337805, 2.680338700106582],
            [32.38894803961735, 2.681257238931166],
            [32.38991336383179, 2.680718568716469],
            [32.390101369542656, 2.67999080155101],
            [32.39157615081256, 2.679209760171075],
            [32.392475141629795, 2.677282720955098],
            [32.393950227428604, 2.675854683656171],
            [32.39794459172931, 2.675614044195091],
            [32.39781009686332, 2.67655750466671],
            [32.39872122212338, 2.677204946257887],
            [32.4013046888456, 2.680770801527226],
            [32.402778550240676, 2.681876796156793],
            [32.405593298114276, 2.681878175355107],
            [32.4083609859451, 2.683046218493374],
            [32.40894289302656, 2.683875975260646],
            [32.41027308326499, 2.688725647074353],
            [32.412111798107674, 2.691725278854774],
            [32.413190053129725, 2.692682846273443],
            [32.41547454255908, 2.69236493710015],
            [32.4171241593395, 2.692748550088468],
            [32.419254426899194, 2.694535402304676],
            [32.42081541679201, 2.69650742209809],
            [32.42311641725631, 2.700649392287017],
            [32.42274010939054, 2.702751935626006],
            [32.422939918964225, 2.705407396773541],
            [32.423314917984634, 2.706054571792742],
            [32.42417261684149, 2.706378474129777],
            [32.423904171488495, 2.707160129796643],
            [32.42433269842175, 2.707996034657076],
            [32.42371590975779, 2.708427062050125],
            [32.42468018923154, 2.710125881185056],
            [32.42457232312547, 2.711473726123971],
            [32.425496681468005, 2.712565966707234],
            [32.42782865225004, 2.713267989455428],
            [32.42825673900878, 2.715047423922309],
            [32.429596504389835, 2.716395958786533],
            [32.42938158515306, 2.717366345370967],
            [32.42994448208648, 2.717528368166239],
            [32.429837049866705, 2.717959642509231],
            [32.43070783987223, 2.718970981688253],
            [32.4311356283903, 2.721397412143893],
            [32.4321000165602, 2.722907515127194],
            [32.43148227029213, 2.725360407086559],
            [32.431857022275835, 2.726573694106812],
            [32.43161496583265, 2.728244979259566],
            [32.431105158434185, 2.729188268717687],
            [32.43168068657883, 2.731008201519717],
            [32.431840432189176, 2.73335363147469],
            [32.433179673852415, 2.735861360716333],
            [32.43308558520786, 2.736413959280104],
            [32.435015193387606, 2.737708858915012],
            [32.4365153933868, 2.740027969067266],
            [32.437975974987054, 2.741066542988537],
            [32.44132662631812, 2.742011652827372],
            [32.441621142577276, 2.742820535044374],
            [32.44229126421965, 2.743036511804946],
            [32.44263893738745, 2.744842867401935],
            [32.4434433625547, 2.744492782772484],
            [32.444005381834096, 2.746568817402104],
            [32.44484220743703, 2.746883532317922],
            [32.4461517175593, 2.748186437835249],
            [32.4513333285772, 2.748360133698462],
            [32.4524476859922, 2.749045025267435],
            [32.45604288120149, 2.747833036932763],
            [32.456395617274204, 2.745809467795145],
            [32.45827630140695, 2.745379473111242],
            [32.46029941881789, 2.745811247109163],
            [32.46132316676342, 2.745404795369668],
            [32.46227498301094, 2.746147253868926],
            [32.46396506081006, 2.746124080620675],
            [32.466572595195395, 2.743815405153095],
            [32.469119917303836, 2.743074516352995],
            [32.47402704179846, 2.747330922081702],
            [32.47408937769264, 2.75085467915022],
            [32.475374991730064, 2.751510493837984],
            [32.476948902989896, 2.754056475425918],
            [32.47613769823718, 2.755677161564626],
            [32.47682472078334, 2.756936069434493],
            [32.47637251695416, 2.76000269399159],
            [32.4769180350801, 2.762092789657578],
            [32.47607828456262, 2.763713544699231],
            [32.47670752297812, 2.764514196779872],
            [32.47582531089377, 2.76637858293502],
            [32.47636924978145, 2.767408646627994],
            [32.47620081656401, 2.769328581571004],
            [32.47720118585428, 2.770128333491161],
            [32.478243545095914, 2.770369315671351],
            [32.47850252130747, 2.771743868927766],
            [32.479987149011215, 2.771826196518177],
            [32.480332156877566, 2.773458390017459],
            [32.47910679643953, 2.774951162023848],
            [32.47965040923876, 2.775752026336436],
            [32.48030654590881, 2.775435278695336],
            [32.48050672558841, 2.775663991539704],
            [32.48036683723744, 2.777583864634364],
            [32.48122324072365, 2.777553125406397],
            [32.48148081107181, 2.777982241690293],
            [32.48118252548171, 2.778971383865715],
            [32.4807830231153, 2.779086959774376],
            [32.48144343217282, 2.781635170153468],
            [32.48078797103588, 2.782410306492427],
            [32.48101733428412, 2.78306869140964],
            [32.48070389950506, 2.783470551553544],
            [32.480304141118815, 2.783414225444588],
            [32.47929206228878, 2.784347809536472],
            [32.47958070446432, 2.785702080250296],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 510,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "KORO",
        Population: 28611,
        Key: "OMOROKORO",
        Dist2: "Gulu",
        "Sub Country": "Koro",
        id2_original: "Gulu Koro",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.450031267285254, 2.552775686734333],
              [32.44879070914926, 2.553665835722152],
              [32.44865917782535, 2.554325706338533],
              [32.44924013179429, 2.555004740170899],
              [32.4493329071019, 2.557286243079083],
              [32.4457051838962, 2.562414512676983],
              [32.444542927411895, 2.562660041476672],
              [32.439833487077046, 2.561919871548562],
              [32.43732539799029, 2.562595361946962],
              [32.435367529710035, 2.563886179802028],
              [32.43285845966299, 2.566775973741663],
              [32.42924891117211, 2.56849660151575],
              [32.4271082698675, 2.568126585600252],
              [32.425763033746364, 2.567203348246831],
              [32.42319437485329, 2.56652558982381],
              [32.421053546699085, 2.566586124896275],
              [32.415914678420755, 2.568675063705263],
              [32.406556837376215, 2.56756357275153],
              [32.39731971373622, 2.569958049990698],
              [32.39176023627552, 2.573272102116034],
              [32.38941941349469, 2.572642221938623],
              [32.38829664874696, 2.570758221564143],
              [32.387278108335096, 2.570245424541238],
              [32.386859004729196, 2.569401430216233],
              [32.385690507648626, 2.569189920022775],
              [32.38485267683091, 2.566748542487298],
              [32.38723588302517, 2.564534741310955],
              [32.38912403036131, 2.563661727057062],
              [32.38890038758478, 2.561386387295445],
              [32.389515452381715, 2.559684027691927],
              [32.3906545107721, 2.558780510428666],
              [32.39203284531986, 2.55881130807466],
              [32.39248320760273, 2.556882841659482],
              [32.393247455618905, 2.556536660586521],
              [32.39369747654194, 2.555331444906915],
              [32.39447661503227, 2.555181136580075],
              [32.394147482193624, 2.554186518757702],
              [32.39456743291086, 2.553192250160335],
              [32.39570622180665, 2.552861291989067],
              [32.39584146676592, 2.551972359351391],
              [32.397010428275486, 2.551189387756099],
              [32.3971311699345, 2.549290900985782],
              [32.396263011992765, 2.547602903931199],
              [32.396503372416745, 2.546186654989057],
              [32.397627419958695, 2.54532831827582],
              [32.39903575733865, 2.545238573577179],
              [32.39930558340221, 2.544907213107097],
              [32.39942577619059, 2.544153885604722],
              [32.399036595466804, 2.543430444784788],
              [32.39918678839241, 2.542616861116171],
              [32.400025827444196, 2.542496708575381],
              [32.39966669177337, 2.541562339898419],
              [32.40007193257783, 2.53998040927762],
              [32.401420465516054, 2.539619416015569],
              [32.40148056730012, 2.539227677487305],
              [32.40429792747458, 2.537541396619372],
              [32.40540656621449, 2.537572043107035],
              [32.405646764043354, 2.536487276899193],
              [32.404508524018226, 2.535673097447642],
              [32.40477895105471, 2.534015762361285],
              [32.40373045631971, 2.533533104571021],
              [32.40388049293845, 2.533051010191603],
              [32.403086812520314, 2.532282180612276],
              [32.40371733462834, 2.529449734643596],
              [32.40347835132175, 2.527882579047897],
              [32.40255010417234, 2.526526056610649],
              [32.40267041553837, 2.525531632104808],
              [32.40439171608181, 2.52406610010903],
              [32.40505558544981, 2.520531136171227],
              [32.4059726476756, 2.520326611758613],
              [32.406685707890254, 2.52063434965839],
              [32.40757745918459, 2.52007117158482],
              [32.409742008252174, 2.521224965993655],
              [32.410812226945694, 2.520303210845381],
              [32.411092206666915, 2.520764456005289],
              [32.41147432932753, 2.520636536734554],
              [32.41198328242816, 2.521712727645583],
              [32.41346081254287, 2.521277893750789],
              [32.41407200110937, 2.521559969869805],
              [32.41469638233409, 2.520830139180907],
              [32.41520552318264, 2.521470817632879],
              [32.416173417477076, 2.521522496135853],
              [32.41663215026177, 2.52095910485452],
              [32.41780374114014, 2.521190198048945],
              [32.419026929451825, 2.519935468691657],
              [32.419969341236595, 2.520012737046647],
              [32.42019888235126, 2.519321159170102],
              [32.42119254751459, 2.518706766793626],
              [32.4226443525745, 2.518861120565555],
              [32.42522999501633, 2.518183399569132],
              [32.42619780127588, 2.51843999961556],
              [32.426223558670024, 2.517799563778156],
              [32.427267936426105, 2.517671934989429],
              [32.42854203316323, 2.516468460940208],
              [32.42915328730675, 2.516596817677859],
              [32.42892492298511, 2.514598512453196],
              [32.43004596745907, 2.513881690901379],
              [32.43040307653062, 2.51270342277012],
              [32.43165153534955, 2.511884190123026],
              [32.43209770968655, 2.510898095365246],
              [32.43270881201475, 2.511385104328148],
              [32.43413581997958, 2.509951114475771],
              [32.43523131816348, 2.509413614226558],
              [32.435231824813314, 2.508235179626459],
              [32.43591995767715, 2.507287608077679],
              [32.43676062357791, 2.507031793805325],
              [32.43665921186718, 2.50590455604209],
              [32.437627431351764, 2.505187669592891],
              [32.43841699928252, 2.505290484027392],
              [32.440237030963914, 2.508019589463867],
              [32.44636021204517, 2.514362697500386],
              [32.44745473016711, 2.516156433146596],
              [32.44778529851357, 2.517488713755353],
              [32.44763174139723, 2.519205061828313],
              [32.445426461816346, 2.523905045741239],
              [32.44452090611105, 2.526991632411266],
              [32.4459074683285, 2.530873373491688],
              [32.447995008420015, 2.533564168461889],
              [32.45056670631373, 2.53584528304252],
              [32.45182665278852, 2.538010552813271],
              [32.45215707650622, 2.539701483566442],
              [32.452003407100435, 2.541674018977526],
              [32.45176092934738, 2.54283953434256],
              [32.45089450425585, 2.543735797212482],
              [32.451174295330844, 2.544683789986686],
              [32.45056243392624, 2.545938813058995],
              [32.452013053209974, 2.548987989977243],
              [32.450031267285254, 2.552775686734333],
            ],
          ],
          [
            [
              [32.436629088660744, 2.636974350551003],
              [32.43650901355165, 2.639343983433208],
              [32.43698438133875, 2.640804312353488],
              [32.43511375743889, 2.645674478106038],
              [32.43516021471213, 2.648211731247759],
              [32.43467187794726, 2.649085182199419],
              [32.43567021704502, 2.652029795346714],
              [32.43486007679593, 2.653968256115613],
              [32.434871254533014, 2.655560014415194],
              [32.433453933101895, 2.657988890619949],
              [32.4338343570483, 2.658874699224504],
              [32.433572208885465, 2.659592666400441],
              [32.43459497587074, 2.661172921541112],
              [32.43497503060957, 2.662872570039901],
              [32.43441362128625, 2.667384289081756],
              [32.43315179104431, 2.668077855274599],
              [32.43136654662228, 2.668268509814482],
              [32.43079497555645, 2.66896239316717],
              [32.42999754467199, 2.669093669637388],
              [32.429402035300484, 2.670074775843748],
              [32.42902047408695, 2.671654389387339],
              [32.42775817222947, 2.67335325797231],
              [32.42605463497243, 2.676978789151123],
              [32.42564889200973, 2.679348277921233],
              [32.42589820504381, 2.680652919888653],
              [32.425218314222704, 2.683919879817928],
              [32.42379542323685, 2.685818231755205],
              [32.42147680950478, 2.69239514639854],
              [32.42032673597239, 2.694346950297454],
              [32.419254426899194, 2.694535402304676],
              [32.4171241593395, 2.692748550088468],
              [32.41547454255908, 2.69236493710015],
              [32.413190053129725, 2.692682846273443],
              [32.412111798107674, 2.691725278854774],
              [32.41027308326499, 2.688725647074353],
              [32.40894289302656, 2.683875975260646],
              [32.4083609859451, 2.683046218493374],
              [32.405593298114276, 2.681878175355107],
              [32.402778550240676, 2.681876796156793],
              [32.4013046888456, 2.680770801527226],
              [32.39872122212338, 2.677204946257887],
              [32.39781009686332, 2.67655750466671],
              [32.39794459172931, 2.675614044195091],
              [32.393950227428604, 2.675854683656171],
              [32.392475141629795, 2.677282720955098],
              [32.39157615081256, 2.679209760171075],
              [32.390101369542656, 2.67999080155101],
              [32.38991336383179, 2.680718568716469],
              [32.38894803961735, 2.681257238931166],
              [32.385034659337805, 2.680338700106582],
              [32.382420666065585, 2.680943933685653],
              [32.379419143173074, 2.679217102152418],
              [32.37810618801166, 2.678057248917884],
              [32.377731359671166, 2.677113534757763],
              [32.37633762440617, 2.676681493065487],
              [32.37442182333235, 2.674914784172217],
              [32.372277301305715, 2.674859757703194],
              [32.37136618323217, 2.674239265492584],
              [32.36974509874178, 2.672796184366856],
              [32.36709403828603, 2.667295439659231],
              [32.36643481141139, 2.665160437631551],
              [32.36667434089371, 2.662216451639556],
              [32.36640118836863, 2.661103291039182],
              [32.365521086426895, 2.660001787770657],
              [32.362035356324874, 2.65764229138101],
              [32.36098825308023, 2.657330578294272],
              [32.35756219177435, 2.654695845749633],
              [32.35509920350474, 2.653796965115037],
              [32.353552901965166, 2.652264258449222],
              [32.352768151699244, 2.650923431993291],
              [32.35243578941717, 2.649271684919675],
              [32.35191238601688, 2.648840572993759],
              [32.34689057720321, 2.648311324290976],
              [32.34424953745441, 2.646586548609619],
              [32.34322618117431, 2.646394514175107],
              [32.3424650503122, 2.645436676481804],
              [32.34231068740703, 2.644778362861565],
              [32.343668415500474, 2.642768474020136],
              [32.343383087210064, 2.642217799146992],
              [32.343788224708256, 2.641236652867929],
              [32.343574621503365, 2.640087620200672],
              [32.3442059323322, 2.638974940425191],
              [32.34384957335393, 2.637730089682652],
              [32.345040389077724, 2.636270632081977],
              [32.3450648663726, 2.634978116861128],
              [32.34401791134999, 2.634427039209635],
              [32.34411367714915, 2.633349980726051],
              [32.342793159071384, 2.632523494092437],
              [32.34253166398376, 2.631901019885268],
              [32.34131800589895, 2.63154134229472],
              [32.34086612097167, 2.630918767091837],
              [32.33969980589895, 2.631037823645243],
              [32.339224157837485, 2.630343434458069],
              [32.3383910728194, 2.630438740407785],
              [32.33735628996889, 2.6293730391761],
              [32.33730912751817, 2.628535260990277],
              [32.33852357432381, 2.62741093558335],
              [32.33849999893748, 2.62698007811075],
              [32.33778690458686, 2.625208443473004],
              [32.33638327168407, 2.624034843890924],
              [32.336824403777364, 2.622491222566782],
              [32.3364676100145, 2.622084122292514],
              [32.33652369183769, 2.62127491613781],
              [32.336685595201374, 2.620361083499795],
              [32.33838832127969, 2.620647412814721],
              [32.33900821901287, 2.619402247652412],
              [32.33965331538806, 2.619272850415292],
              [32.34009267241036, 2.617871913472109],
              [32.340737860413725, 2.617586821904317],
              [32.34117692817852, 2.616730784040075],
              [32.34079019536386, 2.616185678473903],
              [32.341280580287574, 2.615874567012832],
              [32.34089388789712, 2.615251608007792],
              [32.341668248248446, 2.614629275962084],
              [32.34125571402218, 2.614084158714076],
              [32.34203023517197, 2.613150442943758],
              [32.342804600913176, 2.612528108061389],
              [32.343372077457936, 2.612813830740626],
              [32.34381091166075, 2.612398899462514],
              [32.34466192615357, 2.613229670928642],
              [32.34623642670827, 2.612010955015582],
              [32.347926647339534, 2.611557751912752],
              [32.348572959135296, 2.609067104375576],
              [32.348186450899476, 2.608080882484078],
              [32.348754848217396, 2.606576204226237],
              [32.348523160129204, 2.605564125778131],
              [32.34993142654222, 2.604773828586763],
              [32.350696172225085, 2.603698280932476],
              [32.351944545704065, 2.603289043267643],
              [32.35176652027598, 2.602725366697479],
              [32.35265806765277, 2.602725827955199],
              [32.35283654583172, 2.602392889564661],
              [32.35250553371752, 2.602136548624967],
              [32.35311739063058, 2.601137771310476],
              [32.355664858266124, 2.600754823649412],
              [32.35590733691748, 2.599794282160752],
              [32.357868778695966, 2.599718435595783],
              [32.35797141660707, 2.598232668859318],
              [32.358659321298816, 2.597951217149381],
              [32.35868502030248, 2.597515732485224],
              [32.35858386191663, 2.596055476049846],
              [32.35797264729899, 2.595798983958357],
              [32.35835497297886, 2.59533806820584],
              [32.35810054134432, 2.594748727993678],
              [32.35751470233682, 2.594697191537547],
              [32.35757942235981, 2.592635006474],
              [32.358573028234304, 2.592276864748682],
              [32.35913385634764, 2.591431761511198],
              [32.35890325252601, 2.589637508139815],
              [32.3594451576279, 2.589482094969483],
              [32.359522795424645, 2.589015068325752],
              [32.35918783970635, 2.588106727694915],
              [32.36040125614435, 2.586550470905721],
              [32.36305894796357, 2.586136651845541],
              [32.36763717228321, 2.588980251064969],
              [32.36941656148619, 2.590745600207152],
              [32.37053871358293, 2.591122401040869],
              [32.37133807225196, 2.592082877329219],
              [32.37113121898812, 2.5929909485816],
              [32.37226489287668, 2.596157161479279],
              [32.37612184009179, 2.596794808587908],
              [32.386502651140816, 2.599475055129443],
              [32.386020130069085, 2.603896362245254],
              [32.38504364069402, 2.605768741565412],
              [32.3847545817002, 2.607440790324656],
              [32.38530799152594, 2.609291628055381],
              [32.38741343234612, 2.611232406817776],
              [32.387212474725494, 2.614130778526913],
              [32.38752248512669, 2.614955880995511],
              [32.3882759398847, 2.615803495475052],
              [32.3899608379979, 2.616250239505859],
              [32.39073649731313, 2.617030975988619],
              [32.39488225199374, 2.618103201804153],
              [32.397322056542485, 2.61638759590804],
              [32.398984986355394, 2.61641069264437],
              [32.40122475136172, 2.61569830018721],
              [32.40448500612408, 2.613826996361562],
              [32.4053538872096, 2.60627915780942],
              [32.40458625703636, 2.604807394454612],
              [32.40285163896882, 2.603521231671869],
              [32.40253780174452, 2.602759933208175],
              [32.403087865345846, 2.602293452596823],
              [32.40351705433743, 2.600721095246005],
              [32.40320566861555, 2.599690724169696],
              [32.4036933585934, 2.598441231667493],
              [32.404339454793536, 2.598150812367367],
              [32.40611169610181, 2.59532247509029],
              [32.40790865725008, 2.593799701796358],
              [32.41168072175563, 2.595577663365503],
              [32.41397969292572, 2.597793568699466],
              [32.41432986071503, 2.599263752757183],
              [32.4160830065353, 2.60163620569301],
              [32.419610657418374, 2.602343454207904],
              [32.42272768748677, 2.605912150189449],
              [32.42424751926821, 2.607049667602809],
              [32.423153462880315, 2.612576451801999],
              [32.42182655867917, 2.615770688186344],
              [32.4227805623244, 2.618162366806026],
              [32.42359887005606, 2.618927157502802],
              [32.42309159680501, 2.619985339551795],
              [32.42353865328762, 2.622729590328635],
              [32.42414249902497, 2.623611883937159],
              [32.424862434944785, 2.6263758599594],
              [32.42733763940392, 2.626984614322375],
              [32.42772713094483, 2.627749205792382],
              [32.429868721768706, 2.629044035647342],
              [32.430253267185634, 2.630412918621592],
              [32.43229869695158, 2.63369311305008],
              [32.43275078759306, 2.634004493772148],
              [32.43341738873784, 2.633645750049913],
              [32.436629088660744, 2.636974350551003],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 511,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "LAKWANA",
        Population: 12580,
        Key: "OMOROLAKWANA",
        Dist2: "Gulu",
        "Sub Country": "Lakwana",
        id2_original: "Gulu Lakwana",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.61801457071885, 2.791859906697434],
            [32.61574144318119, 2.791380180733659],
            [32.613749096662, 2.792124273023389],
            [32.60985345271941, 2.794626871445162],
            [32.60477109476066, 2.794445392472512],
            [32.60143773420218, 2.795664105485984],
            [32.600185934548705, 2.796690913516184],
            [32.59931757538436, 2.796690615630732],
            [32.59564010437651, 2.795918919772318],
            [32.59069948350158, 2.792077906791301],
            [32.58625623195168, 2.790201632274728],
            [32.58474990723886, 2.788737285657979],
            [32.58164739035221, 2.787182490569252],
            [32.58088154872472, 2.786206342128748],
            [32.577204669706646, 2.783919416064247],
            [32.57420377653314, 2.783931169208713],
            [32.57315680893413, 2.783494220254584],
            [32.572134915111334, 2.784366991946106],
            [32.56991272025364, 2.785085243264353],
            [32.565111527792276, 2.78444145601345],
            [32.56359238861194, 2.783195361482978],
            [32.56188131448969, 2.783014964631513],
            [32.548794399614124, 2.777681235276749],
            [32.54789992732279, 2.7792474156532],
            [32.54529412758429, 2.781326556828989],
            [32.54431068165564, 2.781775589045804],
            [32.542191080691616, 2.781363868366526],
            [32.54045423031059, 2.781825444217796],
            [32.53418153183681, 2.788923690524579],
            [32.5305541841269, 2.790796927198461],
            [32.524599026631314, 2.791170434309176],
            [32.52196045904619, 2.790035875137929],
            [32.52134712260788, 2.791011481153454],
            [32.521397565706025, 2.792578028723147],
            [32.520247679921525, 2.794067035883966],
            [32.519838448800584, 2.795556345322701],
            [32.518101119617505, 2.797122155573163],
            [32.518317574973416, 2.798650242704723],
            [32.516683151399405, 2.798392759710839],
            [32.51614628404964, 2.799702247191027],
            [32.51509883585192, 2.800472230414752],
            [32.514791696466425, 2.802089987056895],
            [32.51554439124972, 2.803849423722407],
            [32.51625711549443, 2.809653541870665],
            [32.515950479165475, 2.810038627171153],
            [32.51536311212369, 2.809909975312376],
            [32.513780379407756, 2.808137351213057],
            [32.512145445590654, 2.809061170750673],
            [32.51114892378472, 2.810190702232911],
            [32.51005063902679, 2.81036999758637],
            [32.50946331510413, 2.810138623123411],
            [32.509106814192045, 2.807621773839141],
            [32.508366461362435, 2.80690240310721],
            [32.507344884644915, 2.806876289905966],
            [32.50632356754053, 2.806208159084579],
            [32.5052251372555, 2.806746991687753],
            [32.50362937088312, 2.805629201727843],
            [32.50204691394996, 2.803265905422714],
            [32.50120510179891, 2.800902936324081],
            [32.4993581682697, 2.800293744650828],
            [32.49767426189658, 2.800613023898194],
            [32.496073814403246, 2.799470951369321],
            [32.4958723806755, 2.798411405339283],
            [32.49342956407562, 2.797142466508559],
            [32.49242774220951, 2.79539728239935],
            [32.490458359323945, 2.795717252962475],
            [32.488400384585034, 2.794060593647929],
            [32.48742977198855, 2.79409161956408],
            [32.48614606776943, 2.794753693702948],
            [32.48500377993562, 2.794527287798634],
            [32.48425990121853, 2.793440415209463],
            [32.48401346369165, 2.790905515062768],
            [32.482699511400334, 2.790421673920268],
            [32.48149608871985, 2.787473688485398],
            [32.47958070446432, 2.785702080250296],
            [32.47929206228878, 2.784347809536472],
            [32.480304141118815, 2.783414225444588],
            [32.48070389950506, 2.783470551553544],
            [32.48101733428412, 2.78306869140964],
            [32.48078797103588, 2.782410306492427],
            [32.48144343217282, 2.781635170153468],
            [32.4807830231153, 2.779086959774376],
            [32.48118252548171, 2.778971383865715],
            [32.48148081107181, 2.777982241690293],
            [32.48122324072365, 2.777553125406397],
            [32.48036683723744, 2.777583864634364],
            [32.48050672558841, 2.775663991539704],
            [32.48030654590881, 2.775435278695336],
            [32.47965040923876, 2.775752026336436],
            [32.47910679643953, 2.774951162023848],
            [32.480332156877566, 2.773458390017459],
            [32.479987149011215, 2.771826196518177],
            [32.47850252130747, 2.771743868927766],
            [32.478243545095914, 2.770369315671351],
            [32.47720118585428, 2.770128333491161],
            [32.47620081656401, 2.769328581571004],
            [32.47636924978145, 2.767408646627994],
            [32.47582531089377, 2.76637858293502],
            [32.47670752297812, 2.764514196779872],
            [32.47607828456262, 2.763713544699231],
            [32.4769180350801, 2.762092789657578],
            [32.47637251695416, 2.76000269399159],
            [32.47682472078334, 2.756936069434493],
            [32.47613769823718, 2.755677161564626],
            [32.476948902989896, 2.754056475425918],
            [32.475374991730064, 2.751510493837984],
            [32.47408937769264, 2.75085467915022],
            [32.47402704179846, 2.747330922081702],
            [32.469119917303836, 2.743074516352995],
            [32.466572595195395, 2.743815405153095],
            [32.46396506081006, 2.746124080620675],
            [32.46227498301094, 2.746147253868926],
            [32.46132316676342, 2.745404795369668],
            [32.46029941881789, 2.745811247109163],
            [32.45827630140695, 2.745379473111242],
            [32.456395617274204, 2.745809467795145],
            [32.45604288120149, 2.747833036932763],
            [32.4524476859922, 2.749045025267435],
            [32.4513333285772, 2.748360133698462],
            [32.4461517175593, 2.748186437835249],
            [32.44484220743703, 2.746883532317922],
            [32.444005381834096, 2.746568817402104],
            [32.4434433625547, 2.744492782772484],
            [32.44263893738745, 2.744842867401935],
            [32.44229126421965, 2.743036511804946],
            [32.441621142577276, 2.742820535044374],
            [32.44132662631812, 2.742011652827372],
            [32.437975974987054, 2.741066542988537],
            [32.4365153933868, 2.740027969067266],
            [32.435015193387606, 2.737708858915012],
            [32.43308558520786, 2.736413959280104],
            [32.433179673852415, 2.735861360716333],
            [32.431840432189176, 2.73335363147469],
            [32.43168068657883, 2.731008201519717],
            [32.431105158434185, 2.729188268717687],
            [32.43161496583265, 2.728244979259566],
            [32.431857022275835, 2.726573694106812],
            [32.43148227029213, 2.725360407086559],
            [32.4321000165602, 2.722907515127194],
            [32.4311356283903, 2.721397412143893],
            [32.43070783987223, 2.718970981688253],
            [32.429837049866705, 2.717959642509231],
            [32.42994448208648, 2.717528368166239],
            [32.42938158515306, 2.717366345370967],
            [32.429596504389835, 2.716395958786533],
            [32.42825673900878, 2.715047423922309],
            [32.42782865225004, 2.713267989455428],
            [32.425496681468005, 2.712565966707234],
            [32.42457232312547, 2.711473726123971],
            [32.42468018923154, 2.710125881185056],
            [32.42371590975779, 2.708427062050125],
            [32.42433269842175, 2.707996034657076],
            [32.423904171488495, 2.707160129796643],
            [32.42417261684149, 2.706378474129777],
            [32.423314917984634, 2.706054571792742],
            [32.422939918964225, 2.705407396773541],
            [32.42274010939054, 2.702751935626006],
            [32.42311641725631, 2.700649392287017],
            [32.42081541679201, 2.69650742209809],
            [32.419254426899194, 2.694535402304676],
            [32.42032673597239, 2.694346950297454],
            [32.42147680950478, 2.69239514639854],
            [32.42379542323685, 2.685818231755205],
            [32.425218314222704, 2.683919879817928],
            [32.42589820504381, 2.680652919888653],
            [32.42564889200973, 2.679348277921233],
            [32.42605463497243, 2.676978789151123],
            [32.42775817222947, 2.67335325797231],
            [32.42902047408695, 2.671654389387339],
            [32.429402035300484, 2.670074775843748],
            [32.42999754467199, 2.669093669637388],
            [32.43079497555645, 2.66896239316717],
            [32.43136654662228, 2.668268509814482],
            [32.43315179104431, 2.668077855274599],
            [32.43441362128625, 2.667384289081756],
            [32.43497503060957, 2.662872570039901],
            [32.43459497587074, 2.661172921541112],
            [32.433572208885465, 2.659592666400441],
            [32.4338343570483, 2.658874699224504],
            [32.433453933101895, 2.657988890619949],
            [32.434871254533014, 2.655560014415194],
            [32.43486007679593, 2.653968256115613],
            [32.43567021704502, 2.652029795346714],
            [32.43467187794726, 2.649085182199419],
            [32.43516021471213, 2.648211731247759],
            [32.43511375743889, 2.645674478106038],
            [32.43698438133875, 2.640804312353488],
            [32.43650901355165, 2.639343983433208],
            [32.436629088660744, 2.636974350551003],
            [32.43821551614744, 2.638169358012961],
            [32.43909136815957, 2.638242395297813],
            [32.440824574075506, 2.6393690790681],
            [32.44260539698969, 2.638898222201753],
            [32.44685498523904, 2.639373358588994],
            [32.44937177271268, 2.640041301075774],
            [32.453934266633375, 2.64245965027688],
            [32.45794863551717, 2.64278407462125],
            [32.45948843594906, 2.64371686278693],
            [32.46066359852899, 2.646915245985333],
            [32.46067008616199, 2.648399461682286],
            [32.45961347425008, 2.651353083199415],
            [32.46036714101051, 2.65483948116186],
            [32.46037397629152, 2.657053653575024],
            [32.45710714765791, 2.659310795110036],
            [32.45710609034082, 2.661727119930282],
            [32.45579567471675, 2.665447587552324],
            [32.456009310260995, 2.666783203508775],
            [32.461650762584625, 2.666240001639395],
            [32.46664932120211, 2.666213470801304],
            [32.46980533815384, 2.666703098645353],
            [32.47131929674992, 2.666445265202958],
            [32.4775026236327, 2.667869610117263],
            [32.481300406006554, 2.670556641956512],
            [32.48325556137468, 2.673975272514899],
            [32.48314085100445, 2.675066622469072],
            [32.4845257019313, 2.676201689640338],
            [32.485196223323975, 2.677925234003239],
            [32.48882347132094, 2.678687869196029],
            [32.49107918861005, 2.680627485004922],
            [32.49222162556422, 2.680886451489489],
            [32.49392068022798, 2.682050362467026],
            [32.49551904093491, 2.684980576221355],
            [32.495561343499965, 2.686301762499463],
            [32.49620394525361, 2.686503076254915],
            [32.49683167000784, 2.688154799322555],
            [32.49808798908551, 2.689347244620686],
            [32.49891568241525, 2.690955967627778],
            [32.50080089136209, 2.69097110549557],
            [32.50201438864849, 2.692120447781102],
            [32.502900090687696, 2.691575110752713],
            [32.502444007034775, 2.689262875345232],
            [32.50305883377818, 2.687525501203779],
            [32.502930540880875, 2.686922305125642],
            [32.50350560459652, 2.686490991041521],
            [32.502693422476796, 2.685594786173199],
            [32.502847013729124, 2.683353374693144],
            [32.507429042413996, 2.679609211630489],
            [32.51255923386503, 2.679580571451358],
            [32.51906498945948, 2.675959943832424],
            [32.52236226828627, 2.675289433761927],
            [32.526019498454126, 2.673038732121024],
            [32.52783474211506, 2.670995870801834],
            [32.5287347525201, 2.669187646334533],
            [32.5296342598686, 2.668698170233067],
            [32.531358099051076, 2.668322046094994],
            [32.536210565552196, 2.668625325881071],
            [32.53692985827829, 2.669062670103857],
            [32.53745402255163, 2.670238442576608],
            [32.53755816424254, 2.672318344592912],
            [32.54211406632569, 2.674128638195713],
            [32.544456339885706, 2.67609114238336],
            [32.547579006882486, 2.677871951189945],
            [32.54787802819282, 2.67868337265675],
            [32.548945194411, 2.678605254369629],
            [32.54905857617288, 2.679152685282802],
            [32.55064762853686, 2.679816412094346],
            [32.551350449753905, 2.679620990921308],
            [32.55487426033912, 2.681698674967163],
            [32.55631125577324, 2.684308276433289],
            [32.55522890892508, 2.68759096929969],
            [32.55543360353729, 2.689591336980603],
            [32.556585270681005, 2.692557805143164],
            [32.55936685095767, 2.696504647582731],
            [32.56101832814905, 2.697370914321196],
            [32.56226921780914, 2.698669867753001],
            [32.56573118657359, 2.703693997726086],
            [32.56772297703562, 2.704761697491287],
            [32.568435413819465, 2.705626860925271],
            [32.56847315563782, 2.704782112293805],
            [32.569913488313226, 2.702674256771328],
            [32.57050866261313, 2.700748043375785],
            [32.571165967093044, 2.699829192611229],
            [32.57265152365483, 2.699226569731916],
            [32.57402378289632, 2.695866652453413],
            [32.57593782866208, 2.695178010364917],
            [32.57771898215629, 2.693302168882825],
            [32.58031870479189, 2.692202084507867],
            [32.580995221540796, 2.690747100029083],
            [32.58079573356396, 2.68939712517147],
            [32.58143406472675, 2.688229341152493],
            [32.5812230378901, 2.687262591474611],
            [32.58014213912615, 2.686174992460891],
            [32.57812287009792, 2.681905593315153],
            [32.578016981183794, 2.680550979348084],
            [32.57606030856117, 2.679818712855884],
            [32.57519955094076, 2.678289692547685],
            [32.574257986267284, 2.677590387389984],
            [32.5737203185186, 2.676124603130911],
            [32.575489150720365, 2.671180352092578],
            [32.57547934650738, 2.665265976900665],
            [32.57421394546218, 2.66259990446936],
            [32.57207234206189, 2.661206842136137],
            [32.56954083838726, 2.657969118435698],
            [32.56935189663188, 2.6567790385718],
            [32.56938815084011, 2.654613225722581],
            [32.57013474157107, 2.651697952310309],
            [32.569993585697226, 2.649210774244899],
            [32.57175790566129, 2.646402955614653],
            [32.572633793606045, 2.646022454552483],
            [32.573486666713194, 2.643726021234648],
            [32.57356145954543, 2.639622451087777],
            [32.57680639623555, 2.62955028130999],
            [32.57900360265698, 2.614207248799939],
            [32.618729511107375, 2.607893056247124],
            [32.656393894676896, 2.60161055920205],
            [32.65687876663972, 2.602555569995801],
            [32.65850978020892, 2.603783082291302],
            [32.65955993592886, 2.606449347961582],
            [32.661841882227655, 2.608509721057689],
            [32.66212704792303, 2.60994209212804],
            [32.66410948153305, 2.611902532424023],
            [32.662084018620924, 2.613423640735374],
            [32.65997306214488, 2.613655403704828],
            [32.6549951225581, 2.615337629023562],
            [32.64903305522137, 2.616605523442816],
            [32.644540222955996, 2.616052098220812],
            [32.6420298494535, 2.616857387103052],
            [32.639947448623715, 2.616687920750804],
            [32.63273018240846, 2.618301061885816],
            [32.63250199685158, 2.618014788569281],
            [32.629649223291985, 2.619622777952194],
            [32.62285987046067, 2.620776883494569],
            [32.62074882055981, 2.621896865293063],
            [32.61868076313018, 2.620968006555537],
            [32.61662685326794, 2.621142328027207],
            [32.615343283796115, 2.620140917664743],
            [32.614173694364176, 2.620228240437586],
            [32.61348911793058, 2.619741913653641],
            [32.61277595710461, 2.619828699823247],
            [32.61190598546434, 2.619099029419663],
            [32.611335460037495, 2.619157001760668],
            [32.60958104849097, 2.619631821712768],
            [32.6080975841055, 2.620607782007147],
            [32.605344322319866, 2.624837434622487],
            [32.6043027589856, 2.627890296685887],
            [32.60210589302566, 2.630786891617995],
            [32.60454425847332, 2.636357307623909],
            [32.60482926067528, 2.638591998054004],
            [32.60461468100168, 2.643993541921834],
            [32.60529909663686, 2.645912576710042],
            [32.606738694490375, 2.654550132952393],
            [32.6041562536442, 2.66087132782826],
            [32.60345675978697, 2.665728995307001],
            [32.599889975595175, 2.672867947179246],
            [32.59812035736756, 2.680176747729783],
            [32.59854796083266, 2.682583197650023],
            [32.59811952013769, 2.686738529711567],
            [32.60055802572254, 2.691563956114867],
            [32.59980180505173, 2.693441655040495],
            [32.597490793761914, 2.695421418695112],
            [32.592440475116064, 2.702103539391786],
            [32.586676378501636, 2.712482800541141],
            [32.586760515609484, 2.722740836958839],
            [32.58627504536869, 2.726179867118227],
            [32.58534753932942, 2.728487554525598],
            [32.583977893287084, 2.730351598539099],
            [32.58235163000911, 2.731241696501529],
            [32.582037641867835, 2.732474168908003],
            [32.58111030291519, 2.733521079844022],
            [32.58023956411367, 2.737633899306316],
            [32.57779987275266, 2.74086019376872],
            [32.57811363721342, 2.741203687091194],
            [32.57771411418575, 2.742006440488512],
            [32.578497994882454, 2.746346646434462],
            [32.57882993495635, 2.747817282448242],
            [32.57938624454383, 2.748304072414756],
            [32.57977252191263, 2.750712836201697],
            [32.58115154726486, 2.75095661914134],
            [32.58238521172937, 2.751759930372354],
            [32.5824817437915, 2.752465522905607],
            [32.583304119993045, 2.75319569775675],
            [32.584441235327475, 2.753342076151406],
            [32.58504576378445, 2.754339801599161],
            [32.58603781108195, 2.754194170759347],
            [32.58763428173353, 2.755362547670288],
            [32.590948681551296, 2.756312551595538],
            [32.59319818070204, 2.758211036290299],
            [32.59437074355754, 2.760863365344279],
            [32.593789141004955, 2.763563752569558],
            [32.59458704709817, 2.765145452852154],
            [32.595554717712126, 2.765559386459114],
            [32.59563896531272, 2.766848885184216],
            [32.59665495450919, 2.767481801753309],
            [32.59687199646497, 2.769598552783464],
            [32.59747646922639, 2.770815242131481],
            [32.596871090064866, 2.772274810632212],
            [32.59763280123867, 2.773588871797631],
            [32.59731765876226, 2.775364823024506],
            [32.59775248647892, 2.77740866116335],
            [32.5994943018485, 2.778187803850441],
            [32.60034075379804, 2.779355913959228],
            [32.60198597152851, 2.779599769074209],
            [32.60380121878269, 2.777872978792747],
            [32.6049383529817, 2.778043671671051],
            [32.6052525477355, 2.779089950337892],
            [32.606026694287785, 2.77943082517778],
            [32.606776813601144, 2.779260767759159],
            [32.607054870029344, 2.779844773526559],
            [32.60845828823479, 2.779626275881165],
            [32.60855462087093, 2.780988767307482],
            [32.61041724617151, 2.782327517552716],
            [32.60993279641688, 2.78395744352925],
            [32.615726747641475, 2.786805927943209],
            [32.61710522232641, 2.788923060654176],
            [32.61801457071885, 2.791859906697434],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 512,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "LALOGI",
        Population: 17086,
        Key: "OMOROLALOGI",
        Dist2: "Gulu",
        "Sub Country": "Lalogi",
        id2_original: "Gulu Lalogi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.69169518083978, 2.80129770933493],
            [32.68902804143871, 2.80305192614912],
            [32.68668876915007, 2.806430776387147],
            [32.68447835210408, 2.807432050373942],
            [32.68317231756364, 2.809342535809826],
            [32.68125719920942, 2.809898898046351],
            [32.679500947014915, 2.812194012726101],
            [32.67930000376731, 2.813588720032054],
            [32.677077350768826, 2.814793441409675],
            [32.676793626869504, 2.815919233066579],
            [32.677199581834586, 2.817545164499005],
            [32.67473238675454, 2.819706760237994],
            [32.67231920827083, 2.824243345349023],
            [32.67066775174072, 2.825615533165731],
            [32.669733536184566, 2.829515000910456],
            [32.66462483602842, 2.834615140412874],
            [32.66181095862231, 2.834591073486789],
            [32.66089133260471, 2.83546221442518],
            [32.66083494176109, 2.838509740084752],
            [32.65886363917573, 2.841136367093488],
            [32.657962113312784, 2.843334195696944],
            [32.65970907063909, 2.839931956589734],
            [32.653603436350274, 2.837361165855385],
            [32.653961450923596, 2.835897460753716],
            [32.65281216251876, 2.835717343901247],
            [32.65112695808006, 2.834073242371124],
            [32.65000326627095, 2.833713370545834],
            [32.64954391185207, 2.832480539217098],
            [32.64852189406179, 2.833738597591543],
            [32.64818995039463, 2.833456007454725],
            [32.64778154482543, 2.832634082780411],
            [32.648407914021895, 2.830592630829103],
            [32.64802518589677, 2.829308462620713],
            [32.647693363502185, 2.828640650626323],
            [32.6461355716118, 2.828023833612587],
            [32.64478237282398, 2.826508226750795],
            [32.64462944632498, 2.825455258601552],
            [32.643722725504745, 2.825570549089788],
            [32.643288832036006, 2.824594534986426],
            [32.64055618029787, 2.823977337193597],
            [32.638768328964936, 2.824028139831127],
            [32.63446596648924, 2.820110428281236],
            [32.634619573911245, 2.818954833857764],
            [32.63290924898395, 2.816129377013486],
            [32.633535872403634, 2.813291825797628],
            [32.63247677664997, 2.810659180832765],
            [32.63247735516501, 2.808810142072562],
            [32.63109850408594, 2.807782463586623],
            [32.63072874493861, 2.805971838220047],
            [32.62807328363624, 2.803711063943049],
            [32.62784361765574, 2.803094640178618],
            [32.62873808186224, 2.801322937083062],
            [32.62730812293175, 2.80042364114569],
            [32.62686152458992, 2.799306379005579],
            [32.62591679694833, 2.798509964900711],
            [32.62538091684708, 2.7970716559305],
            [32.62553462308374, 2.795582206650213],
            [32.622266316721536, 2.793090096403411],
            [32.6193930867263, 2.79307632274769],
            [32.61801457071885, 2.791859906697434],
            [32.61710522232641, 2.788923060654176],
            [32.615726747641475, 2.786805927943209],
            [32.60993279641688, 2.78395744352925],
            [32.61041724617151, 2.782327517552716],
            [32.60855462087093, 2.780988767307482],
            [32.60845828823479, 2.779626275881165],
            [32.607054870029344, 2.779844773526559],
            [32.606776813601144, 2.779260767759159],
            [32.606026694287785, 2.77943082517778],
            [32.6052525477355, 2.779089950337892],
            [32.6049383529817, 2.778043671671051],
            [32.60380121878269, 2.777872978792747],
            [32.60198597152851, 2.779599769074209],
            [32.60034075379804, 2.779355913959228],
            [32.5994943018485, 2.778187803850441],
            [32.59775248647892, 2.77740866116335],
            [32.59731765876226, 2.775364823024506],
            [32.59763280123867, 2.773588871797631],
            [32.596871090064866, 2.772274810632212],
            [32.59747646922639, 2.770815242131481],
            [32.59687199646497, 2.769598552783464],
            [32.59665495450919, 2.767481801753309],
            [32.59563896531272, 2.766848885184216],
            [32.595554717712126, 2.765559386459114],
            [32.59458704709817, 2.765145452852154],
            [32.593789141004955, 2.763563752569558],
            [32.59437074355754, 2.760863365344279],
            [32.59319818070204, 2.758211036290299],
            [32.590948681551296, 2.756312551595538],
            [32.58763428173353, 2.755362547670288],
            [32.58603781108195, 2.754194170759347],
            [32.58504576378445, 2.754339801599161],
            [32.584441235327475, 2.753342076151406],
            [32.583304119993045, 2.75319569775675],
            [32.5824817437915, 2.752465522905607],
            [32.58238521172937, 2.751759930372354],
            [32.58115154726486, 2.75095661914134],
            [32.57977252191263, 2.750712836201697],
            [32.57938624454383, 2.748304072414756],
            [32.57882993495635, 2.747817282448242],
            [32.578497994882454, 2.746346646434462],
            [32.57771411418575, 2.742006440488512],
            [32.57811363721342, 2.741203687091194],
            [32.57779987275266, 2.74086019376872],
            [32.58023956411367, 2.737633899306316],
            [32.58111030291519, 2.733521079844022],
            [32.582037641867835, 2.732474168908003],
            [32.58235163000911, 2.731241696501529],
            [32.583977893287084, 2.730351598539099],
            [32.58534753932942, 2.728487554525598],
            [32.58627504536869, 2.726179867118227],
            [32.586760515609484, 2.722740836958839],
            [32.586676378501636, 2.712482800541141],
            [32.592440475116064, 2.702103539391786],
            [32.597490793761914, 2.695421418695112],
            [32.59980180505173, 2.693441655040495],
            [32.60055802572254, 2.691563956114867],
            [32.59811952013769, 2.686738529711567],
            [32.59854796083266, 2.682583197650023],
            [32.59812035736756, 2.680176747729783],
            [32.599889975595175, 2.672867947179246],
            [32.60345675978697, 2.665728995307001],
            [32.6041562536442, 2.66087132782826],
            [32.606738694490375, 2.654550132952393],
            [32.60529909663686, 2.645912576710042],
            [32.60461468100168, 2.643993541921834],
            [32.60482926067528, 2.638591998054004],
            [32.60454425847332, 2.636357307623909],
            [32.60210589302566, 2.630786891617995],
            [32.6043027589856, 2.627890296685887],
            [32.605344322319866, 2.624837434622487],
            [32.6080975841055, 2.620607782007147],
            [32.60958104849097, 2.619631821712768],
            [32.611335460037495, 2.619157001760668],
            [32.61190598546434, 2.619099029419663],
            [32.61277595710461, 2.619828699823247],
            [32.61348911793058, 2.619741913653641],
            [32.614173694364176, 2.620228240437586],
            [32.615343283796115, 2.620140917664743],
            [32.61662685326794, 2.621142328027207],
            [32.61868076313018, 2.620968006555537],
            [32.62074882055981, 2.621896865293063],
            [32.62285987046067, 2.620776883494569],
            [32.629649223291985, 2.619622777952194],
            [32.63250199685158, 2.618014788569281],
            [32.63273018240846, 2.618301061885816],
            [32.639947448623715, 2.616687920750804],
            [32.6420298494535, 2.616857387103052],
            [32.644540222955996, 2.616052098220812],
            [32.64903305522137, 2.616605523442816],
            [32.6549951225581, 2.615337629023562],
            [32.65997306214488, 2.613655403704828],
            [32.662084018620924, 2.613423640735374],
            [32.66410948153305, 2.611902532424023],
            [32.66212704792303, 2.60994209212804],
            [32.661841882227655, 2.608509721057689],
            [32.65955993592886, 2.606449347961582],
            [32.65850978020892, 2.603783082291302],
            [32.66627007711509, 2.605400839999481],
            [32.683456491518946, 2.60534401119154],
            [32.68915497159175, 2.604747850126372],
            [32.69393890561988, 2.605699043354708],
            [32.69766686823489, 2.605314724975368],
            [32.69957002192785, 2.609971929229915],
            [32.71394410582453, 2.607965193428361],
            [32.72529375799233, 2.606936462415578],
            [32.73175927355363, 2.606972824479221],
            [32.739041936223245, 2.605733338773092],
            [32.74349130799514, 2.605839135246669],
            [32.746480639850944, 2.606364120523959],
            [32.75156730343489, 2.606091807815605],
            [32.76205020352439, 2.604455163683423],
            [32.76329951484453, 2.603963796446517],
            [32.76568928682521, 2.604182735696627],
            [32.76818788521095, 2.603309238988684],
            [32.77269578132532, 2.604184027037312],
            [32.77361914792776, 2.604020327384033],
            [32.77524842954509, 2.604785339371449],
            [32.777203760983014, 2.604621820171164],
            [32.77780117747787, 2.604840416505013],
            [32.77872427638237, 2.606206150964407],
            [32.78594849016802, 2.603585513369266],
            [32.786315675642065, 2.587357104985875],
            [32.79753818475614, 2.590643269114147],
            [32.79800416784347, 2.59207460692625],
            [32.79697301598336, 2.595751276723295],
            [32.796837256289415, 2.600822343270778],
            [32.797695917241924, 2.601686170537207],
            [32.800934564826726, 2.603438750043606],
            [32.80476168707608, 2.607905851161085],
            [32.80555885385585, 2.609818424606545],
            [32.809214538023106, 2.6124100539169],
            [32.81212143867181, 2.617728349172435],
            [32.81393697248858, 2.619406648387657],
            [32.81570332623848, 2.621775885691143],
            [32.816623062748846, 2.624724901378484],
            [32.81679419989532, 2.629018700206675],
            [32.815689689812466, 2.631140739224687],
            [32.81406995728659, 2.632719812008753],
            [32.81376304247989, 2.633990628567097],
            [32.81300225297755, 2.634780171479525],
            [32.81064584622317, 2.639863233067524],
            [32.812853913276385, 2.642207877034568],
            [32.81752798873514, 2.645083421610126],
            [32.820373841673764, 2.649056799748579],
            [32.82277843765324, 2.650118265636903],
            [32.82407895384291, 2.650118452286631],
            [32.82444693073274, 2.650809444704062],
            [32.825400587628245, 2.651313978321569],
            [32.824773776460674, 2.65364963338886],
            [32.825127340780064, 2.656378707471152],
            [32.824726128021354, 2.65682952436268],
            [32.821988800552205, 2.657541032711948],
            [32.821528441816874, 2.659095278156648],
            [32.822188899383434, 2.660827661140838],
            [32.82443049605461, 2.661587339421676],
            [32.82886633201184, 2.664364374247949],
            [32.829385357023426, 2.665147536522447],
            [32.82952684078237, 2.665883184880777],
            [32.82635183883543, 2.674484857625229],
            [32.82392117284809, 2.675576089574943],
            [32.82264702850024, 2.674887727682287],
            [32.81679581416787, 2.668906913274208],
            [32.81558094335741, 2.666426957617642],
            [32.81378774525187, 2.665240184555314],
            [32.811781896155644, 2.665975506225426],
            [32.809327353846385, 2.668941372957959],
            [32.80786423989535, 2.669581850719182],
            [32.805127172937624, 2.668347456108354],
            [32.80174150976838, 2.665202698925325],
            [32.79978312495681, 2.664181988131006],
            [32.79791897341855, 2.664134220697234],
            [32.79725794182854, 2.666127342935244],
            [32.79770563162341, 2.670066677350032],
            [32.796525442071115, 2.672154707749413],
            [32.797280196691396, 2.674266803866765],
            [32.79671377836201, 2.67478876761411],
            [32.79468433411655, 2.675334212632575],
            [32.792607527994356, 2.676923762774712],
            [32.79167503091535, 2.679308461450211],
            [32.78693090752566, 2.685572342188752],
            [32.78536085183503, 2.690377369825368],
            [32.784936040333776, 2.690662048883522],
            [32.78217537912515, 2.68933268461064],
            [32.780641350368946, 2.690471446286322],
            [32.77953190673854, 2.692488282308662],
            [32.779531532141085, 2.694600241001352],
            [32.77883505213161, 2.69655783087749],
            [32.77841021996915, 2.696984889895384],
            [32.77538962763976, 2.697577586836684],
            [32.773926169634, 2.699807918094586],
            [32.77340668288836, 2.701635023443701],
            [32.77435030200886, 2.703130179389432],
            [32.77337047988409, 2.705989452848248],
            [32.769027707593665, 2.710165081093106],
            [32.7676586777956, 2.712063214386371],
            [32.76711555457819, 2.714032683353184],
            [32.76226498621723, 2.72021336750313],
            [32.750734870593696, 2.732491209416577],
            [32.749031740273516, 2.734066434744579],
            [32.74706321707564, 2.734785273675526],
            [32.74540850954251, 2.73610545983857],
            [32.74311185602589, 2.739847751398601],
            [32.74125742695394, 2.741655306100087],
            [32.74054418348297, 2.742171981811704],
            [32.73876159448096, 2.742411200203826],
            [32.73709208540688, 2.744468652089133],
            [32.73703376408369, 2.747318685836362],
            [32.73016890785273, 2.754552451862458],
            [32.72869477516643, 2.75481348506715],
            [32.72538676865854, 2.752490626077584],
            [32.72367295467464, 2.754230033150527],
            [32.722836843232365, 2.756166209457086],
            [32.722788417750365, 2.757781677761379],
            [32.72303572215143, 2.760276478941983],
            [32.72361125119441, 2.761463994973983],
            [32.723116346846496, 2.764247923853893],
            [32.72171580504662, 2.766636401321552],
            [32.72090765815913, 2.7670178012679],
            [32.719742263859565, 2.76689677596864],
            [32.718027845309486, 2.768801786608748],
            [32.71629084131656, 2.769001179863304],
            [32.71173891697349, 2.765918291326948],
            [32.71019284719926, 2.765629435353342],
            [32.70897911185929, 2.764767346180502],
            [32.70767125463714, 2.764861249033044],
            [32.70735644633405, 2.766100068094484],
            [32.70641675554626, 2.767438395536061],
            [32.70338168147619, 2.768936059853106],
            [32.70026762123813, 2.768807463614389],
            [32.698839705974905, 2.767801668629754],
            [32.698054855996, 2.767728929856248],
            [32.6973456621303, 2.769623186323344],
            [32.696120128317425, 2.771013021764729],
            [32.69431358663668, 2.771799433815955],
            [32.69389323257589, 2.772545098804168],
            [32.69400205448941, 2.773202761541156],
            [32.69456116951548, 2.774131333525046],
            [32.69465010452526, 2.775241888308488],
            [32.695690748883, 2.776400030071402],
            [32.696708885951296, 2.776881946066677],
            [32.70062882393241, 2.776036651048618],
            [32.700704731573914, 2.77746087810815],
            [32.70004097539364, 2.779491747234857],
            [32.70059477239324, 2.780529761772027],
            [32.70385978373502, 2.781325326689542],
            [32.70623635676921, 2.783050495062934],
            [32.70452979308799, 2.785270177212703],
            [32.70150197381214, 2.785096901288269],
            [32.69374625561898, 2.786298878555621],
            [32.69177104805711, 2.785217511986566],
            [32.68846460371947, 2.78440043711676],
            [32.68808039876404, 2.786733687418209],
            [32.687244100472206, 2.788498136724388],
            [32.68733041599457, 2.789915834687601],
            [32.688710519325156, 2.792181390088825],
            [32.688637440478445, 2.793715837962214],
            [32.68790451941119, 2.794725712162871],
            [32.687881501878664, 2.795466662867887],
            [32.688927280108246, 2.796894473345998],
            [32.690854722449856, 2.795972571489476],
            [32.692360842346794, 2.797059794350732],
            [32.69275695536961, 2.800212379100608],
            [32.69169518083978, 2.80129770933493],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 513,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "ODEK",
        Population: 31422,
        Key: "OMOROODEK",
        Dist2: "Gulu",
        "Sub Country": "Odek",
        id2_original: "Gulu Odek",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.52324589078603, 2.665248464344204],
            [33.523682589693415, 2.666957953754625],
            [33.52332978534872, 2.668539955539825],
            [33.52356011518421, 2.669890647041666],
            [33.523012543509495, 2.670655145620051],
            [33.52198749300677, 2.670744453340212],
            [33.52139597395177, 2.672086612317994],
            [33.52166124376022, 2.672477519848775],
            [33.52303997087175, 2.672814618381942],
            [33.5245609848361, 2.67526672666897],
            [33.5246142576274, 2.675871007091508],
            [33.52395179861437, 2.67660889415981],
            [33.52472997770396, 2.677834926278098],
            [33.52437670443872, 2.678314966857188],
            [33.523828803980614, 2.678332980836974],
            [33.52368766607308, 2.678919567919293],
            [33.52449277934984, 2.681132036905607],
            [33.52629680754445, 2.684081655822444],
            [33.525864463669556, 2.685654800409364],
            [33.52613054645332, 2.68792970757326],
            [33.52756278081646, 2.689368743651591],
            [33.52909173409129, 2.689643567617355],
            [33.5296575748039, 2.690265391719169],
            [33.529173116964465, 2.693918065199884],
            [33.53064074135653, 2.695428180011993],
            [33.530782523356116, 2.696334564036292],
            [33.532444764161205, 2.698271146671256],
            [33.53351419143898, 2.698581719615485],
            [33.533779753199894, 2.699576925041862],
            [33.53286099315824, 2.700306037262623],
            [33.53245527534835, 2.702119115908592],
            [33.53375589484428, 2.705646585678846],
            [33.53617801875159, 2.707262903507709],
            [33.53678835661349, 2.708568988953204],
            [33.537637002248935, 2.709172912779318],
            [33.537142360209074, 2.709724103141498],
            [33.53708972701827, 2.710612812040541],
            [33.53774390176773, 2.711092398219106],
            [33.53781513996639, 2.712318739280719],
            [33.538345390325794, 2.712354047489019],
            [33.538142897484335, 2.714069282737098],
            [33.53893853892474, 2.714708773970584],
            [33.53840891199615, 2.715313266315636],
            [33.53823260145196, 2.717090743438983],
            [33.53917805852556, 2.716761506796215],
            [33.53962010151058, 2.717170095740306],
            [33.539938147341964, 2.716956670753669],
            [33.542254709321924, 2.719603883220574],
            [33.54474717760421, 2.720349246994735],
            [33.5475320322401, 2.722365168303589],
            [33.54883277480517, 2.726408132685286],
            [33.549345394828805, 2.726496765130252],
            [33.55010583847974, 2.727456181296072],
            [33.55131843116266, 2.731552410819348],
            [33.55213184936422, 2.732387386226699],
            [33.552891941773886, 2.732546993279787],
            [33.5538284902548, 2.732066671780943],
            [33.55464195966034, 2.732990521963233],
            [33.5544302285445, 2.733808192973802],
            [33.55503114307908, 2.733736823190434],
            [33.55551751792335, 2.734403104310815],
            [33.555253226380245, 2.736233895401852],
            [33.557278366797206, 2.739174456505622],
            [33.55911688670546, 2.739866763144954],
            [33.55929404166599, 2.740755351984871],
            [33.56063802463732, 2.74222991332844],
            [33.56087739601612, 2.743856060257472],
            [33.56202670508221, 2.744779744322594],
            [33.56174428014676, 2.745597449455678],
            [33.562098201097335, 2.746468186172694],
            [33.56282313704006, 2.747036596245554],
            [33.563901226772074, 2.746840580271691],
            [33.564803005959945, 2.747622168371505],
            [33.56460059845843, 2.749426269344395],
            [33.566467485366736, 2.754019818041442],
            [33.56957926118905, 2.756008938475981],
            [33.56988906857096, 2.757066311665004],
            [33.570879220423215, 2.757776768770334],
            [33.571746184503894, 2.759624780390757],
            [33.57351352370568, 2.759232906883853],
            [33.57628083424406, 2.761604313970563],
            [33.57884396939647, 2.762100713463535],
            [33.58004672552702, 2.763824146733736],
            [33.57981762548516, 2.765228347975241],
            [33.58009220183994, 2.7664634690104],
            [33.58117087368028, 2.767476009891094],
            [33.586306658042275, 2.769739579657736],
            [33.58775743003962, 2.77256481617475],
            [33.591673849319776, 2.775237737575867],
            [33.5929996207453, 2.775485903985462],
            [33.59818861681314, 2.778033743493875],
            [33.60013373620289, 2.779667891620742],
            [33.60205352310163, 2.783639243639749],
            [33.60343321051223, 2.785593597781639],
            [33.603760111935706, 2.786863585413176],
            [33.603765269163745, 2.799240473787921],
            [33.59132233854908, 2.796948042471987],
            [33.58968735622297, 2.796993299516742],
            [33.51873178910969, 2.805887133543687],
            [33.51483375834338, 2.804831334808245],
            [33.51296007298501, 2.804761071113771],
            [33.51248256091934, 2.804174755675694],
            [33.51207627896748, 2.804779229439914],
            [33.511563671520264, 2.804779454646944],
            [33.511298175336336, 2.80394421621346],
            [33.50823162250208, 2.804505424318217],
            [33.50466097914786, 2.804311472554661],
            [33.502310375510184, 2.805058978705552],
            [33.50130323561759, 2.805965869791267],
            [33.4998681589849, 2.805843248720103],
            [33.49730963937643, 2.807101009308425],
            [33.49164574354376, 2.811220481716038],
            [33.49059896818422, 2.812776795321115],
            [33.48805180148431, 2.812777869309026],
            [33.48643319364916, 2.813536636588083],
            [33.4843619076744, 2.813010904026542],
            [33.48293284705917, 2.81119232740346],
            [33.4809805402488, 2.810522918697301],
            [33.47840559314875, 2.810309244017834],
            [33.47697742006902, 2.810644937232786],
            [33.47635827512407, 2.810142537759868],
            [33.475382423552816, 2.810549848300623],
            [33.47464430213836, 2.810167168655847],
            [33.4732398769215, 2.810383166302373],
            [33.47044210720677, 2.808744654605094],
            [33.465133504052105, 2.808674977938357],
            [33.4643714748747, 2.807981123472454],
            [33.46401371003301, 2.806281779259491],
            [33.46269253888004, 2.806318214299737],
            [33.46197806112386, 2.805504647072182],
            [33.46193007132475, 2.804523277586966],
            [33.459358796537565, 2.803734383209759],
            [33.45838287579603, 2.803974131085123],
            [33.458096756988176, 2.802801357362302],
            [33.45456155846006, 2.802455657658094],
            [33.452109149649566, 2.80121192045194],
            [33.450942106941476, 2.799656494075426],
            [33.449013837251506, 2.799513618872812],
            [33.448275502038044, 2.798532502771527],
            [33.44741848859574, 2.798461017549946],
            [33.44697719839892, 2.796103432105157],
            [33.44383506670657, 2.796463686108797],
            [33.44371631212094, 2.797181830440805],
            [33.44300213979197, 2.797110287713184],
            [33.44226390069823, 2.79636853860039],
            [33.44228750033904, 2.795841918123024],
            [33.442692168018354, 2.795769958991514],
            [33.44264425008445, 2.794956133207785],
            [33.44178713153926, 2.794597403163864],
            [33.4405018076577, 2.795004810633555],
            [33.43945480682103, 2.796130228350729],
            [33.4387406434752, 2.79610655900679],
            [33.43826481395405, 2.796824828274553],
            [33.43496842086612, 2.798489667447659],
            [33.43444495548209, 2.799160086159906],
            [33.43404065611206, 2.800237391533884],
            [33.43454147227284, 2.802678737753872],
            [33.43326884607782, 2.805276333921545],
            [33.43322181478112, 2.806856172942769],
            [33.43191264961193, 2.807191767556943],
            [33.43200820251036, 2.808101328958374],
            [33.431698907168155, 2.808556233212091],
            [33.430889569114605, 2.808700154384848],
            [33.43086597306705, 2.809250705531734],
            [33.428532889272375, 2.808820716896712],
            [33.42658111606132, 2.809563465712381],
            [33.42402204219231, 2.809600310686864],
            [33.418546227528985, 2.807998535247681],
            [33.41716525103596, 2.807257000296085],
            [33.415463582274725, 2.808418533458575],
            [33.41408291031058, 2.80853871826303],
            [33.41264270609425, 2.807988409034407],
            [33.411809206054514, 2.807103061290304],
            [33.41167792086901, 2.806085794648941],
            [33.411320986070635, 2.806468906305077],
            [33.41120173381835, 2.805846599008047],
            [33.4108923711025, 2.806157887732305],
            [33.410773144003066, 2.80558344794672],
            [33.41024937858171, 2.805440011796203],
            [33.40991583232007, 2.804674150168744],
            [33.410534750889575, 2.804602126978575],
            [33.40936793455694, 2.803573255949926],
            [33.4099628537353, 2.802974635159858],
            [33.409367534806634, 2.802424299984157],
            [33.409795930585844, 2.802160846679929],
            [33.409736268976246, 2.801718028473088],
            [33.40906953847406, 2.801215594657502],
            [33.408522042257836, 2.801287602802991],
            [33.408307142784, 2.799396681161827],
            [33.40837819772634, 2.798367373087429],
            [33.40880659440389, 2.798056034737568],
            [33.408639732339836, 2.797409814983681],
            [33.408068314885945, 2.797122772877725],
            [33.407401861064855, 2.797410248352936],
            [33.406854142964754, 2.796835956807328],
            [33.40599714479384, 2.796812317086722],
            [33.40578262979893, 2.796046421105569],
            [33.404687485551214, 2.795711682858697],
            [33.40506822660293, 2.795328564991788],
            [33.40465142717572, 2.79469439106924],
            [33.40419926556733, 2.795101471010272],
            [33.40241366541248, 2.79447972922011],
            [33.40236633677341, 2.795317530655577],
            [33.40105714645141, 2.795581284281115],
            [33.40048563377605, 2.795006998120892],
            [33.39798580469835, 2.794194005350771],
            [33.39779511032983, 2.793452037260634],
            [33.39674747707921, 2.792830033497703],
            [33.39619996738827, 2.792854157812573],
            [33.395890682825836, 2.793380869355234],
            [33.3923550656828, 2.791742396675941],
            [33.39061663606351, 2.789756224574734],
            [33.39056873070603, 2.788870584911555],
            [33.38983082488728, 2.789038390637082],
            [33.38950062574838, 2.786385921991022],
            [33.3907319671696, 2.783597584074834],
            [33.39097637719882, 2.777402104884123],
            [33.38906581869299, 2.775668027421367],
            [33.38801733473778, 2.772384812495402],
            [33.386291044052896, 2.768854001241716],
            [33.384010456006806, 2.765942906997945],
            [33.382961719625015, 2.761792326541177],
            [33.38351467580152, 2.756959732385025],
            [33.38265090612995, 2.753180814600383],
            [33.38277353514939, 2.751322153033064],
            [33.38018384040729, 2.744941714966505],
            [33.378640779090944, 2.736082772727713],
            [33.378121095614226, 2.735595338019433],
            [33.37874474830531, 2.734702365669325],
            [33.378286184403905, 2.73396509898663],
            [33.37892775219667, 2.733688362190747],
            [33.37860673473831, 2.73306627865879],
            [33.379156585438885, 2.732628272846705],
            [33.37890415435245, 2.731499190480733],
            [33.379293679131024, 2.731337759985398],
            [33.38057727645059, 2.732282149789713],
            [33.38002691101538, 2.731084043583373],
            [33.381286969779566, 2.73004666608436],
            [33.38027856955065, 2.729724365491594],
            [33.38072470076851, 2.727408292518955],
            [33.38141211228518, 2.727177637637482],
            [33.381572319629576, 2.726532361853632],
            [33.38253468928502, 2.726209433107168],
            [33.38193873434912, 2.72577178371565],
            [33.380907515115354, 2.725795161044124],
            [33.38076990040033, 2.725426503042848],
            [33.38145726071304, 2.725034533088759],
            [33.380150982729155, 2.724827544927314],
            [33.380127896924684, 2.724274494178918],
            [33.38067789584725, 2.724320418891057],
            [33.38090676861534, 2.723421617373857],
            [33.381731704117186, 2.723306137464184],
            [33.38155921410788, 2.721312883584053],
            [33.382292397483226, 2.720897859691878],
            [33.38378201443006, 2.721173917480992],
            [33.38371288188243, 2.719975647672677],
            [33.38231502604522, 2.719999142660329],
            [33.3816501379877, 2.718985408541575],
            [33.38136305079595, 2.716946112160054],
            [33.38184397645969, 2.715955062070407],
            [33.3824168752355, 2.715977929021981],
            [33.38262300266061, 2.715586113025004],
            [33.382049993391995, 2.715240633822607],
            [33.382347674415925, 2.714526175541222],
            [33.38193476469388, 2.713166708477941],
            [33.38138463371894, 2.712682964096188],
            [33.38190640398205, 2.711721961401562],
            [33.38251847469415, 2.711127116033348],
            [33.38451199261646, 2.710665610668154],
            [33.384695016270754, 2.709697705153401],
            [33.3803946525466, 2.707423442604274],
            [33.376422281698964, 2.704444319097973],
            [33.375888288958116, 2.702775478505891],
            [33.37636214218565, 2.701642789720868],
            [33.37891001136812, 2.698542409860185],
            [33.38258332407452, 2.692997767277463],
            [33.3862515532147, 2.685452609823893],
            [33.3883892022311, 2.683399138537525],
            [33.39034413212206, 2.679881679600569],
            [33.39152838116114, 2.676006823341444],
            [33.39241510009325, 2.668496017230046],
            [33.39336305807661, 2.667184350503117],
            [33.39614857926241, 2.666170127346705],
            [33.41120399757287, 2.666224767450237],
            [33.4125081267866, 2.666581970864437],
            [33.41529546706089, 2.671051565064582],
            [33.41719784460941, 2.672455489296826],
            [33.41795765494809, 2.671904230038618],
            [33.418266551438315, 2.670686623395372],
            [33.419167914706186, 2.670597435017192],
            [33.42059976638699, 2.67130790347111],
            [33.421218296884334, 2.671112182127974],
            [33.42127112860279, 2.670543396325572],
            [33.42067016915245, 2.670454733778092],
            [33.42097047595193, 2.669992511297204],
            [33.420351697519635, 2.669459512709578],
            [33.4201568187985, 2.668090992353761],
            [33.421676475408475, 2.667148454125314],
            [33.42233876194492, 2.665681891967258],
            [33.42156099158878, 2.665362225963944],
            [33.421525182046615, 2.664029205380224],
            [33.41987195044551, 2.661976886323441],
            [33.41902363898336, 2.662101602146082],
            [33.41909396090043, 2.660999590974006],
            [33.41997775312135, 2.661248129944685],
            [33.42054294075877, 2.660128180037813],
            [33.42176237231593, 2.659878929244872],
            [33.42181520942431, 2.659327931762123],
            [33.421196333973924, 2.658492767139169],
            [33.42147886311394, 2.657746172095586],
            [33.42218579053016, 2.657639281672189],
            [33.422583278873695, 2.657114816915989],
            [33.42359084097446, 2.657523274172044],
            [33.42313156920062, 2.658269930370168],
            [33.42344996986657, 2.65903408709604],
            [33.424156938605286, 2.659051619482477],
            [33.42410412125981, 2.659655950945334],
            [33.42463437161921, 2.659744637601699],
            [33.42396335705143, 2.661504483853927],
            [33.42585405111137, 2.660224110944219],
            [33.42730318098839, 2.659779256372409],
            [33.42714341292015, 2.65773532045402],
            [33.42802653499786, 2.656046501278143],
            [33.42862753307577, 2.656295123802685],
            [33.428238979376026, 2.657077312194591],
            [33.42975013612676, 2.657156759926568],
            [33.43059826882416, 2.656481058310434],
            [33.43061581381997, 2.65612557218937],
            [33.43001478879261, 2.655823636249732],
            [33.43082762847914, 2.655361223424832],
            [33.43107459331704, 2.653974790631034],
            [33.43206433194426, 2.65393888758722],
            [33.43275324095249, 2.652872224818802],
            [33.4334427886629, 2.653636246691947],
            [33.43417559564412, 2.651707529763072],
            [33.43375104465436, 2.650659027518448],
            [33.4344223520729, 2.649787877597362],
            [33.43415707148468, 2.649254760801316],
            [33.43366214737383, 2.649148287811286],
            [33.433096746835695, 2.6496106051475],
            [33.43254858766279, 2.648846523357861],
            [33.43155881939119, 2.648758000135507],
            [33.43069296293323, 2.649255977614929],
            [33.430357037034405, 2.648882846511814],
            [33.430604174348844, 2.648047383191429],
            [33.43008248942569, 2.647167769359745],
            [33.429922282979604, 2.643826337909651],
            [33.43111497797895, 2.642981661579229],
            [33.43046080053457, 2.642288726500038],
            [33.43069005328999, 2.640831189220962],
            [33.431361671525664, 2.640866501283529],
            [33.43155535279249, 2.638733572295446],
            [33.43113979753196, 2.638102742255121],
            [33.42893037402266, 2.63751697660104],
            [33.428770845804614, 2.636183999607471],
            [33.42811668273325, 2.635491043688717],
            [33.429282832515966, 2.634566411789356],
            [33.43013111343539, 2.634388367226259],
            [33.43030199456199, 2.632754899062407],
            [33.430855268742135, 2.633019528999209],
            [33.43129695509597, 2.632575034379682],
            [33.43172149261105, 2.633641317059667],
            [33.432746369738894, 2.633054424905286],
            [33.43329439775776, 2.633463027383243],
            [33.433205471731156, 2.631881186264128],
            [33.433824021093066, 2.631774331301205],
            [33.433593828699834, 2.630530240609605],
            [33.43417694850695, 2.630210112364737],
            [33.43378782078376, 2.629303790065482],
            [33.434264696842234, 2.628414923650724],
            [33.43475960388507, 2.628521398416524],
            [33.43567914546104, 2.629996299843254],
            [33.43711062703598, 2.629746964026362],
            [33.43749965414786, 2.630333361492986],
            [33.43803800641278, 2.628333621009546],
            [33.43775499218253, 2.627676085334311],
            [33.438143634815454, 2.627160505354554],
            [33.43862099326923, 2.627640232680496],
            [33.43908032073863, 2.627106860508257],
            [33.439133549512476, 2.627693374976285],
            [33.439734502674604, 2.627853124903422],
            [33.4396110463068, 2.62856411861844],
            [33.44121889232483, 2.627283841828982],
            [33.44008723156083, 2.62572014043187],
            [33.44020111368433, 2.622867406373118],
            [33.44062512388832, 2.622422915317944],
            [33.440288962630916, 2.621409928942263],
            [33.43922847628519, 2.62117923977035],
            [33.43894530215479, 2.620059595640555],
            [33.43790263928263, 2.620273249231865],
            [33.43709793294269, 2.618647228786288],
            [33.436833015273834, 2.619162763817438],
            [33.436355638853755, 2.618647489025674],
            [33.4353483498408, 2.618914451541506],
            [33.43524202704041, 2.618114668495191],
            [33.43612540783295, 2.617261205569558],
            [33.435806926318634, 2.616212673428209],
            [33.43693756390152, 2.614897015567206],
            [33.43653095136963, 2.614506132074832],
            [33.437016824055696, 2.614106041337081],
            [33.43694585714823, 2.613306256121349],
            [33.43782951282522, 2.613288167611552],
            [33.43788286646489, 2.614212385405332],
            [33.438465965610774, 2.613856701456166],
            [33.439031594321, 2.614069797934067],
            [33.43982644075238, 2.612754246409322],
            [33.441576373298865, 2.613517902525174],
            [33.441823482765564, 2.612611357252237],
            [33.44238911776397, 2.612842211324307],
            [33.443095891568284, 2.612379842664775],
            [33.44344952236303, 2.612859612446437],
            [33.44394408175786, 2.612024071150356],
            [33.444261646092244, 2.610424309107036],
            [33.443254182806164, 2.61019361253007],
            [33.442308031334875, 2.608407674978687],
            [33.443015051277555, 2.608656265727721],
            [33.443403507060914, 2.607625253229783],
            [33.44428745828364, 2.608406973223964],
            [33.44471119180652, 2.607215985432819],
            [33.44426887932694, 2.605865336236351],
            [33.44454164647474, 2.60253264081658],
            [33.44399367774468, 2.602230689215649],
            [33.44406381999871, 2.600666569827337],
            [33.44457640229307, 2.600826359988168],
            [33.444549401630574, 2.599431122459535],
            [33.44527424325021, 2.600106268965124],
            [33.44571567268587, 2.599341950513884],
            [33.445273588378356, 2.59824001939543],
            [33.44594442867297, 2.596124700969791],
            [33.44453826162274, 2.592863702378905],
            [33.44377800931296, 2.591957503901216],
            [33.44381297264216, 2.590891061089792],
            [33.44634072135888, 2.592294308332307],
            [33.44720648529034, 2.591654142654693],
            [33.44867366591467, 2.592542301001418],
            [33.44957480460373, 2.591991001010293],
            [33.45161609044126, 2.592105792339796],
            [33.45327697838357, 2.591038766345338],
            [33.45423127218461, 2.590896239070459],
            [33.455521808989765, 2.591997745840263],
            [33.45578730966527, 2.593117401473923],
            [33.456493987349816, 2.592459519823199],
            [33.45730705161516, 2.592708047307769],
            [33.45748396762383, 2.593241201653001],
            [33.45831445651073, 2.592814327672038],
            [33.45858865916639, 2.593587394289846],
            [33.459472251062984, 2.593409323272915],
            [33.4594195594817, 2.594298030490394],
            [33.460002803256316, 2.594386686790227],
            [33.460197908352875, 2.59630618439044],
            [33.46154095078807, 2.595985767431111],
            [33.46299848889612, 2.594643303008727],
            [33.46344060644129, 2.595425188991998],
            [33.46375844296523, 2.594643023021701],
            [33.46464194053876, 2.594233902671911],
            [33.465101541095976, 2.594482574288373],
            [33.46531334317873, 2.593753760559162],
            [33.466214569902675, 2.593469049409876],
            [33.467115974493076, 2.593664222075653],
            [33.4671693847266, 2.594748405829133],
            [33.4679294151525, 2.594979185998372],
            [33.46830963068979, 2.595627784595985],
            [33.469051911304, 2.595663053960257],
            [33.46921129579158, 2.59655168152023],
            [33.47011268870386, 2.596711305286858],
            [33.470165339861005, 2.595733729987083],
            [33.47064252943149, 2.595769097164312],
            [33.47073075207723, 2.595378058767057],
            [33.470094242697826, 2.59463179482372],
            [33.4712959666641, 2.594489142318335],
            [33.47217980919068, 2.595022027591921],
            [33.472568989914464, 2.596017204915735],
            [33.474106696373454, 2.59638988155518],
            [33.47463675269672, 2.596034203340687],
            [33.47500813240485, 2.596691695457719],
            [33.47632464130151, 2.596326834304203],
            [33.476854926695175, 2.596557686874048],
            [33.47772054779453, 2.595579802752029],
            [33.47740195219418, 2.594317992135311],
            [33.47768450558872, 2.593749121924569],
            [33.47715411419384, 2.593233892367998],
            [33.47773732473079, 2.593233671608752],
            [33.477578044447775, 2.59261164546731],
            [33.47846156358084, 2.592255841452033],
            [33.478779407291285, 2.591544774251499],
            [33.479574688507284, 2.591508925054198],
            [33.4793799822627, 2.590744719860603],
            [33.4801043998775, 2.590246781930068],
            [33.4810414064992, 2.59115288830317],
            [33.48107708937891, 2.592023781098955],
            [33.48185460371521, 2.591774662993195],
            [33.48290649138706, 2.592689596851818],
            [33.48359562227915, 2.592369409606823],
            [33.48359582529842, 2.592902626015056],
            [33.48440893717447, 2.593293318783221],
            [33.48456762636603, 2.592333480564654],
            [33.48499182072465, 2.592439963771881],
            [33.48529211494773, 2.592048824734331],
            [33.48569892421066, 2.592919574227712],
            [33.486211267553195, 2.592457261077759],
            [33.486847592777934, 2.592705855867455],
            [33.48734216924077, 2.592012486470386],
            [33.4880491029452, 2.592047758627677],
            [33.48893213968295, 2.590447785483062],
            [33.48998394381147, 2.591113883847495],
            [33.490496295238806, 2.590704901453152],
            [33.49120331877474, 2.59095344633279],
            [33.491186169935986, 2.592322029791946],
            [33.49185782051098, 2.592517283400293],
            [33.49219339696517, 2.591948390842327],
            [33.49267080931783, 2.592588057419054],
            [33.4937306749277, 2.591254611817373],
            [33.494084308417406, 2.591716587088249],
            [33.4945614557671, 2.591645307786519],
            [33.494756202435845, 2.592516147297143],
            [33.49498579475448, 2.592125034307633],
            [33.49558668413621, 2.592160343255015],
            [33.49650523756537, 2.591004699364002],
            [33.49551523483347, 2.590205265630898],
            [33.49625730883519, 2.589725091478331],
            [33.49673460261024, 2.590009278492142],
            [33.49672537421733, 2.589022837103041],
            [33.49815706420139, 2.589484395000534],
            [33.499764789845166, 2.588168498356751],
            [33.50004778521082, 2.588754924190094],
            [33.50048949222592, 2.588470362679653],
            [33.50140879305339, 2.589234265027467],
            [33.502362562238304, 2.587794220131036],
            [33.50312244174725, 2.587651732874107],
            [33.50365289961746, 2.588344688265439],
            [33.50496978131495, 2.588975129612554],
            [33.50417486661163, 2.589899674828679],
            [33.50509378296015, 2.589686023263425],
            [33.50511170524838, 2.590308099301862],
            [33.50615473283655, 2.591125261941962],
            [33.50687928340202, 2.591018323643926],
            [33.506543892000806, 2.592031565113512],
            [33.507215514728024, 2.592155709101569],
            [33.507481109726626, 2.593381982332666],
            [33.50802877033451, 2.592919647814157],
            [33.50862994448223, 2.593648116526909],
            [33.51105942469339, 2.592234129852284],
            [33.51176644104282, 2.592482680713407],
            [33.512172780486864, 2.592144807533676],
            [33.51450659191689, 2.594561068481185],
            [33.51593805103393, 2.594453844204703],
            [33.51648625422426, 2.595288985248579],
            [33.516221468607746, 2.596035591608196],
            [33.51658433318533, 2.597430656103012],
            [33.5175561261681, 2.596879274785878],
            [33.517856792293685, 2.597430132025862],
            [33.5185637188116, 2.597447618613245],
            [33.51836970157482, 2.598407469101391],
            [33.51932412203833, 2.598602580879195],
            [33.518565069877766, 2.600753508075675],
            [33.519661069321614, 2.601410673777096],
            [33.52109259311735, 2.601445625303934],
            [33.52255037107559, 2.60081406215632],
            [33.52193220978587, 2.60179186774044],
            [33.52246269909714, 2.602520356462232],
            [33.52223325410219, 2.603249171412305],
            [33.52308202011188, 2.604333012207444],
            [33.5240185973389, 2.604137114307339],
            [33.52440760648448, 2.604616832492849],
            [33.52546795898124, 2.604509749960542],
            [33.52562657990085, 2.603461044752968],
            [33.52626253681635, 2.602820927810231],
            [33.52925904441462, 2.60501469534667],
            [33.530849694881475, 2.605191750679042],
            [33.532103879562044, 2.60373379146853],
            [33.53298063078777, 2.603729620409684],
            [33.53337726932506, 2.60595493936333],
            [33.53404925048009, 2.606914422625263],
            [33.53387282495154, 2.607643224263661],
            [33.534809742640064, 2.608211573109009],
            [33.535392857057296, 2.607980263212174],
            [33.536462406505905, 2.608770738764177],
            [33.5381411861937, 2.608361220072256],
            [33.5388838243374, 2.609231818313665],
            [33.539449389267226, 2.609302656006185],
            [33.53888498406244, 2.611951153479737],
            [33.53923027220315, 2.613506199780912],
            [33.53590847745394, 2.615284976172346],
            [33.53578517290141, 2.616244797799987],
            [33.53607752781402, 2.618013151752409],
            [33.53660793627689, 2.618492803617628],
            [33.536466916946964, 2.619381541582723],
            [33.53756311761343, 2.620411936898935],
            [33.53690122004749, 2.622429520891724],
            [33.53780288065769, 2.623175617579067],
            [33.538668800896055, 2.623015282863351],
            [33.53866897606752, 2.623424061820898],
            [33.537167087235574, 2.624224528862219],
            [33.53723803797336, 2.62482880099893],
            [33.53612455012755, 2.624687090572339],
            [33.535541477032815, 2.62500726151257],
            [33.5342787475773, 2.627149527813689],
            [33.53468561702736, 2.628073575641436],
            [33.53397892586805, 2.628624850830867],
            [33.53254716042552, 2.628127809121192],
            [33.531522288687526, 2.628554814685158],
            [33.53067366191672, 2.627862005283024],
            [33.528959387995414, 2.627969382850717],
            [33.52834100033025, 2.628396212584315],
            [33.52820003130597, 2.629373820784947],
            [33.5289426182457, 2.630102222592155],
            [33.52905780112973, 2.630821997570813],
            [33.52867026522123, 2.633861441030367],
            [33.52915674067681, 2.634954308857184],
            [33.52866253701484, 2.636500816837334],
            [33.530147598604884, 2.637637697133051],
            [33.529945116543225, 2.639424023664302],
            [33.53051098240866, 2.640170267219731],
            [33.52999936849817, 2.642321094282363],
            [33.53055707047431, 2.644640297981031],
            [33.529532698199624, 2.646293679035318],
            [33.528950373401536, 2.648426751168849],
            [33.52754573169068, 2.64943157116428],
            [33.526663145008875, 2.652009123919215],
            [33.52682253937795, 2.652791079020181],
            [33.52578878330182, 2.653173658064882],
            [33.52520600036292, 2.654240322367886],
            [33.52548913406912, 2.655057778851416],
            [33.52417372830363, 2.65815983735462],
            [33.524439177775136, 2.658941755360444],
            [33.5236440807138, 2.659475307678226],
            [33.52381393506602, 2.664105240063591],
            [33.52324589078603, 2.665248464344204],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 514,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "ADILANG",
        Population: 20274,
        Key: "AGAGOADILANG",
        Dist2: "Agago",
        "Sub Country": "Adilang",
        id2_original: "Agago Adilang",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.295382719482916, 2.802180941292845],
            [33.297933775888026, 2.804923508178972],
            [33.29919343759687, 2.805744635044567],
            [33.302938100791316, 2.807078520053456],
            [33.307601493484725, 2.807111522238691],
            [33.31161790244254, 2.806254776881489],
            [33.31379624963288, 2.805638105025479],
            [33.31832281723042, 2.803240984572666],
            [33.324109187572304, 2.802212578015301],
            [33.32567495740074, 2.802109460780133],
            [33.32656028663912, 2.803238701993251],
            [33.33411079728203, 2.80157369909328],
            [33.33563741314052, 2.802468099698113],
            [33.33770523431324, 2.804768775706492],
            [33.340880195835986, 2.80610407318445],
            [33.34368556978958, 2.805880543328297],
            [33.350845998698475, 2.803131726714696],
            [33.35229543400268, 2.803333403015298],
            [33.354571089399535, 2.813200700158005],
            [33.3551911353547, 2.813927625291417],
            [33.36004634441243, 2.81361450738778],
            [33.36231913508185, 2.81392541899764],
            [33.36459199042999, 2.814444074680113],
            [33.365935271817044, 2.815482384867882],
            [33.366763888614905, 2.822441641552604],
            [33.36624869851127, 2.826700614549597],
            [33.36697304605746, 2.830543700078511],
            [33.3685236828666, 2.833867152605257],
            [33.3700738345855, 2.835632501425977],
            [33.37534351912878, 2.8389547388661],
            [33.37503652167706, 2.847991814577832],
            [33.374314312121264, 2.850900501694009],
            [33.37288098271179, 2.853265496235422],
            [33.37006883456262, 2.852221111785948],
            [33.369900037527486, 2.854265716819232],
            [33.3637146184684, 2.867791996878186],
            [33.36264448421652, 2.871502542822374],
            [33.36276810138276, 2.877178649122089],
            [33.365386455975695, 2.880467281734028],
            [33.369759571559754, 2.883605813287462],
            [33.36482729693213, 2.883938378219915],
            [33.361769614961304, 2.883409938715078],
            [33.35722678695881, 2.881681443267729],
            [33.35665305005484, 2.880989648697438],
            [33.34754534130793, 2.880323570486548],
            [33.34715511674175, 2.879562516307513],
            [33.344150141623594, 2.880463002183949],
            [33.34192492842655, 2.880625136111794],
            [33.3409383141399, 2.880094918650991],
            [33.33999728216741, 2.87854978779377],
            [33.336945978235114, 2.877950986063528],
            [33.33547685545312, 2.874837525113731],
            [33.33543048890974, 2.873176794585496],
            [33.33444313171636, 2.870063188724776],
            [33.33242386089146, 2.868356904517163],
            [33.33166633496857, 2.86667331400824],
            [33.329876348340164, 2.864505638929972],
            [33.328545033411004, 2.861830377205868],
            [33.328682439716864, 2.860999963772212],
            [33.3273058281378, 2.860354513904774],
            [33.32693814589539, 2.858117224958203],
            [33.324900143400214, 2.854816246309473],
            [33.3251091678921, 2.853482730263686],
            [33.32455023881725, 2.851587978272399],
            [33.324829042643785, 2.850184262138106],
            [33.324549470757674, 2.848850884274785],
            [33.32287414599048, 2.848360085178985],
            [33.323362487246904, 2.847447582900841],
            [33.322663868348776, 2.845201958899717],
            [33.321127487803174, 2.842324930712278],
            [33.318893241147656, 2.83986918584087],
            [33.31805492344304, 2.837202504312754],
            [33.315751009742286, 2.835167862211289],
            [33.3152621726158, 2.834255631231505],
            [33.31533164742155, 2.833062518498455],
            [33.31501301858354, 2.832842386201372],
            [33.313867678274384, 2.833641189448594],
            [33.31253439064488, 2.833138888739321],
            [33.31201077164891, 2.833569887619444],
            [33.31124881164174, 2.832947728505355],
            [33.30975727948673, 2.832886708745918],
            [33.30632871457613, 2.831116283759941],
            [33.305328899546375, 2.831260170738779],
            [33.3031266895088, 2.830722172235928],
            [33.30110326487406, 2.831129630787573],
            [33.29834142327911, 2.829861686703187],
            [33.295507939243656, 2.827636285110133],
            [33.28937054591629, 2.826199139866334],
            [33.28894590509495, 2.825630132780094],
            [33.2870578215392, 2.811243259800652],
            [33.28632004687446, 2.809217097772785],
            [33.287592219420276, 2.808863895483731],
            [33.28768736717854, 2.808528758940371],
            [33.28692546017201, 2.808026259860895],
            [33.28780610649278, 2.807355812133413],
            [33.288162977510765, 2.806493988589144],
            [33.29030559780394, 2.806924322619766],
            [33.290638515244886, 2.805464086503388],
            [33.29212628076393, 2.805092693355494],
            [33.29253107869892, 2.805523448706869],
            [33.29355459308251, 2.804972640988034],
            [33.293054437183464, 2.804063164184426],
            [33.293268597343825, 2.803680120827596],
            [33.294792230795544, 2.803966980981345],
            [33.294863283042936, 2.802530739674561],
            [33.295382719482916, 2.802180941292845],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 515,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "AGAGO TOWN COUNCIL",
        Population: 6031,
        Key: "AGAGOAGAGO TOWN COUNCIL",
        Dist2: "Agago",
        "Sub Country": "Agago T/C",
        id2_original: "Agago Agago T/C",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.2038173644192, 2.72068093857603],
            [33.20355823908729, 2.720870389671367],
            [33.20297200751603, 2.719354696626123],
            [33.197904293893, 2.712445199712544],
            [33.19726361902565, 2.711976806207664],
            [33.19604064720795, 2.711918444320112],
            [33.19569115405341, 2.711450003951137],
            [33.192255196008, 2.711333432665003],
            [33.191148751852324, 2.711626421280397],
            [33.189460282935876, 2.714086302867987],
            [33.18689805148864, 2.715199387322365],
            [33.186141489458066, 2.718537553279057],
            [33.1846739710672, 2.719310628246183],
            [33.17856491150222, 2.724403020736895],
            [33.17610548235778, 2.725850572839094],
            [33.17364626521576, 2.728745307516413],
            [33.17140917629069, 2.729758657451101],
            [33.165155370285625, 2.729575356027464],
            [33.16332377279497, 2.730022922741893],
            [33.159294495470704, 2.732707342373603],
            [33.15505562052944, 2.733549900899018],
            [33.152779059630774, 2.732997637500899],
            [33.14987428529435, 2.730656184560456],
            [33.144758385141174, 2.72777559140466],
            [33.14143510098524, 2.726460359939976],
            [33.14091169578831, 2.72585523340936],
            [33.139132373060654, 2.725802821284812],
            [33.13696061591122, 2.726276697299547],
            [33.13549538732606, 2.727066236307361],
            [33.12990933680095, 2.731605775620067],
            [33.129150507422565, 2.731579547699715],
            [33.128156289795356, 2.732605839604228],
            [33.126874372325325, 2.734947799300766],
            [33.123551505886006, 2.737842529993013],
            [33.118305270066585, 2.739645473864083],
            [33.115269928298545, 2.73969839324952],
            [33.113098147792925, 2.740303790062803],
            [33.10565373986316, 2.740659693932392],
            [33.10362579131262, 2.740383593065016],
            [33.10379520099882, 2.734081184442285],
            [33.100688334469545, 2.732044655769801],
            [33.09877612216527, 2.731332658864652],
            [33.09084409522454, 2.729552895809095],
            [33.085461806860394, 2.73040788139799],
            [33.076821911967365, 2.733541959854992],
            [33.07540556520836, 2.734610285535343],
            [33.0740601161865, 2.73696048921311],
            [33.07243132684595, 2.738456119997068],
            [33.070802466538495, 2.738812295397185],
            [33.05833796557722, 2.738599324690862],
            [33.04615677259532, 2.738955937028146],
            [33.04516511875992, 2.734683029918535],
            [33.044386055728076, 2.733757253653859],
            [33.04410270373129, 2.73183443855541],
            [33.04188018637839, 2.72668683265192],
            [33.03682154214652, 2.719805014683024],
            [33.03410794816715, 2.717207473890136],
            [33.035795235799014, 2.715999815217435],
            [33.038912011644165, 2.710973336863492],
            [33.04018133563222, 2.707736349807608],
            [33.03987520774969, 2.704374040506873],
            [33.040781878264276, 2.70261876853918],
            [33.04182449442404, 2.69885749176253],
            [33.04512260509078, 2.695517852927031],
            [33.04577989070606, 2.693124313173446],
            [33.04779722206826, 2.689682131084974],
            [33.05617291435139, 2.686000314946539],
            [33.05778223809806, 2.683743502438131],
            [33.05766883208166, 2.682352982011272],
            [33.05916481269396, 2.680210152731099],
            [33.05925542665498, 2.679070370197122],
            [33.06096673254261, 2.676551397402788],
            [33.06114801077032, 2.6753204403169],
            [33.06191865029973, 2.674021065424508],
            [33.06402669982751, 2.673017956954853],
            [33.06642929436056, 2.669416155909298],
            [33.0692060021751, 2.667854523112335],
            [33.07249275364507, 2.666874132110541],
            [33.076640943658425, 2.666987858583636],
            [33.07809170757093, 2.667534850494858],
            [33.09031942789466, 2.647143542523827],
            [33.08902727052872, 2.645433984407994],
            [33.08766717178124, 2.644431082416346],
            [33.08621625964671, 2.641422196592453],
            [33.08609126356649, 2.636669368779062],
            [33.08748495122077, 2.631893635446407],
            [33.089071499980044, 2.629933122366726],
            [33.09174586093768, 2.62516869615152],
            [33.09182503395523, 2.622946138393095],
            [33.095519115710985, 2.614921882861524],
            [33.09886175317142, 2.605951638776538],
            [33.10056163967514, 2.599205406184229],
            [33.1574323148362, 2.619118630823101],
            [33.18299353219106, 2.585798502368979],
            [33.18306298723388, 2.586747980569636],
            [33.1824063960163, 2.587505169613149],
            [33.18146174383319, 2.590002103798125],
            [33.18038874036231, 2.59101708523619],
            [33.180373543562645, 2.596799994620943],
            [33.18165560206815, 2.601567888336028],
            [33.18482780216972, 2.606931510641864],
            [33.18610964597786, 2.610040235362231],
            [33.186959062367805, 2.613390648523969],
            [33.18678339591567, 2.616934514988245],
            [33.18750468290172, 2.620301054428677],
            [33.188562044906874, 2.621686213698426],
            [33.19058246108374, 2.626895820332456],
            [33.18956600476334, 2.630731475522091],
            [33.18702428544733, 2.636612959562614],
            [33.186651805302986, 2.639527994745735],
            [33.1867876350655, 2.641028080137478],
            [33.18788826981624, 2.642928059590583],
            [33.190056871184076, 2.64530803572862],
            [33.19040840890418, 2.648309054878052],
            [33.19127392040907, 2.650515601601577],
            [33.190848177354916, 2.654248098816438],
            [33.19155089167244, 2.657778671384067],
            [33.19151384065853, 2.661422845979531],
            [33.195301874514904, 2.669643689135307],
            [33.19740861070576, 2.670853873123163],
            [33.19964066277704, 2.671559649243443],
            [33.20122074815783, 2.672669022587701],
            [33.20588613421286, 2.6779390466697],
            [33.20776797896897, 2.683865220761569],
            [33.20863436633125, 2.690863373584735],
            [33.21193256772783, 2.693170356616181],
            [33.21341225559584, 2.693573600978862],
            [33.215744894724416, 2.695565498895101],
            [33.21629747630347, 2.700432681103244],
            [33.217602231642935, 2.704164876406939],
            [33.219020438812905, 2.711238575365849],
            [33.21262589015907, 2.714240797693356],
            [33.2038173644192, 2.72068093857603],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 516,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "ARUM",
        Population: 11771,
        Key: "AGAGOARUM",
        Dist2: "Agago",
        "Sub Country": "Arum",
        id2_original: "Agago Arum",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.34893829773355, 3.034261322390603],
            [33.349203271996295, 3.031499418303396],
            [33.35102009669211, 3.027666515995499],
            [33.35266018953387, 3.021416364632367],
            [33.355591000640494, 3.016757671016971],
            [33.355748368410296, 3.01552938899265],
            [33.354190965490425, 3.01235173677884],
            [33.353666725758586, 3.010366768524998],
            [33.352428760160514, 3.009602102764122],
            [33.35117862867852, 3.007916561509471],
            [33.351130624506354, 3.006553200853458],
            [33.3516777398369, 3.005387519005041],
            [33.353183255167636, 3.007343346669426],
            [33.35581740214324, 3.009175440641523],
            [33.355990835383594, 3.008535303612116],
            [33.357583122580884, 3.010309545861728],
            [33.35995588496165, 3.009290453036513],
            [33.359579433365404, 3.008592309275884],
            [33.36056336079107, 3.008475604919616],
            [33.360766171636136, 3.009173805270839],
            [33.363746582322825, 3.007892652595166],
            [33.36389111945541, 3.007397997565484],
            [33.36470142319791, 3.007339536778525],
            [33.3657723812049, 3.007862876792078],
            [33.3659454596107, 3.00617533864207],
            [33.368260840306036, 3.006698255793107],
            [33.369042505757264, 3.007541730099851],
            [33.3712711981294, 3.008442898381136],
            [33.371560816773616, 3.009082877579307],
            [33.374889029985525, 3.009372676377791],
            [33.37567073226766, 3.010303428702492],
            [33.378044215995594, 3.011437286950045],
            [33.37850750952695, 3.012164486017554],
            [33.37928884349985, 3.012018741058228],
            [33.3801282805053, 3.01251305220513],
            [33.381315244253145, 3.013705506749587],
            [33.38348583179606, 3.013908401297304],
            [33.38397840681243, 3.015595703199615],
            [33.384615287196034, 3.016148270300804],
            [33.385696061992476, 3.016235169554255],
            [33.38349419511137, 3.018959203308673],
            [33.38161417303698, 3.020228098880588],
            [33.38137637191327, 3.020945822630765],
            [33.38061475326593, 3.021161572587707],
            [33.380591167099844, 3.021807404836635],
            [33.38028159417821, 3.021424880484969],
            [33.37974643632242, 3.022680978330157],
            [33.37962776977171, 3.023781329070668],
            [33.379961211828764, 3.024403006310458],
            [33.37965230815199, 3.026053625367469],
            [33.38108075791282, 3.026913806790326],
            [33.38188996121907, 3.026602350410512],
            [33.382914211322884, 3.028850092735195],
            [33.38670028775026, 3.033105270583351],
            [33.38783285581272, 3.038976659530209],
            [33.391004708266244, 3.043110015083329],
            [33.394578575674046, 3.049427980330325],
            [33.38524258884377, 3.070992865328737],
            [33.38377945602812, 3.070432271953789],
            [33.38389804442542, 3.069235792387238],
            [33.38451678782347, 3.068852710783841],
            [33.3842310651726, 3.068613526572978],
            [33.37673303860014, 3.068496564980101],
            [33.370639847774655, 3.069695143519032],
            [33.367188263534906, 3.069337409361885],
            [33.36357088442969, 3.071420456539772],
            [33.36190913769799, 3.071545646220728],
            [33.360354305756445, 3.072621008838219],
            [33.35510526360006, 3.071841078596102],
            [33.3533557667365, 3.072134798470375],
            [33.34946736501171, 3.070865824122649],
            [33.34694017504709, 3.07086665207705],
            [33.344160504588714, 3.071603210092609],
            [33.344040461818985, 3.066945543503683],
            [33.34448571089124, 3.064581338513967],
            [33.347585748427704, 3.059342719850278],
            [33.3502201882541, 3.056244133124494],
            [33.35074636295704, 3.053431541631016],
            [33.350056383157, 3.051230746071362],
            [33.35021807451826, 3.049722590832878],
            [33.351352979997074, 3.04862171034975],
            [33.35423110042067, 3.046908856480764],
            [33.36457627260745, 3.043068736496644],
            [33.36264761215034, 3.040274214842637],
            [33.357302865280225, 3.03725172406781],
            [33.34893829773355, 3.034261322390603],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 517,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "KALONGO TOWN COUNCIL",
        Population: 11594,
        Key: "AGAGOKALONGO TOWN COUNCIL",
        Dist2: "Agago",
        "Sub Country": "Kalongo T/C",
        id2_original: "Agago Kalongo T/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.43030199456199, 2.632754899062407],
            [33.43013111343539, 2.634388367226259],
            [33.429282832515966, 2.634566411789356],
            [33.42811668273325, 2.635491043688717],
            [33.428770845804614, 2.636183999607471],
            [33.42893037402266, 2.63751697660104],
            [33.43113979753196, 2.638102742255121],
            [33.43155535279249, 2.638733572295446],
            [33.431361671525664, 2.640866501283529],
            [33.43069005328999, 2.640831189220962],
            [33.43046080053457, 2.642288726500038],
            [33.43111497797895, 2.642981661579229],
            [33.429922282979604, 2.643826337909651],
            [33.43008248942569, 2.647167769359745],
            [33.430604174348844, 2.648047383191429],
            [33.430357037034405, 2.648882846511814],
            [33.43069296293323, 2.649255977614929],
            [33.43155881939119, 2.648758000135507],
            [33.43254858766279, 2.648846523357861],
            [33.433096746835695, 2.6496106051475],
            [33.43366214737383, 2.649148287811286],
            [33.43415707148468, 2.649254760801316],
            [33.4344223520729, 2.649787877597362],
            [33.43375104465436, 2.650659027518448],
            [33.43417559564412, 2.651707529763072],
            [33.4334427886629, 2.653636246691947],
            [33.43275324095249, 2.652872224818802],
            [33.43206433194426, 2.65393888758722],
            [33.43107459331704, 2.653974790631034],
            [33.43082762847914, 2.655361223424832],
            [33.43001478879261, 2.655823636249732],
            [33.43061581381997, 2.65612557218937],
            [33.43059826882416, 2.656481058310434],
            [33.42975013612676, 2.657156759926568],
            [33.428238979376026, 2.657077312194591],
            [33.42862753307577, 2.656295123802685],
            [33.42802653499786, 2.656046501278143],
            [33.42714341292015, 2.65773532045402],
            [33.42730318098839, 2.659779256372409],
            [33.42585405111137, 2.660224110944219],
            [33.42396335705143, 2.661504483853927],
            [33.42463437161921, 2.659744637601699],
            [33.42410412125981, 2.659655950945334],
            [33.424156938605286, 2.659051619482477],
            [33.42344996986657, 2.65903408709604],
            [33.42313156920062, 2.658269930370168],
            [33.42359084097446, 2.657523274172044],
            [33.422583278873695, 2.657114816915989],
            [33.42218579053016, 2.657639281672189],
            [33.42147886311394, 2.657746172095586],
            [33.421196333973924, 2.658492767139169],
            [33.42181520942431, 2.659327931762123],
            [33.42176237231593, 2.659878929244872],
            [33.42054294075877, 2.660128180037813],
            [33.41997775312135, 2.661248129944685],
            [33.41909396090043, 2.660999590974006],
            [33.41902363898336, 2.662101602146082],
            [33.41987195044551, 2.661976886323441],
            [33.421525182046615, 2.664029205380224],
            [33.42156099158878, 2.665362225963944],
            [33.42233876194492, 2.665681891967258],
            [33.421676475408475, 2.667148454125314],
            [33.4201568187985, 2.668090992353761],
            [33.420351697519635, 2.669459512709578],
            [33.42097047595193, 2.669992511297204],
            [33.42067016915245, 2.670454733778092],
            [33.42127112860279, 2.670543396325572],
            [33.421218296884334, 2.671112182127974],
            [33.42059976638699, 2.67130790347111],
            [33.419167914706186, 2.670597435017192],
            [33.418266551438315, 2.670686623395372],
            [33.41795765494809, 2.671904230038618],
            [33.41719784460941, 2.672455489296826],
            [33.41529546706089, 2.671051565064582],
            [33.4125081267866, 2.666581970864437],
            [33.41120399757287, 2.666224767450237],
            [33.39614857926241, 2.666170127346705],
            [33.39336305807661, 2.667184350503117],
            [33.39241510009325, 2.668496017230046],
            [33.39152838116114, 2.676006823341444],
            [33.39034413212206, 2.679881679600569],
            [33.3883892022311, 2.683399138537525],
            [33.3862515532147, 2.685452609823893],
            [33.38258332407452, 2.692997767277463],
            [33.37891001136812, 2.698542409860185],
            [33.37636214218565, 2.701642789720868],
            [33.375888288958116, 2.702775478505891],
            [33.376422281698964, 2.704444319097973],
            [33.3803946525466, 2.707423442604274],
            [33.384695016270754, 2.709697705153401],
            [33.38451199261646, 2.710665610668154],
            [33.38251847469415, 2.711127116033348],
            [33.38190640398205, 2.711721961401562],
            [33.37234312541856, 2.710904951975169],
            [33.37084349495125, 2.707364105118389],
            [33.368769715253244, 2.704752711783619],
            [33.3637983899619, 2.700886405238171],
            [33.361700194952775, 2.700083333728124],
            [33.35822851989171, 2.699883442671822],
            [33.35573066800595, 2.698904667404686],
            [33.35350786319219, 2.6990057826725],
            [33.351534657076755, 2.698554275110843],
            [33.34948683958876, 2.699207877687725],
            [33.34821351630109, 2.700740304909742],
            [33.34688996191767, 2.701293231824305],
            [33.344967263579065, 2.70282584305677],
            [33.34219491888185, 2.702701053320696],
            [33.337274338522576, 2.701421534701149],
            [33.33649993774708, 2.700869203663744],
            [33.33605000126567, 2.699513078147326],
            [33.335425435886265, 2.698885357102877],
            [33.33480006022652, 2.69529397571638],
            [33.3330507753653, 2.691652670972179],
            [33.334223894278004, 2.688964960399445],
            [33.333802957210594, 2.681933168307554],
            [33.33210666396802, 2.679905747861901],
            [33.32950538006043, 2.678374006945862],
            [33.32771798507165, 2.678374488814193],
            [33.32590736773444, 2.677199724666633],
            [33.32331784277392, 2.676831710556351],
            [33.323625989170864, 2.672211268788517],
            [33.32247975683466, 2.67043717104449],
            [33.32242226735141, 2.669642163656719],
            [33.32054353435946, 2.667638755500887],
            [33.317968103067464, 2.666494855947282],
            [33.31048159289694, 2.665308083847763],
            [33.306541188598715, 2.664120382749847],
            [33.30329050269077, 2.663724960713085],
            [33.296395337302116, 2.663825706490536],
            [33.29137155668639, 2.66323256427241],
            [33.29078033138046, 2.662341181795456],
            [33.290484058016624, 2.659072335659489],
            [33.28930182120378, 2.65818109195584],
            [33.27508703375979, 2.658165356049123],
            [33.27490950150681, 2.657689590650145],
            [33.272839170441195, 2.657690052784904],
            [33.270098470696475, 2.657808514518775],
            [33.267205758937685, 2.658559644723517],
            [33.263355876972305, 2.657846114336949],
            [33.26238181035352, 2.65705128726436],
            [33.26114451220368, 2.657558525636235],
            [33.253888179155055, 2.657376680511382],
            [33.25408787015113, 2.655778014057093],
            [33.253563290856135, 2.652874305779344],
            [33.252224954694704, 2.650430445371959],
            [33.251165160950066, 2.647100814883953],
            [33.24959326011984, 2.645897945294469],
            [33.2490250864824, 2.644964277562924],
            [33.249604412704066, 2.640133863048105],
            [33.24866973810883, 2.63680595568934],
            [33.24901503343605, 2.633605345227632],
            [33.24836870636893, 2.630590472892013],
            [33.24671918840319, 2.627494637854339],
            [33.24524304349065, 2.626497654826943],
            [33.24270676886355, 2.625702348234152],
            [33.24216317403063, 2.624326395076715],
            [33.242239926986834, 2.623009835802641],
            [33.24524133309835, 2.613406222570835],
            [33.2469353553999, 2.6127863385639],
            [33.248012867515214, 2.609843261490409],
            [33.248858534337145, 2.60271826925109],
            [33.250930382657295, 2.595582243662814],
            [33.25265071212194, 2.596764989121882],
            [33.25461246651411, 2.596729036872411],
            [33.25882776786571, 2.597519136294221],
            [33.25994113084569, 2.597145650539784],
            [33.260577142558446, 2.595990187093517],
            [33.26225618275766, 2.596256461629434],
            [33.263899663146375, 2.595491828555082],
            [33.26601156644674, 2.595109234549705],
            [33.2735492895716, 2.594938758393588],
            [33.27793263876339, 2.596395279374655],
            [33.28177640050674, 2.595372404288606],
            [33.287600053627855, 2.5963753240443],
            [33.29132904750884, 2.595894560851233],
            [33.29612041240099, 2.603820698994145],
            [33.29933783279565, 2.607303648316544],
            [33.300203943476824, 2.607747788467064],
            [33.30798926026028, 2.608092496437811],
            [33.31173650790781, 2.609868974220063],
            [33.31246137647689, 2.610864146102172],
            [33.31492714323565, 2.612027719008021],
            [33.34431731809797, 2.607967488938803],
            [33.34710975990474, 2.608020041589653],
            [33.34799353146442, 2.608393048507947],
            [33.35174902474794, 2.60786766563826],
            [33.35448783892889, 2.60576956536612],
            [33.35615782590669, 2.605191426722393],
            [33.357634374162785, 2.605413613401503],
            [33.361566114210106, 2.60586528777747],
            [33.364296570465655, 2.605535684007846],
            [33.37459021977931, 2.601613489178376],
            [33.3752088445997, 2.60180881403904],
            [33.37809819306606, 2.600945920142057],
            [33.38037808491783, 2.601016323964022],
            [33.38191546349167, 2.60034044657237],
            [33.38508772917026, 2.599992879189014],
            [33.3898768294096, 2.598747231410788],
            [33.39386174163692, 2.59733296237761],
            [33.39522223474482, 2.596248320478395],
            [33.39617652585091, 2.595981417765355],
            [33.403608240585726, 2.596307871489583],
            [33.40929004074032, 2.595799464961267],
            [33.41077442769559, 2.595301322619568],
            [33.412259496472146, 2.596882705518361],
            [33.41289625917647, 2.598517688535456],
            [33.41355915477072, 2.598935159518819],
            [33.41348867205519, 2.59957504421482],
            [33.41412514819694, 2.600321333056449],
            [33.41560207194882, 2.603973370675958],
            [33.416601864520686, 2.607785527993196],
            [33.42307364133952, 2.617665625149223],
            [33.425769927478285, 2.620819562681912],
            [33.427308828696574, 2.624658188883347],
            [33.42892669362495, 2.626763822390969],
            [33.42748743713124, 2.630150229140512],
            [33.427576479938836, 2.632123098629925],
            [33.42838965649358, 2.632656028947418],
            [33.43030199456199, 2.632754899062407],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 518,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "KOTOMOL",
        Population: 12544,
        Key: "AGAGOKOTOMOL",
        Dist2: "Agago",
        "Sub Country": "Kotomor",
        id2_original: "Agago Kotomor",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.111119906620324, 2.846703105203656],
            [33.111286636631995, 2.847540892338893],
            [33.11021529863766, 2.847277687927657],
            [33.11016787837042, 2.849240539477143],
            [33.109096561037326, 2.849216712409712],
            [33.108096754092394, 2.850006734155639],
            [33.10685869057794, 2.848833920818232],
            [33.10545414947839, 2.849528230843798],
            [33.10421648930749, 2.852807754636218],
            [33.102954736320676, 2.852975421938018],
            [33.102740569872104, 2.85400474707976],
            [33.10200248618689, 2.853262756181598],
            [33.102430967306056, 2.852760037844448],
            [33.10207385014967, 2.852568568634875],
            [33.101573918829466, 2.852784053250933],
            [33.10071701498161, 2.854483668419013],
            [33.100288495234906, 2.854435837752332],
            [33.10005035185307, 2.853669861352635],
            [33.09897903811322, 2.853622086278576],
            [33.099359886064434, 2.852903932891413],
            [33.1008120226027, 2.851874499997007],
            [33.10040717885359, 2.850414367137811],
            [33.10078801153348, 2.849552589947083],
            [33.099740450148055, 2.848810632962627],
            [33.099169142288574, 2.849480923938523],
            [33.0985858365302, 2.849062071975557],
            [33.09868101393287, 2.848511506534609],
            [33.09775240296581, 2.846764160121498],
            [33.097085820685635, 2.846836034451076],
            [33.09668100837759, 2.845663138033629],
            [33.095895338236836, 2.845064778492211],
            [33.09570475795435, 2.843580677029594],
            [33.094609625384734, 2.843293520709327],
            [33.09308604313701, 2.843892079452993],
            [33.09294316159948, 2.843389412652071],
            [33.092514670598845, 2.843772440223581],
            [33.09113386119248, 2.843533180568976],
            [33.090562429365534, 2.842647544112455],
            [33.089919697356166, 2.843246028722907],
            [33.08943160493304, 2.842492038783684],
            [33.08878882890621, 2.842635712605378],
            [33.08871734995907, 2.84179791383128],
            [33.08781259914424, 2.840601123137691],
            [33.08797917554402, 2.839643619527699],
            [33.08743155446197, 2.838734039754605],
            [33.087264789416004, 2.837178136873756],
            [33.086157666134, 2.835610325851057],
            [33.08644305910313, 2.831756405272388],
            [33.08589545239414, 2.830966518184576],
            [33.08572885263818, 2.831612834176084],
            [33.085300350857736, 2.831708611346645],
            [33.08530028258579, 2.830775060612537],
            [33.08487172870309, 2.830272412333599],
            [33.085038344628714, 2.82984152796794],
            [33.08622864561786, 2.829602069836808],
            [33.08690706410019, 2.828728305503479],
            [33.085478611644426, 2.827866668253079],
            [33.08602611594545, 2.827292130612038],
            [33.08614495048115, 2.824635082328196],
            [33.084597491911445, 2.823893147038407],
            [33.08403792323614, 2.822229546382591],
            [33.08325235011343, 2.822684414614361],
            [33.08225245154037, 2.82222967558311],
            [33.08191918106154, 2.822540886359508],
            [33.08046700050585, 2.822540987745999],
            [33.07956242216756, 2.82352248023467],
            [33.07961008318327, 2.824168780634671],
            [33.0790148999002, 2.823857633997228],
            [33.0785864394423, 2.82452791521276],
            [33.078824554078025, 2.825317827321693],
            [33.07749155929926, 2.827711648128842],
            [33.076777402241646, 2.828262252190421],
            [33.07619430399409, 2.830739799900619],
            [33.07505157239254, 2.830452626035592],
            [33.07459930747792, 2.831266522150271],
            [33.073956533247724, 2.83138624880697],
            [33.073075684806, 2.831146934550066],
            [33.07307564977168, 2.830596377616748],
            [33.07255188165539, 2.830309161546852],
            [33.072742310122564, 2.829878278092089],
            [33.07181381863145, 2.829184155439426],
            [33.07055210247555, 2.829639043376333],
            [33.06905228336201, 2.82939975477802],
            [33.06750497121774, 2.831290897788676],
            [33.0662313398079, 2.831614119890156],
            [33.0659218387515, 2.83118326563163],
            [33.06451734346603, 2.832811086767847],
            [33.06396974933343, 2.831997250954827],
            [33.063707905699474, 2.832499945140701],
            [33.06320793934494, 2.83204516150702],
            [33.06301755579353, 2.833218103153777],
            [33.06242237161213, 2.832883009518245],
            [33.06227956373649, 2.833481452529759],
            [33.06294617296611, 2.833984096724326],
            [33.0618748906673, 2.834175656945725],
            [33.061708297199544, 2.83520496387496],
            [33.061017948191896, 2.835994937792282],
            [33.06066081935745, 2.835348643088849],
            [33.060398954163894, 2.835468342406925],
            [33.06042286821509, 2.83750301627945],
            [33.0594825665729, 2.838640088994163],
            [33.05979211703664, 2.84002842661625],
            [33.05941125381405, 2.840842322273802],
            [33.06031602079856, 2.843092373520914],
            [33.05983993346091, 2.843906264326235],
            [33.05907812616736, 2.844169613060716],
            [33.059018665780414, 2.845186954891577],
            [33.0584234627344, 2.844564620797182],
            [33.058090206628584, 2.84523487925224],
            [33.058375923889535, 2.845929046099423],
            [33.05937582785251, 2.846431675007625],
            [33.059256868451016, 2.847867921223913],
            [33.05742372406143, 2.847365325241671],
            [33.056709535562774, 2.847724425701051],
            [33.055661964295886, 2.846383983073327],
            [33.05604284997637, 2.845761599381573],
            [33.0543763502585, 2.84525900068621],
            [33.053304979924775, 2.84399037317412],
            [33.053209724368685, 2.843320134631586],
            [33.05209078824068, 2.842889313446352],
            [33.05168610618831, 2.843607452442871],
            [33.05118614881697, 2.843200541997768],
            [33.050233933717465, 2.844445322576795],
            [33.04985308756288, 2.845809764169933],
            [33.048948427477896, 2.845905548238591],
            [33.04910320630306, 2.846683500338795],
            [33.04812715261085, 2.847329854192609],
            [33.04786466668147, 2.849248315550908],
            [33.04610365072099, 2.849220981310112],
            [33.044962236947946, 2.848067215746422],
            [33.0427481664537, 2.8471576785034],
            [33.04249815363202, 2.845996735009042],
            [33.04023643380016, 2.843986079132503],
            [33.039022130724966, 2.839222605298313],
            [33.03811746884338, 2.839126878993771],
            [33.036308138791945, 2.83807370070568],
            [33.034332207187944, 2.838839760145834],
            [33.03437984394916, 2.83955787025895],
            [33.03537974252222, 2.840371716004286],
            [33.03508218905911, 2.841125744114228],
            [33.03579639821899, 2.841628402929091],
            [33.036224970068005, 2.843232192856048],
            [33.03536793416781, 2.8435194676232],
            [33.03534416654203, 2.844548767124357],
            [33.03434434252913, 2.8466552813912],
            [33.0332254576051, 2.847971870591099],
            [33.03246364402333, 2.848019760742142],
            [33.03095188270642, 2.846978535082519],
            [33.02690473609455, 2.847696756766269],
            [33.02621435384924, 2.848438823927499],
            [33.02390506373149, 2.847098388411514],
            [33.02328608317825, 2.84717020799066],
            [33.023143255539644, 2.847888331759453],
            [33.02266710082834, 2.846691480095731],
            [33.02221476584511, 2.846571804371365],
            [33.022524233663894, 2.845350997686466],
            [33.02156002695368, 2.843687373140477],
            [33.02210756718732, 2.842897426016592],
            [33.02082196482803, 2.840934589686853],
            [33.020679105748385, 2.839857416212931],
            [33.020107753871486, 2.839929243420587],
            [33.01996490197838, 2.839282932075414],
            [33.02027437249209, 2.838708438680072],
            [33.02141709511051, 2.838756287943883],
            [33.02301211677953, 2.837726958156427],
            [33.02272641209497, 2.836458284685535],
            [33.023254136391806, 2.836017183342586],
            [33.02362701089655, 2.836295641179569],
            [33.02398411008662, 2.836032324743794],
            [33.02465072111286, 2.83734885697627],
            [33.02510304531629, 2.837133416130513],
            [33.02579344552791, 2.837468517507126],
            [33.02615052675168, 2.836870074763515],
            [33.027781267233024, 2.836355386714231],
            [33.028662119268034, 2.836546866690874],
            [33.02892400422449, 2.837073479529392],
            [33.0286145283209, 2.837552237433127],
            [33.02925731333087, 2.837552221283305],
            [33.03025716519154, 2.83681013545712],
            [33.02954295333671, 2.836355342750697],
            [33.02987622381554, 2.835349964687367],
            [33.02959051643606, 2.834224927587902],
            [33.03037613177959, 2.834320653401061],
            [33.03061418532988, 2.833578587932192],
            [33.0316855161377, 2.834990861275887],
            [33.032518739496346, 2.83472752839325],
            [33.032280664386484, 2.834296662732232],
            [33.033518601238484, 2.834153003126482],
            [33.033875668089195, 2.833195502251605],
            [33.03463749424737, 2.833889661081003],
            [33.03537548181285, 2.833291203027791],
            [33.03573258549448, 2.833578440788629],
            [33.03594683548636, 2.833123631559234],
            [33.03620872852768, 2.833817804787206],
            [33.036970529532994, 2.833698086456825],
            [33.03747045097176, 2.833027827589223],
            [33.039101204029535, 2.833231244694408],
            [33.03914879856992, 2.832584930503231],
            [33.04150564549881, 2.832824227415899],
            [33.04181507738494, 2.831292227466832],
            [33.04226740069007, 2.83119646551459],
            [33.04233883921301, 2.831866705703345],
            [33.042695938403085, 2.831747007807276],
            [33.042648282777265, 2.830669823085614],
            [33.04343384781512, 2.829448993323443],
            [33.04393377823703, 2.829137787090796],
            [33.04402901043693, 2.829401093430532],
            [33.04570729066143, 2.827426207843367],
            [33.04635006309501, 2.827474050395659],
            [33.046088176341925, 2.827043197290161],
            [33.046659517439025, 2.826684109248563],
            [33.046611874389605, 2.826013868755703],
            [33.04773075661872, 2.825535072886079],
            [33.04806406303014, 2.825846245990714],
            [33.04984942782641, 2.823189128900413],
            [33.05023032428666, 2.823141244001992],
            [33.05032557355457, 2.823739665123645],
            [33.0510873754582, 2.823619947547214],
            [33.05287276361067, 2.821680945657977],
            [33.05280131520623, 2.821154330314188],
            [33.047909062321125, 2.819562717504038],
            [33.0446951390679, 2.817599986107547],
            [33.04173105346482, 2.811531991521933],
            [33.041040668524595, 2.81131657549578],
            [33.04118347729857, 2.810526642221477],
            [33.03882661869158, 2.808803241429971],
            [33.03624354543145, 2.804937450376404],
            [33.03356513756346, 2.796786868519191],
            [33.03361271773082, 2.795542126661775],
            [33.03279137549013, 2.793998201756357],
            [33.03243421611295, 2.791532660185887],
            [33.03141052386293, 2.789545897339212],
            [33.03150570755382, 2.788205408350147],
            [33.03027967248099, 2.786398172189177],
            [33.02968445685859, 2.783477833678681],
            [33.02875600758824, 2.782041613972408],
            [33.02599437709741, 2.773232747181172],
            [33.02307809354556, 2.766614139199535],
            [33.02180442799976, 2.761431728170467],
            [33.02101882972424, 2.760067315608151],
            [33.0203046178694, 2.756117673995739],
            [33.01741076165694, 2.74709769762719],
            [33.01782501525861, 2.747097691346204],
            [33.018034294872045, 2.743808604626888],
            [33.01736702358406, 2.742348264528985],
            [33.01655583949261, 2.741664145274692],
            [33.014567096116004, 2.736533215524677],
            [33.01446242172416, 2.735296525529638],
            [33.01291250895714, 2.732189131797706],
            [33.01634051062406, 2.731190666445938],
            [33.01697287517673, 2.730648955949736],
            [33.019256409696965, 2.727316303350219],
            [33.02108324342168, 2.725667626150178],
            [33.023565811371185, 2.721545968585688],
            [33.02466505552985, 2.720581967877764],
            [33.027702628713044, 2.719122997535373],
            [33.0302868491218, 2.718940566672104],
            [33.03194164468982, 2.718393439020825],
            [33.03410794816715, 2.717207473890136],
            [33.03682154214652, 2.719805014683024],
            [33.04188018637839, 2.72668683265192],
            [33.04410270373129, 2.73183443855541],
            [33.044386055728076, 2.733757253653859],
            [33.04516511875992, 2.734683029918535],
            [33.04615677259532, 2.738955937028146],
            [33.05833796557722, 2.738599324690862],
            [33.070802466538495, 2.738812295397185],
            [33.07243132684595, 2.738456119997068],
            [33.0740601161865, 2.73696048921311],
            [33.07540556520836, 2.734610285535343],
            [33.076821911967365, 2.733541959854992],
            [33.085461806860394, 2.73040788139799],
            [33.09084409522454, 2.729552895809095],
            [33.09877612216527, 2.731332658864652],
            [33.100688334469545, 2.732044655769801],
            [33.10379520099882, 2.734081184442285],
            [33.10362579131262, 2.740383593065016],
            [33.10325954098479, 2.741357189622315],
            [33.10158495553104, 2.742409839917537],
            [33.10171599817143, 2.744883205729881],
            [33.10025070311088, 2.745435898829646],
            [33.09993673383425, 2.745883241579621],
            [33.10030311531613, 2.746435770013879],
            [33.0999491979588, 2.746876704890662],
            [33.09896695936592, 2.747020411951972],
            [33.09859806349956, 2.74794203341022],
            [33.09824096520781, 2.747582998398009],
            [33.09771731477081, 2.74834903970369],
            [33.09707460432101, 2.748540586068915],
            [33.09719373350409, 2.749857132933213],
            [33.09621778132152, 2.750431708400615],
            [33.09597981400952, 2.751413158733726],
            [33.097631836478264, 2.756166912921579],
            [33.106648571938024, 2.767835957700572],
            [33.11269156310881, 2.773139857105195],
            [33.11672017118817, 2.775839917564788],
            [33.118158945286574, 2.776611331386117],
            [33.12199558338971, 2.777671831993536],
            [33.123806198930296, 2.774470747258272],
            [33.12776824184711, 2.769396465139292],
            [33.128880003130924, 2.769023687791462],
            [33.12979214528391, 2.768077614194725],
            [33.13471207077133, 2.767184038085891],
            [33.136806829724485, 2.766345992351211],
            [33.138068388675194, 2.765364426032673],
            [33.142031864404906, 2.764753551557072],
            [33.14820954896938, 2.766895180626097],
            [33.15006649422241, 2.768019988109255],
            [33.1500679620696, 2.77965348793259],
            [33.15097582375024, 2.805170468713772],
            [33.15058420230381, 2.814326501428572],
            [33.148467041164096, 2.826798070828663],
            [33.14602830650887, 2.838060849020005],
            [33.1461591281637, 2.840449183949392],
            [33.14404376994277, 2.839614019598258],
            [33.142901062595705, 2.839638101672382],
            [33.142258186855905, 2.838896123953928],
            [33.141258352063204, 2.839255311387582],
            [33.13830611434041, 2.837364622820968],
            [33.13727039095381, 2.836155918801238],
            [33.134580080408305, 2.834719999853266],
            [33.130520526265734, 2.829825307130301],
            [33.13052043823085, 2.829035381043017],
            [33.129734804921014, 2.828891845498453],
            [33.12868717885689, 2.827551470754067],
            [33.127306370348826, 2.827192569491913],
            [33.12725888270796, 2.82836549451645],
            [33.12623534496818, 2.829586415141688],
            [33.12566401824413, 2.829849785979345],
            [33.12478310692031, 2.829203569493222],
            [33.12385481305852, 2.830639908002652],
            [33.12399772244383, 2.831310134157879],
            [33.12475955219525, 2.83147761437253],
            [33.124878626581115, 2.831884534327539],
            [33.1246169338641, 2.833536231216559],
            [33.12404560175017, 2.833775663412359],
            [33.122569810773825, 2.835858362808481],
            [33.119201422207496, 2.838120789158745],
            [33.1188921053057, 2.839796430014922],
            [33.11682103672322, 2.840873817082021],
            [33.11633338177966, 2.844643985159289],
            [33.1158334666291, 2.844955213237189],
            [33.11480970431051, 2.844165389002063],
            [33.11414311664046, 2.844165455395496],
            [33.113595602457934, 2.844572442660107],
            [33.110715006277395, 2.844764226325025],
            [33.11014372087581, 2.845578146455457],
            [33.111119906620324, 2.846703105203656],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 519,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "LAMIYO",
        Population: 8484,
        Key: "AGAGOLAMIYO",
        Dist2: "Agago",
        "Sub Country": "Lamiyo",
        id2_original: "Agago Lamiyo",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.56781065536272, 3.037029392943597],
            [33.52196379095799, 3.037120877157252],
            [33.515647595159855, 3.038503233962313],
            [33.50224706135063, 3.040484210850984],
            [33.496685409966986, 3.039485102195786],
            [33.493424645859875, 3.039989793153872],
            [33.492567498568604, 3.039440299851643],
            [33.48948476887268, 3.038808724209292],
            [33.487461693682576, 3.039240741734511],
            [33.48441493881888, 3.039266881822627],
            [33.482907509178276, 3.03999913325033],
            [33.47307025163964, 3.037277970953447],
            [33.47126024695345, 3.037327133066631],
            [33.46814067734776, 3.038262718943169],
            [33.46458014453203, 3.03827722428324],
            [33.45725564642132, 3.035781481221287],
            [33.45370678721271, 3.035209591693681],
            [33.45261129891025, 3.035377888190426],
            [33.45149173845312, 3.034876095256788],
            [33.45025339107105, 3.035116263869752],
            [33.44891946204441, 3.034590692561353],
            [33.446359659641686, 3.035753190808761],
            [33.445621250766365, 3.035490447951505],
            [33.44397826445105, 3.036377077793306],
            [33.439596273511974, 3.036978396342148],
            [33.43724989554942, 3.035723566475186],
            [33.43453311344911, 3.034975285357896],
            [33.432699950194916, 3.034043687636637],
            [33.431295756743374, 3.034570854175971],
            [33.43046261243648, 3.034475759097104],
            [33.428058974959406, 3.035721159677453],
            [33.42716613490693, 3.035111833314145],
            [33.42502370236164, 3.034658820345871],
            [33.42466674869866, 3.034898250730585],
            [33.42411908539582, 3.034372401228866],
            [33.42290932420271, 3.034287075071089],
            [33.42270129145089, 3.030175572205298],
            [33.42520965362549, 3.022292609005573],
            [33.425351776984904, 3.020402929252594],
            [33.42380147075577, 3.011697482559364],
            [33.42326392068638, 3.006136688885382],
            [33.4230016296914, 3.004821321591764],
            [33.42129940936458, 3.003853737619768],
            [33.4202038734514, 3.002060547460422],
            [33.41833486562072, 3.000566845795155],
            [33.41740606870239, 2.999132328162727],
            [33.417072363438955, 2.997793092640551],
            [33.416513167564474, 2.998212030817974],
            [33.41596548270206, 2.997542665676797],
            [33.41534663689608, 2.99759090738267],
            [33.4144462707582, 2.995240581308421],
            [33.413779719020724, 2.995528065704024],
            [33.4139458902803, 2.994235431335117],
            [33.41275510599755, 2.993374162856495],
            [33.41304042350819, 2.992320838310814],
            [33.41239714622146, 2.991172121439332],
            [33.4129559701934, 2.989316837056767],
            [33.41278884671963, 2.988072186302677],
            [33.41343165598412, 2.988000137994525],
            [33.413812259593584, 2.987090407150404],
            [33.413502236616, 2.985726129734242],
            [33.414002135596874, 2.985462628427284],
            [33.413882731529306, 2.984529157402203],
            [33.41466819595586, 2.983906512813107],
            [33.414512507137346, 2.981429133541914],
            [33.413892984899945, 2.980112848459872],
            [33.413154724246645, 2.979634391499216],
            [33.41265420273327, 2.978174450436922],
            [33.41193996842054, 2.978294400147031],
            [33.41245135415897, 2.976941790307504],
            [33.41152247100235, 2.976032543723789],
            [33.41099859598654, 2.97581731415654],
            [33.410427296211935, 2.976128706066084],
            [33.41023659106363, 2.975506420948938],
            [33.40923667632089, 2.975650405265002],
            [33.40885552294246, 2.975100004865466],
            [33.40699828394032, 2.974693773435786],
            [33.40602172359832, 2.973593059323207],
            [33.40502173878697, 2.973593428930782],
            [33.40428386171429, 2.974120305289865],
            [33.40304518914207, 2.972445185009244],
            [33.40198560650149, 2.972218179317195],
            [33.40172346732182, 2.971548059124653],
            [33.402246956062044, 2.970710084231595],
            [33.40210389575979, 2.970135645138029],
            [33.40165155179342, 2.970183687991587],
            [33.4005079227749, 2.967957995398797],
            [33.39905546194481, 2.967599467890157],
            [33.39817417332861, 2.966570515623569],
            [33.39693596428706, 2.966164040629662],
            [33.39787545834379, 2.962797104115971],
            [33.39824176436722, 2.958110823668806],
            [33.39897684139114, 2.955644163639379],
            [33.398975299882125, 2.951327975807148],
            [33.39688834549215, 2.946395937129523],
            [33.397013169095835, 2.943319806469972],
            [33.40336856467805, 2.940251237324774],
            [33.40510577258855, 2.93807237077052],
            [33.43475626933874, 2.894084703333281],
            [33.421841867828675, 2.897913469299929],
            [33.41097929927593, 2.897766857926819],
            [33.40806086515728, 2.889655763367831],
            [33.40657214472909, 2.884136859898874],
            [33.404512389529295, 2.880802935677354],
            [33.40302434912577, 2.877123836629017],
            [33.40302374276297, 2.875399010996113],
            [33.40359495899424, 2.87367398268279],
            [33.40519520795991, 2.871258655871151],
            [33.40622432154267, 2.870798334865703],
            [33.409311167319196, 2.868037507585945],
            [33.40943405235847, 2.867542526816203],
            [33.41420651849369, 2.869620694379999],
            [33.417930497080405, 2.86390638303593],
            [33.41948698731196, 2.862340240416724],
            [33.421255850056454, 2.860916343345686],
            [33.42444018549918, 2.859420755790434],
            [33.42826188372082, 2.858992354992148],
            [33.4324376915393, 2.859204267558944],
            [33.436260565655644, 2.861906972529822],
            [33.43845448783639, 2.861621482391489],
            [33.443375682643286, 2.859245948639026],
            [33.44640016737281, 2.842935305312841],
            [33.44468639650803, 2.843630131198593],
            [33.4436623485252, 2.84260125974405],
            [33.44282920152335, 2.842769140273128],
            [33.44163874871896, 2.842362677240213],
            [33.44154331709304, 2.841836101804021],
            [33.441067165975035, 2.841740550672218],
            [33.44144735905439, 2.839873346213215],
            [33.44107786491006, 2.838568939999426],
            [33.440291872274116, 2.837539963547412],
            [33.44033925211716, 2.836917598414586],
            [33.44107721991968, 2.836869439535733],
            [33.441124644678474, 2.836390694807482],
            [33.43941038962178, 2.835745056189548],
            [33.43919565184472, 2.834500435809296],
            [33.437672094749786, 2.834524954037007],
            [33.437838197737385, 2.833112629880655],
            [33.43667172456118, 2.833137009966335],
            [33.43694519059828, 2.832335041883717],
            [33.43630249901312, 2.832526771952126],
            [33.435183363459096, 2.831833033998254],
            [33.43449312853751, 2.832192340263411],
            [33.43430247369487, 2.831617932171451],
            [33.433874074322404, 2.831905332743817],
            [33.432993068675486, 2.831379061188402],
            [33.43225513860218, 2.831522958004008],
            [33.43239767159338, 2.830709060275027],
            [33.43204046370718, 2.830374087038282],
            [33.431421606223104, 2.830637612018629],
            [33.43118341792552, 2.830278655186912],
            [33.43158784126305, 2.829536466003804],
            [33.43132581886437, 2.829105702489316],
            [33.43211129137573, 2.828794239559453],
            [33.43103998033085, 2.828651020703949],
            [33.43108723171478, 2.827669599842939],
            [33.42917033739125, 2.826246082554935],
            [33.42855140175376, 2.826270251040456],
            [33.427860569452506, 2.825001863798711],
            [33.42636039999601, 2.823877395365992],
            [33.42545585669202, 2.824093164368684],
            [33.42602761460744, 2.82524190517735],
            [33.42538502902343, 2.825696941804611],
            [33.42578987367087, 2.826103714849233],
            [33.42507610109217, 2.827205062409464],
            [33.42402823427957, 2.8260325570093],
            [33.42421836091282, 2.825194713020014],
            [33.42364626702751, 2.823112425133913],
            [33.42236046344557, 2.822275121859668],
            [33.42366927557687, 2.820910246084606],
            [33.42266920273064, 2.820264316221947],
            [33.422371351026825, 2.819462549195485],
            [33.42256134920099, 2.818241712137979],
            [33.42149000491841, 2.817978799844036],
            [33.42008565336338, 2.818481976528035],
            [33.4191806932411, 2.817500900585928],
            [33.415847772857134, 2.817119117760983],
            [33.415418795867936, 2.815778820059403],
            [33.414180779964155, 2.815420217529672],
            [33.41306147822183, 2.81417589926366],
            [33.41303744559305, 2.813505682966183],
            [33.41251364064582, 2.81329044316216],
            [33.41226307446192, 2.811555126699574],
            [33.411286562628966, 2.810167144430493],
            [33.41138130345041, 2.808778782774555],
            [33.41264270609425, 2.807988409034407],
            [33.41408291031058, 2.80853871826303],
            [33.415463582274725, 2.808418533458575],
            [33.41716525103596, 2.807257000296085],
            [33.418546227528985, 2.807998535247681],
            [33.42402204219231, 2.809600310686864],
            [33.42658111606132, 2.809563465712381],
            [33.428532889272375, 2.808820716896712],
            [33.43086597306705, 2.809250705531734],
            [33.430889569114605, 2.808700154384848],
            [33.431698907168155, 2.808556233212091],
            [33.43200820251036, 2.808101328958374],
            [33.43191264961193, 2.807191767556943],
            [33.43322181478112, 2.806856172942769],
            [33.43326884607782, 2.805276333921545],
            [33.43454147227284, 2.802678737753872],
            [33.43404065611206, 2.800237391533884],
            [33.43444495548209, 2.799160086159906],
            [33.43496842086612, 2.798489667447659],
            [33.43826481395405, 2.796824828274553],
            [33.4387406434752, 2.79610655900679],
            [33.43945480682103, 2.796130228350729],
            [33.4405018076577, 2.795004810633555],
            [33.44178713153926, 2.794597403163864],
            [33.44264425008445, 2.794956133207785],
            [33.442692168018354, 2.795769958991514],
            [33.44228750033904, 2.795841918123024],
            [33.44226390069823, 2.79636853860039],
            [33.44300213979197, 2.797110287713184],
            [33.44371631212094, 2.797181830440805],
            [33.44383506670657, 2.796463686108797],
            [33.44697719839892, 2.796103432105157],
            [33.44741848859574, 2.798461017549946],
            [33.448275502038044, 2.798532502771527],
            [33.449013837251506, 2.799513618872812],
            [33.450942106941476, 2.799656494075426],
            [33.452109149649566, 2.80121192045194],
            [33.45456155846006, 2.802455657658094],
            [33.458096756988176, 2.802801357362302],
            [33.45838287579603, 2.803974131085123],
            [33.459358796537565, 2.803734383209759],
            [33.46193007132475, 2.804523277586966],
            [33.46197806112386, 2.805504647072182],
            [33.46269253888004, 2.806318214299737],
            [33.46401371003301, 2.806281779259491],
            [33.4643714748747, 2.807981123472454],
            [33.465133504052105, 2.808674977938357],
            [33.47044210720677, 2.808744654605094],
            [33.4732398769215, 2.810383166302373],
            [33.47464430213836, 2.810167168655847],
            [33.475382423552816, 2.810549848300623],
            [33.47635827512407, 2.810142537759868],
            [33.47697742006902, 2.810644937232786],
            [33.47840559314875, 2.810309244017834],
            [33.4809805402488, 2.810522918697301],
            [33.48293284705917, 2.81119232740346],
            [33.4843619076744, 2.813010904026542],
            [33.48643319364916, 2.813536636588083],
            [33.48805180148431, 2.812777869309026],
            [33.49059896818422, 2.812776795321115],
            [33.49164574354376, 2.811220481716038],
            [33.49730963937643, 2.807101009308425],
            [33.4998681589849, 2.805843248720103],
            [33.50130323561759, 2.805965869791267],
            [33.502310375510184, 2.805058978705552],
            [33.50466097914786, 2.804311472554661],
            [33.50823162250208, 2.804505424318217],
            [33.511298175336336, 2.80394421621346],
            [33.511563671520264, 2.804779454646944],
            [33.51207627896748, 2.804779229439914],
            [33.51248256091934, 2.804174755675694],
            [33.51296007298501, 2.804761071113771],
            [33.51483375834338, 2.804831334808245],
            [33.51873178910969, 2.805887133543687],
            [33.58968735622297, 2.796993299516742],
            [33.59132233854908, 2.796948042471987],
            [33.603765269163745, 2.799240473787921],
            [33.60389855849067, 2.81592485242176],
            [33.604040934276675, 2.851322887968269],
            [33.60546074224447, 2.860340343589552],
            [33.605296331682865, 2.864274119189883],
            [33.604101107925985, 2.866879788177002],
            [33.60453981097475, 2.870080907300071],
            [33.60395744575247, 2.870708937264461],
            [33.60160570933927, 2.870375402200998],
            [33.59971212719565, 2.870669340769438],
            [33.594542460177806, 2.873967571397135],
            [33.59089085436194, 2.875151694043849],
            [33.58564827648234, 2.878418544441596],
            [33.58199682427838, 2.879958346223409],
            [33.57777244095926, 2.880295292256593],
            [33.57721067500478, 2.880525738412463],
            [33.576982111257124, 2.881216350781824],
            [33.57210530400504, 2.929040677963625],
            [33.57056775385296, 2.933958610521346],
            [33.57104789079589, 2.936866800825421],
            [33.57307873192163, 2.940203133067645],
            [33.57582746979152, 2.943298467329764],
            [33.58008489224849, 2.94604774115492],
            [33.5795453021051, 2.948977382501586],
            [33.58057813561144, 2.954092758063434],
            [33.58029814061884, 2.955944671089029],
            [33.57787584962487, 2.960392301726351],
            [33.57545417846846, 2.966053505687237],
            [33.575612345738875, 2.970081283049447],
            [33.57429321465989, 2.974800338721785],
            [33.57526445068719, 2.981464117725322],
            [33.57503639987762, 2.983159085141355],
            [33.572583789844515, 2.989458492505904],
            [33.57298001336014, 2.997134393601897],
            [33.57110211669971, 3.000543187006243],
            [33.57090872199546, 3.001858275077617],
            [33.56819034448721, 3.037028238435616],
            [33.56781065536272, 3.037029392943597],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 520,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "LAPONO",
        Population: 22060,
        Key: "AGAGOLAPONO",
        Dist2: "Agago",
        "Sub Country": "Lapono",
        id2_original: "Agago Lapono",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.23175702869393, 2.95570856969822],
            [33.228410550037374, 2.956126623170204],
            [33.21932415741382, 2.956128465854479],
            [33.20609817434917, 2.954912973570694],
            [33.20125213439555, 2.955116874776949],
            [33.19907446543325, 2.955813198136652],
            [33.19895550513342, 2.955234126655662],
            [33.196460333820475, 2.947457253125422],
            [33.19055347694112, 2.934053495396296],
            [33.18265371299382, 2.918994402378492],
            [33.18295529180773, 2.9166007011324],
            [33.18484015580151, 2.912061908439585],
            [33.184667999067194, 2.907523454526076],
            [33.18392491086752, 2.905800101600012],
            [33.18352413019848, 2.900802090592705],
            [33.18761839883689, 2.896115007870239],
            [33.19026490393586, 2.893727847808218],
            [33.1948439205696, 2.890579981327016],
            [33.1952219532007, 2.890030760110189],
            [33.19492768218163, 2.889016984945533],
            [33.195221632502175, 2.88815095733391],
            [33.194591339464516, 2.887665274645206],
            [33.196439596212144, 2.885573938030993],
            [33.19597731687872, 2.884834770404599],
            [33.19478004586132, 2.885574225127382],
            [33.194191645756966, 2.884370407715644],
            [33.19471670115906, 2.88367331245954],
            [33.19335107148435, 2.882617478171189],
            [33.19284668092705, 2.881286916655722],
            [33.19221640765236, 2.880885717579486],
            [33.19280430110689, 2.879111421677233],
            [33.192573140329785, 2.878604547284547],
            [33.19190090045996, 2.878477933397137],
            [33.191774760824366, 2.877886555812976],
            [33.19227890344666, 2.877759741774101],
            [33.19240469543421, 2.876281224532304],
            [33.19150134688956, 2.875943434856687],
            [33.19148018797136, 2.875035218855999],
            [33.19015649165412, 2.873409094868963],
            [33.18942134905314, 2.873979494991305],
            [33.188728076927575, 2.873683910939172],
            [33.18837071273452, 2.87216323050383],
            [33.188706698820454, 2.871423924983145],
            [33.18960992878749, 2.871064710822328],
            [33.18843342053124, 2.870262294570911],
            [33.188517305212464, 2.869396303841711],
            [33.18752989861174, 2.868826189428626],
            [33.18671066651366, 2.868995295273953],
            [33.184570216550206, 2.866195486053079],
            [33.18346856580489, 2.866692242049692],
            [33.18141677686502, 2.864859053006575],
            [33.18099889047632, 2.864935516240724],
            [33.18016298295162, 2.864209881064497],
            [33.180049070285385, 2.864591882486222],
            [33.17966913951408, 2.864439149760626],
            [33.17966897871563, 2.863407795555366],
            [33.17841518120898, 2.862720423849241],
            [33.17852899865379, 2.861727250025901],
            [33.17792104402232, 2.861039775928662],
            [33.17898465470862, 2.860237445957788],
            [33.17868057049335, 2.859206139111872],
            [33.17761670738046, 2.858365943426495],
            [33.17621075053605, 2.856341651104077],
            [33.17330075339454, 2.853954432043269],
            [33.17243667110928, 2.854095280943417],
            [33.17222682196396, 2.854623006368519],
            [33.172856733217586, 2.855467222454209],
            [33.172192027518044, 2.855924657946198],
            [33.172751916891926, 2.85645226768943],
            [33.17250720952033, 2.857859488698498],
            [33.17128270607509, 2.858422546727715],
            [33.16995312309778, 2.85821166758836],
            [33.169323396897084, 2.858633916595303],
            [33.16823865963194, 2.857930484874989],
            [33.168623437712554, 2.857297194806137],
            [33.16834351638181, 2.857191696820015],
            [33.16718900247696, 2.857860280027168],
            [33.166943953745566, 2.856945645469231],
            [33.16746860760073, 2.855784640974453],
            [33.16848322776468, 2.855538234928223],
            [33.16816808888154, 2.853849659585907],
            [33.16746825635946, 2.853357247659816],
            [33.167258169160576, 2.852266710305186],
            [33.166698274396815, 2.851668738198198],
            [33.16578865650978, 2.85216138501725],
            [33.16564857861429, 2.85128191539123],
            [33.16477390339519, 2.851457938567475],
            [33.16470385276933, 2.850930254755441],
            [33.16344414075482, 2.849910226384228],
            [33.16207964834726, 2.850191857867507],
            [33.16211452364155, 2.849382720406217],
            [33.16330403501155, 2.84881967768733],
            [33.16207926925822, 2.847483025235663],
            [33.163408770488836, 2.847201400267533],
            [33.16389840172602, 2.845794144685397],
            [33.16274389141446, 2.846427542472349],
            [33.162848696960324, 2.845301779556915],
            [33.16351344577898, 2.845160965469109],
            [33.16368831093388, 2.844633246472458],
            [33.162568571712036, 2.843718735084102],
            [33.162008806305664, 2.844000252340877],
            [33.16232354993006, 2.842944818427074],
            [33.1620785856403, 2.842593056553526],
            [33.16109863325979, 2.843684075897039],
            [33.16064630276815, 2.843612323391391],
            [33.160670217717644, 2.844378315454572],
            [33.15950677096563, 2.844100207683427],
            [33.15898294715378, 2.843525785770569],
            [33.15922092883884, 2.842927320146627],
            [33.15857808723499, 2.842448670341772],
            [33.158125966949136, 2.843980713823463],
            [33.157388046757305, 2.84465105605831],
            [33.15493608171458, 2.845560999920366],
            [33.15365047216875, 2.845226057904167],
            [33.153031679363394, 2.84656662031017],
            [33.151650979551476, 2.847260983740569],
            [33.15065097857045, 2.846375434485017],
            [33.15003200161046, 2.846327647444439],
            [33.149960493917206, 2.845681346860937],
            [33.1486510233208, 2.84486765289981],
            [33.14791260366568, 2.841660168673464],
            [33.14732923682186, 2.840858339289999],
            [33.1461591281637, 2.840449183949392],
            [33.14602830650887, 2.838060849020005],
            [33.148467041164096, 2.826798070828663],
            [33.15058420230381, 2.814326501428572],
            [33.15097582375024, 2.805170468713772],
            [33.1500679620696, 2.77965348793259],
            [33.15006649422241, 2.768019988109255],
            [33.14820954896938, 2.766895180626097],
            [33.142031864404906, 2.764753551557072],
            [33.138068388675194, 2.765364426032673],
            [33.136806829724485, 2.766345992351211],
            [33.13471207077133, 2.767184038085891],
            [33.12979214528391, 2.768077614194725],
            [33.128880003130924, 2.769023687791462],
            [33.12776824184711, 2.769396465139292],
            [33.123806198930296, 2.774470747258272],
            [33.12199558338971, 2.777671831993536],
            [33.118158945286574, 2.776611331386117],
            [33.11672017118817, 2.775839917564788],
            [33.11269156310881, 2.773139857105195],
            [33.106648571938024, 2.767835957700572],
            [33.097631836478264, 2.756166912921579],
            [33.09597981400952, 2.751413158733726],
            [33.09621778132152, 2.750431708400615],
            [33.09719373350409, 2.749857132933213],
            [33.09707460432101, 2.748540586068915],
            [33.09771731477081, 2.74834903970369],
            [33.09824096520781, 2.747582998398009],
            [33.09859806349956, 2.74794203341022],
            [33.09896695936592, 2.747020411951972],
            [33.0999491979588, 2.746876704890662],
            [33.10030311531613, 2.746435770013879],
            [33.09993673383425, 2.745883241579621],
            [33.10025070311088, 2.745435898829646],
            [33.10171599817143, 2.744883205729881],
            [33.10158495553104, 2.742409839917537],
            [33.10325954098479, 2.741357189622315],
            [33.10362579131262, 2.740383593065016],
            [33.10565373986316, 2.740659693932392],
            [33.113098147792925, 2.740303790062803],
            [33.115269928298545, 2.73969839324952],
            [33.118305270066585, 2.739645473864083],
            [33.123551505886006, 2.737842529993013],
            [33.126874372325325, 2.734947799300766],
            [33.128156289795356, 2.732605839604228],
            [33.129150507422565, 2.731579547699715],
            [33.12990933680095, 2.731605775620067],
            [33.13549538732606, 2.727066236307361],
            [33.13696061591122, 2.726276697299547],
            [33.139132373060654, 2.725802821284812],
            [33.14091169578831, 2.72585523340936],
            [33.14143510098524, 2.726460359939976],
            [33.144758385141174, 2.72777559140466],
            [33.14987428529435, 2.730656184560456],
            [33.152779059630774, 2.732997637500899],
            [33.15505562052944, 2.733549900899018],
            [33.159294495470704, 2.732707342373603],
            [33.16332377279497, 2.730022922741893],
            [33.165155370285625, 2.729575356027464],
            [33.17140917629069, 2.729758657451101],
            [33.17364626521576, 2.728745307516413],
            [33.17610548235778, 2.725850572839094],
            [33.17856491150222, 2.724403020736895],
            [33.1846739710672, 2.719310628246183],
            [33.186141489458066, 2.718537553279057],
            [33.18689805148864, 2.715199387322365],
            [33.189460282935876, 2.714086302867987],
            [33.191148751852324, 2.711626421280397],
            [33.192255196008, 2.711333432665003],
            [33.19569115405341, 2.711450003951137],
            [33.19604064720795, 2.711918444320112],
            [33.19726361902565, 2.711976806207664],
            [33.197904293893, 2.712445199712544],
            [33.20297200751603, 2.719354696626123],
            [33.20355823908729, 2.720870389671367],
            [33.2038173644192, 2.72068093857603],
            [33.207476870918, 2.728419635430104],
            [33.207661445962785, 2.732426035369621],
            [33.20873593524717, 2.73577793415005],
            [33.20986187553944, 2.736317485243366],
            [33.21275378869594, 2.739224496511916],
            [33.21563233042942, 2.740434350851122],
            [33.215867915409326, 2.740907931264573],
            [33.2161561317834, 2.743012879983218],
            [33.21709841870237, 2.744644073971704],
            [33.21733640308239, 2.749865145651434],
            [33.219241494441384, 2.753790482800243],
            [33.21824345717757, 2.763413409496765],
            [33.21696797523828, 2.766927441897461],
            [33.21690942484467, 2.768584455163988],
            [33.21773354916781, 2.76964951748986],
            [33.21932270843127, 2.77047772416844],
            [33.221971541065166, 2.773081086358071],
            [33.22200111629927, 2.773879992315574],
            [33.223678969823986, 2.776868192858387],
            [33.22444503153873, 2.782046174727328],
            [33.22597532060838, 2.782667255530832],
            [33.231419116620025, 2.782251943445674],
            [33.24004962681331, 2.777066232582024],
            [33.24287149563214, 2.776206879411093],
            [33.24421412484233, 2.777214274243399],
            [33.24433180773779, 2.778159367006027],
            [33.24198306720604, 2.783239863567928],
            [33.23822407318786, 2.786548548228799],
            [33.23646217687839, 2.788793561266181],
            [33.23611053315705, 2.79292852623432],
            [33.23752084503399, 2.795054755866793],
            [33.23975448622501, 2.801551985846018],
            [33.24198779054781, 2.806277113621873],
            [33.243751586794104, 2.813128847967911],
            [33.243518544944784, 2.822461933205768],
            [33.24389295107711, 2.825684278398433],
            [33.244763433858765, 2.825339008072904],
            [33.24464168788327, 2.826013101630189],
            [33.245007421679844, 2.826350058091175],
            [33.247414409872924, 2.824970768720511],
            [33.247094017642006, 2.822902674535772],
            [33.24764230976556, 2.821952733371406],
            [33.24841929140088, 2.821722771648628],
            [33.24870286617989, 2.821179370112654],
            [33.249470193620844, 2.82103142013903],
            [33.24956569262038, 2.82227612764968],
            [33.249216450095815, 2.825199512268182],
            [33.25080916848445, 2.830872783920451],
            [33.25008654839854, 2.834558366368351],
            [33.250281611274275, 2.844547765839747],
            [33.252597083597784, 2.846971879604418],
            [33.25336979554057, 2.851820950451366],
            [33.25308204988371, 2.859240353718761],
            [33.2522140096213, 2.859579992963756],
            [33.251132534138954, 2.861844472138294],
            [33.25231267697883, 2.8696663917952],
            [33.253132881054064, 2.871072489439656],
            [33.25327826350132, 2.872202261719338],
            [33.25277309051142, 2.87347290362264],
            [33.25083905453562, 2.874819791360078],
            [33.24548298440135, 2.877364276247837],
            [33.243252168411914, 2.882600989822576],
            [33.24310413054464, 2.884798036394607],
            [33.2437315103458, 2.88664061463083],
            [33.243825034848356, 2.888813313969024],
            [33.24533707733796, 2.890828903555127],
            [33.2454862605572, 2.892624149839599],
            [33.2440720365172, 2.900266909575682],
            [33.24349356279674, 2.901624822187234],
            [33.244122361936064, 2.91001387244093],
            [33.24349557053139, 2.910983856538659],
            [33.24229067102058, 2.915057479901919],
            [33.24092753417081, 2.917466357050506],
            [33.23935447990373, 2.917480383108601],
            [33.2393781469182, 2.916810142064465],
            [33.23837815492034, 2.916570977600456],
            [33.23565257561846, 2.918689988662298],
            [33.23474786522784, 2.918666240204681],
            [33.23450965357406, 2.918067869698193],
            [33.23267660799914, 2.918906050170794],
            [33.23098601277043, 2.917853164520395],
            [33.22898606919888, 2.917518461783129],
            [33.22846202170653, 2.916225963514156],
            [33.22494992245765, 2.914156118108544],
            [33.22397378701877, 2.914132374040966],
            [33.22075930231849, 2.912098362549323],
            [33.21924385431566, 2.912186382447079],
            [33.21870723579919, 2.915968328357358],
            [33.219303977659294, 2.923897372460549],
            [33.21900785700902, 2.931527377085034],
            [33.21960420720365, 2.937361923481598],
            [33.219529815020024, 2.946133965025317],
            [33.224913639503306, 2.949751016772939],
            [33.23175702869393, 2.95570856969822],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 521,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "LIRA PALWO",
        Population: 16310,
        Key: "AGAGOLIRA PALWO",
        Dist2: "Agago",
        "Sub Country": "Lira Palwo",
        id2_original: "Agago Lira Palwo",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.39693596428706, 2.966164040629662],
            [33.39555514140597, 2.966403911249022],
            [33.39507886901535, 2.966140779418018],
            [33.39418542978661, 2.964405694756512],
            [33.39458978664883, 2.963304454552381],
            [33.39413739417342, 2.963232811017988],
            [33.39377991140271, 2.962227595043581],
            [33.393351379079576, 2.962299554427511],
            [33.39280336723039, 2.961102918211861],
            [33.38948128322368, 2.958913891389886],
            [33.38705313162082, 2.959848265052134],
            [33.385505550880275, 2.959800940340367],
            [33.38524330929263, 2.958795697926548],
            [33.384457750542985, 2.959155017750368],
            [33.38386240017326, 2.958772231120121],
            [33.382386431330524, 2.959251482992587],
            [33.38119590306765, 2.958988591683323],
            [33.38069574537197, 2.958462158467136],
            [33.37968388752749, 2.958498405623109],
            [33.37877869204663, 2.957110386486733],
            [33.377659612188154, 2.956895343425271],
            [33.37654005712092, 2.955268038712191],
            [33.37489705643259, 2.954646237966327],
            [33.3748015843825, 2.953928157776718],
            [33.37425390850323, 2.953665040028364],
            [33.3692657739363, 2.952936653958248],
            [33.36901383243171, 2.954122660021621],
            [33.36851572558981, 2.954177195141039],
            [33.36813102476435, 2.953661853451365],
            [33.36766114029373, 2.953962700549685],
            [33.366533826477394, 2.953817564197908],
            [33.36656363257852, 2.951920842596022],
            [33.36609166401643, 2.950911458199471],
            [33.36491999318798, 2.950345892167753],
            [33.36473701444944, 2.949091674513786],
            [33.36268273088807, 2.947914552708864],
            [33.36172348826811, 2.945574567014194],
            [33.359547158693886, 2.943326752949446],
            [33.36013953653832, 2.940313233679226],
            [33.35899779398187, 2.938141560469717],
            [33.35908878972688, 2.937239062625928],
            [33.35668389101516, 2.933782922224013],
            [33.35408170340243, 2.931841150760612],
            [33.35345754945142, 2.930617660891664],
            [33.3504600635878, 2.929471401896736],
            [33.34831408359545, 2.926795258298852],
            [33.34876935337469, 2.923093459532283],
            [33.34774989039305, 2.922634894682339],
            [33.34633332264848, 2.917128737559408],
            [33.34617972600627, 2.912356399620236],
            [33.345296869829866, 2.910827061447373],
            [33.34566172148083, 2.909924478826103],
            [33.34512869173393, 2.908104406025492],
            [33.3452194476288, 2.906375917746889],
            [33.34489951264034, 2.904892292582167],
            [33.34411542533114, 2.904051655123276],
            [33.343630041328595, 2.905415090592711],
            [33.33669108217154, 2.909691157878324],
            [33.3305319855469, 2.91100134749451],
            [33.3258471527626, 2.910479375662886],
            [33.32402553106318, 2.911177694282001],
            [33.31856028418084, 2.911964276409674],
            [33.311360435400644, 2.914495796561564],
            [33.30648884286878, 2.917037187757787],
            [33.306969892500064, 2.917241313885179],
            [33.300528030478496, 2.920496413069447],
            [33.281746244062646, 2.926196761143269],
            [33.27434313438143, 2.929895658174511],
            [33.27045763421504, 2.933876058592215],
            [33.26932215022117, 2.932891913205459],
            [33.26889304477289, 2.9305940634062],
            [33.26777388765934, 2.929900160028182],
            [33.26759491450865, 2.928140840876329],
            [33.266475749310246, 2.927399059044372],
            [33.26490436231632, 2.927231872840252],
            [33.26378519442301, 2.926466152816635],
            [33.26373742111786, 2.925771990298125],
            [33.26104714919994, 2.926035930128771],
            [33.25823767353874, 2.925557839234829],
            [33.25783281990819, 2.925055263258574],
            [33.258689710281296, 2.92419332557904],
            [33.257891856290335, 2.922960759898311],
            [33.256249131384784, 2.923128694062272],
            [33.25601099249453, 2.922865442556088],
            [33.25405896865352, 2.923966996357606],
            [33.25255849107487, 2.921453941997329],
            [33.25217767007312, 2.921932772095375],
            [33.2524161179838, 2.923584372591451],
            [33.25182108651601, 2.924374426962281],
            [33.2504207091078, 2.92369411687739],
            [33.24961127403623, 2.923885793896403],
            [33.249158713575866, 2.922928414175122],
            [33.24865872476345, 2.922880648294615],
            [33.247658946564634, 2.923598987998123],
            [33.2459205088605, 2.921612589114218],
            [33.24570599476388, 2.92048759499633],
            [33.246062789425075, 2.918979482778111],
            [33.24425921398138, 2.918747987613358],
            [33.24349721534667, 2.918077908812085],
            [33.24268792131058, 2.918915882035593],
            [33.24164002934513, 2.917336268358479],
            [33.24092753417081, 2.917466357050506],
            [33.24229067102058, 2.915057479901919],
            [33.24349557053139, 2.910983856538659],
            [33.244122361936064, 2.91001387244093],
            [33.24349356279674, 2.901624822187234],
            [33.2440720365172, 2.900266909575682],
            [33.2454862605572, 2.892624149839599],
            [33.24533707733796, 2.890828903555127],
            [33.243825034848356, 2.888813313969024],
            [33.2437315103458, 2.88664061463083],
            [33.24310413054464, 2.884798036394607],
            [33.243252168411914, 2.882600989822576],
            [33.24548298440135, 2.877364276247837],
            [33.25083905453562, 2.874819791360078],
            [33.25277309051142, 2.87347290362264],
            [33.25327826350132, 2.872202261719338],
            [33.253132881054064, 2.871072489439656],
            [33.25231267697883, 2.8696663917952],
            [33.251132534138954, 2.861844472138294],
            [33.2522140096213, 2.859579992963756],
            [33.25308204988371, 2.859240353718761],
            [33.25336979554057, 2.851820950451366],
            [33.252597083597784, 2.846971879604418],
            [33.250281611274275, 2.844547765839747],
            [33.25008654839854, 2.834558366368351],
            [33.25080916848445, 2.830872783920451],
            [33.249216450095815, 2.825199512268182],
            [33.24956569262038, 2.82227612764968],
            [33.25013701844614, 2.822228135943738],
            [33.25069206949391, 2.82404436344146],
            [33.252787238977135, 2.825097133686731],
            [33.253763015988206, 2.823828254381647],
            [33.25461995037877, 2.823421136005587],
            [33.25678659701254, 2.82476113868596],
            [33.2576673825722, 2.824593381156513],
            [33.25907207818196, 2.825191486604533],
            [33.259596103216445, 2.826507911825742],
            [33.261500740027905, 2.827153779000029],
            [33.262869902776636, 2.828481980710962],
            [33.26429842080942, 2.829151889600755],
            [33.26494108185188, 2.828696935975595],
            [33.265893332884, 2.828672782793372],
            [33.26648818109545, 2.827356107908984],
            [33.26736887502697, 2.826757479598581],
            [33.267368726804946, 2.826111177947894],
            [33.2669401881936, 2.825991593404954],
            [33.266797214129596, 2.82539319766877],
            [33.26791613049467, 2.825512621670395],
            [33.26796354986358, 2.824698752921038],
            [33.26848715987638, 2.824124140139542],
            [33.268106085549704, 2.82338217670941],
            [33.26897187104076, 2.823256539206042],
            [33.26920544109947, 2.822668010642723],
            [33.27065739527973, 2.8217580631402],
            [33.27027621854508, 2.820537364870511],
            [33.26946663345487, 2.819747633443912],
            [33.26969259657972, 2.818921753948841],
            [33.27071603640315, 2.81796402876284],
            [33.269954129396616, 2.817437589387941],
            [33.26983487085612, 2.816480136636103],
            [33.27057273086082, 2.815929412147606],
            [33.27004885853994, 2.815307171804537],
            [33.27131053427168, 2.815139319599602],
            [33.271167438935095, 2.814014312267237],
            [33.271524283901925, 2.812984930930264],
            [33.27195291324311, 2.813511453068064],
            [33.27235752882012, 2.813152297145332],
            [33.27311937114797, 2.813367555816759],
            [33.27342908690175, 2.814420709868451],
            [33.274119301162095, 2.813750310676393],
            [33.273262086497176, 2.81288877807059],
            [33.27345241345471, 2.812338181086697],
            [33.27433327896445, 2.812553411196957],
            [33.275333365285434, 2.813606396407133],
            [33.27592848119485, 2.813462636444133],
            [33.27598789576774, 2.813019785734306],
            [33.27674959256849, 2.812636614318737],
            [33.27601152954455, 2.812301667277766],
            [33.27598762537485, 2.811870814833541],
            [33.27691570004768, 2.81038649145473],
            [33.277891806740485, 2.810673502492],
            [33.27901061800266, 2.810409928126008],
            [33.278820338655805, 2.811128086328087],
            [33.27970119158911, 2.811271496657538],
            [33.27977278641895, 2.812037465216072],
            [33.28172490637972, 2.812204548938568],
            [33.28205841940367, 2.813185885949031],
            [33.28310576609172, 2.812706886511728],
            [33.283986610940225, 2.812850293955369],
            [33.28455769691579, 2.811796929429817],
            [33.28567637882058, 2.81100673538553],
            [33.28632004687446, 2.809217097772785],
            [33.2870578215392, 2.811243259800652],
            [33.28894590509495, 2.825630132780094],
            [33.28937054591629, 2.826199139866334],
            [33.295507939243656, 2.827636285110133],
            [33.29834142327911, 2.829861686703187],
            [33.30110326487406, 2.831129630787573],
            [33.3031266895088, 2.830722172235928],
            [33.305328899546375, 2.831260170738779],
            [33.30632871457613, 2.831116283759941],
            [33.30975727948673, 2.832886708745918],
            [33.31124881164174, 2.832947728505355],
            [33.31201077164891, 2.833569887619444],
            [33.31253439064488, 2.833138888739321],
            [33.313867678274384, 2.833641189448594],
            [33.31501301858354, 2.832842386201372],
            [33.31533164742155, 2.833062518498455],
            [33.3152621726158, 2.834255631231505],
            [33.315751009742286, 2.835167862211289],
            [33.31805492344304, 2.837202504312754],
            [33.318893241147656, 2.83986918584087],
            [33.321127487803174, 2.842324930712278],
            [33.322663868348776, 2.845201958899717],
            [33.323362487246904, 2.847447582900841],
            [33.32287414599048, 2.848360085178985],
            [33.324549470757674, 2.848850884274785],
            [33.324829042643785, 2.850184262138106],
            [33.32455023881725, 2.851587978272399],
            [33.3251091678921, 2.853482730263686],
            [33.324900143400214, 2.854816246309473],
            [33.32693814589539, 2.858117224958203],
            [33.3273058281378, 2.860354513904774],
            [33.328682439716864, 2.860999963772212],
            [33.328545033411004, 2.861830377205868],
            [33.329876348340164, 2.864505638929972],
            [33.33166633496857, 2.86667331400824],
            [33.33242386089146, 2.868356904517163],
            [33.33444313171636, 2.870063188724776],
            [33.33543048890974, 2.873176794585496],
            [33.33547685545312, 2.874837525113731],
            [33.336945978235114, 2.877950986063528],
            [33.33999728216741, 2.87854978779377],
            [33.3409383141399, 2.880094918650991],
            [33.34192492842655, 2.880625136111794],
            [33.344150141623594, 2.880463002183949],
            [33.34715511674175, 2.879562516307513],
            [33.34754534130793, 2.880323570486548],
            [33.35665305005484, 2.880989648697438],
            [33.35722678695881, 2.881681443267729],
            [33.361769614961304, 2.883409938715078],
            [33.36482729693213, 2.883938378219915],
            [33.369759571559754, 2.883605813287462],
            [33.365386455975695, 2.880467281734028],
            [33.36276810138276, 2.877178649122089],
            [33.36264448421652, 2.871502542822374],
            [33.3637146184684, 2.867791996878186],
            [33.369900037527486, 2.854265716819232],
            [33.37006883456262, 2.852221111785948],
            [33.37288098271179, 2.853265496235422],
            [33.374314312121264, 2.850900501694009],
            [33.37503652167706, 2.847991814577832],
            [33.37534351912878, 2.8389547388661],
            [33.3700738345855, 2.835632501425977],
            [33.3685236828666, 2.833867152605257],
            [33.36697304605746, 2.830543700078511],
            [33.36624869851127, 2.826700614549597],
            [33.366763888614905, 2.822441641552604],
            [33.365935271817044, 2.815482384867882],
            [33.36459199042999, 2.814444074680113],
            [33.36231913508185, 2.81392541899764],
            [33.36004634441243, 2.81361450738778],
            [33.3551911353547, 2.813927625291417],
            [33.354571089399535, 2.813200700158005],
            [33.35229543400268, 2.803333403015298],
            [33.350845998698475, 2.803131726714696],
            [33.34368556978958, 2.805880543328297],
            [33.340880195835986, 2.80610407318445],
            [33.33770523431324, 2.804768775706492],
            [33.33563741314052, 2.802468099698113],
            [33.33411079728203, 2.80157369909328],
            [33.32656028663912, 2.803238701993251],
            [33.32567495740074, 2.802109460780133],
            [33.324109187572304, 2.802212578015301],
            [33.31832281723042, 2.803240984572666],
            [33.31379624963288, 2.805638105025479],
            [33.31161790244254, 2.806254776881489],
            [33.307601493484725, 2.807111522238691],
            [33.302938100791316, 2.807078520053456],
            [33.29919343759687, 2.805744635044567],
            [33.297933775888026, 2.804923508178972],
            [33.295382719482916, 2.802180941292845],
            [33.29750571338378, 2.802554006027588],
            [33.29769604034134, 2.802075213082939],
            [33.29712451149634, 2.801309379759301],
            [33.29798116291759, 2.799920810193454],
            [33.29748098635728, 2.798915587290941],
            [33.29779041285352, 2.798724017680954],
            [33.29852858098035, 2.799489808730017],
            [33.29931411278056, 2.799298107319101],
            [33.29917106595302, 2.798460358075608],
            [33.298599647600795, 2.798125382748022],
            [33.29895632907426, 2.796521517170487],
            [33.29821834959361, 2.796497767082351],
            [33.29807311626667, 2.795172226975191],
            [33.29871789823155, 2.795061417025572],
            [33.299955397604, 2.79355306915622],
            [33.30009834471853, 2.79398389963257],
            [33.30062196012124, 2.793600775818188],
            [33.30112201990056, 2.794151196785915],
            [33.3024308293369, 2.792259831165186],
            [33.303740031337036, 2.791876502215628],
            [33.30387053858151, 2.790236786541345],
            [33.30465616739977, 2.790452010844434],
            [33.30491773435263, 2.789326912491433],
            [33.30391754023382, 2.787890950252538],
            [33.30515521208281, 2.787100710476949],
            [33.30386965284265, 2.786789861732647],
            [33.30372671740622, 2.786382970925191],
            [33.304250221417824, 2.785568978930952],
            [33.30501215178055, 2.786215075992869],
            [33.305750006395364, 2.78578401745914],
            [33.30373795443211, 2.783785807594255],
            [33.304094751788234, 2.782708538281107],
            [33.30321358444457, 2.781200742538192],
            [33.30349901244799, 2.780338944657698],
            [33.3058796647319, 2.780864937714117],
            [33.30671256649367, 2.779787558061523],
            [33.307831322060295, 2.77945214314265],
            [33.30956925401293, 2.78007405348126],
            [33.310783221118214, 2.779690734023212],
            [33.31036616117957, 2.7779314792264],
            [33.3105799835734, 2.776255842940941],
            [33.31107979541768, 2.775944518481386],
            [33.31129420261475, 2.776542888341156],
            [33.31286536143657, 2.77666215581771],
            [33.31369778349797, 2.773765560804891],
            [33.31339982938622, 2.772317458484185],
            [33.31482768625897, 2.770641480459966],
            [33.31589890567572, 2.770641193335093],
            [33.31563681769998, 2.769755602134279],
            [33.31768400546895, 2.769635358633253],
            [33.31885055500198, 2.769994103450711],
            [33.319802576065335, 2.769347550675178],
            [33.320731102590806, 2.769897838504066],
            [33.32075475792717, 2.769299414138875],
            [33.32168343357293, 2.770400269532471],
            [33.322183271468404, 2.770136818034441],
            [33.32268324141618, 2.770399995866547],
            [33.32301637445276, 2.769921161132491],
            [33.324813731758084, 2.770243818743235],
            [33.32445653285503, 2.769765165193755],
            [33.325551294420414, 2.768807386449461],
            [33.325932144168284, 2.768711544916244],
            [33.32638470732357, 2.769692834796779],
            [33.326741790343966, 2.769740603438076],
            [33.326955837316596, 2.768974566940688],
            [33.32771765269499, 2.769237660688046],
            [33.32805055576285, 2.76789709300731],
            [33.32885997376647, 2.768064418984273],
            [33.32853840114927, 2.767358387077607],
            [33.329204831614135, 2.766951265259873],
            [33.32972853774668, 2.766927188867881],
            [33.32970494169913, 2.767717102077418],
            [33.33034752907973, 2.767214258962448],
            [33.33101420208974, 2.767716735095056],
            [33.331442303221536, 2.766328272196666],
            [33.332382647982854, 2.766531476565822],
            [33.33359641656048, 2.765549728255212],
            [33.33416786006552, 2.766004361829953],
            [33.33457240647226, 2.765525513655329],
            [33.334334186733635, 2.764903217021553],
            [33.33554816641534, 2.764687444316904],
            [33.33604733776084, 2.762078179383121],
            [33.33645189494737, 2.761647199086207],
            [33.3380466291555, 2.761024379104072],
            [33.33914176621666, 2.76145492983362],
            [33.339118109982, 2.761981547707066],
            [33.339998873083765, 2.761933427022679],
            [33.340665231683424, 2.761334809314693],
            [33.34049829056766, 2.760257699017385],
            [33.34102204520923, 2.760449036197176],
            [33.34116467611677, 2.759754834796658],
            [33.342057363455645, 2.759790474496407],
            [33.34196203244106, 2.759383575298804],
            [33.34336600311039, 2.757659717457523],
            [33.34417567443893, 2.758760578264615],
            [33.345175193922955, 2.757802813071714],
            [33.34529403564513, 2.757180413692097],
            [33.34641299063777, 2.757658829155275],
            [33.34729365222993, 2.757275573329717],
            [33.347698476216074, 2.757778125450004],
            [33.34796027223935, 2.757562611660975],
            [33.34800769609982, 2.756916314118604],
            [33.34743618162784, 2.756246250971429],
            [33.349486231429324, 2.754491420850445],
            [33.350148733561475, 2.753337601424729],
            [33.349766094369556, 2.752543001142966],
            [33.350505315321925, 2.752158247906431],
            [33.350505142845385, 2.751568623200471],
            [33.35032648500338, 2.750902140781719],
            [33.351091309737946, 2.750901914667152],
            [33.3513970522432, 2.750260914644352],
            [33.35103985064522, 2.749312503952447],
            [33.35121810963525, 2.748620281744611],
            [33.35203400628867, 2.74892766532916],
            [33.3519826621803, 2.747697154272696],
            [33.35253201162093, 2.746462881433081],
            [33.35319668857439, 2.746808347168774],
            [33.35399863079821, 2.746347227874196],
            [33.35379201019801, 2.745079865377915],
            [33.35489196761901, 2.744964309489147],
            [33.35489175022671, 2.744226895689064],
            [33.35532704057575, 2.743835023401337],
            [33.35573969158296, 2.744364909795745],
            [33.35803119685471, 2.74385726082532],
            [33.3588104620075, 2.744225719348294],
            [33.35988699855239, 2.742451002036531],
            [33.36105562948193, 2.742104993977533],
            [33.361880693442835, 2.742335179399576],
            [33.36249899846299, 2.74086017223382],
            [33.363438535638856, 2.740767717506804],
            [33.36288826452674, 2.739846115641844],
            [33.36330044391845, 2.738809011318813],
            [33.36382773882057, 2.739523215601516],
            [33.365179487727495, 2.738508864463607],
            [33.365500405472844, 2.738785289684708],
            [33.366279484674365, 2.738554615454557],
            [33.36632550267141, 2.739130707389951],
            [33.3677463095658, 2.739153300227771],
            [33.36933857340691, 2.737758643254907],
            [33.37069072026751, 2.738034757289554],
            [33.37208812425213, 2.736444286817111],
            [33.372752943139396, 2.737250620901437],
            [33.37323398917742, 2.736605225807296],
            [33.37511326205684, 2.73706552514387],
            [33.37534223902953, 2.73648934697289],
            [33.37607546911725, 2.736189542301888],
            [33.376602778392396, 2.736926788773864],
            [33.378121095614226, 2.735595338019433],
            [33.378640779090944, 2.736082772727713],
            [33.38018384040729, 2.744941714966505],
            [33.38277353514939, 2.751322153033064],
            [33.38265090612995, 2.753180814600383],
            [33.38351467580152, 2.756959732385025],
            [33.382961719625015, 2.761792326541177],
            [33.384010456006806, 2.765942906997945],
            [33.386291044052896, 2.768854001241716],
            [33.38801733473778, 2.772384812495402],
            [33.38906581869299, 2.775668027421367],
            [33.39097637719882, 2.777402104884123],
            [33.3907319671696, 2.783597584074834],
            [33.38950062574838, 2.786385921991022],
            [33.38983082488728, 2.789038390637082],
            [33.39056873070603, 2.788870584911555],
            [33.39061663606351, 2.789756224574734],
            [33.3923550656828, 2.791742396675941],
            [33.395890682825836, 2.793380869355234],
            [33.39619996738827, 2.792854157812573],
            [33.39674747707921, 2.792830033497703],
            [33.39779511032983, 2.793452037260634],
            [33.39798580469835, 2.794194005350771],
            [33.40048563377605, 2.795006998120892],
            [33.40105714645141, 2.795581284281115],
            [33.40236633677341, 2.795317530655577],
            [33.40241366541248, 2.79447972922011],
            [33.40419926556733, 2.795101471010272],
            [33.40465142717572, 2.79469439106924],
            [33.40506822660293, 2.795328564991788],
            [33.404687485551214, 2.795711682858697],
            [33.40578262979893, 2.796046421105569],
            [33.40599714479384, 2.796812317086722],
            [33.406854142964754, 2.796835956807328],
            [33.407401861064855, 2.797410248352936],
            [33.408068314885945, 2.797122772877725],
            [33.408639732339836, 2.797409814983681],
            [33.40880659440389, 2.798056034737568],
            [33.40837819772634, 2.798367373087429],
            [33.408307142784, 2.799396681161827],
            [33.408522042257836, 2.801287602802991],
            [33.40906953847406, 2.801215594657502],
            [33.409736268976246, 2.801718028473088],
            [33.409795930585844, 2.802160846679929],
            [33.409367534806634, 2.802424299984157],
            [33.4099628537353, 2.802974635159858],
            [33.40936793455694, 2.803573255949926],
            [33.410534750889575, 2.804602126978575],
            [33.40991583232007, 2.804674150168744],
            [33.41024937858171, 2.805440011796203],
            [33.410773144003066, 2.80558344794672],
            [33.4108923711025, 2.806157887732305],
            [33.41120173381835, 2.805846599008047],
            [33.411320986070635, 2.806468906305077],
            [33.41167792086901, 2.806085794648941],
            [33.411809206054514, 2.807103061290304],
            [33.41264270609425, 2.807988409034407],
            [33.41138130345041, 2.808778782774555],
            [33.411286562628966, 2.810167144430493],
            [33.41226307446192, 2.811555126699574],
            [33.41251364064582, 2.81329044316216],
            [33.41303744559305, 2.813505682966183],
            [33.41306147822183, 2.81417589926366],
            [33.414180779964155, 2.815420217529672],
            [33.415418795867936, 2.815778820059403],
            [33.415847772857134, 2.817119117760983],
            [33.4191806932411, 2.817500900585928],
            [33.42008565336338, 2.818481976528035],
            [33.42149000491841, 2.817978799844036],
            [33.42256134920099, 2.818241712137979],
            [33.422371351026825, 2.819462549195485],
            [33.42266920273064, 2.820264316221947],
            [33.42366927557687, 2.820910246084606],
            [33.42236046344557, 2.822275121859668],
            [33.42364626702751, 2.823112425133913],
            [33.42421836091282, 2.825194713020014],
            [33.42402823427957, 2.8260325570093],
            [33.42507610109217, 2.827205062409464],
            [33.42578987367087, 2.826103714849233],
            [33.42538502902343, 2.825696941804611],
            [33.42602761460744, 2.82524190517735],
            [33.42545585669202, 2.824093164368684],
            [33.42636039999601, 2.823877395365992],
            [33.427860569452506, 2.825001863798711],
            [33.42855140175376, 2.826270251040456],
            [33.42917033739125, 2.826246082554935],
            [33.43108723171478, 2.827669599842939],
            [33.43103998033085, 2.828651020703949],
            [33.43211129137573, 2.828794239559453],
            [33.43132581886437, 2.829105702489316],
            [33.43158784126305, 2.829536466003804],
            [33.43118341792552, 2.830278655186912],
            [33.431421606223104, 2.830637612018629],
            [33.43204046370718, 2.830374087038282],
            [33.43239767159338, 2.830709060275027],
            [33.43225513860218, 2.831522958004008],
            [33.432993068675486, 2.831379061188402],
            [33.433874074322404, 2.831905332743817],
            [33.43430247369487, 2.831617932171451],
            [33.43449312853751, 2.832192340263411],
            [33.435183363459096, 2.831833033998254],
            [33.43630249901312, 2.832526771952126],
            [33.43694519059828, 2.832335041883717],
            [33.43667172456118, 2.833137009966335],
            [33.437838197737385, 2.833112629880655],
            [33.437672094749786, 2.834524954037007],
            [33.43919565184472, 2.834500435809296],
            [33.43941038962178, 2.835745056189548],
            [33.441124644678474, 2.836390694807482],
            [33.44107721991968, 2.836869439535733],
            [33.44033925211716, 2.836917598414586],
            [33.440291872274116, 2.837539963547412],
            [33.44107786491006, 2.838568939999426],
            [33.44144735905439, 2.839873346213215],
            [33.441067165975035, 2.841740550672218],
            [33.44154331709304, 2.841836101804021],
            [33.44163874871896, 2.842362677240213],
            [33.44282920152335, 2.842769140273128],
            [33.4436623485252, 2.84260125974405],
            [33.44468639650803, 2.843630131198593],
            [33.44640016737281, 2.842935305312841],
            [33.443375682643286, 2.859245948639026],
            [33.43845448783639, 2.861621482391489],
            [33.436260565655644, 2.861906972529822],
            [33.4324376915393, 2.859204267558944],
            [33.42826188372082, 2.858992354992148],
            [33.42444018549918, 2.859420755790434],
            [33.421255850056454, 2.860916343345686],
            [33.41948698731196, 2.862340240416724],
            [33.417930497080405, 2.86390638303593],
            [33.41420651849369, 2.869620694379999],
            [33.40943405235847, 2.867542526816203],
            [33.409311167319196, 2.868037507585945],
            [33.40622432154267, 2.870798334865703],
            [33.40519520795991, 2.871258655871151],
            [33.40359495899424, 2.87367398268279],
            [33.40302374276297, 2.875399010996113],
            [33.40302434912577, 2.877123836629017],
            [33.404512389529295, 2.880802935677354],
            [33.40657214472909, 2.884136859898874],
            [33.40806086515728, 2.889655763367831],
            [33.41097929927593, 2.897766857926819],
            [33.421841867828675, 2.897913469299929],
            [33.43475626933874, 2.894084703333281],
            [33.40510577258855, 2.93807237077052],
            [33.40336856467805, 2.940251237324774],
            [33.397013169095835, 2.943319806469972],
            [33.39688834549215, 2.946395937129523],
            [33.398975299882125, 2.951327975807148],
            [33.39897684139114, 2.955644163639379],
            [33.39824176436722, 2.958110823668806],
            [33.39787545834379, 2.962797104115971],
            [33.39693596428706, 2.966164040629662],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 522,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "LOKOLE",
        Population: 15541,
        Key: "AGAGOLOKOLE",
        Dist2: "Agago",
        "Sub Country": "Lukole",
        id2_original: "Agago Lukole",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.55052021155739, 3.281461967290734],
            [33.54919459284543, 3.280497567981533],
            [33.54809448989734, 3.28079976824145],
            [33.54563627347855, 3.27991070945232],
            [33.54446489550089, 3.280543250485721],
            [33.54278073400622, 3.280630078358421],
            [33.54232609394597, 3.279429434260581],
            [33.5398332196252, 3.276869203510507],
            [33.53833336278246, 3.277803523424685],
            [33.5344750662978, 3.277403487123663],
            [33.533588793828365, 3.276743318538262],
            [33.53276047527118, 3.277605448759161],
            [33.53176038625527, 3.27789323040963],
            [33.53144637924939, 3.278582745694966],
            [33.527431022218785, 3.278426911692856],
            [33.52660243865862, 3.278772013150972],
            [33.524859824686715, 3.277997664486651],
            [33.52443462152002, 3.276739024436607],
            [33.523657544663266, 3.276245941624105],
            [33.52137157660696, 3.276850308747928],
            [33.52077118579018, 3.276362325462161],
            [33.51812802152575, 3.277038702106514],
            [33.515098679605494, 3.276954115141297],
            [33.513240769561854, 3.276351882575989],
            [33.512012672855455, 3.277846116418736],
            [33.5104124822803, 3.278306520093644],
            [33.50866904724821, 3.277991447553601],
            [33.507583255360956, 3.278365415021133],
            [33.50515364399574, 3.277504941032734],
            [33.503067558276655, 3.277793231223639],
            [33.49933859583671, 3.276855971436921],
            [33.49885207007546, 3.277284737526613],
            [33.498649188263485, 3.278672883992412],
            [33.49785055363656, 3.278099285148699],
            [33.49739308837477, 3.278299073587698],
            [33.49684617965676, 3.280273613638108],
            [33.49573265498, 3.280014511043882],
            [33.49521739390946, 3.28052910995857],
            [33.494789097843224, 3.280442678481872],
            [33.49495608567141, 3.282532671877578],
            [33.49407041866648, 3.282588760339391],
            [33.49261048834483, 3.284046810816166],
            [33.492322174952704, 3.285306017433907],
            [33.491036517796154, 3.285390196527423],
            [33.489604694861455, 3.287062989746189],
            [33.48829228767238, 3.286288323749902],
            [33.486292321642935, 3.286457435107884],
            [33.48631851831326, 3.287573922346769],
            [33.485947097282626, 3.287602053429619],
            [33.485344912530245, 3.288689092677674],
            [33.48545755228373, 3.289462162236287],
            [33.48456797401404, 3.291364689591027],
            [33.484715326466734, 3.291684983757469],
            [33.485686477154076, 3.291257278527917],
            [33.48576659699597, 3.291910201868109],
            [33.48513554578023, 3.293140325059845],
            [33.486962387589784, 3.293889247571603],
            [33.48701794659347, 3.294545543062995],
            [33.48641678412389, 3.295145905520955],
            [33.48607132440496, 3.296405060448905],
            [33.48464041236192, 3.29763412431243],
            [33.483728896334725, 3.296401946658778],
            [33.482615939393234, 3.295870864138228],
            [33.4802153427134, 3.296354330420935],
            [33.437643110607134, 3.300161411568575],
            [33.433531028376656, 3.299483008533688],
            [33.42998185924924, 3.302655748489582],
            [33.42818007055467, 3.303612263903436],
            [33.422150757132385, 3.304405481520382],
            [33.417009555929226, 3.304026164417743],
            [33.41438176543259, 3.304758854331625],
            [33.40285341320195, 3.303162352192153],
            [33.39648162246748, 3.298956382196666],
            [33.39597941930792, 3.296123243568525],
            [33.39578738375467, 3.287311231607635],
            [33.39456052223182, 3.284090095007838],
            [33.39295675187022, 3.281342871994396],
            [33.39022193788725, 3.279259366573471],
            [33.38739311520976, 3.277839164968154],
            [33.382962083442706, 3.277651370853272],
            [33.38173617413401, 3.276799056657835],
            [33.37706034246886, 3.277740817766605],
            [33.37352185071695, 3.27450737425905],
            [33.36647579261507, 3.270131489559281],
            [33.35568952606425, 3.264919878424826],
            [33.32827836043408, 3.255241927358338],
            [33.321380499201275, 3.249200938488539],
            [33.303229882578776, 3.234505198715483],
            [33.300813492617905, 3.228876090085393],
            [33.301098970927, 3.228038753971495],
            [33.3024081837069, 3.227320432761371],
            [33.3025988421428, 3.224478189695734],
            [33.30345561842987, 3.223377406196462],
            [33.30440788832659, 3.223233351546131],
            [33.30455051384425, 3.222443934570345],
            [33.30547901521687, 3.222467314826001],
            [33.30578815065895, 3.221151583556869],
            [33.308382596590604, 3.219045181598364],
            [33.30998902776203, 3.216903493939014],
            [33.309630520013606, 3.211856760109423],
            [33.310237239461564, 3.210481055228402],
            [33.31059342955655, 3.207156083337722],
            [33.311485559939946, 3.204847378600929],
            [33.318126493120026, 3.200370598641125],
            [33.31991185252642, 3.199795482696391],
            [33.32097096265312, 3.198730457731644],
            [33.3230897209974, 3.198490007158504],
            [33.32580272119033, 3.195020129576964],
            [33.327659679918106, 3.195114686356377],
            [33.33109789003994, 3.188714265009124],
            [33.33195480376923, 3.188283199436288],
            [33.33290669996679, 3.187014915546029],
            [33.33320355004907, 3.184515188884283],
            [33.336498190523855, 3.181788800947375],
            [33.29721480655543, 3.184521656632914],
            [33.297525088247845, 3.179991744427752],
            [33.301857949425695, 3.178939136720084],
            [33.30394929208586, 3.177136218253028],
            [33.30977654475632, 3.176834093882202],
            [33.312017557522545, 3.175932266805646],
            [33.31859014148593, 3.169922586282651],
            [33.327852765601925, 3.165864508708068],
            [33.33571167866165, 3.164209874743429],
            [33.34518468731888, 3.164507130593945],
            [33.34738403083234, 3.166400772739354],
            [33.34980283726131, 3.165491947571801],
            [33.35206489306311, 3.168073721458975],
            [33.35477980936254, 3.168647272015582],
            [33.36020925119426, 3.16864538754065],
            [33.36621081565741, 3.170366712702478],
            [33.37264083159531, 3.17151336427974],
            [33.37549843539617, 3.171512325623886],
            [33.38135704645658, 3.172946369313332],
            [33.38741252331149, 3.177055096799467],
            [33.39959652442695, 3.179014790322594],
            [33.402408960935354, 3.178050140326286],
            [33.40560085659951, 3.17469102560736],
            [33.4080565981597, 3.173258026580507],
            [33.41277196917206, 3.171429077085154],
            [33.413951069067906, 3.171626124806577],
            [33.414295009735696, 3.171774126959553],
            [33.41429575713402, 3.173650574968113],
            [33.41719536076768, 3.176562834751831],
            [33.41758884711661, 3.177747800061878],
            [33.41980052270233, 3.180215907456533],
            [33.42010697038507, 3.181348682442639],
            [33.429898977986205, 3.181122404696689],
            [33.4501347883007, 3.182399719856809],
            [33.4646560315123, 3.181097611727688],
            [33.47288122364597, 3.181510137162907],
            [33.48536711169755, 3.180556045488217],
            [33.49094996601685, 3.181305274575099],
            [33.500829626731836, 3.181632620222856],
            [33.50444513823959, 3.181288992588089],
            [33.512183087756426, 3.183436206215967],
            [33.51745100890681, 3.183929956574716],
            [33.52189502402468, 3.182769449567902],
            [33.54938593489925, 3.183416950045825],
            [33.556841508888006, 3.182372005617612],
            [33.554494232610196, 3.203415551705415],
            [33.55395931460456, 3.221278366977386],
            [33.55268544334457, 3.239249517775157],
            [33.55078593950663, 3.258618391068731],
            [33.55081409989413, 3.277485930589044],
            [33.55052021155739, 3.281461967290734],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 523,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "OMIYA PACWA",
        Population: 11563,
        Key: "AGAGOOMIYA PACWA",
        Dist2: "Agago",
        "Sub Country": "Omiya Pacwa",
        id2_original: "Agago Omiya Pacwa",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.24956569262038, 2.82227612764968],
            [33.249470193620844, 2.82103142013903],
            [33.24870286617989, 2.821179370112654],
            [33.24841929140088, 2.821722771648628],
            [33.24764230976556, 2.821952733371406],
            [33.247094017642006, 2.822902674535772],
            [33.247414409872924, 2.824970768720511],
            [33.245007421679844, 2.826350058091175],
            [33.24464168788327, 2.826013101630189],
            [33.244763433858765, 2.825339008072904],
            [33.24389295107711, 2.825684278398433],
            [33.243518544944784, 2.822461933205768],
            [33.243751586794104, 2.813128847967911],
            [33.24198779054781, 2.806277113621873],
            [33.23975448622501, 2.801551985846018],
            [33.23752084503399, 2.795054755866793],
            [33.23611053315705, 2.79292852623432],
            [33.23646217687839, 2.788793561266181],
            [33.23822407318786, 2.786548548228799],
            [33.24198306720604, 2.783239863567928],
            [33.24433180773779, 2.778159367006027],
            [33.24421412484233, 2.777214274243399],
            [33.24287149563214, 2.776206879411093],
            [33.24004962681331, 2.777066232582024],
            [33.231419116620025, 2.782251943445674],
            [33.22597532060838, 2.782667255530832],
            [33.22444503153873, 2.782046174727328],
            [33.223678969823986, 2.776868192858387],
            [33.22200111629927, 2.773879992315574],
            [33.221971541065166, 2.773081086358071],
            [33.21932270843127, 2.77047772416844],
            [33.21773354916781, 2.76964951748986],
            [33.21690942484467, 2.768584455163988],
            [33.21696797523828, 2.766927441897461],
            [33.21824345717757, 2.763413409496765],
            [33.219241494441384, 2.753790482800243],
            [33.21733640308239, 2.749865145651434],
            [33.21709841870237, 2.744644073971704],
            [33.2161561317834, 2.743012879983218],
            [33.215867915409326, 2.740907931264573],
            [33.21563233042942, 2.740434350851122],
            [33.21275378869594, 2.739224496511916],
            [33.20986187553944, 2.736317485243366],
            [33.20873593524717, 2.73577793415005],
            [33.207661445962785, 2.732426035369621],
            [33.207476870918, 2.728419635430104],
            [33.2038173644192, 2.72068093857603],
            [33.21262589015907, 2.714240797693356],
            [33.219020438812905, 2.711238575365849],
            [33.217602231642935, 2.704164876406939],
            [33.21629747630347, 2.700432681103244],
            [33.215744894724416, 2.695565498895101],
            [33.21341225559584, 2.693573600978862],
            [33.21193256772783, 2.693170356616181],
            [33.20863436633125, 2.690863373584735],
            [33.20776797896897, 2.683865220761569],
            [33.20588613421286, 2.6779390466697],
            [33.20122074815783, 2.672669022587701],
            [33.19964066277704, 2.671559649243443],
            [33.19740861070576, 2.670853873123163],
            [33.195301874514904, 2.669643689135307],
            [33.19151384065853, 2.661422845979531],
            [33.19155089167244, 2.657778671384067],
            [33.190848177354916, 2.654248098816438],
            [33.19127392040907, 2.650515601601577],
            [33.19040840890418, 2.648309054878052],
            [33.190056871184076, 2.64530803572862],
            [33.18788826981624, 2.642928059590583],
            [33.1867876350655, 2.641028080137478],
            [33.186651805302986, 2.639527994745735],
            [33.18702428544733, 2.636612959562614],
            [33.18956600476334, 2.630731475522091],
            [33.19058246108374, 2.626895820332456],
            [33.188562044906874, 2.621686213698426],
            [33.18750468290172, 2.620301054428677],
            [33.18678339591567, 2.616934514988245],
            [33.186959062367805, 2.613390648523969],
            [33.18610964597786, 2.610040235362231],
            [33.18482780216972, 2.606931510641864],
            [33.18165560206815, 2.601567888336028],
            [33.180373543562645, 2.596799994620943],
            [33.18038874036231, 2.59101708523619],
            [33.18146174383319, 2.590002103798125],
            [33.1824063960163, 2.587505169613149],
            [33.18306298723388, 2.586747980569636],
            [33.18299353219106, 2.585798502368979],
            [33.18328855959163, 2.585399456974379],
            [33.184978587983416, 2.586189142586627],
            [33.18635901919904, 2.585829879083302],
            [33.18763263533752, 2.587421514038638],
            [33.190846228909045, 2.589886577309168],
            [33.19170307526472, 2.589814630240519],
            [33.192131623757504, 2.590652369618858],
            [33.19320268327414, 2.590508582354722],
            [33.19434528462001, 2.591322270145437],
            [33.19517861936973, 2.593117440959321],
            [33.198130135745345, 2.593763287304141],
            [33.19927286375364, 2.595319020123962],
            [33.200662402089634, 2.595674405989419],
            [33.20136261909066, 2.596244074911143],
            [33.20194815716253, 2.596196886386196],
            [33.20215905554009, 2.596856384091424],
            [33.20506354151731, 2.598010123752862],
            [33.20639859703131, 2.59793924504281],
            [33.20686711516438, 2.598528041742145],
            [33.20813171670896, 2.597467853913094],
            [33.213132093516606, 2.596230357358606],
            [33.21360035203654, 2.595429411229734],
            [33.21491216094763, 2.596418507497256],
            [33.217769578797224, 2.596182463482084],
            [33.21830837752485, 2.59677124215512],
            [33.21905779615229, 2.596347114491652],
            [33.22278195619872, 2.596817583519821],
            [33.223484471090266, 2.596157891060015],
            [33.22472582962518, 2.596016352392052],
            [33.226236284791675, 2.594802984449614],
            [33.23054578348398, 2.59418977957209],
            [33.233051935802955, 2.594307084304282],
            [33.23387176707733, 2.594707378757565],
            [33.24065210172152, 2.593328127848832],
            [33.2417295644295, 2.593704799586147],
            [33.24360327224576, 2.593492444501759],
            [33.24589876603735, 2.594457756844599],
            [33.2470464105252, 2.594386864474341],
            [33.2490374455041, 2.595328671594865],
            [33.25027877439461, 2.595163539449428],
            [33.250930382657295, 2.595582243662814],
            [33.248858534337145, 2.60271826925109],
            [33.248012867515214, 2.609843261490409],
            [33.2469353553999, 2.6127863385639],
            [33.24524133309835, 2.613406222570835],
            [33.242239926986834, 2.623009835802641],
            [33.24216317403063, 2.624326395076715],
            [33.24270676886355, 2.625702348234152],
            [33.24524304349065, 2.626497654826943],
            [33.24671918840319, 2.627494637854339],
            [33.24836870636893, 2.630590472892013],
            [33.24901503343605, 2.633605345227632],
            [33.24866973810883, 2.63680595568934],
            [33.249604412704066, 2.640133863048105],
            [33.2490250864824, 2.644964277562924],
            [33.24959326011984, 2.645897945294469],
            [33.251165160950066, 2.647100814883953],
            [33.252224954694704, 2.650430445371959],
            [33.253563290856135, 2.652874305779344],
            [33.25408787015113, 2.655778014057093],
            [33.253888179155055, 2.657376680511382],
            [33.25384098346665, 2.657910154539207],
            [33.24908484061846, 2.657804683736066],
            [33.246578470907195, 2.656928551381681],
            [33.24428988246519, 2.655285310242124],
            [33.24359471938593, 2.655077623767702],
            [33.2425239661948, 2.655531799917501],
            [33.2423655986001, 2.665887130498294],
            [33.23880498403771, 2.66653302082626],
            [33.238452229998664, 2.667113761082343],
            [33.23669077655863, 2.682114775594793],
            [33.23544025161457, 2.685050632497132],
            [33.24034964974514, 2.691566089951948],
            [33.24429675367878, 2.69827527344282],
            [33.246992650847034, 2.704274986818417],
            [33.2486612490294, 2.706500547320351],
            [33.25799861387532, 2.716660308663688],
            [33.26491976932178, 2.722630212281013],
            [33.26448377110033, 2.727387024768793],
            [33.26486961817609, 2.728421006499807],
            [33.26440125275662, 2.729721875495283],
            [33.26235915574038, 2.731293904703074],
            [33.26213723503426, 2.732455699907207],
            [33.26213750632548, 2.733706811432095],
            [33.26307115145141, 2.736074782349441],
            [33.26276038107551, 2.737325961882517],
            [33.263249447272386, 2.738621648351902],
            [33.2624945318537, 2.740811259289202],
            [33.26253925897168, 2.742151726462658],
            [33.262984265498815, 2.745154706078619],
            [33.26517304572288, 2.745136944333524],
            [33.26526681187225, 2.747013270476471],
            [33.26965005326619, 2.761254838130111],
            [33.26962645093041, 2.762116580815301],
            [33.26536828377009, 2.775139301682394],
            [33.26402498351842, 2.782763561608113],
            [33.25907207818196, 2.825191486604533],
            [33.2576673825722, 2.824593381156513],
            [33.25678659701254, 2.82476113868596],
            [33.25461995037877, 2.823421136005587],
            [33.253763015988206, 2.823828254381647],
            [33.252787238977135, 2.825097133686731],
            [33.25069206949391, 2.82404436344146],
            [33.25013701844614, 2.822228135943738],
            [33.24956569262038, 2.82227612764968],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 524,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "OMOT",
        Population: 13399,
        Key: "AGAGOOMOT",
        Dist2: "Agago",
        "Sub Country": "Omot",
        id2_original: "Agago Omot",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.556841508888006, 3.182372005617612],
            [33.54938593489925, 3.183416950045825],
            [33.52189502402468, 3.182769449567902],
            [33.51745100890681, 3.183929956574716],
            [33.512183087756426, 3.183436206215967],
            [33.50444513823959, 3.181288992588089],
            [33.500829626731836, 3.181632620222856],
            [33.49094996601685, 3.181305274575099],
            [33.48536711169755, 3.180556045488217],
            [33.47288122364597, 3.181510137162907],
            [33.4646560315123, 3.181097611727688],
            [33.4501347883007, 3.182399719856809],
            [33.429898977986205, 3.181122404696689],
            [33.42010697038507, 3.181348682442639],
            [33.41980052270233, 3.180215907456533],
            [33.41758884711661, 3.177747800061878],
            [33.41719536076768, 3.176562834751831],
            [33.41429575713402, 3.173650574968113],
            [33.414295009735696, 3.171774126959553],
            [33.413951069067906, 3.171626124806577],
            [33.41277196917206, 3.171429077085154],
            [33.4080565981597, 3.173258026580507],
            [33.40560085659951, 3.17469102560736],
            [33.402408960935354, 3.178050140326286],
            [33.39959652442695, 3.179014790322594],
            [33.38741252331149, 3.177055096799467],
            [33.38135704645658, 3.172946369313332],
            [33.37549843539617, 3.171512325623886],
            [33.37264083159531, 3.17151336427974],
            [33.36621081565741, 3.170366712702478],
            [33.36020925119426, 3.16864538754065],
            [33.35477980936254, 3.168647272015582],
            [33.35206489306311, 3.168073721458975],
            [33.34980283726131, 3.165491947571801],
            [33.34738403083234, 3.166400772739354],
            [33.34518468731888, 3.164507130593945],
            [33.33571167866165, 3.164209874743429],
            [33.33456184857274, 3.162642360406907],
            [33.33432980475169, 3.159854238744837],
            [33.336004430629615, 3.156078012533481],
            [33.33750650810775, 3.154857687832593],
            [33.33780164689942, 3.151492575325911],
            [33.340650799350065, 3.152336545789721],
            [33.34390749498725, 3.151492563665477],
            [33.3449157200447, 3.150087384920279],
            [33.3450126967729, 3.149342175850159],
            [33.346555712275155, 3.14814449058222],
            [33.34619016263322, 3.145224983403806],
            [33.34819072334737, 3.142472939408058],
            [33.34744088071509, 3.140261968023983],
            [33.34822522584082, 3.138946923868908],
            [33.34791586402327, 3.138325494717389],
            [33.34836746867616, 3.137608190910192],
            [33.35133980350848, 3.136662938883835],
            [33.35123259227425, 3.136077300168399],
            [33.35290862221896, 3.134463139542562],
            [33.353966785521365, 3.134175919403814],
            [33.35516793456586, 3.134773138183884],
            [33.356487830111156, 3.134904165023671],
            [33.35710602194357, 3.134557328707921],
            [33.35844983782824, 3.135094731875347],
            [33.36183834236874, 3.134209071474209],
            [33.36304768584526, 3.134249902517047],
            [33.36364263915964, 3.133651552356564],
            [33.36511862057876, 3.133794146687009],
            [33.366642518135166, 3.134893456983929],
            [33.36907024124165, 3.133576382506861],
            [33.36926041458731, 3.132739097258406],
            [33.370045909556566, 3.132499407249673],
            [33.370974326487556, 3.132522737518517],
            [33.37176012239244, 3.133191978751137],
            [33.37325999270994, 3.133597643437031],
            [33.37416435185929, 3.132855584424698],
            [33.375771334596344, 3.133249218150101],
            [33.37660404771189, 3.131765709047566],
            [33.37881753070794, 3.130568336401862],
            [33.37934073198729, 3.129013280695757],
            [33.38137514661123, 3.126225409086837],
            [33.382089132090634, 3.125722640002701],
            [33.38470757202349, 3.125338249511749],
            [33.38596893244654, 3.124428510407332],
            [33.38577778173387, 3.122323767248805],
            [33.38646791514584, 3.121701424078917],
            [33.386158106865594, 3.120673101552919],
            [33.38669302217623, 3.118603765630833],
            [33.38523995588167, 3.115782275113622],
            [33.3859298871727, 3.114538047994063],
            [33.38541745938857, 3.112684643190251],
            [33.385869501521015, 3.111918944462102],
            [33.38670258384414, 3.111679217410721],
            [33.38777327594979, 3.110123791105734],
            [33.38784426172186, 3.108856039039434],
            [33.3871652656228, 3.107194110195995],
            [33.38849776542983, 3.1054949946605],
            [33.38873537970394, 3.104227133879867],
            [33.38704489047642, 3.103175789888239],
            [33.38578274223087, 3.101669710237851],
            [33.385556127827385, 3.100270590378065],
            [33.38598439514751, 3.099624499540881],
            [33.38626925002582, 3.097232422819296],
            [33.385792634478776, 3.095654072034596],
            [33.38601855717946, 3.094996159442495],
            [33.385018478943316, 3.094135720509739],
            [33.38297148071888, 3.094687166293862],
            [33.382328371417096, 3.093515544925465],
            [33.383899272422425, 3.092892644768836],
            [33.38475589689421, 3.09193533987255],
            [33.386469762980376, 3.091790723403373],
            [33.386802776541046, 3.091049016177927],
            [33.38804054450976, 3.090904700982758],
            [33.38823076007625, 3.09021092122902],
            [33.38944482869113, 3.090329739936732],
            [33.38980173833669, 3.089898969246487],
            [33.38958717393444, 3.088918424602018],
            [33.38745633863948, 3.087879320380908],
            [33.38719430725763, 3.087329364582643],
            [33.38764622542254, 3.086252708972293],
            [33.38733654290645, 3.085559262559281],
            [33.38757426138513, 3.084602339458268],
            [33.387026499267606, 3.083813375184254],
            [33.38713299723947, 3.081935664858405],
            [33.387561075913396, 3.080763358455449],
            [33.388060858113285, 3.080452079154337],
            [33.38810808614102, 3.079303943965576],
            [33.38775022967119, 3.076936197996536],
            [33.387047731847666, 3.076087525917038],
            [33.38633251926959, 3.072811079207903],
            [33.38897395068383, 3.070369646102495],
            [33.39436432747881, 3.06686202385578],
            [33.400706069567, 3.061129302602756],
            [33.41500872572051, 3.051815389303062],
            [33.42394542308511, 3.047755153879077],
            [33.43621480637339, 3.044577563976553],
            [33.43654748396415, 3.04304651839715],
            [33.43618958437516, 3.040774478487421],
            [33.436534412578446, 3.039925118455751],
            [33.43634364544637, 3.039016325374143],
            [33.43517673299398, 3.03751024317014],
            [33.43453311344911, 3.034975285357896],
            [33.43724989554942, 3.035723566475186],
            [33.439596273511974, 3.036978396342148],
            [33.44397826445105, 3.036377077793306],
            [33.445621250766365, 3.035490447951505],
            [33.446359659641686, 3.035753190808761],
            [33.44891946204441, 3.034590692561353],
            [33.45025339107105, 3.035116263869752],
            [33.45149173845312, 3.034876095256788],
            [33.45261129891025, 3.035377888190426],
            [33.45370678721271, 3.035209591693681],
            [33.45725564642132, 3.035781481221287],
            [33.46458014453203, 3.03827722428324],
            [33.46814067734776, 3.038262718943169],
            [33.47126024695345, 3.037327133066631],
            [33.47307025163964, 3.037277970953447],
            [33.482907509178276, 3.03999913325033],
            [33.48441493881888, 3.039266881822627],
            [33.487461693682576, 3.039240741734511],
            [33.48948476887268, 3.038808724209292],
            [33.492567498568604, 3.039440299851643],
            [33.493424645859875, 3.039989793153872],
            [33.496685409966986, 3.039485102195786],
            [33.50224706135063, 3.040484210850984],
            [33.515647595159855, 3.038503233962313],
            [33.52196379095799, 3.037120877157252],
            [33.56781065536272, 3.037029392943597],
            [33.56088016103058, 3.125779698619934],
            [33.559478771221045, 3.148935243600278],
            [33.556841508888006, 3.182372005617612],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 525,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "PAIMOL",
        Population: 21019,
        Key: "AGAGOPAIMOL",
        Dist2: "Agago",
        "Sub Country": "Paimol",
        id2_original: "Agago Paimol",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.39693596428706, 2.966164040629662],
            [33.39817417332861, 2.966570515623569],
            [33.39905546194481, 2.967599467890157],
            [33.4005079227749, 2.967957995398797],
            [33.40165155179342, 2.970183687991587],
            [33.40210389575979, 2.970135645138029],
            [33.402246956062044, 2.970710084231595],
            [33.40172346732182, 2.971548059124653],
            [33.40198560650149, 2.972218179317195],
            [33.40304518914207, 2.972445185009244],
            [33.40428386171429, 2.974120305289865],
            [33.40502173878697, 2.973593428930782],
            [33.40602172359832, 2.973593059323207],
            [33.40699828394032, 2.974693773435786],
            [33.40885552294246, 2.975100004865466],
            [33.40923667632089, 2.975650405265002],
            [33.41023659106363, 2.975506420948938],
            [33.410427296211935, 2.976128706066084],
            [33.41099859598654, 2.97581731415654],
            [33.41152247100235, 2.976032543723789],
            [33.41245135415897, 2.976941790307504],
            [33.41193996842054, 2.978294400147031],
            [33.41265420273327, 2.978174450436922],
            [33.413154724246645, 2.979634391499216],
            [33.413892984899945, 2.980112848459872],
            [33.414512507137346, 2.981429133541914],
            [33.41466819595586, 2.983906512813107],
            [33.413882731529306, 2.984529157402203],
            [33.414002135596874, 2.985462628427284],
            [33.413502236616, 2.985726129734242],
            [33.413812259593584, 2.987090407150404],
            [33.41343165598412, 2.988000137994525],
            [33.41278884671963, 2.988072186302677],
            [33.4129559701934, 2.989316837056767],
            [33.41239714622146, 2.991172121439332],
            [33.41304042350819, 2.992320838310814],
            [33.41275510599755, 2.993374162856495],
            [33.4139458902803, 2.994235431335117],
            [33.413779719020724, 2.995528065704024],
            [33.4144462707582, 2.995240581308421],
            [33.41534663689608, 2.99759090738267],
            [33.41596548270206, 2.997542665676797],
            [33.416513167564474, 2.998212030817974],
            [33.417072363438955, 2.997793092640551],
            [33.41740606870239, 2.999132328162727],
            [33.41833486562072, 3.000566845795155],
            [33.4202038734514, 3.002060547460422],
            [33.42129940936458, 3.003853737619768],
            [33.4230016296914, 3.004821321591764],
            [33.42326392068638, 3.006136688885382],
            [33.42380147075577, 3.011697482559364],
            [33.425351776984904, 3.020402929252594],
            [33.42520965362549, 3.022292609005573],
            [33.42270129145089, 3.030175572205298],
            [33.42290932420271, 3.034287075071089],
            [33.42411908539582, 3.034372401228866],
            [33.42466674869866, 3.034898250730585],
            [33.42502370236164, 3.034658820345871],
            [33.42716613490693, 3.035111833314145],
            [33.428058974959406, 3.035721159677453],
            [33.43046261243648, 3.034475759097104],
            [33.431295756743374, 3.034570854175971],
            [33.432699950194916, 3.034043687636637],
            [33.43453311344911, 3.034975285357896],
            [33.43517673299398, 3.03751024317014],
            [33.43634364544637, 3.039016325374143],
            [33.436534412578446, 3.039925118455751],
            [33.43618958437516, 3.040774478487421],
            [33.43654748396415, 3.04304651839715],
            [33.43621480637339, 3.044577563976553],
            [33.42394542308511, 3.047755153879077],
            [33.41500872572051, 3.051815389303062],
            [33.400706069567, 3.061129302602756],
            [33.39436432747881, 3.06686202385578],
            [33.38897395068383, 3.070369646102495],
            [33.38633251926959, 3.072811079207903],
            [33.387047731847666, 3.076087525917038],
            [33.38775022967119, 3.076936197996536],
            [33.38810808614102, 3.079303943965576],
            [33.388060858113285, 3.080452079154337],
            [33.387561075913396, 3.080763358455449],
            [33.38713299723947, 3.081935664858405],
            [33.387026499267606, 3.083813375184254],
            [33.38757426138513, 3.084602339458268],
            [33.38733654290645, 3.085559262559281],
            [33.38764622542254, 3.086252708972293],
            [33.38719430725763, 3.087329364582643],
            [33.38745633863948, 3.087879320380908],
            [33.38958717393444, 3.088918424602018],
            [33.38980173833669, 3.089898969246487],
            [33.38944482869113, 3.090329739936732],
            [33.38823076007625, 3.09021092122902],
            [33.38804054450976, 3.090904700982758],
            [33.386802776541046, 3.091049016177927],
            [33.386469762980376, 3.091790723403373],
            [33.38475589689421, 3.09193533987255],
            [33.383899272422425, 3.092892644768836],
            [33.382328371417096, 3.093515544925465],
            [33.38297148071888, 3.094687166293862],
            [33.385018478943316, 3.094135720509739],
            [33.38601855717946, 3.094996159442495],
            [33.385792634478776, 3.095654072034596],
            [33.38626925002582, 3.097232422819296],
            [33.38598439514751, 3.099624499540881],
            [33.385556127827385, 3.100270590378065],
            [33.38578274223087, 3.101669710237851],
            [33.38704489047642, 3.103175789888239],
            [33.38873537970394, 3.104227133879867],
            [33.38849776542983, 3.1054949946605],
            [33.3871652656228, 3.107194110195995],
            [33.38784426172186, 3.108856039039434],
            [33.38777327594979, 3.110123791105734],
            [33.38670258384414, 3.111679217410721],
            [33.385869501521015, 3.111918944462102],
            [33.38541745938857, 3.112684643190251],
            [33.3859298871727, 3.114538047994063],
            [33.38523995588167, 3.115782275113622],
            [33.38669302217623, 3.118603765630833],
            [33.386158106865594, 3.120673101552919],
            [33.38646791514584, 3.121701424078917],
            [33.38577778173387, 3.122323767248805],
            [33.38596893244654, 3.124428510407332],
            [33.38470757202349, 3.125338249511749],
            [33.382089132090634, 3.125722640002701],
            [33.38137514661123, 3.126225409086837],
            [33.37934073198729, 3.129013280695757],
            [33.37881753070794, 3.130568336401862],
            [33.37660404771189, 3.131765709047566],
            [33.375771334596344, 3.133249218150101],
            [33.37416435185929, 3.132855584424698],
            [33.37325999270994, 3.133597643437031],
            [33.37176012239244, 3.133191978751137],
            [33.370974326487556, 3.132522737518517],
            [33.370045909556566, 3.132499407249673],
            [33.36926041458731, 3.132739097258406],
            [33.36907024124165, 3.133576382506861],
            [33.366642518135166, 3.134893456983929],
            [33.36511862057876, 3.133794146687009],
            [33.36364263915964, 3.133651552356564],
            [33.36304768584526, 3.134249902517047],
            [33.36183834236874, 3.134209071474209],
            [33.35844983782824, 3.135094731875347],
            [33.35710602194357, 3.134557328707921],
            [33.356487830111156, 3.134904165023671],
            [33.35516793456586, 3.134773138183884],
            [33.353966785521365, 3.134175919403814],
            [33.35290862221896, 3.134463139542562],
            [33.35123259227425, 3.136077300168399],
            [33.35133980350848, 3.136662938883835],
            [33.34836746867616, 3.137608190910192],
            [33.34791586402327, 3.138325494717389],
            [33.34822522584082, 3.138946923868908],
            [33.34744088071509, 3.140261968023983],
            [33.34819072334737, 3.142472939408058],
            [33.34619016263322, 3.145224983403806],
            [33.346555712275155, 3.14814449058222],
            [33.3450126967729, 3.149342175850159],
            [33.3449157200447, 3.150087384920279],
            [33.34390749498725, 3.151492563665477],
            [33.340650799350065, 3.152336545789721],
            [33.33780164689942, 3.151492575325911],
            [33.33795462639903, 3.150457915489306],
            [33.338694507613134, 3.149447885104768],
            [33.34107296351617, 3.147055501210595],
            [33.34234074060529, 3.143547399168274],
            [33.343450592070816, 3.142165216856656],
            [33.34355598691154, 3.141102247597747],
            [33.34260412754489, 3.140571093991437],
            [33.3386915557491, 3.140306642331243],
            [33.33805694361157, 3.139828527760421],
            [33.33731642010208, 3.138818979516589],
            [33.33731554963455, 3.136108494093117],
            [33.33689210357255, 3.134620521230304],
            [33.333507490533876, 3.131911123719777],
            [33.332343875796894, 3.130476531036567],
            [33.331761709102274, 3.12861657861628],
            [33.33017503278225, 3.126863236794699],
            [33.32863372946889, 3.120880173684335],
            [33.32961881661957, 3.119382727687666],
            [33.3300419949836, 3.117348145640264],
            [33.32955948379338, 3.112580584275039],
            [33.32972056699517, 3.10903443931752],
            [33.33069321876737, 3.107485269235946],
            [33.334030524726565, 3.10534399074003],
            [33.334503467960744, 3.103693415049182],
            [33.33298083613055, 3.096948179542385],
            [33.333141877111544, 3.09327975694068],
            [33.342320764768296, 3.077890059286256],
            [33.344160504588714, 3.071603210092609],
            [33.34694017504709, 3.07086665207705],
            [33.34946736501171, 3.070865824122649],
            [33.3533557667365, 3.072134798470375],
            [33.35510526360006, 3.071841078596102],
            [33.360354305756445, 3.072621008838219],
            [33.36190913769799, 3.071545646220728],
            [33.36357088442969, 3.071420456539772],
            [33.367188263534906, 3.069337409361885],
            [33.370639847774655, 3.069695143519032],
            [33.37673303860014, 3.068496564980101],
            [33.3842310651726, 3.068613526572978],
            [33.38451678782347, 3.068852710783841],
            [33.38389804442542, 3.069235792387238],
            [33.38377945602812, 3.070432271953789],
            [33.38524258884377, 3.070992865328737],
            [33.394578575674046, 3.049427980330325],
            [33.391004708266244, 3.043110015083329],
            [33.38783285581272, 3.038976659530209],
            [33.38670028775026, 3.033105270583351],
            [33.382914211322884, 3.028850092735195],
            [33.38188996121907, 3.026602350410512],
            [33.38108075791282, 3.026913806790326],
            [33.37965230815199, 3.026053625367469],
            [33.379961211828764, 3.024403006310458],
            [33.37962776977171, 3.023781329070668],
            [33.37974643632242, 3.022680978330157],
            [33.38028159417821, 3.021424880484969],
            [33.380591167099844, 3.021807404836635],
            [33.38061475326593, 3.021161572587707],
            [33.38137637191327, 3.020945822630765],
            [33.38161417303698, 3.020228098880588],
            [33.38349419511137, 3.018959203308673],
            [33.385696061992476, 3.016235169554255],
            [33.384615287196034, 3.016148270300804],
            [33.38397840681243, 3.015595703199615],
            [33.38348583179606, 3.013908401297304],
            [33.381315244253145, 3.013705506749587],
            [33.3801282805053, 3.01251305220513],
            [33.37928884349985, 3.012018741058228],
            [33.37850750952695, 3.012164486017554],
            [33.378044215995594, 3.011437286950045],
            [33.37567073226766, 3.010303428702492],
            [33.374889029985525, 3.009372676377791],
            [33.371560816773616, 3.009082877579307],
            [33.3712711981294, 3.008442898381136],
            [33.369042505757264, 3.007541730099851],
            [33.368260840306036, 3.006698255793107],
            [33.3659454596107, 3.00617533864207],
            [33.3657723812049, 3.007862876792078],
            [33.36470142319791, 3.007339536778525],
            [33.36389111945541, 3.007397997565484],
            [33.363746582322825, 3.007892652595166],
            [33.360766171636136, 3.009173805270839],
            [33.36056336079107, 3.008475604919616],
            [33.359579433365404, 3.008592309275884],
            [33.35995588496165, 3.009290453036513],
            [33.357583122580884, 3.010309545861728],
            [33.355990835383594, 3.008535303612116],
            [33.35581740214324, 3.009175440641523],
            [33.353183255167636, 3.007343346669426],
            [33.3516777398369, 3.005387519005041],
            [33.351130624506354, 3.006553200853458],
            [33.35117862867852, 3.007916561509471],
            [33.352428760160514, 3.009602102764122],
            [33.353666725758586, 3.010366768524998],
            [33.354190965490425, 3.01235173677884],
            [33.355748368410296, 3.01552938899265],
            [33.355591000640494, 3.016757671016971],
            [33.35266018953387, 3.021416364632367],
            [33.35102009669211, 3.027666515995499],
            [33.349203271996295, 3.031499418303396],
            [33.34893829773355, 3.034261322390603],
            [33.3446498771111, 3.031889528208317],
            [33.34374557186067, 3.032631564354776],
            [33.341186761198045, 3.032764642790056],
            [33.326701942874585, 3.030656311553987],
            [33.32307166486018, 3.029570097383436],
            [33.318453263389465, 3.027348270869663],
            [33.30533554977442, 3.018696941692868],
            [33.29939519831136, 3.012541052571956],
            [33.29633635032731, 3.011765365086059],
            [33.29309910591097, 3.011551872995831],
            [33.29238489675105, 3.011002119479779],
            [33.290003855496636, 3.00782215933097],
            [33.28880015433842, 3.000730746564839],
            [33.28921613450211, 2.998350548008848],
            [33.28863471251087, 2.996879734032199],
            [33.28983706889111, 2.994141389501718],
            [33.289312713276615, 2.992059015249918],
            [33.28987165043627, 2.989820761846731],
            [33.2897755324975, 2.986493552809902],
            [33.28817989638083, 2.984938081874037],
            [33.28719133364831, 2.983131101964506],
            [33.28709579512291, 2.98195821301617],
            [33.286333630299865, 2.980953058056352],
            [33.285880616190305, 2.978463744269303],
            [33.2851303145189, 2.977279055239931],
            [33.28261637560306, 2.969200990397539],
            [33.27813958545202, 2.96647331090213],
            [33.27379353970073, 2.962824018448102],
            [33.2621138141582, 2.95680669996181],
            [33.2585779805212, 2.955909900509259],
            [33.24315254884016, 2.956138349424489],
            [33.23175702869393, 2.95570856969822],
            [33.224913639503306, 2.949751016772939],
            [33.219529815020024, 2.946133965025317],
            [33.21960420720365, 2.937361923481598],
            [33.21900785700902, 2.931527377085034],
            [33.219303977659294, 2.923897372460549],
            [33.21870723579919, 2.915968328357358],
            [33.21924385431566, 2.912186382447079],
            [33.22075930231849, 2.912098362549323],
            [33.22397378701877, 2.914132374040966],
            [33.22494992245765, 2.914156118108544],
            [33.22846202170653, 2.916225963514156],
            [33.22898606919888, 2.917518461783129],
            [33.23098601277043, 2.917853164520395],
            [33.23267660799914, 2.918906050170794],
            [33.23450965357406, 2.918067869698193],
            [33.23474786522784, 2.918666240204681],
            [33.23565257561846, 2.918689988662298],
            [33.23837815492034, 2.916570977600456],
            [33.2393781469182, 2.916810142064465],
            [33.23935447990373, 2.917480383108601],
            [33.24092753417081, 2.917466357050506],
            [33.24164002934513, 2.917336268358479],
            [33.24268792131058, 2.918915882035593],
            [33.24349721534667, 2.918077908812085],
            [33.24425921398138, 2.918747987613358],
            [33.246062789425075, 2.918979482778111],
            [33.24570599476388, 2.92048759499633],
            [33.2459205088605, 2.921612589114218],
            [33.247658946564634, 2.923598987998123],
            [33.24865872476345, 2.922880648294615],
            [33.249158713575866, 2.922928414175122],
            [33.24961127403623, 2.923885793896403],
            [33.2504207091078, 2.92369411687739],
            [33.25182108651601, 2.924374426962281],
            [33.2524161179838, 2.923584372591451],
            [33.25217767007312, 2.921932772095375],
            [33.25255849107487, 2.921453941997329],
            [33.25405896865352, 2.923966996357606],
            [33.25601099249453, 2.922865442556088],
            [33.256249131384784, 2.923128694062272],
            [33.257891856290335, 2.922960759898311],
            [33.258689710281296, 2.92419332557904],
            [33.25783281990819, 2.925055263258574],
            [33.25823767353874, 2.925557839234829],
            [33.26104714919994, 2.926035930128771],
            [33.26373742111786, 2.925771990298125],
            [33.26378519442301, 2.926466152816635],
            [33.26490436231632, 2.927231872840252],
            [33.266475749310246, 2.927399059044372],
            [33.26759491450865, 2.928140840876329],
            [33.26777388765934, 2.929900160028182],
            [33.26889304477289, 2.9305940634062],
            [33.26932215022117, 2.932891913205459],
            [33.27045763421504, 2.933876058592215],
            [33.27434313438143, 2.929895658174511],
            [33.281746244062646, 2.926196761143269],
            [33.300528030478496, 2.920496413069447],
            [33.306969892500064, 2.917241313885179],
            [33.30648884286878, 2.917037187757787],
            [33.311360435400644, 2.914495796561564],
            [33.31856028418084, 2.911964276409674],
            [33.32402553106318, 2.911177694282001],
            [33.3258471527626, 2.910479375662886],
            [33.3305319855469, 2.91100134749451],
            [33.33669108217154, 2.909691157878324],
            [33.343630041328595, 2.905415090592711],
            [33.34411542533114, 2.904051655123276],
            [33.34489951264034, 2.904892292582167],
            [33.3452194476288, 2.906375917746889],
            [33.34512869173393, 2.908104406025492],
            [33.34566172148083, 2.909924478826103],
            [33.345296869829866, 2.910827061447373],
            [33.34617972600627, 2.912356399620236],
            [33.34633332264848, 2.917128737559408],
            [33.34774989039305, 2.922634894682339],
            [33.34876935337469, 2.923093459532283],
            [33.34831408359545, 2.926795258298852],
            [33.3504600635878, 2.929471401896736],
            [33.35345754945142, 2.930617660891664],
            [33.35408170340243, 2.931841150760612],
            [33.35668389101516, 2.933782922224013],
            [33.35908878972688, 2.937239062625928],
            [33.35899779398187, 2.938141560469717],
            [33.36013953653832, 2.940313233679226],
            [33.359547158693886, 2.943326752949446],
            [33.36172348826811, 2.945574567014194],
            [33.36268273088807, 2.947914552708864],
            [33.36473701444944, 2.949091674513786],
            [33.36491999318798, 2.950345892167753],
            [33.36609166401643, 2.950911458199471],
            [33.36656363257852, 2.951920842596022],
            [33.366533826477394, 2.953817564197908],
            [33.36766114029373, 2.953962700549685],
            [33.36813102476435, 2.953661853451365],
            [33.36851572558981, 2.954177195141039],
            [33.36901383243171, 2.954122660021621],
            [33.3692657739363, 2.952936653958248],
            [33.37425390850323, 2.953665040028364],
            [33.3748015843825, 2.953928157776718],
            [33.37489705643259, 2.954646237966327],
            [33.37654005712092, 2.955268038712191],
            [33.377659612188154, 2.956895343425271],
            [33.37877869204663, 2.957110386486733],
            [33.37968388752749, 2.958498405623109],
            [33.38069574537197, 2.958462158467136],
            [33.38119590306765, 2.958988591683323],
            [33.382386431330524, 2.959251482992587],
            [33.38386240017326, 2.958772231120121],
            [33.384457750542985, 2.959155017750368],
            [33.38524330929263, 2.958795697926548],
            [33.385505550880275, 2.959800940340367],
            [33.38705313162082, 2.959848265052134],
            [33.38948128322368, 2.958913891389886],
            [33.39280336723039, 2.961102918211861],
            [33.393351379079576, 2.962299554427511],
            [33.39377991140271, 2.962227595043581],
            [33.39413739417342, 2.963232811017988],
            [33.39458978664883, 2.963304454552381],
            [33.39418542978661, 2.964405694756512],
            [33.39507886901535, 2.966140779418018],
            [33.39555514140597, 2.966403911249022],
            [33.39693596428706, 2.966164040629662],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 526,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "PARABONGO",
        Population: 11394,
        Key: "AGAGOPARABONGO",
        Dist2: "Agago",
        "Sub Country": "Parabongo",
        id2_original: "Agago Parabongo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.28632004687446, 2.809217097772785],
            [33.28567637882058, 2.81100673538553],
            [33.28455769691579, 2.811796929429817],
            [33.283986610940225, 2.812850293955369],
            [33.28310576609172, 2.812706886511728],
            [33.28205841940367, 2.813185885949031],
            [33.28172490637972, 2.812204548938568],
            [33.27977278641895, 2.812037465216072],
            [33.27970119158911, 2.811271496657538],
            [33.278820338655805, 2.811128086328087],
            [33.27901061800266, 2.810409928126008],
            [33.277891806740485, 2.810673502492],
            [33.27691570004768, 2.81038649145473],
            [33.27598762537485, 2.811870814833541],
            [33.27601152954455, 2.812301667277766],
            [33.27674959256849, 2.812636614318737],
            [33.27598789576774, 2.813019785734306],
            [33.27592848119485, 2.813462636444133],
            [33.275333365285434, 2.813606396407133],
            [33.27433327896445, 2.812553411196957],
            [33.27345241345471, 2.812338181086697],
            [33.273262086497176, 2.81288877807059],
            [33.274119301162095, 2.813750310676393],
            [33.27342908690175, 2.814420709868451],
            [33.27311937114797, 2.813367555816759],
            [33.27235752882012, 2.813152297145332],
            [33.27195291324311, 2.813511453068064],
            [33.271524283901925, 2.812984930930264],
            [33.271167438935095, 2.814014312267237],
            [33.27131053427168, 2.815139319599602],
            [33.27004885853994, 2.815307171804537],
            [33.27057273086082, 2.815929412147606],
            [33.26983487085612, 2.816480136636103],
            [33.269954129396616, 2.817437589387941],
            [33.27071603640315, 2.81796402876284],
            [33.26969259657972, 2.818921753948841],
            [33.26946663345487, 2.819747633443912],
            [33.27027621854508, 2.820537364870511],
            [33.27065739527973, 2.8217580631402],
            [33.26920544109947, 2.822668010642723],
            [33.26897187104076, 2.823256539206042],
            [33.268106085549704, 2.82338217670941],
            [33.26848715987638, 2.824124140139542],
            [33.26796354986358, 2.824698752921038],
            [33.26791613049467, 2.825512621670395],
            [33.266797214129596, 2.82539319766877],
            [33.2669401881936, 2.825991593404954],
            [33.267368726804946, 2.826111177947894],
            [33.26736887502697, 2.826757479598581],
            [33.26648818109545, 2.827356107908984],
            [33.265893332884, 2.828672782793372],
            [33.26494108185188, 2.828696935975595],
            [33.26429842080942, 2.829151889600755],
            [33.262869902776636, 2.828481980710962],
            [33.261500740027905, 2.827153779000029],
            [33.259596103216445, 2.826507911825742],
            [33.25907207818196, 2.825191486604533],
            [33.26402498351842, 2.782763561608113],
            [33.26536828377009, 2.775139301682394],
            [33.26962645093041, 2.762116580815301],
            [33.26965005326619, 2.761254838130111],
            [33.26526681187225, 2.747013270476471],
            [33.26517304572288, 2.745136944333524],
            [33.262984265498815, 2.745154706078619],
            [33.26253925897168, 2.742151726462658],
            [33.2624945318537, 2.740811259289202],
            [33.263249447272386, 2.738621648351902],
            [33.26276038107551, 2.737325961882517],
            [33.26307115145141, 2.736074782349441],
            [33.26213750632548, 2.733706811432095],
            [33.26213723503426, 2.732455699907207],
            [33.26235915574038, 2.731293904703074],
            [33.26440125275662, 2.729721875495283],
            [33.26486961817609, 2.728421006499807],
            [33.26448377110033, 2.727387024768793],
            [33.26491976932178, 2.722630212281013],
            [33.25799861387532, 2.716660308663688],
            [33.2486612490294, 2.706500547320351],
            [33.246992650847034, 2.704274986818417],
            [33.24429675367878, 2.69827527344282],
            [33.24034964974514, 2.691566089951948],
            [33.23544025161457, 2.685050632497132],
            [33.23669077655863, 2.682114775594793],
            [33.238452229998664, 2.667113761082343],
            [33.23880498403771, 2.66653302082626],
            [33.2423655986001, 2.665887130498294],
            [33.2425239661948, 2.655531799917501],
            [33.24359471938593, 2.655077623767702],
            [33.24428988246519, 2.655285310242124],
            [33.246578470907195, 2.656928551381681],
            [33.24908484061846, 2.657804683736066],
            [33.25384098346665, 2.657910154539207],
            [33.253888179155055, 2.657376680511382],
            [33.26114451220368, 2.657558525636235],
            [33.26238181035352, 2.65705128726436],
            [33.263355876972305, 2.657846114336949],
            [33.267205758937685, 2.658559644723517],
            [33.270098470696475, 2.657808514518775],
            [33.272839170441195, 2.657690052784904],
            [33.27490950150681, 2.657689590650145],
            [33.27508703375979, 2.658165356049123],
            [33.28930182120378, 2.65818109195584],
            [33.290484058016624, 2.659072335659489],
            [33.29078033138046, 2.662341181795456],
            [33.29137155668639, 2.66323256427241],
            [33.296395337302116, 2.663825706490536],
            [33.30329050269077, 2.663724960713085],
            [33.306541188598715, 2.664120382749847],
            [33.31048159289694, 2.665308083847763],
            [33.317968103067464, 2.666494855947282],
            [33.32054353435946, 2.667638755500887],
            [33.32242226735141, 2.669642163656719],
            [33.32247975683466, 2.67043717104449],
            [33.323625989170864, 2.672211268788517],
            [33.32331784277392, 2.676831710556351],
            [33.32590736773444, 2.677199724666633],
            [33.32771798507165, 2.678374488814193],
            [33.32950538006043, 2.678374006945862],
            [33.33210666396802, 2.679905747861901],
            [33.333802957210594, 2.681933168307554],
            [33.334223894278004, 2.688964960399445],
            [33.3330507753653, 2.691652670972179],
            [33.33480006022652, 2.69529397571638],
            [33.335425435886265, 2.698885357102877],
            [33.33605000126567, 2.699513078147326],
            [33.33649993774708, 2.700869203663744],
            [33.337274338522576, 2.701421534701149],
            [33.34219491888185, 2.702701053320696],
            [33.344967263579065, 2.70282584305677],
            [33.34688996191767, 2.701293231824305],
            [33.34821351630109, 2.700740304909742],
            [33.34948683958876, 2.699207877687725],
            [33.351534657076755, 2.698554275110843],
            [33.35350786319219, 2.6990057826725],
            [33.35573066800595, 2.698904667404686],
            [33.35822851989171, 2.699883442671822],
            [33.361700194952775, 2.700083333728124],
            [33.3637983899619, 2.700886405238171],
            [33.368769715253244, 2.704752711783619],
            [33.37084349495125, 2.707364105118389],
            [33.37234312541856, 2.710904951975169],
            [33.38190640398205, 2.711721961401562],
            [33.38138463371894, 2.712682964096188],
            [33.38193476469388, 2.713166708477941],
            [33.382347674415925, 2.714526175541222],
            [33.382049993391995, 2.715240633822607],
            [33.38262300266061, 2.715586113025004],
            [33.3824168752355, 2.715977929021981],
            [33.38184397645969, 2.715955062070407],
            [33.38136305079595, 2.716946112160054],
            [33.3816501379877, 2.718985408541575],
            [33.38231502604522, 2.719999142660329],
            [33.38371288188243, 2.719975647672677],
            [33.38378201443006, 2.721173917480992],
            [33.382292397483226, 2.720897859691878],
            [33.38155921410788, 2.721312883584053],
            [33.381731704117186, 2.723306137464184],
            [33.38090676861534, 2.723421617373857],
            [33.38067789584725, 2.724320418891057],
            [33.380127896924684, 2.724274494178918],
            [33.380150982729155, 2.724827544927314],
            [33.38145726071304, 2.725034533088759],
            [33.38076990040033, 2.725426503042848],
            [33.380907515115354, 2.725795161044124],
            [33.38193873434912, 2.72577178371565],
            [33.38253468928502, 2.726209433107168],
            [33.381572319629576, 2.726532361853632],
            [33.38141211228518, 2.727177637637482],
            [33.38072470076851, 2.727408292518955],
            [33.38027856955065, 2.729724365491594],
            [33.381286969779566, 2.73004666608436],
            [33.38002691101538, 2.731084043583373],
            [33.38057727645059, 2.732282149789713],
            [33.379293679131024, 2.731337759985398],
            [33.37890415435245, 2.731499190480733],
            [33.379156585438885, 2.732628272846705],
            [33.37860673473831, 2.73306627865879],
            [33.37892775219667, 2.733688362190747],
            [33.378286184403905, 2.73396509898663],
            [33.37874474830531, 2.734702365669325],
            [33.378121095614226, 2.735595338019433],
            [33.376602778392396, 2.736926788773864],
            [33.37607546911725, 2.736189542301888],
            [33.37534223902953, 2.73648934697289],
            [33.37511326205684, 2.73706552514387],
            [33.37323398917742, 2.736605225807296],
            [33.372752943139396, 2.737250620901437],
            [33.37208812425213, 2.736444286817111],
            [33.37069072026751, 2.738034757289554],
            [33.36933857340691, 2.737758643254907],
            [33.3677463095658, 2.739153300227771],
            [33.36632550267141, 2.739130707389951],
            [33.366279484674365, 2.738554615454557],
            [33.365500405472844, 2.738785289684708],
            [33.365179487727495, 2.738508864463607],
            [33.36382773882057, 2.739523215601516],
            [33.36330044391845, 2.738809011318813],
            [33.36288826452674, 2.739846115641844],
            [33.363438535638856, 2.740767717506804],
            [33.36249899846299, 2.74086017223382],
            [33.361880693442835, 2.742335179399576],
            [33.36105562948193, 2.742104993977533],
            [33.35988699855239, 2.742451002036531],
            [33.3588104620075, 2.744225719348294],
            [33.35803119685471, 2.74385726082532],
            [33.35573969158296, 2.744364909795745],
            [33.35532704057575, 2.743835023401337],
            [33.35489175022671, 2.744226895689064],
            [33.35489196761901, 2.744964309489147],
            [33.35379201019801, 2.745079865377915],
            [33.35399863079821, 2.746347227874196],
            [33.35319668857439, 2.746808347168774],
            [33.35253201162093, 2.746462881433081],
            [33.3519826621803, 2.747697154272696],
            [33.35203400628867, 2.74892766532916],
            [33.35121810963525, 2.748620281744611],
            [33.35103985064522, 2.749312503952447],
            [33.3513970522432, 2.750260914644352],
            [33.351091309737946, 2.750901914667152],
            [33.35032648500338, 2.750902140781719],
            [33.350505142845385, 2.751568623200471],
            [33.34662103776262, 2.746668507372855],
            [33.34058672701245, 2.741968661125483],
            [33.33669960359034, 2.740334761754145],
            [33.331845007183624, 2.740326396337802],
            [33.325551179436054, 2.738817924989426],
            [33.323404963186796, 2.736085749042677],
            [33.31739684820862, 2.73313885803358],
            [33.31347194254395, 2.732417195229606],
            [33.31125175721756, 2.730557211990599],
            [33.30874257038956, 2.729761129501414],
            [33.303879504666384, 2.729762376742792],
            [33.300304274514275, 2.731992642313773],
            [33.29658578553225, 2.733359955597563],
            [33.294869350264364, 2.733144635705872],
            [33.285969219721714, 2.735860905789591],
            [33.285595681361954, 2.735077759487096],
            [33.283608793904754, 2.735111325384519],
            [33.28037744153838, 2.736111968788907],
            [33.2726350067333, 2.741319506248512],
            [33.273989853929656, 2.74289108685891],
            [33.27586602851968, 2.743338302249442],
            [33.276744082302564, 2.74518553228425],
            [33.278641162485876, 2.74686605593455],
            [33.27918065381459, 2.752222920196523],
            [33.278859908545755, 2.754862028657167],
            [33.279182160289324, 2.758685858652907],
            [33.2801464828822, 2.759708928492993],
            [33.28132537796214, 2.762132249869811],
            [33.282397425625575, 2.765686609331498],
            [33.28261217867405, 2.76784086934184],
            [33.28207749063715, 2.771718758087373],
            [33.28041760341808, 2.773819609224035],
            [33.278329637525104, 2.777697866885108],
            [33.27816990179623, 2.781737240292469],
            [33.27592220107271, 2.789762585184584],
            [33.27849356209815, 2.791485425393072],
            [33.27972546676305, 2.791431272805741],
            [33.28176055242851, 2.790353629159231],
            [33.2894203179729, 2.792236779050375],
            [33.29807311626667, 2.795172226975191],
            [33.29821834959361, 2.796497767082351],
            [33.29895632907426, 2.796521517170487],
            [33.298599647600795, 2.798125382748022],
            [33.29917106595302, 2.798460358075608],
            [33.29931411278056, 2.799298107319101],
            [33.29852858098035, 2.799489808730017],
            [33.29779041285352, 2.798724017680954],
            [33.29748098635728, 2.798915587290941],
            [33.29798116291759, 2.799920810193454],
            [33.29712451149634, 2.801309379759301],
            [33.29769604034134, 2.802075213082939],
            [33.29750571338378, 2.802554006027588],
            [33.295382719482916, 2.802180941292845],
            [33.294863283042936, 2.802530739674561],
            [33.294792230795544, 2.803966980981345],
            [33.293268597343825, 2.803680120827596],
            [33.293054437183464, 2.804063164184426],
            [33.29355459308251, 2.804972640988034],
            [33.29253107869892, 2.805523448706869],
            [33.29212628076393, 2.805092693355494],
            [33.290638515244886, 2.805464086503388],
            [33.29030559780394, 2.806924322619766],
            [33.288162977510765, 2.806493988589144],
            [33.28780610649278, 2.807355812133413],
            [33.28692546017201, 2.808026259860895],
            [33.28768736717854, 2.808528758940371],
            [33.287592219420276, 2.808863895483731],
            [33.28632004687446, 2.809217097772785],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 527,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "PATONGO",
        Population: 10992,
        Key: "AGAGOPATONGO",
        Dist2: "Agago",
        "Sub Country": "Patongo",
        id2_original: "Agago Patongo",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.350505142845385, 2.751568623200471],
            [33.350505315321925, 2.752158247906431],
            [33.349766094369556, 2.752543001142966],
            [33.350148733561475, 2.753337601424729],
            [33.349486231429324, 2.754491420850445],
            [33.34743618162784, 2.756246250971429],
            [33.34800769609982, 2.756916314118604],
            [33.34796027223935, 2.757562611660975],
            [33.347698476216074, 2.757778125450004],
            [33.34729365222993, 2.757275573329717],
            [33.34641299063777, 2.757658829155275],
            [33.34529403564513, 2.757180413692097],
            [33.345175193922955, 2.757802813071714],
            [33.34417567443893, 2.758760578264615],
            [33.34336600311039, 2.757659717457523],
            [33.34196203244106, 2.759383575298804],
            [33.342057363455645, 2.759790474496407],
            [33.34116467611677, 2.759754834796658],
            [33.34102204520923, 2.760449036197176],
            [33.34049829056766, 2.760257699017385],
            [33.340665231683424, 2.761334809314693],
            [33.339998873083765, 2.761933427022679],
            [33.339118109982, 2.761981547707066],
            [33.33914176621666, 2.76145492983362],
            [33.3380466291555, 2.761024379104072],
            [33.33645189494737, 2.761647199086207],
            [33.33604733776084, 2.762078179383121],
            [33.33554816641534, 2.764687444316904],
            [33.334334186733635, 2.764903217021553],
            [33.33457240647226, 2.765525513655329],
            [33.33416786006552, 2.766004361829953],
            [33.33359641656048, 2.765549728255212],
            [33.332382647982854, 2.766531476565822],
            [33.331442303221536, 2.766328272196666],
            [33.33101420208974, 2.767716735095056],
            [33.33034752907973, 2.767214258962448],
            [33.32970494169913, 2.767717102077418],
            [33.32972853774668, 2.766927188867881],
            [33.329204831614135, 2.766951265259873],
            [33.32853840114927, 2.767358387077607],
            [33.32885997376647, 2.768064418984273],
            [33.32805055576285, 2.76789709300731],
            [33.32771765269499, 2.769237660688046],
            [33.326955837316596, 2.768974566940688],
            [33.326741790343966, 2.769740603438076],
            [33.32638470732357, 2.769692834796779],
            [33.325932144168284, 2.768711544916244],
            [33.325551294420414, 2.768807386449461],
            [33.32445653285503, 2.769765165193755],
            [33.324813731758084, 2.770243818743235],
            [33.32301637445276, 2.769921161132491],
            [33.32268324141618, 2.770399995866547],
            [33.322183271468404, 2.770136818034441],
            [33.32168343357293, 2.770400269532471],
            [33.32075475792717, 2.769299414138875],
            [33.320731102590806, 2.769897838504066],
            [33.319802576065335, 2.769347550675178],
            [33.31885055500198, 2.769994103450711],
            [33.31768400546895, 2.769635358633253],
            [33.31563681769998, 2.769755602134279],
            [33.31589890567572, 2.770641193335093],
            [33.31482768625897, 2.770641480459966],
            [33.31339982938622, 2.772317458484185],
            [33.31369778349797, 2.773765560804891],
            [33.31286536143657, 2.77666215581771],
            [33.31129420261475, 2.776542888341156],
            [33.31107979541768, 2.775944518481386],
            [33.3105799835734, 2.776255842940941],
            [33.31036616117957, 2.7779314792264],
            [33.310783221118214, 2.779690734023212],
            [33.30956925401293, 2.78007405348126],
            [33.307831322060295, 2.77945214314265],
            [33.30671256649367, 2.779787558061523],
            [33.3058796647319, 2.780864937714117],
            [33.30349901244799, 2.780338944657698],
            [33.30321358444457, 2.781200742538192],
            [33.304094751788234, 2.782708538281107],
            [33.30373795443211, 2.783785807594255],
            [33.305750006395364, 2.78578401745914],
            [33.30501215178055, 2.786215075992869],
            [33.304250221417824, 2.785568978930952],
            [33.30372671740622, 2.786382970925191],
            [33.30386965284265, 2.786789861732647],
            [33.30515521208281, 2.787100710476949],
            [33.30391754023382, 2.787890950252538],
            [33.30491773435263, 2.789326912491433],
            [33.30465616739977, 2.790452010844434],
            [33.30387053858151, 2.790236786541345],
            [33.303740031337036, 2.791876502215628],
            [33.3024308293369, 2.792259831165186],
            [33.30112201990056, 2.794151196785915],
            [33.30062196012124, 2.793600775818188],
            [33.30009834471853, 2.79398389963257],
            [33.299955397604, 2.79355306915622],
            [33.29871789823155, 2.795061417025572],
            [33.29807311626667, 2.795172226975191],
            [33.2894203179729, 2.792236779050375],
            [33.28176055242851, 2.790353629159231],
            [33.27972546676305, 2.791431272805741],
            [33.27849356209815, 2.791485425393072],
            [33.27592220107271, 2.789762585184584],
            [33.27816990179623, 2.781737240292469],
            [33.278329637525104, 2.777697866885108],
            [33.28041760341808, 2.773819609224035],
            [33.28207749063715, 2.771718758087373],
            [33.28261217867405, 2.76784086934184],
            [33.282397425625575, 2.765686609331498],
            [33.28132537796214, 2.762132249869811],
            [33.2801464828822, 2.759708928492993],
            [33.279182160289324, 2.758685858652907],
            [33.278859908545755, 2.754862028657167],
            [33.27918065381459, 2.752222920196523],
            [33.278641162485876, 2.74686605593455],
            [33.276744082302564, 2.74518553228425],
            [33.27586602851968, 2.743338302249442],
            [33.273989853929656, 2.74289108685891],
            [33.2726350067333, 2.741319506248512],
            [33.28037744153838, 2.736111968788907],
            [33.283608793904754, 2.735111325384519],
            [33.285595681361954, 2.735077759487096],
            [33.285969219721714, 2.735860905789591],
            [33.294869350264364, 2.733144635705872],
            [33.29658578553225, 2.733359955597563],
            [33.300304274514275, 2.731992642313773],
            [33.303879504666384, 2.729762376742792],
            [33.30874257038956, 2.729761129501414],
            [33.31125175721756, 2.730557211990599],
            [33.31347194254395, 2.732417195229606],
            [33.31739684820862, 2.73313885803358],
            [33.323404963186796, 2.736085749042677],
            [33.325551179436054, 2.738817924989426],
            [33.331845007183624, 2.740326396337802],
            [33.33669960359034, 2.740334761754145],
            [33.34058672701245, 2.741968661125483],
            [33.34662103776262, 2.746668507372855],
            [33.350505142845385, 2.751568623200471],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 528,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "PATONGO TOWN COUNCIL",
        Population: 11528,
        Key: "AGAGOPATONGO TOWN COUNCIL",
        Dist2: "Agago",
        "Sub Country": "Patongo T/C",
        id2_original: "Agago Patongo T/C",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.33571167866165, 3.164209874743429],
            [33.327852765601925, 3.165864508708068],
            [33.31859014148593, 3.169922586282651],
            [33.312017557522545, 3.175932266805646],
            [33.30977654475632, 3.176834093882202],
            [33.30394929208586, 3.177136218253028],
            [33.301857949425695, 3.178939136720084],
            [33.297525088247845, 3.179991744427752],
            [33.29721480655543, 3.184521656632914],
            [33.282786203005834, 3.185426513192535],
            [33.24629254523708, 3.172184873902935],
            [33.24149800300376, 3.173275218189219],
            [33.23785440117707, 3.17569256522775],
            [33.23526117605591, 3.176100265517634],
            [33.21133322793992, 3.170740030895594],
            [33.179987633604796, 3.181945965580844],
            [33.17387507420346, 3.181444871995939],
            [33.160214396372815, 3.180338341338994],
            [33.15677650874618, 3.180877686890955],
            [33.151163466541746, 3.180879565961994],
            [33.147059418843135, 3.181514783264094],
            [33.14491948181769, 3.181204528599256],
            [33.14268255997928, 3.181803235249702],
            [33.14075687114911, 3.181397234206654],
            [33.14066352541128, 3.180512251906736],
            [33.14124908504271, 3.179112776650044],
            [33.140822764371826, 3.178227909888118],
            [33.14175325371616, 3.176792457270976],
            [33.14173253227751, 3.17528554106678],
            [33.140997177674116, 3.174329011144024],
            [33.14203354335615, 3.173455624673069],
            [33.141417441903364, 3.1723316103954],
            [33.1420605871378, 3.171853026212684],
            [33.141539566967936, 3.170752901088873],
            [33.14182512073552, 3.170681058876869],
            [33.14211422284846, 3.168863091463303],
            [33.14275789090234, 3.168121394843448],
            [33.14215526687378, 3.166220000866018],
            [33.14241906524182, 3.165143547307637],
            [33.14035333444873, 3.163445948459764],
            [33.139521248357255, 3.163278784544145],
            [33.139760241545346, 3.162704641721038],
            [33.13861921225123, 3.162417972022658],
            [33.13773352728, 3.1593685467479],
            [33.13622903513036, 3.156534585613756],
            [33.13599641369259, 3.1539753010563],
            [33.13545031435666, 3.153521004220562],
            [33.134539109146516, 3.151332677528069],
            [33.1337081073216, 3.150639275820014],
            [33.1326437555252, 3.1477453748705],
            [33.13265933321053, 3.145939464620788],
            [33.13387715947828, 3.143547150709336],
            [33.13337990783255, 3.142470936486351],
            [33.13373904350335, 3.141298782624655],
            [33.134406289638505, 3.140652749299728],
            [33.13492213191907, 3.138440057265242],
            [33.13480605071974, 3.137052775203174],
            [33.134257819681594, 3.137650925187774],
            [33.13390136548193, 3.137507524111273],
            [33.133787619004025, 3.134972119543814],
            [33.13447854383175, 3.134373915105661],
            [33.13521572201515, 3.134421520967118],
            [33.13567013120837, 3.133177574270338],
            [33.135042641812724, 3.131826332806034],
            [33.135424337773586, 3.131252152022197],
            [33.135116282106445, 3.130702101334351],
            [33.13595199379844, 3.129075328114395],
            [33.135787948851124, 3.127879414466873],
            [33.13725725309279, 3.124613968173262],
            [33.13714242683991, 3.122604779934841],
            [33.13833375640004, 3.121528038285279],
            [33.1378984238302, 3.119243885277725],
            [33.138493828098824, 3.118837070488704],
            [33.138873621427905, 3.119195739639726],
            [33.13894574087385, 3.118813007078997],
            [33.1376678110254, 3.115703903533081],
            [33.138515085831706, 3.114232598284795],
            [33.13797237673765, 3.112127868807392],
            [33.137165666256315, 3.111195272806201],
            [33.13745505133855, 3.109233796908022],
            [33.13707701241923, 3.108014028464499],
            [33.13742549317245, 3.106231937686626],
            [33.136292077998704, 3.102237763619155],
            [33.13657916519046, 3.101400501865677],
            [33.13777061961642, 3.100252000042042],
            [33.13783117145643, 3.099713797787721],
            [33.13690508206035, 3.099020426555148],
            [33.13659780792756, 3.098087671871908],
            [33.1378625136767, 3.096006292428484],
            [33.13750928802217, 3.094284213517268],
            [33.13782001168566, 3.093518699696429],
            [33.13717954612577, 3.092705643956591],
            [33.13756220687722, 3.091653077562281],
            [33.136624453755495, 3.090852067216455],
            [33.13657951822835, 3.089560446851567],
            [33.136105097265556, 3.088962605041137],
            [33.13651212392081, 3.087623002145036],
            [33.13596665071062, 3.0868816759288],
            [33.13561464676485, 3.084561609649974],
            [33.13134189186262, 3.074035468320035],
            [33.131366939587686, 3.073413556935817],
            [33.13183700821295, 3.073361630952684],
            [33.13239154183109, 3.072906304549055],
            [33.13323504730644, 3.07280304366951],
            [33.13315738256025, 3.072037712631873],
            [33.13314693425517, 3.072021903474555],
            [33.13326347898521, 3.071318408294263],
            [33.13336107195768, 3.070729308518671],
            [33.133364198094846, 3.070686504257214],
            [33.13340084037528, 3.070219789866244],
            [33.133029121103974, 3.068832498970643],
            [33.13174697097033, 3.067828278514687],
            [33.131273144692244, 3.06694340947257],
            [33.13215409284698, 3.066440837402366],
            [33.133128597843594, 3.066703643559837],
            [33.13386645964491, 3.066392467800676],
            [33.13414344168806, 3.06468214680938],
            [33.13540658706358, 3.063342278382694],
            [33.13545795991806, 3.061476551392099],
            [33.13667276784642, 3.060519402173606],
            [33.13678488028884, 3.05801978975788],
            [33.13766878300253, 3.056058135055027],
            [33.137696418773935, 3.054168500056334],
            [33.13899412952497, 3.053366791492042],
            [33.138211396875185, 3.052362429162696],
            [33.13947341576331, 3.051572693857583],
            [33.138880683982656, 3.05068786252942],
            [33.13976448339011, 3.048774037372881],
            [33.138638613166414, 3.04694456426866],
            [33.139164329728565, 3.045700598465784],
            [33.13924186511738, 3.042662813864021],
            [33.13985234581142, 3.040665357672157],
            [33.13880998656982, 3.03870430464585],
            [33.13923982414504, 3.031994792561693],
            [33.13964523023953, 3.030613592711709],
            [33.140447590179924, 3.030159912241191],
            [33.14009865757413, 3.029328725478561],
            [33.14130250515774, 3.028497048282709],
            [33.14132903240806, 3.027766505142153],
            [33.14193159624951, 3.027035784787699],
            [33.14178245794603, 3.026481627354564],
            [33.1429107006204, 3.025876691396633],
            [33.14244667675871, 3.019795281657233],
            [33.14369277121182, 3.016738698875223],
            [33.14484789507273, 3.015515977775149],
            [33.14730194869846, 3.014234368774154],
            [33.15242645291544, 3.012219290968613],
            [33.15548759250179, 3.007904023054804],
            [33.15795068767088, 3.006237532237352],
            [33.15901375577477, 3.004663709969093],
            [33.16032048830619, 3.000904125893538],
            [33.161822805634515, 2.998600438330652],
            [33.163527258274826, 2.993912699967497],
            [33.16497064971378, 2.992131516322218],
            [33.16571766894112, 2.99040346813359],
            [33.16790249567959, 2.9894413221494],
            [33.169838724442975, 2.987056064568849],
            [33.17234728873852, 2.985227207964833],
            [33.17647066458877, 2.976947949816833],
            [33.17948321609802, 2.974276603452878],
            [33.18090820015851, 2.971149512806103],
            [33.182126171054996, 2.970263431067825],
            [33.182657248762766, 2.968608653178778],
            [33.18505433213155, 2.966653966721932],
            [33.18816359356934, 2.961409442033553],
            [33.190538886504264, 2.959897497032295],
            [33.191145287948586, 2.959034373387558],
            [33.1919539351977, 2.958851854805084],
            [33.19230895838112, 2.958117075686259],
            [33.19357297691908, 2.957651332136528],
            [33.194933697300755, 2.956196840743462],
            [33.19749863806691, 2.956108035742575],
            [33.19856210232778, 2.955837909311305],
            [33.19895550513342, 2.955234126655662],
            [33.19907446543325, 2.955813198136652],
            [33.20125213439555, 2.955116874776949],
            [33.20609817434917, 2.954912973570694],
            [33.21932415741382, 2.956128465854479],
            [33.228410550037374, 2.956126623170204],
            [33.23175702869393, 2.95570856969822],
            [33.24315254884016, 2.956138349424489],
            [33.2585779805212, 2.955909900509259],
            [33.2621138141582, 2.95680669996181],
            [33.27379353970073, 2.962824018448102],
            [33.27813958545202, 2.96647331090213],
            [33.28261637560306, 2.969200990397539],
            [33.2851303145189, 2.977279055239931],
            [33.285880616190305, 2.978463744269303],
            [33.286333630299865, 2.980953058056352],
            [33.28709579512291, 2.98195821301617],
            [33.28719133364831, 2.983131101964506],
            [33.28817989638083, 2.984938081874037],
            [33.2897755324975, 2.986493552809902],
            [33.28987165043627, 2.989820761846731],
            [33.289312713276615, 2.992059015249918],
            [33.28983706889111, 2.994141389501718],
            [33.28863471251087, 2.996879734032199],
            [33.28921613450211, 2.998350548008848],
            [33.28880015433842, 3.000730746564839],
            [33.290003855496636, 3.00782215933097],
            [33.29238489675105, 3.011002119479779],
            [33.29309910591097, 3.011551872995831],
            [33.29633635032731, 3.011765365086059],
            [33.29939519831136, 3.012541052571956],
            [33.30533554977442, 3.018696941692868],
            [33.318453263389465, 3.027348270869663],
            [33.32307166486018, 3.029570097383436],
            [33.326701942874585, 3.030656311553987],
            [33.341186761198045, 3.032764642790056],
            [33.34374557186067, 3.032631564354776],
            [33.3446498771111, 3.031889528208317],
            [33.34893829773355, 3.034261322390603],
            [33.357302865280225, 3.03725172406781],
            [33.36264761215034, 3.040274214842637],
            [33.36457627260745, 3.043068736496644],
            [33.35423110042067, 3.046908856480764],
            [33.351352979997074, 3.04862171034975],
            [33.35021807451826, 3.049722590832878],
            [33.350056383157, 3.051230746071362],
            [33.35074636295704, 3.053431541631016],
            [33.3502201882541, 3.056244133124494],
            [33.347585748427704, 3.059342719850278],
            [33.34448571089124, 3.064581338513967],
            [33.344040461818985, 3.066945543503683],
            [33.344160504588714, 3.071603210092609],
            [33.342320764768296, 3.077890059286256],
            [33.333141877111544, 3.09327975694068],
            [33.33298083613055, 3.096948179542385],
            [33.334503467960744, 3.103693415049182],
            [33.334030524726565, 3.10534399074003],
            [33.33069321876737, 3.107485269235946],
            [33.32972056699517, 3.10903443931752],
            [33.32955948379338, 3.112580584275039],
            [33.3300419949836, 3.117348145640264],
            [33.32961881661957, 3.119382727687666],
            [33.32863372946889, 3.120880173684335],
            [33.33017503278225, 3.126863236794699],
            [33.331761709102274, 3.12861657861628],
            [33.332343875796894, 3.130476531036567],
            [33.333507490533876, 3.131911123719777],
            [33.33689210357255, 3.134620521230304],
            [33.33731554963455, 3.136108494093117],
            [33.33731642010208, 3.138818979516589],
            [33.33805694361157, 3.139828527760421],
            [33.3386915557491, 3.140306642331243],
            [33.34260412754489, 3.140571093991437],
            [33.34355598691154, 3.141102247597747],
            [33.343450592070816, 3.142165216856656],
            [33.34234074060529, 3.143547399168274],
            [33.34107296351617, 3.147055501210595],
            [33.338694507613134, 3.149447885104768],
            [33.33795462639903, 3.150457915489306],
            [33.33780164689942, 3.151492575325911],
            [33.33750650810775, 3.154857687832593],
            [33.336004430629615, 3.156078012533481],
            [33.33432980475169, 3.159854238744837],
            [33.33456184857274, 3.162642360406907],
            [33.33571167866165, 3.164209874743429],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 529,
        District: "AGAGO",
        County: "AGAGO",
        Subcounty: "WOL",
        Population: 23288,
        Key: "AGAGOWOL",
        Dist2: "Agago",
        "Sub Country": "Wol",
        id2_original: "Agago Wol",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "N",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.90068699381172, 3.295336726731474],
            [32.90167961782762, 3.297510875047408],
            [32.9013758354463, 3.298605974024501],
            [32.901732874449245, 3.300832157048772],
            [32.901446959558925, 3.302052917126695],
            [32.9008752824919, 3.302663259384801],
            [32.90069649619078, 3.304243083233846],
            [32.901625214057404, 3.30585892446399],
            [32.9026254315324, 3.306684852679702],
            [32.90176787371102, 3.30822871847397],
            [32.90301809143131, 3.31006002867136],
            [32.90526876288346, 3.310527014427273],
            [32.905875909929506, 3.31257368946689],
            [32.90701817350881, 3.313115948110871],
            [32.90477718769202, 3.316145133144432],
            [32.89856564562447, 3.320751881426292],
            [32.897333372650344, 3.323722416271116],
            [32.895792961364066, 3.324969221771801],
            [32.89565453277541, 3.325707868878077],
            [32.89318551950521, 3.32698400265082],
            [32.8894177848793, 3.330100511238407],
            [32.887386638326376, 3.330933704777096],
            [32.882273353168976, 3.332082714454615],
            [32.877377886111795, 3.331838048577624],
            [32.87526258268812, 3.332540822273307],
            [32.874615720225066, 3.331902030546077],
            [32.87385395245738, 3.331954145199259],
            [32.87245523244088, 3.333009673492111],
            [32.87209156476946, 3.331940799070162],
            [32.87066071381185, 3.33161606801806],
            [32.869899513779465, 3.331763379476318],
            [32.86820548608801, 3.333213357313923],
            [32.86761271478148, 3.333645284464483],
            [32.865768258805836, 3.333824499102613],
            [32.86574560329437, 3.330064111983354],
            [32.864328383372914, 3.328049431565699],
            [32.8623894506805, 3.318492999767415],
            [32.86293489514462, 3.314158026424844],
            [32.86493246087562, 3.311706630147242],
            [32.86707669544135, 3.3079096089561],
            [32.867317906569866, 3.302493496995851],
            [32.86796639228864, 3.299044668499066],
            [32.86884301864854, 3.299701348914458],
            [32.87460170740494, 3.301411199987846],
            [32.87733108837707, 3.3016700629474],
            [32.87959003870294, 3.300835961380237],
            [32.880716562900126, 3.300943053933192],
            [32.88230402704267, 3.300337635983194],
            [32.88407238044241, 3.300732806774554],
            [32.884911991721005, 3.300146447137048],
            [32.886020656512066, 3.300230355031643],
            [32.88787854050459, 3.298698595619222],
            [32.88861704010976, 3.297099683827663],
            [32.892335092510585, 3.294726336927188],
            [32.89444053063584, 3.294331601402389],
            [32.89571301489705, 3.295882498706443],
            [32.898904572794635, 3.294733850572822],
            [32.90068699381172, 3.295336726731474],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 530,
        District: "KITGUM",
        County: "KITGUM MUNICIPALITY",
        Subcounty: "PAGER DIVISION",
        Population: 15536,
        Key: "KITGUMPAGER DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11883812554028, 3.306309525504002],
            [33.119398968925005, 3.308168205658908],
            [33.11936356092974, 3.310825205767773],
            [33.11850633548506, 3.312441064965686],
            [33.11836368122129, 3.31452361572623],
            [33.116863397678756, 3.316139551392088],
            [33.11686349649344, 3.316983331908245],
            [33.11529180047908, 3.319101939151866],
            [33.115399087171795, 3.319963644323644],
            [33.114863229528396, 3.320322777155702],
            [33.11443492717399, 3.323877466535142],
            [33.114006275374905, 3.324344301378257],
            [33.114256588233886, 3.326426796553946],
            [33.113756758423285, 3.329245435094434],
            [33.11422137696969, 3.330825220951351],
            [33.11332831413503, 3.331722976084404],
            [33.10995844873834, 3.343563826901452],
            [33.1083322797835, 3.346996844666676],
            [33.10776350427483, 3.351737491758993],
            [33.10678790602849, 3.354843498523409],
            [33.09727249599157, 3.35484449573808],
            [33.094344982600354, 3.358032419112262],
            [33.09410120947665, 3.360239266159108],
            [33.09158063740074, 3.366859979114174],
            [33.086782252174636, 3.367350826768639],
            [33.08426099917569, 3.366860642720105],
            [33.08230894479194, 3.365062657312383],
            [33.080601030942844, 3.365062800794999],
            [33.07954371924333, 3.364654215995858],
            [33.080194137238294, 3.36203866839041],
            [33.08279611284861, 3.355499708617301],
            [33.08247066849256, 3.353946785978776],
            [33.0826331063538, 3.35133127515795],
            [33.08076222553575, 3.347244720835948],
            [33.07726431517681, 3.336783015175107],
            [33.07645095806069, 3.335638798071486],
            [33.07352309163155, 3.334249540395544],
            [33.07295370347187, 3.332860098707558],
            [33.07108325743843, 3.333759313760178],
            [33.06929404785275, 3.33343250453654],
            [33.067911513681025, 3.333677805844783],
            [33.06449589798526, 3.335230988374254],
            [33.0583148420435, 3.331471596694376],
            [33.05647646766231, 3.329323544508172],
            [33.05002161330679, 3.341602290902109],
            [33.044841162912284, 3.340309946005283],
            [33.03991091398561, 3.341315510635423],
            [33.02072559895423, 3.339879885312584],
            [33.01765308939135, 3.33891049484011],
            [33.01340156706918, 3.335768823237445],
            [33.011293651390375, 3.332716869629035],
            [33.00997174182223, 3.329449465859582],
            [33.00907856579983, 3.328228675920164],
            [33.00714934479398, 3.326828380715963],
            [33.00497002921976, 3.325894830641745],
            [33.00062931856294, 3.32117607549466],
            [32.999210241823754, 3.325619289008606],
            [32.996495056928055, 3.32655283575655],
            [32.99345829222861, 3.329892046835825],
            [32.99402990910853, 3.332656793260556],
            [32.99285091431558, 3.333338981328441],
            [32.99207251963032, 3.334705898456454],
            [32.98895109320693, 3.336378908809632],
            [32.9873083593182, 3.336460238039362],
            [32.98489728738385, 3.339402326850321],
            [32.98347984018859, 3.343207129254147],
            [32.98260323359163, 3.343950231345293],
            [32.98290393115828, 3.346376105629234],
            [32.980909637989846, 3.349327556685331],
            [32.97502079592518, 3.353289604529443],
            [32.97477980398562, 3.351652527358629],
            [32.974025598236004, 3.35076074596938],
            [32.97327142482575, 3.348620495837554],
            [32.97142475001134, 3.346048266613537],
            [32.97128623518443, 3.341519782821973],
            [32.968652294821325, 3.332253731760976],
            [32.96816726475503, 3.325426159880706],
            [32.96927648560323, 3.32263943668734],
            [32.9681673995023, 3.321246022815019],
            [32.96740494452343, 3.319086259353285],
            [32.965741327499316, 3.316996133875828],
            [32.963869900505586, 3.310934866619586],
            [32.96545591117399, 3.307166479703262],
            [32.959849712335384, 3.3019474147623],
            [32.95603734042301, 3.297767114904987],
            [32.95492842230706, 3.293656594279137],
            [32.95460441076385, 3.287424823199945],
            [32.95360254038872, 3.284411386105749],
            [32.948577264976365, 3.278316502877848],
            [32.94615095761477, 3.272422306642472],
            [32.94379180021898, 3.271676950956389],
            [32.94150011169092, 3.269847624925513],
            [32.940286919831735, 3.268018360131261],
            [32.93732111485322, 3.267476195334237],
            [32.93657960768847, 3.2682213756685],
            [32.93596330860633, 3.270127853719041],
            [32.935692608481986, 3.269855736062205],
            [32.93521055183929, 3.266211277530662],
            [32.93424605766817, 3.26534948638702],
            [32.9321386028251, 3.26150745204031],
            [32.93051352891658, 3.256211262176018],
            [32.92919187626661, 3.254344063809333],
            [32.92883474024562, 3.253087337624424],
            [32.92878969512403, 3.241030748661692],
            [32.92965902267224, 3.240133163064743],
            [32.931426495722995, 3.236854995920815],
            [32.93288768188939, 3.2359681414144],
            [32.93560259818885, 3.236542810028151],
            [32.95465640255756, 3.22248703664702],
            [32.961169495591264, 3.23123340548214],
            [32.962555680516296, 3.23402022100463],
            [32.963387434231116, 3.234577604177352],
            [32.971635854103106, 3.235135222924061],
            [32.97264712444936, 3.23568498377036],
            [32.97190971629726, 3.245317787217076],
            [32.97204256814464, 3.249480970340514],
            [32.973088284390464, 3.252320361143757],
            [32.97197205398808, 3.253411898764777],
            [32.97488777070297, 3.255539043718639],
            [32.97502883405035, 3.256437142077949],
            [32.978320779579306, 3.259367844345123],
            [32.98029596917487, 3.260455053250079],
            [32.987679507260985, 3.260124294376574],
            [32.99007798930664, 3.258989885035847],
            [32.99631608198074, 3.257580967777954],
            [32.99841324572393, 3.256137563191201],
            [33.00071077240299, 3.255175385292421],
            [33.00200312560167, 3.252481284440291],
            [33.001027212945004, 3.246757614413911],
            [33.003025888993676, 3.243968313730505],
            [33.004973447309425, 3.239794036818115],
            [33.00817092959633, 3.235057387767788],
            [33.017059761129325, 3.227210115213307],
            [33.01810893049912, 3.225481423320977],
            [33.02051835312663, 3.217994768340958],
            [33.02291994693644, 3.208599199747971],
            [33.02376380005983, 3.208011961339834],
            [33.02577609726316, 3.207816170881356],
            [33.027009426656086, 3.207163673872867],
            [33.02960597374715, 3.208272792793103],
            [33.03174813500121, 3.209381923066535],
            [33.03369558102758, 3.211078272975113],
            [33.037265962073754, 3.215449672196168],
            [33.03720115850747, 3.218516266430369],
            [33.03668192957832, 3.220669424695795],
            [33.037029866850766, 3.223468088460567],
            [33.043497942610635, 3.222365567479694],
            [33.05304038115785, 3.224387756857992],
            [33.05394920313752, 3.224909682180848],
            [33.05907772821371, 3.230455354701754],
            [33.06388175755474, 3.236327256868534],
            [33.069941957751425, 3.238766935212337],
            [33.071188199528216, 3.240436851715929],
            [33.0707732272743, 3.246281881271738],
            [33.07348116905388, 3.250054641129854],
            [33.07097368004175, 3.249608030041202],
            [33.06942305221576, 3.248866005468064],
            [33.06713423560166, 3.25079571055948],
            [33.066986727740435, 3.253318978806996],
            [33.06602681767224, 3.252947976922349],
            [33.06506709265697, 3.255397083341933],
            [33.063368845578644, 3.255619833365884],
            [33.06336890576578, 3.256584608160072],
            [33.063959636998305, 3.257104066643488],
            [33.064550297263885, 3.256436106199145],
            [33.065584083882754, 3.257400814740175],
            [33.064402757063334, 3.258588306701649],
            [33.06366432842504, 3.257772006016798],
            [33.06322134041234, 3.258365742985087],
            [33.063885941907316, 3.259330475685732],
            [33.064845849280594, 3.259627267969069],
            [33.06595338309267, 3.259107700473789],
            [33.06573191603579, 3.259849850240669],
            [33.06676574936707, 3.261408265569743],
            [33.06720873648143, 3.260814526809635],
            [33.0667656460608, 3.259849781182316],
            [33.06794701959264, 3.259404421073862],
            [33.06868541229828, 3.259627012363403],
            [33.0693533195935, 3.262498529662291],
            [33.06911285047342, 3.262981997730956],
            [33.06992820364609, 3.265644722640673],
            [33.069055189411955, 3.268235748654704],
            [33.06846451746824, 3.268755283627061],
            [33.06883380589841, 3.27016531614624],
            [33.066028291807605, 3.275508874759664],
            [33.06455153514236, 3.275805825484746],
            [33.06455159712612, 3.276770599715493],
            [33.06602851638641, 3.278922692932966],
            [33.06573322218624, 3.2798874883727],
            [33.063813503559444, 3.281446094973873],
            [33.063001294490235, 3.281817214572485],
            [33.062115213361984, 3.281668843698621],
            [33.05775894568106, 3.286121914536765],
            [33.05761132283548, 3.287086697641672],
            [33.05879282841964, 3.288274044109856],
            [33.05857134698971, 3.288941977052657],
            [33.06019585136637, 3.289387160801848],
            [33.060662321340594, 3.290238725262628],
            [33.05910195218364, 3.291813046150281],
            [33.056173851294226, 3.292437788854869],
            [33.05683684121157, 3.293908458593027],
            [33.057158837833605, 3.297565503527326],
            [33.05856988093918, 3.299680051090836],
            [33.0599315382637, 3.303685325335327],
            [33.06092167664122, 3.303884288051898],
            [33.06111975336472, 3.304755006070934],
            [33.062184163551635, 3.305128109718537],
            [33.064189288605746, 3.306993828532686],
            [33.06540236548057, 3.309581060322737],
            [33.066169762091796, 3.310252714187393],
            [33.07551087740404, 3.308191835924843],
            [33.0773672872612, 3.307142153481154],
            [33.07926246660935, 3.307297489739316],
            [33.079881216295576, 3.306286772283212],
            [33.084251452779164, 3.303371022222143],
            [33.0828198669997, 3.296762930114069],
            [33.08289710953772, 3.295441281848365],
            [33.08107898228471, 3.291282145929485],
            [33.081060864163746, 3.289972640706007],
            [33.08274495469151, 3.289695335775753],
            [33.08322235716275, 3.289283996041074],
            [33.08445008286491, 3.289695192282163],
            [33.08492747904793, 3.289215300243155],
            [33.086359798751026, 3.289352277496348],
            [33.08670086031829, 3.289763549043413],
            [33.08820123459066, 3.288186763102721],
            [33.08922436000373, 3.288735072556538],
            [33.09004277822818, 3.288255148666135],
            [33.09120230203734, 3.288666343537876],
            [33.0917478668757, 3.287843690851734],
            [33.092361705472285, 3.287775083741427],
            [33.09304380704728, 3.288323420326669],
            [33.09413504272519, 3.2878434675394],
            [33.09713603740834, 3.28756897718807],
            [33.09679497314609, 3.287157709220086],
            [33.09699954828238, 3.286746388169103],
            [33.09997215710086, 3.285838106457005],
            [33.10013693417511, 3.286334775476232],
            [33.100887215185246, 3.286608902051],
            [33.10081912109006, 3.287705711624634],
            [33.10136487098136, 3.288802456316775],
            [33.102797262549686, 3.289624912701881],
            [33.103206605960025, 3.290721671425742],
            [33.104161500733994, 3.290927222187131],
            [33.104638900510274, 3.290584420826324],
            [33.106344205651794, 3.292229442080715],
            [33.106685318423054, 3.293052007741188],
            [33.10757198076129, 3.292983363322482],
            [33.1085270111809, 3.294422811783508],
            [33.10941370496016, 3.294628362677844],
            [33.10961838879261, 3.29524529222659],
            [33.111528311291224, 3.296753181586773],
            [33.11268158372432, 3.299408039243233],
            [33.11453942459771, 3.30059269668377],
            [33.11403929924137, 3.300808184917259],
            [33.11471814532182, 3.301382596668764],
            [33.11446812711025, 3.301885317772919],
            [33.11564710034364, 3.302172417105101],
            [33.115933032301925, 3.303357273033734],
            [33.11839829061426, 3.305116350600453],
            [33.11883812554028, 3.306309525504002],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 531,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "KITGUM MATIDI",
        Population: 16521,
        Key: "KITGUMKITGUM MATIDI",
        Dist2: "Kitgum",
        "Sub Country": "Kitgum T/C",
        id2_original: "Kitgum  Kitgum T/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.95054517731984, 3.436004752432578],
            [32.94308762613914, 3.437007914897232],
            [32.94008184882541, 3.438180268065131],
            [32.93462730447139, 3.436177976110942],
            [32.93127773920351, 3.433698943650827],
            [32.93122706254338, 3.433199424573657],
            [32.93058342233724, 3.433108079220519],
            [32.930484964287174, 3.432585054541831],
            [32.92802793993277, 3.431957121463298],
            [32.927929630104686, 3.431457895594415],
            [32.92660729473512, 3.431382505143066],
            [32.9266045548735, 3.430930302196008],
            [32.92593913411498, 3.431172286134959],
            [32.92543318228572, 3.430223280369284],
            [32.9200032652452, 3.428339776534689],
            [32.9184478107712, 3.427135208684509],
            [32.916827850073254, 3.42707348104471],
            [32.91597578095828, 3.425995622087967],
            [32.91431266788903, 3.425122195826298],
            [32.914732828812014, 3.423832485622857],
            [32.91530326979723, 3.423638672992686],
            [32.9152725240583, 3.422496408235717],
            [32.91469861288117, 3.422119036313945],
            [32.91492811267334, 3.420689604047845],
            [32.914353611303035, 3.420217024472126],
            [32.91463420547194, 3.419358528644505],
            [32.9156785248375, 3.418757275865491],
            [32.915985193505826, 3.414352308632866],
            [32.91529322573405, 3.414142228466213],
            [32.91470056851355, 3.414597982280685],
            [32.91439746256365, 3.415670820767816],
            [32.91271604093059, 3.417251701851056],
            [32.91176209298092, 3.417043187988887],
            [32.90951802414607, 3.418139504282487],
            [32.905377300929366, 3.418711591740232],
            [32.90423108745776, 3.418218605495381],
            [32.902979669588284, 3.416083986873974],
            [32.90154535742189, 3.415211895764219],
            [32.90158893739128, 3.414545223729115],
            [32.90089567694381, 3.414120935827771],
            [32.90062864913234, 3.413289495814925],
            [32.8982017273231, 3.411721177577825],
            [32.8959458716934, 3.408902311583779],
            [32.895301527208105, 3.408691945067034],
            [32.89121942175863, 3.401230869758921],
            [32.88765981780091, 3.397455801378164],
            [32.885714056115724, 3.394706467146831],
            [32.87606042140769, 3.391419716688355],
            [32.873466701314825, 3.391402259810466],
            [32.87327277121464, 3.391986677207651],
            [32.867456942419665, 3.39344700086584],
            [32.85743905164371, 3.392426106466393],
            [32.84148088396489, 3.390740476484012],
            [32.841480926185724, 3.390477517414534],
            [32.83246035581799, 3.389202205535764],
            [32.83426855309382, 3.387990074854241],
            [32.835885600555315, 3.38424847163432],
            [32.84195877422131, 3.380408736718618],
            [32.84350313539989, 3.378296551948097],
            [32.84457489560243, 3.378043303145335],
            [32.844926973210065, 3.377263905744934],
            [32.84728267029537, 3.376618670460768],
            [32.84808880854985, 3.376018896707047],
            [32.85083618008222, 3.371492448583499],
            [32.85169210027482, 3.371249386105831],
            [32.85445943955927, 3.368067548339129],
            [32.855163160888246, 3.366278335523963],
            [32.85572086735597, 3.365953737819836],
            [32.85768863237572, 3.358528179245751],
            [32.85662417727308, 3.355773582828926],
            [32.85726269169218, 3.353044620204819],
            [32.85906244480436, 3.351344129588425],
            [32.86063077842462, 3.350763639876956],
            [32.861030314927014, 3.349880645228403],
            [32.860824949273265, 3.349393950750914],
            [32.86540943574877, 3.343464228931324],
            [32.8653670451488, 3.342357755524372],
            [32.86488630453799, 3.341622781609277],
            [32.86525944584239, 3.340311527044486],
            [32.86500538970365, 3.337671137812659],
            [32.865498606117114, 3.336525792681272],
            [32.86820548608801, 3.333213357313923],
            [32.869899513779465, 3.331763379476318],
            [32.87066071381185, 3.33161606801806],
            [32.87209156476946, 3.331940799070162],
            [32.87245523244088, 3.333009673492111],
            [32.87385395245738, 3.331954145199259],
            [32.874615720225066, 3.331902030546077],
            [32.87526258268812, 3.332540822273307],
            [32.877377886111795, 3.331838048577624],
            [32.882273353168976, 3.332082714454615],
            [32.887386638326376, 3.330933704777096],
            [32.8894177848793, 3.330100511238407],
            [32.89318551950521, 3.32698400265082],
            [32.89565453277541, 3.325707868878077],
            [32.895792961364066, 3.324969221771801],
            [32.897333372650344, 3.323722416271116],
            [32.89856564562447, 3.320751881426292],
            [32.90477718769202, 3.316145133144432],
            [32.90701817350881, 3.313115948110871],
            [32.90855577755982, 3.312873795785877],
            [32.911558011019736, 3.309214363420527],
            [32.91218640591716, 3.308770284462911],
            [32.912758506989015, 3.308862077346428],
            [32.91484471667563, 3.30730256752915],
            [32.917036425407495, 3.307432287024689],
            [32.91918472664652, 3.308252485951674],
            [32.92108459879373, 3.307384296445349],
            [32.92190030680097, 3.30641550361606],
            [32.923208323923234, 3.306122069476766],
            [32.923609242932855, 3.305477053771492],
            [32.925748257388484, 3.304774036621255],
            [32.926821903154796, 3.305100818555857],
            [32.9278861309837, 3.303880607493567],
            [32.92865834795476, 3.301638709972705],
            [32.93194659152641, 3.299988672187461],
            [32.932875746872554, 3.300054501883793],
            [32.933618019401926, 3.300716479177545],
            [32.93393774598119, 3.302380628169529],
            [32.93556475216594, 3.303632319543691],
            [32.9392827210234, 3.304109855850434],
            [32.940962012750916, 3.306122864956269],
            [32.94304911446458, 3.306669657863864],
            [32.94393603731427, 3.307616379733632],
            [32.943948961376286, 3.309734574763518],
            [32.94655614092705, 3.311599186308139],
            [32.94722548552674, 3.313963353434254],
            [32.94899540468998, 3.315214177311324],
            [32.94936119777537, 3.316616230596495],
            [32.952019372888195, 3.319027937208471],
            [32.952275608339846, 3.32003793227859],
            [32.95180457133071, 3.320897599985545],
            [32.952288120973414, 3.32208474726335],
            [32.953314147046555, 3.322411793420175],
            [32.95247067570716, 3.324677923941959],
            [32.952690233844045, 3.325533447069497],
            [32.95147333733263, 3.327099713323356],
            [32.95173995551232, 3.327859733175724],
            [32.95134106669524, 3.328837966221906],
            [32.95112286411611, 3.332099981376523],
            [32.950148027641134, 3.334307422210397],
            [32.95080249344476, 3.336183751453443],
            [32.94957274024499, 3.337595384933282],
            [32.94926511936247, 3.339870209850605],
            [32.948221937264066, 3.340638102608759],
            [32.9479727841301, 3.342734066210125],
            [32.94859704228566, 3.343563356088711],
            [32.94867850960047, 3.345205114546314],
            [32.948241009395836, 3.347659231679452],
            [32.947431472814635, 3.347687898224856],
            [32.947253736644086, 3.349783439613861],
            [32.94846916081676, 3.349918946716607],
            [32.94876424481118, 3.35144043019803],
            [32.94964872603993, 3.351982533804871],
            [32.951767223872785, 3.351803211283588],
            [32.95600925549399, 3.354217298610916],
            [32.957272168205826, 3.354328711411526],
            [32.956182060811905, 3.355215903437497],
            [32.95522976396574, 3.355269231982509],
            [32.95483336527864, 3.356652060485588],
            [32.953574520138396, 3.35720703707826],
            [32.95263152265205, 3.358783562959426],
            [32.95184316295532, 3.358383681397961],
            [32.951559273765966, 3.358694805824905],
            [32.95123677768064, 3.360481796011768],
            [32.95219228959722, 3.360952083937642],
            [32.952301321716526, 3.36515226041481],
            [32.9535050076034, 3.367263294497429],
            [32.952834439498304, 3.370551836049609],
            [32.953431864078, 3.370881466637057],
            [32.952737684654, 3.37225418175558],
            [32.951998390938094, 3.372092022462993],
            [32.9520088706842, 3.373805618893251],
            [32.9506548948537, 3.374384971250893],
            [32.95084876566505, 3.37493121588027],
            [32.95042620085033, 3.375933403543283],
            [32.950907286414235, 3.376715928101937],
            [32.95079316803379, 3.377525843409499],
            [32.95017527623867, 3.377743761108625],
            [32.949505246224426, 3.377224172316288],
            [32.94738664328869, 3.379343268904596],
            [32.94736675279165, 3.379985999540867],
            [32.94651492981508, 3.380895537663454],
            [32.94651652881628, 3.381157335351214],
            [32.94708750429906, 3.381058712402388],
            [32.9470199914139, 3.381701735139571],
            [32.94776247235241, 3.382387501957199],
            [32.94803126804837, 3.383504527724523],
            [32.94939342124291, 3.384257980757546],
            [32.94991046097774, 3.385075998161828],
            [32.950602132305484, 3.385238454798716],
            [32.95058064370558, 3.385619395875533],
            [32.9527133169536, 3.387748653966759],
            [32.95303747222725, 3.390126804775401],
            [32.95360933883879, 3.390170956825626],
            [32.954210555207304, 3.391119389654158],
            [32.95480710482793, 3.391306201690932],
            [32.954944870459926, 3.392412119994889],
            [32.95597576540186, 3.39352454557322],
            [32.955792684255385, 3.394739490457182],
            [32.956710053705, 3.396757048831501],
            [32.95655120551163, 3.398043243389874],
            [32.95716279113346, 3.398741689218489],
            [32.956598211655475, 3.399887521614399],
            [32.95709964855215, 3.400098712359276],
            [32.957254188425416, 3.402001851745483],
            [32.9567673123212, 3.40417064911684],
            [32.95705702439024, 3.404811521362952],
            [32.95598118763291, 3.406091337506243],
            [32.95624943086496, 3.407113161695057],
            [32.95493070582452, 3.409572574434361],
            [32.955125601613595, 3.410285415988958],
            [32.956059384181785, 3.411089034159699],
            [32.955790820251174, 3.411959374125809],
            [32.955985123152196, 3.412577034008428],
            [32.95667768471036, 3.412882284534609],
            [32.95661671784865, 3.414596303619935],
            [32.95886969168293, 3.418855008106632],
            [32.958707345449824, 3.419570000268917],
            [32.95967247832308, 3.423550832870818],
            [32.95972769506867, 3.424788140563172],
            [32.95823511637631, 3.426082347375316],
            [32.95765119347535, 3.427966136324953],
            [32.95648971223715, 3.428877540918409],
            [32.95650620800072, 3.429627169850489],
            [32.955775470737905, 3.43086920518501],
            [32.954493576624095, 3.431567133949193],
            [32.95425861776997, 3.432092151661794],
            [32.95370981270839, 3.431928844791368],
            [32.953451178754925, 3.432477817746192],
            [32.95142249089092, 3.433739543653804],
            [32.95054517731984, 3.436004752432578],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 532,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "LABONGO LAYAMO",
        Population: 11649,
        Key: "KITGUMLABONGO LAYAMO",
        Dist2: "Kitgum",
        "Sub Country": "Labongo Layamo",
        id2_original: "Kitgum  Labongo Layamo",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.09997215710086, 3.285838106457005],
            [33.09699954828238, 3.286746388169103],
            [33.09679497314609, 3.287157709220086],
            [33.09713603740834, 3.28756897718807],
            [33.09413504272519, 3.2878434675394],
            [33.09304380704728, 3.288323420326669],
            [33.092361705472285, 3.287775083741427],
            [33.0917478668757, 3.287843690851734],
            [33.09120230203734, 3.288666343537876],
            [33.09004277822818, 3.288255148666135],
            [33.08922436000373, 3.288735072556538],
            [33.08820123459066, 3.288186763102721],
            [33.08670086031829, 3.289763549043413],
            [33.086359798751026, 3.289352277496348],
            [33.08492747904793, 3.289215300243155],
            [33.08445008286491, 3.289695192282163],
            [33.08322235716275, 3.289283996041074],
            [33.08274495469151, 3.289695335775753],
            [33.081060864163746, 3.289972640706007],
            [33.08107898228471, 3.291282145929485],
            [33.08289710953772, 3.295441281848365],
            [33.0828198669997, 3.296762930114069],
            [33.084251452779164, 3.303371022222143],
            [33.079881216295576, 3.306286772283212],
            [33.07926246660935, 3.307297489739316],
            [33.0773672872612, 3.307142153481154],
            [33.07551087740404, 3.308191835924843],
            [33.066169762091796, 3.310252714187393],
            [33.06540236548057, 3.309581060322737],
            [33.064189288605746, 3.306993828532686],
            [33.062184163551635, 3.305128109718537],
            [33.06111975336472, 3.304755006070934],
            [33.06092167664122, 3.303884288051898],
            [33.0599315382637, 3.303685325335327],
            [33.05856988093918, 3.299680051090836],
            [33.057158837833605, 3.297565503527326],
            [33.05683684121157, 3.293908458593027],
            [33.056173851294226, 3.292437788854869],
            [33.05910195218364, 3.291813046150281],
            [33.060662321340594, 3.290238725262628],
            [33.06019585136637, 3.289387160801848],
            [33.05857134698971, 3.288941977052657],
            [33.05879282841964, 3.288274044109856],
            [33.05761132283548, 3.287086697641672],
            [33.05775894568106, 3.286121914536765],
            [33.062115213361984, 3.281668843698621],
            [33.063001294490235, 3.281817214572485],
            [33.063813503559444, 3.281446094973873],
            [33.06573322218624, 3.2798874883727],
            [33.06602851638641, 3.278922692932966],
            [33.06455159712612, 3.276770599715493],
            [33.06455153514236, 3.275805825484746],
            [33.066028291807605, 3.275508874759664],
            [33.06883380589841, 3.27016531614624],
            [33.06846451746824, 3.268755283627061],
            [33.069055189411955, 3.268235748654704],
            [33.06992820364609, 3.265644722640673],
            [33.06911285047342, 3.262981997730956],
            [33.0693533195935, 3.262498529662291],
            [33.06868541229828, 3.259627012363403],
            [33.06794701959264, 3.259404421073862],
            [33.0667656460608, 3.259849781182316],
            [33.06720873648143, 3.260814526809635],
            [33.06676574936707, 3.261408265569743],
            [33.06573191603579, 3.259849850240669],
            [33.06595338309267, 3.259107700473789],
            [33.064845849280594, 3.259627267969069],
            [33.063885941907316, 3.259330475685732],
            [33.06322134041234, 3.258365742985087],
            [33.06366432842504, 3.257772006016798],
            [33.064402757063334, 3.258588306701649],
            [33.065584083882754, 3.257400814740175],
            [33.064550297263885, 3.256436106199145],
            [33.063959636998305, 3.257104066643488],
            [33.06336890576578, 3.256584608160072],
            [33.063368845578644, 3.255619833365884],
            [33.06506709265697, 3.255397083341933],
            [33.06602681767224, 3.252947976922349],
            [33.066986727740435, 3.253318978806996],
            [33.06713423560166, 3.25079571055948],
            [33.06942305221576, 3.248866005468064],
            [33.07097368004175, 3.249608030041202],
            [33.07348116905388, 3.250054641129854],
            [33.0707732272743, 3.246281881271738],
            [33.071188199528216, 3.240436851715929],
            [33.069941957751425, 3.238766935212337],
            [33.06388175755474, 3.236327256868534],
            [33.05907772821371, 3.230455354701754],
            [33.05394920313752, 3.224909682180848],
            [33.05304038115785, 3.224387756857992],
            [33.043497942610635, 3.222365567479694],
            [33.037029866850766, 3.223468088460567],
            [33.03668192957832, 3.220669424695795],
            [33.03720115850747, 3.218516266430369],
            [33.037265962073754, 3.215449672196168],
            [33.03369558102758, 3.211078272975113],
            [33.03174813500121, 3.209381923066535],
            [33.02960597374715, 3.208272792793103],
            [33.027009426656086, 3.207163673872867],
            [33.02577609726316, 3.207816170881356],
            [33.02376380005983, 3.208011961339834],
            [33.02291994693644, 3.208599199747971],
            [33.02051835312663, 3.217994768340958],
            [33.01810893049912, 3.225481423320977],
            [33.017059761129325, 3.227210115213307],
            [33.00817092959633, 3.235057387767788],
            [33.004973447309425, 3.239794036818115],
            [33.003025888993676, 3.243968313730505],
            [33.001027212945004, 3.246757614413911],
            [33.00200312560167, 3.252481284440291],
            [33.00071077240299, 3.255175385292421],
            [32.99841324572393, 3.256137563191201],
            [32.99631608198074, 3.257580967777954],
            [32.99007798930664, 3.258989885035847],
            [32.987679507260985, 3.260124294376574],
            [32.98029596917487, 3.260455053250079],
            [32.978320779579306, 3.259367844345123],
            [32.97502883405035, 3.256437142077949],
            [32.97488777070297, 3.255539043718639],
            [32.97197205398808, 3.253411898764777],
            [32.973088284390464, 3.252320361143757],
            [32.97204256814464, 3.249480970340514],
            [32.97190971629726, 3.245317787217076],
            [32.97264712444936, 3.23568498377036],
            [32.971635854103106, 3.235135222924061],
            [32.963387434231116, 3.234577604177352],
            [32.962555680516296, 3.23402022100463],
            [32.961169495591264, 3.23123340548214],
            [32.95465640255756, 3.22248703664702],
            [32.98430559046238, 3.200327856190506],
            [32.99853480934141, 3.173386711150765],
            [33.00632212128315, 3.160535444768772],
            [33.01297255863892, 3.147334428996388],
            [33.01893562759721, 3.136880502397286],
            [33.02345518833552, 3.13362664433897],
            [33.024161182402146, 3.130400494481263],
            [33.02358346146989, 3.129045530571747],
            [33.02365040392486, 3.127811335703694],
            [33.02587901095704, 3.123896821814176],
            [33.02653698827512, 3.123566093423019],
            [33.03186321188405, 3.124252357880329],
            [33.03520919916216, 3.125350512114068],
            [33.05193934486018, 3.133106286483712],
            [33.056036613871655, 3.135989009615018],
            [33.06008434079521, 3.138242213920888],
            [33.059429511173896, 3.133323536796536],
            [33.06418462994266, 3.125935416819641],
            [33.06793114456493, 3.121734251836192],
            [33.06793086518886, 3.117388464263311],
            [33.0690834854451, 3.113911757950949],
            [33.074127013725715, 3.111593660627736],
            [33.079026524099966, 3.110724145093183],
            [33.08108415478412, 3.109814389762343],
            [33.082052526982324, 3.108116440949644],
            [33.08046664117971, 3.098410971212037],
            [33.081330995654525, 3.094934274169273],
            [33.08118629772349, 3.087111865291289],
            [33.08161835952739, 3.08392492071818],
            [33.083465469126395, 3.078323629055619],
            [33.098588532374386, 3.080424414244202],
            [33.10340753752953, 3.080367472481621],
            [33.108642522848335, 3.077173964844639],
            [33.11010546252619, 3.076879677647021],
            [33.11120258306752, 3.075850088930373],
            [33.11583569804426, 3.074539533946957],
            [33.119029020233114, 3.071878411858924],
            [33.12019934897853, 3.071510611123811],
            [33.124273128841935, 3.071922544565814],
            [33.12350555256765, 3.070942832848224],
            [33.12450777059078, 3.07194396012736],
            [33.12868467345556, 3.072759693203738],
            [33.13134189186262, 3.074035468320035],
            [33.13561464676485, 3.084561609649974],
            [33.13596665071062, 3.0868816759288],
            [33.13651212392081, 3.087623002145036],
            [33.136105097265556, 3.088962605041137],
            [33.13657951822835, 3.089560446851567],
            [33.136624453755495, 3.090852067216455],
            [33.13756220687722, 3.091653077562281],
            [33.13717954612577, 3.092705643956591],
            [33.13782001168566, 3.093518699696429],
            [33.13750928802217, 3.094284213517268],
            [33.1378625136767, 3.096006292428484],
            [33.13659780792756, 3.098087671871908],
            [33.13690508206035, 3.099020426555148],
            [33.13783117145643, 3.099713797787721],
            [33.13777061961642, 3.100252000042042],
            [33.13657916519046, 3.101400501865677],
            [33.136292077998704, 3.102237763619155],
            [33.13742549317245, 3.106231937686626],
            [33.13707701241923, 3.108014028464499],
            [33.13745505133855, 3.109233796908022],
            [33.137165666256315, 3.111195272806201],
            [33.13797237673765, 3.112127868807392],
            [33.138515085831706, 3.114232598284795],
            [33.1376678110254, 3.115703903533081],
            [33.13894574087385, 3.118813007078997],
            [33.138873621427905, 3.119195739639726],
            [33.138493828098824, 3.118837070488704],
            [33.1378984238302, 3.119243885277725],
            [33.13833375640004, 3.121528038285279],
            [33.13714242683991, 3.122604779934841],
            [33.13725725309279, 3.124613968173262],
            [33.135787948851124, 3.127879414466873],
            [33.13595199379844, 3.129075328114395],
            [33.135116282106445, 3.130702101334351],
            [33.135424337773586, 3.131252152022197],
            [33.135042641812724, 3.131826332806034],
            [33.13567013120837, 3.133177574270338],
            [33.13521572201515, 3.134421520967118],
            [33.13447854383175, 3.134373915105661],
            [33.133787619004025, 3.134972119543814],
            [33.13390136548193, 3.137507524111273],
            [33.134257819681594, 3.137650925187774],
            [33.13480605071974, 3.137052775203174],
            [33.13492213191907, 3.138440057265242],
            [33.134406289638505, 3.140652749299728],
            [33.13373904350335, 3.141298782624655],
            [33.13337990783255, 3.142470936486351],
            [33.13387715947828, 3.143547150709336],
            [33.13265933321053, 3.145939464620788],
            [33.1326437555252, 3.1477453748705],
            [33.1337081073216, 3.150639275820014],
            [33.134539109146516, 3.151332677528069],
            [33.13545031435666, 3.153521004220562],
            [33.13599641369259, 3.1539753010563],
            [33.13622903513036, 3.156534585613756],
            [33.13773352728, 3.1593685467479],
            [33.13861921225123, 3.162417972022658],
            [33.139760241545346, 3.162704641721038],
            [33.139521248357255, 3.163278784544145],
            [33.14035333444873, 3.163445948459764],
            [33.14241906524182, 3.165143547307637],
            [33.14215526687378, 3.166220000866018],
            [33.14275789090234, 3.168121394843448],
            [33.14211422284846, 3.168863091463303],
            [33.14182512073552, 3.170681058876869],
            [33.141539566967936, 3.170752901088873],
            [33.1420605871378, 3.171853026212684],
            [33.141417441903364, 3.1723316103954],
            [33.14203354335615, 3.173455624673069],
            [33.140997177674116, 3.174329011144024],
            [33.14173253227751, 3.17528554106678],
            [33.14175325371616, 3.176792457270976],
            [33.140822764371826, 3.178227909888118],
            [33.14124908504271, 3.179112776650044],
            [33.14066352541128, 3.180512251906736],
            [33.14075687114911, 3.181397234206654],
            [33.14268255997928, 3.181803235249702],
            [33.14491948181769, 3.181204528599256],
            [33.147059418843135, 3.181514783264094],
            [33.151163466541746, 3.180879565961994],
            [33.15677650874618, 3.180877686890955],
            [33.160214396372815, 3.180338341338994],
            [33.17387507420346, 3.181444871995939],
            [33.16678130118695, 3.191833635283851],
            [33.16552084716404, 3.199442922478003],
            [33.16561843205166, 3.20275968488208],
            [33.167269616392254, 3.210661151128287],
            [33.167309679457304, 3.213053776725354],
            [33.165822687387696, 3.214165247205462],
            [33.16525334324547, 3.213423955495666],
            [33.16434888797639, 3.21373521212023],
            [33.1650369265171, 3.214596067795415],
            [33.164417847149174, 3.214931141282048],
            [33.16441679881523, 3.215457365813294],
            [33.16320313354387, 3.215768745589773],
            [33.16194422552156, 3.214932002307497],
            [33.161277857938764, 3.215123590315771],
            [33.16118093421117, 3.216008632433681],
            [33.160324061804374, 3.21631986764088],
            [33.16105759013277, 3.218209236554555],
            [33.160391416586044, 3.218305142816008],
            [33.160247599902334, 3.218855337000035],
            [33.15950964108295, 3.21916653635889],
            [33.15928193612472, 3.220039674039754],
            [33.158164470538836, 3.219824772113264],
            [33.158000041112615, 3.218796315725371],
            [33.15619133089874, 3.219323144564076],
            [33.15592598024192, 3.22116500829651],
            [33.15483053146533, 3.221835133798604],
            [33.15485232908569, 3.222815808648026],
            [33.15373337049979, 3.223342398626742],
            [33.1503786093763, 3.223869756073844],
            [33.14820302450547, 3.223499722807798],
            [33.14784591902721, 3.22366727065709],
            [33.14796314198525, 3.224504411261908],
            [33.14729692082784, 3.224624220921884],
            [33.14698563661557, 3.225652859767763],
            [33.145176408972134, 3.226418861800436],
            [33.144745325433576, 3.227878078814578],
            [33.14552892585591, 3.228523652026863],
            [33.144333202635714, 3.229547655392746],
            [33.144582632450785, 3.230714574979464],
            [33.14531732409749, 3.232029882197819],
            [33.146077809070924, 3.232340576164618],
            [33.14627677602487, 3.233931153178311],
            [33.14686961380675, 3.234815972643568],
            [33.14693768544404, 3.236442447981936],
            [33.14909679341594, 3.23909676564011],
            [33.148928612625085, 3.246865650878367],
            [33.14771304562027, 3.249335725665807],
            [33.14588288902732, 3.248679069626096],
            [33.14496814355666, 3.250649962930008],
            [33.14549120469883, 3.251963742872753],
            [33.14483766954984, 3.252357991948798],
            [33.144314946174205, 3.25340914358793],
            [33.14313857985176, 3.254066236012813],
            [33.142354074825946, 3.252752500962414],
            [33.14143906255564, 3.252884014994015],
            [33.14052408801459, 3.253278296894321],
            [33.14078561544156, 3.253935184021967],
            [33.138694485682144, 3.25669456286188],
            [33.137779540785495, 3.257351612784813],
            [33.13594944707461, 3.257220476916173],
            [33.13425019388316, 3.25787762963518],
            [33.13313260522808, 3.257532170316932],
            [33.134056007763135, 3.260123393030759],
            [33.135362504037644, 3.261207869281892],
            [33.13877053256253, 3.262292053780911],
            [33.139792999510505, 3.263034041556726],
            [33.139452661087006, 3.266288043024615],
            [33.13854410051705, 3.267829515752672],
            [33.13627237524956, 3.269371174452026],
            [33.13030887689659, 3.271997971604785],
            [33.128264134341826, 3.272055323423086],
            [33.12320891269116, 3.27085713269309],
            [33.117926993093704, 3.273826291930272],
            [33.11491679157721, 3.274968383945515],
            [33.11304245044869, 3.275139860413377],
            [33.11230419338864, 3.276281681876227],
            [33.103614416844515, 3.280678320446758],
            [33.10156984946122, 3.282676575456609],
            [33.09997215710086, 3.285838106457005],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 533,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "LAGORO",
        Population: 15662,
        Key: "KITGUMLAGORO",
        Dist2: "Kitgum",
        "Sub Country": "Lagoro",
        id2_original: "Kitgum  Lagoro",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.41438176543259, 3.304758854331625],
            [33.41311500164309, 3.305954078002834],
            [33.412282219357266, 3.307869343595307],
            [33.410615807674304, 3.309665275027702],
            [33.40990352989225, 3.315051279478495],
            [33.40645266430474, 3.321276197662062],
            [33.40359747427704, 3.328218957297131],
            [33.400384556238606, 3.334084715804206],
            [33.39300139274995, 3.334446754485382],
            [33.38764319181184, 3.336124447435476],
            [33.384071681583315, 3.338878559237052],
            [33.383358930389115, 3.343426781828106],
            [33.38502815739221, 3.348572481257617],
            [33.39003144294473, 3.352639701784094],
            [33.39283252025633, 3.358921909788468],
            [33.39249211895077, 3.371232487546744],
            [33.39320720306976, 3.374102120341043],
            [33.3955541811069, 3.377073583790601],
            [33.39698221494778, 3.377482986594021],
            [33.40171676858473, 3.380674623726935],
            [33.40159690098646, 3.381184567902419],
            [33.40378286229717, 3.387528593501143],
            [33.41014916163029, 3.402795842349017],
            [33.41994131655512, 3.419341661415575],
            [33.41526738213183, 3.427193395217662],
            [33.413549434999325, 3.428908677279523],
            [33.41140691621579, 3.429620788887555],
            [33.40891557711582, 3.433286222737151],
            [33.40520829461696, 3.435150945277172],
            [33.40141640339477, 3.436253497101917],
            [33.392062435885755, 3.437527724279961],
            [33.39071438444454, 3.438375160060979],
            [33.38607926352972, 3.438377055681014],
            [33.383956018100605, 3.4380014152768],
            [33.382119116058185, 3.440326486354855],
            [33.380266506973015, 3.443968824201479],
            [33.37849856410335, 3.448627382834184],
            [33.377657679013666, 3.453370260749371],
            [33.37698407011137, 3.454894916573225],
            [33.37403515615514, 3.456843917953317],
            [33.3661135667397, 3.457947968993022],
            [33.362321878536754, 3.459981952123855],
            [33.35911970075585, 3.460914748574099],
            [33.35178755079553, 3.460832821887936],
            [33.348837504962056, 3.459902343269414],
            [33.343564713146215, 3.456298035563557],
            [33.3348776252597, 3.45345102597767],
            [33.32716585085362, 3.451494261298606],
            [33.323886481738654, 3.451673523130302],
            [33.32113846162269, 3.45051659345182],
            [33.317681589000856, 3.449983359681751],
            [33.310798428697645, 3.450966494277163],
            [33.292795668482704, 3.447513898543902],
            [33.28914251217466, 3.445776411994875],
            [33.28246084937958, 3.44402000384674],
            [33.2779167349896, 3.44457132724549],
            [33.27226477866538, 3.444133285743936],
            [33.27083472541176, 3.443701457228007],
            [33.26854217450102, 3.442258204220632],
            [33.26703640674367, 3.440539694724856],
            [33.265394019604656, 3.439611930266137],
            [33.26494898253482, 3.43854631462652],
            [33.26303268648927, 3.436793532854309],
            [33.26214279919915, 3.435315493527558],
            [33.25848173591998, 3.43346004411292],
            [33.25725017530984, 3.433563514646794],
            [33.256599819298636, 3.432257298540776],
            [33.255470964871584, 3.432635767615442],
            [33.25461526746119, 3.431020195991759],
            [33.25362312853553, 3.430917325078208],
            [33.25280189858427, 3.430264347703725],
            [33.25180954496123, 3.429336384052952],
            [33.25156983671419, 3.428442600200088],
            [33.24432249220832, 3.426727262603179],
            [33.24338877970874, 3.427065320994406],
            [33.24159536061762, 3.424963790083662],
            [33.24103506520526, 3.424888861823217],
            [33.240474497603344, 3.423725402080349],
            [33.23610352180628, 3.420385833791391],
            [33.23289112389236, 3.419748519339529],
            [33.233040359213895, 3.419035307292263],
            [33.22908108759973, 3.419036265882027],
            [33.228408624947726, 3.418473393280559],
            [33.22829638314792, 3.41768517434374],
            [33.22575629247748, 3.416897531349238],
            [33.22512142971002, 3.417385642817822],
            [33.22415021973383, 3.417085587514971],
            [33.223851293644955, 3.416597694693101],
            [33.222357560617496, 3.418024394484267],
            [33.22056472632962, 3.418212488091247],
            [33.21877214716332, 3.419526644056804],
            [33.21862285973952, 3.420052175915044],
            [33.21761439752683, 3.420202548797914],
            [33.21724108374591, 3.421103487157152],
            [33.21660610419743, 3.421103631528177],
            [33.216382188333085, 3.421967000328063],
            [33.215000079962785, 3.421554422310501],
            [33.21387979366691, 3.422755812058446],
            [33.213767896820194, 3.423469012369872],
            [33.21264738414885, 3.423656940810154],
            [33.21216203248567, 3.424670509115284],
            [33.20909959393541, 3.42658550005052],
            [33.207792120293895, 3.425872609632095],
            [33.20637284412876, 3.426323345263777],
            [33.20420632595406, 3.425835849007154],
            [33.20260044544989, 3.427037331124646],
            [33.19912688033343, 3.427863846149651],
            [33.19808125481745, 3.428990131458917],
            [33.19444149688187, 3.429971937268529],
            [33.19305310838946, 3.429571121213696],
            [33.19223109241231, 3.428422313088542],
            [33.19065898496955, 3.428458527519231],
            [33.19033737821636, 3.428279072116078],
            [33.190515921972334, 3.427740446556015],
            [33.18926533684113, 3.427525268846391],
            [33.1880139989217, 3.423450261220937],
            [33.18812076459153, 3.42129591308331],
            [33.18733435154404, 3.419357176396703],
            [33.185976318023386, 3.417777610680426],
            [33.18558302660885, 3.416377377178969],
            [33.18504707374403, 3.416305665674766],
            [33.18461802219468, 3.41474386972642],
            [33.183188552846, 3.413200202055986],
            [33.184402914311676, 3.410937936193098],
            [33.18322364463425, 3.409825094005675],
            [33.183651982921276, 3.407598877595473],
            [33.18297289519405, 3.406396179389528],
            [33.183508633361484, 3.405318915955322],
            [33.18307939675919, 3.402733803772086],
            [33.18250761728421, 3.40215943538459],
            [33.18272182236036, 3.401297662013634],
            [33.18168558064582, 3.400651564854761],
            [33.18157826520704, 3.400005280742245],
            [33.181899824349514, 3.400041127686804],
            [33.1812919442782, 3.397384241806043],
            [33.180255884023346, 3.397743495913164],
            [33.179576890619245, 3.396989605915051],
            [33.180480488895526, 3.395084376208169],
            [33.17997976166796, 3.392319752962579],
            [33.17804999089314, 3.389914445186762],
            [33.17787105816666, 3.388334635701033],
            [33.177192183340146, 3.388083426029457],
            [33.177227617386514, 3.386503585755551],
            [33.17661999782666, 3.385157237244634],
            [33.176977070965556, 3.384080001233555],
            [33.175475978939275, 3.381243751708838],
            [33.17515437128778, 3.380956575970161],
            [33.17486864953525, 3.381531115680245],
            [33.174439656376364, 3.380059064253762],
            [33.174725272127716, 3.378945944363526],
            [33.17304593638275, 3.378228135876647],
            [33.1730813389881, 3.376432857268798],
            [33.17215225640549, 3.375481531478464],
            [33.17200910896665, 3.374188966873808],
            [33.17125882256663, 3.374153190712581],
            [33.170972880726836, 3.373471030221639],
            [33.171615870552706, 3.372860520317034],
            [33.171222765987764, 3.372286110887327],
            [33.171294072458366, 3.371460272816551],
            [33.1704722783651, 3.371137275765018],
            [33.170114713847724, 3.369413872123371],
            [33.16900710367883, 3.369162730191844],
            [33.168828233834404, 3.367834263319181],
            [33.16929258019129, 3.367116071779929],
            [33.1691138540773, 3.366613429754104],
            [33.1680062555865, 3.366416137850035],
            [33.16825632590033, 3.366236564195593],
            [33.16779129772215, 3.362933344116423],
            [33.16704085591357, 3.361928118264752],
            [33.16694435259755, 3.359233906602857],
            [33.16932099659867, 3.357955024022787],
            [33.178823840103064, 3.354650021814777],
            [33.18096746650936, 3.354613727496548],
            [33.18428993050344, 3.353823177867813],
            [33.18759426469847, 3.353520163237731],
            [33.19239557214419, 3.355700322590105],
            [33.19664840151511, 3.355790409017182],
            [33.199091376218476, 3.355153353346993],
            [33.2075948790036, 3.345148526537427],
            [33.20868021005516, 3.342874874297526],
            [33.209493774682116, 3.339146289702155],
            [33.211303235887534, 3.338145596013131],
            [33.21428911641601, 3.33778119833935],
            [33.218451560896305, 3.338689645833505],
            [33.22315670908076, 3.338688583136641],
            [33.23397357135186, 3.335853639249529],
            [33.23727085826346, 3.333319997961688],
            [33.23908038684256, 3.33277393814011],
            [33.2423383742571, 3.335228426234509],
            [33.24597626639184, 3.339039613814907],
            [33.24740704817918, 3.341683657364353],
            [33.24912662934717, 3.343229142671195],
            [33.25455577653148, 3.343682425963997],
            [33.26242823259245, 3.345044388306944],
            [33.26423761923774, 3.343952662531544],
            [33.27084141336905, 3.338403731912779],
            [33.2768105594302, 3.328580929978998],
            [33.279341682219155, 3.320123128097541],
            [33.283501887199414, 3.313301710527415],
            [33.29607518402306, 3.301385359784935],
            [33.29548908180918, 3.301593842752117],
            [33.29458911182831, 3.299616774633446],
            [33.29605041118247, 3.2989383945443],
            [33.295684601927405, 3.29746962634145],
            [33.295178682437516, 3.297413281327395],
            [33.295263241753496, 3.298232439243326],
            [33.294841739645776, 3.29851504024967],
            [33.29295707597635, 3.296854911544863],
            [33.29294010949557, 3.296283251339086],
            [33.29405971397015, 3.295788728010848],
            [33.294023427422566, 3.295443242318336],
            [33.2931006016059, 3.295098018380294],
            [33.29288360726083, 3.295498131889274],
            [33.29080245778424, 3.293789443703994],
            [33.28998835865968, 3.29402607530817],
            [33.28998810623309, 3.293153240335907],
            [33.28940887972439, 3.29224420663766],
            [33.287056624983265, 3.29148115955668],
            [33.2866040240987, 3.290481166506058],
            [33.2847945054011, 3.289554300390793],
            [33.2848304883181, 3.288845112517078],
            [33.28566280258168, 3.289044897012708],
            [33.285409077022926, 3.28753569287924],
            [33.28616895653188, 3.287517289785037],
            [33.28653059490909, 3.286771638632849],
            [33.28786957426425, 3.287244037876142],
            [33.28839393257369, 3.286116474316146],
            [33.28824895796156, 3.285298232871864],
            [33.28955133635877, 3.284334099143757],
            [33.28848378386504, 3.283988912612859],
            [33.28917100314223, 3.282970404840078],
            [33.288881335988975, 3.282315863127526],
            [33.286729951731886, 3.280615447259274],
            [33.28619434471845, 3.281513231697653],
            [33.28457689840498, 3.280585050553716],
            [33.282168035427894, 3.280047754348562],
            [33.28234627016343, 3.2793752263039],
            [33.27993688706179, 3.276954986876025],
            [33.28047205479904, 3.276596181869595],
            [33.28047170535441, 3.275340890680687],
            [33.27989165868386, 3.274713408170811],
            [33.280426500332666, 3.273188974513325],
            [33.28020313693221, 3.271978577204349],
            [33.28047043244162, 3.270768043008915],
            [33.28105016470181, 3.270274729456861],
            [33.279756013075946, 3.268123163844729],
            [33.27859597992203, 3.267047523702138],
            [33.27672250027786, 3.266823884735296],
            [33.27681148918653, 3.266016886653206],
            [33.27743596114113, 3.266016713559964],
            [33.2772573437233, 3.265299452537417],
            [33.27561733711979, 3.263779569581022],
            [33.28205697311604, 3.256937431956426],
            [33.28471732215189, 3.251987388817109],
            [33.285514842867855, 3.248442399514302],
            [33.28657888744042, 3.246168099370686],
            [33.287710019995046, 3.245833364450321],
            [33.28917747909711, 3.243050107061548],
            [33.29094716200345, 3.241907820973164],
            [33.291951068859326, 3.241987189263548],
            [33.29361522756756, 3.241375987615386],
            [33.295199791050045, 3.239596478448691],
            [33.29596599739355, 3.239888336523842],
            [33.29718115296993, 3.23964900241494],
            [33.29728653703086, 3.238666513295489],
            [33.2990035148812, 3.238028735951744],
            [33.29889764932326, 3.237364943255913],
            [33.299478810803066, 3.237258559626723],
            [33.29945225301001, 3.236780614790077],
            [33.300139249504994, 3.237231810126691],
            [33.30019178837269, 3.236222783490601],
            [33.30267475876747, 3.235186478928161],
            [33.30307618712185, 3.234271972014763],
            [33.303229882578776, 3.234505198715483],
            [33.321380499201275, 3.249200938488539],
            [33.32827836043408, 3.255241927358338],
            [33.35568952606425, 3.264919878424826],
            [33.36647579261507, 3.270131489559281],
            [33.37352185071695, 3.27450737425905],
            [33.37706034246886, 3.277740817766605],
            [33.38173617413401, 3.276799056657835],
            [33.382962083442706, 3.277651370853272],
            [33.38739311520976, 3.277839164968154],
            [33.39022193788725, 3.279259366573471],
            [33.39295675187022, 3.281342871994396],
            [33.39456052223182, 3.284090095007838],
            [33.39578738375467, 3.287311231607635],
            [33.39597941930792, 3.296123243568525],
            [33.39648162246748, 3.298956382196666],
            [33.40285341320195, 3.303162352192153],
            [33.41438176543259, 3.304758854331625],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 534,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "NAMOKORA",
        Population: 14167,
        Key: "KITGUMNAMOKORA",
        Dist2: "Kitgum",
        "Sub Country": "Namokora",
        id2_original: "Kitgum  Namokora",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.303229882578776, 3.234505198715483],
            [33.30307618712185, 3.234271972014763],
            [33.30267475876747, 3.235186478928161],
            [33.30019178837269, 3.236222783490601],
            [33.300139249504994, 3.237231810126691],
            [33.29945225301001, 3.236780614790077],
            [33.299478810803066, 3.237258559626723],
            [33.29889764932326, 3.237364943255913],
            [33.2990035148812, 3.238028735951744],
            [33.29728653703086, 3.238666513295489],
            [33.29718115296993, 3.23964900241494],
            [33.29596599739355, 3.239888336523842],
            [33.295199791050045, 3.239596478448691],
            [33.29361522756756, 3.241375987615386],
            [33.291951068859326, 3.241987189263548],
            [33.29094716200345, 3.241907820973164],
            [33.28917747909711, 3.243050107061548],
            [33.287710019995046, 3.245833364450321],
            [33.28657888744042, 3.246168099370686],
            [33.285514842867855, 3.248442399514302],
            [33.28471732215189, 3.251987388817109],
            [33.28205697311604, 3.256937431956426],
            [33.27561733711979, 3.263779569581022],
            [33.2772573437233, 3.265299452537417],
            [33.27743596114113, 3.266016713559964],
            [33.27681148918653, 3.266016886653206],
            [33.27672250027786, 3.266823884735296],
            [33.27859597992203, 3.267047523702138],
            [33.279756013075946, 3.268123163844729],
            [33.28105016470181, 3.270274729456861],
            [33.28047043244162, 3.270768043008915],
            [33.28020313693221, 3.271978577204349],
            [33.280426500332666, 3.273188974513325],
            [33.27989165868386, 3.274713408170811],
            [33.28047170535441, 3.275340890680687],
            [33.28047205479904, 3.276596181869595],
            [33.27993688706179, 3.276954986876025],
            [33.28234627016343, 3.2793752263039],
            [33.282168035427894, 3.280047754348562],
            [33.28457689840498, 3.280585050553716],
            [33.28619434471845, 3.281513231697653],
            [33.286729951731886, 3.280615447259274],
            [33.288881335988975, 3.282315863127526],
            [33.28917100314223, 3.282970404840078],
            [33.28848378386504, 3.283988912612859],
            [33.28955133635877, 3.284334099143757],
            [33.28824895796156, 3.285298232871864],
            [33.28839393257369, 3.286116474316146],
            [33.28786957426425, 3.287244037876142],
            [33.28653059490909, 3.286771638632849],
            [33.28616895653188, 3.287517289785037],
            [33.285409077022926, 3.28753569287924],
            [33.28566280258168, 3.289044897012708],
            [33.2848304883181, 3.288845112517078],
            [33.2847945054011, 3.289554300390793],
            [33.2866040240987, 3.290481166506058],
            [33.287056624983265, 3.29148115955668],
            [33.28940887972439, 3.29224420663766],
            [33.28998810623309, 3.293153240335907],
            [33.28998835865968, 3.29402607530817],
            [33.29080245778424, 3.293789443703994],
            [33.29288360726083, 3.295498131889274],
            [33.2931006016059, 3.295098018380294],
            [33.294023427422566, 3.295443242318336],
            [33.29405971397015, 3.295788728010848],
            [33.29294010949557, 3.296283251339086],
            [33.29295707597635, 3.296854911544863],
            [33.294841739645776, 3.29851504024967],
            [33.295263241753496, 3.298232439243326],
            [33.295178682437516, 3.297413281327395],
            [33.295684601927405, 3.29746962634145],
            [33.29605041118247, 3.2989383945443],
            [33.29458911182831, 3.299616774633446],
            [33.29548908180918, 3.301593842752117],
            [33.29607518402306, 3.301385359784935],
            [33.283501887199414, 3.313301710527415],
            [33.279341682219155, 3.320123128097541],
            [33.2768105594302, 3.328580929978998],
            [33.27084141336905, 3.338403731912779],
            [33.26423761923774, 3.343952662531544],
            [33.26242823259245, 3.345044388306944],
            [33.25455577653148, 3.343682425963997],
            [33.24912662934717, 3.343229142671195],
            [33.24740704817918, 3.341683657364353],
            [33.24597626639184, 3.339039613814907],
            [33.2423383742571, 3.335228426234509],
            [33.23908038684256, 3.33277393814011],
            [33.23727085826346, 3.333319997961688],
            [33.23397357135186, 3.335853639249529],
            [33.22315670908076, 3.338688583136641],
            [33.218451560896305, 3.338689645833505],
            [33.21428911641601, 3.33778119833935],
            [33.211303235887534, 3.338145596013131],
            [33.209493774682116, 3.339146289702155],
            [33.20868021005516, 3.342874874297526],
            [33.2075948790036, 3.345148526537427],
            [33.199091376218476, 3.355153353346993],
            [33.19664840151511, 3.355790409017182],
            [33.19239557214419, 3.355700322590105],
            [33.18759426469847, 3.353520163237731],
            [33.18428993050344, 3.353823177867813],
            [33.18096746650936, 3.354613727496548],
            [33.178823840103064, 3.354650021814777],
            [33.16932099659867, 3.357955024022787],
            [33.16694435259755, 3.359233906602857],
            [33.165861334707856, 3.358840457772414],
            [33.165682527745496, 3.357906948920625],
            [33.16443179708724, 3.356201648393447],
            [33.16371718188879, 3.355842708930006],
            [33.162073317919486, 3.353329607967319],
            [33.161037196579194, 3.353078426023919],
            [33.160250943431826, 3.35149872800068],
            [33.15882173279795, 3.350709043936714],
            [33.158321376574584, 3.349524238644038],
            [33.15860705520796, 3.348734265120268],
            [33.15742793554918, 3.347944538471028],
            [33.157249092654205, 3.346598115136625],
            [33.15667739133267, 3.346095523534869],
            [33.155640885513456, 3.343474590399343],
            [33.153461246545724, 3.341428323893053],
            [33.1526035378074, 3.339704997892093],
            [33.15013798664431, 3.33703042759281],
            [33.15006642774709, 3.336312317465519],
            [33.14928038211055, 3.335881568975875],
            [33.14842296622301, 3.336025331185342],
            [33.14845856645772, 3.335163592528312],
            [33.14792252196473, 3.334230122100976],
            [33.14431371907554, 3.331142793130142],
            [33.142884215590875, 3.328055133421929],
            [33.142848350353155, 3.327103634137983],
            [33.14191936658523, 3.326421574477247],
            [33.141597687966836, 3.325452161777166],
            [33.13902492736616, 3.321933794223599],
            [33.13823889430604, 3.321538943083624],
            [33.136488042782986, 3.31949257626834],
            [33.13616635697805, 3.318343631737207],
            [33.135594701470595, 3.318056474314886],
            [33.13480876273358, 3.318325864154918],
            [33.13430827984775, 3.315992082452497],
            [33.13337939848776, 3.315884484827149],
            [33.13320064542433, 3.314986874915618],
            [33.13216450791436, 3.314268893120654],
            [33.13230725739955, 3.313048086204369],
            [33.13105672616725, 3.312042895406644],
            [33.129484728318964, 3.311540437734594],
            [33.129020235536686, 3.311109630898071],
            [33.12927021062912, 3.310247863307235],
            [33.12576903938566, 3.309853355466209],
            [33.12484001339694, 3.308560871209866],
            [33.123018080880385, 3.309135580700596],
            [33.122196225701686, 3.30777128185725],
            [33.12008837110831, 3.307232959117513],
            [33.11962378400294, 3.306048126650009],
            [33.11883812554028, 3.306309525504002],
            [33.11839829061426, 3.305116350600453],
            [33.115933032301925, 3.303357273033734],
            [33.11564710034364, 3.302172417105101],
            [33.11446812711025, 3.301885317772919],
            [33.11471814532182, 3.301382596668764],
            [33.11403929924137, 3.300808184917259],
            [33.11453942459771, 3.30059269668377],
            [33.11268158372432, 3.299408039243233],
            [33.111528311291224, 3.296753181586773],
            [33.10961838879261, 3.29524529222659],
            [33.10941370496016, 3.294628362677844],
            [33.1085270111809, 3.294422811783508],
            [33.10757198076129, 3.292983363322482],
            [33.106685318423054, 3.293052007741188],
            [33.106344205651794, 3.292229442080715],
            [33.104638900510274, 3.290584420826324],
            [33.104161500733994, 3.290927222187131],
            [33.103206605960025, 3.290721671425742],
            [33.102797262549686, 3.289624912701881],
            [33.10136487098136, 3.288802456316775],
            [33.10081912109006, 3.287705711624634],
            [33.100887215185246, 3.286608902051],
            [33.10013693417511, 3.286334775476232],
            [33.09997215710086, 3.285838106457005],
            [33.10156984946122, 3.282676575456609],
            [33.103614416844515, 3.280678320446758],
            [33.11230419338864, 3.276281681876227],
            [33.11304245044869, 3.275139860413377],
            [33.11491679157721, 3.274968383945515],
            [33.117926993093704, 3.273826291930272],
            [33.12320891269116, 3.27085713269309],
            [33.128264134341826, 3.272055323423086],
            [33.13030887689659, 3.271997971604785],
            [33.13627237524956, 3.269371174452026],
            [33.13854410051705, 3.267829515752672],
            [33.139452661087006, 3.266288043024615],
            [33.139792999510505, 3.263034041556726],
            [33.13877053256253, 3.262292053780911],
            [33.135362504037644, 3.261207869281892],
            [33.134056007763135, 3.260123393030759],
            [33.13313260522808, 3.257532170316932],
            [33.13425019388316, 3.25787762963518],
            [33.13594944707461, 3.257220476916173],
            [33.137779540785495, 3.257351612784813],
            [33.138694485682144, 3.25669456286188],
            [33.14078561544156, 3.253935184021967],
            [33.14052408801459, 3.253278296894321],
            [33.14143906255564, 3.252884014994015],
            [33.142354074825946, 3.252752500962414],
            [33.14313857985176, 3.254066236012813],
            [33.144314946174205, 3.25340914358793],
            [33.14483766954984, 3.252357991948798],
            [33.14549120469883, 3.251963742872753],
            [33.14496814355666, 3.250649962930008],
            [33.14588288902732, 3.248679069626096],
            [33.14771304562027, 3.249335725665807],
            [33.148928612625085, 3.246865650878367],
            [33.14909679341594, 3.23909676564011],
            [33.14693768544404, 3.236442447981936],
            [33.14686961380675, 3.234815972643568],
            [33.14627677602487, 3.233931153178311],
            [33.146077809070924, 3.232340576164618],
            [33.14531732409749, 3.232029882197819],
            [33.144582632450785, 3.230714574979464],
            [33.144333202635714, 3.229547655392746],
            [33.14552892585591, 3.228523652026863],
            [33.144745325433576, 3.227878078814578],
            [33.145176408972134, 3.226418861800436],
            [33.14698563661557, 3.225652859767763],
            [33.14729692082784, 3.224624220921884],
            [33.14796314198525, 3.224504411261908],
            [33.14784591902721, 3.22366727065709],
            [33.14820302450547, 3.223499722807798],
            [33.1503786093763, 3.223869756073844],
            [33.15373337049979, 3.223342398626742],
            [33.15485232908569, 3.222815808648026],
            [33.15483053146533, 3.221835133798604],
            [33.15592598024192, 3.22116500829651],
            [33.15619133089874, 3.219323144564076],
            [33.158000041112615, 3.218796315725371],
            [33.158164470538836, 3.219824772113264],
            [33.15928193612472, 3.220039674039754],
            [33.15950964108295, 3.21916653635889],
            [33.160247599902334, 3.218855337000035],
            [33.160391416586044, 3.218305142816008],
            [33.16105759013277, 3.218209236554555],
            [33.160324061804374, 3.21631986764088],
            [33.16118093421117, 3.216008632433681],
            [33.161277857938764, 3.215123590315771],
            [33.16194422552156, 3.214932002307497],
            [33.16320313354387, 3.215768745589773],
            [33.16441679881523, 3.215457365813294],
            [33.164417847149174, 3.214931141282048],
            [33.1650369265171, 3.214596067795415],
            [33.16434888797639, 3.21373521212023],
            [33.16525334324547, 3.213423955495666],
            [33.165822687387696, 3.214165247205462],
            [33.167309679457304, 3.213053776725354],
            [33.167269616392254, 3.210661151128287],
            [33.16561843205166, 3.20275968488208],
            [33.16552084716404, 3.199442922478003],
            [33.16678130118695, 3.191833635283851],
            [33.17387507420346, 3.181444871995939],
            [33.179987633604796, 3.181945965580844],
            [33.21133322793992, 3.170740030895594],
            [33.23526117605591, 3.176100265517634],
            [33.23785440117707, 3.17569256522775],
            [33.24149800300376, 3.173275218189219],
            [33.24629254523708, 3.172184873902935],
            [33.282786203005834, 3.185426513192535],
            [33.29721480655543, 3.184521656632914],
            [33.336498190523855, 3.181788800947375],
            [33.33320355004907, 3.184515188884283],
            [33.33290669996679, 3.187014915546029],
            [33.33195480376923, 3.188283199436288],
            [33.33109789003994, 3.188714265009124],
            [33.327659679918106, 3.195114686356377],
            [33.32580272119033, 3.195020129576964],
            [33.3230897209974, 3.198490007158504],
            [33.32097096265312, 3.198730457731644],
            [33.31991185252642, 3.199795482696391],
            [33.318126493120026, 3.200370598641125],
            [33.311485559939946, 3.204847378600929],
            [33.31059342955655, 3.207156083337722],
            [33.310237239461564, 3.210481055228402],
            [33.309630520013606, 3.211856760109423],
            [33.30998902776203, 3.216903493939014],
            [33.308382596590604, 3.219045181598364],
            [33.30578815065895, 3.221151583556869],
            [33.30547901521687, 3.222467314826001],
            [33.30455051384425, 3.222443934570345],
            [33.30440788832659, 3.223233351546131],
            [33.30345561842987, 3.223377406196462],
            [33.3025988421428, 3.224478189695734],
            [33.3024081837069, 3.227320432761371],
            [33.301098970927, 3.228038753971495],
            [33.300813492617905, 3.228876090085393],
            [33.303229882578776, 3.234505198715483],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 535,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "OMIYA ANYIMA",
        Population: 21083,
        Key: "KITGUMOMIYA ANYIMA",
        Dist2: "Kitgum",
        "Sub Country": "Omiya Anyima",
        id2_original: "Kitgum  Omiya Anyima",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.51070325346302, 3.751986258018007],
            [33.48793866496246, 3.751265922395182],
            [33.328233540789604, 3.764106195163269],
            [33.32942738742916, 3.762975847252001],
            [33.32955297370252, 3.76221714042728],
            [33.32854369581953, 3.761582043756428],
            [33.32879494921464, 3.759430400063788],
            [33.32778565246704, 3.758794052701256],
            [33.32904715123065, 3.758349987191724],
            [33.329803862381574, 3.757589262165918],
            [33.32936192449945, 3.756638881128898],
            [33.329992325334935, 3.755497982930353],
            [33.32929791414558, 3.754167478449874],
            [33.330117872082404, 3.753850317618857],
            [33.330117609774355, 3.753153248405437],
            [33.32910771654542, 3.751632753149543],
            [33.32683332687477, 3.742444966593688],
            [33.32790463702136, 3.739529547340189],
            [33.32758849831333, 3.737565197967232],
            [33.32853428686526, 3.736392498207447],
            [33.327776295615045, 3.73366787467053],
            [33.328532589947685, 3.731829863039523],
            [33.32796384767668, 3.72910516708031],
            [33.32998111705511, 3.725555692277284],
            [33.329665042127445, 3.72340212601301],
            [33.32802429800709, 3.722007708246108],
            [33.327203712147885, 3.720550505566045],
            [33.32606739002589, 3.718174553775325],
            [33.32587808714774, 3.716657726158496],
            [33.32468414798171, 3.716342557077328],
            [33.32317050379595, 3.717103558118679],
            [33.32178260398707, 3.716723844742027],
            [33.320075757336525, 3.713745697755978],
            [33.31787043373818, 3.713430031909348],
            [33.315719667522025, 3.71101751431953],
            [33.31534078777959, 3.709117921536801],
            [33.31420476569486, 3.708229773210968],
            [33.31256382574177, 3.705758923715949],
            [33.31237405304474, 3.70423810893496],
            [33.31451777916405, 3.701480748372166],
            [33.31514729336232, 3.697868429275299],
            [33.31659750121765, 3.696156918677787],
            [33.3172907374106, 3.694382307353463],
            [33.31823520094751, 3.689565842169927],
            [33.316342130843616, 3.685670389536438],
            [33.31381763851981, 3.683642313895072],
            [33.31337531705705, 3.681424516380406],
            [33.31211334577961, 3.67920763580355],
            [33.30990454839609, 3.677116565127857],
            [33.30782355163307, 3.674141155665137],
            [33.30290064463725, 3.6703066844854],
            [33.29867067379704, 3.658838101963828],
            [33.297154160392274, 3.650695531478793],
            [33.29481936620534, 3.647654530857595],
            [33.29374547789388, 3.642712001646703],
            [33.29387015776709, 3.638180985053638],
            [33.29342756680975, 3.634885874458127],
            [33.29411656744615, 3.627756496094684],
            [33.29398921957652, 3.624017680956321],
            [33.29518671876605, 3.621228994427086],
            [33.29688749190694, 3.614447812464212],
            [33.29884140580332, 3.610296414706888],
            [33.29890308502906, 3.606050591764587],
            [33.299784297288475, 3.600473721006585],
            [33.300666429422755, 3.597843549294307],
            [33.302242315179605, 3.595118126171737],
            [33.30261998309472, 3.592773276774992],
            [33.30356547969419, 3.590998604087293],
            [33.304132363350874, 3.588653701072939],
            [33.30564561227788, 3.587322408237399],
            [33.30589677134986, 3.583932026753622],
            [33.30696837704216, 3.58215730103451],
            [33.30766064305461, 3.577657783442186],
            [33.30740757236774, 3.575186422229348],
            [33.30646074087175, 3.572905410370242],
            [33.3021086683232, 3.572209777276851],
            [33.29182811285314, 3.571896268240966],
            [33.289683563877034, 3.571421667773946],
            [33.2871601414467, 3.569458005521271],
            [33.283374692043395, 3.565403453184662],
            [33.27933775208979, 3.563947161553751],
            [33.275868023677894, 3.560906436520387],
            [33.2755519810896, 3.558561828647709],
            [33.27397408130988, 3.554601640729718],
            [33.27409964961692, 3.552700508362633],
            [33.27479302325213, 3.551369502317936],
            [33.27378335460204, 3.549468680687224],
            [33.27182775277122, 3.547884986631303],
            [33.26993497461981, 3.545414105859972],
            [33.26949147007582, 3.538411794650834],
            [33.26993178829551, 3.534419328649354],
            [33.26784923565041, 3.52985724657427],
            [33.271189084740186, 3.51392127525222],
            [33.272256676759824, 3.50476120542668],
            [33.27192812153792, 3.502625721042472],
            [33.270918506786714, 3.500648850847546],
            [33.26995894436653, 3.497303152545945],
            [33.270059299658506, 3.49537666073237],
            [33.2683932329286, 3.491372127255756],
            [33.26849359181383, 3.489445625958065],
            [33.26950078470702, 3.482956172135459],
            [33.276229150015396, 3.462632215141018],
            [33.27431780817864, 3.455839351576861],
            [33.272819666219746, 3.451986168682188],
            [33.27292124052555, 3.447239507898103],
            [33.27226477866538, 3.444133285743936],
            [33.2779167349896, 3.44457132724549],
            [33.28246084937958, 3.44402000384674],
            [33.28914251217466, 3.445776411994875],
            [33.292795668482704, 3.447513898543902],
            [33.310798428697645, 3.450966494277163],
            [33.317681589000856, 3.449983359681751],
            [33.32113846162269, 3.45051659345182],
            [33.323886481738654, 3.451673523130302],
            [33.32716585085362, 3.451494261298606],
            [33.3348776252597, 3.45345102597767],
            [33.343564713146215, 3.456298035563557],
            [33.348837504962056, 3.459902343269414],
            [33.35178755079553, 3.460832821887936],
            [33.35911970075585, 3.460914748574099],
            [33.362321878536754, 3.459981952123855],
            [33.3661135667397, 3.457947968993022],
            [33.37403515615514, 3.456843917953317],
            [33.37698407011137, 3.454894916573225],
            [33.377657679013666, 3.453370260749371],
            [33.37849856410335, 3.448627382834184],
            [33.380266506973015, 3.443968824201479],
            [33.382119116058185, 3.440326486354855],
            [33.383956018100605, 3.4380014152768],
            [33.38607926352972, 3.438377055681014],
            [33.39071438444454, 3.438375160060979],
            [33.392062435885755, 3.437527724279961],
            [33.40141640339477, 3.436253497101917],
            [33.40520829461696, 3.435150945277172],
            [33.40891557711582, 3.433286222737151],
            [33.41140691621579, 3.429620788887555],
            [33.413549434999325, 3.428908677279523],
            [33.41526738213183, 3.427193395217662],
            [33.41994131655512, 3.419341661415575],
            [33.41014916163029, 3.402795842349017],
            [33.40378286229717, 3.387528593501143],
            [33.40159690098646, 3.381184567902419],
            [33.40171676858473, 3.380674623726935],
            [33.39698221494778, 3.377482986594021],
            [33.3955541811069, 3.377073583790601],
            [33.39320720306976, 3.374102120341043],
            [33.39249211895077, 3.371232487546744],
            [33.39283252025633, 3.358921909788468],
            [33.39003144294473, 3.352639701784094],
            [33.38502815739221, 3.348572481257617],
            [33.383358930389115, 3.343426781828106],
            [33.384071681583315, 3.338878559237052],
            [33.38764319181184, 3.336124447435476],
            [33.39300139274995, 3.334446754485382],
            [33.400384556238606, 3.334084715804206],
            [33.40359747427704, 3.328218957297131],
            [33.40645266430474, 3.321276197662062],
            [33.40990352989225, 3.315051279478495],
            [33.410615807674304, 3.309665275027702],
            [33.412282219357266, 3.307869343595307],
            [33.41311500164309, 3.305954078002834],
            [33.41438176543259, 3.304758854331625],
            [33.417009555929226, 3.304026164417743],
            [33.422150757132385, 3.304405481520382],
            [33.42818007055467, 3.303612263903436],
            [33.42998185924924, 3.302655748489582],
            [33.433531028376656, 3.299483008533688],
            [33.437643110607134, 3.300161411568575],
            [33.4802153427134, 3.296354330420935],
            [33.482615939393234, 3.295870864138228],
            [33.483728896334725, 3.296401946658778],
            [33.48464041236192, 3.29763412431243],
            [33.48607132440496, 3.296405060448905],
            [33.48641678412389, 3.295145905520955],
            [33.48701794659347, 3.294545543062995],
            [33.486962387589784, 3.293889247571603],
            [33.48513554578023, 3.293140325059845],
            [33.48576659699597, 3.291910201868109],
            [33.485686477154076, 3.291257278527917],
            [33.484715326466734, 3.291684983757469],
            [33.48456797401404, 3.291364689591027],
            [33.48545755228373, 3.289462162236287],
            [33.485344912530245, 3.288689092677674],
            [33.485947097282626, 3.287602053429619],
            [33.48631851831326, 3.287573922346769],
            [33.486292321642935, 3.286457435107884],
            [33.48829228767238, 3.286288323749902],
            [33.489604694861455, 3.287062989746189],
            [33.491036517796154, 3.285390196527423],
            [33.492322174952704, 3.285306017433907],
            [33.49261048834483, 3.284046810816166],
            [33.49407041866648, 3.282588760339391],
            [33.49495608567141, 3.282532671877578],
            [33.494789097843224, 3.280442678481872],
            [33.49521739390946, 3.28052910995857],
            [33.49573265498, 3.280014511043882],
            [33.49684617965676, 3.280273613638108],
            [33.49739308837477, 3.278299073587698],
            [33.49785055363656, 3.278099285148699],
            [33.498649188263485, 3.278672883992412],
            [33.49885207007546, 3.277284737526613],
            [33.49933859583671, 3.276855971436921],
            [33.503067558276655, 3.277793231223639],
            [33.50515364399574, 3.277504941032734],
            [33.507583255360956, 3.278365415021133],
            [33.50866904724821, 3.277991447553601],
            [33.5104124822803, 3.278306520093644],
            [33.512012672855455, 3.277846116418736],
            [33.513240769561854, 3.276351882575989],
            [33.515098679605494, 3.276954115141297],
            [33.51812802152575, 3.277038702106514],
            [33.52077118579018, 3.276362325462161],
            [33.52137157660696, 3.276850308747928],
            [33.523657544663266, 3.276245941624105],
            [33.52443462152002, 3.276739024436607],
            [33.524859824686715, 3.277997664486651],
            [33.52660243865862, 3.278772013150972],
            [33.527431022218785, 3.278426911692856],
            [33.53144637924939, 3.278582745694966],
            [33.53176038625527, 3.27789323040963],
            [33.53276047527118, 3.277605448759161],
            [33.533588793828365, 3.276743318538262],
            [33.5344750662978, 3.277403487123663],
            [33.53833336278246, 3.277803523424685],
            [33.5398332196252, 3.276869203510507],
            [33.54232609394597, 3.279429434260581],
            [33.54278073400622, 3.280630078358421],
            [33.54446489550089, 3.280543250485721],
            [33.54563627347855, 3.27991070945232],
            [33.54809448989734, 3.28079976824145],
            [33.54919459284543, 3.280497567981533],
            [33.55052021155739, 3.281461967290734],
            [33.55136728154779, 3.281817636985105],
            [33.55291032759278, 3.281472104300295],
            [33.554024118170844, 3.280064044616795],
            [33.5549671336235, 3.279948609173277],
            [33.5567678102038, 3.280378472570313],
            [33.558528813587856, 3.279800491828871],
            [33.559792201508486, 3.280163983487189],
            [33.559844614612075, 3.281382565345981],
            [33.56027007020535, 3.281695744480403],
            [33.56117719167421, 3.281438800057674],
            [33.56282058851959, 3.279614347378498],
            [33.569965846679985, 3.280607520959427],
            [33.57220479332109, 3.279096132812714],
            [33.57529475894656, 3.278410532610319],
            [33.57631477349383, 3.277270242699142],
            [33.578128751428515, 3.276328939436289],
            [33.57852469466975, 3.274619159259916],
            [33.58076464652567, 3.27490278218672],
            [33.582012666966726, 3.275842307445405],
            [33.58246619581096, 3.275671087596265],
            [33.582437070632835, 3.274331957826154],
            [33.58317319239745, 3.272564993752881],
            [33.585158140391954, 3.273133681030338],
            [33.584818663452836, 3.274416040983944],
            [33.58558419426323, 3.274472577428383],
            [33.58598179759114, 3.275640534688979],
            [33.58737035137358, 3.274471526321731],
            [33.58938355497701, 3.274869232885791],
            [33.59074493921371, 3.275723199820903],
            [33.59355195977921, 3.2760634412995],
            [33.594090003922, 3.274980408886345],
            [33.59460036827596, 3.275037089691479],
            [33.59579149302019, 3.275634718632176],
            [33.597464259385475, 3.2756622105988],
            [33.59814514015001, 3.276402604652459],
            [33.59902285616636, 3.274407609709161],
            [33.598993453408795, 3.272641099575578],
            [33.600099148369516, 3.272611942971839],
            [33.60120535357332, 3.273437555241701],
            [33.60215265219324, 3.273010184796807],
            [33.60327132511489, 3.270140139702056],
            [33.60601643468934, 3.267396235333683],
            [33.60773097720691, 3.263781245809049],
            [33.6093577938471, 3.264542999225686],
            [33.61112809209942, 3.263506768590835],
            [33.612140256269385, 3.263851199851035],
            [33.61338680886328, 3.263323780747504],
            [33.61503132321289, 3.263468055694371],
            [33.616441385358165, 3.264375214205913],
            [33.617326634646474, 3.264029618106808],
            [33.61866449290418, 3.265063940587324],
            [33.61947750506723, 3.264791029632468],
            [33.62023676024706, 3.265262732526092],
            [33.621862859133344, 3.264844030311268],
            [33.62352552304494, 3.265115403141906],
            [33.62428292949191, 3.262590622765272],
            [33.62493314446761, 3.262063561744087],
            [33.62514949651725, 3.261264366111746],
            [33.62738949957711, 3.2600643732653],
            [33.62765984666356, 3.258920092987777],
            [33.628364641479294, 3.258992294008525],
            [33.629880776693305, 3.256121987335971],
            [33.629300120965034, 3.252254171354282],
            [33.63029335763195, 3.251236562323991],
            [33.63148428295019, 3.248475422336434],
            [33.63455556092284, 3.247402021317773],
            [33.63498934928873, 3.24756519116784],
            [33.635713023996765, 3.248944929260537],
            [33.63751933301386, 3.247799675807125],
            [33.642001086356835, 3.248323476986443],
            [33.644673177271734, 3.244689682381503],
            [33.64593790458048, 3.244398304623273],
            [33.64622661143467, 3.243744343176911],
            [33.64814189687556, 3.243507027055014],
            [33.65251560355107, 3.244648305939547],
            [33.654015120830685, 3.244175162878064],
            [33.655369525157596, 3.242848573472871],
            [33.65724838121872, 3.242175415156439],
            [33.65800733725956, 3.242193080054413],
            [33.66005025713261, 3.243735374416349],
            [33.661405503180944, 3.243716323871777],
            [33.66221826740899, 3.243116498354722],
            [33.66261518172905, 3.242153737628395],
            [33.664639063606316, 3.242206885688557],
            [33.665650582785894, 3.241588765656572],
            [33.666283236596094, 3.241897072790959],
            [33.66644652156867, 3.242895783275257],
            [33.6670431304781, 3.243349397452014],
            [33.66827172844441, 3.243094338327209],
            [33.66877671009316, 3.241604854750222],
            [33.67258936587316, 3.241420713134111],
            [33.675154776458186, 3.24061994326599],
            [33.68133515776516, 3.241287713276249],
            [33.68355730231718, 3.240596116782919],
            [33.686105495791445, 3.241084712043364],
            [33.686973147981675, 3.241519967042477],
            [33.687497851244174, 3.242518424082883],
            [33.68917869076891, 3.243007601384711],
            [33.69075145847341, 3.244005337661941],
            [33.69152924589756, 3.245148899427117],
            [33.69315631406601, 3.246273715235744],
            [33.69411547763422, 3.248397801662162],
            [33.69370105784419, 3.250141470741741],
            [33.69397336415627, 3.251975465844114],
            [33.69491355800064, 3.252773867049738],
            [33.69626900437326, 3.253045330131823],
            [33.697607644165245, 3.255150986952379],
            [33.69753638889861, 3.25664017520092],
            [33.696237596575976, 3.259928079001923],
            [33.69670864885646, 3.261707453650021],
            [33.69716056881803, 3.261943221095014],
            [33.69707070495025, 3.262651532961701],
            [33.697820382292534, 3.263161231385694],
            [33.69830881607546, 3.264968945481292],
            [33.699733483928945, 3.265683657873657],
            [33.69954653912841, 3.266324147755306],
            [33.70041688626447, 3.267515864123509],
            [33.701055779772645, 3.267308979410763],
            [33.701375720150985, 3.267928086346984],
            [33.70096535715277, 3.268570651013294],
            [33.70121696897566, 3.269396269301894],
            [33.70340477273097, 3.27077888325873],
            [33.70516801831002, 3.273293035094739],
            [33.706697792644995, 3.274232430026894],
            [33.707223519088615, 3.275378985190693],
            [33.708250276390366, 3.275011231765105],
            [33.70868440611605, 3.275722021363262],
            [33.71005408359942, 3.276156878427751],
            [33.71083002678226, 3.276110431609423],
            [33.711810881969654, 3.275398652167039],
            [33.71290680236176, 3.275994252223282],
            [33.71277124389043, 3.277921192261294],
            [33.714324563069034, 3.279869851042182],
            [33.7139833281269, 3.281429898896643],
            [33.71480542764735, 3.28211745752451],
            [33.71423532532704, 3.282737206411279],
            [33.7143499925781, 3.283539973177556],
            [33.713688584593974, 3.284205676157743],
            [33.71419214600625, 3.286223894004589],
            [33.715243188363395, 3.287897653512308],
            [33.71686310594221, 3.287185393689711],
            [33.719830589872004, 3.287871402207406],
            [33.721662151430046, 3.290472367664785],
            [33.72311859179683, 3.291040404411266],
            [33.724277856891206, 3.290849864880141],
            [33.72465601079488, 3.291770965843868],
            [33.72541141040551, 3.292339505869895],
            [33.72565375341127, 3.2919057455049],
            [33.7265442695221, 3.292907788180561],
            [33.72635642281305, 3.294154503306975],
            [33.72530544423626, 3.294968247948338],
            [33.727706283461245, 3.296456987740902],
            [33.72781565244877, 3.298543566524134],
            [33.726900523397475, 3.300793531693769],
            [33.727307152997376, 3.303774188770986],
            [33.72787398904334, 3.304586742628587],
            [33.72790258960533, 3.306835999965472],
            [33.727498632493415, 3.30754090614842],
            [33.72855187212976, 3.309789398076771],
            [33.72973885025065, 3.31057442282074],
            [33.73052298337397, 3.31352767705818],
            [33.7304157981909, 3.314476258640209],
            [33.731225244940596, 3.315180265263646],
            [33.73125298311994, 3.316237123539324],
            [33.73063312042104, 3.316644050560157],
            [33.73093089127648, 3.318215627474024],
            [33.73044606512777, 3.318947680019813],
            [33.7311747650115, 3.319868515448605],
            [33.730097661629664, 3.321847578892515],
            [33.72980320016773, 3.324774575125431],
            [33.72886041019222, 3.326076040281416],
            [33.72932092523441, 3.32894827435671],
            [33.728404596932194, 3.329572246605125],
            [33.72934301660386, 3.33241762309413],
            [33.72899945592344, 3.333196120005809],
            [33.729301679727755, 3.334709109876543],
            [33.73081278976608, 3.337181131700846],
            [33.73210802296355, 3.33719227075381],
            [33.733434118680904, 3.338121631064632],
            [33.73468175823631, 3.338250387839621],
            [33.73644840663363, 3.342053782268375],
            [33.7365363966157, 3.34464782461545],
            [33.737009711752364, 3.344777168825116],
            [33.7374405347795, 3.345598325832789],
            [33.73837261324356, 3.350367121546406],
            [33.73989831910862, 3.353119361222109],
            [33.739813139955075, 3.354243564293922],
            [33.740416289498064, 3.355410449887025],
            [33.73972807309094, 3.355540667927039],
            [33.739599329239354, 3.355973128686747],
            [33.74084781860102, 3.357139510917983],
            [33.74102140365662, 3.359171446446833],
            [33.739989674179775, 3.36016664116915],
            [33.739947368919765, 3.361074619506136],
            [33.740451394761074, 3.361463150447402],
            [33.740207258718, 3.362866826320117],
            [33.74078548001187, 3.363974197501844],
            [33.74057585095381, 3.364396343497167],
            [33.741626498950524, 3.365503352441245],
            [33.741942729286755, 3.367191165044703],
            [33.741629414881935, 3.369354208725073],
            [33.74094758908972, 3.370093274330728],
            [33.74115843536502, 3.371253634061313],
            [33.741788664622256, 3.37167519310948],
            [33.741265222594414, 3.373627414159332],
            [33.74210585615581, 3.374681798941711],
            [33.742422205967955, 3.376527865864934],
            [33.741058536417206, 3.377953208015588],
            [33.74042958276765, 3.379219767143235],
            [33.74064020087086, 3.380063623343884],
            [33.74001095257389, 3.380908160341837],
            [33.74037870757987, 3.381329892756098],
            [33.73948707486312, 3.38228009456535],
            [33.73938262505011, 3.382965955132622],
            [33.736602384161515, 3.385341907205301],
            [33.73649786517823, 3.385975002800302],
            [33.734176863724116, 3.386394025731136],
            [33.731811376798845, 3.387882261857994],
            [33.73261707757381, 3.390778389867596],
            [33.73267113189939, 3.392835683026242],
            [33.731412390963705, 3.394260939303545],
            [33.73010030806648, 3.394578457644265],
            [33.72894664037463, 3.396109142602051],
            [33.728842807704225, 3.397639023450918],
            [33.72728491610083, 3.398830370054953],
            [33.72315725079509, 3.404503105509267],
            [33.722076903596744, 3.405187701157485],
            [33.721304372215336, 3.407049597165985],
            [33.722028717066564, 3.41093773622369],
            [33.721505248987576, 3.412942667108322],
            [33.722130451272484, 3.413546756272837],
            [33.72239888494739, 3.414577297628891],
            [33.72166452208408, 3.415316399497818],
            [33.72103668773538, 3.418112721133295],
            [33.71941003548689, 3.418957995992727],
            [33.714843964474724, 3.420174725516612],
            [33.71106654331513, 3.423078929034056],
            [33.71033280478094, 3.424662055819951],
            [33.70513984714271, 3.43004664902468],
            [33.702205603573375, 3.437539623475747],
            [33.702102671913195, 3.440282839657785],
            [33.699271024932465, 3.44455785354571],
            [33.695597385239296, 3.445984864888787],
            [33.692605567745126, 3.446567331004185],
            [33.690669094639965, 3.448054396880846],
            [33.688485118606046, 3.449069220637383],
            [33.68697371751357, 3.450590220399993],
            [33.68497104306354, 3.451507342151705],
            [33.68146290897835, 3.458082023503422],
            [33.679834887697346, 3.458874489796296],
            [33.678297114763076, 3.460745925810201],
            [33.677886439151145, 3.46207703127984],
            [33.676419784041286, 3.463300992122951],
            [33.67505977782027, 3.46349979026039],
            [33.67325356222794, 3.46540738084148],
            [33.67268178275298, 3.466702632625153],
            [33.670499673418234, 3.468538553112727],
            [33.665369229540616, 3.47701264564903],
            [33.66461798553649, 3.477624632287056],
            [33.66286411926734, 3.477679824465706],
            [33.66155728881958, 3.477177194708667],
            [33.65704701127137, 3.476838664574796],
            [33.651323984733445, 3.475521544523998],
            [33.64896641466076, 3.47636091764508],
            [33.643943815329614, 3.481295087598826],
            [33.64356507392773, 3.484789931436613],
            [33.643687349909285, 3.489457269852705],
            [33.64397733686277, 3.490617602149764],
            [33.645792419725254, 3.491948820581803],
            [33.646114948149936, 3.492865068290203],
            [33.64590071612434, 3.493404316760757],
            [33.646680083685055, 3.495506268844539],
            [33.64568803369261, 3.496207785845558],
            [33.64520656454811, 3.498229744060284],
            [33.644187557012295, 3.49874259233725],
            [33.642901122813065, 3.500468601260392],
            [33.642419315901996, 3.502005368919205],
            [33.641400191585184, 3.502356486845798],
            [33.641470442535365, 3.503343104973141],
            [33.64099782628797, 3.504430615975648],
            [33.64113501699816, 3.507284385437857],
            [33.63870420638206, 3.512586090898171],
            [33.63600122060791, 3.515441809813339],
            [33.63464898571242, 3.515782480600872],
            [33.634041891666996, 3.518025219373385],
            [33.630595108024096, 3.52101733423595],
            [33.62816393718356, 3.525911332783677],
            [33.62640680374174, 3.527543305771253],
            [33.62574769813967, 3.529138129269707],
            [33.622518191811196, 3.532001913509688],
            [33.62377305112652, 3.535591418730389],
            [33.62569049611733, 3.538440192750146],
            [33.626799076466725, 3.543584372186648],
            [33.62786933648278, 3.546507741627187],
            [33.62875976096542, 3.55363914862222],
            [33.63005043970441, 3.557832495562771],
            [33.63215121198007, 3.567418744386688],
            [33.609876846706484, 3.584881503173814],
            [33.60244254482363, 3.591162446172237],
            [33.53589858430774, 3.707383071579837],
            [33.519168143962304, 3.735954403941678],
            [33.51070325346302, 3.751986258018007],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 536,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "OROM",
        Population: 27776,
        Key: "KITGUMOROM",
        Dist2: "Kitgum",
        "Sub Country": "Orom",
        id2_original: "Kitgum  Orom",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.978271051479684, 2.791966877620892],
              [31.978441725095454, 2.792491851590966],
              [31.978182118266574, 2.791733766036492],
              [31.978271051479684, 2.791966877620892],
            ],
          ],
          [
            [
              [31.823425341378368, 2.7967328373045],
              [31.821014748246068, 2.800051863275637],
              [31.81475484627351, 2.802586011505937],
              [31.813409333471267, 2.802181011277669],
              [31.811874273449167, 2.802416874417916],
              [31.811473290659148, 2.801989092277636],
              [31.81069393118327, 2.802130753210936],
              [31.803491645273713, 2.805982214780255],
              [31.80362655246645, 2.806737437004032],
              [31.80253497363212, 2.809949199743639],
              [31.802742730601135, 2.810333107774446],
              [31.801578790674004, 2.810523135828108],
              [31.80058101841321, 2.8100379354029],
              [31.800721335260597, 2.810640341596881],
              [31.800355948213735, 2.811167483884611],
              [31.80064944488505, 2.812033736313326],
              [31.799885883181727, 2.812210082177259],
              [31.799426863834498, 2.813177949028586],
              [31.79863960637064, 2.813555023572052],
              [31.79883042919824, 2.814201002915669],
              [31.79764745217362, 2.815852041260066],
              [31.798006857339015, 2.816812219415519],
              [31.7975674877403, 2.817840125017968],
              [31.795911821704752, 2.817662112954102],
              [31.79381582577143, 2.819442423477172],
              [31.79117571398233, 2.819919570061279],
              [31.790308332185027, 2.820398563840361],
              [31.79034660580603, 2.82106458881339],
              [31.789820153523646, 2.821524350973094],
              [31.78819653219093, 2.821855643651185],
              [31.78771932285751, 2.82209493470189],
              [31.787692300635452, 2.822601135049308],
              [31.786923837723965, 2.822626971552765],
              [31.786207291147665, 2.823691963281689],
              [31.785226290433247, 2.8242504468783],
              [31.786290158037684, 2.826079116590523],
              [31.7849807233739, 2.827216402396777],
              [31.78320992835325, 2.827713963857498],
              [31.78131271162602, 2.827314980159767],
              [31.780420309951392, 2.828172026739496],
              [31.777961917462804, 2.828540792641833],
              [31.777158475052474, 2.829577209664043],
              [31.77657265580795, 2.8295509758468],
              [31.77624207668168, 2.829025588778801],
              [31.774675227976594, 2.829356875727413],
              [31.772880981537117, 2.827933526495965],
              [31.77202753889808, 2.828073482246518],
              [31.77155678845155, 2.827624779140935],
              [31.77034590885589, 2.828558309981571],
              [31.770803884360763, 2.829405671945109],
              [31.768062872900646, 2.829157005551325],
              [31.767178528215815, 2.829528787594326],
              [31.765440418396757, 2.828322734757974],
              [31.764384046335035, 2.829583137596882],
              [31.762073795918255, 2.830125412777266],
              [31.76176633313923, 2.831892851540755],
              [31.759988790872484, 2.83336301449343],
              [31.75882052106568, 2.832587633820214],
              [31.756539668016583, 2.832298462308914],
              [31.756096909074312, 2.833526045112146],
              [31.75488487873677, 2.833185479437723],
              [31.75351526413547, 2.834044131282144],
              [31.752260565618556, 2.83410011400691],
              [31.751170679210226, 2.832299760583288],
              [31.751888010914055, 2.831506104650815],
              [31.751264490275343, 2.830338751844925],
              [31.75197940640938, 2.829513892843633],
              [31.751445837673327, 2.827682544057792],
              [31.750684941271462, 2.827583956456598],
              [31.750403791943747, 2.826976237609859],
              [31.747882474266145, 2.826645971917519],
              [31.745985413845773, 2.828607919114906],
              [31.746034104330782, 2.828989016277279],
              [31.747606648354765, 2.829935855377755],
              [31.747560059029205, 2.830269691066821],
              [31.746322982763218, 2.830179428088895],
              [31.745662584485466, 2.83208865236089],
              [31.743474962189833, 2.832288220566092],
              [31.743382185983894, 2.833098871053141],
              [31.742266868269866, 2.833985188636968],
              [31.7356008631102, 2.831819897825056],
              [31.734883322098913, 2.830440597015447],
              [31.732026986719223, 2.829689640302611],
              [31.73107104900122, 2.828120662622875],
              [31.730499539919123, 2.827884677280268],
              [31.728170201200886, 2.828418458367144],
              [31.7258836070188, 2.827283860021335],
              [31.72512472553816, 2.82804954707605],
              [31.722387813988995, 2.827464905912316],
              [31.721774944674603, 2.829373901378117],
              [31.720297980498525, 2.828569649955654],
              [31.7176371796101, 2.829629039373321],
              [31.71754577333501, 2.830916292762718],
              [31.7156460539014, 2.831972590015883],
              [31.71155284707163, 2.831178929373142],
              [31.711122798392292, 2.830513390215761],
              [31.71135846152561, 2.829749848246445],
              [31.714204848063513, 2.827069206858647],
              [31.714534094089885, 2.825780983787227],
              [31.712538579212698, 2.826599344170154],
              [31.712532396108575, 2.824454547413511],
              [31.709245242193365, 2.822752049255587],
              [31.708248522758105, 2.823518690357434],
              [31.706059844941972, 2.823336921585039],
              [31.705961826168082, 2.822336416728374],
              [31.705436801308693, 2.821718925240257],
              [31.70643324496118, 2.820856975039896],
              [31.70828702185624, 2.820372817010112],
              [31.708189539376548, 2.819562951680477],
              [31.707665062489486, 2.81913612150375],
              [31.707212552334795, 2.818923473935452],
              [31.705976902593466, 2.819309795244886],
              [31.702556414435612, 2.820848852445789],
              [31.702181088428425, 2.822661544339342],
              [31.70099450107467, 2.823571939746725],
              [31.69975664596938, 2.82319565262326],
              [31.699134423396238, 2.821863625373796],
              [31.69665926924278, 2.821301697972214],
              [31.693037153321036, 2.818885595648696],
              [31.69317409699452, 2.816883230674126],
              [31.692029204944717, 2.815743968926788],
              [31.690976834877564, 2.813698765579011],
              [31.691422077661606, 2.811385369126501],
              [31.689750803398027, 2.809152007803642],
              [31.687559982201655, 2.80820762188244],
              [31.687409211659315, 2.80539618258464],
              [31.686836772820925, 2.804826557009956],
              [31.685361925973965, 2.804737201859889],
              [31.684357412755286, 2.802787133405848],
              [31.683310534987786, 2.802648369742477],
              [31.682790722153683, 2.803842021493474],
              [31.68322429761883, 2.805746740863107],
              [31.6821785113044, 2.805989281428547],
              [31.68094014146443, 2.80542234696155],
              [31.67936578643683, 2.80380819285799],
              [31.676510571256323, 2.803390781528802],
              [31.67538518432626, 2.800750093809413],
              [31.67448006340553, 2.800277135793038],
              [31.67314834153955, 2.80033016552164],
              [31.672431576672665, 2.799189175689836],
              [31.670955657237275, 2.798718520268199],
              [31.669053021872248, 2.798726190805411],
              [31.668246434460112, 2.799444369641258],
              [31.667390644523223, 2.799590801524106],
              [31.665059495699662, 2.799457218164449],
              [31.66311254733998, 2.800608936959293],
              [31.659974828172302, 2.801193515328923],
              [31.660078511722393, 2.804195759157721],
              [31.65917679092504, 2.804914310581486],
              [31.658087925002846, 2.806729814970143],
              [31.656734254599524, 2.807426348432011],
              [31.656262243816638, 2.808715096058284],
              [31.657267918557, 2.811094130496305],
              [31.656033901054567, 2.812052324301304],
              [31.655751760885092, 2.813197309515679],
              [31.656085403266427, 2.813434291972409],
              [31.65784400365711, 2.812950611773218],
              [31.658369272858245, 2.813663420009198],
              [31.65580664345736, 2.815770814069818],
              [31.654095326789964, 2.816158964083783],
              [31.65332750078402, 2.813778988910828],
              [31.651906322885424, 2.815834126255665],
              [31.650430261516192, 2.815315780736557],
              [31.649054621914292, 2.816655790960169],
              [31.647197644321903, 2.815995981271655],
              [31.64652888183054, 2.814997784062057],
              [31.64652495888768, 2.813615615469725],
              [31.6457633555117, 2.813428031981193],
              [31.64409947797616, 2.813768323511129],
              [31.643153285182333, 2.815583231825431],
              [31.64215546980241, 2.815968518839172],
              [31.64296787380602, 2.817299782118371],
              [31.64258964085059, 2.818111535895468],
              [31.641116287901948, 2.818546375110233],
              [31.639141019254637, 2.818101495904012],
              [31.63828159114084, 2.816961072538787],
              [31.637853336397136, 2.816915121811427],
              [31.637190377022492, 2.81796631759403],
              [31.636713633914695, 2.817586941290741],
              [31.63642299478432, 2.815729313559996],
              [31.634422525698334, 2.814784100332894],
              [31.634229288199236, 2.81373633179765],
              [31.634605784711237, 2.812304998705295],
              [31.63422459360357, 2.812068217896635],
              [31.63213249186703, 2.812362540074638],
              [31.63199127670434, 2.812887370312132],
              [31.632469897291106, 2.813933998331207],
              [31.632045704729112, 2.815317864107073],
              [31.631001397041643, 2.816084605214145],
              [31.629809812359973, 2.815231466136648],
              [31.62871137219348, 2.813663038685454],
              [31.627235481504197, 2.813192328977007],
              [31.626090944288876, 2.812148350720014],
              [31.625612464737625, 2.811149401922669],
              [31.626176286037495, 2.808668779830915],
              [31.625675560606556, 2.808218010984118],
              [31.62148910595538, 2.807996412385681],
              [31.622342209929553, 2.80689681152294],
              [31.622245859327133, 2.806468254910395],
              [31.621102012916282, 2.805662579896935],
              [31.620905445362446, 2.803423313664252],
              [31.61933109841969, 2.801761471111337],
              [31.61657243147098, 2.801820129168207],
              [31.612109874227322, 2.804888194644102],
              [31.607357504303305, 2.806384578504627],
              [31.606001564755587, 2.806270809627605],
              [31.60423870455383, 2.805229288102716],
              [31.602097993180617, 2.805142478450123],
              [31.600665706715212, 2.803241759788335],
              [31.599046510483568, 2.802533298605546],
              [31.59937453659778, 2.800768554568457],
              [31.597086619197274, 2.799061873886426],
              [31.59798780549705, 2.798152765745094],
              [31.600268779818723, 2.797381130067007],
              [31.600123957920193, 2.796619134783058],
              [31.595667258590506, 2.793276811027436],
              [31.59504796901679, 2.792945648422145],
              [31.592814316147646, 2.793621757955811],
              [31.591196594949704, 2.79343753953013],
              [31.588192571147435, 2.790780496758983],
              [31.588142620326067, 2.78992281170767],
              [31.586591396917022, 2.787998741625432],
              [31.58255031034005, 2.788682006893464],
              [31.57970125939902, 2.79040904422719],
              [31.57917592641749, 2.789648571539513],
              [31.579220165750314, 2.788456898142387],
              [31.579976944274886, 2.786928789673699],
              [31.580349878068468, 2.784210698232022],
              [31.579775927365425, 2.78306914003752],
              [31.577821292121886, 2.781456450036566],
              [31.57805418305422, 2.77969212387634],
              [31.577256547353898, 2.775096105705196],
              [31.57668047393188, 2.773192008738397],
              [31.575345104007496, 2.771910480138892],
              [31.57349014313293, 2.771917842191812],
              [31.572540606809614, 2.772541171480726],
              [31.571025752593187, 2.775120794760857],
              [31.571039041371186, 2.779886705093305],
              [31.56889855008523, 2.779847527211992],
              [31.567901968990483, 2.780661669410621],
              [31.566238298067468, 2.781049529572321],
              [31.563475266204772, 2.779487679064944],
              [31.560329348113484, 2.777069469897208],
              [31.55728332807168, 2.776366619667109],
              [31.55699701702431, 2.776034117183277],
              [31.557300556860515, 2.774007405411024],
              [31.553060864452316, 2.771641165353885],
              [31.550438169199946, 2.769220889884468],
              [31.550148968272314, 2.767839924519381],
              [31.551049607498058, 2.766740210763736],
              [31.551427468550987, 2.765785527844232],
              [31.551141038926005, 2.765405389061968],
              [31.54947451585194, 2.764744740369126],
              [31.548043937083882, 2.763415918265537],
              [31.5476638437175, 2.763560401264066],
              [31.547003104079952, 2.765421719360412],
              [31.546289545300297, 2.765376862183473],
              [31.545002200209346, 2.764238129254267],
              [31.543972685978005, 2.761740075706487],
              [31.543018929369488, 2.76083832695255],
              [31.54192473553934, 2.760747313897104],
              [31.53958919934396, 2.758945470566041],
              [31.538115555341182, 2.75923723892182],
              [31.537061161369703, 2.756334192098354],
              [31.53625051087753, 2.755574837045789],
              [31.53596065507805, 2.753955574747641],
              [31.534624179327604, 2.752245113497562],
              [31.53519373098066, 2.751813953772106],
              [31.5372392766293, 2.751948864209743],
              [31.537950584230824, 2.75118351881301],
              [31.535661953567985, 2.749143204009522],
              [31.53461745364107, 2.749814553365591],
              [31.534125688006746, 2.74702020647416],
              [31.532704224443872, 2.747015957839103],
              [31.534173767637398, 2.746891349448386],
              [31.53507835226389, 2.745697645575685],
              [31.536314649690496, 2.745984404947581],
              [31.536268100789098, 2.744742754657741],
              [31.536696667248222, 2.744074251330915],
              [31.538265948591082, 2.744265562395676],
              [31.538599208290155, 2.743835826471797],
              [31.538171728792513, 2.743167163818196],
              [31.53822055761811, 2.741591249673891],
              [31.537507772287924, 2.740874782768306],
              [31.537223598332623, 2.7394420621225],
              [31.53641545144516, 2.739012110014071],
              [31.535464247848694, 2.739059692352599],
              [31.535034384222296, 2.741304115976793],
              [31.531610771723862, 2.740587139239807],
              [31.52965895988523, 2.742926789872822],
              [31.528850076379214, 2.743404191736831],
              [31.52780407446915, 2.743069705105603],
              [31.527283278878127, 2.740204271840724],
              [31.527355150389038, 2.739559597066084],
              [31.528354269224447, 2.739082228662567],
              [31.528212226713407, 2.738318103414268],
              [31.525216423394312, 2.737887743532809],
              [31.525645076990024, 2.737123742246016],
              [31.526977048587653, 2.736694200264757],
              [31.524884654898624, 2.736502776725869],
              [31.524171950416846, 2.735690802661358],
              [31.524838401542976, 2.734926844839029],
              [31.526265215471657, 2.734831608048511],
              [31.525790250129823, 2.734067424458459],
              [31.524744258101197, 2.733732939706435],
              [31.52117563775296, 2.735881242898559],
              [31.5201299664229, 2.735164700794469],
              [31.51994039584679, 2.734352832601759],
              [31.518228797108403, 2.733779436530092],
              [31.517706133021584, 2.733206260918581],
              [31.51780255099768, 2.731630359696227],
              [31.51923011951123, 2.730627783370185],
              [31.520466660381274, 2.730580272480769],
              [31.520370670003263, 2.731630862181188],
              [31.52117856087089, 2.732347359736247],
              [31.52155921658265, 2.732108645409141],
              [31.521132732418362, 2.730246106194473],
              [31.52070503552843, 2.729863985633374],
              [31.51804251256964, 2.729003880580979],
              [31.51970749772794, 2.728431135187641],
              [31.520041341331925, 2.727285075592992],
              [31.51932842215277, 2.726759634044696],
              [31.515714451255707, 2.726281376711417],
              [31.515406250061538, 2.725159071069894],
              [31.51616779774193, 2.724395136162326],
              [31.514979618573527, 2.723487552819787],
              [31.51459908143938, 2.723582987017976],
              [31.514360667664654, 2.724347037295222],
              [31.51398040182176, 2.724108174222505],
              [31.514362116647238, 2.722580085442505],
              [31.51383927379566, 2.722245703376498],
              [31.512792534368714, 2.722818559389571],
              [31.512127917602392, 2.721385771442711],
              [31.51060609425599, 2.72138546905187],
              [31.508705160300103, 2.719761415609234],
              [31.50685083273782, 2.7192835135218],
              [31.503949510627017, 2.719712711774663],
              [31.503379385848817, 2.719044033895082],
              [31.50361839520655, 2.717563684298016],
              [31.502429866593474, 2.717085895298004],
              [31.502049255797495, 2.717276837381871],
              [31.502000476379244, 2.718757223222969],
              [31.500670330158275, 2.719383981926469],
              [31.498258285348438, 2.716841308669253],
              [31.497028189890568, 2.717081073178868],
              [31.496008938013006, 2.716627364084514],
              [31.495952443863075, 2.713792006573797],
              [31.49493248590973, 2.713911371839243],
              [31.493610953634, 2.715327363003798],
              [31.49292104030928, 2.715356662758793],
              [31.49265457214823, 2.712551211362226],
              [31.49057072413252, 2.711915173627991],
              [31.49039127397641, 2.711492682685359],
              [31.491022293751122, 2.710588601714105],
              [31.490693435796963, 2.709713470905219],
              [31.489705080575273, 2.708535890713272],
              [31.489343494300396, 2.709862594987008],
              [31.488683499366203, 2.709952242608221],
              [31.487904470470323, 2.709287695035067],
              [31.487489004143004, 2.705697833067365],
              [31.485509447836815, 2.705635016611116],
              [31.483397987405922, 2.703098714115682],
              [31.48171951584027, 2.702131412733522],
              [31.481720229102596, 2.701558323490276],
              [31.48346082905161, 2.700806457845615],
              [31.48424191958103, 2.699812062807265],
              [31.485801620391406, 2.699814018960917],
              [31.486072210022975, 2.699301606203949],
              [31.485473252917398, 2.698546792366759],
              [31.484123102113376, 2.69887688820738],
              [31.483703668825733, 2.698484252812128],
              [31.48382514440834, 2.697277911588065],
              [31.48481599245494, 2.696434593759778],
              [31.48492400229145, 2.693991575653837],
              [31.48405711995743, 2.691607648627069],
              [31.48237832230333, 2.690911823737886],
              [31.481388068043145, 2.691272527592601],
              [31.482019959183674, 2.689644542113021],
              [31.4818723740673, 2.687713966828154],
              [31.48103295412985, 2.687381129319282],
              [31.481559446836403, 2.686084809176155],
              [31.480331679811737, 2.684484652834269],
              [31.47850307101599, 2.68366798134731],
              [31.47733500333017, 2.682309211997386],
              [31.4763149510537, 2.682519069898141],
              [31.475325911315746, 2.681914590856685],
              [31.474545730779724, 2.682185069827582],
              [31.471698029108232, 2.680824186510221],
              [31.470544732420617, 2.679646411468618],
              [31.471085930548355, 2.678591405817323],
              [31.470546530847805, 2.678198624807454],
              [31.46985638665607, 2.678439055579504],
              [31.469854399582655, 2.680037656677776],
              [31.468534531885144, 2.680156644786738],
              [31.46787387938418, 2.680789221962347],
              [31.466285540282527, 2.679731537859708],
              [31.467485543076734, 2.679521916376761],
              [31.46736635909643, 2.678888360452679],
              [31.464967033532687, 2.67876468634404],
              [31.464815750052338, 2.67982017191916],
              [31.463378281206047, 2.678038788958954],
              [31.463017383938972, 2.678822549109316],
              [31.461727892772778, 2.678639956958435],
              [31.461010049927573, 2.677040446830157],
              [31.461849559696564, 2.677282805304555],
              [31.462390007731056, 2.676831051015067],
              [31.4620304992594, 2.676498822527308],
              [31.462032004835834, 2.675292333952537],
              [31.46149228264009, 2.675171002426049],
              [31.459916957431965, 2.675711935469602],
              [31.4598258413127, 2.676616679440365],
              [31.459105139129928, 2.677309499218404],
              [31.459884657607628, 2.677551783160824],
              [31.459463660353077, 2.678425950915122],
              [31.45808430981073, 2.678152744115143],
              [31.456765887502524, 2.677125569813038],
              [31.45418574724178, 2.677695372832813],
              [31.454067133691666, 2.676609385899523],
              [31.453047100279832, 2.676819224138654],
              [31.452205279145605, 2.678416745166494],
              [31.450616127068653, 2.678022618996632],
              [31.44929589555345, 2.678443212030125],
              [31.44929426241626, 2.679740174689357],
              [31.44866322108202, 2.680674389460587],
              [31.448185839272057, 2.678683089099274],
              [31.447258071823, 2.677083328670885],
              [31.4456662194103, 2.678830678951894],
              [31.44572579567997, 2.679162541592607],
              [31.446745562292165, 2.679163842725992],
              [31.446894614357365, 2.679887919653154],
              [31.446383585250114, 2.680792121242622],
              [31.44518545813826, 2.679523791802946],
              [31.444856899323064, 2.678437550750548],
              [31.443987489129846, 2.67813481268744],
              [31.443958099847006, 2.67765218502245],
              [31.444648363514695, 2.677321294683373],
              [31.444558911075358, 2.676898908389291],
              [31.442314808104513, 2.676856965154594],
              [31.441972250842284, 2.672174856587926],
              [31.440394013296025, 2.668686963340939],
              [31.433656513019503, 2.662729639978961],
              [31.431097723018148, 2.659922518794011],
              [31.425680838735776, 2.652640750913429],
              [31.423653741788133, 2.646575804552985],
              [31.420492586472978, 2.643389028720621],
              [31.41515174368111, 2.635652714772396],
              [31.414778587105317, 2.632772633728026],
              [31.415760764612802, 2.630803633822109],
              [31.412451333376875, 2.625722208874682],
              [31.411399934388548, 2.622841264965141],
              [31.41170692106048, 2.618446478306783],
              [31.412705137089038, 2.617007451214231],
              [31.41658163883121, 2.607275261326098],
              [31.419753342164416, 2.601974724248998],
              [31.432545627593083, 2.586645390702628],
              [31.44393124471161, 2.581354882684817],
              [31.454834429691623, 2.569887510731031],
              [31.45868115946865, 2.567012521283861],
              [31.461301282844367, 2.563408190803226],
              [31.458652456498694, 2.567057775170975],
              [31.45480580397678, 2.569933032842405],
              [31.44678749205639, 2.578567696157474],
              [31.44793746048586, 2.579204869309074],
              [31.449938138879332, 2.577484469568458],
              [31.450437566244666, 2.577664548523534],
              [31.45111419258805, 2.578885735804525],
              [31.450042681218815, 2.579566387172754],
              [31.45150529480823, 2.580106582694228],
              [31.45214553399268, 2.581902014374259],
              [31.451716216541985, 2.582762911969573],
              [31.45189400481483, 2.583301532088579],
              [31.451108492777568, 2.583587702903131],
              [31.452284157515777, 2.585312003460179],
              [31.452211457758143, 2.586388718122008],
              [31.453601519811944, 2.587897919987807],
              [31.455064797256348, 2.587899714786036],
              [31.455316057837933, 2.586715548535664],
              [31.456422345686736, 2.586788702783108],
              [31.458244208134683, 2.585391102172084],
              [31.459492172880218, 2.586361731503318],
              [31.460135102518947, 2.585931798658105],
              [31.46284643813365, 2.586832439361458],
              [31.464595219039964, 2.58683457068616],
              [31.465735961771507, 2.587948649061556],
              [31.466161637452043, 2.590102754117312],
              [31.4651268114824, 2.589957920425111],
              [31.464804864267713, 2.590567715449024],
              [31.466336802644232, 2.592830856802148],
              [31.468193060686072, 2.592510068337662],
              [31.46819578258138, 2.590248804663903],
              [31.469053246977957, 2.589496095275555],
              [31.473014088847247, 2.590111084658813],
              [31.473371329072798, 2.589824370595784],
              [31.472694167333543, 2.589033899332121],
              [31.473123307816113, 2.588316552120487],
              [31.47542625672626, 2.587529690154024],
              [31.47656729769847, 2.588392503467529],
              [31.47731854799077, 2.586921787181845],
              [31.47763867971026, 2.587819503455593],
              [31.478672963995788, 2.588430944440577],
              [31.478601065535397, 2.588861588075296],
              [31.47795856349475, 2.588932594724584],
              [31.476992358033026, 2.591085033436125],
              [31.477169479755926, 2.592197934279644],
              [31.478167291542597, 2.593455410798005],
              [31.479061188013823, 2.592092544080542],
              [31.4806307226816, 2.592776416295496],
              [31.480347268276834, 2.591053184821142],
              [31.481990081217308, 2.590157835480787],
              [31.48231060100901, 2.590732518849542],
              [31.482628262361448, 2.593712055024721],
              [31.48241245379255, 2.595111640463009],
              [31.48044914711152, 2.595396415854821],
              [31.4799490163653, 2.595790646275138],
              [31.479769188018473, 2.59693901152762],
              [31.48091114796722, 2.597048071658601],
              [31.481390644411352, 2.5989868977151],
              [31.482423726751023, 2.60060334959362],
              [31.482887747019458, 2.600568024729148],
              [31.483174010456118, 2.599958178891256],
              [31.483068991111214, 2.598235160916307],
              [31.484460700675225, 2.598416311998801],
              [31.484534261917204, 2.596585830912303],
              [31.485925842123834, 2.596874667571498],
              [31.485995516355615, 2.598310486185808],
              [31.48813453889605, 2.600323108991865],
              [31.48877743529712, 2.599929055875056],
              [31.489421322539958, 2.598709443154822],
              [31.49113475743481, 2.598460250985743],
              [31.493671288081757, 2.596345570078078],
              [31.494921016220154, 2.595880456518293],
              [31.496973004586007, 2.596062385081124],
              [31.498006665440748, 2.597212212836406],
              [31.499112436758253, 2.597751940474063],
              [31.499256557072552, 2.596603510450846],
              [31.4998280823243, 2.596209363741661],
              [31.502761542562695, 2.596604703086067],
              [31.502856309435256, 2.597034514748087],
              [31.50157050136177, 2.599469817956084],
              [31.501426508608258, 2.601188967393086],
              [31.502115918876406, 2.601308462900526],
              [31.503401169994426, 2.599589481438478],
              [31.505017581448705, 2.600067264785755],
              [31.505682752475536, 2.600783686403465],
              [31.506774045645628, 2.603887919621199],
              [31.50672559950236, 2.605034042111998],
              [31.507532610919327, 2.606801098970955],
              [31.510098902751643, 2.608807193205369],
              [31.510764572343465, 2.608902802315237],
              [31.51124120495848, 2.60747022007295],
              [31.510909778720958, 2.605607708253498],
              [31.512099120309337, 2.604939318429227],
              [31.51266956668444, 2.60517816603707],
              [31.51314419695469, 2.606324365426161],
              [31.513284936010248, 2.608807661639957],
              [31.51561284101729, 2.611625544656254],
              [31.516136074636, 2.611434607724223],
              [31.516565207033764, 2.609954251673687],
              [31.519133603618783, 2.609238285759798],
              [31.522770991798648, 2.609787974588079],
              [31.523153251003166, 2.607400252740917],
              [31.524247401714188, 2.606827338528181],
              [31.526386631765487, 2.60768721946419],
              [31.526624228073292, 2.607926041423803],
              [31.52624292377789, 2.609072115368198],
              [31.5282395965835, 2.609788714032143],
              [31.528999609941426, 2.610887197173614],
              [31.531709457946032, 2.611794896827211],
              [31.5331368234403, 2.610792227151318],
              [31.533707132373177, 2.611222091405596],
              [31.535276284358623, 2.61136556581409],
              [31.53679706116774, 2.612607397107486],
              [31.537985812562997, 2.612703060668462],
              [31.539555512520803, 2.612130198228554],
              [31.540815488639996, 2.612393016228128],
              [31.541387023773208, 2.611199188408384],
              [31.54219561892002, 2.610960516036105],
              [31.54414499093434, 2.611390550735474],
              [31.54495447451495, 2.609957971328015],
              [31.545572710364834, 2.609910291550453],
              [31.546712467644497, 2.611963927712588],
              [31.547378177660523, 2.612011768940999],
              [31.548472508932893, 2.611200045408717],
              [31.550279658773107, 2.611056990956388],
              [31.551614756507938, 2.60623378596943],
              [31.551615073613245, 2.605803975648047],
              [31.550379326853868, 2.604944241494376],
              [31.551093333892844, 2.603989186236717],
              [31.55266324136148, 2.603129769417178],
              [31.553280799881655, 2.603989436607908],
              [31.553041224585243, 2.60642496957493],
              [31.553705804520654, 2.608000983828118],
              [31.555844650092993, 2.609433910061184],
              [31.55886405395126, 2.609792403175939],
              [31.559576233816937, 2.611320675154609],
              [31.560811753302517, 2.612514725409509],
              [31.561382799752206, 2.61198946720413],
              [31.561383383657155, 2.611177614434332],
              [31.562430280289263, 2.610222600701395],
              [31.562099122647997, 2.607882513769159],
              [31.56233731274218, 2.607309461578681],
              [31.56590427030885, 2.606736747441638],
              [31.566663240722704, 2.609315678841328],
              [31.56737592454325, 2.610175371420248],
              [31.57069932637851, 2.617530164149484],
              [31.571792830302485, 2.617864579203526],
              [31.572506385488882, 2.617530355290995],
              [31.57469375176468, 2.617721608069772],
              [31.580280178683875, 2.619417509337522],
              [31.581610703993917, 2.620802578052579],
              [31.582227734304695, 2.622426353159699],
              [31.58294079002777, 2.622808470424036],
              [31.584367492565384, 2.622713100178484],
              [31.586033634753743, 2.62032542177732],
              [31.590028282922106, 2.620278015196101],
              [31.5931189339622, 2.620851373751442],
              [31.594547811321082, 2.617747286537688],
              [31.594786706592785, 2.61617133746029],
              [31.594502193972644, 2.615025154232153],
              [31.594930764923355, 2.614213308809779],
              [31.595406311475184, 2.614213363549973],
              [31.59975638976381, 2.620346132318291],
              [31.600564471972582, 2.620823770476386],
              [31.60907615391838, 2.621827321429132],
              [31.611646102792214, 2.619057579580085],
              [31.618565541558144, 2.618843145960661],
              [31.625174228812813, 2.621040402326587],
              [31.62716855881213, 2.625386455246195],
              [31.62845214804689, 2.626007384736559],
              [31.632733023719283, 2.624765930162452],
              [31.63670337515414, 2.625601899082584],
              [31.63684509786496, 2.62698687031368],
              [31.63579637226293, 2.630616407742985],
              [31.636176323695498, 2.631332800244454],
              [31.63703220436223, 2.631523875027217],
              [31.637602948977996, 2.631428394173687],
              [31.638317892959776, 2.629088297512546],
              [31.639222372483378, 2.627751132447239],
              [31.639555301602414, 2.627703383351996],
              [31.639935098524756, 2.628658559639367],
              [31.640410592974316, 2.628754106212942],
              [31.642028253985124, 2.627655754502572],
              [31.64431115159982, 2.627369321800377],
              [31.64649735006576, 2.629423002017988],
              [31.64882757182791, 2.62947087039759],
              [31.65058762030285, 2.62880233895038],
              [31.652204566254667, 2.6287546392507],
              [31.652823114718277, 2.628277099244453],
              [31.653157878197117, 2.625507144647528],
              [31.654157197356856, 2.624552007229164],
              [31.655131986221114, 2.624719200368648],
              [31.655844825450192, 2.625483371460307],
              [31.657841592578905, 2.626390841579464],
              [31.664737184667317, 2.62653435014545],
              [31.66549846914136, 2.625961260715289],
              [31.66545175135668, 2.624719546754588],
              [31.663644906943674, 2.624241919955114],
              [31.663741085967878, 2.622618144512653],
              [31.667597598398366, 2.61588432242214],
              [31.675510432833068, 2.624027300570431],
              [31.677886230621155, 2.627131666538756],
              [31.678693079443047, 2.62961511624707],
              [31.68102368388753, 2.629137582851716],
              [31.682213974995182, 2.627036231115008],
              [31.682784840883524, 2.626749682509768],
              [31.685923512265422, 2.626893010662911],
              [31.69124847823296, 2.629089970209717],
              [31.695980791471605, 2.6285407869955],
              [31.696739872378277, 2.631406320714346],
              [31.699021867186087, 2.632600301548167],
              [31.69987644709229, 2.634892736121629],
              [31.70187337681607, 2.6356568938012],
              [31.702889657964967, 2.635347667168915],
              [31.703310728881377, 2.633916574316752],
              [31.7006922018119, 2.631183479078964],
              [31.70069342172406, 2.63000659625596],
              [31.701208776219396, 2.629583448979759],
              [31.701163571197693, 2.628029927541652],
              [31.70181953269625, 2.627418631436447],
              [31.705281672140593, 2.62916403910471],
              [31.707434503583617, 2.629589953112927],
              [31.708274079827923, 2.632509500547385],
              [31.708881975170588, 2.633122117773479],
              [31.710754149562636, 2.6333594416627],
              [31.715202437966333, 2.632093035022146],
              [31.715763950595928, 2.632281912932929],
              [31.716885722705268, 2.633930716808775],
              [31.720911953842382, 2.633417044524205],
              [31.724653286083797, 2.636857432086456],
              [31.725026424693244, 2.638175940171907],
              [31.726640630783482, 2.638930809926272],
              [31.733427291363896, 2.639832219340376],
              [31.745762338804518, 2.639515277328519],
              [31.746930582560136, 2.641540728979635],
              [31.748944708733394, 2.640318794936681],
              [31.754094415185673, 2.639853234660503],
              [31.75577938157081, 2.640090311388699],
              [31.756808580493534, 2.640750421320496],
              [31.757511173538482, 2.640327441913369],
              [31.75961777498204, 2.640235409398828],
              [31.763267386537976, 2.641933810615308],
              [31.764085707744368, 2.642829085293252],
              [31.766426010400647, 2.643113885730591],
              [31.767175597013054, 2.64250264638732],
              [31.767269784472298, 2.641937813740344],
              [31.766476033985548, 2.639865659534291],
              [31.767600255800673, 2.639113564095112],
              [31.767975534197145, 2.638313640544288],
              [31.77293787453902, 2.63798904722565],
              [31.773360574101, 2.636577169084032],
              [31.77284799360327, 2.634175745329009],
              [31.77392553087141, 2.633282365043744],
              [31.77757636144117, 2.63375674260868],
              [31.7780433775911, 2.634887034260915],
              [31.77762018754897, 2.636816766235438],
              [31.781154662034922, 2.636631944201743],
              [31.781857662915026, 2.635785264549553],
              [31.78368421816201, 2.634845519437679],
              [31.783778533181994, 2.634139461229005],
              [31.781064974236948, 2.632583260544925],
              [31.78008312191961, 2.631358312419613],
              [31.780270738659972, 2.630981877215803],
              [31.780785936848446, 2.630699924043655],
              [31.783734094423213, 2.631691431564228],
              [31.785279234441145, 2.631316336231593],
              [31.786028906393515, 2.630610927512762],
              [31.787995223329013, 2.630377451915011],
              [31.790944256761193, 2.630474481707456],
              [31.794511019393422, 2.631430291209716],
              [31.797339569881355, 2.629421766340214],
              [31.798965249254387, 2.626161021085106],
              [31.80165222076198, 2.625131548517158],
              [31.80538685606293, 2.624864964224388],
              [31.807005321964237, 2.625507905619251],
              [31.808209353702456, 2.627715147882125],
              [31.81077730112986, 2.626614127372217],
              [31.814395685449863, 2.628568102044328],
              [31.81463268976791, 2.62782770508575],
              [31.813823177441193, 2.627279416892464],
              [31.814630601184895, 2.62610863341389],
              [31.81615255568534, 2.62562950943114],
              [31.817542790215647, 2.624422293751949],
              [31.81842323711047, 2.624612360945311],
              [31.820563423867547, 2.623893802814893],
              [31.821703872849973, 2.622698771802869],
              [31.822798575126548, 2.623007985417226],
              [31.824751536808733, 2.624820467097819],
              [31.827761351151352, 2.625163442932668],
              [31.82878547818596, 2.626117368431635],
              [31.831590645527044, 2.624466907551194],
              [31.83228171767849, 2.625421202401961],
              [31.832900156547623, 2.625348906492833],
              [31.833803052341374, 2.6244406513129],
              [31.833968062977604, 2.623198924175743],
              [31.83441952928994, 2.622768663799582],
              [31.83940508748863, 2.624064497593178],
              [31.840021533894497, 2.622368634927128],
              [31.84104330734305, 2.621412484666952],
              [31.84380118197771, 2.620000799549931],
              [31.845846741999367, 2.619712051657588],
              [31.84628786331289, 2.620535297370865],
              [31.846195505721905, 2.622803618321524],
              [31.846934421247063, 2.623948871033406],
              [31.846959901061766, 2.625309768491724],
              [31.848174691023857, 2.626526136503502],
              [31.851303276121754, 2.626701788899422],
              [31.852705941538996, 2.62593621955008],
              [31.853942948634675, 2.625887112661551],
              [31.85410886028113, 2.625385528260539],
              [31.85356059600536, 2.624502717222152],
              [31.853487894451096, 2.623428373701995],
              [31.855627844052936, 2.622518714530613],
              [31.857079062512973, 2.622541009798511],
              [31.857196700492675, 2.62149032837703],
              [31.85859913234794, 2.62055759805838],
              [31.859908298415462, 2.621129190450783],
              [31.860764316524413, 2.620793988372588],
              [31.861704325315813, 2.621043647236417],
              [31.860612379070535, 2.62295495060712],
              [31.862063831990845, 2.623168224114874],
              [31.862422415197763, 2.624552663208823],
              [31.863112386912963, 2.624599654144391],
              [31.862947021442206, 2.625530993213576],
              [31.863565947198232, 2.625840714039988],
              [31.864683118136707, 2.625075440295904],
              [31.86461112355659, 2.624574115807246],
              [31.865562453815517, 2.624358178238492],
              [31.865847359897757, 2.62390421503911],
              [31.866799083618773, 2.623998670770342],
              [31.865988815808926, 2.622877374405628],
              [31.86655847615813, 2.621850062704685],
              [31.867320036414988, 2.622064109040505],
              [31.86760476552913, 2.621466889834407],
              [31.867961467663825, 2.62134711805804],
              [31.86887861882282, 2.622336964783988],
              [31.870163554632196, 2.622550419666744],
              [31.871399034591903, 2.621283606320534],
              [31.87273136641397, 2.621353754148274],
              [31.873229961041062, 2.620565271519256],
              [31.874967389937115, 2.621160255793483],
              [31.876988359476194, 2.620226826172865],
              [31.880520439053626, 2.619637890670134],
              [31.881422001747488, 2.617702894151233],
              [31.881158192599678, 2.616031851553855],
              [31.881419344530872, 2.615601786138901],
              [31.88591457709469, 2.614761065196251],
              [31.886198144687153, 2.61325653223678],
              [31.887887751769096, 2.613660525954379],
              [31.88944416654213, 2.612614936009818],
              [31.891490211654084, 2.612307440111935],
              [31.891847573152184, 2.612712929172498],
              [31.892561278357228, 2.612712118837022],
              [31.892895299827636, 2.61347578036281],
              [31.895012780767573, 2.613592781779329],
              [31.895371489738615, 2.615048827111428],
              [31.897061319602738, 2.615619962558543],
              [31.89706431997578, 2.617959853798991],
              [31.898183766346868, 2.618985277918962],
              [31.899016572887216, 2.619103704753305],
              [31.898588807725336, 2.619462335096118],
              [31.89938717734926, 2.620547813072056],
              [31.90138539705378, 2.620426172871019],
              [31.90405229480803, 2.622285511119456],
              [31.904053184140157, 2.622977929666327],
              [31.90557775633134, 2.624528176591898],
              [31.9053885351999, 2.625387942192239],
              [31.905841101050154, 2.62581720917336],
              [31.905555991948635, 2.626104043356763],
              [31.906484428642525, 2.626580525295732],
              [31.906759348153766, 2.627618847437539],
              [31.909923347535102, 2.627519722062095],
              [31.910422023908893, 2.626802871506758],
              [31.913276007499153, 2.626131052455098],
              [31.914132622987772, 2.626249465152301],
              [31.915371322509476, 2.62748963052484],
              [31.917691739160315, 2.628143580406189],
              [31.9201887232735, 2.627352788637648],
              [31.92047513313555, 2.62806875406998],
              [31.921879714659276, 2.628783441236847],
              [31.923119228952913, 2.630644397567551],
              [31.923690328403236, 2.630739242246819],
              [31.92369162287555, 2.631742076312785],
              [31.927702906046356, 2.633707278876195],
              [31.931604795076794, 2.633869914860258],
              [31.935076298559647, 2.632385537329833],
              [31.93732400916467, 2.631988965506526],
              [31.93915607108433, 2.632130097199405],
              [31.940655865943338, 2.632868526370049],
              [31.944153202278827, 2.63293609182225],
              [31.94478590280144, 2.634642539813263],
              [31.945999234797807, 2.634641129154326],
              [31.949141704256743, 2.636213326380156],
              [31.951737891123397, 2.638478596506977],
              [31.95312018813986, 2.640315498030053],
              [31.953917485175342, 2.640541407006539],
              [31.957466437808755, 2.643641249505596],
              [31.958613181286378, 2.64724532610047],
              [31.96105663209684, 2.650931456132372],
              [31.961081760670282, 2.651934257741885],
              [31.961844246191884, 2.652816810605828],
              [31.963415388844027, 2.653507399502307],
              [31.965222898908646, 2.653027728826253],
              [31.9779308540917, 2.646625581848167],
              [31.983600522498392, 2.643216328299844],
              [31.991077618324745, 2.637858407272657],
              [31.997416060002568, 2.634493901939855],
              [31.99932636698011, 2.633093849820835],
              [32.00186767935934, 2.630465501738536],
              [32.00311038806212, 2.628277702277313],
              [32.005555842115676, 2.62612926309562],
              [32.00641647666688, 2.624229150334275],
              [32.007791902469776, 2.62319344750246],
              [32.008635592099765, 2.618557185055291],
              [32.00965435619214, 2.61826213275324],
              [32.01056512482105, 2.617229364795369],
              [32.01188157712382, 2.616700300986241],
              [32.013493063115384, 2.618724166317352],
              [32.014464264108405, 2.619208128011232],
              [32.01461111530114, 2.621096707254112],
              [32.01319148969133, 2.62427736260689],
              [32.01364929271969, 2.624848573710794],
              [32.01412752703087, 2.628210222720264],
              [32.01347461800765, 2.629728853319934],
              [32.01364872408613, 2.63104493977605],
              [32.0131660610806, 2.63213380242994],
              [32.013126899924096, 2.63377958147987],
              [32.0117292740556, 2.634012263168588],
              [32.01115969096151, 2.634500335155501],
              [32.010103137440076, 2.634131058292899],
              [32.00979003054613, 2.634475332748483],
              [32.01010610906704, 2.635476212935346],
              [32.009708975558055, 2.636536240296091],
              [32.010482657681344, 2.638022447985163],
              [32.009173992873734, 2.646254329916502],
              [32.01090490000083, 2.648353374385491],
              [32.013934006562486, 2.650406043615816],
              [32.01476463917983, 2.651834858818433],
              [32.01505843139689, 2.655669264153073],
              [32.016462512558995, 2.658355866752873],
              [32.01617970224632, 2.659501442033741],
              [32.01683749900301, 2.660186603625277],
              [32.01730116353856, 2.663419495581754],
              [32.017932196788, 2.664906102609371],
              [32.03178346478259, 2.663967789331102],
              [32.03563347430875, 2.663013053023971],
              [32.0397574430471, 2.663359830222182],
              [32.04055545154828, 2.662928377735939],
              [32.04149783548528, 2.663269323112937],
              [32.04249507235017, 2.662608377205301],
              [32.04503422068786, 2.662429868258642],
              [32.04651640497404, 2.661710388014604],
              [32.04972500660756, 2.661029218667599],
              [32.05606124651463, 2.661756400333457],
              [32.05717299522206, 2.661266861154462],
              [32.05791552916119, 2.661551075866087],
              [32.0594842077345, 2.661232038727899],
              [32.06028213808224, 2.660771961031305],
              [32.06088718576544, 2.663374844597282],
              [32.06048848379795, 2.663719370255885],
              [32.05968983659463, 2.663864618042945],
              [32.05846151800434, 2.663266873361141],
              [32.05669309902762, 2.663586444789916],
              [32.056780876108974, 2.664559322257201],
              [32.05720966085869, 2.664901621274455],
              [32.057128531310426, 2.666905304886311],
              [32.057558977943444, 2.667991752664646],
              [32.05643285888642, 2.668438399849247],
              [32.05592346561132, 2.670328751758325],
              [32.057414672576215, 2.673644787677308],
              [32.05624776102212, 2.674993094724553],
              [32.05746184670502, 2.675605195565053],
              [32.05600952511385, 2.676925653459596],
              [32.055754881476894, 2.677899446410445],
              [32.05609845293708, 2.678413700512511],
              [32.0571541665337, 2.678382255239498],
              [32.0574715601882, 2.679955561498144],
              [32.058042952489274, 2.680268863407341],
              [32.05893142493283, 2.682012365871817],
              [32.05970192791832, 2.682038925980154],
              [32.059532194838646, 2.682697657580304],
              [32.05987835344687, 2.683072688846226],
              [32.06137552522526, 2.683966360607651],
              [32.06163476643983, 2.685053266157921],
              [32.062918964732354, 2.685107061033316],
              [32.063177569041414, 2.685907760009886],
              [32.06380590824328, 2.686163673562564],
              [32.0635518512062, 2.687395057634178],
              [32.06458121631725, 2.688336789740719],
              [32.064171650124706, 2.69021256349044],
              [32.06651178210107, 2.693381836803876],
              [32.06828031067227, 2.69309088429771],
              [32.069109042454485, 2.693632466249296],
              [32.0699681067506, 2.694975346675399],
              [32.07036746538656, 2.69491703691209],
              [32.071163505678946, 2.693598331194472],
              [32.07190747063432, 2.694512208323483],
              [32.07547865567269, 2.696420229450353],
              [32.07679448903627, 2.697847751861119],
              [32.07765002834317, 2.69761648475337],
              [32.078611514056384, 2.700089627516426],
              [32.0795521471769, 2.699629166915331],
              [32.08078359819255, 2.701600705560919],
              [32.08172610519879, 2.70197025558267],
              [32.08178047303639, 2.700768020354895],
              [32.084266657603244, 2.70236410840671],
              [32.085293929639654, 2.702361344672533],
              [32.08543840568681, 2.703162347260555],
              [32.08693654584906, 2.703172624217288],
              [32.087423262951496, 2.703886841539],
              [32.09013329511071, 2.703507465599352],
              [32.09070064589134, 2.702017631205543],
              [32.09158653388182, 2.702587665767874],
              [32.09249889612205, 2.702241744069367],
              [32.092723823489386, 2.700752835948485],
              [32.09389332758137, 2.700549332401534],
              [32.094209479764146, 2.70155021982142],
              [32.094492829964345, 2.700662194316606],
              [32.09305979160904, 2.697889805642204],
              [32.093344244940376, 2.697488328635263],
              [32.09468586085091, 2.697685058827972],
              [32.0948298931303, 2.698285714650307],
              [32.09571436896916, 2.698226082396956],
              [32.09608403559004, 2.69765266468724],
              [32.095569942329355, 2.69745369208679],
              [32.095611868500285, 2.69706720556731],
              [32.09712366485149, 2.69680552004729],
              [32.09734993699685, 2.695917649901976],
              [32.098320012400805, 2.695857782434392],
              [32.09895031621823, 2.696972304081234],
              [32.09846819220186, 2.69829019317096],
              [32.09929564568144, 2.698259334359702],
              [32.099836330871156, 2.69759957476159],
              [32.100264689819454, 2.697741518185411],
              [32.10312335273402, 2.699994873426449],
              [32.103134537657624, 2.698635327251313],
              [32.10393483506615, 2.699205586833265],
              [32.104587974058084, 2.697801366716551],
              [32.10547399859249, 2.698428639661204],
              [32.10584391763997, 2.697969686825007],
              [32.10569858010844, 2.696796616834266],
              [32.106439470130624, 2.696336663766815],
              [32.107894449836735, 2.696189605450221],
              [32.108508968458, 2.69663157447538],
              [32.10864944340884, 2.695658056687826],
              [32.10967716909448, 2.695855623479817],
              [32.1098498091224, 2.69648481859146],
              [32.11036337686865, 2.69645480859973],
              [32.11002290639284, 2.697314375982422],
              [32.11028095464473, 2.697857480600537],
              [32.110966195831644, 2.698027352166593],
              [32.11116724508044, 2.698599233489339],
              [32.11164942838562, 2.697309953092023],
              [32.112789540499804, 2.696734429836548],
              [32.11307275235942, 2.695789153520167],
              [32.11378549007889, 2.695501007513207],
              [32.114157488726256, 2.695957936027402],
              [32.113216533110545, 2.69627533548161],
              [32.11341791293937, 2.69699032316957],
              [32.114616077780475, 2.696843953176739],
              [32.11740806593805, 2.694861483718659],
              [32.11769022137888, 2.693458258205617],
              [32.11964376966097, 2.692952060324433],
              [32.1212448747211, 2.694321534542858],
              [32.12150046069077, 2.693777033009887],
              [32.12215879913158, 2.69466249989387],
              [32.122327796491035, 2.69368891054025],
              [32.12292592355329, 2.693200713952901],
              [32.12381111445112, 2.69345588837592],
              [32.1237230283493, 2.692368512934974],
              [32.12540603011892, 2.692106325698245],
              [32.12595108022264, 2.693364194537745],
              [32.12675138481768, 2.69393443326001],
              [32.12681152612762, 2.695279486665793],
              [32.12758375028522, 2.696050160884182],
              [32.12878224929962, 2.696046883868061],
              [32.129097842730296, 2.696790188430847],
              [32.128558867932846, 2.698194114497302],
              [32.12947305015984, 2.698649561423316],
              [32.130717658799476, 2.700091547776907],
              [32.130973109123566, 2.699489797221198],
              [32.131429745240354, 2.699517174405833],
              [32.13214568814874, 2.700631462984696],
              [32.13140571710313, 2.701492124832189],
              [32.13257758196768, 2.702318950963334],
              [32.13215137897608, 2.703121517600661],
              [32.132295696021416, 2.70383666905762],
              [32.133695822799666, 2.704619970243504],
              [32.134608737503775, 2.704545884356393],
              [32.134867715511994, 2.705489689441704],
              [32.13546612015366, 2.70511597605639],
              [32.13660886163671, 2.705685279646827],
              [32.13668766365006, 2.706466376734567],
              [32.137824222927286, 2.706812505404851],
              [32.137655890321156, 2.708072316055948],
              [32.13848336895355, 2.708041432368709],
              [32.13865576913131, 2.708556156498457],
              [32.13962644730482, 2.708753852198851],
              [32.13982927791282, 2.710098512315696],
              [32.14526857965309, 2.711471766399899],
              [32.14624195816237, 2.712842939861453],
              [32.14689835714048, 2.712869760413237],
              [32.14781328766408, 2.713640038510219],
              [32.148951547452185, 2.713092699384903],
              [32.14975262639498, 2.713148151244961],
              [32.150154110444916, 2.714005695927989],
              [32.149588053238304, 2.716039390906308],
              [32.15004522834429, 2.716295732405775],
              [32.153299077220346, 2.716601645507587],
              [32.15397452227908, 2.717524929693258],
              [32.154368534142485, 2.717156427088288],
              [32.15608225110833, 2.716980389229168],
              [32.157482176663926, 2.717692089537975],
              [32.15822359938705, 2.717461072977203],
              [32.1600793804235, 2.717856674992056],
              [32.1607661011357, 2.718656198437468],
              [32.16182068644834, 2.718109483417377],
              [32.16278991204603, 2.718507120305893],
              [32.1627881351784, 2.717734337345383],
              [32.16620158593433, 2.71834069995291],
              [32.16840190591655, 2.719793953624429],
              [32.1693719705407, 2.719562702372546],
              [32.170433779206526, 2.722135742656393],
              [32.1720030883972, 2.722045546790853],
              [32.172289178458975, 2.722359605034543],
              [32.1712010069345, 2.726899161211746],
              [32.17186060301672, 2.728299807698634],
              [32.17094934480598, 2.729132365358063],
              [32.170780699586125, 2.730249071756349],
              [32.17083929848872, 2.730907225318918],
              [32.17244046822755, 2.732248025696244],
              [32.17265630913581, 2.733034530620796],
              [32.172345378859795, 2.734323370899169],
              [32.17317698974247, 2.736067028855963],
              [32.1730646257718, 2.736840123959786],
              [32.1736087416276, 2.737668652246879],
              [32.174207494815604, 2.737438020871647],
              [32.17471281243427, 2.739998293052272],
              [32.17406354068964, 2.743062615649057],
              [32.17483669370524, 2.744205359051638],
              [32.17879903576101, 2.747143914876672],
              [32.179542391658615, 2.74916861771081],
              [32.17960427480194, 2.751099853742051],
              [32.180425091528164, 2.752672910066285],
              [32.18271723280712, 2.75628625602427],
              [32.18765782493597, 2.762344902328785],
              [32.18827734178345, 2.762594123041161],
              [32.18979523769544, 2.761940042607475],
              [32.19360541143032, 2.761286034492616],
              [32.1962075119065, 2.759884405557976],
              [32.19847476356388, 2.757794179492642],
              [32.19901662644494, 2.760346784767983],
              [32.19830354107745, 2.761522687337147],
              [32.198117989563954, 2.767072410787498],
              [32.19754749288319, 2.769166083962575],
              [32.19777566496538, 2.769682348450075],
              [32.19653483553815, 2.773109665989557],
              [32.19636363550962, 2.775002585000518],
              [32.196135435579656, 2.775576193613467],
              [32.19533679735947, 2.775977705479586],
              [32.19405319824327, 2.778300802009622],
              [32.191728564900465, 2.779118122468522],
              [32.186993805549314, 2.778917173278408],
              [32.179135773736846, 2.779935007191287],
              [32.17415862556584, 2.778859239063985],
              [32.17278957510655, 2.778228193087055],
              [32.16722772878843, 2.777281442242765],
              [32.15524828124967, 2.777653553015689],
              [32.14446710994312, 2.773666217656083],
              [32.144281927637195, 2.770783820806079],
              [32.14339783448065, 2.769493140177266],
              [32.1414013278634, 2.768976742811823],
              [32.140146423632295, 2.768030197215072],
              [32.13643863448363, 2.76705477319245],
              [32.13330098807945, 2.769807827492373],
              [32.13251627015292, 2.774181512034311],
              [32.1309188329141, 2.776504474815044],
              [32.13089018923295, 2.777881125910786],
              [32.13040525977794, 2.778512046456912],
              [32.12932578125047, 2.782847451450195],
              [32.128308506564856, 2.782656160959695],
              [32.127081969333794, 2.783487778857878],
              [32.125456194739336, 2.783430264783513],
              [32.12480011286654, 2.784175889228538],
              [32.12355937506749, 2.784362189838628],
              [32.12338810586867, 2.785824870315716],
              [32.122760558980836, 2.786398412653031],
              [32.12190461453375, 2.789266351637861],
              [32.120250170206994, 2.790700200070994],
              [32.118381528888925, 2.794872970101936],
              [32.1178679144303, 2.796909214187245],
              [32.11588528768246, 2.799848717623109],
              [32.11465872170532, 2.800708992935951],
              [32.113945461166374, 2.802515771004874],
              [32.11243368098485, 2.803261287326804],
              [32.1112071913645, 2.803318514210245],
              [32.11072221519711, 2.804150180282265],
              [32.1096383439079, 2.804264778414925],
              [32.10909634358459, 2.804838318917501],
              [32.10715678476644, 2.80495281559475],
              [32.10470395823936, 2.80392005264828],
              [32.10360577229612, 2.804421824934571],
              [32.1031495017936, 2.803676086836556],
              [32.101181363074694, 2.804306814984339],
              [32.10083911213797, 2.804106011865741],
              [32.10024005352276, 2.804794263579138],
              [32.09792972225764, 2.804822662992169],
              [32.09664604588629, 2.806113105680774],
              [32.09576182786392, 2.806199036865202],
              [32.09282415812013, 2.804936750529942],
              [32.091840096845495, 2.80518039935339],
              [32.08987208029746, 2.804864664549183],
              [32.08924468252997, 2.804061543769529],
              [32.08818936598871, 2.803946688109125],
              [32.088303557132676, 2.803143665395661],
              [32.08776172659099, 2.802397922894059],
              [32.08642128208356, 2.801537347348747],
              [32.08596486066414, 2.802024840164743],
              [32.0842820421508, 2.801938583872305],
              [32.080018159010336, 2.800317591564251],
              [32.07913392930987, 2.800546904313122],
              [32.0788773093793, 2.799973279161412],
              [32.077337161299376, 2.79954286541154],
              [32.075968347995314, 2.797649805512507],
              [32.075939980096976, 2.796559972213954],
              [32.075027321412705, 2.796158324704777],
              [32.075027491194284, 2.794896406186607],
              [32.073772696557654, 2.793634327498743],
              [32.07157658158932, 2.792945698668059],
              [32.067882857363045, 2.793733859180644],
              [32.067797428477846, 2.792758733659109],
              [32.06736958246756, 2.792873393021163],
              [32.06671366139321, 2.792242341992663],
              [32.0663240333084, 2.792422214333494],
              [32.064754202196546, 2.791160876806698],
              [32.06233705765086, 2.790464351622505],
              [32.05920781768114, 2.787637175037789],
              [32.05752702486879, 2.787543210290399],
              [32.053613645487545, 2.786336099313133],
              [32.04864518582197, 2.786294524185405],
              [32.04816142148189, 2.783908063992669],
              [32.04627933777393, 2.781670750872869],
              [32.04633686408812, 2.778659404225616],
              [32.0456524709108, 2.777856264638935],
              [32.045167571998526, 2.778028263929626],
              [32.044853974624424, 2.777196505799552],
              [32.044183705658334, 2.777239422652003],
              [32.042929019717846, 2.775604483369176],
              [32.04278635826757, 2.775977295431256],
              [32.04130314181712, 2.776550641570938],
              [32.04067593539082, 2.774887127130802],
              [32.03927843348983, 2.774600101965442],
              [32.03879382203845, 2.773051325030071],
              [32.037966783580565, 2.772563637170207],
              [32.03651213086119, 2.772964914079066],
              [32.03588473489034, 2.772477260279614],
              [32.03468672366113, 2.773165369889359],
              [32.03414487335651, 2.772878477101101],
              [32.03311832176893, 2.77155904950503],
              [32.03207731539013, 2.77140114081393],
              [32.03030921801026, 2.770110262562343],
              [32.03028089502768, 2.768905719683998],
              [32.02851277339329, 2.767786919349182],
              [32.02787098192001, 2.768173980680475],
              [32.0270724245482, 2.767973084364136],
              [32.02513289896774, 2.768460296768884],
              [32.023792198440475, 2.769664601427452],
              [32.021538947925116, 2.770065715119524],
              [32.01891482075818, 2.77112637951561],
              [32.011833400475155, 2.779069620248385],
              [32.01127493043943, 2.779713906616268],
              [32.01100121826392, 2.779293247624373],
              [32.00943270767557, 2.779148531464523],
              [32.0089332389877, 2.779578288708261],
              [32.00871957469737, 2.779291323004642],
              [32.008006382430366, 2.779505809069507],
              [32.00786341914616, 2.779935865867313],
              [32.002942483952374, 2.781293924486037],
              [31.999803956300937, 2.782796872235877],
              [31.99310392565324, 2.787023867960789],
              [31.985896107019833, 2.787588544861177],
              [31.97890734526342, 2.789016382859473],
              [31.976411387026282, 2.78867028430296],
              [31.97677920850758, 2.788368850835523],
              [31.975997640074404, 2.786865329672706],
              [31.974894399311022, 2.786989600083877],
              [31.972308904192886, 2.78465915241544],
              [31.97266614352014, 2.784197712262118],
              [31.971938799194163, 2.783807284294579],
              [31.972602106216783, 2.783606209390437],
              [31.972602679341932, 2.782944246517177],
              [31.971891279213942, 2.78260369570484],
              [31.970841140561976, 2.783050046435046],
              [31.969578147001734, 2.782744791910104],
              [31.969507428029303, 2.7822258934012],
              [31.968475596144522, 2.782081859516071],
              [31.967728924565193, 2.781383458179421],
              [31.96742637736739, 2.78147264642208],
              [31.967478865929458, 2.782492472730519],
              [31.967016108692306, 2.782670972862673],
              [31.966286981210455, 2.782258840655361],
              [31.96555243329422, 2.780440983504886],
              [31.964702275794167, 2.78078169734538],
              [31.961348580970927, 2.785962720769153],
              [31.9604070728913, 2.786794350688973],
              [31.958976193187617, 2.787814740350744],
              [31.955588261772263, 2.789098256132745],
              [31.954797272706728, 2.789930012143115],
              [31.947721520793127, 2.791172358909494],
              [31.946441457445875, 2.791852310587001],
              [31.943240278591574, 2.794687352167462],
              [31.9413202437578, 2.795631589285535],
              [31.936729318158374, 2.795551737066114],
              [31.93277754478189, 2.796115714502876],
              [31.930915177297784, 2.797267449142327],
              [31.930380028425137, 2.797304499075831],
              [31.927768773217934, 2.794999659540585],
              [31.925927296954058, 2.794660109059972],
              [31.924894154427285, 2.794934449447086],
              [31.92285439123413, 2.793693757595151],
              [31.92144804272422, 2.793830105133658],
              [31.920739465102837, 2.793003576559981],
              [31.919270403406323, 2.793677932838381],
              [31.917665277486982, 2.793451208203645],
              [31.916818550653005, 2.794001004757284],
              [31.915142104788305, 2.793826032527052],
              [31.91484132996657, 2.793046751243931],
              [31.913710996912556, 2.793045700566357],
              [31.913267349536426, 2.792598774005445],
              [31.912661103500636, 2.793369460848361],
              [31.909228951617127, 2.794218694903389],
              [31.908946781803213, 2.793771917732033],
              [31.90622233797187, 2.793271518161679],
              [31.906027076568442, 2.792572913509476],
              [31.90526133824722, 2.792482654793151],
              [31.904263540833604, 2.79296524252851],
              [31.902643414845663, 2.792354840830331],
              [31.902804533980067, 2.791459579228561],
              [31.90093574084673, 2.790132613087045],
              [31.900456027908593, 2.788896492146037],
              [31.901301423439335, 2.786575101536627],
              [31.900732012821763, 2.786763091294454],
              [31.900006605263524, 2.785903322583087],
              [31.900307744801278, 2.783627024816832],
              [31.899369229009885, 2.782251605180012],
              [31.89851443440635, 2.782723299937075],
              [31.898130374079653, 2.782293395791936],
              [31.898451499335827, 2.781494745860846],
              [31.898076764420136, 2.780222947160449],
              [31.899470493396926, 2.778620845412349],
              [31.89929737816021, 2.778125073748142],
              [31.898175650966593, 2.778841376432676],
              [31.895373188452826, 2.778633784786199],
              [31.893640353541127, 2.778939591291956],
              [31.892672452060143, 2.77863124015934],
              [31.891088076325556, 2.780499618399917],
              [31.89049707559844, 2.780703275243846],
              [31.890367332820286, 2.781241539026469],
              [31.887928484977316, 2.783114299815643],
              [31.8874118746372, 2.782742508393615],
              [31.88543605801756, 2.783056236602526],
              [31.883257885998695, 2.78259003767239],
              [31.87814185558984, 2.784534477096515],
              [31.875483357981807, 2.78438340811905],
              [31.87361925585088, 2.783713279762339],
              [31.873512096718954, 2.784582398568145],
              [31.87339561487102, 2.783614312503358],
              [31.87036435864091, 2.786055032004551],
              [31.868709047439886, 2.786018019400979],
              [31.867475361415817, 2.787043862340547],
              [31.86610153910571, 2.78729043723172],
              [31.864974937653404, 2.78682895055514],
              [31.863389388719042, 2.787500296504773],
              [31.86173459045606, 2.786932048495902],
              [31.860430016576267, 2.788418205959205],
              [31.859372936642103, 2.788912984522193],
              [31.853385770376338, 2.788659227472948],
              [31.849616958670413, 2.788938845995954],
              [31.84390921966196, 2.791093515792682],
              [31.840985269887508, 2.791798913500301],
              [31.833483261083387, 2.791968521380972],
              [31.831669501439293, 2.792966047360131],
              [31.82309924304879, 2.794967752552199],
              [31.822384506577812, 2.795684999656618],
              [31.82302705353424, 2.795757444203454],
              [31.823425341378368, 2.7967328373045],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 537,
        District: "NWOYA",
        County: "NWOYA",
        Subcounty: "ALERO",
        Population: 41809,
        Key: "NWOYAALERO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.009135263806904, 2.600704994274199],
            [32.00839487504468, 2.601365253302726],
            [32.00602808017233, 2.602001196330533],
            [32.003086898914084, 2.600950048135373],
            [32.00191693937624, 2.600895912193789],
            [32.00151641562534, 2.600410429552102],
            [32.000889901800136, 2.600955886553769],
            [32.000399412671854, 2.600268697524525],
            [31.999567316698872, 2.601543183205182],
            [31.998496677593817, 2.601496745993324],
            [31.99742674815783, 2.601975597408622],
            [31.99330091182199, 2.601993826971177],
            [31.991915436566035, 2.601488587825661],
            [31.991916835242954, 2.599728760973508],
            [31.991116909736956, 2.597088374458328],
            [31.989370015292714, 2.593347335697086],
            [31.985728561337886, 2.588211579786319],
            [31.98412564078255, 2.586817093823535],
            [31.975705821456035, 2.581700422565281],
            [31.97429151387274, 2.576335680175179],
            [31.972742455403534, 2.574331875819568],
            [31.970147147089204, 2.567552392774636],
            [31.968144124092877, 2.566381089978262],
            [31.948530892982664, 2.56645740159991],
            [31.94765651420761, 2.568489251704866],
            [31.947013044681384, 2.568996863286621],
            [31.9465924615502, 2.572655962181299],
            [31.946813178513807, 2.573348525501914],
            [31.946511374222766, 2.573700965940091],
            [31.945755595523096, 2.573743291344137],
            [31.945649497301513, 2.574184378615008],
            [31.94528264061083, 2.57404390810508],
            [31.944810895729287, 2.574464929215682],
            [31.943396572874605, 2.574621779179142],
            [31.94332634438232, 2.575095809999879],
            [31.942715592397057, 2.574709005486838],
            [31.94114345441159, 2.575690988002614],
            [31.94030580685018, 2.575216198196098],
            [31.939326115879393, 2.577603381305346],
            [31.93710653781414, 2.580323137180867],
            [31.93696607454139, 2.581271196193242],
            [31.935708967641197, 2.581322814858985],
            [31.93502783894166, 2.581585623114662],
            [31.9348353326712, 2.582129784300169],
            [31.9341197248344, 2.581865797866407],
            [31.9313078964855, 2.582934508824843],
            [31.930045199369303, 2.578394026602667],
            [31.928973516421852, 2.577535708784958],
            [31.927908952623067, 2.574824927318275],
            [31.921677096951985, 2.571199463324736],
            [31.912115796478776, 2.566846921496508],
            [31.90887051393728, 2.564495541300246],
            [31.910537189724945, 2.559792968967315],
            [31.910545222460225, 2.558170678655641],
            [31.912205096204538, 2.556285214812243],
            [31.912430973989476, 2.555229451094526],
            [31.911234470133326, 2.55115545791424],
            [31.91123656500456, 2.548666420499411],
            [31.91154016053628, 2.544367428116272],
            [31.912443014109236, 2.540898622629775],
            [31.913975235455045, 2.540044202383985],
            [31.913385531895234, 2.538326462140021],
            [31.910044641658015, 2.533648237681759],
            [31.907290041382613, 2.532649032601078],
            [31.906027643405412, 2.531432813536808],
            [31.905073466385353, 2.529428293006249],
            [31.905047664075425, 2.527900215560509],
            [31.90585452457541, 2.526418915487077],
            [31.904007071819983, 2.523496203459528],
            [31.9026505007566, 2.523020250153411],
            [31.90279229443432, 2.522303785931737],
            [31.897437052546746, 2.52013727390296],
            [31.8959603246276, 2.518730293378209],
            [31.89658748074826, 2.516258334012265],
            [31.895896237018572, 2.51520857028848],
            [31.893991709801558, 2.514088599954236],
            [31.893976534561492, 2.511593520599163],
            [31.892309206596927, 2.509947980568231],
            [31.891643607073682, 2.510306911649641],
            [31.890382594298643, 2.510117369515039],
            [31.890264367922406, 2.510666670084083],
            [31.889645377487696, 2.510285364695025],
            [31.889477141899583, 2.508972352254582],
            [31.890402464134407, 2.507132787157979],
            [31.889864614926054, 2.505139723863377],
            [31.891171897226393, 2.504326387260243],
            [31.89333303000095, 2.501601938223822],
            [31.895045273729718, 2.501241788698426],
            [31.89478235032079, 2.500287045872433],
            [31.895790988603277, 2.498507062707225],
            [31.8950280512291, 2.49719474925434],
            [31.894852772849177, 2.49559128127417],
            [31.895375763922743, 2.495089070588005],
            [31.895921406914546, 2.493344771660682],
            [31.895597702595165, 2.490610241938989],
            [31.894217578603357, 2.490468535529855],
            [31.89328887331316, 2.489609738506069],
            [31.892360823793148, 2.489467505175929],
            [31.890680649021697, 2.486424044065888],
            [31.89079904787447, 2.485802875630205],
            [31.891631383697614, 2.485348080850254],
            [31.891496900509672, 2.481395175172776],
            [31.889795741093188, 2.481409095875844],
            [31.88907966433584, 2.478901933697348],
            [31.88793707556639, 2.4783061153969],
            [31.887080639740823, 2.478402667555175],
            [31.885854111492925, 2.477078442540108],
            [31.88373622092118, 2.476698725821052],
            [31.88304569314881, 2.476102390480301],
            [31.881571056507642, 2.476653466098141],
            [31.881284719409155, 2.475746138909932],
            [31.880785601962558, 2.47631997557525],
            [31.88011949758614, 2.476416286457187],
            [31.879737684844283, 2.475174686593008],
            [31.880141463191467, 2.474409877858584],
            [31.880139270403856, 2.471997443046848],
            [31.879353381972468, 2.471186246233825],
            [31.878506135912275, 2.468309021348114],
            [31.879480250141746, 2.466803098947891],
            [31.877814244497277, 2.466207900760376],
            [31.877884947300032, 2.465467354822751],
            [31.877337043248662, 2.46470365607186],
            [31.87657606779509, 2.46513448703662],
            [31.875585708432006, 2.461851379844325],
            [31.875775460467793, 2.4612062468791],
            [31.87520357229666, 2.460251487714634],
            [31.874775079499393, 2.459989234733136],
            [31.874299687457803, 2.46049139860102],
            [31.873347328627865, 2.459752049426229],
            [31.872086760518894, 2.460207324161073],
            [31.871277308379312, 2.459635016141769],
            [31.869373826801286, 2.459517788092211],
            [31.868826006293247, 2.458849632528391],
            [31.86932390472602, 2.456938215542687],
            [31.867872160751553, 2.456462172676203],
            [31.86782078699875, 2.452282295854716],
            [31.86765270232761, 2.450586628786232],
            [31.86684221532884, 2.448867806894361],
            [31.867079463988635, 2.448127081712575],
            [31.868007151487582, 2.447911043783769],
            [31.869292197789736, 2.448220067617215],
            [31.871193748888203, 2.446235358432559],
            [31.871908071235854, 2.446855562586754],
            [31.87200459341648, 2.448360232148409],
            [31.872908856446113, 2.448526371071661],
            [31.87326656020234, 2.449433614483643],
            [31.87390929131341, 2.44981503434264],
            [31.87497964565252, 2.449503282493919],
            [31.875836962725412, 2.450386041611338],
            [31.876669771062385, 2.450480612333227],
            [31.87683587854154, 2.450002721022413],
            [31.877977353400055, 2.449404239487721],
            [31.87915584154318, 2.450274699413312],
            [31.880344926213425, 2.449700059937545],
            [31.881748729796126, 2.449770070776768],
            [31.88303289395263, 2.449099769815717],
            [31.884318157647083, 2.449647645369545],
            [31.883890997949713, 2.450842427941955],
            [31.884152841583667, 2.450985429175614],
            [31.887709900614183, 2.451136526681753],
            [31.88797231916992, 2.451900557191269],
            [31.88897222582785, 2.452592067187972],
            [31.889781000637722, 2.452423913001032],
            [31.890066085484712, 2.45194586891281],
            [31.89168466996364, 2.452732186386854],
            [31.892231652343483, 2.452468816345776],
            [31.892943130624925, 2.45000775237452],
            [31.893824854924084, 2.451535406784199],
            [31.89499018903651, 2.451008545914957],
            [31.894465606148252, 2.449767106353116],
            [31.895298333636823, 2.449766120904381],
            [31.897095629856715, 2.450826911175442],
            [31.898118807372057, 2.450945145180171],
            [31.898427282552408, 2.450061006085438],
            [31.899379167071874, 2.450274860962217],
            [31.90042530732252, 2.449509271474495],
            [31.901543748478797, 2.449722929888142],
            [31.902256836541238, 2.449005515812],
            [31.902756856794685, 2.449410973389209],
            [31.905540751131507, 2.449622657330885],
            [31.905981670324124, 2.450446189854902],
            [31.90871576745148, 2.448293220664767],
            [31.909834044216083, 2.448339672327318],
            [31.90926376313102, 2.449128577601679],
            [31.910550235059496, 2.450918481545338],
            [31.91259680568585, 2.45136986686221],
            [31.913216523755985, 2.452563413845247],
            [31.914942990510628, 2.454173666852482],
            [31.91836927100547, 2.454360667237544],
            [31.919035165176133, 2.454049343653803],
            [31.91996427201326, 2.455314196565901],
            [31.921176960815874, 2.454548398154187],
            [31.922462502988058, 2.455335093736276],
            [31.924127862743816, 2.455213666847913],
            [31.924581704201774, 2.457100114558196],
            [31.924890578234137, 2.456645909468467],
            [31.92598503616897, 2.456644600031026],
            [31.927581077425828, 2.458696876438431],
            [31.9284378842556, 2.458982480519805],
            [31.929448832106694, 2.458730453270312],
            [31.92985460381547, 2.460091472907435],
            [31.931759672716602, 2.461832863806877],
            [31.93124731500105, 2.462315266136616],
            [31.932553893920527, 2.463474019505409],
            [31.934374204079653, 2.463706998535572],
            [31.935147985017622, 2.464275878210107],
            [31.93860135510817, 2.463394697078827],
            [31.93939626531993, 2.463711032730299],
            [31.940357844457946, 2.464953551564511],
            [31.94088092626138, 2.465017109591058],
            [31.94240727621849, 2.4665336862395],
            [31.94353290749033, 2.468309483551253],
            [31.943334092351655, 2.469453906107051],
            [31.94427275367011, 2.471246175451374],
            [31.94481405690077, 2.474978939625652],
            [31.945999836669067, 2.477119759637064],
            [31.947381641408747, 2.48164943103377],
            [31.95163288794814, 2.486579517193576],
            [31.95296692297597, 2.488969280500399],
            [31.953556103716334, 2.494742438672445],
            [31.953257535156908, 2.496882075180034],
            [31.952811830638826, 2.497379363499062],
            [31.9533558225271, 2.497728150422472],
            [31.95785755080873, 2.498826573253268],
            [31.95924343749309, 2.498230503693915],
            [31.961371117904775, 2.498132669617587],
            [31.962806912291377, 2.496989223213778],
            [31.96451873021869, 2.497025995835366],
            [31.96587988897821, 2.495575478740296],
            [31.9667528466185, 2.496232336460272],
            [31.967226817525347, 2.495790377209846],
            [31.96800457261011, 2.496233325464337],
            [31.96741239239504, 2.496421000192047],
            [31.96981160566934, 2.49739562999913],
            [31.972928887266022, 2.49624521325734],
            [31.97414654285386, 2.496558406216582],
            [31.974386045386698, 2.495657912537701],
            [31.975579979162845, 2.495766930984483],
            [31.97677430370613, 2.495371566085792],
            [31.978480886251955, 2.496489748527991],
            [31.979520369986343, 2.495601886597958],
            [31.981000619301412, 2.49603537027124],
            [31.981262497969656, 2.497080368588875],
            [31.98248029818629, 2.497213418262998],
            [31.98295696314063, 2.498438720129402],
            [31.983900823907994, 2.497682880651563],
            [31.985333097796968, 2.4984045421082],
            [31.985644319127186, 2.497396016805277],
            [31.985083219722622, 2.497275489439082],
            [31.98548983315281, 2.496435166641233],
            [31.98501276934645, 2.495726256157621],
            [31.985049667646763, 2.494321215728363],
            [31.98593420097778, 2.493072951971478],
            [31.98583958951374, 2.491883974521959],
            [31.98655588096847, 2.492040647814711],
            [31.98679546614631, 2.491020055682752],
            [31.987524303472295, 2.490384135057526],
            [31.987529427462675, 2.489013748234892],
            [31.98833855351381, 2.488942572755429],
            [31.991362582797468, 2.486431865512964],
            [31.993314323669193, 2.485835022106628],
            [31.994005429058294, 2.484495263033055],
            [31.99586131250268, 2.484783889629341],
            [31.99676611002989, 2.484066569853813],
            [31.998525919552932, 2.483880994346466],
            [31.999176764247654, 2.485481354282331],
            [31.998511396489757, 2.486342093426643],
            [31.998559768971162, 2.487130283304621],
            [32.000663627858145, 2.487819994383657],
            [32.001753823286954, 2.488607784005134],
            [32.00160793239324, 2.492724281381115],
            [32.00313033245808, 2.493491319582483],
            [32.003462215039804, 2.49516693901862],
            [32.00403304230056, 2.495550312971379],
            [32.00456730094275, 2.496967530651252],
            [32.00434106023843, 2.497912612023729],
            [32.004812669474376, 2.498297726250681],
            [32.004928597061806, 2.499098779455692],
            [32.004645604391115, 2.500129889831622],
            [32.00584971248615, 2.502731134353765],
            [32.00707786219315, 2.503328863063014],
            [32.00824650659741, 2.502839178470814],
            [32.00981908206242, 2.504351828380276],
            [32.01174413488535, 2.504017498566547],
            [32.014173015021925, 2.505699593174093],
            [32.015892434493175, 2.509072185049277],
            [32.015523010417425, 2.509731484259886],
            [32.01375367785405, 2.509535878844302],
            [32.01387307293844, 2.511882469707269],
            [32.0155160619487, 2.512979932956505],
            [32.015404112999654, 2.513953346958467],
            [32.01626266884931, 2.515124475644606],
            [32.01640730838983, 2.516011337141301],
            [32.0188603738688, 2.51574714598904],
            [32.0196312766046, 2.516002646242251],
            [32.019547350600874, 2.516747009332236],
            [32.01798003836509, 2.517581240670227],
            [32.01756907978386, 2.518798730025024],
            [32.017885425104424, 2.519914082539014],
            [32.01848539820458, 2.520284527807203],
            [32.01925489687358, 2.519910396725793],
            [32.02062546907899, 2.520393248044334],
            [32.021054775749896, 2.52099313689977],
            [32.021430187995335, 2.522995574917448],
            [32.021033142521226, 2.524055617068557],
            [32.021633506388525, 2.524597787857217],
            [32.02216470267391, 2.526098949509755],
            [32.02208380219608, 2.528188476302113],
            [32.02254177680265, 2.528845512362806],
            [32.02214492266969, 2.529991421254472],
            [32.02080646793064, 2.531111233406061],
            [32.01878134547998, 2.531374261047823],
            [32.01792799806236, 2.532521393604416],
            [32.01477676014796, 2.533173830794428],
            [32.01446721327747, 2.535092237434267],
            [32.00969943544971, 2.540099324493009],
            [32.00919233018362, 2.542991367947995],
            [32.00830984590975, 2.543880983448328],
            [32.009613729883405, 2.546439034268647],
            [32.00927576301227, 2.548414769469559],
            [32.010389127788876, 2.54869799286709],
            [32.01075862372987, 2.548067352153514],
            [32.0139781246227, 2.546026643493835],
            [32.016323191044954, 2.548481730972668],
            [32.016667803652574, 2.549482542756524],
            [32.0160733857341, 2.551602069437223],
            [32.01643287713779, 2.552874715653504],
            [32.01449541858077, 2.554081990532132],
            [32.013443981863205, 2.555973755716852],
            [32.01273133307694, 2.556261884548904],
            [32.01236399848254, 2.557865616829572],
            [32.01470422478203, 2.558145566150338],
            [32.01537883889915, 2.559989784584852],
            [32.01732320550071, 2.561873536989082],
            [32.01860408092497, 2.566893047675812],
            [32.018351062340365, 2.568582350203492],
            [32.019323834486805, 2.569781802793083],
            [32.02066560490758, 2.570121650838956],
            [32.020925387806265, 2.571466138817782],
            [32.018688232405836, 2.572631264563855],
            [32.01851889099163, 2.573461714845762],
            [32.0195490978241, 2.574832763487954],
            [32.019550373431805, 2.575405168989919],
            [32.01869627412429, 2.576237450867335],
            [32.016842010342366, 2.576385525764435],
            [32.01683818082431, 2.574668291860463],
            [32.016523891747404, 2.574468773714155],
            [32.01432864814489, 2.575247415433009],
            [32.01412988960006, 2.575677255869301],
            [32.01496011168734, 2.576934346716342],
            [32.0144379811998, 2.579497292369759],
            [32.01566931723112, 2.58149743705644],
            [32.016726915493216, 2.582353231394851],
            [32.01656464382027, 2.586360562190846],
            [32.01541409687574, 2.58861036584517],
            [32.012512137859424, 2.592367411106041],
            [32.00893612796967, 2.594537783788614],
            [32.00928258122528, 2.596368587314219],
            [32.00842736531187, 2.596714317834696],
            [32.009174161757024, 2.598944734683845],
            [32.009135263806904, 2.600704994274199],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 538,
        District: "NWOYA",
        County: "NWOYA",
        Subcounty: "ANAKA PAYIRA",
        Population: 11153,
        Key: "NWOYAANAKA PAYIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.12540603011892, 2.692106325698245],
            [32.1237230283493, 2.692368512934974],
            [32.12381111445112, 2.69345588837592],
            [32.12292592355329, 2.693200713952901],
            [32.122327796491035, 2.69368891054025],
            [32.12215879913158, 2.69466249989387],
            [32.12150046069077, 2.693777033009887],
            [32.1212448747211, 2.694321534542858],
            [32.11964376966097, 2.692952060324433],
            [32.11769022137888, 2.693458258205617],
            [32.11740806593805, 2.694861483718659],
            [32.114616077780475, 2.696843953176739],
            [32.11341791293937, 2.69699032316957],
            [32.113216533110545, 2.69627533548161],
            [32.114157488726256, 2.695957936027402],
            [32.11378549007889, 2.695501007513207],
            [32.11307275235942, 2.695789153520167],
            [32.112789540499804, 2.696734429836548],
            [32.11164942838562, 2.697309953092023],
            [32.11116724508044, 2.698599233489339],
            [32.110966195831644, 2.698027352166593],
            [32.11028095464473, 2.697857480600537],
            [32.11002290639284, 2.697314375982422],
            [32.11036337686865, 2.69645480859973],
            [32.1098498091224, 2.69648481859146],
            [32.10967716909448, 2.695855623479817],
            [32.10864944340884, 2.695658056687826],
            [32.108508968458, 2.69663157447538],
            [32.107894449836735, 2.696189605450221],
            [32.106439470130624, 2.696336663766815],
            [32.10569858010844, 2.696796616834266],
            [32.10584391763997, 2.697969686825007],
            [32.10547399859249, 2.698428639661204],
            [32.104587974058084, 2.697801366716551],
            [32.10393483506615, 2.699205586833265],
            [32.103134537657624, 2.698635327251313],
            [32.10312335273402, 2.699994873426449],
            [32.100264689819454, 2.697741518185411],
            [32.099836330871156, 2.69759957476159],
            [32.09929564568144, 2.698259334359702],
            [32.09846819220186, 2.69829019317096],
            [32.09895031621823, 2.696972304081234],
            [32.098320012400805, 2.695857782434392],
            [32.09734993699685, 2.695917649901976],
            [32.09712366485149, 2.69680552004729],
            [32.095611868500285, 2.69706720556731],
            [32.095569942329355, 2.69745369208679],
            [32.09608403559004, 2.69765266468724],
            [32.09571436896916, 2.698226082396956],
            [32.0948298931303, 2.698285714650307],
            [32.09468586085091, 2.697685058827972],
            [32.093344244940376, 2.697488328635263],
            [32.09305979160904, 2.697889805642204],
            [32.094492829964345, 2.700662194316606],
            [32.094209479764146, 2.70155021982142],
            [32.09389332758137, 2.700549332401534],
            [32.092723823489386, 2.700752835948485],
            [32.09249889612205, 2.702241744069367],
            [32.09158653388182, 2.702587665767874],
            [32.09070064589134, 2.702017631205543],
            [32.09013329511071, 2.703507465599352],
            [32.087423262951496, 2.703886841539],
            [32.08693654584906, 2.703172624217288],
            [32.08543840568681, 2.703162347260555],
            [32.085293929639654, 2.702361344672533],
            [32.084266657603244, 2.70236410840671],
            [32.08178047303639, 2.700768020354895],
            [32.08172610519879, 2.70197025558267],
            [32.08078359819255, 2.701600705560919],
            [32.0795521471769, 2.699629166915331],
            [32.078611514056384, 2.700089627516426],
            [32.07765002834317, 2.69761648475337],
            [32.07679448903627, 2.697847751861119],
            [32.07547865567269, 2.696420229450353],
            [32.07190747063432, 2.694512208323483],
            [32.071163505678946, 2.693598331194472],
            [32.07036746538656, 2.69491703691209],
            [32.0699681067506, 2.694975346675399],
            [32.069109042454485, 2.693632466249296],
            [32.06828031067227, 2.69309088429771],
            [32.06651178210107, 2.693381836803876],
            [32.064171650124706, 2.69021256349044],
            [32.06458121631725, 2.688336789740719],
            [32.0635518512062, 2.687395057634178],
            [32.06380590824328, 2.686163673562564],
            [32.063177569041414, 2.685907760009886],
            [32.062918964732354, 2.685107061033316],
            [32.06163476643983, 2.685053266157921],
            [32.06137552522526, 2.683966360607651],
            [32.05987835344687, 2.683072688846226],
            [32.059532194838646, 2.682697657580304],
            [32.05970192791832, 2.682038925980154],
            [32.05893142493283, 2.682012365871817],
            [32.058042952489274, 2.680268863407341],
            [32.0574715601882, 2.679955561498144],
            [32.0571541665337, 2.678382255239498],
            [32.05609845293708, 2.678413700512511],
            [32.055754881476894, 2.677899446410445],
            [32.05600952511385, 2.676925653459596],
            [32.05746184670502, 2.675605195565053],
            [32.05624776102212, 2.674993094724553],
            [32.057414672576215, 2.673644787677308],
            [32.05592346561132, 2.670328751758325],
            [32.05643285888642, 2.668438399849247],
            [32.057558977943444, 2.667991752664646],
            [32.057128531310426, 2.666905304886311],
            [32.05720966085869, 2.664901621274455],
            [32.056780876108974, 2.664559322257201],
            [32.05669309902762, 2.663586444789916],
            [32.05846151800434, 2.663266873361141],
            [32.05968983659463, 2.663864618042945],
            [32.06048848379795, 2.663719370255885],
            [32.06088718576544, 2.663374844597282],
            [32.06028213808224, 2.660771961031305],
            [32.0594842077345, 2.661232038727899],
            [32.05791552916119, 2.661551075866087],
            [32.05717299522206, 2.661266861154462],
            [32.05606124651463, 2.661756400333457],
            [32.04972500660756, 2.661029218667599],
            [32.04651640497404, 2.661710388014604],
            [32.04503422068786, 2.662429868258642],
            [32.04249507235017, 2.662608377205301],
            [32.04149783548528, 2.663269323112937],
            [32.04055545154828, 2.662928377735939],
            [32.0397574430471, 2.663359830222182],
            [32.03563347430875, 2.663013053023971],
            [32.03178346478259, 2.663967789331102],
            [32.017932196788, 2.664906102609371],
            [32.01730116353856, 2.663419495581754],
            [32.01683749900301, 2.660186603625277],
            [32.01617970224632, 2.659501442033741],
            [32.016462512558995, 2.658355866752873],
            [32.01505843139689, 2.655669264153073],
            [32.01476463917983, 2.651834858818433],
            [32.013934006562486, 2.650406043615816],
            [32.01090490000083, 2.648353374385491],
            [32.009173992873734, 2.646254329916502],
            [32.010482657681344, 2.638022447985163],
            [32.009708975558055, 2.636536240296091],
            [32.01010610906704, 2.635476212935346],
            [32.00979003054613, 2.634475332748483],
            [32.010103137440076, 2.634131058292899],
            [32.01115969096151, 2.634500335155501],
            [32.0117292740556, 2.634012263168588],
            [32.013126899924096, 2.63377958147987],
            [32.0131660610806, 2.63213380242994],
            [32.01364872408613, 2.63104493977605],
            [32.01347461800765, 2.629728853319934],
            [32.01412752703087, 2.628210222720264],
            [32.01364929271969, 2.624848573710794],
            [32.01319148969133, 2.62427736260689],
            [32.01461111530114, 2.621096707254112],
            [32.014464264108405, 2.619208128011232],
            [32.013493063115384, 2.618724166317352],
            [32.01188157712382, 2.616700300986241],
            [32.011151455206985, 2.615682521566317],
            [32.01146069126038, 2.613592411161054],
            [32.01070820668287, 2.608786141467922],
            [32.00876601669925, 2.607904069852058],
            [32.00822136095596, 2.606760695077069],
            [32.008961051727205, 2.605785616916998],
            [32.00895807920194, 2.604440471657467],
            [32.00969662282456, 2.602950233413382],
            [32.009135263806904, 2.600704994274199],
            [32.009174161757024, 2.598944734683845],
            [32.00842736531187, 2.596714317834696],
            [32.00928258122528, 2.596368587314219],
            [32.00893612796967, 2.594537783788614],
            [32.012512137859424, 2.592367411106041],
            [32.01541409687574, 2.58861036584517],
            [32.01656464382027, 2.586360562190846],
            [32.016726915493216, 2.582353231394851],
            [32.01566931723112, 2.58149743705644],
            [32.0144379811998, 2.579497292369759],
            [32.01496011168734, 2.576934346716342],
            [32.01412988960006, 2.575677255869301],
            [32.01432864814489, 2.575247415433009],
            [32.016523891747404, 2.574468773714155],
            [32.01683818082431, 2.574668291860463],
            [32.016842010342366, 2.576385525764435],
            [32.01869627412429, 2.576237450867335],
            [32.019550373431805, 2.575405168989919],
            [32.0195490978241, 2.574832763487954],
            [32.01851889099163, 2.573461714845762],
            [32.018688232405836, 2.572631264563855],
            [32.020925387806265, 2.571466138817782],
            [32.02066560490758, 2.570121650838956],
            [32.019323834486805, 2.569781802793083],
            [32.018351062340365, 2.568582350203492],
            [32.01860408092497, 2.566893047675812],
            [32.01732320550071, 2.561873536989082],
            [32.01537883889915, 2.559989784584852],
            [32.01470422478203, 2.558145566150338],
            [32.01236399848254, 2.557865616829572],
            [32.01273133307694, 2.556261884548904],
            [32.013443981863205, 2.555973755716852],
            [32.01449541858077, 2.554081990532132],
            [32.01643287713779, 2.552874715653504],
            [32.0160733857341, 2.551602069437223],
            [32.016667803652574, 2.549482542756524],
            [32.016323191044954, 2.548481730972668],
            [32.0139781246227, 2.546026643493835],
            [32.01075862372987, 2.548067352153514],
            [32.010389127788876, 2.54869799286709],
            [32.00927576301227, 2.548414769469559],
            [32.009613729883405, 2.546439034268647],
            [32.00830984590975, 2.543880983448328],
            [32.00919233018362, 2.542991367947995],
            [32.00969943544971, 2.540099324493009],
            [32.01446721327747, 2.535092237434267],
            [32.01477676014796, 2.533173830794428],
            [32.01792799806236, 2.532521393604416],
            [32.01878134547998, 2.531374261047823],
            [32.02080646793064, 2.531111233406061],
            [32.02214492266969, 2.529991421254472],
            [32.02254177680265, 2.528845512362806],
            [32.02208380219608, 2.528188476302113],
            [32.02216470267391, 2.526098949509755],
            [32.021633506388525, 2.524597787857217],
            [32.021033142521226, 2.524055617068557],
            [32.021430187995335, 2.522995574917448],
            [32.021054775749896, 2.52099313689977],
            [32.02062546907899, 2.520393248044334],
            [32.01925489687358, 2.519910396725793],
            [32.01848539820458, 2.520284527807203],
            [32.017885425104424, 2.519914082539014],
            [32.01756907978386, 2.518798730025024],
            [32.01798003836509, 2.517581240670227],
            [32.019547350600874, 2.516747009332236],
            [32.0196312766046, 2.516002646242251],
            [32.0188603738688, 2.51574714598904],
            [32.01640730838983, 2.516011337141301],
            [32.01626266884931, 2.515124475644606],
            [32.015404112999654, 2.513953346958467],
            [32.0155160619487, 2.512979932956505],
            [32.01387307293844, 2.511882469707269],
            [32.01375367785405, 2.509535878844302],
            [32.015523010417425, 2.509731484259886],
            [32.015892434493175, 2.509072185049277],
            [32.014173015021925, 2.505699593174093],
            [32.01174413488535, 2.504017498566547],
            [32.00981908206242, 2.504351828380276],
            [32.00824650659741, 2.502839178470814],
            [32.00707786219315, 2.503328863063014],
            [32.00584971248615, 2.502731134353765],
            [32.004645604391115, 2.500129889831622],
            [32.004928597061806, 2.499098779455692],
            [32.004812669474376, 2.498297726250681],
            [32.00434106023843, 2.497912612023729],
            [32.00456730094275, 2.496967530651252],
            [32.00403304230056, 2.495550312971379],
            [32.003462215039804, 2.49516693901862],
            [32.00313033245808, 2.493491319582483],
            [32.00160793239324, 2.492724281381115],
            [32.001753823286954, 2.488607784005134],
            [32.000663627858145, 2.487819994383657],
            [31.998559768971162, 2.487130283304621],
            [31.998511396489757, 2.486342093426643],
            [31.999176764247654, 2.485481354282331],
            [31.998525919552932, 2.483880994346466],
            [31.99809122478698, 2.482532716279552],
            [31.995422956203583, 2.479120289262859],
            [31.993209913382017, 2.478860291770189],
            [31.993363299818476, 2.477582175917484],
            [31.994361364031736, 2.476314940732603],
            [31.994573959326885, 2.474762074984959],
            [31.995073018382975, 2.474164285756122],
            [31.99481046507994, 2.473328581029689],
            [31.995392364076597, 2.472288808782007],
            [31.995531508622513, 2.468657884154142],
            [31.994861512744265, 2.464860787606052],
            [31.995931771861983, 2.464429496143215],
            [31.99669349022233, 2.464762954650273],
            [31.99781367950015, 2.466672463134322],
            [31.99948982802248, 2.465392440057865],
            [32.00029740717471, 2.464006021632596],
            [32.003294020774185, 2.465584637992793],
            [32.00357979552732, 2.465297656791312],
            [32.00315203036544, 2.464531437806936],
            [32.00324817255872, 2.463239091096544],
            [32.00500925140127, 2.463001071706518],
            [32.00558084133174, 2.462331364340467],
            [32.004797020822146, 2.460392127549944],
            [32.00260976503912, 2.457757773967385],
            [32.00218684269492, 2.450481584319035],
            [32.00090136969305, 2.451150755541692],
            [31.999714076263484, 2.450781161439141],
            [31.99987973907661, 2.449785976170545],
            [31.999344090740674, 2.448693151683245],
            [32.00003067401065, 2.447178337200264],
            [32.001593776740975, 2.448015951135758],
            [32.00502144333631, 2.446534612505841],
            [32.00568891764357, 2.444907621857682],
            [32.004739311251676, 2.441891254855687],
            [32.00493045387951, 2.440838302568027],
            [32.00557454054833, 2.438660796423046],
            [32.00671725059032, 2.437943648378489],
            [32.00747995440251, 2.436220963602893],
            [32.007338593712795, 2.434306154104906],
            [32.00771970307376, 2.43377989319057],
            [32.00734094190894, 2.431099027908463],
            [32.00862566391924, 2.431387175115122],
            [32.008959825526865, 2.429999268451149],
            [32.008009212123525, 2.428371056051687],
            [32.00639200296529, 2.427173172369972],
            [32.00492213368332, 2.426845708857515],
            [32.00394102606938, 2.425662477475995],
            [32.002170517611276, 2.426167951632038],
            [32.000543063167235, 2.425413059321109],
            [31.998981466911616, 2.422955930828826],
            [31.996657424660295, 2.420680156682759],
            [31.99615463040924, 2.41917241723998],
            [31.995470144705482, 2.418756083455562],
            [31.995315527577066, 2.418171214124451],
            [31.995949918729053, 2.416430420089976],
            [31.99750091486429, 2.4157168745518],
            [31.997449823182507, 2.414911176033728],
            [31.997992945501625, 2.414287841019679],
            [31.998252405006816, 2.412858634558718],
            [31.996960559356307, 2.412571796481105],
            [31.99693582334663, 2.411064413326808],
            [31.9937720602222, 2.408658077433165],
            [31.993113238487787, 2.408488658550155],
            [31.99231172835364, 2.409085810139239],
            [31.991627104309302, 2.40886439340359],
            [31.991292242914103, 2.407408759084049],
            [31.989458417601515, 2.406211898925643],
            [31.988103427573055, 2.40396283939477],
            [31.985791400288644, 2.402973531659829],
            [31.98337494654739, 2.4034265305821],
            [31.98122796762846, 2.406374663855312],
            [31.980195241021637, 2.405152407350003],
            [31.97578974117158, 2.404668291835526],
            [31.976876160082917, 2.403187744917119],
            [31.97787137753504, 2.40272069425612],
            [31.979008226968133, 2.402916466996508],
            [31.979254177608105, 2.402292917370039],
            [31.978687381986312, 2.400005466833453],
            [31.976569197665512, 2.398990306529947],
            [31.97584652907056, 2.39782026163967],
            [31.97620928495196, 2.396495101100627],
            [31.977372982333975, 2.39532647486783],
            [31.977322073010164, 2.394286880298713],
            [31.97636638592212, 2.393727401508462],
            [31.973936733234403, 2.394583206427332],
            [31.973110726042453, 2.393387095247378],
            [31.969894355778365, 2.392345113566256],
            [31.968358419898863, 2.390238856682447],
            [31.965607328442918, 2.389015298699545],
            [31.963656544277, 2.388792913864755],
            [31.962855833643438, 2.38833750201533],
            [31.960800830531493, 2.389258541299132],
            [31.96023277277675, 2.388686354956848],
            [31.95998842473126, 2.387178820708592],
            [31.958180306507135, 2.386241846966128],
            [31.95701860158846, 2.384772597182664],
            [31.956475985020873, 2.384733199783424],
            [31.95593490906401, 2.382653687757883],
            [31.95455321302044, 2.381652067461852],
            [31.952499312141374, 2.381130723577534],
            [31.951195015840984, 2.38029808656416],
            [31.950109660534938, 2.380388215752133],
            [31.948147252169214, 2.378489537404952],
            [31.945189118803242, 2.377759582075098],
            [31.944659744301237, 2.377304373908259],
            [31.944363227493948, 2.376459514541255],
            [31.94506121307982, 2.376057227771665],
            [31.945475610411957, 2.37479709664058],
            [31.94475305859803, 2.373523098193684],
            [31.943732429603116, 2.373457342279877],
            [31.94207933724089, 2.372585450986584],
            [31.94074836456983, 2.372870299493778],
            [31.937686942912496, 2.372075284402723],
            [31.935724277628594, 2.37055343587076],
            [31.933333507619647, 2.371318245822727],
            [31.930011482901744, 2.373407740372044],
            [31.929598096174306, 2.373342446688313],
            [31.921771100256585, 2.370165735210321],
            [31.918463772875057, 2.369968225540659],
            [31.916604430018516, 2.368537400405859],
            [31.91651122801116, 2.365797443562093],
            [31.918447401078993, 2.365547086438056],
            [31.919660001846722, 2.364851526481692],
            [31.920966937397417, 2.363179112974492],
            [31.921918092484837, 2.362600938131792],
            [31.924344099809133, 2.361978684266653],
            [31.927125831002776, 2.360325500068604],
            [31.92812316668235, 2.35815532437894],
            [31.92969166559261, 2.356555463003711],
            [31.933028543953746, 2.350660282183729],
            [31.93503615644285, 2.348092861508194],
            [31.934914262245336, 2.345035339885415],
            [31.936149956004083, 2.343498524521492],
            [31.938350058593965, 2.343156470929354],
            [31.943038878101486, 2.345086768448245],
            [31.944109177643405, 2.344870486277709],
            [31.94446476586713, 2.343622452968279],
            [31.943655049622873, 2.342617768058749],
            [31.941631300696276, 2.341259380669728],
            [31.94134517470188, 2.340571691918281],
            [31.941439487925244, 2.339594832074768],
            [31.942081075480942, 2.338826436878365],
            [31.94609011376184, 2.339236529777482],
            [31.948659155337236, 2.338949008617188],
            [31.95385922134433, 2.340816336033596],
            [31.95497757356739, 2.340979998151453],
            [31.955691040718875, 2.340672979527424],
            [31.957687691964892, 2.338802012286007],
            [31.96094498767671, 2.336959116686355],
            [31.96245127466028, 2.332365007099998],
            [31.964731659687125, 2.329065004134737],
            [31.965479146936715, 2.327184044007136],
            [31.96678631155777, 2.325846238362026],
            [31.967784902183787, 2.325295183602485],
            [31.970710651283802, 2.324863139114687],
            [31.97256848856391, 2.326800293204462],
            [31.9733539718551, 2.327153653933093],
            [31.976980828186562, 2.326016540688041],
            [31.979551062724674, 2.326796351056632],
            [31.980025320194066, 2.325385555100642],
            [31.979071549212534, 2.323403835279096],
            [31.97842605757858, 2.32025543575105],
            [31.979149791575452, 2.318546309156534],
            [31.98219383083206, 2.317345426651705],
            [31.988844582598208, 2.3183995359893],
            [31.990105068960485, 2.318255708664597],
            [31.992624258529194, 2.315724687696268],
            [31.995498659029217, 2.311583754142052],
            [31.99684197724722, 2.310734402187393],
            [32.00055135641394, 2.309678671497273],
            [32.003834810168506, 2.309680992653362],
            [32.00801091532929, 2.309104999359702],
            [32.01309838829529, 2.306476215688442],
            [32.015884095432384, 2.303710118448761],
            [32.01677751669485, 2.301992021164443],
            [32.017171704628026, 2.299658456700314],
            [32.01861996583415, 2.295724497555748],
            [32.02281789466648, 2.289033425452331],
            [32.02359163428192, 2.279752857272156],
            [32.02562809436977, 2.276524856826332],
            [32.02973254271699, 2.276238173914529],
            [32.03292623321509, 2.27719015707101],
            [32.03845470442545, 2.282259610719528],
            [32.04191539309061, 2.284053035087055],
            [32.047429530782274, 2.283685841486397],
            [32.05324770957005, 2.282504688553909],
            [32.062120763991686, 2.276277843631971],
            [32.0641558568437, 2.275057962744042],
            [32.06751124768619, 2.274164594660581],
            [32.07234898451164, 2.271128266258498],
            [32.07909769396625, 2.265786394664336],
            [32.08475656641987, 2.262687204862482],
            [32.090114188842946, 2.255942221919832],
            [32.09532711962321, 2.252245642440295],
            [32.10080725428474, 2.249499040650905],
            [32.107848616892625, 2.246907154560232],
            [32.109859987932914, 2.244845871271246],
            [32.11077482143846, 2.244647416946204],
            [32.11379414534666, 2.245933814981329],
            [32.12031861823836, 2.245820183703165],
            [32.121768247578665, 2.245124507783614],
            [32.124619247863855, 2.242656625626574],
            [32.125308444332994, 2.242421839537002],
            [32.12934947790934, 2.242921805331226],
            [32.13018086511155, 2.241746300280296],
            [32.13291357793508, 2.240644296593786],
            [32.13697606148382, 2.236195983383436],
            [32.14081392578732, 2.23475085660306],
            [32.14566106977041, 2.231108077131054],
            [32.14760618736354, 2.222958564761941],
            [32.14848517269939, 2.221547863848039],
            [32.15119469012396, 2.221621803360383],
            [32.15437947202938, 2.221089914717936],
            [32.1615701112813, 2.222116267414352],
            [32.16594334364634, 2.222046390644595],
            [32.16894996268149, 2.221523413028675],
            [32.17073231901985, 2.22076453350295],
            [32.17462915862007, 2.218297093387299],
            [32.1769392069159, 2.218144601940782],
            [32.18543879663967, 2.216747159108289],
            [32.18922284556946, 2.217002547505524],
            [32.19039966104952, 2.21768167073833],
            [32.19111296201267, 2.22064021207068],
            [32.19256187988727, 2.223771039376454],
            [32.193738471686814, 2.22487533930749],
            [32.2008432391841, 2.227457440599705],
            [32.20281815030193, 2.22973819859011],
            [32.20601306430548, 2.231350188828559],
            [32.211203031452136, 2.23651847709961],
            [32.21309446841882, 2.237822176918557],
            [32.21351377953554, 2.240409666368824],
            [32.214059806107976, 2.241468386612477],
            [32.21790629333989, 2.242863603191123],
            [32.22118577743921, 2.24354384370052],
            [32.2220683578328, 2.244304213192876],
            [32.222866218111974, 2.246376264257269],
            [32.22702919169995, 2.246125188664895],
            [32.22938440100007, 2.245194661719549],
            [32.23203423795041, 2.243504385826233],
            [32.23703813076406, 2.24308184055911],
            [32.24330265007717, 2.241140132110391],
            [32.24413467328659, 2.241330539675884],
            [32.24732099220947, 2.243449060603034],
            [32.24798716306123, 2.244281678286532],
            [32.24874916079761, 2.246769845813576],
            [32.25070088100811, 2.246807040687896],
            [32.25066625634378, 2.2485710812641],
            [32.25279826124526, 2.251638929283811],
            [32.25899192414367, 2.253818361235201],
            [32.25867425021481, 2.255936892755511],
            [32.25819742625864, 2.256702157680681],
            [32.257125958008565, 2.25741915907167],
            [32.25648367246189, 2.25741870397926],
            [32.25674376168608, 2.258567280439836],
            [32.25513623367167, 2.259870072820288],
            [32.254945002110624, 2.260539828414323],
            [32.255466528930285, 2.261856061712817],
            [32.254202117828555, 2.264462983126257],
            [32.25429484822037, 2.266209557179935],
            [32.253623853415554, 2.269749977008538],
            [32.251930879447926, 2.272619759712428],
            [32.25209570233627, 2.273840042995297],
            [32.2506518815026, 2.274995821395854],
            [32.25057134035087, 2.275777098529656],
            [32.249083975480424, 2.278206701652397],
            [32.24866764317717, 2.281146292096995],
            [32.24765430760406, 2.282939656816616],
            [32.24590298446549, 2.284606232229855],
            [32.24265665538671, 2.28639259853032],
            [32.24204938167821, 2.289520640927275],
            [32.243396380293916, 2.291674124538185],
            [32.243177055718974, 2.291902142836979],
            [32.243847944522635, 2.292900762780951],
            [32.24410151826608, 2.294312949062784],
            [32.24350519142767, 2.299883731582717],
            [32.24250409001043, 2.30315037539273],
            [32.23966303856699, 2.307166680229841],
            [32.23982998956422, 2.308193820170699],
            [32.23901419621706, 2.311232688238373],
            [32.234907993460084, 2.320101136562132],
            [32.23327061712371, 2.325274406522478],
            [32.23258454679177, 2.328989561310649],
            [32.232121340397, 2.329587339577242],
            [32.23152791691355, 2.335600771388482],
            [32.231103763877435, 2.336688082492214],
            [32.231007574073466, 2.344032011310984],
            [32.23139855681769, 2.345994593838513],
            [32.23325807933729, 2.349438854136534],
            [32.23350425725103, 2.354050304157417],
            [32.23322967909959, 2.355292687903184],
            [32.23376120776163, 2.357518756112723],
            [32.23248772008226, 2.36068979529997],
            [32.232586029910316, 2.361668353807218],
            [32.23127246389455, 2.36408751267823],
            [32.23105175681237, 2.367717228136006],
            [32.23028433864158, 2.371236639140406],
            [32.23193819996172, 2.377625196718506],
            [32.23147879703382, 2.378421023582903],
            [32.231130064752314, 2.381875981960378],
            [32.23181000947235, 2.386796757656899],
            [32.230259120236596, 2.396921059611222],
            [32.22996294209417, 2.401843538691959],
            [32.22814268313901, 2.405568201399181],
            [32.22795536014774, 2.406818753734223],
            [32.228032767077465, 2.408613941807064],
            [32.228867048651516, 2.411421060813558],
            [32.23058734667513, 2.412535026920853],
            [32.23232418807298, 2.414738529558625],
            [32.23374159125078, 2.420711373105475],
            [32.233228132200686, 2.424636647864128],
            [32.2314981907625, 2.431600533051875],
            [32.229416623569286, 2.435070885268208],
            [32.22859670605665, 2.438618008027755],
            [32.229709102449384, 2.44365381181081],
            [32.22857237967875, 2.453629334653958],
            [32.22888583242409, 2.457443410482132],
            [32.22973707329238, 2.459107592151246],
            [32.230094877659944, 2.462039969498932],
            [32.23007152954739, 2.469590278345544],
            [32.228336960887184, 2.478477616587244],
            [32.22852214768469, 2.486849976761514],
            [32.22891105981221, 2.492496093640356],
            [32.230299150063985, 2.496123568444242],
            [32.23012430467203, 2.497958641039317],
            [32.227971541500956, 2.501868041129198],
            [32.22749232443289, 2.504139877665527],
            [32.22857678950847, 2.506936976733898],
            [32.23252733758292, 2.511876813066407],
            [32.234220879285786, 2.513232350109238],
            [32.23443769486613, 2.51393159185543],
            [32.2383293413057, 2.512827860707558],
            [32.24596338628689, 2.517526097860554],
            [32.247999615507695, 2.517953988555995],
            [32.251479183166865, 2.516931905309795],
            [32.2534309015807, 2.516762348526947],
            [32.255435759835166, 2.51593921183126],
            [32.26465658623931, 2.510267358193122],
            [32.27670591552066, 2.510465271748642],
            [32.28336204460209, 2.511448601782151],
            [32.29091722289122, 2.510544787887106],
            [32.293246992800796, 2.507583232511089],
            [32.29706146766928, 2.504522943861697],
            [32.294497515948265, 2.506616899177704],
            [32.29153132738912, 2.509816877866402],
            [32.28973591583475, 2.512434368554442],
            [32.28838765328941, 2.517527559803775],
            [32.287478745969786, 2.519298382861946],
            [32.28511496135198, 2.521035385958323],
            [32.28153748541167, 2.521770554536947],
            [32.276810673455834, 2.523814272881364],
            [32.27386670113197, 2.526266063135506],
            [32.271885162243954, 2.529070457586021],
            [32.27130425139414, 2.531105494284427],
            [32.272076001241246, 2.539918498084653],
            [32.27171424608307, 2.541271525352104],
            [32.26706259077717, 2.545680667701666],
            [32.26193713165105, 2.556019553831485],
            [32.26152958307465, 2.560915180049545],
            [32.262654386998086, 2.564293421750796],
            [32.26246697417531, 2.566812750664676],
            [32.261557095776844, 2.570123801037282],
            [32.26395033255956, 2.574492966054971],
            [32.263235725445995, 2.581023798991173],
            [32.26427798497461, 2.583905991669111],
            [32.265221258243734, 2.585123947693129],
            [32.26499824608458, 2.58666512452856],
            [32.263620164861734, 2.58838434880489],
            [32.25946528150118, 2.59077205637083],
            [32.26294255665975, 2.594041840464334],
            [32.261117528548766, 2.595050727151299],
            [32.25879255025291, 2.601717188799083],
            [32.25870149971063, 2.605492229856273],
            [32.257600539769776, 2.6080269236338],
            [32.2554780893497, 2.610136580232624],
            [32.254065509226656, 2.613765631675026],
            [32.25066502655016, 2.618762539959147],
            [32.24968955855956, 2.618292756657328],
            [32.24699472769153, 2.618614269915264],
            [32.245986266377166, 2.619606948230252],
            [32.2435563513814, 2.62000012741514],
            [32.24166992072578, 2.62120050218304],
            [32.23902396449746, 2.621835705603169],
            [32.23616297045473, 2.623123328493861],
            [32.233309946265166, 2.622708939053816],
            [32.230851768473954, 2.621339835857588],
            [32.22988674429681, 2.620376903341067],
            [32.22827307539914, 2.619898640438552],
            [32.216426977374404, 2.617880091275758],
            [32.21197542179803, 2.618278900251644],
            [32.20951333813194, 2.620325789701498],
            [32.205149068258464, 2.622015919116949],
            [32.199943999533566, 2.619278432098821],
            [32.19470862524422, 2.618991337905673],
            [32.19256521084034, 2.61839383186779],
            [32.192037332931605, 2.617744319806452],
            [32.186962297140724, 2.623019022221194],
            [32.18474036998099, 2.6269607909105],
            [32.18575786924545, 2.628699165632833],
            [32.18634420052969, 2.628949337110433],
            [32.186708715312434, 2.629759677056494],
            [32.187727746204416, 2.630162505147844],
            [32.18845571306291, 2.631335558754022],
            [32.18656249833025, 2.632823692118866],
            [32.18412455239586, 2.63396361515211],
            [32.18286485655103, 2.635610944225679],
            [32.181901672123615, 2.636070266713312],
            [32.181354562182975, 2.637759428084647],
            [32.181741718104135, 2.640768928500237],
            [32.18003617311243, 2.644984366722488],
            [32.178980299615695, 2.646721960686103],
            [32.176155807716206, 2.649569583464428],
            [32.17460100272414, 2.652651476073008],
            [32.17304120220078, 2.653607071983672],
            [32.17174923707432, 2.655778945506833],
            [32.17119776401635, 2.658522327591845],
            [32.17007379193285, 2.66097351587512],
            [32.169951559968766, 2.662386749007278],
            [32.16922893808622, 2.663507854436492],
            [32.16909207885437, 2.664627365162268],
            [32.16697538394028, 2.666004151208758],
            [32.163963637321544, 2.666320245621114],
            [32.16398066398942, 2.667649144924198],
            [32.163059480293136, 2.66734393740669],
            [32.16255869018347, 2.667904886410934],
            [32.162727871697555, 2.668687797868087],
            [32.161695172938515, 2.668410877496511],
            [32.1606365281391, 2.668973359569453],
            [32.16030130023129, 2.66875045829355],
            [32.15982852857536, 2.669367282257886],
            [32.158629773541094, 2.669650368936734],
            [32.158686589287846, 2.6700978536342],
            [32.1575298349847, 2.67045077471511],
            [32.157142433823466, 2.67179478881313],
            [32.156613045846775, 2.672048052782509],
            [32.15619697585157, 2.673056398908594],
            [32.15342383165372, 2.674029282340639],
            [32.15297972883175, 2.674981739829373],
            [32.15231010395775, 2.674899656873687],
            [32.15203194422328, 2.675236164294079],
            [32.15053081356941, 2.677450545872433],
            [32.150754788722594, 2.677813637020557],
            [32.150252643055175, 2.677787043619174],
            [32.15030933663106, 2.678178568493291],
            [32.149306464634414, 2.678740899823075],
            [32.14885966866321, 2.67851830631252],
            [32.14911288936877, 2.679468848992895],
            [32.14808006215064, 2.67913596347517],
            [32.14746872626046, 2.680144843965091],
            [32.145726839025606, 2.680779119796605],
            [32.145062869944624, 2.683159064082866],
            [32.14330552809364, 2.683135919238602],
            [32.14309931353198, 2.68443744791936],
            [32.14240255414647, 2.684691149863285],
            [32.142571077195456, 2.685194301151284],
            [32.142069510941404, 2.685419498392331],
            [32.14109953614875, 2.688163979872714],
            [32.14062470285923, 2.687885495376976],
            [32.14031981105855, 2.688725670404831],
            [32.13973404032301, 2.688727274824329],
            [32.138843567331314, 2.689652976974352],
            [32.13793686807065, 2.689585507952755],
            [32.137575529730775, 2.690146058227182],
            [32.13573635405237, 2.690934477598123],
            [32.135960721769315, 2.69146543977741],
            [32.13476071897511, 2.691216920393476],
            [32.13417784350974, 2.692477519809569],
            [32.13373224678948, 2.692786490715496],
            [32.13331313689536, 2.6924798833599],
            [32.13325927211431, 2.693319363385667],
            [32.132197721264944, 2.69262281353926],
            [32.13111165808646, 2.693409169259827],
            [32.13044183019318, 2.693243126823773],
            [32.13049890465473, 2.693802528637575],
            [32.1298586259444, 2.694363827133524],
            [32.12930049457355, 2.694253443935372],
            [32.12885554464029, 2.694842182325866],
            [32.12812788051405, 2.69378102789024],
            [32.127262607062704, 2.69353159370939],
            [32.127204329756964, 2.692440622760301],
            [32.12540603011892, 2.692106325698245],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 539,
        District: "NWOYA",
        County: "NWOYA",
        Subcounty: "KOCH-GOMA",
        Population: 35474,
        Key: "NWOYAKOCH-GOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.01188157712382, 2.616700300986241],
            [32.01056512482105, 2.617229364795369],
            [32.00965435619214, 2.61826213275324],
            [32.008635592099765, 2.618557185055291],
            [32.007791902469776, 2.62319344750246],
            [32.00641647666688, 2.624229150334275],
            [32.005555842115676, 2.62612926309562],
            [32.00311038806212, 2.628277702277313],
            [32.00186767935934, 2.630465501738536],
            [31.99932636698011, 2.633093849820835],
            [31.997416060002568, 2.634493901939855],
            [31.991077618324745, 2.637858407272657],
            [31.983600522498392, 2.643216328299844],
            [31.9779308540917, 2.646625581848167],
            [31.965222898908646, 2.653027728826253],
            [31.963415388844027, 2.653507399502307],
            [31.961844246191884, 2.652816810605828],
            [31.961081760670282, 2.651934257741885],
            [31.96105663209684, 2.650931456132372],
            [31.958613181286378, 2.64724532610047],
            [31.957466437808755, 2.643641249505596],
            [31.953917485175342, 2.640541407006539],
            [31.95312018813986, 2.640315498030053],
            [31.951737891123397, 2.638478596506977],
            [31.949141704256743, 2.636213326380156],
            [31.945999234797807, 2.634641129154326],
            [31.94478590280144, 2.634642539813263],
            [31.944153202278827, 2.63293609182225],
            [31.940655865943338, 2.632868526370049],
            [31.93915607108433, 2.632130097199405],
            [31.93732400916467, 2.631988965506526],
            [31.935076298559647, 2.632385537329833],
            [31.931604795076794, 2.633869914860258],
            [31.927702906046356, 2.633707278876195],
            [31.92369162287555, 2.631742076312785],
            [31.923690328403236, 2.630739242246819],
            [31.923119228952913, 2.630644397567551],
            [31.921879714659276, 2.628783441236847],
            [31.92047513313555, 2.62806875406998],
            [31.9201887232735, 2.627352788637648],
            [31.917691739160315, 2.628143580406189],
            [31.915371322509476, 2.62748963052484],
            [31.914132622987772, 2.626249465152301],
            [31.913276007499153, 2.626131052455098],
            [31.910422023908893, 2.626802871506758],
            [31.909923347535102, 2.627519722062095],
            [31.906759348153766, 2.627618847437539],
            [31.906484428642525, 2.626580525295732],
            [31.905555991948635, 2.626104043356763],
            [31.905841101050154, 2.62581720917336],
            [31.9053885351999, 2.625387942192239],
            [31.90557775633134, 2.624528176591898],
            [31.904053184140157, 2.622977929666327],
            [31.90405229480803, 2.622285511119456],
            [31.90138539705378, 2.620426172871019],
            [31.89938717734926, 2.620547813072056],
            [31.898588807725336, 2.619462335096118],
            [31.899016572887216, 2.619103704753305],
            [31.898183766346868, 2.618985277918962],
            [31.89706431997578, 2.617959853798991],
            [31.897061319602738, 2.615619962558543],
            [31.895371489738615, 2.615048827111428],
            [31.895012780767573, 2.613592781779329],
            [31.892895299827636, 2.61347578036281],
            [31.892561278357228, 2.612712118837022],
            [31.891847573152184, 2.612712929172498],
            [31.891490211654084, 2.612307440111935],
            [31.88944416654213, 2.612614936009818],
            [31.88872996277213, 2.611833030182592],
            [31.889585973694565, 2.611497782544868],
            [31.889490116267226, 2.610948742374747],
            [31.890108284743498, 2.610661513462709],
            [31.8898698503075, 2.610232007969946],
            [31.89077412681186, 2.610445878607097],
            [31.890630724251476, 2.609920766707621],
            [31.891939348634875, 2.610062543415389],
            [31.891938532066284, 2.60941786753071],
            [31.892841933611535, 2.608939320466851],
            [31.89316134128893, 2.607825158308316],
            [31.897038837466116, 2.608079303086882],
            [31.899721787216166, 2.609178200518676],
            [31.900517690066327, 2.610191085498768],
            [31.90085358272749, 2.609727463116025],
            [31.900435065721457, 2.608757084164885],
            [31.901064729938383, 2.608040673363847],
            [31.902071158365246, 2.60808373168076],
            [31.902491030929067, 2.607493658877063],
            [31.90324598856855, 2.607367797905173],
            [31.903204820575702, 2.606482098958363],
            [31.90396003423507, 2.606061016700145],
            [31.904662143986414, 2.602895092482596],
            [31.90443616828513, 2.601233776751437],
            [31.90359897347462, 2.600498782105017],
            [31.903767693254636, 2.599162813309901],
            [31.903277465536117, 2.598584604332023],
            [31.90359005140722, 2.596971908149058],
            [31.903243502031852, 2.596333640133745],
            [31.904287655209092, 2.592642475498904],
            [31.90649694846264, 2.590204520791014],
            [31.90748116424751, 2.587851546887505],
            [31.90635787757856, 2.583865438074712],
            [31.90597708711953, 2.583746509872927],
            [31.904390385646657, 2.580131026201224],
            [31.90532319444106, 2.57484129335424],
            [31.907839551621688, 2.570755486254765],
            [31.907599226232037, 2.568893388037278],
            [31.908023656847593, 2.566003811571665],
            [31.90887051393728, 2.564495541300246],
            [31.912115796478776, 2.566846921496508],
            [31.921677096951985, 2.571199463324736],
            [31.927908952623067, 2.574824927318275],
            [31.928973516421852, 2.577535708784958],
            [31.930045199369303, 2.578394026602667],
            [31.9313078964855, 2.582934508824843],
            [31.9341197248344, 2.581865797866407],
            [31.9348353326712, 2.582129784300169],
            [31.93502783894166, 2.581585623114662],
            [31.935708967641197, 2.581322814858985],
            [31.93696607454139, 2.581271196193242],
            [31.93710653781414, 2.580323137180867],
            [31.939326115879393, 2.577603381305346],
            [31.94030580685018, 2.575216198196098],
            [31.94114345441159, 2.575690988002614],
            [31.942715592397057, 2.574709005486838],
            [31.94332634438232, 2.575095809999879],
            [31.943396572874605, 2.574621779179142],
            [31.944810895729287, 2.574464929215682],
            [31.94528264061083, 2.57404390810508],
            [31.945649497301513, 2.574184378615008],
            [31.945755595523096, 2.573743291344137],
            [31.946511374222766, 2.573700965940091],
            [31.946813178513807, 2.573348525501914],
            [31.9465924615502, 2.572655962181299],
            [31.947013044681384, 2.568996863286621],
            [31.94765651420761, 2.568489251704866],
            [31.948530892982664, 2.56645740159991],
            [31.968144124092877, 2.566381089978262],
            [31.970147147089204, 2.567552392774636],
            [31.972742455403534, 2.574331875819568],
            [31.97429151387274, 2.576335680175179],
            [31.975705821456035, 2.581700422565281],
            [31.98412564078255, 2.586817093823535],
            [31.985728561337886, 2.588211579786319],
            [31.989370015292714, 2.593347335697086],
            [31.991116909736956, 2.597088374458328],
            [31.991916835242954, 2.599728760973508],
            [31.991915436566035, 2.601488587825661],
            [31.99330091182199, 2.601993826971177],
            [31.99742674815783, 2.601975597408622],
            [31.998496677593817, 2.601496745993324],
            [31.999567316698872, 2.601543183205182],
            [32.000399412671854, 2.600268697524525],
            [32.000889901800136, 2.600955886553769],
            [32.00151641562534, 2.600410429552102],
            [32.00191693937624, 2.600895912193789],
            [32.003086898914084, 2.600950048135373],
            [32.00602808017233, 2.602001196330533],
            [32.00839487504468, 2.601365253302726],
            [32.009135263806904, 2.600704994274199],
            [32.00969662282456, 2.602950233413382],
            [32.00895807920194, 2.604440471657467],
            [32.008961051727205, 2.605785616916998],
            [32.00822136095596, 2.606760695077069],
            [32.00876601669925, 2.607904069852058],
            [32.01070820668287, 2.608786141467922],
            [32.01146069126038, 2.613592411161054],
            [32.011151455206985, 2.615682521566317],
            [32.01188157712382, 2.616700300986241],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 540,
        District: "NWOYA",
        County: "NWOYA",
        Subcounty: "ANAKA TOWN COUNCIL",
        Population: 13592,
        Key: "NWOYAANAKA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.461492390437915, 2.675171040114175],
            [31.46203194105544, 2.675292320492499],
            [31.462030537886974, 2.676498817143305],
            [31.46239014427498, 2.676831111136532],
            [31.461849470763347, 2.677282863631331],
            [31.46101010741975, 2.677040442343473],
            [31.461727917925636, 2.678639940806422],
            [31.463017280632705, 2.678822492577311],
            [31.463378291087515, 2.678038727042882],
            [31.46481587671479, 2.679820214991132],
            [31.464966905971938, 2.678764726724069],
            [31.46736624950195, 2.678888390064687],
            [31.467485557449788, 2.679521851768786],
            [31.466285463925743, 2.679731603365019],
            [31.46787379763748, 2.680789194145047],
            [31.46853462081836, 2.680156714778698],
            [31.4698543025646, 2.680037678213758],
            [31.469856267180123, 2.678439022378156],
            [31.470546566780428, 2.678198564686055],
            [31.471085836225257, 2.678591429147996],
            [31.470544601266575, 2.679646356731313],
            [31.47169809468526, 2.680824245734143],
            [31.474545754135917, 2.682185105720834],
            [31.475325884366303, 2.681914643799229],
            [31.47631487379858, 2.682519080666126],
            [31.477335023093108, 2.682309189564098],
            [31.478233338377226, 2.683456511141326],
            [31.479912065064426, 2.684212651603676],
            [31.480930810292158, 2.685179103090813],
            [31.481559350716676, 2.686084844171949],
            [31.481032993655724, 2.687381062019728],
            [31.48187235699932, 2.687713914783171],
            [31.482020860193895, 2.68895082302547],
            [31.481388109365643, 2.691272512338094],
            [31.482378220793695, 2.690911760027821],
            [31.48405722865358, 2.691607607350157],
            [31.484924102902756, 2.693991542452912],
            [31.48481602389597, 2.696434640420441],
            [31.48382506984818, 2.697277841597086],
            [31.483703797284818, 2.698484315624463],
            [31.484123198233096, 2.698876892693983],
            [31.485473198120175, 2.69854684800055],
            [31.48607226212527, 2.69930157748977],
            [31.485801644645928, 2.699814029728717],
            [31.48424194473388, 2.699812067293865],
            [31.483460690711052, 2.700806407595856],
            [31.481720204848074, 2.70155833156613],
            [31.48171964340102, 2.702131351716006],
            [31.48339808981386, 2.703098770646562],
            [31.485509411005904, 2.705634947517948],
            [31.48748907331328, 2.705697899468576],
            [31.487904544132185, 2.709287710289347],
            [31.4886835523668, 2.709952281192598],
            [31.489343532927933, 2.70986255012148],
            [31.48970510482979, 2.708535931092281],
            [31.49069353281502, 2.709713512181515],
            [31.491022259615132, 2.710588670806991],
            [31.49039119312804, 2.711492710501958],
            [31.490570856184867, 2.711915146708727],
            [31.49265466736966, 2.71255125443304],
            [31.492921073546942, 2.715356602639232],
            [31.493611091974554, 2.715327300192336],
            [31.494932458061957, 2.71391137722308],
            [31.495952326183794, 2.713792064001501],
            [31.496009032336104, 2.716627412539008],
            [31.49702805873652, 2.717081112660305],
            [31.498258189228718, 2.716841364302204],
            [31.500670446939267, 2.719383961288503],
            [31.502000515006813, 2.718757250142081],
            [31.502049360900394, 2.717276837381871],
            [31.502429740829342, 2.717085880043822],
            [31.50361832423965, 2.717563695065692],
            [31.50337942896794, 2.719043966597285],
            [31.503949578000668, 2.719712738693754],
            [31.50685085609401, 2.719283574538451],
            [31.50870503453597, 2.719761389587429],
            [31.51060609425599, 2.721385507635882],
            [31.51212789694116, 2.721385787594156],
            [31.512792650251413, 2.722818526189436],
            [31.513839187557405, 2.722245654922197],
            [31.514362175037714, 2.722580040577449],
            [31.513980391041965, 2.724108115000694],
            [31.51436077186925, 2.724347021143816],
            [31.5145991056939, 2.723583054315519],
            [31.514979486521185, 2.723487576149597],
            [31.516167788758796, 2.724395111037937],
            [31.515406186281144, 2.725159077350995],
            [31.515714420713007, 2.72628140273308],
            [31.519328455390433, 2.726759634044696],
            [31.520041211974505, 2.727285114176781],
            [31.51970743215092, 2.728431131598459],
            [31.518042460467342, 2.729003859045866],
            [31.520705123563342, 2.729864001784705],
            [31.521512484424946, 2.731249061497532],
            [31.521559084530306, 2.732108640922661],
            [31.521178423428662, 2.732347405498247],
            [31.520370781394373, 2.731630831673158],
            [31.52046678884036, 2.73058029581044],
            [31.51923020215623, 2.730627824645765],
            [31.51780244230153, 2.731630411739323],
            [31.51770615368285, 2.733206284248203],
            [31.518228860888797, 2.733779430249036],
            [31.51994043267774, 2.734352855931358],
            [31.520129920608817, 2.735164765399477],
            [31.5211756161934, 2.73588119623942],
            [31.524744173659567, 2.73373288317699],
            [31.52579014951851, 2.734067404718019],
            [31.52626513372499, 2.734831645734785],
            [31.5248384967644, 2.734926843044448],
            [31.524172059112995, 2.735690802661358],
            [31.524884535422707, 2.736502711223627],
            [31.526977048587653, 2.736694226286195],
            [31.525645015006255, 2.737123804159068],
            [31.525216350630778, 2.737887762375881],
            [31.52821223210332, 2.738318041501312],
            [31.52835427820762, 2.739082278910731],
            [31.5273551827284, 2.739559665260036],
            [31.52728331750567, 2.740204310424098],
            [31.527804060096095, 2.743069740997048],
            [31.528850035955045, 2.74340425993053],
            [31.529659081157806, 2.742926736035648],
            [31.531610671112556, 2.740587200255377],
            [31.535034375239157, 2.741304048680242],
            [31.535464162508738, 2.739059706709232],
            [31.53641553498849, 2.739012178208021],
            [31.537223737571505, 2.739442036101122],
            [31.537507829780107, 2.740874753157815],
            [31.538220587262515, 2.741591180582784],
            [31.53817174136894, 2.743167179969349],
            [31.538599282850313, 2.743835798655947],
            [31.538266064473774, 2.744265513942297],
            [31.536696538789137, 2.74407428004406],
            [31.536268154688024, 2.744742757349607],
            [31.536314754793388, 2.74598437443995],
            [31.535078448383615, 2.745697664418667],
            [31.53417367690756, 2.74689133150272],
            [31.53270408879828, 2.747015969503779],
            [31.534125672735396, 2.747020175966556],
            [31.534617500353455, 2.749814508501555],
            [31.535662073043934, 2.749143229133392],
            [31.537950531230226, 2.751183561882439],
            [31.53723917781462, 2.751948913560105],
            [31.535193826202082, 2.751813900832627],
            [31.534624237718084, 2.752245155669691],
            [31.535960762875902, 2.753955592693201],
            [31.536250469555032, 2.755574897163301],
            [31.53706119909895, 2.756334217222073],
            [31.538115596663687, 2.759237182393582],
            [31.539589114004, 2.758945428394182],
            [31.541924733742714, 2.760747265444395],
            [31.54301899404818, 2.760838394247999],
            [31.543972612316143, 2.761740012897459],
            [31.545002306210566, 2.764238070931697],
            [31.54628942312943, 2.765376902560601],
            [31.547003022333246, 2.765421766018395],
            [31.547663845514133, 2.763560351914186],
            [31.548043945168725, 2.763415946978183],
            [31.549474512258683, 2.764744748444555],
            [31.55114116828342, 2.765405363041157],
            [31.551427506280234, 2.765785580783088],
            [31.551049652413845, 2.766740190126554],
            [31.550149091341517, 2.767839903882218],
            [31.550438236573594, 2.769220853993811],
            [31.553060755756167, 2.771641227265143],
            [31.557300522724525, 2.774007339013601],
            [31.55699706104177, 2.776034169224433],
            [31.55728339903858, 2.776366576598595],
            [31.560329249298803, 2.777069523732836],
            [31.563475317408738, 2.779487637791057],
            [31.56623819835446, 2.781049568154402],
            [31.56790204714393, 2.780661644287418],
            [31.56889861566225, 2.779847522725691],
            [31.571039132101024, 2.779886637798939],
            [31.571025657371763, 2.775120784890978],
            [31.572540722692302, 2.772541154432727],
            [31.573490129658204, 2.771917836808236],
            [31.57534515071991, 2.771910546536432],
            [31.576680552085296, 2.773191951313546],
            [31.577256596761238, 2.775096110191514],
            [31.57805413274859, 2.779692184889902],
            [31.577821412496128, 2.781456417735303],
            [31.57977580968614, 2.78306909607198],
            [31.580349889746568, 2.784210713485379],
            [31.579976807730965, 2.786928831844593],
            [31.579220258276788, 2.788456964539029],
            [31.579175903959626, 2.789648626271832],
            [31.579701137228152, 2.790409046021687],
            [31.5825502007456, 2.788681978181432],
            [31.58659149663004, 2.787998805330332],
            [31.588142493663607, 2.789922848494962],
            [31.588192462451293, 2.79078056315546],
            [31.591196485355255, 2.793437541324622],
            [31.592814294588084, 2.793621757955811],
            [31.595048012135916, 2.792945597279],
            [31.59566728823491, 2.793276877423773],
            [31.60012405493824, 2.796619122221644],
            [31.600268908277812, 2.797381078924055],
            [31.5979877489032, 2.79815270921872],
            [31.597086626383817, 2.799061870297458],
            [31.59937452312306, 2.800768594047114],
            [31.599046638044356, 2.802533356028965],
            [31.60066557017129, 2.803241755302124],
            [31.602098102775095, 2.805142501778327],
            [31.604238619213874, 2.805229281822038],
            [31.606001562958955, 2.806270779121531],
            [31.607357457590926, 2.806384616188623],
            [31.612109826616614, 2.804888190157898],
            [31.616572488064836, 2.801820189283364],
            [31.619331158606826, 2.801761447783064],
            [31.620905456142246, 2.803423306486343],
            [31.621101962610645, 2.805662619375428],
            [31.622245910531106, 2.806468311436368],
            [31.622342199149788, 2.806896742435651],
            [31.621489079904233, 2.807996418666344],
            [31.62377192362, 2.807891974928019],
            [31.62567551030092, 2.808218063921065],
            [31.626176321071817, 2.808668785214323],
            [31.625612347058336, 2.811149360649896],
            [31.626711098940227, 2.812765502746381],
            [31.62871125451419, 2.813663015357419],
            [31.629809725223385, 2.815231488567438],
            [31.631001397041643, 2.816084558558173],
            [31.632045688559433, 2.815317847059695],
            [31.63246986135849, 2.813934007303513],
            [31.631991228195336, 2.812887329936668],
            [31.632132431679885, 2.812362588525223],
            [31.63422466457047, 2.812068183801751],
            [31.634605887119175, 2.812304969096593],
            [31.63422915614689, 2.81373633628382],
            [31.634422574207345, 2.814784134427698],
            [31.63642301005567, 2.815729311765538],
            [31.636713559354536, 2.817586998713419],
            [31.637190508176534, 2.817966357969351],
            [31.637853296871263, 2.816915057210889],
            [31.63828168097238, 2.816961040238502],
            [31.63914097523718, 2.818101503081831],
            [31.64111642714083, 2.818546332043268],
            [31.642589664206785, 2.81811159690703],
            [31.64296779834753, 2.817299744434728],
            [31.642155384462455, 2.815968479361028],
            [31.64315335704757, 2.815583230928185],
            [31.644099395331157, 2.813768300183096],
            [31.6457632432223, 2.813428052617556],
            [31.646524846598282, 2.813615630722699],
            [31.64652877672765, 2.814997787650976],
            [31.64719774044163, 2.815995957046422],
            [31.649054727017184, 2.816655842102277],
            [31.650430272295992, 2.815315743950096],
            [31.65190631659721, 2.815834175603352],
            [31.653327619361637, 2.813778954815994],
            [31.6540953986552, 2.816159000870217],
            [31.65580668927145, 2.815770808686443],
            [31.6583691336194, 2.813663436159386],
            [31.657843899452548, 2.812950557042022],
            [31.656085447283886, 2.813434361059312],
            [31.65575166746029, 2.813197295159946],
            [31.65603379415505, 2.812052342245978],
            [31.657267854776606, 2.811094124215658],
            [31.65626230310545, 2.808715049402017],
            [31.6567341998023, 2.807426393293891],
            [31.65808784864606, 2.806729771902742],
            [31.659176774755363, 2.804914266616763],
            [31.660078458721795, 2.804195774410819],
            [31.65997487218976, 2.801193522506846],
            [31.663112518593913, 2.80060891273374],
            [31.66505961697224, 2.799457218164449],
            [31.66739074513453, 2.799590823057938],
            [31.668246390442654, 2.79944432029288],
            [31.669052909582838, 2.798726244640048],
            [31.670955653644018, 2.79871853372685],
            [31.672431697945235, 2.799189166717417],
            [31.67314838465868, 2.800330206794794],
            [31.67448013706739, 2.80027707388332],
            [31.675385189716142, 2.800750088425968],
            [31.676510610782195, 2.803390781528802],
            [31.679365849318895, 2.803808138126365],
            [31.68094014685431, 2.805422328119553],
            [31.68217841877793, 2.805989270661707],
            [31.683224394636877, 2.805746735479686],
            [31.6827906763396, 2.803842065458236],
            [31.683310576310284, 2.802648315010798],
            [31.684357394788975, 2.802787107385862],
            [31.685361823566033, 2.804737201859889],
            [31.686836744973146, 2.804826504970075],
            [31.687409139794077, 2.805396251672018],
            [31.687559888776857, 2.808207690072433],
            [31.68975093545037, 2.809152031131767],
            [31.69142208305152, 2.811385304525657],
            [31.690976855538835, 2.813698764681796],
            [31.69202928758972, 2.815744031732933],
            [31.693174078129918, 2.816883234263039],
            [31.693037085049088, 2.818885596545907],
            [31.696659261157944, 2.821301662083151],
            [31.69913440004005, 2.82186368997406],
            [31.69975676454699, 2.823195649034366],
            [31.700994474125228, 2.823571922699468],
            [31.70218109292001, 2.822661520114247],
            [31.702556419825495, 2.820848842576295],
            [31.705977036442466, 2.819309817675598],
            [31.707212500232494, 2.818923448813069],
            [31.70766502655687, 2.819136119709297],
            [31.708189418103977, 2.8195630037197],
            [31.708287109891124, 2.820372751512524],
            [31.706433211723517, 2.820856974142687],
            [31.70543692437789, 2.821718872303922],
            [31.705961877372047, 2.822336415831133],
            [31.706059849433558, 2.82333696196014],
            [31.708248651217183, 2.823518649982307],
            [31.709245219735507, 2.822752083350158],
            [31.712532492228327, 2.824454567152439],
            [31.712538668145907, 2.82659935134792],
            [31.714534050970762, 2.825780916495501],
            [31.71420476182526, 2.827069271458621],
            [31.711358506441396, 2.829749859013066],
            [31.71112269867932, 2.830513337279828],
            [31.71155276712159, 2.831178961673031],
            [31.71564599640922, 2.83197257924925],
            [31.71754565296077, 2.830916244312874],
            [31.717637168830336, 2.829629015148372],
            [31.720297866412494, 2.828569594327957],
            [31.721775033607816, 2.829373868180975],
            [31.72238785261654, 2.827464890659557],
            [31.725124626723478, 2.828049486065009],
            [31.72588370313856, 2.827283903985213],
            [31.728170195811003, 2.828418468236575],
            [31.730499639632136, 2.827884621652538],
            [31.731070912457294, 2.828120702997842],
            [31.732027056787828, 2.829689577497221],
            [31.73488341821864, 2.830440578173855],
            [31.735600947551827, 2.831819912180558],
            [31.742266728132684, 2.833985150056668],
            [31.74338232342615, 2.833098867464278],
            [31.743474962189833, 2.832288287857441],
            [31.745662640181024, 2.83208865684699],
            [31.746322901914848, 2.830179402966756],
            [31.74756005094436, 2.830269685683513],
            [31.747606651049725, 2.829935892163753],
            [31.746034037855466, 2.828989044988353],
            [31.745985472236253, 2.828607866178885],
            [31.7478826018269, 2.826646034723074],
            [31.750403780265653, 2.826976184673765],
            [31.750685065238994, 2.827583912492731],
            [31.751445825995233, 2.827682606863291],
            [31.75197948096954, 2.829513918863021],
            [31.75126447859725, 2.830338800294793],
            [31.75188796509997, 2.831506165661674],
            [31.751170716939473, 2.832299783013715],
            [31.752260485668515, 2.834100105931958],
            [31.75351531983102, 2.834044169862442],
            [31.754884969466612, 2.833185505457029],
            [31.75609685337876, 2.833526027167803],
            [31.75653955393055, 2.832298521525297],
            [31.758820433030802, 2.832587594342635],
            [31.75998880434721, 2.833362986679696],
            [31.76176634571566, 2.831892811165952],
            [31.762073737527775, 2.830125429824427],
            [31.764384092149125, 2.829583172588454],
            [31.765440455227708, 2.828322717710787],
            [31.767178414129784, 2.82952877862214],
            [31.768062974410284, 2.829156992990228],
            [31.770803958920954, 2.829405691683953],
            [31.770345818126053, 2.828558379067575],
            [31.77155685941846, 2.827624848226995],
            [31.772027632322878, 2.828073458918772],
            [31.772881031842793, 2.827933548029274],
            [31.774675136348453, 2.82935690533568],
            [31.77624213507219, 2.829025634537051],
            [31.77657254621347, 2.829550929191369],
            [31.777158416661994, 2.829577144166973],
            [31.777961847394227, 2.828540854550084],
            [31.780420424037455, 2.828172013281186],
            [31.781312843678354, 2.827315025918084],
            [31.783209973269006, 2.8277140096158],
            [31.784980777272825, 2.827216472380098],
            [31.78629007179943, 2.82607910223495],
            [31.785226410807496, 2.824250448672746],
            [31.78620725880834, 2.823691926495493],
            [31.78692394552179, 2.822627032564089],
            [31.7876922862624, 2.822601097365837],
            [31.78771923572092, 2.822094865615501],
            [31.78819646571561, 2.821855699279205],
            [31.78982017059166, 2.821524286372812],
            [31.79034652675428, 2.821064597785642],
            [31.790308348354706, 2.820398546793057],
            [31.791175784050935, 2.819919511741506],
            [31.79381570809214, 2.819442438730036],
            [31.795911871112093, 2.817662141665456],
            [31.797567578470137, 2.817840185132334],
            [31.798006910339613, 2.816812156609433],
            [31.797647584225967, 2.815851980248386],
            [31.79883055316574, 2.814200933828812],
            [31.79863966116786, 2.813555067536449],
            [31.79942680993557, 2.813177949028586],
            [31.799885793350217, 2.812210058849195],
            [31.80064936134172, 2.812033696835049],
            [31.800356004807583, 2.811167445303554],
            [31.80072122656445, 2.810640320063252],
            [31.800581145075665, 2.810037911177543],
            [31.801578836488094, 2.81052311878066],
            [31.80274271622808, 2.810333157122365],
            [31.802534980818628, 2.809949168340411],
            [31.803626433888834, 2.806737482763158],
            [31.80349168659621, 2.805982260539411],
            [31.810693929386645, 2.802130719115762],
            [31.811473217895617, 2.801989123681078],
            [31.811874372263848, 2.802416854678615],
            [31.813409368505585, 2.8021810489618],
            [31.814754875917913, 2.802586068929354],
            [31.821014730279764, 2.800051921596403],
            [31.823425302750827, 2.796732819359591],
            [31.82517926334307, 2.801393999529146],
            [31.825570591938714, 2.804770568390336],
            [31.824498789515346, 2.805666825629411],
            [31.82315384355007, 2.811016037014225],
            [31.822449227499092, 2.811638212354939],
            [31.821933257657776, 2.811477271015375],
            [31.819669503141792, 2.813711381562346],
            [31.81939383263898, 2.817117635537583],
            [31.82027530451152, 2.817864018228996],
            [31.819458117877335, 2.818542546635931],
            [31.820198666539678, 2.819354819041229],
            [31.820449633372178, 2.821836913160751],
            [31.820956058613604, 2.822063883509956],
            [31.821114948129484, 2.822667968473118],
            [31.82038675130229, 2.823755713779233],
            [31.819519877053118, 2.823660523634179],
            [31.817948667925652, 2.825119634257709],
            [31.81883884177834, 2.825309032738474],
            [31.821086314329797, 2.827101935721806],
            [31.821810862200316, 2.82877539433671],
            [31.823872214604673, 2.829390130297056],
            [31.827781290157393, 2.833375743312547],
            [31.827405682079217, 2.834199921268071],
            [31.82990749014549, 2.839432784501049],
            [31.829810640079756, 2.842636949857839],
            [31.83011410266084, 2.843697339339114],
            [31.83041503828102, 2.843750751092245],
            [31.83129398319266, 2.846233634497744],
            [31.8316867158551, 2.848447350967604],
            [31.83356166783801, 2.850534753048198],
            [31.835083470523177, 2.856709601422783],
            [31.837323082815896, 2.854571742120855],
            [31.838061665964396, 2.852898882541813],
            [31.839235090304275, 2.852735424003692],
            [31.84243196982164, 2.848403612203876],
            [31.846143977458897, 2.847611687281153],
            [31.850184711896283, 2.845283716071305],
            [31.85185445543064, 2.846393589468643],
            [31.8543102248386, 2.846970465606903],
            [31.858294253123667, 2.850558304646809],
            [31.858281058668773, 2.853725850302456],
            [31.858977814461014, 2.854397348737904],
            [31.859279311528248, 2.856043991761793],
            [31.860580745796117, 2.858636755328031],
            [31.860296653587515, 2.860209653511147],
            [31.862662872639756, 2.85872969869862],
            [31.86537887230742, 2.860586755782312],
            [31.86590326385452, 2.860567830331534],
            [31.86580641468712, 2.860118671531517],
            [31.86656464848246, 2.859065446950969],
            [31.868079432630303, 2.858754512485941],
            [31.867884330228698, 2.859671755547164],
            [31.868660811502412, 2.859613998512639],
            [31.86906814088989, 2.860004839747766],
            [31.86972868379641, 2.859712690142686],
            [31.87009615044315, 2.860981801841704],
            [31.870814241223396, 2.861353437247886],
            [31.872211964109944, 2.861237783382856],
            [31.8722894438032, 2.861667315602492],
            [31.87285229402424, 2.861863016260153],
            [31.873376685571348, 2.861590212450074],
            [31.87357010453012, 2.862117455326793],
            [31.874754476638365, 2.862235772873906],
            [31.874871538797994, 2.861455073323],
            [31.875589909852597, 2.861553344010053],
            [31.875706972012225, 2.860772643994361],
            [31.877124625819974, 2.860344652822429],
            [31.877686914593962, 2.861145540925182],
            [31.879453788468414, 2.86093259694208],
            [31.88123890982124, 2.862007968855925],
            [31.882966762676375, 2.862087735751428],
            [31.88329745499034, 2.861307176062159],
            [31.884035757864474, 2.860897970572879],
            [31.884947547877854, 2.861425914477495],
            [31.885972469921498, 2.860234045584225],
            [31.88702069156865, 2.860072971043669],
            [31.887276430251937, 2.859200587256863],
            [31.88695191385555, 2.857285490851829],
            [31.888355251212623, 2.855691980880533],
            [31.888356092934043, 2.854764640237081],
            [31.88902140769134, 2.853467063331587],
            [31.888394552506302, 2.852984397545404],
            [31.888837534230788, 2.851119898429023],
            [31.889026180440453, 2.850783447138763],
            [31.889402630240035, 2.851183543338422],
            [31.890197920439178, 2.850868821438677],
            [31.89044972899309, 2.850069609325471],
            [31.89180197466838, 2.850023627612969],
            [31.891922124337633, 2.848335480216151],
            [31.893245735314913, 2.845859751184557],
            [31.893887189021644, 2.843251398521422],
            [31.89893824698097, 2.840848136203094],
            [31.90139963085945, 2.838898101410969],
            [31.901963323700237, 2.837589432330549],
            [31.902482381949508, 2.833730004048769],
            [31.903463791397407, 2.831218214995146],
            [31.90418581230702, 2.830415764674471],
            [31.90413584351934, 2.828809600874135],
            [31.90516722175492, 2.827826162296389],
            [31.908517095144944, 2.827233575223305],
            [31.910294636513395, 2.827623726700047],
            [31.91068119325826, 2.827339138753619],
            [31.912819463908825, 2.827392972059051],
            [31.915376574958938, 2.825145710263826],
            [31.9185933853975, 2.821415216850578],
            [31.923519521836788, 2.822281320791964],
            [31.925734150184837, 2.821278249856128],
            [31.926762159738104, 2.819802311392293],
            [31.920948094335998, 2.814982366936501],
            [31.920852368062704, 2.812577784536108],
            [31.919598937068663, 2.811344789022778],
            [31.91930670432696, 2.809284794208034],
            [31.918934745205465, 2.808979032393002],
            [31.919907171500526, 2.806457095963073],
            [31.919756703690435, 2.804251711018047],
            [31.919010821730254, 2.804058664527303],
            [31.918686024161172, 2.80337521979431],
            [31.916677447779755, 2.802930945825446],
            [31.914765720565736, 2.801053187583831],
            [31.91492910165804, 2.800004676379668],
            [31.914585214889172, 2.799552269417143],
            [31.915035776598025, 2.798619556964581],
            [31.914686556531326, 2.798265986297715],
            [31.915720460829476, 2.797190835191365],
            [31.91507479671902, 2.79567617254923],
            [31.915026793445186, 2.793836676574618],
            [31.916818651264315, 2.794000985017841],
            [31.917665313419597, 2.793451140012792],
            [31.919270490542903, 2.793677975906262],
            [31.92073951720513, 2.793003637572853],
            [31.921448063385483, 2.793830087188704],
            [31.922854488252185, 2.793693817710758],
            [31.924894225394187, 2.794934401893008],
            [31.925927287970925, 2.794660040869223],
            [31.927768834303368, 2.794999593144346],
            [31.930380124544893, 2.797304533171146],
            [31.930915183585995, 2.797267381848957],
            [31.932777503459388, 2.796115683099277],
            [31.93672924808977, 2.795551679642354],
            [31.94132020063867, 2.795631591080024],
            [31.94324034955848, 2.794687379084857],
            [31.9464414403779, 2.791852355449443],
            [31.947721539657767, 2.791172409155484],
            [31.95479717568868, 2.789929997787098],
            [31.95558825458575, 2.789098218448194],
            [31.95897630727368, 2.787814727789202],
            [31.960407154638, 2.786794383887324],
            [31.96134870134517, 2.785962742303235],
            [31.9647022245902, 2.780781652482515],
            [31.965552536600487, 2.78044097453229],
            [31.966286909345257, 2.78225890166879],
            [31.967016229066548, 2.782670938766934],
            [31.967478861437872, 2.782492469141501],
            [31.96742636568929, 2.781472680517854],
            [31.967728985650627, 2.781383515603874],
            [31.968475710230553, 2.782081833495626],
            [31.969507369638823, 2.782225955311903],
            [31.969578111967447, 2.782744822416823],
            [31.97084108666305, 2.783050029387199],
            [31.97189127382406, 2.782603644561246],
            [31.972602627239667, 2.782944181017494],
            [31.972602065792614, 2.783606187856312],
            [31.971938715650833, 2.783807228664751],
            [31.972666070756606, 2.78419767457741],
            [31.972308990431173, 2.784659199969933],
            [31.974894454108277, 2.786989536378922],
            [31.975997697566587, 2.786865322494696],
            [31.976779231863773, 2.788368780849875],
            [31.97641148404433, 2.788670341727057],
            [31.978907396467392, 2.789016344277687],
            [31.98589600910348, 2.787588592415552],
            [31.993103866364432, 2.787023884111344],
            [31.999803894317168, 2.782796834551124],
            [32.00294238334106, 2.78129392986957],
            [32.00786346675688, 2.779935847024908],
            [32.00800635548092, 2.779505863802263],
            [32.008719673512054, 2.779291362484021],
            [32.00893330456472, 2.779578345235528],
            [32.00943271126882, 2.779148502752259],
            [32.011001114059354, 2.779293185713549],
            [32.011274819048325, 2.779713915588869],
            [32.01183345886564, 2.779069571796426],
            [32.012225068633974, 2.779657276157335],
            [32.0118825859319, 2.780030059124907],
            [32.01191093855889, 2.781062466227789],
            [32.01427828050524, 2.78103428606823],
            [32.01501995206169, 2.781206447299262],
            [32.01521926576535, 2.781636710743466],
            [32.016074911073474, 2.781636850715528],
            [32.017044530133276, 2.783730682027917],
            [32.01735809786297, 2.784046122833583],
            [32.01772893409036, 2.783845501981304],
            [32.01865560200147, 2.784863746171566],
            [32.019511247309595, 2.784749206260803],
            [32.02073744767242, 2.786756951392602],
            [32.02182132165658, 2.786183550995986],
            [32.02401742135356, 2.786355991417711],
            [32.02487278638732, 2.787933613690604],
            [32.02475853146296, 2.788679174270585],
            [32.026298580728174, 2.789023634443784],
            [32.026241594301496, 2.789453894134729],
            [32.02678339070723, 2.789654654002225],
            [32.02698803770873, 2.790027012995326],
            [32.026594744497565, 2.790656911350081],
            [32.02692740142705, 2.791482800938773],
            [32.02865132505115, 2.793554604347137],
            [32.02817493677787, 2.793805552851728],
            [32.028281892890554, 2.794152675449449],
            [32.02900756275684, 2.794608028362231],
            [32.028875903872176, 2.795541305681482],
            [32.02849468132348, 2.795780337436604],
            [32.028910993863796, 2.796163629221674],
            [32.02936323991381, 2.796008434407619],
            [32.02983878556734, 2.796738707980618],
            [32.02954093745679, 2.797241165249607],
            [32.0301113676622, 2.798139110585043],
            [32.02956339533889, 2.798761012836565],
            [32.030002446934006, 2.80031702899316],
            [32.02869231068599, 2.801488630715576],
            [32.02929811205571, 2.802544852376284],
            [32.03531710473367, 2.802943422852785],
            [32.03805612462883, 2.803564061033554],
            [32.03986286124401, 2.804708602360429],
            [32.042320314993134, 2.805371016833812],
            [32.04409448767927, 2.806320548015703],
            [32.04860262633875, 2.809489756020746],
            [32.05154320572577, 2.80324974702177],
            [32.05206787754724, 2.800187489589054],
            [32.05450483892811, 2.800101970694801],
            [32.0556922994443, 2.799065935707915],
            [32.056357894475966, 2.799096217676807],
            [32.05643144403985, 2.799438431685443],
            [32.05684607313734, 2.798828866894539],
            [32.0574229595347, 2.798784846322533],
            [32.05749594765154, 2.800108560045476],
            [32.05883247280936, 2.800776164977036],
            [32.060372522074566, 2.803783464028843],
            [32.06322719916422, 2.80579622356055],
            [32.06397223940298, 2.808001185684854],
            [32.06607317427372, 2.808546256842137],
            [32.074867962077946, 2.814167428496937],
            [32.07698574036025, 2.816809352765979],
            [32.079875227167165, 2.818507219157678],
            [32.08122298126603, 2.820228073624143],
            [32.08105454715026, 2.820958612885714],
            [32.082302924222496, 2.824994724590637],
            [32.08165950590025, 2.829918368564319],
            [32.08228383502271, 2.83206636636025],
            [32.08230938131277, 2.836251601388281],
            [32.07526995816758, 2.836264218023771],
            [32.07059226159989, 2.834886852420738],
            [32.061479414489554, 2.833465745848464],
            [32.058883844765504, 2.833580000151674],
            [32.05762873032864, 2.833149616766394],
            [32.05509014703125, 2.833493363085678],
            [32.05429148904813, 2.834152817402663],
            [32.052394639731844, 2.834711755334856],
            [32.05093993041862, 2.834768952857832],
            [32.04996974991177, 2.835887247753612],
            [32.04877190307427, 2.836288611501265],
            [32.047602127691064, 2.837378166266388],
            [32.044778610463666, 2.837062178218822],
            [32.04400858628023, 2.836603197413806],
            [32.03885983563542, 2.837448261108045],
            [32.03843201298136, 2.837390922854965],
            [32.037434041294574, 2.835841966200952],
            [32.037662269072285, 2.835096436660435],
            [32.03660702978613, 2.834579976717238],
            [32.0362934611581, 2.833633413269697],
            [32.035523436974664, 2.833489998521873],
            [32.03569495860006, 2.83179790251799],
            [32.0346680719409, 2.831568270231034],
            [32.03386941395778, 2.831625467909309],
            [32.03281389349893, 2.832743765842054],
            [32.03200091816681, 2.832815263315506],
            [32.03120225928536, 2.833818885036191],
            [32.028235573059554, 2.835768506704746],
            [32.02441324152562, 2.836943718118692],
            [32.02224521418127, 2.838405896633337],
            [32.020376998664666, 2.838505991528306],
            [32.01695357571075, 2.84074229307772],
            [32.01438663978638, 2.840827668121389],
            [32.01109262992893, 2.838547066841644],
            [32.010037670917136, 2.836826098696338],
            [32.00804144547254, 2.835449014590858],
            [32.007242787489425, 2.835420274983685],
            [32.00530354936983, 2.834330017648285],
            [32.00419132275868, 2.833211300452736],
            [32.00098265285322, 2.833310975899618],
            [32.0002901074647, 2.833718088111993],
            [31.99842722614425, 2.833356397517185],
            [31.997900588808943, 2.834553200197516],
            [31.999114157062248, 2.834949096774423],
            [31.99843564785004, 2.835235785027794],
            [31.99821921046044, 2.837856212553518],
            [31.997254082977065, 2.8390401140419],
            [31.99750336546841, 2.839901998680101],
            [31.99678864337048, 2.840511681914445],
            [31.99760807489455, 2.842451058714941],
            [31.99680295982116, 2.844640249183692],
            [31.99712410753523, 2.844712306676226],
            [31.99687370214978, 2.845394184783317],
            [31.997229379306752, 2.846974110059868],
            [31.998512847268938, 2.84905745047305],
            [31.998440420599156, 2.850206292085882],
            [31.998833152363268, 2.850422041819599],
            [31.99890080718227, 2.854514686440682],
            [31.998328411463003, 2.856057870540254],
            [31.998649559177075, 2.856094038444116],
            [31.99858022091525, 2.857965258474217],
            [31.9999846802681, 2.860376615433183],
            [32.000962440759324, 2.859566755723531],
            [32.001504517439415, 2.860054466369494],
            [32.00275907132756, 2.862320305651046],
            [32.002801179856505, 2.86471511101052],
            [32.00348558381359, 2.865604312948996],
            [32.00320008753819, 2.866321224746331],
            [32.0035422899659, 2.866780194590186],
            [32.0028862386358, 2.867066734950071],
            [32.00314281993883, 2.868070606721774],
            [32.0055809042138, 2.870093067792572],
            [32.006122700619535, 2.871756510516492],
            [32.007234646057995, 2.87296126356239],
            [32.008260971270104, 2.875514036297169],
            [32.008417334723404, 2.877851338714164],
            [32.00895913112914, 2.878883938625885],
            [32.00830251835199, 2.881264130983684],
            [32.008458881805296, 2.883945713543696],
            [32.00811639910323, 2.885178912144434],
            [32.008458320358244, 2.886240102885308],
            [32.00690311202261, 2.889695626560253],
            [32.00596156531545, 2.890641722930269],
            [32.005903736269026, 2.89385387504197],
            [32.006331558923094, 2.894685579788912],
            [32.00965392140754, 2.897396568487137],
            [32.010366678889945, 2.898486485821008],
            [32.01229019649207, 2.907391945380041],
            [32.01317391415282, 2.909170140912759],
            [32.01308801275378, 2.910661524442445],
            [32.0137008317625, 2.913056368737129],
            [32.01495538565064, 2.915809788999072],
            [32.01722250884894, 2.918491850378099],
            [32.01582366306828, 2.923223606769122],
            [32.016065366473576, 2.92693764573061],
            [32.01877462877661, 2.928745108307571],
            [32.02054262554517, 2.932215640037257],
            [32.02082756037352, 2.932990123863541],
            [32.02072706135111, 2.936388590754315],
            [32.02004209594697, 2.938166460434971],
            [32.018130368732955, 2.939600052457542],
            [32.01677503554804, 2.941392214611835],
            [32.01426480577597, 2.942165990517114],
            [32.010299024070946, 2.944516612561261],
            [32.00978501974348, 2.946524077469552],
            [32.00994194374551, 2.947341444800708],
            [32.008686548135955, 2.948402296977781],
            [32.00700248815092, 2.952990527059566],
            [32.00380673152767, 2.95574300745271],
            [32.003036144998845, 2.957549581828477],
            [31.999884462418375, 2.960733928107255],
            [31.998622609718552, 2.962925272167538],
            [31.99459843841839, 2.964919247093321],
            [31.990767404005975, 2.967741644662937],
            [31.98567732502734, 2.969539649112729],
            [31.984465160840827, 2.970415451467507],
            [31.9823785433191, 2.973434216871074],
            [31.981902436218515, 2.976419192686206],
            [31.98029136345199, 2.977135193142653],
            [31.977720778570937, 2.97917904365775],
            [31.97563640593909, 2.979956717985544],
            [31.974812482838605, 2.980004656347433],
            [31.972535815040413, 2.978930658735065],
            [31.97094720015599, 2.977135612986782],
            [31.969041648859548, 2.976015636009048],
            [31.96742159383851, 2.975662822082423],
            [31.965643209850313, 2.97428744855749],
            [31.961258869816756, 2.973708254872004],
            [31.959955751207733, 2.973930568395807],
            [31.95795447363799, 2.973449495481145],
            [31.954177619315324, 2.968749912078511],
            [31.951160121682097, 2.967565026018796],
            [31.947983173984266, 2.966827152266919],
            [31.944264710155064, 2.967494518502503],
            [31.940898273627827, 2.965798137380821],
            [31.939692004186202, 2.964519191234007],
            [31.933433553891152, 2.963171417905918],
            [31.932448495486582, 2.963202396156221],
            [31.931621202805445, 2.964543301148739],
            [31.930953642259936, 2.964734358411304],
            [31.92965108509796, 2.964541338265275],
            [31.926536738297326, 2.96504946928717],
            [31.919387832976895, 2.96446746727898],
            [31.917894945264102, 2.964018769762204],
            [31.916114877833074, 2.964623901374853],
            [31.91458970646559, 2.964494660572684],
            [31.911286713455294, 2.96299003306055],
            [31.909985279187428, 2.961551144130589],
            [31.908175173889923, 2.960590950206292],
            [31.907412448518166, 2.960654169092982],
            [31.90493534412221, 2.959309895201031],
            [31.903791395303422, 2.959532352467493],
            [31.902838619655206, 2.958988335107692],
            [31.899946887060082, 2.959113230018215],
            [31.89823026224767, 2.960006002414176],
            [31.89616497971394, 2.959940119950644],
            [31.893240682291438, 2.961023248038634],
            [31.890854252043635, 2.964470971402965],
            [31.887419599250343, 2.967342570366852],
            [31.886910086499295, 2.96839625523685],
            [31.885574684235586, 2.96925748047267],
            [31.883985789076796, 2.969479514994917],
            [31.883285945774926, 2.97034130007887],
            [31.88208725631768, 2.970697339016851],
            [31.879166889024546, 2.969283973006229],
            [31.87842381429963, 2.969537546289129],
            [31.876005942118553, 2.969280748795578],
            [31.874916173389504, 2.968580582612841],
            [31.87295728462307, 2.965536853456995],
            [31.868551890774206, 2.962431158486413],
            [31.868003637278207, 2.960905641514151],
            [31.868197897958392, 2.960302050909671],
            [31.867271510321647, 2.960127113171894],
            [31.8672720717687, 2.959564172315458],
            [31.865419296495205, 2.959337089518522],
            [31.864542877646137, 2.960144774707722],
            [31.862864432131627, 2.958843114187222],
            [31.862324600341413, 2.959088279386154],
            [31.862254419459845, 2.957890766806146],
            [31.861653671113583, 2.958033324306923],
            [31.861236797126217, 2.957480195072866],
            [31.86174630987726, 2.95708167777752],
            [31.861177564013005, 2.955689180238097],
            [31.860434208115393, 2.955678106185482],
            [31.859203797348837, 2.954438397414096],
            [31.85908224361279, 2.953599028002682],
            [31.858299024974453, 2.953137710752547],
            [31.858869174905504, 2.952954081459599],
            [31.856733991764568, 2.950321443728388],
            [31.85637578854502, 2.951968928404385],
            [31.853900368490223, 2.953440208697467],
            [31.85031552905953, 2.954541846257879],
            [31.84375866920687, 2.954862427087074],
            [31.83790277644852, 2.956647416407715],
            [31.83624370040816, 2.956205584970655],
            [31.834128167914056, 2.95418706347737],
            [31.831879292194134, 2.952936139009944],
            [31.82952767076526, 2.952882451610354],
            [31.827786062008173, 2.953494596722405],
            [31.826991052981725, 2.954322753092835],
            [31.824353936175786, 2.954616840204332],
            [31.8227661639111, 2.954021515844182],
            [31.817923683082647, 2.950587777562373],
            [31.815187751595452, 2.951256275877425],
            [31.810380080484254, 2.955627643168907],
            [31.807138004928326, 2.956627791918686],
            [31.80592191061245, 2.956596812587448],
            [31.80333616576265, 2.955208379293182],
            [31.799445337688308, 2.954307614169617],
            [31.798084390032866, 2.951920147325451],
            [31.795660061659852, 2.951228380708191],
            [31.792216145439358, 2.95278068381975],
            [31.791661997198467, 2.954032310011391],
            [31.78998692036627, 2.955697730691309],
            [31.790170513552464, 2.956401829920004],
            [31.789647244899463, 2.956378981178403],
            [31.789100114297568, 2.957949219456598],
            [31.788421886258053, 2.958118971297233],
            [31.787934550216423, 2.958844655435442],
            [31.788198991778188, 2.959526604637847],
            [31.787173789460184, 2.960318311146715],
            [31.781812812727843, 2.96231299141463],
            [31.778865777148873, 2.961153890541023],
            [31.77678673871319, 2.961514558861904],
            [31.77573935878745, 2.962306263052827],
            [31.77340935351926, 2.963000125597005],
            [31.771895973438212, 2.964939852876845],
            [31.768895319216558, 2.965788605564943],
            [31.768129225162486, 2.965343132806177],
            [31.766917902697397, 2.967601751933782],
            [31.76749984301655, 2.967913637777839],
            [31.76739597531183, 2.968550725900501],
            [31.767904084894408, 2.9687587432262],
            [31.767615501109386, 2.969773598080974],
            [31.76524507165341, 2.970392182271382],
            [31.76466874580478, 2.969753553080604],
            [31.763342327592238, 2.969392466702193],
            [31.762625639980456, 2.970377604260611],
            [31.76076781168349, 2.970456661932101],
            [31.75835695803973, 2.969885596732787],
            [31.75554158224376, 2.96980121198819],
            [31.753465631317702, 2.968905644925874],
            [31.7512849709655, 2.968787198647649],
            [31.75002817218748, 2.967904245929414],
            [31.749093362844942, 2.968053951212224],
            [31.74666145448755, 2.965615350779653],
            [31.746130045301456, 2.966101894106327],
            [31.745057400258343, 2.965729451786589],
            [31.74541700754468, 2.964140721573422],
            [31.744044830948194, 2.963163708106378],
            [31.6807641336525, 2.947971676342874],
            [31.661288938567147, 2.943542806112504],
            [31.659204005386577, 2.943406834380187],
            [31.658047143285582, 2.94274702364985],
            [31.65564892264967, 2.940118286734388],
            [31.654514799603472, 2.939768124974057],
            [31.64959455790907, 2.940071747968361],
            [31.648577497022494, 2.93981578516908],
            [31.647250236190207, 2.938132958744972],
            [31.646587447495474, 2.937998949283477],
            [31.64534917647019, 2.936860849228955],
            [31.644323974152186, 2.936922387335533],
            [31.644086482048948, 2.936538020377556],
            [31.64365697505373, 2.937176247913445],
            [31.640928342378217, 2.937031865658827],
            [31.64006146812904, 2.938245661250346],
            [31.637326098088895, 2.940276266430077],
            [31.637543658372607, 2.940880008758184],
            [31.636566460226767, 2.942983361046431],
            [31.634148026598634, 2.944281535956777],
            [31.63178517712704, 2.943267919146817],
            [31.630156699501875, 2.94375138883305],
            [31.62970529607161, 2.943025834792737],
            [31.62841930204685, 2.94270286777278],
            [31.62833817249859, 2.941981657856873],
            [31.627598185283293, 2.941479124251154],
            [31.62706284596783, 2.942434709979267],
            [31.62672064354012, 2.941717144935311],
            [31.625384680727684, 2.940814125161159],
            [31.624673607586434, 2.938920333870638],
            [31.623374700279467, 2.939534028832134],
            [31.62314591015638, 2.938557976093836],
            [31.621324857090517, 2.938912343997137],
            [31.620425980359347, 2.937602247092045],
            [31.619800247170087, 2.937299743947659],
            [31.618714128296048, 2.937944980360595],
            [31.6182020885841, 2.93774550875165],
            [31.617821146309762, 2.938253511175669],
            [31.61644953116032, 2.937812793854205],
            [31.614952433043797, 2.937873630349033],
            [31.614734591587396, 2.937399270315393],
            [31.61323833519229, 2.936950562769203],
            [31.61207922730308, 2.938042543740545],
            [31.610894012575095, 2.938158610509035],
            [31.61036512945157, 2.938587973565486],
            [31.60994881691125, 2.939552532206091],
            [31.609086714512856, 2.940049179693965],
            [31.608121025582427, 2.942242667418711],
            [31.60601391479411, 2.943901658080642],
            [31.605692205632987, 2.945390331807761],
            [31.603318407494704, 2.94576320081009],
            [31.59977062356948, 2.945614753881415],
            [31.599202439152275, 2.946328391480794],
            [31.598126426325184, 2.946598791155968],
            [31.59712676939891, 2.947893177771675],
            [31.596492053955135, 2.946767423321624],
            [31.594020282857013, 2.946982873844775],
            [31.59308378917332, 2.946192000232686],
            [31.591565917515847, 2.946297411862436],
            [31.590363859376286, 2.944819112850931],
            [31.59091632327602, 2.944100148025873],
            [31.589639311505774, 2.943202878096321],
            [31.589146080719253, 2.943266237924675],
            [31.58877777145276, 2.942636003719524],
            [31.587587783975664, 2.942613855354234],
            [31.58817309297714, 2.941041772449084],
            [31.58700275614688, 2.93965962748569],
            [31.587766885585435, 2.939346051580879],
            [31.586812987043114, 2.938530360512392],
            [31.585959026076146, 2.939002477231097],
            [31.58542873978416, 2.938831181197336],
            [31.585010742004346, 2.938105623956101],
            [31.586186131858078, 2.93551079953124],
            [31.58472805386254, 2.935301093849366],
            [31.5841082163165, 2.934697909215109],
            [31.584050667544446, 2.934057998130354],
            [31.582821379671994, 2.93326220890575],
            [31.582211367000212, 2.933506539119732],
            [31.581941872414976, 2.932765278492893],
            [31.580669353119482, 2.932545058725229],
            [31.580007125871802, 2.931893791314774],
            [31.57871860488614, 2.931865475799886],
            [31.57870288436867, 2.931145801068998],
            [31.576418917758797, 2.930970998704321],
            [31.575429648052165, 2.928566661376874],
            [31.575578712693787, 2.928033702327573],
            [31.574974314492522, 2.927814323148855],
            [31.575054882593733, 2.927014744437161],
            [31.574473503721624, 2.92560118207911],
            [31.575184576862874, 2.925239660612475],
            [31.57487549981127, 2.924493348070774],
            [31.575409155683907, 2.923661946118804],
            [31.574885887030906, 2.922312442119325],
            [31.572338601753373, 2.921774012880299],
            [31.571742625257905, 2.921231519302792],
            [31.570433050456938, 2.920909947336197],
            [31.568660842386322, 2.921763079343346],
            [31.568385453056194, 2.921371137945409],
            [31.568646244762956, 2.92066253087649],
            [31.566975939781543, 2.920569732532089],
            [31.566520887394596, 2.919838696230908],
            [31.567041067639643, 2.919716880426054],
            [31.567010749498802, 2.919225130429586],
            [31.565712683913247, 2.917364104264421],
            [31.56410610362147, 2.917175421720166],
            [31.563454825040484, 2.916454896932757],
            [31.56399241014416, 2.914856143524201],
            [31.563771761452504, 2.913165990243791],
            [31.561705917471716, 2.912727925815858],
            [31.560639729518876, 2.911562605531945],
            [31.558649679991856, 2.91054433338283],
            [31.558506510993453, 2.907868140226552],
            [31.55939949297974, 2.906810894826191],
            [31.558743161375276, 2.905898454583284],
            [31.559236673334492, 2.905669819568502],
            [31.55888745326779, 2.905141616282231],
            [31.55773620563732, 2.90514568131772],
            [31.557785332703585, 2.904281883824522],
            [31.558576411600665, 2.903664524423309],
            [31.55761689858781, 2.903434065922744],
            [31.55736284334736, 2.903012539596766],
            [31.55767192039897, 2.90176548307224],
            [31.556444035694984, 2.899908633095544],
            [31.5565445347174, 2.898982590733143],
            [31.55849387888394, 2.897629551948181],
            [31.557844284644105, 2.896407021643255],
            [31.55799783996382, 2.895725733810325],
            [31.553951491055916, 2.894581003065215],
            [31.55301134841554, 2.892835166164439],
            [31.550297593637758, 2.891818840155914],
            [31.550325665990385, 2.890624620135067],
            [31.548837551026708, 2.889055409094053],
            [31.548563003417996, 2.888202112413737],
            [31.54633097021132, 2.88773544177341],
            [31.54599241763862, 2.887084569248017],
            [31.54655105745593, 2.885683153088392],
            [31.54581050879358, 2.884173513184265],
            [31.54589641019263, 2.883448621440424],
            [31.54528724014058, 2.883349090308132],
            [31.544800185271637, 2.882178412332382],
            [31.544196068243068, 2.881911081681768],
            [31.543845725282264, 2.882225234306794],
            [31.54327894403352, 2.881702066729224],
            [31.54376234994579, 2.881068153729743],
            [31.542856455575624, 2.88049662132397],
            [31.54263468398986, 2.8797340178292],
            [31.54319220091307, 2.878999030863931],
            [31.541596568389647, 2.878570485778056],
            [31.540924235095023, 2.877732602005071],
            [31.53921940156905, 2.879900137137751],
            [31.538370493625557, 2.880202935601163],
            [31.536862727116702, 2.881597769627133],
            [31.536179446053715, 2.88112240439848],
            [31.535119715191144, 2.882150796266599],
            [31.532980040473785, 2.882403127826185],
            [31.53122860594411, 2.883605627571649],
            [31.530300815138897, 2.883588384710784],
            [31.52933512620847, 2.884153466652642],
            [31.52751182645607, 2.883232877934391],
            [31.526233131242993, 2.883860341712355],
            [31.525374117252557, 2.883827258286772],
            [31.52484383006223, 2.883351333253213],
            [31.525305900986503, 2.883187458290917],
            [31.5252433000893, 2.882414342560868],
            [31.52435817836176, 2.882173225740828],
            [31.52295540335006, 2.883035218810201],
            [31.52295091177364, 2.88229112133037],
            [31.521383631877214, 2.882604152377209],
            [31.520157992961444, 2.881918090445391],
            [31.52010718245235, 2.881198664677954],
            [31.51945758821252, 2.880407184109725],
            [31.51798884272299, 2.879845745553386],
            [31.514967134686028, 2.880944510678926],
            [31.513447858961765, 2.881898464651065],
            [31.512824652733407, 2.883353296278751],
            [31.5109920895538, 2.884051692638332],
            [31.510985632463527, 2.885872961461977],
            [31.510332389267028, 2.886261130890394],
            [31.508880206016375, 2.886204355814082],
            [31.507408934464273, 2.886779529678117],
            [31.507435041303047, 2.887607594389833],
            [31.50565525414639, 2.887840439005783],
            [31.50433669619258, 2.889369559744543],
            [31.503396552653882, 2.889832164622774],
            [31.50182225511846, 2.892158924565898],
            [31.501136728267266, 2.892562931394798],
            [31.501337446037727, 2.893292303171579],
            [31.502404756884673, 2.893405010169546],
            [31.502473814872136, 2.894458203030119],
            [31.503127058068646, 2.895471583062489],
            [31.50208838102138, 2.896462533894035],
            [31.502926621470873, 2.898424525736653],
            [31.501812710518564, 2.899449116785355],
            [31.502093434044852, 2.900391139958127],
            [31.500754663997153, 2.901037938894357],
            [31.49887943084155, 2.901237417917994],
            [31.498032207239216, 2.902076686605368],
            [31.496774284668756, 2.898736851646455],
            [31.49607387991984, 2.898411908889535],
            [31.496098583590154, 2.899178845706434],
            [31.495550330094147, 2.899578645018132],
            [31.495811402973594, 2.900530200455264],
            [31.492652140408758, 2.905355252673003],
            [31.491480400410037, 2.904422345208922],
            [31.490595279580813, 2.905389596877837],
            [31.489459472193456, 2.905439501434218],
            [31.487583957865166, 2.903761249243797],
            [31.486612935636902, 2.904240670020424],
            [31.48604643556085, 2.905613607087511],
            [31.484830060072284, 2.905796403505422],
            [31.485032181011213, 2.907285968469114],
            [31.487671824778058, 2.909300509564308],
            [31.487443596102025, 2.911022910641665],
            [31.48711009655279, 2.911189865099934],
            [31.48656240540217, 2.910654375003141],
            [31.484988669313807, 2.913436117119879],
            [31.484526036942484, 2.91244251842648],
            [31.48352722263595, 2.911890908836814],
            [31.48276702332677, 2.91072937189244],
            [31.483006199771165, 2.90996412508937],
            [31.481699151032768, 2.908359194503778],
            [31.480307323789436, 2.908711329051266],
            [31.478048622296928, 2.906428199733029],
            [31.47740520397468, 2.906917853274096],
            [31.477395097927733, 2.907642309232098],
            [31.47676262737384, 2.908000331157549],
            [31.475996813594126, 2.907276716964687],
            [31.4754255416673, 2.90744633564263],
            [31.47485005843841, 2.908101261485217],
            [31.475028037154072, 2.909440550454344],
            [31.47430124349535, 2.909366394115786],
            [31.473685617251373, 2.90981819711976],
            [31.47334201165519, 2.910836329968658],
            [31.474828723450415, 2.911424527882464],
            [31.474584212809848, 2.911787455150075],
            [31.473745410913303, 2.911853760322061],
            [31.475008386507234, 2.913666573576427],
            [31.474947750225557, 2.914593726226861],
            [31.473719022901832, 2.914394109609274],
            [31.473680564227898, 2.913218417253992],
            [31.472744912265618, 2.912390652102038],
            [31.47156980358458, 2.912780353743626],
            [31.471233777972778, 2.913757551268128],
            [31.47042192553475, 2.914337476798399],
            [31.471616965136995, 2.915551436922109],
            [31.471722517182876, 2.916240141206429],
            [31.47125455151372, 2.916576713091138],
            [31.470585586901414, 2.916383405597103],
            [31.47001319208048, 2.915406210352724],
            [31.468187366265504, 2.915121083554117],
            [31.464028166500036, 2.91675726485154],
            [31.46363290777502, 2.918646888678807],
            [31.464582314740927, 2.920610104213362],
            [31.46433106673573, 2.921554913284268],
            [31.461676264796793, 2.922340897830554],
            [31.461396664164614, 2.921177269661476],
            [31.460012135732963, 2.919769307130876],
            [31.459924549992763, 2.918636515830185],
            [31.45851447527106, 2.917192383260598],
            [31.456080322023787, 2.916869969507157],
            [31.455774613654494, 2.917686377023477],
            [31.455127265202876, 2.917898609686044],
            [31.454828856543596, 2.917595681354906],
            [31.454755025807014, 2.918154858303163],
            [31.451165133352855, 2.920341940227611],
            [31.451091864961658, 2.921055593956909],
            [31.451725738684015, 2.921720044072392],
            [31.451343954688266, 2.922402296780302],
            [31.450454902831346, 2.922637237132747],
            [31.449846294226358, 2.92206838937388],
            [31.447774274327994, 2.922825917862391],
            [31.446987405834648, 2.923953378581818],
            [31.446539932533742, 2.926160635845687],
            [31.445079889922688, 2.926343568878957],
            [31.443668130859823, 2.92809005453919],
            [31.442882104986218, 2.927406263102849],
            [31.4421485748612, 2.927536068924782],
            [31.441630078058978, 2.928565819857585],
            [31.440386472837528, 2.929642249897068],
            [31.44011024088766, 2.930516401541832],
            [31.43908756553056, 2.930942403258349],
            [31.438266729939695, 2.932389881495576],
            [31.436680360843482, 2.932132374753793],
            [31.436432201246244, 2.932540433077041],
            [31.436938065040614, 2.933804556704491],
            [31.43500949441502, 2.933061614140549],
            [31.434621534501687, 2.933597093547636],
            [31.434819163864194, 2.93438377120619],
            [31.43386470387482, 2.934623475535477],
            [31.434028084967114, 2.935867971952274],
            [31.433539345757016, 2.935950256387673],
            [31.433140437176995, 2.935158393483897],
            [31.432791217110296, 2.93514521633841],
            [31.433101135883316, 2.935981516199943],
            [31.43226205371241, 2.936848232813204],
            [31.4318347925054, 2.938257855997159],
            [31.43140331999633, 2.938270051640988],
            [31.431581579884686, 2.93771508960401],
            [31.430357905584433, 2.936730623732502],
            [31.429276839733866, 2.938139406449997],
            [31.427422380119218, 2.938187206667535],
            [31.42711302279325, 2.93913746803628],
            [31.42652855641151, 2.938122725132626],
            [31.426109716910293, 2.938032731780603],
            [31.425550795920287, 2.938306357768641],
            [31.425370852589104, 2.939703643530491],
            [31.424063803850714, 2.939318857671682],
            [31.42372019825454, 2.940026751371841],
            [31.424672692730063, 2.943245631738908],
            [31.424020291254973, 2.94571287729541],
            [31.422862587432565, 2.94782953740596],
            [31.41794431125201, 2.951495414978427],
            [31.41767397494536, 2.952291332033137],
            [31.41614964619762, 2.951108250432914],
            [31.41426346437533, 2.950763979057692],
            [31.412398056992316, 2.950704824477726],
            [31.404846032688134, 2.951802539835966],
            [31.403061192507998, 2.951213802445226],
            [31.40013914087371, 2.94895599143655],
            [31.398148811072332, 2.945780722622315],
            [31.397443633574294, 2.940231269841806],
            [31.398985086906304, 2.930728070166917],
            [31.39921443757812, 2.926908769375747],
            [31.398399777904835, 2.92318239365851],
            [31.397546098110556, 2.921268666610612],
            [31.39388742794329, 2.916115521411458],
            [31.382714912769742, 2.906348436844729],
            [31.379086841916003, 2.90227686613004],
            [31.376060080855577, 2.892860539941362],
            [31.371811891283105, 2.884563925238449],
            [31.3709621416182, 2.878675764674191],
            [31.371434598863775, 2.875067966989908],
            [31.37289969539663, 2.869242560625291],
            [31.37499277000863, 2.864307449013153],
            [31.375248228417554, 2.860178391605996],
            [31.374206182687974, 2.856485161701311],
            [31.372601847286077, 2.853183884080126],
            [31.37104355144082, 2.852142428922749],
            [31.36727904895331, 2.851668453784884],
            [31.36559133911327, 2.851061720176147],
            [31.363924402814174, 2.849868299131546],
            [31.362306312408652, 2.848039823159199],
            [31.361834696884486, 2.841200010759809],
            [31.361034634834574, 2.837202367936203],
            [31.36151607523299, 2.834246604337053],
            [31.366350695802712, 2.824019273460181],
            [31.37260240873313, 2.814325845552107],
            [31.378293236058028, 2.802117120528263],
            [31.380080883473422, 2.794899914421284],
            [31.381976328722917, 2.789486279507587],
            [31.38176129450178, 2.785985032772786],
            [31.38629469917696, 2.778340127990067],
            [31.386941766455884, 2.775592968813279],
            [31.393604178354426, 2.767930472246393],
            [31.402215372074128, 2.765778290473548],
            [31.40985049054209, 2.762051114080276],
            [31.414744063052332, 2.76028727223918],
            [31.423154259625544, 2.76226561762495],
            [31.42863201734482, 2.762469746879342],
            [31.432350762346715, 2.76149101991298],
            [31.438030922177614, 2.756580828121974],
            [31.445481604839642, 2.744197516779626],
            [31.449009457843662, 2.739284309785964],
            [31.449603468825284, 2.733777046141686],
            [31.45137146559384, 2.728271300571605],
            [31.4519626693402, 2.724928022740067],
            [31.45040633811047, 2.718040949083003],
            [31.45383481408785, 2.707731014388547],
            [31.45391622391047, 2.703108445504972],
            [31.45223272537249, 2.693368464000272],
            [31.452386280692206, 2.69117114248501],
            [31.45201235695519, 2.688821412430777],
            [31.450808614474468, 2.687228516362409],
            [31.44583700082392, 2.685251871083165],
            [31.442414700764115, 2.679829188320001],
            [31.442314763188758, 2.676856909519814],
            [31.4445588670579, 2.676898972100087],
            [31.44464841741362, 2.677321280326009],
            [31.443958118711645, 2.677652172459755],
            [31.443987594232738, 2.678134770512758],
            [31.444856995442816, 2.678437620742607],
            [31.445185441968572, 2.679523814236286],
            [31.446383569978764, 2.680792138291922],
            [31.44689448679661, 2.679887934907804],
            [31.44674570332768, 2.67916390015533],
            [31.445725834307506, 2.679162497623263],
            [31.445666320919937, 2.678830624214554],
            [31.44725802331399, 2.677083346617586],
            [31.448185815017535, 2.678683124992629],
            [31.44866332528658, 2.680674363437945],
            [31.449294391773677, 2.679740155845381],
            [31.449295795840474, 2.678443229079491],
            [31.45061603813544, 2.67802260374196],
            [31.452205214466915, 2.678416729014478],
            [31.453047103873082, 2.67681919362928],
            [31.454067253167615, 2.676609441534314],
            [31.454185718495705, 2.677695356680787],
            [31.45676584887498, 2.677125549174321],
            [31.458084406828785, 2.678152717195133],
            [31.459463601962604, 2.678425983219154],
            [31.459884687252032, 2.677551783160824],
            [31.459105117570367, 2.677309502807736],
            [31.45982573531151, 2.676616732383137],
            [31.459916970008386, 2.675711965979037],
            [31.461492390437915, 2.675171040114175],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 542,
        District: "AMURU",
        County: "KILAK",
        Subcounty: "AMURU",
        Population: 42301,
        Key: "AMURUAMURU",
        Dist2: "Amuru",
        "Sub Country": "Amuru S/C",
        id2_original: "Amuru Amuru S/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.915142104788305, 2.793826032527052],
            [31.915074789532504, 2.795676155501566],
            [31.915720509338488, 2.797190854930754],
            [31.914686628396524, 2.798266030262687],
            [31.91503571281763, 2.798619545300414],
            [31.91458519063465, 2.79955227838956],
            [31.914929196879463, 2.800004745467364],
            [31.914765586716737, 2.801053186686608],
            [31.91667732201559, 2.802930893785481],
            [31.91868605470391, 2.80337528708733],
            [31.919010716627362, 2.804058619665327],
            [31.919756792623648, 2.804251716401475],
            [31.919907278400046, 2.806457051998409],
            [31.918934685916657, 2.808978971380962],
            [31.919306831887717, 2.809284816638905],
            [31.919598958628228, 2.811344736983187],
            [31.920852322248614, 2.812577752235702],
            [31.920948116793895, 2.814982410003598],
            [31.92676220914544, 2.819802297036642],
            [31.92573404418361, 2.821278233706045],
            [31.923519525430045, 2.822281362961583],
            [31.918593294667662, 2.821415175578169],
            [31.915376556094298, 2.825145712058269],
            [31.9128195744016, 2.827393019611806],
            [31.910681231885796, 2.827339191689697],
            [31.910294509850935, 2.82762378591667],
            [31.90851717509502, 2.827233524978865],
            [31.905167334942654, 2.827826174857501],
            [31.904135862383946, 2.828809599079696],
            [31.90418587968067, 2.830415778132756],
            [31.903463738396816, 2.831218155778708],
            [31.902482347813518, 2.833730039040216],
            [31.9019634279048, 2.837589437713823],
            [31.901399636249334, 2.838898074494597],
            [31.898938157149427, 2.840848186446909],
            [31.893887150394068, 2.843251371605118],
            [31.893245602364242, 2.845859687482823],
            [31.89192219889779, 2.848335454197185],
            [31.891802046533584, 2.850023563911465],
            [31.890449761332448, 2.850069562670835],
            [31.890197912354335, 2.850868768503677],
            [31.88940251435738, 2.851183569357322],
            [31.889026274763545, 2.85078347943807],
            [31.888837640231976, 2.851119905606637],
            [31.888394683660316, 2.852984337432865],
            [31.889021337622733, 2.853467126135685],
            [31.888356077662692, 2.854764660872708],
            [31.888355184737275, 2.855691936020555],
            [31.886951868939796, 2.857285484571433],
            [31.887276482354235, 2.859200598920421],
            [31.887020608923656, 2.860073006034316],
            [31.88597238278491, 2.860234105696385],
            [31.884947612556545, 2.861425932421403],
            [31.88403565635484, 2.860897990311183],
            [31.88329752056736, 2.861307195800457],
            [31.882966723150503, 2.862087685508508],
            [31.881238935872386, 2.862007909641068],
            [31.879453876503298, 2.860932538624346],
            [31.87768698017098, 2.861145523878447],
            [31.87712474978747, 2.860344637570105],
            [31.875707100471303, 2.860772687956963],
            [31.875589854157038, 2.861553385281027],
            [31.874871625934574, 2.861455075117387],
            [31.874754378722013, 2.86223577018231],
            [31.873570231192584, 2.862117479551059],
            [31.873376605621274, 2.861590240263126],
            [31.872852156582017, 2.861863005493799],
            [31.872289338700302, 2.861667246518472],
            [31.872212102450497, 2.86123772416796],
            [31.87081417205312, 2.861353462369346],
            [31.870096214223544, 2.860981865542601],
            [31.86972859037161, 2.859712684759516],
            [31.86906822533151, 2.860004833467385],
            [31.868660913012015, 2.859614024531349],
            [31.867884293397747, 2.85967181476214],
            [31.86807933471395, 2.8587545573458],
            [31.866564732924086, 2.859065377866793],
            [31.865806549434417, 2.860118717288533],
            [31.865903178514564, 2.86056777919137],
            [31.865378979206938, 2.860586777315011],
            [31.862662842097016, 2.858729652044369],
            [31.860296626638064, 2.860209594296197],
            [31.860580636201632, 2.858636714056951],
            [31.859279362732213, 2.856043969331794],
            [31.858977773138516, 2.854397338868696],
            [31.858281039804165, 2.853725915798155],
            [31.858294274683235, 2.850558304646809],
            [31.854310144888526, 2.846970437793497],
            [31.851854345836156, 2.846393599337919],
            [31.850184795439613, 2.845283675696936],
            [31.84614395769596, 2.847611750085569],
            [31.84243209019588, 2.848403673213843],
            [31.839235130728483, 2.852735451816959],
            [31.838061608472216, 2.852898879850195],
            [31.83732316635923, 2.85457177262569],
            [31.8350834435737, 2.85670955925442],
            [31.833561578904796, 2.850534739590147],
            [31.831686777838836, 2.848447323154234],
            [31.831293916717343, 2.846233623731244],
            [31.83041495563602, 2.843750686493203],
            [31.830114082897904, 2.843697401246553],
            [31.82981054216341, 2.842636887950343],
            [31.829907498230334, 2.839432816800707],
            [31.82740560392577, 2.834199932931882],
            [31.827781337768105, 2.833375713704383],
            [31.82387232509745, 2.829390081847148],
            [31.82181099694761, 2.828775416767205],
            [31.82108631971968, 2.827101915085719],
            [31.81883874206533, 2.825309057860717],
            [31.81794855024633, 2.825119666557767],
            [31.81951991029078, 2.823660555037038],
            [31.820386765675345, 2.823755679684691],
            [31.82111499933345, 2.822667990903764],
            [31.820956067596743, 2.822063897865578],
            [31.820449518387818, 2.821836907777404],
            [31.82019863420032, 2.819354873772125],
            [31.81945805769019, 2.818542586113988],
            [31.820275214679977, 2.817863997592711],
            [31.819393802096247, 2.817117622079144],
            [31.81966939175069, 2.813711356439851],
            [31.82193335198087, 2.811477226153684],
            [31.82244934877163, 2.811638169287718],
            [31.823153826482063, 2.811016080081468],
            [31.82449875987094, 2.80566688484715],
            [31.825570697939902, 2.804770507378076],
            [31.82517938461564, 2.801393938516711],
            [31.823425341378368, 2.7967328373045],
            [31.82302705353424, 2.795757444203454],
            [31.822384506577812, 2.795684999656618],
            [31.82309924304879, 2.794967752552199],
            [31.831669501439293, 2.792966047360131],
            [31.833483261083387, 2.791968521380972],
            [31.840985269887508, 2.791798913500301],
            [31.84390921966196, 2.791093515792682],
            [31.849616958670413, 2.788938845995954],
            [31.853385770376338, 2.788659227472948],
            [31.859372936642103, 2.788912984522193],
            [31.860430016576267, 2.788418205959205],
            [31.86173459045606, 2.786932048495902],
            [31.863389388719042, 2.787500296504773],
            [31.864974937653404, 2.78682895055514],
            [31.86610153910571, 2.78729043723172],
            [31.867475361415817, 2.787043862340547],
            [31.868709047439886, 2.786018019400979],
            [31.87036435864091, 2.786055032004551],
            [31.87339561487102, 2.783614312503358],
            [31.873512096718954, 2.784582398568145],
            [31.87361925585088, 2.783713279762339],
            [31.875483357981807, 2.78438340811905],
            [31.87814185558984, 2.784534477096515],
            [31.883257885998695, 2.78259003767239],
            [31.88543605801756, 2.783056236602526],
            [31.8874118746372, 2.782742508393615],
            [31.887928484977316, 2.783114299815643],
            [31.890367332820286, 2.781241539026469],
            [31.89049707559844, 2.780703275243846],
            [31.891088076325556, 2.780499618399917],
            [31.892672452060143, 2.77863124015934],
            [31.893640353541127, 2.778939591291956],
            [31.895373188452826, 2.778633784786199],
            [31.898175650966593, 2.778841376432676],
            [31.89929737816021, 2.778125073748142],
            [31.899470493396926, 2.778620845412349],
            [31.898076764420136, 2.780222947160449],
            [31.898451499335827, 2.781494745860846],
            [31.898130374079653, 2.782293395791936],
            [31.89851443440635, 2.782723299937075],
            [31.899369229009885, 2.782251605180012],
            [31.900307744801278, 2.783627024816832],
            [31.900006605263524, 2.785903322583087],
            [31.900732012821763, 2.786763091294454],
            [31.901301423439335, 2.786575101536627],
            [31.900456027908593, 2.788896492146037],
            [31.90093574084673, 2.790132613087045],
            [31.902804533980067, 2.791459579228561],
            [31.902643414845663, 2.792354840830331],
            [31.904263540833604, 2.79296524252851],
            [31.90526133824722, 2.792482654793151],
            [31.906027076568442, 2.792572913509476],
            [31.90622233797187, 2.793271518161679],
            [31.908946781803213, 2.793771917732033],
            [31.909228951617127, 2.794218694903389],
            [31.912661103500636, 2.793369460848361],
            [31.913267349536426, 2.792598774005445],
            [31.913710996912556, 2.793045700566357],
            [31.91484132996657, 2.793046751243931],
            [31.915142104788305, 2.793826032527052],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 543,
        District: "AMURU",
        County: "KILAK",
        Subcounty: "AMURU TOWN COUNCIL",
        Population: 9302,
        Key: "AMURUAMURU TOWN COUNCIL",
        Dist2: "Amuru",
        "Sub Country": "Amuru T/C",
        id2_original: "Amuru Amuru T/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.20095428263131, 3.504088671411746],
            [32.194393604040386, 3.50685572225041],
            [32.10322121340443, 3.52933328486381],
            [32.097260374963, 3.530062736353953],
            [32.08508104957859, 3.530071882681169],
            [32.08560396968525, 3.531204215404759],
            [32.08415750600802, 3.533156402646163],
            [32.08377536448279, 3.535106728013107],
            [32.08404407573709, 3.536154202593185],
            [32.08530192284906, 3.536152012187258],
            [32.08617140041593, 3.535614332380429],
            [32.0875436336063, 3.533004267108756],
            [32.089749893249156, 3.534998815201584],
            [32.0891158847795, 3.53779038416222],
            [32.08774087759155, 3.539303779494716],
            [32.087022220872676, 3.542107673586726],
            [32.0874363235574, 3.543252377215512],
            [32.08919572434699, 3.545503612137213],
            [32.08917312093783, 3.546137283768115],
            [32.08864224355438, 3.546650002541353],
            [32.08680364100109, 3.546580098628769],
            [32.08522984382729, 3.545997942089794],
            [32.08488765128108, 3.544585025861432],
            [32.0833407406837, 3.545075139612528],
            [32.08281003847172, 3.545660962015947],
            [32.08395280331097, 3.547998569791203],
            [32.08332813642197, 3.549705609592128],
            [32.081820399557515, 3.551353252516698],
            [32.08175203237452, 3.553034954798808],
            [32.08248187042374, 3.55469089776198],
            [32.081856467814504, 3.556105488592089],
            [32.08343052100815, 3.556785137893283],
            [32.0844394278869, 3.558793977326331],
            [32.08492401598208, 3.559109957328417],
            [32.08659263572401, 3.558912091369758],
            [32.08664290814227, 3.559667494416098],
            [32.08391249051429, 3.560890774147754],
            [32.081948473265896, 3.559042010703278],
            [32.0811748261769, 3.559213944776177],
            [32.081177862482555, 3.560432481298116],
            [32.08219798033605, 3.562087920539963],
            [32.081443083782, 3.564928421696476],
            [32.07933879011041, 3.565029544820169],
            [32.07769562952193, 3.56573913945653],
            [32.07682939846651, 3.567592807155086],
            [32.075207757918996, 3.567230045002214],
            [32.07372924325072, 3.566062795350297],
            [32.07295582972373, 3.566332203821759],
            [32.07238090524694, 3.568599675820452],
            [32.072527315366905, 3.569111212965626],
            [32.073544578374424, 3.56962123730824],
            [32.07381224039648, 3.570254418068314],
            [32.073559969210166, 3.570949416077988],
            [32.072158515620266, 3.571585466740971],
            [32.07017437341457, 3.571369547428734],
            [32.06882141627357, 3.572054243900742],
            [32.06911369842261, 3.572857975580368],
            [32.07032532092501, 3.573708865161262],
            [32.070741159154856, 3.575560323768474],
            [32.06958074331861, 3.575854764275713],
            [32.06778608006085, 3.574005666030307],
            [32.0664334714662, 3.574836587095447],
            [32.06587950827824, 3.575812364755254],
            [32.0653233226583, 3.575886422929725],
            [32.0650834051038, 3.576691074713906],
            [32.06473228869352, 3.576441336349624],
            [32.06279825271772, 3.57881877826509],
            [32.062889502685984, 3.579692404520639],
            [32.062406599830254, 3.580058783857247],
            [32.06200775952222, 3.579607499141924],
            [32.058158958230145, 3.574218350801699],
            [32.05647996564161, 3.570299787291343],
            [32.05646231823786, 3.568020227394761],
            [32.05924175962584, 3.54744387054485],
            [32.06331680611382, 3.527664807621897],
            [32.06365955920879, 3.524481022979827],
            [32.06362234110824, 3.499740641948699],
            [32.06158491443313, 3.497576642761533],
            [32.06028035762136, 3.497086856389481],
            [32.058966097207865, 3.495228392537777],
            [32.05715296189289, 3.491717853138713],
            [32.0560740807451, 3.487494051226064],
            [32.05530755819464, 3.479252543306171],
            [32.05398834357236, 3.476845028183854],
            [32.05358570608559, 3.474384162571732],
            [32.051915395714296, 3.451369943867369],
            [32.051910751424266, 3.443852870139408],
            [32.05317530895142, 3.426929412207925],
            [32.057583225269596, 3.413162077031309],
            [32.05734096221388, 3.409861228433425],
            [32.03940311426137, 3.410180822932406],
            [32.0226053101511, 3.40994683337661],
            [32.02074535105028, 3.410054833115884],
            [32.01867873002678, 3.411761416236084],
            [32.01760703809619, 3.411710060900528],
            [32.01732183916315, 3.411121057061605],
            [32.01885374340368, 3.408969848485499],
            [32.02016110924739, 3.408431690037637],
            [32.02042973246677, 3.40667910066355],
            [32.02143070722159, 3.405703183148603],
            [32.021776873914625, 3.40469041353684],
            [32.02194559998286, 3.403084852589034],
            [32.02519791543473, 3.399099905297895],
            [32.026515505902964, 3.398789025181746],
            [32.02730308137046, 3.397152914243678],
            [32.02782186832851, 3.394520085305466],
            [32.02844153249968, 3.393688501934058],
            [32.03000109766446, 3.392747470634731],
            [32.02995915262889, 3.391821281287682],
            [32.02794159129797, 3.38920128188932],
            [32.029958556147555, 3.385252102403231],
            [32.030958683791006, 3.384189970437123],
            [32.03114576783039, 3.380329035168069],
            [32.03194406109752, 3.377999350518712],
            [32.03123562990153, 3.376335652507879],
            [32.02967922321331, 3.375137201911307],
            [32.02748570437612, 3.370727887326777],
            [32.02764200404903, 3.369255102119793],
            [32.02938998904802, 3.366528507002936],
            [32.02834334933409, 3.365226992434164],
            [32.02836565809584, 3.364224715724552],
            [32.03086341296357, 3.361388508713284],
            [32.031748363112875, 3.359202881886073],
            [32.03346402852455, 3.358114051447071],
            [32.034974920272276, 3.356462651903366],
            [32.036443239960384, 3.356580610899785],
            [32.03678079091152, 3.355304763120523],
            [32.0384206124621, 3.354039226605896],
            [32.03852075395503, 3.351904422607093],
            [32.040694223293364, 3.348632367431073],
            [32.04137304601759, 3.345427887482549],
            [32.04362852255825, 3.340228206364853],
            [32.043632737453564, 3.339320536017301],
            [32.04453851055115, 3.337871878296326],
            [32.04303986912898, 3.336338421308817],
            [32.04342281374805, 3.33401923812389],
            [32.046508478239986, 3.331214833765334],
            [32.04689020833681, 3.330306725530084],
            [32.04639061388482, 3.329851384192289],
            [32.04358158738127, 3.32936779257626],
            [32.04305820733716, 3.328888482940523],
            [32.04412149552827, 3.324477891036089],
            [32.04717049977346, 3.322737693351659],
            [32.049446652836984, 3.319907841363454],
            [32.05137611998125, 3.318763454000419],
            [32.05161465323189, 3.318237733821229],
            [32.051282065472684, 3.317376118618922],
            [32.05204510525479, 3.3160143081253],
            [32.05127253524584, 3.314589829190131],
            [32.05172676657261, 3.312390356384225],
            [32.05120409799423, 3.311073979784143],
            [32.0504430273192, 3.310139822030037],
            [32.0487056307625, 3.309419089768814],
            [32.04884937019109, 3.308367029366254],
            [32.048433308280735, 3.307684636612505],
            [32.04886273442758, 3.306657031539393],
            [32.05017313478031, 3.30553539465103],
            [32.05029293859818, 3.304650704837704],
            [32.04912732870295, 3.303476628466708],
            [32.049175486487016, 3.302830975194286],
            [32.05104587862156, 3.301124428673437],
            [32.052571726420425, 3.298616023867482],
            [32.051671022515954, 3.297274119612864],
            [32.05173199117429, 3.295564203130128],
            [32.05061453187662, 3.293768393279181],
            [32.049258506988934, 3.292546136980575],
            [32.050010614274036, 3.290000421955633],
            [32.04932225323813, 3.287559670711393],
            [32.05001307925117, 3.287082618825434],
            [32.05084612833664, 3.287347243205606],
            [32.05113233428111, 3.286749867002363],
            [32.05052768006001, 3.283842889989387],
            [32.05102869295185, 3.282600167264888],
            [32.050898585457674, 3.281607383996869],
            [32.05175652146976, 3.280580562750421],
            [32.052138470755516, 3.279361525213916],
            [32.053209773715594, 3.279411346706173],
            [32.05393683686891, 3.278300572216093],
            [32.05470195804753, 3.274379672871098],
            [32.056286458647946, 3.272816067879487],
            [32.05666834056005, 3.271668777054856],
            [32.058168570203655, 3.27124104173388],
            [32.05888382140931, 3.269998701562256],
            [32.06052684096228, 3.269642980135496],
            [32.06078935653606, 3.268878134650081],
            [32.06027847924409, 3.267693314021867],
            [32.060232150429954, 3.266138659093536],
            [32.05961386966428, 3.265276519010249],
            [32.059972087256874, 3.26393786235437],
            [32.06032947660279, 3.263603680421495],
            [32.06347101900031, 3.264853111887947],
            [32.064161986048866, 3.264184717129916],
            [32.06449363776356, 3.26619431529201],
            [32.065160432944445, 3.265956371277588],
            [32.065638432795346, 3.263709091768798],
            [32.06258160422403, 3.260773705289528],
            [32.06334520275826, 3.258622611705197],
            [32.063988527655724, 3.257978037981792],
            [32.06539296544901, 3.25821978299715],
            [32.06694223053071, 3.256022282843385],
            [32.06744222113976, 3.255975367826868],
            [32.070249406995295, 3.258515663498497],
            [32.07053536680136, 3.258181350615355],
            [32.070193052982574, 3.25462911489109],
            [32.072930552029945, 3.255040679613729],
            [32.07419256373155, 3.254755980219957],
            [32.07590842048442, 3.252606608323108],
            [32.074671668510256, 3.251097609441753],
            [32.07601580958503, 3.248353366141851],
            [32.074409798825144, 3.245575460169762],
            [32.07296019104444, 3.245396111277744],
            [32.072916258037125, 3.245063610216952],
            [32.07371139462436, 3.244169499108208],
            [32.0753738492285, 3.24446939904256],
            [32.07613813677054, 3.244215481923025],
            [32.07672463154819, 3.244979938065177],
            [32.077315215456984, 3.244370241389357],
            [32.0770215436142, 3.24363793779647],
            [32.0760713497241, 3.243486901151452],
            [32.07350183024498, 3.241280974133187],
            [32.07422921769012, 3.237895512324771],
            [32.07421377385376, 3.23605696690338],
            [32.074796850541745, 3.23497113714469],
            [32.07390704499829, 3.233658308245824],
            [32.073868341084285, 3.232851437903384],
            [32.07505331147049, 3.23113065091224],
            [32.07525384418802, 3.230207358014847],
            [32.07622285329172, 3.229729948885164],
            [32.078119048634484, 3.230411530071403],
            [32.07815932370192, 3.231076095951801],
            [32.0793137334022, 3.232130408811014],
            [32.0798165366364, 3.231850364982454],
            [32.07980527894924, 3.230711634981927],
            [32.08040378240561, 3.230385016272253],
            [32.080271982485435, 3.229387519504678],
            [32.07932910986492, 3.228572358508157],
            [32.07790539153066, 3.22820349470446],
            [32.077947988743134, 3.226495952302436],
            [32.079700852492415, 3.225065012327279],
            [32.07970554978304, 3.224638065361564],
            [32.08201613886466, 3.223342700880057],
            [32.082350552898866, 3.223227159388611],
            [32.082489402797364, 3.223584256853462],
            [32.08219239191667, 3.22462527028664],
            [32.083193821218984, 3.224444671006494],
            [32.08347355749679, 3.222810460465769],
            [32.08169685245988, 3.222082547752476],
            [32.08036519437427, 3.221999195690031],
            [32.07989767157454, 3.221235829893987],
            [32.080385552893546, 3.220149117890932],
            [32.081103536774265, 3.219776155799656],
            [32.08127133218787, 3.216421125883568],
            [32.08244107523172, 3.213917377496772],
            [32.08211396809406, 3.213368794176586],
            [32.082266908966126, 3.212445055550631],
            [32.08345683984935, 3.21243223520926],
            [32.08433427648963, 3.210542560515107],
            [32.08566461764502, 3.21074450680833],
            [32.08569420725219, 3.212381544004866],
            [32.086508928909204, 3.211867131012671],
            [32.086944254292526, 3.211230641856536],
            [32.08637920679228, 3.210679881200512],
            [32.08623536765068, 3.209694127159145],
            [32.08805566253845, 3.208619599898919],
            [32.08808989284235, 3.207671059269334],
            [32.0894732974816, 3.207375340627357],
            [32.08958809139512, 3.207755932761283],
            [32.08908269741963, 3.208273173081807],
            [32.089389926636706, 3.208465758803384],
            [32.091511711405175, 3.208105628084605],
            [32.09099659675999, 3.207341826757379],
            [32.09232817579387, 3.20526652714583],
            [32.092717685301054, 3.203384238726882],
            [32.0934092515259, 3.203248234625138],
            [32.093226729131544, 3.202534918664505],
            [32.094034573286756, 3.200478542268363],
            [32.09478475638054, 3.201505425973638],
            [32.095662502041286, 3.201750655488971],
            [32.096061004582786, 3.202299892614554],
            [32.096726434324445, 3.202377133826579],
            [32.09697062157149, 3.201810052658148],
            [32.096797196416006, 3.200266578105976],
            [32.09614957577484, 3.200735086599124],
            [32.09601645263627, 3.199856181402195],
            [32.09430828456394, 3.199389863670874],
            [32.09446090114418, 3.197410520744032],
            [32.09517938538652, 3.196990103434647],
            [32.09550823615417, 3.195213998590493],
            [32.09662521485316, 3.195342816748981],
            [32.09752049922152, 3.196157526222649],
            [32.098922993958844, 3.196288939046009],
            [32.10003102094606, 3.19506554955177],
            [32.09977815148177, 3.194256707756399],
            [32.09932712624225, 3.194157703970026],
            [32.09950018578341, 3.19356625072788],
            [32.09852440787401, 3.193581054396065],
            [32.098314171554804, 3.19322331411991],
            [32.09855596658828, 3.191790381232199],
            [32.097890013128804, 3.191760579211951],
            [32.09496884274181, 3.189077090621005],
            [32.09622613469493, 3.187262027582186],
            [32.09625773832495, 3.186550671059281],
            [32.09697621448245, 3.186130251100033],
            [32.09795949152782, 3.184348262475585],
            [32.09702782089891, 3.182513204810719],
            [32.096148120504104, 3.179196028157157],
            [32.09754059363612, 3.178070122216033],
            [32.097584173605505, 3.176267685678987],
            [32.098990549064865, 3.176043318188172],
            [32.09879099101942, 3.17471309383675],
            [32.100035237638004, 3.174083970623943],
            [32.10104254012564, 3.172278475744891],
            [32.10236894486346, 3.172836178658646],
            [32.10283505551158, 3.171559473243425],
            [32.10463120997269, 3.170508388018918],
            [32.10629865381995, 3.168175174609034],
            [32.10794053790238, 3.167087099595302],
            [32.107309317803384, 3.166061321592635],
            [32.1084570844621, 3.165549908132636],
            [32.109479904447966, 3.165582952467671],
            [32.11056812088823, 3.166162198204829],
            [32.11081046658892, 3.165761137664507],
            [32.11054080940865, 3.164311663729622],
            [32.110924090895956, 3.164077942985037],
            [32.11239272948597, 3.164684367007637],
            [32.113405938396625, 3.165595015474979],
            [32.11455993666847, 3.164514342932633],
            [32.11472485657487, 3.163578844515845],
            [32.11527338675198, 3.163465239982944],
            [32.11609989071229, 3.164042086676655],
            [32.11660213070281, 3.163809437721897],
            [32.11684951505395, 3.160775337318938],
            [32.11847234317426, 3.16033941028399],
            [32.12058010344454, 3.159077632656432],
            [32.12159617169272, 3.159727370609994],
            [32.12209892911283, 3.159447281907051],
            [32.122056453172945, 3.157893131226447],
            [32.12242009748817, 3.157279682793011],
            [32.124263184431335, 3.158458813981889],
            [32.125048602145476, 3.158442240126341],
            [32.126701186061275, 3.157460965693044],
            [32.127960634869396, 3.15761475969071],
            [32.128313623368726, 3.157973792251569],
            [32.12820366239142, 3.159324925380853],
            [32.12895543011335, 3.160209459394044],
            [32.1310162111892, 3.159979124605979],
            [32.13207423704937, 3.158968717783626],
            [32.13309836318565, 3.158883143341729],
            [32.13418374094959, 3.159723267962392],
            [32.13678698498111, 3.158845509995065],
            [32.13585758888648, 3.156796997072427],
            [32.13458056453984, 3.156073744832164],
            [32.134590684061514, 3.155148685625652],
            [32.13393693960506, 3.15400411034038],
            [32.13408773799518, 3.153270110633593],
            [32.13516393767187, 3.153861065810371],
            [32.13616494925757, 3.15353806071639],
            [32.136211646380985, 3.153099858656476],
            [32.1357914216776, 3.15236066762725],
            [32.135124061456416, 3.148108424732421],
            [32.13411939372746, 3.146415055930706],
            [32.13326520458844, 3.14619379623295],
            [32.13180220652009, 3.147247972782182],
            [32.13165563111013, 3.145420069060557],
            [32.130045800713624, 3.144670072253875],
            [32.13017513026678, 3.143722373425188],
            [32.12986868438063, 3.143458653588799],
            [32.12825029393782, 3.143491384688713],
            [32.12768595610665, 3.145051882256205],
            [32.12721011400908, 3.145047545443587],
            [32.12623116953831, 3.144267700133276],
            [32.125131875074004, 3.142526023559425],
            [32.1232409546386, 3.141370186458074],
            [32.12318800074923, 3.139685471418047],
            [32.1221225539065, 3.139201342397137],
            [32.12310737156258, 3.1383563270969],
            [32.124106376311964, 3.138389136392997],
            [32.123154863695035, 3.137277423793283],
            [32.123497807232845, 3.136379122452298],
            [32.122011365830524, 3.1352269695853],
            [32.12137338950225, 3.131556179562521],
            [32.12296926277416, 3.131404644787524],
            [32.1237446112723, 3.130130723878365],
            [32.12358610713371, 3.129393911511388],
            [32.12437772501994, 3.12880807049771],
            [32.123767698873436, 3.128019708837375],
            [32.12361584675948, 3.125586865201966],
            [32.1245745225425, 3.124955097608709],
            [32.124729456776166, 3.12384159293475],
            [32.12447941880169, 3.122771850801894],
            [32.122949561821684, 3.12123975885452],
            [32.121782548757984, 3.119165362364702],
            [32.122677457630544, 3.118924427828192],
            [32.122791554451425, 3.11719378868969],
            [32.12344118372553, 3.116535490359943],
            [32.123406827657504, 3.11532536939858],
            [32.12470712555652, 3.113913890990642],
            [32.124069071074835, 3.112425491990535],
            [32.124385614923085, 3.111764162439032],
            [32.12406265351044, 3.110836086953457],
            [32.12499933404373, 3.110038068252988],
            [32.12444882038646, 3.10815905174523],
            [32.123765608493756, 3.107536081276392],
            [32.12331476830717, 3.106334041778298],
            [32.12255759901546, 3.105947617893291],
            [32.12368227358148, 3.105364801949058],
            [32.12467456701738, 3.103831909678543],
            [32.12516946597538, 3.101001676049913],
            [32.12479632826423, 3.100310353513517],
            [32.126406661717276, 3.098830520538942],
            [32.12686444677932, 3.096130410883585],
            [32.12865396448715, 3.095672233683242],
            [32.13052225186896, 3.093447492647515],
            [32.13200325936214, 3.092915339039934],
            [32.132111889934514, 3.091682796327951],
            [32.132827176174416, 3.091546964222843],
            [32.134973690664374, 3.089988944657843],
            [32.135298768507816, 3.088544866460957],
            [32.1363890402934, 3.086751915083386],
            [32.13824783877087, 3.086484113025524],
            [32.13895743059021, 3.086870095505718],
            [32.139701420698444, 3.086283794038948],
            [32.140808105602595, 3.084075846959449],
            [32.14037289340701, 3.082529994320639],
            [32.141511242128296, 3.080690013856897],
            [32.14091519107266, 3.078620817710338],
            [32.141716705698386, 3.078212959322407],
            [32.14082403991911, 3.07716111323851],
            [32.141071519491675, 3.076285644636592],
            [32.14460549181939, 3.072949186762586],
            [32.144558030229675, 3.071845687508065],
            [32.145369505375285, 3.071615825848179],
            [32.14559706300979, 3.070384352839654],
            [32.14494462380546, 3.06912118735187],
            [32.14518847777754, 3.068577799771869],
            [32.14612019242391, 3.06823040886546],
            [32.14605967921143, 3.067233545270754],
            [32.147162963992244, 3.065333942447653],
            [32.146964349177885, 3.063908832658804],
            [32.14644871800141, 3.063192510864897],
            [32.14662119453595, 3.062648472616043],
            [32.1475384121703, 3.061446969927429],
            [32.14835194445789, 3.061027338593594],
            [32.14852984322352, 3.059985193167889],
            [32.15005203847245, 3.058943349029781],
            [32.14984232137947, 3.058538184107165],
            [32.15049524926732, 3.057571494076124],
            [32.150681675739925, 3.055746609947225],
            [32.151300490104845, 3.05572848350007],
            [32.15237114088803, 3.052452696583877],
            [32.153493162729035, 3.052107020975098],
            [32.15376363737624, 3.051302926535592],
            [32.15455219739729, 3.051106252812082],
            [32.154998541515866, 3.049573631444106],
            [32.15494224499534, 3.047834810546414],
            [32.15546203357491, 3.046676036400007],
            [32.156154647235375, 3.045691275462635],
            [32.15823054156758, 3.045229234572892],
            [32.16699934829712, 3.038165040677652],
            [32.16740350034347, 3.037411882179034],
            [32.16821038240301, 3.037760262633499],
            [32.16936416148594, 3.036833803843696],
            [32.17397648315883, 3.036779400222652],
            [32.17703295420066, 3.035680513231707],
            [32.17933905080756, 3.035740236442307],
            [32.18349158687023, 3.033772770386757],
            [32.185451806041605, 3.033774256809053],
            [32.18992414234547, 3.035827193330577],
            [32.19419448437283, 3.037036720077381],
            [32.198422810397716, 3.037126047773738],
            [32.199737548714964, 3.036437702504783],
            [32.204125917692565, 3.032563506412961],
            [32.207169936287904, 3.030784995541274],
            [32.20979738632308, 3.032165578893839],
            [32.21092505317734, 3.033344005196174],
            [32.21089619120556, 3.033746091034852],
            [32.211924241183034, 3.034407450095786],
            [32.21243748553575, 3.035815200607557],
            [32.21223672195124, 3.036877765756646],
            [32.212922409600885, 3.036878268106749],
            [32.21343603034772, 3.037769024150037],
            [32.21537806671941, 3.038804435403063],
            [32.21540555696375, 3.040297997455984],
            [32.21583378116475, 3.040757861524015],
            [32.216633836926455, 3.040643558445773],
            [32.217661978532064, 3.041190025384963],
            [32.2208333836246, 3.041077445586027],
            [32.22157555644096, 3.041997087641619],
            [32.22523165922316, 3.043292226259797],
            [32.225602214277856, 3.044498818468401],
            [32.22703843266926, 3.044273861385661],
            [32.22613187444411, 3.045597501816399],
            [32.22548167024818, 3.05071566366188],
            [32.226279407458144, 3.055052132765269],
            [32.227814914841304, 3.059371500320807],
            [32.22793815202018, 3.061175498033132],
            [32.227020236394885, 3.062448255003223],
            [32.22678579586866, 3.065423283938947],
            [32.227210436689965, 3.0657592135128],
            [32.22847341857211, 3.06558077367393],
            [32.22989069329082, 3.064336223077112],
            [32.23162821022179, 3.064280647531361],
            [32.23088948424116, 3.062186462344722],
            [32.230943994910895, 3.061546447320766],
            [32.2315198545339, 3.061100893551317],
            [32.23379609024242, 3.061832989274095],
            [32.234432291499694, 3.062408028481548],
            [32.23387553814448, 3.065486926414831],
            [32.233440113048154, 3.066147243341158],
            [32.231860663674574, 3.066987074134361],
            [32.23165159786019, 3.068716920617608],
            [32.23265694920707, 3.069259694560622],
            [32.23321843937877, 3.070142459056253],
            [32.23405139593777, 3.070126208534087],
            [32.235317906402315, 3.071821853566433],
            [32.237573707234795, 3.072245378234891],
            [32.239436260670125, 3.074930837406836],
            [32.23960915492129, 3.076545510628669],
            [32.239168599546396, 3.077680223994843],
            [32.23790863780027, 3.078677119991927],
            [32.237888891932, 3.080503556283428],
            [32.238451160044725, 3.081315159224658],
            [32.239150061013866, 3.081594239873347],
            [32.23970188171988, 3.081172186438622],
            [32.2417361553083, 3.082281662720118],
            [32.24210809466686, 3.083091552800574],
            [32.24164758860784, 3.083870259353513],
            [32.240834575546465, 3.084242519364545],
            [32.240676945468614, 3.085616997900398],
            [32.24118419626177, 3.087116053438697],
            [32.240579627380626, 3.089115167610021],
            [32.24076200334959, 3.089852194695351],
            [32.24193722521836, 3.091191187503844],
            [32.24206997286117, 3.092117542727916],
            [32.24270773089881, 3.09255026888977],
            [32.242956614538144, 3.093738612415007],
            [32.243908793705025, 3.093699711952654],
            [32.24329858160724, 3.096220660249371],
            [32.243952432963226, 3.097365200797587],
            [32.24394749582241, 3.10002205213489],
            [32.24413296109765, 3.100474443594355],
            [32.245136834715865, 3.100056447627475],
            [32.24779641030224, 3.10055474934168],
            [32.24820497846649, 3.100178854130589],
            [32.248628581733676, 3.101712738398157],
            [32.248449988570336, 3.102826086167261],
            [32.249223841373535, 3.103876816063504],
            [32.248919617021116, 3.105605814933569],
            [32.24921480072852, 3.106913190272416],
            [32.25069963594309, 3.107128143413701],
            [32.252077173685194, 3.10800784997013],
            [32.252476277199655, 3.10930063184775],
            [32.25321934473803, 3.109042662053048],
            [32.2536188147651, 3.109818445962044],
            [32.25213154421779, 3.111942825940296],
            [32.25337224518592, 3.115074428082286],
            [32.25345684851939, 3.116654207439363],
            [32.25259877506505, 3.117917371906441],
            [32.252626090137895, 3.119698166509652],
            [32.25436791449065, 3.121279129217694],
            [32.25250883124724, 3.123891518865979],
            [32.2523934210894, 3.125471156702588],
            [32.25185014785334, 3.126016488439708],
            [32.25068481823251, 3.125873816807622],
            [32.24829497169164, 3.128160136838633],
            [32.244989342126, 3.127988137044391],
            [32.24486011947239, 3.12893586717594],
            [32.24554107928868, 3.130875344786754],
            [32.24364007077263, 3.135033402390123],
            [32.24327880609458, 3.135433440562896],
            [32.24106377619963, 3.135627045356801],
            [32.240766405992794, 3.137818684321267],
            [32.24155250103667, 3.139937032927542],
            [32.24050830384202, 3.14297595876922],
            [32.24049596997317, 3.144114515892232],
            [32.242245351852404, 3.145174010838761],
            [32.24320492325573, 3.144028646024914],
            [32.243241623926686, 3.142664372243799],
            [32.24420594651956, 3.142700979151386],
            [32.24527791423292, 3.142055509988191],
            [32.24552968326096, 3.139614313238361],
            [32.2459944895553, 3.138932501528025],
            [32.24792346891434, 3.138538968608235],
            [32.24899591542975, 3.137211345882141],
            [32.2496388396786, 3.137175903047961],
            [32.251602329615935, 3.138469816867744],
            [32.25335221365342, 3.138794197197573],
            [32.25435126152189, 3.140231022682938],
            [32.25510116074806, 3.140446977192991],
            [32.25588806876725, 3.138831920068572],
            [32.258424382920225, 3.13822338476578],
            [32.25831898179132, 3.135746017706215],
            [32.25889077743596, 3.135279691728648],
            [32.260855363317916, 3.135029767864099],
            [32.26157027675699, 3.134204511270641],
            [32.262840866471294, 3.130417667064619],
            [32.26412781181194, 3.130466693914069],
            [32.265179780332126, 3.131155325455293],
            [32.26435609348857, 3.134314190260224],
            [32.265212337973, 3.135679102824982],
            [32.266748250496306, 3.135536572436323],
            [32.267318994213745, 3.136578159118769],
            [32.26942602864527, 3.136938666369699],
            [32.27199621287771, 3.13898693220755],
            [32.27413892569736, 3.139419263272007],
            [32.27670910184496, 3.141503425284203],
            [32.2799280323076, 3.141259019246168],
            [32.28054495661719, 3.147395512888861],
            [32.28062129365341, 3.153054563307516],
            [32.280328548871964, 3.154003813448439],
            [32.28075042018729, 3.155134568473168],
            [32.281845029937394, 3.155999078892306],
            [32.281948938066314, 3.157016310820725],
            [32.28515901293687, 3.164867411111036],
            [32.286890834548956, 3.166564610284021],
            [32.2881668357145, 3.170345653438291],
            [32.32811128001901, 3.233633782028693],
            [32.329380211443265, 3.234162658835994],
            [32.331012915641836, 3.233077615410811],
            [32.33157827395914, 3.233884924149979],
            [32.333399111429365, 3.234568046979555],
            [32.33680130000658, 3.234358698046085],
            [32.338289412275344, 3.233271230549605],
            [32.33891321049345, 3.233450861417938],
            [32.330945347061125, 3.244876789368108],
            [32.32924965658807, 3.245736655397738],
            [32.326404651659104, 3.24817617292682],
            [32.32748864961076, 3.25107787741521],
            [32.33030123344282, 3.254469022435865],
            [32.331244007248685, 3.254871765648337],
            [32.3344987472535, 3.259498270516072],
            [32.33724123554394, 3.260907497196699],
            [32.33955595238429, 3.260966475657091],
            [32.34234129839865, 3.262404440141755],
            [32.34385429220412, 3.264875581749623],
            [32.34496837832793, 3.265536932135779],
            [32.34548282911808, 3.265451102053477],
            [32.34545384138218, 3.266082979573721],
            [32.34739766450299, 3.265222571273354],
            [32.34911145602899, 3.266544931244738],
            [32.350768505470064, 3.267235354781553],
            [32.35194086171307, 3.266173376393203],
            [32.35278363865476, 3.266576041376647],
            [32.35415545143357, 3.266433313952571],
            [32.35418443198293, 3.265801431271667],
            [32.35504135020381, 3.266433886146602],
            [32.355498865771295, 3.26600333963984],
            [32.35587017271587, 3.266319528947143],
            [32.355813454885464, 3.265630148721503],
            [32.356527983845616, 3.26548699515604],
            [32.35752885529413, 3.264453619295971],
            [32.35904318579277, 3.264885432829554],
            [32.35947210169654, 3.264483589586647],
            [32.36084329194285, 3.26531742465202],
            [32.3622722016411, 3.26526089396943],
            [32.364156705410444, 3.26781842076427],
            [32.36455492857588, 3.270777119150879],
            [32.363538952854164, 3.273103012351984],
            [32.36431011610139, 3.273792852905739],
            [32.36436667493001, 3.274740738730024],
            [32.36362354271289, 3.274912604468992],
            [32.36390801311223, 3.276980822331081],
            [32.36342206406941, 3.277181570618909],
            [32.363507307003346, 3.277957141418554],
            [32.3627356856153, 3.277985371425236],
            [32.36213511513547, 3.278674331500058],
            [32.36222044700263, 3.279306285882587],
            [32.36149178484814, 3.279190931067582],
            [32.361862424344466, 3.280569857133229],
            [32.36134770765297, 3.281057814151353],
            [32.36140441111035, 3.281775919478164],
            [32.360946760795564, 3.282407530203177],
            [32.35968907538037, 3.28280883622268],
            [32.359830588783694, 3.284963133425472],
            [32.36045857494768, 3.286112446615717],
            [32.3598717711496, 3.287605648848658],
            [32.360128406351514, 3.288496221820126],
            [32.35958522025204, 3.288811819282496],
            [32.36018508645272, 3.289243048330984],
            [32.360269957484114, 3.290593072585784],
            [32.36087015606142, 3.290507290391792],
            [32.36132605286473, 3.292633064253936],
            [32.36095413326911, 3.293264727295038],
            [32.36004008578942, 3.292546070614988],
            [32.359182152472265, 3.293464641841872],
            [32.35923871938572, 3.294383806820124],
            [32.35992415910033, 3.295073593211322],
            [32.35998087423578, 3.295762974654259],
            [32.35906511905874, 3.297715528475968],
            [32.359922045364456, 3.298376709151329],
            [32.359436028049664, 3.298663622060488],
            [32.359406767225906, 3.299726340763814],
            [32.36012815841652, 3.300925434911804],
            [32.36312468757436, 3.299070139270302],
            [32.36579228062464, 3.298650588474803],
            [32.36834502137091, 3.299073485330173],
            [32.369945509288435, 3.298921311789718],
            [32.376443870849776, 3.29649356939141],
            [32.38288714322631, 3.290676436010802],
            [32.38437552139638, 3.286924240027685],
            [32.386071826317085, 3.285833815981743],
            [32.38675845629944, 3.284608730291863],
            [32.386071826317085, 3.285833915530828],
            [32.38437552229471, 3.286924339576661],
            [32.38288714322631, 3.290676536456253],
            [32.37644387354474, 3.29649366983624],
            [32.36994551198336, 3.298921412234303],
            [32.36834502137091, 3.299073584877901],
            [32.36579228062464, 3.298650688919416],
            [32.36312468757436, 3.299070239714872],
            [32.36079950446263, 3.300332540221216],
            [32.35889318420831, 3.302016368863314],
            [32.356622342883064, 3.307625396350133],
            [32.350425670628404, 3.314725413781044],
            [32.349052337001815, 3.317098917302869],
            [32.34748896926848, 3.318706348806056],
            [32.345810039562004, 3.322190245688295],
            [32.34420898390924, 3.323146598736211],
            [32.34003564825444, 3.324350154815727],
            [32.339082301277706, 3.32542182922056],
            [32.335156053530035, 3.327487197709125],
            [32.33344140590957, 3.327332852898268],
            [32.33050806784205, 3.326181950808454],
            [32.32757600897549, 3.323154504070027],
            [32.326147436145455, 3.322598221312624],
            [32.318755633558744, 3.321712310057672],
            [32.31494512654888, 3.3217096617894],
            [32.31177948504722, 3.325920069347161],
            [32.31088215970654, 3.328581055530958],
            [32.30401744451108, 3.336771659990534],
            [32.303064536810524, 3.337153945451985],
            [32.30062623783819, 3.336501164963549],
            [32.295041525802844, 3.33965661339822],
            [32.290617138873955, 3.345397877487885],
            [32.28970077733408, 3.347924770702376],
            [32.2892614167185, 3.349513749897148],
            [32.29089662901337, 3.354148802828695],
            [32.29085786311558, 3.355067890636181],
            [32.29017101304596, 3.356369465389166],
            [32.2785380816449, 3.370683717353053],
            [32.27880212255803, 3.374360357938619],
            [32.2771235279232, 3.376924952858802],
            [32.274659636846756, 3.384984465301639],
            [32.272904185051125, 3.388353212668691],
            [32.272574041607825, 3.396682382013276],
            [32.271848418453914, 3.398788125756327],
            [32.26866231153345, 3.404242913911895],
            [32.26831775462138, 3.406348903880741],
            [32.26854479931784, 3.40845539768582],
            [32.27050201003133, 3.415560831839081],
            [32.269890189949216, 3.418317690040646],
            [32.267487608890896, 3.420613616432839],
            [32.26546697622003, 3.421760949867335],
            [32.258052969974436, 3.424225312588922],
            [32.25706145986947, 3.425105351116614],
            [32.25458499237905, 3.424337492086315],
            [32.25325116486205, 3.424374743269886],
            [32.25081078539152, 3.426211037769624],
            [32.24650123549525, 3.430671702244006],
            [32.24364291663543, 3.43186274244065],
            [32.238665790023994, 3.432308731685056],
            [32.235962021817244, 3.433822902017464],
            [32.23243755546185, 3.434127829236838],
            [32.23143704423774, 3.434676227038518],
            [32.22763572250169, 3.439273848518303],
            [32.226619900391874, 3.444641597437866],
            [32.22578483908018, 3.446936248234206],
            [32.22478341157449, 3.448752256570997],
            [32.22321091785614, 3.449945428015803],
            [32.220289718723066, 3.455716472992326],
            [32.22015760349424, 3.457330682792779],
            [32.220917910601244, 3.45972373936077],
            [32.2219408473681, 3.461160554593707],
            [32.222951110702944, 3.463685587475146],
            [32.222950322880415, 3.464785791883723],
            [32.22104297136016, 3.467987445393427],
            [32.21869581904985, 3.470147912495262],
            [32.218836343408036, 3.47340094109986],
            [32.218057659465245, 3.479988852040202],
            [32.217199517738955, 3.481159323765053],
            [32.21475748716496, 3.482721678624197],
            [32.209304804120194, 3.481851173855472],
            [32.208280579169205, 3.482184233479063],
            [32.20378893986655, 3.485943377818208],
            [32.20204987064679, 3.486849197936441],
            [32.20112026973626, 3.488019514974653],
            [32.20073870942102, 3.488736370293403],
            [32.20027005833727, 3.494511589697205],
            [32.19926191053497, 3.497188365285043],
            [32.19871902716771, 3.500572057290005],
            [32.19957348849629, 3.503543788349547],
            [32.20095428263131, 3.504088671411746],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 544,
        District: "AMURU",
        County: "KILAK",
        Subcounty: "ATTIAK",
        Population: 34345,
        Key: "AMURUATTIAK",
        Dist2: "Amuru",
        "Sub Country": "Atiak",
        id2_original: "Amuru Atiak",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.18635944583839, 2.966626978022707],
            [32.18573185133985, 2.966569563788314],
            [32.18470497635882, 2.965393564878417],
            [32.182736622942535, 2.964963184985652],
            [32.182109001494545, 2.965221248410946],
            [32.18188085097195, 2.964504218416],
            [32.18048290889647, 2.965651311522679],
            [32.17948450512006, 2.965134970402622],
            [32.17911356648472, 2.965995348614424],
            [32.17860007329865, 2.966081345759614],
            [32.177658814950675, 2.96450382458332],
            [32.17720236568344, 2.964675863954618],
            [32.176261086674245, 2.963442510535646],
            [32.17569048219566, 2.964044754655049],
            [32.175177029433776, 2.963729213775561],
            [32.17460646537939, 2.963929920532538],
            [32.17443534619923, 2.963471017229392],
            [32.17325143851999, 2.963772048265275],
            [32.170113553163944, 2.962681880516267],
            [32.169029652230336, 2.961477188615858],
            [32.166091360852356, 2.961505565278455],
            [32.16475066481668, 2.960702378324855],
            [32.163381344862785, 2.96098903831563],
            [32.161569970245786, 2.960085409805356],
            [32.15877475444141, 2.956127210783734],
            [32.15920272711412, 2.955467602275874],
            [32.159031776817244, 2.953574681009694],
            [32.15960234626154, 2.953259259158644],
            [32.15910325306947, 2.952097643158242],
            [32.157762590271446, 2.951122368472671],
            [32.155280816432644, 2.950720571700306],
            [32.15476739960338, 2.950146906329354],
            [32.151800699902815, 2.949429567845808],
            [32.15227178452266, 2.94594495629268],
            [32.15038964332252, 2.940466794072409],
            [32.14936271084927, 2.94032327977076],
            [32.14782241634402, 2.939118525059976],
            [32.146709904068594, 2.939061035838706],
            [32.143015928314036, 2.937440163522502],
            [32.14124729733489, 2.937439958078591],
            [32.13915985875298, 2.938362439425141],
            [32.1351233320244, 2.938863841354838],
            [32.13144344005688, 2.938892047242076],
            [32.12947524474408, 2.938060071056941],
            [32.1283629220132, 2.936482509207722],
            [32.127792369636914, 2.936740559508614],
            [32.125082574632906, 2.935277504536961],
            [32.12144588354569, 2.932509383996181],
            [32.11873627269631, 2.929870435951394],
            [32.11290315762029, 2.926843865533168],
            [32.111448506697585, 2.925696457023081],
            [32.11139185085094, 2.922914484179735],
            [32.10815475555493, 2.918970508589025],
            [32.10298400157555, 2.91353199777737],
            [32.09726523035711, 2.909788400739041],
            [32.094522337824806, 2.907518912210632],
            [32.0920117819643, 2.914973031794533],
            [32.08912364712185, 2.917047981385165],
            [32.087845923885936, 2.919032590453972],
            [32.08602168000416, 2.920527973857732],
            [32.08003329023298, 2.92391393108099],
            [32.073924491179426, 2.925894519572521],
            [32.07252446591081, 2.928764898361633],
            [32.068388625935995, 2.933129853183316],
            [32.06869023978422, 2.935818354934505],
            [32.06832491921267, 2.936673400837571],
            [32.065862249845004, 2.938534778000693],
            [32.064160454421305, 2.938869375773422],
            [32.06196967364911, 2.942594410940843],
            [32.06017648812001, 2.943203855968366],
            [32.05597438481656, 2.946476724379072],
            [32.04084659643017, 2.944355456731269],
            [32.04104838139918, 2.945826140636813],
            [32.040304261933606, 2.947443427502516],
            [32.0372343808412, 2.951768005069936],
            [32.035433468902326, 2.95316417316953],
            [32.03479232331773, 2.956811131731439],
            [32.03204638100502, 2.960867903429993],
            [32.0307033969603, 2.964736240554232],
            [32.03001352765303, 2.965432270792509],
            [32.029118927800944, 2.965806099250485],
            [32.0236787717628, 2.965801285347084],
            [32.022113402582995, 2.96624943310843],
            [32.01995251145526, 2.965947817829717],
            [32.016302101297036, 2.964595947332445],
            [32.01145848409975, 2.964216993256888],
            [32.005495371124, 2.965710075958532],
            [31.999607919651417, 2.965929506877377],
            [31.99808687155111, 2.964558005729409],
            [32.00114266256824, 2.959795781917963],
            [32.00303618272808, 2.95754957644574],
            [32.00380681956255, 2.95574299130454],
            [32.00700235879351, 2.952990578195543],
            [32.008686469982536, 2.948402317611664],
            [32.00994184493083, 2.947341489657049],
            [32.009785150897486, 2.946524094514965],
            [32.0102990923429, 2.944516677154559],
            [32.014264670130345, 2.942165926820792],
            [32.016775082260416, 2.941392175138036],
            [32.01813044688637, 2.939600030926347],
            [32.02004196928451, 2.938166510674511],
            [32.02072698499429, 2.936388548588953],
            [32.020827586424666, 2.932990075418042],
            [32.018774728489625, 2.928745073319043],
            [32.016065264065645, 2.926937654702063],
            [32.015823645101975, 2.923223634580662],
            [32.017222419915726, 2.918491875498294],
            [32.014955309293825, 2.915809846416821],
            [32.0137008425423, 2.913056351691206],
            [32.01308810348362, 2.910661496630594],
            [32.013174012967504, 2.909170186667802],
            [32.012290150677984, 2.907391882578918],
            [32.010366758839986, 2.8984865387538],
            [32.00965389805135, 2.897396559515483],
            [32.00633144483703, 2.894685626441691],
            [32.0059037757949, 2.893853827491971],
            [32.00596154375588, 2.890641772274744],
            [32.00690304914055, 2.88969557362705],
            [32.0084583769521, 2.886240074175699],
            [32.008116313763274, 2.88517886369688],
            [32.008458883601925, 2.883945737767499],
            [32.00830259021723, 2.881264191094737],
            [32.008959155383664, 2.878883961952599],
            [32.00841743263976, 2.877851392545115],
            [32.00826107188141, 2.87551399771823],
            [32.00723477182213, 2.87296132277668],
            [32.00612261887284, 2.871756545506781],
            [32.0055810398594, 2.870093033699401],
            [32.003142732802246, 2.868070610310529],
            [32.002886243127385, 2.867066780706811],
            [32.00354234027154, 2.866780132683991],
            [32.00320016209835, 2.866321190653048],
            [32.003485561355696, 2.865604271678168],
            [32.00280119333122, 2.86471506704807],
            [32.00275893568193, 2.862320346921992],
            [32.001504405150015, 2.860054411640528],
            [32.00096257999817, 2.859566747648757],
            [31.99998472877711, 2.860376678236902],
            [31.998580194864097, 2.857965240530254],
            [31.998649632838937, 2.856094078818105],
            [31.998328319834833, 2.85605789835344],
            [31.998900936539652, 2.854514680160271],
            [31.9988330715149, 2.850421971837684],
            [31.998440503244158, 2.850206224795578],
            [31.998512905659418, 2.849057472903151],
            [31.997229337984255, 2.846974124415181],
            [31.996873658132323, 2.845394196447015],
            [31.997124179400462, 2.844712305779003],
            [31.99680290053235, 2.844640224061868],
            [31.99760814765808, 2.84245100219072],
            [31.996788617319332, 2.84051166217579],
            [31.99750323341607, 2.839901978941436],
            [31.997254046146114, 2.839040150827608],
            [31.998219089187867, 2.837856278947315],
            [31.998435575086514, 2.835235732989274],
            [31.99911420287633, 2.834949118307601],
            [31.997900595097153, 2.834553158925575],
            [31.998427097685173, 2.833356353553538],
            [32.00029007871862, 2.833718147328303],
            [32.00098251720759, 2.833310959749703],
            [32.00419132186035, 2.83321126456404],
            [32.00530346762313, 2.834329996115095],
            [32.00724277581133, 2.835420207692519],
            [32.00804140325172, 2.835449054965537],
            [32.01003770864639, 2.836826073574343],
            [32.01109269640425, 2.838547056075105],
            [32.014386616430194, 2.840827736309467],
            [32.01695368889849, 2.840742225786863],
            [32.02037686930725, 2.838505921545667],
            [32.02224513962108, 2.838405917269222],
            [32.02441315438904, 2.836943696585551],
            [32.028235437413954, 2.83576857579032],
            [32.031202173047106, 2.833818937074741],
            [32.03200100081181, 2.832815309970806],
            [32.03281391326187, 2.832743760458757],
            [32.03386946246679, 2.831625458039906],
            [32.03466810967014, 2.831568252286661],
            [32.03569489481966, 2.83179788008752],
            [32.035523441466246, 2.833489932127827],
            [32.03629353302333, 2.833633476972105],
            [32.03660711243113, 2.834579951595194],
            [32.03766236878529, 2.835096383724711],
            [32.037434049379414, 2.835842001192335],
            [32.0384320740668, 2.837390882480353],
            [32.03885990570403, 2.837448318529741],
            [32.04400845332955, 2.836603203694314],
            [32.04477849188605, 2.837062213210169],
            [32.0476022112344, 2.837378182416247],
            [32.04877184737871, 2.836288562154449],
            [32.04996988286244, 2.835887259417405],
            [32.050939850468545, 2.834768922352472],
            [32.052394530137356, 2.834711810065027],
            [32.05429140819976, 2.834152883796672],
            [32.05509016409923, 2.833493382824452],
            [32.05762875997304, 2.833149646374564],
            [32.05888370642495, 2.833580051293037],
            [32.061479320166455, 2.833465753026188],
            [32.07059222836223, 2.834886845243024],
            [32.07526982162366, 2.836264187518484],
            [32.08230941095717, 2.836251543966526],
            [32.08228371644509, 2.832066421987779],
            [32.081659638850915, 2.829918409836425],
            [32.08230288559495, 2.824994682421116],
            [32.081054525590694, 2.82095855097706],
            [32.08122287795977, 2.820228027865546],
            [32.07987521099748, 2.818507177885166],
            [32.07698579785244, 2.816809322260147],
            [32.074868004298736, 2.814167414141217],
            [32.066073297342925, 2.808546284656464],
            [32.063972238504654, 2.808001150692599],
            [32.06322729977553, 2.805796268422493],
            [32.06037257417683, 2.803783501712922],
            [32.058832562640866, 2.800776137162524],
            [32.05749590273578, 2.800108501724714],
            [32.05742300714541, 2.798784784412703],
            [32.05684612793457, 2.798828935982304],
            [32.05643149524382, 2.79943837515913],
            [32.05635781542422, 2.799096247285843],
            [32.05569225003696, 2.799065962625209],
            [32.05450470957069, 2.800101926729897],
            [32.052067930547835, 2.800187453699341],
            [32.051543311726974, 2.803249729974183],
            [32.04860256794827, 2.80948980806042],
            [32.044094489475896, 2.806320587494173],
            [32.04232025480599, 2.805370953129855],
            [32.0398628432777, 2.804708555704002],
            [32.038056108459145, 2.803564008993617],
            [32.03531716132753, 2.802943367223864],
            [32.02929815427651, 2.802544854170763],
            [32.02869237446638, 2.801488685447308],
            [32.03000247568008, 2.800317017329009],
            [32.02956341240687, 2.798760950029508],
            [32.0301113793403, 2.798139124940961],
            [32.02954086020167, 2.797241129359804],
            [32.02983880353365, 2.796738766301548],
            [32.0293633566948, 2.796008387750813],
            [32.02891098488066, 2.796163581667646],
            [32.0284947585786, 2.79578029257431],
            [32.0288757933794, 2.795541271586115],
            [32.029007474721965, 2.794607960171479],
            [32.02828187761917, 2.794152612642145],
            [32.02817505355886, 2.793805483763666],
            [32.02865130618651, 2.793554573840699],
            [32.0269273457315, 2.791482860157229],
            [32.026594793904906, 2.790656864693061],
            [32.02698811945544, 2.790027056063341],
            [32.02678343382636, 2.789654689892261],
            [32.02624156465709, 2.789453834916171],
            [32.026298683136105, 2.78902365597781],
            [32.02475857458209, 2.788679227208415],
            [32.0248727917772, 2.787933580492285],
            [32.024017424048516, 2.7863560551227],
            [32.02182129560543, 2.786183580605347],
            [32.02073737490888, 2.78675696754316],
            [32.01951131378491, 2.784749191904722],
            [32.018655641527346, 2.784863752452353],
            [32.017728880191434, 2.783845462502078],
            [32.01735806193035, 2.784046147059477],
            [32.01704439089439, 2.783730621014563],
            [32.01607504402414, 2.781636841742942],
            [32.0152194050042, 2.781636688312033],
            [32.01501983617899, 2.781206462552624],
            [32.01427831014964, 2.781034243897126],
            [32.01191103288198, 2.781062476994858],
            [32.01188270001793, 2.78003001874828],
            [32.0122250291081, 2.779657251931351],
            [32.011833400475155, 2.779069620248385],
            [32.01891482075818, 2.77112637951561],
            [32.021538947925116, 2.770065715119524],
            [32.023792198440475, 2.769664601427452],
            [32.02513289896774, 2.768460296768884],
            [32.0270724245482, 2.767973084364136],
            [32.02787098192001, 2.768173980680475],
            [32.02851277339329, 2.767786919349182],
            [32.03028089502768, 2.768905719683998],
            [32.03030921801026, 2.770110262562343],
            [32.03207731539013, 2.77140114081393],
            [32.03311832176893, 2.77155904950503],
            [32.03414487335651, 2.772878477101101],
            [32.03468672366113, 2.773165369889359],
            [32.03588473489034, 2.772477260279614],
            [32.03651213086119, 2.772964914079066],
            [32.037966783580565, 2.772563637170207],
            [32.03879382203845, 2.773051325030071],
            [32.03927843348983, 2.774600101965442],
            [32.04067593539082, 2.774887127130802],
            [32.04130314181712, 2.776550641570938],
            [32.04278635826757, 2.775977295431256],
            [32.042929019717846, 2.775604483369176],
            [32.044183705658334, 2.777239422652003],
            [32.044853974624424, 2.777196505799552],
            [32.045167571998526, 2.778028263929626],
            [32.0456524709108, 2.777856264638935],
            [32.04633686408812, 2.778659404225616],
            [32.04627933777393, 2.781670750872869],
            [32.04816142148189, 2.783908063992669],
            [32.04864518582197, 2.786294524185405],
            [32.053613645487545, 2.786336099313133],
            [32.05752702486879, 2.787543210290399],
            [32.05920781768114, 2.787637175037789],
            [32.06233705765086, 2.790464351622505],
            [32.064754202196546, 2.791160876806698],
            [32.0663240333084, 2.792422214333494],
            [32.06671366139321, 2.792242341992663],
            [32.06736958246756, 2.792873393021163],
            [32.067797428477846, 2.792758733659109],
            [32.067882857363045, 2.793733859180644],
            [32.07157658158932, 2.792945698668059],
            [32.073772696557654, 2.793634327498743],
            [32.075027491194284, 2.794896406186607],
            [32.075027321412705, 2.796158324704777],
            [32.075939980096976, 2.796559972213954],
            [32.075968347995314, 2.797649805512507],
            [32.077337161299376, 2.79954286541154],
            [32.0788773093793, 2.799973279161412],
            [32.07913392930987, 2.800546904313122],
            [32.080018159010336, 2.800317591564251],
            [32.0842820421508, 2.801938583872305],
            [32.08596486066414, 2.802024840164743],
            [32.08642128208356, 2.801537347348747],
            [32.08776172659099, 2.802397922894059],
            [32.088303557132676, 2.803143665395661],
            [32.08818936598871, 2.803946688109125],
            [32.08924468252997, 2.804061543769529],
            [32.08987208029746, 2.804864664549183],
            [32.091840096845495, 2.80518039935339],
            [32.09282415812013, 2.804936750529942],
            [32.09576182786392, 2.806199036865202],
            [32.09664604588629, 2.806113105680774],
            [32.09792972225764, 2.804822662992169],
            [32.10024005352276, 2.804794263579138],
            [32.10083911213797, 2.804106011865741],
            [32.101181363074694, 2.804306814984339],
            [32.1031495017936, 2.803676086836556],
            [32.10360577229612, 2.804421824934571],
            [32.10470395823936, 2.80392005264828],
            [32.10715678476644, 2.80495281559475],
            [32.10909634358459, 2.804838318917501],
            [32.1096383439079, 2.804264778414925],
            [32.11072221519711, 2.804150180282265],
            [32.1112071913645, 2.803318514210245],
            [32.11243368098485, 2.803261287326804],
            [32.113945461166374, 2.802515771004874],
            [32.11465872170532, 2.800708992935951],
            [32.11588528768246, 2.799848717623109],
            [32.1178679144303, 2.796909214187245],
            [32.118381528888925, 2.794872970101936],
            [32.120250170206994, 2.790700200070994],
            [32.12190461453375, 2.789266351637861],
            [32.122760558980836, 2.786398412653031],
            [32.12338810586867, 2.785824870315716],
            [32.12355937506749, 2.784362189838628],
            [32.12480011286654, 2.784175889228538],
            [32.125456194739336, 2.783430264783513],
            [32.127081969333794, 2.783487778857878],
            [32.128308506564856, 2.782656160959695],
            [32.12932578125047, 2.782847451450195],
            [32.13040525977794, 2.778512046456912],
            [32.13089018923295, 2.777881125910786],
            [32.1309188329141, 2.776504474815044],
            [32.13251627015292, 2.774181512034311],
            [32.13330098807945, 2.769807827492373],
            [32.13643863448363, 2.76705477319245],
            [32.140146423632295, 2.768030197215072],
            [32.1414013278634, 2.768976742811823],
            [32.14339783448065, 2.769493140177266],
            [32.144281927637195, 2.770783820806079],
            [32.14446710994312, 2.773666217656083],
            [32.15524828124967, 2.777653553015689],
            [32.16722772878843, 2.777281442242765],
            [32.17278957510655, 2.778228193087055],
            [32.17415862556584, 2.778859239063985],
            [32.179135773736846, 2.779935007191287],
            [32.186993805549314, 2.778917173278408],
            [32.191728564900465, 2.779118122468522],
            [32.19405319824327, 2.778300802009622],
            [32.19533679735947, 2.775977705479586],
            [32.196135435579656, 2.775576193613467],
            [32.19636363550962, 2.775002585000518],
            [32.19653483553815, 2.773109665989557],
            [32.19777566496538, 2.769682348450075],
            [32.19754749288319, 2.769166083962575],
            [32.198117989563954, 2.767072410787498],
            [32.19830354107745, 2.761522687337147],
            [32.19901662644494, 2.760346784767983],
            [32.19847476356388, 2.757794179492642],
            [32.199701252285905, 2.756532261272886],
            [32.20121293275445, 2.756589651932301],
            [32.20318098613341, 2.755786628394983],
            [32.20490657343739, 2.756259897643071],
            [32.211723396750116, 2.756030565525181],
            [32.214860841931646, 2.757407278081614],
            [32.21949572299628, 2.758425496561644],
            [32.22117853252642, 2.760347128423533],
            [32.223659986564996, 2.761064158780777],
            [32.23611944348593, 2.768003437118845],
            [32.236452393266205, 2.768220065212821],
            [32.23611012076992, 2.769625436666353],
            [32.234926433177904, 2.772766019473416],
            [32.21239211522402, 2.830242297160412],
            [32.212449002836046, 2.835433529548473],
            [32.21157897460189, 2.836652441933397],
            [32.2088260290232, 2.846676287693546],
            [32.20734262751982, 2.849888482638979],
            [32.20798438306048, 2.851164801659375],
            [32.20775608790912, 2.853717382516792],
            [32.2082693879574, 2.857388553832827],
            [32.21039439498282, 2.859496679274963],
            [32.21019470039346, 2.860213685510907],
            [32.210793660193985, 2.86164774867507],
            [32.21062245747053, 2.863081789409602],
            [32.20826891095201, 2.868832185345751],
            [32.20735607350298, 2.869749930835578],
            [32.206129484169644, 2.870065364406853],
            [32.203405150831074, 2.87398016429162],
            [32.20333869885625, 2.875251496842056],
            [32.19995816416897, 2.88108784862123],
            [32.199016597698865, 2.885246508118205],
            [32.19761874006502, 2.88736880145682],
            [32.19806077496519, 2.889304778448826],
            [32.19768986417764, 2.890767468794923],
            [32.195693023387065, 2.891685130216877],
            [32.19617788636672, 2.892889751813104],
            [32.19609225266565, 2.893864887800383],
            [32.19529349856277, 2.894467141527375],
            [32.195821156384255, 2.895542698014817],
            [32.195792569296955, 2.896546519550578],
            [32.195307567078444, 2.897636358752221],
            [32.19416648568207, 2.898611428748742],
            [32.19345323502455, 2.900332224057573],
            [32.19205541062839, 2.901307271992802],
            [32.1918556729199, 2.902139005354891],
            [32.1923263083821, 2.902784349887564],
            [32.191613108030246, 2.903702085902211],
            [32.191242140648846, 2.905566298921155],
            [32.19269682750418, 2.907688764113441],
            [32.19347561205828, 2.908159262776096],
            [32.19350964024127, 2.910341778756643],
            [32.19285344877399, 2.911747093918002],
            [32.1920832224696, 2.91206252119665],
            [32.19251104692029, 2.913123741448169],
            [32.19159808280883, 2.915045283108319],
            [32.19228265295425, 2.915848390769897],
            [32.19251072712005, 2.917712646495494],
            [32.19158355076248, 2.918874147522815],
            [32.19067072858484, 2.918759362577448],
            [32.190442487332376, 2.919074836336186],
            [32.191526396350824, 2.920308173345441],
            [32.19078462328477, 2.921656109746148],
            [32.19149766373646, 2.923262279159768],
            [32.19049915934873, 2.924524158733204],
            [32.19075578017763, 2.926130294434583],
            [32.18777451070148, 2.929700809892172],
            [32.18788851409755, 2.931048808565293],
            [32.18880125722345, 2.932396863031469],
            [32.18833045108138, 2.933931240641968],
            [32.189785245734555, 2.934763094303241],
            [32.18995601277509, 2.939982980257079],
            [32.1890003292803, 2.940456138829183],
            [32.18834414410124, 2.941373869163594],
            [32.188287009452544, 2.942406364229188],
            [32.18880043436665, 2.943123425539321],
            [32.18777329977249, 2.945360426923379],
            [32.18808706782651, 2.945618575648367],
            [32.1878444481396, 2.94746846093186],
            [32.1884149358372, 2.948070800742169],
            [32.18872861765296, 2.949476177093762],
            [32.188329026353315, 2.952172116041221],
            [32.189213263240326, 2.953405455981695],
            [32.18911317564631, 2.956459938154965],
            [32.18811462185121, 2.957721805292092],
            [32.18857098937174, 2.958582261033015],
            [32.188257084773795, 2.959872855923207],
            [32.18648831006423, 2.960905210001348],
            [32.18630275046585, 2.962496966341226],
            [32.186844701381816, 2.963300070355773],
            [32.18635944583839, 2.966626978022707],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 545,
        District: "AMURU",
        County: "KILAK",
        Subcounty: "LAMOGI",
        Population: 46333,
        Key: "AMURULAMOGI",
        Dist2: "Amuru",
        "Sub Country": "Lamogi",
        id2_original: "Amuru Lamogi",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.88208713774006, 2.970697339913975],
            [31.88328587840128, 2.970341289313554],
            [31.883985788178467, 2.969479477316332],
            [31.88557474532102, 2.969257472398684],
            [31.88691014488978, 2.968396301886556],
            [31.887419594758757, 2.967342621502166],
            [31.89085412358455, 2.964471007287498],
            [31.89324064725715, 2.961023306351156],
            [31.89616497971394, 2.95994009393425],
            [31.898230260451044, 2.960006051755598],
            [31.899946967908452, 2.959113292816433],
            [31.902838577434373, 2.958988391626088],
            [31.903791279420766, 2.959532412574324],
            [31.904935383648084, 2.95930993108573],
            [31.907412486247413, 2.960654101809261],
            [31.90817514065227, 2.960590966354391],
            [31.909985358239172, 2.961551125291179],
            [31.911286715251922, 2.962989964879841],
            [31.914589826839833, 2.9644946695438],
            [31.91611489490105, 2.964623954304516],
            [31.91789487789045, 2.964018738363234],
            [31.91938786172297, 2.964467443954044],
            [31.926536663737167, 2.965049463007376],
            [31.929651104860895, 2.964541363384432],
            [31.93095369436223, 2.96473430458452],
            [31.931621154296433, 2.964543277823805],
            [31.93244859250463, 2.963202356683198],
            [31.93343364731595, 2.963171364976186],
            [31.93969204820366, 2.964519136510116],
            [31.940898285305927, 2.965798133792378],
            [31.94426484490236, 2.967494504148723],
            [31.947983182967405, 2.966827202505163],
            [31.951160016579205, 2.967564994619927],
            [31.954177559128187, 2.968749871708594],
            [31.9579544206374, 2.973449532262473],
            [31.959955830259478, 2.973930622222145],
            [31.961258839274024, 2.973708233341471],
            [31.96564333561444, 2.974287406393534],
            [31.967421492328867, 2.975662766461966],
            [31.969041726114664, 2.976015698806306],
            [31.97094723159702, 2.977135606707056],
            [31.972535753056643, 2.978930595937974],
            [31.97481245049924, 2.980004598932997],
            [31.975636342158694, 2.979956648011685],
            [31.977720910623283, 2.979179054422946],
            [31.980291259247426, 2.977135149184603],
            [31.98190241016737, 2.976419168464404],
            [31.982378504691525, 2.973434257240819],
            [31.98446510963686, 2.970415455953058],
            [31.985677442706624, 2.969539589006409],
            [31.99076751719371, 2.967741576482554],
            [31.994598515673502, 2.964919229151062],
            [31.997264892404875, 2.963801062716894],
            [31.9986225953455, 2.962925306257894],
            [31.99988455494485, 2.960733974757284],
            [32.00114266256824, 2.959795781917963],
            [31.99808687155111, 2.964558005729409],
            [31.999607919651417, 2.965929506877377],
            [32.005495371124, 2.965710075958532],
            [32.01145848409975, 2.964216993256888],
            [32.016302101297036, 2.964595947332445],
            [32.01995251145526, 2.965947817829717],
            [32.022113402582995, 2.96624943310843],
            [32.0236787717628, 2.965801285347084],
            [32.029118927800944, 2.965806099250485],
            [32.03001352765303, 2.965432270792509],
            [32.0307033969603, 2.964736240554232],
            [32.03204638100502, 2.960867903429993],
            [32.03479232331773, 2.956811131731439],
            [32.035433468902326, 2.95316417316953],
            [32.0372343808412, 2.951768005069936],
            [32.040304261933606, 2.947443427502516],
            [32.04104838139918, 2.945826140636813],
            [32.04084659643017, 2.944355456731269],
            [32.05597438481656, 2.946476724379072],
            [32.06017648812001, 2.943203855968366],
            [32.06196967364911, 2.942594410940843],
            [32.064160454421305, 2.938869375773422],
            [32.065862249845004, 2.938534778000693],
            [32.06832491921267, 2.936673400837571],
            [32.06869023978422, 2.935818354934505],
            [32.068388625935995, 2.933129853183316],
            [32.07252446591081, 2.928764898361633],
            [32.073924491179426, 2.925894519572521],
            [32.08003329023298, 2.92391393108099],
            [32.08602168000416, 2.920527973857732],
            [32.087845923885936, 2.919032590453972],
            [32.08912364712185, 2.917047981385165],
            [32.0920117819643, 2.914973031794533],
            [32.094522337824806, 2.907518912210632],
            [32.09726523035711, 2.909788400739041],
            [32.10298400157555, 2.91353199777737],
            [32.10815475555493, 2.918970508589025],
            [32.11139185085094, 2.922914484179735],
            [32.111448506697585, 2.925696457023081],
            [32.11290315762029, 2.926843865533168],
            [32.11873627269631, 2.929870435951394],
            [32.12144588354569, 2.932509383996181],
            [32.125082574632906, 2.935277504536961],
            [32.127792369636914, 2.936740559508614],
            [32.1283629220132, 2.936482509207722],
            [32.12947524474408, 2.938060071056941],
            [32.13144344005688, 2.938892047242076],
            [32.1351233320244, 2.938863841354838],
            [32.13915985875298, 2.938362439425141],
            [32.14124729733489, 2.937439958078591],
            [32.143015928314036, 2.937440163522502],
            [32.146709904068594, 2.939061035838706],
            [32.14782241634402, 2.939118525059976],
            [32.14936271084927, 2.94032327977076],
            [32.15038964332252, 2.940466794072409],
            [32.15227178452266, 2.94594495629268],
            [32.151800699902815, 2.949429567845808],
            [32.15476739960338, 2.950146906329354],
            [32.155280816432644, 2.950720571700306],
            [32.157762590271446, 2.951122368472671],
            [32.15910325306947, 2.952097643158242],
            [32.15960234626154, 2.953259259158644],
            [32.159031776817244, 2.953574681009694],
            [32.15920272711412, 2.955467602275874],
            [32.15877475444141, 2.956127210783734],
            [32.161569970245786, 2.960085409805356],
            [32.163381344862785, 2.96098903831563],
            [32.16475066481668, 2.960702378324855],
            [32.166091360852356, 2.961505565278455],
            [32.169029652230336, 2.961477188615858],
            [32.170113553163944, 2.962681880516267],
            [32.17325143851999, 2.963772048265275],
            [32.17443534619923, 2.963471017229392],
            [32.17460646537939, 2.963929920532538],
            [32.175177029433776, 2.963729213775561],
            [32.17569048219566, 2.964044754655049],
            [32.176261086674245, 2.963442510535646],
            [32.17720236568344, 2.964675863954618],
            [32.177658814950675, 2.96450382458332],
            [32.17860007329865, 2.966081345759614],
            [32.17911356648472, 2.965995348614424],
            [32.17948450512006, 2.965134970402622],
            [32.18048290889647, 2.965651311522679],
            [32.18188085097195, 2.964504218416],
            [32.182109001494545, 2.965221248410946],
            [32.182736622942535, 2.964963184985652],
            [32.18470497635882, 2.965393564878417],
            [32.18573185133985, 2.966569563788314],
            [32.18635944583839, 2.966626978022707],
            [32.18715138621982, 2.972062681979074],
            [32.188321105009145, 2.973034325574431],
            [32.18886329218205, 2.976818269979663],
            [32.18947354829725, 2.977772824966968],
            [32.188964879064244, 2.9783863844886],
            [32.1898463985475, 2.979272779066808],
            [32.189473269819516, 2.980909027502447],
            [32.18955802047668, 2.981198791593449],
            [32.190337907263654, 2.981062503323737],
            [32.19064287811606, 2.983278330983393],
            [32.191761756751916, 2.984164744047586],
            [32.19250771147563, 2.984267080398331],
            [32.19277891735147, 2.984880708065726],
            [32.19237197962946, 2.985426101365837],
            [32.19393164540552, 2.986483004764118],
            [32.195355749117034, 2.986755832026093],
            [32.19616946915252, 2.98757404158575],
            [32.19630513003179, 2.987164988016548],
            [32.198678671251905, 2.987165177303522],
            [32.199899249059364, 2.98852884918767],
            [32.20286606104929, 2.990148327055],
            [32.2031372866881, 2.990557417189983],
            [32.20286588228457, 2.992398220434709],
            [32.20191646094562, 2.992466325741889],
            [32.202018052319396, 2.994136704005971],
            [32.20344219196352, 2.994034550684818],
            [32.20476455068928, 2.994750527998147],
            [32.20683297912315, 2.994239345333998],
            [32.206631942450784, 2.996507751572531],
            [32.207050220504954, 2.997246402025423],
            [32.20705706117585, 2.99881211904825],
            [32.208123475504124, 2.999201253883607],
            [32.20960091039741, 3.001183467770728],
            [32.21107252420765, 3.001505066669155],
            [32.211563460696915, 3.000109867669892],
            [32.212366702782965, 2.999535888003873],
            [32.213008761055875, 2.999565375172805],
            [32.21359143709525, 3.000685544316739],
            [32.21425369578393, 3.001047323724114],
            [32.21591666332612, 3.00127575430425],
            [32.21641015911565, 2.999643355139925],
            [32.217729618079716, 2.998635141178713],
            [32.220836359743146, 2.99735828933085],
            [32.22159737112934, 2.997388836914514],
            [32.22211435786354, 2.996883444382934],
            [32.22272160462256, 2.997932671137041],
            [32.22462323297618, 2.998092051886526],
            [32.225060622688, 2.999448145954195],
            [32.22773962164745, 3.000326166283253],
            [32.22838395175972, 3.002348326997621],
            [32.22832378529692, 3.004613263551846],
            [32.22810378069732, 3.005156904895284],
            [32.22677103654854, 3.005192399656667],
            [32.22635969708162, 3.005829215866083],
            [32.226111479992205, 3.008982043461179],
            [32.2278709032397, 3.009092707745828],
            [32.229320007963864, 3.010398565371031],
            [32.22883108190416, 3.013810192461058],
            [32.22924622483799, 3.015023744713484],
            [32.230172244165466, 3.015198100474691],
            [32.23049684680014, 3.015983851547709],
            [32.23011053619365, 3.017605360935362],
            [32.228254604240256, 3.019818613495429],
            [32.228519739301404, 3.025004302806785],
            [32.22810068061126, 3.026352709619669],
            [32.228469275542025, 3.02747095570261],
            [32.228222396942385, 3.028299020325389],
            [32.2274782307644, 3.02890913096885],
            [32.22810283746626, 3.031654650624112],
            [32.22733282496092, 3.032454299547698],
            [32.227147308481705, 3.034208080327491],
            [32.225961341863815, 3.034968411223046],
            [32.226405671061244, 3.035684060186064],
            [32.22663606288045, 3.038580245009137],
            [32.227127454815616, 3.039343763639504],
            [32.22636783851305, 3.042480138806782],
            [32.22703843266926, 3.044273861385661],
            [32.225602214277856, 3.044498818468401],
            [32.22523165922316, 3.043292226259797],
            [32.22157555644096, 3.041997087641619],
            [32.2208333836246, 3.041077445586027],
            [32.217661978532064, 3.041190025384963],
            [32.216633836926455, 3.040643558445773],
            [32.21583378116475, 3.040757861524015],
            [32.21540555696375, 3.040297997455984],
            [32.21537806671941, 3.038804435403063],
            [32.21343603034772, 3.037769024150037],
            [32.212922409600885, 3.036878268106749],
            [32.21223672195124, 3.036877765756646],
            [32.21243748553575, 3.035815200607557],
            [32.211924241183034, 3.034407450095786],
            [32.21089619120556, 3.033746091034852],
            [32.21092505317734, 3.033344005196174],
            [32.20979738632308, 3.032165578893839],
            [32.207169936287904, 3.030784995541274],
            [32.204125917692565, 3.032563506412961],
            [32.199737548714964, 3.036437702504783],
            [32.198422810397716, 3.037126047773738],
            [32.19419448437283, 3.037036720077381],
            [32.18992414234547, 3.035827193330577],
            [32.185451806041605, 3.033774256809053],
            [32.18349158687023, 3.033772770386757],
            [32.17933905080756, 3.035740236442307],
            [32.17703295420066, 3.035680513231707],
            [32.17397648315883, 3.036779400222652],
            [32.16936416148594, 3.036833803843696],
            [32.16821038240301, 3.037760262633499],
            [32.16740350034347, 3.037411882179034],
            [32.16699934829712, 3.038165040677652],
            [32.15823054156758, 3.045229234572892],
            [32.156154647235375, 3.045691275462635],
            [32.15546203357491, 3.046676036400007],
            [32.15494224499534, 3.047834810546414],
            [32.154998541515866, 3.049573631444106],
            [32.15455219739729, 3.051106252812082],
            [32.15376363737624, 3.051302926535592],
            [32.153493162729035, 3.052107020975098],
            [32.15237114088803, 3.052452696583877],
            [32.151300490104845, 3.05572848350007],
            [32.150681675739925, 3.055746609947225],
            [32.15049524926732, 3.057571494076124],
            [32.14984232137947, 3.058538184107165],
            [32.15005203847245, 3.058943349029781],
            [32.14852984322352, 3.059985193167889],
            [32.14835194445789, 3.061027338593594],
            [32.1475384121703, 3.061446969927429],
            [32.14662119453595, 3.062648472616043],
            [32.14644871800141, 3.063192510864897],
            [32.146964349177885, 3.063908832658804],
            [32.147162963992244, 3.065333942447653],
            [32.14605967921143, 3.067233545270754],
            [32.14612019242391, 3.06823040886546],
            [32.14518847777754, 3.068577799771869],
            [32.14494462380546, 3.06912118735187],
            [32.14559706300979, 3.070384352839654],
            [32.145369505375285, 3.071615825848179],
            [32.144558030229675, 3.071845687508065],
            [32.14460549181939, 3.072949186762586],
            [32.141071519491675, 3.076285644636592],
            [32.14082403991911, 3.07716111323851],
            [32.141716705698386, 3.078212959322407],
            [32.14091519107266, 3.078620817710338],
            [32.141511242128296, 3.080690013856897],
            [32.14037289340701, 3.082529994320639],
            [32.140808105602595, 3.084075846959449],
            [32.139701420698444, 3.086283794038948],
            [32.13895743059021, 3.086870095505718],
            [32.13824783877087, 3.086484113025524],
            [32.1363890402934, 3.086751915083386],
            [32.135298768507816, 3.088544866460957],
            [32.134973690664374, 3.089988944657843],
            [32.132827176174416, 3.091546964222843],
            [32.132111889934514, 3.091682796327951],
            [32.13200325936214, 3.092915339039934],
            [32.13052225186896, 3.093447492647515],
            [32.12865396448715, 3.095672233683242],
            [32.12686444677932, 3.096130410883585],
            [32.126406661717276, 3.098830520538942],
            [32.12479632826423, 3.100310353513517],
            [32.12516946597538, 3.101001676049913],
            [32.12467456701738, 3.103831909678543],
            [32.12368227358148, 3.105364801949058],
            [32.12255759901546, 3.105947617893291],
            [32.12331476830717, 3.106334041778298],
            [32.123765608493756, 3.107536081276392],
            [32.12444882038646, 3.10815905174523],
            [32.12499933404373, 3.110038068252988],
            [32.12406265351044, 3.110836086953457],
            [32.124385614923085, 3.111764162439032],
            [32.124069071074835, 3.112425491990535],
            [32.12470712555652, 3.113913890990642],
            [32.123406827657504, 3.11532536939858],
            [32.12344118372553, 3.116535490359943],
            [32.122791554451425, 3.11719378868969],
            [32.122677457630544, 3.118924427828192],
            [32.121782548757984, 3.119165362364702],
            [32.122949561821684, 3.12123975885452],
            [32.12447941880169, 3.122771850801894],
            [32.124729456776166, 3.12384159293475],
            [32.1245745225425, 3.124955097608709],
            [32.12361584675948, 3.125586865201966],
            [32.123767698873436, 3.128019708837375],
            [32.12437772501994, 3.12880807049771],
            [32.12358610713371, 3.129393911511388],
            [32.1237446112723, 3.130130723878365],
            [32.12296926277416, 3.131404644787524],
            [32.12137338950225, 3.131556179562521],
            [32.122011365830524, 3.1352269695853],
            [32.123497807232845, 3.136379122452298],
            [32.123154863695035, 3.137277423793283],
            [32.124106376311964, 3.138389136392997],
            [32.12310737156258, 3.1383563270969],
            [32.1221225539065, 3.139201342397137],
            [32.12318800074923, 3.139685471418047],
            [32.1232409546386, 3.141370186458074],
            [32.125131875074004, 3.142526023559425],
            [32.12623116953831, 3.144267700133276],
            [32.12721011400908, 3.145047545443587],
            [32.12768595610665, 3.145051882256205],
            [32.12825029393782, 3.143491384688713],
            [32.12986868438063, 3.143458653588799],
            [32.13017513026678, 3.143722373425188],
            [32.130045800713624, 3.144670072253875],
            [32.13165563111013, 3.145420069060557],
            [32.13180220652009, 3.147247972782182],
            [32.13326520458844, 3.14619379623295],
            [32.13411939372746, 3.146415055930706],
            [32.135124061456416, 3.148108424732421],
            [32.1357914216776, 3.15236066762725],
            [32.136211646380985, 3.153099858656476],
            [32.13616494925757, 3.15353806071639],
            [32.13516393767187, 3.153861065810371],
            [32.13408773799518, 3.153270110633593],
            [32.13393693960506, 3.15400411034038],
            [32.134590684061514, 3.155148685625652],
            [32.13458056453984, 3.156073744832164],
            [32.13585758888648, 3.156796997072427],
            [32.13678698498111, 3.158845509995065],
            [32.13418374094959, 3.159723267962392],
            [32.13309836318565, 3.158883143341729],
            [32.13207423704937, 3.158968717783626],
            [32.1310162111892, 3.159979124605979],
            [32.12895543011335, 3.160209459394044],
            [32.12820366239142, 3.159324925380853],
            [32.128313623368726, 3.157973792251569],
            [32.127960634869396, 3.15761475969071],
            [32.126701186061275, 3.157460965693044],
            [32.125048602145476, 3.158442240126341],
            [32.124263184431335, 3.158458813981889],
            [32.12242009748817, 3.157279682793011],
            [32.122056453172945, 3.157893131226447],
            [32.12209892911283, 3.159447281907051],
            [32.12159617169272, 3.159727370609994],
            [32.12058010344454, 3.159077632656432],
            [32.11847234317426, 3.16033941028399],
            [32.11684951505395, 3.160775337318938],
            [32.11660213070281, 3.163809437721897],
            [32.11609989071229, 3.164042086676655],
            [32.11527338675198, 3.163465239982944],
            [32.11472485657487, 3.163578844515845],
            [32.11455993666847, 3.164514342932633],
            [32.113405938396625, 3.165595015474979],
            [32.11239272948597, 3.164684367007637],
            [32.110924090895956, 3.164077942985037],
            [32.11054080940865, 3.164311663729622],
            [32.11081046658892, 3.165761137664507],
            [32.11056812088823, 3.166162198204829],
            [32.109479904447966, 3.165582952467671],
            [32.1084570844621, 3.165549908132636],
            [32.107309317803384, 3.166061321592635],
            [32.10794053790238, 3.167087099595302],
            [32.10629865381995, 3.168175174609034],
            [32.10463120997269, 3.170508388018918],
            [32.10283505551158, 3.171559473243425],
            [32.10236894486346, 3.172836178658646],
            [32.10104254012564, 3.172278475744891],
            [32.100035237638004, 3.174083970623943],
            [32.09879099101942, 3.17471309383675],
            [32.098990549064865, 3.176043318188172],
            [32.097584173605505, 3.176267685678987],
            [32.09754059363612, 3.178070122216033],
            [32.096148120504104, 3.179196028157157],
            [32.09702782089891, 3.182513204810719],
            [32.09795949152782, 3.184348262475585],
            [32.09697621448245, 3.186130251100033],
            [32.09625773832495, 3.186550671059281],
            [32.09622613469493, 3.187262027582186],
            [32.09496884274181, 3.189077090621005],
            [32.097890013128804, 3.191760579211951],
            [32.09855596658828, 3.191790381232199],
            [32.098314171554804, 3.19322331411991],
            [32.09852440787401, 3.193581054396065],
            [32.09950018578341, 3.19356625072788],
            [32.09932712624225, 3.194157703970026],
            [32.09977815148177, 3.194256707756399],
            [32.10003102094606, 3.19506554955177],
            [32.098922993958844, 3.196288939046009],
            [32.09752049922152, 3.196157526222649],
            [32.09662521485316, 3.195342816748981],
            [32.09550823615417, 3.195213998590493],
            [32.09517938538652, 3.196990103434647],
            [32.09446090114418, 3.197410520744032],
            [32.09430828456394, 3.199389863670874],
            [32.09601645263627, 3.199856181402195],
            [32.09614957577484, 3.200735086599124],
            [32.096797196416006, 3.200266578105976],
            [32.09697062157149, 3.201810052658148],
            [32.096726434324445, 3.202377133826579],
            [32.096061004582786, 3.202299892614554],
            [32.095662502041286, 3.201750655488971],
            [32.09478475638054, 3.201505425973638],
            [32.094034573286756, 3.200478542268363],
            [32.093226729131544, 3.202534918664505],
            [32.0934092515259, 3.203248234625138],
            [32.092717685301054, 3.203384238726882],
            [32.09232817579387, 3.20526652714583],
            [32.09099659675999, 3.207341826757379],
            [32.091511711405175, 3.208105628084605],
            [32.089389926636706, 3.208465758803384],
            [32.08908269741963, 3.208273173081807],
            [32.08958809139512, 3.207755932761283],
            [32.0894732974816, 3.207375340627357],
            [32.08808989284235, 3.207671059269334],
            [32.08805566253845, 3.208619599898919],
            [32.08623536765068, 3.209694127159145],
            [32.08637920679228, 3.210679881200512],
            [32.086944254292526, 3.211230641856536],
            [32.086508928909204, 3.211867131012671],
            [32.08569420725219, 3.212381544004866],
            [32.08566461764502, 3.21074450680833],
            [32.08433427648963, 3.210542560515107],
            [32.08345683984935, 3.21243223520926],
            [32.082266908966126, 3.212445055550631],
            [32.08211396809406, 3.213368794176586],
            [32.08244107523172, 3.213917377496772],
            [32.08127133218787, 3.216421125883568],
            [32.081103536774265, 3.219776155799656],
            [32.080385552893546, 3.220149117890932],
            [32.07989767157454, 3.221235829893987],
            [32.08036519437427, 3.221999195690031],
            [32.08169685245988, 3.222082547752476],
            [32.08347355749679, 3.222810460465769],
            [32.083193821218984, 3.224444671006494],
            [32.08219239191667, 3.22462527028664],
            [32.082489402797364, 3.223584256853462],
            [32.082350552898866, 3.223227159388611],
            [32.08201613886466, 3.223342700880057],
            [32.07970554978304, 3.224638065361564],
            [32.079700852492415, 3.225065012327279],
            [32.077947988743134, 3.226495952302436],
            [32.07790539153066, 3.22820349470446],
            [32.07932910986492, 3.228572358508157],
            [32.080271982485435, 3.229387519504678],
            [32.08040378240561, 3.230385016272253],
            [32.07980527894924, 3.230711634981927],
            [32.0798165366364, 3.231850364982454],
            [32.0793137334022, 3.232130408811014],
            [32.07815932370192, 3.231076095951801],
            [32.078119048634484, 3.230411530071403],
            [32.07622285329172, 3.229729948885164],
            [32.07525384418802, 3.230207358014847],
            [32.07505331147049, 3.23113065091224],
            [32.073868341084285, 3.232851437903384],
            [32.07390704499829, 3.233658308245824],
            [32.074796850541745, 3.23497113714469],
            [32.07421377385376, 3.23605696690338],
            [32.07422921769012, 3.237895512324771],
            [32.07350183024498, 3.241280974133187],
            [32.0760713497241, 3.243486901151452],
            [32.0770215436142, 3.24363793779647],
            [32.077315215456984, 3.244370241389357],
            [32.07672463154819, 3.244979938065177],
            [32.07613813677054, 3.244215481923025],
            [32.0753738492285, 3.24446939904256],
            [32.07371139462436, 3.244169499108208],
            [32.072916258037125, 3.245063610216952],
            [32.07296019104444, 3.245396111277744],
            [32.074409798825144, 3.245575460169762],
            [32.07601580958503, 3.248353366141851],
            [32.074671668510256, 3.251097609441753],
            [32.07590842048442, 3.252606608323108],
            [32.07419256373155, 3.254755980219957],
            [32.072930552029945, 3.255040679613729],
            [32.070193052982574, 3.25462911489109],
            [32.07053536680136, 3.258181350615355],
            [32.070249406995295, 3.258515663498497],
            [32.06744222113976, 3.255975367826868],
            [32.06694223053071, 3.256022282843385],
            [32.06539296544901, 3.25821978299715],
            [32.063988527655724, 3.257978037981792],
            [32.06334520275826, 3.258622611705197],
            [32.06258160422403, 3.260773705289528],
            [32.065638432795346, 3.263709091768798],
            [32.065160432944445, 3.265956371277588],
            [32.06449363776356, 3.26619431529201],
            [32.064161986048866, 3.264184717129916],
            [32.06347101900031, 3.264853111887947],
            [32.06032947660279, 3.263603680421495],
            [32.059972087256874, 3.26393786235437],
            [32.05961386966428, 3.265276519010249],
            [32.060232150429954, 3.266138659093536],
            [32.06027847924409, 3.267693314021867],
            [32.06078935653606, 3.268878134650081],
            [32.06052684096228, 3.269642980135496],
            [32.05888382140931, 3.269998701562256],
            [32.058168570203655, 3.27124104173388],
            [32.05666834056005, 3.271668777054856],
            [32.056286458647946, 3.272816067879487],
            [32.05470195804753, 3.274379672871098],
            [32.05393683686891, 3.278300572216093],
            [32.053209773715594, 3.279411346706173],
            [32.052138470755516, 3.279361525213916],
            [32.05175652146976, 3.280580562750421],
            [32.050898585457674, 3.281607383996869],
            [32.05102869295185, 3.282600167264888],
            [32.05052768006001, 3.283842889989387],
            [32.05113233428111, 3.286749867002363],
            [32.05084612833664, 3.287347243205606],
            [32.05001307925117, 3.287082618825434],
            [32.04932225323813, 3.287559670711393],
            [32.050010614274036, 3.290000421955633],
            [32.049258506988934, 3.292546136980575],
            [32.05061453187662, 3.293768393279181],
            [32.05173199117429, 3.295564203130128],
            [32.051671022515954, 3.297274119612864],
            [32.052571726420425, 3.298616023867482],
            [32.05104587862156, 3.301124428673437],
            [32.049175486487016, 3.302830975194286],
            [32.04912732870295, 3.303476628466708],
            [32.05029293859818, 3.304650704837704],
            [32.05017313478031, 3.30553539465103],
            [32.04886273442758, 3.306657031539393],
            [32.048433308280735, 3.307684636612505],
            [32.04884937019109, 3.308367029366254],
            [32.0487056307625, 3.309419089768814],
            [32.0504430273192, 3.310139822030037],
            [32.05120409799423, 3.311073979784143],
            [32.05172676657261, 3.312390356384225],
            [32.05127253524584, 3.314589829190131],
            [32.05204510525479, 3.3160143081253],
            [32.051282065472684, 3.317376118618922],
            [32.05161465323189, 3.318237733821229],
            [32.05137611998125, 3.318763454000419],
            [32.049446652836984, 3.319907841363454],
            [32.04717049977346, 3.322737693351659],
            [32.04412149552827, 3.324477891036089],
            [32.04305820733716, 3.328888482940523],
            [32.04358158738127, 3.32936779257626],
            [32.04639061388482, 3.329851384192289],
            [32.04689020833681, 3.330306725530084],
            [32.046508478239986, 3.331214833765334],
            [32.04342281374805, 3.33401923812389],
            [32.04303986912898, 3.336338421308817],
            [32.04453851055115, 3.337871878296326],
            [32.043632737453564, 3.339320536017301],
            [32.04198732389036, 3.3379191221596],
            [32.04151308887883, 3.336842603436455],
            [32.0397209319207, 3.336679726216235],
            [32.03769502703744, 3.335463578979226],
            [32.03465374381213, 3.335692235296843],
            [32.0328125226698, 3.333450519362098],
            [32.030654402844704, 3.332775135362739],
            [32.03154553609813, 3.329873710891238],
            [32.03255826890169, 3.329945905868613],
            [32.032845409992376, 3.329094553101287],
            [32.03251590884445, 3.326412729321346],
            [32.031412201855474, 3.323965303110509],
            [32.031284868358874, 3.321820617318678],
            [32.03218058212193, 3.317959345371112],
            [32.02672677977635, 3.314702797069062],
            [32.02594093895568, 3.313697404375335],
            [32.02608845939333, 3.313293422175332],
            [32.02702050372143, 3.312971048092603],
            [32.0268549756556, 3.312429982132505],
            [32.02399331057133, 3.311028863675609],
            [32.02048073880864, 3.307739691418393],
            [32.02068262528725, 3.306238026525909],
            [32.021278951227366, 3.305404248065442],
            [32.02111337105927, 3.304920725202841],
            [32.019419549082016, 3.303819979619977],
            [32.01793119516647, 3.304171063950115],
            [32.01731834561501, 3.303570459420825],
            [32.017039057596556, 3.302263963075779],
            [32.01753414789574, 3.299565703975398],
            [32.017180647356696, 3.298028962558831],
            [32.01433817208352, 3.29464263035507],
            [32.01188868549266, 3.293403025024518],
            [32.01229066541265, 3.292223802796596],
            [32.01367755461684, 3.290993770846875],
            [32.013438186831294, 3.289854189455858],
            [32.01246611806571, 3.288495217363722],
            [32.01116163671243, 3.28745239824806],
            [32.00958731941407, 3.28714009892307],
            [32.00853095004727, 3.287515323918423],
            [32.00742155762083, 3.288524712508225],
            [32.00669447021303, 3.288420408676306],
            [32.00655297118275, 3.285370173702598],
            [32.00806202946897, 3.280188217993602],
            [32.0067034731288, 3.27722592145797],
            [32.00492891416712, 3.275460413591176],
            [32.004523613175515, 3.274450587595767],
            [32.005537338617465, 3.273291088930846],
            [32.00486943491549, 3.271067045342245],
            [32.00485343322537, 3.265722370684732],
            [32.005354841375905, 3.264374628557851],
            [32.0062125357412, 3.263633732351648],
            [32.00786730885137, 3.263534233984128],
            [32.00900836509489, 3.261416555249823],
            [32.01099856553889, 3.25993471667504],
            [32.0114012757892, 3.259144233265753],
            [32.01130229042803, 3.257028614354409],
            [32.01231923633024, 3.255831442479781],
            [32.011408263783785, 3.254678546577248],
            [32.01218281996785, 3.253928604605671],
            [32.01225788858286, 3.253298006456102],
            [32.01187524130613, 3.253030397282999],
            [32.01048301251586, 3.253620432087604],
            [32.00961996958138, 3.253412990252479],
            [32.00864351074902, 3.251284848874328],
            [32.00842214430343, 3.249242967666186],
            [32.00976268672721, 3.248859473552892],
            [32.00968964201649, 3.247416340788882],
            [32.00921634843938, 3.246808973866591],
            [32.0093126577193, 3.24386284112461],
            [32.00831611794708, 3.241116377232041],
            [32.0081810203115, 3.238918636253382],
            [32.00857820592279, 3.235047928334862],
            [32.011243367233575, 3.232227672542067],
            [32.01325637051273, 3.23204574094347],
            [32.01339391156589, 3.231733244144135],
            [32.01156535038089, 3.229726565821894],
            [32.00979229250402, 3.228465490533368],
            [32.00919207596041, 3.224722532045652],
            [32.00615604069297, 3.223202380892348],
            [32.00648824576989, 3.220278694372861],
            [32.0051912644509, 3.218024646730408],
            [32.006454984748196, 3.216839728848153],
            [32.00651795934455, 3.21580928819421],
            [32.00408836145405, 3.215345697143465],
            [32.00261003722867, 3.215759268936251],
            [32.000829074177275, 3.214490606489276],
            [32.00050427570989, 3.213245217994238],
            [32.00139821889355, 3.210319093830317],
            [31.99906086810126, 3.207147122326574],
            [31.997232052693015, 3.205849480800222],
            [31.993951577751957, 3.203395345183596],
            [31.99429572682888, 3.200118936124723],
            [31.991602221874228, 3.197953196561473],
            [31.990441121521734, 3.19769504964139],
            [31.989877634395146, 3.196463035269512],
            [31.987087112288137, 3.195464399449237],
            [31.985258838564008, 3.195889519029043],
            [31.980708998312398, 3.191442448175392],
            [31.979784161167842, 3.189310577887172],
            [31.976642501090996, 3.18788324084246],
            [31.975812694923718, 3.186629544068236],
            [31.972065258629957, 3.183681019385508],
            [31.97080983876588, 3.181870064640616],
            [31.968719144689395, 3.17360119676012],
            [31.968924793312457, 3.170356803304764],
            [31.968553880728273, 3.168353989013215],
            [31.969055700307212, 3.167272957881581],
            [31.969024839583962, 3.166159268785532],
            [31.966597738111638, 3.158658549639839],
            [31.966951509941897, 3.157261328469449],
            [31.96593552793197, 3.154139701159303],
            [31.9643765673334, 3.151132402288253],
            [31.96494025119104, 3.149342922119702],
            [31.96599799677683, 3.148750487085624],
            [31.966370130171498, 3.148042498196308],
            [31.964866945070572, 3.146423258639988],
            [31.96387614463471, 3.146738160106512],
            [31.963266963802873, 3.146383371676177],
            [31.960924056032276, 3.136784682750779],
            [31.961176741341927, 3.131654120133809],
            [31.95982407974664, 3.126745588272741],
            [31.959729962356008, 3.124102959553615],
            [31.957505911578977, 3.122405966653788],
            [31.955970632367915, 3.118592162233689],
            [31.953479339980337, 3.114645847157127],
            [31.946648743697676, 3.107249129155175],
            [31.93938353978562, 3.096463348229682],
            [31.930950696684118, 3.086840021388616],
            [31.93061442673054, 3.085841496888114],
            [31.93086526330733, 3.082993055161444],
            [31.929646862117803, 3.081226925982337],
            [31.928623332462866, 3.07505772384129],
            [31.927094085438952, 3.074643373237749],
            [31.92712547886318, 3.073010127852365],
            [31.925085949232006, 3.071015827380377],
            [31.92513433159488, 3.070250090503072],
            [31.9264562690108, 3.069647174138341],
            [31.926951057476057, 3.068869922938341],
            [31.927191224762183, 3.066776219469129],
            [31.92492067718605, 3.06368087368996],
            [31.923853356457638, 3.059653441964565],
            [31.923341524256518, 3.053658264863955],
            [31.922849393906205, 3.051779203553848],
            [31.92020387246245, 3.048725363773706],
            [31.9208675846253, 3.045656912305737],
            [31.92072074600895, 3.043694442052757],
            [31.9201860013782, 3.042772569587699],
            [31.91800872318304, 3.041693491969513],
            [31.91767228973609, 3.038869324563819],
            [31.917108251043917, 3.037486756522924],
            [31.91630534941938, 3.036899643999815],
            [31.91671085073526, 3.036116320269109],
            [31.915660459656713, 3.03304016309156],
            [31.91607793371868, 3.032185059397351],
            [31.916049677211443, 3.030677395128882],
            [31.915193101248665, 3.030203901337312],
            [31.91348141627202, 3.027791156385983],
            [31.911612758784308, 3.02655192833442],
            [31.911305775705635, 3.02510872369265],
            [31.91230896301097, 3.023349248857517],
            [31.912152129738747, 3.023047224094257],
            [31.911167821427444, 3.022642572264517],
            [31.910700157592217, 3.022000210364056],
            [31.909600940382997, 3.022647873921772],
            [31.908804725817447, 3.022398603605776],
            [31.90906675450437, 3.021280770325433],
            [31.90747511678901, 3.01999542107058],
            [31.907037029984515, 3.018656022796554],
            [31.905444811059166, 3.018053129588496],
            [31.903387519039885, 3.015449882448755],
            [31.903293402547583, 3.013448258505389],
            [31.904091721865836, 3.011585574296776],
            [31.902076376678757, 3.008339677978146],
            [31.90070325595288, 3.008269269965208],
            [31.900031958415806, 3.006708778525848],
            [31.899964115848917, 3.005894295385307],
            [31.900995401558028, 3.004501173351862],
            [31.901051213886625, 3.00361779631784],
            [31.903263597344754, 3.00206022002532],
            [31.902372559312756, 3.00052711575111],
            [31.902658656561083, 2.997353280000698],
            [31.902033907925375, 2.99587494619288],
            [31.90187248516038, 2.992506693909712],
            [31.89805811090324, 2.989466049615696],
            [31.891640445902198, 2.980749481881693],
            [31.890113384479353, 2.975578273609623],
            [31.885482589850984, 2.975573577269489],
            [31.884284568740306, 2.97246684923824],
            [31.883132102095978, 2.971178745061211],
            [31.88208713774006, 2.970697339913975],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 546,
        District: "AMURU",
        County: "KILAK",
        Subcounty: "PABO",
        Population: 54415,
        Key: "AMURUPABO",
        Dist2: "Amuru",
        "Sub Country": "Pabbo",
        id2_original: "Amuru Pabbo",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.88148794264135, 3.052410765309878],
            [32.90599022144772, 3.109966161765562],
            [32.906787333430245, 3.116824223161671],
            [32.90660816804007, 3.123251327601069],
            [32.90612330326379, 3.12468162556344],
            [32.913384484520016, 3.125706607402568],
            [32.91358420156725, 3.119847022787545],
            [32.915419638457465, 3.119068710491501],
            [32.92170207107562, 3.119069199348095],
            [32.922932607606334, 3.119655244030502],
            [32.92506973739649, 3.122389849686698],
            [32.92759556551515, 3.123952570939326],
            [32.928761365853234, 3.124213075532687],
            [32.92966832562532, 3.121022943766112],
            [32.93093696330049, 3.120169924373737],
            [32.93101013736859, 3.119532803011688],
            [32.93207467421793, 3.118743652215584],
            [32.9353165296866, 3.118359484314119],
            [32.93719777257145, 3.117713297814662],
            [32.94456803086274, 3.112962181719078],
            [32.94595391395384, 3.11107951069794],
            [32.94870859328103, 3.109952426122543],
            [32.95100003746731, 3.110173079029525],
            [32.95277952907826, 3.111153354610582],
            [32.9562265049606, 3.115766990449286],
            [32.955395675612195, 3.12170085180422],
            [32.95655288895445, 3.126509865124574],
            [32.95662991499851, 3.129767553853507],
            [32.95755577622249, 3.131629125959219],
            [32.957324228271474, 3.133180396145715],
            [32.9577099531764, 3.135274637298927],
            [32.95925295610227, 3.141236849845709],
            [32.95163899834913, 3.1425967518947],
            [32.946400084697586, 3.142740118187804],
            [32.93237387698791, 3.146305934327957],
            [32.925896496478344, 3.148675270784179],
            [32.92205065603344, 3.148519396313018],
            [32.91381138550259, 3.14681920410183],
            [32.91496559757351, 3.15575982835403],
            [32.91696531656622, 3.16353955378272],
            [32.9196675387724, 3.17166643415585],
            [32.919869577066294, 3.176633404701136],
            [32.91859514705421, 3.181480574325477],
            [32.91852350820692, 3.183922152398703],
            [32.91858230743382, 3.186430150162326],
            [32.919620033165224, 3.189200746854274],
            [32.91592763305568, 3.19012829414752],
            [32.90929265121434, 3.19389709135915],
            [32.906984744502154, 3.196042522498476],
            [32.90523393250497, 3.198743315018254],
            [32.87665052471784, 3.184718885724431],
            [32.87174764655956, 3.181837964397256],
            [32.8713024208435, 3.175208616232334],
            [32.87194027949245, 3.171748745373964],
            [32.87066686457661, 3.16008730746213],
            [32.87008803691993, 3.159697575736953],
            [32.86613609825345, 3.159056341749663],
            [32.865119205351824, 3.159312250580723],
            [32.864096515621675, 3.157806655259877],
            [32.861164375906746, 3.157806265086047],
            [32.858741994182935, 3.159151470489997],
            [32.857658080672905, 3.161329800372026],
            [32.85612810511531, 3.162482899344681],
            [32.851538675210826, 3.162322069516218],
            [32.84828774226618, 3.162834177908912],
            [32.847586501185724, 3.163346660075382],
            [32.84618417353502, 3.163282379505931],
            [32.84573789768839, 3.163858966187086],
            [32.843512105078005, 3.163350337556003],
            [32.84344352050268, 3.16148792695276],
            [32.840001541049965, 3.160846669854151],
            [32.83337215840777, 3.161998931614763],
            [32.83095004977184, 3.161421885558859],
            [32.82892477281095, 3.162361972910529],
            [32.82793636099541, 3.163259448170177],
            [32.826412299047306, 3.163211319810016],
            [32.82526941203719, 3.162301518657624],
            [32.82441185062259, 3.163881217624472],
            [32.820791825080526, 3.165963123246085],
            [32.8183272836238, 3.164993238160777],
            [32.81751756378629, 3.165352151565054],
            [32.817184027406114, 3.166189885073597],
            [32.813872325229156, 3.165415615786432],
            [32.814424967893615, 3.163956117997095],
            [32.81505012705939, 3.163660537484056],
            [32.81527101470292, 3.162182113425307],
            [32.8148298287107, 3.161812418507674],
            [32.81574947359294, 3.159705771165864],
            [32.81563998243451, 3.155048590086287],
            [32.81655974230111, 3.152239670052072],
            [32.81644968250912, 3.150798148502182],
            [32.81725883371307, 3.149652481316918],
            [32.8170383018024, 3.149134980190555],
            [32.81906118026148, 3.146215367254892],
            [32.819760236639155, 3.143776021702945],
            [32.82223298779925, 3.142514049980937],
            [32.82206203031586, 3.139584124918272],
            [32.82303483839492, 3.132230826574],
            [32.82286372460464, 3.130220083223121],
            [32.82560796820318, 3.124130956997384],
            [32.82577968476298, 3.122522413706858],
            [32.8249798365121, 3.120971158252954],
            [32.82509433757484, 3.119764748732723],
            [32.825951845988875, 3.11821376996498],
            [32.82646678995414, 3.114594570819402],
            [32.82732425435072, 3.113273385087263],
            [32.82778181752889, 3.111032950567311],
            [32.826468219173755, 3.105862326156235],
            [32.825897411675925, 3.101668455335788],
            [32.826297727915964, 3.100002501106707],
            [32.8253836525885, 3.098106532243622],
            [32.82304079961513, 3.096555019317894],
            [32.82058405284016, 3.092648073153215],
            [32.81818414876139, 3.090636949307785],
            [32.81732723323547, 3.088798434240952],
            [32.817327380559156, 3.087936699482589],
            [32.81807057565832, 3.086385705401937],
            [32.82247133599695, 3.084375737608122],
            [32.82538637717876, 3.081446324564219],
            [32.828473223853614, 3.07616151848153],
            [32.828588189345346, 3.071967758185317],
            [32.82778848212998, 3.069727117124765],
            [32.82978944618767, 3.064671923352416],
            [32.82956197479145, 3.057605655915915],
            [32.83007673999196, 3.054790734792137],
            [32.83116284269632, 3.052780189968039],
            [32.830307254880374, 3.042496673215106],
            [32.83202335328002, 3.031409272921929],
            [32.83288096769525, 3.028594400891575],
            [32.835396128319914, 3.023539268724819],
            [32.844807047221316, 3.013198498968469],
            [32.84617857523418, 3.015278980453608],
            [32.84717811807439, 3.018797886147319],
            [32.84965414718695, 3.020617457511896],
            [32.85228307495079, 3.024536066918599],
            [32.858461266165065, 3.029432036284566],
            [32.859818270216415, 3.030988130895623],
            [32.86022287860692, 3.032328661269188],
            [32.86217501114408, 3.035057754340396],
            [32.86863970923849, 3.034400285311243],
            [32.87016353762461, 3.034903155829337],
            [32.87178250298921, 3.036291706044096],
            [32.87332778134769, 3.04032957274963],
            [32.8755299590459, 3.043190327836667],
            [32.87674406089848, 3.045512370308445],
            [32.87845827732761, 3.047020606800535],
            [32.88148794264135, 3.052410765309878],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 547,
        District: "PADER",
        County: "ARUU",
        Subcounty: "ACHOLIBUR",
        Population: 14038,
        Key: "PADERACHOLIBUR",
        Dist2: "Pader",
        "Sub Country": "Acholibur S/C",
        id2_original: "Pader Acholibur S/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.6379218581508, 3.156902832039637],
            [32.632303191594346, 3.159109216962819],
            [32.628308645833926, 3.159167716947438],
            [32.62664008538081, 3.156949738146745],
            [32.62568630092452, 3.156589818146046],
            [32.624911740248905, 3.15521116740999],
            [32.62425607699102, 3.154791425366374],
            [32.61996338757433, 3.155029574668456],
            [32.6145181012576, 3.152360368940898],
            [32.609483618113586, 3.153006459589124],
            [32.60653716284628, 3.151894525777291],
            [32.605585510990494, 3.152048443481499],
            [32.6050941801408, 3.15254195407599],
            [32.60429609258787, 3.152479936754389],
            [32.60202501680231, 3.151244824186894],
            [32.59877089124515, 3.152014969970605],
            [32.59373664974795, 3.152043863622895],
            [32.59171025887613, 3.153123027012792],
            [32.58633773160584, 3.154725405970455],
            [32.581395722833804, 3.154384002819806],
            [32.57973789994327, 3.154907882264626],
            [32.57777281010643, 3.156172176425514],
            [32.57685201268569, 3.155924952912752],
            [32.57077372940233, 3.15681726998485],
            [32.56420350890648, 3.159591552695164],
            [32.562298256749, 3.161402949189144],
            [32.556651384889285, 3.161377979048586],
            [32.554068189458285, 3.162023872141099],
            [32.55299880350301, 3.160635864474763],
            [32.55438046630891, 3.159895920884855],
            [32.551772621106494, 3.156716640022724],
            [32.54942813679256, 3.157743644430301],
            [32.54912259191667, 3.156864903523988],
            [32.54803049834767, 3.15572223705101],
            [32.54728757813295, 3.155634051311046],
            [32.54370339986233, 3.156774665654409],
            [32.54033815809443, 3.156948895908805],
            [32.53924576538643, 3.156509106784102],
            [32.53797832786047, 3.156596401776166],
            [32.53544272966479, 3.158396408633681],
            [32.533255202590574, 3.157943833186168],
            [32.5322572560566, 3.158115332925542],
            [32.53133436825618, 3.158921716690972],
            [32.52989223356033, 3.158745340365062],
            [32.528931114359736, 3.157954158887927],
            [32.52512889879998, 3.157996348778572],
            [32.522768696663526, 3.158478493977448],
            [32.52062604043773, 3.161069383975498],
            [32.51874713496923, 3.160321696436166],
            [32.51498802776332, 3.161637843744627],
            [32.51350262122022, 3.160538890846565],
            [32.51171076160447, 3.160581975787162],
            [32.50790676378716, 3.16440209019925],
            [32.504613817535, 3.163865732748073],
            [32.502792717756726, 3.164635453886447],
            [32.50055184333105, 3.166821173824585],
            [32.49757466747768, 3.173845753048523],
            [32.495030634999765, 3.177648380304082],
            [32.49757466747768, 3.173845656179282],
            [32.5005518406361, 3.166821077851611],
            [32.502792717756726, 3.164635357016343],
            [32.50461381663667, 3.163865635877897],
            [32.50744062079972, 3.164131890689429],
            [32.50873460084734, 3.163482312460423],
            [32.51044573874998, 3.16161245832279],
            [32.51062524280502, 3.159661734525275],
            [32.51231703369137, 3.157340716769205],
            [32.51348395063535, 3.157125843898146],
            [32.516388522850846, 3.158371894071787],
            [32.51705545547395, 3.157989218017133],
            [32.51758032402648, 3.155859136300193],
            [32.515761129574955, 3.15050852363107],
            [32.516202700046094, 3.148270682925909],
            [32.515417268857234, 3.147432544789518],
            [32.51353626043266, 3.147048686104275],
            [32.51356102159516, 3.145014103998328],
            [32.514752414037346, 3.143339118824561],
            [32.51486066911393, 3.140957510515937],
            [32.51626717393067, 3.137535268251582],
            [32.51752960873882, 3.13669809201428],
            [32.51873307184347, 3.13462815714641],
            [32.52118698712869, 3.131876600103999],
            [32.52178360052967, 3.128980672925347],
            [32.52143860613809, 3.128370143297373],
            [32.52041483483632, 3.12803456008359],
            [32.517413774576184, 3.129660845170527],
            [32.51265121057035, 3.129993743216839],
            [32.504756899396824, 3.131294555575957],
            [32.50361399711536, 3.131126456340138],
            [32.50058949262291, 3.131914905360278],
            [32.50058903717707, 3.131476371310201],
            [32.49749624455337, 3.132352572750611],
            [32.4919951899255, 3.1326971216192],
            [32.48260754906804, 3.129677210488085],
            [32.476128932476634, 3.128615350655616],
            [32.47029713163591, 3.126306792832965],
            [32.47043605609459, 3.123673534662246],
            [32.47093788375837, 3.122448664775144],
            [32.475164813801335, 3.119653094856728],
            [32.484159630368175, 3.109658072676054],
            [32.48524308663572, 3.107487683047863],
            [32.485434881440476, 3.103066014363125],
            [32.48650396196851, 3.100290906542712],
            [32.49143934746198, 3.095403310827102],
            [32.495132211102195, 3.089842385001123],
            [32.49759720351319, 3.088686074733201],
            [32.499797737294415, 3.086739580271816],
            [32.50054038981116, 3.084473085147411],
            [32.502840022141285, 3.0804409103922],
            [32.50648535771647, 3.075535665927823],
            [32.51001254686547, 3.068547897367725],
            [32.51146562483816, 3.067160258048928],
            [32.51203712583538, 3.067064768469213],
            [32.5132749872289, 3.067711622722431],
            [32.514989641137575, 3.067090055703147],
            [32.516800134507285, 3.065128097369968],
            [32.5175149446401, 3.064003429077244],
            [32.5174571928488, 3.060065858988811],
            [32.52180513045211, 3.054382926521149],
            [32.523723833982615, 3.049919646052726],
            [32.52804803719778, 3.043901562356422],
            [32.527835198459215, 3.040550369237391],
            [32.52816874202587, 3.040095731300333],
            [32.530978681217775, 3.039307054490067],
            [32.5335394313431, 3.036591388492366],
            [32.533016764561324, 3.033910279242131],
            [32.53593546727623, 3.029279846472692],
            [32.53841201202177, 3.028538878221396],
            [32.54309315183193, 3.022592662228785],
            [32.546689425917876, 3.020176598233033],
            [32.54778523851216, 3.018812680604239],
            [32.551228154907754, 3.012937700884431],
            [32.55249056366472, 3.011717463997877],
            [32.55595142750135, 3.004700923552383],
            [32.55904361106729, 2.998267823263834],
            [32.55926954544611, 2.997052232135288],
            [32.566168354401526, 2.986555737655441],
            [32.570857277215346, 2.977546172933187],
            [32.57257739288095, 2.975896280830709],
            [32.5756504468229, 2.970930271316564],
            [32.57624100827384, 2.968052478157191],
            [32.57834359065478, 2.964783268110669],
            [32.577693124150834, 2.962891499398001],
            [32.57812294375978, 2.961419013360236],
            [32.57961176749421, 2.959247690877408],
            [32.582816769578386, 2.955883234511457],
            [32.58546773481276, 2.951738778582327],
            [32.5860618419141, 2.951189876151076],
            [32.58751256091082, 2.951048540551496],
            [32.58920012612212, 2.94983193117066],
            [32.589793316941865, 2.948303020993696],
            [32.59416471584544, 2.942943462960331],
            [32.599139779925004, 2.934775568097729],
            [32.602513838657444, 2.931290580619704],
            [32.605091175276144, 2.927864217738675],
            [32.60625380366294, 2.92492585099602],
            [32.61013728890817, 2.919469594687328],
            [32.62064740705246, 2.901334918992916],
            [32.62401711614229, 2.896841335963199],
            [32.624455324219326, 2.894989492183563],
            [32.62788025634293, 2.890232447219659],
            [32.631628720309365, 2.891707672546461],
            [32.63362509397598, 2.893276871844429],
            [32.63649519064747, 2.894595381995201],
            [32.63924064786996, 2.895411909695662],
            [32.63905290267052, 2.897105882776728],
            [32.63961407124536, 2.898549128645301],
            [32.640924591074004, 2.898361320382248],
            [32.642110580149755, 2.897295084548444],
            [32.643795554619764, 2.896981908623402],
            [32.64398305637576, 2.896040838096794],
            [32.6451063259767, 2.895978450826588],
            [32.64654133703237, 2.896794546889698],
            [32.64828871207525, 2.896481384283719],
            [32.65009823885772, 2.896983884185717],
            [32.65047238627525, 2.897862389123121],
            [32.65034682874797, 2.900309289838688],
            [32.65259251365204, 2.903007894986624],
            [32.65409028550501, 2.902694646178916],
            [32.65546304151487, 2.903071520850482],
            [32.65758495923401, 2.90238200556087],
            [32.66226495638713, 2.903199069528128],
            [32.66419969933705, 2.90238400085134],
            [32.66469866586667, 2.903262540172126],
            [32.66563458552689, 2.903702013232102],
            [32.666944650808, 2.905082730235672],
            [32.67162319897857, 2.910981872926456],
            [32.67449328487031, 2.912676749416572],
            [32.67530417611097, 2.913931827890207],
            [32.67773771491059, 2.914685438612049],
            [32.68073314273393, 2.914560812364788],
            [32.682043503560784, 2.915000380604893],
            [32.68460215611992, 2.914687393508841],
            [32.685226056745975, 2.915189506707481],
            [32.686536543336956, 2.915189873642997],
            [32.69021797142363, 2.916696714298669],
            [32.69215241613287, 2.91701095953898],
            [32.694585756404805, 2.918580183778227],
            [32.69683280405314, 2.921672737480058],
            [32.69474083077568, 2.923677288212731],
            [32.693411134610656, 2.927077556131685],
            [32.69159843587694, 2.929748980989844],
            [32.68968522374776, 2.937544031113422],
            [32.68725615316836, 2.940041614172398],
            [32.681539050121394, 2.943174748574179],
            [32.67708456783384, 2.944143742244441],
            [32.67416604388365, 2.943481576086759],
            [32.67317269852058, 2.943649854358098],
            [32.671904696852664, 2.942313521037359],
            [32.672205327045624, 2.946989467730357],
            [32.67117753039308, 2.950389787575496],
            [32.67111670187195, 2.95184717979858],
            [32.67320352510788, 2.958288007211566],
            [32.67311558453313, 2.965115221365295],
            [32.67472372699519, 2.974075093872195],
            [32.67596779125576, 2.974955060575541],
            [32.6776005870825, 2.978435115956854],
            [32.6774106104679, 2.978745592979953],
            [32.67981536544916, 2.981163017953976],
            [32.6800422304826, 2.98205968387192],
            [32.68332895230817, 2.986342708927557],
            [32.683639317543886, 2.987490456610767],
            [32.68498440364634, 2.988675457591469],
            [32.68555673378859, 2.990134294738026],
            [32.68629423806044, 2.990278712228307],
            [32.68691622527497, 2.993793243567893],
            [32.685305313306884, 2.998407495893752],
            [32.684424200760446, 2.998933849907831],
            [32.68351858307139, 3.001901753084415],
            [32.6817440968732, 3.00418721128686],
            [32.68350458911587, 3.009142655181295],
            [32.683277737557184, 3.011428554824213],
            [32.68370613064144, 3.012074981335419],
            [32.683753399093376, 3.013271834709947],
            [32.68487202081103, 3.014828060141256],
            [32.685525979066526, 3.017664763991259],
            [32.68531141017272, 3.018646113774331],
            [32.685811184287765, 3.019460111928547],
            [32.685739565203406, 3.020130321207721],
            [32.686310865876344, 3.020633167849625],
            [32.68631023256406, 3.022835358805195],
            [32.687226739630994, 3.0234699471444],
            [32.68736934808068, 3.024355656576688],
            [32.687131090612816, 3.024906135341589],
            [32.68751166817113, 3.026246707332372],
            [32.68691617496929, 3.027060386709752],
            [32.68751092616273, 3.028831885997401],
            [32.68790274164523, 3.032506313625647],
            [32.686711803750576, 3.033966112018072],
            [32.686449295363296, 3.036024603633277],
            [32.68541299795324, 3.037879411896891],
            [32.68572231575334, 3.03864547685732],
            [32.685293655869415, 3.038884727844846],
            [32.684733303863176, 3.041649270108326],
            [32.684090246663686, 3.042247495384573],
            [32.684375437511875, 3.044090720136683],
            [32.68485148532365, 3.044641406832769],
            [32.68435118569413, 3.045598733461205],
            [32.68441047360457, 3.046400633505286],
            [32.68507703522351, 3.046903510090264],
            [32.68586229303752, 3.048603250082048],
            [32.682705777520844, 3.054024016613621],
            [32.68294352474563, 3.055244864179505],
            [32.68391958382768, 3.055891455561433],
            [32.6833477693184, 3.057088124065405],
            [32.683644967947025, 3.058584263931632],
            [32.6855258020984, 3.059374733234875],
            [32.68666841961395, 3.060452234955596],
            [32.68623914348575, 3.06277398087339],
            [32.68673882687096, 3.063994905487742],
            [32.68426234680412, 3.064425038991681],
            [32.68367875088991, 3.06517887106952],
            [32.68294054683045, 3.065370150165177],
            [32.681987515162355, 3.067356626528791],
            [32.68129681401515, 3.067954833892863],
            [32.6786296162236, 3.069103001927318],
            [32.677248496898436, 3.069365889059765],
            [32.675915237116705, 3.068790998013549],
            [32.674022008011015, 3.069592310210559],
            [32.670950508154476, 3.069112623436968],
            [32.66990270242731, 3.069495285138734],
            [32.66673584550504, 3.069398553385807],
            [32.66417654166734, 3.068141065814627],
            [32.65989052134331, 3.068187581181185],
            [32.655366126770446, 3.0690717800114],
            [32.654865955600016, 3.069478542139191],
            [32.65513848110103, 3.073535915378166],
            [32.65694726407843, 3.076265291234825],
            [32.6571490634205, 3.078144398351728],
            [32.65760122682548, 3.078910517074114],
            [32.657124154035984, 3.081567346426938],
            [32.65611143111389, 3.083852975680065],
            [32.65646775415954, 3.086510074351948],
            [32.65565716834609, 3.089597655705687],
            [32.65485900443634, 3.091045565386869],
            [32.65495396354842, 3.091955197826224],
            [32.653810489040104, 3.093534643982264],
            [32.65385782756065, 3.094420323343456],
            [32.65166641796774, 3.096669659072007],
            [32.648629744896475, 3.098715241456531],
            [32.64758114146532, 3.101371870536175],
            [32.64733012253052, 3.104375844338576],
            [32.64835356235395, 3.10581238591512],
            [32.64821046881403, 3.106482574335275],
            [32.64909132354396, 3.107033413592955],
            [32.648971615845824, 3.10899617897393],
            [32.64951909409573, 3.109594782673716],
            [32.64866183541335, 3.109666311552592],
            [32.64836368097728, 3.111210123393089],
            [32.64783974397771, 3.111401445326312],
            [32.64817258506187, 3.113005314366814],
            [32.64733892961356, 3.113699199359568],
            [32.647552725057935, 3.115231223356567],
            [32.64707619215589, 3.116116725759033],
            [32.647802127025194, 3.117134275451998],
            [32.64727802832888, 3.117804334682486],
            [32.64787320891701, 3.118187520587892],
            [32.64820563497948, 3.121036099813736],
            [32.647205397741516, 3.121394819342384],
            [32.64657365122975, 3.123560876583288],
            [32.646144995837446, 3.12365647588499],
            [32.64657291371294, 3.125763054281089],
            [32.64516702334381, 3.128611043375037],
            [32.64459537771782, 3.129041711247893],
            [32.64382059156507, 3.131662516705322],
            [32.64265307544479, 3.133720673021624],
            [32.643081532309445, 3.134223496571171],
            [32.64265270983048, 3.134797832695064],
            [32.64273553360137, 3.136317841478777],
            [32.64223475606813, 3.138424093029384],
            [32.64471030098876, 3.141297353758612],
            [32.64404348065502, 3.141488613695627],
            [32.6441502014091, 3.142769266835129],
            [32.6409587090885, 3.144467677107154],
            [32.64057727184246, 3.145736182625374],
            [32.64160067932653, 3.147340301395537],
            [32.641350034090884, 3.14909956018539],
            [32.641706667953635, 3.150751314771122],
            [32.64251588922619, 3.151948435545503],
            [32.6428006398999, 3.154916680484245],
            [32.64105029143338, 3.155191345633883],
            [32.63976406205002, 3.156124428044695],
            [32.63766837154391, 3.156530619290306],
            [32.6379218581508, 3.156902832039637],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 548,
        District: "PADER",
        County: "ARUU",
        Subcounty: "ANGAGURA",
        Population: 8973,
        Key: "PADERANGAGURA",
        Dist2: "Pader",
        "Sub Country": "Angagura S/C",
        id2_original: "Pader Angagura S/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.80209135146924, 2.859157149463355],
            [32.799581913112945, 2.860841781001022],
            [32.79321301764866, 2.863796874306204],
            [32.78983193139579, 2.86650115557488],
            [32.78622449484411, 2.870079082418707],
            [32.78679506698334, 2.874387873081898],
            [32.78666343145486, 2.87813400764654],
            [32.78397237081612, 2.882537925341032],
            [32.782555748274305, 2.883004422268132],
            [32.78172232459138, 2.883866000211649],
            [32.780055090949915, 2.887575925917804],
            [32.77915024401536, 2.888389619115056],
            [32.77885235368401, 2.889957435075545],
            [32.77954255536794, 2.891034737251534],
            [32.77901867945379, 2.891609127232181],
            [32.77904230334913, 2.892566615177904],
            [32.77813712942784, 2.895079834390042],
            [32.777422716350344, 2.896013237620089],
            [32.77691049517872, 2.897844326468648],
            [32.77319553567746, 2.902654936858889],
            [32.771659317726936, 2.905706604937047],
            [32.771349533701176, 2.907094893307145],
            [32.770468396001924, 2.908291563126264],
            [32.770408210674525, 2.911606836202929],
            [32.76978865789442, 2.914263726295626],
            [32.76916952732253, 2.91488596758259],
            [32.7694190290028, 2.917243821422632],
            [32.767632270021195, 2.922844721159615],
            [32.76747657581279, 2.927404700279721],
            [32.76892869079147, 2.928362483480995],
            [32.76897622244979, 2.928745484210026],
            [32.768023762110246, 2.929367655567102],
            [32.76932105783958, 2.930648560202574],
            [32.76901134657739, 2.931629916561661],
            [32.76939216578253, 2.932180548438192],
            [32.76910600655047, 2.9344066374447],
            [32.76801052723115, 2.935818688669201],
            [32.76808163517409, 2.937374614353744],
            [32.767664864492986, 2.937960987035447],
            [32.76818798312733, 2.941192594695241],
            [32.768640013581674, 2.942820417013314],
            [32.769651655830465, 2.94388582373998],
            [32.77265134975304, 2.944891801831663],
            [32.773079704209756, 2.945849372669076],
            [32.77448424620764, 2.946711395018518],
            [32.77457932838889, 2.947501335249575],
            [32.7753172252245, 2.94833928373239],
            [32.77485269740794, 2.949643753804096],
            [32.77499525645025, 2.951056072804698],
            [32.77349485612676, 2.953257975376725],
            [32.76500561769001, 2.959826927126418],
            [32.76414800057982, 2.9621486363635],
            [32.76175489405283, 2.96357236867504],
            [32.7607543756422, 2.966061603916069],
            [32.76113501608262, 2.967473973770111],
            [32.76046828827535, 2.967808951273384],
            [32.760479943017856, 2.968969895013335],
            [32.76002738076086, 2.969831531574891],
            [32.76081283261102, 2.971028560249245],
            [32.76057447093856, 2.972249295468372],
            [32.762490286385464, 2.976115543760755],
            [32.76182313726832, 2.978389412207312],
            [32.76237041429562, 2.979969378765756],
            [32.76242949739018, 2.982039945005714],
            [32.76466710015159, 2.98433837987536],
            [32.76428549222564, 2.987378302758057],
            [32.76504729682424, 2.98788114923397],
            [32.765142349361085, 2.988742895692341],
            [32.767559274717854, 2.987582473375537],
            [32.76815443194977, 2.98794165105247],
            [32.768606937612915, 2.987367255936199],
            [32.76970218786182, 2.987319619319181],
            [32.771654927660116, 2.985620496691761],
            [32.77265495648892, 2.985453143430473],
            [32.77439297198485, 2.985884372049753],
            [32.77677374733796, 2.986746596432844],
            [32.77755930608762, 2.987560615671651],
            [32.7777970829568, 2.98914051342823],
            [32.77726059020452, 2.992982300590587],
            [32.7739059737098, 2.996899340759678],
            [32.76567455714947, 2.998416835450643],
            [32.76107610456626, 2.998869064217854],
            [32.75828084654109, 2.999684255911273],
            [32.753231120783326, 3.002130550392669],
            [32.74727914781542, 3.007114681427224],
            [32.749532615723105, 3.009925212548778],
            [32.75151595124168, 3.011194704448715],
            [32.753228570466234, 3.013461232873766],
            [32.75524087755103, 3.018342485537385],
            [32.75449656494765, 3.018361914259267],
            [32.754282401194, 3.017763438058549],
            [32.75216331945624, 3.01766720850599],
            [32.75094936043579, 3.016087084682095],
            [32.7493866915917, 3.015897113746966],
            [32.74917250807515, 3.015442267209056],
            [32.748221797653756, 3.015176104277046],
            [32.74834857958478, 3.014720705738329],
            [32.747181368891724, 3.01364456140903],
            [32.745284420760754, 3.012910567997951],
            [32.7443118255824, 3.011687756476985],
            [32.743728085937754, 3.011736522346318],
            [32.74290144812848, 3.010415937240423],
            [32.740420805268585, 3.009583990793814],
            [32.73635865050328, 3.009684349405829],
            [32.73487735644752, 3.008998607984052],
            [32.723634336998884, 3.022533346457779],
            [32.72208604299601, 3.025022391196472],
            [32.71978772849443, 3.027403523585309],
            [32.70825007241239, 3.033157286424134],
            [32.69909310275021, 3.039845128397662],
            [32.695651898543595, 3.041890759465375],
            [32.69458005839098, 3.043183050082344],
            [32.69393717726127, 3.043134988914552],
            [32.69272221751759, 3.045312894946614],
            [32.69126938029341, 3.046676877828732],
            [32.68901893072511, 3.047837168876713],
            [32.6882807868528, 3.047860892118142],
            [32.68761390812858, 3.048483051565625],
            [32.68680440568333, 3.04826738779683],
            [32.68586229303752, 3.048603250082048],
            [32.68507703522351, 3.046903510090264],
            [32.68441047360457, 3.046400633505286],
            [32.68435118569413, 3.045598733461205],
            [32.68485148532365, 3.044641406832769],
            [32.684375437511875, 3.044090720136683],
            [32.684090246663686, 3.042247495384573],
            [32.684733303863176, 3.041649270108326],
            [32.685293655869415, 3.038884727844846],
            [32.68572231575334, 3.03864547685732],
            [32.68541299795324, 3.037879411896891],
            [32.686449295363296, 3.036024603633277],
            [32.686711803750576, 3.033966112018072],
            [32.68790274164523, 3.032506313625647],
            [32.68751092616273, 3.028831885997401],
            [32.68691617496929, 3.027060386709752],
            [32.68751166817113, 3.026246707332372],
            [32.687131090612816, 3.024906135341589],
            [32.68736934808068, 3.024355656576688],
            [32.687226739630994, 3.0234699471444],
            [32.68631023256406, 3.022835358805195],
            [32.686310865876344, 3.020633167849625],
            [32.685739565203406, 3.020130321207721],
            [32.685811184287765, 3.019460111928547],
            [32.68531141017272, 3.018646113774331],
            [32.685525979066526, 3.017664763991259],
            [32.68487202081103, 3.014828060141256],
            [32.683753399093376, 3.013271834709947],
            [32.68370613064144, 3.012074981335419],
            [32.683277737557184, 3.011428554824213],
            [32.68350458911587, 3.009142655181295],
            [32.6817440968732, 3.00418721128686],
            [32.68351858307139, 3.001901753084415],
            [32.684424200760446, 2.998933849907831],
            [32.685305313306884, 2.998407495893752],
            [32.68691622527497, 2.993793243567893],
            [32.68629423806044, 2.990278712228307],
            [32.68555673378859, 2.990134294738026],
            [32.68498440364634, 2.988675457591469],
            [32.683639317543886, 2.987490456610767],
            [32.68332895230817, 2.986342708927557],
            [32.6800422304826, 2.98205968387192],
            [32.67981536544916, 2.981163017953976],
            [32.6774106104679, 2.978745592979953],
            [32.6776005870825, 2.978435115956854],
            [32.67596779125576, 2.974955060575541],
            [32.67472372699519, 2.974075093872195],
            [32.67311558453313, 2.965115221365295],
            [32.67320352510788, 2.958288007211566],
            [32.67111670187195, 2.95184717979858],
            [32.67117753039308, 2.950389787575496],
            [32.672205327045624, 2.946989467730357],
            [32.671904696852664, 2.942313521037359],
            [32.67317269852058, 2.943649854358098],
            [32.67416604388365, 2.943481576086759],
            [32.67708456783384, 2.944143742244441],
            [32.681539050121394, 2.943174748574179],
            [32.68725615316836, 2.940041614172398],
            [32.68968522374776, 2.937544031113422],
            [32.69159843587694, 2.929748980989844],
            [32.693411134610656, 2.927077556131685],
            [32.69474083077568, 2.923677288212731],
            [32.69683280405314, 2.921672737480058],
            [32.694585756404805, 2.918580183778227],
            [32.69215241613287, 2.91701095953898],
            [32.69021797142363, 2.916696714298669],
            [32.686536543336956, 2.915189873642997],
            [32.685226056745975, 2.915189506707481],
            [32.68460215611992, 2.914687393508841],
            [32.682043503560784, 2.915000380604893],
            [32.68073314273393, 2.914560812364788],
            [32.67773771491059, 2.914685438612049],
            [32.67530417611097, 2.913931827890207],
            [32.67449328487031, 2.912676749416572],
            [32.67162319897857, 2.910981872926456],
            [32.666944650808, 2.905082730235672],
            [32.66563458552689, 2.903702013232102],
            [32.66469866586667, 2.903262540172126],
            [32.66419969933705, 2.90238400085134],
            [32.66226495638713, 2.903199069528128],
            [32.65758495923401, 2.90238200556087],
            [32.65546304151487, 2.903071520850482],
            [32.65409028550501, 2.902694646178916],
            [32.65259251365204, 2.903007894986624],
            [32.65034682874797, 2.900309289838688],
            [32.65047238627525, 2.897862389123121],
            [32.65009823885772, 2.896983884185717],
            [32.64828871207525, 2.896481384283719],
            [32.64654133703237, 2.896794546889698],
            [32.6451063259767, 2.895978450826588],
            [32.64398305637576, 2.896040838096794],
            [32.643795554619764, 2.896981908623402],
            [32.642110580149755, 2.897295084548444],
            [32.640924591074004, 2.898361320382248],
            [32.63961407124536, 2.898549128645301],
            [32.63905290267052, 2.897105882776728],
            [32.63924064786996, 2.895411909695662],
            [32.63649519064747, 2.894595381995201],
            [32.63362509397598, 2.893276871844429],
            [32.631628720309365, 2.891707672546461],
            [32.62788025634293, 2.890232447219659],
            [32.63527192867396, 2.878648990079941],
            [32.63544982474462, 2.877388503770502],
            [32.6345370160417, 2.87609097852832],
            [32.6345123492023, 2.875465895186125],
            [32.636696997176045, 2.872834298248669],
            [32.63858704085576, 2.872963301072272],
            [32.639571224301235, 2.872338778552971],
            [32.64285921185304, 2.866307871846312],
            [32.64569446197637, 2.863402359458682],
            [32.646981443249636, 2.860009855972676],
            [32.649520508044, 2.856264846361127],
            [32.65328568336967, 2.852052234047878],
            [32.65626596829223, 2.847622339808464],
            [32.65777807995212, 2.846031486538928],
            [32.65826108521574, 2.845019656105261],
            [32.657962113312784, 2.843334195696944],
            [32.65886363917573, 2.841136367093488],
            [32.66083494176109, 2.838509740084752],
            [32.66089133260471, 2.83546221442518],
            [32.66181095862231, 2.834591073486789],
            [32.66462483602842, 2.834615140412874],
            [32.669733536184566, 2.829515000910456],
            [32.67066775174072, 2.825615533165731],
            [32.67231920827083, 2.824243345349023],
            [32.67473238675454, 2.819706760237994],
            [32.677199581834586, 2.817545164499005],
            [32.676793626869504, 2.815919233066579],
            [32.677077350768826, 2.814793441409675],
            [32.67930000376731, 2.813588720032054],
            [32.679500947014915, 2.812194012726101],
            [32.68125719920942, 2.809898898046351],
            [32.68317231756364, 2.809342535809826],
            [32.68447835210408, 2.807432050373942],
            [32.68668876915007, 2.806430776387147],
            [32.68902804143871, 2.80305192614912],
            [32.69169518083978, 2.80129770933493],
            [32.69218500431644, 2.802359242834693],
            [32.69637507019508, 2.804205251952701],
            [32.700534618506865, 2.810847519340794],
            [32.70226093344623, 2.812893489440671],
            [32.702644494309645, 2.815810139691023],
            [32.703691973050034, 2.816839341777975],
            [32.70455084510667, 2.819445884982317],
            [32.70742833131972, 2.819306244913767],
            [32.70861681142375, 2.818710238643675],
            [32.70883039396738, 2.818280268750661],
            [32.70852049765225, 2.817586674813638],
            [32.70730664014145, 2.816652874962592],
            [32.70725855242596, 2.816150846840261],
            [32.70766266674306, 2.815984055283355],
            [32.711576379399254, 2.817483116602394],
            [32.71835399304644, 2.817229038259597],
            [32.72412567503512, 2.821503214116432],
            [32.730083933515054, 2.822287777227979],
            [32.731272892421146, 2.822145894436255],
            [32.73588430949052, 2.81997668307696],
            [32.73631310142679, 2.820646517019963],
            [32.737597416500265, 2.82071987608734],
            [32.73819662693076, 2.82144627703212],
            [32.74119425472822, 2.820900930179282],
            [32.743451323083534, 2.818824271886815],
            [32.74368793124453, 2.817701133453486],
            [32.74312646442902, 2.815298174371408],
            [32.74345814668643, 2.814127355426077],
            [32.74421832623267, 2.813339529860299],
            [32.74435933478283, 2.811786020861634],
            [32.74259877606484, 2.811138388372048],
            [32.74164654389736, 2.810252761284479],
            [32.741797995362674, 2.807348748185106],
            [32.741153156803975, 2.804814210102371],
            [32.74157939842315, 2.803117651704151],
            [32.74255313805513, 2.801899848168824],
            [32.746049862637925, 2.802645318226567],
            [32.75072482563218, 2.804336442730077],
            [32.75072458578203, 2.803773521713248],
            [32.751414785669326, 2.804080036776953],
            [32.75198594351012, 2.804941896195795],
            [32.751938095644825, 2.806090868530672],
            [32.749324730295, 2.80713129824731],
            [32.7489455415321, 2.808349866163321],
            [32.750653955742806, 2.809810437827773],
            [32.75066620157677, 2.809240831452546],
            [32.7518090140267, 2.809283932861758],
            [32.75566535038738, 2.810290110483245],
            [32.7599267847204, 2.809381385215666],
            [32.7630334230776, 2.809537614563384],
            [32.765961608408645, 2.809179156364081],
            [32.766366868976, 2.806354654722266],
            [32.763962925173416, 2.804175894272758],
            [32.763534685701075, 2.802859270657301],
            [32.763689709766275, 2.801435041160612],
            [32.76464206590125, 2.800788935425531],
            [32.766356017327396, 2.801100456086591],
            [32.76791454403967, 2.800790324356492],
            [32.769068806416236, 2.80240631478893],
            [32.768616193853575, 2.803938193042713],
            [32.769401644805406, 2.804632524548122],
            [32.76985362495411, 2.806332152891591],
            [32.77135305869035, 2.808031986025264],
            [32.77146004175248, 2.808762092388792],
            [32.77257861136787, 2.810342157285519],
            [32.77510172298111, 2.811994309177312],
            [32.7765297945512, 2.813454755153991],
            [32.777148412185085, 2.815250158152473],
            [32.78270637778114, 2.819236745632244],
            [32.78626469265647, 2.823031439804133],
            [32.78695504166407, 2.823199128472839],
            [32.787097757013285, 2.82386939302107],
            [32.787502474998234, 2.823797660820528],
            [32.78778804942704, 2.824348266738813],
            [32.789168783374954, 2.824492142893283],
            [32.78933532474041, 2.825018789024286],
            [32.79043034142733, 2.82540198058742],
            [32.79219168527292, 2.82722152373924],
            [32.7934648792032, 2.829675307213669],
            [32.79427425049441, 2.829914829929486],
            [32.795012103312565, 2.830752753053371],
            [32.7982608497578, 2.835456977378361],
            [32.79866529016335, 2.837012964221981],
            [32.798188982738445, 2.838066121943544],
            [32.79845062425146, 2.839382706589555],
            [32.79802179368765, 2.841177916937943],
            [32.798580548489326, 2.845211426237643],
            [32.79793733767791, 2.847700768174175],
            [32.79959115138733, 2.852045653964135],
            [32.79969765115585, 2.855672151868895],
            [32.80209135146924, 2.859157149463355],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 549,
        District: "PADER",
        County: "ARUU",
        Subcounty: "ATANGA",
        Population: 15465,
        Key: "PADERATANGA",
        Dist2: "Pader",
        "Sub Country": "Atanga",
        id2_original: "Pader Atanga",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.76791454403967, 2.800790324356492],
            [32.766356017327396, 2.801100456086591],
            [32.76464206590125, 2.800788935425531],
            [32.763689709766275, 2.801435041160612],
            [32.763534685701075, 2.802859270657301],
            [32.763962925173416, 2.804175894272758],
            [32.766366868976, 2.806354654722266],
            [32.765961608408645, 2.809179156364081],
            [32.7630334230776, 2.809537614563384],
            [32.7599267847204, 2.809381385215666],
            [32.75566535038738, 2.810290110483245],
            [32.7518090140267, 2.809283932861758],
            [32.75066620157677, 2.809240831452546],
            [32.750653955742806, 2.809810437827773],
            [32.7489455415321, 2.808349866163321],
            [32.749324730295, 2.80713129824731],
            [32.751938095644825, 2.806090868530672],
            [32.75198594351012, 2.804941896195795],
            [32.751414785669326, 2.804080036776953],
            [32.75072458578203, 2.803773521713248],
            [32.75072482563218, 2.804336442730077],
            [32.746049862637925, 2.802645318226567],
            [32.74255313805513, 2.801899848168824],
            [32.74157939842315, 2.803117651704151],
            [32.741153156803975, 2.804814210102371],
            [32.741797995362674, 2.807348748185106],
            [32.74164654389736, 2.810252761284479],
            [32.74259877606484, 2.811138388372048],
            [32.74435933478283, 2.811786020861634],
            [32.74421832623267, 2.813339529860299],
            [32.74345814668643, 2.814127355426077],
            [32.74312646442902, 2.815298174371408],
            [32.74368793124453, 2.817701133453486],
            [32.743451323083534, 2.818824271886815],
            [32.74119425472822, 2.820900930179282],
            [32.73819662693076, 2.82144627703212],
            [32.737597416500265, 2.82071987608734],
            [32.73631310142679, 2.820646517019963],
            [32.73588430949052, 2.81997668307696],
            [32.731272892421146, 2.822145894436255],
            [32.730083933515054, 2.822287777227979],
            [32.72412567503512, 2.821503214116432],
            [32.71835399304644, 2.817229038259597],
            [32.711576379399254, 2.817483116602394],
            [32.70766266674306, 2.815984055283355],
            [32.70725855242596, 2.816150846840261],
            [32.70730664014145, 2.816652874962592],
            [32.70852049765225, 2.817586674813638],
            [32.70883039396738, 2.818280268750661],
            [32.70861681142375, 2.818710238643675],
            [32.70742833131972, 2.819306244913767],
            [32.70455084510667, 2.819445884982317],
            [32.703691973050034, 2.816839341777975],
            [32.702644494309645, 2.815810139691023],
            [32.70226093344623, 2.812893489440671],
            [32.700534618506865, 2.810847519340794],
            [32.69637507019508, 2.804205251952701],
            [32.69218500431644, 2.802359242834693],
            [32.69169518083978, 2.80129770933493],
            [32.69275695536961, 2.800212379100608],
            [32.692360842346794, 2.797059794350732],
            [32.690854722449856, 2.795972571489476],
            [32.688927280108246, 2.796894473345998],
            [32.687881501878664, 2.795466662867887],
            [32.68790451941119, 2.794725712162871],
            [32.688637440478445, 2.793715837962214],
            [32.688710519325156, 2.792181390088825],
            [32.68733041599457, 2.789915834687601],
            [32.687244100472206, 2.788498136724388],
            [32.68808039876404, 2.786733687418209],
            [32.68846460371947, 2.78440043711676],
            [32.69177104805711, 2.785217511986566],
            [32.69374625561898, 2.786298878555621],
            [32.70150197381214, 2.785096901288269],
            [32.70452979308799, 2.785270177212703],
            [32.70623635676921, 2.783050495062934],
            [32.70385978373502, 2.781325326689542],
            [32.70059477239324, 2.780529761772027],
            [32.70004097539364, 2.779491747234857],
            [32.700704731573914, 2.77746087810815],
            [32.70062882393241, 2.776036651048618],
            [32.696708885951296, 2.776881946066677],
            [32.695690748883, 2.776400030071402],
            [32.69465010452526, 2.775241888308488],
            [32.69456116951548, 2.774131333525046],
            [32.69400205448941, 2.773202761541156],
            [32.69389323257589, 2.772545098804168],
            [32.69431358663668, 2.771799433815955],
            [32.696120128317425, 2.771013021764729],
            [32.6973456621303, 2.769623186323344],
            [32.698054855996, 2.767728929856248],
            [32.698839705974905, 2.767801668629754],
            [32.70026762123813, 2.768807463614389],
            [32.70338168147619, 2.768936059853106],
            [32.70641675554626, 2.767438395536061],
            [32.70735644633405, 2.766100068094484],
            [32.70767125463714, 2.764861249033044],
            [32.70897911185929, 2.764767346180502],
            [32.71019284719926, 2.765629435353342],
            [32.71173891697349, 2.765918291326948],
            [32.71629084131656, 2.769001179863304],
            [32.718027845309486, 2.768801786608748],
            [32.719742263859565, 2.76689677596864],
            [32.72090765815913, 2.7670178012679],
            [32.72171580504662, 2.766636401321552],
            [32.723116346846496, 2.764247923853893],
            [32.72361125119441, 2.761463994973983],
            [32.72303572215143, 2.760276478941983],
            [32.722788417750365, 2.757781677761379],
            [32.722836843232365, 2.756166209457086],
            [32.72367295467464, 2.754230033150527],
            [32.72538676865854, 2.752490626077584],
            [32.72869477516643, 2.75481348506715],
            [32.73016890785273, 2.754552451862458],
            [32.73703376408369, 2.747318685836362],
            [32.73709208540688, 2.744468652089133],
            [32.73876159448096, 2.742411200203826],
            [32.74054418348297, 2.742171981811704],
            [32.74125742695394, 2.741655306100087],
            [32.74311185602589, 2.739847751398601],
            [32.74540850954251, 2.73610545983857],
            [32.74706321707564, 2.734785273675526],
            [32.749031740273516, 2.734066434744579],
            [32.750734870593696, 2.732491209416577],
            [32.76226498621723, 2.72021336750313],
            [32.76711555457819, 2.714032683353184],
            [32.7676586777956, 2.712063214386371],
            [32.769027707593665, 2.710165081093106],
            [32.77337047988409, 2.705989452848248],
            [32.77435030200886, 2.703130179389432],
            [32.77340668288836, 2.701635023443701],
            [32.773926169634, 2.699807918094586],
            [32.77538962763976, 2.697577586836684],
            [32.77841021996915, 2.696984889895384],
            [32.77883505213161, 2.69655783087749],
            [32.779531532141085, 2.694600241001352],
            [32.77953190673854, 2.692488282308662],
            [32.780641350368946, 2.690471446286322],
            [32.78217537912515, 2.68933268461064],
            [32.784936040333776, 2.690662048883522],
            [32.78536085183503, 2.690377369825368],
            [32.78693090752566, 2.685572342188752],
            [32.79167503091535, 2.679308461450211],
            [32.792607527994356, 2.676923762774712],
            [32.79468433411655, 2.675334212632575],
            [32.79671377836201, 2.67478876761411],
            [32.797280196691396, 2.674266803866765],
            [32.796525442071115, 2.672154707749413],
            [32.79770563162341, 2.670066677350032],
            [32.79725794182854, 2.666127342935244],
            [32.79791897341855, 2.664134220697234],
            [32.79978312495681, 2.664181988131006],
            [32.80174150976838, 2.665202698925325],
            [32.805127172937624, 2.668347456108354],
            [32.80786423989535, 2.669581850719182],
            [32.809327353846385, 2.668941372957959],
            [32.811781896155644, 2.665975506225426],
            [32.81378774525187, 2.665240184555314],
            [32.81558094335741, 2.666426957617642],
            [32.81679581416787, 2.668906913274208],
            [32.82264702850024, 2.674887727682287],
            [32.82392117284809, 2.675576089574943],
            [32.82635183883543, 2.674484857625229],
            [32.82952684078237, 2.665883184880777],
            [32.829385357023426, 2.665147536522447],
            [32.82886633201184, 2.664364374247949],
            [32.82443049605461, 2.661587339421676],
            [32.822188899383434, 2.660827661140838],
            [32.821528441816874, 2.659095278156648],
            [32.821988800552205, 2.657541032711948],
            [32.824726128021354, 2.65682952436268],
            [32.825127340780064, 2.656378707471152],
            [32.824773776460674, 2.65364963338886],
            [32.825400587628245, 2.651313978321569],
            [32.82742864936651, 2.648552015746283],
            [32.82863112432436, 2.647787205547679],
            [32.831771870814556, 2.648824059858323],
            [32.83447088693347, 2.650206331111227],
            [32.83513327857284, 2.651292201342368],
            [32.8354522739235, 2.651267564496544],
            [32.836041354052526, 2.650058479389052],
            [32.83589433577312, 2.648454462412031],
            [32.83694971429816, 2.646702553546072],
            [32.837906722808, 2.646505266000726],
            [32.83935438483779, 2.647221084011014],
            [32.841182470814026, 2.647258331489942],
            [32.84324361121601, 2.647850842460572],
            [32.844666751933495, 2.648443269693708],
            [32.84586899422769, 2.649479842583036],
            [32.8492553005907, 2.649258169853605],
            [32.850702908721594, 2.650516869563139],
            [32.85094800775866, 2.652836526339342],
            [32.8521994283231, 2.6531574716235],
            [32.85275181317108, 2.650825580026993],
            [32.853537203037476, 2.649419088058247],
            [32.85780685246374, 2.64944426784069],
            [32.85977011872056, 2.647643082052307],
            [32.860408457069894, 2.644558546823412],
            [32.859034541334985, 2.642584237052963],
            [32.85855634654968, 2.639980771326513],
            [32.85661816125562, 2.637167383413609],
            [32.854569881135255, 2.631651868409626],
            [32.850791284979245, 2.629578563700868],
            [32.85125769925792, 2.627974620802511],
            [32.85074276427582, 2.624939302581807],
            [32.85111092532029, 2.624149687035885],
            [32.85320905654902, 2.622854401626198],
            [32.85492691654494, 2.620954479516314],
            [32.856669155919356, 2.620337763389625],
            [32.8580309264316, 2.620967177380526],
            [32.86080340138456, 2.62360791485342],
            [32.86367423197965, 2.624323870766037],
            [32.86546555709783, 2.623682457886763],
            [32.867317927231134, 2.625940595135898],
            [32.86979620842009, 2.626261661331962],
            [32.87330523004083, 2.625126880385044],
            [32.87563630610081, 2.625225826475886],
            [32.87580810800058, 2.624880370319878],
            [32.874311501262525, 2.622906063458116],
            [32.8723730788132, 2.622313618686769],
            [32.87222604436411, 2.620413488461952],
            [32.872986805120355, 2.619475844203929],
            [32.8742137519832, 2.618859040303429],
            [32.87551415678172, 2.619796894111981],
            [32.876912788763335, 2.620019126664987],
            [32.8801627236797, 2.619005142255602],
            [32.88003093723425, 2.619957887914229],
            [32.880690559367615, 2.620408121256357],
            [32.88183298644028, 2.622505055594081],
            [32.88327009236721, 2.622623652596557],
            [32.88567300759879, 2.624163917581205],
            [32.88781690709293, 2.624235188758671],
            [32.8889005933292, 2.62468545645629],
            [32.891656867166, 2.626770675616327],
            [32.89299971556509, 2.627173576462112],
            [32.89328237136757, 2.62781330946598],
            [32.8926932651874, 2.629234836185644],
            [32.89258673128291, 2.635312065998008],
            [32.895388879386324, 2.652489687856436],
            [32.8980388412025, 2.658946242998443],
            [32.89959357253274, 2.661742131633228],
            [32.90759148550965, 2.671705648074358],
            [32.9125859262499, 2.676515685252592],
            [32.91679120330123, 2.680176543137957],
            [32.921149708685526, 2.682996292816666],
            [32.92789974764678, 2.683695656800961],
            [32.932305736180346, 2.680663205111177],
            [32.933566323153926, 2.678708609270111],
            [32.93820791014216, 2.675249684459229],
            [32.93858491330396, 2.674467833351395],
            [32.94016346346393, 2.674349449495036],
            [32.94294342228151, 2.677690289433153],
            [32.94289626252573, 2.678732770877216],
            [32.94631220251334, 2.685959284606818],
            [32.94631215580093, 2.687025466397688],
            [32.949104009211204, 2.689003950118467],
            [32.950399851466436, 2.688909230161392],
            [32.95435800916963, 2.689667557619047],
            [32.95534753399781, 2.690070378705805],
            [32.956240008435934, 2.691055587715713],
            [32.95671461535, 2.693107974714096],
            [32.956488044964004, 2.697813220309289],
            [32.9567897513387, 2.702480538779678],
            [32.957468891168226, 2.704605516299427],
            [32.95818578090091, 2.706351037877205],
            [32.96233646733243, 2.708817637589848],
            [32.96275151145158, 2.709918073017137],
            [32.96414763623523, 2.711435938623596],
            [32.96588324155128, 2.717697011255531],
            [32.96727936094504, 2.719935838814058],
            [32.96875088043218, 2.725020587260392],
            [32.96893953113344, 2.725931285765978],
            [32.968269540645075, 2.729104926033552],
            [32.96709143787917, 2.730431700105638],
            [32.965182859260246, 2.734009285272386],
            [32.96230835994551, 2.733724885604697],
            [32.96207272376164, 2.734530436386764],
            [32.96100067519991, 2.734471166634694],
            [32.96043517764372, 2.735039780706719],
            [32.95772558386233, 2.735655706898098],
            [32.95687738289298, 2.735276581424571],
            [32.95520450423825, 2.735466067906504],
            [32.95237705957645, 2.736911225268619],
            [32.95141104994745, 2.736626873845504],
            [32.9511989819634, 2.736982261968292],
            [32.949502546787016, 2.737076955727247],
            [32.948960606650814, 2.73750340550947],
            [32.947912143356845, 2.736970274166608],
            [32.94659266373154, 2.737704698181286],
            [32.94569734343058, 2.737254487325508],
            [32.94466062740562, 2.737349213365414],
            [32.94456632765697, 2.738462776987393],
            [32.94197446168682, 2.740381779645969],
            [32.94138534203193, 2.742040261918485],
            [32.940466414903604, 2.742395604467544],
            [32.93888767250418, 2.744741131469675],
            [32.93818081246162, 2.744788472210791],
            [32.93787447886488, 2.745380786735383],
            [32.93622512618917, 2.746020407561861],
            [32.9342577483433, 2.745510903711087],
            [32.933032501092995, 2.746221618942458],
            [32.93269951538011, 2.747708361331129],
            [32.93181865975184, 2.749168484015892],
            [32.93103310369711, 2.749168438254534],
            [32.930437913227536, 2.750317396660721],
            [32.93060450939025, 2.750987650674267],
            [32.92991415858597, 2.751155173741196],
            [32.92885477537141, 2.752172440170605],
            [32.928735683917544, 2.753321426189445],
            [32.92740256157803, 2.754135213337648],
            [32.927473936320645, 2.754733653419351],
            [32.92547418409025, 2.757007568834384],
            [32.925140914509704, 2.756935740134375],
            [32.92452191599015, 2.758108624056403],
            [32.923712574343355, 2.757677699745694],
            [32.923200713396156, 2.758551380567658],
            [32.92281982771567, 2.758527417061876],
            [32.92222465970395, 2.759269438489419],
            [32.92229603624319, 2.759796062715094],
            [32.92112954330402, 2.760561984006839],
            [32.921129491201754, 2.761351912220489],
            [32.920010650295175, 2.761375776072094],
            [32.91984391040203, 2.762907752509994],
            [32.91843936301426, 2.763553960656076],
            [32.918296487764934, 2.764200254588232],
            [32.917260918888566, 2.764930273286685],
            [32.913713880565034, 2.765959318043171],
            [32.91033353632057, 2.766054821528629],
            [32.90904797438545, 2.767107960540741],
            [32.90151340794049, 2.769896051150718],
            [32.899632791181425, 2.769967699613342],
            [32.89908534706747, 2.769081978702519],
            [32.89832357031665, 2.769249476787238],
            [32.89771656340781, 2.76890232891391],
            [32.89547880433954, 2.769668130374342],
            [32.89457413527142, 2.770505855230145],
            [32.893264875779096, 2.770146672702135],
            [32.89000336966355, 2.772228916477614],
            [32.88758693388863, 2.774395008449324],
            [32.885468242918, 2.774562366706433],
            [32.88165923878961, 2.776141854009937],
            [32.880802163363576, 2.776955633579018],
            [32.87774307552933, 2.77790083960332],
            [32.877028853793014, 2.778475261520364],
            [32.87605284411828, 2.778451219458757],
            [32.87590994551276, 2.779073578056911],
            [32.87362457214116, 2.779552074406445],
            [32.873029502045824, 2.779001452804387],
            [32.872291436326925, 2.779887055921237],
            [32.87007767485311, 2.778594196815875],
            [32.86957770490533, 2.779144698375217],
            [32.86835190788607, 2.777528799791881],
            [32.865662065362855, 2.776044378261143],
            [32.86002033725645, 2.774918677552917],
            [32.859496580818224, 2.775277670207176],
            [32.85462844500356, 2.774858176075842],
            [32.85431891609938, 2.775408693732575],
            [32.85153365183175, 2.77574347094979],
            [32.84903382005909, 2.777897500002819],
            [32.848022052046154, 2.778196586225991],
            [32.84776023087009, 2.777909305248361],
            [32.84759353589269, 2.778411961673704],
            [32.84692694462938, 2.778675184321313],
            [32.84685545939403, 2.779249669566954],
            [32.844903305297265, 2.780111155997305],
            [32.84373694710542, 2.779345014062044],
            [32.84161812587905, 2.780397964481419],
            [32.84140398997321, 2.779584070641367],
            [32.84016603964645, 2.780110520738618],
            [32.83971377742679, 2.779799272665084],
            [32.83767834680824, 2.780337579928541],
            [32.83608346707305, 2.779714994990591],
            [32.835702490662726, 2.780385182147009],
            [32.8336553936236, 2.779211973935823],
            [32.832179465205044, 2.779211763977281],
            [32.83179848340487, 2.779905880397466],
            [32.83077484864703, 2.779905733247111],
            [32.829775196212346, 2.778684792171594],
            [32.82925149097809, 2.778612908258064],
            [32.82721580433974, 2.78089861088749],
            [32.82607308351794, 2.781305374383797],
            [32.82557299858577, 2.782502165789053],
            [32.82300173817164, 2.784368877975612],
            [32.82176383096404, 2.784536252763438],
            [32.821620586507144, 2.787265069210624],
            [32.82049628204699, 2.787930218488896],
            [32.818718163061796, 2.786508837600546],
            [32.817480658299466, 2.784043106262268],
            [32.81482658848746, 2.782522677962378],
            [32.81458861129396, 2.782043901976547],
            [32.81506492770204, 2.780679558034852],
            [32.81461272387282, 2.780033176199388],
            [32.81154200465229, 2.779003393575289],
            [32.810994395248336, 2.779553859950714],
            [32.80923297235104, 2.778500342607667],
            [32.80231769997138, 2.777481865019663],
            [32.79893778063004, 2.774967886088639],
            [32.7961170526716, 2.773830382658146],
            [32.79359399585561, 2.772130409449845],
            [32.79059472054794, 2.771148454921773],
            [32.78928562095574, 2.770142858426238],
            [32.78750025076958, 2.77007073083435],
            [32.78645271363868, 2.770668964589575],
            [32.78504821475996, 2.770692647006109],
            [32.78492903077962, 2.7715304267674],
            [32.78896319853229, 2.776067247651526],
            [32.79058120449614, 2.780304410998045],
            [32.79035456404154, 2.78309305100566],
            [32.78787884844103, 2.782853236956325],
            [32.78680725622342, 2.784815891108196],
            [32.78697372841864, 2.785749467808451],
            [32.78787814506017, 2.786778933192132],
            [32.78744948337962, 2.787688463770759],
            [32.78822252500411, 2.79121932992351],
            [32.78727001166394, 2.792846890998683],
            [32.785543832370166, 2.794390522223955],
            [32.78511513924862, 2.795443674520503],
            [32.78780422539038, 2.800686402169713],
            [32.78754195326001, 2.802960386980007],
            [32.78506593941883, 2.804132848304025],
            [32.78418513140127, 2.804132685006419],
            [32.7796625056112, 2.801618436456506],
            [32.77817491706024, 2.800193900387943],
            [32.77836551890229, 2.799332198079935],
            [32.77648504677195, 2.798422222513332],
            [32.77574726851395, 2.797368850374286],
            [32.7711527406702, 2.797607327259785],
            [32.770605136656165, 2.797990211098851],
            [32.76936675693473, 2.800479427196471],
            [32.76791454403967, 2.800790324356492],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 550,
        District: "PADER",
        County: "ARUU",
        Subcounty: "AWERE",
        Population: 19553,
        Key: "PADERAWERE",
        Dist2: "Pader",
        "Sub Country": "Awere S/C",
        id2_original: "Pader Awere S/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.813872325229156, 3.165415615786432],
            [32.813516862769525, 3.165399312919365],
            [32.81223067560699, 3.166859229342107],
            [32.81127807962182, 3.167074493954698],
            [32.811373187854215, 3.167912307691838],
            [32.809433059504165, 3.169096129452433],
            [32.808884469139954, 3.168977044314442],
            [32.80883671110617, 3.169671209623795],
            [32.80816982699207, 3.170197699515665],
            [32.806788809176545, 3.16923995939607],
            [32.805526463301646, 3.170412631565946],
            [32.804883500425255, 3.170388580109546],
            [32.8042403524959, 3.171345938863317],
            [32.80216868024554, 3.17072317559728],
            [32.80028732237634, 3.17105793960147],
            [32.797918164934785, 3.169537476606458],
            [32.7955368182532, 3.16941731877759],
            [32.79353622160642, 3.170661648195101],
            [32.79294052269039, 3.172456797917409],
            [32.79213063666451, 3.173533799072213],
            [32.789546630953126, 3.174598466224384],
            [32.7877363064667, 3.176943919057977],
            [32.785473750303275, 3.17809242806061],
            [32.78590166638214, 3.178620065323483],
            [32.785711714022064, 3.178906334086949],
            [32.78247287599441, 3.179647702760322],
            [32.78166161554617, 3.187211614076718],
            [32.781947189076654, 3.18812127578932],
            [32.7824472506526, 3.188288943342912],
            [32.78213752861065, 3.188935173891893],
            [32.782780199534585, 3.190419409374416],
            [32.782399080292144, 3.19085019510873],
            [32.782803774022575, 3.191568383202861],
            [32.78254167796204, 3.192190692589872],
            [32.78379055719251, 3.193497094588604],
            [32.783362872879, 3.194069917053008],
            [32.783862822165545, 3.19481207216307],
            [32.78369593045709, 3.195745576205646],
            [32.78226667670409, 3.197612361998386],
            [32.782504626049814, 3.198545956772048],
            [32.78001567826513, 3.20020903835707],
            [32.78061088849768, 3.200855466795506],
            [32.779801083320166, 3.201429775820189],
            [32.78070555565726, 3.203680053595136],
            [32.78025268617643, 3.20549916225003],
            [32.7808119161869, 3.207426212358685],
            [32.78050208365214, 3.208551170373635],
            [32.77952561044672, 3.208910024637081],
            [32.779715882607064, 3.210059037825943],
            [32.77907286762837, 3.210178587287452],
            [32.77835853629759, 3.209699688873857],
            [32.777667818980696, 3.210130402822643],
            [32.777267926745424, 3.209870198780788],
            [32.776834708809794, 3.208263142966893],
            [32.77504877627825, 3.207544634714793],
            [32.7731671632875, 3.208788938625657],
            [32.77176600614165, 3.208598544108903],
            [32.771410305628486, 3.207716604250294],
            [32.770505743459886, 3.207069430329688],
            [32.77076762302645, 3.206352045962701],
            [32.77038152711734, 3.205772264066847],
            [32.77010755622703, 3.206238961871612],
            [32.7687982599038, 3.20609507162618],
            [32.767702569480385, 3.205017633697635],
            [32.76736915706774, 3.205065434525842],
            [32.766606460442055, 3.20784194621596],
            [32.765056068873, 3.209864954571707],
            [32.761327942764616, 3.203535043644307],
            [32.75680042115622, 3.202581432539445],
            [32.75406278646324, 3.204485601673845],
            [32.753430667150646, 3.203744840192539],
            [32.7524436486221, 3.203924969567673],
            [32.75123006330082, 3.199643922026058],
            [32.751657691918766, 3.197411713643472],
            [32.75131635097544, 3.196037899782784],
            [32.75157339041925, 3.192775351551393],
            [32.748754624381405, 3.19268880495795],
            [32.74696062138538, 3.193632801309418],
            [32.746191966234406, 3.193203320864326],
            [32.7442104794487, 3.189945569344151],
            [32.74331083106468, 3.189411969751887],
            [32.74309588847172, 3.18847975062882],
            [32.74228541404934, 3.187509504607642],
            [32.74352600901625, 3.183264260416544],
            [32.74305488756549, 3.180893417271681],
            [32.740570930820574, 3.182410090160982],
            [32.73884075761704, 3.182342371947436],
            [32.73786622656928, 3.180417959276904],
            [32.73503631423538, 3.179124111190033],
            [32.73456480650904, 3.178348115126832],
            [32.73271200338777, 3.177864458879876],
            [32.732077996714736, 3.176925035891448],
            [32.729675693235855, 3.175847896556513],
            [32.728947871006156, 3.175846613041578],
            [32.72726278424674, 3.177084536883685],
            [32.72331957091659, 3.181155654827915],
            [32.721697829757765, 3.181685714030008],
            [32.71959743657115, 3.183645934219298],
            [32.717753228530505, 3.184593716731891],
            [32.71736730958951, 3.184507401754328],
            [32.715395579406106, 3.181535513126928],
            [32.71380891476415, 3.181402927026636],
            [32.712436498317494, 3.182049102700289],
            [32.711617278795806, 3.183006376195433],
            [32.70772439447777, 3.184205870619229],
            [32.706581566756505, 3.183859107283009],
            [32.70548933754187, 3.182779899695072],
            [32.703988426975265, 3.182865675762728],
            [32.70205775069867, 3.18622722501763],
            [32.69948448344816, 3.187304071871588],
            [32.697696604267406, 3.18723634501065],
            [32.69674330939297, 3.186377705077586],
            [32.690436863010596, 3.185275493940124],
            [32.68649256271896, 3.182343229412505],
            [32.68593548327531, 3.181049942529769],
            [32.6852934133243, 3.177213499026859],
            [32.6840077229301, 3.174669975400622],
            [32.68396508978505, 3.173850988472065],
            [32.68641001383256, 3.171696541716442],
            [32.6864105339571, 3.169972385331542],
            [32.685553092018424, 3.169325565272735],
            [32.681693347449546, 3.170574392955882],
            [32.6793349392487, 3.170271933004621],
            [32.67719237015949, 3.172122664017205],
            [32.67432676596271, 3.173169073656834],
            [32.67342962747162, 3.174041015404121],
            [32.672308204806924, 3.174161428322785],
            [32.6713071986111, 3.173436489403266],
            [32.67142791871054, 3.171624978518099],
            [32.66910545569749, 3.170376277675031],
            [32.66842520734691, 3.168524252838323],
            [32.66602242416768, 3.168000139889513],
            [32.66345851017591, 3.170374447019647],
            [32.6620967702064, 3.170575284514497],
            [32.66009461049104, 3.169648723312264],
            [32.655310521054346, 3.163762886218602],
            [32.65175493885416, 3.161595180413429],
            [32.63995281695584, 3.159613796151546],
            [32.638693822695274, 3.158709184290896],
            [32.6379218581508, 3.156902832039637],
            [32.63766837154391, 3.156530619290306],
            [32.63976406205002, 3.156124428044695],
            [32.64105029143338, 3.155191345633883],
            [32.6428006398999, 3.154916680484245],
            [32.64251588922619, 3.151948435545503],
            [32.641706667953635, 3.150751314771122],
            [32.641350034090884, 3.14909956018539],
            [32.64160067932653, 3.147340301395537],
            [32.64057727184246, 3.145736182625374],
            [32.6409587090885, 3.144467677107154],
            [32.6441502014091, 3.142769266835129],
            [32.64404348065502, 3.141488613695627],
            [32.64471030098876, 3.141297353758612],
            [32.64223475606813, 3.138424093029384],
            [32.64273553360137, 3.136317841478777],
            [32.64265270983048, 3.134797832695064],
            [32.643081532309445, 3.134223496571171],
            [32.64265307544479, 3.133720673021624],
            [32.64382059156507, 3.131662516705322],
            [32.64459537771782, 3.129041711247893],
            [32.64516702334381, 3.128611043375037],
            [32.64657291371294, 3.125763054281089],
            [32.646144995837446, 3.12365647588499],
            [32.64657365122975, 3.123560876583288],
            [32.647205397741516, 3.121394819342384],
            [32.64820563497948, 3.121036099813736],
            [32.64787320891701, 3.118187520587892],
            [32.64727802832888, 3.117804334682486],
            [32.647802127025194, 3.117134275451998],
            [32.64707619215589, 3.116116725759033],
            [32.647552725057935, 3.115231223356567],
            [32.64733892961356, 3.113699199359568],
            [32.64817258506187, 3.113005314366814],
            [32.64783974397771, 3.111401445326312],
            [32.64836368097728, 3.111210123393089],
            [32.64866183541335, 3.109666311552592],
            [32.64951909409573, 3.109594782673716],
            [32.648971615845824, 3.10899617897393],
            [32.64909132354396, 3.107033413592955],
            [32.64821046881403, 3.106482574335275],
            [32.64835356235395, 3.10581238591512],
            [32.64733012253052, 3.104375844338576],
            [32.64758114146532, 3.101371870536175],
            [32.648629744896475, 3.098715241456531],
            [32.65166641796774, 3.096669659072007],
            [32.65385782756065, 3.094420323343456],
            [32.653810489040104, 3.093534643982264],
            [32.65495396354842, 3.091955197826224],
            [32.65485900443634, 3.091045565386869],
            [32.65565716834609, 3.089597655705687],
            [32.65646775415954, 3.086510074351948],
            [32.65611143111389, 3.083852975680065],
            [32.657124154035984, 3.081567346426938],
            [32.65760122682548, 3.078910517074114],
            [32.6571490634205, 3.078144398351728],
            [32.65694726407843, 3.076265291234825],
            [32.65513848110103, 3.073535915378166],
            [32.654865955600016, 3.069478542139191],
            [32.655366126770446, 3.0690717800114],
            [32.65989052134331, 3.068187581181185],
            [32.66417654166734, 3.068141065814627],
            [32.66673584550504, 3.069398553385807],
            [32.66990270242731, 3.069495285138734],
            [32.670950508154476, 3.069112623436968],
            [32.674022008011015, 3.069592310210559],
            [32.675915237116705, 3.068790998013549],
            [32.677248496898436, 3.069365889059765],
            [32.6786296162236, 3.069103001927318],
            [32.68129681401515, 3.067954833892863],
            [32.681987515162355, 3.067356626528791],
            [32.68294054683045, 3.065370150165177],
            [32.68367875088991, 3.06517887106952],
            [32.68426234680412, 3.064425038991681],
            [32.68673882687096, 3.063994905487742],
            [32.68623914348575, 3.06277398087339],
            [32.68666841961395, 3.060452234955596],
            [32.6855258020984, 3.059374733234875],
            [32.683644967947025, 3.058584263931632],
            [32.6833477693184, 3.057088124065405],
            [32.68391958382768, 3.055891455561433],
            [32.68294352474563, 3.055244864179505],
            [32.682705777520844, 3.054024016613621],
            [32.68586229303752, 3.048603250082048],
            [32.68680440568333, 3.04826738779683],
            [32.68761390812858, 3.048483051565625],
            [32.6882807868528, 3.047860892118142],
            [32.68901893072511, 3.047837168876713],
            [32.69126938029341, 3.046676877828732],
            [32.69272221751759, 3.045312894946614],
            [32.69393717726127, 3.043134988914552],
            [32.69458005839098, 3.043183050082344],
            [32.695651898543595, 3.041890759465375],
            [32.69909310275021, 3.039845128397662],
            [32.70825007241239, 3.033157286424134],
            [32.71978772849443, 3.027403523585309],
            [32.72208604299601, 3.025022391196472],
            [32.723634336998884, 3.022533346457779],
            [32.73487735644752, 3.008998607984052],
            [32.73635865050328, 3.009684349405829],
            [32.740420805268585, 3.009583990793814],
            [32.74290144812848, 3.010415937240423],
            [32.743728085937754, 3.011736522346318],
            [32.7443118255824, 3.011687756476985],
            [32.745284420760754, 3.012910567997951],
            [32.747181368891724, 3.01364456140903],
            [32.74834857958478, 3.014720705738329],
            [32.748221797653756, 3.015176104277046],
            [32.74917250807515, 3.015442267209056],
            [32.7493866915917, 3.015897113746966],
            [32.75094936043579, 3.016087084682095],
            [32.75216331945624, 3.01766720850599],
            [32.754282401194, 3.017763438058549],
            [32.75449656494765, 3.018361914259267],
            [32.75524087755103, 3.018342485537385],
            [32.753228570466234, 3.013461232873766],
            [32.75151595124168, 3.011194704448715],
            [32.749532615723105, 3.009925212548778],
            [32.74727914781542, 3.007114681427224],
            [32.753231120783326, 3.002130550392669],
            [32.75828084654109, 2.999684255911273],
            [32.76107610456626, 2.998869064217854],
            [32.76567455714947, 2.998416835450643],
            [32.7739059737098, 2.996899340759678],
            [32.77726059020452, 2.992982300590587],
            [32.7777970829568, 2.98914051342823],
            [32.77755930608762, 2.987560615671651],
            [32.77677374733796, 2.986746596432844],
            [32.77439297198485, 2.985884372049753],
            [32.77265495648892, 2.985453143430473],
            [32.771654927660116, 2.985620496691761],
            [32.76970218786182, 2.987319619319181],
            [32.768606937612915, 2.987367255936199],
            [32.76815443194977, 2.98794165105247],
            [32.767559274717854, 2.987582473375537],
            [32.765142349361085, 2.988742895692341],
            [32.76504729682424, 2.98788114923397],
            [32.76428549222564, 2.987378302758057],
            [32.76466710015159, 2.98433837987536],
            [32.76242949739018, 2.982039945005714],
            [32.76237041429562, 2.979969378765756],
            [32.76182313726832, 2.978389412207312],
            [32.762490286385464, 2.976115543760755],
            [32.76057447093856, 2.972249295468372],
            [32.76081283261102, 2.971028560249245],
            [32.76002738076086, 2.969831531574891],
            [32.760479943017856, 2.968969895013335],
            [32.76046828827535, 2.967808951273384],
            [32.76113501608262, 2.967473973770111],
            [32.7607543756422, 2.966061603916069],
            [32.76175489405283, 2.96357236867504],
            [32.76414800057982, 2.9621486363635],
            [32.76500561769001, 2.959826927126418],
            [32.77349485612676, 2.953257975376725],
            [32.77499525645025, 2.951056072804698],
            [32.77485269740794, 2.949643753804096],
            [32.7753172252245, 2.94833928373239],
            [32.77457932838889, 2.947501335249575],
            [32.77448424620764, 2.946711395018518],
            [32.773079704209756, 2.945849372669076],
            [32.77265134975304, 2.944891801831663],
            [32.769651655830465, 2.94388582373998],
            [32.768640013581674, 2.942820417013314],
            [32.76818798312733, 2.941192594695241],
            [32.767664864492986, 2.937960987035447],
            [32.76808163517409, 2.937374614353744],
            [32.76801052723115, 2.935818688669201],
            [32.76910600655047, 2.9344066374447],
            [32.76939216578253, 2.932180548438192],
            [32.76901134657739, 2.931629916561661],
            [32.76932105783958, 2.930648560202574],
            [32.768023762110246, 2.929367655567102],
            [32.76897622244979, 2.928745484210026],
            [32.76892869079147, 2.928362483480995],
            [32.76747657581279, 2.927404700279721],
            [32.767632270021195, 2.922844721159615],
            [32.7694190290028, 2.917243821422632],
            [32.76916952732253, 2.91488596758259],
            [32.76978865789442, 2.914263726295626],
            [32.770408210674525, 2.911606836202929],
            [32.770468396001924, 2.908291563126264],
            [32.771349533701176, 2.907094893307145],
            [32.771659317726936, 2.905706604937047],
            [32.77319553567746, 2.902654936858889],
            [32.77691049517872, 2.897844326468648],
            [32.777422716350344, 2.896013237620089],
            [32.77813712942784, 2.895079834390042],
            [32.77904230334913, 2.892566615177904],
            [32.77901867945379, 2.891609127232181],
            [32.77954255536794, 2.891034737251534],
            [32.77885235368401, 2.889957435075545],
            [32.77915024401536, 2.888389619115056],
            [32.780055090949915, 2.887575925917804],
            [32.78172232459138, 2.883866000211649],
            [32.782555748274305, 2.883004422268132],
            [32.78397237081612, 2.882537925341032],
            [32.78666343145486, 2.87813400764654],
            [32.78679506698334, 2.874387873081898],
            [32.78622449484411, 2.870079082418707],
            [32.78983193139579, 2.86650115557488],
            [32.79321301764866, 2.863796874306204],
            [32.799581913112945, 2.860841781001022],
            [32.80209135146924, 2.859157149463355],
            [32.813289090437685, 2.869749503773731],
            [32.81397916456081, 2.87180821182247],
            [32.8190135210424, 2.877302610184322],
            [32.82084653876954, 2.878260387407663],
            [32.8214653908637, 2.879122225535269],
            [32.82298901982383, 2.879409702146102],
            [32.82435739834333, 2.882964592036583],
            [32.82369049626289, 2.884879459680354],
            [32.82392837464171, 2.886196036303054],
            [32.824511374972914, 2.888003382927449],
            [32.826272717021844, 2.890732499714517],
            [32.82717730344497, 2.891450746843048],
            [32.83070066666919, 2.892552389638373],
            [32.832307446386956, 2.89421626337135],
            [32.834282980935605, 2.897639579580813],
            [32.838603633110445, 2.900907628501575],
            [32.83865086203651, 2.903588593118735],
            [32.83489985044794, 2.912337087460681],
            [32.83483975944363, 2.91622686963763],
            [32.83410156526565, 2.91723212436597],
            [32.83436331367821, 2.918189648898659],
            [32.833731959730216, 2.921121860005128],
            [32.8335171024772, 2.925095394343659],
            [32.83512362887006, 2.928746044923745],
            [32.83519484550914, 2.930206228617888],
            [32.83621833653655, 2.932049543679549],
            [32.83728966464944, 2.932408754609141],
            [32.8372776191398, 2.93337820888548],
            [32.83872971794878, 2.934958277232966],
            [32.83918181308182, 2.936849374866644],
            [32.838967334917854, 2.938213761844662],
            [32.8380863616103, 2.938620564650819],
            [32.83775262939743, 2.9414451050156],
            [32.83730017403995, 2.942043461231911],
            [32.837942701233416, 2.94422183378323],
            [32.83789482282542, 2.945993185899889],
            [32.837037373700184, 2.948267084807758],
            [32.837144157336354, 2.950696727033828],
            [32.835572455033784, 2.952874773138558],
            [32.834215172504706, 2.954047485720336],
            [32.8332866657422, 2.953712231330722],
            [32.83238190055432, 2.953903586510499],
            [32.83197709543279, 2.954262587646532],
            [32.83173880921885, 2.955579089222152],
            [32.82994095065361, 2.957410008082868],
            [32.82798852706229, 2.957936320687616],
            [32.8272501280684, 2.959970868629421],
            [32.82582158039121, 2.96001851270749],
            [32.82522624529287, 2.960688656932352],
            [32.82427383795389, 2.960975752027911],
            [32.823845116984565, 2.961957106771997],
            [32.82296415715173, 2.962076650953418],
            [32.822213718038114, 2.964937023383143],
            [32.82104682085707, 2.96644487156912],
            [32.82121329844217, 2.967617813802108],
            [32.82002257165159, 2.969269281047964],
            [32.81874865098426, 2.970023094789773],
            [32.81785551089448, 2.971830201163257],
            [32.81566466813852, 2.974151734477124],
            [32.81424719938373, 2.978974823933291],
            [32.81186604943317, 2.980147340176989],
            [32.81069881538389, 2.983498327165962],
            [32.80913893221553, 2.985544676831166],
            [32.80854333211417, 2.987603172033083],
            [32.807114583214336, 2.988608272466824],
            [32.80642374192991, 2.990666739496004],
            [32.80512602578903, 2.991133285454515],
            [32.80398322501717, 2.990797958005855],
            [32.802483110357926, 2.991324310294737],
            [32.80074501670855, 2.991252178770695],
            [32.798625620560394, 2.993047071378418],
            [32.79738742948515, 2.99354952681554],
            [32.796530139361735, 2.994291410578125],
            [32.79487050726424, 2.997234909451096],
            [32.79454921132815, 2.99821525135543],
            [32.79476328614855, 2.999340326244646],
            [32.79557260713409, 3.000489461557488],
            [32.79548908716888, 3.001506774715076],
            [32.79677468503659, 3.002225130685762],
            [32.79648881775699, 3.00301499705405],
            [32.79796498153415, 3.003350387143194],
            [32.7985834563359, 3.006510204763232],
            [32.79801196522014, 3.006773404967922],
            [32.79841655564434, 3.007754901821857],
            [32.79792831859245, 3.008484886080396],
            [32.7994043224695, 3.009682019698894],
            [32.799142263239865, 3.010495830791547],
            [32.80033268011165, 3.011022664294199],
            [32.80142767703567, 3.012506962867598],
            [32.8032848450709, 3.012626985067965],
            [32.80416559918953, 3.013895812675551],
            [32.80658222001739, 3.014530585650555],
            [32.80858237199809, 3.013980378822916],
            [32.80891565954491, 3.014315561005918],
            [32.80858216269064, 3.015177239072759],
            [32.80882022522407, 3.015440587891274],
            [32.810415683474346, 3.014435508549848],
            [32.81189179155592, 3.015153881119847],
            [32.81172528342813, 3.014244245541964],
            [32.81360647331238, 3.013167394744773],
            [32.81374951385171, 3.012114190655861],
            [32.81527341949295, 3.011803266483089],
            [32.81582100104912, 3.012114544103103],
            [32.816737808153356, 3.011408553644754],
            [32.81754724951313, 3.01203105968237],
            [32.81976168562171, 3.011504807074787],
            [32.82028560196005, 3.010930410879839],
            [32.821142734878265, 3.011145982511773],
            [32.820904749599954, 3.010451766439792],
            [32.82123824286097, 3.009494338779109],
            [32.82207168001865, 3.008991799171279],
            [32.82350025644194, 3.009207462688582],
            [32.82338131500672, 3.008537205415705],
            [32.82416726542187, 3.007172918853739],
            [32.82665543167222, 3.007113472165651],
            [32.82851254131698, 3.007640381760618],
            [32.830488870874625, 3.007018331622103],
            [32.83096502199266, 3.007377458962293],
            [32.83167935512009, 3.007138201923686],
            [32.83296506348059, 3.007401707880497],
            [32.83336972936325, 3.008095947425097],
            [32.83441736980042, 3.008167923540643],
            [32.8354409776088, 3.009652178458146],
            [32.83766725980102, 3.009449044495101],
            [32.838119546275216, 3.01019116684882],
            [32.839048094360216, 3.010502489783311],
            [32.841024096931115, 3.012202311149403],
            [32.84454799734787, 3.012274638646697],
            [32.844807047221316, 3.013198498968469],
            [32.835396128319914, 3.023539268724819],
            [32.83288096769525, 3.028594400891575],
            [32.83202335328002, 3.031409272921929],
            [32.830307254880374, 3.042496673215106],
            [32.83116284269632, 3.052780189968039],
            [32.83007673999196, 3.054790734792137],
            [32.82956197479145, 3.057605655915915],
            [32.82978944618767, 3.064671923352416],
            [32.82778848212998, 3.069727117124765],
            [32.828588189345346, 3.071967758185317],
            [32.828473223853614, 3.07616151848153],
            [32.82538637717876, 3.081446324564219],
            [32.82247133599695, 3.084375737608122],
            [32.81807057565832, 3.086385705401937],
            [32.817327380559156, 3.087936699482589],
            [32.81732723323547, 3.088798434240952],
            [32.81818414876139, 3.090636949307785],
            [32.82058405284016, 3.092648073153215],
            [32.82304079961513, 3.096555019317894],
            [32.8253836525885, 3.098106532243622],
            [32.826297727915964, 3.100002501106707],
            [32.825897411675925, 3.101668455335788],
            [32.826468219173755, 3.105862326156235],
            [32.82778181752889, 3.111032950567311],
            [32.82732425435072, 3.113273385087263],
            [32.82646678995414, 3.114594570819402],
            [32.825951845988875, 3.11821376996498],
            [32.82509433757484, 3.119764748732723],
            [32.8249798365121, 3.120971158252954],
            [32.82577968476298, 3.122522413706858],
            [32.82560796820318, 3.124130956997384],
            [32.82286372460464, 3.130220083223121],
            [32.82303483839492, 3.132230826574],
            [32.82206203031586, 3.139584124918272],
            [32.82223298779925, 3.142514049980937],
            [32.819760236639155, 3.143776021702945],
            [32.81906118026148, 3.146215367254892],
            [32.8170383018024, 3.149134980190555],
            [32.81725883371307, 3.149652481316918],
            [32.81644968250912, 3.150798148502182],
            [32.81655974230111, 3.152239670052072],
            [32.81563998243451, 3.155048590086287],
            [32.81574947359294, 3.159705771165864],
            [32.8148298287107, 3.161812418507674],
            [32.81527101470292, 3.162182113425307],
            [32.81505012705939, 3.163660537484056],
            [32.814424967893615, 3.163956117997095],
            [32.813872325229156, 3.165415615786432],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 551,
        District: "PADER",
        County: "ARUU",
        Subcounty: "LAGUTI",
        Population: 13504,
        Key: "PADERLAGUTI",
        Dist2: "Pader",
        "Sub Country": "Laguti S/C",
        id2_original: "Pader Laguti S/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.965134079841995, 2.840542518178392],
            [32.96308661269696, 2.843486744607743],
            [32.96202700580189, 2.849842060391924],
            [32.95869369465076, 2.859536546212628],
            [32.95605063099763, 2.8720317029058],
            [32.95475282502521, 2.879895054608776],
            [32.95535960915186, 2.88763878735839],
            [32.95522852339235, 2.891313149415468],
            [32.95851395793208, 2.892198958132883],
            [32.96469198744964, 2.89486816713846],
            [32.96935824307386, 2.897645028971548],
            [32.97288174463865, 2.900517589014609],
            [32.97191737892664, 2.906394169565723],
            [32.970738810833446, 2.90887164667844],
            [32.96740556256437, 2.912749392037248],
            [32.96276272871454, 2.920002233037747],
            [32.961976940894495, 2.923425241294326],
            [32.96417907637188, 2.927937484685455],
            [32.9654170671228, 2.929613133178049],
            [32.96713123683955, 2.931001546326536],
            [32.97164291486123, 2.93312011115701],
            [32.97574982279573, 2.936746705784151],
            [32.974868884522465, 2.937321180990328],
            [32.97010713888184, 2.937608310826441],
            [32.96409538752338, 2.939295710730959],
            [32.96080965114969, 2.942742563115964],
            [32.95710727075732, 2.945626864217566],
            [32.95208352966747, 2.947302266366603],
            [32.94942876455945, 2.948822163598961],
            [32.945666957916124, 2.948798047062657],
            [32.94129809405827, 2.947182053131545],
            [32.939488321137425, 2.95280721442654],
            [32.932832021376065, 2.980514177930225],
            [32.93196256896205, 2.986989141296803],
            [32.93133138659227, 2.99863002061582],
            [32.929497782265265, 3.002220485593359],
            [32.92936661925063, 3.005463974418181],
            [32.92175798042227, 3.023667693408675],
            [32.920733877642185, 3.02704275944387],
            [32.92063806872389, 3.034846282517515],
            [32.919923566713216, 3.037239952035776],
            [32.917339719105286, 3.042134906725566],
            [32.91702515155069, 3.048262409201234],
            [32.917818692729945, 3.053051128453719],
            [32.91305526095154, 3.052805179721561],
            [32.9102460934125, 3.052252409789964],
            [32.88148794264135, 3.052410765309878],
            [32.87845827732761, 3.047020606800535],
            [32.87674406089848, 3.045512370308445],
            [32.8755299590459, 3.043190327836667],
            [32.87332778134769, 3.04032957274963],
            [32.87178250298921, 3.036291706044096],
            [32.87016353762461, 3.034903155829337],
            [32.86863970923849, 3.034400285311243],
            [32.86217501114408, 3.035057754340396],
            [32.86022287860692, 3.032328661269188],
            [32.859818270216415, 3.030988130895623],
            [32.858461266165065, 3.029432036284566],
            [32.85228307495079, 3.024536066918599],
            [32.84965414718695, 3.020617457511896],
            [32.84717811807439, 3.018797886147319],
            [32.84617857523418, 3.015278980453608],
            [32.844807047221316, 3.013198498968469],
            [32.84454799734787, 3.012274638646697],
            [32.841024096931115, 3.012202311149403],
            [32.839048094360216, 3.010502489783311],
            [32.838119546275216, 3.01019116684882],
            [32.83766725980102, 3.009449044495101],
            [32.8354409776088, 3.009652178458146],
            [32.83441736980042, 3.008167923540643],
            [32.83336972936325, 3.008095947425097],
            [32.83296506348059, 3.007401707880497],
            [32.83167935512009, 3.007138201923686],
            [32.83096502199266, 3.007377458962293],
            [32.830488870874625, 3.007018331622103],
            [32.82851254131698, 3.007640381760618],
            [32.82665543167222, 3.007113472165651],
            [32.82416726542187, 3.007172918853739],
            [32.82338131500672, 3.008537205415705],
            [32.82350025644194, 3.009207462688582],
            [32.82207168001865, 3.008991799171279],
            [32.82123824286097, 3.009494338779109],
            [32.820904749599954, 3.010451766439792],
            [32.821142734878265, 3.011145982511773],
            [32.82028560196005, 3.010930410879839],
            [32.81976168562171, 3.011504807074787],
            [32.81754724951313, 3.01203105968237],
            [32.816737808153356, 3.011408553644754],
            [32.81582100104912, 3.012114544103103],
            [32.81527341949295, 3.011803266483089],
            [32.81374951385171, 3.012114190655861],
            [32.81360647331238, 3.013167394744773],
            [32.81172528342813, 3.014244245541964],
            [32.81189179155592, 3.015153881119847],
            [32.810415683474346, 3.014435508549848],
            [32.80882022522407, 3.015440587891274],
            [32.80858216269064, 3.015177239072759],
            [32.80891565954491, 3.014315561005918],
            [32.80858237199809, 3.013980378822916],
            [32.80658222001739, 3.014530585650555],
            [32.80416559918953, 3.013895812675551],
            [32.8032848450709, 3.012626985067965],
            [32.80142767703567, 3.012506962867598],
            [32.80033268011165, 3.011022664294199],
            [32.799142263239865, 3.010495830791547],
            [32.7994043224695, 3.009682019698894],
            [32.79792831859245, 3.008484886080396],
            [32.79841655564434, 3.007754901821857],
            [32.79801196522014, 3.006773404967922],
            [32.7985834563359, 3.006510204763232],
            [32.79796498153415, 3.003350387143194],
            [32.79648881775699, 3.00301499705405],
            [32.79677468503659, 3.002225130685762],
            [32.79548908716888, 3.001506774715076],
            [32.79557260713409, 3.000489461557488],
            [32.79476328614855, 2.999340326244646],
            [32.79454921132815, 2.99821525135543],
            [32.79487050726424, 2.997234909451096],
            [32.796530139361735, 2.994291410578125],
            [32.79738742948515, 2.99354952681554],
            [32.798625620560394, 2.993047071378418],
            [32.80074501670855, 2.991252178770695],
            [32.802483110357926, 2.991324310294737],
            [32.80398322501717, 2.990797958005855],
            [32.80512602578903, 2.991133285454515],
            [32.80642374192991, 2.990666739496004],
            [32.807114583214336, 2.988608272466824],
            [32.80854333211417, 2.987603172033083],
            [32.80913893221553, 2.985544676831166],
            [32.81069881538389, 2.983498327165962],
            [32.81186604943317, 2.980147340176989],
            [32.81424719938373, 2.978974823933291],
            [32.81566466813852, 2.974151734477124],
            [32.81785551089448, 2.971830201163257],
            [32.81874865098426, 2.970023094789773],
            [32.82002257165159, 2.969269281047964],
            [32.82121329844217, 2.967617813802108],
            [32.82104682085707, 2.96644487156912],
            [32.822213718038114, 2.964937023383143],
            [32.82296415715173, 2.962076650953418],
            [32.823845116984565, 2.961957106771997],
            [32.82427383795389, 2.960975752027911],
            [32.82522624529287, 2.960688656932352],
            [32.82582158039121, 2.96001851270749],
            [32.8272501280684, 2.959970868629421],
            [32.82798852706229, 2.957936320687616],
            [32.82994095065361, 2.957410008082868],
            [32.83173880921885, 2.955579089222152],
            [32.83197709543279, 2.954262587646532],
            [32.83238190055432, 2.953903586510499],
            [32.8332866657422, 2.953712231330722],
            [32.834215172504706, 2.954047485720336],
            [32.835572455033784, 2.952874773138558],
            [32.837144157336354, 2.950696727033828],
            [32.837037373700184, 2.948267084807758],
            [32.83789482282542, 2.945993185899889],
            [32.837942701233416, 2.94422183378323],
            [32.83730017403995, 2.942043461231911],
            [32.83775262939743, 2.9414451050156],
            [32.8380863616103, 2.938620564650819],
            [32.838967334917854, 2.938213761844662],
            [32.83918181308182, 2.936849374866644],
            [32.83872971794878, 2.934958277232966],
            [32.8372776191398, 2.93337820888548],
            [32.83728966464944, 2.932408754609141],
            [32.83621833653655, 2.932049543679549],
            [32.83519484550914, 2.930206228617888],
            [32.83512362887006, 2.928746044923745],
            [32.8335171024772, 2.925095394343659],
            [32.833731959730216, 2.921121860005128],
            [32.83436331367821, 2.918189648898659],
            [32.83410156526565, 2.91723212436597],
            [32.83483975944363, 2.91622686963763],
            [32.83489985044794, 2.912337087460681],
            [32.83865086203651, 2.903588593118735],
            [32.838603633110445, 2.900907628501575],
            [32.834282980935605, 2.897639579580813],
            [32.832307446386956, 2.89421626337135],
            [32.83070066666919, 2.892552389638373],
            [32.82717730344497, 2.891450746843048],
            [32.826272717021844, 2.890732499714517],
            [32.824511374972914, 2.888003382927449],
            [32.82392837464171, 2.886196036303054],
            [32.82369049626289, 2.884879459680354],
            [32.82435739834333, 2.882964592036583],
            [32.82298901982383, 2.879409702146102],
            [32.8214653908637, 2.879122225535269],
            [32.82084653876954, 2.878260387407663],
            [32.8190135210424, 2.877302610184322],
            [32.81397916456081, 2.87180821182247],
            [32.813289090437685, 2.869749503773731],
            [32.80209135146924, 2.859157149463355],
            [32.79969765115585, 2.855672151868895],
            [32.79959115138733, 2.852045653964135],
            [32.79793733767791, 2.847700768174175],
            [32.798580548489326, 2.845211426237643],
            [32.79802179368765, 2.841177916937943],
            [32.79845062425146, 2.839382706589555],
            [32.798188982738445, 2.838066121943544],
            [32.79866529016335, 2.837012964221981],
            [32.7982608497578, 2.835456977378361],
            [32.795012103312565, 2.830752753053371],
            [32.79427425049441, 2.829914829929486],
            [32.7934648792032, 2.829675307213669],
            [32.79219168527292, 2.82722152373924],
            [32.79043034142733, 2.82540198058742],
            [32.78933532474041, 2.825018789024286],
            [32.789168783374954, 2.824492142893283],
            [32.78778804942704, 2.824348266738813],
            [32.787502474998234, 2.823797660820528],
            [32.787097757013285, 2.82386939302107],
            [32.78695504166407, 2.823199128472839],
            [32.78626469265647, 2.823031439804133],
            [32.78270637778114, 2.819236745632244],
            [32.777148412185085, 2.815250158152473],
            [32.7765297945512, 2.813454755153991],
            [32.77510172298111, 2.811994309177312],
            [32.77257861136787, 2.810342157285519],
            [32.77146004175248, 2.808762092388792],
            [32.77135305869035, 2.808031986025264],
            [32.76985362495411, 2.806332152891591],
            [32.769401644805406, 2.804632524548122],
            [32.768616193853575, 2.803938193042713],
            [32.769068806416236, 2.80240631478893],
            [32.76791454403967, 2.800790324356492],
            [32.76936675693473, 2.800479427196471],
            [32.770605136656165, 2.797990211098851],
            [32.7711527406702, 2.797607327259785],
            [32.77574726851395, 2.797368850374286],
            [32.77648504677195, 2.798422222513332],
            [32.77836551890229, 2.799332198079935],
            [32.77817491706024, 2.800193900387943],
            [32.7796625056112, 2.801618436456506],
            [32.78418513140127, 2.804132685006419],
            [32.78506593941883, 2.804132848304025],
            [32.78754195326001, 2.802960386980007],
            [32.78780422539038, 2.800686402169713],
            [32.78511513924862, 2.795443674520503],
            [32.785543832370166, 2.794390522223955],
            [32.78727001166394, 2.792846890998683],
            [32.78822252500411, 2.79121932992351],
            [32.78744948337962, 2.787688463770759],
            [32.78787814506017, 2.786778933192132],
            [32.78697372841864, 2.785749467808451],
            [32.78680725622342, 2.784815891108196],
            [32.78787884844103, 2.782853236956325],
            [32.79035456404154, 2.78309305100566],
            [32.79058120449614, 2.780304410998045],
            [32.78896319853229, 2.776067247651526],
            [32.78492903077962, 2.7715304267674],
            [32.78504821475996, 2.770692647006109],
            [32.78645271363868, 2.770668964589575],
            [32.78750025076958, 2.77007073083435],
            [32.78928562095574, 2.770142858426238],
            [32.79059472054794, 2.771148454921773],
            [32.79359399585561, 2.772130409449845],
            [32.7961170526716, 2.773830382658146],
            [32.79893778063004, 2.774967886088639],
            [32.80231769997138, 2.777481865019663],
            [32.80923297235104, 2.778500342607667],
            [32.810994395248336, 2.779553859950714],
            [32.81154200465229, 2.779003393575289],
            [32.81461272387282, 2.780033176199388],
            [32.81506492770204, 2.780679558034852],
            [32.81458861129396, 2.782043901976547],
            [32.81482658848746, 2.782522677962378],
            [32.817480658299466, 2.784043106262268],
            [32.818718163061796, 2.786508837600546],
            [32.82049628204699, 2.787930218488896],
            [32.821955268239286, 2.789405735089971],
            [32.8229904337721, 2.791883393088198],
            [32.8251802443638, 2.793990189336958],
            [32.82625108019992, 2.796814943323593],
            [32.82609623489944, 2.79754500733641],
            [32.82773891578754, 2.79694681773234],
            [32.8269293262057, 2.79828717830704],
            [32.825643764270616, 2.798622111417883],
            [32.820906459093926, 2.798429892155258],
            [32.81983513906587, 2.798788790606035],
            [32.819739832305814, 2.79936327051331],
            [32.82085860763537, 2.799985805568623],
            [32.8220010481828, 2.801565839256702],
            [32.82190564530299, 2.802714804140389],
            [32.82069145541553, 2.803336989284638],
            [32.819524964273015, 2.803408615972532],
            [32.818584519798684, 2.804162495793442],
            [32.81560878124976, 2.804185966684674],
            [32.81225230703903, 2.803299751121463],
            [32.80944321855171, 2.803299294426146],
            [32.80631286916262, 2.802616567939503],
            [32.80600336810618, 2.802760139919558],
            [32.80581264588993, 2.804411773161208],
            [32.80681237827466, 2.805106117844055],
            [32.80712170775285, 2.806015777770358],
            [32.807978696940665, 2.806159543136606],
            [32.80824045523466, 2.806805896234917],
            [32.80954967699773, 2.807404534802876],
            [32.811430071872955, 2.809128323470012],
            [32.81245370663079, 2.809224234385914],
            [32.81386997703298, 2.810385419259084],
            [32.81565537506691, 2.810696889809578],
            [32.81679794407342, 2.811463056136856],
            [32.81725030241284, 2.81112800288529],
            [32.81832148499864, 2.811678726053163],
            [32.81944043370307, 2.811248039367163],
            [32.82134481629132, 2.811870697295908],
            [32.82583222452902, 2.812050911158444],
            [32.826855933847014, 2.811668070503863],
            [32.827451209656545, 2.810830357039256],
            [32.82809390842826, 2.811237384711144],
            [32.82930803633199, 2.811141807731842],
            [32.830188714093794, 2.812099424576517],
            [32.8298076667166, 2.813152612074033],
            [32.83047417802987, 2.813535702569125],
            [32.830473918416736, 2.815330992391824],
            [32.831449975702164, 2.81528325790479],
            [32.8328543452235, 2.816623950957842],
            [32.832497182253064, 2.817078699358223],
            [32.83306849370577, 2.817342099948299],
            [32.83240181081429, 2.818131928113777],
            [32.832699287022315, 2.818838119709143],
            [32.833675347002696, 2.818790383571431],
            [32.833603791698735, 2.81972392151154],
            [32.8350796150144, 2.820897060440302],
            [32.835817628631, 2.820705664013307],
            [32.8366268400221, 2.822118075950262],
            [32.83755528659749, 2.822070329180486],
            [32.83791229236274, 2.822740619502159],
            [32.83893601156223, 2.822333830924047],
            [32.83926921107413, 2.82300412737432],
            [32.84012618499056, 2.823387239749154],
            [32.84214944523364, 2.825374299454618],
            [32.84268492648291, 2.826559270630408],
            [32.84266105375424, 2.82703800686085],
            [32.8420182831173, 2.827061857713331],
            [32.84144683871393, 2.827732019542596],
            [32.839280579254066, 2.826893917483051],
            [32.83832845937599, 2.825936296664018],
            [32.83687621683654, 2.826319094940799],
            [32.83542389165207, 2.827348182749117],
            [32.83442376850017, 2.82914333011834],
            [32.832709550274416, 2.830292071310092],
            [32.83287609433483, 2.831010213644846],
            [32.83422097472312, 2.832267111719266],
            [32.839148764062536, 2.833273166270887],
            [32.84102947783966, 2.833225559028909],
            [32.84946860196167, 2.835297262243371],
            [32.853706164464306, 2.835249931427076],
            [32.85459885359981, 2.835645006813506],
            [32.85590825861919, 2.835310055640728],
            [32.858265043564316, 2.835813027421769],
            [32.85928857411755, 2.83701001059256],
            [32.86074077892776, 2.837010187343757],
            [32.863431198169415, 2.834592853563638],
            [32.863336012681906, 2.834281656788006],
            [32.8623837670397, 2.834161857756089],
            [32.86264580111651, 2.83277352924092],
            [32.86083669744054, 2.831193450859449],
            [32.86117008829362, 2.830379626471009],
            [32.860396777174564, 2.827016358687977],
            [32.86120625985685, 2.826441961489807],
            [32.861182577571036, 2.825460530685268],
            [32.862444208386975, 2.826274546942301],
            [32.86296802052072, 2.825724052295908],
            [32.865705785469395, 2.82538924898907],
            [32.86706265926503, 2.826131464153585],
            [32.86775309271431, 2.825700671560811],
            [32.86868145035649, 2.82646677507425],
            [32.87034798600695, 2.825653089130096],
            [32.87095499650906, 2.826072059036322],
            [32.87162159945047, 2.825904578938184],
            [32.872311908033915, 2.826598836342298],
            [32.873240370778994, 2.826431376059037],
            [32.87393067307422, 2.827197438715109],
            [32.874740082993, 2.827245405093473],
            [32.875406707493966, 2.826790666053847],
            [32.87552566869209, 2.827436991551039],
            [32.87602558114773, 2.827700353904672],
            [32.87612067860033, 2.828873284696225],
            [32.87747761258307, 2.829160676977061],
            [32.87764419886431, 2.829735190364618],
            [32.87600125566812, 2.832559604738435],
            [32.875774903572726, 2.834295036078921],
            [32.876822185582114, 2.836281942503278],
            [32.87803629282458, 2.836521442319174],
            [32.877488688810544, 2.837024062762617],
            [32.87753625011324, 2.837550685253135],
            [32.87867897632494, 2.837383252572546],
            [32.87936921124652, 2.838891371417602],
            [32.88057141131989, 2.839286460812261],
            [32.88242808707835, 2.84160856201153],
            [32.884618266877624, 2.841943910617237],
            [32.8848324557841, 2.84270991993795],
            [32.88542760313455, 2.842853603601788],
            [32.886594198481625, 2.842207415914229],
            [32.88757023510582, 2.842590505785642],
            [32.88795116839699, 2.842303295386317],
            [32.888165629492974, 2.840172897468641],
            [32.88995115688429, 2.839861892403966],
            [32.88976033854828, 2.843763638602954],
            [32.89084346333749, 2.844613515963167],
            [32.890771839761584, 2.846719989737398],
            [32.89146216092145, 2.847533921047493],
            [32.8914144226506, 2.848922277572268],
            [32.8933544423045, 2.851495710815094],
            [32.89380676830456, 2.851471823681739],
            [32.89478275372478, 2.852549087683774],
            [32.89530653172253, 2.852237949584204],
            [32.89594927002012, 2.852836441772378],
            [32.896972957778544, 2.852884403497106],
            [32.89778227337423, 2.854224968647268],
            [32.89806794931268, 2.854320741249137],
            [32.89830607113492, 2.853698397737486],
            [32.89899640217626, 2.854488385900211],
            [32.89966304464354, 2.854033633364674],
            [32.89990102004041, 2.855086890374614],
            [32.90082947200569, 2.855278473109053],
            [32.90037710647973, 2.855637497527769],
            [32.90056751428567, 2.856235939496715],
            [32.90154362187677, 2.855996654619769],
            [32.901829256492725, 2.856571174383439],
            [32.90251968814537, 2.8562361081702],
            [32.9034957220746, 2.856882493441054],
            [32.905328860175985, 2.856810839552977],
            [32.90573361948343, 2.856308194544153],
            [32.9052099259273, 2.855590031172237],
            [32.90568610309649, 2.855183138420708],
            [32.90566235523362, 2.854441077404527],
            [32.906543200082126, 2.854632651274663],
            [32.90635281473405, 2.853723015146423],
            [32.90716223094104, 2.853962460198697],
            [32.907543181300184, 2.853435864046948],
            [32.9082335096466, 2.854345540776513],
            [32.90878110737243, 2.853866834707946],
            [32.90987617167006, 2.854561103115892],
            [32.91073329560514, 2.853651557548353],
            [32.911137907588895, 2.855016012452746],
            [32.91178074559949, 2.854321881591387],
            [32.91218542316024, 2.854968215901813],
            [32.91294726548808, 2.854657095503891],
            [32.91339954926734, 2.855327373203107],
            [32.91351862634812, 2.854752886013723],
            [32.91449471148136, 2.85475295958417],
            [32.91425668398222, 2.854106638610641],
            [32.915470848716865, 2.854058850993911],
            [32.91508996573134, 2.853580073029844],
            [32.916066120933145, 2.852622654672573],
            [32.91544717361752, 2.852239614791939],
            [32.915637679339845, 2.851473641415074],
            [32.91447117472258, 2.851090550908381],
            [32.91399508109675, 2.850444211726618],
            [32.91407845733152, 2.849809884850635],
            [32.91326903753127, 2.849642260153301],
            [32.9135071925912, 2.848445419284381],
            [32.91272170660508, 2.846650065030923],
            [32.91272179823326, 2.845429255737319],
            [32.911769575048915, 2.844806818594759],
            [32.91135313764277, 2.842448965523866],
            [32.91209117910715, 2.841922403585229],
            [32.91194848082595, 2.840055281963806],
            [32.910448672492215, 2.839911541427327],
            [32.910258272771124, 2.839289162319125],
            [32.91099628099784, 2.839193463833725],
            [32.9099964794428, 2.838164088677787],
            [32.910472648527154, 2.837733253905135],
            [32.910032277306904, 2.837051007901401],
            [32.9108417554976, 2.836332950960882],
            [32.91400798719242, 2.836931627258199],
            [32.914531639426045, 2.838152465278264],
            [32.91565049021409, 2.839014291362597],
            [32.91617412178648, 2.840570255472908],
            [32.91691209947047, 2.841025110222364],
            [32.917507168667505, 2.842437454318723],
            [32.91824514724982, 2.842772633110923],
            [32.919102222675896, 2.842317883126457],
            [32.91905453560904, 2.843466871422588],
            [32.920304423647565, 2.842832615173966],
            [32.920923324250765, 2.843981650509535],
            [32.92178040686335, 2.843431151726566],
            [32.922327959673446, 2.843455128747599],
            [32.92247076844742, 2.843933878622276],
            [32.92454196908223, 2.84371858525019],
            [32.92561323251643, 2.844317080968677],
            [32.925827516644325, 2.843886232342311],
            [32.92663688164732, 2.844891643349094],
            [32.927684376557394, 2.845011394613394],
            [32.92804153144302, 2.844101804715077],
            [32.92839864141286, 2.844053948495176],
            [32.92911271852041, 2.845968974517612],
            [32.92998166697958, 2.846004935483754],
            [32.930219785208564, 2.845143206134794],
            [32.93155296414193, 2.845239041399652],
            [32.93155298839645, 2.844832108202794],
            [32.93076739551081, 2.844209687784858],
            [32.93221962188059, 2.844066150534965],
            [32.932195844373354, 2.843515591679325],
            [32.93105315319597, 2.842941027716193],
            [32.931148440193084, 2.842031420035551],
            [32.93002955706568, 2.841480795609829],
            [32.93032727492052, 2.839266615368357],
            [32.9296845285381, 2.83862027314722],
            [32.929565579916364, 2.83723190243078],
            [32.92870859522017, 2.836346166037761],
            [32.9290181609553, 2.835077508099153],
            [32.927756519359555, 2.833330011258601],
            [32.925935389936875, 2.832192872313713],
            [32.924768849387014, 2.832599730109395],
            [32.92400707443282, 2.832168808028904],
            [32.92381669267804, 2.831043742716039],
            [32.9226978895007, 2.829487751438622],
            [32.9220789251171, 2.829368024585756],
            [32.9222218695367, 2.827931793961583],
            [32.92126964814899, 2.827285425673409],
            [32.919758083563146, 2.82521474712195],
            [32.92054374831402, 2.8245206198848],
            [32.92087712389571, 2.823156219584719],
            [32.921757984015564, 2.822821153547879],
            [32.92159142558209, 2.821504586872658],
            [32.92232955058981, 2.819589655870703],
            [32.92167491949618, 2.81888346024531],
            [32.920960732794164, 2.819003106531194],
            [32.92067514578892, 2.817686531047876],
            [32.92010380020023, 2.817614684517797],
            [32.91908021215478, 2.816417743249113],
            [32.919937270512875, 2.81591512285321],
            [32.91958024857791, 2.814957607838138],
            [32.92005644640834, 2.813784709663551],
            [32.91971147177968, 2.81070875035386],
            [32.918902164268836, 2.809296392773821],
            [32.91954490615971, 2.80955974667132],
            [32.92011632091867, 2.808554418103169],
            [32.91999733546603, 2.807932044624072],
            [32.920402052552646, 2.807692692344596],
            [32.92066388540684, 2.808171460558277],
            [32.921425691802064, 2.807908203249287],
            [32.921259114504, 2.807046447405245],
            [32.92223518975573, 2.80647201613149],
            [32.92290175317126, 2.806639623739998],
            [32.92360406953514, 2.805909580651369],
            [32.92410396132947, 2.80650804830602],
            [32.92472292481477, 2.806316586710041],
            [32.92517522117042, 2.806627803530105],
            [32.92607986867898, 2.806244866887486],
            [32.927793808427005, 2.807800900906529],
            [32.928127113041796, 2.8075136738263],
            [32.92819849497092, 2.808040296231154],
            [32.92865081019121, 2.808064262319141],
            [32.92869837239223, 2.808782386074696],
            [32.930079124306424, 2.808758531258732],
            [32.930340967940374, 2.809117602399207],
            [32.92974580172532, 2.809476631259215],
            [32.93000762739297, 2.810146891144251],
            [32.93036469873527, 2.810410221521784],
            [32.93126934893875, 2.810170895770092],
            [32.93124549866795, 2.81088901464098],
            [32.93236441233809, 2.810410339956781],
            [32.93260243534565, 2.811032718395433],
            [32.93217388595453, 2.811702936114044],
            [32.93295947345028, 2.81189448385852],
            [32.933078475072584, 2.812540794303844],
            [32.93578029573183, 2.815616891440305],
            [32.937351458146914, 2.816359037475113],
            [32.938256108350394, 2.816191522780324],
            [32.940874745912645, 2.817029465671915],
            [32.94144604389062, 2.818082731258417],
            [32.94136265058785, 2.819387313945228],
            [32.94333851032665, 2.820680020370928],
            [32.94412404302514, 2.822188116983956],
            [32.94467159403858, 2.822044518684179],
            [32.945052458159466, 2.822786587046666],
            [32.94614752694873, 2.823265388535547],
            [32.94662362596447, 2.823935653045548],
            [32.94781392785188, 2.824222956826759],
            [32.9479567330326, 2.824965013031047],
            [32.949861223418694, 2.825372040246348],
            [32.950991969697746, 2.826772412068008],
            [32.95261079312853, 2.82701186001671],
            [32.953420227301834, 2.826796451342591],
            [32.95349165773997, 2.826413460320437],
            [32.95589607225976, 2.827347106082982],
            [32.95584843100696, 2.828017348497372],
            [32.95470569760878, 2.828591799645971],
            [32.95434856248608, 2.829668962074036],
            [32.95280108056022, 2.831153018590954],
            [32.95277725095069, 2.831679636575382],
            [32.95608633184368, 2.832302132827496],
            [32.95664575409359, 2.833151928895321],
            [32.95797890877244, 2.833391348609554],
            [32.95797887463648, 2.834348849322426],
            [32.957336064473665, 2.835330246580552],
            [32.95807393256321, 2.839160246331479],
            [32.961061631281815, 2.840201619013405],
            [32.96199010121341, 2.839866534579219],
            [32.962823319182135, 2.840345302092229],
            [32.96458502864204, 2.839818739194127],
            [32.965134079841995, 2.840542518178392],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 552,
        District: "PADER",
        County: "ARUU",
        Subcounty: "LAPUL",
        Population: 18258,
        Key: "PADERLAPUL",
        Dist2: "Pader",
        "Sub Country": "Lapul S/C",
        id2_original: "Pader Lapul S/C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.95465640255756, 3.22248703664702],
            [32.93560259818885, 3.236542810028151],
            [32.93288768188939, 3.2359681414144],
            [32.931426495722995, 3.236854995920815],
            [32.929235590084964, 3.237199687406778],
            [32.92796060581234, 3.237840333498959],
            [32.92439075117889, 3.237904143012861],
            [32.92305196136826, 3.239249569794211],
            [32.91890832940665, 3.240018121253174],
            [32.9178882385026, 3.241683940547874],
            [32.91355306416288, 3.245784248927391],
            [32.9116522002756, 3.246420920019914],
            [32.91655492212698, 3.23944649772478],
            [32.91789383321019, 3.236755539756557],
            [32.918213259752186, 3.228137741916848],
            [32.92203845691186, 3.222819989970465],
            [32.92535375684156, 3.215932381533409],
            [32.92624665258959, 3.209653294611146],
            [32.922802758826954, 3.208687197089915],
            [32.922544353045595, 3.207981896997364],
            [32.92152813388043, 3.208045659053897],
            [32.92133323988795, 3.207341074251419],
            [32.92012614848785, 3.207149406752083],
            [32.91910227028661, 3.205867224360218],
            [32.91495903088876, 3.203464144581369],
            [32.90523393250497, 3.198743315018254],
            [32.906984744502154, 3.196042522498476],
            [32.90929265121434, 3.19389709135915],
            [32.91592763305568, 3.19012829414752],
            [32.919620033165224, 3.189200746854274],
            [32.91858230743382, 3.186430150162326],
            [32.91852350820692, 3.183922152398703],
            [32.91859514705421, 3.181480574325477],
            [32.919869577066294, 3.176633404701136],
            [32.9196675387724, 3.17166643415585],
            [32.91696531656622, 3.16353955378272],
            [32.91496559757351, 3.15575982835403],
            [32.91381138550259, 3.14681920410183],
            [32.92205065603344, 3.148519396313018],
            [32.925896496478344, 3.148675270784179],
            [32.93237387698791, 3.146305934327957],
            [32.946400084697586, 3.142740118187804],
            [32.95163899834913, 3.1425967518947],
            [32.95925295610227, 3.141236849845709],
            [32.9577099531764, 3.135274637298927],
            [32.957324228271474, 3.133180396145715],
            [32.95755577622249, 3.131629125959219],
            [32.95662991499851, 3.129767553853507],
            [32.95655288895445, 3.126509865124574],
            [32.955395675612195, 3.12170085180422],
            [32.9562265049606, 3.115766990449286],
            [32.95277952907826, 3.111153354610582],
            [32.95100003746731, 3.110173079029525],
            [32.94870859328103, 3.109952426122543],
            [32.94595391395384, 3.11107951069794],
            [32.94456803086274, 3.112962181719078],
            [32.93719777257145, 3.117713297814662],
            [32.9353165296866, 3.118359484314119],
            [32.93207467421793, 3.118743652215584],
            [32.93101013736859, 3.119532803011688],
            [32.93093696330049, 3.120169924373737],
            [32.92966832562532, 3.121022943766112],
            [32.928761365853234, 3.124213075532687],
            [32.92759556551515, 3.123952570939326],
            [32.92506973739649, 3.122389849686698],
            [32.922932607606334, 3.119655244030502],
            [32.92170207107562, 3.119069199348095],
            [32.915419638457465, 3.119068710491501],
            [32.91358420156725, 3.119847022787545],
            [32.913384484520016, 3.125706607402568],
            [32.90612330326379, 3.12468162556344],
            [32.90660816804007, 3.123251327601069],
            [32.906787333430245, 3.116824223161671],
            [32.90599022144772, 3.109966161765562],
            [32.88148794264135, 3.052410765309878],
            [32.9102460934125, 3.052252409789964],
            [32.91305526095154, 3.052805179721561],
            [32.917818692729945, 3.053051128453719],
            [32.919715070430684, 3.054019554739402],
            [32.93097976263387, 3.062950806522651],
            [32.937169453182115, 3.068966918465061],
            [32.93510608226332, 3.071821952239131],
            [32.9342738003391, 3.07382836908678],
            [32.935549531111754, 3.075440799629955],
            [32.93863936468492, 3.077705955002035],
            [32.94127865092225, 3.07887094779006],
            [32.94900352905343, 3.080036190468941],
            [32.956985999092296, 3.079324695585385],
            [32.95878851721891, 3.078483492193758],
            [32.96316600131022, 3.07783651798902],
            [32.96850898209248, 3.081072366419109],
            [32.97095515389995, 3.083402123584918],
            [32.97526819105613, 3.086443768107613],
            [32.978036288518695, 3.087673385470405],
            [32.97777886369763, 3.08404942361124],
            [32.97887326054702, 3.082755175691716],
            [32.97906642618088, 3.080619632100884],
            [32.98086893981591, 3.079195968977285],
            [32.98093334542851, 3.077448705002635],
            [32.98318798294268, 3.07349955275233],
            [32.98980606028701, 3.075152740872898],
            [32.9992948505471, 3.074894983440014],
            [33.00284343397294, 3.075266714654521],
            [33.011540503040536, 3.073799248136609],
            [33.01327155659306, 3.073154714581447],
            [33.016284862687165, 3.071801194194138],
            [33.01987514680676, 3.068707468642557],
            [33.02265253015446, 3.06693522318922],
            [33.026640032224705, 3.067502401688378],
            [33.02845612928518, 3.066637546885302],
            [33.0298421093943, 3.066445329723841],
            [33.03146706382691, 3.066685507430746],
            [33.034525769877156, 3.066060828917192],
            [33.03825360493141, 3.066493105489943],
            [33.04280407490206, 3.065891335203969],
            [33.04551849353482, 3.063736875356723],
            [33.04780414358753, 3.058135470630837],
            [33.05094696608435, 3.052390397101415],
            [33.0535184681453, 3.050235923587945],
            [33.05666133465959, 3.046357935918184],
            [33.05909000818363, 3.045352441250199],
            [33.06180463792049, 3.048368376136708],
            [33.07468420995036, 3.050578453871109],
            [33.07996420086491, 3.056401659193127],
            [33.085380715041374, 3.059103135230744],
            [33.08732612907855, 3.061837835942926],
            [33.08927029086423, 3.062875922290468],
            [33.091943446282734, 3.063425354274673],
            [33.09413043885937, 3.062325844160937],
            [33.09589229115138, 3.062692126688719],
            [33.09801860881876, 3.062508713191156],
            [33.103486226355145, 3.06146994922765],
            [33.10494420463767, 3.060675854761696],
            [33.10743508559685, 3.061042045459184],
            [33.110412035973084, 3.061896768312455],
            [33.11187019391866, 3.062873789148287],
            [33.114413346945916, 3.063543860213231],
            [33.11638667972378, 3.064572202257142],
            [33.120004542122636, 3.067143189391478],
            [33.12350555256765, 3.070942832848224],
            [33.124273128841935, 3.071922544565814],
            [33.12019934897853, 3.071510611123811],
            [33.119029020233114, 3.071878411858924],
            [33.11583569804426, 3.074539533946957],
            [33.11120258306752, 3.075850088930373],
            [33.11010546252619, 3.076879677647021],
            [33.108642522848335, 3.077173964844639],
            [33.10340753752953, 3.080367472481621],
            [33.098588532374386, 3.080424414244202],
            [33.083465469126395, 3.078323629055619],
            [33.08161835952739, 3.08392492071818],
            [33.08118629772349, 3.087111865291289],
            [33.081330995654525, 3.094934274169273],
            [33.08046664117971, 3.098410971212037],
            [33.082052526982324, 3.108116440949644],
            [33.08108415478412, 3.109814389762343],
            [33.079026524099966, 3.110724145093183],
            [33.074127013725715, 3.111593660627736],
            [33.0690834854451, 3.113911757950949],
            [33.06793086518886, 3.117388464263311],
            [33.06793114456493, 3.121734251836192],
            [33.06418462994266, 3.125935416819641],
            [33.059429511173896, 3.133323536796536],
            [33.06008434079521, 3.138242213920888],
            [33.056036613871655, 3.135989009615018],
            [33.05193934486018, 3.133106286483712],
            [33.03520919916216, 3.125350512114068],
            [33.03186321188405, 3.124252357880329],
            [33.02653698827512, 3.123566093423019],
            [33.02587901095704, 3.123896821814176],
            [33.02365040392486, 3.127811335703694],
            [33.02358346146989, 3.129045530571747],
            [33.024161182402146, 3.130400494481263],
            [33.02345518833552, 3.13362664433897],
            [33.01893562759721, 3.136880502397286],
            [33.01297255863892, 3.147334428996388],
            [33.00632212128315, 3.160535444768772],
            [32.99853480934141, 3.173386711150765],
            [32.98430559046238, 3.200327856190506],
            [32.95465640255756, 3.22248703664702],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 553,
        District: "PADER",
        County: "ARUU",
        Subcounty: "LATANYA",
        Population: 15156,
        Key: "PADERLATANYA",
        Dist2: "Pader",
        "Sub Country": "Latanya S/C",
        id2_original: "Pader Latanya S/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19895550513342, 2.955234126655662],
            [33.19856210232778, 2.955837909311305],
            [33.19749863806691, 2.956108035742575],
            [33.194933697300755, 2.956196840743462],
            [33.19357297691908, 2.957651332136528],
            [33.19230895838112, 2.958117075686259],
            [33.1919539351977, 2.958851854805084],
            [33.191145287948586, 2.959034373387558],
            [33.190538886504264, 2.959897497032295],
            [33.18816359356934, 2.961409442033553],
            [33.18505433213155, 2.966653966721932],
            [33.182657248762766, 2.968608653178778],
            [33.182126171054996, 2.970263431067825],
            [33.18090820015851, 2.971149512806103],
            [33.17948321609802, 2.974276603452878],
            [33.17647066458877, 2.976947949816833],
            [33.17234728873852, 2.985227207964833],
            [33.169838724442975, 2.987056064568849],
            [33.16790249567959, 2.9894413221494],
            [33.16571766894112, 2.99040346813359],
            [33.16497064971378, 2.992131516322218],
            [33.163527258274826, 2.993912699967497],
            [33.161822805634515, 2.998600438330652],
            [33.16032048830619, 3.000904125893538],
            [33.15901375577477, 3.004663709969093],
            [33.15795068767088, 3.006237532237352],
            [33.15548759250179, 3.007904023054804],
            [33.15242645291544, 3.012219290968613],
            [33.14730194869846, 3.014234368774154],
            [33.14484789507273, 3.015515977775149],
            [33.14369277121182, 3.016738698875223],
            [33.14244667675871, 3.019795281657233],
            [33.1429107006204, 3.025876691396633],
            [33.14178245794603, 3.026481627354564],
            [33.14193159624951, 3.027035784787699],
            [33.14132903240806, 3.027766505142153],
            [33.14130250515774, 3.028497048282709],
            [33.14009865757413, 3.029328725478561],
            [33.140447590179924, 3.030159912241191],
            [33.13964523023953, 3.030613592711709],
            [33.13923982414504, 3.031994792561693],
            [33.13869412635604, 3.031373057782059],
            [33.135960858373664, 3.030632416596056],
            [33.134464379196345, 3.029795702514991],
            [33.13101666400053, 3.029557564561009],
            [33.12663198170884, 3.028159616164193],
            [33.12573023935193, 3.025784831259881],
            [33.12548035139608, 3.022649180049156],
            [33.12572899788021, 3.014998091150488],
            [33.12510472624993, 3.010984491953335],
            [33.12273382428011, 3.007221945974872],
            [33.1197392561445, 3.004588307672307],
            [33.11599634735978, 3.00396157751683],
            [33.11225325082717, 3.001453424294407],
            [33.109757777680294, 2.998945131649333],
            [33.10763565604359, 2.986778890059109],
            [33.10676214593942, 2.984772138744696],
            [33.104391578142895, 2.983267238368313],
            [33.09952581657553, 2.981511708844116],
            [33.09942938512471, 2.980591497191913],
            [33.09876364995586, 2.980371976788168],
            [33.098644634858815, 2.980731041992717],
            [33.09738266807295, 2.980084852646112],
            [33.096977823425554, 2.979151340275242],
            [33.09607303847476, 2.97886417275393],
            [33.09571592221671, 2.979127512369443],
            [33.09535873409342, 2.978672733977839],
            [33.09498971156461, 2.978948044560109],
            [33.09425156679396, 2.978421490774562],
            [33.09287062803018, 2.978613109911778],
            [33.08994191089649, 2.97679412444888],
            [33.08450126437823, 2.974628232747555],
            [33.07716785138663, 2.97321648476784],
            [33.07537018236595, 2.972414704912218],
            [33.06929852505611, 2.968417588511726],
            [33.06603661200376, 2.96801085672639],
            [33.064357947300316, 2.966060070751904],
            [33.063786422946876, 2.9643126901292],
            [33.06211964475127, 2.962038753222672],
            [33.05872664054951, 2.958364568170136],
            [33.058274192378576, 2.95700017001514],
            [33.058702738176436, 2.956641093509507],
            [33.05865508973713, 2.956114468989568],
            [33.05796452513385, 2.95417558839646],
            [33.05279933442103, 2.948459762391763],
            [33.05138259150497, 2.94591051823462],
            [33.049584798516754, 2.940895742662741],
            [33.04613249292983, 2.940129904604368],
            [33.04037069869747, 2.938071526566968],
            [33.02906149407365, 2.935749959057032],
            [33.02772812020588, 2.932087597636578],
            [33.02528766168361, 2.928509036144549],
            [33.0176924841098, 2.912136088823956],
            [33.01643062602009, 2.910556253900956],
            [33.01453786852995, 2.909586821186896],
            [33.0123951152861, 2.907193116986672],
            [33.01153800392745, 2.90534995224808],
            [33.010157128045726, 2.90432066811394],
            [33.007847687909326, 2.895080900226526],
            [33.00443123947528, 2.888055329321699],
            [33.00358603708235, 2.878851442709598],
            [33.00278848402702, 2.876948433762506],
            [33.00233613467074, 2.874195647571514],
            [33.002431354294245, 2.871299236560438],
            [33.00406213699639, 2.866021057652952],
            [33.0077879229935, 2.859450257416091],
            [33.00908540018252, 2.857810534880383],
            [33.011156568478, 2.853118808244647],
            [33.01002571979102, 2.851215806767202],
            [33.00988286789792, 2.850138631237002],
            [33.008478245949995, 2.848295467542671],
            [33.00740693580341, 2.847625232400718],
            [33.00673103799374, 2.845691744599151],
            [33.007236229848274, 2.845715179659822],
            [33.00778377996338, 2.844877379533655],
            [33.00723622266173, 2.844661942784351],
            [33.00666484922527, 2.843082089704901],
            [33.005593548061846, 2.843082095088149],
            [33.002879568705254, 2.841478301363789],
            [33.00249865877028, 2.83961119786568],
            [33.003474728632135, 2.838055268352193],
            [33.00274862038796, 2.836870368152641],
            [33.00331998034971, 2.83679855959632],
            [33.003986562629876, 2.836080436105144],
            [33.00355803928988, 2.835290509798607],
            [33.00384371612663, 2.834189393330017],
            [33.00401036349331, 2.83387820541805],
            [33.00479597704021, 2.833926080003736],
            [33.00529591554696, 2.832896770142723],
            [33.00505784762362, 2.831771717200797],
            [33.00662906483592, 2.830383345445538],
            [33.00712900873258, 2.830718467618002],
            [33.00790271061881, 2.829916565152543],
            [33.01014051819613, 2.829533553627428],
            [33.01078329691788, 2.830179851576553],
            [33.01318774916692, 2.830443136146316],
            [33.01371150650344, 2.831065494891131],
            [33.015258921953986, 2.831041545426929],
            [33.01537796669544, 2.832118719933524],
            [33.0164492642656, 2.831855396266959],
            [33.01749676187067, 2.832812872230763],
            [33.01812761815197, 2.831987026256475],
            [33.021174830258154, 2.830718295351915],
            [33.02181762155633, 2.831220964073483],
            [33.02157956710774, 2.832178459403316],
            [33.022627079984126, 2.833183808819195],
            [33.022222378168856, 2.833662566538211],
            [33.02222239883009, 2.83471580357376],
            [33.02291279275349, 2.834907291896719],
            [33.02272234991326, 2.835601478410244],
            [33.023174677709974, 2.835625399069206],
            [33.023254136391806, 2.836017183342586],
            [33.02272641209497, 2.836458284685535],
            [33.02301211677953, 2.837726958156427],
            [33.02141709511051, 2.838756287943883],
            [33.02027437249209, 2.838708438680072],
            [33.01996490197838, 2.839282932075414],
            [33.020107753871486, 2.839929243420587],
            [33.020679105748385, 2.839857416212931],
            [33.02082196482803, 2.840934589686853],
            [33.02210756718732, 2.842897426016592],
            [33.02156002695368, 2.843687373140477],
            [33.022524233663894, 2.845350997686466],
            [33.02221476584511, 2.846571804371365],
            [33.02266710082834, 2.846691480095731],
            [33.023143255539644, 2.847888331759453],
            [33.02328608317825, 2.84717020799066],
            [33.02390506373149, 2.847098388411514],
            [33.02621435384924, 2.848438823927499],
            [33.02690473609455, 2.847696756766269],
            [33.03095188270642, 2.846978535082519],
            [33.03246364402333, 2.848019760742142],
            [33.0332254576051, 2.847971870591099],
            [33.03434434252913, 2.8466552813912],
            [33.03534416654203, 2.844548767124357],
            [33.03536793416781, 2.8435194676232],
            [33.036224970068005, 2.843232192856048],
            [33.03579639821899, 2.841628402929091],
            [33.03508218905911, 2.841125744114228],
            [33.03537974252222, 2.840371716004286],
            [33.03437984394916, 2.83955787025895],
            [33.034332207187944, 2.838839760145834],
            [33.036308138791945, 2.83807370070568],
            [33.03811746884338, 2.839126878993771],
            [33.039022130724966, 2.839222605298313],
            [33.04023643380016, 2.843986079132503],
            [33.04249815363202, 2.845996735009042],
            [33.0427481664537, 2.8471576785034],
            [33.044962236947946, 2.848067215746422],
            [33.04610365072099, 2.849220981310112],
            [33.04786466668147, 2.849248315550908],
            [33.04892416937198, 2.849728509312162],
            [33.050575086912936, 2.854100511625136],
            [33.05214540311501, 2.856488889563655],
            [33.05512492357128, 2.85948442895026],
            [33.05528601755287, 2.860455993059119],
            [33.05431988126142, 2.86365412993],
            [33.04911685440716, 2.868463880941084],
            [33.048308053546144, 2.87103489368587],
            [33.04786783683613, 2.876337022173425],
            [33.050070311876674, 2.882931644058869],
            [33.05289164889288, 2.885887771146794],
            [33.05460295388219, 2.889650555278214],
            [33.053999182705, 2.893327561061825],
            [33.05440189115864, 2.894946827318853],
            [33.0543215907554, 2.899683240120651],
            [33.055449219880416, 2.904905381263624],
            [33.055932625792686, 2.909844176096503],
            [33.05710048417105, 2.914013776605463],
            [33.05834878578482, 2.916361674785234],
            [33.05859057902163, 2.920409874117213],
            [33.05959738923253, 2.924336586263807],
            [33.06249667486255, 2.929032352488478],
            [33.06471134093984, 2.931177777830456],
            [33.06716754243743, 2.932311130628979],
            [33.076176721269036, 2.932697339072226],
            [33.07653287992302, 2.932983764945518],
            [33.07817105126839, 2.931981073108909],
            [33.079239498484164, 2.932410674486606],
            [33.08045034663879, 2.932052523976285],
            [33.0829433521136, 2.932482017669881],
            [33.08408282552562, 2.930190325003197],
            [33.08607716181315, 2.929688883297227],
            [33.08678931742434, 2.928113348843258],
            [33.08621940914011, 2.92696758878821],
            [33.086504241560476, 2.925964988455362],
            [33.08978059413272, 2.924604088099037],
            [33.0986837888288, 2.922096892640103],
            [33.09946721857123, 2.921309082227013],
            [33.09968079213172, 2.920091648280633],
            [33.10103397744477, 2.918659272040529],
            [33.10462810276056, 2.918019442411031],
            [33.10424179125577, 2.9159889197936],
            [33.100679294722816, 2.909236130439291],
            [33.09854153880693, 2.901971603667411],
            [33.1002713913119, 2.899822732241214],
            [33.10461686124308, 2.896190680395001],
            [33.10882850375654, 2.891431101475595],
            [33.108755330586774, 2.891118880315357],
            [33.109441267069705, 2.89103914864608],
            [33.11075278043508, 2.889303565470503],
            [33.11268704907452, 2.888256120505091],
            [33.11536536261939, 2.887807027330167],
            [33.11923414693496, 2.888255448521634],
            [33.123995217940795, 2.884065921873052],
            [33.13130570682467, 2.878695330412868],
            [33.13398863860841, 2.877667329287808],
            [33.13616063021812, 2.877667070899249],
            [33.136973469904625, 2.877265383377911],
            [33.13712030133446, 2.875377074839898],
            [33.13623897768394, 2.87159510653543],
            [33.133036215099786, 2.86569495535444],
            [33.12621500531354, 2.861446874752904],
            [33.12057219473719, 2.856324916543836],
            [33.118941156015175, 2.853775775963577],
            [33.11716714322915, 2.849838278675758],
            [33.11647667923715, 2.849192046455259],
            [33.11311965256251, 2.846511407993248],
            [33.1120483163648, 2.846176397168287],
            [33.111119906620324, 2.846703105203656],
            [33.11014372087581, 2.845578146455457],
            [33.110715006277395, 2.844764226325025],
            [33.113595602457934, 2.844572442660107],
            [33.11414311664046, 2.844165455395496],
            [33.11480970431051, 2.844165389002063],
            [33.1158334666291, 2.844955213237189],
            [33.11633338177966, 2.844643985159289],
            [33.11682103672322, 2.840873817082021],
            [33.1188921053057, 2.839796430014922],
            [33.119201422207496, 2.838120789158745],
            [33.122569810773825, 2.835858362808481],
            [33.12404560175017, 2.833775663412359],
            [33.1246169338641, 2.833536231216559],
            [33.124878626581115, 2.831884534327539],
            [33.12475955219525, 2.83147761437253],
            [33.12399772244383, 2.831310134157879],
            [33.12385481305852, 2.830639908002652],
            [33.12478310692031, 2.829203569493222],
            [33.12566401824413, 2.829849785979345],
            [33.12623534496818, 2.829586415141688],
            [33.12725888270796, 2.82836549451645],
            [33.127306370348826, 2.827192569491913],
            [33.12868717885689, 2.827551470754067],
            [33.129734804921014, 2.828891845498453],
            [33.13052043823085, 2.829035381043017],
            [33.130520526265734, 2.829825307130301],
            [33.134580080408305, 2.834719999853266],
            [33.13727039095381, 2.836155918801238],
            [33.13830611434041, 2.837364622820968],
            [33.141258352063204, 2.839255311387582],
            [33.142258186855905, 2.838896123953928],
            [33.142901062595705, 2.839638101672382],
            [33.14404376994277, 2.839614019598258],
            [33.1461591281637, 2.840449183949392],
            [33.14732923682186, 2.840858339289999],
            [33.14791260366568, 2.841660168673464],
            [33.1486510233208, 2.84486765289981],
            [33.149960493917206, 2.845681346860937],
            [33.15003200161046, 2.846327647444439],
            [33.15065097857045, 2.846375434485017],
            [33.151650979551476, 2.847260983740569],
            [33.153031679363394, 2.84656662031017],
            [33.15365047216875, 2.845226057904167],
            [33.15493608171458, 2.845560999920366],
            [33.157388046757305, 2.84465105605831],
            [33.158125966949136, 2.843980713823463],
            [33.15857808723499, 2.842448670341772],
            [33.15922092883884, 2.842927320146627],
            [33.15898294715378, 2.843525785770569],
            [33.15950677096563, 2.844100207683427],
            [33.160670217717644, 2.844378315454572],
            [33.16064630276815, 2.843612323391391],
            [33.16109863325979, 2.843684075897039],
            [33.1620785856403, 2.842593056553526],
            [33.16232354993006, 2.842944818427074],
            [33.162008806305664, 2.844000252340877],
            [33.162568571712036, 2.843718735084102],
            [33.16368831093388, 2.844633246472458],
            [33.16351344577898, 2.845160965469109],
            [33.162848696960324, 2.845301779556915],
            [33.16274389141446, 2.846427542472349],
            [33.16389840172602, 2.845794144685397],
            [33.163408770488836, 2.847201400267533],
            [33.16207926925822, 2.847483025235663],
            [33.16330403501155, 2.84881967768733],
            [33.16211452364155, 2.849382720406217],
            [33.16207964834726, 2.850191857867507],
            [33.16344414075482, 2.849910226384228],
            [33.16470385276933, 2.850930254755441],
            [33.16477390339519, 2.851457938567475],
            [33.16564857861429, 2.85128191539123],
            [33.16578865650978, 2.85216138501725],
            [33.166698274396815, 2.851668738198198],
            [33.167258169160576, 2.852266710305186],
            [33.16746825635946, 2.853357247659816],
            [33.16816808888154, 2.853849659585907],
            [33.16848322776468, 2.855538234928223],
            [33.16746860760073, 2.855784640974453],
            [33.166943953745566, 2.856945645469231],
            [33.16718900247696, 2.857860280027168],
            [33.16834351638181, 2.857191696820015],
            [33.168623437712554, 2.857297194806137],
            [33.16823865963194, 2.857930484874989],
            [33.169323396897084, 2.858633916595303],
            [33.16995312309778, 2.85821166758836],
            [33.17128270607509, 2.858422546727715],
            [33.17250720952033, 2.857859488698498],
            [33.172751916891926, 2.85645226768943],
            [33.172192027518044, 2.855924657946198],
            [33.172856733217586, 2.855467222454209],
            [33.17222682196396, 2.854623006368519],
            [33.17243667110928, 2.854095280943417],
            [33.17330075339454, 2.853954432043269],
            [33.17621075053605, 2.856341651104077],
            [33.17761670738046, 2.858365943426495],
            [33.17868057049335, 2.859206139111872],
            [33.17898465470862, 2.860237445957788],
            [33.17792104402232, 2.861039775928662],
            [33.17852899865379, 2.861727250025901],
            [33.17841518120898, 2.862720423849241],
            [33.17966897871563, 2.863407795555366],
            [33.17966913951408, 2.864439149760626],
            [33.180049070285385, 2.864591882486222],
            [33.18016298295162, 2.864209881064497],
            [33.18099889047632, 2.864935516240724],
            [33.18141677686502, 2.864859053006575],
            [33.18346856580489, 2.866692242049692],
            [33.184570216550206, 2.866195486053079],
            [33.18671066651366, 2.868995295273953],
            [33.18752989861174, 2.868826189428626],
            [33.188517305212464, 2.869396303841711],
            [33.18843342053124, 2.870262294570911],
            [33.18960992878749, 2.871064710822328],
            [33.188706698820454, 2.871423924983145],
            [33.18837071273452, 2.87216323050383],
            [33.188728076927575, 2.873683910939172],
            [33.18942134905314, 2.873979494991305],
            [33.19015649165412, 2.873409094868963],
            [33.19148018797136, 2.875035218855999],
            [33.19150134688956, 2.875943434856687],
            [33.19240469543421, 2.876281224532304],
            [33.19227890344666, 2.877759741774101],
            [33.191774760824366, 2.877886555812976],
            [33.19190090045996, 2.878477933397137],
            [33.192573140329785, 2.878604547284547],
            [33.19280430110689, 2.879111421677233],
            [33.19221640765236, 2.880885717579486],
            [33.19284668092705, 2.881286916655722],
            [33.19335107148435, 2.882617478171189],
            [33.19471670115906, 2.88367331245954],
            [33.194191645756966, 2.884370407715644],
            [33.19478004586132, 2.885574225127382],
            [33.19597731687872, 2.884834770404599],
            [33.196439596212144, 2.885573938030993],
            [33.194591339464516, 2.887665274645206],
            [33.195221632502175, 2.88815095733391],
            [33.19492768218163, 2.889016984945533],
            [33.1952219532007, 2.890030760110189],
            [33.1948439205696, 2.890579981327016],
            [33.19026490393586, 2.893727847808218],
            [33.18761839883689, 2.896115007870239],
            [33.18352413019848, 2.900802090592705],
            [33.18392491086752, 2.905800101600012],
            [33.184667999067194, 2.907523454526076],
            [33.18484015580151, 2.912061908439585],
            [33.18295529180773, 2.9166007011324],
            [33.18265371299382, 2.918994402378492],
            [33.19055347694112, 2.934053495396296],
            [33.196460333820475, 2.947457253125422],
            [33.19895550513342, 2.955234126655662],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 554,
        District: "PADER",
        County: "ARUU",
        Subcounty: "OGOM",
        Population: 8551,
        Key: "PADEROGOM",
        Dist2: "Pader",
        "Sub Country": "Ogom S/C",
        id2_original: "Pader Ogom S/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.965134079841995, 2.840542518178392],
            [32.96458502864204, 2.839818739194127],
            [32.962823319182135, 2.840345302092229],
            [32.96199010121341, 2.839866534579219],
            [32.961061631281815, 2.840201619013405],
            [32.95807393256321, 2.839160246331479],
            [32.957336064473665, 2.835330246580552],
            [32.95797887463648, 2.834348849322426],
            [32.95797890877244, 2.833391348609554],
            [32.95664575409359, 2.833151928895321],
            [32.95608633184368, 2.832302132827496],
            [32.95277725095069, 2.831679636575382],
            [32.95280108056022, 2.831153018590954],
            [32.95434856248608, 2.829668962074036],
            [32.95470569760878, 2.828591799645971],
            [32.95584843100696, 2.828017348497372],
            [32.95589607225976, 2.827347106082982],
            [32.95349165773997, 2.826413460320437],
            [32.953420227301834, 2.826796451342591],
            [32.95261079312853, 2.82701186001671],
            [32.950991969697746, 2.826772412068008],
            [32.949861223418694, 2.825372040246348],
            [32.9479567330326, 2.824965013031047],
            [32.94781392785188, 2.824222956826759],
            [32.94662362596447, 2.823935653045548],
            [32.94614752694873, 2.823265388535547],
            [32.945052458159466, 2.822786587046666],
            [32.94467159403858, 2.822044518684179],
            [32.94412404302514, 2.822188116983956],
            [32.94333851032665, 2.820680020370928],
            [32.94136265058785, 2.819387313945228],
            [32.94144604389062, 2.818082731258417],
            [32.940874745912645, 2.817029465671915],
            [32.938256108350394, 2.816191522780324],
            [32.937351458146914, 2.816359037475113],
            [32.93578029573183, 2.815616891440305],
            [32.933078475072584, 2.812540794303844],
            [32.93295947345028, 2.81189448385852],
            [32.93217388595453, 2.811702936114044],
            [32.93260243534565, 2.811032718395433],
            [32.93236441233809, 2.810410339956781],
            [32.93124549866795, 2.81088901464098],
            [32.93126934893875, 2.810170895770092],
            [32.93036469873527, 2.810410221521784],
            [32.93000762739297, 2.810146891144251],
            [32.92974580172532, 2.809476631259215],
            [32.930340967940374, 2.809117602399207],
            [32.930079124306424, 2.808758531258732],
            [32.92869837239223, 2.808782386074696],
            [32.92865081019121, 2.808064262319141],
            [32.92819849497092, 2.808040296231154],
            [32.928127113041796, 2.8075136738263],
            [32.927793808427005, 2.807800900906529],
            [32.92607986867898, 2.806244866887486],
            [32.92517522117042, 2.806627803530105],
            [32.92472292481477, 2.806316586710041],
            [32.92410396132947, 2.80650804830602],
            [32.92360406953514, 2.805909580651369],
            [32.92290175317126, 2.806639623739998],
            [32.92223518975573, 2.80647201613149],
            [32.921259114504, 2.807046447405245],
            [32.921425691802064, 2.807908203249287],
            [32.92066388540684, 2.808171460558277],
            [32.920402052552646, 2.807692692344596],
            [32.91999733546603, 2.807932044624072],
            [32.92011632091867, 2.808554418103169],
            [32.91954490615971, 2.80955974667132],
            [32.918902164268836, 2.809296392773821],
            [32.91971147177968, 2.81070875035386],
            [32.92005644640834, 2.813784709663551],
            [32.91958024857791, 2.814957607838138],
            [32.919937270512875, 2.81591512285321],
            [32.91908021215478, 2.816417743249113],
            [32.92010380020023, 2.817614684517797],
            [32.92067514578892, 2.817686531047876],
            [32.920960732794164, 2.819003106531194],
            [32.92167491949618, 2.81888346024531],
            [32.92232955058981, 2.819589655870703],
            [32.92159142558209, 2.821504586872658],
            [32.921757984015564, 2.822821153547879],
            [32.92087712389571, 2.823156219584719],
            [32.92054374831402, 2.8245206198848],
            [32.919758083563146, 2.82521474712195],
            [32.92126964814899, 2.827285425673409],
            [32.9222218695367, 2.827931793961583],
            [32.9220789251171, 2.829368024585756],
            [32.9226978895007, 2.829487751438622],
            [32.92381669267804, 2.831043742716039],
            [32.92400707443282, 2.832168808028904],
            [32.924768849387014, 2.832599730109395],
            [32.925935389936875, 2.832192872313713],
            [32.927756519359555, 2.833330011258601],
            [32.9290181609553, 2.835077508099153],
            [32.92870859522017, 2.836346166037761],
            [32.929565579916364, 2.83723190243078],
            [32.9296845285381, 2.83862027314722],
            [32.93032727492052, 2.839266615368357],
            [32.93002955706568, 2.841480795609829],
            [32.931148440193084, 2.842031420035551],
            [32.93105315319597, 2.842941027716193],
            [32.932195844373354, 2.843515591679325],
            [32.93221962188059, 2.844066150534965],
            [32.93076739551081, 2.844209687784858],
            [32.93155298839645, 2.844832108202794],
            [32.93155296414193, 2.845239041399652],
            [32.930219785208564, 2.845143206134794],
            [32.92998166697958, 2.846004935483754],
            [32.92911271852041, 2.845968974517612],
            [32.92839864141286, 2.844053948495176],
            [32.92804153144302, 2.844101804715077],
            [32.927684376557394, 2.845011394613394],
            [32.92663688164732, 2.844891643349094],
            [32.925827516644325, 2.843886232342311],
            [32.92561323251643, 2.844317080968677],
            [32.92454196908223, 2.84371858525019],
            [32.92247076844742, 2.843933878622276],
            [32.922327959673446, 2.843455128747599],
            [32.92178040686335, 2.843431151726566],
            [32.920923324250765, 2.843981650509535],
            [32.920304423647565, 2.842832615173966],
            [32.91905453560904, 2.843466871422588],
            [32.919102222675896, 2.842317883126457],
            [32.91824514724982, 2.842772633110923],
            [32.917507168667505, 2.842437454318723],
            [32.91691209947047, 2.841025110222364],
            [32.91617412178648, 2.840570255472908],
            [32.91565049021409, 2.839014291362597],
            [32.914531639426045, 2.838152465278264],
            [32.91400798719242, 2.836931627258199],
            [32.9108417554976, 2.836332950960882],
            [32.910032277306904, 2.837051007901401],
            [32.910472648527154, 2.837733253905135],
            [32.9099964794428, 2.838164088677787],
            [32.91099628099784, 2.839193463833725],
            [32.910258272771124, 2.839289162319125],
            [32.910448672492215, 2.839911541427327],
            [32.91194848082595, 2.840055281963806],
            [32.91209117910715, 2.841922403585229],
            [32.91135313764277, 2.842448965523866],
            [32.911769575048915, 2.844806818594759],
            [32.91272179823326, 2.845429255737319],
            [32.91272170660508, 2.846650065030923],
            [32.9135071925912, 2.848445419284381],
            [32.91326903753127, 2.849642260153301],
            [32.91407845733152, 2.849809884850635],
            [32.91399508109675, 2.850444211726618],
            [32.91447117472258, 2.851090550908381],
            [32.915637679339845, 2.851473641415074],
            [32.91544717361752, 2.852239614791939],
            [32.916066120933145, 2.852622654672573],
            [32.91508996573134, 2.853580073029844],
            [32.915470848716865, 2.854058850993911],
            [32.91425668398222, 2.854106638610641],
            [32.91449471148136, 2.85475295958417],
            [32.91351862634812, 2.854752886013723],
            [32.91339954926734, 2.855327373203107],
            [32.91294726548808, 2.854657095503891],
            [32.91218542316024, 2.854968215901813],
            [32.91178074559949, 2.854321881591387],
            [32.911137907588895, 2.855016012452746],
            [32.91073329560514, 2.853651557548353],
            [32.90987617167006, 2.854561103115892],
            [32.90878110737243, 2.853866834707946],
            [32.9082335096466, 2.854345540776513],
            [32.907543181300184, 2.853435864046948],
            [32.90716223094104, 2.853962460198697],
            [32.90635281473405, 2.853723015146423],
            [32.906543200082126, 2.854632651274663],
            [32.90566235523362, 2.854441077404527],
            [32.90568610309649, 2.855183138420708],
            [32.9052099259273, 2.855590031172237],
            [32.90573361948343, 2.856308194544153],
            [32.905328860175985, 2.856810839552977],
            [32.9034957220746, 2.856882493441054],
            [32.90251968814537, 2.8562361081702],
            [32.901829256492725, 2.856571174383439],
            [32.90154362187677, 2.855996654619769],
            [32.90056751428567, 2.856235939496715],
            [32.90037710647973, 2.855637497527769],
            [32.90082947200569, 2.855278473109053],
            [32.89990102004041, 2.855086890374614],
            [32.89966304464354, 2.854033633364674],
            [32.89899640217626, 2.854488385900211],
            [32.89830607113492, 2.853698397737486],
            [32.89806794931268, 2.854320741249137],
            [32.89778227337423, 2.854224968647268],
            [32.896972957778544, 2.852884403497106],
            [32.89594927002012, 2.852836441772378],
            [32.89530653172253, 2.852237949584204],
            [32.89478275372478, 2.852549087683774],
            [32.89380676830456, 2.851471823681739],
            [32.8933544423045, 2.851495710815094],
            [32.8914144226506, 2.848922277572268],
            [32.89146216092145, 2.847533921047493],
            [32.890771839761584, 2.846719989737398],
            [32.89084346333749, 2.844613515963167],
            [32.88976033854828, 2.843763638602954],
            [32.88995115688429, 2.839861892403966],
            [32.888165629492974, 2.840172897468641],
            [32.88795116839699, 2.842303295386317],
            [32.88757023510582, 2.842590505785642],
            [32.886594198481625, 2.842207415914229],
            [32.88542760313455, 2.842853603601788],
            [32.8848324557841, 2.84270991993795],
            [32.884618266877624, 2.841943910617237],
            [32.88242808707835, 2.84160856201153],
            [32.88057141131989, 2.839286460812261],
            [32.87936921124652, 2.838891371417602],
            [32.87867897632494, 2.837383252572546],
            [32.87753625011324, 2.837550685253135],
            [32.877488688810544, 2.837024062762617],
            [32.87803629282458, 2.836521442319174],
            [32.876822185582114, 2.836281942503278],
            [32.875774903572726, 2.834295036078921],
            [32.87600125566812, 2.832559604738435],
            [32.87764419886431, 2.829735190364618],
            [32.87747761258307, 2.829160676977061],
            [32.87612067860033, 2.828873284696225],
            [32.87602558114773, 2.827700353904672],
            [32.87552566869209, 2.827436991551039],
            [32.875406707493966, 2.826790666053847],
            [32.874740082993, 2.827245405093473],
            [32.87393067307422, 2.827197438715109],
            [32.873240370778994, 2.826431376059037],
            [32.872311908033915, 2.826598836342298],
            [32.87162159945047, 2.825904578938184],
            [32.87095499650906, 2.826072059036322],
            [32.87034798600695, 2.825653089130096],
            [32.86868145035649, 2.82646677507425],
            [32.86775309271431, 2.825700671560811],
            [32.86706265926503, 2.826131464153585],
            [32.865705785469395, 2.82538924898907],
            [32.86296802052072, 2.825724052295908],
            [32.862444208386975, 2.826274546942301],
            [32.861182577571036, 2.825460530685268],
            [32.86120625985685, 2.826441961489807],
            [32.860396777174564, 2.827016358687977],
            [32.86117008829362, 2.830379626471009],
            [32.86083669744054, 2.831193450859449],
            [32.86264580111651, 2.83277352924092],
            [32.8623837670397, 2.834161857756089],
            [32.863336012681906, 2.834281656788006],
            [32.863431198169415, 2.834592853563638],
            [32.86074077892776, 2.837010187343757],
            [32.85928857411755, 2.83701001059256],
            [32.858265043564316, 2.835813027421769],
            [32.85590825861919, 2.835310055640728],
            [32.85459885359981, 2.835645006813506],
            [32.853706164464306, 2.835249931427076],
            [32.84946860196167, 2.835297262243371],
            [32.84102947783966, 2.833225559028909],
            [32.839148764062536, 2.833273166270887],
            [32.83422097472312, 2.832267111719266],
            [32.83287609433483, 2.831010213644846],
            [32.832709550274416, 2.830292071310092],
            [32.83442376850017, 2.82914333011834],
            [32.83542389165207, 2.827348182749117],
            [32.83687621683654, 2.826319094940799],
            [32.83832845937599, 2.825936296664018],
            [32.839280579254066, 2.826893917483051],
            [32.84144683871393, 2.827732019542596],
            [32.8420182831173, 2.827061857713331],
            [32.84266105375424, 2.82703800686085],
            [32.84268492648291, 2.826559270630408],
            [32.84214944523364, 2.825374299454618],
            [32.84012618499056, 2.823387239749154],
            [32.83926921107413, 2.82300412737432],
            [32.83893601156223, 2.822333830924047],
            [32.83791229236274, 2.822740619502159],
            [32.83755528659749, 2.822070329180486],
            [32.8366268400221, 2.822118075950262],
            [32.835817628631, 2.820705664013307],
            [32.8350796150144, 2.820897060440302],
            [32.833603791698735, 2.81972392151154],
            [32.833675347002696, 2.818790383571431],
            [32.832699287022315, 2.818838119709143],
            [32.83240181081429, 2.818131928113777],
            [32.83306849370577, 2.817342099948299],
            [32.832497182253064, 2.817078699358223],
            [32.8328543452235, 2.816623950957842],
            [32.831449975702164, 2.81528325790479],
            [32.830473918416736, 2.815330992391824],
            [32.83047417802987, 2.813535702569125],
            [32.8298076667166, 2.813152612074033],
            [32.830188714093794, 2.812099424576517],
            [32.82930803633199, 2.811141807731842],
            [32.82809390842826, 2.811237384711144],
            [32.827451209656545, 2.810830357039256],
            [32.826855933847014, 2.811668070503863],
            [32.82583222452902, 2.812050911158444],
            [32.82134481629132, 2.811870697295908],
            [32.81944043370307, 2.811248039367163],
            [32.81832148499864, 2.811678726053163],
            [32.81725030241284, 2.81112800288529],
            [32.81679794407342, 2.811463056136856],
            [32.81565537506691, 2.810696889809578],
            [32.81386997703298, 2.810385419259084],
            [32.81245370663079, 2.809224234385914],
            [32.811430071872955, 2.809128323470012],
            [32.80954967699773, 2.807404534802876],
            [32.80824045523466, 2.806805896234917],
            [32.807978696940665, 2.806159543136606],
            [32.80712170775285, 2.806015777770358],
            [32.80681237827466, 2.805106117844055],
            [32.80581264588993, 2.804411773161208],
            [32.80600336810618, 2.802760139919558],
            [32.80631286916262, 2.802616567939503],
            [32.80944321855171, 2.803299294426146],
            [32.81225230703903, 2.803299751121463],
            [32.81560878124976, 2.804185966684674],
            [32.818584519798684, 2.804162495793442],
            [32.819524964273015, 2.803408615972532],
            [32.82069145541553, 2.803336989284638],
            [32.82190564530299, 2.802714804140389],
            [32.8220010481828, 2.801565839256702],
            [32.82085860763537, 2.799985805568623],
            [32.819739832305814, 2.79936327051331],
            [32.81983513906587, 2.798788790606035],
            [32.820906459093926, 2.798429892155258],
            [32.825643764270616, 2.798622111417883],
            [32.8269293262057, 2.79828717830704],
            [32.82773891578754, 2.79694681773234],
            [32.82609623489944, 2.79754500733641],
            [32.82625108019992, 2.796814943323593],
            [32.8251802443638, 2.793990189336958],
            [32.8229904337721, 2.791883393088198],
            [32.821955268239286, 2.789405735089971],
            [32.82049628204699, 2.787930218488896],
            [32.821620586507144, 2.787265069210624],
            [32.82176383096404, 2.784536252763438],
            [32.82300173817164, 2.784368877975612],
            [32.82557299858577, 2.782502165789053],
            [32.82607308351794, 2.781305374383797],
            [32.82721580433974, 2.78089861088749],
            [32.82925149097809, 2.778612908258064],
            [32.829775196212346, 2.778684792171594],
            [32.83077484864703, 2.779905733247111],
            [32.83179848340487, 2.779905880397466],
            [32.832179465205044, 2.779211763977281],
            [32.8336553936236, 2.779211973935823],
            [32.835702490662726, 2.780385182147009],
            [32.83608346707305, 2.779714994990591],
            [32.83767834680824, 2.780337579928541],
            [32.83971377742679, 2.779799272665084],
            [32.84016603964645, 2.780110520738618],
            [32.84140398997321, 2.779584070641367],
            [32.84161812587905, 2.780397964481419],
            [32.84373694710542, 2.779345014062044],
            [32.844903305297265, 2.780111155997305],
            [32.84685545939403, 2.779249669566954],
            [32.84692694462938, 2.778675184321313],
            [32.84759353589269, 2.778411961673704],
            [32.84776023087009, 2.777909305248361],
            [32.848022052046154, 2.778196586225991],
            [32.84903382005909, 2.777897500002819],
            [32.85153365183175, 2.77574347094979],
            [32.85431891609938, 2.775408693732575],
            [32.85462844500356, 2.774858176075842],
            [32.859496580818224, 2.775277670207176],
            [32.86002033725645, 2.774918677552917],
            [32.865662065362855, 2.776044378261143],
            [32.86835190788607, 2.777528799791881],
            [32.86957770490533, 2.779144698375217],
            [32.87007767485311, 2.778594196815875],
            [32.872291436326925, 2.779887055921237],
            [32.873029502045824, 2.779001452804387],
            [32.87362457214116, 2.779552074406445],
            [32.87590994551276, 2.779073578056911],
            [32.87605284411828, 2.778451219458757],
            [32.877028853793014, 2.778475261520364],
            [32.87774307552933, 2.77790083960332],
            [32.880802163363576, 2.776955633579018],
            [32.88165923878961, 2.776141854009937],
            [32.885468242918, 2.774562366706433],
            [32.88758693388863, 2.774395008449324],
            [32.89000336966355, 2.772228916477614],
            [32.893264875779096, 2.770146672702135],
            [32.89457413527142, 2.770505855230145],
            [32.89547880433954, 2.769668130374342],
            [32.89771656340781, 2.76890232891391],
            [32.89832357031665, 2.769249476787238],
            [32.89908534706747, 2.769081978702519],
            [32.899632791181425, 2.769967699613342],
            [32.90151340794049, 2.769896051150718],
            [32.90904797438545, 2.767107960540741],
            [32.91033353632057, 2.766054821528629],
            [32.913713880565034, 2.765959318043171],
            [32.917260918888566, 2.764930273286685],
            [32.918296487764934, 2.764200254588232],
            [32.91843936301426, 2.763553960656076],
            [32.91984391040203, 2.762907752509994],
            [32.920010650295175, 2.761375776072094],
            [32.921129491201754, 2.761351912220489],
            [32.92112954330402, 2.760561984006839],
            [32.92229603624319, 2.759796062715094],
            [32.92222465970395, 2.759269438489419],
            [32.92281982771567, 2.758527417061876],
            [32.923200713396156, 2.758551380567658],
            [32.923712574343355, 2.757677699745694],
            [32.92452191599015, 2.758108624056403],
            [32.925140914509704, 2.756935740134375],
            [32.92547418409025, 2.757007568834384],
            [32.927473936320645, 2.754733653419351],
            [32.92740256157803, 2.754135213337648],
            [32.928735683917544, 2.753321426189445],
            [32.92885477537141, 2.752172440170605],
            [32.92991415858597, 2.751155173741196],
            [32.93060450939025, 2.750987650674267],
            [32.930437913227536, 2.750317396660721],
            [32.93103310369711, 2.749168438254534],
            [32.93181865975184, 2.749168484015892],
            [32.93269951538011, 2.747708361331129],
            [32.933032501092995, 2.746221618942458],
            [32.9342577483433, 2.745510903711087],
            [32.93622512618917, 2.746020407561861],
            [32.93787447886488, 2.745380786735383],
            [32.93818081246162, 2.744788472210791],
            [32.93888767250418, 2.744741131469675],
            [32.940466414903604, 2.742395604467544],
            [32.94138534203193, 2.742040261918485],
            [32.94197446168682, 2.740381779645969],
            [32.94456632765697, 2.738462776987393],
            [32.94466062740562, 2.737349213365414],
            [32.94569734343058, 2.737254487325508],
            [32.94659266373154, 2.737704698181286],
            [32.947912143356845, 2.736970274166608],
            [32.948960606650814, 2.73750340550947],
            [32.949502546787016, 2.737076955727247],
            [32.9511989819634, 2.736982261968292],
            [32.95141104994745, 2.736626873845504],
            [32.95237705957645, 2.736911225268619],
            [32.95520450423825, 2.735466067906504],
            [32.95687738289298, 2.735276581424571],
            [32.95772558386233, 2.735655706898098],
            [32.96043517764372, 2.735039780706719],
            [32.96100067519991, 2.734471166634694],
            [32.96207272376164, 2.734530436386764],
            [32.96230835994551, 2.733724885604697],
            [32.965182859260246, 2.734009285272386],
            [32.966574458331486, 2.734381166406964],
            [32.9682086052244, 2.735805401138109],
            [32.968818705931064, 2.735673956910474],
            [32.97080149347731, 2.736375147856015],
            [32.972958633240445, 2.735608318239361],
            [32.97481071052296, 2.735783648999238],
            [32.97745805824168, 2.737437952677607],
            [32.97893971342017, 2.737678999795401],
            [32.98070461459426, 2.73897176072068],
            [32.981728708391174, 2.738862216976445],
            [32.982948890939916, 2.739344275596091],
            [32.98845068398297, 2.737711990457093],
            [32.989954134086865, 2.737690093889158],
            [32.990455283522635, 2.737251887875417],
            [32.99261240621775, 2.737558653457354],
            [32.99422481028751, 2.736923251654374],
            [32.99485669693646, 2.737098544535764],
            [32.99641462357414, 2.736561739504036],
            [32.99887679527515, 2.736364545465557],
            [33.00075207514313, 2.734370674365883],
            [33.00075202932904, 2.734782472329332],
            [33.0041965249629, 2.732450807860726],
            [33.00640984446557, 2.731638254093594],
            [33.00992304864226, 2.731473362751461],
            [33.01137518158723, 2.732156359923872],
            [33.01291250895714, 2.732189131797706],
            [33.01446242172416, 2.735296525529638],
            [33.014567096116004, 2.736533215524677],
            [33.01655583949261, 2.741664145274692],
            [33.01736702358406, 2.742348264528985],
            [33.018034294872045, 2.743808604626888],
            [33.01782501525861, 2.747097691346204],
            [33.01741076165694, 2.74709769762719],
            [33.0203046178694, 2.756117673995739],
            [33.02101882972424, 2.760067315608151],
            [33.02180442799976, 2.761431728170467],
            [33.02307809354556, 2.766614139199535],
            [33.02599437709741, 2.773232747181172],
            [33.02875600758824, 2.782041613972408],
            [33.02968445685859, 2.783477833678681],
            [33.03027967248099, 2.786398172189177],
            [33.03150570755382, 2.788205408350147],
            [33.03141052386293, 2.789545897339212],
            [33.03243421611295, 2.791532660185887],
            [33.03279137549013, 2.793998201756357],
            [33.03361271773082, 2.795542126661775],
            [33.03356513756346, 2.796786868519191],
            [33.03624354543145, 2.804937450376404],
            [33.03882661869158, 2.808803241429971],
            [33.04118347729857, 2.810526642221477],
            [33.041040668524595, 2.81131657549578],
            [33.04173105346482, 2.811531991521933],
            [33.0446951390679, 2.817599986107547],
            [33.047909062321125, 2.819562717504038],
            [33.05280131520623, 2.821154330314188],
            [33.05287276361067, 2.821680945657977],
            [33.0510873754582, 2.823619947547214],
            [33.05032557355457, 2.823739665123645],
            [33.05023032428666, 2.823141244001992],
            [33.04984942782641, 2.823189128900413],
            [33.04806406303014, 2.825846245990714],
            [33.04773075661872, 2.825535072886079],
            [33.046611874389605, 2.826013868755703],
            [33.046659517439025, 2.826684109248563],
            [33.046088176341925, 2.827043197290161],
            [33.04635006309501, 2.827474050395659],
            [33.04570729066143, 2.827426207843367],
            [33.04402901043693, 2.829401093430532],
            [33.04393377823703, 2.829137787090796],
            [33.04343384781512, 2.829448993323443],
            [33.042648282777265, 2.830669823085614],
            [33.042695938403085, 2.831747007807276],
            [33.04233883921301, 2.831866705703345],
            [33.04226740069007, 2.83119646551459],
            [33.04181507738494, 2.831292227466832],
            [33.04150564549881, 2.832824227415899],
            [33.03914879856992, 2.832584930503231],
            [33.039101204029535, 2.833231244694408],
            [33.03747045097176, 2.833027827589223],
            [33.036970529532994, 2.833698086456825],
            [33.03620872852768, 2.833817804787206],
            [33.03594683548636, 2.833123631559234],
            [33.03573258549448, 2.833578440788629],
            [33.03537548181285, 2.833291203027791],
            [33.03463749424737, 2.833889661081003],
            [33.033875668089195, 2.833195502251605],
            [33.033518601238484, 2.834153003126482],
            [33.032280664386484, 2.834296662732232],
            [33.032518739496346, 2.83472752839325],
            [33.0316855161377, 2.834990861275887],
            [33.03061418532988, 2.833578587932192],
            [33.03037613177959, 2.834320653401061],
            [33.02959051643606, 2.834224927587902],
            [33.02987622381554, 2.835349964687367],
            [33.02954295333671, 2.836355342750697],
            [33.03025716519154, 2.83681013545712],
            [33.02925731333087, 2.837552221283305],
            [33.0286145283209, 2.837552237433127],
            [33.02892400422449, 2.837073479529392],
            [33.028662119268034, 2.836546866690874],
            [33.027781267233024, 2.836355386714231],
            [33.02615052675168, 2.836870074763515],
            [33.02579344552791, 2.837468517507126],
            [33.02510304531629, 2.837133416130513],
            [33.02465072111286, 2.83734885697627],
            [33.02398411008662, 2.836032324743794],
            [33.02362701089655, 2.836295641179569],
            [33.023254136391806, 2.836017183342586],
            [33.023174677709974, 2.835625399069206],
            [33.02272234991326, 2.835601478410244],
            [33.02291279275349, 2.834907291896719],
            [33.02222239883009, 2.83471580357376],
            [33.022222378168856, 2.833662566538211],
            [33.022627079984126, 2.833183808819195],
            [33.02157956710774, 2.832178459403316],
            [33.02181762155633, 2.831220964073483],
            [33.021174830258154, 2.830718295351915],
            [33.01812761815197, 2.831987026256475],
            [33.01749676187067, 2.832812872230763],
            [33.0164492642656, 2.831855396266959],
            [33.01537796669544, 2.832118719933524],
            [33.015258921953986, 2.831041545426929],
            [33.01371150650344, 2.831065494891131],
            [33.01318774916692, 2.830443136146316],
            [33.01078329691788, 2.830179851576553],
            [33.01014051819613, 2.829533553627428],
            [33.00790271061881, 2.829916565152543],
            [33.00712900873258, 2.830718467618002],
            [33.00662906483592, 2.830383345445538],
            [33.00505784762362, 2.831771717200797],
            [33.00529591554696, 2.832896770142723],
            [33.00479597704021, 2.833926080003736],
            [33.00401036349331, 2.83387820541805],
            [33.00384371612663, 2.834189393330017],
            [33.00355803928988, 2.835290509798607],
            [33.003986562629876, 2.836080436105144],
            [33.00331998034971, 2.83679855959632],
            [33.00274862038796, 2.836870368152641],
            [33.003474728632135, 2.838055268352193],
            [33.00249865877028, 2.83961119786568],
            [33.002879568705254, 2.841478301363789],
            [33.005593548061846, 2.843082095088149],
            [33.00666484922527, 2.843082089704901],
            [33.00723622266173, 2.844661942784351],
            [33.00778377996338, 2.844877379533655],
            [33.007236229848274, 2.845715179659822],
            [33.00673103799374, 2.845691744599151],
            [33.005998274131635, 2.845356131509511],
            [33.005165037298276, 2.845667322609664],
            [33.0030700358, 2.845475827995902],
            [33.00237964007997, 2.845930641334094],
            [33.001974923891616, 2.845236460132537],
            [33.00147498538487, 2.845882765451543],
            [33.00052273165783, 2.845318542988117],
            [32.99945141971462, 2.845510035833628],
            [32.99776114608276, 2.844049863503447],
            [32.99640416269268, 2.843810489063596],
            [32.99588040984774, 2.842948741924983],
            [32.994999567694194, 2.842589683941319],
            [32.99417824162319, 2.841213275127628],
            [32.99272603142309, 2.840543024205678],
            [32.99263081090129, 2.840040344282448],
            [32.99139286416782, 2.839992457388917],
            [32.9915119107059, 2.837957790590099],
            [32.991988051044146, 2.837479053490262],
            [32.99358309606936, 2.836665186866195],
            [32.99591614482974, 2.836449765631774],
            [32.99586853322135, 2.835157147661155],
            [32.9948448616326, 2.833696973010711],
            [32.994225887367534, 2.83364909213499],
            [32.99394020424257, 2.834247526675545],
            [32.99341646487236, 2.833792712325747],
            [32.99032160881845, 2.834726242682635],
            [32.98991690161327, 2.834199620700548],
            [32.987286276033586, 2.834139755724745],
            [32.98750053860188, 2.833469515057219],
            [32.98602452843665, 2.83406792456853],
            [32.98557220782648, 2.833445553978911],
            [32.98473898446784, 2.832966792581287],
            [32.98428666385767, 2.833182227922405],
            [32.982620226123565, 2.831817770520462],
            [32.98126324902166, 2.832248620954083],
            [32.98035861319123, 2.831219306910397],
            [32.97821603422055, 2.831075644231192],
            [32.97783512877713, 2.831267130464545],
            [32.9779541456708, 2.83205706938608],
            [32.97689475257477, 2.831853577605497],
            [32.97679951947655, 2.832356265573201],
            [32.97798979441455, 2.834917574888297],
            [32.97775171750807, 2.835635691026539],
            [32.979941903595524, 2.836736846493145],
            [32.98067989295764, 2.837885852005388],
            [32.980810807138944, 2.839262248634959],
            [32.98133454650915, 2.839549505548593],
            [32.98166782956438, 2.840459125054075],
            [32.98215578903684, 2.845282496765809],
            [32.98153679231388, 2.846814474575118],
            [32.983012800682516, 2.847628364546986],
            [32.98356036606898, 2.847101752935672],
            [32.98465547438407, 2.847460823869446],
            [32.9855601317741, 2.847293273298235],
            [32.9875122831759, 2.848274725945485],
            [32.98791699307604, 2.848897104690668],
            [32.988274109334064, 2.848083240737122],
            [32.98863120852414, 2.848107183567525],
            [32.98882166034753, 2.84882529598565],
            [32.98834550743287, 2.849878538924012],
            [32.98915493801289, 2.850093978286544],
            [32.98936920956435, 2.849710986013007],
            [32.98960727119948, 2.850213667102924],
            [32.98884542617668, 2.852272266679732],
            [32.98782173213004, 2.852391949886278],
            [32.987059908666836, 2.852056816958662],
            [32.98622670507113, 2.849495520559849],
            [32.984941139542755, 2.848801323562376],
            [32.98351271134148, 2.849686977719993],
            [32.98253660734365, 2.851075326264942],
            [32.98245327512633, 2.851901161272752],
            [32.98159621766657, 2.852260212765287],
            [32.98166762474851, 2.853385258292281],
            [32.98057250385699, 2.853528865259369],
            [32.98012017426365, 2.8531458624659],
            [32.97888217452958, 2.855252324212907],
            [32.97728710974143, 2.85525229370809],
            [32.976810975691365, 2.85479747239045],
            [32.976311028201486, 2.855012902756612],
            [32.97576347359475, 2.854701704314327],
            [32.975192097463356, 2.855036808657611],
            [32.97331137021148, 2.85407927577488],
            [32.97376372046606, 2.85302604834635],
            [32.97328759719579, 2.852523358616156],
            [32.97350191276472, 2.85003388534814],
            [32.972859151110946, 2.849148186597155],
            [32.97151406590678, 2.849112245467649],
            [32.970657032701546, 2.848465920427459],
            [32.970157081618375, 2.848537713902374],
            [32.970323755934494, 2.847580227648002],
            [32.969800021055875, 2.847053595378952],
            [32.96868109121608, 2.847316874309498],
            [32.96870493340204, 2.846096074694355],
            [32.96730033481031, 2.845928472783912],
            [32.9674670190079, 2.844683738666343],
            [32.96653856165274, 2.844540087529994],
            [32.96613392631279, 2.841835166013432],
            [32.965134079841995, 2.840542518178392],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 555,
        District: "PADER",
        County: "ARUU",
        Subcounty: "PADER",
        Population: 9494,
        Key: "PADERPADER",
        Dist2: "Pader",
        "Sub Country": "Pader S/C",
        id2_original: "Pader Pader S/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.111119906620324, 2.846703105203656],
            [33.1120483163648, 2.846176397168287],
            [33.11311965256251, 2.846511407993248],
            [33.11647667923715, 2.849192046455259],
            [33.11716714322915, 2.849838278675758],
            [33.118941156015175, 2.853775775963577],
            [33.12057219473719, 2.856324916543836],
            [33.12621500531354, 2.861446874752904],
            [33.133036215099786, 2.86569495535444],
            [33.13623897768394, 2.87159510653543],
            [33.13712030133446, 2.875377074839898],
            [33.136973469904625, 2.877265383377911],
            [33.13616063021812, 2.877667070899249],
            [33.13398863860841, 2.877667329287808],
            [33.13130570682467, 2.878695330412868],
            [33.123995217940795, 2.884065921873052],
            [33.11923414693496, 2.888255448521634],
            [33.11536536261939, 2.887807027330167],
            [33.11268704907452, 2.888256120505091],
            [33.11075278043508, 2.889303565470503],
            [33.109441267069705, 2.89103914864608],
            [33.108755330586774, 2.891118880315357],
            [33.10882850375654, 2.891431101475595],
            [33.10461686124308, 2.896190680395001],
            [33.1002713913119, 2.899822732241214],
            [33.09854153880693, 2.901971603667411],
            [33.100679294722816, 2.909236130439291],
            [33.10424179125577, 2.9159889197936],
            [33.10462810276056, 2.918019442411031],
            [33.10103397744477, 2.918659272040529],
            [33.09968079213172, 2.920091648280633],
            [33.09946721857123, 2.921309082227013],
            [33.0986837888288, 2.922096892640103],
            [33.08978059413272, 2.924604088099037],
            [33.086504241560476, 2.925964988455362],
            [33.08621940914011, 2.92696758878821],
            [33.08678931742434, 2.928113348843258],
            [33.08607716181315, 2.929688883297227],
            [33.08408282552562, 2.930190325003197],
            [33.0829433521136, 2.932482017669881],
            [33.08045034663879, 2.932052523976285],
            [33.079239498484164, 2.932410674486606],
            [33.07817105126839, 2.931981073108909],
            [33.07653287992302, 2.932983764945518],
            [33.076176721269036, 2.932697339072226],
            [33.06716754243743, 2.932311130628979],
            [33.06471134093984, 2.931177777830456],
            [33.06249667486255, 2.929032352488478],
            [33.05959738923253, 2.924336586263807],
            [33.05859057902163, 2.920409874117213],
            [33.05834878578482, 2.916361674785234],
            [33.05710048417105, 2.914013776605463],
            [33.055932625792686, 2.909844176096503],
            [33.055449219880416, 2.904905381263624],
            [33.0543215907554, 2.899683240120651],
            [33.05440189115864, 2.894946827318853],
            [33.053999182705, 2.893327561061825],
            [33.05460295388219, 2.889650555278214],
            [33.05289164889288, 2.885887771146794],
            [33.050070311876674, 2.882931644058869],
            [33.04786783683613, 2.876337022173425],
            [33.048308053546144, 2.87103489368587],
            [33.04911685440716, 2.868463880941084],
            [33.05431988126142, 2.86365412993],
            [33.05528601755287, 2.860455993059119],
            [33.05512492357128, 2.85948442895026],
            [33.05214540311501, 2.856488889563655],
            [33.050575086912936, 2.854100511625136],
            [33.04892416937198, 2.849728509312162],
            [33.04786466668147, 2.849248315550908],
            [33.04812715261085, 2.847329854192609],
            [33.04910320630306, 2.846683500338795],
            [33.048948427477896, 2.845905548238591],
            [33.04985308756288, 2.845809764169933],
            [33.050233933717465, 2.844445322576795],
            [33.05118614881697, 2.843200541997768],
            [33.05168610618831, 2.843607452442871],
            [33.05209078824068, 2.842889313446352],
            [33.053209724368685, 2.843320134631586],
            [33.053304979924775, 2.84399037317412],
            [33.0543763502585, 2.84525900068621],
            [33.05604284997637, 2.845761599381573],
            [33.055661964295886, 2.846383983073327],
            [33.056709535562774, 2.847724425701051],
            [33.05742372406143, 2.847365325241671],
            [33.059256868451016, 2.847867921223913],
            [33.05937582785251, 2.846431675007625],
            [33.058375923889535, 2.845929046099423],
            [33.058090206628584, 2.84523487925224],
            [33.0584234627344, 2.844564620797182],
            [33.059018665780414, 2.845186954891577],
            [33.05907812616736, 2.844169613060716],
            [33.05983993346091, 2.843906264326235],
            [33.06031602079856, 2.843092373520914],
            [33.05941125381405, 2.840842322273802],
            [33.05979211703664, 2.84002842661625],
            [33.0594825665729, 2.838640088994163],
            [33.06042286821509, 2.83750301627945],
            [33.060398954163894, 2.835468342406925],
            [33.06066081935745, 2.835348643088849],
            [33.061017948191896, 2.835994937792282],
            [33.061708297199544, 2.83520496387496],
            [33.0618748906673, 2.834175656945725],
            [33.06294617296611, 2.833984096724326],
            [33.06227956373649, 2.833481452529759],
            [33.06242237161213, 2.832883009518245],
            [33.06301755579353, 2.833218103153777],
            [33.06320793934494, 2.83204516150702],
            [33.063707905699474, 2.832499945140701],
            [33.06396974933343, 2.831997250954827],
            [33.06451734346603, 2.832811086767847],
            [33.0659218387515, 2.83118326563163],
            [33.0662313398079, 2.831614119890156],
            [33.06750497121774, 2.831290897788676],
            [33.06905228336201, 2.82939975477802],
            [33.07055210247555, 2.829639043376333],
            [33.07181381863145, 2.829184155439426],
            [33.072742310122564, 2.829878278092089],
            [33.07255188165539, 2.830309161546852],
            [33.07307564977168, 2.830596377616748],
            [33.073075684806, 2.831146934550066],
            [33.073956533247724, 2.83138624880697],
            [33.07459930747792, 2.831266522150271],
            [33.07505157239254, 2.830452626035592],
            [33.07619430399409, 2.830739799900619],
            [33.076777402241646, 2.828262252190421],
            [33.07749155929926, 2.827711648128842],
            [33.078824554078025, 2.825317827321693],
            [33.0785864394423, 2.82452791521276],
            [33.0790148999002, 2.823857633997228],
            [33.07961008318327, 2.824168780634671],
            [33.07956242216756, 2.82352248023467],
            [33.08046700050585, 2.822540987745999],
            [33.08191918106154, 2.822540886359508],
            [33.08225245154037, 2.82222967558311],
            [33.08325235011343, 2.822684414614361],
            [33.08403792323614, 2.822229546382591],
            [33.084597491911445, 2.823893147038407],
            [33.08614495048115, 2.824635082328196],
            [33.08602611594545, 2.827292130612038],
            [33.085478611644426, 2.827866668253079],
            [33.08690706410019, 2.828728305503479],
            [33.08622864561786, 2.829602069836808],
            [33.085038344628714, 2.82984152796794],
            [33.08487172870309, 2.830272412333599],
            [33.08530028258579, 2.830775060612537],
            [33.085300350857736, 2.831708611346645],
            [33.08572885263818, 2.831612834176084],
            [33.08589545239414, 2.830966518184576],
            [33.08644305910313, 2.831756405272388],
            [33.086157666134, 2.835610325851057],
            [33.087264789416004, 2.837178136873756],
            [33.08743155446197, 2.838734039754605],
            [33.08797917554402, 2.839643619527699],
            [33.08781259914424, 2.840601123137691],
            [33.08871734995907, 2.84179791383128],
            [33.08878882890621, 2.842635712605378],
            [33.08943160493304, 2.842492038783684],
            [33.089919697356166, 2.843246028722907],
            [33.090562429365534, 2.842647544112455],
            [33.09113386119248, 2.843533180568976],
            [33.092514670598845, 2.843772440223581],
            [33.09294316159948, 2.843389412652071],
            [33.09308604313701, 2.843892079452993],
            [33.094609625384734, 2.843293520709327],
            [33.09570475795435, 2.843580677029594],
            [33.095895338236836, 2.845064778492211],
            [33.09668100837759, 2.845663138033629],
            [33.097085820685635, 2.846836034451076],
            [33.09775240296581, 2.846764160121498],
            [33.09868101393287, 2.848511506534609],
            [33.0985858365302, 2.849062071975557],
            [33.099169142288574, 2.849480923938523],
            [33.099740450148055, 2.848810632962627],
            [33.10078801153348, 2.849552589947083],
            [33.10040717885359, 2.850414367137811],
            [33.1008120226027, 2.851874499997007],
            [33.099359886064434, 2.852903932891413],
            [33.09897903811322, 2.853622086278576],
            [33.10005035185307, 2.853669861352635],
            [33.100288495234906, 2.854435837752332],
            [33.10071701498161, 2.854483668419013],
            [33.101573918829466, 2.852784053250933],
            [33.10207385014967, 2.852568568634875],
            [33.102430967306056, 2.852760037844448],
            [33.10200248618689, 2.853262756181598],
            [33.102740569872104, 2.85400474707976],
            [33.102954736320676, 2.852975421938018],
            [33.10421648930749, 2.852807754636218],
            [33.10545414947839, 2.849528230843798],
            [33.10685869057794, 2.848833920818232],
            [33.108096754092394, 2.850006734155639],
            [33.109096561037326, 2.849216712409712],
            [33.11016787837042, 2.849240539477143],
            [33.11021529863766, 2.847277687927657],
            [33.111286636631995, 2.847540892338893],
            [33.111119906620324, 2.846703105203656],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 556,
        District: "PADER",
        County: "ARUU",
        Subcounty: "PADER TOWN COUNCIL",
        Population: 13382,
        Key: "PADERPADER TOWN COUNCIL",
        Dist2: "Pader",
        "Sub Country": "Pader T/C",
        id2_original: "Pader Pader T/C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.12350555256765, 3.070942832848224],
            [33.120004542122636, 3.067143189391478],
            [33.11638667972378, 3.064572202257142],
            [33.114413346945916, 3.063543860213231],
            [33.11187019391866, 3.062873789148287],
            [33.110412035973084, 3.061896768312455],
            [33.10743508559685, 3.061042045459184],
            [33.10494420463767, 3.060675854761696],
            [33.103486226355145, 3.06146994922765],
            [33.09801860881876, 3.062508713191156],
            [33.09589229115138, 3.062692126688719],
            [33.09413043885937, 3.062325844160937],
            [33.091943446282734, 3.063425354274673],
            [33.08927029086423, 3.062875922290468],
            [33.08732612907855, 3.061837835942926],
            [33.085380715041374, 3.059103135230744],
            [33.07996420086491, 3.056401659193127],
            [33.07468420995036, 3.050578453871109],
            [33.06180463792049, 3.048368376136708],
            [33.05909000818363, 3.045352441250199],
            [33.05666133465959, 3.046357935918184],
            [33.0535184681453, 3.050235923587945],
            [33.05094696608435, 3.052390397101415],
            [33.04780414358753, 3.058135470630837],
            [33.04551849353482, 3.063736875356723],
            [33.04280407490206, 3.065891335203969],
            [33.03825360493141, 3.066493105489943],
            [33.034525769877156, 3.066060828917192],
            [33.03146706382691, 3.066685507430746],
            [33.0298421093943, 3.066445329723841],
            [33.02845612928518, 3.066637546885302],
            [33.026640032224705, 3.067502401688378],
            [33.02265253015446, 3.06693522318922],
            [33.01987514680676, 3.068707468642557],
            [33.016284862687165, 3.071801194194138],
            [33.01327155659306, 3.073154714581447],
            [33.011540503040536, 3.073799248136609],
            [33.00284343397294, 3.075266714654521],
            [32.9992948505471, 3.074894983440014],
            [32.98980606028701, 3.075152740872898],
            [32.98318798294268, 3.07349955275233],
            [32.98093334542851, 3.077448705002635],
            [32.98086893981591, 3.079195968977285],
            [32.97906642618088, 3.080619632100884],
            [32.97887326054702, 3.082755175691716],
            [32.97777886369763, 3.08404942361124],
            [32.978036288518695, 3.087673385470405],
            [32.97526819105613, 3.086443768107613],
            [32.97095515389995, 3.083402123584918],
            [32.96850898209248, 3.081072366419109],
            [32.96316600131022, 3.07783651798902],
            [32.95878851721891, 3.078483492193758],
            [32.956985999092296, 3.079324695585385],
            [32.94900352905343, 3.080036190468941],
            [32.94127865092225, 3.07887094779006],
            [32.93863936468492, 3.077705955002035],
            [32.935549531111754, 3.075440799629955],
            [32.9342738003391, 3.07382836908678],
            [32.93510608226332, 3.071821952239131],
            [32.937169453182115, 3.068966918465061],
            [32.93097976263387, 3.062950806522651],
            [32.919715070430684, 3.054019554739402],
            [32.917818692729945, 3.053051128453719],
            [32.91702515155069, 3.048262409201234],
            [32.917339719105286, 3.042134906725566],
            [32.919923566713216, 3.037239952035776],
            [32.92063806872389, 3.034846282517515],
            [32.920733877642185, 3.02704275944387],
            [32.92175798042227, 3.023667693408675],
            [32.92936661925063, 3.005463974418181],
            [32.929497782265265, 3.002220485593359],
            [32.93133138659227, 2.99863002061582],
            [32.93196256896205, 2.986989141296803],
            [32.932832021376065, 2.980514177930225],
            [32.939488321137425, 2.95280721442654],
            [32.94129809405827, 2.947182053131545],
            [32.945666957916124, 2.948798047062657],
            [32.94942876455945, 2.948822163598961],
            [32.95208352966747, 2.947302266366603],
            [32.95710727075732, 2.945626864217566],
            [32.96080965114969, 2.942742563115964],
            [32.96409538752338, 2.939295710730959],
            [32.97010713888184, 2.937608310826441],
            [32.974868884522465, 2.937321180990328],
            [32.97574982279573, 2.936746705784151],
            [32.97164291486123, 2.93312011115701],
            [32.96713123683955, 2.931001546326536],
            [32.9654170671228, 2.929613133178049],
            [32.96417907637188, 2.927937484685455],
            [32.961976940894495, 2.923425241294326],
            [32.96276272871454, 2.920002233037747],
            [32.96740556256437, 2.912749392037248],
            [32.970738810833446, 2.90887164667844],
            [32.97191737892664, 2.906394169565723],
            [32.97288174463865, 2.900517589014609],
            [32.96935824307386, 2.897645028971548],
            [32.96469198744964, 2.89486816713846],
            [32.95851395793208, 2.892198958132883],
            [32.95522852339235, 2.891313149415468],
            [32.95535960915186, 2.88763878735839],
            [32.95475282502521, 2.879895054608776],
            [32.95605063099763, 2.8720317029058],
            [32.95869369465076, 2.859536546212628],
            [32.96202700580189, 2.849842060391924],
            [32.96308661269696, 2.843486744607743],
            [32.965134079841995, 2.840542518178392],
            [32.96613392631279, 2.841835166013432],
            [32.96653856165274, 2.844540087529994],
            [32.9674670190079, 2.844683738666343],
            [32.96730033481031, 2.845928472783912],
            [32.96870493340204, 2.846096074694355],
            [32.96868109121608, 2.847316874309498],
            [32.969800021055875, 2.847053595378952],
            [32.970323755934494, 2.847580227648002],
            [32.970157081618375, 2.848537713902374],
            [32.970657032701546, 2.848465920427459],
            [32.97151406590678, 2.849112245467649],
            [32.972859151110946, 2.849148186597155],
            [32.97350191276472, 2.85003388534814],
            [32.97328759719579, 2.852523358616156],
            [32.97376372046606, 2.85302604834635],
            [32.97331137021148, 2.85407927577488],
            [32.975192097463356, 2.855036808657611],
            [32.97576347359475, 2.854701704314327],
            [32.976311028201486, 2.855012902756612],
            [32.976810975691365, 2.85479747239045],
            [32.97728710974143, 2.85525229370809],
            [32.97888217452958, 2.855252324212907],
            [32.98012017426365, 2.8531458624659],
            [32.98057250385699, 2.853528865259369],
            [32.98166762474851, 2.853385258292281],
            [32.98159621766657, 2.852260212765287],
            [32.98245327512633, 2.851901161272752],
            [32.98253660734365, 2.851075326264942],
            [32.98351271134148, 2.849686977719993],
            [32.984941139542755, 2.848801323562376],
            [32.98622670507113, 2.849495520559849],
            [32.987059908666836, 2.852056816958662],
            [32.98782173213004, 2.852391949886278],
            [32.98884542617668, 2.852272266679732],
            [32.98960727119948, 2.850213667102924],
            [32.98936920956435, 2.849710986013007],
            [32.98915493801289, 2.850093978286544],
            [32.98834550743287, 2.849878538924012],
            [32.98882166034753, 2.84882529598565],
            [32.98863120852414, 2.848107183567525],
            [32.988274109334064, 2.848083240737122],
            [32.98791699307604, 2.848897104690668],
            [32.9875122831759, 2.848274725945485],
            [32.9855601317741, 2.847293273298235],
            [32.98465547438407, 2.847460823869446],
            [32.98356036606898, 2.847101752935672],
            [32.983012800682516, 2.847628364546986],
            [32.98153679231388, 2.846814474575118],
            [32.98215578903684, 2.845282496765809],
            [32.98166782956438, 2.840459125054075],
            [32.98133454650915, 2.839549505548593],
            [32.980810807138944, 2.839262248634959],
            [32.98067989295764, 2.837885852005388],
            [32.979941903595524, 2.836736846493145],
            [32.97775171750807, 2.835635691026539],
            [32.97798979441455, 2.834917574888297],
            [32.97679951947655, 2.832356265573201],
            [32.97689475257477, 2.831853577605497],
            [32.9779541456708, 2.83205706938608],
            [32.97783512877713, 2.831267130464545],
            [32.97821603422055, 2.831075644231192],
            [32.98035861319123, 2.831219306910397],
            [32.98126324902166, 2.832248620954083],
            [32.982620226123565, 2.831817770520462],
            [32.98428666385767, 2.833182227922405],
            [32.98473898446784, 2.832966792581287],
            [32.98557220782648, 2.833445553978911],
            [32.98602452843665, 2.83406792456853],
            [32.98750053860188, 2.833469515057219],
            [32.987286276033586, 2.834139755724745],
            [32.98991690161327, 2.834199620700548],
            [32.99032160881845, 2.834726242682635],
            [32.99341646487236, 2.833792712325747],
            [32.99394020424257, 2.834247526675545],
            [32.994225887367534, 2.83364909213499],
            [32.9948448616326, 2.833696973010711],
            [32.99586853322135, 2.835157147661155],
            [32.99591614482974, 2.836449765631774],
            [32.99358309606936, 2.836665186866195],
            [32.991988051044146, 2.837479053490262],
            [32.9915119107059, 2.837957790590099],
            [32.99139286416782, 2.839992457388917],
            [32.99263081090129, 2.840040344282448],
            [32.99272603142309, 2.840543024205678],
            [32.99417824162319, 2.841213275127628],
            [32.994999567694194, 2.842589683941319],
            [32.99588040984774, 2.842948741924983],
            [32.99640416269268, 2.843810489063596],
            [32.99776114608276, 2.844049863503447],
            [32.99945141971462, 2.845510035833628],
            [33.00052273165783, 2.845318542988117],
            [33.00147498538487, 2.845882765451543],
            [33.001974923891616, 2.845236460132537],
            [33.00237964007997, 2.845930641334094],
            [33.0030700358, 2.845475827995902],
            [33.005165037298276, 2.845667322609664],
            [33.005998274131635, 2.845356131509511],
            [33.00673103799374, 2.845691744599151],
            [33.00740693580341, 2.847625232400718],
            [33.008478245949995, 2.848295467542671],
            [33.00988286789792, 2.850138631237002],
            [33.01002571979102, 2.851215806767202],
            [33.011156568478, 2.853118808244647],
            [33.00908540018252, 2.857810534880383],
            [33.0077879229935, 2.859450257416091],
            [33.00406213699639, 2.866021057652952],
            [33.002431354294245, 2.871299236560438],
            [33.00233613467074, 2.874195647571514],
            [33.00278848402702, 2.876948433762506],
            [33.00358603708235, 2.878851442709598],
            [33.00443123947528, 2.888055329321699],
            [33.007847687909326, 2.895080900226526],
            [33.010157128045726, 2.90432066811394],
            [33.01153800392745, 2.90534995224808],
            [33.0123951152861, 2.907193116986672],
            [33.01453786852995, 2.909586821186896],
            [33.01643062602009, 2.910556253900956],
            [33.0176924841098, 2.912136088823956],
            [33.02528766168361, 2.928509036144549],
            [33.02772812020588, 2.932087597636578],
            [33.02906149407365, 2.935749959057032],
            [33.04037069869747, 2.938071526566968],
            [33.04613249292983, 2.940129904604368],
            [33.049584798516754, 2.940895742662741],
            [33.05138259150497, 2.94591051823462],
            [33.05279933442103, 2.948459762391763],
            [33.05796452513385, 2.95417558839646],
            [33.05865508973713, 2.956114468989568],
            [33.058702738176436, 2.956641093509507],
            [33.058274192378576, 2.95700017001514],
            [33.05872664054951, 2.958364568170136],
            [33.06211964475127, 2.962038753222672],
            [33.063786422946876, 2.9643126901292],
            [33.064357947300316, 2.966060070751904],
            [33.06603661200376, 2.96801085672639],
            [33.06929852505611, 2.968417588511726],
            [33.07537018236595, 2.972414704912218],
            [33.07716785138663, 2.97321648476784],
            [33.08450126437823, 2.974628232747555],
            [33.08994191089649, 2.97679412444888],
            [33.09287062803018, 2.978613109911778],
            [33.09425156679396, 2.978421490774562],
            [33.09498971156461, 2.978948044560109],
            [33.09535873409342, 2.978672733977839],
            [33.09571592221671, 2.979127512369443],
            [33.09607303847476, 2.97886417275393],
            [33.096977823425554, 2.979151340275242],
            [33.09738266807295, 2.980084852646112],
            [33.098644634858815, 2.980731041992717],
            [33.09876364995586, 2.980371976788168],
            [33.09942938512471, 2.980591497191913],
            [33.09952581657553, 2.981511708844116],
            [33.104391578142895, 2.983267238368313],
            [33.10676214593942, 2.984772138744696],
            [33.10763565604359, 2.986778890059109],
            [33.109757777680294, 2.998945131649333],
            [33.11225325082717, 3.001453424294407],
            [33.11599634735978, 3.00396157751683],
            [33.1197392561445, 3.004588307672307],
            [33.12273382428011, 3.007221945974872],
            [33.12510472624993, 3.010984491953335],
            [33.12572899788021, 3.014998091150488],
            [33.12548035139608, 3.022649180049156],
            [33.12573023935193, 3.025784831259881],
            [33.12663198170884, 3.028159616164193],
            [33.13101666400053, 3.029557564561009],
            [33.134464379196345, 3.029795702514991],
            [33.135960858373664, 3.030632416596056],
            [33.13869412635604, 3.031373057782059],
            [33.13923982414504, 3.031994792561693],
            [33.13880998656982, 3.03870430464585],
            [33.13985234581142, 3.040665357672157],
            [33.13924186511738, 3.042662813864021],
            [33.139164329728565, 3.045700598465784],
            [33.138638613166414, 3.04694456426866],
            [33.13976448339011, 3.048774037372881],
            [33.138880683982656, 3.05068786252942],
            [33.13947341576331, 3.051572693857583],
            [33.138211396875185, 3.052362429162696],
            [33.13899412952497, 3.053366791492042],
            [33.137696418773935, 3.054168500056334],
            [33.13766878300253, 3.056058135055027],
            [33.13678488028884, 3.05801978975788],
            [33.13667276784642, 3.060519402173606],
            [33.13545795991806, 3.061476551392099],
            [33.13540658706358, 3.063342278382694],
            [33.13414344168806, 3.06468214680938],
            [33.13386645964491, 3.066392467800676],
            [33.133128597843594, 3.066703643559837],
            [33.13215409284698, 3.066440837402366],
            [33.131273144692244, 3.06694340947257],
            [33.13174697097033, 3.067828278514687],
            [33.133029121103974, 3.068832498970643],
            [33.13340084037528, 3.070219789866244],
            [33.133364198094846, 3.070686504257214],
            [33.13336107195768, 3.070729308518671],
            [33.13326347898521, 3.071318408294263],
            [33.13314693425517, 3.072021903474555],
            [33.13315738256025, 3.072037712631873],
            [33.13323504730644, 3.07280304366951],
            [33.13239154183109, 3.072906304549055],
            [33.13183700821295, 3.073361630952684],
            [33.131366939587686, 3.073413556935817],
            [33.13134189186262, 3.074035468320035],
            [33.12868467345556, 3.072759693203738],
            [33.12450777059078, 3.07194396012736],
            [33.12350555256765, 3.070942832848224],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 557,
        District: "PADER",
        County: "ARUU",
        Subcounty: "PAJULE",
        Population: 22713,
        Key: "PADERPAJULE",
        Dist2: "Pader",
        "Sub Country": "Pajule S/C",
        id2_original: "Pader Pajule S/C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.03410794816715, 2.717207473890136],
            [33.03194164468982, 2.718393439020825],
            [33.0302868491218, 2.718940566672104],
            [33.027702628713044, 2.719122997535373],
            [33.02466505552985, 2.720581967877764],
            [33.023565811371185, 2.721545968585688],
            [33.02108324342168, 2.725667626150178],
            [33.019256409696965, 2.727316303350219],
            [33.01697287517673, 2.730648955949736],
            [33.01634051062406, 2.731190666445938],
            [33.01291250895714, 2.732189131797706],
            [33.01137518158723, 2.732156359923872],
            [33.00992304864226, 2.731473362751461],
            [33.00640984446557, 2.731638254093594],
            [33.0041965249629, 2.732450807860726],
            [33.00075202932904, 2.734782472329332],
            [33.00075207514313, 2.734370674365883],
            [32.99887679527515, 2.736364545465557],
            [32.99641462357414, 2.736561739504036],
            [32.99485669693646, 2.737098544535764],
            [32.99422481028751, 2.736923251654374],
            [32.99261240621775, 2.737558653457354],
            [32.990455283522635, 2.737251887875417],
            [32.989954134086865, 2.737690093889158],
            [32.98845068398297, 2.737711990457093],
            [32.982948890939916, 2.739344275596091],
            [32.981728708391174, 2.738862216976445],
            [32.98070461459426, 2.73897176072068],
            [32.97893971342017, 2.737678999795401],
            [32.97745805824168, 2.737437952677607],
            [32.97481071052296, 2.735783648999238],
            [32.972958633240445, 2.735608318239361],
            [32.97080149347731, 2.736375147856015],
            [32.968818705931064, 2.735673956910474],
            [32.9682086052244, 2.735805401138109],
            [32.966574458331486, 2.734381166406964],
            [32.965182859260246, 2.734009285272386],
            [32.96709143787917, 2.730431700105638],
            [32.968269540645075, 2.729104926033552],
            [32.96893953113344, 2.725931285765978],
            [32.96875088043218, 2.725020587260392],
            [32.96727936094504, 2.719935838814058],
            [32.96588324155128, 2.717697011255531],
            [32.96414763623523, 2.711435938623596],
            [32.96275151145158, 2.709918073017137],
            [32.96233646733243, 2.708817637589848],
            [32.95818578090091, 2.706351037877205],
            [32.957468891168226, 2.704605516299427],
            [32.9567897513387, 2.702480538779678],
            [32.956488044964004, 2.697813220309289],
            [32.95671461535, 2.693107974714096],
            [32.956240008435934, 2.691055587715713],
            [32.95534753399781, 2.690070378705805],
            [32.95435800916963, 2.689667557619047],
            [32.950399851466436, 2.688909230161392],
            [32.949104009211204, 2.689003950118467],
            [32.94631215580093, 2.687025466397688],
            [32.94631220251334, 2.685959284606818],
            [32.94289626252573, 2.678732770877216],
            [32.94294342228151, 2.677690289433153],
            [32.94016346346393, 2.674349449495036],
            [32.93858491330396, 2.674467833351395],
            [32.93820791014216, 2.675249684459229],
            [32.933566323153926, 2.678708609270111],
            [32.932305736180346, 2.680663205111177],
            [32.92789974764678, 2.683695656800961],
            [32.921149708685526, 2.682996292816666],
            [32.91679120330123, 2.680176543137957],
            [32.9125859262499, 2.676515685252592],
            [32.90759148550965, 2.671705648074358],
            [32.89959357253274, 2.661742131633228],
            [32.8980388412025, 2.658946242998443],
            [32.895388879386324, 2.652489687856436],
            [32.89258673128291, 2.635312065998008],
            [32.8926932651874, 2.629234836185644],
            [32.89328237136757, 2.62781330946598],
            [32.89299971556509, 2.627173576462112],
            [32.891656867166, 2.626770675616327],
            [32.8889005933292, 2.62468545645629],
            [32.88781690709293, 2.624235188758671],
            [32.88567300759879, 2.624163917581205],
            [32.88327009236721, 2.622623652596557],
            [32.88183298644028, 2.622505055594081],
            [32.880690559367615, 2.620408121256357],
            [32.88003093723425, 2.619957887914229],
            [32.8801627236797, 2.619005142255602],
            [32.882397043098756, 2.619118953878765],
            [32.88475251111367, 2.620747846211506],
            [32.88580763721212, 2.62067391232144],
            [32.88622502144258, 2.6180582045978],
            [32.884826435275045, 2.617342446114016],
            [32.884041320293136, 2.616379970880019],
            [32.886838813326754, 2.614109947634268],
            [32.8877221303389, 2.614554212806871],
            [32.888875156633624, 2.617293453752648],
            [32.890482247168485, 2.61868784497603],
            [32.89151281871694, 2.618860667248049],
            [32.892199917619884, 2.618293159579815],
            [32.891905736432314, 2.615134490086578],
            [32.88996737417012, 2.613875803100543],
            [32.88979565940695, 2.613382242756262],
            [32.89022546104959, 2.608854068071164],
            [32.89118261778141, 2.606509848822729],
            [32.889857639568284, 2.606065546705779],
            [32.88590706274776, 2.606608090139781],
            [32.88519556290676, 2.60567030186039],
            [32.88490126044665, 2.604041592779459],
            [32.88411614995632, 2.603103797204644],
            [32.8840671208064, 2.602634936845836],
            [32.88502415806236, 2.60169730175444],
            [32.885735753124756, 2.601549305195878],
            [32.88826301315798, 2.602561286361872],
            [32.889906999298205, 2.602758844675837],
            [32.89319512249561, 2.601377220889836],
            [32.89400502828439, 2.59932910974601],
            [32.89569818461, 2.598292817439841],
            [32.89746493182199, 2.597602012264708],
            [32.89995548130281, 2.597367780305919],
            [32.901133232827405, 2.597910761820538],
            [32.902114559630306, 2.600008378918242],
            [32.90437185525939, 2.601785297953655],
            [32.905157048394756, 2.60181002820668],
            [32.90736548375721, 2.600798439494558],
            [32.908886986405086, 2.598182799001906],
            [32.91277632866593, 2.595629011333093],
            [32.913905125600806, 2.594370560610628],
            [32.916260652904526, 2.595061678948229],
            [32.918787905751216, 2.596394395442472],
            [32.91747485536841, 2.601070589124578],
            [32.91970742666595, 2.606277570333486],
            [32.92046806614962, 2.60672180507169],
            [32.9234862069766, 2.606055714044985],
            [32.92608714233785, 2.606697469764827],
            [32.929105260706905, 2.606549582377377],
            [32.933166037456594, 2.609819505056324],
            [32.93721465011902, 2.6115470999849],
            [32.938048927201486, 2.611473111709442],
            [32.940232839455014, 2.610140667813577],
            [32.94035557088239, 2.609153587967694],
            [32.93855216881352, 2.606920237683966],
            [32.93693271746037, 2.606550001456584],
            [32.934479086042764, 2.604254921549397],
            [32.93266351719172, 2.600429896638423],
            [32.93122815669142, 2.599035577600011],
            [32.93059040494195, 2.595062552112635],
            [32.929290039669304, 2.593063650179313],
            [32.93005075640808, 2.592027256714412],
            [32.93190333315388, 2.591644862677893],
            [32.93433247020863, 2.592484014243677],
            [32.937129602119484, 2.594705081428201],
            [32.94078562225668, 2.595346859075881],
            [32.94361956083967, 2.597851698168795],
            [32.94474821224749, 2.599505102468731],
            [32.94788888148257, 2.602170348781614],
            [32.94904211888137, 2.602688613249761],
            [32.94938558793363, 2.603996507125486],
            [32.949925390079436, 2.604416035799125],
            [32.95367959877211, 2.605057780688703],
            [32.9546366036887, 2.603675903667629],
            [32.95458754938596, 2.603157685372243],
            [32.951680090883485, 2.59737083592702],
            [32.951704650823366, 2.5966058454673],
            [32.95285793852781, 2.595668165514277],
            [32.95386396540777, 2.595742232791078],
            [32.95717644372915, 2.597371036045536],
            [32.958010709133525, 2.597371063864703],
            [32.960047356070945, 2.595890516298954],
            [32.96036636669296, 2.595174895072645],
            [32.959924747712776, 2.593496845327598],
            [32.9552751989562, 2.586204644279772],
            [32.95547157337223, 2.583909695246931],
            [32.955152635513784, 2.58257713343347],
            [32.9530179617176, 2.581343206564636],
            [32.95214701450691, 2.578196853961941],
            [32.95023315828567, 2.577629211353257],
            [32.948687401125134, 2.576000474279954],
            [32.94789011846271, 2.57189172680381],
            [32.94688418590587, 2.570016235476593],
            [32.94254121418948, 2.569053641673678],
            [32.940185650054815, 2.569843195636986],
            [32.93905695462958, 2.569966532326762],
            [32.93834540538123, 2.569621013493127],
            [32.93827185761398, 2.568337809695097],
            [32.93890985101022, 2.567523507727088],
            [32.93895905173831, 2.564957099116441],
            [32.93951991488598, 2.563812713733379],
            [32.94335116489402, 2.563723453136349],
            [32.94465166401571, 2.562440309827787],
            [32.94573615244749, 2.560403642644521],
            [32.95129032625476, 2.560858143742209],
            [32.954644530422755, 2.562549199715995],
            [32.95576541948818, 2.562330517128717],
            [32.95727115221124, 2.560109642932588],
            [32.95787346362607, 2.558393485597231],
            [32.95735489406032, 2.557064279520691],
            [32.953080683887364, 2.552580208069534],
            [32.953298219916555, 2.551200554414345],
            [32.9544023886396, 2.550191080220038],
            [32.956644111074944, 2.550712740164351],
            [32.95922045864854, 2.549922040966003],
            [32.96116105502084, 2.550208127716947],
            [32.963034699955, 2.551587853333528],
            [32.964515244815814, 2.55194964015574],
            [32.966087762788646, 2.553564898044693],
            [32.96924958734868, 2.555180194286831],
            [32.970989437204445, 2.555432613082966],
            [32.97509655085312, 2.553523045812767],
            [32.977589272460285, 2.551621839701749],
            [32.979630220531305, 2.553472644724875],
            [32.980483397269005, 2.55520566043445],
            [32.982700024368555, 2.556728366788399],
            [32.98479117658584, 2.55977376151033],
            [32.98549381185162, 2.559773769587069],
            [32.989007025909764, 2.557064945406942],
            [32.99115676265662, 2.557090197033605],
            [32.99380002483744, 2.556383558728349],
            [32.995807558274834, 2.554818822983438],
            [32.998291886023985, 2.553598995641092],
            [32.998793765790055, 2.548080331641573],
            [32.99778165282407, 2.545598603223402],
            [32.996234214017335, 2.537951539340755],
            [32.99513008482015, 2.537514084099931],
            [32.99337351282538, 2.537749630106005],
            [32.99006114230181, 2.537110250205911],
            [32.98782782540262, 2.533080592424693],
            [32.98764382707624, 2.531128866285019],
            [32.988028612343356, 2.529446347704928],
            [32.988396659301756, 2.528924769813398],
            [32.993105903803915, 2.526914184982706],
            [32.99554834131476, 2.528781791397251],
            [32.9978736843266, 2.528916399386834],
            [33.00217244904956, 2.533727603428534],
            [33.00355988353115, 2.53351933878173],
            [33.006127664770226, 2.532123927271274],
            [33.00659562055792, 2.530396206859689],
            [33.00763202127423, 2.530332791099743],
            [33.00787002541718, 2.530955167878341],
            [33.008655452114496, 2.53045247092253],
            [33.01067851113495, 2.530955147237229],
            [33.01182095347901, 2.531697190860747],
            [33.01396303837625, 2.534043036364777],
            [33.01410586511653, 2.535981964271623],
            [33.015712456188105, 2.539369094113553],
            [33.017116723301505, 2.540565943614384],
            [33.0218055293343, 2.54262448838131],
            [33.02185316250223, 2.544324046365037],
            [33.023376433034585, 2.544826702029823],
            [33.02667292583549, 2.547854718451521],
            [33.027696362065626, 2.54780682814302],
            [33.02919583981936, 2.548453101262294],
            [33.02969569657941, 2.549769641901609],
            [33.030647751778794, 2.550391996749012],
            [33.03169504187299, 2.55233090097976],
            [33.03381337531414, 2.553599530505336],
            [33.03464647740021, 2.555945372964285],
            [33.039513876596345, 2.558231249122514],
            [33.043655401110264, 2.561678098299531],
            [33.046249765295215, 2.562491876307975],
            [33.04748743085602, 2.562491831437133],
            [33.05060545535941, 2.564071583249801],
            [33.05122432362328, 2.564837550830821],
            [33.05327128322015, 2.565986464548268],
            [33.05657983590375, 2.569792370715555],
            [33.05749626302062, 2.571503847118029],
            [33.05901961440135, 2.57279639964001],
            [33.06047152995402, 2.57325113414422],
            [33.061661674636284, 2.574830948030898],
            [33.06311359468055, 2.575477183282902],
            [33.06449414447382, 2.576745797033352],
            [33.06694574480052, 2.577415914891111],
            [33.06862384356535, 2.579247036586846],
            [33.06990929141443, 2.582191266289148],
            [33.070694931910786, 2.585614265114179],
            [33.07299198338108, 2.58878583597886],
            [33.081584645754795, 2.59251953765867],
            [33.10056163967514, 2.599205406184229],
            [33.09886175317142, 2.605951638776538],
            [33.095519115710985, 2.614921882861524],
            [33.09182503395523, 2.622946138393095],
            [33.09174586093768, 2.62516869615152],
            [33.089071499980044, 2.629933122366726],
            [33.08748495122077, 2.631893635446407],
            [33.08609126356649, 2.636669368779062],
            [33.08621625964671, 2.641422196592453],
            [33.08766717178124, 2.644431082416346],
            [33.08902727052872, 2.645433984407994],
            [33.09031942789466, 2.647143542523827],
            [33.07809170757093, 2.667534850494858],
            [33.076640943658425, 2.666987858583636],
            [33.07249275364507, 2.666874132110541],
            [33.0692060021751, 2.667854523112335],
            [33.06642929436056, 2.669416155909298],
            [33.06402669982751, 2.673017956954853],
            [33.06191865029973, 2.674021065424508],
            [33.06114801077032, 2.6753204403169],
            [33.06096673254261, 2.676551397402788],
            [33.05925542665498, 2.679070370197122],
            [33.05916481269396, 2.680210152731099],
            [33.05766883208166, 2.682352982011272],
            [33.05778223809806, 2.683743502438131],
            [33.05617291435139, 2.686000314946539],
            [33.04779722206826, 2.689682131084974],
            [33.04577989070606, 2.693124313173446],
            [33.04512260509078, 2.695517852927031],
            [33.04182449442404, 2.69885749176253],
            [33.040781878264276, 2.70261876853918],
            [33.03987520774969, 2.704374040506873],
            [33.04018133563222, 2.707736349807608],
            [33.038912011644165, 2.710973336863492],
            [33.035795235799014, 2.715999815217435],
            [33.03410794816715, 2.717207473890136],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 558,
        District: "PADER",
        County: "ARUU",
        Subcounty: "PURANGA",
        Population: 18917,
        Key: "PADERPURANGA",
        Dist2: "Pader",
        "Sub Country": "Puranga S/C",
        id2_original: "Pader Puranga S/C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.98935705625686, 3.659378394042657],
            [32.9945363496213, 3.661040009848765],
            [33.00921539269233, 3.66262596679449],
            [33.01205140368873, 3.664146623198564],
            [33.017197861832905, 3.66576227762264],
            [33.02786613017959, 3.670519474823716],
            [33.05013198661083, 3.675293908173534],
            [33.06791278659378, 3.680804198803219],
            [33.080439777061144, 3.683370389041152],
            [33.084585728472824, 3.684806210533051],
            [33.08899966170676, 3.685434126384815],
            [33.0998258053714, 3.688700882555301],
            [33.108403465879846, 3.699716563477937],
            [33.11074845504699, 3.70304827778242],
            [33.11223566181393, 3.706207752586127],
            [33.11774069597848, 3.713546080045327],
            [33.125633541999804, 3.722363312815757],
            [33.128622243238276, 3.727375258049854],
            [33.13980454016695, 3.742252673606414],
            [33.141434648234345, 3.743975857214814],
            [33.14596120684874, 3.747009359921257],
            [33.15216483835188, 3.754131317275086],
            [33.17364341575966, 3.78063786959889],
            [33.082404419536985, 3.850151327770524],
            [33.07182395072952, 3.856363889402124],
            [33.06338829590116, 3.864550952178703],
            [33.02849988981591, 3.890907270602603],
            [33.02749892404427, 3.890620061762698],
            [32.990124561564265, 3.867668368312801],
            [32.90190393793385, 3.812892282507568],
            [32.82242567193614, 3.791922140525061],
            [32.825340394216, 3.784041561083545],
            [32.824752895121875, 3.772713374847515],
            [32.82493227520938, 3.769410138377771],
            [32.823236007119625, 3.761815859076916],
            [32.82209267274852, 3.759697219849615],
            [32.82189699901839, 3.755191088002046],
            [32.82344306160611, 3.75282178800846],
            [32.82483839677061, 3.748969551256834],
            [32.825377798267816, 3.745976794754589],
            [32.82613850961671, 3.745754073475591],
            [32.82794621371744, 3.740023411273678],
            [32.8279147304617, 3.738940879526311],
            [32.82236942122965, 3.733081394644385],
            [32.82240164649386, 3.730438763703802],
            [32.82332125274852, 3.728019185017095],
            [32.82439915922423, 3.726427451908402],
            [32.82471677835587, 3.722988901810813],
            [32.82614346652043, 3.720569420966516],
            [32.83048598458762, 3.717959470156217],
            [32.83172224069175, 3.71684534092066],
            [32.83232466259936, 3.715540056184439],
            [32.83194518547726, 3.71108251995746],
            [32.83313773225462, 3.707058799470095],
            [32.83294778079284, 3.70351611612647],
            [32.83161477164106, 3.696622064150118],
            [32.831424627939796, 3.694132600683362],
            [32.83180618106853, 3.692409222838465],
            [32.833617739840165, 3.688483928942343],
            [32.84155863854262, 3.677536919697915],
            [32.84536383201756, 3.678659235540636],
            [32.855872128378465, 3.683829484729927],
            [32.863725791683684, 3.683080854941867],
            [32.864086224521756, 3.683404711790706],
            [32.879092885871856, 3.682967475164844],
            [32.88092979330419, 3.683222268795441],
            [32.88199807612826, 3.684004813302105],
            [32.885424422200124, 3.68405877385709],
            [32.888092706054834, 3.684604344261241],
            [32.89329338471295, 3.687558311413812],
            [32.901328822115914, 3.689052761403816],
            [32.90143262963353, 3.689913936747631],
            [32.90244558432094, 3.69082740489628],
            [32.90247149173373, 3.69145370915709],
            [32.90345852733025, 3.691871351464417],
            [32.90382212672972, 3.692445500397534],
            [32.90475578533038, 3.695008512289801],
            [32.904637163695426, 3.694511494541945],
            [32.90574102249971, 3.692871845871992],
            [32.90640900255843, 3.692684429521009],
            [32.90813202786726, 3.691095545339149],
            [32.910399286711154, 3.690272317983573],
            [32.91149366020436, 3.690587705220602],
            [32.91281718135009, 3.690320083670506],
            [32.91298913686179, 3.689248029662843],
            [32.91384862336607, 3.688870813513416],
            [32.91392459658459, 3.687941332666609],
            [32.91476382697752, 3.686824902107299],
            [32.916120488770744, 3.687093895390938],
            [32.9170281923479, 3.686597701540035],
            [32.917390843126434, 3.68550274393323],
            [32.91817804130149, 3.685292067433243],
            [32.91927171590538, 3.685750490683963],
            [32.920074575309094, 3.684765009313526],
            [32.92090804750106, 3.68484066142074],
            [32.92184002535381, 3.684249220264657],
            [32.922825066690415, 3.682537435108924],
            [32.922165624220135, 3.680960568695164],
            [32.923437131114305, 3.676663301079063],
            [32.921754459924685, 3.67484294801818],
            [32.92250058353168, 3.670805346430625],
            [32.924624960838074, 3.669957527993792],
            [32.9284143843882, 3.669642480387889],
            [32.92953865111911, 3.668694339989709],
            [32.92999749978645, 3.667409117517389],
            [32.93089285871496, 3.666996293956523],
            [32.93201953652409, 3.665547470870123],
            [32.93581388194367, 3.66420718662508],
            [32.93615257016197, 3.663135943911365],
            [32.93758915326939, 3.66164095384768],
            [32.937544613899306, 3.660996991259433],
            [32.938116811989175, 3.660904445613795],
            [32.938395076826545, 3.660011727298301],
            [32.93968607626406, 3.659064390701037],
            [32.94143544197365, 3.656927197093472],
            [32.94204143737945, 3.654760513786157],
            [32.941653931115354, 3.65360225009688],
            [32.94208479546495, 3.653175209910371],
            [32.942305503445425, 3.651864961131711],
            [32.95828240638781, 3.651097138470677],
            [32.966602536074, 3.652341994750386],
            [32.97919027331585, 3.660390817644689],
            [32.982964542287114, 3.662212478526863],
            [32.9843754389673, 3.661785016614064],
            [32.9869713222034, 3.659624193710106],
            [32.98935705625686, 3.659378394042657],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 559,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "AGORO",
        Population: 18475,
        Key: "LAMWOAGORO",
        Dist2: "Lamwo",
        "Sub Country": "Agoro",
        id2_original: "Lamwo Agoro",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.78647653336675, 3.585278120408874],
            [32.78649466226751, 3.586422646590603],
            [32.78586950849161, 3.587587736515037],
            [32.78144645915413, 3.59083157921452],
            [32.77531211920043, 3.598072158324175],
            [32.77489626300427, 3.602155537582637],
            [32.77140804816218, 3.598897681837705],
            [32.76699808278682, 3.597650304424399],
            [32.76003818929037, 3.597371546134922],
            [32.7535603982507, 3.598131410952327],
            [32.74687602074687, 3.598337281753721],
            [32.73936495422974, 3.59771202975084],
            [32.73081955761302, 3.599440442985945],
            [32.72165469445444, 3.598676080402666],
            [32.72035178784783, 3.598202134862728],
            [32.72112705370097, 3.595292306500434],
            [32.721996001261815, 3.594144415034233],
            [32.72357105338209, 3.593486610942523],
            [32.724608254497326, 3.5922348724785],
            [32.72341112541374, 3.589239075217084],
            [32.723881524618996, 3.588648655268033],
            [32.720296963666044, 3.585753803910698],
            [32.71265614628592, 3.584924637451496],
            [32.70995221728072, 3.5854552872526],
            [32.70678672130613, 3.586871130691129],
            [32.706056315521636, 3.585035650087785],
            [32.70007704275227, 3.584832141405299],
            [32.69880035437555, 3.584955852892539],
            [32.69571086845042, 3.587437478390497],
            [32.694681187132396, 3.587809530712775],
            [32.692663447935075, 3.587229567260034],
            [32.691510288689685, 3.587394686715424],
            [32.689657309498614, 3.586732017532797],
            [32.686115565845384, 3.586937690973909],
            [32.68475636810812, 3.58747512832081],
            [32.68249072892666, 3.58925357337945],
            [32.677052756692994, 3.594672105353006],
            [32.67643494574624, 3.594878773966558],
            [32.675568764996456, 3.598685189289317],
            [32.67503294957386, 3.599926319968954],
            [32.67440970471797, 3.600351780501029],
            [32.67339241026941, 3.597289357138434],
            [32.67308977234176, 3.594147577160541],
            [32.673595601101844, 3.578565049875633],
            [32.6726315569867, 3.576302694993044],
            [32.67270331171665, 3.575512816493997],
            [32.67134630497035, 3.572927171898525],
            [32.670078245810245, 3.571436666504834],
            [32.66772026430915, 3.569999623975248],
            [32.66439829977839, 3.566228400079836],
            [32.663774350643294, 3.562368400242978],
            [32.66416819721667, 3.560250156072247],
            [32.66388292013019, 3.558598429863936],
            [32.66534916470998, 3.555439338689303],
            [32.66417044749647, 3.554038618841191],
            [32.66395656671214, 3.552602351595274],
            [32.661657697051716, 3.550522593570352],
            [32.66490624766422, 3.548336283322611],
            [32.66558564261526, 3.547079859574524],
            [32.66712261245569, 3.545931457743162],
            [32.66905244341761, 3.545357682175653],
            [32.669767593113626, 3.544029453074553],
            [32.67055369534402, 3.544137447320938],
            [32.675932285344146, 3.542254350031341],
            [32.67793390157876, 3.540747045644544],
            [32.67861340971757, 3.539095656648569],
            [32.679828400902274, 3.538952459417001],
            [32.68225902916037, 3.536763099375017],
            [32.684224461255326, 3.536512441036326],
            [32.68599389173509, 3.534663936357239],
            [32.68717329705814, 3.534053948819631],
            [32.68856764497413, 3.531828320133311],
            [32.69217738031461, 3.529818845618999],
            [32.69278074455498, 3.528679931866295],
            [32.69335347893909, 3.525628197909294],
            [32.694819128834155, 3.523833432715362],
            [32.695552660755844, 3.520727888358677],
            [32.696196163519716, 3.519794572083959],
            [32.695803288923464, 3.519219961742812],
            [32.696196477930066, 3.518825137160359],
            [32.69601804287024, 3.518106976991076],
            [32.69687657356704, 3.51519895264242],
            [32.69632288436527, 3.514678151356015],
            [32.69778838603832, 3.513242425713161],
            [32.69803889473003, 3.512057645294818],
            [32.69996878947235, 3.511017020734254],
            [32.70032644202461, 3.510011802042623],
            [32.70172033269817, 3.509006906849717],
            [32.70186353673086, 3.508145229606781],
            [32.709223008052206, 3.512743404210754],
            [32.718853247935265, 3.519522660147266],
            [32.72657239661155, 3.524138699322903],
            [32.75061650138536, 3.540446417235571],
            [32.759406860495226, 3.549018578810278],
            [32.75952405380886, 3.549558862602165],
            [32.7651883538834, 3.552755683546744],
            [32.76919836953134, 3.555875702636535],
            [32.77274698709313, 3.563153849290849],
            [32.772520781423125, 3.567909242284819],
            [32.770910929467085, 3.575459037732704],
            [32.77130849416745, 3.581707769233015],
            [32.7722791804258, 3.582904847233045],
            [32.775825784863024, 3.583447508509279],
            [32.77713899065439, 3.582834316691227],
            [32.78080672122962, 3.582972248777176],
            [32.78563524223855, 3.58440358768543],
            [32.78647653336675, 3.585278120408874],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 560,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "LAMWO TOWN COUNCIL",
        Population: 7930,
        Key: "LAMWOLAMWO TOWN COUNCIL",
        Dist2: "Lamwo",
        "Sub Country": "Lamwo TC",
        id2_original: "Lamwo Lamwo TC",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.77489626300427, 3.602155537582637],
            [32.77274941344273, 3.606667032261516],
            [32.769501046984864, 3.611602935977521],
            [32.76751694340673, 3.615418918072538],
            [32.76896765611523, 3.617743375886189],
            [32.771659043740755, 3.619513117500199],
            [32.77720562139397, 3.622534400807671],
            [32.77918570231626, 3.622966357686163],
            [32.786773274752846, 3.625957079751332],
            [32.795235779326745, 3.626366765522916],
            [32.80009684090853, 3.624962779075197],
            [32.80326633977603, 3.624596433952497],
            [32.80832944144837, 3.627946429999095],
            [32.81350219238262, 3.62981325838282],
            [32.81805611637551, 3.630880328993883],
            [32.81969207966195, 3.630836235836564],
            [32.82958830081916, 3.632622136531508],
            [32.833289132515965, 3.632622830430583],
            [32.83557408906927, 3.637325666101116],
            [32.83611785727707, 3.639950369270602],
            [32.83524553294907, 3.648370812498623],
            [32.835342637238014, 3.650785955284186],
            [32.84773013640976, 3.668142705956136],
            [32.847577223385464, 3.669654091511839],
            [32.84155863854262, 3.677536919697915],
            [32.833617739840165, 3.688483928942343],
            [32.83180618106853, 3.692409222838465],
            [32.831424627939796, 3.694132600683362],
            [32.83161477164106, 3.696622064150118],
            [32.83294778079284, 3.70351611612647],
            [32.83313773225462, 3.707058799470095],
            [32.83194518547726, 3.71108251995746],
            [32.83232466259936, 3.715540056184439],
            [32.83172224069175, 3.71684534092066],
            [32.83048598458762, 3.717959470156217],
            [32.82614346652043, 3.720569420966516],
            [32.82471677835587, 3.722988901810813],
            [32.82439915922423, 3.726427451908402],
            [32.82332125274852, 3.728019185017095],
            [32.82240164649386, 3.730438763703802],
            [32.82236942122965, 3.733081394644385],
            [32.8279147304617, 3.738940879526311],
            [32.82794621371744, 3.740023411273678],
            [32.82613850961671, 3.745754073475591],
            [32.825377798267816, 3.745976794754589],
            [32.82483839677061, 3.748969551256834],
            [32.82344306160611, 3.75282178800846],
            [32.82189699901839, 3.755191088002046],
            [32.82209267274852, 3.759697219849615],
            [32.823236007119625, 3.761815859076916],
            [32.82493227520938, 3.769410138377771],
            [32.824752895121875, 3.772713374847515],
            [32.825340394216, 3.784041561083545],
            [32.82242567193614, 3.791922140525061],
            [32.75074641574173, 3.773503099392609],
            [32.72097231709664, 3.765098196676199],
            [32.558946735848735, 3.753889690563249],
            [32.559717889214504, 3.744581017152046],
            [32.560040387994775, 3.742929584319408],
            [32.56054104695039, 3.742355366960957],
            [32.560435401479715, 3.739195738585275],
            [32.54761692297401, 3.679462501330494],
            [32.54851068918953, 3.678852580475239],
            [32.54922677942163, 3.676231933002297],
            [32.55076378429635, 3.675730054874919],
            [32.55105041155069, 3.67429402601535],
            [32.5524629018422, 3.672625186878586],
            [32.55285696940112, 3.670722460393258],
            [32.55346450451935, 3.670758671600441],
            [32.55357202028245, 3.670148349449897],
            [32.55450134541017, 3.66989748670424],
            [32.55557434169456, 3.66817462046363],
            [32.555467466430244, 3.667492386657206],
            [32.556289690816556, 3.666990129786852],
            [32.556004069675325, 3.666415517108127],
            [32.55654024532232, 3.66620036267951],
            [32.55639810669155, 3.664548693918265],
            [32.563887555251355, 3.651453923391171],
            [32.57612064211059, 3.628336364651291],
            [32.58358787892669, 3.612871044438485],
            [32.58692372153028, 3.607051835333738],
            [32.5873214658937, 3.604978875641465],
            [32.60646096325232, 3.573810465189234],
            [32.60923940661202, 3.571738510420617],
            [32.613208284809815, 3.56950757612266],
            [32.61799777222303, 3.567329540589676],
            [32.619534371059224, 3.567294272927361],
            [32.622679633380365, 3.565751671799041],
            [32.62403762737515, 3.565536797420422],
            [32.62443098167178, 3.564854769684249],
            [32.62779064041019, 3.563312246052253],
            [32.62880990037259, 3.561248138695702],
            [32.630670905112396, 3.560265338784603],
            [32.63638546952036, 3.55827420470452],
            [32.64448074729767, 3.556283955734382],
            [32.6460683291195, 3.555168254000169],
            [32.648214124957214, 3.551977282693597],
            [32.65417096140405, 3.548837869677924],
            [32.65729756751337, 3.549138247003341],
            [32.661657697051716, 3.550522593570352],
            [32.66395656671214, 3.552602351595274],
            [32.66417044749647, 3.554038618841191],
            [32.66534916470998, 3.555439338689303],
            [32.66388292013019, 3.558598429863936],
            [32.66416819721667, 3.560250156072247],
            [32.663774350643294, 3.562368400242978],
            [32.66439829977839, 3.566228400079836],
            [32.66772026430915, 3.569999623975248],
            [32.670078245810245, 3.571436666504834],
            [32.67134630497035, 3.572927171898525],
            [32.67270331171665, 3.575512816493997],
            [32.6726315569867, 3.576302694993044],
            [32.673595601101844, 3.578565049875633],
            [32.67308977234176, 3.594147577160541],
            [32.67339241026941, 3.597289357138434],
            [32.67440970471797, 3.600351780501029],
            [32.67503294957386, 3.599926319968954],
            [32.675568764996456, 3.598685189289317],
            [32.67643494574624, 3.594878773966558],
            [32.677052756692994, 3.594672105353006],
            [32.68249072892666, 3.58925357337945],
            [32.68475636810812, 3.58747512832081],
            [32.686115565845384, 3.586937690973909],
            [32.689657309498614, 3.586732017532797],
            [32.691510288689685, 3.587394686715424],
            [32.692663447935075, 3.587229567260034],
            [32.694681187132396, 3.587809530712775],
            [32.69571086845042, 3.587437478390497],
            [32.69880035437555, 3.584955852892539],
            [32.70007704275227, 3.584832141405299],
            [32.706056315521636, 3.585035650087785],
            [32.70678672130613, 3.586871130691129],
            [32.70995221728072, 3.5854552872526],
            [32.71265614628592, 3.584924637451496],
            [32.720296963666044, 3.585753803910698],
            [32.723881524618996, 3.588648655268033],
            [32.72341112541374, 3.589239075217084],
            [32.724608254497326, 3.5922348724785],
            [32.72357105338209, 3.593486610942523],
            [32.721996001261815, 3.594144415034233],
            [32.72112705370097, 3.595292306500434],
            [32.72035178784783, 3.598202134862728],
            [32.72165469445444, 3.598676080402666],
            [32.73081955761302, 3.599440442985945],
            [32.73936495422974, 3.59771202975084],
            [32.74687602074687, 3.598337281753721],
            [32.7535603982507, 3.598131410952327],
            [32.76003818929037, 3.597371546134922],
            [32.76699808278682, 3.597650304424399],
            [32.77140804816218, 3.598897681837705],
            [32.77489626300427, 3.602155537582637],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 561,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "LOKUNG",
        Population: 16554,
        Key: "LAMWOLOKUNG",
        Dist2: "Lamwo",
        "Sub Country": "Lokung",
        id2_original: "Lamwo Lokung",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.96298533663184, 3.455726640467934],
            [32.93862637504589, 3.465324319356337],
            [32.91682917598661, 3.477650199681115],
            [32.89469948259287, 3.488818086533955],
            [32.88501420472898, 3.492142717881245],
            [32.885104096444536, 3.49368017256809],
            [32.88565507273414, 3.494200513907897],
            [32.885083580720085, 3.494227708262531],
            [32.88497490163867, 3.497776772352179],
            [32.88398098315046, 3.499702323141155],
            [32.88334154166996, 3.504837361132978],
            [32.88490208869334, 3.512825520045817],
            [32.884781243728035, 3.515621341902876],
            [32.881563169359886, 3.521017532388855],
            [32.88186933137838, 3.521734330143283],
            [32.881408989711026, 3.523329482799108],
            [32.880668749170816, 3.523707263472798],
            [32.88068745119672, 3.524756429373849],
            [32.87970657355147, 3.525633700436322],
            [32.879485470312275, 3.527015464901408],
            [32.87878890586118, 3.528204111315667],
            [32.877881456507275, 3.528676426112668],
            [32.87628219389179, 3.53180372255778],
            [32.894282762217436, 3.551433221189198],
            [32.87809559420974, 3.569983741200769],
            [32.867949365620724, 3.584526582880903],
            [32.86088124669213, 3.593114651484875],
            [32.852103490945716, 3.600213600905838],
            [32.84765764775621, 3.603304945761365],
            [32.84355394051911, 3.605136590964243],
            [32.838424426397815, 3.606624469209409],
            [32.837056153879544, 3.609258216911776],
            [32.83853681013142, 3.615671681401079],
            [32.838649861313314, 3.62093968682719],
            [32.83785141443427, 3.624031620929205],
            [32.83784965643125, 3.633880458829744],
            [32.83611785727707, 3.639950369270602],
            [32.83557408906927, 3.637325666101116],
            [32.833289132515965, 3.632622830430583],
            [32.82958830081916, 3.632622136531508],
            [32.81969207966195, 3.630836235836564],
            [32.81805611637551, 3.630880328993883],
            [32.81350219238262, 3.62981325838282],
            [32.80832944144837, 3.627946429999095],
            [32.80326633977603, 3.624596433952497],
            [32.80009684090853, 3.624962779075197],
            [32.795235779326745, 3.626366765522916],
            [32.786773274752846, 3.625957079751332],
            [32.77918570231626, 3.622966357686163],
            [32.77720562139397, 3.622534400807671],
            [32.771659043740755, 3.619513117500199],
            [32.76896765611523, 3.617743375886189],
            [32.76751694340673, 3.615418918072538],
            [32.769501046984864, 3.611602935977521],
            [32.77274941344273, 3.606667032261516],
            [32.77489626300427, 3.602155537582637],
            [32.77531211920043, 3.598072158324175],
            [32.78144645915413, 3.59083157921452],
            [32.78586950849161, 3.587587736515037],
            [32.78649466226751, 3.586422646590603],
            [32.78647653336675, 3.585278120408874],
            [32.78552161254163, 3.58194769510116],
            [32.785895686297295, 3.579976988687207],
            [32.78907188929176, 3.577913085553321],
            [32.79066011430734, 3.576318045097965],
            [32.79393047152336, 3.57078178953453],
            [32.79458495978488, 3.567778818535521],
            [32.79441646099041, 3.559192787219991],
            [32.795854312519005, 3.559348967414471],
            [32.80129537944883, 3.556675924873721],
            [32.80297846296516, 3.556400997783444],
            [32.80665806118357, 3.554356774697551],
            [32.810142418659865, 3.549992200643713],
            [32.812177905872225, 3.548930788055011],
            [32.81311755443923, 3.547475878951048],
            [32.814370231746736, 3.546453628534924],
            [32.82141587572525, 3.543898763244224],
            [32.82384249570057, 3.54409586493354],
            [32.82630844032575, 3.543309791769047],
            [32.83237063747732, 3.531399526574776],
            [32.83564788027998, 3.52200488485021],
            [32.837180310034945, 3.519696051391263],
            [32.83779899234755, 3.516934933012202],
            [32.840583914357055, 3.514015927612669],
            [32.846457747369975, 3.499662763382228],
            [32.847496517842, 3.498415992608209],
            [32.84501392563797, 3.49193082666076],
            [32.852800721946714, 3.497717463076991],
            [32.855378633487234, 3.496494082237504],
            [32.85874797875937, 3.496443813734093],
            [32.8593316806748, 3.496010890113348],
            [32.85672422174796, 3.489367994012407],
            [32.85300907000719, 3.482976256333416],
            [32.86076358355958, 3.478309736706394],
            [32.86097886841067, 3.472205847154463],
            [32.8598485326617, 3.463809588559205],
            [32.86650614306506, 3.460838253060669],
            [32.86591779955456, 3.459157419736934],
            [32.86644669166125, 3.457683658251897],
            [32.86566241570579, 3.45608974723171],
            [32.864963158105496, 3.456295298892189],
            [32.86523628727436, 3.454461611625658],
            [32.86349691442401, 3.453296002751052],
            [32.86342887422779, 3.452062083857384],
            [32.86218421887576, 3.4499368368546],
            [32.86153617063654, 3.449851054361504],
            [32.86139983871574, 3.449148391023281],
            [32.860956429393205, 3.44914832646175],
            [32.86068364427907, 3.448582743883439],
            [32.8591829178671, 3.448291182850991],
            [32.85928542013261, 3.447091563922503],
            [32.85824525547522, 3.44614883917973],
            [32.85819446293243, 3.443646738317387],
            [32.855551316634305, 3.442052540128115],
            [32.85512486570768, 3.442703704389923],
            [32.85355010913314, 3.44122173593851],
            [32.854462029402235, 3.438370154691571],
            [32.85519512204774, 3.433534286620787],
            [32.858241225632874, 3.409136975731351],
            [32.853113637499526, 3.408772906867461],
            [32.85008142186869, 3.409172059222587],
            [32.84312237099198, 3.409220897585228],
            [32.84028921214663, 3.40822137542812],
            [32.83944446789449, 3.406522842231201],
            [32.839693442263695, 3.403875390784512],
            [32.84178163273551, 3.400878574704186],
            [32.8511535378041, 3.395393902545844],
            [32.8510048082341, 3.395118088200866],
            [32.8558497612262, 3.393887404216703],
            [32.85743905164371, 3.392426106466393],
            [32.867456942419665, 3.39344700086584],
            [32.87327277121464, 3.391986677207651],
            [32.873466701314825, 3.391402259810466],
            [32.87606042140769, 3.391419716688355],
            [32.885714056115724, 3.394706467146831],
            [32.88765981780091, 3.397455801378164],
            [32.89121942175863, 3.401230869758921],
            [32.895301527208105, 3.408691945067034],
            [32.8959458716934, 3.408902311583779],
            [32.8982017273231, 3.411721177577825],
            [32.90062864913234, 3.413289495814925],
            [32.90089567694381, 3.414120935827771],
            [32.90158893739128, 3.414545223729115],
            [32.90154535742189, 3.415211895764219],
            [32.902979669588284, 3.416083986873974],
            [32.90423108745776, 3.418218605495381],
            [32.905377300929366, 3.418711591740232],
            [32.90951802414607, 3.418139504282487],
            [32.91176209298092, 3.417043187988887],
            [32.91271604093059, 3.417251701851056],
            [32.91439746256365, 3.415670820767816],
            [32.91470056851355, 3.414597982280685],
            [32.91529322573405, 3.414142228466213],
            [32.915985193505826, 3.414352308632866],
            [32.9156785248375, 3.418757275865491],
            [32.91463420547194, 3.419358528644505],
            [32.914353611303035, 3.420217024472126],
            [32.91492811267334, 3.420689604047845],
            [32.91469861288117, 3.422119036313945],
            [32.9152725240583, 3.422496408235717],
            [32.91530326979723, 3.423638672992686],
            [32.914732828812014, 3.423832485622857],
            [32.91431266788903, 3.425122195826298],
            [32.91597578095828, 3.425995622087967],
            [32.916827850073254, 3.42707348104471],
            [32.9184478107712, 3.427135208684509],
            [32.9200032652452, 3.428339776534689],
            [32.92543318228572, 3.430223280369284],
            [32.92593913411498, 3.431172286134959],
            [32.9266045548735, 3.430930302196008],
            [32.92660729473512, 3.431382505143066],
            [32.927929630104686, 3.431457895594415],
            [32.92802793993277, 3.431957121463298],
            [32.930484964287174, 3.432585054541831],
            [32.93058342233724, 3.433108079220519],
            [32.93122706254338, 3.433199424573657],
            [32.93127773920351, 3.433698943650827],
            [32.93462730447139, 3.436177976110942],
            [32.94008184882541, 3.438180268065131],
            [32.94308762613914, 3.437007914897232],
            [32.95054517731984, 3.436004752432578],
            [32.950151870633924, 3.437469725786402],
            [32.94922766949658, 3.438236899050547],
            [32.94904644067621, 3.43976123569307],
            [32.95063516515511, 3.444452354989866],
            [32.95240900995614, 3.446039995246176],
            [32.95327510267104, 3.447721010506405],
            [32.95571585584073, 3.45067479229941],
            [32.95681175467327, 3.451213462289443],
            [32.9579423590185, 3.452541672290352],
            [32.96298533663184, 3.455726640467934],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 562,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PADIBE EAST",
        Population: 9244,
        Key: "LAMWOPADIBE EAST",
        Dist2: "Lamwo",
        "Sub Country": "Padibe East",
        id2_original: "Lamwo Padibe East",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.85355010913314, 3.44122173593851],
            [32.85512486570768, 3.442703704389923],
            [32.855551316634305, 3.442052540128115],
            [32.85819446293243, 3.443646738317387],
            [32.85824525547522, 3.44614883917973],
            [32.85928542013261, 3.447091563922503],
            [32.8591829178671, 3.448291182850991],
            [32.86068364427907, 3.448582743883439],
            [32.860956429393205, 3.44914832646175],
            [32.86139983871574, 3.449148391023281],
            [32.86153617063654, 3.449851054361504],
            [32.86218421887576, 3.4499368368546],
            [32.86342887422779, 3.452062083857384],
            [32.86349691442401, 3.453296002751052],
            [32.86523628727436, 3.454461611625658],
            [32.864963158105496, 3.456295298892189],
            [32.86566241570579, 3.45608974723171],
            [32.86644669166125, 3.457683658251897],
            [32.86591779955456, 3.459157419736934],
            [32.86650614306506, 3.460838253060669],
            [32.8598485326617, 3.463809588559205],
            [32.86097886841067, 3.472205847154463],
            [32.86076358355958, 3.478309736706394],
            [32.85300907000719, 3.482976256333416],
            [32.85672422174796, 3.489367994012407],
            [32.8593316806748, 3.496010890113348],
            [32.85874797875937, 3.496443813734093],
            [32.855378633487234, 3.496494082237504],
            [32.852800721946714, 3.497717463076991],
            [32.84501392563797, 3.49193082666076],
            [32.847496517842, 3.498415992608209],
            [32.846457747369975, 3.499662763382228],
            [32.840583914357055, 3.514015927612669],
            [32.83779899234755, 3.516934933012202],
            [32.837180310034945, 3.519696051391263],
            [32.83564788027998, 3.52200488485021],
            [32.83237063747732, 3.531399526574776],
            [32.82630844032575, 3.543309791769047],
            [32.82384249570057, 3.54409586493354],
            [32.82141587572525, 3.543898763244224],
            [32.814370231746736, 3.546453628534924],
            [32.81311755443923, 3.547475878951048],
            [32.812177905872225, 3.548930788055011],
            [32.810142418659865, 3.549992200643713],
            [32.80665806118357, 3.554356774697551],
            [32.80297846296516, 3.556400997783444],
            [32.80129537944883, 3.556675924873721],
            [32.795854312519005, 3.559348967414471],
            [32.79441646099041, 3.559192787219991],
            [32.79506886516043, 3.542473832074969],
            [32.79864382402131, 3.535293568126815],
            [32.79909094787757, 3.533199191462017],
            [32.80028248764346, 3.531254581559216],
            [32.80086898691269, 3.529066995678047],
            [32.80204049334943, 3.528190779582201],
            [32.803666397301306, 3.524539223234202],
            [32.80704221313844, 3.521051513373242],
            [32.80775637019602, 3.51873050142731],
            [32.808354199017614, 3.518256682429544],
            [32.81030792247117, 3.518147377897557],
            [32.81101232741806, 3.517630842596179],
            [32.812002580779925, 3.515168745340105],
            [32.814684717554634, 3.51164211542321],
            [32.81653803990216, 3.508066324199486],
            [32.81722106853853, 3.505568046732879],
            [32.816928865441234, 3.503951370453779],
            [32.81517349269735, 3.505322700626713],
            [32.81209234223976, 3.506605601012511],
            [32.80489923351912, 3.508149316455159],
            [32.79730951680393, 3.508496610631584],
            [32.794333078467396, 3.508994406915294],
            [32.79071192014979, 3.508794219649102],
            [32.789868715610034, 3.508395270632477],
            [32.78937285096309, 3.507547794588061],
            [32.7897209131014, 3.503859346907322],
            [32.78962186934972, 3.503111650773691],
            [32.78897708019837, 3.502762590015841],
            [32.788928413967845, 3.498575601912169],
            [32.78972258217117, 3.496382602594354],
            [32.78992182221301, 3.492694120813279],
            [32.79031885870395, 3.491797000224582],
            [32.79437653716421, 3.486002392838211],
            [32.79781780515126, 3.482437053886856],
            [32.798359858475166, 3.481293844831364],
            [32.79957911396253, 3.480423000702614],
            [32.80001284214127, 3.47908921227267],
            [32.80109664156524, 3.478218337413182],
            [32.8014490210068, 3.477238417858522],
            [32.80288504805705, 3.476095394382285],
            [32.80377930475272, 3.474761700256547],
            [32.804592097726875, 3.474353537903027],
            [32.806311878320855, 3.472038554325383],
            [32.80805997111766, 3.471611818135119],
            [32.80685414274885, 3.467108652550406],
            [32.80699831516544, 3.463323510314126],
            [32.80654386554805, 3.461005607948098],
            [32.80493321948127, 3.458515969716237],
            [32.80275661502257, 3.451540949039645],
            [32.803052663807605, 3.448611437021471],
            [32.8086989337961, 3.447189396383687],
            [32.81914938224595, 3.445658389486046],
            [32.8272464845016, 3.445500356588538],
            [32.834707994557775, 3.448405377965497],
            [32.84366119038087, 3.456033078751908],
            [32.84451832509574, 3.457341476133927],
            [32.84767796315637, 3.4529166900362],
            [32.85355010913314, 3.44122173593851],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 563,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PADIBE TOWN COUNCIL",
        Population: 9752,
        Key: "LAMWOPADIBE TOWN COUNCIL",
        Dist2: "Lamwo",
        "Sub Country": "Padibe TC",
        id2_original: "Lamwo Padibe TC",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.73159273667973, 3.395118124967138],
              [32.73333101897533, 3.398598037598869],
              [32.73168229062873, 3.396327803100601],
              [32.73159273667973, 3.395118124967138],
            ],
          ],
          [
            [
              [32.78647653336675, 3.585278120408874],
              [32.78563524223855, 3.58440358768543],
              [32.78080672122962, 3.582972248777176],
              [32.77713899065439, 3.582834316691227],
              [32.775825784863024, 3.583447508509279],
              [32.7722791804258, 3.582904847233045],
              [32.77130849416745, 3.581707769233015],
              [32.770910929467085, 3.575459037732704],
              [32.772520781423125, 3.567909242284819],
              [32.77274698709313, 3.563153849290849],
              [32.76919836953134, 3.555875702636535],
              [32.7651883538834, 3.552755683546744],
              [32.75952405380886, 3.549558862602165],
              [32.759406860495226, 3.549018578810278],
              [32.75061650138536, 3.540446417235571],
              [32.72657239661155, 3.524138699322903],
              [32.718853247935265, 3.519522660147266],
              [32.709223008052206, 3.512743404210754],
              [32.70186353673086, 3.508145229606781],
              [32.70200598707702, 3.507131342765124],
              [32.70154895749813, 3.506039683487391],
              [32.70172203859889, 3.501099208361953],
              [32.70080866126241, 3.496790314241142],
              [32.69652306673983, 3.4897802726521],
              [32.694010002783024, 3.48219631682542],
              [32.69338231755467, 3.478519439557225],
              [32.692639497052966, 3.477312788750482],
              [32.69275456225771, 3.475072353867426],
              [32.69407054474161, 3.47174079736978],
              [32.69584512346627, 3.464502919218135],
              [32.694645414421146, 3.461859921822232],
              [32.69453427665084, 3.451863925348897],
              [32.695564116072326, 3.449336543061294],
              [32.697676017576065, 3.446807533734503],
              [32.69855547542574, 3.444943340630228],
              [32.69868655310042, 3.44216302726213],
              [32.699338047277074, 3.440625860946509],
              [32.699176330763, 3.437322094138095],
              [32.69969784410793, 3.435065264573018],
              [32.7036447567004, 3.432277286968506],
              [32.70474038244509, 3.430829525079654],
              [32.70515077598603, 3.429617866521291],
              [32.70389391073265, 3.428019909211108],
              [32.704130540453214, 3.426872490018445],
              [32.703059268035865, 3.424897374299464],
              [32.70295311322044, 3.421522258972587],
              [32.70231059950169, 3.419547286456285],
              [32.70589650702923, 3.41046754072098],
              [32.705794898587435, 3.407093528743529],
              [32.70637043302033, 3.403949980823707],
              [32.70586070736854, 3.400613627647046],
              [32.70662857739194, 3.394775516048387],
              [32.70841570108953, 3.396251685327769],
              [32.710330131334246, 3.399011044242492],
              [32.71352198387925, 3.399846051243724],
              [32.71977848752509, 3.399912054468292],
              [32.72405625502659, 3.398694295861881],
              [32.72678428942414, 3.399645436529385],
              [32.73361727253051, 3.400219599269148],
              [32.73353067673374, 3.399171818056313],
              [32.73438892895282, 3.399906990610384],
              [32.73557776299307, 3.399690109147161],
              [32.73822614557101, 3.397247228525808],
              [32.739415573397686, 3.394803944466104],
              [32.74395630922388, 3.387963063093663],
              [32.74716906197232, 3.385811833372879],
              [32.75503621707478, 3.382641437433181],
              [32.76392552830816, 3.381164291453085],
              [32.76573745089748, 3.380481950260516],
              [32.76819248458522, 3.378714669786202],
              [32.77377951247734, 3.380802722053315],
              [32.77754844635417, 3.381501296011425],
              [32.78097805870038, 3.382722861450641],
              [32.797554970675534, 3.387106935524661],
              [32.80219964337677, 3.387107899526691],
              [32.817133614850704, 3.389480604191139],
              [32.82949574829374, 3.38883657329684],
              [32.83246035581799, 3.389202205535764],
              [32.841480926185724, 3.390477517414534],
              [32.84148088396489, 3.390740476484012],
              [32.85743905164371, 3.392426106466393],
              [32.8558497612262, 3.393887404216703],
              [32.8510048082341, 3.395118088200866],
              [32.8511535378041, 3.395393902545844],
              [32.84178163273551, 3.400878574704186],
              [32.839693442263695, 3.403875390784512],
              [32.83944446789449, 3.406522842231201],
              [32.84028921214663, 3.40822137542812],
              [32.84312237099198, 3.409220897585228],
              [32.85008142186869, 3.409172059222587],
              [32.853113637499526, 3.408772906867461],
              [32.858241225632874, 3.409136975731351],
              [32.85519512204774, 3.433534286620787],
              [32.854462029402235, 3.438370154691571],
              [32.85355010913314, 3.44122173593851],
              [32.84767796315637, 3.4529166900362],
              [32.84451832509574, 3.457341476133927],
              [32.84366119038087, 3.456033078751908],
              [32.834707994557775, 3.448405377965497],
              [32.8272464845016, 3.445500356588538],
              [32.81914938224595, 3.445658389486046],
              [32.8086989337961, 3.447189396383687],
              [32.803052663807605, 3.448611437021471],
              [32.80275661502257, 3.451540949039645],
              [32.80493321948127, 3.458515969716237],
              [32.80654386554805, 3.461005607948098],
              [32.80699831516544, 3.463323510314126],
              [32.80685414274885, 3.467108652550406],
              [32.80805997111766, 3.471611818135119],
              [32.806311878320855, 3.472038554325383],
              [32.804592097726875, 3.474353537903027],
              [32.80377930475272, 3.474761700256547],
              [32.80288504805705, 3.476095394382285],
              [32.8014490210068, 3.477238417858522],
              [32.80109664156524, 3.478218337413182],
              [32.80001284214127, 3.47908921227267],
              [32.79957911396253, 3.480423000702614],
              [32.798359858475166, 3.481293844831364],
              [32.79781780515126, 3.482437053886856],
              [32.79437653716421, 3.486002392838211],
              [32.79031885870395, 3.491797000224582],
              [32.78992182221301, 3.492694120813279],
              [32.78972258217117, 3.496382602594354],
              [32.788928413967845, 3.498575601912169],
              [32.78897708019837, 3.502762590015841],
              [32.78962186934972, 3.503111650773691],
              [32.7897209131014, 3.503859346907322],
              [32.78937285096309, 3.507547794588061],
              [32.789868715610034, 3.508395270632477],
              [32.79071192014979, 3.508794219649102],
              [32.794333078467396, 3.508994406915294],
              [32.79730951680393, 3.508496610631584],
              [32.80489923351912, 3.508149316455159],
              [32.81209234223976, 3.506605601012511],
              [32.81517349269735, 3.505322700626713],
              [32.816928865441234, 3.503951370453779],
              [32.81722106853853, 3.505568046732879],
              [32.81653803990216, 3.508066324199486],
              [32.814684717554634, 3.51164211542321],
              [32.812002580779925, 3.515168745340105],
              [32.81101232741806, 3.517630842596179],
              [32.81030792247117, 3.518147377897557],
              [32.808354199017614, 3.518256682429544],
              [32.80775637019602, 3.51873050142731],
              [32.80704221313844, 3.521051513373242],
              [32.803666397301306, 3.524539223234202],
              [32.80204049334943, 3.528190779582201],
              [32.80086898691269, 3.529066995678047],
              [32.80028248764346, 3.531254581559216],
              [32.79909094787757, 3.533199191462017],
              [32.79864382402131, 3.535293568126815],
              [32.79506886516043, 3.542473832074969],
              [32.79441646099041, 3.559192787219991],
              [32.79458495978488, 3.567778818535521],
              [32.79393047152336, 3.57078178953453],
              [32.79066011430734, 3.576318045097965],
              [32.78907188929176, 3.577913085553321],
              [32.785895686297295, 3.579976988687207],
              [32.78552161254163, 3.58194769510116],
              [32.78647653336675, 3.585278120408874],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 564,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PADIBE WEST",
        Population: 12419,
        Key: "LAMWOPADIBE WEST",
        Dist2: "Lamwo",
        "Sub Country": "Padibe West",
        id2_original: "Lamwo Padibe West",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.6379218581508, 3.156902832039637],
            [32.638693822695274, 3.158709184290896],
            [32.63995281695584, 3.159613796151546],
            [32.65175493885416, 3.161595180413429],
            [32.655310521054346, 3.163762886218602],
            [32.66009461049104, 3.169648723312264],
            [32.6620967702064, 3.170575284514497],
            [32.66345851017591, 3.170374447019647],
            [32.66602242416768, 3.168000139889513],
            [32.66842520734691, 3.168524252838323],
            [32.66910545569749, 3.170376277675031],
            [32.67142791871054, 3.171624978518099],
            [32.6713071986111, 3.173436489403266],
            [32.672308204806924, 3.174161428322785],
            [32.67342962747162, 3.174041015404121],
            [32.67432676596271, 3.173169073656834],
            [32.67719237015949, 3.172122664017205],
            [32.6793349392487, 3.170271933004621],
            [32.681693347449546, 3.170574392955882],
            [32.685553092018424, 3.169325565272735],
            [32.6864105339571, 3.169972385331542],
            [32.68641001383256, 3.171696541716442],
            [32.68396508978505, 3.173850988472065],
            [32.6840077229301, 3.174669975400622],
            [32.6852934133243, 3.177213499026859],
            [32.68593548327531, 3.181049942529769],
            [32.68649256271896, 3.182343229412505],
            [32.690436863010596, 3.185275493940124],
            [32.69674330939297, 3.186377705077586],
            [32.697696604267406, 3.18723634501065],
            [32.70014256766576, 3.18747781443507],
            [32.7010404328939, 3.187026893094968],
            [32.7023031066539, 3.187217646799431],
            [32.70318345473401, 3.186580133295407],
            [32.703444318306, 3.187053986536176],
            [32.702644537428775, 3.188177761431959],
            [32.70328111957171, 3.189401148365568],
            [32.70621035862658, 3.187477567780549],
            [32.70679193063646, 3.186698599316837],
            [32.70717945307023, 3.186854537103083],
            [32.7076439503441, 3.188919379055448],
            [32.70900010638582, 3.19010069492261],
            [32.70747772788055, 3.192479028570721],
            [32.70682518357332, 3.192916030896467],
            [32.706833666364574, 3.194267087807111],
            [32.705626677372415, 3.195658323090889],
            [32.70578117143159, 3.197528292199981],
            [32.706401119470414, 3.198112822552712],
            [32.70612201560659, 3.199290504304574],
            [32.70547042531021, 3.199943522954338],
            [32.706416125827225, 3.200935152206482],
            [32.706218692297455, 3.202426472086069],
            [32.70732995232136, 3.202826859117789],
            [32.706825596798346, 3.204618724734496],
            [32.70761624899567, 3.205715541711994],
            [32.70868488126442, 3.208398065628681],
            [32.70872554350573, 3.209992908960555],
            [32.709381833787695, 3.210813584649099],
            [32.70906847985703, 3.212687646443101],
            [32.7099235457518, 3.213983598488907],
            [32.70968658545121, 3.214656981775918],
            [32.7114733498227, 3.216384824744613],
            [32.71325581306057, 3.217203597453355],
            [32.71491609464004, 3.22017540235139],
            [32.71446217592699, 3.221360389899207],
            [32.71472701274748, 3.222949370589456],
            [32.713670776331355, 3.224503912589339],
            [32.71432363235398, 3.225160482949945],
            [32.714460709876434, 3.226611480865947],
            [32.71418312057218, 3.227683128074452],
            [32.7132526473975, 3.22850106207018],
            [32.714081724132804, 3.229858759997377],
            [32.713772261703944, 3.230307778975765],
            [32.71424364456446, 3.232032298409853],
            [32.714083750732094, 3.233090646260151],
            [32.71491052059371, 3.234780649764982],
            [32.71515011026314, 3.236845990327009],
            [32.71477602752431, 3.238589297258164],
            [32.71792388956988, 3.242237940068626],
            [32.71833983559758, 3.243816808965572],
            [32.71912412772269, 3.244437657724474],
            [32.719314346882406, 3.245266661772902],
            [32.718296437986204, 3.246019908885101],
            [32.71797595053387, 3.246958578605436],
            [32.71810869458339, 3.248502929395777],
            [32.71762847948701, 3.248970111616392],
            [32.71786833685441, 3.250096691796832],
            [32.71605343365498, 3.251088584243697],
            [32.71538675435675, 3.252330802485982],
            [32.71542615087186, 3.254357647751281],
            [32.714125510714695, 3.256043937651923],
            [32.71276867644493, 3.259616955850553],
            [32.71220810435146, 3.260206872894329],
            [32.71186034674203, 3.263157161440563],
            [32.712862320423426, 3.266579531042239],
            [32.7128039559811, 3.270379366120029],
            [32.71348554282146, 3.272491583856815],
            [32.713383691834515, 3.275469805381044],
            [32.71611364683016, 3.284630843664931],
            [32.71777994083379, 3.287623420568084],
            [32.71780201693193, 3.29232530900944],
            [32.715454591533735, 3.296692823223708],
            [32.70926124214733, 3.299899512460569],
            [32.70299000074095, 3.306237309069863],
            [32.69995075040314, 3.308594432828423],
            [32.69587301795247, 3.310873913633197],
            [32.694564242652085, 3.314275273943756],
            [32.694602361762854, 3.315396321595188],
            [32.69498691885787, 3.315628379688579],
            [32.69591015789957, 3.31520344426584],
            [32.696563861931814, 3.315744836045505],
            [32.699063738620225, 3.316441418862725],
            [32.702410001681116, 3.316481092876553],
            [32.7030635826442, 3.317447701092842],
            [32.704294386872846, 3.317486727569544],
            [32.70587104967242, 3.318569580973287],
            [32.70690956232798, 3.318531234320538],
            [32.707409263679494, 3.319613764625578],
            [32.71304142113486, 3.323809440355742],
            [32.71610241968574, 3.327793003147826],
            [32.716821786971984, 3.331775884412326],
            [32.722312489414506, 3.343091874251224],
            [32.72663431568745, 3.347709377955797],
            [32.7290645055677, 3.353412523983069],
            [32.73125748721232, 3.355186248866044],
            [32.73214862226237, 3.359446775985823],
            [32.7318197562234, 3.360121694113009],
            [32.731647126975254, 3.364286651845008],
            [32.73118946049082, 3.365607844507712],
            [32.731717350975956, 3.36878200774569],
            [32.73131667271481, 3.370706417966722],
            [32.73165925782482, 3.372142716300984],
            [32.73072909007739, 3.376695239051616],
            [32.73021410029804, 3.378533442098588],
            [32.72941537134801, 3.379211017520696],
            [32.72914954817731, 3.38116599707456],
            [32.73035664676396, 3.386910427056772],
            [32.7300309751341, 3.391430280309792],
            [32.73159273667973, 3.395118124967138],
            [32.73168229062873, 3.396327803100601],
            [32.73333101897533, 3.398598037598869],
            [32.73353067673374, 3.399171818056313],
            [32.73361727253051, 3.400219599269148],
            [32.72678428942414, 3.399645436529385],
            [32.72405625502659, 3.398694295861881],
            [32.71977848752509, 3.399912054468292],
            [32.71352198387925, 3.399846051243724],
            [32.710330131334246, 3.399011044242492],
            [32.70841570108953, 3.396251685327769],
            [32.70662857739194, 3.394775516048387],
            [32.70586070736854, 3.400613627647046],
            [32.70637043302033, 3.403949980823707],
            [32.705794898587435, 3.407093528743529],
            [32.70589650702923, 3.41046754072098],
            [32.70231059950169, 3.419547286456285],
            [32.70295311322044, 3.421522258972587],
            [32.703059268035865, 3.424897374299464],
            [32.704130540453214, 3.426872490018445],
            [32.70389391073265, 3.428019909211108],
            [32.70307902468394, 3.427821968984706],
            [32.69593202199525, 3.431324055233633],
            [32.685140880287385, 3.433776443860419],
            [32.67059174169125, 3.433886418142741],
            [32.66530353748007, 3.434516498450336],
            [32.658828187163046, 3.437745634667714],
            [32.65338221812672, 3.439854875056384],
            [32.649894727326725, 3.440647535884232],
            [32.64830171159575, 3.43834454409349],
            [32.64562194188179, 3.436694454706181],
            [32.644528360702694, 3.435484709974603],
            [32.6415751006971, 3.433834508037712],
            [32.6410288279863, 3.431855390361843],
            [32.63916946177357, 3.430590382713721],
            [32.63659952817112, 3.427895887322207],
            [32.63512383331453, 3.424652108603901],
            [32.63402986046994, 3.424541750363799],
            [32.631786689052085, 3.425695250252169],
            [32.630856101791366, 3.427453921343413],
            [32.629652513820886, 3.427893212442109],
            [32.627354182251295, 3.430201042960238],
            [32.62680702290332, 3.430585615827165],
            [32.62647890246601, 3.430365609100746],
            [32.6221016348687, 3.433387213009651],
            [32.61958620205452, 3.438044680981439],
            [32.61792812134748, 3.438618491643203],
            [32.61707003890999, 3.440054335379268],
            [32.616040886699686, 3.440398605848191],
            [32.6148397259771, 3.442006650876418],
            [32.613524781047346, 3.442235907013502],
            [32.61223271980116, 3.444463571716176],
            [32.609323417057375, 3.44578244493355],
            [32.60538932971221, 3.435319931301219],
            [32.60416900702629, 3.430505250384333],
            [32.6027618365579, 3.429844630997898],
            [32.60004046586316, 3.430597815505787],
            [32.59506742029804, 3.430784294366651],
            [32.59158211240422, 3.429847205441478],
            [32.59015347399716, 3.428117363424354],
            [32.588182743638654, 3.426715306780056],
            [32.586605947888444, 3.417610364777703],
            [32.58586368254558, 3.415541932576765],
            [32.58457775948772, 3.414823281484374],
            [32.58271997969976, 3.414592689836332],
            [32.582234307338055, 3.414046720509993],
            [32.57980486036454, 3.413844591503372],
            [32.57949062069501, 3.413442324981105],
            [32.58100646305824, 3.411231261712369],
            [32.58255030231564, 3.410370223706353],
            [32.58369512070362, 3.406866432479409],
            [32.58580515550818, 3.403849440300542],
            [32.57753093602122, 3.394115532097868],
            [32.57478344052139, 3.389403116551028],
            [32.56244115445619, 3.371469841251242],
            [32.5580977308872, 3.368128068225489],
            [32.55538259719546, 3.365396934109973],
            [32.55402565692451, 3.362666419180129],
            [32.55251740083384, 3.360845796934863],
            [32.55097618825032, 3.360368435230214],
            [32.54452003942248, 3.363618206779133],
            [32.54144835720796, 3.364361466433305],
            [32.53571635650033, 3.364467430216827],
            [32.52933624197646, 3.362942717139425],
            [32.522091381312336, 3.360548032384774],
            [32.51910094093549, 3.363039423738276],
            [32.51366740548098, 3.369355875806479],
            [32.50873375553267, 3.376103392670376],
            [32.507947768286606, 3.376102992717106],
            [32.50480294164839, 3.377824791861882],
            [32.50185055211033, 3.378834864384129],
            [32.50050438174131, 3.378680427240794],
            [32.495485738590716, 3.380245993208264],
            [32.494077690468295, 3.381413698655236],
            [32.49346510412322, 3.382674065688456],
            [32.48964488902009, 3.386030612777151],
            [32.48669332323716, 3.383895063801117],
            [32.48577875383629, 3.383817983734818],
            [32.4853789604157, 3.383147551452888],
            [32.484959484907264, 3.38368349915888],
            [32.48316827297682, 3.383874034139283],
            [32.48191009708148, 3.384983988231697],
            [32.479738207879706, 3.384408361915592],
            [32.4779470453566, 3.384522283949117],
            [32.47775678577268, 3.383986010290412],
            [32.476651467206075, 3.384291793563361],
            [32.475965903523935, 3.383563767884539],
            [32.47497467010011, 3.3843291790146],
            [32.474288839618325, 3.3840990257605],
            [32.4705915742332, 3.38543742069435],
            [32.46881888197065, 3.386604527136742],
            [32.46672327860115, 3.385914005163305],
            [32.46542731327671, 3.386411160767346],
            [32.465122906566286, 3.385568440891272],
            [32.46458944652638, 3.385453255463449],
            [32.461717390629246, 3.385986117083899],
            [32.459737606150966, 3.384207694676235],
            [32.459006661377316, 3.384112495824799],
            [32.459077955271525, 3.383117238621426],
            [32.45764032203356, 3.381718278403039],
            [32.456885811755065, 3.38159936651653],
            [32.456462221962624, 3.38005878984747],
            [32.454835277761674, 3.379868292677674],
            [32.454576369822036, 3.379015036536536],
            [32.45346827635953, 3.378682644913069],
            [32.45304356367299, 3.379156355020965],
            [32.45245406672564, 3.37913232382261],
            [32.45134653471019, 3.37780463550749],
            [32.45120563755111, 3.376761865306858],
            [32.44913123711724, 3.37557581110446],
            [32.447103358635324, 3.375527259797446],
            [32.44448698303096, 3.373701055069597],
            [32.443497692663094, 3.371804689775225],
            [32.44139923265096, 3.371495414170428],
            [32.43908948888401, 3.369550888441887],
            [32.43932545385125, 3.369266655111701],
            [32.43901903491459, 3.369053200493786],
            [32.4378167351282, 3.368554857653999],
            [32.43562336361474, 3.369288203418592],
            [32.43352538060803, 3.368173200542485],
            [32.43020212699481, 3.368145328234212],
            [32.429806826048996, 3.367659197958996],
            [32.42659877777769, 3.366685512617822],
            [32.426335754655774, 3.365492700654526],
            [32.429149656316376, 3.363992495144005],
            [32.4288866313978, 3.362799684368358],
            [32.42937078740335, 3.361651483729443],
            [32.43095326230278, 3.361387377886574],
            [32.43196470243065, 3.360504519282419],
            [32.434538263430206, 3.356981108386403],
            [32.435605383834336, 3.356790237229556],
            [32.43648249079291, 3.355680114661622],
            [32.43854067214433, 3.354991952572322],
            [32.43953314973483, 3.352043621452724],
            [32.44041006355563, 3.351239874538658],
            [32.44288772311043, 3.35001577297968],
            [32.44406880738473, 3.350437725922867],
            [32.44511705059145, 3.349921304352051],
            [32.446450667902695, 3.350151849505648],
            [32.44759418553014, 3.349616329944608],
            [32.4481656344251, 3.349884738133961],
            [32.44927100329738, 3.34942578736561],
            [32.44988063149021, 3.349579326982949],
            [32.451215914277974, 3.346822652625428],
            [32.452549965475484, 3.346287234374064],
            [32.45468518005746, 3.34406717041082],
            [32.45609550091758, 3.343416898346671],
            [32.456781297263326, 3.343647068380625],
            [32.45754386273497, 3.342881535629577],
            [32.45937314347054, 3.342614464425036],
            [32.46103157541885, 3.341179224827743],
            [32.463127790541066, 3.340567615902513],
            [32.46434770988342, 3.339649141346352],
            [32.46606383792747, 3.337199027184372],
            [32.47399335317867, 3.330999090292589],
            [32.47891158085019, 3.326291094294905],
            [32.48038006582829, 3.323630174571364],
            [32.481620970714005, 3.318939351358654],
            [32.47939339674443, 3.315816908296592],
            [32.47543220812542, 3.312329711991617],
            [32.466996751824766, 3.302999697210845],
            [32.46309432380517, 3.296697618566756],
            [32.4625624007827, 3.293825005755372],
            [32.46399437732934, 3.288138576084191],
            [32.46365249919348, 3.286146905830067],
            [32.465236182326976, 3.281762673120023],
            [32.46485687049487, 3.278507168565678],
            [32.464096069314465, 3.276094001368679],
            [32.46314464383412, 3.27387222406312],
            [32.462306549810016, 3.273488797638518],
            [32.46240320763627, 3.270865451891268],
            [32.46187017519445, 3.270060918920362],
            [32.461870604589166, 3.269256663328555],
            [32.461108545767324, 3.269217956034922],
            [32.460613577639045, 3.268490035499627],
            [32.45771795713535, 3.267952297831251],
            [32.45524098658836, 3.268333924593283],
            [32.45398382309435, 3.267835374903782],
            [32.45226904162491, 3.26802591882045],
            [32.45013557067287, 3.267373687502047],
            [32.44611561067477, 3.267352319034258],
            [32.44535373600756, 3.266968923300144],
            [32.443600791409935, 3.267274329414505],
            [32.44276277733587, 3.266775989959673],
            [32.441276531766285, 3.267119837142721],
            [32.4397146965588, 3.266353015754213],
            [32.43807576254376, 3.267194634866949],
            [32.433846527423775, 3.26665609023125],
            [32.43327535520993, 3.265966413377296],
            [32.43224653357966, 3.266004125285905],
            [32.43178902340208, 3.266463431268504],
            [32.43157970605941, 3.266022894693042],
            [32.43039865951436, 3.265715842466345],
            [32.430322713245275, 3.265256224035535],
            [32.42944649741548, 3.264949344667844],
            [32.428112456099406, 3.265676240870187],
            [32.42754096318702, 3.265561015427222],
            [32.42670224213885, 3.266326488549335],
            [32.42468289855042, 3.266057245182536],
            [32.42411177754057, 3.265290962890307],
            [32.423387844117705, 3.265213953375019],
            [32.42331187898402, 3.264792640388217],
            [32.42232125012637, 3.264677170001796],
            [32.420379435638544, 3.262110121320294],
            [32.420113960115884, 3.259927013530277],
            [32.41954264866318, 3.259505414022223],
            [32.41939062497102, 3.25881597531119],
            [32.41950548985145, 3.257858606263576],
            [32.418039705209075, 3.255770544426572],
            [32.41781194096204, 3.25427681046885],
            [32.418155682203846, 3.252860010323514],
            [32.41781341419912, 3.251710887737149],
            [32.41808103849193, 3.250140848313691],
            [32.41709857801516, 3.249840139292484],
            [32.41626713332077, 3.247190822099955],
            [32.41935051878684, 3.24757411325704],
            [32.423429447793474, 3.247162505128554],
            [32.42642043883758, 3.245224138251773],
            [32.42791985281092, 3.243435521798684],
            [32.431511844627906, 3.24118585211979],
            [32.43607045513164, 3.241019472208764],
            [32.437451532235976, 3.240582910241855],
            [32.440510584137606, 3.238493631482119],
            [32.44483524010367, 3.237888124714003],
            [32.44736969743895, 3.236189111822202],
            [32.44801268906145, 3.235184213400105],
            [32.44791605908297, 3.233707679969337],
            [32.44633480768892, 3.232363778609101],
            [32.44637924105782, 3.231107198208028],
            [32.448368250335726, 3.230342152205781],
            [32.45142487498946, 3.230634458698682],
            [32.45545602260616, 3.230290005347151],
            [32.45779763680273, 3.23082435939569],
            [32.45845691128809, 3.230303308886231],
            [32.45849012919065, 3.228248624404751],
            [32.45968204624898, 3.226092175340428],
            [32.46758301483706, 3.222704537212233],
            [32.4681731001809, 3.221988893053919],
            [32.46726852992746, 3.218298704878333],
            [32.46814648489566, 3.216922893880752],
            [32.47012150470964, 3.215528916091068],
            [32.474833191731044, 3.213700765680249],
            [32.47669903659361, 3.213506438263757],
            [32.478425645282094, 3.212567742101515],
            [32.48215494908184, 3.208518755253465],
            [32.48378445976956, 3.206127686833957],
            [32.48779189096441, 3.20425940436547],
            [32.48943713564432, 3.201638883073484],
            [32.49120106843455, 3.199878677817046],
            [32.491880965543864, 3.198076427484489],
            [32.49173006025422, 3.196224220143036],
            [32.49025165428213, 3.193733562212812],
            [32.489878251567966, 3.191478728672836],
            [32.49016157841194, 3.188110374563082],
            [32.49046401152372, 3.187293258535426],
            [32.49148938811489, 3.186488053041516],
            [32.49404415186716, 3.18650596466157],
            [32.495666124791335, 3.186073280107623],
            [32.49635061229172, 3.185480072309396],
            [32.496914438981506, 3.184147398959053],
            [32.49491492121138, 3.179592910955215],
            [32.495030634999765, 3.177648380304082],
            [32.49757466747768, 3.173845753048523],
            [32.50055184333105, 3.166821173824585],
            [32.502792717756726, 3.164635453886447],
            [32.504613817535, 3.163865732748073],
            [32.50790676378716, 3.16440209019925],
            [32.51171076160447, 3.160581975787162],
            [32.51350262122022, 3.160538890846565],
            [32.51498802776332, 3.161637843744627],
            [32.51874713496923, 3.160321696436166],
            [32.52062604043773, 3.161069383975498],
            [32.522768696663526, 3.158478493977448],
            [32.52512889879998, 3.157996348778572],
            [32.528931114359736, 3.157954158887927],
            [32.52989223356033, 3.158745340365062],
            [32.53133436825618, 3.158921716690972],
            [32.5322572560566, 3.158115332925542],
            [32.533255202590574, 3.157943833186168],
            [32.53544272966479, 3.158396408633681],
            [32.53797832786047, 3.156596401776166],
            [32.53924576538643, 3.156509106784102],
            [32.54033815809443, 3.156948895908805],
            [32.54370339986233, 3.156774665654409],
            [32.54728757813295, 3.155634051311046],
            [32.54803049834767, 3.15572223705101],
            [32.54912259191667, 3.156864903523988],
            [32.54942813679256, 3.157743644430301],
            [32.551772621106494, 3.156716640022724],
            [32.55438046630891, 3.159895920884855],
            [32.55299880350301, 3.160635864474763],
            [32.554068189458285, 3.162023872141099],
            [32.556651384889285, 3.161377979048586],
            [32.562298256749, 3.161402949189144],
            [32.56420350890648, 3.159591552695164],
            [32.57077372940233, 3.15681726998485],
            [32.57685201268569, 3.155924952912752],
            [32.57777281010643, 3.156172176425514],
            [32.57973789994327, 3.154907882264626],
            [32.581395722833804, 3.154384002819806],
            [32.58633773160584, 3.154725405970455],
            [32.59171025887613, 3.153123027012792],
            [32.59373664974795, 3.152043863622895],
            [32.59877089124515, 3.152014969970605],
            [32.60202501680231, 3.151244824186894],
            [32.60429609258787, 3.152479936754389],
            [32.6050941801408, 3.15254195407599],
            [32.605585510990494, 3.152048443481499],
            [32.60653716284628, 3.151894525777291],
            [32.609483618113586, 3.153006459589124],
            [32.6145181012576, 3.152360368940898],
            [32.61996338757433, 3.155029574668456],
            [32.62425607699102, 3.154791425366374],
            [32.624911740248905, 3.15521116740999],
            [32.62568630092452, 3.156589818146046],
            [32.62664008538081, 3.156949738146745],
            [32.628308645833926, 3.159167716947438],
            [32.632303191594346, 3.159109216962819],
            [32.6379218581508, 3.156902832039637],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 565,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PALABEK GEM",
        Population: 15078,
        Key: "LAMWOPALABEK GEM",
        Dist2: "Lamwo",
        "Sub Country": "Palabek Gem",
        id2_original: "Lamwo Palabek Gem",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.661657697051716, 3.550522593570352],
            [32.65729756751337, 3.549138247003341],
            [32.65417096140405, 3.548837869677924],
            [32.648214124957214, 3.551977282693597],
            [32.6460683291195, 3.555168254000169],
            [32.64448074729767, 3.556283955734382],
            [32.63638546952036, 3.55827420470452],
            [32.630670905112396, 3.560265338784603],
            [32.62880990037259, 3.561248138695702],
            [32.62779064041019, 3.563312246052253],
            [32.62443098167178, 3.564854769684249],
            [32.62403762737515, 3.565536797420422],
            [32.622679633380365, 3.565751671799041],
            [32.619534371059224, 3.567294272927361],
            [32.61799777222303, 3.567329540589676],
            [32.613208284809815, 3.56950757612266],
            [32.60923940661202, 3.571738510420617],
            [32.60646096325232, 3.573810465189234],
            [32.5873214658937, 3.604978875641465],
            [32.58692372153028, 3.607051835333738],
            [32.58358787892669, 3.612871044438485],
            [32.57612064211059, 3.628336364651291],
            [32.563887555251355, 3.651453923391171],
            [32.55639810669155, 3.664548693918265],
            [32.55654024532232, 3.66620036267951],
            [32.556004069675325, 3.666415517108127],
            [32.556289690816556, 3.666990129786852],
            [32.555467466430244, 3.667492386657206],
            [32.55557434169456, 3.66817462046363],
            [32.55450134541017, 3.66989748670424],
            [32.55357202028245, 3.670148349449897],
            [32.55346450451935, 3.670758671600441],
            [32.55285696940112, 3.670722460393258],
            [32.5524629018422, 3.672625186878586],
            [32.55105041155069, 3.67429402601535],
            [32.55076378429635, 3.675730054874919],
            [32.54922677942163, 3.676231933002297],
            [32.54851068918953, 3.678852580475239],
            [32.54761692297401, 3.679462501330494],
            [32.560435401479715, 3.739195738585275],
            [32.56054104695039, 3.742355366960957],
            [32.560040387994775, 3.742929584319408],
            [32.559717889214504, 3.744581017152046],
            [32.558946735848735, 3.753889690563249],
            [32.486170302519156, 3.748845364964736],
            [32.46665517192954, 3.745950438917655],
            [32.430032681376034, 3.744019933108007],
            [32.42974565886297, 3.742403166580071],
            [32.430184940426805, 3.742199846968385],
            [32.431808824067566, 3.738434168620755],
            [32.4323831511647, 3.738332734254204],
            [32.43285677622016, 3.73724713561093],
            [32.43255310073837, 3.73670398663549],
            [32.432638718269764, 3.734888538557077],
            [32.431388943418945, 3.734751995980501],
            [32.43165975583269, 3.733869872265088],
            [32.43128826293685, 3.73373388978542],
            [32.43051256409575, 3.73179911436567],
            [32.43031091387403, 3.730204057033625],
            [32.43066653623375, 3.728762064827103],
            [32.43215240990081, 3.729441723592267],
            [32.43353769201899, 3.728967531773176],
            [32.43502487003983, 3.727611114679069],
            [32.43499250104522, 3.725405338945972],
            [32.435668573128034, 3.724659213957889],
            [32.43533135994343, 3.723742764308607],
            [32.43641289201963, 3.722827225364115],
            [32.43648149276461, 3.721198400604742],
            [32.436988878305094, 3.720112819347053],
            [32.43823940953737, 3.719027712752889],
            [32.4398949039947, 3.718553682058837],
            [32.440571073993894, 3.717637878655416],
            [32.44271634252051, 3.717215057309085],
            [32.44275090789603, 3.715959497012314],
            [32.44332513528015, 3.715993794296052],
            [32.443190484107284, 3.71524714768573],
            [32.44373127260324, 3.714738468918076],
            [32.44349511719315, 3.714263240979812],
            [32.44437431632803, 3.712770664928954],
            [32.44437495323358, 3.711752622958955],
            [32.44505060400651, 3.711651250956445],
            [32.444780673738386, 3.711142058254514],
            [32.44515280533639, 3.710259991567961],
            [32.44572720699367, 3.710022813436652],
            [32.4463867985843, 3.708581000666837],
            [32.448177599984675, 3.707767687990136],
            [32.44902189148592, 3.708073630440261],
            [32.449765662405184, 3.707056050998216],
            [32.450542556903926, 3.707090478610852],
            [32.451590130865775, 3.706412435027159],
            [32.45314561947577, 3.703732558677956],
            [32.45388848579156, 3.704174165970066],
            [32.45485149055593, 3.703682710388985],
            [32.455629099215294, 3.702563337800516],
            [32.45573096906684, 3.701681096716968],
            [32.457859694219216, 3.700630428517969],
            [32.45907704617646, 3.698459352181065],
            [32.46115553035164, 3.69667905123757],
            [32.463657772304174, 3.692336915136222],
            [32.46496086306542, 3.687977081499679],
            [32.46495091422367, 3.676354402015965],
            [32.46389115551332, 3.669244416507677],
            [32.46475621157234, 3.662983959167657],
            [32.46465643749039, 3.660370915728205],
            [32.4657246349745, 3.653262204392347],
            [32.46400328502373, 3.651089347058661],
            [32.46449483955393, 3.648086412052958],
            [32.463921388314205, 3.646796538590937],
            [32.463922011745, 3.645744558741424],
            [32.461121073672274, 3.641467091688795],
            [32.46151109252425, 3.638803447898017],
            [32.46087052275976, 3.636800902595987],
            [32.46173317043553, 3.63454475483403],
            [32.46102451016911, 3.633458417185549],
            [32.4611604647975, 3.632033236585593],
            [32.46051901109077, 3.631523828140101],
            [32.46021560690019, 3.630539531496748],
            [32.45954025975777, 3.630233720282759],
            [32.45906885264277, 3.627790127966511],
            [32.459204111975104, 3.627518725879204],
            [32.460791574321014, 3.627553620053638],
            [32.46177171085617, 3.626502225586778],
            [32.462989277510786, 3.623754225379419],
            [32.46341289065941, 3.621362071409381],
            [32.464427091310135, 3.619801668890333],
            [32.46500299315394, 3.616883616821529],
            [32.46456446078508, 3.615933175038579],
            [32.465562097400245, 3.613812840614847],
            [32.465327788028084, 3.610181666606742],
            [32.46461899660766, 3.609332882911348],
            [32.464503020511195, 3.605515132371735],
            [32.46591085124132, 3.594945250286623],
            [32.46699350351669, 3.591789939559385],
            [32.467468391603454, 3.588260988003017],
            [32.47175963383421, 3.58507360494649],
            [32.47328164582684, 3.581307712138768],
            [32.474094796330434, 3.576828771928396],
            [32.4745558979725, 3.567785368906912],
            [32.47427170335596, 3.56271193179371],
            [32.47748508312848, 3.554094282585497],
            [32.47806167398012, 3.549750928721747],
            [32.478028283601006, 3.54907221835154],
            [32.47691479485687, 3.547239091136287],
            [32.476732291327124, 3.541453075245782],
            [32.47612531316437, 3.539789920511492],
            [32.47511292172064, 3.538364076553159],
            [32.472007357748524, 3.53561356936914],
            [32.471197601978396, 3.534221771218157],
            [32.47033666738986, 3.533729223711985],
            [32.470134609333, 3.53271105741565],
            [32.472296689830195, 3.531626376834285],
            [32.47378352918617, 3.530134079676326],
            [32.47678914929471, 3.530407268870722],
            [32.47753351489869, 3.527964367823954],
            [32.47716298409851, 3.526233472098432],
            [32.47800790711541, 3.525148029900874],
            [32.47973005477018, 3.525590158115234],
            [32.479920515576715, 3.524801731791026],
            [32.481529036229524, 3.523761411963689],
            [32.483887713924936, 3.523116458150588],
            [32.48435272952672, 3.522219120188014],
            [32.48571092204916, 3.52153769891283],
            [32.48678278286304, 3.521717806353839],
            [32.48774686111417, 3.522974981753847],
            [32.488033523402805, 3.521503076863534],
            [32.48860545379474, 3.521108449608588],
            [32.48971295257253, 3.521468096165305],
            [32.49049921200812, 3.521181294558794],
            [32.49067742518405, 3.522007186470212],
            [32.49157062635927, 3.522187199675431],
            [32.491928049841164, 3.522007872383439],
            [32.4915352812461, 3.521469096792261],
            [32.49367952210005, 3.520895802825301],
            [32.49446630345681, 3.519639587588799],
            [32.49632458630131, 3.519245653529113],
            [32.49673595810759, 3.518402129785692],
            [32.497307795973065, 3.51815111232954],
            [32.497737465563326, 3.516499756696588],
            [32.498166403924984, 3.516212753613597],
            [32.49777415186122, 3.514704570430898],
            [32.49866763510742, 3.51438191246517],
            [32.49898988685099, 3.513125440981893],
            [32.50211904956562, 3.511901593422748],
            [32.50247584961666, 3.512871196040085],
            [32.502976158229316, 3.512763753172243],
            [32.504441747038946, 3.511651506710924],
            [32.50465658812231, 3.510789917983878],
            [32.506067928570225, 3.510916332858027],
            [32.506497257699024, 3.509875334027415],
            [32.50731923774355, 3.50958854499524],
            [32.50764131521395, 3.508655199642932],
            [32.51064359808121, 3.507077004119161],
            [32.51075194927751, 3.504850999849559],
            [32.51150319058668, 3.503163894210008],
            [32.5137364490954, 3.503075304705078],
            [32.51473730347594, 3.502357739448362],
            [32.515166896709445, 3.500778173099465],
            [32.515953298078834, 3.500168214494976],
            [32.51673928532486, 3.500384043687715],
            [32.51749167378266, 3.496520402298645],
            [32.51972200558019, 3.495142823077534],
            [32.52226631024762, 3.494655830276426],
            [32.52269594300697, 3.492961367229949],
            [32.52512620295582, 3.491899836730751],
            [32.52464050633955, 3.491411291942653],
            [32.5252124133753, 3.490980730462109],
            [32.52515590844561, 3.489659426706273],
            [32.523552457884286, 3.488926027099931],
            [32.522647289352875, 3.486375181677298],
            [32.51793535439644, 3.483184788906236],
            [32.51631113029418, 3.479862102130792],
            [32.516454390022425, 3.478715231577412],
            [32.51496029946544, 3.470900902763114],
            [32.514763366297295, 3.462276071776704],
            [32.51690784071321, 3.460926433171332],
            [32.52364774218648, 3.454160466852647],
            [32.52674851903642, 3.452784095495343],
            [32.52821789873654, 3.45141478533821],
            [32.532441206772276, 3.44260696095116],
            [32.53789976839224, 3.438391744494247],
            [32.54041853305783, 3.437602109046544],
            [32.5416508491511, 3.435613878837779],
            [32.54142717223861, 3.432342483619625],
            [32.53989257484885, 3.430644499787207],
            [32.53736833944321, 3.42861318444647],
            [32.53672562629845, 3.428474456631522],
            [32.536450415733086, 3.427920661571888],
            [32.531860436957935, 3.425242388224008],
            [32.5285090175673, 3.424825491264137],
            [32.52777425764866, 3.425148096416359],
            [32.5271328847903, 3.422287197871187],
            [32.528694992187305, 3.420073327637548],
            [32.528604249767206, 3.417858638968936],
            [32.52989019797787, 3.417028780417342],
            [32.52951380117888, 3.412486300943709],
            [32.527671554160534, 3.410718143757858],
            [32.52801529989389, 3.409167244703083],
            [32.52653002270817, 3.407098418598524],
            [32.52428711270004, 3.405445708067688],
            [32.5241446237263, 3.404583931359103],
            [32.523430286107335, 3.404152723479676],
            [32.52211732106449, 3.400446746420506],
            [32.51907449633013, 3.398075542023455],
            [32.516359931271964, 3.396609285376184],
            [32.515159542202206, 3.39649378202507],
            [32.51305940952702, 3.395214529745554],
            [32.51057323753658, 3.394294118661784],
            [32.50540020273472, 3.393717003916481],
            [32.50410001263352, 3.39315623281807],
            [32.50384315914095, 3.392409287189602],
            [32.50238579530607, 3.391805347084446],
            [32.5007177486893, 3.389897477006883],
            [32.49926610981772, 3.38991442725189],
            [32.4986948872982, 3.389109880343844],
            [32.49732302780701, 3.388994266693628],
            [32.49701867050393, 3.387998366160695],
            [32.49675206490062, 3.387691844243091],
            [32.496066026908046, 3.387844681950227],
            [32.49576165163864, 3.386887069507122],
            [32.493246766796794, 3.386311290978421],
            [32.49019787843425, 3.386654363823637],
            [32.48964488902009, 3.386030612777151],
            [32.49346510412322, 3.382674065688456],
            [32.494077690468295, 3.381413698655236],
            [32.495485738590716, 3.380245993208264],
            [32.50050438174131, 3.378680427240794],
            [32.50185055211033, 3.378834864384129],
            [32.50480294164839, 3.377824791861882],
            [32.507947768286606, 3.376102992717106],
            [32.50873375553267, 3.376103392670376],
            [32.51366740548098, 3.369355875806479],
            [32.51910094093549, 3.363039423738276],
            [32.522091381312336, 3.360548032384774],
            [32.52933624197646, 3.362942717139425],
            [32.53571635650033, 3.364467430216827],
            [32.54144835720796, 3.364361466433305],
            [32.54452003942248, 3.363618206779133],
            [32.55097618825032, 3.360368435230214],
            [32.55251740083384, 3.360845796934863],
            [32.55402565692451, 3.362666419180129],
            [32.55538259719546, 3.365396934109973],
            [32.5580977308872, 3.368128068225489],
            [32.56244115445619, 3.371469841251242],
            [32.57478344052139, 3.389403116551028],
            [32.57753093602122, 3.394115532097868],
            [32.58580515550818, 3.403849440300542],
            [32.58369512070362, 3.406866432479409],
            [32.58255030231564, 3.410370223706353],
            [32.58100646305824, 3.411231261712369],
            [32.57949062069501, 3.413442324981105],
            [32.57980486036454, 3.413844591503372],
            [32.582234307338055, 3.414046720509993],
            [32.58271997969976, 3.414592689836332],
            [32.58457775948772, 3.414823281484374],
            [32.58586368254558, 3.415541932576765],
            [32.586605947888444, 3.417610364777703],
            [32.588182743638654, 3.426715306780056],
            [32.59015347399716, 3.428117363424354],
            [32.59158211240422, 3.429847205441478],
            [32.59506742029804, 3.430784294366651],
            [32.60004046586316, 3.430597815505787],
            [32.6027618365579, 3.429844630997898],
            [32.60416900702629, 3.430505250384333],
            [32.60538932971221, 3.435319931301219],
            [32.609323417057375, 3.44578244493355],
            [32.61223271980116, 3.444463571716176],
            [32.613524781047346, 3.442235907013502],
            [32.6148397259771, 3.442006650876418],
            [32.616040886699686, 3.440398605848191],
            [32.61707003890999, 3.440054335379268],
            [32.61792812134748, 3.438618491643203],
            [32.61958620205452, 3.438044680981439],
            [32.6221016348687, 3.433387213009651],
            [32.62647890246601, 3.430365609100746],
            [32.62680702290332, 3.430585615827165],
            [32.627354182251295, 3.430201042960238],
            [32.629652513820886, 3.427893212442109],
            [32.630856101791366, 3.427453921343413],
            [32.631786689052085, 3.425695250252169],
            [32.63402986046994, 3.424541750363799],
            [32.63512383331453, 3.424652108603901],
            [32.63659952817112, 3.427895887322207],
            [32.63916946177357, 3.430590382713721],
            [32.6410288279863, 3.431855390361843],
            [32.6415751006971, 3.433834508037712],
            [32.644528360702694, 3.435484709974603],
            [32.64562194188179, 3.436694454706181],
            [32.64830171159575, 3.43834454409349],
            [32.649894727326725, 3.440647535884232],
            [32.65338221812672, 3.439854875056384],
            [32.658828187163046, 3.437745634667714],
            [32.66530353748007, 3.434516498450336],
            [32.67059174169125, 3.433886418142741],
            [32.685140880287385, 3.433776443860419],
            [32.69593202199525, 3.431324055233633],
            [32.70307902468394, 3.427821968984706],
            [32.70389391073265, 3.428019909211108],
            [32.70515077598603, 3.429617866521291],
            [32.70474038244509, 3.430829525079654],
            [32.7036447567004, 3.432277286968506],
            [32.69969784410793, 3.435065264573018],
            [32.699176330763, 3.437322094138095],
            [32.699338047277074, 3.440625860946509],
            [32.69868655310042, 3.44216302726213],
            [32.69855547542574, 3.444943340630228],
            [32.697676017576065, 3.446807533734503],
            [32.695564116072326, 3.449336543061294],
            [32.69453427665084, 3.451863925348897],
            [32.694645414421146, 3.461859921822232],
            [32.69584512346627, 3.464502919218135],
            [32.69407054474161, 3.47174079736978],
            [32.69275456225771, 3.475072353867426],
            [32.692639497052966, 3.477312788750482],
            [32.69338231755467, 3.478519439557225],
            [32.694010002783024, 3.48219631682542],
            [32.69652306673983, 3.4897802726521],
            [32.70080866126241, 3.496790314241142],
            [32.70172203859889, 3.501099208361953],
            [32.70154895749813, 3.506039683487391],
            [32.70200598707702, 3.507131342765124],
            [32.70186353673086, 3.508145229606781],
            [32.70172033269817, 3.509006906849717],
            [32.70032644202461, 3.510011802042623],
            [32.69996878947235, 3.511017020734254],
            [32.69803889473003, 3.512057645294818],
            [32.69778838603832, 3.513242425713161],
            [32.69632288436527, 3.514678151356015],
            [32.69687657356704, 3.51519895264242],
            [32.69601804287024, 3.518106976991076],
            [32.696196477930066, 3.518825137160359],
            [32.695803288923464, 3.519219961742812],
            [32.696196163519716, 3.519794572083959],
            [32.695552660755844, 3.520727888358677],
            [32.694819128834155, 3.523833432715362],
            [32.69335347893909, 3.525628197909294],
            [32.69278074455498, 3.528679931866295],
            [32.69217738031461, 3.529818845618999],
            [32.68856764497413, 3.531828320133311],
            [32.68717329705814, 3.534053948819631],
            [32.68599389173509, 3.534663936357239],
            [32.684224461255326, 3.536512441036326],
            [32.68225902916037, 3.536763099375017],
            [32.679828400902274, 3.538952459417001],
            [32.67861340971757, 3.539095656648569],
            [32.67793390157876, 3.540747045644544],
            [32.675932285344146, 3.542254350031341],
            [32.67055369534402, 3.544137447320938],
            [32.669767593113626, 3.544029453074553],
            [32.66905244341761, 3.545357682175653],
            [32.66712261245569, 3.545931457743162],
            [32.66558564261526, 3.547079859574524],
            [32.66490624766422, 3.548336283322611],
            [32.661657697051716, 3.550522593570352],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 566,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PALABEK KAL",
        Population: 14447,
        Key: "LAMWOPALABEK KAL",
        Dist2: "Lamwo",
        "Sub Country": "Palabek Kal",
        id2_original: "Lamwo Palabek Kal",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.98935705625686, 3.659378394042657],
            [32.9869713222034, 3.659624193710106],
            [32.9843754389673, 3.661785016614064],
            [32.982964542287114, 3.662212478526863],
            [32.97919027331585, 3.660390817644689],
            [32.966602536074, 3.652341994750386],
            [32.95828240638781, 3.651097138470677],
            [32.942305503445425, 3.651864961131711],
            [32.94208479546495, 3.653175209910371],
            [32.941653931115354, 3.65360225009688],
            [32.94204143737945, 3.654760513786157],
            [32.94143544197365, 3.656927197093472],
            [32.93968607626406, 3.659064390701037],
            [32.938395076826545, 3.660011727298301],
            [32.938116811989175, 3.660904445613795],
            [32.937544613899306, 3.660996991259433],
            [32.93758915326939, 3.66164095384768],
            [32.93615257016197, 3.663135943911365],
            [32.93581388194367, 3.66420718662508],
            [32.93201953652409, 3.665547470870123],
            [32.93089285871496, 3.666996293956523],
            [32.92999749978645, 3.667409117517389],
            [32.92953865111911, 3.668694339989709],
            [32.9284143843882, 3.669642480387889],
            [32.924624960838074, 3.669957527993792],
            [32.92250058353168, 3.670805346430625],
            [32.921754459924685, 3.67484294801818],
            [32.923437131114305, 3.676663301079063],
            [32.922165624220135, 3.680960568695164],
            [32.922825066690415, 3.682537435108924],
            [32.92184002535381, 3.684249220264657],
            [32.92090804750106, 3.68484066142074],
            [32.920074575309094, 3.684765009313526],
            [32.91927171590538, 3.685750490683963],
            [32.91817804130149, 3.685292067433243],
            [32.917390843126434, 3.68550274393323],
            [32.9170281923479, 3.686597701540035],
            [32.916120488770744, 3.687093895390938],
            [32.91476382697752, 3.686824902107299],
            [32.91392459658459, 3.687941332666609],
            [32.91384862336607, 3.688870813513416],
            [32.91298913686179, 3.689248029662843],
            [32.91281718135009, 3.690320083670506],
            [32.91149366020436, 3.690587705220602],
            [32.910399286711154, 3.690272317983573],
            [32.90813202786726, 3.691095545339149],
            [32.90640900255843, 3.692684429521009],
            [32.90574102249971, 3.692871845871992],
            [32.904637163695426, 3.694511494541945],
            [32.90475578533038, 3.695008512289801],
            [32.90382212672972, 3.692445500397534],
            [32.90345852733025, 3.691871351464417],
            [32.90247149173373, 3.69145370915709],
            [32.90244558432094, 3.69082740489628],
            [32.90143262963353, 3.689913936747631],
            [32.901328822115914, 3.689052761403816],
            [32.89329338471295, 3.687558311413812],
            [32.888092706054834, 3.684604344261241],
            [32.885424422200124, 3.68405877385709],
            [32.88199807612826, 3.684004813302105],
            [32.88092979330419, 3.683222268795441],
            [32.879092885871856, 3.682967475164844],
            [32.864086224521756, 3.683404711790706],
            [32.863725791683684, 3.683080854941867],
            [32.855872128378465, 3.683829484729927],
            [32.84536383201756, 3.678659235540636],
            [32.84155863854262, 3.677536919697915],
            [32.847577223385464, 3.669654091511839],
            [32.84773013640976, 3.668142705956136],
            [32.835342637238014, 3.650785955284186],
            [32.83524553294907, 3.648370812498623],
            [32.83611785727707, 3.639950369270602],
            [32.83784965643125, 3.633880458829744],
            [32.83785141443427, 3.624031620929205],
            [32.838649861313314, 3.62093968682719],
            [32.83853681013142, 3.615671681401079],
            [32.837056153879544, 3.609258216911776],
            [32.838424426397815, 3.606624469209409],
            [32.84355394051911, 3.605136590964243],
            [32.84765764775621, 3.603304945761365],
            [32.852103490945716, 3.600213600905838],
            [32.86088124669213, 3.593114651484875],
            [32.867949365620724, 3.584526582880903],
            [32.87809559420974, 3.569983741200769],
            [32.894282762217436, 3.551433221189198],
            [32.87628219389179, 3.53180372255778],
            [32.877881456507275, 3.528676426112668],
            [32.87878890586118, 3.528204111315667],
            [32.879485470312275, 3.527015464901408],
            [32.87970657355147, 3.525633700436322],
            [32.88068745119672, 3.524756429373849],
            [32.880668749170816, 3.523707263472798],
            [32.881408989711026, 3.523329482799108],
            [32.88186933137838, 3.521734330143283],
            [32.881563169359886, 3.521017532388855],
            [32.884781243728035, 3.515621341902876],
            [32.88490208869334, 3.512825520045817],
            [32.88334154166996, 3.504837361132978],
            [32.88398098315046, 3.499702323141155],
            [32.88497490163867, 3.497776772352179],
            [32.885083580720085, 3.494227708262531],
            [32.88565507273414, 3.494200513907897],
            [32.885104096444536, 3.49368017256809],
            [32.88501420472898, 3.492142717881245],
            [32.89469948259287, 3.488818086533955],
            [32.91682917598661, 3.477650199681115],
            [32.93862637504589, 3.465324319356337],
            [32.96298533663184, 3.455726640467934],
            [32.96584451158611, 3.4571880738445],
            [32.96553718535102, 3.462391160090423],
            [32.96610874563705, 3.466316852202356],
            [32.967061476369516, 3.469380824198633],
            [32.96801427178067, 3.470721329839481],
            [32.97115856571794, 3.473498125245889],
            [32.97503067020681, 3.47552389557464],
            [32.975325525130806, 3.476346987099544],
            [32.97725855948509, 3.478124896414862],
            [32.98119021329411, 3.480001613288785],
            [32.9872843428591, 3.480199255704458],
            [32.99010205517312, 3.480857756202381],
            [32.992690432086675, 3.480001773790727],
            [32.992821493591705, 3.479376231205644],
            [32.99334571805215, 3.479540851585444],
            [32.994492466919695, 3.478948238527402],
            [32.9959340868809, 3.479112863465274],
            [32.997932700047514, 3.478487326566768],
            [32.999767490150695, 3.478849485788044],
            [33.0007831766149, 3.478586097277278],
            [33.00281455493318, 3.479573794846485],
            [33.00380725350928, 3.479574281732443],
            [33.00438343652577, 3.483255836322609],
            [33.006305252718725, 3.484914964486594],
            [33.00759099880848, 3.490041966949115],
            [33.008565454397754, 3.491456312635409],
            [33.0113805463261, 3.493931398338123],
            [33.01259861963056, 3.495971306885868],
            [33.0146556439519, 3.497736841302178],
            [33.017514263747344, 3.498490794005762],
            [33.019157962426654, 3.49845486290269],
            [33.0243035015943, 3.499926866883681],
            [33.02858628708499, 3.501696235045215],
            [33.027442870967185, 3.503009435073488],
            [33.02683769662153, 3.503080990279023],
            [33.02633514671222, 3.502722222516117],
            [33.02572774364637, 3.504517514297871],
            [33.025298967879785, 3.505235629328793],
            [33.024762972794136, 3.505127928248725],
            [33.02494164321257, 3.505594699190377],
            [33.02454859434318, 3.506061475278872],
            [33.023440871884844, 3.505989697936104],
            [33.02326220416138, 3.505630650642005],
            [33.022118753009245, 3.505774301317027],
            [33.02011773505264, 3.507138753436103],
            [33.019510317613694, 3.50893404122284],
            [33.017866604561334, 3.509185410844538],
            [33.01790236559448, 3.51058572585806],
            [33.01736636242399, 3.510657543196178],
            [33.016580253905396, 3.511591098152062],
            [33.01604425432819, 3.511375678615146],
            [33.01525814221634, 3.512201518242164],
            [33.015365357043784, 3.513278679930445],
            [33.01448464963757, 3.515022597215144],
            [33.00626211741543, 3.517877911466578],
            [32.995184752695074, 3.52240201239344],
            [32.9938268709897, 3.523479168569025],
            [32.99311217045133, 3.527428767900985],
            [32.99294562189933, 3.536980751854094],
            [32.99146268033337, 3.54205481637264],
            [32.99234438666622, 3.544430781611478],
            [32.99264323370335, 3.552087379410141],
            [32.99215758469783, 3.561357321586019],
            [32.99312867250311, 3.569976751524737],
            [32.993128622197446, 3.576644605720974],
            [32.992157396949935, 3.583475082178514],
            [32.99215736101732, 3.587703475464568],
            [32.99102423959265, 3.595672360888788],
            [32.991347927742346, 3.60006338699837],
            [32.990187235224994, 3.607251914290704],
            [32.99136673576944, 3.609689600955264],
            [32.992238771738236, 3.613850665174219],
            [32.99321982275837, 3.615754621818354],
            [32.9939434444658, 3.618881507577946],
            [32.99725526611871, 3.621269959192348],
            [32.99891100222286, 3.623757636634976],
            [33.00016481140761, 3.628114990052622],
            [33.00036246232968, 3.631644637538456],
            [32.99974216394789, 3.634347739002605],
            [32.99532919550457, 3.645603760236487],
            [32.992143683268814, 3.65170383922958],
            [32.98922965628496, 3.655014786532318],
            [32.98935705625686, 3.659378394042657],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 567,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PALOGA",
        Population: 9139,
        Key: "LAMWOPALOGA",
        Dist2: "Lamwo",
        "Sub Country": "Paloga",
        id2_original: "Lamwo Paloga",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.38675845629944, 3.284608730291863],
            [32.38694993310057, 3.283038763855697],
            [32.38836120347991, 3.280703508284894],
            [32.38870508036731, 3.279171830074648],
            [32.388211284540446, 3.276605617594306],
            [32.38865037116984, 3.275131441700573],
            [32.39166423242282, 3.269082328478826],
            [32.39545922642601, 3.262937921597613],
            [32.39549824205542, 3.261406053912127],
            [32.39637567600077, 3.259644905655583],
            [32.397671644020136, 3.258879744037364],
            [32.40117758711438, 3.258154200771728],
            [32.403083588466764, 3.25673833343795],
            [32.40428491268273, 3.254919923772723],
            [32.408553929695074, 3.25243312171503],
            [32.41465323714934, 3.247572932972629],
            [32.41626713332077, 3.247190822099955],
            [32.41709857801516, 3.249840139292484],
            [32.41808103849193, 3.250140848313691],
            [32.41781341419912, 3.251710887737149],
            [32.418155682203846, 3.252860010323514],
            [32.41781194096204, 3.25427681046885],
            [32.418039705209075, 3.255770544426572],
            [32.41950548985145, 3.257858606263576],
            [32.41939062497102, 3.25881597531119],
            [32.41954264866318, 3.259505414022223],
            [32.420113960115884, 3.259927013530277],
            [32.420379435638544, 3.262110121320294],
            [32.42232125012637, 3.264677170001796],
            [32.42331187898402, 3.264792640388217],
            [32.423387844117705, 3.265213953375019],
            [32.42411177754057, 3.265290962890307],
            [32.42468289855042, 3.266057245182536],
            [32.42670224213885, 3.266326488549335],
            [32.42754096318702, 3.265561015427222],
            [32.428112456099406, 3.265676240870187],
            [32.42944649741548, 3.264949344667844],
            [32.430322713245275, 3.265256224035535],
            [32.43039865951436, 3.265715842466345],
            [32.43157970605941, 3.266022894693042],
            [32.43178902340208, 3.266463431268504],
            [32.43224653357966, 3.266004125285905],
            [32.43327535520993, 3.265966413377296],
            [32.433846527423775, 3.26665609023125],
            [32.43807576254376, 3.267194634866949],
            [32.4397146965588, 3.266353015754213],
            [32.441276531766285, 3.267119837142721],
            [32.44276277733587, 3.266775989959673],
            [32.443600791409935, 3.267274329414505],
            [32.44535373600756, 3.266968923300144],
            [32.44611561067477, 3.267352319034258],
            [32.45013557067287, 3.267373687502047],
            [32.45226904162491, 3.26802591882045],
            [32.45398382309435, 3.267835374903782],
            [32.45524098658836, 3.268333924593283],
            [32.45771795713535, 3.267952297831251],
            [32.460613577639045, 3.268490035499627],
            [32.461108545767324, 3.269217956034922],
            [32.461870604589166, 3.269256663328555],
            [32.46187017519445, 3.270060918920362],
            [32.46240320763627, 3.270865451891268],
            [32.462306549810016, 3.273488797638518],
            [32.46314464383412, 3.27387222406312],
            [32.464096069314465, 3.276094001368679],
            [32.46485687049487, 3.278507168565678],
            [32.465236182326976, 3.281762673120023],
            [32.46365249919348, 3.286146905830067],
            [32.46399437732934, 3.288138576084191],
            [32.4625624007827, 3.293825005755372],
            [32.46309432380517, 3.296697618566756],
            [32.466996751824766, 3.302999697210845],
            [32.47543220812542, 3.312329711991617],
            [32.47939339674443, 3.315816908296592],
            [32.481620970714005, 3.318939351358654],
            [32.48038006582829, 3.323630174571364],
            [32.47891158085019, 3.326291094294905],
            [32.47399335317867, 3.330999090292589],
            [32.46606383792747, 3.337199027184372],
            [32.46434770988342, 3.339649141346352],
            [32.463127790541066, 3.340567615902513],
            [32.46103157541885, 3.341179224827743],
            [32.45937314347054, 3.342614464425036],
            [32.45754386273497, 3.342881535629577],
            [32.456781297263326, 3.343647068380625],
            [32.45609550091758, 3.343416898346671],
            [32.45468518005746, 3.34406717041082],
            [32.452549965475484, 3.346287234374064],
            [32.451215914277974, 3.346822652625428],
            [32.44988063149021, 3.349579326982949],
            [32.44927100329738, 3.34942578736561],
            [32.4481656344251, 3.349884738133961],
            [32.44759418553014, 3.349616329944608],
            [32.446450667902695, 3.350151849505648],
            [32.44511705059145, 3.349921304352051],
            [32.44406880738473, 3.350437725922867],
            [32.44288772311043, 3.35001577297968],
            [32.44041006355563, 3.351239874538658],
            [32.43953314973483, 3.352043621452724],
            [32.43854067214433, 3.354991952572322],
            [32.43648249079291, 3.355680114661622],
            [32.435605383834336, 3.356790237229556],
            [32.434538263430206, 3.356981108386403],
            [32.43196470243065, 3.360504519282419],
            [32.43095326230278, 3.361387377886574],
            [32.42937078740335, 3.361651483729443],
            [32.4288866313978, 3.362799684368358],
            [32.429149656316376, 3.363992495144005],
            [32.426335754655774, 3.365492700654526],
            [32.42659877777769, 3.366685512617822],
            [32.429806826048996, 3.367659197958996],
            [32.43020212699481, 3.368145328234212],
            [32.43352538060803, 3.368173200542485],
            [32.43562336361474, 3.369288203418592],
            [32.4378167351282, 3.368554857653999],
            [32.43901903491459, 3.369053200493786],
            [32.43932545385125, 3.369266655111701],
            [32.43908948888401, 3.369550888441887],
            [32.44139923265096, 3.371495414170428],
            [32.443497692663094, 3.371804689775225],
            [32.44448698303096, 3.373701055069597],
            [32.447103358635324, 3.375527259797446],
            [32.44913123711724, 3.37557581110446],
            [32.45120563755111, 3.376761865306858],
            [32.45134653471019, 3.37780463550749],
            [32.45245406672564, 3.37913232382261],
            [32.45304356367299, 3.379156355020965],
            [32.45346827635953, 3.378682644913069],
            [32.454576369822036, 3.379015036536536],
            [32.454835277761674, 3.379868292677674],
            [32.456462221962624, 3.38005878984747],
            [32.456885811755065, 3.38159936651653],
            [32.45764032203356, 3.381718278403039],
            [32.459077955271525, 3.383117238621426],
            [32.459006661377316, 3.384112495824799],
            [32.459737606150966, 3.384207694676235],
            [32.461717390629246, 3.385986117083899],
            [32.46458944652638, 3.385453255463449],
            [32.465122906566286, 3.385568440891272],
            [32.46542731327671, 3.386411160767346],
            [32.46672327860115, 3.385914005163305],
            [32.46881888197065, 3.386604527136742],
            [32.4705915742332, 3.38543742069435],
            [32.474288839618325, 3.3840990257605],
            [32.47497467010011, 3.3843291790146],
            [32.475965903523935, 3.383563767884539],
            [32.476651467206075, 3.384291793563361],
            [32.47775678577268, 3.383986010290412],
            [32.4779470453566, 3.384522283949117],
            [32.479738207879706, 3.384408361915592],
            [32.48191009708148, 3.384983988231697],
            [32.48316827297682, 3.383874034139283],
            [32.484959484907264, 3.38368349915888],
            [32.4853789604157, 3.383147551452888],
            [32.48577875383629, 3.383817983734818],
            [32.48669332323716, 3.383895063801117],
            [32.48964488902009, 3.386030612777151],
            [32.49019787843425, 3.386654363823637],
            [32.493246766796794, 3.386311290978421],
            [32.49576165163864, 3.386887069507122],
            [32.496066026908046, 3.387844681950227],
            [32.49675206490062, 3.387691844243091],
            [32.49701867050393, 3.387998366160695],
            [32.49732302780701, 3.388994266693628],
            [32.4986948872982, 3.389109880343844],
            [32.49926610981772, 3.38991442725189],
            [32.5007177486893, 3.389897477006883],
            [32.50238579530607, 3.391805347084446],
            [32.50384315914095, 3.392409287189602],
            [32.50410001263352, 3.39315623281807],
            [32.50540020273472, 3.393717003916481],
            [32.51057323753658, 3.394294118661784],
            [32.51305940952702, 3.395214529745554],
            [32.515159542202206, 3.39649378202507],
            [32.516359931271964, 3.396609285376184],
            [32.51907449633013, 3.398075542023455],
            [32.52211732106449, 3.400446746420506],
            [32.523430286107335, 3.404152723479676],
            [32.5241446237263, 3.404583931359103],
            [32.52428711270004, 3.405445708067688],
            [32.52653002270817, 3.407098418598524],
            [32.52801529989389, 3.409167244703083],
            [32.527671554160534, 3.410718143757858],
            [32.52951380117888, 3.412486300943709],
            [32.52989019797787, 3.417028780417342],
            [32.528604249767206, 3.417858638968936],
            [32.528694992187305, 3.420073327637548],
            [32.5271328847903, 3.422287197871187],
            [32.52777425764866, 3.425148096416359],
            [32.5285090175673, 3.424825491264137],
            [32.531860436957935, 3.425242388224008],
            [32.536450415733086, 3.427920661571888],
            [32.53672562629845, 3.428474456631522],
            [32.53736833944321, 3.42861318444647],
            [32.53989257484885, 3.430644499787207],
            [32.54142717223861, 3.432342483619625],
            [32.5416508491511, 3.435613878837779],
            [32.54041853305783, 3.437602109046544],
            [32.53789976839224, 3.438391744494247],
            [32.532441206772276, 3.44260696095116],
            [32.52821789873654, 3.45141478533821],
            [32.52674851903642, 3.452784095495343],
            [32.52364774218648, 3.454160466852647],
            [32.51690784071321, 3.460926433171332],
            [32.514763366297295, 3.462276071776704],
            [32.51496029946544, 3.470900902763114],
            [32.516454390022425, 3.478715231577412],
            [32.51631113029418, 3.479862102130792],
            [32.51793535439644, 3.483184788906236],
            [32.522647289352875, 3.486375181677298],
            [32.523552457884286, 3.488926027099931],
            [32.52515590844561, 3.489659426706273],
            [32.5252124133753, 3.490980730462109],
            [32.52464050633955, 3.491411291942653],
            [32.52512620295582, 3.491899836730751],
            [32.52269594300697, 3.492961367229949],
            [32.52226631024762, 3.494655830276426],
            [32.51972200558019, 3.495142823077534],
            [32.51749167378266, 3.496520402298645],
            [32.51673928532486, 3.500384043687715],
            [32.515953298078834, 3.500168214494976],
            [32.515166896709445, 3.500778173099465],
            [32.51473730347594, 3.502357739448362],
            [32.5137364490954, 3.503075304705078],
            [32.51150319058668, 3.503163894210008],
            [32.51075194927751, 3.504850999849559],
            [32.51064359808121, 3.507077004119161],
            [32.50764131521395, 3.508655199642932],
            [32.50731923774355, 3.50958854499524],
            [32.506497257699024, 3.509875334027415],
            [32.506067928570225, 3.510916332858027],
            [32.50465658812231, 3.510789917983878],
            [32.504441747038946, 3.511651506710924],
            [32.502976158229316, 3.512763753172243],
            [32.50247584961666, 3.512871196040085],
            [32.50211904956562, 3.511901593422748],
            [32.49898988685099, 3.513125440981893],
            [32.49866763510742, 3.51438191246517],
            [32.49777415186122, 3.514704570430898],
            [32.498166403924984, 3.516212753613597],
            [32.497737465563326, 3.516499756696588],
            [32.497307795973065, 3.51815111232954],
            [32.49673595810759, 3.518402129785692],
            [32.49632458630131, 3.519245653529113],
            [32.49446630345681, 3.519639587588799],
            [32.49367952210005, 3.520895802825301],
            [32.4915352812461, 3.521469096792261],
            [32.491928049841164, 3.522007872383439],
            [32.49157062635927, 3.522187199675431],
            [32.49067742518405, 3.522007186470212],
            [32.49049921200812, 3.521181294558794],
            [32.48971295257253, 3.521468096165305],
            [32.48860545379474, 3.521108449608588],
            [32.488033523402805, 3.521503076863534],
            [32.48774686111417, 3.522974981753847],
            [32.48678278286304, 3.521717806353839],
            [32.48571092204916, 3.52153769891283],
            [32.48435272952672, 3.522219120188014],
            [32.483887713924936, 3.523116458150588],
            [32.481529036229524, 3.523761411963689],
            [32.479920515576715, 3.524801731791026],
            [32.47973005477018, 3.525590158115234],
            [32.47800790711541, 3.525148029900874],
            [32.47716298409851, 3.526233472098432],
            [32.47753351489869, 3.527964367823954],
            [32.47678914929471, 3.530407268870722],
            [32.47378352918617, 3.530134079676326],
            [32.472296689830195, 3.531626376834285],
            [32.470134609333, 3.53271105741565],
            [32.47033666738986, 3.533729223711985],
            [32.471197601978396, 3.534221771218157],
            [32.472007357748524, 3.53561356936914],
            [32.47511292172064, 3.538364076553159],
            [32.47612531316437, 3.539789920511492],
            [32.476732291327124, 3.541453075245782],
            [32.47691479485687, 3.547239091136287],
            [32.478028283601006, 3.54907221835154],
            [32.47806167398012, 3.549750928721747],
            [32.47748508312848, 3.554094282585497],
            [32.47427170335596, 3.56271193179371],
            [32.4745558979725, 3.567785368906912],
            [32.474094796330434, 3.576828771928396],
            [32.47328164582684, 3.581307712138768],
            [32.47175963383421, 3.58507360494649],
            [32.467468391603454, 3.588260988003017],
            [32.46699350351669, 3.591789939559385],
            [32.46591085124132, 3.594945250286623],
            [32.464503020511195, 3.605515132371735],
            [32.46461899660766, 3.609332882911348],
            [32.465327788028084, 3.610181666606742],
            [32.465562097400245, 3.613812840614847],
            [32.46456446078508, 3.615933175038579],
            [32.46500299315394, 3.616883616821529],
            [32.464427091310135, 3.619801668890333],
            [32.46341289065941, 3.621362071409381],
            [32.462989277510786, 3.623754225379419],
            [32.46177171085617, 3.626502225586778],
            [32.460791574321014, 3.627553620053638],
            [32.459204111975104, 3.627518725879204],
            [32.45906885264277, 3.627790127966511],
            [32.45954025975777, 3.630233720282759],
            [32.46021560690019, 3.630539531496748],
            [32.46051901109077, 3.631523828140101],
            [32.4611604647975, 3.632033236585593],
            [32.46102451016911, 3.633458417185549],
            [32.46173317043553, 3.63454475483403],
            [32.46087052275976, 3.636800902595987],
            [32.46151109252425, 3.638803447898017],
            [32.461121073672274, 3.641467091688795],
            [32.463922011745, 3.645744558741424],
            [32.463921388314205, 3.646796538590937],
            [32.46449483955393, 3.648086412052958],
            [32.46400328502373, 3.651089347058661],
            [32.4657246349745, 3.653262204392347],
            [32.46465643749039, 3.660370915728205],
            [32.46475621157234, 3.662983959167657],
            [32.46389115551332, 3.669244416507677],
            [32.46495091422367, 3.676354402015965],
            [32.46496086306542, 3.687977081499679],
            [32.463657772304174, 3.692336915136222],
            [32.46115553035164, 3.69667905123757],
            [32.45907704617646, 3.698459352181065],
            [32.457859694219216, 3.700630428517969],
            [32.45573096906684, 3.701681096716968],
            [32.455629099215294, 3.702563337800516],
            [32.45485149055593, 3.703682710388985],
            [32.45388848579156, 3.704174165970066],
            [32.45314561947577, 3.703732558677956],
            [32.451590130865775, 3.706412435027159],
            [32.450542556903926, 3.707090478610852],
            [32.449765662405184, 3.707056050998216],
            [32.44902189148592, 3.708073630440261],
            [32.448177599984675, 3.707767687990136],
            [32.4463867985843, 3.708581000666837],
            [32.44572720699367, 3.710022813436652],
            [32.44515280533639, 3.710259991567961],
            [32.444780673738386, 3.711142058254514],
            [32.44505060400651, 3.711651250956445],
            [32.44437495323358, 3.711752622958955],
            [32.44437431632803, 3.712770664928954],
            [32.44349511719315, 3.714263240979812],
            [32.44373127260324, 3.714738468918076],
            [32.443190484107284, 3.71524714768573],
            [32.44332513528015, 3.715993794296052],
            [32.44275090789603, 3.715959497012314],
            [32.44271634252051, 3.717215057309085],
            [32.440571073993894, 3.717637878655416],
            [32.4398949039947, 3.718553682058837],
            [32.43823940953737, 3.719027712752889],
            [32.436988878305094, 3.720112819347053],
            [32.43648149276461, 3.721198400604742],
            [32.43641289201963, 3.722827225364115],
            [32.43533135994343, 3.723742764308607],
            [32.435668573128034, 3.724659213957889],
            [32.43499250104522, 3.725405338945972],
            [32.43502487003983, 3.727611114679069],
            [32.43353769201899, 3.728967531773176],
            [32.43215240990081, 3.729441723592267],
            [32.43066653623375, 3.728762064827103],
            [32.43031091387403, 3.730204057033625],
            [32.43051256409575, 3.73179911436567],
            [32.43128826293685, 3.73373388978542],
            [32.43165975583269, 3.733869872265088],
            [32.431388943418945, 3.734751995980501],
            [32.432638718269764, 3.734888538557077],
            [32.43255310073837, 3.73670398663549],
            [32.43285677622016, 3.73724713561093],
            [32.4323831511647, 3.738332734254204],
            [32.431808824067566, 3.738434168620755],
            [32.430184940426805, 3.742199846968385],
            [32.42974565886297, 3.742403166580071],
            [32.430032681376034, 3.744019933108007],
            [32.41758864583357, 3.743232722261969],
            [32.41601627967601, 3.742908537763152],
            [32.413265397527546, 3.741219238699479],
            [32.33414126268617, 3.687918455133865],
            [32.304529862413744, 3.668615930749975],
            [32.252116640268916, 3.633448097463813],
            [32.25249120809798, 3.633245865498971],
            [32.22016454297979, 3.612848111201534],
            [32.197901203628014, 3.597779028549946],
            [32.195599488104754, 3.594689894656379],
            [32.20021101297199, 3.591606862983896],
            [32.20328456727555, 3.590451897568637],
            [32.207507988498996, 3.591999138891373],
            [32.20981472829965, 3.589299926076702],
            [32.2102024438712, 3.585055487315838],
            [32.21174267729105, 3.580426155541281],
            [32.21520484727813, 3.573869023652771],
            [32.21444000637388, 3.570009475509159],
            [32.21444263035283, 3.566922363797724],
            [32.21867185020143, 3.561523527871444],
            [32.21675417254697, 3.558434776519995],
            [32.21138263791507, 3.55225595256972],
            [32.20908259146162, 3.547237422574411],
            [32.20793503860192, 3.541833992916862],
            [32.20909078769027, 3.537590206677032],
            [32.204106407182906, 3.52793871034965],
            [32.20219244585878, 3.520605183234726],
            [32.202683172142294, 3.504984069455105],
            [32.20095428263131, 3.504088671411746],
            [32.19957348849629, 3.503543788349547],
            [32.19871902716771, 3.500572057290005],
            [32.19926191053497, 3.497188365285043],
            [32.20027005833727, 3.494511589697205],
            [32.20073870942102, 3.488736370293403],
            [32.20112026973626, 3.488019514974653],
            [32.20204987064679, 3.486849197936441],
            [32.20378893986655, 3.485943377818208],
            [32.208280579169205, 3.482184233479063],
            [32.209304804120194, 3.481851173855472],
            [32.21475748716496, 3.482721678624197],
            [32.217199517738955, 3.481159323765053],
            [32.218057659465245, 3.479988852040202],
            [32.218836343408036, 3.47340094109986],
            [32.21869581904985, 3.470147912495262],
            [32.22104297136016, 3.467987445393427],
            [32.222950322880415, 3.464785791883723],
            [32.222951110702944, 3.463685587475146],
            [32.2219408473681, 3.461160554593707],
            [32.220917910601244, 3.45972373936077],
            [32.22015760349424, 3.457330682792779],
            [32.220289718723066, 3.455716472992326],
            [32.22321091785614, 3.449945428015803],
            [32.22478341157449, 3.448752256570997],
            [32.22578483908018, 3.446936248234206],
            [32.226619900391874, 3.444641597437866],
            [32.22763572250169, 3.439273848518303],
            [32.23143704423774, 3.434676227038518],
            [32.23243755546185, 3.434127829236838],
            [32.235962021817244, 3.433822902017464],
            [32.238665790023994, 3.432308731685056],
            [32.24364291663543, 3.43186274244065],
            [32.24650123549525, 3.430671702244006],
            [32.25081078539152, 3.426211037769624],
            [32.25325116486205, 3.424374743269886],
            [32.25458499237905, 3.424337492086315],
            [32.25706145986947, 3.425105351116614],
            [32.258052969974436, 3.424225312588922],
            [32.26546697622003, 3.421760949867335],
            [32.267487608890896, 3.420613616432839],
            [32.269890189949216, 3.418317690040646],
            [32.27050201003133, 3.415560831839081],
            [32.26854479931784, 3.40845539768582],
            [32.26831775462138, 3.406348903880741],
            [32.26866231153345, 3.404242913911895],
            [32.271848418453914, 3.398788125756327],
            [32.272574041607825, 3.396682382013276],
            [32.272904185051125, 3.388353212668691],
            [32.274659636846756, 3.384984465301639],
            [32.2771235279232, 3.376924952858802],
            [32.27880212255803, 3.374360357938619],
            [32.2785380816449, 3.370683717353053],
            [32.29017101304596, 3.356369465389166],
            [32.29085786311558, 3.355067890636181],
            [32.29089662901337, 3.354148802828695],
            [32.2892614167185, 3.349513749897148],
            [32.28970077733408, 3.347924770702376],
            [32.290617138873955, 3.345397877487885],
            [32.295041525802844, 3.33965661339822],
            [32.30062623783819, 3.336501164963549],
            [32.303064536810524, 3.337153945451985],
            [32.30401744451108, 3.336771659990534],
            [32.31088215970654, 3.328581055530958],
            [32.31177948504722, 3.325920069347161],
            [32.31494512654888, 3.3217096617894],
            [32.318755633558744, 3.321712310057672],
            [32.326147436145455, 3.322598221312624],
            [32.32757600897549, 3.323154504070027],
            [32.33050806784205, 3.326181950808454],
            [32.33344140590957, 3.327332852898268],
            [32.335156053530035, 3.327487197709125],
            [32.339082301277706, 3.32542182922056],
            [32.34003564825444, 3.324350154815727],
            [32.34420898390924, 3.323146598736211],
            [32.345810039562004, 3.322190245688295],
            [32.34748896926848, 3.318706348806056],
            [32.349052337001815, 3.317098917302869],
            [32.350425670628404, 3.314725413781044],
            [32.356622342883064, 3.307625396350133],
            [32.35889318420831, 3.302016368863314],
            [32.36079950446263, 3.300332540221216],
            [32.36312468757436, 3.299070239714872],
            [32.36579228062464, 3.298650688919416],
            [32.36834502137091, 3.299073584877901],
            [32.36994551198336, 3.298921412234303],
            [32.37644387354474, 3.29649366983624],
            [32.38288714322631, 3.290676536456253],
            [32.38437552229471, 3.286924339576661],
            [32.386071826317085, 3.285833915530828],
            [32.38675845629944, 3.284608730291863],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 568,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "PALABEK OGILI",
        Population: 9491,
        Key: "LAMWOPALABEK OGILI",
        Dist2: "Lamwo",
        "Sub Country": "Palabek Ogili",
        id2_original: "Lamwo Palabek Ogili",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.24727810214622, 2.765827735370829],
            [32.24395172958236, 2.766214428564399],
            [32.23611944348593, 2.768003437118845],
            [32.223659986564996, 2.761064158780777],
            [32.22117853252642, 2.760347128423533],
            [32.21949572299628, 2.758425496561644],
            [32.214860841931646, 2.757407278081614],
            [32.211723396750116, 2.756030565525181],
            [32.20490657343739, 2.756259897643071],
            [32.20318098613341, 2.755786628394983],
            [32.20121293275445, 2.756589651932301],
            [32.199701252285905, 2.756532261272886],
            [32.19847476356388, 2.757794179492642],
            [32.1962075119065, 2.759884405557976],
            [32.19360541143032, 2.761286034492616],
            [32.18979523769544, 2.761940042607475],
            [32.18827734178345, 2.762594123041161],
            [32.18765782493597, 2.762344902328785],
            [32.18271723280712, 2.75628625602427],
            [32.180425091528164, 2.752672910066285],
            [32.17960427480194, 2.751099853742051],
            [32.179542391658615, 2.74916861771081],
            [32.17879903576101, 2.747143914876672],
            [32.17483669370524, 2.744205359051638],
            [32.17406354068964, 2.743062615649057],
            [32.17471281243427, 2.739998293052272],
            [32.174207494815604, 2.737438020871647],
            [32.1736087416276, 2.737668652246879],
            [32.1730646257718, 2.736840123959786],
            [32.17317698974247, 2.736067028855963],
            [32.172345378859795, 2.734323370899169],
            [32.17265630913581, 2.733034530620796],
            [32.17244046822755, 2.732248025696244],
            [32.17083929848872, 2.730907225318918],
            [32.170780699586125, 2.730249071756349],
            [32.17094934480598, 2.729132365358063],
            [32.17186060301672, 2.728299807698634],
            [32.1712010069345, 2.726899161211746],
            [32.172289178458975, 2.722359605034543],
            [32.1720030883972, 2.722045546790853],
            [32.170433779206526, 2.722135742656393],
            [32.1693719705407, 2.719562702372546],
            [32.16840190591655, 2.719793953624429],
            [32.16620158593433, 2.71834069995291],
            [32.1627881351784, 2.717734337345383],
            [32.16278991204603, 2.718507120305893],
            [32.16182068644834, 2.718109483417377],
            [32.1607661011357, 2.718656198437468],
            [32.1600793804235, 2.717856674992056],
            [32.15822359938705, 2.717461072977203],
            [32.157482176663926, 2.717692089537975],
            [32.15608225110833, 2.716980389229168],
            [32.154368534142485, 2.717156427088288],
            [32.15397452227908, 2.717524929693258],
            [32.153299077220346, 2.716601645507587],
            [32.15004522834429, 2.716295732405775],
            [32.149588053238304, 2.716039390906308],
            [32.150154110444916, 2.714005695927989],
            [32.14975262639498, 2.713148151244961],
            [32.148951547452185, 2.713092699384903],
            [32.14781328766408, 2.713640038510219],
            [32.14689835714048, 2.712869760413237],
            [32.14624195816237, 2.712842939861453],
            [32.14526857965309, 2.711471766399899],
            [32.13982927791282, 2.710098512315696],
            [32.13962644730482, 2.708753852198851],
            [32.13865576913131, 2.708556156498457],
            [32.13848336895355, 2.708041432368709],
            [32.137655890321156, 2.708072316055948],
            [32.137824222927286, 2.706812505404851],
            [32.13668766365006, 2.706466376734567],
            [32.13660886163671, 2.705685279646827],
            [32.13546612015366, 2.70511597605639],
            [32.134867715511994, 2.705489689441704],
            [32.134608737503775, 2.704545884356393],
            [32.133695822799666, 2.704619970243504],
            [32.132295696021416, 2.70383666905762],
            [32.13215137897608, 2.703121517600661],
            [32.13257758196768, 2.702318950963334],
            [32.13140571710313, 2.701492124832189],
            [32.13214568814874, 2.700631462984696],
            [32.131429745240354, 2.699517174405833],
            [32.130973109123566, 2.699489797221198],
            [32.130717658799476, 2.700091547776907],
            [32.12947305015984, 2.698649561423316],
            [32.128558867932846, 2.698194114497302],
            [32.129097842730296, 2.696790188430847],
            [32.12878224929962, 2.696046883868061],
            [32.12758375028522, 2.696050160884182],
            [32.12681152612762, 2.695279486665793],
            [32.12675138481768, 2.69393443326001],
            [32.12595108022264, 2.693364194537745],
            [32.12540603011892, 2.692106325698245],
            [32.127204329756964, 2.692440622760301],
            [32.127262607062704, 2.69353159370939],
            [32.12812788051405, 2.69378102789024],
            [32.12885554464029, 2.694842182325866],
            [32.12930049457355, 2.694253443935372],
            [32.1298586259444, 2.694363827133524],
            [32.13049890465473, 2.693802528637575],
            [32.13044183019318, 2.693243126823773],
            [32.13111165808646, 2.693409169259827],
            [32.132197721264944, 2.69262281353926],
            [32.13325927211431, 2.693319363385667],
            [32.13331313689536, 2.6924798833599],
            [32.13373224678948, 2.692786490715496],
            [32.13417784350974, 2.692477519809569],
            [32.13476071897511, 2.691216920393476],
            [32.135960721769315, 2.69146543977741],
            [32.13573635405237, 2.690934477598123],
            [32.137575529730775, 2.690146058227182],
            [32.13793686807065, 2.689585507952755],
            [32.138843567331314, 2.689652976974352],
            [32.13973404032301, 2.688727274824329],
            [32.14031981105855, 2.688725670404831],
            [32.14062470285923, 2.687885495376976],
            [32.14109953614875, 2.688163979872714],
            [32.142069510941404, 2.685419498392331],
            [32.142571077195456, 2.685194301151284],
            [32.14240255414647, 2.684691149863285],
            [32.14309931353198, 2.68443744791936],
            [32.14330552809364, 2.683135919238602],
            [32.145062869944624, 2.683159064082866],
            [32.145726839025606, 2.680779119796605],
            [32.14746872626046, 2.680144843965091],
            [32.14808006215064, 2.67913596347517],
            [32.14911288936877, 2.679468848992895],
            [32.14885966866321, 2.67851830631252],
            [32.149306464634414, 2.678740899823075],
            [32.15030933663106, 2.678178568493291],
            [32.150252643055175, 2.677787043619174],
            [32.150754788722594, 2.677813637020557],
            [32.15053081356941, 2.677450545872433],
            [32.15203194422328, 2.675236164294079],
            [32.15231010395775, 2.674899656873687],
            [32.15297972883175, 2.674981739829373],
            [32.15342383165372, 2.674029282340639],
            [32.15619697585157, 2.673056398908594],
            [32.156613045846775, 2.672048052782509],
            [32.157142433823466, 2.67179478881313],
            [32.1575298349847, 2.67045077471511],
            [32.158686589287846, 2.6700978536342],
            [32.158629773541094, 2.669650368936734],
            [32.15982852857536, 2.669367282257886],
            [32.16030130023129, 2.66875045829355],
            [32.1606365281391, 2.668973359569453],
            [32.161695172938515, 2.668410877496511],
            [32.162727871697555, 2.668687797868087],
            [32.16255869018347, 2.667904886410934],
            [32.163059480293136, 2.66734393740669],
            [32.16398066398942, 2.667649144924198],
            [32.163963637321544, 2.666320245621114],
            [32.16697538394028, 2.666004151208758],
            [32.16909207885437, 2.664627365162268],
            [32.16922893808622, 2.663507854436492],
            [32.169951559968766, 2.662386749007278],
            [32.17007379193285, 2.66097351587512],
            [32.17119776401635, 2.658522327591845],
            [32.17174923707432, 2.655778945506833],
            [32.17304120220078, 2.653607071983672],
            [32.17460100272414, 2.652651476073008],
            [32.176155807716206, 2.649569583464428],
            [32.178980299615695, 2.646721960686103],
            [32.18003617311243, 2.644984366722488],
            [32.181741718104135, 2.640768928500237],
            [32.181354562182975, 2.637759428084647],
            [32.181901672123615, 2.636070266713312],
            [32.18286485655103, 2.635610944225679],
            [32.18412455239586, 2.63396361515211],
            [32.18656249833025, 2.632823692118866],
            [32.18845571306291, 2.631335558754022],
            [32.187727746204416, 2.630162505147844],
            [32.186708715312434, 2.629759677056494],
            [32.18634420052969, 2.628949337110433],
            [32.18575786924545, 2.628699165632833],
            [32.18474036998099, 2.6269607909105],
            [32.186962297140724, 2.623019022221194],
            [32.192037332931605, 2.617744319806452],
            [32.19256521084034, 2.61839383186779],
            [32.19470862524422, 2.618991337905673],
            [32.199943999533566, 2.619278432098821],
            [32.205149068258464, 2.622015919116949],
            [32.20951333813194, 2.620325789701498],
            [32.21197542179803, 2.618278900251644],
            [32.216426977374404, 2.617880091275758],
            [32.22827307539914, 2.619898640438552],
            [32.22988674429681, 2.620376903341067],
            [32.230851768473954, 2.621339835857588],
            [32.233309946265166, 2.622708939053816],
            [32.23616297045473, 2.623123328493861],
            [32.23902396449746, 2.621835705603169],
            [32.24166992072578, 2.62120050218304],
            [32.2435563513814, 2.62000012741514],
            [32.245986266377166, 2.619606948230252],
            [32.24699472769153, 2.618614269915264],
            [32.24968955855956, 2.618292756657328],
            [32.25066502655016, 2.618762539959147],
            [32.25609118683615, 2.621888826608771],
            [32.25720090894429, 2.621832265067654],
            [32.25905003436278, 2.622405661498039],
            [32.26298873006536, 2.625970528773011],
            [32.2635002685174, 2.627029581594377],
            [32.26500791555031, 2.627688610835057],
            [32.26733848136721, 2.632182503462543],
            [32.267316748425536, 2.636512700633899],
            [32.267876044911326, 2.637419324586811],
            [32.26858718722285, 2.637763128811634],
            [32.26918367665633, 2.639537589342402],
            [32.270904537025324, 2.640554428618825],
            [32.271500779422105, 2.642758120281996],
            [32.273861887958695, 2.6437324176108],
            [32.277191638188036, 2.642618399547553],
            [32.27867066309936, 2.643620778049291],
            [32.28029278694051, 2.643192506993266],
            [32.28145907955537, 2.64373686492282],
            [32.28093212241979, 2.644723769369447],
            [32.281699769661, 2.645782969551993],
            [32.280874123591786, 2.64661231891056],
            [32.28235193577749, 2.649732188655707],
            [32.28171070036139, 2.651491638184194],
            [32.281567005848544, 2.653952424138597],
            [32.282448903522514, 2.654267703255491],
            [32.282476418021346, 2.655898769601912],
            [32.2830168983952, 2.656156613326486],
            [32.28256108783013, 2.657100638794362],
            [32.282873401511715, 2.658274026766641],
            [32.28227551609628, 2.658874595132091],
            [32.28258797081334, 2.659819059118651],
            [32.28144947566667, 2.660362080760943],
            [32.28124972268682, 2.661363478442265],
            [32.2807087680025, 2.661906841293124],
            [32.28110688516674, 2.662336302029739],
            [32.281155829875, 2.663855835731781],
            [32.28161251809409, 2.664344393982122],
            [32.281667655787906, 2.667791135794439],
            [32.28196717656152, 2.66843756532193],
            [32.28319510707959, 2.668811682072953],
            [32.28482216177331, 2.670478544687939],
            [32.28633577990792, 2.670737927887106],
            [32.28920496029785, 2.672965598186354],
            [32.28980366318021, 2.674861645699206],
            [32.28988814254615, 2.676958446567131],
            [32.288258983099695, 2.678910630477105],
            [32.28701397381145, 2.683347548327522],
            [32.28886879005728, 2.686307073784692],
            [32.28859616574159, 2.688532898666882],
            [32.28888101253502, 2.689854309918103],
            [32.292049945463916, 2.692412473718124],
            [32.29294867307474, 2.69412200146852],
            [32.29055963950924, 2.701143285643296],
            [32.29024392121273, 2.703785585799153],
            [32.28659830087163, 2.710432702131536],
            [32.28362245452485, 2.719478538886655],
            [32.28249090784689, 2.725064415852522],
            [32.282574947038356, 2.727850538169524],
            [32.28206045941725, 2.728453409686506],
            [32.28197393279076, 2.729860772416875],
            [32.28081607266149, 2.731626498637788],
            [32.280987089433715, 2.732229778323654],
            [32.282300438955524, 2.733178407137566],
            [32.282956581015455, 2.734528763833773],
            [32.28311188894827, 2.737538648374196],
            [32.28174024954435, 2.738534823045637],
            [32.280768002912346, 2.740372479255874],
            [32.280881478099026, 2.741665063199322],
            [32.28036700215601, 2.742239206525817],
            [32.28080962545272, 2.746222017336373],
            [32.28036451741594, 2.7475868836316],
            [32.27903902267152, 2.749036660809355],
            [32.274418679043144, 2.752198504334713],
            [32.27299392674803, 2.754149830887924],
            [32.272197790335895, 2.756558113584473],
            [32.268715978685144, 2.757418337895585],
            [32.258856981018326, 2.7572902967199],
            [32.255209751794524, 2.757808914540977],
            [32.253828398907416, 2.757481200096054],
            [32.24962061825138, 2.760265272001836],
            [32.247817657255325, 2.759939738607994],
            [32.24620456058447, 2.760558952121989],
            [32.24775341064451, 2.764006714317205],
            [32.24781961198937, 2.7657821568051],
            [32.24727810214622, 2.765827735370829],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 569,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "ONGAKO",
        Population: 23169,
        Key: "OMOROONGAKO",
        Dist2: "Gulu",
        "Sub Country": "Ongako",
        id2_original: "Gulu Ongako",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.83246035581799, 3.389202205535764],
            [32.82949574829374, 3.38883657329684],
            [32.817133614850704, 3.389480604191139],
            [32.80219964337677, 3.387107899526691],
            [32.797554970675534, 3.387106935524661],
            [32.78097805870038, 3.382722861450641],
            [32.77754844635417, 3.381501296011425],
            [32.77377951247734, 3.380802722053315],
            [32.76819248458522, 3.378714669786202],
            [32.76573745089748, 3.380481950260516],
            [32.76392552830816, 3.381164291453085],
            [32.75503621707478, 3.382641437433181],
            [32.74716906197232, 3.385811833372879],
            [32.74395630922388, 3.387963063093663],
            [32.739415573397686, 3.394803944466104],
            [32.73822614557101, 3.397247228525808],
            [32.73557776299307, 3.399690109147161],
            [32.73438892895282, 3.399906990610384],
            [32.73353067673374, 3.399171818056313],
            [32.73333101897533, 3.398598037598869],
            [32.73159273667973, 3.395118124967138],
            [32.7300309751341, 3.391430280309792],
            [32.73035664676396, 3.386910427056772],
            [32.72914954817731, 3.38116599707456],
            [32.72941537134801, 3.379211017520696],
            [32.73021410029804, 3.378533442098588],
            [32.73072909007739, 3.376695239051616],
            [32.73165925782482, 3.372142716300984],
            [32.73131667271481, 3.370706417966722],
            [32.731717350975956, 3.36878200774569],
            [32.73118946049082, 3.365607844507712],
            [32.731647126975254, 3.364286651845008],
            [32.7318197562234, 3.360121694113009],
            [32.73214862226237, 3.359446775985823],
            [32.73125748721232, 3.355186248866044],
            [32.7290645055677, 3.353412523983069],
            [32.72663431568745, 3.347709377955797],
            [32.722312489414506, 3.343091874251224],
            [32.716821786971984, 3.331775884412326],
            [32.71610241968574, 3.327793003147826],
            [32.71304142113486, 3.323809440355742],
            [32.707409263679494, 3.319613764625578],
            [32.70690956232798, 3.318531234320538],
            [32.70587104967242, 3.318569580973287],
            [32.704294386872846, 3.317486727569544],
            [32.7030635826442, 3.317447701092842],
            [32.702410001681116, 3.316481092876553],
            [32.699063738620225, 3.316441418862725],
            [32.696563861931814, 3.315744836045505],
            [32.69591015789957, 3.31520344426584],
            [32.69498691885787, 3.315628379688579],
            [32.694602361762854, 3.315396321595188],
            [32.694564242652085, 3.314275273943756],
            [32.69587301795247, 3.310873913633197],
            [32.69995075040314, 3.308594432828423],
            [32.70299000074095, 3.306237309069863],
            [32.70926124214733, 3.299899512460569],
            [32.715454591533735, 3.296692823223708],
            [32.71780201693193, 3.29232530900944],
            [32.71777994083379, 3.287623420568084],
            [32.71611364683016, 3.284630843664931],
            [32.713383691834515, 3.275469805381044],
            [32.71348554282146, 3.272491583856815],
            [32.7128039559811, 3.270379366120029],
            [32.712862320423426, 3.266579531042239],
            [32.71186034674203, 3.263157161440563],
            [32.71220810435146, 3.260206872894329],
            [32.71276867644493, 3.259616955850553],
            [32.714125510714695, 3.256043937651923],
            [32.71542615087186, 3.254357647751281],
            [32.71538675435675, 3.252330802485982],
            [32.71605343365498, 3.251088584243697],
            [32.71786833685441, 3.250096691796832],
            [32.71762847948701, 3.248970111616392],
            [32.71810869458339, 3.248502929395777],
            [32.71797595053387, 3.246958578605436],
            [32.718296437986204, 3.246019908885101],
            [32.719314346882406, 3.245266661772902],
            [32.71912412772269, 3.244437657724474],
            [32.71833983559758, 3.243816808965572],
            [32.71792388956988, 3.242237940068626],
            [32.71477602752431, 3.238589297258164],
            [32.71515011026314, 3.236845990327009],
            [32.71491052059371, 3.234780649764982],
            [32.714083750732094, 3.233090646260151],
            [32.71424364456446, 3.232032298409853],
            [32.713772261703944, 3.230307778975765],
            [32.714081724132804, 3.229858759997377],
            [32.7132526473975, 3.22850106207018],
            [32.71418312057218, 3.227683128074452],
            [32.714460709876434, 3.226611480865947],
            [32.71432363235398, 3.225160482949945],
            [32.713670776331355, 3.224503912589339],
            [32.71472701274748, 3.222949370589456],
            [32.71446217592699, 3.221360389899207],
            [32.71491609464004, 3.22017540235139],
            [32.71325581306057, 3.217203597453355],
            [32.7114733498227, 3.216384824744613],
            [32.70968658545121, 3.214656981775918],
            [32.7099235457518, 3.213983598488907],
            [32.70906847985703, 3.212687646443101],
            [32.709381833787695, 3.210813584649099],
            [32.70872554350573, 3.209992908960555],
            [32.70868488126442, 3.208398065628681],
            [32.70761624899567, 3.205715541711994],
            [32.706825596798346, 3.204618724734496],
            [32.70732995232136, 3.202826859117789],
            [32.706218692297455, 3.202426472086069],
            [32.706416125827225, 3.200935152206482],
            [32.70547042531021, 3.199943522954338],
            [32.70612201560659, 3.199290504304574],
            [32.706401119470414, 3.198112822552712],
            [32.70578117143159, 3.197528292199981],
            [32.705626677372415, 3.195658323090889],
            [32.706833666364574, 3.194267087807111],
            [32.70682518357332, 3.192916030896467],
            [32.70747772788055, 3.192479028570721],
            [32.70900010638582, 3.19010069492261],
            [32.7076439503441, 3.188919379055448],
            [32.70717945307023, 3.186854537103083],
            [32.70679193063646, 3.186698599316837],
            [32.70621035862658, 3.187477567780549],
            [32.70328111957171, 3.189401148365568],
            [32.702644537428775, 3.188177761431959],
            [32.703444318306, 3.187053986536176],
            [32.70318345473401, 3.186580133295407],
            [32.7023031066539, 3.187217646799431],
            [32.7010404328939, 3.187026893094968],
            [32.70014256766576, 3.18747781443507],
            [32.697696604267406, 3.18723634501065],
            [32.69948448344816, 3.187304071871588],
            [32.70205775069867, 3.18622722501763],
            [32.703988426975265, 3.182865675762728],
            [32.70548933754187, 3.182779899695072],
            [32.706581566756505, 3.183859107283009],
            [32.70772439447777, 3.184205870619229],
            [32.711617278795806, 3.183006376195433],
            [32.712436498317494, 3.182049102700289],
            [32.71380891476415, 3.181402927026636],
            [32.715395579406106, 3.181535513126928],
            [32.71736730958951, 3.184507401754328],
            [32.717753228530505, 3.184593716731891],
            [32.71959743657115, 3.183645934219298],
            [32.721697829757765, 3.181685714030008],
            [32.72331957091659, 3.181155654827915],
            [32.72726278424674, 3.177084536883685],
            [32.728947871006156, 3.175846613041578],
            [32.729675693235855, 3.175847896556513],
            [32.732077996714736, 3.176925035891448],
            [32.73271200338777, 3.177864458879876],
            [32.73456480650904, 3.178348115126832],
            [32.73503631423538, 3.179124111190033],
            [32.73786622656928, 3.180417959276904],
            [32.73884075761704, 3.182342371947436],
            [32.740570930820574, 3.182410090160982],
            [32.74305488756549, 3.180893417271681],
            [32.74352600901625, 3.183264260416544],
            [32.74228541404934, 3.187509504607642],
            [32.74309588847172, 3.18847975062882],
            [32.74331083106468, 3.189411969751887],
            [32.7442104794487, 3.189945569344151],
            [32.746191966234406, 3.193203320864326],
            [32.74696062138538, 3.193632801309418],
            [32.748754624381405, 3.19268880495795],
            [32.75157339041925, 3.192775351551393],
            [32.75131635097544, 3.196037899782784],
            [32.751657691918766, 3.197411713643472],
            [32.75123006330082, 3.199643922026058],
            [32.7524436486221, 3.203924969567673],
            [32.753430667150646, 3.203744840192539],
            [32.75406278646324, 3.204485601673845],
            [32.75680042115622, 3.202581432539445],
            [32.761327942764616, 3.203535043644307],
            [32.765056068873, 3.209864954571707],
            [32.76473236814687, 3.211536609207259],
            [32.763184111873244, 3.212070024174623],
            [32.763398163337456, 3.213282373096516],
            [32.764588794008276, 3.214531137484796],
            [32.766660665684654, 3.214531615533489],
            [32.76718430085027, 3.214965993079964],
            [32.76662445100226, 3.21669384449409],
            [32.76852896384622, 3.219209350670138],
            [32.76961116516732, 3.224873027968778],
            [32.770206480502765, 3.225542642490623],
            [32.76781178755096, 3.231250761144847],
            [32.77095477264286, 3.233911300634282],
            [32.7735742689945, 3.234219490820189],
            [32.774193774163884, 3.233649666758939],
            [32.775051117287894, 3.233649858692337],
            [32.778610805687244, 3.235858118087213],
            [32.7804918608242, 3.237876014126515],
            [32.78223050963245, 3.237659263016962],
            [32.784325780625316, 3.238971531563241],
            [32.786957867763974, 3.236999839688254],
            [32.78788656047775, 3.237479527959325],
            [32.78991095978458, 3.23740757563002],
            [32.79138703912008, 3.239208239767478],
            [32.79384011717547, 3.239136368280245],
            [32.796661685957, 3.241823909093819],
            [32.800138164309914, 3.244176832860564],
            [32.802186054561446, 3.246330430843144],
            [32.80378136728462, 3.24701831753372],
            [32.803624181872834, 3.248194400955553],
            [32.80260792947002, 3.249487927368508],
            [32.80263387281543, 3.25169173061564],
            [32.80150820111942, 3.254744033961227],
            [32.80321900484878, 3.256101425807628],
            [32.804491490906614, 3.257856798186749],
            [32.80666179907349, 3.258418135032601],
            [32.8087552096554, 3.258065702787618],
            [32.81047130266514, 3.258301251354703],
            [32.811881243537876, 3.259142891559673],
            [32.81217594305334, 3.262653195738726],
            [32.8138461393386, 3.263196329953241],
            [32.814463350210765, 3.262852657211315],
            [32.81514392464979, 3.265186917622128],
            [32.81780721656649, 3.26653541470827],
            [32.81833508189881, 3.267177850222272],
            [32.81853917104651, 3.26945774051555],
            [32.81930883410721, 3.270742558959633],
            [32.82191142596185, 3.271864859194906],
            [32.822691275019544, 3.272851124854223],
            [32.824236217408114, 3.272362858008606],
            [32.82728319864727, 3.27220959072188],
            [32.82824140011983, 3.273150648532717],
            [32.82957582771142, 3.273286583157843],
            [32.8328671399281, 3.272138165530516],
            [32.834605249747156, 3.272102267284794],
            [32.83658928235838, 3.273351085484805],
            [32.83815977463026, 3.27312516544085],
            [32.83859695144136, 3.274581810898977],
            [32.841885494152024, 3.274917077948164],
            [32.84342848539979, 3.276084390753916],
            [32.845311968682935, 3.276455613685912],
            [32.847152026506954, 3.277541543108803],
            [32.84732624217992, 3.278771968308741],
            [32.849190490736206, 3.279903132915973],
            [32.85011712361303, 3.27956853209893],
            [32.85294044590603, 3.279777035773553],
            [32.85368075741314, 3.280157120840232],
            [32.854846475106186, 3.27993111533883],
            [32.85670850572205, 3.278087277285393],
            [32.85903115468636, 3.27491060270368],
            [32.86231256297704, 3.276069084262307],
            [32.862767361140776, 3.27646721709086],
            [32.86277644220996, 3.277941887869505],
            [32.863684385637306, 3.278484836226907],
            [32.8648253610325, 3.27815025018169],
            [32.86593637940958, 3.276739060310478],
            [32.86609355134665, 3.275164894133125],
            [32.86666210497143, 3.274712617150487],
            [32.869263822765284, 3.275048392668765],
            [32.87212457066962, 3.276200848152195],
            [32.87276027426023, 3.276970608147197],
            [32.87338904375515, 3.278561533517271],
            [32.872633519278686, 3.279792213959753],
            [32.871409866537995, 3.282071989437471],
            [32.87019768797847, 3.282459991845008],
            [32.8694908405123, 3.285689181037448],
            [32.86871218172236, 3.286883833910588],
            [32.86907354791002, 3.287571922400489],
            [32.86849952444344, 3.289134260396738],
            [32.86837200589393, 3.291681708522606],
            [32.86770932499706, 3.294339419973498],
            [32.86524966318893, 3.297162468983365],
            [32.86539542203031, 3.297637639877593],
            [32.86596692482419, 3.297634252558812],
            [32.866043825104086, 3.29853821515727],
            [32.86780543125773, 3.29843257968926],
            [32.86796639228864, 3.299044668499066],
            [32.867317906569866, 3.302493496995851],
            [32.86707669544135, 3.3079096089561],
            [32.86493246087562, 3.311706630147242],
            [32.86293489514462, 3.314158026424844],
            [32.8623894506805, 3.318492999767415],
            [32.864328383372914, 3.328049431565699],
            [32.86574560329437, 3.330064111983354],
            [32.865768258805836, 3.333824499102613],
            [32.86761271478148, 3.333645284464483],
            [32.86820548608801, 3.333213357313923],
            [32.865498606117114, 3.336525792681272],
            [32.86500538970365, 3.337671137812659],
            [32.86525944584239, 3.340311527044486],
            [32.86488630453799, 3.341622781609277],
            [32.8653670451488, 3.342357755524372],
            [32.86540943574877, 3.343464228931324],
            [32.860824949273265, 3.349393950750914],
            [32.861030314927014, 3.349880645228403],
            [32.86063077842462, 3.350763639876956],
            [32.85906244480436, 3.351344129588425],
            [32.85726269169218, 3.353044620204819],
            [32.85662417727308, 3.355773582828926],
            [32.85768863237572, 3.358528179245751],
            [32.85572086735597, 3.365953737819836],
            [32.855163160888246, 3.366278335523963],
            [32.85445943955927, 3.368067548339129],
            [32.85169210027482, 3.371249386105831],
            [32.85083618008222, 3.371492448583499],
            [32.84808880854985, 3.376018896707047],
            [32.84728267029537, 3.376618670460768],
            [32.844926973210065, 3.377263905744934],
            [32.84457489560243, 3.378043303145335],
            [32.84350313539989, 3.378296551948097],
            [32.84195877422131, 3.380408736718618],
            [32.835885600555315, 3.38424847163432],
            [32.83426855309382, 3.387990074854241],
            [32.83246035581799, 3.389202205535764],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 570,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "LABONGO AKWANG",
        Population: 15610,
        Key: "KITGUMLABONGO AKWANG",
        Dist2: "Kitgum",
        "Sub Country": "Labongo Akwang",
        id2_original: "Kitgum  Labongo Akwang",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.97502079592518, 3.353289604529443],
            [32.974294994006556, 3.354199035759761],
            [32.974359867641446, 3.355067380370881],
            [32.97393529688871, 3.355736364874187],
            [32.97123353821323, 3.357894725007892],
            [32.96921132001589, 3.358240116172364],
            [32.968628918860986, 3.3603618941845],
            [32.96779715616303, 3.360652510633969],
            [32.965220189650196, 3.359858815535786],
            [32.96411854968464, 3.360805566921954],
            [32.96271288119943, 3.360718828601539],
            [32.96234531304305, 3.359031184148198],
            [32.95962968437958, 3.358928510927608],
            [32.95891117049285, 3.358266405960091],
            [32.95872974583975, 3.355863619926632],
            [32.957272168205826, 3.354328711411526],
            [32.95600925549399, 3.354217298610916],
            [32.951767223872785, 3.351803211283588],
            [32.94964872603993, 3.351982533804871],
            [32.94876424481118, 3.35144043019803],
            [32.94846916081676, 3.349918946716607],
            [32.947253736644086, 3.349783439613861],
            [32.947431472814635, 3.347687898224856],
            [32.948241009395836, 3.347659231679452],
            [32.94867850960047, 3.345205114546314],
            [32.94859704228566, 3.343563356088711],
            [32.9479727841301, 3.342734066210125],
            [32.948221937264066, 3.340638102608759],
            [32.94926511936247, 3.339870209850605],
            [32.94957274024499, 3.337595384933282],
            [32.95080249344476, 3.336183751453443],
            [32.950148027641134, 3.334307422210397],
            [32.95112286411611, 3.332099981376523],
            [32.95134106669524, 3.328837966221906],
            [32.95173995551232, 3.327859733175724],
            [32.95147333733263, 3.327099713323356],
            [32.952690233844045, 3.325533447069497],
            [32.95247067570716, 3.324677923941959],
            [32.953314147046555, 3.322411793420175],
            [32.952288120973414, 3.32208474726335],
            [32.95180457133071, 3.320897599985545],
            [32.952275608339846, 3.32003793227859],
            [32.952019372888195, 3.319027937208471],
            [32.94936119777537, 3.316616230596495],
            [32.94899540468998, 3.315214177311324],
            [32.94722548552674, 3.313963353434254],
            [32.94655614092705, 3.311599186308139],
            [32.943948961376286, 3.309734574763518],
            [32.94393603731427, 3.307616379733632],
            [32.94304911446458, 3.306669657863864],
            [32.940962012750916, 3.306122864956269],
            [32.9392827210234, 3.304109855850434],
            [32.93556475216594, 3.303632319543691],
            [32.93393774598119, 3.302380628169529],
            [32.933618019401926, 3.300716479177545],
            [32.932875746872554, 3.300054501883793],
            [32.93194659152641, 3.299988672187461],
            [32.92865834795476, 3.301638709972705],
            [32.9278861309837, 3.303880607493567],
            [32.926821903154796, 3.305100818555857],
            [32.925748257388484, 3.304774036621255],
            [32.923609242932855, 3.305477053771492],
            [32.923208323923234, 3.306122069476766],
            [32.92190030680097, 3.30641550361606],
            [32.92108459879373, 3.307384296445349],
            [32.91918472664652, 3.308252485951674],
            [32.917036425407495, 3.307432287024689],
            [32.91484471667563, 3.30730256752915],
            [32.912758506989015, 3.308862077346428],
            [32.91218640591716, 3.308770284462911],
            [32.911558011019736, 3.309214363420527],
            [32.90855577755982, 3.312873795785877],
            [32.90701817350881, 3.313115948110871],
            [32.905875909929506, 3.31257368946689],
            [32.90526876288346, 3.310527014427273],
            [32.90301809143131, 3.31006002867136],
            [32.90176787371102, 3.30822871847397],
            [32.9026254315324, 3.306684852679702],
            [32.901625214057404, 3.30585892446399],
            [32.90069649619078, 3.304243083233846],
            [32.9008752824919, 3.302663259384801],
            [32.901446959558925, 3.302052917126695],
            [32.901732874449245, 3.300832157048772],
            [32.9013758354463, 3.298605974024501],
            [32.90167961782762, 3.297510875047408],
            [32.90068699381172, 3.295336726731474],
            [32.900465197971435, 3.295069174529142],
            [32.901286976793344, 3.294027999907711],
            [32.90423447141143, 3.292215055090174],
            [32.905342050139296, 3.291102095811967],
            [32.90684255376909, 3.290491838834046],
            [32.90905769146189, 3.288409516601273],
            [32.91105859084088, 3.284890954902935],
            [32.91173748453204, 3.283454776013963],
            [32.911683984466976, 3.282539190121129],
            [32.912434315782775, 3.281282559334232],
            [32.91318488245715, 3.277153479600698],
            [32.91081320613958, 3.269262983453924],
            [32.90990108554616, 3.268193244937535],
            [32.907506667478835, 3.266588539061078],
            [32.90304159315578, 3.264620972017312],
            [32.899717938893936, 3.265267439231076],
            [32.89273401995521, 3.264171592511895],
            [32.89132966390859, 3.263527403510218],
            [32.89026911378247, 3.263740465664864],
            [32.88449933083232, 3.266845646037039],
            [32.88224863153236, 3.267599416018054],
            [32.88096241382709, 3.26885595097436],
            [32.879997863062115, 3.268855835280213],
            [32.876746773810645, 3.270471195722355],
            [32.87274555177103, 3.2713683193111],
            [32.87120922961595, 3.272768441548233],
            [32.86994096025005, 3.273288914967138],
            [32.869263822765284, 3.275048392668765],
            [32.86666210497143, 3.274712617150487],
            [32.86609355134665, 3.275164894133125],
            [32.86593637940958, 3.276739060310478],
            [32.8648253610325, 3.27815025018169],
            [32.863684385637306, 3.278484836226907],
            [32.86277644220996, 3.277941887869505],
            [32.862767361140776, 3.27646721709086],
            [32.86231256297704, 3.276069084262307],
            [32.85903115468636, 3.27491060270368],
            [32.85670850572205, 3.278087277285393],
            [32.854846475106186, 3.27993111533883],
            [32.85368075741314, 3.280157120840232],
            [32.85294044590603, 3.279777035773553],
            [32.85011712361303, 3.27956853209893],
            [32.849190490736206, 3.279903132915973],
            [32.84732624217992, 3.278771968308741],
            [32.847152026506954, 3.277541543108803],
            [32.845311968682935, 3.276455613685912],
            [32.84342848539979, 3.276084390753916],
            [32.841885494152024, 3.274917077948164],
            [32.83859695144136, 3.274581810898977],
            [32.83815977463026, 3.27312516544085],
            [32.83658928235838, 3.273351085484805],
            [32.834605249747156, 3.272102267284794],
            [32.8328671399281, 3.272138165530516],
            [32.82957582771142, 3.273286583157843],
            [32.82824140011983, 3.273150648532717],
            [32.82728319864727, 3.27220959072188],
            [32.824236217408114, 3.272362858008606],
            [32.822691275019544, 3.272851124854223],
            [32.82191142596185, 3.271864859194906],
            [32.81930883410721, 3.270742558959633],
            [32.81853917104651, 3.26945774051555],
            [32.81833508189881, 3.267177850222272],
            [32.81780721656649, 3.26653541470827],
            [32.81514392464979, 3.265186917622128],
            [32.814463350210765, 3.262852657211315],
            [32.8138461393386, 3.263196329953241],
            [32.81217594305334, 3.262653195738726],
            [32.811881243537876, 3.259142891559673],
            [32.81047130266514, 3.258301251354703],
            [32.8087552096554, 3.258065702787618],
            [32.80666179907349, 3.258418135032601],
            [32.804491490906614, 3.257856798186749],
            [32.80321900484878, 3.256101425807628],
            [32.80150820111942, 3.254744033961227],
            [32.80263387281543, 3.25169173061564],
            [32.80260792947002, 3.249487927368508],
            [32.803624181872834, 3.248194400955553],
            [32.80378136728462, 3.24701831753372],
            [32.802186054561446, 3.246330430843144],
            [32.800138164309914, 3.244176832860564],
            [32.796661685957, 3.241823909093819],
            [32.79384011717547, 3.239136368280245],
            [32.79138703912008, 3.239208239767478],
            [32.78991095978458, 3.23740757563002],
            [32.78788656047775, 3.237479527959325],
            [32.786957867763974, 3.236999839688254],
            [32.784325780625316, 3.238971531563241],
            [32.78223050963245, 3.237659263016962],
            [32.7804918608242, 3.237876014126515],
            [32.778610805687244, 3.235858118087213],
            [32.775051117287894, 3.233649858692337],
            [32.774193774163884, 3.233649666758939],
            [32.7735742689945, 3.234219490820189],
            [32.77095477264286, 3.233911300634282],
            [32.76781178755096, 3.231250761144847],
            [32.770206480502765, 3.225542642490623],
            [32.76961116516732, 3.224873027968778],
            [32.76852896384622, 3.219209350670138],
            [32.76662445100226, 3.21669384449409],
            [32.76718430085027, 3.214965993079964],
            [32.766660665684654, 3.214531615533489],
            [32.764588794008276, 3.214531137484796],
            [32.763398163337456, 3.213282373096516],
            [32.763184111873244, 3.212070024174623],
            [32.76473236814687, 3.211536609207259],
            [32.765056068873, 3.209864954571707],
            [32.766606460442055, 3.20784194621596],
            [32.76736915706774, 3.205065434525842],
            [32.767702569480385, 3.205017633697635],
            [32.7687982599038, 3.20609507162618],
            [32.77010755622703, 3.206238961871612],
            [32.77038152711734, 3.205772264066847],
            [32.77076762302645, 3.206352045962701],
            [32.770505743459886, 3.207069430329688],
            [32.771410305628486, 3.207716604250294],
            [32.77176600614165, 3.208598544108903],
            [32.7731671632875, 3.208788938625657],
            [32.77504877627825, 3.207544634714793],
            [32.776834708809794, 3.208263142966893],
            [32.777267926745424, 3.209870198780788],
            [32.777667818980696, 3.210130402822643],
            [32.77835853629759, 3.209699688873857],
            [32.77907286762837, 3.210178587287452],
            [32.779715882607064, 3.210059037825943],
            [32.77952561044672, 3.208910024637081],
            [32.78050208365214, 3.208551170373635],
            [32.7808119161869, 3.207426212358685],
            [32.78025268617643, 3.20549916225003],
            [32.78070555565726, 3.203680053595136],
            [32.779801083320166, 3.201429775820189],
            [32.78061088849768, 3.200855466795506],
            [32.78001567826513, 3.20020903835707],
            [32.782504626049814, 3.198545956772048],
            [32.78226667670409, 3.197612361998386],
            [32.78369593045709, 3.195745576205646],
            [32.783862822165545, 3.19481207216307],
            [32.783362872879, 3.194069917053008],
            [32.78379055719251, 3.193497094588604],
            [32.78254167796204, 3.192190692589872],
            [32.782803774022575, 3.191568383202861],
            [32.782399080292144, 3.19085019510873],
            [32.782780199534585, 3.190419409374416],
            [32.78213752861065, 3.188935173891893],
            [32.7824472506526, 3.188288943342912],
            [32.781947189076654, 3.18812127578932],
            [32.78166161554617, 3.187211614076718],
            [32.78247287599441, 3.179647702760322],
            [32.785711714022064, 3.178906334086949],
            [32.78590166638214, 3.178620065323483],
            [32.785473750303275, 3.17809242806061],
            [32.7877363064667, 3.176943919057977],
            [32.789546630953126, 3.174598466224384],
            [32.79213063666451, 3.173533799072213],
            [32.79294052269039, 3.172456797917409],
            [32.79353622160642, 3.170661648195101],
            [32.7955368182532, 3.16941731877759],
            [32.797918164934785, 3.169537476606458],
            [32.80028732237634, 3.17105793960147],
            [32.80216868024554, 3.17072317559728],
            [32.8042403524959, 3.171345938863317],
            [32.804883500425255, 3.170388580109546],
            [32.805526463301646, 3.170412631565946],
            [32.806788809176545, 3.16923995939607],
            [32.80816982699207, 3.170197699515665],
            [32.80883671110617, 3.169671209623795],
            [32.808884469139954, 3.168977044314442],
            [32.809433059504165, 3.169096129452433],
            [32.811373187854215, 3.167912307691838],
            [32.81127807962182, 3.167074493954698],
            [32.81223067560699, 3.166859229342107],
            [32.813516862769525, 3.165399312919365],
            [32.813872325229156, 3.165415615786432],
            [32.817184027406114, 3.166189885073597],
            [32.81751756378629, 3.165352151565054],
            [32.8183272836238, 3.164993238160777],
            [32.820791825080526, 3.165963123246085],
            [32.82441185062259, 3.163881217624472],
            [32.82526941203719, 3.162301518657624],
            [32.826412299047306, 3.163211319810016],
            [32.82793636099541, 3.163259448170177],
            [32.82892477281095, 3.162361972910529],
            [32.83095004977184, 3.161421885558859],
            [32.83337215840777, 3.161998931614763],
            [32.840001541049965, 3.160846669854151],
            [32.84344352050268, 3.16148792695276],
            [32.843512105078005, 3.163350337556003],
            [32.84573789768839, 3.163858966187086],
            [32.84618417353502, 3.163282379505931],
            [32.847586501185724, 3.163346660075382],
            [32.84828774226618, 3.162834177908912],
            [32.851538675210826, 3.162322069516218],
            [32.85612810511531, 3.162482899344681],
            [32.857658080672905, 3.161329800372026],
            [32.858741994182935, 3.159151470489997],
            [32.861164375906746, 3.157806265086047],
            [32.864096515621675, 3.157806655259877],
            [32.865119205351824, 3.159312250580723],
            [32.86613609825345, 3.159056341749663],
            [32.87008803691993, 3.159697575736953],
            [32.87066686457661, 3.16008730746213],
            [32.87194027949245, 3.171748745373964],
            [32.8713024208435, 3.175208616232334],
            [32.87174764655956, 3.181837964397256],
            [32.87665052471784, 3.184718885724431],
            [32.90523393250497, 3.198743315018254],
            [32.91495903088876, 3.203464144581369],
            [32.91910227028661, 3.205867224360218],
            [32.92012614848785, 3.207149406752083],
            [32.92133323988795, 3.207341074251419],
            [32.92152813388043, 3.208045659053897],
            [32.922544353045595, 3.207981896997364],
            [32.922802758826954, 3.208687197089915],
            [32.92624665258959, 3.209653294611146],
            [32.92535375684156, 3.215932381533409],
            [32.92203845691186, 3.222819989970465],
            [32.918213259752186, 3.228137741916848],
            [32.91789383321019, 3.236755539756557],
            [32.91655492212698, 3.23944649772478],
            [32.9116522002756, 3.246420920019914],
            [32.91355306416288, 3.245784248927391],
            [32.9178882385026, 3.241683940547874],
            [32.91890832940665, 3.240018121253174],
            [32.92305196136826, 3.239249569794211],
            [32.92439075117889, 3.237904143012861],
            [32.92796060581234, 3.237840333498959],
            [32.929235590084964, 3.237199687406778],
            [32.931426495722995, 3.236854995920815],
            [32.92965902267224, 3.240133163064743],
            [32.92878969512403, 3.241030748661692],
            [32.92883474024562, 3.253087337624424],
            [32.92919187626661, 3.254344063809333],
            [32.93051352891658, 3.256211262176018],
            [32.9321386028251, 3.26150745204031],
            [32.93424605766817, 3.26534948638702],
            [32.93521055183929, 3.266211277530662],
            [32.935692608481986, 3.269855736062205],
            [32.93596330860633, 3.270127853719041],
            [32.93657960768847, 3.2682213756685],
            [32.93732111485322, 3.267476195334237],
            [32.940286919831735, 3.268018360131261],
            [32.94150011169092, 3.269847624925513],
            [32.94379180021898, 3.271676950956389],
            [32.94615095761477, 3.272422306642472],
            [32.948577264976365, 3.278316502877848],
            [32.95360254038872, 3.284411386105749],
            [32.95460441076385, 3.287424823199945],
            [32.95492842230706, 3.293656594279137],
            [32.95603734042301, 3.297767114904987],
            [32.959849712335384, 3.3019474147623],
            [32.96545591117399, 3.307166479703262],
            [32.963869900505586, 3.310934866619586],
            [32.965741327499316, 3.316996133875828],
            [32.96740494452343, 3.319086259353285],
            [32.9681673995023, 3.321246022815019],
            [32.96927648560323, 3.32263943668734],
            [32.96816726475503, 3.325426159880706],
            [32.968652294821325, 3.332253731760976],
            [32.97128623518443, 3.341519782821973],
            [32.97142475001134, 3.346048266613537],
            [32.97327142482575, 3.348620495837554],
            [32.974025598236004, 3.35076074596938],
            [32.97477980398562, 3.351652527358629],
            [32.97502079592518, 3.353289604529443],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 571,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "LABONGO AMIDA",
        Population: 15685,
        Key: "KITGUMLABONGO AMIDA",
        Dist2: "Kitgum",
        "Sub Country": "Labongo Amida",
        id2_original: "Kitgum  Labongo Amida",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.271189084740186, 3.51392127525222],
            [33.23905447403988, 3.512651229103322],
            [33.22456584416467, 3.515566682759309],
            [33.220467211510595, 3.515963077814679],
            [33.20323551662651, 3.519962286772485],
            [33.19820472466, 3.521557238035338],
            [33.18881808632241, 3.522247018469461],
            [33.183619598655284, 3.521934987150082],
            [33.17559846512657, 3.519745656041298],
            [33.17378100532187, 3.519636049522742],
            [33.17041980507441, 3.518416440770672],
            [33.168005563883696, 3.517047576711915],
            [33.16218848373554, 3.515889631718112],
            [33.15777144951722, 3.513377015699445],
            [33.15594165404701, 3.51179749307408],
            [33.155513234911574, 3.510965382961508],
            [33.1534425076889, 3.50957760430916],
            [33.15231314930697, 3.508091116074389],
            [33.15063826561256, 3.50799239240371],
            [33.14869203051521, 3.507074502513161],
            [33.14240781024962, 3.508291017465658],
            [33.141601984608826, 3.509069827039322],
            [33.14011401247728, 3.508571692765692],
            [33.139649110063225, 3.509007827689858],
            [33.13714174412028, 3.509008199791789],
            [33.13623942235, 3.509537839639368],
            [33.133635649210795, 3.509880840233961],
            [33.13158970920173, 3.509320476629917],
            [33.130413486609754, 3.508210881891722],
            [33.12898411248248, 3.507808934287782],
            [33.128117514016104, 3.506143916282685],
            [33.12461425418962, 3.502282101796775],
            [33.12422061692371, 3.500723753387053],
            [33.12213408653853, 3.499541448869811],
            [33.120645581706, 3.498837965340156],
            [33.11936471346825, 3.499121085924499],
            [33.11461418419229, 3.498182652450721],
            [33.114614098852336, 3.497478380649283],
            [33.108669263897696, 3.496805475574373],
            [33.10163367386383, 3.498365233745039],
            [33.09277236491451, 3.502100323756679],
            [33.08962818685993, 3.505260311889305],
            [33.087913253575216, 3.507845669310874],
            [33.08105282603859, 3.511293215657201],
            [33.08102757529427, 3.511589531741812],
            [33.080418250731995, 3.51138884829945],
            [33.07755493634088, 3.512995005033517],
            [33.07697477109273, 3.51286052527731],
            [33.071485805991955, 3.515237612428903],
            [33.064166910673684, 3.51505877783997],
            [33.062024832064616, 3.515552189715701],
            [33.05934736742768, 3.518332596740372],
            [33.055063257820265, 3.520530139727119],
            [33.04711962913767, 3.522189747865051],
            [33.044308085554675, 3.522189886840924],
            [33.04081316299236, 3.519075496314818],
            [33.032235967811204, 3.509570494925383],
            [33.03110067246355, 3.505514922039108],
            [33.029218203378335, 3.501899507368382],
            [33.028588788893074, 3.501696235045215],
            [33.02744537636852, 3.503009435073488],
            [33.02683769662153, 3.503080990279023],
            [33.027442870967185, 3.503009435073488],
            [33.02858628708499, 3.501696235045215],
            [33.0243035015943, 3.499926866883681],
            [33.019157962426654, 3.49845486290269],
            [33.017514263747344, 3.498490794005762],
            [33.0146556439519, 3.497736841302178],
            [33.01259861963056, 3.495971306885868],
            [33.0113805463261, 3.493931398338123],
            [33.008565454397754, 3.491456312635409],
            [33.00759099880848, 3.490041966949115],
            [33.006305252718725, 3.484914964486594],
            [33.00438343652577, 3.483255836322609],
            [33.00380725350928, 3.479574281732443],
            [33.00281455493318, 3.479573794846485],
            [33.0007831766149, 3.478586097277278],
            [32.999767490150695, 3.478849485788044],
            [32.997932700047514, 3.478487326566768],
            [32.9959340868809, 3.479112863465274],
            [32.994492466919695, 3.478948238527402],
            [32.99334571805215, 3.479540851585444],
            [32.992821493591705, 3.479376231205644],
            [32.992690432086675, 3.480001773790727],
            [32.99010205517312, 3.480857756202381],
            [32.9872843428591, 3.480199255704458],
            [32.98119021329411, 3.480001613288785],
            [32.97725855948509, 3.478124896414862],
            [32.975325525130806, 3.476346987099544],
            [32.97503067020681, 3.47552389557464],
            [32.97115856571794, 3.473498125245889],
            [32.96801427178067, 3.470721329839481],
            [32.967061476369516, 3.469380824198633],
            [32.96610874563705, 3.466316852202356],
            [32.96553718535102, 3.462391160090423],
            [32.96584451158611, 3.4571880738445],
            [32.96298533663184, 3.455726640467934],
            [32.9579423590185, 3.452541672290352],
            [32.95681175467327, 3.451213462289443],
            [32.95571585584073, 3.45067479229941],
            [32.95327510267104, 3.447721010506405],
            [32.95240900995614, 3.446039995246176],
            [32.95063516515511, 3.444452354989866],
            [32.94904644067621, 3.43976123569307],
            [32.94922766949658, 3.438236899050547],
            [32.950151870633924, 3.437469725786402],
            [32.95054517731984, 3.436004752432578],
            [32.95142249089092, 3.433739543653804],
            [32.953451178754925, 3.432477817746192],
            [32.95370981270839, 3.431928844791368],
            [32.95425861776997, 3.432092151661794],
            [32.954493576624095, 3.431567133949193],
            [32.955775470737905, 3.43086920518501],
            [32.95650620800072, 3.429627169850489],
            [32.95648971223715, 3.428877540918409],
            [32.95765119347535, 3.427966136324953],
            [32.95823511637631, 3.426082347375316],
            [32.95972769506867, 3.424788140563172],
            [32.95967247832308, 3.423550832870818],
            [32.958707345449824, 3.419570000268917],
            [32.95886969168293, 3.418855008106632],
            [32.95661671784865, 3.414596303619935],
            [32.95667768471036, 3.412882284534609],
            [32.955985123152196, 3.412577034008428],
            [32.955790820251174, 3.411959374125809],
            [32.956059384181785, 3.411089034159699],
            [32.955125601613595, 3.410285415988958],
            [32.95493070582452, 3.409572574434361],
            [32.95624943086496, 3.407113161695057],
            [32.95598118763291, 3.406091337506243],
            [32.95705702439024, 3.404811521362952],
            [32.9567673123212, 3.40417064911684],
            [32.957254188425416, 3.402001851745483],
            [32.95709964855215, 3.400098712359276],
            [32.956598211655475, 3.399887521614399],
            [32.95716279113346, 3.398741689218489],
            [32.95655120551163, 3.398043243389874],
            [32.956710053705, 3.396757048831501],
            [32.955792684255385, 3.394739490457182],
            [32.95597576540186, 3.39352454557322],
            [32.954944870459926, 3.392412119994889],
            [32.95480710482793, 3.391306201690932],
            [32.954210555207304, 3.391119389654158],
            [32.95360933883879, 3.390170956825626],
            [32.95303747222725, 3.390126804775401],
            [32.9527133169536, 3.387748653966759],
            [32.95058064370558, 3.385619395875533],
            [32.950602132305484, 3.385238454798716],
            [32.94991046097774, 3.385075998161828],
            [32.94939342124291, 3.384257980757546],
            [32.94803126804837, 3.383504527724523],
            [32.94776247235241, 3.382387501957199],
            [32.9470199914139, 3.381701735139571],
            [32.94708750429906, 3.381058712402388],
            [32.94651652881628, 3.381157335351214],
            [32.94651492981508, 3.380895537663454],
            [32.94736675279165, 3.379985999540867],
            [32.94738664328869, 3.379343268904596],
            [32.949505246224426, 3.377224172316288],
            [32.95017527623867, 3.377743761108625],
            [32.95079316803379, 3.377525843409499],
            [32.950907286414235, 3.376715928101937],
            [32.95042620085033, 3.375933403543283],
            [32.95084876566505, 3.37493121588027],
            [32.9506548948537, 3.374384971250893],
            [32.9520088706842, 3.373805618893251],
            [32.951998390938094, 3.372092022462993],
            [32.952737684654, 3.37225418175558],
            [32.953431864078, 3.370881466637057],
            [32.952834439498304, 3.370551836049609],
            [32.9535050076034, 3.367263294497429],
            [32.952301321716526, 3.36515226041481],
            [32.95219228959722, 3.360952083937642],
            [32.95123677768064, 3.360481796011768],
            [32.951559273765966, 3.358694805824905],
            [32.95184316295532, 3.358383681397961],
            [32.95263152265205, 3.358783562959426],
            [32.953574520138396, 3.35720703707826],
            [32.95483336527864, 3.356652060485588],
            [32.95522976396574, 3.355269231982509],
            [32.956182060811905, 3.355215903437497],
            [32.957272168205826, 3.354328711411526],
            [32.95872974583975, 3.355863619926632],
            [32.95891117049285, 3.358266405960091],
            [32.95962968437958, 3.358928510927608],
            [32.96234531304305, 3.359031184148198],
            [32.96271288119943, 3.360718828601539],
            [32.96411854968464, 3.360805566921954],
            [32.965220189650196, 3.359858815535786],
            [32.96779715616303, 3.360652510633969],
            [32.968628918860986, 3.3603618941845],
            [32.96921132001589, 3.358240116172364],
            [32.97123353821323, 3.357894725007892],
            [32.97393529688871, 3.355736364874187],
            [32.974359867641446, 3.355067380370881],
            [32.974294994006556, 3.354199035759761],
            [32.97502079592518, 3.353289604529443],
            [32.980909637989846, 3.349327556685331],
            [32.98290393115828, 3.346376105629234],
            [32.98260323359163, 3.343950231345293],
            [32.98347984018859, 3.343207129254147],
            [32.98489728738385, 3.339402326850321],
            [32.9873083593182, 3.336460238039362],
            [32.98895109320693, 3.336378908809632],
            [32.99207251963032, 3.334705898456454],
            [32.99285091431558, 3.333338981328441],
            [32.99402990910853, 3.332656793260556],
            [32.99345829222861, 3.329892046835825],
            [32.996495056928055, 3.32655283575655],
            [32.999210241823754, 3.325619289008606],
            [33.00062931856294, 3.32117607549466],
            [33.00497002921976, 3.325894830641745],
            [33.00714934479398, 3.326828380715963],
            [33.00907856579983, 3.328228675920164],
            [33.00997174182223, 3.329449465859582],
            [33.011293651390375, 3.332716869629035],
            [33.01340156706918, 3.335768823237445],
            [33.01765308939135, 3.33891049484011],
            [33.02072559895423, 3.339879885312584],
            [33.03991091398561, 3.341315510635423],
            [33.044841162912284, 3.340309946005283],
            [33.05002161330679, 3.341602290902109],
            [33.05647646766231, 3.329323544508172],
            [33.0583148420435, 3.331471596694376],
            [33.06449589798526, 3.335230988374254],
            [33.067911513681025, 3.333677805844783],
            [33.06929404785275, 3.33343250453654],
            [33.07108325743843, 3.333759313760178],
            [33.07295370347187, 3.332860098707558],
            [33.07352309163155, 3.334249540395544],
            [33.07645095806069, 3.335638798071486],
            [33.07726431517681, 3.336783015175107],
            [33.08076222553575, 3.347244720835948],
            [33.0826331063538, 3.35133127515795],
            [33.08247066849256, 3.353946785978776],
            [33.08279611284861, 3.355499708617301],
            [33.080194137238294, 3.36203866839041],
            [33.07954371924333, 3.364654215995858],
            [33.080601030942844, 3.365062800794999],
            [33.08230894479194, 3.365062657312383],
            [33.08426099917569, 3.366860642720105],
            [33.086782252174636, 3.367350826768639],
            [33.09158063740074, 3.366859979114174],
            [33.09410120947665, 3.360239266159108],
            [33.094344982600354, 3.358032419112262],
            [33.09727249599157, 3.35484449573808],
            [33.10678790602849, 3.354843498523409],
            [33.10776350427483, 3.351737491758993],
            [33.1083322797835, 3.346996844666676],
            [33.10995844873834, 3.343563826901452],
            [33.11332831413503, 3.331722976084404],
            [33.11422137696969, 3.330825220951351],
            [33.113756758423285, 3.329245435094434],
            [33.114256588233886, 3.326426796553946],
            [33.114006275374905, 3.324344301378257],
            [33.11443492717399, 3.323877466535142],
            [33.114863229528396, 3.320322777155702],
            [33.115399087171795, 3.319963644323644],
            [33.11529180047908, 3.319101939151866],
            [33.11686349649344, 3.316983331908245],
            [33.116863397678756, 3.316139551392088],
            [33.11836368122129, 3.31452361572623],
            [33.11850633548506, 3.312441064965686],
            [33.11936356092974, 3.310825205767773],
            [33.119398968925005, 3.308168205658908],
            [33.11883812554028, 3.306309525504002],
            [33.11962378400294, 3.306048126650009],
            [33.12008837110831, 3.307232959117513],
            [33.122196225701686, 3.30777128185725],
            [33.123018080880385, 3.309135580700596],
            [33.12484001339694, 3.308560871209866],
            [33.12576903938566, 3.309853355466209],
            [33.12927021062912, 3.310247863307235],
            [33.129020235536686, 3.311109630898071],
            [33.129484728318964, 3.311540437734594],
            [33.13105672616725, 3.312042895406644],
            [33.13230725739955, 3.313048086204369],
            [33.13216450791436, 3.314268893120654],
            [33.13320064542433, 3.314986874915618],
            [33.13337939848776, 3.315884484827149],
            [33.13430827984775, 3.315992082452497],
            [33.13480876273358, 3.318325864154918],
            [33.135594701470595, 3.318056474314886],
            [33.13616635697805, 3.318343631737207],
            [33.136488042782986, 3.31949257626834],
            [33.13823889430604, 3.321538943083624],
            [33.13902492736616, 3.321933794223599],
            [33.141597687966836, 3.325452161777166],
            [33.14191936658523, 3.326421574477247],
            [33.142848350353155, 3.327103634137983],
            [33.142884215590875, 3.328055133421929],
            [33.14431371907554, 3.331142793130142],
            [33.14792252196473, 3.334230122100976],
            [33.14845856645772, 3.335163592528312],
            [33.14842296622301, 3.336025331185342],
            [33.14928038211055, 3.335881568975875],
            [33.15006642774709, 3.336312317465519],
            [33.15013798664431, 3.33703042759281],
            [33.1526035378074, 3.339704997892093],
            [33.153461246545724, 3.341428323893053],
            [33.155640885513456, 3.343474590399343],
            [33.15667739133267, 3.346095523534869],
            [33.157249092654205, 3.346598115136625],
            [33.15742793554918, 3.347944538471028],
            [33.15860705520796, 3.348734265120268],
            [33.158321376574584, 3.349524238644038],
            [33.15882173279795, 3.350709043936714],
            [33.160250943431826, 3.35149872800068],
            [33.161037196579194, 3.353078426023919],
            [33.162073317919486, 3.353329607967319],
            [33.16371718188879, 3.355842708930006],
            [33.16443179708724, 3.356201648393447],
            [33.165682527745496, 3.357906948920625],
            [33.165861334707856, 3.358840457772414],
            [33.16694435259755, 3.359233906602857],
            [33.16704085591357, 3.361928118264752],
            [33.16779129772215, 3.362933344116423],
            [33.16825632590033, 3.366236564195593],
            [33.1680062555865, 3.366416137850035],
            [33.1691138540773, 3.366613429754104],
            [33.16929258019129, 3.367116071779929],
            [33.168828233834404, 3.367834263319181],
            [33.16900710367883, 3.369162730191844],
            [33.170114713847724, 3.369413872123371],
            [33.1704722783651, 3.371137275765018],
            [33.171294072458366, 3.371460272816551],
            [33.171222765987764, 3.372286110887327],
            [33.171615870552706, 3.372860520317034],
            [33.170972880726836, 3.373471030221639],
            [33.17125882256663, 3.374153190712581],
            [33.17200910896665, 3.374188966873808],
            [33.17215225640549, 3.375481531478464],
            [33.1730813389881, 3.376432857268798],
            [33.17304593638275, 3.378228135876647],
            [33.174725272127716, 3.378945944363526],
            [33.174439656376364, 3.380059064253762],
            [33.17486864953525, 3.381531115680245],
            [33.17515437128778, 3.380956575970161],
            [33.175475978939275, 3.381243751708838],
            [33.176977070965556, 3.384080001233555],
            [33.17661999782666, 3.385157237244634],
            [33.177227617386514, 3.386503585755551],
            [33.177192183340146, 3.388083426029457],
            [33.17787105816666, 3.388334635701033],
            [33.17804999089314, 3.389914445186762],
            [33.17997976166796, 3.392319752962579],
            [33.180480488895526, 3.395084376208169],
            [33.179576890619245, 3.396989605915051],
            [33.180255884023346, 3.397743495913164],
            [33.1812919442782, 3.397384241806043],
            [33.181899824349514, 3.400041127686804],
            [33.18157826520704, 3.400005280742245],
            [33.18168558064582, 3.400651564854761],
            [33.18272182236036, 3.401297662013634],
            [33.18250761728421, 3.40215943538459],
            [33.18307939675919, 3.402733803772086],
            [33.183508633361484, 3.405318915955322],
            [33.18297289519405, 3.406396179389528],
            [33.183651982921276, 3.407598877595473],
            [33.18322364463425, 3.409825094005675],
            [33.184402914311676, 3.410937936193098],
            [33.183188552846, 3.413200202055986],
            [33.18461802219468, 3.41474386972642],
            [33.18504707374403, 3.416305665674766],
            [33.18558302660885, 3.416377377178969],
            [33.185976318023386, 3.417777610680426],
            [33.18733435154404, 3.419357176396703],
            [33.18812076459153, 3.42129591308331],
            [33.1880139989217, 3.423450261220937],
            [33.18926533684113, 3.427525268846391],
            [33.190515921972334, 3.427740446556015],
            [33.19033737821636, 3.428279072116078],
            [33.19065898496955, 3.428458527519231],
            [33.19223109241231, 3.428422313088542],
            [33.19305310838946, 3.429571121213696],
            [33.19444149688187, 3.429971937268529],
            [33.19808125481745, 3.428990131458917],
            [33.19912688033343, 3.427863846149651],
            [33.20260044544989, 3.427037331124646],
            [33.20420632595406, 3.425835849007154],
            [33.20637284412876, 3.426323345263777],
            [33.207792120293895, 3.425872609632095],
            [33.20909959393541, 3.42658550005052],
            [33.21216203248567, 3.424670509115284],
            [33.21264738414885, 3.423656940810154],
            [33.213767896820194, 3.423469012369872],
            [33.21387979366691, 3.422755812058446],
            [33.215000079962785, 3.421554422310501],
            [33.216382188333085, 3.421967000328063],
            [33.21660610419743, 3.421103631528177],
            [33.21724108374591, 3.421103487157152],
            [33.21761439752683, 3.420202548797914],
            [33.21862285973952, 3.420052175915044],
            [33.21877214716332, 3.419526644056804],
            [33.22056472632962, 3.418212488091247],
            [33.222357560617496, 3.418024394484267],
            [33.223851293644955, 3.416597694693101],
            [33.22415021973383, 3.417085587514971],
            [33.22512142971002, 3.417385642817822],
            [33.22575629247748, 3.416897531349238],
            [33.22829638314792, 3.41768517434374],
            [33.228408624947726, 3.418473393280559],
            [33.22908108759973, 3.419036265882027],
            [33.233040359213895, 3.419035307292263],
            [33.23289112389236, 3.419748519339529],
            [33.23610352180628, 3.420385833791391],
            [33.240474497603344, 3.423725402080349],
            [33.24103506520526, 3.424888861823217],
            [33.24159536061762, 3.424963790083662],
            [33.24338877970874, 3.427065320994406],
            [33.24432249220832, 3.426727262603179],
            [33.25156983671419, 3.428442600200088],
            [33.25180954496123, 3.429336384052952],
            [33.25280189858427, 3.430264347703725],
            [33.25362312853553, 3.430917325078208],
            [33.25461526746119, 3.431020195991759],
            [33.255470964871584, 3.432635767615442],
            [33.256599819298636, 3.432257298540776],
            [33.25725017530984, 3.433563514646794],
            [33.25848173591998, 3.43346004411292],
            [33.26214279919915, 3.435315493527558],
            [33.26303268648927, 3.436793532854309],
            [33.26494898253482, 3.43854631462652],
            [33.265394019604656, 3.439611930266137],
            [33.26703640674367, 3.440539694724856],
            [33.26854217450102, 3.442258204220632],
            [33.27083472541176, 3.443701457228007],
            [33.27226477866538, 3.444133285743936],
            [33.27292124052555, 3.447239507898103],
            [33.272819666219746, 3.451986168682188],
            [33.27431780817864, 3.455839351576861],
            [33.276229150015396, 3.462632215141018],
            [33.26950078470702, 3.482956172135459],
            [33.26849359181383, 3.489445625958065],
            [33.2683932329286, 3.491372127255756],
            [33.270059299658506, 3.49537666073237],
            [33.26995894436653, 3.497303152545945],
            [33.270918506786714, 3.500648850847546],
            [33.27192812153792, 3.502625721042472],
            [33.272256676759824, 3.50476120542668],
            [33.271189084740186, 3.51392127525222],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 572,
        District: "KITGUM",
        County: "CHUA",
        Subcounty: "MUCWINI",
        Population: 21176,
        Key: "KITGUMMUCWINI",
        Dist2: "Kitgum",
        "Sub Country": "Mucwini",
        id2_original: "Kitgum  Mucwini",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.271189084740186, 3.51392127525222],
            [33.26784923565041, 3.52985724657427],
            [33.26993178829551, 3.534419328649354],
            [33.26949147007582, 3.538411794650834],
            [33.26993497461981, 3.545414105859972],
            [33.27182775277122, 3.547884986631303],
            [33.27378335460204, 3.549468680687224],
            [33.27479302325213, 3.551369502317936],
            [33.27409964961692, 3.552700508362633],
            [33.27397408130988, 3.554601640729718],
            [33.2755519810896, 3.558561828647709],
            [33.275868023677894, 3.560906436520387],
            [33.27933775208979, 3.563947161553751],
            [33.283374692043395, 3.565403453184662],
            [33.2871601414467, 3.569458005521271],
            [33.289683563877034, 3.571421667773946],
            [33.29182811285314, 3.571896268240966],
            [33.3021086683232, 3.572209777276851],
            [33.30646074087175, 3.572905410370242],
            [33.30740757236774, 3.575186422229348],
            [33.30766064305461, 3.577657783442186],
            [33.30696837704216, 3.58215730103451],
            [33.30589677134986, 3.583932026753622],
            [33.30564561227788, 3.587322408237399],
            [33.304132363350874, 3.588653701072939],
            [33.30356547969419, 3.590998604087293],
            [33.30261998309472, 3.592773276774992],
            [33.302242315179605, 3.595118126171737],
            [33.300666429422755, 3.597843549294307],
            [33.299784297288475, 3.600473721006585],
            [33.29890308502906, 3.606050591764587],
            [33.29884140580332, 3.610296414706888],
            [33.29688749190694, 3.614447812464212],
            [33.29518671876605, 3.621228994427086],
            [33.29398921957652, 3.624017680956321],
            [33.29411656744615, 3.627756496094684],
            [33.29342756680975, 3.634885874458127],
            [33.29387015776709, 3.638180985053638],
            [33.29374547789388, 3.642712001646703],
            [33.29481936620534, 3.647654530857595],
            [33.297154160392274, 3.650695531478793],
            [33.29867067379704, 3.658838101963828],
            [33.30290064463725, 3.6703066844854],
            [33.30782355163307, 3.674141155665137],
            [33.30990454839609, 3.677116565127857],
            [33.31211334577961, 3.67920763580355],
            [33.31337531705705, 3.681424516380406],
            [33.31381763851981, 3.683642313895072],
            [33.316342130843616, 3.685670389536438],
            [33.31823520094751, 3.689565842169927],
            [33.3172907374106, 3.694382307353463],
            [33.31659750121765, 3.696156918677787],
            [33.31514729336232, 3.697868429275299],
            [33.31451777916405, 3.701480748372166],
            [33.31237405304474, 3.70423810893496],
            [33.31256382574177, 3.705758923715949],
            [33.31420476569486, 3.708229773210968],
            [33.31534078777959, 3.709117921536801],
            [33.315719667522025, 3.71101751431953],
            [33.31787043373818, 3.713430031909348],
            [33.320075757336525, 3.713745697755978],
            [33.32178260398707, 3.716723844742027],
            [33.32317050379595, 3.717103558118679],
            [33.32468414798171, 3.716342557077328],
            [33.32587808714774, 3.716657726158496],
            [33.32606739002589, 3.718174553775325],
            [33.327203712147885, 3.720550505566045],
            [33.32802429800709, 3.722007708246108],
            [33.329665042127445, 3.72340212601301],
            [33.32998111705511, 3.725555692277284],
            [33.32796384767668, 3.72910516708031],
            [33.328532589947685, 3.731829863039523],
            [33.327776295615045, 3.73366787467053],
            [33.32853428686526, 3.736392498207447],
            [33.32758849831333, 3.737565197967232],
            [33.32790463702136, 3.739529547340189],
            [33.32683332687477, 3.742444966593688],
            [33.32910771654542, 3.751632753149543],
            [33.330117609774355, 3.753153248405437],
            [33.330117872082404, 3.753850317618857],
            [33.32929791414558, 3.754167478449874],
            [33.329992325334935, 3.755497982930353],
            [33.32936192449945, 3.756638881128898],
            [33.329803862381574, 3.757589262165918],
            [33.32904715123065, 3.758349987191724],
            [33.32778565246704, 3.758794052701256],
            [33.32879494921464, 3.759430400063788],
            [33.32854369581953, 3.761582043756428],
            [33.32955297370252, 3.76221714042728],
            [33.32942738742916, 3.762975847252001],
            [33.328233540789604, 3.764106195163269],
            [33.179563975540376, 3.776032876750395],
            [33.17364341575966, 3.78063786959889],
            [33.15216483835188, 3.754131317275086],
            [33.14596120684874, 3.747009359921257],
            [33.141434648234345, 3.743975857214814],
            [33.13980454016695, 3.742252673606414],
            [33.128622243238276, 3.727375258049854],
            [33.125633541999804, 3.722363312815757],
            [33.11774069597848, 3.713546080045327],
            [33.11223566181393, 3.706207752586127],
            [33.11074845504699, 3.70304827778242],
            [33.108403465879846, 3.699716563477937],
            [33.0998258053714, 3.688700882555301],
            [33.08899966170676, 3.685434126384815],
            [33.084585728472824, 3.684806210533051],
            [33.080439777061144, 3.683370389041152],
            [33.06791278659378, 3.680804198803219],
            [33.05013198661083, 3.675293908173534],
            [33.02786613017959, 3.670519474823716],
            [33.017197861832905, 3.66576227762264],
            [33.01205140368873, 3.664146623198564],
            [33.00921539269233, 3.66262596679449],
            [32.9945363496213, 3.661040009848765],
            [32.98935705625686, 3.659378394042657],
            [32.98922965628496, 3.655014786532318],
            [32.992143683268814, 3.65170383922958],
            [32.99532919550457, 3.645603760236487],
            [32.99974216394789, 3.634347739002605],
            [33.00036246232968, 3.631644637538456],
            [33.00016481140761, 3.628114990052622],
            [32.99891100222286, 3.623757636634976],
            [32.99725526611871, 3.621269959192348],
            [32.9939434444658, 3.618881507577946],
            [32.99321982275837, 3.615754621818354],
            [32.992238771738236, 3.613850665174219],
            [32.99136673576944, 3.609689600955264],
            [32.990187235224994, 3.607251914290704],
            [32.991347927742346, 3.60006338699837],
            [32.99102423959265, 3.595672360888788],
            [32.99215736101732, 3.587703475464568],
            [32.992157396949935, 3.583475082178514],
            [32.993128622197446, 3.576644605720974],
            [32.99312867250311, 3.569976751524737],
            [32.99215758469783, 3.561357321586019],
            [32.99264323370335, 3.552087379410141],
            [32.99234438666622, 3.544430781611478],
            [32.99146268033337, 3.54205481637264],
            [32.99294562189933, 3.536980751854094],
            [32.99311217045133, 3.527428767900985],
            [32.9938268709897, 3.523479168569025],
            [32.995184752695074, 3.52240201239344],
            [33.00626211741543, 3.517877911466578],
            [33.01448464963757, 3.515022597215144],
            [33.015365357043784, 3.513278679930445],
            [33.01525814221634, 3.512201518242164],
            [33.01604425432819, 3.511375678615146],
            [33.016580253905396, 3.511591098152062],
            [33.01736636242399, 3.510657543196178],
            [33.01790236559448, 3.51058572585806],
            [33.017866604561334, 3.509185410844538],
            [33.019510317613694, 3.50893404122284],
            [33.02011773505264, 3.507138753436103],
            [33.022118753009245, 3.505774301317027],
            [33.02326220416138, 3.505630650642005],
            [33.023440871884844, 3.505989697936104],
            [33.02454859434318, 3.506061475278872],
            [33.02494164321257, 3.505594699190377],
            [33.024762972794136, 3.505127928248725],
            [33.025298967879785, 3.505235629328793],
            [33.02572774364637, 3.504517514297871],
            [33.02633514671222, 3.502722222516117],
            [33.02683769662153, 3.503080990279023],
            [33.02744537636852, 3.503009435073488],
            [33.028588788893074, 3.501696235045215],
            [33.029218203378335, 3.501899507368382],
            [33.03110067246355, 3.505514922039108],
            [33.032235967811204, 3.509570494925383],
            [33.04081316299236, 3.519075496314818],
            [33.044308085554675, 3.522189886840924],
            [33.04711962913767, 3.522189747865051],
            [33.055063257820265, 3.520530139727119],
            [33.05934736742768, 3.518332596740372],
            [33.062024832064616, 3.515552189715701],
            [33.064166910673684, 3.51505877783997],
            [33.071485805991955, 3.515237612428903],
            [33.07697477109273, 3.51286052527731],
            [33.07755493634088, 3.512995005033517],
            [33.080418250731995, 3.51138884829945],
            [33.08102757529427, 3.511589531741812],
            [33.08105282603859, 3.511293215657201],
            [33.087913253575216, 3.507845669310874],
            [33.08962818685993, 3.505260311889305],
            [33.09277236491451, 3.502100323756679],
            [33.10163367386383, 3.498365233745039],
            [33.108669263897696, 3.496805475574373],
            [33.114614098852336, 3.497478380649283],
            [33.11461418419229, 3.498182652450721],
            [33.11936471346825, 3.499121085924499],
            [33.120645581706, 3.498837965340156],
            [33.12213408653853, 3.499541448869811],
            [33.12422061692371, 3.500723753387053],
            [33.12461425418962, 3.502282101796775],
            [33.128117514016104, 3.506143916282685],
            [33.12898411248248, 3.507808934287782],
            [33.130413486609754, 3.508210881891722],
            [33.13158970920173, 3.509320476629917],
            [33.133635649210795, 3.509880840233961],
            [33.13623942235, 3.509537839639368],
            [33.13714174412028, 3.509008199791789],
            [33.139649110063225, 3.509007827689858],
            [33.14011401247728, 3.508571692765692],
            [33.141601984608826, 3.509069827039322],
            [33.14240781024962, 3.508291017465658],
            [33.14869203051521, 3.507074502513161],
            [33.15063826561256, 3.50799239240371],
            [33.15231314930697, 3.508091116074389],
            [33.1534425076889, 3.50957760430916],
            [33.155513234911574, 3.510965382961508],
            [33.15594165404701, 3.51179749307408],
            [33.15777144951722, 3.513377015699445],
            [33.16218848373554, 3.515889631718112],
            [33.168005563883696, 3.517047576711915],
            [33.17041980507441, 3.518416440770672],
            [33.17378100532187, 3.519636049522742],
            [33.17559846512657, 3.519745656041298],
            [33.183619598655284, 3.521934987150082],
            [33.18881808632241, 3.522247018469461],
            [33.19820472466, 3.521557238035338],
            [33.20323551662651, 3.519962286772485],
            [33.220467211510595, 3.515963077814679],
            [33.22456584416467, 3.515566682759309],
            [33.23905447403988, 3.512651229103322],
            [33.271189084740186, 3.51392127525222],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 573,
        District: "LAMWO",
        County: "LAMWO",
        Subcounty: "MADI  OPEI",
        Population: 11842,
        Key: "LAMWOMADI  OPEI",
        Dist2: "Lamwo",
        "Sub Country": "Madi Opei",
        id2_original: "Lamwo Madi Opei",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.923371454264714, 3.024768653151573],
            [30.923491101775724, 3.025470249187485],
            [30.920216084998334, 3.024743455527157],
            [30.918822404530555, 3.022298259623097],
            [30.917609395029373, 3.021975248603697],
            [30.915403587239094, 3.023292106716375],
            [30.91278351237242, 3.023666578357253],
            [30.912146362494216, 3.025589450040022],
            [30.908782424181773, 3.027437225291507],
            [30.907920694584245, 3.027240467379809],
            [30.90796489259453, 3.026934286715387],
            [30.90697974076516, 3.026334529751797],
            [30.906862020140426, 3.025375656561621],
            [30.910516015474965, 3.018567816707269],
            [30.905125574899586, 3.015432055844445],
            [30.90617588333317, 3.014958641518655],
            [30.906137416574392, 3.013210701856784],
            [30.906780065938758, 3.012564593584005],
            [30.906477171092945, 3.011576677110342],
            [30.90704420297164, 3.010968574251861],
            [30.906438923523094, 3.010398716976838],
            [30.90681690944182, 3.009904650669196],
            [30.906400778361174, 3.00952475235892],
            [30.908403143790736, 3.004356475158272],
            [30.908175538545514, 3.002494565747321],
            [30.90870460223039, 3.001506483163132],
            [30.90959159784362, 3.00150854645389],
            [30.912503025103035, 3.000936845217083],
            [30.916632435835396, 3.001071668770855],
            [30.921012943655935, 3.00180748674227],
            [30.921470007370818, 3.002558492714865],
            [30.924801874030987, 3.001194281211614],
            [30.926784343573626, 3.001475048479435],
            [30.929560621095163, 3.003923310735284],
            [30.931105990183486, 3.004643561544376],
            [30.933648182013375, 3.004877312851955],
            [30.931754847804793, 3.008890901352292],
            [30.93505612143961, 3.011889755223445],
            [30.93707248441794, 3.014338236304722],
            [30.933246932423714, 3.015214221749554],
            [30.93269775366297, 3.017788565873545],
            [30.92705382468411, 3.02336680172704],
            [30.924302343359347, 3.02169554336503],
            [30.923319344791718, 3.022379748181106],
            [30.923054738838253, 3.022683791527539],
            [30.923371454264714, 3.024768653151573],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 574,
        District: "ARUA",
        County: "ARUA MUNICIPALITY",
        Subcounty: "ARUA HILL DIVISION",
        Population: 18573,
        Key: "ARUAARUA HILL DIVISION",
        Dist2: "Koboko",
        "Sub Country": "Arua Hill",
        id2_original: "Koboko Arua Hill",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "#REF!",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.923371454264714, 3.024768653151573],
            [30.925378774801395, 3.024887513197067],
            [30.921619859834923, 3.028535996862615],
            [30.92275358941903, 3.032031850915038],
            [30.922035327958906, 3.032783228019748],
            [30.92057595459272, 3.033331497535075],
            [30.917366387270288, 3.032843371213167],
            [30.913327654279346, 3.036707913105094],
            [30.909842621270002, 3.03680315958961],
            [30.905389837696628, 3.037580845740183],
            [30.90504912108238, 3.036580242596781],
            [30.900509198231532, 3.031413250478302],
            [30.89759095186078, 3.029766278959569],
            [30.898088092115437, 3.029133774589684],
            [30.89892005244279, 3.02905762135651],
            [30.898995374382718, 3.028183635868178],
            [30.900356128900384, 3.026283441145843],
            [30.900242454287678, 3.025675481077879],
            [30.901225122275314, 3.024041352179583],
            [30.90353216480819, 3.024572885114035],
            [30.904893342432356, 3.023888637724932],
            [30.90500641068222, 3.022824644256406],
            [30.90383364929903, 3.021646914296487],
            [30.904097808789775, 3.020088905389908],
            [30.903492219422457, 3.018645072277437],
            [30.905125574899586, 3.015432055844445],
            [30.910516015474965, 3.018567816707269],
            [30.906862020140426, 3.025375656561621],
            [30.90697974076516, 3.026334529751797],
            [30.90796489259453, 3.026934286715387],
            [30.907920694584245, 3.027240467379809],
            [30.908782424181773, 3.027437225291507],
            [30.912146362494216, 3.025589450040022],
            [30.91278351237242, 3.023666578357253],
            [30.915403587239094, 3.023292106716375],
            [30.917609395029373, 3.021975248603697],
            [30.918822404530555, 3.022298259623097],
            [30.920216084998334, 3.024743455527157],
            [30.923491101775724, 3.025470249187485],
            [30.923371454264714, 3.024768653151573],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 575,
        District: "ARUA",
        County: "ARUA MUNICIPALITY",
        Subcounty: "RIVER OLI DIVISION",
        Population: 43389,
        Key: "ARUARIVER OLI DIVISION",
        Dist2: "Koboko",
        "Sub Country": "River Oli",
        id2_original: "Koboko River Oli",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "#REF!",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.892844825228025, 3.061338845123623],
            [30.89252200485089, 3.06199965977075],
            [30.89151031049981, 3.062131097490051],
            [30.891174091750234, 3.062734079089575],
            [30.890163083712036, 3.062516035666202],
            [30.890045217560246, 3.061372051502861],
            [30.889071303655058, 3.061579809777334],
            [30.889110366895174, 3.061001657418658],
            [30.88859885359599, 3.060733769958766],
            [30.88853461776497, 3.061254683659353],
            [30.887148641249073, 3.062058915063144],
            [30.886589996041877, 3.063258742306993],
            [30.8859460710698, 3.062819028031773],
            [30.884831040816675, 3.062839395145127],
            [30.88416194774528, 3.062286903082291],
            [30.882684937755112, 3.06361900812592],
            [30.881879883767155, 3.064046090081254],
            [30.881100381459177, 3.063873066231143],
            [30.880977639252002, 3.06432599961681],
            [30.88014845651551, 3.064630551406281],
            [30.87729745892527, 3.064477893835821],
            [30.87606617319961, 3.064781638254637],
            [30.87488285212024, 3.065477412516158],
            [30.873940927222357, 3.067337226497892],
            [30.873589865609304, 3.066172966553043],
            [30.87242132181636, 3.065558232212478],
            [30.87209133378158, 3.066059739026501],
            [30.871140617072008, 3.066204812885985],
            [30.871349774514535, 3.065188649594697],
            [30.87083890440911, 3.064734452658163],
            [30.869483878448, 3.065993282603367],
            [30.86850854969625, 3.066260783921649],
            [30.86799535025928, 3.066982384468838],
            [30.868639062330615, 3.068036998943516],
            [30.86951523683794, 3.068614407453726],
            [30.868477765329782, 3.069494181796153],
            [30.8677713553432, 3.069333541383104],
            [30.867066353914964, 3.068462521895429],
            [30.866290894924052, 3.066256339141949],
            [30.865512715834424, 3.065421919556454],
            [30.86557594914561, 3.06425849266286],
            [30.864493464855197, 3.063264240214394],
            [30.864546643323372, 3.062333677048742],
            [30.864207040620126, 3.062281258953567],
            [30.863464733954764, 3.062848878568144],
            [30.863369764961252, 3.064017944834351],
            [30.862688090085975, 3.06515479119295],
            [30.8600911666008, 3.066556818767461],
            [30.860635728020963, 3.067075283437568],
            [30.860171502936655, 3.067571024340588],
            [30.85636926941059, 3.069415545759997],
            [30.85505267247901, 3.068885175088571],
            [30.85276230986434, 3.071415649383462],
            [30.85201156262854, 3.071051974804771],
            [30.850495672654606, 3.072373366534219],
            [30.849208430869915, 3.072608748315946],
            [30.848334883036497, 3.071882666446071],
            [30.8456983510338, 3.073205533647781],
            [30.844449788908598, 3.0733595283302],
            [30.844549434531498, 3.073818210302958],
            [30.84343954174344, 3.073974011500736],
            [30.83871206952588, 3.072872575563219],
            [30.826572550288322, 3.07207580566745],
            [30.826784284099087, 3.071793147883866],
            [30.82571236040318, 3.071300744975633],
            [30.821692493829843, 3.071939583545141],
            [30.818859159813027, 3.074267155796571],
            [30.816380268667945, 3.074967955276339],
            [30.814390704231194, 3.074865818564874],
            [30.81350740967694, 3.074451691245315],
            [30.81320462352727, 3.073387808781622],
            [30.81274501578351, 3.057700517516553],
            [30.812249517649217, 3.058411983739141],
            [30.810803879523714, 3.05849919534799],
            [30.810899930088873, 3.059144092063112],
            [30.810214781428385, 3.05979141486894],
            [30.809037738674565, 3.058982334184671],
            [30.808360367627817, 3.059106983511723],
            [30.807660123677344, 3.058147632644974],
            [30.80512942758814, 3.057058477892962],
            [30.803399339724596, 3.056903669942986],
            [30.802696535575528, 3.057204720016347],
            [30.80146924645459, 3.056445950416756],
            [30.799137599066047, 3.056138648674943],
            [30.798863952467595, 3.055054139440569],
            [30.797460971741668, 3.054370629908466],
            [30.79580479366644, 3.05487137319551],
            [30.79464899157749, 3.05595293046299],
            [30.792769173420666, 3.055444886686109],
            [30.79158591612169, 3.059153859878983],
            [30.79212458728856, 3.060652121935976],
            [30.791526770145065, 3.061096638921279],
            [30.79006444671148, 3.060842070642251],
            [30.787682178358395, 3.061336167479122],
            [30.785942621353414, 3.061222281915482],
            [30.78393826256223, 3.060576477755329],
            [30.78242536846974, 3.059360694637452],
            [30.779513285440178, 3.057993007847579],
            [30.77656364654353, 3.057803190500816],
            [30.774369953433172, 3.05594152014168],
            [30.77281875787194, 3.05237002081923],
            [30.769641916175303, 3.050546392680961],
            [30.768734117376724, 3.049444581013181],
            [30.769565326712467, 3.046176921022599],
            [30.769375926816302, 3.044695108566317],
            [30.769867085189457, 3.042757312581125],
            [30.771190300908014, 3.041427387518043],
            [30.775154644410286, 3.03895626953843],
            [30.77880813668825, 3.033732777821778],
            [30.77912046833611, 3.031448758734935],
            [30.778315679351167, 3.03008522756641],
            [30.778164042832884, 3.028527410198044],
            [30.77846550845909, 3.024195877785413],
            [30.781073793835986, 3.020586068233103],
            [30.783947086713283, 3.018268081728484],
            [30.788855177795153, 3.016844041847313],
            [30.79246323957424, 3.014869721060135],
            [30.795096846662357, 3.011314617350604],
            [30.79850339296703, 3.008982078447198],
            [30.799235813672706, 3.007532419327469],
            [30.802923288319533, 3.004355315233041],
            [30.80631041394609, 3.003825471493868],
            [30.809321051145485, 3.002841855786987],
            [30.81766352283112, 3.005763132511068],
            [30.825428585299857, 2.999738687405],
            [30.826406307163534, 2.996176802657821],
            [30.825929556869198, 2.994389893885194],
            [30.83072449076798, 2.994504784935439],
            [30.832044044953438, 2.995593104570562],
            [30.83533156807622, 2.99590752482414],
            [30.836636022480093, 2.996477277525421],
            [30.83934536473317, 2.995737254906417],
            [30.84094670066033, 2.996980074972905],
            [30.844901002794344, 2.99721873049699],
            [30.846308720336733, 3.003564991425649],
            [30.848037413116657, 3.004179341197553],
            [30.846991266577827, 3.005722081258014],
            [30.84495328654051, 3.010703234638236],
            [30.846782154051024, 3.010921539703274],
            [30.84690790830933, 3.01159240910851],
            [30.84858742192072, 3.013735343393926],
            [30.848838709451787, 3.015188852562773],
            [30.848209289576605, 3.02023321665079],
            [30.845964057423476, 3.023038954050234],
            [30.844659556307214, 3.024042277052962],
            [30.84459832983241, 3.025275848401188],
            [30.843206421740707, 3.02850013865676],
            [30.843194055532496, 3.030082184741032],
            [30.84411085994178, 3.030929478510565],
            [30.844240242495527, 3.0319728657781],
            [30.845306791571137, 3.033495509982234],
            [30.846696699114702, 3.033769010823792],
            [30.847929581146605, 3.035083707942266],
            [30.849616301941502, 3.038352508520131],
            [30.851176715115884, 3.039645115550313],
            [30.852650981651152, 3.039766638203454],
            [30.854639302819585, 3.040911885084452],
            [30.85573105233383, 3.040602811715667],
            [30.857113543386397, 3.042399000715286],
            [30.858160387017904, 3.042430735622184],
            [30.85865024642719, 3.045503551443842],
            [30.859217658293254, 3.046006924514312],
            [30.859935934126433, 3.045832954064179],
            [30.8628099905717, 3.041686665421083],
            [30.865060029609932, 3.040196758082347],
            [30.868345926782066, 3.040756978826316],
            [30.87040036934526, 3.043272571032231],
            [30.87110040219168, 3.043690305764136],
            [30.873967283792766, 3.043824096886303],
            [30.87543044086292, 3.044979938066996],
            [30.87625279730158, 3.04629183529922],
            [30.877747656816435, 3.044830618305927],
            [30.879676206780758, 3.044412330537845],
            [30.879865114400182, 3.043842334768038],
            [30.881264204522576, 3.043386131972799],
            [30.881911189156504, 3.04218471449296],
            [30.882247081817635, 3.04224601794442],
            [30.88383603716356, 3.04414567776448],
            [30.884176987339753, 3.045969551777624],
            [30.885122697738264, 3.046805353585488],
            [30.884933913188046, 3.047717350621656],
            [30.886409580196855, 3.050111016676825],
            [30.88705254307324, 3.050300899073242],
            [30.887136982015008, 3.051356525673937],
            [30.88816279698403, 3.052047243952154],
            [30.888406138018105, 3.053165266953116],
            [30.889282709580748, 3.054064726954025],
            [30.889776783885345, 3.054442298849483],
            [30.890261105180887, 3.054254253424241],
            [30.890775717667786, 3.055621106249431],
            [30.891169628021554, 3.056990007960481],
            [30.89033802881697, 3.05820609247945],
            [30.89022509261945, 3.059802051008416],
            [30.891322218550687, 3.061055824791873],
            [30.892305462358397, 3.060941675470517],
            [30.892844825228025, 3.061338845123623],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 576,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "ADUMI",
        Population: 30773,
        Key: "ARUAADUMI",
        Dist2: "Koboko",
        "Sub Country": "Adumi",
        id2_original: "Koboko Adumi",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.93350672879716, 3.121527074926141],
            [30.932613106312076, 3.120870938347453],
            [30.931402777383703, 3.120719134728019],
            [30.929020327570903, 3.121631498028359],
            [30.92633467838341, 3.120567927580494],
            [30.925313744859643, 3.121328069486836],
            [30.92474636712957, 3.121138162106105],
            [30.92364972449196, 3.121670317629713],
            [30.919753679002447, 3.120150922673079],
            [30.91945123061932, 3.120530958414952],
            [30.918316547024393, 3.120379136806738],
            [30.918051929392835, 3.120797157905405],
            [30.917749255532573, 3.120455209070599],
            [30.915707290568665, 3.121633484844275],
            [30.912265821359004, 3.122393944408163],
            [30.91113148541209, 3.123344082604541],
            [30.908294965969265, 3.123534456913417],
            [30.906101800170003, 3.125016708438397],
            [30.905269785045427, 3.125168816409587],
            [30.90027711398629, 3.124029485208883],
            [30.893983933924055, 3.123438717671603],
            [30.883923917551176, 3.12419985583926],
            [30.883329764635747, 3.127758804240485],
            [30.880500216119536, 3.131042938169359],
            [30.87709691902123, 3.131807835415663],
            [30.875038927214344, 3.133032561617737],
            [30.87438105769412, 3.13413546598313],
            [30.872500439138392, 3.135271493416721],
            [30.871208830643106, 3.134307089833824],
            [30.868002242134146, 3.133323659681757],
            [30.862740800531896, 3.133274552238556],
            [30.85933451473865, 3.132667198603387],
            [30.855976245693988, 3.129256257124689],
            [30.85352593534802, 3.128607305674463],
            [30.85076471089568, 3.126973630547204],
            [30.846263873742807, 3.125682059781626],
            [30.84361613256199, 3.124048363056112],
            [30.840686431773083, 3.123842974284651],
            [30.837516189100523, 3.121851426416276],
            [30.834059423378218, 3.118101527501929],
            [30.83699394722187, 3.117660533527057],
            [30.841149244705754, 3.115062334890796],
            [30.845221101276174, 3.114813166857419],
            [30.84573864316924, 3.112324566236764],
            [30.848180946831086, 3.108366139792456],
            [30.853657503502845, 3.104950131288323],
            [30.855162562489415, 3.103136693330149],
            [30.858321980462783, 3.095090035495776],
            [30.85681678942387, 3.089713839965288],
            [30.859025415229183, 3.088614859286858],
            [30.86247986060312, 3.087997686359075],
            [30.863966441244294, 3.08690310464472],
            [30.86652730365906, 3.086119384219419],
            [30.872047489707516, 3.081517186169337],
            [30.87580114324135, 3.081507572844785],
            [30.87738657808965, 3.082179600265157],
            [30.878803060494285, 3.082010941543493],
            [30.880712983891197, 3.082529265944034],
            [30.882250465771335, 3.08157194094461],
            [30.884316190276174, 3.080958669539704],
            [30.884618997985406, 3.080428867038049],
            [30.883638626989978, 3.078470561665757],
            [30.885690126672312, 3.076416650028754],
            [30.88813076575596, 3.076027061321195],
            [30.888900682141553, 3.074948138268514],
            [30.892489430142046, 3.072039749774212],
            [30.893513249952843, 3.071990330010392],
            [30.89763875840358, 3.073782123969791],
            [30.89771025262211, 3.074425978997073],
            [30.898496911807968, 3.07518198916322],
            [30.90039293018261, 3.076139587217646],
            [30.900868737245894, 3.077960221452888],
            [30.902935120215865, 3.077951419898775],
            [30.90343383791213, 3.080115696726135],
            [30.90443717793107, 3.08140893781549],
            [30.90196870903994, 3.082302893288261],
            [30.90213295970143, 3.083170712581753],
            [30.902738235556725, 3.083702601968117],
            [30.90243595695518, 3.084576617587942],
            [30.90277695114883, 3.086514510077099],
            [30.901945134551948, 3.087160615182702],
            [30.901756297001132, 3.087996619813093],
            [30.90300426803485, 3.087768431874128],
            [30.903949840092807, 3.08803428440357],
            [30.903637252425074, 3.089842572476076],
            [30.90712869760893, 3.090589537912963],
            [30.909042861952344, 3.092383198620389],
            [30.909246572909296, 3.093278536114894],
            [30.90967428776554, 3.093451487016555],
            [30.909808328084008, 3.094949046945261],
            [30.91100681362371, 3.094985842988031],
            [30.911055884994393, 3.096156239217356],
            [30.912869390415278, 3.096899875911464],
            [30.914188510714432, 3.096541070910706],
            [30.914594520476772, 3.099054582580867],
            [30.916390947127436, 3.099780974190132],
            [30.91765796603847, 3.099800691167581],
            [30.91770801747115, 3.100471993886396],
            [30.918810595277844, 3.100858369541629],
            [30.919948318771674, 3.102610342791789],
            [30.921004662087327, 3.10317983714348],
            [30.921945976130843, 3.102530064110524],
            [30.922431980869213, 3.102645060222625],
            [30.923341472093792, 3.103962691906182],
            [30.924476055077402, 3.103848512205154],
            [30.925005805973495, 3.104646408212068],
            [30.92674589028957, 3.105672111008518],
            [30.926670733639646, 3.107154094367112],
            [30.92583628408063, 3.108752542161144],
            [30.927238987227124, 3.110041958508264],
            [30.926407186799892, 3.110840082153806],
            [30.92746648018291, 3.111789898000596],
            [30.928109454737427, 3.111827793167596],
            [30.92833662250309, 3.112587737770772],
            [30.929314572538836, 3.113446347965464],
            [30.92973668100939, 3.114677492007108],
            [30.930493212497268, 3.115019363785172],
            [30.93083382490691, 3.115703300757533],
            [30.931854984806137, 3.115665128560839],
            [30.932346812424196, 3.11612104654565],
            [30.932044577840117, 3.117147082620665],
            [30.930758961107774, 3.118097274894317],
            [30.93079690864032, 3.118477259353372],
            [30.932764154433823, 3.120148930472501],
            [30.93423925370736, 3.120338684647837],
            [30.933937087395254, 3.121592723274715],
            [30.93350672879716, 3.121527074926141],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 577,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "AROI",
        Population: 24361,
        Key: "ARUAAROI",
        Dist2: "Koboko",
        "Sub Country": "Aroi",
        id2_original: "Koboko Aroi",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.834059423378218, 3.118101527501929],
            [30.832117867605174, 3.117961035366545],
            [30.83005655113343, 3.11857794053736],
            [30.823018727887746, 3.118252734107179],
            [30.820958059999636, 3.118559031197374],
            [30.818929089166314, 3.120142249738515],
            [30.819436898711597, 3.123628786092923],
            [30.820519401866623, 3.125814128253767],
            [30.819724569808265, 3.129549894679184],
            [30.815980168023575, 3.131266543971868],
            [30.813870270661237, 3.131460011402585],
            [30.812504021148992, 3.132474872345463],
            [30.81091144918575, 3.131848005482619],
            [30.802936895999466, 3.133223402386836],
            [30.802470931776746, 3.129228057101193],
            [30.802930906033158, 3.124297693048011],
            [30.80084540332069, 3.120494740023159],
            [30.800542601001347, 3.119202880532739],
            [30.800887479510273, 3.110768033099435],
            [30.799935232969773, 3.10799401832327],
            [30.800171861792002, 3.101651040990512],
            [30.797559529504746, 3.096939738740935],
            [30.79536563337518, 3.094546079916179],
            [30.794249637433076, 3.092665323494304],
            [30.794459040115704, 3.079390920644781],
            [30.793848219858493, 3.072812389759531],
            [30.79498187218748, 3.069126698684567],
            [30.79509474190966, 3.066618942505996],
            [30.791526770145065, 3.061096638921279],
            [30.79212458728856, 3.060652121935976],
            [30.79158591612169, 3.059153859878983],
            [30.792769173420666, 3.055444886686109],
            [30.79464899157749, 3.05595293046299],
            [30.79580479366644, 3.05487137319551],
            [30.797460971741668, 3.054370629908466],
            [30.798863952467595, 3.055054139440569],
            [30.799137599066047, 3.056138648674943],
            [30.80146924645459, 3.056445950416756],
            [30.802696535575528, 3.057204720016347],
            [30.803399339724596, 3.056903669942986],
            [30.80512942758814, 3.057058477892962],
            [30.807660123677344, 3.058147632644974],
            [30.808360367627817, 3.059106983511723],
            [30.809037738674565, 3.058982334184671],
            [30.810214781428385, 3.05979141486894],
            [30.810899930088873, 3.059144092063112],
            [30.810803879523714, 3.05849919534799],
            [30.812249517649217, 3.058411983739141],
            [30.81274501578351, 3.057700517516553],
            [30.81320462352727, 3.073387808781622],
            [30.81350740967694, 3.074451691245315],
            [30.814390704231194, 3.074865818564874],
            [30.816380268667945, 3.074967955276339],
            [30.818859159813027, 3.074267155796571],
            [30.821692493829843, 3.071939583545141],
            [30.82571236040318, 3.071300744975633],
            [30.826784284099087, 3.071793147883866],
            [30.826572550288322, 3.07207580566745],
            [30.83871206952588, 3.072872575563219],
            [30.84343954174344, 3.073974011500736],
            [30.844549434531498, 3.073818210302958],
            [30.844449788908598, 3.0733595283302],
            [30.8456983510338, 3.073205533647781],
            [30.848334883036497, 3.071882666446071],
            [30.849208430869915, 3.072608748315946],
            [30.850495672654606, 3.072373366534219],
            [30.85201156262854, 3.071051974804771],
            [30.85276230986434, 3.071415649383462],
            [30.85505267247901, 3.068885175088571],
            [30.85636926941059, 3.069415545759997],
            [30.860171502936655, 3.067571024340588],
            [30.860635728020963, 3.067075283437568],
            [30.8600911666008, 3.066556818767461],
            [30.862688090085975, 3.06515479119295],
            [30.863369764961252, 3.064017944834351],
            [30.863464733954764, 3.062848878568144],
            [30.864207040620126, 3.062281258953567],
            [30.864546643323372, 3.062333677048742],
            [30.864493464855197, 3.063264240214394],
            [30.86557594914561, 3.06425849266286],
            [30.865512715834424, 3.065421919556454],
            [30.866290894924052, 3.066256339141949],
            [30.867066353914964, 3.068462521895429],
            [30.8677713553432, 3.069333541383104],
            [30.868477765329782, 3.069494181796153],
            [30.86951523683794, 3.068614407453726],
            [30.868639062330615, 3.068036998943516],
            [30.86799535025928, 3.066982384468838],
            [30.86850854969625, 3.066260783921649],
            [30.869483878448, 3.065993282603367],
            [30.87083890440911, 3.064734452658163],
            [30.871349774514535, 3.065188649594697],
            [30.871140617072008, 3.066204812885985],
            [30.87209133378158, 3.066059739026501],
            [30.87242132181636, 3.065558232212478],
            [30.873589865609304, 3.066172966553043],
            [30.873940927222357, 3.067337226497892],
            [30.87488285212024, 3.065477412516158],
            [30.87606617319961, 3.064781638254637],
            [30.87729745892527, 3.064477893835821],
            [30.88014845651551, 3.064630551406281],
            [30.880977639252002, 3.06432599961681],
            [30.881100381459177, 3.063873066231143],
            [30.881879883767155, 3.064046090081254],
            [30.882684937755112, 3.06361900812592],
            [30.88416194774528, 3.062286903082291],
            [30.884831040816675, 3.062839395145127],
            [30.8859460710698, 3.062819028031773],
            [30.886589996041877, 3.063258742306993],
            [30.887148641249073, 3.062058915063144],
            [30.88853461776497, 3.061254683659353],
            [30.88859885359599, 3.060733769958766],
            [30.889110366895174, 3.061001657418658],
            [30.889071303655058, 3.061579809777334],
            [30.890045217560246, 3.061372051502861],
            [30.890163083712036, 3.062516035666202],
            [30.891174091750234, 3.062734079089575],
            [30.89151031049981, 3.062131097490051],
            [30.89252200485089, 3.06199965977075],
            [30.892844825228025, 3.061338845123623],
            [30.893869455319173, 3.061497786859143],
            [30.894562173184234, 3.061174512193375],
            [30.895022746616906, 3.061592821242759],
            [30.89602348152154, 3.061053722145189],
            [30.8966368853335, 3.061967031100081],
            [30.89803489837588, 3.062758214636601],
            [30.898001357978117, 3.063299370666892],
            [30.898971792708213, 3.06340935481929],
            [30.89847644728749, 3.064072856590765],
            [30.898876593745975, 3.064439953024706],
            [30.90024957702959, 3.0642717184861],
            [30.90058990916485, 3.064731022413601],
            [30.90039231753159, 3.065971952140373],
            [30.898930578002943, 3.067895545736939],
            [30.900033460338527, 3.069192004924628],
            [30.898792155702502, 3.07034952132946],
            [30.899651779649037, 3.071804234210343],
            [30.899493240476126, 3.072121386163389],
            [30.89810269333206, 3.072119474604627],
            [30.89763875840358, 3.073782123969791],
            [30.893513249952843, 3.071990330010392],
            [30.892489430142046, 3.072039749774212],
            [30.888900682141553, 3.074948138268514],
            [30.88813076575596, 3.076027061321195],
            [30.885690126672312, 3.076416650028754],
            [30.883638626989978, 3.078470561665757],
            [30.884618997985406, 3.080428867038049],
            [30.884316190276174, 3.080958669539704],
            [30.882250465771335, 3.08157194094461],
            [30.880712983891197, 3.082529265944034],
            [30.878803060494285, 3.082010941543493],
            [30.87738657808965, 3.082179600265157],
            [30.87580114324135, 3.081507572844785],
            [30.872047489707516, 3.081517186169337],
            [30.86652730365906, 3.086119384219419],
            [30.863966441244294, 3.08690310464472],
            [30.86247986060312, 3.087997686359075],
            [30.859025415229183, 3.088614859286858],
            [30.85681678942387, 3.089713839965288],
            [30.858321980462783, 3.095090035495776],
            [30.855162562489415, 3.103136693330149],
            [30.853657503502845, 3.104950131288323],
            [30.848180946831086, 3.108366139792456],
            [30.84573864316924, 3.112324566236764],
            [30.845221101276174, 3.114813166857419],
            [30.841149244705754, 3.115062334890796],
            [30.83699394722187, 3.117660533527057],
            [30.834059423378218, 3.118101527501929],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 578,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "AYIVUNI",
        Population: 22680,
        Key: "ARUAAYIVUNI",
        Dist2: "Koboko",
        "Sub Country": "Ayivuni",
        id2_original: "Koboko Ayivuni",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.003312493669263, 3.0583661954439],
            [31.003294031493557, 3.05661379328159],
            [31.002344798800817, 3.054844512267184],
            [31.00088305028901, 3.054268843767595],
            [30.996255235372445, 3.053680743782845],
            [30.995468228538545, 3.05289053042721],
            [30.994324939083196, 3.052617220125615],
            [30.994025605159138, 3.049852486244881],
            [30.994406144988243, 3.048472467342607],
            [30.98969493137898, 3.048525939241761],
            [30.988475365074525, 3.047188440372875],
            [30.98685649762628, 3.046286360628093],
            [30.985404048474326, 3.046372642984651],
            [30.984208839988796, 3.045472458912778],
            [30.983584544104026, 3.046025889863507],
            [30.982839018774992, 3.045839616426866],
            [30.981910363790472, 3.045231912257545],
            [30.982669578546105, 3.043474028351452],
            [30.982026191664882, 3.042983778816308],
            [30.981644282803305, 3.04330027457796],
            [30.98013343597137, 3.042610132870881],
            [30.979764131371528, 3.043217429464998],
            [30.97748936979838, 3.043213140676335],
            [30.976527328028, 3.044374439252384],
            [30.97559486688161, 3.043777902503958],
            [30.974935323800025, 3.044900117028846],
            [30.974356694671002, 3.044938675698804],
            [30.972532217227272, 3.043216995293548],
            [30.97137608096503, 3.04269933900421],
            [30.9695598680219, 3.043535368508578],
            [30.968913755652117, 3.042549213377086],
            [30.967492583143404, 3.041919023702544],
            [30.96475615937943, 3.043168825584401],
            [30.964523623281615, 3.041155087972427],
            [30.96406784415758, 3.040595734883214],
            [30.96336422164332, 3.040519933204568],
            [30.96331667381532, 3.039539383681439],
            [30.961650429218988, 3.039238360062058],
            [30.96029395068211, 3.038354613005303],
            [30.957898652265794, 3.038374881009316],
            [30.95801023739715, 3.038126877365729],
            [30.955897387272486, 3.037229425113741],
            [30.95504890243549, 3.037396082379406],
            [30.953967771906196, 3.036653629682963],
            [30.953475016328476, 3.037561355466352],
            [30.95205580304536, 3.038557061588907],
            [30.950269727681718, 3.038800450697524],
            [30.94895148683322, 3.039515889004942],
            [30.947199611230737, 3.039377923366922],
            [30.946796151785488, 3.040274596986309],
            [30.94591353276432, 3.040788937147114],
            [30.94156133355335, 3.040668415717582],
            [30.937995763883798, 3.043567028029966],
            [30.937445440669382, 3.045394500179976],
            [30.938283705373394, 3.046817110263315],
            [30.938078343312945, 3.048279120238514],
            [30.937634420154033, 3.049296394837298],
            [30.935809762148924, 3.050070357318069],
            [30.935155035833876, 3.050950429449549],
            [30.93538715062182, 3.051746226520334],
            [30.935102953310327, 3.053734255789716],
            [30.931232806250463, 3.055189167959224],
            [30.929647118975545, 3.056185708167562],
            [30.92840770169996, 3.059071074295166],
            [30.927401275069723, 3.059967916284028],
            [30.92401106732343, 3.057452771291305],
            [30.92142709035812, 3.058401244426751],
            [30.916010902270067, 3.058570166119507],
            [30.91079359040616, 3.063396990135709],
            [30.901641715089994, 3.064158523051458],
            [30.90058990916485, 3.064731022413601],
            [30.90024957702959, 3.0642717184861],
            [30.898876593745975, 3.064439953024706],
            [30.89847644728749, 3.064072856590765],
            [30.898971792708213, 3.06340935481929],
            [30.898001357978117, 3.063299370666892],
            [30.89803489837588, 3.062758214636601],
            [30.8966368853335, 3.061967031100081],
            [30.89602348152154, 3.061053722145189],
            [30.895022746616906, 3.061592821242759],
            [30.894562173184234, 3.061174512193375],
            [30.893869455319173, 3.061497786859143],
            [30.892844825228025, 3.061338845123623],
            [30.892305462358397, 3.060941675470517],
            [30.891322218550687, 3.061055824791873],
            [30.89022509261945, 3.059802051008416],
            [30.89033802881697, 3.05820609247945],
            [30.891169628021554, 3.056990007960481],
            [30.890775717667786, 3.055621106249431],
            [30.891063010573752, 3.055734037062455],
            [30.891705670717915, 3.054973959437716],
            [30.89159194040969, 3.05413800879218],
            [30.89204553213599, 3.053453962247072],
            [30.89268843123202, 3.053415857784586],
            [30.892763871749565, 3.052845870373272],
            [30.89321763954566, 3.05269379689253],
            [30.89306597697623, 3.051515865380451],
            [30.89556167919353, 3.050679477875677],
            [30.89529678128761, 3.050147538873181],
            [30.896203991689656, 3.048893431208581],
            [30.89525796688079, 3.047183655534045],
            [30.894349231139408, 3.04387792514435],
            [30.895294363921188, 3.042965796578896],
            [30.89586163026016, 3.04296569700648],
            [30.89657971115893, 3.041635617010865],
            [30.898697102267363, 3.040457281387703],
            [30.90308359017275, 3.039392523779485],
            [30.903839622197335, 3.038480415640753],
            [30.905389837696628, 3.037580845740183],
            [30.909842621270002, 3.03680315958961],
            [30.913327654279346, 3.036707913105094],
            [30.917366387270288, 3.032843371213167],
            [30.92057595459272, 3.033331497535075],
            [30.922035327958906, 3.032783228019748],
            [30.92275358941903, 3.032031850915038],
            [30.921619859834923, 3.028535996862615],
            [30.925378774801395, 3.024887513197067],
            [30.923371454264714, 3.024768653151573],
            [30.923054738838253, 3.022683791527539],
            [30.923319344791718, 3.022379748181106],
            [30.924302343359347, 3.02169554336503],
            [30.92705382468411, 3.02336680172704],
            [30.93269775366297, 3.017788565873545],
            [30.933246932423714, 3.015214221749554],
            [30.93707248441794, 3.014338236304722],
            [30.939383618776965, 3.012973804505361],
            [30.94111064248708, 3.017302834009486],
            [30.94256483077745, 3.018677204385299],
            [30.94515967376442, 3.023609865926852],
            [30.947579471933473, 3.024004141948972],
            [30.94809484170016, 3.024898019606694],
            [30.949670832559907, 3.025793914021991],
            [30.95015931215688, 3.02688764397702],
            [30.951628244496014, 3.028316410746771],
            [30.952169180315693, 3.029716758575795],
            [30.954395997005527, 3.029987527929595],
            [30.955166103833967, 3.029375954789019],
            [30.96048044363003, 3.028654670803302],
            [30.962524940944725, 3.030717560042138],
            [30.962895373828548, 3.031783768668711],
            [30.964055147369372, 3.032045141722564],
            [30.965255417861506, 3.033631275892248],
            [30.967263668154484, 3.034755507682146],
            [30.968100679708684, 3.03598745571135],
            [30.968906469416865, 3.035215606448192],
            [30.96869913735097, 3.033879388214639],
            [30.967758197006614, 3.03211994467368],
            [30.967277136595566, 3.027549107700275],
            [30.966495598705098, 3.026405360905099],
            [30.967987907902863, 3.025562438573083],
            [30.96875262214466, 3.026023275044618],
            [30.969418083327355, 3.026963493258725],
            [30.971201003807725, 3.027972883938779],
            [30.971780754932524, 3.030153716252555],
            [30.97301716464856, 3.029049406079046],
            [30.97467354394643, 3.02635299129727],
            [30.975491817542107, 3.025851511739231],
            [30.977217975276318, 3.022232644639561],
            [30.976743177021103, 3.020308319140636],
            [30.976107871384176, 3.019814218759978],
            [30.97720272008614, 3.019485102452895],
            [30.9785833453379, 3.017323278233116],
            [30.98044505705182, 3.015871990373583],
            [30.99065201714394, 3.016992438796806],
            [30.99191755293643, 3.017610206008698],
            [30.993086430902636, 3.01912969655909],
            [30.996924308680903, 3.027971519508819],
            [31.000386203783467, 3.032487489773905],
            [31.003908531250172, 3.032852141740197],
            [31.004856920424867, 3.033742547662321],
            [31.00895742606629, 3.035421337047205],
            [31.009984261521478, 3.036709793330016],
            [31.010004031644268, 3.038093960913808],
            [31.011381072618004, 3.041489189772326],
            [31.014656743368953, 3.044032063978149],
            [31.016451051792195, 3.044029219439642],
            [31.017463206978988, 3.044895632690586],
            [31.017097612421296, 3.045474549928359],
            [31.017409897356767, 3.04641230227706],
            [31.017203723219268, 3.047177134015778],
            [31.015430898006084, 3.047573768738957],
            [31.0150535498912, 3.049416121418064],
            [31.01383068227807, 3.051867928113094],
            [31.012401583035306, 3.051059352770328],
            [31.010501289578208, 3.050911762452926],
            [31.009857437369696, 3.051619350778666],
            [31.009709752540342, 3.053021170896824],
            [31.00812210963305, 3.054066159525954],
            [31.007831501943695, 3.056180560965595],
            [31.006036295205192, 3.057040539845736],
            [31.004955903989377, 3.05849014336064],
            [31.003312493669263, 3.0583661954439],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 579,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "DADAMU",
        Population: 41078,
        Key: "ARUADADAMU",
        Dist2: "Koboko",
        "Sub Country": "Dadamu",
        id2_original: "Koboko Dadamu",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.12457108912107, 3.014962231600287],
            [31.1231662425943, 3.016493778892612],
            [31.12361289483506, 3.017688834163467],
            [31.122601424164486, 3.018794672847204],
            [31.122792142787485, 3.020496858482233],
            [31.122470218030696, 3.020790808557627],
            [31.121564170946918, 3.020591604931984],
            [31.120867178897775, 3.021557919928733],
            [31.12200144477611, 3.022887893642917],
            [31.121169354193047, 3.025815605003113],
            [31.120567894381093, 3.026515382016107],
            [31.119938143027547, 3.026300256582509],
            [31.11944750208399, 3.026694862642149],
            [31.11926370138697, 3.029424587099075],
            [31.1168939420742, 3.030756619777426],
            [31.11703435234639, 3.032200233126947],
            [31.115995752554245, 3.033155532678045],
            [31.11647277952965, 3.033880514917272],
            [31.116343108616704, 3.034405768116199],
            [31.114332220870047, 3.034524964396509],
            [31.112538738896898, 3.033767450842863],
            [31.1118544939416, 3.033058263905814],
            [31.10974406657327, 3.033332044739652],
            [31.107857607171578, 3.032003329860544],
            [31.10651645569004, 3.033372201480824],
            [31.10476549636916, 3.032803778701305],
            [31.102676115629595, 3.034278137703354],
            [31.09978643927817, 3.034448958660012],
            [31.099395511331128, 3.034797058394589],
            [31.09933657196703, 3.0364031291424],
            [31.09802525533273, 3.037216022238261],
            [31.096950672623546, 3.037233248355467],
            [31.094400100410404, 3.038291403096007],
            [31.09260147378558, 3.0366575426321],
            [31.0901230749173, 3.039746187227081],
            [31.089194437899085, 3.039832653105674],
            [31.08679470270361, 3.039137882186042],
            [31.085644891479294, 3.040158941103974],
            [31.085415970202163, 3.041047236521793],
            [31.085700852928213, 3.041625835580101],
            [31.087551218021797, 3.041954778302429],
            [31.08824724977195, 3.042860844570958],
            [31.088211548027605, 3.044621285165215],
            [31.086520865662305, 3.04582467881223],
            [31.084738465306447, 3.044762126962541],
            [31.083525893284826, 3.044895381517435],
            [31.083409929764784, 3.044347389681922],
            [31.08414538408116, 3.0434119373614],
            [31.084060252538325, 3.042948822623893],
            [31.082494551880163, 3.043051780484237],
            [31.080684847231264, 3.041692009146312],
            [31.078832331570897, 3.037398360894786],
            [31.07753035202566, 3.036771251385819],
            [31.074171580822718, 3.03887686338941],
            [31.07386987624466, 3.039861776771917],
            [31.074355412062474, 3.041165808619009],
            [31.072844012766627, 3.041639268003416],
            [31.071943543322465, 3.042586547659301],
            [31.071921858889798, 3.043474492125391],
            [31.073502934214055, 3.045938730168006],
            [31.072531225672908, 3.048009517146512],
            [31.07215534720184, 3.048164549742054],
            [31.071509722617254, 3.047594255448569],
            [31.07006724656157, 3.047967217013925],
            [31.06799431307653, 3.050205789235196],
            [31.066344304630668, 3.050386060701775],
            [31.06591300639477, 3.049413932632437],
            [31.065310067057528, 3.049148545032328],
            [31.064290224088513, 3.049837362101001],
            [31.06252375625258, 3.049137634291969],
            [31.061909075036244, 3.048713987463319],
            [31.061776500768303, 3.047316732174333],
            [31.05841851109971, 3.047403254856345],
            [31.05691760592298, 3.044618468436733],
            [31.05291042445979, 3.043284968241193],
            [31.04942028452802, 3.043170156804381],
            [31.047980974135406, 3.041640943692412],
            [31.04627019286391, 3.041626496705787],
            [31.04543301781638, 3.042367809419259],
            [31.044628402206275, 3.041990516754231],
            [31.044524278481674, 3.040992601674189],
            [31.04407878955926, 3.040528699183997],
            [31.042128683621346, 3.040635091185139],
            [31.03927301030005, 3.041500103281301],
            [31.03665507971195, 3.041177350066368],
            [31.035302351641345, 3.040336322160273],
            [31.034581889308733, 3.039012440242134],
            [31.03389710446597, 3.038686590555699],
            [31.029642742569177, 3.042941517956458],
            [31.027633114260556, 3.04393904729584],
            [31.027240726551206, 3.043665375901148],
            [31.02698239263507, 3.041831446546745],
            [31.026058903861724, 3.039672849688964],
            [31.025649478704686, 3.03939920322598],
            [31.024234907915005, 3.039401461104929],
            [31.02176978794326, 3.043588373290843],
            [31.02089859459417, 3.042218287460129],
            [31.021135442605356, 3.041017879654509],
            [31.020240350476488, 3.040787871451152],
            [31.01831731886293, 3.042728120817381],
            [31.017463206978988, 3.044895632690586],
            [31.016451051792195, 3.044029219439642],
            [31.014656743368953, 3.044032063978149],
            [31.011381072618004, 3.041489189772326],
            [31.010004031644268, 3.038093960913808],
            [31.009984261521478, 3.036709793330016],
            [31.00895742606629, 3.035421337047205],
            [31.004856920424867, 3.033742547662321],
            [31.003908531250172, 3.032852141740197],
            [31.000386203783467, 3.032487489773905],
            [30.996924308680903, 3.027971519508819],
            [30.993086430902636, 3.01912969655909],
            [30.99191755293643, 3.017610206008698],
            [30.99065201714394, 3.016992438796806],
            [30.98044505705182, 3.015871990373583],
            [30.9785833453379, 3.017323278233116],
            [30.97720272008614, 3.019485102452895],
            [30.976107871384176, 3.019814218759978],
            [30.976743177021103, 3.020308319140636],
            [30.977217975276318, 3.022232644639561],
            [30.975491817542107, 3.025851511739231],
            [30.97467354394643, 3.02635299129727],
            [30.97301716464856, 3.029049406079046],
            [30.971780754932524, 3.030153716252555],
            [30.971201003807725, 3.027972883938779],
            [30.969418083327355, 3.026963493258725],
            [30.96875262214466, 3.026023275044618],
            [30.967987907902863, 3.025562438573083],
            [30.966495598705098, 3.026405360905099],
            [30.967277136595566, 3.027549107700275],
            [30.967758197006614, 3.03211994467368],
            [30.96869913735097, 3.033879388214639],
            [30.968906469416865, 3.035215606448192],
            [30.968100679708684, 3.03598745571135],
            [30.967263668154484, 3.034755507682146],
            [30.965255417861506, 3.033631275892248],
            [30.964055147369372, 3.032045141722564],
            [30.962895373828548, 3.031783768668711],
            [30.962524940944725, 3.030717560042138],
            [30.96048044363003, 3.028654670803302],
            [30.955166103833967, 3.029375954789019],
            [30.954395997005527, 3.029987527929595],
            [30.952169180315693, 3.029716758575795],
            [30.951628244496014, 3.028316410746771],
            [30.95015931215688, 3.02688764397702],
            [30.949670832559907, 3.025793914021991],
            [30.94809484170016, 3.024898019606694],
            [30.947579471933473, 3.024004141948972],
            [30.94515967376442, 3.023609865926852],
            [30.94256483077745, 3.018677204385299],
            [30.94111064248708, 3.017302834009486],
            [30.939383618776965, 3.012973804505361],
            [30.93707248441794, 3.014338236304722],
            [30.93505612143961, 3.011889755223445],
            [30.931754847804793, 3.008890901352292],
            [30.933648182013375, 3.004877312851955],
            [30.931105990183486, 3.004643561544376],
            [30.929560621095163, 3.003923310735284],
            [30.926784343573626, 3.001475048479435],
            [30.924801874030987, 3.001194281211614],
            [30.921470007370818, 3.002558492714865],
            [30.921012943655935, 3.00180748674227],
            [30.916632435835396, 3.001071668770855],
            [30.912503025103035, 3.000936845217083],
            [30.90959159784362, 3.00150854645389],
            [30.910103399502034, 3.0004422040804],
            [30.909724772186188, 2.999226328301388],
            [30.910140558313742, 2.998694245641678],
            [30.910745602403676, 2.998656116826848],
            [30.91028119316473, 2.996804806654418],
            [30.910286083593167, 2.995521687409464],
            [30.910745046346545, 2.99469857939732],
            [30.91007438571498, 2.992703476932316],
            [30.910602726256062, 2.991854970161206],
            [30.91165504961083, 2.991301785229501],
            [30.911601516308103, 2.99004043197124],
            [30.911251770726935, 2.989951103998545],
            [30.911137542752048, 2.989305427828888],
            [30.911545733623875, 2.989365655058444],
            [30.91154785364796, 2.988808419391893],
            [30.912015053952487, 2.988692901573474],
            [30.91166677621854, 2.988222304198524],
            [30.91272267037654, 2.986730594948756],
            [30.91243629644711, 2.985321708081474],
            [30.911417844070165, 2.984643226847383],
            [30.91127566052361, 2.983674832016931],
            [30.912494385106655, 2.981553174567102],
            [30.913311768471875, 2.981409679044932],
            [30.913956003362717, 2.980766907150404],
            [30.913870595138746, 2.98020933788752],
            [30.914512164728176, 2.980270454642045],
            [30.91527364144166, 2.979481499491479],
            [30.916412357573925, 2.979221907152245],
            [30.91751978448652, 2.979519449552431],
            [30.91819863865177, 2.977439701211416],
            [30.917010936488754, 2.975235476610898],
            [30.91797343011174, 2.974450015666932],
            [30.92952215074313, 2.973808170009635],
            [30.932700798053464, 2.97462510095435],
            [30.934147552784857, 2.976045758959224],
            [30.936910788565097, 2.977275712635085],
            [30.937125649411396, 2.978026922000152],
            [30.93842934473882, 2.978688497847247],
            [30.93963690865276, 2.980100108736438],
            [30.942456517310386, 2.980078341490942],
            [30.945255965078054, 2.98068861095918],
            [30.94634660337629, 2.979772335993678],
            [30.947158291422614, 2.976956630185585],
            [30.94795913500684, 2.977017209756001],
            [30.949157485799216, 2.977884671196167],
            [30.95127913492209, 2.976684677860057],
            [30.951960790034395, 2.978010392893117],
            [30.953160226889956, 2.978590215877146],
            [30.953838409115416, 2.980836346269307],
            [30.95705415505035, 2.977799639355743],
            [30.958717407358485, 2.976770478603999],
            [30.959859626022023, 2.977350077965033],
            [30.96151294475972, 2.978967115141236],
            [30.964710984900428, 2.980647539030526],
            [30.966085555507153, 2.980307589211639],
            [30.967293205659345, 2.978701402653698],
            [30.968208726376105, 2.978704869951307],
            [30.96952154319693, 2.979572755287958],
            [30.972825424641055, 2.983554662207372],
            [30.97476660222335, 2.984712566143755],
            [30.977282576721652, 2.985182317266745],
            [30.978221863267553, 2.986480242607865],
            [30.97953837036758, 2.986370169016045],
            [30.980904983697524, 2.988158697553586],
            [30.983306102298535, 2.988743060757546],
            [30.987131727954615, 2.990943579305658],
            [30.98844673935968, 2.991236187220314],
            [30.989992791167634, 2.990954393744801],
            [30.991530884800465, 2.992801096484358],
            [30.993190299505695, 2.992807365349791],
            [31.00094914203943, 2.99706009420213],
            [31.002500955641597, 2.996089982544582],
            [31.004043968448933, 2.99781765844285],
            [31.003195565358638, 2.998773591034615],
            [31.00377718138595, 2.999399549981775],
            [31.00823141394187, 2.999271308132774],
            [31.009834849231844, 3.001277631002137],
            [31.01174833175396, 3.00222913884966],
            [31.01297344785022, 3.002205798560987],
            [31.014204855746748, 3.00164816753604],
            [31.01508335778895, 3.001888959789218],
            [31.017094160195647, 3.001600768369969],
            [31.019703213632134, 3.003591223875184],
            [31.019463065210573, 3.004019040033726],
            [31.01791927715718, 3.004050016235888],
            [31.01833092474624, 3.004662000133952],
            [31.02308222477671, 3.004248278262107],
            [31.026383406783392, 3.004941078205551],
            [31.027246160460344, 3.004113311567501],
            [31.02742120437999, 3.002766629192448],
            [31.029701470829224, 3.002705946085435],
            [31.029796691351024, 3.000069980619534],
            [31.03017764081187, 2.99908626913244],
            [31.032755018753104, 2.998811372673404],
            [31.03231341234931, 2.997112114457833],
            [31.0372810725143, 2.997100490907415],
            [31.036061023814536, 2.995845166473967],
            [31.036367850586345, 2.994802752002641],
            [31.039384169629912, 2.992398131622759],
            [31.040678042778048, 2.992888898274765],
            [31.040499781991393, 2.993722630978535],
            [31.042231297277922, 2.993665274674301],
            [31.04342277865333, 2.994468804502099],
            [31.0450898883273, 2.994476732972078],
            [31.047030667057577, 2.995199859788621],
            [31.048294874241762, 2.994492988219265],
            [31.049174306938628, 2.994698592853642],
            [31.049766934514693, 2.99412396265111],
            [31.051059817719384, 2.994302270735737],
            [31.05108574399678, 2.995130343531663],
            [31.05328608104697, 2.995389032330331],
            [31.05408597241701, 2.994969986318861],
            [31.056800910276003, 2.995300164102677],
            [31.057940645996105, 2.996077799200792],
            [31.05714199789445, 2.996887409506257],
            [31.057361922543986, 2.99743687588568],
            [31.061794768907944, 2.997204212946768],
            [31.062463071461863, 2.998188285857903],
            [31.065865181885666, 2.998428942516105],
            [31.068410310308195, 3.000342667244513],
            [31.069461904230927, 2.999879780828545],
            [31.070273059576298, 2.9988827662956],
            [31.071720970439454, 2.998681228037611],
            [31.072834223824955, 2.999186400849966],
            [31.074439080249736, 3.00113632156198],
            [31.07611528267099, 3.000451066371337],
            [31.07642817486761, 3.00172068053226],
            [31.07724449103427, 3.002529744822354],
            [31.076887441251532, 3.003193836555677],
            [31.077142498113524, 3.003610472546876],
            [31.080140436728076, 3.004581772441516],
            [31.08182681795981, 3.004379905109051],
            [31.083786633787614, 3.007357675698486],
            [31.086859940156184, 3.008300404829404],
            [31.088089184909506, 3.008009244879143],
            [31.090203049232098, 3.010043629267772],
            [31.092456350053123, 3.010836057404443],
            [31.091888449503568, 3.012254081296846],
            [31.09400832355544, 3.01511783588093],
            [31.0944984470694, 3.01520231850567],
            [31.095428636376436, 3.013456684713093],
            [31.09599351679001, 3.013133459356655],
            [31.100211471764947, 3.013889417443914],
            [31.102814469658096, 3.015335282460234],
            [31.104312610718686, 3.018294872698004],
            [31.10615101923583, 3.018879460189522],
            [31.106227572766013, 3.022675584275324],
            [31.106794162673605, 3.023451887434878],
            [31.109502409880353, 3.022864387840043],
            [31.111275424638098, 3.023809284293928],
            [31.114028295656624, 3.021619773553799],
            [31.11533821181739, 3.021683912003231],
            [31.115676961121157, 3.021370531707817],
            [31.115588794170968, 3.019218994334943],
            [31.116020112169803, 3.017843832532047],
            [31.118890145959234, 3.018279737347742],
            [31.119821948640517, 3.017586202217894],
            [31.12143883710019, 3.015099993123947],
            [31.12265528445396, 3.015647696556381],
            [31.12370013472384, 3.014935008159995],
            [31.12457108912107, 3.014962231600287],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 580,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "OLUKO",
        Population: 38706,
        Key: "ARUAOLUKO",
        Dist2: "Koboko",
        "Sub Country": "Oluko",
        id2_original: "Koboko Oluko",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.905389837696628, 3.037580845740183],
            [30.903839622197335, 3.038480415640753],
            [30.90308359017275, 3.039392523779485],
            [30.898697102267363, 3.040457281387703],
            [30.89657971115893, 3.041635617010865],
            [30.89586163026016, 3.04296569700648],
            [30.895294363921188, 3.042965796578896],
            [30.894349231139408, 3.04387792514435],
            [30.89525796688079, 3.047183655534045],
            [30.896203991689656, 3.048893431208581],
            [30.89529678128761, 3.050147538873181],
            [30.89556167919353, 3.050679477875677],
            [30.89306597697623, 3.051515865380451],
            [30.89321763954566, 3.05269379689253],
            [30.892763871749565, 3.052845870373272],
            [30.89268843123202, 3.053415857784586],
            [30.89204553213599, 3.053453962247072],
            [30.89159194040969, 3.05413800879218],
            [30.891705670717915, 3.054973959437716],
            [30.891063010573752, 3.055734037062455],
            [30.890775717667786, 3.055621106249431],
            [30.890261105180887, 3.054254253424241],
            [30.889776783885345, 3.054442298849483],
            [30.889282709580748, 3.054064726954025],
            [30.888406138018105, 3.053165266953116],
            [30.88816279698403, 3.052047243952154],
            [30.887136982015008, 3.051356525673937],
            [30.88705254307324, 3.050300899073242],
            [30.886409580196855, 3.050111016676825],
            [30.884933913188046, 3.047717350621656],
            [30.885122697738264, 3.046805353585488],
            [30.884176987339753, 3.045969551777624],
            [30.88383603716356, 3.04414567776448],
            [30.882247081817635, 3.04224601794442],
            [30.881911189156504, 3.04218471449296],
            [30.881264204522576, 3.043386131972799],
            [30.879865114400182, 3.043842334768038],
            [30.879676206780758, 3.044412330537845],
            [30.877747656816435, 3.044830618305927],
            [30.87625279730158, 3.04629183529922],
            [30.87543044086292, 3.044979938066996],
            [30.873967283792766, 3.043824096886303],
            [30.87110040219168, 3.043690305764136],
            [30.87040036934526, 3.043272571032231],
            [30.868345926782066, 3.040756978826316],
            [30.865060029609932, 3.040196758082347],
            [30.8628099905717, 3.041686665421083],
            [30.859935934126433, 3.045832954064179],
            [30.859217658293254, 3.046006924514312],
            [30.85865024642719, 3.045503551443842],
            [30.858160387017904, 3.042430735622184],
            [30.857113543386397, 3.042399000715286],
            [30.85573105233383, 3.040602811715667],
            [30.854639302819585, 3.040911885084452],
            [30.852650981651152, 3.039766638203454],
            [30.851176715115884, 3.039645115550313],
            [30.849616301941502, 3.038352508520131],
            [30.847929581146605, 3.035083707942266],
            [30.846696699114702, 3.033769010823792],
            [30.845306791571137, 3.033495509982234],
            [30.844240242495527, 3.0319728657781],
            [30.84411085994178, 3.030929478510565],
            [30.843194055532496, 3.030082184741032],
            [30.843206421740707, 3.02850013865676],
            [30.84459832983241, 3.025275848401188],
            [30.844659556307214, 3.024042277052962],
            [30.845964057423476, 3.023038954050234],
            [30.848209289576605, 3.02023321665079],
            [30.848838709451787, 3.015188852562773],
            [30.84858742192072, 3.013735343393926],
            [30.84690790830933, 3.01159240910851],
            [30.846782154051024, 3.010921539703274],
            [30.84495328654051, 3.010703234638236],
            [30.846991266577827, 3.005722081258014],
            [30.848037413116657, 3.004179341197553],
            [30.846308720336733, 3.003564991425649],
            [30.844901002794344, 2.99721873049699],
            [30.84094670066033, 2.996980074972905],
            [30.83934536473317, 2.995737254906417],
            [30.836636022480093, 2.996477277525421],
            [30.83533156807622, 2.99590752482414],
            [30.832044044953438, 2.995593104570562],
            [30.83072449076798, 2.994504784935439],
            [30.825929556869198, 2.994389893885194],
            [30.82473849770196, 2.989453293853056],
            [30.82508029588778, 2.987768727190015],
            [30.82858533258192, 2.984000075576682],
            [30.83321654313028, 2.981286918164539],
            [30.835336885204406, 2.976753867841712],
            [30.8383525367997, 2.971809342523995],
            [30.845789892954517, 2.966509885241516],
            [30.846060452043346, 2.965853095362516],
            [30.85480375290706, 2.960780485744849],
            [30.855050716846666, 2.964311074428196],
            [30.85600454801534, 2.965361293053325],
            [30.85625424732497, 2.966318141098168],
            [30.857189986423837, 2.967498945743825],
            [30.86013380603406, 2.96936131548325],
            [30.860271640836334, 2.97187817576291],
            [30.859967873726372, 2.972716909618302],
            [30.860454771390152, 2.972918249893989],
            [30.86090676950513, 2.973987890742702],
            [30.862123542947348, 2.974736167021854],
            [30.862541953952192, 2.975995000827794],
            [30.863062464777265, 2.975996015452181],
            [30.864551346003907, 2.977150829645478],
            [30.864936828363675, 2.976631310084638],
            [30.864643602983584, 2.974456338463294],
            [30.865509074962592, 2.974322124363558],
            [30.866240299112295, 2.973698405548994],
            [30.870459404829106, 2.973081462224561],
            [30.870001465256824, 2.971749037182323],
            [30.870659668950335, 2.970619165014157],
            [30.873979740730814, 2.9733221216919],
            [30.89928160098842, 2.969462951669632],
            [30.902695333815377, 2.969300097647774],
            [30.9053768992616, 2.969896985528433],
            [30.91366150866313, 2.973814843577977],
            [30.91797343011174, 2.974450015666932],
            [30.917010936488754, 2.975235476610898],
            [30.91819863865177, 2.977439701211416],
            [30.91751978448652, 2.979519449552431],
            [30.916412357573925, 2.979221907152245],
            [30.91527364144166, 2.979481499491479],
            [30.914512164728176, 2.980270454642045],
            [30.913870595138746, 2.98020933788752],
            [30.913956003362717, 2.980766907150404],
            [30.913311768471875, 2.981409679044932],
            [30.912494385106655, 2.981553174567102],
            [30.91127566052361, 2.983674832016931],
            [30.911417844070165, 2.984643226847383],
            [30.91243629644711, 2.985321708081474],
            [30.91272267037654, 2.986730594948756],
            [30.91166677621854, 2.988222304198524],
            [30.912015053952487, 2.988692901573474],
            [30.91154785364796, 2.988808419391893],
            [30.911545733623875, 2.989365655058444],
            [30.911137542752048, 2.989305427828888],
            [30.911251770726935, 2.989951103998545],
            [30.911601516308103, 2.99004043197124],
            [30.91165504961083, 2.991301785229501],
            [30.910602726256062, 2.991854970161206],
            [30.91007438571498, 2.992703476932316],
            [30.910745046346545, 2.99469857939732],
            [30.910286083593167, 2.995521687409464],
            [30.91028119316473, 2.996804806654418],
            [30.910745602403676, 2.998656116826848],
            [30.910140558313742, 2.998694245641678],
            [30.909724772186188, 2.999226328301388],
            [30.910103399502034, 3.0004422040804],
            [30.90959159784362, 3.00150854645389],
            [30.90870460223039, 3.001506483163132],
            [30.908175538545514, 3.002494565747321],
            [30.908403143790736, 3.004356475158272],
            [30.906400778361174, 3.00952475235892],
            [30.90681690944182, 3.009904650669196],
            [30.906438923523094, 3.010398716976838],
            [30.90704420297164, 3.010968574251861],
            [30.906477171092945, 3.011576677110342],
            [30.906780065938758, 3.012564593584005],
            [30.906137416574392, 3.013210701856784],
            [30.90617588333317, 3.014958641518655],
            [30.905125574899586, 3.015432055844445],
            [30.903492219422457, 3.018645072277437],
            [30.904097808789775, 3.020088905389908],
            [30.90383364929903, 3.021646914296487],
            [30.90500641068222, 3.022824644256406],
            [30.904893342432356, 3.023888637724932],
            [30.90353216480819, 3.024572885114035],
            [30.901225122275314, 3.024041352179583],
            [30.900242454287678, 3.025675481077879],
            [30.900356128900384, 3.026283441145843],
            [30.898995374382718, 3.028183635868178],
            [30.89892005244279, 3.02905762135651],
            [30.898088092115437, 3.029133774589684],
            [30.89759095186078, 3.029766278959569],
            [30.900509198231532, 3.031413250478302],
            [30.90504912108238, 3.036580242596781],
            [30.905389837696628, 3.037580845740183],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 581,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "PAJULU",
        Population: 60213,
        Key: "ARUAPAJULU",
        Dist2: "Koboko",
        "Sub Country": "Pajulu",
        id2_original: "Koboko Pajulu",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.22150055244421, 2.613938926647672],
            [31.216588313840678, 2.615927402904638],
            [31.21407407937909, 2.617424872089683],
            [31.210075670862953, 2.623785596621115],
            [31.206611682685747, 2.622810806289169],
            [31.20600914579377, 2.623326832263656],
            [31.204092946766266, 2.621899451527486],
            [31.201811782001776, 2.621442298164161],
            [31.19949216035994, 2.621577621442354],
            [31.197509280287225, 2.622948929226671],
            [31.196595026195006, 2.62226681701137],
            [31.194074720020403, 2.622464873857439],
            [31.193198334408994, 2.621606317703639],
            [31.19060384445992, 2.621085653383065],
            [31.18959198212388, 2.620062304819323],
            [31.189511579312704, 2.618518763846206],
            [31.18862677379213, 2.617909940752182],
            [31.186764311086634, 2.618564861220568],
            [31.18634532695665, 2.619173323250808],
            [31.18532082981614, 2.618564480732612],
            [31.18471552521477, 2.618704752459605],
            [31.184575886595425, 2.619126048540367],
            [31.17991933547121, 2.617954415690046],
            [31.17977982531095, 2.619245733483667],
            [31.17878856493764, 2.619041176427123],
            [31.176196371082447, 2.617665316451207],
            [31.174632287391795, 2.615918302582454],
            [31.17463549886895, 2.61369929011179],
            [31.172044745911435, 2.611340972150961],
            [31.170750807186316, 2.609170882352179],
            [31.170094508819513, 2.608712567621486],
            [31.170265509422027, 2.606951159796711],
            [31.16988071786673, 2.605121183765898],
            [31.16867039792149, 2.603374696275354],
            [31.16703593931319, 2.603711084862933],
            [31.16553727183984, 2.603336234219517],
            [31.163665881677023, 2.604434522876567],
            [31.16260535850038, 2.603941738656409],
            [31.16147583482842, 2.604566820203316],
            [31.158259875094437, 2.603579637272749],
            [31.153991839940726, 2.604408439414881],
            [31.151414059554227, 2.607060647114502],
            [31.1493647867955, 2.607694516102049],
            [31.145254294583047, 2.607918794143423],
            [31.140740930423547, 2.607193889112097],
            [31.136131753752462, 2.607485148973238],
            [31.13416480440297, 2.607129891172737],
            [31.13232571855611, 2.606198227045035],
            [31.13055503941812, 2.603840633566841],
            [31.128427580890285, 2.602802707233507],
            [31.127148505689842, 2.60394258579042],
            [31.123635423684064, 2.604115731355733],
            [31.122143180961615, 2.605433687043935],
            [31.117171172950677, 2.608439984411289],
            [31.115679638999005, 2.6111463200118],
            [31.11318484497847, 2.612638336130567],
            [31.111375849998648, 2.612554745936518],
            [31.10916767874087, 2.610570507164032],
            [31.106774282956373, 2.609293306163285],
            [31.105299145055255, 2.610101745606903],
            [31.10416823528284, 2.610605118328395],
            [31.102709047867926, 2.610208301796686],
            [31.104060728502905, 2.609026552486098],
            [31.104207013757012, 2.605680559885368],
            [31.10469561372826, 2.604339656464096],
            [31.104509240256256, 2.603013514551833],
            [31.10134453749406, 2.599015368349639],
            [31.10042989982125, 2.597229907621847],
            [31.09910811062735, 2.597355890753912],
            [31.096407686848387, 2.598618946608323],
            [31.0946385653891, 2.600818529363494],
            [31.091030213454143, 2.602198275526577],
            [31.089912817038535, 2.603087322052314],
            [31.088166908046173, 2.605969214086953],
            [31.08632777908019, 2.604864973502387],
            [31.086653660915793, 2.604396968111796],
            [31.087584867115744, 2.604163218414572],
            [31.086327702723366, 2.603928735508189],
            [31.08567579172842, 2.603085908665697],
            [31.083068313038645, 2.602101972225897],
            [31.08143875204526, 2.602803587571653],
            [31.080880013413264, 2.602662964985435],
            [31.080367731156205, 2.600930756048125],
            [31.079389852985692, 2.599432442521615],
            [31.07873802014416, 2.59961947762377],
            [31.075711473781105, 2.597839594144653],
            [31.07585109173918, 2.596856604850037],
            [31.075106086534706, 2.596341426813998],
            [31.073476553389092, 2.597323907687991],
            [31.072964377133218, 2.597136477393005],
            [31.071474558963768, 2.598727552514123],
            [31.070403621618013, 2.597837758977866],
            [31.06821531839937, 2.598117868214864],
            [31.06740054643668, 2.59860910042858],
            [31.066050269868494, 2.597953268587455],
            [31.065491588728683, 2.598608427384946],
            [31.065770983646658, 2.599217075857991],
            [31.065491647119156, 2.599638261807911],
            [31.063955200098242, 2.600246273534522],
            [31.063163650483954, 2.599637446977055],
            [31.0616271828018, 2.599777337629866],
            [31.061114998461086, 2.599309032416812],
            [31.05948537728059, 2.598980780198935],
            [31.05925252677242, 2.597997671542149],
            [31.05846099242948, 2.597622902658395],
            [31.058833434844583, 2.596967682326911],
            [31.05673822403885, 2.596592443801008],
            [31.05562081055526, 2.596966526485121],
            [31.053944584777813, 2.595655222406186],
            [31.05315298755281, 2.593876127536344],
            [31.0519424529102, 2.593969313914819],
            [31.050964678944258, 2.593594468455293],
            [31.04944236960929, 2.592149935255017],
            [31.048799606158894, 2.592259572824737],
            [31.047449454456537, 2.593663417112289],
            [31.045494016119086, 2.594739347531426],
            [31.044004280594635, 2.598062337604758],
            [31.043538670308138, 2.597828111115693],
            [31.042979991863287, 2.598389643313254],
            [31.039162170770386, 2.599698906578546],
            [31.038324040813663, 2.598060229631183],
            [31.037625644697723, 2.597966354357335],
            [31.03522792891498, 2.600048512016698],
            [31.03462265305972, 2.599814249103149],
            [31.033877726008654, 2.60042248957946],
            [31.031410063804657, 2.599578971197116],
            [31.02971460869024, 2.599758985990114],
            [31.027547759037216, 2.601658608120994],
            [31.02659038670968, 2.603231283772826],
            [31.02540106937582, 2.603329980321446],
            [31.023507473757483, 2.601112582478138],
            [31.020531189032862, 2.600480349710678],
            [31.019076615365268, 2.599484452606943],
            [31.019118292702867, 2.597771865271356],
            [31.017847696700397, 2.595521188585582],
            [31.016989361836295, 2.595689791802708],
            [31.015911315223406, 2.595021332111546],
            [31.015561900222266, 2.593987961778961],
            [31.013756862321294, 2.592638526060179],
            [31.013394773888134, 2.591395958975342],
            [31.013906462358822, 2.588415975829473],
            [31.013699509381972, 2.586691563726838],
            [31.011608713795848, 2.583093019733495],
            [31.01000395349082, 2.581276603051139],
            [31.020500148646523, 2.575233319844646],
            [31.02052586561649, 2.575218512611516],
            [31.066200672999894, 2.54971151741884],
            [31.085090273419492, 2.548247487297822],
            [31.101716859534918, 2.547680413837894],
            [31.12563849968099, 2.540735388696929],
            [31.12949119606817, 2.543073154388724],
            [31.13111049740268, 2.545443948408409],
            [31.1322969185681, 2.545167368860567],
            [31.133144417054915, 2.545690919927796],
            [31.135581770101215, 2.548149357244277],
            [31.13655642691313, 2.54817512147696],
            [31.136794864942384, 2.547245775331307],
            [31.13790168549213, 2.548013450885992],
            [31.138992950814444, 2.547562364441599],
            [31.142710690601522, 2.55049274890858],
            [31.143818546908825, 2.550546589944742],
            [31.14513389338551, 2.551434530119023],
            [31.14834732885354, 2.552556561845656],
            [31.1513117908507, 2.552385572953682],
            [31.152557349009573, 2.552996750020736],
            [31.152831718751862, 2.5548252718607],
            [31.15369590164846, 2.555801523453292],
            [31.154004620272264, 2.557821614518837],
            [31.15532030271886, 2.557823518844692],
            [31.15600743485947, 2.559321244221959],
            [31.157445726562536, 2.560560082419046],
            [31.157444231765897, 2.561604725435603],
            [31.158725496160702, 2.561467293993801],
            [31.159053323747226, 2.56223384196746],
            [31.161423712778994, 2.563160041690733],
            [31.16183877216953, 2.563456625261406],
            [31.162113944107357, 2.564728011408584],
            [31.16384485033612, 2.564922031716208],
            [31.16422426816942, 2.565932407883414],
            [31.164760511190064, 2.566229166704509],
            [31.166664590147757, 2.566388613002186],
            [31.16749682625789, 2.565501859694214],
            [31.167256395765374, 2.564143467159461],
            [31.167672425336374, 2.563761027052649],
            [31.168780531375308, 2.563658158032843],
            [31.17175671009874, 2.564689683691662],
            [31.17333298123285, 2.564065156854469],
            [31.17445294862679, 2.564386870547103],
            [31.175007416667913, 2.566399028392327],
            [31.17653672118401, 2.567863428166993],
            [31.17772460121345, 2.568023744751498],
            [31.17911062264511, 2.567277061806862],
            [31.182360322202868, 2.569549033868468],
            [31.184221641353023, 2.568698349769166],
            [31.185150842513252, 2.568469657593513],
            [31.186362293437394, 2.568749966252071],
            [31.187501202707434, 2.571363249777884],
            [31.190647439700655, 2.574606203757226],
            [31.19100725629445, 2.577253203411654],
            [31.192058699300233, 2.580510580731536],
            [31.192599444677068, 2.580787388659923],
            [31.19340910792076, 2.580477689067227],
            [31.196044068770004, 2.578009073542991],
            [31.197516938425018, 2.577070971519545],
            [31.198157468663634, 2.577089295668171],
            [31.200247406358667, 2.580539681759173],
            [31.20378184940359, 2.583969976426009],
            [31.205486811388653, 2.584925756648891],
            [31.207685703947877, 2.584850832618678],
            [31.209104595634095, 2.585375184972367],
            [31.21980278057468, 2.598466258125298],
            [31.221530252544145, 2.60118488068044],
            [31.22238432939377, 2.60860218126829],
            [31.22150055244421, 2.613938926647672],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 582,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "ANYIRIBU",
        Population: 7902,
        Key: "ARUAANYIRIBU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.071078932827778, 2.725400797215836],
            [31.06150867884613, 2.73819402441557],
            [31.058060085996285, 2.744097197605762],
            [31.055786314366564, 2.746648533846953],
            [31.05276375921828, 2.751381867000725],
            [31.046655913277245, 2.747380072539459],
            [31.03452079488627, 2.747579880341006],
            [31.028123677050697, 2.74866845142031],
            [31.02336765727171, 2.748990291992552],
            [31.01917803156758, 2.750416977747424],
            [31.017623704479238, 2.750288663943109],
            [31.014234018654122, 2.751051392548549],
            [31.008358160838576, 2.745224950884167],
            [30.997247843218663, 2.73378916498007],
            [30.99175218027914, 2.725524692692906],
            [30.988435434061845, 2.717227181406115],
            [30.981594160403723, 2.70623954399695],
            [30.97998272651446, 2.701840311571594],
            [30.977782925758508, 2.693803381094047],
            [30.976732848191944, 2.687761200330867],
            [30.976824778184877, 2.683988876407997],
            [30.978475688539284, 2.676264910516885],
            [30.98089932251461, 2.669798631086667],
            [30.983800551200584, 2.658143384466007],
            [30.984216935606135, 2.64938218522866],
            [30.9840972674339, 2.640485307555485],
            [30.981257925484464, 2.613858065474775],
            [30.98282069493983, 2.600582974351183],
            [30.984705317286757, 2.5955984658481],
            [30.991012691628836, 2.591160207471524],
            [31.000537233040614, 2.586726988590232],
            [31.01000395349082, 2.581276603051139],
            [31.011608713795848, 2.583093019733495],
            [31.013699509381972, 2.586691563726838],
            [31.013906462358822, 2.588415975829473],
            [31.013394773888134, 2.591395958975342],
            [31.013756862321294, 2.592638526060179],
            [31.015561900222266, 2.593987961778961],
            [31.015911315223406, 2.595021332111546],
            [31.016989361836295, 2.595689791802708],
            [31.017847696700397, 2.595521188585582],
            [31.019118292702867, 2.597771865271356],
            [31.019076615365268, 2.599484452606943],
            [31.020531189032862, 2.600480349710678],
            [31.023507473757483, 2.601112582478138],
            [31.02540106937582, 2.603329980321446],
            [31.02659038670968, 2.603231283772826],
            [31.027547759037216, 2.601658608120994],
            [31.02971460869024, 2.599758985990114],
            [31.031410063804657, 2.599578971197116],
            [31.033877726008654, 2.60042248957946],
            [31.03462265305972, 2.599814249103149],
            [31.03522792891498, 2.600048512016698],
            [31.037625644697723, 2.597966354357335],
            [31.038324040813663, 2.598060229631183],
            [31.039162170770386, 2.599698906578546],
            [31.042979991863287, 2.598389643313254],
            [31.043538670308138, 2.597828111115693],
            [31.044004280594635, 2.598062337604758],
            [31.045494016119086, 2.594739347531426],
            [31.047449454456537, 2.593663417112289],
            [31.048799606158894, 2.592259572824737],
            [31.04944236960929, 2.592149935255017],
            [31.050964678944258, 2.593594468455293],
            [31.0519424529102, 2.593969313914819],
            [31.05315298755281, 2.593876127536344],
            [31.053944584777813, 2.595655222406186],
            [31.05562081055526, 2.596966526485121],
            [31.05673822403885, 2.596592443801008],
            [31.058833434844583, 2.596967682326911],
            [31.05846099242948, 2.597622902658395],
            [31.05925252677242, 2.597997671542149],
            [31.05948537728059, 2.598980780198935],
            [31.061114998461086, 2.599309032416812],
            [31.0616271828018, 2.599777337629866],
            [31.063163650483954, 2.599637446977055],
            [31.063955200098242, 2.600246273534522],
            [31.065491647119156, 2.599638261807911],
            [31.065770983646658, 2.599217075857991],
            [31.065491588728683, 2.598608427384946],
            [31.066050269868494, 2.597953268587455],
            [31.06740054643668, 2.59860910042858],
            [31.06821531839937, 2.598117868214864],
            [31.070403621618013, 2.597837758977866],
            [31.071474558963768, 2.598727552514123],
            [31.072964377133218, 2.597136477393005],
            [31.073476553389092, 2.597323907687991],
            [31.075106086534706, 2.596341426813998],
            [31.07585109173918, 2.596856604850037],
            [31.075711473781105, 2.597839594144653],
            [31.07873802014416, 2.59961947762377],
            [31.079389852985692, 2.599432442521615],
            [31.080367731156205, 2.600930756048125],
            [31.080880013413264, 2.602662964985435],
            [31.08143875204526, 2.602803587571653],
            [31.083068313038645, 2.602101972225897],
            [31.08567579172842, 2.603085908665697],
            [31.086327702723366, 2.603928735508189],
            [31.087584867115744, 2.604163218414572],
            [31.086653660915793, 2.604396968111796],
            [31.08632777908019, 2.604864973502387],
            [31.088166908046173, 2.605969214086953],
            [31.089912817038535, 2.603087322052314],
            [31.091030213454143, 2.602198275526577],
            [31.0946385653891, 2.600818529363494],
            [31.096407686848387, 2.598618946608323],
            [31.09910811062735, 2.597355890753912],
            [31.10042989982125, 2.597229907621847],
            [31.10134453749406, 2.599015368349639],
            [31.104509240256256, 2.603013514551833],
            [31.10469561372826, 2.604339656464096],
            [31.104207013757012, 2.605680559885368],
            [31.104060728502905, 2.609026552486098],
            [31.102709047867926, 2.610208301796686],
            [31.10416823528284, 2.610605118328395],
            [31.105299145055255, 2.610101745606903],
            [31.10395217069407, 2.617393114775791],
            [31.10129860843023, 2.623290552335095],
            [31.09883104324425, 2.626379306764019],
            [31.097574085464437, 2.629281212246851],
            [31.095991138949465, 2.631621273548682],
            [31.096270589562963, 2.632791674959857],
            [31.095339345633807, 2.632650910365099],
            [31.08865806462273, 2.638991556888415],
            [31.08635343496469, 2.642665457103566],
            [31.085468872887564, 2.645239797032971],
            [31.084537919114236, 2.651278138912595],
            [31.083187719801163, 2.653805485471068],
            [31.08421216663601, 2.655444271438132],
            [31.084445033313862, 2.656614644094375],
            [31.084258840403237, 2.657972120067572],
            [31.083653542988376, 2.65862725723259],
            [31.08383984549345, 2.659750798789968],
            [31.08270669352608, 2.66124819096424],
            [31.082500658627463, 2.664088514461664],
            [31.08294968242056, 2.674877294350717],
            [31.08377424062996, 2.675048285400157],
            [31.084623093776198, 2.676438331356993],
            [31.084077541514265, 2.680034318600001],
            [31.083301496821775, 2.680765457016657],
            [31.079663734942752, 2.681227285994068],
            [31.076074614141426, 2.688247589188447],
            [31.07596552542827, 2.691356121440721],
            [31.076329331440242, 2.692819121879106],
            [31.074461930695602, 2.693062184314138],
            [31.073467611558748, 2.693598166984434],
            [31.073176611305634, 2.695255950819266],
            [31.072206534105018, 2.696572125194271],
            [31.070436144224555, 2.696888360663782],
            [31.07030276686275, 2.697826966349024],
            [31.070909072187344, 2.698924351888158],
            [31.069065937633468, 2.701044736880793],
            [31.06928421477279, 2.704043668890237],
            [31.068508142232528, 2.70457972657916],
            [31.06803522594783, 2.7085657918316],
            [31.069599485708288, 2.713844892101481],
            [31.070157285600814, 2.714527791591619],
            [31.069963262974152, 2.715941795397813],
            [31.070690821997502, 2.718965327775847],
            [31.07032702407037, 2.721013175625983],
            [31.07081207389959, 2.721647272190002],
            [31.07071504866239, 2.722963797437028],
            [31.071077313165343, 2.723664900684938],
            [31.070736259682885, 2.724274282416135],
            [31.071266777740227, 2.725150688499114],
            [31.071078932827778, 2.725400797215836],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 583,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "OFFAKA",
        Population: 19166,
        Key: "ARUAOFFAKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.39520858562153, 2.918014745828028],
            [31.391270118091047, 2.920613396748181],
            [31.386851653754782, 2.922288187747291],
            [31.383800798980133, 2.922953334216057],
            [31.382240399280477, 2.923790043311308],
            [31.378068208079352, 2.928458562926711],
            [31.376092571122765, 2.929733588739116],
            [31.375789160643983, 2.930467132377157],
            [31.374795506260444, 2.930325587809214],
            [31.37465311250813, 2.929857279377867],
            [31.37400484597828, 2.930428235052817],
            [31.37402448045544, 2.929776461319896],
            [31.373294852612005, 2.93008272462298],
            [31.372564534862438, 2.929696494643085],
            [31.372807338703947, 2.929187056492923],
            [31.372057079253377, 2.92912672999903],
            [31.371084354717645, 2.929657287778254],
            [31.37088242511987, 2.930492568106251],
            [31.370354826587196, 2.930065386478264],
            [31.369341501793883, 2.93053488353373],
            [31.369160078937444, 2.931614550353858],
            [31.368137017304758, 2.932501586064574],
            [31.369821836366203, 2.934455134897711],
            [31.37377807257301, 2.942896275686786],
            [31.37772587809088, 2.948381288974526],
            [31.371656356974817, 2.954696760237514],
            [31.369230955115036, 2.955563508035728],
            [31.367323225404036, 2.957649471512407],
            [31.365062791061327, 2.964086530538652],
            [31.362401539218663, 2.968318151045856],
            [31.358689460614496, 2.975649334122753],
            [31.34582344506059, 2.975040890161462],
            [31.33952797249773, 2.975403505151403],
            [31.326949088153004, 2.978175483898429],
            [31.323035881248302, 2.978301460339127],
            [31.31317339991484, 2.980378151529004],
            [31.299663311166835, 2.984779982957678],
            [31.299438009202003, 2.982254715836181],
            [31.300092413920193, 2.977152230023006],
            [31.300098437124163, 2.972579896334391],
            [31.303729867677077, 2.963645618021213],
            [31.304254186460618, 2.960508626326034],
            [31.30611713695134, 2.957859164012827],
            [31.30409006785147, 2.958411005693419],
            [31.302629662321056, 2.957801402138915],
            [31.301636811929683, 2.958515183523696],
            [31.29711534676296, 2.958519490587127],
            [31.290716086445446, 2.955949161174923],
            [31.284378216994448, 2.95394902662125],
            [31.282289690552712, 2.953767689608669],
            [31.277864657735112, 2.954362471346515],
            [31.27554790082072, 2.953499050933321],
            [31.271979069368403, 2.953074679833186],
            [31.264596844619216, 2.95073939157328],
            [31.262506989569218, 2.949010182313292],
            [31.261372378737793, 2.949907342598112],
            [31.261170354816915, 2.950742554833403],
            [31.25999458317922, 2.950947292924916],
            [31.259731966994092, 2.952047317238781],
            [31.25924563167569, 2.952353263124194],
            [31.258150373341945, 2.951885841329522],
            [31.257785578284835, 2.952069475284676],
            [31.25752496534284, 2.955470881251088],
            [31.2560364955446, 2.957478326374352],
            [31.253746095200647, 2.958274695772198],
            [31.25220441818816, 2.957400355083767],
            [31.251210886873796, 2.957340158405175],
            [31.25063519523578, 2.957903369526563],
            [31.25062936786454, 2.958809231844882],
            [31.24937872434283, 2.959919078075288],
            [31.24937461455041, 2.95870801273681],
            [31.246391207982196, 2.958143594502941],
            [31.24675424323966, 2.959952571932124],
            [31.245594652056848, 2.960563744257063],
            [31.243979836010546, 2.959825552743328],
            [31.242790093773525, 2.96022211692655],
            [31.242241562698084, 2.960037337805484],
            [31.241816298445958, 2.959025184212345],
            [31.240688505827567, 2.958808829936115],
            [31.24062399331544, 2.961046231251906],
            [31.242571873228087, 2.963256196092516],
            [31.242600523197414, 2.964420971697227],
            [31.241288912814024, 2.96475603535109],
            [31.240830736086505, 2.96527636610733],
            [31.24073761672415, 2.966318342051171],
            [31.236164721210766, 2.965912559534978],
            [31.23485242900609, 2.966676720157741],
            [31.234302146215843, 2.9675953573293],
            [31.235184413097414, 2.968822799546521],
            [31.234428465514455, 2.969635175073566],
            [31.23337781122952, 2.96978801372301],
            [31.235346638057948, 2.972237857356116],
            [31.233959849465034, 2.974321742196743],
            [31.23160106127685, 2.975425383730224],
            [31.231522394010764, 2.976558453633961],
            [31.230342976111316, 2.977123146845298],
            [31.22955012034661, 2.976271971720896],
            [31.22821789272911, 2.976269818672347],
            [31.228957240343934, 2.978537403500026],
            [31.228182789262764, 2.982193277133432],
            [31.224522123937245, 2.980333030078195],
            [31.223240430147754, 2.980768774015325],
            [31.222982287572773, 2.981978810407503],
            [31.221905344091024, 2.982543655139192],
            [31.220749881565233, 2.984138544325461],
            [31.219827235411664, 2.984343077075208],
            [31.21936375323409, 2.985784562968544],
            [31.220796681096623, 2.986894331825888],
            [31.219719317203328, 2.987716714564707],
            [31.21989578854593, 2.989494048778814],
            [31.219406638805754, 2.990961245730299],
            [31.22009717286634, 2.991709246714082],
            [31.220274765306417, 2.992791216831349],
            [31.21924834127963, 2.993793957650968],
            [31.21822345516861, 2.993843792752476],
            [31.21550956923681, 2.992706165511498],
            [31.214382290454765, 2.992704320197064],
            [31.21173904624025, 2.995404176969087],
            [31.211098714529328, 2.995300108483213],
            [31.211151670215326, 2.994244274837471],
            [31.209511282726147, 2.994679400541686],
            [31.208205420662217, 2.994213679620352],
            [31.207667151940623, 2.994367319543052],
            [31.207666312914135, 2.994882399996459],
            [31.20940796479038, 2.995194313989908],
            [31.20958671695548, 2.995555166727379],
            [31.209201580447097, 2.996069615969585],
            [31.207280588009244, 2.995757405289457],
            [31.206103121250592, 2.995111615021861],
            [31.20389913973528, 2.995520049327064],
            [31.20414391987044, 2.996280631538059],
            [31.200460218147782, 2.995824564857462],
            [31.198772275644092, 2.996237146131099],
            [31.198188088638393, 2.995509279787399],
            [31.196949319048116, 2.994988015102244],
            [31.195571000670036, 2.995574175120981],
            [31.192886924432624, 2.994496686018802],
            [31.18926995765411, 2.995356033846513],
            [31.188132279075994, 2.996184880031905],
            [31.186515148071205, 2.995420678901687],
            [31.184242812847618, 2.995243824281801],
            [31.182246977271895, 2.994444374982105],
            [31.180630770633524, 2.991718612343744],
            [31.18063160876168, 2.991210488243962],
            [31.1815524870308, 2.990103382732634],
            [31.18173972198712, 2.988024992880657],
            [31.178626693015037, 2.980906034777549],
            [31.178263944320147, 2.977949058914398],
            [31.17739275995423, 2.976792776102858],
            [31.173673942188806, 2.97480027951287],
            [31.171147673895668, 2.974149367913368],
            [31.168803069207485, 2.972543942993754],
            [31.167888524959434, 2.97252865360588],
            [31.167521399672484, 2.971787470153203],
            [31.167014866633245, 2.972433327053067],
            [31.166400984019234, 2.971860431880594],
            [31.166314222932463, 2.970973381836441],
            [31.163670514288953, 2.969106464676116],
            [31.162408580740756, 2.967507928513212],
            [31.161673021321487, 2.967713644049611],
            [31.161233605010384, 2.966678187831948],
            [31.16017646219412, 2.965730390165891],
            [31.159796498185155, 2.964310711097314],
            [31.16056400439087, 2.962567751384515],
            [31.159537591143845, 2.960821795251233],
            [31.157921986376728, 2.959695687884763],
            [31.157776947984225, 2.958483346600389],
            [31.156751371967065, 2.956234816723396],
            [31.156221631850745, 2.956470438940352],
            [31.15572276862739, 2.955819210635962],
            [31.155310954850002, 2.955877649041678],
            [31.154782975431655, 2.955048994134986],
            [31.15516567391235, 2.95481312670219],
            [31.154930945026948, 2.954487536333806],
            [31.151759172523462, 2.951880663133609],
            [31.15067352077335, 2.95040068405018],
            [31.14972135687785, 2.949995846660803],
            [31.148545876294282, 2.948319276920841],
            [31.14623698772347, 2.946387949103862],
            [31.138644014615398, 2.934356962048128],
            [31.135786280558822, 2.931628946753739],
            [31.134465734633267, 2.930892415503074],
            [31.13440086279501, 2.928059940157381],
            [31.133602589290845, 2.927009578685814],
            [31.13334640773813, 2.924176784905638],
            [31.13273839920773, 2.923756158109566],
            [31.132930689882517, 2.923162032920772],
            [31.132306044553044, 2.922286800757866],
            [31.13159724864107, 2.919715507787816],
            [31.132329828348528, 2.918422936684494],
            [31.13080221895336, 2.916706978609883],
            [31.130486995628576, 2.913810943588356],
            [31.129226496689906, 2.912976331788533],
            [31.127733593705763, 2.9096041766937],
            [31.125133350945575, 2.908172684265403],
            [31.12016312070059, 2.909155437397118],
            [31.11882107629367, 2.909946045582451],
            [31.117595352037945, 2.911926130260544],
            [31.116056269359973, 2.912637113117465],
            [31.11534488719829, 2.913587342315558],
            [31.11455780670252, 2.91263459121526],
            [31.112901611559295, 2.912631801960933],
            [31.111877607593883, 2.911876864765906],
            [31.110155969283866, 2.911778634317234],
            [31.10412284520817, 2.902704700681543],
            [31.100651409098926, 2.895040889190556],
            [31.09623195392093, 2.887717191448124],
            [31.09985725616695, 2.87778621583316],
            [31.103059071926797, 2.866255934330252],
            [31.10408439372074, 2.861045983624724],
            [31.10415858108847, 2.857449121901845],
            [31.103892459677134, 2.852858757876782],
            [31.10234865006414, 2.847493236338761],
            [31.099614438850715, 2.842447434883494],
            [31.096437848682367, 2.838087531251077],
            [31.097043944699507, 2.8363480896663],
            [31.097961133587745, 2.835586985690141],
            [31.097542096457165, 2.835293471507364],
            [31.097617282751493, 2.832765972874511],
            [31.097237097756945, 2.831587800883296],
            [31.09794328945293, 2.830237666610395],
            [31.100492144985598, 2.82985042928596],
            [31.10396450815617, 2.830597493757513],
            [31.105845753735977, 2.830591467135743],
            [31.10676998182277, 2.83193638726128],
            [31.107186200938326, 2.831387481585401],
            [31.109777576428293, 2.831210690918446],
            [31.11007176929396, 2.831673079703168],
            [31.109613742585093, 2.832222123415245],
            [31.110931810058783, 2.832575932306703],
            [31.112099828337264, 2.83181399771743],
            [31.113971071176394, 2.829415873338486],
            [31.113411611197233, 2.828857123958834],
            [31.112671906052928, 2.828930271660684],
            [31.11137871742105, 2.828258940547462],
            [31.11052801554192, 2.828369082503166],
            [31.1085731242785, 2.825280067676772],
            [31.10853885534706, 2.823606981753672],
            [31.109836729591464, 2.821378399166524],
            [31.11568917461576, 2.815327843110853],
            [31.1168020659802, 2.813136114655857],
            [31.117435182422764, 2.810348745681237],
            [31.11832565451616, 2.808491257155115],
            [31.119325508173468, 2.807600588279517],
            [31.12406407278819, 2.804299340081904],
            [31.127059350592845, 2.804304165436045],
            [31.129055817684225, 2.805491837196653],
            [31.13039022191966, 2.802562116187723],
            [31.13930976954717, 2.797743127921546],
            [31.14234233013106, 2.797562067546981],
            [31.146559738032032, 2.796416222716759],
            [31.154815013846267, 2.790703678708958],
            [31.156217159138965, 2.790402482636808],
            [31.159197172770302, 2.793503537490338],
            [31.160378389995273, 2.792568374329313],
            [31.16091739892868, 2.79126080887148],
            [31.162709987976445, 2.789780652223437],
            [31.164045888805145, 2.789228679655777],
            [31.166429943907357, 2.789557837952948],
            [31.168391920183417, 2.788708952252051],
            [31.169261178561353, 2.786178733642584],
            [31.171074588760778, 2.784677416928633],
            [31.17387121402183, 2.783404535085299],
            [31.17629606431603, 2.78343868103982],
            [31.179050014211207, 2.78191318515209],
            [31.180767739459828, 2.787855299735382],
            [31.182821509184894, 2.791824962435627],
            [31.186139353143474, 2.793802245597227],
            [31.189062250092434, 2.797634248187973],
            [31.189224129201584, 2.805822475857884],
            [31.18957812740728, 2.806646925460602],
            [31.190755184534154, 2.808530180162658],
            [31.194279433497254, 2.812158041738947],
            [31.19559131696849, 2.814344139211512],
            [31.20052860150046, 2.819304044013538],
            [31.250608726375933, 2.792984656287651],
            [31.276652612126213, 2.778263076738633],
            [31.278466083411075, 2.781416494285564],
            [31.27971702876671, 2.788033539748886],
            [31.277775428077923, 2.791214636411191],
            [31.278046771396017, 2.79489358344839],
            [31.279025306235006, 2.798542664059137],
            [31.2776691969057, 2.800797247477397],
            [31.27720692925036, 2.805733233835973],
            [31.278620157957047, 2.812432795236691],
            [31.27892026982212, 2.816825382675384],
            [31.274667353314623, 2.842247182963432],
            [31.273433262150323, 2.847485057407584],
            [31.27181788914856, 2.851412416278422],
            [31.271967026553718, 2.854186615103136],
            [31.273496211593862, 2.856654681182381],
            [31.275241497155402, 2.858342626156483],
            [31.274447770024885, 2.860777134459185],
            [31.27346672080142, 2.866462564685619],
            [31.273411803194833, 2.873557488503194],
            [31.28070737465507, 2.87526572259798],
            [31.288225110264843, 2.878672742966154],
            [31.29482427537751, 2.880380525292428],
            [31.30864049470298, 2.881327339084538],
            [31.314011303496123, 2.883187548008748],
            [31.322148869465426, 2.882890944458899],
            [31.349486875400547, 2.876448329451588],
            [31.375249529178085, 2.861481082115354],
            [31.374992830195737, 2.864307450807536],
            [31.372899582208902, 2.869242558830916],
            [31.371434531490124, 2.87506795173778],
            [31.370962273670536, 2.878675763776994],
            [31.371811872418498, 2.884563896528765],
            [31.37606014194101, 2.892860564164975],
            [31.37908673411815, 2.902276924445623],
            [31.3827149046849, 2.90634839557538],
            [31.39388728780611, 2.916115509748484],
            [31.39520858562153, 2.918014745828028],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 584,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "OGOKO",
        Population: 18649,
        Key: "ARUAOGOKO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.276652612126213, 2.778263076738633],
            [31.250608726375933, 2.792984656287651],
            [31.20052860150046, 2.819304044013538],
            [31.19559131696849, 2.814344139211512],
            [31.194279433497254, 2.812158041738947],
            [31.190755184534154, 2.808530180162658],
            [31.18957812740728, 2.806646925460602],
            [31.189224129201584, 2.805822475857884],
            [31.189062250092434, 2.797634248187973],
            [31.186139353143474, 2.793802245597227],
            [31.182821509184894, 2.791824962435627],
            [31.180767739459828, 2.787855299735382],
            [31.179050014211207, 2.78191318515209],
            [31.17629606431603, 2.78343868103982],
            [31.17387121402183, 2.783404535085299],
            [31.171074588760778, 2.784677416928633],
            [31.169261178561353, 2.786178733642584],
            [31.168391920183417, 2.788708952252051],
            [31.166429943907357, 2.789557837952948],
            [31.164045888805145, 2.789228679655777],
            [31.162709987976445, 2.789780652223437],
            [31.16091739892868, 2.79126080887148],
            [31.160378389995273, 2.792568374329313],
            [31.159197172770302, 2.793503537490338],
            [31.156217159138965, 2.790402482636808],
            [31.154815013846267, 2.790703678708958],
            [31.146559738032032, 2.796416222716759],
            [31.14234233013106, 2.797562067546981],
            [31.13930976954717, 2.797743127921546],
            [31.13039022191966, 2.802562116187723],
            [31.129055817684225, 2.805491837196653],
            [31.12585028918731, 2.799401726360788],
            [31.126091060141356, 2.798049141209529],
            [31.12918681810381, 2.794693301811507],
            [31.130199350583055, 2.792538931119302],
            [31.129949180556213, 2.79120688776419],
            [31.121511762334926, 2.782442597847096],
            [31.113727922381795, 2.776727298731347],
            [31.112515236274106, 2.775391198029066],
            [31.11271226556202, 2.774893555115524],
            [31.113319339844498, 2.775101229967374],
            [31.11385981662507, 2.774046659753377],
            [31.114949329334276, 2.773231270285909],
            [31.117043245667688, 2.773151526014239],
            [31.116038709991113, 2.77249897675504],
            [31.1162322592056, 2.772056093551913],
            [31.117375925953365, 2.771836326631959],
            [31.117736855559798, 2.770077978945988],
            [31.11860585432464, 2.769331477048946],
            [31.118358936199126, 2.768680141480365],
            [31.119238864765986, 2.769734133253885],
            [31.11988663362918, 2.769513570027914],
            [31.119626311741307, 2.768626765776608],
            [31.121102451263955, 2.767216437528632],
            [31.12074646688314, 2.765844737717782],
            [31.12091458030038, 2.764058377340159],
            [31.12173317459459, 2.763354565588312],
            [31.117260507710725, 2.76230683917535],
            [31.11703995873207, 2.761538967441756],
            [31.116002528546414, 2.760883553977253],
            [31.115566838447112, 2.760939866802353],
            [31.114971235650792, 2.762039788716973],
            [31.113771090922782, 2.761604501500416],
            [31.112845971707202, 2.761936903950833],
            [31.110879141833664, 2.760351214604628],
            [31.11076794387622, 2.759692788337968],
            [31.110276844791876, 2.759474788550718],
            [31.109858971877898, 2.759964739333177],
            [31.108023692192873, 2.758609205410411],
            [31.106628612149883, 2.758525898873684],
            [31.10404760501491, 2.755767368356596],
            [31.10278105053288, 2.755024853037064],
            [31.102646877263737, 2.754015153094416],
            [31.10098284072637, 2.751736759924948],
            [31.10071701575908, 2.750463972810514],
            [31.099534516638183, 2.748798887470037],
            [31.100240537654297, 2.746225722220409],
            [31.099998002409052, 2.745311323473611],
            [31.100394659810945, 2.74333673828033],
            [31.099149090872302, 2.741620035540592],
            [31.099330180453784, 2.738279284873546],
            [31.097908158138818, 2.73696888426355],
            [31.096098988885824, 2.735887672888474],
            [31.09488604945322, 2.735779669511726],
            [31.091443204922864, 2.733829650836392],
            [31.088650794557125, 2.731933705332554],
            [31.08385768423838, 2.7278072112681],
            [31.08318974640045, 2.727717753406025],
            [31.081451982432775, 2.731675018942151],
            [31.077951910727226, 2.731557662684664],
            [31.07650843574497, 2.730884976887099],
            [31.07484459414201, 2.729038803360483],
            [31.071428612831927, 2.727412740423643],
            [31.071078932827778, 2.725400797215836],
            [31.071266777740227, 2.725150688499114],
            [31.070736259682885, 2.724274282416135],
            [31.071077313165343, 2.723664900684938],
            [31.07071504866239, 2.722963797437028],
            [31.07081207389959, 2.721647272190002],
            [31.07032702407037, 2.721013175625983],
            [31.070690821997502, 2.718965327775847],
            [31.069963262974152, 2.715941795397813],
            [31.070157285600814, 2.714527791591619],
            [31.069599485708288, 2.713844892101481],
            [31.06803522594783, 2.7085657918316],
            [31.068508142232528, 2.70457972657916],
            [31.06928421477279, 2.704043668890237],
            [31.069065937633468, 2.701044736880793],
            [31.070909072187344, 2.698924351888158],
            [31.07030276686275, 2.697826966349024],
            [31.070436144224555, 2.696888360663782],
            [31.072206534105018, 2.696572125194271],
            [31.073176611305634, 2.695255950819266],
            [31.073467611558748, 2.693598166984434],
            [31.074461930695602, 2.693062184314138],
            [31.076329331440242, 2.692819121879106],
            [31.07596552542827, 2.691356121440721],
            [31.076074614141426, 2.688247589188447],
            [31.079663734942752, 2.681227285994068],
            [31.083301496821775, 2.680765457016657],
            [31.084077541514265, 2.680034318600001],
            [31.084623093776198, 2.676438331356993],
            [31.08377424062996, 2.675048285400157],
            [31.08294968242056, 2.674877294350717],
            [31.082500658627463, 2.664088514461664],
            [31.08270669352608, 2.66124819096424],
            [31.08383984549345, 2.659750798789968],
            [31.083653542988376, 2.65862725723259],
            [31.084258840403237, 2.657972120067572],
            [31.084445033313862, 2.656614644094375],
            [31.08421216663601, 2.655444271438132],
            [31.083187719801163, 2.653805485471068],
            [31.084537919114236, 2.651278138912595],
            [31.085468872887564, 2.645239797032971],
            [31.08635343496469, 2.642665457103566],
            [31.08865806462273, 2.638991556888415],
            [31.095339345633807, 2.632650910365099],
            [31.096270589562963, 2.632791674959857],
            [31.095991138949465, 2.631621273548682],
            [31.097574085464437, 2.629281212246851],
            [31.09883104324425, 2.626379306764019],
            [31.10129860843023, 2.623290552335095],
            [31.10395217069407, 2.617393114775791],
            [31.105299145055255, 2.610101745606903],
            [31.106774282956373, 2.609293306163285],
            [31.10916767874087, 2.610570507164032],
            [31.111375849998648, 2.612554745936518],
            [31.11318484497847, 2.612638336130567],
            [31.115679638999005, 2.6111463200118],
            [31.117171172950677, 2.608439984411289],
            [31.122143180961615, 2.605433687043935],
            [31.123635423684064, 2.604115731355733],
            [31.127148505689842, 2.60394258579042],
            [31.128427580890285, 2.602802707233507],
            [31.13055503941812, 2.603840633566841],
            [31.13232571855611, 2.606198227045035],
            [31.13416480440297, 2.607129891172737],
            [31.136131753752462, 2.607485148973238],
            [31.140740930423547, 2.607193889112097],
            [31.145254294583047, 2.607918794143423],
            [31.1493647867955, 2.607694516102049],
            [31.151414059554227, 2.607060647114502],
            [31.153991839940726, 2.604408439414881],
            [31.158259875094437, 2.603579637272749],
            [31.16147583482842, 2.604566820203316],
            [31.16260535850038, 2.603941738656409],
            [31.163665881677023, 2.604434522876567],
            [31.16553727183984, 2.603336234219517],
            [31.16703593931319, 2.603711084862933],
            [31.16867039792149, 2.603374696275354],
            [31.16988071786673, 2.605121183765898],
            [31.170265509422027, 2.606951159796711],
            [31.170094508819513, 2.608712567621486],
            [31.170750807186316, 2.609170882352179],
            [31.172044745911435, 2.611340972150961],
            [31.17463549886895, 2.61369929011179],
            [31.174632287391795, 2.615918302582454],
            [31.176196371082447, 2.617665316451207],
            [31.17878856493764, 2.619041176427123],
            [31.17977982531095, 2.619245733483667],
            [31.17991933547121, 2.617954415690046],
            [31.184575886595425, 2.619126048540367],
            [31.18471552521477, 2.618704752459605],
            [31.18532082981614, 2.618564480732612],
            [31.18634532695665, 2.619173323250808],
            [31.186764311086634, 2.618564861220568],
            [31.18862677379213, 2.617909940752182],
            [31.189511579312704, 2.618518763846206],
            [31.18959198212388, 2.620062304819323],
            [31.19060384445992, 2.621085653383065],
            [31.193198334408994, 2.621606317703639],
            [31.194074720020403, 2.622464873857439],
            [31.196595026195006, 2.62226681701137],
            [31.197509280287225, 2.622948929226671],
            [31.19949216035994, 2.621577621442354],
            [31.201811782001776, 2.621442298164161],
            [31.204092946766266, 2.621899451527486],
            [31.20600914579377, 2.623326832263656],
            [31.206611682685747, 2.622810806289169],
            [31.210075670862953, 2.623785596621115],
            [31.21407407937909, 2.617424872089683],
            [31.216588313840678, 2.615927402904638],
            [31.22150055244421, 2.613938926647672],
            [31.221962561384746, 2.615702668629794],
            [31.22267520478109, 2.616469311222466],
            [31.224577824874768, 2.616926614468348],
            [31.226672626947053, 2.616068266299577],
            [31.228527169206703, 2.618280917556245],
            [31.230943251045435, 2.617716346743221],
            [31.23216770508333, 2.616506739993493],
            [31.233190243896505, 2.616843152885134],
            [31.23535570834737, 2.621115557522977],
            [31.235464303885422, 2.622205223907611],
            [31.23450677704769, 2.624180992799593],
            [31.235557086379565, 2.62557949708194],
            [31.234056434527755, 2.628306906296344],
            [31.23383988574705, 2.629505459502635],
            [31.234103967084373, 2.630390018667635],
            [31.23533489078897, 2.631321420719361],
            [31.23587629103765, 2.634302817741504],
            [31.236659093756032, 2.636697775741997],
            [31.23741942062598, 2.637784412478444],
            [31.240462155528792, 2.639607126834492],
            [31.244625086895976, 2.640019793107157],
            [31.245124136968897, 2.640427246469494],
            [31.247468119124587, 2.646095441123379],
            [31.25027854250843, 2.646392180148927],
            [31.250493034147116, 2.64670700084744],
            [31.25151311427137, 2.646184703958423],
            [31.252560911913726, 2.646281995443037],
            [31.252653383590744, 2.648274873695743],
            [31.253472139581724, 2.648659256026599],
            [31.254150346959968, 2.647366847923243],
            [31.255455341251338, 2.647483663099508],
            [31.25783473409721, 2.649115722789026],
            [31.25856430804172, 2.651962178887172],
            [31.259326326439357, 2.652049482377456],
            [31.26047032556378, 2.651485849356439],
            [31.261754761909835, 2.652685235378669],
            [31.26390767509956, 2.652784083259278],
            [31.265991377588207, 2.654693561093425],
            [31.26723849252745, 2.655337220189717],
            [31.267374167779774, 2.656011240797296],
            [31.26662638318781, 2.657051280982908],
            [31.26841605989745, 2.658031028325504],
            [31.268152387293565, 2.660268952280455],
            [31.269562976749906, 2.662209789744658],
            [31.270293252278687, 2.664567650507266],
            [31.27128354067483, 2.664933112657211],
            [31.27169073441671, 2.666696520227593],
            [31.274325423974762, 2.669756460582158],
            [31.274811258033253, 2.669785888855421],
            [31.275509544554716, 2.668829418016578],
            [31.275547828955517, 2.66764086784347],
            [31.27830993465514, 2.66815253561958],
            [31.280070395456782, 2.669611272715239],
            [31.2818424804582, 2.669565863702863],
            [31.28301174200506, 2.671406995728814],
            [31.286409720178554, 2.67369197416419],
            [31.2867711618247, 2.674114032240325],
            [31.286466022088966, 2.675370696526271],
            [31.287063398159656, 2.676346743024588],
            [31.288330657819177, 2.676233554922291],
            [31.288883852947546, 2.675784039099022],
            [31.289629901994388, 2.673667752336137],
            [31.29019174520398, 2.673850572254021],
            [31.291475615611432, 2.675500254810004],
            [31.291979975625996, 2.675362633063633],
            [31.292638300592085, 2.675391821613728],
            [31.291050346867724, 2.677038128116698],
            [31.289619004531662, 2.681071441873626],
            [31.28500149239308, 2.69784334602172],
            [31.285444639407554, 2.701905835428599],
            [31.29050619867255, 2.707488131659007],
            [31.291770272906064, 2.70982616686216],
            [31.298231454994436, 2.71527771771558],
            [31.30081356705724, 2.719157427084321],
            [31.30931690185741, 2.726078795398257],
            [31.31836010887196, 2.731973775804224],
            [31.322668609536, 2.733218205687813],
            [31.327162799155754, 2.733781781156514],
            [31.32980854966986, 2.735209615637034],
            [31.33070311089441, 2.736994256050895],
            [31.326575551589908, 2.743468868090306],
            [31.325358446669327, 2.748144257498582],
            [31.32555500703662, 2.751057275116092],
            [31.276652612126213, 2.778263076738633],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 585,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "OKOLLO",
        Population: 17832,
        Key: "ARUAOKOLLO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.375249529178085, 2.861481082115354],
            [31.349486875400547, 2.876448329451588],
            [31.322148869465426, 2.882890944458899],
            [31.314011303496123, 2.883187548008748],
            [31.30864049470298, 2.881327339084538],
            [31.29482427537751, 2.880380525292428],
            [31.288225110264843, 2.878672742966154],
            [31.28070737465507, 2.87526572259798],
            [31.273411803194833, 2.873557488503194],
            [31.27346672080142, 2.866462564685619],
            [31.274447770024885, 2.860777134459185],
            [31.275241497155402, 2.858342626156483],
            [31.273496211593862, 2.856654681182381],
            [31.271967026553718, 2.854186615103136],
            [31.27181788914856, 2.851412416278422],
            [31.273433262150323, 2.847485057407584],
            [31.274667353314623, 2.842247182963432],
            [31.27892026982212, 2.816825382675384],
            [31.278620157957047, 2.812432795236691],
            [31.27720692925036, 2.805733233835973],
            [31.2776691969057, 2.800797247477397],
            [31.279025306235006, 2.798542664059137],
            [31.278046771396017, 2.79489358344839],
            [31.277775428077923, 2.791214636411191],
            [31.27971702876671, 2.788033539748886],
            [31.278466083411075, 2.781416494285564],
            [31.276652612126213, 2.778263076738633],
            [31.32555500703662, 2.751057275116092],
            [31.327540864126217, 2.754975104410665],
            [31.32974402188639, 2.757657462605443],
            [31.334771491883, 2.76150752343878],
            [31.339989204395508, 2.764058813413489],
            [31.348695707570222, 2.765888030040248],
            [31.354113408421217, 2.768111051751102],
            [31.35705195671737, 2.770346550253579],
            [31.386941768252516, 2.775592967916036],
            [31.386294760262395, 2.778340144140741],
            [31.38176141936761, 2.785984971759549],
            [31.381976385316765, 2.789486291171845],
            [31.3800810056443, 2.794899894681856],
            [31.378293140836604, 2.802117188718579],
            [31.372602537192215, 2.814325779156965],
            [31.366350832346633, 2.824019234879549],
            [31.361516012350926, 2.834246535251387],
            [31.361034507273786, 2.837202427152336],
            [31.36183462322263, 2.841200002684907],
            [31.362306378883968, 2.848039818673161],
            [31.36392438215291, 2.849868309897979],
            [31.365591220535652, 2.851061724662173],
            [31.367279093869065, 2.851668387391883],
            [31.371043443642968, 2.852142439689194],
            [31.372601982931673, 2.853183848192053],
            [31.374900397146263, 2.858527154580764],
            [31.375249529178085, 2.861481082115354],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 586,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "PAWOR",
        Population: 9782,
        Key: "ARUAPAWOR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.40530936664369, 2.986738364688875],
            [31.39165039291711, 2.990673320561564],
            [31.37661973756577, 2.997162402436982],
            [31.3769260307383, 2.99756341528018],
            [31.37010318422161, 3.000242784125137],
            [31.353269699028257, 3.009421611898195],
            [31.339320759009457, 3.019833080508687],
            [31.33293762165465, 3.028174184434092],
            [31.33021463938228, 3.030547516246231],
            [31.32994529661232, 3.032396956945985],
            [31.328890937675126, 3.032886070232139],
            [31.32848283663484, 3.033682636856543],
            [31.32922885244399, 3.036369249201777],
            [31.32823427279571, 3.037498753712658],
            [31.32472171360941, 3.03737127706133],
            [31.318905676405276, 3.039310179818224],
            [31.3148635082567, 3.038865388299316],
            [31.313920177495362, 3.038304348461315],
            [31.311610041164645, 3.039430512121605],
            [31.309414646645152, 3.039156130911674],
            [31.308556393527756, 3.039997810099897],
            [31.30628070848649, 3.037870183016661],
            [31.305533497918, 3.037661733019176],
            [31.30480019327012, 3.040857787563166],
            [31.299358032192252, 3.042875742756579],
            [31.297139829447726, 3.044753820305716],
            [31.29448635701539, 3.045275401981579],
            [31.29373065557084, 3.045867864413645],
            [31.293367166664144, 3.047165528045449],
            [31.2928633663, 3.047560503239966],
            [31.29020511393205, 3.048532583646895],
            [31.28700585028593, 3.048697697146381],
            [31.286650319554354, 3.049244491905368],
            [31.28673854040347, 3.050346853665241],
            [31.285783545916484, 3.050887058811793],
            [31.285415788215584, 3.052585176937134],
            [31.283350078083764, 3.05421456302468],
            [31.28334476904045, 3.054715135947111],
            [31.28188914703888, 3.055349954917052],
            [31.281282238046433, 3.056044168177227],
            [31.281375769735483, 3.056645955655809],
            [31.28051907968667, 3.057337423145344],
            [31.280708265783822, 3.058340769860405],
            [31.279998252654618, 3.059334221340662],
            [31.280238993065925, 3.060187942671809],
            [31.27943651005633, 3.06047949761473],
            [31.278666437363842, 3.062423497805748],
            [31.27891698647973, 3.064704127645221],
            [31.278616721002752, 3.064750886256518],
            [31.2781001313239, 3.06634721627008],
            [31.27729711291837, 3.066688826437454],
            [31.277740867194023, 3.067244407387459],
            [31.27758088173349, 3.068193841536708],
            [31.279269279683035, 3.069163620306958],
            [31.279504692186393, 3.070517926243675],
            [31.27864851777055, 3.07115931642084],
            [31.279140100148528, 3.071915678740643],
            [31.27882865873113, 3.073013639699507],
            [31.279173022505383, 3.073518064618401],
            [31.27886796900794, 3.074015336439939],
            [31.277366617368532, 3.074249123850537],
            [31.276805919510934, 3.075294284614267],
            [31.275454435606978, 3.075529720469885],
            [31.2748581518877, 3.076154281316984],
            [31.272142745108116, 3.076449746502993],
            [31.27146322259629, 3.076862928484183],
            [31.266880680075083, 3.077026039951436],
            [31.26392057041546, 3.078410281094011],
            [31.26295074025158, 3.07843306268515],
            [31.26052468262161, 3.079403876278109],
            [31.254658022656287, 3.079053054212873],
            [31.25409991823488, 3.079344571715003],
            [31.25269428568225, 3.079001080065427],
            [31.252042410619925, 3.078365215755774],
            [31.248553877774228, 3.075679970649929],
            [31.247780123785702, 3.074411472351594],
            [31.246472596245255, 3.07338578599427],
            [31.244968127451813, 3.074187498403293],
            [31.24443283574706, 3.075356355817279],
            [31.242662073065738, 3.075913924541554],
            [31.24120384684818, 3.078080399616668],
            [31.239412841530267, 3.076200971253474],
            [31.238708273089998, 3.077101474859089],
            [31.238029550078753, 3.07702723837037],
            [31.237788228457454, 3.076344491889379],
            [31.237545024865636, 3.076807108703667],
            [31.235753226335316, 3.075415068568121],
            [31.234467835080117, 3.075680995048243],
            [31.229984534838245, 3.074528161498795],
            [31.2270752293995, 3.074523305020259],
            [31.226859126183182, 3.073255736456695],
            [31.225457034789414, 3.070792089534292],
            [31.22395688509585, 3.068986252086404],
            [31.222406355186237, 3.0683256893337],
            [31.216585907254057, 3.069461298598569],
            [31.212077067010306, 3.069136926584053],
            [31.210254674556374, 3.071595145840347],
            [31.21073740044394, 3.072887524462276],
            [31.20891544187627, 3.07507767540032],
            [31.208938017437696, 3.076076848676632],
            [31.208404242089106, 3.076319639032667],
            [31.206392725521756, 3.075877596083564],
            [31.205518150015664, 3.076948357105737],
            [31.203699363399245, 3.077237707086424],
            [31.202848290515913, 3.078747146656913],
            [31.200860042111074, 3.07888998880387],
            [31.19976996436156, 3.078352018811717],
            [31.197975998196448, 3.078300232107023],
            [31.197393323953726, 3.078786621758582],
            [31.196788621223583, 3.077957047798351],
            [31.196168432436274, 3.076855746939663],
            [31.192067553095658, 3.073617140816354],
            [31.18647115397849, 3.070056021632555],
            [31.183960242385133, 3.067812003737567],
            [31.173479677915356, 3.053747839661624],
            [31.17189338427763, 3.050641522223807],
            [31.170380917783227, 3.041520103905382],
            [31.170422299575087, 3.035856899293289],
            [31.171420448230005, 3.029075462987009],
            [31.171424316375603, 3.026771762397082],
            [31.168178080721617, 3.013228797619421],
            [31.166425199904317, 3.010768550694402],
            [31.16555986357091, 3.010511118752904],
            [31.16418378828611, 3.011056544129475],
            [31.16476687216061, 3.007810544865309],
            [31.166387395203902, 3.006532580600175],
            [31.167662076744318, 3.006153982776781],
            [31.16952449722901, 3.004357212558506],
            [31.170831418406618, 3.005293984083851],
            [31.17665313476, 3.003849994997796],
            [31.17930453657559, 3.003854442725447],
            [31.18047379273257, 3.004756365805622],
            [31.18126353313987, 3.006107631594762],
            [31.181952211281082, 3.00610878523857],
            [31.18729319331183, 3.00386780474701],
            [31.19008246137069, 3.003803227472332],
            [31.19108082023139, 3.003943347038183],
            [31.19176852998873, 3.004532932691568],
            [31.192664157513505, 3.00432673962732],
            [31.19332301967212, 3.001524087518566],
            [31.19439109857865, 3.001145104903964],
            [31.194666229193977, 3.001353248827457],
            [31.19435455870615, 3.002425771208137],
            [31.196282867921987, 3.002428971997371],
            [31.195871021805267, 3.001597547842519],
            [31.1961845086866, 2.999417371465626],
            [31.196977059024086, 2.999072541041775],
            [31.197252303725477, 2.999211456429322],
            [31.197113374775206, 2.999938124496837],
            [31.19869552448452, 3.001048402915329],
            [31.20003777280901, 3.001465997809397],
            [31.20127802641613, 3.001087292373398],
            [31.20417417153592, 2.998842146281926],
            [31.204416511846766, 2.998046415339835],
            [31.203867827159424, 2.996660935453184],
            [31.20414391987044, 2.996280631538059],
            [31.20389913973528, 2.995520049327064],
            [31.206103121250592, 2.995111615021861],
            [31.207280588009244, 2.995757405289457],
            [31.209201580447097, 2.996069615969585],
            [31.20958671695548, 2.995555166727379],
            [31.20940796479038, 2.995194313989908],
            [31.207666312914135, 2.994882399996459],
            [31.207667151940623, 2.994367319543052],
            [31.208205420662217, 2.994213679620352],
            [31.209511282726147, 2.994679400541686],
            [31.211151670215326, 2.994244274837471],
            [31.211098714529328, 2.995300108483213],
            [31.21173904624025, 2.995404176969087],
            [31.214382290454765, 2.992704320197064],
            [31.21550956923681, 2.992706165511498],
            [31.21822345516861, 2.993843792752476],
            [31.21924834127963, 2.993793957650968],
            [31.220274765306417, 2.992791216831349],
            [31.22009717286634, 2.991709246714082],
            [31.219406638805754, 2.990961245730299],
            [31.21989578854593, 2.989494048778814],
            [31.219719317203328, 2.987716714564707],
            [31.220796681096623, 2.986894331825888],
            [31.21936375323409, 2.985784562968544],
            [31.219827235411664, 2.984343077075208],
            [31.220749881565233, 2.984138544325461],
            [31.221905344091024, 2.982543655139192],
            [31.222982287572773, 2.981978810407503],
            [31.223240430147754, 2.980768774015325],
            [31.224522123937245, 2.980333030078195],
            [31.228182789262764, 2.982193277133432],
            [31.228957240343934, 2.978537403500026],
            [31.22821789272911, 2.976269818672347],
            [31.22955012034661, 2.976271971720896],
            [31.230342976111316, 2.977123146845298],
            [31.231522394010764, 2.976558453633961],
            [31.23160106127685, 2.975425383730224],
            [31.233959849465034, 2.974321742196743],
            [31.235346638057948, 2.972237857356116],
            [31.23337781122952, 2.96978801372301],
            [31.234428465514455, 2.969635175073566],
            [31.235184413097414, 2.968822799546521],
            [31.234302146215843, 2.9675953573293],
            [31.23485242900609, 2.966676720157741],
            [31.236164721210766, 2.965912559534978],
            [31.24073761672415, 2.966318342051171],
            [31.240830736086505, 2.96527636610733],
            [31.241288912814024, 2.96475603535109],
            [31.242600523197414, 2.964420971697227],
            [31.242571873228087, 2.963256196092516],
            [31.24062399331544, 2.961046231251906],
            [31.240688505827567, 2.958808829936115],
            [31.241816298445958, 2.959025184212345],
            [31.242241562698084, 2.960037337805484],
            [31.242790093773525, 2.96022211692655],
            [31.243979836010546, 2.959825552743328],
            [31.245594652056848, 2.960563744257063],
            [31.24675424323966, 2.959952571932124],
            [31.246391207982196, 2.958143594502941],
            [31.24937461455041, 2.95870801273681],
            [31.24937872434283, 2.959919078075288],
            [31.25062936786454, 2.958809231844882],
            [31.25063519523578, 2.957903369526563],
            [31.251210886873796, 2.957340158405175],
            [31.25220441818816, 2.957400355083767],
            [31.253746095200647, 2.958274695772198],
            [31.2560364955446, 2.957478326374352],
            [31.25752496534284, 2.955470881251088],
            [31.257785578284835, 2.952069475284676],
            [31.258150373341945, 2.951885841329522],
            [31.25924563167569, 2.952353263124194],
            [31.259731966994092, 2.952047317238781],
            [31.25999458317922, 2.950947292924916],
            [31.261170354816915, 2.950742554833403],
            [31.261372378737793, 2.949907342598112],
            [31.262506989569218, 2.949010182313292],
            [31.264596844619216, 2.95073939157328],
            [31.271979069368403, 2.953074679833186],
            [31.27554790082072, 2.953499050933321],
            [31.277864657735112, 2.954362471346515],
            [31.282289690552712, 2.953767689608669],
            [31.284378216994448, 2.95394902662125],
            [31.290716086445446, 2.955949161174923],
            [31.29711534676296, 2.958519490587127],
            [31.301636811929683, 2.958515183523696],
            [31.302629662321056, 2.957801402138915],
            [31.30409006785147, 2.958411005693419],
            [31.30611713695134, 2.957859164012827],
            [31.304254186460618, 2.960508626326034],
            [31.303729867677077, 2.963645618021213],
            [31.300098437124163, 2.972579896334391],
            [31.300092413920193, 2.977152230023006],
            [31.299438009202003, 2.982254715836181],
            [31.299663311166835, 2.984779982957678],
            [31.31317339991484, 2.980378151529004],
            [31.323035881248302, 2.978301460339127],
            [31.326949088153004, 2.978175483898429],
            [31.33952797249773, 2.975403505151403],
            [31.34582344506059, 2.975040890161462],
            [31.358689460614496, 2.975649334122753],
            [31.362401539218663, 2.968318151045856],
            [31.365062791061327, 2.964086530538652],
            [31.367323225404036, 2.957649471512407],
            [31.369230955115036, 2.955563508035728],
            [31.371656356974817, 2.954696760237514],
            [31.37772587809088, 2.948381288974526],
            [31.37377807257301, 2.942896275686786],
            [31.369821836366203, 2.934455134897711],
            [31.368137017304758, 2.932501586064574],
            [31.369160078937444, 2.931614550353858],
            [31.369341501793883, 2.93053488353373],
            [31.370354826587196, 2.930065386478264],
            [31.37088242511987, 2.930492568106251],
            [31.371084354717645, 2.929657287778254],
            [31.372057079253377, 2.92912672999903],
            [31.372807338703947, 2.929187056492923],
            [31.372564534862438, 2.929696494643085],
            [31.373294852612005, 2.93008272462298],
            [31.37402448045544, 2.929776461319896],
            [31.37400484597828, 2.930428235052817],
            [31.37465311250813, 2.929857279377867],
            [31.374795506260444, 2.930325587809214],
            [31.375789160643983, 2.930467132377157],
            [31.376092571122765, 2.929733588739116],
            [31.378068208079352, 2.928458562926711],
            [31.382240399280477, 2.923790043311308],
            [31.383800798980133, 2.922953334216057],
            [31.386851653754782, 2.922288187747291],
            [31.391270118091047, 2.920613396748181],
            [31.39520858562153, 2.918014745828028],
            [31.397546182552183, 2.92126871774804],
            [31.398399715022766, 2.92318238020132],
            [31.399214521121444, 2.926908820512919],
            [31.398985216263686, 2.930728030692741],
            [31.397443652438902, 2.940231212425309],
            [31.39814875627511, 2.945780685840069],
            [31.399103400419122, 2.947429479870184],
            [31.4001390294826, 2.948955978876778],
            [31.401559542627915, 2.950115452238315],
            [31.403061113456253, 2.951213740543666],
            [31.404846041671274, 2.951802527276226],
            [31.412397978838868, 2.950704889967805],
            [31.414263485036596, 2.950764015839774],
            [31.416149567145876, 2.951108263889767],
            [31.417673956979055, 2.95229128],
            [31.417843381936592, 2.953429872056794],
            [31.417422760177825, 2.955942984503308],
            [31.415181667461525, 2.963952456025803],
            [31.414539408864293, 2.965091032517114],
            [31.41130356042991, 2.968676693572175],
            [31.403762803694352, 2.970148919653302],
            [31.402075244771265, 2.972362148811749],
            [31.401043059848558, 2.979550308926622],
            [31.401755310681168, 2.982517650048824],
            [31.402739071020136, 2.984345895753932],
            [31.40530936664369, 2.986738364688875],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 587,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "RHINO CAMP",
        Population: 23804,
        Key: "ARUARHINO CAMP",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.396300327050938, 3.177419682714615],
            [31.395290637739578, 3.177725477168085],
            [31.394885963772083, 3.17841133548156],
            [31.392215055040097, 3.178968831479509],
            [31.389450037002312, 3.180150251145316],
            [31.388643010313995, 3.180024169417973],
            [31.388299699365234, 3.181178179456926],
            [31.386560731655084, 3.18139387520069],
            [31.38457178256431, 3.18263890503848],
            [31.383544164676483, 3.184603135373289],
            [31.38487772539388, 3.185541358451527],
            [31.386054105191047, 3.187727491566452],
            [31.385709908503408, 3.189443170144455],
            [31.384280373577717, 3.190314626342994],
            [31.384155257123247, 3.190907303962646],
            [31.385021944522855, 3.192593688276368],
            [31.38319103783663, 3.192029122945496],
            [31.38173118297344, 3.192432464906943],
            [31.38101783170465, 3.191963277240452],
            [31.37924672407028, 3.192865384468847],
            [31.37797540851726, 3.191833640665372],
            [31.377571844867415, 3.19180179545863],
            [31.377073718262615, 3.192674713432173],
            [31.37530521125097, 3.191923012634136],
            [31.374713450549145, 3.193107817657609],
            [31.37365730845611, 3.19344938111914],
            [31.37387724208881, 3.191795927796439],
            [31.37248086218362, 3.191325650078778],
            [31.37217339131973, 3.189421729180265],
            [31.37220507579812, 3.189016129376018],
            [31.373694643337643, 3.189455351266829],
            [31.373979659014363, 3.185898566832105],
            [31.372210625589954, 3.18549010982252],
            [31.370754664923542, 3.183428345529661],
            [31.369359378268054, 3.182271589816311],
            [31.369085653516148, 3.178651518081227],
            [31.369462232673122, 3.176093408446159],
            [31.368873428326907, 3.175405991511655],
            [31.368936696672346, 3.174657201228362],
            [31.369806194002148, 3.174533764793547],
            [31.367544213658867, 3.169378417538445],
            [31.365839034281507, 3.166979214357898],
            [31.364334745151115, 3.162231086757747],
            [31.362459718608015, 3.160638206408192],
            [31.362363014069377, 3.159082467217927],
            [31.360761188560403, 3.15935141500402],
            [31.359334874993298, 3.161784720758585],
            [31.357745868443406, 3.162817787997416],
            [31.35469934803999, 3.161591242811667],
            [31.353290032394728, 3.16213196957401],
            [31.349696249337068, 3.160440864191155],
            [31.35107008152861, 3.156220190302142],
            [31.347860054268768, 3.153686957024202],
            [31.347630334389347, 3.151673465471106],
            [31.347681570699898, 3.148724085094362],
            [31.348056054985673, 3.147554259594504],
            [31.34973660884613, 3.145216090921233],
            [31.349458679080385, 3.144232493439889],
            [31.347365847013535, 3.142169222701273],
            [31.345328963819174, 3.134160303127857],
            [31.345846482356055, 3.130883947668615],
            [31.34441048045862, 3.125825453507721],
            [31.339906489320768, 3.116829497441974],
            [31.33841922506167, 3.11476720428596],
            [31.338699207477855, 3.114439930913631],
            [31.345267662784178, 3.11384170490711],
            [31.349137864641303, 3.105575646266832],
            [31.34763645640804, 3.103736616247665],
            [31.34540994065383, 3.102184622714671],
            [31.34388531366542, 3.102462269850655],
            [31.342165560919184, 3.101751209800432],
            [31.341658630824593, 3.101025585582065],
            [31.340315034128857, 3.100825788706235],
            [31.339268115038852, 3.099555695071496],
            [31.336843592629734, 3.09887646496729],
            [31.336049994856594, 3.097618976366906],
            [31.335465422473675, 3.097418590413949],
            [31.334060621760987, 3.09746679535089],
            [31.33233059588118, 3.096959794838559],
            [31.328918389291896, 3.097433439400526],
            [31.326787579149755, 3.096572811385581],
            [31.324505000437004, 3.096518757943829],
            [31.32340074278073, 3.096869985067414],
            [31.32242329490323, 3.096338953536373],
            [31.318740908314165, 3.093181453999882],
            [31.31799089320537, 3.091591837042575],
            [31.317668421374574, 3.089296935899847],
            [31.313320748774277, 3.085653096390718],
            [31.31231458624872, 3.083562482009495],
            [31.3117840106992, 3.080600377627948],
            [31.30484480270881, 3.080529577855964],
            [31.30364968046154, 3.078287592210994],
            [31.3017402798841, 3.076079521799088],
            [31.298121231709075, 3.07438151090734],
            [31.293735334895153, 3.073759116229483],
            [31.28886391843306, 3.073725636642989],
            [31.28677099473804, 3.074670918994002],
            [31.2831175042567, 3.078587847783186],
            [31.277929394826074, 3.087215374152436],
            [31.27527102298217, 3.08883590773979],
            [31.266546662197925, 3.092883778753855],
            [31.261232907205102, 3.09426776961058],
            [31.253720046752377, 3.098839749789858],
            [31.249909351096324, 3.099007514217277],
            [31.245949668053758, 3.096812336451018],
            [31.245867173066273, 3.087706734551648],
            [31.246405968200637, 3.086686473573728],
            [31.247302344022053, 3.086143368539278],
            [31.251848198448744, 3.07939576274884],
            [31.252042410619925, 3.078365215755774],
            [31.25269428568225, 3.079001080065427],
            [31.25409991823488, 3.079344571715003],
            [31.254658022656287, 3.079053054212873],
            [31.26052468262161, 3.079403876278109],
            [31.26295074025158, 3.07843306268515],
            [31.26392057041546, 3.078410281094011],
            [31.266880680075083, 3.077026039951436],
            [31.27146322259629, 3.076862928484183],
            [31.272142745108116, 3.076449746502993],
            [31.2748581518877, 3.076154281316984],
            [31.275454435606978, 3.075529720469885],
            [31.276805919510934, 3.075294284614267],
            [31.277366617368532, 3.074249123850537],
            [31.27886796900794, 3.074015336439939],
            [31.279173022505383, 3.073518064618401],
            [31.27882865873113, 3.073013639699507],
            [31.279140100148528, 3.071915678740643],
            [31.27864851777055, 3.07115931642084],
            [31.279504692186393, 3.070517926243675],
            [31.279269279683035, 3.069163620306958],
            [31.27758088173349, 3.068193841536708],
            [31.277740867194023, 3.067244407387459],
            [31.27729711291837, 3.066688826437454],
            [31.2781001313239, 3.06634721627008],
            [31.278616721002752, 3.064750886256518],
            [31.27891698647973, 3.064704127645221],
            [31.278666437363842, 3.062423497805748],
            [31.27943651005633, 3.06047949761473],
            [31.280238993065925, 3.060187942671809],
            [31.279998252654618, 3.059334221340662],
            [31.280708265783822, 3.058340769860405],
            [31.28051907968667, 3.057337423145344],
            [31.281375769735483, 3.056645955655809],
            [31.281282238046433, 3.056044168177227],
            [31.28188914703888, 3.055349954917052],
            [31.28334476904045, 3.054715135947111],
            [31.283350078083764, 3.05421456302468],
            [31.285415788215584, 3.052585176937134],
            [31.285783545916484, 3.050887058811793],
            [31.28673854040347, 3.050346853665241],
            [31.286650319554354, 3.049244491905368],
            [31.28700585028593, 3.048697697146381],
            [31.29020511393205, 3.048532583646895],
            [31.2928633663, 3.047560503239966],
            [31.293367166664144, 3.047165528045449],
            [31.29373065557084, 3.045867864413645],
            [31.29448635701539, 3.045275401981579],
            [31.297139829447726, 3.044753820305716],
            [31.299358032192252, 3.042875742756579],
            [31.30480019327012, 3.040857787563166],
            [31.305533497918, 3.037661733019176],
            [31.30628070848649, 3.037870183016661],
            [31.308556393527756, 3.039997810099897],
            [31.309414646645152, 3.039156130911674],
            [31.311610041164645, 3.039430512121605],
            [31.313920177495362, 3.038304348461315],
            [31.3148635082567, 3.038865388299316],
            [31.318905676405276, 3.039310179818224],
            [31.32472171360941, 3.03737127706133],
            [31.32823427279571, 3.037498753712658],
            [31.32922885244399, 3.036369249201777],
            [31.32848283663484, 3.033682636856543],
            [31.328890937675126, 3.032886070232139],
            [31.32994529661232, 3.032396956945985],
            [31.33021463938228, 3.030547516246231],
            [31.33293762165465, 3.028174184434092],
            [31.339320759009457, 3.019833080508687],
            [31.353269699028257, 3.009421611898195],
            [31.37010318422161, 3.000242784125137],
            [31.3769260307383, 2.99756341528018],
            [31.37661973756577, 2.997162402436982],
            [31.39165039291711, 2.990673320561564],
            [31.40530936664369, 2.986738364688875],
            [31.411321531227177, 2.991014523100853],
            [31.41850774358137, 2.994606260910879],
            [31.42190545944681, 2.997215770111666],
            [31.42632959754237, 2.999392664856951],
            [31.43011567037649, 3.002328301430429],
            [31.43351982895914, 3.007162570158637],
            [31.434714291842983, 3.009723673638079],
            [31.435282618193995, 3.01686905216737],
            [31.436147132568927, 3.017801808413961],
            [31.440077717382813, 3.019996077724133],
            [31.44286996156022, 3.02206208639058],
            [31.450200568214864, 3.030130666313415],
            [31.454666682787032, 3.033781746332142],
            [31.45735519131205, 3.034708076769103],
            [31.460656669762777, 3.035165000877199],
            [31.465371117307054, 3.035017995954375],
            [31.474930560962594, 3.033467001525146],
            [31.47622766714742, 3.033685894068254],
            [31.477667874956992, 3.034501886741762],
            [31.47850675410866, 3.035515993383064],
            [31.47864163614857, 3.036963212812045],
            [31.477777262809152, 3.041899969473155],
            [31.47416212500056, 3.050522719733118],
            [31.476094447889096, 3.063195994936304],
            [31.476919681631582, 3.065512417311846],
            [31.47754456860784, 3.066960338196748],
            [31.48345016694749, 3.071743972996349],
            [31.486479269017558, 3.075067424235157],
            [31.490639229656075, 3.081919634284891],
            [31.49630657412115, 3.089488475284738],
            [31.501990453875624, 3.098142630308899],
            [31.504075423887148, 3.102568120172737],
            [31.505566466460333, 3.10909098306888],
            [31.506877421073575, 3.112927518447024],
            [31.50850959706275, 3.115869154612554],
            [31.511642249732265, 3.119711028363109],
            [31.50099834100111, 3.123305681058185],
            [31.495020474095163, 3.124403586921903],
            [31.492463092652155, 3.124062973967841],
            [31.48952247194263, 3.124531806614294],
            [31.4882213978992, 3.12351634866645],
            [31.487592272671435, 3.123947630371467],
            [31.48548386202092, 3.122485327105514],
            [31.484733103107033, 3.12260236346666],
            [31.48436688691518, 3.121784790506471],
            [31.482835879193285, 3.124834877232213],
            [31.482503962475572, 3.126708835496408],
            [31.48200432310783, 3.126703420440177],
            [31.481449431061872, 3.126008964583189],
            [31.480109933378788, 3.127471453098592],
            [31.47806508751776, 3.127098800201425],
            [31.47495684476947, 3.128066465550565],
            [31.47501362997353, 3.127416198394941],
            [31.475870878774433, 3.126674465989483],
            [31.47478846365433, 3.125060559969121],
            [31.470556378179953, 3.128369195193109],
            [31.469903177204248, 3.128712583787529],
            [31.469156344826505, 3.128454144254532],
            [31.46840006396859, 3.129096816070855],
            [31.467600121394586, 3.129138198953235],
            [31.466992681497786, 3.129882622335426],
            [31.465689956350857, 3.130218953931587],
            [31.46400327148857, 3.129049092463492],
            [31.462603244423303, 3.129134021736311],
            [31.460763514484384, 3.128262896286093],
            [31.460376413360446, 3.127057067417265],
            [31.459333489078542, 3.126444934666098],
            [31.45874338217514, 3.125537307112787],
            [31.457198196343118, 3.125170056035014],
            [31.45606746443713, 3.125783610344479],
            [31.454143582118988, 3.123409543370553],
            [31.449243538145456, 3.123706769587036],
            [31.44874705905083, 3.123400966439828],
            [31.44625873200203, 3.127722209367637],
            [31.44565201165577, 3.127873372429701],
            [31.44490835122928, 3.127314547528702],
            [31.444455003844762, 3.127660088316807],
            [31.44429460426086, 3.12865969088801],
            [31.441828541058054, 3.130335143582532],
            [31.441025970911877, 3.130626817357164],
            [31.43892563162418, 3.129613995242996],
            [31.43828222228507, 3.13019643357985],
            [31.435982874720892, 3.130271536399062],
            [31.432968251696614, 3.131840863778707],
            [31.432508057352944, 3.132837189307432],
            [31.43190638553857, 3.13303090042447],
            [31.430214505719007, 3.132361608858394],
            [31.429858433303316, 3.132958544333479],
            [31.428771917373926, 3.133293019105938],
            [31.42849522728324, 3.134295499167963],
            [31.427435459589752, 3.135285284340766],
            [31.42814275351858, 3.139298343127884],
            [31.427758767752078, 3.142548488033817],
            [31.428388785006927, 3.144407835336654],
            [31.427188091408254, 3.144544952241677],
            [31.426681603284774, 3.14519030595038],
            [31.426495602613628, 3.147186912202024],
            [31.423564185144198, 3.148532652474338],
            [31.42342126587742, 3.149386557359938],
            [31.423816079936365, 3.15055445862159],
            [31.42347405896837, 3.151949005112762],
            [31.420582941719193, 3.153140369643857],
            [31.419419484187408, 3.154505186711947],
            [31.41964325452469, 3.156384594534813],
            [31.42006716501569, 3.157040068387159],
            [31.419924455056364, 3.157751619224615],
            [31.4193855997349, 3.158177853997337],
            [31.418904606697463, 3.157806999689153],
            [31.415726095931053, 3.161702610561799],
            [31.413515699546302, 3.162297099397788],
            [31.412861148402754, 3.164289034687338],
            [31.412350832557838, 3.164572955627495],
            [31.410873842330606, 3.167189973600013],
            [31.409825923415703, 3.167074475118905],
            [31.408578715949957, 3.167613489447194],
            [31.40787215684302, 3.166558989137793],
            [31.406852740573754, 3.166329649574257],
            [31.40634216152246, 3.166784388377668],
            [31.406508372307915, 3.169233109454638],
            [31.40372444293677, 3.173130515189164],
            [31.40130659860347, 3.174302847492108],
            [31.398707635044282, 3.176545048529923],
            [31.39783827156345, 3.176574897631066],
            [31.397402794364854, 3.177104690106623],
            [31.396300327050938, 3.177419682714615],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 588,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "RIGBO",
        Population: 25945,
        Key: "ARUARIGBO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.096437848682367, 2.838087531251077],
            [31.09023008403058, 2.833392724940575],
            [31.08705410741158, 2.831608990492162],
            [31.081532772417834, 2.829701453997761],
            [31.077253213675654, 2.829036903626151],
            [31.070395366998845, 2.830021242882788],
            [31.063323894659288, 2.832056254712001],
            [31.05790267600566, 2.834129749966174],
            [31.049470471606323, 2.838334651622342],
            [31.04508623218408, 2.838829727511555],
            [31.04261438023758, 2.838441598540527],
            [31.03952338873602, 2.837447160226514],
            [31.036475835270036, 2.835050402312751],
            [31.02978358133775, 2.826911794633697],
            [31.02478147796815, 2.824346173515006],
            [31.01974056109006, 2.823180696779991],
            [31.018299023773846, 2.820560161614695],
            [31.016189523466885, 2.812866611033757],
            [31.016239520102342, 2.808250733199386],
            [31.012678342296233, 2.808086904085368],
            [31.010155281886963, 2.806694790400381],
            [31.00893502208311, 2.805342339290099],
            [31.008494222366444, 2.803331191318041],
            [31.006533943007973, 2.801412308644193],
            [31.006183849778825, 2.800582141713361],
            [31.006090123155335, 2.798482403360417],
            [31.006737427589492, 2.797255356972603],
            [31.009184774393372, 2.79543202377715],
            [31.00944257920181, 2.794599949550733],
            [31.009129860380035, 2.791932136140528],
            [31.007228179025827, 2.788022418310724],
            [31.00829860702683, 2.783425232974804],
            [31.00998582908165, 2.781538642361585],
            [31.010933493315918, 2.778816269332102],
            [31.014711617856378, 2.77237844012741],
            [31.014948216135945, 2.761850127897174],
            [31.014234018654122, 2.751051392548549],
            [31.017623704479238, 2.750288663943109],
            [31.01917803156758, 2.750416977747424],
            [31.02336765727171, 2.748990291992552],
            [31.028123677050697, 2.74866845142031],
            [31.03452079488627, 2.747579880341006],
            [31.046655913277245, 2.747380072539459],
            [31.05276375921828, 2.751381867000725],
            [31.055786314366564, 2.746648533846953],
            [31.058060085996285, 2.744097197605762],
            [31.06150867884613, 2.73819402441557],
            [31.071078932827778, 2.725400797215836],
            [31.071428612831927, 2.727412740423643],
            [31.07484459414201, 2.729038803360483],
            [31.07650843574497, 2.730884976887099],
            [31.077951910727226, 2.731557662684664],
            [31.081451982432775, 2.731675018942151],
            [31.08318974640045, 2.727717753406025],
            [31.08385768423838, 2.7278072112681],
            [31.088650794557125, 2.731933705332554],
            [31.091443204922864, 2.733829650836392],
            [31.09488604945322, 2.735779669511726],
            [31.096098988885824, 2.735887672888474],
            [31.097908158138818, 2.73696888426355],
            [31.099330180453784, 2.738279284873546],
            [31.099149090872302, 2.741620035540592],
            [31.100394659810945, 2.74333673828033],
            [31.099998002409052, 2.745311323473611],
            [31.100240537654297, 2.746225722220409],
            [31.099534516638183, 2.748798887470037],
            [31.10071701575908, 2.750463972810514],
            [31.10098284072637, 2.751736759924948],
            [31.102646877263737, 2.754015153094416],
            [31.10278105053288, 2.755024853037064],
            [31.10404760501491, 2.755767368356596],
            [31.106628612149883, 2.758525898873684],
            [31.108023692192873, 2.758609205410411],
            [31.109858971877898, 2.759964739333177],
            [31.110276844791876, 2.759474788550718],
            [31.11076794387622, 2.759692788337968],
            [31.110879141833664, 2.760351214604628],
            [31.112845971707202, 2.761936903950833],
            [31.113771090922782, 2.761604501500416],
            [31.114971235650792, 2.762039788716973],
            [31.115566838447112, 2.760939866802353],
            [31.116002528546414, 2.760883553977253],
            [31.11703995873207, 2.761538967441756],
            [31.117260507710725, 2.76230683917535],
            [31.12173317459459, 2.763354565588312],
            [31.12091458030038, 2.764058377340159],
            [31.12074646688314, 2.765844737717782],
            [31.121102451263955, 2.767216437528632],
            [31.119626311741307, 2.768626765776608],
            [31.11988663362918, 2.769513570027914],
            [31.119238864765986, 2.769734133253885],
            [31.118358936199126, 2.768680141480365],
            [31.11860585432464, 2.769331477048946],
            [31.117736855559798, 2.770077978945988],
            [31.117375925953365, 2.771836326631959],
            [31.1162322592056, 2.772056093551913],
            [31.116038709991113, 2.77249897675504],
            [31.117043245667688, 2.773151526014239],
            [31.114949329334276, 2.773231270285909],
            [31.11385981662507, 2.774046659753377],
            [31.113319339844498, 2.775101229967374],
            [31.11271226556202, 2.774893555115524],
            [31.112515236274106, 2.775391198029066],
            [31.113727922381795, 2.776727298731347],
            [31.121511762334926, 2.782442597847096],
            [31.129949180556213, 2.79120688776419],
            [31.130199350583055, 2.792538931119302],
            [31.12918681810381, 2.794693301811507],
            [31.126091060141356, 2.798049141209529],
            [31.12585028918731, 2.799401726360788],
            [31.129055817684225, 2.805491837196653],
            [31.127059350592845, 2.804304165436045],
            [31.12406407278819, 2.804299340081904],
            [31.119325508173468, 2.807600588279517],
            [31.11832565451616, 2.808491257155115],
            [31.117435182422764, 2.810348745681237],
            [31.1168020659802, 2.813136114655857],
            [31.11568917461576, 2.815327843110853],
            [31.109836729591464, 2.821378399166524],
            [31.10853885534706, 2.823606981753672],
            [31.1085731242785, 2.825280067676772],
            [31.11052801554192, 2.828369082503166],
            [31.11137871742105, 2.828258940547462],
            [31.112671906052928, 2.828930271660684],
            [31.113411611197233, 2.828857123958834],
            [31.113971071176394, 2.829415873338486],
            [31.112099828337264, 2.83181399771743],
            [31.110931810058783, 2.832575932306703],
            [31.109613742585093, 2.832222123415245],
            [31.11007176929396, 2.831673079703168],
            [31.109777576428293, 2.831210690918446],
            [31.107186200938326, 2.831387481585401],
            [31.10676998182277, 2.83193638726128],
            [31.105845753735977, 2.830591467135743],
            [31.10396450815617, 2.830597493757513],
            [31.100492144985598, 2.82985042928596],
            [31.09794328945293, 2.830237666610395],
            [31.097237097756945, 2.831587800883296],
            [31.097617282751493, 2.832765972874511],
            [31.097542096457165, 2.835293471507364],
            [31.097961133587745, 2.835586985690141],
            [31.097043944699507, 2.8363480896663],
            [31.096437848682367, 2.838087531251077],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 589,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "ULEPPI",
        Population: 8798,
        Key: "ARUAULEPPI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.117253350832847, 3.200640237943965],
            [31.11382400438795, 3.199998238334083],
            [31.11153272189841, 3.200892713833167],
            [31.109999424370884, 3.203489072444171],
            [31.107843625792487, 3.205276365351427],
            [31.10432924033122, 3.209838719175357],
            [31.102136749166714, 3.211379335200086],
            [31.098996655751737, 3.215309162771952],
            [31.097204643422376, 3.216295351768333],
            [31.093255757231194, 3.22007589343087],
            [31.092359501784046, 3.219959980253219],
            [31.09188163308719, 3.21938725301128],
            [31.08667720665772, 3.219993828251402],
            [31.079165986528658, 3.22217966714828],
            [31.07104498639153, 3.223457934723712],
            [31.064491535645388, 3.225768897861729],
            [31.057457420645225, 3.225212373560618],
            [31.053444913070667, 3.225611446673044],
            [31.050487102199888, 3.227469495068922],
            [31.047199003257, 3.231978429616026],
            [31.045173639159554, 3.231532790846406],
            [31.040179761662973, 3.231658752320635],
            [31.036563781234673, 3.234320120358082],
            [31.034209111822047, 3.238686712839114],
            [31.030330065152636, 3.243564150896318],
            [31.027133013158736, 3.24907503480372],
            [31.025776764590542, 3.252249833201375],
            [31.02137021460992, 3.24901784849306],
            [31.020154160718246, 3.247694913027407],
            [31.018740233122287, 3.247355872726504],
            [31.017157346794416, 3.246091585261502],
            [31.014935441194282, 3.246521779737961],
            [31.014602922605317, 3.245691472664044],
            [31.013798018636045, 3.245196045443922],
            [31.014035389466713, 3.244426126596906],
            [31.012936738196128, 3.243377019451105],
            [31.01016571851394, 3.243013127042099],
            [31.00997189082172, 3.241790881569925],
            [31.01040558037289, 3.241139873651618],
            [31.009993903139428, 3.240585963217468],
            [31.011340051050553, 3.238566260879151],
            [31.01057192860057, 3.236270038446123],
            [31.010890854780953, 3.232432935702517],
            [31.010563666794898, 3.231160018586968],
            [31.010169408793118, 3.23047009505293],
            [31.009286776297223, 3.23001776035065],
            [31.008389330582297, 3.230400324354457],
            [31.007717326071074, 3.23013394324196],
            [31.005552816529388, 3.231097127061128],
            [31.00489343155126, 3.231122331386345],
            [31.00385300368752, 3.230444383073034],
            [31.00294592354116, 3.229011292537617],
            [31.0026994204373, 3.226943373610827],
            [31.001752084986467, 3.225868029530938],
            [31.00176962189744, 3.223641600659057],
            [31.000596133777165, 3.219688624903848],
            [31.000200681016043, 3.219053540686579],
            [30.99829155801805, 3.217836450442202],
            [30.996334905158356, 3.215203722168249],
            [30.99604749996299, 3.212342334063247],
            [30.996689022840002, 3.20774410613494],
            [30.998276716951235, 3.204779759630275],
            [30.998151688531678, 3.20226484844545],
            [31.0013995528313, 3.198262324130023],
            [31.002252178901752, 3.197926674743472],
            [31.003295796683084, 3.194749755116584],
            [31.004186482575484, 3.194131184744724],
            [31.004803291002418, 3.194333078665404],
            [31.00587947989931, 3.193743449859712],
            [31.005906454510654, 3.192472468489222],
            [31.004329384774255, 3.192386128162132],
            [31.00337861236913, 3.191532231865366],
            [31.004486736374368, 3.186779798940902],
            [31.003537263831447, 3.185252691353149],
            [31.003455787533504, 3.184084921612903],
            [31.002797732062014, 3.18297372706667],
            [31.003386773563495, 3.182568931061499],
            [31.00396168995541, 3.179605608827152],
            [31.00197643922866, 3.17598721128416],
            [31.003093819474593, 3.173467010400608],
            [31.00521198493082, 3.172293631318934],
            [31.007234228280943, 3.171809977618496],
            [31.00840830030617, 3.170918364993644],
            [31.00800956420269, 3.168032779625293],
            [31.00685395525151, 3.165884397551113],
            [31.00882815041209, 3.16447520920042],
            [31.008702538985887, 3.16196640560126],
            [31.006014805706954, 3.158464491679909],
            [31.00531151556933, 3.155340038993453],
            [31.00941647775291, 3.15046737928912],
            [31.01015905211621, 3.150303019865902],
            [31.00873848507201, 3.14488461761435],
            [31.006390293410888, 3.14040887137572],
            [31.01101674827814, 3.136516703247819],
            [31.01190536175718, 3.13346853954213],
            [31.0134200506836, 3.131593112460588],
            [31.020279338258117, 3.137257436633862],
            [31.025535027947587, 3.139353101181361],
            [31.027747090707187, 3.141416700393957],
            [31.035393682457947, 3.142313198092078],
            [31.037018052087312, 3.143991973685593],
            [31.040231664523475, 3.144915695567845],
            [31.04316466033287, 3.147315101295375],
            [31.045068338641926, 3.148236343727579],
            [31.046446214150603, 3.150056272139688],
            [31.048207045956445, 3.149705635065397],
            [31.049375993991262, 3.154089206210453],
            [31.056386908202587, 3.155177830337842],
            [31.0566477960291, 3.153532780342482],
            [31.058506350164794, 3.152357181159331],
            [31.059073042480314, 3.152643297522049],
            [31.05968729969182, 3.152422210466262],
            [31.062851307158, 3.158611931531046],
            [31.06370357749559, 3.15770163212576],
            [31.067529559782823, 3.162891787015227],
            [31.0688391516518, 3.160510821726608],
            [31.071934324811018, 3.159600715933684],
            [31.073255743000686, 3.158253449021706],
            [31.0739270171816, 3.158351110824711],
            [31.07460029280894, 3.157364168467736],
            [31.075103882967323, 3.157365105782221],
            [31.07519767247288, 3.158522194311717],
            [31.07691978060178, 3.160959746371208],
            [31.07686703961312, 3.162472497447447],
            [31.082587251729276, 3.163234967807163],
            [31.08310194955617, 3.163598414089892],
            [31.08513260113736, 3.167796025363437],
            [31.084147611004763, 3.168758293684694],
            [31.083188111466633, 3.168901124482242],
            [31.08366683985121, 3.169384064680699],
            [31.097031874935343, 3.178326847039838],
            [31.10438090783307, 3.185571275458679],
            [31.10668212119809, 3.186129895917057],
            [31.108024824968446, 3.186276994578026],
            [31.108721040873206, 3.1858685305432],
            [31.10958354122524, 3.186328077236479],
            [31.11025574875574, 3.186231514120782],
            [31.11017915839461, 3.196120670966081],
            [31.11091032505214, 3.197082941539274],
            [31.117253350832847, 3.200640237943965],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 590,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "AII-VU",
        Population: 40304,
        Key: "ARUAAII-VU",
        Dist2: "Koboko",
        "Sub Country": "Aiivu",
        id2_original: "Koboko Aiivu",
        drought: "N",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.196788621223583, 3.077957047798351],
            [31.194466753793535, 3.078270364959089],
            [31.192554367216115, 3.078026352410091],
            [31.193042460537537, 3.079035271718907],
            [31.19277340702511, 3.079527133742003],
            [31.190557552476694, 3.079593683509343],
            [31.19088604301991, 3.078433774918242],
            [31.188763132662373, 3.078711474913238],
            [31.188024058135397, 3.081300751344789],
            [31.187312710109705, 3.081287814571876],
            [31.185810928177283, 3.07976139626014],
            [31.185388104647764, 3.081530675501507],
            [31.182520473851703, 3.080845891193515],
            [31.181002896841644, 3.081757590119341],
            [31.17990725582557, 3.081427497086044],
            [31.178952533528143, 3.080523272721982],
            [31.17843830013028, 3.081178811803683],
            [31.178716624256424, 3.082093593487943],
            [31.176625383105936, 3.08431714196316],
            [31.17651516431216, 3.085926038540538],
            [31.17096655107652, 3.087477318541867],
            [31.170620367315475, 3.08812088541829],
            [31.16948793220369, 3.087301329385674],
            [31.16832664500159, 3.088934505302528],
            [31.165666766682993, 3.087666337653507],
            [31.163892071177383, 3.087663255523045],
            [31.162242751739296, 3.086421615493561],
            [31.161699803693384, 3.086817079412319],
            [31.15915701089057, 3.087211608497872],
            [31.15821208921291, 3.087756808404186],
            [31.15652733662678, 3.090409709177659],
            [31.15571709576635, 3.090682873460151],
            [31.155311349210425, 3.090411761533978],
            [31.153625634528602, 3.092453101492398],
            [31.153425603071025, 3.094152189534626],
            [31.152076183495637, 3.095241659813269],
            [31.150117707954234, 3.095652646694546],
            [31.149578428627937, 3.096401008261224],
            [31.14775516390982, 3.096879711275294],
            [31.144645425466596, 3.095457989537969],
            [31.144240196340267, 3.095526609490721],
            [31.143566320638296, 3.096614936470497],
            [31.140322838320614, 3.096076758380084],
            [31.13667550399395, 3.096490550765016],
            [31.13431003952654, 3.095815000897017],
            [31.13160327454, 3.092829743064081],
            [31.130185670139593, 3.093511588230899],
            [31.12984883065412, 3.094123687177941],
            [31.127349006966305, 3.093924001125475],
            [31.125459249849197, 3.095082265639195],
            [31.123296063525903, 3.094134566063382],
            [31.120523240924935, 3.092100692443258],
            [31.117754459844416, 3.092716802722734],
            [31.11654116737392, 3.094485465673356],
            [31.115815484032908, 3.094877492851442],
            [31.11473210412215, 3.094765018273952],
            [31.11448072136966, 3.094311552453432],
            [31.1116711406056, 3.093105827376823],
            [31.109365614428917, 3.093664360942094],
            [31.10445130251369, 3.093168109233683],
            [31.102990827812995, 3.093631590617019],
            [31.09981379567351, 3.093352207251734],
            [31.0917876477489, 3.090642033552952],
            [31.090047526601907, 3.083710662540702],
            [31.08869041385441, 3.081443496271399],
            [31.08758595856878, 3.080487113957445],
            [31.086633058953066, 3.080286952613535],
            [31.08467606114032, 3.080416362616915],
            [31.083769643950646, 3.081204702395306],
            [31.081291977209304, 3.08165505040144],
            [31.078078431248493, 3.080763492110974],
            [31.076696814256668, 3.080928554889689],
            [31.073792413619415, 3.080300876117716],
            [31.07109908114131, 3.081492899450651],
            [31.06762190389908, 3.081534437588164],
            [31.065548514968246, 3.082320621009698],
            [31.06307994277085, 3.083946737900937],
            [31.06256422894938, 3.086360756799353],
            [31.060770485566472, 3.090522748435632],
            [31.060480777090717, 3.092676671529335],
            [31.062737317236646, 3.095960381064741],
            [31.064871741301175, 3.100919559293563],
            [31.06805691397376, 3.104324676935178],
            [31.07012809574396, 3.104783314135333],
            [31.071279006506188, 3.106031171245898],
            [31.07073052483812, 3.108099685104196],
            [31.07153518177069, 3.109762586654955],
            [31.07184498645768, 3.113550589780988],
            [31.07339936834325, 3.116212752703519],
            [31.072638248260905, 3.117251196697694],
            [31.06972800498103, 3.117907566957706],
            [31.06776874161714, 3.117626947689599],
            [31.067015424301317, 3.119318360094657],
            [31.06649440952137, 3.119563622489264],
            [31.063494726378547, 3.118896345032128],
            [31.061460610893608, 3.11769222941454],
            [31.061031743498855, 3.117783769493123],
            [31.060993937900147, 3.118568408278217],
            [31.060540363241824, 3.118567700557064],
            [31.060251042838242, 3.117705377431001],
            [31.059377631548763, 3.118088485334713],
            [31.059466057213747, 3.120228444478879],
            [31.059189551277733, 3.120458048919876],
            [31.05424390882037, 3.120618138011004],
            [31.052346640889162, 3.119937491679912],
            [31.048919868117544, 3.123450624194758],
            [31.048196064052096, 3.125217220103837],
            [31.047895312586554, 3.127410619195492],
            [31.048864870560916, 3.130266712467718],
            [31.052459166556584, 3.134810470120577],
            [31.05294150437197, 3.137557927475519],
            [31.052047771394143, 3.136864876295048],
            [31.050951927358824, 3.136625162116407],
            [31.049466270185732, 3.137940314138633],
            [31.048392846303273, 3.1372037135728],
            [31.048027177185418, 3.137332660037127],
            [31.04682136498629, 3.138432276068178],
            [31.046023087888834, 3.14000797401929],
            [31.048984972619454, 3.142454958857652],
            [31.04986586148538, 3.142694274343246],
            [31.05063939358999, 3.142868570638347],
            [31.051693736357503, 3.142308806553241],
            [31.053069075922107, 3.142527440763251],
            [31.05375706325888, 3.142001986300104],
            [31.053610203082968, 3.14410833222873],
            [31.053010688123592, 3.145622153673638],
            [31.048207045956445, 3.149705635065397],
            [31.046446214150603, 3.150056272139688],
            [31.045068338641926, 3.148236343727579],
            [31.04316466033287, 3.147315101295375],
            [31.040231664523475, 3.144915695567845],
            [31.037018052087312, 3.143991973685593],
            [31.035393682457947, 3.142313198092078],
            [31.027747090707187, 3.141416700393957],
            [31.025535027947587, 3.139353101181361],
            [31.020279338258117, 3.137257436633862],
            [31.0134200506836, 3.131593112460588],
            [31.014926069070903, 3.129644682569167],
            [31.016748321387688, 3.128752623014617],
            [31.01664479594109, 3.127437214575336],
            [31.01791198193875, 3.125890365167967],
            [31.01911525729551, 3.125908190825715],
            [31.014286494639762, 3.12028662731494],
            [31.01347061774928, 3.118655430167678],
            [31.01075258788904, 3.115357377508122],
            [31.009824902186715, 3.110970697569607],
            [31.00965986999092, 3.106046839965532],
            [31.009147962331312, 3.102987169119627],
            [31.00796947508649, 3.100185832795217],
            [31.006164545881663, 3.098261972873781],
            [31.004702900676158, 3.097754175306874],
            [31.003823970137535, 3.091104992187334],
            [31.0017979430834, 3.082806221245067],
            [31.00185836646436, 3.081245616220501],
            [31.000516917640454, 3.078957989987016],
            [31.000921019381124, 3.075760044149586],
            [31.002251414435456, 3.074568727535747],
            [31.003853434878863, 3.071962451388868],
            [31.00379738808996, 3.070195683192447],
            [31.004514178109666, 3.067845283472245],
            [31.0042251038445, 3.066450845555454],
            [31.003649882025364, 3.065717595822564],
            [31.003450649170073, 3.062497427627124],
            [31.0019643568881, 3.060938455119693],
            [31.001690460557953, 3.059950224072905],
            [31.002224120922172, 3.058853059728572],
            [31.003312493669263, 3.0583661954439],
            [31.004955903989377, 3.05849014336064],
            [31.006036295205192, 3.057040539845736],
            [31.007831501943695, 3.056180560965595],
            [31.00812210963305, 3.054066159525954],
            [31.009709752540342, 3.053021170896824],
            [31.009857437369696, 3.051619350778666],
            [31.010501289578208, 3.050911762452926],
            [31.012401583035306, 3.051059352770328],
            [31.01383068227807, 3.051867928113094],
            [31.0150535498912, 3.049416121418064],
            [31.015430898006084, 3.047573768738957],
            [31.017203723219268, 3.047177134015778],
            [31.017409897356767, 3.04641230227706],
            [31.017097612421296, 3.045474549928359],
            [31.017463206978988, 3.044895632690586],
            [31.01831731886293, 3.042728120817381],
            [31.020240350476488, 3.040787871451152],
            [31.021135442605356, 3.041017879654509],
            [31.02089859459417, 3.042218287460129],
            [31.02176978794326, 3.043588373290843],
            [31.024234907915005, 3.039401461104929],
            [31.025649478704686, 3.03939920322598],
            [31.026058903861724, 3.039672849688964],
            [31.02698239263507, 3.041831446546745],
            [31.027240726551206, 3.043665375901148],
            [31.027633114260556, 3.04393904729584],
            [31.029642742569177, 3.042941517956458],
            [31.03389710446597, 3.038686590555699],
            [31.034581889308733, 3.039012440242134],
            [31.035302351641345, 3.040336322160273],
            [31.03665507971195, 3.041177350066368],
            [31.03927301030005, 3.041500103281301],
            [31.042128683621346, 3.040635091185139],
            [31.04407878955926, 3.040528699183997],
            [31.044524278481674, 3.040992601674189],
            [31.044628402206275, 3.041990516754231],
            [31.04543301781638, 3.042367809419259],
            [31.04627019286391, 3.041626496705787],
            [31.047980974135406, 3.041640943692412],
            [31.04942028452802, 3.043170156804381],
            [31.05291042445979, 3.043284968241193],
            [31.05691760592298, 3.044618468436733],
            [31.05841851109971, 3.047403254856345],
            [31.061776500768303, 3.047316732174333],
            [31.061909075036244, 3.048713987463319],
            [31.06252375625258, 3.049137634291969],
            [31.064290224088513, 3.049837362101001],
            [31.065310067057528, 3.049148545032328],
            [31.06591300639477, 3.049413932632437],
            [31.066344304630668, 3.050386060701775],
            [31.06799431307653, 3.050205789235196],
            [31.07006724656157, 3.047967217013925],
            [31.071509722617254, 3.047594255448569],
            [31.07215534720184, 3.048164549742054],
            [31.072531225672908, 3.048009517146512],
            [31.073502934214055, 3.045938730168006],
            [31.071921858889798, 3.043474492125391],
            [31.071943543322465, 3.042586547659301],
            [31.072844012766627, 3.041639268003416],
            [31.074355412062474, 3.041165808619009],
            [31.07386987624466, 3.039861776771917],
            [31.074171580822718, 3.03887686338941],
            [31.07753035202566, 3.036771251385819],
            [31.078832331570897, 3.037398360894786],
            [31.080684847231264, 3.041692009146312],
            [31.082494551880163, 3.043051780484237],
            [31.084060252538325, 3.042948822623893],
            [31.08414538408116, 3.0434119373614],
            [31.083409929764784, 3.044347389681922],
            [31.083525893284826, 3.044895381517435],
            [31.084738465306447, 3.044762126962541],
            [31.086520865662305, 3.04582467881223],
            [31.088211548027605, 3.044621285165215],
            [31.08824724977195, 3.042860844570958],
            [31.087551218021797, 3.041954778302429],
            [31.085700852928213, 3.041625835580101],
            [31.085415970202163, 3.041047236521793],
            [31.085644891479294, 3.040158941103974],
            [31.08679470270361, 3.039137882186042],
            [31.089194437899085, 3.039832653105674],
            [31.0901230749173, 3.039746187227081],
            [31.09260147378558, 3.0366575426321],
            [31.094400100410404, 3.038291403096007],
            [31.096950672623546, 3.037233248355467],
            [31.09802525533273, 3.037216022238261],
            [31.09933657196703, 3.0364031291424],
            [31.099395511331128, 3.034797058394589],
            [31.09978643927817, 3.034448958660012],
            [31.102676115629595, 3.034278137703354],
            [31.10476549636916, 3.032803778701305],
            [31.10651645569004, 3.033372201480824],
            [31.107857607171578, 3.032003329860544],
            [31.10974406657327, 3.033332044739652],
            [31.1118544939416, 3.033058263905814],
            [31.112538738896898, 3.033767450842863],
            [31.114332220870047, 3.034524964396509],
            [31.116343108616704, 3.034405768116199],
            [31.11647277952965, 3.033880514917272],
            [31.115995752554245, 3.033155532678045],
            [31.11703435234639, 3.032200233126947],
            [31.1168939420742, 3.030756619777426],
            [31.11926370138697, 3.029424587099075],
            [31.11944750208399, 3.026694862642149],
            [31.119938143027547, 3.026300256582509],
            [31.120567894381093, 3.026515382016107],
            [31.121169354193047, 3.025815605003113],
            [31.12200144477611, 3.022887893642917],
            [31.120867178897775, 3.021557919928733],
            [31.121564170946918, 3.020591604931984],
            [31.122470218030696, 3.020790808557627],
            [31.122792142787485, 3.020496858482233],
            [31.122601424164486, 3.018794672847204],
            [31.12361289483506, 3.017688834163467],
            [31.1231662425943, 3.016493778892612],
            [31.12457108912107, 3.014962231600287],
            [31.12596634343719, 3.013802161865185],
            [31.128288151578396, 3.013585844394389],
            [31.129135401231885, 3.015389401888937],
            [31.13282822714289, 3.014427496797127],
            [31.13324959091005, 3.013895895206236],
            [31.133246908540617, 3.012197072236382],
            [31.133668111509333, 3.011559292700439],
            [31.134723973328008, 3.011769835208299],
            [31.136415157851552, 3.013253409722073],
            [31.13736546313276, 3.013464138493539],
            [31.13873680519434, 3.012930897478745],
            [31.142737701145478, 3.013877668482057],
            [31.14369524415293, 3.011329712429385],
            [31.14776898449046, 3.009066091479756],
            [31.148312480508743, 3.009067019954175],
            [31.149560586289756, 3.010216458106487],
            [31.14857887231297, 3.012236228625062],
            [31.148740813405887, 3.012892108915192],
            [31.151133407893173, 3.012185958384751],
            [31.152492063047987, 3.01224291003305],
            [31.15629263469079, 3.009599514699045],
            [31.158887974446152, 3.010755770959274],
            [31.162733144747857, 3.010659911279138],
            [31.16418378828611, 3.011056544129475],
            [31.16555986357091, 3.010511118752904],
            [31.166425199904317, 3.010768550694402],
            [31.168178080721617, 3.013228797619421],
            [31.171424316375603, 3.026771762397082],
            [31.171420448230005, 3.029075462987009],
            [31.170422299575087, 3.035856899293289],
            [31.170380917783227, 3.041520103905382],
            [31.17189338427763, 3.050641522223807],
            [31.173479677915356, 3.053747839661624],
            [31.183960242385133, 3.067812003737567],
            [31.18647115397849, 3.070056021632555],
            [31.192067553095658, 3.073617140816354],
            [31.196168432436274, 3.076855746939663],
            [31.196788621223583, 3.077957047798351],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 591,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "BILEAFE",
        Population: 21390,
        Key: "ARUABILEAFE",
        Dist2: "Koboko",
        "Sub Country": "Bileafe",
        id2_original: "Koboko Bileafe",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.0134200506836, 3.131593112460588],
            [31.01190536175718, 3.13346853954213],
            [31.01101674827814, 3.136516703247819],
            [31.006390293410888, 3.14040887137572],
            [31.00873848507201, 3.14488461761435],
            [31.01015905211621, 3.150303019865902],
            [31.00941647775291, 3.15046737928912],
            [31.00531151556933, 3.155340038993453],
            [31.006014805706954, 3.158464491679909],
            [31.008702538985887, 3.16196640560126],
            [31.00882815041209, 3.16447520920042],
            [31.00685395525151, 3.165884397551113],
            [31.00800956420269, 3.168032779625293],
            [31.00840830030617, 3.170918364993644],
            [31.007234228280943, 3.171809977618496],
            [31.00521198493082, 3.172293631318934],
            [31.003093819474593, 3.173467010400608],
            [31.00197643922866, 3.17598721128416],
            [31.00396168995541, 3.179605608827152],
            [31.003386773563495, 3.182568931061499],
            [31.002797732062014, 3.18297372706667],
            [31.003455787533504, 3.184084921612903],
            [31.003537263831447, 3.185252691353149],
            [31.004486736374368, 3.186779798940902],
            [31.00337861236913, 3.191532231865366],
            [31.004329384774255, 3.192386128162132],
            [31.005906454510654, 3.192472468489222],
            [31.00587947989931, 3.193743449859712],
            [31.004803291002418, 3.194333078665404],
            [31.004186482575484, 3.194131184744724],
            [31.003295796683084, 3.194749755116584],
            [31.002479627840106, 3.194383271179364],
            [31.000591493080428, 3.194507290026382],
            [30.999068359091993, 3.19362857591852],
            [30.99865048438139, 3.1915553437512],
            [30.99819639588673, 3.191023411476496],
            [30.99886183371323, 3.187789974073054],
            [30.99789953322805, 3.187897558459047],
            [30.99575519445773, 3.189247189579717],
            [30.994039217330656, 3.189291075172886],
            [30.991644439038893, 3.190159690047609],
            [30.989656272380724, 3.188880866920002],
            [30.98843767805343, 3.186988554892312],
            [30.987885674989442, 3.186798478324644],
            [30.98451336168359, 3.186449300438777],
            [30.981776799579062, 3.185534393811625],
            [30.978978229465422, 3.186284839994844],
            [30.975374935943858, 3.180623305487111],
            [30.974776545675223, 3.17734675567561],
            [30.972176684699065, 3.17797254837908],
            [30.96932974210399, 3.168940113639597],
            [30.967204457499168, 3.168504041146868],
            [30.962846851328464, 3.169486621836874],
            [30.96239894144634, 3.169360615944909],
            [30.96177000306817, 3.168259972428803],
            [30.960551769863603, 3.16923521636999],
            [30.95848573454164, 3.162852261255968],
            [30.95892473223783, 3.161991144315146],
            [30.960179947286036, 3.162112385621148],
            [30.96016729631188, 3.161028675968671],
            [30.958354196031216, 3.159184314112067],
            [30.955147849169084, 3.159831149470181],
            [30.954785643056642, 3.159588634917646],
            [30.95360245402961, 3.157052084852319],
            [30.953662842376293, 3.156384181936656],
            [30.953247632068813, 3.156126336760113],
            [30.953516395425407, 3.155745558727851],
            [30.95283689626977, 3.155788750604742],
            [30.95238036974742, 3.155104977973822],
            [30.95250913785353, 3.149686833025949],
            [30.950593628732165, 3.149152914880879],
            [30.949235733552054, 3.147842982048663],
            [30.94689053058588, 3.147235357931196],
            [30.944997194580672, 3.140395688662422],
            [30.942801560211024, 3.134392076086387],
            [30.93977402480279, 3.128920606921377],
            [30.939546523762136, 3.127172654649724],
            [30.94037822627299, 3.126032533592818],
            [30.940226817028506, 3.125652553660729],
            [30.93833515278803, 3.12390488297714],
            [30.93659553559594, 3.124437156397118],
            [30.935460572624955, 3.123449348688062],
            [30.933115739764677, 3.123753722931191],
            [30.932359035800264, 3.12291784886208],
            [30.93350672879716, 3.121527074926141],
            [30.933937087395254, 3.121592723274715],
            [30.93423925370736, 3.120338684647837],
            [30.932764154433823, 3.120148930472501],
            [30.93079690864032, 3.118477259353372],
            [30.930758961107774, 3.118097274894317],
            [30.932044577840117, 3.117147082620665],
            [30.932346812424196, 3.11612104654565],
            [30.931854984806137, 3.115665128560839],
            [30.93083382490691, 3.115703300757533],
            [30.930493212497268, 3.115019363785172],
            [30.92973668100939, 3.114677492007108],
            [30.929314572538836, 3.113446347965464],
            [30.931270712460513, 3.112982550561868],
            [30.93217813935656, 3.112146411393783],
            [30.932480358669263, 3.11108237748224],
            [30.935429664290957, 3.108877909528224],
            [30.935656284982624, 3.107965883210166],
            [30.93694193495266, 3.107205661693007],
            [30.938216259861854, 3.104524000432265],
            [30.939609192033014, 3.104581558031701],
            [30.940516474300296, 3.103365405393854],
            [30.94286109785308, 3.102566988160521],
            [30.943768396290043, 3.101388833695276],
            [30.94497841440135, 3.100666618725955],
            [30.945916009419587, 3.099120918534733],
            [30.948457249933547, 3.098727969912587],
            [30.949251198947987, 3.097898510200426],
            [30.950149132448107, 3.0982613404872],
            [30.956916386723428, 3.098137772144283],
            [30.958157210760763, 3.098328166253972],
            [30.962515932639064, 3.101249019259301],
            [30.96529541714617, 3.099845905395089],
            [30.964551164729922, 3.098400303166006],
            [30.961105362047324, 3.094830428787227],
            [30.962695220200104, 3.090321737719967],
            [30.95997799792532, 3.088658762562396],
            [30.95842213920942, 3.084280723193489],
            [30.958661673183297, 3.083495046239792],
            [30.95993886910818, 3.082437930922424],
            [30.960486395867097, 3.080627446017115],
            [30.962495041418798, 3.079383740014335],
            [30.96730886958297, 3.078247950245258],
            [30.968777769582736, 3.079831570861774],
            [30.971981620925007, 3.082044702532691],
            [30.972860313410056, 3.083209352398458],
            [30.976630693574485, 3.084815651106754],
            [30.977549413191976, 3.085676420519612],
            [30.98066632198779, 3.085219831900926],
            [30.982521863174057, 3.08432471096741],
            [30.988883563132898, 3.085327998238727],
            [30.991566009826403, 3.085187722413954],
            [30.993300544350618, 3.085719643980846],
            [30.994420970783672, 3.084201961769186],
            [30.995263356059905, 3.083714577112095],
            [30.996776803514603, 3.082950930432947],
            [30.998749366436293, 3.082756426131104],
            [30.99934196346965, 3.082255348763277],
            [30.999897858933796, 3.080287250423312],
            [31.00072611820214, 3.079505297631311],
            [31.000516917640454, 3.078957989987016],
            [31.00185836646436, 3.081245616220501],
            [31.0017979430834, 3.082806221245067],
            [31.003823970137535, 3.091104992187334],
            [31.004702900676158, 3.097754175306874],
            [31.006164545881663, 3.098261972873781],
            [31.00796947508649, 3.100185832795217],
            [31.009147962331312, 3.102987169119627],
            [31.00965986999092, 3.106046839965532],
            [31.009824902186715, 3.110970697569607],
            [31.01075258788904, 3.115357377508122],
            [31.01347061774928, 3.118655430167678],
            [31.014286494639762, 3.12028662731494],
            [31.01911525729551, 3.125908190825715],
            [31.01791198193875, 3.125890365167967],
            [31.01664479594109, 3.127437214575336],
            [31.016748321387688, 3.128752623014617],
            [31.014926069070903, 3.129644682569167],
            [31.0134200506836, 3.131593112460588],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 592,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "KATRINI",
        Population: 31899,
        Key: "ARUAKATRINI",
        Dist2: "Koboko",
        "Sub Country": "Katrini",
        id2_original: "Koboko Katrini",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.000516917640454, 3.078957989987016],
            [31.00072611820214, 3.079505297631311],
            [30.999897858933796, 3.080287250423312],
            [30.99934196346965, 3.082255348763277],
            [30.998749366436293, 3.082756426131104],
            [30.996776803514603, 3.082950930432947],
            [30.995263356059905, 3.083714577112095],
            [30.994420970783672, 3.084201961769186],
            [30.993300544350618, 3.085719643980846],
            [30.991566009826403, 3.085187722413954],
            [30.988883563132898, 3.085327998238727],
            [30.982521863174057, 3.08432471096741],
            [30.98066632198779, 3.085219831900926],
            [30.977549413191976, 3.085676420519612],
            [30.976630693574485, 3.084815651106754],
            [30.972860313410056, 3.083209352398458],
            [30.971981620925007, 3.082044702532691],
            [30.968777769582736, 3.079831570861774],
            [30.96730886958297, 3.078247950245258],
            [30.962495041418798, 3.079383740014335],
            [30.960486395867097, 3.080627446017115],
            [30.95993886910818, 3.082437930922424],
            [30.958661673183297, 3.083495046239792],
            [30.95842213920942, 3.084280723193489],
            [30.95997799792532, 3.088658762562396],
            [30.962695220200104, 3.090321737719967],
            [30.961105362047324, 3.094830428787227],
            [30.964551164729922, 3.098400303166006],
            [30.96529541714617, 3.099845905395089],
            [30.962515932639064, 3.101249019259301],
            [30.958157210760763, 3.098328166253972],
            [30.956916386723428, 3.098137772144283],
            [30.950149132448107, 3.0982613404872],
            [30.949251198947987, 3.097898510200426],
            [30.948457249933547, 3.098727969912587],
            [30.945916009419587, 3.099120918534733],
            [30.94497841440135, 3.100666618725955],
            [30.943768396290043, 3.101388833695276],
            [30.94286109785308, 3.102566988160521],
            [30.940516474300296, 3.103365405393854],
            [30.939609192033014, 3.104581558031701],
            [30.938216259861854, 3.104524000432265],
            [30.93694193495266, 3.107205661693007],
            [30.935656284982624, 3.107965883210166],
            [30.935429664290957, 3.108877909528224],
            [30.932480358669263, 3.11108237748224],
            [30.93217813935656, 3.112146411393783],
            [30.931270712460513, 3.112982550561868],
            [30.929314572538836, 3.113446347965464],
            [30.92833662250309, 3.112587737770772],
            [30.928109454737427, 3.111827793167596],
            [30.92746648018291, 3.111789898000596],
            [30.926407186799892, 3.110840082153806],
            [30.927238987227124, 3.110041958508264],
            [30.92583628408063, 3.108752542161144],
            [30.926670733639646, 3.107154094367112],
            [30.92674589028957, 3.105672111008518],
            [30.925005805973495, 3.104646408212068],
            [30.924476055077402, 3.103848512205154],
            [30.923341472093792, 3.103962691906182],
            [30.922431980869213, 3.102645060222625],
            [30.921945976130843, 3.102530064110524],
            [30.921004662087327, 3.10317983714348],
            [30.919948318771674, 3.102610342791789],
            [30.918810595277844, 3.100858369541629],
            [30.91770801747115, 3.100471993886396],
            [30.91765796603847, 3.099800691167581],
            [30.916390947127436, 3.099780974190132],
            [30.914594520476772, 3.099054582580867],
            [30.914188510714432, 3.096541070910706],
            [30.912869390415278, 3.096899875911464],
            [30.911055884994393, 3.096156239217356],
            [30.91100681362371, 3.094985842988031],
            [30.909808328084008, 3.094949046945261],
            [30.90967428776554, 3.093451487016555],
            [30.909246572909296, 3.093278536114894],
            [30.909042861952344, 3.092383198620389],
            [30.90712869760893, 3.090589537912963],
            [30.903637252425074, 3.089842572476076],
            [30.903949840092807, 3.08803428440357],
            [30.90300426803485, 3.087768431874128],
            [30.901756297001132, 3.087996619813093],
            [30.901945134551948, 3.087160615182702],
            [30.90277695114883, 3.086514510077099],
            [30.90243595695518, 3.084576617587942],
            [30.902738235556725, 3.083702601968117],
            [30.90213295970143, 3.083170712581753],
            [30.90196870903994, 3.082302893288261],
            [30.90443717793107, 3.08140893781549],
            [30.90343383791213, 3.080115696726135],
            [30.902935120215865, 3.077951419898775],
            [30.900868737245894, 3.077960221452888],
            [30.90039293018261, 3.076139587217646],
            [30.898496911807968, 3.07518198916322],
            [30.89771025262211, 3.074425978997073],
            [30.89763875840358, 3.073782123969791],
            [30.89810269333206, 3.072119474604627],
            [30.899493240476126, 3.072121386163389],
            [30.899651779649037, 3.071804234210343],
            [30.898792155702502, 3.07034952132946],
            [30.900033460338527, 3.069192004924628],
            [30.898930578002943, 3.067895545736939],
            [30.90039231753159, 3.065971952140373],
            [30.90058990916485, 3.064731022413601],
            [30.901641715089994, 3.064158523051458],
            [30.91079359040616, 3.063396990135709],
            [30.916010902270067, 3.058570166119507],
            [30.92142709035812, 3.058401244426751],
            [30.92401106732343, 3.057452771291305],
            [30.927401275069723, 3.059967916284028],
            [30.92840770169996, 3.059071074295166],
            [30.929647118975545, 3.056185708167562],
            [30.931232806250463, 3.055189167959224],
            [30.935102953310327, 3.053734255789716],
            [30.93538715062182, 3.051746226520334],
            [30.935155035833876, 3.050950429449549],
            [30.935809762148924, 3.050070357318069],
            [30.937634420154033, 3.049296394837298],
            [30.938078343312945, 3.048279120238514],
            [30.938283705373394, 3.046817110263315],
            [30.937445440669382, 3.045394500179976],
            [30.937995763883798, 3.043567028029966],
            [30.94156133355335, 3.040668415717582],
            [30.94591353276432, 3.040788937147114],
            [30.946796151785488, 3.040274596986309],
            [30.947199611230737, 3.039377923366922],
            [30.94895148683322, 3.039515889004942],
            [30.950269727681718, 3.038800450697524],
            [30.95205580304536, 3.038557061588907],
            [30.953475016328476, 3.037561355466352],
            [30.953967771906196, 3.036653629682963],
            [30.95504890243549, 3.037396082379406],
            [30.955897387272486, 3.037229425113741],
            [30.95801023739715, 3.038126877365729],
            [30.957898652265794, 3.038374881009316],
            [30.96029395068211, 3.038354613005303],
            [30.961650429218988, 3.039238360062058],
            [30.96331667381532, 3.039539383681439],
            [30.96336422164332, 3.040519933204568],
            [30.96406784415758, 3.040595734883214],
            [30.964523623281615, 3.041155087972427],
            [30.96475615937943, 3.043168825584401],
            [30.967492583143404, 3.041919023702544],
            [30.968913755652117, 3.042549213377086],
            [30.9695598680219, 3.043535368508578],
            [30.97137608096503, 3.04269933900421],
            [30.972532217227272, 3.043216995293548],
            [30.974356694671002, 3.044938675698804],
            [30.974935323800025, 3.044900117028846],
            [30.97559486688161, 3.043777902503958],
            [30.976527328028, 3.044374439252384],
            [30.97748936979838, 3.043213140676335],
            [30.979764131371528, 3.043217429464998],
            [30.98013343597137, 3.042610132870881],
            [30.981644282803305, 3.04330027457796],
            [30.982026191664882, 3.042983778816308],
            [30.982669578546105, 3.043474028351452],
            [30.981910363790472, 3.045231912257545],
            [30.982839018774992, 3.045839616426866],
            [30.983584544104026, 3.046025889863507],
            [30.984208839988796, 3.045472458912778],
            [30.985404048474326, 3.046372642984651],
            [30.98685649762628, 3.046286360628093],
            [30.988475365074525, 3.047188440372875],
            [30.98969493137898, 3.048525939241761],
            [30.994406144988243, 3.048472467342607],
            [30.994025605159138, 3.049852486244881],
            [30.994324939083196, 3.052617220125615],
            [30.995468228538545, 3.05289053042721],
            [30.996255235372445, 3.053680743782845],
            [31.00088305028901, 3.054268843767595],
            [31.002344798800817, 3.054844512267184],
            [31.003294031493557, 3.05661379328159],
            [31.003312493669263, 3.0583661954439],
            [31.002224120922172, 3.058853059728572],
            [31.001690460557953, 3.059950224072905],
            [31.0019643568881, 3.060938455119693],
            [31.003450649170073, 3.062497427627124],
            [31.003649882025364, 3.065717595822564],
            [31.0042251038445, 3.066450845555454],
            [31.004514178109666, 3.067845283472245],
            [31.00379738808996, 3.070195683192447],
            [31.003853434878863, 3.071962451388868],
            [31.002251414435456, 3.074568727535747],
            [31.000921019381124, 3.075760044149586],
            [31.000516917640454, 3.078957989987016],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 593,
        District: "ARUA",
        County: "AYIVU",
        Subcounty: "MANIBE",
        Population: 29279,
        Key: "ARUAMANIBE",
        Dist2: "Koboko",
        "Sub Country": "Manibe",
        id2_original: "Koboko Manibe",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.137299343534565, 3.305010499698191],
            [31.133534305651146, 3.30401464832539],
            [31.13126075051543, 3.302174112102017],
            [31.129879660834668, 3.304120735198048],
            [31.129816756306923, 3.306837136235815],
            [31.12712881821209, 3.306700538952481],
            [31.12484185122914, 3.307275153562071],
            [31.1211825234951, 3.309867161960866],
            [31.119136500841073, 3.312295133511857],
            [31.119379620889557, 3.313262635457656],
            [31.11883440998742, 3.314756107184714],
            [31.11850324515962, 3.314087338732141],
            [31.114502062645872, 3.311196167328663],
            [31.0988631831685, 3.300599172658364],
            [31.09477947332791, 3.304353916062981],
            [31.09400904939416, 3.304668910314248],
            [31.090492887963602, 3.304398385866791],
            [31.08752142898868, 3.302915734844008],
            [31.085370563059513, 3.302331360269037],
            [31.084532319016766, 3.301520956047061],
            [31.085042020414004, 3.300308774347514],
            [31.085133341349167, 3.298304586307117],
            [31.084505315659317, 3.29735393372963],
            [31.0804469715474, 3.297012014370493],
            [31.07726094906859, 3.297955263066553],
            [31.075719273852698, 3.299024773298153],
            [31.074766953650343, 3.302943716620556],
            [31.07313935008596, 3.303204276866204],
            [31.07086566738946, 3.302813036040511],
            [31.070062330980317, 3.302055440789055],
            [31.070138950985857, 3.297552918341212],
            [31.069631037236007, 3.296995885808273],
            [31.069607701699876, 3.295618121427863],
            [31.07008793925411, 3.295317526499558],
            [31.07008950501765, 3.294505706742385],
            [31.071241434469414, 3.293896302045952],
            [31.07108090822309, 3.293402428631491],
            [31.071686150840726, 3.29279620163311],
            [31.071822248301213, 3.29107273168147],
            [31.072941875233692, 3.289996182617886],
            [31.07373216181666, 3.2875622437365],
            [31.073069253646015, 3.287049396382166],
            [31.0722056627392, 3.287325742432469],
            [31.071598100671523, 3.286801881790878],
            [31.07029193946863, 3.287066245265837],
            [31.068589113677298, 3.28646240807407],
            [31.067706095804155, 3.286590292667025],
            [31.07281032324851, 3.275765689766023],
            [31.072714738010724, 3.274951865794884],
            [31.070739272632355, 3.275061953012639],
            [31.069947464303265, 3.274263056518727],
            [31.066243493892834, 3.272351971139671],
            [31.064048345511743, 3.273443133646143],
            [31.063019280438024, 3.273549891924418],
            [31.062648340006074, 3.272800628604125],
            [31.060981197094446, 3.272553298823969],
            [31.05886354547459, 3.270840553488752],
            [31.057261766677996, 3.270284167034817],
            [31.0565156313929, 3.270998708826938],
            [31.056425435148505, 3.272768621815098],
            [31.055881413615793, 3.272445735067773],
            [31.05308937694921, 3.267835149793309],
            [31.050439805001847, 3.26935968307158],
            [31.049457948192952, 3.270317763125572],
            [31.049424118537665, 3.271066233691439],
            [31.044889016944936, 3.27200116170333],
            [31.042773470077776, 3.273950152183923],
            [31.040383956811905, 3.274140285078397],
            [31.0393489853152, 3.273519896792834],
            [31.037677318487823, 3.274798119987298],
            [31.03673995253998, 3.27475146683078],
            [31.034943250106505, 3.277274455185505],
            [31.032671728756586, 3.277037849205618],
            [31.032560466120454, 3.27597992598443],
            [31.03210745829907, 3.275816306941074],
            [31.031367546542263, 3.273341446144542],
            [31.02923372884055, 3.271661178931671],
            [31.02829627395949, 3.271422838011903],
            [31.026710626210477, 3.270354405822652],
            [31.025211802430263, 3.266852895319895],
            [31.02306072629534, 3.26502665285685],
            [31.02356335705299, 3.263517134480938],
            [31.024658739354262, 3.262238332789249],
            [31.025391416978078, 3.258501110103802],
            [31.027341831936422, 3.253871784491952],
            [31.025776764590542, 3.252249833201375],
            [31.027133013158736, 3.24907503480372],
            [31.030330065152636, 3.243564150896318],
            [31.034209111822047, 3.238686712839114],
            [31.036563781234673, 3.234320120358082],
            [31.040179761662973, 3.231658752320635],
            [31.045173639159554, 3.231532790846406],
            [31.047199003257, 3.231978429616026],
            [31.050487102199888, 3.227469495068922],
            [31.053444913070667, 3.225611446673044],
            [31.057457420645225, 3.225212373560618],
            [31.064491535645388, 3.225768897861729],
            [31.07104498639153, 3.223457934723712],
            [31.079165986528658, 3.22217966714828],
            [31.08667720665772, 3.219993828251402],
            [31.09188163308719, 3.21938725301128],
            [31.092359501784046, 3.219959980253219],
            [31.093255757231194, 3.22007589343087],
            [31.097204643422376, 3.216295351768333],
            [31.098996655751737, 3.215309162771952],
            [31.102136749166714, 3.211379335200086],
            [31.10432924033122, 3.209838719175357],
            [31.107843625792487, 3.205276365351427],
            [31.109999424370884, 3.203489072444171],
            [31.11153272189841, 3.200892713833167],
            [31.11382400438795, 3.199998238334083],
            [31.117253350832847, 3.200640237943965],
            [31.122790425208674, 3.203075761170938],
            [31.12518669739874, 3.202705118537278],
            [31.127796522488033, 3.205845144242903],
            [31.129045805062077, 3.205004694870946],
            [31.130035561655603, 3.204845904977199],
            [31.130000864227753, 3.204475240561723],
            [31.131750578483643, 3.203050869174522],
            [31.133086788332786, 3.202496560412049],
            [31.134264368279176, 3.203255335475456],
            [31.135031399276116, 3.203256740039239],
            [31.1350980084561, 3.203772732340366],
            [31.135995532324475, 3.204229262778395],
            [31.13788542778213, 3.203832995808468],
            [31.140004063057205, 3.202623414314387],
            [31.141651480761837, 3.202783455745374],
            [31.14236282878753, 3.202156611715966],
            [31.14247955407891, 3.200443715987083],
            [31.142920943090406, 3.199859208489372],
            [31.141384400848064, 3.198067626044977],
            [31.140861262450777, 3.196653579137156],
            [31.14169221217343, 3.194818108428839],
            [31.141065556414382, 3.193875848707191],
            [31.141844782939586, 3.192302483973296],
            [31.142625887842094, 3.191986799009752],
            [31.143092404528698, 3.190361526448852],
            [31.144498441323186, 3.189835210091165],
            [31.145172833556423, 3.187842770680469],
            [31.146630965450882, 3.187316366928846],
            [31.146682367949765, 3.186844651183801],
            [31.145847837542384, 3.186269569819758],
            [31.14594993376937, 3.184854494941672],
            [31.143913798871655, 3.182132814095474],
            [31.142089072594597, 3.181402125170501],
            [31.141983454971694, 3.180459024396342],
            [31.14253262295264, 3.17885833381946],
            [31.14890347135436, 3.178997680430354],
            [31.157170436945425, 3.180197685388677],
            [31.165835027423928, 3.182512490854559],
            [31.166898976775066, 3.181157369760061],
            [31.169203318073908, 3.180140048544711],
            [31.169760569994107, 3.179311124354717],
            [31.171158336898078, 3.179106135759446],
            [31.17266909030525, 3.177863948524465],
            [31.173053851317842, 3.175789835219006],
            [31.17526296041679, 3.174740399278574],
            [31.176821594028592, 3.173354643830268],
            [31.177013687972313, 3.172477183537717],
            [31.178076945620727, 3.172862108246827],
            [31.179221782873306, 3.172002292120233],
            [31.17953811561747, 3.172721053934221],
            [31.180506739343915, 3.172738728104715],
            [31.181811654583502, 3.171145028866039],
            [31.18436876653195, 3.170862262296088],
            [31.185769202330636, 3.169125080930233],
            [31.185691670535082, 3.1680556175734],
            [31.184995029727194, 3.16687334364421],
            [31.185233918710725, 3.166474761634929],
            [31.186408724659508, 3.166636430358166],
            [31.186616436712768, 3.165902631531598],
            [31.187521040203873, 3.166207464279581],
            [31.191295351395958, 3.16910287983425],
            [31.193104322121258, 3.169856183062332],
            [31.194388271580458, 3.171183129968489],
            [31.194801143573223, 3.171183854695776],
            [31.195199328111116, 3.170498265150731],
            [31.196914026037252, 3.170676831597989],
            [31.19811817006491, 3.172243042178739],
            [31.197274912524524, 3.173183215677931],
            [31.197273362032366, 3.174076983483192],
            [31.201602920104932, 3.177324492867761],
            [31.202238692865816, 3.176990440369244],
            [31.20285712185348, 3.177502249997501],
            [31.203028287746022, 3.179529501420153],
            [31.203962684761862, 3.180983519395508],
            [31.204820585739665, 3.180761576438809],
            [31.204743728578897, 3.179293098699146],
            [31.205094577291202, 3.178431858215161],
            [31.206270515117264, 3.177955104810173],
            [31.20699145804852, 3.180030310711554],
            [31.20626438770869, 3.18126449561034],
            [31.206227219015524, 3.184527297413789],
            [31.201797876081173, 3.189736600525081],
            [31.201138677952642, 3.191441199659874],
            [31.198067646118357, 3.195269074783882],
            [31.196596645857472, 3.199913425189037],
            [31.195632826321138, 3.20088588383445],
            [31.195092718748146, 3.202767807318773],
            [31.194429714457744, 3.203193662924878],
            [31.192438559104634, 3.203075605108265],
            [31.19093220295079, 3.204352353925273],
            [31.190270681778937, 3.205749040387778],
            [31.188944014733025, 3.206175983601088],
            [31.189188120233396, 3.207995921941491],
            [31.191482698641718, 3.209266362054944],
            [31.191848674085115, 3.211874920625543],
            [31.191426996805895, 3.212300361656364],
            [31.189435918707908, 3.212242975955019],
            [31.18889338298869, 3.212547260411216],
            [31.1888944016782, 3.213214721498553],
            [31.19215763525403, 3.216667983280625],
            [31.192370316787432, 3.217827326289208],
            [31.192217834056187, 3.21842314595529],
            [31.18880458452284, 3.221816038894853],
            [31.18781968691671, 3.222144029020047],
            [31.187702476535062, 3.222925166995755],
            [31.188431701933265, 3.225721664839633],
            [31.187494689921643, 3.227508255982941],
            [31.18572438088952, 3.229521638447336],
            [31.185280579901523, 3.230713019776387],
            [31.184114513662134, 3.230193706481936],
            [31.182476645048983, 3.227318018331903],
            [31.1794282570481, 3.227163406042315],
            [31.17827022893387, 3.225995398033965],
            [31.17622162901327, 3.224974915876447],
            [31.175168838534574, 3.225311948348899],
            [31.17386267823001, 3.2240081001131],
            [31.17320193320255, 3.223871335503532],
            [31.170457229666628, 3.22740480594595],
            [31.16976600839483, 3.229220215655239],
            [31.168928781244965, 3.229706758936922],
            [31.165115599052207, 3.230205605495625],
            [31.16329264335459, 3.230970007635619],
            [31.160473739874487, 3.230079056379334],
            [31.157913989574062, 3.232111781378491],
            [31.15694124258044, 3.233881647829854],
            [31.148883411075772, 3.238089293363052],
            [31.145591325409633, 3.23891000378018],
            [31.145589765934307, 3.239766288261203],
            [31.14652853325399, 3.240535722753515],
            [31.147758415811143, 3.242782051218099],
            [31.147080515656743, 3.243961891202499],
            [31.1466020244274, 3.248567248556819],
            [31.141890713800084, 3.254257275815207],
            [31.142975467234898, 3.255528950393475],
            [31.14331006811867, 3.256875468495223],
            [31.14474815859912, 3.257930637853292],
            [31.146521699769636, 3.26167032722981],
            [31.15052493852703, 3.264503312381807],
            [31.14577537314336, 3.272073773438119],
            [31.144534822193865, 3.270749888931005],
            [31.14240513943742, 3.272918378745194],
            [31.141607967267767, 3.275379004024516],
            [31.140714757109418, 3.281061912722775],
            [31.138926404516532, 3.283719816593068],
            [31.137369907098464, 3.287433590678821],
            [31.141814941804174, 3.29028058770296],
            [31.14025267450705, 3.293405984569011],
            [31.139784801364367, 3.297008471898279],
            [31.140437582826824, 3.299579156366875],
            [31.13873428003007, 3.301862823632821],
            [31.138185805548513, 3.301909032489939],
            [31.13766740486605, 3.302632431083109],
            [31.137299343534565, 3.305010499698191],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 594,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "OMUGO",
        Population: 43578,
        Key: "ARUAOMUGO",
        Dist2: "Koboko",
        "Sub Country": "Omugo",
        id2_original: "Koboko Omugo",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.30555584800225, 3.28391246954481],
            [31.303893858725438, 3.282349092903071],
            [31.30300123696359, 3.282051726192502],
            [31.302758470851327, 3.281324663400891],
            [31.30140088918324, 3.280375069049708],
            [31.300193153691094, 3.278817478697598],
            [31.298875245219218, 3.27787792304886],
            [31.298130750257823, 3.278125934012947],
            [31.297906429253292, 3.2758421182106],
            [31.2955283524393, 3.274093074051167],
            [31.294307959684815, 3.274160786148574],
            [31.29417542224779, 3.276264503667815],
            [31.291575085164503, 3.276878267938186],
            [31.289915847427405, 3.278311285032332],
            [31.287355683003653, 3.278635935775581],
            [31.286096268331512, 3.278314687663102],
            [31.285262060419324, 3.278811814226021],
            [31.284102213216638, 3.278281340266738],
            [31.283277755618542, 3.278878194189754],
            [31.28130538493634, 3.276345180438466],
            [31.279808130512954, 3.277716302488155],
            [31.279653996678178, 3.278742700674793],
            [31.277048304737495, 3.280587724940086],
            [31.273180834657182, 3.281783009911881],
            [31.269737187032955, 3.284889312790143],
            [31.26800640117843, 3.285444362006291],
            [31.266468929179755, 3.285355824280321],
            [31.26633710590339, 3.286562263795183],
            [31.26500882368664, 3.287285113916028],
            [31.263259317839864, 3.285789066431605],
            [31.2618310540303, 3.285748286286849],
            [31.25941749376259, 3.282815511411621],
            [31.256905770092217, 3.281586098342306],
            [31.255247754962202, 3.282253119188254],
            [31.25250628176801, 3.281731504268255],
            [31.248407369737905, 3.284250871508319],
            [31.246019981886, 3.288170507046831],
            [31.244305025245065, 3.288722555418329],
            [31.24308424621499, 3.28983055516664],
            [31.240875278151552, 3.289730936537239],
            [31.240664042905742, 3.290725876680699],
            [31.239405439412316, 3.29168067626758],
            [31.24139785150853, 3.293302969098458],
            [31.24150860390158, 3.29429815499306],
            [31.238808028307346, 3.295680008053762],
            [31.238100723598716, 3.297190858978737],
            [31.238497788835762, 3.298818519303324],
            [31.23628593538365, 3.300345827586453],
            [31.237721510581295, 3.303347018763125],
            [31.23755491801187, 3.30431019869066],
            [31.236201541357634, 3.304996843801876],
            [31.23494504351524, 3.30474577150075],
            [31.23347641480669, 3.305987283671956],
            [31.232979190110406, 3.30715396817802],
            [31.23303276024405, 3.309163825069155],
            [31.23419393515671, 3.309472153544289],
            [31.23533423681545, 3.310814035925358],
            [31.235123218961935, 3.311674985128116],
            [31.233942147264063, 3.311845134266009],
            [31.233652639112595, 3.314007499954141],
            [31.232377089799655, 3.313756385095528],
            [31.22925826759225, 3.311224233172159],
            [31.224021876410024, 3.310736301710524],
            [31.22167759242041, 3.311746519586545],
            [31.22022696145858, 3.313562242939482],
            [31.218855688567263, 3.313598045525296],
            [31.217939907339076, 3.31451512829196],
            [31.21770849233874, 3.316122504806373],
            [31.21839975942458, 3.317658307912999],
            [31.216631799486976, 3.318439601965951],
            [31.21554997006841, 3.320336948504765],
            [31.214245039557433, 3.320644248446951],
            [31.21342145422349, 3.321716273043609],
            [31.211735726965276, 3.322456413075852],
            [31.210983456186803, 3.323848554467813],
            [31.21095904177399, 3.325995548703766],
            [31.209282512365995, 3.327324066939374],
            [31.208242464489594, 3.328818898469236],
            [31.20617648306659, 3.329682192350958],
            [31.20433319669743, 3.332341961283206],
            [31.204568204958896, 3.333013339593239],
            [31.203725667867417, 3.333197595234589],
            [31.204167463815697, 3.334161676936625],
            [31.20382691338982, 3.335311115098631],
            [31.204559511961882, 3.335717411872339],
            [31.204300959755127, 3.33608949223999],
            [31.200990587983103, 3.337854697567737],
            [31.20034222263857, 3.338843679469955],
            [31.19815651016123, 3.338684938579683],
            [31.19693928666303, 3.339270609922403],
            [31.196061867090734, 3.339238048371568],
            [31.193719612395327, 3.340502379890447],
            [31.190918446150505, 3.340172298731896],
            [31.190515358607826, 3.341718692174824],
            [31.189751486985738, 3.341886439013155],
            [31.189808951316166, 3.340773628014794],
            [31.189193379869405, 3.340664187504543],
            [31.187918438715865, 3.339145629664606],
            [31.187348454973172, 3.339361172262366],
            [31.186949142151263, 3.338849876291937],
            [31.18621819558099, 3.338901209472357],
            [31.18590458113891, 3.337625701869251],
            [31.18430520623402, 3.336740866831456],
            [31.183848457827786, 3.339104284049552],
            [31.18250070193232, 3.338578604319581],
            [31.181467753441616, 3.339412135041829],
            [31.178849316203685, 3.340180824507124],
            [31.178384749759545, 3.34166520326368],
            [31.17756774368674, 3.342267059839561],
            [31.17779711322319, 3.343102937010276],
            [31.177226869867333, 3.343457711985785],
            [31.177841637321926, 3.344000354494995],
            [31.177623543438948, 3.345160119273005],
            [31.174757437083922, 3.346887718725061],
            [31.172586759709464, 3.350842560957683],
            [31.171301197774344, 3.3511513032492],
            [31.159633009295007, 3.350788963137443],
            [31.15133625916241, 3.350115104836876],
            [31.150323920719273, 3.348450675895651],
            [31.149231581910197, 3.348108239757269],
            [31.148447882673178, 3.347364141802794],
            [31.144723611235673, 3.346784636193197],
            [31.14349369723748, 3.345931391455972],
            [31.14094993694913, 3.339753631691072],
            [31.140982560166986, 3.338779022670002],
            [31.144294006324106, 3.335911354166411],
            [31.14443804309507, 3.334917836916084],
            [31.145579825177357, 3.333512139066845],
            [31.144798033962008, 3.33252918096179],
            [31.145136856927632, 3.331670249803435],
            [31.144768102995084, 3.331298247579067],
            [31.144739170954693, 3.330308049204268],
            [31.14429310172059, 3.330121551922776],
            [31.14383036155145, 3.330615748701316],
            [31.143631693736463, 3.329841822525049],
            [31.14180251451053, 3.328415026484895],
            [31.141450753109904, 3.327192152891606],
            [31.139897940581132, 3.326152655874224],
            [31.139992479281638, 3.324992511747823],
            [31.138854282375632, 3.324495284540578],
            [31.138069182665063, 3.323569434910405],
            [31.138412310357523, 3.322127391270945],
            [31.13745956615033, 3.321243741339341],
            [31.13693141335715, 3.319680175943102],
            [31.137110419745493, 3.318628491451767],
            [31.136242937336853, 3.315322921135135],
            [31.136549039168234, 3.314264623394891],
            [31.137319375965397, 3.31391024954289],
            [31.136877437184985, 3.31350307746415],
            [31.13697154289752, 3.310588560230491],
            [31.13797634267878, 3.308326478835874],
            [31.137147097958547, 3.307257418963438],
            [31.137299343534565, 3.305010499698191],
            [31.13766740486605, 3.302632431083109],
            [31.138185805548513, 3.301909032489939],
            [31.13873428003007, 3.301862823632821],
            [31.140437582826824, 3.299579156366875],
            [31.139784801364367, 3.297008471898279],
            [31.14025267450705, 3.293405984569011],
            [31.141814941804174, 3.29028058770296],
            [31.137369907098464, 3.287433590678821],
            [31.138926404516532, 3.283719816593068],
            [31.140714757109418, 3.281061912722775],
            [31.141607967267767, 3.275379004024516],
            [31.14240513943742, 3.272918378745194],
            [31.144534822193865, 3.270749888931005],
            [31.14577537314336, 3.272073773438119],
            [31.15052493852703, 3.264503312381807],
            [31.146521699769636, 3.26167032722981],
            [31.14474815859912, 3.257930637853292],
            [31.14331006811867, 3.256875468495223],
            [31.142975467234898, 3.255528950393475],
            [31.141890713800084, 3.254257275815207],
            [31.1466020244274, 3.248567248556819],
            [31.147080515656743, 3.243961891202499],
            [31.147758415811143, 3.242782051218099],
            [31.14652853325399, 3.240535722753515],
            [31.145589765934307, 3.239766288261203],
            [31.145591325409633, 3.23891000378018],
            [31.148883411075772, 3.238089293363052],
            [31.15694124258044, 3.233881647829854],
            [31.157913989574062, 3.232111781378491],
            [31.160473739874487, 3.230079056379334],
            [31.16329264335459, 3.230970007635619],
            [31.165115599052207, 3.230205605495625],
            [31.168928781244965, 3.229706758936922],
            [31.16976600839483, 3.229220215655239],
            [31.170457229666628, 3.22740480594595],
            [31.17320193320255, 3.223871335503532],
            [31.17386267823001, 3.2240081001131],
            [31.175168838534574, 3.225311948348899],
            [31.17622162901327, 3.224974915876447],
            [31.17827022893387, 3.225995398033965],
            [31.1794282570481, 3.227163406042315],
            [31.182476645048983, 3.227318018331903],
            [31.184114513662134, 3.230193706481936],
            [31.185280579901523, 3.230713019776387],
            [31.18572438088952, 3.229521638447336],
            [31.187494689921643, 3.227508255982941],
            [31.188431701933265, 3.225721664839633],
            [31.187702476535062, 3.222925166995755],
            [31.18781968691671, 3.222144029020047],
            [31.18880458452284, 3.221816038894853],
            [31.192217834056187, 3.21842314595529],
            [31.192370316787432, 3.217827326289208],
            [31.19215763525403, 3.216667983280625],
            [31.1888944016782, 3.213214721498553],
            [31.18889338298869, 3.212547260411216],
            [31.189435918707908, 3.212242975955019],
            [31.191426996805895, 3.212300361656364],
            [31.191848674085115, 3.211874920625543],
            [31.191482698641718, 3.209266362054944],
            [31.189188120233396, 3.207995921941491],
            [31.188944014733025, 3.206175983601088],
            [31.190270681778937, 3.205749040387778],
            [31.19093220295079, 3.204352353925273],
            [31.192438559104634, 3.203075605108265],
            [31.194429714457744, 3.203193662924878],
            [31.195092718748146, 3.202767807318773],
            [31.195632826321138, 3.20088588383445],
            [31.196596645857472, 3.199913425189037],
            [31.198067646118357, 3.195269074783882],
            [31.201138677952642, 3.191441199659874],
            [31.201797876081173, 3.189736600525081],
            [31.2063232093935, 3.189257739199666],
            [31.214568531874395, 3.186898648823676],
            [31.218326469473823, 3.184975786484019],
            [31.219728814192507, 3.183863852932702],
            [31.220732048210223, 3.184063881464088],
            [31.223688903273562, 3.182949298295591],
            [31.225892786872492, 3.181331647034378],
            [31.227444445964426, 3.179513354841927],
            [31.226790884764313, 3.178455348900936],
            [31.226789690004974, 3.177698842711836],
            [31.227942320142677, 3.177242954354436],
            [31.228139643179674, 3.175174801736583],
            [31.22773883825608, 3.159566026402173],
            [31.228184298432417, 3.155883549565695],
            [31.227779528345206, 3.153614686679473],
            [31.22799742549713, 3.148747390782809],
            [31.227688601770467, 3.143754915257558],
            [31.228787667164376, 3.141180853181484],
            [31.229638500197513, 3.140170688234908],
            [31.230686673335658, 3.137142798610973],
            [31.23108256716955, 3.133863860241112],
            [31.230900302591667, 3.130568619845855],
            [31.23174584634443, 3.128435462924464],
            [31.236666581213907, 3.12149567695245],
            [31.240885081466242, 3.119007999885488],
            [31.243383814599316, 3.118392038595288],
            [31.245962003719228, 3.117948369931489],
            [31.24757265427759, 3.118452619174067],
            [31.251176524517557, 3.118090612984006],
            [31.25429644716117, 3.119610920460454],
            [31.2567721798297, 3.120026289483809],
            [31.259394768182553, 3.12280113275844],
            [31.25997604734164, 3.122888677237482],
            [31.265171716993713, 3.119282701379337],
            [31.26751939931008, 3.119005213851346],
            [31.2684868758879, 3.119959169087017],
            [31.272230675801374, 3.121891719751122],
            [31.274166070029885, 3.123539896204521],
            [31.275587052095748, 3.123715398540147],
            [31.278143318729498, 3.123113282221543],
            [31.279979954870605, 3.121395970170994],
            [31.281936043588285, 3.121399184956464],
            [31.2831602973019, 3.12035670414822],
            [31.285212613552826, 3.117564514787575],
            [31.28723467813823, 3.11609423649943],
            [31.2890987892523, 3.116882140678084],
            [31.290531103565513, 3.11642664550377],
            [31.29267730274676, 3.117149602254805],
            [31.297864119501735, 3.115435711441013],
            [31.301224866099954, 3.116247832966363],
            [31.302288127341587, 3.115987933659232],
            [31.303089560220645, 3.116686889145413],
            [31.304607243231924, 3.117103583275258],
            [31.305342524173422, 3.118478287298251],
            [31.30631839820254, 3.118610677796681],
            [31.307121548660415, 3.118241345982621],
            [31.309484759254776, 3.118921023771427],
            [31.310371990226574, 3.12023056674195],
            [31.311131133117012, 3.120253595000209],
            [31.3128649013783, 3.121193874601406],
            [31.317932368862934, 3.126347295889737],
            [31.318777832665617, 3.126653886622127],
            [31.318819266559778, 3.127874860514593],
            [31.3200974416483, 3.128879809755858],
            [31.320248409820003, 3.129425102047361],
            [31.321029914472785, 3.129033924599069],
            [31.32235196148315, 3.129733714559317],
            [31.322415926022973, 3.130431481373982],
            [31.324192101952207, 3.132004083364184],
            [31.32443698629189, 3.133593980202928],
            [31.325485866404158, 3.134719832086794],
            [31.326163068567617, 3.135129709252226],
            [31.32867199129093, 3.134588689514641],
            [31.329009510801075, 3.135474938904005],
            [31.331109832122454, 3.136125559843431],
            [31.33513686725177, 3.140049577123866],
            [31.336153169960255, 3.140357798115196],
            [31.338823705891382, 3.144790634784608],
            [31.338889278415547, 3.146187440365202],
            [31.340107870047923, 3.14717730127087],
            [31.341189595261927, 3.148984526110792],
            [31.343133140803303, 3.155192832782867],
            [31.344441763390076, 3.157308639085588],
            [31.34916502969549, 3.159662610845111],
            [31.349696249337068, 3.160440864191155],
            [31.353290032394728, 3.16213196957401],
            [31.35469934803999, 3.161591242811667],
            [31.357745868443406, 3.162817787997416],
            [31.359334874993298, 3.161784720758585],
            [31.360761188560403, 3.15935141500402],
            [31.362363014069377, 3.159082467217927],
            [31.362459718608015, 3.160638206408192],
            [31.364334745151115, 3.162231086757747],
            [31.365839034281507, 3.166979214357898],
            [31.367544213658867, 3.169378417538445],
            [31.369806194002148, 3.174533764793547],
            [31.368936696672346, 3.174657201228362],
            [31.368873428326907, 3.175405991511655],
            [31.369462232673122, 3.176093408446159],
            [31.369085653516148, 3.178651518081227],
            [31.369359378268054, 3.182271589816311],
            [31.370754664923542, 3.183428345529661],
            [31.372210625589954, 3.18549010982252],
            [31.373979659014363, 3.185898566832105],
            [31.373694643337643, 3.189455351266829],
            [31.37220507579812, 3.189016129376018],
            [31.37217339131973, 3.189421729180265],
            [31.37248086218362, 3.191325650078778],
            [31.37387724208881, 3.191795927796439],
            [31.37365730845611, 3.19344938111914],
            [31.374713450549145, 3.193107817657609],
            [31.37530521125097, 3.191923012634136],
            [31.377073718262615, 3.192674713432173],
            [31.377571844867415, 3.19180179545863],
            [31.37797540851726, 3.191833640665372],
            [31.37924672407028, 3.192865384468847],
            [31.38101783170465, 3.191963277240452],
            [31.38173118297344, 3.192432464906943],
            [31.38319103783663, 3.192029122945496],
            [31.385021944522855, 3.192593688276368],
            [31.384155257123247, 3.190907303962646],
            [31.384280373577717, 3.190314626342994],
            [31.385709908503408, 3.189443170144455],
            [31.386054105191047, 3.187727491566452],
            [31.38487772539388, 3.185541358451527],
            [31.383544164676483, 3.184603135373289],
            [31.38457178256431, 3.18263890503848],
            [31.386560731655084, 3.18139387520069],
            [31.388299699365234, 3.181178179456926],
            [31.388643010313995, 3.180024169417973],
            [31.389450037002312, 3.180150251145316],
            [31.392215055040097, 3.178968831479509],
            [31.394885963772083, 3.17841133548156],
            [31.395290637739578, 3.177725477168085],
            [31.396300327050938, 3.177419682714615],
            [31.398270866966623, 3.178083266779714],
            [31.401148225618883, 3.177959228911909],
            [31.40214663837848, 3.180081385607348],
            [31.405619140787945, 3.181007856726224],
            [31.406530897563663, 3.18405095223951],
            [31.40882676325779, 3.184046185064397],
            [31.40978477698242, 3.186459607020353],
            [31.409676254207902, 3.187150892200382],
            [31.41119898305611, 3.189438437077436],
            [31.41130134248948, 3.190989127512423],
            [31.410727711586706, 3.192969821925695],
            [31.40989526527079, 3.195102545662474],
            [31.4093620585558, 3.195082572175701],
            [31.40883930373914, 3.194459632212874],
            [31.407772671120238, 3.194563254207846],
            [31.407702929514844, 3.195753221537385],
            [31.408835879361302, 3.196680138658615],
            [31.408253482697987, 3.197684202331802],
            [31.40736978929172, 3.1977404381057],
            [31.407629725802344, 3.200803426955672],
            [31.406019407620672, 3.201499605006426],
            [31.405132457821534, 3.20239790632027],
            [31.404361566763825, 3.202138277923103],
            [31.403962819880547, 3.202934696650535],
            [31.404282749479126, 3.203841817827424],
            [31.40364261449923, 3.205228630904436],
            [31.402318575923868, 3.205523259524831],
            [31.401488335870287, 3.206689633498252],
            [31.400422377886176, 3.206352968882082],
            [31.39922051827427, 3.207681466091358],
            [31.399492441904023, 3.20893701345895],
            [31.398360691308493, 3.209498624032948],
            [31.398044832874827, 3.210541378393815],
            [31.399175554001058, 3.212093680017742],
            [31.398849336195497, 3.213672400238796],
            [31.399637136241804, 3.216799962999985],
            [31.39853691112284, 3.218610602194077],
            [31.39668019583851, 3.218531099335111],
            [31.393210428799076, 3.220870525004295],
            [31.392220161962495, 3.220840239507359],
            [31.39009855685708, 3.21965963000703],
            [31.389536685799676, 3.219697021656473],
            [31.385207463696997, 3.223585552865108],
            [31.37679053604737, 3.223131826706227],
            [31.367383555360206, 3.221411757813486],
            [31.363937389758245, 3.222977292706805],
            [31.362918109134576, 3.222736298942259],
            [31.362637483524676, 3.223384714986161],
            [31.361738172907202, 3.223685639042095],
            [31.361164850126567, 3.223298075016495],
            [31.36059619768711, 3.223806531349212],
            [31.359896139687866, 3.222492063742633],
            [31.35836372340762, 3.222409799647268],
            [31.35597913560446, 3.220687554560493],
            [31.3543983234866, 3.220329038982507],
            [31.35342263091719, 3.219566459410226],
            [31.351931473359603, 3.220410949868727],
            [31.35221039037386, 3.221620401764344],
            [31.351624191141966, 3.221650133853483],
            [31.351167071731524, 3.221146151954528],
            [31.350249799299963, 3.222022256661198],
            [31.350553086709574, 3.223262432442985],
            [31.349453996162815, 3.223297464231574],
            [31.347517042458975, 3.224184175540672],
            [31.34708840233802, 3.224950604703838],
            [31.3457029477433, 3.224610804299923],
            [31.34505699168038, 3.223836483113399],
            [31.344537618122462, 3.22407497787222],
            [31.343359831563543, 3.22369255588701],
            [31.342772032432112, 3.224710338786916],
            [31.342917067231358, 3.225637267299233],
            [31.341560133248613, 3.22653718508593],
            [31.342388500314843, 3.228333671076413],
            [31.34152701865231, 3.231345070614347],
            [31.34075455644118, 3.237991121653817],
            [31.33773089456847, 3.242306082119664],
            [31.337729751911425, 3.243004750213675],
            [31.33664093539657, 3.245012822881776],
            [31.336999504230434, 3.247013716574501],
            [31.337604250079707, 3.247620165872944],
            [31.336462809357215, 3.249118407499813],
            [31.33568128134824, 3.249547798884023],
            [31.335974555237343, 3.250715924122956],
            [31.33472695341121, 3.250828704604784],
            [31.333398517582513, 3.254012522653901],
            [31.3322460257854, 3.253954236167404],
            [31.33289106646504, 3.255457923121471],
            [31.3307913712694, 3.258363948362111],
            [31.331336472577057, 3.259558748612333],
            [31.33074077545765, 3.260172741935891],
            [31.330331538048505, 3.260038068316042],
            [31.33005434849456, 3.26066927749091],
            [31.33045362089224, 3.26107191598051],
            [31.33023973561636, 3.262351017810322],
            [31.329232282211745, 3.262572490064098],
            [31.328247080975025, 3.265231518318099],
            [31.327284087888785, 3.265976426777518],
            [31.324732499681026, 3.265732884533288],
            [31.32376933052499, 3.2665830664475],
            [31.322731205941604, 3.266696172503355],
            [31.321646695950236, 3.266072254070765],
            [31.31934100628015, 3.266843607484524],
            [31.318024684233087, 3.269088149057935],
            [31.31802360535644, 3.269473296433306],
            [31.31914473966194, 3.270336592541141],
            [31.319166855285918, 3.271099433347549],
            [31.317609614961118, 3.271549486873275],
            [31.317218367213844, 3.272046503792],
            [31.31545790192062, 3.271344870233048],
            [31.316047401562887, 3.270434288458119],
            [31.315994046126583, 3.269613477259282],
            [31.314672761785886, 3.268223495831965],
            [31.311663925708636, 3.268093994553645],
            [31.309089590361275, 3.270070769949395],
            [31.308041496274907, 3.270451821023129],
            [31.30839229557987, 3.271361628799331],
            [31.30959248971522, 3.271133966620989],
            [31.31056304392123, 3.271566291175557],
            [31.31132610436457, 3.27316744832389],
            [31.31069264925716, 3.273777338310085],
            [31.310300194174125, 3.274992150423013],
            [31.308412085465562, 3.276587249275828],
            [31.308923363406173, 3.278329979770828],
            [31.308911073554746, 3.279976115370831],
            [31.305274623216054, 3.279319123312264],
            [31.305824290660322, 3.281680158259915],
            [31.30534025143577, 3.282722687448169],
            [31.30629469974705, 3.283686851431045],
            [31.30629394246726, 3.283955450610313],
            [31.30555584800225, 3.28391246954481],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 595,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "ODUPI",
        Population: 38711,
        Key: "ARUAODUPI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.201797876081173, 3.189736600525081],
            [31.206227219015524, 3.184527297413789],
            [31.20626438770869, 3.18126449561034],
            [31.20699145804852, 3.180030310711554],
            [31.206270515117264, 3.177955104810173],
            [31.205094577291202, 3.178431858215161],
            [31.204743728578897, 3.179293098699146],
            [31.204820585739665, 3.180761576438809],
            [31.203962684761862, 3.180983519395508],
            [31.203028287746022, 3.179529501420153],
            [31.20285712185348, 3.177502249997501],
            [31.202238692865816, 3.176990440369244],
            [31.201602920104932, 3.177324492867761],
            [31.197273362032366, 3.174076983483192],
            [31.197274912524524, 3.173183215677931],
            [31.19811817006491, 3.172243042178739],
            [31.196914026037252, 3.170676831597989],
            [31.195199328111116, 3.170498265150731],
            [31.194801143573223, 3.171183854695776],
            [31.194388271580458, 3.171183129968489],
            [31.193104322121258, 3.169856183062332],
            [31.191295351395958, 3.16910287983425],
            [31.187521040203873, 3.166207464279581],
            [31.186616436712768, 3.165902631531598],
            [31.186408724659508, 3.166636430358166],
            [31.185233918710725, 3.166474761634929],
            [31.184995029727194, 3.16687334364421],
            [31.185691670535082, 3.1680556175734],
            [31.185769202330636, 3.169125080930233],
            [31.18436876653195, 3.170862262296088],
            [31.181811654583502, 3.171145028866039],
            [31.180506739343915, 3.172738728104715],
            [31.17953811561747, 3.172721053934221],
            [31.179221782873306, 3.172002292120233],
            [31.178076945620727, 3.172862108246827],
            [31.177013687972313, 3.172477183537717],
            [31.176821594028592, 3.173354643830268],
            [31.17526296041679, 3.174740399278574],
            [31.173053851317842, 3.175789835219006],
            [31.17266909030525, 3.177863948524465],
            [31.171158336898078, 3.179106135759446],
            [31.169760569994107, 3.179311124354717],
            [31.169203318073908, 3.180140048544711],
            [31.166898976775066, 3.181157369760061],
            [31.165835027423928, 3.182512490854559],
            [31.157170436945425, 3.180197685388677],
            [31.14890347135436, 3.178997680430354],
            [31.14253262295264, 3.17885833381946],
            [31.141983454971694, 3.180459024396342],
            [31.142089072594597, 3.181402125170501],
            [31.143913798871655, 3.182132814095474],
            [31.14594993376937, 3.184854494941672],
            [31.145847837542384, 3.186269569819758],
            [31.146682367949765, 3.186844651183801],
            [31.146630965450882, 3.187316366928846],
            [31.145172833556423, 3.187842770680469],
            [31.144498441323186, 3.189835210091165],
            [31.143092404528698, 3.190361526448852],
            [31.142625887842094, 3.191986799009752],
            [31.141844782939586, 3.192302483973296],
            [31.141065556414382, 3.193875848707191],
            [31.14169221217343, 3.194818108428839],
            [31.140861262450777, 3.196653579137156],
            [31.141384400848064, 3.198067626044977],
            [31.142920943090406, 3.199859208489372],
            [31.14247955407891, 3.200443715987083],
            [31.14236282878753, 3.202156611715966],
            [31.141651480761837, 3.202783455745374],
            [31.140004063057205, 3.202623414314387],
            [31.13788542778213, 3.203832995808468],
            [31.135995532324475, 3.204229262778395],
            [31.1350980084561, 3.203772732340366],
            [31.135031399276116, 3.203256740039239],
            [31.134264368279176, 3.203255335475456],
            [31.133086788332786, 3.202496560412049],
            [31.131750578483643, 3.203050869174522],
            [31.130000864227753, 3.204475240561723],
            [31.130035561655603, 3.204845904977199],
            [31.129045805062077, 3.205004694870946],
            [31.127796522488033, 3.205845144242903],
            [31.12518669739874, 3.202705118537278],
            [31.122790425208674, 3.203075761170938],
            [31.117253350832847, 3.200640237943965],
            [31.11091032505214, 3.197082941539274],
            [31.11017915839461, 3.196120670966081],
            [31.11025574875574, 3.186231514120782],
            [31.10958354122524, 3.186328077236479],
            [31.108721040873206, 3.1858685305432],
            [31.108024824968446, 3.186276994578026],
            [31.10668212119809, 3.186129895917057],
            [31.10438090783307, 3.185571275458679],
            [31.097031874935343, 3.178326847039838],
            [31.08366683985121, 3.169384064680699],
            [31.083188111466633, 3.168901124482242],
            [31.084147611004763, 3.168758293684694],
            [31.08513260113736, 3.167796025363437],
            [31.08310194955617, 3.163598414089892],
            [31.082587251729276, 3.163234967807163],
            [31.07686703961312, 3.162472497447447],
            [31.07691978060178, 3.160959746371208],
            [31.07519767247288, 3.158522194311717],
            [31.075103882967323, 3.157365105782221],
            [31.07460029280894, 3.157364168467736],
            [31.0739270171816, 3.158351110824711],
            [31.073255743000686, 3.158253449021706],
            [31.071934324811018, 3.159600715933684],
            [31.0688391516518, 3.160510821726608],
            [31.067529559782823, 3.162891787015227],
            [31.06370357749559, 3.15770163212576],
            [31.062851307158, 3.158611931531046],
            [31.05968729969182, 3.152422210466262],
            [31.059073042480314, 3.152643297522049],
            [31.058506350164794, 3.152357181159331],
            [31.0566477960291, 3.153532780342482],
            [31.056386908202587, 3.155177830337842],
            [31.049375993991262, 3.154089206210453],
            [31.048207045956445, 3.149705635065397],
            [31.053010688123592, 3.145622153673638],
            [31.053610203082968, 3.14410833222873],
            [31.05375706325888, 3.142001986300104],
            [31.053069075922107, 3.142527440763251],
            [31.051693736357503, 3.142308806553241],
            [31.05063939358999, 3.142868570638347],
            [31.04986586148538, 3.142694274343246],
            [31.048984972619454, 3.142454958857652],
            [31.046023087888834, 3.14000797401929],
            [31.04682136498629, 3.138432276068178],
            [31.048027177185418, 3.137332660037127],
            [31.048392846303273, 3.1372037135728],
            [31.049466270185732, 3.137940314138633],
            [31.050951927358824, 3.136625162116407],
            [31.052047771394143, 3.136864876295048],
            [31.05294150437197, 3.137557927475519],
            [31.052459166556584, 3.134810470120577],
            [31.048864870560916, 3.130266712467718],
            [31.047895312586554, 3.127410619195492],
            [31.048196064052096, 3.125217220103837],
            [31.048919868117544, 3.123450624194758],
            [31.052346640889162, 3.119937491679912],
            [31.05424390882037, 3.120618138011004],
            [31.059189551277733, 3.120458048919876],
            [31.059466057213747, 3.120228444478879],
            [31.059377631548763, 3.118088485334713],
            [31.060251042838242, 3.117705377431001],
            [31.060540363241824, 3.118567700557064],
            [31.060993937900147, 3.118568408278217],
            [31.061031743498855, 3.117783769493123],
            [31.061460610893608, 3.11769222941454],
            [31.063494726378547, 3.118896345032128],
            [31.06649440952137, 3.119563622489264],
            [31.067015424301317, 3.119318360094657],
            [31.06776874161714, 3.117626947689599],
            [31.06972800498103, 3.117907566957706],
            [31.072638248260905, 3.117251196697694],
            [31.07339936834325, 3.116212752703519],
            [31.07184498645768, 3.113550589780988],
            [31.07153518177069, 3.109762586654955],
            [31.07073052483812, 3.108099685104196],
            [31.071279006506188, 3.106031171245898],
            [31.07012809574396, 3.104783314135333],
            [31.06805691397376, 3.104324676935178],
            [31.064871741301175, 3.100919559293563],
            [31.062737317236646, 3.095960381064741],
            [31.060480777090717, 3.092676671529335],
            [31.060770485566472, 3.090522748435632],
            [31.06256422894938, 3.086360756799353],
            [31.06307994277085, 3.083946737900937],
            [31.065548514968246, 3.082320621009698],
            [31.06762190389908, 3.081534437588164],
            [31.07109908114131, 3.081492899450651],
            [31.073792413619415, 3.080300876117716],
            [31.076696814256668, 3.080928554889689],
            [31.078078431248493, 3.080763492110974],
            [31.081291977209304, 3.08165505040144],
            [31.083769643950646, 3.081204702395306],
            [31.08467606114032, 3.080416362616915],
            [31.086633058953066, 3.080286952613535],
            [31.08758595856878, 3.080487113957445],
            [31.08869041385441, 3.081443496271399],
            [31.090047526601907, 3.083710662540702],
            [31.0917876477489, 3.090642033552952],
            [31.09981379567351, 3.093352207251734],
            [31.102990827812995, 3.093631590617019],
            [31.10445130251369, 3.093168109233683],
            [31.109365614428917, 3.093664360942094],
            [31.1116711406056, 3.093105827376823],
            [31.11448072136966, 3.094311552453432],
            [31.11473210412215, 3.094765018273952],
            [31.115815484032908, 3.094877492851442],
            [31.11654116737392, 3.094485465673356],
            [31.117754459844416, 3.092716802722734],
            [31.120523240924935, 3.092100692443258],
            [31.123296063525903, 3.094134566063382],
            [31.125459249849197, 3.095082265639195],
            [31.127349006966305, 3.093924001125475],
            [31.12984883065412, 3.094123687177941],
            [31.130185670139593, 3.093511588230899],
            [31.13160327454, 3.092829743064081],
            [31.13431003952654, 3.095815000897017],
            [31.13667550399395, 3.096490550765016],
            [31.140322838320614, 3.096076758380084],
            [31.143566320638296, 3.096614936470497],
            [31.144240196340267, 3.095526609490721],
            [31.144645425466596, 3.095457989537969],
            [31.14775516390982, 3.096879711275294],
            [31.149578428627937, 3.096401008261224],
            [31.150117707954234, 3.095652646694546],
            [31.152076183495637, 3.095241659813269],
            [31.153425603071025, 3.094152189534626],
            [31.153625634528602, 3.092453101492398],
            [31.155311349210425, 3.090411761533978],
            [31.15571709576635, 3.090682873460151],
            [31.15652733662678, 3.090409709177659],
            [31.15821208921291, 3.087756808404186],
            [31.15915701089057, 3.087211608497872],
            [31.161699803693384, 3.086817079412319],
            [31.162242751739296, 3.086421615493561],
            [31.163892071177383, 3.087663255523045],
            [31.165666766682993, 3.087666337653507],
            [31.16832664500159, 3.088934505302528],
            [31.16948793220369, 3.087301329385674],
            [31.170620367315475, 3.08812088541829],
            [31.17096655107652, 3.087477318541867],
            [31.17651516431216, 3.085926038540538],
            [31.176625383105936, 3.08431714196316],
            [31.178716624256424, 3.082093593487943],
            [31.17843830013028, 3.081178811803683],
            [31.178952533528143, 3.080523272721982],
            [31.17990725582557, 3.081427497086044],
            [31.181002896841644, 3.081757590119341],
            [31.182520473851703, 3.080845891193515],
            [31.185388104647764, 3.081530675501507],
            [31.185810928177283, 3.07976139626014],
            [31.187312710109705, 3.081287814571876],
            [31.188024058135397, 3.081300751344789],
            [31.188763132662373, 3.078711474913238],
            [31.19088604301991, 3.078433774918242],
            [31.190557552476694, 3.079593683509343],
            [31.19277340702511, 3.079527133742003],
            [31.193042460537537, 3.079035271718907],
            [31.192554367216115, 3.078026352410091],
            [31.194466753793535, 3.078270364959089],
            [31.196788621223583, 3.077957047798351],
            [31.197393323953726, 3.078786621758582],
            [31.197975998196448, 3.078300232107023],
            [31.19976996436156, 3.078352018811717],
            [31.200860042111074, 3.07888998880387],
            [31.202848290515913, 3.078747146656913],
            [31.203699363399245, 3.077237707086424],
            [31.205518150015664, 3.076948357105737],
            [31.206392725521756, 3.075877596083564],
            [31.208404242089106, 3.076319639032667],
            [31.208938017437696, 3.076076848676632],
            [31.20891544187627, 3.07507767540032],
            [31.21073740044394, 3.072887524462276],
            [31.210254674556374, 3.071595145840347],
            [31.212077067010306, 3.069136926584053],
            [31.216585907254057, 3.069461298598569],
            [31.222406355186237, 3.0683256893337],
            [31.22395688509585, 3.068986252086404],
            [31.225457034789414, 3.070792089534292],
            [31.226859126183182, 3.073255736456695],
            [31.2270752293995, 3.074523305020259],
            [31.229984534838245, 3.074528161498795],
            [31.234467835080117, 3.075680995048243],
            [31.235753226335316, 3.075415068568121],
            [31.237545024865636, 3.076807108703667],
            [31.237788228457454, 3.076344491889379],
            [31.238029550078753, 3.07702723837037],
            [31.238708273089998, 3.077101474859089],
            [31.239412841530267, 3.076200971253474],
            [31.24120384684818, 3.078080399616668],
            [31.242662073065738, 3.075913924541554],
            [31.24443283574706, 3.075356355817279],
            [31.244968127451813, 3.074187498403293],
            [31.246472596245255, 3.07338578599427],
            [31.247780123785702, 3.074411472351594],
            [31.248553877774228, 3.075679970649929],
            [31.252042410619925, 3.078365215755774],
            [31.251848198448744, 3.07939576274884],
            [31.247302344022053, 3.086143368539278],
            [31.246405968200637, 3.086686473573728],
            [31.245867173066273, 3.087706734551648],
            [31.245949668053758, 3.096812336451018],
            [31.249909351096324, 3.099007514217277],
            [31.253720046752377, 3.098839749789858],
            [31.261232907205102, 3.09426776961058],
            [31.266546662197925, 3.092883778753855],
            [31.27527102298217, 3.08883590773979],
            [31.277929394826074, 3.087215374152436],
            [31.2831175042567, 3.078587847783186],
            [31.28677099473804, 3.074670918994002],
            [31.28886391843306, 3.073725636642989],
            [31.293735334895153, 3.073759116229483],
            [31.298121231709075, 3.07438151090734],
            [31.3017402798841, 3.076079521799088],
            [31.30364968046154, 3.078287592210994],
            [31.30484480270881, 3.080529577855964],
            [31.3117840106992, 3.080600377627948],
            [31.31231458624872, 3.083562482009495],
            [31.313320748774277, 3.085653096390718],
            [31.317668421374574, 3.089296935899847],
            [31.31799089320537, 3.091591837042575],
            [31.318740908314165, 3.093181453999882],
            [31.32242329490323, 3.096338953536373],
            [31.32340074278073, 3.096869985067414],
            [31.324505000437004, 3.096518757943829],
            [31.326787579149755, 3.096572811385581],
            [31.328918389291896, 3.097433439400526],
            [31.33233059588118, 3.096959794838559],
            [31.334060621760987, 3.09746679535089],
            [31.335465422473675, 3.097418590413949],
            [31.336049994856594, 3.097618976366906],
            [31.336843592629734, 3.09887646496729],
            [31.339268115038852, 3.099555695071496],
            [31.340315034128857, 3.100825788706235],
            [31.341658630824593, 3.101025585582065],
            [31.342165560919184, 3.101751209800432],
            [31.34388531366542, 3.102462269850655],
            [31.34540994065383, 3.102184622714671],
            [31.34763645640804, 3.103736616247665],
            [31.349137864641303, 3.105575646266832],
            [31.345267662784178, 3.11384170490711],
            [31.338699207477855, 3.114439930913631],
            [31.33841922506167, 3.11476720428596],
            [31.339906489320768, 3.116829497441974],
            [31.34441048045862, 3.125825453507721],
            [31.345846482356055, 3.130883947668615],
            [31.345328963819174, 3.134160303127857],
            [31.347365847013535, 3.142169222701273],
            [31.349458679080385, 3.144232493439889],
            [31.34973660884613, 3.145216090921233],
            [31.348056054985673, 3.147554259594504],
            [31.347681570699898, 3.148724085094362],
            [31.347630334389347, 3.151673465471106],
            [31.347860054268768, 3.153686957024202],
            [31.35107008152861, 3.156220190302142],
            [31.349696249337068, 3.160440864191155],
            [31.34916502969549, 3.159662610845111],
            [31.344441763390076, 3.157308639085588],
            [31.343133140803303, 3.155192832782867],
            [31.341189595261927, 3.148984526110792],
            [31.340107870047923, 3.14717730127087],
            [31.338889278415547, 3.146187440365202],
            [31.338823705891382, 3.144790634784608],
            [31.336153169960255, 3.140357798115196],
            [31.33513686725177, 3.140049577123866],
            [31.331109832122454, 3.136125559843431],
            [31.329009510801075, 3.135474938904005],
            [31.32867199129093, 3.134588689514641],
            [31.326163068567617, 3.135129709252226],
            [31.325485866404158, 3.134719832086794],
            [31.32443698629189, 3.133593980202928],
            [31.324192101952207, 3.132004083364184],
            [31.322415926022973, 3.130431481373982],
            [31.32235196148315, 3.129733714559317],
            [31.321029914472785, 3.129033924599069],
            [31.320248409820003, 3.129425102047361],
            [31.3200974416483, 3.128879809755858],
            [31.318819266559778, 3.127874860514593],
            [31.318777832665617, 3.126653886622127],
            [31.317932368862934, 3.126347295889737],
            [31.3128649013783, 3.121193874601406],
            [31.311131133117012, 3.120253595000209],
            [31.310371990226574, 3.12023056674195],
            [31.309484759254776, 3.118921023771427],
            [31.307121548660415, 3.118241345982621],
            [31.30631839820254, 3.118610677796681],
            [31.305342524173422, 3.118478287298251],
            [31.304607243231924, 3.117103583275258],
            [31.303089560220645, 3.116686889145413],
            [31.302288127341587, 3.115987933659232],
            [31.301224866099954, 3.116247832966363],
            [31.297864119501735, 3.115435711441013],
            [31.29267730274676, 3.117149602254805],
            [31.290531103565513, 3.11642664550377],
            [31.2890987892523, 3.116882140678084],
            [31.28723467813823, 3.11609423649943],
            [31.285212613552826, 3.117564514787575],
            [31.2831602973019, 3.12035670414822],
            [31.281936043588285, 3.121399184956464],
            [31.279979954870605, 3.121395970170994],
            [31.278143318729498, 3.123113282221543],
            [31.275587052095748, 3.123715398540147],
            [31.274166070029885, 3.123539896204521],
            [31.272230675801374, 3.121891719751122],
            [31.2684868758879, 3.119959169087017],
            [31.26751939931008, 3.119005213851346],
            [31.265171716993713, 3.119282701379337],
            [31.25997604734164, 3.122888677237482],
            [31.259394768182553, 3.12280113275844],
            [31.2567721798297, 3.120026289483809],
            [31.25429644716117, 3.119610920460454],
            [31.251176524517557, 3.118090612984006],
            [31.24757265427759, 3.118452619174067],
            [31.245962003719228, 3.117948369931489],
            [31.243383814599316, 3.118392038595288],
            [31.240885081466242, 3.119007999885488],
            [31.236666581213907, 3.12149567695245],
            [31.23174584634443, 3.128435462924464],
            [31.230900302591667, 3.130568619845855],
            [31.23108256716955, 3.133863860241112],
            [31.230686673335658, 3.137142798610973],
            [31.229638500197513, 3.140170688234908],
            [31.228787667164376, 3.141180853181484],
            [31.227688601770467, 3.143754915257558],
            [31.22799742549713, 3.148747390782809],
            [31.227779528345206, 3.153614686679473],
            [31.228184298432417, 3.155883549565695],
            [31.22773883825608, 3.159566026402173],
            [31.228139643179674, 3.175174801736583],
            [31.227942320142677, 3.177242954354436],
            [31.226789690004974, 3.177698842711836],
            [31.226790884764313, 3.178455348900936],
            [31.227444445964426, 3.179513354841927],
            [31.225892786872492, 3.181331647034378],
            [31.223688903273562, 3.182949298295591],
            [31.220732048210223, 3.184063881464088],
            [31.219728814192507, 3.183863852932702],
            [31.218326469473823, 3.184975786484019],
            [31.214568531874395, 3.186898648823676],
            [31.2063232093935, 3.189257739199666],
            [31.201797876081173, 3.189736600525081],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 596,
        District: "ARUA",
        County: "TEREGO",
        Subcounty: "URIAMA",
        Population: 23421,
        Key: "ARUAURIAMA",
        Dist2: "Koboko",
        "Sub Country": "Uriama",
        id2_original: "Koboko Uriama",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.12457108912107, 3.014962231600287],
            [31.12370013472384, 3.014935008159995],
            [31.12265528445396, 3.015647696556381],
            [31.12143883710019, 3.015099993123947],
            [31.119821948640517, 3.017586202217894],
            [31.118890145959234, 3.018279737347742],
            [31.116020112169803, 3.017843832532047],
            [31.115588794170968, 3.019218994334943],
            [31.115676961121157, 3.021370531707817],
            [31.11533821181739, 3.021683912003231],
            [31.114028295656624, 3.021619773553799],
            [31.111275424638098, 3.023809284293928],
            [31.109502409880353, 3.022864387840043],
            [31.106794162673605, 3.023451887434878],
            [31.106227572766013, 3.022675584275324],
            [31.10615101923583, 3.018879460189522],
            [31.104312610718686, 3.018294872698004],
            [31.102814469658096, 3.015335282460234],
            [31.100211471764947, 3.013889417443914],
            [31.09599351679001, 3.013133459356655],
            [31.095428636376436, 3.013456684713093],
            [31.0944984470694, 3.01520231850567],
            [31.09400832355544, 3.01511783588093],
            [31.091888449503568, 3.012254081296846],
            [31.092456350053123, 3.010836057404443],
            [31.090203049232098, 3.010043629267772],
            [31.088089184909506, 3.008009244879143],
            [31.086859940156184, 3.008300404829404],
            [31.083786633787614, 3.007357675698486],
            [31.08182681795981, 3.004379905109051],
            [31.080140436728076, 3.004581772441516],
            [31.077142498113524, 3.003610472546876],
            [31.076887441251532, 3.003193836555677],
            [31.07724449103427, 3.002529744822354],
            [31.07642817486761, 3.00172068053226],
            [31.07611528267099, 3.000451066371337],
            [31.074439080249736, 3.00113632156198],
            [31.072834223824955, 2.999186400849966],
            [31.071720970439454, 2.998681228037611],
            [31.070273059576298, 2.9988827662956],
            [31.069461904230927, 2.999879780828545],
            [31.068410310308195, 3.000342667244513],
            [31.065865181885666, 2.998428942516105],
            [31.062463071461863, 2.998188285857903],
            [31.061794768907944, 2.997204212946768],
            [31.057361922543986, 2.99743687588568],
            [31.05714199789445, 2.996887409506257],
            [31.057940645996105, 2.996077799200792],
            [31.056800910276003, 2.995300164102677],
            [31.05408597241701, 2.994969986318861],
            [31.05328608104697, 2.995389032330331],
            [31.05108574399678, 2.995130343531663],
            [31.051059817719384, 2.994302270735737],
            [31.049766934514693, 2.99412396265111],
            [31.049174306938628, 2.994698592853642],
            [31.048294874241762, 2.994492988219265],
            [31.047030667057577, 2.995199859788621],
            [31.0450898883273, 2.994476732972078],
            [31.04342277865333, 2.994468804502099],
            [31.042231297277922, 2.993665274674301],
            [31.040499781991393, 2.993722630978535],
            [31.040678042778048, 2.992888898274765],
            [31.039384169629912, 2.992398131622759],
            [31.036367850586345, 2.994802752002641],
            [31.036061023814536, 2.995845166473967],
            [31.0372810725143, 2.997100490907415],
            [31.03231341234931, 2.997112114457833],
            [31.032755018753104, 2.998811372673404],
            [31.03017764081187, 2.99908626913244],
            [31.029796691351024, 3.000069980619534],
            [31.029701470829224, 3.002705946085435],
            [31.02742120437999, 3.002766629192448],
            [31.027246160460344, 3.004113311567501],
            [31.026383406783392, 3.004941078205551],
            [31.02308222477671, 3.004248278262107],
            [31.01833092474624, 3.004662000133952],
            [31.01791927715718, 3.004050016235888],
            [31.019463065210573, 3.004019040033726],
            [31.019703213632134, 3.003591223875184],
            [31.017094160195647, 3.001600768369969],
            [31.01508335778895, 3.001888959789218],
            [31.014204855746748, 3.00164816753604],
            [31.01297344785022, 3.002205798560987],
            [31.01174833175396, 3.00222913884966],
            [31.009834849231844, 3.001277631002137],
            [31.00823141394187, 2.999271308132774],
            [31.00377718138595, 2.999399549981775],
            [31.003195565358638, 2.998773591034615],
            [31.004043968448933, 2.99781765844285],
            [31.002500955641597, 2.996089982544582],
            [31.00094914203943, 2.99706009420213],
            [30.993190299505695, 2.992807365349791],
            [30.991530884800465, 2.992801096484358],
            [30.989992791167634, 2.990954393744801],
            [30.98844673935968, 2.991236187220314],
            [30.987131727954615, 2.990943579305658],
            [30.983306102298535, 2.988743060757546],
            [30.980904983697524, 2.988158697553586],
            [30.97953837036758, 2.986370169016045],
            [30.978221863267553, 2.986480242607865],
            [30.977282576721652, 2.985182317266745],
            [30.97476660222335, 2.984712566143755],
            [30.972825424641055, 2.983554662207372],
            [30.96952154319693, 2.979572755287958],
            [30.968208726376105, 2.978704869951307],
            [30.967293205659345, 2.978701402653698],
            [30.966085555507153, 2.980307589211639],
            [30.964710984900428, 2.980647539030526],
            [30.96151294475972, 2.978967115141236],
            [30.959859626022023, 2.977350077965033],
            [30.958717407358485, 2.976770478603999],
            [30.95705415505035, 2.977799639355743],
            [30.953838409115416, 2.980836346269307],
            [30.953160226889956, 2.978590215877146],
            [30.951960790034395, 2.978010392893117],
            [30.95127913492209, 2.976684677860057],
            [30.949157485799216, 2.977884671196167],
            [30.94795913500684, 2.977017209756001],
            [30.947158291422614, 2.976956630185585],
            [30.94634660337629, 2.979772335993678],
            [30.945255965078054, 2.98068861095918],
            [30.942456517310386, 2.980078341490942],
            [30.942639088213785, 2.976651780186991],
            [30.943217345440242, 2.97504324864936],
            [30.94335562311195, 2.968715860485754],
            [30.941941835653175, 2.964280951157912],
            [30.94172789917333, 2.96031081484105],
            [30.940829291038416, 2.955820337418873],
            [30.940893643650426, 2.953922216139742],
            [30.942593556205264, 2.950735952895949],
            [30.943230932458942, 2.948609890155067],
            [30.94531049640906, 2.945211107034761],
            [30.94817054362749, 2.946186124044712],
            [30.95075774913794, 2.94092582260769],
            [30.948937673439087, 2.93735630293059],
            [30.94877548351284, 2.934824509617581],
            [30.9479191725531, 2.934303537511744],
            [30.947241832947416, 2.931823735489142],
            [30.947360336004753, 2.930734769113964],
            [30.946789891426285, 2.930272403513989],
            [30.94669507424805, 2.924542482926344],
            [30.96009740828109, 2.923019785861578],
            [30.960197471620578, 2.922477964849219],
            [30.961755439580763, 2.921910042865797],
            [30.966536191776168, 2.921663139794906],
            [30.969716929466184, 2.920365261607071],
            [30.97147436114868, 2.921356835614314],
            [30.97248661155693, 2.920963452357439],
            [30.973227233881136, 2.921829139903032],
            [30.974832089407553, 2.921087300067487],
            [30.975176880779898, 2.92068589441528],
            [30.97444030536608, 2.918727197957526],
            [30.974787018234817, 2.917808062064459],
            [30.974684951652236, 2.914471077295424],
            [30.975035358393438, 2.913759938594724],
            [30.975722975624276, 2.913417480535923],
            [30.976114254812586, 2.913665398304682],
            [30.976803152142715, 2.912977903603302],
            [30.97602150286117, 2.912235618322093],
            [30.97734662031322, 2.911846248439537],
            [30.97764386475589, 2.911009420105273],
            [30.978183123420926, 2.91101142973496],
            [30.978136105598978, 2.910469056568382],
            [30.97936389687816, 2.90988215275341],
            [30.986575393214324, 2.908578223102413],
            [30.98800564499564, 2.906266873350901],
            [30.992034172226592, 2.903965194754885],
            [30.99277716340821, 2.901897722267357],
            [30.99553248862408, 2.899196944226198],
            [30.99592776711203, 2.898360459102724],
            [30.993448906509673, 2.8925348840423],
            [30.99257862674727, 2.885543406224684],
            [30.993456168490447, 2.879464274981863],
            [30.994387875950306, 2.877384339048255],
            [30.997022452320625, 2.875461220856201],
            [31.00065529233022, 2.874216621070712],
            [31.00607520213844, 2.871631847251324],
            [31.013034512628277, 2.864855143938551],
            [31.013012413173982, 2.862531906276319],
            [31.01391407019097, 2.861995334558658],
            [31.014164335439204, 2.860696352744004],
            [31.014073839157504, 2.860184303231967],
            [31.012430890571444, 2.859105156894115],
            [31.013250368807892, 2.857013078926161],
            [31.01300460232259, 2.855700108612972],
            [31.01574587339583, 2.855840776064732],
            [31.01902194299875, 2.854577016763276],
            [31.0216928858667, 2.854184073332926],
            [31.024259331310926, 2.85209628400224],
            [31.02666484986022, 2.852687072887036],
            [31.030734828951672, 2.852076065542648],
            [31.032485599626355, 2.851329847573084],
            [31.033840030004388, 2.850442403860865],
            [31.035134631686237, 2.848557976387201],
            [31.036156999819497, 2.845577517512892],
            [31.040279601321984, 2.843769690277904],
            [31.041601056342596, 2.84145779830201],
            [31.04153991880097, 2.840061957220508],
            [31.04261438023758, 2.838441598540527],
            [31.04508623218408, 2.838829727511555],
            [31.049470471606323, 2.838334651622342],
            [31.05790267600566, 2.834129749966174],
            [31.063323894659288, 2.832056254712001],
            [31.070395366998845, 2.830021242882788],
            [31.077253213675654, 2.829036903626151],
            [31.081532772417834, 2.829701453997761],
            [31.08705410741158, 2.831608990492162],
            [31.09023008403058, 2.833392724940575],
            [31.096437848682367, 2.838087531251077],
            [31.099614438850715, 2.842447434883494],
            [31.10234865006414, 2.847493236338761],
            [31.103892459677134, 2.852858757876782],
            [31.10415858108847, 2.857449121901845],
            [31.10408439372074, 2.861045983624724],
            [31.103059071926797, 2.866255934330252],
            [31.09985725616695, 2.87778621583316],
            [31.09623195392093, 2.887717191448124],
            [31.100651409098926, 2.895040889190556],
            [31.10412284520817, 2.902704700681543],
            [31.110155969283866, 2.911778634317234],
            [31.111877607593883, 2.911876864765906],
            [31.112901611559295, 2.912631801960933],
            [31.11455780670252, 2.91263459121526],
            [31.11534488719829, 2.913587342315558],
            [31.116056269359973, 2.912637113117465],
            [31.117595352037945, 2.911926130260544],
            [31.11882107629367, 2.909946045582451],
            [31.12016312070059, 2.909155437397118],
            [31.125133350945575, 2.908172684265403],
            [31.127733593705763, 2.9096041766937],
            [31.129226496689906, 2.912976331788533],
            [31.130486995628576, 2.913810943588356],
            [31.13080221895336, 2.916706978609883],
            [31.132329828348528, 2.918422936684494],
            [31.13159724864107, 2.919715507787816],
            [31.132306044553044, 2.922286800757866],
            [31.132930689882517, 2.923162032920772],
            [31.13273839920773, 2.923756158109566],
            [31.13334640773813, 2.924176784905638],
            [31.133602589290845, 2.927009578685814],
            [31.13440086279501, 2.928059940157381],
            [31.134465734633267, 2.930892415503074],
            [31.135786280558822, 2.931628946753739],
            [31.138644014615398, 2.934356962048128],
            [31.14623698772347, 2.946387949103862],
            [31.148545876294282, 2.948319276920841],
            [31.14972135687785, 2.949995846660803],
            [31.15067352077335, 2.95040068405018],
            [31.151759172523462, 2.951880663133609],
            [31.154930945026948, 2.954487536333806],
            [31.15516567391235, 2.95481312670219],
            [31.154782975431655, 2.955048994134986],
            [31.155310954850002, 2.955877649041678],
            [31.15572276862739, 2.955819210635962],
            [31.156221631850745, 2.956470438940352],
            [31.156751371967065, 2.956234816723396],
            [31.157776947984225, 2.958483346600389],
            [31.157921986376728, 2.959695687884763],
            [31.159537591143845, 2.960821795251233],
            [31.16056400439087, 2.962567751384515],
            [31.159796498185155, 2.964310711097314],
            [31.16017646219412, 2.965730390165891],
            [31.161233605010384, 2.966678187831948],
            [31.161673021321487, 2.967713644049611],
            [31.162408580740756, 2.967507928513212],
            [31.163670514288953, 2.969106464676116],
            [31.166314222932463, 2.970973381836441],
            [31.166400984019234, 2.971860431880594],
            [31.167014866633245, 2.972433327053067],
            [31.167521399672484, 2.971787470153203],
            [31.167888524959434, 2.97252865360588],
            [31.168803069207485, 2.972543942993754],
            [31.171147673895668, 2.974149367913368],
            [31.173673942188806, 2.97480027951287],
            [31.17739275995423, 2.976792776102858],
            [31.178263944320147, 2.977949058914398],
            [31.178626693015037, 2.980906034777549],
            [31.18173972198712, 2.988024992880657],
            [31.1815524870308, 2.990103382732634],
            [31.18063160876168, 2.991210488243962],
            [31.180630770633524, 2.991718612343744],
            [31.182246977271895, 2.994444374982105],
            [31.184242812847618, 2.995243824281801],
            [31.186515148071205, 2.995420678901687],
            [31.188132279075994, 2.996184880031905],
            [31.18926995765411, 2.995356033846513],
            [31.192886924432624, 2.994496686018802],
            [31.195571000670036, 2.995574175120981],
            [31.196949319048116, 2.994988015102244],
            [31.198188088638393, 2.995509279787399],
            [31.198772275644092, 2.996237146131099],
            [31.200460218147782, 2.995824564857462],
            [31.20414391987044, 2.996280631538059],
            [31.203867827159424, 2.996660935453184],
            [31.204416511846766, 2.998046415339835],
            [31.20417417153592, 2.998842146281926],
            [31.20127802641613, 3.001087292373398],
            [31.20003777280901, 3.001465997809397],
            [31.19869552448452, 3.001048402915329],
            [31.197113374775206, 2.999938124496837],
            [31.197252303725477, 2.999211456429322],
            [31.196977059024086, 2.999072541041775],
            [31.1961845086866, 2.999417371465626],
            [31.195871021805267, 3.001597547842519],
            [31.196282867921987, 3.002428971997371],
            [31.19435455870615, 3.002425771208137],
            [31.194666229193977, 3.001353248827457],
            [31.19439109857865, 3.001145104903964],
            [31.19332301967212, 3.001524087518566],
            [31.192664157513505, 3.00432673962732],
            [31.19176852998873, 3.004532932691568],
            [31.19108082023139, 3.003943347038183],
            [31.19008246137069, 3.003803227472332],
            [31.18729319331183, 3.00386780474701],
            [31.181952211281082, 3.00610878523857],
            [31.18126353313987, 3.006107631594762],
            [31.18047379273257, 3.004756365805622],
            [31.17930453657559, 3.003854442725447],
            [31.17665313476, 3.003849994997796],
            [31.170831418406618, 3.005293984083851],
            [31.16952449722901, 3.004357212558506],
            [31.167662076744318, 3.006153982776781],
            [31.166387395203902, 3.006532580600175],
            [31.16476687216061, 3.007810544865309],
            [31.16418378828611, 3.011056544129475],
            [31.162733144747857, 3.010659911279138],
            [31.158887974446152, 3.010755770959274],
            [31.15629263469079, 3.009599514699045],
            [31.152492063047987, 3.01224291003305],
            [31.151133407893173, 3.012185958384751],
            [31.148740813405887, 3.012892108915192],
            [31.14857887231297, 3.012236228625062],
            [31.149560586289756, 3.010216458106487],
            [31.148312480508743, 3.009067019954175],
            [31.14776898449046, 3.009066091479756],
            [31.14369524415293, 3.011329712429385],
            [31.142737701145478, 3.013877668482057],
            [31.13873680519434, 3.012930897478745],
            [31.13736546313276, 3.013464138493539],
            [31.136415157851552, 3.013253409722073],
            [31.134723973328008, 3.011769835208299],
            [31.133668111509333, 3.011559292700439],
            [31.133246908540617, 3.012197072236382],
            [31.13324959091005, 3.013895895206236],
            [31.13282822714289, 3.014427496797127],
            [31.129135401231885, 3.015389401888937],
            [31.128288151578396, 3.013585844394389],
            [31.12596634343719, 3.013802161865185],
            [31.12457108912107, 3.014962231600287],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 597,
        District: "ARUA",
        County: "VURRA",
        Subcounty: "AJIA",
        Population: 27296,
        Key: "ARUAAJIA",
        Dist2: "Koboko",
        "Sub Country": "Ajia",
        id2_original: "Koboko Ajia",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "#REF!",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.04261438023758, 2.838441598540527],
            [31.04153991880097, 2.840061957220508],
            [31.041601056342596, 2.84145779830201],
            [31.040279601321984, 2.843769690277904],
            [31.036156999819497, 2.845577517512892],
            [31.035134631686237, 2.848557976387201],
            [31.033840030004388, 2.850442403860865],
            [31.032485599626355, 2.851329847573084],
            [31.030734828951672, 2.852076065542648],
            [31.02666484986022, 2.852687072887036],
            [31.024259331310926, 2.85209628400224],
            [31.0216928858667, 2.854184073332926],
            [31.01902194299875, 2.854577016763276],
            [31.01574587339583, 2.855840776064732],
            [31.01300460232259, 2.855700108612972],
            [31.013250368807892, 2.857013078926161],
            [31.012430890571444, 2.859105156894115],
            [31.014073839157504, 2.860184303231967],
            [31.014164335439204, 2.860696352744004],
            [31.01391407019097, 2.861995334558658],
            [31.013012413173982, 2.862531906276319],
            [31.013034512628277, 2.864855143938551],
            [31.00607520213844, 2.871631847251324],
            [31.00065529233022, 2.874216621070712],
            [30.997022452320625, 2.875461220856201],
            [30.994387875950306, 2.877384339048255],
            [30.993456168490447, 2.879464274981863],
            [30.99257862674727, 2.885543406224684],
            [30.993448906509673, 2.8925348840423],
            [30.99592776711203, 2.898360459102724],
            [30.99553248862408, 2.899196944226198],
            [30.99277716340821, 2.901897722267357],
            [30.992034172226592, 2.903965194754885],
            [30.98800564499564, 2.906266873350901],
            [30.986575393214324, 2.908578223102413],
            [30.97936389687816, 2.90988215275341],
            [30.978136105598978, 2.910469056568382],
            [30.978183123420926, 2.91101142973496],
            [30.97764386475589, 2.911009420105273],
            [30.97734662031322, 2.911846248439537],
            [30.97602150286117, 2.912235618322093],
            [30.976803152142715, 2.912977903603302],
            [30.976114254812586, 2.913665398304682],
            [30.975722975624276, 2.913417480535923],
            [30.975035358393438, 2.913759938594724],
            [30.974684951652236, 2.914471077295424],
            [30.974787018234817, 2.917808062064459],
            [30.97444030536608, 2.918727197957526],
            [30.975176880779898, 2.92068589441528],
            [30.974832089407553, 2.921087300067487],
            [30.973227233881136, 2.921829139903032],
            [30.97248661155693, 2.920963452357439],
            [30.97147436114868, 2.921356835614314],
            [30.969716929466184, 2.920365261607071],
            [30.966536191776168, 2.921663139794906],
            [30.961755439580763, 2.921910042865797],
            [30.960197471620578, 2.922477964849219],
            [30.96009740828109, 2.923019785861578],
            [30.94669507424805, 2.924542482926344],
            [30.945537275204213, 2.922964910995536],
            [30.945351120022835, 2.920302566166065],
            [30.945651334295846, 2.918677128914289],
            [30.946536152392813, 2.918039700069721],
            [30.94678457699306, 2.917153422675392],
            [30.9458551494574, 2.916607725829853],
            [30.946004241048467, 2.916066100892852],
            [30.945466090006153, 2.915768337871113],
            [30.945083461594034, 2.913203825935471],
            [30.944448915033547, 2.912462080890486],
            [30.93888466302711, 2.910127872368905],
            [30.935104046560028, 2.907672026719553],
            [30.922258372457424, 2.908427502334483],
            [30.920788646007598, 2.908081364305435],
            [30.918683025524334, 2.906240940046922],
            [30.918421073194228, 2.904945680836466],
            [30.917736426692024, 2.904499484036531],
            [30.91695835090866, 2.902820716375139],
            [30.917155914694153, 2.902427157978068],
            [30.916038013425368, 2.899859896403687],
            [30.91609589277742, 2.897494244840644],
            [30.91510764804854, 2.89302986740669],
            [30.915903245471483, 2.890026249125565],
            [30.915858647710884, 2.888843153966556],
            [30.916894723237085, 2.887072660145884],
            [30.916473238197344, 2.88179715965981],
            [30.917806743219188, 2.879140590837634],
            [30.91742394592378, 2.876625402950399],
            [30.91767751248071, 2.874359066262681],
            [30.91921808636206, 2.868745931342821],
            [30.919373221818372, 2.86657779813757],
            [30.91747799216455, 2.858974411048777],
            [30.917721988070443, 2.856329327175352],
            [30.918720395440157, 2.855409220272535],
            [30.92251041636995, 2.854093351064076],
            [30.92546446329969, 2.852054433988614],
            [30.92882992964643, 2.847938011839505],
            [30.929433423244184, 2.843819286197846],
            [30.929296390637482, 2.841107861799868],
            [30.926902183674272, 2.835142723123898],
            [30.925983723669912, 2.829384903989434],
            [30.9262823335518, 2.826629397529589],
            [30.925652877744003, 2.822740276762096],
            [30.92648984707737, 2.820034949027036],
            [30.926152340143663, 2.817130653442769],
            [30.92420366073044, 2.813242789342491],
            [30.924618156877262, 2.807031516477331],
            [30.925010664960894, 2.806934403980396],
            [30.92506257949945, 2.806145966129655],
            [30.924377600620584, 2.805798394877438],
            [30.92335528997951, 2.803872308722274],
            [30.9230409829363, 2.801531017308958],
            [30.92620019429717, 2.796236141929646],
            [30.93003402875833, 2.792480658415083],
            [30.93233154016604, 2.790831724341847],
            [30.93505631727235, 2.789665660576857],
            [30.938867282423004, 2.789181651138154],
            [30.94217537427086, 2.787379497617348],
            [30.94296215293266, 2.787914659241085],
            [30.944726117163913, 2.787814446052044],
            [30.945286263455962, 2.787208380793119],
            [30.947134212979748, 2.787168262834494],
            [30.948287122493483, 2.786534490067177],
            [30.94993558853202, 2.786650914035631],
            [30.950388261281788, 2.786084031236443],
            [30.95224124676104, 2.785474184955858],
            [30.952920350657955, 2.784567090507386],
            [30.952243839298966, 2.78397552591057],
            [30.95312588788991, 2.783250441314349],
            [30.95353640719498, 2.780935040434581],
            [30.95293062648652, 2.77861786561477],
            [30.953047347286315, 2.776415487183411],
            [30.953683539560412, 2.774191304757197],
            [30.95630343296741, 2.774127740885849],
            [30.9568917171891, 2.773492964254071],
            [30.95727373744179, 2.774606276923785],
            [30.95862977400757, 2.774040954060444],
            [30.958424563762385, 2.775175953928075],
            [30.959664089734122, 2.776699483653387],
            [30.960296023993774, 2.776950360379641],
            [30.961182388091345, 2.773704776631005],
            [30.961996905830826, 2.772843316933427],
            [30.96197727764188, 2.771117537868061],
            [30.962498428965755, 2.770119324944775],
            [30.96310855482524, 2.769916015313503],
            [30.963539636567173, 2.768758695380414],
            [30.9643358682007, 2.765376698880494],
            [30.963348713128266, 2.761537479764677],
            [30.96513189501836, 2.762108234394505],
            [30.968115406689463, 2.760705521627145],
            [30.971368809102795, 2.759961772050503],
            [30.972339816059705, 2.760031561065726],
            [30.97376089155037, 2.761055828503462],
            [30.9748898367073, 2.761216715721771],
            [30.97620065208166, 2.76067398608028],
            [30.975708951126055, 2.757630356824541],
            [30.976167201515437, 2.753027068632222],
            [30.979629530504305, 2.748441834811372],
            [30.98044022321731, 2.74832679787694],
            [30.981406602952173, 2.747435907751334],
            [30.985112973661014, 2.746704893106464],
            [30.988046142845253, 2.746748673349964],
            [30.989087303734287, 2.747293721634394],
            [30.990399414479295, 2.747373554677611],
            [30.99352693417526, 2.746602723944906],
            [30.997965277330426, 2.746687827676216],
            [31.00514624082841, 2.74538049691258],
            [31.008079057873054, 2.745657064111255],
            [31.008358160838576, 2.745224950884167],
            [31.014234018654122, 2.751051392548549],
            [31.014948216135945, 2.761850127897174],
            [31.014711617856378, 2.77237844012741],
            [31.010933493315918, 2.778816269332102],
            [31.00998582908165, 2.781538642361585],
            [31.00829860702683, 2.783425232974804],
            [31.007228179025827, 2.788022418310724],
            [31.009129860380035, 2.791932136140528],
            [31.00944257920181, 2.794599949550733],
            [31.009184774393372, 2.79543202377715],
            [31.006737427589492, 2.797255356972603],
            [31.006090123155335, 2.798482403360417],
            [31.006183849778825, 2.800582141713361],
            [31.006533943007973, 2.801412308644193],
            [31.008494222366444, 2.803331191318041],
            [31.00893502208311, 2.805342339290099],
            [31.010155281886963, 2.806694790400381],
            [31.012678342296233, 2.808086904085368],
            [31.016239520102342, 2.808250733199386],
            [31.016189523466885, 2.812866611033757],
            [31.018299023773846, 2.820560161614695],
            [31.01974056109006, 2.823180696779991],
            [31.02478147796815, 2.824346173515006],
            [31.02978358133775, 2.826911794633697],
            [31.036475835270036, 2.835050402312751],
            [31.03952338873602, 2.837447160226514],
            [31.04261438023758, 2.838441598540527],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 598,
        District: "ARUA",
        County: "VURRA",
        Subcounty: "ARIVU",
        Population: 24190,
        Key: "ARUAARIVU",
        Dist2: "Koboko",
        "Sub Country": "Arivu",
        id2_original: "Koboko Arivu",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.008358160838576, 2.745224950884167],
            [31.008079057873054, 2.745657064111255],
            [31.00514624082841, 2.74538049691258],
            [30.997965277330426, 2.746687827676216],
            [30.99352693417526, 2.746602723944906],
            [30.990399414479295, 2.747373554677611],
            [30.989087303734287, 2.747293721634394],
            [30.988046142845253, 2.746748673349964],
            [30.985112973661014, 2.746704893106464],
            [30.981406602952173, 2.747435907751334],
            [30.98044022321731, 2.74832679787694],
            [30.979629530504305, 2.748441834811372],
            [30.976167201515437, 2.753027068632222],
            [30.975708951126055, 2.757630356824541],
            [30.97620065208166, 2.76067398608028],
            [30.9748898367073, 2.761216715721771],
            [30.97376089155037, 2.761055828503462],
            [30.972339816059705, 2.760031561065726],
            [30.971368809102795, 2.759961772050503],
            [30.968115406689463, 2.760705521627145],
            [30.96513189501836, 2.762108234394505],
            [30.963348713128266, 2.761537479764677],
            [30.9643358682007, 2.765376698880494],
            [30.963539636567173, 2.768758695380414],
            [30.96310855482524, 2.769916015313503],
            [30.962498428965755, 2.770119324944775],
            [30.96197727764188, 2.771117537868061],
            [30.961996905830826, 2.772843316933427],
            [30.961182388091345, 2.773704776631005],
            [30.960296023993774, 2.776950360379641],
            [30.959664089734122, 2.776699483653387],
            [30.958424563762385, 2.775175953928075],
            [30.95862977400757, 2.774040954060444],
            [30.95727373744179, 2.774606276923785],
            [30.9568917171891, 2.773492964254071],
            [30.95630343296741, 2.774127740885849],
            [30.953683539560412, 2.774191304757197],
            [30.953047347286315, 2.776415487183411],
            [30.95293062648652, 2.77861786561477],
            [30.95353640719498, 2.780935040434581],
            [30.95312588788991, 2.783250441314349],
            [30.952243839298966, 2.78397552591057],
            [30.952920350657955, 2.784567090507386],
            [30.95224124676104, 2.785474184955858],
            [30.950388261281788, 2.786084031236443],
            [30.94993558853202, 2.786650914035631],
            [30.948287122493483, 2.786534490067177],
            [30.947134212979748, 2.787168262834494],
            [30.945286263455962, 2.787208380793119],
            [30.944726117163913, 2.787814446052044],
            [30.94296215293266, 2.787914659241085],
            [30.94217537427086, 2.787379497617348],
            [30.938867282423004, 2.789181651138154],
            [30.93505631727235, 2.789665660576857],
            [30.93233154016604, 2.790831724341847],
            [30.93003402875833, 2.792480658415083],
            [30.92620019429717, 2.796236141929646],
            [30.9230409829363, 2.801531017308958],
            [30.92237082266636, 2.801559493066711],
            [30.92097605703375, 2.798474801012136],
            [30.920280754715613, 2.795753973655679],
            [30.917906561318603, 2.794672570922175],
            [30.917346696199246, 2.793349108574261],
            [30.916171592908093, 2.792024548296542],
            [30.91406252648743, 2.790986278306556],
            [30.912061179747386, 2.789020346018085],
            [30.91187318212136, 2.787356270442602],
            [30.911216068084293, 2.787045812967952],
            [30.910878191943006, 2.786160016936966],
            [30.909627083093994, 2.785837832939091],
            [30.90879034193269, 2.785132450499262],
            [30.907442862718298, 2.785322013373732],
            [30.907419366383753, 2.786612432647526],
            [30.906941768079786, 2.78676088674398],
            [30.90599493388887, 2.788326942001959],
            [30.905432458265288, 2.788485908082129],
            [30.905176311746853, 2.789370640017036],
            [30.90337199429472, 2.789964643320821],
            [30.902734807585603, 2.790959027038001],
            [30.90225583845253, 2.793066723987309],
            [30.901594009158533, 2.793429078482975],
            [30.90007574493726, 2.793208222699476],
            [30.89843188366288, 2.793901190465066],
            [30.897626623960722, 2.793588131803313],
            [30.895932016855937, 2.793772044243944],
            [30.895144900427585, 2.79487164038225],
            [30.893677944382066, 2.79484821955027],
            [30.891521605916182, 2.794067873015749],
            [30.889731596829915, 2.792754045536421],
            [30.88280899868913, 2.792877623546733],
            [30.873739148541524, 2.794097433726843],
            [30.872206967619892, 2.795626607774838],
            [30.868256934280115, 2.791624933299676],
            [30.867648909580065, 2.789868450886237],
            [30.867562275155755, 2.787253224579661],
            [30.8667285325709, 2.785507459616856],
            [30.86261579816349, 2.78225593175022],
            [30.861151834406204, 2.77775335702086],
            [30.859952561044008, 2.771139981152936],
            [30.85850741609362, 2.76970643734782],
            [30.857057319629398, 2.76960984128666],
            [30.85488628742042, 2.76835587374682],
            [30.853557847998474, 2.768047030844233],
            [30.852770276124264, 2.768560623759001],
            [30.851954862764444, 2.768436017625247],
            [30.850446029057043, 2.767883410578693],
            [30.84953894082587, 2.768031934324326],
            [30.847940482202585, 2.767205510601556],
            [30.84740052195328, 2.7661399956504],
            [30.847047747253, 2.763495145467235],
            [30.844905953409885, 2.762514760291342],
            [30.8439216900143, 2.763103577411933],
            [30.84331169980041, 2.764620542092072],
            [30.84212972619399, 2.765558038761039],
            [30.839983971678766, 2.765641114206335],
            [30.838054049088672, 2.764570359588728],
            [30.836999514980015, 2.76374599358664],
            [30.836489671648934, 2.762710976468307],
            [30.836672095228643, 2.75429498168964],
            [30.834788129550162, 2.753057296149766],
            [30.832352908206005, 2.749736159724331],
            [30.829668171706857, 2.748510648258959],
            [30.823494045369216, 2.747267104636905],
            [30.823607024685867, 2.743610495653534],
            [30.82254602899535, 2.741401496769261],
            [30.823643913104675, 2.738201784176286],
            [30.822809980975297, 2.734926247242483],
            [30.82489251385742, 2.730888362381526],
            [30.82674816553646, 2.728945438760861],
            [30.82727803321354, 2.726736136497005],
            [30.826709733811963, 2.726050639959687],
            [30.82451263878167, 2.725175015182369],
            [30.824058001416383, 2.724641849653755],
            [30.822390412940358, 2.719690548379724],
            [30.82259827770723, 2.717348004453063],
            [30.819757343044778, 2.716777226693327],
            [30.81930230952247, 2.714225324522801],
            [30.815476556305594, 2.71354047142221],
            [30.814302219277394, 2.712778925868913],
            [30.814036916231284, 2.711941015236018],
            [30.81456697255455, 2.710798232203605],
            [30.811460743829155, 2.709237180901654],
            [30.810778549727658, 2.707142406972426],
            [30.80896027245603, 2.706228638049502],
            [30.808922319533597, 2.70580965361966],
            [30.810058422466664, 2.704781027440553],
            [30.807936951210216, 2.702876994551633],
            [30.807898766522463, 2.701315346203689],
            [30.8089970809248, 2.700743790988216],
            [30.809337838861513, 2.700096212933027],
            [30.80964025760023, 2.697087100950769],
            [30.810965848464413, 2.69662976368252],
            [30.81115513876613, 2.696172659545763],
            [30.81141950397111, 2.692363683538985],
            [30.808691937595817, 2.690155083525058],
            [30.807327741632303, 2.68699396032789],
            [30.80736533253371, 2.685584657127351],
            [30.808501307007695, 2.684098941982878],
            [30.808463116031692, 2.682613478079636],
            [30.807667263487204, 2.680442564545547],
            [30.805053543302833, 2.679148102601204],
            [30.804977579067483, 2.678081616924679],
            [30.805886392063982, 2.677129202224545],
            [30.80592399194853, 2.675796074167319],
            [30.802154634066902, 2.672426008144579],
            [30.80135898903324, 2.671207324314336],
            [30.79885887878285, 2.669684303655565],
            [30.798063286749787, 2.66869416540006],
            [30.79760847780629, 2.667284973061511],
            [30.79775982776196, 2.666561244045579],
            [30.799463652479904, 2.663856570656979],
            [30.79955813458652, 2.662885280038305],
            [30.798270087013034, 2.661552456881954],
            [30.797625892546385, 2.660105224997025],
            [30.798496554092797, 2.657933963896946],
            [30.79656455998766, 2.656296565844237],
            [30.79588256531215, 2.655154052042609],
            [30.795617009839425, 2.653211577481539],
            [30.79362803020592, 2.650679111201523],
            [30.793324263095986, 2.647175020899057],
            [30.792029922823897, 2.644431438667747],
            [30.79667118102872, 2.645872589557862],
            [30.79811271564998, 2.65016712569341],
            [30.80022393353579, 2.651980079288795],
            [30.802641175099506, 2.652501310370153],
            [30.804429172857873, 2.65212857149145],
            [30.806203147914644, 2.653083322500249],
            [30.807804114634223, 2.652780731647272],
            [30.81038556104538, 2.652938058189149],
            [30.81270878852473, 2.65378805082149],
            [30.814681396362204, 2.654731402393916],
            [30.81644021863677, 2.657671536884554],
            [30.818930317163314, 2.659392586570697],
            [30.821494879738687, 2.659994033792075],
            [30.823755844985715, 2.659035328128399],
            [30.826341488325873, 2.658539297348092],
            [30.82928764625081, 2.659911587307651],
            [30.83136974165341, 2.65998081317318],
            [30.833535848399706, 2.661247670503277],
            [30.835336736084056, 2.660615451175938],
            [30.836427249516465, 2.661098742389469],
            [30.837753991122526, 2.6611075462566],
            [30.838646609291125, 2.662046138096066],
            [30.840353066072822, 2.662588018231169],
            [30.84138311390347, 2.663397790603703],
            [30.84236191015221, 2.66522520519935],
            [30.8430265781225, 2.665266868860156],
            [30.843257055281672, 2.665654659394702],
            [30.84351112579348, 2.667118953104205],
            [30.844095621819616, 2.667010150360221],
            [30.84467590923865, 2.667595692964511],
            [30.844569353774602, 2.668013393850412],
            [30.845758268663232, 2.669933859353438],
            [30.846541000414714, 2.669282461140625],
            [30.849768973318973, 2.671806013623652],
            [30.850035917587117, 2.67030429924755],
            [30.852236216009764, 2.669958590944336],
            [30.85303196345136, 2.669440429866978],
            [30.85284411404735, 2.670812273362823],
            [30.856879277133334, 2.672454367623974],
            [30.85709110706386, 2.673950429735091],
            [30.857817844128732, 2.675030798108581],
            [30.858480567246442, 2.674832130506009],
            [30.858271498737096, 2.673166498667534],
            [30.85968949031139, 2.672875902080387],
            [30.861211818510988, 2.671604559261695],
            [30.861438417643093, 2.67273242490865],
            [30.862285081595004, 2.673413339211502],
            [30.863716462558603, 2.673042825776311],
            [30.86469741745897, 2.673869974480133],
            [30.864985020283733, 2.674896829366399],
            [30.866641083374624, 2.674833118473519],
            [30.867053463988942, 2.673847998690746],
            [30.867835095304184, 2.673836042569012],
            [30.868919924197456, 2.674690560403404],
            [30.871293846303278, 2.67318929643051],
            [30.873385155725746, 2.674245402380143],
            [30.873983431010025, 2.673567973797757],
            [30.874936645934394, 2.673368838445386],
            [30.875045196556723, 2.671876933892861],
            [30.87617113145908, 2.671945505822745],
            [30.87651687324902, 2.67128690932487],
            [30.877204104204303, 2.672147136904429],
            [30.880170679039, 2.670017089441781],
            [30.88025215264202, 2.670597710500445],
            [30.880743473610245, 2.670847703017095],
            [30.881693209359558, 2.670270342112368],
            [30.882694319759963, 2.670325194703204],
            [30.8846479785348, 2.67293276100248],
            [30.885238793310645, 2.672582562261624],
            [30.88573397254301, 2.673121157086961],
            [30.88641051983465, 2.672589434077446],
            [30.887500664957777, 2.670353165682983],
            [30.88736805385893, 2.668604395400219],
            [30.889240849885134, 2.667586479058565],
            [30.89061813699728, 2.667867266260925],
            [30.891276429624003, 2.670266435094516],
            [30.892258422976848, 2.669295595514914],
            [30.895549517801225, 2.671153088234954],
            [30.895736886606553, 2.672645523994008],
            [30.896133752417608, 2.672979270026626],
            [30.897220369856633, 2.672807952057757],
            [30.89756617632527, 2.672009199816102],
            [30.897023469027808, 2.67174181621269],
            [30.8974085408575, 2.671222903917328],
            [30.898469432343422, 2.670598575535858],
            [30.899173981020756, 2.66961063021953],
            [30.900047124612307, 2.669895198350916],
            [30.90083010519712, 2.669097196186475],
            [30.90091538496197, 2.668073700583548],
            [30.902012508198254, 2.667127498493752],
            [30.90406246367661, 2.669169358531576],
            [30.905838828252026, 2.668492956399299],
            [30.905890623314708, 2.669199139473765],
            [30.906604743541376, 2.669946424807128],
            [30.90795627595434, 2.669802193527344],
            [30.909398514854786, 2.670857144822792],
            [30.910300658758636, 2.670099303735623],
            [30.910325251936175, 2.669609434962195],
            [30.91192143243192, 2.670160446687233],
            [30.911182977742477, 2.672629766736116],
            [30.914063381683565, 2.675350150220311],
            [30.9137043825567, 2.677536191972872],
            [30.91414371532447, 2.678265828846732],
            [30.911946811635318, 2.679287447699654],
            [30.912250408065372, 2.680106232637812],
            [30.911602624829158, 2.681036659491222],
            [30.911636482332224, 2.681763033376207],
            [30.912626610828255, 2.682471835295442],
            [30.912881540129483, 2.683237610105847],
            [30.91231255890662, 2.685351449462286],
            [30.91508774048353, 2.686939221546905],
            [30.915392937711406, 2.68748623147142],
            [30.91486636505478, 2.687914082419197],
            [30.9145903549888, 2.687316056036198],
            [30.913574531980693, 2.687054350475494],
            [30.913263627755786, 2.687489768735493],
            [30.914597949346224, 2.690589367356971],
            [30.914170959430404, 2.692717115055069],
            [30.914534414201118, 2.69347070676569],
            [30.916433229031256, 2.693473976610176],
            [30.918340301175444, 2.694494881931109],
            [30.918475049366393, 2.695514475409455],
            [30.91809350611913, 2.696199152944065],
            [30.919129149555662, 2.69765129268531],
            [30.91954119779336, 2.697667939761677],
            [30.919868585205375, 2.696210175633295],
            [30.920439312753164, 2.696115529816835],
            [30.921689004958978, 2.697520223870536],
            [30.923463751668592, 2.697730468590447],
            [30.923239181830702, 2.699307949348821],
            [30.925986290156683, 2.702380935779086],
            [30.92629361549345, 2.703398904782128],
            [30.930273637292366, 2.703577160088334],
            [30.930879248219245, 2.703303928416144],
            [30.93071835725693, 2.701776462104101],
            [30.93136408245283, 2.698856432028904],
            [30.93037589341947, 2.698095385134396],
            [30.93063416984345, 2.697038138673528],
            [30.931018160101537, 2.696773096271524],
            [30.932943995357068, 2.697007806557475],
            [30.933250190613254, 2.697385452699474],
            [30.932274780114806, 2.697969844753246],
            [30.93219965580424, 2.698677871838676],
            [30.934140541434072, 2.700095403552221],
            [30.935117094589533, 2.702231247262226],
            [30.937916819936643, 2.704841617703849],
            [30.93822430697018, 2.704456448101483],
            [30.936872813184795, 2.702268535244392],
            [30.937726493877403, 2.701464320569182],
            [30.936756882004115, 2.699882629701575],
            [30.9376338434356, 2.697946058606621],
            [30.937254723843004, 2.696271333430856],
            [30.93771434775645, 2.695921992038546],
            [30.93939326937805, 2.695881784876218],
            [30.940783994388507, 2.694040831478108],
            [30.940476809188926, 2.693342603153057],
            [30.938412003660584, 2.69364056638163],
            [30.93833627298718, 2.693191108109524],
            [30.939561236369865, 2.692781157922725],
            [30.94073665676633, 2.691628927773672],
            [30.943313427446427, 2.692503286456185],
            [30.943877741921366, 2.693107201221538],
            [30.944949709634766, 2.692351017815269],
            [30.94616576172981, 2.692508127516823],
            [30.94571718619607, 2.694393761801745],
            [30.94592208113257, 2.694798952947765],
            [30.94665867900431, 2.694826043992318],
            [30.94704845081955, 2.695623054877486],
            [30.946740589188558, 2.697057127764048],
            [30.947019695747333, 2.699176569343132],
            [30.94742155529305, 2.699607936363793],
            [30.949314186120734, 2.699835106835258],
            [30.950160320066658, 2.700947710857827],
            [30.94930250532711, 2.702575258577685],
            [30.94930749996007, 2.703814624714741],
            [30.950931677349956, 2.705781311067311],
            [30.951537176885765, 2.70736726276141],
            [30.95032593167578, 2.709432491438032],
            [30.952875503165725, 2.711228484220675],
            [30.954016196489903, 2.710369052319484],
            [30.955796902623124, 2.710949200123692],
            [30.95701154795642, 2.711959070891684],
            [30.958374736010185, 2.711229218220026],
            [30.959296647341866, 2.708026466997499],
            [30.96075656149387, 2.705797976875818],
            [30.96209456168536, 2.704757973635989],
            [30.962500361241908, 2.702837789024016],
            [30.9628257534957, 2.702500906960149],
            [30.964556816031365, 2.702436413254297],
            [30.96469537487573, 2.701532199903361],
            [30.96431625348648, 2.70078649791619],
            [30.96741948722875, 2.696265146403964],
            [30.969983541357667, 2.694520849535183],
            [30.973214689806504, 2.69339785401796],
            [30.974486105970826, 2.691379812599715],
            [30.973968153547688, 2.689550973474653],
            [30.976732848191944, 2.687761200330867],
            [30.977782925758508, 2.693803381094047],
            [30.97998272651446, 2.701840311571594],
            [30.981594160403723, 2.70623954399695],
            [30.988435434061845, 2.717227181406115],
            [30.99175218027914, 2.725524692692906],
            [30.997247843218663, 2.73378916498007],
            [31.008358160838576, 2.745224950884167],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 599,
        District: "ARUA",
        County: "VURRA",
        Subcounty: "LOGIRI",
        Population: 37450,
        Key: "ARUALOGIRI",
        Dist2: "Koboko",
        "Sub Country": "Logiri",
        id2_original: "Koboko Logiri",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.942456517310386, 2.980078341490942],
            [30.93963690865276, 2.980100108736438],
            [30.93842934473882, 2.978688497847247],
            [30.937125649411396, 2.978026922000152],
            [30.936910788565097, 2.977275712635085],
            [30.934147552784857, 2.976045758959224],
            [30.932700798053464, 2.97462510095435],
            [30.92952215074313, 2.973808170009635],
            [30.91797343011174, 2.974450015666932],
            [30.91366150866313, 2.973814843577977],
            [30.9053768992616, 2.969896985528433],
            [30.902695333815377, 2.969300097647774],
            [30.89928160098842, 2.969462951669632],
            [30.873979740730814, 2.9733221216919],
            [30.870659668950335, 2.970619165014157],
            [30.870001465256824, 2.971749037182323],
            [30.870459404829106, 2.973081462224561],
            [30.866240299112295, 2.973698405548994],
            [30.865509074962592, 2.974322124363558],
            [30.864643602983584, 2.974456338463294],
            [30.864936828363675, 2.976631310084638],
            [30.864551346003907, 2.977150829645478],
            [30.863062464777265, 2.975996015452181],
            [30.862541953952192, 2.975995000827794],
            [30.862123542947348, 2.974736167021854],
            [30.86090676950513, 2.973987890742702],
            [30.860454771390152, 2.972918249893989],
            [30.859967873726372, 2.972716909618302],
            [30.860271640836334, 2.97187817576291],
            [30.86013380603406, 2.96936131548325],
            [30.857189986423837, 2.967498945743825],
            [30.85625424732497, 2.966318141098168],
            [30.85600454801534, 2.965361293053325],
            [30.855050716846666, 2.964311074428196],
            [30.85480375290706, 2.960780485744849],
            [30.85712403570893, 2.959357246847273],
            [30.858745489406846, 2.959208616031828],
            [30.858009554491826, 2.954778552556451],
            [30.856774061955697, 2.951548453824657],
            [30.854141120519195, 2.948849464034159],
            [30.854112422040824, 2.948224050557446],
            [30.85493746084891, 2.943912682011263],
            [30.855658316643584, 2.942446021903428],
            [30.855238153025642, 2.938473732509612],
            [30.85641270115792, 2.936274099172507],
            [30.861328508768082, 2.931556410320253],
            [30.86102111605764, 2.930617273327014],
            [30.85826581419796, 2.927386349219021],
            [30.85795711623543, 2.926791118878667],
            [30.858178493460766, 2.925822754311701],
            [30.85864684720214, 2.925324316982686],
            [30.86107474188683, 2.924708371362509],
            [30.863567104167895, 2.923498633234495],
            [30.865738710400347, 2.920771285893496],
            [30.867577800738825, 2.919621540379703],
            [30.865632871791888, 2.915893501378807],
            [30.866144792027924, 2.912112375217005],
            [30.867197129755713, 2.909318179080598],
            [30.868101527532612, 2.908633808322235],
            [30.870560608130706, 2.907986662947599],
            [30.870025885957816, 2.901387635439647],
            [30.874633169878585, 2.900060859545755],
            [30.87556877333186, 2.899345325521375],
            [30.874823057559976, 2.895074752826169],
            [30.875171251750626, 2.893450278679784],
            [30.875050039374404, 2.888494244856922],
            [30.879383304794157, 2.885603081007659],
            [30.881563307579576, 2.884735951752102],
            [30.884181824767552, 2.883026310727026],
            [30.887994192188376, 2.878069570228889],
            [30.888721361342856, 2.874883229497643],
            [30.888045122173384, 2.868643160970121],
            [30.88946023374888, 2.864427650439192],
            [30.890820974791822, 2.858117128958046],
            [30.890735886368123, 2.854852771338214],
            [30.88787076097336, 2.850469660015939],
            [30.888561878040594, 2.847785695894186],
            [30.887574334895913, 2.845674844797826],
            [30.887475061175575, 2.844199477549895],
            [30.884652568027597, 2.835417935045606],
            [30.88582419483859, 2.830312590719723],
            [30.886361372107118, 2.830149303941111],
            [30.886415698622248, 2.828985074787602],
            [30.885338226931133, 2.822400307267448],
            [30.885756716987682, 2.814733331386516],
            [30.88488932081733, 2.811687666091256],
            [30.878353874106114, 2.804173294969568],
            [30.87384844476551, 2.797197749361066],
            [30.872206967619892, 2.795626607774838],
            [30.873739148541524, 2.794097433726843],
            [30.88280899868913, 2.792877623546733],
            [30.889731596829915, 2.792754045536421],
            [30.891521605916182, 2.794067873015749],
            [30.893677944382066, 2.79484821955027],
            [30.895144900427585, 2.79487164038225],
            [30.895932016855937, 2.793772044243944],
            [30.897626623960722, 2.793588131803313],
            [30.89843188366288, 2.793901190465066],
            [30.90007574493726, 2.793208222699476],
            [30.901594009158533, 2.793429078482975],
            [30.90225583845253, 2.793066723987309],
            [30.902734807585603, 2.790959027038001],
            [30.90337199429472, 2.789964643320821],
            [30.905176311746853, 2.789370640017036],
            [30.905432458265288, 2.788485908082129],
            [30.90599493388887, 2.788326942001959],
            [30.906941768079786, 2.78676088674398],
            [30.907419366383753, 2.786612432647526],
            [30.907442862718298, 2.785322013373732],
            [30.90879034193269, 2.785132450499262],
            [30.909627083093994, 2.785837832939091],
            [30.910878191943006, 2.786160016936966],
            [30.911216068084293, 2.787045812967952],
            [30.91187318212136, 2.787356270442602],
            [30.912061179747386, 2.789020346018085],
            [30.91406252648743, 2.790986278306556],
            [30.916171592908093, 2.792024548296542],
            [30.917346696199246, 2.793349108574261],
            [30.917906561318603, 2.794672570922175],
            [30.920280754715613, 2.795753973655679],
            [30.92097605703375, 2.798474801012136],
            [30.92237082266636, 2.801559493066711],
            [30.9230409829363, 2.801531017308958],
            [30.92335528997951, 2.803872308722274],
            [30.924377600620584, 2.805798394877438],
            [30.92506257949945, 2.806145966129655],
            [30.925010664960894, 2.806934403980396],
            [30.924618156877262, 2.807031516477331],
            [30.92420366073044, 2.813242789342491],
            [30.926152340143663, 2.817130653442769],
            [30.92648984707737, 2.820034949027036],
            [30.925652877744003, 2.822740276762096],
            [30.9262823335518, 2.826629397529589],
            [30.925983723669912, 2.829384903989434],
            [30.926902183674272, 2.835142723123898],
            [30.929296390637482, 2.841107861799868],
            [30.929433423244184, 2.843819286197846],
            [30.92882992964643, 2.847938011839505],
            [30.92546446329969, 2.852054433988614],
            [30.92251041636995, 2.854093351064076],
            [30.918720395440157, 2.855409220272535],
            [30.917721988070443, 2.856329327175352],
            [30.91747799216455, 2.858974411048777],
            [30.919373221818372, 2.86657779813757],
            [30.91921808636206, 2.868745931342821],
            [30.91767751248071, 2.874359066262681],
            [30.91742394592378, 2.876625402950399],
            [30.917806743219188, 2.879140590837634],
            [30.916473238197344, 2.88179715965981],
            [30.916894723237085, 2.887072660145884],
            [30.915858647710884, 2.888843153966556],
            [30.915903245471483, 2.890026249125565],
            [30.91510764804854, 2.89302986740669],
            [30.91609589277742, 2.897494244840644],
            [30.916038013425368, 2.899859896403687],
            [30.917155914694153, 2.902427157978068],
            [30.91695835090866, 2.902820716375139],
            [30.917736426692024, 2.904499484036531],
            [30.918421073194228, 2.904945680836466],
            [30.918683025524334, 2.906240940046922],
            [30.920788646007598, 2.908081364305435],
            [30.922258372457424, 2.908427502334483],
            [30.935104046560028, 2.907672026719553],
            [30.93888466302711, 2.910127872368905],
            [30.944448915033547, 2.912462080890486],
            [30.945083461594034, 2.913203825935471],
            [30.945466090006153, 2.915768337871113],
            [30.946004241048467, 2.916066100892852],
            [30.9458551494574, 2.916607725829853],
            [30.94678457699306, 2.917153422675392],
            [30.946536152392813, 2.918039700069721],
            [30.945651334295846, 2.918677128914289],
            [30.945351120022835, 2.920302566166065],
            [30.945537275204213, 2.922964910995536],
            [30.94669507424805, 2.924542482926344],
            [30.946789891426285, 2.930272403513989],
            [30.947360336004753, 2.930734769113964],
            [30.947241832947416, 2.931823735489142],
            [30.9479191725531, 2.934303537511744],
            [30.94877548351284, 2.934824509617581],
            [30.948937673439087, 2.93735630293059],
            [30.95075774913794, 2.94092582260769],
            [30.94817054362749, 2.946186124044712],
            [30.94531049640906, 2.945211107034761],
            [30.943230932458942, 2.948609890155067],
            [30.942593556205264, 2.950735952895949],
            [30.940893643650426, 2.953922216139742],
            [30.940829291038416, 2.955820337418873],
            [30.94172789917333, 2.96031081484105],
            [30.941941835653175, 2.964280951157912],
            [30.94335562311195, 2.968715860485754],
            [30.943217345440242, 2.97504324864936],
            [30.942639088213785, 2.976651780186991],
            [30.942456517310386, 2.980078341490942],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 600,
        District: "ARUA",
        County: "VURRA",
        Subcounty: "VURRA",
        Population: 44598,
        Key: "ARUAVURRA",
        Dist2: "Koboko",
        "Sub Country": "Vurra",
        id2_original: "Koboko Vurra",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.334329596221675, 2.596422821265778],
            [31.329232407077573, 2.608602051147555],
            [31.32875720098721, 2.608122872014411],
            [31.32840293149029, 2.606148406858925],
            [31.327276678584294, 2.60497193754941],
            [31.327251170921812, 2.604363308904675],
            [31.32591196968277, 2.602350513068697],
            [31.324991682505114, 2.601899453939021],
            [31.323626664583127, 2.599516176272191],
            [31.32249620845991, 2.598826690931744],
            [31.32075938143507, 2.599062512797096],
            [31.31920785349718, 2.598451843323595],
            [31.318893105381196, 2.597710527621374],
            [31.318130689928207, 2.597259676822904],
            [31.318026989310106, 2.596095276341003],
            [31.31671201743091, 2.595670146959376],
            [31.31495280618583, 2.59303002925803],
            [31.313292238043793, 2.592505701609442],
            [31.312073878176772, 2.591277131091009],
            [31.30802307721832, 2.592394205554101],
            [31.306439763292364, 2.592339863742219],
            [31.305246538286998, 2.591737843716891],
            [31.302131868092875, 2.591603118485874],
            [31.301899265519737, 2.59084576228329],
            [31.30034223001081, 2.590556507854998],
            [31.299538174051126, 2.589646150081429],
            [31.298525103481026, 2.590658471022168],
            [31.29813602875844, 2.590449106451901],
            [31.29805941414282, 2.589509227797616],
            [31.296874715946128, 2.588725993856543],
            [31.294535980849986, 2.590093466949974],
            [31.293761894484835, 2.590240519890584],
            [31.293195491426843, 2.591256638139214],
            [31.291620813005753, 2.590147891418844],
            [31.29088079165447, 2.587574767421437],
            [31.29010858546318, 2.586826010388777],
            [31.289278867330783, 2.58461166707993],
            [31.285894275851668, 2.58041991237815],
            [31.28521249497521, 2.578774031251573],
            [31.27867623528865, 2.57062740502766],
            [31.277784125566516, 2.567575560400429],
            [31.278131698122976, 2.565426720936879],
            [31.277932026889832, 2.560087841042868],
            [31.279312085304625, 2.559119049369998],
            [31.279796409295127, 2.557802382801961],
            [31.280498920593377, 2.555516795746905],
            [31.280469575327988, 2.549792376392002],
            [31.28155084060458, 2.546720965804364],
            [31.281773078415974, 2.544908494636133],
            [31.283052208413647, 2.541815236106092],
            [31.284153417187827, 2.540269221942774],
            [31.28573731951028, 2.539431271870517],
            [31.28630818360196, 2.539962602417334],
            [31.287144947221158, 2.538902582251868],
            [31.289387240086683, 2.538905571602757],
            [31.2900915776599, 2.538243298734989],
            [31.291102808480307, 2.538244643091043],
            [31.291584696239752, 2.539571707580176],
            [31.292990058399454, 2.540767358821272],
            [31.293296429725434, 2.541828905781862],
            [31.294439217022543, 2.54209571122444],
            [31.298133240387813, 2.541481616818496],
            [31.29868325637839, 2.542113512670694],
            [31.301321549977363, 2.527484086414802],
            [31.305198872779705, 2.510816021507558],
            [31.308292404716894, 2.503840578262984],
            [31.308705788749414, 2.497493104248088],
            [31.30813196920041, 2.495252023051412],
            [31.307512688609837, 2.494465966818335],
            [31.30815373178649, 2.493844729479605],
            [31.308104333429007, 2.492556818841073],
            [31.307400686660227, 2.490971880582066],
            [31.305876543863754, 2.489209442865573],
            [31.305540473336162, 2.486967951782394],
            [31.304255281506943, 2.486039922556809],
            [31.30380204371687, 2.484991226875175],
            [31.302052951993495, 2.483861243695968],
            [31.301577421611313, 2.483838202017896],
            [31.300865260610248, 2.484602671443467],
            [31.300198230070755, 2.483673591410935],
            [31.298462205241492, 2.483366467681943],
            [31.29762899535758, 2.48260463700654],
            [31.29632167802292, 2.482821518311685],
            [31.294002478589288, 2.48202642429799],
            [31.292812474044208, 2.481145943317451],
            [31.289911256138005, 2.48067382479941],
            [31.288315318187376, 2.478553748486939],
            [31.28732317117687, 2.474703408677056],
            [31.286441184569686, 2.473083010266475],
            [31.285616275119022, 2.472761002086898],
            [31.284067543636557, 2.472914379412398],
            [31.28312742704734, 2.472440121062856],
            [31.281933741206224, 2.469643365240574],
            [31.278343449001756, 2.468434602383738],
            [31.27650443861335, 2.468690222210299],
            [31.275393152538324, 2.468323246434938],
            [31.274624419233916, 2.46759119275535],
            [31.274326544173913, 2.466472727396313],
            [31.273001489603963, 2.466083969986316],
            [31.27278835801461, 2.465567657601836],
            [31.27325932585343, 2.465095240062255],
            [31.272874987049036, 2.464707712700686],
            [31.271122895850887, 2.463888369457214],
            [31.26983982763901, 2.464101706963196],
            [31.265864049481518, 2.463429959269438],
            [31.264881695904233, 2.462568616499899],
            [31.264539285067396, 2.462826184996949],
            [31.263812932481482, 2.462395205200201],
            [31.259670854605318, 2.458089507375208],
            [31.2594804935118, 2.456411809137466],
            [31.258996956445483, 2.454943111984139],
            [31.25821852133602, 2.454923448857563],
            [31.25486739210122, 2.452104062785535],
            [31.253922245844723, 2.45200960974993],
            [31.250970619874654, 2.449177511705613],
            [31.250321084025337, 2.447089269691287],
            [31.250697239177505, 2.446612645333337],
            [31.250403445163816, 2.4445447509845],
            [31.251411384557034, 2.444605712623154],
            [31.25318894928168, 2.445602038866754],
            [31.260777589815145, 2.446506562151172],
            [31.26625047058075, 2.448123979968508],
            [31.273445455881998, 2.448196008459623],
            [31.273711960873957, 2.447130671185269],
            [31.274992808450477, 2.446340162703553],
            [31.275910565972275, 2.447199531568829],
            [31.27709207964129, 2.447102039265594],
            [31.280598664132658, 2.450836367167843],
            [31.282402264729175, 2.451861917430366],
            [31.283845770254164, 2.452193852442606],
            [31.287390927505506, 2.451439259241311],
            [31.289434619031397, 2.449257610411892],
            [31.291617423662174, 2.411024403678408],
            [31.290173136602874, 2.3988387616161],
            [31.29064758271849, 2.3981462404489],
            [31.292597950964453, 2.398786847693949],
            [31.293808223298978, 2.397305941674149],
            [31.294854003325188, 2.3971371595258],
            [31.295639474938287, 2.397779781297854],
            [31.296926551432943, 2.400019591220582],
            [31.298282272690074, 2.400446564634269],
            [31.301046239698987, 2.396613548077935],
            [31.301376387633876, 2.394800237450201],
            [31.302301285863866, 2.393272116053667],
            [31.304346831512508, 2.393960231012381],
            [31.305436765531585, 2.39150159986072],
            [31.30774257827084, 2.391354442157077],
            [31.313082246066333, 2.39302661507786],
            [31.313487526396667, 2.393789161541766],
            [31.313298763406014, 2.394743569154484],
            [31.317061429737088, 2.399054144102966],
            [31.317676982319213, 2.397335726176247],
            [31.31931918530359, 2.398549287241829],
            [31.32056572621939, 2.397485679937756],
            [31.32137381741133, 2.397341145456706],
            [31.32315706577678, 2.39748111869557],
            [31.32570236218427, 2.398478412125773],
            [31.32558495417326, 2.399456546203476],
            [31.32337441675303, 2.399746670195591],
            [31.324162865382974, 2.402368993450017],
            [31.324329605276116, 2.40258337194688],
            [31.325446125834294, 2.402008956331927],
            [31.32794470266051, 2.403554934100891],
            [31.33014427254944, 2.403873060893091],
            [31.33050170231952, 2.404421027474831],
            [31.330456655401267, 2.406090744952645],
            [31.33107630519942, 2.407115290756008],
            [31.33197291278619, 2.410512632262107],
            [31.332471491243595, 2.410058556874702],
            [31.333061350212002, 2.407052159012699],
            [31.335154290975, 2.407597066458549],
            [31.335580832631468, 2.406666077912823],
            [31.3381251265191, 2.406971655714234],
            [31.34002462496716, 2.405346344305425],
            [31.34258035979826, 2.40535374079899],
            [31.34519050109453, 2.404728952805074],
            [31.345276826498406, 2.408013295060326],
            [31.34997458154805, 2.408634803799985],
            [31.354727785108636, 2.407471621554111],
            [31.360026222927548, 2.405525950472756],
            [31.37131282773543, 2.404141062658867],
            [31.37632413793838, 2.404493647069924],
            [31.380786852387235, 2.403887041636276],
            [31.387231613272192, 2.401278316129556],
            [31.390624448590707, 2.399120714645441],
            [31.39649566660781, 2.405078773587904],
            [31.398672824428687, 2.408601591909211],
            [31.402265409133754, 2.416360593305694],
            [31.40388105163015, 2.42289282943957],
            [31.410010202914776, 2.430552832109782],
            [31.41213883015077, 2.432238960633778],
            [31.41377472606353, 2.435918582125707],
            [31.41408819947013, 2.441826528082975],
            [31.41471064033386, 2.44231061415466],
            [31.414673862407824, 2.44331306932472],
            [31.415632846312985, 2.445211793615114],
            [31.416664042190554, 2.446251321308075],
            [31.416805351676302, 2.447182380419841],
            [31.418263210482912, 2.44868786095013],
            [31.418225716599594, 2.45029897662461],
            [31.420717431195346, 2.45058836543664],
            [31.42201593605708, 2.451377585303886],
            [31.425877453001995, 2.452080568220694],
            [31.427908327365405, 2.450800740262225],
            [31.42928737248057, 2.450822093429859],
            [31.430570350860936, 2.450223439045054],
            [31.431284182728405, 2.450579939765302],
            [31.432995055628037, 2.449932790969827],
            [31.434576066273568, 2.449870284985879],
            [31.437237136656577, 2.448672775853782],
            [31.438026265311162, 2.451581435615044],
            [31.438136973686785, 2.453978496576446],
            [31.437611672146286, 2.460217083437772],
            [31.43583869691445, 2.468989471249949],
            [31.43236676493518, 2.467198090959136],
            [31.426646651633703, 2.465956140532782],
            [31.425434285326247, 2.466101440396609],
            [31.423891288688594, 2.467702390808602],
            [31.423066793361254, 2.472713028253521],
            [31.4217517882444, 2.475708959138303],
            [31.41962834698252, 2.478682484971486],
            [31.41977525387085, 2.4814730354374],
            [31.41608588288044, 2.486643828954643],
            [31.414609812528077, 2.493217969745876],
            [31.41455964521271, 2.498461580264839],
            [31.412868698742688, 2.502272815721338],
            [31.410112372803624, 2.506364537287211],
            [31.41088008741846, 2.508579033944057],
            [31.407242343505743, 2.513444401659689],
            [31.402063242380773, 2.518750548766531],
            [31.398979370926142, 2.520628251511987],
            [31.394684875895717, 2.522504439354029],
            [31.39303172244803, 2.52438389387623],
            [31.392587819052093, 2.52737161726033],
            [31.392803838725076, 2.53069219399786],
            [31.39214199685465, 2.531908814014753],
            [31.390159608160417, 2.533013105121888],
            [31.386956147585288, 2.540251897905192],
            [31.384339567165025, 2.540201619246262],
            [31.38061081942245, 2.539403497212955],
            [31.377531575189863, 2.53765320527666],
            [31.374509671320173, 2.529484585829185],
            [31.373428343161553, 2.527587918584329],
            [31.3707582474049, 2.527631146536899],
            [31.370226074650805, 2.527056302060588],
            [31.36790216984171, 2.526971360997353],
            [31.36718519476906, 2.527547774238758],
            [31.36514586097062, 2.527007891362965],
            [31.35805915589874, 2.523237808623928],
            [31.35541080116861, 2.521397074530737],
            [31.35360739011661, 2.521580033160795],
            [31.349037782437176, 2.523009853259163],
            [31.348414325578865, 2.526885301716103],
            [31.34873908901195, 2.533441836101961],
            [31.344156376709126, 2.545112511709658],
            [31.34258348144387, 2.547216085731327],
            [31.34286780811275, 2.548125693887847],
            [31.34476888400245, 2.549850926250987],
            [31.345625055723335, 2.550091308025699],
            [31.35189851686679, 2.555889859360382],
            [31.35394279319593, 2.557280293180098],
            [31.35903133246218, 2.559488188419451],
            [31.36055032701375, 2.56236145289161],
            [31.367587873578294, 2.566103214588098],
            [31.369108958509553, 2.567349406806859],
            [31.369296982186725, 2.569168152389493],
            [31.36600146495621, 2.578782823133899],
            [31.36426501252886, 2.580796968449128],
            [31.36242973014891, 2.580662738320639],
            [31.35989927301157, 2.582241676115514],
            [31.349165535446993, 2.583772227620766],
            [31.344279321935545, 2.582183619516853],
            [31.34167804162124, 2.58183900858032],
            [31.335744613474077, 2.592907182092368],
            [31.334329596221675, 2.596422821265778],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 601,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "ALWI",
        Population: 18261,
        Key: "PAKWACHALWI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.486386538625712, 2.445622627449717],
            [31.480709933428397, 2.454668340652851],
            [31.476478457011822, 2.457975413220703],
            [31.473670631555787, 2.461642146182889],
            [31.47438385975541, 2.465877756124325],
            [31.474258434280475, 2.467746261534363],
            [31.472586494365245, 2.472737229667853],
            [31.472718594322753, 2.476157176037838],
            [31.47216862055297, 2.478062204987802],
            [31.470911902623318, 2.476816868678461],
            [31.467927640858967, 2.475588646082934],
            [31.463332113190315, 2.474872147000915],
            [31.4583625935127, 2.474846587742214],
            [31.457452957659395, 2.475387511622085],
            [31.454385730190353, 2.475369247066808],
            [31.454108463381257, 2.472900919924124],
            [31.45481637894428, 2.469440870194736],
            [31.454823237581483, 2.466208713880215],
            [31.451638037959455, 2.466763157370987],
            [31.445943962326485, 2.467023989200935],
            [31.44256992245868, 2.468461325799709],
            [31.43583869691445, 2.468989471249949],
            [31.437611672146286, 2.460217083437772],
            [31.438136973686785, 2.453978496576446],
            [31.438026265311162, 2.451581435615044],
            [31.437237136656577, 2.448672775853782],
            [31.434576066273568, 2.449870284985879],
            [31.432995055628037, 2.449932790969827],
            [31.431284182728405, 2.450579939765302],
            [31.430570350860936, 2.450223439045054],
            [31.42928737248057, 2.450822093429859],
            [31.427908327365405, 2.450800740262225],
            [31.425877453001995, 2.452080568220694],
            [31.42201593605708, 2.451377585303886],
            [31.420717431195346, 2.45058836543664],
            [31.418225716599594, 2.45029897662461],
            [31.418263210482912, 2.44868786095013],
            [31.416805351676302, 2.447182380419841],
            [31.416664042190554, 2.446251321308075],
            [31.415632846312985, 2.445211793615114],
            [31.414673862407824, 2.44331306932472],
            [31.41471064033386, 2.44231061415466],
            [31.41408819947013, 2.441826528082975],
            [31.41377472606353, 2.435918582125707],
            [31.41213883015077, 2.432238960633778],
            [31.410010202914776, 2.430552832109782],
            [31.40388105163015, 2.42289282943957],
            [31.402265409133754, 2.416360593305694],
            [31.398672824428687, 2.408601591909211],
            [31.39649566660781, 2.405078773587904],
            [31.390624448590707, 2.399120714645441],
            [31.387231613272192, 2.401278316129556],
            [31.380786852387235, 2.403887041636276],
            [31.37632413793838, 2.404493647069924],
            [31.37131282773543, 2.404141062658867],
            [31.360026222927548, 2.405525950472756],
            [31.354727785108636, 2.407471621554111],
            [31.34997458154805, 2.408634803799985],
            [31.345276826498406, 2.408013295060326],
            [31.34519050109453, 2.404728952805074],
            [31.345161954431433, 2.401213450095034],
            [31.344420540691484, 2.395254522548419],
            [31.348443015074064, 2.395247362948235],
            [31.3506529119955, 2.395919931695656],
            [31.354178305412265, 2.39776820586933],
            [31.357433753289516, 2.397925685361339],
            [31.358618693133025, 2.397340368196528],
            [31.36241432494009, 2.393402805641191],
            [31.365371733365638, 2.388720231506878],
            [31.368280190794714, 2.382451424714173],
            [31.36858610397992, 2.377260380879582],
            [31.36925688229076, 2.374973016105667],
            [31.370658638612916, 2.371762876590128],
            [31.373662010238316, 2.366800207159158],
            [31.376564325885813, 2.360252580156774],
            [31.37960301387827, 2.346335462852392],
            [31.38162311923804, 2.341070471861673],
            [31.386871742779476, 2.330474315413378],
            [31.389564715931474, 2.32379191511967],
            [31.3962380172079, 2.313395534055451],
            [31.40123558588195, 2.316563374295807],
            [31.402115165004172, 2.317526623039442],
            [31.40913005875221, 2.321189408365948],
            [31.434325197357452, 2.330879489362458],
            [31.44549193277047, 2.336700866557859],
            [31.452166833946393, 2.340940916350303],
            [31.457640100089254, 2.345116992085136],
            [31.462480893881622, 2.350089147088455],
            [31.466557027331092, 2.35577815183504],
            [31.46864888292923, 2.359218725053406],
            [31.471021064100007, 2.364526762258512],
            [31.473635378969092, 2.372589974614418],
            [31.474315590488764, 2.376788377733409],
            [31.47629573519145, 2.392841469496409],
            [31.476946705650295, 2.420714797120039],
            [31.47951922011258, 2.431122176402582],
            [31.480844863079025, 2.434924387458523],
            [31.483135970397093, 2.440311076701841],
            [31.486386538625712, 2.445622627449717],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 602,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "PAKWACH",
        Population: 20905,
        Key: "PAKWACHPAKWACH",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.486386538625712, 2.445622627449717],
            [31.490102270678143, 2.449897185580056],
            [31.494378078055714, 2.453327687657724],
            [31.498538570496876, 2.455762567524188],
            [31.504941315379394, 2.457760782350286],
            [31.51113961807629, 2.460373615082169],
            [31.51908187323483, 2.465623536729097],
            [31.52135068796079, 2.467499962778175],
            [31.52951826484713, 2.479718664997947],
            [31.529866147322355, 2.481065914738353],
            [31.529688479423783, 2.483759438138981],
            [31.52741371964726, 2.48721187580476],
            [31.52187556819142, 2.492944421512682],
            [31.519428242947143, 2.494464184454681],
            [31.515583415801867, 2.495982353541124],
            [31.512613142603115, 2.496506003372062],
            [31.50609163684679, 2.496381443624031],
            [31.501143851907486, 2.494911814326982],
            [31.49698073728399, 2.49546024265129],
            [31.49326343856972, 2.492961825155916],
            [31.492475999646153, 2.49148710968802],
            [31.485987001225027, 2.488970360154167],
            [31.484329596949397, 2.486693931080247],
            [31.48096481691554, 2.484120732236548],
            [31.475974669224044, 2.481195288184329],
            [31.47216862055297, 2.478062204987802],
            [31.472718594322753, 2.476157176037838],
            [31.472586494365245, 2.472737229667853],
            [31.474258434280475, 2.467746261534363],
            [31.47438385975541, 2.465877756124325],
            [31.473670631555787, 2.461642146182889],
            [31.476478457011822, 2.457975413220703],
            [31.480709933428397, 2.454668340652851],
            [31.486386538625712, 2.445622627449717],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 603,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "PAKWACH TOWN COUNCIL",
        Population: 23040,
        Key: "PAKWACHPAKWACH TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.412705137089038, 2.617007451214231],
            [31.40283688407986, 2.614756488558246],
            [31.395872024696523, 2.612652880890168],
            [31.393864188526877, 2.609977790938441],
            [31.392780769090283, 2.609828834255508],
            [31.39103500113343, 2.61059301083727],
            [31.390371871977205, 2.611620777761737],
            [31.386420531588684, 2.61199888881754],
            [31.385295615375835, 2.613429433329458],
            [31.38531396616047, 2.614760611121972],
            [31.38587455442362, 2.615507589116965],
            [31.385552458088615, 2.616455115587449],
            [31.384107222408385, 2.617441522940136],
            [31.38360395564349, 2.618913205084805],
            [31.38169837919423, 2.61917292571289],
            [31.38047312206246, 2.620643666270797],
            [31.376823400912045, 2.620396883417151],
            [31.375519142340934, 2.62091957340098],
            [31.37301387306588, 2.619665829590109],
            [31.37201044141877, 2.620188908443],
            [31.368139505638084, 2.620425864173683],
            [31.365512979969353, 2.619898028427901],
            [31.36318621043281, 2.620197502614066],
            [31.36106104081235, 2.619690486803742],
            [31.359614273504537, 2.621846634732471],
            [31.35798868935293, 2.62271174514331],
            [31.35712661659894, 2.622488750300132],
            [31.356503727475893, 2.623395519052226],
            [31.354617823233035, 2.62395774785124],
            [31.352152520903275, 2.622845203540574],
            [31.34999708434594, 2.614835395179695],
            [31.34867653303051, 2.612494086529722],
            [31.347534708727363, 2.61150431369346],
            [31.345833469360837, 2.608900311176713],
            [31.342126436593627, 2.606555847028105],
            [31.340788490301037, 2.602197665302079],
            [31.340610904149134, 2.599978890665251],
            [31.33975028037773, 2.598666795522888],
            [31.338213558472304, 2.597265127584811],
            [31.334329596221675, 2.596422821265778],
            [31.335744613474077, 2.592907182092368],
            [31.34167804162124, 2.58183900858032],
            [31.344279321935545, 2.582183619516853],
            [31.349165535446993, 2.583772227620766],
            [31.35989927301157, 2.582241676115514],
            [31.36242973014891, 2.580662738320639],
            [31.36426501252886, 2.580796968449128],
            [31.36600146495621, 2.578782823133899],
            [31.369296982186725, 2.569168152389493],
            [31.369108958509553, 2.567349406806859],
            [31.367587873578294, 2.566103214588098],
            [31.36055032701375, 2.56236145289161],
            [31.35903133246218, 2.559488188419451],
            [31.35394279319593, 2.557280293180098],
            [31.35189851686679, 2.555889859360382],
            [31.345625055723335, 2.550091308025699],
            [31.34476888400245, 2.549850926250987],
            [31.34286780811275, 2.548125693887847],
            [31.34258348144387, 2.547216085731327],
            [31.344156376709126, 2.545112511709658],
            [31.34873908901195, 2.533441836101961],
            [31.348414325578865, 2.526885301716103],
            [31.349037782437176, 2.523009853259163],
            [31.35360739011661, 2.521580033160795],
            [31.35541080116861, 2.521397074530737],
            [31.35805915589874, 2.523237808623928],
            [31.36514586097062, 2.527007891362965],
            [31.36718519476906, 2.527547774238758],
            [31.36790216984171, 2.526971360997353],
            [31.370226074650805, 2.527056302060588],
            [31.3707582474049, 2.527631146536899],
            [31.373428343161553, 2.527587918584329],
            [31.374509671320173, 2.529484585829185],
            [31.377531575189863, 2.53765320527666],
            [31.38061081942245, 2.539403497212955],
            [31.384339567165025, 2.540201619246262],
            [31.386956147585288, 2.540251897905192],
            [31.390159608160417, 2.533013105121888],
            [31.39214199685465, 2.531908814014753],
            [31.392803838725076, 2.53069219399786],
            [31.392587819052093, 2.52737161726033],
            [31.39303172244803, 2.52438389387623],
            [31.394684875895717, 2.522504439354029],
            [31.398979370926142, 2.520628251511987],
            [31.402063242380773, 2.518750548766531],
            [31.407242343505743, 2.513444401659689],
            [31.41088008741846, 2.508579033944057],
            [31.410112372803624, 2.506364537287211],
            [31.412868698742688, 2.502272815721338],
            [31.41455964521271, 2.498461580264839],
            [31.414609812528077, 2.493217969745876],
            [31.41608588288044, 2.486643828954643],
            [31.41977525387085, 2.4814730354374],
            [31.41962834698252, 2.478682484971486],
            [31.4217517882444, 2.475708959138303],
            [31.423066793361254, 2.472713028253521],
            [31.423891288688594, 2.467702390808602],
            [31.425434285326247, 2.466101440396609],
            [31.426646651633703, 2.465956140532782],
            [31.43236676493518, 2.467198090959136],
            [31.43583869691445, 2.468989471249949],
            [31.44256992245868, 2.468461325799709],
            [31.445943962326485, 2.467023989200935],
            [31.451638037959455, 2.466763157370987],
            [31.454823237581483, 2.466208713880215],
            [31.45481637894428, 2.469440870194736],
            [31.454108463381257, 2.472900919924124],
            [31.454385730190353, 2.475369247066808],
            [31.457452957659395, 2.475387511622085],
            [31.4583625935127, 2.474846587742214],
            [31.463332113190315, 2.474872147000915],
            [31.467927640858967, 2.475588646082934],
            [31.470911902623318, 2.476816868678461],
            [31.47216862055297, 2.478062204987802],
            [31.475974669224044, 2.481195288184329],
            [31.48096481691554, 2.484120732236548],
            [31.484329596949397, 2.486693931080247],
            [31.485987001225027, 2.488970360154167],
            [31.492475999646153, 2.49148710968802],
            [31.49326343856972, 2.492961825155916],
            [31.49698073728399, 2.49546024265129],
            [31.495289634507113, 2.495571666316172],
            [31.492345123194095, 2.49832797429104],
            [31.49050362267573, 2.499175086066752],
            [31.485096757303726, 2.500242748139077],
            [31.48087424787028, 2.502511283049168],
            [31.478007423761344, 2.505387632810339],
            [31.47543998567873, 2.510007291471835],
            [31.469206478904184, 2.524284703926322],
            [31.46625779132342, 2.53261711881462],
            [31.465575204658165, 2.536329574200099],
            [31.464839612899535, 2.552962614716558],
            [31.464042902463955, 2.557546402610072],
            [31.461301282844367, 2.563408190803226],
            [31.45868115946865, 2.567012521283861],
            [31.454834429691623, 2.569887510731031],
            [31.44393124471161, 2.581354882684817],
            [31.432545627593083, 2.586645390702628],
            [31.419753342164416, 2.601974724248998],
            [31.41658163883121, 2.607275261326098],
            [31.412705137089038, 2.617007451214231],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 604,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "PANYANGO",
        Population: 28319,
        Key: "PAKWACHPANYANGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.34519050109453, 2.404728952805074],
            [31.34258035979826, 2.40535374079899],
            [31.34002462496716, 2.405346344305425],
            [31.3381251265191, 2.406971655714234],
            [31.335580832631468, 2.406666077912823],
            [31.335154290975, 2.407597066458549],
            [31.333061350212002, 2.407052159012699],
            [31.332471491243595, 2.410058556874702],
            [31.33197291278619, 2.410512632262107],
            [31.33107630519942, 2.407115290756008],
            [31.330456655401267, 2.406090744952645],
            [31.33050170231952, 2.404421027474831],
            [31.33014427254944, 2.403873060893091],
            [31.32794470266051, 2.403554934100891],
            [31.325446125834294, 2.402008956331927],
            [31.324329605276116, 2.40258337194688],
            [31.324162865382974, 2.402368993450017],
            [31.32337441675303, 2.399746670195591],
            [31.32558495417326, 2.399456546203476],
            [31.32570236218427, 2.398478412125773],
            [31.32315706577678, 2.39748111869557],
            [31.32137381741133, 2.397341145456706],
            [31.32056572621939, 2.397485679937756],
            [31.31931918530359, 2.398549287241829],
            [31.317676982319213, 2.397335726176247],
            [31.317061429737088, 2.399054144102966],
            [31.313298763406014, 2.394743569154484],
            [31.313487526396667, 2.393789161541766],
            [31.313082246066333, 2.39302661507786],
            [31.30774257827084, 2.391354442157077],
            [31.305436765531585, 2.39150159986072],
            [31.304346831512508, 2.393960231012381],
            [31.302301285863866, 2.393272116053667],
            [31.301376387633876, 2.394800237450201],
            [31.301046239698987, 2.396613548077935],
            [31.298282272690074, 2.400446564634269],
            [31.296926551432943, 2.400019591220582],
            [31.295639474938287, 2.397779781297854],
            [31.294854003325188, 2.3971371595258],
            [31.293808223298978, 2.397305941674149],
            [31.292597950964453, 2.398786847693949],
            [31.29064758271849, 2.3981462404489],
            [31.289967959595355, 2.396728473139416],
            [31.28944287365053, 2.39404689842407],
            [31.290964841625698, 2.372879925664069],
            [31.29434673097247, 2.343971121490795],
            [31.293425287663048, 2.340336584398991],
            [31.28884291043184, 2.329849115780159],
            [31.287228000960738, 2.324111372450826],
            [31.28590369917899, 2.317414149911889],
            [31.284101685905576, 2.310850965240989],
            [31.280600035860093, 2.303971159821553],
            [31.281289317669152, 2.303303974509434],
            [31.28115293634105, 2.300906755936284],
            [31.280501010074754, 2.299935615970643],
            [31.280765857675007, 2.299508934053287],
            [31.28174915358501, 2.300146501519922],
            [31.28273098524108, 2.299825087429739],
            [31.284112112651087, 2.300195560280352],
            [31.284535850665545, 2.299502205704372],
            [31.284560667523593, 2.298356708322442],
            [31.282992886367218, 2.29745379447726],
            [31.284133488063254, 2.296785798282273],
            [31.285700263106477, 2.29702274053789],
            [31.28626619904055, 2.297858228372863],
            [31.28766774605524, 2.297211728830292],
            [31.289104411807667, 2.29797573315791],
            [31.289153709553847, 2.296001732987587],
            [31.28842489558405, 2.294658542011287],
            [31.288188394322578, 2.292736632844535],
            [31.288949351809848, 2.290674626785888],
            [31.288997757528946, 2.288931935783712],
            [31.2882091031848, 2.285434622799334],
            [31.287889231078434, 2.280895099555629],
            [31.286534854599296, 2.276219667064199],
            [31.284201622582604, 2.276761972973034],
            [31.283672160944047, 2.276063768069064],
            [31.283457192299934, 2.274218513060214],
            [31.28146745448831, 2.27443849246214],
            [31.279700856396666, 2.272900034418355],
            [31.276968401389603, 2.272431809409831],
            [31.27687352043101, 2.271797360493151],
            [31.27475033249404, 2.269613311314587],
            [31.274536510998555, 2.267230546387879],
            [31.27498625524048, 2.266263870825916],
            [31.27431489032973, 2.265653682581466],
            [31.273999761328078, 2.264233751397449],
            [31.273939215776238, 2.258827067058547],
            [31.271387806333234, 2.254266298860928],
            [31.267085787912325, 2.250869068564411],
            [31.264711961926263, 2.249482028001625],
            [31.26275803006354, 2.248846930842591],
            [31.258133639524846, 2.249913132943113],
            [31.256932301834127, 2.249556109726398],
            [31.258210119393166, 2.248110567972838],
            [31.25737734968376, 2.246008971343499],
            [31.257470904729043, 2.245378904762527],
            [31.25832970132719, 2.245099856288434],
            [31.25999956254083, 2.2456620185287],
            [31.260733596620724, 2.245190887203608],
            [31.262502961523463, 2.239893165391943],
            [31.263468928931623, 2.238168479014935],
            [31.264345799633304, 2.237658397099983],
            [31.264676891697576, 2.232374379160385],
            [31.266436148756704, 2.227159716078562],
            [31.267246882792207, 2.220988739870084],
            [31.267223258896873, 2.216820233532866],
            [31.266236120892415, 2.21028142133737],
            [31.26377574492367, 2.201277582261629],
            [31.25942395534444, 2.189236062913044],
            [31.30641025453361, 2.154195681253644],
            [31.309383908991066, 2.161802256122489],
            [31.311324404752064, 2.170233562388373],
            [31.31821046481701, 2.192668316167242],
            [31.321538563044555, 2.201830219154894],
            [31.3241074267535, 2.211449188643441],
            [31.33554916611939, 2.245450756096104],
            [31.336513839953565, 2.247427379098311],
            [31.33882583040702, 2.25297746933848],
            [31.343273940944297, 2.261068440789069],
            [31.3503967843417, 2.270991725462645],
            [31.357553633464203, 2.279434173608334],
            [31.36786445676946, 2.290434957474834],
            [31.377494797263832, 2.2994692039422],
            [31.389134329485596, 2.308654773813013],
            [31.3962380172079, 2.313395534055451],
            [31.389564715931474, 2.32379191511967],
            [31.386871742779476, 2.330474315413378],
            [31.38162311923804, 2.341070471861673],
            [31.37960301387827, 2.346335462852392],
            [31.376564325885813, 2.360252580156774],
            [31.373662010238316, 2.366800207159158],
            [31.370658638612916, 2.371762876590128],
            [31.36925688229076, 2.374973016105667],
            [31.36858610397992, 2.377260380879582],
            [31.368280190794714, 2.382451424714173],
            [31.365371733365638, 2.388720231506878],
            [31.36241432494009, 2.393402805641191],
            [31.358618693133025, 2.397340368196528],
            [31.357433753289516, 2.397925685361339],
            [31.354178305412265, 2.39776820586933],
            [31.3506529119955, 2.395919931695656],
            [31.348443015074064, 2.395247362948235],
            [31.344420540691484, 2.395254522548419],
            [31.345161954431433, 2.401213450095034],
            [31.34519050109453, 2.404728952805074],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 605,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "PANYIMUR",
        Population: 43366,
        Key: "PAKWACHPANYIMUR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.442314808104513, 2.676856965154594],
            [31.44241476095122, 2.679829201779988],
            [31.445836991840782, 2.685251855828583],
            [31.45080858842332, 2.687228495723896],
            [31.452012421633885, 2.688821419609375],
            [31.45238628248883, 2.691171086850882],
            [31.45223277477983, 2.693368521428942],
            [31.453916181689642, 2.703108453580817],
            [31.453834951530073, 2.707730952473985],
            [31.450406290499753, 2.718040922163875],
            [31.451962632509257, 2.724927957237194],
            [31.451371420678054, 2.728271346333761],
            [31.44960355326691, 2.733777068574022],
            [31.44900953060719, 2.73928430888866],
            [31.445481559025552, 2.744197567924874],
            [31.43803088265174, 2.756580759929027],
            [31.432350669820245, 2.761491075543856],
            [31.4286320757353, 2.762469698426703],
            [31.42315421830304, 2.76226568402303],
            [31.41474403520456, 2.760287309924649],
            [31.409850542644392, 2.762051133820253],
            [31.40221537746401, 2.765778321877956],
            [31.393604084929635, 2.76793042828029],
            [31.386941768252516, 2.775592967916036],
            [31.35705195671737, 2.770346550253579],
            [31.354113408421217, 2.768111051751102],
            [31.348695707570222, 2.765888030040248],
            [31.339989204395508, 2.764058813413489],
            [31.334771491883, 2.76150752343878],
            [31.32974402188639, 2.757657462605443],
            [31.327540864126217, 2.754975104410665],
            [31.32555500703662, 2.751057275116092],
            [31.325358446669327, 2.748144257498582],
            [31.326575551589908, 2.743468868090306],
            [31.33070311089441, 2.736994256050895],
            [31.32980854966986, 2.735209615637034],
            [31.327162799155754, 2.733781781156514],
            [31.322668609536, 2.733218205687813],
            [31.31836010887196, 2.731973775804224],
            [31.30931690185741, 2.726078795398257],
            [31.30081356705724, 2.719157427084321],
            [31.298231454994436, 2.71527771771558],
            [31.291770272906064, 2.70982616686216],
            [31.29050619867255, 2.707488131659007],
            [31.285444639407554, 2.701905835428599],
            [31.28500149239308, 2.69784334602172],
            [31.289619004531662, 2.681071441873626],
            [31.291050346867724, 2.677038128116698],
            [31.292638300592085, 2.675391821613728],
            [31.291979975625996, 2.675362633063633],
            [31.291525673332323, 2.67531042155833],
            [31.291714589036555, 2.673857315743515],
            [31.293144158098237, 2.670706202447368],
            [31.293614763017697, 2.667684039853973],
            [31.29468088808847, 2.665001468714563],
            [31.29546322008965, 2.661406439796477],
            [31.296656234889234, 2.64173366601282],
            [31.29676535504342, 2.637720751718033],
            [31.295387387008308, 2.622057488209433],
            [31.294535980849986, 2.590093466949974],
            [31.296874715946128, 2.588725993856543],
            [31.29805941414282, 2.589509227797616],
            [31.29813602875844, 2.590449106451901],
            [31.298525103481026, 2.590658471022168],
            [31.299538174051126, 2.589646150081429],
            [31.30034223001081, 2.590556507854998],
            [31.301899265519737, 2.59084576228329],
            [31.302131868092875, 2.591603118485874],
            [31.305246538286998, 2.591737843716891],
            [31.306439763292364, 2.592339863742219],
            [31.30802307721832, 2.592394205554101],
            [31.312073878176772, 2.591277131091009],
            [31.313292238043793, 2.592505701609442],
            [31.31495280618583, 2.59303002925803],
            [31.31671201743091, 2.595670146959376],
            [31.318026989310106, 2.596095276341003],
            [31.318130689928207, 2.597259676822904],
            [31.318893105381196, 2.597710527621374],
            [31.31920785349718, 2.598451843323595],
            [31.32075938143507, 2.599062512797096],
            [31.32249620845991, 2.598826690931744],
            [31.323626664583127, 2.599516176272191],
            [31.324991682505114, 2.601899453939021],
            [31.32591196968277, 2.602350513068697],
            [31.327251170921812, 2.604363308904675],
            [31.327276678584294, 2.60497193754941],
            [31.32840293149029, 2.606148406858925],
            [31.32875720098721, 2.608122872014411],
            [31.329232407077573, 2.608602051147555],
            [31.334329596221675, 2.596422821265778],
            [31.338213558472304, 2.597265127584811],
            [31.33975028037773, 2.598666795522888],
            [31.340610904149134, 2.599978890665251],
            [31.340788490301037, 2.602197665302079],
            [31.342126436593627, 2.606555847028105],
            [31.345833469360837, 2.608900311176713],
            [31.347534708727363, 2.61150431369346],
            [31.34867653303051, 2.612494086529722],
            [31.34999708434594, 2.614835395179695],
            [31.352152520903275, 2.622845203540574],
            [31.354617823233035, 2.62395774785124],
            [31.356503727475893, 2.623395519052226],
            [31.35712661659894, 2.622488750300132],
            [31.35798868935293, 2.62271174514331],
            [31.359614273504537, 2.621846634732471],
            [31.36106104081235, 2.619690486803742],
            [31.36318621043281, 2.620197502614066],
            [31.365512979969353, 2.619898028427901],
            [31.368139505638084, 2.620425864173683],
            [31.37201044141877, 2.620188908443],
            [31.37301387306588, 2.619665829590109],
            [31.375519142340934, 2.62091957340098],
            [31.376823400912045, 2.620396883417151],
            [31.38047312206246, 2.620643666270797],
            [31.38169837919423, 2.61917292571289],
            [31.38360395564349, 2.618913205084805],
            [31.384107222408385, 2.617441522940136],
            [31.385552458088615, 2.616455115587449],
            [31.38587455442362, 2.615507589116965],
            [31.38531396616047, 2.614760611121972],
            [31.385295615375835, 2.613429433329458],
            [31.386420531588684, 2.61199888881754],
            [31.390371871977205, 2.611620777761737],
            [31.39103500113343, 2.61059301083727],
            [31.392780769090283, 2.609828834255508],
            [31.393864188526877, 2.609977790938441],
            [31.395872024696523, 2.612652880890168],
            [31.40283688407986, 2.614756488558246],
            [31.412705137089038, 2.617007451214231],
            [31.41170692106048, 2.618446478306783],
            [31.411399934388548, 2.622841264965141],
            [31.412451333376875, 2.625722208874682],
            [31.415760764612802, 2.630803633822109],
            [31.414778587105317, 2.632772633728026],
            [31.41515174368111, 2.635652714772396],
            [31.420492586472978, 2.643389028720621],
            [31.423653741788133, 2.646575804552985],
            [31.425680838735776, 2.652640750913429],
            [31.431097723018148, 2.659922518794011],
            [31.433656513019503, 2.662729639978961],
            [31.440394013296025, 2.668686963340939],
            [31.441972250842284, 2.672174856587926],
            [31.442314808104513, 2.676856965154594],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 606,
        District: "PAKWACH",
        County: "JONAM",
        Subcounty: "WADELAI",
        Population: 24146,
        Key: "PAKWACHWADELAI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.287228000960738, 2.324111372450826],
            [31.284901939296645, 2.324575497434756],
            [31.285011303792608, 2.326161430849125],
            [31.285591775366246, 2.32727949385987],
            [31.285357184821404, 2.327811787650145],
            [31.283942034618324, 2.327116461141742],
            [31.28213230212169, 2.326891301884125],
            [31.28139200947918, 2.328141336390575],
            [31.28007500650912, 2.327743380841843],
            [31.28004333730211, 2.328029052598705],
            [31.273066335391075, 2.329889835062408],
            [31.263815565443576, 2.333889582828113],
            [31.250536904272334, 2.338706121612379],
            [31.247108547770864, 2.341237993481149],
            [31.243302410166578, 2.341520310088732],
            [31.241923234795703, 2.341183602810921],
            [31.237929690656845, 2.33916875989984],
            [31.23621115063625, 2.339154873644708],
            [31.235523077959517, 2.338290646744682],
            [31.23279679258185, 2.339851739809033],
            [31.230155491423332, 2.339800425942449],
            [31.22380885980504, 2.337386783612838],
            [31.217463532540528, 2.335900707509136],
            [31.219472054124722, 2.332789711645818],
            [31.22003172071642, 2.330921960675437],
            [31.220105525401852, 2.327628888985971],
            [31.21911233365069, 2.324828038512351],
            [31.219365481592668, 2.318225514070896],
            [31.219763900590873, 2.316654469802536],
            [31.219615409074397, 2.314179680424755],
            [31.21829055482877, 2.310636160627076],
            [31.217514479593547, 2.306495210435336],
            [31.214065169888112, 2.297963712594132],
            [31.213682228862268, 2.294161385622153],
            [31.212920401805775, 2.293968931310651],
            [31.213157524701437, 2.293610234197205],
            [31.21289530916495, 2.29339449258764],
            [31.211374202674136, 2.294134466739892],
            [31.211030577315018, 2.294744326953648],
            [31.210506361837712, 2.294408578849082],
            [31.21041259568835, 2.29503072971049],
            [31.209794884454606, 2.2954367997091],
            [31.20927034468548, 2.294957448280456],
            [31.2085090072108, 2.294980395290497],
            [31.208391769879707, 2.295746116113937],
            [31.20688969958808, 2.294379955438294],
            [31.20736243171814, 2.292992425287362],
            [31.20491289841489, 2.293515783798244],
            [31.20451030135232, 2.294352932439119],
            [31.20420082455041, 2.29428072988374],
            [31.20384143824965, 2.293179323611745],
            [31.203246927804713, 2.293322151754163],
            [31.203292083419107, 2.292245204248185],
            [31.202840171542377, 2.292316417755006],
            [31.20245769494557, 2.291526116199485],
            [31.20316960352002, 2.29068936982399],
            [31.203718742754898, 2.291527755211449],
            [31.203830089832653, 2.21812587263647],
            [31.248275540173328, 2.197434080256637],
            [31.25942395534444, 2.189236062913044],
            [31.26377574492367, 2.201277582261629],
            [31.266236120892415, 2.21028142133737],
            [31.267223258896873, 2.216820233532866],
            [31.267246882792207, 2.220988739870084],
            [31.266436148756704, 2.227159716078562],
            [31.264676891697576, 2.232374379160385],
            [31.264345799633304, 2.237658397099983],
            [31.263468928931623, 2.238168479014935],
            [31.262502961523463, 2.239893165391943],
            [31.260733596620724, 2.245190887203608],
            [31.25999956254083, 2.2456620185287],
            [31.25832970132719, 2.245099856288434],
            [31.257470904729043, 2.245378904762527],
            [31.25737734968376, 2.246008971343499],
            [31.258210119393166, 2.248110567972838],
            [31.256932301834127, 2.249556109726398],
            [31.258133639524846, 2.249913132943113],
            [31.26275803006354, 2.248846930842591],
            [31.264711961926263, 2.249482028001625],
            [31.267085787912325, 2.250869068564411],
            [31.271387806333234, 2.254266298860928],
            [31.273939215776238, 2.258827067058547],
            [31.273999761328078, 2.264233751397449],
            [31.27431489032973, 2.265653682581466],
            [31.27498625524048, 2.266263870825916],
            [31.274536510998555, 2.267230546387879],
            [31.27475033249404, 2.269613311314587],
            [31.27687352043101, 2.271797360493151],
            [31.276968401389603, 2.272431809409831],
            [31.279700856396666, 2.272900034418355],
            [31.28146745448831, 2.27443849246214],
            [31.283457192299934, 2.274218513060214],
            [31.283672160944047, 2.276063768069064],
            [31.284201622582604, 2.276761972973034],
            [31.286534854599296, 2.276219667064199],
            [31.287889231078434, 2.280895099555629],
            [31.2882091031848, 2.285434622799334],
            [31.288997757528946, 2.288931935783712],
            [31.288949351809848, 2.290674626785888],
            [31.288188394322578, 2.292736632844535],
            [31.28842489558405, 2.294658542011287],
            [31.289153709553847, 2.296001732987587],
            [31.289104411807667, 2.29797573315791],
            [31.28766774605524, 2.297211728830292],
            [31.28626619904055, 2.297858228372863],
            [31.285700263106477, 2.29702274053789],
            [31.284133488063254, 2.296785798282273],
            [31.282992886367218, 2.29745379447726],
            [31.284560667523593, 2.298356708322442],
            [31.284535850665545, 2.299502205704372],
            [31.284112112651087, 2.300195560280352],
            [31.28273098524108, 2.299825087429739],
            [31.28174915358501, 2.300146501519922],
            [31.280765857675007, 2.299508934053287],
            [31.280501010074754, 2.299935615970643],
            [31.28115293634105, 2.300906755936284],
            [31.281289317669152, 2.303303974509434],
            [31.280600035860093, 2.303971159821553],
            [31.284101685905576, 2.310850965240989],
            [31.28590369917899, 2.317414149911889],
            [31.287228000960738, 2.324111372450826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 607,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "AKWORO",
        Population: 25375,
        Key: "NEBBIAKWORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.170104052521076, 2.464932591720976],
            [31.168705155536454, 2.465135034501812],
            [31.167305477017557, 2.465857728780684],
            [31.16322539457408, 2.471576755826343],
            [31.16269027444754, 2.474200994395225],
            [31.16258936938664, 2.484368407316152],
            [31.157295583044267, 2.486603638479505],
            [31.154077954240485, 2.483998979504917],
            [31.151789063964515, 2.484081008369593],
            [31.148341000222352, 2.480585096083501],
            [31.143211906512608, 2.483055071915619],
            [31.14276918979114, 2.482295660646149],
            [31.14168234058679, 2.482003999151571],
            [31.14128412011628, 2.481190967748808],
            [31.142174350562822, 2.480607386632956],
            [31.14145746981327, 2.479539902504535],
            [31.141769394524342, 2.478397643490161],
            [31.141109075298335, 2.476008038766999],
            [31.14173887785581, 2.475236122494518],
            [31.141461111583435, 2.474041394106436],
            [31.14104156959965, 2.474321822728768],
            [31.140878325949608, 2.473100811754313],
            [31.135699129603214, 2.475102654175077],
            [31.13327636519711, 2.4755173253867],
            [31.122620436109155, 2.475410268049617],
            [31.122337197300062, 2.474885157730521],
            [31.123318251015114, 2.471811286076087],
            [31.123312267337017, 2.468963328515053],
            [31.123068226515336, 2.466067161021041],
            [31.122670205470843, 2.465922096294131],
            [31.12216266182687, 2.464244178158159],
            [31.121152747038376, 2.457203501740147],
            [31.116061572115104, 2.451695432488684],
            [31.115878770344658, 2.449830479321327],
            [31.11444475911389, 2.44773066781065],
            [31.112593182192988, 2.445909970978673],
            [31.110948347144852, 2.442032094070114],
            [31.114857740701172, 2.441541480382025],
            [31.12017130794607, 2.440173792307387],
            [31.12000097299517, 2.438857484808504],
            [31.119071473594275, 2.438717643283385],
            [31.11765222797184, 2.435876267525137],
            [31.117404742111056, 2.434865627856453],
            [31.11788786864729, 2.433676968213662],
            [31.11662543922903, 2.432763482783547],
            [31.11673389462993, 2.431476184428458],
            [31.11565834084192, 2.431474673027491],
            [31.116404030562652, 2.429065723917757],
            [31.116111962212656, 2.42779872368925],
            [31.115494109943366, 2.427151843059691],
            [31.117367663249393, 2.425866279627997],
            [31.121086394776565, 2.421617488225685],
            [31.121295456997668, 2.420947853572011],
            [31.120448484025317, 2.41960197307864],
            [31.119261215748573, 2.418810571586863],
            [31.11835149635193, 2.416802927075717],
            [31.11845930586412, 2.415565102630975],
            [31.119501554612942, 2.413794968077807],
            [31.121243403220223, 2.412516725609603],
            [31.12179528501167, 2.412410770786761],
            [31.122876538610132, 2.413137985475198],
            [31.124001757555238, 2.412755348983744],
            [31.125405829734202, 2.410195958310389],
            [31.126955547566805, 2.409749869855808],
            [31.12863393109758, 2.408322109023378],
            [31.130267185963405, 2.405462535935913],
            [31.13034878353392, 2.401210944200987],
            [31.129976280931682, 2.401194140709518],
            [31.129851891214297, 2.397378494332705],
            [31.13024552309033, 2.3965177475675],
            [31.13160203037332, 2.395981305692195],
            [31.134706339398953, 2.395770243431558],
            [31.138871435705973, 2.394177164303045],
            [31.14051326229623, 2.393915706280449],
            [31.1419447762105, 2.391376902919605],
            [31.145914172736248, 2.389419970021975],
            [31.15072984334503, 2.388194140545756],
            [31.156655828051743, 2.38875282188891],
            [31.1621599917488, 2.386809911046247],
            [31.16321987352835, 2.385211439885361],
            [31.164785666712984, 2.385631539188998],
            [31.16763520723583, 2.389224140602297],
            [31.169290131262972, 2.396822613205671],
            [31.170416867462574, 2.399156838347317],
            [31.171469244716235, 2.399277881642068],
            [31.172990032305123, 2.400428338553021],
            [31.175010779062017, 2.401244515282308],
            [31.176199773002427, 2.401485366495132],
            [31.178935606573233, 2.401178010362703],
            [31.18309079536097, 2.4067821177495],
            [31.18337461448172, 2.408002692632409],
            [31.1819446950771, 2.410058354035036],
            [31.179971086516392, 2.409553266992113],
            [31.17878160568913, 2.40967129279672],
            [31.175168782839023, 2.407632776178366],
            [31.17322050497274, 2.405979306659484],
            [31.170724191901044, 2.405042855575615],
            [31.17039041836567, 2.405616609336329],
            [31.17086240579236, 2.408416496903953],
            [31.170834205878943, 2.411718138037472],
            [31.169902084295757, 2.415042480143433],
            [31.16961270011182, 2.417984887235874],
            [31.17170408050119, 2.419351462429906],
            [31.174060099183357, 2.418493348494703],
            [31.175343867182843, 2.419021442698712],
            [31.175765863363996, 2.419556093937439],
            [31.175030202435092, 2.420894762057628],
            [31.17477902180355, 2.422397968043526],
            [31.17074977412372, 2.4231860349782],
            [31.168085538077666, 2.42552965311477],
            [31.166207941454537, 2.426556141719086],
            [31.162117703556806, 2.427723118430511],
            [31.160880099081467, 2.427601715972356],
            [31.155139055033853, 2.424602038042557],
            [31.155033599107732, 2.425355773017438],
            [31.1569455365275, 2.42923557911199],
            [31.15715388728293, 2.43207191052409],
            [31.1577982587177, 2.432958333041404],
            [31.15865514190429, 2.43307920638714],
            [31.158587559848822, 2.434850140522991],
            [31.159828149425852, 2.436359659275744],
            [31.160163750134565, 2.437508909012485],
            [31.16068719485736, 2.437485714855429],
            [31.161633403820826, 2.440418825237016],
            [31.16258773535112, 2.441592883784542],
            [31.16306893320442, 2.44405864993745],
            [31.164658802136994, 2.44754313338688],
            [31.16478034599154, 2.448739950662518],
            [31.16532882406639, 2.449291182993357],
            [31.165593756108265, 2.45077539863263],
            [31.16532105543579, 2.451217771369827],
            [31.16587045787705, 2.452199798331536],
            [31.166208980805344, 2.454713234947296],
            [31.165783988742735, 2.456268272682643],
            [31.164667077417395, 2.456960742528503],
            [31.164599058780695, 2.458963646731696],
            [31.1648512015079, 2.459605591110714],
            [31.165851083911317, 2.459822406169066],
            [31.16709163755573, 2.461308008394714],
            [31.16819873029503, 2.461584808473222],
            [31.169606166664764, 2.463214246012333],
            [31.169537134728415, 2.464315065077153],
            [31.170104052521076, 2.464932591720976],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 608,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "ATEGO",
        Population: 9958,
        Key: "NEBBIATEGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.082169834261155, 2.414219168333313],
            [31.08052183624487, 2.41422820992909],
            [31.07727737835681, 2.415838868641119],
            [31.07561241835133, 2.416123616610276],
            [31.074541299545924, 2.415930596657736],
            [31.07237100754872, 2.413510325527764],
            [31.065525616911636, 2.411238763761216],
            [31.063931601355723, 2.411308219235431],
            [31.062243914871907, 2.412095481251645],
            [31.061528360934002, 2.411256827246872],
            [31.061722557833832, 2.413099838239059],
            [31.06105624055667, 2.413050994373838],
            [31.059411194404415, 2.411469096969532],
            [31.058110331465066, 2.409492838695251],
            [31.057630966174944, 2.407816933379404],
            [31.056821143929465, 2.407408908072755],
            [31.055795182535046, 2.406043308152565],
            [31.055272380107674, 2.406353648351346],
            [31.054343793395134, 2.406041172944546],
            [31.054341794643623, 2.405083913707655],
            [31.055231117791728, 2.403685234975272],
            [31.054872769045126, 2.402990697729666],
            [31.053707401695007, 2.403228298695837],
            [31.053349254171017, 2.402629487709554],
            [31.054774845492627, 2.401674326291143],
            [31.0561781945278, 2.401461004040112],
            [31.056293607380553, 2.399762043046101],
            [31.054624931943078, 2.398251916350936],
            [31.05424248948222, 2.397413756452732],
            [31.054870728072785, 2.396325799182589],
            [31.054177922172848, 2.394984626148743],
            [31.05439010603959, 2.394051612258008],
            [31.053934780564795, 2.392495405346152],
            [31.053124614264554, 2.391919865376511],
            [31.05136458465426, 2.392228394867383],
            [31.050991810760795, 2.390325306228634],
            [31.05120424346087, 2.389511952020389],
            [31.047913357045655, 2.385941365237723],
            [31.04876739257281, 2.384746048927365],
            [31.047917506363945, 2.3822439837387],
            [31.048914946248118, 2.381359983008524],
            [31.04910337955704, 2.38045086853964],
            [31.047296236005028, 2.380974716817083],
            [31.04660253358646, 2.379202786419787],
            [31.0454579757099, 2.378004549943709],
            [31.04365088785345, 2.378552325807493],
            [31.0424355598005, 2.377641161296749],
            [31.04154561681483, 2.378728729466284],
            [31.040427614934707, 2.378846747155306],
            [31.039758817409055, 2.377601344541501],
            [31.039565020259566, 2.375949808032098],
            [31.03880380944735, 2.376020486850512],
            [31.036951496806225, 2.377692952157215],
            [31.036710268609728, 2.376113142901254],
            [31.035687842085956, 2.376422747602062],
            [31.035044244998947, 2.375847455812469],
            [31.03561326215443, 2.374891045236312],
            [31.03544591320352, 2.374507900827541],
            [31.034019917640055, 2.3752476743097],
            [31.033450550141605, 2.376036564537702],
            [31.03235549752206, 2.375747781854018],
            [31.032357347153223, 2.376633234815259],
            [31.031622378825443, 2.377876570366618],
            [31.0304786438057, 2.377061231516364],
            [31.02886175804095, 2.377537470967405],
            [31.039786036362177, 2.367885319187911],
            [31.073840091703126, 2.34320120642532],
            [31.06918512520706, 2.335967237104505],
            [31.069229022281725, 2.334244222609617],
            [31.070081855863034, 2.332522353098319],
            [31.070101443627774, 2.330559986891195],
            [31.07227301662257, 2.328038268886994],
            [31.072675377428236, 2.327057637702356],
            [31.074165286327528, 2.32287169331159],
            [31.07370973717225, 2.321243696587373],
            [31.07432735318457, 2.320789863040927],
            [31.076362222356067, 2.321091871231988],
            [31.0767411964216, 2.320302656473122],
            [31.07669965652622, 2.317586346251286],
            [31.077293169841184, 2.316988885136329],
            [31.07884042898487, 2.317350031240392],
            [31.078742215276538, 2.315937918976684],
            [31.079904204961167, 2.314168594381423],
            [31.084926782732744, 2.309808048566926],
            [31.08570881110333, 2.308373226145109],
            [31.08207008623032, 2.30354589820095],
            [31.078853879459608, 2.301555083094394],
            [31.077044872801725, 2.301169655835675],
            [31.075356016711357, 2.301334824213193],
            [31.07466729814597, 2.301908224820315],
            [31.073981267339907, 2.303726076688128],
            [31.07243469720403, 2.303676051345579],
            [31.070077245708994, 2.302715488670743],
            [31.07595817541262, 2.299241637441816],
            [31.076264721910068, 2.297973683055798],
            [31.075998761297154, 2.296010910887312],
            [31.07721089404263, 2.295438234962636],
            [31.07878166658887, 2.295679733630466],
            [31.081014610687234, 2.294079402858621],
            [31.081895528299267, 2.294367804693011],
            [31.082396559157388, 2.295014659174543],
            [31.083491033261897, 2.295040106882507],
            [31.083510769248694, 2.293173450641871],
            [31.085196028484653, 2.291356960459744],
            [31.085526665103068, 2.290232619213692],
            [31.086584329840477, 2.289743475940236],
            [31.086653254877277, 2.288618772593393],
            [31.088622646746, 2.286180432771092],
            [31.092617464695977, 2.28518078218732],
            [31.095663806334642, 2.285639669798433],
            [31.095883310572635, 2.282660435156631],
            [31.097921696648434, 2.27914521495013],
            [31.10009651615468, 2.278178934233893],
            [31.10100181045025, 2.27873060591258],
            [31.101762831717913, 2.27858805098525],
            [31.102213982721594, 2.278181820034804],
            [31.102282730790265, 2.276985309033426],
            [31.103070118509866, 2.27801546055911],
            [31.10392362672593, 2.276652491049815],
            [31.106419711625527, 2.275722529423385],
            [31.106989029716605, 2.274957472921068],
            [31.108773678555593, 2.275079554685199],
            [31.10999676984923, 2.274088026023677],
            [31.110469652896228, 2.272748461538133],
            [31.112393041140965, 2.271051873392066],
            [31.113320340567736, 2.270789871869137],
            [31.113521223628194, 2.270179869543963],
            [31.1152572861867, 2.26984715949947],
            [31.11637735329365, 2.270686299356565],
            [31.117897493197226, 2.269539596838213],
            [31.119495040928822, 2.271121281060218],
            [31.11973142451101, 2.270427560580002],
            [31.12337698915659, 2.267500741957193],
            [31.12382500414161, 2.265682480700574],
            [31.124966429592746, 2.26542075287476],
            [31.125581036248896, 2.263626642910191],
            [31.12814970771839, 2.263247156666636],
            [31.128814656861373, 2.262697597447575],
            [31.129980886594165, 2.262890614254725],
            [31.131097829360545, 2.262317722293523],
            [31.131358314741792, 2.261767622357762],
            [31.133477874383317, 2.26270381432821],
            [31.133526416646337, 2.263134664017969],
            [31.133003472285154, 2.263349360849496],
            [31.133530782458593, 2.265097138150074],
            [31.1329374730612, 2.265766457782657],
            [31.13376050593127, 2.266760755004579],
            [31.13376428424536, 2.268459971007139],
            [31.13447857784687, 2.26870024896731],
            [31.13440597780225, 2.268149703547392],
            [31.1361896375961, 2.267817025349794],
            [31.135905889442252, 2.268606422567628],
            [31.136407225727584, 2.269372932973735],
            [31.136170901434237, 2.27009059502212],
            [31.136718918673306, 2.270450314097844],
            [31.137170596988057, 2.270283389133838],
            [31.13705679661122, 2.272604697837993],
            [31.137688859329963, 2.273311551974618],
            [31.137643454882234, 2.274292728162839],
            [31.138763443835774, 2.275083998738424],
            [31.13895628158456, 2.276209088771761],
            [31.13960021464145, 2.276903994005462],
            [31.139459640875923, 2.277885043879502],
            [31.14015004288417, 2.278077427641666],
            [31.14136616235286, 2.279299615509753],
            [31.142269579169465, 2.278989695958415],
            [31.142365706989697, 2.279420612599794],
            [31.141676366790122, 2.279706884672983],
            [31.141833064416723, 2.28062850050001],
            [31.143661411802714, 2.280829623861898],
            [31.144126080654754, 2.284842925172083],
            [31.1447390766316, 2.286659201902011],
            [31.145762349368372, 2.288434751375827],
            [31.146418282120855, 2.28876569244528],
            [31.147849974799872, 2.291944648527284],
            [31.14916199571337, 2.293415804203335],
            [31.14901711542433, 2.296134528439677],
            [31.149830685441167, 2.298217767259624],
            [31.151847092436952, 2.300888971965169],
            [31.1537766485144, 2.30194460056823],
            [31.153232065534663, 2.303140509985279],
            [31.15192467723307, 2.303689210901982],
            [31.149265120511327, 2.30605498139502],
            [31.148637175669855, 2.307214874372145],
            [31.14699837550378, 2.308528966338758],
            [31.145072948981696, 2.309340080666463],
            [31.143909896590067, 2.310606941545877],
            [31.143766776998998, 2.314316057330509],
            [31.144378538690635, 2.314965400719459],
            [31.147480310873927, 2.316104484069708],
            [31.150014773599096, 2.319619223679136],
            [31.150790082571355, 2.320010401206422],
            [31.15117835959, 2.319727161164115],
            [31.151804813228093, 2.325974253230087],
            [31.153275062497404, 2.332749364041805],
            [31.153311175670154, 2.335030002642734],
            [31.15397161437208, 2.338215839893312],
            [31.155178809078443, 2.341834930903016],
            [31.157235485751745, 2.34475705763535],
            [31.155211734130223, 2.345320351108446],
            [31.154155351288736, 2.34639291759948],
            [31.15332696445957, 2.348066694911521],
            [31.151610689990125, 2.348332903411714],
            [31.151126528594737, 2.349214445230897],
            [31.150224468234185, 2.34891918017326],
            [31.148753265852353, 2.346475225837853],
            [31.14804205167559, 2.346039576970969],
            [31.146719134197703, 2.34681771573127],
            [31.143833469722342, 2.347107923473036],
            [31.141814573494898, 2.346123192978357],
            [31.14181580239023, 2.34519396528484],
            [31.14108904556242, 2.344376398354059],
            [31.137195845935743, 2.345948057024116],
            [31.13433810738758, 2.347746355340649],
            [31.129941919473772, 2.348641505447298],
            [31.12666367145629, 2.350889739627637],
            [31.12168003834721, 2.351474318031769],
            [31.12095167892498, 2.351867544789966],
            [31.11972423978536, 2.348488390564579],
            [31.119411952154955, 2.349000859072964],
            [31.117370972642902, 2.350052367782612],
            [31.111150320760057, 2.349265389854992],
            [31.109428609686507, 2.350943751150371],
            [31.106436352017827, 2.351105783910918],
            [31.10417899530331, 2.353780094539617],
            [31.10194914500278, 2.350484041902479],
            [31.099899668326476, 2.350295576837183],
            [31.10051021908909, 2.347483568232827],
            [31.098824481051114, 2.345609083568016],
            [31.09778902087089, 2.343038867576671],
            [31.094787914796637, 2.342500872839322],
            [31.091268650585064, 2.343453202028165],
            [31.088726070683002, 2.344957329991686],
            [31.086126802594926, 2.347765654702377],
            [31.0811997714336, 2.346849270414928],
            [31.07910346108995, 2.345649710841626],
            [31.078459370827876, 2.344859049528786],
            [31.0779367031478, 2.345217284865857],
            [31.077558070442066, 2.346174017441836],
            [31.078179434225778, 2.353031343908598],
            [31.07791840356716, 2.358930146200182],
            [31.0786256220375, 2.361432022887848],
            [31.078322074116493, 2.364135877197429],
            [31.07929101045666, 2.366638130451916],
            [31.079967648478107, 2.371545109538052],
            [31.081269839127465, 2.374119640310541],
            [31.08103511203866, 2.375627006647202],
            [31.081704623724967, 2.377183533317027],
            [31.08169661434588, 2.379014303714532],
            [31.082673252841328, 2.379542204934084],
            [31.083719443397616, 2.379208659927439],
            [31.08480075808151, 2.384211962975213],
            [31.086219585987372, 2.385685808745338],
            [31.086102294757346, 2.386475391280961],
            [31.084843732586393, 2.387646241965769],
            [31.08527485475249, 2.388987044313069],
            [31.084967062291764, 2.389704556559145],
            [31.085380233423535, 2.393638134825407],
            [31.083771799009018, 2.396047093738074],
            [31.080151371021717, 2.395885181129222],
            [31.079454823638596, 2.398462813083714],
            [31.07922347241865, 2.405402841632085],
            [31.079618658380127, 2.407684117144939],
            [31.080108761232825, 2.407838914594644],
            [31.08029072846837, 2.409195274529105],
            [31.080765011090616, 2.409704485813483],
            [31.079997720480577, 2.410535550445123],
            [31.08149746323729, 2.411862960894347],
            [31.081556850860736, 2.413219148085181],
            [31.082169834261155, 2.414219168333313],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 609,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "ERUSSI",
        Population: 35022,
        Key: "NEBBIERUSSI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.291979975625996, 2.675362633063633],
            [31.291475615611432, 2.675500254810004],
            [31.29019174520398, 2.673850572254021],
            [31.289629901994388, 2.673667752336137],
            [31.288883852947546, 2.675784039099022],
            [31.288330657819177, 2.676233554922291],
            [31.287063398159656, 2.676346743024588],
            [31.286466022088966, 2.675370696526271],
            [31.2867711618247, 2.674114032240325],
            [31.286409720178554, 2.67369197416419],
            [31.28301174200506, 2.671406995728814],
            [31.2818424804582, 2.669565863702863],
            [31.280070395456782, 2.669611272715239],
            [31.27830993465514, 2.66815253561958],
            [31.275547828955517, 2.66764086784347],
            [31.275509544554716, 2.668829418016578],
            [31.274811258033253, 2.669785888855421],
            [31.274325423974762, 2.669756460582158],
            [31.27169073441671, 2.666696520227593],
            [31.27128354067483, 2.664933112657211],
            [31.270293252278687, 2.664567650507266],
            [31.269562976749906, 2.662209789744658],
            [31.268152387293565, 2.660268952280455],
            [31.26841605989745, 2.658031028325504],
            [31.26662638318781, 2.657051280982908],
            [31.267374167779774, 2.656011240797296],
            [31.26723849252745, 2.655337220189717],
            [31.265991377588207, 2.654693561093425],
            [31.26390767509956, 2.652784083259278],
            [31.261754761909835, 2.652685235378669],
            [31.26047032556378, 2.651485849356439],
            [31.259326326439357, 2.652049482377456],
            [31.25856430804172, 2.651962178887172],
            [31.25783473409721, 2.649115722789026],
            [31.255455341251338, 2.647483663099508],
            [31.254150346959968, 2.647366847923243],
            [31.253472139581724, 2.648659256026599],
            [31.252653383590744, 2.648274873695743],
            [31.252560911913726, 2.646281995443037],
            [31.25151311427137, 2.646184703958423],
            [31.250493034147116, 2.64670700084744],
            [31.25027854250843, 2.646392180148927],
            [31.247468119124587, 2.646095441123379],
            [31.245124136968897, 2.640427246469494],
            [31.244625086895976, 2.640019793107157],
            [31.240462155528792, 2.639607126834492],
            [31.23741942062598, 2.637784412478444],
            [31.236659093756032, 2.636697775741997],
            [31.23587629103765, 2.634302817741504],
            [31.23533489078897, 2.631321420719361],
            [31.234103967084373, 2.630390018667635],
            [31.23383988574705, 2.629505459502635],
            [31.234056434527755, 2.628306906296344],
            [31.235557086379565, 2.62557949708194],
            [31.23450677704769, 2.624180992799593],
            [31.235464303885422, 2.622205223907611],
            [31.23535570834737, 2.621115557522977],
            [31.233190243896505, 2.616843152885134],
            [31.23216770508333, 2.616506739993493],
            [31.230943251045435, 2.617716346743221],
            [31.228527169206703, 2.618280917556245],
            [31.226672626947053, 2.616068266299577],
            [31.224577824874768, 2.616926614468348],
            [31.22267520478109, 2.616469311222466],
            [31.221962561384746, 2.615702668629794],
            [31.22150055244421, 2.613938926647672],
            [31.22238432939377, 2.60860218126829],
            [31.221530252544145, 2.60118488068044],
            [31.21980278057468, 2.598466258125298],
            [31.209104595634095, 2.585375184972367],
            [31.207685703947877, 2.584850832618678],
            [31.205486811388653, 2.584925756648891],
            [31.20378184940359, 2.583969976426009],
            [31.200247406358667, 2.580539681759173],
            [31.198157468663634, 2.577089295668171],
            [31.197516938425018, 2.577070971519545],
            [31.196044068770004, 2.578009073542991],
            [31.19340910792076, 2.580477689067227],
            [31.192599444677068, 2.580787388659923],
            [31.192058699300233, 2.580510580731536],
            [31.19100725629445, 2.577253203411654],
            [31.190647439700655, 2.574606203757226],
            [31.187501202707434, 2.571363249777884],
            [31.186362293437394, 2.568749966252071],
            [31.185150842513252, 2.568469657593513],
            [31.184221641353023, 2.568698349769166],
            [31.18340659450586, 2.566742636605577],
            [31.183719536109813, 2.56518070447425],
            [31.182746258211836, 2.562835744924206],
            [31.182749599046375, 2.560469860460107],
            [31.18101970252398, 2.559529963278815],
            [31.180577375671348, 2.558413347294027],
            [31.180577879626217, 2.558056233364804],
            [31.18168820091066, 2.557656062900796],
            [31.182048919412974, 2.553683670213129],
            [31.18136235141438, 2.552633665818304],
            [31.181186426247443, 2.551472791822643],
            [31.18300697895169, 2.551073626218076],
            [31.18305287387956, 2.550002345316827],
            [31.182433516033907, 2.548506042264734],
            [31.182034572419568, 2.548103720386151],
            [31.17928240478193, 2.548099807604099],
            [31.17817140437115, 2.548991011612117],
            [31.174932716362143, 2.547736496765184],
            [31.173514012423823, 2.546484575160958],
            [31.172163248968776, 2.544273008639225],
            [31.16799556281882, 2.540785210542094],
            [31.16777468775169, 2.540026031166888],
            [31.16831038010508, 2.537884119599541],
            [31.167229043861585, 2.533485630142225],
            [31.166653936128483, 2.532101001315405],
            [31.164924782512823, 2.530670090070963],
            [31.163596325124566, 2.528391609341746],
            [31.163288746462882, 2.52615922353112],
            [31.162027095884007, 2.523724606563559],
            [31.158391077634942, 2.520996458346954],
            [31.157461060804458, 2.519477413661827],
            [31.156440697710885, 2.519074211341862],
            [31.155377707760447, 2.517421063204431],
            [31.153693036022688, 2.51594558461908],
            [31.151672783339198, 2.516366771888915],
            [31.151365403205176, 2.514000483761685],
            [31.14936851660055, 2.513595888698774],
            [31.148745763123095, 2.514532411649019],
            [31.147813491521223, 2.514620356392689],
            [31.147061799257784, 2.512565908950076],
            [31.14621950471142, 2.511805850625902],
            [31.146354431667095, 2.510556164002049],
            [31.144757233380137, 2.510018221557111],
            [31.144669150871575, 2.509527072130592],
            [31.144136563994145, 2.509481672636499],
            [31.14364748072926, 2.510061275089411],
            [31.141872483389722, 2.509701628670025],
            [31.139516911170215, 2.511840899723424],
            [31.13885103406756, 2.511884583207065],
            [31.138030847060335, 2.511191512146306],
            [31.137678405635008, 2.509316197403818],
            [31.136427265344967, 2.507578621386823],
            [31.133443072750893, 2.507355726727766],
            [31.132673087194995, 2.506430255290875],
            [31.131972933076028, 2.504073013493722],
            [31.130198162111927, 2.502122657405003],
            [31.12818327506563, 2.502186753015948],
            [31.12761383031206, 2.501333839314785],
            [31.12790497429565, 2.499481777122484],
            [31.127063842169264, 2.497918237313747],
            [31.127190409402914, 2.497101494850855],
            [31.128378153786723, 2.496122012243513],
            [31.12812527084772, 2.494673729733537],
            [31.127862916072377, 2.494386156233844],
            [31.126625732008577, 2.494480069568597],
            [31.124718666152564, 2.492849866380716],
            [31.124359979639387, 2.492011707237265],
            [31.122026347872417, 2.491218510621706],
            [31.123047514059827, 2.490238785805746],
            [31.12270070057978, 2.48938867881032],
            [31.12222473720963, 2.489364047813767],
            [31.121151381599155, 2.488141922612225],
            [31.12036662504505, 2.48838009185125],
            [31.11998534500417, 2.488116276555625],
            [31.11976953553694, 2.487326193607388],
            [31.11886370315054, 2.486559029761028],
            [31.11695855879092, 2.485838259280724],
            [31.116468326580808, 2.484676824964962],
            [31.116790259422448, 2.484362971334658],
            [31.11478797124801, 2.483231344347203],
            [31.115645266761298, 2.480144652806338],
            [31.114622012889132, 2.47997163420365],
            [31.113768123787406, 2.480656613053402],
            [31.11269207412936, 2.480455906559924],
            [31.112290058276784, 2.479919502634497],
            [31.112791585903295, 2.478808024638548],
            [31.114264948733375, 2.477876833262193],
            [31.118335868360926, 2.477179433703344],
            [31.122620436109155, 2.475410268049617],
            [31.13327636519711, 2.4755173253867],
            [31.135699129603214, 2.475102654175077],
            [31.140878325949608, 2.473100811754313],
            [31.14104156959965, 2.474321822728768],
            [31.141461111583435, 2.474041394106436],
            [31.14173887785581, 2.475236122494518],
            [31.141109075298335, 2.476008038766999],
            [31.141769394524342, 2.478397643490161],
            [31.14145746981327, 2.479539902504535],
            [31.142174350562822, 2.480607386632956],
            [31.14128412011628, 2.481190967748808],
            [31.14168234058679, 2.482003999151571],
            [31.14276918979114, 2.482295660646149],
            [31.143211906512608, 2.483055071915619],
            [31.148341000222352, 2.480585096083501],
            [31.151789063964515, 2.484081008369593],
            [31.154077954240485, 2.483998979504917],
            [31.157295583044267, 2.486603638479505],
            [31.16258936938664, 2.484368407316152],
            [31.16269027444754, 2.474200994395225],
            [31.16322539457408, 2.471576755826343],
            [31.167305477017557, 2.465857728780684],
            [31.168705155536454, 2.465135034501812],
            [31.170104052521076, 2.464932591720976],
            [31.173964660370963, 2.465015398089],
            [31.1877860378228, 2.463120242505482],
            [31.19095071543214, 2.463028951192803],
            [31.192067895353787, 2.462456119355789],
            [31.19744574873537, 2.456923074894998],
            [31.20025716206264, 2.453037816587349],
            [31.202900770993143, 2.450589606670471],
            [31.206361014093915, 2.450829729305291],
            [31.209574769362217, 2.449825964027728],
            [31.210655479479936, 2.448819321526587],
            [31.211555299442157, 2.448562044707515],
            [31.21463822676741, 2.449315794090475],
            [31.216769734900524, 2.450481843694725],
            [31.224249068430243, 2.449897325589149],
            [31.225508856801543, 2.449511274682155],
            [31.2261783720811, 2.4485040620351],
            [31.227527145767812, 2.448502027413608],
            [31.229237863258916, 2.44910638794196],
            [31.23019098835177, 2.448793892802452],
            [31.232878481780542, 2.450340838433754],
            [31.2345226826181, 2.450241260583095],
            [31.23603073029964, 2.451099750095106],
            [31.237211189346493, 2.451024995175032],
            [31.23832344470375, 2.451526795337745],
            [31.238922244604137, 2.451383426189732],
            [31.23927717346449, 2.450756368177773],
            [31.240103237250292, 2.450901623026895],
            [31.24041438042706, 2.451521082794074],
            [31.24111388865731, 2.451734012122352],
            [31.24522776662009, 2.452146494446106],
            [31.246321652328067, 2.453810045494136],
            [31.24692100828562, 2.45324266645159],
            [31.24821804170694, 2.454295916834806],
            [31.249684829767467, 2.454484413320466],
            [31.25104265308234, 2.454180915890023],
            [31.256174651045402, 2.456205949185262],
            [31.25742299398168, 2.455809018927453],
            [31.258813228512, 2.456523180441632],
            [31.2594804935118, 2.456411809137466],
            [31.259670854605318, 2.458089507375208],
            [31.263812932481482, 2.462395205200201],
            [31.264539285067396, 2.462826184996949],
            [31.264881695904233, 2.462568616499899],
            [31.265864049481518, 2.463429959269438],
            [31.26983982763901, 2.464101706963196],
            [31.271122895850887, 2.463888369457214],
            [31.272874987049036, 2.464707712700686],
            [31.27325932585343, 2.465095240062255],
            [31.27278835801461, 2.465567657601836],
            [31.273001489603963, 2.466083969986316],
            [31.274326544173913, 2.466472727396313],
            [31.274624419233916, 2.46759119275535],
            [31.275393152538324, 2.468323246434938],
            [31.27650443861335, 2.468690222210299],
            [31.278343449001756, 2.468434602383738],
            [31.281933741206224, 2.469643365240574],
            [31.28312742704734, 2.472440121062856],
            [31.284067543636557, 2.472914379412398],
            [31.285616275119022, 2.472761002086898],
            [31.286441184569686, 2.473083010266475],
            [31.28732317117687, 2.474703408677056],
            [31.288315318187376, 2.478553748486939],
            [31.289911256138005, 2.48067382479941],
            [31.292812474044208, 2.481145943317451],
            [31.294002478589288, 2.48202642429799],
            [31.29632167802292, 2.482821518311685],
            [31.29762899535758, 2.48260463700654],
            [31.298462205241492, 2.483366467681943],
            [31.300198230070755, 2.483673591410935],
            [31.300865260610248, 2.484602671443467],
            [31.301577421611313, 2.483838202017896],
            [31.302052951993495, 2.483861243695968],
            [31.30380204371687, 2.484991226875175],
            [31.304255281506943, 2.486039922556809],
            [31.305540473336162, 2.486967951782394],
            [31.305876543863754, 2.489209442865573],
            [31.307400686660227, 2.490971880582066],
            [31.308104333429007, 2.492556818841073],
            [31.30815373178649, 2.493844729479605],
            [31.307512688609837, 2.494465966818335],
            [31.30813196920041, 2.495252023051412],
            [31.308705788749414, 2.497493104248088],
            [31.308292404716894, 2.503840578262984],
            [31.305198872779705, 2.510816021507558],
            [31.301321549977363, 2.527484086414802],
            [31.29868325637839, 2.542113512670694],
            [31.298133240387813, 2.541481616818496],
            [31.294439217022543, 2.54209571122444],
            [31.293296429725434, 2.541828905781862],
            [31.292990058399454, 2.540767358821272],
            [31.291584696239752, 2.539571707580176],
            [31.291102808480307, 2.538244643091043],
            [31.2900915776599, 2.538243298734989],
            [31.289387240086683, 2.538905571602757],
            [31.287144947221158, 2.538902582251868],
            [31.28630818360196, 2.539962602417334],
            [31.28573731951028, 2.539431271870517],
            [31.284153417187827, 2.540269221942774],
            [31.283052208413647, 2.541815236106092],
            [31.281773078415974, 2.544908494636133],
            [31.28155084060458, 2.546720965804364],
            [31.280469575327988, 2.549792376392002],
            [31.280498920593377, 2.555516795746905],
            [31.279796409295127, 2.557802382801961],
            [31.279312085304625, 2.559119049369998],
            [31.277932026889832, 2.560087841042868],
            [31.278131698122976, 2.565426720936879],
            [31.277784125566516, 2.567575560400429],
            [31.27867623528865, 2.57062740502766],
            [31.28521249497521, 2.578774031251573],
            [31.285894275851668, 2.58041991237815],
            [31.289278867330783, 2.58461166707993],
            [31.29010858546318, 2.586826010388777],
            [31.29088079165447, 2.587574767421437],
            [31.291620813005753, 2.590147891418844],
            [31.293195491426843, 2.591256638139214],
            [31.293761894484835, 2.590240519890584],
            [31.294535980849986, 2.590093466949974],
            [31.295387387008308, 2.622057488209433],
            [31.29676535504342, 2.637720751718033],
            [31.296656234889234, 2.64173366601282],
            [31.29546322008965, 2.661406439796477],
            [31.29468088808847, 2.665001468714563],
            [31.293614763017697, 2.667684039853973],
            [31.293144158098237, 2.670706202447368],
            [31.291714589036555, 2.673857315743515],
            [31.291525673332323, 2.67531042155833],
            [31.291979975625996, 2.675362633063633],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 610,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "KUCWINY",
        Population: 32019,
        Key: "NEBBIKUCWINY",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.16321987352835, 2.385211439885361],
            [31.1621599917488, 2.386809911046247],
            [31.156655828051743, 2.38875282188891],
            [31.15072984334503, 2.388194140545756],
            [31.145914172736248, 2.389419970021975],
            [31.1419447762105, 2.391376902919605],
            [31.14051326229623, 2.393915706280449],
            [31.138871435705973, 2.394177164303045],
            [31.134706339398953, 2.395770243431558],
            [31.13160203037332, 2.395981305692195],
            [31.13024552309033, 2.3965177475675],
            [31.129851891214297, 2.397378494332705],
            [31.129976280931682, 2.401194140709518],
            [31.13034878353392, 2.401210944200987],
            [31.130267185963405, 2.405462535935913],
            [31.12863393109758, 2.408322109023378],
            [31.126955547566805, 2.409749869855808],
            [31.125405829734202, 2.410195958310389],
            [31.124001757555238, 2.412755348983744],
            [31.122876538610132, 2.413137985475198],
            [31.12179528501167, 2.412410770786761],
            [31.121243403220223, 2.412516725609603],
            [31.119501554612942, 2.413794968077807],
            [31.11845930586412, 2.415565102630975],
            [31.11835149635193, 2.416802927075717],
            [31.119261215748573, 2.418810571586863],
            [31.120448484025317, 2.41960197307864],
            [31.121295456997668, 2.420947853572011],
            [31.121086394776565, 2.421617488225685],
            [31.117367663249393, 2.425866279627997],
            [31.115494109943366, 2.427151843059691],
            [31.116111962212656, 2.42779872368925],
            [31.116404030562652, 2.429065723917757],
            [31.11565834084192, 2.431474673027491],
            [31.11673389462993, 2.431476184428458],
            [31.11662543922903, 2.432763482783547],
            [31.11788786864729, 2.433676968213662],
            [31.117404742111056, 2.434865627856453],
            [31.11765222797184, 2.435876267525137],
            [31.119071473594275, 2.438717643283385],
            [31.12000097299517, 2.438857484808504],
            [31.12017130794607, 2.440173792307387],
            [31.114857740701172, 2.441541480382025],
            [31.110948347144852, 2.442032094070114],
            [31.103429768017, 2.442899778328757],
            [31.097883741929373, 2.444527375427163],
            [31.09811973025284, 2.443594372286281],
            [31.09599955885859, 2.442418605751805],
            [31.09719874598253, 2.441259657338089],
            [31.097221536241292, 2.440781051024667],
            [31.095526304807358, 2.43800246708142],
            [31.09547605305036, 2.436733998856887],
            [31.094833504297334, 2.436685198027524],
            [31.093859843717063, 2.437593189878687],
            [31.09304812422971, 2.436299679131802],
            [31.093212625521154, 2.435318711261685],
            [31.0927361375349, 2.435030831453966],
            [31.09202296053925, 2.435340904739191],
            [31.09119897006511, 2.433867889062975],
            [31.091292791011696, 2.433221864869479],
            [31.092231835910816, 2.432828358978008],
            [31.091849218278462, 2.431918387607426],
            [31.089349921003404, 2.431483964912359],
            [31.088277977544532, 2.430908034866662],
            [31.088247453689526, 2.427701119587184],
            [31.086209868910935, 2.426178473142132],
            [31.08570723006844, 2.424765761105194],
            [31.085776300632304, 2.423664997564142],
            [31.084915746031143, 2.421773128647653],
            [31.08555632298217, 2.420888584471993],
            [31.083805382525906, 2.419892861947778],
            [31.08299407626358, 2.418790817283527],
            [31.083539726441863, 2.418025794194735],
            [31.082275132083794, 2.416348726342068],
            [31.082605529750346, 2.415056890682757],
            [31.082169834261155, 2.414219168333313],
            [31.081556850860736, 2.413219148085181],
            [31.08149746323729, 2.411862960894347],
            [31.079997720480577, 2.410535550445123],
            [31.080765011090616, 2.409704485813483],
            [31.08029072846837, 2.409195274529105],
            [31.080108761232825, 2.407838914594644],
            [31.079618658380127, 2.407684117144939],
            [31.07922347241865, 2.405402841632085],
            [31.079454823638596, 2.398462813083714],
            [31.080151371021717, 2.395885181129222],
            [31.083771799009018, 2.396047093738074],
            [31.085380233423535, 2.393638134825407],
            [31.084967062291764, 2.389704556559145],
            [31.08527485475249, 2.388987044313069],
            [31.084843732586393, 2.387646241965769],
            [31.086102294757346, 2.386475391280961],
            [31.086219585987372, 2.385685808745338],
            [31.08480075808151, 2.384211962975213],
            [31.083719443397616, 2.379208659927439],
            [31.082673252841328, 2.379542204934084],
            [31.08169661434588, 2.379014303714532],
            [31.081704623724967, 2.377183533317027],
            [31.08103511203866, 2.375627006647202],
            [31.081269839127465, 2.374119640310541],
            [31.079967648478107, 2.371545109538052],
            [31.07929101045666, 2.366638130451916],
            [31.078322074116493, 2.364135877197429],
            [31.0786256220375, 2.361432022887848],
            [31.07791840356716, 2.358930146200182],
            [31.078179434225778, 2.353031343908598],
            [31.077558070442066, 2.346174017441836],
            [31.0779367031478, 2.345217284865857],
            [31.078459370827876, 2.344859049528786],
            [31.07910346108995, 2.345649710841626],
            [31.0811997714336, 2.346849270414928],
            [31.086126802594926, 2.347765654702377],
            [31.088726070683002, 2.344957329991686],
            [31.091268650585064, 2.343453202028165],
            [31.094787914796637, 2.342500872839322],
            [31.09778902087089, 2.343038867576671],
            [31.098824481051114, 2.345609083568016],
            [31.10051021908909, 2.347483568232827],
            [31.099899668326476, 2.350295576837183],
            [31.10194914500278, 2.350484041902479],
            [31.10417899530331, 2.353780094539617],
            [31.106436352017827, 2.351105783910918],
            [31.109428609686507, 2.350943751150371],
            [31.111150320760057, 2.349265389854992],
            [31.117370972642902, 2.350052367782612],
            [31.119411952154955, 2.349000859072964],
            [31.11972423978536, 2.348488390564579],
            [31.12095167892498, 2.351867544789966],
            [31.12168003834721, 2.351474318031769],
            [31.12666367145629, 2.350889739627637],
            [31.129941919473772, 2.348641505447298],
            [31.13433810738758, 2.347746355340649],
            [31.137195845935743, 2.345948057024116],
            [31.14108904556242, 2.344376398354059],
            [31.14181580239023, 2.34519396528484],
            [31.141814573494898, 2.346123192978357],
            [31.143833469722342, 2.347107923473036],
            [31.146719134197703, 2.34681771573127],
            [31.14804205167559, 2.346039576970969],
            [31.148753265852353, 2.346475225837853],
            [31.150224468234185, 2.34891918017326],
            [31.151126528594737, 2.349214445230897],
            [31.151610689990125, 2.348332903411714],
            [31.15332696445957, 2.348066694911521],
            [31.154155351288736, 2.34639291759948],
            [31.155211734130223, 2.345320351108446],
            [31.157235485751745, 2.34475705763535],
            [31.15771659736679, 2.344646050609367],
            [31.15856076040895, 2.345206182910737],
            [31.158278118081228, 2.347942459892597],
            [31.158924887119486, 2.35341180247101],
            [31.159705869851084, 2.356269232501582],
            [31.16127317669696, 2.357925018147064],
            [31.162953826677178, 2.358641351874033],
            [31.165455062516635, 2.360523885327878],
            [31.167139631846414, 2.36263252207722],
            [31.16824402694494, 2.367133428451702],
            [31.16760687976166, 2.369549788213648],
            [31.16653535581606, 2.369189327836248],
            [31.164971886573053, 2.366925525631316],
            [31.16387541910695, 2.366038507413979],
            [31.163061705359645, 2.363883432070299],
            [31.162466224734235, 2.363595423233254],
            [31.1617483693126, 2.361751608061067],
            [31.160675177195486, 2.36062529445391],
            [31.159628294936404, 2.360647795208606],
            [31.157484171761748, 2.359424284617575],
            [31.156270369946498, 2.359279026310413],
            [31.156486085090602, 2.359997306133234],
            [31.158487810021363, 2.361388152319635],
            [31.15950274549397, 2.36307680917618],
            [31.160980120200122, 2.364060079938017],
            [31.161651327007384, 2.366334624203849],
            [31.16662431867358, 2.371786175082237],
            [31.16681603442656, 2.372408694705366],
            [31.16696199269392, 2.373868805402719],
            [31.166367869422892, 2.374203051784008],
            [31.163985987345363, 2.37307493705064],
            [31.162293095124465, 2.371469108941007],
            [31.16136575078194, 2.371755031142804],
            [31.161129377081227, 2.3724726932754],
            [31.161154529909187, 2.373094981920472],
            [31.16278869207344, 2.375047759051506],
            [31.163816860628526, 2.377346730716253],
            [31.163909827277273, 2.381786414729255],
            [31.16321987352835, 2.385211439885361],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 611,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "NDHEW",
        Population: 21006,
        Key: "NEBBINDHEW",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.065779057704443, 2.445386963545634],
              [31.064419777322144, 2.445358410568491],
              [31.061799918949475, 2.446581993138146],
              [31.056299487752383, 2.445480930604687],
              [31.053746566444765, 2.445444591841445],
              [31.052032807258126, 2.445839693381233],
              [31.050118062603058, 2.448641362629887],
              [31.041767188974607, 2.454987252377099],
              [31.04092499593785, 2.45315422041049],
              [31.04134990086387, 2.451503609500383],
              [31.040046730152547, 2.448378624518204],
              [31.03985024075216, 2.445386931235722],
              [31.0386157462443, 2.4409458419434],
              [31.037040203643905, 2.438430702091901],
              [31.037309868010723, 2.436504650021492],
              [31.036307882651244, 2.43521086359274],
              [31.036113842058306, 2.433415737677921],
              [31.035732358998185, 2.433032266851742],
              [31.035329444830303, 2.433797457362833],
              [31.034663276673495, 2.433820387716923],
              [31.03496944138695, 2.432289256869089],
              [31.03421692087682, 2.430816364407748],
              [31.03406928365818, 2.428446963734546],
              [31.031424126032118, 2.420677364517732],
              [31.029476176050906, 2.416402756836619],
              [31.029282522631853, 2.414799087762508],
              [31.029589066434344, 2.413459408409656],
              [31.028549154203574, 2.411076717428828],
              [31.02916683219966, 2.410622950976582],
              [31.029283077790694, 2.409306916296585],
              [31.028446119237092, 2.407271531486574],
              [31.029062606965457, 2.406243415453344],
              [31.027468037149003, 2.40602565925359],
              [31.027045846931774, 2.403213136802746],
              [31.025783095018355, 2.402373670456703],
              [31.02482821641407, 2.40084066420243],
              [31.02413783057551, 2.400648187780793],
              [31.01942811445784, 2.395484051573996],
              [31.015749739744802, 2.385860317688309],
              [31.017161934490595, 2.386147260995763],
              [31.021430662245372, 2.385184399788252],
              [31.021952655290693, 2.384491177033975],
              [31.02154405927864, 2.382504304108397],
              [31.02192374301328, 2.382026247958908],
              [31.023616136669187, 2.383536403280603],
              [31.02454324655143, 2.383154880432829],
              [31.024278743005905, 2.381814354227407],
              [31.02618233687333, 2.381912893257985],
              [31.026495372800415, 2.383708181288142],
              [31.026996259928097, 2.384307196203272],
              [31.027802664982257, 2.383087907018567],
              [31.027489576054574, 2.38126868708269],
              [31.029200490276743, 2.380242176989419],
              [31.028365410100406, 2.379116188080449],
              [31.028457785657693, 2.377776185701556],
              [31.02886175804095, 2.377537470967405],
              [31.0304786438057, 2.377061231516364],
              [31.031622378825443, 2.377876570366618],
              [31.032357347153223, 2.376633234815259],
              [31.03235549752206, 2.375747781854018],
              [31.033450550141605, 2.376036564537702],
              [31.034019917640055, 2.3752476743097],
              [31.03544591320352, 2.374507900827541],
              [31.03561326215443, 2.374891045236312],
              [31.035044244998947, 2.375847455812469],
              [31.035687842085956, 2.376422747602062],
              [31.036710268609728, 2.376113142901254],
              [31.036951496806225, 2.377692952157215],
              [31.03880380944735, 2.376020486850512],
              [31.039565020259566, 2.375949808032098],
              [31.039758817409055, 2.377601344541501],
              [31.040427614934707, 2.378846747155306],
              [31.04154561681483, 2.378728729466284],
              [31.0424355598005, 2.377641161296749],
              [31.04365088785345, 2.378552325807493],
              [31.0454579757099, 2.378004549943709],
              [31.04660253358646, 2.379202786419787],
              [31.047296236005028, 2.380974716817083],
              [31.04910337955704, 2.38045086853964],
              [31.048914946248118, 2.381359983008524],
              [31.047917506363945, 2.3822439837387],
              [31.04876739257281, 2.384746048927365],
              [31.047913357045655, 2.385941365237723],
              [31.05120424346087, 2.389511952020389],
              [31.050991810760795, 2.390325306228634],
              [31.05136458465426, 2.392228394867383],
              [31.053124614264554, 2.391919865376511],
              [31.053934780564795, 2.392495405346152],
              [31.05439010603959, 2.394051612258008],
              [31.054177922172848, 2.394984626148743],
              [31.054870728072785, 2.396325799182589],
              [31.05424248948222, 2.397413756452732],
              [31.054624931943078, 2.398251916350936],
              [31.056293607380553, 2.399762043046101],
              [31.0561781945278, 2.401461004040112],
              [31.054774845492627, 2.401674326291143],
              [31.053349254171017, 2.402629487709554],
              [31.053707401695007, 2.403228298695837],
              [31.054872769045126, 2.402990697729666],
              [31.055231117791728, 2.403685234975272],
              [31.054341794643623, 2.405083913707655],
              [31.054343793395134, 2.406041172944546],
              [31.055272380107674, 2.406353648351346],
              [31.055795182535046, 2.406043308152565],
              [31.056821143929465, 2.407408908072755],
              [31.057630966174944, 2.407816933379404],
              [31.058110331465066, 2.409492838695251],
              [31.059411194404415, 2.411469096969532],
              [31.06105624055667, 2.413050994373838],
              [31.061722557833832, 2.413099838239059],
              [31.061528360934002, 2.411256827246872],
              [31.062243914871907, 2.412095481251645],
              [31.063931601355723, 2.411308219235431],
              [31.065525616911636, 2.411238763761216],
              [31.07237100754872, 2.413510325527764],
              [31.074541299545924, 2.415930596657736],
              [31.07561241835133, 2.416123616610276],
              [31.07727737835681, 2.415838868641119],
              [31.08052183624487, 2.41422820992909],
              [31.082169834261155, 2.414219168333313],
              [31.082605529750346, 2.415056890682757],
              [31.082275132083794, 2.416348726342068],
              [31.083539726441863, 2.418025794194735],
              [31.08299407626358, 2.418790817283527],
              [31.083805382525906, 2.419892861947778],
              [31.08555632298217, 2.420888584471993],
              [31.084915746031143, 2.421773128647653],
              [31.085776300632304, 2.423664997564142],
              [31.08570723006844, 2.424765761105194],
              [31.086209868910935, 2.426178473142132],
              [31.088247453689526, 2.427701119587184],
              [31.088277977544532, 2.430908034866662],
              [31.08763440381375, 2.432522557242486],
              [31.084297644030258, 2.436537908795694],
              [31.077873317123036, 2.441876375210293],
              [31.07398116942353, 2.441918485889723],
              [31.065779057704443, 2.445386963545634],
            ],
          ],
          [
            [
              [31.02052586561649, 2.575218512611516],
              [31.01937241172369, 2.57355517553491],
              [31.01833808881062, 2.574456542932278],
              [31.016751987412373, 2.573746131643977],
              [31.016065769756715, 2.57454820065468],
              [31.016063064929387, 2.576293796381643],
              [31.014905447345267, 2.576609362445566],
              [31.01412184871955, 2.575743339179436],
              [31.014375685669382, 2.575044772602018],
              [31.013688689174366, 2.569833232570539],
              [31.012930925197914, 2.56951433543064],
              [31.011054977881688, 2.570086427430829],
              [31.008856836314035, 2.569839654449799],
              [31.008320717260922, 2.569606066198561],
              [31.008459321919347, 2.568410817823159],
              [31.007406613187353, 2.568916974730397],
              [31.006234988172988, 2.568232992759967],
              [31.006047694826155, 2.566771234498244],
              [31.007295841929672, 2.565732419023635],
              [31.006991950852207, 2.564980808828107],
              [31.004964361627778, 2.563295515685546],
              [31.002412808454338, 2.560329303187824],
              [31.002393345555394, 2.559313659234527],
              [31.00332087854414, 2.558119650453585],
              [31.003321731045354, 2.557569528238168],
              [31.000926492816173, 2.556907964061136],
              [30.999763933599656, 2.555338863894784],
              [30.998832434548923, 2.556049649760121],
              [30.99753998792548, 2.555148382466623],
              [30.997320367804825, 2.554322853431684],
              [30.996626966321845, 2.553771643706984],
              [30.996724879094547, 2.552935300729046],
              [30.996041620489457, 2.551474863078928],
              [30.99493667382535, 2.551663717123499],
              [30.994661078781025, 2.55301743025138],
              [30.993935678409336, 2.552751808081291],
              [30.99469724405607, 2.550622364053594],
              [30.99615142426157, 2.548415436257701],
              [30.99609334189024, 2.547619955949536],
              [30.995704640866805, 2.547432602707721],
              [30.994672972475396, 2.545569601913367],
              [30.994172039533627, 2.543691956853186],
              [30.994202276826098, 2.54310315728738],
              [30.995112495686023, 2.542627347596107],
              [30.99539092222013, 2.54157389163827],
              [30.99451232226157, 2.539991612827752],
              [30.99506036734842, 2.537974235449835],
              [30.995021654451236, 2.537437286145541],
              [30.994133453298907, 2.536461548330563],
              [30.994511467065404, 2.534931012127941],
              [30.993444712275625, 2.534352691527159],
              [30.994000389449113, 2.533001396253995],
              [30.993493469235993, 2.528796423266906],
              [30.994070650280758, 2.528089238180966],
              [30.99311975121318, 2.52711414397068],
              [30.992904099849437, 2.525227657444881],
              [30.99190198423424, 2.524216770136491],
              [30.991645421795813, 2.521583900253298],
              [30.991089061902702, 2.520100331416363],
              [30.999935501039136, 2.520156800542884],
              [31.009742373063247, 2.519525283479371],
              [31.012650267248645, 2.52115057492177],
              [31.01737540743974, 2.521342215475495],
              [31.02183865189462, 2.52215978010968],
              [31.026820263794264, 2.515175181563686],
              [31.028847749712416, 2.511492780672636],
              [31.031791458829897, 2.50777998337126],
              [31.03944839288454, 2.500102817047023],
              [31.042736499013934, 2.498455628301207],
              [31.045442522890397, 2.497328610222622],
              [31.046605065038907, 2.497381185347094],
              [31.05645772958296, 2.500344328056391],
              [31.05731721249398, 2.500243939068657],
              [31.059341268644385, 2.498823566758641],
              [31.060756867106743, 2.498673165733007],
              [31.063486445708264, 2.498728055355975],
              [31.065557545731803, 2.499696999833633],
              [31.06801026625768, 2.498963520423614],
              [31.070032016432737, 2.49911901989129],
              [31.070033281260645, 2.498254817720546],
              [31.071282624021833, 2.496354153576164],
              [31.074251268574972, 2.49639365809215],
              [31.074588769220476, 2.49697562396678],
              [31.074791784881416, 2.496315395748014],
              [31.074638206205506, 2.49713088135503],
              [31.076111563645703, 2.500459124858962],
              [31.078206447464694, 2.499749365754959],
              [31.07924869082363, 2.501034263751517],
              [31.079361898312346, 2.502959472884308],
              [31.080579863818976, 2.503077938266988],
              [31.081159077751245, 2.503662138539533],
              [31.08133182288206, 2.504537413563884],
              [31.080983103176973, 2.505003576972169],
              [31.08144477524926, 2.506637629508049],
              [31.083299118981223, 2.507923728724009],
              [31.085994950572452, 2.508948560745111],
              [31.088486618455793, 2.510760611868515],
              [31.089589177397876, 2.510470559542362],
              [31.09080597060303, 2.511405708939565],
              [31.091849931540786, 2.511523914193812],
              [31.091268162799874, 2.512689759967244],
              [31.092369877325556, 2.512983056087339],
              [31.09225233546558, 2.514032914936691],
              [31.09114943157044, 2.514556306263573],
              [31.091785304044308, 2.516073953972509],
              [31.093233368519368, 2.51753446387323],
              [31.0933465804997, 2.519459689085127],
              [31.095336012884108, 2.521716162169022],
              [31.09677949864616, 2.522008731122007],
              [31.098687401732, 2.523731859705842],
              [31.100620024657868, 2.523734702808352],
              [31.101176285736297, 2.523109948827772],
              [31.10244303964429, 2.522731997239394],
              [31.10333085721603, 2.523247164480946],
              [31.104041903407797, 2.52311415694459],
              [31.10346844228661, 2.519716231443505],
              [31.10397405994261, 2.517463049426482],
              [31.104787184395054, 2.516337277225317],
              [31.104583548896557, 2.510177549145758],
              [31.105602391142337, 2.507637597647139],
              [31.113240848648214, 2.509218629801542],
              [31.11611762788715, 2.510680092390732],
              [31.119153146623287, 2.510792965045567],
              [31.118747951632912, 2.509769870145527],
              [31.1185216345718, 2.505751000372237],
              [31.120757446092565, 2.504817631076877],
              [31.12254820437378, 2.50518053570928],
              [31.126127112228634, 2.507743976580391],
              [31.127040692584398, 2.507727277635418],
              [31.12823974945259, 2.508503696233996],
              [31.12992299286903, 2.508902474678456],
              [31.131967210807687, 2.507392059305565],
              [31.133443072750893, 2.507355726727766],
              [31.136427265344967, 2.507578621386823],
              [31.137678405635008, 2.509316197403818],
              [31.138030847060335, 2.511191512146306],
              [31.13885103406756, 2.511884583207065],
              [31.139516911170215, 2.511840899723424],
              [31.141872483389722, 2.509701628670025],
              [31.14364748072926, 2.510061275089411],
              [31.144136563994145, 2.509481672636499],
              [31.144669150871575, 2.509527072130592],
              [31.144757233380137, 2.510018221557111],
              [31.146354431667095, 2.510556164002049],
              [31.14621950471142, 2.511805850625902],
              [31.147061799257784, 2.512565908950076],
              [31.147813491521223, 2.514620356392689],
              [31.148745763123095, 2.514532411649019],
              [31.14936851660055, 2.513595888698774],
              [31.151365403205176, 2.514000483761685],
              [31.151672783339198, 2.516366771888915],
              [31.153693036022688, 2.51594558461908],
              [31.155377707760447, 2.517421063204431],
              [31.156440697710885, 2.519074211341862],
              [31.157461060804458, 2.519477413661827],
              [31.158391077634942, 2.520996458346954],
              [31.162027095884007, 2.523724606563559],
              [31.163288746462882, 2.52615922353112],
              [31.163596325124566, 2.528391609341746],
              [31.164924782512823, 2.530670090070963],
              [31.166653936128483, 2.532101001315405],
              [31.167229043861585, 2.533485630142225],
              [31.16831038010508, 2.537884119599541],
              [31.16777468775169, 2.540026031166888],
              [31.16799556281882, 2.540785210542094],
              [31.172163248968776, 2.544273008639225],
              [31.173514012423823, 2.546484575160958],
              [31.174932716362143, 2.547736496765184],
              [31.17817140437115, 2.548991011612117],
              [31.17928240478193, 2.548099807604099],
              [31.182034572419568, 2.548103720386151],
              [31.182433516033907, 2.548506042264734],
              [31.18305287387956, 2.550002345316827],
              [31.18300697895169, 2.551073626218076],
              [31.181186426247443, 2.551472791822643],
              [31.18136235141438, 2.552633665818304],
              [31.182048919412974, 2.553683670213129],
              [31.18168820091066, 2.557656062900796],
              [31.180577879626217, 2.558056233364804],
              [31.180577375671348, 2.558413347294027],
              [31.18101970252398, 2.559529963278815],
              [31.182749599046375, 2.560469860460107],
              [31.182746258211836, 2.562835744924206],
              [31.183719536109813, 2.56518070447425],
              [31.18340659450586, 2.566742636605577],
              [31.184221641353023, 2.568698349769166],
              [31.182360322202868, 2.569549033868468],
              [31.17911062264511, 2.567277061806862],
              [31.17772460121345, 2.568023744751498],
              [31.17653672118401, 2.567863428166993],
              [31.175007416667913, 2.566399028392327],
              [31.17445294862679, 2.564386870547103],
              [31.17333298123285, 2.564065156854469],
              [31.17175671009874, 2.564689683691662],
              [31.168780531375308, 2.563658158032843],
              [31.167672425336374, 2.563761027052649],
              [31.167256395765374, 2.564143467159461],
              [31.16749682625789, 2.565501859694214],
              [31.166664590147757, 2.566388613002186],
              [31.164760511190064, 2.566229166704509],
              [31.16422426816942, 2.565932407883414],
              [31.16384485033612, 2.564922031716208],
              [31.162113944107357, 2.564728011408584],
              [31.16183877216953, 2.563456625261406],
              [31.161423712778994, 2.563160041690733],
              [31.159053323747226, 2.56223384196746],
              [31.158725496160702, 2.561467293993801],
              [31.157444231765897, 2.561604725435603],
              [31.157445726562536, 2.560560082419046],
              [31.15600743485947, 2.559321244221959],
              [31.15532030271886, 2.557823518844692],
              [31.154004620272264, 2.557821614518837],
              [31.15369590164846, 2.555801523453292],
              [31.152831718751862, 2.5548252718607],
              [31.152557349009573, 2.552996750020736],
              [31.1513117908507, 2.552385572953682],
              [31.14834732885354, 2.552556561845656],
              [31.14513389338551, 2.551434530119023],
              [31.143818546908825, 2.550546589944742],
              [31.142710690601522, 2.55049274890858],
              [31.138992950814444, 2.547562364441599],
              [31.13790168549213, 2.548013450885992],
              [31.136794864942384, 2.547245775331307],
              [31.13655642691313, 2.54817512147696],
              [31.135581770101215, 2.548149357244277],
              [31.133144417054915, 2.545690919927796],
              [31.1322969185681, 2.545167368860567],
              [31.13111049740268, 2.545443948408409],
              [31.12949119606817, 2.543073154388724],
              [31.12563849968099, 2.540735388696929],
              [31.101716859534918, 2.547680413837894],
              [31.085090273419492, 2.548247487297822],
              [31.066200672999894, 2.54971151741884],
              [31.02052586561649, 2.575218512611516],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 612,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "NEBBI",
        Population: 24611,
        Key: "NEBBINEBBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.11269207412936, 2.480455906559924],
            [31.10928598327055, 2.481996086136059],
            [31.10573332328995, 2.482912019384537],
            [31.103006402803373, 2.484300889677847],
            [31.10510363032695, 2.48592137845704],
            [31.103870828245093, 2.487274748892231],
            [31.095641274790676, 2.480403852192591],
            [31.093295191475544, 2.479433059989031],
            [31.09355497976414, 2.477099918240541],
            [31.093908554863336, 2.476727785200939],
            [31.096268044635785, 2.476241493953751],
            [31.098634568216912, 2.475076438864949],
            [31.09586774007381, 2.470539439507344],
            [31.093726867902184, 2.469217412649579],
            [31.092256849499897, 2.473041815100776],
            [31.090367007941133, 2.475911323990896],
            [31.090066524173558, 2.474072009771311],
            [31.088663499430204, 2.471216986714285],
            [31.085560213585666, 2.470313908069629],
            [31.084959166100415, 2.468920242228221],
            [31.08105648655253, 2.465196722163231],
            [31.078153969682422, 2.464559613431015],
            [31.078823864051028, 2.463781725820973],
            [31.078869994337502, 2.462989845959062],
            [31.076535552290125, 2.45936613868125],
            [31.074918276656568, 2.457644142888868],
            [31.069799634845154, 2.450305591154924],
            [31.06962148095802, 2.449038228599803],
            [31.068003962779315, 2.447497255196529],
            [31.066923889567143, 2.447676702293037],
            [31.065779057704443, 2.445386963545634],
            [31.07398116942353, 2.441918485889723],
            [31.077873317123036, 2.441876375210293],
            [31.084297644030258, 2.436537908795694],
            [31.08763440381375, 2.432522557242486],
            [31.088277977544532, 2.430908034866662],
            [31.089349921003404, 2.431483964912359],
            [31.091849218278462, 2.431918387607426],
            [31.092231835910816, 2.432828358978008],
            [31.091292791011696, 2.433221864869479],
            [31.09119897006511, 2.433867889062975],
            [31.09202296053925, 2.435340904739191],
            [31.0927361375349, 2.435030831453966],
            [31.093212625521154, 2.435318711261685],
            [31.09304812422971, 2.436299679131802],
            [31.093859843717063, 2.437593189878687],
            [31.094833504297334, 2.436685198027524],
            [31.09547605305036, 2.436733998856887],
            [31.095526304807358, 2.43800246708142],
            [31.097221536241292, 2.440781051024667],
            [31.09719874598253, 2.441259657338089],
            [31.09599955885859, 2.442418605751805],
            [31.09811973025284, 2.443594372286281],
            [31.097883741929373, 2.444527375427163],
            [31.103429768017, 2.442899778328757],
            [31.110948347144852, 2.442032094070114],
            [31.112593182192988, 2.445909970978673],
            [31.11444475911389, 2.44773066781065],
            [31.115878770344658, 2.449830479321327],
            [31.116061572115104, 2.451695432488684],
            [31.121152747038376, 2.457203501740147],
            [31.12216266182687, 2.464244178158159],
            [31.122670205470843, 2.465922096294131],
            [31.123068226515336, 2.466067161021041],
            [31.123312267337017, 2.468963328515053],
            [31.123318251015114, 2.471811286076087],
            [31.122337197300062, 2.474885157730521],
            [31.122620436109155, 2.475410268049617],
            [31.118335868360926, 2.477179433703344],
            [31.114264948733375, 2.477876833262193],
            [31.112791585903295, 2.478808024638548],
            [31.112290058276784, 2.479919502634497],
            [31.11269207412936, 2.480455906559924],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 613,
        District: "NEBBI",
        County: "NEBBI MUNICIPALITY",
        Subcounty: "ABINDU DIVISION",
        Population: 14237,
        Key: "NEBBIABINDU DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.2594804935118, 2.456411809137466],
            [31.258813228512, 2.456523180441632],
            [31.25742299398168, 2.455809018927453],
            [31.256174651045402, 2.456205949185262],
            [31.25104265308234, 2.454180915890023],
            [31.249684829767467, 2.454484413320466],
            [31.24821804170694, 2.454295916834806],
            [31.24692100828562, 2.45324266645159],
            [31.246321652328067, 2.453810045494136],
            [31.24522776662009, 2.452146494446106],
            [31.24111388865731, 2.451734012122352],
            [31.24041438042706, 2.451521082794074],
            [31.240103237250292, 2.450901623026895],
            [31.23927717346449, 2.450756368177773],
            [31.238922244604137, 2.451383426189732],
            [31.23832344470375, 2.451526795337745],
            [31.237211189346493, 2.451024995175032],
            [31.23603073029964, 2.451099750095106],
            [31.2345226826181, 2.450241260583095],
            [31.232878481780542, 2.450340838433754],
            [31.23019098835177, 2.448793892802452],
            [31.229237863258916, 2.44910638794196],
            [31.227527145767812, 2.448502027413608],
            [31.2261783720811, 2.4485040620351],
            [31.225508856801543, 2.449511274682155],
            [31.224249068430243, 2.449897325589149],
            [31.216769734900524, 2.450481843694725],
            [31.21463822676741, 2.449315794090475],
            [31.211555299442157, 2.448562044707515],
            [31.210655479479936, 2.448819321526587],
            [31.209574769362217, 2.449825964027728],
            [31.206361014093915, 2.450829729305291],
            [31.202900770993143, 2.450589606670471],
            [31.20025716206264, 2.453037816587349],
            [31.19744574873537, 2.456923074894998],
            [31.192067895353787, 2.462456119355789],
            [31.19095071543214, 2.463028951192803],
            [31.1877860378228, 2.463120242505482],
            [31.173964660370963, 2.465015398089],
            [31.170104052521076, 2.464932591720976],
            [31.169537134728415, 2.464315065077153],
            [31.169606166664764, 2.463214246012333],
            [31.16819873029503, 2.461584808473222],
            [31.16709163755573, 2.461308008394714],
            [31.165851083911317, 2.459822406169066],
            [31.1648512015079, 2.459605591110714],
            [31.164599058780695, 2.458963646731696],
            [31.164667077417395, 2.456960742528503],
            [31.165783988742735, 2.456268272682643],
            [31.166208980805344, 2.454713234947296],
            [31.16587045787705, 2.452199798331536],
            [31.16532105543579, 2.451217771369827],
            [31.165593756108265, 2.45077539863263],
            [31.16532882406639, 2.449291182993357],
            [31.16478034599154, 2.448739950662518],
            [31.164658802136994, 2.44754313338688],
            [31.16306893320442, 2.44405864993745],
            [31.16258773535112, 2.441592883784542],
            [31.161633403820826, 2.440418825237016],
            [31.16068719485736, 2.437485714855429],
            [31.160163750134565, 2.437508909012485],
            [31.159828149425852, 2.436359659275744],
            [31.158587559848822, 2.434850140522991],
            [31.15865514190429, 2.43307920638714],
            [31.1577982587177, 2.432958333041404],
            [31.15715388728293, 2.43207191052409],
            [31.1569455365275, 2.42923557911199],
            [31.155033599107732, 2.425355773017438],
            [31.155139055033853, 2.424602038042557],
            [31.160880099081467, 2.427601715972356],
            [31.162117703556806, 2.427723118430511],
            [31.166207941454537, 2.426556141719086],
            [31.168085538077666, 2.42552965311477],
            [31.17074977412372, 2.4231860349782],
            [31.17477902180355, 2.422397968043526],
            [31.175030202435092, 2.420894762057628],
            [31.175765863363996, 2.419556093937439],
            [31.175343867182843, 2.419021442698712],
            [31.174060099183357, 2.418493348494703],
            [31.17170408050119, 2.419351462429906],
            [31.16961270011182, 2.417984887235874],
            [31.169902084295757, 2.415042480143433],
            [31.170834205878943, 2.411718138037472],
            [31.17086240579236, 2.408416496903953],
            [31.17039041836567, 2.405616609336329],
            [31.170724191901044, 2.405042855575615],
            [31.17322050497274, 2.405979306659484],
            [31.175168782839023, 2.407632776178366],
            [31.17878160568913, 2.40967129279672],
            [31.179971086516392, 2.409553266992113],
            [31.1819446950771, 2.410058354035036],
            [31.18337461448172, 2.408002692632409],
            [31.18309079536097, 2.4067821177495],
            [31.178935606573233, 2.401178010362703],
            [31.176199773002427, 2.401485366495132],
            [31.175010779062017, 2.401244515282308],
            [31.172990032305123, 2.400428338553021],
            [31.171469244716235, 2.399277881642068],
            [31.170416867462574, 2.399156838347317],
            [31.169290131262972, 2.396822613205671],
            [31.16763520723583, 2.389224140602297],
            [31.164785666712984, 2.385631539188998],
            [31.16321987352835, 2.385211439885361],
            [31.163909827277273, 2.381786414729255],
            [31.163816860628526, 2.377346730716253],
            [31.16278869207344, 2.375047759051506],
            [31.161154529909187, 2.373094981920472],
            [31.161129377081227, 2.3724726932754],
            [31.16136575078194, 2.371755031142804],
            [31.162293095124465, 2.371469108941007],
            [31.163985987345363, 2.37307493705064],
            [31.166367869422892, 2.374203051784008],
            [31.16696199269392, 2.373868805402719],
            [31.16681603442656, 2.372408694705366],
            [31.16662431867358, 2.371786175082237],
            [31.161651327007384, 2.366334624203849],
            [31.160980120200122, 2.364060079938017],
            [31.15950274549397, 2.36307680917618],
            [31.158487810021363, 2.361388152319635],
            [31.156486085090602, 2.359997306133234],
            [31.156270369946498, 2.359279026310413],
            [31.157484171761748, 2.359424284617575],
            [31.159628294936404, 2.360647795208606],
            [31.160675177195486, 2.36062529445391],
            [31.1617483693126, 2.361751608061067],
            [31.162466224734235, 2.363595423233254],
            [31.163061705359645, 2.363883432070299],
            [31.16387541910695, 2.366038507413979],
            [31.164971886573053, 2.366925525631316],
            [31.16653535581606, 2.369189327836248],
            [31.16760687976166, 2.369549788213648],
            [31.169319171101137, 2.369145267233307],
            [31.170439126817016, 2.36988871993615],
            [31.171103213577318, 2.368908373030386],
            [31.172697585764375, 2.368982348003208],
            [31.17305581234011, 2.369581161077227],
            [31.176211157352007, 2.370770148461911],
            [31.17871487433828, 2.3731908011153],
            [31.179500458240746, 2.373359402205401],
            [31.18097439778926, 2.372763077863939],
            [31.18180978159615, 2.373936938891867],
            [31.18321491738042, 2.374513244804234],
            [31.1844626809033, 2.373856776512997],
            [31.185200574145693, 2.373977444169232],
            [31.185531643752075, 2.373044498610531],
            [31.187004899682634, 2.372137033739148],
            [31.18825466555032, 2.372390025762601],
            [31.189395905948523, 2.371984705001753],
            [31.196288133846174, 2.368284343952356],
            [31.19760976403829, 2.368752822639002],
            [31.19799185435955, 2.369375604812774],
            [31.19913309475772, 2.36897027239854],
            [31.2000860976797, 2.369522020796446],
            [31.201178795814922, 2.368685819804699],
            [31.203630812061608, 2.369215645721092],
            [31.204748206680595, 2.368786341557097],
            [31.20541551929107, 2.3692659047839],
            [31.205842867634665, 2.368835674366326],
            [31.20766759750501, 2.370836564200032],
            [31.208572275556275, 2.371053177119204],
            [31.209023048369218, 2.370455442635393],
            [31.20931007267891, 2.371125964523883],
            [31.210405960731684, 2.371725769356132],
            [31.21140380126443, 2.371033030797081],
            [31.2124746748298, 2.371082328521924],
            [31.213258946293635, 2.370652571675813],
            [31.21433109726334, 2.37127627567229],
            [31.214639099929855, 2.370678347414807],
            [31.21711397830054, 2.370777380890632],
            [31.217412665437585, 2.371340218646858],
            [31.21862673764576, 2.37158117203352],
            [31.218891038172014, 2.372730339008826],
            [31.219319720513795, 2.37289844560777],
            [31.219650398454707, 2.371797937418897],
            [31.222622311977158, 2.370700939556119],
            [31.223171783588693, 2.371682951037305],
            [31.223908520699286, 2.371277056537368],
            [31.224338964637344, 2.372234976592855],
            [31.22490961762494, 2.372044264331075],
            [31.226457895458168, 2.372764330836862],
            [31.227197517059146, 2.373650860968482],
            [31.227401989787474, 2.374644382252428],
            [31.228712587769564, 2.37548380271991],
            [31.22869044789107, 2.376225719909253],
            [31.22821555980431, 2.376679831634859],
            [31.22900250645111, 2.377446757293268],
            [31.22888571917596, 2.378427886184508],
            [31.2306947393086, 2.37869355931339],
            [31.23093413224696, 2.379340089527856],
            [31.230173593374605, 2.379745954732011],
            [31.231555103466913, 2.380370067490535],
            [31.23185406459007, 2.381052577490696],
            [31.23147387420564, 2.381291410989077],
            [31.232095006224025, 2.382393190601259],
            [31.231717482039347, 2.383828717939485],
            [31.2334800952044, 2.384620875678295],
            [31.234149726366653, 2.386129596582197],
            [31.236340075049185, 2.386659047811081],
            [31.23853325791646, 2.388456998915508],
            [31.240530901800867, 2.387933099634554],
            [31.24068121510072, 2.385982684228002],
            [31.241132740701868, 2.385720007584992],
            [31.241751262216027, 2.385649024999144],
            [31.24215733575873, 2.386343646428876],
            [31.242799385946803, 2.386153023179271],
            [31.243653614611738, 2.385077123468473],
            [31.242960869797233, 2.383879510505341],
            [31.245742847129282, 2.382949756110101],
            [31.246885512255513, 2.383166666906131],
            [31.248095058751286, 2.381373208253006],
            [31.248618289675036, 2.381254225925229],
            [31.249119390601763, 2.381877170302217],
            [31.249356968943257, 2.381709943487921],
            [31.250850929244518, 2.37941423716766],
            [31.251433828066084, 2.379355993951004],
            [31.252864745499014, 2.378201478653007],
            [31.25493199444489, 2.377530090479636],
            [31.256401758623962, 2.374689278293555],
            [31.258565235103088, 2.374804792180836],
            [31.259540714771813, 2.375351682541381],
            [31.25961384033087, 2.376591823995272],
            [31.260244977784872, 2.377389740933577],
            [31.260886978565598, 2.377484035804138],
            [31.261056206792105, 2.379415694773863],
            [31.262768853864404, 2.380104420713312],
            [31.263649661881956, 2.380937691506798],
            [31.265878844734242, 2.38533439436945],
            [31.266759129932293, 2.385809899468363],
            [31.267070337787743, 2.387288142348089],
            [31.2678084484224, 2.38807395700836],
            [31.267894033614468, 2.389707618945347],
            [31.268965735426523, 2.391017589912428],
            [31.26865928954038, 2.39280696746827],
            [31.268018151142332, 2.393308947164825],
            [31.268400360041213, 2.39457240374587],
            [31.274143695691112, 2.396029356752039],
            [31.276234484989025, 2.395167088722088],
            [31.277351786183218, 2.395141308056364],
            [31.277635422047627, 2.394019801956514],
            [31.278277263826574, 2.393994835330049],
            [31.280120399278747, 2.394480601592964],
            [31.280953582213183, 2.395242398707429],
            [31.28164192707944, 2.394501810248658],
            [31.28302336171325, 2.396264425201457],
            [31.285282969605863, 2.397047605855599],
            [31.28692364814923, 2.397259425433922],
            [31.287158719292762, 2.395446298757701],
            [31.287657327394573, 2.395016107034122],
            [31.288180410994638, 2.395062895302371],
            [31.289967959595355, 2.396728473139416],
            [31.29064758271849, 2.3981462404489],
            [31.290173136602874, 2.3988387616161],
            [31.291617423662174, 2.411024403678408],
            [31.289434619031397, 2.449257610411892],
            [31.287390927505506, 2.451439259241311],
            [31.283845770254164, 2.452193852442606],
            [31.282402264729175, 2.451861917430366],
            [31.280598664132658, 2.450836367167843],
            [31.27709207964129, 2.447102039265594],
            [31.275910565972275, 2.447199531568829],
            [31.274992808450477, 2.446340162703553],
            [31.273711960873957, 2.447130671185269],
            [31.273445455881998, 2.448196008459623],
            [31.26625047058075, 2.448123979968508],
            [31.260777589815145, 2.446506562151172],
            [31.25318894928168, 2.445602038866754],
            [31.251411384557034, 2.444605712623154],
            [31.250403445163816, 2.4445447509845],
            [31.250697239177505, 2.446612645333337],
            [31.250321084025337, 2.447089269691287],
            [31.250970619874654, 2.449177511705613],
            [31.253922245844723, 2.45200960974993],
            [31.25486739210122, 2.452104062785535],
            [31.25821852133602, 2.454923448857563],
            [31.258996956445483, 2.454943111984139],
            [31.2594804935118, 2.456411809137466],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 614,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "NYARAVUR",
        Population: 20563,
        Key: "NEBBINYARAVUR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.289967959595355, 2.396728473139416],
            [31.288180410994638, 2.395062895302371],
            [31.287657327394573, 2.395016107034122],
            [31.287158719292762, 2.395446298757701],
            [31.28692364814923, 2.397259425433922],
            [31.285282969605863, 2.397047605855599],
            [31.28302336171325, 2.396264425201457],
            [31.28164192707944, 2.394501810248658],
            [31.280953582213183, 2.395242398707429],
            [31.280120399278747, 2.394480601592964],
            [31.278277263826574, 2.393994835330049],
            [31.277635422047627, 2.394019801956514],
            [31.277351786183218, 2.395141308056364],
            [31.276234484989025, 2.395167088722088],
            [31.274143695691112, 2.396029356752039],
            [31.268400360041213, 2.39457240374587],
            [31.268018151142332, 2.393308947164825],
            [31.26865928954038, 2.39280696746827],
            [31.268965735426523, 2.391017589912428],
            [31.267894033614468, 2.389707618945347],
            [31.2678084484224, 2.38807395700836],
            [31.267070337787743, 2.387288142348089],
            [31.266759129932293, 2.385809899468363],
            [31.265878844734242, 2.38533439436945],
            [31.263649661881956, 2.380937691506798],
            [31.262768853864404, 2.380104420713312],
            [31.261056206792105, 2.379415694773863],
            [31.260886978565598, 2.377484035804138],
            [31.260244977784872, 2.377389740933577],
            [31.25961384033087, 2.376591823995272],
            [31.259540714771813, 2.375351682541381],
            [31.258565235103088, 2.374804792180836],
            [31.256401758623962, 2.374689278293555],
            [31.25493199444489, 2.377530090479636],
            [31.252864745499014, 2.378201478653007],
            [31.251433828066084, 2.379355993951004],
            [31.250850929244518, 2.37941423716766],
            [31.249356968943257, 2.381709943487921],
            [31.249119390601763, 2.381877170302217],
            [31.248618289675036, 2.381254225925229],
            [31.248095058751286, 2.381373208253006],
            [31.246885512255513, 2.383166666906131],
            [31.245742847129282, 2.382949756110101],
            [31.242960869797233, 2.383879510505341],
            [31.243653614611738, 2.385077123468473],
            [31.242799385946803, 2.386153023179271],
            [31.24215733575873, 2.386343646428876],
            [31.241751262216027, 2.385649024999144],
            [31.241132740701868, 2.385720007584992],
            [31.24068121510072, 2.385982684228002],
            [31.240530901800867, 2.387933099634554],
            [31.23853325791646, 2.388456998915508],
            [31.236340075049185, 2.386659047811081],
            [31.234149726366653, 2.386129596582197],
            [31.2334800952044, 2.384620875678295],
            [31.231717482039347, 2.383828717939485],
            [31.232095006224025, 2.382393190601259],
            [31.23147387420564, 2.381291410989077],
            [31.23185406459007, 2.381052577490696],
            [31.231555103466913, 2.380370067490535],
            [31.230173593374605, 2.379745954732011],
            [31.23093413224696, 2.379340089527856],
            [31.2306947393086, 2.37869355931339],
            [31.22888571917596, 2.378427886184508],
            [31.22900250645111, 2.377446757293268],
            [31.22821555980431, 2.376679831634859],
            [31.22869044789107, 2.376225719909253],
            [31.228712587769564, 2.37548380271991],
            [31.227401989787474, 2.374644382252428],
            [31.227197517059146, 2.373650860968482],
            [31.226457895458168, 2.372764330836862],
            [31.22490961762494, 2.372044264331075],
            [31.224338964637344, 2.372234976592855],
            [31.223908520699286, 2.371277056537368],
            [31.223171783588693, 2.371682951037305],
            [31.222622311977158, 2.370700939556119],
            [31.219650398454707, 2.371797937418897],
            [31.219319720513795, 2.37289844560777],
            [31.218891038172014, 2.372730339008826],
            [31.21862673764576, 2.37158117203352],
            [31.217412665437585, 2.371340218646858],
            [31.21711397830054, 2.370777380890632],
            [31.214639099929855, 2.370678347414807],
            [31.21433109726334, 2.37127627567229],
            [31.213258946293635, 2.370652571675813],
            [31.2124746748298, 2.371082328521924],
            [31.21140380126443, 2.371033030797081],
            [31.210405960731684, 2.371725769356132],
            [31.20931007267891, 2.371125964523883],
            [31.209023048369218, 2.370455442635393],
            [31.208572275556275, 2.371053177119204],
            [31.20766759750501, 2.370836564200032],
            [31.205842867634665, 2.368835674366326],
            [31.20541551929107, 2.3692659047839],
            [31.204748206680595, 2.368786341557097],
            [31.203630812061608, 2.369215645721092],
            [31.201178795814922, 2.368685819804699],
            [31.2000860976797, 2.369522020796446],
            [31.19913309475772, 2.36897027239854],
            [31.19799185435955, 2.369375604812774],
            [31.19760976403829, 2.368752822639002],
            [31.196288133846174, 2.368284343952356],
            [31.189395905948523, 2.371984705001753],
            [31.18825466555032, 2.372390025762601],
            [31.187004899682634, 2.372137033739148],
            [31.185531643752075, 2.373044498610531],
            [31.185200574145693, 2.373977444169232],
            [31.1844626809033, 2.373856776512997],
            [31.18321491738042, 2.374513244804234],
            [31.18180978159615, 2.373936938891867],
            [31.18097439778926, 2.372763077863939],
            [31.179500458240746, 2.373359402205401],
            [31.17871487433828, 2.3731908011153],
            [31.176211157352007, 2.370770148461911],
            [31.17305581234011, 2.369581161077227],
            [31.172697585764375, 2.368982348003208],
            [31.171103213577318, 2.368908373030386],
            [31.170439126817016, 2.36988871993615],
            [31.169319171101137, 2.369145267233307],
            [31.16760687976166, 2.369549788213648],
            [31.16824402694494, 2.367133428451702],
            [31.167139631846414, 2.36263252207722],
            [31.165455062516635, 2.360523885327878],
            [31.162953826677178, 2.358641351874033],
            [31.16127317669696, 2.357925018147064],
            [31.159705869851084, 2.356269232501582],
            [31.158924887119486, 2.35341180247101],
            [31.158278118081228, 2.347942459892597],
            [31.15856076040895, 2.345206182910737],
            [31.15771659736679, 2.344646050609367],
            [31.157235485751745, 2.34475705763535],
            [31.155178809078443, 2.341834930903016],
            [31.15397161437208, 2.338215839893312],
            [31.153311175670154, 2.335030002642734],
            [31.153275062497404, 2.332749364041805],
            [31.151804813228093, 2.325974253230087],
            [31.15117835959, 2.319727161164115],
            [31.150790082571355, 2.320010401206422],
            [31.150014773599096, 2.319619223679136],
            [31.147480310873927, 2.316104484069708],
            [31.144378538690635, 2.314965400719459],
            [31.143766776998998, 2.314316057330509],
            [31.143909896590067, 2.310606941545877],
            [31.145072948981696, 2.309340080666463],
            [31.14699837550378, 2.308528966338758],
            [31.148637175669855, 2.307214874372145],
            [31.149265120511327, 2.30605498139502],
            [31.15192467723307, 2.303689210901982],
            [31.153232065534663, 2.303140509985279],
            [31.1537766485144, 2.30194460056823],
            [31.151847092436952, 2.300888971965169],
            [31.149830685441167, 2.298217767259624],
            [31.14901711542433, 2.296134528439677],
            [31.14916199571337, 2.293415804203335],
            [31.147849974799872, 2.291944648527284],
            [31.146418282120855, 2.28876569244528],
            [31.145762349368372, 2.288434751375827],
            [31.1447390766316, 2.286659201902011],
            [31.144126080654754, 2.284842925172083],
            [31.143661411802714, 2.280829623861898],
            [31.14582997184801, 2.280538102825062],
            [31.146566524804, 2.280084363139701],
            [31.14849477832428, 2.280565584760073],
            [31.149671144646728, 2.279956864758585],
            [31.150148167130588, 2.280484020400462],
            [31.150504787518575, 2.280364831174088],
            [31.15040673820195, 2.279072331245132],
            [31.15092857224545, 2.278355041682682],
            [31.15133400439106, 2.278786369617017],
            [31.151904063592276, 2.278356336926906],
            [31.152237531700436, 2.278524308461892],
            [31.15336519046986, 2.277412930266239],
            [31.15398459592626, 2.277772742662694],
            [31.155768872862716, 2.277703309283992],
            [31.15662834140069, 2.279020753082662],
            [31.157197331606692, 2.278112058152304],
            [31.15807738863267, 2.27799355809047],
            [31.158527681745266, 2.27720436976241],
            [31.159148480488632, 2.278186438213856],
            [31.160243206121432, 2.278307549393292],
            [31.1611439513484, 2.276800966778645],
            [31.16240367234605, 2.276228239206065],
            [31.162378326380313, 2.275534150468864],
            [31.163174278637804, 2.275044574932495],
            [31.163675583482107, 2.275787156213362],
            [31.164697539288667, 2.275285910973516],
            [31.16503154728435, 2.275693210892439],
            [31.166411409866413, 2.275647160969517],
            [31.16676931843854, 2.276102357970632],
            [31.16831546456958, 2.275936860854846],
            [31.17122278652813, 2.277998922180211],
            [31.172769742939593, 2.278192418060074],
            [31.172893002576327, 2.280107224217679],
            [31.173905297002037, 2.280599182966519],
            [31.174072866040177, 2.281054130663807],
            [31.174690888091053, 2.280791678566426],
            [31.174620585038575, 2.281270247532362],
            [31.175765217475284, 2.282420539208722],
            [31.176904105185756, 2.281009980241326],
            [31.17728575712917, 2.281441277759033],
            [31.17849849444082, 2.281131735662401],
            [31.179572292022446, 2.282521265477949],
            [31.181664992036946, 2.282045343061537],
            [31.181666176016524, 2.282571874104196],
            [31.18235665527985, 2.282788176548289],
            [31.18300089376398, 2.28360274779019],
            [31.184595239001595, 2.283700565746667],
            [31.185069860288674, 2.283150722594403],
            [31.185927376787554, 2.283582641507975],
            [31.186452547174014, 2.284349191522381],
            [31.186263333229082, 2.284851543040232],
            [31.187537957277303, 2.285607105745731],
            [31.187515187679775, 2.286061807710221],
            [31.191014927906963, 2.287023709123833],
            [31.196892594031198, 2.287366433307908],
            [31.19794003594068, 2.287607129985745],
            [31.198179155791227, 2.288133974943757],
            [31.198820871806006, 2.287823674920708],
            [31.200106678981207, 2.288256147144397],
            [31.200512785761564, 2.288974677630578],
            [31.20012162874413, 2.289608405381401],
            [31.20038427277704, 2.290015615072575],
            [31.201954144313053, 2.289802254248821],
            [31.201978964764358, 2.290257022202986],
            [31.20266837682913, 2.289994648981482],
            [31.20316960352002, 2.29068936982399],
            [31.20245769494557, 2.291526116199485],
            [31.202840171542377, 2.292316417755006],
            [31.203292083419107, 2.292245204248185],
            [31.203246927804713, 2.293322151754163],
            [31.20384143824965, 2.293179323611745],
            [31.20420082455041, 2.29428072988374],
            [31.20451030135232, 2.294352932439119],
            [31.20491289841489, 2.293515783798244],
            [31.20736243171814, 2.292992425287362],
            [31.20688969958808, 2.294379955438294],
            [31.208391769879707, 2.295746116113937],
            [31.2085090072108, 2.294980395290497],
            [31.20927034468548, 2.294957448280456],
            [31.209794884454606, 2.2954367997091],
            [31.21041259568835, 2.29503072971049],
            [31.210506361837712, 2.294408578849082],
            [31.211030577315018, 2.294744326953648],
            [31.211374202674136, 2.294134466739892],
            [31.21289530916495, 2.29339449258764],
            [31.213157524701437, 2.293610234197205],
            [31.212920401805775, 2.293968931310651],
            [31.213682228862268, 2.294161385622153],
            [31.214065169888112, 2.297963712594132],
            [31.217514479593547, 2.306495210435336],
            [31.21829055482877, 2.310636160627076],
            [31.219615409074397, 2.314179680424755],
            [31.219763900590873, 2.316654469802536],
            [31.219365481592668, 2.318225514070896],
            [31.21911233365069, 2.324828038512351],
            [31.220105525401852, 2.327628888985971],
            [31.22003172071642, 2.330921960675437],
            [31.219472054124722, 2.332789711645818],
            [31.217463532540528, 2.335900707509136],
            [31.22380885980504, 2.337386783612838],
            [31.230155491423332, 2.339800425942449],
            [31.23279679258185, 2.339851739809033],
            [31.235523077959517, 2.338290646744682],
            [31.23621115063625, 2.339154873644708],
            [31.237929690656845, 2.33916875989984],
            [31.241923234795703, 2.341183602810921],
            [31.243302410166578, 2.341520310088732],
            [31.247108547770864, 2.341237993481149],
            [31.250536904272334, 2.338706121612379],
            [31.263815565443576, 2.333889582828113],
            [31.273066335391075, 2.329889835062408],
            [31.28004333730211, 2.328029052598705],
            [31.28007500650912, 2.327743380841843],
            [31.28139200947918, 2.328141336390575],
            [31.28213230212169, 2.326891301884125],
            [31.283942034618324, 2.327116461141742],
            [31.285357184821404, 2.327811787650145],
            [31.285591775366246, 2.32727949385987],
            [31.285011303792608, 2.326161430849125],
            [31.284901939296645, 2.324575497434756],
            [31.287228000960738, 2.324111372450826],
            [31.28884291043184, 2.329849115780159],
            [31.293425287663048, 2.340336584398991],
            [31.29434673097247, 2.343971121490795],
            [31.290964841625698, 2.372879925664069],
            [31.28944287365053, 2.39404689842407],
            [31.289967959595355, 2.396728473139416],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 615,
        District: "NEBBI",
        County: "PADYERE",
        Subcounty: "PAROMBO",
        Population: 35174,
        Key: "NEBBIPAROMBO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.976732848191944, 2.687761200330867],
            [30.973968153547688, 2.689550973474653],
            [30.974486105970826, 2.691379812599715],
            [30.973214689806504, 2.69339785401796],
            [30.969983541357667, 2.694520849535183],
            [30.96741948722875, 2.696265146403964],
            [30.96431625348648, 2.70078649791619],
            [30.96469537487573, 2.701532199903361],
            [30.964556816031365, 2.702436413254297],
            [30.9628257534957, 2.702500906960149],
            [30.962500361241908, 2.702837789024016],
            [30.96209456168536, 2.704757973635989],
            [30.96075656149387, 2.705797976875818],
            [30.959296647341866, 2.708026466997499],
            [30.958374736010185, 2.711229218220026],
            [30.95701154795642, 2.711959070891684],
            [30.955796902623124, 2.710949200123692],
            [30.954016196489903, 2.710369052319484],
            [30.952875503165725, 2.711228484220675],
            [30.95032593167578, 2.709432491438032],
            [30.951537176885765, 2.70736726276141],
            [30.950931677349956, 2.705781311067311],
            [30.94930749996007, 2.703814624714741],
            [30.94930250532711, 2.702575258577685],
            [30.950160320066658, 2.700947710857827],
            [30.949314186120734, 2.699835106835258],
            [30.94742155529305, 2.699607936363793],
            [30.947019695747333, 2.699176569343132],
            [30.946740589188558, 2.697057127764048],
            [30.94704845081955, 2.695623054877486],
            [30.94665867900431, 2.694826043992318],
            [30.94592208113257, 2.694798952947765],
            [30.94571718619607, 2.694393761801745],
            [30.94616576172981, 2.692508127516823],
            [30.944949709634766, 2.692351017815269],
            [30.943877741921366, 2.693107201221538],
            [30.943313427446427, 2.692503286456185],
            [30.94073665676633, 2.691628927773672],
            [30.939561236369865, 2.692781157922725],
            [30.93833627298718, 2.693191108109524],
            [30.938412003660584, 2.69364056638163],
            [30.940476809188926, 2.693342603153057],
            [30.940783994388507, 2.694040831478108],
            [30.93939326937805, 2.695881784876218],
            [30.93771434775645, 2.695921992038546],
            [30.937254723843004, 2.696271333430856],
            [30.9376338434356, 2.697946058606621],
            [30.936756882004115, 2.699882629701575],
            [30.937726493877403, 2.701464320569182],
            [30.936872813184795, 2.702268535244392],
            [30.93822430697018, 2.704456448101483],
            [30.937916819936643, 2.704841617703849],
            [30.935117094589533, 2.702231247262226],
            [30.934140541434072, 2.700095403552221],
            [30.93219965580424, 2.698677871838676],
            [30.932274780114806, 2.697969844753246],
            [30.933250190613254, 2.697385452699474],
            [30.932943995357068, 2.697007806557475],
            [30.931018160101537, 2.696773096271524],
            [30.93063416984345, 2.697038138673528],
            [30.93037589341947, 2.698095385134396],
            [30.93136408245283, 2.698856432028904],
            [30.93071835725693, 2.701776462104101],
            [30.930879248219245, 2.703303928416144],
            [30.930273637292366, 2.703577160088334],
            [30.92629361549345, 2.703398904782128],
            [30.925986290156683, 2.702380935779086],
            [30.923239181830702, 2.699307949348821],
            [30.923463751668592, 2.697730468590447],
            [30.921689004958978, 2.697520223870536],
            [30.920439312753164, 2.696115529816835],
            [30.919868585205375, 2.696210175633295],
            [30.91954119779336, 2.697667939761677],
            [30.919129149555662, 2.69765129268531],
            [30.91809350611913, 2.696199152944065],
            [30.918475049366393, 2.695514475409455],
            [30.918340301175444, 2.694494881931109],
            [30.916433229031256, 2.693473976610176],
            [30.914534414201118, 2.69347070676569],
            [30.914170959430404, 2.692717115055069],
            [30.914597949346224, 2.690589367356971],
            [30.913263627755786, 2.687489768735493],
            [30.913574531980693, 2.687054350475494],
            [30.9145903549888, 2.687316056036198],
            [30.91486636505478, 2.687914082419197],
            [30.915392937711406, 2.68748623147142],
            [30.91508774048353, 2.686939221546905],
            [30.91231255890662, 2.685351449462286],
            [30.912881540129483, 2.683237610105847],
            [30.912626610828255, 2.682471835295442],
            [30.911636482332224, 2.681763033376207],
            [30.911602624829158, 2.681036659491222],
            [30.912250408065372, 2.680106232637812],
            [30.911946811635318, 2.679287447699654],
            [30.91414371532447, 2.678265828846732],
            [30.9137043825567, 2.677536191972872],
            [30.914063381683565, 2.675350150220311],
            [30.911182977742477, 2.672629766736116],
            [30.91192143243192, 2.670160446687233],
            [30.910325251936175, 2.669609434962195],
            [30.91016372316999, 2.668360050293169],
            [30.91059820323861, 2.66745580185184],
            [30.911803833978063, 2.666630529659349],
            [30.913562897001118, 2.666393725428277],
            [30.914162338298627, 2.664446318819047],
            [30.915722992221536, 2.665204369779067],
            [30.916009901546868, 2.663549780180045],
            [30.91693072142547, 2.663387998776226],
            [30.918124853729275, 2.661702104612551],
            [30.918290138351658, 2.660014460110071],
            [30.91904960463558, 2.659199010686496],
            [30.919267847638917, 2.658219293883612],
            [30.918293886123045, 2.657782047210945],
            [30.91829507369584, 2.657074209160037],
            [30.91753716419233, 2.656964024508174],
            [30.917267787286377, 2.656146830415006],
            [30.916618450863048, 2.655873482268861],
            [30.917839688033908, 2.654160404236087],
            [30.917409505505606, 2.652362851515215],
            [30.919250466136475, 2.652284029827401],
            [30.91812703843205, 2.651595945658705],
            [30.917383102222786, 2.649588184734853],
            [30.916234349213852, 2.650004358138097],
            [30.91546508680175, 2.649100855406821],
            [30.916388572880138, 2.648454359216112],
            [30.916524267895397, 2.647136337646901],
            [30.915997480541435, 2.646357387813462],
            [30.91545698220127, 2.646394241378535],
            [30.915485971733805, 2.644170556735788],
            [30.91479190819246, 2.643635687673084],
            [30.915235936454255, 2.642569046542849],
            [30.91430226437888, 2.64175421826273],
            [30.91469462424046, 2.641360962482194],
            [30.916297021976284, 2.641554976376206],
            [30.916356124833786, 2.640424220566321],
            [30.917339447693234, 2.638565917098996],
            [30.915701946491037, 2.638957293789474],
            [30.91469700297934, 2.640207566957264],
            [30.914619796373934, 2.63812082232942],
            [30.914541612401486, 2.634961498549568],
            [30.915300870276248, 2.634254938779092],
            [30.915466669633304, 2.632240599930523],
            [30.916171865995942, 2.631479497487988],
            [30.91471212701544, 2.63011581324555],
            [30.915527517917397, 2.628211464680836],
            [30.915394454067606, 2.626822787766786],
            [30.916965833874983, 2.626172034529572],
            [30.917346225482035, 2.625355933816173],
            [30.917077020154334, 2.62442984694113],
            [30.915778280832324, 2.62393762604703],
            [30.915617732128105, 2.622793923987557],
            [30.914769894976416, 2.621331446295954],
            [30.913754827451474, 2.62183973122714],
            [30.913717309313633, 2.621196639879358],
            [30.913221057492798, 2.621295587178555],
            [30.912798007587856, 2.620463375385086],
            [30.91253797495748, 2.621044991504944],
            [30.912080427948993, 2.621071939690995],
            [30.911824228429968, 2.620293328918359],
            [30.910622879061144, 2.619173669638283],
            [30.91031615469727, 2.617997967224674],
            [30.911046260444458, 2.616569840973716],
            [30.910534075205447, 2.616625679465268],
            [30.90809172033961, 2.61339929748187],
            [30.907345088286153, 2.613180706225459],
            [30.906862653452716, 2.61229636731839],
            [30.907136574037345, 2.611432197355128],
            [30.90671947277621, 2.610812555564602],
            [30.906758754306953, 2.60998355752429],
            [30.905847187075757, 2.609875592423356],
            [30.905617758250497, 2.609407457878344],
            [30.906051386716264, 2.608557729331111],
            [30.905489320724456, 2.607531516865659],
            [30.904698247217258, 2.607180010149314],
            [30.905166895606044, 2.60663862728169],
            [30.904519538171257, 2.605361790217227],
            [30.90514383854764, 2.603775761401293],
            [30.904734137607797, 2.60283245117621],
            [30.90523612068014, 2.602577771392354],
            [30.905548939214924, 2.601718052087604],
            [30.906706192981353, 2.601729605077512],
            [30.905524123255173, 2.599371064569737],
            [30.905659479605557, 2.598882890064753],
            [30.904607503000534, 2.598436526643104],
            [30.904410312914205, 2.597379869976295],
            [30.903662873275294, 2.597088342152216],
            [30.9028034325851, 2.595571212899785],
            [30.901457177774446, 2.594891613792228],
            [30.900901744044376, 2.595323523246337],
            [30.900060847276603, 2.594870044025995],
            [30.90022673107528, 2.594119238068162],
            [30.8993543905776, 2.594089755959462],
            [30.898210251315962, 2.591633846238845],
            [30.89878366033489, 2.590701259815594],
            [30.899818066791283, 2.590189101707317],
            [30.89963310636921, 2.589674907196192],
            [30.90022669873592, 2.588870032594549],
            [30.900286514855747, 2.587807323953941],
            [30.89997569686913, 2.586148358433269],
            [30.900475977634006, 2.585588589581477],
            [30.900730160435216, 2.581557721042221],
            [30.901995696227708, 2.579724707354257],
            [30.90391056125702, 2.580103764843705],
            [30.905323526757286, 2.579052176691967],
            [30.90632958058669, 2.579039790702971],
            [30.9068199583239, 2.57822556197871],
            [30.90765870811815, 2.577988058984052],
            [30.90861857955881, 2.576873909054894],
            [30.91095993054903, 2.575745120533724],
            [30.912041231758206, 2.574164251530253],
            [30.914678838145967, 2.57441626543843],
            [30.915517907740483, 2.573982019196203],
            [30.91572845847004, 2.573392160237916],
            [30.915182653781486, 2.572370874774584],
            [30.916896805531923, 2.569712133115865],
            [30.916846420824253, 2.567235957568414],
            [30.91746724112722, 2.566430068156881],
            [30.917509668558104, 2.565316808240448],
            [30.91870902636192, 2.563818642064045],
            [30.91868893554057, 2.56313648989064],
            [30.919289999195506, 2.562803518687406],
            [30.91882202454318, 2.557993988303606],
            [30.918119868977783, 2.556220402142509],
            [30.918533701269617, 2.554625879848177],
            [30.9176852856029, 2.552468027378627],
            [30.91704606690458, 2.548094967779884],
            [30.917225837759254, 2.545909251761151],
            [30.915441367684988, 2.539521804919262],
            [30.915742796480277, 2.539169273427557],
            [30.91549395596004, 2.537998857452107],
            [30.91624216006525, 2.536513726107718],
            [30.916134732337056, 2.535582507590911],
            [30.914978717347392, 2.534037809692589],
            [30.91578574852726, 2.531810590283726],
            [30.91770506650545, 2.531426101593072],
            [30.91944598715303, 2.532219838280539],
            [30.92110321176557, 2.532392867028991],
            [30.92188919002846, 2.53338554614324],
            [30.922748939739122, 2.537334157456712],
            [30.92416600155712, 2.54052537069857],
            [30.925482014583714, 2.541301282396348],
            [30.92646138036435, 2.54119734991699],
            [30.927648418672344, 2.542442011951035],
            [30.929140605699242, 2.542397527192273],
            [30.929824988096765, 2.544520679480586],
            [30.930792082890616, 2.544803618351722],
            [30.93159247552053, 2.547278682208726],
            [30.93215138393414, 2.547678202576835],
            [30.9347163444632, 2.547447863462965],
            [30.935415571520796, 2.547577957243462],
            [30.9360555780416, 2.548294157986705],
            [30.936742617655707, 2.54782285709157],
            [30.937055181068953, 2.546904007905998],
            [30.938934437778684, 2.547652575640616],
            [30.942836295368085, 2.546890462129075],
            [30.946791513783676, 2.544008239018045],
            [30.947609590648323, 2.541961003196151],
            [30.94883391263388, 2.540651891602171],
            [30.94950964874678, 2.539181168905762],
            [30.950931578535275, 2.538347542861572],
            [30.951629983634394, 2.538212030341546],
            [30.95291520600634, 2.539414847947106],
            [30.952986396594287, 2.542666104943216],
            [30.953107909906134, 2.543116979512742],
            [30.95388161718224, 2.543364042118282],
            [30.958181983601353, 2.542039334591693],
            [30.959854400522005, 2.540771887264072],
            [30.962873740599882, 2.537949662805971],
            [30.9649370764844, 2.534204052678986],
            [30.964206287119293, 2.532564040750212],
            [30.964860908331445, 2.530803306833976],
            [30.964700309321586, 2.529287113115666],
            [30.965089880812545, 2.527669357791427],
            [30.96588087347133, 2.527378081531191],
            [30.968819806246447, 2.522045862915349],
            [30.97128509959307, 2.522173659097513],
            [30.971697683226637, 2.521674437240701],
            [30.97170091895828, 2.520673635361556],
            [30.972312931279905, 2.520100992834418],
            [30.973289206855927, 2.521085841259946],
            [30.97487768699306, 2.521375131088417],
            [30.9750388770944, 2.522522589278082],
            [30.975975810054244, 2.522606000488832],
            [30.977831177865664, 2.521564125939822],
            [30.97844224156632, 2.521606053694343],
            [30.978074107471336, 2.522547827220905],
            [30.97868491784708, 2.522753641809778],
            [30.98060060752979, 2.522224003071832],
            [30.981089004481795, 2.522552539703529],
            [30.98165825070767, 2.523290921172666],
            [30.98185626185418, 2.526978693993837],
            [30.983362641364213, 2.527677571173797],
            [30.986220862307682, 2.536798288398262],
            [30.987454584264366, 2.542556779013858],
            [30.989201307130365, 2.545919222192894],
            [30.990586118531336, 2.546208201347568],
            [30.990872311899377, 2.548506579823389],
            [30.991247350445658, 2.548904863156727],
            [30.992572864953022, 2.548370056970503],
            [30.994589267457222, 2.5485521816676],
            [30.995704640866805, 2.547432602707721],
            [30.99609334189024, 2.547619955949536],
            [30.99615142426157, 2.548415436257701],
            [30.99469724405607, 2.550622364053594],
            [30.993935678409336, 2.552751808081291],
            [30.994661078781025, 2.55301743025138],
            [30.99493667382535, 2.551663717123499],
            [30.996041620489457, 2.551474863078928],
            [30.996724879094547, 2.552935300729046],
            [30.996626966321845, 2.553771643706984],
            [30.997320367804825, 2.554322853431684],
            [30.99753998792548, 2.555148382466623],
            [30.998832434548923, 2.556049649760121],
            [30.999763933599656, 2.555338863894784],
            [31.000926492816173, 2.556907964061136],
            [31.003321731045354, 2.557569528238168],
            [31.00332087854414, 2.558119650453585],
            [31.002393345555394, 2.559313659234527],
            [31.002412808454338, 2.560329303187824],
            [31.004964361627778, 2.563295515685546],
            [31.006991950852207, 2.564980808828107],
            [31.007295841929672, 2.565732419023635],
            [31.006047694826155, 2.566771234498244],
            [31.006234988172988, 2.568232992759967],
            [31.007406613187353, 2.568916974730397],
            [31.008459321919347, 2.568410817823159],
            [31.008320717260922, 2.569606066198561],
            [31.008856836314035, 2.569839654449799],
            [31.011054977881688, 2.570086427430829],
            [31.012930925197914, 2.56951433543064],
            [31.013688689174366, 2.569833232570539],
            [31.014375685669382, 2.575044772602018],
            [31.01412184871955, 2.575743339179436],
            [31.014905447345267, 2.576609362445566],
            [31.016063064929387, 2.576293796381643],
            [31.016065769756715, 2.57454820065468],
            [31.016751987412373, 2.573746131643977],
            [31.01833808881062, 2.574456542932278],
            [31.01937241172369, 2.57355517553491],
            [31.02052586561649, 2.575218512611516],
            [31.020500148646523, 2.575233319844646],
            [31.01000395349082, 2.581276603051139],
            [31.000537233040614, 2.586726988590232],
            [30.991012691628836, 2.591160207471524],
            [30.984705317286757, 2.5955984658481],
            [30.98282069493983, 2.600582974351183],
            [30.981257925484464, 2.613858065474775],
            [30.9840972674339, 2.640485307555485],
            [30.984216935606135, 2.64938218522866],
            [30.983800551200584, 2.658143384466007],
            [30.98089932251461, 2.669798631086667],
            [30.978475688539284, 2.676264910516885],
            [30.976824778184877, 2.683988876407997],
            [30.976732848191944, 2.687761200330867],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 616,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "ATYAK",
        Population: 22116,
        Key: "ZOMBOATYAK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.89178211465365, 2.496447291362566],
            [30.891077782470287, 2.496901257541628],
            [30.890858072518093, 2.495824486194393],
            [30.890133504884677, 2.495056216238556],
            [30.888695073942692, 2.494521870751376],
            [30.886062804446055, 2.494356771463235],
            [30.87969690037163, 2.490436744563253],
            [30.873989744369826, 2.489994450406052],
            [30.87254851517575, 2.491216983134113],
            [30.870332975936012, 2.492017586535349],
            [30.867061034990147, 2.491876158492057],
            [30.86555927461729, 2.492492328772978],
            [30.864750442315273, 2.493385570411331],
            [30.86545375850402, 2.495793061522169],
            [30.865109871735154, 2.496733513730302],
            [30.862393122872543, 2.494658410024249],
            [30.860272541846555, 2.486685759621664],
            [30.858826947738514, 2.485380745178098],
            [30.857839759428387, 2.48331021505677],
            [30.856014684604986, 2.481085066816018],
            [30.85280399708341, 2.475702428199455],
            [30.853488021951453, 2.471770496531648],
            [30.852558556686514, 2.46474292549489],
            [30.85271392211155, 2.461947640618308],
            [30.85112100519523, 2.459076004162366],
            [30.846259490862536, 2.455753609673764],
            [30.843193762681707, 2.449568641629773],
            [30.84362782683037, 2.445065648729371],
            [30.84481619644163, 2.441162023695915],
            [30.845434444867944, 2.441020298557667],
            [30.844785333023417, 2.43932204232165],
            [30.84615347169269, 2.437724735009021],
            [30.846620521080276, 2.436065286253017],
            [30.84815099430456, 2.434922397691702],
            [30.848148617362313, 2.433823234602626],
            [30.848931249400778, 2.432668018694063],
            [30.8482314824557, 2.432577122902222],
            [30.847399823962306, 2.430630159526184],
            [30.846108087007934, 2.430305159611742],
            [30.845016190169964, 2.430497160639368],
            [30.844683045455287, 2.429309879309506],
            [30.84245108321552, 2.42939953586302],
            [30.84140042803225, 2.428560431244631],
            [30.837694510074314, 2.42802946514356],
            [30.837683511101954, 2.427361263395055],
            [30.837216013455055, 2.42720063615636],
            [30.83728288494312, 2.426438726792413],
            [30.836399727831125, 2.425990254506072],
            [30.836219472784514, 2.425004423609971],
            [30.834628896877856, 2.424008055210916],
            [30.834880260765708, 2.422999566074572],
            [30.83447211031805, 2.420800184770976],
            [30.835231211885944, 2.417397215527873],
            [30.833371240208702, 2.415385141474042],
            [30.833180662621178, 2.414309384141671],
            [30.83446869133006, 2.412998598127664],
            [30.836781342943585, 2.412933033483743],
            [30.837668246030344, 2.412672540296313],
            [30.838298657645584, 2.411945421393549],
            [30.839904621693094, 2.408437158752567],
            [30.840304072855556, 2.406622214171682],
            [30.840124041489457, 2.404220321257839],
            [30.838584331787413, 2.401086062356184],
            [30.83904089064909, 2.400800528600328],
            [30.840817174376138, 2.401426472610919],
            [30.84170423376976, 2.401237654589773],
            [30.842240840608095, 2.400665598007148],
            [30.84286764369087, 2.398289726531708],
            [30.845069056922746, 2.396551205675286],
            [30.846408957051096, 2.394380301610504],
            [30.84660900647498, 2.393628140812345],
            [30.845500019188734, 2.39071006807924],
            [30.846946741580755, 2.388204919044052],
            [30.847198009348887, 2.386282048514672],
            [30.848483573978932, 2.383872040297701],
            [30.848560213747398, 2.382032343146716],
            [30.850076216010777, 2.38047119961765],
            [30.854456160587638, 2.378857793193999],
            [30.85644968928974, 2.374334911784609],
            [30.86144952082002, 2.373344349483082],
            [30.863547846084852, 2.37366044764138],
            [30.865133683378385, 2.37328224567041],
            [30.866099180967666, 2.372090003251885],
            [30.865566058694338, 2.368157874946425],
            [30.866854482661942, 2.36706204998879],
            [30.870402042008322, 2.366043755385626],
            [30.87341409046102, 2.366075457729218],
            [30.87413717677259, 2.364715308868781],
            [30.874321216421475, 2.362828060871183],
            [30.877099919394272, 2.360720514047863],
            [30.87688109607928, 2.359071180654881],
            [30.875745899546313, 2.356511455853191],
            [30.876721747524282, 2.353945234313843],
            [30.876635889244366, 2.351627166909609],
            [30.879197210698212, 2.348539328034682],
            [30.87983685250303, 2.3459602863117],
            [30.88131343309845, 2.344840998637263],
            [30.881715047404125, 2.344053485520602],
            [30.881397658241173, 2.340432533302938],
            [30.88190464492965, 2.338665577611101],
            [30.882602125662356, 2.337902710024305],
            [30.88499427548358, 2.337335359255248],
            [30.887658463020585, 2.338154631184028],
            [30.889657519954966, 2.336188366621853],
            [30.891945755359078, 2.337245630285524],
            [30.896106399615515, 2.33383919772874],
            [30.89920896680781, 2.332281947664068],
            [30.902112990152688, 2.332122085746673],
            [30.905575924606033, 2.32938289221134],
            [30.911261919893036, 2.328596826288895],
            [30.91180064765376, 2.328980531723801],
            [30.912018074986793, 2.329984702207193],
            [30.912215778011163, 2.334143083533211],
            [30.913193454959057, 2.33750375016648],
            [30.913174730475287, 2.338643927395801],
            [30.92184547171855, 2.336269986126887],
            [30.92475689628301, 2.336548913618449],
            [30.92621352888925, 2.336062914343905],
            [30.92791630706987, 2.333197467238663],
            [30.929646770429237, 2.332132168164433],
            [30.934841824735326, 2.332228960448248],
            [30.937050521507572, 2.333739997374868],
            [30.937637288474736, 2.334647991673847],
            [30.936334500445742, 2.336357754869292],
            [30.93472371783504, 2.34083779054607],
            [30.93389263516172, 2.344014997992334],
            [30.934050631752214, 2.346769881967346],
            [30.931487518159397, 2.348689428005664],
            [30.9302686848802, 2.351067361201137],
            [30.927425749669613, 2.351363648124032],
            [30.925949894912947, 2.352164451755789],
            [30.922446294624965, 2.352081132304362],
            [30.919860810286593, 2.353460212239315],
            [30.917044671820953, 2.353366756747024],
            [30.91463565163867, 2.351724623835088],
            [30.913426050345684, 2.351984388065246],
            [30.913212475886894, 2.352676819285589],
            [30.913564893956, 2.3539203055584],
            [30.912517940730012, 2.354753978044969],
            [30.9135424252941, 2.355879706711041],
            [30.914166048340775, 2.358127504675606],
            [30.91574376216922, 2.360102939183464],
            [30.914102780893632, 2.359883683054387],
            [30.913863923351137, 2.361292927386123],
            [30.913487789758527, 2.361459240267399],
            [30.91171341584978, 2.361717548646549],
            [30.910851419452573, 2.361094050377745],
            [30.90843698602242, 2.363740297834881],
            [30.908116685419678, 2.364814787955713],
            [30.908535495276492, 2.365688054699699],
            [30.90789971892235, 2.369987660123585],
            [30.908170474742246, 2.370800807748465],
            [30.907634110449024, 2.371468516560696],
            [30.906746680051203, 2.371490132159137],
            [30.90670781533878, 2.372147155359682],
            [30.90432006905906, 2.374721759507178],
            [30.90432445553259, 2.376681207567567],
            [30.903786369168998, 2.376584239760269],
            [30.903677678409487, 2.376082153436716],
            [30.903033831590857, 2.376797367518818],
            [30.90262181659085, 2.378958864399286],
            [30.90329576685298, 2.379677473283823],
            [30.90308382014147, 2.381110664463794],
            [30.902574174439753, 2.38170673658008],
            [30.902751310535674, 2.382746654808818],
            [30.90453979697756, 2.385156185712171],
            [30.905378760570855, 2.385131051982623],
            [30.90726570775777, 2.38709536873379],
            [30.908212860850625, 2.389726337915407],
            [30.908831313194476, 2.389680138247475],
            [30.910016737229952, 2.390615138661192],
            [30.908540396484693, 2.3918778016128],
            [30.908474999131993, 2.39270203609776],
            [30.909553317036107, 2.393851810128276],
            [30.909905124250816, 2.394832448929803],
            [30.908589878385477, 2.395976047064258],
            [30.909423377526885, 2.395882615988467],
            [30.90955886682794, 2.396336988685556],
            [30.90915950459869, 2.39815202861033],
            [30.908569372542463, 2.398843482613751],
            [30.90939068873201, 2.399311573937124],
            [30.909286512905148, 2.400840627403846],
            [30.910668180202606, 2.405360498255595],
            [30.91022635820318, 2.406231550196523],
            [30.910500244651825, 2.408591546846862],
            [30.912374315387442, 2.410568698564771],
            [30.914438496586666, 2.411537461048029],
            [30.915627609104657, 2.412849242023973],
            [30.917653068423526, 2.41405409233513],
            [30.918535053234113, 2.413538872895656],
            [30.919356295761798, 2.413860961693822],
            [30.919121876795128, 2.415143891528412],
            [30.920488227817014, 2.416064966586009],
            [30.920860157294104, 2.416783313653217],
            [30.921876188711366, 2.416996949429755],
            [30.922059003956505, 2.417649754025424],
            [30.924457754598436, 2.418692048455153],
            [30.924061655948634, 2.419643034361207],
            [30.924479472268764, 2.420163446295063],
            [30.927510060152297, 2.419381775086063],
            [30.92794066668543, 2.41896961032218],
            [30.928011073044136, 2.417652600945131],
            [30.929349928431797, 2.417615341478824],
            [30.931097070811038, 2.418994118758756],
            [30.933168536448857, 2.419164395253845],
            [30.933720324815507, 2.42023666817899],
            [30.93520095321961, 2.419756394907659],
            [30.935924107803125, 2.420109188879228],
            [30.936288876809087, 2.420862191291196],
            [30.938181964879263, 2.421862898787339],
            [30.941840326924396, 2.422359224221875],
            [30.94290350641932, 2.424417165108902],
            [30.94395397475302, 2.425112862656351],
            [30.94452025653844, 2.426315364057194],
            [30.948680191125842, 2.427309543526441],
            [30.94912199785392, 2.426849793423629],
            [30.950045913327017, 2.426800975184037],
            [30.952582988353004, 2.427849946319177],
            [30.952475690880533, 2.429304702483652],
            [30.952908160519573, 2.430261668202937],
            [30.954414199568117, 2.43021775137427],
            [30.954979912719967, 2.430625447614069],
            [30.95501120912615, 2.432585035313115],
            [30.954205887440256, 2.433275957515605],
            [30.953128572954302, 2.432604083975451],
            [30.95251083117782, 2.432984837276701],
            [30.95281592869272, 2.437119699821317],
            [30.951822556380172, 2.437905719037489],
            [30.950985908643663, 2.436613157251641],
            [30.95015337069961, 2.437160632228627],
            [30.949963285388865, 2.436347658759657],
            [30.949478692802096, 2.43613134519802],
            [30.947328755730926, 2.436890480292057],
            [30.946953547403062, 2.437486921996305],
            [30.94560887991552, 2.43753124605428],
            [30.945478298110874, 2.439275337251707],
            [30.944995510239515, 2.439871490698502],
            [30.94381252872331, 2.440059606876904],
            [30.942914480238866, 2.441383527588119],
            [30.942755984185045, 2.442673509864152],
            [30.94205670143193, 2.442671700506078],
            [30.94143698785339, 2.442168276145471],
            [30.940738715704942, 2.442620500877136],
            [30.94171024907462, 2.444104577607802],
            [30.941603671152684, 2.444558335511036],
            [30.941173237096095, 2.444509420983475],
            [30.940694592254815, 2.446969497037827],
            [30.9395372818945, 2.446608054639192],
            [30.939296227072838, 2.447061455389715],
            [30.938785157541417, 2.447036233953831],
            [30.938676459595403, 2.446534135037699],
            [30.93811207684848, 2.446723836158757],
            [30.936119052101244, 2.445476067067524],
            [30.9360127966745, 2.446073193341086],
            [30.935475209774197, 2.446215175527512],
            [30.934612698642354, 2.445376576810176],
            [30.935094373501048, 2.444278602475412],
            [30.934662721328927, 2.44368007889586],
            [30.933749227211454, 2.444107838218341],
            [30.934183799806572, 2.446020655674177],
            [30.93378785207372, 2.446640115005624],
            [30.932711895840505, 2.445889779093741],
            [30.931422293283244, 2.44648642950999],
            [30.928177901870498, 2.446461671171506],
            [30.92704152315462, 2.446045832254298],
            [30.926030942714505, 2.446329032848284],
            [30.925388740711128, 2.445878316263399],
            [30.924851414322244, 2.446139769649805],
            [30.92495735264372, 2.445399269130089],
            [30.92439208056467, 2.445182738035736],
            [30.92407350742218, 2.444218728589514],
            [30.922975443649797, 2.4442232941619],
            [30.92185125597066, 2.444987118598244],
            [30.921377618338802, 2.444647518965228],
            [30.921187000327073, 2.443119339747146],
            [30.920268660696955, 2.441348650741377],
            [30.918225898029057, 2.441916831798041],
            [30.917283039781594, 2.441221392425576],
            [30.916800191723127, 2.441793641004394],
            [30.916339548221842, 2.440239207542723],
            [30.917119876081593, 2.440408510263156],
            [30.917119084665817, 2.440050073623506],
            [30.915957155168332, 2.43758577291858],
            [30.91555331483741, 2.437393553012476],
            [30.914961833511615, 2.437487602303218],
            [30.914185041420808, 2.438919323564205],
            [30.913727877094615, 2.438942031250708],
            [30.91313987943553, 2.44061319781429],
            [30.911850819460682, 2.44147008696361],
            [30.910061743723997, 2.441214507702971],
            [30.909821851322313, 2.442193609860253],
            [30.908183255972112, 2.443097360002697],
            [30.9076165178425, 2.442211742937259],
            [30.906998297263964, 2.442377395279816],
            [30.90409994857679, 2.451366533572394],
            [30.89942700589357, 2.454460696219616],
            [30.89957803245579, 2.455882875192373],
            [30.898348011558046, 2.459153331730134],
            [30.89177690532332, 2.463946792126794],
            [30.88935863608689, 2.466536456769574],
            [30.888837849479, 2.46842804717711],
            [30.8890197789853, 2.469315686838364],
            [30.890995138362484, 2.472861898446313],
            [30.892530813730563, 2.474084630105853],
            [30.89334353214452, 2.47678697734022],
            [30.892321817086454, 2.476927643247461],
            [30.8887665322286, 2.48077733489606],
            [30.889146471983082, 2.482355441278181],
            [30.888440734834617, 2.485591391302477],
            [30.887126511252077, 2.487284474763407],
            [30.889802828740358, 2.48975950157134],
            [30.890469551157715, 2.490997148749714],
            [30.891538989215245, 2.49129827921737],
            [30.892318944274166, 2.492150980450979],
            [30.892590363050754, 2.495411497823907],
            [30.89178211465365, 2.496447291362566],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 617,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "JANGOKORO",
        Population: 31189,
        Key: "ZOMBOJANGOKORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.910325251936175, 2.669609434962195],
            [30.910300658758636, 2.670099303735623],
            [30.909398514854786, 2.670857144822792],
            [30.90795627595434, 2.669802193527344],
            [30.906604743541376, 2.669946424807128],
            [30.905890623314708, 2.669199139473765],
            [30.905838828252026, 2.668492956399299],
            [30.90406246367661, 2.669169358531576],
            [30.902012508198254, 2.667127498493752],
            [30.90091538496197, 2.668073700583548],
            [30.90083010519712, 2.669097196186475],
            [30.900047124612307, 2.669895198350916],
            [30.899173981020756, 2.66961063021953],
            [30.898469432343422, 2.670598575535858],
            [30.8974085408575, 2.671222903917328],
            [30.897023469027808, 2.67174181621269],
            [30.89756617632527, 2.672009199816102],
            [30.897220369856633, 2.672807952057757],
            [30.896133752417608, 2.672979270026626],
            [30.895736886606553, 2.672645523994008],
            [30.895549517801225, 2.671153088234954],
            [30.892258422976848, 2.669295595514914],
            [30.891276429624003, 2.670266435094516],
            [30.89061813699728, 2.667867266260925],
            [30.889240849885134, 2.667586479058565],
            [30.88736805385893, 2.668604395400219],
            [30.887500664957777, 2.670353165682983],
            [30.88641051983465, 2.672589434077446],
            [30.88573397254301, 2.673121157086961],
            [30.885238793310645, 2.672582562261624],
            [30.8846479785348, 2.67293276100248],
            [30.882694319759963, 2.670325194703204],
            [30.881693209359558, 2.670270342112368],
            [30.880743473610245, 2.670847703017095],
            [30.88025215264202, 2.670597710500445],
            [30.880170679039, 2.670017089441781],
            [30.877204104204303, 2.672147136904429],
            [30.87651687324902, 2.67128690932487],
            [30.87617113145908, 2.671945505822745],
            [30.875045196556723, 2.671876933892861],
            [30.874936645934394, 2.673368838445386],
            [30.873983431010025, 2.673567973797757],
            [30.873385155725746, 2.674245402380143],
            [30.871293846303278, 2.67318929643051],
            [30.868919924197456, 2.674690560403404],
            [30.867835095304184, 2.673836042569012],
            [30.867053463988942, 2.673847998690746],
            [30.866641083374624, 2.674833118473519],
            [30.864985020283733, 2.674896829366399],
            [30.86469741745897, 2.673869974480133],
            [30.863716462558603, 2.673042825776311],
            [30.862285081595004, 2.673413339211502],
            [30.861438417643093, 2.67273242490865],
            [30.861211818510988, 2.671604559261695],
            [30.85968949031139, 2.672875902080387],
            [30.858271498737096, 2.673166498667534],
            [30.858480567246442, 2.674832130506009],
            [30.857817844128732, 2.675030798108581],
            [30.85709110706386, 2.673950429735091],
            [30.856879277133334, 2.672454367623974],
            [30.85284411404735, 2.670812273362823],
            [30.85303196345136, 2.669440429866978],
            [30.852236216009764, 2.669958590944336],
            [30.850035917587117, 2.67030429924755],
            [30.849768973318973, 2.671806013623652],
            [30.846541000414714, 2.669282461140625],
            [30.845758268663232, 2.669933859353438],
            [30.844569353774602, 2.668013393850412],
            [30.84467590923865, 2.667595692964511],
            [30.844095621819616, 2.667010150360221],
            [30.84351112579348, 2.667118953104205],
            [30.843257055281672, 2.665654659394702],
            [30.8430265781225, 2.665266868860156],
            [30.84236191015221, 2.66522520519935],
            [30.84138311390347, 2.663397790603703],
            [30.840353066072822, 2.662588018231169],
            [30.838646609291125, 2.662046138096066],
            [30.837753991122526, 2.6611075462566],
            [30.836427249516465, 2.661098742389469],
            [30.835336736084056, 2.660615451175938],
            [30.833535848399706, 2.661247670503277],
            [30.83136974165341, 2.65998081317318],
            [30.82928764625081, 2.659911587307651],
            [30.826341488325873, 2.658539297348092],
            [30.823755844985715, 2.659035328128399],
            [30.821494879738687, 2.659994033792075],
            [30.818930317163314, 2.659392586570697],
            [30.81644021863677, 2.657671536884554],
            [30.814681396362204, 2.654731402393916],
            [30.81270878852473, 2.65378805082149],
            [30.81038556104538, 2.652938058189149],
            [30.807804114634223, 2.652780731647272],
            [30.806203147914644, 2.653083322500249],
            [30.804429172857873, 2.65212857149145],
            [30.802641175099506, 2.652501310370153],
            [30.80022393353579, 2.651980079288795],
            [30.79811271564998, 2.65016712569341],
            [30.79667118102872, 2.645872589557862],
            [30.792029922823897, 2.644431438667747],
            [30.789738464264563, 2.643768845905629],
            [30.788222816835738, 2.643894158513747],
            [30.787120621711342, 2.643088486863821],
            [30.787775322873568, 2.640085924186874],
            [30.787759521507727, 2.638897524950965],
            [30.787259678222405, 2.638032361157391],
            [30.78740700552224, 2.635727906778236],
            [30.78805506633789, 2.633784459563346],
            [30.791279446879358, 2.633069989733581],
            [30.791612034638568, 2.631863915524903],
            [30.7909865116551, 2.630504170254179],
            [30.78921942577823, 2.629084984423521],
            [30.788842546583925, 2.62699853165286],
            [30.78759052863986, 2.624833978839902],
            [30.78572865073757, 2.623223272623084],
            [30.78357059379454, 2.616923833492512],
            [30.78083562260641, 2.614086909185291],
            [30.78154391007196, 2.611657958999863],
            [30.78144957978058, 2.611198539600817],
            [30.78015713136051, 2.610392550718636],
            [30.77972125171665, 2.609396730552018],
            [30.77942225825413, 2.606296249424219],
            [30.780359226248294, 2.603657212871989],
            [30.779203193292318, 2.60101446636713],
            [30.777246412871836, 2.599288806120401],
            [30.7744294587359, 2.599819602935833],
            [30.773269477684252, 2.599434834068453],
            [30.772946554000878, 2.599128095041525],
            [30.772672131258005, 2.595937688682254],
            [30.772037966481488, 2.595528636055994],
            [30.767575488289566, 2.595910903283226],
            [30.76130125639161, 2.593629539551963],
            [30.759875225793827, 2.592243600970112],
            [30.757924385932352, 2.588444651308858],
            [30.753957011514306, 2.588118337345332],
            [30.753008116588116, 2.586183444094518],
            [30.751473045786216, 2.584997783863678],
            [30.75078434788207, 2.583354066022189],
            [30.75081529484361, 2.582439631561741],
            [30.75184619158221, 2.58008149215806],
            [30.75319826927251, 2.578579410891571],
            [30.754640159626653, 2.576044994666348],
            [30.754540875126487, 2.574112585011524],
            [30.753490541540117, 2.570836252364059],
            [30.753522305070252, 2.569449820474124],
            [30.75756602820258, 2.563660260679015],
            [30.758292884743366, 2.561988952047189],
            [30.75798938173808, 2.558723727996075],
            [30.75670633418747, 2.555715884292528],
            [30.756503183779202, 2.554005453817745],
            [30.759448533220382, 2.549346779229746],
            [30.759554915309618, 2.547429606197184],
            [30.758247654568805, 2.543514869642671],
            [30.757208435837423, 2.538039247370691],
            [30.758488976190108, 2.532958918738267],
            [30.760496627306782, 2.533288068294631],
            [30.761991514669386, 2.535034840111098],
            [30.762064416547968, 2.536014782590091],
            [30.763041709016935, 2.537286438167762],
            [30.764515768041367, 2.537906177634143],
            [30.769060515743632, 2.537118871861213],
            [30.769959673647495, 2.535791129982568],
            [30.771164901043385, 2.534903060578788],
            [30.77329054587261, 2.534052189323161],
            [30.774822591148652, 2.531823502627269],
            [30.778590173060948, 2.530037812601649],
            [30.780478579111886, 2.529898641247472],
            [30.783323147459665, 2.528728490610569],
            [30.785003800134806, 2.527231155099207],
            [30.785591146515365, 2.525394387077217],
            [30.7864004782807, 2.524595653736867],
            [30.78773166295414, 2.52356595371389],
            [30.79082974036664, 2.522215371445581],
            [30.79225636475084, 2.523918073933714],
            [30.794417297201083, 2.525084447978708],
            [30.793617056386406, 2.527858513266803],
            [30.792882103329983, 2.528985335371676],
            [30.793616264970666, 2.529955681617228],
            [30.794710135407293, 2.530591867474511],
            [30.795192522630018, 2.530231487236951],
            [30.795866129735725, 2.530752423831361],
            [30.797130349496307, 2.534252124774271],
            [30.798216122518962, 2.534500661768099],
            [30.799001028193423, 2.536545909028612],
            [30.799491328675476, 2.536687707358135],
            [30.80019866662176, 2.537983978892017],
            [30.80057936275773, 2.537899179442475],
            [30.800490778989253, 2.541971074170727],
            [30.801730566370736, 2.541885400884746],
            [30.804205981933954, 2.544172432786767],
            [30.804430220293483, 2.545788331328227],
            [30.80405721822796, 2.549527956106664],
            [30.804684998677736, 2.549985593070282],
            [30.803651674691245, 2.551862729985148],
            [30.80352174147024, 2.553336656366113],
            [30.80436409081386, 2.553970273940022],
            [30.80400954104258, 2.555288541851291],
            [30.805019531289563, 2.556031739021185],
            [30.804823135313935, 2.556425094974788],
            [30.805403767686027, 2.556439217693127],
            [30.805501811612768, 2.557887241067844],
            [30.807999097559883, 2.558257473529495],
            [30.80806005903171, 2.559545660933433],
            [30.809401307531303, 2.559852683219959],
            [30.81048151189752, 2.560953690055363],
            [30.81148771035566, 2.561031599404782],
            [30.811325427004647, 2.562053824552248],
            [30.8126345822924, 2.563089940892639],
            [30.814275261734036, 2.563282461865742],
            [30.81528191923132, 2.564735398932514],
            [30.81680994993633, 2.564593946507856],
            [30.817129652261105, 2.565184369517628],
            [30.81751655216243, 2.565052243979023],
            [30.81805336830822, 2.565498962838906],
            [30.818390757562618, 2.565245282465355],
            [30.81909003133263, 2.565946538573665],
            [30.81991995248427, 2.565957448442823],
            [30.820258667652013, 2.566432282077841],
            [30.820579663550806, 2.566233647494564],
            [30.821482267392106, 2.567876110410915],
            [30.82260333342566, 2.56860838324943],
            [30.823018400901002, 2.568552185468635],
            [30.823226835199726, 2.567992923994461],
            [30.823801234162087, 2.568525072833986],
            [30.824320477464294, 2.568212955322645],
            [30.824677912624256, 2.56877318770091],
            [30.825265949809243, 2.568838588437826],
            [30.82544139707246, 2.569428465654828],
            [30.826964338821384, 2.569397414296771],
            [30.826931951860455, 2.568757793484959],
            [30.827703242668438, 2.567883918803462],
            [30.828104512021028, 2.568103403625832],
            [30.829687415416878, 2.56751923155185],
            [30.83251832128747, 2.570618727957747],
            [30.832943099551038, 2.570658071366392],
            [30.834363133894296, 2.574021431601581],
            [30.834310860927925, 2.57468998850462],
            [30.83588127863962, 2.574309948535283],
            [30.837268194793282, 2.574519753700904],
            [30.83862323602574, 2.575124266812283],
            [30.840433838989902, 2.577111074832497],
            [30.84272353595299, 2.576973287891763],
            [30.845650251640215, 2.575047685589015],
            [30.851353329290628, 2.576828567570142],
            [30.85161080262074, 2.580814182455207],
            [30.851184165742847, 2.583169139207502],
            [30.85132431191032, 2.583612175957398],
            [30.852543693161845, 2.584246444382742],
            [30.851091824321546, 2.586119089720291],
            [30.84570982701155, 2.587847812809638],
            [30.845133019665944, 2.588503012736631],
            [30.845496419639392, 2.590331035882095],
            [30.847697302865253, 2.593710779826438],
            [30.851047450241452, 2.597682704874601],
            [30.849377632146943, 2.599521288707987],
            [30.85235099105865, 2.60420082972175],
            [30.85579422276292, 2.608668712448811],
            [30.85522449144678, 2.612397853115467],
            [30.85766657052981, 2.615989393856069],
            [30.8623341996781, 2.617821726721577],
            [30.86627087956119, 2.621132368954613],
            [30.86870110267909, 2.619958624660158],
            [30.869870955317417, 2.620793783770946],
            [30.87141284253569, 2.621241732094734],
            [30.8725157751769, 2.619419289732817],
            [30.873601514063605, 2.618555008017981],
            [30.874399808229036, 2.622111276852394],
            [30.874232288598243, 2.626047042294156],
            [30.87556815798588, 2.632945935040383],
            [30.875214938619536, 2.633931511875285],
            [30.874010448740496, 2.635008662284564],
            [30.872714172598997, 2.63565768527712],
            [30.870078865000036, 2.636086888599521],
            [30.87053070590983, 2.63863974224513],
            [30.870908275908594, 2.638996172921559],
            [30.872663630686166, 2.639784368408971],
            [30.874270613423178, 2.641737798358411],
            [30.875039043097, 2.641812731556377],
            [30.87712621038769, 2.641178369271536],
            [30.878725905092846, 2.640248725348921],
            [30.87956841433655, 2.639226727783195],
            [30.882266226712975, 2.638770326479568],
            [30.885124567132358, 2.636591445253137],
            [30.886625810973953, 2.636164617428931],
            [30.888357910165432, 2.636290261034079],
            [30.8893348325285, 2.63571531226117],
            [30.889615168880905, 2.635863012242482],
            [30.889418260865565, 2.636880956486912],
            [30.890759984573926, 2.637005930586161],
            [30.891611396122094, 2.638516403305359],
            [30.892294066330685, 2.638812010773386],
            [30.89495442794292, 2.638289001645917],
            [30.897235638521497, 2.638341959528073],
            [30.89827182903207, 2.638797656559229],
            [30.89884459755216, 2.638638976794636],
            [30.900941573547453, 2.639955437005745],
            [30.901820472645007, 2.639637948531755],
            [30.90318654968074, 2.639799759962258],
            [30.90583561228332, 2.638749157692075],
            [30.90707912048672, 2.639254275911865],
            [30.90761119262951, 2.638213306374147],
            [30.90897112698532, 2.638366307679762],
            [30.90975699834869, 2.637150449259186],
            [30.910344837005994, 2.63717462693505],
            [30.9108072151541, 2.636398725481389],
            [30.911522411562498, 2.636086942441411],
            [30.912375120277943, 2.636262265952193],
            [30.914619796373934, 2.63812082232942],
            [30.91469700297934, 2.640207566957264],
            [30.915701946491037, 2.638957293789474],
            [30.917339447693234, 2.638565917098996],
            [30.916356124833786, 2.640424220566321],
            [30.916297021976284, 2.641554976376206],
            [30.91469462424046, 2.641360962482194],
            [30.91430226437888, 2.64175421826273],
            [30.915235936454255, 2.642569046542849],
            [30.91479190819246, 2.643635687673084],
            [30.915485971733805, 2.644170556735788],
            [30.91545698220127, 2.646394241378535],
            [30.915997480541435, 2.646357387813462],
            [30.916524267895397, 2.647136337646901],
            [30.916388572880138, 2.648454359216112],
            [30.91546508680175, 2.649100855406821],
            [30.916234349213852, 2.650004358138097],
            [30.917383102222786, 2.649588184734853],
            [30.91812703843205, 2.651595945658705],
            [30.919250466136475, 2.652284029827401],
            [30.917409505505606, 2.652362851515215],
            [30.917839688033908, 2.654160404236087],
            [30.916618450863048, 2.655873482268861],
            [30.917267787286377, 2.656146830415006],
            [30.91753716419233, 2.656964024508174],
            [30.91829507369584, 2.657074209160037],
            [30.918293886123045, 2.657782047210945],
            [30.919267847638917, 2.658219293883612],
            [30.91904960463558, 2.659199010686496],
            [30.918290138351658, 2.660014460110071],
            [30.918124853729275, 2.661702104612551],
            [30.91693072142547, 2.663387998776226],
            [30.916009901546868, 2.663549780180045],
            [30.915722992221536, 2.665204369779067],
            [30.914162338298627, 2.664446318819047],
            [30.913562897001118, 2.666393725428277],
            [30.911803833978063, 2.666630529659349],
            [30.91059820323861, 2.66745580185184],
            [30.91016372316999, 2.668360050293169],
            [30.910325251936175, 2.669609434962195],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 618,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "KANGO",
        Population: 34822,
        Key: "ZOMBOKANGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.995704640866805, 2.547432602707721],
            [30.994589267457222, 2.5485521816676],
            [30.992572864953022, 2.548370056970503],
            [30.991247350445658, 2.548904863156727],
            [30.990872311899377, 2.548506579823389],
            [30.990586118531336, 2.546208201347568],
            [30.989201307130365, 2.545919222192894],
            [30.987454584264366, 2.542556779013858],
            [30.986220862307682, 2.536798288398262],
            [30.983362641364213, 2.527677571173797],
            [30.98185626185418, 2.526978693993837],
            [30.98165825070767, 2.523290921172666],
            [30.981089004481795, 2.522552539703529],
            [30.98060060752979, 2.522224003071832],
            [30.97868491784708, 2.522753641809778],
            [30.978074107471336, 2.522547827220905],
            [30.97844224156632, 2.521606053694343],
            [30.977831177865664, 2.521564125939822],
            [30.975975810054244, 2.522606000488832],
            [30.9750388770944, 2.522522589278082],
            [30.97487768699306, 2.521375131088417],
            [30.973289206855927, 2.521085841259946],
            [30.972312931279905, 2.520100992834418],
            [30.97170091895828, 2.520673635361556],
            [30.971697683226637, 2.521674437240701],
            [30.97128509959307, 2.522173659097513],
            [30.968819806246447, 2.522045862915349],
            [30.96588087347133, 2.527378081531191],
            [30.965089880812545, 2.527669357791427],
            [30.964700309321586, 2.529287113115666],
            [30.964860908331445, 2.530803306833976],
            [30.964206287119293, 2.532564040750212],
            [30.9649370764844, 2.534204052678986],
            [30.962873740599882, 2.537949662805971],
            [30.959854400522005, 2.540771887264072],
            [30.958181983601353, 2.542039334591693],
            [30.95388161718224, 2.543364042118282],
            [30.953107909906134, 2.543116979512742],
            [30.952986396594287, 2.542666104943216],
            [30.95291520600634, 2.539414847947106],
            [30.951629983634394, 2.538212030341546],
            [30.950931578535275, 2.538347542861572],
            [30.94908657009575, 2.536987529591926],
            [30.9484691903403, 2.534352176398539],
            [30.947902502516364, 2.533571358728535],
            [30.942785915152, 2.535475304395455],
            [30.93777273465663, 2.534181544068039],
            [30.93709706771401, 2.533295613050585],
            [30.935062088948065, 2.532140520005632],
            [30.934911421711984, 2.53116341139883],
            [30.933804925454016, 2.529579696517299],
            [30.933913692570318, 2.52857090453163],
            [30.932945626697634, 2.527522525623747],
            [30.93703212131559, 2.52577366969614],
            [30.937853728559297, 2.524423318569926],
            [30.94021557640936, 2.523306193879407],
            [30.941266475036034, 2.522055104805419],
            [30.941563611680884, 2.52070391070506],
            [30.94075666763757, 2.520160995207563],
            [30.9403879711972, 2.518485178025931],
            [30.94085546255589, 2.518016532600568],
            [30.9423493671616, 2.51783115305243],
            [30.944308553270407, 2.518585288301673],
            [30.944869984153296, 2.517741277217001],
            [30.944497907352485, 2.516895785692734],
            [30.94692723395175, 2.515491467990739],
            [30.948513021837982, 2.516245004200233],
            [30.947947767725235, 2.519529843406963],
            [30.94888127810387, 2.519531323296875],
            [30.949162068105476, 2.519062376705673],
            [30.951303262772296, 2.522820900797729],
            [30.95288361764768, 2.527047933416886],
            [30.95387263043614, 2.528649699817098],
            [30.957315386931615, 2.528882411523669],
            [30.958202416680802, 2.526934488705428],
            [30.961345823980903, 2.524863150171467],
            [30.961219561276135, 2.523034096824083],
            [30.962397598464978, 2.51968125076362],
            [30.961914607574407, 2.518912154804992],
            [30.963733013305117, 2.518904195344823],
            [30.96305622077344, 2.517379662117334],
            [30.96308810916937, 2.515226709544823],
            [30.962304884242847, 2.514096292003541],
            [30.96122858395485, 2.513795682806829],
            [30.960918286092788, 2.513212174508369],
            [30.959396969396185, 2.513971254689972],
            [30.95833385547824, 2.513026332987312],
            [30.957098529130437, 2.512801323066659],
            [30.954934219913042, 2.510956034020406],
            [30.95368968852855, 2.508506734117349],
            [30.952657502707513, 2.508052605927854],
            [30.952591401973958, 2.507013456097559],
            [30.95078738905074, 2.504853047421559],
            [30.949917830635467, 2.504630823596347],
            [30.949357052827796, 2.503881326429895],
            [30.946328907463506, 2.504273864466652],
            [30.94373443098915, 2.503360800003307],
            [30.942332931585174, 2.501946785975201],
            [30.941083875386564, 2.501422640224532],
            [30.93970372444531, 2.498654879961068],
            [30.938800428002914, 2.498363357604913],
            [30.93814607808198, 2.498729778481377],
            [30.936434845856216, 2.498649714174334],
            [30.934394639793663, 2.499903562017112],
            [30.932548233575517, 2.50019073045199],
            [30.93168349013019, 2.499841245958573],
            [30.93102747113945, 2.501271334857689],
            [30.93000716913132, 2.502023958468476],
            [30.92887410789379, 2.501113198011537],
            [30.92683526727045, 2.501496747027805],
            [30.92489765240655, 2.498650753434422],
            [30.924651693681767, 2.496097545608699],
            [30.921578664892632, 2.493849277829637],
            [30.921158284780685, 2.492166074925619],
            [30.920365957225375, 2.491503272154873],
            [30.920368392558107, 2.489953208201574],
            [30.919254338773666, 2.489423755430733],
            [30.9126585989372, 2.489750089831972],
            [30.909277285410564, 2.489362281597627],
            [30.904490317771703, 2.492051636384983],
            [30.903957804556104, 2.492601535052378],
            [30.90353811614696, 2.494236924096266],
            [30.90132592043672, 2.495240179225149],
            [30.898112766141345, 2.496199868048449],
            [30.89178211465365, 2.496447291362566],
            [30.892590363050754, 2.495411497823907],
            [30.892318944274166, 2.492150980450979],
            [30.891538989215245, 2.49129827921737],
            [30.890469551157715, 2.490997148749714],
            [30.889802828740358, 2.48975950157134],
            [30.887126511252077, 2.487284474763407],
            [30.888440734834617, 2.485591391302477],
            [30.889146471983082, 2.482355441278181],
            [30.8887665322286, 2.48077733489606],
            [30.892321817086454, 2.476927643247461],
            [30.89334353214452, 2.47678697734022],
            [30.892530813730563, 2.474084630105853],
            [30.890995138362484, 2.472861898446313],
            [30.8890197789853, 2.469315686838364],
            [30.888837849479, 2.46842804717711],
            [30.88935863608689, 2.466536456769574],
            [30.89177690532332, 2.463946792126794],
            [30.898348011558046, 2.459153331730134],
            [30.89957803245579, 2.455882875192373],
            [30.89942700589357, 2.454460696219616],
            [30.90409994857679, 2.451366533572394],
            [30.906998297263964, 2.442377395279816],
            [30.9076165178425, 2.442211742937259],
            [30.908183255972112, 2.443097360002697],
            [30.909821851322313, 2.442193609860253],
            [30.910061743723997, 2.441214507702971],
            [30.911850819460682, 2.44147008696361],
            [30.91313987943553, 2.44061319781429],
            [30.913727877094615, 2.438942031250708],
            [30.914185041420808, 2.438919323564205],
            [30.914961833511615, 2.437487602303218],
            [30.91555331483741, 2.437393553012476],
            [30.915957155168332, 2.43758577291858],
            [30.917119084665817, 2.440050073623506],
            [30.917119876081593, 2.440408510263156],
            [30.916339548221842, 2.440239207542723],
            [30.916800191723127, 2.441793641004394],
            [30.917283039781594, 2.441221392425576],
            [30.918225898029057, 2.441916831798041],
            [30.920268660696955, 2.441348650741377],
            [30.921187000327073, 2.443119339747146],
            [30.921377618338802, 2.444647518965228],
            [30.92185125597066, 2.444987118598244],
            [30.922975443649797, 2.4442232941619],
            [30.92407350742218, 2.444218728589514],
            [30.92439208056467, 2.445182738035736],
            [30.92495735264372, 2.445399269130089],
            [30.924851414322244, 2.446139769649805],
            [30.925388740711128, 2.445878316263399],
            [30.926030942714505, 2.446329032848284],
            [30.92704152315462, 2.446045832254298],
            [30.928177901870498, 2.446461671171506],
            [30.931422293283244, 2.44648642950999],
            [30.932711895840505, 2.445889779093741],
            [30.93378785207372, 2.446640115005624],
            [30.934183799806572, 2.446020655674177],
            [30.933749227211454, 2.444107838218341],
            [30.934662721328927, 2.44368007889586],
            [30.935094373501048, 2.444278602475412],
            [30.934612698642354, 2.445376576810176],
            [30.935475209774197, 2.446215175527512],
            [30.9360127966745, 2.446073193341086],
            [30.936119052101244, 2.445476067067524],
            [30.93811207684848, 2.446723836158757],
            [30.938676459595403, 2.446534135037699],
            [30.938785157541417, 2.447036233953831],
            [30.939296227072838, 2.447061455389715],
            [30.9395372818945, 2.446608054639192],
            [30.940694592254815, 2.446969497037827],
            [30.941173237096095, 2.444509420983475],
            [30.941603671152684, 2.444558335511036],
            [30.94171024907462, 2.444104577607802],
            [30.940738715704942, 2.442620500877136],
            [30.94143698785339, 2.442168276145471],
            [30.94205670143193, 2.442671700506078],
            [30.942755984185045, 2.442673509864152],
            [30.942914480238866, 2.441383527588119],
            [30.94381252872331, 2.440059606876904],
            [30.944995510239515, 2.439871490698502],
            [30.945478298110874, 2.439275337251707],
            [30.94560887991552, 2.43753124605428],
            [30.946953547403062, 2.437486921996305],
            [30.947328755730926, 2.436890480292057],
            [30.949478692802096, 2.43613134519802],
            [30.949963285388865, 2.436347658759657],
            [30.95015337069961, 2.437160632228627],
            [30.950985908643663, 2.436613157251641],
            [30.951822556380172, 2.437905719037489],
            [30.95281592869272, 2.437119699821317],
            [30.95251083117782, 2.432984837276701],
            [30.953128572954302, 2.432604083975451],
            [30.954205887440256, 2.433275957515605],
            [30.95501120912615, 2.432585035313115],
            [30.95659938203947, 2.433186525596005],
            [30.958194905866733, 2.432784359662336],
            [30.95929282950193, 2.433069820275199],
            [30.95957618060043, 2.432269562895516],
            [30.961380170167462, 2.432089874108787],
            [30.962439084461433, 2.431513771102972],
            [30.963224468039616, 2.431910241841001],
            [30.96356905190113, 2.430593175054318],
            [30.964345576294004, 2.430178804939984],
            [30.965371163989257, 2.428762777201178],
            [30.966074855673792, 2.428471381351176],
            [30.967216706028086, 2.429098843761616],
            [30.96849044613404, 2.427448020225669],
            [30.97137041349391, 2.427901271263202],
            [30.971425688629978, 2.427112384956651],
            [30.972230800110083, 2.426827939065105],
            [30.972655018723223, 2.426189480205094],
            [30.973449109671467, 2.427064394230277],
            [30.97280743408085, 2.428759422315086],
            [30.97342937997288, 2.430242606942417],
            [30.97523838213921, 2.432363510228206],
            [30.97615683855032, 2.432208361063842],
            [30.976788112548242, 2.431559683943838],
            [30.97748262973879, 2.432654587520969],
            [30.97754049381949, 2.433188807054656],
            [30.976995189492595, 2.433587153085949],
            [30.975334096734418, 2.434038642054987],
            [30.976152571552714, 2.435065156499414],
            [30.97703921053476, 2.435118680053972],
            [30.97577077767549, 2.436856038617713],
            [30.97590735842962, 2.437788365231347],
            [30.977187746966983, 2.439046219507283],
            [30.976168065694747, 2.440095062645087],
            [30.9759815188479, 2.440859280739147],
            [30.97911942576347, 2.443362977426804],
            [30.978733370278558, 2.444618122324501],
            [30.97722815588342, 2.445044406759685],
            [30.97993764905351, 2.44790701761876],
            [30.98040380461735, 2.451875080061053],
            [30.980849294438123, 2.452628972972521],
            [30.979881929251377, 2.453032732294574],
            [30.979078795861483, 2.454703452295604],
            [30.97929890825891, 2.456902519692973],
            [30.980552193725888, 2.458064733994148],
            [30.979726872846815, 2.461838307060606],
            [30.980446242828023, 2.46479141118198],
            [30.981094278490826, 2.465916222265043],
            [30.980693346904808, 2.467038348026418],
            [30.982231967848705, 2.469503677712677],
            [30.982842091911564, 2.471715705408018],
            [30.982922773200503, 2.477725962262412],
            [30.983409699610366, 2.478969854577489],
            [30.983334130633736, 2.481263757302741],
            [30.98387515987822, 2.482651172731254],
            [30.98365573379364, 2.486772810557634],
            [30.984277456005156, 2.488160426615095],
            [30.98433407591921, 2.489427110164246],
            [30.98542886353574, 2.491879364240015],
            [30.986962912953175, 2.492289585038139],
            [30.987988583293433, 2.493893327180907],
            [30.98909265679506, 2.494469701166306],
            [30.98936338117392, 2.495258999932901],
            [30.989792154245546, 2.498708142487673],
            [30.989340356454882, 2.501921975722156],
            [30.989555461642922, 2.503563616518104],
            [30.990068970100356, 2.504354314337007],
            [30.98944802672819, 2.506004017524042],
            [30.989582972548497, 2.510271560966687],
            [30.988505864675076, 2.509814113709415],
            [30.988796264853598, 2.51213041686392],
            [30.989261228353087, 2.512426777907439],
            [30.99009826416177, 2.512155805779933],
            [30.99028865220478, 2.512733156238011],
            [30.989870939190915, 2.514176932426474],
            [30.989086435961728, 2.51459454033827],
            [30.9909906146324, 2.518579935924595],
            [30.991089061902702, 2.520100331416363],
            [30.991645421795813, 2.521583900253298],
            [30.99190198423424, 2.524216770136491],
            [30.992904099849437, 2.525227657444881],
            [30.99311975121318, 2.52711414397068],
            [30.994070650280758, 2.528089238180966],
            [30.993493469235993, 2.528796423266906],
            [30.994000389449113, 2.533001396253995],
            [30.993444712275625, 2.534352691527159],
            [30.994511467065404, 2.534931012127941],
            [30.994133453298907, 2.536461548330563],
            [30.995021654451236, 2.537437286145541],
            [30.99506036734842, 2.537974235449835],
            [30.99451232226157, 2.539991612827752],
            [30.99539092222013, 2.54157389163827],
            [30.995112495686023, 2.542627347596107],
            [30.994202276826098, 2.54310315728738],
            [30.994172039533627, 2.543691956853186],
            [30.994672972475396, 2.545569601913367],
            [30.995704640866805, 2.547432602707721],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 619,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "NYAPEA",
        Population: 21189,
        Key: "ZOMBONYAPEA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.007371132428563, 2.39828984590297],
            [31.00545854193357, 2.405394387855785],
            [31.006923532465233, 2.412049331703496],
            [31.0068811427636, 2.414585922837045],
            [31.009493139080945, 2.417856415969781],
            [31.010233853033295, 2.419389104189737],
            [31.012415239224243, 2.421510274902259],
            [31.012283983683147, 2.427133811198572],
            [31.01271340354178, 2.428128078919208],
            [31.012006737535323, 2.431346434598888],
            [31.008350073306072, 2.435477952685599],
            [31.00596132899808, 2.436550717960385],
            [31.00378519615492, 2.440074371662305],
            [31.001863393436686, 2.44099520983831],
            [30.997987184545277, 2.441599441815284],
            [30.996687940370066, 2.440063748843037],
            [30.99205461518754, 2.439552953226337],
            [30.990427304473943, 2.438962695325878],
            [30.98533227038818, 2.440130644959943],
            [30.979776630530377, 2.442221568760114],
            [30.97911942576347, 2.443362977426804],
            [30.9759815188479, 2.440859280739147],
            [30.976168065694747, 2.440095062645087],
            [30.977187746966983, 2.439046219507283],
            [30.97590735842962, 2.437788365231347],
            [30.97577077767549, 2.436856038617713],
            [30.97703921053476, 2.435118680053972],
            [30.976152571552714, 2.435065156499414],
            [30.975334096734418, 2.434038642054987],
            [30.976995189492595, 2.433587153085949],
            [30.97754049381949, 2.433188807054656],
            [30.97748262973879, 2.432654587520969],
            [30.976788112548242, 2.431559683943838],
            [30.97615683855032, 2.432208361063842],
            [30.97523838213921, 2.432363510228206],
            [30.97342937997288, 2.430242606942417],
            [30.97280743408085, 2.428759422315086],
            [30.973449109671467, 2.427064394230277],
            [30.972655018723223, 2.426189480205094],
            [30.9723067841084, 2.42579606381043],
            [30.97364876922651, 2.424556864514409],
            [30.973270392540623, 2.423743414953697],
            [30.97181564370153, 2.42268824600407],
            [30.971704448439045, 2.421086881995395],
            [30.97025289490743, 2.421441623224232],
            [30.969875809998925, 2.421201698187717],
            [30.96921166574644, 2.418893976747418],
            [30.96735478966366, 2.418411298557434],
            [30.965953046816235, 2.416997820020374],
            [30.962616714630794, 2.416415776210933],
            [30.9642631693414, 2.409228394858258],
            [30.96245660340613, 2.409037176149945],
            [30.96073181200947, 2.408213290779118],
            [30.95906781769294, 2.403955023749619],
            [30.956854331103603, 2.401615800400848],
            [30.957997044738878, 2.401337234253379],
            [30.95851862096588, 2.400386931142978],
            [30.958354477203912, 2.398840963252444],
            [30.95721984840621, 2.396615696763625],
            [30.95850674523782, 2.394826738839493],
            [30.960253557935353, 2.394233768897472],
            [30.96127680911256, 2.394785991842578],
            [30.96219411208683, 2.396054843011238],
            [30.963244054007763, 2.396511547433054],
            [30.964864959733383, 2.399693913529587],
            [30.96572701901262, 2.400317419465848],
            [30.967892804162048, 2.400645531998724],
            [30.968590345980157, 2.399882615982955],
            [30.969289343967354, 2.399764913338938],
            [30.970555754718923, 2.400795683750748],
            [30.971981038816722, 2.400727612624983],
            [30.973462287058357, 2.40161555268359],
            [30.975667749895553, 2.401645052575996],
            [30.976154156180893, 2.402649941419892],
            [30.979073470648487, 2.403171132622837],
            [30.979478365601565, 2.40381736858282],
            [30.98117397612451, 2.404347399058363],
            [30.983673513249755, 2.403589040049456],
            [30.984505311880334, 2.402730852449934],
            [30.987651375498714, 2.402428155653776],
            [30.989199100868028, 2.402969752180536],
            [30.989817312463387, 2.402804038473542],
            [30.99046389734704, 2.403283614069584],
            [30.991512279792612, 2.40304728759895],
            [30.992075393220034, 2.402307906050847],
            [30.992560825731587, 2.402882662599703],
            [30.99417357924602, 2.402456588370571],
            [30.995005261095603, 2.401550599605026],
            [30.996564831650275, 2.401387251605391],
            [30.998227377882586, 2.399216812055315],
            [31.001064031174373, 2.397251343184292],
            [31.001894600011322, 2.39619964598951],
            [31.00339248505207, 2.395699353811102],
            [31.007371132428563, 2.39828984590297],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 620,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "PAIDHA TOWN COUNCIL",
        Population: 31632,
        Key: "ZOMBOPAIDHA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.914619796373934, 2.63812082232942],
            [30.912375120277943, 2.636262265952193],
            [30.911522411562498, 2.636086942441411],
            [30.9108072151541, 2.636398725481389],
            [30.910344837005994, 2.63717462693505],
            [30.90975699834869, 2.637150449259186],
            [30.90897112698532, 2.638366307679762],
            [30.90761119262951, 2.638213306374147],
            [30.90707912048672, 2.639254275911865],
            [30.90583561228332, 2.638749157692075],
            [30.90318654968074, 2.639799759962258],
            [30.901820472645007, 2.639637948531755],
            [30.900941573547453, 2.639955437005745],
            [30.89884459755216, 2.638638976794636],
            [30.89827182903207, 2.638797656559229],
            [30.897235638521497, 2.638341959528073],
            [30.89495442794292, 2.638289001645917],
            [30.892294066330685, 2.638812010773386],
            [30.891611396122094, 2.638516403305359],
            [30.890759984573926, 2.637005930586161],
            [30.889418260865565, 2.636880956486912],
            [30.889615168880905, 2.635863012242482],
            [30.8893348325285, 2.63571531226117],
            [30.888357910165432, 2.636290261034079],
            [30.886625810973953, 2.636164617428931],
            [30.885124567132358, 2.636591445253137],
            [30.882266226712975, 2.638770326479568],
            [30.87956841433655, 2.639226727783195],
            [30.878725905092846, 2.640248725348921],
            [30.87712621038769, 2.641178369271536],
            [30.875039043097, 2.641812731556377],
            [30.874270613423178, 2.641737798358411],
            [30.872663630686166, 2.639784368408971],
            [30.870908275908594, 2.638996172921559],
            [30.87053070590983, 2.63863974224513],
            [30.870078865000036, 2.636086888599521],
            [30.872714172598997, 2.63565768527712],
            [30.874010448740496, 2.635008662284564],
            [30.875214938619536, 2.633931511875285],
            [30.87556815798588, 2.632945935040383],
            [30.874232288598243, 2.626047042294156],
            [30.874399808229036, 2.622111276852394],
            [30.873601514063605, 2.618555008017981],
            [30.8725157751769, 2.619419289732817],
            [30.87141284253569, 2.621241732094734],
            [30.869870955317417, 2.620793783770946],
            [30.86870110267909, 2.619958624660158],
            [30.86627087956119, 2.621132368954613],
            [30.8623341996781, 2.617821726721577],
            [30.85766657052981, 2.615989393856069],
            [30.85522449144678, 2.612397853115467],
            [30.85579422276292, 2.608668712448811],
            [30.85235099105865, 2.60420082972175],
            [30.849377632146943, 2.599521288707987],
            [30.851047450241452, 2.597682704874601],
            [30.847697302865253, 2.593710779826438],
            [30.845496419639392, 2.590331035882095],
            [30.845133019665944, 2.588503012736631],
            [30.84570982701155, 2.587847812809638],
            [30.851091824321546, 2.586119089720291],
            [30.852543693161845, 2.584246444382742],
            [30.85132431191032, 2.583612175957398],
            [30.851184165742847, 2.583169139207502],
            [30.85161080262074, 2.580814182455207],
            [30.851353329290628, 2.576828567570142],
            [30.845650251640215, 2.575047685589015],
            [30.84272353595299, 2.576973287891763],
            [30.840433838989902, 2.577111074832497],
            [30.83862323602574, 2.575124266812283],
            [30.837268194793282, 2.574519753700904],
            [30.83588127863962, 2.574309948535283],
            [30.834310860927925, 2.57468998850462],
            [30.834363133894296, 2.574021431601581],
            [30.832943099551038, 2.570658071366392],
            [30.83251832128747, 2.570618727957747],
            [30.829687415416878, 2.56751923155185],
            [30.82973654068648, 2.565261803876973],
            [30.828523333555943, 2.563731302835396],
            [30.82830392274275, 2.562758293367127],
            [30.828222623412906, 2.561813307713002],
            [30.828859600814567, 2.560952916480977],
            [30.829937742648877, 2.560649069524035],
            [30.833971615754134, 2.560850467227242],
            [30.83559143002668, 2.558970263510349],
            [30.838415720703548, 2.559835112655896],
            [30.841898073140083, 2.559990593159176],
            [30.84076074221001, 2.558268556666213],
            [30.84011145339736, 2.555991129798508],
            [30.838308665776186, 2.553786110167562],
            [30.8362311625613, 2.552186167101131],
            [30.834211357238832, 2.548824754376409],
            [30.83357435468435, 2.547614036518317],
            [30.834435347663362, 2.547604024818034],
            [30.83463076806857, 2.546956921151859],
            [30.835103322332206, 2.547641801127372],
            [30.83616091161116, 2.547118313672869],
            [30.838504703324, 2.547366589730988],
            [30.839620557332264, 2.548321304253909],
            [30.840204121805442, 2.547992463654797],
            [30.840359941778, 2.54923873808421],
            [30.842793709648024, 2.54899176096322],
            [30.843535005708688, 2.549452283342516],
            [30.844544216217994, 2.548994712598808],
            [30.845057091363174, 2.549512258329597],
            [30.848183961577174, 2.545671110982755],
            [30.84997157126333, 2.546248205115011],
            [30.854369384229518, 2.544743802887814],
            [30.85682356092449, 2.544958413242507],
            [30.862476335613945, 2.543972757330603],
            [30.863217678386988, 2.54441413574031],
            [30.863770546528613, 2.543764414463672],
            [30.865769749888354, 2.542964007979985],
            [30.86713796221952, 2.544037935871386],
            [30.8679148764812, 2.545991164554215],
            [30.869376877419565, 2.547888126077755],
            [30.871162759645433, 2.549536853188788],
            [30.87217056698627, 2.549882990378929],
            [30.87186578837331, 2.548906813264555],
            [30.87249099694643, 2.547761800625881],
            [30.87027270796361, 2.54559599888498],
            [30.87010943556746, 2.545181879391911],
            [30.871018694128388, 2.544763799409851],
            [30.86997434511842, 2.544448014606321],
            [30.86941101070541, 2.543758584757768],
            [30.87064906523673, 2.543132541855731],
            [30.871410109860587, 2.540440225006908],
            [30.871499202075515, 2.539601168510704],
            [30.87038080493671, 2.538276405969794],
            [30.87026896468384, 2.537472264551837],
            [30.870650977749982, 2.534641124038903],
            [30.87028230376747, 2.53269733360072],
            [30.87108612436855, 2.531192785469232],
            [30.870251885913653, 2.530661142602294],
            [30.87041368776766, 2.529728214741608],
            [30.871226628065504, 2.529093271415456],
            [30.87187309706646, 2.529157685189562],
            [30.872401102535953, 2.53014181238798],
            [30.875007952405028, 2.530432896873068],
            [30.877086061982713, 2.530190507456995],
            [30.8803233513148, 2.531117643811944],
            [30.8837458094781, 2.530918425828269],
            [30.885129959719038, 2.531535239103911],
            [30.887329505353446, 2.531784665083158],
            [30.889181072392883, 2.533078238446095],
            [30.891177592484894, 2.532917633018364],
            [30.89207466539896, 2.532427468647684],
            [30.896433112392778, 2.53288526334017],
            [30.898672624972484, 2.533626375215891],
            [30.899732265105214, 2.533382287548392],
            [30.900647563039797, 2.534223659876623],
            [30.90256215408293, 2.534349692293944],
            [30.907777440245876, 2.534030425582168],
            [30.912404927277404, 2.531887016135077],
            [30.91578574852726, 2.531810590283726],
            [30.914978717347392, 2.534037809692589],
            [30.916134732337056, 2.535582507590911],
            [30.91624216006525, 2.536513726107718],
            [30.91549395596004, 2.537998857452107],
            [30.915742796480277, 2.539169273427557],
            [30.915441367684988, 2.539521804919262],
            [30.917225837759254, 2.545909251761151],
            [30.91704606690458, 2.548094967779884],
            [30.9176852856029, 2.552468027378627],
            [30.918533701269617, 2.554625879848177],
            [30.918119868977783, 2.556220402142509],
            [30.91882202454318, 2.557993988303606],
            [30.919289999195506, 2.562803518687406],
            [30.91868893554057, 2.56313648989064],
            [30.91870902636192, 2.563818642064045],
            [30.917509668558104, 2.565316808240448],
            [30.91746724112722, 2.566430068156881],
            [30.916846420824253, 2.567235957568414],
            [30.916896805531923, 2.569712133115865],
            [30.915182653781486, 2.572370874774584],
            [30.91572845847004, 2.573392160237916],
            [30.915517907740483, 2.573982019196203],
            [30.914678838145967, 2.57441626543843],
            [30.912041231758206, 2.574164251530253],
            [30.91095993054903, 2.575745120533724],
            [30.90861857955881, 2.576873909054894],
            [30.90765870811815, 2.577988058984052],
            [30.9068199583239, 2.57822556197871],
            [30.90632958058669, 2.579039790702971],
            [30.905323526757286, 2.579052176691967],
            [30.90391056125702, 2.580103764843705],
            [30.901995696227708, 2.579724707354257],
            [30.900730160435216, 2.581557721042221],
            [30.900475977634006, 2.585588589581477],
            [30.89997569686913, 2.586148358433269],
            [30.900286514855747, 2.587807323953941],
            [30.90022669873592, 2.588870032594549],
            [30.89963310636921, 2.589674907196192],
            [30.899818066791283, 2.590189101707317],
            [30.89878366033489, 2.590701259815594],
            [30.898210251315962, 2.591633846238845],
            [30.8993543905776, 2.594089755959462],
            [30.90022673107528, 2.594119238068162],
            [30.900060847276603, 2.594870044025995],
            [30.900901744044376, 2.595323523246337],
            [30.901457177774446, 2.594891613792228],
            [30.9028034325851, 2.595571212899785],
            [30.903662873275294, 2.597088342152216],
            [30.904410312914205, 2.597379869976295],
            [30.904607503000534, 2.598436526643104],
            [30.905659479605557, 2.598882890064753],
            [30.905524123255173, 2.599371064569737],
            [30.906706192981353, 2.601729605077512],
            [30.905548939214924, 2.601718052087604],
            [30.90523612068014, 2.602577771392354],
            [30.904734137607797, 2.60283245117621],
            [30.90514383854764, 2.603775761401293],
            [30.904519538171257, 2.605361790217227],
            [30.905166895606044, 2.60663862728169],
            [30.904698247217258, 2.607180010149314],
            [30.905489320724456, 2.607531516865659],
            [30.906051386716264, 2.608557729331111],
            [30.905617758250497, 2.609407457878344],
            [30.905847187075757, 2.609875592423356],
            [30.906758754306953, 2.60998355752429],
            [30.90671947277621, 2.610812555564602],
            [30.907136574037345, 2.611432197355128],
            [30.906862653452716, 2.61229636731839],
            [30.907345088286153, 2.613180706225459],
            [30.90809172033961, 2.61339929748187],
            [30.910534075205447, 2.616625679465268],
            [30.911046260444458, 2.616569840973716],
            [30.91031615469727, 2.617997967224674],
            [30.910622879061144, 2.619173669638283],
            [30.911824228429968, 2.620293328918359],
            [30.912080427948993, 2.621071939690995],
            [30.91253797495748, 2.621044991504944],
            [30.912798007587856, 2.620463375385086],
            [30.913221057492798, 2.621295587178555],
            [30.913717309313633, 2.621196639879358],
            [30.913754827451474, 2.62183973122714],
            [30.914769894976416, 2.621331446295954],
            [30.915617732128105, 2.622793923987557],
            [30.915778280832324, 2.62393762604703],
            [30.917077020154334, 2.62442984694113],
            [30.917346225482035, 2.625355933816173],
            [30.916965833874983, 2.626172034529572],
            [30.915394454067606, 2.626822787766786],
            [30.915527517917397, 2.628211464680836],
            [30.91471212701544, 2.63011581324555],
            [30.916171865995942, 2.631479497487988],
            [30.915466669633304, 2.632240599930523],
            [30.915300870276248, 2.634254938779092],
            [30.914541612401486, 2.634961498549568],
            [30.914619796373934, 2.63812082232942],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 621,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "WARR",
        Population: 18827,
        Key: "ZOMBOWARR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.829687415416878, 2.56751923155185],
            [30.828104512021028, 2.568103403625832],
            [30.827703242668438, 2.567883918803462],
            [30.826931951860455, 2.568757793484959],
            [30.826964338821384, 2.569397414296771],
            [30.82544139707246, 2.569428465654828],
            [30.825265949809243, 2.568838588437826],
            [30.824677912624256, 2.56877318770091],
            [30.824320477464294, 2.568212955322645],
            [30.823801234162087, 2.568525072833986],
            [30.823226835199726, 2.567992923994461],
            [30.823018400901002, 2.568552185468635],
            [30.82260333342566, 2.56860838324943],
            [30.821482267392106, 2.567876110410915],
            [30.820579663550806, 2.566233647494564],
            [30.820258667652013, 2.566432282077841],
            [30.81991995248427, 2.565957448442823],
            [30.81909003133263, 2.565946538573665],
            [30.818390757562618, 2.565245282465355],
            [30.81805336830822, 2.565498962838906],
            [30.81751655216243, 2.565052243979023],
            [30.817129652261105, 2.565184369517628],
            [30.81680994993633, 2.564593946507856],
            [30.81528191923132, 2.564735398932514],
            [30.814275261734036, 2.563282461865742],
            [30.8126345822924, 2.563089940892639],
            [30.811325427004647, 2.562053824552248],
            [30.81148771035566, 2.561031599404782],
            [30.81048151189752, 2.560953690055363],
            [30.809401307531303, 2.559852683219959],
            [30.80806005903171, 2.559545660933433],
            [30.807999097559883, 2.558257473529495],
            [30.805501811612768, 2.557887241067844],
            [30.805403767686027, 2.556439217693127],
            [30.804823135313935, 2.556425094974788],
            [30.805019531289563, 2.556031739021185],
            [30.80400954104258, 2.555288541851291],
            [30.80436409081386, 2.553970273940022],
            [30.80352174147024, 2.553336656366113],
            [30.803651674691245, 2.551862729985148],
            [30.804684998677736, 2.549985593070282],
            [30.80405721822796, 2.549527956106664],
            [30.804430220293483, 2.545788331328227],
            [30.804205981933954, 2.544172432786767],
            [30.801730566370736, 2.541885400884746],
            [30.800490778989253, 2.541971074170727],
            [30.80057936275773, 2.537899179442475],
            [30.80019866662176, 2.537983978892017],
            [30.799491328675476, 2.536687707358135],
            [30.799001028193423, 2.536545909028612],
            [30.798216122518962, 2.534500661768099],
            [30.797130349496307, 2.534252124774271],
            [30.795866129735725, 2.530752423831361],
            [30.795192522630018, 2.530231487236951],
            [30.794710135407293, 2.530591867474511],
            [30.793616264970666, 2.529955681617228],
            [30.792882103329983, 2.528985335371676],
            [30.793617056386406, 2.527858513266803],
            [30.794417297201083, 2.525084447978708],
            [30.79225636475084, 2.523918073933714],
            [30.79082974036664, 2.522215371445581],
            [30.78773166295414, 2.52356595371389],
            [30.7864004782807, 2.524595653736867],
            [30.785591146515365, 2.525394387077217],
            [30.785003800134806, 2.527231155099207],
            [30.783323147459665, 2.528728490610569],
            [30.780478579111886, 2.529898641247472],
            [30.778590173060948, 2.530037812601649],
            [30.774822591148652, 2.531823502627269],
            [30.77329054587261, 2.534052189323161],
            [30.771164901043385, 2.534903060578788],
            [30.769959673647495, 2.535791129982568],
            [30.769060515743632, 2.537118871861213],
            [30.764515768041367, 2.537906177634143],
            [30.763041709016935, 2.537286438167762],
            [30.762064416547968, 2.536014782590091],
            [30.761991514669386, 2.535034840111098],
            [30.760496627306782, 2.533288068294631],
            [30.758488976190108, 2.532958918738267],
            [30.75870883616095, 2.530311389861787],
            [30.75810055184778, 2.528713407327539],
            [30.76017773526239, 2.514877016372139],
            [30.76235204632217, 2.508973217400374],
            [30.762509721315777, 2.507159765564531],
            [30.761439236720918, 2.500317599003425],
            [30.759236872173144, 2.494860058488208],
            [30.757541417957064, 2.49428194090095],
            [30.754261462242194, 2.494774633393766],
            [30.751866452185116, 2.49402731502784],
            [30.748862893710147, 2.491593855198965],
            [30.747054545517372, 2.488411056299241],
            [30.746756275198614, 2.487215574274532],
            [30.746791714634906, 2.478279633600073],
            [30.744097236804794, 2.469204759061927],
            [30.74528505754543, 2.464895329078051],
            [30.74493268079883, 2.457045461941644],
            [30.741496866483857, 2.453631266056103],
            [30.74076593159171, 2.451287736357522],
            [30.742045269998513, 2.445748049967026],
            [30.746595006045553, 2.441686728151661],
            [30.749196167782273, 2.438157646991112],
            [30.749843920475755, 2.432843175000515],
            [30.749718285693387, 2.4306327120363],
            [30.750730529813396, 2.426024074483249],
            [30.750869996854526, 2.421998443869674],
            [30.752338096455382, 2.416793697018688],
            [30.7545336688413, 2.418651383845425],
            [30.75537022674627, 2.420039462805824],
            [30.755911678198913, 2.421761251858744],
            [30.755888750497935, 2.423648760679949],
            [30.757905896807163, 2.423773708663829],
            [30.760113794977087, 2.42509383183859],
            [30.763301527848235, 2.425592284085652],
            [30.765078611974193, 2.42664841738863],
            [30.76556629656217, 2.4283700714848],
            [30.769867382531828, 2.427593231818953],
            [30.771051539942732, 2.428026520417191],
            [30.771549983652843, 2.428469899564625],
            [30.771876263442135, 2.43016722529985],
            [30.772442416768467, 2.430837777128315],
            [30.777234947673886, 2.433550728738372],
            [30.778624625248728, 2.435788553600054],
            [30.77972736924375, 2.435863214233035],
            [30.780878853131128, 2.433548633961384],
            [30.7827604274943, 2.433123635598273],
            [30.782812189319323, 2.432168021757613],
            [30.78415514461793, 2.431383158773214],
            [30.787113330086203, 2.431391137606583],
            [30.78958937177516, 2.432305780851345],
            [30.79342766727001, 2.428851501279931],
            [30.79522384149409, 2.426204100643222],
            [30.796727083188866, 2.424917870357522],
            [30.79821781584329, 2.424073627397175],
            [30.801605481357306, 2.423700416067705],
            [30.80638866169893, 2.421968952496295],
            [30.809224847866762, 2.421510607879647],
            [30.810705283133093, 2.422135807299215],
            [30.812991073323005, 2.422094129500919],
            [30.81579019140898, 2.423152952685001],
            [30.82047821770409, 2.420931342913639],
            [30.82206582557707, 2.421365666682644],
            [30.823571121718906, 2.421035152911884],
            [30.825347191646912, 2.421565559017002],
            [30.827579529382472, 2.421667081205964],
            [30.830731070029127, 2.424017121871744],
            [30.834628896877856, 2.424008055210916],
            [30.836219472784514, 2.425004423609971],
            [30.836399727831125, 2.425990254506072],
            [30.83728288494312, 2.426438726792413],
            [30.837216013455055, 2.42720063615636],
            [30.837683511101954, 2.427361263395055],
            [30.837694510074314, 2.42802946514356],
            [30.84140042803225, 2.428560431244631],
            [30.84245108321552, 2.42939953586302],
            [30.844683045455287, 2.429309879309506],
            [30.845016190169964, 2.430497160639368],
            [30.846108087007934, 2.430305159611742],
            [30.847399823962306, 2.430630159526184],
            [30.8482314824557, 2.432577122902222],
            [30.848931249400778, 2.432668018694063],
            [30.848148617362313, 2.433823234602626],
            [30.84815099430456, 2.434922397691702],
            [30.846620521080276, 2.436065286253017],
            [30.84615347169269, 2.437724735009021],
            [30.844785333023417, 2.43932204232165],
            [30.845434444867944, 2.441020298557667],
            [30.84481619644163, 2.441162023695915],
            [30.84362782683037, 2.445065648729371],
            [30.843193762681707, 2.449568641629773],
            [30.846259490862536, 2.455753609673764],
            [30.85112100519523, 2.459076004162366],
            [30.85271392211155, 2.461947640618308],
            [30.852558556686514, 2.46474292549489],
            [30.853488021951453, 2.471770496531648],
            [30.85280399708341, 2.475702428199455],
            [30.856014684604986, 2.481085066816018],
            [30.857839759428387, 2.48331021505677],
            [30.858826947738514, 2.485380745178098],
            [30.860272541846555, 2.486685759621664],
            [30.862393122872543, 2.494658410024249],
            [30.865109871735154, 2.496733513730302],
            [30.865462439822938, 2.497736080395269],
            [30.866203096283105, 2.498286787990466],
            [30.867297768915307, 2.501348580982388],
            [30.866885360453203, 2.503166687005992],
            [30.867561534045652, 2.505499702698256],
            [30.86762809022504, 2.510064045528021],
            [30.868173095412974, 2.510928435552298],
            [30.868093379812972, 2.511948798598447],
            [30.867545824307946, 2.512654394092106],
            [30.868411761614286, 2.516363170425859],
            [30.867639470981402, 2.517256445144039],
            [30.86618075608032, 2.517289824841066],
            [30.864969271918483, 2.518432845163054],
            [30.864741557078784, 2.519899524159989],
            [30.864040085131307, 2.5209956730818],
            [30.865442015726632, 2.524079485482494],
            [30.86690051593034, 2.52586849347461],
            [30.867306063958637, 2.525791236236898],
            [30.867492001747724, 2.526262269647204],
            [30.868235891244606, 2.525908712359818],
            [30.86897516250261, 2.526269776751457],
            [30.869329606272704, 2.527494242758962],
            [30.870584940796824, 2.528169596837775],
            [30.871226628065504, 2.529093271415456],
            [30.87041368776766, 2.529728214741608],
            [30.870251885913653, 2.530661142602294],
            [30.87108612436855, 2.531192785469232],
            [30.87028230376747, 2.53269733360072],
            [30.870650977749982, 2.534641124038903],
            [30.87026896468384, 2.537472264551837],
            [30.87038080493671, 2.538276405969794],
            [30.871499202075515, 2.539601168510704],
            [30.871410109860587, 2.540440225006908],
            [30.87064906523673, 2.543132541855731],
            [30.86941101070541, 2.543758584757768],
            [30.86997434511842, 2.544448014606321],
            [30.871018694128388, 2.544763799409851],
            [30.87010943556746, 2.545181879391911],
            [30.87027270796361, 2.54559599888498],
            [30.87249099694643, 2.547761800625881],
            [30.87186578837331, 2.548906813264555],
            [30.87217056698627, 2.549882990378929],
            [30.871162759645433, 2.549536853188788],
            [30.869376877419565, 2.547888126077755],
            [30.8679148764812, 2.545991164554215],
            [30.86713796221952, 2.544037935871386],
            [30.865769749888354, 2.542964007979985],
            [30.863770546528613, 2.543764414463672],
            [30.863217678386988, 2.54441413574031],
            [30.862476335613945, 2.543972757330603],
            [30.85682356092449, 2.544958413242507],
            [30.854369384229518, 2.544743802887814],
            [30.84997157126333, 2.546248205115011],
            [30.848183961577174, 2.545671110982755],
            [30.845057091363174, 2.549512258329597],
            [30.844544216217994, 2.548994712598808],
            [30.843535005708688, 2.549452283342516],
            [30.842793709648024, 2.54899176096322],
            [30.840359941778, 2.54923873808421],
            [30.840204121805442, 2.547992463654797],
            [30.839620557332264, 2.548321304253909],
            [30.838504703324, 2.547366589730988],
            [30.83616091161116, 2.547118313672869],
            [30.835103322332206, 2.547641801127372],
            [30.83463076806857, 2.546956921151859],
            [30.834435347663362, 2.547604024818034],
            [30.83357435468435, 2.547614036518317],
            [30.834211357238832, 2.548824754376409],
            [30.8362311625613, 2.552186167101131],
            [30.838308665776186, 2.553786110167562],
            [30.84011145339736, 2.555991129798508],
            [30.84076074221001, 2.558268556666213],
            [30.841898073140083, 2.559990593159176],
            [30.838415720703548, 2.559835112655896],
            [30.83559143002668, 2.558970263510349],
            [30.833971615754134, 2.560850467227242],
            [30.829937742648877, 2.560649069524035],
            [30.828859600814567, 2.560952916480977],
            [30.828222623412906, 2.561813307713002],
            [30.82830392274275, 2.562758293367127],
            [30.828523333555943, 2.563731302835396],
            [30.82973654068648, 2.565261803876973],
            [30.829687415416878, 2.56751923155185],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 622,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "ZEU",
        Population: 35354,
        Key: "ZOMBOZEU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.950931578535275, 2.538347542861572],
            [30.94950964874678, 2.539181168905762],
            [30.94883391263388, 2.540651891602171],
            [30.947609590648323, 2.541961003196151],
            [30.946791513783676, 2.544008239018045],
            [30.942836295368085, 2.546890462129075],
            [30.938934437778684, 2.547652575640616],
            [30.937055181068953, 2.546904007905998],
            [30.936742617655707, 2.54782285709157],
            [30.9360555780416, 2.548294157986705],
            [30.935415571520796, 2.547577957243462],
            [30.9347163444632, 2.547447863462965],
            [30.93215138393414, 2.547678202576835],
            [30.93159247552053, 2.547278682208726],
            [30.930792082890616, 2.544803618351722],
            [30.929824988096765, 2.544520679480586],
            [30.929140605699242, 2.542397527192273],
            [30.927648418672344, 2.542442011951035],
            [30.92646138036435, 2.54119734991699],
            [30.925482014583714, 2.541301282396348],
            [30.92416600155712, 2.54052537069857],
            [30.922748939739122, 2.537334157456712],
            [30.92188919002846, 2.53338554614324],
            [30.92110321176557, 2.532392867028991],
            [30.91944598715303, 2.532219838280539],
            [30.91770506650545, 2.531426101593072],
            [30.91578574852726, 2.531810590283726],
            [30.912404927277404, 2.531887016135077],
            [30.907777440245876, 2.534030425582168],
            [30.90256215408293, 2.534349692293944],
            [30.900647563039797, 2.534223659876623],
            [30.899732265105214, 2.533382287548392],
            [30.898672624972484, 2.533626375215891],
            [30.896433112392778, 2.53288526334017],
            [30.89207466539896, 2.532427468647684],
            [30.891177592484894, 2.532917633018364],
            [30.889181072392883, 2.533078238446095],
            [30.887329505353446, 2.531784665083158],
            [30.885129959719038, 2.531535239103911],
            [30.8837458094781, 2.530918425828269],
            [30.8803233513148, 2.531117643811944],
            [30.877086061982713, 2.530190507456995],
            [30.875007952405028, 2.530432896873068],
            [30.872401102535953, 2.53014181238798],
            [30.87187309706646, 2.529157685189562],
            [30.871226628065504, 2.529093271415456],
            [30.870584940796824, 2.528169596837775],
            [30.869329606272704, 2.527494242758962],
            [30.86897516250261, 2.526269776751457],
            [30.868235891244606, 2.525908712359818],
            [30.867492001747724, 2.526262269647204],
            [30.867306063958637, 2.525791236236898],
            [30.86690051593034, 2.52586849347461],
            [30.865442015726632, 2.524079485482494],
            [30.864040085131307, 2.5209956730818],
            [30.864741557078784, 2.519899524159989],
            [30.864969271918483, 2.518432845163054],
            [30.86618075608032, 2.517289824841066],
            [30.867639470981402, 2.517256445144039],
            [30.868411761614286, 2.516363170425859],
            [30.867545824307946, 2.512654394092106],
            [30.868093379812972, 2.511948798598447],
            [30.868173095412974, 2.510928435552298],
            [30.86762809022504, 2.510064045528021],
            [30.867561534045652, 2.505499702698256],
            [30.866885360453203, 2.503166687005992],
            [30.867297768915307, 2.501348580982388],
            [30.866203096283105, 2.498286787990466],
            [30.865462439822938, 2.497736080395269],
            [30.865109871735154, 2.496733513730302],
            [30.86545375850402, 2.495793061522169],
            [30.864750442315273, 2.493385570411331],
            [30.86555927461729, 2.492492328772978],
            [30.867061034990147, 2.491876158492057],
            [30.870332975936012, 2.492017586535349],
            [30.87254851517575, 2.491216983134113],
            [30.873989744369826, 2.489994450406052],
            [30.87969690037163, 2.490436744563253],
            [30.886062804446055, 2.494356771463235],
            [30.888695073942692, 2.494521870751376],
            [30.890133504884677, 2.495056216238556],
            [30.890858072518093, 2.495824486194393],
            [30.891077782470287, 2.496901257541628],
            [30.89178211465365, 2.496447291362566],
            [30.898112766141345, 2.496199868048449],
            [30.90132592043672, 2.495240179225149],
            [30.90353811614696, 2.494236924096266],
            [30.903957804556104, 2.492601535052378],
            [30.904490317771703, 2.492051636384983],
            [30.909277285410564, 2.489362281597627],
            [30.9126585989372, 2.489750089831972],
            [30.919254338773666, 2.489423755430733],
            [30.920368392558107, 2.489953208201574],
            [30.920365957225375, 2.491503272154873],
            [30.921158284780685, 2.492166074925619],
            [30.921578664892632, 2.493849277829637],
            [30.924651693681767, 2.496097545608699],
            [30.92489765240655, 2.498650753434422],
            [30.92683526727045, 2.501496747027805],
            [30.92887410789379, 2.501113198011537],
            [30.93000716913132, 2.502023958468476],
            [30.93102747113945, 2.501271334857689],
            [30.93168349013019, 2.499841245958573],
            [30.932548233575517, 2.50019073045199],
            [30.934394639793663, 2.499903562017112],
            [30.936434845856216, 2.498649714174334],
            [30.93814607808198, 2.498729778481377],
            [30.938800428002914, 2.498363357604913],
            [30.93970372444531, 2.498654879961068],
            [30.941083875386564, 2.501422640224532],
            [30.942332931585174, 2.501946785975201],
            [30.94373443098915, 2.503360800003307],
            [30.946328907463506, 2.504273864466652],
            [30.949357052827796, 2.503881326429895],
            [30.949917830635467, 2.504630823596347],
            [30.95078738905074, 2.504853047421559],
            [30.952591401973958, 2.507013456097559],
            [30.952657502707513, 2.508052605927854],
            [30.95368968852855, 2.508506734117349],
            [30.954934219913042, 2.510956034020406],
            [30.957098529130437, 2.512801323066659],
            [30.95833385547824, 2.513026332987312],
            [30.959396969396185, 2.513971254689972],
            [30.960918286092788, 2.513212174508369],
            [30.96122858395485, 2.513795682806829],
            [30.962304884242847, 2.514096292003541],
            [30.96308810916937, 2.515226709544823],
            [30.96305622077344, 2.517379662117334],
            [30.963733013305117, 2.518904195344823],
            [30.961914607574407, 2.518912154804992],
            [30.962397598464978, 2.51968125076362],
            [30.961219561276135, 2.523034096824083],
            [30.961345823980903, 2.524863150171467],
            [30.958202416680802, 2.526934488705428],
            [30.957315386931615, 2.528882411523669],
            [30.95387263043614, 2.528649699817098],
            [30.95288361764768, 2.527047933416886],
            [30.951303262772296, 2.522820900797729],
            [30.949162068105476, 2.519062376705673],
            [30.94888127810387, 2.519531323296875],
            [30.947947767725235, 2.519529843406963],
            [30.948513021837982, 2.516245004200233],
            [30.94692723395175, 2.515491467990739],
            [30.944497907352485, 2.516895785692734],
            [30.944869984153296, 2.517741277217001],
            [30.944308553270407, 2.518585288301673],
            [30.9423493671616, 2.51783115305243],
            [30.94085546255589, 2.518016532600568],
            [30.9403879711972, 2.518485178025931],
            [30.94075666763757, 2.520160995207563],
            [30.941563611680884, 2.52070391070506],
            [30.941266475036034, 2.522055104805419],
            [30.94021557640936, 2.523306193879407],
            [30.937853728559297, 2.524423318569926],
            [30.93703212131559, 2.52577366969614],
            [30.932945626697634, 2.527522525623747],
            [30.933913692570318, 2.52857090453163],
            [30.933804925454016, 2.529579696517299],
            [30.934911421711984, 2.53116341139883],
            [30.935062088948065, 2.532140520005632],
            [30.93709706771401, 2.533295613050585],
            [30.93777273465663, 2.534181544068039],
            [30.942785915152, 2.535475304395455],
            [30.947902502516364, 2.533571358728535],
            [30.9484691903403, 2.534352176398539],
            [30.94908657009575, 2.536987529591926],
            [30.950931578535275, 2.538347542861572],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 623,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "ZOMBO TOWN COUNCIL",
        Population: 12091,
        Key: "ZOMBOZOMBO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.337418385054185, 3.349210950953349],
            [31.330777503976375, 3.345367030792378],
            [31.32992210031507, 3.343766218956479],
            [31.330963486681213, 3.342958114041601],
            [31.33069037907192, 3.341138950960449],
            [31.327458723973255, 3.340014097923637],
            [31.326765848004744, 3.339030790295402],
            [31.325119156138864, 3.338804066441404],
            [31.32311413079777, 3.33933776155974],
            [31.32119967899349, 3.339334390526129],
            [31.315919647654773, 3.33687408174166],
            [31.314761763270976, 3.336983957618431],
            [31.3134123913063, 3.337888122774463],
            [31.311431738157157, 3.337683165580462],
            [31.307722150581274, 3.334878660467999],
            [31.300584057383606, 3.332202357877553],
            [31.300413517616807, 3.329560806141453],
            [31.300908118334135, 3.327860541192921],
            [31.301947608356738, 3.326329111519888],
            [31.301552921858576, 3.324224362849435],
            [31.302458653633668, 3.322759843541097],
            [31.303662197586725, 3.322247154280764],
            [31.30390941485121, 3.321419400602196],
            [31.30287268355486, 3.318082415422432],
            [31.302359034960244, 3.314757556433506],
            [31.3027519688453, 3.30574887652095],
            [31.302200036748214, 3.304136293265862],
            [31.30091328364705, 3.302611949431534],
            [31.29999970957949, 3.299017788812629],
            [31.29813878658636, 3.295880828810046],
            [31.296872520463555, 3.294983266267612],
            [31.29665303958176, 3.293886080860534],
            [31.299255684436982, 3.290589096022982],
            [31.30061580833732, 3.28978567485788],
            [31.302516646173455, 3.286700079955956],
            [31.30555584800225, 3.28391246954481],
            [31.30629394246726, 3.283955450610313],
            [31.30629469974705, 3.283686851431045],
            [31.30534025143577, 3.282722687448169],
            [31.305824290660322, 3.281680158259915],
            [31.305274623216054, 3.279319123312264],
            [31.308911073554746, 3.279976115370831],
            [31.308923363406173, 3.278329979770828],
            [31.308412085465562, 3.276587249275828],
            [31.310300194174125, 3.274992150423013],
            [31.31069264925716, 3.273777338310085],
            [31.31132610436457, 3.27316744832389],
            [31.31056304392123, 3.271566291175557],
            [31.30959248971522, 3.271133966620989],
            [31.30839229557987, 3.271361628799331],
            [31.308041496274907, 3.270451821023129],
            [31.309089590361275, 3.270070769949395],
            [31.311663925708636, 3.268093994553645],
            [31.314672761785886, 3.268223495831965],
            [31.315994046126583, 3.269613477259282],
            [31.316047401562887, 3.270434288458119],
            [31.31545790192062, 3.271344870233048],
            [31.317218367213844, 3.272046503792],
            [31.317609614961118, 3.271549486873275],
            [31.319166855285918, 3.271099433347549],
            [31.31914473966194, 3.270336592541141],
            [31.31802360535644, 3.269473296433306],
            [31.318024684233087, 3.269088149057935],
            [31.31934100628015, 3.266843607484524],
            [31.321646695950236, 3.266072254070765],
            [31.322731205941604, 3.266696172503355],
            [31.32376933052499, 3.2665830664475],
            [31.324732499681026, 3.265732884533288],
            [31.327284087888785, 3.265976426777518],
            [31.328247080975025, 3.265231518318099],
            [31.329232282211745, 3.262572490064098],
            [31.33023973561636, 3.262351017810322],
            [31.33045362089224, 3.26107191598051],
            [31.33005434849456, 3.26066927749091],
            [31.330331538048505, 3.260038068316042],
            [31.33074077545765, 3.260172741935891],
            [31.331336472577057, 3.259558748612333],
            [31.3307913712694, 3.258363948362111],
            [31.33289106646504, 3.255457923121471],
            [31.3322460257854, 3.253954236167404],
            [31.333398517582513, 3.254012522653901],
            [31.33472695341121, 3.250828704604784],
            [31.335974555237343, 3.250715924122956],
            [31.33568128134824, 3.249547798884023],
            [31.336462809357215, 3.249118407499813],
            [31.337604250079707, 3.247620165872944],
            [31.336999504230434, 3.247013716574501],
            [31.33664093539657, 3.245012822881776],
            [31.337729751911425, 3.243004750213675],
            [31.33773089456847, 3.242306082119664],
            [31.34075455644118, 3.237991121653817],
            [31.34152701865231, 3.231345070614347],
            [31.342388500314843, 3.228333671076413],
            [31.341560133248613, 3.22653718508593],
            [31.342917067231358, 3.225637267299233],
            [31.342772032432112, 3.224710338786916],
            [31.343359831563543, 3.22369255588701],
            [31.344537618122462, 3.22407497787222],
            [31.34505699168038, 3.223836483113399],
            [31.3457029477433, 3.224610804299923],
            [31.34708840233802, 3.224950604703838],
            [31.347517042458975, 3.224184175540672],
            [31.349453996162815, 3.223297464231574],
            [31.350553086709574, 3.223262432442985],
            [31.350249799299963, 3.222022256661198],
            [31.351167071731524, 3.221146151954528],
            [31.351624191141966, 3.221650133853483],
            [31.35221039037386, 3.221620401764344],
            [31.351931473359603, 3.220410949868727],
            [31.35342263091719, 3.219566459410226],
            [31.3543983234866, 3.220329038982507],
            [31.35597913560446, 3.220687554560493],
            [31.35836372340762, 3.222409799647268],
            [31.359896139687866, 3.222492063742633],
            [31.36059619768711, 3.223806531349212],
            [31.361164850126567, 3.223298075016495],
            [31.361738172907202, 3.223685639042095],
            [31.362637483524676, 3.223384714986161],
            [31.362918109134576, 3.222736298942259],
            [31.363937389758245, 3.222977292706805],
            [31.367383555360206, 3.221411757813486],
            [31.37679053604737, 3.223131826706227],
            [31.385207463696997, 3.223585552865108],
            [31.389536685799676, 3.219697021656473],
            [31.39009855685708, 3.21965963000703],
            [31.392220161962495, 3.220840239507359],
            [31.393210428799076, 3.220870525004295],
            [31.39668019583851, 3.218531099335111],
            [31.39853691112284, 3.218610602194077],
            [31.399637136241804, 3.216799962999985],
            [31.398849336195497, 3.213672400238796],
            [31.399175554001058, 3.212093680017742],
            [31.398044832874827, 3.210541378393815],
            [31.398360691308493, 3.209498624032948],
            [31.399492441904023, 3.20893701345895],
            [31.39922051827427, 3.207681466091358],
            [31.400422377886176, 3.206352968882082],
            [31.401488335870287, 3.206689633498252],
            [31.402318575923868, 3.205523259524831],
            [31.40364261449923, 3.205228630904436],
            [31.404282749479126, 3.203841817827424],
            [31.403962819880547, 3.202934696650535],
            [31.404361566763825, 3.202138277923103],
            [31.405132457821534, 3.20239790632027],
            [31.406019407620672, 3.201499605006426],
            [31.407629725802344, 3.200803426955672],
            [31.40736978929172, 3.1977404381057],
            [31.408253482697987, 3.197684202331802],
            [31.408835879361302, 3.196680138658615],
            [31.407702929514844, 3.195753221537385],
            [31.407772671120238, 3.194563254207846],
            [31.40883930373914, 3.194459632212874],
            [31.4093620585558, 3.195082572175701],
            [31.40989526527079, 3.195102545662474],
            [31.410727711586706, 3.192969821925695],
            [31.41130134248948, 3.190989127512423],
            [31.41119898305611, 3.189438437077436],
            [31.409676254207902, 3.187150892200382],
            [31.40978477698242, 3.186459607020353],
            [31.40882676325779, 3.184046185064397],
            [31.408494833065358, 3.183174693061998],
            [31.409944317776898, 3.181935343234577],
            [31.410279198036697, 3.180727241904813],
            [31.4110602616167, 3.180556169264797],
            [31.412470435153054, 3.181234888816238],
            [31.42599985474767, 3.181431200079818],
            [31.42774545561789, 3.181750651802057],
            [31.42913656420898, 3.182516844552089],
            [31.439956966740635, 3.182359535599946],
            [31.44797612577233, 3.184850177131142],
            [31.450680603648156, 3.184278834844056],
            [31.45252248774717, 3.184949776476817],
            [31.452911689132225, 3.185955371005805],
            [31.45380897045545, 3.186165408832681],
            [31.454998145855505, 3.18712964671821],
            [31.45702571891025, 3.186776225587122],
            [31.460142042902824, 3.185057790788071],
            [31.462392095415776, 3.184932081886202],
            [31.463988915511987, 3.185149727661501],
            [31.466512982034374, 3.187480310578823],
            [31.46865258847979, 3.188354741746295],
            [31.475040947741327, 3.189125182795443],
            [31.4784061041693, 3.189050698627758],
            [31.476566688640702, 3.193613273563376],
            [31.47096924657947, 3.203653096026479],
            [31.460794449767796, 3.214938455513747],
            [31.451377754699156, 3.225066173803146],
            [31.443711145788907, 3.236881747224559],
            [31.44150186511175, 3.238800274052417],
            [31.439659393514557, 3.241310726274493],
            [31.427191917333058, 3.266054605734791],
            [31.433759890244083, 3.31188516001561],
            [31.432674074102298, 3.313231152811566],
            [31.431406956376613, 3.319545851150187],
            [31.430829012662144, 3.320650354805949],
            [31.427579355325214, 3.321908504298268],
            [31.42369332874605, 3.328061054097389],
            [31.422016609793538, 3.328374193388407],
            [31.416770100886264, 3.333576991714602],
            [31.407540720723993, 3.339878670162816],
            [31.405284295562428, 3.342349006468027],
            [31.40412626654987, 3.345821260997511],
            [31.40035141277534, 3.347867981074553],
            [31.396946225621708, 3.348072942417981],
            [31.394016107116148, 3.347645866931422],
            [31.385665697018396, 3.346109898979403],
            [31.38211909527609, 3.344712318710587],
            [31.377705214144417, 3.344357066202351],
            [31.366885664113973, 3.34425204545082],
            [31.35978515463117, 3.345936265476862],
            [31.347500420032986, 3.342131901425833],
            [31.345033931927055, 3.341910275629121],
            [31.34542204904554, 3.342737243526086],
            [31.34715069601141, 3.344218832102258],
            [31.346458025757066, 3.344348129735689],
            [31.343127578435038, 3.343168252663426],
            [31.34031318719262, 3.343946292662137],
            [31.33875231947071, 3.345639743813645],
            [31.338361422964702, 3.346465385809618],
            [31.33861940474127, 3.347466092534068],
            [31.337418385054185, 3.349210950953349],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 624,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "ARIWA",
        Population: 24045,
        Key: "YUMBEARIWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.177594985996052, 3.372830688724049],
            [31.175262027965537, 3.375425149685882],
            [31.174668877569932, 3.376868641096927],
            [31.17333355884955, 3.377072490645843],
            [31.1723569194558, 3.377663967870193],
            [31.17196991085837, 3.378695096340267],
            [31.17029988794798, 3.379414240643959],
            [31.169551629943843, 3.38142495109085],
            [31.16877997262321, 3.382223181394645],
            [31.167931490481177, 3.382918077654622],
            [31.166647412562895, 3.383173602928818],
            [31.16467300539994, 3.384692710977742],
            [31.163859174871675, 3.384754059320202],
            [31.163840687543107, 3.385081975883586],
            [31.1619636613502, 3.384337933971436],
            [31.16018228327718, 3.38451098581525],
            [31.158955066919773, 3.383475163665142],
            [31.15669736345554, 3.383496059719947],
            [31.155895789541006, 3.382889563696399],
            [31.15431476452242, 3.383239437805932],
            [31.14656414067524, 3.382896895524087],
            [31.144254268449163, 3.383976340646442],
            [31.13753635054757, 3.381442740843372],
            [31.136449027931015, 3.382499914100726],
            [31.13431732306687, 3.383447007526348],
            [31.126986094778044, 3.380816983995336],
            [31.126398004592453, 3.378972878357854],
            [31.125511590189245, 3.378436107518647],
            [31.12225737929213, 3.379320717353751],
            [31.120422444560155, 3.379020721954004],
            [31.11510763404691, 3.379235006569682],
            [31.11767880732446, 3.381238689546679],
            [31.1170699597676, 3.383400576529008],
            [31.11892293177217, 3.387232105125173],
            [31.121063178716344, 3.389476321342443],
            [31.121145585668945, 3.39063903515181],
            [31.12032457221166, 3.392026825222167],
            [31.117163918156447, 3.392134066532159],
            [31.116542072875728, 3.392671592906324],
            [31.115554878277415, 3.392442820824144],
            [31.11369022637753, 3.393601716333799],
            [31.112115105985303, 3.393257923179958],
            [31.110632682747262, 3.393875175376316],
            [31.106039759294625, 3.394461497745688],
            [31.103469128599496, 3.396093654148212],
            [31.1026523758516, 3.397158718820596],
            [31.097980670148555, 3.39713357163197],
            [31.09459065823499, 3.395455669883085],
            [31.092826273592195, 3.393603571688942],
            [31.091775401016637, 3.393409425657995],
            [31.089718657867984, 3.394437677660977],
            [31.08857354213763, 3.393571124046909],
            [31.085492993551263, 3.392796752819313],
            [31.084872512811465, 3.392435401188149],
            [31.085135987785986, 3.392099819977493],
            [31.084826196573747, 3.391691072591958],
            [31.08406141765323, 3.391285659121113],
            [31.08532870875378, 3.390035914461082],
            [31.084998869839325, 3.388923135138728],
            [31.083504201665647, 3.389198193502568],
            [31.083450561463398, 3.388336190656726],
            [31.08209648591989, 3.38747160172517],
            [31.082682739949043, 3.384640205466825],
            [31.081604911626748, 3.384189863724018],
            [31.08187860134436, 3.382917811319892],
            [31.08086185486814, 3.382158764211288],
            [31.080834896426445, 3.381797270509381],
            [31.081564678780108, 3.381610375930424],
            [31.080711504737337, 3.379048878221312],
            [31.08085412037353, 3.378374701384164],
            [31.080330636124856, 3.377543679864754],
            [31.08081092218814, 3.376232554256067],
            [31.078390042447513, 3.376483761617969],
            [31.075780418580838, 3.375550518977465],
            [31.07215366016572, 3.373623190426711],
            [31.0684961730797, 3.370482483213977],
            [31.067062228324254, 3.371564927453966],
            [31.06597224849112, 3.374786124122326],
            [31.06425186422926, 3.375527512682859],
            [31.05883160587466, 3.362652040391999],
            [31.050467876456178, 3.32445764748959],
            [31.04976735402793, 3.324424255905365],
            [31.04947986978083, 3.32487170250193],
            [31.045927338259347, 3.322292993599433],
            [31.04689508702672, 3.32062910406663],
            [31.047524466477697, 3.318327959101053],
            [31.04779393141853, 3.31393692076507],
            [31.049388361996098, 3.311997334522103],
            [31.052249490786135, 3.310669621644531],
            [31.05439189638194, 3.30517340904709],
            [31.055500014099, 3.304969792086862],
            [31.05767412752939, 3.303717643226247],
            [31.05927681362441, 3.304057208810282],
            [31.061208256163994, 3.301100001858831],
            [31.061633731520207, 3.299345310729417],
            [31.063048268173933, 3.298429081166611],
            [31.063704783034698, 3.29844803829831],
            [31.064986485807353, 3.296500613085369],
            [31.066079561234947, 3.29608722601002],
            [31.06810402701713, 3.296485845901093],
            [31.069607701699876, 3.295618121427863],
            [31.069631037236007, 3.296995885808273],
            [31.070138950985857, 3.297552918341212],
            [31.070062330980317, 3.302055440789055],
            [31.07086566738946, 3.302813036040511],
            [31.07313935008596, 3.303204276866204],
            [31.074766953650343, 3.302943716620556],
            [31.075719273852698, 3.299024773298153],
            [31.07726094906859, 3.297955263066553],
            [31.0804469715474, 3.297012014370493],
            [31.084505315659317, 3.29735393372963],
            [31.085133341349167, 3.298304586307117],
            [31.085042020414004, 3.300308774347514],
            [31.084532319016766, 3.301520956047061],
            [31.085370563059513, 3.302331360269037],
            [31.08752142898868, 3.302915734844008],
            [31.090492887963602, 3.304398385866791],
            [31.09400904939416, 3.304668910314248],
            [31.09477947332791, 3.304353916062981],
            [31.0988631831685, 3.300599172658364],
            [31.114502062645872, 3.311196167328663],
            [31.11850324515962, 3.314087338732141],
            [31.11883440998742, 3.314756107184714],
            [31.119379620889557, 3.313262635457656],
            [31.119136500841073, 3.312295133511857],
            [31.1211825234951, 3.309867161960866],
            [31.12484185122914, 3.307275153562071],
            [31.12712881821209, 3.306700538952481],
            [31.129816756306923, 3.306837136235815],
            [31.129879660834668, 3.304120735198048],
            [31.13126075051543, 3.302174112102017],
            [31.133534305651146, 3.30401464832539],
            [31.137299343534565, 3.305010499698191],
            [31.137147097958547, 3.307257418963438],
            [31.13797634267878, 3.308326478835874],
            [31.13697154289752, 3.310588560230491],
            [31.136877437184985, 3.31350307746415],
            [31.137319375965397, 3.31391024954289],
            [31.136549039168234, 3.314264623394891],
            [31.136242937336853, 3.315322921135135],
            [31.137110419745493, 3.318628491451767],
            [31.13693141335715, 3.319680175943102],
            [31.13745956615033, 3.321243741339341],
            [31.138412310357523, 3.322127391270945],
            [31.138069182665063, 3.323569434910405],
            [31.138854282375632, 3.324495284540578],
            [31.139992479281638, 3.324992511747823],
            [31.139897940581132, 3.326152655874224],
            [31.141450753109904, 3.327192152891606],
            [31.14180251451053, 3.328415026484895],
            [31.143631693736463, 3.329841822525049],
            [31.14383036155145, 3.330615748701316],
            [31.14429310172059, 3.330121551922776],
            [31.144739170954693, 3.330308049204268],
            [31.144768102995084, 3.331298247579067],
            [31.145136856927632, 3.331670249803435],
            [31.144798033962008, 3.33252918096179],
            [31.145579825177357, 3.333512139066845],
            [31.14443804309507, 3.334917836916084],
            [31.144294006324106, 3.335911354166411],
            [31.140982560166986, 3.338779022670002],
            [31.14094993694913, 3.339753631691072],
            [31.14349369723748, 3.345931391455972],
            [31.144723611235673, 3.346784636193197],
            [31.148447882673178, 3.347364141802794],
            [31.149231581910197, 3.348108239757269],
            [31.150323920719273, 3.348450675895651],
            [31.15133625916241, 3.350115104836876],
            [31.159633009295007, 3.350788963137443],
            [31.171301197774344, 3.3511513032492],
            [31.172586759709464, 3.350842560957683],
            [31.172448633853065, 3.351150650393922],
            [31.17334018302648, 3.352529989978733],
            [31.17317982027353, 3.35328840643506],
            [31.173933179810145, 3.354188299552691],
            [31.173891511455686, 3.355226465658837],
            [31.175559186169924, 3.355948377702828],
            [31.175655344532895, 3.357665654181774],
            [31.176427907355333, 3.35892497674891],
            [31.177598228015906, 3.359985383124368],
            [31.178551734892764, 3.360106970030548],
            [31.17930491656296, 3.361106695177901],
            [31.18025861298434, 3.361308692611307],
            [31.181892377194945, 3.363264180745249],
            [31.18088279927469, 3.36359640635504],
            [31.181225527216807, 3.364634205541488],
            [31.180924185558137, 3.366183229075943],
            [31.179924931077128, 3.368530728446333],
            [31.178331062844908, 3.369627441447746],
            [31.17837726858988, 3.371527018699819],
            [31.177594985996052, 3.372830688724049],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 625,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "DRAJINI",
        Population: 31291,
        Key: "YUMBEDRAJINI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.197388109233476, 3.794044232697045],
            [31.185035967751322, 3.794004217995993],
            [31.184217943887305, 3.793257042024906],
            [31.18185510968706, 3.794018693096064],
            [31.16588196260087, 3.793971685994251],
            [31.162927131441897, 3.789506765148743],
            [31.159936722506046, 3.78615917109289],
            [31.15927806606163, 3.784638604460282],
            [31.15742128430198, 3.783445513148504],
            [31.157099002914, 3.781790905588632],
            [31.1558798210885, 3.779740502144755],
            [31.15425419741102, 3.778881896945982],
            [31.152977417406124, 3.777301040667614],
            [31.1516707190107, 3.777131869010026],
            [31.15064390781, 3.776121290617336],
            [31.14972605506677, 3.776713672077872],
            [31.14856005620103, 3.776088507857954],
            [31.146236185527922, 3.773331859970629],
            [31.143345168890093, 3.771481100258485],
            [31.14188362788911, 3.771873538949611],
            [31.138953005428714, 3.769645297946038],
            [31.135702523438347, 3.768457686169859],
            [31.13475118329796, 3.767260404480383],
            [31.135236410993606, 3.766847088935926],
            [31.135003430229723, 3.765476871704164],
            [31.13420680154084, 3.764847828849052],
            [31.132352447927378, 3.764666922987749],
            [31.13136168072915, 3.765328341288779],
            [31.129739955740007, 3.765411327790802],
            [31.128710708308272, 3.764518383470403],
            [31.128431108574418, 3.763100088005327],
            [31.127569537080344, 3.762163655261147],
            [31.12665319710007, 3.762685433088636],
            [31.122609489239093, 3.760150892986442],
            [31.12334364908315, 3.758671913352356],
            [31.122778817178574, 3.757223987348408],
            [31.12036983831883, 3.757360733483443],
            [31.11913978508172, 3.755827946243302],
            [31.119193065957866, 3.754440319982641],
            [31.11802745516434, 3.753238454627957],
            [31.11678559267452, 3.752823487562039],
            [31.115733387897404, 3.753012809385729],
            [31.11489382692444, 3.75440713661812],
            [31.114463221289636, 3.754492072009321],
            [31.113074327944027, 3.753709101542744],
            [31.111859438268922, 3.753706632889853],
            [31.110235431558955, 3.752777402408243],
            [31.109632828191625, 3.751987738854083],
            [31.109224879864914, 3.749884095714981],
            [31.108101918386115, 3.748918518706663],
            [31.106435451905938, 3.749989126860523],
            [31.105008275057852, 3.749887951097153],
            [31.103603781569014, 3.745915223100861],
            [31.100618568488777, 3.745145142311179],
            [31.10037763314306, 3.744151381804486],
            [31.100811593087123, 3.741665635484936],
            [31.10207208034773, 3.741763244525492],
            [31.10313175281982, 3.741221023433691],
            [31.10520831549857, 3.74103011063548],
            [31.10539497553315, 3.740092582141982],
            [31.10497737121544, 3.739565807722783],
            [31.103204532527492, 3.738915852843756],
            [31.101821993864217, 3.738956857914045],
            [31.1018706304503, 3.737227845872008],
            [31.100465049999972, 3.735840887522798],
            [31.100776620774823, 3.734675103035952],
            [31.100618009736678, 3.732411654781165],
            [31.099935163458287, 3.730939305639524],
            [31.100496538645633, 3.730517053628913],
            [31.10067102381315, 3.728504157621359],
            [31.101261304989727, 3.727054509928692],
            [31.100893709883895, 3.723566824182394],
            [31.100337746147808, 3.722908626542679],
            [31.09962242038203, 3.590996324156802],
            [31.09738260596836, 3.587100053574352],
            [31.09201512633166, 3.580747936026819],
            [31.091089523822475, 3.578903991238145],
            [31.09200329462106, 3.568706836065129],
            [31.089785240098518, 3.566812937699456],
            [31.089419763220103, 3.566075463071345],
            [31.089860298832093, 3.564390122073869],
            [31.08949091428221, 3.562711044180324],
            [31.087971876611473, 3.561336978174213],
            [31.0876159227734, 3.559022662447187],
            [31.08715075266141, 3.558494912156346],
            [31.087054890742518, 3.556833434233665],
            [31.088918296679065, 3.555437362613197],
            [31.088098593863773, 3.553654538555297],
            [31.089168360704715, 3.553747964812968],
            [31.089536397781686, 3.553237975608917],
            [31.08911343321666, 3.551840216544352],
            [31.08762164594007, 3.551183051880677],
            [31.08732004736323, 3.550482170762504],
            [31.086750414861775, 3.547497291408601],
            [31.087063657401355, 3.545352011205617],
            [31.086410761852857, 3.543630503933886],
            [31.088859407620607, 3.538733256278699],
            [31.088959982101507, 3.537892904476676],
            [31.090222967576906, 3.53644066066127],
            [31.089650835962352, 3.535730944882249],
            [31.08978011700647, 3.532292458705804],
            [31.092512424689808, 3.529634009225985],
            [31.093007856348784, 3.526460792548602],
            [31.093508138011956, 3.525517109978495],
            [31.094280875107565, 3.525211899413478],
            [31.093441029368655, 3.522863019303885],
            [31.093791189971455, 3.52207018378855],
            [31.09324967563674, 3.520646363195546],
            [31.09124619270296, 3.495414983303302],
            [31.090407399789584, 3.490194638510054],
            [31.089208334836517, 3.475806324679313],
            [31.09145757078091, 3.474456575374274],
            [31.092239629694205, 3.472832979799732],
            [31.0922916861666, 3.461817943035233],
            [31.09095043227713, 3.458504670661365],
            [31.09020275458468, 3.457931333790083],
            [31.090235540397614, 3.456516888546555],
            [31.08975798161952, 3.455673235888582],
            [31.090210949915036, 3.453838296546398],
            [31.092944769462992, 3.449780851805523],
            [31.092678798968635, 3.447974552093572],
            [31.093216377784096, 3.445451427718685],
            [31.09327326539609, 3.444337225943883],
            [31.094496243501986, 3.443208510774849],
            [31.094660525604507, 3.44244563847212],
            [31.095719218912933, 3.442079792474603],
            [31.096585231677754, 3.443117306264662],
            [31.09764341114984, 3.443010400636583],
            [31.101124323586998, 3.438669832981482],
            [31.102209033902685, 3.438862803253999],
            [31.10256215625098, 3.437902313939938],
            [31.103511023329396, 3.438871627656529],
            [31.104542039543908, 3.438721645980085],
            [31.10576928554572, 3.439759869126965],
            [31.10784897705663, 3.440096605657519],
            [31.108035866161604, 3.441227777872984],
            [31.108913186919228, 3.442293809270754],
            [31.109887003806325, 3.442381273747283],
            [31.111378379654507, 3.443752610883533],
            [31.11087415798047, 3.4451023268037],
            [31.112532576454047, 3.44588657857802],
            [31.113167238897223, 3.445476475003414],
            [31.115411895230245, 3.445600370863533],
            [31.120041704406766, 3.448276835828899],
            [31.120496997542237, 3.4482714296916],
            [31.12099414228844, 3.447603230345025],
            [31.1219424586996, 3.447657477369474],
            [31.122775143967377, 3.448214210178312],
            [31.122685556780713, 3.44850512292847],
            [31.12142820733543, 3.448505127411922],
            [31.122193504583848, 3.449655751341903],
            [31.1234140419671, 3.450603810583584],
            [31.12439776637349, 3.450953581993633],
            [31.124971764687242, 3.450617768408495],
            [31.126538325033096, 3.451642597337288],
            [31.126413428665884, 3.453200765922708],
            [31.126061408550463, 3.453595543630857],
            [31.12805289089035, 3.455844697593427],
            [31.12773679440312, 3.458676684208622],
            [31.12860856447058, 3.458729944253525],
            [31.13078952755503, 3.460692460539522],
            [31.13199991307729, 3.460684550053617],
            [31.133709778965475, 3.462275105160316],
            [31.134035826989443, 3.46226583532732],
            [31.134481605169395, 3.460988343331659],
            [31.13585477979416, 3.461660968215541],
            [31.13678896750254, 3.46127117400677],
            [31.13803829139908, 3.462335193187691],
            [31.13862078597875, 3.463449426742434],
            [31.1409357597373, 3.465092704267945],
            [31.141788676861907, 3.464300797321841],
            [31.142618764201877, 3.464694074756058],
            [31.143642115990392, 3.465922548752994],
            [31.144443022456684, 3.465501565542994],
            [31.14595845159491, 3.46548848308964],
            [31.149812849391196, 3.468837140496721],
            [31.151015621691418, 3.468222440218938],
            [31.151976618721143, 3.46835847132837],
            [31.15338841551322, 3.470105118107965],
            [31.155095552319587, 3.471020649111044],
            [31.156484720549674, 3.47067459731365],
            [31.158219658417483, 3.471026770659152],
            [31.161664919415966, 3.470657904050979],
            [31.16446591767579, 3.472058482735951],
            [31.166871887179365, 3.470614404905921],
            [31.167432523951557, 3.470669156334043],
            [31.16820480919456, 3.471743823619855],
            [31.169804806631937, 3.472846931020436],
            [31.168797415211085, 3.475263495610551],
            [31.168887265604134, 3.476265233013411],
            [31.16969661443745, 3.477667480133085],
            [31.170595224368988, 3.477645155962589],
            [31.17127720287481, 3.478127997067249],
            [31.17134711336349, 3.479151346304532],
            [31.17277938276088, 3.481970985165709],
            [31.1746720656909, 3.482131162157605],
            [31.175665321222457, 3.482734986796058],
            [31.17747467552835, 3.482618127375714],
            [31.178910351337336, 3.483680248491947],
            [31.181318458831267, 3.483721038238646],
            [31.18136621776335, 3.48557567911006],
            [31.182032436225835, 3.486262414136065],
            [31.18335199130962, 3.48541028507667],
            [31.185352476565285, 3.485594731203925],
            [31.18790783500226, 3.488694747775858],
            [31.189872113660414, 3.490406608130697],
            [31.18982143610196, 3.491108725214433],
            [31.190814816499344, 3.49239469096972],
            [31.19078873122013, 3.493502130080186],
            [31.19158882471108, 3.494293633206722],
            [31.1914077773504, 3.496281761610804],
            [31.191774828975483, 3.497783810094195],
            [31.19405190191386, 3.499362104676368],
            [31.19520348192099, 3.498962791188772],
            [31.197316297909673, 3.499290016582262],
            [31.198301823438207, 3.499993529361647],
            [31.198300248691528, 3.501770718770971],
            [31.200398353869108, 3.503062799311526],
            [31.201735450355446, 3.503773712780909],
            [31.201862768580664, 3.507281081346095],
            [31.20232111958132, 3.508138211668542],
            [31.20419550293067, 3.509613812940577],
            [31.205000770717664, 3.513232406802513],
            [31.206555705067153, 3.514042144965417],
            [31.208275704850056, 3.513796092749853],
            [31.20930443754712, 3.514141750276649],
            [31.20925684660002, 3.514601601039987],
            [31.20815558213029, 3.515505912217401],
            [31.206146059822856, 3.519580980858809],
            [31.20411516839144, 3.520086920611736],
            [31.201997848249945, 3.521555770269927],
            [31.20072512054529, 3.523649420916585],
            [31.20026775858974, 3.526906015249914],
            [31.201972663980953, 3.534642312900358],
            [31.201602813205408, 3.536369476522824],
            [31.200896768833143, 3.536991271710683],
            [31.19895357183807, 3.541698080083855],
            [31.198612352167324, 3.543193021523401],
            [31.19876549695693, 3.545640679226556],
            [31.19921471209117, 3.546615967802244],
            [31.194503194851357, 3.545315083999748],
            [31.192476893811072, 3.543430276605124],
            [31.19166760067328, 3.542046390132829],
            [31.190529617566316, 3.542034886764269],
            [31.189711522735365, 3.540962053113407],
            [31.187997400629367, 3.536714977720486],
            [31.187167006065554, 3.535872373609431],
            [31.185922365086586, 3.544872443369597],
            [31.18605882995802, 3.546311233997911],
            [31.185619912211873, 3.546796244313851],
            [31.18536209303041, 3.548862219341463],
            [31.184456526545286, 3.551149845758156],
            [31.18496377823677, 3.553644000059928],
            [31.183912796965064, 3.553786474159291],
            [31.184448028482713, 3.555516190474092],
            [31.183503253230413, 3.557402816578211],
            [31.18378583177777, 3.560386520741065],
            [31.18510329468525, 3.563427508396475],
            [31.18516386718653, 3.565076534415574],
            [31.185727360601327, 3.56659500803991],
            [31.18552311514677, 3.569509535133689],
            [31.18834641947342, 3.572300026000271],
            [31.189543330266414, 3.574279197280456],
            [31.193763499588552, 3.587091773885728],
            [31.19465637557361, 3.588805562931983],
            [31.194274786512267, 3.591657489419689],
            [31.19378178389784, 3.592447359357705],
            [31.191821594370875, 3.593912247514441],
            [31.189686360924266, 3.596903463325454],
            [31.188603079828223, 3.597445402633145],
            [31.19027548956233, 3.602294704870626],
            [31.190173341233052, 3.603751970062807],
            [31.18751031521769, 3.608050147027919],
            [31.1873238312529, 3.608987753323364],
            [31.188245737194702, 3.613279721257751],
            [31.18987769579158, 3.617221920845945],
            [31.190199883754754, 3.619453224355795],
            [31.19006806317335, 3.635880824037652],
            [31.191509782847536, 3.65054114112947],
            [31.1915402483121, 3.657568259786911],
            [31.192812786472206, 3.665563380657038],
            [31.193494024766252, 3.686890672403859],
            [31.19347375248522, 3.694636698791947],
            [31.1961662369537, 3.735781900393144],
            [31.196148128714206, 3.746221205169817],
            [31.19722461046189, 3.765169766951256],
            [31.19668179267169, 3.788579804853669],
            [31.197388109233476, 3.794044232697045],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 626,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "KEI",
        Population: 45726,
        Key: "YUMBEKEI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.361760762841648, 3.745799450846596],
            [31.355953653993133, 3.749239648761871],
            [31.352324125173674, 3.750650714054862],
            [31.337288008065414, 3.761567816412545],
            [31.28984633040082, 3.793813286303194],
            [31.25071270996332, 3.793901336230945],
            [31.246597183592037, 3.794226131857145],
            [31.245150956171702, 3.793889343112804],
            [31.242953075115516, 3.794172126990628],
            [31.22013157564678, 3.79403921136399],
            [31.218688301887106, 3.794691105999375],
            [31.217764532839432, 3.794436016696928],
            [31.216782682318726, 3.794674030611286],
            [31.21576813132504, 3.79420515018261],
            [31.213230406817082, 3.794786623293931],
            [31.21256837360551, 3.793983940844433],
            [31.197388109233476, 3.794044232697045],
            [31.19668179267169, 3.788579804853669],
            [31.19722461046189, 3.765169766951256],
            [31.196148128714206, 3.746221205169817],
            [31.1961662369537, 3.735781900393144],
            [31.19347375248522, 3.694636698791947],
            [31.193494024766252, 3.686890672403859],
            [31.19441449699685, 3.687924190653303],
            [31.196152599629364, 3.688642581650147],
            [31.201339313078073, 3.689649541330049],
            [31.203159095926136, 3.69177703853195],
            [31.204548247088248, 3.691592464597067],
            [31.206018093912324, 3.692511597482435],
            [31.210575759388348, 3.693770128715143],
            [31.21353975515988, 3.693838586948322],
            [31.214326175393914, 3.694464825436951],
            [31.22237799447441, 3.696863004670239],
            [31.224103143400544, 3.698945289462428],
            [31.226567533041948, 3.699946934991619],
            [31.22837808659877, 3.701858527503288],
            [31.228916213386594, 3.702115900150961],
            [31.230420196191446, 3.701378515504964],
            [31.23447002517277, 3.703465452065489],
            [31.235148321484264, 3.704520462833033],
            [31.23614055293636, 3.704522448443796],
            [31.239036371069414, 3.70242092660042],
            [31.240880436277923, 3.701741152893397],
            [31.242555806859198, 3.700349107874055],
            [31.24482482909602, 3.699812555500516],
            [31.246528935884946, 3.698221216173617],
            [31.248913030513, 3.696830556909352],
            [31.250279316856187, 3.69537198687694],
            [31.2502352841359, 3.691116057950178],
            [31.249232387884724, 3.683303041611695],
            [31.24928427457554, 3.682799159396598],
            [31.251589151270284, 3.680665382513552],
            [31.25556648710648, 3.680932401856622],
            [31.256833794376718, 3.681604468477788],
            [31.261697550006033, 3.679389280872162],
            [31.262730354766298, 3.679024113502245],
            [31.26374052647297, 3.67924208332202],
            [31.263999552990192, 3.678724205001415],
            [31.26744165910537, 3.677802153323296],
            [31.270154615280866, 3.675885093506909],
            [31.271426433890458, 3.674224411626728],
            [31.27660578295046, 3.675595234246901],
            [31.280862230735316, 3.676100268910302],
            [31.281482186858977, 3.677980629674405],
            [31.28240570168344, 3.678544004897985],
            [31.28276912680974, 3.679646285308836],
            [31.28408324079784, 3.678352850856125],
            [31.285845548535715, 3.678809846026422],
            [31.28756362053405, 3.678352764795528],
            [31.288946354131728, 3.676782888790919],
            [31.289374878370058, 3.676949200301165],
            [31.290504016664734, 3.676196469670523],
            [31.292644581612556, 3.675573450983737],
            [31.295092412608334, 3.673519283023968],
            [31.299517340323078, 3.673012202947824],
            [31.300709720912078, 3.672355350129742],
            [31.321810633998005, 3.671859234131893],
            [31.323397652576187, 3.672482721576751],
            [31.325490787375287, 3.671084090993685],
            [31.347018636478104, 3.66998625906052],
            [31.34707633077722, 3.672900233830506],
            [31.34798591452827, 3.672941421255078],
            [31.348615347878173, 3.674820635820413],
            [31.347329919792053, 3.690209713311889],
            [31.346539886533964, 3.693272307054811],
            [31.34539234894561, 3.695591464995406],
            [31.34666104231633, 3.702908123895994],
            [31.34948269104793, 3.71243579002655],
            [31.35129597548323, 3.722421597156054],
            [31.35255599382325, 3.734384458060944],
            [31.354335568977493, 3.737883953128712],
            [31.35725855396137, 3.742213640770103],
            [31.358899868511916, 3.744223198513287],
            [31.361760762841648, 3.745799450846596],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 627,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "KERWA",
        Population: 32304,
        Key: "YUMBEKERWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.42940779523767, 3.711691498916583],
            [31.407416186377844, 3.685588040066541],
            [31.407977948739095, 3.683467751724368],
            [31.40893258210331, 3.68221823236908],
            [31.409957818557306, 3.682465410781777],
            [31.411716722578543, 3.682125086501235],
            [31.41242627397371, 3.681365802626032],
            [31.412672133883813, 3.680433949070361],
            [31.412234734290497, 3.679206465918251],
            [31.413068643063685, 3.67717163323555],
            [31.412705460482528, 3.675404536771318],
            [31.413023925827172, 3.674840823388501],
            [31.413610279569305, 3.674694664094227],
            [31.414124414152514, 3.673959562419052],
            [31.41483230725764, 3.674132561217542],
            [31.415150468073396, 3.673740584572926],
            [31.416176219262024, 3.673693343327554],
            [31.417667952639686, 3.672518365246696],
            [31.417524021869905, 3.671046065340283],
            [31.417990390334523, 3.669697519373117],
            [31.42014146557115, 3.668523704141061],
            [31.420118079729345, 3.667934842079202],
            [31.421731082077105, 3.667226213151224],
            [31.42168275720638, 3.666931718091594],
            [31.423173095500417, 3.666541810940656],
            [31.423687387288787, 3.665708560699217],
            [31.424786566768724, 3.665563299974064],
            [31.43049010166163, 3.657796012805291],
            [31.43371691214595, 3.655888004953062],
            [31.43601382707235, 3.655082397868592],
            [31.43638459502776, 3.652506944552805],
            [31.43590231111127, 3.648973161723675],
            [31.437202304481428, 3.645663300218456],
            [31.436936483107388, 3.644043570862944],
            [31.4393599886236, 3.64061298613474],
            [31.44070819816833, 3.637646672470972],
            [31.440734305905444, 3.636665344565238],
            [31.44058947502374, 3.635683717950854],
            [31.43927295624564, 3.63443017924835],
            [31.438637831170062, 3.634551747600259],
            [31.438200006673654, 3.633545079175734],
            [31.437931219062534, 3.633642750292965],
            [31.438298190737576, 3.633250838438713],
            [31.437908742315823, 3.632514131227214],
            [31.438864360233588, 3.630626646505946],
            [31.43832733927189, 3.630503042541917],
            [31.438085462491753, 3.629153235267603],
            [31.43876950802107, 3.628982680664087],
            [31.4388217603262, 3.62699549061125],
            [31.438385030876084, 3.625350931840864],
            [31.438996236510555, 3.624934907226546],
            [31.439753115646464, 3.625009820270158],
            [31.440315943409612, 3.624323833157567],
            [31.43965707855607, 3.624052814636391],
            [31.439194455167886, 3.623266915063868],
            [31.43939153565977, 3.622261347545086],
            [31.43887876921073, 3.622235925804302],
            [31.43873536665038, 3.620420136047618],
            [31.438077303992348, 3.619682965635855],
            [31.437051480040193, 3.61980386088935],
            [31.4377620815659, 3.618382101420491],
            [31.437227044982684, 3.61710538953543],
            [31.437352673476834, 3.615044722677732],
            [31.43659790538187, 3.613743098721624],
            [31.437942600717193, 3.612788582504582],
            [31.43799223712821, 3.612322516754787],
            [31.43733333813868, 3.612076034484115],
            [31.437701557573625, 3.61094809140541],
            [31.44241634198615, 3.6098521755657],
            [31.443322318102982, 3.608406204829691],
            [31.444324464260912, 3.607843635608555],
            [31.44575325538154, 3.608024515099612],
            [31.446313424131482, 3.607335127127489],
            [31.446224340001386, 3.606016586126813],
            [31.446681552836587, 3.605349605584325],
            [31.449740556229205, 3.603938968348555],
            [31.45214638200231, 3.600322147087309],
            [31.45226005481839, 3.597438034824832],
            [31.452772241854024, 3.595757893254214],
            [31.455933230980854, 3.591954021777847],
            [31.455110183737737, 3.590799536456955],
            [31.45548514502893, 3.587451054026374],
            [31.451692633969145, 3.585695474829017],
            [31.449498489006213, 3.58616373552447],
            [31.44658315048207, 3.584764116890656],
            [31.44553064476932, 3.584897120309068],
            [31.444565375352138, 3.584018305258613],
            [31.44346775265253, 3.584016291588508],
            [31.443061707855907, 3.582801163712562],
            [31.441322980894274, 3.581639814417834],
            [31.441163966512566, 3.580694994961354],
            [31.441925742365058, 3.580763862546346],
            [31.442259537460032, 3.579819949507218],
            [31.441742805847348, 3.579166833097827],
            [31.442143385293797, 3.578043135788037],
            [31.441557767271856, 3.576670251082516],
            [31.44195897553901, 3.575816419925063],
            [31.441531951487235, 3.575208446397649],
            [31.440949491941854, 3.575184883720369],
            [31.441851203756066, 3.57283647495212],
            [31.441759080625356, 3.571756850664082],
            [31.440501832689687, 3.570540162637617],
            [31.440271462430005, 3.567818615672153],
            [31.440605041030977, 3.566784752064927],
            [31.439951755613677, 3.565209354201314],
            [31.440509697440007, 3.564333313125519],
            [31.44042821844711, 3.563017575586448],
            [31.43932946566689, 3.56252082233468],
            [31.439009224352954, 3.559686672308029],
            [31.438277460315753, 3.562856231718992],
            [31.437540371065566, 3.56375443223453],
            [31.43633108957281, 3.563887158967094],
            [31.434737340816543, 3.562444972613505],
            [31.433123768038588, 3.56210469196138],
            [31.43169201966401, 3.562889160376919],
            [31.430465274922152, 3.565135768558292],
            [31.429212505088177, 3.565830617124989],
            [31.428719083858798, 3.565559840330939],
            [31.42784917330397, 3.562331141983784],
            [31.427219784869816, 3.561385474213374],
            [31.425741868479548, 3.561585153422509],
            [31.424173003056644, 3.561199957349101],
            [31.42173441931839, 3.562477306853955],
            [31.419674543744353, 3.56285581480976],
            [31.418194651060436, 3.56220091558752],
            [31.416854371843044, 3.56379511446798],
            [31.415746241549595, 3.564074167195245],
            [31.412740953817714, 3.562449442958585],
            [31.410908969153173, 3.564514966006013],
            [31.409521078327387, 3.564894687088786],
            [31.40615870038864, 3.563831489538489],
            [31.405019537793684, 3.565223640255135],
            [31.40239227191315, 3.56725392078824],
            [31.402103874977687, 3.568467753994713],
            [31.400808721730293, 3.570219412317256],
            [31.399353059304552, 3.57035161631148],
            [31.39679764876527, 3.569537251777213],
            [31.395342810992965, 3.570029269130437],
            [31.394317323010718, 3.572163714203071],
            [31.393987039430204, 3.574659278332876],
            [31.39347313481571, 3.575220516878896],
            [31.392149960419655, 3.574520890435485],
            [31.391677049524848, 3.573418084655291],
            [31.39076953010233, 3.573270209078791],
            [31.38826616705231, 3.575626731560714],
            [31.386316168912256, 3.575083337638676],
            [31.384527482146048, 3.57651919860158],
            [31.381281329137064, 3.577300125825715],
            [31.38008476778871, 3.578096181008245],
            [31.378382242933004, 3.578025491404149],
            [31.377572598553947, 3.576584720517514],
            [31.37704598996474, 3.576441729045437],
            [31.375167560603334, 3.577683981955727],
            [31.372360899363933, 3.578212983586692],
            [31.37176594694789, 3.578118530559382],
            [31.370693521992038, 3.576975595260022],
            [31.369555535291816, 3.57957660000508],
            [31.369486165588924, 3.580864393987523],
            [31.366283429055922, 3.579140536004742],
            [31.36545096207874, 3.579308750958782],
            [31.364025577369667, 3.580694040123233],
            [31.363573527152386, 3.580694738544734],
            [31.362215201679273, 3.579289927618916],
            [31.363401295857916, 3.577022716935642],
            [31.363019473234623, 3.576284082284415],
            [31.36016359240247, 3.575740051293156],
            [31.357949091615207, 3.574551183663048],
            [31.357092620755317, 3.574576350316053],
            [31.352826098364545, 3.577265607178277],
            [31.352475743725645, 3.577284636769657],
            [31.35271824573323, 3.576784991742208],
            [31.35185213415372, 3.576954884602296],
            [31.34847397730699, 3.578152280819271],
            [31.344756216858645, 3.577864209346933],
            [31.343495155574594, 3.578362075899787],
            [31.33681916204727, 3.579350240306089],
            [31.334829013705573, 3.578674531056021],
            [31.33338179813847, 3.578875076172396],
            [31.33154272935955, 3.580684763400122],
            [31.328477049687777, 3.58114804088343],
            [31.32733737505311, 3.583334109040119],
            [31.32536208304958, 3.583049147569202],
            [31.320187361211627, 3.584350827039623],
            [31.31886130052856, 3.584352282153298],
            [31.317874027776803, 3.585246359872069],
            [31.317279573925745, 3.585213827398413],
            [31.314917901247146, 3.584816523372396],
            [31.31402861582825, 3.583463172290066],
            [31.312965336620312, 3.583146854597832],
            [31.310492573782124, 3.583613799553342],
            [31.307397774322066, 3.582036311125959],
            [31.30614670589723, 3.581751074006809],
            [31.305081901349954, 3.582267771587751],
            [31.30275194998066, 3.581650457489732],
            [31.302003115258156, 3.580501691773236],
            [31.300846648415884, 3.579823689965848],
            [31.298945270692258, 3.575875082262237],
            [31.29741191746918, 3.575966529334104],
            [31.297087993960876, 3.573466862476095],
            [31.296120580265086, 3.572081931777191],
            [31.296246695646158, 3.571563492693666],
            [31.298079432200606, 3.570309515991693],
            [31.29795902561318, 3.567731640797662],
            [31.29683421180827, 3.566865093269663],
            [31.29491048759362, 3.566562882846285],
            [31.29416085696375, 3.565854206043023],
            [31.294288505769003, 3.564502751035056],
            [31.292820189674178, 3.563274063458718],
            [31.292335356338924, 3.562173248931282],
            [31.29277518407843, 3.560345982706579],
            [31.292358416990584, 3.559849280911553],
            [31.29133400878328, 3.559408670838428],
            [31.289093157713797, 3.559709679501772],
            [31.28614832749884, 3.560829549321927],
            [31.28425179528786, 3.559738786142817],
            [31.28377966952061, 3.558383649749768],
            [31.281715956343675, 3.555308879102963],
            [31.27994911750354, 3.555954086650006],
            [31.279681163528995, 3.557117095722429],
            [31.27878757787486, 3.557802083435229],
            [31.278234132116534, 3.559346034693268],
            [31.277454987337997, 3.559745123184916],
            [31.27692651923613, 3.558065626184297],
            [31.276948235109796, 3.556596975176412],
            [31.274009315809437, 3.55455054961036],
            [31.272300860276232, 3.554432894060766],
            [31.27184816506857, 3.552848910852722],
            [31.2712036993107, 3.552294557913386],
            [31.268679103680626, 3.552060920156475],
            [31.267917313455047, 3.553337432361701],
            [31.266570117209973, 3.552934343207172],
            [31.266021830476312, 3.551712584293591],
            [31.263514909199458, 3.552184698817766],
            [31.26023170966814, 3.551529983883357],
            [31.259983330881976, 3.552368757849163],
            [31.258673756979306, 3.552156467906105],
            [31.257836841544865, 3.552994126842901],
            [31.25605070689238, 3.553810909764731],
            [31.255026520568965, 3.553274901601458],
            [31.254953413874514, 3.551767940647867],
            [31.25600120792362, 3.54984348388735],
            [31.255641031105384, 3.549556695539385],
            [31.25421687439328, 3.549706583290839],
            [31.251404269899957, 3.55120806137288],
            [31.25002221632694, 3.55074390179969],
            [31.24916911953925, 3.548949611119547],
            [31.24899528205707, 3.546511251796349],
            [31.249496444967566, 3.545687577460603],
            [31.25085279594369, 3.545546741089187],
            [31.251466129687078, 3.544901731591078],
            [31.2506065614361, 3.544166035323246],
            [31.25000124785156, 3.542927826581808],
            [31.250570987252544, 3.541028660651359],
            [31.2485782517628, 3.540558802553664],
            [31.247937384655977, 3.539768811823463],
            [31.248117636109303, 3.538801113840698],
            [31.24901147149509, 3.537906476360429],
            [31.249800201297727, 3.53597189050883],
            [31.250965349458887, 3.53453726289947],
            [31.25186223193013, 3.534265570460731],
            [31.251879231648573, 3.533734906409071],
            [31.25028119882671, 3.532332773818224],
            [31.25198220912284, 3.530601127699634],
            [31.254795794576463, 3.529304698197299],
            [31.254937801154895, 3.528803747724056],
            [31.257385477640465, 3.526987970239204],
            [31.258741683089504, 3.527129048825669],
            [31.259708102350267, 3.527767909163551],
            [31.26356313345884, 3.525852518433976],
            [31.266098011205695, 3.526198442264248],
            [31.269621966419674, 3.524226218957939],
            [31.273920096033716, 3.520205875241064],
            [31.27664754023811, 3.51878946954932],
            [31.279084406397548, 3.518662372516307],
            [31.278937689952098, 3.51294986343519],
            [31.279275604720933, 3.509435111768852],
            [31.280270199640594, 3.507734408004434],
            [31.281962262716497, 3.506637765045882],
            [31.28281378565578, 3.506626174266033],
            [31.28379366617105, 3.50806262379914],
            [31.28607004561004, 3.509725216587455],
            [31.28627762920422, 3.510831197007375],
            [31.288372346834876, 3.511545795989301],
            [31.29065239050189, 3.511207781263442],
            [31.292903983625564, 3.512106927565053],
            [31.29365411192209, 3.509908913727434],
            [31.295634357236086, 3.509058362714614],
            [31.297108865418167, 3.509152222049623],
            [31.297585965157147, 3.508400465716526],
            [31.298496640361265, 3.504953433230912],
            [31.298871086019457, 3.500875317653619],
            [31.301012669656817, 3.50122973473729],
            [31.305298139313567, 3.503440819521932],
            [31.30646400253368, 3.503558264543337],
            [31.307392813825064, 3.504224514419926],
            [31.307608011539607, 3.50493954614793],
            [31.308988899997715, 3.50542463632423],
            [31.309750426118583, 3.505818547524528],
            [31.310344428117034, 3.505340736432462],
            [31.312261334118684, 3.506541993835809],
            [31.31621184985377, 3.507465902447186],
            [31.318307243915807, 3.508702644894949],
            [31.31880671709526, 3.508630337845757],
            [31.319260334872705, 3.509678843757422],
            [31.322758216485568, 3.510174215820349],
            [31.322757003759953, 3.509387310591643],
            [31.323637850405046, 3.509791326939502],
            [31.324458365297346, 3.509635056807465],
            [31.32462569987521, 3.510159402596118],
            [31.32776739588467, 3.51108453063293],
            [31.329499698095425, 3.512484920805403],
            [31.330481451598082, 3.512367987086977],
            [31.3311481551508, 3.512748491675329],
            [31.33285971256668, 3.511887388139941],
            [31.3339565258842, 3.513483349369347],
            [31.334193869765418, 3.513125291245129],
            [31.334860256212856, 3.513291179807517],
            [31.335052644803994, 3.514626243004848],
            [31.33744579624675, 3.516065193468929],
            [31.34025522160228, 3.51746771461123],
            [31.341492133476564, 3.517346560215881],
            [31.34185024866119, 3.518156762843414],
            [31.34308845141453, 3.518870200468212],
            [31.344110736004495, 3.5184155396655],
            [31.34468248403842, 3.518915411716414],
            [31.345443622985403, 3.51881883211672],
            [31.34596827504393, 3.51962877434075],
            [31.347014533872198, 3.519293296395879],
            [31.34799071692178, 3.51979253675485],
            [31.348348580578158, 3.520435810811346],
            [31.349846516822836, 3.519885006144547],
            [31.350598434563416, 3.521493428345353],
            [31.352407524764665, 3.522134440851622],
            [31.352620625811284, 3.521490262383256],
            [31.353468632744555, 3.521812743943893],
            [31.35350342269888, 3.512296587709039],
            [31.356108219019216, 3.512875332182289],
            [31.357930279994825, 3.514406337452395],
            [31.35934898842473, 3.514714400137734],
            [31.359957769506266, 3.514409917679731],
            [31.36084359551297, 3.515098984310836],
            [31.360969023682834, 3.515837636461817],
            [31.361601547237324, 3.516449866747381],
            [31.363955757610828, 3.518032732172858],
            [31.36507075013474, 3.518111087108039],
            [31.36615738104853, 3.51992088621272],
            [31.36912274764916, 3.519849712464898],
            [31.36945133880369, 3.520736512048302],
            [31.37087117012767, 3.520247777895517],
            [31.37184371050879, 3.521214308084886],
            [31.373250221613745, 3.52072737369889],
            [31.373487764920956, 3.520182455517252],
            [31.375103011260297, 3.519709865628473],
            [31.37567323754814, 3.51993459016223],
            [31.37656610904165, 3.518691670530917],
            [31.3774983348294, 3.51883312964598],
            [31.378459896001097, 3.518107695185626],
            [31.378683929544753, 3.518365626506629],
            [31.380496895078114, 3.517439915711809],
            [31.38156774798225, 3.517605129246377],
            [31.381400219368285, 3.516985394981243],
            [31.382708827582004, 3.517054832188344],
            [31.382969690255667, 3.516529792700633],
            [31.387751516836136, 3.516450566114086],
            [31.389535215257563, 3.51606615644343],
            [31.390390612630654, 3.515397077194394],
            [31.39401784625456, 3.514854678103876],
            [31.396017735028853, 3.515757598371165],
            [31.39670536573445, 3.514325699396094],
            [31.397468515111033, 3.515469090523116],
            [31.399251988953615, 3.514941582629479],
            [31.40025255497496, 3.515774580441456],
            [31.401061363920814, 3.515725577215251],
            [31.401491148495435, 3.516678737158854],
            [31.403727542124486, 3.516698947954413],
            [31.405521496611506, 3.515301007409838],
            [31.40604590432829, 3.515920161781907],
            [31.406568224360356, 3.515251609643669],
            [31.40680724988778, 3.515942767477841],
            [31.408735138692073, 3.516440403778035],
            [31.40914153293334, 3.51763206738295],
            [31.409664854586932, 3.517583522428637],
            [31.41026196116302, 3.519013344307959],
            [31.413097146607655, 3.521488771305683],
            [31.413360643141733, 3.522585281142509],
            [31.420488020336396, 3.523730177415963],
            [31.424436019890376, 3.522889046324714],
            [31.4252676280781, 3.522219969285659],
            [31.426892213303134, 3.519105278491977],
            [31.428198424811704, 3.517696155290484],
            [31.43028973243751, 3.516285734336768],
            [31.432074236647733, 3.516378161933042],
            [31.43488449294491, 3.518114330191114],
            [31.4358384426912, 3.519495868214578],
            [31.437433335002844, 3.520017850348368],
            [31.438455932206494, 3.519753835912765],
            [31.439551173472264, 3.520252803452331],
            [31.43986322484579, 3.521921567458139],
            [31.438911764331124, 3.522042383233246],
            [31.438532207258977, 3.522710729656358],
            [31.439413831845126, 3.5235200650717],
            [31.439296256747458, 3.524354906725445],
            [31.440607209564067, 3.525807391804515],
            [31.440656451614696, 3.526808884165211],
            [31.44008612471555, 3.527215228638535],
            [31.440087702157182, 3.52816910486767],
            [31.44113529228868, 3.528620460475],
            [31.441923455254347, 3.530455367540528],
            [31.443709379701044, 3.531382439886322],
            [31.444139259497096, 3.532359450615141],
            [31.444817499214704, 3.532465635969029],
            [31.445794867142162, 3.533608667679028],
            [31.447676128891615, 3.53463095917315],
            [31.448200863595176, 3.535417032529576],
            [31.448748079536998, 3.535416127854467],
            [31.44950807043706, 3.534604056496728],
            [31.450080504783863, 3.535461593830536],
            [31.451175652624833, 3.535889018188861],
            [31.451840637700432, 3.535172496748788],
            [31.452144411996905, 3.531857237570922],
            [31.452761533037528, 3.530973865573424],
            [31.45846083327218, 3.531643957549996],
            [31.459078946052863, 3.531356753814906],
            [31.459387124789206, 3.530688514924439],
            [31.459195108998895, 3.52968724910451],
            [31.45833653158968, 3.528448639965915],
            [31.45904812575378, 3.527159692390833],
            [31.461547513758706, 3.527894750314899],
            [31.46278437802224, 3.527701891541498],
            [31.464542853547126, 3.526435019369557],
            [31.465470617402897, 3.526361914812494],
            [31.466304178528038, 3.526861297527548],
            [31.466711492644166, 3.528553772247515],
            [31.468116463138436, 3.529290659949688],
            [31.473169677952757, 3.527743955248697],
            [31.476479002289196, 3.529049941224685],
            [31.477930440836452, 3.52911900812757],
            [31.479640518727084, 3.527375241873336],
            [31.479496558312903, 3.526660063267185],
            [31.479948481867723, 3.526587744161858],
            [31.48035149125699, 3.525728549758533],
            [31.481278529274007, 3.525226175325781],
            [31.483408022485932, 3.525282154617024],
            [31.48519100405177, 3.524444448209813],
            [31.484589288219944, 3.520391402111978],
            [31.48515789574365, 3.51898342853123],
            [31.48729578730517, 3.517000417906976],
            [31.488175476021876, 3.516641191038863],
            [31.489445630053247, 3.515053153309462],
            [31.48968166149581, 3.513955754122946],
            [31.4889178680272, 3.512526214100014],
            [31.4891789337201, 3.512144208465593],
            [31.49029657537579, 3.511808414904972],
            [31.491272942580018, 3.512331383149424],
            [31.49317336539449, 3.509108128427196],
            [31.536670878413045, 3.576560222757618],
            [31.535535996290434, 3.579173256075966],
            [31.535799839574228, 3.57993457321936],
            [31.53764526213712, 3.580241889642016],
            [31.536852568967454, 3.584285982580762],
            [31.537737150807512, 3.585958873292829],
            [31.534998979820323, 3.588048657943287],
            [31.53580916678179, 3.589950543730732],
            [31.53550899742457, 3.59414946977423],
            [31.535062304759645, 3.594733542192707],
            [31.53366985678045, 3.595205173754258],
            [31.533788347261364, 3.596189892452585],
            [31.53472658906661, 3.597336959211587],
            [31.534849186645015, 3.598821333961923],
            [31.53579927004234, 3.599318875304033],
            [31.535880998766864, 3.600323925827341],
            [31.536636468446098, 3.601237298503857],
            [31.53636449810393, 3.601994375440644],
            [31.534929400810004, 3.60301306924109],
            [31.53475208594933, 3.604158787976879],
            [31.535510133793395, 3.610198583280714],
            [31.534556038520044, 3.611073605858495],
            [31.533170803114242, 3.613453790525171],
            [31.532762883533643, 3.615875546284807],
            [31.531371058086933, 3.617423424829466],
            [31.53110886590664, 3.621354021542152],
            [31.526786444050654, 3.622790957120648],
            [31.52570218918082, 3.62492174185916],
            [31.52471221160174, 3.625875960198313],
            [31.524431161987007, 3.627835441429662],
            [31.523625418991244, 3.628879422863237],
            [31.523926996906845, 3.630803102538891],
            [31.52347824979486, 3.631817293061485],
            [31.521759416025187, 3.633519075917707],
            [31.518037827855412, 3.634160022614747],
            [31.516926576814672, 3.634684540220452],
            [31.516891688943964, 3.63544262019404],
            [31.515954711966668, 3.636822172206505],
            [31.513323677653506, 3.637908270918268],
            [31.507355058903414, 3.638275256122596],
            [31.505717294494865, 3.638775051125197],
            [31.50297188757805, 3.640991847096789],
            [31.503565576962778, 3.641478124037523],
            [31.5030811829037, 3.648702273432267],
            [31.507404724958835, 3.662519552762755],
            [31.50905229088545, 3.669275672067575],
            [31.508571967092927, 3.67417042716797],
            [31.48970916431658, 3.680188981667602],
            [31.466852472448245, 3.691519784800987],
            [31.450369398487656, 3.699088974171457],
            [31.441519872739928, 3.70398803570915],
            [31.42940779523767, 3.711691498916583],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 628,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "KOCHI",
        Population: 41373,
        Key: "YUMBEKOCHI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.343829997206857, 3.436594681605314],
            [31.342046118224083, 3.437758118508369],
            [31.34153182463908, 3.438678369545769],
            [31.33872132579679, 3.439486843709862],
            [31.33608071723933, 3.439147145172128],
            [31.334862962836812, 3.440556617174932],
            [31.332749148819822, 3.439093314627215],
            [31.331654931633484, 3.438923854021819],
            [31.331375702903834, 3.436722117894301],
            [31.330185745071173, 3.436743909491732],
            [31.328463062020468, 3.435819642956217],
            [31.328800509665374, 3.434336811939107],
            [31.327146961857288, 3.432913534966701],
            [31.326309920658684, 3.432808193839035],
            [31.324375662799035, 3.433614960274551],
            [31.323060031556405, 3.433052406506523],
            [31.322673043620235, 3.431991614087978],
            [31.321319493591158, 3.431719169306378],
            [31.320067853837802, 3.432277847408468],
            [31.318014021230674, 3.430539623799562],
            [31.316277919146263, 3.430339203806654],
            [31.314312843682487, 3.431042026277655],
            [31.31378781073825, 3.430500225246107],
            [31.313976809985846, 3.429441036892655],
            [31.313353328873006, 3.429097125638312],
            [31.309067082173534, 3.429538803911633],
            [31.308810142442702, 3.430340849261713],
            [31.307834315125962, 3.430386934556249],
            [31.307918341741033, 3.431708529011157],
            [31.306661786406423, 3.432609929997468],
            [31.306111795568665, 3.433518119966585],
            [31.304907700948345, 3.434317447659067],
            [31.303837164251224, 3.434195869204111],
            [31.301049393683925, 3.435387074482493],
            [31.30104807226216, 3.435841669509814],
            [31.299950598682912, 3.436796711654727],
            [31.297334426996123, 3.436265543372411],
            [31.297240700372633, 3.435762923053941],
            [31.295856014735822, 3.436056835482751],
            [31.294350690746242, 3.438057420377238],
            [31.29319789621684, 3.438380557287495],
            [31.293028436225015, 3.439030669541927],
            [31.291473078769062, 3.440042521401085],
            [31.289789184972324, 3.440533804327667],
            [31.289129484685553, 3.440220416134705],
            [31.28791130627824, 3.440907659309353],
            [31.283977423748947, 3.439911924699697],
            [31.283732657986842, 3.439235052009323],
            [31.281910136175494, 3.437618732948009],
            [31.278129232247544, 3.437963108313453],
            [31.275962845226893, 3.437572888317832],
            [31.275030646388554, 3.438066605260042],
            [31.274865109339583, 3.438726852207999],
            [31.272671811487953, 3.439823775816814],
            [31.272396359275767, 3.44067648033633],
            [31.272715010571673, 3.441357318086818],
            [31.271554370156586, 3.442303639732755],
            [31.271661818546043, 3.442749855442702],
            [31.27097682170087, 3.442939663146261],
            [31.270573813209896, 3.442678306424838],
            [31.269478185668547, 3.442936930023201],
            [31.26812548454743, 3.441920931333727],
            [31.265963838834853, 3.442003856775438],
            [31.264319902101978, 3.442666881644435],
            [31.257892196630973, 3.449040299754393],
            [31.256045458036176, 3.448882055800341],
            [31.254091885499598, 3.445821806091334],
            [31.252825042658397, 3.444774771480801],
            [31.25190030163356, 3.445159934771716],
            [31.251010368529357, 3.446783259431839],
            [31.248596546851893, 3.448565578573464],
            [31.24681692408693, 3.451551497651439],
            [31.246486338672486, 3.451168081900715],
            [31.24124803407871, 3.445299904768485],
            [31.236418675839918, 3.43252930468083],
            [31.235148392451165, 3.43363773383232],
            [31.234719238493835, 3.435037121601644],
            [31.233808200370362, 3.435578357828076],
            [31.22738486610153, 3.433508993325704],
            [31.22257881375447, 3.433471447482719],
            [31.22150170677935, 3.4325857638344],
            [31.22184338099766, 3.431326948003421],
            [31.223380587094994, 3.430501143472659],
            [31.22603179128125, 3.427019929592455],
            [31.22796591439361, 3.42685207823104],
            [31.229730985349285, 3.425826654142958],
            [31.23007135072223, 3.426313064489044],
            [31.23203260115953, 3.426859633004582],
            [31.233057539372858, 3.426232879822522],
            [31.23464925164837, 3.426693033421071],
            [31.227989660459816, 3.41393617363467],
            [31.23138418910262, 3.40825600072555],
            [31.233091451673147, 3.407716223286282],
            [31.23460538331978, 3.404032810912296],
            [31.235060959424533, 3.403719322900808],
            [31.237847085176547, 3.404153074101218],
            [31.23796629251308, 3.401152888961707],
            [31.23924801594697, 3.400040804862558],
            [31.24095505753195, 3.399615303562047],
            [31.24576483429417, 3.400274534979161],
            [31.245235033092417, 3.401365521375805],
            [31.245103491887033, 3.405421108099992],
            [31.247646627846272, 3.404657298204042],
            [31.25299275452867, 3.403835017286874],
            [31.25759344840853, 3.400798373566696],
            [31.25977927946349, 3.400802338921549],
            [31.2620877862503, 3.401655131958821],
            [31.26367417600775, 3.403504981837082],
            [31.26464428914095, 3.402733002990817],
            [31.265549221415455, 3.401179596360924],
            [31.26586747835094, 3.399340761096513],
            [31.267234695348755, 3.39874420725114],
            [31.26765865345047, 3.397796521716206],
            [31.270544342180354, 3.395355712251189],
            [31.27059482031282, 3.394906534980345],
            [31.272584870738136, 3.393262797860532],
            [31.27397549873057, 3.393464967951938],
            [31.276586605715757, 3.391772412451288],
            [31.276902038347995, 3.3918258188006],
            [31.276900196801684, 3.39297003092249],
            [31.277850997952875, 3.393330660477827],
            [31.27799224096334, 3.393857289901145],
            [31.277433769130987, 3.397684391132196],
            [31.281394735866073, 3.399757452103505],
            [31.283167103836806, 3.401137344991351],
            [31.284692575241586, 3.40308304657234],
            [31.286489618136525, 3.40375860059853],
            [31.297718845750598, 3.403817305962083],
            [31.30142258978556, 3.396986371385073],
            [31.309504201492455, 3.387801331484224],
            [31.31232358736787, 3.383834632778582],
            [31.319710908259662, 3.376035874994209],
            [31.32516059901619, 3.371750765789194],
            [31.330123694841234, 3.367022095337139],
            [31.340765780890646, 3.360999340138676],
            [31.340471694924503, 3.359141360648191],
            [31.339512353489862, 3.357668928300773],
            [31.339806006468038, 3.357123135830159],
            [31.339015292286984, 3.354852560442861],
            [31.338180486096824, 3.353926635407781],
            [31.338643115773188, 3.352372586607673],
            [31.337975159968956, 3.351699083625332],
            [31.33830193113669, 3.350029751093027],
            [31.337418385054185, 3.349210950953349],
            [31.33861940474127, 3.347466092534068],
            [31.338361422964702, 3.346465385809618],
            [31.33875231947071, 3.345639743813645],
            [31.34031318719262, 3.343946292662137],
            [31.343127578435038, 3.343168252663426],
            [31.346458025757066, 3.344348129735689],
            [31.34715069601141, 3.344218832102258],
            [31.34542204904554, 3.342737243526086],
            [31.345033931927055, 3.341910275629121],
            [31.347500420032986, 3.342131901425833],
            [31.35978515463117, 3.345936265476862],
            [31.366885664113973, 3.34425204545082],
            [31.377705214144417, 3.344357066202351],
            [31.38211909527609, 3.344712318710587],
            [31.385665697018396, 3.346109898979403],
            [31.394016107116148, 3.347645866931422],
            [31.396946225621708, 3.348072942417981],
            [31.40035141277534, 3.347867981074553],
            [31.40412626654987, 3.345821260997511],
            [31.405284295562428, 3.342349006468027],
            [31.407540720723993, 3.339878670162816],
            [31.416770100886264, 3.333576991714602],
            [31.422016609793538, 3.328374193388407],
            [31.42369332874605, 3.328061054097389],
            [31.427579355325214, 3.321908504298268],
            [31.430829012662144, 3.320650354805949],
            [31.431406956376613, 3.319545851150187],
            [31.432674074102298, 3.313231152811566],
            [31.433759890244083, 3.31188516001561],
            [31.441307631381, 3.363282362717672],
            [31.444369424042577, 3.388707333580186],
            [31.443906485345746, 3.389290634366028],
            [31.444942991164954, 3.389873211128159],
            [31.443486438508756, 3.390748357058773],
            [31.442296606440227, 3.390722458232943],
            [31.44122359937605, 3.391486363452894],
            [31.441507336750135, 3.392156810584024],
            [31.440671778670072, 3.393112539138579],
            [31.44078905552704, 3.393734849040937],
            [31.44171579799834, 3.394238875029719],
            [31.44209315240141, 3.395483744069207],
            [31.44025695463818, 3.396844580233457],
            [31.44037041545181, 3.398854701170315],
            [31.43885128525464, 3.397416501902025],
            [31.43797056167871, 3.39748681500813],
            [31.436943361507534, 3.398896841444761],
            [31.437274360147004, 3.399687006446184],
            [31.438464002671022, 3.399784707446048],
            [31.437734898545393, 3.400967905475677],
            [31.433284251165787, 3.401104035842129],
            [31.431714703921585, 3.400694639446934],
            [31.431996184727655, 3.402178631728177],
            [31.431661361061707, 3.402776260423195],
            [31.430041968098998, 3.403180315003605],
            [31.42990115268665, 3.402462249208255],
            [31.42949625773357, 3.402581208745316],
            [31.427395676799062, 3.404874736315263],
            [31.427298033520955, 3.405759887791789],
            [31.428081324922832, 3.406502965357616],
            [31.430866634106252, 3.406172651939699],
            [31.43176581267135, 3.408040519138875],
            [31.431096822007927, 3.40899650096769],
            [31.43062065651683, 3.409067482186011],
            [31.42955257850863, 3.408036801310347],
            [31.42893408933383, 3.407940048987602],
            [31.4260628571918, 3.409215350441215],
            [31.423659440700284, 3.409139515258239],
            [31.42327621131524, 3.410024186650987],
            [31.424055920235784, 3.4120593479694],
            [31.423555293619494, 3.412369560226052],
            [31.423221850664152, 3.412464701589527],
            [31.42198752414125, 3.411314093864362],
            [31.419085208493755, 3.4109263487267],
            [31.415245515220356, 3.413862920484425],
            [31.4125672510828, 3.414205317264257],
            [31.412109086931707, 3.416358002671747],
            [31.408827604080912, 3.415395313528985],
            [31.40747097732197, 3.41544085792386],
            [31.40317519231082, 3.419764358028428],
            [31.40236672472476, 3.419523701931981],
            [31.401228094830792, 3.418205749262079],
            [31.400501549107094, 3.418455734235078],
            [31.39997061782472, 3.421086827996684],
            [31.395480617947467, 3.418279622609107],
            [31.39436814609624, 3.416124248664174],
            [31.393369167398006, 3.415931117775886],
            [31.39230053692589, 3.41511575483007],
            [31.391181429219678, 3.41532917058144],
            [31.39055999806232, 3.416285182821496],
            [31.390673741845266, 3.418151695152531],
            [31.389721077588153, 3.418413254961759],
            [31.387700538342088, 3.417596235197156],
            [31.387377484402972, 3.418229748102092],
            [31.38792247611618, 3.419068144147575],
            [31.387849471829664, 3.419642264802748],
            [31.386894987585766, 3.420549849242926],
            [31.384873096375202, 3.420211367992395],
            [31.383325017967998, 3.420639369186822],
            [31.380804794438394, 3.419797540990989],
            [31.377256059197283, 3.420796305032441],
            [31.376276016086937, 3.422325930504805],
            [31.37627412243832, 3.422995883583375],
            [31.377956202536478, 3.425678643180767],
            [31.37647808761852, 3.426609218907313],
            [31.374826315779732, 3.425828702228599],
            [31.373849043972026, 3.426377317311796],
            [31.37153975295598, 3.426684330858468],
            [31.3707548221287, 3.426539396638578],
            [31.369401321506967, 3.42548423550864],
            [31.367997109190817, 3.425529635053827],
            [31.366330304944064, 3.42586168142793],
            [31.364731698997048, 3.427318417924397],
            [31.36427960116909, 3.427293692978126],
            [31.364357725852695, 3.42492507100738],
            [31.364001094684905, 3.424804814903347],
            [31.362857164730762, 3.425377041855489],
            [31.36157666480229, 3.427946927046325],
            [31.359100386856387, 3.428397171201736],
            [31.356192613943527, 3.429947278747069],
            [31.3550511956789, 3.42963421437614],
            [31.353840369982166, 3.428627140799996],
            [31.347071096294073, 3.428196421667987],
            [31.346546788290297, 3.428458690719991],
            [31.34642601698685, 3.429080561667857],
            [31.34661462007739, 3.429702989065939],
            [31.347991747289424, 3.430806062785257],
            [31.348037564962176, 3.431428241569237],
            [31.346005562314755, 3.434630792059652],
            [31.343829997206857, 3.436594681605314],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 629,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "KULULU",
        Population: 37043,
        Key: "YUMBEKULULU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.22912969082733, 3.463065823913427],
            [31.22634816265296, 3.463978688745883],
            [31.21868156092922, 3.465042042242619],
            [31.21172184979078, 3.467427846777346],
            [31.206882222909968, 3.468420550473092],
            [31.20180130854385, 3.471305232460771],
            [31.201314027299475, 3.478819370567198],
            [31.200339223163827, 3.480087086391411],
            [31.200398353869108, 3.503062799311526],
            [31.198300248691528, 3.501770718770971],
            [31.198301823438207, 3.499993529361647],
            [31.197316297909673, 3.499290016582262],
            [31.19520348192099, 3.498962791188772],
            [31.19405190191386, 3.499362104676368],
            [31.191774828975483, 3.497783810094195],
            [31.1914077773504, 3.496281761610804],
            [31.19158882471108, 3.494293633206722],
            [31.19078873122013, 3.493502130080186],
            [31.190814816499344, 3.49239469096972],
            [31.18982143610196, 3.491108725214433],
            [31.189872113660414, 3.490406608130697],
            [31.18790783500226, 3.488694747775858],
            [31.185352476565285, 3.485594731203925],
            [31.18335199130962, 3.48541028507667],
            [31.182032436225835, 3.486262414136065],
            [31.18136621776335, 3.48557567911006],
            [31.181318458831267, 3.483721038238646],
            [31.178910351337336, 3.483680248491947],
            [31.17747467552835, 3.482618127375714],
            [31.175665321222457, 3.482734986796058],
            [31.1746720656909, 3.482131162157605],
            [31.17277938276088, 3.481970985165709],
            [31.17134711336349, 3.479151346304532],
            [31.17127720287481, 3.478127997067249],
            [31.170595224368988, 3.477645155962589],
            [31.16969661443745, 3.477667480133085],
            [31.168887265604134, 3.476265233013411],
            [31.168797415211085, 3.475263495610551],
            [31.169804806631937, 3.472846931020436],
            [31.16820480919456, 3.471743823619855],
            [31.167432523951557, 3.470669156334043],
            [31.166871887179365, 3.470614404905921],
            [31.16446591767579, 3.472058482735951],
            [31.161664919415966, 3.470657904050979],
            [31.158219658417483, 3.471026770659152],
            [31.156484720549674, 3.47067459731365],
            [31.155095552319587, 3.471020649111044],
            [31.15338841551322, 3.470105118107965],
            [31.151976618721143, 3.46835847132837],
            [31.151015621691418, 3.468222440218938],
            [31.149812849391196, 3.468837140496721],
            [31.14595845159491, 3.46548848308964],
            [31.145565850086516, 3.463959139458141],
            [31.145992942410235, 3.462449221623821],
            [31.145754062409882, 3.460410572099639],
            [31.144405407300788, 3.456073201664313],
            [31.14506593942751, 3.455506348127922],
            [31.145557334955928, 3.454278951890895],
            [31.145898394726597, 3.452301193036726],
            [31.14664102388712, 3.452403121915422],
            [31.148757192388462, 3.451388174389633],
            [31.15182965523896, 3.45079133734294],
            [31.152216353019305, 3.450275368538688],
            [31.163420009190492, 3.447119069887975],
            [31.1671202830335, 3.448284420023483],
            [31.17127304367505, 3.450292952570616],
            [31.17500600361798, 3.452651630058589],
            [31.174315257554984, 3.448543996174962],
            [31.17450117737776, 3.446335467436954],
            [31.172172774704027, 3.442699592150601],
            [31.17170342562934, 3.439767187967098],
            [31.171821767888233, 3.436765078779077],
            [31.174875977870503, 3.432548956838973],
            [31.177887472960997, 3.431879802240351],
            [31.18166852511097, 3.432087015340591],
            [31.184030034296196, 3.43309142206248],
            [31.187988174931373, 3.431749108474554],
            [31.18985359758577, 3.431977637159397],
            [31.190401430670203, 3.431703706534494],
            [31.190925233820813, 3.430979774317516],
            [31.19058150785039, 3.428554366717688],
            [31.191804379056773, 3.426506893615277],
            [31.192157597524783, 3.423882824335023],
            [31.19372790204877, 3.422285957716673],
            [31.195270559123262, 3.422163889023473],
            [31.195246664835032, 3.421638896351412],
            [31.19768641728148, 3.42071859663025],
            [31.200248925409788, 3.420673436279903],
            [31.202790054532677, 3.41875340294648],
            [31.205452727510146, 3.418358448518317],
            [31.206201293636425, 3.417159964007102],
            [31.206972274525636, 3.417286400353929],
            [31.20769735240217, 3.415337936017524],
            [31.209466087585877, 3.41404136798228],
            [31.213222127045103, 3.414323368764567],
            [31.213846292674194, 3.413124639790808],
            [31.214443223180485, 3.413200747262848],
            [31.21516615767674, 3.412402165954956],
            [31.214348562309112, 3.410575800451822],
            [31.21472399072423, 3.409351606080009],
            [31.215670266163052, 3.408853412227606],
            [31.215951513407145, 3.406627724431862],
            [31.217165732939016, 3.406198232012275],
            [31.219164210460033, 3.406201947157709],
            [31.221065009668592, 3.405494437218528],
            [31.221290257734527, 3.404579514067974],
            [31.223119683997165, 3.404238971886176],
            [31.22366578063814, 3.404608036353372],
            [31.227989660459816, 3.41393617363467],
            [31.23464925164837, 3.426693033421071],
            [31.233057539372858, 3.426232879822522],
            [31.23203260115953, 3.426859633004582],
            [31.23007135072223, 3.426313064489044],
            [31.229730985349285, 3.425826654142958],
            [31.22796591439361, 3.42685207823104],
            [31.22603179128125, 3.427019929592455],
            [31.223380587094994, 3.430501143472659],
            [31.22184338099766, 3.431326948003421],
            [31.22150170677935, 3.4325857638344],
            [31.22257881375447, 3.433471447482719],
            [31.22738486610153, 3.433508993325704],
            [31.233808200370362, 3.435578357828076],
            [31.234719238493835, 3.435037121601644],
            [31.235148392451165, 3.43363773383232],
            [31.236418675839918, 3.43252930468083],
            [31.24124803407871, 3.445299904768485],
            [31.246486338672486, 3.451168081900715],
            [31.241065861128963, 3.457523871655129],
            [31.239053237837183, 3.457722124926572],
            [31.237433009441304, 3.457253721612983],
            [31.23560078402824, 3.458716246584824],
            [31.230735405143168, 3.460340361358051],
            [31.228926407468425, 3.461813474001588],
            [31.2297811086472, 3.462636286046965],
            [31.22912969082733, 3.463065823913427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 630,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "KURU",
        Population: 40879,
        Key: "YUMBEKURU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.14595845159491, 3.46548848308964],
            [31.144443022456684, 3.465501565542994],
            [31.143642115990392, 3.465922548752994],
            [31.142618764201877, 3.464694074756058],
            [31.141788676861907, 3.464300797321841],
            [31.1409357597373, 3.465092704267945],
            [31.13862078597875, 3.463449426742434],
            [31.13803829139908, 3.462335193187691],
            [31.13678896750254, 3.46127117400677],
            [31.13585477979416, 3.461660968215541],
            [31.134481605169395, 3.460988343331659],
            [31.134035826989443, 3.46226583532732],
            [31.133709778965475, 3.462275105160316],
            [31.13199991307729, 3.460684550053617],
            [31.13078952755503, 3.460692460539522],
            [31.12860856447058, 3.458729944253525],
            [31.12773679440312, 3.458676684208622],
            [31.12805289089035, 3.455844697593427],
            [31.126061408550463, 3.453595543630857],
            [31.126413428665884, 3.453200765922708],
            [31.126538325033096, 3.451642597337288],
            [31.124971764687242, 3.450617768408495],
            [31.12439776637349, 3.450953581993633],
            [31.1234140419671, 3.450603810583584],
            [31.122193504583848, 3.449655751341903],
            [31.12142820733543, 3.448505127411922],
            [31.122685556780713, 3.44850512292847],
            [31.122775143967377, 3.448214210178312],
            [31.1219424586996, 3.447657477369474],
            [31.12099414228844, 3.447603230345025],
            [31.120496997542237, 3.4482714296916],
            [31.120041704406766, 3.448276835828899],
            [31.115411895230245, 3.445600370863533],
            [31.113167238897223, 3.445476475003414],
            [31.112532576454047, 3.44588657857802],
            [31.11087415798047, 3.4451023268037],
            [31.111378379654507, 3.443752610883533],
            [31.109887003806325, 3.442381273747283],
            [31.108913186919228, 3.442293809270754],
            [31.108035866161604, 3.441227777872984],
            [31.10784897705663, 3.440096605657519],
            [31.10576928554572, 3.439759869126965],
            [31.104542039543908, 3.438721645980085],
            [31.103511023329396, 3.438871627656529],
            [31.10256215625098, 3.437902313939938],
            [31.101738975158895, 3.436504103255595],
            [31.10108757261041, 3.436679974797827],
            [31.09971875930635, 3.436118463008486],
            [31.099056628178392, 3.434863302306387],
            [31.098216716862495, 3.434343734478567],
            [31.09737315658989, 3.43460091037076],
            [31.097386251331784, 3.433722526032319],
            [31.09641044647294, 3.433423967067312],
            [31.09686675380633, 3.432329720833256],
            [31.095913608950536, 3.430714909098253],
            [31.09579546791426, 3.428254926467805],
            [31.095170960925373, 3.426807494753858],
            [31.093810650175477, 3.424209064176582],
            [31.092459734006823, 3.423081556401872],
            [31.09042308437444, 3.420370531348378],
            [31.0901589976472, 3.41534494298601],
            [31.088923701842134, 3.407981814929621],
            [31.089776075485993, 3.407439162429239],
            [31.088668304518645, 3.406958373069739],
            [31.087391634108233, 3.402564127799884],
            [31.087396405060684, 3.400146370183398],
            [31.085214947902823, 3.3971381315384],
            [31.082010412942633, 3.395300104604011],
            [31.080388736462496, 3.393512584853566],
            [31.08135608368293, 3.392919513934817],
            [31.082513959981885, 3.393778598290166],
            [31.083500989290197, 3.393635909927589],
            [31.08406141765323, 3.391285659121113],
            [31.084826196573747, 3.391691072591958],
            [31.085135987785986, 3.392099819977493],
            [31.084872512811465, 3.392435401188149],
            [31.085492993551263, 3.392796752819313],
            [31.08857354213763, 3.393571124046909],
            [31.089718657867984, 3.394437677660977],
            [31.091775401016637, 3.393409425657995],
            [31.092826273592195, 3.393603571688942],
            [31.09459065823499, 3.395455669883085],
            [31.097980670148555, 3.39713357163197],
            [31.1026523758516, 3.397158718820596],
            [31.103469128599496, 3.396093654148212],
            [31.106039759294625, 3.394461497745688],
            [31.110632682747262, 3.393875175376316],
            [31.112115105985303, 3.393257923179958],
            [31.11369022637753, 3.393601716333799],
            [31.115554878277415, 3.392442820824144],
            [31.116542072875728, 3.392671592906324],
            [31.117163918156447, 3.392134066532159],
            [31.12032457221166, 3.392026825222167],
            [31.121145585668945, 3.39063903515181],
            [31.121063178716344, 3.389476321342443],
            [31.11892293177217, 3.387232105125173],
            [31.1170699597676, 3.383400576529008],
            [31.11767880732446, 3.381238689546679],
            [31.11510763404691, 3.379235006569682],
            [31.120422444560155, 3.379020721954004],
            [31.12225737929213, 3.379320717353751],
            [31.125511590189245, 3.378436107518647],
            [31.126398004592453, 3.378972878357854],
            [31.126986094778044, 3.380816983995336],
            [31.13431732306687, 3.383447007526348],
            [31.136449027931015, 3.382499914100726],
            [31.13753635054757, 3.381442740843372],
            [31.144254268449163, 3.383976340646442],
            [31.14656414067524, 3.382896895524087],
            [31.15431476452242, 3.383239437805932],
            [31.155895789541006, 3.382889563696399],
            [31.15669736345554, 3.383496059719947],
            [31.158955066919773, 3.383475163665142],
            [31.16018228327718, 3.38451098581525],
            [31.1619636613502, 3.384337933971436],
            [31.163840687543107, 3.385081975883586],
            [31.163859174871675, 3.384754059320202],
            [31.16467300539994, 3.384692710977742],
            [31.166647412562895, 3.383173602928818],
            [31.167931490481177, 3.382918077654622],
            [31.16877997262321, 3.382223181394645],
            [31.169551629943843, 3.38142495109085],
            [31.17029988794798, 3.379414240643959],
            [31.17196991085837, 3.378695096340267],
            [31.1723569194558, 3.377663967870193],
            [31.17333355884955, 3.377072490645843],
            [31.174668877569932, 3.376868641096927],
            [31.175262027965537, 3.375425149685882],
            [31.177594985996052, 3.372830688724049],
            [31.17752788633589, 3.373524885958617],
            [31.17807414557197, 3.374025782012648],
            [31.179459539081225, 3.378027321187475],
            [31.179901274842432, 3.381227301699441],
            [31.17954580609462, 3.38199741454535],
            [31.181774157106926, 3.390442840364531],
            [31.191624733067922, 3.394917097666946],
            [31.19410279506799, 3.395613796221343],
            [31.200982196820014, 3.399778971036721],
            [31.20581065315025, 3.405509053004063],
            [31.206105553888367, 3.405017258017128],
            [31.207771479582757, 3.405020373255135],
            [31.208929138489417, 3.40431356010376],
            [31.209867966894535, 3.40535908493653],
            [31.210672624725433, 3.404769771424515],
            [31.211337321441828, 3.405676929619528],
            [31.212512801127072, 3.405935143542931],
            [31.213003252526107, 3.405680036784872],
            [31.213766313867815, 3.406390439432689],
            [31.214511484362294, 3.406175195061318],
            [31.215951513407145, 3.406627724431862],
            [31.215670266163052, 3.408853412227606],
            [31.21472399072423, 3.409351606080009],
            [31.214348562309112, 3.410575800451822],
            [31.21516615767674, 3.412402165954956],
            [31.214443223180485, 3.413200747262848],
            [31.213846292674194, 3.413124639790808],
            [31.213222127045103, 3.414323368764567],
            [31.209466087585877, 3.41404136798228],
            [31.20769735240217, 3.415337936017524],
            [31.206972274525636, 3.417286400353929],
            [31.206201293636425, 3.417159964007102],
            [31.205452727510146, 3.418358448518317],
            [31.202790054532677, 3.41875340294648],
            [31.200248925409788, 3.420673436279903],
            [31.19768641728148, 3.42071859663025],
            [31.195246664835032, 3.421638896351412],
            [31.195270559123262, 3.422163889023473],
            [31.19372790204877, 3.422285957716673],
            [31.192157597524783, 3.423882824335023],
            [31.191804379056773, 3.426506893615277],
            [31.19058150785039, 3.428554366717688],
            [31.190925233820813, 3.430979774317516],
            [31.190401430670203, 3.431703706534494],
            [31.18985359758577, 3.431977637159397],
            [31.187988174931373, 3.431749108474554],
            [31.184030034296196, 3.43309142206248],
            [31.18166852511097, 3.432087015340591],
            [31.177887472960997, 3.431879802240351],
            [31.174875977870503, 3.432548956838973],
            [31.171821767888233, 3.436765078779077],
            [31.17170342562934, 3.439767187967098],
            [31.172172774704027, 3.442699592150601],
            [31.17450117737776, 3.446335467436954],
            [31.174315257554984, 3.448543996174962],
            [31.17500600361798, 3.452651630058589],
            [31.17127304367505, 3.450292952570616],
            [31.1671202830335, 3.448284420023483],
            [31.163420009190492, 3.447119069887975],
            [31.152216353019305, 3.450275368538688],
            [31.15182965523896, 3.45079133734294],
            [31.148757192388462, 3.451388174389633],
            [31.14664102388712, 3.452403121915422],
            [31.145898394726597, 3.452301193036726],
            [31.145557334955928, 3.454278951890895],
            [31.14506593942751, 3.455506348127922],
            [31.144405407300788, 3.456073201664313],
            [31.145754062409882, 3.460410572099639],
            [31.145992942410235, 3.462449221623821],
            [31.145565850086516, 3.463959139458141],
            [31.14595845159491, 3.46548848308964],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 631,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "LODONGA",
        Population: 32600,
        Key: "YUMBELODONGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.42940779523767, 3.711691498916583],
            [31.429626477517154, 3.711943105549324],
            [31.41528612535938, 3.720141139124533],
            [31.406226091102923, 3.723626467413999],
            [31.385196922865454, 3.734619438811166],
            [31.361760762841648, 3.745799450846596],
            [31.358899868511916, 3.744223198513287],
            [31.35725855396137, 3.742213640770103],
            [31.354335568977493, 3.737883953128712],
            [31.35255599382325, 3.734384458060944],
            [31.35129597548323, 3.722421597156054],
            [31.34948269104793, 3.71243579002655],
            [31.34666104231633, 3.702908123895994],
            [31.34539234894561, 3.695591464995406],
            [31.346539886533964, 3.693272307054811],
            [31.347329919792053, 3.690209713311889],
            [31.348615347878173, 3.674820635820413],
            [31.34798591452827, 3.672941421255078],
            [31.34707633077722, 3.672900233830506],
            [31.347018636478104, 3.66998625906052],
            [31.325490787375287, 3.671084090993685],
            [31.323397652576187, 3.672482721576751],
            [31.321810633998005, 3.671859234131893],
            [31.300709720912078, 3.672355350129742],
            [31.299517340323078, 3.673012202947824],
            [31.295092412608334, 3.673519283023968],
            [31.292644581612556, 3.675573450983737],
            [31.290504016664734, 3.676196469670523],
            [31.289374878370058, 3.676949200301165],
            [31.288946354131728, 3.676782888790919],
            [31.28756362053405, 3.678352764795528],
            [31.285845548535715, 3.678809846026422],
            [31.28408324079784, 3.678352850856125],
            [31.28276912680974, 3.679646285308836],
            [31.28240570168344, 3.678544004897985],
            [31.281482186858977, 3.677980629674405],
            [31.280862230735316, 3.676100268910302],
            [31.27660578295046, 3.675595234246901],
            [31.271426433890458, 3.674224411626728],
            [31.270154615280866, 3.675885093506909],
            [31.26744165910537, 3.677802153323296],
            [31.263999552990192, 3.678724205001415],
            [31.26374052647297, 3.67924208332202],
            [31.262730354766298, 3.679024113502245],
            [31.261697550006033, 3.679389280872162],
            [31.256833794376718, 3.681604468477788],
            [31.25556648710648, 3.680932401856622],
            [31.251589151270284, 3.680665382513552],
            [31.24928427457554, 3.682799159396598],
            [31.249232387884724, 3.683303041611695],
            [31.2502352841359, 3.691116057950178],
            [31.250279316856187, 3.69537198687694],
            [31.248913030513, 3.696830556909352],
            [31.246528935884946, 3.698221216173617],
            [31.24482482909602, 3.699812555500516],
            [31.242555806859198, 3.700349107874055],
            [31.240880436277923, 3.701741152893397],
            [31.239036371069414, 3.70242092660042],
            [31.23614055293636, 3.704522448443796],
            [31.235148321484264, 3.704520462833033],
            [31.23447002517277, 3.703465452065489],
            [31.230420196191446, 3.701378515504964],
            [31.228916213386594, 3.702115900150961],
            [31.22837808659877, 3.701858527503288],
            [31.226567533041948, 3.699946934991619],
            [31.224103143400544, 3.698945289462428],
            [31.22237799447441, 3.696863004670239],
            [31.214326175393914, 3.694464825436951],
            [31.21353975515988, 3.693838586948322],
            [31.210575759388348, 3.693770128715143],
            [31.206018093912324, 3.692511597482435],
            [31.204548247088248, 3.691592464597067],
            [31.203159095926136, 3.69177703853195],
            [31.201339313078073, 3.689649541330049],
            [31.196152599629364, 3.688642581650147],
            [31.19441449699685, 3.687924190653303],
            [31.193494024766252, 3.686890672403859],
            [31.192812786472206, 3.665563380657038],
            [31.1915402483121, 3.657568259786911],
            [31.191509782847536, 3.65054114112947],
            [31.19006806317335, 3.635880824037652],
            [31.190199883754754, 3.619453224355795],
            [31.18987769579158, 3.617221920845945],
            [31.188245737194702, 3.613279721257751],
            [31.1873238312529, 3.608987753323364],
            [31.18751031521769, 3.608050147027919],
            [31.190173341233052, 3.603751970062807],
            [31.19027548956233, 3.602294704870626],
            [31.188603079828223, 3.597445402633145],
            [31.189686360924266, 3.596903463325454],
            [31.191821594370875, 3.593912247514441],
            [31.19378178389784, 3.592447359357705],
            [31.194274786512267, 3.591657489419689],
            [31.19465637557361, 3.588805562931983],
            [31.193763499588552, 3.587091773885728],
            [31.189543330266414, 3.574279197280456],
            [31.18834641947342, 3.572300026000271],
            [31.18552311514677, 3.569509535133689],
            [31.185727360601327, 3.56659500803991],
            [31.18516386718653, 3.565076534415574],
            [31.18510329468525, 3.563427508396475],
            [31.18378583177777, 3.560386520741065],
            [31.183503253230413, 3.557402816578211],
            [31.184448028482713, 3.555516190474092],
            [31.183912796965064, 3.553786474159291],
            [31.18496377823677, 3.553644000059928],
            [31.184456526545286, 3.551149845758156],
            [31.18536209303041, 3.548862219341463],
            [31.185619912211873, 3.546796244313851],
            [31.18605882995802, 3.546311233997911],
            [31.185922365086586, 3.544872443369597],
            [31.187167006065554, 3.535872373609431],
            [31.187997400629367, 3.536714977720486],
            [31.189711522735365, 3.540962053113407],
            [31.190529617566316, 3.542034886764269],
            [31.19166760067328, 3.542046390132829],
            [31.192476893811072, 3.543430276605124],
            [31.194503194851357, 3.545315083999748],
            [31.19921471209117, 3.546615967802244],
            [31.19876549695693, 3.545640679226556],
            [31.198612352167324, 3.543193021523401],
            [31.19895357183807, 3.541698080083855],
            [31.200896768833143, 3.536991271710683],
            [31.201602813205408, 3.536369476522824],
            [31.201972663980953, 3.534642312900358],
            [31.20026775858974, 3.526906015249914],
            [31.20072512054529, 3.523649420916585],
            [31.201997848249945, 3.521555770269927],
            [31.20411516839144, 3.520086920611736],
            [31.206146059822856, 3.519580980858809],
            [31.20815558213029, 3.515505912217401],
            [31.20925684660002, 3.514601601039987],
            [31.20930443754712, 3.514141750276649],
            [31.209950170827856, 3.514584815309331],
            [31.210717412928886, 3.514342124687742],
            [31.212079929941126, 3.515241935955268],
            [31.21520928220027, 3.515367042050471],
            [31.216841580360317, 3.515895923332236],
            [31.218340534396212, 3.517104634236075],
            [31.22342150086463, 3.519001195983196],
            [31.22468831945135, 3.519922508199427],
            [31.225262642955183, 3.519793426202656],
            [31.226356597833473, 3.520440374607781],
            [31.22662697546262, 3.521175826973618],
            [31.228141251164008, 3.521655126414727],
            [31.22843791170177, 3.522273437329757],
            [31.22943929608833, 3.522224005861721],
            [31.233396953429907, 3.524308622491567],
            [31.234684025433015, 3.52426523074002],
            [31.237491432274098, 3.525548685179986],
            [31.238187769451432, 3.525280930736913],
            [31.238715111065936, 3.526257219830886],
            [31.2383213669005, 3.526860931709082],
            [31.238843601592606, 3.528649230968106],
            [31.23975518589178, 3.528338956467377],
            [31.244935833017358, 3.528895773291729],
            [31.246238204228067, 3.52812295531554],
            [31.24955350954765, 3.529040482866483],
            [31.251518071175113, 3.530003265051183],
            [31.25198220912284, 3.530601127699634],
            [31.25028119882671, 3.532332773818224],
            [31.251879231648573, 3.533734906409071],
            [31.25186223193013, 3.534265570460731],
            [31.250965349458887, 3.53453726289947],
            [31.249800201297727, 3.53597189050883],
            [31.24901147149509, 3.537906476360429],
            [31.248117636109303, 3.538801113840698],
            [31.247937384655977, 3.539768811823463],
            [31.2485782517628, 3.540558802553664],
            [31.250570987252544, 3.541028660651359],
            [31.25000124785156, 3.542927826581808],
            [31.2506065614361, 3.544166035323246],
            [31.251466129687078, 3.544901731591078],
            [31.25085279594369, 3.545546741089187],
            [31.249496444967566, 3.545687577460603],
            [31.24899528205707, 3.546511251796349],
            [31.24916911953925, 3.548949611119547],
            [31.25002221632694, 3.55074390179969],
            [31.251404269899957, 3.55120806137288],
            [31.25421687439328, 3.549706583290839],
            [31.255641031105384, 3.549556695539385],
            [31.25600120792362, 3.54984348388735],
            [31.254953413874514, 3.551767940647867],
            [31.255026520568965, 3.553274901601458],
            [31.25605070689238, 3.553810909764731],
            [31.257836841544865, 3.552994126842901],
            [31.258673756979306, 3.552156467906105],
            [31.259983330881976, 3.552368757849163],
            [31.26023170966814, 3.551529983883357],
            [31.263514909199458, 3.552184698817766],
            [31.266021830476312, 3.551712584293591],
            [31.266570117209973, 3.552934343207172],
            [31.267917313455047, 3.553337432361701],
            [31.268679103680626, 3.552060920156475],
            [31.2712036993107, 3.552294557913386],
            [31.27184816506857, 3.552848910852722],
            [31.272300860276232, 3.554432894060766],
            [31.274009315809437, 3.55455054961036],
            [31.276948235109796, 3.556596975176412],
            [31.27692651923613, 3.558065626184297],
            [31.277454987337997, 3.559745123184916],
            [31.278234132116534, 3.559346034693268],
            [31.27878757787486, 3.557802083435229],
            [31.279681163528995, 3.557117095722429],
            [31.27994911750354, 3.555954086650006],
            [31.281715956343675, 3.555308879102963],
            [31.28377966952061, 3.558383649749768],
            [31.28425179528786, 3.559738786142817],
            [31.28614832749884, 3.560829549321927],
            [31.289093157713797, 3.559709679501772],
            [31.29133400878328, 3.559408670838428],
            [31.292358416990584, 3.559849280911553],
            [31.29277518407843, 3.560345982706579],
            [31.292335356338924, 3.562173248931282],
            [31.292820189674178, 3.563274063458718],
            [31.294288505769003, 3.564502751035056],
            [31.29416085696375, 3.565854206043023],
            [31.29491048759362, 3.566562882846285],
            [31.29683421180827, 3.566865093269663],
            [31.29795902561318, 3.567731640797662],
            [31.298079432200606, 3.570309515991693],
            [31.296246695646158, 3.571563492693666],
            [31.296120580265086, 3.572081931777191],
            [31.297087993960876, 3.573466862476095],
            [31.29741191746918, 3.575966529334104],
            [31.298945270692258, 3.575875082262237],
            [31.300846648415884, 3.579823689965848],
            [31.302003115258156, 3.580501691773236],
            [31.30275194998066, 3.581650457489732],
            [31.305081901349954, 3.582267771587751],
            [31.30614670589723, 3.581751074006809],
            [31.307397774322066, 3.582036311125959],
            [31.310492573782124, 3.583613799553342],
            [31.312965336620312, 3.583146854597832],
            [31.31402861582825, 3.583463172290066],
            [31.314917901247146, 3.584816523372396],
            [31.317279573925745, 3.585213827398413],
            [31.317874027776803, 3.585246359872069],
            [31.31886130052856, 3.584352282153298],
            [31.320187361211627, 3.584350827039623],
            [31.32536208304958, 3.583049147569202],
            [31.32733737505311, 3.583334109040119],
            [31.328477049687777, 3.58114804088343],
            [31.33154272935955, 3.580684763400122],
            [31.33338179813847, 3.578875076172396],
            [31.334829013705573, 3.578674531056021],
            [31.33681916204727, 3.579350240306089],
            [31.343495155574594, 3.578362075899787],
            [31.344756216858645, 3.577864209346933],
            [31.34847397730699, 3.578152280819271],
            [31.35185213415372, 3.576954884602296],
            [31.35271824573323, 3.576784991742208],
            [31.352475743725645, 3.577284636769657],
            [31.352826098364545, 3.577265607178277],
            [31.357092620755317, 3.574576350316053],
            [31.357949091615207, 3.574551183663048],
            [31.36016359240247, 3.575740051293156],
            [31.363019473234623, 3.576284082284415],
            [31.363401295857916, 3.577022716935642],
            [31.362215201679273, 3.579289927618916],
            [31.363573527152386, 3.580694738544734],
            [31.364025577369667, 3.580694040123233],
            [31.36545096207874, 3.579308750958782],
            [31.366283429055922, 3.579140536004742],
            [31.369486165588924, 3.580864393987523],
            [31.369555535291816, 3.57957660000508],
            [31.370693521992038, 3.576975595260022],
            [31.37176594694789, 3.578118530559382],
            [31.372360899363933, 3.578212983586692],
            [31.375167560603334, 3.577683981955727],
            [31.37704598996474, 3.576441729045437],
            [31.377572598553947, 3.576584720517514],
            [31.378382242933004, 3.578025491404149],
            [31.38008476778871, 3.578096181008245],
            [31.381281329137064, 3.577300125825715],
            [31.384527482146048, 3.57651919860158],
            [31.386316168912256, 3.575083337638676],
            [31.38826616705231, 3.575626731560714],
            [31.39076953010233, 3.573270209078791],
            [31.391677049524848, 3.573418084655291],
            [31.392149960419655, 3.574520890435485],
            [31.39347313481571, 3.575220516878896],
            [31.393987039430204, 3.574659278332876],
            [31.394317323010718, 3.572163714203071],
            [31.395342810992965, 3.570029269130437],
            [31.39679764876527, 3.569537251777213],
            [31.399353059304552, 3.57035161631148],
            [31.400808721730293, 3.570219412317256],
            [31.402103874977687, 3.568467753994713],
            [31.40239227191315, 3.56725392078824],
            [31.405019537793684, 3.565223640255135],
            [31.40615870038864, 3.563831489538489],
            [31.409521078327387, 3.564894687088786],
            [31.410908969153173, 3.564514966006013],
            [31.412740953817714, 3.562449442958585],
            [31.415746241549595, 3.564074167195245],
            [31.416854371843044, 3.56379511446798],
            [31.418194651060436, 3.56220091558752],
            [31.419674543744353, 3.56285581480976],
            [31.42173441931839, 3.562477306853955],
            [31.424173003056644, 3.561199957349101],
            [31.425741868479548, 3.561585153422509],
            [31.427219784869816, 3.561385474213374],
            [31.42784917330397, 3.562331141983784],
            [31.428719083858798, 3.565559840330939],
            [31.429212505088177, 3.565830617124989],
            [31.430465274922152, 3.565135768558292],
            [31.43169201966401, 3.562889160376919],
            [31.433123768038588, 3.56210469196138],
            [31.434737340816543, 3.562444972613505],
            [31.43633108957281, 3.563887158967094],
            [31.437540371065566, 3.56375443223453],
            [31.438277460315753, 3.562856231718992],
            [31.439009224352954, 3.559686672308029],
            [31.43932946566689, 3.56252082233468],
            [31.44042821844711, 3.563017575586448],
            [31.440509697440007, 3.564333313125519],
            [31.439951755613677, 3.565209354201314],
            [31.440605041030977, 3.566784752064927],
            [31.440271462430005, 3.567818615672153],
            [31.440501832689687, 3.570540162637617],
            [31.441759080625356, 3.571756850664082],
            [31.441851203756066, 3.57283647495212],
            [31.440949491941854, 3.575184883720369],
            [31.441531951487235, 3.575208446397649],
            [31.44195897553901, 3.575816419925063],
            [31.441557767271856, 3.576670251082516],
            [31.442143385293797, 3.578043135788037],
            [31.441742805847348, 3.579166833097827],
            [31.442259537460032, 3.579819949507218],
            [31.441925742365058, 3.580763862546346],
            [31.441163966512566, 3.580694994961354],
            [31.441322980894274, 3.581639814417834],
            [31.443061707855907, 3.582801163712562],
            [31.44346775265253, 3.584016291588508],
            [31.444565375352138, 3.584018305258613],
            [31.44553064476932, 3.584897120309068],
            [31.44658315048207, 3.584764116890656],
            [31.449498489006213, 3.58616373552447],
            [31.451692633969145, 3.585695474829017],
            [31.45548514502893, 3.587451054026374],
            [31.455110183737737, 3.590799536456955],
            [31.455933230980854, 3.591954021777847],
            [31.452772241854024, 3.595757893254214],
            [31.45226005481839, 3.597438034824832],
            [31.45214638200231, 3.600322147087309],
            [31.449740556229205, 3.603938968348555],
            [31.446681552836587, 3.605349605584325],
            [31.446224340001386, 3.606016586126813],
            [31.446313424131482, 3.607335127127489],
            [31.44575325538154, 3.608024515099612],
            [31.444324464260912, 3.607843635608555],
            [31.443322318102982, 3.608406204829691],
            [31.44241634198615, 3.6098521755657],
            [31.437701557573625, 3.61094809140541],
            [31.43733333813868, 3.612076034484115],
            [31.43799223712821, 3.612322516754787],
            [31.437942600717193, 3.612788582504582],
            [31.43659790538187, 3.613743098721624],
            [31.437352673476834, 3.615044722677732],
            [31.437227044982684, 3.61710538953543],
            [31.4377620815659, 3.618382101420491],
            [31.437051480040193, 3.61980386088935],
            [31.438077303992348, 3.619682965635855],
            [31.43873536665038, 3.620420136047618],
            [31.43887876921073, 3.622235925804302],
            [31.43939153565977, 3.622261347545086],
            [31.439194455167886, 3.623266915063868],
            [31.43965707855607, 3.624052814636391],
            [31.440315943409612, 3.624323833157567],
            [31.439753115646464, 3.625009820270158],
            [31.438996236510555, 3.624934907226546],
            [31.438385030876084, 3.625350931840864],
            [31.4388217603262, 3.62699549061125],
            [31.43876950802107, 3.628982680664087],
            [31.438085462491753, 3.629153235267603],
            [31.43832733927189, 3.630503042541917],
            [31.438864360233588, 3.630626646505946],
            [31.437908742315823, 3.632514131227214],
            [31.438298190737576, 3.633250838438713],
            [31.437931219062534, 3.633642750292965],
            [31.438200006673654, 3.633545079175734],
            [31.438637831170062, 3.634551747600259],
            [31.43927295624564, 3.63443017924835],
            [31.44058947502374, 3.635683717950854],
            [31.440734305905444, 3.636665344565238],
            [31.44070819816833, 3.637646672470972],
            [31.4393599886236, 3.64061298613474],
            [31.436936483107388, 3.644043570862944],
            [31.437202304481428, 3.645663300218456],
            [31.43590231111127, 3.648973161723675],
            [31.43638459502776, 3.652506944552805],
            [31.43601382707235, 3.655082397868592],
            [31.43371691214595, 3.655888004953062],
            [31.43049010166163, 3.657796012805291],
            [31.424786566768724, 3.665563299974064],
            [31.423687387288787, 3.665708560699217],
            [31.423173095500417, 3.666541810940656],
            [31.42168275720638, 3.666931718091594],
            [31.421731082077105, 3.667226213151224],
            [31.420118079729345, 3.667934842079202],
            [31.42014146557115, 3.668523704141061],
            [31.417990390334523, 3.669697519373117],
            [31.417524021869905, 3.671046065340283],
            [31.417667952639686, 3.672518365246696],
            [31.416176219262024, 3.673693343327554],
            [31.415150468073396, 3.673740584572926],
            [31.41483230725764, 3.674132561217542],
            [31.414124414152514, 3.673959562419052],
            [31.413610279569305, 3.674694664094227],
            [31.413023925827172, 3.674840823388501],
            [31.412705460482528, 3.675404536771318],
            [31.413068643063685, 3.67717163323555],
            [31.412234734290497, 3.679206465918251],
            [31.412672133883813, 3.680433949070361],
            [31.41242627397371, 3.681365802626032],
            [31.411716722578543, 3.682125086501235],
            [31.409957818557306, 3.682465410781777],
            [31.40893258210331, 3.68221823236908],
            [31.407977948739095, 3.683467751724368],
            [31.407416186377844, 3.685588040066541],
            [31.42940779523767, 3.711691498916583],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 632,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "MIDIGO",
        Population: 36675,
        Key: "YUMBEMIDIGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.337418385054185, 3.349210950953349],
            [31.33830193113669, 3.350029751093027],
            [31.337975159968956, 3.351699083625332],
            [31.338643115773188, 3.352372586607673],
            [31.338180486096824, 3.353926635407781],
            [31.339015292286984, 3.354852560442861],
            [31.339806006468038, 3.357123135830159],
            [31.339512353489862, 3.357668928300773],
            [31.340471694924503, 3.359141360648191],
            [31.340765780890646, 3.360999340138676],
            [31.330123694841234, 3.367022095337139],
            [31.32516059901619, 3.371750765789194],
            [31.319710908259662, 3.376035874994209],
            [31.31232358736787, 3.383834632778582],
            [31.309504201492455, 3.387801331484224],
            [31.30142258978556, 3.396986371385073],
            [31.297718845750598, 3.403817305962083],
            [31.286489618136525, 3.40375860059853],
            [31.284692575241586, 3.40308304657234],
            [31.283167103836806, 3.401137344991351],
            [31.281394735866073, 3.399757452103505],
            [31.277433769130987, 3.397684391132196],
            [31.27799224096334, 3.393857289901145],
            [31.277850997952875, 3.393330660477827],
            [31.276900196801684, 3.39297003092249],
            [31.276902038347995, 3.3918258188006],
            [31.276586605715757, 3.391772412451288],
            [31.27397549873057, 3.393464967951938],
            [31.272584870738136, 3.393262797860532],
            [31.27059482031282, 3.394906534980345],
            [31.270544342180354, 3.395355712251189],
            [31.26765865345047, 3.397796521716206],
            [31.267234695348755, 3.39874420725114],
            [31.26586747835094, 3.399340761096513],
            [31.265549221415455, 3.401179596360924],
            [31.26464428914095, 3.402733002990817],
            [31.26367417600775, 3.403504981837082],
            [31.2620877862503, 3.401655131958821],
            [31.25977927946349, 3.400802338921549],
            [31.25759344840853, 3.400798373566696],
            [31.25299275452867, 3.403835017286874],
            [31.247646627846272, 3.404657298204042],
            [31.245103491887033, 3.405421108099992],
            [31.245235033092417, 3.401365521375805],
            [31.24576483429417, 3.400274534979161],
            [31.24095505753195, 3.399615303562047],
            [31.23924801594697, 3.400040804862558],
            [31.23796629251308, 3.401152888961707],
            [31.237847085176547, 3.404153074101218],
            [31.235060959424533, 3.403719322900808],
            [31.23460538331978, 3.404032810912296],
            [31.233091451673147, 3.407716223286282],
            [31.23138418910262, 3.40825600072555],
            [31.227989660459816, 3.41393617363467],
            [31.22366578063814, 3.404608036353372],
            [31.223119683997165, 3.404238971886176],
            [31.221290257734527, 3.404579514067974],
            [31.221065009668592, 3.405494437218528],
            [31.219164210460033, 3.406201947157709],
            [31.217165732939016, 3.406198232012275],
            [31.215951513407145, 3.406627724431862],
            [31.214511484362294, 3.406175195061318],
            [31.213766313867815, 3.406390439432689],
            [31.213003252526107, 3.405680036784872],
            [31.212512801127072, 3.405935143542931],
            [31.211337321441828, 3.405676929619528],
            [31.210672624725433, 3.404769771424515],
            [31.209867966894535, 3.40535908493653],
            [31.208929138489417, 3.40431356010376],
            [31.207771479582757, 3.405020373255135],
            [31.206105553888367, 3.405017258017128],
            [31.20581065315025, 3.405509053004063],
            [31.200982196820014, 3.399778971036721],
            [31.19410279506799, 3.395613796221343],
            [31.191624733067922, 3.394917097666946],
            [31.181774157106926, 3.390442840364531],
            [31.17954580609462, 3.38199741454535],
            [31.179901274842432, 3.381227301699441],
            [31.179459539081225, 3.378027321187475],
            [31.17807414557197, 3.374025782012648],
            [31.17752788633589, 3.373524885958617],
            [31.177594985996052, 3.372830688724049],
            [31.17837726858988, 3.371527018699819],
            [31.178331062844908, 3.369627441447746],
            [31.179924931077128, 3.368530728446333],
            [31.180924185558137, 3.366183229075943],
            [31.181225527216807, 3.364634205541488],
            [31.18088279927469, 3.36359640635504],
            [31.181892377194945, 3.363264180745249],
            [31.18025861298434, 3.361308692611307],
            [31.17930491656296, 3.361106695177901],
            [31.178551734892764, 3.360106970030548],
            [31.177598228015906, 3.359985383124368],
            [31.176427907355333, 3.35892497674891],
            [31.175655344532895, 3.357665654181774],
            [31.175559186169924, 3.355948377702828],
            [31.173891511455686, 3.355226465658837],
            [31.173933179810145, 3.354188299552691],
            [31.17317982027353, 3.35328840643506],
            [31.17334018302648, 3.352529989978733],
            [31.172448633853065, 3.351150650393922],
            [31.172586759709464, 3.350842560957683],
            [31.174757437083922, 3.346887718725061],
            [31.177623543438948, 3.345160119273005],
            [31.177841637321926, 3.344000354494995],
            [31.177226869867333, 3.343457711985785],
            [31.17779711322319, 3.343102937010276],
            [31.17756774368674, 3.342267059839561],
            [31.178384749759545, 3.34166520326368],
            [31.178849316203685, 3.340180824507124],
            [31.181467753441616, 3.339412135041829],
            [31.18250070193232, 3.338578604319581],
            [31.183848457827786, 3.339104284049552],
            [31.18430520623402, 3.336740866831456],
            [31.18590458113891, 3.337625701869251],
            [31.18621819558099, 3.338901209472357],
            [31.186949142151263, 3.338849876291937],
            [31.187348454973172, 3.339361172262366],
            [31.187918438715865, 3.339145629664606],
            [31.189193379869405, 3.340664187504543],
            [31.189808951316166, 3.340773628014794],
            [31.189751486985738, 3.341886439013155],
            [31.190515358607826, 3.341718692174824],
            [31.190918446150505, 3.340172298731896],
            [31.193719612395327, 3.340502379890447],
            [31.196061867090734, 3.339238048371568],
            [31.19693928666303, 3.339270609922403],
            [31.19815651016123, 3.338684938579683],
            [31.20034222263857, 3.338843679469955],
            [31.200990587983103, 3.337854697567737],
            [31.204300959755127, 3.33608949223999],
            [31.204559511961882, 3.335717411872339],
            [31.20382691338982, 3.335311115098631],
            [31.204167463815697, 3.334161676936625],
            [31.203725667867417, 3.333197595234589],
            [31.204568204958896, 3.333013339593239],
            [31.20433319669743, 3.332341961283206],
            [31.20617648306659, 3.329682192350958],
            [31.208242464489594, 3.328818898469236],
            [31.209282512365995, 3.327324066939374],
            [31.21095904177399, 3.325995548703766],
            [31.210983456186803, 3.323848554467813],
            [31.211735726965276, 3.322456413075852],
            [31.21342145422349, 3.321716273043609],
            [31.214245039557433, 3.320644248446951],
            [31.21554997006841, 3.320336948504765],
            [31.216631799486976, 3.318439601965951],
            [31.21839975942458, 3.317658307912999],
            [31.21770849233874, 3.316122504806373],
            [31.217939907339076, 3.31451512829196],
            [31.218855688567263, 3.313598045525296],
            [31.22022696145858, 3.313562242939482],
            [31.22167759242041, 3.311746519586545],
            [31.224021876410024, 3.310736301710524],
            [31.22925826759225, 3.311224233172159],
            [31.232377089799655, 3.313756385095528],
            [31.233652639112595, 3.314007499954141],
            [31.233942147264063, 3.311845134266009],
            [31.235123218961935, 3.311674985128116],
            [31.23533423681545, 3.310814035925358],
            [31.23419393515671, 3.309472153544289],
            [31.23303276024405, 3.309163825069155],
            [31.232979190110406, 3.30715396817802],
            [31.23347641480669, 3.305987283671956],
            [31.23494504351524, 3.30474577150075],
            [31.236201541357634, 3.304996843801876],
            [31.23755491801187, 3.30431019869066],
            [31.237721510581295, 3.303347018763125],
            [31.23628593538365, 3.300345827586453],
            [31.238497788835762, 3.298818519303324],
            [31.238100723598716, 3.297190858978737],
            [31.238808028307346, 3.295680008053762],
            [31.24150860390158, 3.29429815499306],
            [31.24139785150853, 3.293302969098458],
            [31.239405439412316, 3.29168067626758],
            [31.240664042905742, 3.290725876680699],
            [31.240875278151552, 3.289730936537239],
            [31.24308424621499, 3.28983055516664],
            [31.244305025245065, 3.288722555418329],
            [31.246019981886, 3.288170507046831],
            [31.248407369737905, 3.284250871508319],
            [31.25250628176801, 3.281731504268255],
            [31.255247754962202, 3.282253119188254],
            [31.256905770092217, 3.281586098342306],
            [31.25941749376259, 3.282815511411621],
            [31.2618310540303, 3.285748286286849],
            [31.263259317839864, 3.285789066431605],
            [31.26500882368664, 3.287285113916028],
            [31.26633710590339, 3.286562263795183],
            [31.266468929179755, 3.285355824280321],
            [31.26800640117843, 3.285444362006291],
            [31.269737187032955, 3.284889312790143],
            [31.273180834657182, 3.281783009911881],
            [31.277048304737495, 3.280587724940086],
            [31.279653996678178, 3.278742700674793],
            [31.279808130512954, 3.277716302488155],
            [31.28130538493634, 3.276345180438466],
            [31.283277755618542, 3.278878194189754],
            [31.284102213216638, 3.278281340266738],
            [31.285262060419324, 3.278811814226021],
            [31.286096268331512, 3.278314687663102],
            [31.287355683003653, 3.278635935775581],
            [31.289915847427405, 3.278311285032332],
            [31.291575085164503, 3.276878267938186],
            [31.29417542224779, 3.276264503667815],
            [31.294307959684815, 3.274160786148574],
            [31.2955283524393, 3.274093074051167],
            [31.297906429253292, 3.2758421182106],
            [31.298130750257823, 3.278125934012947],
            [31.298875245219218, 3.27787792304886],
            [31.300193153691094, 3.278817478697598],
            [31.30140088918324, 3.280375069049708],
            [31.302758470851327, 3.281324663400891],
            [31.30300123696359, 3.282051726192502],
            [31.303893858725438, 3.282349092903071],
            [31.30555584800225, 3.28391246954481],
            [31.302516646173455, 3.286700079955956],
            [31.30061580833732, 3.28978567485788],
            [31.299255684436982, 3.290589096022982],
            [31.29665303958176, 3.293886080860534],
            [31.296872520463555, 3.294983266267612],
            [31.29813878658636, 3.295880828810046],
            [31.29999970957949, 3.299017788812629],
            [31.30091328364705, 3.302611949431534],
            [31.302200036748214, 3.304136293265862],
            [31.3027519688453, 3.30574887652095],
            [31.302359034960244, 3.314757556433506],
            [31.30287268355486, 3.318082415422432],
            [31.30390941485121, 3.321419400602196],
            [31.303662197586725, 3.322247154280764],
            [31.302458653633668, 3.322759843541097],
            [31.301552921858576, 3.324224362849435],
            [31.301947608356738, 3.326329111519888],
            [31.300908118334135, 3.327860541192921],
            [31.300413517616807, 3.329560806141453],
            [31.300584057383606, 3.332202357877553],
            [31.307722150581274, 3.334878660467999],
            [31.311431738157157, 3.337683165580462],
            [31.3134123913063, 3.337888122774463],
            [31.314761763270976, 3.336983957618431],
            [31.315919647654773, 3.33687408174166],
            [31.32119967899349, 3.339334390526129],
            [31.32311413079777, 3.33933776155974],
            [31.325119156138864, 3.338804066441404],
            [31.326765848004744, 3.339030790295402],
            [31.327458723973255, 3.340014097923637],
            [31.33069037907192, 3.341138950960449],
            [31.330963486681213, 3.342958114041601],
            [31.32992210031507, 3.343766218956479],
            [31.330777503976375, 3.345367030792378],
            [31.337418385054185, 3.349210950953349],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 633,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "ODRAVU",
        Population: 42255,
        Key: "YUMBEODRAVU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.49317336539449, 3.509108128427196],
            [31.491272942580018, 3.512331383149424],
            [31.49029657537579, 3.511808414904972],
            [31.4891789337201, 3.512144208465593],
            [31.4889178680272, 3.512526214100014],
            [31.48968166149581, 3.513955754122946],
            [31.489445630053247, 3.515053153309462],
            [31.488175476021876, 3.516641191038863],
            [31.48729578730517, 3.517000417906976],
            [31.48515789574365, 3.51898342853123],
            [31.484589288219944, 3.520391402111978],
            [31.48519100405177, 3.524444448209813],
            [31.483408022485932, 3.525282154617024],
            [31.481278529274007, 3.525226175325781],
            [31.48035149125699, 3.525728549758533],
            [31.479948481867723, 3.526587744161858],
            [31.479496558312903, 3.526660063267185],
            [31.479640518727084, 3.527375241873336],
            [31.477930440836452, 3.52911900812757],
            [31.476479002289196, 3.529049941224685],
            [31.473169677952757, 3.527743955248697],
            [31.468116463138436, 3.529290659949688],
            [31.466711492644166, 3.528553772247515],
            [31.466304178528038, 3.526861297527548],
            [31.465470617402897, 3.526361914812494],
            [31.464542853547126, 3.526435019369557],
            [31.46278437802224, 3.527701891541498],
            [31.461547513758706, 3.527894750314899],
            [31.45904812575378, 3.527159692390833],
            [31.45833653158968, 3.528448639965915],
            [31.459195108998895, 3.52968724910451],
            [31.459387124789206, 3.530688514924439],
            [31.459078946052863, 3.531356753814906],
            [31.45846083327218, 3.531643957549996],
            [31.452761533037528, 3.530973865573424],
            [31.452144411996905, 3.531857237570922],
            [31.451840637700432, 3.535172496748788],
            [31.451175652624833, 3.535889018188861],
            [31.450080504783863, 3.535461593830536],
            [31.44950807043706, 3.534604056496728],
            [31.448748079536998, 3.535416127854467],
            [31.448200863595176, 3.535417032529576],
            [31.447676128891615, 3.53463095917315],
            [31.445794867142162, 3.533608667679028],
            [31.444817499214704, 3.532465635969029],
            [31.444139259497096, 3.532359450615141],
            [31.443709379701044, 3.531382439886322],
            [31.441923455254347, 3.530455367540528],
            [31.44113529228868, 3.528620460475],
            [31.440087702157182, 3.52816910486767],
            [31.44008612471555, 3.527215228638535],
            [31.440656451614696, 3.526808884165211],
            [31.440607209564067, 3.525807391804515],
            [31.439296256747458, 3.524354906725445],
            [31.439413831845126, 3.5235200650717],
            [31.438532207258977, 3.522710729656358],
            [31.438911764331124, 3.522042383233246],
            [31.43986322484579, 3.521921567458139],
            [31.439551173472264, 3.520252803452331],
            [31.438455932206494, 3.519753835912765],
            [31.437433335002844, 3.520017850348368],
            [31.4358384426912, 3.519495868214578],
            [31.43488449294491, 3.518114330191114],
            [31.432074236647733, 3.516378161933042],
            [31.43028973243751, 3.516285734336768],
            [31.428198424811704, 3.517696155290484],
            [31.426892213303134, 3.519105278491977],
            [31.4252676280781, 3.522219969285659],
            [31.424436019890376, 3.522889046324714],
            [31.420488020336396, 3.523730177415963],
            [31.413360643141733, 3.522585281142509],
            [31.413097146607655, 3.521488771305683],
            [31.41026196116302, 3.519013344307959],
            [31.409664854586932, 3.517583522428637],
            [31.40914153293334, 3.51763206738295],
            [31.408735138692073, 3.516440403778035],
            [31.40680724988778, 3.515942767477841],
            [31.406568224360356, 3.515251609643669],
            [31.40604590432829, 3.515920161781907],
            [31.405521496611506, 3.515301007409838],
            [31.403727542124486, 3.516698947954413],
            [31.401491148495435, 3.516678737158854],
            [31.401061363920814, 3.515725577215251],
            [31.40025255497496, 3.515774580441456],
            [31.399251988953615, 3.514941582629479],
            [31.397468515111033, 3.515469090523116],
            [31.39670536573445, 3.514325699396094],
            [31.396017735028853, 3.515757598371165],
            [31.39401784625456, 3.514854678103876],
            [31.390390612630654, 3.515397077194394],
            [31.389535215257563, 3.51606615644343],
            [31.387751516836136, 3.516450566114086],
            [31.382969690255667, 3.516529792700633],
            [31.382708827582004, 3.517054832188344],
            [31.381400219368285, 3.516985394981243],
            [31.38156774798225, 3.517605129246377],
            [31.380496895078114, 3.517439915711809],
            [31.378683929544753, 3.518365626506629],
            [31.378459896001097, 3.518107695185626],
            [31.3774983348294, 3.51883312964598],
            [31.37656610904165, 3.518691670530917],
            [31.37567323754814, 3.51993459016223],
            [31.375103011260297, 3.519709865628473],
            [31.373487764920956, 3.520182455517252],
            [31.373250221613745, 3.52072737369889],
            [31.37184371050879, 3.521214308084886],
            [31.37087117012767, 3.520247777895517],
            [31.36945133880369, 3.520736512048302],
            [31.36912274764916, 3.519849712464898],
            [31.36615738104853, 3.51992088621272],
            [31.36507075013474, 3.518111087108039],
            [31.363955757610828, 3.518032732172858],
            [31.361601547237324, 3.516449866747381],
            [31.360969023682834, 3.515837636461817],
            [31.36084359551297, 3.515098984310836],
            [31.359957769506266, 3.514409917679731],
            [31.35934898842473, 3.514714400137734],
            [31.357930279994825, 3.514406337452395],
            [31.356108219019216, 3.512875332182289],
            [31.35350342269888, 3.512296587709039],
            [31.353468632744555, 3.521812743943893],
            [31.352620625811284, 3.521490262383256],
            [31.352407524764665, 3.522134440851622],
            [31.350598434563416, 3.521493428345353],
            [31.349846516822836, 3.519885006144547],
            [31.348348580578158, 3.520435810811346],
            [31.34799071692178, 3.51979253675485],
            [31.347014533872198, 3.519293296395879],
            [31.34596827504393, 3.51962877434075],
            [31.345443622985403, 3.51881883211672],
            [31.34468248403842, 3.518915411716414],
            [31.344110736004495, 3.5184155396655],
            [31.34308845141453, 3.518870200468212],
            [31.34185024866119, 3.518156762843414],
            [31.341492133476564, 3.517346560215881],
            [31.34025522160228, 3.51746771461123],
            [31.33744579624675, 3.516065193468929],
            [31.335052644803994, 3.514626243004848],
            [31.334860256212856, 3.513291179807517],
            [31.334193869765418, 3.513125291245129],
            [31.3339565258842, 3.513483349369347],
            [31.33285971256668, 3.511887388139941],
            [31.3311481551508, 3.512748491675329],
            [31.330481451598082, 3.512367987086977],
            [31.329499698095425, 3.512484920805403],
            [31.32776739588467, 3.51108453063293],
            [31.32462569987521, 3.510159402596118],
            [31.324458365297346, 3.509635056807465],
            [31.323637850405046, 3.509791326939502],
            [31.322757003759953, 3.509387310591643],
            [31.322758216485568, 3.510174215820349],
            [31.319260334872705, 3.509678843757422],
            [31.31880671709526, 3.508630337845757],
            [31.318307243915807, 3.508702644894949],
            [31.31621184985377, 3.507465902447186],
            [31.312261334118684, 3.506541993835809],
            [31.310344428117034, 3.505340736432462],
            [31.309750426118583, 3.505818547524528],
            [31.308988899997715, 3.50542463632423],
            [31.30989120739497, 3.496768987591495],
            [31.310494830350102, 3.49498672444927],
            [31.30982681076551, 3.493883243987682],
            [31.306923730651686, 3.491943334892733],
            [31.306905381663707, 3.490571137812285],
            [31.30735584994776, 3.489559708502568],
            [31.309250457069094, 3.488224785309753],
            [31.313483465113254, 3.490538922118511],
            [31.31361258176567, 3.490119772789032],
            [31.315100862917685, 3.490917693389878],
            [31.3174257918062, 3.490728852935649],
            [31.321631936630126, 3.491392696360523],
            [31.32493786174151, 3.490530006739561],
            [31.326361257580544, 3.489548120201453],
            [31.329284057511448, 3.486441368098486],
            [31.32921190033626, 3.485403148609981],
            [31.330524512341217, 3.481873103397218],
            [31.33104413922405, 3.481352857452923],
            [31.332677481226458, 3.481143433196633],
            [31.333813127815404, 3.479910078764141],
            [31.33471623381491, 3.479815168309445],
            [31.335389650477765, 3.479237282160599],
            [31.335702259705062, 3.477462198529352],
            [31.33521373609063, 3.475411173360797],
            [31.337018573667283, 3.473099912641871],
            [31.336727906689127, 3.472524173480328],
            [31.33767076493662, 3.467799863752711],
            [31.33555919670788, 3.466850785156247],
            [31.33549863678299, 3.466464327806749],
            [31.336839297784373, 3.465237279326489],
            [31.336869548551565, 3.464115467394944],
            [31.339583778538117, 3.463350361236629],
            [31.340799686902724, 3.462190977252894],
            [31.340478693698884, 3.460813380136514],
            [31.34233974245615, 3.460095919869169],
            [31.34226654593016, 3.456863029807648],
            [31.342725253562026, 3.455681791130572],
            [31.34230644280688, 3.452963574081232],
            [31.342678975951856, 3.447907359584804],
            [31.342370203429127, 3.446156131966721],
            [31.34315450902896, 3.441064659078939],
            [31.343747511202512, 3.440255898413557],
            [31.343829997206857, 3.436594681605314],
            [31.346005562314755, 3.434630792059652],
            [31.348037564962176, 3.431428241569237],
            [31.347991747289424, 3.430806062785257],
            [31.34661462007739, 3.429702989065939],
            [31.34642601698685, 3.429080561667857],
            [31.346546788290297, 3.428458690719991],
            [31.347071096294073, 3.428196421667987],
            [31.353840369982166, 3.428627140799996],
            [31.3550511956789, 3.42963421437614],
            [31.356192613943527, 3.429947278747069],
            [31.359100386856387, 3.428397171201736],
            [31.36157666480229, 3.427946927046325],
            [31.362857164730762, 3.425377041855489],
            [31.364001094684905, 3.424804814903347],
            [31.364357725852695, 3.42492507100738],
            [31.36427960116909, 3.427293692978126],
            [31.364731698997048, 3.427318417924397],
            [31.366330304944064, 3.42586168142793],
            [31.367997109190817, 3.425529635053827],
            [31.369401321506967, 3.42548423550864],
            [31.3707548221287, 3.426539396638578],
            [31.37153975295598, 3.426684330858468],
            [31.373849043972026, 3.426377317311796],
            [31.374826315779732, 3.425828702228599],
            [31.37647808761852, 3.426609218907313],
            [31.377956202536478, 3.425678643180767],
            [31.37627412243832, 3.422995883583375],
            [31.376276016086937, 3.422325930504805],
            [31.377256059197283, 3.420796305032441],
            [31.380804794438394, 3.419797540990989],
            [31.383325017967998, 3.420639369186822],
            [31.384873096375202, 3.420211367992395],
            [31.386894987585766, 3.420549849242926],
            [31.387849471829664, 3.419642264802748],
            [31.38792247611618, 3.419068144147575],
            [31.387377484402972, 3.418229748102092],
            [31.387700538342088, 3.417596235197156],
            [31.389721077588153, 3.418413254961759],
            [31.390673741845266, 3.418151695152531],
            [31.39055999806232, 3.416285182821496],
            [31.391181429219678, 3.41532917058144],
            [31.39230053692589, 3.41511575483007],
            [31.393369167398006, 3.415931117775886],
            [31.39436814609624, 3.416124248664174],
            [31.395480617947467, 3.418279622609107],
            [31.39997061782472, 3.421086827996684],
            [31.400501549107094, 3.418455734235078],
            [31.401228094830792, 3.418205749262079],
            [31.40236672472476, 3.419523701931981],
            [31.40317519231082, 3.419764358028428],
            [31.40747097732197, 3.41544085792386],
            [31.408827604080912, 3.415395313528985],
            [31.412109086931707, 3.416358002671747],
            [31.4125672510828, 3.414205317264257],
            [31.415245515220356, 3.413862920484425],
            [31.419085208493755, 3.4109263487267],
            [31.42198752414125, 3.411314093864362],
            [31.423221850664152, 3.412464701589527],
            [31.423555293619494, 3.412369560226052],
            [31.424055920235784, 3.4120593479694],
            [31.42327621131524, 3.410024186650987],
            [31.423659440700284, 3.409139515258239],
            [31.4260628571918, 3.409215350441215],
            [31.42893408933383, 3.407940048987602],
            [31.42955257850863, 3.408036801310347],
            [31.43062065651683, 3.409067482186011],
            [31.431096822007927, 3.40899650096769],
            [31.43176581267135, 3.408040519138875],
            [31.430866634106252, 3.406172651939699],
            [31.428081324922832, 3.406502965357616],
            [31.427298033520955, 3.405759887791789],
            [31.427395676799062, 3.404874736315263],
            [31.42949625773357, 3.402581208745316],
            [31.42990115268665, 3.402462249208255],
            [31.430041968098998, 3.403180315003605],
            [31.431661361061707, 3.402776260423195],
            [31.431996184727655, 3.402178631728177],
            [31.431714703921585, 3.400694639446934],
            [31.433284251165787, 3.401104035842129],
            [31.437734898545393, 3.400967905475677],
            [31.438464002671022, 3.399784707446048],
            [31.437274360147004, 3.399687006446184],
            [31.436943361507534, 3.398896841444761],
            [31.43797056167871, 3.39748681500813],
            [31.43885128525464, 3.397416501902025],
            [31.44037041545181, 3.398854701170315],
            [31.44025695463818, 3.396844580233457],
            [31.44209315240141, 3.395483744069207],
            [31.44171579799834, 3.394238875029719],
            [31.44078905552704, 3.393734849040937],
            [31.440671778670072, 3.393112539138579],
            [31.441507336750135, 3.392156810584024],
            [31.44122359937605, 3.391486363452894],
            [31.442296606440227, 3.390722458232943],
            [31.443486438508756, 3.390748357058773],
            [31.444942991164954, 3.389873211128159],
            [31.45305614721307, 3.446571838667319],
            [31.468968994885785, 3.471895792470126],
            [31.49317336539449, 3.509108128427196],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 634,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "ROMOGI",
        Population: 45612,
        Key: "YUMBEROMOGI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.710138830602894, 1.919678034632249],
            [32.7105146336155, 1.928493478323649],
            [32.70740945591898, 1.928638825106635],
            [32.7061253258984, 1.92698297480916],
            [32.70424210851656, 1.925426538093177],
            [32.701523681601, 1.924485159107267],
            [32.68645472567922, 1.924373869443659],
            [32.68589804418921, 1.924590897613404],
            [32.68410992964986, 1.928562252094395],
            [32.68283572331824, 1.932624171397909],
            [32.68045904787613, 1.935871638670339],
            [32.67622058705818, 1.937209802116522],
            [32.66746464150852, 1.936918586587017],
            [32.661172692138216, 1.939613366854707],
            [32.65677553943379, 1.93913297792709],
            [32.65789692975913, 1.936589557374777],
            [32.65789720464362, 1.935222079275812],
            [32.65723994238453, 1.933369232089096],
            [32.65759112257516, 1.931163691865206],
            [32.657416072367326, 1.92957561670158],
            [32.6559256092075, 1.928737181591092],
            [32.65360209606388, 1.928163248009191],
            [32.65259399677054, 1.926839675783385],
            [32.651103449169085, 1.926442358274878],
            [32.64930621672959, 1.925030397281832],
            [32.64790338332739, 1.924500759429325],
            [32.64084492667797, 1.9240581558993],
            [32.63589107631387, 1.922733733851113],
            [32.631332161281236, 1.919777237371567],
            [32.624358905344934, 1.916313166315395],
            [32.60706650860218, 1.903798165664658],
            [32.600500054742284, 1.902346854313054],
            [32.595457285538075, 1.900480098394204],
            [32.59798533788538, 1.896674611901108],
            [32.60102105874247, 1.894287698079187],
            [32.602430609746364, 1.892422450786599],
            [32.60131841637287, 1.891228226859334],
            [32.59672076418859, 1.88891384638321],
            [32.58176659679044, 1.883784400572596],
            [32.57263303812289, 1.879195332349479],
            [32.55707966209088, 1.876024979966687],
            [32.549486058365446, 1.875552583757031],
            [32.53987833924655, 1.870004270407781],
            [32.53470221513843, 1.86562416326578],
            [32.52680366391677, 1.857433162488129],
            [32.53594077631958, 1.845096915299608],
            [32.54357071959316, 1.835798606846315],
            [32.5385030850219, 1.830441486112437],
            [32.53769718302432, 1.828550459313443],
            [32.53699001485962, 1.824035834932609],
            [32.537222955199326, 1.818472005455777],
            [32.53794130199941, 1.814410098865971],
            [32.54000693846937, 1.806793071155205],
            [32.54314146682119, 1.799800549006503],
            [32.54717929251367, 1.792717769831666],
            [32.54910689655202, 1.790827428259757],
            [32.5510098759718, 1.789660835774302],
            [32.55568278811228, 1.787734970995139],
            [32.55538099639764, 1.78204433328173],
            [32.55581441465759, 1.777810441454139],
            [32.555051122448894, 1.770409808371815],
            [32.55524200905688, 1.760494338981115],
            [32.55426329635147, 1.745611783253912],
            [32.554798659023135, 1.743838697957945],
            [32.55584245287426, 1.742490942625395],
            [32.56823102822769, 1.733826798472348],
            [32.56860579368612, 1.732723147518381],
            [32.56872752169534, 1.727430667235921],
            [32.567966323459544, 1.721604210475532],
            [32.56869041408757, 1.713796794384583],
            [32.56767570678706, 1.705826136551637],
            [32.567831213247565, 1.702686853887352],
            [32.56977452702359, 1.695241589016611],
            [32.570846530669606, 1.693179106626015],
            [32.576055326504594, 1.689498117808138],
            [32.576488130316925, 1.687562147940703],
            [32.57637730875357, 1.682957181908952],
            [32.5777894603802, 1.673349536590486],
            [32.579497301465764, 1.668292610296719],
            [32.58712267500954, 1.651179910343072],
            [32.596632537051256, 1.655110915477384],
            [32.640012220748964, 1.679676918746241],
            [32.70890855188868, 1.74303673189191],
            [32.7137668700156, 1.747362027955354],
            [32.75060692354777, 1.774472706084033],
            [32.75346031514828, 1.777341994346919],
            [32.75759987504668, 1.7815033124215],
            [32.75374134500008, 1.783411754081099],
            [32.74100022581338, 1.793271420493289],
            [32.73619515083336, 1.798490950873572],
            [32.73290470010104, 1.806117237202248],
            [32.72988615323557, 1.808378580829097],
            [32.72237658061679, 1.812086777683482],
            [32.721992935311754, 1.81284668016814],
            [32.71882069029443, 1.815286412097319],
            [32.716566647465, 1.819273646882921],
            [32.71345588134907, 1.835614443469634],
            [32.713877598154156, 1.842809594559332],
            [32.72007219440219, 1.863311452991786],
            [32.72009894263807, 1.864740908430075],
            [32.71763841395575, 1.871589210351836],
            [32.71773143630005, 1.873235807698002],
            [32.71609694175913, 1.878555269480781],
            [32.710650732872615, 1.883250291420024],
            [32.70909160249246, 1.885357602373374],
            [32.708068096193706, 1.88869033499315],
            [32.7065170497528, 1.908744001586819],
            [32.70966384639641, 1.914779228067949],
            [32.71019885064029, 1.91645492916896],
            [32.710138830602894, 1.919678034632249],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 635,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "CHAWENTE",
        Population: 33937,
        Key: "APACCHAWENTE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.77418048718252, 2.473547130471591],
            [32.76554254702354, 2.473091764272681],
            [32.76287866491371, 2.472120658875856],
            [32.757135916762, 2.472577586123955],
            [32.75574296931953, 2.47124442626318],
            [32.75290229786345, 2.470833773529291],
            [32.75143429258573, 2.471161596948717],
            [32.75076813341206, 2.471940706197312],
            [32.74864778774464, 2.471830938183597],
            [32.74705886922966, 2.470540957146571],
            [32.74062482165279, 2.467105597299447],
            [32.736947957007736, 2.466576547335444],
            [32.73040087531695, 2.464661743556485],
            [32.72577334067475, 2.466359330406576],
            [32.72383481222423, 2.466107309937454],
            [32.72117037854881, 2.46682394119169],
            [32.718149472707395, 2.466750899549969],
            [32.71631761201036, 2.46739610342194],
            [32.71333147366537, 2.469488248218958],
            [32.70638405597161, 2.473313238635838],
            [32.703601492937985, 2.47211580889801],
            [32.70088988782869, 2.471851464435767],
            [32.6972984242211, 2.470988610380001],
            [32.695348286842155, 2.470078612004429],
            [32.69336205425681, 2.46993490021872],
            [32.69470778714628, 2.468727825789875],
            [32.695422140036634, 2.467005563881181],
            [32.69770613988417, 2.465953877977083],
            [32.698491548615166, 2.464925453132407],
            [32.70705868985167, 2.458911922695295],
            [32.70732477892364, 2.457830603397249],
            [32.707227917179814, 2.457147574692954],
            [32.70591859390713, 2.455732480957431],
            [32.706549423239, 2.454512961615562],
            [32.70635570334459, 2.453146903158006],
            [32.70301049849912, 2.44577942646132],
            [32.70155588171236, 2.443437357619739],
            [32.69816111950758, 2.440997280371198],
            [32.69675492101632, 2.439094295069899],
            [32.69505758123646, 2.437727893319775],
            [32.695106250161906, 2.436996110994528],
            [32.69646469421267, 2.435532831454511],
            [32.69733832469108, 2.43304492706387],
            [32.69669619006138, 2.429417689754966],
            [32.69401269054237, 2.427358762934304],
            [32.69525498152854, 2.422652974666041],
            [32.6958371679861, 2.422018884723533],
            [32.69549855792122, 2.417920759754974],
            [32.694431667485816, 2.417091150024842],
            [32.69351056284126, 2.415041917400025],
            [32.69127913240414, 2.416261066796427],
            [32.688272001329324, 2.415918870600506],
            [32.68526473730379, 2.416162104817841],
            [32.681772256362414, 2.417185795781332],
            [32.680405236993955, 2.417075471316914],
            [32.67667792655584, 2.4138127066279],
            [32.66817943637002, 2.402695883060392],
            [32.66551585878904, 2.401761613404783],
            [32.66364945697101, 2.40005014933209],
            [32.66177172110903, 2.397106564550529],
            [32.66115430721762, 2.394857363484248],
            [32.66003580138263, 2.396148790154943],
            [32.65818026648458, 2.396722130298731],
            [32.656610423694666, 2.396721408685034],
            [32.65608692686956, 2.397199660764402],
            [32.65093735067304, 2.397209243683087],
            [32.64853613415564, 2.394767824025451],
            [32.64317591739804, 2.387384576265712],
            [32.64043736642348, 2.381158501531857],
            [32.637057121891985, 2.3793744114882],
            [32.634008600940426, 2.376676667797357],
            [32.63253670056762, 2.376147463146748],
            [32.62943573686812, 2.373026650032383],
            [32.62822715875622, 2.370805320611563],
            [32.624770999396716, 2.368993207430904],
            [32.62049968090061, 2.368264923706269],
            [32.617477618029135, 2.365157331679918],
            [32.61662337229622, 2.364958789113742],
            [32.615966419057564, 2.364231494165622],
            [32.614653060552634, 2.360793867453181],
            [32.61709981446839, 2.34925262385526],
            [32.61662649214521, 2.348255269780009],
            [32.6166039632962, 2.345623562150479],
            [32.61440645414251, 2.340275368601707],
            [32.61592958184273, 2.338338213323132],
            [32.617761187418225, 2.337908451763915],
            [32.62254196296983, 2.337695428451289],
            [32.62377264143434, 2.336568665508888],
            [32.624029367366134, 2.33584197957927],
            [32.62317449371082, 2.332946703953764],
            [32.62148679644721, 2.33084053383793],
            [32.62084532387587, 2.329356910165748],
            [32.620929812224944, 2.326713288599597],
            [32.623961204999006, 2.325304452865595],
            [32.626280312804475, 2.322257421904905],
            [32.6460534943409, 2.322426576662337],
            [32.65729056424743, 2.308466506005049],
            [32.66251811061737, 2.30409796671547],
            [32.65973659412106, 2.298088830752647],
            [32.65797241249751, 2.295562119150067],
            [32.655043506717625, 2.29276247643294],
            [32.65436356469256, 2.279075517741834],
            [32.654035258303985, 2.278201517982095],
            [32.654483686514034, 2.277020757289367],
            [32.654224151550345, 2.275792616355227],
            [32.6544618969785, 2.27487595312427],
            [32.65453552020422, 2.274262706776005],
            [32.659483275499156, 2.27629780011594],
            [32.65982690265489, 2.278436001177085],
            [32.66244769797044, 2.281287448304936],
            [32.66363127956124, 2.284006194644618],
            [32.66707189267643, 2.287051278001925],
            [32.66856983610763, 2.287245076051902],
            [32.67065508908847, 2.286298676342107],
            [32.673377600643626, 2.287103643071127],
            [32.67513884836946, 2.286666240880946],
            [32.677375579765055, 2.287247095651014],
            [32.68050276708436, 2.288927753872086],
            [32.681028745056274, 2.290475466951659],
            [32.68165615270519, 2.291066136301322],
            [32.68517860234277, 2.290425482434486],
            [32.686605608510966, 2.29105705351515],
            [32.688234830839484, 2.292686459013507],
            [32.691119119095866, 2.294397589592091],
            [32.69255635348184, 2.29456080558619],
            [32.694479170398026, 2.295925547890236],
            [32.69542048264492, 2.295925750746505],
            [32.696715912573424, 2.296577647204675],
            [32.69881052959277, 2.29925584273392],
            [32.70000480832197, 2.29962263201547],
            [32.70057138295818, 2.300763085714192],
            [32.70303068903344, 2.302015935663738],
            [32.70322277938388, 2.303085039843285],
            [32.706674378895016, 2.302576680875867],
            [32.707463745603164, 2.303187737559909],
            [32.70853669697178, 2.302933420785947],
            [32.70869844672352, 2.303900702666137],
            [32.71001412108527, 2.304623863125319],
            [32.7130711400994, 2.303300883211137],
            [32.71496382662268, 2.30365762024712],
            [32.71704860798797, 2.305124185253362],
            [32.71657267965211, 2.306172792479316],
            [32.71832346020827, 2.307578199611895],
            [32.71850550559722, 2.30832149016633],
            [32.71984914720871, 2.308756237844355],
            [32.720792396223345, 2.309307801688855],
            [32.72156858913786, 2.310669649518882],
            [32.72262590622726, 2.311163150569382],
            [32.72287090824627, 2.312170338818117],
            [32.723811933930584, 2.313203374955082],
            [32.723304359743906, 2.316772661479056],
            [32.72549871850588, 2.319152482418274],
            [32.72942541541119, 2.334062892836053],
            [32.7324873410234, 2.340034580336337],
            [32.73601724488123, 2.349136656370223],
            [32.73810549374352, 2.352656381888098],
            [32.73988939248923, 2.354448047593257],
            [32.744149921320435, 2.357181073459446],
            [32.74628560572132, 2.359687520046357],
            [32.74724734655607, 2.361714252834691],
            [32.749527982212875, 2.374127325981584],
            [32.75309372705386, 2.377104476898662],
            [32.75636639204185, 2.38129388281296],
            [32.76341911115158, 2.396322408315281],
            [32.767566676835806, 2.403217039242292],
            [32.768278552172596, 2.41047296275773],
            [32.76813758943653, 2.41296090054451],
            [32.76748911629417, 2.41469783880249],
            [32.76328492350938, 2.421364842765505],
            [32.763111467811164, 2.424748438245965],
            [32.763932433657736, 2.426856564235901],
            [32.76671947299641, 2.42968880262453],
            [32.769128661163606, 2.431353891083658],
            [32.77284507683396, 2.432024014212072],
            [32.77375213721739, 2.4354349371207],
            [32.77369071490982, 2.437443886750526],
            [32.77143333843236, 2.441282853225058],
            [32.77044817133164, 2.445324327212604],
            [32.769061488739915, 2.447486367674726],
            [32.770793648118534, 2.45359166961903],
            [32.77112209284766, 2.458492608983072],
            [32.77181240232944, 2.459804631428137],
            [32.7716037452485, 2.46066419357486],
            [32.77286233347057, 2.464504261979878],
            [32.772390481689506, 2.467333726595966],
            [32.77313337675137, 2.47223425551177],
            [32.77407429643446, 2.472982453170836],
            [32.77418048718252, 2.473547130471591],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 636,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "ABOKE",
        Population: 46611,
        Key: "KOLEABOKE",
        Dist2: "Kole",
        "Sub Country": "Aboke",
        id2_original: "Kole Aboke",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.81047893744673, 2.248787480344329],
            [32.80997746012593, 2.249503361808118],
            [32.80784295611132, 2.250381437028524],
            [32.79877406985604, 2.25241798931647],
            [32.79880955600471, 2.253305968024997],
            [32.79684886881109, 2.257491377835059],
            [32.79524970860354, 2.258373259521319],
            [32.79358166647832, 2.259981569367692],
            [32.793032483226014, 2.262069356658607],
            [32.7901787736219, 2.265828049290993],
            [32.78947153179537, 2.267631299602372],
            [32.78785542846323, 2.268621637077651],
            [32.78669393105539, 2.268799260860215],
            [32.7828560496839, 2.268646289969213],
            [32.78212388589643, 2.268188991104533],
            [32.78212420479833, 2.266055446046915],
            [32.780837158846374, 2.261610365507518],
            [32.77929739614374, 2.258689205605755],
            [32.77712474606892, 2.257324016931265],
            [32.77707546359412, 2.256379321042529],
            [32.777866520033335, 2.254838109672657],
            [32.77470327254188, 2.254589018379818],
            [32.76674592119498, 2.252797823972243],
            [32.76417578098, 2.252648246197661],
            [32.75849167664668, 2.253194232198578],
            [32.75359819756123, 2.254883898152185],
            [32.752312676050316, 2.257469135756051],
            [32.751373423640366, 2.258363939558246],
            [32.74845700264628, 2.259904763907258],
            [32.74544187926038, 2.260550598911232],
            [32.74302011647581, 2.259804364588849],
            [32.73941239066664, 2.257566305606117],
            [32.73807811129703, 2.256273336496085],
            [32.73679342342269, 2.254085412244996],
            [32.73664595778226, 2.249560841994774],
            [32.73615185922317, 2.248665786833663],
            [32.73501519574135, 2.247919776209838],
            [32.72758424008295, 2.24668897790429],
            [32.72410072971799, 2.244805378469394],
            [32.721770017475684, 2.242796113300698],
            [32.71811329575429, 2.238718353572594],
            [32.717569880584385, 2.237326082659234],
            [32.71480283055744, 2.233298208929049],
            [32.71233213204778, 2.230364234331301],
            [32.71070130263322, 2.229319788355018],
            [32.70654968105546, 2.229184239121938],
            [32.70222304520253, 2.230323299493253],
            [32.69822845632298, 2.229408723373512],
            [32.69635006199589, 2.227499395232512],
            [32.69504221375688, 2.225490667399971],
            [32.69193904738829, 2.218134726081419],
            [32.68900654385567, 2.215334901139434],
            [32.68869074201586, 2.21462437184636],
            [32.6887508420033, 2.211692081822522],
            [32.687977933329485, 2.209657259456029],
            [32.68631255830234, 2.208400206176448],
            [32.68357645883019, 2.206963393153077],
            [32.6815539145444, 2.206903116024662],
            [32.67965010148804, 2.20797987521989],
            [32.67625872054201, 2.210851592206984],
            [32.67459289995047, 2.211689024439897],
            [32.67102347561007, 2.212585874053451],
            [32.667751777209325, 2.212166239957583],
            [32.66721651335235, 2.211627533885725],
            [32.66602748258103, 2.208455599141092],
            [32.664958058896545, 2.202471079744174],
            [32.661734594636656, 2.194604880032872],
            [32.66008268445731, 2.191279375372325],
            [32.65794188774417, 2.188167063037583],
            [32.65360166846579, 2.17829201195386],
            [32.646463364164035, 2.178410028118178],
            [32.64444092408281, 2.178110335085825],
            [32.64366778005038, 2.177392040326847],
            [32.64372858701198, 2.171766844626268],
            [32.643372039387486, 2.170210851313286],
            [32.64158776334936, 2.169013574119546],
            [32.63629356647691, 2.169072144501778],
            [32.632289639609965, 2.170223149405375],
            [32.63147535453417, 2.168711915115762],
            [32.628680006677456, 2.166856107594521],
            [32.626390976264304, 2.162187822253028],
            [32.62486357258337, 2.154208949868066],
            [32.625165796387655, 2.150501508151459],
            [32.62430913418665, 2.146700507896648],
            [32.62467874421367, 2.144566648497136],
            [32.63001111948566, 2.139184961534392],
            [32.63101215891917, 2.136733452828635],
            [32.639352258154105, 2.1370013991106],
            [32.64180851265233, 2.136711272687109],
            [32.645031987691986, 2.132624600386864],
            [32.64620182955051, 2.132002865214941],
            [32.654033102347285, 2.130260421505474],
            [32.65654708078903, 2.130231917910727],
            [32.658714195445064, 2.130697532215865],
            [32.6624119953278, 2.134913593056061],
            [32.66365442465452, 2.135437138462411],
            [32.67047391596366, 2.135671191738064],
            [32.67570470704841, 2.136381725011718],
            [32.677368969961215, 2.136282559789334],
            [32.67872392495538, 2.135685737927859],
            [32.6836568400818, 2.132710271723648],
            [32.68605790658055, 2.13282837939583],
            [32.690676849735375, 2.131481301645034],
            [32.69638616259221, 2.131600058444048],
            [32.69802767656875, 2.132848885396021],
            [32.69993394292415, 2.13543673629666],
            [32.7035564999187, 2.145081671569326],
            [32.708787510192344, 2.14990479955453],
            [32.715206597226526, 2.149516992388173],
            [32.71613376100767, 2.149281941209234],
            [32.717393831449954, 2.148133190687474],
            [32.71815456166349, 2.148232850664187],
            [32.72022282480732, 2.147346614629282],
            [32.723166065004214, 2.146775627060003],
            [32.72403224485567, 2.142071566565849],
            [32.7227958665807, 2.135076840086575],
            [32.72301442219776, 2.134234609391906],
            [32.72403375761861, 2.133612247383637],
            [32.73047675511071, 2.133357054030356],
            [32.73364384649325, 2.132112513079024],
            [32.73746584205723, 2.132662482136728],
            [32.74056000820504, 2.132113702522754],
            [32.74667525985728, 2.132700656533561],
            [32.74949479754797, 2.136405604486832],
            [32.75057196021861, 2.136386754773749],
            [32.75262054666449, 2.137101813871712],
            [32.77468806047086, 2.137286177040115],
            [32.77686335159261, 2.136436063137845],
            [32.77872705846479, 2.13503402288736],
            [32.78575692982357, 2.139621944030151],
            [32.78803097543946, 2.142037858397722],
            [32.79226109539999, 2.152080811116834],
            [32.7926545691725, 2.153953630682786],
            [32.79474223862146, 2.159065571852092],
            [32.798994710462864, 2.166475785960251],
            [32.803083747313075, 2.171027059309567],
            [32.81809430106329, 2.191041336097154],
            [32.82183310544547, 2.197085311744631],
            [32.822992292386424, 2.198008264073643],
            [32.82466500485279, 2.200813091066807],
            [32.83937797998705, 2.215245038904643],
            [32.83522511334435, 2.216565469863811],
            [32.833571434382215, 2.216646708361309],
            [32.83002558183485, 2.218274796855201],
            [32.828812005496715, 2.218464647250805],
            [32.82624221831962, 2.217677239975115],
            [32.82436259060565, 2.217649875344193],
            [32.82191143763994, 2.218961421993211],
            [32.821078702066494, 2.218943226796068],
            [32.8203048061442, 2.222733903590719],
            [32.82099445716083, 2.22536671888549],
            [32.821589406881955, 2.22558392387738],
            [32.82246973160587, 2.227212524044883],
            [32.82214814551395, 2.23011663163881],
            [32.82240972594152, 2.230740919524601],
            [32.82129113296994, 2.233255900794255],
            [32.819839271316184, 2.235291338725702],
            [32.81952965168213, 2.23680218052733],
            [32.81792320164607, 2.238873785317982],
            [32.81616198356464, 2.242438153914394],
            [32.81086971178187, 2.247612461138262],
            [32.81047893744673, 2.248787480344329],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 637,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "BALA",
        Population: 45740,
        Key: "KOLEBALA",
        Dist2: "Kole",
        "Sub Country": "Bala",
        id2_original: "Kole Bala",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.23109431815265, 1.92179417683138],
            [33.22960312556081, 1.928107124318554],
            [33.23064507067908, 1.933732986280764],
            [33.23008651081181, 1.938156265484136],
            [33.2303572064446, 1.943743431303759],
            [33.229354782707226, 1.945276169101446],
            [33.22582554539939, 1.945839375390755],
            [33.22196139100076, 1.944882250487653],
            [33.22228362567631, 1.946372398454714],
            [33.222059486131464, 1.950385623498273],
            [33.22418046960272, 1.956720911802084],
            [33.222999879401826, 1.95952526528717],
            [33.22264589646748, 1.961842337515867],
            [33.22142963147169, 1.96281683932045],
            [33.220355367664446, 1.965977642477176],
            [33.217981654866115, 1.966239365180828],
            [33.21182841615545, 1.963440857673721],
            [33.20803363325634, 1.964294053106038],
            [33.205969496972905, 1.963467003949817],
            [33.204912337987, 1.96370350818962],
            [33.20157286888459, 1.962910378075994],
            [33.19976057349444, 1.963130087473707],
            [33.19543142056203, 1.965595639659097],
            [33.1943071170002, 1.965680191414471],
            [33.19296456863841, 1.964937460415136],
            [33.19200351950642, 1.963567282362075],
            [33.18767808739593, 1.960193711090274],
            [33.1849930158252, 1.958809537986328],
            [33.1751258722354, 1.958169021002076],
            [33.1735315746085, 1.959085869756567],
            [33.17088044138919, 1.959131841103776],
            [33.169085036122986, 1.960482731988414],
            [33.1671743096322, 1.958245742602717],
            [33.163664961923025, 1.956417578558534],
            [33.16158294197891, 1.953485438770017],
            [33.160726805292335, 1.949003726299913],
            [33.15565950579266, 1.936021435228905],
            [33.15392664662643, 1.932672791989096],
            [33.152135657478205, 1.930235222007136],
            [33.14886983046615, 1.926737895849628],
            [33.13254161977234, 1.918631136265364],
            [33.12990808993931, 1.917836426407479],
            [33.1278539932275, 1.917942570238467],
            [33.11648552045618, 1.926681674251011],
            [33.11391911543616, 1.927837088286829],
            [33.11101497980188, 1.928516833861305],
            [33.10241975902624, 1.928608903912308],
            [33.10042128420018, 1.928034522281562],
            [33.09262833892333, 1.927416177539731],
            [33.09280217281226, 1.927277383746569],
            [33.09711152687581, 1.92259971422809],
            [33.09991139595335, 1.91852828924178],
            [33.10329425637892, 1.908829436938227],
            [33.10600844773793, 1.905735111232519],
            [33.10976571519415, 1.903391637468666],
            [33.112480167962914, 1.90027920820559],
            [33.11278263251568, 1.897791194665561],
            [33.11184246112924, 1.89373808941717],
            [33.11211088851589, 1.890662007442132],
            [33.112849532749856, 1.889494864352746],
            [33.11387201676581, 1.888979104050631],
            [33.11692163456032, 1.889711727232305],
            [33.12129154675209, 1.889394771919098],
            [33.12509324398396, 1.888326925003871],
            [33.126498615126835, 1.886481184709303],
            [33.12661356983877, 1.883034176525326],
            [33.12587847754346, 1.88262710476125],
            [33.123821106472434, 1.878908834981472],
            [33.12211485270998, 1.877443301793238],
            [33.12206954528034, 1.876448108330058],
            [33.120850510778524, 1.874783499854616],
            [33.118448355521664, 1.866342582552535],
            [33.11840705367985, 1.858001022236685],
            [33.12006794701204, 1.85798281487849],
            [33.12363297050585, 1.85660738529998],
            [33.125948811138635, 1.856272472507711],
            [33.13039409467771, 1.854209376022034],
            [33.13238960685994, 1.853838289494511],
            [33.141773558336524, 1.857022186348943],
            [33.14421109553749, 1.860577553218324],
            [33.14446480672316, 1.863816444089633],
            [33.14417581510302, 1.865553537444091],
            [33.14507073385704, 1.868774281044494],
            [33.14611137192657, 1.870583641753543],
            [33.147841786776894, 1.871877250502546],
            [33.15495964272785, 1.874328431518851],
            [33.15619402853953, 1.87450021870495],
            [33.15897619900936, 1.872835275280307],
            [33.16021166190108, 1.872509461548407],
            [33.162229442420895, 1.872780692272654],
            [33.165159114463734, 1.874037981084643],
            [33.16857114767817, 1.877240372655256],
            [33.17051163625263, 1.88012624758105],
            [33.17500031470812, 1.884966065392947],
            [33.178579799281415, 1.887616535046597],
            [33.18047283974088, 1.890601921317336],
            [33.185013084188625, 1.893632257434977],
            [33.190437639185205, 1.899458072358112],
            [33.1946846771175, 1.900950386029416],
            [33.196473386341566, 1.902822953925796],
            [33.19874474868966, 1.906333009713557],
            [33.200379997815446, 1.907789419104883],
            [33.20562403815232, 1.909444434156617],
            [33.20660760715014, 1.910294752346034],
            [33.21109373169529, 1.911189876499054],
            [33.21556023164475, 1.910157936847903],
            [33.220606790841146, 1.909922064378861],
            [33.22131194857621, 1.910026683310114],
            [33.222310293063856, 1.91100750859935],
            [33.22721808770167, 1.919637880029318],
            [33.230027703500056, 1.921564553825449],
            [33.23109431815265, 1.92179417683138],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 638,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "DOKOLO TC",
        Population: 20135,
        Key: "DOKOLODOKOLO TC",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.04324956202784, 1.837471200722837],
            [33.0408545492758, 1.843032853199169],
            [33.04041824113559, 1.84518828585277],
            [33.03557154541181, 1.845838949175891],
            [33.03387009943276, 1.847115228725691],
            [33.0319520813168, 1.847302031486098],
            [33.03218413142606, 1.849060755850414],
            [33.03348348699234, 1.851659913904289],
            [33.03250908081042, 1.85578438296224],
            [33.03254007448434, 1.858928303464991],
            [33.03134906023289, 1.860251263154388],
            [33.02474739690543, 1.855194579184012],
            [33.02060799151723, 1.859934279162544],
            [33.018965594496784, 1.862402196425537],
            [33.02393102324658, 1.864356677049196],
            [33.025862622092994, 1.865616681572455],
            [33.02741618022346, 1.865483440446868],
            [33.02875438523085, 1.866063905953528],
            [33.030491087389855, 1.867350522974753],
            [33.03175796077379, 1.869965684071989],
            [33.035451408318956, 1.870917132344586],
            [33.038276559581874, 1.873879350725708],
            [33.03934712682174, 1.874160593890943],
            [33.039442302427744, 1.874818876326318],
            [33.04120874600919, 1.875513025189167],
            [33.04605602473958, 1.875961733859975],
            [33.04684804147782, 1.876335959935015],
            [33.04738832332398, 1.877553547609121],
            [33.04826857797929, 1.878062197764699],
            [33.04833998146798, 1.879271045636087],
            [33.049121936176704, 1.880755422770821],
            [33.04888773729733, 1.881591503781041],
            [33.04947163324883, 1.881790477468544],
            [33.05035656094028, 1.883138718971085],
            [33.05058136074686, 1.885414090180996],
            [33.052236321604916, 1.887724728682621],
            [33.053159405238034, 1.888213027507158],
            [33.053216523717076, 1.888935941011434],
            [33.05807343148899, 1.891548572027941],
            [33.05944287271546, 1.891499078482827],
            [33.05514733743593, 1.893132399740783],
            [33.052138798701016, 1.893594403349192],
            [33.04758385332368, 1.89538973943369],
            [33.046106148935785, 1.895529483008787],
            [33.04108795494281, 1.898144056849041],
            [33.03952103347419, 1.900229664632145],
            [33.03792432746401, 1.900948174696506],
            [33.035405244794816, 1.903087632120471],
            [33.03109872581435, 1.903871066805072],
            [33.030149046658885, 1.904760232782793],
            [33.0185435030942, 1.911068191959149],
            [33.01000900483852, 1.914580148643912],
            [33.00063096158159, 1.906733596354333],
            [32.992772202133736, 1.90089809604095],
            [32.98212500197541, 1.890014158347112],
            [32.978641912022, 1.885689526126849],
            [32.971936504059045, 1.879283966338107],
            [32.96754865430766, 1.876497332054951],
            [32.96561491387761, 1.875891128206836],
            [32.954273771450474, 1.873882372837928],
            [32.95215022688237, 1.868282060418951],
            [32.94986650191931, 1.863803599590026],
            [32.938495604595055, 1.847527209161692],
            [32.93598579523454, 1.841773059758551],
            [32.935414973363656, 1.838081755278511],
            [32.93552215405514, 1.834553325714071],
            [32.9382228356506, 1.821109183920993],
            [32.94044731312743, 1.813364797968476],
            [32.944134872215876, 1.812813033549684],
            [32.9489879585546, 1.810949440527725],
            [32.954994753009316, 1.80791876467013],
            [32.95744519091607, 1.80610032314591],
            [32.961846202782986, 1.801965818409431],
            [32.965973823172966, 1.797017042755612],
            [32.97207588216693, 1.788223196603536],
            [32.98933491817498, 1.793669839158247],
            [32.995222721787194, 1.796700701247468],
            [32.99779195111049, 1.798654917696467],
            [33.004553357353345, 1.808769764764476],
            [33.00599533753896, 1.811492990037324],
            [33.00758904587106, 1.813329580095142],
            [33.01107991703144, 1.815093780654439],
            [33.01908696317986, 1.818015981741255],
            [33.0196073428509, 1.818803088769482],
            [33.02143454757985, 1.819354951919836],
            [33.0304263386208, 1.825140380297323],
            [33.036518267313326, 1.831921365569154],
            [33.04324956202784, 1.837471200722837],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 639,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "KWERA",
        Population: 13386,
        Key: "DOKOLOKWERA",
        Dist2: "Dokolo",
        "Sub Country": "Kwera",
        id2_original: "Dokolo Kwera",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.90392757636767, 2.249308960884588],
            [32.89915831272644, 2.252135845394777],
            [32.89801372340886, 2.25015442559259],
            [32.898742718838335, 2.245083692741871],
            [32.89710486010665, 2.242730212207284],
            [32.89625241908917, 2.243228045134639],
            [32.894017045946256, 2.239966273675364],
            [32.891794963378, 2.239838957580287],
            [32.889930286325324, 2.238781322290666],
            [32.89187379773071, 2.235642252552666],
            [32.88620254379754, 2.227761699853187],
            [32.881845529616626, 2.223337267945777],
            [32.88190990109323, 2.223192518259183],
            [32.88276663695613, 2.221871693768682],
            [32.88688324939061, 2.220297802509342],
            [32.88783521296182, 2.219528861589988],
            [32.89748379105309, 2.223998892392782],
            [32.90308136516663, 2.224613899496414],
            [32.90406243235644, 2.223248821774161],
            [32.90518464913185, 2.223161527268291],
            [32.90625826794871, 2.22062764061305],
            [32.90801763280572, 2.220753372239759],
            [32.910179006328775, 2.218960423815643],
            [32.91129611169023, 2.21744165369046],
            [32.91318907219964, 2.217965410108719],
            [32.9169011445156, 2.21774849124197],
            [32.91854308249696, 2.21655434986051],
            [32.91973302146502, 2.216744406934741],
            [32.921089360763055, 2.216554488995213],
            [32.921731861007096, 2.216002643017967],
            [32.92311316897845, 2.216035388154268],
            [32.92619320552511, 2.221259310222731],
            [32.92669282962151, 2.222815457718266],
            [32.92703747726342, 2.226850535855315],
            [32.926371296530185, 2.228786608098638],
            [32.926466172098934, 2.231175080143854],
            [32.927346555213326, 2.234079282244575],
            [32.92839337099709, 2.236015439221267],
            [32.93075814196508, 2.237570413171454],
            [32.92869370384772, 2.242502012918846],
            [32.927355639875806, 2.244745019409115],
            [32.90840589724793, 2.245948164417966],
            [32.90392757636767, 2.249308960884588],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 641,
        District: "LIRA",
        County: "LIRA  MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 23567,
        Key: "LIRACENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.95771786284247, 1.941230274433771],
            [32.954358713448826, 1.945138602264706],
            [32.95019367912557, 1.947834565285545],
            [32.94497940177069, 1.950133595402437],
            [32.94205950699139, 1.950611621793461],
            [32.93806543015156, 1.952975962592883],
            [32.93585575241905, 1.955667069467402],
            [32.935390524814885, 1.957041898261345],
            [32.93387866198833, 1.9581826692163],
            [32.933471534721804, 1.960669079852579],
            [32.93146537480847, 1.96286290303734],
            [32.928994076224186, 1.964032881339085],
            [32.92675539907768, 1.964354556794596],
            [32.925553971555445, 1.965577560927851],
            [32.92333183688492, 1.965534046102365],
            [32.92177844314616, 1.966749542084264],
            [32.92149793701217, 1.96766120590998],
            [32.92210195971761, 1.968811682754368],
            [32.92186457720885, 1.970244306371618],
            [32.919836467859874, 1.973066064008684],
            [32.91910285688648, 1.974867674985145],
            [32.91772204029357, 1.976191707676046],
            [32.91216118751221, 1.969925456481504],
            [32.90959223127677, 1.967575214206774],
            [32.904304105219, 1.963883914136285],
            [32.901858003480136, 1.962690466647037],
            [32.90022720191332, 1.963063277677336],
            [32.896891521006474, 1.962988492826471],
            [32.89334512138512, 1.961925758247417],
            [32.89178372635211, 1.959970872509697],
            [32.888799684675014, 1.958969133682241],
            [32.87899917451975, 1.953082342139274],
            [32.87399892886614, 1.948543356403284],
            [32.8691620148975, 1.94574834143657],
            [32.85178770078396, 1.936330238860494],
            [32.84798237974827, 1.941504201192339],
            [32.84323897590912, 1.945279605870594],
            [32.84323891751864, 1.945908911584913],
            [32.84434367284156, 1.947725484836135],
            [32.84428797909058, 1.951777434799939],
            [32.84105267054369, 1.954686833791747],
            [32.83982723824042, 1.955081251976445],
            [32.838552819906425, 1.955179763137721],
            [32.83237711612711, 1.95231876865711],
            [32.831151749400895, 1.952072059382461],
            [32.82453450299822, 1.953353618481132],
            [32.81865269114895, 1.95271186943684],
            [32.81698621209234, 1.952218517403497],
            [32.81247720116871, 1.948371296513524],
            [32.80943840717506, 1.946891444450741],
            [32.80639939758574, 1.947334947896191],
            [32.80345815614035, 1.950047035393069],
            [32.80242879552089, 1.950342815740723],
            [32.801252307027575, 1.951329014407398],
            [32.800075921840524, 1.951427507832837],
            [32.793948966038435, 1.951525396139169],
            [32.791596317835214, 1.950736034593505],
            [32.790224023559404, 1.949601574570331],
            [32.787185189141546, 1.948614853271935],
            [32.7842443195987, 1.948170624744231],
            [32.77953020083782, 1.948465380138658],
            [32.779532532864316, 1.94292624781624],
            [32.77869820817114, 1.934647956652724],
            [32.773316169538646, 1.935641099112126],
            [32.763038474304416, 1.935812032658118],
            [32.760526227814566, 1.935294629830904],
            [32.755901707918426, 1.932306580279407],
            [32.75527359688862, 1.932536288923884],
            [32.75439660581272, 1.934278577020947],
            [32.753035934838394, 1.935555569037589],
            [32.75167952547176, 1.93780483905702],
            [32.75050660957833, 1.938394690088433],
            [32.749223853980176, 1.938210115609511],
            [32.74676843581348, 1.936919070502307],
            [32.73987892621785, 1.931312789449195],
            [32.73749679351035, 1.930243001492331],
            [32.73181607313074, 1.929357072772699],
            [32.73064333330708, 1.928840616062333],
            [32.72972724755001, 1.927697298860097],
            [32.723753773405804, 1.924119316430627],
            [32.72111512137906, 1.922975713250445],
            [32.716130854957726, 1.921757963664211],
            [32.710138830602894, 1.919678034632249],
            [32.71019885064029, 1.91645492916896],
            [32.70966384639641, 1.914779228067949],
            [32.7065170497528, 1.908744001586819],
            [32.708068096193706, 1.88869033499315],
            [32.70909160249246, 1.885357602373374],
            [32.710650732872615, 1.883250291420024],
            [32.71609694175913, 1.878555269480781],
            [32.71773143630005, 1.873235807698002],
            [32.71763841395575, 1.871589210351836],
            [32.72009894263807, 1.864740908430075],
            [32.72007219440219, 1.863311452991786],
            [32.713877598154156, 1.842809594559332],
            [32.71345588134907, 1.835614443469634],
            [32.716566647465, 1.819273646882921],
            [32.71882069029443, 1.815286412097319],
            [32.721992935311754, 1.81284668016814],
            [32.72237658061679, 1.812086777683482],
            [32.72988615323557, 1.808378580829097],
            [32.73290470010104, 1.806117237202248],
            [32.73619515083336, 1.798490950873572],
            [32.74100022581338, 1.793271420493289],
            [32.75374134500008, 1.783411754081099],
            [32.75759987504668, 1.7815033124215],
            [32.76794022687366, 1.791899888480885],
            [32.78689383674884, 1.812774124539697],
            [32.798337600019046, 1.826092947077638],
            [32.81228586809803, 1.834372678209039],
            [32.821584970102755, 1.836174034670325],
            [32.8358921771215, 1.832936505697988],
            [32.85198811222891, 1.822135513019914],
            [32.86450704750314, 1.81494394411339],
            [32.87146200924869, 1.811723634826347],
            [32.87774648194089, 1.809371787644548],
            [32.887654974983185, 1.806830154028691],
            [32.893566752833706, 1.805952928963173],
            [32.89923633410381, 1.805746175739741],
            [32.90230932336707, 1.805682005925814],
            [32.90844692151032, 1.806351825217007],
            [32.92775169989806, 1.812061526098572],
            [32.933603565508996, 1.813120282263911],
            [32.94044731312743, 1.813364797968476],
            [32.9382228356506, 1.821109183920993],
            [32.93552215405514, 1.834553325714071],
            [32.935414973363656, 1.838081755278511],
            [32.93598579523454, 1.841773059758551],
            [32.938495604595055, 1.847527209161692],
            [32.94986650191931, 1.863803599590026],
            [32.95215022688237, 1.868282060418951],
            [32.954273771450474, 1.873882372837928],
            [32.95561220642659, 1.881192596556466],
            [32.95574834520958, 1.886747620655681],
            [32.95460791239684, 1.893704935445851],
            [32.952438431578344, 1.902444531759385],
            [32.95166989320837, 1.903466851409582],
            [32.95153351906678, 1.906778144282244],
            [32.951781330117676, 1.907619546667515],
            [32.95247564788227, 1.908144307411505],
            [32.95287206723063, 1.91034280256194],
            [32.95391338173153, 1.911962291301854],
            [32.95455764447016, 1.914034131425022],
            [32.954309492059465, 1.925931271366701],
            [32.95579697730412, 1.929894010070999],
            [32.95802800709263, 1.932988230104829],
            [32.95910641482829, 1.935295307672086],
            [32.9591063393698, 1.938443753130137],
            [32.95848641199221, 1.940388898504951],
            [32.95771786284247, 1.941230274433771],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 642,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "NAMBIESO",
        Population: 48286,
        Key: "APACNAMBIESO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.85931956599488, 1.682303157239126],
            [32.86002088163549, 1.684316468110792],
            [32.86110016163529, 1.69222698828168],
            [32.86099081869889, 1.694533806273748],
            [32.86058873816762, 1.694958997643314],
            [32.86043885785573, 1.696732249589373],
            [32.85884450273665, 1.699428215463242],
            [32.85853674531018, 1.700884800354314],
            [32.857991942243196, 1.701192366487878],
            [32.85820891862199, 1.704006079106609],
            [32.85777803720438, 1.706304050220355],
            [32.85814043465797, 1.706874054108877],
            [32.857611053867785, 1.707606387643304],
            [32.85796956341284, 1.708795103717821],
            [32.85694516418871, 1.711457938514512],
            [32.85634242966737, 1.711862220009557],
            [32.85721722615902, 1.713173091025341],
            [32.85734674974828, 1.714386084120406],
            [32.85640051653026, 1.71508380383822],
            [32.85628380651023, 1.715853323079513],
            [32.855739417566596, 1.715970666769854],
            [32.85568092376686, 1.718214029639021],
            [32.85413200273992, 1.718605196611593],
            [32.85412543425854, 1.719759486250054],
            [32.85361344036068, 1.72000073866561],
            [32.853775352707494, 1.721376769912832],
            [32.85279670827403, 1.72210057134965],
            [32.85287444488545, 1.722524469015237],
            [32.85150046537018, 1.723372144641509],
            [32.85108555959162, 1.725152459319094],
            [32.85161686008156, 1.726698075517149],
            [32.85095573596506, 1.727832749067151],
            [32.851020438920024, 1.729176166289246],
            [32.851383210072775, 1.731106532570393],
            [32.85452614485904, 1.734132715241583],
            [32.856869219716266, 1.737850324507237],
            [32.857880045396485, 1.740274080368684],
            [32.85844451438166, 1.747036486186421],
            [32.85555970869569, 1.752871046126376],
            [32.85473419198388, 1.760505901126835],
            [32.854948203023895, 1.761609682112964],
            [32.860502095658475, 1.773036786183716],
            [32.86258309331979, 1.778845277222097],
            [32.864830412259344, 1.788833608848067],
            [32.86843370757753, 1.799192975004777],
            [32.87146200924869, 1.811723634826347],
            [32.86450704750314, 1.81494394411339],
            [32.85198811222891, 1.822135513019914],
            [32.8358921771215, 1.832936505697988],
            [32.821584970102755, 1.836174034670325],
            [32.81228586809803, 1.834372678209039],
            [32.798337600019046, 1.826092947077638],
            [32.78689383674884, 1.812774124539697],
            [32.76794022687366, 1.791899888480885],
            [32.75759987504668, 1.7815033124215],
            [32.75346031514828, 1.777341994346919],
            [32.76295169345472, 1.750022143678191],
            [32.76960127920763, 1.739450479648698],
            [32.78800364329861, 1.731269408095107],
            [32.79545028354186, 1.728592744454574],
            [32.796848360364635, 1.727889508451892],
            [32.798526184244984, 1.72577952681591],
            [32.800903346573996, 1.720363695622111],
            [32.80174303690434, 1.711712118353357],
            [32.79971716885203, 1.699965335966995],
            [32.80216422280508, 1.694197811749553],
            [32.803213181070795, 1.689485221812555],
            [32.806079397020255, 1.685757557163714],
            [32.8095047082329, 1.682874006856262],
            [32.81880392073041, 1.678095543395785],
            [32.824039905874145, 1.67482652225895],
            [32.83061776204993, 1.667395847386783],
            [32.83201342869279, 1.666487129855197],
            [32.835857806680416, 1.666628133533544],
            [32.837550561459096, 1.667710232335614],
            [32.84192208163524, 1.671208522051338],
            [32.84592962961104, 1.675593625905844],
            [32.846861411631096, 1.679867446762564],
            [32.84785001119453, 1.681828222363139],
            [32.84942033817638, 1.682384364057837],
            [32.85372428887348, 1.682794392083991],
            [32.85931956599488, 1.682303157239126],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 643,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "ARWOTCEK",
        Population: 16669,
        Key: "AMOLATARARWOTCEK",
        Dist2: "Amolatar",
        "Sub Country": "Arwotcek",
        id2_original: "Amolatar Arwotcek",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.915337766002466, 2.270854635316676],
            [32.90939084875299, 2.270773784905153],
            [32.906326460858565, 2.271234995632297],
            [32.905794091373444, 2.27198587996251],
            [32.90600811229491, 2.274211508129483],
            [32.90532974052497, 2.276979909933285],
            [32.90568657111875, 2.27870795126189],
            [32.905424503804284, 2.28057165974238],
            [32.90402725163494, 2.282232328982309],
            [32.902149345093086, 2.28141955486317],
            [32.89812742407268, 2.2756840355556],
            [32.89589382150921, 2.274582416651352],
            [32.89452527320816, 2.274617125337797],
            [32.89182864121801, 2.272612834661128],
            [32.887216683362816, 2.271981417049967],
            [32.88285929188945, 2.269722461655837],
            [32.88148240003606, 2.268425726237798],
            [32.87926918653458, 2.267303193721225],
            [32.87724071606287, 2.264716912657955],
            [32.87624082557461, 2.264730266455829],
            [32.87352876142621, 2.266084622052988],
            [32.86941320361389, 2.269965504046144],
            [32.86704515828668, 2.271602829709347],
            [32.865471011668205, 2.272049583280086],
            [32.86364768945794, 2.271730984981616],
            [32.862284550811516, 2.269476289256265],
            [32.86225971329223, 2.267603516721021],
            [32.86292230884916, 2.2660384147416],
            [32.86499330915967, 2.264021085099916],
            [32.89727959680246, 2.253742295088399],
            [32.89767598740475, 2.254344845104534],
            [32.900060434172396, 2.252669018944642],
            [32.900255079331544, 2.252952304536842],
            [32.90077714334374, 2.252630662698122],
            [32.90123139982336, 2.253188402151797],
            [32.90312334254156, 2.251781885407389],
            [32.903960903864686, 2.253046739637873],
            [32.915337766002466, 2.270854635316676],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 644,
        District: "LIRA",
        County: "LIRA  MUNICIPALITY",
        Subcounty: "ADYEL DIVISION",
        Population: 31885,
        Key: "LIRAADYEL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.077390646153525, 2.0545285476465],
            [33.07706981105318, 2.0561557648289],
            [33.07773135288626, 2.059711421107642],
            [33.07957951351414, 2.063730048188946],
            [33.07975548269853, 2.067443930514733],
            [33.079004422849046, 2.067797672213028],
            [33.07767804236572, 2.067604808306056],
            [33.07638368233073, 2.068633827896268],
            [33.07622395289006, 2.070161193317178],
            [33.07655957695493, 2.070932895333832],
            [33.07508944805986, 2.072363859639136],
            [33.07529724545308, 2.073457114800357],
            [33.07499367776911, 2.074727249147048],
            [33.07373129685992, 2.076302898243459],
            [33.07285246962756, 2.078441239455683],
            [33.070391552873, 2.080161639147434],
            [33.06757897982074, 2.080017066187462],
            [33.06611322392444, 2.080393237381797],
            [33.06516762581537, 2.081597935647876],
            [33.06473594579547, 2.084153267445159],
            [33.064300424579415, 2.083949492835409],
            [33.06326739254541, 2.085060205125757],
            [33.06203175627885, 2.085213098593718],
            [33.061434253545706, 2.086782325700374],
            [33.06043157828008, 2.087291845194821],
            [33.05976314906368, 2.088178368737072],
            [33.05936820295239, 2.089645690234426],
            [33.05749448345803, 2.089768035714216],
            [33.057028991749185, 2.090395940736854],
            [33.05334430906623, 2.09233630917838],
            [33.0508689060794, 2.0957516018345],
            [33.04818511550627, 2.097847663928093],
            [33.04879794349812, 2.100276511300636],
            [33.049263634633, 2.100177862644324],
            [33.049704847574695, 2.101164190930049],
            [33.0516902060993, 2.102199784957137],
            [33.05303832311753, 2.103864190887045],
            [33.05392069689863, 2.104061429376397],
            [33.05448441489223, 2.103555909249766],
            [33.05526730474717, 2.104499261155524],
            [33.051912328028, 2.109684350102375],
            [33.0513589478467, 2.111172003289965],
            [33.05077094300106, 2.111580905413958],
            [33.05154921910871, 2.112085457004052],
            [33.051854752306504, 2.113027378185265],
            [33.05163148772073, 2.117147614464562],
            [33.04880140740187, 2.120136471151489],
            [33.04869076190834, 2.120943088814541],
            [33.04734597404656, 2.123035861908787],
            [33.04488588553868, 2.123889900761159],
            [33.03748981146277, 2.12227839615925],
            [33.03444595366585, 2.122009850347037],
            [33.028516143034366, 2.120364557940841],
            [33.02472434164366, 2.118738420728161],
            [33.02264140362134, 2.118566688692036],
            [33.020268231608796, 2.119270954916582],
            [33.0185907850209, 2.120509153200548],
            [33.01420701182428, 2.122601128827679],
            [33.010883627057034, 2.125104239036403],
            [33.00927309148303, 2.124681626354117],
            [33.00838528019954, 2.124870571960453],
            [33.005141358605684, 2.127309635050921],
            [32.99877300123225, 2.130607512336081],
            [32.994236071567926, 2.134685019176247],
            [32.98418893254465, 2.138756260997454],
            [32.980281167633926, 2.142876620634574],
            [32.97707172068574, 2.143633107638133],
            [32.9737858450732, 2.145356802365199],
            [32.97139146204017, 2.147359675040465],
            [32.97049915109541, 2.148831815793522],
            [32.968170242670176, 2.151075911803904],
            [32.96660621826837, 2.151848621244835],
            [32.96589809968607, 2.152900703070515],
            [32.96484139794265, 2.153185621669058],
            [32.96163812781037, 2.156000467590083],
            [32.961191880709805, 2.157185695639741],
            [32.96041840609735, 2.157733643088685],
            [32.95905662390703, 2.159815881989055],
            [32.95073332855777, 2.162678984542234],
            [32.94310196864097, 2.163450793106672],
            [32.941029266921305, 2.167559745678802],
            [32.940712662885915, 2.171981027783601],
            [32.9410406997799, 2.17385434612288],
            [32.9330487471249, 2.16533872536572],
            [32.93207301323296, 2.164768706853522],
            [32.921223295080324, 2.154300533017527],
            [32.92414757633315, 2.146298295662118],
            [32.92433292572573, 2.135865363252152],
            [32.924749483506126, 2.132514131170049],
            [32.921686118792834, 2.130359600581562],
            [32.9168710940727, 2.125284592729654],
            [32.909400137333044, 2.119922167621631],
            [32.904013430156006, 2.115503763092399],
            [32.899723186851816, 2.112661611152149],
            [32.89927585907801, 2.111806415252417],
            [32.89806796099078, 2.111243726369675],
            [32.89694958630983, 2.110005909396905],
            [32.89759867569645, 2.104121050760623],
            [32.8990946931397, 2.102375194926017],
            [32.89897078132604, 2.101391239158081],
            [32.89700100587669, 2.100587321541542],
            [32.88926826299522, 2.095428242378086],
            [32.88216137727052, 2.092731647256742],
            [32.88023057522973, 2.091320132525937],
            [32.87590908043516, 2.086823324551244],
            [32.87300630305362, 2.084579378758585],
            [32.87697283215693, 2.082127898852559],
            [32.87829551607284, 2.079531448925742],
            [32.879506232175125, 2.078491110732519],
            [32.8808377591067, 2.077821718004504],
            [32.887189216474695, 2.076193686340755],
            [32.888573886840156, 2.075008598371974],
            [32.89178069992792, 2.073597454679848],
            [32.894232605681864, 2.071269990574595],
            [32.895937943162714, 2.07244330315603],
            [32.89708870749954, 2.072429521240351],
            [32.90491722516335, 2.07563371196294],
            [32.90815306461456, 2.076016904416251],
            [32.910865362324955, 2.078075688774666],
            [32.91482033729713, 2.079968581043833],
            [32.918251233335894, 2.080443048449477],
            [32.926370307485044, 2.078388217164902],
            [32.93001086671787, 2.075700770289906],
            [32.932368112498736, 2.07264437170444],
            [32.934882390977776, 2.071985748339053],
            [32.93558958070205, 2.070589272635638],
            [32.93553725204013, 2.069324509676509],
            [32.93460789547137, 2.065837286510116],
            [32.93560725415694, 2.064444052492374],
            [32.93594033868452, 2.062480814144004],
            [32.93793904437763, 2.059775768050388],
            [32.93993762161163, 2.060327727664146],
            [32.94211466714311, 2.060318761091477],
            [32.943352015598606, 2.059576932335124],
            [32.94399439546838, 2.060291687212623],
            [32.945897730621006, 2.060273658906925],
            [32.94634987516142, 2.06065365913556],
            [32.94730168781565, 2.06049084063666],
            [32.94934782635237, 2.059007158699937],
            [32.950799290052444, 2.058717692906283],
            [32.95227433093551, 2.059387234640433],
            [32.95329746892498, 2.061033863059172],
            [32.95492706046107, 2.062146721751284],
            [32.956069127309334, 2.061812006261246],
            [32.95713979066892, 2.062436295547405],
            [32.95940032831789, 2.061359732442387],
            [32.96011411167632, 2.061459270488148],
            [32.96318335676151, 2.062915951715156],
            [32.96566948383619, 2.064888307789961],
            [32.969309793337345, 2.065205035678357],
            [32.97123700032034, 2.066299789599833],
            [32.974996453377635, 2.06747599565346],
            [32.977054359844566, 2.067222703662725],
            [32.97968220154522, 2.064743794481191],
            [32.98231285407438, 2.061387296465821],
            [32.98829693283052, 2.050693504967538],
            [32.99090225556359, 2.046757967921315],
            [32.99644529834616, 2.041863427945549],
            [33.00291705809699, 2.037439323280601],
            [33.01267605171309, 2.029993388445068],
            [33.01722363539673, 2.025777327249686],
            [33.02874582069292, 2.017517021786528],
            [33.034155169906704, 2.012694731282995],
            [33.036334660652415, 2.011789958431442],
            [33.039871709709985, 2.011102284583645],
            [33.044884916256514, 2.011102153510388],
            [33.04897673159588, 2.012413886453651],
            [33.053672789727976, 2.015725030338935],
            [33.05504024927091, 2.017633953919806],
            [33.05575352418291, 2.019705749076254],
            [33.057329275192465, 2.031204745663212],
            [33.05985582286167, 2.037809143088195],
            [33.064383746016965, 2.043544920336447],
            [33.067158040058374, 2.046313263195537],
            [33.077390646153525, 2.0545285476465],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 645,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "AMACH",
        Population: 34822,
        Key: "LIRAAMACH",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.903960903864686, 2.253046739637873],
            [32.90312334254156, 2.251781885407389],
            [32.90123139982336, 2.253188402151797],
            [32.90077714334374, 2.252630662698122],
            [32.900255079331544, 2.252952304536842],
            [32.900060434172396, 2.252669018944642],
            [32.89767598740475, 2.254344845104534],
            [32.89727959680246, 2.253742295088399],
            [32.86499330915967, 2.264021085099916],
            [32.866284525091196, 2.260393277300701],
            [32.8658381028192, 2.252395510187905],
            [32.86664966779631, 2.250559002901598],
            [32.868885429011414, 2.247510298935758],
            [32.87372342634829, 2.244525150405126],
            [32.87503242532915, 2.242824388555408],
            [32.8762108191492, 2.236753813485285],
            [32.87898324738974, 2.231434287271826],
            [32.87974516158282, 2.228077835667687],
            [32.881845529616626, 2.223337267945777],
            [32.88620254379754, 2.227761699853187],
            [32.89187379773071, 2.235642252552666],
            [32.889930286325324, 2.238781322290666],
            [32.891794963378, 2.239838957580287],
            [32.894017045946256, 2.239966273675364],
            [32.89625241908917, 2.243228045134639],
            [32.89710486010665, 2.242730212207284],
            [32.898742718838335, 2.245083692741871],
            [32.89801372340886, 2.25015442559259],
            [32.89915831272644, 2.252135845394777],
            [32.90392757636767, 2.249308960884588],
            [32.903960903864686, 2.253046739637873],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 646,
        District: "LIRA",
        County: "LIRA  MUNICIPALITY",
        Subcounty: "OJWINA DIVISION",
        Population: 38167,
        Key: "LIRAOJWINA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.96221368919267, 1.65185475964784],
            [32.953293902613304, 1.661869995735516],
            [32.94683799722891, 1.665746104091928],
            [32.94576977189703, 1.663625085509151],
            [32.94471046503925, 1.662899697140399],
            [32.94295486412331, 1.659968327653184],
            [32.9409876425843, 1.659226392524333],
            [32.93997237293837, 1.655987434518119],
            [32.93881374025796, 1.655299805334693],
            [32.93779281212408, 1.653426986284427],
            [32.937124234685655, 1.650513740322163],
            [32.93690072306321, 1.646505787529924],
            [32.9359815075757, 1.644605828784161],
            [32.935138114389716, 1.64384582933457],
            [32.93287857746401, 1.642668972521864],
            [32.929873411004664, 1.642032197523844],
            [32.92328310238241, 1.641660563513792],
            [32.91658731178289, 1.642243907233848],
            [32.91374026588155, 1.642880454984058],
            [32.90989144752147, 1.644418901717836],
            [32.90530455176439, 1.645002302100684],
            [32.90298471452692, 1.645851081800681],
            [32.896394172342696, 1.649936042592501],
            [32.8911215305455, 1.656673841366919],
            [32.88969782927926, 1.659963219282218],
            [32.88730930775344, 1.663254188256425],
            [32.881075139818826, 1.667626232331432],
            [32.87774669753653, 1.658784755723388],
            [32.874406137879376, 1.647510745984893],
            [32.87233870837212, 1.642068421579333],
            [32.87035765547267, 1.64128692701342],
            [32.864426238653444, 1.633995657171958],
            [32.858470047196995, 1.629839584668406],
            [32.85182171728885, 1.62612889935375],
            [32.86809238010893, 1.619943712460792],
            [32.86789903840527, 1.617899359556954],
            [32.8655777449987, 1.611960887164959],
            [32.86325659981416, 1.603978072773813],
            [32.864610951140484, 1.603296716066942],
            [32.86719511585368, 1.603409953763568],
            [32.86732903579791, 1.602566190221483],
            [32.866950256666776, 1.601970508707089],
            [32.87078600094624, 1.598587429454421],
            [32.878576058139444, 1.587961395389287],
            [32.88309665373698, 1.58339343072179],
            [32.88341498433432, 1.582615420211531],
            [32.87975485889632, 1.577675694823971],
            [32.87894626195288, 1.575186134670572],
            [32.878737029950166, 1.558711500901377],
            [32.8774805114465, 1.540896450203034],
            [32.876901074732054, 1.524054932346071],
            [32.87757907459947, 1.508576379524751],
            [32.87738598711905, 1.501859244143147],
            [32.87786875971903, 1.480658618191183],
            [32.8945464402112, 1.481228293905714],
            [32.92133820667318, 1.480885621191431],
            [32.92775523207375, 1.480333952395138],
            [32.946266309382096, 1.479701173784449],
            [32.94739397174477, 1.479221693500643],
            [32.94965264718613, 1.479339359625868],
            [32.97368007832994, 1.477186523572353],
            [32.97450535070001, 1.557535576717849],
            [32.973336281392626, 1.563615343807465],
            [32.96969627462372, 1.57279829526063],
            [32.96732216117675, 1.582388388477131],
            [32.96796338311813, 1.593534661154263],
            [32.966848301661, 1.61159303341444],
            [32.966170872223785, 1.61550145063345],
            [32.96404596041982, 1.621237394936564],
            [32.96277603995043, 1.622929214577666],
            [32.95189073593614, 1.631650566878952],
            [32.9482219579253, 1.636581245074918],
            [32.945131844077764, 1.642146439649554],
            [32.96221368919267, 1.65185475964784],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 647,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "MUNTU",
        Population: 13264,
        Key: "AMOLATARMUNTU",
        Dist2: "Amolatar",
        "Sub Country": "Muntu",
        id2_original: "Amolatar Muntu",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.21319551277902, 2.089202159175504],
            [33.21141455062596, 2.090324252608539],
            [33.20863923340345, 2.090695561097335],
            [33.20548218877905, 2.090306950898768],
            [33.200625197463815, 2.091755133780066],
            [33.198428057517724, 2.090868790902732],
            [33.19446139097216, 2.090507403130048],
            [33.19351335034381, 2.091529853554084],
            [33.18731500632442, 2.092833406968615],
            [33.185140952182806, 2.094670248798046],
            [33.182817315071674, 2.100686910076043],
            [33.18038909609516, 2.104061799232773],
            [33.17746356348915, 2.105934907860722],
            [33.172606823702196, 2.107826322083072],
            [33.170016307899914, 2.107591382146896],
            [33.16278835712269, 2.105040847336366],
            [33.15980468465317, 2.104715458286496],
            [33.15560677827876, 2.105123011054596],
            [33.153224501840796, 2.104842784873873],
            [33.14966234936261, 2.103124162783119],
            [33.14632050241965, 2.104164911055646],
            [33.13970582789363, 2.108300099693649],
            [33.13554274021962, 2.108608076069532],
            [33.13481405560721, 2.105523038223338],
            [33.13182994296321, 2.099941161142805],
            [33.13149416618474, 2.097136551022973],
            [33.132419043753494, 2.094132794797931],
            [33.134870351229445, 2.090178949840085],
            [33.13564514906032, 2.087139016564739],
            [33.13550623088982, 2.086044314782033],
            [33.13418771964842, 2.083230743000403],
            [33.13128477877349, 2.079937800800507],
            [33.12837038887027, 2.077404819113143],
            [33.12228711185226, 2.073334053463825],
            [33.11752238739816, 2.06902793664047],
            [33.11383332991978, 2.067318280553949],
            [33.10987825074304, 2.066965719264833],
            [33.10253502725023, 2.068124260189051],
            [33.09640603496742, 2.068586056098978],
            [33.09216205939197, 2.068152042243561],
            [33.08915538915286, 2.067292727549969],
            [33.085223531426216, 2.06494971086032],
            [33.083639047893804, 2.0630227334714],
            [33.0795431595929, 2.056355129737747],
            [33.07794224767058, 2.054961812014889],
            [33.08621440552397, 2.050318771205134],
            [33.090593918909484, 2.048927830825636],
            [33.09859469212228, 2.042493693225957],
            [33.10448933101548, 2.035029348269664],
            [33.10873119105843, 2.034585751713492],
            [33.11337987024582, 2.032893596367114],
            [33.11568097401636, 2.03139159184297],
            [33.11646725950308, 2.031554385465793],
            [33.11942762248762, 2.030160893608244],
            [33.121555439443235, 2.030088356189057],
            [33.123868092853385, 2.029111078010331],
            [33.12507081664456, 2.029011466137492],
            [33.127013372242494, 2.028016118241147],
            [33.12741796805658, 2.02723802418952],
            [33.128620646932, 2.026604622481427],
            [33.13055791055461, 2.026233529786519],
            [33.1318584294392, 2.026215329627554],
            [33.1366458174896, 2.023835509625841],
            [33.1382991434138, 2.022170678803203],
            [33.14054263463193, 2.021057675723446],
            [33.14116692961843, 2.019772915678988],
            [33.14528334172859, 2.018614505059307],
            [33.146162408811136, 2.0193834398385],
            [33.1477118607424, 2.018985220643239],
            [33.14946971732805, 2.020523086793607],
            [33.15128535445105, 2.02085766454673],
            [33.152303006429115, 2.022069896727648],
            [33.154083776342695, 2.022160199299052],
            [33.15475447739843, 2.021418263161344],
            [33.15503199214252, 2.020115436940517],
            [33.156696885672645, 2.019183412296027],
            [33.15935659151474, 2.018667461099079],
            [33.160015879474805, 2.019056426287113],
            [33.16170418220293, 2.019029115603596],
            [33.164502376820785, 2.018051733800363],
            [33.16621387315123, 2.016748759443858],
            [33.167532070880604, 2.016585774009415],
            [33.172176956482545, 2.014273661544752],
            [33.17517482413016, 2.014847839252038],
            [33.179528762479556, 2.014667831200022],
            [33.18234791838628, 2.012800394168405],
            [33.184938841125344, 2.007747188469882],
            [33.18553770031457, 2.0052128684052],
            [33.18523194613119, 2.004610095273342],
            [33.18559872377013, 2.004204080762359],
            [33.18557398686215, 2.001706737831199],
            [33.18597743912086, 2.001239208478977],
            [33.18562272944947, 2.000218166550706],
            [33.18599728470214, 1.997729376882175],
            [33.18902684760792, 1.998099963437167],
            [33.19050715261853, 1.997819327976605],
            [33.19271736484865, 1.999093403891802],
            [33.19340539440622, 1.999930394195928],
            [33.194426936987746, 2.000036464594893],
            [33.19683115747144, 1.997857110594955],
            [33.19736747595057, 2.003265602860174],
            [33.19651805596737, 2.008014714880483],
            [33.198885277539475, 2.016314595125341],
            [33.200139042706795, 2.019318041801818],
            [33.20533665182156, 2.025346365838783],
            [33.209329511444196, 2.040009209280502],
            [33.21091348024197, 2.042683328286137],
            [33.21471624736731, 2.04843534083469],
            [33.21689851660218, 2.046566554017414],
            [33.219059233456754, 2.042459968553599],
            [33.22035736821258, 2.042133268496539],
            [33.22603689023964, 2.042050842957226],
            [33.22664054373751, 2.043594006282653],
            [33.22507101086636, 2.045232989627395],
            [33.223763301866235, 2.04838055348188],
            [33.22393426563787, 2.050536355578894],
            [33.22632455864139, 2.057594910937196],
            [33.22567980272769, 2.057442379284625],
            [33.222948809279615, 2.054886300613048],
            [33.223612866395506, 2.057480827528963],
            [33.22209618051421, 2.059903960094338],
            [33.222077540472064, 2.062231491134539],
            [33.22010581657684, 2.06520794971576],
            [33.21910123957776, 2.06852767851908],
            [33.217642173435415, 2.076407137637334],
            [33.217642286623146, 2.077227495098238],
            [33.21870453276853, 2.079535798396914],
            [33.22043034914291, 2.080832866726276],
            [33.22267348013659, 2.08503643528159],
            [33.21862272229727, 2.086098225557941],
            [33.21319551277902, 2.089202159175504],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 648,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "BATTA",
        Population: 18490,
        Key: "DOKOLOBATTA",
        Dist2: "Dokolo",
        "Sub Country": "Bata",
        id2_original: "Dokolo Bata",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.87300630305362, 2.084579378758585],
            [32.87063925305973, 2.084660609920548],
            [32.868817157049804, 2.084081435396815],
            [32.86649381189117, 2.082434645110122],
            [32.86429292866527, 2.081574969213095],
            [32.86280110545611, 2.0802177567285],
            [32.860551064621255, 2.079186174488632],
            [32.86004025021134, 2.078272360450481],
            [32.85557195812291, 2.082126069294723],
            [32.854683498255774, 2.08379972241695],
            [32.85368384582109, 2.084441981686917],
            [32.8512822250618, 2.087581138787076],
            [32.84922680872483, 2.096637202234103],
            [32.84865864856214, 2.104671071949308],
            [32.8461613087161, 2.103368027528169],
            [32.84264068176024, 2.10288817181708],
            [32.8408695193286, 2.101567098073318],
            [32.838715785977065, 2.098472730735914],
            [32.83751308284712, 2.09772168693114],
            [32.83276785542796, 2.096472669221768],
            [32.83020975353608, 2.09338729499916],
            [32.82835264748461, 2.091812877610152],
            [32.8246583573197, 2.094083314523266],
            [32.820426797359765, 2.098335016192835],
            [32.81949740755335, 2.098732984850343],
            [32.818140059447245, 2.098787109743364],
            [32.81329761185645, 2.097556116276174],
            [32.808362861471885, 2.095139915276063],
            [32.807412343289975, 2.093665104787749],
            [32.807175248242125, 2.090643313051653],
            [32.806533267224324, 2.089394720606236],
            [32.80484226056717, 2.087937912060287],
            [32.799169573821125, 2.085675394925299],
            [32.793623609717265, 2.096585579195398],
            [32.78988718676889, 2.102501936397147],
            [32.7826654217907, 2.116831669981363],
            [32.78175723042836, 2.114225955017075],
            [32.78059640585867, 2.10756706863405],
            [32.77570591187488, 2.100482429320035],
            [32.7722692127194, 2.09643140130889],
            [32.7721053977408, 2.093773719394945],
            [32.7725282895423, 2.09198671773942],
            [32.773152863904805, 2.089848145358514],
            [32.77391440170376, 2.088747137195616],
            [32.77462867464408, 2.085396009121814],
            [32.77358334377548, 2.07443254439395],
            [32.773234715698564, 2.066519267800352],
            [32.77346124655869, 2.064094365104553],
            [32.774268409790935, 2.063497366647548],
            [32.77568671936886, 2.063352813712057],
            [32.77741135895021, 2.061027932627346],
            [32.77733826303556, 2.059236581221305],
            [32.77846352599812, 2.056649245338214],
            [32.77902652444118, 2.053699942613437],
            [32.779992887108065, 2.051990159649456],
            [32.779993038923344, 2.050877355817661],
            [32.779503898166304, 2.050117325479029],
            [32.77950403650686, 2.049104040308402],
            [32.77886821972855, 2.048244470264635],
            [32.7785262562527, 2.045982627321413],
            [32.778783475359596, 2.043259461070325],
            [32.776631527858825, 2.040879752388909],
            [32.77570225483336, 2.040626300871257],
            [32.77421053493046, 2.039377580247294],
            [32.774088538324975, 2.037631456469552],
            [32.77296348107662, 2.036817051361347],
            [32.77275593970327, 2.03592135115092],
            [32.771092973957714, 2.035495896541134],
            [32.76938129437096, 2.03380382923118],
            [32.769063315913215, 2.032917159608805],
            [32.76750808242476, 2.031786038334388],
            [32.766226677892774, 2.031758709910474],
            [32.76390317822387, 2.032473096539575],
            [32.76338952423937, 2.032246841941919],
            [32.76312082286653, 2.030699735595748],
            [32.76074878722283, 2.028980420973003],
            [32.75918332551656, 2.030572488345867],
            [32.75829060134674, 2.030264750876523],
            [32.75689669899511, 2.030879748153103],
            [32.75535601551931, 2.030246211412861],
            [32.755625274745945, 2.028029696749426],
            [32.752544018287125, 2.02608408432779],
            [32.75170023882556, 2.023641219286695],
            [32.7478436868692, 2.021740714738489],
            [32.74601295625278, 2.019677674412255],
            [32.74601279725099, 2.018890570952659],
            [32.742707522519865, 2.010890401075708],
            [32.74233854850006, 2.008621460257911],
            [32.74085243677947, 2.004233350618901],
            [32.73778527398911, 2.000641136392383],
            [32.73815954986573, 1.998404168875396],
            [32.74198470929618, 1.992053972143016],
            [32.74627032178507, 1.987372658831926],
            [32.74753245655589, 1.985467512870364],
            [32.74967220673174, 1.976289742665503],
            [32.753634838045045, 1.975229638090745],
            [32.76014208933446, 1.974755110211514],
            [32.76228705512882, 1.973767869569595],
            [32.76966751738341, 1.967880183885146],
            [32.770290260979394, 1.966607837316232],
            [32.76879358417274, 1.959805268899702],
            [32.76909318130315, 1.95729621019908],
            [32.76889459253991, 1.950621976060246],
            [32.769643058054875, 1.948163161365661],
            [32.77029151143429, 1.947611249233052],
            [32.77238626589586, 1.947661717058254],
            [32.77418171607781, 1.948113598533962],
            [32.77953020083782, 1.948465380138658],
            [32.7842443195987, 1.948170624744231],
            [32.787185189141546, 1.948614853271935],
            [32.790224023559404, 1.949601574570331],
            [32.791596317835214, 1.950736034593505],
            [32.793948966038435, 1.951525396139169],
            [32.800075921840524, 1.951427507832837],
            [32.801252307027575, 1.951329014407398],
            [32.80242879552089, 1.950342815740723],
            [32.80345815614035, 1.950047035393069],
            [32.80639939758574, 1.947334947896191],
            [32.80943840717506, 1.946891444450741],
            [32.81247720116871, 1.948371296513524],
            [32.81698621209234, 1.952218517403497],
            [32.81865269114895, 1.95271186943684],
            [32.82453450299822, 1.953353618481132],
            [32.831151749400895, 1.952072059382461],
            [32.83237711612711, 1.95231876865711],
            [32.838552819906425, 1.955179763137721],
            [32.83982723824042, 1.955081251976445],
            [32.84105267054369, 1.954686833791747],
            [32.84428797909058, 1.951777434799939],
            [32.84434367284156, 1.947725484836135],
            [32.84323891751864, 1.945908911584913],
            [32.84323897590912, 1.945279605870594],
            [32.84798237974827, 1.941504201192339],
            [32.85178770078396, 1.936330238860494],
            [32.8691620148975, 1.94574834143657],
            [32.869134171615265, 1.946793293718326],
            [32.86719381688978, 1.949575877873486],
            [32.86593142969238, 1.953782839926974],
            [32.866882277556, 1.96395636290374],
            [32.866405790468036, 1.972214768285616],
            [32.86525762675394, 1.977034350348513],
            [32.86063320836743, 1.986578793068426],
            [32.86048431350743, 1.989464846595822],
            [32.86191485185128, 1.990161604209156],
            [32.863744211638604, 1.989953670893109],
            [32.86552941114484, 1.990252377179863],
            [32.86879450064004, 1.992650158442076],
            [32.871034619582595, 1.993383163137864],
            [32.87338793792902, 1.994749478580904],
            [32.87558466824333, 1.997056692574948],
            [32.87904479186819, 1.999626366798682],
            [32.88070972672081, 2.000051709593826],
            [32.88447282963312, 2.002060467016162],
            [32.885953545173805, 2.004847120617905],
            [32.885953461630514, 2.006059449995336],
            [32.88715340962746, 2.009515578421214],
            [32.88843338134657, 2.009841367544155],
            [32.89097494794898, 2.012193821816842],
            [32.89352068363266, 2.015378619058088],
            [32.89407949682481, 2.017142866554515],
            [32.89411269047289, 2.020951755718153],
            [32.89350834886552, 2.023548272908979],
            [32.88945843184927, 2.031609086309897],
            [32.88860623247858, 2.034087969585107],
            [32.88827313896787, 2.035426936889442],
            [32.8884748853093, 2.039823906427296],
            [32.88787989785897, 2.045035071392491],
            [32.889509016881256, 2.052110120948291],
            [32.89308933688775, 2.062107559023667],
            [32.894295417683146, 2.068456322455099],
            [32.89455917203373, 2.071065610131335],
            [32.894232605681864, 2.071269990574595],
            [32.89178069992792, 2.073597454679848],
            [32.888573886840156, 2.075008598371974],
            [32.887189216474695, 2.076193686340755],
            [32.8808377591067, 2.077821718004504],
            [32.879506232175125, 2.078491110732519],
            [32.87829551607284, 2.079531448925742],
            [32.87697283215693, 2.082127898852559],
            [32.87300630305362, 2.084579378758585],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 649,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "ABONGOMOLA",
        Population: 34189,
        Key: "APACABONGOMOLA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.77872705846479, 2.13503402288736],
            [32.77686335159261, 2.136436063137845],
            [32.77468806047086, 2.137286177040115],
            [32.75262054666449, 2.137101813871712],
            [32.75057196021861, 2.136386754773749],
            [32.74949479754797, 2.136405604486832],
            [32.74667525985728, 2.132700656533561],
            [32.74056000820504, 2.132113702522754],
            [32.73746584205723, 2.132662482136728],
            [32.73364384649325, 2.132112513079024],
            [32.73047675511071, 2.133357054030356],
            [32.72403375761861, 2.133612247383637],
            [32.72301442219776, 2.134234609391906],
            [32.7227958665807, 2.135076840086575],
            [32.72403224485567, 2.142071566565849],
            [32.723166065004214, 2.146775627060003],
            [32.72022282480732, 2.147346614629282],
            [32.71815456166349, 2.148232850664187],
            [32.717393831449954, 2.148133190687474],
            [32.71613376100767, 2.149281941209234],
            [32.715206597226526, 2.149516992388173],
            [32.708787510192344, 2.14990479955453],
            [32.7035564999187, 2.145081671569326],
            [32.69993394292415, 2.13543673629666],
            [32.69802767656875, 2.132848885396021],
            [32.69638616259221, 2.131600058444048],
            [32.690676849735375, 2.131481301645034],
            [32.68605790658055, 2.13282837939583],
            [32.6836568400818, 2.132710271723648],
            [32.67872392495538, 2.135685737927859],
            [32.677368969961215, 2.136282559789334],
            [32.67570470704841, 2.136381725011718],
            [32.67047391596366, 2.135671191738064],
            [32.66365442465452, 2.135437138462411],
            [32.6624119953278, 2.134913593056061],
            [32.658714195445064, 2.130697532215865],
            [32.65654708078903, 2.130231917910727],
            [32.654033102347285, 2.130260421505474],
            [32.64620182955051, 2.132002865214941],
            [32.645031987691986, 2.132624600386864],
            [32.64180851265233, 2.136711272687109],
            [32.639352258154105, 2.1370013991106],
            [32.63101215891917, 2.136733452828635],
            [32.63001111948566, 2.139184961534392],
            [32.62467874421367, 2.144566648497136],
            [32.624881003493144, 2.137971402789113],
            [32.62444641742331, 2.136152839851531],
            [32.62307131501394, 2.134035492285145],
            [32.62046761823151, 2.124861147033331],
            [32.6175792031147, 2.122815799145208],
            [32.61536800633107, 2.122127671574849],
            [32.59904752294533, 2.120386469905177],
            [32.597454663521184, 2.119408976415756],
            [32.59690785002459, 2.118115108986425],
            [32.59686020877183, 2.114342490427498],
            [32.60028310261805, 2.101994196624089],
            [32.60123387412484, 2.095010138931971],
            [32.60117443529746, 2.092250781044812],
            [32.59966469249499, 2.082741971236302],
            [32.59560169870316, 2.074614438150115],
            [32.5995013599117, 2.071954440973963],
            [32.603657221537595, 2.067721863373583],
            [32.606107950498476, 2.065846818622486],
            [32.608824704751, 2.065204410857019],
            [32.6163196429155, 2.065476502568078],
            [32.61718774426334, 2.064456197013867],
            [32.6171353500244, 2.060812040117299],
            [32.6152192740661, 2.054487915134907],
            [32.61532656345374, 2.051326111672748],
            [32.61633920822238, 2.048861200490524],
            [32.62044187251546, 2.043878279569757],
            [32.622307296966454, 2.039109177423721],
            [32.62236094974513, 2.037447887790556],
            [32.62129598529771, 2.035947104853968],
            [32.62081708263995, 2.033856966119636],
            [32.61854032411192, 2.02937099335588],
            [32.618359174343304, 2.027360931963829],
            [32.6184804549915, 2.026508225309428],
            [32.62090277473154, 2.023463314751207],
            [32.62296125432362, 2.022976520419323],
            [32.631012921588834, 2.023770211419345],
            [32.63349510056783, 2.023648957935173],
            [32.63736994940991, 2.022431640250035],
            [32.6384596741215, 2.022431885337346],
            [32.643423684431475, 2.023773007028323],
            [32.6477819445757, 2.026758550374419],
            [32.648689695763565, 2.028403314410085],
            [32.65117179389419, 2.028708405660145],
            [32.65323029055428, 2.028160661792662],
            [32.66110165875546, 2.022924085218217],
            [32.662675986833584, 2.021584397439846],
            [32.6629067298941, 2.020588858248579],
            [32.66340027868423, 2.024148875444368],
            [32.66791512686059, 2.023609064394046],
            [32.670064958828874, 2.023825805792733],
            [32.67318199877873, 2.025232390565481],
            [32.67417469555817, 2.026326398803411],
            [32.67698607654608, 2.032929963317747],
            [32.679963392536635, 2.037203089120674],
            [32.68497787019928, 2.038557287701366],
            [32.687573592636944, 2.040700301141558],
            [32.69468656265106, 2.048969309150447],
            [32.69810540868859, 2.051966284274231],
            [32.699870101453556, 2.052854419263965],
            [32.70538520034255, 2.053354839414083],
            [32.705219459376, 2.054908458572579],
            [32.70356408978451, 2.05929166265897],
            [32.70372931062653, 2.060567905751366],
            [32.70417047685581, 2.060845425956898],
            [32.707700338492806, 2.060180232564409],
            [32.70858272305366, 2.06045783273585],
            [32.71139480472751, 2.064231500010254],
            [32.714923215585294, 2.07172296000319],
            [32.716081391023245, 2.071889631296908],
            [32.71806701455083, 2.071168650505086],
            [32.7249127213949, 2.065475976497327],
            [32.7312680990108, 2.074589677058516],
            [32.736127268740596, 2.080310108212946],
            [32.74355401219861, 2.090806041366586],
            [32.74471927175087, 2.091620476269656],
            [32.74814514081731, 2.092820099225383],
            [32.750846125145024, 2.092421916306285],
            [32.75588085442744, 2.089872459146905],
            [32.757742555361595, 2.087161989202357],
            [32.75891260023936, 2.086520146686899],
            [32.76438988005492, 2.08787636445268],
            [32.7675980693617, 2.089963418602335],
            [32.7725282895423, 2.09198671773942],
            [32.7721053977408, 2.093773719394945],
            [32.7722692127194, 2.09643140130889],
            [32.77570591187488, 2.100482429320035],
            [32.78059640585867, 2.10756706863405],
            [32.78175723042836, 2.114225955017075],
            [32.7826654217907, 2.116831669981363],
            [32.78339525265341, 2.118804057942232],
            [32.78188884439727, 2.121581328160372],
            [32.78046655618096, 2.127624638403058],
            [32.779645656809734, 2.133668032687963],
            [32.77872705846479, 2.13503402288736],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 650,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "INOMO",
        Population: 29612,
        Key: "APACINOMO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.52680366391677, 1.857433162488129],
            [32.52302498421744, 1.860369299725057],
            [32.51842543029969, 1.867175825194466],
            [32.51406692132214, 1.871511441586001],
            [32.51014309094087, 1.872916402789573],
            [32.50736971228277, 1.874853583910666],
            [32.50535609006438, 1.877368057994155],
            [32.50370528930442, 1.878579874579972],
            [32.49994820240958, 1.879580961095895],
            [32.49677613166542, 1.881085146816691],
            [32.4937203783775, 1.88096537343857],
            [32.49236395104456, 1.88052167774812],
            [32.49003298457904, 1.878530673359553],
            [32.48887721393112, 1.875001193265163],
            [32.476899946603545, 1.873321836470937],
            [32.47347540884037, 1.87869132880657],
            [32.46877509988035, 1.88503308744279],
            [32.46610280235294, 1.890334475907218],
            [32.459855454336484, 1.894615905826835],
            [32.45881502108283, 1.895946056108809],
            [32.45909474658084, 1.893189507692595],
            [32.45864404114155, 1.891567942619203],
            [32.45510073621632, 1.885470279009742],
            [32.452716822149625, 1.882161825645246],
            [32.448850612405636, 1.878139476920673],
            [32.44704589789815, 1.877814618572702],
            [32.44511261830384, 1.876387151714325],
            [32.444339455406805, 1.875349196504264],
            [32.44369569931801, 1.87275471968849],
            [32.44021637600059, 1.868408203027616],
            [32.43763849859604, 1.867110239899627],
            [32.43540631626904, 1.866708361121677],
            [32.43022584251831, 1.867367261372825],
            [32.429194548724354, 1.867302067542614],
            [32.42842125287665, 1.866718105363551],
            [32.427583647536075, 1.865680124678945],
            [32.425909132150935, 1.861463897817787],
            [32.42384733418218, 1.858933815320256],
            [32.42301038730667, 1.855885281783921],
            [32.42185090571834, 1.853614921778411],
            [32.42155095105843, 1.849278238750586],
            [32.4203064591998, 1.845896487838249],
            [32.41463501392548, 1.843754353204257],
            [32.410317846315614, 1.839537250824358],
            [32.403102343493266, 1.828833540402703],
            [32.40129808622827, 1.827341239220211],
            [32.398784264093386, 1.827534962047355],
            [32.3967218238292, 1.827145128068438],
            [32.39253203642829, 1.827727410792736],
            [32.38705343069939, 1.827466110675906],
            [32.3811223327821, 1.831031145454706],
            [32.37454691193904, 1.833882509506132],
            [32.37138871836938, 1.833557115088503],
            [32.3709376904349, 1.833102963638647],
            [32.36913480849059, 1.827784139272425],
            [32.36501071758138, 1.824864160967735],
            [32.35746927902449, 1.825510020956284],
            [32.353423546360865, 1.824855537025372],
            [32.32975770778017, 1.805542063126373],
            [32.3076686119491, 1.792289484916686],
            [32.30239306859351, 1.788062704531171],
            [32.29477986632353, 1.780596339172286],
            [32.2901808945141, 1.777165907788561],
            [32.28743648921882, 1.77592546198651],
            [32.28519442722032, 1.775417981586521],
            [32.27788823587679, 1.774248115526192],
            [32.27260146537681, 1.773927030165599],
            [32.270903791423635, 1.772969505848754],
            [32.270564316281146, 1.772627638708861],
            [32.27020143553391, 1.76969417834896],
            [32.27048526543443, 1.765197306099018],
            [32.268144368093445, 1.760043409853811],
            [32.266640741919744, 1.75357634604935],
            [32.265562969293, 1.751286361476022],
            [32.264216158425185, 1.746361287631795],
            [32.25922279925653, 1.741003772001425],
            [32.25617819585795, 1.738930912559818],
            [32.24566410087188, 1.733598324089591],
            [32.22556468805517, 1.724905555223567],
            [32.2070958558197, 1.719488136732686],
            [32.20004231564983, 1.721041150918795],
            [32.19221052183018, 1.724737792736074],
            [32.18635889696774, 1.726101281280463],
            [32.17952293864117, 1.728622253253205],
            [32.167307049129704, 1.731177002870655],
            [32.16310483982507, 1.731147999632462],
            [32.160770195656774, 1.730685598111113],
            [32.15442013606735, 1.729018238048468],
            [32.152702903993806, 1.727497690607704],
            [32.14789468041872, 1.727613124631051],
            [32.14161327906647, 1.7257919772057],
            [32.138642553116846, 1.72362856946337],
            [32.137346010175676, 1.721230721271275],
            [32.134901369097456, 1.719935992131138],
            [32.13475133247871, 1.718732773626263],
            [32.132156672748046, 1.716831876841605],
            [32.128094807240245, 1.714749381554438],
            [32.118901571691744, 1.705753209512324],
            [32.10393395561549, 1.68585371341608],
            [32.10081091761447, 1.684043029516727],
            [32.10136329527595, 1.682025991062688],
            [32.10137949998536, 1.679764456973418],
            [32.098319846212476, 1.668998107437512],
            [32.09279425230599, 1.657696909706122],
            [32.09246795185544, 1.656186052574061],
            [32.092954346462676, 1.652205971661976],
            [32.09394644316751, 1.649962982673489],
            [32.09557515615124, 1.648208775153155],
            [32.09654858945775, 1.647467435454509],
            [32.09973519314658, 1.646500949405535],
            [32.10286622974688, 1.646665203182832],
            [32.105320829548326, 1.647435240571631],
            [32.10806334748321, 1.64889291558756],
            [32.11107043993049, 1.651110588299809],
            [32.126755505389895, 1.664126074825515],
            [32.131954442214635, 1.666905583839132],
            [32.138117569579954, 1.669595050403326],
            [32.14310736243689, 1.670845633997068],
            [32.15703740459709, 1.671276884396781],
            [32.17591787454016, 1.673338480351296],
            [32.182980537101756, 1.670778688575481],
            [32.19842812932253, 1.673371113003155],
            [32.217630427902634, 1.671560321463739],
            [32.22305250804062, 1.670425860889131],
            [32.23025294611564, 1.671126250718032],
            [32.23221944630748, 1.669039566854389],
            [32.23660766616477, 1.667703295789483],
            [32.24936898037734, 1.66736246306413],
            [32.26705465326332, 1.665269232847456],
            [32.27119559566895, 1.664501823463797],
            [32.28017997021894, 1.661764039115243],
            [32.28069313102836, 1.660428397063059],
            [32.29738827476964, 1.654505861523469],
            [32.30000950756473, 1.651840631428752],
            [32.30845205516625, 1.647497657554014],
            [32.31254904659829, 1.643221017146608],
            [32.315625254525216, 1.643213036203726],
            [32.330853762919574, 1.644882822424461],
            [32.344547136731634, 1.647112889435292],
            [32.354909170296295, 1.649586049583934],
            [32.360250225988906, 1.651605206291944],
            [32.3705154606918, 1.65747079599846],
            [32.37830563736096, 1.663543646246208],
            [32.386130655188396, 1.671570594715387],
            [32.393111275513384, 1.679443475971835],
            [32.39576313457145, 1.682013588878128],
            [32.398974735679715, 1.684258190841343],
            [32.40457757661577, 1.687019196460076],
            [32.409716670371274, 1.688613011611199],
            [32.41505874834669, 1.689772630451285],
            [32.42115034017097, 1.690181576717775],
            [32.4311534545588, 1.689904102777142],
            [32.43756710319222, 1.689082722500707],
            [32.44924092680333, 1.686154908454335],
            [32.4560359767502, 1.683750365360358],
            [32.465163955083185, 1.67939231015792],
            [32.496796358132336, 1.662123124282535],
            [32.5154662503964, 1.656972218656885],
            [32.54314633030014, 1.647068107165827],
            [32.557240175760775, 1.645875187125608],
            [32.566918762972456, 1.646560829724364],
            [32.578464875794566, 1.648784708027666],
            [32.58712267500954, 1.651179910343072],
            [32.579497301465764, 1.668292610296719],
            [32.5777894603802, 1.673349536590486],
            [32.57637730875357, 1.682957181908952],
            [32.576488130316925, 1.687562147940703],
            [32.576055326504594, 1.689498117808138],
            [32.570846530669606, 1.693179106626015],
            [32.56977452702359, 1.695241589016611],
            [32.567831213247565, 1.702686853887352],
            [32.56767570678706, 1.705826136551637],
            [32.56869041408757, 1.713796794384583],
            [32.567966323459544, 1.721604210475532],
            [32.56872752169534, 1.727430667235921],
            [32.56860579368612, 1.732723147518381],
            [32.56823102822769, 1.733826798472348],
            [32.55584245287426, 1.742490942625395],
            [32.554798659023135, 1.743838697957945],
            [32.55426329635147, 1.745611783253912],
            [32.55524200905688, 1.760494338981115],
            [32.555051122448894, 1.770409808371815],
            [32.55581441465759, 1.777810441454139],
            [32.55538099639764, 1.78204433328173],
            [32.55568278811228, 1.787734970995139],
            [32.5510098759718, 1.789660835774302],
            [32.54910689655202, 1.790827428259757],
            [32.54717929251367, 1.792717769831666],
            [32.54314146682119, 1.799800549006503],
            [32.54000693846937, 1.806793071155205],
            [32.53794130199941, 1.814410098865971],
            [32.537222955199326, 1.818472005455777],
            [32.53699001485962, 1.824035834932609],
            [32.53769718302432, 1.828550459313443],
            [32.5385030850219, 1.830441486112437],
            [32.54357071959316, 1.835798606846315],
            [32.53594077631958, 1.845096915299608],
            [32.52680366391677, 1.857433162488129],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 651,
        District: "APAC",
        County: "MARUZI",
        Subcounty: "AKOKORO",
        Population: 42111,
        Key: "APACAKOKORO",
        Dist2: "Apac",
        "Sub Country": "Akokoro",
        id2_original: "Apac Akokoro",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.850288995581394, 2.301061986217492],
            [32.84870224739614, 2.301746256419391],
            [32.84717025601902, 2.303664095456272],
            [32.84612689066431, 2.304252049530404],
            [32.84496748273781, 2.304496197285827],
            [32.84248359785809, 2.303184080779908],
            [32.841788194030336, 2.303699692949465],
            [32.841009703225325, 2.30322915234298],
            [32.84034737177308, 2.304568060933303],
            [32.839105326925285, 2.304848383248432],
            [32.839005655251235, 2.30641353445803],
            [32.8380368437769, 2.306304858142969],
            [32.83744058251548, 2.307435687052469],
            [32.83621511068637, 2.307770291256845],
            [32.83479076083648, 2.309534326278708],
            [32.83464155785431, 2.311606113864143],
            [32.83358151437802, 2.312917830352462],
            [32.833523497583705, 2.313922060717799],
            [32.832860993654926, 2.314229586019098],
            [32.83254636231993, 2.315260927816367],
            [32.83300964057993, 2.31694375835988],
            [32.83256269009854, 2.317423205602498],
            [32.832280889492196, 2.318906910032394],
            [32.83037208539614, 2.320219029954602],
            [32.828745200483965, 2.320344985389515],
            [32.8281058425468, 2.320033555152855],
            [32.82781283006745, 2.321048027225798],
            [32.82696834183514, 2.321514919551687],
            [32.823627720194224, 2.321366682742669],
            [32.82315715659726, 2.3206640988299],
            [32.82261144443518, 2.321269679679955],
            [32.82256633283827, 2.322648452396975],
            [32.82154389373808, 2.322953462586157],
            [32.820903401228705, 2.32365407158949],
            [32.81894850637204, 2.323461695770921],
            [32.817476636541926, 2.323947468717442],
            [32.81671251249326, 2.3249758019356],
            [32.81501595065442, 2.325359828790393],
            [32.8134543840432, 2.324421599934195],
            [32.81318454091163, 2.325935959980451],
            [32.81260032605818, 2.325822868195226],
            [32.81194883547478, 2.324692634694889],
            [32.811319516210936, 2.325811394490639],
            [32.81083641303093, 2.325743520745058],
            [32.810072576443126, 2.324579366885105],
            [32.809642561899786, 2.322839545688587],
            [32.809461025855605, 2.318406407861557],
            [32.81137426223928, 2.313928316869981],
            [32.81432230033811, 2.3120649911848],
            [32.818454630595134, 2.306564846169799],
            [32.81892712018004, 2.301941800086273],
            [32.81753646703481, 2.299426507288596],
            [32.817760574240296, 2.296413826462612],
            [32.8162538327092, 2.294034225090361],
            [32.81660196491608, 2.290415399720535],
            [32.81603090499166, 2.287800691892035],
            [32.81677679503669, 2.283684322744079],
            [32.818176119619366, 2.281956491147895],
            [32.81878958451679, 2.278129612619108],
            [32.81849194122214, 2.273678362249453],
            [32.817084732126176, 2.271144973466829],
            [32.81389754273581, 2.266919532748687],
            [32.81316900095553, 2.265110002745127],
            [32.812449301292624, 2.26011586716043],
            [32.81073616463847, 2.254515440475733],
            [32.81047893744673, 2.248787480344329],
            [32.81086971178187, 2.247612461138262],
            [32.81616198356464, 2.242438153914394],
            [32.81792320164607, 2.238873785317982],
            [32.81952965168213, 2.23680218052733],
            [32.819839271316184, 2.235291338725702],
            [32.82129113296994, 2.233255900794255],
            [32.82240972594152, 2.230740919524601],
            [32.82214814551395, 2.23011663163881],
            [32.82246973160587, 2.227212524044883],
            [32.821589406881955, 2.22558392387738],
            [32.82099445716083, 2.22536671888549],
            [32.8203048061442, 2.222733903590719],
            [32.821078702066494, 2.218943226796068],
            [32.82191143763994, 2.218961421993211],
            [32.82436259060565, 2.217649875344193],
            [32.82624221831962, 2.217677239975115],
            [32.828812005496715, 2.218464647250805],
            [32.83002558183485, 2.218274796855201],
            [32.833571434382215, 2.216646708361309],
            [32.83522511334435, 2.216565469863811],
            [32.83937797998705, 2.215245038904643],
            [32.856463019511104, 2.209158036402615],
            [32.86520805951319, 2.205268561845043],
            [32.88190990109323, 2.223192518259183],
            [32.881845529616626, 2.223337267945777],
            [32.87974516158282, 2.228077835667687],
            [32.87898324738974, 2.231434287271826],
            [32.8762108191492, 2.236753813485285],
            [32.87503242532915, 2.242824388555408],
            [32.87372342634829, 2.244525150405126],
            [32.868885429011414, 2.247510298935758],
            [32.86664966779631, 2.250559002901598],
            [32.8658381028192, 2.252395510187905],
            [32.866284525091196, 2.260393277300701],
            [32.86499330915967, 2.264021085099916],
            [32.86292230884916, 2.2660384147416],
            [32.86225971329223, 2.267603516721021],
            [32.862284550811516, 2.269476289256265],
            [32.86364768945794, 2.271730984981616],
            [32.865471011668205, 2.272049583280086],
            [32.86704515828668, 2.271602829709347],
            [32.86941320361389, 2.269965504046144],
            [32.87352876142621, 2.266084622052988],
            [32.87624082557461, 2.264730266455829],
            [32.87724071606287, 2.264716912657955],
            [32.87926918653458, 2.267303193721225],
            [32.88148240003606, 2.268425726237798],
            [32.88285929188945, 2.269722461655837],
            [32.887216683362816, 2.271981417049967],
            [32.89182864121801, 2.272612834661128],
            [32.89452527320816, 2.274617125337797],
            [32.89589382150921, 2.274582416651352],
            [32.89812742407268, 2.2756840355556],
            [32.902149345093086, 2.28141955486317],
            [32.90402725163494, 2.282232328982309],
            [32.9020098214581, 2.286271172076728],
            [32.90214239752266, 2.28750160191632],
            [32.901769649680354, 2.288433438188707],
            [32.902150410495004, 2.28954627094535],
            [32.90118990304714, 2.291364694155661],
            [32.901388456776054, 2.293644604927957],
            [32.89846554635238, 2.295897153396332],
            [32.897438817796704, 2.296068976248772],
            [32.89687550943484, 2.296928420515462],
            [32.89425907274508, 2.297416776835699],
            [32.893017012625904, 2.298095224306129],
            [32.88943183632696, 2.297506881728386],
            [32.8874612595804, 2.298203360896425],
            [32.88519256702527, 2.297759866544308],
            [32.88133356176987, 2.301541279048203],
            [32.88034840814387, 2.301912132031302],
            [32.87862606735133, 2.301812466283309],
            [32.87758266965725, 2.302925181809609],
            [32.874593455480735, 2.304254858086123],
            [32.87262299551512, 2.303467576346062],
            [32.87161281482532, 2.303937939151136],
            [32.86955941879941, 2.303422061381367],
            [32.86904596873246, 2.302870134424057],
            [32.86747283721027, 2.303150451687868],
            [32.866479310387525, 2.30285180025487],
            [32.86494765498033, 2.301431245204196],
            [32.8626788788819, 2.301892434409992],
            [32.860045742511, 2.300526049832392],
            [32.85797592438338, 2.298499272952811],
            [32.85688304299186, 2.299648156834262],
            [32.854200254938554, 2.30020880962805],
            [32.85343850693384, 2.300896317850194],
            [32.850288995581394, 2.301061986217492],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 652,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "LIRA",
        Population: 35512,
        Key: "LIRALIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.52680364415384, 1.857433177751455],
            [32.53470222142664, 1.865624155185225],
            [32.53987834194151, 1.870004271305599],
            [32.549486034110956, 1.875552614283404],
            [32.55707967646393, 1.876024959316529],
            [32.572633022851534, 1.879195361080126],
            [32.581766573434216, 1.883784399674785],
            [32.59672078574815, 1.888913876909348],
            [32.60131840559308, 1.891228234939737],
            [32.602430632204225, 1.892422483108323],
            [32.601021048861, 1.894287714240032],
            [32.59798530464773, 1.896674593046838],
            [32.59545731877577, 1.900480096598565],
            [32.600500025996205, 1.902346861495604],
            [32.607066500517334, 1.903798173745037],
            [32.624358928701156, 1.91631316990664],
            [32.63133217206104, 1.919777250838727],
            [32.635891051161046, 1.922733712303688],
            [32.64084490960999, 1.924058120884765],
            [32.647903351886356, 1.924500782772342],
            [32.649306196966656, 1.925030419727052],
            [32.65110345905055, 1.926442362763925],
            [32.652594030906535, 1.926839642564519],
            [32.653602109538596, 1.928163276738989],
            [32.655925587647936, 1.928737171715222],
            [32.65741608943531, 1.929575638248918],
            [32.657591120778534, 1.931163701741062],
            [32.65723993519802, 1.933369215030834],
            [32.657897179490796, 1.935222056830759],
            [32.65780910237211, 1.937339467147023],
            [32.656812393716606, 1.938870639599714],
            [32.65700883011644, 1.94286044813808],
            [32.65541186359483, 1.946325106996791],
            [32.65601289311375, 1.950360278748996],
            [32.657730499784755, 1.955182692634032],
            [32.65784531525787, 1.95845780792626],
            [32.65470773892229, 1.967838991690815],
            [32.65453537467716, 1.972670122940479],
            [32.6557564519479, 1.975927317433657],
            [32.65666396059065, 1.98206139578333],
            [32.656822499763564, 1.988521105605239],
            [32.656428082759994, 1.992112128939883],
            [32.66168442013477, 2.004465289278128],
            [32.662111892445864, 2.01668628889297],
            [32.66290676043683, 2.020588869919413],
            [32.66267600569822, 2.021584397439846],
            [32.653230291452616, 2.028160659099392],
            [32.651171815453786, 2.028708428103929],
            [32.64868972810292, 2.028403332365136],
            [32.64778193828752, 2.026758551272188],
            [32.64342370599104, 2.023773027676669],
            [32.638459671426574, 2.02243186558672],
            [32.63736997366443, 2.022431654614135],
            [32.63349507631331, 2.023648955241896],
            [32.63101291889388, 2.023770222192387],
            [32.62296127678152, 2.022976550045251],
            [32.620902801680984, 2.023463302182623],
            [32.61848043792352, 2.026508232491443],
            [32.61835916536017, 2.027360957100937],
            [32.61854030255236, 2.02937101131092],
            [32.62081711048773, 2.033856958937654],
            [32.62129595475496, 2.035947100365218],
            [32.62236094974513, 2.037447882404048],
            [32.62230733110244, 2.039109205253864],
            [32.62044185365082, 2.04387826520588],
            [32.616339219002185, 2.048861226525019],
            [32.61532657962342, 2.051326084740572],
            [32.615219273167774, 2.054487948351201],
            [32.61713535092273, 2.060812007798886],
            [32.617187776602705, 2.064456173672836],
            [32.61631963932225, 2.065476502568078],
            [32.60882467151334, 2.065204377640949],
            [32.606107969363116, 2.065846816827027],
            [32.60365725297862, 2.067721882225905],
            [32.59950135182686, 2.071954464314885],
            [32.59560168163519, 2.07461447226373],
            [32.59188342801174, 2.075060741004464],
            [32.588421335279804, 2.073934444319276],
            [32.58394688254515, 2.074147584409628],
            [32.57952534686894, 2.075700510847125],
            [32.576062902895714, 2.076235498806341],
            [32.57217460088395, 2.075484214561519],
            [32.57068360861639, 2.073715343293057],
            [32.56455801016872, 2.073499257701874],
            [32.56301417180965, 2.070229844447106],
            [32.5616837525008, 2.06567435363223],
            [32.56036947501933, 2.063394885961105],
            [32.52020432453097, 2.047671789291928],
            [32.489261784500876, 2.042053108865106],
            [32.476866787989785, 2.039271710818596],
            [32.47272344977726, 2.037596711854322],
            [32.462316607347915, 2.03130566542379],
            [32.4543306545407, 2.028715582291466],
            [32.44985915007681, 2.027718866037852],
            [32.45011159014639, 2.024163551041354],
            [32.448576313630255, 2.015523339695928],
            [32.44887374043094, 2.006702758451065],
            [32.451193849857965, 1.997738135519411],
            [32.46362562070186, 1.964522232047185],
            [32.465524084290706, 1.948193224963959],
            [32.46669645580506, 1.944692167829292],
            [32.46726492049665, 1.940128331732377],
            [32.4696155591686, 1.935157527244245],
            [32.47050769853514, 1.931490278304695],
            [32.47017812911528, 1.927856830161056],
            [32.46969907464222, 1.927007490334564],
            [32.46735047155273, 1.925621289717061],
            [32.46254490609256, 1.924715695689187],
            [32.45969822850049, 1.922199725645304],
            [32.458526909811646, 1.920046173065324],
            [32.45743300074744, 1.907422343749844],
            [32.4590721449683, 1.895330382505708],
            [32.466102796064725, 1.890334476805059],
            [32.468775072930896, 1.88503308474929],
            [32.47347543758645, 1.878691312645614],
            [32.476899913365884, 1.873321845449307],
            [32.48887719326986, 1.875001217506698],
            [32.49003300254532, 1.878530685031373],
            [32.49236392050186, 1.880521697500413],
            [32.493720376580875, 1.880965352788436],
            [32.49677612178395, 1.881085156692834],
            [32.4999482275624, 1.879580938650118],
            [32.50370529110104, 1.878579854827658],
            [32.50535608557279, 1.877368061585481],
            [32.507369715876024, 1.874853565953976],
            [32.51014312328023, 1.872916417154915],
            [32.514066936593494, 1.871511444279522],
            [32.51842545006263, 1.867175802748496],
            [32.52302496445451, 1.860369332945197],
            [32.52680364415384, 1.857433177751455],
          ],
          [
            [32.54495375322817, 1.939773209470018],
            [32.54232232096136, 1.940302000422659],
            [32.54021689451421, 1.941757558423225],
            [32.53850616534502, 1.943389658294554],
            [32.536575770241086, 1.946301398870467],
            [32.534909325320434, 1.946036128552908],
            [32.53179561003546, 1.946344185183576],
            [32.52912010372586, 1.947446510778037],
            [32.52828439023724, 1.950424456716937],
            [32.5241214004796, 1.958237919254872],
            [32.522428076169035, 1.958806052764144],
            [32.52135648484976, 1.96049586126149],
            [32.51719896942544, 1.96346207060551],
            [32.51007048640466, 1.970163763454387],
            [32.508260732348454, 1.972651115080649],
            [32.50610365277246, 1.977038251205005],
            [32.50564810810874, 1.980023579815125],
            [32.505331663075175, 1.989640377525125],
            [32.50562417698956, 1.995267654818915],
            [32.50620359034782, 1.998180917967695],
            [32.512351435573514, 1.996155325300685],
            [32.5167318454777, 1.995260290406315],
            [32.5216316639741, 1.995186996409209],
            [32.52474881800999, 1.998474447123307],
            [32.53088052140834, 2.003508046418029],
            [32.53847619844544, 2.004966565606645],
            [32.54493971705186, 2.007182150196026],
            [32.54709237512004, 2.008303162728084],
            [32.54694675012763, 1.997733857648724],
            [32.55779496000891, 1.995026098836922],
            [32.56021872693488, 1.994053349552541],
            [32.560443024583215, 1.990394226264832],
            [32.55958380038699, 1.982369445771303],
            [32.5597010017855, 1.977333887619378],
            [32.562315099262285, 1.968595164832734],
            [32.56280734819021, 1.96468698947453],
            [32.56434774869669, 1.961575522762806],
            [32.56597447101379, 1.96038518087579],
            [32.56779622656218, 1.957840436754403],
            [32.568920594802734, 1.955298634425808],
            [32.56871973689509, 1.952663892242705],
            [32.56788697077894, 1.95058984757738],
            [32.56591425604195, 1.947677062192843],
            [32.56530038420773, 1.947368093644568],
            [32.56100257708884, 1.947587563569708],
            [32.5596867554034, 1.948072583617432],
            [32.5565293873855, 1.947321661405825],
            [32.553810931723845, 1.945467710614907],
            [32.55284657589327, 1.943614177955983],
            [32.55074206213447, 1.941583889882459],
            [32.54683944367202, 1.939994362860406],
            [32.54495375322817, 1.939773209470018],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 653,
        District: "APAC",
        County: "APAC MUNICIPALITY",
        Subcounty: "APAC",
        Population: 52613,
        Key: "APACAPAC",
        Dist2: "Apac",
        "Sub Country": "Apac",
        id2_original: "Apac Apac",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.08399120185823, 1.747478842628954],
            [33.07915587880595, 1.748875505520856],
            [33.074249737966554, 1.752014840266174],
            [33.069428604702516, 1.753670205661908],
            [33.06653597109717, 1.756124544012095],
            [33.06525985045568, 1.758436132233958],
            [33.06514644803253, 1.759520563980693],
            [33.065146510914595, 1.761318431480092],
            [33.066239445306714, 1.763341479063696],
            [33.066810600452555, 1.769589176767713],
            [33.06666802344393, 1.773969766786367],
            [33.0655367264976, 1.77798887052725],
            [33.06501955201551, 1.778376178514761],
            [33.06549072556854, 1.781163063047632],
            [33.06518152454942, 1.782766893749743],
            [33.062112768147784, 1.783652693020939],
            [33.057592925338454, 1.78609447704988],
            [33.05221105918247, 1.790594110540363],
            [33.05150168295881, 1.793211682153181],
            [33.049185813579946, 1.797277461065496],
            [33.047002513079114, 1.797378442185829],
            [33.045246904078326, 1.798872193893838],
            [33.04103113470447, 1.807744043118738],
            [33.039657541464784, 1.813217928729641],
            [33.03825419602287, 1.815768923495658],
            [33.0363528748931, 1.818866562274893],
            [33.0304263386208, 1.825140380297323],
            [33.02143454757985, 1.819354951919836],
            [33.0196073428509, 1.818803088769482],
            [33.01908696317986, 1.818015981741255],
            [33.01107991703144, 1.815093780654439],
            [33.00758904587106, 1.813329580095142],
            [33.00599533753896, 1.811492990037324],
            [33.004553357353345, 1.808769764764476],
            [32.99779195111049, 1.798654917696467],
            [32.995222721787194, 1.796700701247468],
            [32.98933491817498, 1.793669839158247],
            [32.97207588216693, 1.788223196603536],
            [32.97540269310868, 1.781709207316678],
            [32.97828330186563, 1.774815219359703],
            [32.98234936430244, 1.761352915876352],
            [32.986250726920154, 1.74706729664852],
            [32.98789836561029, 1.739539971677089],
            [32.98853141378092, 1.73433779018778],
            [32.988511986814586, 1.730073991478076],
            [32.988714092482134, 1.72600524466566],
            [32.990224571903155, 1.722123969076675],
            [32.99163501673073, 1.71971739578971],
            [32.99365937202013, 1.717274646192468],
            [32.994836041074834, 1.716587053029164],
            [32.999039804464914, 1.712443403074176],
            [32.99993860483927, 1.712280551980268],
            [33.004244064706064, 1.713357174109998],
            [33.00491050864568, 1.712452447762797],
            [33.00827727305799, 1.711936741512742],
            [33.00994365150329, 1.710235842298587],
            [33.012013767871565, 1.709566327931708],
            [33.014203572175056, 1.708064467697911],
            [33.018319929487994, 1.707340650177902],
            [33.02247141721675, 1.707376792213722],
            [33.02349495495653, 1.706707287625369],
            [33.02599324881343, 1.706064896308066],
            [33.03966145632277, 1.706860817918806],
            [33.04679846435558, 1.70805489591184],
            [33.0487963957009, 1.708769584052729],
            [33.06734810830115, 1.719574612722466],
            [33.072938536316606, 1.722991126815738],
            [33.0795146883883, 1.727903535552224],
            [33.08381923017685, 1.731875091761532],
            [33.0865177899516, 1.735756255825883],
            [33.08651626191731, 1.739158023283516],
            [33.08449157964116, 1.744441726995255],
            [33.08399120185823, 1.747478842628954],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 654,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "ADEKNINO",
        Population: 16096,
        Key: "DOKOLOADEKNINO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.57677381613685, 2.218590973300425],
            [32.57441866792217, 2.218422848550908],
            [32.5702580110893, 2.219451249722021],
            [32.569188124772445, 2.219331650671054],
            [32.56714349181213, 2.217418253045043],
            [32.56581211040763, 2.215552700050804],
            [32.56442133329487, 2.210661616960634],
            [32.56269781391266, 2.198858484329289],
            [32.56122381148208, 2.196275403285789],
            [32.55758634964035, 2.191611511632372],
            [32.55769342612728, 2.185883353471411],
            [32.55499514842355, 2.177237266423941],
            [32.554495937552154, 2.173984533227055],
            [32.55410381394747, 2.163185934982605],
            [32.553236108756685, 2.15977772622278],
            [32.552451584866226, 2.15829485891895],
            [32.54893307793444, 2.154061469046386],
            [32.54148004887286, 2.147854846682031],
            [32.53926912787201, 2.145510922412559],
            [32.53036617122949, 2.131842103571567],
            [32.52272322035057, 2.122861037777404],
            [32.517754706786064, 2.118197065542006],
            [32.514331435647435, 2.115542164134463],
            [32.5103733534027, 2.110363991794034],
            [32.50661729507887, 2.107398149676144],
            [32.50075717035722, 2.105383279321392],
            [32.497958620006514, 2.105466018452903],
            [32.49575056193644, 2.106237707620158],
            [32.492438959472466, 2.108999355985832],
            [32.48664112483095, 2.108564062391678],
            [32.48240068232948, 2.105953813602774],
            [32.47983902221076, 2.105336935997834],
            [32.47911443391608, 2.104169708415618],
            [32.477651699952425, 2.103089988751847],
            [32.47747581520969, 2.10176237176378],
            [32.47525141319136, 2.100746267661963],
            [32.474907027857505, 2.099606421357263],
            [32.46876086337971, 2.092905140765795],
            [32.46530187702201, 2.088408335535102],
            [32.46202671831081, 2.085606202243812],
            [32.45621219207297, 2.082329444654028],
            [32.440412098239754, 2.077759514662675],
            [32.435687912957775, 2.07605418337197],
            [32.43217410690987, 2.075394253439262],
            [32.423485559261046, 2.075108092470582],
            [32.40781245936124, 2.072007078355196],
            [32.4043885001131, 2.071973574250171],
            [32.388723395219294, 2.073619615969465],
            [32.3844413966528, 2.07376707301378],
            [32.37069094658255, 2.073194254890523],
            [32.36134585442855, 2.074250876843974],
            [32.352774369837654, 2.074426783682512],
            [32.35252648422656, 2.070699537063104],
            [32.35072293483401, 2.060530343645409],
            [32.350116245030485, 2.052930895830937],
            [32.34575889937121, 2.043701514707015],
            [32.353488262790556, 2.042338620414776],
            [32.35667285155823, 2.04080197172055],
            [32.38941297077747, 2.032699905017297],
            [32.39408289691798, 2.030349523740613],
            [32.397348339451064, 2.027383419778107],
            [32.398957394601446, 2.026434113066839],
            [32.416258695445336, 2.025544854768909],
            [32.42559085994407, 2.025665822625512],
            [32.441905868996464, 2.026549106307948],
            [32.44957131638503, 2.027972101429694],
            [32.44985914558523, 2.027718888481684],
            [32.45433063477776, 2.028715566131953],
            [32.4623166351957, 2.031305659139528],
            [32.472723415641305, 2.037596684921916],
            [32.4768668131426, 2.039271717102793],
            [32.48926180875539, 2.042053121433546],
            [32.520204318242754, 2.047671821610606],
            [32.56036950017214, 2.063394884165643],
            [32.5616837740604, 2.065674330291183],
            [32.56301418348774, 2.07022984893576],
            [32.56455801645693, 2.073499265781421],
            [32.57068361759956, 2.073715310077165],
            [32.57217460717216, 2.07548418852746],
            [32.57606287684457, 2.076235504192685],
            [32.57952535854704, 2.075700535085732],
            [32.58394690679967, 2.074147598773265],
            [32.588421368517466, 2.073934416489741],
            [32.59188341992693, 2.075060713174948],
            [32.59560169870316, 2.074614438150115],
            [32.59966469249499, 2.082741971236302],
            [32.60117443529746, 2.092250781044812],
            [32.60123387412484, 2.095010138931971],
            [32.60028310261805, 2.101994196624089],
            [32.59686020877183, 2.114342490427498],
            [32.59690785002459, 2.118115108986425],
            [32.597454663521184, 2.119408976415756],
            [32.59904752294533, 2.120386469905177],
            [32.61536800633107, 2.122127671574849],
            [32.6175792031147, 2.122815799145208],
            [32.62046761823151, 2.124861147033331],
            [32.62307131501394, 2.134035492285145],
            [32.62444641742331, 2.136152839851531],
            [32.624881003493144, 2.137971402789113],
            [32.62467874421367, 2.144566648497136],
            [32.62430913418665, 2.146700507896648],
            [32.625165796387655, 2.150501508151459],
            [32.62486357258337, 2.154208949868066],
            [32.626390976264304, 2.162187822253028],
            [32.628680006677456, 2.166856107594521],
            [32.63147535453417, 2.168711915115762],
            [32.632289639609965, 2.170223149405375],
            [32.632923675927394, 2.171399860015959],
            [32.62775603281387, 2.170939546310222],
            [32.623975802622375, 2.171228109654505],
            [32.62142030045493, 2.172674992889859],
            [32.61821062623297, 2.173823153029658],
            [32.61661785214879, 2.175586917712973],
            [32.61564320521833, 2.177911755138098],
            [32.61462078408449, 2.179105700319464],
            [32.61440676585793, 2.180806486748411],
            [32.61377695611391, 2.181964343542803],
            [32.61391965349678, 2.183330482444429],
            [32.60603841550558, 2.193813918868823],
            [32.5966950400321, 2.198289681378479],
            [32.5958629296861, 2.199194155660489],
            [32.59404418439222, 2.209109175646166],
            [32.59286714882487, 2.210321150293128],
            [32.5801356991039, 2.21186461567545],
            [32.578471479310224, 2.214542047985903],
            [32.57677381613685, 2.218590973300425],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 655,
        District: "APAC",
        County: "MARUZI",
        Subcounty: "CHEGERE",
        Population: 35479,
        Key: "APACCHEGERE",
        Dist2: "Apac",
        "Sub Country": "Chegere",
        id2_original: "Apac Chegere",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11194715169074, 2.255319648470884],
            [33.11520697795671, 2.261055322132837],
            [33.11613633183051, 2.26341656883407],
            [33.116284093914985, 2.266031199729814],
            [33.11498635801112, 2.268256916953658],
            [33.11255283627948, 2.270075597749248],
            [33.11119612777388, 2.273079376595122],
            [33.10941160020746, 2.275495118929491],
            [33.10675644163735, 2.282959265836173],
            [33.10412733600712, 2.28570076408468],
            [33.10080901863637, 2.287827096569006],
            [33.09670672534753, 2.28861448745699],
            [33.096706799907686, 2.289727294940366],
            [33.09804365115395, 2.291636164270304],
            [33.09894266173409, 2.294250745716093],
            [33.09921948477542, 2.298005317818602],
            [33.0983669943506, 2.301651401745183],
            [33.09504848384207, 2.305777155509642],
            [33.09417270279684, 2.305958158597669],
            [33.09335573445328, 2.308429305542032],
            [33.08871926876051, 2.305992760608606],
            [33.085059112779774, 2.305011188746673],
            [33.082700455745595, 2.305256726736119],
            [33.08042296329397, 2.304356929201369],
            [33.076844161440306, 2.303620778694088],
            [33.07269607832648, 2.304030079363804],
            [33.06879712858365, 2.302926640392974],
            [33.065120984387505, 2.302379325959276],
            [33.0631656592378, 2.302647474693008],
            [33.06150738988456, 2.303410759832644],
            [33.060273375975385, 2.304713777273806],
            [33.05924888961467, 2.307964122398649],
            [33.062439419839606, 2.311686381233298],
            [33.06326157864886, 2.313193979951038],
            [33.062122937975126, 2.314584912004694],
            [33.06057779975382, 2.319821235532159],
            [33.06074061580581, 2.323830203042033],
            [33.0593829434079, 2.326401428931401],
            [33.05608723483623, 2.32897146982428],
            [33.054850923036575, 2.326698598892135],
            [33.05329968435618, 2.325103543122059],
            [33.050528273008524, 2.324931986772422],
            [33.046753491099224, 2.326827241985066],
            [33.04236430555303, 2.327321761532049],
            [33.041777247531705, 2.326985326408324],
            [33.03925842357731, 2.327637705856428],
            [33.03778396570086, 2.327129633944073],
            [33.03708766176123, 2.325653377253954],
            [33.034043461706176, 2.323626189268576],
            [33.03061224766381, 2.323539708652814],
            [33.02858835949836, 2.322879713163265],
            [33.02588111211649, 2.322685728780772],
            [33.02038551565231, 2.317587012256014],
            [33.01946212928689, 2.316208984086076],
            [33.01941555792764, 2.315499743838769],
            [33.01519171719096, 2.312622683342652],
            [33.014116747307895, 2.311492494949194],
            [33.01349244872814, 2.309763382023366],
            [33.012412901030395, 2.30936850989832],
            [33.01175544832846, 2.309946859246614],
            [33.01042942447634, 2.309921190101267],
            [33.00983254607231, 2.309488538642058],
            [33.00896960913902, 2.309874128803486],
            [33.008473696881396, 2.309431611068518],
            [33.00347339912549, 2.309065030758529],
            [33.00247382484422, 2.30826823726468],
            [33.00004090408553, 2.304853395382861],
            [33.00104046938364, 2.299522444606611],
            [33.00107818694747, 2.296012745569687],
            [33.00071985167558, 2.295064177679781],
            [32.99670274921838, 2.290681790511159],
            [32.99442074093581, 2.289258932691331],
            [32.99249705984032, 2.289277894456102],
            [32.99144093391697, 2.287418696039271],
            [32.990422521065895, 2.28673572050196],
            [32.98944184284663, 2.283908981692496],
            [32.98970011477903, 2.279407211364723],
            [32.989157821604934, 2.278164605761041],
            [32.989229113702514, 2.276698630701221],
            [32.98458774949649, 2.273093672804595],
            [32.98359631754498, 2.271482392071566],
            [32.982388178709265, 2.270930743651238],
            [32.98089692323533, 2.267705031230619],
            [32.979463181499156, 2.266050358377584],
            [32.97830319775255, 2.260933701457425],
            [32.97625087880667, 2.255547731756783],
            [32.97601296449526, 2.252764993484088],
            [32.97686048903322, 2.248593872824642],
            [32.978353991193664, 2.246195391922159],
            [32.98196977219601, 2.244350437351816],
            [32.98291302660053, 2.243085303603948],
            [32.9852187396268, 2.241451183572591],
            [32.985026862177044, 2.240757869030587],
            [32.99024011635083, 2.234225797401301],
            [32.99088767590653, 2.2314322810596],
            [32.990364669561586, 2.23021715866554],
            [32.988732295044755, 2.231021018271065],
            [32.98477036082409, 2.228830700861758],
            [32.980094539040415, 2.229225612935411],
            [32.9780243400271, 2.228471552292286],
            [32.976596658325846, 2.225455403701721],
            [32.97563299779134, 2.222080199350227],
            [32.97230336524128, 2.220465671217996],
            [32.96870863895257, 2.213232894134683],
            [32.96876152906154, 2.212116081304278],
            [32.96955453664155, 2.210892918958385],
            [32.972092113825816, 2.209137974875644],
            [32.97246219097676, 2.208127531183163],
            [32.97293801870131, 2.205947091716501],
            [32.97193364112823, 2.202543446624144],
            [32.97082350669335, 2.200735248421278],
            [32.96944903939289, 2.199458862024632],
            [32.96553704790876, 2.198288779236006],
            [32.96125505742711, 2.195204137368167],
            [32.95725111079726, 2.193539832783756],
            [32.95810774604882, 2.192870361813958],
            [32.96053484392785, 2.192074271413185],
            [32.964235096211304, 2.189694943744113],
            [32.96609113506422, 2.187804114716395],
            [32.96726292177536, 2.184929996133764],
            [32.97121292636903, 2.181387325037818],
            [32.97411590587151, 2.180190501059021],
            [32.978018239568016, 2.180286314229504],
            [32.98259845006276, 2.179329882428684],
            [32.98559422104252, 2.174684823280929],
            [32.98567989426947, 2.173349110213707],
            [32.986693561320905, 2.171438905080766],
            [32.98832111727457, 2.170706430233424],
            [32.989577480369704, 2.169514350949278],
            [32.98983446591459, 2.168767501648581],
            [32.99117645732092, 2.172415588825383],
            [32.99457432230667, 2.173894944988857],
            [32.99778659535476, 2.175963155360026],
            [32.99923133696159, 2.177320072591434],
            [33.00047087371313, 2.179665795117261],
            [33.00205903135506, 2.181037167695397],
            [33.005610247742986, 2.180503372294759],
            [33.00617653940988, 2.179888157575716],
            [33.008276463675905, 2.179200557545121],
            [33.00997533777831, 2.177780131208984],
            [33.011013774975375, 2.177535848318687],
            [33.01143841849165, 2.176730641161527],
            [33.01202831788422, 2.176495408382089],
            [33.015520517652945, 2.177590092515156],
            [33.01875303513425, 2.178060511016917],
            [33.02007449734137, 2.179272824113335],
            [33.024675683497975, 2.179842730329907],
            [33.03173069151504, 2.183407207506857],
            [33.033099361986956, 2.183570028324056],
            [33.03390144165302, 2.183235262823273],
            [33.03988291259989, 2.176151131419255],
            [33.041204279585585, 2.173283122557181],
            [33.043430391996225, 2.171001761160068],
            [33.04662534103402, 2.174632359056246],
            [33.048583653082055, 2.175608154736756],
            [33.04938062941898, 2.1756127095029],
            [33.05017763989189, 2.176680169829027],
            [33.055600386579776, 2.179897660259469],
            [33.05792276515121, 2.180280572764381],
            [33.06079714588833, 2.179744258246614],
            [33.06551786008003, 2.176124706782978],
            [33.06636588138632, 2.1746966365957],
            [33.06687875203991, 2.172438271141889],
            [33.06764965208076, 2.171461584718914],
            [33.068092150511596, 2.169661464917226],
            [33.06851093072402, 2.169556120495295],
            [33.06845855984126, 2.16904864794657],
            [33.06982426856772, 2.166927721247641],
            [33.06967669063789, 2.165788302803862],
            [33.07017628239496, 2.163767953308692],
            [33.0698954187315, 2.161833814817542],
            [33.07131815251216, 2.160735077942072],
            [33.07173651770292, 2.158721294515843],
            [33.07455123683044, 2.154898949076635],
            [33.07617208865714, 2.154807312102381],
            [33.07933378924963, 2.155974241887117],
            [33.08309765932319, 2.160615268635979],
            [33.08569310687637, 2.162080773522776],
            [33.08729754738117, 2.162207343108938],
            [33.090294174455394, 2.161202924457451],
            [33.09403388613601, 2.160723192704203],
            [33.0954733663102, 2.160976424553021],
            [33.099107323823986, 2.16354560194292],
            [33.10351634596829, 2.165038097057275],
            [33.103299684898175, 2.165693243656979],
            [33.10410019610575, 2.16743930225744],
            [33.10905072360163, 2.168361768296538],
            [33.11301600314841, 2.170116636254926],
            [33.115947190649145, 2.173409599644373],
            [33.120318751249464, 2.173644482814101],
            [33.12797819519699, 2.170821118428466],
            [33.13207933774399, 2.173679682207308],
            [33.134024979953224, 2.173905690083992],
            [33.135387083740426, 2.17492682116999],
            [33.13970284009699, 2.17591082852296],
            [33.14052685033409, 2.176410470209516],
            [33.140955326961674, 2.178277551449758],
            [33.14243082778215, 2.180766906918065],
            [33.14395381444686, 2.182107257922276],
            [33.145143585429956, 2.182490141139533],
            [33.14730179778152, 2.18215942745286],
            [33.14847483225256, 2.182394065093955],
            [33.148477555944496, 2.183606932147288],
            [33.15067997888277, 2.186889345455922],
            [33.1516984168867, 2.19038503805242],
            [33.14809052039761, 2.193606860832918],
            [33.14529476380742, 2.200280618673186],
            [33.14373314060234, 2.206281007443598],
            [33.14053199588403, 2.207777845982723],
            [33.13870386229708, 2.20915741882106],
            [33.136723546016185, 2.212452833999937],
            [33.13688582218069, 2.212162555121527],
            [33.1325048840671, 2.216092997115386],
            [33.12673810149, 2.224627095676325],
            [33.12585912423899, 2.227188002406087],
            [33.12452906335795, 2.229362663908613],
            [33.12268620189195, 2.230302460901821],
            [33.11070530626893, 2.233293254892751],
            [33.10710315181116, 2.23357932420616],
            [33.10486418001724, 2.23516996185445],
            [33.103663056125555, 2.236725880110767],
            [33.10324797607379, 2.240119678442573],
            [33.10174964816364, 2.244452452564626],
            [33.10474284367349, 2.246024606178619],
            [33.11027614692173, 2.248092320176922],
            [33.10792004649286, 2.249131662351024],
            [33.10727114575242, 2.249810251008201],
            [33.108229917655166, 2.251194403608817],
            [33.10955738420165, 2.251936174886314],
            [33.11106199133565, 2.253682171574459],
            [33.11194715169074, 2.255319648470884],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 656,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "BARR",
        Population: 43942,
        Key: "LIRABARR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.99732118988417, 2.331697628729052],
            [32.9952902005364, 2.331902751630014],
            [32.99407291325781, 2.33358637373688],
            [32.99331210399256, 2.335537846413116],
            [32.992551133928835, 2.336208385992831],
            [32.9853235343929, 2.335165640629378],
            [32.98249175895309, 2.335237985610777],
            [32.978446306563846, 2.336631199995843],
            [32.97616176952375, 2.336794012604803],
            [32.9744719594226, 2.33787060223748],
            [32.9714594366594, 2.338657651196344],
            [32.969865163287025, 2.340648004759379],
            [32.96888922368088, 2.343570233597813],
            [32.96888919583311, 2.344809702406472],
            [32.96965087017599, 2.346157754511281],
            [32.96944846177615, 2.34786767330323],
            [32.969757896357244, 2.349034770700984],
            [32.96785390812942, 2.34932423929022],
            [32.96587878321252, 2.350545566013457],
            [32.964141462114306, 2.351070260317044],
            [32.96309443792142, 2.352173992801585],
            [32.95149305714975, 2.3552225456648],
            [32.947233375429875, 2.355629514745873],
            [32.943913629737835, 2.355330825971156],
            [32.94191457100683, 2.356914004995099],
            [32.940343910749995, 2.357411535091448],
            [32.936274237085755, 2.357583249922398],
            [32.932811712264154, 2.357139773355198],
            [32.93093186985281, 2.357592040575189],
            [32.926862479157855, 2.35770944523972],
            [32.92433986251635, 2.357356468294607],
            [32.923507067654135, 2.356876920700504],
            [32.918457387710426, 2.357860939921082],
            [32.917730770121494, 2.355638855612914],
            [32.91517396899018, 2.35114429009261],
            [32.91468967644071, 2.347786988835088],
            [32.91398990590237, 2.346866403074809],
            [32.912832517388644, 2.346595583519428],
            [32.91372088293267, 2.344565031164258],
            [32.913424898826335, 2.342994675999492],
            [32.91159482398009, 2.339258242813297],
            [32.91039700049874, 2.33527298093805],
            [32.909499672463134, 2.334288196352972],
            [32.90507101314671, 2.332937939175666],
            [32.89688471087831, 2.329495052030261],
            [32.89091251952833, 2.330371979601987],
            [32.88531925463317, 2.329446396396599],
            [32.88517757144826, 2.326937091650477],
            [32.88343892982655, 2.326448399024586],
            [32.88084102538107, 2.326457228468451],
            [32.87946274742716, 2.325579531931559],
            [32.87608409830365, 2.327687891018741],
            [32.87433434362355, 2.327858062974106],
            [32.87309269493278, 2.326722427705063],
            [32.87060931760122, 2.325359574776492],
            [32.86648909483761, 2.324053339650951],
            [32.86282018118114, 2.325245282886468],
            [32.859603027586154, 2.324506875051233],
            [32.858484189374494, 2.32253754505164],
            [32.85689443991787, 2.317466368457384],
            [32.85294412630373, 2.310823117673753],
            [32.850288995581394, 2.301061986217492],
            [32.85343850693384, 2.300896317850194],
            [32.854200254938554, 2.30020880962805],
            [32.85688304299186, 2.299648156834262],
            [32.85797592438338, 2.298499272952811],
            [32.860045742511, 2.300526049832392],
            [32.8626788788819, 2.301892434409992],
            [32.86494765498033, 2.301431245204196],
            [32.866479310387525, 2.30285180025487],
            [32.86747283721027, 2.303150451687868],
            [32.86904596873246, 2.302870134424057],
            [32.86955941879941, 2.303422061381367],
            [32.87161281482532, 2.303937939151136],
            [32.87262299551512, 2.303467576346062],
            [32.874593455480735, 2.304254858086123],
            [32.87758266965725, 2.302925181809609],
            [32.87862606735133, 2.301812466283309],
            [32.88034840814387, 2.301912132031302],
            [32.88133356176987, 2.301541279048203],
            [32.88519256702527, 2.297759866544308],
            [32.8874612595804, 2.298203360896425],
            [32.88943183632696, 2.297506881728386],
            [32.893017012625904, 2.298095224306129],
            [32.89425907274508, 2.297416776835699],
            [32.89687550943484, 2.296928420515462],
            [32.897438817796704, 2.296068976248772],
            [32.89846554635238, 2.295897153396332],
            [32.901388456776054, 2.293644604927957],
            [32.90118990304714, 2.291364694155661],
            [32.902150410495004, 2.28954627094535],
            [32.901769649680354, 2.288433438188707],
            [32.90214239752266, 2.28750160191632],
            [32.9020098214581, 2.286271172076728],
            [32.90402725163494, 2.282232328982309],
            [32.905424503804284, 2.28057165974238],
            [32.90568657111875, 2.27870795126189],
            [32.90532974052497, 2.276979909933285],
            [32.90600811229491, 2.274211508129483],
            [32.905794091373444, 2.27198587996251],
            [32.906326460858565, 2.271234995632297],
            [32.90939084875299, 2.270773784905153],
            [32.915337766002466, 2.270854635316676],
            [32.92085229266464, 2.270818195050372],
            [32.92284182566036, 2.271281677613159],
            [32.924217472448774, 2.277079475978775],
            [32.92662045954561, 2.280065797994511],
            [32.92826501881098, 2.280845416299695],
            [32.93470236230664, 2.280786214853107],
            [32.93850792768411, 2.281877954481919],
            [32.9443612189214, 2.280882122900813],
            [32.94489342850641, 2.279702622847734],
            [32.946020936358885, 2.278613875978688],
            [32.94766848521749, 2.273547087064118],
            [32.949394527967335, 2.27250770762085],
            [32.95066804708777, 2.273036961903022],
            [32.95173458628188, 2.272431474601751],
            [32.95303297256599, 2.272449611685833],
            [32.955150707729175, 2.27338154297953],
            [32.95691153684006, 2.273218747352703],
            [32.95883901511428, 2.273625929371037],
            [32.96000509931998, 2.274413070419736],
            [32.96093315153495, 2.274367859719073],
            [32.96385287653263, 2.272863844636443],
            [32.96782072705777, 2.268265262047104],
            [32.97002026370901, 2.266797492482819],
            [32.972413853529645, 2.266125091822203],
            [32.97477844213965, 2.266155293798244],
            [32.98089692323533, 2.267705031230619],
            [32.982388178709265, 2.270930743651238],
            [32.98359631754498, 2.271482392071566],
            [32.98458774949649, 2.273093672804595],
            [32.989229113702514, 2.276698630701221],
            [32.989157821604934, 2.278164605761041],
            [32.98970011477903, 2.279407211364723],
            [32.98944184284663, 2.283908981692496],
            [32.990422521065895, 2.28673572050196],
            [32.99144093391697, 2.287418696039271],
            [32.99249705984032, 2.289277894456102],
            [32.99442074093581, 2.289258932691331],
            [32.99670274921838, 2.290681790511159],
            [33.00071985167558, 2.295064177679781],
            [33.00107818694747, 2.296012745569687],
            [33.00104046938364, 2.299522444606611],
            [33.00004090408553, 2.304853395382861],
            [33.00247382484422, 2.30826823726468],
            [33.00347339912549, 2.309065030758529],
            [33.008473696881396, 2.309431611068518],
            [33.00896960913902, 2.309874128803486],
            [33.007905808908234, 2.311097100910695],
            [33.006207878935186, 2.311552941868223],
            [33.00558457838373, 2.315486541307815],
            [33.0030913186857, 2.321129546181578],
            [33.002605785562835, 2.32147274595131],
            [33.002350307390984, 2.325364479129331],
            [32.999397110267495, 2.330466164559327],
            [32.99732118988417, 2.331697628729052],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 657,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "NGETTA",
        Population: 32621,
        Key: "LIRANGETTA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.927355639875806, 2.244745019409115],
            [32.92671525875755, 2.247476873203658],
            [32.92699529058106, 2.2501380816798],
            [32.931503088779046, 2.256218034197744],
            [32.93111594633264, 2.257431374756901],
            [32.92723616304472, 2.259424667303156],
            [32.92632553724794, 2.260284075092378],
            [32.92301179948852, 2.265037650616538],
            [32.92284182566036, 2.271281677613159],
            [32.92085229266464, 2.270818195050372],
            [32.915337766002466, 2.270854635316676],
            [32.903960903864686, 2.253046739637873],
            [32.90392757636767, 2.249308960884588],
            [32.90840589724793, 2.245948164417966],
            [32.927355639875806, 2.244745019409115],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 658,
        District: "LIRA",
        County: "LIRA  MUNICIPALITY",
        Subcounty: "RAILWAY DIVISION",
        Population: 5773,
        Key: "LIRARAILWAY DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.02381146736374, 2.440106290379627],
            [33.02414990764704, 2.440915737991479],
            [33.025502401257334, 2.441678285371919],
            [33.02545914737639, 2.443551057216475],
            [33.025979745338056, 2.444383389846809],
            [33.02468709389874, 2.446826847194042],
            [33.02427045167669, 2.44676422708316],
            [33.02185958276158, 2.449843317976566],
            [33.02085568399055, 2.452030839941758],
            [33.02076331382314, 2.453293559629997],
            [33.019866593946965, 2.454441497986342],
            [33.021100304225556, 2.455594870558655],
            [33.02213282242322, 2.458826675677577],
            [33.02231639943976, 2.464181630662364],
            [33.02078152986044, 2.468784274685113],
            [33.01976419858098, 2.470686926926934],
            [33.019817094978166, 2.471298186201965],
            [33.019291767386555, 2.471459183299148],
            [33.0188813666591, 2.472420991297152],
            [33.018191871050995, 2.472474663235354],
            [33.018048236725264, 2.473333271251945],
            [33.0174490388712, 2.473902930303946],
            [33.015503674241366, 2.474208420126874],
            [33.01566815846483, 2.477380062613305],
            [33.01442857230596, 2.479521638903984],
            [33.0143855816314, 2.481410677223177],
            [33.01274000816808, 2.484040010092379],
            [33.01180635046572, 2.483855017040166],
            [33.00944202236717, 2.481638113004376],
            [33.00671976323859, 2.48061493438507],
            [33.00396924670446, 2.477810632786305],
            [33.002593993378106, 2.47749799360572],
            [33.00122816158248, 2.476645332271498],
            [32.99664085619363, 2.475660029598704],
            [32.99207240823921, 2.472495683091011],
            [32.98652390549635, 2.471601128680027],
            [32.9809309639947, 2.473755427984693],
            [32.97623809128862, 2.473100869192945],
            [32.97526258287382, 2.472459920347597],
            [32.973290364006886, 2.469418210592757],
            [32.97133556526994, 2.468790239347159],
            [32.968359010152426, 2.46890385960244],
            [32.962707258644066, 2.471442751343335],
            [32.95660340032458, 2.472427864191647],
            [32.95392827310402, 2.472200397212135],
            [32.94831436133037, 2.469509565188124],
            [32.94530016320918, 2.468713624939392],
            [32.941833775631856, 2.469281919109936],
            [32.93618802127636, 2.468859145282353],
            [32.93573705083406, 2.476281917190268],
            [32.931840853529266, 2.475425384255011],
            [32.93119197165343, 2.4757054589787],
            [32.92958765152292, 2.47881700746298],
            [32.92798339427446, 2.480622436365954],
            [32.92704761654803, 2.480929705225762],
            [32.923820226650385, 2.480410918002492],
            [32.92206326838002, 2.480737344378976],
            [32.917999962872805, 2.480451875108498],
            [32.91639936266588, 2.480908035733274],
            [32.9153894191313, 2.480236491298322],
            [32.912984303925576, 2.479917812691033],
            [32.91111000232293, 2.477472814029871],
            [32.91101921229208, 2.47686107116904],
            [32.90895750954475, 2.477144221238965],
            [32.90487514717711, 2.476126296563003],
            [32.902888486993675, 2.476574329338724],
            [32.900762656213146, 2.475951931220207],
            [32.89764799230724, 2.47595172569805],
            [32.89385653586962, 2.476644730962439],
            [32.88920343607272, 2.476644358509836],
            [32.87596527185279, 2.475600733301767],
            [32.876243539385115, 2.473998371705373],
            [32.87770730191975, 2.473003318652149],
            [32.87816756902695, 2.471800086429922],
            [32.877766556592526, 2.47056963343729],
            [32.878191399534785, 2.469402586344664],
            [32.87823898060045, 2.465485161797553],
            [32.878782146936985, 2.464490021594988],
            [32.881189832222745, 2.463305058952696],
            [32.882051617515835, 2.460699547381374],
            [32.88169773968438, 2.457288728219269],
            [32.883031977731484, 2.452122904747776],
            [32.88230055505409, 2.449155364228935],
            [32.88279626968238, 2.447418348259555],
            [32.88364606965296, 2.446730836630155],
            [32.88441358394351, 2.445174788004049],
            [32.885381431525566, 2.444559662910258],
            [32.89097541237798, 2.444750122696011],
            [32.89305272065846, 2.444180318366636],
            [32.89520094284574, 2.442588183729938],
            [32.896888775754974, 2.440444131162258],
            [32.89901336236883, 2.439014837470714],
            [32.899512367525986, 2.43823554388493],
            [32.90220015111059, 2.434147685294057],
            [32.90392379985021, 2.43004038416613],
            [32.90604822925889, 2.426484988039579],
            [32.908987698328204, 2.416026632748577],
            [32.91051029153082, 2.412453091506072],
            [32.91041631248074, 2.409621312546848],
            [32.913508441249434, 2.406400711770984],
            [32.91210447327506, 2.401325142777261],
            [32.91226990522113, 2.398882410200541],
            [32.913414591556766, 2.396973524687152],
            [32.91298997588828, 2.395408331430597],
            [32.91408765248678, 2.394557965166716],
            [32.915834307979125, 2.394250469258367],
            [32.916211848333454, 2.393445291197963],
            [32.91913890987209, 2.390595600255198],
            [32.92107465085028, 2.386723510643294],
            [32.92083862839086, 2.385257850624737],
            [32.91956435109234, 2.382905503872957],
            [32.9183725094925, 2.379286552114765],
            [32.91813659393257, 2.376074781019021],
            [32.917361422402564, 2.373332606008034],
            [32.91735292523828, 2.372750085001159],
            [32.91886042315087, 2.370150998389717],
            [32.918968147323106, 2.369176313398779],
            [32.91894159671656, 2.362867890617082],
            [32.918457387710426, 2.357860939921082],
            [32.923507067654135, 2.356876920700504],
            [32.92433986251635, 2.357356468294607],
            [32.926862479157855, 2.35770944523972],
            [32.93093186985281, 2.357592040575189],
            [32.932811712264154, 2.357139773355198],
            [32.936274237085755, 2.357583249922398],
            [32.940343910749995, 2.357411535091448],
            [32.94191457100683, 2.356914004995099],
            [32.943913629737835, 2.355330825971156],
            [32.947233375429875, 2.355629514745873],
            [32.95149305714975, 2.3552225456648],
            [32.96309443792142, 2.352173992801585],
            [32.964141462114306, 2.351070260317044],
            [32.96587878321252, 2.350545566013457],
            [32.96785390812942, 2.34932423929022],
            [32.969757896357244, 2.349034770700984],
            [32.96944846177615, 2.34786767330323],
            [32.96965087017599, 2.346157754511281],
            [32.96888919583311, 2.344809702406472],
            [32.96888922368088, 2.343570233597813],
            [32.969865163287025, 2.340648004759379],
            [32.9714594366594, 2.338657651196344],
            [32.9744719594226, 2.33787060223748],
            [32.97616176952375, 2.336794012604803],
            [32.978446306563846, 2.336631199995843],
            [32.98249175895309, 2.335237985610777],
            [32.9853235343929, 2.335165640629378],
            [32.992551133928835, 2.336208385992831],
            [32.99331210399256, 2.335537846413116],
            [32.99407291325781, 2.33358637373688],
            [32.9952902005364, 2.331902751630014],
            [32.99732118988417, 2.331697628729052],
            [32.998333391783376, 2.339364284927697],
            [32.99787690568523, 2.342157573183537],
            [32.99806710059042, 2.3469023378589],
            [32.9889786274687, 2.351882323092123],
            [32.987057842541674, 2.353793874737718],
            [32.98324983913652, 2.355883741225285],
            [32.98017794132633, 2.359004988742],
            [32.98056491488948, 2.363809064595666],
            [32.98132657665594, 2.367608904815099],
            [32.98243651885134, 2.369689778639376],
            [32.98243647842714, 2.372856303176629],
            [32.98092619843214, 2.376818961492893],
            [32.981726416788916, 2.37762417441826],
            [32.983223955978254, 2.381224983188244],
            [32.98339170288281, 2.385920487640762],
            [32.98197158499625, 2.393891061865833],
            [32.98206179561371, 2.395094342079783],
            [32.98286229693981, 2.396632378247339],
            [32.98472107924759, 2.397745206694313],
            [32.98725106656602, 2.401174124970323],
            [32.990323287769726, 2.402757412024737],
            [32.99068446620949, 2.404964933437715],
            [32.99182060148192, 2.40550777382315],
            [32.99645621377516, 2.41246509672166],
            [33.00078042687183, 2.414102645368462],
            [33.0045236509652, 2.417477247013482],
            [33.00552151754911, 2.420010460534995],
            [33.00510916747749, 2.421213741021497],
            [33.006627890737846, 2.423348875060436],
            [33.01087992509973, 2.426669172300651],
            [33.0108799340829, 2.427800072645202],
            [33.011682735994434, 2.429437609942118],
            [33.01359189941663, 2.430487068171337],
            [33.0137653407418, 2.431446070392247],
            [33.01467664117336, 2.432495536034754],
            [33.01758366848449, 2.432712633702422],
            [33.01819111017792, 2.433318788263338],
            [33.01860519938792, 2.434614836425032],
            [33.020140109391406, 2.435452423188538],
            [33.0206754909277, 2.436232097131883],
            [33.020865109114496, 2.43669765985718],
            [33.02021821790537, 2.437712939135626],
            [33.0207926339357, 2.438228977760262],
            [33.02214221341121, 2.438004587879016],
            [33.02381146736374, 2.440106290379627],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 659,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "OGUR",
        Population: 35937,
        Key: "LIRAOGUR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.54709361749009, 2.003709441384618],
            [32.54709235266215, 2.008303149261637],
            [32.54493968561083, 2.007182130445216],
            [32.53847620742861, 2.004966540469225],
            [32.53088054566286, 2.003508078737589],
            [32.52474880363697, 1.998474472260827],
            [32.52163167924548, 1.995187017955703],
            [32.51673183739286, 1.995260269757609],
            [32.512351433776885, 1.996155296572023],
            [32.50620359304275, 1.998180915274375],
            [32.50562420753227, 1.995267632374637],
            [32.50533168553304, 1.989640361365192],
            [32.505648136854816, 1.980023583406268],
            [32.506103668942146, 1.977038236840508],
            [32.5082607404333, 1.972651124058497],
            [32.51007049718446, 1.970163757169891],
            [32.51719895415406, 1.963462074196655],
            [32.521356503714365, 1.960495881910662],
            [32.522428095033646, 1.958806046479605],
            [32.524121366343614, 1.958237905788018],
            [32.52828439652545, 1.950424455819161],
            [32.52912013876014, 1.947446522449387],
            [32.531795580391055, 1.946344162738672],
            [32.534909347778324, 1.946036159078028],
            [32.53657575496973, 1.946301367447574],
            [32.53850615546355, 1.9433896852285],
            [32.5402169295485, 1.941757548547431],
            [32.54232234341926, 1.940302015685287],
            [32.54495376131302, 1.939773236404022],
            [32.54683945085853, 1.939994369144982],
            [32.55074209267717, 1.941583901553851],
            [32.55284658307982, 1.943614194116328],
            [32.553810900282805, 1.945467682783181],
            [32.55652941343662, 1.947321638063123],
            [32.559686769776455, 1.94807258990201],
            [32.561002542952885, 1.947587565365297],
            [32.565300380614474, 1.947368064017284],
            [32.565914270415, 1.947677095411301],
            [32.56788699862672, 1.950589834110464],
            [32.568719715335526, 1.952663908402996],
            [32.56892057144654, 1.955298622754513],
            [32.567796231952094, 1.957840416105231],
            [32.565974496166604, 1.960385196138203],
            [32.56434774510343, 1.961575495829119],
            [32.56280732483399, 1.964687012816991],
            [32.56231512890669, 1.968595184584006],
            [32.559700988310745, 1.977333882232672],
            [32.559583795895435, 1.98236946372686],
            [32.56044304434615, 1.990394239731425],
            [32.56021875208769, 1.994053371996836],
            [32.55779495911058, 1.995026070108273],
            [32.54694677887374, 1.99773384687551],
            [32.54709361749009, 2.003709441384618],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 660,
        District: "APAC",
        County: "APAC MUNICIPALITY",
        Subcounty: "APAC TOWN COUNCIL",
        Population: 14972,
        Key: "APACAPAC TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.899512367525986, 2.43823554388493],
            [32.89901336236883, 2.439014837470714],
            [32.896888775754974, 2.440444131162258],
            [32.89520094284574, 2.442588183729938],
            [32.89305272065846, 2.444180318366636],
            [32.89097541237798, 2.444750122696011],
            [32.885381431525566, 2.444559662910258],
            [32.88441358394351, 2.445174788004049],
            [32.88364606965296, 2.446730836630155],
            [32.88279626968238, 2.447418348259555],
            [32.88230055505409, 2.449155364228935],
            [32.883031977731484, 2.452122904747776],
            [32.88169773968438, 2.457288728219269],
            [32.882051617515835, 2.460699547381374],
            [32.881189832222745, 2.463305058952696],
            [32.878782146936985, 2.464490021594988],
            [32.87823898060045, 2.465485161797553],
            [32.878191399534785, 2.469402586344664],
            [32.877766556592526, 2.47056963343729],
            [32.87816756902695, 2.471800086429922],
            [32.87770730191975, 2.473003318652149],
            [32.876243539385115, 2.473998371705373],
            [32.87596527185279, 2.475600733301767],
            [32.874437427099046, 2.477644213913378],
            [32.874189627726246, 2.479245540799108],
            [32.87468501626606, 2.481235967049394],
            [32.873811426211816, 2.483515771950442],
            [32.872607408846655, 2.484257523878922],
            [32.871285667263464, 2.484375008214932],
            [32.871120293707875, 2.485279709767764],
            [32.87060080336893, 2.485469649476086],
            [32.86982171787923, 2.487079969392874],
            [32.87006950737057, 2.488518494904783],
            [32.86957386460751, 2.489160794733198],
            [32.869384796189635, 2.49087069213339],
            [32.8704940906997, 2.493024030254991],
            [32.87009254915758, 2.49433583003478],
            [32.869195436717646, 2.495520920149613],
            [32.869124510234386, 2.496425631099764],
            [32.86829153301415, 2.497149320614253],
            [32.868527117095724, 2.502577648313728],
            [32.86582513114647, 2.50558103379557],
            [32.866059160244305, 2.506856709205722],
            [32.86579150900201, 2.507245709479063],
            [32.86440275579358, 2.508204565653207],
            [32.863322917041714, 2.507933064946883],
            [32.8585956262838, 2.504807931361697],
            [32.85795153961497, 2.5037419350982],
            [32.855904843224494, 2.501881564938947],
            [32.852704710907474, 2.501066085872907],
            [32.85210219108348, 2.500000091951661],
            [32.84893395255231, 2.497584112276565],
            [32.84460249364459, 2.496386736859381],
            [32.8386468223127, 2.495919381251023],
            [32.837369460199476, 2.495157843225102],
            [32.835823934804296, 2.494856270293508],
            [32.83356848431482, 2.49637874495353],
            [32.83100961616001, 2.497200544167783],
            [32.83015790457451, 2.49880622063053],
            [32.82942223735743, 2.500927710166228],
            [32.82978943001802, 2.504830306759328],
            [32.827892425293165, 2.508333591806856],
            [32.82539722972573, 2.519454570945311],
            [32.824225770899666, 2.518024962328872],
            [32.8202240799395, 2.517065415151519],
            [32.817271852996505, 2.515445562542383],
            [32.815661688426744, 2.513409725944866],
            [32.81488077845867, 2.513409615558386],
            [32.814124449091715, 2.512531934121689],
            [32.81334354900512, 2.512477538675844],
            [32.81157484975403, 2.510450722238637],
            [32.809281409511165, 2.509844229558261],
            [32.80828092254158, 2.510106449302578],
            [32.808134750475176, 2.50817033852668],
            [32.80742708823706, 2.507093623998555],
            [32.80579266286643, 2.505817733429779],
            [32.80296493972685, 2.501985118241543],
            [32.80253593399158, 2.49966718350331],
            [32.802658218057935, 2.497777492873539],
            [32.799123467789165, 2.492744285881496],
            [32.797243589445245, 2.491461645882124],
            [32.79648722773896, 2.491548464058968],
            [32.79547171464958, 2.490483304243339],
            [32.795147826175594, 2.488809670327297],
            [32.791982862901946, 2.483103780403677],
            [32.79081596841587, 2.48284277852561],
            [32.79005974145688, 2.48210367603909],
            [32.788935992155594, 2.482320845515062],
            [32.78527335053646, 2.480918354881157],
            [32.78105784975887, 2.476843942838764],
            [32.77856349052293, 2.474994259563318],
            [32.77418048718252, 2.473547130471591],
            [32.77407429643446, 2.472982453170836],
            [32.77313337675137, 2.47223425551177],
            [32.772390481689506, 2.467333726595966],
            [32.77286233347057, 2.464504261979878],
            [32.7716037452485, 2.46066419357486],
            [32.77181240232944, 2.459804631428137],
            [32.77112209284766, 2.458492608983072],
            [32.770793648118534, 2.45359166961903],
            [32.769061488739915, 2.447486367674726],
            [32.77044817133164, 2.445324327212604],
            [32.77143333843236, 2.441282853225058],
            [32.77369071490982, 2.437443886750526],
            [32.77375213721739, 2.4354349371207],
            [32.77284507683396, 2.432024014212072],
            [32.769128661163606, 2.431353891083658],
            [32.76671947299641, 2.42968880262453],
            [32.763932433657736, 2.426856564235901],
            [32.763111467811164, 2.424748438245965],
            [32.76328492350938, 2.421364842765505],
            [32.76748911629417, 2.41469783880249],
            [32.76813758943653, 2.41296090054451],
            [32.768278552172596, 2.41047296275773],
            [32.767566676835806, 2.403217039242292],
            [32.76341911115158, 2.396322408315281],
            [32.75636639204185, 2.38129388281296],
            [32.75309372705386, 2.377104476898662],
            [32.749527982212875, 2.374127325981584],
            [32.74724734655607, 2.361714252834691],
            [32.74628560572132, 2.359687520046357],
            [32.744149921320435, 2.357181073459446],
            [32.73988939248923, 2.354448047593257],
            [32.73810549374352, 2.352656381888098],
            [32.73601724488123, 2.349136656370223],
            [32.7324873410234, 2.340034580336337],
            [32.72942541541119, 2.334062892836053],
            [32.72549871850588, 2.319152482418274],
            [32.723304359743906, 2.316772661479056],
            [32.723811933930584, 2.313203374955082],
            [32.72287090824627, 2.312170338818117],
            [32.72262590622726, 2.311163150569382],
            [32.72156858913786, 2.310669649518882],
            [32.720792396223345, 2.309307801688855],
            [32.71984914720871, 2.308756237844355],
            [32.7220078787865, 2.306115607165311],
            [32.723692137299224, 2.306690850389499],
            [32.72561311536405, 2.307615737589848],
            [32.72683693069978, 2.30887196271497],
            [32.72733459557054, 2.310840716618228],
            [32.728348215011266, 2.310833856377892],
            [32.73056108086474, 2.312213752258862],
            [32.7317956472378, 2.312298660999706],
            [32.73387523813737, 2.31369263853284],
            [32.73466793490028, 2.313488161042545],
            [32.73609532195415, 2.314031750718483],
            [32.73752942571139, 2.316194719723019],
            [32.74093511681989, 2.315891937669118],
            [32.74204313572227, 2.317560915103074],
            [32.743516346737074, 2.316876740480662],
            [32.744203637879465, 2.317713016394564],
            [32.748001969123976, 2.318461652112433],
            [32.749390501346824, 2.320621076094822],
            [32.75176491572942, 2.321020168190484],
            [32.75401316712023, 2.320837104389469],
            [32.75597116835116, 2.32205378129658],
            [32.75616071287609, 2.322695566227432],
            [32.7584510108121, 2.323256884895962],
            [32.75829926559767, 2.324740589485759],
            [32.75927155175555, 2.325907837154439],
            [32.7608271679263, 2.326369507577656],
            [32.7617131915624, 2.325736358991633],
            [32.763484979221445, 2.326017120521563],
            [32.76443540847015, 2.326822475863837],
            [32.764478509637485, 2.32791718706733],
            [32.76669304186577, 2.329527948974955],
            [32.768659396530545, 2.329419709757375],
            [32.76945864830009, 2.330035047951406],
            [32.77050526106458, 2.329753236164154],
            [32.77375724324146, 2.33962837144064],
            [32.77415737892015, 2.342287329636873],
            [32.77319548447346, 2.346235366717992],
            [32.7730348558192, 2.348652533775188],
            [32.77295435688826, 2.35115025796279],
            [32.77367499978223, 2.353325882869572],
            [32.773674686270205, 2.355017924324272],
            [32.77303348678672, 2.357435091422805],
            [32.77359393760765, 2.359288307914409],
            [32.777518274638716, 2.363720549919066],
            [32.78168305473873, 2.367266430807816],
            [32.785110692587956, 2.37218200615306],
            [32.78910825129784, 2.375804695961616],
            [32.79116914106983, 2.374900060165285],
            [32.793911223321786, 2.372738329852945],
            [32.794393909683514, 2.371811768598326],
            [32.79632426975316, 2.370686857950137],
            [32.80338750274494, 2.368356952890542],
            [32.812145166771714, 2.367496431221439],
            [32.81281143733649, 2.367975268778272],
            [32.813073093222556, 2.368860986106994],
            [32.81328649700142, 2.374629912947672],
            [32.813809735111725, 2.376975842929714],
            [32.8147854177997, 2.377191411942585],
            [32.82094919285032, 2.376162924220528],
            [32.826422626079804, 2.376714186870414],
            [32.83253336998598, 2.382762837429603],
            [32.8352887706603, 2.384133335085529],
            [32.83545455923758, 2.38904920934778],
            [32.836587816307855, 2.390482264211445],
            [32.83883917047964, 2.396389798435249],
            [32.8412034330012, 2.398853392221116],
            [32.83931689634435, 2.401049460323595],
            [32.83790965221413, 2.401866725380981],
            [32.833710681336065, 2.402691220415194],
            [32.829743672532366, 2.414013689661767],
            [32.82968325364299, 2.415777219103036],
            [32.83162434139377, 2.418570357982391],
            [32.83622933550887, 2.420856711073448],
            [32.838478843642754, 2.424701947176577],
            [32.839434417543096, 2.425542200310938],
            [32.84510055736736, 2.42710961344759],
            [32.84637952926154, 2.429569629752334],
            [32.84614600861017, 2.431726717961832],
            [32.84528794863058, 2.433543138537493],
            [32.84555872780666, 2.434610374033044],
            [32.84507932299067, 2.436228850862309],
            [32.84626986472828, 2.439709367918621],
            [32.850133122608234, 2.439578680993415],
            [32.852239899223264, 2.439904924402114],
            [32.85542718024184, 2.439416259310317],
            [32.899512367525986, 2.43823554388493],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 661,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "ALITO",
        Population: 39282,
        Key: "KOLEALITO",
        Dist2: "Kole",
        "Sub Country": "Alito",
        id2_original: "Kole Alito",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.44985914558523, 2.027718888481684],
            [32.44957131638503, 2.027972101429694],
            [32.441905868996464, 2.026549106307948],
            [32.42559085994407, 2.025665822625512],
            [32.416258695445336, 2.025544854768909],
            [32.398957394601446, 2.026434113066839],
            [32.397348339451064, 2.027383419778107],
            [32.39408289691798, 2.030349523740613],
            [32.38941297077747, 2.032699905017297],
            [32.35667285155823, 2.04080197172055],
            [32.353488262790556, 2.042338620414776],
            [32.34575889937121, 2.043701514707015],
            [32.344981284423596, 2.041864725186962],
            [32.34366233031277, 2.034138340498874],
            [32.343960190101384, 2.018786286520681],
            [32.3434558471548, 2.013792327333455],
            [32.340646971568226, 2.004210780788158],
            [32.33999295402393, 1.997579319226278],
            [32.337386594635, 1.99315445219813],
            [32.3364522506198, 1.988395537497745],
            [32.33649580723296, 1.98557300064658],
            [32.33906444815975, 1.978128643027518],
            [32.33896609611087, 1.976020733354955],
            [32.33559525873705, 1.971441775913997],
            [32.33354481547347, 1.96746947390701],
            [32.333553311739465, 1.965180676301953],
            [32.334565766065246, 1.958604172019803],
            [32.33682122643623, 1.956406735928844],
            [32.33791392636804, 1.955782951971441],
            [32.339827273244524, 1.955412798581069],
            [32.34103972489191, 1.955368045435895],
            [32.34693803519967, 1.956953534047296],
            [32.35270484382793, 1.95786045389976],
            [32.358528478084416, 1.957148019883939],
            [32.3603107338115, 1.956452110318098],
            [32.36325451928577, 1.953657808773008],
            [32.36362136699328, 1.952472830969734],
            [32.36364095835131, 1.949695501910311],
            [32.36297059865537, 1.946537949520934],
            [32.36107551632524, 1.943198996387955],
            [32.35652674327219, 1.93795922500577],
            [32.35295516656838, 1.934393461738942],
            [32.347541872852176, 1.931360738519807],
            [32.34451916139706, 1.92904361993026],
            [32.34351788840157, 1.92724294476276],
            [32.34234715092271, 1.923343377827205],
            [32.34198318770558, 1.918467084517496],
            [32.34416015238869, 1.895579855408197],
            [32.34360665362976, 1.891065355836655],
            [32.33958669902154, 1.881673384164063],
            [32.33923455763352, 1.87667949259586],
            [32.34046182699155, 1.870682020398116],
            [32.34336411479127, 1.86416951336302],
            [32.34359594571156, 1.860288578359141],
            [32.34197253907619, 1.855701308137226],
            [32.33942488189616, 1.853067772121681],
            [32.33486878398026, 1.850750109941383],
            [32.32965058817412, 1.849155160924239],
            [32.316804711950574, 1.845107145397134],
            [32.312403456640205, 1.842879968992608],
            [32.30549048035443, 1.838335872818298],
            [32.30056723918528, 1.836832201953586],
            [32.29689316380922, 1.836025603232312],
            [32.292875016611326, 1.83568928231811],
            [32.28900141463089, 1.836447646685253],
            [32.283715125627886, 1.838680020714609],
            [32.28264525188743, 1.838634355024476],
            [32.27895828568705, 1.837094945350395],
            [32.27733967156369, 1.83572825727367],
            [32.27564509410331, 1.831140968577812],
            [32.27571378647645, 1.829395012937872],
            [32.27818675323221, 1.821706449414505],
            [32.27856248437959, 1.818648866476431],
            [32.277996648158535, 1.813682082029021],
            [32.27760333967602, 1.812198289949534],
            [32.27649674729833, 1.810560419125837],
            [32.27464380853143, 1.808560387394201],
            [32.27193558827413, 1.806713800124512],
            [32.26840657644338, 1.805210647870316],
            [32.25846502000873, 1.803252542592188],
            [32.2569242404132, 1.802654840034349],
            [32.25064944976312, 1.799268859588372],
            [32.240569440485274, 1.792633592196593],
            [32.23727629480713, 1.790940523885536],
            [32.23337865301137, 1.789690472901272],
            [32.230029253033486, 1.789535269453755],
            [32.227738416108345, 1.7901765969574],
            [32.220833102451905, 1.793258487497024],
            [32.21675960555782, 1.79333815328003],
            [32.21345447635375, 1.791509349192201],
            [32.20898497064138, 1.783456105768542],
            [32.20627328288708, 1.781491859948267],
            [32.203280212243065, 1.781219166258699],
            [32.19704733878077, 1.782130124894029],
            [32.19469560685912, 1.782002441753774],
            [32.178583674553124, 1.777743491713847],
            [32.17145865813104, 1.777821700905428],
            [32.16629086410053, 1.776896632599125],
            [32.1625085219698, 1.773837257848644],
            [32.15624534114647, 1.76552084869715],
            [32.151748495208395, 1.76148414531287],
            [32.14281959432218, 1.756233197187014],
            [32.12742160078317, 1.746257077582124],
            [32.119233048234946, 1.743005641219097],
            [32.114302716663275, 1.742315800958555],
            [32.110383082312744, 1.74125553612908],
            [32.107209798842945, 1.739200542509553],
            [32.10626902738187, 1.73786126005687],
            [32.102626695772976, 1.732033789268913],
            [32.100150928968496, 1.724732355901237],
            [32.09901635586631, 1.720344428261248],
            [32.098339358518764, 1.713677089048379],
            [32.09572141445593, 1.699835235448066],
            [32.09612173698419, 1.694995733437702],
            [32.097226570460556, 1.690844067062238],
            [32.10081091761447, 1.684043029516727],
            [32.10393395561549, 1.68585371341608],
            [32.118901571691744, 1.705753209512324],
            [32.128094807240245, 1.714749381554438],
            [32.132156672748046, 1.716831876841605],
            [32.13475133247871, 1.718732773626263],
            [32.134901369097456, 1.719935992131138],
            [32.137346010175676, 1.721230721271275],
            [32.138642553116846, 1.72362856946337],
            [32.14161327906647, 1.7257919772057],
            [32.14789468041872, 1.727613124631051],
            [32.152702903993806, 1.727497690607704],
            [32.15442013606735, 1.729018238048468],
            [32.160770195656774, 1.730685598111113],
            [32.16310483982507, 1.731147999632462],
            [32.167307049129704, 1.731177002870655],
            [32.17952293864117, 1.728622253253205],
            [32.18635889696774, 1.726101281280463],
            [32.19221052183018, 1.724737792736074],
            [32.20004231564983, 1.721041150918795],
            [32.2070958558197, 1.719488136732686],
            [32.22556468805517, 1.724905555223567],
            [32.24566410087188, 1.733598324089591],
            [32.25617819585795, 1.738930912559818],
            [32.25922279925653, 1.741003772001425],
            [32.264216158425185, 1.746361287631795],
            [32.265562969293, 1.751286361476022],
            [32.266640741919744, 1.75357634604935],
            [32.268144368093445, 1.760043409853811],
            [32.27048526543443, 1.765197306099018],
            [32.27020143553391, 1.76969417834896],
            [32.270564316281146, 1.772627638708861],
            [32.270903791423635, 1.772969505848754],
            [32.27260146537681, 1.773927030165599],
            [32.27788823587679, 1.774248115526192],
            [32.28519442722032, 1.775417981586521],
            [32.28743648921882, 1.77592546198651],
            [32.2901808945141, 1.777165907788561],
            [32.29477986632353, 1.780596339172286],
            [32.30239306859351, 1.788062704531171],
            [32.3076686119491, 1.792289484916686],
            [32.32975770778017, 1.805542063126373],
            [32.353423546360865, 1.824855537025372],
            [32.35746927902449, 1.825510020956284],
            [32.36501071758138, 1.824864160967735],
            [32.36913480849059, 1.827784139272425],
            [32.3709376904349, 1.833102963638647],
            [32.37138871836938, 1.833557115088503],
            [32.37454691193904, 1.833882509506132],
            [32.3811223327821, 1.831031145454706],
            [32.38705343069939, 1.827466110675906],
            [32.39253203642829, 1.827727410792736],
            [32.3967218238292, 1.827145128068438],
            [32.398784264093386, 1.827534962047355],
            [32.40129808622827, 1.827341239220211],
            [32.403102343493266, 1.828833540402703],
            [32.410317846315614, 1.839537250824358],
            [32.41463501392548, 1.843754353204257],
            [32.4203064591998, 1.845896487838249],
            [32.42155095105843, 1.849278238750586],
            [32.42185090571834, 1.853614921778411],
            [32.42301038730667, 1.855885281783921],
            [32.42384733418218, 1.858933815320256],
            [32.425909132150935, 1.861463897817787],
            [32.427583647536075, 1.865680124678945],
            [32.42842125287665, 1.866718105363551],
            [32.429194548724354, 1.867302067542614],
            [32.43022584251831, 1.867367261372825],
            [32.43540631626904, 1.866708361121677],
            [32.43763849859604, 1.867110239899627],
            [32.44021637600059, 1.868408203027616],
            [32.44369569931801, 1.87275471968849],
            [32.444339455406805, 1.875349196504264],
            [32.44511261830384, 1.876387151714325],
            [32.44704589789815, 1.877814618572702],
            [32.448850612405636, 1.878139476920673],
            [32.452716822149625, 1.882161825645246],
            [32.45510073621632, 1.885470279009742],
            [32.45864404114155, 1.891567942619203],
            [32.45909474658084, 1.893189507692595],
            [32.45881502108283, 1.895946056108809],
            [32.4574330034424, 1.907422347341108],
            [32.458526899031845, 1.920046206284322],
            [32.45969819526284, 1.922199731929945],
            [32.462544878244785, 1.924715664265894],
            [32.46735045538305, 1.925621272658722],
            [32.4696990602692, 1.927007518166559],
            [32.470178102165804, 1.927856814898349],
            [32.470507684162094, 1.931490295362975],
            [32.469615528625866, 1.935157533528872],
            [32.46726492588653, 1.940128316469748],
            [32.46669647916128, 1.944692157055701],
            [32.46552407620586, 1.948193224066182],
            [32.463625594650715, 1.964522200624633],
            [32.45119381572197, 1.99773812923502],
            [32.44887374043094, 2.006702760246591],
            [32.448576291172394, 2.01552332084296],
            [32.450111559603656, 2.024163570791958],
            [32.44985914558523, 2.027718888481684],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 662,
        District: "APAC",
        County: "MARUZI",
        Subcounty: "IBUJE",
        Population: 40147,
        Key: "APACIBUJE",
        Dist2: "Apac",
        "Sub Country": "Ibuje",
        id2_original: "Apac Ibuje",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.10448933101548, 2.035029348269664],
            [33.09859469212228, 2.042493693225957],
            [33.090593918909484, 2.048927830825636],
            [33.08621440552397, 2.050318771205134],
            [33.07794224767058, 2.054961812014889],
            [33.077390646153525, 2.0545285476465],
            [33.067158040058374, 2.046313263195537],
            [33.064383746016965, 2.043544920336447],
            [33.05985582286167, 2.037809143088195],
            [33.057329275192465, 2.031204745663212],
            [33.05575352418291, 2.019705749076254],
            [33.05504024927091, 2.017633953919806],
            [33.053672789727976, 2.015725030338935],
            [33.04897673159588, 2.012413886453651],
            [33.044884916256514, 2.011102153510388],
            [33.039871709709985, 2.011102284583645],
            [33.036334660652415, 2.011789958431442],
            [33.034155169906704, 2.012694731282995],
            [33.02874582069292, 2.017517021786528],
            [33.01722363539673, 2.025777327249686],
            [33.01267605171309, 2.029993388445068],
            [33.00291705809699, 2.037439323280601],
            [32.99644529834616, 2.041863427945549],
            [32.98365379085854, 2.041863347148511],
            [32.97932533951037, 2.040415737320367],
            [32.97542997494386, 2.036633931463427],
            [32.972977062178494, 2.033295456108523],
            [32.972111603674215, 2.029667493837377],
            [32.96937039099144, 2.026184252988054],
            [32.9657633892244, 2.02299050026651],
            [32.964609063965774, 2.019796796019822],
            [32.9573953110616, 2.016892454719354],
            [32.94813281270977, 2.014047987054625],
            [32.942785445453985, 2.011603359573195],
            [32.94840041364639, 2.006808221522784],
            [32.95091146268197, 2.004071453822469],
            [32.9538478406484, 2.00233099289737],
            [32.95474007523637, 2.00113414006625],
            [32.95774395800316, 1.995658501914353],
            [32.96140208199472, 1.990841155707538],
            [32.962234845415914, 1.988776559187567],
            [32.96250259996447, 1.984527646194352],
            [32.962948720402544, 1.983390621756936],
            [32.96650476972669, 1.977953290432676],
            [32.96793790599835, 1.977048592739099],
            [32.969012523741824, 1.973809696349305],
            [32.968833636829416, 1.967766125621583],
            [32.96493762278094, 1.964029530795922],
            [32.96449215631638, 1.954439428177709],
            [32.961248752152144, 1.946749187655282],
            [32.95771786284247, 1.941230274433771],
            [32.95848641199221, 1.940388898504951],
            [32.9591063393698, 1.938443753130137],
            [32.95910641482829, 1.935295307672086],
            [32.95802800709263, 1.932988230104829],
            [32.95579697730412, 1.929894010070999],
            [32.954309492059465, 1.925931271366701],
            [32.95455764447016, 1.914034131425022],
            [32.95391338173153, 1.911962291301854],
            [32.95287206723063, 1.91034280256194],
            [32.95247564788227, 1.908144307411505],
            [32.951781330117676, 1.907619546667515],
            [32.95153351906678, 1.906778144282244],
            [32.95166989320837, 1.903466851409582],
            [32.952438431578344, 1.902444531759385],
            [32.95460791239684, 1.893704935445851],
            [32.95574834520958, 1.886747620655681],
            [32.95561220642659, 1.881192596556466],
            [32.954273771450474, 1.873882372837928],
            [32.96561491387761, 1.875891128206836],
            [32.96754865430766, 1.876497332054951],
            [32.971936504059045, 1.879283966338107],
            [32.978641912022, 1.885689526126849],
            [32.98212500197541, 1.890014158347112],
            [32.992772202133736, 1.90089809604095],
            [33.00063096158159, 1.906733596354333],
            [33.01000900483852, 1.914580148643912],
            [33.01305706764929, 1.917300750331768],
            [33.01604013195935, 1.921046291052891],
            [33.01838622785091, 1.928021706090542],
            [33.0211047041738, 1.938172701533746],
            [33.02224023667669, 1.939982138410168],
            [33.02359184364981, 1.940778278889973],
            [33.02732179513486, 1.940072536134654],
            [33.032186171500065, 1.941655721027467],
            [33.03674769344364, 1.945708798850194],
            [33.03729367510028, 1.9457811649069],
            [33.03750389435147, 1.947255862796907],
            [33.0380962533313, 1.947862016302757],
            [33.039494249305704, 1.949101457633013],
            [33.0412260619346, 1.94977091311709],
            [33.04691348015299, 1.949752669020862],
            [33.04900188262721, 1.950376869100518],
            [33.05061844679506, 1.949625899435567],
            [33.05130661918478, 1.949788728964824],
            [33.05263908036423, 1.94864873339211],
            [33.055963300564706, 1.948802428842345],
            [33.0566745246229, 1.949281909142274],
            [33.05901383733575, 1.949209449865175],
            [33.059820595427794, 1.949517028288499],
            [33.06354473840621, 1.951244916211805],
            [33.06546936003784, 1.952773827969263],
            [33.066511902535744, 1.953678511882204],
            [33.069525664075705, 1.954664539806525],
            [33.07597043484214, 1.955668503241284],
            [33.077084910834785, 1.956346995973726],
            [33.07995841571447, 1.956346860407195],
            [33.08157138841782, 1.957043420017584],
            [33.08989541230077, 1.966850208142946],
            [33.090581676668805, 1.967944887284053],
            [33.091357699801705, 1.971192806147002],
            [33.092267412011864, 1.973137913556046],
            [33.09473028619541, 1.976096223276781],
            [33.09885530686094, 1.9790906184611],
            [33.10032227907611, 1.981307104228575],
            [33.1004537870438, 1.985948331987423],
            [33.10004725086872, 1.987214970042449],
            [33.09797308040354, 1.990734473331981],
            [33.09466524906715, 1.993629785485801],
            [33.09279584597774, 1.995945986833362],
            [33.091875240796476, 2.00553611681293],
            [33.08982469512496, 2.010123183297559],
            [33.08865579649749, 2.011941742975495],
            [33.087942335634224, 2.012357955029625],
            [33.09094463826441, 2.017397102802343],
            [33.09300555588418, 2.022155834410068],
            [33.09577011039126, 2.026416921985059],
            [33.097523941626115, 2.031727546295684],
            [33.09899034700435, 2.033066447329704],
            [33.10274562379387, 2.034703760810849],
            [33.10448933101548, 2.035029348269664],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 663,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "AGWATA",
        Population: 21287,
        Key: "DOKOLOAGWATA",
        Dist2: "Dokolo",
        "Sub Country": "Agwata",
        id2_original: "Dokolo Agwata",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.7725282895423, 2.09198671773942],
            [32.7675980693617, 2.089963418602335],
            [32.76438988005492, 2.08787636445268],
            [32.75891260023936, 2.086520146686899],
            [32.757742555361595, 2.087161989202357],
            [32.75588085442744, 2.089872459146905],
            [32.750846125145024, 2.092421916306285],
            [32.74814514081731, 2.092820099225383],
            [32.74471927175087, 2.091620476269656],
            [32.74355401219861, 2.090806041366586],
            [32.736127268740596, 2.080310108212946],
            [32.7312680990108, 2.074589677058516],
            [32.7249127213949, 2.065475976497327],
            [32.71806701455083, 2.071168650505086],
            [32.716081391023245, 2.071889631296908],
            [32.714923215585294, 2.07172296000319],
            [32.71139480472751, 2.064231500010254],
            [32.70858272305366, 2.06045783273585],
            [32.707700338492806, 2.060180232564409],
            [32.70417047685581, 2.060845425956898],
            [32.70372931062653, 2.060567905751366],
            [32.70356408978451, 2.05929166265897],
            [32.705219459376, 2.054908458572579],
            [32.70538520034255, 2.053354839414083],
            [32.699870101453556, 2.052854419263965],
            [32.69810540868859, 2.051966284274231],
            [32.69468656265106, 2.048969309150447],
            [32.687573592636944, 2.040700301141558],
            [32.68497787019928, 2.038557287701366],
            [32.679963392536635, 2.037203089120674],
            [32.67698607654608, 2.032929963317747],
            [32.67417469555817, 2.026326398803411],
            [32.67318199877873, 2.025232390565481],
            [32.670064958828874, 2.023825805792733],
            [32.66791512686059, 2.023609064394046],
            [32.66340027868423, 2.024148875444368],
            [32.6629067298941, 2.020588858248579],
            [32.66211189783578, 2.01668627093779],
            [32.66168444438929, 2.004465254265245],
            [32.65642807737007, 1.992112133428754],
            [32.65682249078042, 1.988521082263113],
            [32.656663937234455, 1.982061424512205],
            [32.655756451049605, 1.975927305762505],
            [32.65453534413442, 1.972670097802533],
            [32.6547077497021, 1.967838986304111],
            [32.657845305376405, 1.958457798050564],
            [32.657730480920144, 1.955182725852341],
            [32.65601289850366, 1.950360269771062],
            [32.655446494547334, 1.947202716832422],
            [32.65541182945884, 1.946325142010899],
            [32.657008855269254, 1.94286043107988],
            [32.65677553943379, 1.93913297792709],
            [32.661172692138216, 1.939613366854707],
            [32.66746464150852, 1.936918586587017],
            [32.67622058705818, 1.937209802116522],
            [32.68045904787613, 1.935871638670339],
            [32.68283572331824, 1.932624171397909],
            [32.68410992964986, 1.928562252094395],
            [32.68589804418921, 1.924590897613404],
            [32.68645472567922, 1.924373869443659],
            [32.701523681601, 1.924485159107267],
            [32.70424210851656, 1.925426538093177],
            [32.7061253258984, 1.92698297480916],
            [32.70740945591898, 1.928638825106635],
            [32.7105146336155, 1.928493478323649],
            [32.710138830602894, 1.919678034632249],
            [32.716130854957726, 1.921757963664211],
            [32.72111512137906, 1.922975713250445],
            [32.723753773405804, 1.924119316430627],
            [32.72972724755001, 1.927697298860097],
            [32.73064333330708, 1.928840616062333],
            [32.73181607313074, 1.929357072772699],
            [32.73749679351035, 1.930243001492331],
            [32.73987892621785, 1.931312789449195],
            [32.74676843581348, 1.936919070502307],
            [32.749223853980176, 1.938210115609511],
            [32.75050660957833, 1.938394690088433],
            [32.75167952547176, 1.93780483905702],
            [32.753035934838394, 1.935555569037589],
            [32.75439660581272, 1.934278577020947],
            [32.75527359688862, 1.932536288923884],
            [32.755901707918426, 1.932306580279407],
            [32.760526227814566, 1.935294629830904],
            [32.763038474304416, 1.935812032658118],
            [32.773316169538646, 1.935641099112126],
            [32.77869820817114, 1.934647956652724],
            [32.779532532864316, 1.94292624781624],
            [32.77953020083782, 1.948465380138658],
            [32.77418171607781, 1.948113598533962],
            [32.77238626589586, 1.947661717058254],
            [32.77029151143429, 1.947611249233052],
            [32.769643058054875, 1.948163161365661],
            [32.76889459253991, 1.950621976060246],
            [32.76909318130315, 1.95729621019908],
            [32.76879358417274, 1.959805268899702],
            [32.76834461338028, 1.960457572336283],
            [32.76418045491443, 1.963220618621937],
            [32.76016433072256, 1.965223699149382],
            [32.75547547618073, 1.968886296765185],
            [32.751684338645035, 1.97274974102008],
            [32.74086119265854, 1.973199716015051],
            [32.740061533053854, 1.971757673601923],
            [32.738907384763365, 1.971734722666939],
            [32.73651855421711, 1.97235457286782],
            [32.73235708351058, 1.97514493778844],
            [32.72904365926322, 1.975221926147421],
            [32.72642344785258, 1.977082181402125],
            [32.71605151036193, 1.978165828175123],
            [32.706013557510765, 1.982646496342636],
            [32.70318106970695, 1.98462177266979],
            [32.69592065561198, 1.987182316168793],
            [32.69738117163517, 1.989786482109741],
            [32.69971844247738, 1.991550842461178],
            [32.70122082448443, 1.993525039784183],
            [32.71178000232133, 2.003564547328657],
            [32.70981635607714, 2.013307818497979],
            [32.70777013848867, 2.017759275595936],
            [32.7068512778357, 2.020572999375848],
            [32.70685032921477, 2.021664955793189],
            [32.71227674013072, 2.027335713184654],
            [32.713361764856764, 2.029099838155124],
            [32.710176138534976, 2.034885237149995],
            [32.70639820892892, 2.040431622033009],
            [32.70723879308297, 2.041481454498754],
            [32.70792449420733, 2.041348915892212],
            [32.70863637044243, 2.041986658691185],
            [32.7094904320207, 2.042048191019064],
            [32.71311321359406, 2.036389263741073],
            [32.71426930134726, 2.03522654235493],
            [32.719924781762366, 2.035964890143636],
            [32.72058877869115, 2.031428756927822],
            [32.72205339732026, 2.028482926193451],
            [32.72305507904919, 2.028948270675104],
            [32.72374840776861, 2.030111318875948],
            [32.72374791998342, 2.03297987551751],
            [32.72320825797479, 2.034452828302758],
            [32.72158972919142, 2.036158175319261],
            [32.72112713634597, 2.037553611006385],
            [32.72220586837344, 2.038096496670305],
            [32.72428677799984, 2.036236170773777],
            [32.72621369572535, 2.033600529377559],
            [32.730909331649244, 2.024718551014581],
            [32.73333699367029, 2.022741972823831],
            [32.73445807317857, 2.022276379676545],
            [32.73440567085479, 2.020180270255982],
            [32.73509197295204, 2.016280042173066],
            [32.73498691857285, 2.013600199396908],
            [32.73601596208701, 2.010230685864773],
            [32.742707522519865, 2.010890401075708],
            [32.74601279725099, 2.018890570952659],
            [32.74601295625278, 2.019677674412255],
            [32.7478436868692, 2.021740714738489],
            [32.75170023882556, 2.023641219286695],
            [32.752544018287125, 2.02608408432779],
            [32.755625274745945, 2.028029696749426],
            [32.75535601551931, 2.030246211412861],
            [32.75689669899511, 2.030879748153103],
            [32.75829060134674, 2.030264750876523],
            [32.75918332551656, 2.030572488345867],
            [32.76074878722283, 2.028980420973003],
            [32.76312082286653, 2.030699735595748],
            [32.76338952423937, 2.032246841941919],
            [32.76390317822387, 2.032473096539575],
            [32.766226677892774, 2.031758709910474],
            [32.76750808242476, 2.031786038334388],
            [32.769063315913215, 2.032917159608805],
            [32.76938129437096, 2.03380382923118],
            [32.771092973957714, 2.035495896541134],
            [32.77275593970327, 2.03592135115092],
            [32.77296348107662, 2.036817051361347],
            [32.774088538324975, 2.037631456469552],
            [32.77421053493046, 2.039377580247294],
            [32.77570225483336, 2.040626300871257],
            [32.776631527858825, 2.040879752388909],
            [32.778783475359596, 2.043259461070325],
            [32.7785262562527, 2.045982627321413],
            [32.77886821972855, 2.048244470264635],
            [32.77950403650686, 2.049104040308402],
            [32.779503898166304, 2.050117325479029],
            [32.779993038923344, 2.050877355817661],
            [32.779992887108065, 2.051990159649456],
            [32.77902652444118, 2.053699942613437],
            [32.77846352599812, 2.056649245338214],
            [32.77733826303556, 2.059236581221305],
            [32.77741135895021, 2.061027932627346],
            [32.77568671936886, 2.063352813712057],
            [32.774268409790935, 2.063497366647548],
            [32.77346124655869, 2.064094365104553],
            [32.773234715698564, 2.066519267800352],
            [32.77358334377548, 2.07443254439395],
            [32.77462867464408, 2.085396009121814],
            [32.77391440170376, 2.088747137195616],
            [32.773152863904805, 2.089848145358514],
            [32.7725282895423, 2.09198671773942],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 664,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "ADUKU",
        Population: 29565,
        Key: "APACADUKU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.87727410913694, 1.677475609716278],
            [32.879719870414306, 1.680349076176126],
            [32.88814428103026, 1.67898328889433],
            [32.892163560105395, 1.676990576438085],
            [32.89327029262026, 1.676873405479785],
            [32.894609988831036, 1.677342406240355],
            [32.897638764812626, 1.680449210520418],
            [32.90432201582913, 1.682764519819651],
            [32.905854839944524, 1.684608152543762],
            [32.906602496077404, 1.686865608022204],
            [32.909430355760875, 1.690781610151356],
            [32.914187197498336, 1.694032509580494],
            [32.91940361913182, 1.693984576671913],
            [32.924667997326715, 1.691408323412072],
            [32.92658230180727, 1.690782340163726],
            [32.928467869181915, 1.690686094362717],
            [32.93100426777652, 1.69138448263484],
            [32.93354063313344, 1.692997873417596],
            [32.94244199077475, 1.694924492287142],
            [32.94654806597098, 1.697308445677606],
            [32.949108401074646, 1.698199444548785],
            [32.95044840091597, 1.698247638647889],
            [32.95211194966811, 1.697994775178949],
            [32.95482780201208, 1.694573024831675],
            [32.9563340324018, 1.694343407198897],
            [32.957224062524055, 1.694848661853151],
            [32.961623011859075, 1.700655808423264],
            [32.97837284233989, 1.719871233921634],
            [32.988511986814586, 1.730073991478076],
            [32.98853141378092, 1.73433779018778],
            [32.98789836561029, 1.739539971677089],
            [32.986250726920154, 1.74706729664852],
            [32.98234936430244, 1.761352915876352],
            [32.97828330186563, 1.774815219359703],
            [32.97540269310868, 1.781709207316678],
            [32.97207588216693, 1.788223196603536],
            [32.965973823172966, 1.797017042755612],
            [32.961846202782986, 1.801965818409431],
            [32.95744519091607, 1.80610032314591],
            [32.954994753009316, 1.80791876467013],
            [32.9489879585546, 1.810949440527725],
            [32.944134872215876, 1.812813033549684],
            [32.94044731312743, 1.813364797968476],
            [32.933603565508996, 1.813120282263911],
            [32.92775169989806, 1.812061526098572],
            [32.90844692151032, 1.806351825217007],
            [32.90230932336707, 1.805682005925814],
            [32.89923633410381, 1.805746175739741],
            [32.89824728628103, 1.798457830142774],
            [32.89793671263619, 1.791848244448389],
            [32.89669326911148, 1.786294572930309],
            [32.89486673542406, 1.782383482588977],
            [32.89253486794829, 1.779645657480024],
            [32.89237946120076, 1.778589680619762],
            [32.89510020936305, 1.777572982842949],
            [32.89622744233101, 1.775969542693106],
            [32.89603318434575, 1.774600686945023],
            [32.89510043933174, 1.773505556722711],
            [32.89377904000668, 1.772175745503573],
            [32.892613055514, 1.771784578899691],
            [32.892341119307815, 1.769516190236259],
            [32.891175310884925, 1.766152674108899],
            [32.891136513546115, 1.764940264705407],
            [32.89210832988508, 1.762398180847802],
            [32.89218614375162, 1.760990230790699],
            [32.89164226594938, 1.756570783492359],
            [32.89028212857432, 1.753285473972995],
            [32.889817897201794, 1.749209322884616],
            [32.88766878029248, 1.748536377934872],
            [32.88165108837505, 1.749401054344509],
            [32.880457045004455, 1.748526299938887],
            [32.8822515780065, 1.745811803580346],
            [32.88744330135952, 1.745073345830617],
            [32.89058982940691, 1.744070908157234],
            [32.891271702809846, 1.741696305545294],
            [32.89048526910109, 1.738530073087609],
            [32.89069556291247, 1.72929536782481],
            [32.890013991343494, 1.726551298182995],
            [32.88938507542319, 1.720113343827577],
            [32.885242640017545, 1.714044569995211],
            [32.888179450971954, 1.711406252756344],
            [32.88796973567559, 1.710614693304243],
            [32.88634416589701, 1.709295352298044],
            [32.88600118013839, 1.70336409005312],
            [32.885077658127386, 1.701764560118083],
            [32.88181300431511, 1.698197965673317],
            [32.87848375444739, 1.697333178017622],
            [32.87249135549507, 1.692080463322447],
            [32.87378018909445, 1.69091336435705],
            [32.87401657088001, 1.689227448244743],
            [32.87296452600301, 1.682462037526497],
            [32.87227730403086, 1.680732832130975],
            [32.87727410913694, 1.677475609716278],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 665,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "APUTI",
        Population: 15024,
        Key: "AMOLATARAPUTI",
        Dist2: "Amolatar",
        "Sub Country": "Aputi",
        id2_original: "Amolatar Aputi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.921223295080324, 2.154300533017527],
            [32.914853755523986, 2.172521303785532],
            [32.913087407164, 2.172955468799714],
            [32.911669240418206, 2.173814872932535],
            [32.911321274399654, 2.174511488010691],
            [32.910518345825665, 2.174565724236941],
            [32.9096085204278, 2.176311784257039],
            [32.907654933518174, 2.177768267649036],
            [32.90511262760225, 2.178229517332765],
            [32.90236948533828, 2.177026059778491],
            [32.899029891370056, 2.177215830141082],
            [32.89832331878839, 2.177840040569443],
            [32.896299826779966, 2.182137331457156],
            [32.891140403251285, 2.183539283365902],
            [32.89073342959666, 2.183928283790248],
            [32.889941251161666, 2.186787146745559],
            [32.888024939844755, 2.189193564115707],
            [32.886997091988235, 2.19028819950212],
            [32.88519895314864, 2.190803752794747],
            [32.88483496837195, 2.191283227224494],
            [32.88256552572358, 2.191753504993412],
            [32.879514917985595, 2.190577123585151],
            [32.876817055303526, 2.192431581409572],
            [32.875189964677155, 2.194150415382426],
            [32.87057635661679, 2.194511908859628],
            [32.86845668288924, 2.195181216618832],
            [32.86742921232516, 2.19498208687153],
            [32.86702460393466, 2.193950668807619],
            [32.86395861883567, 2.198211625857235],
            [32.863863091090025, 2.201016251393846],
            [32.862852600481425, 2.202563230865694],
            [32.86520805951319, 2.205268561845043],
            [32.856463019511104, 2.209158036402615],
            [32.83937797998705, 2.215245038904643],
            [32.82466500485279, 2.200813091066807],
            [32.822992292386424, 2.198008264073643],
            [32.82183310544547, 2.197085311744631],
            [32.81809430106329, 2.191041336097154],
            [32.803083747313075, 2.171027059309567],
            [32.798994710462864, 2.166475785960251],
            [32.79474223862146, 2.159065571852092],
            [32.7926545691725, 2.153953630682786],
            [32.79226109539999, 2.152080811116834],
            [32.78803097543946, 2.142037858397722],
            [32.78575692982357, 2.139621944030151],
            [32.77872705846479, 2.13503402288736],
            [32.779645656809734, 2.133668032687963],
            [32.78046655618096, 2.127624638403058],
            [32.78188884439727, 2.121581328160372],
            [32.78339525265341, 2.118804057942232],
            [32.7826654217907, 2.116831669981363],
            [32.78988718676889, 2.102501936397147],
            [32.793623609717265, 2.096585579195398],
            [32.799169573821125, 2.085675394925299],
            [32.80484226056717, 2.087937912060287],
            [32.806533267224324, 2.089394720606236],
            [32.807175248242125, 2.090643313051653],
            [32.807412343289975, 2.093665104787749],
            [32.808362861471885, 2.095139915276063],
            [32.81329761185645, 2.097556116276174],
            [32.818140059447245, 2.098787109743364],
            [32.81949740755335, 2.098732984850343],
            [32.820426797359765, 2.098335016192835],
            [32.8246583573197, 2.094083314523266],
            [32.82835264748461, 2.091812877610152],
            [32.83020975353608, 2.09338729499916],
            [32.83276785542796, 2.096472669221768],
            [32.83751308284712, 2.09772168693114],
            [32.838715785977065, 2.098472730735914],
            [32.8408695193286, 2.101567098073318],
            [32.84264068176024, 2.10288817181708],
            [32.8461613087161, 2.103368027528169],
            [32.84865864856214, 2.104671071949308],
            [32.84922680872483, 2.096637202234103],
            [32.8512822250618, 2.087581138787076],
            [32.85368384582109, 2.084441981686917],
            [32.854683498255774, 2.08379972241695],
            [32.85557195812291, 2.082126069294723],
            [32.86004025021134, 2.078272360450481],
            [32.860551064621255, 2.079186174488632],
            [32.86280110545611, 2.0802177567285],
            [32.86429292866527, 2.081574969213095],
            [32.86649381189117, 2.082434645110122],
            [32.868817157049804, 2.084081435396815],
            [32.87063925305973, 2.084660609920548],
            [32.87300630305362, 2.084579378758585],
            [32.87590908043516, 2.086823324551244],
            [32.88023057522973, 2.091320132525937],
            [32.88216137727052, 2.092731647256742],
            [32.88926826299522, 2.095428242378086],
            [32.89700100587669, 2.100587321541542],
            [32.89897078132604, 2.101391239158081],
            [32.8990946931397, 2.102375194926017],
            [32.89759867569645, 2.104121050760623],
            [32.89694958630983, 2.110005909396905],
            [32.89806796099078, 2.111243726369675],
            [32.89927585907801, 2.111806415252417],
            [32.899723186851816, 2.112661611152149],
            [32.904013430156006, 2.115503763092399],
            [32.909400137333044, 2.119922167621631],
            [32.9168710940727, 2.125284592729654],
            [32.921686118792834, 2.130359600581562],
            [32.924749483506126, 2.132514131170049],
            [32.92433292572573, 2.135865363252152],
            [32.92414757633315, 2.146298295662118],
            [32.921223295080324, 2.154300533017527],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 666,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "AKALO",
        Population: 28887,
        Key: "KOLEAKALO",
        Dist2: "Kole",
        "Sub Country": "Akalo",
        id2_original: "Kole Akalo",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.70890855188868, 1.74303673189191],
            [32.71744004977131, 1.727482707233408],
            [32.729691205344196, 1.703401588020285],
            [32.74037663959765, 1.684038983456384],
            [32.74509180669247, 1.68107388162618],
            [32.751506315013614, 1.673085226638342],
            [32.754644159047125, 1.672122692342148],
            [32.76228364781897, 1.667099818874116],
            [32.76323586920664, 1.662098484882302],
            [32.76608204553877, 1.65750808832072],
            [32.766971615723605, 1.654589303566385],
            [32.766772522107196, 1.643951645035659],
            [32.77638866472851, 1.64388585795256],
            [32.779781227857455, 1.645971246550646],
            [32.781710483897605, 1.647697358480994],
            [32.7848554093505, 1.648752673],
            [32.79061478531811, 1.649861269094688],
            [32.79614175095203, 1.649758850625469],
            [32.80381835451815, 1.646978692580519],
            [32.80551318530341, 1.645963737937641],
            [32.806042106156184, 1.646269322840261],
            [32.81005418523432, 1.648099034766241],
            [32.82160503936451, 1.65639643362308],
            [32.829669912762725, 1.661481700611888],
            [32.83461183978806, 1.665390535002949],
            [32.835786193884275, 1.665806807236192],
            [32.837550561459096, 1.667710232335614],
            [32.835857806680416, 1.666628133533544],
            [32.83201342869279, 1.666487129855197],
            [32.83061776204993, 1.667395847386783],
            [32.824039905874145, 1.67482652225895],
            [32.81880392073041, 1.678095543395785],
            [32.8095047082329, 1.682874006856262],
            [32.806079397020255, 1.685757557163714],
            [32.803213181070795, 1.689485221812555],
            [32.80216422280508, 1.694197811749553],
            [32.79971716885203, 1.699965335966995],
            [32.80174303690434, 1.711712118353357],
            [32.800903346573996, 1.720363695622111],
            [32.798526184244984, 1.72577952681591],
            [32.796848360364635, 1.727889508451892],
            [32.79545028354186, 1.728592744454574],
            [32.78800364329861, 1.731269408095107],
            [32.76960127920763, 1.739450479648698],
            [32.76295169345472, 1.750022143678191],
            [32.75346031514828, 1.777341994346919],
            [32.75060692354777, 1.774472706084033],
            [32.7137668700156, 1.747362027955354],
            [32.70890855188868, 1.74303673189191],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 667,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "AWELO",
        Population: 11554,
        Key: "AMOLATARAWELO",
        Dist2: "Amolatar",
        "Sub Country": "Awelo",
        id2_original: "Amolatar Awelo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.766772522107196, 1.643951645035659],
            [32.766971615723605, 1.654589303566385],
            [32.76608204553877, 1.65750808832072],
            [32.76323586920664, 1.662098484882302],
            [32.76228364781897, 1.667099818874116],
            [32.754644159047125, 1.672122692342148],
            [32.751506315013614, 1.673085226638342],
            [32.74509180669247, 1.68107388162618],
            [32.74037663959765, 1.684038983456384],
            [32.729691205344196, 1.703401588020285],
            [32.71744004977131, 1.727482707233408],
            [32.70890855188868, 1.74303673189191],
            [32.640012220748964, 1.679676918746241],
            [32.596632537051256, 1.655110915477384],
            [32.58712267500954, 1.651179910343072],
            [32.5896716958322, 1.645830941799255],
            [32.595957847475646, 1.634650065967293],
            [32.60449277063449, 1.616729528462002],
            [32.6078202795672, 1.613627031116002],
            [32.61084698403378, 1.61151060068927],
            [32.61900787296279, 1.606409597007522],
            [32.62115078790338, 1.6054419598599],
            [32.624183043958396, 1.605098734258166],
            [32.62819960832477, 1.605352793063951],
            [32.63500277455022, 1.607507239705256],
            [32.64427118022337, 1.611552948481851],
            [32.65076450762584, 1.615188865963328],
            [32.64830021949403, 1.604112208731349],
            [32.6567944256143, 1.606526535931891],
            [32.660105213306316, 1.608273555629339],
            [32.66145243200928, 1.608572517492592],
            [32.66455191798016, 1.608746175115417],
            [32.66633396978967, 1.608157340561973],
            [32.67086021219706, 1.607784732316295],
            [32.67527499164403, 1.608457475179735],
            [32.677752741030375, 1.609513061677295],
            [32.680728578393975, 1.609093037744347],
            [32.68532894169377, 1.60928043322778],
            [32.68898301428343, 1.62222570178411],
            [32.68898249595551, 1.625608082657412],
            [32.68811213983628, 1.63037747122988],
            [32.68748556402731, 1.631468025095217],
            [32.689318720095, 1.63117656629936],
            [32.691645153661625, 1.629789653156658],
            [32.69692605546786, 1.62459095403187],
            [32.701843910338546, 1.622379619389226],
            [32.70671659432348, 1.619050824967835],
            [32.7125181309223, 1.617478124215328],
            [32.71460372885619, 1.616436193502605],
            [32.73557687994916, 1.629760863023209],
            [32.738151282670174, 1.633154616369172],
            [32.74332849373982, 1.638812855042265],
            [32.74807133253862, 1.64236523504137],
            [32.751834438145885, 1.643398532955323],
            [32.766772522107196, 1.643951645035659],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 668,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "ETAM",
        Population: 14690,
        Key: "AMOLATARETAM",
        Dist2: "Amolatar",
        "Sub Country": "Etam",
        id2_original: "Amolatar Etam",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.99993860483927, 1.712280551980268],
            [32.999039804464914, 1.712443403074176],
            [32.994836041074834, 1.716587053029164],
            [32.99365937202013, 1.717274646192468],
            [32.99163501673073, 1.71971739578971],
            [32.990224571903155, 1.722123969076675],
            [32.988714092482134, 1.72600524466566],
            [32.988511986814586, 1.730073991478076],
            [32.97837284233989, 1.719871233921634],
            [32.961623011859075, 1.700655808423264],
            [32.957224062524055, 1.694848661853151],
            [32.9563340324018, 1.694343407198897],
            [32.95482780201208, 1.694573024831675],
            [32.95211194966811, 1.697994775178949],
            [32.95044840091597, 1.698247638647889],
            [32.949108401074646, 1.698199444548785],
            [32.94654806597098, 1.697308445677606],
            [32.94244199077475, 1.694924492287142],
            [32.93354063313344, 1.692997873417596],
            [32.93100426777652, 1.69138448263484],
            [32.928467869181915, 1.690686094362717],
            [32.92658230180727, 1.690782340163726],
            [32.924667997326715, 1.691408323412072],
            [32.91940361913182, 1.693984576671913],
            [32.914187197498336, 1.694032509580494],
            [32.909430355760875, 1.690781610151356],
            [32.906602496077404, 1.686865608022204],
            [32.905854839944524, 1.684608152543762],
            [32.90432201582913, 1.682764519819651],
            [32.897638764812626, 1.680449210520418],
            [32.894609988831036, 1.677342406240355],
            [32.89327029262026, 1.676873405479785],
            [32.892163560105395, 1.676990576438085],
            [32.88814428103026, 1.67898328889433],
            [32.879719870414306, 1.680349076176126],
            [32.87727410913694, 1.677475609716278],
            [32.87361243949493, 1.6730887842462],
            [32.87453296652278, 1.671912040897098],
            [32.875017844773794, 1.672013703954538],
            [32.881075139818826, 1.667626232331432],
            [32.88730930775344, 1.663254188256425],
            [32.88969782927926, 1.659963219282218],
            [32.8911215305455, 1.656673841366919],
            [32.896394172342696, 1.649936042592501],
            [32.90298471452692, 1.645851081800681],
            [32.90530455176439, 1.645002302100684],
            [32.90989144752147, 1.644418901717836],
            [32.91374026588155, 1.642880454984058],
            [32.91658731178289, 1.642243907233848],
            [32.92328310238241, 1.641660563513792],
            [32.929873411004664, 1.642032197523844],
            [32.93287857746401, 1.642668972521864],
            [32.935138114389716, 1.64384582933457],
            [32.9359815075757, 1.644605828784161],
            [32.93690072306321, 1.646505787529924],
            [32.937124234685655, 1.650513740322163],
            [32.93779281212408, 1.653426986284427],
            [32.93881374025796, 1.655299805334693],
            [32.93997237293837, 1.655987434518119],
            [32.9409876425843, 1.659226392524333],
            [32.94295486412331, 1.659968327653184],
            [32.94471046503925, 1.662899697140399],
            [32.94576977189703, 1.663625085509151],
            [32.94683799722891, 1.665746104091928],
            [32.953293902613304, 1.661869995735516],
            [32.96221368919267, 1.65185475964784],
            [32.99645137724569, 1.671641694845864],
            [32.99386823301865, 1.682334036985826],
            [32.99405308474454, 1.688413812287724],
            [32.99908504002936, 1.709946355338534],
            [32.99993860483927, 1.712280551980268],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 669,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "AGIKDAK",
        Population: 10868,
        Key: "AMOLATARAGIKDAK",
        Dist2: "Amolatar",
        "Sub Country": "Agikdak",
        id2_original: "Amolatar Agikdak",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.89923633410381, 1.805746175739741],
            [32.893566752833706, 1.805952928963173],
            [32.887654974983185, 1.806830154028691],
            [32.87774648194089, 1.809371787644548],
            [32.87146200924869, 1.811723634826347],
            [32.86843370757753, 1.799192975004777],
            [32.864830412259344, 1.788833608848067],
            [32.86258309331979, 1.778845277222097],
            [32.860502095658475, 1.773036786183716],
            [32.854948203023895, 1.761609682112964],
            [32.85473419198388, 1.760505901126835],
            [32.85555970869569, 1.752871046126376],
            [32.85844451438166, 1.747036486186421],
            [32.857880045396485, 1.740274080368684],
            [32.856869219716266, 1.737850324507237],
            [32.85452614485904, 1.734132715241583],
            [32.851383210072775, 1.731106532570393],
            [32.851020438920024, 1.729176166289246],
            [32.85095573596506, 1.727832749067151],
            [32.85161686008156, 1.726698075517149],
            [32.85108555959162, 1.725152459319094],
            [32.85150046537018, 1.723372144641509],
            [32.85287444488545, 1.722524469015237],
            [32.85279670827403, 1.72210057134965],
            [32.853775352707494, 1.721376769912832],
            [32.85361344036068, 1.72000073866561],
            [32.85412543425854, 1.719759486250054],
            [32.85413200273992, 1.718605196611593],
            [32.85568092376686, 1.718214029639021],
            [32.855739417566596, 1.715970666769854],
            [32.85628380651023, 1.715853323079513],
            [32.85640051653026, 1.71508380383822],
            [32.85734674974828, 1.714386084120406],
            [32.85721722615902, 1.713173091025341],
            [32.85634242966737, 1.711862220009557],
            [32.85694516418871, 1.711457938514512],
            [32.85796956341284, 1.708795103717821],
            [32.857611053867785, 1.707606387643304],
            [32.85814043465797, 1.706874054108877],
            [32.85777803720438, 1.706304050220355],
            [32.85820891862199, 1.704006079106609],
            [32.857991942243196, 1.701192366487878],
            [32.85853674531018, 1.700884800354314],
            [32.85884450273665, 1.699428215463242],
            [32.86043885785573, 1.696732249589373],
            [32.86058873816762, 1.694958997643314],
            [32.86099081869889, 1.694533806273748],
            [32.86110016163529, 1.69222698828168],
            [32.86002088163549, 1.684316468110792],
            [32.85931956599488, 1.682303157239126],
            [32.85897547171518, 1.681315343605514],
            [32.85689435727287, 1.679458514493433],
            [32.85573132464418, 1.67667833364254],
            [32.85567332132463, 1.674512781368398],
            [32.86181488013997, 1.674241004372316],
            [32.87100237096219, 1.676056577612157],
            [32.87361243949493, 1.6730887842462],
            [32.87727410913694, 1.677475609716278],
            [32.87227730403086, 1.680732832130975],
            [32.87296452600301, 1.682462037526497],
            [32.87401657088001, 1.689227448244743],
            [32.87378018909445, 1.69091336435705],
            [32.87249135549507, 1.692080463322447],
            [32.87848375444739, 1.697333178017622],
            [32.88181300431511, 1.698197965673317],
            [32.885077658127386, 1.701764560118083],
            [32.88600118013839, 1.70336409005312],
            [32.88634416589701, 1.709295352298044],
            [32.88796973567559, 1.710614693304243],
            [32.888179450971954, 1.711406252756344],
            [32.885242640017545, 1.714044569995211],
            [32.88938507542319, 1.720113343827577],
            [32.890013991343494, 1.726551298182995],
            [32.89069556291247, 1.72929536782481],
            [32.89048526910109, 1.738530073087609],
            [32.891271702809846, 1.741696305545294],
            [32.89058982940691, 1.744070908157234],
            [32.88744330135952, 1.745073345830617],
            [32.8822515780065, 1.745811803580346],
            [32.880457045004455, 1.748526299938887],
            [32.88165108837505, 1.749401054344509],
            [32.88766878029248, 1.748536377934872],
            [32.889817897201794, 1.749209322884616],
            [32.89028212857432, 1.753285473972995],
            [32.89164226594938, 1.756570783492359],
            [32.89218614375162, 1.760990230790699],
            [32.89210832988508, 1.762398180847802],
            [32.891136513546115, 1.764940264705407],
            [32.891175310884925, 1.766152674108899],
            [32.892341119307815, 1.769516190236259],
            [32.892613055514, 1.771784578899691],
            [32.89377904000668, 1.772175745503573],
            [32.89510043933174, 1.773505556722711],
            [32.89603318434575, 1.774600686945023],
            [32.89622744233101, 1.775969542693106],
            [32.89510020936305, 1.777572982842949],
            [32.89237946120076, 1.778589680619762],
            [32.89253486794829, 1.779645657480024],
            [32.89486673542406, 1.782383482588977],
            [32.89669326911148, 1.786294572930309],
            [32.89793671263619, 1.791848244448389],
            [32.89824728628103, 1.798457830142774],
            [32.89923633410381, 1.805746175739741],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 670,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "AKWON",
        Population: 7738,
        Key: "AMOLATARAKWON",
        Dist2: "Amolatar",
        "Sub Country": "Akwon",
        id2_original: "Amolatar Akwon",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.85931956599488, 1.682303157239126],
            [32.85372428887348, 1.682794392083991],
            [32.84942033817638, 1.682384364057837],
            [32.84785001119453, 1.681828222363139],
            [32.846861411631096, 1.679867446762564],
            [32.84592962961104, 1.675593625905844],
            [32.84192208163524, 1.671208522051338],
            [32.837550561459096, 1.667710232335614],
            [32.835786193884275, 1.665806807236192],
            [32.83461183978806, 1.665390535002949],
            [32.829669912762725, 1.661481700611888],
            [32.82160503936451, 1.65639643362308],
            [32.81005418523432, 1.648099034766241],
            [32.806042106156184, 1.646269322840261],
            [32.80414788800539, 1.634832927132043],
            [32.79177895790888, 1.590495510905447],
            [32.79166038568127, 1.586904871107484],
            [32.79249311676313, 1.584870265932743],
            [32.7946340077994, 1.583793293248154],
            [32.80759782203997, 1.581879544095718],
            [32.8134254789523, 1.582239143611086],
            [32.81627971047759, 1.583915028628708],
            [32.818063521188414, 1.585949878990449],
            [32.82032284880666, 1.590498214690659],
            [32.82127392035079, 1.595046433507325],
            [32.821793943390674, 1.600480839466664],
            [32.82411415971719, 1.603180628227452],
            [32.82680299972058, 1.60767376221523],
            [32.83119264340757, 1.611783998956445],
            [32.836674748972825, 1.619058704537446],
            [32.837651670437566, 1.619886719176219],
            [32.84058250849367, 1.621491080871207],
            [32.847623233297675, 1.624045782618758],
            [32.85182171728885, 1.62612889935375],
            [32.858470047196995, 1.629839584668406],
            [32.864426238653444, 1.633995657171958],
            [32.87035765547267, 1.64128692701342],
            [32.87233870837212, 1.642068421579333],
            [32.874406137879376, 1.647510745984893],
            [32.87774669753653, 1.658784755723388],
            [32.881075139818826, 1.667626232331432],
            [32.875017844773794, 1.672013703954538],
            [32.87453296652278, 1.671912040897098],
            [32.87361243949493, 1.6730887842462],
            [32.87100237096219, 1.676056577612157],
            [32.86181488013997, 1.674241004372316],
            [32.85567332132463, 1.674512781368398],
            [32.85573132464418, 1.67667833364254],
            [32.85689435727287, 1.679458514493433],
            [32.85897547171518, 1.681315343605514],
            [32.85931956599488, 1.682303157239126],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 671,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "AMOLATAR TOWN COUNCIL",
        Population: 11202,
        Key: "AMOLATARAMOLATAR TOWN COUNCIL",
        Dist2: "Amolatar",
        "Sub Country": "Amolatar T/C",
        id2_original: "Amolatar Amolatar T/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.806042106156184, 1.646269322840261],
            [32.80551318530341, 1.645963737937641],
            [32.80381835451815, 1.646978692580519],
            [32.79614175095203, 1.649758850625469],
            [32.79061478531811, 1.649861269094688],
            [32.7848554093505, 1.648752673],
            [32.781710483897605, 1.647697358480994],
            [32.779781227857455, 1.645971246550646],
            [32.77638866472851, 1.64388585795256],
            [32.766772522107196, 1.643951645035659],
            [32.751834438145885, 1.643398532955323],
            [32.74807133253862, 1.64236523504137],
            [32.74332849373982, 1.638812855042265],
            [32.738151282670174, 1.633154616369172],
            [32.73557687994916, 1.629760863023209],
            [32.71460372885619, 1.616436193502605],
            [32.714008895017756, 1.614480488935708],
            [32.717050059665446, 1.610158374866943],
            [32.72081809432868, 1.602371005182626],
            [32.73034895449018, 1.578035981119642],
            [32.73150224668621, 1.576372844403771],
            [32.73542995868781, 1.56832134605197],
            [32.749380704320345, 1.555168437300269],
            [32.74936927774993, 1.554399423079461],
            [32.75222696599242, 1.552047488431307],
            [32.820144686834695, 1.474980857749987],
            [32.8202649218439, 1.475008011109088],
            [32.83613046782702, 1.477397721834605],
            [32.85034030914706, 1.479045333942632],
            [32.865291575885145, 1.480331014088518],
            [32.867252197501784, 1.480086857138051],
            [32.86820424731125, 1.4804397583716],
            [32.87786875971903, 1.480658618191183],
            [32.87738598711905, 1.501859244143147],
            [32.87757907459947, 1.508576379524751],
            [32.876901074732054, 1.524054932346071],
            [32.8774805114465, 1.540896450203034],
            [32.878737029950166, 1.558711500901377],
            [32.87894626195288, 1.575186134670572],
            [32.87975485889632, 1.577675694823971],
            [32.88341498433432, 1.582615420211531],
            [32.88309665373698, 1.58339343072179],
            [32.878576058139444, 1.587961395389287],
            [32.87078600094624, 1.598587429454421],
            [32.866950256666776, 1.601970508707089],
            [32.86732903579791, 1.602566190221483],
            [32.86719511585368, 1.603409953763568],
            [32.864610951140484, 1.603296716066942],
            [32.86325659981416, 1.603978072773813],
            [32.8655777449987, 1.611960887164959],
            [32.86789903840527, 1.617899359556954],
            [32.86809238010893, 1.619943712460792],
            [32.85182171728885, 1.62612889935375],
            [32.847623233297675, 1.624045782618758],
            [32.84058250849367, 1.621491080871207],
            [32.837651670437566, 1.619886719176219],
            [32.836674748972825, 1.619058704537446],
            [32.83119264340757, 1.611783998956445],
            [32.82680299972058, 1.60767376221523],
            [32.82411415971719, 1.603180628227452],
            [32.821793943390674, 1.600480839466664],
            [32.82127392035079, 1.595046433507325],
            [32.82032284880666, 1.590498214690659],
            [32.818063521188414, 1.585949878990449],
            [32.81627971047759, 1.583915028628708],
            [32.8134254789523, 1.582239143611086],
            [32.80759782203997, 1.581879544095718],
            [32.7946340077994, 1.583793293248154],
            [32.79249311676313, 1.584870265932743],
            [32.79166038568127, 1.586904871107484],
            [32.79177895790888, 1.590495510905447],
            [32.80414788800539, 1.634832927132043],
            [32.806042106156184, 1.646269322840261],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 672,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "AGWINGIRI",
        Population: 15859,
        Key: "AMOLATARAGWINGIRI",
        Dist2: "Amolatar",
        "Sub Country": "Agwingiri",
        id2_original: "Amolatar Agwingiri",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19683115747144, 1.997857110594955],
            [33.194426936987746, 2.000036464594893],
            [33.19340539440622, 1.999930394195928],
            [33.19271736484865, 1.999093403891802],
            [33.19050715261853, 1.997819327976605],
            [33.18902684760792, 1.998099963437167],
            [33.18599728470214, 1.997729376882175],
            [33.18562272944947, 2.000218166550706],
            [33.18597743912086, 2.001239208478977],
            [33.18557398686215, 2.001706737831199],
            [33.18559872377013, 2.004204080762359],
            [33.18523194613119, 2.004610095273342],
            [33.18553770031457, 2.0052128684052],
            [33.184938841125344, 2.007747188469882],
            [33.18234791838628, 2.012800394168405],
            [33.179528762479556, 2.014667831200022],
            [33.17517482413016, 2.014847839252038],
            [33.172176956482545, 2.014273661544752],
            [33.167532070880604, 2.016585774009415],
            [33.16621387315123, 2.016748759443858],
            [33.164502376820785, 2.018051733800363],
            [33.16170418220293, 2.019029115603596],
            [33.160015879474805, 2.019056426287113],
            [33.15935659151474, 2.018667461099079],
            [33.156696885672645, 2.019183412296027],
            [33.15503199214252, 2.020115436940517],
            [33.15475447739843, 2.021418263161344],
            [33.154083776342695, 2.022160199299052],
            [33.152303006429115, 2.022069896727648],
            [33.15128535445105, 2.02085766454673],
            [33.14946971732805, 2.020523086793607],
            [33.1477118607424, 2.018985220643239],
            [33.146162408811136, 2.0193834398385],
            [33.14528334172859, 2.018614505059307],
            [33.14116692961843, 2.019772915678988],
            [33.14054263463193, 2.021057675723446],
            [33.1382991434138, 2.022170678803203],
            [33.1366458174896, 2.023835509625841],
            [33.1318584294392, 2.026215329627554],
            [33.13055791055461, 2.026233529786519],
            [33.13581378799197, 2.013234233536545],
            [33.13736167415973, 2.006592517470182],
            [33.14123050967927, 2.001302198530203],
            [33.14197069362562, 1.999487709178481],
            [33.14150985788486, 1.999069491826282],
            [33.1408939684345, 1.996888507090791],
            [33.13938264639376, 1.995372133771697],
            [33.13917114704327, 1.994312568427268],
            [33.138098137284146, 1.992640651933622],
            [33.13582351494987, 1.991161503546636],
            [33.13214606909484, 1.99056224273347],
            [33.13209066460139, 1.989727101565303],
            [33.135189308850855, 1.986627531497216],
            [33.1368678145525, 1.985903600311731],
            [33.13799287359749, 1.984307451233819],
            [33.13856450485043, 1.982061789907779],
            [33.140353483569086, 1.979017998876507],
            [33.14005819745372, 1.977162145813594],
            [33.14064828818744, 1.975139188395255],
            [33.14038936317983, 1.972432566873014],
            [33.1433782512679, 1.971590534155893],
            [33.147106926246934, 1.972460202430179],
            [33.14899761132374, 1.971541368837934],
            [33.151065952621025, 1.969459959700704],
            [33.1525122267537, 1.968589941519002],
            [33.15477403192555, 1.968028115584688],
            [33.15590404517929, 1.967160274684291],
            [33.15688520848882, 1.964646746162528],
            [33.15780700483614, 1.963360017260245],
            [33.161107897585325, 1.961654153804225],
            [33.163664961923025, 1.956417578558534],
            [33.1671743096322, 1.958245742602717],
            [33.169085036122986, 1.960482731988414],
            [33.17088044138919, 1.959131841103776],
            [33.1735315746085, 1.959085869756567],
            [33.1751258722354, 1.958169021002076],
            [33.1849930158252, 1.958809537986328],
            [33.18767808739593, 1.960193711090274],
            [33.19200351950642, 1.963567282362075],
            [33.19296456863841, 1.964937460415136],
            [33.1943071170002, 1.965680191414471],
            [33.19543142056203, 1.965595639659097],
            [33.19976057349444, 1.963130087473707],
            [33.20157286888459, 1.962910378075994],
            [33.204912337987, 1.96370350818962],
            [33.205969496972905, 1.963467003949817],
            [33.20803363325634, 1.964294053106038],
            [33.21182841615545, 1.963440857673721],
            [33.217981654866115, 1.966239365180828],
            [33.220355367664446, 1.965977642477176],
            [33.22142963147169, 1.96281683932045],
            [33.22264589646748, 1.961842337515867],
            [33.222999879401826, 1.95952526528717],
            [33.22418046960272, 1.956720911802084],
            [33.222059486131464, 1.950385623498273],
            [33.22228362567631, 1.946372398454714],
            [33.22196139100076, 1.944882250487653],
            [33.22582554539939, 1.945839375390755],
            [33.229354782707226, 1.945276169101446],
            [33.2303572064446, 1.943743431303759],
            [33.23008651081181, 1.938156265484136],
            [33.23064507067908, 1.933732986280764],
            [33.22960312556081, 1.928107124318554],
            [33.23109431815265, 1.92179417683138],
            [33.23244880422627, 1.922070860306788],
            [33.23710474269943, 1.921364544161738],
            [33.23924036331992, 1.921988492534348],
            [33.24213315952034, 1.923860852523924],
            [33.24356114485218, 1.927642369237328],
            [33.24482985888413, 1.933767127062261],
            [33.24727141694431, 1.935702863448026],
            [33.25155704829781, 1.941337394508495],
            [33.25194761242715, 1.943496877888015],
            [33.25147390742164, 1.944590744495337],
            [33.25008673434981, 1.945603419881952],
            [33.24938807862073, 1.946680850952327],
            [33.248482201318545, 1.949056313778739],
            [33.24875060355238, 1.951309017833453],
            [33.24963614299654, 1.952378924434092],
            [33.25469095860869, 1.953656812222667],
            [33.25764090472919, 1.953880491078763],
            [33.2590991569979, 1.955007713802859],
            [33.26001039634402, 1.95460685214332],
            [33.26024674579022, 1.955163748318531],
            [33.26201237909125, 1.954033387015171],
            [33.26327610118517, 1.954278555389403],
            [33.26430324296587, 1.953876882848687],
            [33.265825687048135, 1.954590436903133],
            [33.267081998040965, 1.954709202293412],
            [33.27064434365697, 1.957102819684994],
            [33.27144402212626, 1.957129754320843],
            [33.2712950913336, 1.959779449361857],
            [33.27208615226437, 1.961838918736351],
            [33.27077249102718, 1.966546729499184],
            [33.272383329333394, 1.971549468640813],
            [33.27480763075697, 1.973809420730125],
            [33.27462661124406, 1.979875881707769],
            [33.26908064983515, 1.982842693036689],
            [33.26683390132582, 1.984672031989527],
            [33.26299649246814, 1.986196795887124],
            [33.26151545173733, 1.987593068849978],
            [33.26122690657986, 1.988876645743321],
            [33.25830079905207, 1.988661575857862],
            [33.2563064133572, 1.989881204407067],
            [33.25400895764501, 1.990491221689121],
            [33.25140832142276, 1.989754952299604],
            [33.25044893956392, 1.989983721168688],
            [33.24810104973675, 1.991025578033661],
            [33.24618267498965, 1.994124964767899],
            [33.243986237526094, 1.994988978708386],
            [33.239365934321924, 1.995421503073173],
            [33.23580588030821, 1.994736154762544],
            [33.23220479304899, 1.995111478630765],
            [33.231439562275895, 1.994490621576721],
            [33.2281250555586, 1.993851833100053],
            [33.227248750795596, 1.992847719458405],
            [33.22596517862882, 1.993273113385198],
            [33.22508728384775, 1.992992773365564],
            [33.22241287348277, 1.994377358775239],
            [33.221582722362406, 1.993897969572342],
            [33.2190187984892, 1.993581662237512],
            [33.21548543701585, 1.991356524044549],
            [33.213086264165746, 1.991655398858312],
            [33.210001015593804, 1.990814404763584],
            [33.206261385659886, 1.990597750561182],
            [33.20355205238992, 1.991493762971713],
            [33.200766560848486, 1.994660623496842],
            [33.19998230196107, 1.994895947207304],
            [33.19955275723661, 1.995800719517208],
            [33.198364167538095, 1.996298461279316],
            [33.19683115747144, 1.997857110594955],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 673,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "DOKOLO",
        Population: 15847,
        Key: "DOKOLODOKOLO",
        Dist2: "Dokolo",
        "Sub Country": "Dokolo S/C",
        id2_original: "Dokolo Dokolo S/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.13055791055461, 2.026233529786519],
            [33.128620646932, 2.026604622481427],
            [33.12741796805658, 2.02723802418952],
            [33.127013372242494, 2.028016118241147],
            [33.12507081664456, 2.029011466137492],
            [33.123868092853385, 2.029111078010331],
            [33.121555439443235, 2.030088356189057],
            [33.11942762248762, 2.030160893608244],
            [33.11646725950308, 2.031554385465793],
            [33.11568097401636, 2.03139159184297],
            [33.11337987024582, 2.032893596367114],
            [33.10873119105843, 2.034585751713492],
            [33.10448933101548, 2.035029348269664],
            [33.10274562379387, 2.034703760810849],
            [33.09899034700435, 2.033066447329704],
            [33.097523941626115, 2.031727546295684],
            [33.09577011039126, 2.026416921985059],
            [33.09300555588418, 2.022155834410068],
            [33.09094463826441, 2.017397102802343],
            [33.087942335634224, 2.012357955029625],
            [33.08865579649749, 2.011941742975495],
            [33.08982469512496, 2.010123183297559],
            [33.091875240796476, 2.00553611681293],
            [33.09279584597774, 1.995945986833362],
            [33.09466524906715, 1.993629785485801],
            [33.09797308040354, 1.990734473331981],
            [33.10004725086872, 1.987214970042449],
            [33.1004537870438, 1.985948331987423],
            [33.10032227907611, 1.981307104228575],
            [33.09885530686094, 1.9790906184611],
            [33.09473028619541, 1.976096223276781],
            [33.092267412011864, 1.973137913556046],
            [33.091357699801705, 1.971192806147002],
            [33.090581676668805, 1.967944887284053],
            [33.08989541230077, 1.966850208142946],
            [33.08157138841782, 1.957043420017584],
            [33.07995841571447, 1.956346860407195],
            [33.077084910834785, 1.956346995973726],
            [33.07597043484214, 1.955668503241284],
            [33.069525664075705, 1.954664539806525],
            [33.066511902535744, 1.953678511882204],
            [33.06546936003784, 1.952773827969263],
            [33.073416574795054, 1.946096624819476],
            [33.07964150535361, 1.939645649968281],
            [33.09262833892333, 1.927416177539731],
            [33.10042128420018, 1.928034522281562],
            [33.10241975902624, 1.928608903912308],
            [33.11101497980188, 1.928516833861305],
            [33.11391911543616, 1.927837088286829],
            [33.11648552045618, 1.926681674251011],
            [33.1278539932275, 1.917942570238467],
            [33.12990808993931, 1.917836426407479],
            [33.13254161977234, 1.918631136265364],
            [33.14886983046615, 1.926737895849628],
            [33.152135657478205, 1.930235222007136],
            [33.15392664662643, 1.932672791989096],
            [33.15565950579266, 1.936021435228905],
            [33.160726805292335, 1.949003726299913],
            [33.16158294197891, 1.953485438770017],
            [33.163664961923025, 1.956417578558534],
            [33.161107897585325, 1.961654153804225],
            [33.15780700483614, 1.963360017260245],
            [33.15688520848882, 1.964646746162528],
            [33.15590404517929, 1.967160274684291],
            [33.15477403192555, 1.968028115584688],
            [33.1525122267537, 1.968589941519002],
            [33.151065952621025, 1.969459959700704],
            [33.14899761132374, 1.971541368837934],
            [33.147106926246934, 1.972460202430179],
            [33.1433782512679, 1.971590534155893],
            [33.14038936317983, 1.972432566873014],
            [33.14064828818744, 1.975139188395255],
            [33.14005819745372, 1.977162145813594],
            [33.140353483569086, 1.979017998876507],
            [33.13856450485043, 1.982061789907779],
            [33.13799287359749, 1.984307451233819],
            [33.1368678145525, 1.985903600311731],
            [33.135189308850855, 1.986627531497216],
            [33.13209066460139, 1.989727101565303],
            [33.13214606909484, 1.99056224273347],
            [33.13582351494987, 1.991161503546636],
            [33.138098137284146, 1.992640651933622],
            [33.13917114704327, 1.994312568427268],
            [33.13938264639376, 1.995372133771697],
            [33.1408939684345, 1.996888507090791],
            [33.14150985788486, 1.999069491826282],
            [33.14197069362562, 1.999487709178481],
            [33.14123050967927, 2.001302198530203],
            [33.13736167415973, 2.006592517470182],
            [33.13581378799197, 2.013234233536545],
            [33.13055791055461, 2.026233529786519],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 674,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "AMWOMA",
        Population: 14587,
        Key: "DOKOLOAMWOMA",
        Dist2: "Dokolo",
        "Sub Country": "Amwoma",
        id2_original: "Dokolo Amwoma",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11840705367985, 1.858001022236685],
            [33.118448355521664, 1.866342582552535],
            [33.120850510778524, 1.874783499854616],
            [33.12206954528034, 1.876448108330058],
            [33.12211485270998, 1.877443301793238],
            [33.123821106472434, 1.878908834981472],
            [33.12587847754346, 1.88262710476125],
            [33.12661356983877, 1.883034176525326],
            [33.126498615126835, 1.886481184709303],
            [33.12509324398396, 1.888326925003871],
            [33.12129154675209, 1.889394771919098],
            [33.11692163456032, 1.889711727232305],
            [33.11387201676581, 1.888979104050631],
            [33.112849532749856, 1.889494864352746],
            [33.11211088851589, 1.890662007442132],
            [33.11184246112924, 1.89373808941717],
            [33.11278263251568, 1.897791194665561],
            [33.112480167962914, 1.90027920820559],
            [33.10976571519415, 1.903391637468666],
            [33.10600844773793, 1.905735111232519],
            [33.10329425637892, 1.908829436938227],
            [33.09991139595335, 1.91852828924178],
            [33.09711152687581, 1.92259971422809],
            [33.09280217281226, 1.927277383746569],
            [33.09201452188631, 1.916402631571754],
            [33.09059538136677, 1.914014233171401],
            [33.08981334041978, 1.91329954158102],
            [33.087701916819775, 1.912413021390882],
            [33.087275902474396, 1.911815924080225],
            [33.088365669406784, 1.9078803132329],
            [33.088937170404044, 1.907165550856038],
            [33.08906097621648, 1.904994203481463],
            [33.0899187783796, 1.903763731595792],
            [33.088358013963955, 1.901013448071187],
            [33.08823257860759, 1.89878783038279],
            [33.09254682130286, 1.89193883171505],
            [33.09426653631986, 1.882638162440364],
            [33.092748887444564, 1.876667055806814],
            [33.091780488296926, 1.874423388305522],
            [33.09111184977307, 1.868724255333799],
            [33.08900551872243, 1.868275314066035],
            [33.088775227514496, 1.867696103569379],
            [33.087842654078706, 1.86741812390738],
            [33.087508738609515, 1.866688322262773],
            [33.088064276544145, 1.863268328824204],
            [33.09039761007045, 1.857535408878382],
            [33.08756526150548, 1.854338693519163],
            [33.086714360200396, 1.852628803730308],
            [33.08073776710551, 1.844567979491455],
            [33.06757593632854, 1.842397188347183],
            [33.05903761035143, 1.838154326944718],
            [33.057518066030894, 1.838172471656521],
            [33.052942349807495, 1.840099681599565],
            [33.05073384257981, 1.840289738911765],
            [33.04650954190572, 1.839249419095314],
            [33.04324956202784, 1.837471200722837],
            [33.036518267313326, 1.831921365569154],
            [33.0304263386208, 1.825140380297323],
            [33.0363528748931, 1.818866562274893],
            [33.03825419602287, 1.815768923495658],
            [33.039657541464784, 1.813217928729641],
            [33.04103113470447, 1.807744043118738],
            [33.045246904078326, 1.798872193893838],
            [33.047002513079114, 1.797378442185829],
            [33.049185813579946, 1.797277461065496],
            [33.05150168295881, 1.793211682153181],
            [33.05221105918247, 1.790594110540363],
            [33.057592925338454, 1.78609447704988],
            [33.062112768147784, 1.783652693020939],
            [33.06518152454942, 1.782766893749743],
            [33.06549072556854, 1.781163063047632],
            [33.06501955201551, 1.778376178514761],
            [33.0655367264976, 1.77798887052725],
            [33.06666802344393, 1.773969766786367],
            [33.066810600452555, 1.769589176767713],
            [33.066239445306714, 1.763341479063696],
            [33.065146510914595, 1.761318431480092],
            [33.06514644803253, 1.759520563980693],
            [33.06525985045568, 1.758436132233958],
            [33.06653597109717, 1.756124544012095],
            [33.069428604702516, 1.753670205661908],
            [33.074249737966554, 1.752014840266174],
            [33.07915587880595, 1.748875505520856],
            [33.08399120185823, 1.747478842628954],
            [33.08456202642404, 1.749073923651963],
            [33.08851739934986, 1.753325955556348],
            [33.08974729268682, 1.755361532033422],
            [33.091342503900364, 1.758546091707573],
            [33.09197706393561, 1.761287381515849],
            [33.0935366075408, 1.764598602600616],
            [33.094861756433836, 1.766507507950335],
            [33.09833274069048, 1.769673868148985],
            [33.10062953703926, 1.772396970140126],
            [33.10397813482157, 1.777255163661023],
            [33.10409957357326, 1.778313685884386],
            [33.102196357896574, 1.784945435996659],
            [33.10146670130703, 1.790572873064081],
            [33.10344322040924, 1.79828102731172],
            [33.104858711073774, 1.802189361351305],
            [33.115199325208806, 1.822698858789224],
            [33.11464572044866, 1.825883527720867],
            [33.112453175385234, 1.82928543392505],
            [33.11202279522756, 1.830570171448199],
            [33.1133082287036, 1.834306605961345],
            [33.11367634842557, 1.83930971347971],
            [33.11208383125955, 1.845100055977253],
            [33.1118376461593, 1.848863729484092],
            [33.113903743464995, 1.853812443227133],
            [33.11710100386806, 1.857403991559601],
            [33.11840705367985, 1.858001022236685],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 675,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "KANGAI",
        Population: 17263,
        Key: "DOKOLOKANGAI",
        Dist2: "Dokolo",
        "Sub Country": "Kangai",
        id2_original: "Dokolo Kangai",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.09262833892333, 1.927416177539731],
            [33.07964150535361, 1.939645649968281],
            [33.073416574795054, 1.946096624819476],
            [33.06546936003784, 1.952773827969263],
            [33.06354473840621, 1.951244916211805],
            [33.059820595427794, 1.949517028288499],
            [33.05901383733575, 1.949209449865175],
            [33.0566745246229, 1.949281909142274],
            [33.055963300564706, 1.948802428842345],
            [33.05263908036423, 1.94864873339211],
            [33.05130661918478, 1.949788728964824],
            [33.05061844679506, 1.949625899435567],
            [33.04900188262721, 1.950376869100518],
            [33.04691348015299, 1.949752669020862],
            [33.0412260619346, 1.94977091311709],
            [33.039494249305704, 1.949101457633013],
            [33.0380962533313, 1.947862016302757],
            [33.03750389435147, 1.947255862796907],
            [33.03729367510028, 1.9457811649069],
            [33.03674769344364, 1.945708798850194],
            [33.032186171500065, 1.941655721027467],
            [33.02732179513486, 1.940072536134654],
            [33.02359184364981, 1.940778278889973],
            [33.02224023667669, 1.939982138410168],
            [33.0211047041738, 1.938172701533746],
            [33.01838622785091, 1.928021706090542],
            [33.01604013195935, 1.921046291052891],
            [33.01305706764929, 1.917300750331768],
            [33.01000900483852, 1.914580148643912],
            [33.0185435030942, 1.911068191959149],
            [33.030149046658885, 1.904760232782793],
            [33.03109872581435, 1.903871066805072],
            [33.035405244794816, 1.903087632120471],
            [33.03792432746401, 1.900948174696506],
            [33.03952103347419, 1.900229664632145],
            [33.04108795494281, 1.898144056849041],
            [33.046106148935785, 1.895529483008787],
            [33.04758385332368, 1.89538973943369],
            [33.052138798701016, 1.893594403349192],
            [33.05514733743593, 1.893132399740783],
            [33.05944287271546, 1.891499078482827],
            [33.05807343148899, 1.891548572027941],
            [33.053216523717076, 1.888935941011434],
            [33.053159405238034, 1.888213027507158],
            [33.052236321604916, 1.887724728682621],
            [33.05058136074686, 1.885414090180996],
            [33.05035656094028, 1.883138718971085],
            [33.04947163324883, 1.881790477468544],
            [33.04888773729733, 1.881591503781041],
            [33.049121936176704, 1.880755422770821],
            [33.04833998146798, 1.879271045636087],
            [33.04826857797929, 1.878062197764699],
            [33.04738832332398, 1.877553547609121],
            [33.04684804147782, 1.876335959935015],
            [33.04605602473958, 1.875961733859975],
            [33.04120874600919, 1.875513025189167],
            [33.039442302427744, 1.874818876326318],
            [33.03934712682174, 1.874160593890943],
            [33.038276559581874, 1.873879350725708],
            [33.035451408318956, 1.870917132344586],
            [33.03175796077379, 1.869965684071989],
            [33.030491087389855, 1.867350522974753],
            [33.02875438523085, 1.866063905953528],
            [33.02741618022346, 1.865483440446868],
            [33.025862622092994, 1.865616681572455],
            [33.02393102324658, 1.864356677049196],
            [33.018965594496784, 1.862402196425537],
            [33.02060799151723, 1.859934279162544],
            [33.02474739690543, 1.855194579184012],
            [33.03134906023289, 1.860251263154388],
            [33.03254007448434, 1.858928303464991],
            [33.03250908081042, 1.85578438296224],
            [33.03348348699234, 1.851659913904289],
            [33.03218413142606, 1.849060755850414],
            [33.0319520813168, 1.847302031486098],
            [33.03387009943276, 1.847115228725691],
            [33.03557154541181, 1.845838949175891],
            [33.04041824113559, 1.84518828585277],
            [33.0408545492758, 1.843032853199169],
            [33.04324956202784, 1.837471200722837],
            [33.04650954190572, 1.839249419095314],
            [33.05073384257981, 1.840289738911765],
            [33.052942349807495, 1.840099681599565],
            [33.057518066030894, 1.838172471656521],
            [33.05903761035143, 1.838154326944718],
            [33.06757593632854, 1.842397188347183],
            [33.08073776710551, 1.844567979491455],
            [33.086714360200396, 1.852628803730308],
            [33.08756526150548, 1.854338693519163],
            [33.09039761007045, 1.857535408878382],
            [33.088064276544145, 1.863268328824204],
            [33.087508738609515, 1.866688322262773],
            [33.087842654078706, 1.86741812390738],
            [33.088775227514496, 1.867696103569379],
            [33.08900551872243, 1.868275314066035],
            [33.09111184977307, 1.868724255333799],
            [33.091780488296926, 1.874423388305522],
            [33.092748887444564, 1.876667055806814],
            [33.09426653631986, 1.882638162440364],
            [33.09254682130286, 1.89193883171505],
            [33.08823257860759, 1.89878783038279],
            [33.088358013963955, 1.901013448071187],
            [33.0899187783796, 1.903763731595792],
            [33.08906097621648, 1.904994203481463],
            [33.088937170404044, 1.907165550856038],
            [33.088365669406784, 1.9078803132329],
            [33.087275902474396, 1.911815924080225],
            [33.087701916819775, 1.912413021390882],
            [33.08981334041978, 1.91329954158102],
            [33.09059538136677, 1.914014233171401],
            [33.09201452188631, 1.916402631571754],
            [33.09280217281226, 1.927277383746569],
            [33.09262833892333, 1.927416177539731],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 676,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "OKWONGODUL",
        Population: 13635,
        Key: "DOKOLOOKWONGODUL",
        Dist2: "Dokolo",
        "Sub Country": "Okwongodul",
        id2_original: "Dokolo Okwongodul",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.290506465593054, 2.039359813848006],
            [33.28952417669449, 2.039730000392515],
            [33.288056343893274, 2.041520788303045],
            [33.28739910139713, 2.043327354764084],
            [33.287709011186976, 2.047882238775601],
            [33.28673508650202, 2.050822213941146],
            [33.28235893012073, 2.054724361308225],
            [33.278806731874205, 2.057009042872981],
            [33.26912127075397, 2.061853037179962],
            [33.2656053392921, 2.064591777016318],
            [33.26437294774034, 2.066876451604793],
            [33.26093512030085, 2.069221941388639],
            [33.25831854796545, 2.070392442902072],
            [33.253892478492, 2.07652578372132],
            [33.25305453628317, 2.08126720566843],
            [33.251931778721946, 2.083867118837682],
            [33.25111521282362, 2.084169025142498],
            [33.24125369448414, 2.081435604969173],
            [33.236189893024196, 2.08254013103476],
            [33.23439385444575, 2.084150797814609],
            [33.230959393891936, 2.085273157885154],
            [33.22267348013659, 2.08503643528159],
            [33.22043034914291, 2.080832866726276],
            [33.21870453276853, 2.079535798396914],
            [33.217642286623146, 2.077227495098238],
            [33.217642173435415, 2.076407137637334],
            [33.21910123957776, 2.06852767851908],
            [33.22010581657684, 2.06520794971576],
            [33.222077540472064, 2.062231491134539],
            [33.22209618051421, 2.059903960094338],
            [33.223612866395506, 2.057480827528963],
            [33.222948809279615, 2.054886300613048],
            [33.22567980272769, 2.057442379284625],
            [33.22632455864139, 2.057594910937196],
            [33.22393426563787, 2.050536355578894],
            [33.223763301866235, 2.04838055348188],
            [33.22507101086636, 2.045232989627395],
            [33.22664054373751, 2.043594006282653],
            [33.22603689023964, 2.042050842957226],
            [33.22035736821258, 2.042133268496539],
            [33.219059233456754, 2.042459968553599],
            [33.21689851660218, 2.046566554017414],
            [33.21471624736731, 2.04843534083469],
            [33.21091348024197, 2.042683328286137],
            [33.209329511444196, 2.040009209280502],
            [33.20533665182156, 2.025346365838783],
            [33.200139042706795, 2.019318041801818],
            [33.198885277539475, 2.016314595125341],
            [33.19651805596737, 2.008014714880483],
            [33.19736747595057, 2.003265602860174],
            [33.19683115747144, 1.997857110594955],
            [33.198364167538095, 1.996298461279316],
            [33.19955275723661, 1.995800719517208],
            [33.19998230196107, 1.994895947207304],
            [33.200766560848486, 1.994660623496842],
            [33.20355205238992, 1.991493762971713],
            [33.206261385659886, 1.990597750561182],
            [33.210001015593804, 1.990814404763584],
            [33.213086264165746, 1.991655398858312],
            [33.21548543701585, 1.991356524044549],
            [33.2190187984892, 1.993581662237512],
            [33.221582722362406, 1.993897969572342],
            [33.22241287348277, 1.994377358775239],
            [33.22508728384775, 1.992992773365564],
            [33.22596517862882, 1.993273113385198],
            [33.227248750795596, 1.992847719458405],
            [33.2281250555586, 1.993851833100053],
            [33.231439562275895, 1.994490621576721],
            [33.23220479304899, 1.995111478630765],
            [33.23580588030821, 1.994736154762544],
            [33.239365934321924, 1.995421503073173],
            [33.243986237526094, 1.994988978708386],
            [33.24618267498965, 1.994124964767899],
            [33.24810104973675, 1.991025578033661],
            [33.25044893956392, 1.989983721168688],
            [33.25140832142276, 1.989754952299604],
            [33.25400895764501, 1.990491221689121],
            [33.2563064133572, 1.989881204407067],
            [33.25830079905207, 1.988661575857862],
            [33.26122690657986, 1.988876645743321],
            [33.26151545173733, 1.987593068849978],
            [33.26299649246814, 1.986196795887124],
            [33.26683390132582, 1.984672031989527],
            [33.26908064983515, 1.982842693036689],
            [33.27462661124406, 1.979875881707769],
            [33.27446457492975, 1.985593706052495],
            [33.274807451992245, 1.986829887354796],
            [33.27449624773004, 1.990146843916186],
            [33.27707804717909, 1.995788644505966],
            [33.277945350822975, 1.996684538278422],
            [33.28086700989347, 2.001702691594783],
            [33.28260445406091, 2.003625096264543],
            [33.28251723932492, 2.006917476743967],
            [33.283947518954, 2.010619288576072],
            [33.284088846406064, 2.01469860461699],
            [33.28185495907664, 2.019423143158902],
            [33.28201240769481, 2.021864718192026],
            [33.28488860752038, 2.030918109951813],
            [33.28848996696913, 2.03658695680776],
            [33.28951648531901, 2.037413267958259],
            [33.290506465593054, 2.039359813848006],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 677,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "OKWALONGWEN",
        Population: 14456,
        Key: "DOKOLOOKWALONGWEN",
        Dist2: "Dokolo",
        "Sub Country": "Okwalongwen",
        id2_original: "Dokolo Okwalongwen",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.742707522519865, 2.010890401075708],
            [32.73601596208701, 2.010230685864773],
            [32.73498691857285, 2.013600199396908],
            [32.73509197295204, 2.016280042173066],
            [32.73440567085479, 2.020180270255982],
            [32.73445807317857, 2.022276379676545],
            [32.73333699367029, 2.022741972823831],
            [32.730909331649244, 2.024718551014581],
            [32.72621369572535, 2.033600529377559],
            [32.72428677799984, 2.036236170773777],
            [32.72220586837344, 2.038096496670305],
            [32.72112713634597, 2.037553611006385],
            [32.72158972919142, 2.036158175319261],
            [32.72320825797479, 2.034452828302758],
            [32.72374791998342, 2.03297987551751],
            [32.72374840776861, 2.030111318875948],
            [32.72305507904919, 2.028948270675104],
            [32.72205339732026, 2.028482926193451],
            [32.72058877869115, 2.031428756927822],
            [32.719924781762366, 2.035964890143636],
            [32.71426930134726, 2.03522654235493],
            [32.71311321359406, 2.036389263741073],
            [32.7094904320207, 2.042048191019064],
            [32.70863637044243, 2.041986658691185],
            [32.70792449420733, 2.041348915892212],
            [32.70723879308297, 2.041481454498754],
            [32.70639820892892, 2.040431622033009],
            [32.710176138534976, 2.034885237149995],
            [32.713361764856764, 2.029099838155124],
            [32.71227674013072, 2.027335713184654],
            [32.70685032921477, 2.021664955793189],
            [32.7068512778357, 2.020572999375848],
            [32.70777013848867, 2.017759275595936],
            [32.70981635607714, 2.013307818497979],
            [32.71178000232133, 2.003564547328657],
            [32.70122082448443, 1.993525039784183],
            [32.69971844247738, 1.991550842461178],
            [32.69738117163517, 1.989786482109741],
            [32.69592065561198, 1.987182316168793],
            [32.70318106970695, 1.98462177266979],
            [32.706013557510765, 1.982646496342636],
            [32.71605151036193, 1.978165828175123],
            [32.72642344785258, 1.977082181402125],
            [32.72904365926322, 1.975221926147421],
            [32.73235708351058, 1.97514493778844],
            [32.73651855421711, 1.97235457286782],
            [32.738907384763365, 1.971734722666939],
            [32.740061533053854, 1.971757673601923],
            [32.74086119265854, 1.973199716015051],
            [32.751684338645035, 1.97274974102008],
            [32.75547547618073, 1.968886296765185],
            [32.76016433072256, 1.965223699149382],
            [32.76418045491443, 1.963220618621937],
            [32.76834461338028, 1.960457572336283],
            [32.76879358417274, 1.959805268899702],
            [32.770290260979394, 1.966607837316232],
            [32.76966751738341, 1.967880183885146],
            [32.76228705512882, 1.973767869569595],
            [32.76014208933446, 1.974755110211514],
            [32.753634838045045, 1.975229638090745],
            [32.74967220673174, 1.976289742665503],
            [32.74753245655589, 1.985467512870364],
            [32.74627032178507, 1.987372658831926],
            [32.74198470929618, 1.992053972143016],
            [32.73815954986573, 1.998404168875396],
            [32.73778527398911, 2.000641136392383],
            [32.74085243677947, 2.004233350618901],
            [32.74233854850006, 2.008621460257911],
            [32.742707522519865, 2.010890401075708],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 678,
        District: "APAC",
        County: "KWANIA",
        Subcounty: "ADUKU TOWN COUNCIL",
        Population: 7715,
        Key: "APACADUKU TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.71984914720871, 2.308756237844355],
            [32.71850550559722, 2.30832149016633],
            [32.71832346020827, 2.307578199611895],
            [32.71657267965211, 2.306172792479316],
            [32.71704860798797, 2.305124185253362],
            [32.71496382662268, 2.30365762024712],
            [32.7130711400994, 2.303300883211137],
            [32.71001412108527, 2.304623863125319],
            [32.70869844672352, 2.303900702666137],
            [32.70853669697178, 2.302933420785947],
            [32.707463745603164, 2.303187737559909],
            [32.706674378895016, 2.302576680875867],
            [32.70322277938388, 2.303085039843285],
            [32.70303068903344, 2.302015935663738],
            [32.70057138295818, 2.300763085714192],
            [32.70000480832197, 2.29962263201547],
            [32.69881052959277, 2.29925584273392],
            [32.696715912573424, 2.296577647204675],
            [32.69542048264492, 2.295925750746505],
            [32.694479170398026, 2.295925547890236],
            [32.69255635348184, 2.29456080558619],
            [32.691119119095866, 2.294397589592091],
            [32.688234830839484, 2.292686459013507],
            [32.686605608510966, 2.29105705351515],
            [32.68517860234277, 2.290425482434486],
            [32.68165615270519, 2.291066136301322],
            [32.681028745056274, 2.290475466951659],
            [32.68050276708436, 2.288927753872086],
            [32.677375579765055, 2.287247095651014],
            [32.67513884836946, 2.286666240880946],
            [32.673377600643626, 2.287103643071127],
            [32.67065508908847, 2.286298676342107],
            [32.66856983610763, 2.287245076051902],
            [32.66707189267643, 2.287051278001925],
            [32.66363127956124, 2.284006194644618],
            [32.66244769797044, 2.281287448304936],
            [32.65982690265489, 2.278436001177085],
            [32.659483275499156, 2.27629780011594],
            [32.65453552020422, 2.274262706776005],
            [32.65367679008143, 2.270249655147904],
            [32.65658881022893, 2.268475223218379],
            [32.658279600392085, 2.26434188155745],
            [32.660211006100724, 2.263775241155124],
            [32.66147481443289, 2.262638280362395],
            [32.661788180041675, 2.258687064788333],
            [32.66433337673616, 2.254466963612793],
            [32.67248171440403, 2.246220487723248],
            [32.67464363679774, 2.243318539385528],
            [32.67561831157593, 2.242723545530185],
            [32.67993391252396, 2.243809890351539],
            [32.687137937571926, 2.246857550027746],
            [32.688773762517776, 2.246962939236325],
            [32.693161309536904, 2.236985293611737],
            [32.693439750444035, 2.236985351957718],
            [32.699330134916046, 2.24226154123207],
            [32.71044261478083, 2.250884832605033],
            [32.71548599573776, 2.253130896077205],
            [32.72284949779978, 2.246525456696395],
            [32.72410072971799, 2.244805378469394],
            [32.72758424008295, 2.24668897790429],
            [32.723288833262544, 2.251406793520577],
            [32.721120496897726, 2.254659851358683],
            [32.719169518695665, 2.256424788126073],
            [32.71747543800364, 2.259030040749902],
            [32.716628075162426, 2.261986209656451],
            [32.71682691186069, 2.264090757901458],
            [32.72140911302207, 2.266396590931375],
            [32.72247419425049, 2.266197274247667],
            [32.72536110289256, 2.264201546804638],
            [32.728969518607876, 2.262841126957031],
            [32.73326512665093, 2.261538418028895],
            [32.735008532038584, 2.261488631779052],
            [32.73715032857662, 2.261990098126019],
            [32.73799690449365, 2.263192831238575],
            [32.73809638302989, 2.263994568682799],
            [32.73560481216461, 2.269505931053281],
            [32.73597838915191, 2.273956048946229],
            [32.735484624766116, 2.275643667483712],
            [32.73456331889894, 2.27666935976326],
            [32.73196414693059, 2.278290399748596],
            [32.730582140069934, 2.280044033788093],
            [32.73021993126253, 2.281864042533667],
            [32.73028496659416, 2.285934411288252],
            [32.72886951635379, 2.290533975053361],
            [32.727619013867596, 2.292651643052004],
            [32.728440750468714, 2.296358139738973],
            [32.724557486209065, 2.303406051975964],
            [32.723692137299224, 2.306690850389499],
            [32.7220078787865, 2.306115607165311],
            [32.71984914720871, 2.308756237844355],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 679,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "KOLE TOWN COUNCIL",
        Population: 8860,
        Key: "KOLEKOLE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.899512367525986, 2.43823554388493],
            [32.85542718024184, 2.439416259310317],
            [32.852239899223264, 2.439904924402114],
            [32.850133122608234, 2.439578680993415],
            [32.84626986472828, 2.439709367918621],
            [32.84507932299067, 2.436228850862309],
            [32.84555872780666, 2.434610374033044],
            [32.84528794863058, 2.433543138537493],
            [32.84614600861017, 2.431726717961832],
            [32.84637952926154, 2.429569629752334],
            [32.84510055736736, 2.42710961344759],
            [32.839434417543096, 2.425542200310938],
            [32.838478843642754, 2.424701947176577],
            [32.83622933550887, 2.420856711073448],
            [32.83162434139377, 2.418570357982391],
            [32.82968325364299, 2.415777219103036],
            [32.829743672532366, 2.414013689661767],
            [32.833710681336065, 2.402691220415194],
            [32.83790965221413, 2.401866725380981],
            [32.83931689634435, 2.401049460323595],
            [32.8412034330012, 2.398853392221116],
            [32.83883917047964, 2.396389798435249],
            [32.836587816307855, 2.390482264211445],
            [32.83545455923758, 2.38904920934778],
            [32.8352887706603, 2.384133335085529],
            [32.83253336998598, 2.382762837429603],
            [32.826422626079804, 2.376714186870414],
            [32.82094919285032, 2.376162924220528],
            [32.8147854177997, 2.377191411942585],
            [32.813809735111725, 2.376975842929714],
            [32.81328649700142, 2.374629912947672],
            [32.813073093222556, 2.368860986106994],
            [32.81281143733649, 2.367975268778272],
            [32.812145166771714, 2.367496431221439],
            [32.80338750274494, 2.368356952890542],
            [32.79632426975316, 2.370686857950137],
            [32.794393909683514, 2.371811768598326],
            [32.793911223321786, 2.372738329852945],
            [32.79116914106983, 2.374900060165285],
            [32.78910825129784, 2.375804695961616],
            [32.785110692587956, 2.37218200615306],
            [32.78168305473873, 2.367266430807816],
            [32.777518274638716, 2.363720549919066],
            [32.77359393760765, 2.359288307914409],
            [32.77303348678672, 2.357435091422805],
            [32.773674686270205, 2.355017924324272],
            [32.77367499978223, 2.353325882869572],
            [32.77295435688826, 2.35115025796279],
            [32.7730348558192, 2.348652533775188],
            [32.77319548447346, 2.346235366717992],
            [32.77415737892015, 2.342287329636873],
            [32.77375724324146, 2.33962837144064],
            [32.77050526106458, 2.329753236164154],
            [32.77207308354341, 2.330297842815771],
            [32.77267810337884, 2.331012666607125],
            [32.77330462798387, 2.330840872222608],
            [32.77380148347255, 2.331275215354305],
            [32.7750117459256, 2.33133874099593],
            [32.775552048433035, 2.330750763165315],
            [32.777636850459594, 2.331701046681356],
            [32.781634309456464, 2.330851244565315],
            [32.78208834225557, 2.330136590333197],
            [32.78258517887964, 2.330715685148881],
            [32.783449471370695, 2.330634394730418],
            [32.784659372701014, 2.331222646369068],
            [32.78563163819763, 2.330851862992462],
            [32.7871875948299, 2.331042090810552],
            [32.78760950926433, 2.330815975368539],
            [32.78763068075895, 2.33020981968213],
            [32.789467202813995, 2.329974871094389],
            [32.790072431058576, 2.329359755472193],
            [32.79082850530399, 2.329314632681309],
            [32.790871883152434, 2.328690385756305],
            [32.79162831043574, 2.328147668773585],
            [32.79344313727835, 2.32827459736852],
            [32.7939405299596, 2.326989974049166],
            [32.7958850681394, 2.326121732001995],
            [32.796836054343565, 2.325144775954679],
            [32.79770033785144, 2.325099665594963],
            [32.79863497022588, 2.326035658140678],
            [32.79967979174969, 2.326386153104258],
            [32.80127533893316, 2.32530144060192],
            [32.803679667214695, 2.325290478511217],
            [32.80456739315823, 2.324216965123401],
            [32.80546596805547, 2.325957513453208],
            [32.80661187969316, 2.326522745148257],
            [32.80803889753942, 2.325415398589302],
            [32.80924101766274, 2.325743304429392],
            [32.810072576443126, 2.324579366885105],
            [32.81083641303093, 2.325743520745058],
            [32.811319516210936, 2.325811394490639],
            [32.81194883547478, 2.324692634694889],
            [32.81260032605818, 2.325822868195226],
            [32.81318454091163, 2.325935959980451],
            [32.8134543840432, 2.324421599934195],
            [32.81501595065442, 2.325359828790393],
            [32.81671251249326, 2.3249758019356],
            [32.817476636541926, 2.323947468717442],
            [32.81894850637204, 2.323461695770921],
            [32.820903401228705, 2.32365407158949],
            [32.82154389373808, 2.322953462586157],
            [32.82256633283827, 2.322648452396975],
            [32.82261144443518, 2.321269679679955],
            [32.82315715659726, 2.3206640988299],
            [32.823627720194224, 2.321366682742669],
            [32.82696834183514, 2.321514919551687],
            [32.82781283006745, 2.321048027225798],
            [32.8281058425468, 2.320033555152855],
            [32.828745200483965, 2.320344985389515],
            [32.83037208539614, 2.320219029954602],
            [32.832280889492196, 2.318906910032394],
            [32.83256269009854, 2.317423205602498],
            [32.83300964057993, 2.31694375835988],
            [32.83254636231993, 2.315260927816367],
            [32.832860993654926, 2.314229586019098],
            [32.833523497583705, 2.313922060717799],
            [32.83358151437802, 2.312917830352462],
            [32.83464155785431, 2.311606113864143],
            [32.83479076083648, 2.309534326278708],
            [32.83621511068637, 2.307770291256845],
            [32.83744058251548, 2.307435687052469],
            [32.8380368437769, 2.306304858142969],
            [32.839005655251235, 2.30641353445803],
            [32.839105326925285, 2.304848383248432],
            [32.84034737177308, 2.304568060933303],
            [32.841009703225325, 2.30322915234298],
            [32.841788194030336, 2.303699692949465],
            [32.84248359785809, 2.303184080779908],
            [32.84496748273781, 2.304496197285827],
            [32.84612689066431, 2.304252049530404],
            [32.84717025601902, 2.303664095456272],
            [32.84870224739614, 2.301746256419391],
            [32.850288995581394, 2.301061986217492],
            [32.85294412630373, 2.310823117673753],
            [32.85689443991787, 2.317466368457384],
            [32.858484189374494, 2.32253754505164],
            [32.859603027586154, 2.324506875051233],
            [32.86282018118114, 2.325245282886468],
            [32.86648909483761, 2.324053339650951],
            [32.87060931760122, 2.325359574776492],
            [32.87309269493278, 2.326722427705063],
            [32.87433434362355, 2.327858062974106],
            [32.87608409830365, 2.327687891018741],
            [32.87946274742716, 2.325579531931559],
            [32.88084102538107, 2.326457228468451],
            [32.88343892982655, 2.326448399024586],
            [32.88517757144826, 2.326937091650477],
            [32.88531925463317, 2.329446396396599],
            [32.89091251952833, 2.330371979601987],
            [32.89688471087831, 2.329495052030261],
            [32.90507101314671, 2.332937939175666],
            [32.909499672463134, 2.334288196352972],
            [32.91039700049874, 2.33527298093805],
            [32.91159482398009, 2.339258242813297],
            [32.913424898826335, 2.342994675999492],
            [32.91372088293267, 2.344565031164258],
            [32.912832517388644, 2.346595583519428],
            [32.91398990590237, 2.346866403074809],
            [32.91468967644071, 2.347786988835088],
            [32.91517396899018, 2.35114429009261],
            [32.917730770121494, 2.355638855612914],
            [32.918457387710426, 2.357860939921082],
            [32.91894159671656, 2.362867890617082],
            [32.918968147323106, 2.369176313398779],
            [32.91886042315087, 2.370150998389717],
            [32.91735292523828, 2.372750085001159],
            [32.917361422402564, 2.373332606008034],
            [32.91813659393257, 2.376074781019021],
            [32.9183725094925, 2.379286552114765],
            [32.91956435109234, 2.382905503872957],
            [32.92083862839086, 2.385257850624737],
            [32.92107465085028, 2.386723510643294],
            [32.91913890987209, 2.390595600255198],
            [32.916211848333454, 2.393445291197963],
            [32.915834307979125, 2.394250469258367],
            [32.91408765248678, 2.394557965166716],
            [32.91298997588828, 2.395408331430597],
            [32.913414591556766, 2.396973524687152],
            [32.91226990522113, 2.398882410200541],
            [32.91210447327506, 2.401325142777261],
            [32.913508441249434, 2.406400711770984],
            [32.91041631248074, 2.409621312546848],
            [32.91051029153082, 2.412453091506072],
            [32.908987698328204, 2.416026632748577],
            [32.90604822925889, 2.426484988039579],
            [32.90392379985021, 2.43004038416613],
            [32.90220015111059, 2.434147685294057],
            [32.899512367525986, 2.43823554388493],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 680,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "OKWERODOT",
        Population: 34434,
        Key: "KOLEOKWERODOT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.00659562055792, 2.530396206859689],
            [33.006127664770226, 2.532123927271274],
            [33.00355988353115, 2.53351933878173],
            [33.00217244904956, 2.533727603428534],
            [32.9978736843266, 2.528916399386834],
            [32.99554834131476, 2.528781791397251],
            [32.993105903803915, 2.526914184982706],
            [32.988396659301756, 2.528924769813398],
            [32.988028612343356, 2.529446347704928],
            [32.98764382707624, 2.531128866285019],
            [32.98782782540262, 2.533080592424693],
            [32.99006114230181, 2.537110250205911],
            [32.99337351282538, 2.537749630106005],
            [32.99513008482015, 2.537514084099931],
            [32.996234214017335, 2.537951539340755],
            [32.99778165282407, 2.545598603223402],
            [32.998793765790055, 2.548080331641573],
            [32.998291886023985, 2.553598995641092],
            [32.995807558274834, 2.554818822983438],
            [32.99380002483744, 2.556383558728349],
            [32.99115676265662, 2.557090197033605],
            [32.989007025909764, 2.557064945406942],
            [32.98549381185162, 2.559773769587069],
            [32.98479117658584, 2.55977376151033],
            [32.982700024368555, 2.556728366788399],
            [32.980483397269005, 2.55520566043445],
            [32.979630220531305, 2.553472644724875],
            [32.977589272460285, 2.551621839701749],
            [32.97509655085312, 2.553523045812767],
            [32.970989437204445, 2.555432613082966],
            [32.96924958734868, 2.555180194286831],
            [32.966087762788646, 2.553564898044693],
            [32.964515244815814, 2.55194964015574],
            [32.963034699955, 2.551587853333528],
            [32.96116105502084, 2.550208127716947],
            [32.95922045864854, 2.549922040966003],
            [32.956644111074944, 2.550712740164351],
            [32.9544023886396, 2.550191080220038],
            [32.953298219916555, 2.551200554414345],
            [32.953080683887364, 2.552580208069534],
            [32.95735489406032, 2.557064279520691],
            [32.95787346362607, 2.558393485597231],
            [32.95727115221124, 2.560109642932588],
            [32.95576541948818, 2.562330517128717],
            [32.954644530422755, 2.562549199715995],
            [32.95129032625476, 2.560858143742209],
            [32.94573615244749, 2.560403642644521],
            [32.94465166401571, 2.562440309827787],
            [32.94335116489402, 2.563723453136349],
            [32.93951991488598, 2.563812713733379],
            [32.935918367689304, 2.562546342340347],
            [32.925839647493895, 2.557975989644653],
            [32.91724814574354, 2.552491714885635],
            [32.911300017565075, 2.55141124912595],
            [32.90502138122728, 2.551327697082639],
            [32.90191269740618, 2.558480309173458],
            [32.89818471412994, 2.556572960375532],
            [32.8967914118529, 2.555337609298786],
            [32.89479332150577, 2.552372824147046],
            [32.889854596974416, 2.552468157505108],
            [32.886201402937125, 2.549451730528022],
            [32.881845956316376, 2.547991157000879],
            [32.87947482347955, 2.546532841541007],
            [32.878717947936885, 2.545652863563477],
            [32.87744941626294, 2.542604750286201],
            [32.87658476893737, 2.541694333237908],
            [32.87456445965999, 2.540686267744449],
            [32.873804876595116, 2.539775859214987],
            [32.86999832486747, 2.540897140969389],
            [32.86744460944911, 2.5401409770336],
            [32.86749324334027, 2.538734842950154],
            [32.86619232111211, 2.536629561644951],
            [32.86468957169415, 2.532532902348021],
            [32.86503764371389, 2.527079065668718],
            [32.866500589679966, 2.525234166598552],
            [32.86629868164175, 2.523958052364358],
            [32.866767548321164, 2.522592599843645],
            [32.865983903881364, 2.52004033352763],
            [32.8640840038864, 2.51887114505232],
            [32.86308886728262, 2.516355927114462],
            [32.863574185708146, 2.515125563353924],
            [32.864895792544026, 2.513868145676905],
            [32.86528083113607, 2.511868761125739],
            [32.86529753441042, 2.51071977237566],
            [32.86440275579358, 2.508204565653207],
            [32.86579150900201, 2.507245709479063],
            [32.866059160244305, 2.506856709205722],
            [32.86582513114647, 2.50558103379557],
            [32.868527117095724, 2.502577648313728],
            [32.86829153301415, 2.497149320614253],
            [32.869124510234386, 2.496425631099764],
            [32.869195436717646, 2.495520920149613],
            [32.87009254915758, 2.49433583003478],
            [32.8704940906997, 2.493024030254991],
            [32.869384796189635, 2.49087069213339],
            [32.86957386460751, 2.489160794733198],
            [32.87006950737057, 2.488518494904783],
            [32.86982171787923, 2.487079969392874],
            [32.87060080336893, 2.485469649476086],
            [32.871120293707875, 2.485279709767764],
            [32.871285667263464, 2.484375008214932],
            [32.872607408846655, 2.484257523878922],
            [32.873811426211816, 2.483515771950442],
            [32.87468501626606, 2.481235967049394],
            [32.874189627726246, 2.479245540799108],
            [32.874437427099046, 2.477644213913378],
            [32.87596527185279, 2.475600733301767],
            [32.88920343607272, 2.476644358509836],
            [32.89385653586962, 2.476644730962439],
            [32.89764799230724, 2.47595172569805],
            [32.900762656213146, 2.475951931220207],
            [32.902888486993675, 2.476574329338724],
            [32.90487514717711, 2.476126296563003],
            [32.90895750954475, 2.477144221238965],
            [32.91101921229208, 2.47686107116904],
            [32.91111000232293, 2.477472814029871],
            [32.912984303925576, 2.479917812691033],
            [32.9153894191313, 2.480236491298322],
            [32.91639936266588, 2.480908035733274],
            [32.917999962872805, 2.480451875108498],
            [32.92206326838002, 2.480737344378976],
            [32.923820226650385, 2.480410918002492],
            [32.92704761654803, 2.480929705225762],
            [32.92798339427446, 2.480622436365954],
            [32.92958765152292, 2.47881700746298],
            [32.93119197165343, 2.4757054589787],
            [32.931840853529266, 2.475425384255011],
            [32.93573705083406, 2.476281917190268],
            [32.93618802127636, 2.468859145282353],
            [32.941833775631856, 2.469281919109936],
            [32.94530016320918, 2.468713624939392],
            [32.94831436133037, 2.469509565188124],
            [32.95392827310402, 2.472200397212135],
            [32.95660340032458, 2.472427864191647],
            [32.962707258644066, 2.471442751343335],
            [32.968359010152426, 2.46890385960244],
            [32.97133556526994, 2.468790239347159],
            [32.973290364006886, 2.469418210592757],
            [32.97526258287382, 2.472459920347597],
            [32.97623809128862, 2.473100869192945],
            [32.9809309639947, 2.473755427984693],
            [32.98652390549635, 2.471601128680027],
            [32.99207240823921, 2.472495683091011],
            [32.99664085619363, 2.475660029598704],
            [33.00122816158248, 2.476645332271498],
            [33.002593993378106, 2.47749799360572],
            [33.00396924670446, 2.477810632786305],
            [33.00671976323859, 2.48061493438507],
            [33.00944202236717, 2.481638113004376],
            [33.01180635046572, 2.483855017040166],
            [33.01274000816808, 2.484040010092379],
            [33.01259514674368, 2.485070014912332],
            [33.01436352799116, 2.488920666462946],
            [33.013570870754144, 2.491383780822128],
            [33.01253135468039, 2.492639214236627],
            [33.01226913016077, 2.495617881188632],
            [33.010569373014455, 2.496432096421236],
            [33.00999997946486, 2.497112053494398],
            [33.00732230552049, 2.498522069157667],
            [33.00334778859762, 2.497997347663646],
            [33.002181493287836, 2.498277813375852],
            [33.001443879421544, 2.499191581397086],
            [33.0015152820119, 2.500123442477562],
            [33.00325250429546, 2.501417188159173],
            [33.004787619114815, 2.50382373746992],
            [33.00735803511258, 2.503706112175123],
            [33.00895274057463, 2.504113225871284],
            [33.01014266337303, 2.505235069666965],
            [33.011332864649134, 2.505732655466891],
            [33.01287980129763, 2.507578268686951],
            [33.012546709583546, 2.509423899944939],
            [33.0114757066608, 2.510455290275065],
            [33.01034511579029, 2.512400446672315],
            [33.01032123407845, 2.514083225122453],
            [33.00989283650261, 2.515159844145167],
            [33.01010706044337, 2.517693057329113],
            [33.00975007623765, 2.520760058519728],
            [33.00562090535552, 2.525555095744968],
            [33.004002283147344, 2.526586481382458],
            [33.00310976648836, 2.52810641250871],
            [33.003419270239725, 2.529110650346242],
            [33.00659562055792, 2.530396206859689],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 681,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "AGWENG",
        Population: 28594,
        Key: "LIRAAGWENG",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.95725111079726, 2.193539832783756],
            [32.95665641619768, 2.193901704322077],
            [32.956537233115704, 2.194616431972982],
            [32.952420820107186, 2.194254416982528],
            [32.951326149271644, 2.194616270394806],
            [32.95000554585394, 2.194218148962304],
            [32.949042405443954, 2.194480484599959],
            [32.94882362794304, 2.189920673632631],
            [32.94937086993601, 2.188319333138625],
            [32.95059626540837, 2.186582305859267],
            [32.95081051270532, 2.183687198475861],
            [32.94993036045791, 2.181723920389524],
            [32.94592095566437, 2.176422103079672],
            [32.944802721120595, 2.175915417399565],
            [32.943755908031825, 2.174413538022095],
            [32.94301817558787, 2.174576359811745],
            [32.9410406997799, 2.17385434612288],
            [32.940712662885915, 2.171981027783601],
            [32.941029266921305, 2.167559745678802],
            [32.94310196864097, 2.163450793106672],
            [32.95073332855777, 2.162678984542234],
            [32.95905662390703, 2.159815881989055],
            [32.96041840609735, 2.157733643088685],
            [32.961191880709805, 2.157185695639741],
            [32.96163812781037, 2.156000467590083],
            [32.96484139794265, 2.153185621669058],
            [32.96589809968607, 2.152900703070515],
            [32.96660621826837, 2.151848621244835],
            [32.968170242670176, 2.151075911803904],
            [32.97049915109541, 2.148831815793522],
            [32.97139146204017, 2.147359675040465],
            [32.9737858450732, 2.145356802365199],
            [32.97707172068574, 2.143633107638133],
            [32.980281167633926, 2.142876620634574],
            [32.98418893254465, 2.138756260997454],
            [32.994236071567926, 2.134685019176247],
            [32.99877300123225, 2.130607512336081],
            [33.005141358605684, 2.127309635050921],
            [33.00838528019954, 2.124870571960453],
            [33.00927309148303, 2.124681626354117],
            [33.010883627057034, 2.125104239036403],
            [33.01420701182428, 2.122601128827679],
            [33.0185907850209, 2.120509153200548],
            [33.020268231608796, 2.119270954916582],
            [33.02264140362134, 2.118566688692036],
            [33.02472434164366, 2.118738420728161],
            [33.028516143034366, 2.120364557940841],
            [33.03444595366585, 2.122009850347037],
            [33.03748981146277, 2.12227839615925],
            [33.04488588553868, 2.123889900761159],
            [33.04734597404656, 2.123035861908787],
            [33.04869076190834, 2.120943088814541],
            [33.04880140740187, 2.120136471151489],
            [33.05163148772073, 2.117147614464562],
            [33.051854752306504, 2.113027378185265],
            [33.05154921910871, 2.112085457004052],
            [33.05077094300106, 2.111580905413958],
            [33.0513589478467, 2.111172003289965],
            [33.051912328028, 2.109684350102375],
            [33.05526730474717, 2.104499261155524],
            [33.05448441489223, 2.103555909249766],
            [33.05392069689863, 2.104061429376397],
            [33.05303832311753, 2.103864190887045],
            [33.0516902060993, 2.102199784957137],
            [33.049704847574695, 2.101164190930049],
            [33.049263634633, 2.100177862644324],
            [33.04879794349812, 2.100276511300636],
            [33.04818511550627, 2.097847663928093],
            [33.0508689060794, 2.0957516018345],
            [33.05334430906623, 2.09233630917838],
            [33.057028991749185, 2.090395940736854],
            [33.05749448345803, 2.089768035714216],
            [33.05936820295239, 2.089645690234426],
            [33.05976314906368, 2.088178368737072],
            [33.06043157828008, 2.087291845194821],
            [33.061434253545706, 2.086782325700374],
            [33.06203175627885, 2.085213098593718],
            [33.06326739254541, 2.085060205125757],
            [33.064300424579415, 2.083949492835409],
            [33.06473594579547, 2.084153267445159],
            [33.06516762581537, 2.081597935647876],
            [33.06611322392444, 2.080393237381797],
            [33.06757897982074, 2.080017066187462],
            [33.070391552873, 2.080161639147434],
            [33.07285246962756, 2.078441239455683],
            [33.07373129685992, 2.076302898243459],
            [33.07499367776911, 2.074727249147048],
            [33.07529724545308, 2.073457114800357],
            [33.07508944805986, 2.072363859639136],
            [33.07655957695493, 2.070932895333832],
            [33.07622395289006, 2.070161193317178],
            [33.07638368233073, 2.068633827896268],
            [33.07767804236572, 2.067604808306056],
            [33.079004422849046, 2.067797672213028],
            [33.07975548269853, 2.067443930514733],
            [33.07957951351414, 2.063730048188946],
            [33.07773135288626, 2.059711421107642],
            [33.07706981105318, 2.0561557648289],
            [33.077390646153525, 2.0545285476465],
            [33.07794224767058, 2.054961812014889],
            [33.0795431595929, 2.056355129737747],
            [33.083639047893804, 2.0630227334714],
            [33.085223531426216, 2.06494971086032],
            [33.08915538915286, 2.067292727549969],
            [33.09216205939197, 2.068152042243561],
            [33.09640603496742, 2.068586056098978],
            [33.10253502725023, 2.068124260189051],
            [33.10987825074304, 2.066965719264833],
            [33.11383332991978, 2.067318280553949],
            [33.11752238739816, 2.06902793664047],
            [33.12228711185226, 2.073334053463825],
            [33.12837038887027, 2.077404819113143],
            [33.13128477877349, 2.079937800800507],
            [33.13418771964842, 2.083230743000403],
            [33.13550623088982, 2.086044314782033],
            [33.13564514906032, 2.087139016564739],
            [33.134870351229445, 2.090178949840085],
            [33.132419043753494, 2.094132794797931],
            [33.13149416618474, 2.097136551022973],
            [33.13182994296321, 2.099941161142805],
            [33.13481405560721, 2.105523038223338],
            [33.13554274021962, 2.108608076069532],
            [33.13520166158431, 2.112842204186254],
            [33.133650508243875, 2.117456420357856],
            [33.133108988519254, 2.120975835110323],
            [33.13418121764241, 2.128711111403417],
            [33.13526507455855, 2.131090434067607],
            [33.13315949360116, 2.133135289816623],
            [33.132297322930825, 2.133488206023766],
            [33.130450587929275, 2.135813499142849],
            [33.12909609916073, 2.136754525219565],
            [33.12828336188217, 2.136808876797821],
            [33.12579587655478, 2.139260880009864],
            [33.12282834142103, 2.141224369211242],
            [33.11947929268443, 2.144915901311284],
            [33.11886374010231, 2.147376792985225],
            [33.11944263692928, 2.150579462907073],
            [33.119196671017946, 2.153402215029507],
            [33.118039145061964, 2.154098941821156],
            [33.11786692275063, 2.154768448838544],
            [33.11429562632118, 2.155935814925257],
            [33.11172224678126, 2.160531994762245],
            [33.10997367697904, 2.160975437108953],
            [33.10987533840491, 2.161319239063632],
            [33.10490034259729, 2.163870909420837],
            [33.10351634596829, 2.165038097057275],
            [33.099107323823986, 2.16354560194292],
            [33.0954733663102, 2.160976424553021],
            [33.09403388613601, 2.160723192704203],
            [33.090294174455394, 2.161202924457451],
            [33.08729754738117, 2.162207343108938],
            [33.08569310687637, 2.162080773522776],
            [33.08309765932319, 2.160615268635979],
            [33.07933378924963, 2.155974241887117],
            [33.07617208865714, 2.154807312102381],
            [33.07455123683044, 2.154898949076635],
            [33.07173651770292, 2.158721294515843],
            [33.07131815251216, 2.160735077942072],
            [33.0698954187315, 2.161833814817542],
            [33.07017628239496, 2.163767953308692],
            [33.06967669063789, 2.165788302803862],
            [33.06982426856772, 2.166927721247641],
            [33.06845855984126, 2.16904864794657],
            [33.06851093072402, 2.169556120495295],
            [33.068092150511596, 2.169661464917226],
            [33.06764965208076, 2.171461584718914],
            [33.06687875203991, 2.172438271141889],
            [33.06636588138632, 2.1746966365957],
            [33.06551786008003, 2.176124706782978],
            [33.06079714588833, 2.179744258246614],
            [33.05792276515121, 2.180280572764381],
            [33.055600386579776, 2.179897660259469],
            [33.05017763989189, 2.176680169829027],
            [33.04938062941898, 2.1756127095029],
            [33.048583653082055, 2.175608154736756],
            [33.04662534103402, 2.174632359056246],
            [33.043430391996225, 2.171001761160068],
            [33.041204279585585, 2.173283122557181],
            [33.03988291259989, 2.176151131419255],
            [33.03390144165302, 2.183235262823273],
            [33.033099361986956, 2.183570028324056],
            [33.03173069151504, 2.183407207506857],
            [33.024675683497975, 2.179842730329907],
            [33.02007449734137, 2.179272824113335],
            [33.01875303513425, 2.178060511016917],
            [33.015520517652945, 2.177590092515156],
            [33.01202831788422, 2.176495408382089],
            [33.01143841849165, 2.176730641161527],
            [33.011013774975375, 2.177535848318687],
            [33.00997533777831, 2.177780131208984],
            [33.008276463675905, 2.179200557545121],
            [33.00617653940988, 2.179888157575716],
            [33.005610247742986, 2.180503372294759],
            [33.00205903135506, 2.181037167695397],
            [33.00047087371313, 2.179665795117261],
            [32.99923133696159, 2.177320072591434],
            [32.99778659535476, 2.175963155360026],
            [32.99457432230667, 2.173894944988857],
            [32.99117645732092, 2.172415588825383],
            [32.98983446591459, 2.168767501648581],
            [32.989577480369704, 2.169514350949278],
            [32.98832111727457, 2.170706430233424],
            [32.986693561320905, 2.171438905080766],
            [32.98567989426947, 2.173349110213707],
            [32.98559422104252, 2.174684823280929],
            [32.98259845006276, 2.179329882428684],
            [32.978018239568016, 2.180286314229504],
            [32.97411590587151, 2.180190501059021],
            [32.97121292636903, 2.181387325037818],
            [32.96726292177536, 2.184929996133764],
            [32.96609113506422, 2.187804114716395],
            [32.964235096211304, 2.189694943744113],
            [32.96053484392785, 2.192074271413185],
            [32.95810774604882, 2.192870361813958],
            [32.95725111079726, 2.193539832783756],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 682,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "AGALI",
        Population: 24856,
        Key: "LIRAAGALI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.98089692323533, 2.267705031230619],
            [32.97477844213965, 2.266155293798244],
            [32.972413853529645, 2.266125091822203],
            [32.97002026370901, 2.266797492482819],
            [32.96782072705777, 2.268265262047104],
            [32.96385287653263, 2.272863844636443],
            [32.96093315153495, 2.274367859719073],
            [32.96000509931998, 2.274413070419736],
            [32.95883901511428, 2.273625929371037],
            [32.95691153684006, 2.273218747352703],
            [32.955150707729175, 2.27338154297953],
            [32.95303297256599, 2.272449611685833],
            [32.95173458628188, 2.272431474601751],
            [32.95066804708777, 2.273036961903022],
            [32.949394527967335, 2.27250770762085],
            [32.94766848521749, 2.273547087064118],
            [32.946020936358885, 2.278613875978688],
            [32.94489342850641, 2.279702622847734],
            [32.9443612189214, 2.280882122900813],
            [32.93850792768411, 2.281877954481919],
            [32.93470236230664, 2.280786214853107],
            [32.92826501881098, 2.280845416299695],
            [32.92662045954561, 2.280065797994511],
            [32.924217472448774, 2.277079475978775],
            [32.92284182566036, 2.271281677613159],
            [32.92301179948852, 2.265037650616538],
            [32.92632553724794, 2.260284075092378],
            [32.92723616304472, 2.259424667303156],
            [32.93111594633264, 2.257431374756901],
            [32.931503088779046, 2.256218034197744],
            [32.92699529058106, 2.2501380816798],
            [32.92671525875755, 2.247476873203658],
            [32.927355639875806, 2.244745019409115],
            [32.92869370384772, 2.242502012918846],
            [32.93075814196508, 2.237570413171454],
            [32.92839337099709, 2.236015439221267],
            [32.927346555213326, 2.234079282244575],
            [32.926466172098934, 2.231175080143854],
            [32.926371296530185, 2.228786608098638],
            [32.92703747726342, 2.226850535855315],
            [32.92669282962151, 2.222815457718266],
            [32.92619320552511, 2.221259310222731],
            [32.92311316897845, 2.216035388154268],
            [32.921731861007096, 2.216002643017967],
            [32.921089360763055, 2.216554488995213],
            [32.91973302146502, 2.216744406934741],
            [32.91854308249696, 2.21655434986051],
            [32.9169011445156, 2.21774849124197],
            [32.91318907219964, 2.217965410108719],
            [32.91129611169023, 2.21744165369046],
            [32.910179006328775, 2.218960423815643],
            [32.90801763280572, 2.220753372239759],
            [32.90625826794871, 2.22062764061305],
            [32.90518464913185, 2.223161527268291],
            [32.90406243235644, 2.223248821774161],
            [32.90308136516663, 2.224613899496414],
            [32.89748379105309, 2.223998892392782],
            [32.88783521296182, 2.219528861589988],
            [32.88688324939061, 2.220297802509342],
            [32.88276663695613, 2.221871693768682],
            [32.88190990109323, 2.223192518259183],
            [32.86520805951319, 2.205268561845043],
            [32.862852600481425, 2.202563230865694],
            [32.863863091090025, 2.201016251393846],
            [32.86395861883567, 2.198211625857235],
            [32.86702460393466, 2.193950668807619],
            [32.86742921232516, 2.19498208687153],
            [32.86845668288924, 2.195181216618832],
            [32.87057635661679, 2.194511908859628],
            [32.875189964677155, 2.194150415382426],
            [32.876817055303526, 2.192431581409572],
            [32.879514917985595, 2.190577123585151],
            [32.88256552572358, 2.191753504993412],
            [32.88483496837195, 2.191283227224494],
            [32.88519895314864, 2.190803752794747],
            [32.886997091988235, 2.19028819950212],
            [32.888024939844755, 2.189193564115707],
            [32.889941251161666, 2.186787146745559],
            [32.89073342959666, 2.183928283790248],
            [32.891140403251285, 2.183539283365902],
            [32.896299826779966, 2.182137331457156],
            [32.89832331878839, 2.177840040569443],
            [32.899029891370056, 2.177215830141082],
            [32.90236948533828, 2.177026059778491],
            [32.90511262760225, 2.178229517332765],
            [32.907654933518174, 2.177768267649036],
            [32.9096085204278, 2.176311784257039],
            [32.910518345825665, 2.174565724236941],
            [32.911321274399654, 2.174511488010691],
            [32.911669240418206, 2.173814872932535],
            [32.913087407164, 2.172955468799714],
            [32.914853755523986, 2.172521303785532],
            [32.921223295080324, 2.154300533017527],
            [32.93207301323296, 2.164768706853522],
            [32.9330487471249, 2.16533872536572],
            [32.9410406997799, 2.17385434612288],
            [32.94301817558787, 2.174576359811745],
            [32.943755908031825, 2.174413538022095],
            [32.944802721120595, 2.175915417399565],
            [32.94592095566437, 2.176422103079672],
            [32.94993036045791, 2.181723920389524],
            [32.95081051270532, 2.183687198475861],
            [32.95059626540837, 2.186582305859267],
            [32.94937086993601, 2.188319333138625],
            [32.94882362794304, 2.189920673632631],
            [32.949042405443954, 2.194480484599959],
            [32.95000554585394, 2.194218148962304],
            [32.951326149271644, 2.194616270394806],
            [32.952420820107186, 2.194254416982528],
            [32.956537233115704, 2.194616431972982],
            [32.95665641619768, 2.193901704322077],
            [32.95725111079726, 2.193539832783756],
            [32.96125505742711, 2.195204137368167],
            [32.96553704790876, 2.198288779236006],
            [32.96944903939289, 2.199458862024632],
            [32.97082350669335, 2.200735248421278],
            [32.97193364112823, 2.202543446624144],
            [32.97293801870131, 2.205947091716501],
            [32.97246219097676, 2.208127531183163],
            [32.972092113825816, 2.209137974875644],
            [32.96955453664155, 2.210892918958385],
            [32.96876152906154, 2.212116081304278],
            [32.96870863895257, 2.213232894134683],
            [32.97230336524128, 2.220465671217996],
            [32.97563299779134, 2.222080199350227],
            [32.976596658325846, 2.225455403701721],
            [32.9780243400271, 2.228471552292286],
            [32.980094539040415, 2.229225612935411],
            [32.98477036082409, 2.228830700861758],
            [32.988732295044755, 2.231021018271065],
            [32.990364669561586, 2.23021715866554],
            [32.99088767590653, 2.2314322810596],
            [32.99024011635083, 2.234225797401301],
            [32.985026862177044, 2.240757869030587],
            [32.9852187396268, 2.241451183572591],
            [32.98291302660053, 2.243085303603948],
            [32.98196977219601, 2.244350437351816],
            [32.978353991193664, 2.246195391922159],
            [32.97686048903322, 2.248593872824642],
            [32.97601296449526, 2.252764993484088],
            [32.97625087880667, 2.255547731756783],
            [32.97830319775255, 2.260933701457425],
            [32.979463181499156, 2.266050358377584],
            [32.98089692323533, 2.267705031230619],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 683,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "ADEKOKWOK",
        Population: 39957,
        Key: "LIRAADEKOKWOK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.99644529834616, 2.041863427945549],
            [32.99090225556359, 2.046757967921315],
            [32.98829693283052, 2.050693504967538],
            [32.98231285407438, 2.061387296465821],
            [32.97968220154522, 2.064743794481191],
            [32.977054359844566, 2.067222703662725],
            [32.974996453377635, 2.06747599565346],
            [32.97123700032034, 2.066299789599833],
            [32.969309793337345, 2.065205035678357],
            [32.96566948383619, 2.064888307789961],
            [32.96318335676151, 2.062915951715156],
            [32.96011411167632, 2.061459270488148],
            [32.95940032831789, 2.061359732442387],
            [32.95713979066892, 2.062436295547405],
            [32.956069127309334, 2.061812006261246],
            [32.95492706046107, 2.062146721751284],
            [32.95329746892498, 2.061033863059172],
            [32.95227433093551, 2.059387234640433],
            [32.950799290052444, 2.058717692906283],
            [32.94934782635237, 2.059007158699937],
            [32.94730168781565, 2.06049084063666],
            [32.94634987516142, 2.06065365913556],
            [32.945897730621006, 2.060273658906925],
            [32.94399439546838, 2.060291687212623],
            [32.943352015598606, 2.059576932335124],
            [32.94211466714311, 2.060318761091477],
            [32.93993762161163, 2.060327727664146],
            [32.93793904437763, 2.059775768050388],
            [32.93594033868452, 2.062480814144004],
            [32.93560725415694, 2.064444052492374],
            [32.93460789547137, 2.065837286510116],
            [32.93553725204013, 2.069324509676509],
            [32.93558958070205, 2.070589272635638],
            [32.934882390977776, 2.071985748339053],
            [32.932368112498736, 2.07264437170444],
            [32.93001086671787, 2.075700770289906],
            [32.926370307485044, 2.078388217164902],
            [32.918251233335894, 2.080443048449477],
            [32.91482033729713, 2.079968581043833],
            [32.910865362324955, 2.078075688774666],
            [32.90815306461456, 2.076016904416251],
            [32.90491722516335, 2.07563371196294],
            [32.89708870749954, 2.072429521240351],
            [32.895937943162714, 2.07244330315603],
            [32.894232605681864, 2.071269990574595],
            [32.89455917203373, 2.071065610131335],
            [32.894295417683146, 2.068456322455099],
            [32.89308933688775, 2.062107559023667],
            [32.889509016881256, 2.052110120948291],
            [32.88787989785897, 2.045035071392491],
            [32.8884748853093, 2.039823906427296],
            [32.88827313896787, 2.035426936889442],
            [32.88860623247858, 2.034087969585107],
            [32.88945843184927, 2.031609086309897],
            [32.89350834886552, 2.023548272908979],
            [32.89411269047289, 2.020951755718153],
            [32.89407949682481, 2.017142866554515],
            [32.89352068363266, 2.015378619058088],
            [32.89097494794898, 2.012193821816842],
            [32.88843338134657, 2.009841367544155],
            [32.88715340962746, 2.009515578421214],
            [32.885953461630514, 2.006059449995336],
            [32.885953545173805, 2.004847120617905],
            [32.88447282963312, 2.002060467016162],
            [32.88070972672081, 2.000051709593826],
            [32.87904479186819, 1.999626366798682],
            [32.87558466824333, 1.997056692574948],
            [32.87338793792902, 1.994749478580904],
            [32.871034619582595, 1.993383163137864],
            [32.86879450064004, 1.992650158442076],
            [32.86552941114484, 1.990252377179863],
            [32.863744211638604, 1.989953670893109],
            [32.86191485185128, 1.990161604209156],
            [32.86048431350743, 1.989464846595822],
            [32.86063320836743, 1.986578793068426],
            [32.86525762675394, 1.977034350348513],
            [32.866405790468036, 1.972214768285616],
            [32.866882277556, 1.96395636290374],
            [32.86593142969238, 1.953782839926974],
            [32.86719381688978, 1.949575877873486],
            [32.869134171615265, 1.946793293718326],
            [32.8691620148975, 1.94574834143657],
            [32.87399892886614, 1.948543356403284],
            [32.87899917451975, 1.953082342139274],
            [32.888799684675014, 1.958969133682241],
            [32.89178372635211, 1.959970872509697],
            [32.89334512138512, 1.961925758247417],
            [32.896891521006474, 1.962988492826471],
            [32.90022720191332, 1.963063277677336],
            [32.901858003480136, 1.962690466647037],
            [32.904304105219, 1.963883914136285],
            [32.90959223127677, 1.967575214206774],
            [32.91216118751221, 1.969925456481504],
            [32.91772204029357, 1.976191707676046],
            [32.91910285688648, 1.974867674985145],
            [32.919836467859874, 1.973066064008684],
            [32.92186457720885, 1.970244306371618],
            [32.92210195971761, 1.968811682754368],
            [32.92149793701217, 1.96766120590998],
            [32.92177844314616, 1.966749542084264],
            [32.92333183688492, 1.965534046102365],
            [32.925553971555445, 1.965577560927851],
            [32.92675539907768, 1.964354556794596],
            [32.928994076224186, 1.964032881339085],
            [32.93146537480847, 1.96286290303734],
            [32.933471534721804, 1.960669079852579],
            [32.93387866198833, 1.9581826692163],
            [32.935390524814885, 1.957041898261345],
            [32.93585575241905, 1.955667069467402],
            [32.93806543015156, 1.952975962592883],
            [32.94205950699139, 1.950611621793461],
            [32.94497940177069, 1.950133595402437],
            [32.95019367912557, 1.947834565285545],
            [32.954358713448826, 1.945138602264706],
            [32.95771786284247, 1.941230274433771],
            [32.961248752152144, 1.946749187655282],
            [32.96449215631638, 1.954439428177709],
            [32.96493762278094, 1.964029530795922],
            [32.968833636829416, 1.967766125621583],
            [32.969012523741824, 1.973809696349305],
            [32.96793790599835, 1.977048592739099],
            [32.96650476972669, 1.977953290432676],
            [32.962948720402544, 1.983390621756936],
            [32.96250259996447, 1.984527646194352],
            [32.962234845415914, 1.988776559187567],
            [32.96140208199472, 1.990841155707538],
            [32.95774395800316, 1.995658501914353],
            [32.95474007523637, 2.00113414006625],
            [32.9538478406484, 2.00233099289737],
            [32.95091146268197, 2.004071453822469],
            [32.94840041364639, 2.006808221522784],
            [32.942785445453985, 2.011603359573195],
            [32.94813281270977, 2.014047987054625],
            [32.9573953110616, 2.016892454719354],
            [32.964609063965774, 2.019796796019822],
            [32.9657633892244, 2.02299050026651],
            [32.96937039099144, 2.026184252988054],
            [32.972111603674215, 2.029667493837377],
            [32.972977062178494, 2.033295456108523],
            [32.97542997494386, 2.036633931463427],
            [32.97932533951037, 2.040415737320367],
            [32.98365379085854, 2.041863347148511],
            [32.99644529834616, 2.041863427945549],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 685,
        District: "DOKOLO",
        County: "DOKOLO",
        Subcounty: "ADOK",
        Population: 17911,
        Key: "DOKOLOADOK",
        Dist2: "Dokolo",
        "Sub Country": "Adok",
        id2_original: "Dokolo Adok",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.357634374162785, 2.605413613401503],
            [33.35615782590669, 2.605191426722393],
            [33.35448783892889, 2.60576956536612],
            [33.35174902474794, 2.60786766563826],
            [33.34799353146442, 2.608393048507947],
            [33.34710975990474, 2.608020041589653],
            [33.34431731809797, 2.607967488938803],
            [33.31492714323565, 2.612027719008021],
            [33.31246137647689, 2.610864146102172],
            [33.31173650790781, 2.609868974220063],
            [33.30798926026028, 2.608092496437811],
            [33.300203943476824, 2.607747788467064],
            [33.29933783279565, 2.607303648316544],
            [33.29612041240099, 2.603820698994145],
            [33.29132904750884, 2.595894560851233],
            [33.287600053627855, 2.5963753240443],
            [33.28177640050674, 2.595372404288606],
            [33.27793263876339, 2.596395279374655],
            [33.2735492895716, 2.594938758393588],
            [33.26601156644674, 2.595109234549705],
            [33.263899663146375, 2.595491828555082],
            [33.26225618275766, 2.596256461629434],
            [33.260577142558446, 2.595990187093517],
            [33.25994113084569, 2.597145650539784],
            [33.25882776786571, 2.597519136294221],
            [33.25461246651411, 2.596729036872411],
            [33.25265071212194, 2.596764989121882],
            [33.250930382657295, 2.595582243662814],
            [33.25027877439461, 2.595163539449428],
            [33.2490374455041, 2.595328671594865],
            [33.2470464105252, 2.594386864474341],
            [33.24589876603735, 2.594457756844599],
            [33.24360327224576, 2.593492444501759],
            [33.2417295644295, 2.593704799586147],
            [33.24065210172152, 2.593328127848832],
            [33.23387176707733, 2.594707378757565],
            [33.233051935802955, 2.594307084304282],
            [33.23054578348398, 2.59418977957209],
            [33.226236284791675, 2.594802984449614],
            [33.22472582962518, 2.596016352392052],
            [33.223484471090266, 2.596157891060015],
            [33.22278195619872, 2.596817583519821],
            [33.21905779615229, 2.596347114491652],
            [33.21830837752485, 2.59677124215512],
            [33.217769578797224, 2.596182463482084],
            [33.21491216094763, 2.596418507497256],
            [33.21360035203654, 2.595429411229734],
            [33.213132093516606, 2.596230357358606],
            [33.20813171670896, 2.597467853913094],
            [33.20686711516438, 2.598528041742145],
            [33.20639859703131, 2.59793924504281],
            [33.20506354151731, 2.598010123752862],
            [33.20215905554009, 2.596856384091424],
            [33.20194815716253, 2.596196886386196],
            [33.20136261909066, 2.596244074911143],
            [33.200662402089634, 2.595674405989419],
            [33.201490019062554, 2.586390405234366],
            [33.204123227298695, 2.577306665513602],
            [33.20723743575877, 2.571977400778381],
            [33.21032918543845, 2.572121646023524],
            [33.21328021852043, 2.571325006616642],
            [33.2197085114896, 2.568012662596681],
            [33.224088050926305, 2.566600547238915],
            [33.22493120336376, 2.565487602463544],
            [33.22553957750847, 2.562520040843282],
            [33.226160106757284, 2.561542841308646],
            [33.22606595073908, 2.560031989291431],
            [33.22676833447657, 2.557751990856276],
            [33.226346049037915, 2.554241783849142],
            [33.22662705014364, 2.553608436533537],
            [33.21937717508359, 2.547113866918326],
            [33.21893159093974, 2.543657942455336],
            [33.22055896812866, 2.540509264480121],
            [33.22098033638741, 2.538763096851604],
            [33.22143564209927, 2.531615790496454],
            [33.21596573026567, 2.52414379091464],
            [33.213435328823884, 2.517992162402062],
            [33.212006474821195, 2.516273441670878],
            [33.2116427155216, 2.512727024848945],
            [33.212625776073, 2.50775998897211],
            [33.21139588004112, 2.505579830306437],
            [33.211325435953164, 2.50452132664381],
            [33.20912341096856, 2.501807541621087],
            [33.20902950468202, 2.499925752621628],
            [33.20714369386393, 2.496967639244197],
            [33.205982522544524, 2.493787351881023],
            [33.20508691208773, 2.492664818921775],
            [33.20505885500649, 2.49115455089064],
            [33.20660493825543, 2.490284210197149],
            [33.20746008050702, 2.490567887792516],
            [33.20803291190917, 2.490025973938118],
            [33.208947885551936, 2.490146232728388],
            [33.20961476068287, 2.489509698711124],
            [33.21218672178296, 2.489399527397753],
            [33.213718652074604, 2.487435962130498],
            [33.21561805530125, 2.486453992624285],
            [33.21652065914254, 2.486759952514775],
            [33.21725525377119, 2.486495943939153],
            [33.21787451280217, 2.486896949404091],
            [33.2183676896898, 2.486411315255226],
            [33.219920996291975, 2.486864941163802],
            [33.22108584980572, 2.486431971414357],
            [33.22146372792662, 2.48682245945634],
            [33.22185193218169, 2.486199621914567],
            [33.222973793224284, 2.486846946905299],
            [33.22533784374343, 2.486920846316928],
            [33.22535617835836, 2.486131372034618],
            [33.227324271263214, 2.48586755808419],
            [33.228436005597594, 2.485961994353651],
            [33.22903405540473, 2.486800825061821],
            [33.229284872218585, 2.485895028740855],
            [33.22973512400864, 2.48576131379529],
            [33.23153632071346, 2.486332661021101],
            [33.23595127802686, 2.478422458673597],
            [33.237054629283016, 2.475690916264208],
            [33.23718127646671, 2.47376519703423],
            [33.23851887600959, 2.469982338356543],
            [33.23827374463316, 2.464814442421254],
            [33.23884979020744, 2.463203042703818],
            [33.24017820896812, 2.462770503199102],
            [33.243059242628206, 2.462479627200364],
            [33.24712470588875, 2.462739853169436],
            [33.25058478100456, 2.463870191799867],
            [33.253352777855824, 2.4641306050715],
            [33.25923509545657, 2.466739438693587],
            [33.26278142051777, 2.466303725042574],
            [33.27117109777327, 2.463605139377342],
            [33.27584207494261, 2.464300201835999],
            [33.281366689685456, 2.464528168271353],
            [33.28293431722985, 2.466351195619392],
            [33.28346091683596, 2.467703900373693],
            [33.28659600214322, 2.470467674286913],
            [33.286643275985035, 2.472749806936118],
            [33.28748590560302, 2.475184693463552],
            [33.288399240718704, 2.480042868502476],
            [33.291487424985, 2.47896165794186],
            [33.29250634268928, 2.479288475974771],
            [33.294804111913486, 2.479048131413094],
            [33.297405540449816, 2.479592619241824],
            [33.30210948129854, 2.479199093804551],
            [33.3011710813898, 2.486161353806064],
            [33.300591581793256, 2.494718596646804],
            [33.30121045454872, 2.500544887926078],
            [33.30264142228728, 2.501983512687521],
            [33.304966473346674, 2.50252265384916],
            [33.30604037333623, 2.506479500489198],
            [33.30532642378944, 2.512415366808177],
            [33.30657926638695, 2.516552010745881],
            [33.313377354436106, 2.525543860659509],
            [33.31713368584782, 2.528600721098981],
            [33.317671013135, 2.531658394595018],
            [33.316241234765855, 2.53561587066301],
            [33.315169903059704, 2.542810877583898],
            [33.31606473647377, 2.545328786733735],
            [33.31810787643408, 2.547382701248348],
            [33.31762065627514, 2.549056476178035],
            [33.32004293828594, 2.552312809806705],
            [33.32341243716998, 2.555007980762658],
            [33.325222171463246, 2.557015965075278],
            [33.32495618390087, 2.55785295602452],
            [33.327854872151256, 2.55846890207001],
            [33.33203971432651, 2.561057427095705],
            [33.33654624859491, 2.5629984456777],
            [33.339604441707145, 2.564939901947195],
            [33.338961303659254, 2.567044097687005],
            [33.33558235629504, 2.569472765507272],
            [33.334456208491936, 2.571091565812677],
            [33.334939846169554, 2.574004815177968],
            [33.33735508808347, 2.578859711045107],
            [33.34089679221083, 2.583228707884187],
            [33.348783651859094, 2.587272857117888],
            [33.35039399968516, 2.590995037091333],
            [33.352486984465656, 2.593907785832591],
            [33.35377520092243, 2.596820722599791],
            [33.356512137624414, 2.600218804415418],
            [33.357634374162785, 2.605413613401503],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 686,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "ADWARI",
        Population: 10193,
        Key: "OTUKEADWARI",
        Dist2: "Otuke",
        "Sub Country": "Adwari",
        id2_original: "OtukeAdwari",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.48431460149322, 2.357219462791146],
            [33.48304268766223, 2.357029923365318],
            [33.482447717279875, 2.35633351993135],
            [33.480591818564136, 2.357048870756888],
            [33.48028231481277, 2.357718448612197],
            [33.479163914979004, 2.356759865114809],
            [33.47790252491155, 2.356832676605522],
            [33.476689266577004, 2.357936817401004],
            [33.47378635175322, 2.359349131544676],
            [33.47294176470626, 2.358553293723385],
            [33.470824113984705, 2.359892959269035],
            [33.46882474713156, 2.35859993064329],
            [33.466539967546375, 2.357741246504546],
            [33.46350557260265, 2.357678939145806],
            [33.46184039520487, 2.358927970529165],
            [33.46115004260397, 2.358756309717404],
            [33.4608884091758, 2.358014549224656],
            [33.46019801884566, 2.357725278106858],
            [33.4588410893545, 2.356169657662115],
            [33.45834138979957, 2.356269340208291],
            [33.45765147647486, 2.357436621754084],
            [33.4580087508364, 2.358422617891177],
            [33.457605246475396, 2.360458310103147],
            [33.456058300843765, 2.36057643167055],
            [33.455416291079864, 2.362132714964697],
            [33.45488120059773, 2.362313829273215],
            [33.453119848667335, 2.361717311692725],
            [33.45276246021976, 2.360378483527116],
            [33.451953376389426, 2.359826884974794],
            [33.45119205867772, 2.360976094901591],
            [33.44869332913793, 2.360805016854496],
            [33.448384235018345, 2.361049384567171],
            [33.44859849668831, 2.361329770121372],
            [33.45009799779824, 2.362243022302903],
            [33.44943149187489, 2.362813196520281],
            [33.44812279562625, 2.362650777380146],
            [33.44783694810958, 2.361764269830198],
            [33.445575244447376, 2.359231858958935],
            [33.44392172448706, 2.360082803472904],
            [33.443493522743964, 2.360535287841312],
            [33.443541561950404, 2.361349497427462],
            [33.442589567836464, 2.362164027860075],
            [33.442494863845965, 2.36309589381071],
            [33.44292353630628, 2.364127107229711],
            [33.44220965503147, 2.364217805621078],
            [33.44156695536143, 2.363648054727079],
            [33.44111506055272, 2.363838184736457],
            [33.44140010048395, 2.362182503069396],
            [33.43944818713568, 2.361586026719948],
            [33.438829963862226, 2.361975242154456],
            [33.437663267005505, 2.361107106178492],
            [33.43728242444415, 2.360220625467746],
            [33.43597428245605, 2.36183139596349],
            [33.43359386822571, 2.360728417001011],
            [33.432333383660065, 2.361950151983474],
            [33.43164341643642, 2.363026955582287],
            [33.43166722448639, 2.363669281807939],
            [33.43129963117719, 2.363805101010904],
            [33.43062104740483, 2.363524857769545],
            [33.43057342411837, 2.362213063815148],
            [33.42990659120824, 2.36175187642921],
            [33.42883515619582, 2.359888536125759],
            [33.42850206538004, 2.358884426591589],
            [33.42877458279621, 2.356667836957097],
            [33.42753697382928, 2.355501161514809],
            [33.42603754458459, 2.354759772671261],
            [33.42520388464472, 2.35284207318038],
            [33.4236811090841, 2.35296014961854],
            [33.42300279480634, 2.35168473453143],
            [33.420265540100715, 2.350871339663445],
            [33.4197174141655, 2.34694512014072],
            [33.41864626661398, 2.34595932322727],
            [33.41433831302398, 2.344721177547486],
            [33.413601229163675, 2.346177961330354],
            [33.41372057663739, 2.346775025894418],
            [33.41488650812948, 2.347037040334851],
            [33.41445834231895, 2.347634268785706],
            [33.41343533997511, 2.347878842554307],
            [33.4134351692952, 2.347299835604682],
            [33.41213785020963, 2.347553536733368],
            [33.41170937537868, 2.347101314726578],
            [33.41213759059654, 2.346666932514635],
            [33.411804524035276, 2.345689957547541],
            [33.40992459538568, 2.347029466709212],
            [33.40930627509414, 2.347102024697863],
            [33.40861581200046, 2.346523221173016],
            [33.406710911982614, 2.343176395059047],
            [33.406567867850036, 2.342262690586853],
            [33.40556824146647, 2.341693022273555],
            [33.40487811973262, 2.340327127643658],
            [33.40117664753702, 2.336845105779524],
            [33.400818707523854, 2.333353068266868],
            [33.40005679782236, 2.332539056894304],
            [33.39874727602199, 2.329354887933768],
            [33.39489301297297, 2.332133410403023],
            [33.393285998794894, 2.330469214510003],
            [33.393214396778546, 2.329700238979841],
            [33.39223882907494, 2.328678201196895],
            [33.39133440614519, 2.328796066048247],
            [33.39104906527835, 2.329583234976545],
            [33.389526595144936, 2.330759770301497],
            [33.38786061644992, 2.331330195215351],
            [33.384838271507455, 2.329992072175856],
            [33.38400482087505, 2.328580967062787],
            [33.383933088602994, 2.327314405013027],
            [33.382315259607196, 2.327170094803455],
            [33.38174402091802, 2.326717899440787],
            [33.38043496444498, 2.327197748172904],
            [33.37976908015579, 2.328057395287976],
            [33.38029242786053, 2.328102488499189],
            [33.3803403457944, 2.328609108684504],
            [33.382387442833526, 2.33011035518602],
            [33.382149445877126, 2.331386049309052],
            [33.382577990776646, 2.332145881257751],
            [33.38226884185984, 2.332218342181208],
            [33.38122149337513, 2.331811512598262],
            [33.38094779916596, 2.332037762516019],
            [33.38006688874047, 2.329721965626604],
            [33.378472499485405, 2.328953400776988],
            [33.377116121559794, 2.329053284521497],
            [33.376353940567114, 2.327162661989829],
            [33.37564000539338, 2.327018101341448],
            [33.37406965954689, 2.327877989115918],
            [33.37292778314147, 2.329244393999334],
            [33.372570992073534, 2.329841593223381],
            [33.37280894591085, 2.33051100906588],
            [33.372523701163736, 2.331705293092203],
            [33.37162010558238, 2.332854505486571],
            [33.36988268836442, 2.333289224078667],
            [33.369597341209335, 2.334103532112607],
            [33.3682176564937, 2.335397621884007],
            [33.36712310872736, 2.335063169626368],
            [33.36667036501069, 2.33417667957621],
            [33.36612344012299, 2.334267293745873],
            [33.365741966944306, 2.33291033797806],
            [33.364695274229774, 2.3328563293504],
            [33.36333901578011, 2.333453787337142],
            [33.362577188723655, 2.332884022101262],
            [33.361768410320536, 2.333363724223303],
            [33.36057824138375, 2.332785021838276],
            [33.359935828276285, 2.333174210287741],
            [33.36003105418797, 2.334060795214951],
            [33.35850834061111, 2.334414021280831],
            [33.35836564053329, 2.334730704508136],
            [33.359341719378314, 2.335617063163725],
            [33.35881210143287, 2.336172232825321],
            [33.35679611754361, 2.337507230036854],
            [33.35660913860712, 2.337098634673499],
            [33.357185949545986, 2.336845129116292],
            [33.357007017717805, 2.336125963160219],
            [33.3565846469392, 2.336632788691824],
            [33.35636517683719, 2.336256893293743],
            [33.355731458523394, 2.33637964746338],
            [33.355577224077315, 2.336935441530937],
            [33.35513031491842, 2.336796616450299],
            [33.35469174122703, 2.337499593529949],
            [33.354179813804485, 2.337287228970127],
            [33.35437521175184, 2.338872714532553],
            [33.353892878428006, 2.339562966669613],
            [33.3522506206464, 2.338459643399138],
            [33.35227459668133, 2.337672544065409],
            [33.35118514236264, 2.33753353774898],
            [33.350584522475465, 2.336406383336772],
            [33.349965570668296, 2.336216550277119],
            [33.35039369246136, 2.335329832972094],
            [33.349013402281216, 2.334253579775692],
            [33.348347320362656, 2.334416592818247],
            [33.34744314626624, 2.335592934713305],
            [33.346800532834486, 2.335185976856903],
            [33.34345769415147, 2.338072813426149],
            [33.34205343063132, 2.337810793718573],
            [33.34026845570392, 2.336924619551475],
            [33.339221159321504, 2.334382651216611],
            [33.33719779038228, 2.333261305147997],
            [33.33695979971405, 2.33237475113171],
            [33.336126674271796, 2.332157821647759],
            [33.33593642007776, 2.331081267132185],
            [33.335031921689556, 2.330936731120374],
            [33.33443706000334, 2.330385002479301],
            [33.33264872807169, 2.330129218570149],
            [33.3311164914545, 2.327626437711081],
            [33.329950712676016, 2.327934312777707],
            [33.32990286121746, 2.32762672403722],
            [33.32814261870645, 2.329083714945385],
            [33.327500129242196, 2.329183383263103],
            [33.327357631285295, 2.330404771510225],
            [33.32645325686458, 2.330784959765068],
            [33.32628703799431, 2.331526858557351],
            [33.324573654303435, 2.331454880491824],
            [33.32438258264251, 2.329229345288992],
            [33.32464446310741, 2.328921684127764],
            [33.32390617191137, 2.327962864603629],
            [33.3243585068946, 2.32719375935233],
            [33.323287662973634, 2.327221147936842],
            [33.323144664655146, 2.326262190824633],
            [33.32221656033788, 2.326117651625741],
            [33.321526127786896, 2.325493562155904],
            [33.321513946631654, 2.323828902453633],
            [33.320609341343925, 2.323186767085177],
            [33.31953848754149, 2.323159870294528],
            [33.31794476842963, 2.32525010735546],
            [33.31699261172064, 2.325630300591127],
            [33.316660041029415, 2.326562224975822],
            [33.313066426855045, 2.326852539227883],
            [33.31268580977082, 2.326590258031327],
            [33.313137595883425, 2.325848296502055],
            [33.31232858391832, 2.325341840478612],
            [33.31185190099763, 2.322781621443284],
            [33.310780831599565, 2.321777632528572],
            [33.31109020060363, 2.320121947826203],
            [33.309114630122366, 2.318901027295341],
            [33.3084008575437, 2.31948019763009],
            [33.3070096609177, 2.322366523346384],
            [33.304939124137846, 2.323923074384434],
            [33.30386821643649, 2.323660940743494],
            [33.30355910704555, 2.323941467521276],
            [33.30325046028699, 2.326384249347902],
            [33.30136994054594, 2.325425662365304],
            [33.300560810901544, 2.324349231957727],
            [33.30051271689784, 2.322865518878475],
            [33.29998927127675, 2.322368041149873],
            [33.298109416289016, 2.321861803784591],
            [33.29777594189261, 2.321219531090108],
            [33.29699079546966, 2.321907276869139],
            [33.29613392126624, 2.320975606119416],
            [33.29565779799598, 2.320957612366332],
            [33.29498010894562, 2.322088642314669],
            [33.29581345896673, 2.323427437958327],
            [33.294956834494926, 2.323699031202556],
            [33.29476637548502, 2.324196661050243],
            [33.29495738156893, 2.326331735829787],
            [33.29564747545503, 2.328077680456524],
            [33.296909156576646, 2.329344007553706],
            [33.29681428909274, 2.329968276628365],
            [33.297337780527954, 2.330682886067319],
            [33.29682651246881, 2.331967682840019],
            [33.295659947664426, 2.3312713028389],
            [33.294137083170625, 2.331009258526407],
            [33.29408915805021, 2.330312641989557],
            [33.295017223739904, 2.330267211361866],
            [33.29520765580036, 2.329642920877977],
            [33.29397023997121, 2.328828943262618],
            [33.293517692985574, 2.328666189869078],
            [33.29311380863723, 2.33005048081418],
            [33.29247121137512, 2.329643496222167],
            [33.29080519405256, 2.330295234470335],
            [33.28980546256613, 2.329001706374111],
            [33.289401285367, 2.328974648131166],
            [33.28861628536945, 2.330413300242561],
            [33.287569066242156, 2.330558268937935],
            [33.28697449291514, 2.331345488940292],
            [33.287056886393025, 2.332937762354249],
            [33.2854864282571, 2.333607569859576],
            [33.284177136425456, 2.330368972734567],
            [33.28253501339115, 2.329654583939203],
            [33.281296833095666, 2.327791129087017],
            [33.28023836885767, 2.327918001166884],
            [33.280238226923835, 2.32720327902624],
            [33.27911928989753, 2.325674541183351],
            [33.27897628349416, 2.324525586819955],
            [33.27816725446109, 2.323874354830611],
            [33.27778589806342, 2.322680211373383],
            [33.27454911088957, 2.319469123296779],
            [33.27464389393182, 2.318347261828264],
            [33.273608351106596, 2.314864323989949],
            [33.273869518309134, 2.313715289936139],
            [33.27460753911228, 2.313470874489792],
            [33.274464526420736, 2.31225858836871],
            [33.274821358811145, 2.311652361893201],
            [33.27453563526198, 2.310792941771003],
            [33.27515395285857, 2.310702350330438],
            [33.27508238587651, 2.309788605071614],
            [33.274309007383806, 2.307382223184681],
            [33.2737136695905, 2.307119972490175],
            [33.2741896670966, 2.306495628711105],
            [33.2732379505621, 2.306260588223073],
            [33.27278520594712, 2.305012173401174],
            [33.27180927442582, 2.304532863786385],
            [33.27014329034092, 2.302307591454336],
            [33.27076193222933, 2.300968499426473],
            [33.270773146797325, 2.297847240937584],
            [33.27146328200593, 2.297078104102001],
            [33.27147367551378, 2.289596133419858],
            [33.2742924927556, 2.285660096495234],
            [33.27503021801303, 2.283941001837083],
            [33.277790261180755, 2.284320445836898],
            [33.27790918914122, 2.28307192120102],
            [33.27950313462852, 2.282022144515691],
            [33.27935997371495, 2.280031806625011],
            [33.280906833108325, 2.279678666686038],
            [33.28060900026916, 2.277217909249281],
            [33.28108498160561, 2.276575471049048],
            [33.28108473546721, 2.275308875352432],
            [33.28158437214003, 2.274901657007199],
            [33.28153607601542, 2.272241814329561],
            [33.2819405784047, 2.271137987370972],
            [33.28253525593627, 2.270975021843007],
            [33.28360573783616, 2.269273953434111],
            [33.28508113804533, 2.268622268995936],
            [33.28609217662623, 2.267654027133465],
            [33.2881145610119, 2.267300786325785],
            [33.29037471508022, 2.264133843373546],
            [33.29042160444312, 2.26248726023564],
            [33.29099247482301, 2.2613562559086],
            [33.290480780064144, 2.260442601315743],
            [33.29090878058463, 2.258832129619944],
            [33.290789786148814, 2.256868930715943],
            [33.29014373845773, 2.255548126709271],
            [33.29040826446115, 2.254770078173766],
            [33.291018527762894, 2.252122866686887],
            [33.292266899445245, 2.251193366855435],
            [33.29262591653843, 2.249974663187395],
            [33.2954624925751, 2.248327514671813],
            [33.295507572731005, 2.247305525697142],
            [33.296518135204806, 2.247164725228781],
            [33.29623490537889, 2.246566353381732],
            [33.297173040284605, 2.245974917239401],
            [33.297166251716014, 2.244561784320303],
            [33.29780331445763, 2.244011566371408],
            [33.297264741207115, 2.24312919935715],
            [33.29743718001245, 2.24236774940818],
            [33.298568297295695, 2.241098241598896],
            [33.2983877485, 2.240519264124653],
            [33.29973877785638, 2.239315721489754],
            [33.29979870626562, 2.238257198066488],
            [33.30031641524535, 2.238276238592356],
            [33.300368539091366, 2.237623782680289],
            [33.29975349315907, 2.236719050037502],
            [33.29998274052462, 2.235610356113718],
            [33.298524196303454, 2.234714625479365],
            [33.29805559552539, 2.231756303594657],
            [33.296690115869325, 2.231599162898109],
            [33.29649440890154, 2.230915263476476],
            [33.2969493211513, 2.230476035632727],
            [33.29653039002194, 2.229663851060838],
            [33.296991784514795, 2.226820759444032],
            [33.300050106984415, 2.220831617773603],
            [33.29923963525697, 2.219846452449516],
            [33.29835258664315, 2.216733927849931],
            [33.297542814703334, 2.215477159736135],
            [33.29768239852542, 2.213419409527729],
            [33.29729153525711, 2.211025769748383],
            [33.29894492316508, 2.205527362389425],
            [33.300413735129965, 2.203199147774386],
            [33.30009565606088, 2.201770370896312],
            [33.29926532887075, 2.200896270253033],
            [33.29916789130681, 2.200119886716917],
            [33.29818844557613, 2.199487218897696],
            [33.29774059767774, 2.197751820361924],
            [33.297013997156824, 2.196649344033299],
            [33.29656595881562, 2.193928761493563],
            [33.296813623441125, 2.192810072446454],
            [33.30123378289831, 2.185132942280895],
            [33.301090910343945, 2.184167361892306],
            [33.30191422797995, 2.18247085304063],
            [33.30435258713937, 2.179513911930636],
            [33.30437888262437, 2.177966345820223],
            [33.307680402397594, 2.174799183524904],
            [33.31128215980006, 2.172156686513775],
            [33.314508685518426, 2.170681336747461],
            [33.32300791052617, 2.171674712259482],
            [33.32912401198467, 2.17024394395282],
            [33.33231314083774, 2.170089441311301],
            [33.343626887343646, 2.172258193216325],
            [33.352238914699925, 2.17491603299406],
            [33.35512871412055, 2.178235623258162],
            [33.358751026773334, 2.184450086999559],
            [33.36010249450757, 2.185508267312061],
            [33.36100346341505, 2.187733625028616],
            [33.366426981755815, 2.195069456641372],
            [33.3670284020419, 2.197376305404094],
            [33.3679668540529, 2.198805506594173],
            [33.36995589207689, 2.200505855049389],
            [33.37051887345197, 2.201898959551892],
            [33.372094924498825, 2.201862375743885],
            [33.37295778597363, 2.202169757798911],
            [33.37310800944198, 2.202766824519824],
            [33.37385892376437, 2.202694259269704],
            [33.373971179038925, 2.202051890721224],
            [33.37595994397506, 2.20262135021553],
            [33.37652255165098, 2.202503596277651],
            [33.376560078771995, 2.201978858657254],
            [33.37723577715564, 2.202313426969626],
            [33.377273256665944, 2.201598701208761],
            [33.37924268626392, 2.201281551680466],
            [33.38115600259767, 2.199127866630987],
            [33.37995481133234, 2.196748805120009],
            [33.379354526516785, 2.196785147584183],
            [33.37939152722503, 2.19640516205981],
            [33.380404802611004, 2.195843987349876],
            [33.37969185378745, 2.194894230566867],
            [33.38005849578076, 2.19350493367321],
            [33.378089266507104, 2.191140235622625],
            [33.378640357781066, 2.19064215806688],
            [33.37886508572245, 2.189612277395694],
            [33.37818970893562, 2.187948886697136],
            [33.378908988187, 2.185255316955032],
            [33.382001623605554, 2.181633170136452],
            [33.38227169221423, 2.181972603846563],
            [33.38284536623613, 2.181825338476662],
            [33.382687776582486, 2.181429293536532],
            [33.384408487831124, 2.1797652905441],
            [33.38565367318914, 2.17919609973771],
            [33.38771408595574, 2.178971258721897],
            [33.388594193287354, 2.17789386554475],
            [33.38898685228794, 2.178109196845035],
            [33.38947453957084, 2.177750015396744],
            [33.39071109481397, 2.174877257319636],
            [33.39168642356569, 2.1739913348629],
            [33.39182018810141, 2.173063786962929],
            [33.39141181756649, 2.171812232617871],
            [33.39193678403538, 2.171812095274342],
            [33.392343062393984, 2.170875403261443],
            [33.392165630752324, 2.170282176655301],
            [33.3928389962112, 2.16994203115352],
            [33.39217396532152, 2.169196230544375],
            [33.39277832040366, 2.167230160684631],
            [33.393301730990466, 2.167124707475034],
            [33.39319271504084, 2.166381667618029],
            [33.394290008058704, 2.165433530493174],
            [33.394031931060745, 2.164471152966718],
            [33.395374538711344, 2.162518117507288],
            [33.39572435975097, 2.162528859092506],
            [33.39553629924288, 2.161244231031634],
            [33.39642242708351, 2.16019031294217],
            [33.39699918232686, 2.15848450595503],
            [33.39864992649297, 2.158411695298661],
            [33.39864977737262, 2.157841732534351],
            [33.40056365066184, 2.158103589754869],
            [33.40075054066514, 2.157054086964439],
            [33.40247636692099, 2.156103691737066],
            [33.40303970762218, 2.156709691576809],
            [33.404390168345, 2.156103180957555],
            [33.405384150613614, 2.15499013181935],
            [33.40534636387951, 2.154501603532652],
            [33.40748521484177, 2.153252541992775],
            [33.409059958839876, 2.150646579039994],
            [33.40998798141044, 2.150515397994373],
            [33.41245186530035, 2.147754849151395],
            [33.41303678083973, 2.147551425813977],
            [33.413599071410346, 2.146348021130798],
            [33.41438700710224, 2.146121631228645],
            [33.415928239448704, 2.142873336895207],
            [33.41830676542031, 2.139119400594173],
            [33.41966588320753, 2.137913731594384],
            [33.42050471834174, 2.137661010296505],
            [33.421020032412905, 2.13643256752967],
            [33.42177908098021, 2.136057520322935],
            [33.421792188298525, 2.134685907891235],
            [33.422271319128335, 2.134331567321635],
            [33.421806520918885, 2.133446172465939],
            [33.42207540824298, 2.133205039646599],
            [33.421918597428686, 2.131999787921824],
            [33.42337051926958, 2.130434964717836],
            [33.42288629768702, 2.130051371791717],
            [33.423810085599335, 2.128467015447395],
            [33.42453385283387, 2.12860948241042],
            [33.42466561951638, 2.127645210902015],
            [33.425102746021814, 2.127539203775155],
            [33.42496359339106, 2.126479190456238],
            [33.425437940692, 2.126528254964166],
            [33.42542797298561, 2.125839518613709],
            [33.426454428453425, 2.124191178111231],
            [33.42712429587258, 2.123945013143724],
            [33.427187685490594, 2.123285774014708],
            [33.42784294630325, 2.123270832720507],
            [33.42833641783827, 2.121740711108895],
            [33.429187032580806, 2.120835272362336],
            [33.42925525962662, 2.119989088497129],
            [33.430008263430395, 2.11977241771049],
            [33.43084109332694, 2.118251667335276],
            [33.434543795316166, 2.11446061835542],
            [33.43515691526052, 2.114234270447071],
            [33.43594563338502, 2.112849859810807],
            [33.43706670930004, 2.112171019959005],
            [33.437528953599156, 2.111058106896118],
            [33.441379270349124, 2.116313304291855],
            [33.44423137735875, 2.119406548135173],
            [33.448828952287954, 2.123612050585831],
            [33.452848915879315, 2.125754028229768],
            [33.45512686647172, 2.127892815183508],
            [33.45496695287642, 2.133028125043834],
            [33.454341866474174, 2.13652947864077],
            [33.45548240977973, 2.140862632302111],
            [33.45586730643792, 2.144300359768712],
            [33.4580735148768, 2.148642231291523],
            [33.459364968861884, 2.150062210946149],
            [33.46394056560931, 2.153616264331901],
            [33.46640824937287, 2.156383868195097],
            [33.46815241653189, 2.162281931878835],
            [33.46847592681517, 2.165185893692399],
            [33.467939876034, 2.165665549527303],
            [33.46912224849244, 2.166868423667339],
            [33.46905567165179, 2.167863608697868],
            [33.46944529704163, 2.168261552184906],
            [33.46910435405196, 2.168985413261355],
            [33.46958009643655, 2.169781392000741],
            [33.469769686775564, 2.172169725167607],
            [33.47034204296896, 2.172757593741465],
            [33.47020233068775, 2.173535676360614],
            [33.47066567991469, 2.174223094953144],
            [33.47074561021202, 2.176412426226505],
            [33.47120861538421, 2.177796459761757],
            [33.47094077100414, 2.178628862934904],
            [33.47142817082617, 2.1789272596347],
            [33.47211733495594, 2.180980691131416],
            [33.47541393555466, 2.184933153211686],
            [33.47629743582312, 2.186525129327936],
            [33.47688264151833, 2.186832536977331],
            [33.477729622575545, 2.188460714607506],
            [33.47865672706787, 2.19105687995222],
            [33.47867016586452, 2.196204571092566],
            [33.47794673639656, 2.199570256328642],
            [33.47481174271744, 2.207333524290378],
            [33.47225408818658, 2.208365692504811],
            [33.46916628660261, 2.210836490200458],
            [33.46555443303467, 2.210900964564638],
            [33.46423888892866, 2.211751791444255],
            [33.46289555004939, 2.211797444824467],
            [33.46004257706384, 2.213978652162054],
            [33.45875149138803, 2.215797490176002],
            [33.4577343146188, 2.216367762153067],
            [33.456577739978705, 2.218774610178888],
            [33.45493948958156, 2.219426500850989],
            [33.454282231814055, 2.220638993074647],
            [33.45336839633675, 2.220983058703617],
            [33.453441803068536, 2.222077715580901],
            [33.45180341612746, 2.22229535012874],
            [33.45168165308399, 2.222982957211037],
            [33.4492213112512, 2.224422175622289],
            [33.44775933726228, 2.224386436150146],
            [33.44513483100629, 2.22760795179581],
            [33.44355719712792, 2.228006497828718],
            [33.443276935335675, 2.228739383483088],
            [33.44238789515689, 2.229318658232063],
            [33.44253423520826, 2.229969997584698],
            [33.44120126827727, 2.232829240515308],
            [33.44083595668889, 2.232974102356435],
            [33.44080646230316, 2.23585104073293],
            [33.44119622423693, 2.23663800833012],
            [33.440655068329995, 2.238954194072981],
            [33.44138617749534, 2.240283876281033],
            [33.44119755194694, 2.241071020126327],
            [33.442800195821135, 2.24340464692878],
            [33.44390552247262, 2.24611945463573],
            [33.444883882140104, 2.246245327700758],
            [33.4449589651282, 2.245677527699993],
            [33.44575548422264, 2.245891776498976],
            [33.44581225146038, 2.245305145073388],
            [33.44674143645093, 2.244979779094544],
            [33.446840268200155, 2.244591546009613],
            [33.44813652727368, 2.244650870113449],
            [33.44815618600536, 2.244222846066909],
            [33.448532209105196, 2.244272500058283],
            [33.44865078133281, 2.243724998218502],
            [33.449224594593595, 2.243416250549982],
            [33.44934355040181, 2.244122940259979],
            [33.45002643081617, 2.244540793334758],
            [33.45030336704524, 2.24414255070222],
            [33.451312704217, 2.244311454343541],
            [33.45159194192983, 2.243589617274945],
            [33.451829696341115, 2.244125771373388],
            [33.45232618441888, 2.244082719418876],
            [33.45270968419682, 2.242723852518663],
            [33.453072581113695, 2.242801533173365],
            [33.45312629318118, 2.243361038424434],
            [33.45480360771674, 2.242612491987956],
            [33.45501196296376, 2.24309415330817],
            [33.45571694642568, 2.24327944235111],
            [33.45646623928901, 2.242474333682417],
            [33.45712660882065, 2.242665620748987],
            [33.457392818266904, 2.241718239537787],
            [33.45802579636892, 2.241823362521377],
            [33.457711540529715, 2.241301641438393],
            [33.45804931336473, 2.240932908351973],
            [33.458206476318665, 2.241306272301552],
            [33.45874898778335, 2.24126301470724],
            [33.4583969784477, 2.241761010604382],
            [33.45872068815696, 2.242076873218487],
            [33.45899655628913, 2.241588476661441],
            [33.459125210309175, 2.242105468940145],
            [33.45986765621339, 2.242244068015609],
            [33.46033374799687, 2.241319962026982],
            [33.46051954385214, 2.241942258696407],
            [33.460852508005466, 2.241415545048954],
            [33.46154262345114, 2.2416163946836],
            [33.46194692282117, 2.24093167590834],
            [33.461252022948294, 2.240649442697721],
            [33.46125190886226, 2.240285605113883],
            [33.46241308197829, 2.24022778884932],
            [33.46234627067737, 2.239634178779372],
            [33.46363118582545, 2.23960504622726],
            [33.464837929577534, 2.238449193016178],
            [33.46529206568291, 2.239033980766396],
            [33.46607236569488, 2.238751526373279],
            [33.46589374288716, 2.238428331201688],
            [33.4673878325458, 2.237227201475851],
            [33.46797456447868, 2.237745242828119],
            [33.468020739680924, 2.238596972496802],
            [33.46869911684079, 2.238596754372767],
            [33.46877031192031, 2.237924572283811],
            [33.46956610876924, 2.238257829997952],
            [33.47028465679198, 2.236271906822483],
            [33.47087630340778, 2.236210143515338],
            [33.47086086226636, 2.235774015878339],
            [33.472278572667975, 2.234998778071762],
            [33.472686750963405, 2.235414255922846],
            [33.47350794408374, 2.235419119291195],
            [33.47308471541404, 2.235788687664199],
            [33.47336020715213, 2.235978445142156],
            [33.47423232846085, 2.23574213649724],
            [33.47446663154483, 2.234736387671667],
            [33.47555800107173, 2.234269113549348],
            [33.476603868234534, 2.235048681019796],
            [33.47740957170443, 2.234473747682907],
            [33.47792490913179, 2.23503285576952],
            [33.478843074488736, 2.235232662332959],
            [33.48015888539442, 2.234816620717585],
            [33.480500400610914, 2.23413408809229],
            [33.4808575177673, 2.234375126620691],
            [33.481107085922886, 2.23327188404708],
            [33.48178030226143, 2.233097209148067],
            [33.482933184825704, 2.23357913929382],
            [33.48274464012568, 2.234117954046616],
            [33.483882021361424, 2.233989303561947],
            [33.48418826692325, 2.234635703868427],
            [33.487254579907315, 2.233299086814095],
            [33.487582315865666, 2.232523720237159],
            [33.48882770334466, 2.231747207870308],
            [33.49051307037844, 2.231746338960693],
            [33.49121591225672, 2.230996380900861],
            [33.49171352502521, 2.230972682455849],
            [33.49228028920594, 2.232327303667167],
            [33.495323432842206, 2.235380163871826],
            [33.496730723684834, 2.238661487836021],
            [33.49898163947881, 2.241659606488445],
            [33.50869377876631, 2.25126854897775],
            [33.52156456078111, 2.258367271514607],
            [33.535411526743836, 2.266820717304225],
            [33.53871107022345, 2.269950536393115],
            [33.54226708002172, 2.275603778732747],
            [33.545307895224774, 2.279854053175191],
            [33.546297346391086, 2.280615154030006],
            [33.54803680727632, 2.283411771309225],
            [33.54905401279166, 2.286462558380634],
            [33.54905598818698, 2.291648057428511],
            [33.54762790853204, 2.298855671900217],
            [33.54620395214426, 2.312240060442495],
            [33.54519251291472, 2.316469675797759],
            [33.54386059252106, 2.31801946467428],
            [33.54616652024467, 2.329229039216571],
            [33.54115272170839, 2.341764438836099],
            [33.53833358646293, 2.34618705543104],
            [33.53708955633835, 2.351374996858925],
            [33.53627648308987, 2.352158651733369],
            [33.53498325762708, 2.352030978532045],
            [33.53437552487949, 2.351518857593693],
            [33.53257506658982, 2.351484039491589],
            [33.53175143274683, 2.351744765949412],
            [33.531339928888244, 2.352703704739849],
            [33.529915884465545, 2.352278124830186],
            [33.52902160890527, 2.352444182984392],
            [33.52838588914501, 2.351734215147193],
            [33.52792716085191, 2.352290720266153],
            [33.52750330785309, 2.351710877723778],
            [33.526291659299545, 2.352823999953057],
            [33.525715050481594, 2.35283605595175],
            [33.5254911193459, 2.351912867907988],
            [33.52480832606811, 2.351191079845562],
            [33.52391418076355, 2.351712239320295],
            [33.52367928838475, 2.352943358105426],
            [33.52270248998918, 2.352718826797878],
            [33.52231387610233, 2.351961415952305],
            [33.52153715408013, 2.351807830215445],
            [33.52101954571171, 2.352257824753295],
            [33.51964401390766, 2.352490864089206],
            [33.51956374314879, 2.353321679607068],
            [33.51835508059526, 2.353362658498892],
            [33.518032474017176, 2.352572519443385],
            [33.518152646144316, 2.350688009587528],
            [33.517246012460674, 2.350343876313802],
            [33.51674203961996, 2.349371436596515],
            [33.516278676918304, 2.349270293226735],
            [33.51561403949075, 2.349635276187132],
            [33.51589635483172, 2.350425431266964],
            [33.51450614006431, 2.349777527776248],
            [33.51400268734815, 2.350223502799089],
            [33.51323702179046, 2.349757734784346],
            [33.51225052877639, 2.351379147171325],
            [33.510639136209626, 2.35186605484269],
            [33.50918878013227, 2.352028694245675],
            [33.50799995327852, 2.351218606185604],
            [33.505865140243486, 2.35265806660462],
            [33.50320601561138, 2.352577981982197],
            [33.502783188488614, 2.353165766652735],
            [33.50328727900862, 2.354482686109938],
            [33.50296508026567, 2.354807012876361],
            [33.50151460291575, 2.35464543381206],
            [33.5009300583806, 2.353673015942112],
            [33.500366028671564, 2.353734009456065],
            [33.49954038619563, 2.354544831153922],
            [33.498866551816164, 2.353857901990098],
            [33.49900915397763, 2.353360272790713],
            [33.49977076454013, 2.353170013896047],
            [33.49913962888276, 2.351957961249507],
            [33.49835439442493, 2.352102993237929],
            [33.49764031013084, 2.351578530892882],
            [33.496973781749595, 2.352003973689522],
            [33.49733087465145, 2.352410954481027],
            [33.49699821502701, 2.352745808290023],
            [33.49573659678746, 2.352149166336128],
            [33.495427751501204, 2.35306301154412],
            [33.49471387831124, 2.353135641023798],
            [33.49376191563836, 2.353923059264112],
            [33.494190686015024, 2.355144234761332],
            [33.493405464133616, 2.355334499669343],
            [33.49145409875768, 2.354692865200622],
            [33.48985919925953, 2.352657881707668],
            [33.488145741008516, 2.352368985554455],
            [33.487646144759864, 2.352749131049847],
            [33.487598605016736, 2.353445757972167],
            [33.48649243574555, 2.353717553638739],
            [33.48649291005601, 2.355083633541322],
            [33.48511245368754, 2.355445993218542],
            [33.48527997062341, 2.35707437478929],
            [33.48431460149322, 2.357219462791146],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 687,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "OMORO",
        Population: 43229,
        Key: "ALEBTONGOMORO",
        Dist2: "Alebtong",
        "Sub Country": "Omoro",
        id2_original: "Alebtong Omoro",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.18299353219106, 2.585798502368979],
            [33.1574323148362, 2.619118630823101],
            [33.10056163967514, 2.599205406184229],
            [33.081584645754795, 2.59251953765867],
            [33.07299198338108, 2.58878583597886],
            [33.070694931910786, 2.585614265114179],
            [33.06990929141443, 2.582191266289148],
            [33.06862384356535, 2.579247036586846],
            [33.06694574480052, 2.577415914891111],
            [33.06449414447382, 2.576745797033352],
            [33.06311359468055, 2.575477183282902],
            [33.061661674636284, 2.574830948030898],
            [33.06047152995402, 2.57325113414422],
            [33.05901961440135, 2.57279639964001],
            [33.05749626302062, 2.571503847118029],
            [33.05657983590375, 2.569792370715555],
            [33.05327128322015, 2.565986464548268],
            [33.05122432362328, 2.564837550830821],
            [33.05060545535941, 2.564071583249801],
            [33.04748743085602, 2.562491831437133],
            [33.046249765295215, 2.562491876307975],
            [33.043655401110264, 2.561678098299531],
            [33.039513876596345, 2.558231249122514],
            [33.03464647740021, 2.555945372964285],
            [33.03381337531414, 2.553599530505336],
            [33.03169504187299, 2.55233090097976],
            [33.030647751778794, 2.550391996749012],
            [33.02969569657941, 2.549769641901609],
            [33.02919583981936, 2.548453101262294],
            [33.027696362065626, 2.54780682814302],
            [33.02667292583549, 2.547854718451521],
            [33.023376433034585, 2.544826702029823],
            [33.02185316250223, 2.544324046365037],
            [33.0218055293343, 2.54262448838131],
            [33.017116723301505, 2.540565943614384],
            [33.015712456188105, 2.539369094113553],
            [33.01410586511653, 2.535981964271623],
            [33.01396303837625, 2.534043036364777],
            [33.01182095347901, 2.531697190860747],
            [33.01067851113495, 2.530955147237229],
            [33.008655452114496, 2.53045247092253],
            [33.00787002541718, 2.530955167878341],
            [33.00763202127423, 2.530332791099743],
            [33.00659562055792, 2.530396206859689],
            [33.003419270239725, 2.529110650346242],
            [33.00310976648836, 2.52810641250871],
            [33.004002283147344, 2.526586481382458],
            [33.00562090535552, 2.525555095744968],
            [33.00975007623765, 2.520760058519728],
            [33.01010706044337, 2.517693057329113],
            [33.00989283650261, 2.515159844145167],
            [33.01032123407845, 2.514083225122453],
            [33.01034511579029, 2.512400446672315],
            [33.0114757066608, 2.510455290275065],
            [33.012546709583546, 2.509423899944939],
            [33.01287980129763, 2.507578268686951],
            [33.011332864649134, 2.505732655466891],
            [33.01014266337303, 2.505235069666965],
            [33.00895274057463, 2.504113225871284],
            [33.00735803511258, 2.503706112175123],
            [33.004787619114815, 2.50382373746992],
            [33.00325250429546, 2.501417188159173],
            [33.0015152820119, 2.500123442477562],
            [33.001443879421544, 2.499191581397086],
            [33.002181493287836, 2.498277813375852],
            [33.00334778859762, 2.497997347663646],
            [33.00732230552049, 2.498522069157667],
            [33.00999997946486, 2.497112053494398],
            [33.01077340556831, 2.498277770297709],
            [33.014367341339536, 2.501389971807622],
            [33.01612846689449, 2.502348953425568],
            [33.01667605923044, 2.502493701835667],
            [33.02113855988024, 2.501073227856018],
            [33.0235183929006, 2.501688395849611],
            [33.02808808232674, 2.504900059806339],
            [33.03152741444435, 2.505705181634973],
            [33.0333838251998, 2.505578474249729],
            [33.033788297046335, 2.50409472388792],
            [33.034883169104525, 2.503045220531121],
            [33.03533515374479, 2.501896215059565],
            [33.036644221895955, 2.500747185247257],
            [33.038191120815206, 2.50031287477361],
            [33.03876229302902, 2.49928147825142],
            [33.039000354664154, 2.498186760522344],
            [33.04018650633498, 2.49652931855468],
            [33.040223214192444, 2.494618789683249],
            [33.041706018316184, 2.492091916440531],
            [33.04190067335677, 2.490314783304831],
            [33.042719266752705, 2.488503320513705],
            [33.04367185555133, 2.487819633601291],
            [33.045264499379805, 2.487719775856615],
            [33.046395693019875, 2.486821503651564],
            [33.049595911575146, 2.48794417710752],
            [33.05491060710406, 2.49349925765799],
            [33.05529380864133, 2.495388624173457],
            [33.05449413196867, 2.496964834674321],
            [33.054208624015175, 2.499208550586562],
            [33.055969854672995, 2.502058341913489],
            [33.05744570673473, 2.503379167378367],
            [33.05884981394802, 2.503234349961744],
            [33.059801865554114, 2.50218483155668],
            [33.06199132580284, 2.501008594612347],
            [33.06541848125676, 2.49985943389082],
            [33.06783427293963, 2.499678366758711],
            [33.07023803977412, 2.500709619375408],
            [33.07218973034018, 2.500537616705846],
            [33.07295121154529, 2.50003997867606],
            [33.0730225835929, 2.499533331748017],
            [33.07097576682814, 2.497552110578376],
            [33.06951511515933, 2.496918194452039],
            [33.06876346062513, 2.495334690209573],
            [33.06897626343111, 2.494492651117172],
            [33.07060500426262, 2.492530939529414],
            [33.07117604083084, 2.489518194137921],
            [33.07587236845753, 2.492579866649047],
            [33.07889689989943, 2.492518723230527],
            [33.0832312953998, 2.495092272738253],
            [33.08505250297593, 2.493608152433605],
            [33.08664325046083, 2.493468922452429],
            [33.0880033545982, 2.491845702988632],
            [33.08844130485876, 2.490593546365921],
            [33.09010113728062, 2.489364492060199],
            [33.08980133982589, 2.488019634462914],
            [33.08777236719594, 2.485144515728658],
            [33.0855820724123, 2.483034593403118],
            [33.0849880443627, 2.481676050076492],
            [33.087171839835236, 2.477449891604738],
            [33.08724139189611, 2.475779991734152],
            [33.088495263962955, 2.475009187303211],
            [33.08937768176147, 2.475429520726558],
            [33.090678143153916, 2.476865775738422],
            [33.09228043399022, 2.477659740239573],
            [33.09448658673355, 2.48012355409434],
            [33.09622821974513, 2.481057635548183],
            [33.09759844430253, 2.483684989297865],
            [33.1024517938476, 2.48597342632469],
            [33.10334576577732, 2.485529608561003],
            [33.10360113794799, 2.484782223026328],
            [33.102161295752694, 2.482902245017679],
            [33.10185927766261, 2.480998822333603],
            [33.10216105320758, 2.479749297583593],
            [33.101475905445426, 2.478009390364735],
            [33.101440973557295, 2.476689826447541],
            [33.10182406550009, 2.476012496533344],
            [33.10271805629444, 2.475895651355505],
            [33.103263684913166, 2.475124888275746],
            [33.10377454423883, 2.475148203836119],
            [33.10481967029152, 2.477588735566233],
            [33.108558471978775, 2.480671314566161],
            [33.11057889893544, 2.483216858256166],
            [33.1111595483755, 2.484723217021338],
            [33.11284319783046, 2.486276190437199],
            [33.11434123558478, 2.489604170618441],
            [33.11733685205431, 2.490795017754329],
            [33.11826570107494, 2.490876677337572],
            [33.120668954971386, 2.489533537241207],
            [33.123339536716635, 2.49130827968352],
            [33.128308759051876, 2.490490371794216],
            [33.128297083648135, 2.489824751030552],
            [33.12544064855546, 2.487162541932327],
            [33.12418653124854, 2.485189151419047],
            [33.12489959685308, 2.480706608606758],
            [33.12637068425059, 2.47984439483121],
            [33.12724060648352, 2.479985844805771],
            [33.12858396422739, 2.481195189462289],
            [33.129799706403674, 2.485582635584027],
            [33.131565279517595, 2.48722940427188],
            [33.13265269555891, 2.487486630528835],
            [33.133241142375645, 2.487242102560654],
            [33.134980653566544, 2.484153903665912],
            [33.13693771515972, 2.481850551080993],
            [33.137539138140724, 2.48342023251346],
            [33.139394034336604, 2.482853899100855],
            [33.13953486142707, 2.483870358414339],
            [33.1406222729768, 2.484088977015801],
            [33.14214493265477, 2.487048165780005],
            [33.145420112925535, 2.489016419996474],
            [33.146865745661145, 2.489389394989394],
            [33.14857062410288, 2.488043426351596],
            [33.14870528785217, 2.487094568522668],
            [33.14971590242828, 2.485671190752606],
            [33.14941254225516, 2.48453600461948],
            [33.14848593003957, 2.483909195586064],
            [33.14679846274468, 2.483686159600565],
            [33.14565377101916, 2.480534810641603],
            [33.14413826821907, 2.479273794191081],
            [33.14194128457984, 2.47644917178482],
            [33.13873217090665, 2.473949586596601],
            [33.13688862222941, 2.473498593050216],
            [33.13586829417015, 2.469127262453982],
            [33.13651153642261, 2.468480160350953],
            [33.138410028757555, 2.467959178400138],
            [33.14156388885425, 2.468700568377756],
            [33.142976160855156, 2.469915580151024],
            [33.14478053490114, 2.469631319251591],
            [33.14655362062579, 2.470199252242383],
            [33.147453476520596, 2.470076176241995],
            [33.15031513890991, 2.472830258730218],
            [33.15160394555985, 2.472899970391646],
            [33.15101728549217, 2.471658110556],
            [33.1512024668998, 2.471347607721386],
            [33.152769074856394, 2.471215472665745],
            [33.15457504700526, 2.472193279304639],
            [33.15520808709103, 2.47405609479514],
            [33.15582549379593, 2.474203500153374],
            [33.15619587367913, 2.473737734203004],
            [33.156967752883645, 2.474956282810712],
            [33.15778582346008, 2.475196807610371],
            [33.15790944062633, 2.476376623387248],
            [33.159044023609944, 2.477455409284979],
            [33.15958444918654, 2.479194041023359],
            [33.16080398404996, 2.480730775771081],
            [33.16166059684366, 2.480575429396278],
            [33.162146838737264, 2.480947948164971],
            [33.163574378504705, 2.479488508642193],
            [33.16506215929514, 2.48013812996667],
            [33.16506223205867, 2.480724720517947],
            [33.1660255988441, 2.481337552022429],
            [33.16719193278143, 2.480533315450672],
            [33.16805046707151, 2.481258203739486],
            [33.168823734173145, 2.481363558994826],
            [33.16906626941839, 2.481950117590993],
            [33.169747790681726, 2.4820159391263],
            [33.17027867345505, 2.482721095679002],
            [33.171124040239725, 2.482938485831597],
            [33.174066285103265, 2.482516281768655],
            [33.17476081127698, 2.481817554600994],
            [33.17514091003325, 2.482008640879596],
            [33.17512794105548, 2.483043412858939],
            [33.17598643312474, 2.483412387714288],
            [33.176477818771694, 2.482726868219288],
            [33.17812258375126, 2.48243664726282],
            [33.17847658285528, 2.483458187483852],
            [33.17896066430063, 2.483689246902208],
            [33.17864456691508, 2.484329066676753],
            [33.181163005492216, 2.486000786590331],
            [33.18079790051634, 2.486669663508457],
            [33.181604637947125, 2.486927214758395],
            [33.18137581009482, 2.487672822090202],
            [33.18185551494812, 2.487990722516121],
            [33.181419568828936, 2.488785698958859],
            [33.181926499821856, 2.488911719605915],
            [33.1817249529064, 2.489849199832641],
            [33.1822482332375, 2.48995328807613],
            [33.18198670760715, 2.490731793925307],
            [33.18268998337172, 2.491718488095043],
            [33.18319685687247, 2.491416897323341],
            [33.183316888862436, 2.492255654557562],
            [33.183960165250845, 2.492929871808321],
            [33.18618953854598, 2.493176255575767],
            [33.188146551630076, 2.494645198457571],
            [33.189601776576296, 2.493844590372595],
            [33.19064569619155, 2.493767461374487],
            [33.19231470041243, 2.494527177456167],
            [33.194249617635485, 2.493305526420425],
            [33.19434620988475, 2.492581740556698],
            [33.195217042111075, 2.492482092282398],
            [33.195652366596065, 2.491803491578943],
            [33.198567029587124, 2.491771950140099],
            [33.19915133337378, 2.492122614253979],
            [33.20027442151503, 2.491316167514102],
            [33.20145208680138, 2.492022047837517],
            [33.202172124230835, 2.491461643189746],
            [33.20311417040132, 2.491456942262216],
            [33.202869458538146, 2.490527712693934],
            [33.203485368649744, 2.490245193719731],
            [33.20505885500649, 2.49115455089064],
            [33.20508691208773, 2.492664818921775],
            [33.205982522544524, 2.493787351881023],
            [33.20714369386393, 2.496967639244197],
            [33.20902950468202, 2.499925752621628],
            [33.20912341096856, 2.501807541621087],
            [33.211325435953164, 2.50452132664381],
            [33.21139588004112, 2.505579830306437],
            [33.212625776073, 2.50775998897211],
            [33.2116427155216, 2.512727024848945],
            [33.212006474821195, 2.516273441670878],
            [33.213435328823884, 2.517992162402062],
            [33.21596573026567, 2.52414379091464],
            [33.22143564209927, 2.531615790496454],
            [33.22098033638741, 2.538763096851604],
            [33.22055896812866, 2.540509264480121],
            [33.21893159093974, 2.543657942455336],
            [33.21937717508359, 2.547113866918326],
            [33.22662705014364, 2.553608436533537],
            [33.226346049037915, 2.554241783849142],
            [33.22676833447657, 2.557751990856276],
            [33.22606595073908, 2.560031989291431],
            [33.226160106757284, 2.561542841308646],
            [33.22553957750847, 2.562520040843282],
            [33.22493120336376, 2.565487602463544],
            [33.224088050926305, 2.566600547238915],
            [33.2197085114896, 2.568012662596681],
            [33.21328021852043, 2.571325006616642],
            [33.21032918543845, 2.572121646023524],
            [33.20723743575877, 2.571977400778381],
            [33.204123227298695, 2.577306665513602],
            [33.201490019062554, 2.586390405234366],
            [33.200662402089634, 2.595674405989419],
            [33.19927286375364, 2.595319020123962],
            [33.198130135745345, 2.593763287304141],
            [33.19517861936973, 2.593117440959321],
            [33.19434528462001, 2.591322270145437],
            [33.19320268327414, 2.590508582354722],
            [33.192131623757504, 2.590652369618858],
            [33.19170307526472, 2.589814630240519],
            [33.190846228909045, 2.589886577309168],
            [33.18763263533752, 2.587421514038638],
            [33.18635901919904, 2.585829879083302],
            [33.184978587983416, 2.586189142586627],
            [33.18328855959163, 2.585399456974379],
            [33.18299353219106, 2.585798502368979],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 688,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "OKWANG",
        Population: 22124,
        Key: "OTUKEOKWANG",
        Dist2: "Otuke",
        "Sub Country": "Okwang",
        id2_original: "OtukeOkwang",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.63887992403816, 2.480833676478855],
            [33.63454035154679, 2.477746647276473],
            [33.62734671641341, 2.471159431329745],
            [33.61460028279349, 2.489754247797892],
            [33.615035612668365, 2.492939449556009],
            [33.60900554915284, 2.493989529982521],
            [33.6060995755655, 2.495823582448991],
            [33.60777675086221, 2.499659050716076],
            [33.60385780821441, 2.503430460690429],
            [33.593258523295034, 2.510926006147573],
            [33.591273262686805, 2.514002736362889],
            [33.59007355813328, 2.514768672603876],
            [33.57169014040995, 2.507648372492479],
            [33.55553354296971, 2.507707565933794],
            [33.5438978294862, 2.506702185292858],
            [33.542815507790856, 2.505614528665368],
            [33.5407244975074, 2.504832557581421],
            [33.54005205102507, 2.504108524989034],
            [33.540291906595805, 2.50362555098022],
            [33.53981154327741, 2.502998013331331],
            [33.53910174933712, 2.497754366180035],
            [33.538908362717706, 2.488037138687641],
            [33.536632687557905, 2.482131397168851],
            [33.52563894251577, 2.466511871119522],
            [33.52089921009123, 2.456796396939485],
            [33.52051788513456, 2.450508812486162],
            [33.52297787303109, 2.443648525545282],
            [33.526385880894736, 2.438883746602301],
            [33.52753923058298, 2.434037905203541],
            [33.527343846110355, 2.433204153498854],
            [33.51922041782701, 2.427023164440998],
            [33.51803185867119, 2.425498557069574],
            [33.514639061081965, 2.423361619729406],
            [33.512699931658524, 2.421098340548982],
            [33.51158998317491, 2.420752870546056],
            [33.50954139133915, 2.418348125155365],
            [33.507320278951426, 2.414371202479734],
            [33.50447393732927, 2.410394507803157],
            [33.50389485544934, 2.408413702918684],
            [33.50375244283242, 2.403697041017565],
            [33.50412612312599, 2.399703417448345],
            [33.50495348138411, 2.396747302409727],
            [33.50306053614608, 2.392377180600879],
            [33.50176146444741, 2.387692386952465],
            [33.49847719232763, 2.38274103352455],
            [33.49617876014672, 2.380792290055637],
            [33.49508390515654, 2.378843108523531],
            [33.49464554795915, 2.376893687285525],
            [33.48846861169129, 2.369003242909845],
            [33.486684384162174, 2.362337564134342],
            [33.48632467626452, 2.36175596118936],
            [33.48566828267633, 2.362023473011989],
            [33.48519923274061, 2.361646300050098],
            [33.4852298769699, 2.359869653396703],
            [33.484369599948174, 2.358156209367687],
            [33.48431460149322, 2.357219462791146],
            [33.48527997062341, 2.35707437478929],
            [33.48511245368754, 2.355445993218542],
            [33.48649291005601, 2.355083633541322],
            [33.48649243574555, 2.353717553638739],
            [33.487598605016736, 2.353445757972167],
            [33.487646144759864, 2.352749131049847],
            [33.488145741008516, 2.352368985554455],
            [33.48985919925953, 2.352657881707668],
            [33.49145409875768, 2.354692865200622],
            [33.493405464133616, 2.355334499669343],
            [33.494190686015024, 2.355144234761332],
            [33.49376191563836, 2.353923059264112],
            [33.49471387831124, 2.353135641023798],
            [33.495427751501204, 2.35306301154412],
            [33.49573659678746, 2.352149166336128],
            [33.49699821502701, 2.352745808290023],
            [33.49733087465145, 2.352410954481027],
            [33.496973781749595, 2.352003973689522],
            [33.49764031013084, 2.351578530892882],
            [33.49835439442493, 2.352102993237929],
            [33.49913962888276, 2.351957961249507],
            [33.49977076454013, 2.353170013896047],
            [33.49900915397763, 2.353360272790713],
            [33.498866551816164, 2.353857901990098],
            [33.49954038619563, 2.354544831153922],
            [33.500366028671564, 2.353734009456065],
            [33.5009300583806, 2.353673015942112],
            [33.50151460291575, 2.35464543381206],
            [33.50296508026567, 2.354807012876361],
            [33.50328727900862, 2.354482686109938],
            [33.502783188488614, 2.353165766652735],
            [33.50320601561138, 2.352577981982197],
            [33.505865140243486, 2.35265806660462],
            [33.50799995327852, 2.351218606185604],
            [33.50918878013227, 2.352028694245675],
            [33.510639136209626, 2.35186605484269],
            [33.51225052877639, 2.351379147171325],
            [33.51323702179046, 2.349757734784346],
            [33.51400268734815, 2.350223502799089],
            [33.51450614006431, 2.349777527776248],
            [33.51589635483172, 2.350425431266964],
            [33.51561403949075, 2.349635276187132],
            [33.516278676918304, 2.349270293226735],
            [33.51674203961996, 2.349371436596515],
            [33.517246012460674, 2.350343876313802],
            [33.518152646144316, 2.350688009587528],
            [33.518032474017176, 2.352572519443385],
            [33.51835508059526, 2.353362658498892],
            [33.51956374314879, 2.353321679607068],
            [33.51964401390766, 2.352490864089206],
            [33.52101954571171, 2.352257824753295],
            [33.52153715408013, 2.351807830215445],
            [33.52231387610233, 2.351961415952305],
            [33.52270248998918, 2.352718826797878],
            [33.52367928838475, 2.352943358105426],
            [33.52391418076355, 2.351712239320295],
            [33.52480832606811, 2.351191079845562],
            [33.5254911193459, 2.351912867907988],
            [33.525715050481594, 2.35283605595175],
            [33.526291659299545, 2.352823999953057],
            [33.52750330785309, 2.351710877723778],
            [33.52792716085191, 2.352290720266153],
            [33.52838588914501, 2.351734215147193],
            [33.52902160890527, 2.352444182984392],
            [33.529915884465545, 2.352278124830186],
            [33.531339928888244, 2.352703704739849],
            [33.53175143274683, 2.351744765949412],
            [33.53257506658982, 2.351484039491589],
            [33.53437552487949, 2.351518857593693],
            [33.53498325762708, 2.352030978532045],
            [33.534599700356964, 2.353069393180228],
            [33.53552946655749, 2.352850565873819],
            [33.536311498521336, 2.3532271201095],
            [33.53636106935534, 2.35506223310097],
            [33.53745326084072, 2.357159101308693],
            [33.5380071746213, 2.357355507013151],
            [33.539554286441295, 2.356371798887074],
            [33.54331662488727, 2.355075905579624],
            [33.543886879022885, 2.355403382630627],
            [33.545925407930866, 2.355051802596431],
            [33.54688432086908, 2.355926525026865],
            [33.54813811208756, 2.354680762545047],
            [33.54906651284883, 2.354451004145782],
            [33.54952305104928, 2.355565008279895],
            [33.55227579720198, 2.355187055385396],
            [33.552992798325775, 2.355874941586162],
            [33.553383703814916, 2.355776475200262],
            [33.55429524319835, 2.354104835243348],
            [33.55543568229931, 2.354579545062978],
            [33.55701550267708, 2.35397266366334],
            [33.55706405751649, 2.353186161857535],
            [33.557585275315716, 2.353087641428165],
            [33.557796722563914, 2.352301075396482],
            [33.55856213569502, 2.351841985911203],
            [33.55975142697777, 2.352283901515566],
            [33.55944236879077, 2.353381824046857],
            [33.56089212120027, 2.35339762285599],
            [33.561771353572816, 2.352430549972486],
            [33.56175426402283, 2.350431583139924],
            [33.56222660538575, 2.350316696414523],
            [33.56335083798067, 2.35100441178918],
            [33.5639859271236, 2.350528988090436],
            [33.563301116229695, 2.3488743784407],
            [33.563333267832014, 2.347809338109226],
            [33.56367497169473, 2.346891638024826],
            [33.565417552428976, 2.345989753284637],
            [33.56556352237443, 2.344416731262674],
            [33.566230888883844, 2.343203969127786],
            [33.56601860350749, 2.341893253780211],
            [33.568591933640036, 2.341023799351179],
            [33.56824836397647, 2.337304541260567],
            [33.568735841053616, 2.334338655036986],
            [33.56922457128055, 2.334485921106324],
            [33.56955095976599, 2.335993208257182],
            [33.57103351325978, 2.3366152331521],
            [33.57228697299989, 2.334648518547245],
            [33.576143784569375, 2.332479034526572],
            [33.577482403700095, 2.332778491112991],
            [33.57831286653589, 2.332106362991106],
            [33.57956720482833, 2.332318848608399],
            [33.580300813106795, 2.333793192770018],
            [33.5821731887215, 2.331711521340869],
            [33.5822540685381, 2.330335149514822],
            [33.583555914234374, 2.327254232527659],
            [33.58393044972407, 2.326991916400427],
            [33.585380344965685, 2.327433706097176],
            [33.585167884417835, 2.328088393000062],
            [33.58512016860491, 2.328515222494981],
            [33.58683087711284, 2.329415678757182],
            [33.587518264374985, 2.330549299498501],
            [33.58857429507691, 2.330627434058046],
            [33.59100091954381, 2.329610544528238],
            [33.59176684112134, 2.330429468212926],
            [33.593167693738344, 2.330445260100295],
            [33.59448625528541, 2.328445737734954],
            [33.59583921871461, 2.330788208976054],
            [33.59859247960195, 2.331819282874243],
            [33.60048182529065, 2.331425234596844],
            [33.60167099799578, 2.331621343226342],
            [33.60258367913794, 2.332800663804888],
            [33.60486446122011, 2.333586153832143],
            [33.60719019589746, 2.335167696063097],
            [33.607211260492534, 2.336370569455256],
            [33.60957259001467, 2.335058748199647],
            [33.60932788174478, 2.334190455479479],
            [33.60959269431075, 2.333864222881831],
            [33.61149784136529, 2.333704874554468],
            [33.61300905830316, 2.333926687478676],
            [33.616544574834855, 2.335825775768372],
            [33.61706615645178, 2.3365956347465],
            [33.61677406654218, 2.339135418885246],
            [33.617507513123904, 2.340150956070713],
            [33.61802880997484, 2.340265419082189],
            [33.61990128170926, 2.338544177172633],
            [33.622214951113996, 2.34000139821156],
            [33.622020077782786, 2.341345043411665],
            [33.623893501731395, 2.341786596127498],
            [33.62387777851897, 2.343064621387843],
            [33.62467614185471, 2.343523038788374],
            [33.62521419408234, 2.344686121421764],
            [33.6249540797053, 2.345833177110589],
            [33.62339041642622, 2.346014112229601],
            [33.6231300981316, 2.346702392493622],
            [33.62391250738786, 2.347914520609885],
            [33.62492247068539, 2.348012376311608],
            [33.6254277146422, 2.348651156917132],
            [33.62529867254995, 2.351502177360535],
            [33.62595849141434, 2.351927833799401],
            [33.626113703227475, 2.352796212455309],
            [33.628003241155646, 2.352811742901244],
            [33.62832924965372, 2.353319524571129],
            [33.62816694743806, 2.354630384477026],
            [33.630463913568434, 2.3550881159386],
            [33.63142541904458, 2.356087151635743],
            [33.63264705596575, 2.355988284954909],
            [33.632038809381825, 2.358412596696617],
            [33.63337587802038, 2.358177528083039],
            [33.63393855666321, 2.357364673742927],
            [33.63511366624258, 2.357487254626166],
            [33.63650884060866, 2.357043378616281],
            [33.637390299006455, 2.357412334812969],
            [33.639421485085286, 2.355933950507441],
            [33.64084137300315, 2.356007166839099],
            [33.642922654532086, 2.35701578866488],
            [33.643730434906935, 2.356867668699749],
            [33.64429311804135, 2.356079436245407],
            [33.64549272737343, 2.35625124548405],
            [33.64666744708395, 2.355536598830367],
            [33.64989904918199, 2.356002942940883],
            [33.65188171365903, 2.355509528534182],
            [33.6530573703124, 2.356814048740693],
            [33.65339990960836, 2.356419902486018],
            [33.65557852808992, 2.356172631264568],
            [33.65614141065029, 2.355827627817708],
            [33.65658155729173, 2.354768585780773],
            [33.65902910621655, 2.353782463193467],
            [33.661600027965854, 2.354864693459],
            [33.66304437700887, 2.354913250376144],
            [33.66407233086659, 2.354469526130479],
            [33.666153536038735, 2.355305741065689],
            [33.66906675992872, 2.355501328460257],
            [33.67139289884793, 2.356608280558033],
            [33.67413420495549, 2.355646613190842],
            [33.67443001658526, 2.356125416237337],
            [33.674064925084146, 2.35742727730889],
            [33.67277168345167, 2.359168202643464],
            [33.67264544859468, 2.35991814641293],
            [33.67392595570967, 2.360936230994436],
            [33.67460185351934, 2.362435666547243],
            [33.6745885261138, 2.363963735941905],
            [33.67578458620221, 2.364868669690729],
            [33.67561686265381, 2.367075953019405],
            [33.67601109909603, 2.36786808805646],
            [33.677699604843426, 2.369027453356668],
            [33.67864198339054, 2.368913799603082],
            [33.678965863779716, 2.369649372864172],
            [33.67875558164642, 2.371106794733028],
            [33.67971233952631, 2.371629824403361],
            [33.68106234120999, 2.370907571781803],
            [33.68241347387264, 2.37249155698436],
            [33.683566950223344, 2.37259002487693],
            [33.684523752120654, 2.373197942879375],
            [33.68524184649416, 2.374654900568985],
            [33.688026984997656, 2.374710102207995],
            [33.690237137938965, 2.378246163656175],
            [33.691869344470874, 2.379292343048309],
            [33.69212397912466, 2.382178544174216],
            [33.69540269875768, 2.384723641908681],
            [33.69612079941939, 2.386152291687148],
            [33.697738543973536, 2.386391994013187],
            [33.698751067469594, 2.385896273900162],
            [33.699890716951444, 2.38644748777886],
            [33.701156330897355, 2.385753554812201],
            [33.70169117344445, 2.386389970068992],
            [33.701551228499596, 2.387804906469368],
            [33.70437873514517, 2.388157166589242],
            [33.70539199256487, 2.389104601584767],
            [33.705659678841414, 2.389939232075598],
            [33.707094210196736, 2.389485734149227],
            [33.70746053598307, 2.390659879805852],
            [33.70660321621524, 2.392075186975148],
            [33.70689895687815, 2.392754167453335],
            [33.70670293550001, 2.394522848373108],
            [33.70708305312091, 2.395159340341447],
            [33.70846195720057, 2.395936797181497],
            [33.709742025039404, 2.395992724068107],
            [33.71081223834301, 2.398255944458653],
            [33.71159249433755, 2.398908530958928],
            [33.71422903981498, 2.398751144922963],
            [33.7148791622642, 2.4017148460088],
            [33.71657236889545, 2.404110713762114],
            [33.7177003474651, 2.40412429959201],
            [33.71801010274475, 2.40328739713807],
            [33.71918028955636, 2.403130774502927],
            [33.72200141636678, 2.405412577969786],
            [33.72283325003168, 2.40532704305605],
            [33.72342609410173, 2.406574741489167],
            [33.72630430884847, 2.410132880561108],
            [33.728109384478685, 2.41072755247815],
            [33.729774523248885, 2.41330777445454],
            [33.73310234030377, 2.413844887143072],
            [33.73448446843698, 2.41451068751593],
            [33.734457328535605, 2.416481994976295],
            [33.73599414656076, 2.417496765289278],
            [33.73641431646691, 2.419589654693604],
            [33.73701913687635, 2.419676214569151],
            [33.73811851937556, 2.421363771134734],
            [33.738193165782405, 2.422456068516222],
            [33.73863782106825, 2.423064057705116],
            [33.73762661450239, 2.424665880696258],
            [33.73761476392715, 2.425572030865434],
            [33.73839256931761, 2.426006056069735],
            [33.737554068356665, 2.427446417274278],
            [33.739306791968765, 2.427631647899949],
            [33.74120798823271, 2.428487091339954],
            [33.74263960545325, 2.42830010620222],
            [33.7430841556362, 2.428709486746596],
            [33.743541673898605, 2.43026084788124],
            [33.742752356597805, 2.431353620934182],
            [33.74281431430128, 2.431800451695766],
            [33.74485223954133, 2.434393619517704],
            [33.74524783423626, 2.435547799125423],
            [33.74433481981917, 2.436144127441489],
            [33.743927272141065, 2.435697489287949],
            [33.74322390115506, 2.435970964021884],
            [33.7429406515662, 2.437113109458621],
            [33.742113889789415, 2.437448716211655],
            [33.742151311807504, 2.438168644981288],
            [33.740509637930856, 2.437946121894562],
            [33.73994220899677, 2.438542256185387],
            [33.73978400579377, 2.442651021230419],
            [33.74020407419032, 2.443420389512351],
            [33.73906921901716, 2.444625071649486],
            [33.739402890144596, 2.445394488162367],
            [33.73726810136408, 2.446264574641048],
            [33.73699699789614, 2.4470591524147],
            [33.734973457378736, 2.448239498391009],
            [33.734405690678116, 2.448227399256563],
            [33.73378816180239, 2.447495375840304],
            [33.73281392630034, 2.449022703734929],
            [33.732110627179566, 2.449445130235784],
            [33.73031646069013, 2.448382679401629],
            [33.729993562159585, 2.448650408482462],
            [33.728644070718964, 2.448077821779473],
            [33.72821951254265, 2.448879598182281],
            [33.72849297139321, 2.450007676985007],
            [33.727614515165094, 2.451349833915877],
            [33.72264345397843, 2.452968655844142],
            [33.70644301156582, 2.459711367210591],
            [33.705358579727864, 2.460848778811124],
            [33.70444635852314, 2.463566793432828],
            [33.6987409874738, 2.475178606773321],
            [33.696316113823414, 2.482055107519879],
            [33.6934618275009, 2.48498607359943],
            [33.69055008223788, 2.487285223252519],
            [33.68781057186258, 2.491307490810697],
            [33.68392832090255, 2.494583628839645],
            [33.67781889033337, 2.498665085889852],
            [33.672566591784076, 2.503550250678324],
            [33.67142438749359, 2.503838042047668],
            [33.66954029694927, 2.50538990876025],
            [33.65251146501257, 2.489717218297431],
            [33.6401184456934, 2.482086694064665],
            [33.63887992403816, 2.480833676478855],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 689,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "OGWETTE",
        Population: 15297,
        Key: "OTUKEOGWETTE",
        Dist2: "Otuke",
        "Sub Country": "Ogwette",
        id2_original: "OtukeOgwette",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.147453476520596, 2.470076176241995],
            [33.14655362062579, 2.470199252242383],
            [33.14478053490114, 2.469631319251591],
            [33.142976160855156, 2.469915580151024],
            [33.14156388885425, 2.468700568377756],
            [33.138410028757555, 2.467959178400138],
            [33.13651153642261, 2.468480160350953],
            [33.13586829417015, 2.469127262453982],
            [33.13688862222941, 2.473498593050216],
            [33.13873217090665, 2.473949586596601],
            [33.14194128457984, 2.47644917178482],
            [33.14413826821907, 2.479273794191081],
            [33.14565377101916, 2.480534810641603],
            [33.14679846274468, 2.483686159600565],
            [33.14848593003957, 2.483909195586064],
            [33.14941254225516, 2.48453600461948],
            [33.14971590242828, 2.485671190752606],
            [33.14870528785217, 2.487094568522668],
            [33.14857062410288, 2.488043426351596],
            [33.146865745661145, 2.489389394989394],
            [33.145420112925535, 2.489016419996474],
            [33.14214493265477, 2.487048165780005],
            [33.1406222729768, 2.484088977015801],
            [33.13953486142707, 2.483870358414339],
            [33.139394034336604, 2.482853899100855],
            [33.137539138140724, 2.48342023251346],
            [33.13693771515972, 2.481850551080993],
            [33.134980653566544, 2.484153903665912],
            [33.133241142375645, 2.487242102560654],
            [33.13265269555891, 2.487486630528835],
            [33.131565279517595, 2.48722940427188],
            [33.129799706403674, 2.485582635584027],
            [33.12858396422739, 2.481195189462289],
            [33.12724060648352, 2.479985844805771],
            [33.12637068425059, 2.47984439483121],
            [33.12489959685308, 2.480706608606758],
            [33.12418653124854, 2.485189151419047],
            [33.12544064855546, 2.487162541932327],
            [33.128297083648135, 2.489824751030552],
            [33.128308759051876, 2.490490371794216],
            [33.123339536716635, 2.49130827968352],
            [33.120668954971386, 2.489533537241207],
            [33.11826570107494, 2.490876677337572],
            [33.11733685205431, 2.490795017754329],
            [33.11434123558478, 2.489604170618441],
            [33.11284319783046, 2.486276190437199],
            [33.1111595483755, 2.484723217021338],
            [33.11057889893544, 2.483216858256166],
            [33.108558471978775, 2.480671314566161],
            [33.10481967029152, 2.477588735566233],
            [33.10377454423883, 2.475148203836119],
            [33.103263684913166, 2.475124888275746],
            [33.10271805629444, 2.475895651355505],
            [33.10182406550009, 2.476012496533344],
            [33.101440973557295, 2.476689826447541],
            [33.101475905445426, 2.478009390364735],
            [33.10216105320758, 2.479749297583593],
            [33.10185927766261, 2.480998822333603],
            [33.102161295752694, 2.482902245017679],
            [33.10360113794799, 2.484782223026328],
            [33.10334576577732, 2.485529608561003],
            [33.1024517938476, 2.48597342632469],
            [33.09759844430253, 2.483684989297865],
            [33.09622821974513, 2.481057635548183],
            [33.09448658673355, 2.48012355409434],
            [33.09228043399022, 2.477659740239573],
            [33.090678143153916, 2.476865775738422],
            [33.08937768176147, 2.475429520726558],
            [33.088495263962955, 2.475009187303211],
            [33.08724139189611, 2.475779991734152],
            [33.087171839835236, 2.477449891604738],
            [33.0849880443627, 2.481676050076492],
            [33.0855820724123, 2.483034593403118],
            [33.08777236719594, 2.485144515728658],
            [33.08980133982589, 2.488019634462914],
            [33.09010113728062, 2.489364492060199],
            [33.08844130485876, 2.490593546365921],
            [33.0880033545982, 2.491845702988632],
            [33.08664325046083, 2.493468922452429],
            [33.08505250297593, 2.493608152433605],
            [33.0832312953998, 2.495092272738253],
            [33.07889689989943, 2.492518723230527],
            [33.07587236845753, 2.492579866649047],
            [33.07117604083084, 2.489518194137921],
            [33.07060500426262, 2.492530939529414],
            [33.06897626343111, 2.494492651117172],
            [33.06876346062513, 2.495334690209573],
            [33.06951511515933, 2.496918194452039],
            [33.07097576682814, 2.497552110578376],
            [33.0730225835929, 2.499533331748017],
            [33.07295121154529, 2.50003997867606],
            [33.07218973034018, 2.500537616705846],
            [33.07023803977412, 2.500709619375408],
            [33.06783427293963, 2.499678366758711],
            [33.06541848125676, 2.49985943389082],
            [33.06199132580284, 2.501008594612347],
            [33.059801865554114, 2.50218483155668],
            [33.05884981394802, 2.503234349961744],
            [33.05744570673473, 2.503379167378367],
            [33.055969854672995, 2.502058341913489],
            [33.054208624015175, 2.499208550586562],
            [33.05449413196867, 2.496964834674321],
            [33.05529380864133, 2.495388624173457],
            [33.05491060710406, 2.49349925765799],
            [33.049595911575146, 2.48794417710752],
            [33.046395693019875, 2.486821503651564],
            [33.045264499379805, 2.487719775856615],
            [33.04367185555133, 2.487819633601291],
            [33.042719266752705, 2.488503320513705],
            [33.04190067335677, 2.490314783304831],
            [33.041706018316184, 2.492091916440531],
            [33.040223214192444, 2.494618789683249],
            [33.04018650633498, 2.49652931855468],
            [33.039000354664154, 2.498186760522344],
            [33.03876229302902, 2.49928147825142],
            [33.038191120815206, 2.50031287477361],
            [33.036644221895955, 2.500747185247257],
            [33.03533515374479, 2.501896215059565],
            [33.034883169104525, 2.503045220531121],
            [33.033788297046335, 2.50409472388792],
            [33.0333838251998, 2.505578474249729],
            [33.03152741444435, 2.505705181634973],
            [33.02808808232674, 2.504900059806339],
            [33.0235183929006, 2.501688395849611],
            [33.02113855988024, 2.501073227856018],
            [33.01667605923044, 2.502493701835667],
            [33.01612846689449, 2.502348953425568],
            [33.014367341339536, 2.501389971807622],
            [33.01077340556831, 2.498277770297709],
            [33.00999997946486, 2.497112053494398],
            [33.010569373014455, 2.496432096421236],
            [33.01226913016077, 2.495617881188632],
            [33.01253135468039, 2.492639214236627],
            [33.013570870754144, 2.491383780822128],
            [33.01436352799116, 2.488920666462946],
            [33.01259514674368, 2.485070014912332],
            [33.01274000816808, 2.484040010092379],
            [33.0143855816314, 2.481410677223177],
            [33.01442857230596, 2.479521638903984],
            [33.01566815846483, 2.477380062613305],
            [33.015503674241366, 2.474208420126874],
            [33.0174490388712, 2.473902930303946],
            [33.018048236725264, 2.473333271251945],
            [33.018191871050995, 2.472474663235354],
            [33.0188813666591, 2.472420991297152],
            [33.019291767386555, 2.471459183299148],
            [33.019817094978166, 2.471298186201965],
            [33.01976419858098, 2.470686926926934],
            [33.02078152986044, 2.468784274685113],
            [33.02231639943976, 2.464181630662364],
            [33.02213282242322, 2.458826675677577],
            [33.021100304225556, 2.455594870558655],
            [33.019866593946965, 2.454441497986342],
            [33.02076331382314, 2.453293559629997],
            [33.02085568399055, 2.452030839941758],
            [33.02185958276158, 2.449843317976566],
            [33.02427045167669, 2.44676422708316],
            [33.02468709389874, 2.446826847194042],
            [33.025979745338056, 2.444383389846809],
            [33.02545914737639, 2.443551057216475],
            [33.025502401257334, 2.441678285371919],
            [33.02414990764704, 2.440915737991479],
            [33.02381146736374, 2.440106290379627],
            [33.02804659812691, 2.438049969177461],
            [33.03087209434288, 2.433458987556144],
            [33.036305709747424, 2.430179577693838],
            [33.04188941656794, 2.421992865827642],
            [33.042826976551886, 2.421380081642381],
            [33.04677333668047, 2.421366321867284],
            [33.04813606839008, 2.422031458877614],
            [33.04897841414041, 2.42315181194722],
            [33.051033947258375, 2.423461861034371],
            [33.051706702761166, 2.424486188205689],
            [33.05505443456754, 2.42464508805803],
            [33.05564962324053, 2.423620443287826],
            [33.05648114339337, 2.415786741757492],
            [33.05790627298093, 2.411742116170797],
            [33.05903694739474, 2.410114894247313],
            [33.06002350598584, 2.411286874417799],
            [33.06096459095896, 2.411072143666778],
            [33.06123625407729, 2.411776740680742],
            [33.07149021761834, 2.403929805100055],
            [33.07362943868647, 2.403113507014518],
            [33.075815359572964, 2.402913523113235],
            [33.077987671881246, 2.400746784695471],
            [33.078810751463685, 2.398759525143099],
            [33.0790027268298, 2.396965505262878],
            [33.08005910787466, 2.39613743909504],
            [33.08051175457331, 2.394288201464421],
            [33.08318705516871, 2.393211635877389],
            [33.08377693030676, 2.391941992247624],
            [33.08479214515543, 2.391113924839507],
            [33.08376299833502, 2.388436774762148],
            [33.08436655930642, 2.386656527529869],
            [33.08392746459217, 2.385621548707763],
            [33.08523079161036, 2.384834863829697],
            [33.0855462961078, 2.384048240431866],
            [33.086451757490025, 2.38338577932913],
            [33.08528536246724, 2.379839233425649],
            [33.08588898182915, 2.379080191302207],
            [33.08391510018062, 2.375603664240239],
            [33.08432643964751, 2.374046869219205],
            [33.08416205334043, 2.373229076015761],
            [33.08353065806993, 2.373307414620119],
            [33.08283866694195, 2.372541852727535],
            [33.08355508775409, 2.371789059794172],
            [33.084642468761125, 2.372519061361245],
            [33.094373955963206, 2.369180011294133],
            [33.107354073727876, 2.365366739956575],
            [33.10980100820501, 2.363317468705139],
            [33.11185586399326, 2.362252560586945],
            [33.117584297490886, 2.357429096652901],
            [33.11882969934293, 2.357178492988313],
            [33.1212585031227, 2.360372653919656],
            [33.125430718578315, 2.362063443696675],
            [33.12729907333377, 2.365007189504616],
            [33.131844984354345, 2.366384755919149],
            [33.135082992338674, 2.366447123920712],
            [33.13937952115489, 2.36538183854063],
            [33.14368518493923, 2.367040257504098],
            [33.14645151451734, 2.368927500666937],
            [33.148926033561885, 2.371604738894858],
            [33.14827988705611, 2.373604197628424],
            [33.146593504027756, 2.376266233197426],
            [33.14552443338116, 2.379859700938835],
            [33.14565388690182, 2.382446082563274],
            [33.145325673039714, 2.383098317566109],
            [33.14597094368808, 2.384720016755483],
            [33.146593467196844, 2.385206928864455],
            [33.14788869949598, 2.387694406407057],
            [33.14975292918767, 2.389352899081637],
            [33.15221711311491, 2.3899557314412],
            [33.153181609980955, 2.391366955561766],
            [33.154996440416824, 2.391395337348951],
            [33.15706281350533, 2.392743898789015],
            [33.15806246504169, 2.393868840785363],
            [33.162277040554535, 2.395799515477385],
            [33.16256948440035, 2.396821810814419],
            [33.16461629667353, 2.399029075250131],
            [33.165639680801405, 2.401091706003382],
            [33.16578610888765, 2.403299197798695],
            [33.16629773986615, 2.40380577704995],
            [33.16607860303911, 2.404692426262148],
            [33.167248346981275, 2.406013169318609],
            [33.16790633238416, 2.408075842472262],
            [33.16922185403231, 2.408509943277723],
            [33.17064751542252, 2.410825839019664],
            [33.17174375022498, 2.410907124727876],
            [33.172036196765724, 2.411857039958197],
            [33.17310205773182, 2.412338421766985],
            [33.17287701088849, 2.412511566669984],
            [33.173613231467826, 2.412163849786236],
            [33.17447899899255, 2.412765574416672],
            [33.17475935151464, 2.414929589502416],
            [33.17404660301539, 2.416299819767487],
            [33.175829034812246, 2.41724716164043],
            [33.17675860967163, 2.419001329392541],
            [33.178095349526785, 2.419039568009378],
            [33.17836280224139, 2.41984624954729],
            [33.17796815976065, 2.419948742975383],
            [33.178057367858244, 2.420653007791389],
            [33.17752859522753, 2.420879863332932],
            [33.17722164718314, 2.420108496895883],
            [33.17606204522053, 2.421184483881971],
            [33.174975016353095, 2.420919331490318],
            [33.173392581877835, 2.421715417666275],
            [33.172561704918714, 2.424521203705265],
            [33.173257167136974, 2.425333073179793],
            [33.17294556042955, 2.426161150300995],
            [33.17394478616444, 2.427302586932016],
            [33.17504780145069, 2.42753558032144],
            [33.17622947591814, 2.429992412391411],
            [33.18221802019956, 2.432122870920136],
            [33.183040818609314, 2.433870126542723],
            [33.184383331936814, 2.434505348061516],
            [33.18517969472438, 2.435378921210324],
            [33.18445603259275, 2.436815303651824],
            [33.18458121192928, 2.437914009265497],
            [33.18302189290289, 2.439899866984595],
            [33.18124921860665, 2.440969598773399],
            [33.18230929801556, 2.443728838186408],
            [33.18252885615248, 2.446008691144201],
            [33.183479161433645, 2.447618954726202],
            [33.1843562549175, 2.448279276280478],
            [33.18421015830959, 2.448794984156326],
            [33.184722168377135, 2.449826288920665],
            [33.18611083983886, 2.450414160991821],
            [33.186622396257206, 2.450196957587139],
            [33.18918066882897, 2.450630859969819],
            [33.18925390847409, 2.451734601775222],
            [33.19005793478937, 2.452476354385114],
            [33.19035039480484, 2.453353886343732],
            [33.19064310634859, 2.456004659220973],
            [33.187353991411115, 2.455634194099343],
            [33.183370443724726, 2.454277677119853],
            [33.182639674122555, 2.454793465253346],
            [33.18271257779776, 2.453463523948582],
            [33.18147015026763, 2.453463693574531],
            [33.179934920463914, 2.452070640155896],
            [33.17920409157296, 2.452143116283598],
            [33.17810773639623, 2.451410443427622],
            [33.17723019644968, 2.449501610461697],
            [33.17586927574372, 2.451095035562255],
            [33.17536074934286, 2.452374220634598],
            [33.17286356580364, 2.452711770231662],
            [33.1722853759508, 2.451711807248409],
            [33.17163737442399, 2.447223347522886],
            [33.17080490834513, 2.446746691800231],
            [33.171405928880915, 2.445479123942867],
            [33.17038832720855, 2.443758258181595],
            [33.16769438746931, 2.442235284345034],
            [33.165416416215635, 2.438770318553696],
            [33.16261843719345, 2.437212461214833],
            [33.161612673519876, 2.437654461470973],
            [33.16014405199783, 2.434619636278659],
            [33.15795874466069, 2.432375621172992],
            [33.15676787324134, 2.431678058757168],
            [33.15359957811633, 2.426701485342096],
            [33.15177293303783, 2.426678436395775],
            [33.15074387335399, 2.425527343820353],
            [33.150038632973896, 2.425364626061682],
            [33.14926414326515, 2.426260096291638],
            [33.149981112049616, 2.427934500631705],
            [33.14805055794387, 2.429213836083057],
            [33.14824728719445, 2.430969698075856],
            [33.146929373332696, 2.431411720124493],
            [33.145782928994066, 2.430433756244633],
            [33.144959136149296, 2.430569777941662],
            [33.14627522553271, 2.433509966747369],
            [33.146348523568314, 2.43550033732879],
            [33.14784675356211, 2.435753493517535],
            [33.147700787209914, 2.437590086315289],
            [33.15020878736344, 2.43986670253111],
            [33.15206035440288, 2.4402389508575],
            [33.152845479266226, 2.440924184365972],
            [33.15380822980738, 2.440551616719129],
            [33.15448963159477, 2.440909097387354],
            [33.15552664226718, 2.442264725015439],
            [33.15536378309607, 2.442920270023288],
            [33.15580827219361, 2.443977998959234],
            [33.15865251624954, 2.4464805814228],
            [33.1597636558992, 2.448327839749867],
            [33.15930470751887, 2.450294473],
            [33.15982346842578, 2.453080396304493],
            [33.15908292784827, 2.453721113050084],
            [33.15831260991571, 2.45308057670041],
            [33.15797194360714, 2.453229600763494],
            [33.158860830174056, 2.454466055139254],
            [33.15977920843172, 2.454570234112176],
            [33.158994475233804, 2.457281821142034],
            [33.15598770079013, 2.458488941845287],
            [33.154950817678504, 2.4583549782265],
            [33.15127706749256, 2.455912077727937],
            [33.148402877198286, 2.450578801743253],
            [33.14786960670294, 2.45032558911463],
            [33.14695127695429, 2.450638555978402],
            [33.14355910908406, 2.449268279828094],
            [33.1426406454864, 2.448314885303227],
            [33.1420035584903, 2.446810222870626],
            [33.14115924902275, 2.446720921988177],
            [33.13970755086236, 2.445812276644866],
            [33.13837443481103, 2.445693229054957],
            [33.135871297238154, 2.447049235082649],
            [33.13533820281257, 2.448524224263318],
            [33.13550128027432, 2.449939549101009],
            [33.134982906541296, 2.450505739467397],
            [33.13676050630023, 2.451697424923142],
            [33.13836016956432, 2.451026833241642],
            [33.1391897098303, 2.45150349462129],
            [33.14071571663098, 2.454721372497969],
            [33.14059760254418, 2.458401272479108],
            [33.144045982493324, 2.461940130454482],
            [33.144867887079364, 2.464017630597496],
            [33.146077761460205, 2.465635950722656],
            [33.14829176368251, 2.465842315399362],
            [33.14891958455645, 2.467162260761899],
            [33.148691478051326, 2.468413430789359],
            [33.15019808124187, 2.470031713255922],
            [33.1502666550374, 2.470915542042769],
            [33.14961616068565, 2.470984486459337],
            [33.14853181328935, 2.469377633677854],
            [33.14782426873053, 2.469538411125014],
            [33.147453476520596, 2.470076176241995],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 690,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "ABIA",
        Population: 23436,
        Key: "ALEBTONGABIA",
        Dist2: "Alebtong",
        "Sub Country": "Abia",
        id2_original: "Alebtong Abia",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.24761962281306, 2.38109264635496],
            [33.24429622996097, 2.382168328385665],
            [33.24430591739301, 2.383125816346311],
            [33.24330638623086, 2.38300152164],
            [33.24320180526381, 2.383738807078384],
            [33.242459453682685, 2.384552804647085],
            [33.237709298105884, 2.383979145281726],
            [33.23665251551405, 2.38306971212052],
            [33.23563398498366, 2.383175212368448],
            [33.23600502512863, 2.381959135371212],
            [33.23573813655604, 2.379891001765054],
            [33.23478613525558, 2.37936454571978],
            [33.23382477620483, 2.379795581543236],
            [33.23339636874752, 2.379517982105897],
            [33.235385186684255, 2.375515331621403],
            [33.23252886747428, 2.371982678343796],
            [33.2309090289472, 2.371371377853903],
            [33.224928629690474, 2.371755287840886],
            [33.223080952356206, 2.3707632633836],
            [33.22265055602886, 2.371340686268322],
            [33.220749157643965, 2.370907978370269],
            [33.21970883667975, 2.371088568262958],
            [33.218973658146155, 2.372622279060955],
            [33.219476064325, 2.373686693637635],
            [33.22112660277691, 2.375725206848487],
            [33.22189815858793, 2.377348887509943],
            [33.223387112578074, 2.378413140476651],
            [33.22487631989316, 2.38102902694631],
            [33.22512762898379, 2.382183690662623],
            [33.22641924556391, 2.383031465316793],
            [33.224356969691435, 2.386135076041846],
            [33.22290419445103, 2.387019385149437],
            [33.22062614145065, 2.386893459972226],
            [33.21989081649169, 2.387543099886444],
            [33.21877863120304, 2.387074179709451],
            [33.21818672407582, 2.387218612055908],
            [33.21752296250563, 2.386695492261647],
            [33.21590872138111, 2.387417439530205],
            [33.21443786485066, 2.387417671094385],
            [33.21389990155624, 2.388428124320906],
            [33.21580143558673, 2.3895825314139],
            [33.215793951722105, 2.391123755519872],
            [33.21453048834298, 2.391033483430142],
            [33.2132669405222, 2.392209810561323],
            [33.21344751986063, 2.393024025698384],
            [33.212996514384045, 2.393847386196301],
            [33.21556956873381, 2.397791537129605],
            [33.21731386075863, 2.398553454465532],
            [33.217679410400564, 2.399487555783993],
            [33.21914114453932, 2.400268339093019],
            [33.21936971457516, 2.401478115379861],
            [33.22037458442502, 2.401554522692409],
            [33.22078573883897, 2.402029192850273],
            [33.21780162170339, 2.402075617380596],
            [33.21739060832495, 2.402489164065308],
            [33.216842984547945, 2.405536755760275],
            [33.215442459816046, 2.406746793044707],
            [33.21203209656974, 2.407252695181139],
            [33.21023540132278, 2.406456642716917],
            [33.20985484442573, 2.406931439515382],
            [33.210159611360595, 2.408646571206042],
            [33.209779133515255, 2.409642046178841],
            [33.20612538431912, 2.411664068763321],
            [33.20496870637276, 2.414604552611889],
            [33.20277628797182, 2.414758024538335],
            [33.201649753893136, 2.415692353490826],
            [33.20107117327315, 2.415554613349109],
            [33.20081223029923, 2.414788945813988],
            [33.199091768782246, 2.414758572921603],
            [33.19890910086079, 2.415003625717017],
            [33.199990275407515, 2.416228593748035],
            [33.19918348228117, 2.417239444798318],
            [33.19915320366621, 2.418418634846461],
            [33.196960640636505, 2.417622623921204],
            [33.19648858044627, 2.417102012661545],
            [33.1965646542761, 2.416734462740306],
            [33.197980650692145, 2.417025223879478],
            [33.198452522236174, 2.416244135145718],
            [33.196899421348206, 2.415417400933515],
            [33.19692973948904, 2.414498549485804],
            [33.1961074944415, 2.413947362176424],
            [33.19551370444543, 2.41391681963427],
            [33.19453938450175, 2.41460609454727],
            [33.19487462947758, 2.416627509310629],
            [33.19460063253616, 2.417041030035254],
            [33.19338262211377, 2.417148404367363],
            [33.19249930510162, 2.41538740770492],
            [33.19257518579368, 2.41364158758945],
            [33.18957547120983, 2.411237695712528],
            [33.189498883543656, 2.407899228979582],
            [33.18831104304008, 2.405908558479839],
            [33.1875192643554, 2.405418616509579],
            [33.18620993748943, 2.405709765104416],
            [33.18515922661062, 2.404438837051445],
            [33.184717691173766, 2.404392955603758],
            [33.183347646279415, 2.406062380523327],
            [33.180805113988065, 2.406644659425548],
            [33.18008969120424, 2.407885198913814],
            [33.18048573954837, 2.409339987259359],
            [33.18136893618627, 2.410335287606263],
            [33.18085144280221, 2.411591115673089],
            [33.18191725615759, 2.411927882965913],
            [33.18238985533697, 2.416537369945121],
            [33.18506982717189, 2.418864751868377],
            [33.18404979376001, 2.419339628700468],
            [33.182496744076005, 2.418865101899186],
            [33.18062408908527, 2.419340092715494],
            [33.17954329632256, 2.42091759121161],
            [33.17847761591785, 2.421652811646412],
            [33.17749835074852, 2.421252971328123],
            [33.17752859522753, 2.420879863332932],
            [33.178057367858244, 2.420653007791389],
            [33.17796815976065, 2.419948742975383],
            [33.17836280224139, 2.41984624954729],
            [33.178095349526785, 2.419039568009378],
            [33.17675860967163, 2.419001329392541],
            [33.175829034812246, 2.41724716164043],
            [33.17404660301539, 2.416299819767487],
            [33.17475935151464, 2.414929589502416],
            [33.17447899899255, 2.412765574416672],
            [33.173613231467826, 2.412163849786236],
            [33.17287701088849, 2.412511566669984],
            [33.17310205773182, 2.412338421766985],
            [33.172036196765724, 2.411857039958197],
            [33.17174375022498, 2.410907124727876],
            [33.17064751542252, 2.410825839019664],
            [33.16922185403231, 2.408509943277723],
            [33.16790633238416, 2.408075842472262],
            [33.167248346981275, 2.406013169318609],
            [33.16607860303911, 2.404692426262148],
            [33.16629773986615, 2.40380577704995],
            [33.16578610888765, 2.403299197798695],
            [33.165639680801405, 2.401091706003382],
            [33.16461629667353, 2.399029075250131],
            [33.16256948440035, 2.396821810814419],
            [33.162277040554535, 2.395799515477385],
            [33.162285541312066, 2.394240503073238],
            [33.16141532083847, 2.391028529944491],
            [33.16145084291976, 2.389104875332793],
            [33.16469454532467, 2.388040188146627],
            [33.168790978004616, 2.384833338016382],
            [33.1728037424973, 2.383507389464289],
            [33.17506861721243, 2.380248177943372],
            [33.18011115465132, 2.376506048538705],
            [33.181700125268556, 2.374524342935197],
            [33.18290764965663, 2.371315243531262],
            [33.18330016852003, 2.365181142784159],
            [33.182956437159724, 2.364259514798076],
            [33.18406328645558, 2.361699166776488],
            [33.18353493064312, 2.360054307950473],
            [33.1850672714649, 2.355107461871672],
            [33.18508224907561, 2.3534479659638],
            [33.18447671270889, 2.350031033684467],
            [33.18051070822168, 2.345020977082476],
            [33.18051047555804, 2.343207939951622],
            [33.178183250575636, 2.339615126052489],
            [33.178510754768666, 2.337966867253877],
            [33.19063817459766, 2.34136962593122],
            [33.19351986133297, 2.341369248953753],
            [33.20168722711522, 2.344819992967684],
            [33.20360067550131, 2.345043513991452],
            [33.204869028410535, 2.346139945080742],
            [33.204977110112246, 2.346718301778417],
            [33.20542531464178, 2.346553891764757],
            [33.2091634686437, 2.348679429180131],
            [33.209608431153384, 2.348556272186112],
            [33.21050967584363, 2.34960799395222],
            [33.21217847704527, 2.350402226660483],
            [33.21313977950217, 2.348048711378453],
            [33.21294124823111, 2.346519498983267],
            [33.213546763038266, 2.343882017650196],
            [33.21330379750001, 2.339925969438016],
            [33.21375528177865, 2.338629367960165],
            [33.213611450721885, 2.334562490983267],
            [33.210030615082395, 2.331493466199823],
            [33.209854179672405, 2.33034101874064],
            [33.20923720326056, 2.329997585066768],
            [33.208399686853156, 2.328224674318617],
            [33.20855360958385, 2.326130252682106],
            [33.20826706317788, 2.325321347930785],
            [33.20789242707683, 2.324811655059519],
            [33.206614463990725, 2.324457236399562],
            [33.20738546374458, 2.323404382800948],
            [33.20724214562582, 2.322695189244961],
            [33.206008249395964, 2.322329682279254],
            [33.205820915624926, 2.321964020835616],
            [33.20621742929639, 2.321420970059692],
            [33.20475212165944, 2.320590073730888],
            [33.20407994107842, 2.319360127546048],
            [33.20333081889501, 2.319326991608271],
            [33.20268073776829, 2.318551381380423],
            [33.20001471497314, 2.318230399599295],
            [33.19947483826717, 2.317720728405423],
            [33.19831808665896, 2.317532506679771],
            [33.19701796572804, 2.316213993487649],
            [33.19670936658016, 2.315205621507495],
            [33.19424138906751, 2.313000747313608],
            [33.18934974883342, 2.31029752963317],
            [33.1889529782438, 2.308934559463928],
            [33.18799447673394, 2.308347367580621],
            [33.18761971127551, 2.306751682577763],
            [33.187046770278876, 2.30606470675862],
            [33.18750933347992, 2.30512271769638],
            [33.1871784722827, 2.302285899393172],
            [33.18790529289087, 2.300324379012523],
            [33.18825086849245, 2.296623328442624],
            [33.18820428365847, 2.289749881199826],
            [33.18987562799065, 2.282638118066353],
            [33.19015963126604, 2.278544907599959],
            [33.195216610021404, 2.267433548523938],
            [33.19508754457296, 2.265866745384231],
            [33.1936468265203, 2.266143034203441],
            [33.186714185214626, 2.271585546241108],
            [33.18492315474386, 2.272108329100143],
            [33.18380841015498, 2.273361940112833],
            [33.18233945625629, 2.274140596219274],
            [33.17915263337853, 2.278152094938708],
            [33.17656463375738, 2.284237821622962],
            [33.172906367832006, 2.286516506837808],
            [33.17229670280823, 2.2872905978149],
            [33.17144015738818, 2.287451345322817],
            [33.17030792439734, 2.288926493643727],
            [33.16955300808035, 2.289116437152619],
            [33.167317469647436, 2.291219690940117],
            [33.165270498372436, 2.291906322944731],
            [33.163702242905636, 2.289263163072285],
            [33.16860316093994, 2.284640241443222],
            [33.16705890576258, 2.284736701258463],
            [33.165345411578954, 2.283348531656776],
            [33.16632106013093, 2.283348418558911],
            [33.16855477139055, 2.281016136006065],
            [33.17011775195001, 2.278714680606039],
            [33.17018978336107, 2.277993956627249],
            [33.17078811254427, 2.277517353226108],
            [33.17063843614992, 2.276840193063204],
            [33.171353413369395, 2.275090964170202],
            [33.17110776186845, 2.27363567470209],
            [33.15519433208742, 2.270152140568234],
            [33.15057924360347, 2.269853116939978],
            [33.14781010229851, 2.268805106103659],
            [33.148082094200234, 2.265774965358419],
            [33.1491363291699, 2.261675127570446],
            [33.14848594620925, 2.26032849453541],
            [33.146101512916324, 2.258340750506076],
            [33.13729723261451, 2.258595900073761],
            [33.13516601733218, 2.259258187184407],
            [33.134859004609105, 2.261612432716146],
            [33.13357356753981, 2.264409391094265],
            [33.12990921193512, 2.263019389652681],
            [33.12353239243169, 2.259441140368457],
            [33.11194715169074, 2.255319648470884],
            [33.11106199133565, 2.253682171574459],
            [33.10955738420165, 2.251936174886314],
            [33.108229917655166, 2.251194403608817],
            [33.10727114575242, 2.249810251008201],
            [33.10792004649286, 2.249131662351024],
            [33.11027614692173, 2.248092320176922],
            [33.10474284367349, 2.246024606178619],
            [33.10174964816364, 2.244452452564626],
            [33.10324797607379, 2.240119678442573],
            [33.103663056125555, 2.236725880110767],
            [33.10486418001724, 2.23516996185445],
            [33.10710315181116, 2.23357932420616],
            [33.11070530626893, 2.233293254892751],
            [33.12268620189195, 2.230302460901821],
            [33.12452906335795, 2.229362663908613],
            [33.12585912423899, 2.227188002406087],
            [33.12673810149, 2.224627095676325],
            [33.1325048840671, 2.216092997115386],
            [33.13688582218069, 2.212162555121527],
            [33.136723546016185, 2.212452833999937],
            [33.13870386229708, 2.20915741882106],
            [33.14053199588403, 2.207777845982723],
            [33.14373314060234, 2.206281007443598],
            [33.14529476380742, 2.200280618673186],
            [33.14809052039761, 2.193606860832918],
            [33.1516984168867, 2.19038503805242],
            [33.15067997888277, 2.186889345455922],
            [33.15792495902285, 2.187914158909447],
            [33.16118884836883, 2.189230877133447],
            [33.162198010369124, 2.188392787770242],
            [33.16239906590612, 2.186827600739206],
            [33.16343373197565, 2.188284086511942],
            [33.16646308198071, 2.188482788966316],
            [33.16908616350867, 2.189685770563288],
            [33.16957881218688, 2.18955905337431],
            [33.16984979887379, 2.190128996082406],
            [33.170514739033635, 2.190128919781397],
            [33.17088409214248, 2.190698850603109],
            [33.173125391471324, 2.190725733686732],
            [33.17352001329079, 2.193530316721514],
            [33.1747271226572, 2.196280521716817],
            [33.174086798132784, 2.197737194877049],
            [33.17416086782122, 2.199076170754925],
            [33.17562648178368, 2.201319701008423],
            [33.17725221954719, 2.202929907139622],
            [33.1783241531246, 2.205589651206772],
            [33.18044213173123, 2.205915093202061],
            [33.183841390902316, 2.20856549908564],
            [33.18433403778389, 2.208393541139403],
            [33.185811832901614, 2.208936187263211],
            [33.188003911739386, 2.208465456214308],
            [33.18975257855967, 2.208591892629143],
            [33.192843686842195, 2.21008427740859],
            [33.193533464521316, 2.210835102438811],
            [33.198385724409974, 2.213259100884972],
            [33.19956822622579, 2.214371744193416],
            [33.20171134777888, 2.217619387814503],
            [33.20852221705791, 2.221843466583474],
            [33.211576153952336, 2.222512519667208],
            [33.22384849629116, 2.226513199384629],
            [33.22049290422601, 2.233439052919213],
            [33.20875870484466, 2.249946984092598],
            [33.207530746478824, 2.25513129020076],
            [33.20357384731536, 2.257450590068175],
            [33.20125429933539, 2.261952767202178],
            [33.203164553312334, 2.266045624367648],
            [33.21162408086935, 2.27218494092729],
            [33.22608709797918, 2.285964249321078],
            [33.23195421698367, 2.285145694070452],
            [33.246963036985385, 2.285145688684822],
            [33.24300616117809, 2.294832162895095],
            [33.243006163873005, 2.297560740907658],
            [33.248736841362245, 2.295787149635446],
            [33.2518750231623, 2.295241440953135],
            [33.2618354172685, 2.296060013771966],
            [33.2609327200024, 2.285413946566307],
            [33.258786222580454, 2.281611466013628],
            [33.258075756700336, 2.280861322732966],
            [33.25555387038917, 2.279682776816268],
            [33.25202488191462, 2.279746626103245],
            [33.252130636979786, 2.278054693991431],
            [33.25462459916034, 2.277056177718615],
            [33.255681455414035, 2.275917359452442],
            [33.25596831982358, 2.268092034700288],
            [33.259379430468236, 2.268910576300716],
            [33.263282145948736, 2.270582996119543],
            [33.266651613391716, 2.273285578780858],
            [33.26674738637743, 2.264408454883055],
            [33.264018520139935, 2.259087735090807],
            [33.26156253603464, 2.255540599273846],
            [33.25998383136442, 2.245881383793884],
            [33.25863960225473, 2.246036568829076],
            [33.260479398669, 2.243248184291126],
            [33.262399935661016, 2.243147908595309],
            [33.2637309218068, 2.242503535294774],
            [33.264343133554384, 2.242622619018635],
            [33.26588386374259, 2.244708242775993],
            [33.26874718172696, 2.243833622698921],
            [33.269774097132185, 2.243912894786413],
            [33.270860397465945, 2.244747054327139],
            [33.27262225155458, 2.245339078911273],
            [33.27690189563672, 2.245011231004682],
            [33.27832708900465, 2.246509839819137],
            [33.279585698786285, 2.246822471753701],
            [33.27992555571281, 2.247472226202835],
            [33.28149538143474, 2.247769372120646],
            [33.28235214245043, 2.248411551102008],
            [33.28254288442965, 2.249397649638689],
            [33.28406571299087, 2.249940178316896],
            [33.28574392135015, 2.25170403557995],
            [33.286719734293825, 2.251749078234462],
            [33.28855189233324, 2.253160064264379],
            [33.28962274164409, 2.253404121945338],
            [33.29040826446115, 2.254770078173766],
            [33.29014373845773, 2.255548126709271],
            [33.290789786148814, 2.256868930715943],
            [33.29090878058463, 2.258832129619944],
            [33.290480780064144, 2.260442601315743],
            [33.29099247482301, 2.2613562559086],
            [33.29042160444312, 2.26248726023564],
            [33.29037471508022, 2.264133843373546],
            [33.2881145610119, 2.267300786325785],
            [33.28609217662623, 2.267654027133465],
            [33.28508113804533, 2.268622268995936],
            [33.28360573783616, 2.269273953434111],
            [33.28253525593627, 2.270975021843007],
            [33.2819405784047, 2.271137987370972],
            [33.28153607601542, 2.272241814329561],
            [33.28158437214003, 2.274901657007199],
            [33.28108473546721, 2.275308875352432],
            [33.28108498160561, 2.276575471049048],
            [33.28060900026916, 2.277217909249281],
            [33.280906833108325, 2.279678666686038],
            [33.27935997371495, 2.280031806625011],
            [33.27950313462852, 2.282022144515691],
            [33.27790918914122, 2.28307192120102],
            [33.277790261180755, 2.284320445836898],
            [33.27503021801303, 2.283941001837083],
            [33.2742924927556, 2.285660096495234],
            [33.27147367551378, 2.289596133419858],
            [33.27146328200593, 2.297078104102001],
            [33.270773146797325, 2.297847240937584],
            [33.27076193222933, 2.300968499426473],
            [33.27014329034092, 2.302307591454336],
            [33.27180927442582, 2.304532863786385],
            [33.27278520594712, 2.305012173401174],
            [33.2732379505621, 2.306260588223073],
            [33.2741896670966, 2.306495628711105],
            [33.2737136695905, 2.307119972490175],
            [33.274309007383806, 2.307382223184681],
            [33.27508238587651, 2.309788605071614],
            [33.27515395285857, 2.310702350330438],
            [33.27453563526198, 2.310792941771003],
            [33.274821358811145, 2.311652361893201],
            [33.274464526420736, 2.31225858836871],
            [33.27460753911228, 2.313470874489792],
            [33.273869518309134, 2.313715289936139],
            [33.273608351106596, 2.314864323989949],
            [33.27464389393182, 2.318347261828264],
            [33.27454911088957, 2.319469123296779],
            [33.27778589806342, 2.322680211373383],
            [33.27816725446109, 2.323874354830611],
            [33.27897628349416, 2.324525586819955],
            [33.27911928989753, 2.325674541183351],
            [33.280238226923835, 2.32720327902624],
            [33.28023836885767, 2.327918001166884],
            [33.281296833095666, 2.327791129087017],
            [33.28253501339115, 2.329654583939203],
            [33.284177136425456, 2.330368972734567],
            [33.2854864282571, 2.333607569859576],
            [33.287056886393025, 2.332937762354249],
            [33.28787864006208, 2.335289839980848],
            [33.28823616505359, 2.338094368508108],
            [33.28792668016686, 2.339315791197678],
            [33.28842662136857, 2.340319915700822],
            [33.28961672742325, 2.340654411584025],
            [33.289926057799775, 2.341414304040069],
            [33.288287404957394, 2.343628918120959],
            [33.2875330168498, 2.343993223995907],
            [33.28432017786311, 2.342826808130209],
            [33.28353489938782, 2.342944580242775],
            [33.28223835824327, 2.344464758083179],
            [33.28145364031674, 2.347387132436324],
            [33.27966906424129, 2.348436957639032],
            [33.279121347937846, 2.347459980318743],
            [33.27771785786717, 2.348292594850209],
            [33.277218475417584, 2.350111164228621],
            [33.275695151884634, 2.350473351968992],
            [33.271566059155916, 2.349506125370997],
            [33.26932928733611, 2.349388948893436],
            [33.267449250888696, 2.348095574835144],
            [33.26602151528852, 2.34859344017513],
            [33.26318872026087, 2.344622294803097],
            [33.26254618498253, 2.344550039164638],
            [33.26190377007844, 2.345129175604305],
            [33.261475732727035, 2.346802974175544],
            [33.26166645494333, 2.347644320574863],
            [33.26295178870635, 2.349173040773644],
            [33.26321348232167, 2.350774331457994],
            [33.26266659336658, 2.351154414558778],
            [33.25915594220195, 2.350666530094493],
            [33.258442078893445, 2.350956171574357],
            [33.2568954979778, 2.350214594519526],
            [33.255110380218234, 2.348423592958667],
            [33.25392029482479, 2.34820668031898],
            [33.250826363137286, 2.345502150646678],
            [33.249797190265724, 2.346063258255508],
            [33.249169461918235, 2.347085697153672],
            [33.24922072338161, 2.347682798130052],
            [33.25035748028823, 2.348315892838083],
            [33.25149298943492, 2.348252357194816],
            [33.251873814029935, 2.349690782195812],
            [33.25149338738857, 2.350477951063791],
            [33.251517271795365, 2.352006911398518],
            [33.25370718389667, 2.3540963982061],
            [33.2543978976203, 2.356321864272758],
            [33.25166079922155, 2.356150469713622],
            [33.25082833493935, 2.356530599816509],
            [33.24767522493587, 2.356214518399002],
            [33.246421699618736, 2.356504250276795],
            [33.24587880367512, 2.357264306440636],
            [33.245920667862286, 2.358775169125176],
            [33.24738411508827, 2.363018012380152],
            [33.24646476575178, 2.364827602280454],
            [33.244877577392046, 2.366592076311313],
            [33.24562989937449, 2.367559984834514],
            [33.245504606850254, 2.36793998705584],
            [33.24466873166489, 2.368148219124171],
            [33.24452087525732, 2.368923726479375],
            [33.245846044811636, 2.371985147491731],
            [33.24584022103365, 2.373903254950372],
            [33.245374853292304, 2.375517226335321],
            [33.24588115815948, 2.376418265273739],
            [33.24564850078908, 2.377375440395482],
            [33.246402719115096, 2.377716410311738],
            [33.247177324706506, 2.378846501229018],
            [33.247096549094465, 2.380017475980041],
            [33.24761962281306, 2.38109264635496],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 691,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "ALOI",
        Population: 30709,
        Key: "ALEBTONGALOI",
        Dist2: "Alebtong",
        "Sub Country": "Aloi",
        id2_original: "Alebtong Aloi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.53298063078777, 2.603729620409684],
            [33.532103879562044, 2.60373379146853],
            [33.530849694881475, 2.605191750679042],
            [33.52925904441462, 2.60501469534667],
            [33.52626253681635, 2.602820927810231],
            [33.52562657990085, 2.603461044752968],
            [33.52546795898124, 2.604509749960542],
            [33.52440760648448, 2.604616832492849],
            [33.5240185973389, 2.604137114307339],
            [33.52308202011188, 2.604333012207444],
            [33.52223325410219, 2.603249171412305],
            [33.52246269909714, 2.602520356462232],
            [33.52193220978587, 2.60179186774044],
            [33.52255037107559, 2.60081406215632],
            [33.52109259311735, 2.601445625303934],
            [33.519661069321614, 2.601410673777096],
            [33.518565069877766, 2.600753508075675],
            [33.51932412203833, 2.598602580879195],
            [33.51836970157482, 2.598407469101391],
            [33.5185637188116, 2.597447618613245],
            [33.517856792293685, 2.597430132025862],
            [33.5175561261681, 2.596879274785878],
            [33.51658433318533, 2.597430656103012],
            [33.516221468607746, 2.596035591608196],
            [33.51648625422426, 2.595288985248579],
            [33.51593805103393, 2.594453844204703],
            [33.51450659191689, 2.594561068481185],
            [33.512172780486864, 2.592144807533676],
            [33.51176644104282, 2.592482680713407],
            [33.51105942469339, 2.592234129852284],
            [33.50862994448223, 2.593648116526909],
            [33.50802877033451, 2.592919647814157],
            [33.507481109726626, 2.593381982332666],
            [33.507215514728024, 2.592155709101569],
            [33.506543892000806, 2.592031565113512],
            [33.50687928340202, 2.591018323643926],
            [33.50615473283655, 2.591125261941962],
            [33.50511170524838, 2.590308099301862],
            [33.50509378296015, 2.589686023263425],
            [33.50417486661163, 2.589899674828679],
            [33.50496978131495, 2.588975129612554],
            [33.50365289961746, 2.588344688265439],
            [33.50312244174725, 2.587651732874107],
            [33.502362562238304, 2.587794220131036],
            [33.50140879305339, 2.589234265027467],
            [33.50048949222592, 2.588470362679653],
            [33.50004778521082, 2.588754924190094],
            [33.499764789845166, 2.588168498356751],
            [33.49815706420139, 2.589484395000534],
            [33.49672537421733, 2.589022837103041],
            [33.49673460261024, 2.590009278492142],
            [33.49625730883519, 2.589725091478331],
            [33.49551523483347, 2.590205265630898],
            [33.49650523756537, 2.591004699364002],
            [33.49558668413621, 2.592160343255015],
            [33.49498579475448, 2.592125034307633],
            [33.494756202435845, 2.592516147297143],
            [33.4945614557671, 2.591645307786519],
            [33.494084308417406, 2.591716587088249],
            [33.4937306749277, 2.591254611817373],
            [33.49267080931783, 2.592588057419054],
            [33.49219339696517, 2.591948390842327],
            [33.49185782051098, 2.592517283400293],
            [33.491186169935986, 2.592322029791946],
            [33.49120331877474, 2.59095344633279],
            [33.490496295238806, 2.590704901453152],
            [33.48998394381147, 2.591113883847495],
            [33.48893213968295, 2.590447785483062],
            [33.4880491029452, 2.592047758627677],
            [33.48734216924077, 2.592012486470386],
            [33.486847592777934, 2.592705855867455],
            [33.486211267553195, 2.592457261077759],
            [33.48569892421066, 2.592919574227712],
            [33.48529211494773, 2.592048824734331],
            [33.48499182072465, 2.592439963771881],
            [33.48456762636603, 2.592333480564654],
            [33.48440893717447, 2.593293318783221],
            [33.48359582529842, 2.592902626015056],
            [33.48359562227915, 2.592369409606823],
            [33.48290649138706, 2.592689596851818],
            [33.48185460371521, 2.591774662993195],
            [33.48107708937891, 2.592023781098955],
            [33.4810414064992, 2.59115288830317],
            [33.4801043998775, 2.590246781930068],
            [33.4793799822627, 2.590744719860603],
            [33.479574688507284, 2.591508925054198],
            [33.478779407291285, 2.591544774251499],
            [33.47846156358084, 2.592255841452033],
            [33.477578044447775, 2.59261164546731],
            [33.47773732473079, 2.593233671608752],
            [33.47715411419384, 2.593233892367998],
            [33.47768450558872, 2.593749121924569],
            [33.47740195219418, 2.594317992135311],
            [33.47772054779453, 2.595579802752029],
            [33.476854926695175, 2.596557686874048],
            [33.47632464130151, 2.596326834304203],
            [33.47500813240485, 2.596691695457719],
            [33.47463675269672, 2.596034203340687],
            [33.474106696373454, 2.59638988155518],
            [33.472568989914464, 2.596017204915735],
            [33.47217980919068, 2.595022027591921],
            [33.4712959666641, 2.594489142318335],
            [33.470094242697826, 2.59463179482372],
            [33.47073075207723, 2.595378058767057],
            [33.47064252943149, 2.595769097164312],
            [33.470165339861005, 2.595733729987083],
            [33.47011268870386, 2.596711305286858],
            [33.46921129579158, 2.59655168152023],
            [33.469051911304, 2.595663053960257],
            [33.46830963068979, 2.595627784595985],
            [33.4679294151525, 2.594979185998372],
            [33.4671693847266, 2.594748405829133],
            [33.467115974493076, 2.593664222075653],
            [33.466214569902675, 2.593469049409876],
            [33.46531334317873, 2.593753760559162],
            [33.465101541095976, 2.594482574288373],
            [33.46464194053876, 2.594233902671911],
            [33.46375844296523, 2.594643023021701],
            [33.46344060644129, 2.595425188991998],
            [33.46299848889612, 2.594643303008727],
            [33.46154095078807, 2.595985767431111],
            [33.460197908352875, 2.59630618439044],
            [33.460002803256316, 2.594386686790227],
            [33.4594195594817, 2.594298030490394],
            [33.459472251062984, 2.593409323272915],
            [33.45858865916639, 2.593587394289846],
            [33.45831445651073, 2.592814327672038],
            [33.45748396762383, 2.593241201653001],
            [33.45730705161516, 2.592708047307769],
            [33.456493987349816, 2.592459519823199],
            [33.45578730966527, 2.593117401473923],
            [33.455521808989765, 2.591997745840263],
            [33.45423127218461, 2.590896239070459],
            [33.45327697838357, 2.591038766345338],
            [33.45161609044126, 2.592105792339796],
            [33.44957480460373, 2.591991001010293],
            [33.44867366591467, 2.592542301001418],
            [33.44720648529034, 2.591654142654693],
            [33.44634072135888, 2.592294308332307],
            [33.44381297264216, 2.590891061089792],
            [33.44377800931296, 2.591957503901216],
            [33.44453826162274, 2.592863702378905],
            [33.44594442867297, 2.596124700969791],
            [33.445273588378356, 2.59824001939543],
            [33.44571567268587, 2.599341950513884],
            [33.44527424325021, 2.600106268965124],
            [33.444549401630574, 2.599431122459535],
            [33.44457640229307, 2.600826359988168],
            [33.44406381999871, 2.600666569827337],
            [33.44399367774468, 2.602230689215649],
            [33.44454164647474, 2.60253264081658],
            [33.44426887932694, 2.605865336236351],
            [33.44471119180652, 2.607215985432819],
            [33.44428745828364, 2.608406973223964],
            [33.443403507060914, 2.607625253229783],
            [33.443015051277555, 2.608656265727721],
            [33.442308031334875, 2.608407674978687],
            [33.443254182806164, 2.61019361253007],
            [33.444261646092244, 2.610424309107036],
            [33.44394408175786, 2.612024071150356],
            [33.44344952236303, 2.612859612446437],
            [33.443095891568284, 2.612379842664775],
            [33.44238911776397, 2.612842211324307],
            [33.441823482765564, 2.612611357252237],
            [33.441576373298865, 2.613517902525174],
            [33.43982644075238, 2.612754246409322],
            [33.439031594321, 2.614069797934067],
            [33.438465965610774, 2.613856701456166],
            [33.43788286646489, 2.614212385405332],
            [33.43782951282522, 2.613288167611552],
            [33.43694585714823, 2.613306256121349],
            [33.437016824055696, 2.614106041337081],
            [33.43653095136963, 2.614506132074832],
            [33.43693756390152, 2.614897015567206],
            [33.435806926318634, 2.616212673428209],
            [33.43612540783295, 2.617261205569558],
            [33.43524202704041, 2.618114668495191],
            [33.4353483498408, 2.618914451541506],
            [33.436355638853755, 2.618647489025674],
            [33.436833015273834, 2.619162763817438],
            [33.43709793294269, 2.618647228786288],
            [33.43790263928263, 2.620273249231865],
            [33.43894530215479, 2.620059595640555],
            [33.43922847628519, 2.62117923977035],
            [33.440288962630916, 2.621409928942263],
            [33.44062512388832, 2.622422915317944],
            [33.44020111368433, 2.622867406373118],
            [33.44008723156083, 2.62572014043187],
            [33.44121889232483, 2.627283841828982],
            [33.4396110463068, 2.62856411861844],
            [33.439734502674604, 2.627853124903422],
            [33.439133549512476, 2.627693374976285],
            [33.43908032073863, 2.627106860508257],
            [33.43862099326923, 2.627640232680496],
            [33.438143634815454, 2.627160505354554],
            [33.43775499218253, 2.627676085334311],
            [33.43803800641278, 2.628333621009546],
            [33.43749965414786, 2.630333361492986],
            [33.43711062703598, 2.629746964026362],
            [33.43567914546104, 2.629996299843254],
            [33.43475960388507, 2.628521398416524],
            [33.434264696842234, 2.628414923650724],
            [33.43378782078376, 2.629303790065482],
            [33.43417694850695, 2.630210112364737],
            [33.433593828699834, 2.630530240609605],
            [33.433824021093066, 2.631774331301205],
            [33.433205471731156, 2.631881186264128],
            [33.43329439775776, 2.633463027383243],
            [33.432746369738894, 2.633054424905286],
            [33.43172149261105, 2.633641317059667],
            [33.43129695509597, 2.632575034379682],
            [33.430855268742135, 2.633019528999209],
            [33.43030199456199, 2.632754899062407],
            [33.42838965649358, 2.632656028947418],
            [33.427576479938836, 2.632123098629925],
            [33.42748743713124, 2.630150229140512],
            [33.42892669362495, 2.626763822390969],
            [33.427308828696574, 2.624658188883347],
            [33.425769927478285, 2.620819562681912],
            [33.42307364133952, 2.617665625149223],
            [33.416601864520686, 2.607785527993196],
            [33.41560207194882, 2.603973370675958],
            [33.41412514819694, 2.600321333056449],
            [33.41348867205519, 2.59957504421482],
            [33.41355915477072, 2.598935159518819],
            [33.41289625917647, 2.598517688535456],
            [33.412259496472146, 2.596882705518361],
            [33.41077442769559, 2.595301322619568],
            [33.40929004074032, 2.595799464961267],
            [33.403608240585726, 2.596307871489583],
            [33.39617652585091, 2.595981417765355],
            [33.39522223474482, 2.596248320478395],
            [33.39386174163692, 2.59733296237761],
            [33.3898768294096, 2.598747231410788],
            [33.38508772917026, 2.599992879189014],
            [33.38191546349167, 2.60034044657237],
            [33.38037808491783, 2.601016323964022],
            [33.37809819306606, 2.600945920142057],
            [33.3752088445997, 2.60180881403904],
            [33.37459021977931, 2.601613489178376],
            [33.364296570465655, 2.605535684007846],
            [33.361566114210106, 2.60586528777747],
            [33.357634374162785, 2.605413613401503],
            [33.356512137624414, 2.600218804415418],
            [33.35377520092243, 2.596820722599791],
            [33.352486984465656, 2.593907785832591],
            [33.35039399968516, 2.590995037091333],
            [33.348783651859094, 2.587272857117888],
            [33.34089679221083, 2.583228707884187],
            [33.33735508808347, 2.578859711045107],
            [33.334939846169554, 2.574004815177968],
            [33.334456208491936, 2.571091565812677],
            [33.33558235629504, 2.569472765507272],
            [33.338961303659254, 2.567044097687005],
            [33.339604441707145, 2.564939901947195],
            [33.33654624859491, 2.5629984456777],
            [33.33203971432651, 2.561057427095705],
            [33.327854872151256, 2.55846890207001],
            [33.32495618390087, 2.55785295602452],
            [33.325222171463246, 2.557015965075278],
            [33.32341243716998, 2.555007980762658],
            [33.32004293828594, 2.552312809806705],
            [33.31762065627514, 2.549056476178035],
            [33.31810787643408, 2.547382701248348],
            [33.31606473647377, 2.545328786733735],
            [33.315169903059704, 2.542810877583898],
            [33.316241234765855, 2.53561587066301],
            [33.317671013135, 2.531658394595018],
            [33.31713368584782, 2.528600721098981],
            [33.313377354436106, 2.525543860659509],
            [33.30657926638695, 2.516552010745881],
            [33.30532642378944, 2.512415366808177],
            [33.30604037333623, 2.506479500489198],
            [33.304966473346674, 2.50252265384916],
            [33.30264142228728, 2.501983512687521],
            [33.30121045454872, 2.500544887926078],
            [33.300591581793256, 2.494718596646804],
            [33.3011710813898, 2.486161353806064],
            [33.30210948129854, 2.479199093804551],
            [33.303532189926386, 2.478126192277299],
            [33.30773862580444, 2.472633804203435],
            [33.30883629252146, 2.471692956994415],
            [33.310960518012585, 2.466815342408727],
            [33.310613071220246, 2.46055150510527],
            [33.308622838436925, 2.457246039142548],
            [33.30576789993752, 2.454810750030948],
            [33.303777103910484, 2.44837330416647],
            [33.302046251580606, 2.444284780851426],
            [33.30126660733878, 2.439065042805376],
            [33.30179905318073, 2.433495897456488],
            [33.30386984148884, 2.433751601140983],
            [33.30818501214385, 2.433473463417252],
            [33.31165997414057, 2.434277849501255],
            [33.31601562917048, 2.436511453992922],
            [33.31993134506977, 2.439704137282644],
            [33.32507199650394, 2.441041360193467],
            [33.326928473734746, 2.441878723966685],
            [33.32753442512312, 2.442603849576618],
            [33.32903370614579, 2.441170535586403],
            [33.33213439585915, 2.439610228157015],
            [33.33537634205769, 2.439042275885853],
            [33.33749019919377, 2.437056819879711],
            [33.33875803557171, 2.433795600425058],
            [33.339321109473254, 2.430676305748946],
            [33.34242129972333, 2.427131108797812],
            [33.344621282837295, 2.427716244409037],
            [33.3472141531239, 2.428405871306274],
            [33.352605417454384, 2.431986588205389],
            [33.35979483050593, 2.435109938364177],
            [33.36060519443553, 2.435830580104692],
            [33.361358194646016, 2.44105772341578],
            [33.368785938827294, 2.447681952642824],
            [33.37371979538813, 2.44867298945757],
            [33.38288224207855, 2.448953961016856],
            [33.38753465646089, 2.451646414112441],
            [33.390637351213975, 2.457174812596713],
            [33.39700699138162, 2.462868944796435],
            [33.39776262365591, 2.461452676935225],
            [33.39623976095869, 2.464481481133412],
            [33.396264257118176, 2.467466978505735],
            [33.398967272536765, 2.473301467308564],
            [33.399253671619014, 2.476006427796483],
            [33.3999563365292, 2.477670858165987],
            [33.40278971725839, 2.481306878189779],
            [33.40476549614882, 2.482165733567383],
            [33.40978703367126, 2.482498914783988],
            [33.4411352654601, 2.496927659987853],
            [33.45536219273683, 2.505634951184003],
            [33.45881900606985, 2.510184330302952],
            [33.4606624164065, 2.511730697977026],
            [33.46373408873956, 2.512887607641773],
            [33.46707468702428, 2.516170431559168],
            [33.46653799843927, 2.51833283269738],
            [33.4657740396806, 2.527986143748099],
            [33.467580730481735, 2.535204907841874],
            [33.46988552632808, 2.53922088571246],
            [33.471882615053644, 2.541147140397165],
            [33.480601253569546, 2.551665415948219],
            [33.48117796299881, 2.554370213120693],
            [33.480603300830104, 2.557165912424101],
            [33.48108494604439, 2.561227774973085],
            [33.48003072904104, 2.565570669877569],
            [33.48305497392037, 2.568799255742074],
            [33.49445537910508, 2.575552863482875],
            [33.51017425894839, 2.582186998239737],
            [33.52349337574848, 2.586641624314799],
            [33.537231683291026, 2.592633153351772],
            [33.53392287818084, 2.603406978018094],
            [33.53298063078777, 2.603729620409684],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 692,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "OGOR",
        Population: 14388,
        Key: "OTUKEOGOR",
        Dist2: "Otuke",
        "Sub Country": "Ogor",
        id2_original: "OtukeOgor",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.08355508775409, 2.371789059794172],
            [33.08283866694195, 2.372541852727535],
            [33.08353065806993, 2.373307414620119],
            [33.08416205334043, 2.373229076015761],
            [33.08432643964751, 2.374046869219205],
            [33.08391510018062, 2.375603664240239],
            [33.08588898182915, 2.379080191302207],
            [33.08528536246724, 2.379839233425649],
            [33.086451757490025, 2.38338577932913],
            [33.0855462961078, 2.384048240431866],
            [33.08523079161036, 2.384834863829697],
            [33.08392746459217, 2.385621548707763],
            [33.08436655930642, 2.386656527529869],
            [33.08376299833502, 2.388436774762148],
            [33.08479214515543, 2.391113924839507],
            [33.08377693030676, 2.391941992247624],
            [33.08318705516871, 2.393211635877389],
            [33.08051175457331, 2.394288201464421],
            [33.08005910787466, 2.39613743909504],
            [33.0790027268298, 2.396965505262878],
            [33.078810751463685, 2.398759525143099],
            [33.077987671881246, 2.400746784695471],
            [33.075815359572964, 2.402913523113235],
            [33.07362943868647, 2.403113507014518],
            [33.07149021761834, 2.403929805100055],
            [33.06123625407729, 2.411776740680742],
            [33.06096459095896, 2.411072143666778],
            [33.06002350598584, 2.411286874417799],
            [33.05903694739474, 2.410114894247313],
            [33.05790627298093, 2.411742116170797],
            [33.05648114339337, 2.415786741757492],
            [33.05564962324053, 2.423620443287826],
            [33.05505443456754, 2.42464508805803],
            [33.051706702761166, 2.424486188205689],
            [33.051033947258375, 2.423461861034371],
            [33.04897841414041, 2.42315181194722],
            [33.04813606839008, 2.422031458877614],
            [33.04677333668047, 2.421366321867284],
            [33.042826976551886, 2.421380081642381],
            [33.04188941656794, 2.421992865827642],
            [33.036305709747424, 2.430179577693838],
            [33.03087209434288, 2.433458987556144],
            [33.02804659812691, 2.438049969177461],
            [33.02381146736374, 2.440106290379627],
            [33.02214221341121, 2.438004587879016],
            [33.0207926339357, 2.438228977760262],
            [33.02021821790537, 2.437712939135626],
            [33.020865109114496, 2.43669765985718],
            [33.0206754909277, 2.436232097131883],
            [33.020140109391406, 2.435452423188538],
            [33.01860519938792, 2.434614836425032],
            [33.01819111017792, 2.433318788263338],
            [33.01758366848449, 2.432712633702422],
            [33.01467664117336, 2.432495536034754],
            [33.0137653407418, 2.431446070392247],
            [33.01359189941663, 2.430487068171337],
            [33.011682735994434, 2.429437609942118],
            [33.0108799340829, 2.427800072645202],
            [33.01087992509973, 2.426669172300651],
            [33.006627890737846, 2.423348875060436],
            [33.00510916747749, 2.421213741021497],
            [33.00552151754911, 2.420010460534995],
            [33.0045236509652, 2.417477247013482],
            [33.00078042687183, 2.414102645368462],
            [32.99645621377516, 2.41246509672166],
            [32.99182060148192, 2.40550777382315],
            [32.99068446620949, 2.404964933437715],
            [32.990323287769726, 2.402757412024737],
            [32.98725106656602, 2.401174124970323],
            [32.98472107924759, 2.397745206694313],
            [32.98286229693981, 2.396632378247339],
            [32.98206179561371, 2.395094342079783],
            [32.98197158499625, 2.393891061865833],
            [32.98339170288281, 2.385920487640762],
            [32.983223955978254, 2.381224983188244],
            [32.981726416788916, 2.37762417441826],
            [32.98092619843214, 2.376818961492893],
            [32.98243647842714, 2.372856303176629],
            [32.98243651885134, 2.369689778639376],
            [32.98132657665594, 2.367608904815099],
            [32.98056491488948, 2.363809064595666],
            [32.98017794132633, 2.359004988742],
            [32.98324983913652, 2.355883741225285],
            [32.987057842541674, 2.353793874737718],
            [32.9889786274687, 2.351882323092123],
            [32.99806710059042, 2.3469023378589],
            [32.99787690568523, 2.342157573183537],
            [32.998333391783376, 2.339364284927697],
            [32.99732118988417, 2.331697628729052],
            [32.999397110267495, 2.330466164559327],
            [33.002350307390984, 2.325364479129331],
            [33.002605785562835, 2.32147274595131],
            [33.0030913186857, 2.321129546181578],
            [33.00558457838373, 2.315486541307815],
            [33.006207878935186, 2.311552941868223],
            [33.007905808908234, 2.311097100910695],
            [33.00896960913902, 2.309874128803486],
            [33.00983254607231, 2.309488538642058],
            [33.01042942447634, 2.309921190101267],
            [33.01175544832846, 2.309946859246614],
            [33.012412901030395, 2.30936850989832],
            [33.01349244872814, 2.309763382023366],
            [33.014116747307895, 2.311492494949194],
            [33.01519171719096, 2.312622683342652],
            [33.01941555792764, 2.315499743838769],
            [33.01946212928689, 2.316208984086076],
            [33.02038551565231, 2.317587012256014],
            [33.02588111211649, 2.322685728780772],
            [33.02858835949836, 2.322879713163265],
            [33.03061224766381, 2.323539708652814],
            [33.034043461706176, 2.323626189268576],
            [33.03708766176123, 2.325653377253954],
            [33.03778396570086, 2.327129633944073],
            [33.03925842357731, 2.327637705856428],
            [33.041777247531705, 2.326985326408324],
            [33.04236430555303, 2.327321761532049],
            [33.046753491099224, 2.326827241985066],
            [33.050528273008524, 2.324931986772422],
            [33.05329968435618, 2.325103543122059],
            [33.054850923036575, 2.326698598892135],
            [33.05608723483623, 2.32897146982428],
            [33.058005624854715, 2.330143767322953],
            [33.05879535627884, 2.331391704908415],
            [33.06214796503893, 2.33380059503127],
            [33.06285554283541, 2.334779072736811],
            [33.06347462040671, 2.337002944041152],
            [33.06851585888169, 2.345364535431704],
            [33.07355696979585, 2.350701635435998],
            [33.07470668310381, 2.351591182881356],
            [33.08045499362374, 2.351146094186328],
            [33.082842795599014, 2.351323827922061],
            [33.08399250890694, 2.352658087248471],
            [33.084169512950524, 2.354615106264843],
            [33.081782342490946, 2.364489383770496],
            [33.08187084541105, 2.36600162890176],
            [33.08471738017097, 2.367712207250464],
            [33.08328450441071, 2.371022321275635],
            [33.08355508775409, 2.371789059794172],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 693,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "APALA",
        Population: 19621,
        Key: "ALEBTONGAPALA",
        Dist2: "Alebtong",
        "Sub Country": "Apala",
        id2_original: "Alebtong Apala",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.62823672036366, 0.332430658911365],
            [31.628106259831586, 0.331752286858291],
            [31.6257051142811, 0.332376035973117],
            [31.62377966440279, 0.332303403014386],
            [31.623351709696387, 0.332873162460543],
            [31.619643387846747, 0.333189202405014],
            [31.617075933594453, 0.334527451168539],
            [31.614782255298056, 0.333631696937121],
            [31.613474983777447, 0.332021556838762],
            [31.61174007824904, 0.330727922719192],
            [31.60598692760635, 0.333648529283547],
            [31.601125133897593, 0.338902757645756],
            [31.59520557304349, 0.343234255689709],
            [31.59427848022925, 0.343469278595739],
            [31.592031713753578, 0.346381302568088],
            [31.590462684837302, 0.347430242505367],
            [31.589464022346085, 0.349392766400922],
            [31.586230533785944, 0.353245260108587],
            [31.581534680469716, 0.360027953481705],
            [31.574545540522568, 0.3636898824665],
            [31.57025075443802, 0.367704957387742],
            [31.557881694085804, 0.356370225263839],
            [31.54829152714923, 0.348843734376449],
            [31.536324317359586, 0.341099866093145],
            [31.520158955955434, 0.334594496685058],
            [31.51401923688978, 0.329402134665161],
            [31.507254748527227, 0.321216054182074],
            [31.504777417755797, 0.319533456907552],
            [31.499990506710823, 0.31713602696198],
            [31.489542645408978, 0.315090498073423],
            [31.476772420807063, 0.311950296263422],
            [31.456673111296624, 0.306267660732451],
            [31.44911419152432, 0.306610224773221],
            [31.44368286772207, 0.305949213407403],
            [31.4370321033795, 0.30678027521688],
            [31.42324774190726, 0.302925518760415],
            [31.420910123417038, 0.302581504741895],
            [31.41789895710995, 0.302716717272106],
            [31.413535357379683, 0.300030044341244],
            [31.411213231234843, 0.299396632934305],
            [31.403914705215648, 0.297912370347732],
            [31.388539317780737, 0.29656257727059],
            [31.3622102313008, 0.292552322666821],
            [31.35707478380705, 0.289729954889979],
            [31.355761590592106, 0.289485583915103],
            [31.351318600451954, 0.285433404738004],
            [31.34847004538099, 0.283868451926865],
            [31.342779555822634, 0.283596317834867],
            [31.340384300525447, 0.282583094342265],
            [31.340188578286313, 0.281027578733135],
            [31.339495768793117, 0.280946087245483],
            [31.33781452143323, 0.27901957520433],
            [31.33709039666922, 0.276062241899587],
            [31.335751658960845, 0.275908311971519],
            [31.335168519390795, 0.276496056663],
            [31.333708873835093, 0.275763324666557],
            [31.333901467242104, 0.273620042692596],
            [31.331243920949966, 0.271349752556021],
            [31.33027802720367, 0.268853615443053],
            [31.327775911913555, 0.265172574977844],
            [31.326877611900816, 0.263083410473329],
            [31.32468514049925, 0.261391984951258],
            [31.323390696022592, 0.259655466033925],
            [31.322721539170843, 0.256960428992726],
            [31.32117768643872, 0.256209616522149],
            [31.31968788443892, 0.254292210321695],
            [31.31796012500855, 0.253830766466457],
            [31.318198061777885, 0.252537587765479],
            [31.31688282848894, 0.248730134625976],
            [31.316691658911626, 0.246532558860835],
            [31.31430541192013, 0.24326758183649],
            [31.313047006056067, 0.238365897717476],
            [31.313438852979633, 0.234034157615816],
            [31.311076198442443, 0.225795335208606],
            [31.31107645176736, 0.223615877393856],
            [31.3119191855899, 0.220975303982109],
            [31.31137320752651, 0.218370743299195],
            [31.311479967806456, 0.212546808864075],
            [31.3110049566505, 0.210340168090447],
            [31.3094617048913, 0.209200531636573],
            [31.3048434633207, 0.208377076635838],
            [31.30327633793451, 0.207391179405958],
            [31.302350423709935, 0.205862750804923],
            [31.3022778595979, 0.201892711067389],
            [31.310109639942826, 0.200871639221911],
            [31.312650378298546, 0.201088951131993],
            [31.318360736794368, 0.203558408044593],
            [31.321732359295712, 0.206904841876173],
            [31.328250185552662, 0.208470062432326],
            [31.330790960739332, 0.208542686250581],
            [31.333806216177603, 0.208036576068871],
            [31.336881166463126, 0.205875509494539],
            [31.33794961457723, 0.205613359428625],
            [31.339873112416416, 0.205586435296267],
            [31.34546494090542, 0.206762687103682],
            [31.348361704066118, 0.206762996122105],
            [31.357871345122312, 0.205000497642058],
            [31.359984623743365, 0.205027849370717],
            [31.367523506593237, 0.207235287690342],
            [31.371298926306412, 0.207642647645633],
            [31.37665326269218, 0.206983019050474],
            [31.38071387684679, 0.205039046799041],
            [31.385070874858062, 0.203782416816762],
            [31.389178747583145, 0.203809964378991],
            [31.39170759314282, 0.203249512602552],
            [31.394319602934885, 0.202074083389505],
            [31.397928868456486, 0.199732108992947],
            [31.40420940023952, 0.199045405913593],
            [31.40648897768091, 0.198421606058014],
            [31.409801279932495, 0.195753997349187],
            [31.41041847194005, 0.194225647609761],
            [31.41037099507896, 0.19163910265237],
            [31.40843576883543, 0.187252657590488],
            [31.408507035780165, 0.184575688543525],
            [31.4117716806093, 0.177793096213815],
            [31.41418176978676, 0.17423907319222],
            [31.414395328075898, 0.17182438038068],
            [31.415190858125193, 0.169138418791563],
            [31.41754144020329, 0.165403490387414],
            [31.419642864655845, 0.163404967194949],
            [31.42484303037592, 0.161008751320107],
            [31.428719917495375, 0.161235154622576],
            [31.43158116845628, 0.16081936025567],
            [31.434122044254256, 0.161262710334813],
            [31.43744122580428, 0.160241005586244],
            [31.43899766932342, 0.159481430867755],
            [31.44196183038499, 0.157139272249582],
            [31.44507495008695, 0.156289374846847],
            [31.446471297652774, 0.156587929716994],
            [31.45126685408405, 0.15210246104846],
            [31.453258156760885, 0.151406216144815],
            [31.454746170214932, 0.149796486530576],
            [31.45600503062656, 0.149145406896167],
            [31.45719517710544, 0.147598959624864],
            [31.458087941699432, 0.147237261359439],
            [31.461670393408102, 0.147499792234513],
            [31.463913822642457, 0.146550322817604],
            [31.46581355914405, 0.146622810335587],
            [31.468011236282702, 0.145628110853116],
            [31.469601887647848, 0.145709622820236],
            [31.471181383733835, 0.144669659131213],
            [31.472532028611266, 0.144371299031778],
            [31.473241495564775, 0.143765389983055],
            [31.47347035306151, 0.142942391130019],
            [31.47904441107757, 0.142834241492642],
            [31.481813995251926, 0.141333099284859],
            [31.483439303620763, 0.13962386286327],
            [31.487502495041944, 0.138783022476069],
            [31.488601154397365, 0.136820507497111],
            [31.490020348815804, 0.1359252247664],
            [31.493579577277746, 0.131294820919947],
            [31.496097591850056, 0.130372467326888],
            [31.497905942737823, 0.128690352899887],
            [31.5005612576148, 0.127514764761862],
            [31.500807273831768, 0.126022480776291],
            [31.508297383551604, 0.122332864228817],
            [31.515867298703007, 0.117603126947912],
            [31.527894412647356, 0.11105568100334],
            [31.53221774000515, 0.108170751239717],
            [31.541218639064773, 0.097743008388865],
            [31.565199038911885, 0.073414387772736],
            [31.566966372723755, 0.080903294140601],
            [31.5697253576761, 0.086682838289714],
            [31.571750033664067, 0.088944047917541],
            [31.57785417135958, 0.094018282229929],
            [31.57973733574082, 0.096614147500722],
            [31.581444437512904, 0.099906441225587],
            [31.58377931703984, 0.102719406037015],
            [31.58717314948829, 0.106436883611214],
            [31.589503880595235, 0.10791126255146],
            [31.591146762705947, 0.109557457379416],
            [31.602819495762304, 0.123143074484125],
            [31.60544919517895, 0.125413423581506],
            [31.60720863279949, 0.12629085181687],
            [31.615895823992236, 0.129954430201657],
            [31.621673878629526, 0.133084226067416],
            [31.630525399535504, 0.136060454971739],
            [31.635624930587575, 0.138557107623553],
            [31.646865451821384, 0.146625740630458],
            [31.65218719553203, 0.151971564395978],
            [31.66216747654197, 0.159280453363452],
            [31.672296721582228, 0.16873304949345],
            [31.673354875003156, 0.169311997700176],
            [31.674660147772222, 0.169194504861881],
            [31.682068865635777, 0.165893618141172],
            [31.683493729322, 0.166056524239487],
            [31.689080464363325, 0.168788484289169],
            [31.690980109236783, 0.168897154813892],
            [31.692651821878247, 0.168291256354235],
            [31.70165599439876, 0.154697219276935],
            [31.706354106079587, 0.149089594756591],
            [31.709381067464335, 0.148700840248593],
            [31.714557264336023, 0.148945367132247],
            [31.720734602150788, 0.150646210817046],
            [31.722111487716, 0.150619158145748],
            [31.72752049826491, 0.145518044229845],
            [31.729920410428516, 0.142234806541566],
            [31.73263460627911, 0.136979744206454],
            [31.733746724194077, 0.131769811959601],
            [31.73794870891991, 0.131824301823942],
            [31.742717900695933, 0.130983349775623],
            [31.745246231520944, 0.130992526042293],
            [31.749242855084617, 0.133742465705701],
            [31.74979363913478, 0.135415853580546],
            [31.749504592717383, 0.137948488213958],
            [31.74422865140815, 0.147897882024907],
            [31.74305092413804, 0.150973167701782],
            [31.741212833624495, 0.153858461743601],
            [31.738940710403316, 0.156110565854039],
            [31.73671355594698, 0.157611920850016],
            [31.733097442567974, 0.159022735787509],
            [31.730439660018934, 0.159411508073438],
            [31.727779962261685, 0.159058581124195],
            [31.7241133851233, 0.159456332934261],
            [31.72217039294414, 0.160704431148919],
            [31.720088348745495, 0.163092198438753],
            [31.713604977371286, 0.182104479866306],
            [31.708270695874255, 0.200501691901086],
            [31.708406180683724, 0.20208458462986],
            [31.709477499813456, 0.203179121059643],
            [31.717200094427174, 0.205612871646542],
            [31.722774819891473, 0.208191177804333],
            [31.72427566488106, 0.209955094359289],
            [31.724749033018355, 0.21344653996419],
            [31.725489565511023, 0.215065675467649],
            [31.727849165776213, 0.218204527431867],
            [31.731291074262067, 0.222021863112023],
            [31.735022927480568, 0.223659357319021],
            [31.738201807454587, 0.226906842578621],
            [31.73872868284347, 0.228408382689296],
            [31.73899879097802, 0.231483756466535],
            [31.738196671786113, 0.237218302639003],
            [31.736966482005116, 0.238656365447803],
            [31.73451300240282, 0.239813911855919],
            [31.73352527779846, 0.239542466708279],
            [31.733003865064827, 0.239786634751227],
            [31.72882725954243, 0.244381156617059],
            [31.728083800338553, 0.247058434037874],
            [31.72754050913618, 0.247058381037771],
            [31.726161423596846, 0.249428065107799],
            [31.723593529170074, 0.254854868139223],
            [31.723786259121013, 0.2554906525611],
            [31.720509867022898, 0.26500070125575],
            [31.714990025029195, 0.271656070137194],
            [31.710505511163348, 0.273739182194616],
            [31.70653808643969, 0.278716224014187],
            [31.69969596746687, 0.285174590736962],
            [31.694463883706426, 0.288936007913916],
            [31.688263375645526, 0.290864609547885],
            [31.68854525350695, 0.291250828034449],
            [31.685354782570812, 0.292239695052619],
            [31.6712153952202, 0.294004539893174],
            [31.66962515797838, 0.294004347656226],
            [31.667239988066907, 0.292509865246592],
            [31.66260313250532, 0.293397797874103],
            [31.661271937950414, 0.294184539243603],
            [31.655530997209066, 0.295631008014631],
            [31.65362880201852, 0.298190466132305],
            [31.652202442637364, 0.298859607613297],
            [31.65039599527968, 0.299031230208879],
            [31.64603328667816, 0.303127982719075],
            [31.644131349304107, 0.305786914402754],
            [31.64310899015399, 0.306600812360437],
            [31.64159896887379, 0.311665699822746],
            [31.641241995447874, 0.314795147249802],
            [31.631529698056852, 0.328831311431941],
            [31.62823672036366, 0.332430658911365],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1896,
        District: "GOMBA",
        County: "GOMBA",
        Subcounty: "MADDU",
        Population: 35357,
        Key: "GOMBAMADDU",
        Dist2: "Gomba",
        "Sub Country": "Maddu",
        id2_original: "Gomba Maddu",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.415928239448704, 2.142873336895207],
            [33.41438700710224, 2.146121631228645],
            [33.413599071410346, 2.146348021130798],
            [33.41303678083973, 2.147551425813977],
            [33.41245186530035, 2.147754849151395],
            [33.40998798141044, 2.150515397994373],
            [33.409059958839876, 2.150646579039994],
            [33.40748521484177, 2.153252541992775],
            [33.40534636387951, 2.154501603532652],
            [33.405384150613614, 2.15499013181935],
            [33.404390168345, 2.156103180957555],
            [33.40303970762218, 2.156709691576809],
            [33.40247636692099, 2.156103691737066],
            [33.40075054066514, 2.157054086964439],
            [33.40056365066184, 2.158103589754869],
            [33.39864977737262, 2.157841732534351],
            [33.39864992649297, 2.158411695298661],
            [33.39699918232686, 2.15848450595503],
            [33.39642242708351, 2.16019031294217],
            [33.39553629924288, 2.161244231031634],
            [33.39572435975097, 2.162528859092506],
            [33.395374538711344, 2.162518117507288],
            [33.394031931060745, 2.164471152966718],
            [33.394290008058704, 2.165433530493174],
            [33.39319271504084, 2.166381667618029],
            [33.393301730990466, 2.167124707475034],
            [33.39277832040366, 2.167230160684631],
            [33.39217396532152, 2.169196230544375],
            [33.3928389962112, 2.16994203115352],
            [33.392165630752324, 2.170282176655301],
            [33.392343062393984, 2.170875403261443],
            [33.39193678403538, 2.171812095274342],
            [33.39141181756649, 2.171812232617871],
            [33.39182018810141, 2.173063786962929],
            [33.39168642356569, 2.1739913348629],
            [33.39071109481397, 2.174877257319636],
            [33.38947453957084, 2.177750015396744],
            [33.38898685228794, 2.178109196845035],
            [33.388594193287354, 2.17789386554475],
            [33.38771408595574, 2.178971258721897],
            [33.38565367318914, 2.17919609973771],
            [33.384408487831124, 2.1797652905441],
            [33.382687776582486, 2.181429293536532],
            [33.38284536623613, 2.181825338476662],
            [33.38227169221423, 2.181972603846563],
            [33.382001623605554, 2.181633170136452],
            [33.378908988187, 2.185255316955032],
            [33.37818970893562, 2.187948886697136],
            [33.37886508572245, 2.189612277395694],
            [33.378640357781066, 2.19064215806688],
            [33.378089266507104, 2.191140235622625],
            [33.38005849578076, 2.19350493367321],
            [33.37969185378745, 2.194894230566867],
            [33.380404802611004, 2.195843987349876],
            [33.37939152722503, 2.19640516205981],
            [33.379354526516785, 2.196785147584183],
            [33.37995481133234, 2.196748805120009],
            [33.38115600259767, 2.199127866630987],
            [33.37924268626392, 2.201281551680466],
            [33.377273256665944, 2.201598701208761],
            [33.37723577715564, 2.202313426969626],
            [33.376560078771995, 2.201978858657254],
            [33.37652255165098, 2.202503596277651],
            [33.37595994397506, 2.20262135021553],
            [33.373971179038925, 2.202051890721224],
            [33.37385892376437, 2.202694259269704],
            [33.37310800944198, 2.202766824519824],
            [33.37295778597363, 2.202169757798911],
            [33.372094924498825, 2.201862375743885],
            [33.37051887345197, 2.201898959551892],
            [33.36995589207689, 2.200505855049389],
            [33.3679668540529, 2.198805506594173],
            [33.3670284020419, 2.197376305404094],
            [33.366426981755815, 2.195069456641372],
            [33.36100346341505, 2.187733625028616],
            [33.36010249450757, 2.185508267312061],
            [33.358751026773334, 2.184450086999559],
            [33.35512871412055, 2.178235623258162],
            [33.352238914699925, 2.17491603299406],
            [33.343626887343646, 2.172258193216325],
            [33.33231314083774, 2.170089441311301],
            [33.32912401198467, 2.17024394395282],
            [33.32300791052617, 2.171674712259482],
            [33.314508685518426, 2.170681336747461],
            [33.31128215980006, 2.172156686513775],
            [33.307680402397594, 2.174799183524904],
            [33.30437888262437, 2.177966345820223],
            [33.30435258713937, 2.179513911930636],
            [33.30191422797995, 2.18247085304063],
            [33.301090910343945, 2.184167361892306],
            [33.30123378289831, 2.185132942280895],
            [33.296813623441125, 2.192810072446454],
            [33.29607790232511, 2.192513241328124],
            [33.29547115502937, 2.190527342119718],
            [33.29468136341811, 2.189931692399302],
            [33.285275201096155, 2.186911934197626],
            [33.28222886215242, 2.184486728683748],
            [33.28383553047912, 2.179805084942803],
            [33.28310127182038, 2.174485520258925],
            [33.28256522103918, 2.173379122881871],
            [33.28297385118722, 2.171747669496531],
            [33.28263532197071, 2.171208670602856],
            [33.28332608959327, 2.170187157288157],
            [33.28318490317669, 2.16925091579721],
            [33.284284486000224, 2.167605146364063],
            [33.284495715856124, 2.166073032269733],
            [33.28043406504566, 2.163208245799924],
            [33.27906092006529, 2.163269444799256],
            [33.265770319385595, 2.173124434394843],
            [33.26434899057002, 2.167506412259742],
            [33.26491403627364, 2.165235480302256],
            [33.26524564307255, 2.155455463008662],
            [33.26822466586216, 2.146290185975105],
            [33.26927787226084, 2.145747171683947],
            [33.272925561422056, 2.142127665753315],
            [33.27559666598678, 2.140109673642508],
            [33.27605905401633, 2.139078216404566],
            [33.27682958035804, 2.138770474115199],
            [33.27713799984284, 2.137938081435223],
            [33.27677805119671, 2.136644406398908],
            [33.277933788606965, 2.134346224837938],
            [33.27860097994487, 2.131396737993975],
            [33.27803605910712, 2.131089238339221],
            [33.27783017961704, 2.130157420937456],
            [33.27834383180491, 2.129795441738389],
            [33.27947336805327, 2.125606413607454],
            [33.27937539419513, 2.124872080990107],
            [33.2788253638315, 2.12466808907263],
            [33.2794786303842, 2.123371988977962],
            [33.28142521851948, 2.121634365144039],
            [33.282658320638596, 2.121426054864195],
            [33.28581746103256, 2.117571393524346],
            [33.28808015912979, 2.117259893650203],
            [33.28951638830095, 2.114983224516976],
            [33.290646598285804, 2.114621125961371],
            [33.29059498108958, 2.112087940953815],
            [33.29105736283091, 2.111110764510326],
            [33.291416403280316, 2.107518987413474],
            [33.2942668915258, 2.103429148114593],
            [33.300381095742424, 2.102034718392441],
            [33.30521000662019, 2.098315411040097],
            [33.30577430582379, 2.095474506099006],
            [33.30541440838162, 2.094488440846834],
            [33.306030845804315, 2.093864069075319],
            [33.305953310415504, 2.091104713659522],
            [33.30744251952722, 2.0872232082727],
            [33.309857228740185, 2.085368072962566],
            [33.310627566435684, 2.08428226726018],
            [33.31144934974915, 2.081848428033791],
            [33.31247652297088, 2.080708287016944],
            [33.3114220274898, 2.074375521698944],
            [33.31347666947897, 2.070756269026414],
            [33.31424714192177, 2.070394228484767],
            [33.31460668722434, 2.06962515206404],
            [33.31440067658021, 2.068069092875236],
            [33.31493977354854, 2.065771018667191],
            [33.31694312353165, 2.064323080377296],
            [33.317148647288874, 2.063445467818141],
            [33.31822777457504, 2.06359905283394],
            [33.31925487233832, 2.062151308271857],
            [33.319871406779036, 2.0620968984378],
            [33.3200251938641, 2.061065497414813],
            [33.32146373440053, 2.05982575302877],
            [33.327236267093795, 2.05150445302282],
            [33.32837249848595, 2.050442492364872],
            [33.331248590513674, 2.046045009658321],
            [33.33633448334307, 2.044135004645469],
            [33.33903093207691, 2.040850341349674],
            [33.339646985020686, 2.038579382146583],
            [33.3409231092554, 2.037529651028173],
            [33.34319182696334, 2.036823491803502],
            [33.34493829830105, 2.035529387047066],
            [33.34719853321777, 2.031955302004846],
            [33.348730247015446, 2.030718602733327],
            [33.358629060710584, 2.028053492579947],
            [33.36186558916964, 2.027591372569153],
            [33.364027713684266, 2.027862290118311],
            [33.36562061083765, 2.036004293209352],
            [33.36346159359559, 2.042111550255218],
            [33.3621260916189, 2.043975550105642],
            [33.36017472354799, 2.048834269158273],
            [33.356172676854975, 2.053610410274811],
            [33.354652974430955, 2.054390419905369],
            [33.3518788187301, 2.056924215756724],
            [33.35018398075826, 2.057955956111508],
            [33.34877167911298, 2.060824199927992],
            [33.347723417041614, 2.061827502940475],
            [33.34760319999876, 2.063576825869802],
            [33.348258857866725, 2.064859310149224],
            [33.34841340941812, 2.067392454645344],
            [33.34903036606703, 2.06925601650777],
            [33.35174894389957, 2.071896953166559],
            [33.35342458936536, 2.075633219111445],
            [33.36118809056214, 2.098529579298648],
            [33.36293568299732, 2.10189467909215],
            [33.36545380177422, 2.105096746781472],
            [33.368306218702614, 2.10775590501018],
            [33.371492371437164, 2.109881200045523],
            [33.37739704181715, 2.111937616652592],
            [33.379714854251965, 2.111865278676881],
            [33.38703544648783, 2.113722373642786],
            [33.38888548549296, 2.115169434210062],
            [33.39029234873752, 2.117643421526925],
            [33.39325397744829, 2.118579054526766],
            [33.39430758090229, 2.11989965149827],
            [33.395683596898316, 2.120300471121257],
            [33.39686934073403, 2.121562899287063],
            [33.398760986109856, 2.122342849158084],
            [33.400199192472975, 2.122386319337007],
            [33.40221294854035, 2.123473147024156],
            [33.402404962534, 2.124455222487433],
            [33.40314591633655, 2.124700559696322],
            [33.403834922362826, 2.12629633232856],
            [33.40820855178326, 2.130417696669078],
            [33.4091533467985, 2.131775530617382],
            [33.41010428718858, 2.135002257169461],
            [33.411211480539194, 2.135791166380554],
            [33.41278132153251, 2.139114182326332],
            [33.4140543995801, 2.140902706003465],
            [33.415327253048886, 2.141849407730807],
            [33.41541463756647, 2.142664896632458],
            [33.415928239448704, 2.142873336895207],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 694,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "AMUGU",
        Population: 27708,
        Key: "ALEBTONGAMUGU",
        Dist2: "Alebtong",
        "Sub Country": "Amugu",
        id2_original: "Alebtong Amugu",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.25863960225473, 2.246036568829076],
            [33.25998383136442, 2.245881383793884],
            [33.26156253603464, 2.255540599273846],
            [33.264018520139935, 2.259087735090807],
            [33.26674738637743, 2.264408454883055],
            [33.266651613391716, 2.273285578780858],
            [33.263282145948736, 2.270582996119543],
            [33.259379430468236, 2.268910576300716],
            [33.25596831982358, 2.268092034700288],
            [33.255681455414035, 2.275917359452442],
            [33.25462459916034, 2.277056177718615],
            [33.252130636979786, 2.278054693991431],
            [33.25202488191462, 2.279746626103245],
            [33.25555387038917, 2.279682776816268],
            [33.258075756700336, 2.280861322732966],
            [33.258786222580454, 2.281611466013628],
            [33.2609327200024, 2.285413946566307],
            [33.2618354172685, 2.296060013771966],
            [33.2518750231623, 2.295241440953135],
            [33.248736841362245, 2.295787149635446],
            [33.243006163873005, 2.297560740907658],
            [33.24300616117809, 2.294832162895095],
            [33.246963036985385, 2.285145688684822],
            [33.23195421698367, 2.285145694070452],
            [33.22608709797918, 2.285964249321078],
            [33.21162408086935, 2.27218494092729],
            [33.203164553312334, 2.266045624367648],
            [33.20125429933539, 2.261952767202178],
            [33.20357384731536, 2.257450590068175],
            [33.207530746478824, 2.25513129020076],
            [33.20875870484466, 2.249946984092598],
            [33.22049290422601, 2.233439052919213],
            [33.22384849629116, 2.226513199384629],
            [33.22940932032645, 2.22791099202821],
            [33.23413866732802, 2.23083247375456],
            [33.2345329019736, 2.232144247450436],
            [33.23544403442021, 2.23199934603163],
            [33.23758717393961, 2.234722191620257],
            [33.23800622095166, 2.23650441211954],
            [33.23784625525409, 2.237933887889247],
            [33.23851152150235, 2.239833680419665],
            [33.238293819284834, 2.242249305671968],
            [33.243188995287866, 2.244854072878925],
            [33.24490005593539, 2.245052822494765],
            [33.245887188549965, 2.245577390405126],
            [33.24924350286057, 2.245712525215255],
            [33.25077810923351, 2.246164617744444],
            [33.25863960225473, 2.246036568829076],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 695,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "ALEBTONG TOWN COUNCIL",
        Population: 6702,
        Key: "ALEBTONGALEBTONG TOWN COUNCIL",
        Dist2: "Alebtong",
        "Sub Country": "Alebtong T/C",
        id2_original: "Alebtong Alebtong T/C",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11194715169074, 2.255319648470884],
            [33.12353239243169, 2.259441140368457],
            [33.12990921193512, 2.263019389652681],
            [33.13357356753981, 2.264409391094265],
            [33.134859004609105, 2.261612432716146],
            [33.13516601733218, 2.259258187184407],
            [33.13729723261451, 2.258595900073761],
            [33.146101512916324, 2.258340750506076],
            [33.14848594620925, 2.26032849453541],
            [33.1491363291699, 2.261675127570446],
            [33.148082094200234, 2.265774965358419],
            [33.14781010229851, 2.268805106103659],
            [33.15057924360347, 2.269853116939978],
            [33.15519433208742, 2.270152140568234],
            [33.17110776186845, 2.27363567470209],
            [33.171353413369395, 2.275090964170202],
            [33.17063843614992, 2.276840193063204],
            [33.17078811254427, 2.277517353226108],
            [33.17018978336107, 2.277993956627249],
            [33.17011775195001, 2.278714680606039],
            [33.16855477139055, 2.281016136006065],
            [33.16632106013093, 2.283348418558911],
            [33.165345411578954, 2.283348531656776],
            [33.16705890576258, 2.284736701258463],
            [33.16860316093994, 2.284640241443222],
            [33.163702242905636, 2.289263163072285],
            [33.165270498372436, 2.291906322944731],
            [33.167317469647436, 2.291219690940117],
            [33.16955300808035, 2.289116437152619],
            [33.17030792439734, 2.288926493643727],
            [33.17144015738818, 2.287451345322817],
            [33.17229670280823, 2.2872905978149],
            [33.172906367832006, 2.286516506837808],
            [33.17656463375738, 2.284237821622962],
            [33.17915263337853, 2.278152094938708],
            [33.18233945625629, 2.274140596219274],
            [33.18380841015498, 2.273361940112833],
            [33.18492315474386, 2.272108329100143],
            [33.186714185214626, 2.271585546241108],
            [33.1936468265203, 2.266143034203441],
            [33.19508754457296, 2.265866745384231],
            [33.195216610021404, 2.267433548523938],
            [33.19015963126604, 2.278544907599959],
            [33.18987562799065, 2.282638118066353],
            [33.18820428365847, 2.289749881199826],
            [33.18825086849245, 2.296623328442624],
            [33.18790529289087, 2.300324379012523],
            [33.1871784722827, 2.302285899393172],
            [33.18750933347992, 2.30512271769638],
            [33.187046770278876, 2.30606470675862],
            [33.18761971127551, 2.306751682577763],
            [33.18799447673394, 2.308347367580621],
            [33.1889529782438, 2.308934559463928],
            [33.18934974883342, 2.31029752963317],
            [33.19424138906751, 2.313000747313608],
            [33.19670936658016, 2.315205621507495],
            [33.19701796572804, 2.316213993487649],
            [33.19831808665896, 2.317532506679771],
            [33.19947483826717, 2.317720728405423],
            [33.20001471497314, 2.318230399599295],
            [33.20268073776829, 2.318551381380423],
            [33.20333081889501, 2.319326991608271],
            [33.20407994107842, 2.319360127546048],
            [33.20475212165944, 2.320590073730888],
            [33.20621742929639, 2.321420970059692],
            [33.205820915624926, 2.321964020835616],
            [33.206008249395964, 2.322329682279254],
            [33.20724214562582, 2.322695189244961],
            [33.20738546374458, 2.323404382800948],
            [33.206614463990725, 2.324457236399562],
            [33.20789242707683, 2.324811655059519],
            [33.20826706317788, 2.325321347930785],
            [33.20855360958385, 2.326130252682106],
            [33.208399686853156, 2.328224674318617],
            [33.20923720326056, 2.329997585066768],
            [33.209854179672405, 2.33034101874064],
            [33.210030615082395, 2.331493466199823],
            [33.213611450721885, 2.334562490983267],
            [33.21375528177865, 2.338629367960165],
            [33.21330379750001, 2.339925969438016],
            [33.213546763038266, 2.343882017650196],
            [33.21294124823111, 2.346519498983267],
            [33.21313977950217, 2.348048711378453],
            [33.21217847704527, 2.350402226660483],
            [33.21050967584363, 2.34960799395222],
            [33.209608431153384, 2.348556272186112],
            [33.2091634686437, 2.348679429180131],
            [33.20542531464178, 2.346553891764757],
            [33.204977110112246, 2.346718301778417],
            [33.204869028410535, 2.346139945080742],
            [33.20360067550131, 2.345043513991452],
            [33.20168722711522, 2.344819992967684],
            [33.19351986133297, 2.341369248953753],
            [33.19063817459766, 2.34136962593122],
            [33.178510754768666, 2.337966867253877],
            [33.178183250575636, 2.339615126052489],
            [33.18051047555804, 2.343207939951622],
            [33.18051070822168, 2.345020977082476],
            [33.18447671270889, 2.350031033684467],
            [33.18508224907561, 2.3534479659638],
            [33.1850672714649, 2.355107461871672],
            [33.18353493064312, 2.360054307950473],
            [33.18406328645558, 2.361699166776488],
            [33.182956437159724, 2.364259514798076],
            [33.18330016852003, 2.365181142784159],
            [33.18290764965663, 2.371315243531262],
            [33.181700125268556, 2.374524342935197],
            [33.18011115465132, 2.376506048538705],
            [33.17506861721243, 2.380248177943372],
            [33.1728037424973, 2.383507389464289],
            [33.168790978004616, 2.384833338016382],
            [33.16469454532467, 2.388040188146627],
            [33.16145084291976, 2.389104875332793],
            [33.16141532083847, 2.391028529944491],
            [33.162285541312066, 2.394240503073238],
            [33.162277040554535, 2.395799515477385],
            [33.15806246504169, 2.393868840785363],
            [33.15706281350533, 2.392743898789015],
            [33.154996440416824, 2.391395337348951],
            [33.153181609980955, 2.391366955561766],
            [33.15221711311491, 2.3899557314412],
            [33.14975292918767, 2.389352899081637],
            [33.14788869949598, 2.387694406407057],
            [33.146593467196844, 2.385206928864455],
            [33.14597094368808, 2.384720016755483],
            [33.145325673039714, 2.383098317566109],
            [33.14565388690182, 2.382446082563274],
            [33.14552443338116, 2.379859700938835],
            [33.146593504027756, 2.376266233197426],
            [33.14827988705611, 2.373604197628424],
            [33.148926033561885, 2.371604738894858],
            [33.14645151451734, 2.368927500666937],
            [33.14368518493923, 2.367040257504098],
            [33.13937952115489, 2.36538183854063],
            [33.135082992338674, 2.366447123920712],
            [33.131844984354345, 2.366384755919149],
            [33.12729907333377, 2.365007189504616],
            [33.125430718578315, 2.362063443696675],
            [33.1212585031227, 2.360372653919656],
            [33.11882969934293, 2.357178492988313],
            [33.117584297490886, 2.357429096652901],
            [33.11185586399326, 2.362252560586945],
            [33.10980100820501, 2.363317468705139],
            [33.107354073727876, 2.365366739956575],
            [33.094373955963206, 2.369180011294133],
            [33.084642468761125, 2.372519061361245],
            [33.08355508775409, 2.371789059794172],
            [33.08328450441071, 2.371022321275635],
            [33.08471738017097, 2.367712207250464],
            [33.08187084541105, 2.36600162890176],
            [33.081782342490946, 2.364489383770496],
            [33.084169512950524, 2.354615106264843],
            [33.08399250890694, 2.352658087248471],
            [33.082842795599014, 2.351323827922061],
            [33.08045499362374, 2.351146094186328],
            [33.07470668310381, 2.351591182881356],
            [33.07355696979585, 2.350701635435998],
            [33.06851585888169, 2.345364535431704],
            [33.06347462040671, 2.337002944041152],
            [33.06285554283541, 2.334779072736811],
            [33.06214796503893, 2.33380059503127],
            [33.05879535627884, 2.331391704908415],
            [33.058005624854715, 2.330143767322953],
            [33.05608723483623, 2.32897146982428],
            [33.0593829434079, 2.326401428931401],
            [33.06074061580581, 2.323830203042033],
            [33.06057779975382, 2.319821235532159],
            [33.062122937975126, 2.314584912004694],
            [33.06326157864886, 2.313193979951038],
            [33.062439419839606, 2.311686381233298],
            [33.05924888961467, 2.307964122398649],
            [33.060273375975385, 2.304713777273806],
            [33.06150738988456, 2.303410759832644],
            [33.0631656592378, 2.302647474693008],
            [33.065120984387505, 2.302379325959276],
            [33.06879712858365, 2.302926640392974],
            [33.07269607832648, 2.304030079363804],
            [33.076844161440306, 2.303620778694088],
            [33.08042296329397, 2.304356929201369],
            [33.082700455745595, 2.305256726736119],
            [33.085059112779774, 2.305011188746673],
            [33.08871926876051, 2.305992760608606],
            [33.09335573445328, 2.308429305542032],
            [33.09417270279684, 2.305958158597669],
            [33.09504848384207, 2.305777155509642],
            [33.0983669943506, 2.301651401745183],
            [33.09921948477542, 2.298005317818602],
            [33.09894266173409, 2.294250745716093],
            [33.09804365115395, 2.291636164270304],
            [33.096706799907686, 2.289727294940366],
            [33.09670672534753, 2.28861448745699],
            [33.10080901863637, 2.287827096569006],
            [33.10412733600712, 2.28570076408468],
            [33.10675644163735, 2.282959265836173],
            [33.10941160020746, 2.275495118929491],
            [33.11119612777388, 2.273079376595122],
            [33.11255283627948, 2.270075597749248],
            [33.11498635801112, 2.268256916953658],
            [33.116284093914985, 2.266031199729814],
            [33.11613633183051, 2.26341656883407],
            [33.11520697795671, 2.261055322132837],
            [33.11194715169074, 2.255319648470884],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 696,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "AKURA",
        Population: 23218,
        Key: "ALEBTONGAKURA",
        Dist2: "Alebtong",
        "Sub Country": "Akura",
        id2_original: "Alebtong Akura",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.59007355813328, 2.514768672603876],
            [33.58814111307387, 2.516002406623274],
            [33.586308322620496, 2.518693196490727],
            [33.58600362395757, 2.520845288069008],
            [33.584629065927274, 2.522921020611861],
            [33.58007619116664, 2.526396960462754],
            [33.578854265886235, 2.528057602489005],
            [33.57916164691859, 2.531930991510473],
            [33.57647323451329, 2.535252374130656],
            [33.57574058743218, 2.537404676965409],
            [33.57528995295979, 2.54136449928624],
            [33.57397010502525, 2.542840722540845],
            [33.570156094585805, 2.544563991225687],
            [33.56898321821822, 2.546630401850832],
            [33.568446079577235, 2.548548974264353],
            [33.56436333003571, 2.550936393774336],
            [33.56138094754696, 2.553200353894727],
            [33.55727343414798, 2.554923723579314],
            [33.55321575029783, 2.558860528846193],
            [33.552042834404375, 2.560877739765021],
            [33.551652370886366, 2.562747057708377],
            [33.551478805593675, 2.568590663835086],
            [33.543747347303096, 2.580386529831254],
            [33.53933187525503, 2.587846897462485],
            [33.537231683291026, 2.592633153351772],
            [33.52349337574848, 2.586641624314799],
            [33.51017425894839, 2.582186998239737],
            [33.49445537910508, 2.575552863482875],
            [33.48305497392037, 2.568799255742074],
            [33.48003072904104, 2.565570669877569],
            [33.48108494604439, 2.561227774973085],
            [33.480603300830104, 2.557165912424101],
            [33.48117796299881, 2.554370213120693],
            [33.480601253569546, 2.551665415948219],
            [33.471882615053644, 2.541147140397165],
            [33.46988552632808, 2.53922088571246],
            [33.467580730481735, 2.535204907841874],
            [33.4657740396806, 2.527986143748099],
            [33.46653799843927, 2.51833283269738],
            [33.46707468702428, 2.516170431559168],
            [33.46373408873956, 2.512887607641773],
            [33.4606624164065, 2.511730697977026],
            [33.45881900606985, 2.510184330302952],
            [33.45536219273683, 2.505634951184003],
            [33.4411352654601, 2.496927659987853],
            [33.40978703367126, 2.482498914783988],
            [33.40476549614882, 2.482165733567383],
            [33.40278971725839, 2.481306878189779],
            [33.3999563365292, 2.477670858165987],
            [33.399253671619014, 2.476006427796483],
            [33.398967272536765, 2.473301467308564],
            [33.396264257118176, 2.467466978505735],
            [33.39623976095869, 2.464481481133412],
            [33.39776262365591, 2.461452676935225],
            [33.398605978214306, 2.458844500690857],
            [33.40320934009055, 2.452247862652837],
            [33.40416033617618, 2.449705373104034],
            [33.4039325324033, 2.443662060718444],
            [33.4058118924193, 2.441888283234605],
            [33.40753646911859, 2.437644727159968],
            [33.409701127780664, 2.434984256373208],
            [33.41127167844302, 2.434531425951778],
            [33.41241369139236, 2.433526861384313],
            [33.41467447158645, 2.432730030054994],
            [33.415602311799006, 2.431779811743412],
            [33.419444735052586, 2.430086832869062],
            [33.42237105817604, 2.427335639505931],
            [33.422775478818615, 2.426258924143631],
            [33.42427339170711, 2.42187067753154],
            [33.42430874131186, 2.419853195409846],
            [33.423808722855064, 2.419011985585536],
            [33.42399777330659, 2.415926913248727],
            [33.4232828347147, 2.41269737285084],
            [33.42440126958276, 2.411882796075186],
            [33.42579256951503, 2.409973450370017],
            [33.42714805451522, 2.406797541679584],
            [33.428860689909456, 2.404227665701107],
            [33.428551052309125, 2.402771203401439],
            [33.42913214731358, 2.39682717085994],
            [33.42903625575025, 2.393977409760777],
            [33.42999906917347, 2.391715367942386],
            [33.43059424706665, 2.391280926126675],
            [33.43026073853425, 2.390783448612703],
            [33.43026011869672, 2.388793119400191],
            [33.43075967092789, 2.388168721455654],
            [33.430378585821444, 2.386522295622516],
            [33.43135365675669, 2.385725856831382],
            [33.43135323904008, 2.384386907410866],
            [33.430996114697216, 2.383862296626635],
            [33.43149553846929, 2.382830786484069],
            [33.42917366205611, 2.376643397689813],
            [33.42900662571892, 2.374562650110287],
            [33.429339101188724, 2.373558333999001],
            [33.42901748185914, 2.371486681095114],
            [33.430681813043925, 2.367342654227572],
            [33.43022965772375, 2.366700461642583],
            [33.431181048169805, 2.365714045942978],
            [33.432014222121104, 2.366003287573175],
            [33.432489544094125, 2.365216053888671],
            [33.43215655299132, 2.364546683390108],
            [33.43151411922262, 2.364827340195798],
            [33.43129963117719, 2.363805101010904],
            [33.43166722448639, 2.363669281807939],
            [33.43164341643642, 2.363026955582287],
            [33.432333383660065, 2.361950151983474],
            [33.43359386822571, 2.360728417001011],
            [33.43597428245605, 2.36183139596349],
            [33.43728242444415, 2.360220625467746],
            [33.437663267005505, 2.361107106178492],
            [33.438829963862226, 2.361975242154456],
            [33.43944818713568, 2.361586026719948],
            [33.44140010048395, 2.362182503069396],
            [33.44111506055272, 2.363838184736457],
            [33.44156695536143, 2.363648054727079],
            [33.44220965503147, 2.364217805621078],
            [33.44292353630628, 2.364127107229711],
            [33.442494863845965, 2.36309589381071],
            [33.442589567836464, 2.362164027860075],
            [33.443541561950404, 2.361349497427462],
            [33.443493522743964, 2.360535287841312],
            [33.44392172448706, 2.360082803472904],
            [33.445575244447376, 2.359231858958935],
            [33.44783694810958, 2.361764269830198],
            [33.44812279562625, 2.362650777380146],
            [33.44943149187489, 2.362813196520281],
            [33.45009799779824, 2.362243022302903],
            [33.44859849668831, 2.361329770121372],
            [33.448384235018345, 2.361049384567171],
            [33.44869332913793, 2.360805016854496],
            [33.45119205867772, 2.360976094901591],
            [33.451953376389426, 2.359826884974794],
            [33.45276246021976, 2.360378483527116],
            [33.453119848667335, 2.361717311692725],
            [33.45488120059773, 2.362313829273215],
            [33.455416291079864, 2.362132714964697],
            [33.456058300843765, 2.36057643167055],
            [33.457605246475396, 2.360458310103147],
            [33.4580087508364, 2.358422617891177],
            [33.45765147647486, 2.357436621754084],
            [33.45834138979957, 2.356269340208291],
            [33.4588410893545, 2.356169657662115],
            [33.46019801884566, 2.357725278106858],
            [33.4608884091758, 2.358014549224656],
            [33.46115004260397, 2.358756309717404],
            [33.46184039520487, 2.358927970529165],
            [33.46350557260265, 2.357678939145806],
            [33.466539967546375, 2.357741246504546],
            [33.46882474713156, 2.35859993064329],
            [33.470824113984705, 2.359892959269035],
            [33.47294176470626, 2.358553293723385],
            [33.47378635175322, 2.359349131544676],
            [33.476689266577004, 2.357936817401004],
            [33.47790252491155, 2.356832676605522],
            [33.479163914979004, 2.356759865114809],
            [33.48028231481277, 2.357718448612197],
            [33.480591818564136, 2.357048870756888],
            [33.482447717279875, 2.35633351993135],
            [33.48304268766223, 2.357029923365318],
            [33.48431460149322, 2.357219462791146],
            [33.484369599948174, 2.358156209367687],
            [33.4852298769699, 2.359869653396703],
            [33.48519923274061, 2.361646300050098],
            [33.48566828267633, 2.362023473011989],
            [33.48632467626452, 2.36175596118936],
            [33.486684384162174, 2.362337564134342],
            [33.48846861169129, 2.369003242909845],
            [33.49464554795915, 2.376893687285525],
            [33.49508390515654, 2.378843108523531],
            [33.49617876014672, 2.380792290055637],
            [33.49847719232763, 2.38274103352455],
            [33.50176146444741, 2.387692386952465],
            [33.50306053614608, 2.392377180600879],
            [33.50495348138411, 2.396747302409727],
            [33.50412612312599, 2.399703417448345],
            [33.50375244283242, 2.403697041017565],
            [33.50389485544934, 2.408413702918684],
            [33.50447393732927, 2.410394507803157],
            [33.507320278951426, 2.414371202479734],
            [33.50954139133915, 2.418348125155365],
            [33.51158998317491, 2.420752870546056],
            [33.512699931658524, 2.421098340548982],
            [33.514639061081965, 2.423361619729406],
            [33.51803185867119, 2.425498557069574],
            [33.51922041782701, 2.427023164440998],
            [33.527343846110355, 2.433204153498854],
            [33.52753923058298, 2.434037905203541],
            [33.526385880894736, 2.438883746602301],
            [33.52297787303109, 2.443648525545282],
            [33.52051788513456, 2.450508812486162],
            [33.52089921009123, 2.456796396939485],
            [33.52563894251577, 2.466511871119522],
            [33.536632687557905, 2.482131397168851],
            [33.538908362717706, 2.488037138687641],
            [33.53910174933712, 2.497754366180035],
            [33.53981154327741, 2.502998013331331],
            [33.540291906595805, 2.50362555098022],
            [33.54005205102507, 2.504108524989034],
            [33.5407244975074, 2.504832557581421],
            [33.542815507790856, 2.505614528665368],
            [33.5438978294862, 2.506702185292858],
            [33.55553354296971, 2.507707565933794],
            [33.57169014040995, 2.507648372492479],
            [33.59007355813328, 2.514768672603876],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 697,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "OLILIM",
        Population: 13605,
        Key: "OTUKEOLILIM",
        Dist2: "Otuke",
        "Sub Country": "Olilim",
        id2_original: "OtukeOlilim",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.344621282837295, 2.427716244409037],
              [33.34242129972333, 2.427131108797812],
              [33.339321109473254, 2.430676305748946],
              [33.33875803557171, 2.433795600425058],
              [33.33749019919377, 2.437056819879711],
              [33.33537634205769, 2.439042275885853],
              [33.33213439585915, 2.439610228157015],
              [33.32903370614579, 2.441170535586403],
              [33.32753442512312, 2.442603849576618],
              [33.326928473734746, 2.441878723966685],
              [33.32507199650394, 2.441041360193467],
              [33.31993134506977, 2.439704137282644],
              [33.31601562917048, 2.436511453992922],
              [33.31165997414057, 2.434277849501255],
              [33.30818501214385, 2.433473463417252],
              [33.30386984148884, 2.433751601140983],
              [33.30100997573012, 2.433239870621622],
              [33.300010268498205, 2.432480140219638],
              [33.298391161199774, 2.429675905438848],
              [33.298200255727174, 2.428165084998822],
              [33.292999437830176, 2.424665007418019],
              [33.291689690552666, 2.419897476068211],
              [33.290570862222516, 2.419345845783836],
              [33.29049915061169, 2.417862138528872],
              [33.28810706277423, 2.41484092285048],
              [33.28598876257074, 2.414524724693544],
              [33.28446560432782, 2.413285594078507],
              [33.28279979271945, 2.412706929632606],
              [33.281275853840555, 2.410391190567515],
              [33.280299768707316, 2.406799693939373],
              [33.27943035761581, 2.405279960751339],
              [33.2771216397249, 2.402864858387927],
              [33.276122113952674, 2.402837920957025],
              [33.273432390007045, 2.401065232558766],
              [33.272670917785106, 2.399509284030574],
              [33.27159988162466, 2.398885248184237],
              [33.26706461743685, 2.39135894956767],
              [33.266921551744716, 2.389920487079952],
              [33.265481269374945, 2.386781419664892],
              [33.265076031265444, 2.384239259787227],
              [33.26393368773608, 2.383977114153691],
              [33.26357659932583, 2.38333483775373],
              [33.26255343079362, 2.383063621425037],
              [33.260982511821986, 2.381652570981402],
              [33.25974513911196, 2.381245685836221],
              [33.25912631935713, 2.38182481953449],
              [33.25862645720717, 2.381245897655569],
              [33.25617543809046, 2.381038275195509],
              [33.25603257990911, 2.380649275147871],
              [33.25558008861906, 2.38086649057217],
              [33.255461355593, 2.38022416784465],
              [33.254913770443565, 2.379952855764242],
              [33.254414055617325, 2.380151984964083],
              [33.25419979484566, 2.379717762983035],
              [33.252593095077934, 2.379319987306072],
              [33.251879302736306, 2.380089123933621],
              [33.25114168168349, 2.379654997072049],
              [33.24999103682258, 2.380089469486645],
              [33.24796897762706, 2.380089837478156],
              [33.24761962281306, 2.38109264635496],
              [33.247096549094465, 2.380017475980041],
              [33.247177324706506, 2.378846501229018],
              [33.246402719115096, 2.377716410311738],
              [33.24564850078908, 2.377375440395482],
              [33.24588115815948, 2.376418265273739],
              [33.245374853292304, 2.375517226335321],
              [33.24584022103365, 2.373903254950372],
              [33.245846044811636, 2.371985147491731],
              [33.24452087525732, 2.368923726479375],
              [33.24466873166489, 2.368148219124171],
              [33.245504606850254, 2.36793998705584],
              [33.24562989937449, 2.367559984834514],
              [33.244877577392046, 2.366592076311313],
              [33.24646476575178, 2.364827602280454],
              [33.24738411508827, 2.363018012380152],
              [33.245920667862286, 2.358775169125176],
              [33.24587880367512, 2.357264306440636],
              [33.246421699618736, 2.356504250276795],
              [33.24767522493587, 2.356214518399002],
              [33.25082833493935, 2.356530599816509],
              [33.25166079922155, 2.356150469713622],
              [33.2543978976203, 2.356321864272758],
              [33.25370718389667, 2.3540963982061],
              [33.251517271795365, 2.352006911398518],
              [33.25149338738857, 2.350477951063791],
              [33.251873814029935, 2.349690782195812],
              [33.25149298943492, 2.348252357194816],
              [33.25035748028823, 2.348315892838083],
              [33.24922072338161, 2.347682798130052],
              [33.249169461918235, 2.347085697153672],
              [33.249797190265724, 2.346063258255508],
              [33.250826363137286, 2.345502150646678],
              [33.25392029482479, 2.34820668031898],
              [33.255110380218234, 2.348423592958667],
              [33.2568954979778, 2.350214594519526],
              [33.258442078893445, 2.350956171574357],
              [33.25915594220195, 2.350666530094493],
              [33.26266659336658, 2.351154414558778],
              [33.26321348232167, 2.350774331457994],
              [33.26295178870635, 2.349173040773644],
              [33.26166645494333, 2.347644320574863],
              [33.261475732727035, 2.346802974175544],
              [33.26190377007844, 2.345129175604305],
              [33.26254618498253, 2.344550039164638],
              [33.26318872026087, 2.344622294803097],
              [33.26602151528852, 2.34859344017513],
              [33.267449250888696, 2.348095574835144],
              [33.26932928733611, 2.349388948893436],
              [33.271566059155916, 2.349506125370997],
              [33.275695151884634, 2.350473351968992],
              [33.277218475417584, 2.350111164228621],
              [33.27771785786717, 2.348292594850209],
              [33.279121347937846, 2.347459980318743],
              [33.27966906424129, 2.348436957639032],
              [33.28145364031674, 2.347387132436324],
              [33.28223835824327, 2.344464758083179],
              [33.28353489938782, 2.342944580242775],
              [33.28432017786311, 2.342826808130209],
              [33.2875330168498, 2.343993223995907],
              [33.288287404957394, 2.343628918120959],
              [33.29354171663122, 2.346265847930427],
              [33.299795777757815, 2.350570402380633],
              [33.30332591697422, 2.350998863078507],
              [33.304295688747615, 2.350764569603046],
              [33.30522683386209, 2.35134958158059],
              [33.30654636289473, 2.353924610243081],
              [33.30782676670348, 2.355368171495861],
              [33.32063067273867, 2.366173798626003],
              [33.32117406006077, 2.367461312840637],
              [33.320165914953385, 2.369412519137096],
              [33.319894720755606, 2.370934451497932],
              [33.32032179421472, 2.37265124194611],
              [33.32202933256802, 2.375343196268414],
              [33.32334854898697, 2.376513534044446],
              [33.32490045870886, 2.377215470561397],
              [33.329052236593455, 2.381272620101039],
              [33.33813224938184, 2.391571666660648],
              [33.33867019830321, 2.392463152525148],
              [33.337972559467055, 2.393849657848131],
              [33.33393885165184, 2.400083687233389],
              [33.330215524343686, 2.403929546612938],
              [33.33027702570297, 2.40512800636691],
              [33.33223694573537, 2.409835850559753],
              [33.33384760707346, 2.415427493513868],
              [33.335418768590245, 2.417652677233984],
              [33.336716046353274, 2.41888275781168],
              [33.33994155428043, 2.420582797088561],
              [33.34416539681374, 2.421730695132251],
              [33.34533223380764, 2.423168883523542],
              [33.344621282837295, 2.427716244409037],
            ],
          ],
          [
            [
              [33.43129963117719, 2.363805101010904],
              [33.43151411922262, 2.364827340195798],
              [33.43215655299132, 2.364546683390108],
              [33.432489544094125, 2.365216053888671],
              [33.432014222121104, 2.366003287573175],
              [33.431181048169805, 2.365714045942978],
              [33.43022965772375, 2.366700461642583],
              [33.430681813043925, 2.367342654227572],
              [33.42901748185914, 2.371486681095114],
              [33.429339101188724, 2.373558333999001],
              [33.42900662571892, 2.374562650110287],
              [33.42917366205611, 2.376643397689813],
              [33.43149553846929, 2.382830786484069],
              [33.430996114697216, 2.383862296626635],
              [33.43135323904008, 2.384386907410866],
              [33.43135365675669, 2.385725856831382],
              [33.430378585821444, 2.386522295622516],
              [33.43075967092789, 2.388168721455654],
              [33.43026011869672, 2.388793119400191],
              [33.43026073853425, 2.390783448612703],
              [33.43059424706665, 2.391280926126675],
              [33.42999906917347, 2.391715367942386],
              [33.42903625575025, 2.393977409760777],
              [33.42913214731358, 2.39682717085994],
              [33.428551052309125, 2.402771203401439],
              [33.428860689909456, 2.404227665701107],
              [33.42714805451522, 2.406797541679584],
              [33.42579256951503, 2.409973450370017],
              [33.42440126958276, 2.411882796075186],
              [33.4232828347147, 2.41269737285084],
              [33.42399777330659, 2.415926913248727],
              [33.423808722855064, 2.419011985585536],
              [33.42430874131186, 2.419853195409846],
              [33.42427339170711, 2.42187067753154],
              [33.422775478818615, 2.426258924143631],
              [33.42237105817604, 2.427335639505931],
              [33.419444735052586, 2.430086832869062],
              [33.415602311799006, 2.431779811743412],
              [33.41467447158645, 2.432730030054994],
              [33.41241369139236, 2.433526861384313],
              [33.41127167844302, 2.434531425951778],
              [33.409701127780664, 2.434984256373208],
              [33.40753646911859, 2.437644727159968],
              [33.4058118924193, 2.441888283234605],
              [33.4039325324033, 2.443662060718444],
              [33.40416033617618, 2.449705373104034],
              [33.40320934009055, 2.452247862652837],
              [33.398605978214306, 2.458844500690857],
              [33.39776262365591, 2.461452676935225],
              [33.39700699138162, 2.462868944796435],
              [33.390637351213975, 2.457174812596713],
              [33.38753465646089, 2.451646414112441],
              [33.38288224207855, 2.448953961016856],
              [33.37371979538813, 2.44867298945757],
              [33.368785938827294, 2.447681952642824],
              [33.361358194646016, 2.44105772341578],
              [33.36060519443553, 2.435830580104692],
              [33.35979483050593, 2.435109938364177],
              [33.362366410720334, 2.430988977420249],
              [33.36271324665827, 2.425785422030985],
              [33.36358212864209, 2.42437723393765],
              [33.365428725303055, 2.422699798782897],
              [33.369736839691505, 2.420364535192739],
              [33.37059334109409, 2.41950256976658],
              [33.37344793553874, 2.415157226840891],
              [33.374485104314644, 2.411599050644572],
              [33.37647411628752, 2.409970085564713],
              [33.37652344996628, 2.408216334275899],
              [33.37761520127715, 2.406883107016833],
              [33.37850758857869, 2.404666465373703],
              [33.38008258051183, 2.398431991960927],
              [33.381587997027914, 2.395375690945027],
              [33.381725123957715, 2.393496015195785],
              [33.381326206394554, 2.392068083005379],
              [33.38320021694304, 2.387314383597147],
              [33.383627535642226, 2.383595953135905],
              [33.38341562486333, 2.381883296904552],
              [33.38125760564958, 2.37564432564126],
              [33.38052428573031, 2.374330504843219],
              [33.37803294663034, 2.372113966819699],
              [33.37662725209398, 2.369529791760022],
              [33.376200817337036, 2.366778093347796],
              [33.37415712491285, 2.361930813325966],
              [33.373745538409224, 2.359613483544375],
              [33.371804641999624, 2.356783828049797],
              [33.370656186333065, 2.35633231630912],
              [33.368829702052984, 2.35422436292437],
              [33.367437234310856, 2.353853770533763],
              [33.36700872444558, 2.353229637758885],
              [33.36607982781424, 2.350452437935151],
              [33.36529437326916, 2.349737938201929],
              [33.364139345528, 2.345893206087345],
              [33.361491261190764, 2.341256582060803],
              [33.361598467035066, 2.340789041958354],
              [33.36044920108812, 2.340411680153493],
              [33.358688225551816, 2.338928496521093],
              [33.359095321377346, 2.337447285969731],
              [33.35956282621076, 2.337042130069875],
              [33.35881210143287, 2.336172232825321],
              [33.359341719378314, 2.335617063163725],
              [33.35836564053329, 2.334730704508136],
              [33.35850834061111, 2.334414021280831],
              [33.36003105418797, 2.334060795214951],
              [33.359935828276285, 2.333174210287741],
              [33.36057824138375, 2.332785021838276],
              [33.361768410320536, 2.333363724223303],
              [33.362577188723655, 2.332884022101262],
              [33.36333901578011, 2.333453787337142],
              [33.364695274229774, 2.3328563293504],
              [33.365741966944306, 2.33291033797806],
              [33.36612344012299, 2.334267293745873],
              [33.36667036501069, 2.33417667957621],
              [33.36712310872736, 2.335063169626368],
              [33.3682176564937, 2.335397621884007],
              [33.369597341209335, 2.334103532112607],
              [33.36988268836442, 2.333289224078667],
              [33.37162010558238, 2.332854505486571],
              [33.372523701163736, 2.331705293092203],
              [33.37280894591085, 2.33051100906588],
              [33.372570992073534, 2.329841593223381],
              [33.37292778314147, 2.329244393999334],
              [33.37406965954689, 2.327877989115918],
              [33.37564000539338, 2.327018101341448],
              [33.376353940567114, 2.327162661989829],
              [33.377116121559794, 2.329053284521497],
              [33.378472499485405, 2.328953400776988],
              [33.38006688874047, 2.329721965626604],
              [33.38094779916596, 2.332037762516019],
              [33.38122149337513, 2.331811512598262],
              [33.38226884185984, 2.332218342181208],
              [33.382577990776646, 2.332145881257751],
              [33.382149445877126, 2.331386049309052],
              [33.382387442833526, 2.33011035518602],
              [33.3803403457944, 2.328609108684504],
              [33.38029242786053, 2.328102488499189],
              [33.37976908015579, 2.328057395287976],
              [33.38043496444498, 2.327197748172904],
              [33.38174402091802, 2.326717899440787],
              [33.382315259607196, 2.327170094803455],
              [33.383933088602994, 2.327314405013027],
              [33.38400482087505, 2.328580967062787],
              [33.384838271507455, 2.329992072175856],
              [33.38786061644992, 2.331330195215351],
              [33.389526595144936, 2.330759770301497],
              [33.39104906527835, 2.329583234976545],
              [33.39133440614519, 2.328796066048247],
              [33.39223882907494, 2.328678201196895],
              [33.393214396778546, 2.329700238979841],
              [33.393285998794894, 2.330469214510003],
              [33.39489301297297, 2.332133410403023],
              [33.39874727602199, 2.329354887933768],
              [33.40005679782236, 2.332539056894304],
              [33.400818707523854, 2.333353068266868],
              [33.40117664753702, 2.336845105779524],
              [33.40487811973262, 2.340327127643658],
              [33.40556824146647, 2.341693022273555],
              [33.406567867850036, 2.342262690586853],
              [33.406710911982614, 2.343176395059047],
              [33.40861581200046, 2.346523221173016],
              [33.40930627509414, 2.347102024697863],
              [33.40992459538568, 2.347029466709212],
              [33.411804524035276, 2.345689957547541],
              [33.41213759059654, 2.346666932514635],
              [33.41170937537868, 2.347101314726578],
              [33.41213785020963, 2.347553536733368],
              [33.4134351692952, 2.347299835604682],
              [33.41343533997511, 2.347878842554307],
              [33.41445834231895, 2.347634268785706],
              [33.41488650812948, 2.347037040334851],
              [33.41372057663739, 2.346775025894418],
              [33.413601229163675, 2.346177961330354],
              [33.41433831302398, 2.344721177547486],
              [33.41864626661398, 2.34595932322727],
              [33.4197174141655, 2.34694512014072],
              [33.420265540100715, 2.350871339663445],
              [33.42300279480634, 2.35168473453143],
              [33.4236811090841, 2.35296014961854],
              [33.42520388464472, 2.35284207318038],
              [33.42603754458459, 2.354759772671261],
              [33.42753697382928, 2.355501161514809],
              [33.42877458279621, 2.356667836957097],
              [33.42850206538004, 2.358884426591589],
              [33.42883515619582, 2.359888536125759],
              [33.42990659120824, 2.36175187642921],
              [33.43057342411837, 2.362213063815148],
              [33.43062104740483, 2.363524857769545],
              [33.43129963117719, 2.363805101010904],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 698,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "ORUM",
        Population: 10024,
        Key: "OTUKEORUM",
        Dist2: "Otuke",
        "Sub Country": "Orum",
        id2_original: "OtukeOrum",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.35881210143287, 2.336172232825321],
            [33.35956282621076, 2.337042130069875],
            [33.359095321377346, 2.337447285969731],
            [33.358688225551816, 2.338928496521093],
            [33.36044920108812, 2.340411680153493],
            [33.361598467035066, 2.340789041958354],
            [33.361491261190764, 2.341256582060803],
            [33.364139345528, 2.345893206087345],
            [33.36529437326916, 2.349737938201929],
            [33.36607982781424, 2.350452437935151],
            [33.36700872444558, 2.353229637758885],
            [33.367437234310856, 2.353853770533763],
            [33.368829702052984, 2.35422436292437],
            [33.370656186333065, 2.35633231630912],
            [33.371804641999624, 2.356783828049797],
            [33.373745538409224, 2.359613483544375],
            [33.37415712491285, 2.361930813325966],
            [33.376200817337036, 2.366778093347796],
            [33.37662725209398, 2.369529791760022],
            [33.37803294663034, 2.372113966819699],
            [33.38052428573031, 2.374330504843219],
            [33.38125760564958, 2.37564432564126],
            [33.38341562486333, 2.381883296904552],
            [33.383627535642226, 2.383595953135905],
            [33.38320021694304, 2.387314383597147],
            [33.381326206394554, 2.392068083005379],
            [33.381725123957715, 2.393496015195785],
            [33.381587997027914, 2.395375690945027],
            [33.38008258051183, 2.398431991960927],
            [33.37850758857869, 2.404666465373703],
            [33.37761520127715, 2.406883107016833],
            [33.37652344996628, 2.408216334275899],
            [33.37647411628752, 2.409970085564713],
            [33.374485104314644, 2.411599050644572],
            [33.37344793553874, 2.415157226840891],
            [33.37059334109409, 2.41950256976658],
            [33.369736839691505, 2.420364535192739],
            [33.365428725303055, 2.422699798782897],
            [33.36358212864209, 2.42437723393765],
            [33.36271324665827, 2.425785422030985],
            [33.362366410720334, 2.430988977420249],
            [33.35979483050593, 2.435109938364177],
            [33.352605417454384, 2.431986588205389],
            [33.3472141531239, 2.428405871306274],
            [33.344621282837295, 2.427716244409037],
            [33.34533223380764, 2.423168883523542],
            [33.34416539681374, 2.421730695132251],
            [33.33994155428043, 2.420582797088561],
            [33.336716046353274, 2.41888275781168],
            [33.335418768590245, 2.417652677233984],
            [33.33384760707346, 2.415427493513868],
            [33.33223694573537, 2.409835850559753],
            [33.33027702570297, 2.40512800636691],
            [33.330215524343686, 2.403929546612938],
            [33.33393885165184, 2.400083687233389],
            [33.337972559467055, 2.393849657848131],
            [33.33867019830321, 2.392463152525148],
            [33.33813224938184, 2.391571666660648],
            [33.329052236593455, 2.381272620101039],
            [33.32490045870886, 2.377215470561397],
            [33.32334854898697, 2.376513534044446],
            [33.32202933256802, 2.375343196268414],
            [33.32032179421472, 2.37265124194611],
            [33.319894720755606, 2.370934451497932],
            [33.320165914953385, 2.369412519137096],
            [33.32117406006077, 2.367461312840637],
            [33.32063067273867, 2.366173798626003],
            [33.30782676670348, 2.355368171495861],
            [33.30654636289473, 2.353924610243081],
            [33.30522683386209, 2.35134958158059],
            [33.304295688747615, 2.350764569603046],
            [33.30332591697422, 2.350998863078507],
            [33.299795777757815, 2.350570402380633],
            [33.29354171663122, 2.346265847930427],
            [33.288287404957394, 2.343628918120959],
            [33.289926057799775, 2.341414304040069],
            [33.28961672742325, 2.340654411584025],
            [33.28842662136857, 2.340319915700822],
            [33.28792668016686, 2.339315791197678],
            [33.28823616505359, 2.338094368508108],
            [33.28787864006208, 2.335289839980848],
            [33.287056886393025, 2.332937762354249],
            [33.28697449291514, 2.331345488940292],
            [33.287569066242156, 2.330558268937935],
            [33.28861628536945, 2.330413300242561],
            [33.289401285367, 2.328974648131166],
            [33.28980546256613, 2.329001706374111],
            [33.29080519405256, 2.330295234470335],
            [33.29247121137512, 2.329643496222167],
            [33.29311380863723, 2.33005048081418],
            [33.293517692985574, 2.328666189869078],
            [33.29397023997121, 2.328828943262618],
            [33.29520765580036, 2.329642920877977],
            [33.295017223739904, 2.330267211361866],
            [33.29408915805021, 2.330312641989557],
            [33.294137083170625, 2.331009258526407],
            [33.295659947664426, 2.3312713028389],
            [33.29682651246881, 2.331967682840019],
            [33.297337780527954, 2.330682886067319],
            [33.29681428909274, 2.329968276628365],
            [33.296909156576646, 2.329344007553706],
            [33.29564747545503, 2.328077680456524],
            [33.29495738156893, 2.326331735829787],
            [33.29476637548502, 2.324196661050243],
            [33.294956834494926, 2.323699031202556],
            [33.29581345896673, 2.323427437958327],
            [33.29498010894562, 2.322088642314669],
            [33.29565779799598, 2.320957612366332],
            [33.29613392126624, 2.320975606119416],
            [33.29699079546966, 2.321907276869139],
            [33.29777594189261, 2.321219531090108],
            [33.298109416289016, 2.321861803784591],
            [33.29998927127675, 2.322368041149873],
            [33.30051271689784, 2.322865518878475],
            [33.300560810901544, 2.324349231957727],
            [33.30136994054594, 2.325425662365304],
            [33.30325046028699, 2.326384249347902],
            [33.30355910704555, 2.323941467521276],
            [33.30386821643649, 2.323660940743494],
            [33.304939124137846, 2.323923074384434],
            [33.3070096609177, 2.322366523346384],
            [33.3084008575437, 2.31948019763009],
            [33.309114630122366, 2.318901027295341],
            [33.31109020060363, 2.320121947826203],
            [33.310780831599565, 2.321777632528572],
            [33.31185190099763, 2.322781621443284],
            [33.31232858391832, 2.325341840478612],
            [33.313137595883425, 2.325848296502055],
            [33.31268580977082, 2.326590258031327],
            [33.313066426855045, 2.326852539227883],
            [33.316660041029415, 2.326562224975822],
            [33.31699261172064, 2.325630300591127],
            [33.31794476842963, 2.32525010735546],
            [33.31953848754149, 2.323159870294528],
            [33.320609341343925, 2.323186767085177],
            [33.321513946631654, 2.323828902453633],
            [33.321526127786896, 2.325493562155904],
            [33.32221656033788, 2.326117651625741],
            [33.323144664655146, 2.326262190824633],
            [33.323287662973634, 2.327221147936842],
            [33.3243585068946, 2.32719375935233],
            [33.32390617191137, 2.327962864603629],
            [33.32464446310741, 2.328921684127764],
            [33.32438258264251, 2.329229345288992],
            [33.324573654303435, 2.331454880491824],
            [33.32628703799431, 2.331526858557351],
            [33.32645325686458, 2.330784959765068],
            [33.327357631285295, 2.330404771510225],
            [33.327500129242196, 2.329183383263103],
            [33.32814261870645, 2.329083714945385],
            [33.32990286121746, 2.32762672403722],
            [33.329950712676016, 2.327934312777707],
            [33.3311164914545, 2.327626437711081],
            [33.33264872807169, 2.330129218570149],
            [33.33443706000334, 2.330385002479301],
            [33.335031921689556, 2.330936731120374],
            [33.33593642007776, 2.331081267132185],
            [33.336126674271796, 2.332157821647759],
            [33.33695979971405, 2.33237475113171],
            [33.33719779038228, 2.333261305147997],
            [33.339221159321504, 2.334382651216611],
            [33.34026845570392, 2.336924619551475],
            [33.34205343063132, 2.337810793718573],
            [33.34345769415147, 2.338072813426149],
            [33.346800532834486, 2.335185976856903],
            [33.34744314626624, 2.335592934713305],
            [33.348347320362656, 2.334416592818247],
            [33.349013402281216, 2.334253579775692],
            [33.35039369246136, 2.335329832972094],
            [33.349965570668296, 2.336216550277119],
            [33.350584522475465, 2.336406383336772],
            [33.35118514236264, 2.33753353774898],
            [33.35227459668133, 2.337672544065409],
            [33.3522506206464, 2.338459643399138],
            [33.353892878428006, 2.339562966669613],
            [33.35437521175184, 2.338872714532553],
            [33.354179813804485, 2.337287228970127],
            [33.35469174122703, 2.337499593529949],
            [33.35513031491842, 2.336796616450299],
            [33.355577224077315, 2.336935441530937],
            [33.355731458523394, 2.33637964746338],
            [33.35636517683719, 2.336256893293743],
            [33.3565846469392, 2.336632788691824],
            [33.357007017717805, 2.336125963160219],
            [33.357185949545986, 2.336845129116292],
            [33.35660913860712, 2.337098634673499],
            [33.35679611754361, 2.337507230036854],
            [33.35881210143287, 2.336172232825321],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 699,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "OTUKE TOWN COUNCIL",
        Population: 6213,
        Key: "OTUKEOTUKE TOWN COUNCIL",
        Dist2: "Otuke",
        "Sub Country": "Otuke\nT/C",
        id2_original: "OtukeOtuke\nT/C",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.20505885500649, 2.49115455089064],
            [33.203485368649744, 2.490245193719731],
            [33.202869458538146, 2.490527712693934],
            [33.20311417040132, 2.491456942262216],
            [33.202172124230835, 2.491461643189746],
            [33.20145208680138, 2.492022047837517],
            [33.20027442151503, 2.491316167514102],
            [33.19915133337378, 2.492122614253979],
            [33.198567029587124, 2.491771950140099],
            [33.195652366596065, 2.491803491578943],
            [33.195217042111075, 2.492482092282398],
            [33.19434620988475, 2.492581740556698],
            [33.194249617635485, 2.493305526420425],
            [33.19231470041243, 2.494527177456167],
            [33.19064569619155, 2.493767461374487],
            [33.189601776576296, 2.493844590372595],
            [33.188146551630076, 2.494645198457571],
            [33.18618953854598, 2.493176255575767],
            [33.183960165250845, 2.492929871808321],
            [33.183316888862436, 2.492255654557562],
            [33.18319685687247, 2.491416897323341],
            [33.18268998337172, 2.491718488095043],
            [33.18198670760715, 2.490731793925307],
            [33.1822482332375, 2.48995328807613],
            [33.1817249529064, 2.489849199832641],
            [33.181926499821856, 2.488911719605915],
            [33.181419568828936, 2.488785698958859],
            [33.18185551494812, 2.487990722516121],
            [33.18137581009482, 2.487672822090202],
            [33.181604637947125, 2.486927214758395],
            [33.18079790051634, 2.486669663508457],
            [33.181163005492216, 2.486000786590331],
            [33.17864456691508, 2.484329066676753],
            [33.17896066430063, 2.483689246902208],
            [33.17847658285528, 2.483458187483852],
            [33.17812258375126, 2.48243664726282],
            [33.176477818771694, 2.482726868219288],
            [33.17598643312474, 2.483412387714288],
            [33.17512794105548, 2.483043412858939],
            [33.17514091003325, 2.482008640879596],
            [33.17476081127698, 2.481817554600994],
            [33.174066285103265, 2.482516281768655],
            [33.171124040239725, 2.482938485831597],
            [33.17027867345505, 2.482721095679002],
            [33.169747790681726, 2.4820159391263],
            [33.16906626941839, 2.481950117590993],
            [33.168823734173145, 2.481363558994826],
            [33.16805046707151, 2.481258203739486],
            [33.16719193278143, 2.480533315450672],
            [33.1660255988441, 2.481337552022429],
            [33.16506223205867, 2.480724720517947],
            [33.16506215929514, 2.48013812996667],
            [33.163574378504705, 2.479488508642193],
            [33.162146838737264, 2.480947948164971],
            [33.16166059684366, 2.480575429396278],
            [33.16080398404996, 2.480730775771081],
            [33.15958444918654, 2.479194041023359],
            [33.159044023609944, 2.477455409284979],
            [33.15790944062633, 2.476376623387248],
            [33.15778582346008, 2.475196807610371],
            [33.156967752883645, 2.474956282810712],
            [33.15619587367913, 2.473737734203004],
            [33.15582549379593, 2.474203500153374],
            [33.15520808709103, 2.47405609479514],
            [33.15457504700526, 2.472193279304639],
            [33.152769074856394, 2.471215472665745],
            [33.1512024668998, 2.471347607721386],
            [33.15101728549217, 2.471658110556],
            [33.15160394555985, 2.472899970391646],
            [33.15031513890991, 2.472830258730218],
            [33.147453476520596, 2.470076176241995],
            [33.14782426873053, 2.469538411125014],
            [33.14853181328935, 2.469377633677854],
            [33.14961616068565, 2.470984486459337],
            [33.1502666550374, 2.470915542042769],
            [33.15019808124187, 2.470031713255922],
            [33.148691478051326, 2.468413430789359],
            [33.14891958455645, 2.467162260761899],
            [33.14829176368251, 2.465842315399362],
            [33.146077761460205, 2.465635950722656],
            [33.144867887079364, 2.464017630597496],
            [33.144045982493324, 2.461940130454482],
            [33.14059760254418, 2.458401272479108],
            [33.14071571663098, 2.454721372497969],
            [33.1391897098303, 2.45150349462129],
            [33.13836016956432, 2.451026833241642],
            [33.13676050630023, 2.451697424923142],
            [33.134982906541296, 2.450505739467397],
            [33.13550128027432, 2.449939549101009],
            [33.13533820281257, 2.448524224263318],
            [33.135871297238154, 2.447049235082649],
            [33.13837443481103, 2.445693229054957],
            [33.13970755086236, 2.445812276644866],
            [33.14115924902275, 2.446720921988177],
            [33.1420035584903, 2.446810222870626],
            [33.1426406454864, 2.448314885303227],
            [33.14355910908406, 2.449268279828094],
            [33.14695127695429, 2.450638555978402],
            [33.14786960670294, 2.45032558911463],
            [33.148402877198286, 2.450578801743253],
            [33.15127706749256, 2.455912077727937],
            [33.154950817678504, 2.4583549782265],
            [33.15598770079013, 2.458488941845287],
            [33.158994475233804, 2.457281821142034],
            [33.15977920843172, 2.454570234112176],
            [33.158860830174056, 2.454466055139254],
            [33.15797194360714, 2.453229600763494],
            [33.15831260991571, 2.45308057670041],
            [33.15908292784827, 2.453721113050084],
            [33.15982346842578, 2.453080396304493],
            [33.15930470751887, 2.450294473],
            [33.1597636558992, 2.448327839749867],
            [33.15865251624954, 2.4464805814228],
            [33.15580827219361, 2.443977998959234],
            [33.15536378309607, 2.442920270023288],
            [33.15552664226718, 2.442264725015439],
            [33.15448963159477, 2.440909097387354],
            [33.15380822980738, 2.440551616719129],
            [33.152845479266226, 2.440924184365972],
            [33.15206035440288, 2.4402389508575],
            [33.15020878736344, 2.43986670253111],
            [33.147700787209914, 2.437590086315289],
            [33.14784675356211, 2.435753493517535],
            [33.146348523568314, 2.43550033732879],
            [33.14627522553271, 2.433509966747369],
            [33.144959136149296, 2.430569777941662],
            [33.145782928994066, 2.430433756244633],
            [33.146929373332696, 2.431411720124493],
            [33.14824728719445, 2.430969698075856],
            [33.14805055794387, 2.429213836083057],
            [33.149981112049616, 2.427934500631705],
            [33.14926414326515, 2.426260096291638],
            [33.150038632973896, 2.425364626061682],
            [33.15074387335399, 2.425527343820353],
            [33.15177293303783, 2.426678436395775],
            [33.15359957811633, 2.426701485342096],
            [33.15676787324134, 2.431678058757168],
            [33.15795874466069, 2.432375621172992],
            [33.16014405199783, 2.434619636278659],
            [33.161612673519876, 2.437654461470973],
            [33.16261843719345, 2.437212461214833],
            [33.165416416215635, 2.438770318553696],
            [33.16769438746931, 2.442235284345034],
            [33.17038832720855, 2.443758258181595],
            [33.171405928880915, 2.445479123942867],
            [33.17080490834513, 2.446746691800231],
            [33.17163737442399, 2.447223347522886],
            [33.1722853759508, 2.451711807248409],
            [33.17286356580364, 2.452711770231662],
            [33.17536074934286, 2.452374220634598],
            [33.17586927574372, 2.451095035562255],
            [33.17723019644968, 2.449501610461697],
            [33.17810773639623, 2.451410443427622],
            [33.17920409157296, 2.452143116283598],
            [33.179934920463914, 2.452070640155896],
            [33.18147015026763, 2.453463693574531],
            [33.18271257779776, 2.453463523948582],
            [33.182639674122555, 2.454793465253346],
            [33.183370443724726, 2.454277677119853],
            [33.187353991411115, 2.455634194099343],
            [33.19064310634859, 2.456004659220973],
            [33.19035039480484, 2.453353886343732],
            [33.19005793478937, 2.452476354385114],
            [33.18925390847409, 2.451734601775222],
            [33.18918066882897, 2.450630859969819],
            [33.186622396257206, 2.450196957587139],
            [33.18611083983886, 2.450414160991821],
            [33.184722168377135, 2.449826288920665],
            [33.18421015830959, 2.448794984156326],
            [33.1843562549175, 2.448279276280478],
            [33.183479161433645, 2.447618954726202],
            [33.18252885615248, 2.446008691144201],
            [33.18230929801556, 2.443728838186408],
            [33.18124921860665, 2.440969598773399],
            [33.18302189290289, 2.439899866984595],
            [33.18458121192928, 2.437914009265497],
            [33.18445603259275, 2.436815303651824],
            [33.18517969472438, 2.435378921210324],
            [33.184383331936814, 2.434505348061516],
            [33.183040818609314, 2.433870126542723],
            [33.18221802019956, 2.432122870920136],
            [33.17622947591814, 2.429992412391411],
            [33.17504780145069, 2.42753558032144],
            [33.17394478616444, 2.427302586932016],
            [33.17294556042955, 2.426161150300995],
            [33.173257167136974, 2.425333073179793],
            [33.172561704918714, 2.424521203705265],
            [33.173392581877835, 2.421715417666275],
            [33.174975016353095, 2.420919331490318],
            [33.17606204522053, 2.421184483881971],
            [33.17722164718314, 2.420108496895883],
            [33.17752859522753, 2.420879863332932],
            [33.17749835074852, 2.421252971328123],
            [33.17847761591785, 2.421652811646412],
            [33.17954329632256, 2.42091759121161],
            [33.18062408908527, 2.419340092715494],
            [33.182496744076005, 2.418865101899186],
            [33.18404979376001, 2.419339628700468],
            [33.18506982717189, 2.418864751868377],
            [33.18238985533697, 2.416537369945121],
            [33.18191725615759, 2.411927882965913],
            [33.18085144280221, 2.411591115673089],
            [33.18136893618627, 2.410335287606263],
            [33.18048573954837, 2.409339987259359],
            [33.18008969120424, 2.407885198913814],
            [33.180805113988065, 2.406644659425548],
            [33.183347646279415, 2.406062380523327],
            [33.184717691173766, 2.404392955603758],
            [33.18515922661062, 2.404438837051445],
            [33.18620993748943, 2.405709765104416],
            [33.1875192643554, 2.405418616509579],
            [33.18831104304008, 2.405908558479839],
            [33.189498883543656, 2.407899228979582],
            [33.18957547120983, 2.411237695712528],
            [33.19257518579368, 2.41364158758945],
            [33.19249930510162, 2.41538740770492],
            [33.19338262211377, 2.417148404367363],
            [33.19460063253616, 2.417041030035254],
            [33.19487462947758, 2.416627509310629],
            [33.19453938450175, 2.41460609454727],
            [33.19551370444543, 2.41391681963427],
            [33.1961074944415, 2.413947362176424],
            [33.19692973948904, 2.414498549485804],
            [33.196899421348206, 2.415417400933515],
            [33.198452522236174, 2.416244135145718],
            [33.197980650692145, 2.417025223879478],
            [33.1965646542761, 2.416734462740306],
            [33.19648858044627, 2.417102012661545],
            [33.196960640636505, 2.417622623921204],
            [33.19915320366621, 2.418418634846461],
            [33.19918348228117, 2.417239444798318],
            [33.199990275407515, 2.416228593748035],
            [33.19890910086079, 2.415003625717017],
            [33.199091768782246, 2.414758572921603],
            [33.20081223029923, 2.414788945813988],
            [33.20107117327315, 2.415554613349109],
            [33.201649753893136, 2.415692353490826],
            [33.20277628797182, 2.414758024538335],
            [33.20496870637276, 2.414604552611889],
            [33.20612538431912, 2.411664068763321],
            [33.209779133515255, 2.409642046178841],
            [33.210159611360595, 2.408646571206042],
            [33.20985484442573, 2.406931439515382],
            [33.21023540132278, 2.406456642716917],
            [33.21203209656974, 2.407252695181139],
            [33.215442459816046, 2.406746793044707],
            [33.216842984547945, 2.405536755760275],
            [33.21739060832495, 2.402489164065308],
            [33.21780162170339, 2.402075617380596],
            [33.22078573883897, 2.402029192850273],
            [33.22037458442502, 2.401554522692409],
            [33.21936971457516, 2.401478115379861],
            [33.21914114453932, 2.400268339093019],
            [33.217679410400564, 2.399487555783993],
            [33.21731386075863, 2.398553454465532],
            [33.21556956873381, 2.397791537129605],
            [33.212996514384045, 2.393847386196301],
            [33.21344751986063, 2.393024025698384],
            [33.2132669405222, 2.392209810561323],
            [33.21453048834298, 2.391033483430142],
            [33.215793951722105, 2.391123755519872],
            [33.21580143558673, 2.3895825314139],
            [33.21389990155624, 2.388428124320906],
            [33.21443786485066, 2.387417671094385],
            [33.21590872138111, 2.387417439530205],
            [33.21752296250563, 2.386695492261647],
            [33.21818672407582, 2.387218612055908],
            [33.21877863120304, 2.387074179709451],
            [33.21989081649169, 2.387543099886444],
            [33.22062614145065, 2.386893459972226],
            [33.22290419445103, 2.387019385149437],
            [33.224356969691435, 2.386135076041846],
            [33.22641924556391, 2.383031465316793],
            [33.22512762898379, 2.382183690662623],
            [33.22487631989316, 2.38102902694631],
            [33.223387112578074, 2.378413140476651],
            [33.22189815858793, 2.377348887509943],
            [33.22112660277691, 2.375725206848487],
            [33.219476064325, 2.373686693637635],
            [33.218973658146155, 2.372622279060955],
            [33.21970883667975, 2.371088568262958],
            [33.220749157643965, 2.370907978370269],
            [33.22265055602886, 2.371340686268322],
            [33.223080952356206, 2.3707632633836],
            [33.224928629690474, 2.371755287840886],
            [33.2309090289472, 2.371371377853903],
            [33.23252886747428, 2.371982678343796],
            [33.235385186684255, 2.375515331621403],
            [33.23339636874752, 2.379517982105897],
            [33.23382477620483, 2.379795581543236],
            [33.23478613525558, 2.37936454571978],
            [33.23573813655604, 2.379891001765054],
            [33.23600502512863, 2.381959135371212],
            [33.23563398498366, 2.383175212368448],
            [33.23665251551405, 2.38306971212052],
            [33.237709298105884, 2.383979145281726],
            [33.242459453682685, 2.384552804647085],
            [33.24320180526381, 2.383738807078384],
            [33.24330638623086, 2.38300152164],
            [33.24430591739301, 2.383125816346311],
            [33.24429622996097, 2.382168328385665],
            [33.24761962281306, 2.38109264635496],
            [33.24796897762706, 2.380089837478156],
            [33.24999103682258, 2.380089469486645],
            [33.25114168168349, 2.379654997072049],
            [33.251879302736306, 2.380089123933621],
            [33.252593095077934, 2.379319987306072],
            [33.25419979484566, 2.379717762983035],
            [33.254414055617325, 2.380151984964083],
            [33.254913770443565, 2.379952855764242],
            [33.255461355593, 2.38022416784465],
            [33.25558008861906, 2.38086649057217],
            [33.25603257990911, 2.380649275147871],
            [33.25617543809046, 2.381038275195509],
            [33.25862645720717, 2.381245897655569],
            [33.25912631935713, 2.38182481953449],
            [33.25974513911196, 2.381245685836221],
            [33.260982511821986, 2.381652570981402],
            [33.26255343079362, 2.383063621425037],
            [33.26357659932583, 2.38333483775373],
            [33.26393368773608, 2.383977114153691],
            [33.265076031265444, 2.384239259787227],
            [33.265481269374945, 2.386781419664892],
            [33.266921551744716, 2.389920487079952],
            [33.26706461743685, 2.39135894956767],
            [33.27159988162466, 2.398885248184237],
            [33.272670917785106, 2.399509284030574],
            [33.273432390007045, 2.401065232558766],
            [33.276122113952674, 2.402837920957025],
            [33.2771216397249, 2.402864858387927],
            [33.27943035761581, 2.405279960751339],
            [33.280299768707316, 2.406799693939373],
            [33.281275853840555, 2.410391190567515],
            [33.28279979271945, 2.412706929632606],
            [33.28446560432782, 2.413285594078507],
            [33.28598876257074, 2.414524724693544],
            [33.28810706277423, 2.41484092285048],
            [33.29049915061169, 2.417862138528872],
            [33.290570862222516, 2.419345845783836],
            [33.291689690552666, 2.419897476068211],
            [33.292999437830176, 2.424665007418019],
            [33.298200255727174, 2.428165084998822],
            [33.298391161199774, 2.429675905438848],
            [33.300010268498205, 2.432480140219638],
            [33.30100997573012, 2.433239870621622],
            [33.30386984148884, 2.433751601140983],
            [33.30179905318073, 2.433495897456488],
            [33.30126660733878, 2.439065042805376],
            [33.302046251580606, 2.444284780851426],
            [33.303777103910484, 2.44837330416647],
            [33.30576789993752, 2.454810750030948],
            [33.308622838436925, 2.457246039142548],
            [33.310613071220246, 2.46055150510527],
            [33.310960518012585, 2.466815342408727],
            [33.30883629252146, 2.471692956994415],
            [33.30773862580444, 2.472633804203435],
            [33.303532189926386, 2.478126192277299],
            [33.30210948129854, 2.479199093804551],
            [33.297405540449816, 2.479592619241824],
            [33.294804111913486, 2.479048131413094],
            [33.29250634268928, 2.479288475974771],
            [33.291487424985, 2.47896165794186],
            [33.288399240718704, 2.480042868502476],
            [33.28748590560302, 2.475184693463552],
            [33.286643275985035, 2.472749806936118],
            [33.28659600214322, 2.470467674286913],
            [33.28346091683596, 2.467703900373693],
            [33.28293431722985, 2.466351195619392],
            [33.281366689685456, 2.464528168271353],
            [33.27584207494261, 2.464300201835999],
            [33.27117109777327, 2.463605139377342],
            [33.26278142051777, 2.466303725042574],
            [33.25923509545657, 2.466739438693587],
            [33.253352777855824, 2.4641306050715],
            [33.25058478100456, 2.463870191799867],
            [33.24712470588875, 2.462739853169436],
            [33.243059242628206, 2.462479627200364],
            [33.24017820896812, 2.462770503199102],
            [33.23884979020744, 2.463203042703818],
            [33.23827374463316, 2.464814442421254],
            [33.23851887600959, 2.469982338356543],
            [33.23718127646671, 2.47376519703423],
            [33.237054629283016, 2.475690916264208],
            [33.23595127802686, 2.478422458673597],
            [33.23153632071346, 2.486332661021101],
            [33.22973512400864, 2.48576131379529],
            [33.229284872218585, 2.485895028740855],
            [33.22903405540473, 2.486800825061821],
            [33.228436005597594, 2.485961994353651],
            [33.227324271263214, 2.48586755808419],
            [33.22535617835836, 2.486131372034618],
            [33.22533784374343, 2.486920846316928],
            [33.222973793224284, 2.486846946905299],
            [33.22185193218169, 2.486199621914567],
            [33.22146372792662, 2.48682245945634],
            [33.22108584980572, 2.486431971414357],
            [33.219920996291975, 2.486864941163802],
            [33.2183676896898, 2.486411315255226],
            [33.21787451280217, 2.486896949404091],
            [33.21725525377119, 2.486495943939153],
            [33.21652065914254, 2.486759952514775],
            [33.21561805530125, 2.486453992624285],
            [33.213718652074604, 2.487435962130498],
            [33.21218672178296, 2.489399527397753],
            [33.20961476068287, 2.489509698711124],
            [33.208947885551936, 2.490146232728388],
            [33.20803291190917, 2.490025973938118],
            [33.20746008050702, 2.490567887792516],
            [33.20660493825543, 2.490284210197149],
            [33.20505885500649, 2.49115455089064],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 700,
        District: "OTUKE",
        County: "OTUKE",
        Subcounty: "ALANGO",
        Population: 12410,
        Key: "OTUKEALANGO",
        Dist2: "Otuke",
        "Sub Country": "Alango",
        id2_original: "OtukeAlango",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.662247422231516, 1.574096586196507],
            [33.646296596483545, 1.574000377912287],
            [33.64164334397304, 1.572120108011162],
            [33.640906286163876, 1.572409831336527],
            [33.64016847556652, 1.572075330380414],
            [33.63786217144879, 1.572365537721648],
            [33.6363872437535, 1.572130775979572],
            [33.635079380243134, 1.572538280659233],
            [33.63452936874411, 1.570810522878223],
            [33.63250651543789, 1.570168822522921],
            [33.63177982598372, 1.569445304476035],
            [33.62949576325413, 1.568966521253049],
            [33.626403859962544, 1.56882270909363],
            [33.619294989859384, 1.569584769480032],
            [33.618438667221554, 1.569376949469281],
            [33.61565180844424, 1.567197507353485],
            [33.61136159927607, 1.561680240106968],
            [33.608931471379556, 1.559292600812586],
            [33.60628861344063, 1.557619715065632],
            [33.60117128855943, 1.555639944608135],
            [33.60070950419773, 1.555839106717371],
            [33.59488552319153, 1.552375844069031],
            [33.593398184372234, 1.551932971900999],
            [33.592018880542305, 1.552060017128093],
            [33.58854468750347, 1.551056798023057],
            [33.58373961791334, 1.550578657165421],
            [33.57970904791338, 1.551095443754331],
            [33.578615255630176, 1.551575226911446],
            [33.574023547598145, 1.550599429385473],
            [33.57114688693682, 1.544366938866855],
            [33.56908006828396, 1.542303233480581],
            [33.566449320533394, 1.541105250930041],
            [33.56409614951067, 1.542113143389273],
            [33.55809065940971, 1.541488602079033],
            [33.55641355238498, 1.541706831644007],
            [33.555143058790435, 1.545191756846795],
            [33.55499343000684, 1.547250881485723],
            [33.55342518801475, 1.549220480219535],
            [33.5452960769889, 1.554807628037288],
            [33.541197351808314, 1.555980019277208],
            [33.53766867774415, 1.557680788708452],
            [33.53716226777408, 1.555738772256391],
            [33.53606572664612, 1.554309643462978],
            [33.53606377550532, 1.553260204331577],
            [33.533468753753596, 1.549524496364017],
            [33.53296467311507, 1.546891975505036],
            [33.5333561077119, 1.546186217955252],
            [33.53287886244586, 1.545254507393143],
            [33.53591764745638, 1.541906384790414],
            [33.537103092153046, 1.539418187704848],
            [33.537383886646275, 1.53664976566685],
            [33.53879588376267, 1.53467718384163],
            [33.539074055175234, 1.530416026536637],
            [33.5415504256476, 1.524905841385108],
            [33.54193125293757, 1.51774060696892],
            [33.541236550694066, 1.507635404113576],
            [33.54262747063896, 1.500008526105512],
            [33.54650588130113, 1.500116114579477],
            [33.552414733338765, 1.500042243591005],
            [33.55665153047678, 1.502121941616532],
            [33.559458577991755, 1.502501186825485],
            [33.560742282210875, 1.502111839940445],
            [33.56230087719514, 1.50231951383179],
            [33.56950434618591, 1.500662059910011],
            [33.57214101203757, 1.49834537346914],
            [33.57586272327654, 1.496589303494051],
            [33.57734410177393, 1.496583025514133],
            [33.578891572021696, 1.495722128502432],
            [33.58564957364961, 1.495002152196563],
            [33.585970581226505, 1.494690892203107],
            [33.58642210233606, 1.493254585498587],
            [33.586027240666404, 1.488608628653224],
            [33.58534128082724, 1.484932175680721],
            [33.584922541937324, 1.484415260129833],
            [33.585417032161914, 1.483572565599529],
            [33.58638729441543, 1.483055278850911],
            [33.58638714799004, 1.482499953879572],
            [33.58591132116385, 1.481963904656909],
            [33.583475923749894, 1.482385834181977],
            [33.57733328605788, 1.480378116795639],
            [33.57549910141921, 1.474478919715586],
            [33.575194990254495, 1.471665430742793],
            [33.57883757339164, 1.468235729311951],
            [33.58284426437472, 1.460671529463219],
            [33.583136003043016, 1.456898923779006],
            [33.58263861485332, 1.456229588012587],
            [33.582869354320586, 1.453379776119617],
            [33.58258839004581, 1.450991485612539],
            [33.58361428676153, 1.448819979271766],
            [33.588905016136984, 1.440837071052241],
            [33.58867157723228, 1.435559368477772],
            [33.58905028719313, 1.432751404209831],
            [33.5897662336948, 1.431294679638416],
            [33.59256706037645, 1.427695022932226],
            [33.594612085002204, 1.426503873410417],
            [33.59724719048022, 1.424108428835931],
            [33.60054079070593, 1.420054904400614],
            [33.6013822875483, 1.418249406277481],
            [33.602225722955104, 1.414419453402835],
            [33.6032242480041, 1.41294710479189],
            [33.60532854437064, 1.410864089713958],
            [33.608895376173116, 1.408242119832256],
            [33.61371008288965, 1.402783364005713],
            [33.615992838570506, 1.401095248741948],
            [33.61691143332216, 1.398670518681751],
            [33.616668899873545, 1.397440647509162],
            [33.61750542364252, 1.396642630150834],
            [33.618199006585186, 1.396553802384571],
            [33.61826470846676, 1.395190884153278],
            [33.61898022916697, 1.394791796546833],
            [33.619376192171174, 1.393329067157795],
            [33.621908170156274, 1.39244195555876],
            [33.62311889973328, 1.391200619312102],
            [33.62310586068691, 1.389452257154566],
            [33.62296723536723, 1.388676841943634],
            [33.624212005703576, 1.387782437313592],
            [33.62544635019279, 1.387759103233893],
            [33.62629223171209, 1.388218989227725],
            [33.62759565125671, 1.390082091775993],
            [33.62867048549418, 1.396318541519375],
            [33.63051850957813, 1.399330611441467],
            [33.63225045156445, 1.401021884611097],
            [33.63656005805458, 1.403047178491816],
            [33.63952641100539, 1.405154252898183],
            [33.64040568559877, 1.40532589805746],
            [33.64510100441739, 1.404365642499184],
            [33.6461573692926, 1.404980525159444],
            [33.646735982251904, 1.406843989793385],
            [33.64794536794927, 1.408209706731313],
            [33.65174676155055, 1.408959515853978],
            [33.65360116726627, 1.408533796410238],
            [33.65639672443048, 1.406560821078672],
            [33.65841842879145, 1.405727950112718],
            [33.66300453942096, 1.406070415929185],
            [33.66637537948974, 1.408086860598778],
            [33.66948255593777, 1.411433236038489],
            [33.67061345582872, 1.413341757461494],
            [33.67309689334745, 1.420053668698437],
            [33.67421367351875, 1.446578189305848],
            [33.67484225526577, 1.45386057126204],
            [33.67598544410985, 1.459152528683088],
            [33.676908063313974, 1.46141391539339],
            [33.68324831958867, 1.471182367426452],
            [33.68832845421715, 1.480869748771868],
            [33.69498327804647, 1.497196824358519],
            [33.695392248655985, 1.49707908734539],
            [33.695696985048116, 1.497802720557507],
            [33.698125548079375, 1.5060072291924],
            [33.69760457372363, 1.514294104870276],
            [33.6984671171948, 1.518220059063079],
            [33.70051134231997, 1.52434395282275],
            [33.70099278720998, 1.527672949566842],
            [33.702823726235565, 1.534357792831115],
            [33.70570226796903, 1.540318550172597],
            [33.70670726627799, 1.545049589078546],
            [33.70585179793799, 1.552449998819168],
            [33.706866129742714, 1.568217884526838],
            [33.707201343277504, 1.56927622323846],
            [33.708141623360135, 1.570225794735228],
            [33.68119872882634, 1.572804069251769],
            [33.662247422231516, 1.574096586196507],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 701,
        District: "SERERE",
        County: "SERERE",
        Subcounty: "KYERE",
        Population: 47898,
        Key: "SEREREKYERE",
        Dist2: "Serere",
        "Sub Country": "Kyere",
        id2_original: "SerereKyere",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.585167884417835, 2.328088393000062],
            [33.585380344965685, 2.327433706097176],
            [33.58393044972407, 2.326991916400427],
            [33.583555914234374, 2.327254232527659],
            [33.5822540685381, 2.330335149514822],
            [33.5821731887215, 2.331711521340869],
            [33.580300813106795, 2.333793192770018],
            [33.57956720482833, 2.332318848608399],
            [33.57831286653589, 2.332106362991106],
            [33.577482403700095, 2.332778491112991],
            [33.576143784569375, 2.332479034526572],
            [33.57228697299989, 2.334648518547245],
            [33.57103351325978, 2.3366152331521],
            [33.56955095976599, 2.335993208257182],
            [33.56922457128055, 2.334485921106324],
            [33.568735841053616, 2.334338655036986],
            [33.56824836397647, 2.337304541260567],
            [33.568591933640036, 2.341023799351179],
            [33.56601860350749, 2.341893253780211],
            [33.566230888883844, 2.343203969127786],
            [33.56556352237443, 2.344416731262674],
            [33.565417552428976, 2.345989753284637],
            [33.56367497169473, 2.346891638024826],
            [33.563333267832014, 2.347809338109226],
            [33.563301116229695, 2.3488743784407],
            [33.5639859271236, 2.350528988090436],
            [33.56335083798067, 2.35100441178918],
            [33.56222660538575, 2.350316696414523],
            [33.56175426402283, 2.350431583139924],
            [33.561771353572816, 2.352430549972486],
            [33.56089212120027, 2.35339762285599],
            [33.55944236879077, 2.353381824046857],
            [33.55975142697777, 2.352283901515566],
            [33.55856213569502, 2.351841985911203],
            [33.557796722563914, 2.352301075396482],
            [33.557585275315716, 2.353087641428165],
            [33.55706405751649, 2.353186161857535],
            [33.55701550267708, 2.35397266366334],
            [33.55543568229931, 2.354579545062978],
            [33.55429524319835, 2.354104835243348],
            [33.553383703814916, 2.355776475200262],
            [33.552992798325775, 2.355874941586162],
            [33.55227579720198, 2.355187055385396],
            [33.54952305104928, 2.355565008279895],
            [33.54906651284883, 2.354451004145782],
            [33.54813811208756, 2.354680762545047],
            [33.54688432086908, 2.355926525026865],
            [33.545925407930866, 2.355051802596431],
            [33.543886879022885, 2.355403382630627],
            [33.54331662488727, 2.355075905579624],
            [33.539554286441295, 2.356371798887074],
            [33.5380071746213, 2.357355507013151],
            [33.53745326084072, 2.357159101308693],
            [33.53636106935534, 2.35506223310097],
            [33.536311498521336, 2.3532271201095],
            [33.53552946655749, 2.352850565873819],
            [33.534599700356964, 2.353069393180228],
            [33.53498325762708, 2.352030978532045],
            [33.53627648308987, 2.352158651733369],
            [33.53708955633835, 2.351374996858925],
            [33.53833358646293, 2.34618705543104],
            [33.54115272170839, 2.341764438836099],
            [33.54616652024467, 2.329229039216571],
            [33.54386059252106, 2.31801946467428],
            [33.54519251291472, 2.316469675797759],
            [33.54620395214426, 2.312240060442495],
            [33.54762790853204, 2.298855671900217],
            [33.54905598818698, 2.291648057428511],
            [33.54905401279166, 2.286462558380634],
            [33.54803680727632, 2.283411771309225],
            [33.546297346391086, 2.280615154030006],
            [33.545307895224774, 2.279854053175191],
            [33.54226708002172, 2.275603778732747],
            [33.53871107022345, 2.269950536393115],
            [33.535411526743836, 2.266820717304225],
            [33.52156456078111, 2.258367271514607],
            [33.50869377876631, 2.25126854897775],
            [33.49898163947881, 2.241659606488445],
            [33.496730723684834, 2.238661487836021],
            [33.495323432842206, 2.235380163871826],
            [33.49228028920594, 2.232327303667167],
            [33.49171352502521, 2.230972682455849],
            [33.49121591225672, 2.230996380900861],
            [33.49051307037844, 2.231746338960693],
            [33.48882770334466, 2.231747207870308],
            [33.487582315865666, 2.232523720237159],
            [33.48751420470251, 2.23209980291419],
            [33.48827552241424, 2.231194859514544],
            [33.489274225329666, 2.230868838721525],
            [33.48927406902281, 2.230398396514217],
            [33.48856758627266, 2.230543382468422],
            [33.48851904221304, 2.229919166309617],
            [33.48912776580236, 2.229900865326719],
            [33.48953002330176, 2.229330778105022],
            [33.49068741271382, 2.229556562110042],
            [33.491702540425905, 2.2290326643888],
            [33.49209470265816, 2.229974736199829],
            [33.492476886404184, 2.229647721454255],
            [33.49372898519666, 2.229926114004665],
            [33.49388177964333, 2.229560718161236],
            [33.49498085581704, 2.229521889153132],
            [33.49542977540557, 2.228704519310485],
            [33.49558286899121, 2.229233255403554],
            [33.49616565731999, 2.228617741268306],
            [33.4969016362525, 2.228819392447373],
            [33.49715037975465, 2.22834076942818],
            [33.497490450480186, 2.228593093086287],
            [33.49789500946335, 2.228039216667377],
            [33.49845368970487, 2.228429901088105],
            [33.49920644377698, 2.228217920757647],
            [33.49895564942098, 2.228657739919667],
            [33.49929563570488, 2.228657624124663],
            [33.49919868053629, 2.229203251938711],
            [33.49973294726328, 2.229211213067566],
            [33.49985416233446, 2.228592287906927],
            [33.50054208768748, 2.228176748883981],
            [33.50088216739617, 2.228453501731769],
            [33.50071230675571, 2.228844433790032],
            [33.5015300404639, 2.229283886529653],
            [33.50173271656166, 2.230179570206171],
            [33.50395846695124, 2.229152759943353],
            [33.50423354636259, 2.228721076202031],
            [33.50398242501986, 2.228191854303906],
            [33.504508446110904, 2.227760082312513],
            [33.50437869165465, 2.227067955163705],
            [33.50494530312177, 2.226978183406315],
            [33.50535834579449, 2.227572495156398],
            [33.505641326787085, 2.226578926166696],
            [33.50717920931583, 2.226154947887407],
            [33.50796466116596, 2.226879420912575],
            [33.50796448509616, 2.226366398908807],
            [33.508790070978236, 2.226097386893421],
            [33.508692666651996, 2.225323817184057],
            [33.50908947497087, 2.225787842006476],
            [33.50972070405304, 2.225290886442567],
            [33.5095261478271, 2.224476634443568],
            [33.51015740385871, 2.224061111315328],
            [33.50976058206512, 2.223556371742748],
            [33.511662756594404, 2.223213694463464],
            [33.512301665373926, 2.221519686026849],
            [33.512803757142414, 2.222130250846687],
            [33.513256958999875, 2.221812506981659],
            [33.51388780989133, 2.220232507212791],
            [33.51435727125542, 2.220118338055365],
            [33.514300409694584, 2.219548334123562],
            [33.51547364987983, 2.218074005074163],
            [33.515894685761914, 2.218375155932186],
            [33.51614512258839, 2.21692557911494],
            [33.516606402995215, 2.216567116141346],
            [33.51751307261147, 2.21671337451707],
            [33.51811979834762, 2.215605687960804],
            [33.51919641035104, 2.215613451681364],
            [33.51957643993703, 2.21439183886245],
            [33.519228199033996, 2.213919657155235],
            [33.51984315423645, 2.213202839179047],
            [33.51933300547819, 2.212698141681007],
            [33.52102446129296, 2.211679645833462],
            [33.521008100276696, 2.211191060570039],
            [33.521477723337554, 2.21154919451024],
            [33.52199567755733, 2.211231427728022],
            [33.52191493248802, 2.211809621392828],
            [33.52235206797663, 2.211858325869982],
            [33.522376150012754, 2.211280151074714],
            [33.52342044153054, 2.2114670742447],
            [33.52328261032155, 2.210840098739826],
            [33.5239222009224, 2.211133025036322],
            [33.52448052812599, 2.210530231995263],
            [33.52541959099139, 2.21072533371863],
            [33.52602655837435, 2.210326101713535],
            [33.52617193363509, 2.209389583692379],
            [33.52647967848514, 2.209796632661503],
            [33.52711915050834, 2.209755688277303],
            [33.528138796746326, 2.208924719813016],
            [33.527741733305916, 2.207735958114337],
            [33.528024952352034, 2.207458988648023],
            [33.52936857959051, 2.207173495954537],
            [33.53017776223549, 2.206350745821137],
            [33.531011631482805, 2.206659887239296],
            [33.53084147888989, 2.206203929881246],
            [33.531213678759876, 2.205755921968985],
            [33.53226609014953, 2.20602426803361],
            [33.5328572175391, 2.206618506511176],
            [33.53455676807288, 2.205656997380168],
            [33.53532540346091, 2.204638823450036],
            [33.536353325877585, 2.204337154552652],
            [33.536393600945026, 2.203783403707123],
            [33.537336978418736, 2.202358522300312],
            [33.53845365348719, 2.202412252141303],
            [33.53802297598715, 2.201965779868165],
            [33.54041682901416, 2.199461076535757],
            [33.540658721963986, 2.198703071716992],
            [33.5417987119073, 2.198824985682994],
            [33.54244582410202, 2.198353220032918],
            [33.54457385934821, 2.198868875570081],
            [33.546931952240385, 2.197782743661601],
            [33.547869443952386, 2.197917120736564],
            [33.54963988324018, 2.197138069615372],
            [33.550354163367004, 2.197242588056743],
            [33.5511350984879, 2.196516295374003],
            [33.55173787612836, 2.196890299794692],
            [33.55207243748626, 2.19623901772176],
            [33.553069381500364, 2.196193739084408],
            [33.55353782866653, 2.195452591482269],
            [33.554155360237225, 2.195482299403459],
            [33.55438563617381, 2.194494250161848],
            [33.555070065283715, 2.194359272246806],
            [33.55516702584223, 2.195010393560844],
            [33.555695085210616, 2.194523699577033],
            [33.55663248888771, 2.194426048017742],
            [33.55697456195799, 2.193976846274573],
            [33.55672892932166, 2.193670071144033],
            [33.55737610260181, 2.19338541511997],
            [33.558454969376555, 2.19357212419983],
            [33.55851381711251, 2.191760837064811],
            [33.55883382396617, 2.192000222712513],
            [33.55969667825447, 2.191505916505154],
            [33.559681586557666, 2.190937095496537],
            [33.560269372214364, 2.191011720546601],
            [33.56056649718113, 2.189739232459869],
            [33.56227740960663, 2.188990131088622],
            [33.56351165078957, 2.186871534065923],
            [33.56375727534107, 2.187155853807236],
            [33.564426791518954, 2.186946033645826],
            [33.565110966405655, 2.186144925760981],
            [33.56461234752404, 2.185763402534997],
            [33.56644956577344, 2.184572661010388],
            [33.56659764047163, 2.182641589556489],
            [33.56747550111674, 2.18250653427298],
            [33.567876856707585, 2.181443575375152],
            [33.56774995170739, 2.18030597039906],
            [33.56718431581066, 2.179767297723651],
            [33.567615544876276, 2.179003709338309],
            [33.56652907835419, 2.178360449122032],
            [33.566067515876384, 2.177589713699872],
            [33.565635421733155, 2.176033089943333],
            [33.565970062142796, 2.175621312750564],
            [33.56583580892358, 2.174723215655911],
            [33.56514160075348, 2.174337152717854],
            [33.56663111259744, 2.173139051142801],
            [33.56573160704557, 2.170990165052653],
            [33.56598363209345, 2.170339751471396],
            [33.56677179416082, 2.169871541527345],
            [33.56676295833167, 2.167317853433103],
            [33.569285300987026, 2.166444522696282],
            [33.56967134389555, 2.165801988735216],
            [33.57208303836242, 2.164191138684187],
            [33.57212219323071, 2.163493221713341],
            [33.57279240560292, 2.163841917220231],
            [33.5734621319866, 2.162897908710814],
            [33.573445992854175, 2.161906575937669],
            [33.57458108428429, 2.161628569283072],
            [33.57452573728298, 2.161192400998206],
            [33.57510893704017, 2.160755989317684],
            [33.57480914407704, 2.160153370844502],
            [33.57595232663286, 2.160430508818111],
            [33.57787556845221, 2.159684287006642],
            [33.57808005914684, 2.158431156956393],
            [33.578655499256605, 2.158327837813486],
            [33.577837657750564, 2.15785146695762],
            [33.57856260267643, 2.15686914448488],
            [33.57972982325096, 2.157144193261285],
            [33.58040780874535, 2.156842199756145],
            [33.58030322687996, 2.15616005881505],
            [33.58085070423158, 2.155582619331319],
            [33.582363440220576, 2.155719785667863],
            [33.58412992153123, 2.154433456134838],
            [33.58553837030225, 2.154669051411492],
            [33.58598148138415, 2.153986699439403],
            [33.58700503439528, 2.153684569758082],
            [33.58706345992307, 2.15301548596986],
            [33.588125855188764, 2.151991804180548],
            [33.58802132362905, 2.151447412179642],
            [33.58854954199926, 2.151670228518164],
            [33.58845784467, 2.150587959472488],
            [33.58998973184256, 2.1496756049198],
            [33.58998291632448, 2.148908155701733],
            [33.590374059867194, 2.148737459370895],
            [33.5911566478882, 2.149176634872523],
            [33.591104231191366, 2.148514154264198],
            [33.59265559922914, 2.14740500720707],
            [33.59377047497206, 2.14722746855676],
            [33.5941809215136, 2.146394261784646],
            [33.59502191170618, 2.146118437264775],
            [33.595370624224756, 2.144888602683145],
            [33.596544328838995, 2.144713042240619],
            [33.59757698807217, 2.143780821967858],
            [33.59817162428124, 2.143789634556738],
            [33.59882270163958, 2.142966124522779],
            [33.60009709482079, 2.142515641763678],
            [33.60023856330835, 2.141771396873454],
            [33.60259196789307, 2.14076627892913],
            [33.60315291638065, 2.139427140120459],
            [33.6048434711852, 2.139326955319905],
            [33.606949485130556, 2.138095762466936],
            [33.60782908581234, 2.138149692981195],
            [33.60890243333802, 2.137318557628674],
            [33.608393676968426, 2.136933428675641],
            [33.60860076918412, 2.136636451063612],
            [33.61035040708323, 2.135749204701014],
            [33.6194459876755, 2.151955102462569],
            [33.61985999424047, 2.153254840953773],
            [33.62363519476471, 2.158608904358206],
            [33.62611679253372, 2.160323751708906],
            [33.62880874430125, 2.170773866842904],
            [33.62973964687061, 2.17212537758609],
            [33.63315177081486, 2.174203787897321],
            [33.638580809303065, 2.179037121353983],
            [33.6393468009492, 2.180889960582127],
            [33.63442030698043, 2.187706383724797],
            [33.634555592363874, 2.190445548341658],
            [33.635307994296426, 2.193420589814019],
            [33.634966535673776, 2.194797094286476],
            [33.63507485183576, 2.197185433476288],
            [33.63641827785159, 2.202110059461826],
            [33.639202696804574, 2.204773864168132],
            [33.64263877163094, 2.209980935786334],
            [33.64647041240616, 2.21482348998888],
            [33.64928776359744, 2.216009693109871],
            [33.64981121011687, 2.216744866527997],
            [33.65101852609582, 2.216973725090066],
            [33.65383616744293, 2.218807611081772],
            [33.65551296814215, 2.219063243281821],
            [33.65625096738574, 2.219643140305196],
            [33.65751176815836, 2.219487399535701],
            [33.657780291664764, 2.220060758873163],
            [33.658538302677925, 2.220391013535148],
            [33.65890091213393, 2.22139612675466],
            [33.659571288897844, 2.220721144248897],
            [33.66001953205495, 2.220915841589037],
            [33.6605314298331, 2.222204946142502],
            [33.660541687695314, 2.223866093932934],
            [33.66127471656043, 2.224267886838204],
            [33.660851947828135, 2.225977101688296],
            [33.6614425514999, 2.227130546475989],
            [33.661918379224424, 2.227020225123541],
            [33.66244215901884, 2.227723704701851],
            [33.66144755960759, 2.228802235038648],
            [33.66132603012606, 2.230184299844259],
            [33.66047977311097, 2.230761094757928],
            [33.66117455530456, 2.231393183708331],
            [33.66042727197251, 2.232050690681301],
            [33.661168664152925, 2.233138288427809],
            [33.661229106398494, 2.234017524230963],
            [33.660482081781275, 2.234588377110689],
            [33.66033500061982, 2.233930674691702],
            [33.659828233120265, 2.23463565629392],
            [33.65889826749375, 2.234916459836716],
            [33.65984858984292, 2.235862343707436],
            [33.65981375587114, 2.237262482844414],
            [33.66081537112472, 2.236940982071375],
            [33.66060376756967, 2.239527291797355],
            [33.66141945581393, 2.23974095265236],
            [33.661534943226876, 2.240275978943863],
            [33.66025580155108, 2.242193944496198],
            [33.66089902493892, 2.243590128922139],
            [33.65941257904501, 2.243294731629128],
            [33.65801050471926, 2.245190234629733],
            [33.65825608974488, 2.245900698893846],
            [33.65739510754567, 2.246058636943312],
            [33.65601224009895, 2.247488701198608],
            [33.655027171812904, 2.247517869498653],
            [33.654385366864915, 2.248954315324265],
            [33.65350025232391, 2.249026521940726],
            [33.65377171242299, 2.249485969464373],
            [33.65345785723239, 2.250003127701562],
            [33.65280097585897, 2.249644383763678],
            [33.652258580276936, 2.249903137015916],
            [33.65198764569229, 2.250621336490604],
            [33.650974320898975, 2.251325510269369],
            [33.65101766730639, 2.252488778417507],
            [33.65051808812574, 2.252718787544122],
            [33.650047616156954, 2.254198240406715],
            [33.64857773519689, 2.255577612605256],
            [33.64837815559188, 2.25623833474628],
            [33.6467793223711, 2.256583729470366],
            [33.64575112417165, 2.255952278843671],
            [33.64509512045227, 2.257589793577462],
            [33.64358221108843, 2.258538333174982],
            [33.641269665476095, 2.259171272722413],
            [33.64065612691683, 2.259990156865284],
            [33.63971385077766, 2.259961851424636],
            [33.63761568271798, 2.261126071318233],
            [33.63684467038773, 2.260968433809304],
            [33.63346175875816, 2.262520979143037],
            [33.630764234740965, 2.264331727749429],
            [33.63053624771175, 2.265351502913012],
            [33.62898000990678, 2.265194206058981],
            [33.627610428543164, 2.267492665245292],
            [33.62592610355509, 2.268283289674898],
            [33.62472784349256, 2.270596035699783],
            [33.62369992197421, 2.27062520622862],
            [33.62378632912475, 2.272362926905881],
            [33.62194536310396, 2.274115847377458],
            [33.62067553066949, 2.276012135942474],
            [33.6201616664792, 2.276256506628963],
            [33.61946177736324, 2.275510003047614],
            [33.619291123510415, 2.277075497789216],
            [33.61799153617874, 2.276171274405097],
            [33.616592966180896, 2.277507511877462],
            [33.61637865959514, 2.277148562911649],
            [33.61587908760101, 2.277436011300012],
            [33.615907947776165, 2.278154081339175],
            [33.614580270125586, 2.278341354999268],
            [33.61309640868476, 2.280568050477645],
            [33.609542685098866, 2.283528076288045],
            [33.609614435337264, 2.284389746051137],
            [33.60824390535269, 2.284548309122399],
            [33.6078021516252, 2.286530410662631],
            [33.60694595834475, 2.287550454662599],
            [33.60733177128455, 2.28834018305007],
            [33.606189998185364, 2.289274179296626],
            [33.605733517477134, 2.290193521651261],
            [33.60624820093094, 2.291873619906909],
            [33.60547761080886, 2.292764373053595],
            [33.60485019058352, 2.294602936900418],
            [33.6054229644935, 2.298609604126095],
            [33.60466641324269, 2.298940244840966],
            [33.60400909438976, 2.297590525740189],
            [33.60335235674677, 2.297619528768555],
            [33.602053705459646, 2.298984441385755],
            [33.60209699527321, 2.300075912229454],
            [33.59958468590126, 2.301225913239356],
            [33.59864286880117, 2.302375248207439],
            [33.59807223557651, 2.303466978551525],
            [33.59784462673804, 2.305448991031491],
            [33.5964745054869, 2.30664159169077],
            [33.59681784428344, 2.308278681579832],
            [33.59754643097947, 2.309341139817605],
            [33.595162256401345, 2.309672466488763],
            [33.59423502614485, 2.31158296516548],
            [33.59280756003924, 2.312229843245196],
            [33.59259403858105, 2.313766637064971],
            [33.592836944830495, 2.314226109681593],
            [33.59317957216133, 2.314154156764385],
            [33.594037687836504, 2.317686777426247],
            [33.59342377018817, 2.317715760297875],
            [33.5929100470334, 2.318347891929428],
            [33.59221189615749, 2.321809361006895],
            [33.59039981815963, 2.32459629786199],
            [33.590343085057874, 2.325501110765548],
            [33.58937256049627, 2.326334498565453],
            [33.58872990574202, 2.325932640747397],
            [33.587374299469246, 2.327757148729905],
            [33.585167884417835, 2.328088393000062],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 702,
        District: "AMURIA",
        County: "KAPELEBYONG",
        Subcounty: "OBALANGA",
        Population: 17966,
        Key: "AMURIAOBALANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.8943388539825, 1.976562029730153],
            [33.8941727393168, 1.976969197515052],
            [33.89236666925155, 1.976970176095864],
            [33.890844152405734, 1.975496476694023],
            [33.88887276717538, 1.976356925408293],
            [33.8870419269645, 1.97521809441584],
            [33.88585495692846, 1.97598765640569],
            [33.884619176931416, 1.975843581383929],
            [33.883717324980026, 1.977020067557733],
            [33.88175735913357, 1.9771749023764],
            [33.880950356699785, 1.97813422991217],
            [33.88019016637373, 1.978351744025098],
            [33.87793278630302, 1.978235348660869],
            [33.86953405133455, 1.979406765174917],
            [33.8633780512027, 1.978496336848091],
            [33.858899527303166, 1.978824342445701],
            [33.85365124062994, 1.981559038737767],
            [33.85061222654904, 1.983740761075364],
            [33.843364034033506, 1.993315454094932],
            [33.84151418187797, 1.996808268916896],
            [33.84079663996835, 2.002462561511273],
            [33.83948551916678, 2.006714989592937],
            [33.83874166200922, 2.008153732679646],
            [33.83561039274527, 2.011384873092246],
            [33.83296380050971, 2.012951244947001],
            [33.82917071273155, 2.016562666591854],
            [33.82824027369286, 2.016897856533884],
            [33.82764033203374, 2.016246830472193],
            [33.82536905592389, 2.015479055013317],
            [33.82247390164583, 2.015625272207285],
            [33.8206377865276, 2.016377049530863],
            [33.82032446224135, 2.017996500128051],
            [33.81890998307981, 2.01908277726731],
            [33.80891018886525, 2.022091207657366],
            [33.80828184786675, 2.02196487364665],
            [33.807048263352286, 2.020689956426428],
            [33.80461570371633, 2.019940324043119],
            [33.80066969213406, 2.017006541002439],
            [33.79805215770301, 2.015691398475332],
            [33.79552407032142, 2.014854910008993],
            [33.78945734835577, 2.014259500275009],
            [33.7888015153163, 2.014352266734145],
            [33.78757513618872, 2.01643077322747],
            [33.784993948492364, 2.014524100715529],
            [33.783454273824645, 2.012773305126911],
            [33.78252081015839, 2.011022214089948],
            [33.78231768310635, 2.008801606334974],
            [33.779858875596105, 2.002703665720206],
            [33.780689127327776, 1.998958472864147],
            [33.77911708276708, 1.994890214940444],
            [33.777829154669504, 1.987901702258475],
            [33.77857687817603, 1.984382849204932],
            [33.775468880667816, 1.983889674427804],
            [33.77276729716384, 1.984047767534125],
            [33.76897402792598, 1.982847260030314],
            [33.76774509668468, 1.982876939653114],
            [33.762186909204736, 1.984426470372157],
            [33.75958860500899, 1.983631586012185],
            [33.75718859852228, 1.981434403790738],
            [33.75578559084691, 1.980648006490499],
            [33.75745038286743, 1.975056526950392],
            [33.75760205891159, 1.972460122527476],
            [33.75602685048444, 1.966137363179056],
            [33.754300358576984, 1.963261372809663],
            [33.74862160640613, 1.957697249876394],
            [33.74715258333716, 1.954147356435438],
            [33.74669694255371, 1.950913393025136],
            [33.74739411246929, 1.947257064946447],
            [33.74889549914299, 1.945006538019058],
            [33.74840495701412, 1.941842898748704],
            [33.74803026162426, 1.933157506571883],
            [33.74892621433918, 1.92809816331002],
            [33.75017893296919, 1.923843268038264],
            [33.750371448222786, 1.919909141075526],
            [33.7515563000314, 1.919470080016141],
            [33.76257903640267, 1.911792299867576],
            [33.76857761935741, 1.910360266878947],
            [33.772354243711355, 1.908802573361413],
            [33.773992240783556, 1.907462959219192],
            [33.77536628677417, 1.903970413211202],
            [33.77670008913836, 1.895936578683826],
            [33.77810932124032, 1.891973606295301],
            [33.78133713065121, 1.888434993797695],
            [33.78721271627723, 1.883655819668988],
            [33.79070276727576, 1.881048864560142],
            [33.79399207714767, 1.879409961807729],
            [33.7983157027461, 1.880210263076493],
            [33.80286909313974, 1.880217404429307],
            [33.80396086960343, 1.880500968367116],
            [33.80456169071322, 1.881235190562728],
            [33.808584745407494, 1.882216635511085],
            [33.812382777512994, 1.881805191120034],
            [33.81181136994054, 1.884720467792365],
            [33.81298056501209, 1.889586967019935],
            [33.81292555667566, 1.89271175253131],
            [33.81877932312172, 1.893277115652257],
            [33.821094300473526, 1.893124508757128],
            [33.82512236417381, 1.893671781473898],
            [33.82591274148666, 1.893406271349645],
            [33.841220663647086, 1.885577343310554],
            [33.84278464313315, 1.886105748742069],
            [33.84389452154815, 1.885313318753679],
            [33.844540435390236, 1.884139310859953],
            [33.84521828164575, 1.883881450584077],
            [33.84547996358296, 1.885157139594782],
            [33.84633536904092, 1.885509525805267],
            [33.84764213031841, 1.884984201542496],
            [33.848898756619924, 1.883047682584759],
            [33.850824164277405, 1.883643790544422],
            [33.851154902405426, 1.882015300577477],
            [33.851867984179655, 1.882042088254298],
            [33.85286774890375, 1.883443766607416],
            [33.855171943777194, 1.883008408798861],
            [33.85581460841291, 1.883822253076487],
            [33.85560246137712, 1.885495915616782],
            [33.85591351472233, 1.88728691907875],
            [33.85743561025829, 1.888163649686743],
            [33.858242106042255, 1.887321947837486],
            [33.85852487772739, 1.885295448364999],
            [33.85709637855921, 1.882763207763236],
            [33.85719011506418, 1.881406223789671],
            [33.85756902085777, 1.880619012553781],
            [33.85848378249811, 1.880555235994959],
            [33.85984265055367, 1.884326845010701],
            [33.86481562425356, 1.890095859666319],
            [33.86806000758146, 1.891007897662761],
            [33.872839494050595, 1.894072148391104],
            [33.87559947792954, 1.897146454703305],
            [33.878235962321526, 1.895996241748794],
            [33.878711497195255, 1.896303569393486],
            [33.87899918446165, 1.898501647789922],
            [33.880866815174976, 1.900373251388701],
            [33.88124728224052, 1.900472563879043],
            [33.88200652664055, 1.899558508075957],
            [33.88214561369432, 1.896817442088144],
            [33.8833343363435, 1.897359602332638],
            [33.88697312140362, 1.900333917841006],
            [33.88778406205162, 1.902721687914395],
            [33.88923493915186, 1.903842660697153],
            [33.89099396534397, 1.904294053709096],
            [33.89305174874173, 1.906572613108561],
            [33.89471585983925, 1.907114512614024],
            [33.89571500113256, 1.908308080925662],
            [33.89790033002928, 1.907302811012041],
            [33.89927908768354, 1.908034823094171],
            [33.8990551493613, 1.909627062588972],
            [33.894022345168565, 1.913411000754429],
            [33.89255265644798, 1.916134665841095],
            [33.89089136785707, 1.917809078153224],
            [33.889870196279745, 1.91857853706994],
            [33.88720914026979, 1.918959869079772],
            [33.88458510922259, 1.920318164864708],
            [33.884327616129546, 1.923330677418278],
            [33.88508970639242, 1.924660067475285],
            [33.88561513998526, 1.92690324413412],
            [33.88756422184372, 1.927544500198783],
            [33.88903948730558, 1.929045388608462],
            [33.890322272548175, 1.928881881932734],
            [33.891025652517314, 1.93075406735382],
            [33.89176174373924, 1.930699400886724],
            [33.892568764139334, 1.929812450701946],
            [33.89416152744372, 1.930336285282917],
            [33.89273924192237, 1.933448916672934],
            [33.890841087354, 1.935648138783111],
            [33.89041563625228, 1.9376566120134],
            [33.889407881912035, 1.939384962775931],
            [33.889646631656674, 1.940316590574191],
            [33.8891985717559, 1.943157325061079],
            [33.88817916267315, 1.945166115273833],
            [33.89020228277904, 1.947643690205886],
            [33.89033638777623, 1.950475067207198],
            [33.890029231322686, 1.951958801772099],
            [33.89031500697415, 1.952555696433147],
            [33.89067194716241, 1.952772613254541],
            [33.89207317258025, 1.952337649261329],
            [33.893331389798114, 1.951378084255337],
            [33.89551799699746, 1.951639250811839],
            [33.89753443543428, 1.948906231979158],
            [33.899078245047285, 1.948208850206093],
            [33.89978957241174, 1.947014377058944],
            [33.89990729932466, 1.946489637272542],
            [33.8990510566369, 1.945684991059682],
            [33.89897863625529, 1.944753277340014],
            [33.90090316715707, 1.944625597909335],
            [33.9016643330535, 1.945222233012629],
            [33.901334653140864, 1.94765582122982],
            [33.89946004431438, 1.949737442414155],
            [33.89780085328966, 1.953257284361553],
            [33.89450167272945, 1.956271425255168],
            [33.89129441138233, 1.95673449897828],
            [33.89053525771214, 1.957829490887953],
            [33.89062051412079, 1.959656769966731],
            [33.88952870891103, 1.960779078797425],
            [33.888628529622665, 1.962977778623029],
            [33.887892586622804, 1.963340019034191],
            [33.88760624593103, 1.962743124622144],
            [33.88679972319759, 1.963530572715982],
            [33.88713632912108, 1.966732736426227],
            [33.88811011187222, 1.966632706890818],
            [33.88841808219938, 1.965628417851857],
            [33.889035395479475, 1.965148639672443],
            [33.890532505274095, 1.965364944368073],
            [33.89136502435357, 1.965916312883803],
            [33.891366114908315, 1.966911389567306],
            [33.89043953593042, 1.967011395743578],
            [33.890487733240356, 1.96782552401033],
            [33.89159420973535, 1.968928559991023],
            [33.891905482269536, 1.970963777019503],
            [33.893047485337405, 1.972292945445142],
            [33.89338404904007, 1.975377501803478],
            [33.8943388539825, 1.976562029730153],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 703,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "ABARILELA",
        Population: 24290,
        Key: "AMURIAABARILELA",
        Dist2: "Amuria",
        "Sub Country": "Abrilela",
        id2_original: "AmuriaAbrilela",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.47807523231311, 1.555058100158731],
            [33.47553544886651, 1.575874165428524],
            [33.47475769647667, 1.577774210733432],
            [33.47170180215327, 1.580706134696318],
            [33.46742035605069, 1.583167891502674],
            [33.46014148606818, 1.58637217054256],
            [33.45802017830514, 1.587802071207651],
            [33.456489429298045, 1.589385637745956],
            [33.448182307217195, 1.605626861138376],
            [33.44667637057656, 1.607708005983517],
            [33.445584871692304, 1.608766747406502],
            [33.44293419032555, 1.609961535611824],
            [33.44215259584123, 1.609853142776472],
            [33.43652903975471, 1.611193323564273],
            [33.43167448916212, 1.611403972427788],
            [33.42866187297415, 1.612470639118124],
            [33.427095354849094, 1.61516698900361],
            [33.4245882628923, 1.617972100371689],
            [33.41648414120103, 1.622863345990301],
            [33.41572568552181, 1.623696334639137],
            [33.41274371715638, 1.623999993227564],
            [33.41159000724374, 1.62385983330706],
            [33.40302856581771, 1.616628519893652],
            [33.39760576343427, 1.613390746646694],
            [33.39338765215244, 1.610161766464039],
            [33.39238314432364, 1.607936380968392],
            [33.39218098745209, 1.602680067308773],
            [33.39258203761577, 1.599043065262743],
            [33.385350458543094, 1.588938851089527],
            [33.38507061716242, 1.585763375758257],
            [33.386648990354274, 1.583085141550751],
            [33.396033488006545, 1.577528452103177],
            [33.400086637161145, 1.573537911967242],
            [33.40135772364378, 1.571303039346668],
            [33.40234043115724, 1.565404159394965],
            [33.40374343613767, 1.562563108509774],
            [33.40419921256674, 1.560156499444617],
            [33.40365871422661, 1.554357433313418],
            [33.4032019487524, 1.553326388534243],
            [33.4040928394607, 1.551186894659471],
            [33.4052465466784, 1.542408039669042],
            [33.40449350694204, 1.531536627723825],
            [33.40351106443155, 1.529502034617639],
            [33.401950983633824, 1.527700090597518],
            [33.39883120831393, 1.526130985728364],
            [33.39601368554443, 1.525503611063137],
            [33.39342963401893, 1.526097825406312],
            [33.38858665013393, 1.526080391699293],
            [33.38656557818689, 1.525384489975346],
            [33.385163668252794, 1.525421391363584],
            [33.383870769776784, 1.524157347162748],
            [33.380283814813595, 1.522838744351574],
            [33.37957341271388, 1.520878326700528],
            [33.37349191076686, 1.518149291279368],
            [33.368918121429765, 1.517004018645026],
            [33.36719349891639, 1.516164418606829],
            [33.36972040411507, 1.515549571750702],
            [33.373788102384, 1.515216874014224],
            [33.37635787069648, 1.513400745794814],
            [33.378761586326966, 1.510629148175753],
            [33.38058890604028, 1.509235469404886],
            [33.38219474971354, 1.508120499702952],
            [33.38463132931037, 1.507172585213938],
            [33.387178834675154, 1.507172129925642],
            [33.3907786885475, 1.507840291869824],
            [33.393104571446834, 1.507282527902452],
            [33.395046467681375, 1.508644177023955],
            [33.40385232362821, 1.511202868795228],
            [33.40644914650208, 1.510831450299319],
            [33.408340529569855, 1.509824889287955],
            [33.409908937750274, 1.509880109312842],
            [33.41643416522684, 1.508279157267702],
            [33.420324537855315, 1.509120349823696],
            [33.42191436546536, 1.51055134608586],
            [33.42261656594655, 1.510381371152873],
            [33.431282702425655, 1.502247906792216],
            [33.4322024775636, 1.499785029999838],
            [33.43391724106672, 1.498387059006268],
            [33.435847757443234, 1.49483054616612],
            [33.43696574045872, 1.494350829400437],
            [33.43725423890382, 1.492876104692252],
            [33.43856422692981, 1.491663539812575],
            [33.43892411449052, 1.49036974195147],
            [33.4383209820155, 1.489003760232874],
            [33.43856174398637, 1.487637610637446],
            [33.43830462189752, 1.485828254784681],
            [33.43970526430874, 1.482750429892088],
            [33.440085140282825, 1.47930342731634],
            [33.44208227482248, 1.475329487925548],
            [33.44712359324751, 1.470110214002547],
            [33.4474086071276, 1.468099451127257],
            [33.44940532215401, 1.462114807934758],
            [33.45202107702251, 1.459385466215828],
            [33.454779743971216, 1.457709319253742],
            [33.45568335302733, 1.456703782962121],
            [33.45586743130375, 1.461279579217813],
            [33.45798224963719, 1.465486885527882],
            [33.45932337416929, 1.467340911120984],
            [33.4718074970313, 1.475634384600907],
            [33.47743129476464, 1.479840023176031],
            [33.48003123209758, 1.4812236457795],
            [33.48278206663535, 1.484090934333952],
            [33.48458791032516, 1.484479556122167],
            [33.4851094200768, 1.48503130650258],
            [33.48528497244291, 1.486207374390912],
            [33.48696967023179, 1.48755499977138],
            [33.48742462560071, 1.488867858692188],
            [33.4897837308942, 1.489738966086094],
            [33.50204924783352, 1.491693741713786],
            [33.5070621480545, 1.490872445978238],
            [33.51062237544305, 1.489667598405029],
            [33.51097432189664, 1.487468104484194],
            [33.511783771341264, 1.4867713013942],
            [33.512924798838746, 1.486463438318215],
            [33.51705899579491, 1.487240502287121],
            [33.52315991662342, 1.484461648829119],
            [33.52867581321644, 1.4834923064806],
            [33.53011651330279, 1.481763998468679],
            [33.53106714826569, 1.481790910178804],
            [33.53218609427516, 1.480813573426866],
            [33.533183430853036, 1.481129972923194],
            [33.533895454411855, 1.481871646205315],
            [33.53603965843488, 1.485173243828298],
            [33.53691551134534, 1.487280957757483],
            [33.542049381397426, 1.493341110577205],
            [33.54380768983565, 1.496896100114828],
            [33.54422232971291, 1.496905043383729],
            [33.54650588130113, 1.500116114579477],
            [33.54262747063896, 1.500008526105512],
            [33.541236550694066, 1.507635404113576],
            [33.54193125293757, 1.51774060696892],
            [33.5415504256476, 1.524905841385108],
            [33.539074055175234, 1.530416026536637],
            [33.53879588376267, 1.53467718384163],
            [33.537383886646275, 1.53664976566685],
            [33.537103092153046, 1.539418187704848],
            [33.53591764745638, 1.541906384790414],
            [33.53287886244586, 1.545254507393143],
            [33.5333561077119, 1.546186217955252],
            [33.53296467311507, 1.546891975505036],
            [33.533468753753596, 1.549524496364017],
            [33.53606377550532, 1.553260204331577],
            [33.53606572664612, 1.554309643462978],
            [33.53716226777408, 1.555738772256391],
            [33.53766867774415, 1.557680788708452],
            [33.53700334232559, 1.560479386006579],
            [33.53497463290201, 1.56331158651704],
            [33.53384222743463, 1.568930001365181],
            [33.52465052620868, 1.572665103737888],
            [33.51988604609633, 1.575257454603141],
            [33.516238577022335, 1.576383627291298],
            [33.51265058270837, 1.57683543453812],
            [33.511143646242864, 1.57131505787741],
            [33.50876779186089, 1.565426088067063],
            [33.50928493849524, 1.561743858511762],
            [33.50671932938252, 1.556397743456283],
            [33.50493665593885, 1.555999207400292],
            [33.502439202905066, 1.55605965070528],
            [33.496731139604826, 1.557916112409678],
            [33.482999110387794, 1.558212049046689],
            [33.47830462251079, 1.552964542681467],
            [33.478264593581734, 1.550362587271844],
            [33.4793471748902, 1.546096369743345],
            [33.480524617394366, 1.543508190937886],
            [33.48342577780839, 1.540016018885594],
            [33.48295355771805, 1.536274279163423],
            [33.48155619954749, 1.531149597501353],
            [33.481757079913024, 1.530050773388684],
            [33.481110375553456, 1.529024429517196],
            [33.48189963356545, 1.526673618985071],
            [33.48142273145584, 1.523780205258704],
            [33.48145720430488, 1.520158858003628],
            [33.4780881204425, 1.520106357382157],
            [33.475222950131986, 1.518533842666074],
            [33.47322840363867, 1.514694391722397],
            [33.47251957628566, 1.510656792302279],
            [33.47259873403186, 1.508815315905712],
            [33.46923779699079, 1.507216402445222],
            [33.46897237446873, 1.505473752204569],
            [33.468424527909576, 1.505082653841365],
            [33.46602121741925, 1.504087336796609],
            [33.46530205494887, 1.505246106077629],
            [33.464138324329234, 1.504066712297891],
            [33.46315676486268, 1.50227883593294],
            [33.458701513617214, 1.501559210209225],
            [33.45482986906575, 1.501800217264613],
            [33.452702698897156, 1.503963280887394],
            [33.4522738009597, 1.502827680385611],
            [33.451407860958405, 1.5022410298582],
            [33.450718788456804, 1.502507915587623],
            [33.44889868940176, 1.502010374173885],
            [33.44755585447739, 1.502384089478368],
            [33.446135237127514, 1.50373413942298],
            [33.4478293735151, 1.505717046944698],
            [33.448156588450594, 1.506781458419464],
            [33.4463910979817, 1.509508108684536],
            [33.444801533578016, 1.513105892229263],
            [33.443600771707395, 1.517000567629341],
            [33.443387818882776, 1.520980270218779],
            [33.434958900520755, 1.521947294359552],
            [33.43362179684791, 1.521596548735614],
            [33.431732686517776, 1.522474471428364],
            [33.43540371121516, 1.526098145991124],
            [33.44025244701294, 1.531893305671808],
            [33.43618337072833, 1.5377186626108],
            [33.43591892198006, 1.540093507409334],
            [33.4362762906647, 1.541907164245727],
            [33.43559630192721, 1.542980787366139],
            [33.43524108830094, 1.544692208408745],
            [33.43633991653965, 1.548952669073034],
            [33.43650729603327, 1.553675275503133],
            [33.43793769873152, 1.56105324589958],
            [33.44521714633073, 1.557512930474659],
            [33.45667014787533, 1.556459739363941],
            [33.4572474106668, 1.547942002383725],
            [33.459120112369945, 1.547894432395329],
            [33.460078141365926, 1.548422135572298],
            [33.4667620831869, 1.548501496990869],
            [33.47078096790161, 1.550992784181902],
            [33.476660881610655, 1.553234144800718],
            [33.47807523231311, 1.555058100158731],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 704,
        District: "SERERE",
        County: "SERERE",
        Subcounty: "OLIO",
        Population: 28272,
        Key: "SEREREOLIO",
        Dist2: "Serere",
        "Sub Country": "Olio",
        id2_original: "SerereOlio",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.30280629368464, 1.810924679162175],
            [33.29951867803538, 1.81292464992341],
            [33.29420473170142, 1.815295880975889],
            [33.28897276562026, 1.820887874500039],
            [33.28290085318891, 1.824182011938714],
            [33.280919082535554, 1.825657012200945],
            [33.27773281571497, 1.829303517672469],
            [33.27157147150549, 1.832407647092906],
            [33.26917765441112, 1.8346799456884],
            [33.26547557136112, 1.838715354812002],
            [33.26489037734401, 1.839881620258422],
            [33.26464088824013, 1.841371030673059],
            [33.2651058795874, 1.842615502574445],
            [33.26472704386243, 1.845011392436033],
            [33.262506965435556, 1.848153048825238],
            [33.258738864297, 1.851781484073149],
            [33.25760989668221, 1.853599496797433],
            [33.25726041610409, 1.85517941459168],
            [33.25280207016248, 1.855605404910264],
            [33.25011032410915, 1.856301337290195],
            [33.24826039290187, 1.857762251650003],
            [33.24722758005675, 1.857840134151608],
            [33.245944719355705, 1.858905500958277],
            [33.24398293891238, 1.859403527857677],
            [33.24152992284076, 1.86136298674511],
            [33.240671980540455, 1.862674946958389],
            [33.240073262386744, 1.865153959472668],
            [33.239387704992815, 1.870448365608997],
            [33.237551043698886, 1.871273196270751],
            [33.23708723094128, 1.871955475352774],
            [33.23715869731203, 1.872673588580368],
            [33.23847930162806, 1.874576430493043],
            [33.23767508486996, 1.885405606595133],
            [33.237766075225096, 1.887117832920631],
            [33.238452711495675, 1.887849666798626],
            [33.23844057884944, 1.888722108201977],
            [33.23599514905041, 1.899072427374834],
            [33.235685564450634, 1.899551970138806],
            [33.23183722219768, 1.90013151390861],
            [33.229246109914065, 1.901371326618537],
            [33.225603898679445, 1.905434001762693],
            [33.2228925675563, 1.907117138730796],
            [33.220606790841146, 1.909922064378861],
            [33.21556023164475, 1.910157936847903],
            [33.21109373169529, 1.911189876499054],
            [33.20660760715014, 1.910294752346034],
            [33.20562403815232, 1.909444434156617],
            [33.200379997815446, 1.907789419104883],
            [33.19874474868966, 1.906333009713557],
            [33.196473386341566, 1.902822953925796],
            [33.1946846771175, 1.900950386029416],
            [33.190437639185205, 1.899458072358112],
            [33.185013084188625, 1.893632257434977],
            [33.18047283974088, 1.890601921317336],
            [33.178579799281415, 1.887616535046597],
            [33.17500031470812, 1.884966065392947],
            [33.17051163625263, 1.88012624758105],
            [33.16857114767817, 1.877240372655256],
            [33.165159114463734, 1.874037981084643],
            [33.162229442420895, 1.872780692272654],
            [33.16021166190108, 1.872509461548407],
            [33.15897619900936, 1.872835275280307],
            [33.15619402853953, 1.87450021870495],
            [33.15495964272785, 1.874328431518851],
            [33.147841786776894, 1.871877250502546],
            [33.14611137192657, 1.870583641753543],
            [33.14507073385704, 1.868774281044494],
            [33.14417581510302, 1.865553537444091],
            [33.14446480672316, 1.863816444089633],
            [33.14421109553749, 1.860577553218324],
            [33.141773558336524, 1.857022186348943],
            [33.13238960685994, 1.853838289494511],
            [33.13039409467771, 1.854209376022034],
            [33.125948811138635, 1.856272472507711],
            [33.12363297050585, 1.85660738529998],
            [33.12006794701204, 1.85798281487849],
            [33.11840705367985, 1.858001022236685],
            [33.11710100386806, 1.857403991559601],
            [33.113903743464995, 1.853812443227133],
            [33.1118376461593, 1.848863729484092],
            [33.11208383125955, 1.845100055977253],
            [33.11367634842557, 1.83930971347971],
            [33.1133082287036, 1.834306605961345],
            [33.11202279522756, 1.830570171448199],
            [33.112453175385234, 1.82928543392505],
            [33.11464572044866, 1.825883527720867],
            [33.115199325208806, 1.822698858789224],
            [33.104858711073774, 1.802189361351305],
            [33.10344322040924, 1.79828102731172],
            [33.10146670130703, 1.790572873064081],
            [33.102196357896574, 1.784945435996659],
            [33.10679631515788, 1.787677444846132],
            [33.11077211667156, 1.788319563131721],
            [33.112242765691185, 1.788916591582795],
            [33.11560869646692, 1.791431518588662],
            [33.11862219120725, 1.792299860769472],
            [33.12604258447452, 1.790679903549179],
            [33.12852260031033, 1.792796787372018],
            [33.13083072621144, 1.795773167908854],
            [33.133219032141554, 1.800043295900437],
            [33.134072124437665, 1.800785107717988],
            [33.13896196983778, 1.801399951253266],
            [33.14458677278594, 1.797518241952714],
            [33.14660717908134, 1.796568119424749],
            [33.14900746404577, 1.795672245959474],
            [33.15031370070716, 1.795554523880314],
            [33.15195097463556, 1.796061033505297],
            [33.157167360336395, 1.79408829022404],
            [33.16267557992698, 1.794341128194299],
            [33.16409876825519, 1.79501049553261],
            [33.164785269778456, 1.795942298649274],
            [33.16614668365956, 1.796016284364554],
            [33.16791564971029, 1.797156904503411],
            [33.16859302524858, 1.79852827095454],
            [33.16932496445725, 1.799090318554793],
            [33.16890021763475, 1.803080188276738],
            [33.1696076373277, 1.805296694289143],
            [33.16863667618488, 1.809286615941695],
            [33.168869233842265, 1.8113584106421],
            [33.168246260277584, 1.813837410915899],
            [33.16823923814701, 1.816904424184038],
            [33.170804709817446, 1.821545411704331],
            [33.17436261236603, 1.823300230569351],
            [33.176709496080086, 1.824946595259702],
            [33.17801279075891, 1.826167841990937],
            [33.17915670274678, 1.829515201026631],
            [33.182290314816996, 1.830926250660084],
            [33.19059641910664, 1.831884385567101],
            [33.1950758862372, 1.830291589794361],
            [33.20155833144836, 1.830281820212563],
            [33.214609045116255, 1.829022732479298],
            [33.217115567541136, 1.828371029596431],
            [33.219234945722974, 1.826820851159983],
            [33.222570904209256, 1.826341562443024],
            [33.22422619385068, 1.826542371280057],
            [33.22468257574427, 1.82458958557703],
            [33.227964365818906, 1.823038474593688],
            [33.22933408731973, 1.821860920153581],
            [33.2295041842171, 1.81287260963064],
            [33.22990365424413, 1.812298226921021],
            [33.23272891869479, 1.811694815115975],
            [33.23349933723862, 1.810689635622292],
            [33.23324203638506, 1.807157530376895],
            [33.2335841346082, 1.804285828633658],
            [33.234784710527556, 1.800666304033254],
            [33.236019098135856, 1.799163851614793],
            [33.24067002850133, 1.797054254224057],
            [33.24546475668591, 1.796851379702416],
            [33.25770893863723, 1.797578956140253],
            [33.2720402151157, 1.80750431678342],
            [33.30280629368464, 1.810924679162175],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 705,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "ALWA",
        Population: 23332,
        Key: "KABERAMAIDOALWA",
        Dist2: "Kaberamaido",
        "Sub Country": "Alwa",
        id2_original: "KaberamaidoAlwa",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.63393877136055, 1.937221017457458],
            [33.630497994751984, 1.939013559635799],
            [33.62648903552283, 1.939195993669981],
            [33.62262790395517, 1.938060725948546],
            [33.61936134212123, 1.939168603562363],
            [33.618890512622926, 1.940697037865683],
            [33.61835366593439, 1.940723584914322],
            [33.617502857155785, 1.941567075892368],
            [33.61610834933964, 1.94160052521026],
            [33.61513961152713, 1.942220090276748],
            [33.6145371429071, 1.941831658299997],
            [33.614288597932614, 1.94250365744125],
            [33.61255373282837, 1.942787547765746],
            [33.61137589506548, 1.944540208345591],
            [33.61057725504867, 1.944823755368889],
            [33.608456735108106, 1.94685342814563],
            [33.60845041995165, 1.947498989672116],
            [33.60771148376526, 1.94816821865083],
            [33.60414049096633, 1.950584995894521],
            [33.59962697409326, 1.952739751315417],
            [33.59680070981771, 1.952387940977202],
            [33.59412966723674, 1.950769521436886],
            [33.59074746437795, 1.949974604878336],
            [33.58736212011064, 1.945968634852664],
            [33.584639167482635, 1.944112064594844],
            [33.583293030351314, 1.942286494198691],
            [33.57997512081571, 1.939139298445082],
            [33.573715557508024, 1.93501710995768],
            [33.57308940300889, 1.934009850967477],
            [33.57311976337056, 1.931239292437442],
            [33.57443237807043, 1.926484838937044],
            [33.574212161468445, 1.922958762609091],
            [33.57333553061696, 1.921479334583464],
            [33.57070313715278, 1.909453519161588],
            [33.56825863082187, 1.90124063624243],
            [33.569523782135406, 1.898161825651455],
            [33.572928149127186, 1.897881485085997],
            [33.577533116292834, 1.898773641203318],
            [33.58141316188882, 1.898678258382572],
            [33.58288546740185, 1.897925170435079],
            [33.58473118461216, 1.895478632067845],
            [33.584923974750225, 1.894474602657243],
            [33.58414669577253, 1.890819962006548],
            [33.58274135427406, 1.887735481067899],
            [33.580794568509454, 1.885456343806891],
            [33.57871543485235, 1.883982412434169],
            [33.577921784976944, 1.882572248221146],
            [33.57771316472692, 1.881263088868635],
            [33.578047836577596, 1.879011102567455],
            [33.57730694475882, 1.876835314278155],
            [33.577536326871666, 1.872545441411558],
            [33.57857074320953, 1.866069789491741],
            [33.57733365796041, 1.864371300165288],
            [33.58091282722505, 1.865797607816988],
            [33.58477675794313, 1.865859645798958],
            [33.584678585557306, 1.864665501577069],
            [33.585135464219256, 1.863027879091058],
            [33.585010164508475, 1.859662513138563],
            [33.5899907810748, 1.855037934954455],
            [33.592090406201834, 1.854033035679366],
            [33.59245268956939, 1.845076596964569],
            [33.59341479152691, 1.841900853610057],
            [33.5940651942505, 1.84095072303367],
            [33.59363957067226, 1.838526328067172],
            [33.59238221583707, 1.837576836760587],
            [33.59180069772608, 1.836120498327533],
            [33.59059225705644, 1.835243362939575],
            [33.587449923243135, 1.830520759692214],
            [33.58700260984235, 1.826586368158964],
            [33.58208567754146, 1.825581912554412],
            [33.581904602333, 1.813196124964017],
            [33.583211934040705, 1.810012161819462],
            [33.581595555824116, 1.806369567106108],
            [33.58058632375525, 1.800574106076272],
            [33.57852550405184, 1.796882772953601],
            [33.5776839227678, 1.792225819235596],
            [33.57515376117621, 1.790874859484484],
            [33.57120965132742, 1.786972959702546],
            [33.570238028126234, 1.785557131501964],
            [33.56828952837606, 1.784533675639475],
            [33.562757464802885, 1.779450178684371],
            [33.55841824804437, 1.776531458925503],
            [33.558217413492955, 1.775948191914686],
            [33.552836342346005, 1.773275549106782],
            [33.55191731999626, 1.772298764807801],
            [33.57490131841171, 1.749022289201015],
            [33.57971338947115, 1.744595395212569],
            [33.580767817578625, 1.744615287264363],
            [33.58187550140936, 1.745410926962662],
            [33.58298291664385, 1.7453362891487],
            [33.583425993589756, 1.745665157027747],
            [33.58402709227899, 1.745399641276454],
            [33.584649439717914, 1.745632935046413],
            [33.585893814795575, 1.74507004964464],
            [33.586357962624774, 1.745324618263573],
            [33.58669528630218, 1.744740791075543],
            [33.58845655379095, 1.744464295685425],
            [33.59213818579519, 1.746776789904799],
            [33.59433225709626, 1.747699431790484],
            [33.596177892559886, 1.747401674621864],
            [33.597986641401306, 1.747775128131563],
            [33.59902863143533, 1.748178020921828],
            [33.60001439142414, 1.748056419601575],
            [33.6014130907794, 1.748797212506378],
            [33.60312214998049, 1.751941826109701],
            [33.60600343966043, 1.755474158432208],
            [33.60764149152988, 1.75584660738582],
            [33.61102824884716, 1.757987631408298],
            [33.6123706705465, 1.758042631810651],
            [33.613624897447856, 1.758681926630382],
            [33.616493324151286, 1.758877957124548],
            [33.619548465686485, 1.757889035629529],
            [33.622821188166654, 1.755765806846117],
            [33.631489100615084, 1.755763038640345],
            [33.634192378341695, 1.753465528793983],
            [33.63620142723695, 1.752550758897889],
            [33.636772405414696, 1.751662908360231],
            [33.638812792038635, 1.750377574993442],
            [33.64092186025596, 1.747825677956801],
            [33.64124034266861, 1.746415128291291],
            [33.6409028249551, 1.744520911804862],
            [33.64133859410615, 1.742030660230022],
            [33.64156360052526, 1.734657020989296],
            [33.641970642451874, 1.730842622022338],
            [33.642479416787765, 1.729871155447665],
            [33.64219346237158, 1.728754575929973],
            [33.65008295677853, 1.733136028221072],
            [33.65198297085956, 1.730442062778775],
            [33.655435642959134, 1.732124179553159],
            [33.657336565236896, 1.732092910017671],
            [33.65986065781043, 1.731097340713802],
            [33.660697285783996, 1.731724463713193],
            [33.66267183308414, 1.732007080190748],
            [33.661795356742886, 1.734238670588354],
            [33.661111692099276, 1.734831328316474],
            [33.661397596209824, 1.736159677357553],
            [33.66119775339844, 1.740337945368121],
            [33.6590851395307, 1.746039024813664],
            [33.65811089774044, 1.746738301513348],
            [33.65636759565906, 1.750816664103024],
            [33.65621995754213, 1.753137041193994],
            [33.654595123483766, 1.756471066170167],
            [33.654103789939114, 1.763834673752561],
            [33.65311055866208, 1.766694723949321],
            [33.65297146801506, 1.768670228835779],
            [33.65406438533917, 1.776586962491242],
            [33.65719602560733, 1.786219924187912],
            [33.658785008801026, 1.789486352207631],
            [33.66005298711276, 1.795883975445916],
            [33.66210236587271, 1.80235159495078],
            [33.66323834393998, 1.80791254872919],
            [33.665851635627945, 1.810613475870207],
            [33.66811403099291, 1.811911219722472],
            [33.669977701932474, 1.813837454911302],
            [33.67195997654071, 1.817512538157018],
            [33.67143716063862, 1.820308873043367],
            [33.673110827115835, 1.824354092192551],
            [33.68076616127094, 1.826046835728467],
            [33.68491821493834, 1.824670160413997],
            [33.68950624796254, 1.824614114209477],
            [33.699334440601625, 1.832571294793995],
            [33.70108867248509, 1.835257441297975],
            [33.70220626024186, 1.839391290555719],
            [33.70348739348262, 1.840711582931343],
            [33.716722798976285, 1.850404183949557],
            [33.71257971139376, 1.857326488826474],
            [33.701511711610245, 1.869272446112553],
            [33.69894383155653, 1.87126292233081],
            [33.68852184532811, 1.880034045651936],
            [33.68651959218799, 1.881265179917234],
            [33.68205321351111, 1.882415865906776],
            [33.67460698289963, 1.885304660988524],
            [33.66653545747674, 1.890138704846106],
            [33.663133854601064, 1.892627847174326],
            [33.66197765186351, 1.894826630540569],
            [33.660331833160114, 1.901033272853861],
            [33.65797104981364, 1.905331346979293],
            [33.655817712619125, 1.911366301738724],
            [33.65589399485812, 1.913944572672319],
            [33.65745872353912, 1.919046287923503],
            [33.657158414044716, 1.921389490716784],
            [33.65460725972326, 1.923056517889171],
            [33.6519210787331, 1.928867325799495],
            [33.645602028088994, 1.936609309920904],
            [33.642666193603304, 1.937347934315831],
            [33.6408199418954, 1.937173177186535],
            [33.64038572054158, 1.937634723609365],
            [33.639178653396, 1.937689462574957],
            [33.63736606605335, 1.93696641519374],
            [33.63393877136055, 1.937221017457458],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 706,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "ARAPAI",
        Population: 40428,
        Key: "SOROTIARAPAI",
        Dist2: "Soroti",
        "Sub Country": "Arapai",
        id2_original: "SorotiArapai",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.85821322340925, 2.337745999208846],
            [33.85403682090609, 2.340179051684929],
            [33.852730510582845, 2.336181467909191],
            [33.85137913986666, 2.334216028143933],
            [33.84986737315987, 2.33360882556041],
            [33.84747040208048, 2.335475194295943],
            [33.84694647316575, 2.33551605433364],
            [33.84436620983584, 2.334179743879969],
            [33.84178677205767, 2.334221842601805],
            [33.840133182028744, 2.332337650928063],
            [33.83888327512555, 2.331527568536487],
            [33.83839820912666, 2.329135899849189],
            [33.836866034493234, 2.328082732899555],
            [33.8379336579539, 2.327352344580963],
            [33.838214851299064, 2.325771050277067],
            [33.837931478641, 2.323663051843724],
            [33.83724602634997, 2.32317696105716],
            [33.837064025876806, 2.322102713639122],
            [33.83768816096316, 2.321129340636158],
            [33.83887690696854, 2.320763756073706],
            [33.839037763794856, 2.320155535227507],
            [33.83833198173064, 2.319365393644166],
            [33.83956057610369, 2.318229493043415],
            [33.839660987989525, 2.317641578865626],
            [33.83905616937672, 2.317195982159673],
            [33.83883377166521, 2.315959592877799],
            [33.83830966937563, 2.315696384253229],
            [33.83794738960133, 2.316466891500898],
            [33.837342810838685, 2.316426710380362],
            [33.836865212534754, 2.315581895909248],
            [33.836355659359505, 2.315508981750731],
            [33.83600023103586, 2.314502457391135],
            [33.83460778575162, 2.313835177391806],
            [33.834343370241015, 2.312874357692751],
            [33.83340679211566, 2.313826735624942],
            [33.83291508936343, 2.313158919450431],
            [33.83194194531446, 2.313818449139853],
            [33.83176878246703, 2.313315183307743],
            [33.832314076912496, 2.312271516269024],
            [33.830694201554515, 2.311650125113245],
            [33.83151191639806, 2.309691082411848],
            [33.83264969199422, 2.310514105233432],
            [33.83345871563742, 2.309259783544323],
            [33.83487786783507, 2.308929467458716],
            [33.83360299315688, 2.307035726756701],
            [33.8339935860323, 2.30594639032342],
            [33.83469420098701, 2.306019194569701],
            [33.834875965203274, 2.30567130565066],
            [33.833483433680755, 2.304839281700589],
            [33.83368295220033, 2.303731753940129],
            [33.83499504767398, 2.303288457879404],
            [33.83528987654685, 2.302425340914956],
            [33.83602137198775, 2.302764427065766],
            [33.83761009107675, 2.30199957169437],
            [33.83967565388487, 2.298999268711829],
            [33.83981548474366, 2.297626965327309],
            [33.83840726683966, 2.294402371081295],
            [33.836775402565905, 2.293512096475234],
            [33.8366903150405, 2.292295536969265],
            [33.837069613397844, 2.291587983963384],
            [33.83319953820321, 2.292805621186116],
            [33.82390047033447, 2.294791359130471],
            [33.82016707381029, 2.295271527425814],
            [33.81451677397944, 2.29482948267689],
            [33.80231435919727, 2.297193767089647],
            [33.79369525311654, 2.301432430921514],
            [33.78153888777244, 2.285157965172454],
            [33.77405320495035, 2.295014175370986],
            [33.76921577265377, 2.295229542439244],
            [33.76716929814714, 2.294943424259774],
            [33.75098453313284, 2.286287448261255],
            [33.737762106498366, 2.277471449671202],
            [33.73066384639703, 2.283395786812779],
            [33.730106205506324, 2.284116425505601],
            [33.730171655859614, 2.284808678996821],
            [33.728702850182934, 2.286016256287392],
            [33.72779116078086, 2.285464762436411],
            [33.72576356706489, 2.285129006771752],
            [33.72295266847229, 2.286253981237424],
            [33.71759151746677, 2.286684717078465],
            [33.71560556964734, 2.286172082395782],
            [33.71221848264836, 2.287588748945647],
            [33.71140235872114, 2.289649317903175],
            [33.708713224070365, 2.29004604453748],
            [33.70669668592057, 2.290983484650472],
            [33.70495900819118, 2.291077990867564],
            [33.7023218015537, 2.291922090127934],
            [33.700884587828945, 2.293046526089982],
            [33.69931234204563, 2.293016085917711],
            [33.69857273302108, 2.293572641994901],
            [33.696055354455986, 2.294171114657217],
            [33.69464477937266, 2.295452013037599],
            [33.69138305496652, 2.29693566678801],
            [33.69088280743931, 2.294610944345281],
            [33.691181150521594, 2.282633150734199],
            [33.6892822799959, 2.272818543228781],
            [33.686348405634185, 2.264804685803813],
            [33.679294431578015, 2.251545733707161],
            [33.67787969729496, 2.247889766844096],
            [33.67388094921562, 2.243077385636457],
            [33.66938564837986, 2.24258344207681],
            [33.664631709099076, 2.240513299382982],
            [33.66257176076148, 2.240063798356827],
            [33.661534943226876, 2.240275978943863],
            [33.66141945581393, 2.23974095265236],
            [33.66060376756967, 2.239527291797355],
            [33.66081537112472, 2.236940982071375],
            [33.65981375587114, 2.237262482844414],
            [33.65984858984292, 2.235862343707436],
            [33.65889826749375, 2.234916459836716],
            [33.659828233120265, 2.23463565629392],
            [33.66033500061982, 2.233930674691702],
            [33.660482081781275, 2.234588377110689],
            [33.661229106398494, 2.234017524230963],
            [33.661168664152925, 2.233138288427809],
            [33.66042727197251, 2.232050690681301],
            [33.66117455530456, 2.231393183708331],
            [33.66047977311097, 2.230761094757928],
            [33.66132603012606, 2.230184299844259],
            [33.66144755960759, 2.228802235038648],
            [33.66244215901884, 2.227723704701851],
            [33.661918379224424, 2.227020225123541],
            [33.6614425514999, 2.227130546475989],
            [33.660851947828135, 2.225977101688296],
            [33.66127471656043, 2.224267886838204],
            [33.660541687695314, 2.223866093932934],
            [33.6605314298331, 2.222204946142502],
            [33.661109396903726, 2.222064839835612],
            [33.660926793661, 2.22153692071733],
            [33.66188226515337, 2.219621367118263],
            [33.66315401998258, 2.218779571445138],
            [33.662735767979555, 2.218466538582493],
            [33.6628021930049, 2.217804270741246],
            [33.664367998765954, 2.21804519075836],
            [33.66448785558442, 2.217508186959336],
            [33.665083821300094, 2.217360255456207],
            [33.66516362762993, 2.216782998403595],
            [33.66424705139272, 2.216139072254288],
            [33.66462464384938, 2.215047103913657],
            [33.66524409691646, 2.21497019825654],
            [33.66501105237218, 2.213776147092075],
            [33.66543309167247, 2.213368852362372],
            [33.666154158571224, 2.213712986107323],
            [33.665846805386686, 2.212724243416221],
            [33.66719143783991, 2.211130042157222],
            [33.66726875493812, 2.210175821248981],
            [33.66918665806971, 2.209861671690931],
            [33.668263867287344, 2.208724855830999],
            [33.66918420117739, 2.207661685779044],
            [33.66830599198597, 2.207152249504313],
            [33.6700644540361, 2.206111602148153],
            [33.670260651484035, 2.204544746996844],
            [33.67097437196043, 2.204357724214602],
            [33.67085986730444, 2.203697144841764],
            [33.6716233858886, 2.203136699972748],
            [33.67162304452877, 2.20237553908407],
            [33.671166056272384, 2.202031070582547],
            [33.671386807371974, 2.200853325653815],
            [33.672083311635966, 2.200669887633205],
            [33.67290162116423, 2.199775521821941],
            [33.67261599463315, 2.198171809505817],
            [33.67171449482132, 2.197442173511333],
            [33.67170482984718, 2.195781627210586],
            [33.6730448629262, 2.192842893496213],
            [33.67302350098872, 2.191628157805764],
            [33.67382272491048, 2.191117363284572],
            [33.67363979557928, 2.189078110719163],
            [33.674217344933325, 2.187681192677164],
            [33.674663475252906, 2.187698942118993],
            [33.674234577315445, 2.186309660095387],
            [33.67463047114934, 2.185724249224504],
            [33.67471882674575, 2.183778223289778],
            [33.67539300428165, 2.182977264522491],
            [33.67455010337245, 2.181577398261229],
            [33.67513415742748, 2.179474528655014],
            [33.67479030659123, 2.178672672623313],
            [33.67554739503456, 2.17840694283986],
            [33.674951449980156, 2.178039762358159],
            [33.67588675519273, 2.176715534322131],
            [33.67584230116256, 2.175625546151628],
            [33.678224467107746, 2.172183836536721],
            [33.678990818978285, 2.172297230179886],
            [33.68052778073387, 2.171490854153686],
            [33.680570235114196, 2.170657868045051],
            [33.68190720403978, 2.170231204206809],
            [33.6820923162771, 2.169177943179229],
            [33.682754022501896, 2.168592452043837],
            [33.683381553220045, 2.168430559597625],
            [33.68498443245285, 2.166744749465794],
            [33.68700175752683, 2.166068840134887],
            [33.686939568058044, 2.165341220001333],
            [33.68784336126876, 2.164603584166464],
            [33.68750508268221, 2.163670243201323],
            [33.687889652353654, 2.161736055213397],
            [33.68755621568649, 2.160984623031829],
            [33.68864579037947, 2.160692108856997],
            [33.68880698856562, 2.159380354125228],
            [33.689390925839625, 2.158751893657411],
            [33.68939185020607, 2.157709088892707],
            [33.69042734811554, 2.156882829598978],
            [33.69103450055147, 2.155101975557284],
            [33.692961203579564, 2.153465407275126],
            [33.69403564255831, 2.151798647297397],
            [33.69903484526785, 2.148116096091001],
            [33.70938287140227, 2.151820375686262],
            [33.71820832499534, 2.156316038659968],
            [33.72675044725285, 2.159601442171566],
            [33.729348053457656, 2.169029726823455],
            [33.73270294932845, 2.169315321932621],
            [33.7369055062811, 2.168814630315825],
            [33.744156282351376, 2.16360107645597],
            [33.747366854888625, 2.160727227760439],
            [33.751411077484235, 2.158973949491641],
            [33.75455139008817, 2.156149890801883],
            [33.77333062349197, 2.162599537572247],
            [33.77632107554696, 2.162480396283915],
            [33.778856609962254, 2.16298568698912],
            [33.780531066058586, 2.164468429422681],
            [33.78390798862014, 2.166149303089331],
            [33.785988873992025, 2.16778561263826],
            [33.788481877670215, 2.167549101975565],
            [33.79032399533118, 2.168271843995662],
            [33.792299058264284, 2.168506009826266],
            [33.79564097617418, 2.170304735125256],
            [33.7958658074218, 2.17204125245645],
            [33.7979108455223, 2.172809106501739],
            [33.799627748812455, 2.174807436686626],
            [33.80114091778942, 2.175195621591496],
            [33.80728014637488, 2.18072985131977],
            [33.80869514566098, 2.183004712374664],
            [33.80997840790896, 2.186689210123306],
            [33.81256432703193, 2.189392195534397],
            [33.81498784153127, 2.190539752253128],
            [33.81946736076413, 2.19057279058609],
            [33.81979345819544, 2.191061235391355],
            [33.8215697185663, 2.191686049575948],
            [33.821702450039396, 2.193041097145985],
            [33.82240645613432, 2.193632012283985],
            [33.82408275916688, 2.19341038614567],
            [33.82564692909579, 2.192514231444517],
            [33.82738600729872, 2.193545966474248],
            [33.829177999865145, 2.192949498393675],
            [33.83028748661468, 2.193223710258934],
            [33.834864173018545, 2.191143880116014],
            [33.83864546142546, 2.190128571489665],
            [33.84308315060711, 2.190062740762033],
            [33.84609244392684, 2.189473027079005],
            [33.849799115571315, 2.187734037952453],
            [33.85317449572551, 2.185551968182962],
            [33.86140789127439, 2.178355499391103],
            [33.86505232583935, 2.175983292735803],
            [33.872249308095476, 2.173762803651901],
            [33.87632856229223, 2.173100054596098],
            [33.88330988509977, 2.173159282811493],
            [33.88790723455181, 2.174314474020544],
            [33.893546106913945, 2.176626933680021],
            [33.8945371229455, 2.177159171207401],
            [33.89315300953552, 2.180139855695397],
            [33.89360568318358, 2.181204675475144],
            [33.89254143020185, 2.181935316680689],
            [33.893582807584856, 2.182754454586609],
            [33.89481296861978, 2.182488067536518],
            [33.89478494747112, 2.183509241277273],
            [33.893483222149094, 2.185339450323202],
            [33.89407252865359, 2.186110988771314],
            [33.893959997596255, 2.186559336504256],
            [33.89141419184401, 2.18680668433882],
            [33.88852877530365, 2.187735925732529],
            [33.887729776859025, 2.188434887131532],
            [33.88575875634466, 2.187337361719488],
            [33.88465770028408, 2.188968403233935],
            [33.883623884919146, 2.188429778547935],
            [33.88303105162884, 2.188698196845826],
            [33.882356398884184, 2.189949513627233],
            [33.88242862792457, 2.191813426363691],
            [33.8819017803835, 2.192916922406729],
            [33.88211803900835, 2.193380486982353],
            [33.88283855434156, 2.193240361800329],
            [33.883578423877566, 2.194396194655186],
            [33.88196988166519, 2.196733310695131],
            [33.881989503565926, 2.198190681788671],
            [33.881397157162525, 2.19929351065454],
            [33.88026367281849, 2.199226222540987],
            [33.87996568367245, 2.199720784718898],
            [33.880529386394706, 2.202068389563328],
            [33.88113644271088, 2.202115137478488],
            [33.88218653554876, 2.200814074894124],
            [33.88294984752043, 2.201356362925489],
            [33.883310158187626, 2.203648326095465],
            [33.88214195395784, 2.205603289199874],
            [33.8825957765512, 2.205773330986834],
            [33.883442457571086, 2.207543637811289],
            [33.88378475701685, 2.207588663864539],
            [33.88394604503455, 2.206797696123618],
            [33.88434487096953, 2.206688016869997],
            [33.885268622949226, 2.208754727757168],
            [33.884455229002185, 2.209338818135507],
            [33.88345291755425, 2.21192196986724],
            [33.88228007532269, 2.213044394922139],
            [33.8823016160249, 2.214781196584185],
            [33.88171944304208, 2.215396731746877],
            [33.88149214412235, 2.216889483994864],
            [33.88093806145847, 2.217016461867697],
            [33.88015534228345, 2.216463891664613],
            [33.879709809343545, 2.217439496655266],
            [33.879936076098986, 2.217840267098348],
            [33.88103051247426, 2.217809693398925],
            [33.88144710798389, 2.218192398693418],
            [33.88101953146824, 2.219353485799493],
            [33.881894257891304, 2.219945343776644],
            [33.88212211376648, 2.221520737163417],
            [33.8820477889565, 2.22216764651877],
            [33.88061128490085, 2.223021719966058],
            [33.87962191278625, 2.224805994070156],
            [33.879280281687095, 2.225891738162124],
            [33.87942021405552, 2.227764209644398],
            [33.87969235148432, 2.228126342128855],
            [33.88034057040346, 2.227904556873932],
            [33.88069192217231, 2.228592466536471],
            [33.881607758197745, 2.228286747898439],
            [33.88205405111236, 2.228591645199661],
            [33.88235534336369, 2.229996842256473],
            [33.881833598253436, 2.230863689890345],
            [33.882829038487735, 2.231481288289989],
            [33.88130092064613, 2.232427630370494],
            [33.882086869264626, 2.233749545892079],
            [33.88266347538762, 2.233132879291031],
            [33.88322269371999, 2.233282133220321],
            [33.88304314115595, 2.235424117304281],
            [33.882458024393955, 2.236041063004055],
            [33.88108889218796, 2.235958121871309],
            [33.881505635021284, 2.236574186770611],
            [33.88134529113297, 2.237005107911767],
            [33.880893001963834, 2.236628410860354],
            [33.88052451752588, 2.237137244529344],
            [33.87989993148525, 2.237095736294088],
            [33.88052986160348, 2.236126001361566],
            [33.880148827701, 2.235539832792074],
            [33.879679166012586, 2.235952989215368],
            [33.878828348250806, 2.235576531561439],
            [33.87880397426219, 2.236255077136125],
            [33.878228221538706, 2.236653953845624],
            [33.87843154442348, 2.237118535214409],
            [33.87957297975609, 2.237431020148507],
            [33.87909800453278, 2.238909273101694],
            [33.87983394214276, 2.238266551370271],
            [33.8803467678806, 2.238304168346828],
            [33.88042431674413, 2.238675108468684],
            [33.87751172975966, 2.242093543060276],
            [33.87744059396895, 2.242500476180837],
            [33.878173830344885, 2.242834760636825],
            [33.8773842606175, 2.246040296666336],
            [33.87644651917387, 2.247742105891101],
            [33.87756831014784, 2.248080967927522],
            [33.87816937200612, 2.247804727737791],
            [33.87875002234455, 2.248670912264036],
            [33.87975180198983, 2.24822819439635],
            [33.87987520266208, 2.248797557962884],
            [33.8784876280433, 2.250206001192206],
            [33.879574003835515, 2.25075363614267],
            [33.87918070343784, 2.251563821683199],
            [33.881634934930034, 2.251721488935537],
            [33.8823216062349, 2.253482437546952],
            [33.88354141777943, 2.253106783289817],
            [33.883426396592114, 2.254772724356883],
            [33.88417602542535, 2.255978341212481],
            [33.88455819659499, 2.25565038080305],
            [33.884682699500104, 2.254517739280372],
            [33.88543378629907, 2.254403659861123],
            [33.88593343554829, 2.255036455794196],
            [33.88614182852454, 2.256606700429225],
            [33.887327252559984, 2.257504339440302],
            [33.88721863007246, 2.258116285955336],
            [33.88625526598198, 2.25813456234943],
            [33.88628760802715, 2.259284026884897],
            [33.88699084336756, 2.259354331836233],
            [33.887529174072924, 2.259990637987742],
            [33.8883314154357, 2.259865277752246],
            [33.888348775378574, 2.260616160797423],
            [33.88758258250982, 2.261090574201398],
            [33.88722715508452, 2.260574408180902],
            [33.88611243205519, 2.260309828603454],
            [33.88570185974953, 2.261622262503963],
            [33.88673527895741, 2.261165369837239],
            [33.886985927786306, 2.262834620147414],
            [33.887893038475376, 2.262816377024241],
            [33.88885714637092, 2.264014783849218],
            [33.88822471534289, 2.264743769257419],
            [33.88879121362231, 2.265440183507356],
            [33.88933224017183, 2.264728937987655],
            [33.89074585066252, 2.265035771911629],
            [33.8903947073028, 2.265778732640059],
            [33.890414886159, 2.267646759170675],
            [33.89112436928219, 2.268805842144742],
            [33.89070265696871, 2.269142106967989],
            [33.88973884372059, 2.268435329781378],
            [33.890245916647324, 2.269694142043597],
            [33.888997841409015, 2.269861147860591],
            [33.88899503058049, 2.271014170193882],
            [33.8886226474542, 2.271523710828221],
            [33.88756737762532, 2.270753325683246],
            [33.8867519867234, 2.271277287404809],
            [33.88737448867256, 2.271556314694226],
            [33.88795554055789, 2.273048516816735],
            [33.88846858368803, 2.27257072065426],
            [33.888616663776105, 2.273235561352209],
            [33.88901404701675, 2.273359106363567],
            [33.889597241384024, 2.272605389894337],
            [33.890328373007264, 2.274567089105562],
            [33.890014753175265, 2.275723781584855],
            [33.89115987160054, 2.27532024444329],
            [33.892103161937676, 2.275809110776741],
            [33.89214149754244, 2.275129049642536],
            [33.89157262950728, 2.27433241857879],
            [33.89276516999642, 2.274024143274461],
            [33.894027432328, 2.27505857132173],
            [33.89487907474322, 2.273563691917107],
            [33.89622742532344, 2.274550418738766],
            [33.897028303043655, 2.274523929442962],
            [33.89846297543445, 2.27583978738428],
            [33.89962207523881, 2.27715581646494],
            [33.900635380269186, 2.27944217664983],
            [33.90134157286347, 2.27948504623889],
            [33.901306525092686, 2.278519158004146],
            [33.90165254536033, 2.278365525710833],
            [33.90206919836214, 2.279371969616542],
            [33.9032272381545, 2.278981410168899],
            [33.90413591011552, 2.279188745185025],
            [33.90401142876996, 2.279812549750802],
            [33.90312042936551, 2.280324221777924],
            [33.90422754096945, 2.28112050484838],
            [33.904732094121826, 2.282341648912644],
            [33.90281702697156, 2.284032119174529],
            [33.90429894805136, 2.285135695693826],
            [33.90409724393072, 2.286210017675563],
            [33.904627223897236, 2.286772767142915],
            [33.90434333201292, 2.287249405174786],
            [33.903585351542496, 2.287024651603563],
            [33.90317667288545, 2.287635642229566],
            [33.903935039631456, 2.288475458380933],
            [33.902819968055795, 2.288731721028842],
            [33.902643765309456, 2.289273261053539],
            [33.90297112846698, 2.289454974438438],
            [33.90340578101214, 2.289064870121982],
            [33.90351394266393, 2.289883441087954],
            [33.90257116975639, 2.290239216557018],
            [33.903786531047, 2.291979680826758],
            [33.90410514730862, 2.291944826251421],
            [33.904158306013855, 2.291171629102005],
            [33.90503066447785, 2.291537083038594],
            [33.905238597516664, 2.293520745707104],
            [33.90425346904348, 2.294998390269963],
            [33.90437855315858, 2.295336162311674],
            [33.905463460205304, 2.295036601775162],
            [33.9061742827166, 2.295581909310953],
            [33.90750495265541, 2.295797630843411],
            [33.906622714519905, 2.296556193816339],
            [33.906623138524736, 2.297227564172108],
            [33.90863843610111, 2.297416858516694],
            [33.90857427483026, 2.298092601539988],
            [33.907885480806385, 2.298339933213662],
            [33.91010303406898, 2.300920576145229],
            [33.910544065550994, 2.300988720356085],
            [33.9110038233134, 2.302912554516893],
            [33.91062299871835, 2.303441293132623],
            [33.90844056509178, 2.304327631900921],
            [33.90830411279677, 2.304938207623875],
            [33.908789179694004, 2.305826934839317],
            [33.908862047436564, 2.306230036134238],
            [33.85821322340925, 2.337745999208846],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 707,
        District: "AMURIA",
        County: "KAPELEBYONG",
        Subcounty: "KAPELEBYONG",
        Population: 19211,
        Key: "AMURIAKAPELEBYONG",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.615376883543114, 1.715229779320945],
            [33.61209503148471, 1.71573745914181],
            [33.61131212456179, 1.716904743299532],
            [33.612796731604284, 1.722449929068782],
            [33.61110702570769, 1.722170026448187],
            [33.60803987549376, 1.722912849789571],
            [33.60472811672292, 1.726632136789318],
            [33.60365318995902, 1.72920555924892],
            [33.60320806126101, 1.728016780454198],
            [33.59594859488864, 1.725223631106546],
            [33.594487143719235, 1.727169152690977],
            [33.5911543571842, 1.7248089860888],
            [33.589867753203386, 1.723443321882979],
            [33.59000710346349, 1.714306010915067],
            [33.589337044703186, 1.70566692684895],
            [33.589443386368224, 1.704662296350489],
            [33.59133066772839, 1.702454293841171],
            [33.594788543768416, 1.700616722880847],
            [33.59625950719839, 1.698580737572812],
            [33.60050572946038, 1.698660833880922],
            [33.609165143846205, 1.695555060783159],
            [33.60995366164643, 1.694369684003549],
            [33.610690168788295, 1.693962345003853],
            [33.61393605140442, 1.693536113620759],
            [33.6158870565559, 1.693969734009737],
            [33.6263989848055, 1.699738158623236],
            [33.62618626015296, 1.700452920786429],
            [33.62250194488096, 1.702136816679982],
            [33.61932048943703, 1.705503240117235],
            [33.61315441110602, 1.702257442204006],
            [33.612679107997636, 1.702429482549909],
            [33.6123251313515, 1.704247996168209],
            [33.61304004389225, 1.704844852893092],
            [33.61055415936272, 1.711685004031003],
            [33.615376883543114, 1.715229779320945],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 708,
        District: "SOROTI",
        County: "SOROTI  MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 11808,
        Key: "SOROTIWESTERN DIVISION",
        Dist2: "Soroti",
        "Sub Country": "West Div",
        id2_original: "SorotiWest Div",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.463657154323705, 1.645927728561593],
            [33.448774213446086, 1.6548786514794],
            [33.414153849370265, 1.668438719500961],
            [33.401494508315444, 1.672186848738873],
            [33.39685107978092, 1.672694435678828],
            [33.390279098587094, 1.672659576143081],
            [33.40284420097872, 1.655657589661792],
            [33.407480345074596, 1.647197636501233],
            [33.409444668648504, 1.641461397158871],
            [33.41274371715638, 1.623999993227564],
            [33.41572568552181, 1.623696334639137],
            [33.41648414120103, 1.622863345990301],
            [33.4245882628923, 1.617972100371689],
            [33.427095354849094, 1.61516698900361],
            [33.42866187297415, 1.612470639118124],
            [33.43167448916212, 1.611403972427788],
            [33.43652903975471, 1.611193323564273],
            [33.44215259584123, 1.609853142776472],
            [33.44293419032555, 1.609961535611824],
            [33.445584871692304, 1.608766747406502],
            [33.44667637057656, 1.607708005983517],
            [33.448182307217195, 1.605626861138376],
            [33.456489429298045, 1.589385637745956],
            [33.45802017830514, 1.587802071207651],
            [33.46014148606818, 1.58637217054256],
            [33.46742035605069, 1.583167891502674],
            [33.47170180215327, 1.580706134696318],
            [33.47475769647667, 1.577774210733432],
            [33.47553544886651, 1.575874165428524],
            [33.47807523231311, 1.555058100158731],
            [33.47830462251079, 1.552964542681467],
            [33.482999110387794, 1.558212049046689],
            [33.496731139604826, 1.557916112409678],
            [33.502439202905066, 1.55605965070528],
            [33.50493665593885, 1.555999207400292],
            [33.50671932938252, 1.556397743456283],
            [33.50928493849524, 1.561743858511762],
            [33.50876779186089, 1.565426088067063],
            [33.511143646242864, 1.57131505787741],
            [33.51265058270837, 1.57683543453812],
            [33.516238577022335, 1.576383627291298],
            [33.51988604609633, 1.575257454603141],
            [33.52465052620868, 1.572665103737888],
            [33.53384222743463, 1.568930001365181],
            [33.53497463290201, 1.56331158651704],
            [33.53700334232559, 1.560479386006579],
            [33.53766867774415, 1.557680788708452],
            [33.541197351808314, 1.555980019277208],
            [33.5452960769889, 1.554807628037288],
            [33.55342518801475, 1.549220480219535],
            [33.55499343000684, 1.547250881485723],
            [33.555143058790435, 1.545191756846795],
            [33.55641355238498, 1.541706831644007],
            [33.55809065940971, 1.541488602079033],
            [33.56409614951067, 1.542113143389273],
            [33.566449320533394, 1.541105250930041],
            [33.56908006828396, 1.542303233480581],
            [33.57114688693682, 1.544366938866855],
            [33.574023547598145, 1.550599429385473],
            [33.578615255630176, 1.551575226911446],
            [33.57970904791338, 1.551095443754331],
            [33.58373961791334, 1.550578657165421],
            [33.58854468750347, 1.551056798023057],
            [33.592018880542305, 1.552060017128093],
            [33.593398184372234, 1.551932971900999],
            [33.59488552319153, 1.552375844069031],
            [33.60070950419773, 1.555839106717371],
            [33.59557867673948, 1.55649303929862],
            [33.593492618868176, 1.557291463511705],
            [33.58815245969421, 1.55989642580361],
            [33.58377204529847, 1.56275305667727],
            [33.58251591037543, 1.564198580454596],
            [33.576689504816265, 1.573914411044178],
            [33.57596612565395, 1.573952927944287],
            [33.57459573580654, 1.574834555554738],
            [33.56817473715747, 1.580499647489484],
            [33.565307820522065, 1.582002044661567],
            [33.56004444125378, 1.585818210371859],
            [33.559407768380964, 1.586907997841654],
            [33.55895178444106, 1.590241541854853],
            [33.55899128605906, 1.595529024376364],
            [33.55560449730075, 1.602081845486984],
            [33.55325502733699, 1.608179518414091],
            [33.553164253475856, 1.615377499170088],
            [33.55178697175359, 1.615724766546166],
            [33.54780404390473, 1.618481258165226],
            [33.54496393659067, 1.618793497512876],
            [33.54347116296391, 1.6193545444163],
            [33.538627755972406, 1.619238518553037],
            [33.53479601548418, 1.620036033137614],
            [33.531840833083905, 1.620916487997947],
            [33.526097205481584, 1.623628826411596],
            [33.50985748333482, 1.625642196817829],
            [33.495625995311364, 1.62921026668249],
            [33.490101191024024, 1.629853962673529],
            [33.48677804251369, 1.631401804789846],
            [33.48414555113316, 1.633410871636411],
            [33.483913139002844, 1.634270389446677],
            [33.48287718654585, 1.634931069432377],
            [33.463657154323705, 1.645927728561593],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 709,
        District: "SERERE",
        County: "SERERE",
        Subcounty: "ATIIRA",
        Population: 20406,
        Key: "SEREREATIIRA",
        Dist2: "Serere",
        "Sub Country": "Atiira",
        id2_original: "SerereAtiira",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.487582315865666, 2.232523720237159],
            [33.487254579907315, 2.233299086814095],
            [33.48418826692325, 2.234635703868427],
            [33.483882021361424, 2.233989303561947],
            [33.48274464012568, 2.234117954046616],
            [33.482933184825704, 2.23357913929382],
            [33.48178030226143, 2.233097209148067],
            [33.481107085922886, 2.23327188404708],
            [33.4808575177673, 2.234375126620691],
            [33.480500400610914, 2.23413408809229],
            [33.48015888539442, 2.234816620717585],
            [33.478843074488736, 2.235232662332959],
            [33.47792490913179, 2.23503285576952],
            [33.47740957170443, 2.234473747682907],
            [33.476603868234534, 2.235048681019796],
            [33.47555800107173, 2.234269113549348],
            [33.47446663154483, 2.234736387671667],
            [33.47423232846085, 2.23574213649724],
            [33.47336020715213, 2.235978445142156],
            [33.47308471541404, 2.235788687664199],
            [33.47350794408374, 2.235419119291195],
            [33.472686750963405, 2.235414255922846],
            [33.472278572667975, 2.234998778071762],
            [33.47086086226636, 2.235774015878339],
            [33.47087630340778, 2.236210143515338],
            [33.47028465679198, 2.236271906822483],
            [33.46956610876924, 2.238257829997952],
            [33.46877031192031, 2.237924572283811],
            [33.46869911684079, 2.238596754372767],
            [33.468020739680924, 2.238596972496802],
            [33.46797456447868, 2.237745242828119],
            [33.4673878325458, 2.237227201475851],
            [33.46589374288716, 2.238428331201688],
            [33.46607236569488, 2.238751526373279],
            [33.46529206568291, 2.239033980766396],
            [33.464837929577534, 2.238449193016178],
            [33.46363118582545, 2.23960504622726],
            [33.46234627067737, 2.239634178779372],
            [33.46241308197829, 2.24022778884932],
            [33.46125190886226, 2.240285605113883],
            [33.461252022948294, 2.240649442697721],
            [33.46194692282117, 2.24093167590834],
            [33.46154262345114, 2.2416163946836],
            [33.460852508005466, 2.241415545048954],
            [33.46051954385214, 2.241942258696407],
            [33.46033374799687, 2.241319962026982],
            [33.45986765621339, 2.242244068015609],
            [33.459125210309175, 2.242105468940145],
            [33.45899655628913, 2.241588476661441],
            [33.45872068815696, 2.242076873218487],
            [33.4583969784477, 2.241761010604382],
            [33.45874898778335, 2.24126301470724],
            [33.458206476318665, 2.241306272301552],
            [33.45804931336473, 2.240932908351973],
            [33.457711540529715, 2.241301641438393],
            [33.45802579636892, 2.241823362521377],
            [33.457392818266904, 2.241718239537787],
            [33.45712660882065, 2.242665620748987],
            [33.45646623928901, 2.242474333682417],
            [33.45571694642568, 2.24327944235111],
            [33.45501196296376, 2.24309415330817],
            [33.45480360771674, 2.242612491987956],
            [33.45312629318118, 2.243361038424434],
            [33.453072581113695, 2.242801533173365],
            [33.45270968419682, 2.242723852518663],
            [33.45232618441888, 2.244082719418876],
            [33.451829696341115, 2.244125771373388],
            [33.45159194192983, 2.243589617274945],
            [33.451312704217, 2.244311454343541],
            [33.45030336704524, 2.24414255070222],
            [33.45002643081617, 2.244540793334758],
            [33.44934355040181, 2.244122940259979],
            [33.449224594593595, 2.243416250549982],
            [33.44865078133281, 2.243724998218502],
            [33.448532209105196, 2.244272500058283],
            [33.44815618600536, 2.244222846066909],
            [33.44813652727368, 2.244650870113449],
            [33.446840268200155, 2.244591546009613],
            [33.44674143645093, 2.244979779094544],
            [33.44581225146038, 2.245305145073388],
            [33.44575548422264, 2.245891776498976],
            [33.4449589651282, 2.245677527699993],
            [33.444883882140104, 2.246245327700758],
            [33.44390552247262, 2.24611945463573],
            [33.442800195821135, 2.24340464692878],
            [33.44119755194694, 2.241071020126327],
            [33.44138617749534, 2.240283876281033],
            [33.440655068329995, 2.238954194072981],
            [33.44119622423693, 2.23663800833012],
            [33.44080646230316, 2.23585104073293],
            [33.44083595668889, 2.232974102356435],
            [33.44120126827727, 2.232829240515308],
            [33.44253423520826, 2.229969997584698],
            [33.44238789515689, 2.229318658232063],
            [33.443276935335675, 2.228739383483088],
            [33.44355719712792, 2.228006497828718],
            [33.44513483100629, 2.22760795179581],
            [33.44775933726228, 2.224386436150146],
            [33.4492213112512, 2.224422175622289],
            [33.45168165308399, 2.222982957211037],
            [33.45180341612746, 2.22229535012874],
            [33.453441803068536, 2.222077715580901],
            [33.45336839633675, 2.220983058703617],
            [33.454282231814055, 2.220638993074647],
            [33.45493948958156, 2.219426500850989],
            [33.456577739978705, 2.218774610178888],
            [33.4577343146188, 2.216367762153067],
            [33.45875149138803, 2.215797490176002],
            [33.46004257706384, 2.213978652162054],
            [33.46289555004939, 2.211797444824467],
            [33.46423888892866, 2.211751791444255],
            [33.46555443303467, 2.210900964564638],
            [33.46916628660261, 2.210836490200458],
            [33.47225408818658, 2.208365692504811],
            [33.47481174271744, 2.207333524290378],
            [33.47794673639656, 2.199570256328642],
            [33.47867016586452, 2.196204571092566],
            [33.47865672706787, 2.19105687995222],
            [33.477729622575545, 2.188460714607506],
            [33.47688264151833, 2.186832536977331],
            [33.47629743582312, 2.186525129327936],
            [33.47541393555466, 2.184933153211686],
            [33.47211733495594, 2.180980691131416],
            [33.47142817082617, 2.1789272596347],
            [33.47094077100414, 2.178628862934904],
            [33.47120861538421, 2.177796459761757],
            [33.47074561021202, 2.176412426226505],
            [33.47066567991469, 2.174223094953144],
            [33.47020233068775, 2.173535676360614],
            [33.47034204296896, 2.172757593741465],
            [33.469769686775564, 2.172169725167607],
            [33.46958009643655, 2.169781392000741],
            [33.46910435405196, 2.168985413261355],
            [33.46944529704163, 2.168261552184906],
            [33.46905567165179, 2.167863608697868],
            [33.46912224849244, 2.166868423667339],
            [33.467939876034, 2.165665549527303],
            [33.46847592681517, 2.165185893692399],
            [33.46815241653189, 2.162281931878835],
            [33.46640824937287, 2.156383868195097],
            [33.46394056560931, 2.153616264331901],
            [33.459364968861884, 2.150062210946149],
            [33.4580735148768, 2.148642231291523],
            [33.45586730643792, 2.144300359768712],
            [33.45548240977973, 2.140862632302111],
            [33.454341866474174, 2.13652947864077],
            [33.45496695287642, 2.133028125043834],
            [33.45512686647172, 2.127892815183508],
            [33.4573078017084, 2.125689322222659],
            [33.45888114253805, 2.123293940378125],
            [33.46210615549347, 2.12010908321139],
            [33.462027867316465, 2.118693422559335],
            [33.46237252394154, 2.118066614251978],
            [33.46596511313819, 2.116565913283501],
            [33.47010207151553, 2.112759660248909],
            [33.471530770109695, 2.110364315865901],
            [33.47458145779771, 2.101057934226022],
            [33.47525413065551, 2.100005759599522],
            [33.478946149879384, 2.096445838345657],
            [33.48240522157705, 2.095068257886929],
            [33.48467960406116, 2.093679848868763],
            [33.48565772477678, 2.087358888662362],
            [33.49120461863698, 2.083776032450924],
            [33.497747556399354, 2.080587997516352],
            [33.49828798916249, 2.077854774918759],
            [33.498105909637545, 2.076611063141584],
            [33.4990277131714, 2.075232514621928],
            [33.500337968895366, 2.074234812922809],
            [33.50141994923088, 2.074761878044915],
            [33.50240147186651, 2.074090315727234],
            [33.504510428692726, 2.073887127829363],
            [33.50541598978794, 2.073121528207083],
            [33.510117494405605, 2.071506647014801],
            [33.51292144902104, 2.071649172137496],
            [33.51615671804209, 2.073093938353316],
            [33.51913619987079, 2.075266397498325],
            [33.52181043596259, 2.075265511442684],
            [33.52588431553902, 2.077284396497483],
            [33.52982427067962, 2.077216048206944],
            [33.53071930531631, 2.078565765480547],
            [33.53134743790569, 2.078623000784972],
            [33.5319570885564, 2.080327074284188],
            [33.532575758292595, 2.080547080195963],
            [33.53350914021214, 2.081915118030551],
            [33.53742767592309, 2.084192117220424],
            [33.53835070116574, 2.084599379080112],
            [33.5381581059621, 2.085618534226307],
            [33.53942105909814, 2.0879393528991],
            [33.539815577611336, 2.089678134656845],
            [33.5412548727326, 2.090454083203491],
            [33.5417455397273, 2.091246534995787],
            [33.54318576011331, 2.094699604976918],
            [33.54338752352276, 2.096964171147598],
            [33.54432051287854, 2.09820939472945],
            [33.54435310375703, 2.099463021702181],
            [33.545189664356954, 2.100821509352991],
            [33.54504549283869, 2.102366365044468],
            [33.54617990244746, 2.104848977271797],
            [33.548045592799795, 2.106465914050971],
            [33.54962151448927, 2.107063864833268],
            [33.55114897476409, 2.107022882671448],
            [33.55140653253583, 2.107872027062574],
            [33.552717188010064, 2.10855903702767],
            [33.55294277923243, 2.109941999895266],
            [33.55649776495128, 2.112517086976883],
            [33.55745481747858, 2.114770907789915],
            [33.5597335684699, 2.116524369410592],
            [33.56002467202932, 2.117854127383836],
            [33.55916401502022, 2.122985260429711],
            [33.55853604143263, 2.123409914044659],
            [33.55836768726694, 2.124513478587553],
            [33.55631012485473, 2.126553268382918],
            [33.555281893417614, 2.128803664690175],
            [33.55573485183162, 2.131298870515402],
            [33.55498545296711, 2.131508586148565],
            [33.55485500231647, 2.132651596710656],
            [33.55569444201689, 2.134715807314305],
            [33.55551025773924, 2.13530231687236],
            [33.55597427980431, 2.135469702219025],
            [33.55489392002953, 2.13743942444659],
            [33.55468492967363, 2.139529469493586],
            [33.55413281611687, 2.139622573310119],
            [33.55366365029849, 2.141633570381175],
            [33.552415649620336, 2.142635909414509],
            [33.55140667446963, 2.145246821508589],
            [33.54912798546204, 2.147004475623612],
            [33.54958407450484, 2.147632253309959],
            [33.5488196629953, 2.147738363180566],
            [33.548735944502404, 2.148973112081588],
            [33.54730574212843, 2.150405902257759],
            [33.547292045515285, 2.151330182978462],
            [33.54682933049896, 2.151788959514913],
            [33.547187278596965, 2.152543772418135],
            [33.54687199149182, 2.153418773651316],
            [33.548298985083555, 2.156765722900465],
            [33.54792742122082, 2.157310553760601],
            [33.54830012055409, 2.159181747481947],
            [33.54699857040357, 2.160710471729371],
            [33.547432957047384, 2.161697959639675],
            [33.54710271299277, 2.162945631821637],
            [33.547588670120426, 2.163652402811505],
            [33.54752710677737, 2.164879184509157],
            [33.54617420173868, 2.167302007714961],
            [33.54517210858134, 2.168196451206366],
            [33.5447591799947, 2.16942336118095],
            [33.54478100097129, 2.17263580243455],
            [33.54331404223085, 2.174029435513212],
            [33.54288033561166, 2.174954861629903],
            [33.543449318631154, 2.176628456123483],
            [33.54229285089058, 2.179331907562095],
            [33.538543553287575, 2.1850512182263],
            [33.53818254642602, 2.186995453472816],
            [33.53706738771378, 2.189657305785222],
            [33.53699636061921, 2.193337616672577],
            [33.53529858246147, 2.199234454922255],
            [33.535944144164, 2.200424054636229],
            [33.53556810399615, 2.20123543927702],
            [33.535838095349746, 2.201955558305173],
            [33.53528899653908, 2.202501089136605],
            [33.536393600945026, 2.203783403707123],
            [33.536353325877585, 2.204337154552652],
            [33.53532540346091, 2.204638823450036],
            [33.53455676807288, 2.205656997380168],
            [33.5328572175391, 2.206618506511176],
            [33.53226609014953, 2.20602426803361],
            [33.531213678759876, 2.205755921968985],
            [33.53084147888989, 2.206203929881246],
            [33.531011631482805, 2.206659887239296],
            [33.53017776223549, 2.206350745821137],
            [33.52936857959051, 2.207173495954537],
            [33.528024952352034, 2.207458988648023],
            [33.527741733305916, 2.207735958114337],
            [33.528138796746326, 2.208924719813016],
            [33.52711915050834, 2.209755688277303],
            [33.52647967848514, 2.209796632661503],
            [33.52617193363509, 2.209389583692379],
            [33.52602655837435, 2.210326101713535],
            [33.52541959099139, 2.21072533371863],
            [33.52448052812599, 2.210530231995263],
            [33.5239222009224, 2.211133025036322],
            [33.52328261032155, 2.210840098739826],
            [33.52342044153054, 2.2114670742447],
            [33.522376150012754, 2.211280151074714],
            [33.52235206797663, 2.211858325869982],
            [33.52191493248802, 2.211809621392828],
            [33.52199567755733, 2.211231427728022],
            [33.521477723337554, 2.21154919451024],
            [33.521008100276696, 2.211191060570039],
            [33.52102446129296, 2.211679645833462],
            [33.51933300547819, 2.212698141681007],
            [33.51984315423645, 2.213202839179047],
            [33.519228199033996, 2.213919657155235],
            [33.51957643993703, 2.21439183886245],
            [33.51919641035104, 2.215613451681364],
            [33.51811979834762, 2.215605687960804],
            [33.51751307261147, 2.21671337451707],
            [33.516606402995215, 2.216567116141346],
            [33.51614512258839, 2.21692557911494],
            [33.515894685761914, 2.218375155932186],
            [33.51547364987983, 2.218074005074163],
            [33.514300409694584, 2.219548334123562],
            [33.51435727125542, 2.220118338055365],
            [33.51388780989133, 2.220232507212791],
            [33.513256958999875, 2.221812506981659],
            [33.512803757142414, 2.222130250846687],
            [33.512301665373926, 2.221519686026849],
            [33.511662756594404, 2.223213694463464],
            [33.50976058206512, 2.223556371742748],
            [33.51015740385871, 2.224061111315328],
            [33.5095261478271, 2.224476634443568],
            [33.50972070405304, 2.225290886442567],
            [33.50908947497087, 2.225787842006476],
            [33.508692666651996, 2.225323817184057],
            [33.508790070978236, 2.226097386893421],
            [33.50796448509616, 2.226366398908807],
            [33.50796466116596, 2.226879420912575],
            [33.50717920931583, 2.226154947887407],
            [33.505641326787085, 2.226578926166696],
            [33.50535834579449, 2.227572495156398],
            [33.50494530312177, 2.226978183406315],
            [33.50437869165465, 2.227067955163705],
            [33.504508446110904, 2.227760082312513],
            [33.50398242501986, 2.228191854303906],
            [33.50423354636259, 2.228721076202031],
            [33.50395846695124, 2.229152759943353],
            [33.50173271656166, 2.230179570206171],
            [33.5015300404639, 2.229283886529653],
            [33.50071230675571, 2.228844433790032],
            [33.50088216739617, 2.228453501731769],
            [33.50054208768748, 2.228176748883981],
            [33.49985416233446, 2.228592287906927],
            [33.49973294726328, 2.229211213067566],
            [33.49919868053629, 2.229203251938711],
            [33.49929563570488, 2.228657624124663],
            [33.49895564942098, 2.228657739919667],
            [33.49920644377698, 2.228217920757647],
            [33.49845368970487, 2.228429901088105],
            [33.49789500946335, 2.228039216667377],
            [33.497490450480186, 2.228593093086287],
            [33.49715037975465, 2.22834076942818],
            [33.4969016362525, 2.228819392447373],
            [33.49616565731999, 2.228617741268306],
            [33.49558286899121, 2.229233255403554],
            [33.49542977540557, 2.228704519310485],
            [33.49498085581704, 2.229521889153132],
            [33.49388177964333, 2.229560718161236],
            [33.49372898519666, 2.229926114004665],
            [33.492476886404184, 2.229647721454255],
            [33.49209470265816, 2.229974736199829],
            [33.491702540425905, 2.2290326643888],
            [33.49068741271382, 2.229556562110042],
            [33.48953002330176, 2.229330778105022],
            [33.48912776580236, 2.229900865326719],
            [33.48851904221304, 2.229919166309617],
            [33.48856758627266, 2.230543382468422],
            [33.48927406902281, 2.230398396514217],
            [33.489274225329666, 2.230868838721525],
            [33.48827552241424, 2.231194859514544],
            [33.48751420470251, 2.23209980291419],
            [33.487582315865666, 2.232523720237159],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 710,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "MORUNGATUNY",
        Population: 17180,
        Key: "AMURIAMORUNGATUNY",
        Dist2: "Amuria",
        "Sub Country": "Morugatuny",
        id2_original: "AmuriaMorugatuny",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.750371448222786, 1.919909141075526],
            [33.75017893296919, 1.923843268038264],
            [33.74892621433918, 1.92809816331002],
            [33.74803026162426, 1.933157506571883],
            [33.74840495701412, 1.941842898748704],
            [33.74889549914299, 1.945006538019058],
            [33.74739411246929, 1.947257064946447],
            [33.74669694255371, 1.950913393025136],
            [33.74715258333716, 1.954147356435438],
            [33.74862160640613, 1.957697249876394],
            [33.754300358576984, 1.963261372809663],
            [33.75602685048444, 1.966137363179056],
            [33.75760205891159, 1.972460122527476],
            [33.75745038286743, 1.975056526950392],
            [33.75578559084691, 1.980648006490499],
            [33.753910208570986, 1.986028935187037],
            [33.752164314849985, 1.988455358897322],
            [33.74514298107969, 1.99200911943361],
            [33.74130106896749, 1.995350498398264],
            [33.7365866555592, 2.000977282132692],
            [33.73078738900312, 2.005975082552263],
            [33.729173923124655, 2.0062501944662],
            [33.72417575257938, 2.005524634398275],
            [33.71624684638594, 2.000842395250583],
            [33.71390588077297, 2.002686016527025],
            [33.71237863699215, 2.003139013322899],
            [33.70205993276692, 2.003713432852327],
            [33.69784834505069, 2.007324830943253],
            [33.6965357429272, 2.007732491178525],
            [33.69430112077589, 2.009904629286277],
            [33.69321060644515, 2.011904392505584],
            [33.69081436569615, 2.013316684783132],
            [33.6845338689474, 2.006868749690096],
            [33.68353314033099, 2.004489474185685],
            [33.68297076621704, 2.000760699295292],
            [33.68145968043321, 2.002478640512883],
            [33.679704521488375, 2.003632423831212],
            [33.67660949924613, 2.000317922031796],
            [33.682946481161636, 1.993579859512202],
            [33.68541018359187, 1.977612031631037],
            [33.68470371880803, 1.9733242330732],
            [33.68070934732078, 1.97117795051999],
            [33.675186158204326, 1.969341078645857],
            [33.6707032262717, 1.969964631302797],
            [33.66800086303004, 1.969597908793557],
            [33.67046393394464, 1.971290333285669],
            [33.67142760076737, 1.973431309799381],
            [33.67035012458467, 1.9823201236615],
            [33.670132543639696, 1.987299742447282],
            [33.67047107734776, 1.989039890697569],
            [33.669763177056126, 1.992857254694383],
            [33.66674221012927, 1.999362473184294],
            [33.6654093024871, 2.003158001080776],
            [33.664988024059895, 2.005663236743957],
            [33.658218211382604, 2.005487358296134],
            [33.656335055984535, 2.006317186559268],
            [33.65605753674886, 2.007249162001689],
            [33.65129955504928, 2.005594075623902],
            [33.64431977375075, 2.004490257935039],
            [33.64127349768911, 2.002914513368773],
            [33.63979830499078, 2.000464217790271],
            [33.63933675059777, 1.997126170967779],
            [33.63393877136055, 1.937221017457458],
            [33.63736606605335, 1.93696641519374],
            [33.639178653396, 1.937689462574957],
            [33.64038572054158, 1.937634723609365],
            [33.6408199418954, 1.937173177186535],
            [33.642666193603304, 1.937347934315831],
            [33.645602028088994, 1.936609309920904],
            [33.6519210787331, 1.928867325799495],
            [33.65460725972326, 1.923056517889171],
            [33.657158414044716, 1.921389490716784],
            [33.65745872353912, 1.919046287923503],
            [33.65589399485812, 1.913944572672319],
            [33.655817712619125, 1.911366301738724],
            [33.65797104981364, 1.905331346979293],
            [33.660331833160114, 1.901033272853861],
            [33.66197765186351, 1.894826630540569],
            [33.663133854601064, 1.892627847174326],
            [33.66653545747674, 1.890138704846106],
            [33.67460698289963, 1.885304660988524],
            [33.68205321351111, 1.882415865906776],
            [33.68651959218799, 1.881265179917234],
            [33.68852184532811, 1.880034045651936],
            [33.69894383155653, 1.87126292233081],
            [33.701831405850214, 1.874808827763575],
            [33.70236542015063, 1.876663161005257],
            [33.70645691568976, 1.883817342845417],
            [33.709181834729904, 1.889615078874721],
            [33.709159824208825, 1.890764002296427],
            [33.70785944995296, 1.893397089295117],
            [33.707828429329595, 1.897259987994912],
            [33.71102425512312, 1.902958003097466],
            [33.715488345790966, 1.908510729001712],
            [33.71628594106713, 1.908998907932034],
            [33.72002824438733, 1.908472633729384],
            [33.72249189022371, 1.908715849641502],
            [33.72455940866418, 1.910397629491597],
            [33.72760712382694, 1.913806874015962],
            [33.72871811705121, 1.913896863726656],
            [33.7313969498223, 1.912719667359726],
            [33.73374125537148, 1.913786147975002],
            [33.738027606275544, 1.913494807238363],
            [33.74870796774259, 1.919914549488965],
            [33.750371448222786, 1.919909141075526],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 711,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "ASAMUK",
        Population: 21385,
        Key: "AMURIAASAMUK",
        Dist2: "Amuria",
        "Sub Country": "Asamuk",
        id2_original: "AmuriaAsamuk",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.314631809509564, 1.498909210252845],
            [33.31330437709907, 1.498787135953308],
            [33.3099631113661, 1.499502341697361],
            [33.30478782089455, 1.499349271796652],
            [33.30056513628964, 1.496997594854769],
            [33.296887934776386, 1.493976343131058],
            [33.29408630589919, 1.492393466271478],
            [33.29029809327806, 1.491064037554993],
            [33.288777147585684, 1.491055192145542],
            [33.28747128552179, 1.4902230239471],
            [33.28618800800242, 1.490241286805958],
            [33.2840473828675, 1.490612500460137],
            [33.28316593524948, 1.491444955874876],
            [33.281941666264515, 1.491580821336131],
            [33.28089603446032, 1.4914542969848],
            [33.27788197467969, 1.48939192227223],
            [33.273913521385026, 1.48890387436137],
            [33.26660805767685, 1.487231045315714],
            [33.263141225433465, 1.485738676165863],
            [33.259379847286525, 1.483070198461601],
            [33.25629285688123, 1.481731573844707],
            [33.25079038650846, 1.479814199837183],
            [33.25078874618477, 1.480203230075012],
            [33.22215654819962, 1.468770605436257],
            [33.21797258637332, 1.467567738569011],
            [33.20361136185992, 1.464927307634408],
            [33.19973670076577, 1.463579620051257],
            [33.19765746470069, 1.462466993593291],
            [33.176045158689824, 1.447332742771679],
            [33.16505139568138, 1.442882321952078],
            [33.160942025464735, 1.438838489939879],
            [33.159028059649025, 1.438413403738174],
            [33.1578864006359, 1.438648712412274],
            [33.15362555829268, 1.441878881364899],
            [33.152315984390015, 1.443335580325663],
            [33.15122179684808, 1.44354374193684],
            [33.08904405914308, 1.414668092364531],
            [33.110646614839844, 1.395523092199719],
            [33.15124401308336, 1.356436579475382],
            [33.15252493611837, 1.355676527513403],
            [33.18552980142826, 1.348002126114918],
            [33.247746609559954, 1.334371422466434],
            [33.26543350056139, 1.34688185772771],
            [33.278814502301394, 1.357393199279982],
            [33.292564437637004, 1.366706335578263],
            [33.289176533171094, 1.388330264107407],
            [33.28960791225536, 1.398676134173596],
            [33.29297849001609, 1.409391990303302],
            [33.294125732957, 1.41148411464882],
            [33.29656342466817, 1.414297545153775],
            [33.30648097991509, 1.421438816812524],
            [33.31601642687443, 1.42977291750624],
            [33.31979250325608, 1.433908823924848],
            [33.32160924890016, 1.438756849845316],
            [33.32442972892357, 1.444345439387679],
            [33.32691612998439, 1.45302677183559],
            [33.32763357667258, 1.456985133268695],
            [33.32772985181654, 1.461761252735976],
            [33.32519760703182, 1.466739767893527],
            [33.325054791071295, 1.47061168066258],
            [33.32319178847831, 1.476737235870835],
            [33.321494454986635, 1.484463983664974],
            [33.320122334984, 1.486291440986596],
            [33.3180270217703, 1.491834398047289],
            [33.31675320351089, 1.493861373611858],
            [33.314631809509564, 1.498909210252845],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 712,
        District: "SERERE",
        County: "KASILO",
        Subcounty: "LABORI",
        Population: 19877,
        Key: "SERERELABORI",
        Dist2: "Serere",
        "Sub Country": "Labori",
        id2_original: "SerereLabori",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "N",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.327236267093795, 2.05150445302282],
            [33.3243804707033, 2.052638766241845],
            [33.322587149528566, 2.052573111005735],
            [33.32124468381177, 2.051833830921945],
            [33.31891162427162, 2.051909329001941],
            [33.31451210360808, 2.053442901271484],
            [33.31146441449647, 2.049124086861596],
            [33.309323800141314, 2.047370296193431],
            [33.305178323938435, 2.045749085849888],
            [33.29924433973413, 2.045203584952082],
            [33.29440461403864, 2.042795275219705],
            [33.290506465593054, 2.039359813848006],
            [33.28951648531901, 2.037413267958259],
            [33.28848996696913, 2.03658695680776],
            [33.28488860752038, 2.030918109951813],
            [33.28201240769481, 2.021864718192026],
            [33.28185495907664, 2.019423143158902],
            [33.284088846406064, 2.01469860461699],
            [33.283947518954, 2.010619288576072],
            [33.28251723932492, 2.006917476743967],
            [33.28260445406091, 2.003625096264543],
            [33.28086700989347, 2.001702691594783],
            [33.277945350822975, 1.996684538278422],
            [33.27707804717909, 1.995788644505966],
            [33.27449624773004, 1.990146843916186],
            [33.274807451992245, 1.986829887354796],
            [33.27446457492975, 1.985593706052495],
            [33.27462661124406, 1.979875881707769],
            [33.27480763075697, 1.973809420730125],
            [33.272383329333394, 1.971549468640813],
            [33.27077249102718, 1.966546729499184],
            [33.27208615226437, 1.961838918736351],
            [33.2712950913336, 1.959779449361857],
            [33.27144402212626, 1.957129754320843],
            [33.27274299501025, 1.957000127622418],
            [33.27422979214542, 1.956170546681033],
            [33.27580275747924, 1.955204097797975],
            [33.27661464405326, 1.954018785311085],
            [33.278607191795075, 1.953863127762065],
            [33.279275736894135, 1.953284950760648],
            [33.280169793265514, 1.953246377070306],
            [33.281679624102864, 1.950943108230044],
            [33.28358150488307, 1.949587029388846],
            [33.28448821043194, 1.946861283867165],
            [33.285105226369666, 1.946136756351713],
            [33.2890875837883, 1.944598595738413],
            [33.293452150105814, 1.942272719265843],
            [33.29643443198329, 1.944389225652478],
            [33.303301570833376, 1.945518888662084],
            [33.30717677271334, 1.94711047721103],
            [33.31140079131648, 1.947706807082122],
            [33.31812626045638, 1.951487238087175],
            [33.32115954238744, 1.952662782569766],
            [33.32284637547178, 1.954227607443575],
            [33.32544698654121, 1.952770516906503],
            [33.32638912613646, 1.951132805927049],
            [33.32730687377679, 1.951223097114176],
            [33.32926447974901, 1.949349960240786],
            [33.33249201427545, 1.949530263587182],
            [33.33327615728021, 1.949999498940292],
            [33.33732109942639, 1.951944872497727],
            [33.33835965340445, 1.951935615343446],
            [33.33933892576029, 1.953364857955165],
            [33.339851516139525, 1.956431720572413],
            [33.34140587107561, 1.958666036066666],
            [33.343470323566024, 1.959932204705213],
            [33.34563740947599, 1.960166979404163],
            [33.34796678412685, 1.959786515865668],
            [33.35204587752514, 1.957876721870228],
            [33.35439001329278, 1.958238107790927],
            [33.35855421757268, 1.960209478969266],
            [33.36026775038388, 1.960326721310406],
            [33.362011524080806, 1.959937317617877],
            [33.365580217192566, 1.957611439014511],
            [33.36870132740898, 1.954227145978083],
            [33.370156136435206, 1.953421634400916],
            [33.37460521625465, 1.95263354681709],
            [33.38446262300508, 1.948397282319019],
            [33.386339595299056, 1.948143532850497],
            [33.389567732595054, 1.948567995512352],
            [33.39198110511487, 1.949481182911791],
            [33.39520385880736, 1.950909857510079],
            [33.398153074597516, 1.952953787991501],
            [33.40434526066564, 1.953920331540441],
            [33.41042069179794, 1.955447794519858],
            [33.40795532838275, 1.962686022595039],
            [33.407691123077925, 1.969326606356401],
            [33.408474538447294, 1.976238341114103],
            [33.40713738087555, 1.980110799933743],
            [33.404413965615184, 1.982463698956143],
            [33.39773550890738, 1.986038908576985],
            [33.388383704541575, 1.987696758247592],
            [33.38662706427482, 1.988402843585679],
            [33.384541856209765, 1.989986568008553],
            [33.381584226798665, 1.993171824082241],
            [33.377316251832056, 2.004825422525846],
            [33.374350723534675, 2.008046864694597],
            [33.373601854676146, 2.011765378616833],
            [33.371366479736636, 2.015502327634036],
            [33.36979592907424, 2.019166749018837],
            [33.364027713684266, 2.027862290118311],
            [33.36186558916964, 2.027591372569153],
            [33.358629060710584, 2.028053492579947],
            [33.348730247015446, 2.030718602733327],
            [33.34719853321777, 2.031955302004846],
            [33.34493829830105, 2.035529387047066],
            [33.34319182696334, 2.036823491803502],
            [33.3409231092554, 2.037529651028173],
            [33.339646985020686, 2.038579382146583],
            [33.33903093207691, 2.040850341349674],
            [33.33633448334307, 2.044135004645469],
            [33.331248590513674, 2.046045009658321],
            [33.32837249848595, 2.050442492364872],
            [33.327236267093795, 2.05150445302282],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 713,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "ANYARA",
        Population: 21971,
        Key: "KABERAMAIDOANYARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19122716130192, 1.676642939908886],
            [33.190211273615084, 1.688703003466337],
            [33.189520123310224, 1.691643422319247],
            [33.18536543668074, 1.698718765018379],
            [33.18063892925375, 1.708390712928802],
            [33.17683919124756, 1.720242951814827],
            [33.175291371555126, 1.723301062575737],
            [33.17208939050528, 1.728051157712148],
            [33.169566791830086, 1.729942259715357],
            [33.1654263704473, 1.731516847412561],
            [33.149639683969674, 1.732848115173445],
            [33.14684383575134, 1.733174036511276],
            [33.14536854423836, 1.733843648538893],
            [33.144178468726345, 1.735019882661547],
            [33.143868425087526, 1.736883640166663],
            [33.145389306999505, 1.740800982038375],
            [33.145503503533355, 1.743674423692025],
            [33.1433464545001, 1.745896272463558],
            [33.141812994377496, 1.746854201267871],
            [33.13522338374623, 1.747551185331893],
            [33.12703409188452, 1.747273989097168],
            [33.1236295928404, 1.747737172213701],
            [33.11888138570943, 1.750029449860312],
            [33.11104918315633, 1.751035788404002],
            [33.110169505219396, 1.751560581492001],
            [33.10952422558789, 1.75331578869454],
            [33.10957724235932, 1.756655686470845],
            [33.1102913733658, 1.758248127953049],
            [33.11252825837333, 1.760359323965043],
            [33.114131640662706, 1.761016527324905],
            [33.1163486243934, 1.761295244346273],
            [33.11706125521336, 1.761832990216421],
            [33.11838757640785, 1.763406444987642],
            [33.11888253734961, 1.76499987107351],
            [33.11874405755699, 1.766274645078888],
            [33.11765553748621, 1.769003510210852],
            [33.115597101911554, 1.771991372763956],
            [33.11244113706213, 1.775128558519282],
            [33.10885101284261, 1.777182502465646],
            [33.10409957357326, 1.778313685884386],
            [33.10397813482157, 1.777255163661023],
            [33.10062953703926, 1.772396970140126],
            [33.09833274069048, 1.769673868148985],
            [33.094861756433836, 1.766507507950335],
            [33.0935366075408, 1.764598602600616],
            [33.09197706393561, 1.761287381515849],
            [33.091342503900364, 1.758546091707573],
            [33.08974729268682, 1.755361532033422],
            [33.08851739934986, 1.753325955556348],
            [33.08456202642404, 1.749073923651963],
            [33.08399120185823, 1.747478842628954],
            [33.08449157964116, 1.744441726995255],
            [33.08651626191731, 1.739158023283516],
            [33.0865177899516, 1.735756255825883],
            [33.08381923017685, 1.731875091761532],
            [33.0795146883883, 1.727903535552224],
            [33.072938536316606, 1.722991126815738],
            [33.06734810830115, 1.719574612722466],
            [33.06824624482051, 1.706754329484578],
            [33.067630557491086, 1.703891547862115],
            [33.06543049442705, 1.702196653994906],
            [33.065739829295154, 1.700985949186165],
            [33.06760441741462, 1.700000719398878],
            [33.072284038173656, 1.696312242310816],
            [33.073709033912216, 1.694689476386818],
            [33.07460756389368, 1.694169539758549],
            [33.07698493642848, 1.693949215578037],
            [33.07976891071538, 1.692727723341967],
            [33.0817684177057, 1.690836757061769],
            [33.083852357349585, 1.685969232548648],
            [33.0866758620006, 1.676849454977183],
            [33.09480793207698, 1.660645411626978],
            [33.09594048037648, 1.655280320925474],
            [33.095728194101795, 1.651733802370252],
            [33.09270367254136, 1.632191830149327],
            [33.0926361605545, 1.624130710249871],
            [33.09370989525405, 1.616929025914613],
            [33.10542823847234, 1.561631490480258],
            [33.13274445756685, 1.576630303787385],
            [33.1517604491503, 1.586318610164526],
            [33.15838475900609, 1.589321799284807],
            [33.171300990384374, 1.594332937373791],
            [33.20498476016519, 1.605693160408265],
            [33.19711810452601, 1.641367190878856],
            [33.19122716130192, 1.676642939908886],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 714,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "KOBULUBULU",
        Population: 19658,
        Key: "KABERAMAIDOKOBULUBULU",
        Dist2: "Kaberamaido",
        "Sub Country": "Kobulubulu",
        id2_original: "KaberamaidoKobulubulu",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.66267183308414, 1.732007080190748],
            [33.660697285783996, 1.731724463713193],
            [33.65986065781043, 1.731097340713802],
            [33.657336565236896, 1.732092910017671],
            [33.655435642959134, 1.732124179553159],
            [33.65198297085956, 1.730442062778775],
            [33.65008295677853, 1.733136028221072],
            [33.64219346237158, 1.728754575929973],
            [33.6427887327912, 1.727264679235692],
            [33.642384976901944, 1.72576654396675],
            [33.642725845331434, 1.724744168782962],
            [33.642669283807884, 1.721577362972685],
            [33.640974693771085, 1.717799060746413],
            [33.639396806567795, 1.716197917619091],
            [33.6390748180306, 1.715128562099652],
            [33.632837629061726, 1.715142620720826],
            [33.633072854715486, 1.714518317994068],
            [33.63014296977194, 1.698425154871191],
            [33.6263989848055, 1.699738158623236],
            [33.6158870565559, 1.693969734009737],
            [33.61393605140442, 1.693536113620759],
            [33.610690168788295, 1.693962345003853],
            [33.60995366164643, 1.694369684003549],
            [33.609165143846205, 1.695555060783159],
            [33.60050572946038, 1.698660833880922],
            [33.59625950719839, 1.698580737572812],
            [33.594788543768416, 1.700616722880847],
            [33.59133066772839, 1.702454293841171],
            [33.589443386368224, 1.704662296350489],
            [33.589337044703186, 1.70566692684895],
            [33.589325787016065, 1.70465260243068],
            [33.585349058440976, 1.69893068412082],
            [33.582305528529126, 1.69634673956095],
            [33.574541771312475, 1.691747930766923],
            [33.568131852484136, 1.683281688494542],
            [33.568402506794385, 1.682675812624873],
            [33.5700672817469, 1.682340590064872],
            [33.5755329849734, 1.679281145593787],
            [33.57950121189262, 1.678022456380216],
            [33.58177918494293, 1.67832936615549],
            [33.58724916325185, 1.680308969279605],
            [33.588241457586044, 1.680326762640676],
            [33.58943646844221, 1.679928339830856],
            [33.592291971083625, 1.679945563010419],
            [33.59432263524125, 1.678588030115206],
            [33.594716122488514, 1.679118319545148],
            [33.59557257358547, 1.67915748723184],
            [33.59682343988936, 1.678021215440879],
            [33.59783236114113, 1.677693876807252],
            [33.60095981256512, 1.678356240299724],
            [33.60469895201892, 1.677723205901379],
            [33.60660116787071, 1.678988156570775],
            [33.608953470222545, 1.679831840277382],
            [33.61117741230346, 1.679867327337964],
            [33.614009646782364, 1.679178878607034],
            [33.61966696604886, 1.680108895422142],
            [33.62544453559592, 1.679838476872286],
            [33.62841023816647, 1.680390149243425],
            [33.632859060169444, 1.682046595821316],
            [33.63653839967306, 1.68171381102872],
            [33.6374540820866, 1.681204194415642],
            [33.63494686256904, 1.676603445325083],
            [33.63442257792146, 1.673539785067841],
            [33.63488730246905, 1.670606469436349],
            [33.63603287364526, 1.669188813384912],
            [33.63970801532158, 1.668187120049696],
            [33.64199838063121, 1.665576428364272],
            [33.64347560621701, 1.664866476234423],
            [33.64658050723243, 1.664811171453016],
            [33.6484115037502, 1.66434918417465],
            [33.65104982070536, 1.661896652804026],
            [33.65638552962538, 1.660715982368446],
            [33.65992265863303, 1.660972947053824],
            [33.66293075270184, 1.662745121775045],
            [33.664805189950116, 1.662416741683215],
            [33.66697283191721, 1.662708655653668],
            [33.666129476460476, 1.663652947584902],
            [33.66612981332872, 1.664654831792884],
            [33.67011392785205, 1.669689250852269],
            [33.671545508241664, 1.670640445442078],
            [33.67370479048674, 1.670940193559369],
            [33.67416537559751, 1.674407260027932],
            [33.67532018055652, 1.677460529874638],
            [33.676766525656134, 1.679465583891574],
            [33.67795819747436, 1.680903584062009],
            [33.67957732453573, 1.681952428292206],
            [33.68019744594938, 1.683028761119108],
            [33.681864251992764, 1.683842372389365],
            [33.683020576901235, 1.68540703266781],
            [33.685331107592376, 1.687287914240282],
            [33.68559380911743, 1.688156298078206],
            [33.687213496727516, 1.689177990540916],
            [33.68954839422073, 1.691619745864929],
            [33.6914335295057, 1.694893946767571],
            [33.69276004024474, 1.695914725188486],
            [33.69485764146745, 1.700316954190643],
            [33.68980034291185, 1.702900536963938],
            [33.687513914019775, 1.704539058934199],
            [33.68484261362231, 1.70738066133575],
            [33.684751925999436, 1.709913751137263],
            [33.684229577221295, 1.710483876969041],
            [33.68456341274044, 1.710700876076845],
            [33.683851208620275, 1.711442955912228],
            [33.68508860378817, 1.711804376365399],
            [33.685423937697195, 1.713070783627979],
            [33.68452770650454, 1.715278007113903],
            [33.68495209310264, 1.719936786782],
            [33.6845610420864, 1.722968110710786],
            [33.684110689685035, 1.723755330840746],
            [33.68425713573759, 1.725832664999859],
            [33.68366428717594, 1.727964841036899],
            [33.680099446040096, 1.728687197031598],
            [33.67657723625271, 1.727874267381447],
            [33.67310485242087, 1.728137863177069],
            [33.66717793166961, 1.727506052815631],
            [33.66430402793795, 1.728981287408549],
            [33.66267183308414, 1.732007080190748],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 715,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "SOROTI",
        Population: 25116,
        Key: "SOROTISOROTI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.16718044871883, 1.78201126792239],
            [33.16192902872189, 1.781872451050755],
            [33.15630241746508, 1.778100646157066],
            [33.15449623421214, 1.778328223502086],
            [33.15208883459063, 1.777821779021256],
            [33.150487159998626, 1.777905561368262],
            [33.14382520264761, 1.770949992058991],
            [33.14298992035037, 1.767427223749278],
            [33.142297608523826, 1.767797543217076],
            [33.141641893163644, 1.765117919241963],
            [33.14029626807199, 1.764295126772956],
            [33.14374052116073, 1.761414645871145],
            [33.144025685957764, 1.757508014003649],
            [33.151961225311275, 1.75314117061216],
            [33.15590052108845, 1.751991841574887],
            [33.162409242021646, 1.75394458784768],
            [33.165812859818516, 1.757953543818321],
            [33.166899306577626, 1.76186801064382],
            [33.167176041584035, 1.765215513491951],
            [33.17018476088033, 1.772543789679111],
            [33.170112938776725, 1.77442143149094],
            [33.16899581814389, 1.777429258706235],
            [33.16779476521914, 1.779144046660884],
            [33.16874470308937, 1.780689988212866],
            [33.16718044871883, 1.78201126792239],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 716,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "KABERAMAIDO TOWN COUNCIL",
        Population: 4032,
        Key: "KABERAMAIDOKABERAMAIDO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.6263989848055, 1.699738158623236],
            [33.63014296977194, 1.698425154871191],
            [33.633072854715486, 1.714518317994068],
            [33.632837629061726, 1.715142620720826],
            [33.621930240864494, 1.715263831765062],
            [33.62190744791077, 1.716023765718976],
            [33.61688867540276, 1.716170151475934],
            [33.61683950072579, 1.715265492005776],
            [33.615376883543114, 1.715229779320945],
            [33.61055415936272, 1.711685004031003],
            [33.61304004389225, 1.704844852893092],
            [33.6123251313515, 1.704247996168209],
            [33.612679107997636, 1.702429482549909],
            [33.61315441110602, 1.702257442204006],
            [33.61932048943703, 1.705503240117235],
            [33.62250194488096, 1.702136816679982],
            [33.62618626015296, 1.700452920786429],
            [33.6263989848055, 1.699738158623236],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 717,
        District: "SOROTI",
        County: "SOROTI  MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 19117,
        Key: "SOROTINORTHERN DIVISION",
        Dist2: "Soroti",
        "Sub Country": "North Div",
        id2_original: "SorotiNorth Div",
        drought: "N",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.558217413492955, 1.775948191914686],
            [33.554257442091185, 1.77709289192578],
            [33.55235123053301, 1.778341933271861],
            [33.546900530070076, 1.783717405029585],
            [33.540590082591436, 1.787256610245525],
            [33.53615225866249, 1.791917062155031],
            [33.532978371524834, 1.793356450182681],
            [33.52588129091146, 1.795394069263242],
            [33.51864812182072, 1.795160931700854],
            [33.50890170192365, 1.793806653774191],
            [33.50407518775107, 1.792323246842518],
            [33.50230428044099, 1.790262095482166],
            [33.49980180762139, 1.789457607567284],
            [33.4941472910986, 1.78579514217731],
            [33.4936913475829, 1.784962947338573],
            [33.48959572248838, 1.781643821826686],
            [33.48318920558002, 1.775104579624109],
            [33.47579955266173, 1.769271218837868],
            [33.47470606041585, 1.769298642103156],
            [33.470309694635574, 1.765273868194043],
            [33.45984167154548, 1.765294600449939],
            [33.455105645569795, 1.764680578992405],
            [33.45358457860485, 1.764907128107202],
            [33.45222687925747, 1.764509393706669],
            [33.45087210931624, 1.764609242588574],
            [33.44896412987358, 1.763551208172236],
            [33.44335107599102, 1.76348923492016],
            [33.435937973450606, 1.764956616164061],
            [33.43014797481327, 1.765220337849443],
            [33.42105277780164, 1.763195900578685],
            [33.42075501053945, 1.76343119083194],
            [33.41682264526469, 1.758284318401482],
            [33.41714967963884, 1.758266150448097],
            [33.41713260356358, 1.744596081207323],
            [33.41682573007939, 1.741746332058059],
            [33.41469044722544, 1.728890960725829],
            [33.41338152190644, 1.717428642553647],
            [33.412162628440136, 1.711674986897407],
            [33.40998141652235, 1.704302112782629],
            [33.40626010323705, 1.694513994512943],
            [33.40318409832937, 1.688407877001692],
            [33.39583016063019, 1.67853904984008],
            [33.390279098587094, 1.672659576143081],
            [33.39685107978092, 1.672694435678828],
            [33.401494508315444, 1.672186848738873],
            [33.414153849370265, 1.668438719500961],
            [33.448774213446086, 1.6548786514794],
            [33.463657154323705, 1.645927728561593],
            [33.46526028777972, 1.64865049512259],
            [33.46725606227004, 1.650848442105873],
            [33.47354333590929, 1.654547156023494],
            [33.479560065731064, 1.657024568538343],
            [33.48516851844272, 1.658036451965982],
            [33.48798397868035, 1.65967325343251],
            [33.49207876744331, 1.660920710416997],
            [33.495629493351096, 1.661535008473395],
            [33.498552976001626, 1.661452844488538],
            [33.502128529547214, 1.662483283317379],
            [33.50613065888527, 1.66611007240549],
            [33.5092371768682, 1.66765628980116],
            [33.51613887031403, 1.669870972905105],
            [33.522601280399364, 1.672483808539371],
            [33.52777149449125, 1.675539471676222],
            [33.53002589664681, 1.675988276492648],
            [33.53434285764418, 1.675259465281994],
            [33.53619312482138, 1.675472963707318],
            [33.53806493449744, 1.676692294668591],
            [33.54166040099796, 1.681699084105655],
            [33.544148945439055, 1.682875430071873],
            [33.54682850494723, 1.682660666376723],
            [33.551697928946, 1.680262399089109],
            [33.553441671201895, 1.679791085065324],
            [33.560630216480845, 1.681137266408822],
            [33.56505414257403, 1.682676833568902],
            [33.568131852484136, 1.683281688494542],
            [33.574541771312475, 1.691747930766923],
            [33.582305528529126, 1.69634673956095],
            [33.585349058440976, 1.69893068412082],
            [33.589325787016065, 1.70465260243068],
            [33.589337044703186, 1.70566692684895],
            [33.59000710346349, 1.714306010915067],
            [33.589867753203386, 1.723443321882979],
            [33.5911543571842, 1.7248089860888],
            [33.594487143719235, 1.727169152690977],
            [33.59594859488864, 1.725223631106546],
            [33.60320806126101, 1.728016780454198],
            [33.60365318995902, 1.72920555924892],
            [33.603117282908286, 1.730573128260857],
            [33.60247457605173, 1.737232937698076],
            [33.603651476871754, 1.741570624644779],
            [33.59972019586355, 1.747052321510526],
            [33.597986641401306, 1.747775128131563],
            [33.596177892559886, 1.747401674621864],
            [33.59433225709626, 1.747699431790484],
            [33.59213818579519, 1.746776789904799],
            [33.58845655379095, 1.744464295685425],
            [33.58669528630218, 1.744740791075543],
            [33.586357962624774, 1.745324618263573],
            [33.585893814795575, 1.74507004964464],
            [33.584649439717914, 1.745632935046413],
            [33.58402709227899, 1.745399641276454],
            [33.583425993589756, 1.745665157027747],
            [33.58298291664385, 1.7453362891487],
            [33.58187550140936, 1.745410926962662],
            [33.580767817578625, 1.744615287264363],
            [33.57971338947115, 1.744595395212569],
            [33.57490131841171, 1.749022289201015],
            [33.55191731999626, 1.772298764807801],
            [33.552836342346005, 1.773275549106782],
            [33.558217413492955, 1.775948191914686],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 718,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "KAMUDA",
        Population: 37023,
        Key: "SOROTIKAMUDA",
        Dist2: "Soroti",
        "Sub Country": "Kamuda",
        id2_original: "SorotiKamuda",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.30280629368464, 1.810924679162175],
            [33.2720402151157, 1.80750431678342],
            [33.25770893863723, 1.797578956140253],
            [33.24546475668591, 1.796851379702416],
            [33.24067002850133, 1.797054254224057],
            [33.236019098135856, 1.799163851614793],
            [33.234784710527556, 1.800666304033254],
            [33.2335841346082, 1.804285828633658],
            [33.23324203638506, 1.807157530376895],
            [33.23349933723862, 1.810689635622292],
            [33.23272891869479, 1.811694815115975],
            [33.22990365424413, 1.812298226921021],
            [33.2295041842171, 1.81287260963064],
            [33.22933408731973, 1.821860920153581],
            [33.227964365818906, 1.823038474593688],
            [33.22468257574427, 1.82458958557703],
            [33.22422619385068, 1.826542371280057],
            [33.222570904209256, 1.826341562443024],
            [33.219234945722974, 1.826820851159983],
            [33.220319031709515, 1.825316232367072],
            [33.22125699683366, 1.822888431306643],
            [33.22199307188589, 1.813649648442076],
            [33.222165030990844, 1.805102652129664],
            [33.22614760490348, 1.778173981626191],
            [33.230459653912845, 1.755275625150873],
            [33.22928625742074, 1.752788419139783],
            [33.227400708012404, 1.750933676996534],
            [33.222540456711, 1.748362596247346],
            [33.21562742023809, 1.746719225673185],
            [33.214789456469695, 1.746339896108699],
            [33.21407709514434, 1.745201697745592],
            [33.21356668767126, 1.741506878209917],
            [33.21348903280653, 1.731711032850064],
            [33.20737166292687, 1.726231104358044],
            [33.20121219799296, 1.718516751458569],
            [33.20012270953826, 1.716535413202976],
            [33.199410247601605, 1.714216766420393],
            [33.196030003968445, 1.691081336320184],
            [33.192698895486394, 1.682751416358114],
            [33.19203244705522, 1.678729979341888],
            [33.19122716130192, 1.676642939908886],
            [33.19711810452601, 1.641367190878856],
            [33.20498476016519, 1.605693160408265],
            [33.24099081868593, 1.68655313963142],
            [33.243288974185724, 1.690551714611009],
            [33.24635640018243, 1.694568282005442],
            [33.24984068759011, 1.697861011907999],
            [33.25629654716041, 1.702311378392674],
            [33.258433809901234, 1.704554794045408],
            [33.259928810451605, 1.706816388999878],
            [33.261864652041105, 1.711249246100791],
            [33.2618970776296, 1.71415338810982],
            [33.263632690132155, 1.72122804729543],
            [33.265055796713696, 1.723562021846932],
            [33.268825368394324, 1.725018085569246],
            [33.26989861261373, 1.72483698915402],
            [33.272484195766786, 1.726112269874448],
            [33.27725278656986, 1.726971056402599],
            [33.28348437544126, 1.729946648679151],
            [33.28592629552251, 1.73238901476459],
            [33.29173160145224, 1.740250107311187],
            [33.294578467690535, 1.744854665293646],
            [33.294937853991286, 1.746881172321998],
            [33.2945766324324, 1.751097204476094],
            [33.290593174577516, 1.765926127839577],
            [33.29070013158853, 1.770757294893519],
            [33.2940805998005, 1.779182129437447],
            [33.29617545397508, 1.785774798035101],
            [33.29938052702613, 1.790424744959843],
            [33.30283185973762, 1.79358649210151],
            [33.30585143786903, 1.794268054652082],
            [33.31166464987163, 1.793525517397511],
            [33.309433618286484, 1.799424635052394],
            [33.307864538166235, 1.801949055156841],
            [33.30779958368298, 1.803324232156316],
            [33.302861934435015, 1.810829128193597],
            [33.30280629368464, 1.810924679162175],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 719,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "APERKIRA",
        Population: 14298,
        Key: "KABERAMAIDOAPERKIRA",
        Dist2: "Kaberamaido",
        "Sub Country": "Aperikira",
        id2_original: "KaberamaidoAperikira",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.84521828164575, 1.883881450584077],
            [33.844540435390236, 1.884139310859953],
            [33.84389452154815, 1.885313318753679],
            [33.84278464313315, 1.886105748742069],
            [33.841220663647086, 1.885577343310554],
            [33.82591274148666, 1.893406271349645],
            [33.82512236417381, 1.893671781473898],
            [33.821094300473526, 1.893124508757128],
            [33.81877932312172, 1.893277115652257],
            [33.81292555667566, 1.89271175253131],
            [33.81298056501209, 1.889586967019935],
            [33.81181136994054, 1.884720467792365],
            [33.812382777512994, 1.881805191120034],
            [33.808584745407494, 1.882216635511085],
            [33.80456169071322, 1.881235190562728],
            [33.80396086960343, 1.880500968367116],
            [33.80286909313974, 1.880217404429307],
            [33.7983157027461, 1.880210263076493],
            [33.79399207714767, 1.879409961807729],
            [33.79070276727576, 1.881048864560142],
            [33.78721271627723, 1.883655819668988],
            [33.78133713065121, 1.888434993797695],
            [33.77810932124032, 1.891973606295301],
            [33.77670008913836, 1.895936578683826],
            [33.77536628677417, 1.903970413211202],
            [33.773992240783556, 1.907462959219192],
            [33.772354243711355, 1.908802573361413],
            [33.76857761935741, 1.910360266878947],
            [33.76257903640267, 1.911792299867576],
            [33.7515563000314, 1.919470080016141],
            [33.750371448222786, 1.919909141075526],
            [33.74870796774259, 1.919914549488965],
            [33.738027606275544, 1.913494807238363],
            [33.73374125537148, 1.913786147975002],
            [33.7313969498223, 1.912719667359726],
            [33.72871811705121, 1.913896863726656],
            [33.72760712382694, 1.913806874015962],
            [33.72455940866418, 1.910397629491597],
            [33.72249189022371, 1.908715849641502],
            [33.72002824438733, 1.908472633729384],
            [33.71628594106713, 1.908998907932034],
            [33.715488345790966, 1.908510729001712],
            [33.71102425512312, 1.902958003097466],
            [33.707828429329595, 1.897259987994912],
            [33.70785944995296, 1.893397089295117],
            [33.709159824208825, 1.890764002296427],
            [33.709181834729904, 1.889615078874721],
            [33.70645691568976, 1.883817342845417],
            [33.70236542015063, 1.876663161005257],
            [33.701831405850214, 1.874808827763575],
            [33.69894383155653, 1.87126292233081],
            [33.701511711610245, 1.869272446112553],
            [33.71257971139376, 1.857326488826474],
            [33.716722798976285, 1.850404183949557],
            [33.720121029576404, 1.845553845233579],
            [33.72211972898126, 1.841255918935588],
            [33.72720971094185, 1.837418101673497],
            [33.72816015815686, 1.835255589024155],
            [33.72953446376058, 1.833527137494153],
            [33.7303522998767, 1.83137372620141],
            [33.73397024581889, 1.828079302060936],
            [33.734041281896594, 1.827274131482498],
            [33.73445134845076, 1.826957334657738],
            [33.738976050247466, 1.824666696470933],
            [33.742234697025445, 1.823606903765597],
            [33.74505825288039, 1.822140194467439],
            [33.747979442132, 1.821713789430359],
            [33.74969214759484, 1.820374190704165],
            [33.75007876991669, 1.820446401248378],
            [33.75162964298276, 1.819106869817964],
            [33.75343034561418, 1.814537636978302],
            [33.75580496391434, 1.813197759977102],
            [33.75902465255508, 1.813133076847709],
            [33.76111288255272, 1.8109067622336],
            [33.76263323086546, 1.810517119498694],
            [33.76363015062505, 1.809422074502882],
            [33.766266054705376, 1.808127310688663],
            [33.76764372449982, 1.807855331184823],
            [33.768189653155865, 1.807285171356623],
            [33.76944877138396, 1.807040380084286],
            [33.77159651836248, 1.804759756631905],
            [33.775395571852414, 1.80221607839883],
            [33.77706057767199, 1.803771350900164],
            [33.7779877693009, 1.803906648256016],
            [33.77959581564324, 1.797048759238419],
            [33.78643658265153, 1.784444142674722],
            [33.788522503978946, 1.779585318013753],
            [33.789347702687145, 1.773786211300667],
            [33.788941869892895, 1.76147421464074],
            [33.789659586075686, 1.755249975917197],
            [33.79264779234242, 1.750182712669265],
            [33.79307240890925, 1.747115800184009],
            [33.79584621606376, 1.73997700622587],
            [33.79836137309517, 1.736429747675276],
            [33.80038469442365, 1.735108112447656],
            [33.80675309761116, 1.735367731321449],
            [33.809002785408126, 1.733910297258071],
            [33.809188892978796, 1.732887976744253],
            [33.80841434038798, 1.730880014395448],
            [33.80485281223894, 1.725996493657097],
            [33.804478454615634, 1.724304979331656],
            [33.80543561224582, 1.7223234136317],
            [33.8105973390549, 1.71524694651538],
            [33.81229564003211, 1.722673288505712],
            [33.81401283437643, 1.725594525471694],
            [33.81540693795067, 1.727149897071775],
            [33.81972897532769, 1.730060948498569],
            [33.822723418597484, 1.733198723492476],
            [33.82375530527952, 1.733867700693231],
            [33.8265284404942, 1.734554003606771],
            [33.82730450225468, 1.737403256305661],
            [33.82864686556349, 1.738804844479398],
            [33.840397550826985, 1.743187066322886],
            [33.84318393798871, 1.744587986648843],
            [33.85816892748261, 1.754206377923786],
            [33.866362757633084, 1.761602396627611],
            [33.86833719983036, 1.764062045437217],
            [33.871070460626214, 1.769253686695772],
            [33.871666208051266, 1.771071301869417],
            [33.87167063674562, 1.774526957162755],
            [33.869839058119574, 1.783212205593916],
            [33.86979150041013, 1.785580892076532],
            [33.86960563358796, 1.789852247897476],
            [33.86994490930446, 1.795578347176496],
            [33.87125470329435, 1.79803829185562],
            [33.87119687334963, 1.799313836708945],
            [33.87079387024854, 1.800218652986902],
            [33.86927463225352, 1.801612502525059],
            [33.86875416454757, 1.803639108088757],
            [33.87051399922347, 1.804832362861532],
            [33.8718471988181, 1.806858072356274],
            [33.871467648034134, 1.807455306640729],
            [33.87011290414405, 1.807383591201335],
            [33.86782867792105, 1.804697962546373],
            [33.8671876212697, 1.804815871689841],
            [33.86621505483746, 1.806128042157795],
            [33.86720812980763, 1.812496112972468],
            [33.868994285121346, 1.815833307541999],
            [33.87053300667655, 1.821070325369986],
            [33.87063384166888, 1.826271853570469],
            [33.87001743658555, 1.827421024716254],
            [33.87017305533546, 1.828533634355153],
            [33.871124975787545, 1.82984487087654],
            [33.87129314939189, 1.831346461892707],
            [33.87070010948909, 1.832016171994282],
            [33.86991549846205, 1.831591383647158],
            [33.86815844497027, 1.832741113442705],
            [33.86597277561205, 1.832959288785],
            [33.86331451605759, 1.835448298215943],
            [33.86253201337654, 1.837077001746837],
            [33.86318651511274, 1.838017492341922],
            [33.8630682285494, 1.838587462866242],
            [33.859982409547264, 1.841194282328992],
            [33.85872679474875, 1.844017321839282],
            [33.85735049578344, 1.845935795672661],
            [33.85596495315384, 1.849672571497672],
            [33.854184342242036, 1.850967051232954],
            [33.85416104982506, 1.851609347204826],
            [33.8550304213907, 1.853002048034166],
            [33.8549855756951, 1.855562161141088],
            [33.85344261049848, 1.856784157248781],
            [33.85123361009568, 1.857644625219331],
            [33.84923759934846, 1.857392297150573],
            [33.848548961631415, 1.857935406971503],
            [33.84705495192284, 1.86049622492096],
            [33.84739017713573, 1.862359595676867],
            [33.85017161907185, 1.86352521438697],
            [33.85043408523829, 1.864809656901926],
            [33.84997212570513, 1.865832109974687],
            [33.84669565635193, 1.868221918755909],
            [33.84389248237243, 1.868630359482515],
            [33.84287297806829, 1.870566757936618],
            [33.84377618557743, 1.871018634543134],
            [33.84676979431232, 1.870492496973121],
            [33.84736489135713, 1.871731546990609],
            [33.84651233625356, 1.873785466822286],
            [33.84724038665535, 1.876897030445287],
            [33.84631565730865, 1.878435347786721],
            [33.847172899821345, 1.880271322809481],
            [33.84684110527451, 1.880886631840527],
            [33.84489331160015, 1.881638424424683],
            [33.84521828164575, 1.883881450584077],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 720,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "WERA",
        Population: 24124,
        Key: "AMURIAWERA",
        Dist2: "Amuria",
        "Sub Country": "Were",
        id2_original: "AmuriaWere",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.10542823847234, 1.561631490480258],
            [33.09370989525405, 1.616929025914613],
            [33.0926361605545, 1.624130710249871],
            [33.09270367254136, 1.632191830149327],
            [33.095728194101795, 1.651733802370252],
            [33.09594048037648, 1.655280320925474],
            [33.09480793207698, 1.660645411626978],
            [33.0866758620006, 1.676849454977183],
            [33.083852357349585, 1.685969232548648],
            [33.0817684177057, 1.690836757061769],
            [33.07976891071538, 1.692727723341967],
            [33.07698493642848, 1.693949215578037],
            [33.07460756389368, 1.694169539758549],
            [33.073709033912216, 1.694689476386818],
            [33.072284038173656, 1.696312242310816],
            [33.06760441741462, 1.700000719398878],
            [33.065739829295154, 1.700985949186165],
            [33.06543049442705, 1.702196653994906],
            [33.067630557491086, 1.703891547862115],
            [33.06824624482051, 1.706754329484578],
            [33.06734810830115, 1.719574612722466],
            [33.0487963957009, 1.708769584052729],
            [33.04679846435558, 1.70805489591184],
            [33.03966145632277, 1.706860817918806],
            [33.02599324881343, 1.706064896308066],
            [33.02349495495653, 1.706707287625369],
            [33.02247141721675, 1.707376792213722],
            [33.018319929487994, 1.707340650177902],
            [33.014203572175056, 1.708064467697911],
            [33.012013767871565, 1.709566327931708],
            [33.00994365150329, 1.710235842298587],
            [33.00827727305799, 1.711936741512742],
            [33.00491050864568, 1.712452447762797],
            [33.004244064706064, 1.713357174109998],
            [32.99993860483927, 1.712280551980268],
            [32.99908504002936, 1.709946355338534],
            [32.99405308474454, 1.688413812287724],
            [32.99386823301865, 1.682334036985826],
            [32.99645137724569, 1.671641694845864],
            [32.96221368919267, 1.65185475964784],
            [32.945131844077764, 1.642146439649554],
            [32.9482219579253, 1.636581245074918],
            [32.95189073593614, 1.631650566878952],
            [32.96277603995043, 1.622929214577666],
            [32.96404596041982, 1.621237394936564],
            [32.966170872223785, 1.61550145063345],
            [32.966848301661, 1.61159303341444],
            [32.96796338311813, 1.593534661154263],
            [32.96732216117675, 1.582388388477131],
            [32.96969627462372, 1.57279829526063],
            [32.973336281392626, 1.563615343807465],
            [32.97450535070001, 1.557535576717849],
            [32.97368007832994, 1.477186523572353],
            [33.01545454627677, 1.460874340851044],
            [33.02449881779495, 1.493308830703015],
            [33.026018711560155, 1.49767865800573],
            [33.03096886176362, 1.506002106971972],
            [33.03732849380067, 1.514017911901055],
            [33.048754077864494, 1.525200138378102],
            [33.06235673890086, 1.535522744713159],
            [33.07392711701544, 1.542877818492648],
            [33.10542823847234, 1.561631490480258],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 721,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "OCHERO",
        Population: 26116,
        Key: "KABERAMAIDOOCHERO",
        Dist2: "Kaberamaido",
        "Sub Country": "Ochero",
        id2_original: "KaberamaidoOchero",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.42894953957927, 1.788722384269158],
            [33.41982939635218, 1.797878224440026],
            [33.417480402495514, 1.810973606607406],
            [33.41075059539109, 1.816663329819146],
            [33.4015725458625, 1.82006658677244],
            [33.39454919627271, 1.816315120256159],
            [33.384670932438006, 1.815818816013947],
            [33.3814667038033, 1.820921282136881],
            [33.37462028010365, 1.827168017176324],
            [33.3606518241853, 1.837170317461894],
            [33.351010302360564, 1.84081514114843],
            [33.34664598038479, 1.851043554941355],
            [33.342881039519426, 1.856353027956094],
            [33.33671396405847, 1.858428292198978],
            [33.337660977014146, 1.863506193642602],
            [33.34479388693263, 1.86954577648052],
            [33.34299419580421, 1.876939917249981],
            [33.33761023118374, 1.883500011165198],
            [33.33044512834041, 1.889361297340526],
            [33.32514062240177, 1.883994396664887],
            [33.32301350523377, 1.88130484519675],
            [33.32300993263387, 1.879682502296546],
            [33.32386316955871, 1.876761537512681],
            [33.323594587661795, 1.875387091389215],
            [33.32403326376112, 1.873177996087274],
            [33.32334964313497, 1.869889148862137],
            [33.320836632178796, 1.867214251776307],
            [33.31889325192742, 1.866603914661177],
            [33.318235996854845, 1.864693634482898],
            [33.31749882136639, 1.863831267428549],
            [33.3146460801462, 1.862404426661964],
            [33.31347517647897, 1.861233967845573],
            [33.3121061161382, 1.860538153231242],
            [33.305101731780674, 1.85457971187359],
            [33.303181585555826, 1.852462106992063],
            [33.3028411222665, 1.850041047060546],
            [33.30469088099728, 1.846461538323433],
            [33.3046566632698, 1.844574809434888],
            [33.306533030099274, 1.842456547064498],
            [33.306627533765486, 1.841326097698623],
            [33.30306592207312, 1.831135957640393],
            [33.30277003139157, 1.829326579141473],
            [33.30260683894546, 1.824163589646496],
            [33.30388491791425, 1.820632623182563],
            [33.30427050447862, 1.814738000891527],
            [33.30382392859469, 1.811566386119935],
            [33.302861934435015, 1.810829128193597],
            [33.30779958368298, 1.803324232156316],
            [33.307864538166235, 1.801949055156841],
            [33.309433618286484, 1.799424635052394],
            [33.31166464987163, 1.793525517397511],
            [33.3145542813073, 1.787743897698606],
            [33.318206502469145, 1.785571950996512],
            [33.32158272524306, 1.782947690951502],
            [33.32285682826841, 1.780839484575091],
            [33.32543736648283, 1.77837820862731],
            [33.32690896502171, 1.777771788493641],
            [33.328850698661135, 1.776016298194339],
            [33.331157426783705, 1.775961600911091],
            [33.33465740775938, 1.774287248030793],
            [33.34762722633932, 1.765281943807297],
            [33.35413519897591, 1.766553981753419],
            [33.36187924535858, 1.765363759446865],
            [33.373562819283805, 1.773022056376953],
            [33.377500674163265, 1.773417490366846],
            [33.383800790117824, 1.771831229454049],
            [33.39338166577939, 1.766942266341572],
            [33.396267865650685, 1.759941434519992],
            [33.398988551829206, 1.756075707591358],
            [33.41682264526469, 1.758284318401482],
            [33.42075501053945, 1.76343119083194],
            [33.42698723811307, 1.772947232009668],
            [33.42844461901592, 1.781577751251112],
            [33.428646901651625, 1.786372625527836],
            [33.42917890192918, 1.788154763049933],
            [33.42894953957927, 1.788722384269158],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 722,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "KALAKI",
        Population: 16725,
        Key: "KABERAMAIDOKALAKI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.43084109332694, 2.118251667335276],
            [33.430008263430395, 2.11977241771049],
            [33.42925525962662, 2.119989088497129],
            [33.429187032580806, 2.120835272362336],
            [33.42833641783827, 2.121740711108895],
            [33.42784294630325, 2.123270832720507],
            [33.427187685490594, 2.123285774014708],
            [33.42712429587258, 2.123945013143724],
            [33.426454428453425, 2.124191178111231],
            [33.42542797298561, 2.125839518613709],
            [33.425437940692, 2.126528254964166],
            [33.42496359339106, 2.126479190456238],
            [33.425102746021814, 2.127539203775155],
            [33.42466561951638, 2.127645210902015],
            [33.42453385283387, 2.12860948241042],
            [33.423810085599335, 2.128467015447395],
            [33.42288629768702, 2.130051371791717],
            [33.42337051926958, 2.130434964717836],
            [33.421918597428686, 2.131999787921824],
            [33.42207540824298, 2.133205039646599],
            [33.421806520918885, 2.133446172465939],
            [33.422271319128335, 2.134331567321635],
            [33.421792188298525, 2.134685907891235],
            [33.42177908098021, 2.136057520322935],
            [33.421020032412905, 2.13643256752967],
            [33.42050471834174, 2.137661010296505],
            [33.41966588320753, 2.137913731594384],
            [33.41830676542031, 2.139119400594173],
            [33.415928239448704, 2.142873336895207],
            [33.41541463756647, 2.142664896632458],
            [33.415327253048886, 2.141849407730807],
            [33.4140543995801, 2.140902706003465],
            [33.41278132153251, 2.139114182326332],
            [33.411211480539194, 2.135791166380554],
            [33.41010428718858, 2.135002257169461],
            [33.4091533467985, 2.131775530617382],
            [33.40820855178326, 2.130417696669078],
            [33.403834922362826, 2.12629633232856],
            [33.40314591633655, 2.124700559696322],
            [33.402404962534, 2.124455222487433],
            [33.40221294854035, 2.123473147024156],
            [33.400199192472975, 2.122386319337007],
            [33.398760986109856, 2.122342849158084],
            [33.39686934073403, 2.121562899287063],
            [33.395683596898316, 2.120300471121257],
            [33.39430758090229, 2.11989965149827],
            [33.39325397744829, 2.118579054526766],
            [33.39029234873752, 2.117643421526925],
            [33.38888548549296, 2.115169434210062],
            [33.38703544648783, 2.113722373642786],
            [33.379714854251965, 2.111865278676881],
            [33.37739704181715, 2.111937616652592],
            [33.371492371437164, 2.109881200045523],
            [33.368306218702614, 2.10775590501018],
            [33.36545380177422, 2.105096746781472],
            [33.36293568299732, 2.10189467909215],
            [33.36118809056214, 2.098529579298648],
            [33.35342458936536, 2.075633219111445],
            [33.35174894389957, 2.071896953166559],
            [33.34903036606703, 2.06925601650777],
            [33.34841340941812, 2.067392454645344],
            [33.348258857866725, 2.064859310149224],
            [33.34760319999876, 2.063576825869802],
            [33.347723417041614, 2.061827502940475],
            [33.34877167911298, 2.060824199927992],
            [33.35018398075826, 2.057955956111508],
            [33.3518788187301, 2.056924215756724],
            [33.354652974430955, 2.054390419905369],
            [33.356172676854975, 2.053610410274811],
            [33.36017472354799, 2.048834269158273],
            [33.3621260916189, 2.043975550105642],
            [33.36346159359559, 2.042111550255218],
            [33.36562061083765, 2.036004293209352],
            [33.364027713684266, 2.027862290118311],
            [33.36979592907424, 2.019166749018837],
            [33.371366479736636, 2.015502327634036],
            [33.373601854676146, 2.011765378616833],
            [33.374350723534675, 2.008046864694597],
            [33.377316251832056, 2.004825422525846],
            [33.381584226798665, 1.993171824082241],
            [33.384541856209765, 1.989986568008553],
            [33.38662706427482, 1.988402843585679],
            [33.388383704541575, 1.987696758247592],
            [33.39773550890738, 1.986038908576985],
            [33.404413965615184, 1.982463698956143],
            [33.40713738087555, 1.980110799933743],
            [33.408474538447294, 1.976238341114103],
            [33.407691123077925, 1.969326606356401],
            [33.40795532838275, 1.962686022595039],
            [33.41042069179794, 1.955447794519858],
            [33.412706525106984, 1.949421807215392],
            [33.41635055992164, 1.951497124597762],
            [33.419467218087505, 1.954338843969513],
            [33.42046475229474, 1.95605245204469],
            [33.422773204284326, 1.962483281339641],
            [33.42333309006495, 1.96752232295976],
            [33.42299457432316, 1.971186448940597],
            [33.422073879310354, 1.975022616840545],
            [33.42040701307987, 1.979483219157541],
            [33.4205527638364, 1.982477742891213],
            [33.42232653317897, 1.985155203511514],
            [33.42588291128652, 1.987642211247475],
            [33.431225406080216, 1.992616663463607],
            [33.433821609116556, 1.99820701970481],
            [33.433663492151815, 1.998843872695228],
            [33.432890134320346, 1.999419564071623],
            [33.43300723870077, 2.000215668960302],
            [33.43232323179903, 2.002151908166146],
            [33.43269350478274, 2.003311938372077],
            [33.431906565322485, 2.003436691964158],
            [33.43156986597423, 2.004402021938913],
            [33.431010879407204, 2.004648250307892],
            [33.43080695195625, 2.004238168927624],
            [33.43042648848397, 2.004323690089111],
            [33.42956624649653, 2.005011489783336],
            [33.42921439795932, 2.004875876941187],
            [33.428718923181215, 2.00568119114511],
            [33.42317085432462, 2.007899161920137],
            [33.421763755721464, 2.009986546532412],
            [33.42023128284737, 2.011120660873166],
            [33.41828294659057, 2.013835269012255],
            [33.41736983066381, 2.014387371849806],
            [33.41700817701528, 2.015316000324241],
            [33.41667615160142, 2.014976260209667],
            [33.41620368357604, 2.016649426014916],
            [33.4150051809684, 2.016450247416168],
            [33.414560630785424, 2.017645019689352],
            [33.413465402994404, 2.018133840063837],
            [33.41210964939792, 2.019590756247753],
            [33.40941192954799, 2.023734979922863],
            [33.41016201472539, 2.025182310246606],
            [33.409640672060334, 2.025969528259748],
            [33.40979050476154, 2.027326550717573],
            [33.410651816642456, 2.028565770778989],
            [33.41089994210374, 2.029687540632763],
            [33.41031973732971, 2.031062830998541],
            [33.410907039692766, 2.033279201452636],
            [33.41019708315744, 2.034980222561246],
            [33.41041793037677, 2.039183634716743],
            [33.41087572352365, 2.039993778823138],
            [33.412706299629846, 2.040858815169187],
            [33.412874133671025, 2.042953304258799],
            [33.41712049337524, 2.049188729587585],
            [33.41936952899532, 2.050700390633031],
            [33.41947836258693, 2.053035278600482],
            [33.42032036787576, 2.054051289506622],
            [33.42116220607796, 2.054426104088326],
            [33.42131867373583, 2.054982571298261],
            [33.421775616178174, 2.054970352192341],
            [33.42228120598636, 2.057047445343201],
            [33.425047648752205, 2.05976875763885],
            [33.42638595257428, 2.060590373350344],
            [33.419702026922984, 2.067318503191161],
            [33.4129855499191, 2.072688419605452],
            [33.409997393957994, 2.077132472701436],
            [33.406783800386435, 2.07994673584188],
            [33.40469518680816, 2.082663688094066],
            [33.40477303031911, 2.085405821204989],
            [33.40569902539206, 2.086446613567674],
            [33.407756460243476, 2.087460205249204],
            [33.41168579819572, 2.087976584891447],
            [33.41308510391383, 2.089611234923161],
            [33.41701490539674, 2.091866100537136],
            [33.418022949892816, 2.091969311912867],
            [33.41892831066374, 2.092734837739894],
            [33.42345394042011, 2.092133416289592],
            [33.42538783805536, 2.092691693501752],
            [33.42627264177926, 2.093498611749857],
            [33.42649609950281, 2.096301766012967],
            [33.426088536553365, 2.097339916358707],
            [33.42604842497929, 2.101148067137307],
            [33.4254316991974, 2.102741860290827],
            [33.425609581793346, 2.104916806380633],
            [33.42658676736276, 2.106793692434202],
            [33.42666286904037, 2.109785423759597],
            [33.427514325504326, 2.110847254688157],
            [33.42828438921364, 2.113233706565145],
            [33.43084109332694, 2.118251667335276],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 723,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "AKERIAU",
        Population: 14227,
        Key: "AMURIAAKERIAU",
        Dist2: "Amuria",
        "Sub Country": "Akeriau",
        id2_original: "AmuriaAkeriau",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.56120972955211, 1.980205785834671],
            [33.55959855258102, 1.981821102837346],
            [33.55880397025433, 1.983675972105225],
            [33.557646028378386, 1.984581047734573],
            [33.55595702765928, 1.985540584651105],
            [33.55508704434089, 1.985441364247005],
            [33.55453253767222, 1.985957220864768],
            [33.55349401603349, 1.986029946082466],
            [33.552601268507516, 1.986763040804798],
            [33.55268706660029, 1.987893865583481],
            [33.551869693116544, 1.990526769918139],
            [33.54729376309413, 1.993197124188722],
            [33.5461662516484, 1.997802343977885],
            [33.54221828084053, 2.004634031497716],
            [33.54001936582344, 2.006824101178069],
            [33.53904176163908, 2.009339450809786],
            [33.53716482437939, 2.011420849998544],
            [33.535079221953914, 2.013013786564299],
            [33.53365611177912, 2.016035907337787],
            [33.53194977447337, 2.018327877894209],
            [33.53026275543777, 2.019403106111927],
            [33.52761580567273, 2.020047739777556],
            [33.52594388102889, 2.019939261098724],
            [33.52456076654547, 2.019342669981286],
            [33.52306904484594, 2.017977745959932],
            [33.522558243012426, 2.018144044879957],
            [33.52200078627636, 2.01764063413978],
            [33.521159702658984, 2.0177083978371],
            [33.520380731255315, 2.018373181454548],
            [33.51840431456105, 2.018129809130011],
            [33.51720235613447, 2.0192619777469],
            [33.51611341475382, 2.018795076466565],
            [33.51523121524589, 2.019392400355036],
            [33.51430733031552, 2.018707394262972],
            [33.513904524843824, 2.01771072213341],
            [33.51254209137488, 2.017228328685492],
            [33.51208257076771, 2.016377040553288],
            [33.50853193289484, 2.014929683531299],
            [33.50610091297125, 2.01303029279634],
            [33.50405223938882, 2.012724623135879],
            [33.50236457356624, 2.011759494687304],
            [33.49812963234756, 2.014778841015707],
            [33.49761194133416, 2.014749407058106],
            [33.49722670151952, 2.015637165724717],
            [33.49647269699255, 2.016156319292099],
            [33.49576625915816, 2.016138442213459],
            [33.495128166947225, 2.017209653511239],
            [33.49361062317483, 2.0167814324792],
            [33.49308694309343, 2.017125375522943],
            [33.49320844472717, 2.017487215308672],
            [33.49221607762945, 2.017903675522352],
            [33.49094919616067, 2.017460762855897],
            [33.490376571371016, 2.017641874841833],
            [33.48998684806478, 2.016782535824822],
            [33.48809826863901, 2.015914603001821],
            [33.4871052457711, 2.016023465292343],
            [33.48660603669636, 2.015507940426664],
            [33.4858997407958, 2.015969546768541],
            [33.48451102441829, 2.015924728829076],
            [33.483645708746145, 2.014576994942997],
            [33.48303918243599, 2.014348453048914],
            [33.48125690425104, 2.013537311266532],
            [33.48034386378277, 2.012334339419197],
            [33.47927477157661, 2.011755652267651],
            [33.47664671787358, 2.011267894724558],
            [33.475955802927295, 2.01051720133656],
            [33.475981470489934, 2.009874860375215],
            [33.47536877814363, 2.009476973721041],
            [33.47429933379792, 2.009612993765827],
            [33.47336617915214, 2.006853945556887],
            [33.47194457724871, 2.0057777726947],
            [33.46869082269575, 2.004548332594827],
            [33.467588624876434, 2.002151205214689],
            [33.466793498170695, 2.002495217774888],
            [33.464980808420115, 2.001618182080046],
            [33.46410695785444, 2.001808418034335],
            [33.46398251872972, 1.998967709107725],
            [33.46111805359673, 1.997059613019668],
            [33.46067204185477, 1.995811258443321],
            [33.460793382690106, 1.991595339665095],
            [33.46021879328493, 1.990763181422571],
            [33.460801392069165, 1.986031456141155],
            [33.460228595701295, 1.985579268918031],
            [33.460558916112724, 1.985108733719695],
            [33.46005808288397, 1.984746995420256],
            [33.460389605241254, 1.984556916400926],
            [33.46047621630937, 1.982765593707123],
            [33.45882273677323, 1.980350516753855],
            [33.45679650310656, 1.97941019558946],
            [33.453320341858955, 1.976416608086918],
            [33.45065514551387, 1.971351032437219],
            [33.44991416296523, 1.968202885665556],
            [33.44668736236238, 1.960233368252847],
            [33.44675517169161, 1.959518638699303],
            [33.45195216995199, 1.95237012246364],
            [33.45470835216065, 1.946941189571162],
            [33.45545380292949, 1.943747405857277],
            [33.4543300248821, 1.94021034399444],
            [33.45226959055597, 1.937243491233657],
            [33.44082097189165, 1.928434759983109],
            [33.44057259939366, 1.926335922287086],
            [33.441401139834724, 1.918338164130998],
            [33.443196418438475, 1.910937258113301],
            [33.443258730078135, 1.908485505731521],
            [33.4478601129658, 1.910628440907305],
            [33.45154906084971, 1.913504408465132],
            [33.45451190767602, 1.916199619017852],
            [33.45874832572499, 1.921518101128636],
            [33.460513766786576, 1.922603258780334],
            [33.463466556973245, 1.923326210817502],
            [33.46860333038035, 1.922909829302761],
            [33.469994034729574, 1.924155369737696],
            [33.47090691799266, 1.925816351062405],
            [33.47253637118819, 1.926253063619823],
            [33.47525234570304, 1.927760526910003],
            [33.47735970442639, 1.928065949107839],
            [33.481140957799006, 1.932327248635969],
            [33.484421797456086, 1.933878248222051],
            [33.4870939485581, 1.934008627261203],
            [33.49293722537658, 1.931886676179944],
            [33.499106654423635, 1.930813807316701],
            [33.50438500321783, 1.928495264060734],
            [33.510183930210744, 1.92353170855837],
            [33.514984104880895, 1.92055754095542],
            [33.51669949810305, 1.917824744076544],
            [33.51882802832099, 1.916359596708294],
            [33.52005131904061, 1.915977628467402],
            [33.518389234542376, 1.913340621081471],
            [33.51854455864488, 1.912209712983339],
            [33.517889928449584, 1.910527189720225],
            [33.517960978002016, 1.909459635087406],
            [33.51952598246583, 1.905523762070304],
            [33.5174591314736, 1.892451626518473],
            [33.52181892773696, 1.892920749163337],
            [33.52732485482696, 1.892539101637273],
            [33.53027266565198, 1.893705243399709],
            [33.534076474823095, 1.893486941806216],
            [33.53484849506308, 1.893142921351556],
            [33.540428274449184, 1.893566380443502],
            [33.543554125075346, 1.892597382168381],
            [33.54580092119539, 1.892931404551321],
            [33.54833853251564, 1.894170016643763],
            [33.55008247599415, 1.898358149762226],
            [33.550855832029, 1.898692635207674],
            [33.55431042382833, 1.899487643910728],
            [33.55590402705751, 1.899170489274149],
            [33.55690575999041, 1.898446417359618],
            [33.564247085343005, 1.89830831703491],
            [33.56710000532797, 1.899740636571769],
            [33.56825863082187, 1.90124063624243],
            [33.57070313715278, 1.909453519161588],
            [33.57333553061696, 1.921479334583464],
            [33.574212161468445, 1.922958762609091],
            [33.57443237807043, 1.926484838937044],
            [33.57311976337056, 1.931239292437442],
            [33.57308940300889, 1.934009850967477],
            [33.573715557508024, 1.93501710995768],
            [33.57997512081571, 1.939139298445082],
            [33.583293030351314, 1.942286494198691],
            [33.584639167482635, 1.944112064594844],
            [33.58736212011064, 1.945968634852664],
            [33.59074746437795, 1.949974604878336],
            [33.58966133562244, 1.950418280786193],
            [33.58428143498031, 1.95478976929769],
            [33.58253104698795, 1.955224627614171],
            [33.57787007255929, 1.955262437237833],
            [33.574395097986155, 1.957661041068903],
            [33.5728527005248, 1.959950414574787],
            [33.57205816221557, 1.961877657422084],
            [33.571568188720256, 1.965378939967117],
            [33.569062900580555, 1.970337454174704],
            [33.568749499039185, 1.970871323238396],
            [33.56737332314305, 1.97118843483816],
            [33.567104624465145, 1.972626970106715],
            [33.56612015535539, 1.972971086677075],
            [33.566025007597126, 1.974120065045218],
            [33.56525304844258, 1.974708372589103],
            [33.56469944817401, 1.976219379979715],
            [33.56120972955211, 1.980205785834671],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 724,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "TUBUR",
        Population: 21973,
        Key: "SOROTITUBUR",
        Dist2: "Soroti",
        "Sub Country": "Tubur",
        id2_original: "SorotiTubur",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.893546106913945, 2.176626933680021],
            [33.88790723455181, 2.174314474020544],
            [33.88330988509977, 2.173159282811493],
            [33.87632856229223, 2.173100054596098],
            [33.872249308095476, 2.173762803651901],
            [33.86505232583935, 2.175983292735803],
            [33.86140789127439, 2.178355499391103],
            [33.85317449572551, 2.185551968182962],
            [33.849799115571315, 2.187734037952453],
            [33.84609244392684, 2.189473027079005],
            [33.84308315060711, 2.190062740762033],
            [33.83864546142546, 2.190128571489665],
            [33.834864173018545, 2.191143880116014],
            [33.83028748661468, 2.193223710258934],
            [33.829177999865145, 2.192949498393675],
            [33.82738600729872, 2.193545966474248],
            [33.82564692909579, 2.192514231444517],
            [33.82408275916688, 2.19341038614567],
            [33.82240645613432, 2.193632012283985],
            [33.821702450039396, 2.193041097145985],
            [33.8215697185663, 2.191686049575948],
            [33.81979345819544, 2.191061235391355],
            [33.81946736076413, 2.19057279058609],
            [33.81498784153127, 2.190539752253128],
            [33.81256432703193, 2.189392195534397],
            [33.80997840790896, 2.186689210123306],
            [33.80869514566098, 2.183004712374664],
            [33.80728014637488, 2.18072985131977],
            [33.80114091778942, 2.175195621591496],
            [33.799627748812455, 2.174807436686626],
            [33.7979108455223, 2.172809106501739],
            [33.7958658074218, 2.17204125245645],
            [33.79564097617418, 2.170304735125256],
            [33.79723912038711, 2.14892707797302],
            [33.796499594007564, 2.140405794187418],
            [33.79723872153514, 2.136216942170595],
            [33.79707348811672, 2.13474079636242],
            [33.79611265817366, 2.130738400641691],
            [33.79479336449963, 2.127632337941566],
            [33.794194649040875, 2.12370740230389],
            [33.79423928183576, 2.120866819333335],
            [33.79356420328964, 2.118148880517167],
            [33.79235813417234, 2.11540447982725],
            [33.78666475024214, 2.105715830151734],
            [33.78301035066574, 2.102642476565406],
            [33.78314303362983, 2.100679132302904],
            [33.78431322942457, 2.097450809107674],
            [33.78438519795357, 2.095261545746325],
            [33.78319520598488, 2.084569304535793],
            [33.78367728059392, 2.069533950844596],
            [33.78332621898087, 2.068756135504858],
            [33.778044470961625, 2.067193724019225],
            [33.77902733208704, 2.063539183038925],
            [33.782951480471915, 2.055149681544669],
            [33.78836739816704, 2.049452257789456],
            [33.78971250403244, 2.047541769362124],
            [33.790052379823564, 2.046263031813121],
            [33.79491555783615, 2.042249994163433],
            [33.801476134019126, 2.043789823076953],
            [33.80324576033163, 2.043575271264236],
            [33.80565196788872, 2.042315830269126],
            [33.80711373436681, 2.039893597553711],
            [33.808338918735046, 2.036236998497476],
            [33.81067489151169, 2.033624406821223],
            [33.81247431943372, 2.032501750030609],
            [33.81548514078776, 2.032084089685374],
            [33.81937715463826, 2.032841997292559],
            [33.82021058910099, 2.032475296027431],
            [33.82287615195872, 2.029873013428004],
            [33.8285656632517, 2.028311637727599],
            [33.8340210690901, 2.028156757466865],
            [33.837071790914116, 2.027068901870249],
            [33.84086153426447, 2.023922597238731],
            [33.8436927168162, 2.022742796963422],
            [33.8477622180039, 2.022315485918615],
            [33.85283848269011, 2.022457547684165],
            [33.85571623300784, 2.021298102968601],
            [33.85849610468886, 2.021034284678389],
            [33.85975504774546, 2.019677929375311],
            [33.866812650995364, 2.018109939947858],
            [33.871724723410566, 2.016543084673441],
            [33.882803497587595, 2.014191527255973],
            [33.88308751343941, 2.015056141979573],
            [33.8857408852604, 2.016807750279193],
            [33.88761674813503, 2.015727914839937],
            [33.88997315309278, 2.016216339878623],
            [33.8908482586049, 2.016897207454309],
            [33.892145906473836, 2.016264824258329],
            [33.89288731033234, 2.017549042136063],
            [33.89397342561313, 2.01709420893356],
            [33.89460815632825, 2.018300808695361],
            [33.89437673953129, 2.019322565601509],
            [33.895582805055334, 2.018917345677174],
            [33.89655653750084, 2.019349746105272],
            [33.897311091796766, 2.018880898511508],
            [33.897840227346876, 2.018994163206848],
            [33.8975022631707, 2.020165418662571],
            [33.89629599552571, 2.02020157672171],
            [33.89577421807609, 2.020641903999686],
            [33.896254367595446, 2.021472031579122],
            [33.89606893465953, 2.021855131953155],
            [33.89455299797318, 2.022244958223317],
            [33.893718865519475, 2.023018863950431],
            [33.89386138503595, 2.023547987422876],
            [33.894806478291855, 2.023339401195391],
            [33.895761878817325, 2.0238641246664],
            [33.8955669273327, 2.027653988136206],
            [33.8949798827861, 2.028016161333266],
            [33.89359836460896, 2.027811475519017],
            [33.89240837803019, 2.028642286206774],
            [33.89125675041235, 2.028600586511056],
            [33.892064374480334, 2.030939689192591],
            [33.893536814740635, 2.031338912726252],
            [33.89298687061529, 2.031878620650029],
            [33.892923830441916, 2.032694855173449],
            [33.89263077394508, 2.032957003544133],
            [33.890913309207875, 2.032653389895054],
            [33.888896418918485, 2.033861067038788],
            [33.88969574345159, 2.036097312486271],
            [33.8903642103972, 2.036639710266173],
            [33.890746184835805, 2.036620926688385],
            [33.89070319865283, 2.035421490249298],
            [33.89146476429957, 2.034860373099036],
            [33.893906450818804, 2.036434632331481],
            [33.89559888310228, 2.035312298890875],
            [33.89692537767164, 2.035801275526086],
            [33.89768665316255, 2.0347220470581],
            [33.89843503872741, 2.035843013639041],
            [33.89993747463339, 2.035579566695438],
            [33.899317352321404, 2.036772275295252],
            [33.89958149654079, 2.037720090157361],
            [33.90097591722035, 2.038184281961623],
            [33.90068293797866, 2.039745803417057],
            [33.901726528810514, 2.040812657585207],
            [33.901424817045935, 2.043356151701008],
            [33.90227725087691, 2.044144778380437],
            [33.902769233005195, 2.045317037224916],
            [33.90506557390812, 2.047407985190402],
            [33.905115169894934, 2.047791214962641],
            [33.90449447625443, 2.047961905255735],
            [33.9041844568701, 2.048629233178642],
            [33.905024375372534, 2.049416563620365],
            [33.90486969356546, 2.050332212170992],
            [33.905956099002076, 2.050374177034586],
            [33.90676605599486, 2.05159276904243],
            [33.906729594275795, 2.053116334523428],
            [33.90816917416301, 2.054396260588076],
            [33.90755018821985, 2.054921289038288],
            [33.90593023381012, 2.054547441436381],
            [33.90505281603444, 2.056859881267205],
            [33.90322965462259, 2.056813042762349],
            [33.90281750577362, 2.058225825370351],
            [33.90105076305318, 2.058482166605996],
            [33.9003023837765, 2.057403790992519],
            [33.901367273663766, 2.056807005484201],
            [33.90094987236533, 2.054692226786868],
            [33.90006787497832, 2.054352053280748],
            [33.897993974906065, 2.054551954364308],
            [33.896584688905214, 2.057427191383968],
            [33.89439899529248, 2.057751157406755],
            [33.89362993500132, 2.059352253495021],
            [33.89447030805129, 2.060941593940633],
            [33.89224963314308, 2.063618563258614],
            [33.892283857158766, 2.063985146076554],
            [33.89443013629009, 2.06479549666488],
            [33.89456502731317, 2.066321357591193],
            [33.89308424889038, 2.067521656022046],
            [33.89050178828128, 2.066621747387551],
            [33.88717532229262, 2.06790683352409],
            [33.886086305453446, 2.067802403251845],
            [33.88581862726174, 2.068512294121433],
            [33.886231986141404, 2.070013296947609],
            [33.88527163589869, 2.072139686233081],
            [33.88445677051121, 2.072131098568259],
            [33.881974746042445, 2.070047491447711],
            [33.881489886656034, 2.070703469114754],
            [33.88259166226719, 2.074303226876297],
            [33.88282642169533, 2.074663051832966],
            [33.88398783376322, 2.074617090931813],
            [33.886288752480816, 2.076638553286502],
            [33.887198643455704, 2.078190479904636],
            [33.887101715236554, 2.07965448823429],
            [33.88803043759473, 2.079320778302054],
            [33.88804015916271, 2.079980437277052],
            [33.88866110253488, 2.08022849439664],
            [33.889544397987436, 2.081769298294962],
            [33.89179415046309, 2.081713477017514],
            [33.89270165820751, 2.082475228428935],
            [33.8921480606339, 2.083380158873006],
            [33.8888233849876, 2.084331897763006],
            [33.888742313829816, 2.085073728387655],
            [33.889990319897855, 2.086818920339279],
            [33.889941649175775, 2.087207937169821],
            [33.88896389587106, 2.087362278450092],
            [33.888491649729566, 2.088031962473679],
            [33.8884440093751, 2.090257343925192],
            [33.890343654248554, 2.091531766588618],
            [33.89174516263571, 2.091413365814362],
            [33.89275676176536, 2.093466260768857],
            [33.89401250681956, 2.094958153162827],
            [33.89604139770284, 2.094224248647397],
            [33.8956989769845, 2.093916877188134],
            [33.89592624536151, 2.092342718873192],
            [33.89662679563749, 2.091926193687452],
            [33.897148563205675, 2.09236915392665],
            [33.897914399443245, 2.092124466953971],
            [33.89770270964994, 2.092432157454009],
            [33.898941958042236, 2.09357125490257],
            [33.89892631028833, 2.094711075979268],
            [33.90029657706653, 2.095976740512469],
            [33.89974351578712, 2.097813424248356],
            [33.90127545057039, 2.097776351384828],
            [33.901577543220625, 2.099295924222886],
            [33.90301270249832, 2.100036871602847],
            [33.90252363001326, 2.100751799360471],
            [33.90275204823382, 2.101194925871567],
            [33.9034859942788, 2.101194498560987],
            [33.905293620226146, 2.098787179764968],
            [33.90708619579918, 2.098550934988637],
            [33.909849646276804, 2.099870048884796],
            [33.90967142411768, 2.101679372997329],
            [33.911285185541864, 2.102230237099397],
            [33.91067531300725, 2.103949353915358],
            [33.91007243924703, 2.104175860419303],
            [33.90858849156795, 2.103624919801023],
            [33.90842643459237, 2.105208082447858],
            [33.90878543461758, 2.105994882870448],
            [33.90790553569508, 2.106275827908402],
            [33.907466380793736, 2.107786785250363],
            [33.90588584984856, 2.108348570495014],
            [33.90451648947047, 2.107707098447743],
            [33.90290377548194, 2.108983543778384],
            [33.90303511187141, 2.11063890615317],
            [33.90264360181609, 2.110973841064537],
            [33.90193425164354, 2.109780167689014],
            [33.901575727725465, 2.109816561601231],
            [33.90164174761061, 2.111254856122325],
            [33.902587709537414, 2.112475528632296],
            [33.903349540187165, 2.112095145934171],
            [33.90423404297548, 2.112963054966092],
            [33.905423963078896, 2.113306109111857],
            [33.90646842347997, 2.114780010502899],
            [33.9067464817048, 2.116498607145769],
            [33.9081801830168, 2.115665521090651],
            [33.90968008477533, 2.116569245554853],
            [33.910853429165144, 2.116432860314355],
            [33.91131038418387, 2.117500028920098],
            [33.91363289570597, 2.117209177076448],
            [33.91565523068427, 2.118700579033161],
            [33.91744829044928, 2.119260367432742],
            [33.917253050605424, 2.11982134059466],
            [33.91581944092159, 2.12079917225654],
            [33.915117796497576, 2.120311101687589],
            [33.91492178410258, 2.119560393392213],
            [33.91428618291994, 2.119569817453931],
            [33.914238413208054, 2.121478570289738],
            [33.91362740610128, 2.121800349768374],
            [33.914188886391514, 2.122471258720141],
            [33.911206802143425, 2.123105029589196],
            [33.91086836904664, 2.124104495493017],
            [33.91143316591692, 2.12370325763096],
            [33.91192668955423, 2.124417253459192],
            [33.91127328376265, 2.12490606153681],
            [33.90939983915277, 2.125050781151696],
            [33.908471729445615, 2.124596573982559],
            [33.908506984727275, 2.123860567575585],
            [33.90785834090501, 2.12327455457859],
            [33.90830394750674, 2.122466501813186],
            [33.90763721700458, 2.121461645959716],
            [33.90726253688607, 2.121503752557782],
            [33.906579419316465, 2.122994080319353],
            [33.90711508382208, 2.123628029615967],
            [33.90671691186061, 2.124184741616616],
            [33.90553926094732, 2.1241794541754],
            [33.90529560280797, 2.124520665556155],
            [33.90600381750996, 2.125268200775833],
            [33.90752657061269, 2.125500662184252],
            [33.90805653351119, 2.127829415413603],
            [33.90912225703504, 2.128395793182147],
            [33.910513992650195, 2.128341114545468],
            [33.91099713535611, 2.130680423959617],
            [33.910545384277796, 2.131153399219473],
            [33.90952817786416, 2.130908676162216],
            [33.90928494642457, 2.131973906521854],
            [33.90794709445507, 2.132638884479115],
            [33.908203046937395, 2.132979799544133],
            [33.908797551094125, 2.132518706712007],
            [33.9092497486351, 2.132805651605232],
            [33.90840263103398, 2.134241122148365],
            [33.90664520384304, 2.13377654754553],
            [33.905676400453544, 2.134937947432898],
            [33.90415987986224, 2.135208110428529],
            [33.90406846011239, 2.135972686718497],
            [33.90345864866325, 2.136243694259373],
            [33.903167166014796, 2.136172063904619],
            [33.90322612604016, 2.135286450174719],
            [33.902768047229024, 2.135113195700244],
            [33.902143913040966, 2.135765780569994],
            [33.90171053251023, 2.137148258580366],
            [33.90005692900659, 2.136939807664778],
            [33.900101129711835, 2.138982114272486],
            [33.898969611779954, 2.138873166198681],
            [33.89969642250666, 2.140895209408917],
            [33.90075483913397, 2.140397940310407],
            [33.900529406913435, 2.141397342019419],
            [33.90086645660465, 2.142276274324977],
            [33.900149303665586, 2.142348966358838],
            [33.899899731018415, 2.142750018024353],
            [33.90119071428625, 2.143281797930633],
            [33.90138132511143, 2.143760375361064],
            [33.899819860908174, 2.144130947512519],
            [33.90013232101512, 2.145278930827851],
            [33.89971755447541, 2.146519820983407],
            [33.90089504998017, 2.146922929946673],
            [33.90188849505624, 2.146500582697168],
            [33.90365788421347, 2.14849036025784],
            [33.90230014444193, 2.148630512928461],
            [33.90004052846445, 2.149577270017572],
            [33.89962470370932, 2.150469080264624],
            [33.899113239817474, 2.150553155421718],
            [33.898417591647984, 2.151540525145172],
            [33.89828770424103, 2.152623985635664],
            [33.90029222383066, 2.152790336754353],
            [33.901173492683924, 2.154471215260494],
            [33.89943782718076, 2.156351112780559],
            [33.898647838838436, 2.158182576451172],
            [33.897048235761474, 2.158817793974495],
            [33.89572155344422, 2.158292021358768],
            [33.89471700788618, 2.159393608331584],
            [33.89459301522414, 2.160949431422555],
            [33.89576179796895, 2.164160771252297],
            [33.896617366920296, 2.164478580324359],
            [33.89702129259117, 2.163574809591167],
            [33.89762850162095, 2.164466011087939],
            [33.89810966623656, 2.163424570225347],
            [33.898894048193206, 2.164999470143454],
            [33.899845435944314, 2.16547313586035],
            [33.89905733945396, 2.166744926307396],
            [33.8991223622092, 2.168346190993267],
            [33.8986240092289, 2.168211177517959],
            [33.89843161075629, 2.16896194722562],
            [33.897655288484394, 2.169546108766731],
            [33.89786175637098, 2.169948314851327],
            [33.89874373848661, 2.169515540363848],
            [33.89879802906912, 2.170001355543529],
            [33.89696701638171, 2.172400719825258],
            [33.89648037204284, 2.174237989967714],
            [33.893546106913945, 2.176626933680021],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 725,
        District: "AMURIA",
        County: "KAPELEBYONG",
        Subcounty: "ACOWA",
        Population: 18539,
        Key: "AMURIAACOWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.62310586068691, 1.389452257154566],
            [33.62311889973328, 1.391200619312102],
            [33.621908170156274, 1.39244195555876],
            [33.619376192171174, 1.393329067157795],
            [33.61898022916697, 1.394791796546833],
            [33.61826470846676, 1.395190884153278],
            [33.618199006585186, 1.396553802384571],
            [33.61750542364252, 1.396642630150834],
            [33.616668899873545, 1.397440647509162],
            [33.61691143332216, 1.398670518681751],
            [33.615992838570506, 1.401095248741948],
            [33.61371008288965, 1.402783364005713],
            [33.608895376173116, 1.408242119832256],
            [33.60532854437064, 1.410864089713958],
            [33.6032242480041, 1.41294710479189],
            [33.602225722955104, 1.414419453402835],
            [33.6013822875483, 1.418249406277481],
            [33.60054079070593, 1.420054904400614],
            [33.59724719048022, 1.424108428835931],
            [33.594612085002204, 1.426503873410417],
            [33.59256706037645, 1.427695022932226],
            [33.5897662336948, 1.431294679638416],
            [33.58905028719313, 1.432751404209831],
            [33.58867157723228, 1.435559368477772],
            [33.588905016136984, 1.440837071052241],
            [33.58361428676153, 1.448819979271766],
            [33.58258839004581, 1.450991485612539],
            [33.582869354320586, 1.453379776119617],
            [33.58263861485332, 1.456229588012587],
            [33.583136003043016, 1.456898923779006],
            [33.58284426437472, 1.460671529463219],
            [33.57883757339164, 1.468235729311951],
            [33.575194990254495, 1.471665430742793],
            [33.57549910141921, 1.474478919715586],
            [33.57733328605788, 1.480378116795639],
            [33.583475923749894, 1.482385834181977],
            [33.58591132116385, 1.481963904656909],
            [33.58638714799004, 1.482499953879572],
            [33.58638729441543, 1.483055278850911],
            [33.585417032161914, 1.483572565599529],
            [33.584922541937324, 1.484415260129833],
            [33.58534128082724, 1.484932175680721],
            [33.586027240666404, 1.488608628653224],
            [33.58642210233606, 1.493254585498587],
            [33.585970581226505, 1.494690892203107],
            [33.58564957364961, 1.495002152196563],
            [33.578891572021696, 1.495722128502432],
            [33.57734410177393, 1.496583025514133],
            [33.57586272327654, 1.496589303494051],
            [33.57214101203757, 1.49834537346914],
            [33.56950434618591, 1.500662059910011],
            [33.56230087719514, 1.50231951383179],
            [33.560742282210875, 1.502111839940445],
            [33.559458577991755, 1.502501186825485],
            [33.55665153047678, 1.502121941616532],
            [33.552414733338765, 1.500042243591005],
            [33.54650588130113, 1.500116114579477],
            [33.54422232971291, 1.496905043383729],
            [33.54380768983565, 1.496896100114828],
            [33.542049381397426, 1.493341110577205],
            [33.53691551134534, 1.487280957757483],
            [33.53603965843488, 1.485173243828298],
            [33.533895454411855, 1.481871646205315],
            [33.533183430853036, 1.481129972923194],
            [33.53218609427516, 1.480813573426866],
            [33.53106714826569, 1.481790910178804],
            [33.53011651330279, 1.481763998468679],
            [33.52867581321644, 1.4834923064806],
            [33.52315991662342, 1.484461648829119],
            [33.51705899579491, 1.487240502287121],
            [33.512924798838746, 1.486463438318215],
            [33.511783771341264, 1.4867713013942],
            [33.51097432189664, 1.487468104484194],
            [33.51062237544305, 1.489667598405029],
            [33.5070621480545, 1.490872445978238],
            [33.50204924783352, 1.491693741713786],
            [33.4897837308942, 1.489738966086094],
            [33.48742462560071, 1.488867858692188],
            [33.48696967023179, 1.48755499977138],
            [33.48528497244291, 1.486207374390912],
            [33.4851094200768, 1.48503130650258],
            [33.48458791032516, 1.484479556122167],
            [33.48278206663535, 1.484090934333952],
            [33.48003123209758, 1.4812236457795],
            [33.47743129476464, 1.479840023176031],
            [33.4718074970313, 1.475634384600907],
            [33.45932337416929, 1.467340911120984],
            [33.45798224963719, 1.465486885527882],
            [33.45586743130375, 1.461279579217813],
            [33.45568335302733, 1.456703782962121],
            [33.45601613302602, 1.455698363863046],
            [33.45532396043833, 1.44914576678079],
            [33.45456481215805, 1.447374229002691],
            [33.453404141200224, 1.446452565823185],
            [33.451510647989856, 1.443060313376314],
            [33.44963815020429, 1.440690366865383],
            [33.449210670706684, 1.435334614072245],
            [33.44965416177592, 1.433516074117592],
            [33.44925123772661, 1.433054755731822],
            [33.448598421229825, 1.427445728908214],
            [33.446220936405616, 1.422560800239117],
            [33.444027117531135, 1.420281374657145],
            [33.44182465057543, 1.416816785825076],
            [33.44092281928526, 1.416310324970184],
            [33.4389923514178, 1.413189466597338],
            [33.43897084036001, 1.412330001579087],
            [33.43762352553731, 1.40905522934797],
            [33.436461441529595, 1.407843145807415],
            [33.43657130369221, 1.406467974938859],
            [33.433205385492876, 1.397231572919996],
            [33.43259966137826, 1.381390304413372],
            [33.433383283360165, 1.371420313822222],
            [33.43321506034851, 1.366969196748721],
            [33.430044233771, 1.34513923245747],
            [33.428190469452375, 1.339937503668307],
            [33.43039356343218, 1.338046279633127],
            [33.431312398932334, 1.336408600233271],
            [33.43405439225108, 1.322412327049328],
            [33.43602897817876, 1.32146203760018],
            [33.44049810031054, 1.321189831535895],
            [33.445403467700444, 1.322527911227246],
            [33.449177506703, 1.324680418810376],
            [33.453459162113084, 1.328470336377089],
            [33.45592954621239, 1.32912126289627],
            [33.46401929935072, 1.330730111817214],
            [33.47134935893131, 1.331642457728873],
            [33.47695999814238, 1.331035220427238],
            [33.48317891807336, 1.329676952155044],
            [33.4911167984365, 1.324726675969497],
            [33.49856342789995, 1.321594925058871],
            [33.50093779557013, 1.319766957390914],
            [33.509677009099285, 1.31070012004409],
            [33.512327957265676, 1.309831068296655],
            [33.523771665738664, 1.309340147780024],
            [33.52598076495611, 1.309891544142511],
            [33.52882993177983, 1.31130225942548],
            [33.53418080246524, 1.315453648872096],
            [33.53757555928013, 1.317226107716989],
            [33.54400366090815, 1.317324217336944],
            [33.54512054348742, 1.317468721653213],
            [33.546054990808905, 1.318291782888391],
            [33.5497053057457, 1.324859017223605],
            [33.553128720614765, 1.336637295782131],
            [33.553958745971, 1.33773177987205],
            [33.55707766789139, 1.339368553134211],
            [33.55746357964587, 1.349057673044485],
            [33.55925975656487, 1.35436777334066],
            [33.561832880983246, 1.357081234555564],
            [33.570604430269356, 1.362326341616307],
            [33.573974149240655, 1.364768184496662],
            [33.57780493571803, 1.368802153717677],
            [33.583510675076646, 1.380552600197525],
            [33.58744676207165, 1.385382629780399],
            [33.59275166416731, 1.388891464555223],
            [33.59424737708168, 1.389605784382476],
            [33.59733579311333, 1.39022922843308],
            [33.5993201104905, 1.390273955855631],
            [33.60229188567239, 1.389531354804655],
            [33.61071626394898, 1.389845811874666],
            [33.62310586068691, 1.389452257154566],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 726,
        District: "SERERE",
        County: "SERERE",
        Subcounty: "KATETA",
        Population: 54381,
        Key: "SEREREKATETA",
        Dist2: "Serere",
        "Sub Country": "Kateta",
        id2_original: "SerereKateta",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.56825863082187, 1.90124063624243],
            [33.56710000532797, 1.899740636571769],
            [33.564247085343005, 1.89830831703491],
            [33.55690575999041, 1.898446417359618],
            [33.55590402705751, 1.899170489274149],
            [33.55431042382833, 1.899487643910728],
            [33.550855832029, 1.898692635207674],
            [33.55008247599415, 1.898358149762226],
            [33.54833853251564, 1.894170016643763],
            [33.54580092119539, 1.892931404551321],
            [33.543554125075346, 1.892597382168381],
            [33.540428274449184, 1.893566380443502],
            [33.53484849506308, 1.893142921351556],
            [33.534076474823095, 1.893486941806216],
            [33.53027266565198, 1.893705243399709],
            [33.52732485482696, 1.892539101637273],
            [33.52181892773696, 1.892920749163337],
            [33.5174591314736, 1.892451626518473],
            [33.51952598246583, 1.905523762070304],
            [33.517960978002016, 1.909459635087406],
            [33.517889928449584, 1.910527189720225],
            [33.51854455864488, 1.912209712983339],
            [33.518389234542376, 1.913340621081471],
            [33.52005131904061, 1.915977628467402],
            [33.51882802832099, 1.916359596708294],
            [33.51669949810305, 1.917824744076544],
            [33.514984104880895, 1.92055754095542],
            [33.510183930210744, 1.92353170855837],
            [33.50438500321783, 1.928495264060734],
            [33.499106654423635, 1.930813807316701],
            [33.49293722537658, 1.931886676179944],
            [33.4870939485581, 1.934008627261203],
            [33.484421797456086, 1.933878248222051],
            [33.481140957799006, 1.932327248635969],
            [33.47735970442639, 1.928065949107839],
            [33.47525234570304, 1.927760526910003],
            [33.47253637118819, 1.926253063619823],
            [33.47090691799266, 1.925816351062405],
            [33.469994034729574, 1.924155369737696],
            [33.46860333038035, 1.922909829302761],
            [33.463466556973245, 1.923326210817502],
            [33.460513766786576, 1.922603258780334],
            [33.45874832572499, 1.921518101128636],
            [33.45451190767602, 1.916199619017852],
            [33.45154906084971, 1.913504408465132],
            [33.4478601129658, 1.910628440907305],
            [33.443258730078135, 1.908485505731521],
            [33.44272546137942, 1.906441025308802],
            [33.440621404863066, 1.90181855439039],
            [33.43945460829334, 1.896761582230082],
            [33.43966984194046, 1.894545012728769],
            [33.44039766866175, 1.892654004414382],
            [33.444097611924754, 1.888165745216202],
            [33.44425860619333, 1.887025783094436],
            [33.4449687352052, 1.886283746844391],
            [33.445836346971234, 1.88386797595518],
            [33.4474423918671, 1.881524390917901],
            [33.45007833098172, 1.880718526390759],
            [33.45100080376045, 1.879695976957784],
            [33.452665882343545, 1.879686495852849],
            [33.453625509442425, 1.878926298717584],
            [33.453147743153544, 1.878528356951719],
            [33.45297370355038, 1.87699946155469],
            [33.4514837191926, 1.873887687122642],
            [33.45095220041202, 1.86985286906699],
            [33.45091911905338, 1.867943964316557],
            [33.45150773026182, 1.866704374718486],
            [33.45168640247688, 1.864388299863054],
            [33.45120272437509, 1.862823296259402],
            [33.45121861197919, 1.861221975378629],
            [33.4521398648458, 1.859855643463832],
            [33.45241766705076, 1.858426148150418],
            [33.44968788543002, 1.854681396378104],
            [33.449107945659, 1.852428844498132],
            [33.449883627432094, 1.85096303426742],
            [33.44888976553773, 1.849624332859419],
            [33.44763396029639, 1.845743493442263],
            [33.443367770282286, 1.84393517035102],
            [33.44093061306868, 1.841683077108122],
            [33.43947963805209, 1.839276935580047],
            [33.43840440496265, 1.838327265999972],
            [33.4373999115069, 1.83711521529234],
            [33.43646149363189, 1.834926071009858],
            [33.43683187441342, 1.832854215429985],
            [33.43668971781634, 1.830601546157252],
            [33.43563925756748, 1.829823760457899],
            [33.43553719008658, 1.82834912276048],
            [33.43207792704777, 1.82624201143107],
            [33.430982658832555, 1.826061336152851],
            [33.429498065264795, 1.821574373119669],
            [33.42939484165212, 1.819936887896374],
            [33.42893951797395, 1.819294659558363],
            [33.429690318210305, 1.81712319493556],
            [33.430800342152374, 1.815566842082231],
            [33.43114831266255, 1.813748308569082],
            [33.43085577898518, 1.812373231946712],
            [33.43229371046385, 1.812092429750222],
            [33.43434979245248, 1.809531629582167],
            [33.43405605862593, 1.807839909401545],
            [33.435393713864364, 1.804157452985619],
            [33.434841041555465, 1.800574968931],
            [33.430032360737904, 1.794885543725097],
            [33.42879789497615, 1.79532009339939],
            [33.427959799155424, 1.794225601333496],
            [33.42779760024603, 1.792669552115617],
            [33.428413360338986, 1.792162773984519],
            [33.42894953957927, 1.788722384269158],
            [33.42917890192918, 1.788154763049933],
            [33.428646901651625, 1.786372625527836],
            [33.42844461901592, 1.781577751251112],
            [33.42698723811307, 1.772947232009668],
            [33.42075501053945, 1.76343119083194],
            [33.42105277780164, 1.763195900578685],
            [33.43014797481327, 1.765220337849443],
            [33.435937973450606, 1.764956616164061],
            [33.44335107599102, 1.76348923492016],
            [33.44896412987358, 1.763551208172236],
            [33.45087210931624, 1.764609242588574],
            [33.45222687925747, 1.764509393706669],
            [33.45358457860485, 1.764907128107202],
            [33.455105645569795, 1.764680578992405],
            [33.45984167154548, 1.765294600449939],
            [33.470309694635574, 1.765273868194043],
            [33.47470606041585, 1.769298642103156],
            [33.47579955266173, 1.769271218837868],
            [33.48318920558002, 1.775104579624109],
            [33.48959572248838, 1.781643821826686],
            [33.4936913475829, 1.784962947338573],
            [33.4941472910986, 1.78579514217731],
            [33.49980180762139, 1.789457607567284],
            [33.50230428044099, 1.790262095482166],
            [33.50407518775107, 1.792323246842518],
            [33.50890170192365, 1.793806653774191],
            [33.51864812182072, 1.795160931700854],
            [33.52588129091146, 1.795394069263242],
            [33.532978371524834, 1.793356450182681],
            [33.53615225866249, 1.791917062155031],
            [33.540590082591436, 1.787256610245525],
            [33.546900530070076, 1.783717405029585],
            [33.55235123053301, 1.778341933271861],
            [33.554257442091185, 1.77709289192578],
            [33.558217413492955, 1.775948191914686],
            [33.55841824804437, 1.776531458925503],
            [33.562757464802885, 1.779450178684371],
            [33.56828952837606, 1.784533675639475],
            [33.570238028126234, 1.785557131501964],
            [33.57120965132742, 1.786972959702546],
            [33.57515376117621, 1.790874859484484],
            [33.5776839227678, 1.792225819235596],
            [33.57852550405184, 1.796882772953601],
            [33.58058632375525, 1.800574106076272],
            [33.581595555824116, 1.806369567106108],
            [33.583211934040705, 1.810012161819462],
            [33.581904602333, 1.813196124964017],
            [33.58208567754146, 1.825581912554412],
            [33.58700260984235, 1.826586368158964],
            [33.587449923243135, 1.830520759692214],
            [33.59059225705644, 1.835243362939575],
            [33.59180069772608, 1.836120498327533],
            [33.59238221583707, 1.837576836760587],
            [33.59363957067226, 1.838526328067172],
            [33.5940651942505, 1.84095072303367],
            [33.59341479152691, 1.841900853610057],
            [33.59245268956939, 1.845076596964569],
            [33.592090406201834, 1.854033035679366],
            [33.5899907810748, 1.855037934954455],
            [33.585010164508475, 1.859662513138563],
            [33.585135464219256, 1.863027879091058],
            [33.584678585557306, 1.864665501577069],
            [33.58477675794313, 1.865859645798958],
            [33.58091282722505, 1.865797607816988],
            [33.57733365796041, 1.864371300165288],
            [33.57857074320953, 1.866069789491741],
            [33.577536326871666, 1.872545441411558],
            [33.57730694475882, 1.876835314278155],
            [33.578047836577596, 1.879011102567455],
            [33.57771316472692, 1.881263088868635],
            [33.577921784976944, 1.882572248221146],
            [33.57871543485235, 1.883982412434169],
            [33.580794568509454, 1.885456343806891],
            [33.58274135427406, 1.887735481067899],
            [33.58414669577253, 1.890819962006548],
            [33.584923974750225, 1.894474602657243],
            [33.58473118461216, 1.895478632067845],
            [33.58288546740185, 1.897925170435079],
            [33.58141316188882, 1.898678258382572],
            [33.577533116292834, 1.898773641203318],
            [33.572928149127186, 1.897881485085997],
            [33.569523782135406, 1.898161825651455],
            [33.56825863082187, 1.90124063624243],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 727,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "KATINE",
        Population: 35072,
        Key: "SOROTIKATINE",
        Dist2: "Soroti",
        "Sub Country": "Katine",
        id2_original: "SorotiKatine",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.27144402212626, 1.957129754320843],
            [33.27064434365697, 1.957102819684994],
            [33.267081998040965, 1.954709202293412],
            [33.265825687048135, 1.954590436903133],
            [33.26430324296587, 1.953876882848687],
            [33.26327610118517, 1.954278555389403],
            [33.26201237909125, 1.954033387015171],
            [33.26024674579022, 1.955163748318531],
            [33.26001039634402, 1.95460685214332],
            [33.2590991569979, 1.955007713802859],
            [33.25764090472919, 1.953880491078763],
            [33.25469095860869, 1.953656812222667],
            [33.24963614299654, 1.952378924434092],
            [33.24875060355238, 1.951309017833453],
            [33.248482201318545, 1.949056313778739],
            [33.24938807862073, 1.946680850952327],
            [33.25008673434981, 1.945603419881952],
            [33.25147390742164, 1.944590744495337],
            [33.25194761242715, 1.943496877888015],
            [33.25155704829781, 1.941337394508495],
            [33.24727141694431, 1.935702863448026],
            [33.24482985888413, 1.933767127062261],
            [33.24356114485218, 1.927642369237328],
            [33.24213315952034, 1.923860852523924],
            [33.23924036331992, 1.921988492534348],
            [33.23710474269943, 1.921364544161738],
            [33.23244880422627, 1.922070860306788],
            [33.23109431815265, 1.92179417683138],
            [33.230027703500056, 1.921564553825449],
            [33.22721808770167, 1.919637880029318],
            [33.222310293063856, 1.91100750859935],
            [33.22131194857621, 1.910026683310114],
            [33.220606790841146, 1.909922064378861],
            [33.2228925675563, 1.907117138730796],
            [33.225603898679445, 1.905434001762693],
            [33.229246109914065, 1.901371326618537],
            [33.23183722219768, 1.90013151390861],
            [33.235685564450634, 1.899551970138806],
            [33.23599514905041, 1.899072427374834],
            [33.23844057884944, 1.888722108201977],
            [33.238452711495675, 1.887849666798626],
            [33.237766075225096, 1.887117832920631],
            [33.23767508486996, 1.885405606595133],
            [33.23847930162806, 1.874576430493043],
            [33.23715869731203, 1.872673588580368],
            [33.23708723094128, 1.871955475352774],
            [33.237551043698886, 1.871273196270751],
            [33.239387704992815, 1.870448365608997],
            [33.240073262386744, 1.865153959472668],
            [33.240671980540455, 1.862674946958389],
            [33.24152992284076, 1.86136298674511],
            [33.24398293891238, 1.859403527857677],
            [33.245944719355705, 1.858905500958277],
            [33.24722758005675, 1.857840134151608],
            [33.24826039290187, 1.857762251650003],
            [33.25011032410915, 1.856301337290195],
            [33.25280207016248, 1.855605404910264],
            [33.25726041610409, 1.85517941459168],
            [33.25760989668221, 1.853599496797433],
            [33.258738864297, 1.851781484073149],
            [33.262506965435556, 1.848153048825238],
            [33.26472704386243, 1.845011392436033],
            [33.2651058795874, 1.842615502574445],
            [33.26464088824013, 1.841371030673059],
            [33.26489037734401, 1.839881620258422],
            [33.26547557136112, 1.838715354812002],
            [33.26917765441112, 1.8346799456884],
            [33.27157147150549, 1.832407647092906],
            [33.27773281571497, 1.829303517672469],
            [33.280919082535554, 1.825657012200945],
            [33.28290085318891, 1.824182011938714],
            [33.28897276562026, 1.820887874500039],
            [33.29420473170142, 1.815295880975889],
            [33.29951867803538, 1.81292464992341],
            [33.30280629368464, 1.810924679162175],
            [33.302861934435015, 1.810829128193597],
            [33.30382392859469, 1.811566386119935],
            [33.30427050447862, 1.814738000891527],
            [33.30388491791425, 1.820632623182563],
            [33.30260683894546, 1.824163589646496],
            [33.30277003139157, 1.829326579141473],
            [33.30306592207312, 1.831135957640393],
            [33.306627533765486, 1.841326097698623],
            [33.306533030099274, 1.842456547064498],
            [33.3046566632698, 1.844574809434888],
            [33.30469088099728, 1.846461538323433],
            [33.3028411222665, 1.850041047060546],
            [33.303181585555826, 1.852462106992063],
            [33.305101731780674, 1.85457971187359],
            [33.3121061161382, 1.860538153231242],
            [33.31347517647897, 1.861233967845573],
            [33.3146460801462, 1.862404426661964],
            [33.31749882136639, 1.863831267428549],
            [33.318235996854845, 1.864693634482898],
            [33.31889325192742, 1.866603914661177],
            [33.320836632178796, 1.867214251776307],
            [33.32334964313497, 1.869889148862137],
            [33.32403326376112, 1.873177996087274],
            [33.323594587661795, 1.875387091389215],
            [33.32386316955871, 1.876761537512681],
            [33.32300993263387, 1.879682502296546],
            [33.32301350523377, 1.88130484519675],
            [33.32514062240177, 1.883994396664887],
            [33.33044512834041, 1.889361297340526],
            [33.33351883176434, 1.89198140121687],
            [33.342634001918, 1.894983249661265],
            [33.352436957287466, 1.900282305688955],
            [33.35101308354471, 1.899949677245966],
            [33.35028704716577, 1.900283481834778],
            [33.349773041939976, 1.903044873452051],
            [33.347579635392194, 1.904880354666304],
            [33.3452361688695, 1.905831703024433],
            [33.344715191818764, 1.912588881779301],
            [33.345262772476644, 1.914490761402171],
            [33.346805390025224, 1.917018092039865],
            [33.3473032246776, 1.918894954613693],
            [33.34678116336033, 1.920221449990623],
            [33.34337365945156, 1.92057250925468],
            [33.34225449604978, 1.921148337975953],
            [33.33600331222709, 1.921458967759495],
            [33.33504465351208, 1.921780701600874],
            [33.33331931683805, 1.923645999652542],
            [33.3331947717121, 1.924420418128281],
            [33.33463494538572, 1.929009156741448],
            [33.33681095515968, 1.934576049794937],
            [33.33327615728021, 1.949999498940292],
            [33.33249201427545, 1.949530263587182],
            [33.32926447974901, 1.949349960240786],
            [33.32730687377679, 1.951223097114176],
            [33.32638912613646, 1.951132805927049],
            [33.32544698654121, 1.952770516906503],
            [33.32284637547178, 1.954227607443575],
            [33.32115954238744, 1.952662782569766],
            [33.31812626045638, 1.951487238087175],
            [33.31140079131648, 1.947706807082122],
            [33.30717677271334, 1.94711047721103],
            [33.303301570833376, 1.945518888662084],
            [33.29643443198329, 1.944389225652478],
            [33.293452150105814, 1.942272719265843],
            [33.2890875837883, 1.944598595738413],
            [33.285105226369666, 1.946136756351713],
            [33.28448821043194, 1.946861283867165],
            [33.28358150488307, 1.949587029388846],
            [33.281679624102864, 1.950943108230044],
            [33.280169793265514, 1.953246377070306],
            [33.279275736894135, 1.953284950760648],
            [33.278607191795075, 1.953863127762065],
            [33.27661464405326, 1.954018785311085],
            [33.27580275747924, 1.955204097797975],
            [33.27422979214542, 1.956170546681033],
            [33.27274299501025, 1.957000127622418],
            [33.27144402212626, 1.957129754320843],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 728,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "OTUBOI",
        Population: 25953,
        Key: "KABERAMAIDOOTUBOI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.8105973390549, 1.71524694651538],
            [33.80543561224582, 1.7223234136317],
            [33.804478454615634, 1.724304979331656],
            [33.80485281223894, 1.725996493657097],
            [33.80841434038798, 1.730880014395448],
            [33.809188892978796, 1.732887976744253],
            [33.809002785408126, 1.733910297258071],
            [33.80675309761116, 1.735367731321449],
            [33.80038469442365, 1.735108112447656],
            [33.79836137309517, 1.736429747675276],
            [33.79584621606376, 1.73997700622587],
            [33.79307240890925, 1.747115800184009],
            [33.79264779234242, 1.750182712669265],
            [33.789659586075686, 1.755249975917197],
            [33.788941869892895, 1.76147421464074],
            [33.789347702687145, 1.773786211300667],
            [33.788522503978946, 1.779585318013753],
            [33.78643658265153, 1.784444142674722],
            [33.77959581564324, 1.797048759238419],
            [33.7779877693009, 1.803906648256016],
            [33.77706057767199, 1.803771350900164],
            [33.775395571852414, 1.80221607839883],
            [33.77159651836248, 1.804759756631905],
            [33.76944877138396, 1.807040380084286],
            [33.768189653155865, 1.807285171356623],
            [33.76764372449982, 1.807855331184823],
            [33.766266054705376, 1.808127310688663],
            [33.76363015062505, 1.809422074502882],
            [33.76263323086546, 1.810517119498694],
            [33.76111288255272, 1.8109067622336],
            [33.75902465255508, 1.813133076847709],
            [33.75580496391434, 1.813197759977102],
            [33.75343034561418, 1.814537636978302],
            [33.75162964298276, 1.819106869817964],
            [33.75007876991669, 1.820446401248378],
            [33.74969214759484, 1.820374190704165],
            [33.747979442132, 1.821713789430359],
            [33.74505825288039, 1.822140194467439],
            [33.742234697025445, 1.823606903765597],
            [33.738976050247466, 1.824666696470933],
            [33.73445134845076, 1.826957334657738],
            [33.734041281896594, 1.827274131482498],
            [33.73397024581889, 1.828079302060936],
            [33.7303522998767, 1.83137372620141],
            [33.72953446376058, 1.833527137494153],
            [33.72816015815686, 1.835255589024155],
            [33.72720971094185, 1.837418101673497],
            [33.72211972898126, 1.841255918935588],
            [33.720121029576404, 1.845553845233579],
            [33.716722798976285, 1.850404183949557],
            [33.70348739348262, 1.840711582931343],
            [33.70220626024186, 1.839391290555719],
            [33.70108867248509, 1.835257441297975],
            [33.699334440601625, 1.832571294793995],
            [33.68950624796254, 1.824614114209477],
            [33.68491821493834, 1.824670160413997],
            [33.68076616127094, 1.826046835728467],
            [33.673110827115835, 1.824354092192551],
            [33.67143716063862, 1.820308873043367],
            [33.67195997654071, 1.817512538157018],
            [33.669977701932474, 1.813837454911302],
            [33.66811403099291, 1.811911219722472],
            [33.665851635627945, 1.810613475870207],
            [33.66323834393998, 1.80791254872919],
            [33.66210236587271, 1.80235159495078],
            [33.66005298711276, 1.795883975445916],
            [33.658785008801026, 1.789486352207631],
            [33.65719602560733, 1.786219924187912],
            [33.65406438533917, 1.776586962491242],
            [33.65297146801506, 1.768670228835779],
            [33.65311055866208, 1.766694723949321],
            [33.654103789939114, 1.763834673752561],
            [33.654595123483766, 1.756471066170167],
            [33.65621995754213, 1.753137041193994],
            [33.65636759565906, 1.750816664103024],
            [33.65811089774044, 1.746738301513348],
            [33.6590851395307, 1.746039024813664],
            [33.66119775339844, 1.740337945368121],
            [33.661397596209824, 1.736159677357553],
            [33.661111692099276, 1.734831328316474],
            [33.661795356742886, 1.734238670588354],
            [33.66267183308414, 1.732007080190748],
            [33.66430402793795, 1.728981287408549],
            [33.66717793166961, 1.727506052815631],
            [33.67310485242087, 1.728137863177069],
            [33.67657723625271, 1.727874267381447],
            [33.680099446040096, 1.728687197031598],
            [33.68366428717594, 1.727964841036899],
            [33.68425713573759, 1.725832664999859],
            [33.684110689685035, 1.723755330840746],
            [33.6845610420864, 1.722968110710786],
            [33.68495209310264, 1.719936786782],
            [33.68452770650454, 1.715278007113903],
            [33.685423937697195, 1.713070783627979],
            [33.68508860378817, 1.711804376365399],
            [33.683851208620275, 1.711442955912228],
            [33.68456341274044, 1.710700876076845],
            [33.684229577221295, 1.710483876969041],
            [33.684751925999436, 1.709913751137263],
            [33.68484261362231, 1.70738066133575],
            [33.687513914019775, 1.704539058934199],
            [33.68980034291185, 1.702900536963938],
            [33.69485764146745, 1.700316954190643],
            [33.69276004024474, 1.695914725188486],
            [33.6914335295057, 1.694893946767571],
            [33.68954839422073, 1.691619745864929],
            [33.687213496727516, 1.689177990540916],
            [33.68559380911743, 1.688156298078206],
            [33.685331107592376, 1.687287914240282],
            [33.683020576901235, 1.68540703266781],
            [33.681864251992764, 1.683842372389365],
            [33.68019744594938, 1.683028761119108],
            [33.67957732453573, 1.681952428292206],
            [33.67795819747436, 1.680903584062009],
            [33.676766525656134, 1.679465583891574],
            [33.67532018055652, 1.677460529874638],
            [33.67416537559751, 1.674407260027932],
            [33.67370479048674, 1.670940193559369],
            [33.671545508241664, 1.670640445442078],
            [33.67011392785205, 1.669689250852269],
            [33.66612981332872, 1.664654831792884],
            [33.666129476460476, 1.663652947584902],
            [33.66697283191721, 1.662708655653668],
            [33.66756965462568, 1.661200479102702],
            [33.66900870360853, 1.65922968885707],
            [33.66975041199594, 1.656317604373796],
            [33.6673865447331, 1.651035152164701],
            [33.66693072248997, 1.648909338970698],
            [33.66750367696133, 1.643399722733495],
            [33.670261512968416, 1.635564379706106],
            [33.67066333837814, 1.627377012146517],
            [33.66989364746966, 1.622446835823026],
            [33.6680181232599, 1.618169705706625],
            [33.66760840435378, 1.615871982285922],
            [33.6686333838896, 1.603512573035498],
            [33.668347097096756, 1.599115984546913],
            [33.666078438677616, 1.592117811044452],
            [33.66461548462674, 1.590664687396475],
            [33.66441636226422, 1.58906579259631],
            [33.66396485552768, 1.588684369106611],
            [33.66295281981681, 1.585759326805861],
            [33.662247422231516, 1.574096586196507],
            [33.68119872882634, 1.572804069251769],
            [33.708141623360135, 1.570225794735228],
            [33.70961717089299, 1.570677620377507],
            [33.713118358306104, 1.573381349752838],
            [33.714894007822565, 1.575705709702848],
            [33.715849436195846, 1.584761007924906],
            [33.71659136197551, 1.587239512453389],
            [33.71713941694382, 1.587981140858],
            [33.71932994439111, 1.58930117381858],
            [33.72323371000218, 1.591109112919044],
            [33.724331108122946, 1.593044690316019],
            [33.723370918678675, 1.594664365485531],
            [33.72228914136238, 1.595632731480439],
            [33.71683761175445, 1.59906330720012],
            [33.71393014067555, 1.602574403897458],
            [33.71215398900084, 1.607016901346864],
            [33.71217692927825, 1.613204759541516],
            [33.71298957313205, 1.615402793756729],
            [33.714871902080056, 1.617356188787019],
            [33.72738732853478, 1.633490763167877],
            [33.735375038446726, 1.651381886286001],
            [33.738519404249196, 1.66100622103826],
            [33.741527779490696, 1.667455257453937],
            [33.743388010781075, 1.670177552619009],
            [33.744734105691606, 1.671316900787068],
            [33.74657903418109, 1.672184659578847],
            [33.751537712989865, 1.67277982187412],
            [33.76110504744685, 1.672586129751719],
            [33.77233407563492, 1.670265814107138],
            [33.782852903844194, 1.6708948703755],
            [33.78830700353215, 1.669825194444117],
            [33.78985127308259, 1.669127994511433],
            [33.792179701807434, 1.667951017122782],
            [33.79802297323604, 1.663669688715261],
            [33.798624806747185, 1.663886556559276],
            [33.799783415173074, 1.665433018142637],
            [33.804116765034486, 1.67312971918428],
            [33.807054791409456, 1.676059530907093],
            [33.81175138942905, 1.67886194986587],
            [33.81178115510597, 1.681548709832227],
            [33.8124542887995, 1.684325663782842],
            [33.81580234310107, 1.693587728922172],
            [33.81559854860079, 1.696654532693217],
            [33.81513530447674, 1.697351298964021],
            [33.81431005007299, 1.697641132618664],
            [33.811215883026925, 1.697669583245206],
            [33.80788782881683, 1.695988361059941],
            [33.802458716666806, 1.695049812598731],
            [33.800112820201235, 1.696136358315147],
            [33.798721819407966, 1.697928124310286],
            [33.79851653011104, 1.698787617560756],
            [33.798955771250675, 1.699818724495487],
            [33.8004006476048, 1.700596111136033],
            [33.80308246368095, 1.700676405800752],
            [33.80767200228159, 1.699869348325591],
            [33.80932224967934, 1.699995301350169],
            [33.81265039911085, 1.701884583161734],
            [33.81455029012268, 1.706434096427509],
            [33.814696037285955, 1.710957216398981],
            [33.8138963067144, 1.710496193669172],
            [33.81193643968263, 1.710316103338224],
            [33.810853985036616, 1.710940763906271],
            [33.81026162965004, 1.711927070975406],
            [33.8105973390549, 1.71524694651538],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 729,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "GWERI",
        Population: 47898,
        Key: "SOROTIGWERI",
        Dist2: "Soroti",
        "Sub Country": "Gweri",
        id2_original: "SorotiGweri",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.66697283191721, 1.662708655653668],
            [33.664805189950116, 1.662416741683215],
            [33.66293075270184, 1.662745121775045],
            [33.65992265863303, 1.660972947053824],
            [33.65638552962538, 1.660715982368446],
            [33.65104982070536, 1.661896652804026],
            [33.6484115037502, 1.66434918417465],
            [33.64658050723243, 1.664811171453016],
            [33.64347560621701, 1.664866476234423],
            [33.64199838063121, 1.665576428364272],
            [33.63970801532158, 1.668187120049696],
            [33.63603287364526, 1.669188813384912],
            [33.63488730246905, 1.670606469436349],
            [33.63442257792146, 1.673539785067841],
            [33.63494686256904, 1.676603445325083],
            [33.6374540820866, 1.681204194415642],
            [33.63653839967306, 1.68171381102872],
            [33.632859060169444, 1.682046595821316],
            [33.62841023816647, 1.680390149243425],
            [33.62544453559592, 1.679838476872286],
            [33.61966696604886, 1.680108895422142],
            [33.614009646782364, 1.679178878607034],
            [33.61117741230346, 1.679867327337964],
            [33.608953470222545, 1.679831840277382],
            [33.60660116787071, 1.678988156570775],
            [33.60469895201892, 1.677723205901379],
            [33.60095981256512, 1.678356240299724],
            [33.59783236114113, 1.677693876807252],
            [33.59682343988936, 1.678021215440879],
            [33.59557257358547, 1.67915748723184],
            [33.594716122488514, 1.679118319545148],
            [33.59432263524125, 1.678588030115206],
            [33.592291971083625, 1.679945563010419],
            [33.58943646844221, 1.679928339830856],
            [33.588241457586044, 1.680326762640676],
            [33.58724916325185, 1.680308969279605],
            [33.58177918494293, 1.67832936615549],
            [33.57950121189262, 1.678022456380216],
            [33.5755329849734, 1.679281145593787],
            [33.5700672817469, 1.682340590064872],
            [33.568402506794385, 1.682675812624873],
            [33.568131852484136, 1.683281688494542],
            [33.56505414257403, 1.682676833568902],
            [33.560630216480845, 1.681137266408822],
            [33.553441671201895, 1.679791085065324],
            [33.551697928946, 1.680262399089109],
            [33.54682850494723, 1.682660666376723],
            [33.544148945439055, 1.682875430071873],
            [33.54166040099796, 1.681699084105655],
            [33.53806493449744, 1.676692294668591],
            [33.53619312482138, 1.675472963707318],
            [33.53434285764418, 1.675259465281994],
            [33.53002589664681, 1.675988276492648],
            [33.52777149449125, 1.675539471676222],
            [33.522601280399364, 1.672483808539371],
            [33.51613887031403, 1.669870972905105],
            [33.5092371768682, 1.66765628980116],
            [33.50613065888527, 1.66611007240549],
            [33.502128529547214, 1.662483283317379],
            [33.498552976001626, 1.661452844488538],
            [33.495629493351096, 1.661535008473395],
            [33.49207876744331, 1.660920710416997],
            [33.48798397868035, 1.65967325343251],
            [33.48516851844272, 1.658036451965982],
            [33.479560065731064, 1.657024568538343],
            [33.47354333590929, 1.654547156023494],
            [33.46725606227004, 1.650848442105873],
            [33.46526028777972, 1.64865049512259],
            [33.463657154323705, 1.645927728561593],
            [33.48287718654585, 1.634931069432377],
            [33.483913139002844, 1.634270389446677],
            [33.48414555113316, 1.633410871636411],
            [33.48677804251369, 1.631401804789846],
            [33.490101191024024, 1.629853962673529],
            [33.495625995311364, 1.62921026668249],
            [33.50985748333482, 1.625642196817829],
            [33.526097205481584, 1.623628826411596],
            [33.531840833083905, 1.620916487997947],
            [33.53479601548418, 1.620036033137614],
            [33.538627755972406, 1.619238518553037],
            [33.54347116296391, 1.6193545444163],
            [33.54496393659067, 1.618793497512876],
            [33.54780404390473, 1.618481258165226],
            [33.55178697175359, 1.615724766546166],
            [33.553164253475856, 1.615377499170088],
            [33.55325502733699, 1.608179518414091],
            [33.55560449730075, 1.602081845486984],
            [33.55899128605906, 1.595529024376364],
            [33.55895178444106, 1.590241541854853],
            [33.559407768380964, 1.586907997841654],
            [33.56004444125378, 1.585818210371859],
            [33.565307820522065, 1.582002044661567],
            [33.56817473715747, 1.580499647489484],
            [33.57459573580654, 1.574834555554738],
            [33.57596612565395, 1.573952927944287],
            [33.576689504816265, 1.573914411044178],
            [33.58251591037543, 1.564198580454596],
            [33.58377204529847, 1.56275305667727],
            [33.58815245969421, 1.55989642580361],
            [33.593492618868176, 1.557291463511705],
            [33.59557867673948, 1.55649303929862],
            [33.60070950419773, 1.555839106717371],
            [33.60117128855943, 1.555639944608135],
            [33.60628861344063, 1.557619715065632],
            [33.608931471379556, 1.559292600812586],
            [33.61136159927607, 1.561680240106968],
            [33.61565180844424, 1.567197507353485],
            [33.618438667221554, 1.569376949469281],
            [33.619294989859384, 1.569584769480032],
            [33.626403859962544, 1.56882270909363],
            [33.62949576325413, 1.568966521253049],
            [33.63177982598372, 1.569445304476035],
            [33.63250651543789, 1.570168822522921],
            [33.63452936874411, 1.570810522878223],
            [33.635079380243134, 1.572538280659233],
            [33.6363872437535, 1.572130775979572],
            [33.63786217144879, 1.572365537721648],
            [33.64016847556652, 1.572075330380414],
            [33.640906286163876, 1.572409831336527],
            [33.64164334397304, 1.572120108011162],
            [33.646296596483545, 1.574000377912287],
            [33.662247422231516, 1.574096586196507],
            [33.66295281981681, 1.585759326805861],
            [33.66396485552768, 1.588684369106611],
            [33.66441636226422, 1.58906579259631],
            [33.66461548462674, 1.590664687396475],
            [33.666078438677616, 1.592117811044452],
            [33.668347097096756, 1.599115984546913],
            [33.6686333838896, 1.603512573035498],
            [33.66760840435378, 1.615871982285922],
            [33.6680181232599, 1.618169705706625],
            [33.66989364746966, 1.622446835823026],
            [33.67066333837814, 1.627377012146517],
            [33.670261512968416, 1.635564379706106],
            [33.66750367696133, 1.643399722733495],
            [33.66693072248997, 1.648909338970698],
            [33.6673865447331, 1.651035152164701],
            [33.66975041199594, 1.656317604373796],
            [33.66900870360853, 1.65922968885707],
            [33.66756965462568, 1.661200479102702],
            [33.66697283191721, 1.662708655653668],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 730,
        District: "SOROTI",
        County: "SOROTI",
        Subcounty: "ASURET",
        Population: 39638,
        Key: "SOROTIASURET",
        Dist2: "Soroti",
        "Sub Country": "Asuret",
        id2_original: "SorotiAsuret",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.60009709482079, 2.142515641763678],
            [33.59882270163958, 2.142966124522779],
            [33.59817162428124, 2.143789634556738],
            [33.59757698807217, 2.143780821967858],
            [33.596544328838995, 2.144713042240619],
            [33.595370624224756, 2.144888602683145],
            [33.59502191170618, 2.146118437264775],
            [33.5941809215136, 2.146394261784646],
            [33.59377047497206, 2.14722746855676],
            [33.59265559922914, 2.14740500720707],
            [33.591104231191366, 2.148514154264198],
            [33.5911566478882, 2.149176634872523],
            [33.590374059867194, 2.148737459370895],
            [33.58998291632448, 2.148908155701733],
            [33.58998973184256, 2.1496756049198],
            [33.58845784467, 2.150587959472488],
            [33.58854954199926, 2.151670228518164],
            [33.58802132362905, 2.151447412179642],
            [33.588125855188764, 2.151991804180548],
            [33.58706345992307, 2.15301548596986],
            [33.58700503439528, 2.153684569758082],
            [33.58598148138415, 2.153986699439403],
            [33.58553837030225, 2.154669051411492],
            [33.58412992153123, 2.154433456134838],
            [33.582363440220576, 2.155719785667863],
            [33.58085070423158, 2.155582619331319],
            [33.58030322687996, 2.15616005881505],
            [33.58040780874535, 2.156842199756145],
            [33.57972982325096, 2.157144193261285],
            [33.57856260267643, 2.15686914448488],
            [33.577837657750564, 2.15785146695762],
            [33.578655499256605, 2.158327837813486],
            [33.57808005914684, 2.158431156956393],
            [33.57787556845221, 2.159684287006642],
            [33.57595232663286, 2.160430508818111],
            [33.57480914407704, 2.160153370844502],
            [33.57510893704017, 2.160755989317684],
            [33.57452573728298, 2.161192400998206],
            [33.57458108428429, 2.161628569283072],
            [33.573445992854175, 2.161906575937669],
            [33.5734621319866, 2.162897908710814],
            [33.57279240560292, 2.163841917220231],
            [33.57212219323071, 2.163493221713341],
            [33.57208303836242, 2.164191138684187],
            [33.56967134389555, 2.165801988735216],
            [33.569285300987026, 2.166444522696282],
            [33.56676295833167, 2.167317853433103],
            [33.56677179416082, 2.169871541527345],
            [33.56598363209345, 2.170339751471396],
            [33.56573160704557, 2.170990165052653],
            [33.56663111259744, 2.173139051142801],
            [33.56514160075348, 2.174337152717854],
            [33.56583580892358, 2.174723215655911],
            [33.565970062142796, 2.175621312750564],
            [33.565635421733155, 2.176033089943333],
            [33.566067515876384, 2.177589713699872],
            [33.56652907835419, 2.178360449122032],
            [33.567615544876276, 2.179003709338309],
            [33.56718431581066, 2.179767297723651],
            [33.56774995170739, 2.18030597039906],
            [33.567876856707585, 2.181443575375152],
            [33.56747550111674, 2.18250653427298],
            [33.56659764047163, 2.182641589556489],
            [33.56644956577344, 2.184572661010388],
            [33.56461234752404, 2.185763402534997],
            [33.565110966405655, 2.186144925760981],
            [33.564426791518954, 2.186946033645826],
            [33.56375727534107, 2.187155853807236],
            [33.56351165078957, 2.186871534065923],
            [33.56227740960663, 2.188990131088622],
            [33.56056649718113, 2.189739232459869],
            [33.560269372214364, 2.191011720546601],
            [33.559681586557666, 2.190937095496537],
            [33.55969667825447, 2.191505916505154],
            [33.55883382396617, 2.192000222712513],
            [33.55851381711251, 2.191760837064811],
            [33.558454969376555, 2.19357212419983],
            [33.55737610260181, 2.19338541511997],
            [33.55672892932166, 2.193670071144033],
            [33.55697456195799, 2.193976846274573],
            [33.55663248888771, 2.194426048017742],
            [33.555695085210616, 2.194523699577033],
            [33.55516702584223, 2.195010393560844],
            [33.555070065283715, 2.194359272246806],
            [33.55438563617381, 2.194494250161848],
            [33.554155360237225, 2.195482299403459],
            [33.55353782866653, 2.195452591482269],
            [33.553069381500364, 2.196193739084408],
            [33.55207243748626, 2.19623901772176],
            [33.55173787612836, 2.196890299794692],
            [33.5511350984879, 2.196516295374003],
            [33.550354163367004, 2.197242588056743],
            [33.54963988324018, 2.197138069615372],
            [33.547869443952386, 2.197917120736564],
            [33.546931952240385, 2.197782743661601],
            [33.54457385934821, 2.198868875570081],
            [33.54244582410202, 2.198353220032918],
            [33.5417987119073, 2.198824985682994],
            [33.540658721963986, 2.198703071716992],
            [33.54041682901416, 2.199461076535757],
            [33.53802297598715, 2.201965779868165],
            [33.53845365348719, 2.202412252141303],
            [33.537336978418736, 2.202358522300312],
            [33.536393600945026, 2.203783403707123],
            [33.53528899653908, 2.202501089136605],
            [33.535838095349746, 2.201955558305173],
            [33.53556810399615, 2.20123543927702],
            [33.535944144164, 2.200424054636229],
            [33.53529858246147, 2.199234454922255],
            [33.53699636061921, 2.193337616672577],
            [33.53706738771378, 2.189657305785222],
            [33.53818254642602, 2.186995453472816],
            [33.538543553287575, 2.1850512182263],
            [33.54229285089058, 2.179331907562095],
            [33.543449318631154, 2.176628456123483],
            [33.54288033561166, 2.174954861629903],
            [33.54331404223085, 2.174029435513212],
            [33.54478100097129, 2.17263580243455],
            [33.5447591799947, 2.16942336118095],
            [33.54517210858134, 2.168196451206366],
            [33.54617420173868, 2.167302007714961],
            [33.54752710677737, 2.164879184509157],
            [33.547588670120426, 2.163652402811505],
            [33.54710271299277, 2.162945631821637],
            [33.547432957047384, 2.161697959639675],
            [33.54699857040357, 2.160710471729371],
            [33.54830012055409, 2.159181747481947],
            [33.54792742122082, 2.157310553760601],
            [33.548298985083555, 2.156765722900465],
            [33.54687199149182, 2.153418773651316],
            [33.547187278596965, 2.152543772418135],
            [33.54682933049896, 2.151788959514913],
            [33.547292045515285, 2.151330182978462],
            [33.54730574212843, 2.150405902257759],
            [33.548735944502404, 2.148973112081588],
            [33.5488196629953, 2.147738363180566],
            [33.54958407450484, 2.147632253309959],
            [33.54912798546204, 2.147004475623612],
            [33.55140667446963, 2.145246821508589],
            [33.552415649620336, 2.142635909414509],
            [33.55366365029849, 2.141633570381175],
            [33.55413281611687, 2.139622573310119],
            [33.55468492967363, 2.139529469493586],
            [33.55489392002953, 2.13743942444659],
            [33.55597427980431, 2.135469702219025],
            [33.55551025773924, 2.13530231687236],
            [33.55569444201689, 2.134715807314305],
            [33.55485500231647, 2.132651596710656],
            [33.55498545296711, 2.131508586148565],
            [33.55573485183162, 2.131298870515402],
            [33.555281893417614, 2.128803664690175],
            [33.55631012485473, 2.126553268382918],
            [33.55836768726694, 2.124513478587553],
            [33.55853604143263, 2.123409914044659],
            [33.55916401502022, 2.122985260429711],
            [33.56002467202932, 2.117854127383836],
            [33.5597335684699, 2.116524369410592],
            [33.55745481747858, 2.114770907789915],
            [33.55649776495128, 2.112517086976883],
            [33.55294277923243, 2.109941999895266],
            [33.552717188010064, 2.10855903702767],
            [33.55140653253583, 2.107872027062574],
            [33.55114897476409, 2.107022882671448],
            [33.54962151448927, 2.107063864833268],
            [33.548045592799795, 2.106465914050971],
            [33.54617990244746, 2.104848977271797],
            [33.54504549283869, 2.102366365044468],
            [33.545189664356954, 2.100821509352991],
            [33.54435310375703, 2.099463021702181],
            [33.54432051287854, 2.09820939472945],
            [33.54338752352276, 2.096964171147598],
            [33.54318576011331, 2.094699604976918],
            [33.5417455397273, 2.091246534995787],
            [33.5412548727326, 2.090454083203491],
            [33.539815577611336, 2.089678134656845],
            [33.53942105909814, 2.0879393528991],
            [33.5381581059621, 2.085618534226307],
            [33.53835070116574, 2.084599379080112],
            [33.53742767592309, 2.084192117220424],
            [33.537326968491556, 2.081416277001717],
            [33.53846660090539, 2.079344158620303],
            [33.53889353332899, 2.077100394292418],
            [33.53989025545924, 2.0762315542003],
            [33.54067353069144, 2.074060042585005],
            [33.54269924872511, 2.071390526761846],
            [33.543943027321426, 2.064921608259465],
            [33.54600779781545, 2.063093434434397],
            [33.549007279735655, 2.05826138647774],
            [33.549341233832415, 2.056976621121982],
            [33.551632483982594, 2.05412515539412],
            [33.55461227662841, 2.051866470928001],
            [33.55647850058003, 2.049229026478797],
            [33.55740325148632, 2.048504878073478],
            [33.557762556938705, 2.047298377196211],
            [33.55796450450279, 2.036854545794606],
            [33.55551416091914, 2.034459881019199],
            [33.55522267018587, 2.033615519998877],
            [33.55520380825985, 2.028548747599535],
            [33.556641791840775, 2.025945926313412],
            [33.556729757568355, 2.023844741239829],
            [33.55965823125859, 2.022395508275521],
            [33.561468523405686, 2.021995372212178],
            [33.565196260543566, 2.019678284887174],
            [33.56524393413569, 2.015208308665048],
            [33.56590917163788, 2.012565497671739],
            [33.56549010576122, 2.011569889221629],
            [33.567525834620405, 2.009309582236753],
            [33.568802991019425, 2.003581549223033],
            [33.569602901254065, 2.00225833752817],
            [33.569441627609415, 1.998784259955564],
            [33.56844652783659, 1.997737764740705],
            [33.5668672671092, 1.993665981838126],
            [33.566318387487456, 1.993493615982626],
            [33.56725361544491, 1.990975973383873],
            [33.566724786220306, 1.989245442334584],
            [33.56653342350522, 1.986205585110062],
            [33.56565274484508, 1.984961195870258],
            [33.564439195456416, 1.984291394499116],
            [33.56313010215243, 1.982496612380731],
            [33.5612263205371, 1.980917459450879],
            [33.56120972955211, 1.980205785834671],
            [33.56469944817401, 1.976219379979715],
            [33.56525304844258, 1.974708372589103],
            [33.566025007597126, 1.974120065045218],
            [33.56612015535539, 1.972971086677075],
            [33.567104624465145, 1.972626970106715],
            [33.56737332314305, 1.97118843483816],
            [33.568749499039185, 1.970871323238396],
            [33.569062900580555, 1.970337454174704],
            [33.571568188720256, 1.965378939967117],
            [33.57205816221557, 1.961877657422084],
            [33.5728527005248, 1.959950414574787],
            [33.574395097986155, 1.957661041068903],
            [33.57787007255929, 1.955262437237833],
            [33.58253104698795, 1.955224627614171],
            [33.58428143498031, 1.95478976929769],
            [33.58966133562244, 1.950418280786193],
            [33.59074746437795, 1.949974604878336],
            [33.59412966723674, 1.950769521436886],
            [33.59680070981771, 1.952387940977202],
            [33.59962697409326, 1.952739751315417],
            [33.60414049096633, 1.950584995894521],
            [33.60771148376526, 1.94816821865083],
            [33.60845041995165, 1.947498989672116],
            [33.608456735108106, 1.94685342814563],
            [33.61057725504867, 1.944823755368889],
            [33.61137589506548, 1.944540208345591],
            [33.61255373282837, 1.942787547765746],
            [33.614288597932614, 1.94250365744125],
            [33.6145371429071, 1.941831658299997],
            [33.61513961152713, 1.942220090276748],
            [33.61610834933964, 1.94160052521026],
            [33.617502857155785, 1.941567075892368],
            [33.61835366593439, 1.940723584914322],
            [33.618890512622926, 1.940697037865683],
            [33.61936134212123, 1.939168603562363],
            [33.62262790395517, 1.938060725948546],
            [33.62648903552283, 1.939195993669981],
            [33.630497994751984, 1.939013559635799],
            [33.63393877136055, 1.937221017457458],
            [33.63933675059777, 1.997126170967779],
            [33.63979830499078, 2.000464217790271],
            [33.64127349768911, 2.002914513368773],
            [33.642158574500876, 2.004669997779402],
            [33.64225876540115, 2.006515481199417],
            [33.641378032842084, 2.011634923078283],
            [33.6354320363658, 2.011945632078294],
            [33.63144647375822, 2.013505689443811],
            [33.62805930231758, 2.013623369699774],
            [33.62781165206513, 2.014142963811628],
            [33.62136900401767, 2.0176572696021],
            [33.618828958263016, 2.018634905707918],
            [33.61823072519957, 2.020567673882842],
            [33.6168053072528, 2.019778577833521],
            [33.613459350517424, 2.019696729309437],
            [33.61304749541754, 2.022959347255979],
            [33.61240742870962, 2.02351234564749],
            [33.611602829269195, 2.025923125163114],
            [33.61306981855234, 2.027397947216585],
            [33.61542154508411, 2.028234768569689],
            [33.61292609170014, 2.034660047620779],
            [33.6110027959819, 2.036743094004397],
            [33.610676035593926, 2.043605789171841],
            [33.61238774841838, 2.055913134357152],
            [33.61549840763476, 2.058797831055083],
            [33.61720902002296, 2.061393578807986],
            [33.61801404706148, 2.063932859442647],
            [33.61816647140224, 2.066676483840805],
            [33.618642223668274, 2.068167253382799],
            [33.61541049939937, 2.067932221335862],
            [33.61273861779192, 2.068551274452033],
            [33.61184777559265, 2.06819626353136],
            [33.608816550803574, 2.068567892330155],
            [33.60544923482568, 2.068261221484848],
            [33.603102413095364, 2.066857005856737],
            [33.600472378607144, 2.065992143380092],
            [33.597316561081406, 2.06556041264467],
            [33.59544359527358, 2.074161993821313],
            [33.60012963269868, 2.101239759367822],
            [33.5989116743786, 2.117133305991084],
            [33.60009709482079, 2.142515641763678],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 731,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "KUJU",
        Population: 18066,
        Key: "AMURIAKUJU",
        Dist2: "Amuria",
        "Sub Country": "Kuju",
        id2_original: "AmuriaKuju",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.281941666264515, 1.491580821336131],
            [33.278448090276775, 1.49643961349536],
            [33.27753825948903, 1.499452444799267],
            [33.2777791975297, 1.511955633014518],
            [33.27933898188342, 1.521129281437689],
            [33.281184060391546, 1.524793150822144],
            [33.28360327375733, 1.527715071864431],
            [33.285009202754, 1.533016534514093],
            [33.28534957890673, 1.536622974068577],
            [33.28743842694533, 1.537455497123823],
            [33.28864636006684, 1.538805830448886],
            [33.288959633149126, 1.539931201855765],
            [33.28873627244362, 1.542137044289056],
            [33.28793136398273, 1.544072866314707],
            [33.28667899839065, 1.544973367797425],
            [33.2769660820604, 1.544549868193223],
            [33.27214951044135, 1.545148929972751],
            [33.26427043739, 1.545299541520991],
            [33.26129729946384, 1.546167644865083],
            [33.26121976317674, 1.545447785062785],
            [33.260833162414414, 1.545262575820697],
            [33.257850920062836, 1.544725696208255],
            [33.25696731019991, 1.544707278457367],
            [33.25588131888665, 1.545633697413697],
            [33.24900519868032, 1.545279857611177],
            [33.24637925332325, 1.545509965378891],
            [33.24351823682265, 1.544746886050415],
            [33.241805972432616, 1.542620987164262],
            [33.239962395009336, 1.541960750901162],
            [33.23894022270878, 1.540811870277738],
            [33.232517775975445, 1.538478403930172],
            [33.227306304059205, 1.542685928881323],
            [33.22383191249271, 1.544866682244933],
            [33.218810632786706, 1.54938177662427],
            [33.216108971129316, 1.553245223244323],
            [33.214370887361405, 1.556810011403678],
            [33.21035723443489, 1.569232269890965],
            [33.20498476016519, 1.605693160408265],
            [33.171300990384374, 1.594332937373791],
            [33.15838475900609, 1.589321799284807],
            [33.1517604491503, 1.586318610164526],
            [33.13274445756685, 1.576630303787385],
            [33.10542823847234, 1.561631490480258],
            [33.07392711701544, 1.542877818492648],
            [33.06235673890086, 1.535522744713159],
            [33.048754077864494, 1.525200138378102],
            [33.03732849380067, 1.514017911901055],
            [33.03096886176362, 1.506002106971972],
            [33.026018711560155, 1.49767865800573],
            [33.02449881779495, 1.493308830703015],
            [33.01545454627677, 1.460874340851044],
            [33.06372994766161, 1.43726003822696],
            [33.08904405914308, 1.414668092364531],
            [33.15122179684808, 1.44354374193684],
            [33.152315984390015, 1.443335580325663],
            [33.15362555829268, 1.441878881364899],
            [33.1578864006359, 1.438648712412274],
            [33.159028059649025, 1.438413403738174],
            [33.160942025464735, 1.438838489939879],
            [33.16505139568138, 1.442882321952078],
            [33.176045158689824, 1.447332742771679],
            [33.19765746470069, 1.462466993593291],
            [33.19973670076577, 1.463579620051257],
            [33.20361136185992, 1.464927307634408],
            [33.21797258637332, 1.467567738569011],
            [33.22215654819962, 1.468770605436257],
            [33.25078874618477, 1.480203230075012],
            [33.25079038650846, 1.479814199837183],
            [33.25629285688123, 1.481731573844707],
            [33.259379847286525, 1.483070198461601],
            [33.263141225433465, 1.485738676165863],
            [33.26660805767685, 1.487231045315714],
            [33.273913521385026, 1.48890387436137],
            [33.27788197467969, 1.48939192227223],
            [33.28089603446032, 1.4914542969848],
            [33.281941666264515, 1.491580821336131],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 732,
        District: "SERERE",
        County: "KASILO",
        Subcounty: "KADUNGULU",
        Population: 32917,
        Key: "SEREREKADUNGULU",
        Dist2: "Serere",
        "Sub Country": "Kadungulu",
        id2_original: "SerereKadungulu",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.41682264526469, 1.758284318401482],
            [33.398988551829206, 1.756075707591358],
            [33.396267865650685, 1.759941434519992],
            [33.39338166577939, 1.766942266341572],
            [33.383800790117824, 1.771831229454049],
            [33.377500674163265, 1.773417490366846],
            [33.373562819283805, 1.773022056376953],
            [33.36187924535858, 1.765363759446865],
            [33.35413519897591, 1.766553981753419],
            [33.34762722633932, 1.765281943807297],
            [33.33465740775938, 1.774287248030793],
            [33.331157426783705, 1.775961600911091],
            [33.328850698661135, 1.776016298194339],
            [33.32690896502171, 1.777771788493641],
            [33.32543736648283, 1.77837820862731],
            [33.32285682826841, 1.780839484575091],
            [33.32158272524306, 1.782947690951502],
            [33.318206502469145, 1.785571950996512],
            [33.3145542813073, 1.787743897698606],
            [33.31166464987163, 1.793525517397511],
            [33.30585143786903, 1.794268054652082],
            [33.30283185973762, 1.79358649210151],
            [33.29938052702613, 1.790424744959843],
            [33.29617545397508, 1.785774798035101],
            [33.2940805998005, 1.779182129437447],
            [33.29070013158853, 1.770757294893519],
            [33.290593174577516, 1.765926127839577],
            [33.2945766324324, 1.751097204476094],
            [33.294937853991286, 1.746881172321998],
            [33.294578467690535, 1.744854665293646],
            [33.29173160145224, 1.740250107311187],
            [33.28592629552251, 1.73238901476459],
            [33.28348437544126, 1.729946648679151],
            [33.27725278656986, 1.726971056402599],
            [33.272484195766786, 1.726112269874448],
            [33.26989861261373, 1.72483698915402],
            [33.268825368394324, 1.725018085569246],
            [33.265055796713696, 1.723562021846932],
            [33.263632690132155, 1.72122804729543],
            [33.2618970776296, 1.71415338810982],
            [33.261864652041105, 1.711249246100791],
            [33.259928810451605, 1.706816388999878],
            [33.258433809901234, 1.704554794045408],
            [33.25629654716041, 1.702311378392674],
            [33.24984068759011, 1.697861011907999],
            [33.24635640018243, 1.694568282005442],
            [33.243288974185724, 1.690551714611009],
            [33.24099081868593, 1.68655313963142],
            [33.20498476016519, 1.605693160408265],
            [33.230765306586584, 1.614936647402482],
            [33.23880529215985, 1.618690303420402],
            [33.250816572399025, 1.625447101993493],
            [33.25594692464848, 1.627527308813026],
            [33.260342822406486, 1.629073812074725],
            [33.268252830741254, 1.630755543846474],
            [33.27214413043114, 1.632084954245178],
            [33.27494366264043, 1.633360222751032],
            [33.28088174675572, 1.637249682575172],
            [33.2838931412349, 1.638624426065323],
            [33.29050515764601, 1.639935310189567],
            [33.31739692187045, 1.647114630548935],
            [33.34336439063447, 1.656971656546643],
            [33.3668174731216, 1.663336578446395],
            [33.37472728652197, 1.666166820132767],
            [33.390279098587094, 1.672659576143081],
            [33.39583016063019, 1.67853904984008],
            [33.40318409832937, 1.688407877001692],
            [33.40626010323705, 1.694513994512943],
            [33.40998141652235, 1.704302112782629],
            [33.412162628440136, 1.711674986897407],
            [33.41338152190644, 1.717428642553647],
            [33.41469044722544, 1.728890960725829],
            [33.41682573007939, 1.741746332058059],
            [33.41713260356358, 1.744596081207323],
            [33.41714967963884, 1.758266150448097],
            [33.41682264526469, 1.758284318401482],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 733,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "BULULU",
        Population: 21390,
        Key: "KABERAMAIDOBULULU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.36719349891639, 1.516164418606829],
            [33.35638287903819, 1.518420062496403],
            [33.35014980525162, 1.517787164683143],
            [33.34732896410544, 1.51805682781351],
            [33.34175596879634, 1.522503035851676],
            [33.336751571129525, 1.522588474087874],
            [33.334312315451406, 1.521742413325326],
            [33.33031640425177, 1.516537404996335],
            [33.32766619360223, 1.511078247549689],
            [33.325670087633576, 1.508844237016698],
            [33.32009532084678, 1.504983448492493],
            [33.314631809509564, 1.498909210252845],
            [33.31675320351089, 1.493861373611858],
            [33.3180270217703, 1.491834398047289],
            [33.320122334984, 1.486291440986596],
            [33.321494454986635, 1.484463983664974],
            [33.32319178847831, 1.476737235870835],
            [33.325054791071295, 1.47061168066258],
            [33.32519760703182, 1.466739767893527],
            [33.32772985181654, 1.461761252735976],
            [33.32763357667258, 1.456985133268695],
            [33.32691612998439, 1.45302677183559],
            [33.32442972892357, 1.444345439387679],
            [33.32160924890016, 1.438756849845316],
            [33.31979250325608, 1.433908823924848],
            [33.31601642687443, 1.42977291750624],
            [33.30648097991509, 1.421438816812524],
            [33.29656342466817, 1.414297545153775],
            [33.294125732957, 1.41148411464882],
            [33.29297849001609, 1.409391990303302],
            [33.28960791225536, 1.398676134173596],
            [33.289176533171094, 1.388330264107407],
            [33.292564437637004, 1.366706335578263],
            [33.298821533272594, 1.370355406330417],
            [33.30797480367242, 1.374696882345101],
            [33.311953258809474, 1.375926777010335],
            [33.31397304167405, 1.376026028391139],
            [33.32554137252811, 1.37424217462459],
            [33.33765153931374, 1.374339998165011],
            [33.34153927359024, 1.373660904528617],
            [33.34777131431426, 1.371723910380176],
            [33.35081218970445, 1.369814516493832],
            [33.35414252563537, 1.368773601729465],
            [33.36037030564998, 1.368600771175204],
            [33.364147557028, 1.3693782485833],
            [33.365977971437445, 1.369359873403548],
            [33.37424154229502, 1.367612492941587],
            [33.37626397339307, 1.366806981130084],
            [33.38053938281696, 1.362925092524881],
            [33.38520092318426, 1.356618514572041],
            [33.390870230468224, 1.346104869715594],
            [33.39539593568311, 1.333881509049832],
            [33.4029556019554, 1.336847718263741],
            [33.4104971590899, 1.338954427047104],
            [33.4203218213499, 1.340445513771948],
            [33.42547983362527, 1.340535086319767],
            [33.428190469452375, 1.339937503668307],
            [33.430044233771, 1.34513923245747],
            [33.43321506034851, 1.366969196748721],
            [33.433383283360165, 1.371420313822222],
            [33.43259966137826, 1.381390304413372],
            [33.433205385492876, 1.397231572919996],
            [33.43657130369221, 1.406467974938859],
            [33.436461441529595, 1.407843145807415],
            [33.43762352553731, 1.40905522934797],
            [33.43897084036001, 1.412330001579087],
            [33.4389923514178, 1.413189466597338],
            [33.44092281928526, 1.416310324970184],
            [33.44182465057543, 1.416816785825076],
            [33.444027117531135, 1.420281374657145],
            [33.446220936405616, 1.422560800239117],
            [33.448598421229825, 1.427445728908214],
            [33.44925123772661, 1.433054755731822],
            [33.44965416177592, 1.433516074117592],
            [33.449210670706684, 1.435334614072245],
            [33.44963815020429, 1.440690366865383],
            [33.451510647989856, 1.443060313376314],
            [33.453404141200224, 1.446452565823185],
            [33.45456481215805, 1.447374229002691],
            [33.45532396043833, 1.44914576678079],
            [33.45601613302602, 1.455698363863046],
            [33.45568335302733, 1.456703782962121],
            [33.454779743971216, 1.457709319253742],
            [33.45202107702251, 1.459385466215828],
            [33.44940532215401, 1.462114807934758],
            [33.4474086071276, 1.468099451127257],
            [33.44712359324751, 1.470110214002547],
            [33.44208227482248, 1.475329487925548],
            [33.440085140282825, 1.47930342731634],
            [33.43970526430874, 1.482750429892088],
            [33.43830462189752, 1.485828254784681],
            [33.43856174398637, 1.487637610637446],
            [33.4383209820155, 1.489003760232874],
            [33.43892411449052, 1.49036974195147],
            [33.43856422692981, 1.491663539812575],
            [33.43725423890382, 1.492876104692252],
            [33.43696574045872, 1.494350829400437],
            [33.435847757443234, 1.49483054616612],
            [33.43391724106672, 1.498387059006268],
            [33.4322024775636, 1.499785029999838],
            [33.431282702425655, 1.502247906792216],
            [33.42261656594655, 1.510381371152873],
            [33.42191436546536, 1.51055134608586],
            [33.420324537855315, 1.509120349823696],
            [33.41643416522684, 1.508279157267702],
            [33.409908937750274, 1.509880109312842],
            [33.408340529569855, 1.509824889287955],
            [33.40644914650208, 1.510831450299319],
            [33.40385232362821, 1.511202868795228],
            [33.395046467681375, 1.508644177023955],
            [33.393104571446834, 1.507282527902452],
            [33.3907786885475, 1.507840291869824],
            [33.387178834675154, 1.507172129925642],
            [33.38463132931037, 1.507172585213938],
            [33.38219474971354, 1.508120499702952],
            [33.38058890604028, 1.509235469404886],
            [33.378761586326966, 1.510629148175753],
            [33.37635787069648, 1.513400745794814],
            [33.373788102384, 1.515216874014224],
            [33.36972040411507, 1.515549571750702],
            [33.36719349891639, 1.516164418606829],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 734,
        District: "SERERE",
        County: "KASILO",
        Subcounty: "PINGIRE",
        Population: 34516,
        Key: "SEREREPINGIRE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.47807523231311, 1.555058100158731],
            [33.476660881610655, 1.553234144800718],
            [33.47078096790161, 1.550992784181902],
            [33.4667620831869, 1.548501496990869],
            [33.460078141365926, 1.548422135572298],
            [33.459120112369945, 1.547894432395329],
            [33.4572474106668, 1.547942002383725],
            [33.45667014787533, 1.556459739363941],
            [33.44521714633073, 1.557512930474659],
            [33.43793769873152, 1.56105324589958],
            [33.43650729603327, 1.553675275503133],
            [33.43633991653965, 1.548952669073034],
            [33.43524108830094, 1.544692208408745],
            [33.43559630192721, 1.542980787366139],
            [33.4362762906647, 1.541907164245727],
            [33.43591892198006, 1.540093507409334],
            [33.43618337072833, 1.5377186626108],
            [33.44025244701294, 1.531893305671808],
            [33.43540371121516, 1.526098145991124],
            [33.431732686517776, 1.522474471428364],
            [33.43362179684791, 1.521596548735614],
            [33.434958900520755, 1.521947294359552],
            [33.443387818882776, 1.520980270218779],
            [33.443600771707395, 1.517000567629341],
            [33.444801533578016, 1.513105892229263],
            [33.4463910979817, 1.509508108684536],
            [33.448156588450594, 1.506781458419464],
            [33.4478293735151, 1.505717046944698],
            [33.446135237127514, 1.50373413942298],
            [33.44755585447739, 1.502384089478368],
            [33.44889868940176, 1.502010374173885],
            [33.450718788456804, 1.502507915587623],
            [33.451407860958405, 1.5022410298582],
            [33.4522738009597, 1.502827680385611],
            [33.452702698897156, 1.503963280887394],
            [33.45482986906575, 1.501800217264613],
            [33.458701513617214, 1.501559210209225],
            [33.46315676486268, 1.50227883593294],
            [33.464138324329234, 1.504066712297891],
            [33.46530205494887, 1.505246106077629],
            [33.46602121741925, 1.504087336796609],
            [33.468424527909576, 1.505082653841365],
            [33.46897237446873, 1.505473752204569],
            [33.46923779699079, 1.507216402445222],
            [33.47259873403186, 1.508815315905712],
            [33.47251957628566, 1.510656792302279],
            [33.47322840363867, 1.514694391722397],
            [33.475222950131986, 1.518533842666074],
            [33.4780881204425, 1.520106357382157],
            [33.48145720430488, 1.520158858003628],
            [33.48142273145584, 1.523780205258704],
            [33.48189963356545, 1.526673618985071],
            [33.481110375553456, 1.529024429517196],
            [33.481757079913024, 1.530050773388684],
            [33.48155619954749, 1.531149597501353],
            [33.48295355771805, 1.536274279163423],
            [33.48342577780839, 1.540016018885594],
            [33.480524617394366, 1.543508190937886],
            [33.4793471748902, 1.546096369743345],
            [33.478264593581734, 1.550362587271844],
            [33.47830462251079, 1.552964542681467],
            [33.47807523231311, 1.555058100158731],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 735,
        District: "SERERE",
        County: "SERERE",
        Subcounty: "SERERE TOWN COUNCIL",
        Population: 8621,
        Key: "SERERESERERE TOWN COUNCIL",
        Dist2: "Serere",
        "Sub Country": "serere  TC",
        id2_original: "Serereserere  TC",
        drought: "H",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "#REF!",
        "Environmental degradation": "N",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.64219346237158, 1.728754575929973],
            [33.642479416787765, 1.729871155447665],
            [33.641970642451874, 1.730842622022338],
            [33.64156360052526, 1.734657020989296],
            [33.64133859410615, 1.742030660230022],
            [33.6409028249551, 1.744520911804862],
            [33.64124034266861, 1.746415128291291],
            [33.64092186025596, 1.747825677956801],
            [33.638812792038635, 1.750377574993442],
            [33.636772405414696, 1.751662908360231],
            [33.63620142723695, 1.752550758897889],
            [33.634192378341695, 1.753465528793983],
            [33.631489100615084, 1.755763038640345],
            [33.622821188166654, 1.755765806846117],
            [33.619548465686485, 1.757889035629529],
            [33.616493324151286, 1.758877957124548],
            [33.613624897447856, 1.758681926630382],
            [33.6123706705465, 1.758042631810651],
            [33.61102824884716, 1.757987631408298],
            [33.60764149152988, 1.75584660738582],
            [33.60600343966043, 1.755474158432208],
            [33.60312214998049, 1.751941826109701],
            [33.6014130907794, 1.748797212506378],
            [33.60001439142414, 1.748056419601575],
            [33.59902863143533, 1.748178020921828],
            [33.597986641401306, 1.747775128131563],
            [33.59972019586355, 1.747052321510526],
            [33.603651476871754, 1.741570624644779],
            [33.60247457605173, 1.737232937698076],
            [33.603117282908286, 1.730573128260857],
            [33.60365318995902, 1.72920555924892],
            [33.60472811672292, 1.726632136789318],
            [33.60803987549376, 1.722912849789571],
            [33.61110702570769, 1.722170026448187],
            [33.612796731604284, 1.722449929068782],
            [33.61131212456179, 1.716904743299532],
            [33.61209503148471, 1.71573745914181],
            [33.615376883543114, 1.715229779320945],
            [33.61683950072579, 1.715265492005776],
            [33.61688867540276, 1.716170151475934],
            [33.62190744791077, 1.716023765718976],
            [33.621930240864494, 1.715263831765062],
            [33.632837629061726, 1.715142620720826],
            [33.6390748180306, 1.715128562099652],
            [33.639396806567795, 1.716197917619091],
            [33.640974693771085, 1.717799060746413],
            [33.642669283807884, 1.721577362972685],
            [33.642725845331434, 1.724744168782962],
            [33.642384976901944, 1.72576654396675],
            [33.6427887327912, 1.727264679235692],
            [33.64219346237158, 1.728754575929973],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 736,
        District: "SOROTI",
        County: "SOROTI  MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 18760,
        Key: "SOROTIEASTERN DIVISION",
        Dist2: "Soroti",
        "Sub Country": "Soroti",
        id2_original: "SorotiSoroti",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.191227173878346, 1.676642921950269],
            [33.1920324641232, 1.678729978443977],
            [33.192698901774605, 1.68275143701047],
            [33.19603000307015, 1.691081312974165],
            [33.199410264669616, 1.714216748462125],
            [33.20012270594501, 1.716535397938479],
            [33.2012121943997, 1.718516766723051],
            [33.207371653943696, 1.726231071135435],
            [33.213489040891375, 1.731711035543791],
            [33.21356669575609, 1.741506872822523],
            [33.214077086161204, 1.745201729172039],
            [33.214789457368035, 1.74633988533394],
            [33.21562741754316, 1.746719247222731],
            [33.222540445032905, 1.748362610613709],
            [33.22740071609725, 1.750933680588111],
            [33.22928626640388, 1.75278839579452],
            [33.230459655709474, 1.75527563323192],
            [33.22614760131019, 1.778173958281247],
            [33.22216504716052, 1.805102666495585],
            [33.221390881743595, 1.821539706693322],
            [33.220319044285944, 1.825316261996434],
            [33.21849479770923, 1.827547581446521],
            [33.217115567541136, 1.828371015230728],
            [33.214609057692655, 1.829022734275011],
            [33.201558326058446, 1.830281838169706],
            [33.19507589342374, 1.830291588896489],
            [33.19059642359822, 1.831884372099264],
            [33.18229030583383, 1.830926261434345],
            [33.179535775626995, 1.829822738696423],
            [33.17868374513956, 1.828637636819065],
            [33.178012780877445, 1.826167824931628],
            [33.174362602484564, 1.823300215305699],
            [33.17080471251241, 1.821545388359941],
            [33.16990520426557, 1.820378378332209],
            [33.16809759089469, 1.816497295944283],
            [33.16824626926072, 1.813837442341211],
            [33.16886922935071, 1.811358421416512],
            [33.16863668516805, 1.809286593495031],
            [33.1696076373277, 1.805296689799786],
            [33.168900214041464, 1.803080214314988],
            [33.1693249491859, 1.799090297903744],
            [33.16859303243513, 1.798528285320513],
            [33.16791564701536, 1.797156925154515],
            [33.16614666748988, 1.796016274487941],
            [33.16478526349028, 1.795942269917321],
            [33.164098753882165, 1.795010515285848],
            [33.16267559160507, 1.794341107543197],
            [33.157167374709445, 1.794088299202774],
            [33.15195097014398, 1.796061028118029],
            [33.150313685435776, 1.795554500535591],
            [33.14900747841883, 1.795672276487177],
            [33.146607187166175, 1.796568115833261],
            [33.14458678446403, 1.797518248237833],
            [33.138961962651265, 1.801399933295837],
            [33.13407211006461, 1.80078510143288],
            [33.13321902585337, 1.800043304879142],
            [33.130830735194586, 1.795773147257735],
            [33.12852259132716, 1.792796762231511],
            [33.12604257459305, 1.790679879306502],
            [33.11862217503757, 1.792299843709844],
            [33.1156087126366, 1.791431499733243],
            [33.112242767487814, 1.78891660235734],
            [33.11077212745137, 1.788319584680784],
            [33.106796309767965, 1.787677461007943],
            [33.102196374066224, 1.784945454852111],
            [33.10409957447159, 1.778313691271673],
            [33.10885099577463, 1.777182499772017],
            [33.11244113346887, 1.775128590843125],
            [33.1155970983183, 1.771991394313244],
            [33.117655538384504, 1.769003537147455],
            [33.11874404408227, 1.766274659445113],
            [33.11888254543445, 1.764999868379864],
            [33.11838756023816, 1.763406464741218],
            [33.117061246230186, 1.761832982135403],
            [33.11634862978329, 1.76129522998001],
            [33.114131650544174, 1.761016532712275],
            [33.11252826376321, 1.760359318577705],
            [33.110291387738854, 1.75824815040037],
            [33.109577227087975, 1.756655654146715],
            [33.109524240859244, 1.753315768940856],
            [33.11016951869415, 1.75156059406255],
            [33.11104916608836, 1.751035816238775],
            [33.118881387506065, 1.75002947140982],
            [33.12362958026397, 1.747737168622118],
            [33.12703409008789, 1.747273980118173],
            [33.13522339183106, 1.747551205983517],
            [33.14181299078424, 1.746854212940539],
            [33.14334644282201, 1.745896267974058],
            [33.145503487363705, 1.743674389571841],
            [33.145389303406255, 1.740800968569871],
            [33.14386841340939, 1.736883662614239],
            [33.14417847231964, 1.735019882661547],
            [33.14536852986531, 1.733843628785005],
            [33.14684383664967, 1.733174058958896],
            [33.149639667800024, 1.732848147498018],
            [33.16542636595571, 1.731516863574859],
            [33.16956679272838, 1.729942231880273],
            [33.1720893743356, 1.72805115681426],
            [33.17529137694504, 1.723301084125549],
            [33.17683918136609, 1.72024293026498],
            [33.180638913982406, 1.708390685991301],
            [33.18536542140939, 1.698718773997602],
            [33.189520129598435, 1.691643427706781],
            [33.19021127092016, 1.688703006160125],
            [33.191227173878346, 1.676642921950269],
          ],
          [
            [33.155900504020465, 1.75199186492016],
            [33.151961216328104, 1.75314117061216],
            [33.144025688652725, 1.757508020288904],
            [33.1437405085843, 1.761414621628085],
            [33.140296277055164, 1.764295095346829],
            [33.14164188957039, 1.765117926425062],
            [33.142297624693505, 1.767797562072703],
            [33.142989923943624, 1.767427253379579],
            [33.14382521702067, 1.770949986671683],
            [33.15048717257502, 1.777905575734396],
            [33.15208883998054, 1.777821750288986],
            [33.15449621983908, 1.778328211829615],
            [33.1563024300415, 1.778100655135878],
            [33.16192904219662, 1.781872460029549],
            [33.167180431650856, 1.782011280492734],
            [33.1687446932079, 1.780689992702283],
            [33.16779475982926, 1.779144022418055],
            [33.168995801075916, 1.777429276663899],
            [33.17011293967502, 1.774421435980372],
            [33.17018476986346, 1.772543804943188],
            [33.16717604517733, 1.765215501819398],
            [33.166899322747305, 1.761867986400765],
            [33.16629804798829, 1.760619637008832],
            [33.16593724773927, 1.75827852430232],
            [33.162409254598074, 1.753944576175056],
            [33.155900504020465, 1.75199186492016],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 737,
        District: "KABERAMAIDO",
        County: "KABERAMAIDO",
        Subcounty: "KABERAMAIDO",
        Population: 17716,
        Key: "KABERAMAIDOKABERAMAIDO",
        Dist2: "Kaberamaido",
        "Sub Country": "Kaberamaido",
        id2_original: "KaberamaidoKaberamaido",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.43840440496265, 1.838327265999972],
            [33.42849516182708, 1.848181890395927],
            [33.423206581221784, 1.852616208750456],
            [33.42203637285064, 1.854027825484766],
            [33.416276058143566, 1.864695645643601],
            [33.41456308857604, 1.866541647756647],
            [33.407829784330225, 1.869230203767335],
            [33.40575475866891, 1.870461085260711],
            [33.404412572328184, 1.871908924357697],
            [33.40353301925711, 1.873980901235763],
            [33.40306704245796, 1.878386918698273],
            [33.40187756163069, 1.881671270670136],
            [33.39980077257647, 1.882648832256672],
            [33.392462006524134, 1.884731335118367],
            [33.39109172447455, 1.886287738589947],
            [33.39035425433869, 1.888024939815649],
            [33.38829293517198, 1.897968120466491],
            [33.383955121581934, 1.903144014305063],
            [33.383057578848984, 1.910409005717894],
            [33.38232305339061, 1.912824735925666],
            [33.381437002805065, 1.913639170395261],
            [33.378286334422555, 1.915096450754838],
            [33.37276161098356, 1.91531479988825],
            [33.37231939642034, 1.912989799153166],
            [33.37070217648233, 1.911035983720773],
            [33.36440833166678, 1.909607902289358],
            [33.36219281847819, 1.908586053150445],
            [33.359959748615665, 1.906912815162586],
            [33.35790798662528, 1.904199120103071],
            [33.352436957287466, 1.900282305688955],
            [33.342634001918, 1.894983249661265],
            [33.33351883176434, 1.89198140121687],
            [33.33044512834041, 1.889361297340526],
            [33.33761023118374, 1.883500011165198],
            [33.34299419580421, 1.876939917249981],
            [33.34479388693263, 1.86954577648052],
            [33.337660977014146, 1.863506193642602],
            [33.33671396405847, 1.858428292198978],
            [33.342881039519426, 1.856353027956094],
            [33.34664598038479, 1.851043554941355],
            [33.351010302360564, 1.84081514114843],
            [33.3606518241853, 1.837170317461894],
            [33.37462028010365, 1.827168017176324],
            [33.3814667038033, 1.820921282136881],
            [33.384670932438006, 1.815818816013947],
            [33.39454919627271, 1.816315120256159],
            [33.4015725458625, 1.82006658677244],
            [33.41075059539109, 1.816663329819146],
            [33.417480402495514, 1.810973606607406],
            [33.41982939635218, 1.797878224440026],
            [33.42894953957927, 1.788722384269158],
            [33.428413360338986, 1.792162773984519],
            [33.42779760024603, 1.792669552115617],
            [33.427959799155424, 1.794225601333496],
            [33.42879789497615, 1.79532009339939],
            [33.430032360737904, 1.794885543725097],
            [33.434841041555465, 1.800574968931],
            [33.435393713864364, 1.804157452985619],
            [33.43405605862593, 1.807839909401545],
            [33.43434979245248, 1.809531629582167],
            [33.43229371046385, 1.812092429750222],
            [33.43085577898518, 1.812373231946712],
            [33.43114831266255, 1.813748308569082],
            [33.430800342152374, 1.815566842082231],
            [33.429690318210305, 1.81712319493556],
            [33.42893951797395, 1.819294659558363],
            [33.42939484165212, 1.819936887896374],
            [33.429498065264795, 1.821574373119669],
            [33.430982658832555, 1.826061336152851],
            [33.43207792704777, 1.82624201143107],
            [33.43553719008658, 1.82834912276048],
            [33.43563925756748, 1.829823760457899],
            [33.43668971781634, 1.830601546157252],
            [33.43683187441342, 1.832854215429985],
            [33.43646149363189, 1.834926071009858],
            [33.4373999115069, 1.83711521529234],
            [33.43840440496265, 1.838327265999972],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 738,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "KAKURE",
        Population: 12611,
        Key: "KABERAMAIDOKAKURE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.41042069179794, 1.955447794519858],
            [33.40434526066564, 1.953920331540441],
            [33.398153074597516, 1.952953787991501],
            [33.39520385880736, 1.950909857510079],
            [33.39198110511487, 1.949481182911791],
            [33.389567732595054, 1.948567995512352],
            [33.386339595299056, 1.948143532850497],
            [33.38446262300508, 1.948397282319019],
            [33.37460521625465, 1.95263354681709],
            [33.370156136435206, 1.953421634400916],
            [33.36870132740898, 1.954227145978083],
            [33.365580217192566, 1.957611439014511],
            [33.362011524080806, 1.959937317617877],
            [33.36026775038388, 1.960326721310406],
            [33.35855421757268, 1.960209478969266],
            [33.35439001329278, 1.958238107790927],
            [33.35204587752514, 1.957876721870228],
            [33.34796678412685, 1.959786515865668],
            [33.34563740947599, 1.960166979404163],
            [33.343470323566024, 1.959932204705213],
            [33.34140587107561, 1.958666036066666],
            [33.339851516139525, 1.956431720572413],
            [33.33933892576029, 1.953364857955165],
            [33.33835965340445, 1.951935615343446],
            [33.33732109942639, 1.951944872497727],
            [33.33327615728021, 1.949999498940292],
            [33.33681095515968, 1.934576049794937],
            [33.33463494538572, 1.929009156741448],
            [33.3331947717121, 1.924420418128281],
            [33.33331931683805, 1.923645999652542],
            [33.33504465351208, 1.921780701600874],
            [33.33600331222709, 1.921458967759495],
            [33.34225449604978, 1.921148337975953],
            [33.34337365945156, 1.92057250925468],
            [33.34678116336033, 1.920221449990623],
            [33.3473032246776, 1.918894954613693],
            [33.346805390025224, 1.917018092039865],
            [33.345262772476644, 1.914490761402171],
            [33.344715191818764, 1.912588881779301],
            [33.3452361688695, 1.905831703024433],
            [33.347579635392194, 1.904880354666304],
            [33.349773041939976, 1.903044873452051],
            [33.35028704716577, 1.900283481834778],
            [33.35101308354471, 1.899949677245966],
            [33.352436957287466, 1.900282305688955],
            [33.35790798662528, 1.904199120103071],
            [33.359959748615665, 1.906912815162586],
            [33.36219281847819, 1.908586053150445],
            [33.36440833166678, 1.909607902289358],
            [33.37070217648233, 1.911035983720773],
            [33.37231939642034, 1.912989799153166],
            [33.37276161098356, 1.91531479988825],
            [33.378286334422555, 1.915096450754838],
            [33.381437002805065, 1.913639170395261],
            [33.38232305339061, 1.912824735925666],
            [33.383057578848984, 1.910409005717894],
            [33.383955121581934, 1.903144014305063],
            [33.38829293517198, 1.897968120466491],
            [33.39035425433869, 1.888024939815649],
            [33.39109172447455, 1.886287738589947],
            [33.392462006524134, 1.884731335118367],
            [33.39980077257647, 1.882648832256672],
            [33.40187756163069, 1.881671270670136],
            [33.40306704245796, 1.878386918698273],
            [33.40353301925711, 1.873980901235763],
            [33.404412572328184, 1.871908924357697],
            [33.40575475866891, 1.870461085260711],
            [33.407829784330225, 1.869230203767335],
            [33.41456308857604, 1.866541647756647],
            [33.416276058143566, 1.864695645643601],
            [33.42203637285064, 1.854027825484766],
            [33.423206581221784, 1.852616208750456],
            [33.42849516182708, 1.848181890395927],
            [33.43840440496265, 1.838327265999972],
            [33.43947963805209, 1.839276935580047],
            [33.44093061306868, 1.841683077108122],
            [33.443367770282286, 1.84393517035102],
            [33.44763396029639, 1.845743493442263],
            [33.44888976553773, 1.849624332859419],
            [33.449883627432094, 1.85096303426742],
            [33.449107945659, 1.852428844498132],
            [33.44968788543002, 1.854681396378104],
            [33.45241766705076, 1.858426148150418],
            [33.4521398648458, 1.859855643463832],
            [33.45121861197919, 1.861221975378629],
            [33.45120272437509, 1.862823296259402],
            [33.45168640247688, 1.864388299863054],
            [33.45150773026182, 1.866704374718486],
            [33.45091911905338, 1.867943964316557],
            [33.45095220041202, 1.86985286906699],
            [33.4514837191926, 1.873887687122642],
            [33.45297370355038, 1.87699946155469],
            [33.453147743153544, 1.878528356951719],
            [33.453625509442425, 1.878926298717584],
            [33.452665882343545, 1.879686495852849],
            [33.45100080376045, 1.879695976957784],
            [33.45007833098172, 1.880718526390759],
            [33.4474423918671, 1.881524390917901],
            [33.445836346971234, 1.88386797595518],
            [33.4449687352052, 1.886283746844391],
            [33.44425860619333, 1.887025783094436],
            [33.444097611924754, 1.888165745216202],
            [33.44039766866175, 1.892654004414382],
            [33.43966984194046, 1.894545012728769],
            [33.43945460829334, 1.896761582230082],
            [33.43820305926982, 1.900995897468593],
            [33.43633686496261, 1.903601909509033],
            [33.42979859843971, 1.90900462792232],
            [33.423175393511755, 1.9188222947247],
            [33.41590917540174, 1.928459169546384],
            [33.41499080882217, 1.930368317187579],
            [33.41457615547016, 1.933037291507398],
            [33.412706525106984, 1.949421807215392],
            [33.41042069179794, 1.955447794519858],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 739,
        District: "KABERAMAIDO",
        County: "KALAKI",
        Subcounty: "APAPAI",
        Population: 11224,
        Key: "KABERAMAIDOAPAPAI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.437528953599156, 2.111058106896118],
            [33.43706670930004, 2.112171019959005],
            [33.43594563338502, 2.112849859810807],
            [33.43515691526052, 2.114234270447071],
            [33.434543795316166, 2.11446061835542],
            [33.43084109332694, 2.118251667335276],
            [33.42828438921364, 2.113233706565145],
            [33.427514325504326, 2.110847254688157],
            [33.42666286904037, 2.109785423759597],
            [33.42658676736276, 2.106793692434202],
            [33.425609581793346, 2.104916806380633],
            [33.4254316991974, 2.102741860290827],
            [33.42604842497929, 2.101148067137307],
            [33.426088536553365, 2.097339916358707],
            [33.42649609950281, 2.096301766012967],
            [33.42627264177926, 2.093498611749857],
            [33.42538783805536, 2.092691693501752],
            [33.42345394042011, 2.092133416289592],
            [33.41892831066374, 2.092734837739894],
            [33.418022949892816, 2.091969311912867],
            [33.41701490539674, 2.091866100537136],
            [33.41308510391383, 2.089611234923161],
            [33.41168579819572, 2.087976584891447],
            [33.407756460243476, 2.087460205249204],
            [33.40569902539206, 2.086446613567674],
            [33.40477303031911, 2.085405821204989],
            [33.40469518680816, 2.082663688094066],
            [33.406783800386435, 2.07994673584188],
            [33.409997393957994, 2.077132472701436],
            [33.4129855499191, 2.072688419605452],
            [33.419702026922984, 2.067318503191161],
            [33.42638595257428, 2.060590373350344],
            [33.425047648752205, 2.05976875763885],
            [33.42228120598636, 2.057047445343201],
            [33.421775616178174, 2.054970352192341],
            [33.42131867373583, 2.054982571298261],
            [33.42116220607796, 2.054426104088326],
            [33.42032036787576, 2.054051289506622],
            [33.41947836258693, 2.053035278600482],
            [33.41936952899532, 2.050700390633031],
            [33.41712049337524, 2.049188729587585],
            [33.412874133671025, 2.042953304258799],
            [33.412706299629846, 2.040858815169187],
            [33.41087572352365, 2.039993778823138],
            [33.41041793037677, 2.039183634716743],
            [33.41019708315744, 2.034980222561246],
            [33.410907039692766, 2.033279201452636],
            [33.41031973732971, 2.031062830998541],
            [33.41089994210374, 2.029687540632763],
            [33.410651816642456, 2.028565770778989],
            [33.40979050476154, 2.027326550717573],
            [33.409640672060334, 2.025969528259748],
            [33.41016201472539, 2.025182310246606],
            [33.40941192954799, 2.023734979922863],
            [33.41210964939792, 2.019590756247753],
            [33.413465402994404, 2.018133840063837],
            [33.414560630785424, 2.017645019689352],
            [33.4150051809684, 2.016450247416168],
            [33.41620368357604, 2.016649426014916],
            [33.41667615160142, 2.014976260209667],
            [33.41700817701528, 2.015316000324241],
            [33.41736983066381, 2.014387371849806],
            [33.41828294659057, 2.013835269012255],
            [33.42023128284737, 2.011120660873166],
            [33.421763755721464, 2.009986546532412],
            [33.42317085432462, 2.007899161920137],
            [33.428718923181215, 2.00568119114511],
            [33.42921439795932, 2.004875876941187],
            [33.42956624649653, 2.005011489783336],
            [33.43042648848397, 2.004323690089111],
            [33.43080695195625, 2.004238168927624],
            [33.431010879407204, 2.004648250307892],
            [33.43156986597423, 2.004402021938913],
            [33.431906565322485, 2.003436691964158],
            [33.43269350478274, 2.003311938372077],
            [33.43232323179903, 2.002151908166146],
            [33.43300723870077, 2.000215668960302],
            [33.432890134320346, 1.999419564071623],
            [33.433663492151815, 1.998843872695228],
            [33.433821609116556, 1.99820701970481],
            [33.431225406080216, 1.992616663463607],
            [33.42588291128652, 1.987642211247475],
            [33.42232653317897, 1.985155203511514],
            [33.4205527638364, 1.982477742891213],
            [33.42040701307987, 1.979483219157541],
            [33.422073879310354, 1.975022616840545],
            [33.42299457432316, 1.971186448940597],
            [33.42333309006495, 1.96752232295976],
            [33.422773204284326, 1.962483281339641],
            [33.42046475229474, 1.95605245204469],
            [33.419467218087505, 1.954338843969513],
            [33.41635055992164, 1.951497124597762],
            [33.412706525106984, 1.949421807215392],
            [33.41457615547016, 1.933037291507398],
            [33.41499080882217, 1.930368317187579],
            [33.41590917540174, 1.928459169546384],
            [33.423175393511755, 1.9188222947247],
            [33.42979859843971, 1.90900462792232],
            [33.43633686496261, 1.903601909509033],
            [33.43820305926982, 1.900995897468593],
            [33.43945460829334, 1.896761582230082],
            [33.440621404863066, 1.90181855439039],
            [33.44272546137942, 1.906441025308802],
            [33.443258730078135, 1.908485505731521],
            [33.443196418438475, 1.910937258113301],
            [33.441401139834724, 1.918338164130998],
            [33.44057259939366, 1.926335922287086],
            [33.44082097189165, 1.928434759983109],
            [33.45226959055597, 1.937243491233657],
            [33.4543300248821, 1.94021034399444],
            [33.45545380292949, 1.943747405857277],
            [33.45470835216065, 1.946941189571162],
            [33.45195216995199, 1.95237012246364],
            [33.44675517169161, 1.959518638699303],
            [33.44668736236238, 1.960233368252847],
            [33.44991416296523, 1.968202885665556],
            [33.45065514551387, 1.971351032437219],
            [33.453320341858955, 1.976416608086918],
            [33.45679650310656, 1.97941019558946],
            [33.45882273677323, 1.980350516753855],
            [33.46047621630937, 1.982765593707123],
            [33.460389605241254, 1.984556916400926],
            [33.46005808288397, 1.984746995420256],
            [33.460558916112724, 1.985108733719695],
            [33.460228595701295, 1.985579268918031],
            [33.460801392069165, 1.986031456141155],
            [33.46021879328493, 1.990763181422571],
            [33.460793382690106, 1.991595339665095],
            [33.46067204185477, 1.995811258443321],
            [33.46111805359673, 1.997059613019668],
            [33.46398251872972, 1.998967709107725],
            [33.46410695785444, 2.001808418034335],
            [33.464980808420115, 2.001618182080046],
            [33.466793498170695, 2.002495217774888],
            [33.467588624876434, 2.002151205214689],
            [33.46869082269575, 2.004548332594827],
            [33.47194457724871, 2.0057777726947],
            [33.47336617915214, 2.006853945556887],
            [33.47429933379792, 2.009612993765827],
            [33.47536877814363, 2.009476973721041],
            [33.475981470489934, 2.009874860375215],
            [33.475955802927295, 2.01051720133656],
            [33.47664671787358, 2.011267894724558],
            [33.47927477157661, 2.011755652267651],
            [33.48034386378277, 2.012334339419197],
            [33.48125690425104, 2.013537311266532],
            [33.48303918243599, 2.014348453048914],
            [33.4825618069142, 2.015405544663996],
            [33.48316359461127, 2.015734141699218],
            [33.48280559890255, 2.016748508071405],
            [33.48334186258443, 2.017146413598886],
            [33.48292797190212, 2.018177885870517],
            [33.48350091649201, 2.019073362483706],
            [33.48172349998939, 2.023534029126613],
            [33.482144093900345, 2.024266707548018],
            [33.48131603136303, 2.025388775741813],
            [33.48136520963326, 2.026347733018759],
            [33.48057996888722, 2.027840712631932],
            [33.47854613906653, 2.029967348264254],
            [33.4780223350176, 2.029922268568061],
            [33.477176167834045, 2.030646275412954],
            [33.476056151032765, 2.032772642517432],
            [33.47625753625147, 2.035314772188157],
            [33.47544179590488, 2.036319221443514],
            [33.475551619439955, 2.037124366537446],
            [33.47459621801615, 2.039069742115088],
            [33.47493748889091, 2.039521987221324],
            [33.474425768979195, 2.040444930215331],
            [33.473421247675674, 2.041648467401561],
            [33.47244681454426, 2.041965400093268],
            [33.47213061115751, 2.042680205033196],
            [33.46959688684753, 2.04398371239161],
            [33.46799555720855, 2.045368366576577],
            [33.45888462710305, 2.048781719887509],
            [33.45767940240209, 2.04983151277561],
            [33.45635842079365, 2.052907858060021],
            [33.45639525351694, 2.053975392034328],
            [33.458034363601776, 2.056906133548776],
            [33.45939541995337, 2.066178867001271],
            [33.46040142707039, 2.07004162658376],
            [33.459621977762964, 2.070304215004958],
            [33.45886100590264, 2.072258576819088],
            [33.4578868296894, 2.073543529113143],
            [33.45683406346523, 2.077117382841228],
            [33.45356422098386, 2.079135806792431],
            [33.45219407188498, 2.081334615663356],
            [33.45178049201973, 2.083551237646284],
            [33.45102531069973, 2.084202839600203],
            [33.449016970575215, 2.089360185392541],
            [33.449297912392126, 2.091088077166701],
            [33.44834913514523, 2.096751752319013],
            [33.44726504197214, 2.096987287275527],
            [33.44481822068273, 2.10387273259526],
            [33.44174317248082, 2.107311458937682],
            [33.44039723657211, 2.107800383723341],
            [33.440214784246336, 2.108542286711883],
            [33.438680114991335, 2.10943837494032],
            [33.4381201088365, 2.110668920050023],
            [33.437528953599156, 2.111058106896118],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 740,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "ORUNGO",
        Population: 14758,
        Key: "AMURIAORUNGO",
        Dist2: "Amuria",
        "Sub Country": "Orungo",
        id2_original: "AmuriaOrungo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.53742767592309, 2.084192117220424],
            [33.53350914021214, 2.081915118030551],
            [33.532575758292595, 2.080547080195963],
            [33.5319570885564, 2.080327074284188],
            [33.53134743790569, 2.078623000784972],
            [33.53071930531631, 2.078565765480547],
            [33.52982427067962, 2.077216048206944],
            [33.52588431553902, 2.077284396497483],
            [33.52181043596259, 2.075265511442684],
            [33.51913619987079, 2.075266397498325],
            [33.51615671804209, 2.073093938353316],
            [33.51292144902104, 2.071649172137496],
            [33.510117494405605, 2.071506647014801],
            [33.50541598978794, 2.073121528207083],
            [33.504510428692726, 2.073887127829363],
            [33.50240147186651, 2.074090315727234],
            [33.50141994923088, 2.074761878044915],
            [33.500337968895366, 2.074234812922809],
            [33.4990277131714, 2.075232514621928],
            [33.498105909637545, 2.076611063141584],
            [33.49828798916249, 2.077854774918759],
            [33.497747556399354, 2.080587997516352],
            [33.49120461863698, 2.083776032450924],
            [33.48565772477678, 2.087358888662362],
            [33.48467960406116, 2.093679848868763],
            [33.48240522157705, 2.095068257886929],
            [33.478946149879384, 2.096445838345657],
            [33.47525413065551, 2.100005759599522],
            [33.47458145779771, 2.101057934226022],
            [33.471530770109695, 2.110364315865901],
            [33.47010207151553, 2.112759660248909],
            [33.46596511313819, 2.116565913283501],
            [33.46237252394154, 2.118066614251978],
            [33.462027867316465, 2.118693422559335],
            [33.46210615549347, 2.12010908321139],
            [33.45888114253805, 2.123293940378125],
            [33.4573078017084, 2.125689322222659],
            [33.45512686647172, 2.127892815183508],
            [33.452848915879315, 2.125754028229768],
            [33.448828952287954, 2.123612050585831],
            [33.44423137735875, 2.119406548135173],
            [33.441379270349124, 2.116313304291855],
            [33.437528953599156, 2.111058106896118],
            [33.4381201088365, 2.110668920050023],
            [33.438680114991335, 2.10943837494032],
            [33.440214784246336, 2.108542286711883],
            [33.44039723657211, 2.107800383723341],
            [33.44174317248082, 2.107311458937682],
            [33.44481822068273, 2.10387273259526],
            [33.44726504197214, 2.096987287275527],
            [33.44834913514523, 2.096751752319013],
            [33.449297912392126, 2.091088077166701],
            [33.449016970575215, 2.089360185392541],
            [33.45102531069973, 2.084202839600203],
            [33.45178049201973, 2.083551237646284],
            [33.45219407188498, 2.081334615663356],
            [33.45356422098386, 2.079135806792431],
            [33.45683406346523, 2.077117382841228],
            [33.4578868296894, 2.073543529113143],
            [33.45886100590264, 2.072258576819088],
            [33.459621977762964, 2.070304215004958],
            [33.46040142707039, 2.07004162658376],
            [33.45939541995337, 2.066178867001271],
            [33.458034363601776, 2.056906133548776],
            [33.45639525351694, 2.053975392034328],
            [33.45635842079365, 2.052907858060021],
            [33.45767940240209, 2.04983151277561],
            [33.45888462710305, 2.048781719887509],
            [33.46799555720855, 2.045368366576577],
            [33.46959688684753, 2.04398371239161],
            [33.47213061115751, 2.042680205033196],
            [33.47244681454426, 2.041965400093268],
            [33.473421247675674, 2.041648467401561],
            [33.474425768979195, 2.040444930215331],
            [33.47493748889091, 2.039521987221324],
            [33.47459621801615, 2.039069742115088],
            [33.475551619439955, 2.037124366537446],
            [33.47544179590488, 2.036319221443514],
            [33.47625753625147, 2.035314772188157],
            [33.476056151032765, 2.032772642517432],
            [33.477176167834045, 2.030646275412954],
            [33.4780223350176, 2.029922268568061],
            [33.47854613906653, 2.029967348264254],
            [33.48057996888722, 2.027840712631932],
            [33.48136520963326, 2.026347733018759],
            [33.48131603136303, 2.025388775741813],
            [33.482144093900345, 2.024266707548018],
            [33.48172349998939, 2.023534029126613],
            [33.48350091649201, 2.019073362483706],
            [33.48292797190212, 2.018177885870517],
            [33.48334186258443, 2.017146413598886],
            [33.48280559890255, 2.016748508071405],
            [33.48316359461127, 2.015734141699218],
            [33.4825618069142, 2.015405544663996],
            [33.48303918243599, 2.014348453048914],
            [33.483645708746145, 2.014576994942997],
            [33.48451102441829, 2.015924728829076],
            [33.4858997407958, 2.015969546768541],
            [33.48660603669636, 2.015507940426664],
            [33.4871052457711, 2.016023465292343],
            [33.48809826863901, 2.015914603001821],
            [33.48998684806478, 2.016782535824822],
            [33.490376571371016, 2.017641874841833],
            [33.49094919616067, 2.017460762855897],
            [33.49221607762945, 2.017903675522352],
            [33.49320844472717, 2.017487215308672],
            [33.49308694309343, 2.017125375522943],
            [33.49361062317483, 2.0167814324792],
            [33.495128166947225, 2.017209653511239],
            [33.49576625915816, 2.016138442213459],
            [33.49647269699255, 2.016156319292099],
            [33.49722670151952, 2.015637165724717],
            [33.49761194133416, 2.014749407058106],
            [33.49812963234756, 2.014778841015707],
            [33.50236457356624, 2.011759494687304],
            [33.50405223938882, 2.012724623135879],
            [33.50610091297125, 2.01303029279634],
            [33.50853193289484, 2.014929683531299],
            [33.51208257076771, 2.016377040553288],
            [33.51254209137488, 2.017228328685492],
            [33.513904524843824, 2.01771072213341],
            [33.51430733031552, 2.018707394262972],
            [33.51523121524589, 2.019392400355036],
            [33.51611341475382, 2.018795076466565],
            [33.51720235613447, 2.0192619777469],
            [33.51840431456105, 2.018129809130011],
            [33.520380731255315, 2.018373181454548],
            [33.521159702658984, 2.0177083978371],
            [33.52200078627636, 2.01764063413978],
            [33.522558243012426, 2.018144044879957],
            [33.52306904484594, 2.017977745959932],
            [33.52456076654547, 2.019342669981286],
            [33.52594388102889, 2.019939261098724],
            [33.52761580567273, 2.020047739777556],
            [33.53026275543777, 2.019403106111927],
            [33.53194977447337, 2.018327877894209],
            [33.53365611177912, 2.016035907337787],
            [33.535079221953914, 2.013013786564299],
            [33.53716482437939, 2.011420849998544],
            [33.53904176163908, 2.009339450809786],
            [33.54001936582344, 2.006824101178069],
            [33.54221828084053, 2.004634031497716],
            [33.5461662516484, 1.997802343977885],
            [33.54729376309413, 1.993197124188722],
            [33.551869693116544, 1.990526769918139],
            [33.55268706660029, 1.987893865583481],
            [33.552601268507516, 1.986763040804798],
            [33.55349401603349, 1.986029946082466],
            [33.55453253767222, 1.985957220864768],
            [33.55508704434089, 1.985441364247005],
            [33.55595702765928, 1.985540584651105],
            [33.557646028378386, 1.984581047734573],
            [33.55880397025433, 1.983675972105225],
            [33.55959855258102, 1.981821102837346],
            [33.56120972955211, 1.980205785834671],
            [33.5612263205371, 1.980917459450879],
            [33.56313010215243, 1.982496612380731],
            [33.564439195456416, 1.984291394499116],
            [33.56565274484508, 1.984961195870258],
            [33.56653342350522, 1.986205585110062],
            [33.566724786220306, 1.989245442334584],
            [33.56725361544491, 1.990975973383873],
            [33.566318387487456, 1.993493615982626],
            [33.5668672671092, 1.993665981838126],
            [33.56844652783659, 1.997737764740705],
            [33.569441627609415, 1.998784259955564],
            [33.569602901254065, 2.00225833752817],
            [33.568802991019425, 2.003581549223033],
            [33.567525834620405, 2.009309582236753],
            [33.56549010576122, 2.011569889221629],
            [33.56590917163788, 2.012565497671739],
            [33.56524393413569, 2.015208308665048],
            [33.565196260543566, 2.019678284887174],
            [33.561468523405686, 2.021995372212178],
            [33.55965823125859, 2.022395508275521],
            [33.556729757568355, 2.023844741239829],
            [33.556641791840775, 2.025945926313412],
            [33.55520380825985, 2.028548747599535],
            [33.55522267018587, 2.033615519998877],
            [33.55551416091914, 2.034459881019199],
            [33.55796450450279, 2.036854545794606],
            [33.557762556938705, 2.047298377196211],
            [33.55740325148632, 2.048504878073478],
            [33.55647850058003, 2.049229026478797],
            [33.55461227662841, 2.051866470928001],
            [33.551632483982594, 2.05412515539412],
            [33.549341233832415, 2.056976621121982],
            [33.549007279735655, 2.05826138647774],
            [33.54600779781545, 2.063093434434397],
            [33.543943027321426, 2.064921608259465],
            [33.54269924872511, 2.071390526761846],
            [33.54067353069144, 2.074060042585005],
            [33.53989025545924, 2.0762315542003],
            [33.53889353332899, 2.077100394292418],
            [33.53846660090539, 2.079344158620303],
            [33.537326968491556, 2.081416277001717],
            [33.53742767592309, 2.084192117220424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 741,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "OGOLAI",
        Population: 13891,
        Key: "AMURIAOGOLAI",
        Dist2: "Amuria",
        "Sub Country": "Ogolai",
        id2_original: "AmuriaOgolai",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.657968938772726, 2.059408896089975],
            [33.64676966099026, 2.055916504461964],
            [33.64438920364075, 2.056930889529585],
            [33.643279199461624, 2.057691402302094],
            [33.64119708699104, 2.06055514984307],
            [33.64023573692342, 2.060947087176184],
            [33.639629568142745, 2.062191072479856],
            [33.638702737636564, 2.063037880022951],
            [33.63666557147289, 2.063833314369773],
            [33.633838407983774, 2.064168419948068],
            [33.63231663763796, 2.0657352207265],
            [33.63035012127644, 2.071534376044112],
            [33.629502486245705, 2.072738181540991],
            [33.629301160315805, 2.076141873210919],
            [33.628625501458, 2.078097306878222],
            [33.62745287392377, 2.074873679986924],
            [33.62583869657964, 2.072828689530341],
            [33.62470015741551, 2.071961970218476],
            [33.62254135936237, 2.071614268466706],
            [33.62074474586211, 2.070484139618388],
            [33.618642223668274, 2.068167253382799],
            [33.61816647140224, 2.066676483840805],
            [33.61801404706148, 2.063932859442647],
            [33.61720902002296, 2.061393578807986],
            [33.61549840763476, 2.058797831055083],
            [33.61238774841838, 2.055913134357152],
            [33.610676035593926, 2.043605789171841],
            [33.6110027959819, 2.036743094004397],
            [33.61292609170014, 2.034660047620779],
            [33.61542154508411, 2.028234768569689],
            [33.61306981855234, 2.027397947216585],
            [33.611602829269195, 2.025923125163114],
            [33.61240742870962, 2.02351234564749],
            [33.61304749541754, 2.022959347255979],
            [33.613459350517424, 2.019696729309437],
            [33.6168053072528, 2.019778577833521],
            [33.61823072519957, 2.020567673882842],
            [33.618828958263016, 2.018634905707918],
            [33.62136900401767, 2.0176572696021],
            [33.62781165206513, 2.014142963811628],
            [33.62805930231758, 2.013623369699774],
            [33.63144647375822, 2.013505689443811],
            [33.6354320363658, 2.011945632078294],
            [33.641378032842084, 2.011634923078283],
            [33.64225876540115, 2.006515481199417],
            [33.642158574500876, 2.004669997779402],
            [33.64127349768911, 2.002914513368773],
            [33.64431977375075, 2.004490257935039],
            [33.65129955504928, 2.005594075623902],
            [33.65605753674886, 2.007249162001689],
            [33.65931602542336, 2.01631551712395],
            [33.662386548811156, 2.020084176143982],
            [33.66070988465586, 2.021521022136569],
            [33.65949751565344, 2.023891179408408],
            [33.65682224021086, 2.026836400846792],
            [33.65653735838314, 2.028344483796294],
            [33.65646655137583, 2.029744768710951],
            [33.656931142074455, 2.031396161394243],
            [33.66014992611171, 2.037422216704217],
            [33.65813165421341, 2.041424738551929],
            [33.6558028634675, 2.044456175093368],
            [33.65469305332444, 2.045216206321461],
            [33.65494604765456, 2.053914901540757],
            [33.657968938772726, 2.059408896089975],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 742,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "AMURIA TOWN COUNCIL",
        Population: 7262,
        Key: "AMURIAAMURIA TOWN COUNCIL",
        Dist2: "Amuria",
        "Sub Country": "Amuria TC",
        id2_original: "AmuriaAmuria TC",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.68939185020607, 2.157709088892707],
            [33.689390925839625, 2.158751893657411],
            [33.68880698856562, 2.159380354125228],
            [33.68864579037947, 2.160692108856997],
            [33.68755621568649, 2.160984623031829],
            [33.687889652353654, 2.161736055213397],
            [33.68750508268221, 2.163670243201323],
            [33.68784336126876, 2.164603584166464],
            [33.686939568058044, 2.165341220001333],
            [33.68700175752683, 2.166068840134887],
            [33.68498443245285, 2.166744749465794],
            [33.683381553220045, 2.168430559597625],
            [33.682754022501896, 2.168592452043837],
            [33.6820923162771, 2.169177943179229],
            [33.68190720403978, 2.170231204206809],
            [33.680570235114196, 2.170657868045051],
            [33.68052778073387, 2.171490854153686],
            [33.678990818978285, 2.172297230179886],
            [33.678224467107746, 2.172183836536721],
            [33.67584230116256, 2.175625546151628],
            [33.67588675519273, 2.176715534322131],
            [33.674951449980156, 2.178039762358159],
            [33.67554739503456, 2.17840694283986],
            [33.67479030659123, 2.178672672623313],
            [33.67513415742748, 2.179474528655014],
            [33.67455010337245, 2.181577398261229],
            [33.67539300428165, 2.182977264522491],
            [33.67471882674575, 2.183778223289778],
            [33.67463047114934, 2.185724249224504],
            [33.674234577315445, 2.186309660095387],
            [33.674663475252906, 2.187698942118993],
            [33.674217344933325, 2.187681192677164],
            [33.67363979557928, 2.189078110719163],
            [33.67382272491048, 2.191117363284572],
            [33.67302350098872, 2.191628157805764],
            [33.6730448629262, 2.192842893496213],
            [33.67170482984718, 2.195781627210586],
            [33.67171449482132, 2.197442173511333],
            [33.67261599463315, 2.198171809505817],
            [33.67290162116423, 2.199775521821941],
            [33.672083311635966, 2.200669887633205],
            [33.671386807371974, 2.200853325653815],
            [33.671166056272384, 2.202031070582547],
            [33.67162304452877, 2.20237553908407],
            [33.6716233858886, 2.203136699972748],
            [33.67085986730444, 2.203697144841764],
            [33.67097437196043, 2.204357724214602],
            [33.670260651484035, 2.204544746996844],
            [33.6700644540361, 2.206111602148153],
            [33.66830599198597, 2.207152249504313],
            [33.66918420117739, 2.207661685779044],
            [33.668263867287344, 2.208724855830999],
            [33.66918665806971, 2.209861671690931],
            [33.66726875493812, 2.210175821248981],
            [33.66719143783991, 2.211130042157222],
            [33.665846805386686, 2.212724243416221],
            [33.666154158571224, 2.213712986107323],
            [33.66543309167247, 2.213368852362372],
            [33.66501105237218, 2.213776147092075],
            [33.66524409691646, 2.21497019825654],
            [33.66462464384938, 2.215047103913657],
            [33.66424705139272, 2.216139072254288],
            [33.66516362762993, 2.216782998403595],
            [33.665083821300094, 2.217360255456207],
            [33.66448785558442, 2.217508186959336],
            [33.664367998765954, 2.21804519075836],
            [33.6628021930049, 2.217804270741246],
            [33.662735767979555, 2.218466538582493],
            [33.66315401998258, 2.218779571445138],
            [33.66188226515337, 2.219621367118263],
            [33.660926793661, 2.22153692071733],
            [33.661109396903726, 2.222064839835612],
            [33.6605314298331, 2.222204946142502],
            [33.66001953205495, 2.220915841589037],
            [33.659571288897844, 2.220721144248897],
            [33.65890091213393, 2.22139612675466],
            [33.658538302677925, 2.220391013535148],
            [33.657780291664764, 2.220060758873163],
            [33.65751176815836, 2.219487399535701],
            [33.65625096738574, 2.219643140305196],
            [33.65551296814215, 2.219063243281821],
            [33.65383616744293, 2.218807611081772],
            [33.65101852609582, 2.216973725090066],
            [33.64981121011687, 2.216744866527997],
            [33.64928776359744, 2.216009693109871],
            [33.64647041240616, 2.21482348998888],
            [33.64263877163094, 2.209980935786334],
            [33.639202696804574, 2.204773864168132],
            [33.63641827785159, 2.202110059461826],
            [33.63507485183576, 2.197185433476288],
            [33.634966535673776, 2.194797094286476],
            [33.635307994296426, 2.193420589814019],
            [33.634555592363874, 2.190445548341658],
            [33.63442030698043, 2.187706383724797],
            [33.6393468009492, 2.180889960582127],
            [33.638580809303065, 2.179037121353983],
            [33.63315177081486, 2.174203787897321],
            [33.62973964687061, 2.17212537758609],
            [33.62880874430125, 2.170773866842904],
            [33.62611679253372, 2.160323751708906],
            [33.62363519476471, 2.158608904358206],
            [33.61985999424047, 2.153254840953773],
            [33.6194459876755, 2.151955102462569],
            [33.61035040708323, 2.135749204701014],
            [33.60860076918412, 2.136636451063612],
            [33.608393676968426, 2.136933428675641],
            [33.60890243333802, 2.137318557628674],
            [33.60782908581234, 2.138149692981195],
            [33.606949485130556, 2.138095762466936],
            [33.6048434711852, 2.139326955319905],
            [33.60315291638065, 2.139427140120459],
            [33.60259196789307, 2.14076627892913],
            [33.60023856330835, 2.141771396873454],
            [33.60009709482079, 2.142515641763678],
            [33.5989116743786, 2.117133305991084],
            [33.60012963269868, 2.101239759367822],
            [33.59544359527358, 2.074161993821313],
            [33.597316561081406, 2.06556041264467],
            [33.600472378607144, 2.065992143380092],
            [33.603102413095364, 2.066857005856737],
            [33.60544923482568, 2.068261221484848],
            [33.608816550803574, 2.068567892330155],
            [33.61184777559265, 2.06819626353136],
            [33.61273861779192, 2.068551274452033],
            [33.61541049939937, 2.067932221335862],
            [33.618642223668274, 2.068167253382799],
            [33.62074474586211, 2.070484139618388],
            [33.62254135936237, 2.071614268466706],
            [33.62470015741551, 2.071961970218476],
            [33.62583869657964, 2.072828689530341],
            [33.62745287392377, 2.074873679986924],
            [33.628625501458, 2.078097306878222],
            [33.629301160315805, 2.076141873210919],
            [33.629502486245705, 2.072738181540991],
            [33.63035012127644, 2.071534376044112],
            [33.63231663763796, 2.0657352207265],
            [33.633838407983774, 2.064168419948068],
            [33.63666557147289, 2.063833314369773],
            [33.638702737636564, 2.063037880022951],
            [33.639629568142745, 2.062191072479856],
            [33.64023573692342, 2.060947087176184],
            [33.64119708699104, 2.06055514984307],
            [33.643279199461624, 2.057691402302094],
            [33.64438920364075, 2.056930889529585],
            [33.64676966099026, 2.055916504461964],
            [33.657968938772726, 2.059408896089975],
            [33.65916944282685, 2.062091322614704],
            [33.66029739175213, 2.063493081769087],
            [33.665405004946784, 2.066584886552515],
            [33.67496167729964, 2.075673243321929],
            [33.675293097248996, 2.077754623858592],
            [33.67468252402849, 2.080036457910436],
            [33.674784862800585, 2.081010568277422],
            [33.6753457295415, 2.0816768535328],
            [33.67422543605912, 2.083728187498167],
            [33.6741494287046, 2.084753646105482],
            [33.67435418530058, 2.086881316333214],
            [33.67481322890233, 2.087778365861965],
            [33.67593489411218, 2.08893148366187],
            [33.677489377507364, 2.089238436863544],
            [33.67726047509487, 2.090238325778706],
            [33.680243884358006, 2.091438695793991],
            [33.68268166679905, 2.094081300049965],
            [33.684131050899246, 2.094401108423201],
            [33.6859274694651, 2.095464422071231],
            [33.68627925152699, 2.100473785254107],
            [33.68679040280511, 2.102602841750779],
            [33.686678206819394, 2.105312023677951],
            [33.688597672121276, 2.108514600528433],
            [33.6898853343175, 2.114531146439779],
            [33.68970648782928, 2.116061647721629],
            [33.69364903011789, 2.121611212576684],
            [33.69432084328797, 2.123759199493355],
            [33.692784137552245, 2.125891524895092],
            [33.68907409003892, 2.129312805965577],
            [33.68346335111488, 2.132872091656288],
            [33.682266841868824, 2.134273390589595],
            [33.6807214611024, 2.1378888952052],
            [33.680447825283714, 2.142721707664134],
            [33.67974613504561, 2.145165214695246],
            [33.680173337862115, 2.145621444554553],
            [33.6801382963795, 2.146847532508255],
            [33.6807259814249, 2.148109137244524],
            [33.68239015720115, 2.149576094950334],
            [33.685648014359984, 2.153995636746982],
            [33.68772993728605, 2.154639049145129],
            [33.68869583732056, 2.155593762228312],
            [33.68876772769611, 2.156733073420249],
            [33.68927703652961, 2.157058367994375],
            [33.68939185020607, 2.157709088892707],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 743,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "WILLA",
        Population: 13447,
        Key: "AMURIAWILLA",
        Dist2: "Amuria",
        "Sub Country": "Willa",
        id2_original: "AmuriaWilla",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.69903484526785, 2.148116096091001],
            [33.69403564255831, 2.151798647297397],
            [33.692961203579564, 2.153465407275126],
            [33.69103450055147, 2.155101975557284],
            [33.69042734811554, 2.156882829598978],
            [33.68939185020607, 2.157709088892707],
            [33.68927703652961, 2.157058367994375],
            [33.68876772769611, 2.156733073420249],
            [33.68869583732056, 2.155593762228312],
            [33.68772993728605, 2.154639049145129],
            [33.685648014359984, 2.153995636746982],
            [33.68239015720115, 2.149576094950334],
            [33.6807259814249, 2.148109137244524],
            [33.6801382963795, 2.146847532508255],
            [33.680173337862115, 2.145621444554553],
            [33.67974613504561, 2.145165214695246],
            [33.680447825283714, 2.142721707664134],
            [33.6807214611024, 2.1378888952052],
            [33.682266841868824, 2.134273390589595],
            [33.68346335111488, 2.132872091656288],
            [33.68907409003892, 2.129312805965577],
            [33.692784137552245, 2.125891524895092],
            [33.69432084328797, 2.123759199493355],
            [33.69364903011789, 2.121611212576684],
            [33.68970648782928, 2.116061647721629],
            [33.6898853343175, 2.114531146439779],
            [33.688597672121276, 2.108514600528433],
            [33.686678206819394, 2.105312023677951],
            [33.68679040280511, 2.102602841750779],
            [33.68627925152699, 2.100473785254107],
            [33.6859274694651, 2.095464422071231],
            [33.684131050899246, 2.094401108423201],
            [33.68268166679905, 2.094081300049965],
            [33.680243884358006, 2.091438695793991],
            [33.67726047509487, 2.090238325778706],
            [33.677489377507364, 2.089238436863544],
            [33.67593489411218, 2.08893148366187],
            [33.67481322890233, 2.087778365861965],
            [33.67435418530058, 2.086881316333214],
            [33.6741494287046, 2.084753646105482],
            [33.67422543605912, 2.083728187498167],
            [33.6753457295415, 2.0816768535328],
            [33.674784862800585, 2.081010568277422],
            [33.67468252402849, 2.080036457910436],
            [33.675293097248996, 2.077754623858592],
            [33.67496167729964, 2.075673243321929],
            [33.665405004946784, 2.066584886552515],
            [33.66029739175213, 2.063493081769087],
            [33.65916944282685, 2.062091322614704],
            [33.657968938772726, 2.059408896089975],
            [33.65494604765456, 2.053914901540757],
            [33.65469305332444, 2.045216206321461],
            [33.6558028634675, 2.044456175093368],
            [33.65813165421341, 2.041424738551929],
            [33.66014992611171, 2.037422216704217],
            [33.656931142074455, 2.031396161394243],
            [33.65646655137583, 2.029744768710951],
            [33.65653735838314, 2.028344483796294],
            [33.65682224021086, 2.026836400846792],
            [33.65949751565344, 2.023891179408408],
            [33.66070988465586, 2.021521022136569],
            [33.662386548811156, 2.020084176143982],
            [33.65931602542336, 2.01631551712395],
            [33.65605753674886, 2.007249162001689],
            [33.656335055984535, 2.006317186559268],
            [33.658218211382604, 2.005487358296134],
            [33.664988024059895, 2.005663236743957],
            [33.6654093024871, 2.003158001080776],
            [33.66674221012927, 1.999362473184294],
            [33.669763177056126, 1.992857254694383],
            [33.67047107734776, 1.989039890697569],
            [33.670132543639696, 1.987299742447282],
            [33.67035012458467, 1.9823201236615],
            [33.67142760076737, 1.973431309799381],
            [33.67046393394464, 1.971290333285669],
            [33.66800086303004, 1.969597908793557],
            [33.6707032262717, 1.969964631302797],
            [33.675186158204326, 1.969341078645857],
            [33.68070934732078, 1.97117795051999],
            [33.68470371880803, 1.9733242330732],
            [33.68541018359187, 1.977612031631037],
            [33.682946481161636, 1.993579859512202],
            [33.67660949924613, 2.000317922031796],
            [33.679704521488375, 2.003632423831212],
            [33.68145968043321, 2.002478640512883],
            [33.68297076621704, 2.000760699295292],
            [33.68353314033099, 2.004489474185685],
            [33.6845338689474, 2.006868749690096],
            [33.69081436569615, 2.013316684783132],
            [33.69321060644515, 2.011904392505584],
            [33.69430112077589, 2.009904629286277],
            [33.6965357429272, 2.007732491178525],
            [33.69784834505069, 2.007324830943253],
            [33.70205993276692, 2.003713432852327],
            [33.71237863699215, 2.003139013322899],
            [33.71390588077297, 2.002686016527025],
            [33.71624684638594, 2.000842395250583],
            [33.72417575257938, 2.005524634398275],
            [33.729173923124655, 2.0062501944662],
            [33.73078738900312, 2.005975082552263],
            [33.731763879276514, 2.005957238579401],
            [33.73133893662124, 2.007908636020665],
            [33.73208415742139, 2.008878035610066],
            [33.73460799577168, 2.014923715223776],
            [33.734912024291404, 2.017888882262441],
            [33.736299659995616, 2.021450623683629],
            [33.73747922791372, 2.022872628568885],
            [33.738711227800025, 2.025733181100791],
            [33.74089855993984, 2.027363091059776],
            [33.74256037314685, 2.029462077462091],
            [33.74368145445176, 2.033600956706338],
            [33.74285640755883, 2.040994552482978],
            [33.742112206346555, 2.043276304545589],
            [33.73775336678897, 2.051607889668108],
            [33.73567037217278, 2.053933604119678],
            [33.73480241275874, 2.056489344074587],
            [33.74705630100669, 2.056652762670294],
            [33.746992092125126, 2.059724096226558],
            [33.748202174016825, 2.061006748794424],
            [33.749986811177685, 2.061695245215119],
            [33.748010001021356, 2.070932578435673],
            [33.74838903707065, 2.07598228811401],
            [33.747571833368454, 2.079434396914244],
            [33.74814639851914, 2.082366849141745],
            [33.744980174909166, 2.088011389451186],
            [33.74417539760231, 2.093294965827931],
            [33.738128521217945, 2.095872206169748],
            [33.73622502077528, 2.095873108372648],
            [33.73360080108187, 2.096579975665024],
            [33.72262687646818, 2.096033278556756],
            [33.716288401552674, 2.100541384738916],
            [33.71240898118413, 2.104617401501177],
            [33.71198117739468, 2.106116753979042],
            [33.71209778141352, 2.108027294533458],
            [33.7112856594809, 2.110993262028439],
            [33.70868032596803, 2.113718040425267],
            [33.7073263564257, 2.118493836642588],
            [33.70715375502534, 2.131311489397876],
            [33.70662056537832, 2.135979198569885],
            [33.70216728862987, 2.141374923160335],
            [33.70092137204319, 2.143632123773573],
            [33.69991283257542, 2.14705256997635],
            [33.69903484526785, 2.148116096091001],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 744,
        District: "AMURIA",
        County: "AMURIA",
        Subcounty: "APEDURU",
        Population: 14718,
        Key: "AMURIAAPEDURU",
        Dist2: "Amuria",
        "Sub Country": "Apeduru",
        id2_original: "AmuriaApeduru",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.79564097617418, 2.170304735125256],
            [33.792299058264284, 2.168506009826266],
            [33.79032399533118, 2.168271843995662],
            [33.788481877670215, 2.167549101975565],
            [33.785988873992025, 2.16778561263826],
            [33.78390798862014, 2.166149303089331],
            [33.780531066058586, 2.164468429422681],
            [33.778856609962254, 2.16298568698912],
            [33.77632107554696, 2.162480396283915],
            [33.77333062349197, 2.162599537572247],
            [33.75455139008817, 2.156149890801883],
            [33.751411077484235, 2.158973949491641],
            [33.747366854888625, 2.160727227760439],
            [33.744156282351376, 2.16360107645597],
            [33.7369055062811, 2.168814630315825],
            [33.73270294932845, 2.169315321932621],
            [33.729348053457656, 2.169029726823455],
            [33.72675044725285, 2.159601442171566],
            [33.71820832499534, 2.156316038659968],
            [33.70938287140227, 2.151820375686262],
            [33.69903484526785, 2.148116096091001],
            [33.69991283257542, 2.14705256997635],
            [33.70092137204319, 2.143632123773573],
            [33.70216728862987, 2.141374923160335],
            [33.70662056537832, 2.135979198569885],
            [33.70715375502534, 2.131311489397876],
            [33.7073263564257, 2.118493836642588],
            [33.70868032596803, 2.113718040425267],
            [33.7112856594809, 2.110993262028439],
            [33.71209778141352, 2.108027294533458],
            [33.71198117739468, 2.106116753979042],
            [33.71240898118413, 2.104617401501177],
            [33.716288401552674, 2.100541384738916],
            [33.72262687646818, 2.096033278556756],
            [33.73360080108187, 2.096579975665024],
            [33.73622502077528, 2.095873108372648],
            [33.738128521217945, 2.095872206169748],
            [33.74417539760231, 2.093294965827931],
            [33.744980174909166, 2.088011389451186],
            [33.74814639851914, 2.082366849141745],
            [33.747571833368454, 2.079434396914244],
            [33.74838903707065, 2.07598228811401],
            [33.748010001021356, 2.070932578435673],
            [33.749986811177685, 2.061695245215119],
            [33.748202174016825, 2.061006748794424],
            [33.746992092125126, 2.059724096226558],
            [33.74705630100669, 2.056652762670294],
            [33.73480241275874, 2.056489344074587],
            [33.73567037217278, 2.053933604119678],
            [33.73775336678897, 2.051607889668108],
            [33.742112206346555, 2.043276304545589],
            [33.74285640755883, 2.040994552482978],
            [33.74368145445176, 2.033600956706338],
            [33.74256037314685, 2.029462077462091],
            [33.74089855993984, 2.027363091059776],
            [33.738711227800025, 2.025733181100791],
            [33.73747922791372, 2.022872628568885],
            [33.736299659995616, 2.021450623683629],
            [33.734912024291404, 2.017888882262441],
            [33.73460799577168, 2.014923715223776],
            [33.73208415742139, 2.008878035610066],
            [33.73133893662124, 2.007908636020665],
            [33.731763879276514, 2.005957238579401],
            [33.73078738900312, 2.005975082552263],
            [33.7365866555592, 2.000977282132692],
            [33.74130106896749, 1.995350498398264],
            [33.74514298107969, 1.99200911943361],
            [33.752164314849985, 1.988455358897322],
            [33.753910208570986, 1.986028935187037],
            [33.75578559084691, 1.980648006490499],
            [33.75718859852228, 1.981434403790738],
            [33.75958860500899, 1.983631586012185],
            [33.762186909204736, 1.984426470372157],
            [33.76774509668468, 1.982876939653114],
            [33.76897402792598, 1.982847260030314],
            [33.77276729716384, 1.984047767534125],
            [33.775468880667816, 1.983889674427804],
            [33.77857687817603, 1.984382849204932],
            [33.777829154669504, 1.987901702258475],
            [33.77911708276708, 1.994890214940444],
            [33.780689127327776, 1.998958472864147],
            [33.779858875596105, 2.002703665720206],
            [33.78231768310635, 2.008801606334974],
            [33.78252081015839, 2.011022214089948],
            [33.783454273824645, 2.012773305126911],
            [33.784993948492364, 2.014524100715529],
            [33.78757513618872, 2.01643077322747],
            [33.7888015153163, 2.014352266734145],
            [33.78945734835577, 2.014259500275009],
            [33.79552407032142, 2.014854910008993],
            [33.79805215770301, 2.015691398475332],
            [33.80066969213406, 2.017006541002439],
            [33.80461570371633, 2.019940324043119],
            [33.807048263352286, 2.020689956426428],
            [33.80828184786675, 2.02196487364665],
            [33.80891018886525, 2.022091207657366],
            [33.81890998307981, 2.01908277726731],
            [33.82032446224135, 2.017996500128051],
            [33.8206377865276, 2.016377049530863],
            [33.82247390164583, 2.015625272207285],
            [33.82536905592389, 2.015479055013317],
            [33.82764033203374, 2.016246830472193],
            [33.82824027369286, 2.016897856533884],
            [33.82917071273155, 2.016562666591854],
            [33.83296380050971, 2.012951244947001],
            [33.83561039274527, 2.011384873092246],
            [33.83874166200922, 2.008153732679646],
            [33.83948551916678, 2.006714989592937],
            [33.84079663996835, 2.002462561511273],
            [33.84151418187797, 1.996808268916896],
            [33.843364034033506, 1.993315454094932],
            [33.85061222654904, 1.983740761075364],
            [33.85365124062994, 1.981559038737767],
            [33.858899527303166, 1.978824342445701],
            [33.8633780512027, 1.978496336848091],
            [33.86953405133455, 1.979406765174917],
            [33.87793278630302, 1.978235348660869],
            [33.88019016637373, 1.978351744025098],
            [33.880950356699785, 1.97813422991217],
            [33.88175735913357, 1.9771749023764],
            [33.883717324980026, 1.977020067557733],
            [33.884619176931416, 1.975843581383929],
            [33.88585495692846, 1.97598765640569],
            [33.8870419269645, 1.97521809441584],
            [33.88887276717538, 1.976356925408293],
            [33.890844152405734, 1.975496476694023],
            [33.89236666925155, 1.976970176095864],
            [33.8941727393168, 1.976969197515052],
            [33.8943388539825, 1.976562029730153],
            [33.89457088522711, 1.974372736826992],
            [33.895330047880485, 1.973295833517435],
            [33.89613808427517, 1.973241118157885],
            [33.89704210026807, 1.974027641964127],
            [33.89792375090537, 1.976062543917922],
            [33.89771143408799, 1.977419799813465],
            [33.89742220261762, 1.978640968262955],
            [33.89640057469614, 1.978596293847744],
            [33.895450711386076, 1.979293363978742],
            [33.89256273464715, 1.988395362431753],
            [33.89161444967702, 1.989951817888529],
            [33.889120563853254, 1.991029672776084],
            [33.88953762199526, 1.992259718220766],
            [33.89296095960921, 1.993252929681029],
            [33.89374476844071, 1.993062532034902],
            [33.89384155562435, 1.994347032066303],
            [33.89127718528846, 1.996031018244586],
            [33.889044360666006, 1.996674512882307],
            [33.887896488904396, 1.998168787312256],
            [33.886775078816086, 1.998566851779161],
            [33.884371538357065, 2.000422167243728],
            [33.88270663404714, 2.00203259673944],
            [33.88154176166876, 2.003906650043955],
            [33.88120515844022, 2.004056174745814],
            [33.880795695553935, 2.0034673102792],
            [33.8795683660088, 2.003680897811424],
            [33.877950995153824, 2.006321022707355],
            [33.877615807670175, 2.006449947084052],
            [33.87702999112057, 2.005868274575103],
            [33.87653650521251, 2.006457627459514],
            [33.87765889626109, 2.007876505954633],
            [33.87977458326542, 2.006753967828334],
            [33.88245174337349, 2.007424949585887],
            [33.88308764279679, 2.006999433641498],
            [33.883618352195285, 2.00523303490474],
            [33.88560030790158, 2.004685455505675],
            [33.885874003009114, 2.006346591042705],
            [33.88324341066706, 2.009288030539249],
            [33.88410209407746, 2.012756025920026],
            [33.882803497587595, 2.014191527255973],
            [33.871724723410566, 2.016543084673441],
            [33.866812650995364, 2.018109939947858],
            [33.85975504774546, 2.019677929375311],
            [33.85849610468886, 2.021034284678389],
            [33.85571623300784, 2.021298102968601],
            [33.85283848269011, 2.022457547684165],
            [33.8477622180039, 2.022315485918615],
            [33.8436927168162, 2.022742796963422],
            [33.84086153426447, 2.023922597238731],
            [33.837071790914116, 2.027068901870249],
            [33.8340210690901, 2.028156757466865],
            [33.8285656632517, 2.028311637727599],
            [33.82287615195872, 2.029873013428004],
            [33.82021058910099, 2.032475296027431],
            [33.81937715463826, 2.032841997292559],
            [33.81548514078776, 2.032084089685374],
            [33.81247431943372, 2.032501750030609],
            [33.81067489151169, 2.033624406821223],
            [33.808338918735046, 2.036236998497476],
            [33.80711373436681, 2.039893597553711],
            [33.80565196788872, 2.042315830269126],
            [33.80324576033163, 2.043575271264236],
            [33.801476134019126, 2.043789823076953],
            [33.79491555783615, 2.042249994163433],
            [33.790052379823564, 2.046263031813121],
            [33.78971250403244, 2.047541769362124],
            [33.78836739816704, 2.049452257789456],
            [33.782951480471915, 2.055149681544669],
            [33.77902733208704, 2.063539183038925],
            [33.778044470961625, 2.067193724019225],
            [33.78332621898087, 2.068756135504858],
            [33.78367728059392, 2.069533950844596],
            [33.78319520598488, 2.084569304535793],
            [33.78438519795357, 2.095261545746325],
            [33.78431322942457, 2.097450809107674],
            [33.78314303362983, 2.100679132302904],
            [33.78301035066574, 2.102642476565406],
            [33.78666475024214, 2.105715830151734],
            [33.79235813417234, 2.11540447982725],
            [33.79356420328964, 2.118148880517167],
            [33.79423928183576, 2.120866819333335],
            [33.794194649040875, 2.12370740230389],
            [33.79479336449963, 2.127632337941566],
            [33.79611265817366, 2.130738400641691],
            [33.79707348811672, 2.13474079636242],
            [33.79723872153514, 2.136216942170595],
            [33.796499594007564, 2.140405794187418],
            [33.79723912038711, 2.14892707797302],
            [33.79564097617418, 2.170304735125256],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 745,
        District: "AMURIA",
        County: "KAPELEBYONG",
        Subcounty: "AKOROMIT",
        Population: 18059,
        Key: "AMURIAAKOROMIT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.84937006941183, 2.343775902277493],
            [33.84942982534453, 2.343131551854567],
            [33.75345758522856, 2.403018855791996],
            [33.75194180484907, 2.404150787337722],
            [33.751210701971935, 2.406961783861747],
            [33.748387291644065, 2.410386032517339],
            [33.7425147081877, 2.412296071425938],
            [33.741680159814045, 2.412959514775532],
            [33.74084606598788, 2.414462736731608],
            [33.73599414656076, 2.417496765289278],
            [33.734457328535605, 2.416481994976295],
            [33.73448446843698, 2.41451068751593],
            [33.73310234030377, 2.413844887143072],
            [33.729774523248885, 2.41330777445454],
            [33.728109384478685, 2.41072755247815],
            [33.72630430884847, 2.410132880561108],
            [33.72342609410173, 2.406574741489167],
            [33.72283325003168, 2.40532704305605],
            [33.72200141636678, 2.405412577969786],
            [33.71918028955636, 2.403130774502927],
            [33.71801010274475, 2.40328739713807],
            [33.7177003474651, 2.40412429959201],
            [33.71657236889545, 2.404110713762114],
            [33.7148791622642, 2.4017148460088],
            [33.71422903981498, 2.398751144922963],
            [33.71159249433755, 2.398908530958928],
            [33.71081223834301, 2.398255944458653],
            [33.709742025039404, 2.395992724068107],
            [33.70846195720057, 2.395936797181497],
            [33.70708305312091, 2.395159340341447],
            [33.70670293550001, 2.394522848373108],
            [33.70689895687815, 2.392754167453335],
            [33.70660321621524, 2.392075186975148],
            [33.70746053598307, 2.390659879805852],
            [33.707094210196736, 2.389485734149227],
            [33.705659678841414, 2.389939232075598],
            [33.70539199256487, 2.389104601584767],
            [33.70437873514517, 2.388157166589242],
            [33.701551228499596, 2.387804906469368],
            [33.70169117344445, 2.386389970068992],
            [33.701156330897355, 2.385753554812201],
            [33.699890716951444, 2.38644748777886],
            [33.698751067469594, 2.385896273900162],
            [33.697738543973536, 2.386391994013187],
            [33.69612079941939, 2.386152291687148],
            [33.69540269875768, 2.384723641908681],
            [33.69212397912466, 2.382178544174216],
            [33.691869344470874, 2.379292343048309],
            [33.690237137938965, 2.378246163656175],
            [33.688026984997656, 2.374710102207995],
            [33.68524184649416, 2.374654900568985],
            [33.684523752120654, 2.373197942879375],
            [33.683566950223344, 2.37259002487693],
            [33.68241347387264, 2.37249155698436],
            [33.68106234120999, 2.370907571781803],
            [33.67971233952631, 2.371629824403361],
            [33.67875558164642, 2.371106794733028],
            [33.678965863779716, 2.369649372864172],
            [33.67864198339054, 2.368913799603082],
            [33.677699604843426, 2.369027453356668],
            [33.67601109909603, 2.36786808805646],
            [33.67561686265381, 2.367075953019405],
            [33.67578458620221, 2.364868669690729],
            [33.6745885261138, 2.363963735941905],
            [33.67460185351934, 2.362435666547243],
            [33.67392595570967, 2.360936230994436],
            [33.67264544859468, 2.35991814641293],
            [33.67277168345167, 2.359168202643464],
            [33.674064925084146, 2.35742727730889],
            [33.67443001658526, 2.356125416237337],
            [33.67413420495549, 2.355646613190842],
            [33.67139289884793, 2.356608280558033],
            [33.66906675992872, 2.355501328460257],
            [33.666153536038735, 2.355305741065689],
            [33.66407233086659, 2.354469526130479],
            [33.66304437700887, 2.354913250376144],
            [33.661600027965854, 2.354864693459],
            [33.65902910621655, 2.353782463193467],
            [33.65658155729173, 2.354768585780773],
            [33.65614141065029, 2.355827627817708],
            [33.65557852808992, 2.356172631264568],
            [33.65339990960836, 2.356419902486018],
            [33.6530573703124, 2.356814048740693],
            [33.65188171365903, 2.355509528534182],
            [33.64989904918199, 2.356002942940883],
            [33.64666744708395, 2.355536598830367],
            [33.64549272737343, 2.35625124548405],
            [33.64429311804135, 2.356079436245407],
            [33.643730434906935, 2.356867668699749],
            [33.642922654532086, 2.35701578866488],
            [33.64084137300315, 2.356007166839099],
            [33.639421485085286, 2.355933950507441],
            [33.637390299006455, 2.357412334812969],
            [33.63650884060866, 2.357043378616281],
            [33.63511366624258, 2.357487254626166],
            [33.63393855666321, 2.357364673742927],
            [33.63337587802038, 2.358177528083039],
            [33.632038809381825, 2.358412596696617],
            [33.63264705596575, 2.355988284954909],
            [33.63142541904458, 2.356087151635743],
            [33.630463913568434, 2.3550881159386],
            [33.62816694743806, 2.354630384477026],
            [33.62832924965372, 2.353319524571129],
            [33.628003241155646, 2.352811742901244],
            [33.626113703227475, 2.352796212455309],
            [33.62595849141434, 2.351927833799401],
            [33.62529867254995, 2.351502177360535],
            [33.6254277146422, 2.348651156917132],
            [33.62492247068539, 2.348012376311608],
            [33.62391250738786, 2.347914520609885],
            [33.6231300981316, 2.346702392493622],
            [33.62339041642622, 2.346014112229601],
            [33.6249540797053, 2.345833177110589],
            [33.62521419408234, 2.344686121421764],
            [33.62467614185471, 2.343523038788374],
            [33.62387777851897, 2.343064621387843],
            [33.623893501731395, 2.341786596127498],
            [33.622020077782786, 2.341345043411665],
            [33.622214951113996, 2.34000139821156],
            [33.61990128170926, 2.338544177172633],
            [33.61802880997484, 2.340265419082189],
            [33.617507513123904, 2.340150956070713],
            [33.61677406654218, 2.339135418885246],
            [33.61706615645178, 2.3365956347465],
            [33.616544574834855, 2.335825775768372],
            [33.61300905830316, 2.333926687478676],
            [33.61149784136529, 2.333704874554468],
            [33.60959269431075, 2.333864222881831],
            [33.60932788174478, 2.334190455479479],
            [33.60957259001467, 2.335058748199647],
            [33.607211260492534, 2.336370569455256],
            [33.60719019589746, 2.335167696063097],
            [33.60486446122011, 2.333586153832143],
            [33.60258367913794, 2.332800663804888],
            [33.60167099799578, 2.331621343226342],
            [33.60048182529065, 2.331425234596844],
            [33.59859247960195, 2.331819282874243],
            [33.59583921871461, 2.330788208976054],
            [33.59448625528541, 2.328445737734954],
            [33.593167693738344, 2.330445260100295],
            [33.59176684112134, 2.330429468212926],
            [33.59100091954381, 2.329610544528238],
            [33.58857429507691, 2.330627434058046],
            [33.587518264374985, 2.330549299498501],
            [33.58683087711284, 2.329415678757182],
            [33.58512016860491, 2.328515222494981],
            [33.585167884417835, 2.328088393000062],
            [33.587374299469246, 2.327757148729905],
            [33.58872990574202, 2.325932640747397],
            [33.58937256049627, 2.326334498565453],
            [33.590343085057874, 2.325501110765548],
            [33.59039981815963, 2.32459629786199],
            [33.59221189615749, 2.321809361006895],
            [33.5929100470334, 2.318347891929428],
            [33.59342377018817, 2.317715760297875],
            [33.594037687836504, 2.317686777426247],
            [33.59317957216133, 2.314154156764385],
            [33.592836944830495, 2.314226109681593],
            [33.59259403858105, 2.313766637064971],
            [33.59280756003924, 2.312229843245196],
            [33.59423502614485, 2.31158296516548],
            [33.595162256401345, 2.309672466488763],
            [33.59754643097947, 2.309341139817605],
            [33.59681784428344, 2.308278681579832],
            [33.5964745054869, 2.30664159169077],
            [33.59784462673804, 2.305448991031491],
            [33.59807223557651, 2.303466978551525],
            [33.59864286880117, 2.302375248207439],
            [33.59958468590126, 2.301225913239356],
            [33.60209699527321, 2.300075912229454],
            [33.602053705459646, 2.298984441385755],
            [33.60335235674677, 2.297619528768555],
            [33.60400909438976, 2.297590525740189],
            [33.60466641324269, 2.298940244840966],
            [33.6054229644935, 2.298609604126095],
            [33.60485019058352, 2.294602936900418],
            [33.60547761080886, 2.292764373053595],
            [33.60624820093094, 2.291873619906909],
            [33.605733517477134, 2.290193521651261],
            [33.606189998185364, 2.289274179296626],
            [33.60733177128455, 2.28834018305007],
            [33.60694595834475, 2.287550454662599],
            [33.6078021516252, 2.286530410662631],
            [33.60824390535269, 2.284548309122399],
            [33.609614435337264, 2.284389746051137],
            [33.609542685098866, 2.283528076288045],
            [33.61309640868476, 2.280568050477645],
            [33.614580270125586, 2.278341354999268],
            [33.615907947776165, 2.278154081339175],
            [33.61587908760101, 2.277436011300012],
            [33.61637865959514, 2.277148562911649],
            [33.616592966180896, 2.277507511877462],
            [33.61799153617874, 2.276171274405097],
            [33.619291123510415, 2.277075497789216],
            [33.61946177736324, 2.275510003047614],
            [33.6201616664792, 2.276256506628963],
            [33.62067553066949, 2.276012135942474],
            [33.62194536310396, 2.274115847377458],
            [33.62378632912475, 2.272362926905881],
            [33.62369992197421, 2.27062520622862],
            [33.62472784349256, 2.270596035699783],
            [33.62592610355509, 2.268283289674898],
            [33.627610428543164, 2.267492665245292],
            [33.62898000990678, 2.265194206058981],
            [33.63053624771175, 2.265351502913012],
            [33.630764234740965, 2.264331727749429],
            [33.63346175875816, 2.262520979143037],
            [33.63684467038773, 2.260968433809304],
            [33.63761568271798, 2.261126071318233],
            [33.63971385077766, 2.259961851424636],
            [33.64065612691683, 2.259990156865284],
            [33.641269665476095, 2.259171272722413],
            [33.64358221108843, 2.258538333174982],
            [33.64509512045227, 2.257589793577462],
            [33.64575112417165, 2.255952278843671],
            [33.6467793223711, 2.256583729470366],
            [33.64837815559188, 2.25623833474628],
            [33.64857773519689, 2.255577612605256],
            [33.650047616156954, 2.254198240406715],
            [33.65051808812574, 2.252718787544122],
            [33.65101766730639, 2.252488778417507],
            [33.650974320898975, 2.251325510269369],
            [33.65198764569229, 2.250621336490604],
            [33.652258580276936, 2.249903137015916],
            [33.65280097585897, 2.249644383763678],
            [33.65345785723239, 2.250003127701562],
            [33.65377171242299, 2.249485969464373],
            [33.65350025232391, 2.249026521940726],
            [33.654385366864915, 2.248954315324265],
            [33.655027171812904, 2.247517869498653],
            [33.65601224009895, 2.247488701198608],
            [33.65739510754567, 2.246058636943312],
            [33.65825608974488, 2.245900698893846],
            [33.65801050471926, 2.245190234629733],
            [33.65941257904501, 2.243294731629128],
            [33.66089902493892, 2.243590128922139],
            [33.66025580155108, 2.242193944496198],
            [33.661534943226876, 2.240275978943863],
            [33.66257176076148, 2.240063798356827],
            [33.664631709099076, 2.240513299382982],
            [33.66938564837986, 2.24258344207681],
            [33.67388094921562, 2.243077385636457],
            [33.67787969729496, 2.247889766844096],
            [33.679294431578015, 2.251545733707161],
            [33.686348405634185, 2.264804685803813],
            [33.6892822799959, 2.272818543228781],
            [33.691181150521594, 2.282633150734199],
            [33.69088280743931, 2.294610944345281],
            [33.69138305496652, 2.29693566678801],
            [33.69464477937266, 2.295452013037599],
            [33.696055354455986, 2.294171114657217],
            [33.69857273302108, 2.293572641994901],
            [33.69931234204563, 2.293016085917711],
            [33.700884587828945, 2.293046526089982],
            [33.7023218015537, 2.291922090127934],
            [33.70495900819118, 2.291077990867564],
            [33.70669668592057, 2.290983484650472],
            [33.708713224070365, 2.29004604453748],
            [33.71140235872114, 2.289649317903175],
            [33.71221848264836, 2.287588748945647],
            [33.71560556964734, 2.286172082395782],
            [33.71759151746677, 2.286684717078465],
            [33.72295266847229, 2.286253981237424],
            [33.72576356706489, 2.285129006771752],
            [33.72779116078086, 2.285464762436411],
            [33.728702850182934, 2.286016256287392],
            [33.730171655859614, 2.284808678996821],
            [33.730106205506324, 2.284116425505601],
            [33.73066384639703, 2.283395786812779],
            [33.737762106498366, 2.277471449671202],
            [33.75098453313284, 2.286287448261255],
            [33.76716929814714, 2.294943424259774],
            [33.76921577265377, 2.295229542439244],
            [33.77405320495035, 2.295014175370986],
            [33.78153888777244, 2.285157965172454],
            [33.79369525311654, 2.301432430921514],
            [33.80231435919727, 2.297193767089647],
            [33.81451677397944, 2.29482948267689],
            [33.82016707381029, 2.295271527425814],
            [33.82390047033447, 2.294791359130471],
            [33.83319953820321, 2.292805621186116],
            [33.837069613397844, 2.291587983963384],
            [33.8366903150405, 2.292295536969265],
            [33.836775402565905, 2.293512096475234],
            [33.83840726683966, 2.294402371081295],
            [33.83981548474366, 2.297626965327309],
            [33.83967565388487, 2.298999268711829],
            [33.83761009107675, 2.30199957169437],
            [33.83602137198775, 2.302764427065766],
            [33.83528987654685, 2.302425340914956],
            [33.83499504767398, 2.303288457879404],
            [33.83368295220033, 2.303731753940129],
            [33.833483433680755, 2.304839281700589],
            [33.834875965203274, 2.30567130565066],
            [33.83469420098701, 2.306019194569701],
            [33.8339935860323, 2.30594639032342],
            [33.83360299315688, 2.307035726756701],
            [33.83487786783507, 2.308929467458716],
            [33.83345871563742, 2.309259783544323],
            [33.83264969199422, 2.310514105233432],
            [33.83151191639806, 2.309691082411848],
            [33.830694201554515, 2.311650125113245],
            [33.832314076912496, 2.312271516269024],
            [33.83176878246703, 2.313315183307743],
            [33.83194194531446, 2.313818449139853],
            [33.83291508936343, 2.313158919450431],
            [33.83340679211566, 2.313826735624942],
            [33.834343370241015, 2.312874357692751],
            [33.83460778575162, 2.313835177391806],
            [33.83600023103586, 2.314502457391135],
            [33.836355659359505, 2.315508981750731],
            [33.836865212534754, 2.315581895909248],
            [33.837342810838685, 2.316426710380362],
            [33.83794738960133, 2.316466891500898],
            [33.83830966937563, 2.315696384253229],
            [33.83883377166521, 2.315959592877799],
            [33.83905616937672, 2.317195982159673],
            [33.839660987989525, 2.317641578865626],
            [33.83956057610369, 2.318229493043415],
            [33.83833198173064, 2.319365393644166],
            [33.839037763794856, 2.320155535227507],
            [33.83887690696854, 2.320763756073706],
            [33.83768816096316, 2.321129340636158],
            [33.837064025876806, 2.322102713639122],
            [33.83724602634997, 2.32317696105716],
            [33.837931478641, 2.323663051843724],
            [33.838214851299064, 2.325771050277067],
            [33.8379336579539, 2.327352344580963],
            [33.836866034493234, 2.328082732899555],
            [33.83839820912666, 2.329135899849189],
            [33.83888327512555, 2.331527568536487],
            [33.840133182028744, 2.332337650928063],
            [33.84178677205767, 2.334221842601805],
            [33.84436620983584, 2.334179743879969],
            [33.84694647316575, 2.33551605433364],
            [33.84747040208048, 2.335475194295943],
            [33.84986737315987, 2.33360882556041],
            [33.85137913986666, 2.334216028143933],
            [33.852730510582845, 2.336181467909191],
            [33.85403682090609, 2.340179051684929],
            [33.85821322340925, 2.337745999208846],
            [33.84971204276911, 2.342910821053028],
            [33.84937006941183, 2.343775902277493],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 746,
        District: "AMURIA",
        County: "KAPELEBYONG",
        Subcounty: "OKUNGUR",
        Population: 13805,
        Key: "AMURIAOKUNGUR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.35838264564161, 1.573825253662329],
            [33.357956188426805, 1.573028556268125],
            [33.35481244156353, 1.570716123867684],
            [33.353899636453896, 1.569423734139349],
            [33.3593068845082, 1.565511157304222],
            [33.36143918046384, 1.562523758073442],
            [33.35704357645494, 1.560073472002327],
            [33.359710494870434, 1.553857779278914],
            [33.36467887189101, 1.553231055731561],
            [33.36730265679982, 1.550416858877481],
            [33.368463508318996, 1.548196278294564],
            [33.373761323605386, 1.545446874502435],
            [33.37782459587495, 1.544127565524047],
            [33.38166936462971, 1.544867862202172],
            [33.38315130187919, 1.54561984773793],
            [33.38532046379578, 1.548605938290657],
            [33.38726145991835, 1.552166390717448],
            [33.38741402080308, 1.554233928978514],
            [33.38240059506763, 1.562479905158208],
            [33.38046803682049, 1.568206737915738],
            [33.37953961360129, 1.575377232896713],
            [33.37768577112924, 1.575641546651368],
            [33.37585765191534, 1.577123239133482],
            [33.37399878875918, 1.57998493528459],
            [33.37251437665106, 1.583706738613265],
            [33.37248982120278, 1.585403715792419],
            [33.37197205473089, 1.586881334395915],
            [33.3722594796892, 1.588598137047569],
            [33.37032266252932, 1.589250245465699],
            [33.36363867399596, 1.587343568386883],
            [33.36058078361601, 1.586868269819227],
            [33.36029739478827, 1.585831837983129],
            [33.36065324801503, 1.580409999198251],
            [33.36043872763024, 1.577824819689299],
            [33.359546242412314, 1.574880698947651],
            [33.35838264564161, 1.573825253662329],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 747,
        District: "SERERE",
        County: "KASILO",
        Subcounty: "KASILO TOWN COUNCIL",
        Population: 3537,
        Key: "SEREREKASILO TOWN COUNCIL",
        Dist2: "Serere",
        "Sub Country": "Kasilo TC",
        id2_original: "SerereKasilo TC",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.24900519868032, 1.545279857611177],
            [33.25588131080182, 1.545633721659393],
            [33.256967290436975, 1.54470724972174],
            [33.25785093802915, 1.544725700698175],
            [33.26083313366834, 1.545262599168394],
            [33.26121976048178, 1.545447809308484],
            [33.261297310243606, 1.546167673600691],
            [33.264270452661385, 1.545299571154614],
            [33.27214952032282, 1.545148947932527],
            [33.27696610451829, 1.544549890642958],
            [33.28667899839065, 1.544973348939644],
            [33.287931375660854, 1.544072833987121],
            [33.28873628052847, 1.542137035309139],
            [33.28895966638678, 1.539931206345729],
            [33.288646378931446, 1.538805841224764],
            [33.2874384251487, 1.537455486347905],
            [33.28534956183873, 1.536622949822778],
            [33.285009183889386, 1.533016525534171],
            [33.283603250401136, 1.527715058394465],
            [33.2811840451202, 1.524793131964218],
            [33.27933898996825, 1.52112930029568],
            [33.27825778308218, 1.515628700008842],
            [33.27746389694984, 1.506753555618349],
            [33.27753828913343, 1.499452414267024],
            [33.278448113633, 1.496439596433203],
            [33.28194164829821, 1.491580801579892],
            [33.28264289566687, 1.49163503335545],
            [33.28404735501972, 1.490612493276059],
            [33.2853795287383, 1.490331864728601],
            [33.28747127025041, 1.490223050887432],
            [33.28877712602612, 1.491055184961432],
            [33.290298086091546, 1.491064024982825],
            [33.29408630949245, 1.492393431249075],
            [33.2968879302848, 1.493976315292748],
            [33.30056512730647, 1.496997625387046],
            [33.30478784065749, 1.499349284368739],
            [33.30996311945094, 1.499502365943577],
            [33.313304360929386, 1.498787117095156],
            [33.31458488151913, 1.498877409098779],
            [33.32009534420297, 1.50498343322641],
            [33.325670092125165, 1.508844221750643],
            [33.327666176534244, 1.511078215221606],
            [33.330316417726486, 1.516537434630356],
            [33.33431230646827, 1.521742394467373],
            [33.33675158280762, 1.522588477679861],
            [33.3417559714913, 1.522503026871709],
            [33.34732896500373, 1.518056808955525],
            [33.350149815133086, 1.517787198807157],
            [33.356382860173554, 1.518420078660372],
            [33.367193523170876, 1.516164414116816],
            [33.36891814837921, 1.517004044687011],
            [33.37349190627527, 1.518149275115397],
            [33.37957343068015, 1.520878351844486],
            [33.38028380133887, 1.522838724595618],
            [33.383870746420556, 1.524157377694677],
            [33.38516368891406, 1.525421378791648],
            [33.386565552135735, 1.525384476505398],
            [33.38858662048953, 1.526080424027184],
            [33.39242825232733, 1.526116343893166],
            [33.39601365320507, 1.52550360208315],
            [33.39883120472067, 1.526131006382268],
            [33.40195095578605, 1.527700114843418],
            [33.40351107700797, 1.529501999595835],
            [33.40449353838307, 1.531536659153625],
            [33.40455192887654, 1.535199210489977],
            [33.40518825949119, 1.539501223140873],
            [33.40524657991605, 1.542408045954977],
            [33.40409280622301, 1.55118686053599],
            [33.40320192988776, 1.553326381350374],
            [33.4036587375828, 1.554357450375149],
            [33.40421646471176, 1.559360341927806],
            [33.40374344512084, 1.562563121081524],
            [33.40234045990335, 1.565404177354534],
            [33.40135771645726, 1.571303055510268],
            [33.40008667039881, 1.573537895803692],
            [33.39603351405769, 1.577528486226228],
            [33.386648996642485, 1.583085119101462],
            [33.385070628840516, 1.585763390125773],
            [33.38535043967849, 1.588938838517937],
            [33.39258201875113, 1.599043078732252],
            [33.39218100452011, 1.602680046655622],
            [33.39238312545904, 1.607936355825477],
            [33.393387625203, 1.610161755688531],
            [33.39760577690899, 1.613390762809965],
            [33.403028582885725, 1.616628534260985],
            [33.41159001892183, 1.623859817143872],
            [33.41274372254627, 1.623999982452095],
            [33.40944465966533, 1.641461402546575],
            [33.40748036663417, 1.647197659847772],
            [33.402844218046695, 1.655657608518522],
            [33.39027910307865, 1.672659542919584],
            [33.37472729999672, 1.666166848866687],
            [33.36681749378287, 1.663336596405133],
            [33.343364377159745, 1.656971687076606],
            [33.31739688953112, 1.647114600916779],
            [33.29050518908704, 1.639935313781383],
            [33.28389316818435, 1.638624450309926],
            [33.28088177640012, 1.63724967808542],
            [33.27494363209773, 1.633360223648997],
            [33.27214411605809, 1.632084923714834],
            [33.268252796605296, 1.630755534866942],
            [33.26034285025423, 1.629073839911246],
            [33.25594693003836, 1.627527326772086],
            [33.25081656790744, 1.625447091218033],
            [33.23880532000762, 1.618690328563217],
            [33.23076532814615, 1.614936655484112],
            [33.20498473231742, 1.605693134367345],
            [33.210357219163505, 1.569232234869784],
            [33.21437086400518, 1.556809999729893],
            [33.21610896304447, 1.553245211570518],
            [33.21881064626146, 1.549381767644383],
            [33.22383187835672, 1.544866712776533],
            [33.227306322923845, 1.542685931575305],
            [33.23251774453441, 1.538478425481963],
            [33.23894020743742, 1.54081186848176],
            [33.239962392314375, 1.541960734737369],
            [33.241805974229244, 1.542620968306494],
            [33.24351824670412, 1.544746886948418],
            [33.24637924074686, 1.545509967174865],
            [33.24900519868032, 1.545279857611177],
          ],
          [
            [33.37782459317999, 1.544127555646167],
            [33.3737613307919, 1.54544689785013],
            [33.36846351640381, 1.548196283682512],
            [33.36730265410486, 1.550416837325776],
            [33.36467887189101, 1.553231040465822],
            [33.35971048678559, 1.55385780621845],
            [33.358399226745135, 1.556610058262441],
            [33.35704354321725, 1.560073466614442],
            [33.36143918226047, 1.562523764359283],
            [33.35930687642337, 1.565511163590088],
            [33.35389964992862, 1.569423756588785],
            [33.35481242269893, 1.570716143623194],
            [33.35795617495208, 1.573028575125622],
            [33.35954626307355, 1.574880721397062],
            [33.36043875368136, 1.577824817893352],
            [33.36065322645543, 1.580410000994195],
            [33.36029740916131, 1.585831860432388],
            [33.36058079978565, 1.586868244676055],
            [33.363638650639764, 1.587343537855902],
            [33.370322677800665, 1.589250251751493],
            [33.37225945992626, 1.588598171170405],
            [33.37197206910395, 1.58688136402895],
            [33.37248979335503, 1.5854037104046],
            [33.372514356888125, 1.583706753878816],
            [33.37399882289513, 1.579984937080535],
            [33.37585763394903, 1.577123205010423],
            [33.37768577562082, 1.575641545753377],
            [33.37953960371982, 1.575377204161472],
            [33.380468026040695, 1.568206714568295],
            [33.382400596864265, 1.562479917729958],
            [33.38741403876936, 1.554233907426882],
            [33.38726146530827, 1.55216636647186],
            [33.38532047277891, 1.54860592033091],
            [33.38315132254045, 1.545619830676162],
            [33.38166938259602, 1.544867835262488],
            [33.37782459317999, 1.544127555646167],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 748,
        District: "SERERE",
        County: "KASILO",
        Subcounty: "BUGONDO",
        Population: 35478,
        Key: "SEREREBUGONDO",
        Dist2: "Serere",
        "Sub Country": "Bugondo",
        id2_original: "SerereBugondo",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.29835258664315, 2.216733927849931],
            [33.29923963525697, 2.219846452449516],
            [33.300050106984415, 2.220831617773603],
            [33.296991784514795, 2.226820759444032],
            [33.29653039002194, 2.229663851060838],
            [33.2969493211513, 2.230476035632727],
            [33.29649440890154, 2.230915263476476],
            [33.296690115869325, 2.231599162898109],
            [33.29805559552539, 2.231756303594657],
            [33.298524196303454, 2.234714625479365],
            [33.29998274052462, 2.235610356113718],
            [33.29975349315907, 2.236719050037502],
            [33.300368539091366, 2.237623782680289],
            [33.30031641524535, 2.238276238592356],
            [33.29979870626562, 2.238257198066488],
            [33.29973877785638, 2.239315721489754],
            [33.2983877485, 2.240519264124653],
            [33.298568297295695, 2.241098241598896],
            [33.29743718001245, 2.24236774940818],
            [33.297264741207115, 2.24312919935715],
            [33.29780331445763, 2.244011566371408],
            [33.297166251716014, 2.244561784320303],
            [33.297173040284605, 2.245974917239401],
            [33.29623490537889, 2.246566353381732],
            [33.296518135204806, 2.247164725228781],
            [33.295507572731005, 2.247305525697142],
            [33.2954624925751, 2.248327514671813],
            [33.29262591653843, 2.249974663187395],
            [33.292266899445245, 2.251193366855435],
            [33.291018527762894, 2.252122866686887],
            [33.29040826446115, 2.254770078173766],
            [33.28962274164409, 2.253404121945338],
            [33.28855189233324, 2.253160064264379],
            [33.286719734293825, 2.251749078234462],
            [33.28574392135015, 2.25170403557995],
            [33.28406571299087, 2.249940178316896],
            [33.28254288442965, 2.249397649638689],
            [33.28235214245043, 2.248411551102008],
            [33.28149538143474, 2.247769372120646],
            [33.27992555571281, 2.247472226202835],
            [33.279585698786285, 2.246822471753701],
            [33.27832708900465, 2.246509839819137],
            [33.27690189563672, 2.245011231004682],
            [33.27262225155458, 2.245339078911273],
            [33.270860397465945, 2.244747054327139],
            [33.269774097132185, 2.243912894786413],
            [33.26874718172696, 2.243833622698921],
            [33.26588386374259, 2.244708242775993],
            [33.264343133554384, 2.242622619018635],
            [33.2637309218068, 2.242503535294774],
            [33.262399935661016, 2.243147908595309],
            [33.260479398669, 2.243248184291126],
            [33.25863960225473, 2.246036568829076],
            [33.25077810923351, 2.246164617744444],
            [33.24924350286057, 2.245712525215255],
            [33.245887188549965, 2.245577390405126],
            [33.24490005593539, 2.245052822494765],
            [33.243188995287866, 2.244854072878925],
            [33.238293819284834, 2.242249305671968],
            [33.23851152150235, 2.239833680419665],
            [33.23784625525409, 2.237933887889247],
            [33.23800622095166, 2.23650441211954],
            [33.23758717393961, 2.234722191620257],
            [33.23544403442021, 2.23199934603163],
            [33.2345329019736, 2.232144247450436],
            [33.23413866732802, 2.23083247375456],
            [33.22940932032645, 2.22791099202821],
            [33.22384849629116, 2.226513199384629],
            [33.211576153952336, 2.222512519667208],
            [33.20852221705791, 2.221843466583474],
            [33.20171134777888, 2.217619387814503],
            [33.19956822622579, 2.214371744193416],
            [33.198385724409974, 2.213259100884972],
            [33.193533464521316, 2.210835102438811],
            [33.192843686842195, 2.21008427740859],
            [33.18975257855967, 2.208591892629143],
            [33.188003911739386, 2.208465456214308],
            [33.185811832901614, 2.208936187263211],
            [33.18433403778389, 2.208393541139403],
            [33.183841390902316, 2.20856549908564],
            [33.18044213173123, 2.205915093202061],
            [33.1783241531246, 2.205589651206772],
            [33.17725221954719, 2.202929907139622],
            [33.17562648178368, 2.201319701008423],
            [33.17416086782122, 2.199076170754925],
            [33.174086798132784, 2.197737194877049],
            [33.1747271226572, 2.196280521716817],
            [33.17352001329079, 2.193530316721514],
            [33.173125391471324, 2.190725733686732],
            [33.17088409214248, 2.190698850603109],
            [33.170514739033635, 2.190128919781397],
            [33.16984979887379, 2.190128996082406],
            [33.16957881218688, 2.18955905337431],
            [33.16908616350867, 2.189685770563288],
            [33.16646308198071, 2.188482788966316],
            [33.16343373197565, 2.188284086511942],
            [33.16239906590612, 2.186827600739206],
            [33.162198010369124, 2.188392787770242],
            [33.16118884836883, 2.189230877133447],
            [33.15792495902285, 2.187914158909447],
            [33.15067997888277, 2.186889345455922],
            [33.148477555944496, 2.183606932147288],
            [33.14847483225256, 2.182394065093955],
            [33.14730179778152, 2.18215942745286],
            [33.145143585429956, 2.182490141139533],
            [33.14395381444686, 2.182107257922276],
            [33.14243082778215, 2.180766906918065],
            [33.140955326961674, 2.178277551449758],
            [33.14052685033409, 2.176410470209516],
            [33.13970284009699, 2.17591082852296],
            [33.135387083740426, 2.17492682116999],
            [33.134024979953224, 2.173905690083992],
            [33.13207933774399, 2.173679682207308],
            [33.12797819519699, 2.170821118428466],
            [33.120318751249464, 2.173644482814101],
            [33.115947190649145, 2.173409599644373],
            [33.11301600314841, 2.170116636254926],
            [33.10905072360163, 2.168361768296538],
            [33.10410019610575, 2.16743930225744],
            [33.103299684898175, 2.165693243656979],
            [33.10351634596829, 2.165038097057275],
            [33.10490034259729, 2.163870909420837],
            [33.10987533840491, 2.161319239063632],
            [33.10997367697904, 2.160975437108953],
            [33.11172224678126, 2.160531994762245],
            [33.11429562632118, 2.155935814925257],
            [33.11786692275063, 2.154768448838544],
            [33.118039145061964, 2.154098941821156],
            [33.119196671017946, 2.153402215029507],
            [33.11944263692928, 2.150579462907073],
            [33.11886374010231, 2.147376792985225],
            [33.11947929268443, 2.144915901311284],
            [33.12282834142103, 2.141224369211242],
            [33.12579587655478, 2.139260880009864],
            [33.12828336188217, 2.136808876797821],
            [33.12909609916073, 2.136754525219565],
            [33.130450587929275, 2.135813499142849],
            [33.132297322930825, 2.133488206023766],
            [33.13315949360116, 2.133135289816623],
            [33.13526507455855, 2.131090434067607],
            [33.13418121764241, 2.128711111403417],
            [33.133108988519254, 2.120975835110323],
            [33.133650508243875, 2.117456420357856],
            [33.13520166158431, 2.112842204186254],
            [33.13554274021962, 2.108608076069532],
            [33.13970582789363, 2.108300099693649],
            [33.14632050241965, 2.104164911055646],
            [33.14966234936261, 2.103124162783119],
            [33.153224501840796, 2.104842784873873],
            [33.15560677827876, 2.105123011054596],
            [33.15980468465317, 2.104715458286496],
            [33.16278835712269, 2.105040847336366],
            [33.170016307899914, 2.107591382146896],
            [33.172606823702196, 2.107826322083072],
            [33.17746356348915, 2.105934907860722],
            [33.18038909609516, 2.104061799232773],
            [33.182817315071674, 2.100686910076043],
            [33.185140952182806, 2.094670248798046],
            [33.18731500632442, 2.092833406968615],
            [33.19351335034381, 2.091529853554084],
            [33.19446139097216, 2.090507403130048],
            [33.198428057517724, 2.090868790902732],
            [33.200625197463815, 2.091755133780066],
            [33.20548218877905, 2.090306950898768],
            [33.20863923340345, 2.090695561097335],
            [33.21141455062596, 2.090324252608539],
            [33.21319551277902, 2.089202159175504],
            [33.21591324439856, 2.098356827923636],
            [33.21977425469368, 2.107341173962034],
            [33.22096701706668, 2.121324378711318],
            [33.22427615814678, 2.146605496032393],
            [33.22101255895663, 2.152616550140966],
            [33.221870790514465, 2.152491626104422],
            [33.22237211602003, 2.151694651749943],
            [33.22360747201223, 2.151153454494007],
            [33.22548966172139, 2.150941157121775],
            [33.22587471738141, 2.150195375909665],
            [33.2266127426761, 2.150057270997347],
            [33.23056881179628, 2.155061322327203],
            [33.232186026344394, 2.161971493162879],
            [33.2334396962903, 2.164567083832014],
            [33.23452978302295, 2.175416921870855],
            [33.23576701829072, 2.177955031633552],
            [33.23854002414802, 2.181766094443888],
            [33.24541614794757, 2.188803477989984],
            [33.24818697179707, 2.190495220295447],
            [33.249522713623946, 2.190146601869812],
            [33.25100697661168, 2.190395205835029],
            [33.25239247522382, 2.191738778014478],
            [33.25491693161506, 2.192855681524189],
            [33.25636215561719, 2.194013188806184],
            [33.2561035827492, 2.194973231493391],
            [33.25645010517508, 2.196167664886629],
            [33.25743976924214, 2.197212676402874],
            [33.260408500033506, 2.198804816298332],
            [33.26674199558742, 2.203233267497004],
            [33.27345569859373, 2.209030678151786],
            [33.27451986803212, 2.210562409042006],
            [33.277356285965304, 2.207225212195437],
            [33.279087825506394, 2.207854445016864],
            [33.280397759633466, 2.210230862269779],
            [33.284005724394504, 2.213850734194688],
            [33.28458246706142, 2.215085093107598],
            [33.284277879789606, 2.215805950467013],
            [33.28530758715878, 2.217015367641042],
            [33.28524184575134, 2.217769318341377],
            [33.28335967221186, 2.220213898218808],
            [33.28331715045788, 2.220717659608005],
            [33.28418038114027, 2.221842899275027],
            [33.287962773576645, 2.222035089359281],
            [33.286653310166784, 2.218810520338777],
            [33.28657026990193, 2.215230561703067],
            [33.2856650555564, 2.213249945802081],
            [33.291255205992464, 2.215106188640035],
            [33.29344655809318, 2.216780882659015],
            [33.29835258664315, 2.216733927849931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 749,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "AWEI",
        Population: 28589,
        Key: "ALEBTONGAWEI",
        Dist2: "Alebtong",
        "Sub Country": "Awei",
        id2_original: "Alebtong Awei",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "N",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.56367054737113, 3.236597688469034],
            [31.560222321932198, 3.236427595607219],
            [31.555746330383478, 3.235051907808089],
            [31.55349681416476, 3.235091713302026],
            [31.549426844954766, 3.23629179592269],
            [31.543703477955344, 3.239534551592102],
            [31.540585439977207, 3.240255767348237],
            [31.538526365700385, 3.24029519774223],
            [31.535979902381328, 3.241564089852852],
            [31.53481344717143, 3.241494583600315],
            [31.532695152357817, 3.24211858182497],
            [31.531719068122946, 3.241929444693809],
            [31.530397358879085, 3.240774732879518],
            [31.528135790862507, 3.240492428614461],
            [31.519030606381545, 3.24049644752897],
            [31.50492597844255, 3.23922083016987],
            [31.500570140156334, 3.239920206238488],
            [31.48989541741431, 3.238504340237684],
            [31.48217548271216, 3.236866456280938],
            [31.477838258416934, 3.235529321608259],
            [31.474674725261263, 3.233842051262534],
            [31.473013888522924, 3.230070780792316],
            [31.471533487392584, 3.225043534440517],
            [31.471255720221908, 3.211762734049942],
            [31.47078137741253, 3.210565589456758],
            [31.46923432937293, 3.210323975687207],
            [31.46845893236578, 3.211459415326113],
            [31.46744627502071, 3.212056103327284],
            [31.460794449767796, 3.214938455513747],
            [31.47096924657947, 3.203653096026479],
            [31.476566688640702, 3.193613273563376],
            [31.4784061041693, 3.189050698627758],
            [31.47902482421112, 3.187515977719035],
            [31.483263022721008, 3.182354134287522],
            [31.488352507913234, 3.178131121779985],
            [31.489393031896732, 3.176759103851632],
            [31.490201516550737, 3.173771855270782],
            [31.491241177253258, 3.173042597321089],
            [31.493734725310482, 3.172419864675984],
            [31.495398752864673, 3.170856330831958],
            [31.496541212276707, 3.170858000037299],
            [31.49861675536762, 3.172009408434204],
            [31.500632712307425, 3.171404976320718],
            [31.539060922583243, 3.150743826074021],
            [31.542495667004705, 3.155005918411801],
            [31.543556136282415, 3.156897644965847],
            [31.54334412309559, 3.161338035253767],
            [31.543905017684285, 3.164187741709906],
            [31.549933427401353, 3.175845160902758],
            [31.558985067799824, 3.187588262736672],
            [31.561892118467178, 3.192901319601532],
            [31.5634060141812, 3.197543147832163],
            [31.564256188749233, 3.207113159994925],
            [31.56990225571849, 3.215315218648625],
            [31.571332348497982, 3.218772145218202],
            [31.57165570696595, 3.222408400491202],
            [31.5688388166104, 3.229775499158263],
            [31.56367054737113, 3.236597688469034],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 750,
        District: "MOYO",
        County: "OBONGI",
        Subcounty: "ALIBA",
        Population: 16542,
        Key: "MOYOALIBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.91471220702595, 3.50866093539433],
            [31.91746659619727, 3.50883598921808],
            [31.920690600344656, 3.509662920496813],
            [31.92585991432461, 3.511939308299581],
            [31.93258569877316, 3.515773227434925],
            [31.93652498646552, 3.516763716463455],
            [31.94001083604346, 3.518441102360427],
            [31.949382510245037, 3.524295184901521],
            [31.949862898716287, 3.525145989203786],
            [31.94992785050459, 3.526430530918134],
            [31.949439917981614, 3.528790865201864],
            [31.947842144772846, 3.531927881400347],
            [31.947430885256004, 3.533636969988502],
            [31.94743678000089, 3.536640110351869],
            [31.950985160407484, 3.54584342909681],
            [31.956900181176152, 3.555221350749235],
            [31.964697627910883, 3.564456565640357],
            [31.969105934996236, 3.568143102854245],
            [31.985305752181425, 3.575298225025017],
            [31.99539699129862, 3.574875157422049],
            [31.997362126051236, 3.575130609138249],
            [32.000665715542866, 3.576762149047513],
            [32.00041229271637, 3.585842631154159],
            [31.98838342975214, 3.585470350305839],
            [31.97569827021777, 3.586293851828585],
            [31.96843374183879, 3.585747162218919],
            [31.96646923860183, 3.585146608917154],
            [31.963848228588947, 3.585861613049769],
            [31.9588624386249, 3.585963386558054],
            [31.957849131797865, 3.586575425997039],
            [31.958186491407886, 3.587298764285379],
            [31.9577458956088, 3.588787535030656],
            [31.957989423492435, 3.589771011755869],
            [31.957662871513623, 3.592199755499096],
            [31.956870354413763, 3.593095325465026],
            [31.95598253055384, 3.59553064460235],
            [31.95625262162042, 3.597302723732707],
            [31.95555593589678, 3.598928831353214],
            [31.955659733532897, 3.600393839093264],
            [31.95385804994119, 3.605307017367504],
            [31.954135334716586, 3.61206296216905],
            [31.952693117375702, 3.623357638368816],
            [31.952705013764994, 3.627070832915277],
            [31.954378546393244, 3.632928634559707],
            [31.955494949272133, 3.634030220671379],
            [31.955148536440696, 3.635197992821426],
            [31.956977029353748, 3.636805332233363],
            [31.956976361905507, 3.637378115270711],
            [31.9610311325192, 3.644516513428119],
            [31.961489063108314, 3.645940614620814],
            [31.961599878383456, 3.649480510914173],
            [31.961060257697326, 3.652481027905771],
            [31.959178708486967, 3.656826545895079],
            [31.950397921824777, 3.666050431388841],
            [31.949398652072382, 3.669088853181502],
            [31.94652060441231, 3.673971821633998],
            [31.944808716416393, 3.673102946331909],
            [31.94221258524529, 3.672692951077102],
            [31.94018881475913, 3.671757189704007],
            [31.936166116696036, 3.669000115698533],
            [31.933982052627233, 3.66829890504762],
            [31.927065937627834, 3.664588682239538],
            [31.924717333640007, 3.662701662913204],
            [31.920209686358973, 3.657545134942162],
            [31.909987103665763, 3.649747357578883],
            [31.906701691583898, 3.646703687568296],
            [31.89596577111317, 3.641560515219868],
            [31.89297108260331, 3.639660980707638],
            [31.890610584022816, 3.636118314133409],
            [31.87845100899823, 3.622654711149198],
            [31.877934687915616, 3.621315882616845],
            [31.876197395563484, 3.619938320519552],
            [31.875389016910667, 3.615402112665299],
            [31.874687243129237, 3.614434773354898],
            [31.87416965901537, 3.614099555935634],
            [31.87302248254978, 3.614283974571656],
            [31.870288235403738, 3.611306723806169],
            [31.867366289770636, 3.610522469076213],
            [31.86651717072306, 3.60903443404431],
            [31.865374275628103, 3.608326872292114],
            [31.859752506290672, 3.608057772055755],
            [31.863020934823783, 3.589258995733362],
            [31.861651811600957, 3.567660213411016],
            [31.854609440185005, 3.535619521036335],
            [31.85786920177225, 3.529035191960058],
            [31.861677286924078, 3.524227798796158],
            [31.863469531018794, 3.522601838988015],
            [31.870742972482002, 3.518495109491257],
            [31.877251196646874, 3.516305037757259],
            [31.879925087785598, 3.51579263039137],
            [31.890014677595953, 3.515470126124876],
            [31.898325778315215, 3.514249804484814],
            [31.91471220702595, 3.50866093539433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 751,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "DIFULE",
        Population: 10709,
        Key: "MOYODIFULE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.613428124957288, 3.35388559173341],
            [31.61378078197828, 3.356355881050392],
            [31.614944571886728, 3.358773065344139],
            [31.614643767420596, 3.360601871797754],
            [31.61531070094203, 3.360794323215492],
            [31.616171347171328, 3.362635903040341],
            [31.61478345275232, 3.364401677467423],
            [31.61508581310053, 3.365239054837094],
            [31.61460990183268, 3.366044033143313],
            [31.613676399538885, 3.365706356928496],
            [31.612367935055605, 3.366338060987529],
            [31.612242651514507, 3.366869771785301],
            [31.61282568867662, 3.36736338595268],
            [31.61256750388081, 3.368309468238211],
            [31.611780306604086, 3.3690827102648],
            [31.611430697566878, 3.368636360870664],
            [31.610658365611457, 3.369902402153981],
            [31.60968665976524, 3.369064064774281],
            [31.60922203762558, 3.367397332964522],
            [31.60859919701154, 3.367529411983518],
            [31.607603634606335, 3.367050846506868],
            [31.607565475071368, 3.366518903545806],
            [31.60688049259925, 3.366564851096798],
            [31.606507626179315, 3.366055891970355],
            [31.60599307208289, 3.366665260975396],
            [31.6050297133823, 3.365435839409978],
            [31.60450812278225, 3.365521129033686],
            [31.60430752179281, 3.364284982961359],
            [31.60376192461509, 3.364831730068981],
            [31.603599838893434, 3.363877226449304],
            [31.602869310039786, 3.363117453336344],
            [31.602315830145432, 3.363734584806032],
            [31.60086762912645, 3.364115770163461],
            [31.599934362191263, 3.363621645883409],
            [31.59953640852039, 3.364332862253997],
            [31.599125113070926, 3.363487507355643],
            [31.597927615678064, 3.362719235263263],
            [31.59772855619764, 3.363169152021919],
            [31.59715545979244, 3.363114320924996],
            [31.59702492290359, 3.363586657592646],
            [31.59641170414456, 3.363405761580862],
            [31.59519229504526, 3.36438955048691],
            [31.594592291402396, 3.364361680760652],
            [31.593690755657985, 3.365386430288534],
            [31.592956659594325, 3.365187355364561],
            [31.591767343158725, 3.367039728419506],
            [31.590622506804472, 3.36598500982915],
            [31.589040534063248, 3.366860254420939],
            [31.587500509950857, 3.366592498362324],
            [31.586680550217395, 3.366937821879239],
            [31.585951836858943, 3.366113217703227],
            [31.585739068188953, 3.367710488375984],
            [31.585040680157814, 3.367592463468369],
            [31.58437667873747, 3.368469038308895],
            [31.583978768185727, 3.368036435123872],
            [31.583154894492576, 3.367990228477589],
            [31.583118158787343, 3.368620205682861],
            [31.582222150376868, 3.368911409739686],
            [31.581696812005454, 3.369891689435577],
            [31.58104312504122, 3.369827729679718],
            [31.579829445396804, 3.370487193901715],
            [31.57922044961793, 3.371284273684068],
            [31.578919398115094, 3.371195779542319],
            [31.57876789275082, 3.36994081495165],
            [31.578001460930206, 3.369796606656379],
            [31.57803009652652, 3.368932637910098],
            [31.576453811917684, 3.369550254430945],
            [31.575276390074784, 3.368244954178548],
            [31.574345892645617, 3.368936759432165],
            [31.5726060149421, 3.369124980967848],
            [31.572795707689057, 3.36969921201507],
            [31.574728237190122, 3.369502261506003],
            [31.5750491675119, 3.370769070187064],
            [31.573640556145797, 3.370473805253648],
            [31.572746070379736, 3.370894737803799],
            [31.572505154796925, 3.370116560543595],
            [31.571890122339354, 3.370471226167776],
            [31.57155600924078, 3.370031792341098],
            [31.570935962387278, 3.370317636031579],
            [31.57046000081376, 3.36993420133245],
            [31.57014907143607, 3.370627099433967],
            [31.569362770677984, 3.370577881586135],
            [31.56922102371265, 3.369836351149815],
            [31.5684822617994, 3.369858950449172],
            [31.56911742640082, 3.369150896511986],
            [31.56831203374802, 3.368095469074882],
            [31.567262526611685, 3.368430776109384],
            [31.567672456621924, 3.369618394910528],
            [31.567481024736562, 3.370096300901721],
            [31.56558897062728, 3.36864624858082],
            [31.564849893405345, 3.368860146288847],
            [31.5647680164588, 3.369685614410582],
            [31.564113934235802, 3.370096493705526],
            [31.56196401692757, 3.370361474220153],
            [31.561523203736183, 3.369391395670139],
            [31.560176959705302, 3.37026264033297],
            [31.558953025791954, 3.369777162164569],
            [31.559173068120803, 3.370779281606325],
            [31.55837535786029, 3.370945059548398],
            [31.55670388417069, 3.370274709847595],
            [31.55717008824357, 3.369585281965054],
            [31.557026743175363, 3.369150959285366],
            [31.556362092273087, 3.369216754758731],
            [31.55532194737863, 3.368547345468672],
            [31.554036557920053, 3.368946144055286],
            [31.553550059108282, 3.368377737938565],
            [31.552963089121842, 3.368343469022845],
            [31.553707931731246, 3.366474574653684],
            [31.552566515263244, 3.366884718163266],
            [31.551581294263592, 3.366527055140307],
            [31.55128486369456, 3.364756787279114],
            [31.550609389889715, 3.364655599706985],
            [31.549990612355714, 3.36366401905496],
            [31.548627584202094, 3.364140613307257],
            [31.547898298616758, 3.362981902329103],
            [31.546712368829816, 3.363536675342806],
            [31.546304216585526, 3.362422969785816],
            [31.54509782048145, 3.361842353038922],
            [31.544749581375044, 3.361817994092056],
            [31.544032747337877, 3.362988397622057],
            [31.542720574609106, 3.363918605094628],
            [31.541982731672416, 3.363729939549673],
            [31.542149727585404, 3.363151381663963],
            [31.541697378229156, 3.36197082421131],
            [31.541265044235733, 3.362226185501497],
            [31.540667304347362, 3.361991537787405],
            [31.539514321171765, 3.36273557618001],
            [31.539094737865483, 3.361866733507674],
            [31.53784290317772, 3.362054074885056],
            [31.53736711318241, 3.361741693361553],
            [31.536323922100866, 3.363131484171542],
            [31.53503816073976, 3.363786268213808],
            [31.533521274534134, 3.363461180941131],
            [31.532835715343616, 3.362703244982782],
            [31.532093061928535, 3.363091702637032],
            [31.531396378899817, 3.362367142336699],
            [31.53016656281798, 3.362643552476867],
            [31.529601531487423, 3.364552486765901],
            [31.52849281010251, 3.364945024867675],
            [31.528990828909524, 3.366356724465525],
            [31.527917751776748, 3.366809104751256],
            [31.526771487101175, 3.36826564071838],
            [31.5248162329184, 3.36900335303887],
            [31.523982171431605, 3.369025744308595],
            [31.52336464704742, 3.36782903608259],
            [31.522220772788796, 3.3678747746258],
            [31.521602319546613, 3.367228026546913],
            [31.51976695452163, 3.367535538676139],
            [31.519744265772502, 3.366865963225403],
            [31.519434568883366, 3.366817582765694],
            [31.51918328045397, 3.367450779216459],
            [31.517537979180208, 3.368093392170318],
            [31.51579943547485, 3.367516340749271],
            [31.51549063869763, 3.366941893190912],
            [31.514775734241695, 3.366964497041263],
            [31.514062166478908, 3.366198023014355],
            [31.512988517119307, 3.366985133389498],
            [31.512225870799295, 3.367055477399184],
            [31.511581175971035, 3.367819471199149],
            [31.510961703140982, 3.36777051058059],
            [31.510865207909802, 3.368463765340813],
            [31.510292939751324, 3.368677918666436],
            [31.510039393855624, 3.370626251097792],
            [31.509132175368737, 3.371628873644207],
            [31.50636520798679, 3.373249774724262],
            [31.506670094397602, 3.376095812389877],
            [31.505607417959187, 3.377420943703194],
            [31.50481726971673, 3.37961934869948],
            [31.505029178699, 3.381102248797642],
            [31.504455912512245, 3.381890270755032],
            [31.503335401637532, 3.382199057010239],
            [31.502343000403812, 3.384217745436112],
            [31.50100652914492, 3.385386929319048],
            [31.50090465570015, 3.389308447289421],
            [31.500102756595464, 3.389582604316207],
            [31.497868504550027, 3.389922077370322],
            [31.495945408257775, 3.389669653919916],
            [31.48359299728106, 3.384332837749012],
            [31.479479530746687, 3.383694646648483],
            [31.478623609655784, 3.382889294671399],
            [31.47841060832212, 3.381833723435841],
            [31.476434676718114, 3.380827485856546],
            [31.475626148046654, 3.379993430033299],
            [31.474816495582758, 3.379878590089541],
            [31.473931154666282, 3.379990753226644],
            [31.47234732420906, 3.381161710602099],
            [31.46889941497714, 3.382064733624802],
            [31.463734905187323, 3.384725194787476],
            [31.459856007638265, 3.384245842367097],
            [31.458123083793353, 3.3844134133002],
            [31.457501259173892, 3.384620612412073],
            [31.456823079643396, 3.385782725853155],
            [31.455979979308236, 3.385664484335676],
            [31.455470567168497, 3.385999734188495],
            [31.454658111960885, 3.384895261287677],
            [31.45368386927233, 3.384959451411881],
            [31.452732677353964, 3.384241962135416],
            [31.450369673372133, 3.384464647234016],
            [31.450070454432474, 3.385194741929917],
            [31.451608803186847, 3.386972510590637],
            [31.451469109770276, 3.387958563225896],
            [31.450814755357758, 3.388008651828479],
            [31.448556651244925, 3.38626625186947],
            [31.447992171479946, 3.386392875205092],
            [31.447282850053504, 3.387272393229376],
            [31.44768015424241, 3.388858378534837],
            [31.44733642557703, 3.39014363395604],
            [31.44698753878532, 3.390106542861183],
            [31.4470465239635, 3.389587930974168],
            [31.44574576253379, 3.38926438039052],
            [31.44530374649822, 3.388365062255817],
            [31.444369424042577, 3.388707333580186],
            [31.441307631381, 3.363282362717672],
            [31.433759890244083, 3.31188516001561],
            [31.427191917333058, 3.266054605734791],
            [31.439659393514557, 3.241310726274493],
            [31.44150186511175, 3.238800274052417],
            [31.443711145788907, 3.236881747224559],
            [31.451377754699156, 3.225066173803146],
            [31.460794449767796, 3.214938455513747],
            [31.46744627502071, 3.212056103327284],
            [31.46845893236578, 3.211459415326113],
            [31.46923432937293, 3.210323975687207],
            [31.47078137741253, 3.210565589456758],
            [31.471255720221908, 3.211762734049942],
            [31.471533487392584, 3.225043534440517],
            [31.473013888522924, 3.230070780792316],
            [31.474674725261263, 3.233842051262534],
            [31.477838258416934, 3.235529321608259],
            [31.48217548271216, 3.236866456280938],
            [31.48989541741431, 3.238504340237684],
            [31.500570140156334, 3.239920206238488],
            [31.50492597844255, 3.23922083016987],
            [31.519030606381545, 3.24049644752897],
            [31.528135790862507, 3.240492428614461],
            [31.530397358879085, 3.240774732879518],
            [31.531719068122946, 3.241929444693809],
            [31.532695152357817, 3.24211858182497],
            [31.53481344717143, 3.241494583600315],
            [31.535979902381328, 3.241564089852852],
            [31.538526365700385, 3.24029519774223],
            [31.540585439977207, 3.240255767348237],
            [31.543703477955344, 3.239534551592102],
            [31.549426844954766, 3.23629179592269],
            [31.55349681416476, 3.235091713302026],
            [31.555746330383478, 3.235051907808089],
            [31.560222321932198, 3.236427595607219],
            [31.56367054737113, 3.236597688469034],
            [31.56266660278601, 3.239362677123101],
            [31.562156846591517, 3.243504209069767],
            [31.56233717619829, 3.246823701423495],
            [31.563690766651536, 3.251652677351468],
            [31.56519790074643, 3.255302246965075],
            [31.566766979070053, 3.257502243765416],
            [31.576971475981626, 3.260926484636217],
            [31.579708784586174, 3.2626759221513],
            [31.580421772935598, 3.263780339085373],
            [31.582874039812246, 3.272475401087407],
            [31.585095327371512, 3.276657030229877],
            [31.58549513965668, 3.279904509571215],
            [31.586667441102453, 3.284346939199335],
            [31.586338469062262, 3.296275932317046],
            [31.586999578805717, 3.300075492088232],
            [31.58848468800648, 3.302655245371671],
            [31.59411197479638, 3.307746190663599],
            [31.598567057158565, 3.315729658408116],
            [31.600375355045703, 3.317495883101654],
            [31.603339177442393, 3.319281838008318],
            [31.604861195723235, 3.321056697981739],
            [31.60595426396432, 3.323093237058593],
            [31.606396149744146, 3.325325892852334],
            [31.606084055251483, 3.331387130055379],
            [31.604798752031197, 3.33783394850602],
            [31.604373811172554, 3.342769416652095],
            [31.60485699340431, 3.346082141726594],
            [31.60583015991118, 3.348475080014762],
            [31.609743001201565, 3.352917623954129],
            [31.613428124957288, 3.35388559173341],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 752,
        District: "MOYO",
        County: "OBONGI",
        Subcounty: "GIMARA",
        Population: 13257,
        Key: "MOYOGIMARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.6273886774978, 3.552580910565249],
            [31.618177502593067, 3.552571000566527],
            [31.609464036576593, 3.551902826301697],
            [31.60067993423268, 3.549233286687581],
            [31.592968816495038, 3.545775640192401],
            [31.589969343558007, 3.54490958308653],
            [31.58804027616405, 3.544906628801102],
            [31.586112845500573, 3.543826835503095],
            [31.5832095848254, 3.543406561589859],
            [31.582322541601464, 3.544130266473664],
            [31.58001472561911, 3.544184143896835],
            [31.57889705881061, 3.543600370180492],
            [31.575344021537596, 3.543187188255855],
            [31.57541706534998, 3.543720149356403],
            [31.574268024880183, 3.543854577126957],
            [31.57415533571936, 3.544412842499539],
            [31.57553367925026, 3.545024490884811],
            [31.576100509906336, 3.546659826530482],
            [31.57552908796086, 3.548020990904269],
            [31.574478430082642, 3.548084061769555],
            [31.57513479582309, 3.548789938728929],
            [31.574192016627343, 3.549220928059355],
            [31.574503168787242, 3.549630024207833],
            [31.574051330572377, 3.55035461543082],
            [31.574643203563642, 3.551128494353417],
            [31.57366517896774, 3.551640533431193],
            [31.573203913832266, 3.553669956282348],
            [31.57276629954161, 3.554146751785157],
            [31.572429531921372, 3.553838180380202],
            [31.57217612706118, 3.554145834576097],
            [31.572719019411576, 3.554986110636461],
            [31.57104348803185, 3.5580023784777],
            [31.569893215073463, 3.558377945686179],
            [31.570878504345067, 3.559755988862982],
            [31.5706881657094, 3.560018628195222],
            [31.56872936407955, 3.560261544451407],
            [31.567854025903795, 3.561324638536404],
            [31.566517660646088, 3.560283535803868],
            [31.5651921748848, 3.560395688286333],
            [31.56387376155976, 3.561390509409306],
            [31.56316530431262, 3.560986517333421],
            [31.562978275070467, 3.561834397327324],
            [31.562522851679283, 3.561566509931971],
            [31.56183425348815, 3.561964070585629],
            [31.562174906321967, 3.562753407545768],
            [31.561595710356002, 3.563367424187267],
            [31.560031995872958, 3.561965482699011],
            [31.558888489923604, 3.561764365457894],
            [31.55869316024824, 3.562518932345372],
            [31.55825198144253, 3.562468878110875],
            [31.558003848794776, 3.561975017826291],
            [31.558597695384698, 3.561484011988653],
            [31.558615384110944, 3.560966655377356],
            [31.557783558530886, 3.561185872066902],
            [31.55689428928167, 3.560349023014426],
            [31.55601149958062, 3.560771719844551],
            [31.5549283442487, 3.559764932269026],
            [31.553884057222465, 3.559510635562793],
            [31.545005185311027, 3.559590012680172],
            [31.541425265953176, 3.559996225305358],
            [31.53990948198039, 3.562296065997802],
            [31.53863262382208, 3.563140703653107],
            [31.539323383359804, 3.564843846685442],
            [31.53847037640366, 3.567199827741941],
            [31.538895815827285, 3.568250148390757],
            [31.538645057403944, 3.569879301305119],
            [31.5395414422085, 3.572403350287821],
            [31.539291701576367, 3.573388801823312],
            [31.536670878413045, 3.576560222757618],
            [31.49317336539449, 3.509108128427196],
            [31.468968994885785, 3.471895792470126],
            [31.45305614721307, 3.446571838667319],
            [31.444942991164954, 3.389873211128159],
            [31.443906485345746, 3.389290634366028],
            [31.444369424042577, 3.388707333580186],
            [31.44530374649822, 3.388365062255817],
            [31.44574576253379, 3.38926438039052],
            [31.4470465239635, 3.389587930974168],
            [31.44698753878532, 3.390106542861183],
            [31.44733642557703, 3.39014363395604],
            [31.44768015424241, 3.388858378534837],
            [31.447282850053504, 3.387272393229376],
            [31.447992171479946, 3.386392875205092],
            [31.448556651244925, 3.38626625186947],
            [31.450814755357758, 3.388008651828479],
            [31.451469109770276, 3.387958563225896],
            [31.451608803186847, 3.386972510590637],
            [31.450070454432474, 3.385194741929917],
            [31.450369673372133, 3.384464647234016],
            [31.452732677353964, 3.384241962135416],
            [31.45368386927233, 3.384959451411881],
            [31.454658111960885, 3.384895261287677],
            [31.455470567168497, 3.385999734188495],
            [31.455979979308236, 3.385664484335676],
            [31.456823079643396, 3.385782725853155],
            [31.457501259173892, 3.384620612412073],
            [31.458123083793353, 3.3844134133002],
            [31.459856007638265, 3.384245842367097],
            [31.463734905187323, 3.384725194787476],
            [31.46889941497714, 3.382064733624802],
            [31.47234732420906, 3.381161710602099],
            [31.473931154666282, 3.379990753226644],
            [31.474816495582758, 3.379878590089541],
            [31.475626148046654, 3.379993430033299],
            [31.476434676718114, 3.380827485856546],
            [31.47841060832212, 3.381833723435841],
            [31.478623609655784, 3.382889294671399],
            [31.479479530746687, 3.383694646648483],
            [31.48359299728106, 3.384332837749012],
            [31.495945408257775, 3.389669653919916],
            [31.497868504550027, 3.389922077370322],
            [31.500102756595464, 3.389582604316207],
            [31.50090465570015, 3.389308447289421],
            [31.50100652914492, 3.385386929319048],
            [31.502343000403812, 3.384217745436112],
            [31.503335401637532, 3.382199057010239],
            [31.504455912512245, 3.381890270755032],
            [31.505029178699, 3.381102248797642],
            [31.50481726971673, 3.37961934869948],
            [31.505607417959187, 3.377420943703194],
            [31.506670094397602, 3.376095812389877],
            [31.50636520798679, 3.373249774724262],
            [31.509132175368737, 3.371628873644207],
            [31.510039393855624, 3.370626251097792],
            [31.510292939751324, 3.368677918666436],
            [31.510865207909802, 3.368463765340813],
            [31.510961703140982, 3.36777051058059],
            [31.511581175971035, 3.367819471199149],
            [31.512225870799295, 3.367055477399184],
            [31.512988517119307, 3.366985133389498],
            [31.514062166478908, 3.366198023014355],
            [31.514775734241695, 3.366964497041263],
            [31.51549063869763, 3.366941893190912],
            [31.51579943547485, 3.367516340749271],
            [31.517537979180208, 3.368093392170318],
            [31.51918328045397, 3.367450779216459],
            [31.519434568883366, 3.366817582765694],
            [31.519744265772502, 3.366865963225403],
            [31.51976695452163, 3.367535538676139],
            [31.521602319546613, 3.367228026546913],
            [31.522220772788796, 3.3678747746258],
            [31.52336464704742, 3.36782903608259],
            [31.523982171431605, 3.369025744308595],
            [31.5248162329184, 3.36900335303887],
            [31.526771487101175, 3.36826564071838],
            [31.527917751776748, 3.366809104751256],
            [31.528990828909524, 3.366356724465525],
            [31.52849281010251, 3.364945024867675],
            [31.529601531487423, 3.364552486765901],
            [31.53016656281798, 3.362643552476867],
            [31.531396378899817, 3.362367142336699],
            [31.532093061928535, 3.363091702637032],
            [31.532835715343616, 3.362703244982782],
            [31.533521274534134, 3.363461180941131],
            [31.53503816073976, 3.363786268213808],
            [31.536323922100866, 3.363131484171542],
            [31.53736711318241, 3.361741693361553],
            [31.53784290317772, 3.362054074885056],
            [31.539094737865483, 3.361866733507674],
            [31.539514321171765, 3.36273557618001],
            [31.540667304347362, 3.361991537787405],
            [31.541265044235733, 3.362226185501497],
            [31.541697378229156, 3.36197082421131],
            [31.542149727585404, 3.363151381663963],
            [31.541982731672416, 3.363729939549673],
            [31.542720574609106, 3.363918605094628],
            [31.544032747337877, 3.362988397622057],
            [31.544749581375044, 3.361817994092056],
            [31.54509782048145, 3.361842353038922],
            [31.546304216585526, 3.362422969785816],
            [31.546712368829816, 3.363536675342806],
            [31.547898298616758, 3.362981902329103],
            [31.548627584202094, 3.364140613307257],
            [31.549990612355714, 3.36366401905496],
            [31.550609389889715, 3.364655599706985],
            [31.55128486369456, 3.364756787279114],
            [31.551581294263592, 3.366527055140307],
            [31.552566515263244, 3.366884718163266],
            [31.553707931731246, 3.366474574653684],
            [31.552963089121842, 3.368343469022845],
            [31.553550059108282, 3.368377737938565],
            [31.554036557920053, 3.368946144055286],
            [31.55532194737863, 3.368547345468672],
            [31.556362092273087, 3.369216754758731],
            [31.557026743175363, 3.369150959285366],
            [31.55717008824357, 3.369585281965054],
            [31.55670388417069, 3.370274709847595],
            [31.55837535786029, 3.370945059548398],
            [31.559173068120803, 3.370779281606325],
            [31.558953025791954, 3.369777162164569],
            [31.560176959705302, 3.37026264033297],
            [31.561523203736183, 3.369391395670139],
            [31.56196401692757, 3.370361474220153],
            [31.564113934235802, 3.370096493705526],
            [31.5647680164588, 3.369685614410582],
            [31.564849893405345, 3.368860146288847],
            [31.56558897062728, 3.36864624858082],
            [31.567481024736562, 3.370096300901721],
            [31.567672456621924, 3.369618394910528],
            [31.567262526611685, 3.368430776109384],
            [31.56831203374802, 3.368095469074882],
            [31.56911742640082, 3.369150896511986],
            [31.5684822617994, 3.369858950449172],
            [31.56922102371265, 3.369836351149815],
            [31.569362770677984, 3.370577881586135],
            [31.57014907143607, 3.370627099433967],
            [31.57046000081376, 3.36993420133245],
            [31.570935962387278, 3.370317636031579],
            [31.57155600924078, 3.370031792341098],
            [31.571890122339354, 3.370471226167776],
            [31.572505154796925, 3.370116560543595],
            [31.572746070379736, 3.370894737803799],
            [31.573640556145797, 3.370473805253648],
            [31.5750491675119, 3.370769070187064],
            [31.574728237190122, 3.369502261506003],
            [31.572795707689057, 3.36969921201507],
            [31.5726060149421, 3.369124980967848],
            [31.574345892645617, 3.368936759432165],
            [31.575276390074784, 3.368244954178548],
            [31.576453811917684, 3.369550254430945],
            [31.57803009652652, 3.368932637910098],
            [31.578001460930206, 3.369796606656379],
            [31.57876789275082, 3.36994081495165],
            [31.578919398115094, 3.371195779542319],
            [31.57922044961793, 3.371284273684068],
            [31.579829445396804, 3.370487193901715],
            [31.58104312504122, 3.369827729679718],
            [31.581696812005454, 3.369891689435577],
            [31.582222150376868, 3.368911409739686],
            [31.583118158787343, 3.368620205682861],
            [31.583154894492576, 3.367990228477589],
            [31.583978768185727, 3.368036435123872],
            [31.58437667873747, 3.368469038308895],
            [31.585040680157814, 3.367592463468369],
            [31.585739068188953, 3.367710488375984],
            [31.585951836858943, 3.366113217703227],
            [31.586680550217395, 3.366937821879239],
            [31.587500509950857, 3.366592498362324],
            [31.589040534063248, 3.366860254420939],
            [31.590622506804472, 3.36598500982915],
            [31.591767343158725, 3.367039728419506],
            [31.592956659594325, 3.365187355364561],
            [31.593690755657985, 3.365386430288534],
            [31.594592291402396, 3.364361680760652],
            [31.59519229504526, 3.36438955048691],
            [31.59641170414456, 3.363405761580862],
            [31.59702492290359, 3.363586657592646],
            [31.59715545979244, 3.363114320924996],
            [31.59772855619764, 3.363169152021919],
            [31.597927615678064, 3.362719235263263],
            [31.599125113070926, 3.363487507355643],
            [31.59953640852039, 3.364332862253997],
            [31.599934362191263, 3.363621645883409],
            [31.60086762912645, 3.364115770163461],
            [31.602315830145432, 3.363734584806032],
            [31.602869310039786, 3.363117453336344],
            [31.603599838893434, 3.363877226449304],
            [31.60376192461509, 3.364831730068981],
            [31.60430752179281, 3.364284982961359],
            [31.60450812278225, 3.365521129033686],
            [31.6050297133823, 3.365435839409978],
            [31.60599307208289, 3.366665260975396],
            [31.606507626179315, 3.366055891970355],
            [31.60688049259925, 3.366564851096798],
            [31.607565475071368, 3.366518903545806],
            [31.607603634606335, 3.367050846506868],
            [31.60859919701154, 3.367529411983518],
            [31.60922203762558, 3.367397332964522],
            [31.60968665976524, 3.369064064774281],
            [31.610658365611457, 3.369902402153981],
            [31.611430697566878, 3.368636360870664],
            [31.611780306604086, 3.3690827102648],
            [31.61256750388081, 3.368309468238211],
            [31.61282568867662, 3.36736338595268],
            [31.612242651514507, 3.366869771785301],
            [31.612367935055605, 3.366338060987529],
            [31.613676399538885, 3.365706356928496],
            [31.61460990183268, 3.366044033143313],
            [31.61508581310053, 3.365239054837094],
            [31.61478345275232, 3.364401677467423],
            [31.616171347171328, 3.362635903040341],
            [31.61531070094203, 3.360794323215492],
            [31.614643767420596, 3.360601871797754],
            [31.614944571886728, 3.358773065344139],
            [31.61378078197828, 3.356355881050392],
            [31.613428124957288, 3.35388559173341],
            [31.61926713028664, 3.354565441487602],
            [31.622031964169786, 3.355308909809882],
            [31.625759808207178, 3.356946292038101],
            [31.629029920183115, 3.359297068927131],
            [31.63326096810334, 3.364046363960185],
            [31.637053304889918, 3.372517829994453],
            [31.65046158217689, 3.385288079923438],
            [31.65628808475411, 3.392538791846853],
            [31.658514474744152, 3.397412789412918],
            [31.65883773888902, 3.402207626662421],
            [31.65753932924875, 3.408011703725586],
            [31.65646911145353, 3.408387782732809],
            [31.657441959956756, 3.408526282994383],
            [31.65358425725851, 3.416248415551795],
            [31.652316073232576, 3.420401021454627],
            [31.651245725181678, 3.426580703552561],
            [31.652581467008567, 3.433338426990551],
            [31.65841705155327, 3.442901689054848],
            [31.66244798806584, 3.448321843333112],
            [31.665840302361463, 3.450777713984603],
            [31.67834456904542, 3.455733636379705],
            [31.681010945776787, 3.457618649846061],
            [31.682390319675363, 3.459438550856413],
            [31.687166928840657, 3.468390387396039],
            [31.695219253672647, 3.477844247876431],
            [31.69763910124904, 3.485209998626043],
            [31.699044803870247, 3.487654064087092],
            [31.7004753826383, 3.489835786015079],
            [31.707173857403916, 3.496836648257474],
            [31.723893692239088, 3.496760152072957],
            [31.726301442203532, 3.496401646399204],
            [31.73412307068743, 3.493807368041101],
            [31.73854446981971, 3.493731942204583],
            [31.748728892977983, 3.496875160857016],
            [31.751476984959154, 3.496969287716631],
            [31.76626527215191, 3.505626862361869],
            [31.769389369266637, 3.508686423936042],
            [31.766355598652023, 3.512175078473991],
            [31.76449265983943, 3.514973197640983],
            [31.761361898123603, 3.522416594095668],
            [31.75778103194141, 3.533796277383513],
            [31.757713332206652, 3.537713043151519],
            [31.756554628559343, 3.538588916719401],
            [31.755351752952855, 3.540665027315435],
            [31.752023527164553, 3.542950265749824],
            [31.750366893643438, 3.544649579035501],
            [31.748862110439674, 3.545388776126158],
            [31.747980791280707, 3.546684746485646],
            [31.747694253857908, 3.548765527198607],
            [31.747962456665782, 3.549763714120544],
            [31.74535021331174, 3.551157103657632],
            [31.741774193540483, 3.551864946282763],
            [31.738540926864225, 3.551176641259315],
            [31.731735759192343, 3.546689221390094],
            [31.72917124961753, 3.546174669997909],
            [31.72788806013308, 3.544368815104511],
            [31.72396414261525, 3.544697478818296],
            [31.72054511062645, 3.543486998077464],
            [31.71910952015742, 3.543666986494574],
            [31.717234715498208, 3.545039615568876],
            [31.71212365456946, 3.546719615951916],
            [31.709830799129875, 3.548142630835292],
            [31.704690646260662, 3.550031095681089],
            [31.703209368374583, 3.550728952940759],
            [31.702104319302574, 3.552214775806083],
            [31.699354499861084, 3.553216506799383],
            [31.6273886774978, 3.552580910565249],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 753,
        District: "MOYO",
        County: "OBONGI",
        Subcounty: "ITULA",
        Population: 13262,
        Key: "MOYOITULA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.6273886774978, 3.552580910565249],
            [31.627060437584543, 3.573163858968539],
            [31.62729255057587, 3.577232324892673],
            [31.628240058503273, 3.580703615401276],
            [31.628074463063797, 3.591920604647611],
            [31.62905505055318, 3.592727307080856],
            [31.62981776963676, 3.591873401256817],
            [31.630286796216257, 3.592729163835526],
            [31.630351617748843, 3.59431330501762],
            [31.629962173818676, 3.595202075286489],
            [31.629091976701275, 3.608284354144493],
            [31.626606169426832, 3.618062006248818],
            [31.626358151763405, 3.624582573778434],
            [31.627126097245295, 3.628651857966106],
            [31.627206233256835, 3.634724237609526],
            [31.627886684626695, 3.638357596497166],
            [31.62889380834961, 3.64176917323343],
            [31.63067893509232, 3.642609454549934],
            [31.630855674132892, 3.643866055070521],
            [31.630200570525393, 3.643924879761203],
            [31.629961477624327, 3.644522766505595],
            [31.62775934124865, 3.643801495470117],
            [31.62656732178239, 3.644517572192917],
            [31.62591721370622, 3.641286016276131],
            [31.625261296225087, 3.641883263775347],
            [31.622702987720704, 3.640443536396427],
            [31.61942977296376, 3.639242006916173],
            [31.616512202126124, 3.639117864437428],
            [31.61802358704892, 3.642288453534893],
            [31.618228258304942, 3.646179852921661],
            [31.61751178000065, 3.647435070540123],
            [31.617389574087714, 3.649468930009543],
            [31.618219658732727, 3.651803383835985],
            [31.61958758899287, 3.652882346325584],
            [31.618929367333056, 3.654975203892772],
            [31.61970228948163, 3.655754121748982],
            [31.619640086538084, 3.657488950397332],
            [31.620948386629664, 3.658627646878443],
            [31.62231815933446, 3.65851011148029],
            [31.622793166897125, 3.659408220055745],
            [31.622612602830078, 3.660664267242597],
            [31.62153992454931, 3.661201035942527],
            [31.621299168866653, 3.662875764768746],
            [31.62257756583906, 3.664104153403685],
            [31.623165165544496, 3.669250015883275],
            [31.624174001456346, 3.671524927402216],
            [31.627089125283153, 3.673324185231198],
            [31.627265757424205, 3.67464061153234],
            [31.628334338488944, 3.67679596644075],
            [31.62785666652315, 3.67763278143924],
            [31.628236818280044, 3.68215016858022],
            [31.6288907585692, 3.682869081497719],
            [31.628829926454785, 3.683706539827533],
            [31.627935679640586, 3.684363233674652],
            [31.627158786040173, 3.686156784735167],
            [31.627455247151907, 3.686994796669347],
            [31.626975451568775, 3.689207581670288],
            [31.62757002759071, 3.689806755022431],
            [31.628042473158192, 3.692379968968003],
            [31.62779457856396, 3.696403855654881],
            [31.62826194056527, 3.703794016745833],
            [31.628911557262963, 3.707324710049267],
            [31.627464490816177, 3.718868702439808],
            [31.627939143544328, 3.720006119969525],
            [31.627934603458893, 3.722937544142167],
            [31.628348407004623, 3.724912419684446],
            [31.631202553189958, 3.727728662441905],
            [31.631645071383733, 3.729522866888353],
            [31.627925605034672, 3.728740565242157],
            [31.62697221224388, 3.729098020873528],
            [31.62584109316397, 3.728856947516375],
            [31.62476831696685, 3.729393689303272],
            [31.623041490886067, 3.729271326231777],
            [31.622685109449908, 3.728672517582147],
            [31.621612706951943, 3.72896995477868],
            [31.621674496670465, 3.727534253380475],
            [31.620601535420377, 3.728190639492664],
            [31.61869652670635, 3.727768864847092],
            [31.61857564760509, 3.728905345778593],
            [31.61821805523994, 3.72908425644725],
            [31.616969241586485, 3.727945614491735],
            [31.61363724556893, 3.726085782876698],
            [31.613877325718512, 3.724889667710014],
            [31.612747627773377, 3.723751211262468],
            [31.61304688444228, 3.722794489013022],
            [31.61293162250651, 3.720341493097986],
            [31.611741347568536, 3.719861015142035],
            [31.61108825259402, 3.718603663075791],
            [31.610017458080428, 3.717884074566058],
            [31.60894507085379, 3.718181499271683],
            [31.608290573609167, 3.717821515772327],
            [31.60734020005599, 3.716264570676755],
            [31.60781895359342, 3.714769713015937],
            [31.60764142762866, 3.714051537735782],
            [31.606093203694357, 3.713989261045311],
            [31.60538028721013, 3.712911287877551],
            [31.604903882767204, 3.712910533083701],
            [31.604604813846194, 3.713747602667414],
            [31.603177105195464, 3.712788145311997],
            [31.602822249098676, 3.711232144243323],
            [31.600620958935966, 3.709912510075638],
            [31.6000861370501, 3.709193767885334],
            [31.600802905510243, 3.707818943451782],
            [31.600386807667263, 3.70733968858879],
            [31.59931490732755, 3.707337985361514],
            [31.599142285265906, 3.703508949094296],
            [31.597657968379252, 3.700694844163811],
            [31.594858763156697, 3.700929690461119],
            [31.59289504774223, 3.700029198863938],
            [31.589947875619337, 3.699695463895518],
            [31.589115132859384, 3.699095892028053],
            [31.58917629196057, 3.698078979082258],
            [31.586258859463488, 3.697775194507324],
            [31.585127047782485, 3.698012678919165],
            [31.58197275829108, 3.696870965110906],
            [31.58084047140131, 3.69740756229456],
            [31.58042524851744, 3.696389889018456],
            [31.579354513292625, 3.695670281535852],
            [31.579296297970625, 3.694832653398681],
            [31.577510315133452, 3.694530662401451],
            [31.577572056342923, 3.693154812976852],
            [31.576977524338446, 3.692555617679281],
            [31.5766823568007, 3.690939899769408],
            [31.575730727402778, 3.690220482398635],
            [31.576151664470185, 3.687648735970888],
            [31.575717604813107, 3.686999364112596],
            [31.574633331078676, 3.687556557946984],
            [31.572846793082622, 3.687613505275801],
            [31.572252745270088, 3.686715192002908],
            [31.57189507564982, 3.686953910207287],
            [31.571300743071333, 3.686235067824608],
            [31.569394253933726, 3.686830227953308],
            [31.566893051331963, 3.686945833138428],
            [31.566238793039172, 3.686466185999519],
            [31.56659972174731, 3.684193474871707],
            [31.564904581043212, 3.682964349208644],
            [31.563654275288073, 3.682842678056672],
            [31.563476496896698, 3.682303978840461],
            [31.56288102166117, 3.682303015145211],
            [31.561275741231594, 3.680745002711258],
            [31.555379796187985, 3.681214011035709],
            [31.553654281647532, 3.680373675405674],
            [31.553238129007326, 3.679954233876673],
            [31.552824294020567, 3.678099039254575],
            [31.55324314969144, 3.676843433431268],
            [31.55098636340714, 3.673130718074583],
            [31.550394086174016, 3.671155588218268],
            [31.54831112479547, 3.670434314408723],
            [31.543909165205946, 3.667675264971082],
            [31.541918595554378, 3.6650697091698],
            [31.53983546798751, 3.664468070012783],
            [31.538468930116064, 3.662611320992823],
            [31.538352266808445, 3.661115558182014],
            [31.536625646441866, 3.660993082597434],
            [31.53591460384335, 3.658838294707936],
            [31.53508223568085, 3.658059232507908],
            [31.53442733688926, 3.657998335173114],
            [31.53276367854264, 3.655782162976423],
            [31.531810278565306, 3.656199354909763],
            [31.530858048194457, 3.655898676736813],
            [31.530205004423937, 3.654701149222488],
            [31.529788191522005, 3.654700463408838],
            [31.529671636910535, 3.653144883448531],
            [31.52872223802947, 3.651109352277683],
            [31.528008094446573, 3.65086888709494],
            [31.526578248703782, 3.651345114400261],
            [31.526163194703166, 3.650267624793917],
            [31.525329965056347, 3.650026961260838],
            [31.524379503468285, 3.648649477082848],
            [31.52390315112763, 3.64864869175371],
            [31.52354851781302, 3.647036882043669],
            [31.522286214158946, 3.646504895747727],
            [31.52212249889336, 3.645176051942711],
            [31.519620873185065, 3.645650500924607],
            [31.51884827263338, 3.644751889096491],
            [31.515916812943157, 3.643679117034439],
            [31.515878933682547, 3.639961193649179],
            [31.516537045747924, 3.638047967925684],
            [31.515954711966668, 3.636822172206505],
            [31.516891688943964, 3.63544262019404],
            [31.516926576814672, 3.634684540220452],
            [31.518037827855412, 3.634160022614747],
            [31.521759416025187, 3.633519075917707],
            [31.52347824979486, 3.631817293061485],
            [31.523926996906845, 3.630803102538891],
            [31.523625418991244, 3.628879422863237],
            [31.524431161987007, 3.627835441429662],
            [31.52471221160174, 3.625875960198313],
            [31.52570218918082, 3.62492174185916],
            [31.526786444050654, 3.622790957120648],
            [31.53110886590664, 3.621354021542152],
            [31.531371058086933, 3.617423424829466],
            [31.532762883533643, 3.615875546284807],
            [31.533170803114242, 3.613453790525171],
            [31.534556038520044, 3.611073605858495],
            [31.535510133793395, 3.610198583280714],
            [31.53475208594933, 3.604158787976879],
            [31.534929400810004, 3.60301306924109],
            [31.53636449810393, 3.601994375440644],
            [31.536636468446098, 3.601237298503857],
            [31.535880998766864, 3.600323925827341],
            [31.53579927004234, 3.599318875304033],
            [31.534849186645015, 3.598821333961923],
            [31.53472658906661, 3.597336959211587],
            [31.533788347261364, 3.596189892452585],
            [31.53366985678045, 3.595205173754258],
            [31.535062304759645, 3.594733542192707],
            [31.53550899742457, 3.59414946977423],
            [31.53580916678179, 3.589950543730732],
            [31.534998979820323, 3.588048657943287],
            [31.537737150807512, 3.585958873292829],
            [31.536852568967454, 3.584285982580762],
            [31.53764526213712, 3.580241889642016],
            [31.535799839574228, 3.57993457321936],
            [31.535535996290434, 3.579173256075966],
            [31.536670878413045, 3.576560222757618],
            [31.539291701576367, 3.573388801823312],
            [31.5395414422085, 3.572403350287821],
            [31.538645057403944, 3.569879301305119],
            [31.538895815827285, 3.568250148390757],
            [31.53847037640366, 3.567199827741941],
            [31.539323383359804, 3.564843846685442],
            [31.53863262382208, 3.563140703653107],
            [31.53990948198039, 3.562296065997802],
            [31.541425265953176, 3.559996225305358],
            [31.545005185311027, 3.559590012680172],
            [31.553884057222465, 3.559510635562793],
            [31.5549283442487, 3.559764932269026],
            [31.55601149958062, 3.560771719844551],
            [31.55689428928167, 3.560349023014426],
            [31.557783558530886, 3.561185872066902],
            [31.558615384110944, 3.560966655377356],
            [31.558597695384698, 3.561484011988653],
            [31.558003848794776, 3.561975017826291],
            [31.55825198144253, 3.562468878110875],
            [31.55869316024824, 3.562518932345372],
            [31.558888489923604, 3.561764365457894],
            [31.560031995872958, 3.561965482699011],
            [31.561595710356002, 3.563367424187267],
            [31.562174906321967, 3.562753407545768],
            [31.56183425348815, 3.561964070585629],
            [31.562522851679283, 3.561566509931971],
            [31.562978275070467, 3.561834397327324],
            [31.56316530431262, 3.560986517333421],
            [31.56387376155976, 3.561390509409306],
            [31.5651921748848, 3.560395688286333],
            [31.566517660646088, 3.560283535803868],
            [31.567854025903795, 3.561324638536404],
            [31.56872936407955, 3.560261544451407],
            [31.5706881657094, 3.560018628195222],
            [31.570878504345067, 3.559755988862982],
            [31.569893215073463, 3.558377945686179],
            [31.57104348803185, 3.5580023784777],
            [31.572719019411576, 3.554986110636461],
            [31.57217612706118, 3.554145834576097],
            [31.572429531921372, 3.553838180380202],
            [31.57276629954161, 3.554146751785157],
            [31.573203913832266, 3.553669956282348],
            [31.57366517896774, 3.551640533431193],
            [31.574643203563642, 3.551128494353417],
            [31.574051330572377, 3.55035461543082],
            [31.574503168787242, 3.549630024207833],
            [31.574192016627343, 3.549220928059355],
            [31.57513479582309, 3.548789938728929],
            [31.574478430082642, 3.548084061769555],
            [31.57552908796086, 3.548020990904269],
            [31.576100509906336, 3.546659826530482],
            [31.57553367925026, 3.545024490884811],
            [31.57415533571936, 3.544412842499539],
            [31.574268024880183, 3.543854577126957],
            [31.57541706534998, 3.543720149356403],
            [31.575344021537596, 3.543187188255855],
            [31.57889705881061, 3.543600370180492],
            [31.58001472561911, 3.544184143896835],
            [31.582322541601464, 3.544130266473664],
            [31.5832095848254, 3.543406561589859],
            [31.586112845500573, 3.543826835503095],
            [31.58804027616405, 3.544906628801102],
            [31.589969343558007, 3.54490958308653],
            [31.592968816495038, 3.545775640192401],
            [31.60067993423268, 3.549233286687581],
            [31.609464036576593, 3.551902826301697],
            [31.618177502593067, 3.552571000566527],
            [31.6273886774978, 3.552580910565249],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 754,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "LEFORI",
        Population: 12423,
        Key: "MOYOLEFORI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.859752511680558, 3.608057740677043],
            [31.865374287306203, 3.608326882153993],
            [31.866517178807904, 3.60903444480273],
            [31.867366303245362, 3.610522434111462],
            [31.870288232708777, 3.611306725599229],
            [31.87302246907502, 3.614283995191828],
            [31.87416966440525, 3.614099557728689],
            [31.874687235942723, 3.614434761700031],
            [31.875389024097174, 3.615402140457619],
            [31.876197409038202, 3.619938285555165],
            [31.87793467623752, 3.621315858410753],
            [31.878451016184737, 3.622654739837866],
            [31.8906105894127, 3.63611834909717],
            [31.89297106733196, 3.639660959191559],
            [31.895965772011465, 3.641560497289835],
            [31.906701691583898, 3.646703656190926],
            [31.90998711444556, 3.649747371922786],
            [31.920209668392662, 3.657545140321067],
            [31.924717337233265, 3.662701688014647],
            [31.927065943916045, 3.664588649966301],
            [31.933982067000255, 3.668298880842827],
            [31.936166123882543, 3.669000121973824],
            [31.940188803081035, 3.671757194186339],
            [31.94221258524529, 3.672692984246501],
            [31.945958860915695, 3.673535484917991],
            [31.94124149384675, 3.680398045742665],
            [31.932616789465172, 3.696578001125594],
            [31.92838831162498, 3.702886462321771],
            [31.916093261672383, 3.717595743991815],
            [31.912215674765328, 3.725991863536172],
            [31.90712351798343, 3.734427226577283],
            [31.902728935359, 3.7400553097432],
            [31.897765354443735, 3.747327739642225],
            [31.887737698082336, 3.758525767052606],
            [31.88203197758836, 3.764070944223747],
            [31.8778719082537, 3.770961370532704],
            [31.875571692018625, 3.775611109064688],
            [31.870540197569557, 3.782034142479295],
            [31.8654968363756, 3.786493138435005],
            [31.851607634323173, 3.795660671078358],
            [31.842526954086534, 3.801009835102288],
            [31.836260418055613, 3.80681692511954],
            [31.828067435914726, 3.815724619724715],
            [31.825189506832235, 3.81761782588654],
            [31.81650733362868, 3.821369477228006],
            [31.813491153823996, 3.8220977917964],
            [31.8054880701443, 3.822217789849351],
            [31.80221335609913, 3.821610587643888],
            [31.798275123028922, 3.820331490112962],
            [31.796509065723065, 3.819275289411625],
            [31.7972244453878, 3.817559432301445],
            [31.79718511085646, 3.816128674393406],
            [31.796472587834327, 3.815307008856299],
            [31.796783308802894, 3.812770537106373],
            [31.79754746788585, 3.81177889679082],
            [31.80118062679738, 3.810413607026715],
            [31.802202321194184, 3.809638127513463],
            [31.803757546597826, 3.805438983787639],
            [31.80355445278344, 3.802971555597219],
            [31.801910092944066, 3.800490215424307],
            [31.801690416229533, 3.799138373501688],
            [31.79463849662043, 3.794542620923122],
            [31.792997435394796, 3.792641220727884],
            [31.78969091919195, 3.790942499866211],
            [31.785001068418463, 3.787450629863769],
            [31.78346542179646, 3.787016853007426],
            [31.780622518026902, 3.784164201516383],
            [31.774783759734284, 3.780314598961335],
            [31.772370165330617, 3.777786251234172],
            [31.765964063443878, 3.772565447131311],
            [31.763344665906914, 3.771266883976952],
            [31.76051224457842, 3.768683972802183],
            [31.75686323040215, 3.76621858220703],
            [31.75601644877092, 3.764890172785361],
            [31.751391107814626, 3.761570943882486],
            [31.742968454303405, 3.753568918083055],
            [31.741209926676255, 3.752534741784953],
            [31.739731687790794, 3.751045652299408],
            [31.738910380584386, 3.748513243188396],
            [31.73911575971285, 3.747185019258187],
            [31.740129756445995, 3.746109585061889],
            [31.74018991212902, 3.74569087753605],
            [31.73941619766637, 3.745330793260077],
            [31.73983540188361, 3.743716049634548],
            [31.740133609320274, 3.743417340965118],
            [31.740967135411132, 3.743598027129236],
            [31.741326863970052, 3.741923368506982],
            [31.74216243911809, 3.740668188612933],
            [31.743055775938892, 3.740669474949057],
            [31.745142017066538, 3.7394160896502],
            [31.745321535494597, 3.738818067791022],
            [31.743891857736767, 3.739055325114041],
            [31.74321661210398, 3.738685143710621],
            [31.746517580311657, 3.735349765135716],
            [31.74651825943799, 3.734871142875156],
            [31.747410997082536, 3.735291217212489],
            [31.74818717023408, 3.733916285602995],
            [31.748426070895697, 3.733438003196178],
            [31.747712762746033, 3.732479735318778],
            [31.74855119812993, 3.729190396258819],
            [31.748968338018646, 3.729011508022075],
            [31.74861261594592, 3.727874268861112],
            [31.749566849559823, 3.726918382967928],
            [31.74913734885282, 3.726565537613829],
            [31.75177140420029, 3.720980528956111],
            [31.75410530636015, 3.718624169670564],
            [31.754800668865396, 3.718389525288913],
            [31.75516175657532, 3.717595462514373],
            [31.754853644314327, 3.716349886258574],
            [31.75515757222274, 3.715320112390425],
            [31.757189949467627, 3.712803059215966],
            [31.75623968011904, 3.71177151075868],
            [31.757251272062184, 3.711157781663977],
            [31.75723160614396, 3.707950350045933],
            [31.756603980204414, 3.707259817982244],
            [31.75653139004126, 3.705938583123234],
            [31.75520284461809, 3.703743131280336],
            [31.754057692056865, 3.700525931139334],
            [31.752752954683665, 3.69559092533414],
            [31.75250575358883, 3.690630975182213],
            [31.75168721229522, 3.689462118023874],
            [31.754813203956893, 3.688485545249754],
            [31.759125210745434, 3.686122715789064],
            [31.7574980563387, 3.684899622368347],
            [31.75639909694598, 3.682259895383766],
            [31.756480539107965, 3.680501545036949],
            [31.757556623800294, 3.67751164026663],
            [31.758034529328064, 3.676435399571547],
            [31.76202953951749, 3.672791445375743],
            [31.764890573086102, 3.670940742420871],
            [31.766859142098024, 3.668490505894387],
            [31.767576303121967, 3.666636815934639],
            [31.767999225466127, 3.662210092094746],
            [31.7674657223071, 3.660414500028213],
            [31.766455076289965, 3.65915670614039],
            [31.766456632172037, 3.658019968254985],
            [31.76709956809898, 3.657023931532873],
            [31.763294077281703, 3.653555551957503],
            [31.759637116608413, 3.652229477084383],
            [31.760604157503337, 3.650499733930191],
            [31.760173700988858, 3.648181016476806],
            [31.7574685098507, 3.644972242084513],
            [31.75480131385578, 3.643265454184795],
            [31.75297270326344, 3.643249501866956],
            [31.752501884544934, 3.642898072968045],
            [31.751979385748115, 3.633133390270977],
            [31.75378342202756, 3.633914498385145],
            [31.753599630313705, 3.632603983988687],
            [31.75586431548431, 3.630753507482094],
            [31.76051646576195, 3.62537537539343],
            [31.761891698427036, 3.621249106098253],
            [31.761983013073984, 3.61978343540302],
            [31.76069737029049, 3.616786211059007],
            [31.761820731519567, 3.61604308744219],
            [31.7611027090113, 3.614588233905486],
            [31.760992743542413, 3.612396641894509],
            [31.759611586488035, 3.612062321149554],
            [31.75985318928203, 3.609549860121397],
            [31.760808302346593, 3.607816145157452],
            [31.76135467297378, 3.605766074900981],
            [31.761215717074027, 3.604127622502664],
            [31.758270907520338, 3.597597803645599],
            [31.75653581424403, 3.594891189359038],
            [31.7565476675142, 3.593259060484209],
            [31.755523792007875, 3.592550702887808],
            [31.755934208006686, 3.590967684714688],
            [31.75699835858044, 3.590415840934053],
            [31.75890004532453, 3.58837695279892],
            [31.75998724397355, 3.585793722198636],
            [31.774302441506734, 3.588423343195925],
            [31.775008105891665, 3.589629195035624],
            [31.776138644659884, 3.590054105405737],
            [31.776514224890274, 3.591146507282121],
            [31.777201254622945, 3.591526254087364],
            [31.78059660612256, 3.590345860558261],
            [31.781282466248708, 3.591264328469288],
            [31.78333993164283, 3.591881548212591],
            [31.78450680995926, 3.591508098032953],
            [31.784834141675752, 3.590946020442894],
            [31.785533970604572, 3.590946955546176],
            [31.79164254238436, 3.593439540322012],
            [31.80508957568764, 3.600075736872637],
            [31.810552455509196, 3.601827716578097],
            [31.81440977911836, 3.60435029845667],
            [31.815721839557725, 3.601733975157015],
            [31.81702947309936, 3.601195827185279],
            [31.818549881599207, 3.599702065913542],
            [31.821529251138525, 3.598180281591898],
            [31.82522227018731, 3.597377366506671],
            [31.826799375856286, 3.598097362881103],
            [31.828943302299884, 3.597950556391039],
            [31.830252753133347, 3.598430884560047],
            [31.833972009276657, 3.600410060232541],
            [31.838493484324847, 3.603736431249283],
            [31.84486188841066, 3.606377101407642],
            [31.851143499968675, 3.607043224108171],
            [31.854299725329557, 3.606957477634432],
            [31.859752511680558, 3.608057740677043],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 755,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "METU",
        Population: 28049,
        Key: "MOYOMETU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.7577133295117, 3.537713022529658],
            [31.75815841598891, 3.542661980633592],
            [31.758979672889648, 3.544198805053939],
            [31.758610030523265, 3.546884039754885],
            [31.75907926012204, 3.548679538570891],
            [31.758849277036237, 3.551274050422001],
            [31.758185155241648, 3.55335322755773],
            [31.757506997270745, 3.553854826429456],
            [31.755226469411756, 3.558330609667602],
            [31.7540636424973, 3.559328548645363],
            [31.754174528739316, 3.560323264227989],
            [31.753452858172672, 3.562200689649423],
            [31.758533813861295, 3.566911223852309],
            [31.76182999943835, 3.56863656892028],
            [31.76368930187073, 3.572832802604233],
            [31.765345570675827, 3.575311183106296],
            [31.764531261345503, 3.576816012906085],
            [31.760921578107286, 3.578977783780031],
            [31.76014881675719, 3.580412564559609],
            [31.760038281756408, 3.581473448600501],
            [31.75873165342959, 3.582375261962299],
            [31.7585858182314, 3.582948290020345],
            [31.75903918627722, 3.583764999692782],
            [31.760025157370112, 3.584252643170626],
            [31.759976381545144, 3.585831354265518],
            [31.75890001747675, 3.58837694114372],
            [31.756998326241114, 3.590415829278879],
            [31.75605783235944, 3.590815214456578],
            [31.755524106418232, 3.592302648989015],
            [31.755684821310748, 3.592827551206891],
            [31.75654769536198, 3.59325908558758],
            [31.756535834006968, 3.594891224324422],
            [31.75827091650351, 3.597597813507594],
            [31.761215706294262, 3.604127649398844],
            [31.76135466399061, 3.605766072211391],
            [31.760808305939882, 3.607816128123299],
            [31.759853214434848, 3.609549870879778],
            [31.75961158199645, 3.612062331907938],
            [31.760992741745785, 3.61239663920494],
            [31.76110271529952, 3.614588233905486],
            [31.761820735112856, 3.616043059649855],
            [31.760697350527554, 3.616786195818073],
            [31.761982361795386, 3.620262049531085],
            [31.761651810516938, 3.622505174241837],
            [31.76051649360972, 3.625375365531735],
            [31.75586434333209, 3.630753474311146],
            [31.75359960695748, 3.632604000125881],
            [31.75378341034946, 3.633914515418806],
            [31.751979410900933, 3.633133361582675],
            [31.75250190790112, 3.642898052348526],
            [31.75297268080554, 3.64324950814246],
            [31.75480131385578, 3.643265477493783],
            [31.757468538596775, 3.644972257324971],
            [31.760173730633262, 3.648181014683819],
            [31.76060415031683, 3.650499711517864],
            [31.75963712738821, 3.652229450189636],
            [31.763294043145713, 3.653555555543455],
            [31.767099601336643, 3.65702391270668],
            [31.76645660342596, 3.658019992460091],
            [31.766455060120283, 3.65915670614039],
            [31.767643783667765, 3.660833550005707],
            [31.76799840799924, 3.662808400552641],
            [31.767576269884273, 3.666636782765015],
            [31.766859160962664, 3.668490526513285],
            [31.764890587459156, 3.67094077021151],
            [31.762029523347802, 3.672791422963974],
            [31.758034547294375, 3.676435427362015],
            [31.75695895487882, 3.679066342335132],
            [31.7563991220988, 3.682259919588215],
            [31.757498084186473, 3.684899642986865],
            [31.759125227813442, 3.686122747165051],
            [31.75481317431249, 3.688485538078131],
            [31.751687177260933, 3.689462112645162],
            [31.75250576706359, 3.690631002972238],
            [31.752752944802197, 3.695590892165596],
            [31.75405767768381, 3.70052596072193],
            [31.755202818566975, 3.703743132176756],
            [31.756531413397454, 3.705938564298077],
            [31.756603980204414, 3.707259827843034],
            [31.757231607940586, 3.707950362596032],
            [31.757251258587427, 3.711157772699643],
            [31.75623967113587, 3.711771477590742],
            [31.757189919823222, 3.712803073558853],
            [31.755157552459803, 3.715320146454673],
            [31.75485366856885, 3.716349916737082],
            [31.75516176286353, 3.717595458032239],
            [31.75480068234012, 3.718389494810508],
            [31.754105329716374, 3.718624175049132],
            [31.751771394318823, 3.720980506545593],
            [31.7491373659208, 3.726565545681576],
            [31.749566872916017, 3.726918369521702],
            [31.748612623132427, 3.727874241968655],
            [31.74896837035797, 3.729011497265132],
            [31.748551215197914, 3.729190429426101],
            [31.74771276454266, 3.732479769382362],
            [31.74842608257379, 3.733438016642339],
            [31.748187187302086, 3.733916264985587],
            [31.74741098630274, 3.735291200180769],
            [31.746518285489145, 3.734871149150014],
            [31.746517583904907, 3.735349747207575],
            [31.743216625578736, 3.73868514460704],
            [31.7438918361772, 3.739055331388867],
            [31.745321561545747, 3.738818064205415],
            [31.745142038626106, 3.739416063654513],
            [31.743055771447306, 3.740669485705856],
            [31.74216243911809, 3.740668155446085],
            [31.741326865766677, 3.741923396295391],
            [31.740967118343157, 3.743598052228418],
            [31.74013357967587, 3.743417372339069],
            [31.739835381222345, 3.743716055012928],
            [31.73941619047986, 3.745330760989783],
            [31.740189935485212, 3.745690860504499],
            [31.74012978968368, 3.746109575201535],
            [31.739115746238127, 3.747185039875249],
            [31.739003106484645, 3.748383476781492],
            [31.737883931404777, 3.747172363956194],
            [31.73683255217939, 3.747022638220108],
            [31.735281344041734, 3.749597668830033],
            [31.732636998492676, 3.750044534636928],
            [31.730893073878807, 3.752179274941404],
            [31.730130488644228, 3.752412476065637],
            [31.72961746617536, 3.746543066777583],
            [31.728958046162948, 3.746171902503288],
            [31.728496396548547, 3.745024795641074],
            [31.728252798596337, 3.742992633448866],
            [31.72548493469572, 3.734355504981669],
            [31.724591672435075, 3.733611625923404],
            [31.722805990533523, 3.733767937174904],
            [31.720768569248307, 3.729359697321871],
            [31.71910149281203, 3.729058068628428],
            [31.718091519633052, 3.727381423592576],
            [31.717496174653242, 3.72720108996647],
            [31.716903637806986, 3.725166085200233],
            [31.712357952263556, 3.718129741517489],
            [31.712122074432898, 3.716514074783094],
            [31.70825103714258, 3.716568210850415],
            [31.704743817542322, 3.712135863239367],
            [31.702839950587045, 3.710876727022365],
            [31.702184741876685, 3.710995364388673],
            [31.702599089801488, 3.712730938740213],
            [31.70230025983234, 3.713506980495448],
            [31.701763586518652, 3.713926270793185],
            [31.70045366047642, 3.713744884694943],
            [31.70015483050727, 3.714462377146334],
            [31.698547547732925, 3.714041195638887],
            [31.697655899744834, 3.71290315098454],
            [31.697001182412958, 3.7126628656401],
            [31.694797712937355, 3.712659573949081],
            [31.69390564363942, 3.711820711368551],
            [31.694681844638772, 3.710445879368425],
            [31.69456344937925, 3.709967058906835],
            [31.69272049898004, 3.707810575231617],
            [31.692363068311636, 3.707869823304229],
            [31.69170589408743, 3.709304749039748],
            [31.68861225075914, 3.707206181555362],
            [31.687897388524036, 3.707384627791641],
            [31.686286737067373, 3.709236815519234],
            [31.6855124315133, 3.70929550412177],
            [31.685452216541496, 3.70977404526018],
            [31.68390276281357, 3.710489650362157],
            [31.68032262516509, 3.715210544761628],
            [31.67919081797567, 3.715388359192462],
            [31.677703614802006, 3.714309214308757],
            [31.674517473745546, 3.714394164336933],
            [31.667547037620935, 3.716238213948517],
            [31.66349521527798, 3.717727750632053],
            [31.657836320366506, 3.718676350507831],
            [31.653962686046707, 3.720465203837054],
            [31.65053470144777, 3.722942686901237],
            [31.648745088518524, 3.724914177559285],
            [31.646838134053617, 3.725748756254471],
            [31.643439905250137, 3.728196390886268],
            [31.643200868942955, 3.728734449011718],
            [31.642129698035216, 3.728194359611666],
            [31.640104278242216, 3.72861000168638],
            [31.63968677184089, 3.729028094358791],
            [31.637722619845196, 3.728307181401415],
            [31.63575643226708, 3.72896219452762],
            [31.634506299886784, 3.728661125059982],
            [31.63313454460013, 3.72997514112491],
            [31.631646358669542, 3.729554036955842],
            [31.631202535223647, 3.727728644513608],
            [31.628348418682716, 3.724912426855808],
            [31.62793463220497, 3.722937574620415],
            [31.627939123781392, 3.720006137897978],
            [31.627464490816177, 3.718868731125351],
            [31.62891155007645, 3.70732467867403],
            [31.62826195583662, 3.703794047224774],
            [31.627794551614517, 3.696403857447771],
            [31.628042500107668, 3.69237999406861],
            [31.62757004286206, 3.689806756815333],
            [31.626975470433383, 3.689207604081644],
            [31.627455226490675, 3.686994830734682],
            [31.627158782446916, 3.686156783838729],
            [31.6279356850305, 3.684363238156954],
            [31.62882993004804, 3.683706512037324],
            [31.628890776535503, 3.682869093151698],
            [31.628236831754762, 3.682150173062534],
            [31.62785666113327, 3.677632769785193],
            [31.628334312437826, 3.676795974508949],
            [31.627265738559565, 3.674640600774737],
            [31.62708909294379, 3.673324192402943],
            [31.624173989778253, 3.671524948021044],
            [31.62316513949335, 3.669250007815007],
            [31.622577585601995, 3.664104163264954],
            [31.62129917066328, 3.662875776422984],
            [31.621539891311656, 3.661201037735487],
            [31.62261260552504, 3.660664269035559],
            [31.62279318127018, 3.659408211987422],
            [31.622318126995093, 3.658510116859189],
            [31.6209484063926, 3.658627640603047],
            [31.61964009462292, 3.65748896474111],
            [31.619702275108576, 3.655754123541956],
            [31.61892937272294, 3.654975228994464],
            [31.61958759887434, 3.65288234722209],
            [31.618219633579905, 3.651803407144753],
            [31.617389603732118, 3.64946895421488],
            [31.61751178898379, 3.647435101917468],
            [31.618228265491485, 3.64617986726562],
            [31.61802361848995, 3.642288432018844],
            [31.61651220302442, 3.639117894918577],
            [31.619429762183994, 3.639242005123136],
            [31.6227029985005, 3.640443529224418],
            [31.625261302513298, 3.641883255706834],
            [31.62591721280789, 3.641286031516652],
            [31.626567298426163, 3.644517564124426],
            [31.627759320587383, 3.643801485608626],
            [31.629961456064763, 3.644522747679141],
            [31.63020056244059, 3.643924895001713],
            [31.630855701082336, 3.643866061346022],
            [31.630678915329383, 3.642609421379423],
            [31.628893794874852, 3.641769161578916],
            [31.62788669899971, 3.638357618013276],
            [31.627206225171992, 3.634724244781581],
            [31.627126078380687, 3.6286518516905],
            [31.626358158949948, 3.624582577364502],
            [31.626606178410004, 3.618061993697492],
            [31.629091985684408, 3.608284356834109],
            [31.629962158547325, 3.595202073493397],
            [31.63035159169773, 3.594313300534904],
            [31.630286815080897, 3.592729140525238],
            [31.629817795687913, 3.59187342546366],
            [31.629055070316117, 3.592727319632566],
            [31.628074432521057, 3.591920634233781],
            [31.62824005940157, 3.580703596573497],
            [31.62729254788091, 3.577232355375898],
            [31.62706045914411, 3.573163832968032],
            [31.62738869546408, 3.552580899806166],
            [31.699354487284655, 3.55321649693691],
            [31.70210431481099, 3.552214769529951],
            [31.703209382747637, 3.55072895114758],
            [31.704690620209508, 3.550031081335616],
            [31.709830809011343, 3.548142633525084],
            [31.712123687807154, 3.546719641056559],
            [31.717234681362218, 3.545039645156556],
            [31.719109493207945, 3.543667010702721],
            [31.72054511332138, 3.54348699090466],
            [31.723964115665805, 3.544697467162542],
            [31.72788806911625, 3.544368808828326],
            [31.72917125590574, 3.54617467896388],
            [31.731735735836118, 3.546689240218602],
            [31.7385408945249, 3.551176616154794],
            [31.74177419803207, 3.551864959731603],
            [31.745350195345427, 3.551157073173576],
            [31.747962467445547, 3.549763715017117],
            [31.747694236789926, 3.54876555588956],
            [31.747980784992496, 3.546684757244798],
            [31.748862116727853, 3.545388757297623],
            [31.750366864897362, 3.544649555723992],
            [31.752023555012332, 3.542950292647796],
            [31.755351742173087, 3.540665014763014],
            [31.756554642932365, 3.538588891614537],
            [31.7577133295117, 3.537713022529658],
          ],
          [
            [31.732021722591668, 3.638372956312061],
            [31.7307356576, 3.639041552225409],
            [31.728347051632568, 3.641434514612832],
            [31.72622029019741, 3.640589421567357],
            [31.72590559957361, 3.643167422821158],
            [31.724582479076442, 3.64517459961609],
            [31.720762323262154, 3.648661269570702],
            [31.71831104543061, 3.651885631529941],
            [31.715958442143144, 3.65420242810218],
            [31.718942322123493, 3.654537841293957],
            [31.719121073390298, 3.655785010220133],
            [31.718498919089136, 3.658813381409812],
            [31.719979596002258, 3.660330048665413],
            [31.723464427789015, 3.660285435199031],
            [31.72664958698684, 3.662425294996415],
            [31.728503765428837, 3.661981046576407],
            [31.73085398279092, 3.660370460314982],
            [31.734141606525007, 3.659953035444765],
            [31.736392377690176, 3.658689904137343],
            [31.738895238581975, 3.653901264259149],
            [31.73907076040535, 3.652113746380591],
            [31.735844405366862, 3.64406434184896],
            [31.73493472010621, 3.640686215141968],
            [31.732021722591668, 3.638372956312061],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 756,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "MOYO",
        Population: 24570,
        Key: "MOYOMOYO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.721092048988872, 3.660331677574601],
            [31.71997961396856, 3.660330082731734],
            [31.718498902919457, 3.658813353618796],
            [31.71912106620375, 3.655785034425298],
            [31.718942310445364, 3.654537866395627],
            [31.715958413397036, 3.654202421826751],
            [31.718311031955885, 3.651885627047475],
            [31.720762307990803, 3.648661284811131],
            [31.724582454821952, 3.645174567342186],
            [31.725905586098886, 3.643167395926173],
            [31.726220289299082, 3.640589452944941],
            [31.72834707948034, 3.641434528060384],
            [31.73073562975223, 3.639041549535885],
            [31.732021693845592, 3.638372964380605],
            [31.734934715614624, 3.640686242037028],
            [31.735844419739916, 3.644064372329908],
            [31.73907074872722, 3.652113770585824],
            [31.738895250260075, 3.653901268741604],
            [31.7363923794868, 3.658689879035754],
            [31.7341415777789, 3.659953007653784],
            [31.730853950451554, 3.660370444178287],
            [31.72850379147995, 3.661981027750318],
            [31.72664956812224, 3.662425317408443],
            [31.72346442060247, 3.66028541547641],
            [31.721092048988872, 3.660331677574601],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 757,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "MOYO TOWN COUNCIL",
        Population: 10579,
        Key: "MOYOMOYO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.817341040280954, 3.379059150532754],
            [31.816283869616914, 3.379687295671045],
            [31.8163160113378, 3.380728008269588],
            [31.81437803624949, 3.381162041503415],
            [31.81262107977576, 3.382583188125819],
            [31.81118075698182, 3.385331286125547],
            [31.808773839755645, 3.386805396544171],
            [31.80767141466256, 3.386871173782724],
            [31.807235965311737, 3.387844164528138],
            [31.80599918099825, 3.388514033989966],
            [31.804997791221773, 3.387908532012423],
            [31.80406242851702, 3.387940942181153],
            [31.8008208048137, 3.389078291631991],
            [31.799150754055507, 3.388941931797433],
            [31.796544140443338, 3.389811495445255],
            [31.79413978161909, 3.38920423128071],
            [31.79300353675218, 3.389605646147035],
            [31.790235980973737, 3.38857305952156],
            [31.78783887784205, 3.388607103536823],
            [31.784241905765125, 3.38971426781402],
            [31.781630266977263, 3.391445645087996],
            [31.775611623743934, 3.393995602141452],
            [31.777222553678328, 3.389366695295501],
            [31.77653297632352, 3.388287204170674],
            [31.774529724256762, 3.386619854328225],
            [31.765555063189964, 3.382052115445236],
            [31.764881902546986, 3.38222640610973],
            [31.76173305864281, 3.380328420892712],
            [31.762542692242075, 3.374212768624441],
            [31.761159946067927, 3.364361681657401],
            [31.761964815002955, 3.359879442169947],
            [31.763084879414944, 3.358946244594809],
            [31.76773383169018, 3.35972613553751],
            [31.76918466387463, 3.361538810906144],
            [31.771188817849904, 3.362446767340308],
            [31.772349586724076, 3.363820966841494],
            [31.774136275637066, 3.364334349990619],
            [31.77574801046196, 3.365314822614761],
            [31.782346707552335, 3.364081822140525],
            [31.783224358889957, 3.364225440312442],
            [31.782900141632567, 3.362061636442783],
            [31.78556991399573, 3.362199627686508],
            [31.787358735509205, 3.356166383630097],
            [31.789093252067104, 3.353167613224957],
            [31.790102078995783, 3.352710984857319],
            [31.790317474339687, 3.350996624968675],
            [31.792675181854598, 3.349479762805156],
            [31.794967215335706, 3.349232588484329],
            [31.795651250085218, 3.348775506302629],
            [31.79856863586992, 3.349565990061327],
            [31.80045414485405, 3.350176361195982],
            [31.80208948470967, 3.351644841964869],
            [31.804410803269054, 3.352094374623375],
            [31.800873206239153, 3.358187035298861],
            [31.800805280128927, 3.360291794510236],
            [31.80016966906482, 3.361444510191718],
            [31.798956806887336, 3.36265625879165],
            [31.798209715794798, 3.364361585703339],
            [31.796523216883738, 3.366341826504766],
            [31.796708482733, 3.367137890957311],
            [31.798153571089532, 3.36735429724652],
            [31.79896391345957, 3.366746394883102],
            [31.801871814831483, 3.367909821948972],
            [31.803070738749003, 3.368980517871043],
            [31.80554703376291, 3.369625103588674],
            [31.80806723842788, 3.369166304687689],
            [31.808603254174756, 3.369380807596094],
            [31.809333668044083, 3.370733196153044],
            [31.812081788771362, 3.371857112581778],
            [31.81321051384104, 3.374106547635705],
            [31.815718686471076, 3.37747097635474],
            [31.81573405215403, 3.378499307157252],
            [31.817070334766704, 3.37863780363231],
            [31.817341040280954, 3.379059150532754],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 758,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "ADJUMANI TOWN COUNCIL",
        Population: 35433,
        Key: "ADJUMANIADJUMANI TOWN COUNCIL",
        Dist2: "Adjumani",
        "Sub Country": "Adjumani Tc",
        id2_original: "AdjumaniAdjumani Tc",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.775611623743934, 3.393995602141452],
            [31.769361032809293, 3.396080634413082],
            [31.762229775790935, 3.399698933013457],
            [31.75709083564737, 3.401413007861358],
            [31.75648625688476, 3.402259201307672],
            [31.750968212419917, 3.405541478723003],
            [31.75083272671211, 3.411040739306588],
            [31.748244684870137, 3.41434346875994],
            [31.748339908086898, 3.415166089516264],
            [31.74528340021415, 3.420806654016726],
            [31.74449667545127, 3.421079784304861],
            [31.744432963338067, 3.422190349242682],
            [31.743839353005043, 3.422027739222028],
            [31.74290848008009, 3.420626129192034],
            [31.743616244726127, 3.419369127828077],
            [31.742655785787267, 3.417497094084134],
            [31.743234027742414, 3.417110798745913],
            [31.74337974256633, 3.416127222184586],
            [31.743239590110637, 3.412837061941652],
            [31.74364339361064, 3.410837802615996],
            [31.743065891867307, 3.410659644165108],
            [31.74436813641556, 3.40885509000168],
            [31.744755990327697, 3.406775171599976],
            [31.743617707183407, 3.405902803923217],
            [31.744184114732985, 3.402258766392643],
            [31.744409420291067, 3.389357183532208],
            [31.744700861617023, 3.387357771506682],
            [31.747214058524463, 3.379781178523814],
            [31.746354897210338, 3.374006466738559],
            [31.747700800779683, 3.372452090343466],
            [31.74736094025994, 3.371426615600087],
            [31.74509920156345, 3.36743696456362],
            [31.743360762062682, 3.363316560966719],
            [31.742047584119128, 3.361854523992823],
            [31.74136420873302, 3.362182213328215],
            [31.7410885714679, 3.3618313765817],
            [31.740372955546256, 3.358975491020818],
            [31.736992915830676, 3.354575499727853],
            [31.736123425687385, 3.352741651965912],
            [31.736313112146153, 3.35212855801899],
            [31.735363404244623, 3.350528261224595],
            [31.734594177765135, 3.349826302130984],
            [31.733693386724084, 3.349737511899128],
            [31.733832226741143, 3.349117050807278],
            [31.733018977422866, 3.348750911176543],
            [31.73192429940078, 3.346894866983087],
            [31.731585122498963, 3.345112821951277],
            [31.73189133572143, 3.344280831368406],
            [31.731477842992792, 3.343791082346666],
            [31.731914815886324, 3.342417079791983],
            [31.731632926346805, 3.338106143482082],
            [31.730777542448433, 3.33644982717372],
            [31.728599217715956, 3.334999824513441],
            [31.725906427820295, 3.334923964709682],
            [31.725311225672588, 3.33456139709552],
            [31.724547975684697, 3.334967419760047],
            [31.724167477178124, 3.334514683076327],
            [31.723285788811612, 3.334513533385921],
            [31.722357680002762, 3.333653065059521],
            [31.721475968280057, 3.333670003726859],
            [31.721214987028752, 3.332792316180096],
            [31.72019080429862, 3.332501544392595],
            [31.71999155168039, 3.330212946437413],
            [31.71904065620606, 3.32871026643854],
            [31.71937956091836, 3.325219411866753],
            [31.71885576675089, 3.324884071211326],
            [31.71885660757401, 3.324232845716227],
            [31.717321296023623, 3.323172599795941],
            [31.716893987205903, 3.321950993166047],
            [31.715345969884105, 3.321370104054445],
            [31.71301052891015, 3.321412272785565],
            [31.712844306446595, 3.320986950635842],
            [31.711581559923054, 3.320985296027446],
            [31.71027240014375, 3.31990725036717],
            [31.709200110833493, 3.319860619953328],
            [31.708573871892764, 3.318676357726313],
            [31.709731282864386, 3.317126363283073],
            [31.70973260967607, 3.316104141701572],
            [31.71144904943551, 3.314646068301388],
            [31.711950091971758, 3.314687834650635],
            [31.711886086109434, 3.313770447127523],
            [31.710844724896113, 3.310059871728435],
            [31.71070263657098, 3.30757714032174],
            [31.710122534204913, 3.306729397711877],
            [31.7092802145057, 3.306407025977367],
            [31.708149112493803, 3.304682369811154],
            [31.707713291240456, 3.304623386757259],
            [31.707830324653976, 3.304010207262432],
            [31.70727868091609, 3.303629802163102],
            [31.706497094516642, 3.301292270298227],
            [31.7067315377378, 3.299773846530586],
            [31.70769178916583, 3.298782083024277],
            [31.708012917116964, 3.297643454012484],
            [31.709175526639125, 3.297469732167141],
            [31.71060163000044, 3.295777618983612],
            [31.711997428695643, 3.295049273867699],
            [31.713539986955446, 3.293182065409153],
            [31.712701089837477, 3.290201919173664],
            [31.713663422662016, 3.287574586006088],
            [31.71352138284593, 3.285033441136212],
            [31.712738431007224, 3.283747343314151],
            [31.712276254081733, 3.281585468759022],
            [31.712887468699364, 3.280826891463636],
            [31.713296464461692, 3.279133446925073],
            [31.712951044268646, 3.276562831725401],
            [31.71437870261374, 3.273614821134765],
            [31.714817902430873, 3.271016011788051],
            [31.717615145732832, 3.267097031010565],
            [31.716086404460412, 3.261871524321394],
            [31.71396326682912, 3.256699081265401],
            [31.712891467100683, 3.255186840960413],
            [31.713335763958746, 3.254798903341705],
            [31.713236757038015, 3.253849090167766],
            [31.71286526593881, 3.253273047528332],
            [31.711219469693308, 3.252824870139603],
            [31.710578277396326, 3.250435445075537],
            [31.71109435413713, 3.249889319192791],
            [31.711310960410025, 3.248421900610382],
            [31.712742061997588, 3.248826631911367],
            [31.713587335357428, 3.248338483448419],
            [31.714004397991026, 3.246842541144231],
            [31.713906954138903, 3.244655260310228],
            [31.71559634472685, 3.244585472651337],
            [31.716026699731696, 3.243895341217787],
            [31.717158325461398, 3.243378771947543],
            [31.71770600942551, 3.24155070663944],
            [31.718249270983478, 3.241136380310397],
            [31.716375345774914, 3.239497636916387],
            [31.716577237643452, 3.238454420753747],
            [31.7160233750668, 3.23792012095183],
            [31.71646074591405, 3.237268506045851],
            [31.714940279922025, 3.236033374399366],
            [31.714330356183453, 3.233174904163862],
            [31.712432957098205, 3.2314531293519],
            [31.710714324551144, 3.228320521776563],
            [31.70965082076437, 3.22472241186201],
            [31.710172833572624, 3.223676468303052],
            [31.709593141736605, 3.220912683612754],
            [31.709782805737508, 3.219154622865695],
            [31.708535157198956, 3.217562191264554],
            [31.70674454264818, 3.21712033468162],
            [31.704685289606637, 3.215003563384957],
            [31.703582201556856, 3.214395123206728],
            [31.702834372049136, 3.212845192010397],
            [31.69969163758719, 3.211103812341432],
            [31.698444728362148, 3.208946211237791],
            [31.695431636965385, 3.205492415694629],
            [31.70058274299284, 3.200892375696681],
            [31.704677532654127, 3.198994217288084],
            [31.706726473934527, 3.196809035561737],
            [31.709863150158178, 3.195150287756495],
            [31.711301642185596, 3.193708165023582],
            [31.712872617751085, 3.190756632623959],
            [31.713526283155794, 3.19025426431601],
            [31.71886195434657, 3.188226312874013],
            [31.721757660190217, 3.187770495546892],
            [31.722279713422648, 3.188077437683264],
            [31.722628594824478, 3.187596559296937],
            [31.724436227059996, 3.186876839169844],
            [31.7281159824836, 3.186093807173248],
            [31.73275202956147, 3.186537112223629],
            [31.73573278070966, 3.187744088272397],
            [31.73703993365262, 3.186870578625898],
            [31.737976041959058, 3.186806098608993],
            [31.743612145713474, 3.188322616591221],
            [31.744809606275425, 3.188149061627764],
            [31.745354845923636, 3.187296482086382],
            [31.747511640733677, 3.185855162743997],
            [31.751651699197105, 3.186259920683445],
            [31.755075676411554, 3.185067621114995],
            [31.75757547404822, 3.185190301076067],
            [31.759389438508155, 3.186418876693703],
            [31.76046066600974, 3.186569732537782],
            [31.771771080664255, 3.185656089787972],
            [31.77280024814591, 3.185982533538588],
            [31.77202841565381, 3.187019591220971],
            [31.772193314000607, 3.188648623590549],
            [31.773287493457705, 3.190454428834325],
            [31.772492023595515, 3.191323783583733],
            [31.772631738571643, 3.194086583616288],
            [31.771077550722183, 3.198308504546131],
            [31.769909520765605, 3.198474771247662],
            [31.769599221106883, 3.198865637270803],
            [31.77025598839427, 3.201062159674463],
            [31.768394381783207, 3.20323967270547],
            [31.768805811979966, 3.204645437421177],
            [31.767859225724052, 3.205642352092847],
            [31.767882112102534, 3.206432841319078],
            [31.767190052702617, 3.207174558752226],
            [31.767425926940014, 3.209226852426965],
            [31.764959859245632, 3.211946562638742],
            [31.76345060512668, 3.211777053126737],
            [31.76347960184576, 3.214084595965006],
            [31.76310439082293, 3.215593199672622],
            [31.76246801798745, 3.216263118964841],
            [31.761117427907244, 3.216277439772276],
            [31.759864936551004, 3.215657457239994],
            [31.75958812608607, 3.215870921416576],
            [31.75978847554726, 3.217314329556745],
            [31.758374395237727, 3.216820855385029],
            [31.75641642095624, 3.217502622806484],
            [31.75531833921755, 3.219564461122755],
            [31.755529643633636, 3.220740628405626],
            [31.756485400790293, 3.222013921813502],
            [31.755526432156483, 3.223381073596285],
            [31.75558719599895, 3.225893316499917],
            [31.755171738654767, 3.226405928626615],
            [31.754556057613524, 3.225378923783519],
            [31.753960153881614, 3.225581302129338],
            [31.753128767577746, 3.226991367139658],
            [31.75333040881629, 3.227365767888791],
            [31.754564323910785, 3.227324527066865],
            [31.754158145265187, 3.228948917486845],
            [31.752221993756887, 3.229160331277944],
            [31.75001752804967, 3.231327688943522],
            [31.749792912397726, 3.232342964572439],
            [31.750589073064354, 3.233648137570032],
            [31.74907762525946, 3.23448008864719],
            [31.750522448612987, 3.23593572627057],
            [31.75036172922889, 3.236886941965861],
            [31.75176472971772, 3.237754573706841],
            [31.75163643232883, 3.238288917543237],
            [31.752497322899902, 3.238856556885689],
            [31.75279208978902, 3.241358395350268],
            [31.752120208347, 3.242790030731892],
            [31.752874261383017, 3.243742380812099],
            [31.751288008169492, 3.244841489262475],
            [31.750437252391436, 3.244680083126066],
            [31.7500212030575, 3.245663050716308],
            [31.749032101335818, 3.24555491995143],
            [31.748988289601108, 3.24658111061463],
            [31.74806453941801, 3.247897068975778],
            [31.747395997013903, 3.249137920728058],
            [31.748041757244085, 3.249342551751646],
            [31.749309906235737, 3.251722786497802],
            [31.748702809495395, 3.251902928891492],
            [31.74912540125956, 3.253793844948231],
            [31.748518468012556, 3.253612189877294],
            [31.74736352830628, 3.254949396586736],
            [31.745723588178087, 3.255743299450201],
            [31.745964603473876, 3.257326461131731],
            [31.7465103551618, 3.257634670184185],
            [31.746084599531226, 3.258303461225389],
            [31.746629355885833, 3.259642790855178],
            [31.74608316492173, 3.259461208588369],
            [31.745413120534444, 3.261414070946679],
            [31.745716257027077, 3.261658663564057],
            [31.746445453679172, 3.260990253228568],
            [31.7461992021036, 3.263857182791807],
            [31.747622201785614, 3.266572441397725],
            [31.747439261674614, 3.267368164668854],
            [31.746892393380797, 3.267729276102072],
            [31.7467735049462, 3.2690315943727],
            [31.747978808698882, 3.272678209446708],
            [31.747410608111995, 3.273907604763448],
            [31.747496979329956, 3.274785069946566],
            [31.74618265064448, 3.275136168986758],
            [31.74626824032813, 3.276637732779146],
            [31.74477849222726, 3.277160461548831],
            [31.74363792915877, 3.278660477040002],
            [31.74433787756353, 3.279357817659667],
            [31.744336228256692, 3.280678372463669],
            [31.74346074814709, 3.280243111991462],
            [31.743108358824063, 3.281825524711127],
            [31.742232117841414, 3.281996269974102],
            [31.742843542664808, 3.283317597955727],
            [31.74336926102359, 3.283236858968835],
            [31.744156728693238, 3.284115209219066],
            [31.745207125161706, 3.284559735944889],
            [31.745555885290955, 3.285880733188403],
            [31.74476627783432, 3.286937990340022],
            [31.7451159192109, 3.287553485227142],
            [31.744763753568378, 3.288955000900252],
            [31.74633895750394, 3.290277548330932],
            [31.74554850742753, 3.291778004190253],
            [31.746773961290362, 3.292575505551812],
            [31.74606949615636, 3.295478030346544],
            [31.74650688496988, 3.296093638339078],
            [31.746679666931605, 3.298029467472736],
            [31.745364468676975, 3.298823753184387],
            [31.74650070366242, 3.301023106310766],
            [31.745318350068594, 3.303532799153365],
            [31.745288004978303, 3.304554998731784],
            [31.74617093212161, 3.305889716792665],
            [31.747170870220547, 3.306481387592248],
            [31.74783943957413, 3.306336201414926],
            [31.748506910288096, 3.307067218848262],
            [31.75271793565895, 3.309248460416923],
            [31.753356496790463, 3.309862612409253],
            [31.753616615659094, 3.311002010321471],
            [31.75424103371477, 3.311309471900708],
            [31.755517486732884, 3.313078101668786],
            [31.7560406682493, 3.313005745825022],
            [31.75711317315523, 3.315197618575341],
            [31.76164650955843, 3.315305554373467],
            [31.765944414593662, 3.317793546811475],
            [31.76943971534673, 3.32116435692355],
            [31.77005979004801, 3.321208991881348],
            [31.771258400453508, 3.32346071351766],
            [31.77363202521695, 3.325123364275256],
            [31.775541536287164, 3.327251311269222],
            [31.776581933608202, 3.329349053959111],
            [31.77750295560775, 3.334271030285329],
            [31.7797762538253, 3.335693876428613],
            [31.77913929977983, 3.335283491162729],
            [31.780861784302843, 3.33420165514773],
            [31.781177996672728, 3.333010829461885],
            [31.785599574569765, 3.337029374758862],
            [31.786934365080754, 3.337542339709371],
            [31.786985142352187, 3.338775886593588],
            [31.792725814497263, 3.345222717531769],
            [31.794967215335706, 3.349232588484329],
            [31.792675181854598, 3.349479762805156],
            [31.790317474339687, 3.350996624968675],
            [31.790102078995783, 3.352710984857319],
            [31.789093252067104, 3.353167613224957],
            [31.787358735509205, 3.356166383630097],
            [31.78556991399573, 3.362199627686508],
            [31.782900141632567, 3.362061636442783],
            [31.783224358889957, 3.364225440312442],
            [31.782346707552335, 3.364081822140525],
            [31.77574801046196, 3.365314822614761],
            [31.774136275637066, 3.364334349990619],
            [31.772349586724076, 3.363820966841494],
            [31.771188817849904, 3.362446767340308],
            [31.76918466387463, 3.361538810906144],
            [31.76773383169018, 3.35972613553751],
            [31.763084879414944, 3.358946244594809],
            [31.761964815002955, 3.359879442169947],
            [31.761159946067927, 3.364361681657401],
            [31.762542692242075, 3.374212768624441],
            [31.76173305864281, 3.380328420892712],
            [31.764881902546986, 3.38222640610973],
            [31.765555063189964, 3.382052115445236],
            [31.774529724256762, 3.386619854328225],
            [31.77653297632352, 3.388287204170674],
            [31.777222553678328, 3.389366695295501],
            [31.775611623743934, 3.393995602141452],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 759,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "ADROPI",
        Population: 11714,
        Key: "ADJUMANIADROPI",
        Dist2: "Adjumani",
        "Sub Country": "Adropi",
        id2_original: "AdjumaniAdropi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.06200775952222, 3.579607499141924],
            [32.062378829311584, 3.580030102830692],
            [32.0618016006561, 3.580490846064989],
            [32.06109447650882, 3.580559134486459],
            [32.06034855322614, 3.579838051999966],
            [32.05994335374419, 3.580600465085682],
            [32.058716719495095, 3.579995481181442],
            [32.05753091637062, 3.580844564737666],
            [32.057690797626556, 3.581754558041258],
            [32.059415139865564, 3.583880566090433],
            [32.06106149486319, 3.584515470046096],
            [32.05913158844275, 3.586584968937503],
            [32.05764263355428, 3.58746006888682],
            [32.05710108508357, 3.587323458999986],
            [32.05658997782288, 3.585958179358139],
            [32.056061339939426, 3.586046922305455],
            [32.054634181955954, 3.587475844668236],
            [32.05414720613876, 3.587311892542314],
            [32.05391934667033, 3.586665423165945],
            [32.053309949344516, 3.58666479019758],
            [32.0531740378353, 3.58714081994478],
            [32.0538924681787, 3.58811091557597],
            [32.05351069136946, 3.588986334133535],
            [32.053958716235954, 3.589530995595705],
            [32.05387272770032, 3.590840377076067],
            [32.05276380060121, 3.590992278019775],
            [32.05044338754364, 3.590049532091721],
            [32.04971081053113, 3.588599736600579],
            [32.048017625459416, 3.588997610983245],
            [32.04683096534213, 3.586716910569106],
            [32.04603842488611, 3.587703077394269],
            [32.0449126714434, 3.587761418003046],
            [32.04618910469862, 3.589310309059028],
            [32.04633073937452, 3.591478733297113],
            [32.04582843380698, 3.592224734287635],
            [32.04466746191356, 3.592350155391592],
            [32.04372150986823, 3.591326990227354],
            [32.04361964450827, 3.58918303705153],
            [32.042076098999985, 3.588897844299765],
            [32.04055215383287, 3.586185663497221],
            [32.03796042261002, 3.58481702096186],
            [32.03672417998064, 3.585682922138314],
            [32.0337244429389, 3.584052412131185],
            [32.029533017909245, 3.583042842067542],
            [32.019862564942486, 3.582266697508765],
            [32.01500486485647, 3.580634138149811],
            [32.00519296226678, 3.578565412087355],
            [31.997362136831, 3.575130599276012],
            [31.99281154468952, 3.574818042496196],
            [31.985305764757822, 3.575298200817702],
            [31.982168774123853, 3.574091646016496],
            [31.978272627124692, 3.571979676165053],
            [31.970726728432417, 3.569121859769259],
            [31.96469761353783, 3.56445660060687],
            [31.955864496417085, 3.553836173816665],
            [31.950985160407484, 3.5458434282002],
            [31.947436793475646, 3.536640100489219],
            [31.94743089962905, 3.533636985230819],
            [31.94784214926443, 3.531927852708839],
            [31.94943992516812, 3.528790875961191],
            [31.949927855894472, 3.526430549747019],
            [31.949862905902798, 3.525146012515785],
            [31.94938252371979, 3.524295189384612],
            [31.940010828856952, 3.518441131948955],
            [31.936524970295842, 3.516763731706048],
            [31.93258571134959, 3.515773256126897],
            [31.926589024738455, 3.51233343642738],
            [31.926687717248797, 3.511084010588023],
            [31.928822465605144, 3.506864645543747],
            [31.93024425525647, 3.506577330160487],
            [31.931871662988115, 3.504916658642287],
            [31.93259886178703, 3.503575792886937],
            [31.93215914364197, 3.502266875097619],
            [31.932589650462127, 3.500330537627983],
            [31.93366136125732, 3.499578474728833],
            [31.933238660797006, 3.494628267413129],
            [31.93067160360006, 3.491935309001384],
            [31.929924146893203, 3.49010521389604],
            [31.93014439852948, 3.484725293421254],
            [31.931112667421406, 3.480745066009371],
            [31.938609267469204, 3.480000309546853],
            [31.940560109127304, 3.480133261625966],
            [31.94860954228241, 3.47747963769382],
            [31.958374488135583, 3.472391950214807],
            [31.959721083407732, 3.471327763911343],
            [31.959559486369603, 3.465102052083826],
            [31.95897328444275, 3.463450431914613],
            [31.95897763318703, 3.459470775682162],
            [31.960272467532523, 3.450433412299625],
            [31.961526725874922, 3.449208116723335],
            [31.963574553244353, 3.449848849407168],
            [31.967390151006935, 3.448197389190227],
            [31.97066194193415, 3.44796992428074],
            [31.972267390348684, 3.44729275872092],
            [31.978755923442485, 3.438873430915684],
            [31.98219514596564, 3.436322195095584],
            [31.98683429312952, 3.435133914230332],
            [31.99000087247235, 3.436141831915526],
            [31.995535134223033, 3.443039635545696],
            [32.010739569564365, 3.435041293952985],
            [32.01050949035888, 3.43488977741815],
            [32.014654534472086, 3.434516342424215],
            [32.024346612582676, 3.436544265549665],
            [32.0346249896382, 3.440903760475857],
            [32.04043962008061, 3.442823219363925],
            [32.051910751424266, 3.443852870139408],
            [32.051915395714296, 3.451369943867369],
            [32.05358570608559, 3.474384162571732],
            [32.05398834357236, 3.476845028183854],
            [32.05530755819464, 3.479252543306171],
            [32.0560740807451, 3.487494051226064],
            [32.05715296189289, 3.491717853138713],
            [32.058966097207865, 3.495228392537777],
            [32.06028035762136, 3.497086856389481],
            [32.06158491443313, 3.497576642761533],
            [32.06362234110824, 3.499740641948699],
            [32.06365955920879, 3.524481022979827],
            [32.06331680611382, 3.527664807621897],
            [32.05924175962584, 3.54744387054485],
            [32.05646231823786, 3.568020227394761],
            [32.05647996564161, 3.570299787291343],
            [32.058158958230145, 3.574218350801699],
            [32.06200775952222, 3.579607499141924],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 760,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "ARINYAPI",
        Population: 11668,
        Key: "ADJUMANIARINYAPI",
        Dist2: "Adjumani",
        "Sub Country": "Arinyapi",
        id2_original: "AdjumaniArinyapi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.708573871892764, 3.318676357726313],
            [31.709200110833493, 3.319860619953328],
            [31.71027240014375, 3.31990725036717],
            [31.711581559923054, 3.320985296027446],
            [31.712844306446595, 3.320986950635842],
            [31.71301052891015, 3.321412272785565],
            [31.715345969884105, 3.321370104054445],
            [31.716893987205903, 3.321950993166047],
            [31.717321296023623, 3.323172599795941],
            [31.71885660757401, 3.324232845716227],
            [31.71885576675089, 3.324884071211326],
            [31.71937956091836, 3.325219411866753],
            [31.71904065620606, 3.32871026643854],
            [31.71999155168039, 3.330212946437413],
            [31.72019080429862, 3.332501544392595],
            [31.721214987028752, 3.332792316180096],
            [31.721475968280057, 3.333670003726859],
            [31.722357680002762, 3.333653065059521],
            [31.723285788811612, 3.334513533385921],
            [31.724167477178124, 3.334514683076327],
            [31.724547975684697, 3.334967419760047],
            [31.725311225672588, 3.33456139709552],
            [31.725906427820295, 3.334923964709682],
            [31.728599217715956, 3.334999824513441],
            [31.730777542448433, 3.33644982717372],
            [31.731632926346805, 3.338106143482082],
            [31.731914815886324, 3.342417079791983],
            [31.731477842992792, 3.343791082346666],
            [31.73189133572143, 3.344280831368406],
            [31.731585122498963, 3.345112821951277],
            [31.73192429940078, 3.346894866983087],
            [31.733018977422866, 3.348750911176543],
            [31.733832226741143, 3.349117050807278],
            [31.733693386724084, 3.349737511899128],
            [31.734594177765135, 3.349826302130984],
            [31.735363404244623, 3.350528261224595],
            [31.736313112146153, 3.35212855801899],
            [31.736123425687385, 3.352741651965912],
            [31.736992915830676, 3.354575499727853],
            [31.740372955546256, 3.358975491020818],
            [31.7410885714679, 3.3618313765817],
            [31.74136420873302, 3.362182213328215],
            [31.742047584119128, 3.361854523992823],
            [31.743360762062682, 3.363316560966719],
            [31.74509920156345, 3.36743696456362],
            [31.74736094025994, 3.371426615600087],
            [31.747700800779683, 3.372452090343466],
            [31.746354897210338, 3.374006466738559],
            [31.747214058524463, 3.379781178523814],
            [31.744700861617023, 3.387357771506682],
            [31.744409420291067, 3.389357183532208],
            [31.744184114732985, 3.402258766392643],
            [31.743617707183407, 3.405902803923217],
            [31.744755990327697, 3.406775171599976],
            [31.74436813641556, 3.40885509000168],
            [31.743065891867307, 3.410659644165108],
            [31.74364339361064, 3.410837802615996],
            [31.743239590110637, 3.412837061941652],
            [31.74337974256633, 3.416127222184586],
            [31.743234027742414, 3.417110798745913],
            [31.742655785787267, 3.417497094084134],
            [31.743616244726127, 3.419369127828077],
            [31.74290848008009, 3.420626129192034],
            [31.743839353005043, 3.422027739222028],
            [31.744432963338067, 3.422190349242682],
            [31.744778994385502, 3.422628515588459],
            [31.744596889707733, 3.422978757268492],
            [31.744051831519208, 3.423065659481461],
            [31.74215200159281, 3.425684457449194],
            [31.741931846974555, 3.42734894905803],
            [31.74110973397935, 3.428158348352099],
            [31.741652301139595, 3.429977182102503],
            [31.739817160693452, 3.433114472714056],
            [31.74051400541891, 3.433641115298073],
            [31.73939339393289, 3.434895517204335],
            [31.739449527858348, 3.436414338204198],
            [31.738583576178986, 3.437398913458841],
            [31.738303604542576, 3.440333810570806],
            [31.737707356755905, 3.44066159249178],
            [31.736923289209614, 3.440156734542283],
            [31.73636265872563, 3.441024886141189],
            [31.735730455869707, 3.441067854005646],
            [31.73493020876685, 3.441811556073354],
            [31.731020520563114, 3.442229829217633],
            [31.73020443975506, 3.443951925126068],
            [31.729134829220975, 3.44508224538885],
            [31.729170345912348, 3.445695629974004],
            [31.726692561491724, 3.447132211776229],
            [31.723431441651762, 3.451567207586478],
            [31.72030892557196, 3.459600574342549],
            [31.71599563778579, 3.468298219592903],
            [31.710054451787826, 3.477110405079753],
            [31.702951895044475, 3.484927890652758],
            [31.699044803870247, 3.487654064087092],
            [31.69763910124904, 3.485209998626043],
            [31.695219253672647, 3.477844247876431],
            [31.687166928840657, 3.468390387396039],
            [31.682390319675363, 3.459438550856413],
            [31.681010945776787, 3.457618649846061],
            [31.67834456904542, 3.455733636379705],
            [31.665840302361463, 3.450777713984603],
            [31.66244798806584, 3.448321843333112],
            [31.65841705155327, 3.442901689054848],
            [31.652581467008567, 3.433338426990551],
            [31.651245725181678, 3.426580703552561],
            [31.652316073232576, 3.420401021454627],
            [31.65358425725851, 3.416248415551795],
            [31.657441959956756, 3.408526282994383],
            [31.65646911145353, 3.408387782732809],
            [31.65753932924875, 3.408011703725586],
            [31.65883773888902, 3.402207626662421],
            [31.658514474744152, 3.397412789412918],
            [31.65628808475411, 3.392538791846853],
            [31.65046158217689, 3.385288079923438],
            [31.637053304889918, 3.372517829994453],
            [31.63326096810334, 3.364046363960185],
            [31.629029920183115, 3.359297068927131],
            [31.625759808207178, 3.356946292038101],
            [31.622031964169786, 3.355308909809882],
            [31.61926713028664, 3.354565441487602],
            [31.613428124957288, 3.35388559173341],
            [31.609743001201565, 3.352917623954129],
            [31.60583015991118, 3.348475080014762],
            [31.60485699340431, 3.346082141726594],
            [31.604373811172554, 3.342769416652095],
            [31.604798752031197, 3.33783394850602],
            [31.606084055251483, 3.331387130055379],
            [31.606396149744146, 3.325325892852334],
            [31.60915420314353, 3.326172849165],
            [31.611696632128616, 3.325327919626586],
            [31.613253792503375, 3.325654078667433],
            [31.614136186047403, 3.325175992258291],
            [31.614256187494636, 3.324552108700585],
            [31.615674593192256, 3.324255632602775],
            [31.616984060195403, 3.324999068275058],
            [31.61867541090728, 3.325336163037571],
            [31.620012249577155, 3.323836664638855],
            [31.6207034528826, 3.323665740036021],
            [31.62049107228483, 3.32225454754583],
            [31.62146659417435, 3.323314145166044],
            [31.62163516034246, 3.322256109781099],
            [31.622301362635262, 3.32290830243991],
            [31.623492452345232, 3.323000420448083],
            [31.62354151383448, 3.322068873802087],
            [31.624234528143546, 3.320848789481024],
            [31.62502135800932, 3.320641931097596],
            [31.625296488624645, 3.320000173091807],
            [31.62689327368657, 3.319767253295728],
            [31.627774918035655, 3.319795562827743],
            [31.62734397193935, 3.321061206228757],
            [31.627629290348327, 3.321396238785143],
            [31.628129925947757, 3.321324558845423],
            [31.62856081095862, 3.320086100708952],
            [31.629657459884406, 3.319816309579016],
            [31.631467499604884, 3.320298142755276],
            [31.632013824417992, 3.321429546172046],
            [31.632730089821564, 3.32061648957879],
            [31.633349415327896, 3.320780162232277],
            [31.635014890068007, 3.322392399106008],
            [31.63576622031042, 3.321850821742755],
            [31.63605409891792, 3.320702543592096],
            [31.638651156252102, 3.320968392117572],
            [31.640797890829283, 3.319659939472659],
            [31.647097154282633, 3.321884559581121],
            [31.650452730178095, 3.324611513857549],
            [31.65446881753901, 3.324110553960482],
            [31.65513714434748, 3.323387927071095],
            [31.656351983716874, 3.32363378062149],
            [31.65733000471953, 3.3231286357369],
            [31.65781251321483, 3.319212964028373],
            [31.661362840270627, 3.319335390015281],
            [31.662957375951088, 3.320649026634724],
            [31.66367420370005, 3.319438003702257],
            [31.663628638453876, 3.318171735835871],
            [31.664070710184962, 3.317322120791199],
            [31.664833101383465, 3.317323180820666],
            [31.665069920648545, 3.318372656066828],
            [31.666142318654952, 3.31834696966069],
            [31.668745810621477, 3.314217129084089],
            [31.671103487593683, 3.315179046496179],
            [31.671747250869018, 3.314917631149828],
            [31.67186819105572, 3.313886717166047],
            [31.6756808998363, 3.313846592847934],
            [31.67694486447537, 3.313133713993103],
            [31.679539922159712, 3.314692956346395],
            [31.68001668323382, 3.314639273153318],
            [31.680328438163272, 3.313283011065135],
            [31.68068607185092, 3.313111652372526],
            [31.6821508530751, 3.313611046629267],
            [31.682602176555328, 3.314543217358502],
            [31.683960268466464, 3.31470789006673],
            [31.690956419764426, 3.313251945438087],
            [31.69334084676914, 3.312278275190956],
            [31.694009048711774, 3.311627955243372],
            [31.69824920554897, 3.312709859953747],
            [31.699367105919453, 3.314031873538734],
            [31.699113351614624, 3.3164555436333],
            [31.701424026934536, 3.317010307963079],
            [31.702445988130975, 3.31880253064643],
            [31.703017437924267, 3.319020324201157],
            [31.703230006269933, 3.320314026109887],
            [31.70389216794059, 3.320956321098929],
            [31.70639348642501, 3.320599565932848],
            [31.70653074271222, 3.319750028307811],
            [31.708573871892764, 3.318676357726313],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 761,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "CIFORO",
        Population: 14471,
        Key: "ADJUMANICIFORO",
        Dist2: "Adjumani",
        "Sub Country": "Ciforo",
        id2_original: "AdjumaniCiforo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.926589024738455, 3.51233343642738],
            [31.920690601242953, 3.509662890011362],
            [31.917466593502347, 3.508836011633842],
            [31.91471219444952, 3.50866094077411],
            [31.89832577023037, 3.514249817037591],
            [31.890014681189204, 3.515470093846401],
            [31.881431420583255, 3.515631659363921],
            [31.87725119215529, 3.516305014445039],
            [31.87074298505843, 3.5184951274237],
            [31.863469522035654, 3.522601841677881],
            [31.861677284229156, 3.524227788036746],
            [31.8578692170436, 3.529035168648156],
            [31.854657906989537, 3.535539862119176],
            [31.852916503048323, 3.531733564681122],
            [31.852409345679934, 3.525509824083108],
            [31.849312419907612, 3.506465808679374],
            [31.848931362648944, 3.499473387600928],
            [31.849192276526573, 3.49658828535005],
            [31.84858789449499, 3.490329503494058],
            [31.848222135545594, 3.490451514100584],
            [31.8473524091454, 3.48957542677207],
            [31.84659054435966, 3.477279836443822],
            [31.84698773266591, 3.470059652543903],
            [31.847962080457357, 3.467328699194379],
            [31.854381949924147, 3.458164300132364],
            [31.858471000249082, 3.449192161953464],
            [31.86198012517605, 3.43787743055194],
            [31.86432185435698, 3.428317657447214],
            [31.86480615588959, 3.424453697804207],
            [31.870466044337785, 3.403342761422115],
            [31.87225037068158, 3.391406969499837],
            [31.874713367934326, 3.385153930038504],
            [31.87762891037608, 3.38263199824059],
            [31.88596657697324, 3.383043415488634],
            [31.893218060915963, 3.384429217596607],
            [31.899950794731552, 3.383527588531718],
            [31.901143231914435, 3.382778273432409],
            [31.903019886204813, 3.382501052076876],
            [31.904101459603506, 3.381712426205668],
            [31.908674516813633, 3.370846589805521],
            [31.911033185525902, 3.357842795572193],
            [31.914174958790483, 3.350387892762426],
            [31.914764879742624, 3.346123013545715],
            [31.917939783773186, 3.33806282757311],
            [31.92272387051492, 3.329126647755496],
            [31.92453371080941, 3.326804260345198],
            [31.925577590000497, 3.323436720410748],
            [31.925583079605193, 3.318362591178427],
            [31.923837763500924, 3.316213935593261],
            [31.923454888950427, 3.311139383654267],
            [31.9254151790887, 3.293967521203978],
            [31.92755990143962, 3.285773153825768],
            [31.92854056079428, 3.276601721692011],
            [31.931264800708046, 3.271140179112344],
            [31.93516472332634, 3.255531559375434],
            [31.935367906972232, 3.24694473805812],
            [31.93843630404777, 3.238749010159225],
            [31.94876625248543, 3.233540891644163],
            [31.958146825398188, 3.226236112989854],
            [31.962631553961376, 3.224309688582533],
            [31.97142726343709, 3.219520327490285],
            [31.98071843960606, 3.215136385510065],
            [31.98594288588995, 3.211846358711344],
            [31.99507145711102, 3.207932116830295],
            [31.997232052693015, 3.205849480800222],
            [31.99906086810126, 3.207147122326574],
            [32.00139821889355, 3.210319093830317],
            [32.00050427570989, 3.213245217994238],
            [32.000829074177275, 3.214490606489276],
            [32.00261003722867, 3.215759268936251],
            [32.00408836145405, 3.215345697143465],
            [32.00651795934455, 3.21580928819421],
            [32.006454984748196, 3.216839728848153],
            [32.0051912644509, 3.218024646730408],
            [32.00648824576989, 3.220278694372861],
            [32.00615604069297, 3.223202380892348],
            [32.00919207596041, 3.224722532045652],
            [32.00979229250402, 3.228465490533368],
            [32.01156535038089, 3.229726565821894],
            [32.01339391156589, 3.231733244144135],
            [32.01325637051273, 3.23204574094347],
            [32.011243367233575, 3.232227672542067],
            [32.00857820592279, 3.235047928334862],
            [32.0081810203115, 3.238918636253382],
            [32.00831611794708, 3.241116377232041],
            [32.0093126577193, 3.24386284112461],
            [32.00921634843938, 3.246808973866591],
            [32.00968964201649, 3.247416340788882],
            [32.00976268672721, 3.248859473552892],
            [32.00842214430343, 3.249242967666186],
            [32.00864351074902, 3.251284848874328],
            [32.00961996958138, 3.253412990252479],
            [32.01048301251586, 3.253620432087604],
            [32.01187524130613, 3.253030397282999],
            [32.01225788858286, 3.253298006456102],
            [32.01218281996785, 3.253928604605671],
            [32.011408263783785, 3.254678546577248],
            [32.01231923633024, 3.255831442479781],
            [32.01130229042803, 3.257028614354409],
            [32.0114012757892, 3.259144233265753],
            [32.01099856553889, 3.25993471667504],
            [32.00900836509489, 3.261416555249823],
            [32.00786730885137, 3.263534233984128],
            [32.0062125357412, 3.263633732351648],
            [32.005354841375905, 3.264374628557851],
            [32.00485343322537, 3.265722370684732],
            [32.00486943491549, 3.271067045342245],
            [32.005537338617465, 3.273291088930846],
            [32.004523613175515, 3.274450587595767],
            [32.00492891416712, 3.275460413591176],
            [32.0067034731288, 3.27722592145797],
            [32.00806202946897, 3.280188217993602],
            [32.00655297118275, 3.285370173702598],
            [32.00669447021303, 3.288420408676306],
            [32.00742155762083, 3.288524712508225],
            [32.00853095004727, 3.287515323918423],
            [32.00958731941407, 3.28714009892307],
            [32.01116163671243, 3.28745239824806],
            [32.01246611806571, 3.288495217363722],
            [32.013438186831294, 3.289854189455858],
            [32.01367755461684, 3.290993770846875],
            [32.01229066541265, 3.292223802796596],
            [32.01188868549266, 3.293403025024518],
            [32.01433817208352, 3.29464263035507],
            [32.017180647356696, 3.298028962558831],
            [32.01753414789574, 3.299565703975398],
            [32.017039057596556, 3.302263963075779],
            [32.01731834561501, 3.303570459420825],
            [32.01793119516647, 3.304171063950115],
            [32.019419549082016, 3.303819979619977],
            [32.02111337105927, 3.304920725202841],
            [32.021278951227366, 3.305404248065442],
            [32.02068262528725, 3.306238026525909],
            [32.02048073880864, 3.307739691418393],
            [32.02399331057133, 3.311028863675609],
            [32.0268549756556, 3.312429982132505],
            [32.02702050372143, 3.312971048092603],
            [32.02608845939333, 3.313293422175332],
            [32.02594093895568, 3.313697404375335],
            [32.02672677977635, 3.314702797069062],
            [32.03218058212193, 3.317959345371112],
            [32.031284868358874, 3.321820617318678],
            [32.031412201855474, 3.323965303110509],
            [32.03251590884445, 3.326412729321346],
            [32.032845409992376, 3.329094553101287],
            [32.03255826890169, 3.329945905868613],
            [32.03154553609813, 3.329873710891238],
            [32.030654402844704, 3.332775135362739],
            [32.0328125226698, 3.333450519362098],
            [32.03465374381213, 3.335692235296843],
            [32.03769502703744, 3.335463578979226],
            [32.0397209319207, 3.336679726216235],
            [32.04151308887883, 3.336842603436455],
            [32.04198732389036, 3.3379191221596],
            [32.043632737453564, 3.339320536017301],
            [32.04362852255825, 3.340228206364853],
            [32.04137304601759, 3.345427887482549],
            [32.040694223293364, 3.348632367431073],
            [32.03852075395503, 3.351904422607093],
            [32.0384206124621, 3.354039226605896],
            [32.03678079091152, 3.355304763120523],
            [32.036443239960384, 3.356580610899785],
            [32.034974920272276, 3.356462651903366],
            [32.03346402852455, 3.358114051447071],
            [32.031748363112875, 3.359202881886073],
            [32.03086341296357, 3.361388508713284],
            [32.02836565809584, 3.364224715724552],
            [32.02834334933409, 3.365226992434164],
            [32.02938998904802, 3.366528507002936],
            [32.02764200404903, 3.369255102119793],
            [32.02748570437612, 3.370727887326777],
            [32.02967922321331, 3.375137201911307],
            [32.03123562990153, 3.376335652507879],
            [32.03194406109752, 3.377999350518712],
            [32.03114576783039, 3.380329035168069],
            [32.030958683791006, 3.384189970437123],
            [32.029958556147555, 3.385252102403231],
            [32.02794159129797, 3.38920128188932],
            [32.02995915262889, 3.391821281287682],
            [32.03000109766446, 3.392747470634731],
            [32.02844153249968, 3.393688501934058],
            [32.02782186832851, 3.394520085305466],
            [32.02730308137046, 3.397152914243678],
            [32.026515505902964, 3.398789025181746],
            [32.02519791543473, 3.399099905297895],
            [32.02194559998286, 3.403084852589034],
            [32.021776873914625, 3.40469041353684],
            [32.02143070722159, 3.405703183148603],
            [32.02042973246677, 3.40667910066355],
            [32.02016110924739, 3.408431690037637],
            [32.01885374340368, 3.408969848485499],
            [32.01732183916315, 3.411121057061605],
            [32.01760703809619, 3.411710060900528],
            [32.01867873002678, 3.411761416236084],
            [32.02074535105028, 3.410054833115884],
            [32.0226053101511, 3.40994683337661],
            [32.03940311426137, 3.410180822932406],
            [32.05734096221388, 3.409861228433425],
            [32.057583225269596, 3.413162077031309],
            [32.05317530895142, 3.426929412207925],
            [32.051910751424266, 3.443852870139408],
            [32.04043962008061, 3.442823219363925],
            [32.0346249896382, 3.440903760475857],
            [32.024346612582676, 3.436544265549665],
            [32.014654534472086, 3.434516342424215],
            [32.01050949035888, 3.43488977741815],
            [32.010739569564365, 3.435041293952985],
            [31.995535134223033, 3.443039635545696],
            [31.99000087247235, 3.436141831915526],
            [31.98683429312952, 3.435133914230332],
            [31.98219514596564, 3.436322195095584],
            [31.978755923442485, 3.438873430915684],
            [31.972267390348684, 3.44729275872092],
            [31.97066194193415, 3.44796992428074],
            [31.967390151006935, 3.448197389190227],
            [31.963574553244353, 3.449848849407168],
            [31.961526725874922, 3.449208116723335],
            [31.960272467532523, 3.450433412299625],
            [31.95897763318703, 3.459470775682162],
            [31.95897328444275, 3.463450431914613],
            [31.959559486369603, 3.465102052083826],
            [31.959721083407732, 3.471327763911343],
            [31.958374488135583, 3.472391950214807],
            [31.94860954228241, 3.47747963769382],
            [31.940560109127304, 3.480133261625966],
            [31.938609267469204, 3.480000309546853],
            [31.931112667421406, 3.480745066009371],
            [31.93014439852948, 3.484725293421254],
            [31.929924146893203, 3.49010521389604],
            [31.93067160360006, 3.491935309001384],
            [31.933238660797006, 3.494628267413129],
            [31.93366136125732, 3.499578474728833],
            [31.932589650462127, 3.500330537627983],
            [31.93215914364197, 3.502266875097619],
            [31.93259886178703, 3.503575792886937],
            [31.931871662988115, 3.504916658642287],
            [31.93024425525647, 3.506577330160487],
            [31.928822465605144, 3.506864645543747],
            [31.926687717248797, 3.511084010588023],
            [31.926589024738455, 3.51233343642738],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 762,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "DZAIPI",
        Population: 42888,
        Key: "ADJUMANIDZAIPI",
        Dist2: "Adjumani",
        "Sub Country": "Dzaipi",
        id2_original: "AdjumaniDzaipi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.817524660416595, 2.950712748776555],
            [31.815749075578825, 2.955398075439251],
            [31.813181698581644, 2.958037788367925],
            [31.813367744168577, 2.964114401162405],
            [31.810206473869062, 2.969503169070061],
            [31.810338982560012, 2.972785123797168],
            [31.81139265877758, 2.975278691923751],
            [31.811989334162327, 2.988304397250882],
            [31.8118311291627, 3.009044816407982],
            [31.8131808954878, 3.01587540462626],
            [31.812833435220714, 3.023581515092887],
            [31.813099116457575, 3.028764693479983],
            [31.814313664772847, 3.035043385309454],
            [31.815581701475093, 3.054618558047059],
            [31.818147325859137, 3.066497731468544],
            [31.820446276367957, 3.074143471638715],
            [31.820849375588775, 3.07782531331867],
            [31.82030236086957, 3.081506098149846],
            [31.821110990152338, 3.082827597119238],
            [31.821678509816223, 3.085804098632722],
            [31.82120209998338, 3.086391505483269],
            [31.822660499575814, 3.089287593542628],
            [31.822928202920373, 3.091567282348807],
            [31.825398510662897, 3.099385091721916],
            [31.827457716093726, 3.113579323933867],
            [31.828445948246216, 3.116905437208624],
            [31.82867655925439, 3.119340921941086],
            [31.828392949441096, 3.121032511882318],
            [31.827140382626364, 3.123769170729879],
            [31.82721077281539, 3.125266129692156],
            [31.82877177977619, 3.129416974550665],
            [31.8341774467956, 3.131998334661144],
            [31.844554651108773, 3.143741872512808],
            [31.851237991058493, 3.149472218691451],
            [31.863464972967055, 3.162076197374176],
            [31.8711036236107, 3.172753114098882],
            [31.8721714545822, 3.175889602269839],
            [31.871848774342244, 3.17728814011691],
            [31.870969999212193, 3.177918864198293],
            [31.871014056186972, 3.179633664871952],
            [31.86868245371421, 3.184464748336455],
            [31.86878949426852, 3.185883685917583],
            [31.868082936059913, 3.186537745453631],
            [31.86500409247594, 3.186400447545584],
            [31.85346816475251, 3.192253604450566],
            [31.853280516571125, 3.193004504953397],
            [31.850823856932706, 3.193764462005965],
            [31.84824703954023, 3.195317346949123],
            [31.846802871956843, 3.19794788771333],
            [31.84690222742392, 3.199630418075063],
            [31.84825254980616, 3.201965621311731],
            [31.848758278853264, 3.204390323745843],
            [31.852303419934888, 3.211779206593893],
            [31.854441380666692, 3.213071854705097],
            [31.857733016276846, 3.216976193940746],
            [31.85898087591949, 3.217850713826032],
            [31.85930556479242, 3.218833336090666],
            [31.860065420945183, 3.219107038849534],
            [31.861609970769955, 3.225047149814584],
            [31.863640674453478, 3.226641694439756],
            [31.86439914270909, 3.228170502612427],
            [31.86408393016411, 3.229242645949709],
            [31.86623343873889, 3.233258488499641],
            [31.860961706935058, 3.237687833175005],
            [31.859842609110306, 3.237973673727745],
            [31.854631053650735, 3.244232354844179],
            [31.85232451058114, 3.247133258099006],
            [31.84924587091474, 3.254083419982109],
            [31.84755523166856, 3.254563081307989],
            [31.846405830974323, 3.254163237542488],
            [31.84422002866544, 3.255924392699258],
            [31.839091855728853, 3.257185522535228],
            [31.83612026200667, 3.254238955518742],
            [31.834686798748233, 3.253742285849726],
            [31.83396371243666, 3.252722316867759],
            [31.833239121447058, 3.25301265454713],
            [31.83118317151081, 3.252194960094628],
            [31.830719076682172, 3.252689424230516],
            [31.82915508731465, 3.252338185506848],
            [31.828836750429094, 3.252046635066788],
            [31.829372318814986, 3.250823476750913],
            [31.82815187934808, 3.250036051695916],
            [31.82829307744272, 3.249506327572814],
            [31.827679214591644, 3.248463496631342],
            [31.827187855894174, 3.247862382436437],
            [31.825782298800032, 3.247595796946932],
            [31.823991378822043, 3.246251320296545],
            [31.823832831564296, 3.246586731321045],
            [31.82306024358904, 3.246038276865129],
            [31.822902678189877, 3.245525866600228],
            [31.823500310280433, 3.245402925730847],
            [31.823203099973718, 3.244077857244447],
            [31.822271903655274, 3.243917801681177],
            [31.822536258978754, 3.243264583434574],
            [31.82172850645168, 3.242733749911158],
            [31.820514134206203, 3.244304327316303],
            [31.817014696711272, 3.246340283001303],
            [31.815753599494602, 3.246528674902056],
            [31.814879935778503, 3.2460110065134],
            [31.813433844902132, 3.246605423062107],
            [31.81297361193093, 3.245695242226817],
            [31.812362130513648, 3.246384449548073],
            [31.80050984219832, 3.248176644681555],
            [31.797430527897127, 3.249192101616488],
            [31.79013410752893, 3.249373150301863],
            [31.77805096655861, 3.248466422227362],
            [31.764280961062916, 3.248970490993007],
            [31.75910552416597, 3.248358860379454],
            [31.74806453941801, 3.247897068975778],
            [31.748988289601108, 3.24658111061463],
            [31.749032101335818, 3.24555491995143],
            [31.7500212030575, 3.245663050716308],
            [31.750437252391436, 3.244680083126066],
            [31.751288008169492, 3.244841489262475],
            [31.752874261383017, 3.243742380812099],
            [31.752120208347, 3.242790030731892],
            [31.75279208978902, 3.241358395350268],
            [31.752497322899902, 3.238856556885689],
            [31.75163643232883, 3.238288917543237],
            [31.75176472971772, 3.237754573706841],
            [31.75036172922889, 3.236886941965861],
            [31.750522448612987, 3.23593572627057],
            [31.74907762525946, 3.23448008864719],
            [31.750589073064354, 3.233648137570032],
            [31.749792912397726, 3.232342964572439],
            [31.75001752804967, 3.231327688943522],
            [31.752221993756887, 3.229160331277944],
            [31.754158145265187, 3.228948917486845],
            [31.754564323910785, 3.227324527066865],
            [31.75333040881629, 3.227365767888791],
            [31.753128767577746, 3.226991367139658],
            [31.753960153881614, 3.225581302129338],
            [31.754556057613524, 3.225378923783519],
            [31.755171738654767, 3.226405928626615],
            [31.75558719599895, 3.225893316499917],
            [31.755526432156483, 3.223381073596285],
            [31.756485400790293, 3.222013921813502],
            [31.755529643633636, 3.220740628405626],
            [31.75531833921755, 3.219564461122755],
            [31.75641642095624, 3.217502622806484],
            [31.758374395237727, 3.216820855385029],
            [31.75978847554726, 3.217314329556745],
            [31.75958812608607, 3.215870921416576],
            [31.759864936551004, 3.215657457239994],
            [31.761117427907244, 3.216277439772276],
            [31.76246801798745, 3.216263118964841],
            [31.76310439082293, 3.215593199672622],
            [31.76347960184576, 3.214084595965006],
            [31.76345060512668, 3.211777053126737],
            [31.764959859245632, 3.211946562638742],
            [31.767425926940014, 3.209226852426965],
            [31.767190052702617, 3.207174558752226],
            [31.767882112102534, 3.206432841319078],
            [31.767859225724052, 3.205642352092847],
            [31.768805811979966, 3.204645437421177],
            [31.768394381783207, 3.20323967270547],
            [31.77025598839427, 3.201062159674463],
            [31.769599221106883, 3.198865637270803],
            [31.769909520765605, 3.198474771247662],
            [31.771077550722183, 3.198308504546131],
            [31.772631738571643, 3.194086583616288],
            [31.772492023595515, 3.191323783583733],
            [31.773287493457705, 3.190454428834325],
            [31.772193314000607, 3.188648623590549],
            [31.77202841565381, 3.187019591220971],
            [31.77280024814591, 3.185982533538588],
            [31.771771080664255, 3.185656089787972],
            [31.76046066600974, 3.186569732537782],
            [31.759389438508155, 3.186418876693703],
            [31.75757547404822, 3.185190301076067],
            [31.755075676411554, 3.185067621114995],
            [31.751651699197105, 3.186259920683445],
            [31.747511640733677, 3.185855162743997],
            [31.745354845923636, 3.187296482086382],
            [31.744809606275425, 3.188149061627764],
            [31.743612145713474, 3.188322616591221],
            [31.737976041959058, 3.186806098608993],
            [31.73703993365262, 3.186870578625898],
            [31.73573278070966, 3.187744088272397],
            [31.73275202956147, 3.186537112223629],
            [31.7281159824836, 3.186093807173248],
            [31.724436227059996, 3.186876839169844],
            [31.722628594824478, 3.187596559296937],
            [31.722279713422648, 3.188077437683264],
            [31.721757660190217, 3.187770495546892],
            [31.71886195434657, 3.188226312874013],
            [31.713526283155794, 3.19025426431601],
            [31.712872617751085, 3.190756632623959],
            [31.711301642185596, 3.193708165023582],
            [31.709863150158178, 3.195150287756495],
            [31.706726473934527, 3.196809035561737],
            [31.704677532654127, 3.198994217288084],
            [31.70058274299284, 3.200892375696681],
            [31.695431636965385, 3.205492415694629],
            [31.69218163287874, 3.204291269814305],
            [31.690873408245647, 3.201233514119669],
            [31.690041337425516, 3.200437028594708],
            [31.687064325065545, 3.199449398204897],
            [31.680899889753157, 3.199169331051225],
            [31.676445774876548, 3.196944782205929],
            [31.67463987908448, 3.194741412871152],
            [31.675559950666468, 3.194530234121345],
            [31.675561356529894, 3.194062202645908],
            [31.673522485363794, 3.192686606604576],
            [31.67356037720079, 3.190644476921694],
            [31.67045723059514, 3.184592217068199],
            [31.669754638448488, 3.18234457570445],
            [31.668430363616217, 3.181035825730548],
            [31.668462348131904, 3.180248507341401],
            [31.66800615668117, 3.180256906211041],
            [31.667479344174357, 3.179537024889561],
            [31.667660776912296, 3.177559470811389],
            [31.66665648108591, 3.175550054677688],
            [31.665793660933602, 3.169877850462374],
            [31.662435649705408, 3.162949649954283],
            [31.653262345078144, 3.156995726669859],
            [31.647822096513536, 3.152912394972427],
            [31.63790556444775, 3.143669099178455],
            [31.639057264829123, 3.140684293801603],
            [31.64048242495939, 3.138888136615802],
            [31.640721400181167, 3.137837491956426],
            [31.641472713355533, 3.137307502749822],
            [31.639811396018548, 3.13311678106231],
            [31.63890243120674, 3.127590301694689],
            [31.65105986464768, 3.112641680060529],
            [31.65406019637414, 3.094457995778905],
            [31.65292353199402, 3.087780108267591],
            [31.650408123434325, 3.084784016127794],
            [31.633470663636725, 3.077165008099543],
            [31.626800612465036, 3.074972390152545],
            [31.625799743711443, 3.072878281530675],
            [31.608466199637103, 3.054540712107205],
            [31.606511338018088, 3.04101672873899],
            [31.60824278054109, 3.033014640924998],
            [31.606746743334906, 3.025153084378161],
            [31.608405770866252, 3.017657376622775],
            [31.60781033335994, 3.006586205278758],
            [31.610527137918105, 2.984855845931706],
            [31.610750733982208, 2.978289848251856],
            [31.606646045784835, 2.962963336731229],
            [31.60736409434425, 2.962249733149569],
            [31.607150209068365, 2.961308839481512],
            [31.60672061763149, 2.960657095486188],
            [31.603925127840963, 2.959504914138934],
            [31.60320915349155, 2.958563385671687],
            [31.602066744385155, 2.954455764784738],
            [31.60213979987564, 2.953587591491958],
            [31.60343189076623, 2.952431537099771],
            [31.603720082885786, 2.951500324039063],
            [31.604082389609566, 2.948398537122071],
            [31.603568219093734, 2.94574234616598],
            [31.605793744006178, 2.945319974496887],
            [31.606013817776063, 2.943901592590163],
            [31.608120989649812, 2.942242606413799],
            [31.609086602223453, 2.940049203916562],
            [31.609948752232526, 2.939552577062745],
            [31.610365145621248, 2.938587947548593],
            [31.610893876929495, 2.938158612303301],
            [31.612079116810307, 2.938042525797852],
            [31.613238272310223, 2.936950583403298],
            [31.61473468141891, 2.937399212001634],
            [31.614952403399393, 2.937873677897171],
            [31.616449444023736, 2.937812840505196],
            [31.617821120258615, 2.938253472598875],
            [31.61820208499084, 2.937745477351938],
            [31.618714222619143, 2.937944985743393],
            [31.619800234593658, 2.937299711650817],
            [31.620426020783515, 2.937602243503511],
            [31.62132493075238, 2.938912296449043],
            [31.623145900274913, 2.938557929442843],
            [31.623374706567684, 2.939534037803485],
            [31.62467361477295, 2.938920368858846],
            [31.62538469420241, 2.940814116189852],
            [31.62672073067671, 2.941717135963977],
            [31.627062908849897, 2.942434733304665],
            [31.62759815743552, 2.941479163724949],
            [31.62833823448236, 2.941981709890501],
            [31.62841921760519, 2.942702902760871],
            [31.6297052897834, 2.943025849146834],
            [31.63015661595855, 2.943751419335448],
            [31.63178526336529, 2.943267915558302],
            [31.634147925088993, 2.944281490203169],
            [31.636566513227358, 2.942983361046431],
            [31.6375436700507, 2.940880059894717],
            [31.63732609359731, 2.940276266430077],
            [31.640061327991862, 2.93824565945608],
            [31.640928239970282, 2.93703182977341],
            [31.643656936426154, 2.937176247913445],
            [31.644086529659663, 2.93653797462363],
            [31.64432386725267, 2.936922327227447],
            [31.645349218690985, 2.93686087345162],
            [31.64658753553036, 2.937998896352547],
            [31.647250101442907, 2.93813295067076],
            [31.648577428750514, 2.939815824642934],
            [31.649594605519784, 2.940071798207816],
            [31.65451476636581, 2.939768170727851],
            [31.655648787004047, 2.940118337870956],
            [31.658047067827095, 2.942746992250278],
            [31.659204112286098, 2.943406790420799],
            [31.661288879278338, 2.943542769330183],
            [31.680764104008095, 2.947971675445733],
            [31.74404496928874, 2.963163768213045],
            [31.74541691861147, 2.964140786165579],
            [31.745057426309494, 2.965729498436407],
            [31.74613010638689, 2.96610190307743],
            [31.746661435622944, 2.965615331043184],
            [31.74909335925169, 2.968053982611079],
            [31.750028165899266, 2.967904253106285],
            [31.751284897303645, 2.968787239914691],
            [31.7534655908935, 2.968905710414877],
            [31.755541567870708, 2.969801221856387],
            [31.75835693917513, 2.969885603909645],
            [31.760767913193128, 2.970456700507776],
            [31.762625750473237, 2.970377597980847],
            [31.763342255727, 2.969392446068701],
            [31.76466881856831, 2.96975352257892],
            [31.76524505009385, 2.970392144592829],
            [31.767615625975214, 2.969773590006991],
            [31.767904217845075, 2.968758785390367],
            [31.767395854937583, 2.968550744739792],
            [31.767499754981635, 2.967913627909625],
            [31.766917798492834, 2.967601768978872],
            [31.76812913083936, 2.965343172279124],
            [31.768895210520416, 2.965788610050511],
            [31.771896104592223, 2.964939848391272],
            [31.77340927806077, 2.96300019377768],
            [31.775739244701416, 2.962306273818221],
            [31.77678678183232, 2.961514597437858],
            [31.778865769962334, 2.96115382684579],
            [31.78181286033855, 2.962313006665574],
            [31.787173689747174, 2.960318291410152],
            [31.78819910945747, 2.959526575930113],
            [31.787934497215826, 2.958844589048744],
            [31.78842176588381, 2.958118969502999],
            [31.78910007387336, 2.95794928943185],
            [31.789647224238198, 2.956379023343041],
            [31.7901705333154, 2.956401826331531],
            [31.789987024570834, 2.955697699292102],
            [31.791662020554654, 2.954032338719267],
            [31.792216190355113, 2.952780696379479],
            [31.795660065253102, 2.9512284031363],
            [31.798084339727197, 2.9519201500168],
            [31.79944538709565, 2.95430757738762],
            [31.803137319182945, 2.955141479209773],
            [31.80540616534994, 2.956448059393729],
            [31.806688485265198, 2.956656921388655],
            [31.810380093958972, 2.95562767097964],
            [31.815187825257315, 2.951256297408394],
            [31.817524660416595, 2.950712748776555],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 763,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "ITIRIKWA",
        Population: 17095,
        Key: "ADJUMANIITIRIKWA",
        Dist2: "Adjumani",
        "Sub Country": "Itirikwa",
        id2_original: "AdjumaniItirikwa",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.839091855728853, 3.257185522535228],
            [31.834969308125284, 3.259736167628952],
            [31.82797332211735, 3.266417328393706],
            [31.826094634041183, 3.267179617923834],
            [31.825374689138194, 3.268034098132792],
            [31.82731822300148, 3.26947520673048],
            [31.828625905950457, 3.271366261037045],
            [31.823052220735228, 3.27666634039549],
            [31.81305519333176, 3.291959388673068],
            [31.811052313167565, 3.293420238811288],
            [31.81086518690736, 3.294935046395104],
            [31.8131325948716, 3.295667985155962],
            [31.81501015286716, 3.295750879114275],
            [31.818505853370496, 3.298158345162056],
            [31.822805078030903, 3.299647378822233],
            [31.823301572396844, 3.300502832106419],
            [31.82448902572653, 3.300617150415593],
            [31.825876546446377, 3.303694872009569],
            [31.829361308164525, 3.305570369761391],
            [31.83428094708938, 3.307034673274327],
            [31.834973799701704, 3.308050091090322],
            [31.833765721951423, 3.315975216123281],
            [31.83470574960747, 3.321429798174608],
            [31.83161310430745, 3.336583483345277],
            [31.830205411917873, 3.336157663748315],
            [31.83000732082133, 3.336709183156555],
            [31.82887249259764, 3.336210340465116],
            [31.82734101056528, 3.337447695902552],
            [31.827095825289934, 3.33626984804987],
            [31.825950272080064, 3.335698856321939],
            [31.825370128391498, 3.336280517193738],
            [31.82463405244094, 3.333986604655493],
            [31.823974970195096, 3.333949416364653],
            [31.82408472994975, 3.333014138638264],
            [31.82336786716651, 3.332838570224739],
            [31.823324962730233, 3.332372634409324],
            [31.822799489611526, 3.332663181139132],
            [31.822611831548667, 3.332106077799798],
            [31.821109102791933, 3.331922284701163],
            [31.821341540075075, 3.331369325939396],
            [31.82089297082951, 3.33094657830747],
            [31.82016852177368, 3.331062178208388],
            [31.8190970122011, 3.330667797956347],
            [31.818822521186277, 3.330041435537344],
            [31.81834411260193, 3.330346595385187],
            [31.817910065521243, 3.329894746199636],
            [31.816823828967923, 3.329704171095803],
            [31.81669409696953, 3.329165336573749],
            [31.814969129503076, 3.330095020141641],
            [31.813188082010054, 3.329466835062753],
            [31.810783034178, 3.329755098503818],
            [31.80921896845366, 3.329389229661468],
            [31.80905892190768, 3.329971388399453],
            [31.80862437266879, 3.329941743826476],
            [31.808419709497613, 3.331484729392106],
            [31.8069109395706, 3.333317304884846],
            [31.805809041788574, 3.334102137836459],
            [31.804736924056524, 3.334217299730888],
            [31.797803825508396, 3.340699059135897],
            [31.79447706127904, 3.342097996582321],
            [31.789668053474696, 3.339162385292067],
            [31.786985142352187, 3.338775886593588],
            [31.786934365080754, 3.337542339709371],
            [31.785599574569765, 3.337029374758862],
            [31.781177996672728, 3.333010829461885],
            [31.780861784302843, 3.33420165514773],
            [31.77913929977983, 3.335283491162729],
            [31.7797762538253, 3.335693876428613],
            [31.77750295560775, 3.334271030285329],
            [31.776581933608202, 3.329349053959111],
            [31.775541536287164, 3.327251311269222],
            [31.77363202521695, 3.325123364275256],
            [31.771258400453508, 3.32346071351766],
            [31.77005979004801, 3.321208991881348],
            [31.76943971534673, 3.32116435692355],
            [31.765944414593662, 3.317793546811475],
            [31.76164650955843, 3.315305554373467],
            [31.75711317315523, 3.315197618575341],
            [31.7560406682493, 3.313005745825022],
            [31.755517486732884, 3.313078101668786],
            [31.75424103371477, 3.311309471900708],
            [31.753616615659094, 3.311002010321471],
            [31.753356496790463, 3.309862612409253],
            [31.75271793565895, 3.309248460416923],
            [31.748506910288096, 3.307067218848262],
            [31.74783943957413, 3.306336201414926],
            [31.747170870220547, 3.306481387592248],
            [31.74617093212161, 3.305889716792665],
            [31.745288004978303, 3.304554998731784],
            [31.745318350068594, 3.303532799153365],
            [31.74650070366242, 3.301023106310766],
            [31.745364468676975, 3.298823753184387],
            [31.746679666931605, 3.298029467472736],
            [31.74650688496988, 3.296093638339078],
            [31.74606949615636, 3.295478030346544],
            [31.746773961290362, 3.292575505551812],
            [31.74554850742753, 3.291778004190253],
            [31.74633895750394, 3.290277548330932],
            [31.744763753568378, 3.288955000900252],
            [31.7451159192109, 3.287553485227142],
            [31.74476627783432, 3.286937990340022],
            [31.745555885290955, 3.285880733188403],
            [31.745207125161706, 3.284559735944889],
            [31.744156728693238, 3.284115209219066],
            [31.74336926102359, 3.283236858968835],
            [31.742843542664808, 3.283317597955727],
            [31.742232117841414, 3.281996269974102],
            [31.743108358824063, 3.281825524711127],
            [31.74346074814709, 3.280243111991462],
            [31.744336228256692, 3.280678372463669],
            [31.74433787756353, 3.279357817659667],
            [31.74363792915877, 3.278660477040002],
            [31.74477849222726, 3.277160461548831],
            [31.74626824032813, 3.276637732779146],
            [31.74618265064448, 3.275136168986758],
            [31.747496979329956, 3.274785069946566],
            [31.747410608111995, 3.273907604763448],
            [31.747978808698882, 3.272678209446708],
            [31.7467735049462, 3.2690315943727],
            [31.746892393380797, 3.267729276102072],
            [31.747439261674614, 3.267368164668854],
            [31.747622201785614, 3.266572441397725],
            [31.7461992021036, 3.263857182791807],
            [31.746445453679172, 3.260990253228568],
            [31.745716257027077, 3.261658663564057],
            [31.745413120534444, 3.261414070946679],
            [31.74608316492173, 3.259461208588369],
            [31.746629355885833, 3.259642790855178],
            [31.746084599531226, 3.258303461225389],
            [31.7465103551618, 3.257634670184185],
            [31.745964603473876, 3.257326461131731],
            [31.745723588178087, 3.255743299450201],
            [31.74736352830628, 3.254949396586736],
            [31.748518468012556, 3.253612189877294],
            [31.74912540125956, 3.253793844948231],
            [31.748702809495395, 3.251902928891492],
            [31.749309906235737, 3.251722786497802],
            [31.748041757244085, 3.249342551751646],
            [31.747395997013903, 3.249137920728058],
            [31.74806453941801, 3.247897068975778],
            [31.75910552416597, 3.248358860379454],
            [31.764280961062916, 3.248970490993007],
            [31.77805096655861, 3.248466422227362],
            [31.79013410752893, 3.249373150301863],
            [31.797430527897127, 3.249192101616488],
            [31.80050984219832, 3.248176644681555],
            [31.812362130513648, 3.246384449548073],
            [31.81297361193093, 3.245695242226817],
            [31.813433844902132, 3.246605423062107],
            [31.814879935778503, 3.2460110065134],
            [31.815753599494602, 3.246528674902056],
            [31.817014696711272, 3.246340283001303],
            [31.820514134206203, 3.244304327316303],
            [31.82172850645168, 3.242733749911158],
            [31.822536258978754, 3.243264583434574],
            [31.822271903655274, 3.243917801681177],
            [31.823203099973718, 3.244077857244447],
            [31.823500310280433, 3.245402925730847],
            [31.822902678189877, 3.245525866600228],
            [31.82306024358904, 3.246038276865129],
            [31.823832831564296, 3.246586731321045],
            [31.823991378822043, 3.246251320296545],
            [31.825782298800032, 3.247595796946932],
            [31.827187855894174, 3.247862382436437],
            [31.827679214591644, 3.248463496631342],
            [31.82829307744272, 3.249506327572814],
            [31.82815187934808, 3.250036051695916],
            [31.829372318814986, 3.250823476750913],
            [31.828836750429094, 3.252046635066788],
            [31.82915508731465, 3.252338185506848],
            [31.830719076682172, 3.252689424230516],
            [31.83118317151081, 3.252194960094628],
            [31.833239121447058, 3.25301265454713],
            [31.83396371243666, 3.252722316867759],
            [31.834686798748233, 3.253742285849726],
            [31.83612026200667, 3.254238955518742],
            [31.839091855728853, 3.257185522535228],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 764,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "OFUA",
        Population: 14027,
        Key: "ADJUMANIOFUA",
        Dist2: "Adjumani",
        "Sub Country": "Ofua",
        id2_original: "AdjumaniOfua",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.695431636965385, 3.205492415694629],
            [31.698444728362148, 3.208946211237791],
            [31.69969163758719, 3.211103812341432],
            [31.702834372049136, 3.212845192010397],
            [31.703582201556856, 3.214395123206728],
            [31.704685289606637, 3.215003563384957],
            [31.70674454264818, 3.21712033468162],
            [31.708535157198956, 3.217562191264554],
            [31.709782805737508, 3.219154622865695],
            [31.709593141736605, 3.220912683612754],
            [31.710172833572624, 3.223676468303052],
            [31.70965082076437, 3.22472241186201],
            [31.710714324551144, 3.228320521776563],
            [31.712432957098205, 3.2314531293519],
            [31.714330356183453, 3.233174904163862],
            [31.714940279922025, 3.236033374399366],
            [31.71646074591405, 3.237268506045851],
            [31.7160233750668, 3.23792012095183],
            [31.716577237643452, 3.238454420753747],
            [31.716375345774914, 3.239497636916387],
            [31.718249270983478, 3.241136380310397],
            [31.71770600942551, 3.24155070663944],
            [31.717158325461398, 3.243378771947543],
            [31.716026699731696, 3.243895341217787],
            [31.71559634472685, 3.244585472651337],
            [31.713906954138903, 3.244655260310228],
            [31.714004397991026, 3.246842541144231],
            [31.713587335357428, 3.248338483448419],
            [31.712742061997588, 3.248826631911367],
            [31.711310960410025, 3.248421900610382],
            [31.71109435413713, 3.249889319192791],
            [31.710578277396326, 3.250435445075537],
            [31.711219469693308, 3.252824870139603],
            [31.71286526593881, 3.253273047528332],
            [31.713236757038015, 3.253849090167766],
            [31.713335763958746, 3.254798903341705],
            [31.712891467100683, 3.255186840960413],
            [31.71396326682912, 3.256699081265401],
            [31.716086404460412, 3.261871524321394],
            [31.717615145732832, 3.267097031010565],
            [31.714817902430873, 3.271016011788051],
            [31.71437870261374, 3.273614821134765],
            [31.712951044268646, 3.276562831725401],
            [31.713296464461692, 3.279133446925073],
            [31.712887468699364, 3.280826891463636],
            [31.712276254081733, 3.281585468759022],
            [31.712738431007224, 3.283747343314151],
            [31.71352138284593, 3.285033441136212],
            [31.713663422662016, 3.287574586006088],
            [31.712701089837477, 3.290201919173664],
            [31.713539986955446, 3.293182065409153],
            [31.711997428695643, 3.295049273867699],
            [31.71060163000044, 3.295777618983612],
            [31.709175526639125, 3.297469732167141],
            [31.708012917116964, 3.297643454012484],
            [31.70769178916583, 3.298782083024277],
            [31.7067315377378, 3.299773846530586],
            [31.706497094516642, 3.301292270298227],
            [31.70727868091609, 3.303629802163102],
            [31.707830324653976, 3.304010207262432],
            [31.707713291240456, 3.304623386757259],
            [31.708149112493803, 3.304682369811154],
            [31.7092802145057, 3.306407025977367],
            [31.710122534204913, 3.306729397711877],
            [31.71070263657098, 3.30757714032174],
            [31.710844724896113, 3.310059871728435],
            [31.711886086109434, 3.313770447127523],
            [31.711950091971758, 3.314687834650635],
            [31.71144904943551, 3.314646068301388],
            [31.70973260967607, 3.316104141701572],
            [31.709731282864386, 3.317126363283073],
            [31.708573871892764, 3.318676357726313],
            [31.70653074271222, 3.319750028307811],
            [31.70639348642501, 3.320599565932848],
            [31.70389216794059, 3.320956321098929],
            [31.703230006269933, 3.320314026109887],
            [31.703017437924267, 3.319020324201157],
            [31.702445988130975, 3.31880253064643],
            [31.701424026934536, 3.317010307963079],
            [31.699113351614624, 3.3164555436333],
            [31.699367105919453, 3.314031873538734],
            [31.69824920554897, 3.312709859953747],
            [31.694009048711774, 3.311627955243372],
            [31.69334084676914, 3.312278275190956],
            [31.690956419764426, 3.313251945438087],
            [31.683960268466464, 3.31470789006673],
            [31.682602176555328, 3.314543217358502],
            [31.6821508530751, 3.313611046629267],
            [31.68068607185092, 3.313111652372526],
            [31.680328438163272, 3.313283011065135],
            [31.68001668323382, 3.314639273153318],
            [31.679539922159712, 3.314692956346395],
            [31.67694486447537, 3.313133713993103],
            [31.6756808998363, 3.313846592847934],
            [31.67186819105572, 3.313886717166047],
            [31.671747250869018, 3.314917631149828],
            [31.671103487593683, 3.315179046496179],
            [31.668745810621477, 3.314217129084089],
            [31.666142318654952, 3.31834696966069],
            [31.665069920648545, 3.318372656066828],
            [31.664833101383465, 3.317323180820666],
            [31.664070710184962, 3.317322120791199],
            [31.663628638453876, 3.318171735835871],
            [31.66367420370005, 3.319438003702257],
            [31.662957375951088, 3.320649026634724],
            [31.661362840270627, 3.319335390015281],
            [31.65781251321483, 3.319212964028373],
            [31.65733000471953, 3.3231286357369],
            [31.656351983716874, 3.32363378062149],
            [31.65513714434748, 3.323387927071095],
            [31.65446881753901, 3.324110553960482],
            [31.650452730178095, 3.324611513857549],
            [31.647097154282633, 3.321884559581121],
            [31.640797890829283, 3.319659939472659],
            [31.638651156252102, 3.320968392117572],
            [31.63605409891792, 3.320702543592096],
            [31.63576622031042, 3.321850821742755],
            [31.635014890068007, 3.322392399106008],
            [31.633349415327896, 3.320780162232277],
            [31.632730089821564, 3.32061648957879],
            [31.632013824417992, 3.321429546172046],
            [31.631467499604884, 3.320298142755276],
            [31.629657459884406, 3.319816309579016],
            [31.62856081095862, 3.320086100708952],
            [31.628129925947757, 3.321324558845423],
            [31.627629290348327, 3.321396238785143],
            [31.62734397193935, 3.321061206228757],
            [31.627774918035655, 3.319795562827743],
            [31.62689327368657, 3.319767253295728],
            [31.625296488624645, 3.320000173091807],
            [31.62502135800932, 3.320641931097596],
            [31.624234528143546, 3.320848789481024],
            [31.62354151383448, 3.322068873802087],
            [31.623492452345232, 3.323000420448083],
            [31.622301362635262, 3.32290830243991],
            [31.62163516034246, 3.322256109781099],
            [31.62146659417435, 3.323314145166044],
            [31.62049107228483, 3.32225454754583],
            [31.6207034528826, 3.323665740036021],
            [31.620012249577155, 3.323836664638855],
            [31.61867541090728, 3.325336163037571],
            [31.616984060195403, 3.324999068275058],
            [31.615674593192256, 3.324255632602775],
            [31.614256187494636, 3.324552108700585],
            [31.614136186047403, 3.325175992258291],
            [31.613253792503375, 3.325654078667433],
            [31.611696632128616, 3.325327919626586],
            [31.60915420314353, 3.326172849165],
            [31.606396149744146, 3.325325892852334],
            [31.60595426396432, 3.323093237058593],
            [31.604861195723235, 3.321056697981739],
            [31.603339177442393, 3.319281838008318],
            [31.600375355045703, 3.317495883101654],
            [31.598567057158565, 3.315729658408116],
            [31.59411197479638, 3.307746190663599],
            [31.58848468800648, 3.302655245371671],
            [31.586999578805717, 3.300075492088232],
            [31.586338469062262, 3.296275932317046],
            [31.586667441102453, 3.284346939199335],
            [31.58549513965668, 3.279904509571215],
            [31.585095327371512, 3.276657030229877],
            [31.582874039812246, 3.272475401087407],
            [31.580421772935598, 3.263780339085373],
            [31.579708784586174, 3.2626759221513],
            [31.576971475981626, 3.260926484636217],
            [31.566766979070053, 3.257502243765416],
            [31.56519790074643, 3.255302246965075],
            [31.563690766651536, 3.251652677351468],
            [31.56233717619829, 3.246823701423495],
            [31.562156846591517, 3.243504209069767],
            [31.56266660278601, 3.239362677123101],
            [31.56367054737113, 3.236597688469034],
            [31.5688388166104, 3.229775499158263],
            [31.57165570696595, 3.222408400491202],
            [31.571332348497982, 3.218772145218202],
            [31.56990225571849, 3.215315218648625],
            [31.564256188749233, 3.207113159994925],
            [31.5634060141812, 3.197543147832163],
            [31.561892118467178, 3.192901319601532],
            [31.558985067799824, 3.187588262736672],
            [31.549933427401353, 3.175845160902758],
            [31.543905017684285, 3.164187741709906],
            [31.54334412309559, 3.161338035253767],
            [31.543556136282415, 3.156897644965847],
            [31.542495667004705, 3.155005918411801],
            [31.539060922583243, 3.150743826074021],
            [31.53674291162074, 3.146776666634042],
            [31.535147960918614, 3.146295075715639],
            [31.530244565330747, 3.14618865485081],
            [31.52637589510121, 3.144464785299149],
            [31.524351743729383, 3.142897280666585],
            [31.523065119985592, 3.140109870318437],
            [31.520931241198436, 3.13320619845546],
            [31.516142066398942, 3.123929217158279],
            [31.515117876482268, 3.122480712135078],
            [31.511642249732265, 3.119711028363109],
            [31.50850959706275, 3.115869154612554],
            [31.506877421073575, 3.112927518447024],
            [31.505566466460333, 3.10909098306888],
            [31.504075423887148, 3.102568120172737],
            [31.501990453875624, 3.098142630308899],
            [31.49630657412115, 3.089488475284738],
            [31.490639229656075, 3.081919634284891],
            [31.486479269017558, 3.075067424235157],
            [31.48345016694749, 3.071743972996349],
            [31.47754456860784, 3.066960338196748],
            [31.476919681631582, 3.065512417311846],
            [31.476094447889096, 3.063195994936304],
            [31.47416212500056, 3.050522719733118],
            [31.477777262809152, 3.041899969473155],
            [31.47864163614857, 3.036963212812045],
            [31.47850675410866, 3.035515993383064],
            [31.477667874956992, 3.034501886741762],
            [31.47622766714742, 3.033685894068254],
            [31.474930560962594, 3.033467001525146],
            [31.465371117307054, 3.035017995954375],
            [31.460656669762777, 3.035165000877199],
            [31.45735519131205, 3.034708076769103],
            [31.454666682787032, 3.033781746332142],
            [31.450200568214864, 3.030130666313415],
            [31.44286996156022, 3.02206208639058],
            [31.440077717382813, 3.019996077724133],
            [31.436147132568927, 3.017801808413961],
            [31.435282618193995, 3.01686905216737],
            [31.434714291842983, 3.009723673638079],
            [31.43351982895914, 3.007162570158637],
            [31.43011567037649, 3.002328301430429],
            [31.42632959754237, 2.999392664856951],
            [31.42190545944681, 2.997215770111666],
            [31.41850774358137, 2.994606260910879],
            [31.411321531227177, 2.991014523100853],
            [31.40530936664369, 2.986738364688875],
            [31.402739071020136, 2.984345895753932],
            [31.401755310681168, 2.982517650048824],
            [31.401043059848558, 2.979550308926622],
            [31.402075244771265, 2.972362148811749],
            [31.403762803694352, 2.970148919653302],
            [31.41130356042991, 2.968676693572175],
            [31.414539408864293, 2.965091032517114],
            [31.415181667461525, 2.963952456025803],
            [31.417422760177825, 2.955942984503308],
            [31.417843381936592, 2.953429872056794],
            [31.417673956979055, 2.95229128],
            [31.417944438812764, 2.951495393447463],
            [31.422862580246058, 2.947829528434709],
            [31.42402029574656, 2.945712817187797],
            [31.42467262176316, 2.943245657755692],
            [31.423854181080824, 2.939497260720759],
            [31.42537096487851, 2.939703609439422],
            [31.42555065757974, 2.938306392756868],
            [31.426109628875377, 2.93803279547716],
            [31.426528443223784, 2.938122726029776],
            [31.427112969792653, 2.939137408825461],
            [31.427422416051833, 2.938187166296506],
            [31.429276926870454, 2.938139378638827],
            [31.43035798733114, 2.936730670383571],
            [31.431581697563974, 2.937715098575376],
            [31.43140318884229, 2.938270007681398],
            [31.43183484191274, 2.938257855100042],
            [31.43226210042479, 2.936848219356178],
            [31.433101192477164, 2.935981563748161],
            [31.43279132760307, 2.935145193909977],
            [31.4331404263972, 2.935158447312114],
            [31.433539219992856, 2.935950275227517],
            [31.434028099340168, 2.935868009631999],
            [31.43386479729962, 2.934623449518491],
            [31.434819268068757, 2.934383839388619],
            [31.43462158929891, 2.933597146478775],
            [31.435009537534143, 2.933061672454536],
            [31.436938170143506, 2.933804601561377],
            [31.4364321221945, 2.93254041603138],
            [31.43668024496082, 2.932132368473812],
            [31.438266782940286, 2.932389844712888],
            [31.43908763020925, 2.930942466058156],
            [31.44011018249718, 2.930516358479093],
            [31.440386587821887, 2.929642295651277],
            [31.441629954989775, 2.928565839594711],
            [31.44214863774326, 2.927536006124785],
            [31.44288203132436, 2.927406211965701],
            [31.443668186555374, 2.928090099396305],
            [31.445079760565275, 2.926343617324711],
            [31.446539955889936, 2.926160598165635],
            [31.446987326782903, 2.923953320267357],
            [31.447774238395375, 2.922825912479521],
            [31.449846322972434, 2.922068452174183],
            [31.45045490822123, 2.922637227264131],
            [31.45134389090787, 2.922402355094843],
            [31.451725681191835, 2.921720092518346],
            [31.45109183621555, 2.921055566145315],
            [31.4511652537271, 2.920341999439423],
            [31.45475515785936, 2.918154843948747],
            [31.454828939188598, 2.917595728006738],
            [31.45512735413609, 2.917898556754164],
            [31.4557746019764, 2.917686371640582],
            [31.4560803992789, 2.916869995524555],
            [31.458514583068876, 2.917192338403049],
            [31.459924613773158, 2.918636521213076],
            [31.46001201715535, 2.919769368137013],
            [31.461396716266883, 2.921177227495507],
            [31.461676321390648, 2.922340899624845],
            [31.46403337044045, 2.921734020734298],
            [31.464582436013465, 2.920610169705205],
            [31.4636329661655, 2.918646957759359],
            [31.4638614742176, 2.916876714291688],
            [31.468187476758285, 2.915121027033501],
            [31.470013201961947, 2.915406252518909],
            [31.470585689309353, 2.916383471986326],
            [31.47125458295475, 2.916576663747795],
            [31.47172247496205, 2.916240204904225],
            [31.47161683577958, 2.915551429744901],
            [31.47042185456785, 2.914337528833312],
            [31.47123388846555, 2.913757574594124],
            [31.47156992575545, 2.912780311577342],
            [31.472744996707245, 2.912390686193937],
            [31.47368044924353, 2.913218364321891],
            [31.473719015715325, 2.914394043219934],
            [31.474947718784527, 2.914593731609771],
            [31.475008287692553, 2.913666536793126],
            [31.473745326471676, 2.911853702006972],
            [31.474584172385647, 2.911787518848124],
            [31.474828811485292, 2.911424499173461],
            [31.473567809490056, 2.91112370074238],
            [31.473377461871248, 2.910452762411122],
            [31.474301335123524, 2.909366446150928],
            [31.475028112612566, 2.909440533408334],
            [31.474849966810236, 2.908101229187502],
            [31.47542551022627, 2.907446380500569],
            [31.475996682440087, 2.907276674798199],
            [31.476762743256497, 2.908000270150774],
            [31.477395158114838, 2.907642319997986],
            [31.477405281229792, 2.906917838022362],
            [31.47804854055023, 2.906428214087594],
            [31.480307255517456, 2.908711374806327],
            [31.481699268712052, 2.908359253716221],
            [31.483006128804256, 2.9099641080434],
            [31.48276710327681, 2.910729438281997],
            [31.48352715436397, 2.911890910631122],
            [31.484526027061015, 2.912442574947231],
            [31.48498880226447, 2.913436159286138],
            [31.48656233802852, 2.910654384871862],
            [31.48711003097577, 2.911189915340683],
            [31.487443457761472, 2.911022879241205],
            [31.487671858914048, 2.909300463809271],
            [31.485032254673076, 2.907285925405485],
            [31.48483008881836, 2.905796381973579],
            [31.486046464306927, 2.905613558640831],
            [31.486613073977455, 2.904240635928278],
            [31.487584042306793, 2.903761309353657],
            [31.48945937337877, 2.90543946285633],
            [31.490595370310658, 2.905389563682902],
            [31.491480392325194, 2.90442237212375],
            [31.492652051475545, 2.905355264336088],
            [31.495811275412837, 2.900530269536926],
            [31.495550399264424, 2.899578662961439],
            [31.49609866533682, 2.899178789185019],
            [31.49607376583377, 2.898411867619897],
            [31.49677421549848, 2.898736822039982],
            [31.49803228629096, 2.902076617523802],
            [31.49887941916346, 2.901237348836375],
            [31.500754616386438, 2.901037982855404],
            [31.50209340979033, 2.900391106763045],
            [31.50181264314492, 2.899449079104409],
            [31.502926673573175, 2.898424587641093],
            [31.50208851127709, 2.89646247557812],
            [31.5031271964092, 2.895471575885153],
            [31.50247386966936, 2.894458175217869],
            [31.502404752393087, 2.893405049645029],
            [31.501337306798842, 2.893292252930034],
            [31.501136832471833, 2.892562963692957],
            [31.501822234457194, 2.892158860866743],
            [31.503396463720666, 2.889832125147166],
            [31.504336726735282, 2.889369498736764],
            [31.505655116704162, 2.887840425548172],
            [31.507435088913763, 2.887607658089244],
            [31.507408965006974, 2.886779582611456],
            [31.508880172778714, 2.886204380037837],
            [31.51033238477544, 2.886261083340077],
            [31.510985574073054, 2.885873017984055],
            [31.51099202307845, 2.884051634321812],
            [31.512824514392854, 2.883353351006602],
            [31.51366408704391, 2.881719498923506],
            [31.517988833739818, 2.879845780543428],
            [31.51945769780697, 2.880407172446383],
            [31.5201071572995, 2.881198616230265],
            [31.520158121420533, 2.881918116463593],
            [31.521383695657608, 2.882604120975961],
            [31.522950947706263, 2.882291124021886],
            [31.522955389875342, 2.883035281612675],
            [31.5243581343443, 2.882173285851833],
            [31.525243381835974, 2.882414336280611],
            [31.525306017767488, 2.883187421506625],
            [31.52484380580771, 2.883351378112105],
            [31.52537412893065, 2.883827236754511],
            [31.526233132141293, 2.883860342609547],
            [31.52751190460948, 2.883232941634047],
            [31.529335119021923, 2.884153448709091],
            [31.530300700154534, 2.883588417906358],
            [31.531228661639666, 2.88360561590834],
            [31.532980116830572, 2.882403065920838],
            [31.535119842751904, 2.882150798958148],
            [31.53617932478114, 2.881122416959009],
            [31.536862773829082, 2.881597766935583],
            [31.538370543032897, 2.880202968796836],
            [31.539219371924645, 2.879900191865767],
            [31.54092432223161, 2.877732633406454],
            [31.541596705831875, 2.878570480394974],
            [31.543192295236164, 2.878999020994935],
            [31.542634569005493, 2.879733995399666],
            [31.542856315438442, 2.880496627604238],
            [31.543762363420516, 2.881068221018233],
            [31.54327900332233, 2.881701999440771],
            [31.543845735163732, 2.88222517688734],
            [31.544196119447033, 2.881911091550739],
            [31.544800297561043, 2.882178423995705],
            [31.545287117071382, 2.883349050832299],
            [31.54589636078529, 2.883448635795281],
            [31.54581059413354, 2.88417355535158],
            [31.546551067337397, 2.885683210507671],
            [31.54599248860552, 2.887084572836711],
            [31.546331040279924, 2.887735404092076],
            [31.548562936044345, 2.888202080115454],
            [31.548837597739087, 2.889055409991208],
            [31.550325701024676, 2.890624669479542],
            [31.550297669096246, 2.891818803371901],
            [31.553011440043683, 2.892835200256928],
            [31.553951444343536, 2.894580949235057],
            [31.55799777977668, 2.895725729324475],
            [31.55784425769463, 2.896407066501632],
            [31.558493840256364, 2.897629577966022],
            [31.556544543700532, 2.898982647254568],
            [31.556444031203398, 2.899908676159455],
            [31.557671948246742, 2.901765484866564],
            [31.557362795736644, 2.903012571894627],
            [31.557616800671433, 2.903434057848282],
            [31.558576337040474, 2.903664528011951],
            [31.557785417145215, 2.904281924196769],
            [31.557736181382797, 2.905145718998475],
            [31.55888733558847, 2.90514165037435],
            [31.55923665806311, 2.905669880575404],
            [31.558743194612937, 2.905898486881063],
            [31.55939959987926, 2.90681095314154],
            [31.5585066304694, 2.907868091780002],
            [31.55853158926126, 2.910320821177192],
            [31.5597173016559, 2.911358820190989],
            [31.56063975826495, 2.911562587588829],
            [31.56170593184477, 2.912727892621138],
            [31.563771779418808, 2.913165949871828],
            [31.56399235983849, 2.914856205427772],
            [31.5634547271241, 2.916454859252379],
            [31.564106080265283, 2.91717540018854],
            [31.565712650675593, 2.917364052229648],
            [31.56701063271781, 2.919225129532422],
            [31.567040978706427, 2.91971693335785],
            [31.566520871224917, 2.919838741985517],
            [31.566976002663605, 2.920569693057555],
            [31.56864633908605, 2.920662463590356],
            [31.568385591396748, 2.921371173831329],
            [31.56866085226779, 2.921763023720193],
            [31.570433145678365, 2.920909985913589],
            [31.571742588426986, 2.92123152917142],
            [31.57233869877143, 2.921773960845731],
            [31.574885927455075, 2.922312441222163],
            [31.575409224854184, 2.923661894981484],
            [31.574875462082023, 2.92449331667069],
            [31.57518450320102, 2.925239635492431],
            [31.574473434551347, 2.925601245776376],
            [31.57505498500167, 2.927014748922887],
            [31.574974427680257, 2.927814322251698],
            [31.575578701015687, 2.92803367272187],
            [31.57542954025434, 2.928566598576935],
            [31.576419027353275, 2.930971034589934],
            [31.57870287538553, 2.931145795686167],
            [31.578718588716463, 2.931865466828474],
            [31.580007207618504, 2.931893767989156],
            [31.58066927496603, 2.932545017456843],
            [31.581941743057556, 2.932765217487463],
            [31.582211267287196, 2.933506596536576],
            [31.58282143446922, 2.933262138928946],
            [31.58405075647766, 2.934058052855744],
            [31.584108284588442, 2.934697867946802],
            [31.584727990980475, 2.935301082186592],
            [31.586186088738955, 2.935510853359441],
            [31.58505310924809, 2.938217658099126],
            [31.5854288601584, 2.938831223362639],
            [31.585958959600823, 2.939002496968039],
            [31.586813000517832, 2.938530403574823],
            [31.587766903551746, 2.939345995061485],
            [31.587002853164936, 2.939659563789225],
            [31.588173111841748, 2.941041832556949],
            [31.58758778217904, 2.942613791657937],
            [31.588777729231936, 2.942635940920374],
            [31.589146095092307, 2.943266182302592],
            [31.589639370794583, 2.943202835034071],
            [31.590916309801294, 2.944100100478001],
            [31.59036387285101, 2.944819111056676],
            [31.591565836667478, 2.94629738315436],
            [31.5930839293105, 2.946192023558006],
            [31.594020359213797, 2.946982897170078],
            [31.596491927292682, 2.946767453823939],
            [31.597254151404524, 2.947914630758891],
            [31.598126285289673, 2.94659875706511],
            [31.59920242118597, 2.946328394172189],
            [31.599770758316783, 2.94561472876183],
            [31.603568219093734, 2.94574234616598],
            [31.604082389609566, 2.948398537122071],
            [31.603720082885786, 2.951500324039063],
            [31.60343189076623, 2.952431537099771],
            [31.60213979987564, 2.953587591491958],
            [31.602066744385155, 2.954455764784738],
            [31.60320915349155, 2.958563385671687],
            [31.603925127840963, 2.959504914138934],
            [31.60672061763149, 2.960657095486188],
            [31.607150209068365, 2.961308839481512],
            [31.60736409434425, 2.962249733149569],
            [31.606646045784835, 2.962963336731229],
            [31.610750733982208, 2.978289848251856],
            [31.610527137918105, 2.984855845931706],
            [31.60781033335994, 3.006586205278758],
            [31.608405770866252, 3.017657376622775],
            [31.606746743334906, 3.025153084378161],
            [31.60824278054109, 3.033014640924998],
            [31.606511338018088, 3.04101672873899],
            [31.608466199637103, 3.054540712107205],
            [31.625799743711443, 3.072878281530675],
            [31.626800612465036, 3.074972390152545],
            [31.633470663636725, 3.077165008099543],
            [31.650408123434325, 3.084784016127794],
            [31.65292353199402, 3.087780108267591],
            [31.65406019637414, 3.094457995778905],
            [31.65105986464768, 3.112641680060529],
            [31.63890243120674, 3.127590301694689],
            [31.639811396018548, 3.13311678106231],
            [31.641472713355533, 3.137307502749822],
            [31.640721400181167, 3.137837491956426],
            [31.64048242495939, 3.138888136615802],
            [31.639057264829123, 3.140684293801603],
            [31.63790556444775, 3.143669099178455],
            [31.647822096513536, 3.152912394972427],
            [31.653262345078144, 3.156995726669859],
            [31.662435649705408, 3.162949649954283],
            [31.665793660933602, 3.169877850462374],
            [31.66665648108591, 3.175550054677688],
            [31.667660776912296, 3.177559470811389],
            [31.667479344174357, 3.179537024889561],
            [31.66800615668117, 3.180256906211041],
            [31.668462348131904, 3.180248507341401],
            [31.668430363616217, 3.181035825730548],
            [31.669754638448488, 3.18234457570445],
            [31.67045723059514, 3.184592217068199],
            [31.67356037720079, 3.190644476921694],
            [31.673522485363794, 3.192686606604576],
            [31.675561356529894, 3.194062202645908],
            [31.675559950666468, 3.194530234121345],
            [31.67463987908448, 3.194741412871152],
            [31.676445774876548, 3.196944782205929],
            [31.680899889753157, 3.199169331051225],
            [31.687064325065545, 3.199449398204897],
            [31.690041337425516, 3.200437028594708],
            [31.690873408245647, 3.201233514119669],
            [31.69218163287874, 3.204291269814305],
            [31.695431636965385, 3.205492415694629],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 765,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "UKUSIJONI",
        Population: 11317,
        Key: "ADJUMANIUKUSIJONI",
        Dist2: "Adjumani",
        "Sub Country": "Ukusijoni",
        id2_original: "AdjumaniUkusijoni",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.854609449168144, 3.535619492344975],
            [31.849595317356908, 3.541331828938966],
            [31.845260468207275, 3.5451549797185],
            [31.838456731551634, 3.548188067495326],
            [31.835297341426006, 3.549200740386849],
            [31.832874709072247, 3.549505752078459],
            [31.829326345733666, 3.54956872152748],
            [31.822096857040666, 3.548896637739467],
            [31.817900220884056, 3.549633656301626],
            [31.81505113131545, 3.548993649055531],
            [31.80847569609938, 3.544277164057163],
            [31.80231857846331, 3.54082301549987],
            [31.79846506820249, 3.536123625673701],
            [31.795140105993614, 3.528856131385693],
            [31.793805993710663, 3.526985949271658],
            [31.78750048427113, 3.522239685924288],
            [31.785361170676506, 3.518958554456532],
            [31.783173118087856, 3.516538818116627],
            [31.781198092883958, 3.515148322907824],
            [31.775840390510833, 3.514255895265733],
            [31.773864541551838, 3.513511480138582],
            [31.771794336250313, 3.512072989292812],
            [31.769389369266637, 3.508686423936042],
            [31.76626527215191, 3.505626862361869],
            [31.751476984959154, 3.496969287716631],
            [31.748728892977983, 3.496875160857016],
            [31.73854446981971, 3.493731942204583],
            [31.73412307068743, 3.493807368041101],
            [31.726301442203532, 3.496401646399204],
            [31.723893692239088, 3.496760152072957],
            [31.707173857403916, 3.496836648257474],
            [31.7004753826383, 3.489835786015079],
            [31.699044803870247, 3.487654064087092],
            [31.702951895044475, 3.484927890652758],
            [31.710054451787826, 3.477110405079753],
            [31.71599563778579, 3.468298219592903],
            [31.72030892557196, 3.459600574342549],
            [31.723431441651762, 3.451567207586478],
            [31.726692561491724, 3.447132211776229],
            [31.729170345912348, 3.445695629974004],
            [31.729134829220975, 3.44508224538885],
            [31.73020443975506, 3.443951925126068],
            [31.731020520563114, 3.442229829217633],
            [31.73493020876685, 3.441811556073354],
            [31.735730455869707, 3.441067854005646],
            [31.73636265872563, 3.441024886141189],
            [31.736923289209614, 3.440156734542283],
            [31.737707356755905, 3.44066159249178],
            [31.738303604542576, 3.440333810570806],
            [31.738583576178986, 3.437398913458841],
            [31.739449527858348, 3.436414338204198],
            [31.73939339393289, 3.434895517204335],
            [31.74051400541891, 3.433641115298073],
            [31.739817160693452, 3.433114472714056],
            [31.741652301139595, 3.429977182102503],
            [31.74110973397935, 3.428158348352099],
            [31.741931846974555, 3.42734894905803],
            [31.74215200159281, 3.425684457449194],
            [31.744051831519208, 3.423065659481461],
            [31.744596889707733, 3.422978757268492],
            [31.744778994385502, 3.422628515588459],
            [31.744432963338067, 3.422190349242682],
            [31.74449667545127, 3.421079784304861],
            [31.74528340021415, 3.420806654016726],
            [31.748339908086898, 3.415166089516264],
            [31.748244684870137, 3.41434346875994],
            [31.75083272671211, 3.411040739306588],
            [31.750968212419917, 3.405541478723003],
            [31.75648625688476, 3.402259201307672],
            [31.75709083564737, 3.401413007861358],
            [31.762229775790935, 3.399698933013457],
            [31.769361032809293, 3.396080634413082],
            [31.775611623743934, 3.393995602141452],
            [31.781630266977263, 3.391445645087996],
            [31.784241905765125, 3.38971426781402],
            [31.78783887784205, 3.388607103536823],
            [31.790235980973737, 3.38857305952156],
            [31.79300353675218, 3.389605646147035],
            [31.79413978161909, 3.38920423128071],
            [31.796544140443338, 3.389811495445255],
            [31.799150754055507, 3.388941931797433],
            [31.8008208048137, 3.389078291631991],
            [31.80406242851702, 3.387940942181153],
            [31.804997791221773, 3.387908532012423],
            [31.80599918099825, 3.388514033989966],
            [31.807235965311737, 3.387844164528138],
            [31.80767141466256, 3.386871173782724],
            [31.808773839755645, 3.386805396544171],
            [31.81118075698182, 3.385331286125547],
            [31.81262107977576, 3.382583188125819],
            [31.81437803624949, 3.381162041503415],
            [31.8163160113378, 3.380728008269588],
            [31.816283869616914, 3.379687295671045],
            [31.817341040280954, 3.379059150532754],
            [31.82512141543205, 3.395560195489197],
            [31.83064052799374, 3.402061357101146],
            [31.83649844555475, 3.407323733010839],
            [31.841852345359296, 3.411210612857041],
            [31.848947689529222, 3.415796057500339],
            [31.860332724539433, 3.421490124328463],
            [31.863384554884494, 3.423212366131005],
            [31.86480615588959, 3.424453697804207],
            [31.86432185435698, 3.428317657447214],
            [31.86198012517605, 3.43787743055194],
            [31.858471000249082, 3.449192161953464],
            [31.854381949924147, 3.458164300132364],
            [31.847962080457357, 3.467328699194379],
            [31.84698773266591, 3.470059652543903],
            [31.84659054435966, 3.477279836443822],
            [31.8473524091454, 3.48957542677207],
            [31.848222135545594, 3.490451514100584],
            [31.84858789449499, 3.490329503494058],
            [31.849192276526573, 3.49658828535005],
            [31.848931362648944, 3.499473387600928],
            [31.849312419907612, 3.506465808679374],
            [31.852409345679934, 3.525509824083108],
            [31.852916503048323, 3.531733564681122],
            [31.854657906989537, 3.535539862119176],
            [31.854609449168144, 3.535619492344975],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 766,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "PACARA",
        Population: 17170,
        Key: "ADJUMANIPACARA",
        Dist2: "Adjumani",
        "Sub Country": "Pachara",
        id2_original: "AdjumaniPachara",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.997232052693015, 3.205849480800222],
            [31.99507145711102, 3.207932116830295],
            [31.98594288588995, 3.211846358711344],
            [31.98071843960606, 3.215136385510065],
            [31.97142726343709, 3.219520327490285],
            [31.962631553961376, 3.224309688582533],
            [31.958146825398188, 3.226236112989854],
            [31.94876625248543, 3.233540891644163],
            [31.93843630404777, 3.238749010159225],
            [31.935367906972232, 3.24694473805812],
            [31.93516472332634, 3.255531559375434],
            [31.931264800708046, 3.271140179112344],
            [31.92854056079428, 3.276601721692011],
            [31.92755990143962, 3.285773153825768],
            [31.9254151790887, 3.293967521203978],
            [31.923454888950427, 3.311139383654267],
            [31.923837763500924, 3.316213935593261],
            [31.925583079605193, 3.318362591178427],
            [31.925577590000497, 3.323436720410748],
            [31.92453371080941, 3.326804260345198],
            [31.92272387051492, 3.329126647755496],
            [31.917939783773186, 3.33806282757311],
            [31.914764879742624, 3.346123013545715],
            [31.914174958790483, 3.350387892762426],
            [31.911033185525902, 3.357842795572193],
            [31.908674516813633, 3.370846589805521],
            [31.904101459603506, 3.381712426205668],
            [31.903019886204813, 3.382501052076876],
            [31.901143231914435, 3.382778273432409],
            [31.899950794731552, 3.383527588531718],
            [31.893218060915963, 3.384429217596607],
            [31.88596657697324, 3.383043415488634],
            [31.87762891037608, 3.38263199824059],
            [31.874713367934326, 3.385153930038504],
            [31.87225037068158, 3.391406969499837],
            [31.870466044337785, 3.403342761422115],
            [31.86480615588959, 3.424453697804207],
            [31.863384554884494, 3.423212366131005],
            [31.860332724539433, 3.421490124328463],
            [31.848947689529222, 3.415796057500339],
            [31.841852345359296, 3.411210612857041],
            [31.83649844555475, 3.407323733010839],
            [31.83064052799374, 3.402061357101146],
            [31.82512141543205, 3.395560195489197],
            [31.817341040280954, 3.379059150532754],
            [31.817070334766704, 3.37863780363231],
            [31.81573405215403, 3.378499307157252],
            [31.815718686471076, 3.37747097635474],
            [31.81321051384104, 3.374106547635705],
            [31.812081788771362, 3.371857112581778],
            [31.809333668044083, 3.370733196153044],
            [31.808603254174756, 3.369380807596094],
            [31.80806723842788, 3.369166304687689],
            [31.80554703376291, 3.369625103588674],
            [31.803070738749003, 3.368980517871043],
            [31.801871814831483, 3.367909821948972],
            [31.79896391345957, 3.366746394883102],
            [31.798153571089532, 3.36735429724652],
            [31.796708482733, 3.367137890957311],
            [31.796523216883738, 3.366341826504766],
            [31.798209715794798, 3.364361585703339],
            [31.798956806887336, 3.36265625879165],
            [31.80016966906482, 3.361444510191718],
            [31.800805280128927, 3.360291794510236],
            [31.800873206239153, 3.358187035298861],
            [31.804410803269054, 3.352094374623375],
            [31.80208948470967, 3.351644841964869],
            [31.80045414485405, 3.350176361195982],
            [31.79856863586992, 3.349565990061327],
            [31.795651250085218, 3.348775506302629],
            [31.794967215335706, 3.349232588484329],
            [31.792725814497263, 3.345222717531769],
            [31.786985142352187, 3.338775886593588],
            [31.789668053474696, 3.339162385292067],
            [31.79447706127904, 3.342097996582321],
            [31.797803825508396, 3.340699059135897],
            [31.804736924056524, 3.334217299730888],
            [31.805809041788574, 3.334102137836459],
            [31.8069109395706, 3.333317304884846],
            [31.808419709497613, 3.331484729392106],
            [31.80862437266879, 3.329941743826476],
            [31.80905892190768, 3.329971388399453],
            [31.80921896845366, 3.329389229661468],
            [31.810783034178, 3.329755098503818],
            [31.813188082010054, 3.329466835062753],
            [31.814969129503076, 3.330095020141641],
            [31.81669409696953, 3.329165336573749],
            [31.816823828967923, 3.329704171095803],
            [31.817910065521243, 3.329894746199636],
            [31.81834411260193, 3.330346595385187],
            [31.818822521186277, 3.330041435537344],
            [31.8190970122011, 3.330667797956347],
            [31.82016852177368, 3.331062178208388],
            [31.82089297082951, 3.33094657830747],
            [31.821341540075075, 3.331369325939396],
            [31.821109102791933, 3.331922284701163],
            [31.822611831548667, 3.332106077799798],
            [31.822799489611526, 3.332663181139132],
            [31.823324962730233, 3.332372634409324],
            [31.82336786716651, 3.332838570224739],
            [31.82408472994975, 3.333014138638264],
            [31.823974970195096, 3.333949416364653],
            [31.82463405244094, 3.333986604655493],
            [31.825370128391498, 3.336280517193738],
            [31.825950272080064, 3.335698856321939],
            [31.827095825289934, 3.33626984804987],
            [31.82734101056528, 3.337447695902552],
            [31.82887249259764, 3.336210340465116],
            [31.83000732082133, 3.336709183156555],
            [31.830205411917873, 3.336157663748315],
            [31.83161310430745, 3.336583483345277],
            [31.83470574960747, 3.321429798174608],
            [31.833765721951423, 3.315975216123281],
            [31.834973799701704, 3.308050091090322],
            [31.83428094708938, 3.307034673274327],
            [31.829361308164525, 3.305570369761391],
            [31.825876546446377, 3.303694872009569],
            [31.82448902572653, 3.300617150415593],
            [31.823301572396844, 3.300502832106419],
            [31.822805078030903, 3.299647378822233],
            [31.818505853370496, 3.298158345162056],
            [31.81501015286716, 3.295750879114275],
            [31.8131325948716, 3.295667985155962],
            [31.81086518690736, 3.294935046395104],
            [31.811052313167565, 3.293420238811288],
            [31.81305519333176, 3.291959388673068],
            [31.823052220735228, 3.27666634039549],
            [31.828625905950457, 3.271366261037045],
            [31.82731822300148, 3.26947520673048],
            [31.825374689138194, 3.268034098132792],
            [31.826094634041183, 3.267179617923834],
            [31.82797332211735, 3.266417328393706],
            [31.834969308125284, 3.259736167628952],
            [31.839091855728853, 3.257185522535228],
            [31.84422002866544, 3.255924392699258],
            [31.846405830974323, 3.254163237542488],
            [31.84755523166856, 3.254563081307989],
            [31.84924587091474, 3.254083419982109],
            [31.85232451058114, 3.247133258099006],
            [31.854631053650735, 3.244232354844179],
            [31.859842609110306, 3.237973673727745],
            [31.860961706935058, 3.237687833175005],
            [31.86623343873889, 3.233258488499641],
            [31.86408393016411, 3.229242645949709],
            [31.86439914270909, 3.228170502612427],
            [31.863640674453478, 3.226641694439756],
            [31.861609970769955, 3.225047149814584],
            [31.860065420945183, 3.219107038849534],
            [31.85930556479242, 3.218833336090666],
            [31.85898087591949, 3.217850713826032],
            [31.857733016276846, 3.216976193940746],
            [31.854441380666692, 3.213071854705097],
            [31.852303419934888, 3.211779206593893],
            [31.848758278853264, 3.204390323745843],
            [31.84825254980616, 3.201965621311731],
            [31.84690222742392, 3.199630418075063],
            [31.846802871956843, 3.19794788771333],
            [31.84824703954023, 3.195317346949123],
            [31.850823856932706, 3.193764462005965],
            [31.853280516571125, 3.193004504953397],
            [31.85346816475251, 3.192253604450566],
            [31.86500409247594, 3.186400447545584],
            [31.868082936059913, 3.186537745453631],
            [31.86878949426852, 3.185883685917583],
            [31.86868245371421, 3.184464748336455],
            [31.871014056186972, 3.179633664871952],
            [31.870969999212193, 3.177918864198293],
            [31.871848774342244, 3.17728814011691],
            [31.8721714545822, 3.175889602269839],
            [31.8711036236107, 3.172753114098882],
            [31.863464972967055, 3.162076197374176],
            [31.851237991058493, 3.149472218691451],
            [31.844554651108773, 3.143741872512808],
            [31.8341774467956, 3.131998334661144],
            [31.82877177977619, 3.129416974550665],
            [31.82721077281539, 3.125266129692156],
            [31.827140382626364, 3.123769170729879],
            [31.828392949441096, 3.121032511882318],
            [31.82867655925439, 3.119340921941086],
            [31.828445948246216, 3.116905437208624],
            [31.827457716093726, 3.113579323933867],
            [31.825398510662897, 3.099385091721916],
            [31.822928202920373, 3.091567282348807],
            [31.822660499575814, 3.089287593542628],
            [31.82120209998338, 3.086391505483269],
            [31.821678509816223, 3.085804098632722],
            [31.821110990152338, 3.082827597119238],
            [31.82030236086957, 3.081506098149846],
            [31.820849375588775, 3.07782531331867],
            [31.820446276367957, 3.074143471638715],
            [31.818147325859137, 3.066497731468544],
            [31.815581701475093, 3.054618558047059],
            [31.814313664772847, 3.035043385309454],
            [31.813099116457575, 3.028764693479983],
            [31.812833435220714, 3.023581515092887],
            [31.8131808954878, 3.01587540462626],
            [31.8118311291627, 3.009044816407982],
            [31.811989334162327, 2.988304397250882],
            [31.81139265877758, 2.975278691923751],
            [31.810338982560012, 2.972785123797168],
            [31.810206473869062, 2.969503169070061],
            [31.813367744168577, 2.964114401162405],
            [31.813181698581644, 2.958037788367925],
            [31.815749075578825, 2.955398075439251],
            [31.817524660416595, 2.950712748776555],
            [31.818412216578547, 2.950854375984179],
            [31.822766301353326, 2.95402151853556],
            [31.8243539011415, 2.954616818673428],
            [31.826991075439622, 2.9543228185827],
            [31.827786060211547, 2.953494655035354],
            [31.829527643815815, 2.952882422902415],
            [31.831879387415558, 2.952936084285449],
            [31.83412807359096, 2.954187088596762],
            [31.836243612373277, 2.956205549982957],
            [31.83790265607427, 2.956647389494109],
            [31.843758593748383, 2.954862466560394],
            [31.850315506601632, 2.954541801401829],
            [31.853900363998637, 2.953440174606819],
            [31.85637586490181, 2.951968935581359],
            [31.856733886661672, 2.950321512806982],
            [31.85886921263475, 2.952954050060315],
            [31.8582988866339, 2.953137685633132],
            [31.8590823559022, 2.953599059401947],
            [31.85920367158468, 2.954438434196056],
            [31.860434315014917, 2.955678111568195],
            [31.8611775226905, 2.955689112056938],
            [31.86174624340194, 2.957081626641732],
            [31.86123678095653, 2.957480256974077],
            [31.86165364146918, 2.958033364677265],
            [31.862254473358764, 2.957890698625157],
            [31.862324518594708, 2.95908823722162],
            [31.862864367452904, 2.958843159940231],
            [31.86465490834185, 2.960155055664618],
            [31.865419327037937, 2.95933706081075],
            [31.867099088584325, 2.959461604909157],
            [31.867271491457046, 2.960127043196779],
            [31.868197798245383, 2.960301986317257],
            [31.8680037423811, 2.960905639719922],
            [31.86855197611417, 2.962431186296975],
            [31.872957281928116, 2.965536847177204],
            [31.875152952230412, 2.968866840451316],
            [31.87709640434699, 2.969409020160334],
            [31.879166973466173, 2.9692840295241],
            [31.88208713774006, 2.970697339913975],
            [31.883132102095978, 2.971178745061211],
            [31.884284568740306, 2.97246684923824],
            [31.885482589850984, 2.975573577269489],
            [31.890113384479353, 2.975578273609623],
            [31.891640445902198, 2.980749481881693],
            [31.89805811090324, 2.989466049615696],
            [31.90187248516038, 2.992506693909712],
            [31.902033907925375, 2.99587494619288],
            [31.902658656561083, 2.997353280000698],
            [31.902372559312756, 3.00052711575111],
            [31.903263597344754, 3.00206022002532],
            [31.901051213886625, 3.00361779631784],
            [31.900995401558028, 3.004501173351862],
            [31.899964115848917, 3.005894295385307],
            [31.900031958415806, 3.006708778525848],
            [31.90070325595288, 3.008269269965208],
            [31.902076376678757, 3.008339677978146],
            [31.904091721865836, 3.011585574296776],
            [31.903293402547583, 3.013448258505389],
            [31.903387519039885, 3.015449882448755],
            [31.905444811059166, 3.018053129588496],
            [31.907037029984515, 3.018656022796554],
            [31.90747511678901, 3.01999542107058],
            [31.90906675450437, 3.021280770325433],
            [31.908804725817447, 3.022398603605776],
            [31.909600940382997, 3.022647873921772],
            [31.910700157592217, 3.022000210364056],
            [31.911167821427444, 3.022642572264517],
            [31.912152129738747, 3.023047224094257],
            [31.91230896301097, 3.023349248857517],
            [31.911305775705635, 3.02510872369265],
            [31.911612758784308, 3.02655192833442],
            [31.91348141627202, 3.027791156385983],
            [31.915193101248665, 3.030203901337312],
            [31.916049677211443, 3.030677395128882],
            [31.91607793371868, 3.032185059397351],
            [31.915660459656713, 3.03304016309156],
            [31.91671085073526, 3.036116320269109],
            [31.91630534941938, 3.036899643999815],
            [31.917108251043917, 3.037486756522924],
            [31.91767228973609, 3.038869324563819],
            [31.91800872318304, 3.041693491969513],
            [31.9201860013782, 3.042772569587699],
            [31.92072074600895, 3.043694442052757],
            [31.9208675846253, 3.045656912305737],
            [31.92020387246245, 3.048725363773706],
            [31.922849393906205, 3.051779203553848],
            [31.923341524256518, 3.053658264863955],
            [31.923853356457638, 3.059653441964565],
            [31.92492067718605, 3.06368087368996],
            [31.927191224762183, 3.066776219469129],
            [31.926951057476057, 3.068869922938341],
            [31.9264562690108, 3.069647174138341],
            [31.92513433159488, 3.070250090503072],
            [31.925085949232006, 3.071015827380377],
            [31.92712547886318, 3.073010127852365],
            [31.927094085438952, 3.074643373237749],
            [31.928623332462866, 3.07505772384129],
            [31.929646862117803, 3.081226925982337],
            [31.93086526330733, 3.082993055161444],
            [31.93061442673054, 3.085841496888114],
            [31.930950696684118, 3.086840021388616],
            [31.93938353978562, 3.096463348229682],
            [31.946648743697676, 3.107249129155175],
            [31.953479339980337, 3.114645847157127],
            [31.955970632367915, 3.118592162233689],
            [31.957505911578977, 3.122405966653788],
            [31.959729962356008, 3.124102959553615],
            [31.95982407974664, 3.126745588272741],
            [31.961176741341927, 3.131654120133809],
            [31.960924056032276, 3.136784682750779],
            [31.963266963802873, 3.146383371676177],
            [31.96387614463471, 3.146738160106512],
            [31.964866945070572, 3.146423258639988],
            [31.966370130171498, 3.148042498196308],
            [31.96599799677683, 3.148750487085624],
            [31.96494025119104, 3.149342922119702],
            [31.9643765673334, 3.151132402288253],
            [31.96593552793197, 3.154139701159303],
            [31.966951509941897, 3.157261328469449],
            [31.966597738111638, 3.158658549639839],
            [31.969024839583962, 3.166159268785532],
            [31.969055700307212, 3.167272957881581],
            [31.968553880728273, 3.168353989013215],
            [31.968924793312457, 3.170356803304764],
            [31.968719144689395, 3.17360119676012],
            [31.97080983876588, 3.181870064640616],
            [31.972065258629957, 3.183681019385508],
            [31.975812694923718, 3.186629544068236],
            [31.976642501090996, 3.18788324084246],
            [31.979784161167842, 3.189310577887172],
            [31.980708998312398, 3.191442448175392],
            [31.985258838564008, 3.195889519029043],
            [31.987087112288137, 3.195464399449237],
            [31.989877634395146, 3.196463035269512],
            [31.990441121521734, 3.19769504964139],
            [31.991602221874228, 3.197953196561473],
            [31.99429572682888, 3.200118936124723],
            [31.993951577751957, 3.203395345183596],
            [31.997232052693015, 3.205849480800222],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 767,
        District: "ADJUMANI",
        County: "EAST MOYO",
        Subcounty: "PAKELE",
        Population: 49468,
        Key: "ADJUMANIPAKELE",
        Dist2: "Adjumani",
        "Sub Country": "Pakele",
        id2_original: "AdjumaniPakele",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.4784061041693, 3.189050698627758],
            [31.475040947741327, 3.189125182795443],
            [31.46865258847979, 3.188354741746295],
            [31.466512982034374, 3.187480310578823],
            [31.463988915511987, 3.185149727661501],
            [31.462392095415776, 3.184932081886202],
            [31.460142042902824, 3.185057790788071],
            [31.45702571891025, 3.186776225587122],
            [31.454998145855505, 3.18712964671821],
            [31.45380897045545, 3.186165408832681],
            [31.452911689132225, 3.185955371005805],
            [31.45252248774717, 3.184949776476817],
            [31.450680603648156, 3.184278834844056],
            [31.44797612577233, 3.184850177131142],
            [31.439956966740635, 3.182359535599946],
            [31.42913656420898, 3.182516844552089],
            [31.42774545561789, 3.181750651802057],
            [31.42599985474767, 3.181431200079818],
            [31.412470435153054, 3.181234888816238],
            [31.4110602616167, 3.180556169264797],
            [31.410279198036697, 3.180727241904813],
            [31.409944317776898, 3.181935343234577],
            [31.408494833065358, 3.183174693061998],
            [31.40882676325779, 3.184046185064397],
            [31.406530897563663, 3.18405095223951],
            [31.405619140787945, 3.181007856726224],
            [31.40214663837848, 3.180081385607348],
            [31.401148225618883, 3.177959228911909],
            [31.398270866966623, 3.178083266779714],
            [31.396300327050938, 3.177419682714615],
            [31.397402794364854, 3.177104690106623],
            [31.39783827156345, 3.176574897631066],
            [31.398707635044282, 3.176545048529923],
            [31.40130659860347, 3.174302847492108],
            [31.40372444293677, 3.173130515189164],
            [31.406508372307915, 3.169233109454638],
            [31.40634216152246, 3.166784388377668],
            [31.406852740573754, 3.166329649574257],
            [31.40787215684302, 3.166558989137793],
            [31.408578715949957, 3.167613489447194],
            [31.409825923415703, 3.167074475118905],
            [31.410873842330606, 3.167189973600013],
            [31.412350832557838, 3.164572955627495],
            [31.412861148402754, 3.164289034687338],
            [31.413515699546302, 3.162297099397788],
            [31.415726095931053, 3.161702610561799],
            [31.418904606697463, 3.157806999689153],
            [31.4193855997349, 3.158177853997337],
            [31.419924455056364, 3.157751619224615],
            [31.42006716501569, 3.157040068387159],
            [31.41964325452469, 3.156384594534813],
            [31.419419484187408, 3.154505186711947],
            [31.420582941719193, 3.153140369643857],
            [31.42347405896837, 3.151949005112762],
            [31.423816079936365, 3.15055445862159],
            [31.42342126587742, 3.149386557359938],
            [31.423564185144198, 3.148532652474338],
            [31.426495602613628, 3.147186912202024],
            [31.426681603284774, 3.14519030595038],
            [31.427188091408254, 3.144544952241677],
            [31.428388785006927, 3.144407835336654],
            [31.427758767752078, 3.142548488033817],
            [31.42814275351858, 3.139298343127884],
            [31.427435459589752, 3.135285284340766],
            [31.42849522728324, 3.134295499167963],
            [31.428771917373926, 3.133293019105938],
            [31.429858433303316, 3.132958544333479],
            [31.430214505719007, 3.132361608858394],
            [31.43190638553857, 3.13303090042447],
            [31.432508057352944, 3.132837189307432],
            [31.432968251696614, 3.131840863778707],
            [31.435982874720892, 3.130271536399062],
            [31.43828222228507, 3.13019643357985],
            [31.43892563162418, 3.129613995242996],
            [31.441025970911877, 3.130626817357164],
            [31.441828541058054, 3.130335143582532],
            [31.44429460426086, 3.12865969088801],
            [31.444455003844762, 3.127660088316807],
            [31.44490835122928, 3.127314547528702],
            [31.44565201165577, 3.127873372429701],
            [31.44625873200203, 3.127722209367637],
            [31.44874705905083, 3.123400966439828],
            [31.449243538145456, 3.123706769587036],
            [31.454143582118988, 3.123409543370553],
            [31.45606746443713, 3.125783610344479],
            [31.457198196343118, 3.125170056035014],
            [31.45874338217514, 3.125537307112787],
            [31.459333489078542, 3.126444934666098],
            [31.460376413360446, 3.127057067417265],
            [31.460763514484384, 3.128262896286093],
            [31.462603244423303, 3.129134021736311],
            [31.46400327148857, 3.129049092463492],
            [31.465689956350857, 3.130218953931587],
            [31.466992681497786, 3.129882622335426],
            [31.467600121394586, 3.129138198953235],
            [31.46840006396859, 3.129096816070855],
            [31.469156344826505, 3.128454144254532],
            [31.469903177204248, 3.128712583787529],
            [31.470556378179953, 3.128369195193109],
            [31.47478846365433, 3.125060559969121],
            [31.475870878774433, 3.126674465989483],
            [31.47501362997353, 3.127416198394941],
            [31.47495684476947, 3.128066465550565],
            [31.47806508751776, 3.127098800201425],
            [31.480109933378788, 3.127471453098592],
            [31.481449431061872, 3.126008964583189],
            [31.48200432310783, 3.126703420440177],
            [31.482503962475572, 3.126708835496408],
            [31.482835879193285, 3.124834877232213],
            [31.48436688691518, 3.121784790506471],
            [31.484733103107033, 3.12260236346666],
            [31.48548386202092, 3.122485327105514],
            [31.487592272671435, 3.123947630371467],
            [31.4882213978992, 3.12351634866645],
            [31.48952247194263, 3.124531806614294],
            [31.492463092652155, 3.124062973967841],
            [31.495020474095163, 3.124403586921903],
            [31.50099834100111, 3.123305681058185],
            [31.511642249732265, 3.119711028363109],
            [31.515117876482268, 3.122480712135078],
            [31.516142066398942, 3.123929217158279],
            [31.520931241198436, 3.13320619845546],
            [31.523065119985592, 3.140109870318437],
            [31.524351743729383, 3.142897280666585],
            [31.52637589510121, 3.144464785299149],
            [31.530244565330747, 3.14618865485081],
            [31.535147960918614, 3.146295075715639],
            [31.53674291162074, 3.146776666634042],
            [31.539060922583243, 3.150743826074021],
            [31.500632712307425, 3.171404976320718],
            [31.49861675536762, 3.172009408434204],
            [31.496541212276707, 3.170858000037299],
            [31.495398752864673, 3.170856330831958],
            [31.493734725310482, 3.172419864675984],
            [31.491241177253258, 3.173042597321089],
            [31.490201516550737, 3.173771855270782],
            [31.489393031896732, 3.176759103851632],
            [31.488352507913234, 3.178131121779985],
            [31.483263022721008, 3.182354134287522],
            [31.47902482421112, 3.187515977719035],
            [31.4784061041693, 3.189050698627758],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 768,
        District: "ARUA",
        County: "MADI OKOLLO",
        Subcounty: "EWANGA",
        Population: 8310,
        Key: "ARUAEWANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.72410072971799, 2.244805378469394],
              [32.72284949779978, 2.246525456696395],
              [32.71548599573776, 2.253130896077205],
              [32.71044261478083, 2.250884832605033],
              [32.699330134916046, 2.24226154123207],
              [32.693439750444035, 2.236985351957718],
              [32.693161309536904, 2.236985293611737],
              [32.688773762517776, 2.246962939236325],
              [32.687137937571926, 2.246857550027746],
              [32.67993391252396, 2.243809890351539],
              [32.67561831157593, 2.242723545530185],
              [32.67464363679774, 2.243318539385528],
              [32.67248171440403, 2.246220487723248],
              [32.66433337673616, 2.254466963612793],
              [32.661788180041675, 2.258687064788333],
              [32.66147481443289, 2.262638280362395],
              [32.660211006100724, 2.263775241155124],
              [32.658279600392085, 2.26434188155745],
              [32.65658881022893, 2.268475223218379],
              [32.65367679008143, 2.270249655147904],
              [32.65453552020422, 2.274262706776005],
              [32.6544618969785, 2.27487595312427],
              [32.64988054652168, 2.267215111948258],
              [32.647705638980554, 2.264355135723628],
              [32.643236518645395, 2.25959209797905],
              [32.64178666921788, 2.257533924034571],
              [32.64047881199573, 2.257054836467661],
              [32.639694314156415, 2.256288890435407],
              [32.637446725722306, 2.256467294861611],
              [32.63678104355406, 2.255916725050431],
              [32.63509226831209, 2.256298742699736],
              [32.63416398882335, 2.257925194801196],
              [32.633759618486415, 2.258044627336498],
              [32.632237642426375, 2.257732907994813],
              [32.630906151427425, 2.256918849971691],
              [32.62779006459008, 2.257994017851357],
              [32.626839095453924, 2.257227988835461],
              [32.624662956322545, 2.257191080567404],
              [32.623046276272, 2.255946252229383],
              [32.622452285951645, 2.254677971610367],
              [32.62166769109429, 2.254151257173158],
              [32.61824288203989, 2.254245352896065],
              [32.61633990172178, 2.254962190336108],
              [32.612690167096666, 2.252914905161697],
              [32.61085890827085, 2.252842265186908],
              [32.609955606438575, 2.251884850681961],
              [32.608885542255294, 2.251525473486181],
              [32.60767316876133, 2.250328664006676],
              [32.606936895181406, 2.248222955863781],
              [32.605771723664056, 2.247815684137116],
              [32.60528174567716, 2.246954416290859],
              [32.600321917024836, 2.242567301840734],
              [32.587114591070296, 2.233323326494266],
              [32.58420212266344, 2.228695340984818],
              [32.58082605439972, 2.222118098599486],
              [32.57879328908266, 2.219786155199174],
              [32.57677381613685, 2.218590973300425],
              [32.578471479310224, 2.214542047985903],
              [32.5801356991039, 2.21186461567545],
              [32.59286714882487, 2.210321150293128],
              [32.59404418439222, 2.209109175646166],
              [32.5958629296861, 2.199194155660489],
              [32.5966950400321, 2.198289681378479],
              [32.60603841550558, 2.193813918868823],
              [32.61391965349678, 2.183330482444429],
              [32.61377695611391, 2.181964343542803],
              [32.61440676585793, 2.180806486748411],
              [32.61462078408449, 2.179105700319464],
              [32.61564320521833, 2.177911755138098],
              [32.61661785214879, 2.175586917712973],
              [32.61821062623297, 2.173823153029658],
              [32.62142030045493, 2.172674992889859],
              [32.623975802622375, 2.171228109654505],
              [32.62775603281387, 2.170939546310222],
              [32.632923675927394, 2.171399860015959],
              [32.632289639609965, 2.170223149405375],
              [32.63629356647691, 2.169072144501778],
              [32.64158776334936, 2.169013574119546],
              [32.643372039387486, 2.170210851313286],
              [32.64372858701198, 2.171766844626268],
              [32.64366778005038, 2.177392040326847],
              [32.64444092408281, 2.178110335085825],
              [32.646463364164035, 2.178410028118178],
              [32.65360166846579, 2.17829201195386],
              [32.65794188774417, 2.188167063037583],
              [32.66008268445731, 2.191279375372325],
              [32.661734594636656, 2.194604880032872],
              [32.664958058896545, 2.202471079744174],
              [32.66602748258103, 2.208455599141092],
              [32.66721651335235, 2.211627533885725],
              [32.667751777209325, 2.212166239957583],
              [32.67102347561007, 2.212585874053451],
              [32.67459289995047, 2.211689024439897],
              [32.67625872054201, 2.210851592206984],
              [32.67965010148804, 2.20797987521989],
              [32.6815539145444, 2.206903116024662],
              [32.68357645883019, 2.206963393153077],
              [32.68631255830234, 2.208400206176448],
              [32.687977933329485, 2.209657259456029],
              [32.6887508420033, 2.211692081822522],
              [32.68869074201586, 2.21462437184636],
              [32.68900654385567, 2.215334901139434],
              [32.69193904738829, 2.218134726081419],
              [32.69504221375688, 2.225490667399971],
              [32.69635006199589, 2.227499395232512],
              [32.69822845632298, 2.229408723373512],
              [32.70222304520253, 2.230323299493253],
              [32.70654968105546, 2.229184239121938],
              [32.71070130263322, 2.229319788355018],
              [32.71233213204778, 2.230364234331301],
              [32.71480283055744, 2.233298208929049],
              [32.717569880584385, 2.237326082659234],
              [32.71811329575429, 2.238718353572594],
              [32.721770017475684, 2.242796113300698],
              [32.72410072971799, 2.244805378469394],
            ],
          ],
          [
            [
              [32.810072576443126, 2.324579366885105],
              [32.80924101766274, 2.325743304429392],
              [32.80803889753942, 2.325415398589302],
              [32.80661187969316, 2.326522745148257],
              [32.80546596805547, 2.325957513453208],
              [32.80456739315823, 2.324216965123401],
              [32.803679667214695, 2.325290478511217],
              [32.80127533893316, 2.32530144060192],
              [32.79967979174969, 2.326386153104258],
              [32.79863497022588, 2.326035658140678],
              [32.79770033785144, 2.325099665594963],
              [32.796836054343565, 2.325144775954679],
              [32.7958850681394, 2.326121732001995],
              [32.7939405299596, 2.326989974049166],
              [32.79344313727835, 2.32827459736852],
              [32.79162831043574, 2.328147668773585],
              [32.790871883152434, 2.328690385756305],
              [32.79082850530399, 2.329314632681309],
              [32.790072431058576, 2.329359755472193],
              [32.789467202813995, 2.329974871094389],
              [32.78763068075895, 2.33020981968213],
              [32.78760950926433, 2.330815975368539],
              [32.7871875948299, 2.331042090810552],
              [32.78563163819763, 2.330851862992462],
              [32.784659372701014, 2.331222646369068],
              [32.783449471370695, 2.330634394730418],
              [32.78258517887964, 2.330715685148881],
              [32.78208834225557, 2.330136590333197],
              [32.781634309456464, 2.330851244565315],
              [32.777636850459594, 2.331701046681356],
              [32.775552048433035, 2.330750763165315],
              [32.7750117459256, 2.33133874099593],
              [32.77380148347255, 2.331275215354305],
              [32.77330462798387, 2.330840872222608],
              [32.77267810337884, 2.331012666607125],
              [32.77207308354341, 2.330297842815771],
              [32.77050526106458, 2.329753236164154],
              [32.76945864830009, 2.330035047951406],
              [32.768659396530545, 2.329419709757375],
              [32.76669304186577, 2.329527948974955],
              [32.764478509637485, 2.32791718706733],
              [32.76443540847015, 2.326822475863837],
              [32.763484979221445, 2.326017120521563],
              [32.7617131915624, 2.325736358991633],
              [32.7608271679263, 2.326369507577656],
              [32.75927155175555, 2.325907837154439],
              [32.75829926559767, 2.324740589485759],
              [32.7584510108121, 2.323256884895962],
              [32.75616071287609, 2.322695566227432],
              [32.75597116835116, 2.32205378129658],
              [32.75401316712023, 2.320837104389469],
              [32.75176491572942, 2.321020168190484],
              [32.749390501346824, 2.320621076094822],
              [32.748001969123976, 2.318461652112433],
              [32.744203637879465, 2.317713016394564],
              [32.743516346737074, 2.316876740480662],
              [32.74204313572227, 2.317560915103074],
              [32.74093511681989, 2.315891937669118],
              [32.73752942571139, 2.316194719723019],
              [32.73609532195415, 2.314031750718483],
              [32.73466793490028, 2.313488161042545],
              [32.73387523813737, 2.31369263853284],
              [32.7317956472378, 2.312298660999706],
              [32.73056108086474, 2.312213752258862],
              [32.728348215011266, 2.310833856377892],
              [32.72733459557054, 2.310840716618228],
              [32.72683693069978, 2.30887196271497],
              [32.72561311536405, 2.307615737589848],
              [32.723692137299224, 2.306690850389499],
              [32.724557486209065, 2.303406051975964],
              [32.728440750468714, 2.296358139738973],
              [32.727619013867596, 2.292651643052004],
              [32.72886951635379, 2.290533975053361],
              [32.73028496659416, 2.285934411288252],
              [32.73021993126253, 2.281864042533667],
              [32.730582140069934, 2.280044033788093],
              [32.73196414693059, 2.278290399748596],
              [32.73456331889894, 2.27666935976326],
              [32.735484624766116, 2.275643667483712],
              [32.73597838915191, 2.273956048946229],
              [32.73560481216461, 2.269505931053281],
              [32.73809638302989, 2.263994568682799],
              [32.73799690449365, 2.263192831238575],
              [32.73715032857662, 2.261990098126019],
              [32.735008532038584, 2.261488631779052],
              [32.73326512665093, 2.261538418028895],
              [32.728969518607876, 2.262841126957031],
              [32.72536110289256, 2.264201546804638],
              [32.72247419425049, 2.266197274247667],
              [32.72140911302207, 2.266396590931375],
              [32.71682691186069, 2.264090757901458],
              [32.716628075162426, 2.261986209656451],
              [32.71747543800364, 2.259030040749902],
              [32.719169518695665, 2.256424788126073],
              [32.721120496897726, 2.254659851358683],
              [32.723288833262544, 2.251406793520577],
              [32.72758424008295, 2.24668897790429],
              [32.73501519574135, 2.247919776209838],
              [32.73615185922317, 2.248665786833663],
              [32.73664595778226, 2.249560841994774],
              [32.73679342342269, 2.254085412244996],
              [32.73807811129703, 2.256273336496085],
              [32.73941239066664, 2.257566305606117],
              [32.74302011647581, 2.259804364588849],
              [32.74544187926038, 2.260550598911232],
              [32.74845700264628, 2.259904763907258],
              [32.751373423640366, 2.258363939558246],
              [32.752312676050316, 2.257469135756051],
              [32.75359819756123, 2.254883898152185],
              [32.75849167664668, 2.253194232198578],
              [32.76417578098, 2.252648246197661],
              [32.76674592119498, 2.252797823972243],
              [32.77470327254188, 2.254589018379818],
              [32.777866520033335, 2.254838109672657],
              [32.77707546359412, 2.256379321042529],
              [32.77712474606892, 2.257324016931265],
              [32.77929739614374, 2.258689205605755],
              [32.780837158846374, 2.261610365507518],
              [32.78212420479833, 2.266055446046915],
              [32.78212388589643, 2.268188991104533],
              [32.7828560496839, 2.268646289969213],
              [32.78669393105539, 2.268799260860215],
              [32.78785542846323, 2.268621637077651],
              [32.78947153179537, 2.267631299602372],
              [32.7901787736219, 2.265828049290993],
              [32.793032483226014, 2.262069356658607],
              [32.79358166647832, 2.259981569367692],
              [32.79524970860354, 2.258373259521319],
              [32.79684886881109, 2.257491377835059],
              [32.79880955600471, 2.253305968024997],
              [32.79877406985604, 2.25241798931647],
              [32.80784295611132, 2.250381437028524],
              [32.80997746012593, 2.249503361808118],
              [32.81047893744673, 2.248787480344329],
              [32.81073616463847, 2.254515440475733],
              [32.812449301292624, 2.26011586716043],
              [32.81316900095553, 2.265110002745127],
              [32.81389754273581, 2.266919532748687],
              [32.817084732126176, 2.271144973466829],
              [32.81849194122214, 2.273678362249453],
              [32.81878958451679, 2.278129612619108],
              [32.818176119619366, 2.281956491147895],
              [32.81677679503669, 2.283684322744079],
              [32.81603090499166, 2.287800691892035],
              [32.81660196491608, 2.290415399720535],
              [32.8162538327092, 2.294034225090361],
              [32.817760574240296, 2.296413826462612],
              [32.81753646703481, 2.299426507288596],
              [32.81892712018004, 2.301941800086273],
              [32.818454630595134, 2.306564846169799],
              [32.81432230033811, 2.3120649911848],
              [32.81137426223928, 2.313928316869981],
              [32.809461025855605, 2.318406407861557],
              [32.809642561899786, 2.322839545688587],
              [32.810072576443126, 2.324579366885105],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 769,
        District: "KOLE",
        County: "KOLE",
        Subcounty: "AYER",
        Population: 35513,
        Key: "KOLEAYER",
        Dist2: "Kole",
        "Sub Country": "Ayer TC",
        id2_original: "Kole Ayer TC",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.8801627236797, 2.619005142255602],
            [32.876912788763335, 2.620019126664987],
            [32.87551415678172, 2.619796894111981],
            [32.8742137519832, 2.618859040303429],
            [32.872986805120355, 2.619475844203929],
            [32.87222604436411, 2.620413488461952],
            [32.8723730788132, 2.622313618686769],
            [32.874311501262525, 2.622906063458116],
            [32.87580810800058, 2.624880370319878],
            [32.87563630610081, 2.625225826475886],
            [32.87330523004083, 2.625126880385044],
            [32.86979620842009, 2.626261661331962],
            [32.867317927231134, 2.625940595135898],
            [32.86546555709783, 2.623682457886763],
            [32.86367423197965, 2.624323870766037],
            [32.86080340138456, 2.62360791485342],
            [32.8580309264316, 2.620967177380526],
            [32.856669155919356, 2.620337763389625],
            [32.85492691654494, 2.620954479516314],
            [32.85320905654902, 2.622854401626198],
            [32.85111092532029, 2.624149687035885],
            [32.85074276427582, 2.624939302581807],
            [32.85125769925792, 2.627974620802511],
            [32.850791284979245, 2.629578563700868],
            [32.854569881135255, 2.631651868409626],
            [32.85661816125562, 2.637167383413609],
            [32.85855634654968, 2.639980771326513],
            [32.859034541334985, 2.642584237052963],
            [32.860408457069894, 2.644558546823412],
            [32.85977011872056, 2.647643082052307],
            [32.85780685246374, 2.64944426784069],
            [32.853537203037476, 2.649419088058247],
            [32.85275181317108, 2.650825580026993],
            [32.8521994283231, 2.6531574716235],
            [32.85094800775866, 2.652836526339342],
            [32.850702908721594, 2.650516869563139],
            [32.8492553005907, 2.649258169853605],
            [32.84586899422769, 2.649479842583036],
            [32.844666751933495, 2.648443269693708],
            [32.84324361121601, 2.647850842460572],
            [32.841182470814026, 2.647258331489942],
            [32.83935438483779, 2.647221084011014],
            [32.837906722808, 2.646505266000726],
            [32.83694971429816, 2.646702553546072],
            [32.83589433577312, 2.648454462412031],
            [32.836041354052526, 2.650058479389052],
            [32.8354522739235, 2.651267564496544],
            [32.83513327857284, 2.651292201342368],
            [32.83447088693347, 2.650206331111227],
            [32.831771870814556, 2.648824059858323],
            [32.82863112432436, 2.647787205547679],
            [32.82742864936651, 2.648552015746283],
            [32.825400587628245, 2.651313978321569],
            [32.82444693073274, 2.650809444704062],
            [32.82407895384291, 2.650118452286631],
            [32.82277843765324, 2.650118265636903],
            [32.820373841673764, 2.649056799748579],
            [32.81752798873514, 2.645083421610126],
            [32.812853913276385, 2.642207877034568],
            [32.81064584622317, 2.639863233067524],
            [32.81300225297755, 2.634780171479525],
            [32.81376304247989, 2.633990628567097],
            [32.81406995728659, 2.632719812008753],
            [32.815689689812466, 2.631140739224687],
            [32.81679419989532, 2.629018700206675],
            [32.816623062748846, 2.624724901378484],
            [32.81570332623848, 2.621775885691143],
            [32.81393697248858, 2.619406648387657],
            [32.81212143867181, 2.617728349172435],
            [32.809214538023106, 2.6124100539169],
            [32.80555885385585, 2.609818424606545],
            [32.80476168707608, 2.607905851161085],
            [32.800934564826726, 2.603438750043606],
            [32.797695917241924, 2.601686170537207],
            [32.796837256289415, 2.600822343270778],
            [32.79697301598336, 2.595751276723295],
            [32.79800416784347, 2.59207460692625],
            [32.79753818475614, 2.590643269114147],
            [32.786315675642065, 2.587357104985875],
            [32.78639505706881, 2.579650086340199],
            [32.78739503828687, 2.575892202955282],
            [32.79048066864282, 2.571828777051304],
            [32.79579544771507, 2.566607697834697],
            [32.797221251039055, 2.562517764096367],
            [32.79696676011571, 2.559843717108053],
            [32.79534224406095, 2.555443093176556],
            [32.79449755819932, 2.550926038386083],
            [32.79381097043775, 2.549039450204097],
            [32.79218155586975, 2.546756083957802],
            [32.79125316049836, 2.540570741287529],
            [32.79116856794468, 2.533937354197396],
            [32.794333462946355, 2.527588209355323],
            [32.79669557579943, 2.519788473212577],
            [32.798307762476895, 2.517332079404444],
            [32.79852067397902, 2.502569043481352],
            [32.7995065974612, 2.501726584530025],
            [32.800877107682844, 2.5014037406287],
            [32.80296493972685, 2.501985118241543],
            [32.80579266286643, 2.505817733429779],
            [32.80742708823706, 2.507093623998555],
            [32.808134750475176, 2.50817033852668],
            [32.80828092254158, 2.510106449302578],
            [32.809281409511165, 2.509844229558261],
            [32.81157484975403, 2.510450722238637],
            [32.81334354900512, 2.512477538675844],
            [32.814124449091715, 2.512531934121689],
            [32.81488077845867, 2.513409615558386],
            [32.815661688426744, 2.513409725944866],
            [32.817271852996505, 2.515445562542383],
            [32.8202240799395, 2.517065415151519],
            [32.824225770899666, 2.518024962328872],
            [32.82539722972573, 2.519454570945311],
            [32.827892425293165, 2.508333591806856],
            [32.82978943001802, 2.504830306759328],
            [32.82942223735743, 2.500927710166228],
            [32.83015790457451, 2.49880622063053],
            [32.83100961616001, 2.497200544167783],
            [32.83356848431482, 2.49637874495353],
            [32.835823934804296, 2.494856270293508],
            [32.837369460199476, 2.495157843225102],
            [32.8386468223127, 2.495919381251023],
            [32.84460249364459, 2.496386736859381],
            [32.84893395255231, 2.497584112276565],
            [32.85210219108348, 2.500000091951661],
            [32.852704710907474, 2.501066085872907],
            [32.855904843224494, 2.501881564938947],
            [32.85795153961497, 2.5037419350982],
            [32.8585956262838, 2.504807931361697],
            [32.863322917041714, 2.507933064946883],
            [32.86440275579358, 2.508204565653207],
            [32.86529753441042, 2.51071977237566],
            [32.86528083113607, 2.511868761125739],
            [32.864895792544026, 2.513868145676905],
            [32.863574185708146, 2.515125563353924],
            [32.86308886728262, 2.516355927114462],
            [32.8640840038864, 2.51887114505232],
            [32.865983903881364, 2.52004033352763],
            [32.866767548321164, 2.522592599843645],
            [32.86629868164175, 2.523958052364358],
            [32.866500589679966, 2.525234166598552],
            [32.86503764371389, 2.527079065668718],
            [32.86468957169415, 2.532532902348021],
            [32.86619232111211, 2.536629561644951],
            [32.86749324334027, 2.538734842950154],
            [32.86744460944911, 2.5401409770336],
            [32.86999832486747, 2.540897140969389],
            [32.873804876595116, 2.539775859214987],
            [32.87456445965999, 2.540686267744449],
            [32.87658476893737, 2.541694333237908],
            [32.87744941626294, 2.542604750286201],
            [32.878717947936885, 2.545652863563477],
            [32.87947482347955, 2.546532841541007],
            [32.881845956316376, 2.547991157000879],
            [32.886201402937125, 2.549451730528022],
            [32.889854596974416, 2.552468157505108],
            [32.89479332150577, 2.552372824147046],
            [32.8967914118529, 2.555337609298786],
            [32.89818471412994, 2.556572960375532],
            [32.90191269740618, 2.558480309173458],
            [32.90502138122728, 2.551327697082639],
            [32.911300017565075, 2.55141124912595],
            [32.91724814574354, 2.552491714885635],
            [32.925839647493895, 2.557975989644653],
            [32.935918367689304, 2.562546342340347],
            [32.93951991488598, 2.563812713733379],
            [32.93895905173831, 2.564957099116441],
            [32.93890985101022, 2.567523507727088],
            [32.93827185761398, 2.568337809695097],
            [32.93834540538123, 2.569621013493127],
            [32.93905695462958, 2.569966532326762],
            [32.940185650054815, 2.569843195636986],
            [32.94254121418948, 2.569053641673678],
            [32.94688418590587, 2.570016235476593],
            [32.94789011846271, 2.57189172680381],
            [32.948687401125134, 2.576000474279954],
            [32.95023315828567, 2.577629211353257],
            [32.95214701450691, 2.578196853961941],
            [32.9530179617176, 2.581343206564636],
            [32.955152635513784, 2.58257713343347],
            [32.95547157337223, 2.583909695246931],
            [32.9552751989562, 2.586204644279772],
            [32.959924747712776, 2.593496845327598],
            [32.96036636669296, 2.595174895072645],
            [32.960047356070945, 2.595890516298954],
            [32.958010709133525, 2.597371063864703],
            [32.95717644372915, 2.597371036045536],
            [32.95386396540777, 2.595742232791078],
            [32.95285793852781, 2.595668165514277],
            [32.951704650823366, 2.5966058454673],
            [32.951680090883485, 2.59737083592702],
            [32.95458754938596, 2.603157685372243],
            [32.9546366036887, 2.603675903667629],
            [32.95367959877211, 2.605057780688703],
            [32.949925390079436, 2.604416035799125],
            [32.94938558793363, 2.603996507125486],
            [32.94904211888137, 2.602688613249761],
            [32.94788888148257, 2.602170348781614],
            [32.94474821224749, 2.599505102468731],
            [32.94361956083967, 2.597851698168795],
            [32.94078562225668, 2.595346859075881],
            [32.937129602119484, 2.594705081428201],
            [32.93433247020863, 2.592484014243677],
            [32.93190333315388, 2.591644862677893],
            [32.93005075640808, 2.592027256714412],
            [32.929290039669304, 2.593063650179313],
            [32.93059040494195, 2.595062552112635],
            [32.93122815669142, 2.599035577600011],
            [32.93266351719172, 2.600429896638423],
            [32.934479086042764, 2.604254921549397],
            [32.93693271746037, 2.606550001456584],
            [32.93855216881352, 2.606920237683966],
            [32.94035557088239, 2.609153587967694],
            [32.940232839455014, 2.610140667813577],
            [32.938048927201486, 2.611473111709442],
            [32.93721465011902, 2.6115470999849],
            [32.933166037456594, 2.609819505056324],
            [32.929105260706905, 2.606549582377377],
            [32.92608714233785, 2.606697469764827],
            [32.9234862069766, 2.606055714044985],
            [32.92046806614962, 2.60672180507169],
            [32.91970742666595, 2.606277570333486],
            [32.91747485536841, 2.601070589124578],
            [32.918787905751216, 2.596394395442472],
            [32.916260652904526, 2.595061678948229],
            [32.913905125600806, 2.594370560610628],
            [32.91277632866593, 2.595629011333093],
            [32.908886986405086, 2.598182799001906],
            [32.90736548375721, 2.600798439494558],
            [32.905157048394756, 2.60181002820668],
            [32.90437185525939, 2.601785297953655],
            [32.902114559630306, 2.600008378918242],
            [32.901133232827405, 2.597910761820538],
            [32.89995548130281, 2.597367780305919],
            [32.89746493182199, 2.597602012264708],
            [32.89569818461, 2.598292817439841],
            [32.89400502828439, 2.59932910974601],
            [32.89319512249561, 2.601377220889836],
            [32.889906999298205, 2.602758844675837],
            [32.88826301315798, 2.602561286361872],
            [32.885735753124756, 2.601549305195878],
            [32.88502415806236, 2.60169730175444],
            [32.8840671208064, 2.602634936845836],
            [32.88411614995632, 2.603103797204644],
            [32.88490126044665, 2.604041592779459],
            [32.88519556290676, 2.60567030186039],
            [32.88590706274776, 2.606608090139781],
            [32.889857639568284, 2.606065546705779],
            [32.89118261778141, 2.606509848822729],
            [32.89022546104959, 2.608854068071164],
            [32.88979565940695, 2.613382242756262],
            [32.88996737417012, 2.613875803100543],
            [32.891905736432314, 2.615134490086578],
            [32.892199917619884, 2.618293159579815],
            [32.89151281871694, 2.618860667248049],
            [32.890482247168485, 2.61868784497603],
            [32.888875156633624, 2.617293453752648],
            [32.8877221303389, 2.614554212806871],
            [32.886838813326754, 2.614109947634268],
            [32.884041320293136, 2.616379970880019],
            [32.884826435275045, 2.617342446114016],
            [32.88622502144258, 2.6180582045978],
            [32.88580763721212, 2.62067391232144],
            [32.88475251111367, 2.620747846211506],
            [32.882397043098756, 2.619118953878765],
            [32.8801627236797, 2.619005142255602],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 770,
        District: "LIRA",
        County: "ERUTE",
        Subcounty: "AROMO",
        Population: 32410,
        Key: "LIRAAROMO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86979152017307, 1.785580914523522],
            [33.8730845472736, 1.788039488102724],
            [33.896894393879194, 1.800250867732932],
            [33.89898697801104, 1.801703034878459],
            [33.90261224162951, 1.803259367305208],
            [33.908862270218776, 1.804225068878172],
            [33.91571711742085, 1.804317871814589],
            [33.92141826099847, 1.803231098752889],
            [33.93535197367488, 1.801995263192463],
            [33.94646483532367, 1.806305250063677],
            [33.94853313619678, 1.807255938556203],
            [33.94983042923119, 1.809270879916976],
            [33.95357275500926, 1.819291825006535],
            [33.95689350411949, 1.824430466851406],
            [33.96022435837833, 1.828124455343382],
            [33.962697672782106, 1.830005466995289],
            [33.96715577348363, 1.832538824735318],
            [33.973502932412984, 1.835199351907483],
            [33.977828600780384, 1.836288351236969],
            [33.97956347217284, 1.836618803665964],
            [33.98100049635307, 1.836269481937877],
            [33.983710179965975, 1.837075376631889],
            [33.98803430502773, 1.836970369062022],
            [33.99339472031302, 1.839000219224311],
            [33.99705486371736, 1.839947312508483],
            [34.00040136932336, 1.839295598341311],
            [34.00149471694051, 1.83957589708198],
            [34.00298900872011, 1.840607163668343],
            [34.00479532402542, 1.841044235175632],
            [34.017204075540164, 1.846163595240439],
            [34.020785687324015, 1.848610092000012],
            [34.02453832935485, 1.850080457157804],
            [34.029613950847306, 1.85102074155884],
            [34.03113357691454, 1.851718536078317],
            [34.03215169152494, 1.852819169459415],
            [34.031516343667214, 1.857402594515426],
            [34.02930255793891, 1.860215928587955],
            [34.02790645022324, 1.863735745327618],
            [34.0271669534881, 1.864161308004577],
            [34.02523894430956, 1.864319341280258],
            [34.0247279574231, 1.866794922632861],
            [34.02398397000987, 1.868197233603648],
            [34.02474101174083, 1.871762628276652],
            [34.02396881093946, 1.874117832714979],
            [34.02267706140866, 1.875636856252849],
            [34.02264891898742, 1.876589752344265],
            [34.0245459785095, 1.879078853885952],
            [34.026996905998075, 1.880576409554177],
            [34.02713579362581, 1.881434749676705],
            [34.02567013564594, 1.884549238266051],
            [34.02578368898603, 1.885741106391553],
            [34.0250621594549, 1.887429444777392],
            [34.024558400413234, 1.890941421721582],
            [34.022791947848646, 1.892196203276316],
            [34.02377223440244, 1.89637010438531],
            [34.02114452205921, 1.901254396243341],
            [34.02178092184414, 1.902591517478389],
            [34.02263663722087, 1.902786022102301],
            [34.023062285053626, 1.903359784623208],
            [34.0239066304538, 1.908664768350287],
            [34.02556970759043, 1.909220292461381],
            [34.025295650461864, 1.911935134188483],
            [34.026439389074866, 1.911582951782528],
            [34.02715067152357, 1.912134125933678],
            [34.02666214251923, 1.914919524918812],
            [34.02757210805427, 1.916269751674818],
            [34.02768573056468, 1.917437750209329],
            [34.026168069112956, 1.924933975360289],
            [34.0266174378591, 1.928140621485696],
            [34.027564458001315, 1.929193158522978],
            [34.02779809094209, 1.930147288234629],
            [34.030502510427446, 1.931946335300553],
            [34.031708428627766, 1.93361954787993],
            [34.03146441026398, 1.934952715931651],
            [34.032134707976184, 1.936683089507737],
            [34.03186921358889, 1.937515800798965],
            [34.03224622483556, 1.938327539940801],
            [34.031813068883636, 1.939397746560331],
            [34.03316545379781, 1.948135920437679],
            [34.03242778333763, 1.953398049372214],
            [34.03156378639229, 1.955014286540971],
            [34.03179931298171, 1.955563343060412],
            [34.030735300748475, 1.956690281849863],
            [34.030536408354685, 1.957791689402282],
            [34.02954580464986, 1.95732827481047],
            [34.01934466294584, 1.956457697275387],
            [34.01134895533294, 1.957132935195276],
            [34.00978364095037, 1.957870456187824],
            [34.00966180693996, 1.958608748955603],
            [34.0081519356784, 1.959503452581733],
            [34.00380163281097, 1.964734965426593],
            [34.001137426409294, 1.966702941598443],
            [33.99985129134905, 1.970323681267774],
            [33.99963106396723, 1.973452175162227],
            [33.99976728539525, 1.978368158133785],
            [34.0005999814428, 1.982793084550023],
            [33.986101312894284, 1.98906973001291],
            [33.9818938987509, 1.987885228991263],
            [33.97451873026827, 1.983506677399266],
            [33.971025406707156, 1.983275639847973],
            [33.96824434924997, 1.982565484489349],
            [33.95970179130956, 1.982548651160147],
            [33.954115112862056, 1.98048362142653],
            [33.95089521401554, 1.98035940476351],
            [33.94573993711022, 1.981278225395808],
            [33.93641275736298, 1.980904805263636],
            [33.93270671543754, 1.981581575661216],
            [33.92866913947669, 1.983261963110534],
            [33.92162417192955, 1.983719268295863],
            [33.91632298885914, 1.981963833366296],
            [33.91226884976111, 1.979811689609477],
            [33.89761676603007, 1.977730384199795],
            [33.897923737430645, 1.976062545713482],
            [33.897042125420924, 1.974027667999782],
            [33.89613805463077, 1.973241126237932],
            [33.895330062253535, 1.973295835312998],
            [33.89457091576985, 1.974372752987041],
            [33.89433882793135, 1.976562007285655],
            [33.89338401670071, 1.975377497314562],
            [33.89304749971043, 1.972292913124938],
            [33.89190551640549, 1.970963773428373],
            [33.8915941935657, 1.968928537546421],
            [33.89048772156226, 1.967825524908097],
            [33.89043950808264, 1.96701141549487],
            [33.891366105925144, 1.966911396749616],
            [33.89136505309965, 1.965916326350628],
            [33.890532497189284, 1.965364959630473],
            [33.889035399072725, 1.965148648650298],
            [33.888418087589294, 1.96562840348726],
            [33.888110134330084, 1.966632732028821],
            [33.887563986485105, 1.96680485468479],
            [33.8868743192988, 1.966443425726157],
            [33.88679971690937, 1.963530596956262],
            [33.88760623515127, 1.962743138986765],
            [33.88789257314808, 1.963340028012089],
            [33.888628560165394, 1.962977756178347],
            [33.88952869992786, 1.960779085979728],
            [33.89062050423932, 1.959656778944614],
            [33.890535234355944, 1.957829494479144],
            [33.890938353339685, 1.957087484512164],
            [33.89129438083963, 1.956734470248935],
            [33.8945016475766, 1.95627140550375],
            [33.8978008505947, 1.953257278076994],
            [33.89946006677228, 1.949737433436184],
            [33.90133466841222, 1.947655809558471],
            [33.90166430790069, 1.945222218647892],
            [33.90090319680148, 1.944625604193894],
            [33.898978626373825, 1.944753259384054],
            [33.89905105304361, 1.945685005424416],
            [33.89990732986739, 1.946489656126262],
            [33.89978956612353, 1.947014376161132],
            [33.89907821270792, 1.948208866366428],
            [33.89753444351913, 1.948906201454124],
            [33.89551800687893, 1.951639284928028],
            [33.89333138081494, 1.951378083357561],
            [33.892073177970126, 1.952337670808378],
            [33.89067194716241, 1.952772609663373],
            [33.89031500697415, 1.952555665908179],
            [33.89002923042439, 1.951958773940481],
            [33.89033641203072, 1.950475098630014],
            [33.89020229625377, 1.947643675841136],
            [33.88817919231755, 1.945166106295872],
            [33.889198569060945, 1.943157352892842],
            [33.8896466038089, 1.940316589676375],
            [33.889407848674374, 1.939384980731948],
            [33.89041564613375, 1.937656643436454],
            [33.890841082862416, 1.935648162125974],
            [33.89273926527856, 1.933448895125644],
            [33.894161550799915, 1.930336318501715],
            [33.89256879558037, 1.929812434541436],
            [33.891761715891455, 1.930699368565754],
            [33.891025658805525, 1.930754078127499],
            [33.89032230578584, 1.928881872954687],
            [33.88903946933928, 1.929045371550123],
            [33.887564196690896, 1.927544491220728],
            [33.88561513369705, 1.926903260294658],
            [33.88508968932442, 1.924660073759951],
            [33.884327595468314, 1.923330685498563],
            [33.88458508856136, 1.920318181923101],
            [33.88720915194788, 1.918959891525072],
            [33.88987020077133, 1.918578532580872],
            [33.890891401993066, 1.917809079948845],
            [33.89255265375302, 1.916134659556399],
            [33.894022311930875, 1.913410987287186],
            [33.899055123310156, 1.909627045530473],
            [33.89927907061556, 1.908034823992004],
            [33.89790029679162, 1.907302821785834],
            [33.895715004725815, 1.908308097086375],
            [33.89471583917802, 1.907114491066402],
            [33.89305178018276, 1.906572643634387],
            [33.890993936597894, 1.904294077950223],
            [33.889234922982176, 1.903842643638564],
            [33.88778407372972, 1.902721701381689],
            [33.88697313398004, 1.900333919636645],
            [33.883334324665405, 1.89735960412828],
            [33.88214560111793, 1.896817472614142],
            [33.88200650238606, 1.899558496404278],
            [33.88124728583381, 1.900472590813699],
            [33.880866835836244, 1.900373269345129],
            [33.87899918176669, 1.898501662155086],
            [33.87871151066998, 1.896303539765316],
            [33.87823596501645, 1.895996245340082],
            [33.87559947972617, 1.897146441235934],
            [33.87283947608428, 1.894072166347597],
            [33.86806001746293, 1.891007916517093],
            [33.86481562605019, 1.890095851585877],
            [33.85984267840145, 1.884326815382326],
            [33.858483766328426, 1.880555226118813],
            [33.857569028942606, 1.88061898561885],
            [33.85719012225069, 1.881406201343883],
            [33.85709636059291, 1.882763188908815],
            [33.85852489210045, 1.885295418736641],
            [33.85824213299174, 1.88732191641351],
            [33.857435614749846, 1.888163629036695],
            [33.855913531790314, 1.887286914589634],
            [33.85574250064507, 1.883442313020699],
            [33.85517193030247, 1.883008407901016],
            [33.8528677515987, 1.883443785461863],
            [33.85186795453525, 1.882042117882711],
            [33.851154916778476, 1.882015323921069],
            [33.85082415439594, 1.883643763609539],
            [33.848898742246874, 1.883047687971731],
            [33.8476421536746, 1.884984195257686],
            [33.8463353852106, 1.88550949527907],
            [33.84547995100657, 1.885157167427487],
            [33.8448933089052, 1.881638445074808],
            [33.846841108867764, 1.880886651592815],
            [33.847172924075835, 1.880271356927057],
            [33.84631566449516, 1.878435360356389],
            [33.84724036779075, 1.87689705019762],
            [33.84651231110074, 1.873785493757321],
            [33.84736486889924, 1.871731554173318],
            [33.84676980509209, 1.870492470038034],
            [33.843776169407754, 1.871018616586404],
            [33.84287301130595, 1.870566752549574],
            [33.843892459016246, 1.868630370256547],
            [33.84669562401257, 1.868221924142927],
            [33.84997215894279, 1.865832130624966],
            [33.85040945612817, 1.863787442060588],
            [33.84739020408518, 1.862359594779011],
            [33.84705495012622, 1.86049622312528],
            [33.84854896073312, 1.857935408767186],
            [33.84923757509394, 1.85739228368293],
            [33.85123358943445, 1.857644591999106],
            [33.85344260331193, 1.856784134802679],
            [33.85498559994962, 1.855562155753998],
            [33.85503044564523, 1.85300203456649],
            [33.85416104533348, 1.851609322065141],
            [33.854184344936996, 1.85096708086189],
            [33.8559649747134, 1.849672567906289],
            [33.85735048500364, 1.84593576604364],
            [33.85872680283359, 1.844017313758629],
            [33.85998240864893, 1.841194275146192],
            [33.86306826178706, 1.838587487108277],
            [33.863186516909366, 1.838017490546219],
            [33.86253200978328, 1.837076989176908],
            [33.8633143166316, 1.835448577448669],
            [33.86597276842554, 1.832959274419301],
            [33.86815841083431, 1.832741123319118],
            [33.86991552990308, 1.831591376464286],
            [33.87070008164132, 1.83201617468783],
            [33.87129318083292, 1.831346429569896],
            [33.871124956922934, 1.829844904995089],
            [33.87017302389443, 1.828533611908695],
            [33.87001743299229, 1.827421039081997],
            [33.87063383088911, 1.826271849979039],
            [33.87053298152373, 1.821070293046991],
            [33.86899426535841, 1.815833297665493],
            [33.867208162146966, 1.812496115666044],
            [33.866215032379564, 1.806128061013029],
            [33.8671875988118, 1.804815839366521],
            [33.86782870127727, 1.80469799397181],
            [33.87011287899123, 1.807383603771504],
            [33.871467650729095, 1.807455293172711],
            [33.871847188936634, 1.806858070560506],
            [33.870514032461124, 1.804832393389115],
            [33.868754177123996, 1.80363913861636],
            [33.86927463854174, 1.801612475588934],
            [33.8707938432991, 1.800218670944344],
            [33.871196892214236, 1.79931385376854],
            [33.87125458112347, 1.798037892302168],
            [33.869944935355605, 1.795578350767986],
            [33.86960561113006, 1.789852219165394],
            [33.86979152017307, 1.785580914523522],
          ],
          [
            [33.960015781247435, 1.900584608364779],
            [33.9566660470963, 1.901069501721121],
            [33.93778219679282, 1.906173184615792],
            [33.936262640794155, 1.907107757433643],
            [33.93460138903419, 1.908806806567723],
            [33.93384308427195, 1.910479970887031],
            [33.93303586354753, 1.911007087523799],
            [33.93310765870165, 1.911436705733651],
            [33.93415553000584, 1.913368621220369],
            [33.936629405856664, 1.91560782551102],
            [33.93931578986606, 1.916724269400725],
            [33.95064789613974, 1.924686797029829],
            [33.96009754141302, 1.928307486927038],
            [33.96366301136957, 1.929302578639458],
            [33.965480906857195, 1.930688566172128],
            [33.96765504005055, 1.926668498029014],
            [33.97545880284007, 1.925230462179934],
            [33.97954262856332, 1.922738060395159],
            [33.98461340813638, 1.914176935033573],
            [33.98290197738296, 1.913679279350347],
            [33.978740250656585, 1.910823105331975],
            [33.9735771134925, 1.905175273772952],
            [33.97071162787338, 1.903331026561549],
            [33.9689032769856, 1.901281401793538],
            [33.96396008692895, 1.900599829125815],
            [33.960015781247435, 1.900584608364779],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 771,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "KATAKWI",
        Population: 36902,
        Key: "KATAKWIKATAKWI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96815390956212, 1.926595742405575],
            [33.967655013999405, 1.926668464810145],
            [33.96718065232541, 1.92736200475926],
            [33.96548088619596, 1.930688585923845],
            [33.96366299070829, 1.929302562478943],
            [33.95109963284497, 1.924900738494542],
            [33.939315822205415, 1.916724247853224],
            [33.93662942651793, 1.915607814737279],
            [33.93372717015925, 1.912844207731108],
            [33.933035847377845, 1.911007062384969],
            [33.933843086966874, 1.910479962806685],
            [33.93533703379339, 1.907993301740748],
            [33.9377822210473, 1.906173168455059],
            [33.956666072249114, 1.901069535838323],
            [33.96001578214576, 1.90058462003645],
            [33.963960116573354, 1.90059983181929],
            [33.9689032590193, 1.901281435012898],
            [33.97071161799191, 1.903331004116046],
            [33.973577098221156, 1.905175271977318],
            [33.978740256944796, 1.910823085580029],
            [33.982901997145895, 1.91367929910226],
            [33.98461340544143, 1.914176957478935],
            [33.983075023449395, 1.916330797564822],
            [33.98023050271233, 1.921781381243057],
            [33.9786880549453, 1.923408539021782],
            [33.97545880733162, 1.925230452304044],
            [33.96815390956212, 1.926595742405575],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 772,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "KATAKWI TOWN COUNCIL",
        Population: 7758,
        Key: "KATAKWIKATAKWI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.22293035524913, 1.901085069036773],
            [34.22305789625657, 1.983577200477745],
            [34.21197248263125, 2.118646701700615],
            [34.15136815133292, 2.156302428945829],
            [34.14557983254516, 2.150570166506448],
            [34.12961987362566, 2.132470105604484],
            [34.11844056000205, 2.118944082254031],
            [34.11521741015251, 2.114432399041443],
            [34.111534386657894, 2.108286926738263],
            [34.108291686772844, 2.101939696599041],
            [34.10539704453453, 2.094150998669421],
            [34.102191316611595, 2.082059020217971],
            [34.102389353809244, 2.07862684304449],
            [34.108389815141216, 2.069330534338953],
            [34.10997338778197, 2.062993034667133],
            [34.10892258437665, 2.059473135316718],
            [34.10930940792116, 2.058923275209843],
            [34.108132946377324, 2.04321213648791],
            [34.10602286036879, 2.035520321583296],
            [34.10283785837612, 2.030066996886001],
            [34.10029787909678, 2.02841703835099],
            [34.0982851623802, 2.024932667231286],
            [34.09669454694764, 2.023975915798303],
            [34.09564216250747, 2.021578116737595],
            [34.09464599194283, 2.020574893642561],
            [34.09351264144777, 2.017211498405149],
            [34.094418830465344, 2.015997658304708],
            [34.09394640915239, 2.014685622109829],
            [34.09635565571007, 2.006025687756644],
            [34.09728440771264, 2.005336315604195],
            [34.09750487584296, 2.002523949899724],
            [34.09696079142818, 2.001354813082221],
            [34.097202108557894, 1.999805882734422],
            [34.09606732345333, 1.997517206152881],
            [34.09699549424592, 1.994834905073178],
            [34.09654873061409, 1.993641663003153],
            [34.0969951699541, 1.989593385355206],
            [34.096193952670745, 1.987850589253263],
            [34.09759313531961, 1.986248627163983],
            [34.09853020302679, 1.984227661335867],
            [34.09848592147316, 1.983488881662635],
            [34.09742318305101, 1.981697280399161],
            [34.0977350736261, 1.981126871646917],
            [34.0988541525862, 1.980965064152299],
            [34.098763680558996, 1.979916356278405],
            [34.096857907378705, 1.977751718149888],
            [34.09576614438971, 1.977127415175392],
            [34.09535642728021, 1.975636522503425],
            [34.09369435984995, 1.974842896209504],
            [34.093203445818546, 1.972887059596776],
            [34.092351984863, 1.97173965149785],
            [34.093023360553545, 1.970599043321858],
            [34.09103674079429, 1.967897960935501],
            [34.09080286530836, 1.966991564549461],
            [34.0895191628859, 1.966723771134123],
            [34.088384816159184, 1.967635979032021],
            [34.087767340284046, 1.967371155595445],
            [34.088921781425334, 1.964636397369088],
            [34.08880515674526, 1.964111732222879],
            [34.08766454067617, 1.963773093022126],
            [34.087026717061505, 1.962745776688645],
            [34.08686775298547, 1.961053479098115],
            [34.08575071769259, 1.960762590896755],
            [34.084150299843664, 1.962137308671926],
            [34.08367784349639, 1.961372802919726],
            [34.08332039665834, 1.961490328880652],
            [34.0821187822865, 1.964129555100538],
            [34.08164215416307, 1.964294215605568],
            [34.080312145384326, 1.96374028965491],
            [34.0793773126856, 1.965260923190174],
            [34.07871257285008, 1.964924413773377],
            [34.07833541158476, 1.964136502180251],
            [34.076740445611286, 1.964296154826406],
            [34.076363695774404, 1.963412935572741],
            [34.0765583382386, 1.962460803411565],
            [34.07592125932729, 1.961266691440455],
            [34.076390346992255, 1.960137091987002],
            [34.07532304333182, 1.959369917986794],
            [34.07490828487695, 1.956366070455656],
            [34.07336014807924, 1.956692710375863],
            [34.071176990410535, 1.955372560432887],
            [34.06884537446306, 1.955314488538924],
            [34.068161468172626, 1.953953381993008],
            [34.06716351265552, 1.953639180463515],
            [34.065672541947535, 1.951845615977646],
            [34.06564314188489, 1.950451707483663],
            [34.0646492772956, 1.949232164091011],
            [34.06381627312589, 1.949276090529924],
            [34.06262151469634, 1.950390523662647],
            [34.06171970316912, 1.949862331110222],
            [34.06024015903154, 1.950184837949104],
            [34.05931939574678, 1.949208289913394],
            [34.0588043143393, 1.947347607724466],
            [34.05881207129177, 1.945632205062409],
            [34.05772269782145, 1.944483710815546],
            [34.05679602541875, 1.944193657391794],
            [34.05448465929441, 1.944921874793014],
            [34.054010077533164, 1.944633838796557],
            [34.05351211532006, 1.944250402723847],
            [34.053280421841954, 1.942867488676812],
            [34.051548729587296, 1.941692270445262],
            [34.050593974052205, 1.939722386777812],
            [34.04831944065111, 1.937567883173202],
            [34.04715568667529, 1.937086151451258],
            [34.042230158395434, 1.931846231873786],
            [34.039248493660594, 1.930844061557963],
            [34.037440458081505, 1.930764447778562],
            [34.03640141452159, 1.9290205068075],
            [34.03497647178362, 1.928418450429894],
            [34.03436247957513, 1.927391183489073],
            [34.03182235566706, 1.926093173045569],
            [34.03161178068299, 1.925305973234909],
            [34.03056516971512, 1.925229786130352],
            [34.030237564910806, 1.92401320171333],
            [34.029666728666875, 1.923962983672743],
            [34.02939742632111, 1.925629560324301],
            [34.02865327271952, 1.92444682537325],
            [34.02903916201614, 1.92330494889978],
            [34.02751644754095, 1.923274259087084],
            [34.026677863036696, 1.922480575789572],
            [34.02768574673433, 1.917437742129015],
            [34.02757208110482, 1.916269775915776],
            [34.02666213533272, 1.914919526714437],
            [34.027150682303336, 1.912134118751136],
            [34.02643935853213, 1.911582921256824],
            [34.0252956289023, 1.911935155736044],
            [34.02556972016682, 1.909220274505046],
            [34.02390664303019, 1.908664775532809],
            [34.02306230212161, 1.903359752301688],
            [34.022636607576466, 1.90278601132848],
            [34.02178090926771, 1.902591528252245],
            [34.021144546313735, 1.901254425871425],
            [34.0237722667418, 1.896370125933066],
            [34.02279192449246, 1.892196201480668],
            [34.02455839681998, 1.890941433393318],
            [34.025062175624576, 1.887429416046881],
            [34.02578369527425, 1.885741074069704],
            [34.025670141934114, 1.884549272383544],
            [34.0271376145109, 1.881029701250767],
            [34.02699691947279, 1.880576393393204],
            [34.02454596413645, 1.879078854783767],
            [34.02290824554194, 1.87711509170445],
            [34.022556011627486, 1.876088988331999],
            [34.02396884417711, 1.87411784977386],
            [34.02474099018126, 1.87176260583074],
            [34.02395798624026, 1.868673641538058],
            [34.02472796101636, 1.86679490198256],
            [34.025071177642026, 1.864580660221841],
            [34.02554889272698, 1.864177786957272],
            [34.02716693731842, 1.864161301719691],
            [34.027906479867646, 1.863735774058485],
            [34.029302570515306, 1.860215903448392],
            [34.03177683264171, 1.856748679855856],
            [34.03416016280347, 1.85587791766684],
            [34.03509580308766, 1.854190538337652],
            [34.03631088769716, 1.853838638756251],
            [34.037028364928055, 1.853031817000423],
            [34.03785960121328, 1.853369152792882],
            [34.03911161286917, 1.852743429894322],
            [34.0400633320986, 1.852747728779347],
            [34.04205885955221, 1.850767579344048],
            [34.04384359732442, 1.853265106879614],
            [34.044215024643265, 1.855623035876982],
            [34.04762034115431, 1.857184829792388],
            [34.0493228480437, 1.857705086875655],
            [34.050556279844564, 1.857629879940756],
            [34.05188884612691, 1.858324112804818],
            [34.05218571956538, 1.859738819843454],
            [34.05350501773099, 1.86157651942718],
            [34.056160153843216, 1.864167248113083],
            [34.05847992550366, 1.865555905045933],
            [34.06030600913514, 1.866448406313115],
            [34.06178627192492, 1.866596441052538],
            [34.063513827437724, 1.867737222756133],
            [34.06440175190895, 1.86743881189499],
            [34.065290305200875, 1.868182942719365],
            [34.06588222490452, 1.867934356552848],
            [34.068793589281846, 1.868528313056232],
            [34.070373282997195, 1.869917398403181],
            [34.07007827266464, 1.871605502484943],
            [34.0714106997081, 1.872051486327307],
            [34.07249546571934, 1.870908988968376],
            [34.07412395681923, 1.871404432088985],
            [34.07644462050676, 1.874232747480914],
            [34.07708700127486, 1.875820979548276],
            [34.08004878180092, 1.878152438931364],
            [34.08101704709956, 1.879409115152089],
            [34.084935793914624, 1.882096131376543],
            [34.087699618989696, 1.883434798183786],
            [34.09162256003884, 1.8842018168588],
            [34.09709932152647, 1.884396926888012],
            [34.105832005201826, 1.883894921621558],
            [34.1072141836407, 1.884986209088541],
            [34.111168534283735, 1.896352174854107],
            [34.11911266871783, 1.89719096606799],
            [34.131745081873696, 1.899714518045168],
            [34.13474052945994, 1.900644501111536],
            [34.13492773028034, 1.900159208105342],
            [34.157871061962865, 1.901434593348025],
            [34.16541993946861, 1.901578405357331],
            [34.168972031713906, 1.901178840136266],
            [34.194776277489126, 1.901806397003512],
            [34.200696261449735, 1.901007976750745],
            [34.206518311976396, 1.901301742820062],
            [34.22293035524913, 1.901085069036773],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 773,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "PALAM",
        Population: 12650,
        Key: "KATAKWIPALAM",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.087424200015164, 2.195843773707826],
            [34.06035794613159, 2.212723053138343],
            [34.006135914059904, 2.245428827104657],
            [33.92596209780901, 2.295914569416017],
            [33.90898251960101, 2.306165857716679],
            [33.908789179694004, 2.305826934839317],
            [33.90830411279677, 2.304938207623875],
            [33.90844056509178, 2.304327631900921],
            [33.91062299871835, 2.303441293132623],
            [33.9110038233134, 2.302912554516893],
            [33.910544065550994, 2.300988720356085],
            [33.91010303406898, 2.300920576145229],
            [33.907885480806385, 2.298339933213662],
            [33.90857427483026, 2.298092601539988],
            [33.90863843610111, 2.297416858516694],
            [33.906623138524736, 2.297227564172108],
            [33.906622714519905, 2.296556193816339],
            [33.90750495265541, 2.295797630843411],
            [33.9061742827166, 2.295581909310953],
            [33.905463460205304, 2.295036601775162],
            [33.90437855315858, 2.295336162311674],
            [33.90425346904348, 2.294998390269963],
            [33.905238597516664, 2.293520745707104],
            [33.90503066447785, 2.291537083038594],
            [33.904158306013855, 2.291171629102005],
            [33.90410514730862, 2.291944826251421],
            [33.903786531047, 2.291979680826758],
            [33.90257116975639, 2.290239216557018],
            [33.90351394266393, 2.289883441087954],
            [33.90340578101214, 2.289064870121982],
            [33.90297112846698, 2.289454974438438],
            [33.902643765309456, 2.289273261053539],
            [33.902819968055795, 2.288731721028842],
            [33.903935039631456, 2.288475458380933],
            [33.90317667288545, 2.287635642229566],
            [33.903585351542496, 2.287024651603563],
            [33.90434333201292, 2.287249405174786],
            [33.904627223897236, 2.286772767142915],
            [33.90409724393072, 2.286210017675563],
            [33.90429894805136, 2.285135695693826],
            [33.90281702697156, 2.284032119174529],
            [33.904732094121826, 2.282341648912644],
            [33.90422754096945, 2.28112050484838],
            [33.90312042936551, 2.280324221777924],
            [33.90401142876996, 2.279812549750802],
            [33.90413591011552, 2.279188745185025],
            [33.9032272381545, 2.278981410168899],
            [33.90206919836214, 2.279371969616542],
            [33.90165254536033, 2.278365525710833],
            [33.901306525092686, 2.278519158004146],
            [33.90134157286347, 2.27948504623889],
            [33.900635380269186, 2.27944217664983],
            [33.89962207523881, 2.27715581646494],
            [33.89846297543445, 2.27583978738428],
            [33.897028303043655, 2.274523929442962],
            [33.89622742532344, 2.274550418738766],
            [33.89487907474322, 2.273563691917107],
            [33.894027432328, 2.27505857132173],
            [33.89276516999642, 2.274024143274461],
            [33.89157262950728, 2.27433241857879],
            [33.89214149754244, 2.275129049642536],
            [33.892103161937676, 2.275809110776741],
            [33.89115987160054, 2.27532024444329],
            [33.890014753175265, 2.275723781584855],
            [33.890328373007264, 2.274567089105562],
            [33.889597241384024, 2.272605389894337],
            [33.88901404701675, 2.273359106363567],
            [33.888616663776105, 2.273235561352209],
            [33.88846858368803, 2.27257072065426],
            [33.88795554055789, 2.273048516816735],
            [33.88737448867256, 2.271556314694226],
            [33.8867519867234, 2.271277287404809],
            [33.88756737762532, 2.270753325683246],
            [33.8886226474542, 2.271523710828221],
            [33.88899503058049, 2.271014170193882],
            [33.888997841409015, 2.269861147860591],
            [33.890245916647324, 2.269694142043597],
            [33.88973884372059, 2.268435329781378],
            [33.89070265696871, 2.269142106967989],
            [33.89112436928219, 2.268805842144742],
            [33.890414886159, 2.267646759170675],
            [33.8903947073028, 2.265778732640059],
            [33.89074585066252, 2.265035771911629],
            [33.88933224017183, 2.264728937987655],
            [33.88879121362231, 2.265440183507356],
            [33.88822471534289, 2.264743769257419],
            [33.88885714637092, 2.264014783849218],
            [33.887893038475376, 2.262816377024241],
            [33.886985927786306, 2.262834620147414],
            [33.88673527895741, 2.261165369837239],
            [33.88570185974953, 2.261622262503963],
            [33.88611243205519, 2.260309828603454],
            [33.88722715508452, 2.260574408180902],
            [33.88758258250982, 2.261090574201398],
            [33.888348775378574, 2.260616160797423],
            [33.8883314154357, 2.259865277752246],
            [33.887529174072924, 2.259990637987742],
            [33.88699084336756, 2.259354331836233],
            [33.88628760802715, 2.259284026884897],
            [33.88625526598198, 2.25813456234943],
            [33.88721863007246, 2.258116285955336],
            [33.887327252559984, 2.257504339440302],
            [33.88614182852454, 2.256606700429225],
            [33.88593343554829, 2.255036455794196],
            [33.88543378629907, 2.254403659861123],
            [33.884682699500104, 2.254517739280372],
            [33.88455819659499, 2.25565038080305],
            [33.88417602542535, 2.255978341212481],
            [33.883426396592114, 2.254772724356883],
            [33.88354141777943, 2.253106783289817],
            [33.8823216062349, 2.253482437546952],
            [33.881634934930034, 2.251721488935537],
            [33.87918070343784, 2.251563821683199],
            [33.879574003835515, 2.25075363614267],
            [33.8784876280433, 2.250206001192206],
            [33.87987520266208, 2.248797557962884],
            [33.87975180198983, 2.24822819439635],
            [33.87875002234455, 2.248670912264036],
            [33.87816937200612, 2.247804727737791],
            [33.87756831014784, 2.248080967927522],
            [33.87644651917387, 2.247742105891101],
            [33.8773842606175, 2.246040296666336],
            [33.878173830344885, 2.242834760636825],
            [33.87744059396895, 2.242500476180837],
            [33.87751172975966, 2.242093543060276],
            [33.88042431674413, 2.238675108468684],
            [33.8803467678806, 2.238304168346828],
            [33.87983394214276, 2.238266551370271],
            [33.87909800453278, 2.238909273101694],
            [33.87957297975609, 2.237431020148507],
            [33.87843154442348, 2.237118535214409],
            [33.878228221538706, 2.236653953845624],
            [33.87880397426219, 2.236255077136125],
            [33.878828348250806, 2.235576531561439],
            [33.879679166012586, 2.235952989215368],
            [33.880148827701, 2.235539832792074],
            [33.88052986160348, 2.236126001361566],
            [33.87989993148525, 2.237095736294088],
            [33.88052451752588, 2.237137244529344],
            [33.880893001963834, 2.236628410860354],
            [33.88134529113297, 2.237005107911767],
            [33.881505635021284, 2.236574186770611],
            [33.88108889218796, 2.235958121871309],
            [33.882458024393955, 2.236041063004055],
            [33.88304314115595, 2.235424117304281],
            [33.88322269371999, 2.233282133220321],
            [33.88266347538762, 2.233132879291031],
            [33.882086869264626, 2.233749545892079],
            [33.88130092064613, 2.232427630370494],
            [33.882829038487735, 2.231481288289989],
            [33.881833598253436, 2.230863689890345],
            [33.88235534336369, 2.229996842256473],
            [33.88205405111236, 2.228591645199661],
            [33.881607758197745, 2.228286747898439],
            [33.88069192217231, 2.228592466536471],
            [33.88034057040346, 2.227904556873932],
            [33.87969235148432, 2.228126342128855],
            [33.87942021405552, 2.227764209644398],
            [33.879280281687095, 2.225891738162124],
            [33.87962191278625, 2.224805994070156],
            [33.88061128490085, 2.223021719966058],
            [33.8820477889565, 2.22216764651877],
            [33.88212211376648, 2.221520737163417],
            [33.881894257891304, 2.219945343776644],
            [33.88101953146824, 2.219353485799493],
            [33.88144710798389, 2.218192398693418],
            [33.88103051247426, 2.217809693398925],
            [33.879936076098986, 2.217840267098348],
            [33.879709809343545, 2.217439496655266],
            [33.88015534228345, 2.216463891664613],
            [33.88093806145847, 2.217016461867697],
            [33.88149214412235, 2.216889483994864],
            [33.88171944304208, 2.215396731746877],
            [33.8823016160249, 2.214781196584185],
            [33.88228007532269, 2.213044394922139],
            [33.88345291755425, 2.21192196986724],
            [33.884455229002185, 2.209338818135507],
            [33.885268622949226, 2.208754727757168],
            [33.88434487096953, 2.206688016869997],
            [33.88394604503455, 2.206797696123618],
            [33.88378475701685, 2.207588663864539],
            [33.883442457571086, 2.207543637811289],
            [33.8825957765512, 2.205773330986834],
            [33.88214195395784, 2.205603289199874],
            [33.883310158187626, 2.203648326095465],
            [33.88294984752043, 2.201356362925489],
            [33.88218653554876, 2.200814074894124],
            [33.88113644271088, 2.202115137478488],
            [33.880529386394706, 2.202068389563328],
            [33.87996568367245, 2.199720784718898],
            [33.88026367281849, 2.199226222540987],
            [33.881397157162525, 2.19929351065454],
            [33.881989503565926, 2.198190681788671],
            [33.88196988166519, 2.196733310695131],
            [33.883578423877566, 2.194396194655186],
            [33.88283855434156, 2.193240361800329],
            [33.88211803900835, 2.193380486982353],
            [33.8819017803835, 2.192916922406729],
            [33.88242862792457, 2.191813426363691],
            [33.882356398884184, 2.189949513627233],
            [33.88303105162884, 2.188698196845826],
            [33.883623884919146, 2.188429778547935],
            [33.88465770028408, 2.188968403233935],
            [33.88575875634466, 2.187337361719488],
            [33.887729776859025, 2.188434887131532],
            [33.88852877530365, 2.187735925732529],
            [33.89141419184401, 2.18680668433882],
            [33.893959997596255, 2.186559336504256],
            [33.89407252865359, 2.186110988771314],
            [33.893483222149094, 2.185339450323202],
            [33.89478494747112, 2.183509241277273],
            [33.89481296861978, 2.182488067536518],
            [33.893582807584856, 2.182754454586609],
            [33.89254143020185, 2.181935316680689],
            [33.89360568318358, 2.181204675475144],
            [33.89315300953552, 2.180139855695397],
            [33.8945371229455, 2.177159171207401],
            [33.893546106913945, 2.176626933680021],
            [33.89648037204284, 2.174237989967714],
            [33.89696701638171, 2.172400719825258],
            [33.89879802906912, 2.170001355543529],
            [33.89874373848661, 2.169515540363848],
            [33.89786175637098, 2.169948314851327],
            [33.897655288484394, 2.169546108766731],
            [33.89843161075629, 2.16896194722562],
            [33.8986240092289, 2.168211177517959],
            [33.8991223622092, 2.168346190993267],
            [33.89905733945396, 2.166744926307396],
            [33.899845435944314, 2.16547313586035],
            [33.898894048193206, 2.164999470143454],
            [33.89810966623656, 2.163424570225347],
            [33.89762850162095, 2.164466011087939],
            [33.89702129259117, 2.163574809591167],
            [33.896617366920296, 2.164478580324359],
            [33.89576179796895, 2.164160771252297],
            [33.89459301522414, 2.160949431422555],
            [33.89471700788618, 2.159393608331584],
            [33.89572155344422, 2.158292021358768],
            [33.897048235761474, 2.158817793974495],
            [33.898647838838436, 2.158182576451172],
            [33.89943782718076, 2.156351112780559],
            [33.901173492683924, 2.154471215260494],
            [33.90029222383066, 2.152790336754353],
            [33.89828770424103, 2.152623985635664],
            [33.898417591647984, 2.151540525145172],
            [33.899113239817474, 2.150553155421718],
            [33.89962470370932, 2.150469080264624],
            [33.90004052846445, 2.149577270017572],
            [33.90230014444193, 2.148630512928461],
            [33.90365788421347, 2.14849036025784],
            [33.90188849505624, 2.146500582697168],
            [33.90089504998017, 2.146922929946673],
            [33.89971755447541, 2.146519820983407],
            [33.90013232101512, 2.145278930827851],
            [33.899819860908174, 2.144130947512519],
            [33.90138132511143, 2.143760375361064],
            [33.90119071428625, 2.143281797930633],
            [33.899899731018415, 2.142750018024353],
            [33.900149303665586, 2.142348966358838],
            [33.90086645660465, 2.142276274324977],
            [33.900529406913435, 2.141397342019419],
            [33.90075483913397, 2.140397940310407],
            [33.89969642250666, 2.140895209408917],
            [33.898969611779954, 2.138873166198681],
            [33.900101129711835, 2.138982114272486],
            [33.90005692900659, 2.136939807664778],
            [33.90171053251023, 2.137148258580366],
            [33.902143913040966, 2.135765780569994],
            [33.902768047229024, 2.135113195700244],
            [33.90322612604016, 2.135286450174719],
            [33.903167166014796, 2.136172063904619],
            [33.90345864866325, 2.136243694259373],
            [33.90406846011239, 2.135972686718497],
            [33.90415987986224, 2.135208110428529],
            [33.905676400453544, 2.134937947432898],
            [33.90664520384304, 2.13377654754553],
            [33.90840263103398, 2.134241122148365],
            [33.9092497486351, 2.132805651605232],
            [33.908797551094125, 2.132518706712007],
            [33.908203046937395, 2.132979799544133],
            [33.90794709445507, 2.132638884479115],
            [33.90928494642457, 2.131973906521854],
            [33.90952817786416, 2.130908676162216],
            [33.910545384277796, 2.131153399219473],
            [33.91099713535611, 2.130680423959617],
            [33.910513992650195, 2.128341114545468],
            [33.90912225703504, 2.128395793182147],
            [33.90805653351119, 2.127829415413603],
            [33.90752657061269, 2.125500662184252],
            [33.90600381750996, 2.125268200775833],
            [33.90529560280797, 2.124520665556155],
            [33.90553926094732, 2.1241794541754],
            [33.90671691186061, 2.124184741616616],
            [33.90711508382208, 2.123628029615967],
            [33.906579419316465, 2.122994080319353],
            [33.90726253688607, 2.121503752557782],
            [33.90763721700458, 2.121461645959716],
            [33.90830394750674, 2.122466501813186],
            [33.90785834090501, 2.12327455457859],
            [33.908506984727275, 2.123860567575585],
            [33.908471729445615, 2.124596573982559],
            [33.90939983915277, 2.125050781151696],
            [33.91127328376265, 2.12490606153681],
            [33.91192668955423, 2.124417253459192],
            [33.91143316591692, 2.12370325763096],
            [33.91086836904664, 2.124104495493017],
            [33.911206802143425, 2.123105029589196],
            [33.914188886391514, 2.122471258720141],
            [33.91362740610128, 2.121800349768374],
            [33.914238413208054, 2.121478570289738],
            [33.91428618291994, 2.119569817453931],
            [33.91492178410258, 2.119560393392213],
            [33.915117796497576, 2.120311101687589],
            [33.91581944092159, 2.12079917225654],
            [33.917253050605424, 2.11982134059466],
            [33.91744829044928, 2.119260367432742],
            [33.91565523068427, 2.118700579033161],
            [33.91363289570597, 2.117209177076448],
            [33.91131038418387, 2.117500028920098],
            [33.910853429165144, 2.116432860314355],
            [33.90968008477533, 2.116569245554853],
            [33.9081801830168, 2.115665521090651],
            [33.9067464817048, 2.116498607145769],
            [33.90646842347997, 2.114780010502899],
            [33.905423963078896, 2.113306109111857],
            [33.90423404297548, 2.112963054966092],
            [33.903349540187165, 2.112095145934171],
            [33.902587709537414, 2.112475528632296],
            [33.90164174761061, 2.111254856122325],
            [33.901575727725465, 2.109816561601231],
            [33.90193425164354, 2.109780167689014],
            [33.90264360181609, 2.110973841064537],
            [33.90303511187141, 2.11063890615317],
            [33.90290377548194, 2.108983543778384],
            [33.90451648947047, 2.107707098447743],
            [33.90588584984856, 2.108348570495014],
            [33.907466380793736, 2.107786785250363],
            [33.90790553569508, 2.106275827908402],
            [33.90878543461758, 2.105994882870448],
            [33.90842643459237, 2.105208082447858],
            [33.90858849156795, 2.103624919801023],
            [33.91007243924703, 2.104175860419303],
            [33.91067531300725, 2.103949353915358],
            [33.911285185541864, 2.102230237099397],
            [33.90967142411768, 2.101679372997329],
            [33.909849646276804, 2.099870048884796],
            [33.90708619579918, 2.098550934988637],
            [33.905293620226146, 2.098787179764968],
            [33.9034859942788, 2.101194498560987],
            [33.90275204823382, 2.101194925871567],
            [33.90252363001326, 2.100751799360471],
            [33.90301270249832, 2.100036871602847],
            [33.901577543220625, 2.099295924222886],
            [33.90127545057039, 2.097776351384828],
            [33.89974351578712, 2.097813424248356],
            [33.90029657706653, 2.095976740512469],
            [33.89892631028833, 2.094711075979268],
            [33.898941958042236, 2.09357125490257],
            [33.89770270964994, 2.092432157454009],
            [33.897914399443245, 2.092124466953971],
            [33.897148563205675, 2.09236915392665],
            [33.89662679563749, 2.091926193687452],
            [33.89592624536151, 2.092342718873192],
            [33.8956989769845, 2.093916877188134],
            [33.89604139770284, 2.094224248647397],
            [33.89401250681956, 2.094958153162827],
            [33.89275676176536, 2.093466260768857],
            [33.89174516263571, 2.091413365814362],
            [33.890343654248554, 2.091531766588618],
            [33.8884440093751, 2.090257343925192],
            [33.888491649729566, 2.088031962473679],
            [33.88896389587106, 2.087362278450092],
            [33.889941649175775, 2.087207937169821],
            [33.889990319897855, 2.086818920339279],
            [33.888742313829816, 2.085073728387655],
            [33.8888233849876, 2.084331897763006],
            [33.8921480606339, 2.083380158873006],
            [33.89270165820751, 2.082475228428935],
            [33.89179415046309, 2.081713477017514],
            [33.889544397987436, 2.081769298294962],
            [33.88866110253488, 2.08022849439664],
            [33.88804015916271, 2.079980437277052],
            [33.88803043759473, 2.079320778302054],
            [33.887101715236554, 2.07965448823429],
            [33.887198643455704, 2.078190479904636],
            [33.886288752480816, 2.076638553286502],
            [33.88398783376322, 2.074617090931813],
            [33.88282642169533, 2.074663051832966],
            [33.88259166226719, 2.074303226876297],
            [33.881489886656034, 2.070703469114754],
            [33.881974746042445, 2.070047491447711],
            [33.88445677051121, 2.072131098568259],
            [33.88527163589869, 2.072139686233081],
            [33.886231986141404, 2.070013296947609],
            [33.88581862726174, 2.068512294121433],
            [33.886086305453446, 2.067802403251845],
            [33.88717532229262, 2.06790683352409],
            [33.89050178828128, 2.066621747387551],
            [33.89308424889038, 2.067521656022046],
            [33.89456502731317, 2.066321357591193],
            [33.89443013629009, 2.06479549666488],
            [33.892283857158766, 2.063985146076554],
            [33.89224963314308, 2.063618563258614],
            [33.89447030805129, 2.060941593940633],
            [33.89362993500132, 2.059352253495021],
            [33.89439899529248, 2.057751157406755],
            [33.896584688905214, 2.057427191383968],
            [33.897993974906065, 2.054551954364308],
            [33.90006787497832, 2.054352053280748],
            [33.90094987236533, 2.054692226786868],
            [33.901367273663766, 2.056807005484201],
            [33.9003023837765, 2.057403790992519],
            [33.90105076305318, 2.058482166605996],
            [33.90281750577362, 2.058225825370351],
            [33.90322965462259, 2.056813042762349],
            [33.90505281603444, 2.056859881267205],
            [33.90593023381012, 2.054547441436381],
            [33.90755018821985, 2.054921289038288],
            [33.90816917416301, 2.054396260588076],
            [33.906729594275795, 2.053116334523428],
            [33.90676605599486, 2.05159276904243],
            [33.905956099002076, 2.050374177034586],
            [33.90486969356546, 2.050332212170992],
            [33.905024375372534, 2.049416563620365],
            [33.9041844568701, 2.048629233178642],
            [33.90449447625443, 2.047961905255735],
            [33.905115169894934, 2.047791214962641],
            [33.90506557390812, 2.047407985190402],
            [33.902769233005195, 2.045317037224916],
            [33.90227725087691, 2.044144778380437],
            [33.901424817045935, 2.043356151701008],
            [33.90546773438943, 2.042146068541238],
            [33.91047011084688, 2.040044345260879],
            [33.913264996071256, 2.039608213947517],
            [33.920316815967354, 2.044613595298949],
            [33.92801796689689, 2.045060051095028],
            [33.9298925182312, 2.045501700251546],
            [33.93389520093145, 2.048065547712677],
            [33.93612140317361, 2.05064683146606],
            [33.9379417043496, 2.05588471918434],
            [33.941890508794046, 2.063753116326395],
            [33.9452576208544, 2.066300897400096],
            [33.949111192200625, 2.067407033789559],
            [33.951053930156576, 2.067366512925196],
            [33.95288616455278, 2.067883565253133],
            [33.95572813227782, 2.067121002446844],
            [33.958948910575, 2.067525704786541],
            [33.962417106460975, 2.067405523806764],
            [33.96856410008379, 2.066253946058917],
            [33.97941698928934, 2.063485963646005],
            [33.9868812904111, 2.063107462409977],
            [33.99348576187212, 2.063910063320784],
            [33.998425218530436, 2.062521759760804],
            [34.0014314917142, 2.062403538154542],
            [34.0065196231453, 2.06315637718607],
            [34.01276492120628, 2.065304274538797],
            [34.01658228685332, 2.067860821256307],
            [34.02219070992058, 2.068555102372319],
            [34.02681797686485, 2.071867152187358],
            [34.028438391211985, 2.074366925966677],
            [34.027575317734765, 2.08076497014404],
            [34.02769313627588, 2.084138109425343],
            [34.02642518042201, 2.090245628711067],
            [34.02659919217739, 2.091117898430062],
            [34.02772371223319, 2.091271986169913],
            [34.02991265954388, 2.088788237437389],
            [34.043521765992416, 2.076823538554482],
            [34.082874839463905, 2.07161474426263],
            [34.09661228552214, 2.05785280086877],
            [34.0976804677349, 2.05857009352016],
            [34.09894060105928, 2.058524980513301],
            [34.100536359346826, 2.057264853742068],
            [34.10191502267799, 2.057363005938926],
            [34.102535380348584, 2.056386937449433],
            [34.10367264659997, 2.058081701971771],
            [34.10445636470159, 2.058440854609192],
            [34.10585934363086, 2.058300674982946],
            [34.10892258437665, 2.059473135316718],
            [34.10997338778197, 2.062993034667133],
            [34.108389815141216, 2.069330534338953],
            [34.102389353809244, 2.07862684304449],
            [34.102191316611595, 2.082059020217971],
            [34.10539704453453, 2.094150998669421],
            [34.108291686772844, 2.101939696599041],
            [34.111534386657894, 2.108286926738263],
            [34.11521741015251, 2.114432399041443],
            [34.11844056000205, 2.118944082254031],
            [34.12961987362566, 2.132470105604484],
            [34.14557983254516, 2.150570166506448],
            [34.15136815133292, 2.156302428945829],
            [34.087424200015164, 2.195843773707826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 774,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "ONGONGOJA",
        Population: 16419,
        Key: "KATAKWIONGONGOJA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.10892258437665, 2.059473135316718],
            [34.10585934363086, 2.058300674982946],
            [34.10445636470159, 2.058440854609192],
            [34.10367264659997, 2.058081701971771],
            [34.102535380348584, 2.056386937449433],
            [34.10191502267799, 2.057363005938926],
            [34.100536359346826, 2.057264853742068],
            [34.09894060105928, 2.058524980513301],
            [34.0976804677349, 2.05857009352016],
            [34.09661228552214, 2.05785280086877],
            [34.082874839463905, 2.07161474426263],
            [34.043521765992416, 2.076823538554482],
            [34.02991265954388, 2.088788237437389],
            [34.02772371223319, 2.091271986169913],
            [34.02659919217739, 2.091117898430062],
            [34.02642518042201, 2.090245628711067],
            [34.02769313627588, 2.084138109425343],
            [34.027575317734765, 2.08076497014404],
            [34.028438391211985, 2.074366925966677],
            [34.02681797686485, 2.071867152187358],
            [34.02219070992058, 2.068555102372319],
            [34.01658228685332, 2.067860821256307],
            [34.01276492120628, 2.065304274538797],
            [34.0065196231453, 2.06315637718607],
            [34.0014314917142, 2.062403538154542],
            [33.998425218530436, 2.062521759760804],
            [33.99348576187212, 2.063910063320784],
            [33.9868812904111, 2.063107462409977],
            [33.97941698928934, 2.063485963646005],
            [33.96856410008379, 2.066253946058917],
            [33.962417106460975, 2.067405523806764],
            [33.958948910575, 2.067525704786541],
            [33.95572813227782, 2.067121002446844],
            [33.95288616455278, 2.067883565253133],
            [33.951053930156576, 2.067366512925196],
            [33.949111192200625, 2.067407033789559],
            [33.9452576208544, 2.066300897400096],
            [33.941890508794046, 2.063753116326395],
            [33.9379417043496, 2.05588471918434],
            [33.93612140317361, 2.05064683146606],
            [33.93389520093145, 2.048065547712677],
            [33.9298925182312, 2.045501700251546],
            [33.92801796689689, 2.045060051095028],
            [33.920316815967354, 2.044613595298949],
            [33.913264996071256, 2.039608213947517],
            [33.91047011084688, 2.040044345260879],
            [33.90546773438943, 2.042146068541238],
            [33.901424817045935, 2.043356151701008],
            [33.901726528810514, 2.040812657585207],
            [33.90068293797866, 2.039745803417057],
            [33.90097591722035, 2.038184281961623],
            [33.89958149654079, 2.037720090157361],
            [33.899317352321404, 2.036772275295252],
            [33.89993747463339, 2.035579566695438],
            [33.89843503872741, 2.035843013639041],
            [33.89768665316255, 2.0347220470581],
            [33.89692537767164, 2.035801275526086],
            [33.89559888310228, 2.035312298890875],
            [33.893906450818804, 2.036434632331481],
            [33.89146476429957, 2.034860373099036],
            [33.89070319865283, 2.035421490249298],
            [33.890746184835805, 2.036620926688385],
            [33.8903642103972, 2.036639710266173],
            [33.88969574345159, 2.036097312486271],
            [33.888896418918485, 2.033861067038788],
            [33.890913309207875, 2.032653389895054],
            [33.89263077394508, 2.032957003544133],
            [33.892923830441916, 2.032694855173449],
            [33.89298687061529, 2.031878620650029],
            [33.893536814740635, 2.031338912726252],
            [33.892064374480334, 2.030939689192591],
            [33.89125675041235, 2.028600586511056],
            [33.89240837803019, 2.028642286206774],
            [33.89359836460896, 2.027811475519017],
            [33.8949798827861, 2.028016161333266],
            [33.8955669273327, 2.027653988136206],
            [33.895761878817325, 2.0238641246664],
            [33.894806478291855, 2.023339401195391],
            [33.89386138503595, 2.023547987422876],
            [33.893718865519475, 2.023018863950431],
            [33.89455299797318, 2.022244958223317],
            [33.89606893465953, 2.021855131953155],
            [33.896254367595446, 2.021472031579122],
            [33.89577421807609, 2.020641903999686],
            [33.89629599552571, 2.02020157672171],
            [33.8975022631707, 2.020165418662571],
            [33.897840227346876, 2.018994163206848],
            [33.897311091796766, 2.018880898511508],
            [33.89655653750084, 2.019349746105272],
            [33.895582805055334, 2.018917345677174],
            [33.89437673953129, 2.019322565601509],
            [33.89460815632825, 2.018300808695361],
            [33.89397342561313, 2.01709420893356],
            [33.89288731033234, 2.017549042136063],
            [33.892145906473836, 2.016264824258329],
            [33.8908482586049, 2.016897207454309],
            [33.88997315309278, 2.016216339878623],
            [33.88761674813503, 2.015727914839937],
            [33.8857408852604, 2.016807750279193],
            [33.88308751343941, 2.015056141979573],
            [33.882803497587595, 2.014191527255973],
            [33.88410209407746, 2.012756025920026],
            [33.88324341066706, 2.009288030539249],
            [33.885874003009114, 2.006346591042705],
            [33.88560030790158, 2.004685455505675],
            [33.883618352195285, 2.00523303490474],
            [33.88308764279679, 2.006999433641498],
            [33.88245174337349, 2.007424949585887],
            [33.87977458326542, 2.006753967828334],
            [33.87765889626109, 2.007876505954633],
            [33.87653650521251, 2.006457627459514],
            [33.87702999112057, 2.005868274575103],
            [33.877615807670175, 2.006449947084052],
            [33.877950995153824, 2.006321022707355],
            [33.8795683660088, 2.003680897811424],
            [33.880795695553935, 2.0034673102792],
            [33.88120515844022, 2.004056174745814],
            [33.88154176166876, 2.003906650043955],
            [33.88270663404714, 2.00203259673944],
            [33.884371538357065, 2.000422167243728],
            [33.886775078816086, 1.998566851779161],
            [33.887896488904396, 1.998168787312256],
            [33.889044360666006, 1.996674512882307],
            [33.89127718528846, 1.996031018244586],
            [33.89384155562435, 1.994347032066303],
            [33.89374476844071, 1.993062532034902],
            [33.89296095960921, 1.993252929681029],
            [33.88953762199526, 1.992259718220766],
            [33.889120563853254, 1.991029672776084],
            [33.89161444967702, 1.989951817888529],
            [33.89256273464715, 1.988395362431753],
            [33.895450711386076, 1.979293363978742],
            [33.89640057469614, 1.978596293847744],
            [33.89742220261762, 1.978640968262955],
            [33.89771143408799, 1.977419799813465],
            [33.89761675794522, 1.97773041831545],
            [33.91226885964258, 1.979811696791697],
            [33.91632300952041, 1.981963843241852],
            [33.92162418720094, 1.983719254829215],
            [33.92866917271435, 1.983261993634974],
            [33.93270669387794, 1.981581593616781],
            [33.936412782515795, 1.980904814241405],
            [33.945739942500104, 1.981278220009148],
            [33.95089518796442, 1.980359429901306],
            [33.95411511645534, 1.980483619630976],
            [33.95970180927587, 1.982548678991255],
            [33.968244316910635, 1.982565509627111],
            [33.971025392334106, 1.983275670372379],
            [33.97451869703061, 1.98350666931927],
            [33.98189388617447, 1.987885224502381],
            [33.98543589123749, 1.989023479388107],
            [33.98655263367956, 1.988973212120815],
            [34.000599950900096, 1.982793052230023],
            [33.999767254852514, 1.97836813928039],
            [33.99963104150937, 1.97345220927797],
            [33.99985128685747, 1.970323706405721],
            [34.00113739856154, 1.966702957758599],
            [34.00380161304803, 1.964734942084132],
            [34.008151937475034, 1.959503468741926],
            [34.009661780888806, 1.958608736386558],
            [34.0097836310689, 1.957870472348032],
            [34.01134896341778, 1.957132910954903],
            [34.01934465216604, 1.956457674830584],
            [34.03065949910817, 1.957666790522305],
            [34.03073530524006, 1.956690287236636],
            [34.03179928064235, 1.955563353833899],
            [34.0315638151384, 1.955014303599014],
            [34.032161482263206, 1.954397515622751],
            [34.033112152260394, 1.949398427725738],
            [34.03298600454003, 1.94572871738228],
            [34.03181308415502, 1.939397759129519],
            [34.03224462583433, 1.93868493663671],
            [34.03186920460575, 1.937515793616563],
            [34.03213472234924, 1.936683090405555],
            [34.031464430026915, 1.934952712340444],
            [34.03170843491598, 1.933619578405273],
            [34.03050249156281, 1.931946364030287],
            [34.027798077467374, 1.930147261300473],
            [34.02756446518783, 1.929193184559361],
            [34.02661745762204, 1.928140587369034],
            [34.02616804216351, 1.924934005885788],
            [34.026677863036696, 1.922480575789572],
            [34.02751644754095, 1.923274259087084],
            [34.02903916201614, 1.92330494889978],
            [34.02865327271952, 1.92444682537325],
            [34.02939742632111, 1.925629560324301],
            [34.029666728666875, 1.923962983672743],
            [34.030237564910806, 1.92401320171333],
            [34.03056516971512, 1.925229786130352],
            [34.03161178068299, 1.925305973234909],
            [34.03182235566706, 1.926093173045569],
            [34.03436247957513, 1.927391183489073],
            [34.03497647178362, 1.928418450429894],
            [34.03640141452159, 1.9290205068075],
            [34.037440458081505, 1.930764447778562],
            [34.039248493660594, 1.930844061557963],
            [34.042230158395434, 1.931846231873786],
            [34.04715568667529, 1.937086151451258],
            [34.04831944065111, 1.937567883173202],
            [34.050593974052205, 1.939722386777812],
            [34.051548729587296, 1.941692270445262],
            [34.053280421841954, 1.942867488676812],
            [34.05351211532006, 1.944250402723847],
            [34.054010077533164, 1.944633838796557],
            [34.05448465929441, 1.944921874793014],
            [34.05679602541875, 1.944193657391794],
            [34.05772269782145, 1.944483710815546],
            [34.05881207129177, 1.945632205062409],
            [34.0588043143393, 1.947347607724466],
            [34.05931939574678, 1.949208289913394],
            [34.06024015903154, 1.950184837949104],
            [34.06171970316912, 1.949862331110222],
            [34.06262151469634, 1.950390523662647],
            [34.06381627312589, 1.949276090529924],
            [34.0646492772956, 1.949232164091011],
            [34.06564314188489, 1.950451707483663],
            [34.065672541947535, 1.951845615977646],
            [34.06716351265552, 1.953639180463515],
            [34.068161468172626, 1.953953381993008],
            [34.06884537446306, 1.955314488538924],
            [34.071176990410535, 1.955372560432887],
            [34.07336014807924, 1.956692710375863],
            [34.07490828487695, 1.956366070455656],
            [34.07532304333182, 1.959369917986794],
            [34.076390346992255, 1.960137091987002],
            [34.07592125932729, 1.961266691440455],
            [34.0765583382386, 1.962460803411565],
            [34.076363695774404, 1.963412935572741],
            [34.076740445611286, 1.964296154826406],
            [34.07833541158476, 1.964136502180251],
            [34.07871257285008, 1.964924413773377],
            [34.0793773126856, 1.965260923190174],
            [34.080312145384326, 1.96374028965491],
            [34.08164215416307, 1.964294215605568],
            [34.0821187822865, 1.964129555100538],
            [34.08332039665834, 1.961490328880652],
            [34.08367784349639, 1.961372802919726],
            [34.084150299843664, 1.962137308671926],
            [34.08575071769259, 1.960762590896755],
            [34.08686775298547, 1.961053479098115],
            [34.087026717061505, 1.962745776688645],
            [34.08766454067617, 1.963773093022126],
            [34.08880515674526, 1.964111732222879],
            [34.088921781425334, 1.964636397369088],
            [34.087767340284046, 1.967371155595445],
            [34.088384816159184, 1.967635979032021],
            [34.0895191628859, 1.966723771134123],
            [34.09080286530836, 1.966991564549461],
            [34.09103674079429, 1.967897960935501],
            [34.093023360553545, 1.970599043321858],
            [34.092351984863, 1.97173965149785],
            [34.093203445818546, 1.972887059596776],
            [34.09369435984995, 1.974842896209504],
            [34.09535642728021, 1.975636522503425],
            [34.09576614438971, 1.977127415175392],
            [34.096857907378705, 1.977751718149888],
            [34.098763680558996, 1.979916356278405],
            [34.0988541525862, 1.980965064152299],
            [34.0977350736261, 1.981126871646917],
            [34.09742318305101, 1.981697280399161],
            [34.09848592147316, 1.983488881662635],
            [34.09853020302679, 1.984227661335867],
            [34.09759313531961, 1.986248627163983],
            [34.096193952670745, 1.987850589253263],
            [34.0969951699541, 1.989593385355206],
            [34.09654873061409, 1.993641663003153],
            [34.09699549424592, 1.994834905073178],
            [34.09606732345333, 1.997517206152881],
            [34.097202108557894, 1.999805882734422],
            [34.09696079142818, 2.001354813082221],
            [34.09750487584296, 2.002523949899724],
            [34.09728440771264, 2.005336315604195],
            [34.09635565571007, 2.006025687756644],
            [34.09394640915239, 2.014685622109829],
            [34.094418830465344, 2.015997658304708],
            [34.09351264144777, 2.017211498405149],
            [34.09464599194283, 2.020574893642561],
            [34.09564216250747, 2.021578116737595],
            [34.09669454694764, 2.023975915798303],
            [34.0982851623802, 2.024932667231286],
            [34.10029787909678, 2.02841703835099],
            [34.10283785837612, 2.030066996886001],
            [34.10602286036879, 2.035520321583296],
            [34.108132946377324, 2.04321213648791],
            [34.10930940792116, 2.058923275209843],
            [34.10892258437665, 2.059473135316718],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 775,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "USUK",
        Population: 21224,
        Key: "KATAKWIUSUK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.222483819789396, 1.802698982949471],
            [34.21851842525826, 1.800966045004741],
            [34.216611222858354, 1.796526291977597],
            [34.213295876216236, 1.793080892236802],
            [34.21037751306453, 1.791304916240168],
            [34.208604624070944, 1.791404239312836],
            [34.20796408305253, 1.790996380779898],
            [34.20770559103291, 1.790280499262889],
            [34.20809074101602, 1.789281605670813],
            [34.207646835823425, 1.7874689916664],
            [34.20588728860843, 1.787246739869632],
            [34.20560384049188, 1.786792812960631],
            [34.205682904813315, 1.785077817535272],
            [34.20620832852469, 1.78462750585143],
            [34.205719005409634, 1.782338204262834],
            [34.2062628966866, 1.780422771482449],
            [34.20605081612612, 1.779969176901936],
            [34.20296167695068, 1.779145387199069],
            [34.20127884136936, 1.777732250219741],
            [34.199468719003875, 1.778176834199558],
            [34.198964181122854, 1.779270504389998],
            [34.19796572075255, 1.779099285435354],
            [34.19754542777722, 1.777334410826177],
            [34.198004188409655, 1.775835532636927],
            [34.198958495685424, 1.775244183551439],
            [34.1987709615901, 1.774623911623787],
            [34.196560356796226, 1.774185215116582],
            [34.19577001361937, 1.775349066291287],
            [34.19498395271144, 1.77555998284037],
            [34.193326103769785, 1.773884884352034],
            [34.19065539176882, 1.77259835687005],
            [34.19051510905743, 1.772049771249362],
            [34.191019113339166, 1.771075215755141],
            [34.19038417870647, 1.769428503496937],
            [34.1919366777232, 1.768077457902172],
            [34.191631473308775, 1.767170765393478],
            [34.19051471829029, 1.766856054710898],
            [34.186771746623506, 1.768578508746417],
            [34.1859896526759, 1.767907931327934],
            [34.18573246770499, 1.766906154177682],
            [34.18012345354628, 1.76564218849278],
            [34.17552128912433, 1.765323784534153],
            [34.15935139482126, 1.766144725999618],
            [34.151988798261016, 1.765956808694199],
            [34.14124149703396, 1.767159324504038],
            [34.13539678291099, 1.765393826154771],
            [34.127057846095994, 1.765392020500201],
            [34.12206406921076, 1.764845373087346],
            [34.1193788027056, 1.764142340105645],
            [34.112183420349, 1.763788251959116],
            [34.109752703157696, 1.764658801586574],
            [34.1056223851269, 1.767808887130705],
            [34.10387260709064, 1.770659999033156],
            [34.098486851229495, 1.783048555238845],
            [34.09745633447827, 1.784687829888575],
            [34.09245830317184, 1.7902880010235],
            [34.091006478349, 1.793009426739188],
            [34.08968517783862, 1.794248043715448],
            [34.09020191394286, 1.796817815392338],
            [34.09183238492964, 1.799279170754763],
            [34.09112780121799, 1.80249238827931],
            [34.08958003272955, 1.805916640685942],
            [34.085025046928, 1.802953261706739],
            [34.08011767360006, 1.799071412952021],
            [34.07821692559543, 1.798491011031029],
            [34.07558285677324, 1.796978114552271],
            [34.06950687407535, 1.796319262935089],
            [34.06743990809876, 1.795666619880042],
            [34.06444026088855, 1.796058068725473],
            [34.056941142863025, 1.798128509233104],
            [34.05650760872039, 1.794664188008995],
            [34.05675249844999, 1.793140477044497],
            [34.05759065625448, 1.791953004130638],
            [34.057644022470555, 1.790690496697217],
            [34.05700728312245, 1.78944868446369],
            [34.05725644434123, 1.784386915416628],
            [34.05769265815834, 1.782649624271988],
            [34.05706344669232, 1.779763904942396],
            [34.05743186824821, 1.777240081019802],
            [34.05697952877343, 1.77470061429743],
            [34.059879371358946, 1.770115476673325],
            [34.06299826902481, 1.761850297955872],
            [34.06219631781783, 1.760321829818642],
            [34.06010974880515, 1.758763713827343],
            [34.059687607096926, 1.757427570897107],
            [34.05987057325904, 1.756439652478505],
            [34.05672745880976, 1.746583016356993],
            [34.05342755061413, 1.731674423466542],
            [34.05151094015826, 1.72721957556486],
            [34.0472690405894, 1.719829210807021],
            [34.04488448961716, 1.713550386264234],
            [34.04312261307062, 1.706784295660095],
            [34.04176657291159, 1.700306940589557],
            [34.04074702458998, 1.692337795630984],
            [34.03809854858728, 1.68719514413709],
            [34.03260292876688, 1.67816497852732],
            [34.02961751446402, 1.671198397854718],
            [34.02671101895553, 1.657109269386543],
            [34.02679781956817, 1.652748590644601],
            [34.02814118449856, 1.647718622689281],
            [34.222213104393674, 1.640185995521553],
            [34.22265984556765, 1.719664856341619],
            [34.22263801021803, 1.746964011472728],
            [34.22229123895878, 1.747978711084047],
            [34.222483819789396, 1.802698982949471],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 777,
        District: "KATAKWI",
        County: "TOROMA",
        Subcounty: "MAGORO",
        Population: 18667,
        Key: "KATAKWIMAGORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.04312261307062, 1.706784295660095],
            [34.035607540067346, 1.709139599857914],
            [34.029369285696504, 1.713423094440395],
            [34.02730027695098, 1.716641420711],
            [34.02524229682219, 1.721317124451363],
            [34.02260732429482, 1.725631464504679],
            [34.02081652918266, 1.734526844714426],
            [34.01401320215879, 1.739378948337296],
            [34.01037577355472, 1.742845772874404],
            [34.00421180536633, 1.744089686819675],
            [34.001909824840055, 1.744068007045119],
            [33.998386304410644, 1.743203663996117],
            [33.99512250220125, 1.746589590765674],
            [33.99499684585932, 1.747211038392847],
            [33.99357232892278, 1.748049860462306],
            [33.99255223352718, 1.749317639749603],
            [33.991127651911945, 1.750108711653425],
            [33.989229166763536, 1.75195146950594],
            [33.97793644532686, 1.756698350759327],
            [33.968154718045874, 1.756082024271352],
            [33.96209650043102, 1.755126131219248],
            [33.96212959436609, 1.75665409809794],
            [33.96083878267647, 1.75958067693323],
            [33.951461481427934, 1.75962641643384],
            [33.947254972786354, 1.758680305935072],
            [33.94385927004548, 1.760263602461923],
            [33.947086988726525, 1.757271820620527],
            [33.94923048847037, 1.751596007062854],
            [33.9540136059299, 1.747079759468621],
            [33.9471236741261, 1.734657304726825],
            [33.949782043275036, 1.731642599916206],
            [33.95057324613961, 1.726729737527074],
            [33.95057238285864, 1.725845358722283],
            [33.94817936526485, 1.720768759110021],
            [33.94741600208922, 1.717710108236005],
            [33.9456914765939, 1.715859580631647],
            [33.94514306679104, 1.713924105937677],
            [33.945425371352215, 1.711007684596827],
            [33.94696912706632, 1.710241078041657],
            [33.947170464674315, 1.709583535583083],
            [33.946954089268445, 1.707002300852524],
            [33.947592492296465, 1.703750852173897],
            [33.947242812292345, 1.698456831714994],
            [33.945980646978796, 1.695566036981242],
            [33.93928490668491, 1.688414666214661],
            [33.93541819208775, 1.682694281206177],
            [33.93362037394668, 1.678692584159953],
            [33.92923696816104, 1.66681779810586],
            [33.92282670258296, 1.640422102650565],
            [33.946110435571065, 1.635819610105765],
            [33.954975724955396, 1.635427320311702],
            [33.974998266238316, 1.637387129758793],
            [33.981404812791084, 1.638515710608332],
            [34.000762180352176, 1.644702015778563],
            [34.005035777874156, 1.64724844307448],
            [34.01001721909392, 1.648726589540639],
            [34.02814118449856, 1.647718622689281],
            [34.02679781956817, 1.652748590644601],
            [34.02671101895553, 1.657109269386543],
            [34.02961751446402, 1.671198397854718],
            [34.03260292876688, 1.67816497852732],
            [34.03809854858728, 1.68719514413709],
            [34.04074702458998, 1.692337795630984],
            [34.04176657291159, 1.700306940589557],
            [34.04312261307062, 1.706784295660095],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 778,
        District: "KATAKWI",
        County: "TOROMA",
        Subcounty: "TOROMA",
        Population: 11713,
        Key: "KATAKWITOROMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.04205885955221, 1.850767579344048],
            [34.0400633320986, 1.852747728779347],
            [34.03911161286917, 1.852743429894322],
            [34.03785960121328, 1.853369152792882],
            [34.037028364928055, 1.853031817000423],
            [34.03631088769716, 1.853838638756251],
            [34.03509580308766, 1.854190538337652],
            [34.03416016280347, 1.85587791766684],
            [34.03177683264171, 1.856748679855856],
            [34.031617576613186, 1.855151646058976],
            [34.032151658287276, 1.852819138932649],
            [34.03113357332125, 1.851718563911519],
            [34.029613960728774, 1.85102072539763],
            [34.02453834642282, 1.850080453566422],
            [34.02078567205266, 1.848610069553805],
            [34.01720404140417, 1.846163593444744],
            [34.004795325822045, 1.841044249541233],
            [34.002989018601575, 1.840607162770509],
            [34.001494748381546, 1.839575862963584],
            [34.000401386391374, 1.839295618094064],
            [33.997054893361764, 1.839947314304184],
            [33.9933946951602, 1.839000228202855],
            [33.9880343337738, 1.836970381631951],
            [33.98371014582999, 1.837075383814705],
            [33.98100051521767, 1.836269453206532],
            [33.97956347396946, 1.836618834193008],
            [33.97782859359388, 1.836288331484182],
            [33.97350293600624, 1.835199374353824],
            [33.967155760907204, 1.832538828326736],
            [33.96269767188377, 1.830005458016699],
            [33.960224348496865, 1.828124421224767],
            [33.955870113703405, 1.823023862810206],
            [33.95357277746716, 1.819291822312969],
            [33.94983043282445, 1.809270883508439],
            [33.948533102060786, 1.807255937658354],
            [33.946464855984935, 1.806305257246616],
            [33.93535198714964, 1.801995233562719],
            [33.921418259201815, 1.803231070021051],
            [33.915717141675366, 1.80431784936783],
            [33.908862259438976, 1.80422506798032],
            [33.902612220069955, 1.803259396934931],
            [33.898986986994174, 1.80170305912099],
            [33.896894408252216, 1.80025089466911],
            [33.87308451403591, 1.788039504264498],
            [33.86979150041013, 1.785580892076532],
            [33.869839058119574, 1.783212205593916],
            [33.87167063674562, 1.774526957162755],
            [33.871666208051266, 1.771071301869417],
            [33.871070460626214, 1.769253686695772],
            [33.87534530231484, 1.767620903549969],
            [33.88730476144023, 1.764503272795138],
            [33.89672153376399, 1.761104418282283],
            [33.902732252059884, 1.760709584155666],
            [33.90498750042845, 1.759057141349375],
            [33.90863322138089, 1.757891272279781],
            [33.91255307671701, 1.757500864981967],
            [33.921642802090254, 1.75899779338394],
            [33.927204470541916, 1.760681335601694],
            [33.9349656981027, 1.763900309484944],
            [33.9401435011621, 1.762432600575944],
            [33.942114501015205, 1.761568734703899],
            [33.94385927004548, 1.760263602461923],
            [33.947254972786354, 1.758680305935072],
            [33.951461481427934, 1.75962641643384],
            [33.96083878267647, 1.75958067693323],
            [33.96212959436609, 1.75665409809794],
            [33.96209650043102, 1.755126131219248],
            [33.968154718045874, 1.756082024271352],
            [33.97793644532686, 1.756698350759327],
            [33.989229166763536, 1.75195146950594],
            [33.991127651911945, 1.750108711653425],
            [33.99255223352718, 1.749317639749603],
            [33.99357232892278, 1.748049860462306],
            [33.99499684585932, 1.747211038392847],
            [33.99512250220125, 1.746589590765674],
            [33.998386304410644, 1.743203663996117],
            [34.001909824840055, 1.744068007045119],
            [34.00421180536633, 1.744089686819675],
            [34.01037577355472, 1.742845772874404],
            [34.01401320215879, 1.739378948337296],
            [34.02081652918266, 1.734526844714426],
            [34.02260732429482, 1.725631464504679],
            [34.02524229682219, 1.721317124451363],
            [34.02730027695098, 1.716641420711],
            [34.029369285696504, 1.713423094440395],
            [34.035607540067346, 1.709139599857914],
            [34.04312261307062, 1.706784295660095],
            [34.04488448961716, 1.713550386264234],
            [34.0472690405894, 1.719829210807021],
            [34.05151094015826, 1.72721957556486],
            [34.05342755061413, 1.731674423466542],
            [34.05672745880976, 1.746583016356993],
            [34.05987057325904, 1.756439652478505],
            [34.059687607096926, 1.757427570897107],
            [34.06010974880515, 1.758763713827343],
            [34.06219631781783, 1.760321829818642],
            [34.06299826902481, 1.761850297955872],
            [34.059879371358946, 1.770115476673325],
            [34.05697952877343, 1.77470061429743],
            [34.05743186824821, 1.777240081019802],
            [34.05706344669232, 1.779763904942396],
            [34.05769265815834, 1.782649624271988],
            [34.05725644434123, 1.784386915416628],
            [34.05700728312245, 1.78944868446369],
            [34.057644022470555, 1.790690496697217],
            [34.05759065625448, 1.791953004130638],
            [34.05675249844999, 1.793140477044497],
            [34.05650760872039, 1.794664188008995],
            [34.056941142863025, 1.798128509233104],
            [34.057586471003575, 1.800684995028169],
            [34.057739746048924, 1.803592395491805],
            [34.05742806747626, 1.804115139964921],
            [34.0577433240387, 1.805415047839105],
            [34.057448904797596, 1.807367397247247],
            [34.0558366696111, 1.811338954774813],
            [34.05539438767421, 1.814410425688806],
            [34.05461239703287, 1.816324827961144],
            [34.053631897578335, 1.817416371602138],
            [34.05146200353481, 1.818454869742698],
            [34.05036222128532, 1.819617325262028],
            [34.04805955983605, 1.823681065230577],
            [34.04774906434462, 1.826550618113582],
            [34.04619644495363, 1.827877830776392],
            [34.04611985638916, 1.829021106459166],
            [34.04665904139233, 1.830786633046365],
            [34.045419429182346, 1.831305182942033],
            [34.04510665017344, 1.832066180783339],
            [34.045646162163415, 1.833760226116197],
            [34.04633429951884, 1.834168376695073],
            [34.04629073931238, 1.835895536491151],
            [34.045263845466685, 1.836724778244996],
            [34.04371711004084, 1.836765426777325],
            [34.043382484902544, 1.837097473706047],
            [34.0429637666739, 1.840216721099941],
            [34.041908516607954, 1.842046509301723],
            [34.041880705665086, 1.845536827397841],
            [34.040796988886086, 1.848390985709012],
            [34.04090966367385, 1.849773365619394],
            [34.04205885955221, 1.850767579344048],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 779,
        District: "KATAKWI",
        County: "TOROMA",
        Subcounty: "OMODOI",
        Population: 16868,
        Key: "KATAKWIOMODOI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.22057943809945, 3.602581191622121],
            [34.21753493980373, 3.604109586835499],
            [34.21165966499483, 3.605429489752221],
            [34.20968144358517, 3.606928002226215],
            [34.206215722557765, 3.607280841008729],
            [34.20358298324221, 3.608468281764501],
            [34.2019536441327, 3.608296337224546],
            [34.19769323657407, 3.610600219042665],
            [34.19431770729951, 3.611852997328364],
            [34.19337475023733, 3.610023547823241],
            [34.18847082823674, 3.607035417971577],
            [34.18744855173161, 3.605929171101256],
            [34.186499280411304, 3.598136282775151],
            [34.18551769579194, 3.5969069123368],
            [34.18286200901243, 3.595720743938699],
            [34.18008467507211, 3.595191070167288],
            [34.16620067246855, 3.59463468882196],
            [34.16061020133393, 3.597554417141023],
            [34.16007931496731, 3.597514072611941],
            [34.158934525325435, 3.596366915524663],
            [34.15807702409794, 3.596368009311086],
            [34.15840571316881, 3.597967453568456],
            [34.15750872559471, 3.599035173983605],
            [34.15734592301744, 3.600256708459065],
            [34.15624787002483, 3.600930094939449],
            [34.15505540858745, 3.602515581917066],
            [34.15362199024477, 3.602469408303214],
            [34.153049616085106, 3.603238122194071],
            [34.15013644519572, 3.604297802546924],
            [34.14804093435266, 3.60967636633337],
            [34.1426289881094, 3.604910736079608],
            [34.14229213335258, 3.603480553608069],
            [34.14234495429128, 3.598812164111656],
            [34.14126012809293, 3.598416282544413],
            [34.13675340248338, 3.598752725046629],
            [34.13348009070838, 3.598320832855292],
            [34.12955863187951, 3.59978982580978],
            [34.126056434759995, 3.600385453733314],
            [34.12560778286943, 3.600160763174788],
            [34.12266483193007, 3.601109351272072],
            [34.11934544017426, 3.600737166307125],
            [34.120139505969654, 3.600082836593389],
            [34.12168439266267, 3.599881918688834],
            [34.12318858746996, 3.598805414929629],
            [34.124924484738465, 3.592833019263618],
            [34.12488330147427, 3.591559418404661],
            [34.12290087864401, 3.590328016480537],
            [34.121988149891166, 3.589095289583025],
            [34.12246103832808, 3.587025019061658],
            [34.12241816712947, 3.584358359920211],
            [34.12027554593796, 3.581694280478308],
            [34.12007590434922, 3.580420871205528],
            [34.11928195084323, 3.579108387939682],
            [34.11817250811116, 3.578990341942073],
            [34.116192480189454, 3.5797091989311],
            [34.113886603669805, 3.581513171624912],
            [34.112422259925154, 3.57544097280926],
            [34.11394440756341, 3.574980184000708],
            [34.118881873555054, 3.574624490615732],
            [34.11951214503311, 3.574164788037407],
            [34.11961485930101, 3.573555418354363],
            [34.117918584923075, 3.569533716591743],
            [34.115573322668084, 3.565339115745051],
            [34.114854938138755, 3.562168936382889],
            [34.11419898472501, 3.561391930489358],
            [34.112053922810915, 3.560257741152363],
            [34.11170501176465, 3.557849431136544],
            [34.11279092851778, 3.556427612021897],
            [34.11312324049418, 3.555185112516447],
            [34.11274370049001, 3.553324411209655],
            [34.11382840451749, 3.550897312063234],
            [34.116370716721626, 3.548643278563016],
            [34.12002200004229, 3.540396094617253],
            [34.122286854994485, 3.541322986670233],
            [34.12657111911213, 3.541605177118856],
            [34.13454478386461, 3.538993901268867],
            [34.13454224792054, 3.539740365348379],
            [34.1355030068967, 3.539739183627616],
            [34.138146979644894, 3.541280508452977],
            [34.13834090345687, 3.542728316379861],
            [34.13891783207502, 3.543113748794765],
            [34.14093543023686, 3.543111254458496],
            [34.14175332025191, 3.544123872838748],
            [34.14189850147655, 3.544992520947373],
            [34.145355816967815, 3.543829794274935],
            [34.14597959721964, 3.543249802185792],
            [34.15131353645859, 3.544642927184284],
            [34.154252341672915, 3.544634844364632],
            [34.15844280640353, 3.550661012870882],
            [34.16044600996124, 3.55781680803356],
            [34.16339911455827, 3.560014414260734],
            [34.16438991050257, 3.561668877878463],
            [34.16464219606191, 3.565725073968499],
            [34.16497229099621, 3.566138583805994],
            [34.1646434474151, 3.566718504120087],
            [34.165387179706826, 3.568456064468442],
            [34.168477564845546, 3.56983484925471],
            [34.1695033402887, 3.571376581922691],
            [34.171329563159055, 3.576174822270278],
            [34.1754779597849, 3.573197710723074],
            [34.17732809850305, 3.567350357260399],
            [34.17831106742628, 3.56644626796257],
            [34.180021865765745, 3.565885172885103],
            [34.18100395164507, 3.564293216381095],
            [34.182546120934326, 3.565709950520262],
            [34.18323094440466, 3.565881032496729],
            [34.184856269841504, 3.56540602456624],
            [34.187553270140896, 3.566477320855943],
            [34.18849575918082, 3.567378920335513],
            [34.188754862953154, 3.56922722053139],
            [34.1893545009817, 3.569699347592918],
            [34.18939811868033, 3.570344163110662],
            [34.1919677163129, 3.572146460610542],
            [34.193122932700284, 3.572101962944858],
            [34.193508744741756, 3.572660347481548],
            [34.19427825868215, 3.572143445445693],
            [34.19474920226644, 3.572357787509676],
            [34.195347729977335, 3.571970082864482],
            [34.19723028080923, 3.57188163621481],
            [34.19783053687871, 3.572826660207877],
            [34.19890095679487, 3.573384145045129],
            [34.202151539396546, 3.572391076248171],
            [34.20416825002285, 3.572934338176243],
            [34.20452026385009, 3.573790105018278],
            [34.2073280246274, 3.574239698084456],
            [34.208881396806596, 3.573784346359613],
            [34.21048621819706, 3.574336253066387],
            [34.21164114532694, 3.575845712541764],
            [34.2121444120918, 3.577356036510288],
            [34.21500423383309, 3.579266153457687],
            [34.2153595193246, 3.582589855359692],
            [34.2173193872547, 3.586263976784659],
            [34.21797499571533, 3.589234708106219],
            [34.22008581834242, 3.593311541788704],
            [34.220292364382416, 3.597844221702923],
            [34.219993937756826, 3.599607438489083],
            [34.22057943809945, 3.602581191622121],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 780,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAABONG EAST",
        Population: 9493,
        Key: "KAABONGKAABONG EAST",
        Dist2: "Kaabong",
        "Sub Country": "Kaaabong East",
        id2_original: "KaabongKaaabong East",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.13454478386461, 3.538993901268867],
            [34.12657111911213, 3.541605177118856],
            [34.122286854994485, 3.541322986670233],
            [34.12002200004229, 3.540396094617253],
            [34.12148302361364, 3.538761739545429],
            [34.122043936168616, 3.537414885694492],
            [34.1207956129953, 3.536903727277141],
            [34.116068068912504, 3.537047145389925],
            [34.112846205450474, 3.535765900835201],
            [34.11049360395963, 3.535631039726833],
            [34.11029660790938, 3.534771769409748],
            [34.11077218949553, 3.534113055840484],
            [34.11053322774847, 3.533455200753536],
            [34.110954971503006, 3.530882570948849],
            [34.11191150390576, 3.530422489730686],
            [34.11230225757962, 3.529766400145501],
            [34.11386783696521, 3.52930558494613],
            [34.11477958745272, 3.527774712663437],
            [34.11582270846569, 3.526964861811082],
            [34.11616718273277, 3.525905359535505],
            [34.116618985913306, 3.526036711809683],
            [34.11701670063231, 3.524996571790155],
            [34.11851594392574, 3.523639821734591],
            [34.11873066463486, 3.522859865002474],
            [34.118132446842765, 3.52197107246494],
            [34.118464520765635, 3.520821907911024],
            [34.118893417804756, 3.52096499048071],
            [34.12027289590789, 3.519335917284953],
            [34.11984297928089, 3.518331271532843],
            [34.119937330233505, 3.517565321880771],
            [34.12074598466912, 3.516607049397958],
            [34.12060165594566, 3.515410600988788],
            [34.12255469667963, 3.515408243761772],
            [34.123578682678726, 3.51374476895014],
            [34.124220316946804, 3.514066015846483],
            [34.12512463836692, 3.513442683755917],
            [34.12450188758442, 3.510523688950791],
            [34.12364290772994, 3.50923236919903],
            [34.12404330930997, 3.507692990762763],
            [34.12535987480048, 3.506278469633104],
            [34.12768921351872, 3.506628884788809],
            [34.12865466170066, 3.505568017143943],
            [34.12812587739182, 3.504332344719506],
            [34.12610461320532, 3.504378942870263],
            [34.12513705038921, 3.503673646390061],
            [34.12491649691895, 3.502967446464905],
            [34.125880837478164, 3.500979347487136],
            [34.123726752885325, 3.500187170352213],
            [34.12324239565717, 3.499348825432587],
            [34.1233293840177, 3.498598099533955],
            [34.125828934617665, 3.494312139963511],
            [34.12691173780999, 3.490826015566987],
            [34.126260832029864, 3.489749839470507],
            [34.12577895864345, 3.48915449626561],
            [34.125874330082226, 3.488347813888344],
            [34.12760918261007, 3.489087766665424],
            [34.12895782244778, 3.489086141038664],
            [34.13028907898646, 3.491492313945082],
            [34.13580023337306, 3.495788818376316],
            [34.13868093106324, 3.497231757398052],
            [34.14282082603326, 3.498383855191567],
            [34.14861912151054, 3.501992839302127],
            [34.149313106898475, 3.505228280510508],
            [34.148875983986265, 3.50624651988283],
            [34.14984293774461, 3.510014062447242],
            [34.15060702406404, 3.511592643043192],
            [34.15213261853802, 3.512643771851451],
            [34.15251487055602, 3.513600583317982],
            [34.15327772708182, 3.514174008196237],
            [34.15375461481838, 3.516001122485128],
            [34.15369309010288, 3.516918376859208],
            [34.15191995497092, 3.51804666389225],
            [34.151692237436265, 3.518574720554858],
            [34.14966998150971, 3.519373023952031],
            [34.14819229688476, 3.521766924928758],
            [34.1479696251871, 3.525020822555606],
            [34.14657774494314, 3.525412980666037],
            [34.1454758920769, 3.5246660101324],
            [34.14424583344994, 3.52499289207918],
            [34.139982613266135, 3.524320886410577],
            [34.13838496132995, 3.525000112525697],
            [34.13615797126531, 3.525306162392241],
            [34.13490742296502, 3.524004451605385],
            [34.13284118192885, 3.523476027718988],
            [34.130585943441794, 3.52555432130314],
            [34.12928957657042, 3.526086854987192],
            [34.128857998060155, 3.526714870597509],
            [34.12862055087271, 3.528983774856128],
            [34.1273720408498, 3.529371443754023],
            [34.126890327363505, 3.52826185675436],
            [34.126313643985426, 3.528069484917902],
            [34.12618216656044, 3.528921359907233],
            [34.12771750865356, 3.530527247005716],
            [34.131052131344994, 3.530618904792434],
            [34.13291190090129, 3.532244027489308],
            [34.133391282361096, 3.534732399426344],
            [34.13553711502973, 3.536548619031837],
            [34.13530085810999, 3.538128440335096],
            [34.13454478386461, 3.538993901268867],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 781,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAABONG TOWN COUNCIL",
        Population: 11559,
        Key: "KAABONGKAABONG TOWN COUNCIL",
        Dist2: "Kaabong",
        "Sub Country": "Kaabong TC",
        id2_original: "KaabongKaabong TC",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "N",
        "Environmental degradation": "N",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.1805236907346, 3.498083135103749],
              [34.17717417307743, 3.502582213513112],
              [34.1726643042627, 3.507240276484558],
              [34.16901173635116, 3.511839817521737],
              [34.16361256594788, 3.51535420507021],
              [34.16251931265383, 3.517321597331803],
              [34.1618445045006, 3.520127301706677],
              [34.160099043767595, 3.522095510572514],
              [34.159396971745494, 3.523957558551291],
              [34.156500216669606, 3.523174767877634],
              [34.15298631989186, 3.523233851381844],
              [34.153886191956374, 3.520816407148813],
              [34.15259133335636, 3.52045258388394],
              [34.15229227611345, 3.520802607273974],
              [34.14966998150971, 3.519373023952031],
              [34.151692237436265, 3.518574720554858],
              [34.15191995497092, 3.51804666389225],
              [34.15369309010288, 3.516918376859208],
              [34.15375461481838, 3.516001122485128],
              [34.15327772708182, 3.514174008196237],
              [34.15251487055602, 3.513600583317982],
              [34.15213261853802, 3.512643771851451],
              [34.15060702406404, 3.511592643043192],
              [34.14984293774461, 3.510014062447242],
              [34.148875983986265, 3.50624651988283],
              [34.149313106898475, 3.505228280510508],
              [34.14861912151054, 3.501992839302127],
              [34.14282082603326, 3.498383855191567],
              [34.13868093106324, 3.497231757398052],
              [34.13580023337306, 3.495788818376316],
              [34.13028907898646, 3.491492313945082],
              [34.12895782244778, 3.489086141038664],
              [34.12892509592369, 3.488569981533734],
              [34.12786413886075, 3.4874743266819],
              [34.12911328848412, 3.484827280672895],
              [34.12972280708251, 3.484342606653855],
              [34.13013800930514, 3.482470870390001],
              [34.1308118607526, 3.482082904983788],
              [34.131293822173866, 3.482340426589396],
              [34.13062008391415, 3.482825179648565],
              [34.1316182406539, 3.485114623342223],
              [34.13206809628694, 3.485372182674388],
              [34.13412288290488, 3.485143858744201],
              [34.13447505303898, 3.484272342099121],
              [34.13370232043496, 3.482531094320623],
              [34.13389417183354, 3.481853347352226],
              [34.132288467399164, 3.481693973717949],
              [34.13148266691122, 3.479146194994895],
              [34.131126801108024, 3.476920498414132],
              [34.13202334132115, 3.474790085045829],
              [34.13298686890503, 3.474982500108498],
              [34.134465817459564, 3.476561582575368],
              [34.135300214017946, 3.476173423747249],
              [34.136713207365986, 3.476300767743091],
              [34.13674863153093, 3.475279379104796],
              [34.14507071774779, 3.472398988146753],
              [34.14997055870209, 3.471328147684834],
              [34.149548843693616, 3.471265576460858],
              [34.15220728830106, 3.470269296254543],
              [34.15363390010883, 3.469269442668301],
              [34.15729527869667, 3.468204461088128],
              [34.159727835637675, 3.466907910291217],
              [34.161140979004394, 3.465579706970414],
              [34.16399492217045, 3.464203795151613],
              [34.16920768406746, 3.462700193888014],
              [34.172001672773135, 3.46307101207445],
              [34.173088813031676, 3.463693472829112],
              [34.17293492353867, 3.464754143799737],
              [34.17358724686032, 3.465158809688487],
              [34.17368136514928, 3.465969648252645],
              [34.17293723041232, 3.466625576263081],
              [34.17315716045174, 3.468777453693556],
              [34.172316446940265, 3.469296764173233],
              [34.17356491025079, 3.472207909486824],
              [34.173348404589206, 3.47283199077755],
              [34.17372207410301, 3.473798432658433],
              [34.17300901299005, 3.474485516104488],
              [34.17301051676983, 3.475701946844389],
              [34.17444173603668, 3.478444928881482],
              [34.17562934028331, 3.482472271864054],
              [34.17634328533855, 3.482785073115065],
              [34.17714742753648, 3.483904407814257],
              [34.176881070766505, 3.48489064632898],
              [34.17844733646498, 3.489190798041248],
              [34.17764804516957, 3.491970257628603],
              [34.1805236907346, 3.498083135103749],
            ],
          ],
          [
            [
              [34.113886603669805, 3.581513171624912],
              [34.110450707608166, 3.582064513326455],
              [34.10414880131126, 3.579883056744548],
              [34.100345698215975, 3.580086662459699],
              [34.09483503251289, 3.576948928719145],
              [34.09154734410007, 3.577470292042591],
              [34.08552528367542, 3.577397865744104],
              [34.083027556655495, 3.575888346961059],
              [34.08080637419913, 3.573701855789091],
              [34.07755638448553, 3.572591230041391],
              [34.073155899929716, 3.570128658619267],
              [34.070926745823535, 3.569988157714891],
              [34.068428083657366, 3.568933041490312],
              [34.062850907588945, 3.565283106601727],
              [34.05784576791369, 3.564546184831461],
              [34.05506430262139, 3.564786231742264],
              [34.05409200658204, 3.563669608763381],
              [34.053629991353326, 3.56189270192533],
              [34.05490194471018, 3.560255998197804],
              [34.05514817472619, 3.558975961242396],
              [34.05436730608062, 3.556843935036018],
              [34.05492899837326, 3.552932930183382],
              [34.057297342839476, 3.550868384461258],
              [34.06178915731364, 3.549227973481662],
              [34.06582199106808, 3.548476792012514],
              [34.068263387431514, 3.548438412450713],
              [34.071832824348334, 3.544737215086159],
              [34.07151097864329, 3.541787060416684],
              [34.070623952487324, 3.539655179236747],
              [34.06994731536421, 3.535852266340258],
              [34.06810407840239, 3.532939414552791],
              [34.0642248915958, 3.524610230749478],
              [34.06311343753579, 3.519543045722228],
              [34.06307253634262, 3.517218424696358],
              [34.06321010075196, 3.514920495792754],
              [34.06593823935407, 3.514558378298539],
              [34.06902450302228, 3.514913826692763],
              [34.07688521540755, 3.51483947940494],
              [34.079742404186725, 3.513726552188072],
              [34.08376940068846, 3.513003884333464],
              [34.09114043422584, 3.510873958157287],
              [34.09256802250232, 3.509468958680614],
              [34.094127014541925, 3.509336586395585],
              [34.095521543917634, 3.507442091471784],
              [34.09948183871288, 3.505283488999535],
              [34.10016396005085, 3.505282683821586],
              [34.10022815994925, 3.504629900367734],
              [34.10393002560695, 3.503711733702934],
              [34.10448141691825, 3.503025740414714],
              [34.1060075270252, 3.502567035237237],
              [34.10639596484225, 3.501424339358545],
              [34.11013001983151, 3.500277669075867],
              [34.11379836665101, 3.498510994434903],
              [34.11668911020103, 3.498409637214904],
              [34.11818194221827, 3.497298254188896],
              [34.11876696106392, 3.497591267890145],
              [34.12013040873078, 3.496936933262898],
              [34.12113640057642, 3.496152481777338],
              [34.120778176695644, 3.495369666907861],
              [34.1218806422129, 3.493769223837014],
              [34.122756978416966, 3.493213375067881],
              [34.12278825595855, 3.4922016482271],
              [34.12346903970502, 3.491091237883586],
              [34.12460615683609, 3.491318314924917],
              [34.12570993479196, 3.490827462757668],
              [34.126260832029864, 3.489749839470507],
              [34.12691173780999, 3.490826015566987],
              [34.125828934617665, 3.494312139963511],
              [34.1233293840177, 3.498598099533955],
              [34.12324239565717, 3.499348825432587],
              [34.123726752885325, 3.500187170352213],
              [34.125880837478164, 3.500979347487136],
              [34.12491649691895, 3.502967446464905],
              [34.12513705038921, 3.503673646390061],
              [34.12610461320532, 3.504378942870263],
              [34.12812587739182, 3.504332344719506],
              [34.12865466170066, 3.505568017143943],
              [34.12768921351872, 3.506628884788809],
              [34.12535987480048, 3.506278469633104],
              [34.12404330930997, 3.507692990762763],
              [34.12364290772994, 3.50923236919903],
              [34.12450188758442, 3.510523688950791],
              [34.12512463836692, 3.513442683755917],
              [34.124220316946804, 3.514066015846483],
              [34.123578682678726, 3.51374476895014],
              [34.12255469667963, 3.515408243761772],
              [34.12060165594566, 3.515410600988788],
              [34.12074598466912, 3.516607049397958],
              [34.119937330233505, 3.517565321880771],
              [34.11984297928089, 3.518331271532843],
              [34.12027289590789, 3.519335917284953],
              [34.118893417804756, 3.52096499048071],
              [34.118464520765635, 3.520821907911024],
              [34.118132446842765, 3.52197107246494],
              [34.11873066463486, 3.522859865002474],
              [34.11851594392574, 3.523639821734591],
              [34.11701670063231, 3.524996571790155],
              [34.116618985913306, 3.526036711809683],
              [34.11616718273277, 3.525905359535505],
              [34.11582270846569, 3.526964861811082],
              [34.11477958745272, 3.527774712663437],
              [34.11386783696521, 3.52930558494613],
              [34.11230225757962, 3.529766400145501],
              [34.11191150390576, 3.530422489730686],
              [34.110954971503006, 3.530882570948849],
              [34.11053322774847, 3.533455200753536],
              [34.11077218949553, 3.534113055840484],
              [34.11029660790938, 3.534771769409748],
              [34.11049360395963, 3.535631039726833],
              [34.112846205450474, 3.535765900835201],
              [34.116068068912504, 3.537047145389925],
              [34.1207956129953, 3.536903727277141],
              [34.122043936168616, 3.537414885694492],
              [34.12148302361364, 3.538761739545429],
              [34.12002200004229, 3.540396094617253],
              [34.116370716721626, 3.548643278563016],
              [34.11382840451749, 3.550897312063234],
              [34.11274370049001, 3.553324411209655],
              [34.11312324049418, 3.555185112516447],
              [34.11279092851778, 3.556427612021897],
              [34.11170501176465, 3.557849431136544],
              [34.112053922810915, 3.560257741152363],
              [34.11419898472501, 3.561391930489358],
              [34.114854938138755, 3.562168936382889],
              [34.115573322668084, 3.565339115745051],
              [34.117918584923075, 3.569533716591743],
              [34.11961485930101, 3.573555418354363],
              [34.11951214503311, 3.574164788037407],
              [34.118881873555054, 3.574624490615732],
              [34.11394440756341, 3.574980184000708],
              [34.112422259925154, 3.57544097280926],
              [34.113886603669805, 3.581513171624912],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 782,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAABONG WEST",
        Population: 13210,
        Key: "KAABONGKAABONG WEST",
        Dist2: "Kaabong",
        "Sub Country": "Kaabong West",
        id2_original: "KaabongKaabong West",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.306748580912135, 3.6035302057427],
            [34.30645851041532, 3.605478242553557],
            [34.30676560308847, 3.606704797050633],
            [34.305035775736314, 3.607014040973361],
            [34.30290013445459, 3.608244113192619],
            [34.30280054093399, 3.609778003598494],
            [34.301988188134345, 3.611108422668163],
            [34.301888740140804, 3.612744562877967],
            [34.29893751931093, 3.613055557459877],
            [34.29558352445039, 3.616434626625799],
            [34.29494724324308, 3.616555419212189],
            [34.292253429267966, 3.623320206881916],
            [34.29108981992087, 3.629408424312259],
            [34.28794858923874, 3.636939073025137],
            [34.28286027724625, 3.640228856266141],
            [34.27518909052133, 3.641806257009148],
            [34.274964714719545, 3.642951063299183],
            [34.272618377181196, 3.644313807010445],
            [34.27126520174958, 3.644355709361994],
            [34.26935229235264, 3.642599178861493],
            [34.260763271749106, 3.642931100034117],
            [34.26039791434664, 3.643211551235285],
            [34.25908681690127, 3.644892677873345],
            [34.257499832459075, 3.648533355046057],
            [34.256677479613714, 3.658210387942371],
            [34.255247960857695, 3.660611376570066],
            [34.24825263870475, 3.66769819501897],
            [34.24790525120123, 3.675495384798806],
            [34.24742917913493, 3.676615578586035],
            [34.24397077847881, 3.679819078610284],
            [34.242063731487406, 3.682340688905955],
            [34.23852391382214, 3.684264832093743],
            [34.23666639993552, 3.685861412020943],
            [34.23630282029899, 3.68531522203896],
            [34.23298450023331, 3.684630385480856],
            [34.23092646979888, 3.685380157845124],
            [34.226005788828296, 3.684065515228344],
            [34.22388984310916, 3.684298257453641],
            [34.224182588788906, 3.689238974583793],
            [34.22452702891999, 3.69015777552772],
            [34.225614789016056, 3.69090318468024],
            [34.22584546649955, 3.692281781629849],
            [34.227164622731316, 3.694922875514311],
            [34.227223560298825, 3.696186799936402],
            [34.22648245108772, 3.697968929719466],
            [34.2257441841462, 3.701819428333018],
            [34.22586174307419, 3.704117458157181],
            [34.224602688626454, 3.703602113336527],
            [34.217566923421124, 3.70326712290631],
            [34.2140219260699, 3.704191288844088],
            [34.20927389051718, 3.703738169490104],
            [34.20291638928394, 3.703789156253507],
            [34.198521771625224, 3.70455721949088],
            [34.191883713054025, 3.702267992958201],
            [34.18742180259737, 3.701929273725467],
            [34.18433394621615, 3.702565435470727],
            [34.184128087387336, 3.702891343437186],
            [34.17760470774533, 3.700439251437837],
            [34.17438848480497, 3.700253508551499],
            [34.17136068439373, 3.69949742165042],
            [34.16877313123528, 3.697853944516733],
            [34.16328589898471, 3.696974389874714],
            [34.16082711752558, 3.697357676895427],
            [34.159693711335, 3.698626022695991],
            [34.15906617522696, 3.70097052518212],
            [34.1577436718724, 3.702302459304049],
            [34.15534800963843, 3.702748997729946],
            [34.15004778147716, 3.700222205671941],
            [34.144183708659845, 3.700546537658714],
            [34.14216419708646, 3.699282291353745],
            [34.13711801787744, 3.698148624772106],
            [34.13572951080737, 3.697200261943766],
            [34.129547877248925, 3.695751287193222],
            [34.12513070828331, 3.693349866978948],
            [34.120900987174764, 3.689554623952068],
            [34.116421992558045, 3.688103376760043],
            [34.11036850367484, 3.688237671964545],
            [34.10646036416667, 3.6907138181301],
            [34.10625050693651, 3.687204605893252],
            [34.10398358675745, 3.682529073822027],
            [34.10352323610696, 3.678348970060469],
            [34.10295683933718, 3.677214553331342],
            [34.1031788085523, 3.67008433321188],
            [34.10428701430425, 3.666103667780044],
            [34.10526761886165, 3.664852756978538],
            [34.10523362750961, 3.663833309128803],
            [34.10693126553017, 3.659983461185928],
            [34.10719102597099, 3.658240142275571],
            [34.10666488270908, 3.656333365348472],
            [34.10610705227383, 3.655281681755078],
            [34.105615744780316, 3.65508496989275],
            [34.106005050369966, 3.652190455525261],
            [34.10678978266955, 3.651400205609993],
            [34.10619679846228, 3.648375362209345],
            [34.10868144960495, 3.645609808008478],
            [34.108974712714286, 3.644491296716017],
            [34.10861287041954, 3.643077617730921],
            [34.10975796998021, 3.634231288791954],
            [34.11243019025249, 3.623906188060935],
            [34.11237671983183, 3.622402071695861],
            [34.1106971559148, 3.621133368727601],
            [34.11069658638291, 3.620666555086128],
            [34.112321001826324, 3.619056633667978],
            [34.11291472624537, 3.61902996925513],
            [34.1158535943418, 3.615680837633344],
            [34.116315445178806, 3.613372127451987],
            [34.11590145298686, 3.612594613724491],
            [34.116130523384314, 3.609923115525811],
            [34.115792770312225, 3.608160009283634],
            [34.117030851793, 3.607302659096139],
            [34.11718400287084, 3.60587608984405],
            [34.118628345625666, 3.604811009689018],
            [34.11822893668406, 3.603503037915285],
            [34.118634347270074, 3.603354369288013],
            [34.11859584457868, 3.602020901389965],
            [34.11934544017426, 3.600737166307125],
            [34.12266483193007, 3.601109351272072],
            [34.12560778286943, 3.600160763174788],
            [34.126056434759995, 3.600385453733314],
            [34.12955863187951, 3.59978982580978],
            [34.13348009070838, 3.598320832855292],
            [34.13675340248338, 3.598752725046629],
            [34.14126012809293, 3.598416282544413],
            [34.14234495429128, 3.598812164111656],
            [34.14229213335258, 3.603480553608069],
            [34.1426289881094, 3.604910736079608],
            [34.14804093435266, 3.60967636633337],
            [34.15013644519572, 3.604297802546924],
            [34.153049616085106, 3.603238122194071],
            [34.15362199024477, 3.602469408303214],
            [34.15505540858745, 3.602515581917066],
            [34.15624787002483, 3.600930094939449],
            [34.15734592301744, 3.600256708459065],
            [34.15750872559471, 3.599035173983605],
            [34.15840571316881, 3.597967453568456],
            [34.15807702409794, 3.596368009311086],
            [34.158934525325435, 3.596366915524663],
            [34.16007931496731, 3.597514072611941],
            [34.16061020133393, 3.597554417141023],
            [34.16620067246855, 3.59463468882196],
            [34.18008467507211, 3.595191070167288],
            [34.18286200901243, 3.595720743938699],
            [34.18551769579194, 3.5969069123368],
            [34.186499280411304, 3.598136282775151],
            [34.18744855173161, 3.605929171101256],
            [34.18847082823674, 3.607035417971577],
            [34.19337475023733, 3.610023547823241],
            [34.19431770729951, 3.611852997328364],
            [34.19769323657407, 3.610600219042665],
            [34.2019536441327, 3.608296337224546],
            [34.20358298324221, 3.608468281764501],
            [34.206215722557765, 3.607280841008729],
            [34.20968144358517, 3.606928002226215],
            [34.21165966499483, 3.605429489752221],
            [34.21753493980373, 3.604109586835499],
            [34.22057943809945, 3.602581191622121],
            [34.222570055361736, 3.602369063032166],
            [34.22802259826932, 3.598894208627236],
            [34.230583661906664, 3.598931890360357],
            [34.231210313174124, 3.59929399353653],
            [34.235390015189346, 3.597337899687578],
            [34.242275472484714, 3.596255577923192],
            [34.24801024898657, 3.593743063388787],
            [34.25831992604153, 3.591787461493145],
            [34.25991043187961, 3.592697531764409],
            [34.26065494570562, 3.592679500353734],
            [34.26318559059085, 3.591678445399397],
            [34.26427824470857, 3.591976188990577],
            [34.266759781392146, 3.59137421337053],
            [34.26854549653135, 3.59022455435388],
            [34.27058082025038, 3.590072083971681],
            [34.272067126905405, 3.587825545868254],
            [34.27315956632579, 3.587973648611996],
            [34.27425304240203, 3.5888699032071],
            [34.276883359859575, 3.588167941810109],
            [34.2776288267981, 3.588715540870351],
            [34.27743072312513, 3.589064957388453],
            [34.2840860482144, 3.590950903959266],
            [34.28478368974552, 3.592795355209398],
            [34.28766566304336, 3.594536959711765],
            [34.28845742196511, 3.592690404193124],
            [34.292078200295386, 3.590241314501967],
            [34.29361682752749, 3.589939871169184],
            [34.2947595420611, 3.590536760699129],
            [34.297540175513454, 3.590832057973104],
            [34.297640246039485, 3.591380557366392],
            [34.29918063127461, 3.592326008605072],
            [34.29943020751504, 3.593273303066171],
            [34.30052349494505, 3.594019885346191],
            [34.30107180323828, 3.595565267456106],
            [34.302759437619834, 3.595313465912923],
            [34.30375329412431, 3.595960432127874],
            [34.3039045776047, 3.597606132548886],
            [34.30504702174535, 3.598003501835632],
            [34.304552471333686, 3.599350871142016],
            [34.305595481853885, 3.599648629262064],
            [34.305299379169924, 3.60089596000829],
            [34.306642482690556, 3.602739448870705],
            [34.306748580912135, 3.6035302057427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 783,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KALAPATA",
        Population: 24716,
        Key: "KAABONGKALAPATA",
        Dist2: "Kaabong",
        "Sub Country": "Kalapata",
        id2_original: "KaabongKalapata",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.455801568684194, 3.617035209494321],
            [34.463969090773276, 3.666788257689546],
            [34.45654788812393, 3.673588426821141],
            [34.422784016467524, 3.685861659443126],
            [34.40565163572797, 3.69003415557485],
            [34.403598900862136, 3.702529256934163],
            [34.39497223366166, 3.715029288012896],
            [34.38309865707072, 3.724820029507176],
            [34.373918435415746, 3.729177576653548],
            [34.36581725301208, 3.732447595439571],
            [34.35516413115939, 3.732442658910375],
            [34.32623805831217, 3.725381205605552],
            [34.31932067938319, 3.71894637217255],
            [34.31651072042838, 3.713460473749362],
            [34.30603793177572, 3.683238233847693],
            [34.30335241014901, 3.682874390334679],
            [34.30543361082957, 3.687284816270158],
            [34.30715300694463, 3.694638087390352],
            [34.308662627576226, 3.708989769170696],
            [34.29822450940193, 3.718399965045081],
            [34.28698807280773, 3.726381857499282],
            [34.284040179337666, 3.728053341094161],
            [34.27851712317185, 3.734174403668672],
            [34.2712583547905, 3.741091982927052],
            [34.26719093230432, 3.745528388653097],
            [34.25870430347351, 3.763814026269185],
            [34.258421361108454, 3.763712677315163],
            [34.24632861894439, 3.78117909361836],
            [34.24017275805139, 3.780172952444725],
            [34.236128153671785, 3.778148745864846],
            [34.23392345170763, 3.7780596178031],
            [34.2297196730462, 3.771408869878063],
            [34.22756301298342, 3.771411928292193],
            [34.22757332743952, 3.778750032197526],
            [34.22676317551234, 3.779838308602994],
            [34.221083732537025, 3.78147703908872],
            [34.21269342556255, 3.77790798363956],
            [34.1865387712495, 3.768198518716983],
            [34.176923364348426, 3.765746054277432],
            [34.17162038285082, 3.764997734387986],
            [34.16681601484492, 3.770804945822118],
            [34.19088930857725, 3.780117733925071],
            [34.18897456482051, 3.787532336051164],
            [34.18977017122659, 3.790805415716132],
            [34.189390774054566, 3.792424086684528],
            [34.17131231820054, 3.797541682686663],
            [34.16422367276767, 3.795018100064107],
            [34.162738244665, 3.79697803701275],
            [34.159811756251514, 3.798697449705325],
            [34.1545092032503, 3.797229646856434],
            [34.153916718506345, 3.804254299253679],
            [34.159019732326755, 3.804822325044422],
            [34.16464518565519, 3.807760843256243],
            [34.16934001219703, 3.815605814667663],
            [34.18080532694921, 3.828852578927918],
            [34.22675486789258, 3.828296749893449],
            [34.22580734020224, 3.849411575371799],
            [34.216315889132275, 3.878149435217879],
            [34.20531829391084, 3.879392782931582],
            [34.17573864998205, 3.876979481266028],
            [34.171440245483495, 3.873879224302784],
            [34.16765889599115, 3.867170306795313],
            [34.153336438273854, 3.866085826694844],
            [34.1285526912378, 3.869433054543955],
            [34.11016403813303, 3.865712291314301],
            [34.093407367879614, 3.857180784890657],
            [34.089178351948554, 3.858556599359991],
            [34.092183473492106, 3.882538094954775],
            [34.117061422360415, 3.894736219210579],
            [34.120671593383825, 3.898129676107747],
            [34.13489491482301, 3.952675954748641],
            [34.134502183957196, 3.953053079115849],
            [34.13538477243563, 3.958634788074429],
            [34.10643885400717, 3.973933013945618],
            [34.08286056613236, 3.999554116137058],
            [34.0607958335101, 4.006806364297193],
            [34.05957917415391, 4.024990747354698],
            [34.06619781564025, 4.027428116739785],
            [34.08836262507672, 4.033919460030319],
            [34.09209976667731, 4.046368275685229],
            [34.0923641983576, 4.058572673726835],
            [34.080490534630066, 4.082749202925586],
            [34.06388281044067, 4.091489199428039],
            [34.050275124228605, 4.118407822547494],
            [34.0664296609336, 4.14130148524366],
            [34.04811910915624, 4.176446235851382],
            [33.988505262985115, 4.231367004701014],
            [33.92904678493391, 4.171093490336892],
            [33.8612823669848, 4.103294430979093],
            [34.0092293597588, 3.855116898575957],
            [34.005876574928955, 3.854994025389579],
            [34.00407830852857, 3.842457206734825],
            [34.00486819715789, 3.840067904261416],
            [34.00476585119925, 3.837281591043802],
            [34.00634573535742, 3.832602500510788],
            [34.00851324257725, 3.822051310573582],
            [34.008112257990604, 3.818071168384504],
            [34.00661998921704, 3.812898121180912],
            [34.00701446461112, 3.811305410471055],
            [34.00839917629911, 3.809213958822188],
            [34.0081933668776, 3.802646182435735],
            [34.00878414841579, 3.799460994427533],
            [34.00758813863302, 3.79339195393701],
            [34.007184901969985, 3.787421497483791],
            [34.00955911243497, 3.784234227590364],
            [34.011737111977304, 3.782738948325671],
            [34.01282547394463, 3.781443975074849],
            [34.01073698882541, 3.774679371512738],
            [34.00746386569663, 3.771598205590929],
            [34.00726444958503, 3.770503766168544],
            [34.00518039405849, 3.767520716882178],
            [34.0050791440445, 3.76563003815018],
            [34.00338959535307, 3.76105427296417],
            [34.003287898876394, 3.758765529797105],
            [34.00240267294425, 3.760862192928931],
            [34.00104801259749, 3.761370688973318],
            [34.00114760881305, 3.760031835587593],
            [34.004201196262805, 3.754881762860897],
            [34.00554123383338, 3.745910075097973],
            [34.01201998696871, 3.753272697568175],
            [34.0141251214634, 3.754405679092176],
            [34.014691458046045, 3.755382756051993],
            [34.01578927029017, 3.754340661422342],
            [34.016574166981464, 3.754245125337123],
            [34.01736045606144, 3.755348099960364],
            [34.017894407479794, 3.75547363528589],
            [34.02068680616744, 3.753546437561577],
            [34.02291618844571, 3.753512280685358],
            [34.02332483027182, 3.753890276800962],
            [34.02539629051976, 3.753067808217113],
            [34.02731214728913, 3.753444022504997],
            [34.02831617901083, 3.752780506603584],
            [34.0302941309259, 3.752557388164492],
            [34.03026143494452, 3.751453537828975],
            [34.03126634971014, 3.751546970391421],
            [34.032615814201314, 3.750914578433993],
            [34.0341547863865, 3.75122814938987],
            [34.03691665313427, 3.750089436697677],
            [34.03795314997035, 3.750340520495268],
            [34.03857891549893, 3.748447397708904],
            [34.03955224010929, 3.74838315945817],
            [34.03952165696544, 3.749077065520482],
            [34.041311417218374, 3.749043389832556],
            [34.041407039287115, 3.750241779372367],
            [34.04206595085307, 3.749830978210216],
            [34.04272643267415, 3.750744836027956],
            [34.04325926030007, 3.749924169816661],
            [34.043417721319564, 3.751154023257271],
            [34.04410911955945, 3.751657825184392],
            [34.04483067963332, 3.751120788673604],
            [34.046777737587476, 3.75133922832091],
            [34.0503554093605, 3.749726406894877],
            [34.05060574288075, 3.749000698223109],
            [34.051233359837155, 3.748684546648377],
            [34.05264623820083, 3.748588222014981],
            [34.054104213788435, 3.749228197345032],
            [34.054008097646296, 3.74839233135721],
            [34.05536320535407, 3.748127954375977],
            [34.05607569873177, 3.747386650697393],
            [34.057620810901916, 3.746930961212134],
            [34.05788270124829, 3.747193378139736],
            [34.057574001489094, 3.747552032796443],
            [34.0579545826407, 3.747647108866654],
            [34.05916687259134, 3.747263477106593],
            [34.06185099913442, 3.744823927388099],
            [34.066166544386896, 3.734667488949736],
            [34.06856477759922, 3.731822235482451],
            [34.07263998488562, 3.724606058172417],
            [34.07547663638078, 3.723816994949564],
            [34.07812177334558, 3.720963248637461],
            [34.08007615167099, 3.720517436557777],
            [34.08209281468661, 3.719438098944692],
            [34.08512000604005, 3.719624398062734],
            [34.08865332619087, 3.721140288296422],
            [34.08976969852706, 3.720616682125022],
            [34.09237029342681, 3.718158497917427],
            [34.09337755728691, 3.716763673839972],
            [34.094821714090486, 3.711694347774314],
            [34.094312393578925, 3.707767645857679],
            [34.09563182739013, 3.703838672854063],
            [34.099160543675126, 3.701680585745512],
            [34.10092160724631, 3.697941096001136],
            [34.10469915147513, 3.693058899121243],
            [34.105516883386684, 3.691410935869702],
            [34.10646036416667, 3.6907138181301],
            [34.11036850367484, 3.688237671964545],
            [34.116421992558045, 3.688103376760043],
            [34.120900987174764, 3.689554623952068],
            [34.12513070828331, 3.693349866978948],
            [34.129547877248925, 3.695751287193222],
            [34.13572951080737, 3.697200261943766],
            [34.13711801787744, 3.698148624772106],
            [34.14216419708646, 3.699282291353745],
            [34.144183708659845, 3.700546537658714],
            [34.15004778147716, 3.700222205671941],
            [34.15534800963843, 3.702748997729946],
            [34.1577436718724, 3.702302459304049],
            [34.15906617522696, 3.70097052518212],
            [34.159693711335, 3.698626022695991],
            [34.16082711752558, 3.697357676895427],
            [34.16328589898471, 3.696974389874714],
            [34.16877313123528, 3.697853944516733],
            [34.17136068439373, 3.69949742165042],
            [34.17438848480497, 3.700253508551499],
            [34.17760470774533, 3.700439251437837],
            [34.184128087387336, 3.702891343437186],
            [34.18433394621615, 3.702565435470727],
            [34.18742180259737, 3.701929273725467],
            [34.191883713054025, 3.702267992958201],
            [34.198521771625224, 3.70455721949088],
            [34.20291638928394, 3.703789156253507],
            [34.20927389051718, 3.703738169490104],
            [34.2140219260699, 3.704191288844088],
            [34.217566923421124, 3.70326712290631],
            [34.224602688626454, 3.703602113336527],
            [34.22586174307419, 3.704117458157181],
            [34.2257441841462, 3.701819428333018],
            [34.22648245108772, 3.697968929719466],
            [34.227223560298825, 3.696186799936402],
            [34.227164622731316, 3.694922875514311],
            [34.22584546649955, 3.692281781629849],
            [34.225614789016056, 3.69090318468024],
            [34.22452702891999, 3.69015777552772],
            [34.224182588788906, 3.689238974583793],
            [34.22388984310916, 3.684298257453641],
            [34.226005788828296, 3.684065515228344],
            [34.23092646979888, 3.685380157845124],
            [34.23298450023331, 3.684630385480856],
            [34.23630282029899, 3.68531522203896],
            [34.23666639993552, 3.685861412020943],
            [34.23852391382214, 3.684264832093743],
            [34.242063731487406, 3.682340688905955],
            [34.24397077847881, 3.679819078610284],
            [34.24742917913493, 3.676615578586035],
            [34.24790525120123, 3.675495384798806],
            [34.24825263870475, 3.66769819501897],
            [34.255247960857695, 3.660611376570066],
            [34.256677479613714, 3.658210387942371],
            [34.257499832459075, 3.648533355046057],
            [34.25908681690127, 3.644892677873345],
            [34.26039791434664, 3.643211551235285],
            [34.260763271749106, 3.642931100034117],
            [34.26935229235264, 3.642599178861493],
            [34.27126520174958, 3.644355709361994],
            [34.272618377181196, 3.644313807010445],
            [34.274964714719545, 3.642951063299183],
            [34.27518909052133, 3.641806257009148],
            [34.28286027724625, 3.640228856266141],
            [34.28794858923874, 3.636939073025137],
            [34.29108981992087, 3.629408424312259],
            [34.292253429267966, 3.623320206881916],
            [34.29494724324308, 3.616555419212189],
            [34.29558352445039, 3.616434626625799],
            [34.29893751931093, 3.613055557459877],
            [34.301888740140804, 3.612744562877967],
            [34.301988188134345, 3.611108422668163],
            [34.30280054093399, 3.609778003598494],
            [34.30290013445459, 3.608244113192619],
            [34.305035775736314, 3.607014040973361],
            [34.30676560308847, 3.606704797050633],
            [34.30645851041532, 3.605478242553557],
            [34.306748580912135, 3.6035302057427],
            [34.30972309415902, 3.605040904397314],
            [34.3106518048391, 3.606186586510266],
            [34.3110929432206, 3.608198623028974],
            [34.31193985959913, 3.609392419007172],
            [34.312098951235924, 3.611184724685853],
            [34.311319024024776, 3.613041289188162],
            [34.31157203093129, 3.614833459457918],
            [34.31282631801979, 3.616309692070586],
            [34.31389645676326, 3.620333477281696],
            [34.315589242982966, 3.621966306126982],
            [34.31721737655337, 3.62218406656258],
            [34.31822020183765, 3.62293735078166],
            [34.31935011717504, 3.6249798129171],
            [34.320854360491346, 3.626109732380699],
            [34.327395465690536, 3.625093788138154],
            [34.34098168665889, 3.625262357688785],
            [34.379393905126015, 3.623991523222807],
            [34.39909903478809, 3.625310707783928],
            [34.40581549202908, 3.625000353936996],
            [34.41066789564817, 3.621684411200457],
            [34.43208644673037, 3.619757460437858],
            [34.43689773984877, 3.618936980896973],
            [34.44545618000342, 3.616722872384345],
            [34.44912476307985, 3.617262123745626],
            [34.455801568684194, 3.617035209494321],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 784,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAMION",
        Population: 6137,
        Key: "KAABONGKAMION",
        Dist2: "Kaabong",
        "Sub Country": "Kamion",
        id2_original: "KaabongKamion",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "N",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.9890002904022, 3.59019649047416],
            [33.983626174910505, 3.591846649081423],
            [33.980236029147974, 3.590416919486235],
            [33.978716634846094, 3.587193430704902],
            [33.97543968399588, 3.586399191788626],
            [33.97463682099888, 3.587060556724506],
            [33.97222620720532, 3.587136523651786],
            [33.97135028871786, 3.587797967847465],
            [33.97094819830512, 3.587504836565912],
            [33.968428466153966, 3.588021247584878],
            [33.96693056224864, 3.587692585910518],
            [33.96411973641957, 3.589273447274624],
            [33.96316945000301, 3.588687333495637],
            [33.96170868694308, 3.588945743569905],
            [33.96043147215359, 3.590084637498623],
            [33.953674213432414, 3.590128440358787],
            [33.95137360912516, 3.590644579135886],
            [33.95155677201834, 3.591158115829197],
            [33.95046182719662, 3.591966552865169],
            [33.94757554647695, 3.591272357085734],
            [33.946152654592794, 3.592851729359377],
            [33.944837823749076, 3.592963180341623],
            [33.944511320279275, 3.595128532398133],
            [33.943780793222246, 3.595129291773825],
            [33.94312385076339, 3.5956437054556],
            [33.9426484784847, 3.595130467147563],
            [33.94217375119639, 3.595241043717734],
            [33.94195542285314, 3.596048564451272],
            [33.941443828705545, 3.595828923071233],
            [33.94053365026979, 3.597205422560624],
            [33.94101531075547, 3.597607816260411],
            [33.939893141590744, 3.59833418777933],
            [33.93949366976704, 3.599865598920442],
            [33.93635996247543, 3.602346396699261],
            [33.93987003243008, 3.604318966232888],
            [33.93944894085243, 3.605520313460374],
            [33.938725327229804, 3.605437194593876],
            [33.9371964754646, 3.607088200614697],
            [33.93600035608739, 3.607564696651737],
            [33.93480337522582, 3.607202500837778],
            [33.934441124197626, 3.60672761478954],
            [33.93302348925448, 3.608294634705522],
            [33.93138262745484, 3.609274798299415],
            [33.9322185565391, 3.61033628081727],
            [33.93152276463914, 3.610253129219592],
            [33.93118914022408, 3.610560991274853],
            [33.93138439444099, 3.611008092695345],
            [33.92765679923693, 3.61238178817809],
            [33.92771336435373, 3.613276335065562],
            [33.92707351413978, 3.613472686675004],
            [33.926488522243616, 3.612886202070553],
            [33.925347644764805, 3.612971238829379],
            [33.92295495236114, 3.616611449416395],
            [33.92102202400809, 3.617045034521092],
            [33.91966266726904, 3.618197387764958],
            [33.92224114744311, 3.618842175274955],
            [33.92302947210552, 3.619488789440813],
            [33.924750216591825, 3.621645088880972],
            [33.92460795399355, 3.622580393200085],
            [33.92547156286668, 3.623933658300743],
            [33.926472610385, 3.623912518381917],
            [33.92797517744498, 3.624856296039521],
            [33.928455442846996, 3.624614441420244],
            [33.92909666299175, 3.625136726860734],
            [33.930037747964874, 3.625216209438629],
            [33.931260432321665, 3.626562534248237],
            [33.931100612151155, 3.62690462422868],
            [33.93206194964234, 3.627205330015683],
            [33.93268360448021, 3.628170121233337],
            [33.934325815549435, 3.628610909672469],
            [33.93496629368575, 3.628409113226815],
            [33.935468239927175, 3.629776294246605],
            [33.93612904963333, 3.62987617029741],
            [33.93630384741458, 3.629498865495664],
            [33.936563101205564, 3.630122108021395],
            [33.93599453320773, 3.630486411338211],
            [33.93646088909589, 3.631317274557737],
            [33.937443879578716, 3.631576045450595],
            [33.93692751537698, 3.632407929689365],
            [33.93837691744351, 3.633549519587197],
            [33.939203614541604, 3.632717310967449],
            [33.940447368883376, 3.635054169642632],
            [33.941120083063666, 3.635365220207036],
            [33.941690326419526, 3.636611642038195],
            [33.94345023296062, 3.637908771168126],
            [33.94433087119659, 3.639206820036973],
            [33.94526523677136, 3.642427299980279],
            [33.945475168561686, 3.645336781452874],
            [33.94806359667924, 3.647516323523983],
            [33.951479109967075, 3.649227344666769],
            [33.95241226101961, 3.651252749746333],
            [33.959194215326264, 3.657116849621008],
            [33.96664776900394, 3.662148808658844],
            [33.97058009295621, 3.663391545552961],
            [33.975701725259206, 3.664321209768024],
            [33.977461958787075, 3.665826077222694],
            [33.98046645600151, 3.669979455726184],
            [33.98062281586152, 3.671070410830943],
            [33.97788791384364, 3.676996687902262],
            [33.97902794241452, 3.678917894164162],
            [33.97882257855744, 3.680321000154853],
            [33.979341015172515, 3.681411556234965],
            [33.97882513516271, 3.682659129610614],
            [33.98048806317903, 3.689723638571734],
            [33.98276486752114, 3.69055245043781],
            [33.98493033556526, 3.690441542236568],
            [33.993392966801586, 3.694137049758672],
            [34.00276750752723, 3.699676282701017],
            [34.00361533030586, 3.705949014958662],
            [34.00484066648938, 3.727362623976041],
            [34.00452244997807, 3.741072172463708],
            [34.00389164849399, 3.739012326447717],
            [33.99995220449479, 3.734800129477686],
            [33.99538797502898, 3.733199273346872],
            [33.994403939805494, 3.731944196606886],
            [33.99319744129348, 3.731452062681482],
            [33.993422411779974, 3.730288562701037],
            [33.99270863111647, 3.729918755886633],
            [33.99248205354394, 3.730779912021643],
            [33.991545057702, 3.731633390451373],
            [33.991275257689544, 3.730018590232925],
            [33.98984579462909, 3.729840750070998],
            [33.98944311222656, 3.729213107783427],
            [33.989664811947094, 3.728623464028634],
            [33.98756645254627, 3.72854226058982],
            [33.987352076790245, 3.727901803129782],
            [33.98828801172184, 3.727167286147492],
            [33.98792186380194, 3.726837023395351],
            [33.98488383786784, 3.726077750986039],
            [33.98349789638625, 3.724867973507778],
            [33.98019313549147, 3.725230584215675],
            [33.977879131015115, 3.724677734846243],
            [33.977512182696294, 3.724246563157001],
            [33.97703684814685, 3.724925687560694],
            [33.972867580961974, 3.72470036939544],
            [33.97256779338875, 3.726326893746543],
            [33.9709891929231, 3.726644060055516],
            [33.96517863364557, 3.726096078218599],
            [33.96242474483583, 3.724600511138603],
            [33.960138516268096, 3.721093928965987],
            [33.958975445910156, 3.721435617863506],
            [33.95876412532442, 3.720871432652133],
            [33.95728853377411, 3.720308628466132],
            [33.95616139063766, 3.717205570439091],
            [33.95482643214171, 3.716783709853989],
            [33.95412186280311, 3.714738468918076],
            [33.95404988259602, 3.713115851333622],
            [33.95060202187313, 3.707263764987764],
            [33.949547347627266, 3.706206617697459],
            [33.94891243814738, 3.703596877235105],
            [33.946875367205166, 3.703387409845611],
            [33.94076624296146, 3.704734438141378],
            [33.93508236769856, 3.709749699037355],
            [33.930098289025125, 3.712365417559895],
            [33.92609830306735, 3.715756156941609],
            [33.92448556392597, 3.718368297963628],
            [33.92146769079696, 3.720629151354035],
            [33.91802632489356, 3.720914968266131],
            [33.91732284700803, 3.719857409729928],
            [33.91725173547184, 3.719010853715007],
            [33.91528347188709, 3.717460745064697],
            [33.91268155197229, 3.714429680823867],
            [33.91022193418167, 3.713162278315655],
            [33.90748209142974, 3.71260068566612],
            [33.90684944929764, 3.71210746611186],
            [33.90628387897789, 3.708509850684698],
            [33.9041060923363, 3.708088770325362],
            [33.904807890372226, 3.707523624567497],
            [33.90438575046066, 3.706818529568733],
            [33.9045255786245, 3.706183408954416],
            [33.903611994675515, 3.705690473575256],
            [33.90318956909967, 3.704703165899116],
            [33.90199582666472, 3.704986599856339],
            [33.900801011641285, 3.704211738401394],
            [33.902416031605156, 3.703786769036401],
            [33.901291527719, 3.703082390004216],
            [33.901923302976876, 3.702728977533672],
            [33.90171101849882, 3.701177028610802],
            [33.90213115337066, 3.699906644364298],
            [33.901499380807785, 3.700260054375309],
            [33.90093634733039, 3.699131782049953],
            [33.901568262725455, 3.698919478152271],
            [33.90044383429779, 3.698285647234172],
            [33.900513716040365, 3.697932811056991],
            [33.899178153876534, 3.69687587494575],
            [33.89685956889054, 3.696102143987459],
            [33.885064380189625, 3.700700000499028],
            [33.87270803369362, 3.70621547986929],
            [33.8593503944392, 3.693317251453497],
            [33.84143322121296, 3.686208503121235],
            [33.83159810256305, 3.684101154849237],
            [33.82731366057898, 3.684105162020533],
            [33.82682232883096, 3.684458390961265],
            [33.82654053361453, 3.683541445177943],
            [33.826819852175724, 3.681777325048132],
            [33.82584891259246, 3.679915613349927],
            [33.826240031880644, 3.677974736313044],
            [33.82623946594201, 3.677360777654628],
            [33.82558397426234, 3.676659725074642],
            [33.82588605523452, 3.672844142586654],
            [33.824657488709235, 3.666091757186694],
            [33.82517986892841, 3.664468673342895],
            [33.82487351556877, 3.663635731352119],
            [33.82578276694315, 3.655434181492868],
            [33.82565035437196, 3.653855559445438],
            [33.82735053192981, 3.651266597855787],
            [33.826428724802696, 3.645741839664968],
            [33.825476903165324, 3.643264821255931],
            [33.8256773703058, 3.619116158367301],
            [33.82742067508214, 3.602516023911379],
            [33.8269916891098, 3.596768071464844],
            [33.83056397817764, 3.575325254723492],
            [33.83030755946969, 3.574194696649037],
            [33.831453472903995, 3.557954309930877],
            [33.83359204898178, 3.558202174976179],
            [33.83295212061438, 3.556599096496844],
            [33.83295087195615, 3.555209258487407],
            [33.83465224606997, 3.553817877148847],
            [33.83582135400493, 3.552213158358821],
            [33.835288034102206, 3.550823803280662],
            [33.836882791666525, 3.549218694647931],
            [33.8370926318287, 3.54590427834695],
            [33.83783733070764, 3.545689779499714],
            [33.837942972585076, 3.544834398088685],
            [33.836131553950615, 3.542163279770818],
            [33.833127443910094, 3.541951147078483],
            [33.831656645770124, 3.541159372405373],
            [33.82991299065082, 3.540941988094875],
            [33.83018374826734, 3.539080643046021],
            [33.829692376095146, 3.537931580354939],
            [33.829581462005315, 3.535742147069692],
            [33.829255002552976, 3.536235087116447],
            [33.82712886005705, 3.534759056428964],
            [33.826801235489775, 3.533938273957979],
            [33.826583740783086, 3.534431113646926],
            [33.82592912226586, 3.533501145614124],
            [33.82473040406254, 3.533392741274882],
            [33.82412901162423, 3.531039525215622],
            [33.82320213440563, 3.530274012813302],
            [33.82347425476645, 3.52994533860529],
            [33.82287451522827, 3.529453229066325],
            [33.82292745294796, 3.527701550828489],
            [33.82216450479398, 3.527483277510332],
            [33.82249077380351, 3.526771387767532],
            [33.821236763396115, 3.525732468862821],
            [33.82123743623427, 3.526498806305258],
            [33.82058340611358, 3.526225693070658],
            [33.820146730562385, 3.525295527636509],
            [33.82074440577203, 3.523433891192721],
            [33.820416504523656, 3.522284671957705],
            [33.82096099048536, 3.521901022337083],
            [33.82030552665347, 3.519985755815963],
            [33.819160492669816, 3.518946737881036],
            [33.81845227257792, 3.519002098881074],
            [33.81803283839198, 3.518359112546896],
            [33.81660473717749, 3.518719151988893],
            [33.81660408230564, 3.517967858847153],
            [33.81570629612921, 3.517442740074301],
            [33.81607959374048, 3.51676624763204],
            [33.815630276198306, 3.516015346534401],
            [33.81704940773468, 3.514135862132493],
            [33.81615149489583, 3.51346048628193],
            [33.81537224321777, 3.510989376759468],
            [33.82216231919292, 3.508815716384689],
            [33.82971151739719, 3.507454375338528],
            [33.83069978009242, 3.506568889253186],
            [33.831054888615796, 3.507083267997011],
            [33.83231535341851, 3.506488263073129],
            [33.83306466334981, 3.507160656384457],
            [33.8338921886946, 3.507159915765683],
            [33.83633479419039, 3.506524254838894],
            [33.842679600432014, 3.507033231393434],
            [33.84918639447894, 3.512372211997572],
            [33.85281232105411, 3.513002361860363],
            [33.85880011164898, 3.510898491728452],
            [33.86250458781092, 3.511251389710489],
            [33.86419816364974, 3.51029961848271],
            [33.86573487836862, 3.510179414481018],
            [33.86742987354562, 3.510771710130459],
            [33.868573593294016, 3.511800025152782],
            [33.869401115045505, 3.51179925136244],
            [33.874590134469564, 3.514194622527848],
            [33.87562458404509, 3.514243138069918],
            [33.87734595106388, 3.511420621238007],
            [33.87739460741293, 3.510777212745176],
            [33.87832947424765, 3.509687565281942],
            [33.88108800375413, 3.509833425527222],
            [33.880347990487685, 3.508596893491163],
            [33.88103698393758, 3.507952880516756],
            [33.88226831188403, 3.5078527356694],
            [33.88266264714093, 3.50814929762587],
            [33.88404151259304, 3.507801564867198],
            [33.88576335751555, 3.505523422133796],
            [33.88704426348255, 3.50576965047535],
            [33.887339289984794, 3.505224987171113],
            [33.88881638082333, 3.504580219597112],
            [33.89182206471223, 3.505666110736646],
            [33.89290434867833, 3.50422988975093],
            [33.893741662066454, 3.504179596556878],
            [33.89364413646763, 3.505218962682271],
            [33.89398944976116, 3.505763012692213],
            [33.895615199202794, 3.506058385478321],
            [33.897240335095084, 3.505710397297822],
            [33.89724142115828, 3.506848646917997],
            [33.89871765320739, 3.505313062700869],
            [33.89827273830842, 3.503630862494873],
            [33.899505094825884, 3.504619454566315],
            [33.9022132504045, 3.50362705627391],
            [33.902755354932374, 3.503923465348996],
            [33.9056108423024, 3.502485516558087],
            [33.90639898999672, 3.502534238934626],
            [33.90807298615564, 3.50179027623992],
            [33.91088073076326, 3.501936005014477],
            [33.91191520728826, 3.502033972562018],
            [33.91295116872843, 3.503666091333157],
            [33.91364075596471, 3.5036654161661],
            [33.914084494968975, 3.50411038075819],
            [33.91590938384111, 3.50658303274917],
            [33.915916960232195, 3.507371214454192],
            [33.9181021462968, 3.508101841586196],
            [33.91755376613834, 3.508403069534949],
            [33.91940057749668, 3.509704230055501],
            [33.92099617947736, 3.509151389976089],
            [33.92134607238222, 3.509902763740523],
            [33.92199465422072, 3.510052466012231],
            [33.92264239433781, 3.509350219666753],
            [33.922992141715575, 3.509951247226971],
            [33.92354081652145, 3.509950702972408],
            [33.92368942032733, 3.508898149075912],
            [33.924039362639526, 3.509699635721118],
            [33.92458818387077, 3.509849435758067],
            [33.92498618335573, 3.508796630690706],
            [33.92578430145135, 3.508845952584753],
            [33.92693172405535, 3.509045270107727],
            [33.92803000701666, 3.509996351311768],
            [33.92867819090147, 3.509745135232086],
            [33.9292773375516, 3.51034591058521],
            [33.931122526552514, 3.509993264214128],
            [33.93132254004378, 3.510494207767176],
            [33.936610592439685, 3.511340848170625],
            [33.93735998052444, 3.512542839371295],
            [33.937461893495076, 3.514697660137054],
            [33.93990558505406, 3.514294276240593],
            [33.94040503128404, 3.514945257000385],
            [33.94284831500788, 3.514140951382725],
            [33.94843393703657, 3.513283324458344],
            [33.952975435532466, 3.515734279854136],
            [33.95477348903211, 3.518087800928295],
            [33.95652034215381, 3.519138402376079],
            [33.96380473857193, 3.521085313239257],
            [33.96480299771962, 3.521735760250384],
            [33.96719751999151, 3.522033948742235],
            [33.9711898487098, 3.523934109333512],
            [33.972885850898244, 3.524032558744956],
            [33.97353527535648, 3.524984039791949],
            [33.9748325576111, 3.525383589614958],
            [33.979677484552084, 3.531692821860062],
            [33.980178333052194, 3.533646730456538],
            [33.98552331348429, 3.541057879059664],
            [33.98747294511173, 3.54511500587059],
            [33.98822184361464, 3.545765679911335],
            [33.98947221225187, 3.548921497562628],
            [33.98992386361717, 3.551476811608291],
            [33.989575980243586, 3.55267991102507],
            [33.99027489738241, 3.553230409299346],
            [33.99142617196233, 3.556987694343521],
            [33.99123131210584, 3.561347789142094],
            [33.99008592328767, 3.563103001618677],
            [33.99053587324381, 3.564054678282181],
            [33.990338494511256, 3.566059435880342],
            [33.98994008719119, 3.566661229992995],
            [33.990239859493094, 3.567111928440157],
            [33.98929264800972, 3.567614089141955],
            [33.98979194511938, 3.568064572840674],
            [33.98934333365299, 3.568365738261897],
            [33.98974437213856, 3.570219509147019],
            [33.988947068814866, 3.570972076913476],
            [33.988649606081594, 3.572676263382749],
            [33.98895088575653, 3.574530142117108],
            [33.989450455954, 3.575231191405239],
            [33.99089762301209, 3.575780872860057],
            [33.991597049495674, 3.576782387219587],
            [33.99159796577728, 3.577634317656843],
            [33.99005442206559, 3.580241899504199],
            [33.98970686388218, 3.581745687470803],
            [33.99035657400468, 3.582897594963607],
            [33.99046125109149, 3.587457822119994],
            [33.9890002904022, 3.59019649047416],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 785,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAPEDO",
        Population: 14599,
        Key: "KAABONGKAPEDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.82584891259246, 3.679915613349927],
            [33.82383852969901, 3.679057596432569],
            [33.82051553120732, 3.679147200692368],
            [33.818145272431266, 3.680195401238027],
            [33.821511234648035, 3.685085499349964],
            [33.82218064931629, 3.686633367056714],
            [33.81575735277671, 3.686329604562966],
            [33.81210973458239, 3.687055584451298],
            [33.81031208083303, 3.687934707863891],
            [33.80717992313528, 3.690466774685028],
            [33.80487115583704, 3.694391730820366],
            [33.80256130427224, 3.697129508172444],
            [33.634116559633405, 3.872893871512729],
            [33.51525822399322, 3.752195736241445],
            [33.51070325346302, 3.751986258018007],
            [33.519168143962304, 3.735954403941678],
            [33.53589858430774, 3.707383071579837],
            [33.60244254482363, 3.591162446172237],
            [33.609876846706484, 3.584881503173814],
            [33.63215121198007, 3.567418744386688],
            [33.63005043970441, 3.557832495562771],
            [33.62875976096542, 3.55363914862222],
            [33.636968466318706, 3.554871927623159],
            [33.64080360333703, 3.555854853429257],
            [33.64218463822053, 3.557035117399764],
            [33.64317933195483, 3.557058212525003],
            [33.64782041229324, 3.553412177339244],
            [33.64929990792178, 3.551044779699272],
            [33.6511878315774, 3.545322323116587],
            [33.655353322244814, 3.538120373597396],
            [33.65710979991646, 3.537019051196693],
            [33.661784568874644, 3.535781718746404],
            [33.66688073932924, 3.53580623283217],
            [33.668521575976065, 3.533289291577276],
            [33.669584046700244, 3.529345324563663],
            [33.67233049566279, 3.528104045753093],
            [33.673620061389144, 3.528103108792787],
            [33.67535881889351, 3.52900314256931],
            [33.67883442408398, 3.528155628779053],
            [33.68113230739422, 3.526914654124738],
            [33.68292479223742, 3.524603755387911],
            [33.686400452225115, 3.523868879565449],
            [33.68696046646482, 3.522967165937477],
            [33.68768669867646, 3.519361432433738],
            [33.68863930364479, 3.518628421033284],
            [33.68919806922623, 3.516036769580487],
            [33.69166761429908, 3.513400073356964],
            [33.695282740429576, 3.512246455445511],
            [33.696888113385626, 3.51224525396399],
            [33.69858827836709, 3.512718372163164],
            [33.699439100620424, 3.513951159809451],
            [33.69996479831798, 3.518507287411145],
            [33.70097695709802, 3.522449695446521],
            [33.7019316228016, 3.524476890475631],
            [33.703951535921924, 3.526446943443687],
            [33.711804721323425, 3.531341729327778],
            [33.719430712908114, 3.532349787863893],
            [33.72156207102258, 3.533362079086598],
            [33.72464527053736, 3.532683696516704],
            [33.726552008508285, 3.533245508427526],
            [33.72733761666528, 3.534089850756105],
            [33.72851517145885, 3.534257917921793],
            [33.73187910078812, 3.534086267914705],
            [33.73535400888591, 3.532449922904457],
            [33.73770879867278, 3.532391716869332],
            [33.740849785911465, 3.53391012856396],
            [33.74443878184699, 3.534752200977078],
            [33.74666665315895, 3.535788307002281],
            [33.751004552987254, 3.535830104947932],
            [33.751728876278925, 3.536379882517523],
            [33.7545885488999, 3.536659199957888],
            [33.756103104875656, 3.537559248748347],
            [33.76140244819638, 3.536265515195868],
            [33.763896675379975, 3.537778155388638],
            [33.77142926553129, 3.538584656063797],
            [33.77217460401072, 3.539118598006612],
            [33.77377365282717, 3.542538446365049],
            [33.77505204710465, 3.544247969062015],
            [33.776861802957484, 3.545101743418263],
            [33.77867084644631, 3.54510021561816],
            [33.781438693278915, 3.546380816053161],
            [33.78324899979906, 3.547876045799919],
            [33.78442127609199, 3.549906374413248],
            [33.788360246679055, 3.551827422208427],
            [33.793042586638435, 3.551930307672121],
            [33.79453285127061, 3.552463582019487],
            [33.79698057267194, 3.552675284626121],
            [33.802068366336506, 3.552187295340733],
            [33.80701448310433, 3.553708644052942],
            [33.81158027294381, 3.55379254585232],
            [33.81886519667298, 3.555184144203026],
            [33.824681793527574, 3.555688690053913],
            [33.82952354222906, 3.556683041965892],
            [33.831453472903995, 3.557954309930877],
            [33.83030755946969, 3.574194696649037],
            [33.83056397817764, 3.575325254723492],
            [33.8269916891098, 3.596768071464844],
            [33.82742067508214, 3.602516023911379],
            [33.8256773703058, 3.619116158367301],
            [33.825476903165324, 3.643264821255931],
            [33.826428724802696, 3.645741839664968],
            [33.82735053192981, 3.651266597855787],
            [33.82565035437196, 3.653855559445438],
            [33.82578276694315, 3.655434181492868],
            [33.82487351556877, 3.663635731352119],
            [33.82517986892841, 3.664468673342895],
            [33.824657488709235, 3.666091757186694],
            [33.82588605523452, 3.672844142586654],
            [33.82558397426234, 3.676659725074642],
            [33.82623946594201, 3.677360777654628],
            [33.826240031880644, 3.677974736313044],
            [33.82584891259246, 3.679915613349927],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 786,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "NAPORE KARENGA",
        Population: 14817,
        Key: "KAABONGNAPORE KARENGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.10646036416667, 3.6907138181301],
            [34.105516883386684, 3.691410935869702],
            [34.10469915147513, 3.693058899121243],
            [34.10092160724631, 3.697941096001136],
            [34.099160543675126, 3.701680585745512],
            [34.09563182739013, 3.703838672854063],
            [34.094312393578925, 3.707767645857679],
            [34.094821714090486, 3.711694347774314],
            [34.09337755728691, 3.716763673839972],
            [34.09237029342681, 3.718158497917427],
            [34.08976969852706, 3.720616682125022],
            [34.08865332619087, 3.721140288296422],
            [34.08512000604005, 3.719624398062734],
            [34.08209281468661, 3.719438098944692],
            [34.08007615167099, 3.720517436557777],
            [34.07812177334558, 3.720963248637461],
            [34.07547663638078, 3.723816994949564],
            [34.07263998488562, 3.724606058172417],
            [34.06856477759922, 3.731822235482451],
            [34.066166544386896, 3.734667488949736],
            [34.06185099913442, 3.744823927388099],
            [34.05916687259134, 3.747263477106593],
            [34.0579545826407, 3.747647108866654],
            [34.057574001489094, 3.747552032796443],
            [34.05788270124829, 3.747193378139736],
            [34.057620810901916, 3.746930961212134],
            [34.05607569873177, 3.747386650697393],
            [34.05536320535407, 3.748127954375977],
            [34.054008097646296, 3.74839233135721],
            [34.054104213788435, 3.749228197345032],
            [34.05264623820083, 3.748588222014981],
            [34.051233359837155, 3.748684546648377],
            [34.05060574288075, 3.749000698223109],
            [34.0503554093605, 3.749726406894877],
            [34.046777737587476, 3.75133922832091],
            [34.04483067963332, 3.751120788673604],
            [34.04410911955945, 3.751657825184392],
            [34.043417721319564, 3.751154023257271],
            [34.04325926030007, 3.749924169816661],
            [34.04272643267415, 3.750744836027956],
            [34.04206595085307, 3.749830978210216],
            [34.041407039287115, 3.750241779372367],
            [34.041311417218374, 3.749043389832556],
            [34.03952165696544, 3.749077065520482],
            [34.03955224010929, 3.74838315945817],
            [34.03857891549893, 3.748447397708904],
            [34.03795314997035, 3.750340520495268],
            [34.03691665313427, 3.750089436697677],
            [34.0341547863865, 3.75122814938987],
            [34.032615814201314, 3.750914578433993],
            [34.03126634971014, 3.751546970391421],
            [34.03026143494452, 3.751453537828975],
            [34.0302941309259, 3.752557388164492],
            [34.02831617901083, 3.752780506603584],
            [34.02731214728913, 3.753444022504997],
            [34.02539629051976, 3.753067808217113],
            [34.02332483027182, 3.753890276800962],
            [34.02291618844571, 3.753512280685358],
            [34.02068680616744, 3.753546437561577],
            [34.017894407479794, 3.75547363528589],
            [34.01736045606144, 3.755348099960364],
            [34.016574166981464, 3.754245125337123],
            [34.01578927029017, 3.754340661422342],
            [34.014691458046045, 3.755382756051993],
            [34.0141251214634, 3.754405679092176],
            [34.01201998696871, 3.753272697568175],
            [34.00554123383338, 3.745910075097973],
            [34.005638354292, 3.744716074659981],
            [34.00452244997807, 3.741072172463708],
            [34.00484066648938, 3.727362623976041],
            [34.00361533030586, 3.705949014958662],
            [34.00276750752723, 3.699676282701017],
            [33.993392966801586, 3.694137049758672],
            [33.98493033556526, 3.690441542236568],
            [33.98276486752114, 3.69055245043781],
            [33.98048806317903, 3.689723638571734],
            [33.97882513516271, 3.682659129610614],
            [33.979341015172515, 3.681411556234965],
            [33.97882257855744, 3.680321000154853],
            [33.97902794241452, 3.678917894164162],
            [33.97788791384364, 3.676996687902262],
            [33.98062281586152, 3.671070410830943],
            [33.98046645600151, 3.669979455726184],
            [33.977461958787075, 3.665826077222694],
            [33.975701725259206, 3.664321209768024],
            [33.97058009295621, 3.663391545552961],
            [33.96664776900394, 3.662148808658844],
            [33.959194215326264, 3.657116849621008],
            [33.95241226101961, 3.651252749746333],
            [33.951479109967075, 3.649227344666769],
            [33.94806359667924, 3.647516323523983],
            [33.945475168561686, 3.645336781452874],
            [33.94526523677136, 3.642427299980279],
            [33.94433087119659, 3.639206820036973],
            [33.94345023296062, 3.637908771168126],
            [33.941690326419526, 3.636611642038195],
            [33.941120083063666, 3.635365220207036],
            [33.940447368883376, 3.635054169642632],
            [33.939203614541604, 3.632717310967449],
            [33.93837691744351, 3.633549519587197],
            [33.93692751537698, 3.632407929689365],
            [33.937443879578716, 3.631576045450595],
            [33.93646088909589, 3.631317274557737],
            [33.93599453320773, 3.630486411338211],
            [33.936563101205564, 3.630122108021395],
            [33.93630384741458, 3.629498865495664],
            [33.93612904963333, 3.62987617029741],
            [33.935468239927175, 3.629776294246605],
            [33.93496629368575, 3.628409113226815],
            [33.934325815549435, 3.628610909672469],
            [33.93268360448021, 3.628170121233337],
            [33.93206194964234, 3.627205330015683],
            [33.931100612151155, 3.62690462422868],
            [33.931260432321665, 3.626562534248237],
            [33.930037747964874, 3.625216209438629],
            [33.92909666299175, 3.625136726860734],
            [33.928455442846996, 3.624614441420244],
            [33.92797517744498, 3.624856296039521],
            [33.926472610385, 3.623912518381917],
            [33.92547156286668, 3.623933658300743],
            [33.92460795399355, 3.622580393200085],
            [33.924750216591825, 3.621645088880972],
            [33.92302947210552, 3.619488789440813],
            [33.92224114744311, 3.618842175274955],
            [33.91966266726904, 3.618197387764958],
            [33.92102202400809, 3.617045034521092],
            [33.92295495236114, 3.616611449416395],
            [33.925347644764805, 3.612971238829379],
            [33.926488522243616, 3.612886202070553],
            [33.92707351413978, 3.613472686675004],
            [33.92771336435373, 3.613276335065562],
            [33.92765679923693, 3.61238178817809],
            [33.93138439444099, 3.611008092695345],
            [33.93118914022408, 3.610560991274853],
            [33.93152276463914, 3.610253129219592],
            [33.9322185565391, 3.61033628081727],
            [33.93138262745484, 3.609274798299415],
            [33.93302348925448, 3.608294634705522],
            [33.934441124197626, 3.60672761478954],
            [33.93480337522582, 3.607202500837778],
            [33.93600035608739, 3.607564696651737],
            [33.9371964754646, 3.607088200614697],
            [33.938725327229804, 3.605437194593876],
            [33.93944894085243, 3.605520313460374],
            [33.93987003243008, 3.604318966232888],
            [33.93635996247543, 3.602346396699261],
            [33.93949366976704, 3.599865598920442],
            [33.939893141590744, 3.59833418777933],
            [33.94101531075547, 3.597607816260411],
            [33.94053365026979, 3.597205422560624],
            [33.941443828705545, 3.595828923071233],
            [33.94195542285314, 3.596048564451272],
            [33.94217375119639, 3.595241043717734],
            [33.9426484784847, 3.595130467147563],
            [33.94312385076339, 3.5956437054556],
            [33.943780793222246, 3.595129291773825],
            [33.944511320279275, 3.595128532398133],
            [33.944837823749076, 3.592963180341623],
            [33.946152654592794, 3.592851729359377],
            [33.94757554647695, 3.591272357085734],
            [33.95046182719662, 3.591966552865169],
            [33.95155677201834, 3.591158115829197],
            [33.95137360912516, 3.590644579135886],
            [33.953674213432414, 3.590128440358787],
            [33.96043147215359, 3.590084637498623],
            [33.96170868694308, 3.588945743569905],
            [33.96316945000301, 3.588687333495637],
            [33.96411973641957, 3.589273447274624],
            [33.96693056224864, 3.587692585910518],
            [33.968428466153966, 3.588021247584878],
            [33.97094819830512, 3.587504836565912],
            [33.97135028871786, 3.587797967847465],
            [33.97222620720532, 3.587136523651786],
            [33.97463682099888, 3.587060556724506],
            [33.97543968399588, 3.586399191788626],
            [33.978716634846094, 3.587193430704902],
            [33.980236029147974, 3.590416919486235],
            [33.983626174910505, 3.591846649081423],
            [33.9890002904022, 3.59019649047416],
            [33.98883233868173, 3.591635617164445],
            [33.99020810225117, 3.595518705285081],
            [33.99075182284822, 3.595722867858225],
            [33.99190573308519, 3.594766085085797],
            [33.99170391218355, 3.596609099528021],
            [33.99286873964618, 3.597044968710282],
            [33.99856110668347, 3.59911082343408],
            [33.99935904691268, 3.598521618415611],
            [34.001222130354066, 3.598278884442259],
            [34.003004565744206, 3.597314196823074],
            [34.00375161641258, 3.59627332236833],
            [34.00670349121597, 3.596267158612283],
            [34.008859065215525, 3.596733463898037],
            [34.010616448389015, 3.596209327785537],
            [34.01114933081218, 3.596663353111083],
            [34.0120810005428, 3.596662314910902],
            [34.01242643061731, 3.596100344495909],
            [34.01319897457514, 3.59663432653904],
            [34.01349945115621, 3.597549072835818],
            [34.01306712794259, 3.598365608966977],
            [34.01350137714419, 3.59928998419465],
            [34.015447403832376, 3.596132405894798],
            [34.02086187344328, 3.595364689243475],
            [34.02264661840199, 3.593295355488543],
            [34.02405119453583, 3.590247183333013],
            [34.026702487655264, 3.588285677312306],
            [34.026863606789675, 3.587088622493664],
            [34.0284308040411, 3.584203479507509],
            [34.02999921132319, 3.582406399489595],
            [34.029998054293124, 3.581372739707137],
            [34.0324858746921, 3.578540957415459],
            [34.03307916971644, 3.576418560888802],
            [34.035722077062694, 3.573516837213463],
            [34.03618408959649, 3.573489009515602],
            [34.03635851098362, 3.572169316868732],
            [34.037663003116705, 3.569082701049052],
            [34.039424676643996, 3.567995193254992],
            [34.04010760197412, 3.568451472218529],
            [34.041926589813166, 3.567763818848311],
            [34.04488356435241, 3.56764618740162],
            [34.04607861922604, 3.568387538450422],
            [34.0494315217352, 3.566384079687661],
            [34.052500986009285, 3.565180790162233],
            [34.05506430262139, 3.564786231742264],
            [34.05784576791369, 3.564546184831461],
            [34.062850907588945, 3.565283106601727],
            [34.068428083657366, 3.568933041490312],
            [34.070926745823535, 3.569988157714891],
            [34.073155899929716, 3.570128658619267],
            [34.07755638448553, 3.572591230041391],
            [34.08080637419913, 3.573701855789091],
            [34.083027556655495, 3.575888346961059],
            [34.08552528367542, 3.577397865744104],
            [34.09154734410007, 3.577470292042591],
            [34.09483503251289, 3.576948928719145],
            [34.100345698215975, 3.580086662459699],
            [34.10414880131126, 3.579883056744548],
            [34.110450707608166, 3.582064513326455],
            [34.113886603669805, 3.581513171624912],
            [34.116192480189454, 3.5797091989311],
            [34.11817250811116, 3.578990341942073],
            [34.11928195084323, 3.579108387939682],
            [34.12007590434922, 3.580420871205528],
            [34.12027554593796, 3.581694280478308],
            [34.12241816712947, 3.584358359920211],
            [34.12246103832808, 3.587025019061658],
            [34.121988149891166, 3.589095289583025],
            [34.12290087864401, 3.590328016480537],
            [34.12488330147427, 3.591559418404661],
            [34.124924484738465, 3.592833019263618],
            [34.12318858746996, 3.598805414929629],
            [34.12168439266267, 3.599881918688834],
            [34.120139505969654, 3.600082836593389],
            [34.11934544017426, 3.600737166307125],
            [34.11859584457868, 3.602020901389965],
            [34.118634347270074, 3.603354369288013],
            [34.11822893668406, 3.603503037915285],
            [34.118628345625666, 3.604811009689018],
            [34.11718400287084, 3.60587608984405],
            [34.117030851793, 3.607302659096139],
            [34.115792770312225, 3.608160009283634],
            [34.116130523384314, 3.609923115525811],
            [34.11590145298686, 3.612594613724491],
            [34.116315445178806, 3.613372127451987],
            [34.1158535943418, 3.615680837633344],
            [34.11291472624537, 3.61902996925513],
            [34.112321001826324, 3.619056633667978],
            [34.11069658638291, 3.620666555086128],
            [34.1106971559148, 3.621133368727601],
            [34.11237671983183, 3.622402071695861],
            [34.11243019025249, 3.623906188060935],
            [34.10975796998021, 3.634231288791954],
            [34.10861287041954, 3.643077617730921],
            [34.108974712714286, 3.644491296716017],
            [34.10868144960495, 3.645609808008478],
            [34.10619679846228, 3.648375362209345],
            [34.10678978266955, 3.651400205609993],
            [34.106005050369966, 3.652190455525261],
            [34.105615744780316, 3.65508496989275],
            [34.10610705227383, 3.655281681755078],
            [34.10666488270908, 3.656333365348472],
            [34.10719102597099, 3.658240142275571],
            [34.10693126553017, 3.659983461185928],
            [34.10523362750961, 3.663833309128803],
            [34.10526761886165, 3.664852756978538],
            [34.10428701430425, 3.666103667780044],
            [34.1031788085523, 3.67008433321188],
            [34.10295683933718, 3.677214553331342],
            [34.10352323610696, 3.678348970060469],
            [34.10398358675745, 3.682529073822027],
            [34.10625050693651, 3.687204605893252],
            [34.10646036416667, 3.6907138181301],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 787,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KATHILE",
        Population: 20573,
        Key: "KAABONGKATHILE",
        Dist2: "Kaabong",
        "Sub Country": "Kathile",
        id2_original: "KaabongKathile",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.00554123383338, 3.745910075097973],
            [34.004201196262805, 3.754881762860897],
            [34.00114760881305, 3.760031835587593],
            [34.00104801259749, 3.761370688973318],
            [34.00240267294425, 3.760862192928931],
            [34.003287898876394, 3.758765529797105],
            [34.00338959535307, 3.76105427296417],
            [34.0050791440445, 3.76563003815018],
            [34.00518039405849, 3.767520716882178],
            [34.00726444958503, 3.770503766168544],
            [34.00746386569663, 3.771598205590929],
            [34.01073698882541, 3.774679371512738],
            [34.01282547394463, 3.781443975074849],
            [34.011737111977304, 3.782738948325671],
            [34.00955911243497, 3.784234227590364],
            [34.007184901969985, 3.787421497483791],
            [34.00758813863302, 3.79339195393701],
            [34.00878414841579, 3.799460994427533],
            [34.0081933668776, 3.802646182435735],
            [34.00839917629911, 3.809213958822188],
            [34.00701446461112, 3.811305410471055],
            [34.00661998921704, 3.812898121180912],
            [34.008112257990604, 3.818071168384504],
            [34.00851324257725, 3.822051310573582],
            [34.00634573535742, 3.832602500510788],
            [34.00476585119925, 3.837281591043802],
            [34.00486819715789, 3.840067904261416],
            [34.00407830852857, 3.842457206734825],
            [34.005876574928955, 3.854994025389579],
            [34.0092293597588, 3.855116898575957],
            [33.8612823669848, 4.103294430979093],
            [33.634116559633405, 3.872893871512729],
            [33.80256130427224, 3.697129508172444],
            [33.80487115583704, 3.694391730820366],
            [33.80717992313528, 3.690466774685028],
            [33.81031208083303, 3.687934707863891],
            [33.81210973458239, 3.687055584451298],
            [33.81575735277671, 3.686329604562966],
            [33.82218064931629, 3.686633367056714],
            [33.821511234648035, 3.685085499349964],
            [33.818145272431266, 3.680195401238027],
            [33.82051553120732, 3.679147200692368],
            [33.82383852969901, 3.679057596432569],
            [33.82584891259246, 3.679915613349927],
            [33.826819852175724, 3.681777325048132],
            [33.82654053361453, 3.683541445177943],
            [33.82682232883096, 3.684458390961265],
            [33.82731366057898, 3.684105162020533],
            [33.83159810256305, 3.684101154849237],
            [33.84143322121296, 3.686208503121235],
            [33.8593503944392, 3.693317251453497],
            [33.87270803369362, 3.70621547986929],
            [33.885064380189625, 3.700700000499028],
            [33.89685956889054, 3.696102143987459],
            [33.899178153876534, 3.69687587494575],
            [33.900513716040365, 3.697932811056991],
            [33.90044383429779, 3.698285647234172],
            [33.901568262725455, 3.698919478152271],
            [33.90093634733039, 3.699131782049953],
            [33.901499380807785, 3.700260054375309],
            [33.90213115337066, 3.699906644364298],
            [33.90171101849882, 3.701177028610802],
            [33.901923302976876, 3.702728977533672],
            [33.901291527719, 3.703082390004216],
            [33.902416031605156, 3.703786769036401],
            [33.900801011641285, 3.704211738401394],
            [33.90199582666472, 3.704986599856339],
            [33.90318956909967, 3.704703165899116],
            [33.903611994675515, 3.705690473575256],
            [33.9045255786245, 3.706183408954416],
            [33.90438575046066, 3.706818529568733],
            [33.904807890372226, 3.707523624567497],
            [33.9041060923363, 3.708088770325362],
            [33.90628387897789, 3.708509850684698],
            [33.90684944929764, 3.71210746611186],
            [33.90748209142974, 3.71260068566612],
            [33.91022193418167, 3.713162278315655],
            [33.91268155197229, 3.714429680823867],
            [33.91528347188709, 3.717460745064697],
            [33.91725173547184, 3.719010853715007],
            [33.91732284700803, 3.719857409729928],
            [33.91802632489356, 3.720914968266131],
            [33.92146769079696, 3.720629151354035],
            [33.92448556392597, 3.718368297963628],
            [33.92609830306735, 3.715756156941609],
            [33.930098289025125, 3.712365417559895],
            [33.93508236769856, 3.709749699037355],
            [33.94076624296146, 3.704734438141378],
            [33.946875367205166, 3.703387409845611],
            [33.94891243814738, 3.703596877235105],
            [33.949547347627266, 3.706206617697459],
            [33.95060202187313, 3.707263764987764],
            [33.95404988259602, 3.713115851333622],
            [33.95412186280311, 3.714738468918076],
            [33.95482643214171, 3.716783709853989],
            [33.95616139063766, 3.717205570439091],
            [33.95728853377411, 3.720308628466132],
            [33.95876412532442, 3.720871432652133],
            [33.958975445910156, 3.721435617863506],
            [33.960138516268096, 3.721093928965987],
            [33.96242474483583, 3.724600511138603],
            [33.96517863364557, 3.726096078218599],
            [33.9709891929231, 3.726644060055516],
            [33.97256779338875, 3.726326893746543],
            [33.972867580961974, 3.72470036939544],
            [33.97703684814685, 3.724925687560694],
            [33.977512182696294, 3.724246563157001],
            [33.977879131015115, 3.724677734846243],
            [33.98019313549147, 3.725230584215675],
            [33.98349789638625, 3.724867973507778],
            [33.98488383786784, 3.726077750986039],
            [33.98792186380194, 3.726837023395351],
            [33.98828801172184, 3.727167286147492],
            [33.987352076790245, 3.727901803129782],
            [33.98756645254627, 3.72854226058982],
            [33.989664811947094, 3.728623464028634],
            [33.98944311222656, 3.729213107783427],
            [33.98984579462909, 3.729840750070998],
            [33.991275257689544, 3.730018590232925],
            [33.991545057702, 3.731633390451373],
            [33.99248205354394, 3.730779912021643],
            [33.99270863111647, 3.729918755886633],
            [33.993422411779974, 3.730288562701037],
            [33.99319744129348, 3.731452062681482],
            [33.994403939805494, 3.731944196606886],
            [33.99538797502898, 3.733199273346872],
            [33.99995220449479, 3.734800129477686],
            [34.00389164849399, 3.739012326447717],
            [34.00452244997807, 3.741072172463708],
            [34.005638354292, 3.744716074659981],
            [34.00554123383338, 3.745910075097973],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 788,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "KAWALAKOL",
        Population: 14153,
        Key: "KAABONGKAWALAKOL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.81537224321777, 3.510989376759468],
            [33.81615149489583, 3.51346048628193],
            [33.81704940773468, 3.514135862132493],
            [33.815630276198306, 3.516015346534401],
            [33.81607959374048, 3.51676624763204],
            [33.81570629612921, 3.517442740074301],
            [33.81660408230564, 3.517967858847153],
            [33.81660473717749, 3.518719151988893],
            [33.81803283839198, 3.518359112546896],
            [33.81845227257792, 3.519002098881074],
            [33.819160492669816, 3.518946737881036],
            [33.82030552665347, 3.519985755815963],
            [33.82096099048536, 3.521901022337083],
            [33.820416504523656, 3.522284671957705],
            [33.82074440577203, 3.523433891192721],
            [33.820146730562385, 3.525295527636509],
            [33.82058340611358, 3.526225693070658],
            [33.82123743623427, 3.526498806305258],
            [33.821236763396115, 3.525732468862821],
            [33.82249077380351, 3.526771387767532],
            [33.82216450479398, 3.527483277510332],
            [33.82292745294796, 3.527701550828489],
            [33.82287451522827, 3.529453229066325],
            [33.82347425476645, 3.52994533860529],
            [33.82320213440563, 3.530274012813302],
            [33.82412901162423, 3.531039525215622],
            [33.82473040406254, 3.533392741274882],
            [33.82592912226586, 3.533501145614124],
            [33.826583740783086, 3.534431113646926],
            [33.826801235489775, 3.533938273957979],
            [33.82712886005705, 3.534759056428964],
            [33.829255002552976, 3.536235087116447],
            [33.829581462005315, 3.535742147069692],
            [33.829692376095146, 3.537931580354939],
            [33.83018374826734, 3.539080643046021],
            [33.82991299065082, 3.540941988094875],
            [33.831656645770124, 3.541159372405373],
            [33.833127443910094, 3.541951147078483],
            [33.836131553950615, 3.542163279770818],
            [33.837942972585076, 3.544834398088685],
            [33.83783733070764, 3.545689779499714],
            [33.8370926318287, 3.54590427834695],
            [33.836882791666525, 3.549218694647931],
            [33.835288034102206, 3.550823803280662],
            [33.83582135400493, 3.552213158358821],
            [33.83465224606997, 3.553817877148847],
            [33.83295087195615, 3.555209258487407],
            [33.83295212061438, 3.556599096496844],
            [33.83359204898178, 3.558202174976179],
            [33.831453472903995, 3.557954309930877],
            [33.82952354222906, 3.556683041965892],
            [33.824681793527574, 3.555688690053913],
            [33.81886519667298, 3.555184144203026],
            [33.81158027294381, 3.55379254585232],
            [33.80701448310433, 3.553708644052942],
            [33.802068366336506, 3.552187295340733],
            [33.79698057267194, 3.552675284626121],
            [33.79453285127061, 3.552463582019487],
            [33.793042586638435, 3.551930307672121],
            [33.788360246679055, 3.551827422208427],
            [33.78442127609199, 3.549906374413248],
            [33.78324899979906, 3.547876045799919],
            [33.781438693278915, 3.546380816053161],
            [33.77867084644631, 3.54510021561816],
            [33.776861802957484, 3.545101743418263],
            [33.77505204710465, 3.544247969062015],
            [33.77377365282717, 3.542538446365049],
            [33.77217460401072, 3.539118598006612],
            [33.77142926553129, 3.538584656063797],
            [33.763896675379975, 3.537778155388638],
            [33.76140244819638, 3.536265515195868],
            [33.756103104875656, 3.537559248748347],
            [33.7545885488999, 3.536659199957888],
            [33.751728876278925, 3.536379882517523],
            [33.751004552987254, 3.535830104947932],
            [33.74666665315895, 3.535788307002281],
            [33.74443878184699, 3.534752200977078],
            [33.740849785911465, 3.53391012856396],
            [33.73770879867278, 3.532391716869332],
            [33.73535400888591, 3.532449922904457],
            [33.73187910078812, 3.534086267914705],
            [33.72851517145885, 3.534257917921793],
            [33.72733761666528, 3.534089850756105],
            [33.726552008508285, 3.533245508427526],
            [33.72464527053736, 3.532683696516704],
            [33.72156207102258, 3.533362079086598],
            [33.719430712908114, 3.532349787863893],
            [33.711804721323425, 3.531341729327778],
            [33.703951535921924, 3.526446943443687],
            [33.7019316228016, 3.524476890475631],
            [33.70097695709802, 3.522449695446521],
            [33.69996479831798, 3.518507287411145],
            [33.699439100620424, 3.513951159809451],
            [33.69858827836709, 3.512718372163164],
            [33.696888113385626, 3.51224525396399],
            [33.695282740429576, 3.512246455445511],
            [33.69166761429908, 3.513400073356964],
            [33.68919806922623, 3.516036769580487],
            [33.68863930364479, 3.518628421033284],
            [33.68768669867646, 3.519361432433738],
            [33.68696046646482, 3.522967165937477],
            [33.686400452225115, 3.523868879565449],
            [33.68292479223742, 3.524603755387911],
            [33.68113230739422, 3.526914654124738],
            [33.67883442408398, 3.528155628779053],
            [33.67535881889351, 3.52900314256931],
            [33.673620061389144, 3.528103108792787],
            [33.67233049566279, 3.528104045753093],
            [33.669584046700244, 3.529345324563663],
            [33.668521575976065, 3.533289291577276],
            [33.66688073932924, 3.53580623283217],
            [33.661784568874644, 3.535781718746404],
            [33.65710979991646, 3.537019051196693],
            [33.655353322244814, 3.538120373597396],
            [33.6511878315774, 3.545322323116587],
            [33.64929990792178, 3.551044779699272],
            [33.64782041229324, 3.553412177339244],
            [33.64317933195483, 3.557058212525003],
            [33.64218463822053, 3.557035117399764],
            [33.64080360333703, 3.555854853429257],
            [33.636968466318706, 3.554871927623159],
            [33.62875976096542, 3.55363914862222],
            [33.62786933648278, 3.546507741627187],
            [33.626799076466725, 3.543584372186648],
            [33.62569049611733, 3.538440192750146],
            [33.62377305112652, 3.535591418730389],
            [33.622518191811196, 3.532001913509688],
            [33.62574769813967, 3.529138129269707],
            [33.62640680374174, 3.527543305771253],
            [33.62816393718356, 3.525911332783677],
            [33.630595108024096, 3.52101733423595],
            [33.634041891666996, 3.518025219373385],
            [33.63464898571242, 3.515782480600872],
            [33.63600122060791, 3.515441809813339],
            [33.63870420638206, 3.512586090898171],
            [33.64113501699816, 3.507284385437857],
            [33.64099782628797, 3.504430615975648],
            [33.641470442535365, 3.503343104973141],
            [33.641400191585184, 3.502356486845798],
            [33.642419315901996, 3.502005368919205],
            [33.642901122813065, 3.500468601260392],
            [33.644187557012295, 3.49874259233725],
            [33.64520656454811, 3.498229744060284],
            [33.64568803369261, 3.496207785845558],
            [33.646680083685055, 3.495506268844539],
            [33.64590071612434, 3.493404316760757],
            [33.646114948149936, 3.492865068290203],
            [33.645792419725254, 3.491948820581803],
            [33.64397733686277, 3.490617602149764],
            [33.643687349909285, 3.489457269852705],
            [33.64356507392773, 3.484789931436613],
            [33.643943815329614, 3.481295087598826],
            [33.64896641466076, 3.47636091764508],
            [33.651323984733445, 3.475521544523998],
            [33.65704701127137, 3.476838664574796],
            [33.66155728881958, 3.477177194708667],
            [33.66286411926734, 3.477679824465706],
            [33.66461798553649, 3.477624632287056],
            [33.665369229540616, 3.47701264564903],
            [33.670499673418234, 3.468538553112727],
            [33.67268178275298, 3.466702632625153],
            [33.67325356222794, 3.46540738084148],
            [33.67505977782027, 3.46349979026039],
            [33.676419784041286, 3.463300992122951],
            [33.677886439151145, 3.46207703127984],
            [33.678297114763076, 3.460745925810201],
            [33.679834887697346, 3.458874489796296],
            [33.68146290897835, 3.458082023503422],
            [33.68497104306354, 3.451507342151705],
            [33.68697371751357, 3.450590220399993],
            [33.688485118606046, 3.449069220637383],
            [33.690669094639965, 3.448054396880846],
            [33.692605567745126, 3.446567331004185],
            [33.695597385239296, 3.445984864888787],
            [33.699271024932465, 3.44455785354571],
            [33.702102671913195, 3.440282839657785],
            [33.702205603573375, 3.437539623475747],
            [33.70513984714271, 3.43004664902468],
            [33.71033280478094, 3.424662055819951],
            [33.71106654331513, 3.423078929034056],
            [33.714843964474724, 3.420174725516612],
            [33.71941003548689, 3.418957995992727],
            [33.72103668773538, 3.418112721133295],
            [33.72166452208408, 3.415316399497818],
            [33.72239888494739, 3.414577297628891],
            [33.722130451272484, 3.413546756272837],
            [33.721505248987576, 3.412942667108322],
            [33.722028717066564, 3.41093773622369],
            [33.721304372215336, 3.407049597165985],
            [33.722076903596744, 3.405187701157485],
            [33.72315725079509, 3.404503105509267],
            [33.72728491610083, 3.398830370054953],
            [33.728842807704225, 3.397639023450918],
            [33.72894664037463, 3.396109142602051],
            [33.73010030806648, 3.394578457644265],
            [33.731412390963705, 3.394260939303545],
            [33.73267113189939, 3.392835683026242],
            [33.73261707757381, 3.390778389867596],
            [33.731811376798845, 3.387882261857994],
            [33.734176863724116, 3.386394025731136],
            [33.73649786517823, 3.385975002800302],
            [33.736602384161515, 3.385341907205301],
            [33.73938262505011, 3.382965955132622],
            [33.73948707486312, 3.38228009456535],
            [33.74037870757987, 3.381329892756098],
            [33.74001095257389, 3.380908160341837],
            [33.74064020087086, 3.380063623343884],
            [33.74042958276765, 3.379219767143235],
            [33.741058536417206, 3.377953208015588],
            [33.742422205967955, 3.376527865864934],
            [33.74210585615581, 3.374681798941711],
            [33.741265222594414, 3.373627414159332],
            [33.741788664622256, 3.37167519310948],
            [33.74115843536502, 3.371253634061313],
            [33.74094758908972, 3.370093274330728],
            [33.741629414881935, 3.369354208725073],
            [33.741942729286755, 3.367191165044703],
            [33.741626498950524, 3.365503352441245],
            [33.74057585095381, 3.364396343497167],
            [33.74078548001187, 3.363974197501844],
            [33.740207258718, 3.362866826320117],
            [33.740451394761074, 3.361463150447402],
            [33.75140488180372, 3.355468874795048],
            [33.82351942744883, 3.312777129089267],
            [33.8225642820449, 3.313817348666184],
            [33.82259593059067, 3.314988979733761],
            [33.82087926176081, 3.316840399161874],
            [33.820849268810115, 3.317672918737065],
            [33.82315053158246, 3.317794329726288],
            [33.82348926291989, 3.319274033086016],
            [33.822753605584275, 3.320137978332765],
            [33.8234293533753, 3.321031571252744],
            [33.82309292441994, 3.322326842626579],
            [33.822663524324206, 3.32251220243996],
            [33.82198999716861, 3.324301085305715],
            [33.82103884387778, 3.324301880770598],
            [33.82057972930909, 3.325658922297565],
            [33.81806425607074, 3.326246851469461],
            [33.81711358337859, 3.326833472754309],
            [33.81573490297944, 3.329301270707929],
            [33.8163492392427, 3.330133256038649],
            [33.81444851908585, 3.332077323810124],
            [33.814756589126006, 3.333587894054458],
            [33.814205723329174, 3.335315006286361],
            [33.81626661310117, 3.341541587325286],
            [33.815838761700995, 3.343607766730754],
            [33.816207618041524, 3.344409117419754],
            [33.817680171489556, 3.344130388418231],
            [33.818110118659256, 3.344592526151487],
            [33.817866214381496, 3.346473550126397],
            [33.81627181973655, 3.347831544813203],
            [33.815566237098324, 3.347986298026682],
            [33.815965727786626, 3.348725960027638],
            [33.81599978920727, 3.352795907913974],
            [33.81520352972596, 3.35461572730707],
            [33.81459004237064, 3.35483207449635],
            [33.81502065609031, 3.356095873828586],
            [33.814868546159865, 3.357668489778666],
            [33.81312114686245, 3.359550774580205],
            [33.81269241870659, 3.360568628514153],
            [33.813030705377976, 3.361493337509413],
            [33.81208086811903, 3.363128291676789],
            [33.8099962134162, 3.365350022480302],
            [33.809443703702414, 3.365103816199604],
            [33.808646437209624, 3.365721146390312],
            [33.80824948156706, 3.368064799758521],
            [33.807789401309456, 3.368281014831109],
            [33.80628528555391, 3.367542270684468],
            [33.80573376219031, 3.368498557962016],
            [33.805734193381646, 3.369022722218062],
            [33.80631754225915, 3.369453900906112],
            [33.805552805559465, 3.37232202611501],
            [33.80432620993791, 3.373248042186127],
            [33.80211652861215, 3.372725710492737],
            [33.800829443134326, 3.374730935873585],
            [33.80098362188485, 3.375655805387925],
            [33.80288727773601, 3.37716505462458],
            [33.8028580663196, 3.378953406250296],
            [33.803657174358705, 3.380556069516565],
            [33.80332018126133, 3.381203846266858],
            [33.80356715598073, 3.383022801003476],
            [33.8024325451493, 3.383887075560694],
            [33.80237239665285, 3.385367120163162],
            [33.80313958305829, 3.385458982990309],
            [33.80277182715401, 3.386014286600095],
            [33.80301775982768, 3.386569079642677],
            [33.80353942319127, 3.386599477557051],
            [33.80400152286161, 3.388819083192756],
            [33.80219342260383, 3.391595579448526],
            [33.80225596421222, 3.393013856429318],
            [33.80164272569026, 3.393569364642878],
            [33.80149009294033, 3.394525321365534],
            [33.801030001902966, 3.394741537712256],
            [33.80136842332163, 3.3958204163313],
            [33.80106200797822, 3.396344838422885],
            [33.80170631293766, 3.396251803697129],
            [33.80078483010234, 3.399124292900777],
            [33.80182980703471, 3.399713786521512],
            [33.80150394586033, 3.400370018296916],
            [33.80222230344021, 3.400697399592473],
            [33.800461353056754, 3.402666754254909],
            [33.80104985556905, 3.40384699581317],
            [33.80157231753492, 3.404108943315356],
            [33.80072442648434, 3.405027997248669],
            [33.79942108329647, 3.407784123445643],
            [33.80020461814179, 3.407980259108845],
            [33.80020510682532, 3.408570624308361],
            [33.80203368687496, 3.409421844783582],
            [33.80348299012681, 3.411311565103915],
            [33.80211301260611, 3.413125986667068],
            [33.80174450211701, 3.414239945933042],
            [33.8029082758558, 3.417473850262207],
            [33.80359437044226, 3.417473273672652],
            [33.80454514823727, 3.418427028533645],
            [33.804599296885975, 3.420070936994341],
            [33.80533861305974, 3.420600622137591],
            [33.80475917634529, 3.421926879567173],
            [33.80486552879009, 3.422881346471009],
            [33.80581582329149, 3.423251757810863],
            [33.80613377120653, 3.424789383404558],
            [33.80703164721447, 3.425584085989851],
            [33.80638596513771, 3.426569305480809],
            [33.80706138863691, 3.428538217016703],
            [33.80856289119327, 3.429521683990794],
            [33.80605506710953, 3.433708961612262],
            [33.8067609165474, 3.435431661146241],
            [33.80510826166469, 3.43681785403989],
            [33.80492506822881, 3.437495018976519],
            [33.80590562966708, 3.43810965127059],
            [33.806305688988985, 3.440386527348859],
            [33.80566328216973, 3.441279494786103],
            [33.80630708676757, 3.442048276344541],
            [33.80450123499293, 3.443373057634522],
            [33.80450315109943, 3.445650269945804],
            [33.80312776751737, 3.449005711801127],
            [33.80374095034378, 3.449774522088678],
            [33.80398772563716, 3.451866888894503],
            [33.805213833473516, 3.453096772065616],
            [33.804847763707016, 3.454820381619238],
            [33.80536948635942, 3.456081637644074],
            [33.804758504405456, 3.457928547806041],
            [33.80518790809441, 3.458666737347718],
            [33.80668933429399, 3.459496331013762],
            [33.807180774738164, 3.461157662811284],
            [33.804640623880616, 3.463406273382182],
            [33.80378303731316, 3.463376230299648],
            [33.80167336452966, 3.467655498906744],
            [33.80102980337527, 3.467194449622063],
            [33.79959158443573, 3.468703555570773],
            [33.79968416840219, 3.469534355426019],
            [33.79891972455328, 3.471012117320978],
            [33.799502035876635, 3.4714732203366],
            [33.79925745516747, 3.471996574196855],
            [33.79843022986002, 3.471658768504618],
            [33.79809358620729, 3.471966787833874],
            [33.79824773351678, 3.4731668137412],
            [33.79729869126687, 3.473659990303932],
            [33.79827913502586, 3.474089983150429],
            [33.7981888318819, 3.47596722542906],
            [33.79785218643257, 3.476275242455554],
            [33.79846611216571, 3.477905699631477],
            [33.799201489226974, 3.478274352691396],
            [33.7987423575903, 3.478613249043749],
            [33.79831497061917, 3.480275364983729],
            [33.79914275198379, 3.481259403315589],
            [33.7986534845643, 3.48218301671586],
            [33.79880719529257, 3.48285989458717],
            [33.799419855299504, 3.482982466572856],
            [33.79969594890882, 3.483505374683503],
            [33.80055733085835, 3.487997525500559],
            [33.7993327043439, 3.488583260033348],
            [33.79826290516359, 3.493641738742239],
            [33.80013535893171, 3.497246369082381],
            [33.80208171260668, 3.499799113634127],
            [33.80626956593476, 3.500246282210361],
            [33.8082144553558, 3.501071024317494],
            [33.80926216316662, 3.502046802552177],
            [33.80986134395271, 3.503173227301526],
            [33.80963785658474, 3.504150108000116],
            [33.81016167949829, 3.504600429757874],
            [33.81106094070839, 3.50685353536208],
            [33.810912230002984, 3.507830350349134],
            [33.812109759735215, 3.509106510904851],
            [33.81225989966023, 3.509782544445088],
            [33.81412886527008, 3.509255005542364],
            [33.81338187838211, 3.510157213922263],
            [33.81375647855053, 3.510983310166231],
            [33.81427926480823, 3.510231558893126],
            [33.8154012444284, 3.510606222810455],
            [33.81537224321777, 3.510989376759468],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 789,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "LOBALANGIT",
        Population: 7664,
        Key: "KAABONGLOBALANGIT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.05506430262139, 3.564786231742264],
            [34.052500986009285, 3.565180790162233],
            [34.0494315217352, 3.566384079687661],
            [34.04607861922604, 3.568387538450422],
            [34.04488356435241, 3.56764618740162],
            [34.041926589813166, 3.567763818848311],
            [34.04010760197412, 3.568451472218529],
            [34.039424676643996, 3.567995193254992],
            [34.037663003116705, 3.569082701049052],
            [34.03635851098362, 3.572169316868732],
            [34.03618408959649, 3.573489009515602],
            [34.035722077062694, 3.573516837213463],
            [34.03307916971644, 3.576418560888802],
            [34.0324858746921, 3.578540957415459],
            [34.029998054293124, 3.581372739707137],
            [34.02999921132319, 3.582406399489595],
            [34.0284308040411, 3.584203479507509],
            [34.026863606789675, 3.587088622493664],
            [34.026702487655264, 3.588285677312306],
            [34.02405119453583, 3.590247183333013],
            [34.02264661840199, 3.593295355488543],
            [34.02086187344328, 3.595364689243475],
            [34.015447403832376, 3.596132405894798],
            [34.01350137714419, 3.59928998419465],
            [34.01306712794259, 3.598365608966977],
            [34.01349945115621, 3.597549072835818],
            [34.01319897457514, 3.59663432653904],
            [34.01242643061731, 3.596100344495909],
            [34.0120810005428, 3.596662314910902],
            [34.01114933081218, 3.596663353111083],
            [34.010616448389015, 3.596209327785537],
            [34.008859065215525, 3.596733463898037],
            [34.00670349121597, 3.596267158612283],
            [34.00375161641258, 3.59627332236833],
            [34.003004565744206, 3.597314196823074],
            [34.001222130354066, 3.598278884442259],
            [33.99935904691268, 3.598521618415611],
            [33.99856110668347, 3.59911082343408],
            [33.99286873964618, 3.597044968710282],
            [33.99170391218355, 3.596609099528021],
            [33.99190573308519, 3.594766085085797],
            [33.99075182284822, 3.595722867858225],
            [33.99020810225117, 3.595518705285081],
            [33.98883233868173, 3.591635617164445],
            [33.9890002904022, 3.59019649047416],
            [33.99046125109149, 3.587457822119994],
            [33.99035657400468, 3.582897594963607],
            [33.98970686388218, 3.581745687470803],
            [33.99005442206559, 3.580241899504199],
            [33.99159796577728, 3.577634317656843],
            [33.991597049495674, 3.576782387219587],
            [33.99089762301209, 3.575780872860057],
            [33.989450455954, 3.575231191405239],
            [33.98895088575653, 3.574530142117108],
            [33.988649606081594, 3.572676263382749],
            [33.988947068814866, 3.570972076913476],
            [33.98974437213856, 3.570219509147019],
            [33.98934333365299, 3.568365738261897],
            [33.98979194511938, 3.568064572840674],
            [33.98929264800972, 3.567614089141955],
            [33.990239859493094, 3.567111928440157],
            [33.98994008719119, 3.566661229992995],
            [33.990338494511256, 3.566059435880342],
            [33.99053587324381, 3.564054678282181],
            [33.99008592328767, 3.563103001618677],
            [33.99123131210584, 3.561347789142094],
            [33.99142617196233, 3.556987694343521],
            [33.99027489738241, 3.553230409299346],
            [33.989575980243586, 3.55267991102507],
            [33.98992386361717, 3.551476811608291],
            [33.98947221225187, 3.548921497562628],
            [33.98822184361464, 3.545765679911335],
            [33.98747294511173, 3.54511500587059],
            [33.98552331348429, 3.541057879059664],
            [33.980178333052194, 3.533646730456538],
            [33.979677484552084, 3.531692821860062],
            [33.9748325576111, 3.525383589614958],
            [33.97353527535648, 3.524984039791949],
            [33.972885850898244, 3.524032558744956],
            [33.9711898487098, 3.523934109333512],
            [33.96719751999151, 3.522033948742235],
            [33.96480299771962, 3.521735760250384],
            [33.96380473857193, 3.521085313239257],
            [33.95652034215381, 3.519138402376079],
            [33.95477348903211, 3.518087800928295],
            [33.952975435532466, 3.515734279854136],
            [33.94843393703657, 3.513283324458344],
            [33.94284831500788, 3.514140951382725],
            [33.94040503128404, 3.514945257000385],
            [33.93990558505406, 3.514294276240593],
            [33.937461893495076, 3.514697660137054],
            [33.93735998052444, 3.512542839371295],
            [33.936610592439685, 3.511340848170625],
            [33.93132254004378, 3.510494207767176],
            [33.931122526552514, 3.509993264214128],
            [33.9292773375516, 3.51034591058521],
            [33.92867819090147, 3.509745135232086],
            [33.92803000701666, 3.509996351311768],
            [33.92693172405535, 3.509045270107727],
            [33.92578430145135, 3.508845952584753],
            [33.92498618335573, 3.508796630690706],
            [33.92458818387077, 3.509849435758067],
            [33.924039362639526, 3.509699635721118],
            [33.92368942032733, 3.508898149075912],
            [33.92354081652145, 3.509950702972408],
            [33.922992141715575, 3.509951247226971],
            [33.92264239433781, 3.509350219666753],
            [33.92199465422072, 3.510052466012231],
            [33.92134607238222, 3.509902763740523],
            [33.92099617947736, 3.509151389976089],
            [33.91940057749668, 3.509704230055501],
            [33.91755376613834, 3.508403069534949],
            [33.9181021462968, 3.508101841586196],
            [33.915916960232195, 3.507371214454192],
            [33.91590938384111, 3.50658303274917],
            [33.914084494968975, 3.50411038075819],
            [33.91364075596471, 3.5036654161661],
            [33.91295116872843, 3.503666091333157],
            [33.91191520728826, 3.502033972562018],
            [33.91088073076326, 3.501936005014477],
            [33.90807298615564, 3.50179027623992],
            [33.90639898999672, 3.502534238934626],
            [33.9056108423024, 3.502485516558087],
            [33.902755354932374, 3.503923465348996],
            [33.9022132504045, 3.50362705627391],
            [33.899505094825884, 3.504619454566315],
            [33.89827273830842, 3.503630862494873],
            [33.89871765320739, 3.505313062700869],
            [33.89724142115828, 3.506848646917997],
            [33.897240335095084, 3.505710397297822],
            [33.895615199202794, 3.506058385478321],
            [33.89398944976116, 3.505763012692213],
            [33.89364413646763, 3.505218962682271],
            [33.893741662066454, 3.504179596556878],
            [33.89290434867833, 3.50422988975093],
            [33.89182206471223, 3.505666110736646],
            [33.88881638082333, 3.504580219597112],
            [33.887339289984794, 3.505224987171113],
            [33.88704426348255, 3.50576965047535],
            [33.88576335751555, 3.505523422133796],
            [33.88404151259304, 3.507801564867198],
            [33.88266264714093, 3.50814929762587],
            [33.88226831188403, 3.5078527356694],
            [33.88103698393758, 3.507952880516756],
            [33.880347990487685, 3.508596893491163],
            [33.88108800375413, 3.509833425527222],
            [33.87832947424765, 3.509687565281942],
            [33.87739460741293, 3.510777212745176],
            [33.87734595106388, 3.511420621238007],
            [33.87562458404509, 3.514243138069918],
            [33.874590134469564, 3.514194622527848],
            [33.869401115045505, 3.51179925136244],
            [33.868573593294016, 3.511800025152782],
            [33.86742987354562, 3.510771710130459],
            [33.86573487836862, 3.510179414481018],
            [33.86419816364974, 3.51029961848271],
            [33.86250458781092, 3.511251389710489],
            [33.85880011164898, 3.510898491728452],
            [33.85281232105411, 3.513002361860363],
            [33.84918639447894, 3.512372211997572],
            [33.842679600432014, 3.507033231393434],
            [33.83633479419039, 3.506524254838894],
            [33.8338921886946, 3.507159915765683],
            [33.83306466334981, 3.507160656384457],
            [33.83231535341851, 3.506488263073129],
            [33.831054888615796, 3.507083267997011],
            [33.83069978009242, 3.506568889253186],
            [33.82971151739719, 3.507454375338528],
            [33.82216231919292, 3.508815716384689],
            [33.81537224321777, 3.510989376759468],
            [33.8154012444284, 3.510606222810455],
            [33.81427926480823, 3.510231558893126],
            [33.81375647855053, 3.510983310166231],
            [33.81338187838211, 3.510157213922263],
            [33.81412886527008, 3.509255005542364],
            [33.81225989966023, 3.509782544445088],
            [33.812109759735215, 3.509106510904851],
            [33.810912230002984, 3.507830350349134],
            [33.81106094070839, 3.50685353536208],
            [33.81016167949829, 3.504600429757874],
            [33.80963785658474, 3.504150108000116],
            [33.80986134395271, 3.503173227301526],
            [33.80926216316662, 3.502046802552177],
            [33.8082144553558, 3.501071024317494],
            [33.80626956593476, 3.500246282210361],
            [33.80208171260668, 3.499799113634127],
            [33.80013535893171, 3.497246369082381],
            [33.79826290516359, 3.493641738742239],
            [33.7993327043439, 3.488583260033348],
            [33.80055733085835, 3.487997525500559],
            [33.79969594890882, 3.483505374683503],
            [33.799419855299504, 3.482982466572856],
            [33.79880719529257, 3.48285989458717],
            [33.7986534845643, 3.48218301671586],
            [33.79914275198379, 3.481259403315589],
            [33.79831497061917, 3.480275364983729],
            [33.7987423575903, 3.478613249043749],
            [33.799201489226974, 3.478274352691396],
            [33.79846611216571, 3.477905699631477],
            [33.79785218643257, 3.476275242455554],
            [33.7981888318819, 3.47596722542906],
            [33.79827913502586, 3.474089983150429],
            [33.79729869126687, 3.473659990303932],
            [33.79824773351678, 3.4731668137412],
            [33.79809358620729, 3.471966787833874],
            [33.79843022986002, 3.471658768504618],
            [33.79925745516747, 3.471996574196855],
            [33.799502035876635, 3.4714732203366],
            [33.79891972455328, 3.471012117320978],
            [33.79968416840219, 3.469534355426019],
            [33.79959158443573, 3.468703555570773],
            [33.80102980337527, 3.467194449622063],
            [33.80167336452966, 3.467655498906744],
            [33.80378303731316, 3.463376230299648],
            [33.804640623880616, 3.463406273382182],
            [33.807180774738164, 3.461157662811284],
            [33.80668933429399, 3.459496331013762],
            [33.80518790809441, 3.458666737347718],
            [33.804758504405456, 3.457928547806041],
            [33.80536948635942, 3.456081637644074],
            [33.804847763707016, 3.454820381619238],
            [33.805213833473516, 3.453096772065616],
            [33.80398772563716, 3.451866888894503],
            [33.80374095034378, 3.449774522088678],
            [33.80312776751737, 3.449005711801127],
            [33.80450315109943, 3.445650269945804],
            [33.80450123499293, 3.443373057634522],
            [33.80630708676757, 3.442048276344541],
            [33.80566328216973, 3.441279494786103],
            [33.806305688988985, 3.440386527348859],
            [33.80590562966708, 3.43810965127059],
            [33.80492506822881, 3.437495018976519],
            [33.80510826166469, 3.43681785403989],
            [33.8067609165474, 3.435431661146241],
            [33.80605506710953, 3.433708961612262],
            [33.80856289119327, 3.429521683990794],
            [33.80706138863691, 3.428538217016703],
            [33.80638596513771, 3.426569305480809],
            [33.80703164721447, 3.425584085989851],
            [33.80613377120653, 3.424789383404558],
            [33.80581582329149, 3.423251757810863],
            [33.80486552879009, 3.422881346471009],
            [33.80475917634529, 3.421926879567173],
            [33.80533861305974, 3.420600622137591],
            [33.804599296885975, 3.420070936994341],
            [33.80454514823727, 3.418427028533645],
            [33.80359437044226, 3.417473273672652],
            [33.8029082758558, 3.417473850262207],
            [33.80174450211701, 3.414239945933042],
            [33.80211301260611, 3.413125986667068],
            [33.80348299012681, 3.411311565103915],
            [33.80203368687496, 3.409421844783582],
            [33.80020510682532, 3.408570624308361],
            [33.80020461814179, 3.407980259108845],
            [33.79942108329647, 3.407784123445643],
            [33.80072442648434, 3.405027997248669],
            [33.80157231753492, 3.404108943315356],
            [33.80104985556905, 3.40384699581317],
            [33.800461353056754, 3.402666754254909],
            [33.80222230344021, 3.400697399592473],
            [33.80150394586033, 3.400370018296916],
            [33.80182980703471, 3.399713786521512],
            [33.80078483010234, 3.399124292900777],
            [33.80170631293766, 3.396251803697129],
            [33.80106200797822, 3.396344838422885],
            [33.80136842332163, 3.3958204163313],
            [33.801030001902966, 3.394741537712256],
            [33.80149009294033, 3.394525321365534],
            [33.80164272569026, 3.393569364642878],
            [33.80225596421222, 3.393013856429318],
            [33.80219342260383, 3.391595579448526],
            [33.80400152286161, 3.388819083192756],
            [33.80353942319127, 3.386599477557051],
            [33.80301775982768, 3.386569079642677],
            [33.80277182715401, 3.386014286600095],
            [33.80313958305829, 3.385458982990309],
            [33.80237239665285, 3.385367120163162],
            [33.8024325451493, 3.383887075560694],
            [33.80356715598073, 3.383022801003476],
            [33.80332018126133, 3.381203846266858],
            [33.803657174358705, 3.380556069516565],
            [33.8028580663196, 3.378953406250296],
            [33.80288727773601, 3.37716505462458],
            [33.80098362188485, 3.375655805387925],
            [33.800829443134326, 3.374730935873585],
            [33.80211652861215, 3.372725710492737],
            [33.80432620993791, 3.373248042186127],
            [33.805552805559465, 3.37232202611501],
            [33.80631754225915, 3.369453900906112],
            [33.805734193381646, 3.369022722218062],
            [33.80573376219031, 3.368498557962016],
            [33.80628528555391, 3.367542270684468],
            [33.807789401309456, 3.368281014831109],
            [33.80824948156706, 3.368064799758521],
            [33.808646437209624, 3.365721146390312],
            [33.809443703702414, 3.365103816199604],
            [33.8099962134162, 3.365350022480302],
            [33.81208086811903, 3.363128291676789],
            [33.813030705377976, 3.361493337509413],
            [33.81269241870659, 3.360568628514153],
            [33.81312114686245, 3.359550774580205],
            [33.814868546159865, 3.357668489778666],
            [33.81502065609031, 3.356095873828586],
            [33.81459004237064, 3.35483207449635],
            [33.81520352972596, 3.35461572730707],
            [33.81599978920727, 3.352795907913974],
            [33.815965727786626, 3.348725960027638],
            [33.815566237098324, 3.347986298026682],
            [33.81627181973655, 3.347831544813203],
            [33.817866214381496, 3.346473550126397],
            [33.818110118659256, 3.344592526151487],
            [33.817680171489556, 3.344130388418231],
            [33.816207618041524, 3.344409117419754],
            [33.815838761700995, 3.343607766730754],
            [33.81626661310117, 3.341541587325286],
            [33.814205723329174, 3.335315006286361],
            [33.814756589126006, 3.333587894054458],
            [33.81444851908585, 3.332077323810124],
            [33.8163492392427, 3.330133256038649],
            [33.81573490297944, 3.329301270707929],
            [33.81711358337859, 3.326833472754309],
            [33.81806425607074, 3.326246851469461],
            [33.82057972930909, 3.325658922297565],
            [33.82103884387778, 3.324301880770598],
            [33.82198999716861, 3.324301085305715],
            [33.822663524324206, 3.32251220243996],
            [33.82309292441994, 3.322326842626579],
            [33.8234293533753, 3.321031571252744],
            [33.822753605584275, 3.320137978332765],
            [33.82348926291989, 3.319274033086016],
            [33.82315053158246, 3.317794329726288],
            [33.820849268810115, 3.317672918737065],
            [33.82087926176081, 3.316840399161874],
            [33.82259593059067, 3.314988979733761],
            [33.8225642820449, 3.313817348666184],
            [33.82351942744883, 3.312777129089267],
            [33.85165558381894, 3.301819252333161],
            [33.85494160136532, 3.300928142426099],
            [33.861231651697096, 3.300775193416055],
            [33.862400653630836, 3.301434772121096],
            [33.86341253483148, 3.306119408611309],
            [33.86437752487264, 3.307378050997515],
            [33.86599995683593, 3.308565350815638],
            [33.869489509269464, 3.307446967951583],
            [33.87138916132947, 3.308546206442197],
            [33.871464551541344, 3.311261771180559],
            [33.87219754716879, 3.314343693583612],
            [33.87270911077364, 3.314783617800452],
            [33.87409679319023, 3.314929170432572],
            [33.87642952754027, 3.310229826534644],
            [33.87759795904382, 3.310228787124338],
            [33.87847611074305, 3.312283078529991],
            [33.87840528487109, 3.314778554397981],
            [33.88023166853987, 3.31558427808163],
            [33.88804569727645, 3.315650666352772],
            [33.88899955090302, 3.320714066664801],
            [33.8899472636463, 3.318878312771832],
            [33.89255781277769, 3.316418117026484],
            [33.895933346543835, 3.314197450319447],
            [33.904273708985144, 3.310643770921044],
            [33.90771755334044, 3.308182726044414],
            [33.90479968785536, 3.307012796262705],
            [33.902221371174655, 3.304400889793076],
            [33.902557291683564, 3.301907092659652],
            [33.902354976708565, 3.297340515387519],
            [33.903165596658006, 3.294186530934532],
            [33.904536751870026, 3.281871080699884],
            [33.90351362825358, 3.271360569617783],
            [33.902174603982665, 3.249661102372098],
            [33.90588458771557, 3.254313700389013],
            [33.91071342762643, 3.2572485801515],
            [33.919779752784855, 3.259337133990638],
            [33.926130813995805, 3.258906852605741],
            [33.9429661425321, 3.256132573930996],
            [33.94955835648109, 3.255414414374521],
            [33.97658079952826, 3.253914313029846],
            [33.98779095590884, 3.252423083067717],
            [33.991821268092295, 3.252520951130251],
            [33.99983161914262, 3.250805558189735],
            [33.99985609823412, 3.250800244236257],
            [33.99935593784349, 3.25199220051783],
            [34.00052667622069, 3.254209926632988],
            [33.99978115987482, 3.257051756142201],
            [34.00141245461668, 3.259259930296968],
            [34.003738315956454, 3.264777217132778],
            [34.007361699401066, 3.271249560926746],
            [34.00861222434513, 3.274548962922907],
            [34.00899217398107, 3.280314291766238],
            [34.00878790786525, 3.283907627504567],
            [34.00754679996029, 3.29000884771783],
            [34.005926556293026, 3.291180348139386],
            [34.00509791074909, 3.294022268260148],
            [34.00543223225681, 3.295734931691172],
            [34.0051437661511, 3.298283839105472],
            [34.0061868889607, 3.302001248412369],
            [34.00510685707099, 3.302921520249691],
            [34.004576734272405, 3.304222525385688],
            [34.00509642673222, 3.323289289329519],
            [34.00501479861901, 3.34310281594408],
            [34.004853621094085, 3.345439694546286],
            [34.00300789669728, 3.353097849325934],
            [34.00316182481782, 3.361237298966066],
            [34.00462491002275, 3.367093182761954],
            [34.00693435914231, 3.38139901524884],
            [34.00739245591976, 3.386509185938164],
            [34.006629102625595, 3.406055504237694],
            [34.00688623639254, 3.41319720521175],
            [34.008794819503045, 3.419010794653949],
            [34.00846440476852, 3.42108195166362],
            [34.00968562666802, 3.423368315171725],
            [34.01212523538404, 3.426466618810617],
            [34.021876032771495, 3.431515543841692],
            [34.02512686600313, 3.433715300402894],
            [34.02715952981059, 3.435916359286013],
            [34.02546362284357, 3.445386461516954],
            [34.02030014791297, 3.457238530950033],
            [34.01441427028873, 3.46591306016767],
            [34.0103984362527, 3.475452388483764],
            [34.006668126339875, 3.483113304813081],
            [34.00451836983005, 3.489761235886093],
            [34.00438243496464, 3.49679770257789],
            [34.00498107945649, 3.49911815390978],
            [34.00498347526335, 3.501364375768213],
            [34.005431006954765, 3.501738261369651],
            [34.006399391729346, 3.501362848792955],
            [34.0068459622234, 3.500838247013919],
            [34.006770801081885, 3.500239336840703],
            [34.007814021807874, 3.500163334982319],
            [34.00915461094402, 3.499413148617141],
            [34.010422520085484, 3.500385137587767],
            [34.011669487701035, 3.499246776993432],
            [34.013260793938066, 3.500258996558529],
            [34.01852099676352, 3.500499074443035],
            [34.02087503555882, 3.499851266694635],
            [34.02169968898964, 3.498897871707197],
            [34.0231972533318, 3.498066643175044],
            [34.02539891090546, 3.497910599728639],
            [34.02882456886781, 3.498459889473389],
            [34.029712252590514, 3.499227048213081],
            [34.03289394249475, 3.500391100239593],
            [34.03650197642607, 3.499926219509732],
            [34.03769561016492, 3.500815926980442],
            [34.03781742441238, 3.500354909183977],
            [34.03867368865971, 3.500353956952942],
            [34.03882605101675, 3.499862181491901],
            [34.039162915655034, 3.500291963302337],
            [34.0418844345718, 3.500135303338442],
            [34.04212880956677, 3.499889227736776],
            [34.04166935004503, 3.499213780623708],
            [34.04325948128566, 3.49915055491355],
            [34.04533948271529, 3.499609105749092],
            [34.045952119366035, 3.500530179755327],
            [34.04674756048212, 3.500836540709985],
            [34.04842980856524, 3.501111182074981],
            [34.05099804165688, 3.500616686608332],
            [34.05295647767242, 3.50175131193682],
            [34.05329365672106, 3.502457609616326],
            [34.052651908366904, 3.50285776624589],
            [34.053357603294536, 3.504946286153295],
            [34.05332943122893, 3.507097084214159],
            [34.054064925071174, 3.508478887811169],
            [34.056943158682515, 3.511701770810819],
            [34.05740405461038, 3.513636935253641],
            [34.05911718317972, 3.51415731122391],
            [34.059240271238245, 3.514833124123302],
            [34.06056742337438, 3.5160960983159],
            [34.06224857012296, 3.517219367047386],
            [34.06307253634262, 3.517218424696358],
            [34.06311343753579, 3.519543045722228],
            [34.0642248915958, 3.524610230749478],
            [34.06810407840239, 3.532939414552791],
            [34.06994731536421, 3.535852266340258],
            [34.070623952487324, 3.539655179236747],
            [34.07151097864329, 3.541787060416684],
            [34.071832824348334, 3.544737215086159],
            [34.068263387431514, 3.548438412450713],
            [34.06582199106808, 3.548476792012514],
            [34.06178915731364, 3.549227973481662],
            [34.057297342839476, 3.550868384461258],
            [34.05492899837326, 3.552932930183382],
            [34.05436730608062, 3.556843935036018],
            [34.05514817472619, 3.558975961242396],
            [34.05490194471018, 3.560255998197804],
            [34.053629991353326, 3.56189270192533],
            [34.05409200658204, 3.563669608763381],
            [34.05506430262139, 3.564786231742264],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 790,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "LOLELIA",
        Population: 7964,
        Key: "KAABONGLOLELIA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.55968948191115, 3.107657862605006],
            [34.54656058966069, 3.13381020607258],
            [34.53745056775192, 3.137896390492769],
            [34.512815116399615, 3.146077983275064],
            [34.49558489205767, 3.138636227727197],
            [34.48952718738086, 3.152560233138623],
            [34.482788283037536, 3.162412491674676],
            [34.471318793814206, 3.169895726493122],
            [34.461334830609935, 3.171216466525988],
            [34.45613806321658, 3.179280893239414],
            [34.452824371271255, 3.224226519668769],
            [34.450845281190695, 3.257151479367018],
            [34.448176941640426, 3.280234800942805],
            [34.43875666858198, 3.304685605543079],
            [34.433389663255745, 3.329809431053801],
            [34.43036253568267, 3.338298998394078],
            [34.43070271061279, 3.339995525415406],
            [34.41552795650672, 3.355630388484589],
            [34.40136105016569, 3.36786964962053],
            [34.401051571567145, 3.387555878781254],
            [34.40243834129545, 3.412330760833022],
            [34.40529269319495, 3.412599284380547],
            [34.41054862902283, 3.415373510684797],
            [34.42002793756513, 3.430632787916969],
            [34.41735155449979, 3.447946535936703],
            [34.40454537033706, 3.467311926965575],
            [34.39172927236687, 3.480228558508477],
            [34.390953894224324, 3.483627730491175],
            [34.389934567786604, 3.484253734719263],
            [34.38468944947138, 3.484529515203765],
            [34.383621389429486, 3.48372704313911],
            [34.38122441924844, 3.486142728903621],
            [34.38105286977526, 3.490431248939214],
            [34.37838707066063, 3.491417909204525],
            [34.375186382286444, 3.491422620192853],
            [34.374116365713874, 3.489280054172081],
            [34.37242659603689, 3.488925176178763],
            [34.37109142104694, 3.487855061958351],
            [34.3701993643254, 3.485801564038443],
            [34.369487327291864, 3.485266568517096],
            [34.36717507992023, 3.484823248418805],
            [34.35019210967369, 3.483775791595683],
            [34.34450311491197, 3.48458803177256],
            [34.341300505041424, 3.483252516006434],
            [34.33640914238678, 3.482276755001699],
            [34.33481777506435, 3.482595742349894],
            [34.33025267153772, 3.48528035187948],
            [34.32942737581147, 3.485026463423857],
            [34.32923843854768, 3.486046969050172],
            [34.32701744922908, 3.486050118095757],
            [34.32657280472304, 3.48573192276676],
            [34.32473318078529, 3.486180881487236],
            [34.323463773253934, 3.485991380144577],
            [34.32168822524711, 3.48688659820013],
            [34.321584764479205, 3.487860500148767],
            [34.31995801970421, 3.488189815023575],
            [34.31930659110457, 3.487798309306098],
            [34.31934013868889, 3.488517705005051],
            [34.31693073762093, 3.487703548491059],
            [34.315434255748684, 3.488098075962251],
            [34.3155981147447, 3.488915395516907],
            [34.314979775588554, 3.488916264371095],
            [34.31426262264948, 3.48806701955364],
            [34.31374296163065, 3.488819895974522],
            [34.31208389098018, 3.489312753203348],
            [34.31068426276693, 3.489151203766415],
            [34.31035827672675, 3.488759235777737],
            [34.308764109355565, 3.489121189300037],
            [34.30840566898079, 3.488794668714378],
            [34.3084676356674, 3.486538139335902],
            [34.30888993997066, 3.485981612902025],
            [34.30648059010668, 3.485200125570233],
            [34.30544120878026, 3.486673169828654],
            [34.30309861182672, 3.487101560694868],
            [34.30222226035131, 3.488803291801744],
            [34.30215924443241, 3.490307679954088],
            [34.3014106792045, 3.490276019277043],
            [34.30128180779213, 3.491224561400708],
            [34.29656574058542, 3.493324053485944],
            [34.296306237062765, 3.493945756323159],
            [34.29412718559324, 3.494995247952213],
            [34.29399781561591, 3.495584068851655],
            [34.29328201194638, 3.495715868332705],
            [34.29207960705713, 3.496992922319821],
            [34.291039161227054, 3.497713811951071],
            [34.29019304165422, 3.497747683496084],
            [34.290292601038836, 3.499153746057298],
            [34.2892816433063, 3.499633061282856],
            [34.28685075633338, 3.499520987540611],
            [34.284657121613535, 3.498198020885612],
            [34.282512892437694, 3.497602693799696],
            [34.278940532402906, 3.497607593948435],
            [34.27596097152247, 3.495697184068124],
            [34.26850355149581, 3.492834674660993],
            [34.26447152173354, 3.490716220053336],
            [34.26248986965779, 3.490652523926539],
            [34.258200365667115, 3.493578694675485],
            [34.25001204308761, 3.495248998320436],
            [34.24426955904062, 3.498376189805145],
            [34.241300400651134, 3.500835942651807],
            [34.23238690946529, 3.503701807043595],
            [34.22928333076996, 3.5044360119281],
            [34.22710363610671, 3.504505257291634],
            [34.2181235393341, 3.507039233454752],
            [34.21627401416531, 3.507041650777321],
            [34.21237508598204, 3.505719261424229],
            [34.21025920673823, 3.504062670765618],
            [34.20847565204727, 3.503998610614803],
            [34.20880754451046, 3.505259281656024],
            [34.20853868054255, 3.507068300502906],
            [34.2056911217032, 3.505237196646276],
            [34.19949577805688, 3.502462704309969],
            [34.196413246888646, 3.501658906206228],
            [34.191187659744344, 3.50132902848703],
            [34.18691893019291, 3.498739185998306],
            [34.183400091782765, 3.498955828773404],
            [34.1805236907346, 3.498083135103749],
            [34.17764804516957, 3.491970257628603],
            [34.17844733646498, 3.489190798041248],
            [34.176881070766505, 3.48489064632898],
            [34.17714742753648, 3.483904407814257],
            [34.17634328533855, 3.482785073115065],
            [34.17562934028331, 3.482472271864054],
            [34.17444173603668, 3.478444928881482],
            [34.17301051676983, 3.475701946844389],
            [34.17300901299005, 3.474485516104488],
            [34.17372207410301, 3.473798432658433],
            [34.173348404589206, 3.47283199077755],
            [34.17356491025079, 3.472207909486824],
            [34.172316446940265, 3.469296764173233],
            [34.17381756411941, 3.470174078169533],
            [34.18112847610975, 3.472273337426807],
            [34.180546345347736, 3.469656734566345],
            [34.179606128147206, 3.470021432057697],
            [34.1794606900044, 3.469439984619045],
            [34.18003865707503, 3.468712223675457],
            [34.17931479821235, 3.46849501889997],
            [34.17953070020606, 3.467549599417572],
            [34.180253660753465, 3.467039767585589],
            [34.18032448752372, 3.465803719055053],
            [34.18454056322309, 3.458972879674376],
            [34.18597454121619, 3.454246443536829],
            [34.187707286296344, 3.452156876940738],
            [34.190068072337745, 3.445870715214937],
            [34.19071892421898, 3.445579083409248],
            [34.19100934685539, 3.446378456582327],
            [34.192527759298684, 3.44550410655241],
            [34.19267165772909, 3.444849594164081],
            [34.19382891598712, 3.444484619778547],
            [34.19505916415863, 3.444628477035859],
            [34.19563883712998, 3.445282076744103],
            [34.199976969621964, 3.442659280367904],
            [34.20236446078011, 3.442438146590554],
            [34.20409974000771, 3.441418102376339],
            [34.20453460814854, 3.441999175131877],
            [34.20504009734546, 3.441198798466481],
            [34.20593740112654, 3.440742612564147],
            [34.20673848725589, 3.441417020961748],
            [34.20730219985961, 3.440166721051564],
            [34.208431762159115, 3.43937009821529],
            [34.20933363387344, 3.437324178067036],
            [34.208310121286516, 3.432554343337978],
            [34.20829699420526, 3.422103301682709],
            [34.20757009095206, 3.416524109960005],
            [34.205348578814025, 3.40926777121991],
            [34.20371905105829, 3.40600320434236],
            [34.20340107080391, 3.404461036321609],
            [34.20389587993041, 3.402963215474348],
            [34.2036184945437, 3.397746047127619],
            [34.20117566716405, 3.393983416345966],
            [34.20207594077548, 3.39175917654318],
            [34.201936281494895, 3.388356622092804],
            [34.2013920075356, 3.386361031728487],
            [34.2007139627524, 3.385726700668041],
            [34.20071178254121, 3.383957281143853],
            [34.20102677230401, 3.383094865611562],
            [34.20265085267585, 3.382003970690323],
            [34.20192503189258, 3.379237320193318],
            [34.203946734456956, 3.371068258359693],
            [34.20483880465322, 3.361893607891281],
            [34.204392127259645, 3.357197690903398],
            [34.20359620734151, 3.355337805705652],
            [34.203856087258245, 3.351527139748458],
            [34.202498161535445, 3.350007979959454],
            [34.20229704401468, 3.34912375783274],
            [34.20165662516716, 3.348883327217198],
            [34.20125448894034, 3.347195284787801],
            [34.20029244627163, 3.345668744918661],
            [34.1991320780461, 3.345549562289813],
            [34.198731123103855, 3.344826394250783],
            [34.19725015872983, 3.344265363612301],
            [34.19636862936511, 3.34314075180831],
            [34.19568825884365, 3.342940567513074],
            [34.19544879583669, 3.343423302297403],
            [34.194448265747965, 3.343143102285783],
            [34.192366901574, 3.342341576585636],
            [34.19132554036067, 3.341377964756669],
            [34.19012507044255, 3.341178409647162],
            [34.1886855246913, 3.341783215159795],
            [34.183404378543315, 3.341669016405707],
            [34.18276526764284, 3.342514062837267],
            [34.181924623301654, 3.342113043779282],
            [34.17212764532207, 3.346265829941809],
            [34.171568444057705, 3.347030371795171],
            [34.16912943002644, 3.348279612087906],
            [34.16596973896518, 3.349087470483755],
            [34.1652907410695, 3.350053173198477],
            [34.16313162591105, 3.351181460139326],
            [34.162371087937025, 3.350860737780661],
            [34.16112874395023, 3.349093248444233],
            [34.15948689041049, 3.347808678659596],
            [34.15732125168649, 3.343388820864932],
            [34.15463656728961, 3.339854048806655],
            [34.15485700487719, 3.323048539409635],
            [34.157684317486655, 3.311707703634981],
            [34.16833978484053, 3.289181018708267],
            [34.17532512042247, 3.275784938803852],
            [34.17903834887019, 3.269589191376314],
            [34.17927330323277, 3.265246920041964],
            [34.17858942479011, 3.261991230899149],
            [34.176784450669494, 3.257892577658783],
            [34.17061526776088, 3.250542509836103],
            [34.167295241794484, 3.250827799663179],
            [34.165855784078154, 3.251432530958986],
            [34.16409416175483, 3.250188253292986],
            [34.16225345983876, 3.249748142782462],
            [34.16225129669555, 3.247858560863142],
            [34.16281052490939, 3.247134245556238],
            [34.16232886532202, 3.245727665129876],
            [34.16180853685495, 3.245487040903619],
            [34.16280693613982, 3.243998342927395],
            [34.162525253212806, 3.242551328710848],
            [34.16304291548011, 3.240460129312822],
            [34.162922076803056, 3.239736597959161],
            [34.16240239512297, 3.240058827915685],
            [34.16136050300533, 3.238492076290974],
            [34.161277563351774, 3.235919119585347],
            [34.1605977273279, 3.236120921824644],
            [34.161035980320726, 3.234552465410574],
            [34.16019540155655, 3.234111189321595],
            [34.16031459002844, 3.233387379883661],
            [34.1597527099879, 3.231779867900683],
            [34.161028525202184, 3.227999230721218],
            [34.16022530916729, 3.225226079870891],
            [34.1594648807877, 3.224905321488458],
            [34.15914202896954, 3.222413043716197],
            [34.15862171128227, 3.222172415751216],
            [34.157939066226504, 3.219881569023392],
            [34.156497998729165, 3.219038929323196],
            [34.1562573894719, 3.218516550747147],
            [34.15597559874706, 3.216948914735931],
            [34.156543692434425, 3.216281281196331],
            [34.157325924722585, 3.21570770521265],
            [34.15842294824586, 3.213828315085383],
            [34.17270053870799, 3.203979369918896],
            [34.18763582172226, 3.192859065661564],
            [34.18818391441982, 3.191587936998487],
            [34.18840062399894, 3.188880982623227],
            [34.187955276112, 3.183910005294133],
            [34.18707327603007, 3.181535756195156],
            [34.18778395570923, 3.178275843811866],
            [34.18739857755402, 3.177668661777616],
            [34.187780290582864, 3.175071994899477],
            [34.18953668201628, 3.173191845118103],
            [34.19041386353503, 3.171367949759998],
            [34.19041209295558, 3.169821266051161],
            [34.192002979679366, 3.167388920060075],
            [34.1937059815405, 3.166889800762352],
            [34.196729016389135, 3.167383442429191],
            [34.19837740607085, 3.166605841888557],
            [34.19922845739462, 3.167013761027364],
            [34.201002812438766, 3.166342571845137],
            [34.20299999728406, 3.166488937831405],
            [34.20532743786213, 3.164404508364536],
            [34.20595629718856, 3.164552467599697],
            [34.207394318498736, 3.160870621970803],
            [34.2102042199614, 3.160272558871888],
            [34.21072075304639, 3.159231100821783],
            [34.21193988636288, 3.158151645089861],
            [34.21245589842499, 3.156664108220438],
            [34.21326926991418, 3.156477287397101],
            [34.21459679395284, 3.153204480419634],
            [34.214262151746574, 3.15164359591977],
            [34.21292979836494, 3.150752997463162],
            [34.21333590155204, 3.150157750371499],
            [34.214213634636366, 3.150312458552316],
            [34.25651089512909, 3.127370734197244],
            [34.33224202756534, 3.089780302982122],
            [34.33912817297022, 3.085785359138959],
            [34.34250444065992, 3.084495828934225],
            [34.39763030906149, 3.09192590335274],
            [34.39818887162368, 3.093093619117062],
            [34.39920259167575, 3.092859794586322],
            [34.44227455208294, 3.079757956196667],
            [34.48790741712573, 3.096779939376753],
            [34.49213852523306, 3.094806854595083],
            [34.49675579662316, 3.091173738002959],
            [34.50069206058626, 3.092595158710209],
            [34.513412175364984, 3.09143463729837],
            [34.52049493773107, 3.086333552210221],
            [34.52724919967247, 3.087681398471282],
            [34.539409725114616, 3.092075830984704],
            [34.54548877286427, 3.093424496993693],
            [34.55022328517872, 3.098847777058346],
            [34.55394451222576, 3.10393310803484],
            [34.55968948191115, 3.107657862605006],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 791,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "LOYORO",
        Population: 3664,
        Key: "KAABONGLOYORO",
        Dist2: "Kaabong",
        "Sub Country": "Loyoro",
        id2_original: "KaabongLoyoro",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.126260832029864, 3.489749839470507],
            [34.12570993479196, 3.490827462757668],
            [34.12460615683609, 3.491318314924917],
            [34.12346903970502, 3.491091237883586],
            [34.12278825595855, 3.4922016482271],
            [34.122756978416966, 3.493213375067881],
            [34.1218806422129, 3.493769223837014],
            [34.120778176695644, 3.495369666907861],
            [34.12113640057642, 3.496152481777338],
            [34.12013040873078, 3.496936933262898],
            [34.11876696106392, 3.497591267890145],
            [34.11818194221827, 3.497298254188896],
            [34.11668911020103, 3.498409637214904],
            [34.11379836665101, 3.498510994434903],
            [34.11013001983151, 3.500277669075867],
            [34.10639596484225, 3.501424339358545],
            [34.1060075270252, 3.502567035237237],
            [34.10448141691825, 3.503025740414714],
            [34.10393002560695, 3.503711733702934],
            [34.10022815994925, 3.504629900367734],
            [34.10016396005085, 3.505282683821586],
            [34.09948183871288, 3.505283488999535],
            [34.095521543917634, 3.507442091471784],
            [34.094127014541925, 3.509336586395585],
            [34.09256802250232, 3.509468958680614],
            [34.09114043422584, 3.510873958157287],
            [34.08376940068846, 3.513003884333464],
            [34.079742404186725, 3.513726552188072],
            [34.07688521540755, 3.51483947940494],
            [34.06902450302228, 3.514913826692763],
            [34.06593823935407, 3.514558378298539],
            [34.06321010075196, 3.514920495792754],
            [34.06307253634262, 3.517218424696358],
            [34.06224857012296, 3.517219367047386],
            [34.06056742337438, 3.5160960983159],
            [34.059240271238245, 3.514833124123302],
            [34.05911718317972, 3.51415731122391],
            [34.05740405461038, 3.513636935253641],
            [34.056943158682515, 3.511701770810819],
            [34.054064925071174, 3.508478887811169],
            [34.05332943122893, 3.507097084214159],
            [34.053357603294536, 3.504946286153295],
            [34.052651908366904, 3.50285776624589],
            [34.05329365672106, 3.502457609616326],
            [34.05295647767242, 3.50175131193682],
            [34.05099804165688, 3.500616686608332],
            [34.04842980856524, 3.501111182074981],
            [34.04674756048212, 3.500836540709985],
            [34.045952119366035, 3.500530179755327],
            [34.04533948271529, 3.499609105749092],
            [34.04325948128566, 3.49915055491355],
            [34.04166935004503, 3.499213780623708],
            [34.04212880956677, 3.499889227736776],
            [34.0418844345718, 3.500135303338442],
            [34.039162915655034, 3.500291963302337],
            [34.03882605101675, 3.499862181491901],
            [34.03867368865971, 3.500353956952942],
            [34.03781742441238, 3.500354909183977],
            [34.03769561016492, 3.500815926980442],
            [34.03650197642607, 3.499926219509732],
            [34.03289394249475, 3.500391100239593],
            [34.029712252590514, 3.499227048213081],
            [34.02882456886781, 3.498459889473389],
            [34.02539891090546, 3.497910599728639],
            [34.0231972533318, 3.498066643175044],
            [34.02169968898964, 3.498897871707197],
            [34.02087503555882, 3.499851266694635],
            [34.01852099676352, 3.500499074443035],
            [34.013260793938066, 3.500258996558529],
            [34.011669487701035, 3.499246776993432],
            [34.010422520085484, 3.500385137587767],
            [34.00915461094402, 3.499413148617141],
            [34.007814021807874, 3.500163334982319],
            [34.006770801081885, 3.500239336840703],
            [34.0068459622234, 3.500838247013919],
            [34.006399391729346, 3.501362848792955],
            [34.005431006954765, 3.501738261369651],
            [34.00498347526335, 3.501364375768213],
            [34.00498107945649, 3.49911815390978],
            [34.00438243496464, 3.49679770257789],
            [34.00451836983005, 3.489761235886093],
            [34.006668126339875, 3.483113304813081],
            [34.0103984362527, 3.475452388483764],
            [34.01441427028873, 3.46591306016767],
            [34.02030014791297, 3.457238530950033],
            [34.02546362284357, 3.445386461516954],
            [34.02715952981059, 3.435916359286013],
            [34.02512686600313, 3.433715300402894],
            [34.021876032771495, 3.431515543841692],
            [34.01212523538404, 3.426466618810617],
            [34.00968562666802, 3.423368315171725],
            [34.00846440476852, 3.42108195166362],
            [34.008794819503045, 3.419010794653949],
            [34.00688623639254, 3.41319720521175],
            [34.006629102625595, 3.406055504237694],
            [34.00739245591976, 3.386509185938164],
            [34.00693435914231, 3.38139901524884],
            [34.00462491002275, 3.367093182761954],
            [34.00316182481782, 3.361237298966066],
            [34.00300789669728, 3.353097849325934],
            [34.004853621094085, 3.345439694546286],
            [34.00501479861901, 3.34310281594408],
            [34.00509642673222, 3.323289289329519],
            [34.004576734272405, 3.304222525385688],
            [34.00510685707099, 3.302921520249691],
            [34.0061868889607, 3.302001248412369],
            [34.0051437661511, 3.298283839105472],
            [34.00543223225681, 3.295734931691172],
            [34.00509791074909, 3.294022268260148],
            [34.005926556293026, 3.291180348139386],
            [34.00754679996029, 3.29000884771783],
            [34.00878790786525, 3.283907627504567],
            [34.00899217398107, 3.280314291766238],
            [34.00861222434513, 3.274548962922907],
            [34.007361699401066, 3.271249560926746],
            [34.003738315956454, 3.264777217132778],
            [34.00141245461668, 3.259259930296968],
            [33.99978115987482, 3.257051756142201],
            [34.00052667622069, 3.254209926632988],
            [33.99935593784349, 3.25199220051783],
            [33.99985609823412, 3.250800244236257],
            [34.00352634768541, 3.250174112338378],
            [34.01117133145179, 3.251583185246182],
            [34.01664489853029, 3.250467525221977],
            [34.0183316893938, 3.249394210627748],
            [34.0201199009512, 3.249014501369108],
            [34.022233450863475, 3.249236364900602],
            [34.02495838158168, 3.248499896175224],
            [34.02879955258377, 3.24866460936403],
            [34.035187451907895, 3.248277777770199],
            [34.038522729471175, 3.248314258936107],
            [34.04196134473317, 3.249315042921447],
            [34.04470725290992, 3.248826382581069],
            [34.049471367407925, 3.249496044050605],
            [34.05098536732654, 3.250541615656697],
            [34.05361904448326, 3.251195123369479],
            [34.06116526207744, 3.250589959640015],
            [34.06421813806149, 3.250724241694013],
            [34.07099280523455, 3.249942557429946],
            [34.08263820165851, 3.25062180121414],
            [34.08803555566832, 3.248480137191742],
            [34.10473607941981, 3.239313268903073],
            [34.11075265113809, 3.237035728422054],
            [34.11380437458363, 3.23506396102877],
            [34.11590384699709, 3.23443053579063],
            [34.11839770497312, 3.234445363978726],
            [34.11982490517739, 3.233762537038477],
            [34.121470865814594, 3.232216957441977],
            [34.12425357976517, 3.23133331152839],
            [34.13087889932729, 3.227667734746708],
            [34.13795583072885, 3.225070153315499],
            [34.14003225147379, 3.223239841472479],
            [34.1437158624666, 3.221683425720209],
            [34.14725298877929, 3.219370160833977],
            [34.15353518514055, 3.216750671176463],
            [34.15549470093106, 3.216185589103634],
            [34.156543692434425, 3.216281281196331],
            [34.15597559874706, 3.216948914735931],
            [34.1562573894719, 3.218516550747147],
            [34.156497998729165, 3.219038929323196],
            [34.157939066226504, 3.219881569023392],
            [34.15862171128227, 3.222172415751216],
            [34.15914202896954, 3.222413043716197],
            [34.1594648807877, 3.224905321488458],
            [34.16022530916729, 3.225226079870891],
            [34.161028525202184, 3.227999230721218],
            [34.1597527099879, 3.231779867900683],
            [34.16031459002844, 3.233387379883661],
            [34.16019540155655, 3.234111189321595],
            [34.161035980320726, 3.234552465410574],
            [34.1605977273279, 3.236120921824644],
            [34.161277563351774, 3.235919119585347],
            [34.16136050300533, 3.238492076290974],
            [34.16240239512297, 3.240058827915685],
            [34.162922076803056, 3.239736597959161],
            [34.16304291548011, 3.240460129312822],
            [34.162525253212806, 3.242551328710848],
            [34.16280693613982, 3.243998342927395],
            [34.16180853685495, 3.245487040903619],
            [34.16232886532202, 3.245727665129876],
            [34.16281052490939, 3.247134245556238],
            [34.16225129669555, 3.247858560863142],
            [34.16225345983876, 3.249748142782462],
            [34.16409416175483, 3.250188253292986],
            [34.165855784078154, 3.251432530958986],
            [34.167295241794484, 3.250827799663179],
            [34.17061526776088, 3.250542509836103],
            [34.176784450669494, 3.257892577658783],
            [34.17858942479011, 3.261991230899149],
            [34.17927330323277, 3.265246920041964],
            [34.17903834887019, 3.269589191376314],
            [34.17532512042247, 3.275784938803852],
            [34.16833978484053, 3.289181018708267],
            [34.157684317486655, 3.311707703634981],
            [34.15485700487719, 3.323048539409635],
            [34.15463656728961, 3.339854048806655],
            [34.15732125168649, 3.343388820864932],
            [34.15948689041049, 3.347808678659596],
            [34.16112874395023, 3.349093248444233],
            [34.162371087937025, 3.350860737780661],
            [34.16313162591105, 3.351181460139326],
            [34.1652907410695, 3.350053173198477],
            [34.16596973896518, 3.349087470483755],
            [34.16912943002644, 3.348279612087906],
            [34.171568444057705, 3.347030371795171],
            [34.17212764532207, 3.346265829941809],
            [34.181924623301654, 3.342113043779282],
            [34.18276526764284, 3.342514062837267],
            [34.183404378543315, 3.341669016405707],
            [34.1886855246913, 3.341783215159795],
            [34.19012507044255, 3.341178409647162],
            [34.19132554036067, 3.341377964756669],
            [34.192366901574, 3.342341576585636],
            [34.194448265747965, 3.343143102285783],
            [34.19544879583669, 3.343423302297403],
            [34.19568825884365, 3.342940567513074],
            [34.19636862936511, 3.34314075180831],
            [34.19725015872983, 3.344265363612301],
            [34.198731123103855, 3.344826394250783],
            [34.1991320780461, 3.345549562289813],
            [34.20029244627163, 3.345668744918661],
            [34.20125448894034, 3.347195284787801],
            [34.20165662516716, 3.348883327217198],
            [34.20229704401468, 3.34912375783274],
            [34.202498161535445, 3.350007979959454],
            [34.203856087258245, 3.351527139748458],
            [34.20359620734151, 3.355337805705652],
            [34.204392127259645, 3.357197690903398],
            [34.20483880465322, 3.361893607891281],
            [34.203946734456956, 3.371068258359693],
            [34.20192503189258, 3.379237320193318],
            [34.20265085267585, 3.382003970690323],
            [34.20102677230401, 3.383094865611562],
            [34.20071178254121, 3.383957281143853],
            [34.2007139627524, 3.385726700668041],
            [34.2013920075356, 3.386361031728487],
            [34.201936281494895, 3.388356622092804],
            [34.20207594077548, 3.39175917654318],
            [34.20117566716405, 3.393983416345966],
            [34.2036184945437, 3.397746047127619],
            [34.20389587993041, 3.402963215474348],
            [34.20340107080391, 3.404461036321609],
            [34.20371905105829, 3.40600320434236],
            [34.205348578814025, 3.40926777121991],
            [34.20757009095206, 3.416524109960005],
            [34.20829699420526, 3.422103301682709],
            [34.208310121286516, 3.432554343337978],
            [34.20933363387344, 3.437324178067036],
            [34.208431762159115, 3.43937009821529],
            [34.20730219985961, 3.440166721051564],
            [34.20673848725589, 3.441417020961748],
            [34.20593740112654, 3.440742612564147],
            [34.20504009734546, 3.441198798466481],
            [34.20453460814854, 3.441999175131877],
            [34.20409974000771, 3.441418102376339],
            [34.20236446078011, 3.442438146590554],
            [34.199976969621964, 3.442659280367904],
            [34.19563883712998, 3.445282076744103],
            [34.19505916415863, 3.444628477035859],
            [34.19382891598712, 3.444484619778547],
            [34.19267165772909, 3.444849594164081],
            [34.192527759298684, 3.44550410655241],
            [34.19100934685539, 3.446378456582327],
            [34.19071892421898, 3.445579083409248],
            [34.190068072337745, 3.445870715214937],
            [34.187707286296344, 3.452156876940738],
            [34.18597454121619, 3.454246443536829],
            [34.18454056322309, 3.458972879674376],
            [34.18032448752372, 3.465803719055053],
            [34.180253660753465, 3.467039767585589],
            [34.17953070020606, 3.467549599417572],
            [34.17931479821235, 3.46849501889997],
            [34.18003865707503, 3.468712223675457],
            [34.1794606900044, 3.469439984619045],
            [34.179606128147206, 3.470021432057697],
            [34.180546345347736, 3.469656734566345],
            [34.18112847610975, 3.472273337426807],
            [34.17381756411941, 3.470174078169533],
            [34.172316446940265, 3.469296764173233],
            [34.17315716045174, 3.468777453693556],
            [34.17293723041232, 3.466625576263081],
            [34.17368136514928, 3.465969648252645],
            [34.17358724686032, 3.465158809688487],
            [34.17293492353867, 3.464754143799737],
            [34.173088813031676, 3.463693472829112],
            [34.172001672773135, 3.46307101207445],
            [34.16920768406746, 3.462700193888014],
            [34.16399492217045, 3.464203795151613],
            [34.161140979004394, 3.465579706970414],
            [34.159727835637675, 3.466907910291217],
            [34.15729527869667, 3.468204461088128],
            [34.15363390010883, 3.469269442668301],
            [34.15220728830106, 3.470269296254543],
            [34.149548843693616, 3.471265576460858],
            [34.14997055870209, 3.471328147684834],
            [34.14507071774779, 3.472398988146753],
            [34.13674863153093, 3.475279379104796],
            [34.136713207365986, 3.476300767743091],
            [34.135300214017946, 3.476173423747249],
            [34.134465817459564, 3.476561582575368],
            [34.13298686890503, 3.474982500108498],
            [34.13202334132115, 3.474790085045829],
            [34.131126801108024, 3.476920498414132],
            [34.13148266691122, 3.479146194994895],
            [34.132288467399164, 3.481693973717949],
            [34.13389417183354, 3.481853347352226],
            [34.13370232043496, 3.482531094320623],
            [34.13447505303898, 3.484272342099121],
            [34.13412288290488, 3.485143858744201],
            [34.13206809628694, 3.485372182674388],
            [34.1316182406539, 3.485114623342223],
            [34.13062008391415, 3.482825179648565],
            [34.131293822173866, 3.482340426589396],
            [34.1308118607526, 3.482082904983788],
            [34.13013800930514, 3.482470870390001],
            [34.12972280708251, 3.484342606653855],
            [34.12911328848412, 3.484827280672895],
            [34.12786413886075, 3.4874743266819],
            [34.12892509592369, 3.488569981533734],
            [34.12895782244778, 3.489086141038664],
            [34.12760918261007, 3.489087766665424],
            [34.125874330082226, 3.488347813888344],
            [34.12577895864345, 3.48915449626561],
            [34.126260832029864, 3.489749839470507],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 792,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "SIDOK",
        Population: 12968,
        Key: "KAABONGSIDOK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.455801568684194, 3.617035209494321],
            [34.44912476307985, 3.617262123745626],
            [34.44545618000342, 3.616722872384345],
            [34.43689773984877, 3.618936980896973],
            [34.43208644673037, 3.619757460437858],
            [34.41066789564817, 3.621684411200457],
            [34.40581549202908, 3.625000353936996],
            [34.39909903478809, 3.625310707783928],
            [34.379393905126015, 3.623991523222807],
            [34.34098168665889, 3.625262357688785],
            [34.327395465690536, 3.625093788138154],
            [34.320854360491346, 3.626109732380699],
            [34.31935011717504, 3.6249798129171],
            [34.31822020183765, 3.62293735078166],
            [34.31721737655337, 3.62218406656258],
            [34.315589242982966, 3.621966306126982],
            [34.31389645676326, 3.620333477281696],
            [34.31282631801979, 3.616309692070586],
            [34.31157203093129, 3.614833459457918],
            [34.311319024024776, 3.613041289188162],
            [34.312098951235924, 3.611184724685853],
            [34.31193985959913, 3.609392419007172],
            [34.3110929432206, 3.608198623028974],
            [34.3106518048391, 3.606186586510266],
            [34.30972309415902, 3.605040904397314],
            [34.306748580912135, 3.6035302057427],
            [34.306642482690556, 3.602739448870705],
            [34.305299379169924, 3.60089596000829],
            [34.305595481853885, 3.599648629262064],
            [34.304552471333686, 3.599350871142016],
            [34.30504702174535, 3.598003501835632],
            [34.3039045776047, 3.597606132548886],
            [34.30375329412431, 3.595960432127874],
            [34.302759437619834, 3.595313465912923],
            [34.30107180323828, 3.595565267456106],
            [34.30052349494505, 3.594019885346191],
            [34.29943020751504, 3.593273303066171],
            [34.29918063127461, 3.592326008605072],
            [34.297640246039485, 3.591380557366392],
            [34.297540175513454, 3.590832057973104],
            [34.2947595420611, 3.590536760699129],
            [34.29361682752749, 3.589939871169184],
            [34.292078200295386, 3.590241314501967],
            [34.28845742196511, 3.592690404193124],
            [34.28766566304336, 3.594536959711765],
            [34.28478368974552, 3.592795355209398],
            [34.2840860482144, 3.590950903959266],
            [34.27743072312513, 3.589064957388453],
            [34.2776288267981, 3.588715540870351],
            [34.276883359859575, 3.588167941810109],
            [34.27425304240203, 3.5888699032071],
            [34.27315956632579, 3.587973648611996],
            [34.272067126905405, 3.587825545868254],
            [34.27058082025038, 3.590072083971681],
            [34.26854549653135, 3.59022455435388],
            [34.266759781392146, 3.59137421337053],
            [34.26427824470857, 3.591976188990577],
            [34.26318559059085, 3.591678445399397],
            [34.26065494570562, 3.592679500353734],
            [34.25991043187961, 3.592697531764409],
            [34.25831992604153, 3.591787461493145],
            [34.24801024898657, 3.593743063388787],
            [34.242275472484714, 3.596255577923192],
            [34.235390015189346, 3.597337899687578],
            [34.231210313174124, 3.59929399353653],
            [34.230583661906664, 3.598931890360357],
            [34.22802259826932, 3.598894208627236],
            [34.222570055361736, 3.602369063032166],
            [34.22057943809945, 3.602581191622121],
            [34.219993937756826, 3.599607438489083],
            [34.220292364382416, 3.597844221702923],
            [34.22008581834242, 3.593311541788704],
            [34.21797499571533, 3.589234708106219],
            [34.2173193872547, 3.586263976784659],
            [34.2153595193246, 3.582589855359692],
            [34.21500423383309, 3.579266153457687],
            [34.2121444120918, 3.577356036510288],
            [34.21164114532694, 3.575845712541764],
            [34.21048621819706, 3.574336253066387],
            [34.208881396806596, 3.573784346359613],
            [34.2073280246274, 3.574239698084456],
            [34.20452026385009, 3.573790105018278],
            [34.20416825002285, 3.572934338176243],
            [34.202151539396546, 3.572391076248171],
            [34.19890095679487, 3.573384145045129],
            [34.19783053687871, 3.572826660207877],
            [34.19723028080923, 3.57188163621481],
            [34.195347729977335, 3.571970082864482],
            [34.19474920226644, 3.572357787509676],
            [34.19427825868215, 3.572143445445693],
            [34.193508744741756, 3.572660347481548],
            [34.193122932700284, 3.572101962944858],
            [34.1919677163129, 3.572146460610542],
            [34.18939811868033, 3.570344163110662],
            [34.1893545009817, 3.569699347592918],
            [34.188754862953154, 3.56922722053139],
            [34.18849575918082, 3.567378920335513],
            [34.187553270140896, 3.566477320855943],
            [34.184856269841504, 3.56540602456624],
            [34.18323094440466, 3.565881032496729],
            [34.182546120934326, 3.565709950520262],
            [34.18100395164507, 3.564293216381095],
            [34.180021865765745, 3.565885172885103],
            [34.17831106742628, 3.56644626796257],
            [34.17732809850305, 3.567350357260399],
            [34.1754779597849, 3.573197710723074],
            [34.171329563159055, 3.576174822270278],
            [34.1695033402887, 3.571376581922691],
            [34.168477564845546, 3.56983484925471],
            [34.165387179706826, 3.568456064468442],
            [34.1646434474151, 3.566718504120087],
            [34.16497229099621, 3.566138583805994],
            [34.16464219606191, 3.565725073968499],
            [34.16438991050257, 3.561668877878463],
            [34.16339911455827, 3.560014414260734],
            [34.16044600996124, 3.55781680803356],
            [34.15844280640353, 3.550661012870882],
            [34.154252341672915, 3.544634844364632],
            [34.15131353645859, 3.544642927184284],
            [34.14597959721964, 3.543249802185792],
            [34.145355816967815, 3.543829794274935],
            [34.14189850147655, 3.544992520947373],
            [34.14175332025191, 3.544123872838748],
            [34.14093543023686, 3.543111254458496],
            [34.13891783207502, 3.543113748794765],
            [34.13834090345687, 3.542728316379861],
            [34.138146979644894, 3.541280508452977],
            [34.1355030068967, 3.539739183627616],
            [34.13454224792054, 3.539740365348379],
            [34.13454478386461, 3.538993901268867],
            [34.13530085810999, 3.538128440335096],
            [34.13553711502973, 3.536548619031837],
            [34.133391282361096, 3.534732399426344],
            [34.13291190090129, 3.532244027489308],
            [34.131052131344994, 3.530618904792434],
            [34.12771750865356, 3.530527247005716],
            [34.12618216656044, 3.528921359907233],
            [34.126313643985426, 3.528069484917902],
            [34.126890327363505, 3.52826185675436],
            [34.1273720408498, 3.529371443754023],
            [34.12862055087271, 3.528983774856128],
            [34.128857998060155, 3.526714870597509],
            [34.12928957657042, 3.526086854987192],
            [34.130585943441794, 3.52555432130314],
            [34.13284118192885, 3.523476027718988],
            [34.13490742296502, 3.524004451605385],
            [34.13615797126531, 3.525306162392241],
            [34.13838496132995, 3.525000112525697],
            [34.139982613266135, 3.524320886410577],
            [34.14424583344994, 3.52499289207918],
            [34.1454758920769, 3.5246660101324],
            [34.14657774494314, 3.525412980666037],
            [34.1479696251871, 3.525020822555606],
            [34.14819229688476, 3.521766924928758],
            [34.14966998150971, 3.519373023952031],
            [34.15229227611345, 3.520802607273974],
            [34.15259133335636, 3.52045258388394],
            [34.153886191956374, 3.520816407148813],
            [34.15298631989186, 3.523233851381844],
            [34.156500216669606, 3.523174767877634],
            [34.159396971745494, 3.523957558551291],
            [34.160099043767595, 3.522095510572514],
            [34.1618445045006, 3.520127301706677],
            [34.16251931265383, 3.517321597331803],
            [34.16361256594788, 3.51535420507021],
            [34.16901173635116, 3.511839817521737],
            [34.1726643042627, 3.507240276484558],
            [34.17717417307743, 3.502582213513112],
            [34.1805236907346, 3.498083135103749],
            [34.183400091782765, 3.498955828773404],
            [34.18691893019291, 3.498739185998306],
            [34.191187659744344, 3.50132902848703],
            [34.196413246888646, 3.501658906206228],
            [34.19949577805688, 3.502462704309969],
            [34.2056911217032, 3.505237196646276],
            [34.20853868054255, 3.507068300502906],
            [34.20880754451046, 3.505259281656024],
            [34.20847565204727, 3.503998610614803],
            [34.21025920673823, 3.504062670765618],
            [34.21237508598204, 3.505719261424229],
            [34.21627401416531, 3.507041650777321],
            [34.2181235393341, 3.507039233454752],
            [34.22710363610671, 3.504505257291634],
            [34.22928333076996, 3.5044360119281],
            [34.23238690946529, 3.503701807043595],
            [34.241300400651134, 3.500835942651807],
            [34.24426955904062, 3.498376189805145],
            [34.25001204308761, 3.495248998320436],
            [34.258200365667115, 3.493578694675485],
            [34.26248986965779, 3.490652523926539],
            [34.26447152173354, 3.490716220053336],
            [34.26850355149581, 3.492834674660993],
            [34.27596097152247, 3.495697184068124],
            [34.278940532402906, 3.497607593948435],
            [34.282512892437694, 3.497602693799696],
            [34.284657121613535, 3.498198020885612],
            [34.28685075633338, 3.499520987540611],
            [34.2892816433063, 3.499633061282856],
            [34.290292601038836, 3.499153746057298],
            [34.29019304165422, 3.497747683496084],
            [34.291039161227054, 3.497713811951071],
            [34.29207960705713, 3.496992922319821],
            [34.29328201194638, 3.495715868332705],
            [34.29399781561591, 3.495584068851655],
            [34.29412718559324, 3.494995247952213],
            [34.296306237062765, 3.493945756323159],
            [34.29656574058542, 3.493324053485944],
            [34.30128180779213, 3.491224561400708],
            [34.3014106792045, 3.490276019277043],
            [34.30215924443241, 3.490307679954088],
            [34.30222226035131, 3.488803291801744],
            [34.30309861182672, 3.487101560694868],
            [34.30544120878026, 3.486673169828654],
            [34.30648059010668, 3.485200125570233],
            [34.30888993997066, 3.485981612902025],
            [34.3084676356674, 3.486538139335902],
            [34.30840566898079, 3.488794668714378],
            [34.308764109355565, 3.489121189300037],
            [34.31035827672675, 3.488759235777737],
            [34.31068426276693, 3.489151203766415],
            [34.31208389098018, 3.489312753203348],
            [34.31374296163065, 3.488819895974522],
            [34.31426262264948, 3.48806701955364],
            [34.314979775588554, 3.488916264371095],
            [34.3155981147447, 3.488915395516907],
            [34.315434255748684, 3.488098075962251],
            [34.31693073762093, 3.487703548491059],
            [34.31934013868889, 3.488517705005051],
            [34.31930659110457, 3.487798309306098],
            [34.31995801970421, 3.488189815023575],
            [34.321584764479205, 3.487860500148767],
            [34.32168822524711, 3.48688659820013],
            [34.323463773253934, 3.485991380144577],
            [34.32473318078529, 3.486180881487236],
            [34.32657280472304, 3.48573192276676],
            [34.32701744922908, 3.486050118095757],
            [34.32923843854768, 3.486046969050172],
            [34.32942737581147, 3.485026463423857],
            [34.33025267153772, 3.48528035187948],
            [34.33481777506435, 3.482595742349894],
            [34.33640914238678, 3.482276755001699],
            [34.341300505041424, 3.483252516006434],
            [34.34450311491197, 3.48458803177256],
            [34.35019210967369, 3.483775791595683],
            [34.36717507992023, 3.484823248418805],
            [34.369487327291864, 3.485266568517096],
            [34.3701993643254, 3.485801564038443],
            [34.37109142104694, 3.487855061958351],
            [34.37242659603689, 3.488925176178763],
            [34.374116365713874, 3.489280054172081],
            [34.375186382286444, 3.491422620192853],
            [34.37838707066063, 3.491417909204525],
            [34.38105286977526, 3.490431248939214],
            [34.38122441924844, 3.486142728903621],
            [34.383621389429486, 3.48372704313911],
            [34.38468944947138, 3.484529515203765],
            [34.389934567786604, 3.484253734719263],
            [34.390953894224324, 3.483627730491175],
            [34.389715611520906, 3.489056226995059],
            [34.39174375141261, 3.490071446086444],
            [34.39680330473959, 3.485312169639204],
            [34.425519212234505, 3.489002379562175],
            [34.44040008968189, 3.501537520221318],
            [34.45224191531912, 3.514416412837892],
            [34.453415144724566, 3.535439043302013],
            [34.45742080444168, 3.57275697794156],
            [34.4538611447884, 3.608435524193017],
            [34.455801568684194, 3.617035209494321],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 793,
        District: "KAABONG",
        County: "DODOTH",
        Subcounty: "LODIKO",
        Population: 6362,
        Key: "KAABONGLODIKO",
        Dist2: "Kaabong",
        "Sub Country": "Lodiko",
        id2_original: "KaabongLodiko",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.82351942744883, 3.312777129089267],
            [33.75140488180372, 3.355468874795048],
            [33.740451394761074, 3.361463150447402],
            [33.739947368919765, 3.361074619506136],
            [33.739989674179775, 3.36016664116915],
            [33.74102140365662, 3.359171446446833],
            [33.74084781860102, 3.357139510917983],
            [33.739599329239354, 3.355973128686747],
            [33.73972807309094, 3.355540667927039],
            [33.740416289498064, 3.355410449887025],
            [33.739813139955075, 3.354243564293922],
            [33.73989831910862, 3.353119361222109],
            [33.73837261324356, 3.350367121546406],
            [33.7374405347795, 3.345598325832789],
            [33.737009711752364, 3.344777168825116],
            [33.7365363966157, 3.34464782461545],
            [33.73644840663363, 3.342053782268375],
            [33.73468175823631, 3.338250387839621],
            [33.733434118680904, 3.338121631064632],
            [33.73210802296355, 3.33719227075381],
            [33.73081278976608, 3.337181131700846],
            [33.729301679727755, 3.334709109876543],
            [33.72899945592344, 3.333196120005809],
            [33.72934301660386, 3.33241762309413],
            [33.728404596932194, 3.329572246605125],
            [33.72932092523441, 3.32894827435671],
            [33.72886041019222, 3.326076040281416],
            [33.72980320016773, 3.324774575125431],
            [33.730097661629664, 3.321847578892515],
            [33.7311747650115, 3.319868515448605],
            [33.73044606512777, 3.318947680019813],
            [33.73093089127648, 3.318215627474024],
            [33.73063312042104, 3.316644050560157],
            [33.73125298311994, 3.316237123539324],
            [33.731225244940596, 3.315180265263646],
            [33.7304157981909, 3.314476258640209],
            [33.73052298337397, 3.31352767705818],
            [33.72973885025065, 3.31057442282074],
            [33.72855187212976, 3.309789398076771],
            [33.727498632493415, 3.30754090614842],
            [33.72790258960533, 3.306835999965472],
            [33.72787398904334, 3.304586742628587],
            [33.727307152997376, 3.303774188770986],
            [33.726900523397475, 3.300793531693769],
            [33.72781565244877, 3.298543566524134],
            [33.727706283461245, 3.296456987740902],
            [33.72530544423626, 3.294968247948338],
            [33.72635642281305, 3.294154503306975],
            [33.7265442695221, 3.292907788180561],
            [33.72565375341127, 3.2919057455049],
            [33.72541141040551, 3.292339505869895],
            [33.72465601079488, 3.291770965843868],
            [33.724277856891206, 3.290849864880141],
            [33.72311859179683, 3.291040404411266],
            [33.721662151430046, 3.290472367664785],
            [33.719830589872004, 3.287871402207406],
            [33.71686310594221, 3.287185393689711],
            [33.715243188363395, 3.287897653512308],
            [33.71419214600625, 3.286223894004589],
            [33.713688584593974, 3.284205676157743],
            [33.7143499925781, 3.283539973177556],
            [33.71423532532704, 3.282737206411279],
            [33.71480542764735, 3.28211745752451],
            [33.7139833281269, 3.281429898896643],
            [33.714324563069034, 3.279869851042182],
            [33.71277124389043, 3.277921192261294],
            [33.71290680236176, 3.275994252223282],
            [33.711810881969654, 3.275398652167039],
            [33.71083002678226, 3.276110431609423],
            [33.71005408359942, 3.276156878427751],
            [33.70868440611605, 3.275722021363262],
            [33.708250276390366, 3.275011231765105],
            [33.707223519088615, 3.275378985190693],
            [33.706697792644995, 3.274232430026894],
            [33.70516801831002, 3.273293035094739],
            [33.70340477273097, 3.27077888325873],
            [33.70121696897566, 3.269396269301894],
            [33.70096535715277, 3.268570651013294],
            [33.701375720150985, 3.267928086346984],
            [33.701055779772645, 3.267308979410763],
            [33.70041688626447, 3.267515864123509],
            [33.69954653912841, 3.266324147755306],
            [33.699733483928945, 3.265683657873657],
            [33.69830881607546, 3.264968945481292],
            [33.697820382292534, 3.263161231385694],
            [33.69707070495025, 3.262651532961701],
            [33.69716056881803, 3.261943221095014],
            [33.69670864885646, 3.261707453650021],
            [33.696237596575976, 3.259928079001923],
            [33.69753638889861, 3.25664017520092],
            [33.697607644165245, 3.255150986952379],
            [33.69626900437326, 3.253045330131823],
            [33.69491355800064, 3.252773867049738],
            [33.69397336415627, 3.251975465844114],
            [33.69370105784419, 3.250141470741741],
            [33.69411547763422, 3.248397801662162],
            [33.69315631406601, 3.246273715235744],
            [33.69152924589756, 3.245148899427117],
            [33.69075145847341, 3.244005337661941],
            [33.68917869076891, 3.243007601384711],
            [33.687497851244174, 3.242518424082883],
            [33.686973147981675, 3.241519967042477],
            [33.686105495791445, 3.241084712043364],
            [33.68355730231718, 3.240596116782919],
            [33.68133515776516, 3.241287713276249],
            [33.675154776458186, 3.24061994326599],
            [33.67258936587316, 3.241420713134111],
            [33.66877671009316, 3.241604854750222],
            [33.66827172844441, 3.243094338327209],
            [33.6670431304781, 3.243349397452014],
            [33.66644652156867, 3.242895783275257],
            [33.666283236596094, 3.241897072790959],
            [33.665650582785894, 3.241588765656572],
            [33.664639063606316, 3.242206885688557],
            [33.66261518172905, 3.242153737628395],
            [33.66221826740899, 3.243116498354722],
            [33.661405503180944, 3.243716323871777],
            [33.66005025713261, 3.243735374416349],
            [33.65800733725956, 3.242193080054413],
            [33.65724838121872, 3.242175415156439],
            [33.655369525157596, 3.242848573472871],
            [33.654015120830685, 3.244175162878064],
            [33.65251560355107, 3.244648305939547],
            [33.64814189687556, 3.243507027055014],
            [33.64622661143467, 3.243744343176911],
            [33.64593790458048, 3.244398304623273],
            [33.644673177271734, 3.244689682381503],
            [33.642001086356835, 3.248323476986443],
            [33.63751933301386, 3.247799675807125],
            [33.635713023996765, 3.248944929260537],
            [33.63498934928873, 3.24756519116784],
            [33.63455556092284, 3.247402021317773],
            [33.63148428295019, 3.248475422336434],
            [33.63029335763195, 3.251236562323991],
            [33.629300120965034, 3.252254171354282],
            [33.629880776693305, 3.256121987335971],
            [33.628364641479294, 3.258992294008525],
            [33.62765984666356, 3.258920092987777],
            [33.62738949957711, 3.2600643732653],
            [33.62514949651725, 3.261264366111746],
            [33.62493314446761, 3.262063561744087],
            [33.62428292949191, 3.262590622765272],
            [33.62352552304494, 3.265115403141906],
            [33.621862859133344, 3.264844030311268],
            [33.62023676024706, 3.265262732526092],
            [33.61947750506723, 3.264791029632468],
            [33.61866449290418, 3.265063940587324],
            [33.617326634646474, 3.264029618106808],
            [33.616441385358165, 3.264375214205913],
            [33.61503132321289, 3.263468055694371],
            [33.61338680886328, 3.263323780747504],
            [33.612140256269385, 3.263851199851035],
            [33.61112809209942, 3.263506768590835],
            [33.6093577938471, 3.264542999225686],
            [33.60773097720691, 3.263781245809049],
            [33.60601643468934, 3.267396235333683],
            [33.60327132511489, 3.270140139702056],
            [33.60215265219324, 3.273010184796807],
            [33.60120535357332, 3.273437555241701],
            [33.600099148369516, 3.272611942971839],
            [33.598993453408795, 3.272641099575578],
            [33.59902285616636, 3.274407609709161],
            [33.59814514015001, 3.276402604652459],
            [33.597464259385475, 3.2756622105988],
            [33.59579149302019, 3.275634718632176],
            [33.59460036827596, 3.275037089691479],
            [33.594090003922, 3.274980408886345],
            [33.59355195977921, 3.2760634412995],
            [33.59074493921371, 3.275723199820903],
            [33.58938355497701, 3.274869232885791],
            [33.58737035137358, 3.274471526321731],
            [33.58598179759114, 3.275640534688979],
            [33.58558419426323, 3.274472577428383],
            [33.584818663452836, 3.274416040983944],
            [33.585158140391954, 3.273133681030338],
            [33.58317319239745, 3.272564993752881],
            [33.582437070632835, 3.274331957826154],
            [33.58246619581096, 3.275671087596265],
            [33.582012666966726, 3.275842307445405],
            [33.58076464652567, 3.27490278218672],
            [33.57852469466975, 3.274619159259916],
            [33.578128751428515, 3.276328939436289],
            [33.57631477349383, 3.277270242699142],
            [33.57529475894656, 3.278410532610319],
            [33.57220479332109, 3.279096132812714],
            [33.569965846679985, 3.280607520959427],
            [33.56282058851959, 3.279614347378498],
            [33.56117719167421, 3.281438800057674],
            [33.56027007020535, 3.281695744480403],
            [33.559844614612075, 3.281382565345981],
            [33.559792201508486, 3.280163983487189],
            [33.558528813587856, 3.279800491828871],
            [33.5567678102038, 3.280378472570313],
            [33.5549671336235, 3.279948609173277],
            [33.554024118170844, 3.280064044616795],
            [33.55291032759278, 3.281472104300295],
            [33.55136728154779, 3.281817636985105],
            [33.55052021155739, 3.281461967290734],
            [33.55081409989413, 3.277485930589044],
            [33.55078593950663, 3.258618391068731],
            [33.55268544334457, 3.239249517775157],
            [33.55395931460456, 3.221278366977386],
            [33.554494232610196, 3.203415551705415],
            [33.556841508888006, 3.182372005617612],
            [33.559478771221045, 3.148935243600278],
            [33.55976650250486, 3.14890796887263],
            [33.559928587328216, 3.147950136457673],
            [33.573427966361386, 3.149639175837144],
            [33.580994602661995, 3.149123816641756],
            [33.58555173903033, 3.147024338109632],
            [33.59170960496301, 3.143331912617782],
            [33.59604008740202, 3.140113272512477],
            [33.60823073155902, 3.132755183569337],
            [33.61352261526961, 3.130622351320324],
            [33.61827956390663, 3.13208544692814],
            [33.62834155297986, 3.137466111959825],
            [33.632937139038994, 3.13861674110175],
            [33.641801733127295, 3.139413621348816],
            [33.65352481675533, 3.1392870251954],
            [33.66674344890603, 3.138198709171853],
            [33.67704051810597, 3.137961551658918],
            [33.69148532995826, 3.138721378669934],
            [33.694083162538504, 3.138374747232192],
            [33.69983930996098, 3.13671726473616],
            [33.70434030252238, 3.134641688854277],
            [33.70688569954118, 3.132543512310737],
            [33.70721801421258, 3.130856819573375],
            [33.704677049481354, 3.129582989489597],
            [33.70215492421833, 3.129544560365392],
            [33.69827490018187, 3.128501727960655],
            [33.695985756581024, 3.126920125821087],
            [33.6920363781131, 3.122159243739084],
            [33.68970502986356, 3.117112294805307],
            [33.68944241906834, 3.110288059957242],
            [33.688768856878426, 3.107223432053563],
            [33.68133938254194, 3.091441079609826],
            [33.6797228965275, 3.089657130128737],
            [33.675598709498566, 3.083157025927043],
            [33.67298853676123, 3.080441942859094],
            [33.67039238223393, 3.076969749243867],
            [33.66694349563497, 3.071157596823733],
            [33.664095601724036, 3.067518393009296],
            [33.66069508401324, 3.061276463630052],
            [33.66457471189261, 3.058421652887747],
            [33.680198321806785, 3.052605999941483],
            [33.68461443345532, 3.052176273438719],
            [33.68556302564926, 3.053024789557324],
            [33.68696723347385, 3.053655766608261],
            [33.6872551605904, 3.053363980168692],
            [33.68908821604678, 3.053594072697428],
            [33.69047874252958, 3.054233170310464],
            [33.69122216580084, 3.055192678070763],
            [33.692962526797984, 3.055287551546216],
            [33.69372691944292, 3.055841713015437],
            [33.695297475495174, 3.055904692252394],
            [33.69601877685424, 3.055456229734828],
            [33.69718648880725, 3.056138124804926],
            [33.69944653417941, 3.055795317315804],
            [33.70180362724667, 3.057831078461581],
            [33.7024403665948, 3.057894659493056],
            [33.7029609735396, 3.058875636315519],
            [33.70382068641931, 3.059141734654688],
            [33.704372956282974, 3.059856027373909],
            [33.704458469609804, 3.060805289567008],
            [33.70640168906273, 3.062777309759583],
            [33.70682678353328, 3.063737015293605],
            [33.708556929787335, 3.064418523857364],
            [33.70982106600462, 3.066465650122716],
            [33.71141332176088, 3.067232575583059],
            [33.71941621859098, 3.069787153298966],
            [33.72082726349319, 3.069327537583872],
            [33.72579423015878, 3.07038014040676],
            [33.73546000919111, 3.068282872417554],
            [33.736786612456626, 3.068505952371059],
            [33.738494210098736, 3.067235461323375],
            [33.739968024781426, 3.065495808804414],
            [33.74096542424136, 3.065367116409887],
            [33.74217463746217, 3.064630290370378],
            [33.74298034183039, 3.063509755075752],
            [33.74391409295751, 3.06341310620542],
            [33.74512314448158, 3.06245228178165],
            [33.74562116328856, 3.061406623165695],
            [33.746194220167894, 3.061459554406642],
            [33.74755177758142, 3.060423960441325],
            [33.75007085845399, 3.059921560232403],
            [33.75120742491776, 3.060247110155029],
            [33.7522620865872, 3.059512080941804],
            [33.75566496147731, 3.058528377713133],
            [33.75590273744817, 3.058822118285777],
            [33.75646896802965, 3.058417594697894],
            [33.757218533082494, 3.058857923454541],
            [33.757620424069245, 3.058637208767494],
            [33.7598684850172, 3.059039731883901],
            [33.761349363152966, 3.05993876625129],
            [33.7631221946544, 3.060213037205826],
            [33.76467536650928, 3.059973125363207],
            [33.76597330633068, 3.060596749825751],
            [33.770542587023364, 3.061475174446132],
            [33.77198600361515, 3.061088379036487],
            [33.77299111690846, 3.061106020097911],
            [33.77370424898832, 3.061693314063923],
            [33.77685803721982, 3.061524004448014],
            [33.77791713477013, 3.060794475824767],
            [33.77802899478593, 3.061242858068011],
            [33.783159465613, 3.060790638314235],
            [33.78962924996854, 3.061514620583964],
            [33.79872123101146, 3.063638045823537],
            [33.81238378003286, 3.062394448307452],
            [33.834356712019606, 3.062321415511486],
            [33.83904072374372, 3.061588995396513],
            [33.851477261048515, 3.06174730827481],
            [33.858280392239685, 3.060957050627369],
            [33.86419183861184, 3.060952275717258],
            [33.872444630584305, 3.059824423948519],
            [33.89692643588706, 3.059411725162418],
            [33.907521487046516, 3.058449808149062],
            [33.91415800949854, 3.058668367298263],
            [33.91884318723593, 3.05950518633185],
            [33.92230042996366, 3.059109810966668],
            [33.92464121591358, 3.057426105084554],
            [33.92843294993061, 3.056918314072557],
            [33.929548533545976, 3.057197619970163],
            [33.94350286525312, 3.071535628248082],
            [33.956532483783214, 3.082086132109743],
            [33.957650577291474, 3.084943331117277],
            [33.95750461453253, 3.085606366503239],
            [33.9595014140006, 3.085567727670634],
            [33.95983032405703, 3.084628319667927],
            [33.961258801665636, 3.084129849008131],
            [33.9617356067572, 3.084681831022067],
            [33.9616628252529, 3.085234315973857],
            [33.96373413009227, 3.086558232243006],
            [33.965693322489294, 3.085451611130503],
            [33.96692079935812, 3.085524146295028],
            [33.967287888712455, 3.086297195403463],
            [33.96811235080213, 3.086388509462274],
            [33.96871656035717, 3.086019679481866],
            [33.969707102976564, 3.08743663907641],
            [33.970550135938105, 3.087804141885533],
            [33.97141112352723, 3.087766523931494],
            [33.97271224518138, 3.088244088051251],
            [33.97300580922634, 3.088740992395119],
            [33.97403153705878, 3.088555909556521],
            [33.975149750941284, 3.089346673298753],
            [33.9752227435497, 3.089033571095355],
            [33.97593749169878, 3.089345946720837],
            [33.976799555469604, 3.09048680708739],
            [33.97832065207895, 3.091111469484139],
            [33.97954711564815, 3.090079157768976],
            [33.98004223469341, 3.090612701368873],
            [33.98196642872694, 3.091310638492521],
            [33.98126728880594, 3.095082516800546],
            [33.983112409534904, 3.097312265062064],
            [33.982736676590896, 3.098673949769929],
            [33.984051120260695, 3.100791912601716],
            [33.983786728106274, 3.101760530519801],
            [33.98442969637258, 3.102503749759062],
            [33.98403940533108, 3.103219868371929],
            [33.9851582543225, 3.105197665530872],
            [33.984628102777805, 3.105661296825413],
            [33.985271115061536, 3.106446618280057],
            [33.985189360285865, 3.1086220188609],
            [33.98572046494308, 3.109182896147002],
            [33.985469775690014, 3.109870814171924],
            [33.98630799637657, 3.11036122938738],
            [33.98827970320379, 3.113531135878206],
            [33.9888938562107, 3.113306006799985],
            [33.98981637121025, 3.114343678663303],
            [33.98948188081926, 3.115003609088042],
            [33.99041814902582, 3.115816715838864],
            [33.990308101810264, 3.117585145461194],
            [33.99071346029401, 3.118047894054929],
            [33.989639435438654, 3.119241829389529],
            [33.99017040624687, 3.119648322901663],
            [33.99007302168356, 3.12002734164571],
            [33.99074346222786, 3.120265290768312],
            [33.990242496946735, 3.122076193975895],
            [33.990955275090414, 3.122791269551493],
            [33.991709152954925, 3.122664247116789],
            [33.992269450163946, 3.124558349145312],
            [33.99206056041936, 3.125147988549423],
            [33.99289842986465, 3.125245431895913],
            [33.993108876389606, 3.126311841027137],
            [33.99359800277362, 3.126760472725179],
            [33.99413191736103, 3.130282578160761],
            [33.99464942152485, 3.131208349187037],
            [33.9945401971661, 3.133832870759044],
            [33.99469412349005, 3.134183581335313],
            [33.995797414559036, 3.134407077036501],
            [33.996119706726816, 3.135613717273963],
            [33.995673315895814, 3.136063243751662],
            [33.996373143926334, 3.137830897444182],
            [33.99789619886299, 3.138966215846227],
            [33.99849877168758, 3.141239192719737],
            [33.99921165403582, 3.142038461377096],
            [33.9993953532232, 3.144325874457792],
            [34.00043140000333, 3.147229972580978],
            [34.00005592038424, 3.148830244685144],
            [34.00060066056916, 3.149012164104779],
            [34.00043405362669, 3.150008759378038],
            [34.001035182858615, 3.150751994664823],
            [34.0010775168647, 3.151215085578949],
            [34.00021247967029, 3.151931669637475],
            [34.00095414404019, 3.153615067885276],
            [34.000605290486135, 3.153853987043939],
            [34.001215951741564, 3.156286446398625],
            [34.00124129501234, 3.160735133385785],
            [34.00027391455425, 3.163002795846953],
            [33.999536226127766, 3.163024696596538],
            [33.99919959684807, 3.163660551835204],
            [33.99928557370561, 3.165397588094677],
            [33.998380847145306, 3.167072026463766],
            [33.99850775933201, 3.167537959685119],
            [33.99741331577023, 3.16919140078191],
            [33.99785860436836, 3.171966120363797],
            [33.997164386316776, 3.173364958615153],
            [33.99735487676772, 3.174190966255625],
            [33.99682903533977, 3.175335433138664],
            [33.9971458325129, 3.175991840368456],
            [33.99628207451945, 3.176437550858423],
            [33.996704381517674, 3.177220961521614],
            [33.99636724019827, 3.177327211475821],
            [33.99624221806693, 3.17883142403402],
            [33.99685732149144, 3.182834669804482],
            [33.99603648949383, 3.184085346756989],
            [33.99452481172021, 3.190251469503583],
            [33.99374506956204, 3.190400515691857],
            [33.993303431717216, 3.191438979777704],
            [33.99267151901712, 3.191884465631256],
            [33.99121770622257, 3.192479037539918],
            [33.990776308227936, 3.193771714501445],
            [33.99071528926393, 3.196080872023286],
            [33.990020790039694, 3.197204319536251],
            [33.99027472490587, 3.198242108537424],
            [33.9898754596947, 3.199513561713921],
            [33.9903192418181, 3.200699456691628],
            [33.98996343799867, 3.203326666864323],
            [33.98933174179258, 3.204005183917341],
            [33.989987083453606, 3.205995878838754],
            [33.989927868306694, 3.210169261262159],
            [33.990371842669575, 3.211545815034837],
            [33.99035225580309, 3.213092296921166],
            [33.98948945002387, 3.214554859641624],
            [33.98949008333613, 3.215211575435684],
            [33.990589746109706, 3.218917771865027],
            [33.99175025626908, 3.220145332985951],
            [33.99118158586331, 3.220611944394468],
            [33.99109825723922, 3.221628875634063],
            [33.99055092990629, 3.222370866335067],
            [33.991162949414424, 3.223132904773125],
            [33.990510085306965, 3.223726707808054],
            [33.99257933120772, 3.227368393087417],
            [33.99344384648095, 3.227664125660201],
            [33.99479426677957, 3.229082149464163],
            [33.99528099735673, 3.231051816316249],
            [33.99616748632013, 3.232258450987071],
            [33.996506214962636, 3.233762205191062],
            [33.99600351233975, 3.237025093195261],
            [33.99674371964226, 3.239524111911348],
            [33.99640720355032, 3.240287082779991],
            [33.99748250131845, 3.240561413849214],
            [33.99727277075075, 3.241642024062432],
            [33.997968813280664, 3.242086206340668],
            [33.99788534631605, 3.242954847095506],
            [33.99710602906097, 3.24356996355103],
            [33.99668567320355, 3.244820256641654],
            [33.99814125208599, 3.245962766348228],
            [33.99890141186931, 3.24729662440765],
            [33.9991138283997, 3.248948791188949],
            [34.000126919631036, 3.250261213691663],
            [33.99983161914262, 3.250805558189735],
            [33.991821268092295, 3.252520951130251],
            [33.98779095590884, 3.252423083067717],
            [33.97658079952826, 3.253914313029846],
            [33.94955835648109, 3.255414414374521],
            [33.9429661425321, 3.256132573930996],
            [33.926130813995805, 3.258906852605741],
            [33.919779752784855, 3.259337133990638],
            [33.91071342762643, 3.2572485801515],
            [33.90588458771557, 3.254313700389013],
            [33.902174603982665, 3.249661102372098],
            [33.90351362825358, 3.271360569617783],
            [33.904536751870026, 3.281871080699884],
            [33.903165596658006, 3.294186530934532],
            [33.902354976708565, 3.297340515387519],
            [33.902557291683564, 3.301907092659652],
            [33.902221371174655, 3.304400889793076],
            [33.90479968785536, 3.307012796262705],
            [33.90771755334044, 3.308182726044414],
            [33.904273708985144, 3.310643770921044],
            [33.895933346543835, 3.314197450319447],
            [33.89255781277769, 3.316418117026484],
            [33.8899472636463, 3.318878312771832],
            [33.88899955090302, 3.320714066664801],
            [33.88804569727645, 3.315650666352772],
            [33.88023166853987, 3.31558427808163],
            [33.87840528487109, 3.314778554397981],
            [33.87847611074305, 3.312283078529991],
            [33.87759795904382, 3.310228787124338],
            [33.87642952754027, 3.310229826534644],
            [33.87409679319023, 3.314929170432572],
            [33.87270911077364, 3.314783617800452],
            [33.87219754716879, 3.314343693583612],
            [33.871464551541344, 3.311261771180559],
            [33.87138916132947, 3.308546206442197],
            [33.869489509269464, 3.307446967951583],
            [33.86599995683593, 3.308565350815638],
            [33.86437752487264, 3.307378050997515],
            [33.86341253483148, 3.306119408611309],
            [33.862400653630836, 3.301434772121096],
            [33.861231651697096, 3.300775193416055],
            [33.85494160136532, 3.300928142426099],
            [33.85165558381894, 3.301819252333161],
            [33.82351942744883, 3.312777129089267],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 794,
        District: "KOTIDO",
        County: "JIE",
        Subcounty: "KACHERI",
        Population: 30016,
        Key: "KOTIDOKACHERI",
        Dist2: "Kotido",
        "Sub Country": "Kacheri",
        id2_original: "KotidoKacheri",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.13170566559566, 3.014139809258428],
            [34.131137982438396, 3.015093419382096],
            [34.13117799160453, 3.016162283445063],
            [34.13050430005719, 3.016775649204402],
            [34.13128339273344, 3.017765527333518],
            [34.131492269003296, 3.019107955208474],
            [34.132245265620526, 3.019941433740152],
            [34.13206601129714, 3.022157639165967],
            [34.13145725806342, 3.022862188235818],
            [34.131950278644155, 3.02309630970622],
            [34.1325487623376, 3.024985814326412],
            [34.13328890585975, 3.02592358625315],
            [34.13334185705416, 3.026966363856964],
            [34.13282357674594, 3.027384039407509],
            [34.133900859790835, 3.028295386331912],
            [34.13288510505467, 3.028890260407411],
            [34.13283858310275, 3.029578884084047],
            [34.13142209081665, 3.030316435622213],
            [34.130219635621735, 3.032454648503018],
            [34.11713435298507, 3.0332518631202],
            [34.11651806108947, 3.031163027708607],
            [34.11538400182363, 3.030926762216929],
            [34.11375270708177, 3.029527550733782],
            [34.112009723003965, 3.026659610789404],
            [34.110761304609234, 3.025224984011136],
            [34.109529573319215, 3.024670927020442],
            [34.10932360579425, 3.023917482833374],
            [34.10966032670207, 3.022657215064985],
            [34.108327985896864, 3.020389021119911],
            [34.107580532783224, 3.020420762054809],
            [34.106922245546386, 3.019775399044634],
            [34.106190326998984, 3.020211848502357],
            [34.10576983459764, 3.017606329770614],
            [34.10619034137204, 3.01656512112121],
            [34.10459048407184, 3.014897480951026],
            [34.104276897477504, 3.012665144792242],
            [34.103549857680406, 3.012060770782187],
            [34.10356967900713, 3.011142657951775],
            [34.10167987787257, 3.010080410276906],
            [34.09952839210587, 3.007149163323511],
            [34.100871887291966, 3.006607376337377],
            [34.10099544876266, 3.006108398597459],
            [34.099414295284994, 3.005744176325243],
            [34.09815685510984, 3.003571234214036],
            [34.09831238582487, 3.002214816929954],
            [34.09690059711764, 3.002389716577533],
            [34.096695388669055, 3.00112828459319],
            [34.09532966467125, 3.000293826407938],
            [34.09595523796039, 2.998321885228805],
            [34.09560974680044, 2.997975283612138],
            [34.09443410901171, 2.99897000602305],
            [34.09380632137539, 2.998718308158965],
            [34.092959504709874, 2.999081881490054],
            [34.09247225580482, 2.998167680697171],
            [34.093428588781585, 2.997504360992928],
            [34.09173258838976, 2.995834387069536],
            [34.09242185852076, 2.994808613578463],
            [34.09224765722086, 2.99316865485921],
            [34.093376266407844, 2.992205522707702],
            [34.093154984403895, 2.990549843940083],
            [34.094816986257165, 2.98958617571796],
            [34.095004728761644, 2.989065562196867],
            [34.09461156939945, 2.98810395598709],
            [34.093262692406476, 2.988420715317748],
            [34.091488500855704, 2.986987373122877],
            [34.092458269934184, 2.984053087744259],
            [34.09344747047054, 2.984903706929732],
            [34.093980696948464, 2.984729698896143],
            [34.093430813908526, 2.983925952912417],
            [34.09369575044202, 2.982143620922731],
            [34.09347572428285, 2.981749576491504],
            [34.09275424326073, 2.981923774284654],
            [34.09243991735291, 2.981356350073806],
            [34.09330209700642, 2.980677357737108],
            [34.09348943257409, 2.979746711208539],
            [34.09424213723886, 2.979414781194459],
            [34.0941944510703, 2.978784005073591],
            [34.09364491567841, 2.978327208060871],
            [34.094834811527335, 2.975897363635066],
            [34.096073995240936, 2.975722649950776],
            [34.097251629984584, 2.976762323936214],
            [34.097627391674656, 2.976004964959577],
            [34.09965064922278, 2.9754982833168],
            [34.099414248572614, 2.974410356446158],
            [34.100400935622794, 2.972737696471881],
            [34.1001965239799, 2.972264789400493],
            [34.09936504425123, 2.972249848086182],
            [34.09956790899522, 2.971161485605835],
            [34.099865687935505, 2.970861548362816],
            [34.10116841308243, 2.971491061403914],
            [34.10265769046609, 2.970401406339396],
            [34.101936023492705, 2.967887434978068],
            [34.10102018297571, 2.967001424186329],
            [34.10141064739204, 2.965325720750557],
            [34.10052726031133, 2.964209731124227],
            [34.101146531020404, 2.962599500273227],
            [34.102215695091786, 2.961831960989781],
            [34.10348880637707, 2.961015788519481],
            [34.10575490819087, 2.962440540513045],
            [34.10642149047104, 2.964519557256138],
            [34.107373203412294, 2.964939037401331],
            [34.10784692728242, 2.964550087809278],
            [34.10814361476962, 2.964726898020063],
            [34.10852877643085, 2.966503583930322],
            [34.109742528838765, 2.966916430980088],
            [34.11046924973395, 2.966378932073691],
            [34.11084284738252, 2.966668483778264],
            [34.11065894876912, 2.969017808733824],
            [34.110947043870624, 2.969272865896559],
            [34.11177630745549, 2.968871997934338],
            [34.112073609390336, 2.969663403503878],
            [34.113047362497085, 2.970028250473149],
            [34.11365822138187, 2.971346906094457],
            [34.115739209161724, 2.973614178089402],
            [34.11689372216824, 2.974013065314894],
            [34.117253992411236, 2.97609301748675],
            [34.117891471072845, 2.976812478281901],
            [34.11932400457495, 2.976650990736127],
            [34.11970392636312, 2.977113469796563],
            [34.11966371238112, 2.97798299718725],
            [34.11904786335493, 2.978810189672492],
            [34.11916086063789, 2.979674209318758],
            [34.11985533830259, 2.982679185177245],
            [34.12058498680726, 2.983505001572654],
            [34.12064177201131, 2.984218791457243],
            [34.122486755298056, 2.985907595166662],
            [34.1238766906894, 2.986169167611565],
            [34.124307458020944, 2.987107997384009],
            [34.12604533517636, 2.987049849496244],
            [34.12803967236222, 2.988164668610394],
            [34.1286589197151, 2.989139505095628],
            [34.12884273029359, 2.990678120899875],
            [34.12946317869403, 2.991501840159793],
            [34.129027011589294, 2.992674717118699],
            [34.13012283855663, 2.995018429085878],
            [34.12975896427268, 2.995605018793402],
            [34.130580855384, 2.997381118383836],
            [34.129544190563, 2.999415620356384],
            [34.13067678108332, 3.002052395671865],
            [34.13045875457395, 3.002693792419063],
            [34.13160811843728, 3.004422536171432],
            [34.131810318427945, 3.005605120926933],
            [34.132905149163605, 3.00695959541169],
            [34.13254078619617, 3.007069891202407],
            [34.132778282790994, 3.007637535332453],
            [34.13234229085772, 3.008975284884619],
            [34.132510397088424, 3.012932034967967],
            [34.13170566559566, 3.014139809258428],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 795,
        District: "KOTIDO",
        County: "KOTIDO MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 13838,
        Key: "KOTIDOCENTRAL DIVISION",
        Dist2: "Kotido",
        "Sub Country": "Kotido TC",
        id2_original: "KotidoKotido TC",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.156543692434425, 3.216281281196331],
            [34.15549470093106, 3.216185589103634],
            [34.15353518514055, 3.216750671176463],
            [34.14725298877929, 3.219370160833977],
            [34.1437158624666, 3.221683425720209],
            [34.142382652092174, 3.218218796596847],
            [34.14082718055019, 3.21664802008083],
            [34.140596537202654, 3.214434965385354],
            [34.13962911182881, 3.211191830993357],
            [34.140319264105386, 3.210789561045208],
            [34.14060509096079, 3.210023210923883],
            [34.14026771697774, 3.209712217755063],
            [34.1405754160137, 3.208554700600011],
            [34.13971601484938, 3.208472155545396],
            [34.13897599080317, 3.207903751228632],
            [34.13849920637284, 3.205946057317175],
            [34.13724855566462, 3.204441130151134],
            [34.13724567117424, 3.201830163241572],
            [34.1366199622395, 3.200726220604646],
            [34.136468341890904, 3.199144744808022],
            [34.135893092223995, 3.198492643194372],
            [34.13596637049666, 3.196986233236793],
            [34.135216129910724, 3.196208796742693],
            [34.13543972777146, 3.195103906288394],
            [34.136221316865864, 3.194970629515602],
            [34.13591309680706, 3.193973636297365],
            [34.13663283150426, 3.189730010827631],
            [34.13755747910433, 3.190105565215822],
            [34.138006684357066, 3.189664350638482],
            [34.1377842192719, 3.188492155096847],
            [34.13710561573661, 3.188072524328018],
            [34.138252654759974, 3.18624675649167],
            [34.13879940088292, 3.1837022918467],
            [34.139646703537, 3.181893758851277],
            [34.13933733093968, 3.18082341537136],
            [34.13994554159099, 3.181064947290635],
            [34.14054443222125, 3.180511963094749],
            [34.13989658610297, 3.179551915762],
            [34.13994170668305, 3.177575294523911],
            [34.13936694030974, 3.177349982845411],
            [34.13889594192818, 3.176200750983688],
            [34.1379660248107, 3.175443521108793],
            [34.137580355601344, 3.173776526521078],
            [34.13826318750668, 3.173083276153583],
            [34.13821226830144, 3.172204641537755],
            [34.137119827084426, 3.169913511932543],
            [34.1376594639402, 3.169217702692146],
            [34.13705964265532, 3.168917099013513],
            [34.13656121780981, 3.167920940763749],
            [34.13645812265622, 3.16705995809201],
            [34.13743086964985, 3.165753401518983],
            [34.13750429704287, 3.164372517903005],
            [34.13717896946776, 3.16382055536868],
            [34.13661750444888, 3.164028551763052],
            [34.136127294696664, 3.161461797957269],
            [34.136426711265685, 3.161160202694341],
            [34.13577614504873, 3.160131593436537],
            [34.136977712708145, 3.157088980072527],
            [34.13659573916787, 3.155812549459113],
            [34.13716163377941, 3.154936787496903],
            [34.13694635162328, 3.152611991972359],
            [34.137240919086395, 3.151895383267607],
            [34.13628474600976, 3.151114606660387],
            [34.13562435222359, 3.14981218204206],
            [34.13509117155975, 3.150416517306351],
            [34.13474130829929, 3.150266268815105],
            [34.13499000419076, 3.14926177427349],
            [34.1342653063016, 3.148961303844839],
            [34.134214561369525, 3.148233298549959],
            [34.135811104784636, 3.146323533603467],
            [34.13489524630133, 3.14477107023836],
            [34.13548759629799, 3.142359172910218],
            [34.13504542215897, 3.141665216289581],
            [34.13387430648936, 3.141299985455406],
            [34.1343645818186, 3.140445016424788],
            [34.13281619708589, 3.138947758048724],
            [34.13264375917888, 3.139218005358605],
            [34.13152978264955, 3.138447616911158],
            [34.130836106282096, 3.135882797590726],
            [34.13156394827476, 3.13474150290956],
            [34.130274502024356, 3.132698469769442],
            [34.13040955833745, 3.130357591276295],
            [34.129464835187406, 3.129054919219612],
            [34.129473592863114, 3.128057380969002],
            [34.12864747607671, 3.127396549207733],
            [34.12887156801085, 3.125608659996722],
            [34.12880248666719, 3.125332193108296],
            [34.128075408242516, 3.125392237790297],
            [34.12796529365331, 3.123496067931765],
            [34.12730719775762, 3.123743689306877],
            [34.12701209310197, 3.123447714389055],
            [34.12731598956931, 3.122775783168233],
            [34.126941972407536, 3.122193471670727],
            [34.12609729373237, 3.122549937586507],
            [34.12624341279818, 3.121354720633721],
            [34.124984087957586, 3.11988447545143],
            [34.124325627345875, 3.119786418070566],
            [34.12402061157768, 3.119411437462714],
            [34.124196887985875, 3.118848286385735],
            [34.1231449266522, 3.118325962184903],
            [34.12252612486368, 3.118563658742831],
            [34.122672015757395, 3.11666278980705],
            [34.12140346072725, 3.115428389330934],
            [34.12123982181845, 3.114220971517754],
            [34.122181165506376, 3.113112574595995],
            [34.12197757672026, 3.111765259458721],
            [34.12228511855106, 3.110802404920231],
            [34.12196509103614, 3.110022033619805],
            [34.12140659405097, 3.110305978269589],
            [34.12124329560366, 3.110005820484905],
            [34.12145976623092, 3.109213802935807],
            [34.12200129853198, 3.10925720034982],
            [34.12277163712577, 3.105990554385822],
            [34.1237106775333, 3.105743920015977],
            [34.123870224615956, 3.102494697248867],
            [34.12487454649353, 3.101811051310882],
            [34.1242492974962, 3.101347569023036],
            [34.124737258765286, 3.100418747944126],
            [34.12397558532069, 3.099382048196597],
            [34.124544949225886, 3.098371231327261],
            [34.12332199447618, 3.097799174341183],
            [34.123329777479796, 3.096708761251096],
            [34.13635644594249, 3.094798185040259],
            [34.158028095559374, 3.09280787672848],
            [34.16036523704416, 3.092370721250133],
            [34.16054490459258, 3.091204302660808],
            [34.16988931492527, 3.092498444305521],
            [34.18431168596344, 3.090599211254959],
            [34.195176164334484, 3.090022029048641],
            [34.20939214923274, 3.088431073503556],
            [34.209391055084744, 3.08746515237687],
            [34.20901652498489, 3.087889644977582],
            [34.20871112743269, 3.087277456321395],
            [34.20800866913504, 3.087890797636714],
            [34.20760936260134, 3.087137360156314],
            [34.20552494056218, 3.088553288492025],
            [34.20470318419813, 3.087305590190259],
            [34.20510113337741, 3.086857513120264],
            [34.204219770201014, 3.086764823982454],
            [34.20424368694717, 3.085346012953925],
            [34.20472746386364, 3.08576672100729],
            [34.20520955194737, 3.084855668676521],
            [34.206558245684036, 3.08485413119528],
            [34.20508767930942, 3.083884599025508],
            [34.20605333679882, 3.083377662888381],
            [34.20633576802245, 3.083923645163805],
            [34.20675840290574, 3.083842231241408],
            [34.20701937966546, 3.083214698607558],
            [34.20675712460311, 3.082709159701114],
            [34.205750409613636, 3.082507971692296],
            [34.20619178065882, 3.081192296655084],
            [34.206614365236476, 3.081070412716632],
            [34.206876623892086, 3.081575949710577],
            [34.207440093950694, 3.081433673044323],
            [34.2064707228259, 3.078642564137302],
            [34.20530097349384, 3.076661014578305],
            [34.20534070957212, 3.076195599892589],
            [34.20725224364836, 3.075505489230035],
            [34.20739525095002, 3.075090716303157],
            [34.1946450614739, 3.065215760535165],
            [34.18434327432208, 3.057893306762442],
            [34.18060794372511, 3.056271266717186],
            [34.17892961499159, 3.054960659045522],
            [34.17898070847001, 3.054329821802369],
            [34.17852481615823, 3.054055552034861],
            [34.177793631534435, 3.05201082856824],
            [34.17636478292159, 3.050791189230909],
            [34.17633334637823, 3.049814253377564],
            [34.174751308060024, 3.047373564461482],
            [34.17438511252937, 3.045786390184928],
            [34.17371644795439, 3.045359700151902],
            [34.17413941431601, 3.043283172350303],
            [34.17383360533541, 3.04136009531422],
            [34.17206991958192, 3.039438609806427],
            [34.17134067801404, 3.039164634963061],
            [34.17024496333614, 3.037028701315259],
            [34.16945524179344, 3.036999032163993],
            [34.167388044051535, 3.035261044082604],
            [34.158039485298836, 3.041071952050367],
            [34.15727876945838, 3.039759958759233],
            [34.156944340152826, 3.03945501508597],
            [34.156792899467284, 3.039852075162611],
            [34.156245702390066, 3.039394706306138],
            [34.15642615326937, 3.037715333733281],
            [34.15612235920997, 3.037654598756003],
            [34.156152149141406, 3.037105017250763],
            [34.15560524581331, 3.036922422884422],
            [34.15621126816859, 3.035578425708289],
            [34.155967831913124, 3.035151262477477],
            [34.154934904083646, 3.034908125516076],
            [34.15535963204157, 3.034449713083899],
            [34.15459791547786, 3.032191270624325],
            [34.15326088007699, 3.031582091183171],
            [34.152986135737216, 3.03026957235296],
            [34.15234772731932, 3.029720703844196],
            [34.149855601295194, 3.028227369382217],
            [34.1492162370698, 3.02676258006929],
            [34.14945654089989, 3.02422828692182],
            [34.15006356846996, 3.023830739386794],
            [34.14981914586431, 3.022457124583938],
            [34.15012261114032, 3.022212554849349],
            [34.150242170616444, 3.02038059227469],
            [34.14993783487292, 3.019800835404456],
            [34.150301271677286, 3.018823468752228],
            [34.15014703363798, 3.016564365787791],
            [34.14926550606988, 3.015863100398783],
            [34.14987214556776, 3.015099189347652],
            [34.15017602676376, 3.015251519297281],
            [34.15014372424447, 3.013419718123851],
            [34.14701553081204, 3.013545158544739],
            [34.144534074078514, 3.013057594755841],
            [34.141424447026395, 3.013596419987945],
            [34.13661522542301, 3.013659376568758],
            [34.13291019230561, 3.014374512117056],
            [34.13170566559566, 3.014139809258428],
            [34.132510397088424, 3.012932034967967],
            [34.13234229085772, 3.008975284884619],
            [34.132778282790994, 3.007637535332453],
            [34.13254078619617, 3.007069891202407],
            [34.132905149163605, 3.00695959541169],
            [34.131810318427945, 3.005605120926933],
            [34.13160811843728, 3.004422536171432],
            [34.13045875457395, 3.002693792419063],
            [34.13067678108332, 3.002052395671865],
            [34.129544190563, 2.999415620356384],
            [34.130580855384, 2.997381118383836],
            [34.12975896427268, 2.995605018793402],
            [34.13012283855663, 2.995018429085878],
            [34.129027011589294, 2.992674717118699],
            [34.12946317869403, 2.991501840159793],
            [34.12884273029359, 2.990678120899875],
            [34.1286589197151, 2.989139505095628],
            [34.12803967236222, 2.988164668610394],
            [34.12604533517636, 2.987049849496244],
            [34.124307458020944, 2.987107997384009],
            [34.1238766906894, 2.986169167611565],
            [34.122486755298056, 2.985907595166662],
            [34.12064177201131, 2.984218791457243],
            [34.12058498680726, 2.983505001572654],
            [34.11985533830259, 2.982679185177245],
            [34.11916086063789, 2.979674209318758],
            [34.11904786335493, 2.978810189672492],
            [34.11966371238112, 2.97798299718725],
            [34.11970392636312, 2.977113469796563],
            [34.12091802731737, 2.978769685539006],
            [34.12139818671823, 2.98132958242083],
            [34.12227551017077, 2.983088948226855],
            [34.123072225996275, 2.983848246339068],
            [34.126018197969934, 2.984805362718199],
            [34.12689536960721, 2.986404696420671],
            [34.1277694384635, 2.98496358004764],
            [34.12894834432324, 2.985619430044706],
            [34.130977823603025, 2.985827218976448],
            [34.13266444648154, 2.984918514404974],
            [34.13477377610862, 2.984996338422267],
            [34.13724271841192, 2.986473989853998],
            [34.13756253841598, 2.987873860344396],
            [34.14003215086248, 2.989991593366451],
            [34.141425260900036, 2.990190168333581],
            [34.14353401740197, 2.989707888763884],
            [34.14651933828002, 2.990224834667339],
            [34.14711716979654, 2.991064323342179],
            [34.14807271764573, 2.991463375582402],
            [34.14891062482024, 2.993542789673679],
            [34.14954700663889, 2.993182070836706],
            [34.14942949262669, 2.994982446875239],
            [34.15062545839197, 2.99694146167148],
            [34.15110357053227, 2.997461030830501],
            [34.15197860867074, 2.996980037295264],
            [34.15229753125787, 2.997499774191058],
            [34.153255940241216, 3.000619196010827],
            [34.1526194757776, 3.000899911395572],
            [34.15400242137773, 3.003282993899178],
            [34.17005420249231, 3.001520884932518],
            [34.16903413494445, 2.999496746409855],
            [34.16835589971843, 2.999132442989598],
            [34.16820785825793, 2.996504369554388],
            [34.171113851608176, 2.993930284709156],
            [34.17258575377761, 2.993287236664478],
            [34.17408028181414, 2.990843136440705],
            [34.17488988666732, 2.990546204438155],
            [34.17673221902563, 2.992049187621459],
            [34.17788626760315, 2.992541374523647],
            [34.179677987081725, 2.992613453034576],
            [34.18152880582454, 2.989698302432275],
            [34.182632458914625, 2.982070799823745],
            [34.18299875325993, 2.981554123698116],
            [34.18286657335238, 2.981157306120913],
            [34.18025736271074, 2.980587462932973],
            [34.18301209324189, 2.975673924642243],
            [34.1851385995555, 2.970768625018512],
            [34.18628371798078, 2.966946202511015],
            [34.18636950888704, 2.964502329095751],
            [34.184885863041885, 2.95593980959544],
            [34.1832418364775, 2.954648772333445],
            [34.18371941322187, 2.954279437380901],
            [34.18426684925098, 2.954431673490118],
            [34.184570114202664, 2.953697799331219],
            [34.18639423681188, 2.953573582932391],
            [34.18651507369231, 2.952839903779157],
            [34.18748797339954, 2.952808294562146],
            [34.18776076659848, 2.952013322548564],
            [34.18925092612776, 2.952347931522443],
            [34.190863484707755, 2.953415953207462],
            [34.19174429182701, 2.95255919588651],
            [34.19335525050747, 2.952129555623082],
            [34.194480921305185, 2.952800757835202],
            [34.19484521330572, 2.952280768409616],
            [34.195270902460976, 2.952310871372132],
            [34.20065372891599, 2.95352761529856],
            [34.20299585964386, 2.954472563380268],
            [34.204315369811894, 2.954052059246221],
            [34.20575274433506, 2.955304875380777],
            [34.21111794853914, 2.952145336019022],
            [34.214372951750335, 2.94875255919365],
            [34.2214396863751, 2.937334477429124],
            [34.225257926981214, 2.928296617986106],
            [34.22727647106906, 2.924566290471279],
            [34.23377187896975, 2.915666132479751],
            [34.2350232716864, 2.910936109888192],
            [34.236452758103056, 2.897099608886757],
            [34.237285995834746, 2.893553790567047],
            [34.238965111492455, 2.887012465975669],
            [34.24409213548379, 2.874398150337059],
            [34.24664367069092, 2.870032835043463],
            [34.256411951090456, 2.859570872062032],
            [34.25842822423725, 2.853920055782713],
            [34.26164324702838, 2.85006126801864],
            [34.267764008946585, 2.847127189635187],
            [34.27401951815737, 2.845670566015002],
            [34.27456977489647, 2.847254872868331],
            [34.275151046869055, 2.858915802538973],
            [34.27872712862404, 2.888996541948644],
            [34.27900393729231, 2.89459265639535],
            [34.28011057638238, 2.900113545548266],
            [34.28028598501802, 2.906533047200487],
            [34.28132548582042, 2.909928066556821],
            [34.28445029350252, 2.915530884055435],
            [34.29867389521609, 2.930380320566632],
            [34.305147416563194, 2.937958538755243],
            [34.34849669678011, 2.991037415082416],
            [34.358439712977116, 3.01148400570609],
            [34.363106356673526, 3.022543826875334],
            [34.365775069922975, 3.0264527455348],
            [34.36871239201876, 3.032318227593303],
            [34.37223449131337, 3.040408697117801],
            [34.37439815554042, 3.043860534973483],
            [34.39763030906149, 3.09192590335274],
            [34.34250444065992, 3.084495828934225],
            [34.33912817297022, 3.085785359138959],
            [34.33224202756534, 3.089780302982122],
            [34.25651089512909, 3.127370734197244],
            [34.214213634636366, 3.150312458552316],
            [34.21333590155204, 3.150157750371499],
            [34.21292979836494, 3.150752997463162],
            [34.214262151746574, 3.15164359591977],
            [34.21459679395284, 3.153204480419634],
            [34.21326926991418, 3.156477287397101],
            [34.21245589842499, 3.156664108220438],
            [34.21193988636288, 3.158151645089861],
            [34.21072075304639, 3.159231100821783],
            [34.2102042199614, 3.160272558871888],
            [34.207394318498736, 3.160870621970803],
            [34.20595629718856, 3.164552467599697],
            [34.20532743786213, 3.164404508364536],
            [34.20299999728406, 3.166488937831405],
            [34.201002812438766, 3.166342571845137],
            [34.19922845739462, 3.167013761027364],
            [34.19837740607085, 3.166605841888557],
            [34.196729016389135, 3.167383442429191],
            [34.1937059815405, 3.166889800762352],
            [34.192002979679366, 3.167388920060075],
            [34.19041209295558, 3.169821266051161],
            [34.19041386353503, 3.171367949759998],
            [34.18953668201628, 3.173191845118103],
            [34.187780290582864, 3.175071994899477],
            [34.18739857755402, 3.177668661777616],
            [34.18778395570923, 3.178275843811866],
            [34.18707327603007, 3.181535756195156],
            [34.187955276112, 3.183910005294133],
            [34.18840062399894, 3.188880982623227],
            [34.18818391441982, 3.191587936998487],
            [34.18763582172226, 3.192859065661564],
            [34.17270053870799, 3.203979369918896],
            [34.15842294824586, 3.213828315085383],
            [34.157325924722585, 3.21570770521265],
            [34.156543692434425, 3.216281281196331],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 796,
        District: "KOTIDO",
        County: "JIE",
        Subcounty: "NAKAPELIMORU",
        Population: 26512,
        Key: "KOTIDONAKAPELIMORU",
        Dist2: "Kotido",
        "Sub Country": "Nakapelimoru",
        id2_original: "KotidoNakapelimoru",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.1437158624666, 3.221683425720209],
            [34.14003225147379, 3.223239841472479],
            [34.13795583072885, 3.225070153315499],
            [34.13087889932729, 3.227667734746708],
            [34.12425357976517, 3.23133331152839],
            [34.121470865814594, 3.232216957441977],
            [34.11982490517739, 3.233762537038477],
            [34.11839770497312, 3.234445363978726],
            [34.11590384699709, 3.23443053579063],
            [34.11380437458363, 3.23506396102877],
            [34.11075265113809, 3.237035728422054],
            [34.10473607941981, 3.239313268903073],
            [34.08803555566832, 3.248480137191742],
            [34.08263820165851, 3.25062180121414],
            [34.07099280523455, 3.249942557429946],
            [34.06421813806149, 3.250724241694013],
            [34.06116526207744, 3.250589959640015],
            [34.05361904448326, 3.251195123369479],
            [34.05098536732654, 3.250541615656697],
            [34.049471367407925, 3.249496044050605],
            [34.04470725290992, 3.248826382581069],
            [34.04196134473317, 3.249315042921447],
            [34.038522729471175, 3.248314258936107],
            [34.035187451907895, 3.248277777770199],
            [34.02879955258377, 3.24866460936403],
            [34.02495838158168, 3.248499896175224],
            [34.022233450863475, 3.249236364900602],
            [34.0201199009512, 3.249014501369108],
            [34.0183316893938, 3.249394210627748],
            [34.01664489853029, 3.250467525221977],
            [34.01117133145179, 3.251583185246182],
            [34.00352634768541, 3.250174112338378],
            [33.99985609823412, 3.250800244236257],
            [33.99983161914262, 3.250805558189735],
            [34.000126919631036, 3.250261213691663],
            [33.9991138283997, 3.248948791188949],
            [33.99890141186931, 3.24729662440765],
            [33.99814125208599, 3.245962766348228],
            [33.99668567320355, 3.244820256641654],
            [33.99710602906097, 3.24356996355103],
            [33.99788534631605, 3.242954847095506],
            [33.997968813280664, 3.242086206340668],
            [33.99727277075075, 3.241642024062432],
            [33.99748250131845, 3.240561413849214],
            [33.99640720355032, 3.240287082779991],
            [33.99674371964226, 3.239524111911348],
            [33.99600351233975, 3.237025093195261],
            [33.996506214962636, 3.233762205191062],
            [33.99616748632013, 3.232258450987071],
            [33.99528099735673, 3.231051816316249],
            [33.99479426677957, 3.229082149464163],
            [33.99344384648095, 3.227664125660201],
            [33.99257933120772, 3.227368393087417],
            [33.990510085306965, 3.223726707808054],
            [33.991162949414424, 3.223132904773125],
            [33.99055092990629, 3.222370866335067],
            [33.99109825723922, 3.221628875634063],
            [33.99118158586331, 3.220611944394468],
            [33.99175025626908, 3.220145332985951],
            [33.990589746109706, 3.218917771865027],
            [33.98949008333613, 3.215211575435684],
            [33.98948945002387, 3.214554859641624],
            [33.99035225580309, 3.213092296921166],
            [33.990371842669575, 3.211545815034837],
            [33.989927868306694, 3.210169261262159],
            [33.989987083453606, 3.205995878838754],
            [33.98933174179258, 3.204005183917341],
            [33.98996343799867, 3.203326666864323],
            [33.9903192418181, 3.200699456691628],
            [33.9898754596947, 3.199513561713921],
            [33.99027472490587, 3.198242108537424],
            [33.990020790039694, 3.197204319536251],
            [33.99071528926393, 3.196080872023286],
            [33.990776308227936, 3.193771714501445],
            [33.99121770622257, 3.192479037539918],
            [33.99267151901712, 3.191884465631256],
            [33.993303431717216, 3.191438979777704],
            [33.99374506956204, 3.190400515691857],
            [33.99452481172021, 3.190251469503583],
            [33.99603648949383, 3.184085346756989],
            [33.99685732149144, 3.182834669804482],
            [33.99624221806693, 3.17883142403402],
            [33.99636724019827, 3.177327211475821],
            [33.996704381517674, 3.177220961521614],
            [33.99628207451945, 3.176437550858423],
            [33.9971458325129, 3.175991840368456],
            [33.99682903533977, 3.175335433138664],
            [33.99735487676772, 3.174190966255625],
            [33.997164386316776, 3.173364958615153],
            [33.99785860436836, 3.171966120363797],
            [33.99741331577023, 3.16919140078191],
            [33.99850775933201, 3.167537959685119],
            [33.998380847145306, 3.167072026463766],
            [33.99928557370561, 3.165397588094677],
            [33.99919959684807, 3.163660551835204],
            [33.999536226127766, 3.163024696596538],
            [34.00027391455425, 3.163002795846953],
            [34.00124129501234, 3.160735133385785],
            [34.001215951741564, 3.156286446398625],
            [34.000605290486135, 3.153853987043939],
            [34.00095414404019, 3.153615067885276],
            [34.00021247967029, 3.151931669637475],
            [34.0010775168647, 3.151215085578949],
            [34.001035182858615, 3.150751994664823],
            [34.00043405362669, 3.150008759378038],
            [34.00060066056916, 3.149012164104779],
            [34.00005592038424, 3.148830244685144],
            [34.00043140000333, 3.147229972580978],
            [33.9993953532232, 3.144325874457792],
            [33.99921165403582, 3.142038461377096],
            [33.99849877168758, 3.141239192719737],
            [33.99789619886299, 3.138966215846227],
            [33.996373143926334, 3.137830897444182],
            [33.995673315895814, 3.136063243751662],
            [33.996119706726816, 3.135613717273963],
            [33.995797414559036, 3.134407077036501],
            [33.99469412349005, 3.134183581335313],
            [33.9945401971661, 3.133832870759044],
            [33.99464942152485, 3.131208349187037],
            [33.99413191736103, 3.130282578160761],
            [33.99359800277362, 3.126760472725179],
            [33.993108876389606, 3.126311841027137],
            [33.99289842986465, 3.125245431895913],
            [33.99206056041936, 3.125147988549423],
            [33.992269450163946, 3.124558349145312],
            [33.991709152954925, 3.122664247116789],
            [33.990955275090414, 3.122791269551493],
            [33.990242496946735, 3.122076193975895],
            [33.99074346222786, 3.120265290768312],
            [33.99007302168356, 3.12002734164571],
            [33.99017040624687, 3.119648322901663],
            [33.989639435438654, 3.119241829389529],
            [33.99071346029401, 3.118047894054929],
            [33.990308101810264, 3.117585145461194],
            [33.99041814902582, 3.115816715838864],
            [33.98948188081926, 3.115003609088042],
            [33.98981637121025, 3.114343678663303],
            [33.9888938562107, 3.113306006799985],
            [33.98827970320379, 3.113531135878206],
            [33.98630799637657, 3.11036122938738],
            [33.985469775690014, 3.109870814171924],
            [33.98572046494308, 3.109182896147002],
            [33.985189360285865, 3.1086220188609],
            [33.985271115061536, 3.106446618280057],
            [33.984628102777805, 3.105661296825413],
            [33.9851582543225, 3.105197665530872],
            [33.98403940533108, 3.103219868371929],
            [33.98442969637258, 3.102503749759062],
            [33.983786728106274, 3.101760530519801],
            [33.984051120260695, 3.100791912601716],
            [33.982736676590896, 3.098673949769929],
            [33.983112409534904, 3.097312265062064],
            [33.98126728880594, 3.095082516800546],
            [33.98196642872694, 3.091310638492521],
            [33.98004223469341, 3.090612701368873],
            [33.97954711564815, 3.090079157768976],
            [33.97832065207895, 3.091111469484139],
            [33.976799555469604, 3.09048680708739],
            [33.97593749169878, 3.089345946720837],
            [33.9752227435497, 3.089033571095355],
            [33.975149750941284, 3.089346673298753],
            [33.97403153705878, 3.088555909556521],
            [33.97300580922634, 3.088740992395119],
            [33.97271224518138, 3.088244088051251],
            [33.97141112352723, 3.087766523931494],
            [33.970550135938105, 3.087804141885533],
            [33.969707102976564, 3.08743663907641],
            [33.96871656035717, 3.086019679481866],
            [33.96811235080213, 3.086388509462274],
            [33.967287888712455, 3.086297195403463],
            [33.96692079935812, 3.085524146295028],
            [33.965693322489294, 3.085451611130503],
            [33.96373413009227, 3.086558232243006],
            [33.9616628252529, 3.085234315973857],
            [33.9617356067572, 3.084681831022067],
            [33.961258801665636, 3.084129849008131],
            [33.95983032405703, 3.084628319667927],
            [33.9595014140006, 3.085567727670634],
            [33.95750461453253, 3.085606366503239],
            [33.957650577291474, 3.084943331117277],
            [33.956532483783214, 3.082086132109743],
            [33.94350286525312, 3.071535628248082],
            [33.929548533545976, 3.057197619970163],
            [33.92843294993061, 3.056918314072557],
            [33.92464121591358, 3.057426105084554],
            [33.92230042996366, 3.059109810966668],
            [33.91884318723593, 3.05950518633185],
            [33.91415800949854, 3.058668367298263],
            [33.907521487046516, 3.058449808149062],
            [33.89692643588706, 3.059411725162418],
            [33.872444630584305, 3.059824423948519],
            [33.86419183861184, 3.060952275717258],
            [33.858280392239685, 3.060957050627369],
            [33.851477261048515, 3.06174730827481],
            [33.83904072374372, 3.061588995396513],
            [33.834356712019606, 3.062321415511486],
            [33.81238378003286, 3.062394448307452],
            [33.79872123101146, 3.063638045823537],
            [33.78962924996854, 3.061514620583964],
            [33.783159465613, 3.060790638314235],
            [33.77802899478593, 3.061242858068011],
            [33.77791713477013, 3.060794475824767],
            [33.77685803721982, 3.061524004448014],
            [33.77370424898832, 3.061693314063923],
            [33.77299111690846, 3.061106020097911],
            [33.77198600361515, 3.061088379036487],
            [33.770542587023364, 3.061475174446132],
            [33.76597330633068, 3.060596749825751],
            [33.76467536650928, 3.059973125363207],
            [33.7631221946544, 3.060213037205826],
            [33.761349363152966, 3.05993876625129],
            [33.7598684850172, 3.059039731883901],
            [33.757620424069245, 3.058637208767494],
            [33.757218533082494, 3.058857923454541],
            [33.75646896802965, 3.058417594697894],
            [33.75590273744817, 3.058822118285777],
            [33.75566496147731, 3.058528377713133],
            [33.7522620865872, 3.059512080941804],
            [33.75120742491776, 3.060247110155029],
            [33.75007085845399, 3.059921560232403],
            [33.74755177758142, 3.060423960441325],
            [33.746194220167894, 3.061459554406642],
            [33.74562116328856, 3.061406623165695],
            [33.74512314448158, 3.06245228178165],
            [33.74391409295751, 3.06341310620542],
            [33.74298034183039, 3.063509755075752],
            [33.74217463746217, 3.064630290370378],
            [33.74096542424136, 3.065367116409887],
            [33.739968024781426, 3.065495808804414],
            [33.738494210098736, 3.067235461323375],
            [33.736786612456626, 3.068505952371059],
            [33.73546000919111, 3.068282872417554],
            [33.72579423015878, 3.07038014040676],
            [33.72082726349319, 3.069327537583872],
            [33.71941621859098, 3.069787153298966],
            [33.71141332176088, 3.067232575583059],
            [33.70982106600462, 3.066465650122716],
            [33.708556929787335, 3.064418523857364],
            [33.70682678353328, 3.063737015293605],
            [33.70640168906273, 3.062777309759583],
            [33.704458469609804, 3.060805289567008],
            [33.704372956282974, 3.059856027373909],
            [33.70382068641931, 3.059141734654688],
            [33.7029609735396, 3.058875636315519],
            [33.7024403665948, 3.057894659493056],
            [33.70180362724667, 3.057831078461581],
            [33.69944653417941, 3.055795317315804],
            [33.69718648880725, 3.056138124804926],
            [33.69601877685424, 3.055456229734828],
            [33.695297475495174, 3.055904692252394],
            [33.69372691944292, 3.055841713015437],
            [33.692962526797984, 3.055287551546216],
            [33.69122216580084, 3.055192678070763],
            [33.69047874252958, 3.054233170310464],
            [33.68908821604678, 3.053594072697428],
            [33.6872551605904, 3.053363980168692],
            [33.69157674072493, 3.049098126700354],
            [33.69318849531276, 3.046108794862576],
            [33.69887502779227, 3.040299305356158],
            [33.7077692025046, 3.034072008593804],
            [33.72131081942413, 3.021687145927304],
            [33.72226654424143, 3.020291101724847],
            [33.72280799928733, 3.018367241055348],
            [33.722760214304124, 3.01498562185188],
            [33.72171028945117, 3.002300420113347],
            [33.72057582145192, 2.997842430574416],
            [33.72086512748245, 2.99389317302749],
            [33.72054998859929, 2.990804944556126],
            [33.72202910334215, 2.989641237472601],
            [33.722164338419965, 2.987991537554325],
            [33.72441664390764, 2.984490808305992],
            [33.72472015679439, 2.984209582755599],
            [33.726699281909234, 2.985204515017463],
            [33.72769296953043, 2.985133730529927],
            [33.729364487237454, 2.983569852761441],
            [33.72974296633129, 2.981864365698493],
            [33.730529624618846, 2.981669344430188],
            [33.73127070418554, 2.980612679518064],
            [33.734319130813965, 2.979340739857392],
            [33.73741434978727, 2.979148155565895],
            [33.73798156492228, 2.978795505915051],
            [33.739068773452765, 2.976435928150888],
            [33.73983355237329, 2.976356251906505],
            [33.74001161642891, 2.975192559135056],
            [33.74131114716666, 2.975002270706162],
            [33.742628990959844, 2.973604840115823],
            [33.74380305939177, 2.973335492159173],
            [33.744335338147096, 2.971202447543756],
            [33.74502318893991, 2.970456216069282],
            [33.74727010812916, 2.969931126795666],
            [33.74878652721082, 2.967829650302549],
            [33.749608634816106, 2.967691694446198],
            [33.752133408312645, 2.965576520173325],
            [33.762937822628864, 2.969194410997771],
            [33.77012869723936, 2.97212723600208],
            [33.783374851973726, 2.976678307530003],
            [33.78682512287656, 2.977311378748533],
            [33.8040688120663, 2.983436923519503],
            [33.85150411259066, 2.948909160576762],
            [33.854824804208704, 2.950607771773391],
            [33.87723626856434, 2.959798888633919],
            [33.882867139632225, 2.962568082419828],
            [33.88828111157644, 2.970108155040182],
            [33.91266030052763, 2.998520882110095],
            [33.91793674130018, 3.001466684077857],
            [33.922965795026606, 3.005050699596147],
            [33.93652321061706, 3.015510953278168],
            [33.949789875685994, 3.026410608720205],
            [33.95711453729008, 3.030980974161957],
            [33.95949071057399, 3.031932947602381],
            [33.96078066077926, 3.028507351024562],
            [33.96333256070241, 3.023719929483557],
            [33.96568395934908, 3.021986808197109],
            [33.967278294705224, 3.019570830765712],
            [33.969855493881724, 3.017466763660047],
            [33.971380772148706, 3.015400347955516],
            [33.97350146726075, 3.013840517110099],
            [33.982608439389146, 3.014849356629763],
            [33.988436576001845, 3.014286045529438],
            [33.99398849413941, 3.015210968967726],
            [34.00277828102242, 3.015853864154475],
            [34.007773974912496, 3.015570225476064],
            [34.01638633015388, 3.013549775779632],
            [34.016446776891, 3.013968658568351],
            [34.01961480970797, 3.014071133867632],
            [34.02211268135666, 3.013975780428361],
            [34.02446929202861, 3.013361374279559],
            [34.02394831228299, 3.014469176569846],
            [34.024290578491055, 3.015764006329704],
            [34.026036288057426, 3.01846693323213],
            [34.027591203542265, 3.019760605497876],
            [34.03054834876144, 3.021167216931679],
            [34.032936351061, 3.021812510937535],
            [34.03388362183316, 3.021697327629941],
            [34.03358161631948, 3.022916579997397],
            [34.031460820596116, 3.024328035075369],
            [34.03146118171885, 3.024708960732794],
            [34.03169078661391, 3.027070482243981],
            [34.03321677993986, 3.028723805463539],
            [34.034532836085624, 3.028758738792634],
            [34.03676573077665, 3.03185041199926],
            [34.03688821606562, 3.033505645823998],
            [34.04019551290445, 3.034117555717144],
            [34.04167950549931, 3.036956444542198],
            [34.04298634582855, 3.038022560000336],
            [34.04546581548867, 3.038599068754729],
            [34.04660623931827, 3.040289486237135],
            [34.04807534323559, 3.039985249589844],
            [34.04916641542012, 3.042875421613107],
            [34.04895764874473, 3.046142461897321],
            [34.05086716879808, 3.048342154638392],
            [34.052887853571214, 3.048939971630276],
            [34.053467014502885, 3.049524565873215],
            [34.052500607818544, 3.054149830873736],
            [34.05421667657379, 3.054561104494919],
            [34.05692529927635, 3.053741606132906],
            [34.057107065289244, 3.054288000040415],
            [34.05583985234214, 3.055386561256935],
            [34.05700294695456, 3.055493957368859],
            [34.05926700240617, 3.054858524909576],
            [34.06216972499048, 3.055751152547684],
            [34.06339391312708, 3.05508056350586],
            [34.06389194271386, 3.054275013603493],
            [34.068475809351796, 3.053112609797183],
            [34.07048324127955, 3.054015154760898],
            [34.07470684036944, 3.054779785536443],
            [34.07788212528567, 3.056612825378386],
            [34.07890440268909, 3.057624890171329],
            [34.08287839230086, 3.05958373877493],
            [34.083325884466404, 3.05886868967344],
            [34.08731951035197, 3.055752980711135],
            [34.090841500950425, 3.05451920469956],
            [34.09518328329739, 3.055934900002391],
            [34.10053364463803, 3.058697305665149],
            [34.10468632263454, 3.059950329922962],
            [34.10729688074913, 3.059450123639438],
            [34.10951010862364, 3.058118147968325],
            [34.111972029694655, 3.05800704018365],
            [34.114029433105046, 3.056639038601519],
            [34.11847590062363, 3.054825093171927],
            [34.11850040217303, 3.055212636279485],
            [34.117838273740034, 3.05542516978501],
            [34.117400330665966, 3.056310759692445],
            [34.117649813481634, 3.056803783069948],
            [34.11825929435077, 3.056447684390102],
            [34.11893381144984, 3.057308760132016],
            [34.118161695090095, 3.057578910773755],
            [34.11792461800851, 3.058510156227223],
            [34.1199159350584, 3.059523743291912],
            [34.11924326669215, 3.060447785666602],
            [34.119730008049075, 3.0611844773381],
            [34.12108094757396, 3.060938304418026],
            [34.121296468681955, 3.06207685840858],
            [34.12096148511589, 3.0638315525232],
            [34.12191309475088, 3.066138893792424],
            [34.121028207483604, 3.069094507980344],
            [34.12154928694227, 3.069617183855549],
            [34.12155054099039, 3.070817522895168],
            [34.12081637395982, 3.071495411038518],
            [34.120212374610574, 3.073239856452576],
            [34.121951396219615, 3.073494776104151],
            [34.12342230754732, 3.074601226650532],
            [34.12316539207101, 3.077685346873821],
            [34.125121070258615, 3.080577283921158],
            [34.124884724405675, 3.083133091772708],
            [34.12429818920386, 3.083308453708592],
            [34.1242899112285, 3.083701672661067],
            [34.12536825069218, 3.084245614960133],
            [34.12492853703871, 3.084725377448649],
            [34.125713215439404, 3.085731452257702],
            [34.123998924450085, 3.088026722601816],
            [34.124239616352384, 3.089599118728279],
            [34.123087554848276, 3.089272706767546],
            [34.122553339325215, 3.090013040119433],
            [34.121575150337605, 3.089828565674955],
            [34.12119541180575, 3.090347724965834],
            [34.121684805887696, 3.090784053338963],
            [34.122447817822064, 3.093103993895356],
            [34.12350732769908, 3.093239383576849],
            [34.123329777479796, 3.096708761251096],
            [34.12332199447618, 3.097799174341183],
            [34.124544949225886, 3.098371231327261],
            [34.12397558532069, 3.099382048196597],
            [34.124737258765286, 3.100418747944126],
            [34.1242492974962, 3.101347569023036],
            [34.12487454649353, 3.101811051310882],
            [34.123870224615956, 3.102494697248867],
            [34.1237106775333, 3.105743920015977],
            [34.12277163712577, 3.105990554385822],
            [34.12200129853198, 3.10925720034982],
            [34.12145976623092, 3.109213802935807],
            [34.12124329560366, 3.110005820484905],
            [34.12140659405097, 3.110305978269589],
            [34.12196509103614, 3.110022033619805],
            [34.12228511855106, 3.110802404920231],
            [34.12197757672026, 3.111765259458721],
            [34.122181165506376, 3.113112574595995],
            [34.12123982181845, 3.114220971517754],
            [34.12140346072725, 3.115428389330934],
            [34.122672015757395, 3.11666278980705],
            [34.12252612486368, 3.118563658742831],
            [34.1231449266522, 3.118325962184903],
            [34.124196887985875, 3.118848286385735],
            [34.12402061157768, 3.119411437462714],
            [34.124325627345875, 3.119786418070566],
            [34.124984087957586, 3.11988447545143],
            [34.12624341279818, 3.121354720633721],
            [34.12609729373237, 3.122549937586507],
            [34.126941972407536, 3.122193471670727],
            [34.12731598956931, 3.122775783168233],
            [34.12701209310197, 3.123447714389055],
            [34.12730719775762, 3.123743689306877],
            [34.12796529365331, 3.123496067931765],
            [34.128075408242516, 3.125392237790297],
            [34.12880248666719, 3.125332193108296],
            [34.12887156801085, 3.125608659996722],
            [34.12864747607671, 3.127396549207733],
            [34.129473592863114, 3.128057380969002],
            [34.129464835187406, 3.129054919219612],
            [34.13040955833745, 3.130357591276295],
            [34.130274502024356, 3.132698469769442],
            [34.13156394827476, 3.13474150290956],
            [34.130836106282096, 3.135882797590726],
            [34.13152978264955, 3.138447616911158],
            [34.13264375917888, 3.139218005358605],
            [34.13281619708589, 3.138947758048724],
            [34.1343645818186, 3.140445016424788],
            [34.13387430648936, 3.141299985455406],
            [34.13504542215897, 3.141665216289581],
            [34.13548759629799, 3.142359172910218],
            [34.13489524630133, 3.14477107023836],
            [34.135811104784636, 3.146323533603467],
            [34.134214561369525, 3.148233298549959],
            [34.1342653063016, 3.148961303844839],
            [34.13499000419076, 3.14926177427349],
            [34.13474130829929, 3.150266268815105],
            [34.13509117155975, 3.150416517306351],
            [34.13562435222359, 3.14981218204206],
            [34.13628474600976, 3.151114606660387],
            [34.137240919086395, 3.151895383267607],
            [34.13694635162328, 3.152611991972359],
            [34.13716163377941, 3.154936787496903],
            [34.13659573916787, 3.155812549459113],
            [34.136977712708145, 3.157088980072527],
            [34.13577614504873, 3.160131593436537],
            [34.136426711265685, 3.161160202694341],
            [34.136127294696664, 3.161461797957269],
            [34.13661750444888, 3.164028551763052],
            [34.13717896946776, 3.16382055536868],
            [34.13750429704287, 3.164372517903005],
            [34.13743086964985, 3.165753401518983],
            [34.13645812265622, 3.16705995809201],
            [34.13656121780981, 3.167920940763749],
            [34.13705964265532, 3.168917099013513],
            [34.1376594639402, 3.169217702692146],
            [34.137119827084426, 3.169913511932543],
            [34.13821226830144, 3.172204641537755],
            [34.13826318750668, 3.173083276153583],
            [34.137580355601344, 3.173776526521078],
            [34.1379660248107, 3.175443521108793],
            [34.13889594192818, 3.176200750983688],
            [34.13936694030974, 3.177349982845411],
            [34.13994170668305, 3.177575294523911],
            [34.13989658610297, 3.179551915762],
            [34.14054443222125, 3.180511963094749],
            [34.13994554159099, 3.181064947290635],
            [34.13933733093968, 3.18082341537136],
            [34.139646703537, 3.181893758851277],
            [34.13879940088292, 3.1837022918467],
            [34.138252654759974, 3.18624675649167],
            [34.13710561573661, 3.188072524328018],
            [34.1377842192719, 3.188492155096847],
            [34.138006684357066, 3.189664350638482],
            [34.13755747910433, 3.190105565215822],
            [34.13663283150426, 3.189730010827631],
            [34.13591309680706, 3.193973636297365],
            [34.136221316865864, 3.194970629515602],
            [34.13543972777146, 3.195103906288394],
            [34.135216129910724, 3.196208796742693],
            [34.13596637049666, 3.196986233236793],
            [34.135893092223995, 3.198492643194372],
            [34.136468341890904, 3.199144744808022],
            [34.1366199622395, 3.200726220604646],
            [34.13724567117424, 3.201830163241572],
            [34.13724855566462, 3.204441130151134],
            [34.13849920637284, 3.205946057317175],
            [34.13897599080317, 3.207903751228632],
            [34.13971601484938, 3.208472155545396],
            [34.1405754160137, 3.208554700600011],
            [34.14026771697774, 3.209712217755063],
            [34.14060509096079, 3.210023210923883],
            [34.140319264105386, 3.210789561045208],
            [34.13962911182881, 3.211191830993357],
            [34.140596537202654, 3.214434965385354],
            [34.14082718055019, 3.21664802008083],
            [34.142382652092174, 3.218218796596847],
            [34.1437158624666, 3.221683425720209],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 797,
        District: "KOTIDO",
        County: "JIE",
        Subcounty: "RENGEN",
        Population: 31807,
        Key: "KOTIDORENGEN",
        Dist2: "Kotido",
        "Sub Country": "Rengen",
        id2_original: "KotidoRengen",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.68690472061154, 2.717948682829166],
            [33.68827654956002, 2.720327710826292],
            [33.68825396860871, 2.721168749916796],
            [33.68903322118507, 2.722088226945163],
            [33.689007904863736, 2.723041228230577],
            [33.68973090493702, 2.723903070232434],
            [33.6902389327729, 2.726385762137587],
            [33.69104242369227, 2.726408475453277],
            [33.691024244485845, 2.727081044415364],
            [33.69181065663503, 2.7277203439038],
            [33.691791406636796, 2.728449161882891],
            [33.6925794653979, 2.729032201950263],
            [33.69287128671119, 2.731003887325313],
            [33.69350272959241, 2.731021621463796],
            [33.69422629919758, 2.731883439801164],
            [33.694203725432786, 2.732724496835195],
            [33.69489195261972, 2.732743604704928],
            [33.69487709448493, 2.733304210355732],
            [33.69562324054982, 2.733325259061626],
            [33.695601769916195, 2.734110047656595],
            [33.696290559448514, 2.734129163579938],
            [33.696275711195184, 2.734689769480695],
            [33.699065201137934, 2.737741321072099],
            [33.69904869189965, 2.738358202385912],
            [33.699736921781536, 2.738377298501115],
            [33.699719320191846, 2.739050133533009],
            [33.70040755097203, 2.739069247582963],
            [33.70038664627708, 2.739854322241484],
            [33.70119014168801, 2.7398767490673],
            [33.7010589391475, 2.740490289575521],
            [33.701164268411205, 2.740829756874446],
            [33.70173835835306, 2.740845815631546],
            [33.70171579806302, 2.741686870863149],
            [33.70246194143296, 2.741707626008927],
            [33.704226393449396, 2.746582076558104],
            [33.704955478710424, 2.747219414950992],
            [33.70491531772902, 2.748733313226114],
            [33.705546207247984, 2.748750742923515],
            [33.70551759321124, 2.749815980042256],
            [33.70612978699255, 2.750562521115299],
            [33.706089084327026, 2.752076131607807],
            [33.706643350247205, 2.752821011300154],
            [33.70658945133015, 2.754839254866578],
            [33.70720273836117, 2.755529517399684],
            [33.70734026953282, 2.758955793703764],
            [33.70688143883178, 2.758943062282549],
            [33.70685887764344, 2.759784117314377],
            [33.70588330454992, 2.759756714584473],
            [33.705864056348354, 2.760485530079899],
            [33.704810235502016, 2.761241539657458],
            [33.70478767251702, 2.762082594856987],
            [33.703733839992594, 2.762838604315323],
            [33.703717336144216, 2.76345518013694],
            [33.70234755535458, 2.765268409253613],
            [33.702328929685464, 2.765973778425975],
            [33.69954405618497, 2.769173348230549],
            [33.69913212293167, 2.769554679168179],
            [33.69781242142249, 2.769517860754114],
            [33.69779150774436, 2.770302647953527],
            [33.696930631546344, 2.770278572526886],
            [33.69690807484956, 2.771119619522462],
            [33.69639188851424, 2.771105231880905],
            [33.69637538197091, 2.771721808786226],
            [33.695584150360226, 2.771697431907625],
            [33.695611050411415, 2.772373612847791],
            [33.69457810731058, 2.77234482144427],
            [33.694552804464, 2.773297819400014],
            [33.69361187130615, 2.773514522792563],
            [33.691622317649205, 2.775516227835133],
            [33.69124792050002, 2.776628034790403],
            [33.6904251346667, 2.777334147302729],
            [33.69040697162995, 2.778006983623949],
            [33.68947222966106, 2.778598107071225],
            [33.68883098616011, 2.781104931619291],
            [33.688084809552514, 2.781083877477906],
            [33.68806390126427, 2.781868963858399],
            [33.68723780244415, 2.782687305614423],
            [33.687210832324396, 2.78369657376658],
            [33.685794686788, 2.785115729270317],
            [33.68497969653468, 2.787673531699087],
            [33.684209869082274, 2.788549793292945],
            [33.68416142563397, 2.790343871563307],
            [33.68358786300314, 2.790327809887359],
            [33.68354438903498, 2.791953656657332],
            [33.6829702712453, 2.79193759679788],
            [33.682934493144174, 2.793283002038337],
            [33.68224566678094, 2.793263904115412],
            [33.68222476478091, 2.794048703325822],
            [33.68145765922381, 2.794812734337576],
            [33.681434011073954, 2.795709763649286],
            [33.680630464459064, 2.795687332496512],
            [33.68060459118226, 2.796640334897359],
            [33.679175192800486, 2.798564113572445],
            [33.67311884547805, 2.803836944910253],
            [33.67243000114851, 2.803817566323195],
            [33.67096856435213, 2.804786673833169],
            [33.66982427597017, 2.806774460617958],
            [33.6687913068182, 2.806745374865521],
            [33.66877037876706, 2.807530453056367],
            [33.667832856512355, 2.808233511642067],
            [33.66701452272954, 2.810903553428131],
            [33.66557739344645, 2.813107787223606],
            [33.665536639576956, 2.814621408928726],
            [33.66496307874276, 2.814605332332963],
            [33.6649223149918, 2.81611896285983],
            [33.66429083258472, 2.816101510830463],
            [33.664297630136495, 2.820141065903553],
            [33.661263737351, 2.819775860225141],
            [33.661280255572464, 2.819158992745352],
            [33.65956007522817, 2.819054803922587],
            [33.65957659704286, 2.818438214201399],
            [33.65825682995669, 2.818401364122907],
            [33.65576504708899, 2.817097247787631],
            [33.653928509762565, 2.817045705530057],
            [33.6530273180729, 2.816403342704182],
            [33.65130548572679, 2.816355400103657],
            [33.65057747035927, 2.815661773616972],
            [33.64828206729752, 2.815597473570628],
            [33.64755129589875, 2.815015788802429],
            [33.6461162578936, 2.814975875467911],
            [33.645503511648414, 2.814285293364898],
            [33.6441258328708, 2.814246762639664],
            [33.64351143282719, 2.813612429397605],
            [33.64230637880614, 2.813578609120227],
            [33.637767930988986, 2.811487950791747],
            [33.63673494476904, 2.811459124457361],
            [33.6367531338569, 2.810786273215335],
            [33.63577751584765, 2.810759099569681],
            [33.633457835815335, 2.809459630439916],
            [33.632712203586784, 2.809438833416627],
            [33.63198418552435, 2.808745191152313],
            [33.629303285729776, 2.808052886255795],
            [33.62937110494045, 2.807662151296727],
            [33.62818590728047, 2.806899470934972],
            [33.625892186763245, 2.806779158554157],
            [33.62483934687721, 2.807479137377013],
            [33.623347494023605, 2.807437250760264],
            [33.62175418274689, 2.809019852140969],
            [33.62066384179102, 2.8089893362504],
            [33.61996068280743, 2.809530529094625],
            [33.61755000523347, 2.809463113508361],
            [33.6175334501811, 2.810079707977491],
            [33.61684516729861, 2.810060564569554],
            [33.61573386415557, 2.810814852826852],
            [33.613847685926544, 2.810481403644933],
            [33.61242974106463, 2.811956469246308],
            [33.61179824518282, 2.81193899741548],
            [33.61177729108053, 2.812723796663182],
            [33.611146367425576, 2.812706036832005],
            [33.61112650567462, 2.813434873379088],
            [33.6107249973702, 2.813423782688017],
            [33.61070844860603, 2.814040378652724],
            [33.610019601581534, 2.814021231720865],
            [33.610001398120616, 2.814693799365731],
            [33.60902632359211, 2.814666614147119],
            [33.60646341032358, 2.815997530788776],
            [33.60389855849067, 2.81592485242176],
            [33.603765269163745, 2.799240473787921],
            [33.603760111935706, 2.786863585413176],
            [33.60343321051223, 2.785593597781639],
            [33.60205352310163, 2.783639243639749],
            [33.60013373620289, 2.779667891620742],
            [33.59818861681314, 2.778033743493875],
            [33.5929996207453, 2.775485903985462],
            [33.591673849319776, 2.775237737575867],
            [33.58775743003962, 2.77256481617475],
            [33.586306658042275, 2.769739579657736],
            [33.58117087368028, 2.767476009891094],
            [33.58009220183994, 2.7664634690104],
            [33.57981762548516, 2.765228347975241],
            [33.58004672552702, 2.763824146733736],
            [33.57884396939647, 2.762100713463535],
            [33.57628083424406, 2.761604313970563],
            [33.57351352370568, 2.759232906883853],
            [33.571746184503894, 2.759624780390757],
            [33.570879220423215, 2.757776768770334],
            [33.56988906857096, 2.757066311665004],
            [33.56957926118905, 2.756008938475981],
            [33.566467485366736, 2.754019818041442],
            [33.56460059845843, 2.749426269344395],
            [33.564803005959945, 2.747622168371505],
            [33.563901226772074, 2.746840580271691],
            [33.56282313704006, 2.747036596245554],
            [33.562098201097335, 2.746468186172694],
            [33.56174428014676, 2.745597449455678],
            [33.56202670508221, 2.744779744322594],
            [33.56087739601612, 2.743856060257472],
            [33.56063802463732, 2.74222991332844],
            [33.55929404166599, 2.740755351984871],
            [33.55911688670546, 2.739866763144954],
            [33.557278366797206, 2.739174456505622],
            [33.555253226380245, 2.736233895401852],
            [33.55551751792335, 2.734403104310815],
            [33.55503114307908, 2.733736823190434],
            [33.5544302285445, 2.733808192973802],
            [33.55464195966034, 2.732990521963233],
            [33.5538284902548, 2.732066671780943],
            [33.552891941773886, 2.732546993279787],
            [33.55213184936422, 2.732387386226699],
            [33.55131843116266, 2.731552410819348],
            [33.55010583847974, 2.727456181296072],
            [33.549345394828805, 2.726496765130252],
            [33.54883277480517, 2.726408132685286],
            [33.5475320322401, 2.722365168303589],
            [33.54474717760421, 2.720349246994735],
            [33.542254709321924, 2.719603883220574],
            [33.539938147341964, 2.716956670753669],
            [33.53962010151058, 2.717170095740306],
            [33.53917805852556, 2.716761506796215],
            [33.53823260145196, 2.717090743438983],
            [33.53840891199615, 2.715313266315636],
            [33.53893853892474, 2.714708773970584],
            [33.538142897484335, 2.714069282737098],
            [33.538345390325794, 2.712354047489019],
            [33.53781513996639, 2.712318739280719],
            [33.53774390176773, 2.711092398219106],
            [33.53708972701827, 2.710612812040541],
            [33.537142360209074, 2.709724103141498],
            [33.537637002248935, 2.709172912779318],
            [33.53678835661349, 2.708568988953204],
            [33.53617801875159, 2.707262903507709],
            [33.53375589484428, 2.705646585678846],
            [33.53245527534835, 2.702119115908592],
            [33.53286099315824, 2.700306037262623],
            [33.533779753199894, 2.699576925041862],
            [33.53351419143898, 2.698581719615485],
            [33.532444764161205, 2.698271146671256],
            [33.530782523356116, 2.696334564036292],
            [33.53064074135653, 2.695428180011993],
            [33.529173116964465, 2.693918065199884],
            [33.5296575748039, 2.690265391719169],
            [33.52909173409129, 2.689643567617355],
            [33.52756278081646, 2.689368743651591],
            [33.52613054645332, 2.68792970757326],
            [33.525864463669556, 2.685654800409364],
            [33.52629680754445, 2.684081655822444],
            [33.52449277934984, 2.681132036905607],
            [33.52368766607308, 2.678919567919293],
            [33.523828803980614, 2.678332980836974],
            [33.52437670443872, 2.678314966857188],
            [33.52472997770396, 2.677834926278098],
            [33.52395179861437, 2.67660889415981],
            [33.5246142576274, 2.675871007091508],
            [33.5245609848361, 2.67526672666897],
            [33.52303997087175, 2.672814618381942],
            [33.52166124376022, 2.672477519848775],
            [33.52139597395177, 2.672086612317994],
            [33.52198749300677, 2.670744453340212],
            [33.523012543509495, 2.670655145620051],
            [33.52356011518421, 2.669890647041666],
            [33.52332978534872, 2.668539955539825],
            [33.523682589693415, 2.666957953754625],
            [33.52324589078603, 2.665248464344204],
            [33.52415675104308, 2.665065742751741],
            [33.52663730047814, 2.666612157468137],
            [33.52939670763866, 2.666277991544415],
            [33.53068473455091, 2.666832393127425],
            [33.53407114062693, 2.669975684375891],
            [33.535580066860796, 2.670825960481869],
            [33.5371989253259, 2.670640263242736],
            [33.53962684785838, 2.669529276442478],
            [33.54245979200635, 2.669084056426031],
            [33.54444624467895, 2.668121246221034],
            [33.54658052321642, 2.668638254771275],
            [33.548015323168, 2.668267640290714],
            [33.55003921851996, 2.668784691851747],
            [33.55106905344989, 2.667896296159718],
            [33.553239578110734, 2.667192370947039],
            [33.55445385962638, 2.667376807044267],
            [33.55728790241393, 2.669410359089661],
            [33.55861260125103, 2.669668733903837],
            [33.56155584324455, 2.669075432084097],
            [33.56262293310594, 2.669222929769127],
            [33.5643528026789, 2.670443035159801],
            [33.568400420008, 2.671070107683883],
            [33.57185967855522, 2.672437382804854],
            [33.577968090434894, 2.672656535230304],
            [33.583387861902565, 2.671471974739544],
            [33.58598281268742, 2.67196053355309],
            [33.587552736325705, 2.671274705512571],
            [33.58852825731693, 2.671301944241976],
            [33.58935381714786, 2.670483672087138],
            [33.59211715533608, 2.670224496119803],
            [33.592789351188436, 2.670860555610041],
            [33.595756131737346, 2.671561076909688],
            [33.59682702686227, 2.672320472182227],
            [33.59785989360628, 2.672349370964417],
            [33.59933333908139, 2.673063887192864],
            [33.6004842318773, 2.672984171286216],
            [33.60274016745706, 2.674506017724071],
            [33.60360098885785, 2.674530177619358],
            [33.60358443290718, 2.675147062390794],
            [33.604502589280955, 2.675172611350016],
            [33.60591428546176, 2.676053952307961],
            [33.607007260278046, 2.675972284890468],
            [33.607957393980996, 2.676952808611396],
            [33.61143758147773, 2.677779684579883],
            [33.61233644563247, 2.678534341668216],
            [33.61509038923944, 2.678611538398084],
            [33.61616129963573, 2.679370931995894],
            [33.62006558177809, 2.679368374596215],
            [33.62068044984399, 2.680002740563385],
            [33.62400571837838, 2.680207983878216],
            [33.62398750503599, 2.680880828806475],
            [33.62466330852254, 2.680837239103655],
            [33.62460350318251, 2.67932704611933],
            [33.62564751532423, 2.67745051715774],
            [33.62680383753774, 2.680316765710531],
            [33.63094493535194, 2.68629276857957],
            [33.63222757237248, 2.689234736100233],
            [33.63394532546888, 2.69192609370034],
            [33.63950569854992, 2.69776368108468],
            [33.64156280910949, 2.700387300155917],
            [33.64425531603586, 2.70553210816492],
            [33.649334191226274, 2.710864325368232],
            [33.6491485588644, 2.712025522019219],
            [33.646580856677105, 2.71685856744436],
            [33.6443845871985, 2.719706311309274],
            [33.64326753393935, 2.719997880154691],
            [33.63866739072677, 2.723722058724633],
            [33.63518126716266, 2.72527812564223],
            [33.6331618804551, 2.727670794239526],
            [33.63639938178961, 2.73078158515735],
            [33.64468713170135, 2.734875711751482],
            [33.64746828258334, 2.737038663855796],
            [33.649375355625864, 2.735837983583793],
            [33.64983970737263, 2.734840548667456],
            [33.65188475715123, 2.73399805924254],
            [33.655415885412765, 2.730287855562421],
            [33.657336902105136, 2.729351943639734],
            [33.65749103324496, 2.727824924815931],
            [33.658915392976304, 2.724987356671092],
            [33.65852910572604, 2.723448086846],
            [33.66005347759291, 2.7246056543755],
            [33.66295228172594, 2.72456668643976],
            [33.66663134993837, 2.724190963618655],
            [33.66945499472653, 2.722657305394899],
            [33.67179665653384, 2.723216512369585],
            [33.67432266251894, 2.721122493082669],
            [33.67621812124315, 2.721270897016951],
            [33.67714703853576, 2.720934063157221],
            [33.67800081265313, 2.719139925172739],
            [33.679078173851465, 2.718429326710197],
            [33.68160497574388, 2.717792642421829],
            [33.685767623243414, 2.718276051857488],
            [33.68690472061154, 2.717948682829166],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 798,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "ABIM",
        Population: 12634,
        Key: "ABIMABIM",
        Dist2: "Abim",
        "Sub Country": "Abim",
        id2_original: "AbimAbim",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.68690472061154, 2.717948682829166],
            [33.685767623243414, 2.718276051857488],
            [33.68160497574388, 2.717792642421829],
            [33.679078173851465, 2.718429326710197],
            [33.67800081265313, 2.719139925172739],
            [33.67714703853576, 2.720934063157221],
            [33.67621812124315, 2.721270897016951],
            [33.67432266251894, 2.721122493082669],
            [33.67179665653384, 2.723216512369585],
            [33.66945499472653, 2.722657305394899],
            [33.66663134993837, 2.724190963618655],
            [33.66295228172594, 2.72456668643976],
            [33.66005347759291, 2.7246056543755],
            [33.65852910572604, 2.723448086846],
            [33.658915392976304, 2.724987356671092],
            [33.65749103324496, 2.727824924815931],
            [33.657336902105136, 2.729351943639734],
            [33.655415885412765, 2.730287855562421],
            [33.65188475715123, 2.73399805924254],
            [33.64983970737263, 2.734840548667456],
            [33.649375355625864, 2.735837983583793],
            [33.64746828258334, 2.737038663855796],
            [33.64468713170135, 2.734875711751482],
            [33.63639938178961, 2.73078158515735],
            [33.6331618804551, 2.727670794239526],
            [33.63518126716266, 2.72527812564223],
            [33.63866739072677, 2.723722058724633],
            [33.64326753393935, 2.719997880154691],
            [33.6443845871985, 2.719706311309274],
            [33.646580856677105, 2.71685856744436],
            [33.6491485588644, 2.712025522019219],
            [33.649334191226274, 2.710864325368232],
            [33.64425531603586, 2.70553210816492],
            [33.64156280910949, 2.700387300155917],
            [33.63950569854992, 2.69776368108468],
            [33.63394532546888, 2.69192609370034],
            [33.63222757237248, 2.689234736100233],
            [33.63094493535194, 2.68629276857957],
            [33.62680383753774, 2.680316765710531],
            [33.62564751532423, 2.67745051715774],
            [33.62621708943519, 2.676959958576572],
            [33.62623805252065, 2.676174873664729],
            [33.627121503381765, 2.675358237013798],
            [33.6271413705226, 2.674629409601406],
            [33.62808050525323, 2.673870142282198],
            [33.6288801289253, 2.671872688583451],
            [33.62975915468532, 2.671224264283524],
            [33.6297784603791, 2.670495438902847],
            [33.63112842972345, 2.669411125418454],
            [33.63537411030133, 2.663133966690567],
            [33.63564874863987, 2.661458505624838],
            [33.63661158002937, 2.659802474342088],
            [33.63655866476758, 2.657500417791201],
            [33.63733456932285, 2.656400289635776],
            [33.637275588636264, 2.654322705519075],
            [33.63798199592792, 2.653669291678532],
            [33.638045444834745, 2.651314594803549],
            [33.63882297354407, 2.650158197913392],
            [33.63955875754214, 2.637723249080661],
            [33.63882921414037, 2.63708555818033],
            [33.63885349739911, 2.636188510659368],
            [33.6382221066202, 2.63617102281767],
            [33.6341588999277, 2.632337237428425],
            [33.63532152651783, 2.632517246621607],
            [33.63745267442655, 2.62856502675698],
            [33.63760307126973, 2.626432441934475],
            [33.63628168092781, 2.621630082888227],
            [33.63628061462755, 2.619519335561449],
            [33.635719690394495, 2.617197799515512],
            [33.63585645440492, 2.610900666888964],
            [33.634875658506346, 2.608438626668528],
            [33.634699537506705, 2.606046533783945],
            [33.63588589129848, 2.599854404642524],
            [33.6355686045435, 2.594999844907775],
            [33.63423625745004, 2.589055241258667],
            [33.6321712785469, 2.58715660438384],
            [33.628812139034686, 2.585715938818504],
            [33.62635141811289, 2.583809309169798],
            [33.62310582834755, 2.583725026964953],
            [33.619176381699155, 2.582438657879508],
            [33.61678393184063, 2.580378543829231],
            [33.61097517009196, 2.578405963895031],
            [33.60869448682444, 2.576666559582749],
            [33.615837415653324, 2.575498769532118],
            [33.6190380061111, 2.572448951243743],
            [33.6223244072381, 2.570300682657639],
            [33.62321998086398, 2.568239450543799],
            [33.62424438278307, 2.567723749377183],
            [33.62492704670344, 2.566821817238121],
            [33.62910994941599, 2.564587229352503],
            [33.63248106347092, 2.561150909332696],
            [33.63623693225023, 2.558787718502987],
            [33.64050525486485, 2.556724795052593],
            [33.647804479773356, 2.554059264194375],
            [33.65198893387643, 2.555087525576548],
            [33.65319189033126, 2.555795837389423],
            [33.65498363586098, 2.557195432181754],
            [33.65561497633425, 2.557212913039937],
            [33.65558810952073, 2.55794173062886],
            [33.657373925271244, 2.557991706164139],
            [33.657359032102164, 2.558552317240835],
            [33.65827655246873, 2.558578133315236],
            [33.66082066848993, 2.560051988267888],
            [33.66168141083899, 2.560076136010717],
            [33.66268714127491, 2.561114277628644],
            [33.66354787643742, 2.561138415479855],
            [33.66438101984598, 2.56217155941766],
            [33.66630318189035, 2.563291480003739],
            [33.666910257071166, 2.564206265627372],
            [33.66748427784274, 2.56422237065145],
            [33.66781181707007, 2.564848666217561],
            [33.67204433822736, 2.567604233657189],
            [33.67267512893165, 2.567621704501704],
            [33.673286618433764, 2.568368293016571],
            [33.673826028914114, 2.568368447371593],
            [33.674563613135994, 2.569901862140867],
            [33.68057845469904, 2.57745428440388],
            [33.68663794792161, 2.58322076048835],
            [33.69292413459937, 2.587063819539106],
            [33.69943731027808, 2.589578756396209],
            [33.70312433037738, 2.5902709084604],
            [33.705551425561495, 2.592113872494604],
            [33.705898538180534, 2.591948090214576],
            [33.7058745208231, 2.592572212101419],
            [33.7073046630099, 2.59305323680238],
            [33.70749328766, 2.594573510854427],
            [33.70885694553266, 2.596277501910029],
            [33.70906813855763, 2.599749354295663],
            [33.70812725480716, 2.60111763209019],
            [33.705512325490425, 2.60248685335063],
            [33.70464755419732, 2.605156157624505],
            [33.70146295644655, 2.610305870684856],
            [33.70104129982859, 2.611793029375024],
            [33.69589776929389, 2.618037310056573],
            [33.69444562646745, 2.633617972968627],
            [33.69408377878281, 2.636118736071854],
            [33.695458526357626, 2.63909181113047],
            [33.6927191183903, 2.651307363030261],
            [33.69103084620488, 2.654388369212793],
            [33.68691944849061, 2.668728878139943],
            [33.68425647817081, 2.675331473962569],
            [33.684090542269836, 2.677234162581493],
            [33.68479148510961, 2.678937046182054],
            [33.68474356897237, 2.680731125983649],
            [33.68528566900866, 2.681924385228371],
            [33.685185504159534, 2.687812605505103],
            [33.68446094371263, 2.689138899887499],
            [33.68447484424332, 2.692898272076245],
            [33.683637247885905, 2.694165270352842],
            [33.68371283572714, 2.695626234086746],
            [33.68285264853696, 2.697734004030139],
            [33.68265035422319, 2.700982386788681],
            [33.68326084839196, 2.701784921108867],
            [33.683285293347474, 2.707284063037615],
            [33.68391672365225, 2.70730179662746],
            [33.68382192533863, 2.70870150304093],
            [33.68455703110866, 2.709114976082086],
            [33.68438395629615, 2.711298105583425],
            [33.684488193208445, 2.711693845109599],
            [33.685119073744275, 2.711711567867158],
            [33.685060694030604, 2.713898042332674],
            [33.68569213870841, 2.713915486892532],
            [33.685654119310655, 2.715317142680573],
            [33.686285562191834, 2.71533488333115],
            [33.68690472061154, 2.717948682829166],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 799,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "ABIM TOWN COUNCIL",
        Population: 17168,
        Key: "ABIMABIM TOWN COUNCIL",
        Dist2: "Abim",
        "Sub Country": "Abim TC",
        id2_original: "AbimAbim TC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.6872551605904, 3.053363980168692],
            [33.68696723347385, 3.053655766608261],
            [33.68556302564926, 3.053024789557324],
            [33.68461443345532, 3.052176273438719],
            [33.680198321806785, 3.052605999941483],
            [33.66457471189261, 3.058421652887747],
            [33.66069508401324, 3.061276463630052],
            [33.664095601724036, 3.067518393009296],
            [33.66694349563497, 3.071157596823733],
            [33.67039238223393, 3.076969749243867],
            [33.67298853676123, 3.080441942859094],
            [33.675598709498566, 3.083157025927043],
            [33.6797228965275, 3.089657130128737],
            [33.68133938254194, 3.091441079609826],
            [33.688768856878426, 3.107223432053563],
            [33.68944241906834, 3.110288059957242],
            [33.68970502986356, 3.117112294805307],
            [33.6920363781131, 3.122159243739084],
            [33.695985756581024, 3.126920125821087],
            [33.69827490018187, 3.128501727960655],
            [33.70215492421833, 3.129544560365392],
            [33.704677049481354, 3.129582989489597],
            [33.70721801421258, 3.130856819573375],
            [33.70688569954118, 3.132543512310737],
            [33.70434030252238, 3.134641688854277],
            [33.69983930996098, 3.13671726473616],
            [33.694083162538504, 3.138374747232192],
            [33.69148532995826, 3.138721378669934],
            [33.67704051810597, 3.137961551658918],
            [33.66674344890603, 3.138198709171853],
            [33.65352481675533, 3.1392870251954],
            [33.641801733127295, 3.139413621348816],
            [33.632937139038994, 3.13861674110175],
            [33.62834155297986, 3.137466111959825],
            [33.61827956390663, 3.13208544692814],
            [33.61352261526961, 3.130622351320324],
            [33.60823073155902, 3.132755183569337],
            [33.59604008740202, 3.140113272512477],
            [33.59170960496301, 3.143331912617782],
            [33.58555173903033, 3.147024338109632],
            [33.580994602661995, 3.149123816641756],
            [33.573427966361386, 3.149639175837144],
            [33.559928587328216, 3.147950136457673],
            [33.55976650250486, 3.14890796887263],
            [33.559478771221045, 3.148935243600278],
            [33.56088016103058, 3.125779698619934],
            [33.56781065536272, 3.037029392943597],
            [33.56819034448721, 3.037028238435616],
            [33.57090872199546, 3.001858275077617],
            [33.57110211669971, 3.000543187006243],
            [33.57298001336014, 2.997134393601897],
            [33.572583789844515, 2.989458492505904],
            [33.57503639987762, 2.983159085141355],
            [33.57526445068719, 2.981464117725322],
            [33.57429321465989, 2.974800338721785],
            [33.575612345738875, 2.970081283049447],
            [33.57545417846846, 2.966053505687237],
            [33.57787584962487, 2.960392301726351],
            [33.58029814061884, 2.955944671089029],
            [33.58057813561144, 2.954092758063434],
            [33.5795453021051, 2.948977382501586],
            [33.58008489224849, 2.94604774115492],
            [33.57582746979152, 2.943298467329764],
            [33.57307873192163, 2.940203133067645],
            [33.57104789079589, 2.936866800825421],
            [33.57056775385296, 2.933958610521346],
            [33.57210530400504, 2.929040677963625],
            [33.576982111257124, 2.881216350781824],
            [33.57721067500478, 2.880525738412463],
            [33.57777244095926, 2.880295292256593],
            [33.58199682427838, 2.879958346223409],
            [33.58564827648234, 2.878418544441596],
            [33.59089085436194, 2.875151694043849],
            [33.594542460177806, 2.873967571397135],
            [33.59971212719565, 2.870669340769438],
            [33.60160570933927, 2.870375402200998],
            [33.60395744575247, 2.870708937264461],
            [33.60453981097475, 2.870080907300071],
            [33.604101107925985, 2.866879788177002],
            [33.605296331682865, 2.864274119189883],
            [33.60546074224447, 2.860340343589552],
            [33.604040934276675, 2.851322887968269],
            [33.60389855849067, 2.81592485242176],
            [33.60646341032358, 2.815997530788776],
            [33.60902632359211, 2.814666614147119],
            [33.610001398120616, 2.814693799365731],
            [33.610019601581534, 2.814021231720865],
            [33.61070844860603, 2.814040378652724],
            [33.6107249973702, 2.813423782688017],
            [33.61112650567462, 2.813434873379088],
            [33.611146367425576, 2.812706036832005],
            [33.61177729108053, 2.812723796663182],
            [33.61179824518282, 2.81193899741548],
            [33.61242974106463, 2.811956469246308],
            [33.613847685926544, 2.810481403644933],
            [33.61573386415557, 2.810814852826852],
            [33.61684516729861, 2.810060564569554],
            [33.6175334501811, 2.810079707977491],
            [33.61755000523347, 2.809463113508361],
            [33.61996068280743, 2.809530529094625],
            [33.62066384179102, 2.8089893362504],
            [33.62175418274689, 2.809019852140969],
            [33.623347494023605, 2.807437250760264],
            [33.62483934687721, 2.807479137377013],
            [33.625892186763245, 2.806779158554157],
            [33.62818590728047, 2.806899470934972],
            [33.62937110494045, 2.807662151296727],
            [33.629303285729776, 2.808052886255795],
            [33.63198418552435, 2.808745191152313],
            [33.632712203586784, 2.809438833416627],
            [33.633457835815335, 2.809459630439916],
            [33.63577751584765, 2.810759099569681],
            [33.6367531338569, 2.810786273215335],
            [33.63673494476904, 2.811459124457361],
            [33.637767930988986, 2.811487950791747],
            [33.64230637880614, 2.813578609120227],
            [33.64351143282719, 2.813612429397605],
            [33.6441258328708, 2.814246762639664],
            [33.645503511648414, 2.814285293364898],
            [33.6461162578936, 2.814975875467911],
            [33.64755129589875, 2.815015788802429],
            [33.64828206729752, 2.815597473570628],
            [33.65057747035927, 2.815661773616972],
            [33.65130548572679, 2.816355400103657],
            [33.6530273180729, 2.816403342704182],
            [33.653928509762565, 2.817045705530057],
            [33.65576504708899, 2.817097247787631],
            [33.65825682995669, 2.818401364122907],
            [33.65957659704286, 2.818438214201399],
            [33.65956007522817, 2.819054803922587],
            [33.661280255572464, 2.819158992745352],
            [33.661263737351, 2.819775860225141],
            [33.664297630136495, 2.820141065903553],
            [33.66429083258472, 2.816101510830463],
            [33.6649223149918, 2.81611896285983],
            [33.66496307874276, 2.814605332332963],
            [33.665536639576956, 2.814621408928726],
            [33.66557739344645, 2.813107787223606],
            [33.66701452272954, 2.810903553428131],
            [33.667832856512355, 2.808233511642067],
            [33.66877037876706, 2.807530453056367],
            [33.6687913068182, 2.806745374865521],
            [33.66982427597017, 2.806774460617958],
            [33.67096856435213, 2.804786673833169],
            [33.67243000114851, 2.803817566323195],
            [33.67311884547805, 2.803836944910253],
            [33.679175192800486, 2.798564113572445],
            [33.68060459118226, 2.796640334897359],
            [33.680630464459064, 2.795687332496512],
            [33.681434011073954, 2.795709763649286],
            [33.68145765922381, 2.794812734337576],
            [33.68222476478091, 2.794048703325822],
            [33.68224566678094, 2.793263904115412],
            [33.682934493144174, 2.793283002038337],
            [33.6829702712453, 2.79193759679788],
            [33.68354438903498, 2.791953656657332],
            [33.68358786300314, 2.790327809887359],
            [33.68416142563397, 2.790343871563307],
            [33.684209869082274, 2.788549793292945],
            [33.68497969653468, 2.787673531699087],
            [33.685794686788, 2.785115729270317],
            [33.687210832324396, 2.78369657376658],
            [33.68723780244415, 2.782687305614423],
            [33.68806390126427, 2.781868963858399],
            [33.688084809552514, 2.781083877477906],
            [33.68883098616011, 2.781104931619291],
            [33.68947222966106, 2.778598107071225],
            [33.69040697162995, 2.778006983623949],
            [33.6904251346667, 2.777334147302729],
            [33.69124792050002, 2.776628034790403],
            [33.691622317649205, 2.775516227835133],
            [33.69361187130615, 2.773514522792563],
            [33.694552804464, 2.773297819400014],
            [33.69457810731058, 2.77234482144427],
            [33.695611050411415, 2.772373612847791],
            [33.695584150360226, 2.771697431907625],
            [33.69637538197091, 2.771721808786226],
            [33.69639188851424, 2.771105231880905],
            [33.69690807484956, 2.771119619522462],
            [33.696930631546344, 2.770278572526886],
            [33.69779150774436, 2.770302647953527],
            [33.69781242142249, 2.769517860754114],
            [33.69913212293167, 2.769554679168179],
            [33.69954405618497, 2.769173348230549],
            [33.702328929685464, 2.765973778425975],
            [33.70234755535458, 2.765268409253613],
            [33.703717336144216, 2.76345518013694],
            [33.703733839992594, 2.762838604315323],
            [33.70478767251702, 2.762082594856987],
            [33.704810235502016, 2.761241539657458],
            [33.705864056348354, 2.760485530079899],
            [33.70588330454992, 2.759756714584473],
            [33.70685887764344, 2.759784117314377],
            [33.70688143883178, 2.758943062282549],
            [33.70734026953282, 2.758955793703764],
            [33.70720273836117, 2.755529517399684],
            [33.70658945133015, 2.754839254866578],
            [33.706643350247205, 2.752821011300154],
            [33.706089084327026, 2.752076131607807],
            [33.70612978699255, 2.750562521115299],
            [33.70551759321124, 2.749815980042256],
            [33.705546207247984, 2.748750742923515],
            [33.70491531772902, 2.748733313226114],
            [33.704955478710424, 2.747219414950992],
            [33.704226393449396, 2.746582076558104],
            [33.70246194143296, 2.741707626008927],
            [33.70171579806302, 2.741686870863149],
            [33.70173835835306, 2.740845815631546],
            [33.701164268411205, 2.740829756874446],
            [33.7010589391475, 2.740490289575521],
            [33.70119014168801, 2.7398767490673],
            [33.70038664627708, 2.739854322241484],
            [33.70040755097203, 2.739069247582963],
            [33.699719320191846, 2.739050133533009],
            [33.699736921781536, 2.738377298501115],
            [33.69904869189965, 2.738358202385912],
            [33.699065201137934, 2.737741321072099],
            [33.696275711195184, 2.734689769480695],
            [33.696290559448514, 2.734129163579938],
            [33.695601769916195, 2.734110047656595],
            [33.69562324054982, 2.733325259061626],
            [33.69487709448493, 2.733304210355732],
            [33.69489195261972, 2.732743604704928],
            [33.694203725432786, 2.732724496835195],
            [33.69422629919758, 2.731883439801164],
            [33.69350272959241, 2.731021621463796],
            [33.69287128671119, 2.731003887325313],
            [33.6925794653979, 2.729032201950263],
            [33.691791406636796, 2.728449161882891],
            [33.69181065663503, 2.7277203439038],
            [33.691024244485845, 2.727081044415364],
            [33.69104242369227, 2.726408475453277],
            [33.6902389327729, 2.726385762137587],
            [33.68973090493702, 2.723903070232434],
            [33.689007904863736, 2.723041228230577],
            [33.68903322118507, 2.722088226945163],
            [33.68825396860871, 2.721168749916796],
            [33.68827654956002, 2.720327710826292],
            [33.68690472061154, 2.717948682829166],
            [33.686285562191834, 2.71533488333115],
            [33.685654119310655, 2.715317142680573],
            [33.68569213870841, 2.713915486892532],
            [33.685060694030604, 2.713898042332674],
            [33.685119073744275, 2.711711567867158],
            [33.684488193208445, 2.711693845109599],
            [33.68438395629615, 2.711298105583425],
            [33.68455703110866, 2.709114976082086],
            [33.68382192533863, 2.70870150304093],
            [33.68391672365225, 2.70730179662746],
            [33.683285293347474, 2.707284063037615],
            [33.68326084839196, 2.701784921108867],
            [33.68265035422319, 2.700982386788681],
            [33.68285264853696, 2.697734004030139],
            [33.68371283572714, 2.695626234086746],
            [33.683637247885905, 2.694165270352842],
            [33.68447484424332, 2.692898272076245],
            [33.68446094371263, 2.689138899887499],
            [33.685185504159534, 2.687812605505103],
            [33.68528566900866, 2.681924385228371],
            [33.68474356897237, 2.680731125983649],
            [33.68479148510961, 2.678937046182054],
            [33.684090542269836, 2.677234162581493],
            [33.68425647817081, 2.675331473962569],
            [33.68691944849061, 2.668728878139943],
            [33.69103084620488, 2.654388369212793],
            [33.6927191183903, 2.651307363030261],
            [33.695458526357626, 2.63909181113047],
            [33.69408377878281, 2.636118736071854],
            [33.69444562646745, 2.633617972968627],
            [33.702800670973794, 2.635991291438358],
            [33.70701278869601, 2.634273531305261],
            [33.714702169898715, 2.634849054160699],
            [33.719899005564045, 2.636355070494234],
            [33.72950546254995, 2.63812675031083],
            [33.7335449375493, 2.642763887613852],
            [33.73969708840015, 2.6443067264469],
            [33.755859267073255, 2.646949689233336],
            [33.76073078594328, 2.646439996725992],
            [33.764299701837224, 2.644868722363325],
            [33.77045285969952, 2.643707951112885],
            [33.78042138176239, 2.637801127667523],
            [33.781330630441815, 2.636885584193654],
            [33.782475770426686, 2.630114737300139],
            [33.78526446086881, 2.625902296196154],
            [33.78753150321874, 2.624497302473329],
            [33.789362090104724, 2.62389074815564],
            [33.79042053188486, 2.622808088142625],
            [33.793275835998585, 2.616961421085931],
            [33.79593487439243, 2.624407651315304],
            [33.79891110162484, 2.626813579839284],
            [33.80050735668075, 2.626958468513686],
            [33.80232240181402, 2.628854385508056],
            [33.80238876665226, 2.629484949226846],
            [33.803306854754084, 2.629510653476871],
            [33.80328434746465, 2.630351395016883],
            [33.80414510508505, 2.630375441808902],
            [33.8041192884021, 2.631328430061742],
            [33.805037389080354, 2.631354123505338],
            [33.80500610884386, 2.63253128952177],
            [33.80569425518242, 2.632550638554245],
            [33.80785559187452, 2.635472302218104],
            [33.809374874785334, 2.636636588061974],
            [33.809358399683, 2.63725342894368],
            [33.81052866105477, 2.638576251130092],
            [33.81721248609476, 2.644148582212081],
            [33.817987371062195, 2.645236161835408],
            [33.818793521893106, 2.645146586651408],
            [33.81922870893587, 2.64605629300634],
            [33.81986008983332, 2.646073964667181],
            [33.82313412026053, 2.648184929020728],
            [33.82405167476309, 2.648210317014817],
            [33.82403522571193, 2.648827174579198],
            [33.82512536724181, 2.648857541985542],
            [33.82573863540818, 2.649547740947651],
            [33.8270581806105, 2.649584464301323],
            [33.82795983133927, 2.650226992697911],
            [33.831402326424985, 2.650322752978437],
            [33.83207897881949, 2.650790445924167],
            [33.8406275896083, 2.651028602770141],
            [33.84141455511967, 2.651667797646401],
            [33.84376524769055, 2.651789445561935],
            [33.843748800436025, 2.652406012394974],
            [33.84579960661896, 2.653024262353791],
            [33.84578151275249, 2.653696808976286],
            [33.846642278457736, 2.653720801475057],
            [33.8466214519162, 2.654505860329154],
            [33.847424305930026, 2.654528197199016],
            [33.84740512779699, 2.655256990748139],
            [33.84803650959277, 2.655274377817364],
            [33.848012379945935, 2.656171377428592],
            [33.84873881787177, 2.656261331393689],
            [33.84873871636217, 2.656921145555412],
            [33.84937282274817, 2.656826564903475],
            [33.84969442860303, 2.657676971230439],
            [33.853315158424294, 2.661873289526562],
            [33.862575925722545, 2.669873212619675],
            [33.86323723758695, 2.670901744387323],
            [33.863868615789436, 2.670919110596937],
            [33.864417985891336, 2.671832096569002],
            [33.865330078636966, 2.672081919237379],
            [33.86768173599847, 2.674335274263996],
            [33.86766366548822, 2.675008086524145],
            [33.86852442400692, 2.675032075915613],
            [33.86925079366081, 2.675781538224001],
            [33.87005421720654, 2.675803863939724],
            [33.870949873477414, 2.676670522245393],
            [33.87181064996242, 2.67669449096564],
            [33.872929682210184, 2.677791392101572],
            [33.87401985518109, 2.677821706748449],
            [33.8751361502622, 2.67903110737186],
            [33.876225762684385, 2.679061421090704],
            [33.879057586633216, 2.680542651206498],
            [33.88103588350134, 2.680875818103936],
            [33.882196200522934, 2.69691368304348],
            [33.88188836314642, 2.696942836980308],
            [33.88412165848605, 2.717618130971269],
            [33.88594934830524, 2.724501970483449],
            [33.885354894454174, 2.727720841903865],
            [33.885913513610255, 2.732758731282242],
            [33.88982441004802, 2.744063528772461],
            [33.89204146474566, 2.752018717401638],
            [33.900855915773114, 2.789421729484694],
            [33.904297970684354, 2.790706371355975],
            [33.90413338315462, 2.792660422152396],
            [33.903421405409894, 2.796020056433362],
            [33.900195571394285, 2.800154874817333],
            [33.8990243146892, 2.803992962353328],
            [33.89631255596797, 2.806380178449829],
            [33.8945669389281, 2.806706622273685],
            [33.89208974739556, 2.810890156820432],
            [33.89360480552955, 2.815614876259851],
            [33.894933200934034, 2.81658376850939],
            [33.89418771872417, 2.81744569765018],
            [33.89411055793281, 2.820224026231926],
            [33.89353064421297, 2.820704759608589],
            [33.89347804785308, 2.821777047546871],
            [33.893962039466885, 2.823059796603302],
            [33.89506046436203, 2.824171330545939],
            [33.89473047632726, 2.827192382869776],
            [33.89572055541595, 2.829989669721006],
            [33.895051618651415, 2.831840799422608],
            [33.8949507710827, 2.835832610040906],
            [33.89446331466678, 2.836623107502849],
            [33.894458810513974, 2.838811401938464],
            [33.89385698598599, 2.839299508973827],
            [33.89409676430164, 2.841085351670249],
            [33.89360719594652, 2.842797136807779],
            [33.89371852685464, 2.84425147438173],
            [33.89336008827649, 2.84465374858055],
            [33.89384432243544, 2.845490128589441],
            [33.89347095834886, 2.846237567853741],
            [33.89413899500146, 2.848456720483459],
            [33.893879440274844, 2.849463854621124],
            [33.894449216506736, 2.850415504792311],
            [33.894458459272705, 2.852920686342702],
            [33.89540241526146, 2.854913211241321],
            [33.89493955561637, 2.855527830101397],
            [33.89502432244321, 2.856075050115289],
            [33.89593519707332, 2.858179513814164],
            [33.89514524017201, 2.859732387196631],
            [33.89538578744555, 2.86102860404949],
            [33.8936939336771, 2.863342049198725],
            [33.894006687533164, 2.864220960501773],
            [33.89380199920913, 2.866380017698761],
            [33.89287014981546, 2.867673199908426],
            [33.89247930900504, 2.869817138344403],
            [33.89012746838724, 2.873438977437969],
            [33.8900690204016, 2.874574990886039],
            [33.88940702941082, 2.87582668431419],
            [33.88794681791651, 2.876715192157318],
            [33.887787383123225, 2.87778021188842],
            [33.884658926484455, 2.881566919215387],
            [33.88405830030907, 2.883096840601561],
            [33.882798690702494, 2.883798888631772],
            [33.881349559927216, 2.885925564686452],
            [33.88030550646295, 2.8861531046465],
            [33.8799679618, 2.887613327335961],
            [33.87828903299188, 2.88907173226912],
            [33.878267600087504, 2.889703571924516],
            [33.87720364444815, 2.890378610084024],
            [33.876839542890465, 2.891647811472654],
            [33.87478188166358, 2.894977599313418],
            [33.87385096112791, 2.89905659074951],
            [33.87406599714567, 2.908516419677045],
            [33.87327425619023, 2.912634793075103],
            [33.86909375736938, 2.916441839785756],
            [33.867775847999205, 2.918524897800482],
            [33.866073761521356, 2.919482874292189],
            [33.865202532239685, 2.922032285474872],
            [33.865706072092394, 2.924847094221723],
            [33.86757270118423, 2.930691235377425],
            [33.86738387261656, 2.932303291427594],
            [33.86854658275002, 2.937100769236362],
            [33.865844620157006, 2.943802083848117],
            [33.86173276879351, 2.946061158601913],
            [33.85257663366627, 2.948332604627811],
            [33.85150411259066, 2.948909160576762],
            [33.8040688120663, 2.983436923519503],
            [33.78682512287656, 2.977311378748533],
            [33.783374851973726, 2.976678307530003],
            [33.77012869723936, 2.97212723600208],
            [33.762937822628864, 2.969194410997771],
            [33.752133408312645, 2.965576520173325],
            [33.749608634816106, 2.967691694446198],
            [33.74878652721082, 2.967829650302549],
            [33.74727010812916, 2.969931126795666],
            [33.74502318893991, 2.970456216069282],
            [33.744335338147096, 2.971202447543756],
            [33.74380305939177, 2.973335492159173],
            [33.742628990959844, 2.973604840115823],
            [33.74131114716666, 2.975002270706162],
            [33.74001161642891, 2.975192559135056],
            [33.73983355237329, 2.976356251906505],
            [33.739068773452765, 2.976435928150888],
            [33.73798156492228, 2.978795505915051],
            [33.73741434978727, 2.979148155565895],
            [33.734319130813965, 2.979340739857392],
            [33.73127070418554, 2.980612679518064],
            [33.730529624618846, 2.981669344430188],
            [33.72974296633129, 2.981864365698493],
            [33.729364487237454, 2.983569852761441],
            [33.72769296953043, 2.985133730529927],
            [33.726699281909234, 2.985204515017463],
            [33.72472015679439, 2.984209582755599],
            [33.72441664390764, 2.984490808305992],
            [33.722164338419965, 2.987991537554325],
            [33.72202910334215, 2.989641237472601],
            [33.72054998859929, 2.990804944556126],
            [33.72086512748245, 2.99389317302749],
            [33.72057582145192, 2.997842430574416],
            [33.72171028945117, 3.002300420113347],
            [33.722760214304124, 3.01498562185188],
            [33.72280799928733, 3.018367241055348],
            [33.72226654424143, 3.020291101724847],
            [33.72131081942413, 3.021687145927304],
            [33.7077692025046, 3.034072008593804],
            [33.69887502779227, 3.040299305356158],
            [33.69318849531276, 3.046108794862576],
            [33.69157674072493, 3.049098126700354],
            [33.6872551605904, 3.053363980168692],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 800,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "ALEREK",
        Population: 17398,
        Key: "ABIMALEREK",
        Dist2: "Abim",
        "Sub Country": "Alerek",
        id2_original: "AbimAlerek",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.63887992403816, 2.480833676478855],
            [33.6396640311103, 2.485615668766267],
            [33.640991781524434, 2.488313270853575],
            [33.64382710441129, 2.491495207524607],
            [33.64470255218153, 2.493950485793554],
            [33.64593954310755, 2.495950822972046],
            [33.64671942270798, 2.504232338216426],
            [33.64801482389041, 2.507556676814627],
            [33.64844729173279, 2.510014056475778],
            [33.65319377230177, 2.515360558797183],
            [33.65434465880951, 2.517094750052803],
            [33.655086633098215, 2.519975117881812],
            [33.65495041526345, 2.520730791009455],
            [33.652662702678846, 2.522823853390488],
            [33.651496835865444, 2.528962780003164],
            [33.650350180422734, 2.540787097841927],
            [33.65139146977082, 2.548669062523581],
            [33.65319189033126, 2.555795837389423],
            [33.65198893387643, 2.555087525576548],
            [33.647804479773356, 2.554059264194375],
            [33.64050525486485, 2.556724795052593],
            [33.63623693225023, 2.558787718502987],
            [33.63248106347092, 2.561150909332696],
            [33.62910994941599, 2.564587229352503],
            [33.62492704670344, 2.566821817238121],
            [33.62424438278307, 2.567723749377183],
            [33.62321998086398, 2.568239450543799],
            [33.6223244072381, 2.570300682657639],
            [33.6190380061111, 2.572448951243743],
            [33.615837415653324, 2.575498769532118],
            [33.60869448682444, 2.576666559582749],
            [33.61097517009196, 2.578405963895031],
            [33.61678393184063, 2.580378543829231],
            [33.619176381699155, 2.582438657879508],
            [33.62310582834755, 2.583725026964953],
            [33.62635141811289, 2.583809309169798],
            [33.628812139034686, 2.585715938818504],
            [33.6321712785469, 2.58715660438384],
            [33.63423625745004, 2.589055241258667],
            [33.6355686045435, 2.594999844907775],
            [33.63588589129848, 2.599854404642524],
            [33.634699537506705, 2.606046533783945],
            [33.634875658506346, 2.608438626668528],
            [33.63585645440492, 2.610900666888964],
            [33.635719690394495, 2.617197799515512],
            [33.63628061462755, 2.619519335561449],
            [33.63628168092781, 2.621630082888227],
            [33.63760307126973, 2.626432441934475],
            [33.63745267442655, 2.62856502675698],
            [33.63532152651783, 2.632517246621607],
            [33.6341588999277, 2.632337237428425],
            [33.6382221066202, 2.63617102281767],
            [33.63885349739911, 2.636188510659368],
            [33.63882921414037, 2.63708555818033],
            [33.63955875754214, 2.637723249080661],
            [33.63882297354407, 2.650158197913392],
            [33.638045444834745, 2.651314594803549],
            [33.63798199592792, 2.653669291678532],
            [33.637275588636264, 2.654322705519075],
            [33.63733456932285, 2.656400289635776],
            [33.63655866476758, 2.657500417791201],
            [33.63661158002937, 2.659802474342088],
            [33.63564874863987, 2.661458505624838],
            [33.63537411030133, 2.663133966690567],
            [33.63112842972345, 2.669411125418454],
            [33.6297784603791, 2.670495438902847],
            [33.62975915468532, 2.671224264283524],
            [33.6288801289253, 2.671872688583451],
            [33.62808050525323, 2.673870142282198],
            [33.6271413705226, 2.674629409601406],
            [33.627121503381765, 2.675358237013798],
            [33.62623805252065, 2.676174873664729],
            [33.62621708943519, 2.676959958576572],
            [33.62564751532423, 2.67745051715774],
            [33.62460350318251, 2.67932704611933],
            [33.62466330852254, 2.680837239103655],
            [33.62398750503599, 2.680880828806475],
            [33.62400571837838, 2.680207983878216],
            [33.62068044984399, 2.680002740563385],
            [33.62006558177809, 2.679368374596215],
            [33.61616129963573, 2.679370931995894],
            [33.61509038923944, 2.678611538398084],
            [33.61233644563247, 2.678534341668216],
            [33.61143758147773, 2.677779684579883],
            [33.607957393980996, 2.676952808611396],
            [33.607007260278046, 2.675972284890468],
            [33.60591428546176, 2.676053952307961],
            [33.604502589280955, 2.675172611350016],
            [33.60358443290718, 2.675147062390794],
            [33.60360098885785, 2.674530177619358],
            [33.60274016745706, 2.674506017724071],
            [33.6004842318773, 2.672984171286216],
            [33.59933333908139, 2.673063887192864],
            [33.59785989360628, 2.672349370964417],
            [33.59682702686227, 2.672320472182227],
            [33.595756131737346, 2.671561076909688],
            [33.592789351188436, 2.670860555610041],
            [33.59211715533608, 2.670224496119803],
            [33.58935381714786, 2.670483672087138],
            [33.58852825731693, 2.671301944241976],
            [33.587552736325705, 2.671274705512571],
            [33.58598281268742, 2.67196053355309],
            [33.583387861902565, 2.671471974739544],
            [33.577968090434894, 2.672656535230304],
            [33.57185967855522, 2.672437382804854],
            [33.568400420008, 2.671070107683883],
            [33.5643528026789, 2.670443035159801],
            [33.56262293310594, 2.669222929769127],
            [33.56155584324455, 2.669075432084097],
            [33.55861260125103, 2.669668733903837],
            [33.55728790241393, 2.669410359089661],
            [33.55445385962638, 2.667376807044267],
            [33.553239578110734, 2.667192370947039],
            [33.55106905344989, 2.667896296159718],
            [33.55003921851996, 2.668784691851747],
            [33.548015323168, 2.668267640290714],
            [33.54658052321642, 2.668638254771275],
            [33.54444624467895, 2.668121246221034],
            [33.54245979200635, 2.669084056426031],
            [33.53962684785838, 2.669529276442478],
            [33.5371989253259, 2.670640263242736],
            [33.535580066860796, 2.670825960481869],
            [33.53407114062693, 2.669975684375891],
            [33.53068473455091, 2.666832393127425],
            [33.52939670763866, 2.666277991544415],
            [33.52663730047814, 2.666612157468137],
            [33.52415675104308, 2.665065742751741],
            [33.52324589078603, 2.665248464344204],
            [33.52381393506602, 2.664105240063591],
            [33.5236440807138, 2.659475307678226],
            [33.524439177775136, 2.658941755360444],
            [33.52417372830363, 2.65815983735462],
            [33.52548913406912, 2.655057778851416],
            [33.52520600036292, 2.654240322367886],
            [33.52578878330182, 2.653173658064882],
            [33.52682253937795, 2.652791079020181],
            [33.526663145008875, 2.652009123919215],
            [33.52754573169068, 2.64943157116428],
            [33.528950373401536, 2.648426751168849],
            [33.529532698199624, 2.646293679035318],
            [33.53055707047431, 2.644640297981031],
            [33.52999936849817, 2.642321094282363],
            [33.53051098240866, 2.640170267219731],
            [33.529945116543225, 2.639424023664302],
            [33.530147598604884, 2.637637697133051],
            [33.52866253701484, 2.636500816837334],
            [33.52915674067681, 2.634954308857184],
            [33.52867026522123, 2.633861441030367],
            [33.52905780112973, 2.630821997570813],
            [33.5289426182457, 2.630102222592155],
            [33.52820003130597, 2.629373820784947],
            [33.52834100033025, 2.628396212584315],
            [33.528959387995414, 2.627969382850717],
            [33.53067366191672, 2.627862005283024],
            [33.531522288687526, 2.628554814685158],
            [33.53254716042552, 2.628127809121192],
            [33.53397892586805, 2.628624850830867],
            [33.53468561702736, 2.628073575641436],
            [33.5342787475773, 2.627149527813689],
            [33.535541477032815, 2.62500726151257],
            [33.53612455012755, 2.624687090572339],
            [33.53723803797336, 2.62482880099893],
            [33.537167087235574, 2.624224528862219],
            [33.53866897606752, 2.623424061820898],
            [33.538668800896055, 2.623015282863351],
            [33.53780288065769, 2.623175617579067],
            [33.53690122004749, 2.622429520891724],
            [33.53756311761343, 2.620411936898935],
            [33.536466916946964, 2.619381541582723],
            [33.53660793627689, 2.618492803617628],
            [33.53607752781402, 2.618013151752409],
            [33.53578517290141, 2.616244797799987],
            [33.53590847745394, 2.615284976172346],
            [33.53923027220315, 2.613506199780912],
            [33.53888498406244, 2.611951153479737],
            [33.539449389267226, 2.609302656006185],
            [33.5388838243374, 2.609231818313665],
            [33.5381411861937, 2.608361220072256],
            [33.536462406505905, 2.608770738764177],
            [33.535392857057296, 2.607980263212174],
            [33.534809742640064, 2.608211573109009],
            [33.53387282495154, 2.607643224263661],
            [33.53404925048009, 2.606914422625263],
            [33.53337726932506, 2.60595493936333],
            [33.53298063078777, 2.603729620409684],
            [33.53392287818084, 2.603406978018094],
            [33.537231683291026, 2.592633153351772],
            [33.53933187525503, 2.587846897462485],
            [33.543747347303096, 2.580386529831254],
            [33.551478805593675, 2.568590663835086],
            [33.551652370886366, 2.562747057708377],
            [33.552042834404375, 2.560877739765021],
            [33.55321575029783, 2.558860528846193],
            [33.55727343414798, 2.554923723579314],
            [33.56138094754696, 2.553200353894727],
            [33.56436333003571, 2.550936393774336],
            [33.568446079577235, 2.548548974264353],
            [33.56898321821822, 2.546630401850832],
            [33.570156094585805, 2.544563991225687],
            [33.57397010502525, 2.542840722540845],
            [33.57528995295979, 2.54136449928624],
            [33.57574058743218, 2.537404676965409],
            [33.57647323451329, 2.535252374130656],
            [33.57916164691859, 2.531930991510473],
            [33.578854265886235, 2.528057602489005],
            [33.58007619116664, 2.526396960462754],
            [33.584629065927274, 2.522921020611861],
            [33.58600362395757, 2.520845288069008],
            [33.586308322620496, 2.518693196490727],
            [33.58814111307387, 2.516002406623274],
            [33.59007355813328, 2.514768672603876],
            [33.591273262686805, 2.514002736362889],
            [33.593258523295034, 2.510926006147573],
            [33.60385780821441, 2.503430460690429],
            [33.60777675086221, 2.499659050716076],
            [33.6060995755655, 2.495823582448991],
            [33.60900554915284, 2.493989529982521],
            [33.615035612668365, 2.492939449556009],
            [33.61460028279349, 2.489754247797892],
            [33.62734671641341, 2.471159431329745],
            [33.63454035154679, 2.477746647276473],
            [33.63887992403816, 2.480833676478855],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 801,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "LOTUKEI",
        Population: 22974,
        Key: "ABIMLOTUKEI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96576081381488, 2.61670450789719],
            [33.88090785291212, 2.670454802873253],
            [33.88103588350134, 2.680875818103936],
            [33.879057586633216, 2.680542651206498],
            [33.876225762684385, 2.679061421090704],
            [33.8751361502622, 2.67903110737186],
            [33.87401985518109, 2.677821706748449],
            [33.872929682210184, 2.677791392101572],
            [33.87181064996242, 2.67669449096564],
            [33.870949873477414, 2.676670522245393],
            [33.87005421720654, 2.675803863939724],
            [33.86925079366081, 2.675781538224001],
            [33.86852442400692, 2.675032075915613],
            [33.86766366548822, 2.675008086524145],
            [33.86768173599847, 2.674335274263996],
            [33.865330078636966, 2.672081919237379],
            [33.864417985891336, 2.671832096569002],
            [33.863868615789436, 2.670919110596937],
            [33.86323723758695, 2.670901744387323],
            [33.862575925722545, 2.669873212619675],
            [33.853315158424294, 2.661873289526562],
            [33.84969442860303, 2.657676971230439],
            [33.84937282274817, 2.656826564903475],
            [33.84873871636217, 2.656921145555412],
            [33.84873881787177, 2.656261331393689],
            [33.848012379945935, 2.656171377428592],
            [33.84803650959277, 2.655274377817364],
            [33.84740512779699, 2.655256990748139],
            [33.847424305930026, 2.654528197199016],
            [33.8466214519162, 2.654505860329154],
            [33.846642278457736, 2.653720801475057],
            [33.84578151275249, 2.653696808976286],
            [33.84579960661896, 2.653024262353791],
            [33.843748800436025, 2.652406012394974],
            [33.84376524769055, 2.651789445561935],
            [33.84141455511967, 2.651667797646401],
            [33.8406275896083, 2.651028602770141],
            [33.83207897881949, 2.650790445924167],
            [33.831402326424985, 2.650322752978437],
            [33.82795983133927, 2.650226992697911],
            [33.8270581806105, 2.649584464301323],
            [33.82573863540818, 2.649547740947651],
            [33.82512536724181, 2.648857541985542],
            [33.82403522571193, 2.648827174579198],
            [33.82405167476309, 2.648210317014817],
            [33.82313412026053, 2.648184929020728],
            [33.81986008983332, 2.646073964667181],
            [33.81922870893587, 2.64605629300634],
            [33.818793521893106, 2.645146586651408],
            [33.817987371062195, 2.645236161835408],
            [33.81721248609476, 2.644148582212081],
            [33.81052866105477, 2.638576251130092],
            [33.809358399683, 2.63725342894368],
            [33.809374874785334, 2.636636588061974],
            [33.80785559187452, 2.635472302218104],
            [33.80569425518242, 2.632550638554245],
            [33.80500610884386, 2.63253128952177],
            [33.805037389080354, 2.631354123505338],
            [33.8041192884021, 2.631328430061742],
            [33.80414510508505, 2.630375441808902],
            [33.80328434746465, 2.630351395016883],
            [33.803306854754084, 2.629510653476871],
            [33.80238876665226, 2.629484949226846],
            [33.80232240181402, 2.628854385508056],
            [33.80050735668075, 2.626958468513686],
            [33.79891110162484, 2.626813579839284],
            [33.79593487439243, 2.624407651315304],
            [33.793275835998585, 2.616961421085931],
            [33.798171858214616, 2.614993080979817],
            [33.80525276555962, 2.613499077268702],
            [33.81247574416175, 2.61104470399309],
            [33.81657257569368, 2.608940181955654],
            [33.81970252443416, 2.606940961009537],
            [33.819702150735004, 2.606364008350716],
            [33.822267381656985, 2.603866931515983],
            [33.82389103622736, 2.600768135532503],
            [33.824061151989326, 2.5992191596001],
            [33.82363150485693, 2.59637985677685],
            [33.821491089029465, 2.594230056438546],
            [33.820291683614926, 2.59182149182721],
            [33.8145339210216, 2.588929723049743],
            [33.80815552227992, 2.588403482243984],
            [33.80715822432959, 2.587814803776121],
            [33.80565669212879, 2.585377315402102],
            [33.80274573738321, 2.582367474078404],
            [33.80318678862816, 2.580721462657502],
            [33.803691981381, 2.580173508437276],
            [33.80325538667822, 2.58015200482857],
            [33.805079383523264, 2.579120132711768],
            [33.805769591495405, 2.577381576527412],
            [33.80663344291365, 2.576946496707811],
            [33.808620931343775, 2.576945228671923],
            [33.81008928426954, 2.575901420228691],
            [33.81535684609382, 2.570249172131979],
            [33.8188979043325, 2.567379007994371],
            [33.82009409108337, 2.564648646676195],
            [33.81708204712222, 2.559554137056607],
            [33.81343737001214, 2.55568104189225],
            [33.81010896456078, 2.551064494021226],
            [33.80736288211089, 2.549101971209022],
            [33.80498594166572, 2.546555235963314],
            [33.80313660424482, 2.54358345844143],
            [33.80149733605649, 2.538859632879881],
            [33.80111674861667, 2.520809871260715],
            [33.8012677410429, 2.508758746484927],
            [33.801688849688524, 2.506847309255811],
            [33.795670343897456, 2.504992914287127],
            [33.785907285404676, 2.503430600693864],
            [33.77806634404048, 2.50313200114665],
            [33.77278828001224, 2.502073567303275],
            [33.76600008690594, 2.497072995038762],
            [33.7548382688708, 2.490406704553699],
            [33.71035872746508, 2.465872573157307],
            [33.705358579727864, 2.460848778811124],
            [33.70644301156582, 2.459711367210591],
            [33.72264345397843, 2.452968655844142],
            [33.727614515165094, 2.451349833915877],
            [33.72849297139321, 2.450007676985007],
            [33.72821951254265, 2.448879598182281],
            [33.728644070718964, 2.448077821779473],
            [33.729993562159585, 2.448650408482462],
            [33.73031646069013, 2.448382679401629],
            [33.732110627179566, 2.449445130235784],
            [33.73281392630034, 2.449022703734929],
            [33.73378816180239, 2.447495375840304],
            [33.734405690678116, 2.448227399256563],
            [33.734973457378736, 2.448239498391009],
            [33.73699699789614, 2.4470591524147],
            [33.73726810136408, 2.446264574641048],
            [33.739402890144596, 2.445394488162367],
            [33.73906921901716, 2.444625071649486],
            [33.74020407419032, 2.443420389512351],
            [33.73978400579377, 2.442651021230419],
            [33.73994220899677, 2.438542256185387],
            [33.740509637930856, 2.437946121894562],
            [33.742151311807504, 2.438168644981288],
            [33.742113889789415, 2.437448716211655],
            [33.7429406515662, 2.437113109458621],
            [33.74322390115506, 2.435970964021884],
            [33.743927272141065, 2.435697489287949],
            [33.74433481981917, 2.436144127441489],
            [33.74524783423626, 2.435547799125423],
            [33.74485223954133, 2.434393619517704],
            [33.74281431430128, 2.431800451695766],
            [33.742752356597805, 2.431353620934182],
            [33.743541673898605, 2.43026084788124],
            [33.7430841556362, 2.428709486746596],
            [33.74263960545325, 2.42830010620222],
            [33.74120798823271, 2.428487091339954],
            [33.739306791968765, 2.427631647899949],
            [33.737554068356665, 2.427446417274278],
            [33.73839256931761, 2.426006056069735],
            [33.73761476392715, 2.425572030865434],
            [33.73762661450239, 2.424665880696258],
            [33.73863782106825, 2.423064057705116],
            [33.738193165782405, 2.422456068516222],
            [33.73811851937556, 2.421363771134734],
            [33.73701913687635, 2.419676214569151],
            [33.73641431646691, 2.419589654693604],
            [33.73599414656076, 2.417496765289278],
            [33.74084606598788, 2.414462736731608],
            [33.741680159814045, 2.412959514775532],
            [33.7425147081877, 2.412296071425938],
            [33.748387291644065, 2.410386032517339],
            [33.751210701971935, 2.406961783861747],
            [33.75194180484907, 2.404150787337722],
            [33.75345758522856, 2.403018855791996],
            [33.84942982534453, 2.343131551854567],
            [33.84937006941183, 2.343775902277493],
            [33.85094906333954, 2.346079400016237],
            [33.85339701111635, 2.347452507222272],
            [33.856111039880275, 2.347619941911921],
            [33.858019384038926, 2.345772742432956],
            [33.85901127323294, 2.345639736228549],
            [33.86063058534724, 2.34760311712481],
            [33.860338561913, 2.34909061690889],
            [33.86137894306436, 2.350046930365577],
            [33.861595286130864, 2.351194531857603],
            [33.86253021405101, 2.351727139692104],
            [33.862880102464295, 2.353607116376387],
            [33.86426114273768, 2.353704473534646],
            [33.86380151702761, 2.354841295054136],
            [33.86495954154858, 2.355219416783068],
            [33.86510579266673, 2.357475118785316],
            [33.865873685148024, 2.357902561328503],
            [33.866952196189914, 2.358214766722358],
            [33.868590298365035, 2.357922509481698],
            [33.87118651397777, 2.358100970269861],
            [33.871700706951465, 2.357836324482325],
            [33.87211483389068, 2.356855703388997],
            [33.87346240293662, 2.356333385297987],
            [33.87551700989151, 2.356955861590367],
            [33.87787967071691, 2.356852056621472],
            [33.879103391729544, 2.357247594861822],
            [33.882128966115474, 2.359547490016677],
            [33.883935994683114, 2.35917449629133],
            [33.88496318766782, 2.359710939013497],
            [33.88725216058875, 2.364215169514866],
            [33.8880844613776, 2.3645253486166],
            [33.88940343165811, 2.366359868674039],
            [33.891539982034935, 2.367432688222712],
            [33.8919524722437, 2.370159235176536],
            [33.89514161726649, 2.372771241934027],
            [33.89610242026007, 2.376006508516168],
            [33.89816997463316, 2.377526667254469],
            [33.89925657769917, 2.377611674351711],
            [33.900362039097914, 2.378780429634232],
            [33.903724778159436, 2.379945801994091],
            [33.90515665229814, 2.379752168405223],
            [33.90781749900061, 2.380361928596466],
            [33.92269378785352, 2.388257168147511],
            [33.93098679829959, 2.389616366655256],
            [33.93581303129952, 2.392191071879429],
            [33.942773964146745, 2.394373820539172],
            [33.944045509668484, 2.396032887634735],
            [33.94408426119321, 2.396592438183192],
            [33.94525469953307, 2.396938949165697],
            [33.945696505362854, 2.397787656215254],
            [33.94613764913428, 2.397671575225564],
            [33.946233062793844, 2.39693826883846],
            [33.947919987506324, 2.396698991989052],
            [33.94761189321168, 2.398518195964952],
            [33.94787381320242, 2.398757362100318],
            [33.94846846108958, 2.398421855275839],
            [33.94875469578013, 2.399426892786608],
            [33.94827917078787, 2.3999777197765],
            [33.94920789494267, 2.401018203061145],
            [33.949969227027424, 2.400850139392374],
            [33.950278184603086, 2.400299428535016],
            [33.95192019355135, 2.400513681702861],
            [33.951752714344735, 2.399197435327003],
            [33.95310879852122, 2.398861393683762],
            [33.9527269031344, 2.397162334321763],
            [33.953631331454, 2.397496792243749],
            [33.95391635072397, 2.396730694524804],
            [33.95498740574905, 2.397136831927651],
            [33.95653380789994, 2.396728857282005],
            [33.956724461844246, 2.397159528645556],
            [33.956058660200085, 2.397830169459394],
            [33.95636817293459, 2.39806928096578],
            [33.95789139405957, 2.398570830612511],
            [33.959105754626954, 2.399742748898037],
            [33.96093788841188, 2.399621785524405],
            [33.96196163725575, 2.400434818698138],
            [33.96203326172998, 2.400769830491419],
            [33.96108176348607, 2.401201318229112],
            [33.960083223165725, 2.40242266100135],
            [33.960345487211214, 2.403164436187102],
            [33.961607364165566, 2.404216637817145],
            [33.961489489030605, 2.405784406751391],
            [33.96284684971313, 2.407267361596899],
            [33.96341648760444, 2.405208619272116],
            [33.96446261617699, 2.404011184562127],
            [33.965105047250766, 2.403938912283454],
            [33.965367398432846, 2.404800361623696],
            [33.96619987079991, 2.404297148458414],
            [33.96857958703928, 2.40460659512028],
            [33.96872178226393, 2.403792737809488],
            [33.96819747605675, 2.402620350001602],
            [33.969101867545476, 2.402882977631107],
            [33.969529712657426, 2.40223645671316],
            [33.970433741226756, 2.401972527546609],
            [33.97076661195528, 2.401613283737242],
            [33.970408862384936, 2.40044077738006],
            [33.97076571543661, 2.400344779681705],
            [33.97243114076939, 2.400032444708911],
            [33.973383377428455, 2.400654051323897],
            [33.97338415716613, 2.40175500402221],
            [33.974193659611345, 2.402424583501413],
            [33.97390907063441, 2.403753129141215],
            [33.97571918311842, 2.406145219231045],
            [33.97609941572369, 2.405450860049799],
            [33.9767421324617, 2.405809402780791],
            [33.97719362662181, 2.404947461337009],
            [33.97824145480688, 2.40614340084888],
            [33.97648217978141, 2.408322658306744],
            [33.97643525179097, 2.409256113903893],
            [33.978885377084, 2.408201245137564],
            [33.97945562942299, 2.407028073991586],
            [33.98093073588304, 2.406763733788859],
            [33.980906682592995, 2.406404746137335],
            [33.97974021211174, 2.405687579219483],
            [33.98021553408476, 2.404873473939316],
            [33.9818097571515, 2.404824458351964],
            [33.983285743062204, 2.40580467013945],
            [33.9858228387495, 2.405742997708714],
            [33.98645338601033, 2.403648322468717],
            [33.98712199668642, 2.402787713382724],
            [33.98790326867555, 2.403497679186627],
            [33.98875829594274, 2.403347468494982],
            [33.98853584163737, 2.404207761299433],
            [33.98957720464733, 2.404693149666681],
            [33.99176968143878, 2.403120894544947],
            [33.99236378943846, 2.402073358307798],
            [33.994890815909685, 2.400463442629696],
            [33.9968609111593, 2.399901044015113],
            [33.99872092954893, 2.401358154696814],
            [33.99976148317683, 2.400721645866601],
            [34.00098137556974, 2.400556210120203],
            [34.00174345056123, 2.39948652183213],
            [34.0027680348383, 2.399485858559206],
            [34.00257496442586, 2.400631526989155],
            [34.00458231730187, 2.401966681959654],
            [34.003246226928674, 2.404678713886989],
            [34.0042333227123, 2.404525321601576],
            [34.00510137465284, 2.406159071605085],
            [34.003765863692976, 2.406068294304496],
            [34.00358300263375, 2.406312813740804],
            [34.00455278159367, 2.406892583062366],
            [34.00370283879095, 2.406862599518615],
            [34.003488645392935, 2.407443144065693],
            [34.00394285426184, 2.407839973670791],
            [34.00485547881012, 2.407197868220635],
            [34.00478996916802, 2.408847502049269],
            [34.00506264738261, 2.40903061257619],
            [34.00646047088046, 2.408571467492151],
            [34.00667226757333, 2.40881570196501],
            [34.00523743079083, 2.411565973454044],
            [34.0060563871061, 2.411809820558683],
            [34.00602355098753, 2.412665191410971],
            [34.00681153878169, 2.413122877543519],
            [34.006505369576686, 2.414008974101778],
            [34.006111599360096, 2.413703757785027],
            [34.005957585899566, 2.414467552812043],
            [34.005293433562244, 2.41318497685885],
            [34.00474644219923, 2.413368641468519],
            [34.00510790271001, 2.414345933762075],
            [34.00410535949673, 2.414590979451781],
            [34.00485897864644, 2.416423363815372],
            [34.003705008222376, 2.416546317286219],
            [34.003764571017285, 2.416943410797668],
            [34.004281289155216, 2.416729229322859],
            [34.00446166816933, 2.417340076077886],
            [34.00339803592347, 2.417707355682928],
            [34.00335105223747, 2.418211431785973],
            [34.0044727156507, 2.418760545002348],
            [34.005021389558244, 2.417996483135521],
            [34.00669199996683, 2.41768989451602],
            [34.0069038074395, 2.417934138120949],
            [34.00647665492864, 2.418667569631113],
            [34.00689989976799, 2.419278244088259],
            [34.00628854770813, 2.420714413881709],
            [34.00710895480261, 2.420469473409267],
            [34.00686376593401, 2.421263894962392],
            [34.0074368569493, 2.422546535977845],
            [34.00795313581108, 2.422485079709849],
            [34.00810306732693, 2.423126496722486],
            [34.00907720311597, 2.42220940692937],
            [34.00946956207925, 2.423003396656378],
            [34.010107010198126, 2.423033514470692],
            [34.01031738665451, 2.423766514210657],
            [34.00961843088814, 2.424011375105859],
            [34.00961719211138, 2.424439052714254],
            [34.010737623036015, 2.425415835321208],
            [34.01116282260943, 2.425354445599297],
            [34.012948057149984, 2.427399959505478],
            [34.01437448120986, 2.42755174805074],
            [34.01534198114391, 2.428925738673008],
            [34.01576743583885, 2.428772727875791],
            [34.016324792861944, 2.430253912842186],
            [34.01778122065231, 2.430527869743961],
            [34.01801832917492, 2.4325133165226],
            [34.0195654993854, 2.432909386679378],
            [34.02093234717564, 2.432664075053958],
            [34.02156794296837, 2.433335694570243],
            [34.02196286841842, 2.433243784642367],
            [34.02305888403195, 2.432173866316985],
            [34.02345761564384, 2.430768386378051],
            [34.026222461205116, 2.430002792963038],
            [34.02759168953083, 2.428932692566539],
            [34.028166034594264, 2.429787638860951],
            [34.03013555582038, 2.431099839254566],
            [34.028857243289636, 2.432230989882947],
            [34.02973533839502, 2.43302463177268],
            [34.02851992410381, 2.433392039949957],
            [34.02854350757495, 2.43574419986709],
            [34.027780570200775, 2.437119373130336],
            [34.02856620261229, 2.438401848303783],
            [34.02771200988, 2.439838180849146],
            [34.02889442186427, 2.440387224242312],
            [34.02810245633003, 2.44130420654422],
            [34.02856679999196, 2.443457505564133],
            [34.029839946311526, 2.444128681713682],
            [34.02956477886528, 2.444800921959812],
            [34.029109474950054, 2.444770687957114],
            [34.02940964071402, 2.445961832834788],
            [34.02959125940322, 2.446144993978199],
            [34.03020108253049, 2.445228151401634],
            [34.03101884049316, 2.445899630917089],
            [34.03080404163063, 2.446694028510196],
            [34.03107560773095, 2.447274237340106],
            [34.0313207597686, 2.446479833808235],
            [34.03195750989649, 2.446754326801378],
            [34.03213288888773, 2.449106383454478],
            [34.03276832388204, 2.449839089881183],
            [34.03167451632747, 2.450145324755891],
            [34.03133617485886, 2.451672944006322],
            [34.031607123816556, 2.452467002513453],
            [34.03114874227314, 2.453505943898636],
            [34.031662648684254, 2.454269283781482],
            [34.03261910023863, 2.454222791937572],
            [34.03307299559548, 2.454741786827463],
            [34.032859243270266, 2.455169600056677],
            [34.03237508007822, 2.454620078970521],
            [34.03228233621165, 2.455200559894516],
            [34.033585232936794, 2.456085535642325],
            [34.03452128644601, 2.457856635062046],
            [34.033451240229034, 2.460453950054068],
            [34.033993236959056, 2.462011506626028],
            [34.03338437952073, 2.462592343328991],
            [34.033807038658544, 2.463416830857126],
            [34.0344443277756, 2.463508035087165],
            [34.034443189610144, 2.463905151525474],
            [34.033497569941474, 2.465463748733084],
            [34.03395129012689, 2.466043839916333],
            [34.035075471517814, 2.465737564712507],
            [34.03577136762234, 2.466561873488425],
            [34.03718110367917, 2.466619994486373],
            [34.03733265036594, 2.467339735241171],
            [34.03605746037908, 2.467371191104152],
            [34.03514816768219, 2.466852519737005],
            [34.03563032313959, 2.468104631514519],
            [34.0364200222244, 2.467981891875893],
            [34.03641862354749, 2.468470655122139],
            [34.0372672862509, 2.468958805208879],
            [34.03614293867162, 2.469326180187841],
            [34.035142553211664, 2.468807570612249],
            [34.035594973534856, 2.469845883590073],
            [34.03507560626511, 2.470976502477119],
            [34.03622805314647, 2.471403363650905],
            [34.036776800715884, 2.470608740243121],
            [34.03735231448751, 2.471066545747049],
            [34.036741626282634, 2.472288893145036],
            [34.036013433048694, 2.472136666315635],
            [34.035798196706615, 2.473083791072864],
            [34.036678528617074, 2.473113721983702],
            [34.03682928658299, 2.473480188462303],
            [34.0360990793262, 2.474030566034941],
            [34.03752291713637, 2.4750987268147],
            [34.037308211698644, 2.475862567671765],
            [34.03627694575246, 2.475527278406032],
            [34.03572985467643, 2.475741494467534],
            [34.035848844620666, 2.476596747397363],
            [34.03672971641858, 2.476443384857514],
            [34.03700172089674, 2.476870861735106],
            [34.03633214363341, 2.477451741302047],
            [34.037059367585144, 2.477939994883397],
            [34.03572162700675, 2.4786129728537],
            [34.03541609830051, 2.479285249554306],
            [34.03551750731632, 2.480980579395097],
            [34.03603449674547, 2.480674740222315],
            [34.03600098419549, 2.481774475911809],
            [34.03675822714906, 2.482384899011522],
            [34.035785054354015, 2.482965981678365],
            [34.03672096143784, 2.484798187234374],
            [34.03556133881396, 2.486876260943369],
            [34.034801020927155, 2.487335009444669],
            [34.035012491531575, 2.487701436981785],
            [34.035802904777036, 2.487334301341702],
            [34.03546195010926, 2.489778360948536],
            [34.0361352086686, 2.493214497454097],
            [34.03595059948782, 2.494069972405969],
            [34.03673926551006, 2.494313791904765],
            [34.03682877184832, 2.494863580136151],
            [34.03585480404424, 2.49571961582733],
            [34.03685606087005, 2.495932737296456],
            [34.036319051586446, 2.496972542081072],
            [34.036772584023936, 2.497833743983426],
            [34.03678562037535, 2.499281687359778],
            [34.03581135343227, 2.501143739456285],
            [34.03626516165257, 2.503183253185349],
            [34.035481630400504, 2.505727915999811],
            [34.03608498116612, 2.506106609325303],
            [34.035181706283325, 2.507473130023269],
            [34.03462359377708, 2.509307906724603],
            [34.03234037815878, 2.510553766007485],
            [34.03212004208084, 2.512532590158884],
            [34.031311736191554, 2.514184183826997],
            [34.03127144315781, 2.517276432218198],
            [34.03250229859042, 2.517404844518087],
            [34.03335070886726, 2.519053495568152],
            [34.032972413029775, 2.522165149523482],
            [34.031473149075076, 2.522070616247075],
            [34.03091372952009, 2.52511263935681],
            [34.03006016021859, 2.525745535768713],
            [34.02934905473801, 2.52708880470563],
            [34.028372040746774, 2.527589767313441],
            [34.02692209879278, 2.529721002915086],
            [34.02641913296352, 2.52979877684421],
            [34.0258933005187, 2.529059391249745],
            [34.025284281383634, 2.529276690245817],
            [34.02375572067257, 2.527928503801117],
            [34.02261458627559, 2.529341492602405],
            [34.02263916418174, 2.530346686154143],
            [34.021830222285246, 2.530538800993859],
            [34.021320281037816, 2.532705192463337],
            [34.0209635555469, 2.532992679442839],
            [34.02020158026842, 2.532394940110737],
            [34.01917863541672, 2.532802620996742],
            [34.01842701142523, 2.532544531348162],
            [34.01832231816877, 2.53328197469486],
            [34.018895288809816, 2.533999958497982],
            [34.01802739497277, 2.536211485175854],
            [34.01663516708083, 2.534998207664021],
            [34.017474397473755, 2.53423033860071],
            [34.01748923764224, 2.533043291331336],
            [34.01639485786085, 2.533403165529691],
            [34.015804409597656, 2.534268838635293],
            [34.01491970917998, 2.533739394854097],
            [34.014443913794786, 2.533931242651939],
            [34.01416073786779, 2.536994974711034],
            [34.01438684562141, 2.537433847176553],
            [34.01511532721455, 2.537312419796535],
            [34.01504211990879, 2.53811916118026],
            [34.01580750429379, 2.538643316387177],
            [34.0157094747401, 2.539458915502239],
            [34.01511499393959, 2.540033793959692],
            [34.01394911814305, 2.540274049232329],
            [34.01356275543429, 2.539586549327244],
            [34.0128302691516, 2.539772328714057],
            [34.01308889412193, 2.541043462776117],
            [34.01249718462403, 2.542046423401485],
            [34.01189182432711, 2.541747589516412],
            [34.01201246178159, 2.543853658498984],
            [34.011204468505994, 2.545290320233666],
            [33.98641845232557, 2.570755637917254],
            [33.98031573127325, 2.587662840882524],
            [33.96576081381488, 2.61670450789719],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 802,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "NYAKWAE",
        Population: 14913,
        Key: "ABIMNYAKWAE",
        Dist2: "Abim",
        "Sub Country": "Nyakwae",
        id2_original: "AbimNyakwae",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.793275835998585, 2.616961421085931],
            [33.79042053188486, 2.622808088142625],
            [33.789362090104724, 2.62389074815564],
            [33.78753150321874, 2.624497302473329],
            [33.78526446086881, 2.625902296196154],
            [33.782475770426686, 2.630114737300139],
            [33.781330630441815, 2.636885584193654],
            [33.78042138176239, 2.637801127667523],
            [33.77045285969952, 2.643707951112885],
            [33.764299701837224, 2.644868722363325],
            [33.76073078594328, 2.646439996725992],
            [33.755859267073255, 2.646949689233336],
            [33.73969708840015, 2.6443067264469],
            [33.7335449375493, 2.642763887613852],
            [33.72950546254995, 2.63812675031083],
            [33.719899005564045, 2.636355070494234],
            [33.714702169898715, 2.634849054160699],
            [33.70701278869601, 2.634273531305261],
            [33.702800670973794, 2.635991291438358],
            [33.69444562646745, 2.633617972968627],
            [33.69589776929389, 2.618037310056573],
            [33.70104129982859, 2.611793029375024],
            [33.70146295644655, 2.610305870684856],
            [33.70464755419732, 2.605156157624505],
            [33.705512325490425, 2.60248685335063],
            [33.70812725480716, 2.60111763209019],
            [33.70906813855763, 2.599749354295663],
            [33.70885694553266, 2.596277501910029],
            [33.70749328766, 2.594573510854427],
            [33.7073046630099, 2.59305323680238],
            [33.7058745208231, 2.592572212101419],
            [33.705898538180534, 2.591948090214576],
            [33.705551425561495, 2.592113872494604],
            [33.70312433037738, 2.5902709084604],
            [33.69943731027808, 2.589578756396209],
            [33.69292413459937, 2.587063819539106],
            [33.68663794792161, 2.58322076048835],
            [33.68057845469904, 2.57745428440388],
            [33.674563613135994, 2.569901862140867],
            [33.673826028914114, 2.568368447371593],
            [33.673286618433764, 2.568368293016571],
            [33.67267512893165, 2.567621704501704],
            [33.67204433822736, 2.567604233657189],
            [33.66781181707007, 2.564848666217561],
            [33.66748427784274, 2.56422237065145],
            [33.666910257071166, 2.564206265627372],
            [33.66630318189035, 2.563291480003739],
            [33.66438101984598, 2.56217155941766],
            [33.66354787643742, 2.561138415479855],
            [33.66268714127491, 2.561114277628644],
            [33.66168141083899, 2.560076136010717],
            [33.66082066848993, 2.560051988267888],
            [33.65827655246873, 2.558578133315236],
            [33.657359032102164, 2.558552317240835],
            [33.657373925271244, 2.557991706164139],
            [33.65558810952073, 2.55794173062886],
            [33.65561497633425, 2.557212913039937],
            [33.65498363586098, 2.557195432181754],
            [33.65319189033126, 2.555795837389423],
            [33.65139146977082, 2.548669062523581],
            [33.650350180422734, 2.540787097841927],
            [33.651496835865444, 2.528962780003164],
            [33.652662702678846, 2.522823853390488],
            [33.65495041526345, 2.520730791009455],
            [33.655086633098215, 2.519975117881812],
            [33.65434465880951, 2.517094750052803],
            [33.65319377230177, 2.515360558797183],
            [33.64844729173279, 2.510014056475778],
            [33.64801482389041, 2.507556676814627],
            [33.64671942270798, 2.504232338216426],
            [33.64593954310755, 2.495950822972046],
            [33.64470255218153, 2.493950485793554],
            [33.64382710441129, 2.491495207524607],
            [33.640991781524434, 2.488313270853575],
            [33.6396640311103, 2.485615668766267],
            [33.63887992403816, 2.480833676478855],
            [33.6401184456934, 2.482086694064665],
            [33.65251146501257, 2.489717218297431],
            [33.66954029694927, 2.50538990876025],
            [33.67142438749359, 2.503838042047668],
            [33.672566591784076, 2.503550250678324],
            [33.67781889033337, 2.498665085889852],
            [33.68392832090255, 2.494583628839645],
            [33.68781057186258, 2.491307490810697],
            [33.69055008223788, 2.487285223252519],
            [33.6934618275009, 2.48498607359943],
            [33.696316113823414, 2.482055107519879],
            [33.6987409874738, 2.475178606773321],
            [33.70444635852314, 2.463566793432828],
            [33.705358579727864, 2.460848778811124],
            [33.71035872746508, 2.465872573157307],
            [33.7548382688708, 2.490406704553699],
            [33.76600008690594, 2.497072995038762],
            [33.77278828001224, 2.502073567303275],
            [33.77806634404048, 2.50313200114665],
            [33.785907285404676, 2.503430600693864],
            [33.795670343897456, 2.504992914287127],
            [33.801688849688524, 2.506847309255811],
            [33.8012677410429, 2.508758746484927],
            [33.80111674861667, 2.520809871260715],
            [33.80149733605649, 2.538859632879881],
            [33.80313660424482, 2.54358345844143],
            [33.80498594166572, 2.546555235963314],
            [33.80736288211089, 2.549101971209022],
            [33.81010896456078, 2.551064494021226],
            [33.81343737001214, 2.55568104189225],
            [33.81708204712222, 2.559554137056607],
            [33.82009409108337, 2.564648646676195],
            [33.8188979043325, 2.567379007994371],
            [33.81535684609382, 2.570249172131979],
            [33.81008928426954, 2.575901420228691],
            [33.808620931343775, 2.576945228671923],
            [33.80663344291365, 2.576946496707811],
            [33.805769591495405, 2.577381576527412],
            [33.805079383523264, 2.579120132711768],
            [33.80325538667822, 2.58015200482857],
            [33.803691981381, 2.580173508437276],
            [33.80318678862816, 2.580721462657502],
            [33.80274573738321, 2.582367474078404],
            [33.80565669212879, 2.585377315402102],
            [33.80715822432959, 2.587814803776121],
            [33.80815552227992, 2.588403482243984],
            [33.8145339210216, 2.588929723049743],
            [33.820291683614926, 2.59182149182721],
            [33.821491089029465, 2.594230056438546],
            [33.82363150485693, 2.59637985677685],
            [33.824061151989326, 2.5992191596001],
            [33.82389103622736, 2.600768135532503],
            [33.822267381656985, 2.603866931515983],
            [33.819702150735004, 2.606364008350716],
            [33.81970252443416, 2.606940961009537],
            [33.81657257569368, 2.608940181955654],
            [33.81247574416175, 2.61104470399309],
            [33.80525276555962, 2.613499077268702],
            [33.798171858214616, 2.614993080979817],
            [33.793275835998585, 2.616961421085931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 803,
        District: "ABIM",
        County: "LABWOR",
        Subcounty: "MORULEM",
        Population: 22879,
        Key: "ABIMMORULEM",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.42125723981063, 2.484514424035708],
            [34.4206235035305, 2.484619556458705],
            [34.42000380342671, 2.483591230456508],
            [34.4184819522325, 2.484406506752119],
            [34.41731578268688, 2.48409667372822],
            [34.418099689434726, 2.482923248553335],
            [34.418074618353465, 2.48172677523662],
            [34.41683616047858, 2.480555532408195],
            [34.41562221133961, 2.480054311294396],
            [34.41481359103998, 2.480366275868378],
            [34.41476669988045, 2.481012436105022],
            [34.41598093019212, 2.481776896395678],
            [34.41681365857902, 2.481775998922993],
            [34.417171504269085, 2.482661019795204],
            [34.41648232935951, 2.483427531649887],
            [34.41491240122964, 2.483788163504414],
            [34.41446121609, 2.48460228194114],
            [34.41339101266783, 2.485034178018639],
            [34.41265191119141, 2.483599162309353],
            [34.411389785403735, 2.482547597265847],
            [34.412244894417626, 2.481206592755424],
            [34.41174411239284, 2.480130277070753],
            [34.40763788987292, 2.478232223580843],
            [34.40747177071563, 2.47863921322312],
            [34.4082581109996, 2.479763091760138],
            [34.407071340389535, 2.482468478808443],
            [34.40635797564599, 2.482852123901298],
            [34.4036208143652, 2.481897845196623],
            [34.40305277278009, 2.48472221275164],
            [34.40178529752494, 2.485833111393096],
            [34.401260433463996, 2.485607532302366],
            [34.40100899321932, 2.484075068905573],
            [34.39963345692369, 2.482644310659468],
            [34.39262836738863, 2.472575696930772],
            [34.39192007722816, 2.470997037717285],
            [34.391813934989116, 2.469602011114029],
            [34.388021136468495, 2.471632906637282],
            [34.38307669416032, 2.473612364576391],
            [34.381531979943844, 2.473061185381789],
            [34.37679520477318, 2.473408348910157],
            [34.37590503181881, 2.473093401273623],
            [34.37444213705671, 2.475753596942068],
            [34.372376120599384, 2.477282527644526],
            [34.37206333440399, 2.478520064458916],
            [34.368803558443695, 2.477220444757873],
            [34.36746950544955, 2.477932562890361],
            [34.36647459971279, 2.477591396581233],
            [34.36445712462019, 2.478468460547854],
            [34.3628640738549, 2.481206658270965],
            [34.36318031227594, 2.483442929569722],
            [34.3620285786569, 2.482838927473308],
            [34.35998845074776, 2.483314677285879],
            [34.359073821159754, 2.484315509480195],
            [34.358511244924856, 2.484223993463751],
            [34.35835504047337, 2.484960924680158],
            [34.357439959032796, 2.485540757832687],
            [34.35744076661822, 2.486330143618861],
            [34.3566827520118, 2.486988750630414],
            [34.35606732878706, 2.489222112416329],
            [34.35533462151885, 2.489354488886879],
            [34.354393993788214, 2.490882240732481],
            [34.35580835347381, 2.491907401969759],
            [34.35633291031095, 2.492986136587586],
            [34.35755274521167, 2.501216550343892],
            [34.3566512894173, 2.500860467102573],
            [34.35468740511957, 2.502922244520146],
            [34.352094113523094, 2.503666443644492],
            [34.350266059886216, 2.505041495421479],
            [34.34913600980149, 2.508104807281014],
            [34.347907755889935, 2.508600418487575],
            [34.348647492475266, 2.511016412847006],
            [34.34802199644124, 2.513488747408559],
            [34.34540298787479, 2.515798367917319],
            [34.34177334766426, 2.517806944391068],
            [34.33988958680168, 2.518165919080648],
            [34.336956105003715, 2.520050188387895],
            [34.33583871128307, 2.52216601555795],
            [34.334446657664266, 2.522716724525907],
            [34.33300074016273, 2.524008988582453],
            [34.33259343682637, 2.526261400923128],
            [34.33172139995928, 2.527992491348563],
            [34.328242809667124, 2.530920935965181],
            [34.32605837189916, 2.531005569845701],
            [34.324418643773384, 2.529689019056208],
            [34.322097198551546, 2.529306905260388],
            [34.320648152217885, 2.527523269602624],
            [34.31917285980654, 2.526783264374117],
            [34.31350747366881, 2.527516833153172],
            [34.311458591677216, 2.526640074823193],
            [34.310393751197296, 2.526751021979567],
            [34.30700544518448, 2.524474972724577],
            [34.297049810352675, 2.522109393952944],
            [34.2944264449571, 2.520162093682015],
            [34.29030432584992, 2.521374629416323],
            [34.28707009438305, 2.523011943407361],
            [34.2863873675806, 2.522957691092692],
            [34.284173440816794, 2.520845175888268],
            [34.28218063975006, 2.52145135921855],
            [34.280759417834005, 2.520161968936955],
            [34.27983116259979, 2.520327667155509],
            [34.27813719060389, 2.51936810193067],
            [34.27611629472668, 2.519177853924222],
            [34.272648889358145, 2.519758005794175],
            [34.27161263147393, 2.521208705174759],
            [34.2709054624109, 2.524093118550271],
            [34.27033276036612, 2.52486269068056],
            [34.26898169507715, 2.525509407832685],
            [34.25073539619878, 2.548569694950698],
            [34.239506204517326, 2.565606441730683],
            [34.23120449837931, 2.577230277364032],
            [34.206567158768266, 2.609596028717574],
            [34.207422810364605, 2.613024075517973],
            [34.20963071122949, 2.616347786387339],
            [34.21514741630622, 2.621442044206988],
            [34.22110834637583, 2.62986165409325],
            [34.228175007338734, 2.641605923133796],
            [34.2356799230911, 2.650467273689901],
            [34.238772322252714, 2.656228902955922],
            [34.2403229734349, 2.663544116139802],
            [34.23790726888862, 2.673080552551056],
            [34.236146767662774, 2.676408149481538],
            [34.2352713001296, 2.682838944098082],
            [34.23718933261861, 2.685543270534196],
            [34.23851128979744, 2.68610142500404],
            [34.23976440817775, 2.687359028146704],
            [34.24171186857714, 2.687496913255114],
            [34.24303482108931, 2.689034190009241],
            [34.247626918990214, 2.690987729332805],
            [34.24700170682384, 2.691687749169176],
            [34.2482562634069, 2.69434408694227],
            [34.250204587087275, 2.695321202245448],
            [34.25083230016344, 2.697068993029167],
            [34.25055589843198, 2.698817718102271],
            [34.250974544795405, 2.700146098427266],
            [34.24993204721325, 2.700846553577729],
            [34.24993433881554, 2.703084553575723],
            [34.2508394624312, 2.70406274132155],
            [34.25153702131731, 2.706090205908522],
            [34.25126077050281, 2.707978806264123],
            [34.251957759857035, 2.709446769451599],
            [34.25112418974868, 2.710426761937187],
            [34.25154198091599, 2.710915890183678],
            [34.251264868617135, 2.711965241686964],
            [34.252448628074355, 2.713362759556521],
            [34.253287897993154, 2.717907819570529],
            [34.256074545666344, 2.722450837259678],
            [34.25628420706378, 2.723429741534088],
            [34.255380653703256, 2.723990187321792],
            [34.255034504078196, 2.725529173804619],
            [34.2550368262232, 2.727767168473712],
            [34.25586911443562, 2.728855918172685],
            [34.25092021648364, 2.729464123611161],
            [34.23581403078322, 2.733639532401671],
            [34.226918756533, 2.736969939477217],
            [34.21466223532296, 2.739472770033244],
            [34.20334321660468, 2.742885824275846],
            [34.19107822787476, 2.745923735102568],
            [34.17138454454601, 2.752186941098673],
            [34.15676534274762, 2.757361281959785],
            [34.148604438547224, 2.759617660525371],
            [34.14098292596257, 2.75889508593625],
            [34.12513599576705, 2.758755579550212],
            [34.11774821673448, 2.758143710187069],
            [34.10307545917551, 2.755358485698503],
            [34.09439553086183, 2.75187053890201],
            [34.0841784844857, 2.745373002794544],
            [34.070808803314925, 2.741181457693466],
            [34.06215354992548, 2.736018914304865],
            [34.052183244706775, 2.727809739852184],
            [34.047652607740986, 2.725680748250575],
            [34.040265580598316, 2.718793784776919],
            [34.031138361341746, 2.711857716225206],
            [34.02602852751167, 2.705741619289476],
            [34.019642065492, 2.699035375348041],
            [34.00016545017021, 2.681915207323331],
            [33.98650713670536, 2.668957447921821],
            [33.982865805819735, 2.662637591183951],
            [33.982610072526334, 2.65608147729793],
            [33.98659252067481, 2.65098655186912],
            [33.98672389928511, 2.644158034990319],
            [33.96576081381488, 2.61670450789719],
            [33.98031573127325, 2.587662840882524],
            [33.98641845232557, 2.570755637917254],
            [34.011204468505994, 2.545290320233666],
            [34.01201246178159, 2.543853658498984],
            [34.01189182432711, 2.541747589516412],
            [34.01249718462403, 2.542046423401485],
            [34.01308889412193, 2.541043462776117],
            [34.0128302691516, 2.539772328714057],
            [34.01356275543429, 2.539586549327244],
            [34.01394911814305, 2.540274049232329],
            [34.01511499393959, 2.540033793959692],
            [34.0157094747401, 2.539458915502239],
            [34.01580750429379, 2.538643316387177],
            [34.01504211990879, 2.53811916118026],
            [34.01511532721455, 2.537312419796535],
            [34.01438684562141, 2.537433847176553],
            [34.01416073786779, 2.536994974711034],
            [34.014443913794786, 2.533931242651939],
            [34.01491970917998, 2.533739394854097],
            [34.015804409597656, 2.534268838635293],
            [34.01639485786085, 2.533403165529691],
            [34.01748923764224, 2.533043291331336],
            [34.017474397473755, 2.53423033860071],
            [34.01663516708083, 2.534998207664021],
            [34.01802739497277, 2.536211485175854],
            [34.018895288809816, 2.533999958497982],
            [34.01832231816877, 2.53328197469486],
            [34.01842701142523, 2.532544531348162],
            [34.01917863541672, 2.532802620996742],
            [34.02020158026842, 2.532394940110737],
            [34.0209635555469, 2.532992679442839],
            [34.021320281037816, 2.532705192463337],
            [34.021830222285246, 2.530538800993859],
            [34.02263916418174, 2.530346686154143],
            [34.02261458627559, 2.529341492602405],
            [34.02375572067257, 2.527928503801117],
            [34.025284281383634, 2.529276690245817],
            [34.0258933005187, 2.529059391249745],
            [34.02641913296352, 2.52979877684421],
            [34.02692209879278, 2.529721002915086],
            [34.028372040746774, 2.527589767313441],
            [34.02934905473801, 2.52708880470563],
            [34.03006016021859, 2.525745535768713],
            [34.03091372952009, 2.52511263935681],
            [34.031473149075076, 2.522070616247075],
            [34.032972413029775, 2.522165149523482],
            [34.03335070886726, 2.519053495568152],
            [34.03250229859042, 2.517404844518087],
            [34.03127144315781, 2.517276432218198],
            [34.031311736191554, 2.514184183826997],
            [34.03212004208084, 2.512532590158884],
            [34.03234037815878, 2.510553766007485],
            [34.03462359377708, 2.509307906724603],
            [34.035181706283325, 2.507473130023269],
            [34.03608498116612, 2.506106609325303],
            [34.035481630400504, 2.505727915999811],
            [34.03626516165257, 2.503183253185349],
            [34.03581135343227, 2.501143739456285],
            [34.03678562037535, 2.499281687359778],
            [34.036772584023936, 2.497833743983426],
            [34.036319051586446, 2.496972542081072],
            [34.03685606087005, 2.495932737296456],
            [34.03585480404424, 2.49571961582733],
            [34.03682877184832, 2.494863580136151],
            [34.03673926551006, 2.494313791904765],
            [34.03595059948782, 2.494069972405969],
            [34.0361352086686, 2.493214497454097],
            [34.03546195010926, 2.489778360948536],
            [34.035802904777036, 2.487334301341702],
            [34.035012491531575, 2.487701436981785],
            [34.034801020927155, 2.487335009444669],
            [34.03556133881396, 2.486876260943369],
            [34.03672096143784, 2.484798187234374],
            [34.035785054354015, 2.482965981678365],
            [34.03675822714906, 2.482384899011522],
            [34.03600098419549, 2.481774475911809],
            [34.03603449674547, 2.480674740222315],
            [34.03551750731632, 2.480980579395097],
            [34.03541609830051, 2.479285249554306],
            [34.03572162700675, 2.4786129728537],
            [34.037059367585144, 2.477939994883397],
            [34.03633214363341, 2.477451741302047],
            [34.03700172089674, 2.476870861735106],
            [34.03672971641858, 2.476443384857514],
            [34.035848844620666, 2.476596747397363],
            [34.03572985467643, 2.475741494467534],
            [34.03627694575246, 2.475527278406032],
            [34.037308211698644, 2.475862567671765],
            [34.03752291713637, 2.4750987268147],
            [34.0360990793262, 2.474030566034941],
            [34.03682928658299, 2.473480188462303],
            [34.036678528617074, 2.473113721983702],
            [34.035798196706615, 2.473083791072864],
            [34.036013433048694, 2.472136666315635],
            [34.036741626282634, 2.472288893145036],
            [34.03735231448751, 2.471066545747049],
            [34.036776800715884, 2.470608740243121],
            [34.03622805314647, 2.471403363650905],
            [34.03507560626511, 2.470976502477119],
            [34.035594973534856, 2.469845883590073],
            [34.035142553211664, 2.468807570612249],
            [34.03614293867162, 2.469326180187841],
            [34.0372672862509, 2.468958805208879],
            [34.03641862354749, 2.468470655122139],
            [34.0364200222244, 2.467981891875893],
            [34.03563032313959, 2.468104631514519],
            [34.03514816768219, 2.466852519737005],
            [34.03605746037908, 2.467371191104152],
            [34.03733265036594, 2.467339735241171],
            [34.03718110367917, 2.466619994486373],
            [34.03577136762234, 2.466561873488425],
            [34.035075471517814, 2.465737564712507],
            [34.03395129012689, 2.466043839916333],
            [34.033497569941474, 2.465463748733084],
            [34.034443189610144, 2.463905151525474],
            [34.0344443277756, 2.463508035087165],
            [34.033807038658544, 2.463416830857126],
            [34.03338437952073, 2.462592343328991],
            [34.033993236959056, 2.462011506626028],
            [34.033451240229034, 2.460453950054068],
            [34.03452128644601, 2.457856635062046],
            [34.033585232936794, 2.456085535642325],
            [34.03228233621165, 2.455200559894516],
            [34.03237508007822, 2.454620078970521],
            [34.032859243270266, 2.455169600056677],
            [34.03307299559548, 2.454741786827463],
            [34.03261910023863, 2.454222791937572],
            [34.031662648684254, 2.454269283781482],
            [34.03114874227314, 2.453505943898636],
            [34.031607123816556, 2.452467002513453],
            [34.03133617485886, 2.451672944006322],
            [34.03167451632747, 2.450145324755891],
            [34.03276832388204, 2.449839089881183],
            [34.03213288888773, 2.449106383454478],
            [34.03195750989649, 2.446754326801378],
            [34.0313207597686, 2.446479833808235],
            [34.03107560773095, 2.447274237340106],
            [34.03080404163063, 2.446694028510196],
            [34.03101884049316, 2.445899630917089],
            [34.03020108253049, 2.445228151401634],
            [34.02959125940322, 2.446144993978199],
            [34.02940964071402, 2.445961832834788],
            [34.029109474950054, 2.444770687957114],
            [34.02956477886528, 2.444800921959812],
            [34.029839946311526, 2.444128681713682],
            [34.02856679999196, 2.443457505564133],
            [34.02810245633003, 2.44130420654422],
            [34.02889442186427, 2.440387224242312],
            [34.02771200988, 2.439838180849146],
            [34.02856620261229, 2.438401848303783],
            [34.027780570200775, 2.437119373130336],
            [34.02854350757495, 2.43574419986709],
            [34.02851992410381, 2.433392039949957],
            [34.02973533839502, 2.43302463177268],
            [34.028857243289636, 2.432230989882947],
            [34.03013555582038, 2.431099839254566],
            [34.028166034594264, 2.429787638860951],
            [34.02759168953083, 2.428932692566539],
            [34.026222461205116, 2.430002792963038],
            [34.02345761564384, 2.430768386378051],
            [34.02305888403195, 2.432173866316985],
            [34.02196286841842, 2.433243784642367],
            [34.02156794296837, 2.433335694570243],
            [34.02093234717564, 2.432664075053958],
            [34.0195654993854, 2.432909386679378],
            [34.01801832917492, 2.4325133165226],
            [34.01778122065231, 2.430527869743961],
            [34.016324792861944, 2.430253912842186],
            [34.01576743583885, 2.428772727875791],
            [34.01534198114391, 2.428925738673008],
            [34.01437448120986, 2.42755174805074],
            [34.012948057149984, 2.427399959505478],
            [34.01116282260943, 2.425354445599297],
            [34.010737623036015, 2.425415835321208],
            [34.00961719211138, 2.424439052714254],
            [34.00961843088814, 2.424011375105859],
            [34.01031738665451, 2.423766514210657],
            [34.010107010198126, 2.423033514470692],
            [34.00946956207925, 2.423003396656378],
            [34.00907720311597, 2.42220940692937],
            [34.00810306732693, 2.423126496722486],
            [34.00795313581108, 2.422485079709849],
            [34.0074368569493, 2.422546535977845],
            [34.00686376593401, 2.421263894962392],
            [34.00710895480261, 2.420469473409267],
            [34.00628854770813, 2.420714413881709],
            [34.00689989976799, 2.419278244088259],
            [34.00647665492864, 2.418667569631113],
            [34.0069038074395, 2.417934138120949],
            [34.00669199996683, 2.41768989451602],
            [34.005021389558244, 2.417996483135521],
            [34.0044727156507, 2.418760545002348],
            [34.00335105223747, 2.418211431785973],
            [34.00339803592347, 2.417707355682928],
            [34.00446166816933, 2.417340076077886],
            [34.004281289155216, 2.416729229322859],
            [34.003764571017285, 2.416943410797668],
            [34.003705008222376, 2.416546317286219],
            [34.00485897864644, 2.416423363815372],
            [34.00410535949673, 2.414590979451781],
            [34.00510790271001, 2.414345933762075],
            [34.00474644219923, 2.413368641468519],
            [34.005293433562244, 2.41318497685885],
            [34.005957585899566, 2.414467552812043],
            [34.006111599360096, 2.413703757785027],
            [34.006505369576686, 2.414008974101778],
            [34.00681153878169, 2.413122877543519],
            [34.00602355098753, 2.412665191410971],
            [34.0060563871061, 2.411809820558683],
            [34.00523743079083, 2.411565973454044],
            [34.00667226757333, 2.40881570196501],
            [34.00646047088046, 2.408571467492151],
            [34.00506264738261, 2.40903061257619],
            [34.00478996916802, 2.408847502049269],
            [34.00485547881012, 2.407197868220635],
            [34.00394285426184, 2.407839973670791],
            [34.003488645392935, 2.407443144065693],
            [34.00370283879095, 2.406862599518615],
            [34.00455278159367, 2.406892583062366],
            [34.00358300263375, 2.406312813740804],
            [34.003765863692976, 2.406068294304496],
            [34.00510137465284, 2.406159071605085],
            [34.0042333227123, 2.404525321601576],
            [34.003246226928674, 2.404678713886989],
            [34.00458231730187, 2.401966681959654],
            [34.00257496442586, 2.400631526989155],
            [34.0027680348383, 2.399485858559206],
            [34.00174345056123, 2.39948652183213],
            [34.00098137556974, 2.400556210120203],
            [33.99976148317683, 2.400721645866601],
            [33.99872092954893, 2.401358154696814],
            [33.9968609111593, 2.399901044015113],
            [33.994890815909685, 2.400463442629696],
            [33.99236378943846, 2.402073358307798],
            [33.99176968143878, 2.403120894544947],
            [33.98957720464733, 2.404693149666681],
            [33.98853584163737, 2.404207761299433],
            [33.98875829594274, 2.403347468494982],
            [33.98790326867555, 2.403497679186627],
            [33.98712199668642, 2.402787713382724],
            [33.98645338601033, 2.403648322468717],
            [33.9858228387495, 2.405742997708714],
            [33.983285743062204, 2.40580467013945],
            [33.9818097571515, 2.404824458351964],
            [33.98021553408476, 2.404873473939316],
            [33.97974021211174, 2.405687579219483],
            [33.980906682592995, 2.406404746137335],
            [33.98093073588304, 2.406763733788859],
            [33.97945562942299, 2.407028073991586],
            [33.978885377084, 2.408201245137564],
            [33.97643525179097, 2.409256113903893],
            [33.97648217978141, 2.408322658306744],
            [33.97824145480688, 2.40614340084888],
            [33.97719362662181, 2.404947461337009],
            [33.9767421324617, 2.405809402780791],
            [33.97609941572369, 2.405450860049799],
            [33.97571918311842, 2.406145219231045],
            [33.97390907063441, 2.403753129141215],
            [33.974193659611345, 2.402424583501413],
            [33.97338415716613, 2.40175500402221],
            [33.973383377428455, 2.400654051323897],
            [33.97243114076939, 2.400032444708911],
            [33.97076571543661, 2.400344779681705],
            [33.970408862384936, 2.40044077738006],
            [33.97076661195528, 2.401613283737242],
            [33.970433741226756, 2.401972527546609],
            [33.969529712657426, 2.40223645671316],
            [33.969101867545476, 2.402882977631107],
            [33.96819747605675, 2.402620350001602],
            [33.96872178226393, 2.403792737809488],
            [33.96857958703928, 2.40460659512028],
            [33.96619987079991, 2.404297148458414],
            [33.965367398432846, 2.404800361623696],
            [33.965105047250766, 2.403938912283454],
            [33.96446261617699, 2.404011184562127],
            [33.96341648760444, 2.405208619272116],
            [33.96284684971313, 2.407267361596899],
            [33.961489489030605, 2.405784406751391],
            [33.961607364165566, 2.404216637817145],
            [33.960345487211214, 2.403164436187102],
            [33.960083223165725, 2.40242266100135],
            [33.96108176348607, 2.401201318229112],
            [33.96203326172998, 2.400769830491419],
            [33.96196163725575, 2.400434818698138],
            [33.96093788841188, 2.399621785524405],
            [33.959105754626954, 2.399742748898037],
            [33.95789139405957, 2.398570830612511],
            [33.95636817293459, 2.39806928096578],
            [33.956058660200085, 2.397830169459394],
            [33.956724461844246, 2.397159528645556],
            [33.95653380789994, 2.396728857282005],
            [33.95498740574905, 2.397136831927651],
            [33.95391635072397, 2.396730694524804],
            [33.953631331454, 2.397496792243749],
            [33.9527269031344, 2.397162334321763],
            [33.95310879852122, 2.398861393683762],
            [33.951752714344735, 2.399197435327003],
            [33.95192019355135, 2.400513681702861],
            [33.950278184603086, 2.400299428535016],
            [33.949969227027424, 2.400850139392374],
            [33.94920789494267, 2.401018203061145],
            [33.94827917078787, 2.3999777197765],
            [33.94875469578013, 2.399426892786608],
            [33.94846846108958, 2.398421855275839],
            [33.94787381320242, 2.398757362100318],
            [33.94761189321168, 2.398518195964952],
            [33.947919987506324, 2.396698991989052],
            [33.946233062793844, 2.39693826883846],
            [33.94613764913428, 2.397671575225564],
            [33.945696505362854, 2.397787656215254],
            [33.94525469953307, 2.396938949165697],
            [33.94408426119321, 2.396592438183192],
            [33.944045509668484, 2.396032887634735],
            [33.942773964146745, 2.394373820539172],
            [33.93581303129952, 2.392191071879429],
            [33.93098679829959, 2.389616366655256],
            [33.92269378785352, 2.388257168147511],
            [33.90781749900061, 2.380361928596466],
            [33.90515665229814, 2.379752168405223],
            [33.903724778159436, 2.379945801994091],
            [33.900362039097914, 2.378780429634232],
            [33.89925657769917, 2.377611674351711],
            [33.89816997463316, 2.377526667254469],
            [33.89610242026007, 2.376006508516168],
            [33.89514161726649, 2.372771241934027],
            [33.8919524722437, 2.370159235176536],
            [33.891539982034935, 2.367432688222712],
            [33.88940343165811, 2.366359868674039],
            [33.8880844613776, 2.3645253486166],
            [33.88725216058875, 2.364215169514866],
            [33.88496318766782, 2.359710939013497],
            [33.883935994683114, 2.35917449629133],
            [33.882128966115474, 2.359547490016677],
            [33.879103391729544, 2.357247594861822],
            [33.87787967071691, 2.356852056621472],
            [33.87551700989151, 2.356955861590367],
            [33.87346240293662, 2.356333385297987],
            [33.87211483389068, 2.356855703388997],
            [33.871700706951465, 2.357836324482325],
            [33.87118651397777, 2.358100970269861],
            [33.868590298365035, 2.357922509481698],
            [33.866952196189914, 2.358214766722358],
            [33.865873685148024, 2.357902561328503],
            [33.86510579266673, 2.357475118785316],
            [33.86495954154858, 2.355219416783068],
            [33.86380151702761, 2.354841295054136],
            [33.86426114273768, 2.353704473534646],
            [33.862880102464295, 2.353607116376387],
            [33.86253021405101, 2.351727139692104],
            [33.861595286130864, 2.351194531857603],
            [33.86137894306436, 2.350046930365577],
            [33.860338561913, 2.34909061690889],
            [33.86063058534724, 2.34760311712481],
            [33.85901127323294, 2.345639736228549],
            [33.858019384038926, 2.345772742432956],
            [33.856111039880275, 2.347619941911921],
            [33.85339701111635, 2.347452507222272],
            [33.85094906333954, 2.346079400016237],
            [33.84937006941183, 2.343775902277493],
            [33.84971204276911, 2.342910821053028],
            [33.85821322340925, 2.337745999208846],
            [33.908862047436564, 2.306230036134238],
            [33.908789179694004, 2.305826934839317],
            [33.90898251960101, 2.306165857716679],
            [33.92596209780901, 2.295914569416017],
            [34.006135914059904, 2.245428827104657],
            [34.06035794613159, 2.212723053138343],
            [34.087424200015164, 2.195843773707826],
            [34.08783127517943, 2.196845924218062],
            [34.08884179183919, 2.196221341091275],
            [34.08965895511715, 2.19665651270743],
            [34.09031438930464, 2.195940120880945],
            [34.09113738264883, 2.195883487788575],
            [34.09106879807351, 2.195173853146239],
            [34.09145225113906, 2.194874756812709],
            [34.09211459516773, 2.195154409018374],
            [34.09325914136615, 2.194666222278938],
            [34.09333666597516, 2.195154135233255],
            [34.09457175426943, 2.195680008992729],
            [34.09455029621223, 2.196489609878607],
            [34.095603151369616, 2.196555373896955],
            [34.09777866707017, 2.194351171794139],
            [34.09910474392292, 2.193816430512753],
            [34.1012275267197, 2.194415347054557],
            [34.10434433400588, 2.193879264696821],
            [34.10719687310517, 2.19474450329717],
            [34.109384301364734, 2.193074867014431],
            [34.11004664629169, 2.191873389921478],
            [34.11097517012218, 2.19187269692945],
            [34.11216771420458, 2.190137075014076],
            [34.11422385997357, 2.190335700921784],
            [34.115682612603855, 2.189867560034285],
            [34.11700957250055, 2.19053376845934],
            [34.117076337987385, 2.191134213231903],
            [34.11807173510259, 2.191867377407943],
            [34.117674483914286, 2.192801772705442],
            [34.118006346733075, 2.193135124953264],
            [34.11973044103705, 2.192733496876276],
            [34.120593088712816, 2.193333340233862],
            [34.12192138799758, 2.195800974383508],
            [34.12497398819882, 2.19813387912499],
            [34.12557204788743, 2.199667992828646],
            [34.12424683790895, 2.201336994280965],
            [34.12610438952481, 2.202002793648903],
            [34.126038820593905, 2.203003645608562],
            [34.126835457367655, 2.204003841610644],
            [34.12816136713374, 2.203268911430566],
            [34.12855955526489, 2.203602207481746],
            [34.12822859345636, 2.204469815626771],
            [34.129290659938654, 2.205669970214176],
            [34.12975482573418, 2.205536169231785],
            [34.13021943799237, 2.206002859990056],
            [34.130087652445255, 2.207137207602629],
            [34.1312157585757, 2.207936980195738],
            [34.131415339079, 2.208737473169676],
            [34.131150842719975, 2.209805194420868],
            [34.13207943122919, 2.209871200215965],
            [34.13241174679887, 2.210805017812253],
            [34.133407240033804, 2.211638261654618],
            [34.133939352600756, 2.213639451037637],
            [34.13579752135922, 2.21510585292117],
            [34.137727033419246, 2.21537124404713],
            [34.167457615875335, 2.24543831769933],
            [34.17120310731648, 2.252026715273689],
            [34.18327455761171, 2.263332705612819],
            [34.192805976525335, 2.274887730629826],
            [34.21475673719255, 2.298104059312005],
            [34.22472959542328, 2.313120673425777],
            [34.22725550169538, 2.31802374792707],
            [34.23195210061326, 2.32300752275522],
            [34.23453236843476, 2.32488321250127],
            [34.23923109366494, 2.327329690703398],
            [34.252771108888325, 2.329910152517165],
            [34.25794008330511, 2.330234579218316],
            [34.261422031499784, 2.331652990701745],
            [34.27128218170508, 2.339370360556107],
            [34.27772588617129, 2.345708713014737],
            [34.278274820590255, 2.344997430414748],
            [34.28173347996122, 2.349522077706782],
            [34.28297714177652, 2.350139556735059],
            [34.285675520989884, 2.353190715167941],
            [34.290193234792, 2.356753492471142],
            [34.29215682623894, 2.357594037634855],
            [34.29801090619705, 2.362919249410497],
            [34.299479749602966, 2.366419015372644],
            [34.30268918666968, 2.370193542106671],
            [34.30510123327612, 2.374798012135207],
            [34.310563707957485, 2.380992185633136],
            [34.31289786883217, 2.386202142651532],
            [34.314706169414265, 2.388832838000489],
            [34.32360136191781, 2.399367064487335],
            [34.32589281957881, 2.400904789795114],
            [34.32817345164236, 2.404772206290672],
            [34.3299288881666, 2.406797438464482],
            [34.334171957341944, 2.410215397708934],
            [34.3396577819325, 2.413224070974706],
            [34.34245877210752, 2.413905708359569],
            [34.3460986189763, 2.415981678826311],
            [34.35045965760971, 2.419544191101178],
            [34.354754240675014, 2.422040652998475],
            [34.3703370068882, 2.4265069510023],
            [34.372008549748074, 2.428872386296808],
            [34.372456192830555, 2.430665632595162],
            [34.37424242000948, 2.433533725503606],
            [34.37602756292187, 2.435325593321967],
            [34.379238820873674, 2.436577877302318],
            [34.38111332280064, 2.438549009886401],
            [34.3812032217027, 2.439266395446101],
            [34.38434852354971, 2.441675566845323],
            [34.38412848571244, 2.444899033703601],
            [34.38681869025672, 2.450606543274816],
            [34.397023234779006, 2.459820994421167],
            [34.39840553449046, 2.462068986120121],
            [34.39912729399032, 2.464540996912937],
            [34.399347056044775, 2.464299808737775],
            [34.402363481089566, 2.466059875251272],
            [34.40771275097713, 2.465336719775518],
            [34.410655635441145, 2.465692318975628],
            [34.41221937687367, 2.468592852636742],
            [34.41611490403527, 2.473652163248272],
            [34.42125723981063, 2.484514424035708],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 804,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "LOKOPO",
        Population: 21102,
        Key: "NAPAKLOKOPO",
        Dist2: "Napak",
        "Sub Country": "Lokopo",
        id2_original: "NapakLokopo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.47581895902726, 2.572068545360338],
            [34.44218337757321, 2.620544537650146],
            [34.36368034959736, 2.731985245019758],
            [34.36410505779236, 2.735090769323227],
            [34.36382521730998, 2.735938182315409],
            [34.36237453244922, 2.736033962776522],
            [34.362375968855375, 2.73730460278439],
            [34.363313295277315, 2.738480050706122],
            [34.36331505417866, 2.740033053999826],
            [34.36275324241007, 2.739845453442995],
            [34.36172513583875, 2.741164332066133],
            [34.36233396093774, 2.741540122254548],
            [34.36186803983415, 2.743376025937486],
            [34.361963720293396, 2.745211287935121],
            [34.36360492974105, 2.748033050136103],
            [34.362204237024194, 2.750952427048929],
            [34.3622517327499, 2.751564162823618],
            [34.36347004051462, 2.752880463187381],
            [34.36375223637965, 2.754103717994122],
            [34.36412685451439, 2.754291528965683],
            [34.36417676580989, 2.757020994767532],
            [34.362588550675774, 2.759658228055292],
            [34.362777738569555, 2.761399257685252],
            [34.36240322553771, 2.761305568109675],
            [34.361800024790746, 2.765871159592423],
            [34.36198905727596, 2.767471007624291],
            [34.361568117513634, 2.767706797858519],
            [34.36096250029854, 2.770154658365613],
            [34.361666347391605, 2.771753911110329],
            [34.36232210137936, 2.772223759901509],
            [34.36138958094417, 2.775283790428995],
            [34.3627015281958, 2.776599971168872],
            [34.36218827935149, 2.777965328346394],
            [34.36237710522421, 2.7793769322411],
            [34.361816568165, 2.780318797630331],
            [34.36191260345876, 2.782436421135231],
            [34.36154008378854, 2.784083980713344],
            [34.360605131613866, 2.785026281996859],
            [34.360980302212525, 2.785684697753425],
            [34.36070035752558, 2.786437994977803],
            [34.36018580792071, 2.786673897171495],
            [34.3600463229133, 2.78747409224899],
            [34.35915806067553, 2.788322219766021],
            [34.35901830527519, 2.788887112280867],
            [34.3599143451267, 2.789391349465906],
            [34.35973137806626, 2.790234127091507],
            [34.35836210033319, 2.790256270331102],
            [34.35881292704506, 2.791303815833829],
            [34.35707558618389, 2.791161981320941],
            [34.35683161273585, 2.792271985296551],
            [34.355321250095855, 2.794020523477251],
            [34.35571119079438, 2.795438048786148],
            [34.35454760121022, 2.796610774250357],
            [34.35383250181988, 2.796796557870883],
            [34.3543856825752, 2.797987839682011],
            [34.35315985680987, 2.798359170482117],
            [34.35328564520413, 2.801112780602297],
            [34.35377728148104, 2.802098629284298],
            [34.35289924566446, 2.802777814664061],
            [34.351901061975255, 2.805614933841081],
            [34.35267809481455, 2.80596338713303],
            [34.352249447507056, 2.806436546524],
            [34.35341652524948, 2.808284725003334],
            [34.35341993794922, 2.811243981176953],
            [34.35205136719027, 2.811903191511446],
            [34.35084819064819, 2.81420624095557],
            [34.350337599918795, 2.814515092363699],
            [34.35097271241795, 2.815850131953257],
            [34.3507690212239, 2.816446331694863],
            [34.35015624174105, 2.816755302737925],
            [34.350012228326264, 2.815933453274138],
            [34.34960359009342, 2.816036681442358],
            [34.34989154415941, 2.817618730124635],
            [34.349647995614546, 2.819098646976564],
            [34.34928025587995, 2.819222378319619],
            [34.350509259884745, 2.821584245311245],
            [34.34949070959145, 2.824483046836561],
            [34.34826568691996, 2.825573652584636],
            [34.348368944668586, 2.826498301676351],
            [34.34890035834626, 2.826518231677964],
            [34.346081898633926, 2.828247762070161],
            [34.34473691943099, 2.831660711547134],
            [34.34206074836807, 2.832732458208663],
            [34.342081731216474, 2.833205096195554],
            [34.34253139640666, 2.833225122084113],
            [34.3413717270704, 2.837829787817405],
            [34.3387770071526, 2.838654834690067],
            [34.337695809249695, 2.840423440256247],
            [34.33759463649083, 2.841307231062014],
            [34.33679763230613, 2.841390361242313],
            [34.33630791572899, 2.842089650782537],
            [34.336513151127015, 2.842829230898734],
            [34.335348515005535, 2.843138845386407],
            [34.33596292403232, 2.844227308963448],
            [34.336412664681, 2.84430898814701],
            [34.33549428283008, 2.845481439132881],
            [34.33498997851104, 2.85125673448641],
            [34.33419393911696, 2.852182438770853],
            [34.334297319036494, 2.853209846405405],
            [34.333868415709155, 2.853477504065138],
            [34.33376804873908, 2.855060014741882],
            [34.332931296798016, 2.856129621372821],
            [34.33139881943234, 2.856501319360151],
            [34.33043988134126, 2.857961529719454],
            [34.32837601634905, 2.858354393801054],
            [34.327273692765566, 2.859547613134314],
            [34.32641528603627, 2.8595691620051],
            [34.32608954074458, 2.860679274621262],
            [34.32467935463177, 2.860763116672442],
            [34.32343194774003, 2.86020969747377],
            [34.323187790137396, 2.861175861645912],
            [34.32230877695378, 2.861053577487878],
            [34.3220235519696, 2.861855383822995],
            [34.32155322193462, 2.861650422316421],
            [34.32059325257761, 2.862226954347906],
            [34.31971626240002, 2.863872024120217],
            [34.318837387556954, 2.863873042434651],
            [34.31736667565527, 2.864655670199425],
            [34.31775621660349, 2.865703305519555],
            [34.315733271669096, 2.866157760943374],
            [34.31565254905765, 2.86706208660432],
            [34.315039659980364, 2.867309402616336],
            [34.314264361787856, 2.868522792212461],
            [34.31451064210954, 2.869406189070173],
            [34.31373534122211, 2.870619577338126],
            [34.31408365309205, 2.871359000910922],
            [34.3134094198606, 2.871585838590747],
            [34.31345161462782, 2.872736630542703],
            [34.31287981179665, 2.873168857180589],
            [34.31286040728821, 2.874073112696323],
            [34.311982250199065, 2.874711201495881],
            [34.312003277064925, 2.875224944669119],
            [34.31249403029788, 2.87540933399857],
            [34.31259848370418, 2.877382084428049],
            [34.31094464484194, 2.878904753237703],
            [34.30984082915677, 2.878823827460326],
            [34.30941256722653, 2.879666902416939],
            [34.30832977571231, 2.880099719464345],
            [34.307493077670166, 2.88125153009505],
            [34.30692056427161, 2.881067234120423],
            [34.30610409179808, 2.882034062509431],
            [34.3046383412917, 2.887194003968118],
            [34.30155263188401, 2.887772984939886],
            [34.299938821950825, 2.888576326403435],
            [34.29885809746005, 2.890838162371413],
            [34.29861467108602, 2.892461960204873],
            [34.29792002723302, 2.892729920877925],
            [34.297001717247305, 2.894025681238506],
            [34.29538744917333, 2.894438555023256],
            [34.295940302043576, 2.895301056447587],
            [34.29477685079997, 2.896720404075806],
            [34.294614642009115, 2.897871439739323],
            [34.29398145370134, 2.898262634791572],
            [34.29410544816001, 2.899454443255721],
            [34.2935132077578, 2.899907243387063],
            [34.29159214525134, 2.900156061288916],
            [34.29140851343761, 2.900443983846205],
            [34.29173585503557, 2.900710770036687],
            [34.29112296236499, 2.900978636349787],
            [34.2904092481768, 2.902459120304425],
            [34.290102788815936, 2.902582778056093],
            [34.28973407890084, 2.901884469370152],
            [34.289162414410214, 2.902460551279261],
            [34.28738379506341, 2.902154325313017],
            [34.284973558562264, 2.903636751877491],
            [34.28456541170786, 2.904212645386396],
            [34.28466902878262, 2.905466135438975],
            [34.284158169456965, 2.905590025225997],
            [34.28399560313663, 2.906432800368266],
            [34.2827285545812, 2.906639759853016],
            [34.2824235801355, 2.908078675521582],
            [34.28132548582042, 2.909928066556821],
            [34.28028598501802, 2.906533047200487],
            [34.28011057638238, 2.900113545548266],
            [34.27900393729231, 2.89459265639535],
            [34.27872712862404, 2.888996541948644],
            [34.275151046869055, 2.858915802538973],
            [34.27456977489647, 2.847254872868331],
            [34.27401951815737, 2.845670566015002],
            [34.27191147851106, 2.835370385313655],
            [34.27038351787462, 2.81983598254913],
            [34.269290269970476, 2.802531029483357],
            [34.267450920917234, 2.790963127469291],
            [34.266485868892346, 2.778837408753556],
            [34.26442397031228, 2.769208084100284],
            [34.26181456114295, 2.744521214141828],
            [34.261893763804935, 2.735391441052776],
            [34.260913631761376, 2.727058718745099],
            [34.25760953382325, 2.72864531456276],
            [34.25586911443562, 2.728855918172685],
            [34.2550368262232, 2.727767168473712],
            [34.255034504078196, 2.725529173804619],
            [34.255380653703256, 2.723990187321792],
            [34.25628420706378, 2.723429741534088],
            [34.256074545666344, 2.722450837259678],
            [34.253287897993154, 2.717907819570529],
            [34.252448628074355, 2.713362759556521],
            [34.251264868617135, 2.711965241686964],
            [34.25154198091599, 2.710915890183678],
            [34.25112418974868, 2.710426761937187],
            [34.251957759857035, 2.709446769451599],
            [34.25126077050281, 2.707978806264123],
            [34.25153702131731, 2.706090205908522],
            [34.2508394624312, 2.70406274132155],
            [34.24993433881554, 2.703084553575723],
            [34.24993204721325, 2.700846553577729],
            [34.250974544795405, 2.700146098427266],
            [34.25055589843198, 2.698817718102271],
            [34.25083230016344, 2.697068993029167],
            [34.250204587087275, 2.695321202245448],
            [34.2482562634069, 2.69434408694227],
            [34.24700170682384, 2.691687749169176],
            [34.247626918990214, 2.690987729332805],
            [34.24303482108931, 2.689034190009241],
            [34.24171186857714, 2.687496913255114],
            [34.23976440817775, 2.687359028146704],
            [34.23851128979744, 2.68610142500404],
            [34.23718933261861, 2.685543270534196],
            [34.2352713001296, 2.682838944098082],
            [34.236146767662774, 2.676408149481538],
            [34.23790726888862, 2.673080552551056],
            [34.2403229734349, 2.663544116139802],
            [34.238772322252714, 2.656228902955922],
            [34.2356799230911, 2.650467273689901],
            [34.228175007338734, 2.641605923133796],
            [34.22110834637583, 2.62986165409325],
            [34.21514741630622, 2.621442044206988],
            [34.20963071122949, 2.616347786387339],
            [34.207422810364605, 2.613024075517973],
            [34.206567158768266, 2.609596028717574],
            [34.23120449837931, 2.577230277364032],
            [34.239506204517326, 2.565606441730683],
            [34.25073539619878, 2.548569694950698],
            [34.26898169507715, 2.525509407832685],
            [34.27033276036612, 2.52486269068056],
            [34.2709054624109, 2.524093118550271],
            [34.27161263147393, 2.521208705174759],
            [34.272648889358145, 2.519758005794175],
            [34.27611629472668, 2.519177853924222],
            [34.27813719060389, 2.51936810193067],
            [34.27983116259979, 2.520327667155509],
            [34.280759417834005, 2.520161968936955],
            [34.28218063975006, 2.52145135921855],
            [34.284173440816794, 2.520845175888268],
            [34.2863873675806, 2.522957691092692],
            [34.28707009438305, 2.523011943407361],
            [34.29030432584992, 2.521374629416323],
            [34.2944264449571, 2.520162093682015],
            [34.297049810352675, 2.522109393952944],
            [34.30700544518448, 2.524474972724577],
            [34.310393751197296, 2.526751021979567],
            [34.311458591677216, 2.526640074823193],
            [34.31350747366881, 2.527516833153172],
            [34.31917285980654, 2.526783264374117],
            [34.320648152217885, 2.527523269602624],
            [34.322097198551546, 2.529306905260388],
            [34.324418643773384, 2.529689019056208],
            [34.32605837189916, 2.531005569845701],
            [34.328242809667124, 2.530920935965181],
            [34.33172139995928, 2.527992491348563],
            [34.33259343682637, 2.526261400923128],
            [34.33300074016273, 2.524008988582453],
            [34.334446657664266, 2.522716724525907],
            [34.33583871128307, 2.52216601555795],
            [34.336956105003715, 2.520050188387895],
            [34.33988958680168, 2.518165919080648],
            [34.34177334766426, 2.517806944391068],
            [34.34540298787479, 2.515798367917319],
            [34.34802199644124, 2.513488747408559],
            [34.348647492475266, 2.511016412847006],
            [34.347907755889935, 2.508600418487575],
            [34.34913600980149, 2.508104807281014],
            [34.350266059886216, 2.505041495421479],
            [34.352094113523094, 2.503666443644492],
            [34.35468740511957, 2.502922244520146],
            [34.3566512894173, 2.500860467102573],
            [34.35755274521167, 2.501216550343892],
            [34.35633291031095, 2.492986136587586],
            [34.35580835347381, 2.491907401969759],
            [34.354393993788214, 2.490882240732481],
            [34.35533462151885, 2.489354488886879],
            [34.35606732878706, 2.489222112416329],
            [34.3566827520118, 2.486988750630414],
            [34.35744076661822, 2.486330143618861],
            [34.357439959032796, 2.485540757832687],
            [34.35835504047337, 2.484960924680158],
            [34.358511244924856, 2.484223993463751],
            [34.359073821159754, 2.484315509480195],
            [34.35998845074776, 2.483314677285879],
            [34.3620285786569, 2.482838927473308],
            [34.36318031227594, 2.483442929569722],
            [34.3628640738549, 2.481206658270965],
            [34.36445712462019, 2.478468460547854],
            [34.36647459971279, 2.477591396581233],
            [34.36746950544955, 2.477932562890361],
            [34.368803558443695, 2.477220444757873],
            [34.37206333440399, 2.478520064458916],
            [34.372376120599384, 2.477282527644526],
            [34.37444213705671, 2.475753596942068],
            [34.37590503181881, 2.473093401273623],
            [34.37679520477318, 2.473408348910157],
            [34.381531979943844, 2.473061185381789],
            [34.38307669416032, 2.473612364576391],
            [34.388021136468495, 2.471632906637282],
            [34.391813934989116, 2.469602011114029],
            [34.39192007722816, 2.470997037717285],
            [34.39262836738863, 2.472575696930772],
            [34.39963345692369, 2.482644310659468],
            [34.40100899321932, 2.484075068905573],
            [34.401260433463996, 2.485607532302366],
            [34.40178529752494, 2.485833111393096],
            [34.40305277278009, 2.48472221275164],
            [34.405028352244535, 2.485461939309624],
            [34.40681252228146, 2.485196796071759],
            [34.40757335041132, 2.484693448815264],
            [34.411430145811124, 2.486938732878101],
            [34.415831658938, 2.486814338256848],
            [34.42035077231528, 2.487644809399469],
            [34.4221527325881, 2.49075256937978],
            [34.42825751078245, 2.497254376641859],
            [34.43280128471096, 2.498688764505927],
            [34.435852888680586, 2.501188652816442],
            [34.43747312066972, 2.50343978438092],
            [34.438409255925635, 2.506004571254481],
            [34.43941008784829, 2.510822199573131],
            [34.438921852593054, 2.519521496253539],
            [34.447196032554146, 2.518198074635591],
            [34.452425224637665, 2.520445120438461],
            [34.458710254285336, 2.520938692447506],
            [34.45977257858416, 2.525005219011867],
            [34.46070773737134, 2.526631250276256],
            [34.4611474321602, 2.530322993753567],
            [34.46208456634269, 2.533701267240145],
            [34.46482878927997, 2.539392948783934],
            [34.46785165434699, 2.55521137162881],
            [34.469997793341165, 2.559372634933502],
            [34.47271252907921, 2.5613795758944],
            [34.474672447314944, 2.571176420504821],
            [34.47581895902726, 2.572068545360338],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 805,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "LOPEEI",
        Population: 13218,
        Key: "NAPAKLOPEEI",
        Dist2: "Napak",
        "Sub Country": "Lopeei",
        id2_original: "NapakLopeei",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.58532831550316, 2.41979827292354],
            [34.58383572513274, 2.420573244849813],
            [34.581578124974776, 2.419013675605849],
            [34.58098683139687, 2.419349131584607],
            [34.57969222432517, 2.419090279387361],
            [34.579915248162465, 2.420954785966227],
            [34.58074955039775, 2.422389505397823],
            [34.58051986016274, 2.429448626851087],
            [34.580186291443226, 2.430559768044822],
            [34.57739681856847, 2.432507047444448],
            [34.573495405645126, 2.438559629127631],
            [34.57181042758189, 2.444779911540333],
            [34.57063920321613, 2.443674706470604],
            [34.569101497655474, 2.443350986845702],
            [34.56966873345175, 2.444082759429134],
            [34.56772703484661, 2.444247808422218],
            [34.56779661026367, 2.442279192704331],
            [34.56757264678862, 2.442689375852133],
            [34.56600252282601, 2.442717538473955],
            [34.56589732561464, 2.442270195273744],
            [34.56665568158089, 2.441795529343617],
            [34.565883076537624, 2.441256841880611],
            [34.565987166126234, 2.440756613886076],
            [34.55920913745735, 2.440580288268529],
            [34.54739085127383, 2.438106642845713],
            [34.53405326690814, 2.434344854503746],
            [34.52155444670975, 2.431792725064077],
            [34.520558116245, 2.430109257989553],
            [34.51888227045493, 2.429216212684279],
            [34.51652269444422, 2.425349546089042],
            [34.51408758089788, 2.424141486439246],
            [34.51222961515869, 2.424196225657153],
            [34.51126043537504, 2.423381337168137],
            [34.51118119408551, 2.422723370149143],
            [34.50980663964847, 2.422132673184841],
            [34.50839162509102, 2.420449634763809],
            [34.5065826399927, 2.417477263168739],
            [34.503798580365846, 2.41168491724671],
            [34.500697264526714, 2.409324129855314],
            [34.50025033829981, 2.406400582527677],
            [34.49811334415525, 2.402467758077803],
            [34.49731957749886, 2.399883073721913],
            [34.4948846552937, 2.394714608529259],
            [34.49107807392165, 2.387999138478762],
            [34.4894932840637, 2.385273221842566],
            [34.48498171473813, 2.379609734995891],
            [34.48274355052967, 2.373418116885963],
            [34.47433814826513, 2.358368211734406],
            [34.466708205889844, 2.341797198166026],
            [34.4656321265874, 2.339212722718152],
            [34.45454864703491, 2.301178775358816],
            [34.4532178746882, 2.298026248786157],
            [34.45040278365814, 2.293468773121802],
            [34.442547012905266, 2.276016631156399],
            [34.43868665388874, 2.271204405995011],
            [34.43379498311195, 2.266009591496421],
            [34.42631443955155, 2.256285316117172],
            [34.42308970417555, 2.251429723270527],
            [34.41922993535215, 2.247066147209675],
            [34.40716973376092, 2.234242220483428],
            [34.401371645794455, 2.229028957153937],
            [34.39419048017555, 2.224164890899618],
            [34.38873799925174, 2.218603270994608],
            [34.387699050913255, 2.217125577535598],
            [34.38700425165168, 2.213820957521498],
            [34.387368241818294, 2.203700540655205],
            [34.35264856719116, 2.182917747645433],
            [34.351890050426505, 2.183204681232967],
            [34.3522053519047, 2.182250237817662],
            [34.35021158425074, 2.180025672696732],
            [34.35670809438429, 2.177010384718911],
            [34.3605662704947, 2.171938303183768],
            [34.360564799054245, 2.170295366133996],
            [34.3689792239975, 2.168883798618451],
            [34.37405870465242, 2.168652916530072],
            [34.37710270348482, 2.16581024822974],
            [34.37998978999332, 2.160851608026454],
            [34.38105606687937, 2.155679165668452],
            [34.38126578037907, 2.150722979899811],
            [34.382544612136066, 2.143718781951102],
            [34.383450123823934, 2.140009144174076],
            [34.385377102634834, 2.136565271367982],
            [34.405083260867954, 2.124213063988088],
            [34.40994477699727, 2.116000546483369],
            [34.4138220620704, 2.110811786334668],
            [34.41851106124098, 2.105909147215787],
            [34.4237263986079, 2.101006030349647],
            [34.43794924393998, 2.089144311114076],
            [34.461811898907875, 2.066771086726878],
            [34.47633947703884, 2.08746759527324],
            [34.47999313281018, 2.091908720531444],
            [34.48454744038372, 2.100857951950803],
            [34.48820569642763, 2.110065650846169],
            [34.50099456107168, 2.148988979535157],
            [34.50522349256108, 2.156733228718692],
            [34.50843374529806, 2.168395165287315],
            [34.510536634902884, 2.180154901459229],
            [34.51116261333218, 2.183655383505846],
            [34.52483267047272, 2.226602307816548],
            [34.53097491649927, 2.247699145600798],
            [34.53165699920966, 2.247975034839553],
            [34.58532831550316, 2.41979827292354],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 806,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "LOTOME",
        Population: 11088,
        Key: "NAPAKLOTOME",
        Dist2: "Napak",
        "Sub Country": "Lorengecora TC",
        id2_original: "NapakLorengecora TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.5065826399927, 2.417477263168739],
            [34.506190913443376, 2.418214729257189],
            [34.50629833667998, 2.420688886798226],
            [34.50572274924653, 2.420821139918206],
            [34.50488395633316, 2.419584938255454],
            [34.5036015950954, 2.419533729673016],
            [34.5032118915521, 2.422113725793875],
            [34.502401133262076, 2.422562110511074],
            [34.50127523249567, 2.422010606065588],
            [34.500209726364126, 2.422147544072863],
            [34.49849799737003, 2.42322626505606],
            [34.49488800780634, 2.428853657992259],
            [34.49222396938965, 2.429335212368609],
            [34.48891700852074, 2.429291024462398],
            [34.48758519053501, 2.429723231019314],
            [34.48512175400609, 2.428732888379037],
            [34.484051273902814, 2.428829786965065],
            [34.483101497729336, 2.43052982720703],
            [34.48293661734885, 2.432037561169723],
            [34.481961337106114, 2.432182216713214],
            [34.47994136739194, 2.43424236934722],
            [34.48001466183428, 2.436013073988664],
            [34.47439224301492, 2.43983604030942],
            [34.47425007024816, 2.440362643496511],
            [34.47482257376524, 2.441749922001685],
            [34.47432463580663, 2.443281961124855],
            [34.47351576218208, 2.443306776064406],
            [34.47165806054757, 2.44149019006253],
            [34.46998960519732, 2.438668338129972],
            [34.46688554859827, 2.439305887298527],
            [34.4662203057062, 2.440144143371027],
            [34.467790736892645, 2.440333859754901],
            [34.467816470930565, 2.442128548334813],
            [34.46612924797742, 2.443925112083464],
            [34.46353694901933, 2.444813366661751],
            [34.46291915693718, 2.445531934470151],
            [34.46092368697575, 2.448309951771731],
            [34.45963070405807, 2.451673488784578],
            [34.45280706432897, 2.455868665230101],
            [34.447775959748746, 2.456651875979872],
            [34.44587118100344, 2.455313877059265],
            [34.44168669456104, 2.457974649457756],
            [34.44052235668026, 2.459339914983488],
            [34.43992927994652, 2.460943846897576],
            [34.44064360319248, 2.461469533525566],
            [34.44171297387636, 2.460295813711895],
            [34.44264063083261, 2.460079431319417],
            [34.44304577012743, 2.460701170037769],
            [34.44209625177042, 2.462712304849309],
            [34.44116848971128, 2.462832971782446],
            [34.43910006037911, 2.464199223155528],
            [34.43662433669376, 2.462933628369234],
            [34.43588805053741, 2.464106986865456],
            [34.43504360093268, 2.464263448946601],
            [34.43404520703772, 2.465078147479526],
            [34.433570627971434, 2.466251232148058],
            [34.435117616722195, 2.466728146563938],
            [34.43490526487052, 2.46837954098049],
            [34.433644223349376, 2.468333056808604],
            [34.43205119414368, 2.469291980771223],
            [34.43007911182064, 2.471782834182044],
            [34.430104084985544, 2.472883575250255],
            [34.43134091870638, 2.472547218128794],
            [34.431817024010336, 2.472786008538856],
            [34.43155663654547, 2.474030647705447],
            [34.430736410012344, 2.474593883210924],
            [34.42959408175436, 2.474307971954466],
            [34.427238830233414, 2.474478028723342],
            [34.42678785080797, 2.475483578458074],
            [34.427621812581755, 2.476631317283331],
            [34.42705182165252, 2.47758913314791],
            [34.42724434588926, 2.479622970023511],
            [34.426982809479135, 2.479790766270293],
            [34.42676803217617, 2.479192745967728],
            [34.42481642784837, 2.478596609194641],
            [34.42386499068992, 2.478836945761041],
            [34.422486841195095, 2.480537472548167],
            [34.42277493719493, 2.482954079406041],
            [34.42125723981063, 2.484514424035708],
            [34.41611490403527, 2.473652163248272],
            [34.41221937687367, 2.468592852636742],
            [34.410655635441145, 2.465692318975628],
            [34.40771275097713, 2.465336719775518],
            [34.402363481089566, 2.466059875251272],
            [34.399347056044775, 2.464299808737775],
            [34.39912729399032, 2.464540996912937],
            [34.39840553449046, 2.462068986120121],
            [34.397023234779006, 2.459820994421167],
            [34.38681869025672, 2.450606543274816],
            [34.38412848571244, 2.444899033703601],
            [34.38434852354971, 2.441675566845323],
            [34.3812032217027, 2.439266395446101],
            [34.38111332280064, 2.438549009886401],
            [34.379238820873674, 2.436577877302318],
            [34.37602756292187, 2.435325593321967],
            [34.37424242000948, 2.433533725503606],
            [34.372456192830555, 2.430665632595162],
            [34.372008549748074, 2.428872386296808],
            [34.3703370068882, 2.4265069510023],
            [34.354754240675014, 2.422040652998475],
            [34.35045965760971, 2.419544191101178],
            [34.3460986189763, 2.415981678826311],
            [34.34245877210752, 2.413905708359569],
            [34.3396577819325, 2.413224070974706],
            [34.334171957341944, 2.410215397708934],
            [34.3299288881666, 2.406797438464482],
            [34.32817345164236, 2.404772206290672],
            [34.32589281957881, 2.400904789795114],
            [34.32360136191781, 2.399367064487335],
            [34.314706169414265, 2.388832838000489],
            [34.31289786883217, 2.386202142651532],
            [34.310563707957485, 2.380992185633136],
            [34.30510123327612, 2.374798012135207],
            [34.30268918666968, 2.370193542106671],
            [34.299479749602966, 2.366419015372644],
            [34.29801090619705, 2.362919249410497],
            [34.29215682623894, 2.357594037634855],
            [34.290193234792, 2.356753492471142],
            [34.285675520989884, 2.353190715167941],
            [34.28297714177652, 2.350139556735059],
            [34.28173347996122, 2.349522077706782],
            [34.278274820590255, 2.344997430414748],
            [34.27772588617129, 2.345708713014737],
            [34.27128218170508, 2.339370360556107],
            [34.261422031499784, 2.331652990701745],
            [34.25794008330511, 2.330234579218316],
            [34.252771108888325, 2.329910152517165],
            [34.23923109366494, 2.327329690703398],
            [34.23453236843476, 2.32488321250127],
            [34.2374184820678, 2.324095848867835],
            [34.23999573334658, 2.321317637279791],
            [34.24395353262196, 2.31938305351799],
            [34.24455223909759, 2.317994557720682],
            [34.24503249282154, 2.318356210700881],
            [34.24581191428114, 2.317812403674615],
            [34.24629086185468, 2.316683362937207],
            [34.24834909261343, 2.318323717406901],
            [34.25012624860463, 2.319126260530644],
            [34.25349945214091, 2.316800239655147],
            [34.259004130572634, 2.314204274189101],
            [34.26326496393272, 2.311252024901388],
            [34.2645043515639, 2.306604900112072],
            [34.26521436738807, 2.30597884081661],
            [34.26761237781818, 2.305797999297038],
            [34.269032166023074, 2.304277839054986],
            [34.273739349789956, 2.303916223777452],
            [34.274182578551134, 2.302933017768148],
            [34.27533724606789, 2.302931977461639],
            [34.276047253807185, 2.302305915653524],
            [34.2777355601286, 2.303108507324618],
            [34.28048755618802, 2.301497793474465],
            [34.28208624028845, 2.301407002176882],
            [34.28608491290927, 2.303368981531114],
            [34.2882165162638, 2.303277696678538],
            [34.29061570618192, 2.304437003100688],
            [34.29372497390793, 2.30505958132901],
            [34.294613093313586, 2.304969423058315],
            [34.296654739375555, 2.303627372385197],
            [34.299585549583846, 2.303356647754079],
            [34.30011822449619, 2.30308812306374],
            [34.3010937805217, 2.301479014082676],
            [34.30215920849983, 2.301031309251995],
            [34.30358056426485, 2.301298037353137],
            [34.30535622096782, 2.300492297707627],
            [34.3062447401238, 2.300848858621134],
            [34.3087296418964, 2.298612943170098],
            [34.31112677826577, 2.297538591001786],
            [34.31183651291725, 2.296644487419214],
            [34.31378979260304, 2.295838578194374],
            [34.315388366210726, 2.295658408584637],
            [34.31645345372732, 2.294853320103017],
            [34.317608096091256, 2.294852249272412],
            [34.32426758666847, 2.292791136677521],
            [34.32524401046654, 2.292164817301466],
            [34.32666501768526, 2.292074147483848],
            [34.329591888781046, 2.287604207402198],
            [34.33429806463818, 2.286348992217597],
            [34.336252130349834, 2.286436505537794],
            [34.337227714223125, 2.284916744782433],
            [34.34563008108033, 2.278061713265148],
            [34.3486717263267, 2.276747026035447],
            [34.35801620582968, 2.275207738372192],
            [34.36781689295307, 2.275576060632467],
            [34.36811056749078, 2.27490147569053],
            [34.37083877077161, 2.274320984852404],
            [34.37931458208978, 2.273656948911313],
            [34.387573640709704, 2.273648979049151],
            [34.37235274913063, 2.266448672207917],
            [34.37174605393719, 2.266618824531217],
            [34.371994829778735, 2.266052996461586],
            [34.340172435741934, 2.252048908964305],
            [34.33430114585959, 2.248774754736455],
            [34.3236437632975, 2.240476223733201],
            [34.32159183691542, 2.237954509145912],
            [34.31857476238869, 2.232951476614909],
            [34.31905823297968, 2.232770248057288],
            [34.317557645806566, 2.230118350609649],
            [34.31585274939852, 2.219536224044279],
            [34.31816000393382, 2.21474511308121],
            [34.31833171690036, 2.213790217674794],
            [34.31775042965642, 2.211281370976113],
            [34.31872959960433, 2.210384293469366],
            [34.32197993606763, 2.20885784146216],
            [34.323984038838944, 2.208452755392078],
            [34.32338773984827, 2.204858475782944],
            [34.32478850622702, 2.201725082552633],
            [34.325957176682394, 2.199630645062853],
            [34.33042989387193, 2.194270205864471],
            [34.351890050426505, 2.183204681232967],
            [34.35264856719116, 2.182917747645433],
            [34.387368241818294, 2.203700540655205],
            [34.38700425165168, 2.213820957521498],
            [34.387699050913255, 2.217125577535598],
            [34.38873799925174, 2.218603270994608],
            [34.39419048017555, 2.224164890899618],
            [34.401371645794455, 2.229028957153937],
            [34.40716973376092, 2.234242220483428],
            [34.41922993535215, 2.247066147209675],
            [34.42308970417555, 2.251429723270527],
            [34.42631443955155, 2.256285316117172],
            [34.43379498311195, 2.266009591496421],
            [34.43868665388874, 2.271204405995011],
            [34.442547012905266, 2.276016631156399],
            [34.45040278365814, 2.293468773121802],
            [34.4532178746882, 2.298026248786157],
            [34.45454864703491, 2.301178775358816],
            [34.4656321265874, 2.339212722718152],
            [34.466708205889844, 2.341797198166026],
            [34.47433814826513, 2.358368211734406],
            [34.48274355052967, 2.373418116885963],
            [34.48498171473813, 2.379609734995891],
            [34.4894932840637, 2.385273221842566],
            [34.49107807392165, 2.387999138478762],
            [34.4948846552937, 2.394714608529259],
            [34.49731957749886, 2.399883073721913],
            [34.49811334415525, 2.402467758077803],
            [34.50025033829981, 2.406400582527677],
            [34.500697264526714, 2.409324129855314],
            [34.503798580365846, 2.41168491724671],
            [34.5065826399927, 2.417477263168739],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 807,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "MATANY",
        Population: 22267,
        Key: "NAPAKMATANY",
        Dist2: "Napak",
        "Sub Country": "Lotome",
        id2_original: "NapakLotome",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.57181042758189, 2.444779911540333],
            [34.57134113689768, 2.446201517423048],
            [34.5723912378204, 2.449163503608395],
            [34.57231630485098, 2.451386012765187],
            [34.5720866334806, 2.45388163211346],
            [34.571429867091545, 2.455792910772477],
            [34.574043003370974, 2.462170513326039],
            [34.54972739717558, 2.496892469589747],
            [34.55014318240484, 2.497110135617544],
            [34.50462465762638, 2.56107278550761],
            [34.5025316261335, 2.561721349339354],
            [34.50079935087222, 2.561667603898245],
            [34.50080012791495, 2.562160657592978],
            [34.500027854350044, 2.563001460100237],
            [34.499162189233225, 2.56331353401293],
            [34.49878958332472, 2.562069710633589],
            [34.49820148325767, 2.561697123552224],
            [34.4977078329579, 2.56275532830191],
            [34.49461720257911, 2.564780905073947],
            [34.49319353005893, 2.564004908835791],
            [34.49096733141004, 2.564660757298324],
            [34.489295930484005, 2.563636197360887],
            [34.48805926923968, 2.564104242009127],
            [34.48482693231975, 2.563968046577503],
            [34.48247775700341, 2.565277284286869],
            [34.48167475746248, 2.566304743352876],
            [34.481150418916, 2.567580744757914],
            [34.48127661245046, 2.569726967335277],
            [34.479545024400394, 2.570164486988975],
            [34.47880133882105, 2.568983288128425],
            [34.47581895902726, 2.572068545360338],
            [34.474672447314944, 2.571176420504821],
            [34.47271252907921, 2.5613795758944],
            [34.469997793341165, 2.559372634933502],
            [34.46785165434699, 2.55521137162881],
            [34.46482878927997, 2.539392948783934],
            [34.46208456634269, 2.533701267240145],
            [34.4611474321602, 2.530322993753567],
            [34.46070773737134, 2.526631250276256],
            [34.45977257858416, 2.525005219011867],
            [34.458710254285336, 2.520938692447506],
            [34.452425224637665, 2.520445120438461],
            [34.447196032554146, 2.518198074635591],
            [34.438921852593054, 2.519521496253539],
            [34.43941008784829, 2.510822199573131],
            [34.438409255925635, 2.506004571254481],
            [34.43747312066972, 2.50343978438092],
            [34.435852888680586, 2.501188652816442],
            [34.43280128471096, 2.498688764505927],
            [34.42825751078245, 2.497254376641859],
            [34.4221527325881, 2.49075256937978],
            [34.42035077231528, 2.487644809399469],
            [34.415831658938, 2.486814338256848],
            [34.411430145811124, 2.486938732878101],
            [34.40757335041132, 2.484693448815264],
            [34.40681252228146, 2.485196796071759],
            [34.405028352244535, 2.485461939309624],
            [34.40305277278009, 2.48472221275164],
            [34.4036208143652, 2.481897845196623],
            [34.40635797564599, 2.482852123901298],
            [34.407071340389535, 2.482468478808443],
            [34.4082581109996, 2.479763091760138],
            [34.40747177071563, 2.47863921322312],
            [34.40763788987292, 2.478232223580843],
            [34.41174411239284, 2.480130277070753],
            [34.412244894417626, 2.481206592755424],
            [34.411389785403735, 2.482547597265847],
            [34.41265191119141, 2.483599162309353],
            [34.41339101266783, 2.485034178018639],
            [34.41446121609, 2.48460228194114],
            [34.41491240122964, 2.483788163504414],
            [34.41648232935951, 2.483427531649887],
            [34.417171504269085, 2.482661019795204],
            [34.41681365857902, 2.481775998922993],
            [34.41598093019212, 2.481776896395678],
            [34.41476669988045, 2.481012436105022],
            [34.41481359103998, 2.480366275868378],
            [34.41562221133961, 2.480054311294396],
            [34.41683616047858, 2.480555532408195],
            [34.418074618353465, 2.48172677523662],
            [34.418099689434726, 2.482923248553335],
            [34.41731578268688, 2.48409667372822],
            [34.4184819522325, 2.484406506752119],
            [34.42000380342671, 2.483591230456508],
            [34.4206235035305, 2.484619556458705],
            [34.42125723981063, 2.484514424035708],
            [34.42277493719493, 2.482954079406041],
            [34.422486841195095, 2.480537472548167],
            [34.42386499068992, 2.478836945761041],
            [34.42481642784837, 2.478596609194641],
            [34.42676803217617, 2.479192745967728],
            [34.426982809479135, 2.479790766270293],
            [34.42724434588926, 2.479622970023511],
            [34.42705182165252, 2.47758913314791],
            [34.427621812581755, 2.476631317283331],
            [34.42678785080797, 2.475483578458074],
            [34.427238830233414, 2.474478028723342],
            [34.42959408175436, 2.474307971954466],
            [34.430736410012344, 2.474593883210924],
            [34.43155663654547, 2.474030647705447],
            [34.431817024010336, 2.472786008538856],
            [34.43134091870638, 2.472547218128794],
            [34.430104084985544, 2.472883575250255],
            [34.43007911182064, 2.471782834182044],
            [34.43205119414368, 2.469291980771223],
            [34.433644223349376, 2.468333056808604],
            [34.43490526487052, 2.46837954098049],
            [34.435117616722195, 2.466728146563938],
            [34.433570627971434, 2.466251232148058],
            [34.43404520703772, 2.465078147479526],
            [34.43504360093268, 2.464263448946601],
            [34.43588805053741, 2.464106986865456],
            [34.43662433669376, 2.462933628369234],
            [34.43910006037911, 2.464199223155528],
            [34.44116848971128, 2.462832971782446],
            [34.44209625177042, 2.462712304849309],
            [34.44304577012743, 2.460701170037769],
            [34.44264063083261, 2.460079431319417],
            [34.44171297387636, 2.460295813711895],
            [34.44064360319248, 2.461469533525566],
            [34.43992927994652, 2.460943846897576],
            [34.44052235668026, 2.459339914983488],
            [34.44168669456104, 2.457974649457756],
            [34.44587118100344, 2.455313877059265],
            [34.447775959748746, 2.456651875979872],
            [34.45280706432897, 2.455868665230101],
            [34.45963070405807, 2.451673488784578],
            [34.46092368697575, 2.448309951771731],
            [34.46291915693718, 2.445531934470151],
            [34.46353694901933, 2.444813366661751],
            [34.46612924797742, 2.443925112083464],
            [34.467816470930565, 2.442128548334813],
            [34.467790736892645, 2.440333859754901],
            [34.4662203057062, 2.440144143371027],
            [34.46688554859827, 2.439305887298527],
            [34.46998960519732, 2.438668338129972],
            [34.47165806054757, 2.44149019006253],
            [34.47351576218208, 2.443306776064406],
            [34.47432463580663, 2.443281961124855],
            [34.47482257376524, 2.441749922001685],
            [34.47425007024816, 2.440362643496511],
            [34.47439224301492, 2.43983604030942],
            [34.48001466183428, 2.436013073988664],
            [34.47994136739194, 2.43424236934722],
            [34.481961337106114, 2.432182216713214],
            [34.48293661734885, 2.432037561169723],
            [34.483101497729336, 2.43052982720703],
            [34.484051273902814, 2.428829786965065],
            [34.48512175400609, 2.428732888379037],
            [34.48758519053501, 2.429723231019314],
            [34.48891700852074, 2.429291024462398],
            [34.49222396938965, 2.429335212368609],
            [34.49488800780634, 2.428853657992259],
            [34.49849799737003, 2.42322626505606],
            [34.500209726364126, 2.422147544072863],
            [34.50127523249567, 2.422010606065588],
            [34.502401133262076, 2.422562110511074],
            [34.5032118915521, 2.422113725793875],
            [34.5036015950954, 2.419533729673016],
            [34.50488395633316, 2.419584938255454],
            [34.50572274924653, 2.420821139918206],
            [34.50629833667998, 2.420688886798226],
            [34.506190913443376, 2.418214729257189],
            [34.5065826399927, 2.417477263168739],
            [34.50839162509102, 2.420449634763809],
            [34.50980663964847, 2.422132673184841],
            [34.51118119408551, 2.422723370149143],
            [34.51126043537504, 2.423381337168137],
            [34.51222961515869, 2.424196225657153],
            [34.51408758089788, 2.424141486439246],
            [34.51652269444422, 2.425349546089042],
            [34.51888227045493, 2.429216212684279],
            [34.520558116245, 2.430109257989553],
            [34.52155444670975, 2.431792725064077],
            [34.53405326690814, 2.434344854503746],
            [34.54739085127383, 2.438106642845713],
            [34.55920913745735, 2.440580288268529],
            [34.565987166126234, 2.440756613886076],
            [34.565883076537624, 2.441256841880611],
            [34.56665568158089, 2.441795529343617],
            [34.56589732561464, 2.442270195273744],
            [34.56600252282601, 2.442717538473955],
            [34.56757264678862, 2.442689375852133],
            [34.56779661026367, 2.442279192704331],
            [34.56772703484661, 2.444247808422218],
            [34.56966873345175, 2.444082759429134],
            [34.569101497655474, 2.443350986845702],
            [34.57063920321613, 2.443674706470604],
            [34.57181042758189, 2.444779911540333],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 808,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "NGOLERIET",
        Population: 17331,
        Key: "NAPAKNGOLERIET",
        Dist2: "Napak",
        "Sub Country": "Ngoleriet",
        id2_original: "NapakNgoleriet",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.7209977557097, 1.990708160499606],
            [34.723230990862234, 1.995569940450366],
            [34.72624927452132, 2.000411719021753],
            [34.7285588431168, 2.006531906698321],
            [34.72966557652997, 2.016315085301809],
            [34.731125479902175, 2.020546877347789],
            [34.731021117225715, 2.026396796146876],
            [34.73178808803552, 2.034757077219465],
            [34.73168163767437, 2.037891488047622],
            [34.73319083250451, 2.041668577787821],
            [34.730920967647975, 2.047618606177407],
            [34.72762959165091, 2.053116140611917],
            [34.7266882237085, 2.05685040835163],
            [34.72628277898646, 2.060428049496656],
            [34.72570477598321, 2.062367174565974],
            [34.72455630953686, 2.064139992354254],
            [34.724667633258456, 2.066269106943382],
            [34.72546720572657, 2.068899239012793],
            [34.72550527273503, 2.071138304590993],
            [34.70613028292301, 2.062682208933986],
            [34.70107997415863, 2.061029648197322],
            [34.69335120362734, 2.059825103966503],
            [34.68808604479646, 2.058364310078269],
            [34.6776933077137, 2.053588123920659],
            [34.66940785838736, 2.048412827279916],
            [34.65999240029885, 2.043179897597244],
            [34.64852002928011, 2.034338061856787],
            [34.641703111644254, 2.030215314401095],
            [34.64032993971444, 2.028327858318855],
            [34.64047612166231, 2.027394428922735],
            [34.63867079180885, 2.026560577801265],
            [34.63523021911785, 2.023935460270684],
            [34.634793748382535, 2.022919451004611],
            [34.633086861307824, 2.021200117350049],
            [34.62928516587259, 2.01972414412156],
            [34.62643129097847, 2.019322992036283],
            [34.623320614694116, 2.017582454908228],
            [34.62186888060112, 2.017657072993005],
            [34.619853608177564, 2.018917148170491],
            [34.616859517047374, 2.01782238082075],
            [34.616007048182084, 2.01669950480149],
            [34.61493848328703, 2.016103417036101],
            [34.61477843943598, 2.01433317317066],
            [34.61425856192319, 2.013353187734568],
            [34.61471446591305, 2.012323453165818],
            [34.61387630361697, 2.010542569405246],
            [34.61294893951151, 2.010376881983158],
            [34.61190532262851, 2.009469713512809],
            [34.609406348746944, 2.009618126275638],
            [34.60774302098036, 2.008999271341749],
            [34.60669498887772, 2.009288421066159],
            [34.60496256180114, 2.008047603554107],
            [34.604413524075895, 2.008527196901368],
            [34.60291560849248, 2.008219054854472],
            [34.601319056094205, 2.008844259065369],
            [34.59965466023073, 2.00851251398125],
            [34.59774973685667, 2.00887510800432],
            [34.59701369504212, 2.008445846070746],
            [34.5961323085095, 2.008710747307182],
            [34.59589534910725, 2.008448011476123],
            [34.59553673266267, 2.008903318416711],
            [34.594256945098195, 2.007518034241945],
            [34.59214149704575, 2.006900034979767],
            [34.59140323729075, 2.007068944830131],
            [34.58987410255623, 2.005552542321668],
            [34.58854272923657, 2.005244069336624],
            [34.58778528146709, 2.004168814727719],
            [34.58755434077722, 2.002279037337539],
            [34.58665208727889, 2.001754384127119],
            [34.58639272569008, 2.001108861628432],
            [34.58406526714573, 1.999916998598157],
            [34.58270665331339, 2.000541713105023],
            [34.58218537981864, 1.999944533145572],
            [34.57990275888505, 1.999494310469041],
            [34.57926260504055, 1.998873444297764],
            [34.57851310736135, 1.998862917960069],
            [34.5768138371019, 1.997944740051293],
            [34.5723400985279, 1.998112029453749],
            [34.5712011668, 1.997673988106739],
            [34.56839268557382, 1.995283212286257],
            [34.56832955646723, 1.993043223655711],
            [34.567417064869616, 1.990616723201835],
            [34.56838310414298, 1.987512669521563],
            [34.56780387943095, 1.986938692323313],
            [34.56780307094719, 1.985976714268692],
            [34.56853508651264, 1.984412650897787],
            [34.56781303775526, 1.982870683940317],
            [34.56835903378495, 1.9811706248734],
            [34.568040072570284, 1.977917613550807],
            [34.568441084106375, 1.975735574711807],
            [34.56931605127793, 1.974220568159838],
            [34.56849243180803, 1.971685881453062],
            [34.554797015227, 1.971637453218178],
            [34.537867402213415, 1.970640653815298],
            [34.536045075336474, 1.97184841077204],
            [34.536605656413116, 1.974095404765639],
            [34.53773184464042, 1.984020877324728],
            [34.53724786200975, 1.985626038553761],
            [34.53485590802123, 1.983976475978747],
            [34.534405732587956, 1.98445084051626],
            [34.53345747816056, 1.984042072936191],
            [34.53234404511198, 1.985656676053579],
            [34.53189348969136, 1.985130911484337],
            [34.531348548283795, 1.985723952682925],
            [34.53028174408668, 1.985243260984776],
            [34.53006813189865, 1.984504176521237],
            [34.52844451954907, 1.984604550624319],
            [34.52072895694743, 1.989651837606455],
            [34.51382004284333, 1.994859571327834],
            [34.510695502859164, 1.996676883892508],
            [34.49548811026391, 1.99983590769252],
            [34.48220620797111, 2.004988968442634],
            [34.476448185764625, 2.005268488549369],
            [34.47224197626205, 2.006620194649905],
            [34.43884930554903, 2.006465547538042],
            [34.41522240444429, 2.005112454262408],
            [34.41150240719091, 2.008065728504179],
            [34.395660592900946, 1.989995569085835],
            [34.308958971906975, 1.92439504605623],
            [34.24988649723846, 1.891019851318985],
            [34.2227803240203, 1.880048403776879],
            [34.222483819789396, 1.802698982949471],
            [34.22229123895878, 1.747978711084047],
            [34.22263801021803, 1.746964011472728],
            [34.22265984556765, 1.719664856341619],
            [34.222213104393674, 1.640185995521553],
            [34.22900191643924, 1.640082106615967],
            [34.229070110247406, 1.637204170950427],
            [34.23993191523215, 1.636796189772819],
            [34.24087434857652, 1.637130024641954],
            [34.24267851421334, 1.636786399437552],
            [34.24656711446578, 1.637574571108833],
            [34.24963415778019, 1.636339688738925],
            [34.25371762687225, 1.637336649788101],
            [34.257211883782965, 1.637143069141248],
            [34.25870894057699, 1.636304923746847],
            [34.260634524304265, 1.636471127808857],
            [34.2611818929597, 1.637499344582072],
            [34.26137339940526, 1.639628085563816],
            [34.2641671383793, 1.640595057136875],
            [34.26616362433532, 1.64013929957113],
            [34.26773308983282, 1.641023332935464],
            [34.26927779057457, 1.640352572807573],
            [34.271786773485026, 1.642132991107023],
            [34.27311933347916, 1.644284904025651],
            [34.274997779010214, 1.645096965263264],
            [34.27540264970877, 1.646292683764163],
            [34.276043814157966, 1.6452637217288],
            [34.277470292116774, 1.645573758749093],
            [34.27865831587665, 1.644759723124093],
            [34.279348612781995, 1.6462183734689],
            [34.28164426737204, 1.648931754329332],
            [34.28261907599923, 1.649218145241531],
            [34.283664765295605, 1.64883476477772],
            [34.28475906063536, 1.650125706968673],
            [34.28487849883891, 1.65101064821585],
            [34.28601915623046, 1.650459756013412],
            [34.28735097241957, 1.651439583560559],
            [34.287207276110095, 1.649789231626096],
            [34.288206064365475, 1.650410472432855],
            [34.28984642221025, 1.650648602314002],
            [34.29048783818774, 1.65002626339759],
            [34.29128411563538, 1.649942032769174],
            [34.29394712727769, 1.650944905365052],
            [34.29542177829191, 1.652235575905506],
            [34.298488881793425, 1.653214258599624],
            [34.29929765570496, 1.654074824761304],
            [34.29996448142858, 1.655940089727528],
            [34.30133146486442, 1.656166428992836],
            [34.302235161955416, 1.656787729761668],
            [34.303401950440275, 1.659848643249428],
            [34.30499601360689, 1.661976409400277],
            [34.30726705974805, 1.663326332089893],
            [34.31176000520112, 1.663658185249212],
            [34.3124496220818, 1.664040426955101],
            [34.31373448961919, 1.665905278448196],
            [34.31468568692748, 1.666430858042918],
            [34.31584075958443, 1.669695062280279],
            [34.316792547984136, 1.671105654823772],
            [34.316129281385685, 1.674574393846601],
            [34.31638129834876, 1.67819801247346],
            [34.316999747997684, 1.678771649566485],
            [34.31768913041809, 1.678795104388362],
            [34.31906681817884, 1.677263315634002],
            [34.3205657820962, 1.679319365961656],
            [34.32352483174378, 1.678635641944147],
            [34.32576061631507, 1.680547629815389],
            [34.32702063914668, 1.680785966169712],
            [34.32699832499501, 1.682914787145953],
            [34.32792618586883, 1.684086191085078],
            [34.32747502498368, 1.684804086496579],
            [34.327464261369954, 1.686466461024356],
            [34.32630029449338, 1.68766323371552],
            [34.326872085646464, 1.689552458418581],
            [34.32884645597848, 1.691536389802057],
            [34.32912170786638, 1.694298853180552],
            [34.328647127901796, 1.695519067580891],
            [34.32895648522776, 1.696021145979092],
            [34.32755471543086, 1.697098498232351],
            [34.32719870859218, 1.697911996753619],
            [34.32773434884327, 1.699047785507922],
            [34.327592368316, 1.70000464959427],
            [34.331183335155224, 1.702178788102913],
            [34.332754137345866, 1.70490448090907],
            [34.333538610032356, 1.704951762556367],
            [34.33416921927696, 1.705920050605669],
            [34.33540808408866, 1.709889756147217],
            [34.33488672615229, 1.712210271339192],
            [34.336493222900735, 1.714971787410721],
            [34.3360905144471, 1.717005202589115],
            [34.336234098467166, 1.718368497327935],
            [34.337721112096304, 1.720221165813979],
            [34.3386266264791, 1.72335392966038],
            [34.342254007426696, 1.726520616685027],
            [34.34177983978881, 1.728314884577595],
            [34.342184981778594, 1.729773654538945],
            [34.34192494196171, 1.73183088071784],
            [34.343556490926844, 1.736338451612729],
            [34.34550702356448, 1.738107057147371],
            [34.34864477327489, 1.737961271083085],
            [34.350165716272336, 1.737338281399602],
            [34.35445840568902, 1.74002605586789],
            [34.355600671064984, 1.741747387988759],
            [34.356623416490656, 1.742535965121122],
            [34.36081981728869, 1.744836821351462],
            [34.36265953015963, 1.747344384268145],
            [34.364857152501024, 1.752217219578813],
            [34.364872379843426, 1.753579188783599],
            [34.36530041449987, 1.754410386677427],
            [34.36786552774253, 1.75521135391358],
            [34.36923572535044, 1.758565108166366],
            [34.371331610791, 1.760642347370825],
            [34.37389741663472, 1.762389512614404],
            [34.375496292974624, 1.766689276461183],
            [34.37546819906243, 1.767234090742174],
            [34.37435774303073, 1.768381845365639],
            [34.374887007938256, 1.771234425328903],
            [34.3764266242155, 1.772437538402756],
            [34.3764841595128, 1.773182999599505],
            [34.37594333328756, 1.773957573511447],
            [34.376485411764314, 1.774874707787565],
            [34.37836614979596, 1.774959310036552],
            [34.37893657730642, 1.775675719183157],
            [34.37792574354139, 1.776665695197847],
            [34.37761308221183, 1.777726832394209],
            [34.37828870783195, 1.783639384643025],
            [34.37897927692682, 1.784136402480715],
            [34.38029581367125, 1.783373391253359],
            [34.380638102337215, 1.783831901786053],
            [34.38032560450103, 1.785093749506174],
            [34.38053656576066, 1.785796127150575],
            [34.38113306238069, 1.786113714103941],
            [34.38237754435784, 1.785493626307607],
            [34.38311879729938, 1.786009181251578],
            [34.38306344670482, 1.788188370616961],
            [34.383447818746916, 1.788522973733957],
            [34.384023248975204, 1.788227828755111],
            [34.384837071418666, 1.788415240982627],
            [34.38636861902801, 1.787841777176355],
            [34.38688279673035, 1.789533088510145],
            [34.38773736855171, 1.789159690991457],
            [34.388164016209366, 1.788127133553023],
            [34.39166942390767, 1.78881260928895],
            [34.392776963109675, 1.789625213398018],
            [34.395687471392556, 1.789153613259723],
            [34.39742492544147, 1.78817740932452],
            [34.39897829223075, 1.788706658841557],
            [34.40074493344156, 1.788647952911849],
            [34.40299718952189, 1.79016587361422],
            [34.40285583242543, 1.791628291745275],
            [34.40542071120778, 1.792085074498607],
            [34.4063339960178, 1.793976764278148],
            [34.40790141515311, 1.794233604989955],
            [34.4089649674489, 1.796478781886488],
            [34.409649554662295, 1.796621738646067],
            [34.41112274411754, 1.796066148693216],
            [34.41217361130322, 1.797657951921563],
            [34.413146409500804, 1.797813501259075],
            [34.41385917416973, 1.797268271331645],
            [34.41474258191172, 1.79735359443968],
            [34.41480489894129, 1.798315831557286],
            [34.41522802699966, 1.798700829517617],
            [34.41605438453458, 1.798700183947185],
            [34.41759195534794, 1.797208007866222],
            [34.416565493591904, 1.796377307783679],
            [34.416977175316916, 1.795517151661859],
            [34.417818741329604, 1.795688185021273],
            [34.418872713991206, 1.795257272723515],
            [34.42022942968335, 1.796410996008424],
            [34.42045992930042, 1.800237827041474],
            [34.41894042540406, 1.813027178094885],
            [34.41881124317463, 1.818598947100458],
            [34.42073163014799, 1.823859102834708],
            [34.42094792470546, 1.827151195796507],
            [34.426042722534284, 1.844984070873222],
            [34.42680996463532, 1.84951427743435],
            [34.43226483597611, 1.865922083317051],
            [34.43598243562601, 1.866312704274515],
            [34.44695418182512, 1.870300608625763],
            [34.449029352115204, 1.871512352889652],
            [34.45593028199304, 1.87776030327458],
            [34.46127377571334, 1.879807802815536],
            [34.46564432031907, 1.879804111828815],
            [34.475065904019516, 1.880577826332205],
            [34.484100043439604, 1.88262208229802],
            [34.49294209340755, 1.887206964800823],
            [34.50139862238815, 1.895212025977576],
            [34.506965374406015, 1.894064182892306],
            [34.510814354462845, 1.899705619735713],
            [34.513500609114814, 1.901325184021282],
            [34.51751436894085, 1.902874230217218],
            [34.5181332246283, 1.904659162609741],
            [34.52105930879989, 1.907598103195712],
            [34.5217714796824, 1.908789858479579],
            [34.52220906971857, 1.912207653395629],
            [34.524462889765815, 1.914391681356992],
            [34.52509454285278, 1.913874415679196],
            [34.526358761715066, 1.913873282637703],
            [34.52971736403472, 1.914466461172522],
            [34.53216519143724, 1.912675681617923],
            [34.533745035171236, 1.912197306077281],
            [34.53394157577559, 1.911084240413552],
            [34.53528526050625, 1.911599728360391],
            [34.5364321890368, 1.912989806335704],
            [34.53738034824277, 1.912988950718361],
            [34.537578379152215, 1.913545215025112],
            [34.53848706458799, 1.913584139765332],
            [34.539277941364126, 1.914418092348148],
            [34.54180871291178, 1.914977149289325],
            [34.546297589894934, 1.916954956066753],
            [34.54911812561393, 1.913421725147501],
            [34.555117561968146, 1.91937775718689],
            [34.55546323189285, 1.920219949748703],
            [34.559541081124515, 1.923404084092726],
            [34.56001551915529, 1.924525240873705],
            [34.564390010060066, 1.928674978872396],
            [34.56759118352449, 1.932522133242706],
            [34.56922697523268, 1.933552887744044],
            [34.570661814710135, 1.935904375245588],
            [34.58084432445686, 1.942745203977339],
            [34.583570969160625, 1.945209191604402],
            [34.586487727921245, 1.948912187955539],
            [34.58750700674829, 1.94917835830915],
            [34.59350249231187, 1.946512543663566],
            [34.594284702142176, 1.946682475066812],
            [34.59608687441741, 1.948833028413271],
            [34.59721419452196, 1.952564267669653],
            [34.598708296756996, 1.954784966107737],
            [34.60008451128071, 1.958529135588327],
            [34.59981427828029, 1.964278562681853],
            [34.60085787450206, 1.966044962099703],
            [34.602588456439044, 1.966909346206372],
            [34.6045462016501, 1.972596565789738],
            [34.60824554304186, 1.977040838608558],
            [34.61011819803259, 1.977524817665463],
            [34.61082952000717, 1.978170669004538],
            [34.614752444886605, 1.978770253020649],
            [34.61508441280828, 1.979128798326744],
            [34.615132826612225, 1.981510156515125],
            [34.61451675570214, 1.981936225798495],
            [34.61454076856802, 1.982674483658444],
            [34.61783621213667, 1.984735874664348],
            [34.61902207904155, 1.986526636807281],
            [34.61999405977222, 1.987006870266699],
            [34.622044188625445, 1.986812906833853],
            [34.62311154528644, 1.988603176540202],
            [34.62391750657284, 1.988796990732206],
            [34.62470009279722, 1.989776481809272],
            [34.6257664415485, 1.989257012844847],
            [34.62782907225554, 1.990551323117926],
            [34.627782024789155, 1.99136071215456],
            [34.62650245282035, 1.992117431183469],
            [34.6278311572453, 1.995289821673651],
            [34.62844779050073, 1.996197191913609],
            [34.6314879499336, 1.99813522780679],
            [34.632077079469994, 1.999689282397055],
            [34.63321673613835, 2.000357008151561],
            [34.63428747944797, 2.000354913659141],
            [34.634575739839505, 1.999612618375481],
            [34.63636092497269, 1.999441653662258],
            [34.63699787632324, 1.997090823981693],
            [34.63473947935962, 1.993544259278304],
            [34.63043040916369, 1.977084741872173],
            [34.630464073528984, 1.972715489705697],
            [34.630960615505636, 1.969907780902424],
            [34.63204994495851, 1.967745436153463],
            [34.63533082503979, 1.96362768462692],
            [34.638032536104554, 1.963043528135062],
            [34.63995248739499, 1.963384801593375],
            [34.641777891001766, 1.964297163041651],
            [34.64682808927336, 1.968508725182915],
            [34.64743453922673, 1.973213931505009],
            [34.64847906789976, 1.976956601653402],
            [34.64824270677546, 1.978455731166929],
            [34.64884832488888, 1.981232230419828],
            [34.64991533749515, 1.982212868851225],
            [34.64979766807439, 1.98409347783664],
            [34.65029594020629, 1.985286075028624],
            [34.651671238448394, 1.986672760520827],
            [34.652016393638434, 1.989972039339594],
            [34.65253802915424, 1.990426584707496],
            [34.6536538642979, 1.994502861787387],
            [34.65434152105465, 1.995196203945341],
            [34.654033898375474, 1.996290264638492],
            [34.65587211285655, 1.999741688718573],
            [34.65711276262072, 2.004975692288984],
            [34.65848267276773, 2.007748413917454],
            [34.66021481956992, 2.009060926120591],
            [34.663120064623556, 2.008409179616601],
            [34.66354668892505, 2.008862933437682],
            [34.66643604457792, 2.009299836122152],
            [34.66736803680373, 2.008197394513189],
            [34.66946338235675, 2.007786511421912],
            [34.67010853981742, 2.007043530023776],
            [34.67163046736838, 2.007279772165515],
            [34.67295847739562, 2.008497361530722],
            [34.675076567393354, 2.008373532123155],
            [34.676367369201515, 2.006744012519367],
            [34.67741429098647, 2.006741933297131],
            [34.67797558442711, 2.006154632805222],
            [34.68051343200426, 2.001842956030727],
            [34.68134752493209, 2.00148240287003],
            [34.682345725689274, 2.001791464601001],
            [34.68401773118153, 2.000017633910255],
            [34.68437463633549, 2.000016922877967],
            [34.6850574251217, 2.002001407417802],
            [34.6881302877225, 2.004304124183653],
            [34.691186180249275, 2.008006516502729],
            [34.692256896609486, 2.008004380722967],
            [34.69447501940397, 2.006540491122206],
            [34.695361805709744, 2.004768224992725],
            [34.69952941011299, 2.000465260098706],
            [34.70077345371233, 1.998596587678352],
            [34.70571374131226, 1.996402520908021],
            [34.70828782602967, 1.994679718187531],
            [34.70931384761122, 1.994907992598663],
            [34.71008760878625, 1.993668708370216],
            [34.71307399416791, 1.993871989863716],
            [34.71439556596951, 1.993343104565481],
            [34.71588953615221, 1.994201588645768],
            [34.7183961169676, 1.99335036753845],
            [34.71976306357252, 1.992615021438456],
            [34.7209977557097, 1.990708160499606],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 809,
        District: "NAKAPIRIPIRIT",
        County: "PIAN",
        Subcounty: "LOLACHAT",
        Population: 32072,
        Key: "NAKAPIRIPIRITLOLACHAT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.793597043960226, 2.146149529488451],
            [34.79191275041322, 2.148199224321087],
            [34.79192532862381, 2.1505598072496],
            [34.79083622734301, 2.150316172589156],
            [34.79101673751116, 2.152248375062606],
            [34.78854716369223, 2.153238031877226],
            [34.78847270143999, 2.153952987943482],
            [34.787567916489216, 2.154830891464623],
            [34.78787344699208, 2.155380750023968],
            [34.78744458588554, 2.155855583928578],
            [34.78758319593388, 2.156619236954798],
            [34.78684455169994, 2.157450246906393],
            [34.78654981086195, 2.159642466918668],
            [34.785827111724295, 2.159603254581931],
            [34.78510418890613, 2.162127246197015],
            [34.785242241100704, 2.163010120811285],
            [34.78456773208647, 2.165319745847424],
            [34.78467859676893, 2.166941645052031],
            [34.78303179980019, 2.169365868915699],
            [34.781546064473694, 2.170300620201833],
            [34.780551528842864, 2.170105129010151],
            [34.7799521665971, 2.171556731475088],
            [34.77989780145439, 2.17303480481282],
            [34.77856661767928, 2.173862996059368],
            [34.77685846577663, 2.174212517724292],
            [34.77656170642422, 2.17683392134642],
            [34.775731051348984, 2.177068404521172],
            [34.77569982411308, 2.178665793809314],
            [34.77409018505775, 2.18074446081267],
            [34.77295275531297, 2.180691353173382],
            [34.770624212502064, 2.181920147954688],
            [34.76831564732477, 2.183935882505748],
            [34.76653569667474, 2.184428120300914],
            [34.76249243617478, 2.187389350638583],
            [34.76147979320277, 2.18851710830549],
            [34.75927556285412, 2.193537699950622],
            [34.753955968811965, 2.198245398301816],
            [34.75233482503281, 2.200240572577836],
            [34.74773175151577, 2.202814208847989],
            [34.74271457711064, 2.208542968121055],
            [34.7381582869553, 2.211758628814274],
            [34.724707195063566, 2.216943128931653],
            [34.72012507025897, 2.217323701651315],
            [34.71793234014261, 2.218309291445671],
            [34.71635706074859, 2.219652443459325],
            [34.71166265102504, 2.221504652349775],
            [34.71060860919315, 2.22349268785219],
            [34.710216691302676, 2.226675588210026],
            [34.70909773541174, 2.230206958840816],
            [34.70908766170415, 2.233078019547968],
            [34.708027325377074, 2.2368604924192],
            [34.70707915449301, 2.239195228218882],
            [34.705622414088914, 2.240657777177946],
            [34.70389458548827, 2.244776622125473],
            [34.701852929544835, 2.247280139084388],
            [34.70201468648312, 2.250565582473557],
            [34.69918850575089, 2.254253646905754],
            [34.69264868244758, 2.265518984068593],
            [34.68591567015425, 2.274344025543353],
            [34.68058155125227, 2.279363033963552],
            [34.67954876625497, 2.281003257191107],
            [34.678526155576556, 2.281171950987896],
            [34.67828896440891, 2.281746484366354],
            [34.67676745816782, 2.282442159762772],
            [34.67688844327027, 2.284212629539578],
            [34.675367850615785, 2.285697900738853],
            [34.674989025670584, 2.287205691176097],
            [34.67534714804175, 2.288353849891072],
            [34.67750104758165, 2.289416071633626],
            [34.67826451675847, 2.291401132106242],
            [34.67800340435315, 2.291856044963388],
            [34.678290231033486, 2.293052076823423],
            [34.676650844267506, 2.294657130992042],
            [34.676701485893346, 2.297289063676078],
            [34.675822373895045, 2.298127555598253],
            [34.67432422205469, 2.298464309927737],
            [34.673656334522406, 2.29686196807464],
            [34.67260972714783, 2.296863202265792],
            [34.67194591078042, 2.298754244862418],
            [34.66880788079565, 2.300289280495845],
            [34.66861825362569, 2.300863760427879],
            [34.66921378006518, 2.301640684513901],
            [34.6684779026423, 2.30289775326162],
            [34.6669796834283, 2.303186637115069],
            [34.666183879392825, 2.304084854735065],
            [34.66587585426842, 2.305114069432403],
            [34.666354228716806, 2.307386554041698],
            [34.66609470183797, 2.309205409593193],
            [34.666630832569176, 2.309819327625174],
            [34.66683507353219, 2.311764753797747],
            [34.6642449727516, 2.314040916833418],
            [34.66341123375999, 2.313013019971298],
            [34.662340215565855, 2.312487884226274],
            [34.660437634998054, 2.312801184890908],
            [34.66060562265113, 2.314069140424671],
            [34.66174674177677, 2.313517465334816],
            [34.66269857599056, 2.313827392655591],
            [34.66243756509488, 2.314378037200139],
            [34.66146270346709, 2.314714166555837],
            [34.65977554070105, 2.316175727798636],
            [34.65991914897563, 2.316941236157563],
            [34.66122812909189, 2.317537877801616],
            [34.661997482233836, 2.319176945947245],
            [34.661114780567665, 2.322323487199473],
            [34.65973600225213, 2.323066871445979],
            [34.65757088455098, 2.32263873612293],
            [34.65590799606058, 2.324530965095826],
            [34.65524226628161, 2.32479495206948],
            [34.653957257708704, 2.324365772491743],
            [34.652106325778156, 2.327838072206662],
            [34.65283385785206, 2.327556481680818],
            [34.65273946557694, 2.328202641576118],
            [34.651693437615705, 2.328730279304482],
            [34.6511825396625, 2.331547294467932],
            [34.64964105758438, 2.335568939102698],
            [34.644312563932715, 2.345660704188187],
            [34.6426855056457, 2.347708436070306],
            [34.64058820895188, 2.369648036416505],
            [34.64122931411227, 2.370352897036446],
            [34.64047251762139, 2.370364262669676],
            [34.64034236700809, 2.371301853939538],
            [34.63748706109771, 2.400796023015866],
            [34.6350623868733, 2.432060451165982],
            [34.635254196051086, 2.43330445600144],
            [34.63382624395694, 2.432803710781258],
            [34.63356482342948, 2.433019384058113],
            [34.6338513033601, 2.433856504213063],
            [34.63304201022231, 2.433474640944018],
            [34.63282977694823, 2.435030202303545],
            [34.632020942849586, 2.43503118866061],
            [34.6311664590631, 2.436635391992922],
            [34.62871673801197, 2.437116926537848],
            [34.62832543906073, 2.438134335272481],
            [34.627921049859154, 2.43815875720116],
            [34.62763488523717, 2.437584837721023],
            [34.626802544922484, 2.437825125130216],
            [34.626302223733404, 2.4372036073508],
            [34.62582761142946, 2.438185224536564],
            [34.624781140598785, 2.438401851893818],
            [34.623900239156455, 2.43782865321168],
            [34.62230863557709, 2.43892061506893],
            [34.62180760022739, 2.438525100438356],
            [34.62240130578179, 2.437662976076146],
            [34.622186804261645, 2.43732825251914],
            [34.62090349080965, 2.438430487588967],
            [34.620070057245265, 2.437761511064643],
            [34.61935677335009, 2.438097368956592],
            [34.61776279642175, 2.438027518161514],
            [34.61418066361502, 2.436512425091358],
            [34.613253845685264, 2.437327092048246],
            [34.612968171543436, 2.437159938459015],
            [34.61278044700526, 2.439337604993778],
            [34.61071112474768, 2.439651165873556],
            [34.609640253877245, 2.439365319832717],
            [34.60895086696529, 2.439796854520422],
            [34.607950960307384, 2.439175926412716],
            [34.607878401585225, 2.43817104490177],
            [34.60652179818252, 2.437670181225291],
            [34.60430973182966, 2.437983903146599],
            [34.6014776824037, 2.437078035948054],
            [34.600764311371975, 2.437342097394327],
            [34.6002640719296, 2.436792350013638],
            [34.59909948521546, 2.437726936582262],
            [34.59645837449979, 2.437347244571736],
            [34.59562675014235, 2.4382096419768],
            [34.594555451673855, 2.437564863804093],
            [34.59365264840657, 2.43859485427741],
            [34.5930102990795, 2.438571689756631],
            [34.59286685519662, 2.437973653671732],
            [34.59138438165294, 2.438384670117435],
            [34.59092869146212, 2.43818279051102],
            [34.58532831550316, 2.41979827292354],
            [34.53165699920966, 2.247975034839553],
            [34.53097491649927, 2.247699145600798],
            [34.52483267047272, 2.226602307816548],
            [34.51116261333218, 2.183655383505846],
            [34.510536634902884, 2.180154901459229],
            [34.54040364629779, 2.162720928425763],
            [34.57518980434078, 2.187236834484077],
            [34.592229016310604, 2.19707230562268],
            [34.60124365600083, 2.201659912110228],
            [34.6046662120805, 2.202849273806402],
            [34.60869841521762, 2.203259769750882],
            [34.6136724642009, 2.203153915128524],
            [34.62236252281604, 2.205349325206492],
            [34.64391416290082, 2.207769385645928],
            [34.66218535499403, 2.21235054548107],
            [34.66290163027907, 2.2118333416888],
            [34.66694908860636, 2.211274619777931],
            [34.669054699208154, 2.208040233990647],
            [34.67173886348048, 2.20606076107675],
            [34.67291365864946, 2.203593950888016],
            [34.67494496330591, 2.201173202341397],
            [34.67544703351484, 2.197164593521283],
            [34.676192892118834, 2.194866165344888],
            [34.67712631715751, 2.193356891166869],
            [34.67984702938715, 2.191126133407938],
            [34.68187607208571, 2.185989835884286],
            [34.68168968963056, 2.184865722621959],
            [34.679131074800665, 2.181664983353905],
            [34.67911008925731, 2.180875481252004],
            [34.68271007608032, 2.165603395499911],
            [34.682711866422665, 2.161763307758241],
            [34.68302454212532, 2.160829555705323],
            [34.68374286197595, 2.159583931181505],
            [34.69420493013403, 2.148059103029829],
            [34.703904691535215, 2.144277656385615],
            [34.71090718583739, 2.139059352361265],
            [34.72022030964538, 2.133118493984568],
            [34.72980047024798, 2.129007352639848],
            [34.739031404495705, 2.126057284637815],
            [34.74482895886286, 2.125052288385782],
            [34.74689876800733, 2.125143667703782],
            [34.747135358202016, 2.125525967371276],
            [34.74816115789969, 2.124782152335412],
            [34.74985049099544, 2.124802541741952],
            [34.75309295372526, 2.123435013692994],
            [34.75484780275133, 2.12322885095067],
            [34.7570502499441, 2.123597097624675],
            [34.75778621360522, 2.123338349522895],
            [34.7592627897091, 2.124334976755011],
            [34.76073492454221, 2.123769789639506],
            [34.763244790496586, 2.124282568252573],
            [34.76565307136535, 2.126225485200344],
            [34.76678888414262, 2.126612440952075],
            [34.76699630963328, 2.127853323747638],
            [34.76867824510267, 2.128028301717365],
            [34.774340193387815, 2.131071684831095],
            [34.7762405093028, 2.130174721306114],
            [34.77718401254065, 2.131133001817659],
            [34.776873418234544, 2.131656070040112],
            [34.77767562186808, 2.13242291746453],
            [34.777960362660316, 2.132352748376379],
            [34.778084281660526, 2.13120884079614],
            [34.77862813969983, 2.131473726007489],
            [34.78121316320243, 2.131128443327755],
            [34.782490276482314, 2.131706798707212],
            [34.783030641871804, 2.132710822009494],
            [34.783695264926344, 2.132499409900097],
            [34.78447523345998, 2.132956170472139],
            [34.786443674911155, 2.135194971814628],
            [34.78779200123684, 2.135749817824154],
            [34.788055287565136, 2.135202678496827],
            [34.78956905931165, 2.135853685187457],
            [34.79100768878129, 2.1373627105274],
            [34.790601069062895, 2.138147606749973],
            [34.792609287914836, 2.139492438922294],
            [34.79259378389133, 2.142782786298379],
            [34.79321728027555, 2.146266932340562],
            [34.79347708114054, 2.146458920239972],
            [34.793597043960226, 2.146149529488451],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 810,
        District: "NAKAPIRIPIRIT",
        County: "PIAN",
        Subcounty: "LORENGEDWAT",
        Population: 8156,
        Key: "NAKAPIRIPIRITLORENGEDWAT",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.69420493013403, 2.148059103029829],
            [34.68374286197595, 2.159583931181505],
            [34.68302454212532, 2.160829555705323],
            [34.682711866422665, 2.161763307758241],
            [34.68271007608032, 2.165603395499911],
            [34.67911008925731, 2.180875481252004],
            [34.679131074800665, 2.181664983353905],
            [34.68168968963056, 2.184865722621959],
            [34.68187607208571, 2.185989835884286],
            [34.67984702938715, 2.191126133407938],
            [34.67712631715751, 2.193356891166869],
            [34.676192892118834, 2.194866165344888],
            [34.67544703351484, 2.197164593521283],
            [34.67494496330591, 2.201173202341397],
            [34.67291365864946, 2.203593950888016],
            [34.67173886348048, 2.20606076107675],
            [34.669054699208154, 2.208040233990647],
            [34.66694908860636, 2.211274619777931],
            [34.66290163027907, 2.2118333416888],
            [34.66218535499403, 2.21235054548107],
            [34.64391416290082, 2.207769385645928],
            [34.62236252281604, 2.205349325206492],
            [34.6136724642009, 2.203153915128524],
            [34.60869841521762, 2.203259769750882],
            [34.6046662120805, 2.202849273806402],
            [34.60124365600083, 2.201659912110228],
            [34.592229016310604, 2.19707230562268],
            [34.57518980434078, 2.187236834484077],
            [34.54040364629779, 2.162720928425763],
            [34.510536634902884, 2.180154901459229],
            [34.50843374529806, 2.168395165287315],
            [34.50522349256108, 2.156733228718692],
            [34.50099456107168, 2.148988979535157],
            [34.48820569642763, 2.110065650846169],
            [34.48454744038372, 2.100857951950803],
            [34.47999313281018, 2.091908720531444],
            [34.47633947703884, 2.08746759527324],
            [34.461811898907875, 2.066771086726878],
            [34.44721027983454, 2.04738999713772],
            [34.43970904358156, 2.03845488262364],
            [34.438767103412296, 2.036675361627324],
            [34.433758880719004, 2.03317318259682],
            [34.43367994755161, 2.03226676212248],
            [34.41150240719091, 2.008065728504179],
            [34.41522240444429, 2.005112454262408],
            [34.43884930554903, 2.006465547538042],
            [34.47224197626205, 2.006620194649905],
            [34.476448185764625, 2.005268488549369],
            [34.48220620797111, 2.004988968442634],
            [34.49548811026391, 1.99983590769252],
            [34.510695502859164, 1.996676883892508],
            [34.51382004284333, 1.994859571327834],
            [34.52072895694743, 1.989651837606455],
            [34.52844451954907, 1.984604550624319],
            [34.53006813189865, 1.984504176521237],
            [34.53028174408668, 1.985243260984776],
            [34.531348548283795, 1.985723952682925],
            [34.53189348969136, 1.985130911484337],
            [34.53234404511198, 1.985656676053579],
            [34.53345747816056, 1.984042072936191],
            [34.534405732587956, 1.98445084051626],
            [34.53485590802123, 1.983976475978747],
            [34.53724786200975, 1.985626038553761],
            [34.53773184464042, 1.984020877324728],
            [34.536605656413116, 1.974095404765639],
            [34.536045075336474, 1.97184841077204],
            [34.537867402213415, 1.970640653815298],
            [34.554797015227, 1.971637453218178],
            [34.56849243180803, 1.971685881453062],
            [34.56931605127793, 1.974220568159838],
            [34.568441084106375, 1.975735574711807],
            [34.568040072570284, 1.977917613550807],
            [34.56835903378495, 1.9811706248734],
            [34.56781303775526, 1.982870683940317],
            [34.56853508651264, 1.984412650897787],
            [34.56780307094719, 1.985976714268692],
            [34.56780387943095, 1.986938692323313],
            [34.56838310414298, 1.987512669521563],
            [34.567417064869616, 1.990616723201835],
            [34.56832955646723, 1.993043223655711],
            [34.56839268557382, 1.995283212286257],
            [34.5712011668, 1.997673988106739],
            [34.5723400985279, 1.998112029453749],
            [34.5768138371019, 1.997944740051293],
            [34.57851310736135, 1.998862917960069],
            [34.57926260504055, 1.998873444297764],
            [34.57990275888505, 1.999494310469041],
            [34.58218537981864, 1.999944533145572],
            [34.58270665331339, 2.000541713105023],
            [34.58406526714573, 1.999916998598157],
            [34.58639272569008, 2.001108861628432],
            [34.58665208727889, 2.001754384127119],
            [34.58755434077722, 2.002279037337539],
            [34.58778528146709, 2.004168814727719],
            [34.58854272923657, 2.005244069336624],
            [34.58987410255623, 2.005552542321668],
            [34.59140323729075, 2.007068944830131],
            [34.59214149704575, 2.006900034979767],
            [34.594256945098195, 2.007518034241945],
            [34.59553673266267, 2.008903318416711],
            [34.59589534910725, 2.008448011476123],
            [34.5961323085095, 2.008710747307182],
            [34.59701369504212, 2.008445846070746],
            [34.59774973685667, 2.00887510800432],
            [34.59965466023073, 2.00851251398125],
            [34.601319056094205, 2.008844259065369],
            [34.60291560849248, 2.008219054854472],
            [34.604413524075895, 2.008527196901368],
            [34.60496256180114, 2.008047603554107],
            [34.60669498887772, 2.009288421066159],
            [34.60774302098036, 2.008999271341749],
            [34.609406348746944, 2.009618126275638],
            [34.61190532262851, 2.009469713512809],
            [34.61294893951151, 2.010376881983158],
            [34.61387630361697, 2.010542569405246],
            [34.61471446591305, 2.012323453165818],
            [34.61425856192319, 2.013353187734568],
            [34.61477843943598, 2.01433317317066],
            [34.61493848328703, 2.016103417036101],
            [34.616007048182084, 2.01669950480149],
            [34.616859517047374, 2.01782238082075],
            [34.619853608177564, 2.018917148170491],
            [34.62186888060112, 2.017657072993005],
            [34.623320614694116, 2.017582454908228],
            [34.62643129097847, 2.019322992036283],
            [34.62928516587259, 2.01972414412156],
            [34.633086861307824, 2.021200117350049],
            [34.634793748382535, 2.022919451004611],
            [34.63523021911785, 2.023935460270684],
            [34.63867079180885, 2.026560577801265],
            [34.64047612166231, 2.027394428922735],
            [34.64032993971444, 2.028327858318855],
            [34.641703111644254, 2.030215314401095],
            [34.64852002928011, 2.034338061856787],
            [34.65999240029885, 2.043179897597244],
            [34.66940785838736, 2.048412827279916],
            [34.6776933077137, 2.053588123920659],
            [34.68808604479646, 2.058364310078269],
            [34.69335120362734, 2.059825103966503],
            [34.70107997415863, 2.061029648197322],
            [34.70613028292301, 2.062682208933986],
            [34.72550527273503, 2.071138304590993],
            [34.7262810236784, 2.076733080168636],
            [34.726093405141455, 2.08261906233836],
            [34.7244250207581, 2.086725665232875],
            [34.71975441638959, 2.091986862271793],
            [34.716932864676046, 2.095844646339291],
            [34.71761723090389, 2.100759888639138],
            [34.714297504076455, 2.107525619677526],
            [34.71343072325208, 2.110374533555567],
            [34.7129219731707, 2.112911675745916],
            [34.713104970773855, 2.118306457643899],
            [34.711946775573, 2.122806816771059],
            [34.71019139204932, 2.124616816169136],
            [34.709041190057874, 2.126868187506017],
            [34.70702814725285, 2.134205481974725],
            [34.707518482769224, 2.136836268929701],
            [34.70613033053372, 2.139088147541371],
            [34.700123811861786, 2.141923785642333],
            [34.69690083269216, 2.144897225853923],
            [34.69420493013403, 2.148059103029829],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 811,
        District: "NAKAPIRIPIRIT",
        County: "PIAN",
        Subcounty: "NABILATUK",
        Population: 28181,
        Key: "NAKAPIRIPIRITNABILATUK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.7209977557097, 1.990708160499606],
            [34.71976306357252, 1.992615021438456],
            [34.7183961169676, 1.99335036753845],
            [34.71588953615221, 1.994201588645768],
            [34.71439556596951, 1.993343104565481],
            [34.71307399416791, 1.993871989863716],
            [34.71008760878625, 1.993668708370216],
            [34.70931384761122, 1.994907992598663],
            [34.70828782602967, 1.994679718187531],
            [34.70571374131226, 1.996402520908021],
            [34.70077345371233, 1.998596587678352],
            [34.69952941011299, 2.000465260098706],
            [34.695361805709744, 2.004768224992725],
            [34.69447501940397, 2.006540491122206],
            [34.692256896609486, 2.008004380722967],
            [34.691186180249275, 2.008006516502729],
            [34.6881302877225, 2.004304124183653],
            [34.6850574251217, 2.002001407417802],
            [34.68437463633549, 2.000016922877967],
            [34.68401773118153, 2.000017633910255],
            [34.682345725689274, 2.001791464601001],
            [34.68134752493209, 2.00148240287003],
            [34.68051343200426, 2.001842956030727],
            [34.67797558442711, 2.006154632805222],
            [34.67741429098647, 2.006741933297131],
            [34.676367369201515, 2.006744012519367],
            [34.675076567393354, 2.008373532123155],
            [34.67295847739562, 2.008497361530722],
            [34.67163046736838, 2.007279772165515],
            [34.67010853981742, 2.007043530023776],
            [34.66946338235675, 2.007786511421912],
            [34.66736803680373, 2.008197394513189],
            [34.66643604457792, 2.009299836122152],
            [34.66354668892505, 2.008862933437682],
            [34.663120064623556, 2.008409179616601],
            [34.66021481956992, 2.009060926120591],
            [34.65848267276773, 2.007748413917454],
            [34.65711276262072, 2.004975692288984],
            [34.65587211285655, 1.999741688718573],
            [34.654033898375474, 1.996290264638492],
            [34.65434152105465, 1.995196203945341],
            [34.6536538642979, 1.994502861787387],
            [34.65253802915424, 1.990426584707496],
            [34.652016393638434, 1.989972039339594],
            [34.651671238448394, 1.986672760520827],
            [34.65029594020629, 1.985286075028624],
            [34.64979766807439, 1.98409347783664],
            [34.64991533749515, 1.982212868851225],
            [34.64884832488888, 1.981232230419828],
            [34.64824270677546, 1.978455731166929],
            [34.64847906789976, 1.976956601653402],
            [34.64743453922673, 1.973213931505009],
            [34.64682808927336, 1.968508725182915],
            [34.641777891001766, 1.964297163041651],
            [34.63995248739499, 1.963384801593375],
            [34.638032536104554, 1.963043528135062],
            [34.63533082503979, 1.96362768462692],
            [34.63204994495851, 1.967745436153463],
            [34.630960615505636, 1.969907780902424],
            [34.630464073528984, 1.972715489705697],
            [34.63043040916369, 1.977084741872173],
            [34.63473947935962, 1.993544259278304],
            [34.63699787632324, 1.997090823981693],
            [34.63636092497269, 1.999441653662258],
            [34.634575739839505, 1.999612618375481],
            [34.63428747944797, 2.000354913659141],
            [34.63321673613835, 2.000357008151561],
            [34.632077079469994, 1.999689282397055],
            [34.6314879499336, 1.99813522780679],
            [34.62844779050073, 1.996197191913609],
            [34.6278311572453, 1.995289821673651],
            [34.62650245282035, 1.992117431183469],
            [34.627782024789155, 1.99136071215456],
            [34.62782907225554, 1.990551323117926],
            [34.6257664415485, 1.989257012844847],
            [34.62470009279722, 1.989776481809272],
            [34.62391750657284, 1.988796990732206],
            [34.62311154528644, 1.988603176540202],
            [34.622044188625445, 1.986812906833853],
            [34.61999405977222, 1.987006870266699],
            [34.61902207904155, 1.986526636807281],
            [34.61783621213667, 1.984735874664348],
            [34.61454076856802, 1.982674483658444],
            [34.61451675570214, 1.981936225798495],
            [34.615132826612225, 1.981510156515125],
            [34.61508441280828, 1.979128798326744],
            [34.614752444886605, 1.978770253020649],
            [34.61082952000717, 1.978170669004538],
            [34.61011819803259, 1.977524817665463],
            [34.60824554304186, 1.977040838608558],
            [34.6045462016501, 1.972596565789738],
            [34.602588456439044, 1.966909346206372],
            [34.60085787450206, 1.966044962099703],
            [34.59981427828029, 1.964278562681853],
            [34.60008451128071, 1.958529135588327],
            [34.598708296756996, 1.954784966107737],
            [34.59721419452196, 1.952564267669653],
            [34.59608687441741, 1.948833028413271],
            [34.594284702142176, 1.946682475066812],
            [34.59350249231187, 1.946512543663566],
            [34.58750700674829, 1.94917835830915],
            [34.586487727921245, 1.948912187955539],
            [34.583570969160625, 1.945209191604402],
            [34.58084432445686, 1.942745203977339],
            [34.570661814710135, 1.935904375245588],
            [34.56922697523268, 1.933552887744044],
            [34.56759118352449, 1.932522133242706],
            [34.564390010060066, 1.928674978872396],
            [34.56001551915529, 1.924525240873705],
            [34.559541081124515, 1.923404084092726],
            [34.55546323189285, 1.920219949748703],
            [34.555117561968146, 1.91937775718689],
            [34.54911812561393, 1.913421725147501],
            [34.551325842324175, 1.910234016885597],
            [34.55784270109552, 1.905238256652168],
            [34.558090808590485, 1.897144845804681],
            [34.55904812791739, 1.896758586194428],
            [34.55910390341508, 1.894760765266254],
            [34.55844132941772, 1.893974406726177],
            [34.55831844348011, 1.891129352875502],
            [34.557835732863865, 1.889616404964892],
            [34.5585070627403, 1.887426811448082],
            [34.56783043632571, 1.887249259683258],
            [34.56888115618766, 1.886484340576125],
            [34.57084453922547, 1.882580483121754],
            [34.57256533311908, 1.884376380958002],
            [34.57806461357428, 1.887881494790303],
            [34.58408951267523, 1.88762657186377],
            [34.60137399705698, 1.871468013253161],
            [34.601967124994694, 1.869843727291101],
            [34.602859921029676, 1.870825696682506],
            [34.603159477735915, 1.873303763946612],
            [34.605919780516764, 1.872916646102967],
            [34.60676952299516, 1.873257700511859],
            [34.60732286095567, 1.874581819295907],
            [34.60795942872556, 1.874025741800482],
            [34.60850929379919, 1.871546896235499],
            [34.609869277562304, 1.872528426529516],
            [34.61275588616706, 1.870944749792261],
            [34.614710901398, 1.872395750667045],
            [34.615305381300175, 1.872267009110648],
            [34.61594319772833, 1.873078281603834],
            [34.61742941724677, 1.872777793161966],
            [34.61798182095939, 1.873076386273506],
            [34.618492891389145, 1.874614179945548],
            [34.619002428394715, 1.874485516663791],
            [34.62014773726284, 1.872946180397625],
            [34.620827513997874, 1.873201926987825],
            [34.62065860916489, 1.87427032455656],
            [34.61836807407367, 1.877434459035422],
            [34.618410977611646, 1.877904444953356],
            [34.619472879702265, 1.878031644516223],
            [34.6243120457473, 1.875249696726863],
            [34.62566989960491, 1.873923809713205],
            [34.62630534807398, 1.872171303412063],
            [34.62728210514701, 1.872084930711529],
            [34.62864189038247, 1.872852789355848],
            [34.6296010072383, 1.872574229611136],
            [34.63027985152209, 1.868753886665499],
            [34.63198463564073, 1.864451129789333],
            [34.633889923730784, 1.857637107578372],
            [34.64037749293233, 1.841067670897309],
            [34.64154867867051, 1.835822166540766],
            [34.64202023760082, 1.829204580959281],
            [34.64273051483471, 1.827231218335637],
            [34.645359400377714, 1.822432337778332],
            [34.649930901705766, 1.815712893175996],
            [34.653803168789715, 1.808692901003453],
            [34.65561219880382, 1.803916153108813],
            [34.65999531712856, 1.794467872196994],
            [34.66173526490071, 1.78912957438938],
            [34.66512227194962, 1.78378628589268],
            [34.666838439519545, 1.778185987215805],
            [34.671468025015585, 1.768359560696787],
            [34.67198868406269, 1.766361636103684],
            [34.67209151421323, 1.755420907949082],
            [34.67076199052476, 1.748319622892368],
            [34.699698758713744, 1.752893894858419],
            [34.706216332544074, 1.754778444243314],
            [34.71052014310396, 1.762118206046906],
            [34.71201464958092, 1.76629129911422],
            [34.714540047406544, 1.770528208167706],
            [34.71650867301235, 1.775060413597912],
            [34.716723740471146, 1.779751974785173],
            [34.71476119017161, 1.791172812594528],
            [34.71311594998325, 1.795773271164384],
            [34.71333115668092, 1.80072676312049],
            [34.711634549028, 1.806730376576513],
            [34.71586089336939, 1.805455967336349],
            [34.71639538826849, 1.8039577316764],
            [34.716512451326444, 1.801800893855811],
            [34.72067920053355, 1.800359117859166],
            [34.72163196180872, 1.800418120608476],
            [34.723359643983976, 1.801375017366238],
            [34.72466927448049, 1.801014315476172],
            [34.72573914732262, 1.798976396492566],
            [34.72698832928536, 1.797657212971943],
            [34.72829778730534, 1.797116785722888],
            [34.72972819359688, 1.798553229123039],
            [34.73014664053431, 1.800290181951367],
            [34.73122001500943, 1.801966595965778],
            [34.73145909892735, 1.802924904260481],
            [34.73074576382821, 1.804183668094947],
            [34.730829167910755, 1.80498186623072],
            [34.735371096699666, 1.802485067040856],
            [34.74135456909299, 1.80187890359176],
            [34.744020737415234, 1.802208177134658],
            [34.74470560130974, 1.803446830965495],
            [34.74496981110615, 1.805636809882466],
            [34.74414782657003, 1.81601543030469],
            [34.74257567960143, 1.81656738858287],
            [34.73369755329165, 1.816441390450291],
            [34.73259285815586, 1.817938280666662],
            [34.732711995423784, 1.819534066488447],
            [34.73518930104236, 1.821580083517725],
            [34.73601952762122, 1.823488337715283],
            [34.73615540140119, 1.825233211789769],
            [34.73498430729115, 1.828066780532057],
            [34.73380038613718, 1.829421059781595],
            [34.73348392134068, 1.832150591823543],
            [34.733025633222084, 1.83296432126585],
            [34.733395723847785, 1.835246835840739],
            [34.73285031351966, 1.836921594060958],
            [34.73314792986487, 1.838274433638453],
            [34.73292097050833, 1.838938757621039],
            [34.72971280545604, 1.840219945286436],
            [34.727086763979244, 1.840166295935606],
            [34.723124273701416, 1.836835575189922],
            [34.72188150301486, 1.836697182709799],
            [34.718419412079555, 1.839269242780093],
            [34.71705448398908, 1.839388355476179],
            [34.71630262553731, 1.838936535435743],
            [34.716048638568836, 1.840215779253211],
            [34.713642032159726, 1.842660161671926],
            [34.712106644252515, 1.843103131553626],
            [34.71060395502166, 1.844965116370443],
            [34.70778406339474, 1.846008481045788],
            [34.70891058849029, 1.846546856407739],
            [34.708015407428185, 1.846971739059779],
            [34.70763574435481, 1.849354597978428],
            [34.707904282234274, 1.8505840109924],
            [34.70886028642762, 1.851774328239284],
            [34.7089765284254, 1.853503445312051],
            [34.708062003940285, 1.855733116062137],
            [34.70798798096426, 1.858192533932969],
            [34.70821803681356, 1.859114565376026],
            [34.70890620561002, 1.859805586075171],
            [34.70718955744142, 1.86199761676481],
            [34.70341964979084, 1.864490701176323],
            [34.7037929177577, 1.864486030614251],
            [34.702915045434494, 1.865421819946875],
            [34.702900126214274, 1.867239067128894],
            [34.70262339390278, 1.874107372939917],
            [34.70355988938311, 1.878234397587124],
            [34.7077615138845, 1.883765445589821],
            [34.71133947042346, 1.886518204867596],
            [34.7119398118329, 1.88791115632325],
            [34.71302663408783, 1.88911530531677],
            [34.71336470516353, 1.890282533056956],
            [34.71452621874106, 1.891298287808399],
            [34.71647622676259, 1.894686042954032],
            [34.71857420078615, 1.89626580155712],
            [34.72164514368719, 1.897467950684048],
            [34.72830857697021, 1.897310603653931],
            [34.730075758966834, 1.905029742740679],
            [34.730228138391844, 1.911824201936769],
            [34.73176922880446, 1.91318769274889],
            [34.73532494665027, 1.914892752116487],
            [34.73889840262968, 1.929181519364497],
            [34.740534576121874, 1.931116823746374],
            [34.742018853482655, 1.937492061125959],
            [34.739460800998145, 1.945872125239928],
            [34.7412307084833, 1.954784914933567],
            [34.74095935797869, 1.956895157856779],
            [34.73946779438262, 1.958330126842831],
            [34.73646369781682, 1.962943091680669],
            [34.73338947875993, 1.965881915987547],
            [34.7329368563158, 1.969047356683531],
            [34.72869285109594, 1.976012451324321],
            [34.72750872243112, 1.977160415790621],
            [34.7250189661627, 1.98322923464329],
            [34.720210474889655, 1.984426879758268],
            [34.72034583303667, 1.988060170250699],
            [34.7209977557097, 1.990708160499606],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 812,
        District: "NAKAPIRIPIRIT",
        County: "CHEKWII",
        Subcounty: "KAKOMONGOLE",
        Population: 19610,
        Key: "NAKAPIRIPIRITKAKOMONGOLE",
        Dist2: "Nakapiripirit",
        "Sub Country": "Kakomongole",
        id2_original: "NakapiripiritKakomongole",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.54911812561393, 1.913421725147501],
            [34.546297589894934, 1.916954956066753],
            [34.54180871291178, 1.914977149289325],
            [34.539277941364126, 1.914418092348148],
            [34.53848706458799, 1.913584139765332],
            [34.537578379152215, 1.913545215025112],
            [34.53738034824277, 1.912988950718361],
            [34.5364321890368, 1.912989806335704],
            [34.53528526050625, 1.911599728360391],
            [34.53394157577559, 1.911084240413552],
            [34.533745035171236, 1.912197306077281],
            [34.53216519143724, 1.912675681617923],
            [34.52971736403472, 1.914466461172522],
            [34.526358761715066, 1.913873282637703],
            [34.52509454285278, 1.913874415679196],
            [34.524462889765815, 1.914391681356992],
            [34.52220906971857, 1.912207653395629],
            [34.5217714796824, 1.908789858479579],
            [34.52105930879989, 1.907598103195712],
            [34.5181332246283, 1.904659162609741],
            [34.51751436894085, 1.902874230217218],
            [34.513500609114814, 1.901325184021282],
            [34.510814354462845, 1.899705619735713],
            [34.506965374406015, 1.894064182892306],
            [34.50139862238815, 1.895212025977576],
            [34.49294209340755, 1.887206964800823],
            [34.484100043439604, 1.88262208229802],
            [34.475065904019516, 1.880577826332205],
            [34.46564432031907, 1.879804111828815],
            [34.46127377571334, 1.879807802815536],
            [34.45593028199304, 1.87776030327458],
            [34.449029352115204, 1.871512352889652],
            [34.44695418182512, 1.870300608625763],
            [34.43598243562601, 1.866312704274515],
            [34.43226483597611, 1.865922083317051],
            [34.42680996463532, 1.84951427743435],
            [34.426042722534284, 1.844984070873222],
            [34.42094792470546, 1.827151195796507],
            [34.42073163014799, 1.823859102834708],
            [34.41881124317463, 1.818598947100458],
            [34.41894042540406, 1.813027178094885],
            [34.42045992930042, 1.800237827041474],
            [34.42022942968335, 1.796410996008424],
            [34.418872713991206, 1.795257272723515],
            [34.417818741329604, 1.795688185021273],
            [34.416977175316916, 1.795517151661859],
            [34.416565493591904, 1.796377307783679],
            [34.41759195534794, 1.797208007866222],
            [34.41605438453458, 1.798700183947185],
            [34.41522802699966, 1.798700829517617],
            [34.41480489894129, 1.798315831557286],
            [34.41474258191172, 1.79735359443968],
            [34.41385917416973, 1.797268271331645],
            [34.413146409500804, 1.797813501259075],
            [34.41217361130322, 1.797657951921563],
            [34.41112274411754, 1.796066148693216],
            [34.409649554662295, 1.796621738646067],
            [34.4089649674489, 1.796478781886488],
            [34.40790141515311, 1.794233604989955],
            [34.4063339960178, 1.793976764278148],
            [34.40542071120778, 1.792085074498607],
            [34.40285583242543, 1.791628291745275],
            [34.40299718952189, 1.79016587361422],
            [34.40074493344156, 1.788647952911849],
            [34.39897829223075, 1.788706658841557],
            [34.39742492544147, 1.78817740932452],
            [34.395687471392556, 1.789153613259723],
            [34.392776963109675, 1.789625213398018],
            [34.39166942390767, 1.78881260928895],
            [34.388164016209366, 1.788127133553023],
            [34.38773736855171, 1.789159690991457],
            [34.38688279673035, 1.789533088510145],
            [34.38636861902801, 1.787841777176355],
            [34.384837071418666, 1.788415240982627],
            [34.384023248975204, 1.788227828755111],
            [34.383447818746916, 1.788522973733957],
            [34.38306344670482, 1.788188370616961],
            [34.38311879729938, 1.786009181251578],
            [34.38237754435784, 1.785493626307607],
            [34.38113306238069, 1.786113714103941],
            [34.38053656576066, 1.785796127150575],
            [34.38032560450103, 1.785093749506174],
            [34.380638102337215, 1.783831901786053],
            [34.38029581367125, 1.783373391253359],
            [34.37897927692682, 1.784136402480715],
            [34.37828870783195, 1.783639384643025],
            [34.37761308221183, 1.777726832394209],
            [34.37792574354139, 1.776665695197847],
            [34.37893657730642, 1.775675719183157],
            [34.37836614979596, 1.774959310036552],
            [34.376485411764314, 1.774874707787565],
            [34.37594333328756, 1.773957573511447],
            [34.3764841595128, 1.773182999599505],
            [34.3764266242155, 1.772437538402756],
            [34.374887007938256, 1.771234425328903],
            [34.37435774303073, 1.768381845365639],
            [34.37546819906243, 1.767234090742174],
            [34.375496292974624, 1.766689276461183],
            [34.37389741663472, 1.762389512614404],
            [34.371331610791, 1.760642347370825],
            [34.36923572535044, 1.758565108166366],
            [34.36786552774253, 1.75521135391358],
            [34.36530041449987, 1.754410386677427],
            [34.364872379843426, 1.753579188783599],
            [34.364857152501024, 1.752217219578813],
            [34.36265953015963, 1.747344384268145],
            [34.36081981728869, 1.744836821351462],
            [34.356623416490656, 1.742535965121122],
            [34.355600671064984, 1.741747387988759],
            [34.35445840568902, 1.74002605586789],
            [34.350165716272336, 1.737338281399602],
            [34.34864477327489, 1.737961271083085],
            [34.34550702356448, 1.738107057147371],
            [34.343556490926844, 1.736338451612729],
            [34.34192494196171, 1.73183088071784],
            [34.342184981778594, 1.729773654538945],
            [34.34177983978881, 1.728314884577595],
            [34.342254007426696, 1.726520616685027],
            [34.3386266264791, 1.72335392966038],
            [34.337721112096304, 1.720221165813979],
            [34.336234098467166, 1.718368497327935],
            [34.3360905144471, 1.717005202589115],
            [34.336493222900735, 1.714971787410721],
            [34.33488672615229, 1.712210271339192],
            [34.33540808408866, 1.709889756147217],
            [34.33416921927696, 1.705920050605669],
            [34.333538610032356, 1.704951762556367],
            [34.332754137345866, 1.70490448090907],
            [34.331183335155224, 1.702178788102913],
            [34.327592368316, 1.70000464959427],
            [34.32773434884327, 1.699047785507922],
            [34.32719870859218, 1.697911996753619],
            [34.32755471543086, 1.697098498232351],
            [34.32895648522776, 1.696021145979092],
            [34.328647127901796, 1.695519067580891],
            [34.32912170786638, 1.694298853180552],
            [34.32884645597848, 1.691536389802057],
            [34.326872085646464, 1.689552458418581],
            [34.32630029449338, 1.68766323371552],
            [34.327464261369954, 1.686466461024356],
            [34.32747502498368, 1.684804086496579],
            [34.32792618586883, 1.684086191085078],
            [34.32699832499501, 1.682914787145953],
            [34.32702063914668, 1.680785966169712],
            [34.32576061631507, 1.680547629815389],
            [34.32352483174378, 1.678635641944147],
            [34.3205657820962, 1.679319365961656],
            [34.31906681817884, 1.677263315634002],
            [34.31768913041809, 1.678795104388362],
            [34.316999747997684, 1.678771649566485],
            [34.31638129834876, 1.67819801247346],
            [34.316129281385685, 1.674574393846601],
            [34.316792547984136, 1.671105654823772],
            [34.31584075958443, 1.669695062280279],
            [34.31468568692748, 1.666430858042918],
            [34.31373448961919, 1.665905278448196],
            [34.3124496220818, 1.664040426955101],
            [34.31176000520112, 1.663658185249212],
            [34.30726705974805, 1.663326332089893],
            [34.30499601360689, 1.661976409400277],
            [34.303401950440275, 1.659848643249428],
            [34.302235161955416, 1.656787729761668],
            [34.30133146486442, 1.656166428992836],
            [34.29996448142858, 1.655940089727528],
            [34.29929765570496, 1.654074824761304],
            [34.298488881793425, 1.653214258599624],
            [34.29542177829191, 1.652235575905506],
            [34.29394712727769, 1.650944905365052],
            [34.29128411563538, 1.649942032769174],
            [34.29048783818774, 1.65002626339759],
            [34.28984642221025, 1.650648602314002],
            [34.288206064365475, 1.650410472432855],
            [34.287207276110095, 1.649789231626096],
            [34.28735097241957, 1.651439583560559],
            [34.28601915623046, 1.650459756013412],
            [34.28487849883891, 1.65101064821585],
            [34.28475906063536, 1.650125706968673],
            [34.283664765295605, 1.64883476477772],
            [34.28261907599923, 1.649218145241531],
            [34.28164426737204, 1.648931754329332],
            [34.279348612781995, 1.6462183734689],
            [34.27865831587665, 1.644759723124093],
            [34.277470292116774, 1.645573758749093],
            [34.276043814157966, 1.6452637217288],
            [34.27540264970877, 1.646292683764163],
            [34.274997779010214, 1.645096965263264],
            [34.27311933347916, 1.644284904025651],
            [34.271786773485026, 1.642132991107023],
            [34.26927779057457, 1.640352572807573],
            [34.26773308983282, 1.641023332935464],
            [34.26616362433532, 1.64013929957113],
            [34.2641671383793, 1.640595057136875],
            [34.26137339940526, 1.639628085563816],
            [34.2611818929597, 1.637499344582072],
            [34.260634524304265, 1.636471127808857],
            [34.25870894057699, 1.636304923746847],
            [34.257211883782965, 1.637143069141248],
            [34.25371762687225, 1.637336649788101],
            [34.24963415778019, 1.636339688738925],
            [34.24656711446578, 1.637574571108833],
            [34.24267851421334, 1.636786399437552],
            [34.24087434857652, 1.637130024641954],
            [34.23993191523215, 1.636796189772819],
            [34.229070110247406, 1.637204170950427],
            [34.22950715500616, 1.579334968311825],
            [34.22956819013982, 1.561541322345902],
            [34.25066468890444, 1.562019725622509],
            [34.25600078859163, 1.561293880785959],
            [34.258877399845616, 1.561961893818823],
            [34.259566476838806, 1.561530916534202],
            [34.26037475577861, 1.561650021229294],
            [34.260956552367325, 1.56070484416431],
            [34.26143195069714, 1.560680631874545],
            [34.261241428805164, 1.560082753547402],
            [34.2617642824365, 1.559938911145564],
            [34.26185903763097, 1.559388700218421],
            [34.262572108625434, 1.559316505110288],
            [34.262286504552186, 1.558718684764462],
            [34.2633799446958, 1.558741938929081],
            [34.26487791058493, 1.559458627020087],
            [34.26525783147476, 1.558788641221817],
            [34.26749220569108, 1.558739438046761],
            [34.26772884708973, 1.556969232886916],
            [34.26841801481276, 1.556681771246055],
            [34.26858333626608, 1.554911610155597],
            [34.270257278526074, 1.551812983038896],
            [34.2721576869675, 1.549802559752111],
            [34.27163416409129, 1.548822164613198],
            [34.27163313641861, 1.54709994590237],
            [34.27348702470474, 1.546811790571266],
            [34.27409349531934, 1.547373533139835],
            [34.27447345483676, 1.546775302626924],
            [34.27492524723753, 1.547038148175685],
            [34.2773019181881, 1.546486546497706],
            [34.278324356389966, 1.547012153223359],
            [34.27889469137399, 1.546772612254989],
            [34.27948926470096, 1.547322401719365],
            [34.28048759930715, 1.547297870490523],
            [34.28079684254705, 1.547704315864699],
            [34.28172374402014, 1.547488472868872],
            [34.282198709362014, 1.546770593578075],
            [34.282864470582005, 1.547105058147019],
            [34.28348228691868, 1.54674588723521],
            [34.283922301507744, 1.547212056984738],
            [34.28430253051975, 1.547068299913356],
            [34.28437412265463, 1.547522728403685],
            [34.28606252868902, 1.548741597209919],
            [34.289247927737044, 1.549122354492386],
            [34.295014084188416, 1.552312041294441],
            [34.29689203474777, 1.55252615787039],
            [34.29929420347935, 1.55479701924779],
            [34.30408270813564, 1.552988106714447],
            [34.3056753869984, 1.553130630450132],
            [34.306864548923734, 1.554230178994029],
            [34.307339464858266, 1.55344053681518],
            [34.308789811054154, 1.554061538340842],
            [34.30869450070081, 1.553702805928022],
            [34.309074754865634, 1.553606892145958],
            [34.312283691570734, 1.553604876169528],
            [34.31395896603229, 1.552826440614668],
            [34.31538525534487, 1.552992965713048],
            [34.31590782151531, 1.55239465686693],
            [34.3170015176788, 1.552872360893115],
            [34.31892668189284, 1.55256019870518],
            [34.31966369568454, 1.55282283879524],
            [34.32094699476343, 1.552391480691942],
            [34.3215882319762, 1.551506068524455],
            [34.3227294023058, 1.551888053754293],
            [34.323312172668274, 1.552545460069042],
            [34.32685278444427, 1.55084494601961],
            [34.328065114819104, 1.550963778330441],
            [34.32932641595331, 1.553378813806334],
            [34.33001609032621, 1.55392851624645],
            [34.33281000896331, 1.555517343720433],
            [34.334069994065636, 1.555827500272712],
            [34.334950097804, 1.556831540562704],
            [34.336186432061545, 1.557333051820761],
            [34.336495956474145, 1.558146103860806],
            [34.33704280500505, 1.558384942215599],
            [34.338587590188425, 1.558001242115693],
            [34.339324666862225, 1.558335633967087],
            [34.33999125093899, 1.559985627779466],
            [34.34328528505097, 1.563033185473492],
            [34.343405652112516, 1.56542501228699],
            [34.34221769662462, 1.566239028320354],
            [34.34238423709178, 1.566478108209545],
            [34.344048134390256, 1.566500946523707],
            [34.34568871501721, 1.567265285030779],
            [34.34682965268316, 1.567264545993875],
            [34.34755497220652, 1.567802254090937],
            [34.348909481636284, 1.567227315774713],
            [34.35026351855226, 1.565958731132043],
            [34.3519035862412, 1.565885904969919],
            [34.3521170843432, 1.565239947577157],
            [34.35520648403008, 1.564233334995214],
            [34.35694090626492, 1.563084091120101],
            [34.35733321941411, 1.563263227549922],
            [34.357807996109756, 1.562330077874743],
            [34.3583784703326, 1.562329706110463],
            [34.3583543909914, 1.561851330741897],
            [34.35970870099522, 1.561013291093126],
            [34.35992195385715, 1.559960724035015],
            [34.36163300552154, 1.559433390117841],
            [34.362440467892775, 1.558356512970807],
            [34.36305921398574, 1.559504210410695],
            [34.36372481800055, 1.559599440559772],
            [34.363677755262806, 1.560317047892537],
            [34.36650672975558, 1.560984915762735],
            [34.36664990055061, 1.561845898851496],
            [34.36711362796826, 1.562192411044762],
            [34.36832601493695, 1.562430800847456],
            [34.36899136293194, 1.562119419523356],
            [34.36951473219625, 1.562812716748737],
            [34.37063204237357, 1.563027253410737],
            [34.370252029855564, 1.563505882640058],
            [34.370513658792184, 1.563744885614491],
            [34.370846248348016, 1.563481559930932],
            [34.37117918914515, 1.563744447399867],
            [34.37141629048126, 1.562835379996502],
            [34.37172544658458, 1.563050447362962],
            [34.37182028981396, 1.562715525554348],
            [34.37315110527983, 1.562308020758962],
            [34.374577193369795, 1.562187483820805],
            [34.374411204468224, 1.562809483118692],
            [34.37571882633176, 1.563263074893154],
            [34.37626533529947, 1.562999606370196],
            [34.376598275198276, 1.56326248491969],
            [34.37708526988011, 1.56281966442879],
            [34.378012386948875, 1.563010399204449],
            [34.37820214257792, 1.562412308718519],
            [34.378725006090725, 1.562316289371226],
            [34.37929612350732, 1.563320484609994],
            [34.38100754348099, 1.563367196678815],
            [34.38126942933574, 1.564012824191445],
            [34.38164952899033, 1.56370162808601],
            [34.38212511416977, 1.564012256667686],
            [34.38319456300707, 1.563748429046475],
            [34.38336139363006, 1.56444195651487],
            [34.384050420317614, 1.564010967167528],
            [34.38490684536338, 1.565110642929207],
            [34.385833506087984, 1.564607745248683],
            [34.38628563356038, 1.565396753753663],
            [34.38690333670932, 1.564941889104468],
            [34.38760467031624, 1.565144715887794],
            [34.38876862461638, 1.564043686887208],
            [34.38917326624455, 1.564904485533867],
            [34.38964817319591, 1.56418660947597],
            [34.39093235711538, 1.565166416475672],
            [34.39304706046446, 1.564040818737131],
            [34.39354662257713, 1.564662369393661],
            [34.394093206105026, 1.564494570086037],
            [34.39387896329963, 1.564016338887612],
            [34.39414033801304, 1.563872654799624],
            [34.39490125148285, 1.564326595658775],
            [34.39578064645047, 1.564254248063625],
            [34.39589917915222, 1.563775793213221],
            [34.39389621634299, 1.56272388306511],
            [34.394971367685734, 1.562807561439046],
            [34.395493919483144, 1.562233164134248],
            [34.39634968426718, 1.562376100315973],
            [34.396634435839225, 1.561634439451969],
            [34.39737120169589, 1.561538262922351],
            [34.397988716198604, 1.560820293221545],
            [34.3979644940253, 1.560126676555244],
            [34.3986771742526, 1.559528228749766],
            [34.39893808723189, 1.558714817152177],
            [34.3998650776382, 1.558714195748006],
            [34.40114803625563, 1.557852261311466],
            [34.401766069984596, 1.557923606079679],
            [34.40193201576701, 1.557277699220699],
            [34.40290669144353, 1.557492314571721],
            [34.402668568722966, 1.556822755588257],
            [34.40380954411816, 1.556941575888947],
            [34.40385653858395, 1.556128316847953],
            [34.4044987181294, 1.55674976747258],
            [34.404617177169314, 1.556175643297498],
            [34.405567714215834, 1.555840151072873],
            [34.40694517739778, 1.554141004612103],
            [34.408466559671375, 1.554403085959158],
            [34.40958440614297, 1.555478645088937],
            [34.410772721855295, 1.555286508775211],
            [34.411128588556785, 1.55428169009517],
            [34.41237638980892, 1.554197133153328],
            [34.41263749682435, 1.553670749658568],
            [34.41351712894721, 1.553957183516911],
            [34.4143481280772, 1.552593269715068],
            [34.414610063339296, 1.553310644160043],
            [34.416131138389076, 1.553118263397066],
            [34.41762907283714, 1.553858714979251],
            [34.41914956757527, 1.552829196531817],
            [34.41917388137674, 1.553642402066887],
            [34.41998184949948, 1.553378751845347],
            [34.420410094361706, 1.554000338875331],
            [34.422513805026675, 1.554273962038182],
            [34.423107735159924, 1.553843025386091],
            [34.42374958322705, 1.553986096834896],
            [34.42415390774993, 1.554344596621524],
            [34.4236787268124, 1.554655857867221],
            [34.42391664651372, 1.55499055646185],
            [34.42474874338496, 1.555277006304866],
            [34.42558038930196, 1.554893733977958],
            [34.42541462947079, 1.555802747340416],
            [34.426104145740155, 1.556161051057986],
            [34.42579569571262, 1.556950567399152],
            [34.42639009925805, 1.557237177714993],
            [34.42686628541037, 1.558432758015195],
            [34.427936116031674, 1.558790800870573],
            [34.42826941076503, 1.559579869030943],
            [34.430683044694604, 1.561216598676223],
            [34.43047015115879, 1.562723603792988],
            [34.43118356620797, 1.563249307947302],
            [34.43144482773361, 1.562962113864851],
            [34.43106411722462, 1.562364413987003],
            [34.431443935706554, 1.561646608001103],
            [34.432394839265726, 1.561885133460954],
            [34.43165835278509, 1.562387928525919],
            [34.43211036706975, 1.562985569130292],
            [34.43130274659502, 1.563727583321582],
            [34.43135061242663, 1.564229840055016],
            [34.43208713124659, 1.563774879966821],
            [34.433560998929885, 1.564084802724905],
            [34.43299105561136, 1.564826662972914],
            [34.4336564907429, 1.564682687994819],
            [34.43437034506827, 1.565854184730561],
            [34.43365815172787, 1.567122336610517],
            [34.43422879573233, 1.567408965294281],
            [34.43484617279278, 1.566523564832654],
            [34.4348707929198, 1.567767276012723],
            [34.435845103880304, 1.567455675476056],
            [34.43599997792689, 1.568017648710182],
            [34.435191893921456, 1.568089957562328],
            [34.43500214907221, 1.568688048224433],
            [34.43398001989082, 1.568569160341933],
            [34.434027748280165, 1.568856142631119],
            [34.43531172109552, 1.569524963230871],
            [34.435929130495374, 1.568687407067686],
            [34.436666508104764, 1.569476188643203],
            [34.43611995242464, 1.569667910589011],
            [34.43661970138687, 1.570552538357175],
            [34.4371421247252, 1.569834631908396],
            [34.43790256029129, 1.569594917532023],
            [34.43814063989273, 1.570168789297742],
            [34.438829894752345, 1.570096552355716],
            [34.43885407290822, 1.57071840832307],
            [34.439733372654416, 1.570502532665868],
            [34.439591084005, 1.570957074630702],
            [34.439187015501986, 1.570981277821997],
            [34.44023354921473, 1.572009020153786],
            [34.44018533393849, 1.571028410871445],
            [34.440874529509294, 1.570884424646194],
            [34.44101781169543, 1.571864968443795],
            [34.441920429011454, 1.571003281865784],
            [34.44251508408513, 1.571624738861355],
            [34.44275203719918, 1.570572182519793],
            [34.443917828554085, 1.572197787522486],
            [34.444249855764575, 1.571145165917379],
            [34.44522404724916, 1.570666122670189],
            [34.444630702817484, 1.571934190815156],
            [34.445676700236, 1.572196560885763],
            [34.44586734699379, 1.572913968145557],
            [34.44659256590584, 1.573308101800271],
            [34.44668711269119, 1.572542659194923],
            [34.44716251641088, 1.572590163073626],
            [34.44756720205649, 1.573474848870337],
            [34.447899838324744, 1.57330718766004],
            [34.44775667651285, 1.5724940759468],
            [34.4480653690855, 1.572063333405496],
            [34.449183116742375, 1.572971432374214],
            [34.449419990804714, 1.571799285896592],
            [34.44984805151234, 1.572109920460442],
            [34.45020433323549, 1.571774815117564],
            [34.45084622352344, 1.57196570622353],
            [34.45122630251677, 1.571654505912523],
            [34.451106974805995, 1.570960971853674],
            [34.451796812672264, 1.571749776816588],
            [34.45305659745027, 1.571820641592202],
            [34.45291450283696, 1.572562201867447],
            [34.45355588647509, 1.572035555379628],
            [34.45338894356269, 1.571222462926556],
            [34.4538877510905, 1.570743751050863],
            [34.4538168452685, 1.571317832627854],
            [34.45424496167164, 1.57172413687053],
            [34.45339015269506, 1.572968473540724],
            [34.453841952282374, 1.573231254754621],
            [34.45488692562146, 1.572034620585383],
            [34.455196129335526, 1.572345318870562],
            [34.45517341363692, 1.573852177688846],
            [34.45562493025493, 1.573708354192099],
            [34.45617187580386, 1.574114573559547],
            [34.45634979612905, 1.573624130284331],
            [34.45577915212459, 1.573337511432707],
            [34.45589743509467, 1.572524219237935],
            [34.45699103783336, 1.572882219277491],
            [34.45725336655756, 1.57412575875212],
            [34.45760914702079, 1.573073124649813],
            [34.45803696518327, 1.573048900829323],
            [34.45772857624117, 1.573910169901769],
            [34.458418023340265, 1.574148860089766],
            [34.45841859916037, 1.574962067241264],
            [34.459630539666364, 1.574602434140247],
            [34.45939327304027, 1.575200555264238],
            [34.460034971088746, 1.575128344537688],
            [34.45984532146092, 1.575822083745321],
            [34.460297386051224, 1.576491475020821],
            [34.46122446898402, 1.576658246979484],
            [34.46091621568752, 1.577710846943208],
            [34.460155604051636, 1.577687472660746],
            [34.45991866441228, 1.578740022715128],
            [34.46113092382021, 1.578834834430347],
            [34.461249569709686, 1.578547740369552],
            [34.460583907304375, 1.578356870520038],
            [34.46110654983159, 1.577973809847736],
            [34.46182019754446, 1.578810423898246],
            [34.462438040830584, 1.578618645322785],
            [34.46298504836328, 1.579096608274986],
            [34.464006761624724, 1.578617523752847],
            [34.463983519513356, 1.579358997198802],
            [34.46312776640741, 1.579240012943545],
            [34.462724004229905, 1.579670824042484],
            [34.46284303549664, 1.579933836985588],
            [34.46367475687213, 1.579694061810613],
            [34.464626072757994, 1.580506590620814],
            [34.4637826544192, 1.581021430208598],
            [34.463925749755745, 1.581714941160858],
            [34.46549432142957, 1.581498562880762],
            [34.465185669281084, 1.581977123220102],
            [34.4640449993131, 1.582288885914475],
            [34.464354408741336, 1.582886609719051],
            [34.4647819008154, 1.582384031513503],
            [34.46530482631194, 1.582431494758747],
            [34.46504472630795, 1.584345100624127],
            [34.46578161792878, 1.584440245230817],
            [34.466208982442055, 1.583770240508175],
            [34.46654199510439, 1.584128770211],
            [34.46630480753004, 1.584822561189001],
            [34.466922624765004, 1.584606858508015],
            [34.46739823779218, 1.584941363733837],
            [34.46777829522595, 1.584606237111582],
            [34.46851527039011, 1.584820972677145],
            [34.46898991233846, 1.58379215910939],
            [34.46918073875931, 1.584748739835723],
            [34.47003608762339, 1.584293691734248],
            [34.47039334581525, 1.585321901616096],
            [34.47089224676786, 1.584986680768387],
            [34.47153409573331, 1.585129734820898],
            [34.47146316475847, 1.585655979292016],
            [34.47082136609868, 1.585584672288181],
            [34.47060781589438, 1.586111019012365],
            [34.470917050151186, 1.586445641629294],
            [34.471772584966494, 1.58625369853323],
            [34.47141701920063, 1.5876172617147],
            [34.4718093718757, 1.587868120518752],
            [34.472355493669525, 1.587078438969233],
            [34.47354458462799, 1.588010368892649],
            [34.47385314784322, 1.587412207459668],
            [34.473330254686005, 1.587436504746224],
            [34.47325870567026, 1.587077790634401],
            [34.473781215246845, 1.586527300412235],
            [34.474233253786025, 1.587148838073245],
            [34.47482687400051, 1.586311288108907],
            [34.47572993059268, 1.586095377253738],
            [34.47516042295708, 1.587411267284494],
            [34.47630115490883, 1.587195185929753],
            [34.47665713120477, 1.586429554479588],
            [34.4767289964275, 1.587218790883501],
            [34.47794095579813, 1.586883064785598],
            [34.47884494843484, 1.587982621611012],
            [34.47934336250056, 1.586977723473466],
            [34.479247691024476, 1.586140670915781],
            [34.47996089407128, 1.586355417097835],
            [34.480080063678564, 1.586809757145109],
            [34.481077699395435, 1.585900169101931],
            [34.482016872753604, 1.58636589013348],
            [34.48230162791889, 1.585719893295989],
            [34.4819923101188, 1.585241779214769],
            [34.48232495626853, 1.585098025650173],
            [34.4835378310224, 1.586053843395785],
            [34.483895009264224, 1.586962461563018],
            [34.4842983779796, 1.586005467894893],
            [34.48536873231874, 1.587080986512017],
            [34.48627131370215, 1.586219291874721],
            [34.48620100256486, 1.58760656419276],
            [34.48700913418097, 1.587605978716051],
            [34.48693842059843, 1.588443139334878],
            [34.486296899518074, 1.588754534683764],
            [34.48658325548119, 1.590332885984284],
            [34.48582383051977, 1.591959841320186],
            [34.48656029993241, 1.591457029154101],
            [34.48635962438277, 1.593358619933792],
            [34.487262669296875, 1.593142711611623],
            [34.48721467231122, 1.592496966529439],
            [34.48847386779444, 1.591754609698678],
            [34.48887810967229, 1.591993488201695],
            [34.48828440501618, 1.592711448945745],
            [34.48859423485599, 1.593883182210059],
            [34.487619688536874, 1.593812135901032],
            [34.48674087028766, 1.594673816592131],
            [34.48745390265454, 1.594649375716052],
            [34.48764472458385, 1.595582024183885],
            [34.48840545389902, 1.595772807136711],
            [34.48783564981938, 1.596658176261176],
            [34.488857611015824, 1.596537828990609],
            [34.48866783921713, 1.597064147776369],
            [34.48923841944119, 1.597255078756082],
            [34.48874051561854, 1.59895359108407],
            [34.489524724200315, 1.598737757880498],
            [34.489596814001885, 1.599837917197959],
            [34.49047582988043, 1.599239329074875],
            [34.49036924656861, 1.599753639578274],
            [34.49079733781894, 1.60013600208416],
            [34.491581693724434, 1.600111504701276],
            [34.49155846778275, 1.600876873348979],
            [34.49234264941508, 1.60061321384635],
            [34.49241369447596, 1.600254398764031],
            [34.493434690881784, 1.600300945673786],
            [34.493401913153726, 1.60073053832877],
            [34.4931037964469, 1.601378014793265],
            [34.493341575112716, 1.601521343382502],
            [34.4947279100564, 1.607424780774015],
            [34.497164807656866, 1.633064023051241],
            [34.50387471168786, 1.651400679318009],
            [34.50575396929592, 1.676665858691663],
            [34.50595961881728, 1.702119461703282],
            [34.504961887878984, 1.710241559324181],
            [34.50339205766546, 1.715470183780956],
            [34.50173364009021, 1.775945843050711],
            [34.50226973039729, 1.784902578416492],
            [34.50372074134645, 1.785079189494911],
            [34.51256181125243, 1.788046030938873],
            [34.518309400425196, 1.788939782859585],
            [34.52240995816891, 1.790338456311115],
            [34.532827698959274, 1.795443110258161],
            [34.53459459888488, 1.7980097116604],
            [34.53894097701283, 1.801469795764798],
            [34.54717866740709, 1.806162091145561],
            [34.552141005054004, 1.811461931044579],
            [34.55346852729605, 1.81448555183869],
            [34.55632136373768, 1.818582996567502],
            [34.56555502257563, 1.825192901488947],
            [34.576565294822366, 1.829775672122936],
            [34.585713708929745, 1.830242896316282],
            [34.589530109786175, 1.832259202772428],
            [34.5959654940562, 1.834631784757552],
            [34.59861955398673, 1.833595236230107],
            [34.60514912571599, 1.832062429540586],
            [34.6069130225736, 1.829792699985301],
            [34.614377842023245, 1.825600833143998],
            [34.62268995694047, 1.817508446593723],
            [34.62901723166101, 1.8099885784427],
            [34.63269804080844, 1.803136935487291],
            [34.63496546763733, 1.801517926154967],
            [34.638178333573464, 1.799993175786921],
            [34.64545605011913, 1.798274506061074],
            [34.653211467376664, 1.802167134556038],
            [34.65561219880382, 1.803916153108813],
            [34.653803168789715, 1.808692901003453],
            [34.649930901705766, 1.815712893175996],
            [34.645359400377714, 1.822432337778332],
            [34.64273051483471, 1.827231218335637],
            [34.64202023760082, 1.829204580959281],
            [34.64154867867051, 1.835822166540766],
            [34.64037749293233, 1.841067670897309],
            [34.633889923730784, 1.857637107578372],
            [34.63198463564073, 1.864451129789333],
            [34.63027985152209, 1.868753886665499],
            [34.6296010072383, 1.872574229611136],
            [34.62864189038247, 1.872852789355848],
            [34.62728210514701, 1.872084930711529],
            [34.62630534807398, 1.872171303412063],
            [34.62566989960491, 1.873923809713205],
            [34.6243120457473, 1.875249696726863],
            [34.619472879702265, 1.878031644516223],
            [34.618410977611646, 1.877904444953356],
            [34.61836807407367, 1.877434459035422],
            [34.62065860916489, 1.87427032455656],
            [34.620827513997874, 1.873201926987825],
            [34.62014773726284, 1.872946180397625],
            [34.619002428394715, 1.874485516663791],
            [34.618492891389145, 1.874614179945548],
            [34.61798182095939, 1.873076386273506],
            [34.61742941724677, 1.872777793161966],
            [34.61594319772833, 1.873078281603834],
            [34.615305381300175, 1.872267009110648],
            [34.614710901398, 1.872395750667045],
            [34.61275588616706, 1.870944749792261],
            [34.609869277562304, 1.872528426529516],
            [34.60850929379919, 1.871546896235499],
            [34.60795942872556, 1.874025741800482],
            [34.60732286095567, 1.874581819295907],
            [34.60676952299516, 1.873257700511859],
            [34.605919780516764, 1.872916646102967],
            [34.603159477735915, 1.873303763946612],
            [34.602859921029676, 1.870825696682506],
            [34.601967124994694, 1.869843727291101],
            [34.60137399705698, 1.871468013253161],
            [34.58408951267523, 1.88762657186377],
            [34.57806461357428, 1.887881494790303],
            [34.57256533311908, 1.884376380958002],
            [34.57084453922547, 1.882580483121754],
            [34.56888115618766, 1.886484340576125],
            [34.56783043632571, 1.887249259683258],
            [34.5585070627403, 1.887426811448082],
            [34.557835732863865, 1.889616404964892],
            [34.55831844348011, 1.891129352875502],
            [34.55844132941772, 1.893974406726177],
            [34.55910390341508, 1.894760765266254],
            [34.55904812791739, 1.896758586194428],
            [34.558090808590485, 1.897144845804681],
            [34.55784270109552, 1.905238256652168],
            [34.551325842324175, 1.910234016885597],
            [34.54911812561393, 1.913421725147501],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 813,
        District: "NAKAPIRIPIRIT",
        County: "CHEKWII",
        Subcounty: "LOREGAE",
        Population: 22198,
        Key: "NAKAPIRIPIRITLOREGAE",
        Dist2: "Nakapiripirit",
        "Sub Country": "Loregae",
        id2_original: "NakapiripiritLoregae",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.84253027893266, 1.735454658233756],
            [34.84228844527164, 1.736068390260976],
            [34.84254926213124, 1.736590679680476],
            [34.84185457156583, 1.736846543322122],
            [34.84206590742295, 1.737747151063771],
            [34.84082123769787, 1.737975845829066],
            [34.84084156118287, 1.738804230314679],
            [34.84041280787418, 1.739313301868989],
            [34.84002089537359, 1.739116620148041],
            [34.837501934875306, 1.740428284074944],
            [34.83766690508734, 1.741753227034033],
            [34.83550990186813, 1.742779304948571],
            [34.83489189419031, 1.743754235267629],
            [34.833895892508956, 1.743419258644579],
            [34.83268292163532, 1.743615278164675],
            [34.8305189708457, 1.744983876512597],
            [34.8259797325111, 1.745955691778163],
            [34.82480540536434, 1.746762983827512],
            [34.82117387420015, 1.747411448236618],
            [34.81941229769091, 1.748541770704263],
            [34.81989354405322, 1.749078729195335],
            [34.817971513162895, 1.749994237061266],
            [34.816903124337635, 1.749887795940846],
            [34.81620988005981, 1.751070818910631],
            [34.81466096711771, 1.751179817170947],
            [34.813112983931894, 1.752256189129671],
            [34.8124186473027, 1.752310608762425],
            [34.81220540432224, 1.752740761568087],
            [34.81156396319194, 1.752257699389442],
            [34.808841527993565, 1.754033878057354],
            [34.809055548016744, 1.754409872184045],
            [34.81103199255879, 1.754515432213332],
            [34.81373942319697, 1.757563158980823],
            [34.821112195872736, 1.762238149844858],
            [34.82382807067457, 1.763536087708171],
            [34.82757744373607, 1.764182687667909],
            [34.83080885539125, 1.763919363600461],
            [34.83403885669146, 1.762225368374651],
            [34.83662456111709, 1.762612982244594],
            [34.837531084307955, 1.764302867477722],
            [34.839211798966865, 1.764561314156196],
            [34.840765040890346, 1.76664073213108],
            [34.84167221356314, 1.768980910391056],
            [34.84283432272372, 1.76767914504267],
            [34.84554800294135, 1.766766009991386],
            [34.84748801720533, 1.767804544047745],
            [34.8489114849096, 1.769363833188399],
            [34.84878480269159, 1.77196515539904],
            [34.846330817337794, 1.774048580414064],
            [34.84516974842632, 1.776390827018753],
            [34.84594728791545, 1.77834094380522],
            [34.847368310405514, 1.777429091700001],
            [34.8490486405855, 1.777297337232115],
            [34.8530606999007, 1.782105483453847],
            [34.85448614928847, 1.785615637303472],
            [34.85681529666555, 1.787954331565855],
            [34.860177004461136, 1.788731255299408],
            [34.86121336654991, 1.790941195497132],
            [34.860054048454955, 1.794974207037525],
            [34.85643826655431, 1.798619565755017],
            [34.85333809157559, 1.800833749913061],
            [34.853211195558565, 1.803174949527016],
            [34.85838149588871, 1.802779459097594],
            [34.86019202968259, 1.803557949597266],
            [34.86070949432054, 1.803947592927555],
            [34.861487217964275, 1.806027731332844],
            [34.86084327053433, 1.808369454899918],
            [34.859164915749666, 1.810452130100974],
            [34.85593335227917, 1.810585526175076],
            [34.853863741662394, 1.809287066671151],
            [34.85011470097756, 1.809030805410765],
            [34.84843645758399, 1.811243543895245],
            [34.847017673695596, 1.814366436593476],
            [34.84727819500946, 1.816317065927358],
            [34.8555555163791, 1.820340353879166],
            [34.85904924058885, 1.823718259092339],
            [34.86047347186109, 1.825927776914353],
            [34.85815065311518, 1.829831965974954],
            [34.858670146149045, 1.832172485145214],
            [34.857895067145506, 1.832693530678787],
            [34.8568598378323, 1.831654140211763],
            [34.85543787390781, 1.83165562436822],
            [34.85243602313023, 1.830709741492367],
            [34.850528170350024, 1.834131871704768],
            [34.85001470770664, 1.837644014144808],
            [34.848564982246614, 1.839782764937016],
            [34.8511864782481, 1.845706478710506],
            [34.850673711799104, 1.849868919899607],
            [34.84816666565638, 1.85650710513386],
            [34.84682240420736, 1.857947103172618],
            [34.843628066023925, 1.8597275447422],
            [34.84169414413419, 1.860321938569961],
            [34.84093653646459, 1.859730376536242],
            [34.840177434896695, 1.85770022325931],
            [34.83908312248892, 1.856855140763474],
            [34.83840892608842, 1.855586502595938],
            [34.83369743310313, 1.854322083389245],
            [34.83268828098431, 1.854492382105626],
            [34.83327792705197, 1.855337999948204],
            [34.835304373619344, 1.862867342520115],
            [34.83522237001031, 1.864898384993211],
            [34.83446818402362, 1.867607117041896],
            [34.8277432296184, 1.871422234384222],
            [34.831113503748504, 1.877003832207135],
            [34.83153706479487, 1.879880579267732],
            [34.83255514347269, 1.883036919396544],
            [34.83212817960802, 1.883410042317616],
            [34.8311754452823, 1.886840428263602],
            [34.830961601328916, 1.889315597949724],
            [34.828415827916, 1.934794878553671],
            [34.837771184220465, 1.951177688467459],
            [34.84989843157291, 1.970388088303044],
            [34.8651898606647, 1.99687182473308],
            [34.86774008522986, 1.998907169875311],
            [34.87065640920589, 1.998587384650127],
            [34.87245614435173, 1.998858289962519],
            [34.872926468098534, 1.999623517282216],
            [34.87166973310087, 1.999784381186831],
            [34.871454193128244, 2.000260202738182],
            [34.87183119988329, 2.000715018183902],
            [34.87334984858352, 2.00029313914927],
            [34.87400974829628, 2.001059271647144],
            [34.8739719229346, 2.004039416150913],
            [34.87361375474934, 2.004609916617988],
            [34.87197831248582, 2.004673604103408],
            [34.871618000021996, 2.005697102233106],
            [34.86995331759592, 2.006928925931573],
            [34.86935113823342, 2.007938504619345],
            [34.86871383474331, 2.008755995473506],
            [34.86963034540351, 2.01038169219391],
            [34.8699974140966, 2.012934612129895],
            [34.86977961755596, 2.013887280763595],
            [34.86882821902509, 2.014621838056829],
            [34.86585460139855, 2.014524131239387],
            [34.86549710155987, 2.014951575405203],
            [34.86570123831828, 2.016883816484413],
            [34.866195266808795, 2.01764915476434],
            [34.86614086663183, 2.019127136365678],
            [34.864854312956616, 2.020575373044648],
            [34.86458596462171, 2.02219539043071],
            [34.86356222655761, 2.02319188474593],
            [34.86207210385925, 2.022588668489518],
            [34.861550082067886, 2.02272921930857],
            [34.860949517876236, 2.024443019378689],
            [34.86121869715282, 2.02514766860535],
            [34.85771122512598, 2.025178538781256],
            [34.85715793297956, 2.026916407718657],
            [34.857272354092224, 2.027775297879035],
            [34.85632523603369, 2.027603854924777],
            [34.85532349591428, 2.028958099265096],
            [34.855814715372865, 2.03031949395858],
            [34.85654821495519, 2.030561438824087],
            [34.85718974501871, 2.030206867458165],
            [34.857353144077315, 2.030732196480672],
            [34.85639835440624, 2.032182029757779],
            [34.85592174155412, 2.035243542122503],
            [34.855014337115975, 2.036693619124295],
            [34.85521881613251, 2.038554335910034],
            [34.8563522510692, 2.039418110798816],
            [34.8567140358718, 2.038084641921004],
            [34.857740614408826, 2.041499077235396],
            [34.85683423584669, 2.042734562561091],
            [34.85576410249313, 2.043516249984779],
            [34.85384197278813, 2.044055441215773],
            [34.85356668676424, 2.044638263491113],
            [34.85353588802475, 2.046140225130237],
            [34.85384215963769, 2.046523176007681],
            [34.854532558052675, 2.045858881578209],
            [34.85505380010639, 2.045885219552546],
            [34.85559682720409, 2.046316986133361],
            [34.855544697069824, 2.047318139187861],
            [34.8558752205005, 2.04758199178218],
            [34.854767653450764, 2.051272327194072],
            [34.8540789501567, 2.051578991434881],
            [34.85370090225421, 2.051338759926068],
            [34.85425362127548, 2.049720088818227],
            [34.85335343569894, 2.049644247698024],
            [34.853523600868286, 2.048739034096108],
            [34.85295406089333, 2.048903212075228],
            [34.853088013176915, 2.05064437704491],
            [34.85125244513269, 2.052924512908708],
            [34.851176506050116, 2.053949390844883],
            [34.85059449656072, 2.054244643424814],
            [34.85135012344508, 2.054820491956132],
            [34.851369880093145, 2.055655079826135],
            [34.85070621823597, 2.055675758304185],
            [34.85070272738278, 2.056414868733197],
            [34.851985023941815, 2.055872613200169],
            [34.85219515515813, 2.056541219789451],
            [34.85269607911676, 2.055852170829535],
            [34.85304716228934, 2.056783721789373],
            [34.85245301835708, 2.057138527879767],
            [34.85105504843383, 2.057084151090757],
            [34.849840475864035, 2.058342014813157],
            [34.849121413106666, 2.060055268796681],
            [34.84847986507684, 2.060409844338821],
            [34.847156148098335, 2.059688229921922],
            [34.84663083847303, 2.060520220791881],
            [34.84794780461215, 2.062672378755214],
            [34.84794442604836, 2.063387653825525],
            [34.84739745085503, 2.063790361456658],
            [34.84640223250458, 2.063761765980088],
            [34.84574743162934, 2.06441430703259],
            [34.84569338808356, 2.065820790694845],
            [34.84519189279641, 2.066629051326902],
            [34.843839731562745, 2.066908707073897],
            [34.843693262154, 2.067814038734578],
            [34.84331307895608, 2.068026805294771],
            [34.84255516765593, 2.06792781796897],
            [34.84106791148164, 2.066704704911097],
            [34.840284287703106, 2.067034765534587],
            [34.83989800674105, 2.068535028233891],
            [34.840843697376634, 2.069016407098724],
            [34.84128245432433, 2.073965930292825],
            [34.84042209735254, 2.075487778533626],
            [34.83937778607181, 2.075816586795241],
            [34.838883374000666, 2.075122767600482],
            [34.83812265816018, 2.075619848382018],
            [34.837928343581105, 2.076620319587473],
            [34.838852930994, 2.076553211026919],
            [34.838897400295515, 2.077173347019547],
            [34.83648091870651, 2.076994894538184],
            [34.83530976800262, 2.079087486802945],
            [34.83345305810817, 2.08081915849706],
            [34.832577998410144, 2.08043348231152],
            [34.832363355854476, 2.080718571331648],
            [34.8325930317164, 2.082269481306607],
            [34.83175211788064, 2.082182008159147],
            [34.83177321571341, 2.082730501044259],
            [34.829752847147226, 2.083984532687189],
            [34.829589996060946, 2.083339983143077],
            [34.82913848034127, 2.08360010062041],
            [34.82837403649236, 2.08488397898642],
            [34.827093495241385, 2.085044756253214],
            [34.82668735791826, 2.085734274594826],
            [34.827943848574144, 2.085644902961646],
            [34.82817701079774, 2.086456691369351],
            [34.8273958448098, 2.086262208458217],
            [34.82528370884579, 2.086872033913745],
            [34.824116933835654, 2.088034776822181],
            [34.824375821113996, 2.088417501242111],
            [34.82321141226632, 2.089079547029317],
            [34.82280329056477, 2.090511200474697],
            [34.821077084321516, 2.089692272815773],
            [34.820811780377106, 2.090668581998971],
            [34.821330906, 2.091147932451819],
            [34.821092448207835, 2.091456752471177],
            [34.82012044501928, 2.091523632376465],
            [34.819625137327805, 2.091020558068275],
            [34.81903096914102, 2.091375356480638],
            [34.8187376718957, 2.093257587634059],
            [34.817834851560434, 2.093730137997906],
            [34.817736795057264, 2.094421117596778],
            [34.81668940884334, 2.095393679468137],
            [34.81559811657155, 2.095626904809634],
            [34.81532089198329, 2.096615073586302],
            [34.81595435248061, 2.097977177006958],
            [34.81585302251659, 2.099359597164872],
            [34.813993893459084, 2.101591984419413],
            [34.81287855598209, 2.10189662353389],
            [34.813227735624615, 2.103233521832653],
            [34.812230337062985, 2.103657933081735],
            [34.812296705494475, 2.104659673734512],
            [34.81101604297092, 2.104844297513837],
            [34.81059113355331, 2.104484614129174],
            [34.810115570831805, 2.104816149842139],
            [34.80917052069503, 2.104191704095386],
            [34.80855263878136, 2.104546398079045],
            [34.80772552845824, 2.10404173093377],
            [34.807119445915816, 2.104408406679407],
            [34.80647346739501, 2.105692867661193],
            [34.806946106998595, 2.105981248473359],
            [34.80675099291889, 2.107148639876962],
            [34.80556308773664, 2.107762894560803],
            [34.804854353808395, 2.107282626359531],
            [34.804117978718864, 2.107636759470036],
            [34.80377897070029, 2.109161127229266],
            [34.80330553698601, 2.109039641475178],
            [34.802979947102855, 2.10772669360766],
            [34.80229186723961, 2.107890297204261],
            [34.80195759244429, 2.108413267351279],
            [34.80285187069951, 2.109752779566096],
            [34.80192544713015, 2.110201376832007],
            [34.801623506295186, 2.111404027835883],
            [34.80213960459559, 2.112527141270141],
            [34.80121915212793, 2.111712063743298],
            [34.800153672047536, 2.111492363840174],
            [34.79934506791758, 2.112084595207238],
            [34.79901394351395, 2.11193994529959],
            [34.798318091426886, 2.113748727540659],
            [34.79717925761534, 2.114005551669718],
            [34.796956722461566, 2.115959671383857],
            [34.797995676189934, 2.11677532120942],
            [34.798087319620294, 2.117443382135427],
            [34.797746178102926, 2.119420761431401],
            [34.798099084855544, 2.119970852610439],
            [34.79780041119326, 2.120482060610409],
            [34.7979311277452, 2.122914733628061],
            [34.797753084350845, 2.126772593605085],
            [34.79926888359495, 2.126994418880459],
            [34.799921560852844, 2.129310367825952],
            [34.79934983527678, 2.129927575215497],
            [34.798519442509594, 2.130114358530731],
            [34.797803036968844, 2.131255412257615],
            [34.798119535003, 2.134499670927593],
            [34.7973550803743, 2.135783557549636],
            [34.79874124194314, 2.138365274979682],
            [34.79845705810639, 2.140831742848595],
            [34.798239933505585, 2.141641388344303],
            [34.79774044415648, 2.142020491733736],
            [34.79724362639702, 2.14182738206555],
            [34.79555136389512, 2.143846018247918],
            [34.7945779647246, 2.144199019964598],
            [34.79417000741473, 2.145270049125753],
            [34.793577950268855, 2.145171844104433],
            [34.793597043960226, 2.146149529488451],
            [34.79347708114054, 2.146458920239972],
            [34.79321728027555, 2.146266932340562],
            [34.79259378389133, 2.142782786298379],
            [34.792609287914836, 2.139492438922294],
            [34.790601069062895, 2.138147606749973],
            [34.79100768878129, 2.1373627105274],
            [34.78956905931165, 2.135853685187457],
            [34.788055287565136, 2.135202678496827],
            [34.78779200123684, 2.135749817824154],
            [34.786443674911155, 2.135194971814628],
            [34.78447523345998, 2.132956170472139],
            [34.783695264926344, 2.132499409900097],
            [34.783030641871804, 2.132710822009494],
            [34.782490276482314, 2.131706798707212],
            [34.78121316320243, 2.131128443327755],
            [34.77862813969983, 2.131473726007489],
            [34.778084281660526, 2.13120884079614],
            [34.777960362660316, 2.132352748376379],
            [34.77767562186808, 2.13242291746453],
            [34.776873418234544, 2.131656070040112],
            [34.77718401254065, 2.131133001817659],
            [34.7762405093028, 2.130174721306114],
            [34.774340193387815, 2.131071684831095],
            [34.76867824510267, 2.128028301717365],
            [34.76699630963328, 2.127853323747638],
            [34.76678888414262, 2.126612440952075],
            [34.76565307136535, 2.126225485200344],
            [34.763244790496586, 2.124282568252573],
            [34.76073492454221, 2.123769789639506],
            [34.7592627897091, 2.124334976755011],
            [34.75778621360522, 2.123338349522895],
            [34.7570502499441, 2.123597097624675],
            [34.75484780275133, 2.12322885095067],
            [34.75309295372526, 2.123435013692994],
            [34.74985049099544, 2.124802541741952],
            [34.74816115789969, 2.124782152335412],
            [34.747135358202016, 2.125525967371276],
            [34.74689876800733, 2.125143667703782],
            [34.74482895886286, 2.125052288385782],
            [34.739031404495705, 2.126057284637815],
            [34.72980047024798, 2.129007352639848],
            [34.72022030964538, 2.133118493984568],
            [34.71090718583739, 2.139059352361265],
            [34.703904691535215, 2.144277656385615],
            [34.69420493013403, 2.148059103029829],
            [34.69690083269216, 2.144897225853923],
            [34.700123811861786, 2.141923785642333],
            [34.70613033053372, 2.139088147541371],
            [34.707518482769224, 2.136836268929701],
            [34.70702814725285, 2.134205481974725],
            [34.709041190057874, 2.126868187506017],
            [34.71019139204932, 2.124616816169136],
            [34.711946775573, 2.122806816771059],
            [34.713104970773855, 2.118306457643899],
            [34.7129219731707, 2.112911675745916],
            [34.71343072325208, 2.110374533555567],
            [34.714297504076455, 2.107525619677526],
            [34.71761723090389, 2.100759888639138],
            [34.716932864676046, 2.095844646339291],
            [34.71975441638959, 2.091986862271793],
            [34.7244250207581, 2.086725665232875],
            [34.726093405141455, 2.08261906233836],
            [34.7262810236784, 2.076733080168636],
            [34.72550527273503, 2.071138304590993],
            [34.72546720572657, 2.068899239012793],
            [34.724667633258456, 2.066269106943382],
            [34.72455630953686, 2.064139992354254],
            [34.72570477598321, 2.062367174565974],
            [34.72628277898646, 2.060428049496656],
            [34.7266882237085, 2.05685040835163],
            [34.72762959165091, 2.053116140611917],
            [34.730920967647975, 2.047618606177407],
            [34.73319083250451, 2.041668577787821],
            [34.73168163767437, 2.037891488047622],
            [34.73178808803552, 2.034757077219465],
            [34.731021117225715, 2.026396796146876],
            [34.731125479902175, 2.020546877347789],
            [34.72966557652997, 2.016315085301809],
            [34.7285588431168, 2.006531906698321],
            [34.72624927452132, 2.000411719021753],
            [34.723230990862234, 1.995569940450366],
            [34.7209977557097, 1.990708160499606],
            [34.72034583303667, 1.988060170250699],
            [34.720210474889655, 1.984426879758268],
            [34.7250189661627, 1.98322923464329],
            [34.72750872243112, 1.977160415790621],
            [34.72869285109594, 1.976012451324321],
            [34.7329368563158, 1.969047356683531],
            [34.73338947875993, 1.965881915987547],
            [34.73646369781682, 1.962943091680669],
            [34.73946779438262, 1.958330126842831],
            [34.74095935797869, 1.956895157856779],
            [34.7412307084833, 1.954784914933567],
            [34.739460800998145, 1.945872125239928],
            [34.742018853482655, 1.937492061125959],
            [34.740534576121874, 1.931116823746374],
            [34.73889840262968, 1.929181519364497],
            [34.73532494665027, 1.914892752116487],
            [34.73176922880446, 1.91318769274889],
            [34.730228138391844, 1.911824201936769],
            [34.730075758966834, 1.905029742740679],
            [34.72830857697021, 1.897310603653931],
            [34.72164514368719, 1.897467950684048],
            [34.71857420078615, 1.89626580155712],
            [34.71647622676259, 1.894686042954032],
            [34.71452621874106, 1.891298287808399],
            [34.71336470516353, 1.890282533056956],
            [34.71302663408783, 1.88911530531677],
            [34.7119398118329, 1.88791115632325],
            [34.71133947042346, 1.886518204867596],
            [34.7077615138845, 1.883765445589821],
            [34.70355988938311, 1.878234397587124],
            [34.70262339390278, 1.874107372939917],
            [34.702900126214274, 1.867239067128894],
            [34.70774571521358, 1.867715773405364],
            [34.71166594065561, 1.866759686959998],
            [34.71727299738531, 1.862401068737557],
            [34.719570394706984, 1.861174499322696],
            [34.72207159641045, 1.860967989508067],
            [34.72524957357762, 1.861508997280217],
            [34.72661595244725, 1.861357664341974],
            [34.72646721299577, 1.859357878861921],
            [34.726740258621334, 1.858875981691149],
            [34.72544004696054, 1.857845206067142],
            [34.725815517596494, 1.857214133605366],
            [34.72526808336405, 1.856801844767878],
            [34.725563162866884, 1.855540153183065],
            [34.72524377495245, 1.855242313979885],
            [34.72629138305026, 1.854990033154001],
            [34.7285743300723, 1.85338585181843],
            [34.728539142164294, 1.852793867271631],
            [34.729230367029345, 1.851713624859666],
            [34.72919467067488, 1.850599268102288],
            [34.72974804816126, 1.850146003579958],
            [34.73040367818149, 1.848055881019739],
            [34.73005653052816, 1.847011483224807],
            [34.73258163909628, 1.84107932141918],
            [34.73292097050833, 1.838938757621039],
            [34.73314792986487, 1.838274433638453],
            [34.73285031351966, 1.836921594060958],
            [34.733395723847785, 1.835246835840739],
            [34.733025633222084, 1.83296432126585],
            [34.73348392134068, 1.832150591823543],
            [34.73380038613718, 1.829421059781595],
            [34.73498430729115, 1.828066780532057],
            [34.73615540140119, 1.825233211789769],
            [34.73601952762122, 1.823488337715283],
            [34.73518930104236, 1.821580083517725],
            [34.732711995423784, 1.819534066488447],
            [34.73259285815586, 1.817938280666662],
            [34.73369755329165, 1.816441390450291],
            [34.74257567960143, 1.81656738858287],
            [34.74414782657003, 1.81601543030469],
            [34.74496981110615, 1.805636809882466],
            [34.74470560130974, 1.803446830965495],
            [34.744020737415234, 1.802208177134658],
            [34.74135456909299, 1.80187890359176],
            [34.735371096699666, 1.802485067040856],
            [34.730829167910755, 1.80498186623072],
            [34.73074576382821, 1.804183668094947],
            [34.73145909892735, 1.802924904260481],
            [34.73122001500943, 1.801966595965778],
            [34.73014664053431, 1.800290181951367],
            [34.72972819359688, 1.798553229123039],
            [34.72829778730534, 1.797116785722888],
            [34.72698832928536, 1.797657212971943],
            [34.72573914732262, 1.798976396492566],
            [34.72466927448049, 1.801014315476172],
            [34.723359643983976, 1.801375017366238],
            [34.72163196180872, 1.800418120608476],
            [34.72067920053355, 1.800359117859166],
            [34.716512451326444, 1.801800893855811],
            [34.71639538826849, 1.8039577316764],
            [34.71586089336939, 1.805455967336349],
            [34.711634549028, 1.806730376576513],
            [34.71333115668092, 1.80072676312049],
            [34.71311594998325, 1.795773271164384],
            [34.71476119017161, 1.791172812594528],
            [34.716723740471146, 1.779751974785173],
            [34.71650867301235, 1.775060413597912],
            [34.714540047406544, 1.770528208167706],
            [34.71201464958092, 1.76629129911422],
            [34.71052014310396, 1.762118206046906],
            [34.706216332544074, 1.754778444243314],
            [34.699698758713744, 1.752893894858419],
            [34.67076199052476, 1.748319622892368],
            [34.671306666030986, 1.746679274604885],
            [34.67125657147915, 1.743241127058675],
            [34.67296694222057, 1.735216271194626],
            [34.67236966226961, 1.731299578608236],
            [34.673424015816884, 1.729157347970768],
            [34.673029365251345, 1.723789158655576],
            [34.6723465450241, 1.721248594169037],
            [34.67242081054527, 1.717578306478575],
            [34.67143554283321, 1.715763728471073],
            [34.6715849883605, 1.708303995792442],
            [34.66969813729334, 1.702982806953458],
            [34.66846994087396, 1.701882458685321],
            [34.66764158279091, 1.699746594581822],
            [34.66760601759049, 1.698101890845768],
            [34.66666345399041, 1.69695479042087],
            [34.66419147358482, 1.69526647043813],
            [34.662754048755986, 1.693521889624034],
            [34.66154569971452, 1.689704429481814],
            [34.660353624552705, 1.688544605874054],
            [34.66023691902426, 1.684992856769291],
            [34.65891876261735, 1.681568310711947],
            [34.6591406437976, 1.677231114951496],
            [34.660526806264734, 1.674601871452414],
            [34.6607559233746, 1.672528988915269],
            [34.66043774549083, 1.670525860152754],
            [34.65863718928481, 1.668053121270999],
            [34.658842888213506, 1.661058300533728],
            [34.65858958396466, 1.659937242824881],
            [34.65906834019702, 1.659485933588933],
            [34.658835852608206, 1.658770134585241],
            [34.65917354908645, 1.658103861156812],
            [34.658844410857924, 1.657602265102452],
            [34.65911427644736, 1.656459085584177],
            [34.65992461702077, 1.656175705611226],
            [34.659785994396, 1.655627053407293],
            [34.66032409872594, 1.655187864487301],
            [34.659734332284025, 1.654566230978961],
            [34.66005140074838, 1.653470880346796],
            [34.65926622647769, 1.653563665511482],
            [34.65919803895771, 1.653134404672709],
            [34.66010574792478, 1.652541504654606],
            [34.659658082384404, 1.651991852934316],
            [34.65980333906753, 1.651634803360935],
            [34.6612779119283, 1.651544253084094],
            [34.6614089833148, 1.649876260250931],
            [34.66186396832809, 1.64942487240052],
            [34.661214693888496, 1.64881497500437],
            [34.6616020231845, 1.647862854913879],
            [34.66044400315511, 1.646929534625986],
            [34.65988097237268, 1.645902812393295],
            [34.6596178279782, 1.620184308152745],
            [34.660292770878726, 1.609198715186054],
            [34.65895807918242, 1.606429514707716],
            [34.65674018186503, 1.604157933019122],
            [34.65656950016442, 1.603120568825753],
            [34.65372619664459, 1.601847985082736],
            [34.65241686977863, 1.598864339596972],
            [34.65115837947293, 1.598669535841122],
            [34.649838543216454, 1.597115921820333],
            [34.64905513683022, 1.596970349803419],
            [34.6488598224262, 1.596052063147797],
            [34.64779623599442, 1.595214349776813],
            [34.6455659275531, 1.589784574205415],
            [34.64357166492741, 1.586202770105264],
            [34.64021834559995, 1.581555810460854],
            [34.638660648930994, 1.580025233652259],
            [34.63485151903847, 1.577557641672229],
            [34.63385573744434, 1.577196829978373],
            [34.631644446337575, 1.577261023513048],
            [34.63122887760229, 1.576874080692652],
            [34.632861055388126, 1.576151793401528],
            [34.635620139155115, 1.575946394986724],
            [34.63953430995214, 1.573838021988858],
            [34.64134498747645, 1.573295784254773],
            [34.6532232892058, 1.572727214105793],
            [34.65813919203739, 1.571778105306356],
            [34.660290217866674, 1.571820963068055],
            [34.66116694214296, 1.572205201221475],
            [34.663905550609705, 1.571546859079744],
            [34.6661499167869, 1.571828342645271],
            [34.6665246400245, 1.572592281401226],
            [34.668931310214, 1.571813657124958],
            [34.67163386300018, 1.572823600248149],
            [34.679067435450996, 1.570536090995419],
            [34.68660171982493, 1.569095030952005],
            [34.69123966414466, 1.568752752072737],
            [34.69266949371777, 1.569889573801309],
            [34.69435635105663, 1.570014276016596],
            [34.695344215798144, 1.571447563431552],
            [34.696606691928785, 1.571094193118384],
            [34.69717545036944, 1.571334403006379],
            [34.698637682174855, 1.572912259295679],
            [34.700200258492444, 1.573775408787208],
            [34.700916351419515, 1.573372570235607],
            [34.703749186871335, 1.574442463288305],
            [34.70386261444734, 1.575181694180122],
            [34.70476135732951, 1.575804328972711],
            [34.705668664749645, 1.575259111368456],
            [34.70716411715255, 1.575550002524091],
            [34.708793470635115, 1.577033051013648],
            [34.70970880899386, 1.578632932992492],
            [34.711634150176025, 1.580271858531855],
            [34.71219468364195, 1.581632226171938],
            [34.712787385778206, 1.581848676275944],
            [34.71261154684956, 1.58313513616411],
            [34.713436012532455, 1.584162690203481],
            [34.71433773332984, 1.584380137690023],
            [34.714651992762306, 1.583666138598468],
            [34.71534413840051, 1.583287051535335],
            [34.71666918398732, 1.584125562655159],
            [34.71821847422185, 1.583558606429684],
            [34.718952743660346, 1.583918511862311],
            [34.7205251017331, 1.583446952562725],
            [34.721864908436615, 1.58389225695538],
            [34.72453071114454, 1.58342426170172],
            [34.725174820271256, 1.586357928722697],
            [34.72485534522021, 1.587786926937391],
            [34.72638838133802, 1.589436443073647],
            [34.7264310558056, 1.590103937932182],
            [34.72705669557006, 1.590689904165145],
            [34.726908306461524, 1.591475934090604],
            [34.72750222491668, 1.591525538782635],
            [34.72759208788612, 1.592240840805158],
            [34.72811382221661, 1.592409380493435],
            [34.72820175111327, 1.593386857433627],
            [34.7285581325494, 1.593411846085132],
            [34.72852581655538, 1.594579591975646],
            [34.729214988769996, 1.594605677928851],
            [34.729255554891594, 1.595559164638464],
            [34.73034762420607, 1.595753378724951],
            [34.73022404746403, 1.596396492641284],
            [34.73103278454465, 1.596327614110533],
            [34.73170266094695, 1.59736656485424],
            [34.732203237257565, 1.597177518716132],
            [34.73211833748005, 1.599036282929619],
            [34.73251547098907, 1.599990918774375],
            [34.73310972810907, 1.599992838623665],
            [34.73285425173384, 1.602423062849269],
            [34.733397670497, 1.602877671432613],
            [34.73299025127798, 1.603329183736588],
            [34.73270304011872, 1.605223050021573],
            [34.73372430961239, 1.605345532137559],
            [34.73395818509832, 1.60587063282051],
            [34.73369479187047, 1.606131948862136],
            [34.73558043200864, 1.608330770137926],
            [34.73571749425975, 1.609093892603255],
            [34.737429159473486, 1.609075597544698],
            [34.73858782628985, 1.609913524348132],
            [34.73941698656845, 1.611930168858327],
            [34.74052532886432, 1.613149263863781],
            [34.75001970484887, 1.615409579627355],
            [34.75150566834746, 1.615358978780472],
            [34.75274675738782, 1.615935024328613],
            [34.75380041384245, 1.615634218242527],
            [34.755922820245075, 1.61702062028104],
            [34.75644148503225, 1.618704255873356],
            [34.75809411566047, 1.620856734424459],
            [34.759456146684144, 1.62112590655149],
            [34.75985798287363, 1.622193468782296],
            [34.76021671340427, 1.622195800772112],
            [34.76045272238897, 1.622907302681218],
            [34.76147983811852, 1.623197962594301],
            [34.76176314430126, 1.624028096508057],
            [34.762507591651946, 1.623346627090135],
            [34.76585252969778, 1.624101979300648],
            [34.76609399325289, 1.623582898725942],
            [34.76682581927385, 1.6257412123772],
            [34.767401897187455, 1.625271640014307],
            [34.767877900981766, 1.625795363473475],
            [34.76835862811785, 1.625254183790548],
            [34.76932401970591, 1.625982249172557],
            [34.77013693664756, 1.626034848598617],
            [34.77153767338187, 1.628363151924465],
            [34.774210562899064, 1.6296584255664],
            [34.7740879428628, 1.630343920165267],
            [34.77537655637492, 1.630991239925492],
            [34.7759038557686, 1.630734344110519],
            [34.77640409251602, 1.631187228572619],
            [34.777317494107024, 1.630151868056335],
            [34.778341359731876, 1.63117611462989],
            [34.77860087583095, 1.631982423519738],
            [34.77951186724206, 1.631491352967569],
            [34.781447243504225, 1.631906193772253],
            [34.782340884853944, 1.632633770959175],
            [34.782676542156466, 1.632446634450976],
            [34.78312822316618, 1.633064857247186],
            [34.78267182600124, 1.633511549817636],
            [34.78326877357551, 1.633728398498551],
            [34.78357664598631, 1.634416680742175],
            [34.78431760158548, 1.634516135865399],
            [34.78460102993909, 1.635322605045952],
            [34.78567524523733, 1.635779191616482],
            [34.786753116678746, 1.635407533099418],
            [34.78935845378487, 1.635755697673313],
            [34.790247408623735, 1.634838513276709],
            [34.79113061424478, 1.635222873394218],
            [34.79134176504893, 1.636147181044929],
            [34.79284101822386, 1.63783711863321],
            [34.7939668228705, 1.637442094082811],
            [34.79515017718753, 1.637556236798272],
            [34.795934367803035, 1.6386972406618],
            [34.79672503617, 1.638371042203948],
            [34.797510806023766, 1.639157075238426],
            [34.7986109062769, 1.63916418159646],
            [34.79857936193569, 1.640891531393713],
            [34.799342562516244, 1.641369767087928],
            [34.79929191819548, 1.64200839835224],
            [34.80119816209298, 1.643606282580055],
            [34.801843561200435, 1.64368145140864],
            [34.80301970833395, 1.642718777102558],
            [34.804120232591885, 1.642631221968819],
            [34.805291457855965, 1.642780787462945],
            [34.80632891858433, 1.643438277831397],
            [34.8067844551632, 1.643180903210426],
            [34.80692565325788, 1.643702443582193],
            [34.80795390715292, 1.643732757329219],
            [34.807994954771495, 1.645271242017756],
            [34.808539795567725, 1.646458006112462],
            [34.80833773122268, 1.648894199646525],
            [34.8090035050191, 1.649774102185956],
            [34.80988712745843, 1.650063780345464],
            [34.81031113406915, 1.651533750753049],
            [34.81229917226823, 1.653569924161633],
            [34.812002182947104, 1.65583984009739],
            [34.81288154377874, 1.657099764695851],
            [34.813159369339914, 1.659184065492418],
            [34.813989325525846, 1.660798625882787],
            [34.81465671988303, 1.664033197668728],
            [34.81679581428873, 1.667076083756676],
            [34.81681256158058, 1.668709070482546],
            [34.81640422428333, 1.669108740109827],
            [34.816712841397525, 1.669631349381524],
            [34.816644896422694, 1.671488610735841],
            [34.817333872804575, 1.672534300186429],
            [34.816853789760536, 1.672933518273313],
            [34.81706300828853, 1.674307420793984],
            [34.81665115498527, 1.675511684297266],
            [34.817316735643885, 1.676438887842954],
            [34.816451523278005, 1.677403581337442],
            [34.81591924631931, 1.678796390223684],
            [34.81616065148394, 1.681010602797085],
            [34.819649201397645, 1.687209577396879],
            [34.82003134382118, 1.687330353804366],
            [34.82000709829168, 1.690134469804508],
            [34.81969132609625, 1.691244693837541],
            [34.81897219596522, 1.691618706967115],
            [34.81882403592711, 1.692682679020353],
            [34.82034543796364, 1.69479862064314],
            [34.82031385589322, 1.69654961146639],
            [34.81976026281117, 1.697350665929645],
            [34.82033301156832, 1.700371606075595],
            [34.82018455508617, 1.70150656280779],
            [34.81837823618756, 1.704382083144665],
            [34.81882673895781, 1.705733854008647],
            [34.818234123958106, 1.707256439977098],
            [34.81824667342263, 1.709859643659911],
            [34.81896435996101, 1.70981692803277],
            [34.8194874157133, 1.7105302327287],
            [34.8187647614914, 1.711708834680247],
            [34.81907432183661, 1.712018461591936],
            [34.818879487132975, 1.712821818155441],
            [34.84683592205575, 1.727045773957571],
            [34.84253027893266, 1.735454658233756],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 814,
        District: "NAKAPIRIPIRIT",
        County: "CHEKWII",
        Subcounty: "MORUITA",
        Population: 15014,
        Key: "NAKAPIRIPIRITMORUITA",
        Dist2: "Nakapiripirit",
        "Sub Country": "Moruita",
        id2_original: "NakapiripiritMoruita",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.73292097050833, 1.838938757621039],
            [34.73258163909628, 1.84107932141918],
            [34.73005653052816, 1.847011483224807],
            [34.73040367818149, 1.848055881019739],
            [34.72974804816126, 1.850146003579958],
            [34.72919467067488, 1.850599268102288],
            [34.729230367029345, 1.851713624859666],
            [34.728539142164294, 1.852793867271631],
            [34.7285743300723, 1.85338585181843],
            [34.72629138305026, 1.854990033154001],
            [34.72524377495245, 1.855242313979885],
            [34.725563162866884, 1.855540153183065],
            [34.72526808336405, 1.856801844767878],
            [34.725815517596494, 1.857214133605366],
            [34.72544004696054, 1.857845206067142],
            [34.726740258621334, 1.858875981691149],
            [34.72646721299577, 1.859357878861921],
            [34.72661595244725, 1.861357664341974],
            [34.72524957357762, 1.861508997280217],
            [34.72207159641045, 1.860967989508067],
            [34.719570394706984, 1.861174499322696],
            [34.71727299738531, 1.862401068737557],
            [34.71166594065561, 1.866759686959998],
            [34.70774571521358, 1.867715773405364],
            [34.702900126214274, 1.867239067128894],
            [34.702915045434494, 1.865421819946875],
            [34.7037929177577, 1.864486030614251],
            [34.70341964979084, 1.864490701176323],
            [34.70718955744142, 1.86199761676481],
            [34.70890620561002, 1.859805586075171],
            [34.70821803681356, 1.859114565376026],
            [34.70798798096426, 1.858192533932969],
            [34.708062003940285, 1.855733116062137],
            [34.7089765284254, 1.853503445312051],
            [34.70886028642762, 1.851774328239284],
            [34.707904282234274, 1.8505840109924],
            [34.70763574435481, 1.849354597978428],
            [34.708015407428185, 1.846971739059779],
            [34.70891058849029, 1.846546856407739],
            [34.70778406339474, 1.846008481045788],
            [34.71060395502166, 1.844965116370443],
            [34.712106644252515, 1.843103131553626],
            [34.713642032159726, 1.842660161671926],
            [34.716048638568836, 1.840215779253211],
            [34.71630262553731, 1.838936535435743],
            [34.71705448398908, 1.839388355476179],
            [34.718419412079555, 1.839269242780093],
            [34.72188150301486, 1.836697182709799],
            [34.723124273701416, 1.836835575189922],
            [34.727086763979244, 1.840166295935606],
            [34.72971280545604, 1.840219945286436],
            [34.73292097050833, 1.838938757621039],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 815,
        District: "NAKAPIRIPIRIT",
        County: "CHEKWII",
        Subcounty: "NAKAPIRIPIRIT TOWN COUNCIL",
        Population: 3727,
        Key: "NAKAPIRIPIRITNAKAPIRIPIRIT TOWN COUNCIL",
        Dist2: "Nakapiripirit",
        "Sub Country": "Nakapiripirit TC",
        id2_original: "NakapiripiritNakapiripirit TC",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.65561219880382, 1.803916153108813],
            [34.653211467376664, 1.802167134556038],
            [34.64545605011913, 1.798274506061074],
            [34.638178333573464, 1.799993175786921],
            [34.63496546763733, 1.801517926154967],
            [34.63269804080844, 1.803136935487291],
            [34.62901723166101, 1.8099885784427],
            [34.62268995694047, 1.817508446593723],
            [34.614377842023245, 1.825600833143998],
            [34.6069130225736, 1.829792699985301],
            [34.60514912571599, 1.832062429540586],
            [34.59861955398673, 1.833595236230107],
            [34.5959654940562, 1.834631784757552],
            [34.589530109786175, 1.832259202772428],
            [34.585713708929745, 1.830242896316282],
            [34.576565294822366, 1.829775672122936],
            [34.56555502257563, 1.825192901488947],
            [34.55632136373768, 1.818582996567502],
            [34.55346852729605, 1.81448555183869],
            [34.552141005054004, 1.811461931044579],
            [34.54717866740709, 1.806162091145561],
            [34.53894097701283, 1.801469795764798],
            [34.53459459888488, 1.7980097116604],
            [34.532827698959274, 1.795443110258161],
            [34.52240995816891, 1.790338456311115],
            [34.518309400425196, 1.788939782859585],
            [34.51256181125243, 1.788046030938873],
            [34.50372074134645, 1.785079189494911],
            [34.50226973039729, 1.784902578416492],
            [34.50173364009021, 1.775945843050711],
            [34.50339205766546, 1.715470183780956],
            [34.504961887878984, 1.710241559324181],
            [34.50595961881728, 1.702119461703282],
            [34.50575396929592, 1.676665858691663],
            [34.50387471168786, 1.651400679318009],
            [34.497164807656866, 1.633064023051241],
            [34.4947279100564, 1.607424780774015],
            [34.493341575112716, 1.601521343382502],
            [34.494291970225426, 1.601042291902253],
            [34.49433998877061, 1.601711947986421],
            [34.49529092287251, 1.601974342116169],
            [34.495242615968095, 1.600922002358419],
            [34.49595559533439, 1.60082580968996],
            [34.495956334647865, 1.601830340085443],
            [34.496764528247745, 1.601925413843352],
            [34.4970494406182, 1.60149469449347],
            [34.49790497543354, 1.601326640451018],
            [34.497762071438146, 1.600920148959403],
            [34.498118400772015, 1.600656792974448],
            [34.49754717735419, 1.5995809276475],
            [34.49797520123087, 1.599843705481087],
            [34.498331520683266, 1.59955641948239],
            [34.498378003109316, 1.598097423901321],
            [34.4987345920563, 1.59819283995724],
            [34.498853949411476, 1.598910275921675],
            [34.49956660628255, 1.598359633512486],
            [34.499280939327264, 1.597737997762211],
            [34.49792602655389, 1.597595501323265],
            [34.49944650871559, 1.596637678379624],
            [34.49859051665776, 1.596183867604113],
            [34.49916074743719, 1.595896451786309],
            [34.498851379331455, 1.59537049278641],
            [34.499373947298515, 1.594915678701833],
            [34.49973059553432, 1.595082831709902],
            [34.49975523452591, 1.596278689294991],
            [34.50015864456381, 1.595369514002295],
            [34.50135836079544, 1.595098934955517],
            [34.50271309390573, 1.595151162522364],
            [34.5033979065963, 1.595773206731985],
            [34.5048280254269, 1.595277455314336],
            [34.50623047435018, 1.59530600168854],
            [34.507177693020026, 1.595809750392324],
            [34.50789443093747, 1.595335427172086],
            [34.509820244633445, 1.595318055998802],
            [34.510692957033655, 1.5962506035912],
            [34.51107774230078, 1.595655982538633],
            [34.511887451358525, 1.595468011109754],
            [34.51262052783435, 1.595994872541335],
            [34.513381982089975, 1.595902084732295],
            [34.513425110206754, 1.596498139766306],
            [34.51368891306635, 1.596189148546357],
            [34.51459000324641, 1.596502044124965],
            [34.51494942547978, 1.59612186569554],
            [34.515756478219245, 1.596291421564387],
            [34.51661550209115, 1.595865242050625],
            [34.51665455275487, 1.597009531667624],
            [34.51593605234285, 1.597722212417241],
            [34.51636467809079, 1.597628309412296],
            [34.5167166901214, 1.598249231312944],
            [34.51745665757376, 1.597846496301333],
            [34.5179067494637, 1.598062528947048],
            [34.518279518865576, 1.59908873937758],
            [34.518902045967565, 1.598494921927745],
            [34.519828488401565, 1.598593371293194],
            [34.52007307539891, 1.599273522698167],
            [34.520937220566246, 1.598156112256306],
            [34.52113863902264, 1.599849167802866],
            [34.52168682873825, 1.599660312261948],
            [34.5218585408065, 1.598945798539448],
            [34.52245003740361, 1.599329156141456],
            [34.52240602803954, 1.59885228620546],
            [34.523406620112034, 1.598569602142036],
            [34.52487825548183, 1.598884397453172],
            [34.5261419506263, 1.598388073883936],
            [34.52642333710925, 1.598913412515246],
            [34.5273048790504, 1.598654162669525],
            [34.52784937848683, 1.598965853700944],
            [34.53202710600504, 1.598228985775684],
            [34.53262602987296, 1.597611256138379],
            [34.53302468872131, 1.59835150961622],
            [34.533645267377466, 1.598019875566728],
            [34.53411842620727, 1.598331330529456],
            [34.535451837804324, 1.598049751790341],
            [34.53602592684788, 1.597574948675138],
            [34.5364034591174, 1.597957581874631],
            [34.53747766363584, 1.597365276272745],
            [34.53780343228372, 1.598319799750914],
            [34.53897288427343, 1.597703981910589],
            [34.538969181417826, 1.598204527880533],
            [34.54102598924517, 1.598151805612069],
            [34.54155252507085, 1.597676842682537],
            [34.54528116232065, 1.598189848833053],
            [34.54573461211314, 1.597953006738166],
            [34.545670344841064, 1.596999344239325],
            [34.54638265675911, 1.597120910023163],
            [34.54643937458951, 1.595881620067972],
            [34.54686693942707, 1.595930713710739],
            [34.5465885434357, 1.595000190889434],
            [34.5458045693142, 1.594926056509525],
            [34.54626473131851, 1.593783470974364],
            [34.54840268845701, 1.594005126222455],
            [34.548603109783436, 1.592623312464325],
            [34.54931100738015, 1.593340754861455],
            [34.5493537743742, 1.593984474762006],
            [34.54961581384089, 1.593913837031769],
            [34.550121575227315, 1.593033591430474],
            [34.549847057263015, 1.591578679674282],
            [34.55108006326241, 1.592011846270452],
            [34.552178911264065, 1.591300434169531],
            [34.552771989794394, 1.591469265774557],
            [34.553037728523435, 1.590898085720818],
            [34.55425331259623, 1.590473102084097],
            [34.55525829563383, 1.589594526135269],
            [34.55618154455698, 1.590121997891934],
            [34.556950206894456, 1.589051945003739],
            [34.55775407780117, 1.589650519925965],
            [34.558900810499026, 1.588891599016457],
            [34.55987442257025, 1.589037866632837],
            [34.560047533315384, 1.58813267782811],
            [34.560970965494846, 1.588636309752671],
            [34.561402751515935, 1.588113366080449],
            [34.56254400988045, 1.588093335058481],
            [34.56295326166265, 1.587403452246936],
            [34.56508893079215, 1.586326043568503],
            [34.565812507583836, 1.5849221435495],
            [34.565555418732686, 1.584325396427386],
            [34.566796708097314, 1.583638287991778],
            [34.566846195388024, 1.583376267777597],
            [34.566110132912215, 1.583254630244365],
            [34.56618461762231, 1.582825828653811],
            [34.5669935945531, 1.582733186622554],
            [34.567259671048674, 1.58211434335083],
            [34.56787828419097, 1.582044905804619],
            [34.567907877391384, 1.581258407145816],
            [34.56852790268532, 1.580998295722261],
            [34.568662803589845, 1.580438601452125],
            [34.56985053270234, 1.580561745950012],
            [34.57058342861678, 1.581112406575924],
            [34.57130472278931, 1.58001836325522],
            [34.575019367880245, 1.579196502507306],
            [34.575492176367085, 1.57955561309155],
            [34.575461524951294, 1.580485097624351],
            [34.57603523310918, 1.580057971978424],
            [34.57674769684247, 1.580155684986468],
            [34.57697890433198, 1.581038376760727],
            [34.57843236858023, 1.580590341915975],
            [34.5803401378171, 1.581395187317278],
            [34.58191877691029, 1.583307300811105],
            [34.58379555247324, 1.583480376885664],
            [34.584120968083226, 1.584482569336292],
            [34.58504668737339, 1.584676332785264],
            [34.58565666141761, 1.585774793462648],
            [34.58608561684725, 1.585633205841857],
            [34.58613879621375, 1.584870644876799],
            [34.58654469099173, 1.584633642311265],
            [34.58730046340322, 1.585303553365542],
            [34.5889050108075, 1.585320797111193],
            [34.59012725319318, 1.583990059580042],
            [34.591223412537175, 1.583636178655168],
            [34.59162455253235, 1.584042704984884],
            [34.591845721348534, 1.583066192536873],
            [34.59215510742061, 1.583019557236777],
            [34.59255642258725, 1.583402255095347],
            [34.59226305078177, 1.584497714528691],
            [34.59328402203481, 1.584667952015181],
            [34.59378747115768, 1.584097576460889],
            [34.59397482469165, 1.581261776341294],
            [34.593299006832055, 1.579424191009799],
            [34.594676188841305, 1.579643284081146],
            [34.59536382134353, 1.578275031820485],
            [34.5965254903296, 1.578707936297541],
            [34.597408931309246, 1.578186480758131],
            [34.59861990612633, 1.57838119485193],
            [34.59924554589079, 1.577358346033525],
            [34.59962818238772, 1.577049756940965],
            [34.60045915366994, 1.577195535098478],
            [34.60046407284444, 1.576528151922012],
            [34.60127496767836, 1.576173316973958],
            [34.60209960224458, 1.577177139183443],
            [34.60462012401486, 1.577090167612393],
            [34.60713537357273, 1.5761093398178],
            [34.607362696746925, 1.574298609301103],
            [34.60814682537866, 1.574348896865975],
            [34.60783179878494, 1.575158254317023],
            [34.608544601183105, 1.575208282346132],
            [34.60874075551191, 1.574398524417189],
            [34.61283147670328, 1.574149920599763],
            [34.6131434993307, 1.573745752217393],
            [34.615614373910155, 1.575553499241313],
            [34.61635129248043, 1.575555951612851],
            [34.61700722253796, 1.576869071787577],
            [34.61781723432796, 1.576633399107909],
            [34.61829899093339, 1.575776924554482],
            [34.617736391342305, 1.574702465080631],
            [34.618664539677, 1.574562539756778],
            [34.619148072251726, 1.573467721630381],
            [34.61967052074287, 1.573540963291501],
            [34.61946186006868, 1.572825218402409],
            [34.6214606151691, 1.572569650586233],
            [34.62152894192793, 1.572975077261962],
            [34.62198025642498, 1.573024240591854],
            [34.62198904284676, 1.571832502075968],
            [34.622534560074406, 1.572001156567503],
            [34.62239597428059, 1.57145249512359],
            [34.62299502121771, 1.570810935947968],
            [34.62228397322928, 1.57052255936753],
            [34.62286135729333, 1.569594889694695],
            [34.623217934562184, 1.569596083107756],
            [34.62319419658082, 1.569078659906938],
            [34.62451253354907, 1.568699523493152],
            [34.62662894639213, 1.571828938004175],
            [34.62736130601237, 1.572451078114512],
            [34.62833717195665, 1.572287452330918],
            [34.62866785438914, 1.572574578683753],
            [34.62894081018317, 1.574243931529254],
            [34.63007095189604, 1.575725452594258],
            [34.62987481283858, 1.576535191149943],
            [34.63122887760229, 1.576874080692652],
            [34.631644446337575, 1.577261023513048],
            [34.63385573744434, 1.577196829978373],
            [34.63485151903847, 1.577557641672229],
            [34.638660648930994, 1.580025233652259],
            [34.64021834559995, 1.581555810460854],
            [34.64357166492741, 1.586202770105264],
            [34.6455659275531, 1.589784574205415],
            [34.64779623599442, 1.595214349776813],
            [34.6488598224262, 1.596052063147797],
            [34.64905513683022, 1.596970349803419],
            [34.649838543216454, 1.597115921820333],
            [34.65115837947293, 1.598669535841122],
            [34.65241686977863, 1.598864339596972],
            [34.65372619664459, 1.601847985082736],
            [34.65656950016442, 1.603120568825753],
            [34.65674018186503, 1.604157933019122],
            [34.65895807918242, 1.606429514707716],
            [34.660292770878726, 1.609198715186054],
            [34.6596178279782, 1.620184308152745],
            [34.65988097237268, 1.645902812393295],
            [34.66044400315511, 1.646929534625986],
            [34.6616020231845, 1.647862854913879],
            [34.661214693888496, 1.64881497500437],
            [34.66186396832809, 1.64942487240052],
            [34.6614089833148, 1.649876260250931],
            [34.6612779119283, 1.651544253084094],
            [34.65980333906753, 1.651634803360935],
            [34.659658082384404, 1.651991852934316],
            [34.66010574792478, 1.652541504654606],
            [34.65919803895771, 1.653134404672709],
            [34.65926622647769, 1.653563665511482],
            [34.66005140074838, 1.653470880346796],
            [34.659734332284025, 1.654566230978961],
            [34.66032409872594, 1.655187864487301],
            [34.659785994396, 1.655627053407293],
            [34.65992461702077, 1.656175705611226],
            [34.65911427644736, 1.656459085584177],
            [34.658844410857924, 1.657602265102452],
            [34.65917354908645, 1.658103861156812],
            [34.658835852608206, 1.658770134585241],
            [34.65906834019702, 1.659485933588933],
            [34.65858958396466, 1.659937242824881],
            [34.658842888213506, 1.661058300533728],
            [34.65863718928481, 1.668053121270999],
            [34.66043774549083, 1.670525860152754],
            [34.6607559233746, 1.672528988915269],
            [34.660526806264734, 1.674601871452414],
            [34.6591406437976, 1.677231114951496],
            [34.65891876261735, 1.681568310711947],
            [34.66023691902426, 1.684992856769291],
            [34.660353624552705, 1.688544605874054],
            [34.66154569971452, 1.689704429481814],
            [34.662754048755986, 1.693521889624034],
            [34.66419147358482, 1.69526647043813],
            [34.66666345399041, 1.69695479042087],
            [34.66760601759049, 1.698101890845768],
            [34.66764158279091, 1.699746594581822],
            [34.66846994087396, 1.701882458685321],
            [34.66969813729334, 1.702982806953458],
            [34.6715849883605, 1.708303995792442],
            [34.67143554283321, 1.715763728471073],
            [34.67242081054527, 1.717578306478575],
            [34.6723465450241, 1.721248594169037],
            [34.673029365251345, 1.723789158655576],
            [34.673424015816884, 1.729157347970768],
            [34.67236966226961, 1.731299578608236],
            [34.67296694222057, 1.735216271194626],
            [34.67125657147915, 1.743241127058675],
            [34.671306666030986, 1.746679274604885],
            [34.67076199052476, 1.748319622892368],
            [34.67209151421323, 1.755420907949082],
            [34.67198868406269, 1.766361636103684],
            [34.671468025015585, 1.768359560696787],
            [34.666838439519545, 1.778185987215805],
            [34.66512227194962, 1.78378628589268],
            [34.66173526490071, 1.78912957438938],
            [34.65999531712856, 1.794467872196994],
            [34.65561219880382, 1.803916153108813],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 816,
        District: "NAKAPIRIPIRIT",
        County: "CHEKWII",
        Subcounty: "NAMALU",
        Population: 27732,
        Key: "NAKAPIRIPIRITNAMALU",
        Dist2: "Nakapiripirit",
        "Sub Country": "Namalu",
        id2_original: "NakapiripiritNamalu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.90404866579555, 2.554259804098606],
            [34.89805240139258, 2.585298590905554],
            [34.89461024227678, 2.590136469343107],
            [34.881271526932146, 2.586699391746764],
            [34.87909363339104, 2.569680364732541],
            [34.86899271851991, 2.567865047997875],
            [34.85293029147089, 2.580855857004744],
            [34.839281315095114, 2.601499177021385],
            [34.83235887415952, 2.618161199317803],
            [34.79993536167055, 2.653115834474309],
            [34.791608513484334, 2.679714457126803],
            [34.7902767404144, 2.681742918793917],
            [34.785049910001746, 2.686830036506421],
            [34.783845915992735, 2.686752848371378],
            [34.78324332699846, 2.686306318234386],
            [34.782926793031685, 2.684596098457123],
            [34.7835272036114, 2.683542479860292],
            [34.783395278825395, 2.682805759014582],
            [34.7826350193291, 2.681912053203611],
            [34.77993733092017, 2.680494816212082],
            [34.7793072067658, 2.679100866073719],
            [34.77905536766918, 2.676877327481641],
            [34.77753737114588, 2.676826910711014],
            [34.77677772699554, 2.676354286026253],
            [34.77565331743248, 2.67701388302401],
            [34.77463078760245, 2.675725773286439],
            [34.772091765927215, 2.675439966388363],
            [34.77201208536154, 2.674624205048567],
            [34.77290114620159, 2.674096545832748],
            [34.77263720410311, 2.672544142726476],
            [34.77182480009951, 2.671782087880174],
            [34.7704390930782, 2.67273155987474],
            [34.769991283807386, 2.670705685579791],
            [34.76873458294575, 2.670365363223087],
            [34.76896484001766, 2.666680440747485],
            [34.76770615028598, 2.664945234874195],
            [34.76697396224399, 2.665367395559632],
            [34.7661000344232, 2.66732938431383],
            [34.76282760030223, 2.666597185307636],
            [34.76128212341605, 2.665625620469557],
            [34.7600028883155, 2.667838231874695],
            [34.75793513721137, 2.667683297752339],
            [34.75639313590703, 2.669159363951013],
            [34.753593441102666, 2.669610798919532],
            [34.752728556621825, 2.668743520950353],
            [34.75175996433641, 2.66856068322269],
            [34.75175947924615, 2.668218536874265],
            [34.748915404971804, 2.666026745407722],
            [34.74765480003191, 2.666256148425973],
            [34.746360377114826, 2.665445144983564],
            [34.74493718788829, 2.665024493656917],
            [34.74422617583251, 2.665220597340184],
            [34.74192755051379, 2.663045435518765],
            [34.74073082477378, 2.662721990109594],
            [34.73989216481103, 2.664121288170327],
            [34.73737011231154, 2.663994813757046],
            [34.73649477503408, 2.662305320272902],
            [34.73694218724951, 2.658565564531008],
            [34.73235331430052, 2.648573945324125],
            [34.73300993516248, 2.644134840058353],
            [34.73239334053462, 2.64247747902695],
            [34.73219606241338, 2.640104224983319],
            [34.73277531946478, 2.638152558476666],
            [34.734581844077546, 2.635256266031052],
            [34.734945074269454, 2.629061809850009],
            [34.73555572564337, 2.62642731255818],
            [34.73513187713613, 2.623859286241677],
            [34.73435427296832, 2.622657352593206],
            [34.734208425193735, 2.621619164525518],
            [34.7299031970923, 2.621572100790616],
            [34.728656265409356, 2.621137868071284],
            [34.72789635535771, 2.620212493281894],
            [34.72686782388326, 2.620976864549653],
            [34.72513289679525, 2.620325320373819],
            [34.72318308191149, 2.621036469129749],
            [34.720744149626896, 2.62071286830034],
            [34.71890039793045, 2.619734486966239],
            [34.71694507637399, 2.616412919041239],
            [34.720251761460126, 2.617280295496172],
            [34.72361159267507, 2.61738464442369],
            [34.7246395294648, 2.616184310868348],
            [34.728267302976164, 2.614108441829824],
            [34.728854332251416, 2.612824680081637],
            [34.719447218613546, 2.608973229921753],
            [34.71570999975784, 2.606751123560992],
            [34.71169646630728, 2.603407616958444],
            [34.70752383852492, 2.601950155529242],
            [34.70632637257312, 2.601041379087214],
            [34.704967962658344, 2.600653049748665],
            [34.70194501584462, 2.60064090536882],
            [34.69654116521868, 2.597201658603011],
            [34.690202774744826, 2.596039663081799],
            [34.68488134993611, 2.593787021605863],
            [34.6815180835635, 2.593141228219483],
            [34.67930146454882, 2.591664750778154],
            [34.67622347526268, 2.586694033371543],
            [34.6754120836604, 2.584321509340667],
            [34.674408891863486, 2.583607506773995],
            [34.67295077074882, 2.581138285298562],
            [34.671829560984825, 2.57670143461513],
            [34.67172726173857, 2.572637167726127],
            [34.66822913937722, 2.567699445628753],
            [34.66564814661527, 2.559427679036427],
            [34.663575654203065, 2.556829158834967],
            [34.66347702547308, 2.555561184925497],
            [34.664087609473384, 2.552699035071869],
            [34.6621451697581, 2.550653095485753],
            [34.66097807135445, 2.548150929536456],
            [34.658259468369096, 2.545910884183796],
            [34.65792502019894, 2.543527398666589],
            [34.65819329487201, 2.542800307644348],
            [34.65895435746217, 2.542607903858379],
            [34.661383555602356, 2.538871880154871],
            [34.666344861085015, 2.538527131928657],
            [34.668247424584806, 2.535691240007967],
            [34.669393186203834, 2.5329127186499],
            [34.672235166505274, 2.530101056067649],
            [34.67293414562784, 2.5282136378524],
            [34.67277517706021, 2.525248717738364],
            [34.6718046345323, 2.524664752388337],
            [34.66886375600631, 2.524490756062719],
            [34.66664467740434, 2.524164227502337],
            [34.66489795004676, 2.52330815120537],
            [34.66435377220722, 2.522450521765139],
            [34.66325981373568, 2.52210320876131],
            [34.664792101556834, 2.518928457832608],
            [34.6659809338005, 2.51838856419858],
            [34.66651674922306, 2.518806602433439],
            [34.66740888679298, 2.518805452803345],
            [34.66934893609124, 2.518363802719807],
            [34.66550738150856, 2.514682327126515],
            [34.66537447755892, 2.512330510047688],
            [34.66757809974809, 2.508407704501279],
            [34.66861362460701, 2.505401063248237],
            [34.671855735197255, 2.500823606637316],
            [34.67574989332634, 2.49820530028243],
            [34.68172316894288, 2.495976313614898],
            [34.682111583403746, 2.494930493240168],
            [34.680935710256406, 2.489705407627616],
            [34.681192224185786, 2.487091779188723],
            [34.68222938218189, 2.485391804703998],
            [34.68443642335905, 2.484212989571246],
            [34.692355338489875, 2.48270428692461],
            [34.692048393140446, 2.481628981218603],
            [34.69113218700913, 2.482039951901411],
            [34.68965302285893, 2.480300242447148],
            [34.68552586510132, 2.478820044517393],
            [34.68379271128769, 2.477592886390644],
            [34.68084850630021, 2.477715524622874],
            [34.68233761929217, 2.475853788554515],
            [34.68546122772337, 2.473256981096064],
            [34.68769996505702, 2.469316884975677],
            [34.69081028740516, 2.465675779250463],
            [34.690880776408896, 2.464787415582332],
            [34.68985182182795, 2.462748094779476],
            [34.689587301214445, 2.461187943537009],
            [34.689965752460466, 2.458450608318491],
            [34.689801594325445, 2.451284590643595],
            [34.690181231347665, 2.449483555565243],
            [34.69215460634639, 2.447350212166428],
            [34.69313743243748, 2.447811409210285],
            [34.70744002031905, 2.470882486954197],
            [34.708988294558985, 2.472435720723129],
            [34.710895403534124, 2.475543721978474],
            [34.71661324769119, 2.482116110520299],
            [34.72899661910421, 2.492148996154444],
            [34.73018654190261, 2.492506319361226],
            [34.735783091936725, 2.497164554138149],
            [34.739475599844134, 2.501107488374027],
            [34.744263411899325, 2.503938731408526],
            [34.744609062061095, 2.508059225554217],
            [34.74516033569308, 2.509374426904163],
            [34.74712584953474, 2.511556258377452],
            [34.752172876753384, 2.515125606431514],
            [34.75560713159299, 2.519666389044958],
            [34.76047936552198, 2.520446252118179],
            [34.76140532645897, 2.521175897251101],
            [34.76269803539047, 2.521274134350841],
            [34.767996287258114, 2.523042338954],
            [34.77623919147427, 2.526655881468546],
            [34.782351298124695, 2.531899748990196],
            [34.78345895051443, 2.535079178841227],
            [34.784265882879644, 2.540916838706187],
            [34.786133702239205, 2.542364936983437],
            [34.78861945381809, 2.543413496812963],
            [34.804771718683696, 2.546546892573738],
            [34.80797522597124, 2.546608116916077],
            [34.81098075624824, 2.545354616535154],
            [34.81254793463503, 2.544037387541693],
            [34.81877037236867, 2.545820118251899],
            [34.82005100345119, 2.546553689694609],
            [34.824804303131494, 2.546914618196137],
            [34.826998929591404, 2.547646876079269],
            [34.82949040164205, 2.547859229818291],
            [34.830458856485194, 2.547289202753],
            [34.83417503050877, 2.547771289124823],
            [34.836113311024256, 2.547606040440006],
            [34.83934635132508, 2.549144847548324],
            [34.84128520586404, 2.549385758936428],
            [34.84435717104788, 2.551249713555304],
            [34.84629602468851, 2.551490615574942],
            [34.8501729127063, 2.551403774475027],
            [34.855581636692634, 2.549365095698466],
            [34.859053712402336, 2.548628953832375],
            [34.86624389081848, 2.549755745261282],
            [34.86980023479005, 2.551456438051825],
            [34.88538971052008, 2.552083386895373],
            [34.90404866579555, 2.554259804098606],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 817,
        District: "MOROTO",
        County: "MATHENIKO",
        Subcounty: "KATIKEKILE",
        Population: 9847,
        Key: "MOROTOKATIKEKILE",
        Dist2: "Moroto",
        "Sub Country": "Katikekile",
        id2_original: "MorotoKatikekile",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.310332003457912, -0.495273700802032],
            [30.31017269083554, -0.492038280583218],
            [30.30886757437333, -0.490085697841639],
            [30.306431787988874, -0.48771695003188],
            [30.305067132986238, -0.483432739162194],
            [30.30502116439654, -0.476853590466821],
            [30.30534354998908, -0.474901666292459],
            [30.30680515387209, -0.472651954799451],
            [30.30848574097024, -0.471432572711738],
            [30.309299451124264, -0.470276113480199],
            [30.310434925236667, -0.462450243692284],
            [30.308813035855785, -0.461274779741068],
            [30.307044449792436, -0.459285907405084],
            [30.30760836361877, -0.455770615336227],
            [30.305902375757622, -0.452136992859637],
            [30.308121671751888, -0.447140195200078],
            [30.30762233242143, -0.444781279940794],
            [30.306977733712902, -0.444211696021126],
            [30.307127549346095, -0.441048701021445],
            [30.30592452731421, -0.438174412077726],
            [30.3058187668592, -0.436128482212576],
            [30.303748132162998, -0.437441810639168],
            [30.30118213857135, -0.440999873642367],
            [30.300589311569265, -0.443383038505087],
            [30.298393013344626, -0.447446492513422],
            [30.29724611266181, -0.447880516464525],
            [30.296001024321814, -0.447073214360336],
            [30.29522463108302, -0.445719832070663],
            [30.294139544373216, -0.445694647665392],
            [30.286627317232742, -0.45337572287557],
            [30.284000259761367, -0.455038137818464],
            [30.283370432051036, -0.457554041514279],
            [30.283690627550914, -0.45877068442935],
            [30.282875984945612, -0.46091793285536],
            [30.282037216286756, -0.46157549989487],
            [30.281716271591925, -0.462531228668265],
            [30.279867419261286, -0.460519531229143],
            [30.278979773267793, -0.460047508728535],
            [30.27804325263462, -0.458383718769249],
            [30.277499990178356, -0.458429714632893],
            [30.27124416565889, -0.463278913398977],
            [30.267821526934213, -0.467032895967008],
            [30.26524553329684, -0.469068777879511],
            [30.265134280542146, -0.471438945144629],
            [30.26063236810587, -0.477094072813313],
            [30.257042664297938, -0.475756753066535],
            [30.255833574146326, -0.475740254278492],
            [30.255388378074667, -0.475163555722439],
            [30.254212851677014, -0.474743342762159],
            [30.255862013011605, -0.477710706222401],
            [30.257699117174973, -0.48226842915255],
            [30.25769886744331, -0.482980429247819],
            [30.25701535281835, -0.483725487889459],
            [30.25083646451139, -0.485318973054403],
            [30.250052385286995, -0.483636997105745],
            [30.2475072047622, -0.484001653397364],
            [30.245667413737817, -0.486687104724245],
            [30.24422150701605, -0.485885112334985],
            [30.24338048807737, -0.486110530157834],
            [30.242853788758325, -0.485704004110655],
            [30.24131787892993, -0.485522768325298],
            [30.237921260805784, -0.486736586636289],
            [30.238382474737254, -0.488755660332914],
            [30.24042822430346, -0.49100666093318],
            [30.242126137208505, -0.491865858015297],
            [30.24033035375156, -0.496401576050664],
            [30.23817774059917, -0.497539307050614],
            [30.236528778690598, -0.499065825649795],
            [30.236012487252424, -0.499734327388163],
            [30.235898759639124, -0.501360893309324],
            [30.235334644590168, -0.502011299845225],
            [30.233697427255617, -0.502181083897655],
            [30.23346921025767, -0.509955039165448],
            [30.235902386137937, -0.510600864512069],
            [30.237219611890183, -0.513993952265122],
            [30.241677485317943, -0.518710093850122],
            [30.24471669882484, -0.522873831472561],
            [30.245420831582212, -0.523044283290655],
            [30.24683664384362, -0.524323256557677],
            [30.248878846861086, -0.526887650141703],
            [30.249474125365577, -0.526371575438266],
            [30.251670837713583, -0.525875518805075],
            [30.25557396911407, -0.52669959668413],
            [30.261102221135463, -0.526503221579404],
            [30.261909450843028, -0.526142099699088],
            [30.267142533530073, -0.526460693536076],
            [30.27113203614849, -0.528125254265469],
            [30.27389840076089, -0.53021402579201],
            [30.27418734117706, -0.53119015259418],
            [30.273995885037202, -0.534063844117742],
            [30.274669997894378, -0.536296291972342],
            [30.27576856562163, -0.537534857159902],
            [30.279157331571884, -0.539208229674794],
            [30.278865033253165, -0.538855652936072],
            [30.279762864345347, -0.537283604037575],
            [30.280546144069124, -0.536877284242178],
            [30.280803603026182, -0.535756800897516],
            [30.281657270244065, -0.535088435899593],
            [30.28241847117478, -0.53513395963441],
            [30.28293688443367, -0.533868996316331],
            [30.282742544701733, -0.532748309412046],
            [30.283680601454044, -0.530053847762171],
            [30.285873320790614, -0.529251222079813],
            [30.288320257064385, -0.529341872596836],
            [30.2946524491628, -0.531581189487215],
            [30.296320595492585, -0.532447031974151],
            [30.297494848977454, -0.53485144550554],
            [30.30145647956756, -0.535368315373849],
            [30.30210137741506, -0.536136765350822],
            [30.304172719085418, -0.536770287910228],
            [30.30764961515491, -0.53661819004264],
            [30.307696177531035, -0.534107407821355],
            [30.30904467543497, -0.530961710949573],
            [30.309153058072305, -0.529537791287197],
            [30.30908632941638, -0.528073110176571],
            [30.307751109510676, -0.524372712132873],
            [30.308694980159466, -0.52237587739916],
            [30.30919328642736, -0.518878657599561],
            [30.308126626859007, -0.514409371319866],
            [30.307875134512074, -0.512967709588869],
            [30.30850363451239, -0.509344020299414],
            [30.310403804001954, -0.502259567587222],
            [30.3099335584086, -0.498617340776455],
            [30.310332003457912, -0.495273700802032],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1480,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "KYABUGIMBI",
        Population: 19275,
        Key: "BUSHENYIKYABUGIMBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.71228183082301, -0.304366637885028],
            [31.70450921711597, -0.306271458755217],
            [31.69709645773198, -0.30699930110419],
            [31.692296515725474, -0.306732830476843],
            [31.69115585743559, -0.305828189605505],
            [31.689172472509675, -0.301655748016185],
            [31.672160451645194, -0.301999396454791],
            [31.671373708017672, -0.30093588672828],
            [31.670897118521786, -0.297422318126009],
            [31.669848268053922, -0.296454173626959],
            [31.666643265071446, -0.295045765178761],
            [31.65921186744194, -0.296488747522759],
            [31.656472799936076, -0.297456429392644],
            [31.652436491498097, -0.296143382254039],
            [31.65106231794672, -0.296151431949767],
            [31.64548075091323, -0.298960132217166],
            [31.64027091303247, -0.302356378390634],
            [31.636451781297566, -0.303324556503191],
            [31.630240833016437, -0.30376816621266],
            [31.62162719228591, -0.302776932301634],
            [31.610995082926024, -0.298790578412458],
            [31.597248534239043, -0.295704470362121],
            [31.597105688634123, -0.297395802911002],
            [31.590376486994217, -0.321453550635046],
            [31.589590377577316, -0.325586816621625],
            [31.584768929004603, -0.367688599403284],
            [31.597031716862066, -0.370322519275962],
            [31.59938419348708, -0.370250528894236],
            [31.603126848946882, -0.369355697949108],
            [31.609363566300253, -0.373354409647669],
            [31.615136939816633, -0.37802238311094],
            [31.62009076951948, -0.381071230628397],
            [31.624581281436484, -0.382718084439236],
            [31.6327075996001, -0.384872044350416],
            [31.63881398398219, -0.388047732234727],
            [31.64067958540131, -0.386745592909743],
            [31.646334908611223, -0.387388667773957],
            [31.651456526541192, -0.384341385535394],
            [31.657350734243046, -0.38005505543864],
            [31.658682828011557, -0.375415260813189],
            [31.660975665484862, -0.374737250321001],
            [31.66306699287364, -0.373516502706158],
            [31.66839024755057, -0.372133444453081],
            [31.670766358850717, -0.372224254127582],
            [31.675660869202094, -0.374757570676391],
            [31.680899767582282, -0.380076780715789],
            [31.68151740605253, -0.380321077568585],
            [31.687030289696047, -0.380439498964395],
            [31.692032535897784, -0.3799970605813],
            [31.693577379471677, -0.379617401358016],
            [31.695811373700614, -0.37834240814603],
            [31.700267723585636, -0.374797431666065],
            [31.703108450737254, -0.369642193481655],
            [31.704202281648016, -0.366169067378749],
            [31.70445225763875, -0.363482735132862],
            [31.704038244785565, -0.354600475809573],
            [31.70458525591152, -0.352058902737633],
            [31.705747958858474, -0.349761619469182],
            [31.706736498234807, -0.348007022161218],
            [31.709303361395644, -0.345447630440965],
            [31.70651174424227, -0.342733752127288],
            [31.702044735846393, -0.340444764191156],
            [31.697756193053042, -0.336744775943175],
            [31.69592711713337, -0.333569746571954],
            [31.695380998932833, -0.3316069041521],
            [31.6947758389602, -0.328034058037609],
            [31.69509730827113, -0.323737735262136],
            [31.695560555988433, -0.321711718787955],
            [31.69616705984073, -0.321349991783476],
            [31.708203186582324, -0.320329444366365],
            [31.7102586622081, -0.320555818972462],
            [31.71258769729579, -0.320194314705805],
            [31.71460765533187, -0.319362430217173],
            [31.714833610371922, -0.317598660320865],
            [31.71231947562331, -0.304555403600481],
            [31.71228183082301, -0.304366637885028],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1495,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "KKINGO",
        Population: 34388,
        Key: "LWENGOKKINGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.419741108008576, 1.155038966426783],
            [31.421231024992743, 1.156424807383079],
            [31.42567642980436, 1.158757644941706],
            [31.43320917266927, 1.160463387596277],
            [31.43978718605025, 1.160836956194954],
            [31.442873549431468, 1.161985360041277],
            [31.448199824244366, 1.166501099367495],
            [31.449521913475564, 1.16816638652724],
            [31.45039969866218, 1.175823816772871],
            [31.45311444518003, 1.184444028774788],
            [31.450130781693684, 1.186886830684705],
            [31.458731297139614, 1.195174343767849],
            [31.46376432770782, 1.198432333559854],
            [31.478904642202505, 1.200364367800566],
            [31.484196926561737, 1.200145388624698],
            [31.48537226970305, 1.201403728302777],
            [31.484488481973692, 1.204584429525573],
            [31.482796611137267, 1.206950878145962],
            [31.48235423847055, 1.209392009271606],
            [31.482720679241243, 1.211315727282046],
            [31.48264515248541, 1.214940763898801],
            [31.48462893985659, 1.216347531433676],
            [31.492048272213516, 1.224341729947048],
            [31.496343910799272, 1.227758848456626],
            [31.493439107716785, 1.234533481181046],
            [31.488953003832908, 1.238747853718755],
            [31.48182016847458, 1.243996403066888],
            [31.480790229340087, 1.245549409568659],
            [31.477910765036793, 1.246163273694644],
            [31.476158578617213, 1.247174292991511],
            [31.472924263607048, 1.247468324540505],
            [31.464835044067996, 1.254121828521034],
            [31.452555775718317, 1.261364588027379],
            [31.44711555500152, 1.263062857712036],
            [31.443363511248652, 1.26875703982306],
            [31.44257437181427, 1.270595226880094],
            [31.44566179969911, 1.272191965496891],
            [31.442223920157314, 1.270436957494038],
            [31.43877513955957, 1.269515194485872],
            [31.428137178573927, 1.269647634723897],
            [31.418406658857386, 1.268961749803531],
            [31.402455072236332, 1.27056692792516],
            [31.39972183928825, 1.270215414644489],
            [31.392077611004986, 1.267147463502275],
            [31.383129301118718, 1.261611156222603],
            [31.37814447414866, 1.25685259114936],
            [31.377074650713865, 1.255244717443134],
            [31.37462648374814, 1.249674701597278],
            [31.372823488616127, 1.246933654505335],
            [31.37037349537544, 1.240223075751778],
            [31.369798447829478, 1.239224819460106],
            [31.368961067966, 1.238891382623668],
            [31.35882111590591, 1.237791023791522],
            [31.349297275180028, 1.239264410630423],
            [31.34185391288925, 1.238227733921781],
            [31.337031996294282, 1.238687073541027],
            [31.32302151628862, 1.238640096343472],
            [31.318340755567494, 1.236704782729613],
            [31.31541557420275, 1.234321528873781],
            [31.31337156736821, 1.229992755472815],
            [31.31136938699159, 1.227815346700084],
            [31.30863274853028, 1.22366125062614],
            [31.30687656909927, 1.222287697257691],
            [31.304793813434966, 1.219356638944859],
            [31.30280320695248, 1.217814049652237],
            [31.299957653152852, 1.2168542852831],
            [31.29807563771683, 1.214608705334077],
            [31.29335268941502, 1.210545595754464],
            [31.292423572696453, 1.209423035558213],
            [31.292442540623668, 1.20815823494809],
            [31.2936657370202, 1.207253689607203],
            [31.296391242660214, 1.207653319710292],
            [31.297113411791848, 1.207174481174167],
            [31.29766217463261, 1.203358554656844],
            [31.300673182836203, 1.20066554002974],
            [31.301934323171995, 1.19809802768293],
            [31.302726930103372, 1.197673486849443],
            [31.306336174065404, 1.197856606128994],
            [31.309245020464996, 1.197370077974475],
            [31.313583876100783, 1.197318514260288],
            [31.319468650593823, 1.197801460725426],
            [31.328232150076705, 1.193836796900709],
            [31.3331388909907, 1.192664151527782],
            [31.342035074335964, 1.186113028843466],
            [31.345662175907503, 1.178545787852767],
            [31.351513746871017, 1.172101235076732],
            [31.353986189010676, 1.170827559116975],
            [31.35918767255926, 1.16978157960756],
            [31.36074844326315, 1.168959532747808],
            [31.367437060815156, 1.162859017299747],
            [31.378073049998736, 1.157918313913913],
            [31.38324584225549, 1.156510478427196],
            [31.38632760177085, 1.158176291496746],
            [31.389623760398493, 1.161054088317377],
            [31.39209274312596, 1.162439198845231],
            [31.397679465590898, 1.162994072738511],
            [31.406859966621912, 1.162067804832325],
            [31.411515719143836, 1.160985191800961],
            [31.41605313479676, 1.158627317065445],
            [31.419741108008576, 1.155038966426783],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1608,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "BANANYWA",
        Population: 31146,
        Key: "KYANKWANZIBANANYWA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Bananywa",
        id2_original: "KyankwanziBananywa",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.58300254291534, 1.357096717167118],
            [31.58017889722886, 1.358503078514162],
            [31.577614211584283, 1.361898488978944],
            [31.57285756567952, 1.362074817964445],
            [31.569794059032382, 1.363643641015889],
            [31.564684030267934, 1.365375710642244],
            [31.56162146146197, 1.365076987054233],
            [31.559273639008417, 1.363758954723475],
            [31.556113499687882, 1.363648101684244],
            [31.54937262084757, 1.364673972564821],
            [31.545163142375653, 1.363923398636577],
            [31.54000627455395, 1.362014312869015],
            [31.536030882672037, 1.362436840880257],
            [31.532553840177115, 1.362026465436947],
            [31.530872317932747, 1.361556055401149],
            [31.52908041340124, 1.360445978200674],
            [31.524704168985025, 1.357033834773286],
            [31.51657922973532, 1.348598223186776],
            [31.5141536248563, 1.345979048676871],
            [31.510111623794376, 1.337973329378742],
            [31.507673053530844, 1.335436742700907],
            [31.502647249909085, 1.328127799320329],
            [31.50025213654574, 1.325726752538321],
            [31.49100622199235, 1.320538472754086],
            [31.481401562535343, 1.314182658166957],
            [31.474145600490917, 1.311505329680947],
            [31.469805021886433, 1.310478320258242],
            [31.464927062095807, 1.30812920326928],
            [31.462909937346147, 1.306471582881953],
            [31.457705821733768, 1.300797811161288],
            [31.455690410969662, 1.297309332521911],
            [31.45584893576952, 1.293136162385759],
            [31.45701922049748, 1.289711710446283],
            [31.457276938169368, 1.287708161292547],
            [31.45697157924471, 1.283381091289642],
            [31.456589582348247, 1.282523589482844],
            [31.45513505898629, 1.280214116157875],
            [31.451279914689948, 1.275959356884483],
            [31.449327209925936, 1.27419949006811],
            [31.44566179969911, 1.272191965496891],
            [31.44257437181427, 1.270595226880094],
            [31.443363511248652, 1.26875703982306],
            [31.44711555500152, 1.263062857712036],
            [31.452555775718317, 1.261364588027379],
            [31.464835044067996, 1.254121828521034],
            [31.472924263607048, 1.247468324540505],
            [31.476158578617213, 1.247174292991511],
            [31.477910765036793, 1.246163273694644],
            [31.480790229340087, 1.245549409568659],
            [31.48182016847458, 1.243996403066888],
            [31.488953003832908, 1.238747853718755],
            [31.493439107716785, 1.234533481181046],
            [31.496343910799272, 1.227758848456626],
            [31.492048272213516, 1.224341729947048],
            [31.48462893985659, 1.216347531433676],
            [31.48264515248541, 1.214940763898801],
            [31.482720679241243, 1.211315727282046],
            [31.48235423847055, 1.209392009271606],
            [31.482796611137267, 1.206950878145962],
            [31.484488481973692, 1.204584429525573],
            [31.48537226970305, 1.201403728302777],
            [31.484196926561737, 1.200145388624698],
            [31.478904642202505, 1.200364367800566],
            [31.46376432770782, 1.198432333559854],
            [31.458731297139614, 1.195174343767849],
            [31.450130781693684, 1.186886830684705],
            [31.45311444518003, 1.184444028774788],
            [31.45039969866218, 1.175823816772871],
            [31.449521913475564, 1.16816638652724],
            [31.448199824244366, 1.166501099367495],
            [31.442873549431468, 1.161985360041277],
            [31.43978718605025, 1.160836956194954],
            [31.43320917266927, 1.160463387596277],
            [31.42567642980436, 1.158757644941706],
            [31.421231024992743, 1.156424807383079],
            [31.419741108008576, 1.155038966426783],
            [31.4213455799544, 1.152218195891719],
            [31.422628055278196, 1.147914029951695],
            [31.423029057831112, 1.143745026152017],
            [31.42272577221816, 1.136609241711467],
            [31.42368066878876, 1.132051652994032],
            [31.426262857208346, 1.128761093589306],
            [31.42615295102827, 1.122719715175646],
            [31.42757165496659, 1.121852271640417],
            [31.428892957273597, 1.119881417208954],
            [31.431011566497556, 1.119710727688754],
            [31.431954028588002, 1.118906328480755],
            [31.435151251261786, 1.114604841596579],
            [31.439837902236242, 1.118344304941838],
            [31.44748088365787, 1.122890749407235],
            [31.458468578546555, 1.124116501176798],
            [31.465578713477658, 1.124120280559973],
            [31.47344218997904, 1.119364601928216],
            [31.476501048742893, 1.116433858267996],
            [31.480225386655754, 1.119456525154114],
            [31.481862437801936, 1.12155561855435],
            [31.482732601681683, 1.122116809796882],
            [31.48530473256337, 1.125771989106822],
            [31.486506696379802, 1.126523283800827],
            [31.487733464477895, 1.129806953407662],
            [31.489272705259353, 1.131562328346381],
            [31.48977040067285, 1.132937302374271],
            [31.49247411408238, 1.134657116292899],
            [31.495798723253365, 1.138439333113447],
            [31.498043399349324, 1.142220987229566],
            [31.501118520314765, 1.145216240405795],
            [31.503074648558346, 1.148798781705041],
            [31.50297179415325, 1.151105002131189],
            [31.50345801718225, 1.152941235596809],
            [31.505973530844802, 1.1532319838225],
            [31.507617690359893, 1.151984750290632],
            [31.509159570391656, 1.151949387173375],
            [31.510752614868732, 1.151262865343067],
            [31.516169026637264, 1.152712798047319],
            [31.518817587979928, 1.151502255751374],
            [31.521759396262247, 1.151747992352995],
            [31.52388977611138, 1.151296892045574],
            [31.527085299172654, 1.151805040912864],
            [31.527539458634216, 1.15324588153756],
            [31.532924601844346, 1.159342014192566],
            [31.53384132989684, 1.161694021743078],
            [31.533958352530593, 1.180696245547354],
            [31.54236522443891, 1.186850880635014],
            [31.549707916129066, 1.190816224519232],
            [31.560550445064464, 1.195696915650991],
            [31.56306585901404, 1.196376579309525],
            [31.567489074539818, 1.196559802857532],
            [31.57158683942133, 1.197828187848335],
            [31.575501710904256, 1.200362705383869],
            [31.576860401093384, 1.201747229602782],
            [31.578665540503998, 1.202670718966137],
            [31.582926062148694, 1.20367689765589],
            [31.585219045149064, 1.203388673015796],
            [31.586821354849977, 1.204492946452667],
            [31.590625130783394, 1.205815440170226],
            [31.591415940185904, 1.20682884483825],
            [31.591798183220742, 1.213241644305797],
            [31.593023538268895, 1.217258078517145],
            [31.593063279737056, 1.219139371306914],
            [31.593590353653628, 1.21970945767607],
            [31.593589864071774, 1.220650093050542],
            [31.59443171395207, 1.221256523864922],
            [31.59497871429826, 1.222930060212363],
            [31.595790016967324, 1.223418896415664],
            [31.59660027848899, 1.225906585916849],
            [31.596689680622692, 1.229470200089784],
            [31.597804949827708, 1.230800346905377],
            [31.59779409638244, 1.232220341534283],
            [31.599374942636302, 1.235730484794932],
            [31.5996883648389, 1.237810909647054],
            [31.608922143152803, 1.234767770282914],
            [31.613955462978538, 1.23221983051107],
            [31.615254367590545, 1.231994394729837],
            [31.619332348874583, 1.232692969690978],
            [31.628886581403126, 1.237844391025777],
            [31.629879604271036, 1.240495010208098],
            [31.633641109080436, 1.245064560520976],
            [31.637415164252683, 1.247101598779992],
            [31.640113918961838, 1.249753119339112],
            [31.641906919438, 1.252594109516205],
            [31.642076577059218, 1.254149896843204],
            [31.644753795557758, 1.256647653894159],
            [31.64524443650132, 1.258203611244075],
            [31.64704046609663, 1.259000491399534],
            [31.648185964509278, 1.2614319713917],
            [31.65015834507295, 1.264148607384844],
            [31.652977271909247, 1.265805282624511],
            [31.655143318468394, 1.270102701083045],
            [31.656999679816508, 1.27534966783257],
            [31.657839566877946, 1.279266515866945],
            [31.657481236995945, 1.283019925292932],
            [31.65845589290954, 1.284829404601684],
            [31.658556931819437, 1.287090663462453],
            [31.658234275834005, 1.288130646297621],
            [31.65898266319552, 1.290853535313777],
            [31.660098515407157, 1.292780676373434],
            [31.659643997517783, 1.295701912496163],
            [31.660350070636156, 1.29984481925475],
            [31.660838853863716, 1.300650070088194],
            [31.66019349607876, 1.305434436541521],
            [31.659072721099367, 1.307496053273505],
            [31.658936962303752, 1.308771299787607],
            [31.657583865923876, 1.31043481545081],
            [31.65604413466227, 1.318158249535395],
            [31.654765240023206, 1.322291028408028],
            [31.652748748585825, 1.325600320663232],
            [31.651895701205476, 1.328991649319845],
            [31.650181889018246, 1.331866947148759],
            [31.649728843467646, 1.335575058248572],
            [31.648530379487536, 1.339933977846891],
            [31.648944891804003, 1.340956268269865],
            [31.648320595919234, 1.34503511587092],
            [31.648498359937527, 1.346699262720232],
            [31.64700319499549, 1.346686251523253],
            [31.645966124135967, 1.34601125068019],
            [31.64384514335967, 1.346410081486367],
            [31.640771797465227, 1.345118423329985],
            [31.63615660836997, 1.346277794378768],
            [31.63502072911738, 1.345885230265699],
            [31.634060894507666, 1.344762047573482],
            [31.628438778420524, 1.34386380980341],
            [31.62746971182461, 1.342539549508623],
            [31.624786736921738, 1.342292981145862],
            [31.623655547773254, 1.341545878513686],
            [31.623275254980886, 1.341541088213366],
            [31.622379004025294, 1.342806372885541],
            [31.621169020948276, 1.342625646454065],
            [31.61944774915091, 1.343360447015567],
            [31.61678231475226, 1.343586912909832],
            [31.613873656998862, 1.341529000203865],
            [31.612569851178655, 1.341252535017092],
            [31.6104013710834, 1.341650722684826],
            [31.607620592103945, 1.343412323037232],
            [31.606185526251057, 1.345876450758221],
            [31.60435697943907, 1.345735201805971],
            [31.60240132909924, 1.347117127045948],
            [31.600974950853445, 1.347122794746786],
            [31.597178125185373, 1.350219031433903],
            [31.592570345394574, 1.351721157477351],
            [31.589264027719423, 1.354575349225205],
            [31.58300254291534, 1.357096717167118],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1611,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "NSAMBYA",
        Population: 26382,
        Key: "KYANKWANZINSAMBYA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Nsambya",
        id2_original: "KyankwanziNsambya",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.08436024139459, 1.633711714585194],
            [32.08192766648729, 1.632154663067],
            [32.07817627311472, 1.627982675937427],
            [32.074484986916104, 1.627555804449839],
            [32.071681977328346, 1.625844794025996],
            [32.070419404179646, 1.625563779415082],
            [32.05895883612543, 1.625992640291344],
            [32.0570530449788, 1.625575625221117],
            [32.05576438026271, 1.624634228240064],
            [32.05277566015959, 1.624261930118136],
            [32.04948673386834, 1.623111527257835],
            [32.04396995962133, 1.624854788222835],
            [32.039981974257415, 1.624653869191693],
            [32.035446508846995, 1.62798062052372],
            [32.03423341131089, 1.628251415199793],
            [32.029617919483385, 1.626792777827363],
            [32.02710088766796, 1.628139406389295],
            [32.023120536187385, 1.628454073206657],
            [32.01895513085993, 1.627475073096808],
            [32.01801042118465, 1.626343864923466],
            [32.01665751524762, 1.625872811975253],
            [32.01593411542403, 1.625999100169339],
            [32.014273333482954, 1.627264715044531],
            [32.012946324178955, 1.627264061334715],
            [32.00848812735767, 1.625353167042631],
            [32.00884531098938, 1.623896948460946],
            [32.00773222379217, 1.623018943620508],
            [32.00536977676584, 1.62363289683993],
            [32.004378950278806, 1.623198200552341],
            [32.002127466749606, 1.620944650586398],
            [32.000179778178115, 1.617849982687753],
            [31.996468701195514, 1.617350611573592],
            [31.994874720673895, 1.616463319012034],
            [31.989343763825172, 1.615782111049275],
            [31.987131334552952, 1.61470454218462],
            [31.986227530562434, 1.613844730501377],
            [31.983015825249645, 1.61298375829114],
            [31.975891328952105, 1.616245704315221],
            [31.974464002085377, 1.618036052877681],
            [31.9727632127748, 1.627325250545577],
            [31.97125290403369, 1.632625327529521],
            [31.968743217742375, 1.637725871817143],
            [31.966459630221543, 1.640121824619573],
            [31.962356095460976, 1.642426362731601],
            [31.957265305016634, 1.643934338033251],
            [31.952091115879625, 1.644845229951652],
            [31.948498909365277, 1.648579222657996],
            [31.94716695124237, 1.649464996986356],
            [31.943443911395118, 1.649851975385892],
            [31.93997062385809, 1.650718502648325],
            [31.933892673849726, 1.653908364456908],
            [31.930086556008344, 1.655217926636007],
            [31.912125949238142, 1.658636378508419],
            [31.908390912390253, 1.659927831533367],
            [31.9049296200572, 1.662992369620908],
            [31.903847157326382, 1.664773750863742],
            [31.903601982830832, 1.666311005219219],
            [31.89759107139716, 1.656908243148889],
            [31.892536178529863, 1.65031880056983],
            [31.89070457025941, 1.646205269764485],
            [31.890240835655245, 1.640908624711106],
            [31.89082376232458, 1.635684011692201],
            [31.895272433410582, 1.619066452107438],
            [31.894879969344405, 1.616280574713907],
            [31.892584508790467, 1.609644229510905],
            [31.890848026718714, 1.60667859145426],
            [31.888219537332763, 1.600735599257952],
            [31.885043898480273, 1.597088022007011],
            [31.884187570452557, 1.59500740066829],
            [31.883081523352235, 1.585932419736954],
            [31.88202301509675, 1.580898600028685],
            [31.880488749185353, 1.577036334908309],
            [31.86813136423687, 1.5558345548359],
            [31.865788354058306, 1.55101558315264],
            [31.86125695891443, 1.544617755254878],
            [31.858580961226387, 1.536809708852669],
            [31.85734404665715, 1.534322494514436],
            [31.85670181051781, 1.533796247083048],
            [31.852669950537123, 1.533998274940753],
            [31.847888799489738, 1.535192406398232],
            [31.84100250676118, 1.538406409259677],
            [31.83597156657262, 1.541764438606064],
            [31.82794351511793, 1.544093282096824],
            [31.81703723544175, 1.548310154762063],
            [31.811161900445715, 1.549814652938607],
            [31.79310762903575, 1.557316783952089],
            [31.787981580614794, 1.558594292579866],
            [31.780072530782434, 1.55975124719112],
            [31.772270562826844, 1.5601789166739],
            [31.77188992418309, 1.561398257696005],
            [31.772508349577496, 1.5617332317976],
            [31.77329317081029, 1.564172435750957],
            [31.77200865271757, 1.565176258337856],
            [31.77147334753806, 1.567124825809126],
            [31.771116420824526, 1.569467969448024],
            [31.771615822138745, 1.571548388335233],
            [31.777466776857988, 1.581067119987762],
            [31.77958366850313, 1.58324379710607],
            [31.785779836802885, 1.588279311870058],
            [31.78673125599502, 1.589236101544352],
            [31.787016644472605, 1.590144874559083],
            [31.785529835659332, 1.592356139948729],
            [31.781652358346715, 1.596108815544871],
            [31.774980172777887, 1.595759687840376],
            [31.772791737506907, 1.596571870902537],
            [31.772315947511636, 1.597336852948546],
            [31.771613968016002, 1.601317795501039],
            [31.76954420199069, 1.605884057359399],
            [31.768723290043035, 1.609554109264078],
            [31.768675567043566, 1.61168217210092],
            [31.76762886085428, 1.612781702164864],
            [31.76730952055057, 1.613712874203786],
            [31.76629601070429, 1.612300624834931],
            [31.764454569474733, 1.611794078555913],
            [31.762333841125024, 1.611680465079133],
            [31.7583150857677, 1.612351892941929],
            [31.75691938319225, 1.613081085407531],
            [31.75239823602913, 1.613920661909405],
            [31.749516745126552, 1.613599109976994],
            [31.748283852314856, 1.612236680230101],
            [31.74643724756905, 1.609036789463254],
            [31.747628696605094, 1.60280614951398],
            [31.747583750298187, 1.601709413033224],
            [31.746566601376696, 1.599584742203795],
            [31.74640260314179, 1.593540908316728],
            [31.748261166260686, 1.5866446786774],
            [31.74350345136074, 1.58810897590401],
            [31.741174794463802, 1.587720814765775],
            [31.738083197497726, 1.588284027111347],
            [31.73552519352223, 1.589385185169239],
            [31.7335465382263, 1.591763409791382],
            [31.73183672983026, 1.591043246897272],
            [31.729340032279644, 1.591345940536051],
            [31.72433585020846, 1.590941564482249],
            [31.72239056463037, 1.589835806956772],
            [31.720872790889253, 1.58832951648294],
            [31.718302899507595, 1.584424317904508],
            [31.71819185606039, 1.581134166263948],
            [31.720056263618503, 1.571782591600899],
            [31.718595856291426, 1.571146623334945],
            [31.71624188397148, 1.571425873684517],
            [31.715339279231884, 1.571137189182662],
            [31.71391524648728, 1.570203326428613],
            [31.71185308020928, 1.567718050598602],
            [31.709381453739923, 1.562478150502795],
            [31.708051443164553, 1.556979328916859],
            [31.706433301555066, 1.552695479319111],
            [31.704513826371713, 1.550186799235563],
            [31.69881053492226, 1.544484615828917],
            [31.69805316530619, 1.543099761999791],
            [31.696889539789456, 1.537601440556725],
            [31.690928155172323, 1.530492021144982],
            [31.69113928621357, 1.52664260398486],
            [31.692211931256644, 1.525382230615016],
            [31.698103165534906, 1.521930651755523],
            [31.698748004093634, 1.520645177456887],
            [31.699843211223406, 1.519885485500782],
            [31.70164995861836, 1.51979533176335],
            [31.70302619739659, 1.520824391992407],
            [31.707373472043212, 1.521957372595377],
            [31.710642939927098, 1.521501919444784],
            [31.713474940844048, 1.520079717339335],
            [31.716070356057866, 1.518180026225793],
            [31.71839620122796, 1.514670404309042],
            [31.720300142743405, 1.51367461122196],
            [31.723582150210373, 1.512945011563737],
            [31.725177088336068, 1.511948333151965],
            [31.72961035511157, 1.511901446643327],
            [31.733464957723758, 1.510267566309062],
            [31.734512794891995, 1.50943618129386],
            [31.735397030880637, 1.507412351505045],
            [31.737123446431347, 1.506094196483305],
            [31.73774414636004, 1.504951672571],
            [31.739196011607085, 1.504145273434353],
            [31.7397692158101, 1.502978766347036],
            [31.740745822864486, 1.502099483369794],
            [31.739225461077027, 1.501713718562123],
            [31.738063885515764, 1.500351530800382],
            [31.734252936534787, 1.49856458532542],
            [31.73033216761202, 1.498005058892714],
            [31.72311640248162, 1.498663822395954],
            [31.718006930672637, 1.498196235865432],
            [31.71443215327144, 1.497034352145935],
            [31.71346110499202, 1.495256226908178],
            [31.71275858650723, 1.492646821978418],
            [31.713800332199515, 1.487577090879737],
            [31.713031610573232, 1.481881687807305],
            [31.713318373473168, 1.479970365656955],
            [31.71354665874306, 1.478885732248322],
            [31.71582323940466, 1.477195607011693],
            [31.71736171212657, 1.473989367032798],
            [31.717362204403347, 1.473130312935131],
            [31.715563794272523, 1.469622037922891],
            [31.714471061103016, 1.465599199272489],
            [31.71158906355064, 1.45880147670954],
            [31.70668973194111, 1.451527192024368],
            [31.70571844381151, 1.449391431299371],
            [31.704578479021016, 1.44181018469828],
            [31.704604165448256, 1.438547666734053],
            [31.7061807456028, 1.432839132294099],
            [31.706470914016002, 1.425522582915167],
            [31.70639982763262, 1.424754887551438],
            [31.70575653148124, 1.424130802549901],
            [31.706758319211364, 1.423123821763201],
            [31.708665749783364, 1.42252516787058],
            [31.71343526674951, 1.419337278318133],
            [31.708763481096387, 1.418255135773261],
            [31.70797725759342, 1.417439059658953],
            [31.706309606235365, 1.41554297229138],
            [31.70480969279874, 1.412087680095913],
            [31.704858606065965, 1.409856710714706],
            [31.703762817726197, 1.408440732124303],
            [31.702142117714775, 1.407864081909788],
            [31.692964151729477, 1.408146781687286],
            [31.690506697980357, 1.407104523264779],
            [31.68931185421085, 1.40396887071765],
            [31.686929691858957, 1.394423342231239],
            [31.68790629981167, 1.387969834670717],
            [31.688676486590186, 1.38544994421747],
            [31.688479512099498, 1.383260685668452],
            [31.68516882052724, 1.378325318858798],
            [31.683801165151575, 1.374773781145799],
            [31.68283256208636, 1.374312412552071],
            [31.682416247749384, 1.373432459441069],
            [31.681681594730254, 1.373257721749495],
            [31.68119522707249, 1.372282313705504],
            [31.67904068344057, 1.371616883435438],
            [31.678631851171616, 1.37016965911583],
            [31.677148439786738, 1.369087137440061],
            [31.676666434348007, 1.367780821595646],
            [31.67565985141088, 1.367496281359441],
            [31.673565539818743, 1.364065628108664],
            [31.670384819196705, 1.361897917811814],
            [31.66767574913315, 1.357312950147167],
            [31.66594377121421, 1.357054756056615],
            [31.664641091881368, 1.35488704036301],
            [31.66343119144938, 1.35379615622979],
            [31.662910378790375, 1.351827396804201],
            [31.66372589635476, 1.34947359175418],
            [31.663292681114022, 1.348073331126447],
            [31.66329767934027, 1.344988284330474],
            [31.664394507929142, 1.342728007419205],
            [31.66623510564065, 1.343073280651763],
            [31.666696648355522, 1.342322813194345],
            [31.668343763327865, 1.34179911690993],
            [31.670836767006055, 1.340226677585633],
            [31.6719717928591, 1.33888865868574],
            [31.67464759201949, 1.337886137521931],
            [31.678009775023874, 1.335283039591049],
            [31.679658932765182, 1.334614611284222],
            [31.68223024258665, 1.335222010253928],
            [31.685136895300367, 1.334744200316967],
            [31.687206037894853, 1.336472894926724],
            [31.688841446920755, 1.33684461812341],
            [31.68963138765237, 1.336428976564606],
            [31.690937514719277, 1.336538218807755],
            [31.691521645131093, 1.335507409235415],
            [31.695379451135565, 1.334080375379661],
            [31.69831045987155, 1.335366325828169],
            [31.699739194398333, 1.335177144404129],
            [31.700589935803333, 1.335566531062127],
            [31.70193720211698, 1.334355223049429],
            [31.70432475436059, 1.333578623520459],
            [31.707252477957585, 1.334195236064043],
            [31.70847568513388, 1.333381834390714],
            [31.70988230224006, 1.333066003089769],
            [31.71134680229155, 1.333772287344259],
            [31.713017506124938, 1.333275693050183],
            [31.714029749346675, 1.332240728525498],
            [31.714497408690324, 1.331910674302867],
            [31.71591766671406, 1.332372717332706],
            [31.71708376349618, 1.332291924941452],
            [31.71756731583384, 1.33348612300408],
            [31.720406962312158, 1.331760010948698],
            [31.72204063579293, 1.33227643319185],
            [31.723321831017426, 1.330658038763201],
            [31.72343107693577, 1.329572689424621],
            [31.72502577341465, 1.329428800095896],
            [31.725506590382277, 1.327213010245911],
            [31.727411092446477, 1.326996917398156],
            [31.729497534796703, 1.327423118308259],
            [31.73215054459666, 1.325443618268343],
            [31.73568734931249, 1.324043451705567],
            [31.737734228959315, 1.323854556797954],
            [31.73848021242913, 1.323176556400352],
            [31.742084488707622, 1.32386583213587],
            [31.744200584445405, 1.325657848644516],
            [31.745750934691962, 1.324365187209161],
            [31.748491971304936, 1.323814831325833],
            [31.75302827125026, 1.32417894254656],
            [31.754546782508225, 1.32533749365],
            [31.756155867303015, 1.325654889487877],
            [31.756597161991415, 1.327165656584535],
            [31.75786022023034, 1.327537148584064],
            [31.759160709470535, 1.328876493824823],
            [31.762649343825867, 1.331202872669594],
            [31.763716217193263, 1.331330044269943],
            [31.764170158364198, 1.332270974707542],
            [31.766335890513037, 1.333719301101769],
            [31.768170774041007, 1.333503143264622],
            [31.769178421481726, 1.334136816496457],
            [31.771037754456806, 1.333893533333899],
            [31.77292531339641, 1.334500513082265],
            [31.773484271217328, 1.336056573465216],
            [31.774577074455408, 1.337142550390603],
            [31.774368320356412, 1.339005762524051],
            [31.775155375699356, 1.340462441483059],
            [31.775644471540605, 1.34300439879755],
            [31.779103201878467, 1.34456192571341],
            [31.78017563402083, 1.346525285552154],
            [31.78217217836736, 1.346001667402841],
            [31.784864887414646, 1.346744733656091],
            [31.787478595920923, 1.349920937313453],
            [31.78828487521092, 1.350011795543822],
            [31.78938373399233, 1.350808332299786],
            [31.79044170685191, 1.35079981773943],
            [31.791320525101096, 1.351867602287649],
            [31.792938886797838, 1.352818170040696],
            [31.792791083390874, 1.354102527334188],
            [31.793467660326886, 1.354663674740245],
            [31.79461537578164, 1.354356710984328],
            [31.79701208904451, 1.354529772464298],
            [31.798068898585786, 1.354041854999201],
            [31.80102681725442, 1.354097604145026],
            [31.80514951397834, 1.35571877153788],
            [31.806872767459204, 1.354136694194842],
            [31.80744318598652, 1.354127931780405],
            [31.80841200374911, 1.354390727864661],
            [31.810427381275552, 1.356182704977444],
            [31.814159676465167, 1.356148370207749],
            [31.81502468671013, 1.35677292760329],
            [31.81623513241949, 1.356854934264073],
            [31.81728453714789, 1.35774189833628],
            [31.821479303012083, 1.359091727167892],
            [31.822443293228336, 1.358902248531211],
            [31.825193000380388, 1.360387043774987],
            [31.82788139032783, 1.36032504426185],
            [31.8291700415692, 1.359574906335308],
            [31.83141554142029, 1.359476503841166],
            [31.833136832082264, 1.360816065957223],
            [31.834934669986232, 1.36300593598751],
            [31.836532209633024, 1.362382580014465],
            [31.836936277237704, 1.362563684854429],
            [31.839728724434366, 1.366915901399291],
            [31.841236915846345, 1.368128726161753],
            [31.842694734228754, 1.368382708066108],
            [31.843505807827427, 1.369649465896509],
            [31.84634876908917, 1.371785577317739],
            [31.84769251490522, 1.373893824612542],
            [31.84896383674645, 1.377096539918026],
            [31.85113491297289, 1.377640325233551],
            [31.851961858006007, 1.37979355181853],
            [31.85294003441719, 1.381096576906986],
            [31.85548357641495, 1.382147090982631],
            [31.85801587779353, 1.382636777284993],
            [31.859650331910274, 1.38356925683156],
            [31.860324874162163, 1.386102325510971],
            [31.86155731691788, 1.387830615995418],
            [31.863404837945286, 1.387831512251066],
            [31.864130199689438, 1.38864595975025],
            [31.86414379479294, 1.39016561410168],
            [31.86271305971803, 1.391367972810706],
            [31.862056266379522, 1.392814935457642],
            [31.86292576820091, 1.394678734854174],
            [31.8639821618222, 1.395719483798209],
            [31.865676132021445, 1.396145448045945],
            [31.866110400087674, 1.396037112848353],
            [31.867053655390528, 1.394635514441745],
            [31.86764956451235, 1.394816714715619],
            [31.86720502151588, 1.396435647943634],
            [31.868885020217533, 1.399059668733903],
            [31.867981235091655, 1.40189952576497],
            [31.868584142987835, 1.40388079130106],
            [31.871156413108366, 1.40950837135209],
            [31.871770749371617, 1.409924766234024],
            [31.87218151661169, 1.41138129953271],
            [31.87449103579983, 1.413236765573668],
            [31.876370544936183, 1.413943236274964],
            [31.877955511762227, 1.413880690359668],
            [31.878734370876494, 1.414441894563666],
            [31.877538383551613, 1.417462529046815],
            [31.877663235003073, 1.418321917625506],
            [31.87896066098816, 1.419290427588109],
            [31.882392665547968, 1.420323297825551],
            [31.883908484555008, 1.42330907715734],
            [31.885539979621218, 1.424639574137457],
            [31.88944861499942, 1.423375093735047],
            [31.890199880563106, 1.421159286936056],
            [31.89163260271144, 1.422914827610469],
            [31.892016404323336, 1.42557442031947],
            [31.89354377027503, 1.426769181328388],
            [31.894749901376098, 1.431310662865412],
            [31.8977354369515, 1.431592526399385],
            [31.89915469604866, 1.429802179996156],
            [31.8999334285005, 1.42947691417641],
            [31.901121720856644, 1.429640309075281],
            [31.90209511823053, 1.43104285175017],
            [31.902296773842128, 1.434009917403994],
            [31.90357988876642, 1.436181490863221],
            [31.905121360064708, 1.437276758697105],
            [31.90862062777805, 1.437567908050654],
            [31.91086378122963, 1.439142932660843],
            [31.912975064692457, 1.43984046538071],
            [31.913278183218758, 1.440907999355861],
            [31.911732282327787, 1.446732661961026],
            [31.912193410919333, 1.448053551671378],
            [31.913400155569718, 1.448425007620034],
            [31.918532891947965, 1.447812377150206],
            [31.920287129221315, 1.449830407936375],
            [31.920822826964585, 1.451467935710222],
            [31.9250947832645, 1.450664919779456],
            [31.926859421232205, 1.44911894807328],
            [31.929031174788385, 1.446107762159498],
            [31.930366241082186, 1.445981756090324],
            [31.93079514171456, 1.447175995450539],
            [31.929593213830714, 1.449681086579554],
            [31.929598747452868, 1.450459020952949],
            [31.93222539888576, 1.453689595168537],
            [31.93501639979482, 1.453274820192534],
            [31.936753876301594, 1.45395407643164],
            [31.938413016122347, 1.453972954735415],
            [31.941208527472433, 1.455937206269266],
            [31.945951297101, 1.458092338372936],
            [31.947006345046002, 1.457957149773685],
            [31.948524687420683, 1.456953785016837],
            [31.950669938879326, 1.457189983505076],
            [31.951320709912185, 1.457859676399869],
            [31.95301214506569, 1.458520812720467],
            [31.95410759743554, 1.459697278051782],
            [31.955986392411262, 1.460340409358871],
            [31.95694329851314, 1.46349783986026],
            [31.957799858306238, 1.464384729155752],
            [31.958745813046498, 1.46389670000043],
            [31.959311808269344, 1.462639598033056],
            [31.959202904609153, 1.461255540036247],
            [31.95824932047718, 1.460015819633712],
            [31.958329585846137, 1.459554521004156],
            [31.962056530669933, 1.459094922239432],
            [31.966394640704, 1.460553313661942],
            [31.9696102006877, 1.463585156358249],
            [31.970764709202637, 1.46525012395458],
            [31.97364107521654, 1.466210313535331],
            [31.975152559852347, 1.466102462088765],
            [31.975019698123504, 1.469187032601592],
            [31.974128576548175, 1.470760597418225],
            [31.972453807838118, 1.472288566919153],
            [31.971953324053995, 1.473400972067243],
            [31.972414723936737, 1.476657688631965],
            [31.971866931276477, 1.47985061347482],
            [31.969158000451774, 1.482445498273908],
            [31.968911348227593, 1.484942031380036],
            [31.968371166992746, 1.486235330436194],
            [31.968491489138504, 1.487221381801301],
            [31.969561464388608, 1.488253110119709],
            [31.969857313747653, 1.489899590730189],
            [31.971160117946326, 1.492197846334739],
            [31.973552858859005, 1.493085465024092],
            [31.97361653863285, 1.494469508572144],
            [31.97542414571556, 1.495465402921283],
            [31.975953252519595, 1.496252639949532],
            [31.975648067868107, 1.499572321637007],
            [31.974506465448844, 1.500937704993207],
            [31.972865275764125, 1.502058612395403],
            [31.97291285862641, 1.50301749376339],
            [31.971878086555666, 1.504174869907673],
            [31.97423301827638, 1.504248353715968],
            [31.975303520837514, 1.505370545362126],
            [31.976683299876274, 1.505253602625847],
            [31.978062915421628, 1.506692545179817],
            [31.979014647227487, 1.506521124157688],
            [31.98037053467291, 1.507046424557618],
            [31.983546095371956, 1.507418800972683],
            [31.9843548270627, 1.506704557788653],
            [31.984212064102778, 1.505646124296528],
            [31.98464028201556, 1.505338765854259],
            [31.98578216021764, 1.506415760357264],
            [31.987518703374825, 1.506841730695675],
            [31.987566333847827, 1.507710157583263],
            [31.98590128131588, 1.509997982132043],
            [31.98547317389587, 1.511273248868588],
            [31.985544553130037, 1.513616162976987],
            [31.985913340300247, 1.514267639866136],
            [31.98838719818476, 1.514151209469393],
            [31.989838504679714, 1.516087710480488],
            [31.989481586949317, 1.517091635647734],
            [31.98765023739366, 1.518167232420512],
            [31.986936595969038, 1.519152895801765],
            [31.989232360153522, 1.521478771735624],
            [31.989327749558612, 1.525332362149891],
            [31.987995584823175, 1.527502741603841],
            [31.98879269500906, 1.528235836728592],
            [31.989696585237837, 1.53008162490456],
            [31.99300312839016, 1.530960644176543],
            [31.99381183941963, 1.53031876830487],
            [31.99526278658844, 1.527017701547695],
            [31.9973798399303, 1.526494034961641],
            [31.999485222360033, 1.526911135430221],
            [31.999889730139188, 1.528684324498399],
            [31.99791526458572, 1.530637311312728],
            [31.997368207645685, 1.531577827705336],
            [31.997415785118093, 1.532554808525702],
            [31.998902637050488, 1.53419281890356],
            [32.00087716368939, 1.535143569955008],
            [32.00084210064722, 1.54286876316545],
            [32.001965858033344, 1.54309544267025],
            [32.00289174351185, 1.542381253531031],
            [32.003221692919084, 1.541395404165039],
            [32.00295272564491, 1.539305669421612],
            [32.003423148206394, 1.53765953344329],
            [32.005919090273856, 1.536647562891925],
            [32.008269371416326, 1.534758064278819],
            [32.00879270295139, 1.534704032935887],
            [32.01046441110127, 1.536314990545886],
            [32.012868641466454, 1.539880214832853],
            [32.01415478910312, 1.540043641980766],
            [32.01510427961235, 1.53930231632281],
            [32.01569553186772, 1.538153755747198],
            [32.016742737520296, 1.53809996604991],
            [32.01960832015751, 1.540824130541672],
            [32.023102591441265, 1.542861093436189],
            [32.0295944456067, 1.540946338061348],
            [32.030189875028135, 1.541109439157018],
            [32.03328287156942, 1.54415031338325],
            [32.03637725780445, 1.544133637726198],
            [32.03754703318762, 1.545129233489722],
            [32.03849804274801, 1.544758780810226],
            [32.03901470519039, 1.54268747881153],
            [32.03986970820309, 1.54218129094578],
            [32.04602431504794, 1.542564014206173],
            [32.047361442076976, 1.543722510450543],
            [32.048632634560825, 1.546599726218269],
            [32.04724252848956, 1.550841689023571],
            [32.049780027520384, 1.55495878936296],
            [32.050070193238625, 1.556225367363092],
            [32.049861310680555, 1.5578626060785],
            [32.050815799416036, 1.558523401315784],
            [32.05236350771737, 1.55865979504614],
            [32.05387727048071, 1.559329888643348],
            [32.054857866054974, 1.560660103106892],
            [32.05541055633018, 1.562198183269191],
            [32.05556070164507, 1.564387397916699],
            [32.05676816135442, 1.56596196026736],
            [32.05756499755416, 1.569291272457841],
            [32.05680916854882, 1.570982543072456],
            [32.05695486450813, 1.57181484694485],
            [32.060002316464505, 1.571988107162896],
            [32.06207042150488, 1.57116585172839],
            [32.062785984425894, 1.571573248839103],
            [32.06314212421524, 1.574820952116665],
            [32.06236042552635, 1.57594231099418],
            [32.06329304118297, 1.577173000416816],
            [32.06375099333165, 1.578882917358924],
            [32.067358270881506, 1.579137841450909],
            [32.06883240266951, 1.578650018750108],
            [32.06980654834001, 1.578098647173722],
            [32.07134633978872, 1.57587400020104],
            [32.07282071322351, 1.575467587213776],
            [32.073083517156526, 1.5757481345596],
            [32.072901776296455, 1.578271915849008],
            [32.07445223074761, 1.579240545442152],
            [32.07525444785587, 1.580624959691718],
            [32.07497497388614, 1.582461194307386],
            [32.07329223891616, 1.584586271607569],
            [32.07351103438338, 1.585916147601241],
            [32.0743486576903, 1.587273440476595],
            [32.07637378463251, 1.58776284337191],
            [32.07936683641189, 1.585909735188985],
            [32.08107992006544, 1.585666257471444],
            [32.08812930552714, 1.590156285055527],
            [32.088986849873756, 1.590319497262515],
            [32.08977527694414, 1.591152093303277],
            [32.08923488999508, 1.596706184243908],
            [32.090822786227264, 1.605183131984909],
            [32.08967394428512, 1.606892337855054],
            [32.084399867878425, 1.609965645577833],
            [32.08416564743945, 1.611087260103124],
            [32.08480104470452, 1.612399236066241],
            [32.086042719446446, 1.61355770418609],
            [32.0908558190769, 1.614934891893651],
            [32.09131280912992, 1.616319158167764],
            [32.09123561060935, 1.618092168012249],
            [32.090364232207335, 1.624342659803773],
            [32.08436024139459, 1.633711714585194],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1620,
        District: "MASINDI",
        County: "BURULI",
        Subcounty: "KIMENGO",
        Population: 14008,
        Key: "MASINDIKIMENGO",
        Dist2: "Masindi",
        "Sub Country": "Kimengo",
        id2_original: "Masindi Kimengo",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.714029749346675, 1.332240728525498],
            [31.713017506124938, 1.333275693050183],
            [31.71134680229155, 1.333772287344259],
            [31.70988230224006, 1.333066003089769],
            [31.70847568513388, 1.333381834390714],
            [31.707252477957585, 1.334195236064043],
            [31.70432475436059, 1.333578623520459],
            [31.70193720211698, 1.334355223049429],
            [31.700589935803333, 1.335566531062127],
            [31.699739194398333, 1.335177144404129],
            [31.69831045987155, 1.335366325828169],
            [31.695379451135565, 1.334080375379661],
            [31.691521645131093, 1.335507409235415],
            [31.690937514719277, 1.336538218807755],
            [31.68963138765237, 1.336428976564606],
            [31.688841446920755, 1.33684461812341],
            [31.687206037894853, 1.336472894926724],
            [31.685136895300367, 1.334744200316967],
            [31.68223024258665, 1.335222010253928],
            [31.679658932765182, 1.334614611284222],
            [31.678009775023874, 1.335283039591049],
            [31.67464759201949, 1.337886137521931],
            [31.6719717928591, 1.33888865868574],
            [31.670836767006055, 1.340226677585633],
            [31.668343763327865, 1.34179911690993],
            [31.666696648355522, 1.342322813194345],
            [31.66623510564065, 1.343073280651763],
            [31.664394507929142, 1.342728007419205],
            [31.6621429642128, 1.344219718695634],
            [31.660790271176523, 1.344038074543091],
            [31.654740422266862, 1.34672102737769],
            [31.65190562399611, 1.346276252397186],
            [31.651395147352748, 1.3471442675287],
            [31.649727694522387, 1.34737850045241],
            [31.648498359937527, 1.346699262720232],
            [31.648320595919234, 1.34503511587092],
            [31.648944891804003, 1.340956268269865],
            [31.648530379487536, 1.339933977846891],
            [31.649728843467646, 1.335575058248572],
            [31.650181889018246, 1.331866947148759],
            [31.651895701205476, 1.328991649319845],
            [31.652748748585825, 1.325600320663232],
            [31.654765240023206, 1.322291028408028],
            [31.65604413466227, 1.318158249535395],
            [31.657583865923876, 1.31043481545081],
            [31.658936962303752, 1.308771299787607],
            [31.659072721099367, 1.307496053273505],
            [31.66019349607876, 1.305434436541521],
            [31.660838853863716, 1.300650070088194],
            [31.660350070636156, 1.29984481925475],
            [31.659643997517783, 1.295701912496163],
            [31.660098515407157, 1.292780676373434],
            [31.65898266319552, 1.290853535313777],
            [31.658234275834005, 1.288130646297621],
            [31.658556931819437, 1.287090663462453],
            [31.65845589290954, 1.284829404601684],
            [31.657481236995945, 1.283019925292932],
            [31.657839566877946, 1.279266515866945],
            [31.656999679816508, 1.27534966783257],
            [31.655143318468394, 1.270102701083045],
            [31.652977271909247, 1.265805282624511],
            [31.65015834507295, 1.264148607384844],
            [31.648185964509278, 1.2614319713917],
            [31.658539934795918, 1.244808922619189],
            [31.67323371832246, 1.229845445949565],
            [31.67272976793964, 1.228604942487864],
            [31.672458125482578, 1.224227087076306],
            [31.673139217351203, 1.221188348240801],
            [31.672897115093924, 1.21839336081219],
            [31.673151595237506, 1.216566422186467],
            [31.675640513377765, 1.2102905033003],
            [31.675031402614525, 1.205583909356607],
            [31.673767436178863, 1.20215224203399],
            [31.67355165096612, 1.20027875109421],
            [31.67258061885639, 1.198290445158347],
            [31.67429876721151, 1.192464260395467],
            [31.6712989888473, 1.188146492181449],
            [31.665083069289363, 1.183611355146857],
            [31.664016144718005, 1.172810518466241],
            [31.661877206619156, 1.16180293984064],
            [31.662310495521726, 1.15230729972929],
            [31.664241629939138, 1.14928680561785],
            [31.670244823047884, 1.150152893715429],
            [31.680104214176797, 1.158142713942514],
            [31.686750616300337, 1.159224914022904],
            [31.689421940952283, 1.159130036315236],
            [31.68958465998622, 1.158252753045182],
            [31.68893620301355, 1.156515822314337],
            [31.688784853956175, 1.15465249448722],
            [31.69022683773508, 1.151650243959867],
            [31.69133319655079, 1.150574407868355],
            [31.691659017300967, 1.147960568612594],
            [31.692907826462868, 1.145482826871587],
            [31.69205035218482, 1.14515681434878],
            [31.691035744597286, 1.143099725022396],
            [31.689075668258024, 1.139520444929053],
            [31.68829600066001, 1.136055876054676],
            [31.686896797349878, 1.134562820663092],
            [31.686735768047008, 1.131722638266433],
            [31.685184426060353, 1.129469741993202],
            [31.68522540450865, 1.128890885733638],
            [31.684373382106084, 1.128320666781819],
            [31.684932886102704, 1.124938119929785],
            [31.685440471967475, 1.123979588346541],
            [31.68454825893907, 1.122857612429398],
            [31.68440658653393, 1.121916875970501],
            [31.683717173570823, 1.121310552991214],
            [31.68501714627972, 1.118000699212919],
            [31.683558173562137, 1.113893645146662],
            [31.683781920543225, 1.112772175520719],
            [31.68322596758693, 1.107571096233948],
            [31.684586697850076, 1.105247159456892],
            [31.684112201428785, 1.0999647116766],
            [31.68576709670982, 1.096627868848223],
            [31.68532155478678, 1.095090033185419],
            [31.685829380501744, 1.093543574477589],
            [31.68742334395535, 1.090812708046362],
            [31.689392495973923, 1.088669922019724],
            [31.69035738989532, 1.086029220435255],
            [31.692285571550375, 1.084456240863584],
            [31.69261107070368, 1.082412223128161],
            [31.69515921387231, 1.078379275529067],
            [31.6970980396652, 1.076191230669203],
            [31.700755088373374, 1.064850392711597],
            [31.700960797183544, 1.057768254423408],
            [31.70142819781239, 1.056113218574695],
            [31.702605903522905, 1.054132860844226],
            [31.703195482216916, 1.05104876520107],
            [31.703560852195803, 1.050967513679127],
            [31.750566263042657, 1.048427067880871],
            [31.770510795524594, 1.052874761107756],
            [31.771050895012774, 1.051772942290022],
            [31.791359593731094, 1.056710636813792],
            [31.805142062453047, 1.061880911272592],
            [31.809252320205193, 1.064072376655584],
            [31.81593012114288, 1.04856284077051],
            [31.825147975920032, 1.054393711692431],
            [31.829435008645394, 1.058064428784618],
            [31.83715372702864, 1.059254419712085],
            [31.841014641204033, 1.055694691802072],
            [31.844306913719706, 1.048267052615508],
            [31.845943819338867, 1.040467812397906],
            [31.845930418271468, 1.034841518488636],
            [31.846924013366195, 1.035374225932086],
            [31.850437635259457, 1.035322529142466],
            [31.853253588672164, 1.03586664773561],
            [31.857715651842426, 1.03319256193804],
            [31.86170316379417, 1.032770129567215],
            [31.86613695159252, 1.035593158117288],
            [31.86939910180012, 1.039647658126144],
            [31.873938933921163, 1.040377835805954],
            [31.87633404279293, 1.040259481617954],
            [31.879080371381228, 1.056137779731285],
            [31.880862466309832, 1.057079169036205],
            [31.883638539015532, 1.060047134496444],
            [31.88568831752576, 1.061639905923027],
            [31.88668347389247, 1.065077598479053],
            [31.88742188007284, 1.065584422087013],
            [31.888212254690757, 1.067610927100706],
            [31.889740546805527, 1.069167330861233],
            [31.891384705422254, 1.072614312734967],
            [31.892687125142004, 1.078286396299011],
            [31.893985867158968, 1.079381394019093],
            [31.894941676417886, 1.081344647181903],
            [31.896341912790618, 1.082132131686233],
            [31.898072343810618, 1.082331769995976],
            [31.900566868336558, 1.08347243562658],
            [31.902170110488754, 1.08359966192777],
            [31.903340014331047, 1.082975939275415],
            [31.90654669177318, 1.083483665254411],
            [31.907287282656355, 1.086532325798964],
            [31.907940957044204, 1.092285612202911],
            [31.909217533131525, 1.097234064856994],
            [31.9104408085798, 1.099694938915918],
            [31.911411911656433, 1.104417142012942],
            [31.91143171861013, 1.106316743241529],
            [31.910413462065925, 1.10691338188602],
            [31.908469120617188, 1.110241467024791],
            [31.908420520862016, 1.114094906080275],
            [31.909210879310223, 1.117686333432035],
            [31.90813595164799, 1.120381540400878],
            [31.90879030875546, 1.122643205081682],
            [31.908067555718883, 1.125320450932302],
            [31.908069498774836, 1.127636143970038],
            [31.9092624884216, 1.129943241756248],
            [31.909492012468284, 1.131987651540628],
            [31.9108407636971, 1.134575226659396],
            [31.911277100583455, 1.136312162617253],
            [31.912665766655298, 1.137307715881006],
            [31.912666732344217, 1.138474609278042],
            [31.91402488444249, 1.139967664442299],
            [31.91363273029511, 1.141722378467645],
            [31.913012082468686, 1.142436751111673],
            [31.91355125130221, 1.143305342591119],
            [31.913241577769263, 1.144544483213428],
            [31.9135741790032, 1.145811006558599],
            [31.912714692498913, 1.146100138866325],
            [31.913854984276185, 1.147394108534325],
            [31.91389938800068, 1.151021446029887],
            [31.913258143601404, 1.151970997168952],
            [31.91307337811377, 1.154114752644423],
            [31.91374755924292, 1.155173357620261],
            [31.913375419560076, 1.155969234219496],
            [31.913438408529483, 1.157235654594774],
            [31.9123627217908, 1.15885441592318],
            [31.909981336481632, 1.1598846992569],
            [31.90712446390944, 1.162425419728487],
            [31.90592306513328, 1.162298310920767],
            [31.90523039308231, 1.164043852963238],
            [31.90382187514101, 1.164278487593064],
            [31.90374021648505, 1.165553892726281],
            [31.902333054101504, 1.16735342466616],
            [31.902458358303868, 1.168674138984868],
            [31.90071881028202, 1.169406149477102],
            [31.90013116206757, 1.172599030184265],
            [31.899344712189137, 1.173539464367441],
            [31.899263198161947, 1.175149556584789],
            [31.900259541203134, 1.177528957202682],
            [31.902321991348778, 1.179139903031154],
            [31.902800593070904, 1.181889971378446],
            [31.904065912369397, 1.183744834275029],
            [31.905558175753075, 1.184830907951676],
            [31.905330974749752, 1.185536379158939],
            [31.90577751829432, 1.186965771165204],
            [31.905947581055706, 1.192275642460923],
            [31.907771641681148, 1.193786998824689],
            [31.90794911374698, 1.195261513482876],
            [31.9086336120272, 1.196491999332843],
            [31.908594924282834, 1.199856972312701],
            [31.909705082972202, 1.202055517465247],
            [31.910370156082717, 1.20481471563441],
            [31.909977411742176, 1.205818626687058],
            [31.907720157435598, 1.206722279777898],
            [31.905918971510538, 1.208394997065337],
            [31.90475256750461, 1.213387724323413],
            [31.903677507790004, 1.216100981478851],
            [31.899872142736854, 1.220169073506724],
            [31.896623397189945, 1.216106490503669],
            [31.886012159287358, 1.207792531240122],
            [31.884190773844836, 1.204554287828801],
            [31.88022455376196, 1.202502239323328],
            [31.87926030033936, 1.200775182279108],
            [31.876044394504273, 1.199263025949339],
            [31.867363565180376, 1.190086579923314],
            [31.864040999676686, 1.187279396431353],
            [31.856751621202005, 1.184038905961835],
            [31.850320531777335, 1.179503789152331],
            [31.844611359057716, 1.177972314164609],
            [31.839361749166063, 1.173960016729211],
            [31.83836604392875, 1.171497132121135],
            [31.83510585474342, 1.167118051132465],
            [31.832796387657574, 1.16004698527684],
            [31.83186120551421, 1.158965325287618],
            [31.829879317181557, 1.155133541600587],
            [31.82961223277623, 1.152813273137152],
            [31.827630808872577, 1.147848396939548],
            [31.827417723995612, 1.144556925092189],
            [31.826238969951117, 1.143099597487028],
            [31.826078698826333, 1.141750604217083],
            [31.825275016565847, 1.140725088833457],
            [31.824043620347414, 1.136893630977021],
            [31.821471998810516, 1.133223497261466],
            [31.8197033813061, 1.132251545708331],
            [31.818256842170378, 1.130200586869212],
            [31.81520233754072, 1.127609401812299],
            [31.812470042433773, 1.123615473295688],
            [31.81027317916883, 1.121186516710068],
            [31.808772627928327, 1.120160722820819],
            [31.804643658268812, 1.123396425300669],
            [31.79980896942711, 1.128089101746816],
            [31.800138754442646, 1.128304611611447],
            [31.79868581481054, 1.141793142676238],
            [31.79632529826374, 1.146216579446083],
            [31.790532972989823, 1.153012621036184],
            [31.784851641755775, 1.150851928616889],
            [31.77498916850715, 1.148473605723513],
            [31.77219178506801, 1.17134974130866],
            [31.77229602287861, 1.17814824345991],
            [31.76897081902291, 1.18181576656228],
            [31.75627991386397, 1.193219366077535],
            [31.754361323521195, 1.192710245774552],
            [31.746385753442002, 1.197084162632205],
            [31.739683108696852, 1.199484901627815],
            [31.737247915200477, 1.201884299423779],
            [31.737146008518014, 1.203477617148627],
            [31.737764764492454, 1.203873252083441],
            [31.73845372560298, 1.206892583233346],
            [31.73957220538683, 1.207695779030059],
            [31.73838005566485, 1.211762497913472],
            [31.739117021845836, 1.213919279239144],
            [31.739211028743693, 1.216531006904543],
            [31.739996185048106, 1.217441871857894],
            [31.739305180270314, 1.218831249741238],
            [31.73954208307872, 1.221299282940118],
            [31.738909070840712, 1.225929328747932],
            [31.738527867156627, 1.22660003785832],
            [31.738478713140914, 1.229882587219996],
            [31.737215822886938, 1.232421785253304],
            [31.737429824045513, 1.232949015604422],
            [31.737095990322995, 1.234122914335282],
            [31.73800021741998, 1.234938000113341],
            [31.737427942074994, 1.236926437085394],
            [31.739219304922386, 1.240101016116342],
            [31.736430519258832, 1.242689526453031],
            [31.73482118203743, 1.245062777786135],
            [31.7322451560607, 1.251104507727266],
            [31.730850544039992, 1.252830390797995],
            [31.728491215964326, 1.254124159090791],
            [31.727524880246882, 1.257037258291941],
            [31.72623815679008, 1.257360354810229],
            [31.72623768517457, 1.258331545399924],
            [31.72548640074628, 1.259949825263331],
            [31.724306574113353, 1.260920432920949],
            [31.72334006771603, 1.264157251565037],
            [31.719155698054582, 1.270306028789543],
            [31.717222369052934, 1.277319188972536],
            [31.716471225660154, 1.278613726387458],
            [31.716684471335537, 1.28098784572958],
            [31.715717654121118, 1.284764192531098],
            [31.719895459792745, 1.291888351713517],
            [31.720645801888345, 1.292212462289531],
            [31.721930649662806, 1.295666229759145],
            [31.7227882631797, 1.295882485171273],
            [31.723323960922972, 1.296638126139394],
            [31.722680451870886, 1.297069438733656],
            [31.7234296566993, 1.299659657652314],
            [31.72331993916544, 1.304623457471256],
            [31.722354069673656, 1.306457430011485],
            [31.72246024604866, 1.308507771394422],
            [31.722030781274235, 1.309694558252279],
            [31.720743423606887, 1.311204632736008],
            [31.718705608859604, 1.312606407795015],
            [31.71870445182951, 1.314872511164199],
            [31.717846393646514, 1.31551952382995],
            [31.716987394927457, 1.318000999741636],
            [31.714628091106274, 1.319078868674054],
            [31.714305554596756, 1.320805251812806],
            [31.715054452201358, 1.323935018973293],
            [31.713550410107704, 1.329761343211918],
            [31.714029749346675, 1.332240728525498],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1627,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "KYANKWANZI",
        Population: 6798,
        Key: "KYANKWANZIKYANKWANZI",
        Dist2: "Kyankwanzi",
        "Sub Country": "Kyankwanzi",
        id2_original: "KyankwanziKyankwanzi",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "VH",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.882873668466836, 0.594512089779809],
            [31.878874136158295, 0.590732858558646],
            [31.876666806621934, 0.589239884711176],
            [31.870149347775964, 0.585828370433474],
            [31.859389719866574, 0.582063219984506],
            [31.856292679109856, 0.580018296023192],
            [31.853148920568522, 0.577132131020803],
            [31.8489065044684, 0.582142475149901],
            [31.846818618525468, 0.585760243966528],
            [31.844103730073808, 0.587948686608818],
            [31.84193275086543, 0.591412652119778],
            [31.839466225928557, 0.594243365138015],
            [31.838269254948454, 0.597987937044465],
            [31.833550482016086, 0.603405153308037],
            [31.83185639952744, 0.606263148526012],
            [31.829855933136376, 0.607981345942991],
            [31.828309785208702, 0.60843327906837],
            [31.824431723991175, 0.608689847695051],
            [31.823103553165495, 0.60861304158056],
            [31.82146687302351, 0.607038777837216],
            [31.81921219149188, 0.600163767689735],
            [31.81784000411562, 0.597350346647784],
            [31.816299139180114, 0.595477613458963],
            [31.814803865541926, 0.594428022774136],
            [31.812689619435336, 0.593902930928744],
            [31.809973204745976, 0.591469132480584],
            [31.80629266958472, 0.589822076281999],
            [31.80284535863077, 0.590047460622492],
            [31.801203107137347, 0.590933547691982],
            [31.799261892724136, 0.592760283055586],
            [31.795352514439166, 0.597643903713104],
            [31.791316315595665, 0.600781731547457],
            [31.78955714387646, 0.600898927399941],
            [31.782880238559148, 0.599739629822056],
            [31.777390116428283, 0.594085097681865],
            [31.775328963449912, 0.591045426908741],
            [31.772716438024844, 0.590140318141712],
            [31.76915132110623, 0.589985752329442],
            [31.763231136821304, 0.585289953761327],
            [31.75938168335231, 0.584755425641801],
            [31.75650374169343, 0.585541714139001],
            [31.754756706213712, 0.585496096477695],
            [31.750719812074184, 0.58699668774207],
            [31.74821482397179, 0.586236326166023],
            [31.7470907153444, 0.586814962704649],
            [31.74424160780949, 0.586778136404366],
            [31.74174213985452, 0.588966494210912],
            [31.73650160923547, 0.595097892727867],
            [31.730210851929538, 0.600369730199194],
            [31.726349746412993, 0.603037124052298],
            [31.71898811733836, 0.606042838252263],
            [31.718790581400615, 0.604346539030355],
            [31.71588081512616, 0.603398517820997],
            [31.711973985361688, 0.601174883654349],
            [31.710577516523255, 0.598636162839537],
            [31.70818172313524, 0.589816394738914],
            [31.715646115885168, 0.585830882889986],
            [31.720019960002936, 0.581589756784038],
            [31.722185049856314, 0.580405347656126],
            [31.72305461725472, 0.574945408864239],
            [31.723921611878136, 0.572961014087995],
            [31.728270519661944, 0.568261939793817],
            [31.72885383170854, 0.565455310817055],
            [31.72937233390064, 0.564632321562467],
            [31.729746519945703, 0.55990181265885],
            [31.73364111016446, 0.556565015424174],
            [31.73370699620064, 0.554394201121591],
            [31.73425913580856, 0.553815431972367],
            [31.73561241544474, 0.552902166400552],
            [31.73877074825325, 0.552414408384154],
            [31.737757075811928, 0.551328774656489],
            [31.73761292046334, 0.550541816781655],
            [31.735700358714418, 0.549971563792246],
            [31.732958097697743, 0.548044365335181],
            [31.73204500872046, 0.546669312199399],
            [31.730528144074402, 0.545507993305271],
            [31.72887944896547, 0.54286969115068],
            [31.732540590398088, 0.535887637492067],
            [31.734214183213435, 0.529719213578896],
            [31.729212732919024, 0.528418714208343],
            [31.72605931569177, 0.524433171609002],
            [31.721492981473222, 0.521041687476849],
            [31.719893717061105, 0.516863564508982],
            [31.718216493255387, 0.509716368040378],
            [31.71491258396348, 0.505015683738679],
            [31.709055760550505, 0.500208882098011],
            [31.706940538873496, 0.497321567225192],
            [31.706229650785183, 0.495390472035263],
            [31.71177995824344, 0.491870067365582],
            [31.71470444251554, 0.489301840385215],
            [31.71910261301121, 0.487412277671827],
            [31.72098096242251, 0.486128237111351],
            [31.722169797361097, 0.484500351484875],
            [31.72548762514999, 0.476061910122899],
            [31.725725920347106, 0.473502194707636],
            [31.725310294119666, 0.470806675628861],
            [31.725192620207316, 0.464827855485968],
            [31.726417193721165, 0.462684385533638],
            [31.727297544496228, 0.458858466780932],
            [31.729651637190447, 0.45535843999059],
            [31.73017492650472, 0.452563592187469],
            [31.731102326542757, 0.450980856571365],
            [31.73394362861616, 0.449173031280965],
            [31.734417302180642, 0.450480439475895],
            [31.736698983476433, 0.451809883323387],
            [31.740353458511322, 0.452303416751847],
            [31.7434561945869, 0.458174650659508],
            [31.74639349512312, 0.462432223176316],
            [31.750607342102292, 0.46216784681455],
            [31.755153526210677, 0.463260062868962],
            [31.758545524299326, 0.464985794774702],
            [31.765504099967266, 0.470127227227133],
            [31.7730220026637, 0.476677056065836],
            [31.776553904374705, 0.478473247841484],
            [31.780750408478973, 0.479600629152786],
            [31.782498881263148, 0.480481119703481],
            [31.78389747192226, 0.482241725880024],
            [31.78505112164777, 0.484741637525431],
            [31.785959873558866, 0.48773440456374],
            [31.78527216919144, 0.489053545209022],
            [31.785751966571205, 0.492019784953522],
            [31.787227054166642, 0.495909548590581],
            [31.78989480352378, 0.497348243489206],
            [31.792219213186044, 0.499980866923591],
            [31.793690620383778, 0.501012307315154],
            [31.801063702978308, 0.504469002846656],
            [31.803486774608253, 0.505048357789491],
            [31.806980580564677, 0.505193733688757],
            [31.807694368414694, 0.504958683356326],
            [31.809729751422534, 0.499061469884243],
            [31.813023677736656, 0.492666977457755],
            [31.815205019011856, 0.490062303872449],
            [31.81680734488245, 0.489167093513378],
            [31.819800541290597, 0.48911335825134],
            [31.824673398650372, 0.493528389489249],
            [31.82567488095331, 0.494017018027288],
            [31.82847885802665, 0.49384566266951],
            [31.831880645955263, 0.492100491113912],
            [31.831110669382532, 0.497174857203202],
            [31.832384761628077, 0.502620453672838],
            [31.83321446898071, 0.509033825417064],
            [31.836576846021167, 0.520277956085632],
            [31.842566030801372, 0.520713254523522],
            [31.846342961480865, 0.519341562923463],
            [31.853064589424605, 0.526890806688165],
            [31.857676049613115, 0.531117243068868],
            [31.86361436639205, 0.537598697617182],
            [31.8678279187238, 0.540438821179094],
            [31.86988510204694, 0.540906863026449],
            [31.874115920896735, 0.5401727717848],
            [31.87837941237176, 0.542227916773362],
            [31.879955515520912, 0.542428636331612],
            [31.889917084623484, 0.541418523283957],
            [31.89243088519877, 0.544819923928615],
            [31.893657467345598, 0.549044472294981],
            [31.894987504870443, 0.549596502987477],
            [31.897674219459834, 0.549343724199358],
            [31.901924414072024, 0.546060938766846],
            [31.902031517508398, 0.540733050355576],
            [31.904048313474696, 0.537051835405811],
            [31.904480844199146, 0.534871901049854],
            [31.905884349541175, 0.534492241033808],
            [31.9114227947461, 0.534484179004959],
            [31.914373959880425, 0.533506736749357],
            [31.91803006356092, 0.540428406574986],
            [31.919576689392347, 0.542093099159876],
            [31.918013567797352, 0.543601271387303],
            [31.918824928856928, 0.548558038917235],
            [31.918383707830387, 0.552143083959395],
            [31.917398402389114, 0.553959463809528],
            [31.915477434205783, 0.555254181801551],
            [31.914246897675074, 0.55810665722698],
            [31.914082148448593, 0.559750973858501],
            [31.915718611198322, 0.564339704170767],
            [31.91483273488594, 0.56883886336293],
            [31.914256629124534, 0.56992158344657],
            [31.91327766758579, 0.57033895240307],
            [31.907022527582573, 0.571673927246421],
            [31.904896492884475, 0.572567193481339],
            [31.899864856501598, 0.579725241959038],
            [31.896732286477114, 0.582718124468174],
            [31.88692302673095, 0.589701700326403],
            [31.884531135624524, 0.590999829952595],
            [31.88034521097937, 0.591996672335275],
            [31.882873668466836, 0.594512089779809],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1633,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "KASSANDA",
        Population: 43857,
        Key: "MUBENDEKASSANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.914373959880425, 0.533506736749357],
            [31.9114227947461, 0.534484179004959],
            [31.905884349541175, 0.534492241033808],
            [31.904480844199146, 0.534871901049854],
            [31.904048313474696, 0.537051835405811],
            [31.902031517508398, 0.540733050355576],
            [31.901924414072024, 0.546060938766846],
            [31.897674219459834, 0.549343724199358],
            [31.894987504870443, 0.549596502987477],
            [31.893657467345598, 0.549044472294981],
            [31.89243088519877, 0.544819923928615],
            [31.889917084623484, 0.541418523283957],
            [31.886301538081412, 0.537826510221974],
            [31.883524514059857, 0.535998778484824],
            [31.882293366674787, 0.533682883347661],
            [31.882387460709225, 0.528870627509938],
            [31.88356472175367, 0.523163066163211],
            [31.885327288206348, 0.51748563956829],
            [31.887401653605924, 0.514629955421557],
            [31.886655190435725, 0.513894933158446],
            [31.8825895852414, 0.512123283890912],
            [31.88376407588151, 0.509982493287959],
            [31.883463930778806, 0.507460750397585],
            [31.880784967751968, 0.499895190670035],
            [31.88013477253922, 0.49349753440217],
            [31.877280280502504, 0.486900296890746],
            [31.875051200956484, 0.485159951799291],
            [31.875953861391633, 0.479778815422494],
            [31.875177974802636, 0.475920490533068],
            [31.873169428065616, 0.471595737174668],
            [31.871632367495344, 0.471079665320145],
            [31.870664791204515, 0.469551165987469],
            [31.86931823545824, 0.464526549787835],
            [31.86916671661928, 0.46266386778322],
            [31.867307519289803, 0.459282131907254],
            [31.86165280513765, 0.456835892749739],
            [31.8594138315471, 0.454982432349375],
            [31.857402951885287, 0.450721901851804],
            [31.85897927601999, 0.442685047735042],
            [31.85850563838813, 0.437589914256957],
            [31.859796983677025, 0.431503531646479],
            [31.85987383544791, 0.425092214512133],
            [31.859952227829485, 0.407913792727864],
            [31.859555527308434, 0.39495541697551],
            [31.86012575898619, 0.388125773381443],
            [31.85907502744611, 0.368508293386854],
            [31.858330318685702, 0.338874622004922],
            [31.865688092191164, 0.334668371975743],
            [31.869196110393673, 0.333420499405621],
            [31.880164828372006, 0.330536217344664],
            [31.883124674825208, 0.330002865878744],
            [31.887608881467223, 0.329858646445919],
            [31.924700676179693, 0.335199775675337],
            [31.926103009220284, 0.337208080326141],
            [31.927132195566543, 0.34016343567103],
            [31.92855074319801, 0.346661171169591],
            [31.929785386826186, 0.358845954625437],
            [31.93268538661689, 0.36394811056533],
            [31.93409924144929, 0.368172658291511],
            [31.93559668901048, 0.370678522264655],
            [31.939515994577643, 0.382912968691804],
            [31.93891030370069, 0.394484448634992],
            [31.940086422088104, 0.399953455584828],
            [31.941940161253918, 0.404836169212399],
            [31.9438059189799, 0.408773519705544],
            [31.948120023334628, 0.415559316590446],
            [31.958305598133077, 0.428090046676878],
            [31.9556660980967, 0.432134501161457],
            [31.95453629504871, 0.435903911690866],
            [31.95328705559379, 0.443670256329991],
            [31.95300091522634, 0.449701528937043],
            [31.952132714165487, 0.452729026157364],
            [31.945831562453407, 0.459309887161106],
            [31.9444404296078, 0.461571409998103],
            [31.943346718172958, 0.462217462746591],
            [31.941254109786584, 0.465352460616155],
            [31.938876316840243, 0.467769405551095],
            [31.93546377517934, 0.47390786092321],
            [31.934393295076102, 0.478048215789384],
            [31.934464319475715, 0.48001078822443],
            [31.93533174439214, 0.482129056878856],
            [31.935616682813748, 0.484378860482018],
            [31.93492669762379, 0.487753399650453],
            [31.933297415108168, 0.492432164722655],
            [31.93201330395223, 0.494274848280811],
            [31.929754429084877, 0.496260965340251],
            [31.929425100413503, 0.497226509285503],
            [31.930149629419383, 0.506633698512452],
            [31.929657678732152, 0.508746844766531],
            [31.926822103418683, 0.511847771711857],
            [31.92382470199669, 0.512870417857412],
            [31.92184902910749, 0.51408566117472],
            [31.919182475407993, 0.515992551170794],
            [31.918360031832787, 0.517054234048213],
            [31.91797365025939, 0.519800490637112],
            [31.919017930997416, 0.525928677965891],
            [31.91908386733927, 0.528365088862946],
            [31.918033932604846, 0.530178834000921],
            [31.914373959880425, 0.533506736749357],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1636,
        District: "MUBENDE",
        County: "KASSANDA",
        Subcounty: "MYANZI",
        Population: 21471,
        Key: "MUBENDEMYANZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.302813314856486, 0.63897050050416],
              [32.30293364778204, 0.63826186359663],
              [32.30205381263995, 0.638144136800829],
              [32.29178418068373, 0.639056428898104],
              [32.28520836548029, 0.641932337630191],
              [32.282187641098545, 0.644564478968173],
              [32.28285307263684, 0.645568749770734],
              [32.27445183855524, 0.652379643854746],
              [32.263956097947066, 0.651817214541261],
              [32.259104965444095, 0.652124078937409],
              [32.25456319296205, 0.651354442315046],
              [32.25104383263073, 0.651254402507356],
              [32.25043493297161, 0.651643313749743],
              [32.24302194182226, 0.650990841246402],
              [32.239577939363485, 0.652184460677496],
              [32.23608614204004, 0.651894437708199],
              [32.23401933865851, 0.651197537433278],
              [32.22597146497877, 0.656176552529171],
              [32.2253706815982, 0.655403513932288],
              [32.220031600402606, 0.655079382550485],
              [32.217301954427434, 0.654230307251561],
              [32.21581676707326, 0.653381428527195],
              [32.213006824288136, 0.652613163735599],
              [32.211521657595185, 0.65164304966211],
              [32.2104793055401, 0.649458276624147],
              [32.21327881708817, 0.646026111418781],
              [32.2147545451824, 0.643229141269446],
              [32.21472475974251, 0.641015296050503],
              [32.21368174652739, 0.636286972234947],
              [32.21155486651462, 0.63147766318732],
              [32.20684851458768, 0.624688979681813],
              [32.212364006040474, 0.62023314159738],
              [32.21324784317718, 0.620165622786511],
              [32.213950593427285, 0.620782842380711],
              [32.21517448152658, 0.62105815535616],
              [32.21660199075132, 0.620192156567248],
              [32.2183466142545, 0.618824211052338],
              [32.21932056858385, 0.617067297477194],
              [32.22231811283799, 0.609707943382097],
              [32.22258967893826, 0.604695009369778],
              [32.22313498596012, 0.601536906332572],
              [32.2238945492621, 0.599838743601241],
              [32.22592466275246, 0.597316399361487],
              [32.229415803407434, 0.595405854519445],
              [32.234449869733155, 0.590242560759447],
              [32.23500678119189, 0.586282816938035],
              [32.23474483784492, 0.584296375387051],
              [32.23365127732706, 0.581567219214656],
              [32.23187798409158, 0.579359959837584],
              [32.24129671294605, 0.573974068947339],
              [32.24312561728751, 0.573617117015256],
              [32.24823289720721, 0.574460190307164],
              [32.25062284256272, 0.574383191489135],
              [32.25601020730654, 0.570617083079202],
              [32.25953286894653, 0.56913264468651],
              [32.261578324763626, 0.567388081837811],
              [32.26374294569645, 0.564639057701694],
              [32.26860788530531, 0.556594080840396],
              [32.272045149501125, 0.551992280891796],
              [32.28508015971956, 0.53609592253949],
              [32.28845636901875, 0.537724732888602],
              [32.290869791844244, 0.538360261132867],
              [32.294365370176706, 0.538147456039472],
              [32.2975519244582, 0.53752782276248],
              [32.30427031307704, 0.534411203046167],
              [32.30607763359714, 0.533981931203344],
              [32.30771782166036, 0.536279245389937],
              [32.30818078910327, 0.539161721460365],
              [32.30936922878313, 0.541243453042419],
              [32.313208415406734, 0.545802588731006],
              [32.315704884785255, 0.547191596756892],
              [32.32188736815, 0.547674295221298],
              [32.32960323887381, 0.549748643645612],
              [32.332967425121254, 0.551987343081844],
              [32.33004174519155, 0.555044710798491],
              [32.3265931945625, 0.557052685966026],
              [32.32372724092108, 0.560173468189442],
              [32.320717797582695, 0.565537812565824],
              [32.31958682043663, 0.570929514208117],
              [32.32094109271118, 0.574783572037205],
              [32.32133233237361, 0.579153178227254],
              [32.32218766506801, 0.582165835531284],
              [32.32330489799025, 0.583812472696092],
              [32.32504055720519, 0.585160644428479],
              [32.33006916716391, 0.587278186106664],
              [32.33168566216149, 0.589431502292384],
              [32.33250520328, 0.59351167544169],
              [32.331717752678365, 0.598125410421071],
              [32.33420083626088, 0.60539023878646],
              [32.33385438300523, 0.611451503985651],
              [32.33608936627931, 0.612863073782249],
              [32.339085216310814, 0.613587188511684],
              [32.339368246710755, 0.614010037183393],
              [32.33697902539733, 0.614255948543581],
              [32.33497995408994, 0.614984804119321],
              [32.331792704512424, 0.618746589460669],
              [32.327707561858965, 0.620904220107447],
              [32.32524475774403, 0.623207874963],
              [32.320753991603816, 0.625598753619445],
              [32.3191023715803, 0.627844179320978],
              [32.32008698801378, 0.630819054788798],
              [32.32075251297687, 0.636943620833502],
              [32.32138957032856, 0.639218510823096],
              [32.324112051341025, 0.645080878736815],
              [32.32153381910195, 0.643797306917146],
              [32.31765249610163, 0.638051443598714],
              [32.31536414032327, 0.635543020763875],
              [32.314408145113084, 0.635251250630548],
              [32.312235331544905, 0.635338451022777],
              [32.30916420089593, 0.637117047845671],
              [32.30826627817561, 0.635862868690801],
              [32.30725227335763, 0.63609604439678],
              [32.302813314856486, 0.63897050050416],
            ],
          ],
          [
            [
              [32.387246128311, 0.652991898520098],
              [32.38249915456691, 0.663110225486387],
              [32.380535559526685, 0.662836423843679],
              [32.38087888125524, 0.66453101157806],
              [32.38300820199063, 0.669234506247717],
              [32.38111839905944, 0.672139198348246],
              [32.37864467682055, 0.674317579306751],
              [32.37682358243216, 0.677153110119625],
              [32.375861179539044, 0.681095388935625],
              [32.37276114649416, 0.685404957582185],
              [32.37149537624136, 0.685296036561842],
              [32.3653832561162, 0.686824128393682],
              [32.36376652037014, 0.68637157258138],
              [32.36040091208959, 0.688678046604635],
              [32.356429575202846, 0.688550850754198],
              [32.356050094487486, 0.684868765475604],
              [32.34149050938294, 0.680066443168562],
              [32.341748189325585, 0.67915901812745],
              [32.336146827914746, 0.674947934646738],
              [32.334546002230674, 0.669206593004418],
              [32.33463577447028, 0.667853805210406],
              [32.332910019181334, 0.667770842446368],
              [32.32631505459096, 0.669212262783705],
              [32.32759077188889, 0.662881190186486],
              [32.32759189747792, 0.65515411570011],
              [32.33235681147654, 0.650092120364172],
              [32.33818018791656, 0.648227721086448],
              [32.342415591767605, 0.645030875389064],
              [32.34188720451411, 0.636717477641959],
              [32.347400032462076, 0.630583371799297],
              [32.35058882804019, 0.631347401008375],
              [32.355295996535716, 0.635265242827665],
              [32.35707954134521, 0.63565447866257],
              [32.35741227193655, 0.636133999471491],
              [32.36882499571876, 0.642386756010308],
              [32.374305584927825, 0.644332500127576],
              [32.37749178078154, 0.645916085569324],
              [32.38079632428399, 0.648883848058948],
              [32.387246128311, 0.652991898520098],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1681,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "SEMUTO",
        Population: 23404,
        Key: "NAKASEKESEMUTO",
        Dist2: "Nakaseke",
        "Sub Country": "Semuto",
        id2_original: "NakasekeSemuto",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.68166583025575, 0.557272904731814],
            [32.67767379977814, 0.558855945934743],
            [32.67192339618361, 0.560402693814782],
            [32.666886690607576, 0.56071001073134],
            [32.66510440433779, 0.56140654178612],
            [32.659463278102606, 0.557615442188187],
            [32.65698059966032, 0.557723861910601],
            [32.653678450168066, 0.557244166290218],
            [32.65180124970199, 0.557786884724668],
            [32.65094612002683, 0.557044965311047],
            [32.64963963812541, 0.556900132289686],
            [32.64729933546909, 0.557252830131377],
            [32.64470904424565, 0.558229767291225],
            [32.64135912234662, 0.558301939006724],
            [32.639553257097255, 0.558844657343551],
            [32.63823436497016, 0.559577395287475],
            [32.63640427125928, 0.561350524635559],
            [32.633315185982724, 0.562517413304126],
            [32.63007097962295, 0.565186116796533],
            [32.626317211104755, 0.565158732089119],
            [32.622372967406996, 0.566108424253101],
            [32.61828738188411, 0.568234232621612],
            [32.61679079401067, 0.567754633980556],
            [32.613798286610326, 0.565175997767194],
            [32.61161310863055, 0.564117336106494],
            [32.60953432351978, 0.5637734040144],
            [32.60860750109844, 0.564325215946342],
            [32.60738541681625, 0.566288360594765],
            [32.60580309732535, 0.566930597667977],
            [32.60402048406879, 0.56833277924902],
            [32.603033761984314, 0.570042618255285],
            [32.60008699230666, 0.572249909984398],
            [32.59656985800064, 0.574013848843421],
            [32.59471651589018, 0.57475558014484],
            [32.592281312512334, 0.574809687443233],
            [32.589691686940505, 0.574311908363054],
            [32.58831386173753, 0.574384185874186],
            [32.58714944211006, 0.574954068187558],
            [32.5835959440013, 0.5785545553039],
            [32.583452908851896, 0.579721621035493],
            [32.58188399941153, 0.581277605601285],
            [32.58029841544288, 0.5842449351387],
            [32.56999088805641, 0.576807440644964],
            [32.56925518131345, 0.575441273675859],
            [32.56818875171379, 0.568863960156668],
            [32.558388782344316, 0.568419903459733],
            [32.55368638749623, 0.564375497603458],
            [32.55292684216056, 0.562647448952589],
            [32.54892506765706, 0.559770171736548],
            [32.54630149654729, 0.555445471750229],
            [32.54504282837514, 0.554631138647268],
            [32.543498786996786, 0.554323418987036],
            [32.53695864479158, 0.547656927088746],
            [32.54009406606878, 0.544764113224703],
            [32.54534564147424, 0.542326903989076],
            [32.550384103256675, 0.538263240177901],
            [32.55124090828984, 0.534771730683396],
            [32.55126649320744, 0.530562350584791],
            [32.54751690994016, 0.520946055887114],
            [32.548444307283276, 0.519009183744539],
            [32.55029821982394, 0.517168392694799],
            [32.55423292790496, 0.510748387174707],
            [32.560888836899146, 0.502117238590925],
            [32.56143577795653, 0.500921618667337],
            [32.56276674074609, 0.499726347956996],
            [32.56488207920408, 0.49864499795834],
            [32.56375166260677, 0.498051113646284],
            [32.563104916026376, 0.496550644078887],
            [32.56387220843304, 0.495718972748998],
            [32.56633223046556, 0.49507525599402],
            [32.57287581231999, 0.494580392559757],
            [32.57318318975909, 0.492565201199603],
            [32.57739443252224, 0.486840485625348],
            [32.57476344941305, 0.467805267796899],
            [32.576595319991554, 0.4679861806659],
            [32.57831948436414, 0.467335402565557],
            [32.57954071345019, 0.467769398364791],
            [32.581428972177406, 0.467246688796958],
            [32.5872607227125, 0.467446256373049],
            [32.592046388692495, 0.46127233640268],
            [32.59400098171524, 0.45960898778743],
            [32.59876490217717, 0.456666526174545],
            [32.601381989247194, 0.456054592553158],
            [32.60150283151754, 0.459310356964891],
            [32.601143739864206, 0.460120106432558],
            [32.6020508119257, 0.462829777611707],
            [32.60154529308441, 0.468778532948938],
            [32.60283711897199, 0.473957783087194],
            [32.60443910348278, 0.474880948260399],
            [32.60652123391968, 0.478178581052603],
            [32.60862008380062, 0.483789632500888],
            [32.6152283434572, 0.488067229088806],
            [32.616540821613185, 0.489823439791965],
            [32.61632995737161, 0.492362761650177],
            [32.618389896726036, 0.497597383638685],
            [32.61843889623152, 0.498535645687759],
            [32.619370842643235, 0.499720871137011],
            [32.622213819176324, 0.501721809087801],
            [32.62436370594182, 0.502236945284305],
            [32.62840296354887, 0.501329805604124],
            [32.63151448784289, 0.503196663899496],
            [32.63337941911881, 0.503376841027816],
            [32.63677689333743, 0.503210859428434],
            [32.64403585485659, 0.501145075033367],
            [32.64757498171742, 0.503155623253453],
            [32.64970034357736, 0.505536286608862],
            [32.65321588337377, 0.507140232389945],
            [32.65510460203839, 0.5072725634191],
            [32.655769994050814, 0.506890168273977],
            [32.65643508961919, 0.507201373824356],
            [32.65729051214513, 0.506890806951152],
            [32.66035486949682, 0.507968372925699],
            [32.663130565808395, 0.508016426413061],
            [32.66324038664852, 0.513370644425656],
            [32.66555400754421, 0.520128266996544],
            [32.66884274069772, 0.524422809976232],
            [32.66957755541359, 0.528420729043808],
            [32.6725564030317, 0.535007247907714],
            [32.675735232700085, 0.54651545755548],
            [32.67859588089141, 0.552504860935037],
            [32.68166583025575, 0.557272904731814],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1692,
        District: "WAKISO",
        County: "NANSANA MUNICIPALITY",
        Subcounty: "BUSUKUMA DIVISION",
        Population: 37730,
        Key: "WAKISOBUSUKUMA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.72113575388449, 0.436606625401136],
            [32.71374420821592, 0.444271645984548],
            [32.712900140395185, 0.445879910601938],
            [32.70833329862851, 0.45029495927007],
            [32.70724808345965, 0.451903211785797],
            [32.70435429641747, 0.453329318258957],
            [32.701008286681464, 0.456515426256856],
            [32.69589894333157, 0.458927651906706],
            [32.69330650064301, 0.462235164371512],
            [32.69173900515091, 0.463539940011279],
            [32.686448792306756, 0.466073524355887],
            [32.67734960048706, 0.47209326030835],
            [32.67700368262732, 0.471473836325655],
            [32.66662960624798, 0.463368553350256],
            [32.66288387316001, 0.460017499677177],
            [32.662044245711705, 0.458405640553845],
            [32.66578586990558, 0.443714237425854],
            [32.665842405377965, 0.440757113818846],
            [32.66520442096489, 0.435544094722217],
            [32.66187918297321, 0.430561249832583],
            [32.66162099817739, 0.429463387660496],
            [32.66659551428463, 0.415872850914302],
            [32.666176544527694, 0.412914251451022],
            [32.66671555795269, 0.411568445599071],
            [32.66653180666301, 0.409445304970341],
            [32.666918658953584, 0.407278666655759],
            [32.669432179254514, 0.401655597432631],
            [32.672141177452865, 0.398170077101703],
            [32.67454451040109, 0.393562686661066],
            [32.67486109108025, 0.39108335058376],
            [32.674151400446235, 0.389912549567833],
            [32.674153782778376, 0.389125535768612],
            [32.67249312480479, 0.386527485128157],
            [32.67572896964592, 0.383203878001722],
            [32.6770755137141, 0.378199710279882],
            [32.67839069310412, 0.375699611017945],
            [32.6812635808412, 0.373049296147516],
            [32.68336539965418, 0.369859993571772],
            [32.68365784709325, 0.367499834009425],
            [32.68344660825419, 0.362669722225758],
            [32.684558839356924, 0.352596858555775],
            [32.68400451594452, 0.339358842292465],
            [32.68531735342662, 0.325800227732305],
            [32.68705482993339, 0.289783324915147],
            [32.6874473955092, 0.289379372064335],
            [32.69548375278703, 0.288454976965389],
            [32.69988458678752, 0.289071507169286],
            [32.70537602674689, 0.291286881452486],
            [32.71002941310636, 0.292405721319181],
            [32.7100908884145, 0.294870540324718],
            [32.71087118842647, 0.297392796290251],
            [32.71239080101898, 0.299170805840945],
            [32.71750413558372, 0.303615864385584],
            [32.71980413173149, 0.304815022029853],
            [32.72477379154632, 0.306551774031096],
            [32.73048856705837, 0.31388465373335],
            [32.72894689723237, 0.318501700304847],
            [32.726888601794926, 0.321664583131291],
            [32.7269911974852, 0.324786373103472],
            [32.7276483187088, 0.325944140004724],
            [32.73233044307252, 0.329293468158841],
            [32.733439379154774, 0.329624284361072],
            [32.73455726694886, 0.329399234951352],
            [32.73534276910466, 0.33026247288974],
            [32.738369795168104, 0.328610501084413],
            [32.74001366812058, 0.329569797949033],
            [32.739719539035306, 0.330369881764983],
            [32.740607609033596, 0.332618833929607],
            [32.73949728146098, 0.33832824474925],
            [32.73700838757521, 0.346003420565408],
            [32.73456827400604, 0.350939306755521],
            [32.73378777995795, 0.355239496296113],
            [32.73230601518499, 0.358975048083771],
            [32.73230902633782, 0.360532019663135],
            [32.731446450527294, 0.362558054889194],
            [32.7298649844359, 0.368739557175425],
            [32.72976991842434, 0.375096952314298],
            [32.72816399300437, 0.376796883071752],
            [32.72980798004292, 0.379668881778517],
            [32.72732752043937, 0.3873864058678],
            [32.72977767088522, 0.388765898141328],
            [32.73122164802575, 0.390276801684755],
            [32.73156021227655, 0.392706135353541],
            [32.742343896170944, 0.395490434541758],
            [32.74223936730619, 0.391279582085632],
            [32.74294371296425, 0.388169242758859],
            [32.744215965460135, 0.38617956385065],
            [32.74656334594255, 0.384453903280629],
            [32.74515766757584, 0.383009143771031],
            [32.74594097694402, 0.378691433746579],
            [32.74727520510966, 0.378798668688968],
            [32.748926503536275, 0.376369172064191],
            [32.75191304881808, 0.377188744868861],
            [32.754277724564645, 0.379334818228837],
            [32.753466989630844, 0.380431148409625],
            [32.760541330291105, 0.392853695442941],
            [32.7619085113563, 0.394481489654587],
            [32.76252328150582, 0.394650631225334],
            [32.76294080767012, 0.397439432009885],
            [32.7570309692823, 0.397988198697706],
            [32.750135392465275, 0.397676802516186],
            [32.7477338067403, 0.398323042126416],
            [32.74155362845258, 0.397612060696234],
            [32.739821542735825, 0.402834090668703],
            [32.739840876277356, 0.404923930627785],
            [32.73914238134673, 0.406798903840736],
            [32.73902591926173, 0.408556708741961],
            [32.74013164476516, 0.41252158107841],
            [32.74040314079686, 0.416115333055843],
            [32.74199394218065, 0.418537257071336],
            [32.742149097399896, 0.420138821394597],
            [32.7410819769958, 0.422111437931376],
            [32.73937462279713, 0.424103563943003],
            [32.73669725697487, 0.424923782335414],
            [32.7349123072003, 0.426642467137558],
            [32.731342468736536, 0.428204837385432],
            [32.728451633558386, 0.430646133738109],
            [32.7269382714436, 0.432989821158042],
            [32.723446041132185, 0.434395938043835],
            [32.72113575388449, 0.436606625401136],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1698,
        District: "MUKONO",
        County: "MUKONO MUNICIPALITY",
        Subcounty: "GOMA DIVISION",
        Population: 93039,
        Key: "MUKONOGOMA DIVISION",
        Dist2: "Mukono",
        "Sub Country": "Kasawo",
        id2_original: "MukonoKasawo",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.28132548582042, 2.909928066556821],
            [34.2824235801355, 2.908078675521582],
            [34.2827285545812, 2.906639759853016],
            [34.28399560313663, 2.906432800368266],
            [34.284158169456965, 2.905590025225997],
            [34.28466902878262, 2.905466135438975],
            [34.28456541170786, 2.904212645386396],
            [34.284973558562264, 2.903636751877491],
            [34.28738379506341, 2.902154325313017],
            [34.289162414410214, 2.902460551279261],
            [34.28973407890084, 2.901884469370152],
            [34.290102788815936, 2.902582778056093],
            [34.2904092481768, 2.902459120304425],
            [34.29112296236499, 2.900978636349787],
            [34.29173585503557, 2.900710770036687],
            [34.29140851343761, 2.900443983846205],
            [34.29159214525134, 2.900156061288916],
            [34.2935132077578, 2.899907243387063],
            [34.29410544816001, 2.899454443255721],
            [34.29398145370134, 2.898262634791572],
            [34.294614642009115, 2.897871439739323],
            [34.29477685079997, 2.896720404075806],
            [34.295940302043576, 2.895301056447587],
            [34.29538744917333, 2.894438555023256],
            [34.297001717247305, 2.894025681238506],
            [34.29792002723302, 2.892729920877925],
            [34.29861467108602, 2.892461960204873],
            [34.29885809746005, 2.890838162371413],
            [34.299938821950825, 2.888576326403435],
            [34.30155263188401, 2.887772984939886],
            [34.3046383412917, 2.887194003968118],
            [34.30610409179808, 2.882034062509431],
            [34.30692056427161, 2.881067234120423],
            [34.307493077670166, 2.88125153009505],
            [34.30832977571231, 2.880099719464345],
            [34.30941256722653, 2.879666902416939],
            [34.30984082915677, 2.878823827460326],
            [34.31094464484194, 2.878904753237703],
            [34.31259848370418, 2.877382084428049],
            [34.31249403029788, 2.87540933399857],
            [34.312003277064925, 2.875224944669119],
            [34.311982250199065, 2.874711201495881],
            [34.31286040728821, 2.874073112696323],
            [34.31287981179665, 2.873168857180589],
            [34.31345161462782, 2.872736630542703],
            [34.3134094198606, 2.871585838590747],
            [34.31408365309205, 2.871359000910922],
            [34.31373534122211, 2.870619577338126],
            [34.31451064210954, 2.869406189070173],
            [34.314264361787856, 2.868522792212461],
            [34.315039659980364, 2.867309402616336],
            [34.31565254905765, 2.86706208660432],
            [34.315733271669096, 2.866157760943374],
            [34.31775621660349, 2.865703305519555],
            [34.31736667565527, 2.864655670199425],
            [34.318837387556954, 2.863873042434651],
            [34.31971626240002, 2.863872024120217],
            [34.32059325257761, 2.862226954347906],
            [34.32155322193462, 2.861650422316421],
            [34.3220235519696, 2.861855383822995],
            [34.32230877695378, 2.861053577487878],
            [34.323187790137396, 2.861175861645912],
            [34.32343194774003, 2.86020969747377],
            [34.32467935463177, 2.860763116672442],
            [34.32608954074458, 2.860679274621262],
            [34.32641528603627, 2.8595691620051],
            [34.327273692765566, 2.859547613134314],
            [34.32837601634905, 2.858354393801054],
            [34.33043988134126, 2.857961529719454],
            [34.33139881943234, 2.856501319360151],
            [34.332931296798016, 2.856129621372821],
            [34.33376804873908, 2.855060014741882],
            [34.333868415709155, 2.853477504065138],
            [34.334297319036494, 2.853209846405405],
            [34.33419393911696, 2.852182438770853],
            [34.33498997851104, 2.85125673448641],
            [34.33549428283008, 2.845481439132881],
            [34.336412664681, 2.84430898814701],
            [34.33596292403232, 2.844227308963448],
            [34.335348515005535, 2.843138845386407],
            [34.336513151127015, 2.842829230898734],
            [34.33630791572899, 2.842089650782537],
            [34.33679763230613, 2.841390361242313],
            [34.33759463649083, 2.841307231062014],
            [34.337695809249695, 2.840423440256247],
            [34.3387770071526, 2.838654834690067],
            [34.3413717270704, 2.837829787817405],
            [34.34253139640666, 2.833225122084113],
            [34.342081731216474, 2.833205096195554],
            [34.34206074836807, 2.832732458208663],
            [34.34473691943099, 2.831660711547134],
            [34.346081898633926, 2.828247762070161],
            [34.34890035834626, 2.826518231677964],
            [34.348368944668586, 2.826498301676351],
            [34.34826568691996, 2.825573652584636],
            [34.34949070959145, 2.824483046836561],
            [34.350509259884745, 2.821584245311245],
            [34.34928025587995, 2.819222378319619],
            [34.349647995614546, 2.819098646976564],
            [34.34989154415941, 2.817618730124635],
            [34.34960359009342, 2.816036681442358],
            [34.350012228326264, 2.815933453274138],
            [34.35015624174105, 2.816755302737925],
            [34.3507690212239, 2.816446331694863],
            [34.35097271241795, 2.815850131953257],
            [34.350337599918795, 2.814515092363699],
            [34.35084819064819, 2.81420624095557],
            [34.35205136719027, 2.811903191511446],
            [34.35341993794922, 2.811243981176953],
            [34.35341652524948, 2.808284725003334],
            [34.352249447507056, 2.806436546524],
            [34.35267809481455, 2.80596338713303],
            [34.351901061975255, 2.805614933841081],
            [34.35289924566446, 2.802777814664061],
            [34.35377728148104, 2.802098629284298],
            [34.35328564520413, 2.801112780602297],
            [34.35315985680987, 2.798359170482117],
            [34.3543856825752, 2.797987839682011],
            [34.35383250181988, 2.796796557870883],
            [34.35454760121022, 2.796610774250357],
            [34.35571119079438, 2.795438048786148],
            [34.355321250095855, 2.794020523477251],
            [34.35683161273585, 2.792271985296551],
            [34.35707558618389, 2.791161981320941],
            [34.35881292704506, 2.791303815833829],
            [34.35836210033319, 2.790256270331102],
            [34.35973137806626, 2.790234127091507],
            [34.3599143451267, 2.789391349465906],
            [34.35901830527519, 2.788887112280867],
            [34.35915806067553, 2.788322219766021],
            [34.3600463229133, 2.78747409224899],
            [34.36018580792071, 2.786673897171495],
            [34.36070035752558, 2.786437994977803],
            [34.360980302212525, 2.785684697753425],
            [34.360605131613866, 2.785026281996859],
            [34.36154008378854, 2.784083980713344],
            [34.36191260345876, 2.782436421135231],
            [34.361816568165, 2.780318797630331],
            [34.36237710522421, 2.7793769322411],
            [34.36218827935149, 2.777965328346394],
            [34.3627015281958, 2.776599971168872],
            [34.36138958094417, 2.775283790428995],
            [34.36232210137936, 2.772223759901509],
            [34.361666347391605, 2.771753911110329],
            [34.36096250029854, 2.770154658365613],
            [34.361568117513634, 2.767706797858519],
            [34.36198905727596, 2.767471007624291],
            [34.361800024790746, 2.765871159592423],
            [34.36240322553771, 2.761305568109675],
            [34.362777738569555, 2.761399257685252],
            [34.362588550675774, 2.759658228055292],
            [34.36417676580989, 2.757020994767532],
            [34.36412685451439, 2.754291528965683],
            [34.36375223637965, 2.754103717994122],
            [34.36347004051462, 2.752880463187381],
            [34.3622517327499, 2.751564162823618],
            [34.362204237024194, 2.750952427048929],
            [34.36360492974105, 2.748033050136103],
            [34.361963720293396, 2.745211287935121],
            [34.36186803983415, 2.743376025937486],
            [34.36233396093774, 2.741540122254548],
            [34.36172513583875, 2.741164332066133],
            [34.36275324241007, 2.739845453442995],
            [34.36331505417866, 2.740033053999826],
            [34.363313295277315, 2.738480050706122],
            [34.362375968855375, 2.73730460278439],
            [34.36237453244922, 2.736033962776522],
            [34.36382521730998, 2.735938182315409],
            [34.36410505779236, 2.735090769323227],
            [34.36368034959736, 2.731985245019758],
            [34.44218337757321, 2.620544537650146],
            [34.47581895902726, 2.572068545360338],
            [34.47880133882105, 2.568983288128425],
            [34.479545024400394, 2.570164486988975],
            [34.48127661245046, 2.569726967335277],
            [34.481150418916, 2.567580744757914],
            [34.48167475746248, 2.566304743352876],
            [34.48247775700341, 2.565277284286869],
            [34.48482693231975, 2.563968046577503],
            [34.48805926923968, 2.564104242009127],
            [34.489295930484005, 2.563636197360887],
            [34.49096733141004, 2.564660757298324],
            [34.49319353005893, 2.564004908835791],
            [34.49461720257911, 2.564780905073947],
            [34.4977078329579, 2.56275532830191],
            [34.49820148325767, 2.561697123552224],
            [34.49878958332472, 2.562069710633589],
            [34.499162189233225, 2.56331353401293],
            [34.500027854350044, 2.563001460100237],
            [34.50080012791495, 2.562160657592978],
            [34.50079935087222, 2.561667603898245],
            [34.5025316261335, 2.561721349339354],
            [34.50462465762638, 2.56107278550761],
            [34.55014318240484, 2.497110135617544],
            [34.54972739717558, 2.496892469589747],
            [34.574043003370974, 2.462170513326039],
            [34.571429867091545, 2.455792910772477],
            [34.5720866334806, 2.45388163211346],
            [34.57231630485098, 2.451386012765187],
            [34.5723912378204, 2.449163503608395],
            [34.57134113689768, 2.446201517423048],
            [34.57181042758189, 2.444779911540333],
            [34.573495405645126, 2.438559629127631],
            [34.57739681856847, 2.432507047444448],
            [34.580186291443226, 2.430559768044822],
            [34.58051986016274, 2.429448626851087],
            [34.58074955039775, 2.422389505397823],
            [34.579915248162465, 2.420954785966227],
            [34.57969222432517, 2.419090279387361],
            [34.58098683139687, 2.419349131584607],
            [34.581578124974776, 2.419013675605849],
            [34.58383572513274, 2.420573244849813],
            [34.58532831550316, 2.41979827292354],
            [34.59092869146212, 2.43818279051102],
            [34.59138438165294, 2.438384670117435],
            [34.59286685519662, 2.437973653671732],
            [34.5930102990795, 2.438571689756631],
            [34.59365264840657, 2.43859485427741],
            [34.594555451673855, 2.437564863804093],
            [34.59562675014235, 2.4382096419768],
            [34.59645837449979, 2.437347244571736],
            [34.59909948521546, 2.437726936582262],
            [34.6002640719296, 2.436792350013638],
            [34.600764311371975, 2.437342097394327],
            [34.6014776824037, 2.437078035948054],
            [34.60430973182966, 2.437983903146599],
            [34.60652179818252, 2.437670181225291],
            [34.607878401585225, 2.43817104490177],
            [34.607950960307384, 2.439175926412716],
            [34.60895086696529, 2.439796854520422],
            [34.609640253877245, 2.439365319832717],
            [34.61071112474768, 2.439651165873556],
            [34.61278044700526, 2.439337604993778],
            [34.612968171543436, 2.437159938459015],
            [34.613253845685264, 2.437327092048246],
            [34.61418066361502, 2.436512425091358],
            [34.61776279642175, 2.438027518161514],
            [34.61935677335009, 2.438097368956592],
            [34.620070057245265, 2.437761511064643],
            [34.62090349080965, 2.438430487588967],
            [34.622186804261645, 2.43732825251914],
            [34.62240130578179, 2.437662976076146],
            [34.62180760022739, 2.438525100438356],
            [34.62230863557709, 2.43892061506893],
            [34.623900239156455, 2.43782865321168],
            [34.624781140598785, 2.438401851893818],
            [34.62582761142946, 2.438185224536564],
            [34.626302223733404, 2.4372036073508],
            [34.626802544922484, 2.437825125130216],
            [34.62763488523717, 2.437584837721023],
            [34.627921049859154, 2.43815875720116],
            [34.62832543906073, 2.438134335272481],
            [34.62871673801197, 2.437116926537848],
            [34.6311664590631, 2.436635391992922],
            [34.632020942849586, 2.43503118866061],
            [34.63282977694823, 2.435030202303545],
            [34.63304201022231, 2.433474640944018],
            [34.6338513033601, 2.433856504213063],
            [34.63356482342948, 2.433019384058113],
            [34.63382624395694, 2.432803710781258],
            [34.635254196051086, 2.43330445600144],
            [34.6350623868733, 2.432060451165982],
            [34.63748706109771, 2.400796023015866],
            [34.64034236700809, 2.371301853939538],
            [34.64047251762139, 2.370364262669676],
            [34.64122931411227, 2.370352897036446],
            [34.64058820895188, 2.369648036416505],
            [34.6426855056457, 2.347708436070306],
            [34.644312563932715, 2.345660704188187],
            [34.64964105758438, 2.335568939102698],
            [34.6511825396625, 2.331547294467932],
            [34.651693437615705, 2.328730279304482],
            [34.65273946557694, 2.328202641576118],
            [34.65283385785206, 2.327556481680818],
            [34.652106325778156, 2.327838072206662],
            [34.653957257708704, 2.324365772491743],
            [34.65524226628161, 2.32479495206948],
            [34.65590799606058, 2.324530965095826],
            [34.65757088455098, 2.32263873612293],
            [34.65973600225213, 2.323066871445979],
            [34.661114780567665, 2.322323487199473],
            [34.661997482233836, 2.319176945947245],
            [34.66122812909189, 2.317537877801616],
            [34.65991914897563, 2.316941236157563],
            [34.65977554070105, 2.316175727798636],
            [34.66146270346709, 2.314714166555837],
            [34.66243756509488, 2.314378037200139],
            [34.66269857599056, 2.313827392655591],
            [34.66174674177677, 2.313517465334816],
            [34.66060562265113, 2.314069140424671],
            [34.660437634998054, 2.312801184890908],
            [34.662340215565855, 2.312487884226274],
            [34.66341123375999, 2.313013019971298],
            [34.6642449727516, 2.314040916833418],
            [34.66683507353219, 2.311764753797747],
            [34.666630832569176, 2.309819327625174],
            [34.66609470183797, 2.309205409593193],
            [34.666354228716806, 2.307386554041698],
            [34.66587585426842, 2.305114069432403],
            [34.666183879392825, 2.304084854735065],
            [34.6669796834283, 2.303186637115069],
            [34.6684779026423, 2.30289775326162],
            [34.66921378006518, 2.301640684513901],
            [34.66861825362569, 2.300863760427879],
            [34.66880788079565, 2.300289280495845],
            [34.67194591078042, 2.298754244862418],
            [34.67260972714783, 2.296863202265792],
            [34.673656334522406, 2.29686196807464],
            [34.67432422205469, 2.298464309927737],
            [34.675822373895045, 2.298127555598253],
            [34.676701485893346, 2.297289063676078],
            [34.676650844267506, 2.294657130992042],
            [34.678290231033486, 2.293052076823423],
            [34.67800340435315, 2.291856044963388],
            [34.67826451675847, 2.291401132106242],
            [34.67750104758165, 2.289416071633626],
            [34.67534714804175, 2.288353849891072],
            [34.674989025670584, 2.287205691176097],
            [34.675367850615785, 2.285697900738853],
            [34.67688844327027, 2.284212629539578],
            [34.67676745816782, 2.282442159762772],
            [34.67828896440891, 2.281746484366354],
            [34.678526155576556, 2.281171950987896],
            [34.67954876625497, 2.281003257191107],
            [34.68058155125227, 2.279363033963552],
            [34.68591567015425, 2.274344025543353],
            [34.69264868244758, 2.265518984068593],
            [34.69918850575089, 2.254253646905754],
            [34.70201468648312, 2.250565582473557],
            [34.701852929544835, 2.247280139084388],
            [34.70389458548827, 2.244776622125473],
            [34.705622414088914, 2.240657777177946],
            [34.70707915449301, 2.239195228218882],
            [34.708027325377074, 2.2368604924192],
            [34.70908766170415, 2.233078019547968],
            [34.70909773541174, 2.230206958840816],
            [34.710216691302676, 2.226675588210026],
            [34.71060860919315, 2.22349268785219],
            [34.71166265102504, 2.221504652349775],
            [34.71635706074859, 2.219652443459325],
            [34.71793234014261, 2.218309291445671],
            [34.72012507025897, 2.217323701651315],
            [34.724707195063566, 2.216943128931653],
            [34.7381582869553, 2.211758628814274],
            [34.74271457711064, 2.208542968121055],
            [34.74773175151577, 2.202814208847989],
            [34.75233482503281, 2.200240572577836],
            [34.753955968811965, 2.198245398301816],
            [34.75927556285412, 2.193537699950622],
            [34.76147979320277, 2.18851710830549],
            [34.76249243617478, 2.187389350638583],
            [34.76653569667474, 2.184428120300914],
            [34.76831564732477, 2.183935882505748],
            [34.770624212502064, 2.181920147954688],
            [34.77295275531297, 2.180691353173382],
            [34.77409018505775, 2.18074446081267],
            [34.77569982411308, 2.178665793809314],
            [34.775731051348984, 2.177068404521172],
            [34.77656170642422, 2.17683392134642],
            [34.77685846577663, 2.174212517724292],
            [34.77856661767928, 2.173862996059368],
            [34.77989780145439, 2.17303480481282],
            [34.7799521665971, 2.171556731475088],
            [34.780551528842864, 2.170105129010151],
            [34.781546064473694, 2.170300620201833],
            [34.78303179980019, 2.169365868915699],
            [34.78467859676893, 2.166941645052031],
            [34.78456773208647, 2.165319745847424],
            [34.785242241100704, 2.163010120811285],
            [34.78510418890613, 2.162127246197015],
            [34.785827111724295, 2.159603254581931],
            [34.78654981086195, 2.159642466918668],
            [34.78684455169994, 2.157450246906393],
            [34.78758319593388, 2.156619236954798],
            [34.78744458588554, 2.155855583928578],
            [34.78787344699208, 2.155380750023968],
            [34.787567916489216, 2.154830891464623],
            [34.78847270143999, 2.153952987943482],
            [34.78854716369223, 2.153238031877226],
            [34.79101673751116, 2.152248375062606],
            [34.79083622734301, 2.150316172589156],
            [34.79192532862381, 2.1505598072496],
            [34.79191275041322, 2.148199224321087],
            [34.793597043960226, 2.146149529488451],
            [34.793577950268855, 2.145171844104433],
            [34.79417000741473, 2.145270049125753],
            [34.7945779647246, 2.144199019964598],
            [34.79555136389512, 2.143846018247918],
            [34.79724362639702, 2.14182738206555],
            [34.79774044415648, 2.142020491733736],
            [34.798239933505585, 2.141641388344303],
            [34.79845705810639, 2.140831742848595],
            [34.79874124194314, 2.138365274979682],
            [34.7973550803743, 2.135783557549636],
            [34.798119535003, 2.134499670927593],
            [34.797803036968844, 2.131255412257615],
            [34.798519442509594, 2.130114358530731],
            [34.79934983527678, 2.129927575215497],
            [34.799921560852844, 2.129310367825952],
            [34.79926888359495, 2.126994418880459],
            [34.797753084350845, 2.126772593605085],
            [34.7979311277452, 2.122914733628061],
            [34.79857080638093, 2.122965476048122],
            [34.79927695765272, 2.123994123514827],
            [34.800275848316076, 2.123259744348278],
            [34.80164931579162, 2.123504737928531],
            [34.8023622196994, 2.123102805092008],
            [34.8028110557446, 2.123414915122673],
            [34.80392922111809, 2.122514199253061],
            [34.806994915162925, 2.123256060193499],
            [34.80861569781934, 2.126339598619088],
            [34.80825593063289, 2.127243931768553],
            [34.808318495597504, 2.129056332684005],
            [34.809164953835214, 2.130490979947055],
            [34.812024550099366, 2.132221328773583],
            [34.81358660808903, 2.132681794207365],
            [34.81474690624599, 2.135417382966788],
            [34.815647275078845, 2.135469361096296],
            [34.81635132608952, 2.136951000968336],
            [34.817459945066496, 2.138076909183884],
            [34.81866774883059, 2.138273403614908],
            [34.82012492312098, 2.140879244921063],
            [34.821952505142306, 2.140315700368226],
            [34.82256724474912, 2.140628579818223],
            [34.82280965962013, 2.142000720164535],
            [34.82498030735018, 2.144085392622678],
            [34.82478344245397, 2.14563426978688],
            [34.82390116838588, 2.14677455432667],
            [34.82337070871902, 2.148703331233702],
            [34.822703874910594, 2.149391626437681],
            [34.82520102790704, 2.150083003076533],
            [34.82552734452727, 2.15125287369471],
            [34.826259585569865, 2.151780901024924],
            [34.82632018591893, 2.154022441487975],
            [34.82683688968384, 2.155026311912176],
            [34.827688859085804, 2.155292626597345],
            [34.827968687890085, 2.15627152274871],
            [34.829818358585946, 2.15858115444325],
            [34.82981468178149, 2.159367958996004],
            [34.83024038890306, 2.159560718145281],
            [34.83034885418543, 2.161707116832563],
            [34.82910706445914, 2.163704055918984],
            [34.829148212689056, 2.165039467805508],
            [34.83009478008033, 2.165353912211786],
            [34.831001406577464, 2.16407067614387],
            [34.83133175034512, 2.164382248192995],
            [34.83100140837409, 2.164070741674122],
            [34.83009478008033, 2.165353978639671],
            [34.82926381778129, 2.165209215261148],
            [34.8255727094491, 2.173445507303944],
            [34.823708015328414, 2.176492694734087],
            [34.826877041682074, 2.201374487423682],
            [34.83535655046599, 2.244274611275182],
            [34.83535903969764, 2.246266957770843],
            [34.83494746217716, 2.247463151221431],
            [34.834006954820765, 2.248517046117937],
            [34.826388735459936, 2.254935057088819],
            [34.82380071607585, 2.256570033604822],
            [34.82235105709115, 2.258453592699527],
            [34.81600132808177, 2.264646319832517],
            [34.80848550498525, 2.269406201120205],
            [34.802186638587216, 2.274519849816722],
            [34.79666137436247, 2.281119505815773],
            [34.794338253782605, 2.285464947342146],
            [34.79349271362313, 2.289295318634726],
            [34.79339097672225, 2.29163777814944],
            [34.79135480050204, 2.295298590799431],
            [34.791304971851545, 2.297298846545456],
            [34.790730752552236, 2.298404944052],
            [34.79068072088249, 2.300247284885697],
            [34.79133606434015, 2.301246552442661],
            [34.79248837467758, 2.302139915322392],
            [34.79368929554999, 2.300059254725396],
            [34.794265576482864, 2.300611206108423],
            [34.79450332280931, 2.302426871306016],
            [34.7953152192648, 2.30308379578403],
            [34.79427247015436, 2.306111719712787],
            [34.79448554874311, 2.309111733048779],
            [34.797930542941955, 2.31267346593096],
            [34.80067861605852, 2.313380550699943],
            [34.80157021463928, 2.314984820806736],
            [34.80219820619314, 2.315036650788741],
            [34.804533700167724, 2.320507833090767],
            [34.80708681820638, 2.322202062014832],
            [34.80735056447212, 2.323859761134267],
            [34.80960520468121, 2.3274361124937],
            [34.808716648694364, 2.328226799773206],
            [34.80856066792335, 2.329016540566865],
            [34.80852416578013, 2.331161510058475],
            [34.80899713506542, 2.332739985324022],
            [34.80863303081277, 2.334451133995681],
            [34.80923577791054, 2.335213576214692],
            [34.808216940156306, 2.336425521292405],
            [34.80866482488561, 2.338846209380807],
            [34.80793216702474, 2.338794518499308],
            [34.80798537783227, 2.339478724666663],
            [34.808655003604606, 2.34138591315164],
            [34.8081064428848, 2.342070890857563],
            [34.80907585533207, 2.343122359001961],
            [34.8092350466819, 2.344832820042185],
            [34.810856571346726, 2.344330665702678],
            [34.81106760536992, 2.345672612150894],
            [34.81023256651608, 2.347384376922597],
            [34.810469290559766, 2.348357828676733],
            [34.809739486646535, 2.350516867447501],
            [34.80991112864618, 2.351740425355681],
            [34.809100612901304, 2.352188894066002],
            [34.808996881740505, 2.352899620108212],
            [34.81046529934496, 2.355397906639516],
            [34.810962760298146, 2.355660443633642],
            [34.81093741523074, 2.356292109402571],
            [34.81151357578934, 2.356712439181962],
            [34.811070347028156, 2.357923652966407],
            [34.81146420707629, 2.359002169524925],
            [34.812118901051974, 2.359448721415031],
            [34.81138688009661, 2.359897082629465],
            [34.81136132302679, 2.360370842657477],
            [34.810184240747056, 2.36060924889978],
            [34.81010744916331, 2.361925246707792],
            [34.808877426468975, 2.361689996485049],
            [34.808995617810886, 2.362045137225566],
            [34.80821082622249, 2.362151438796324],
            [34.80826391036757, 2.362730370462166],
            [34.80693061465322, 2.363574289496583],
            [34.807141467216695, 2.364758331146907],
            [34.80635697117402, 2.365101497784768],
            [34.80667470169677, 2.367996070355081],
            [34.80607219983908, 2.367444175048937],
            [34.805208736493014, 2.367418991631826],
            [34.806178839744746, 2.368970482424678],
            [34.805737214476345, 2.371418650702997],
            [34.80490046702686, 2.371814519575908],
            [34.804796764612135, 2.372551563269388],
            [34.80399896002852, 2.372723675633922],
            [34.804026806005716, 2.374013234645358],
            [34.802694284639124, 2.375462477090407],
            [34.80261763319256, 2.376883754183648],
            [34.80298479531042, 2.377541231668328],
            [34.801913106973124, 2.378358498154003],
            [34.802934420484256, 2.379041431891813],
            [34.80230745839967, 2.379805482312675],
            [34.80228434295079, 2.382147821415054],
            [34.801174547180786, 2.383846808713117],
            [34.79829726488534, 2.384508547973818],
            [34.79448110657403, 2.387540161355334],
            [34.7826716122022, 2.390700683470007],
            [34.776038621027524, 2.390643548287467],
            [34.768553355922, 2.389126790431187],
            [34.76544060902087, 2.389867745293624],
            [34.762471048186185, 2.390042662980854],
            [34.758809507003264, 2.391337007578936],
            [34.7578428281294, 2.392469961204779],
            [34.75687885857442, 2.395734734448387],
            [34.75491900950895, 2.397763810670912],
            [34.75230403797139, 2.399030487959126],
            [34.750551284714874, 2.399249634647393],
            [34.746365044761035, 2.400977369188526],
            [34.7426241032868, 2.405879562190231],
            [34.742494800683126, 2.407428175186797],
            [34.74166151713737, 2.409061710793726],
            [34.74095005053403, 2.412639644430718],
            [34.73718269859042, 2.415573332862387],
            [34.73522955544856, 2.418720753676744],
            [34.73336937356553, 2.419899483807472],
            [34.730103451332084, 2.423024587815197],
            [34.72772093145068, 2.426388625996336],
            [34.72567415061854, 2.43100061359625],
            [34.722850400727495, 2.434641311010114],
            [34.7223029988344, 2.435866372548156],
            [34.720943606162706, 2.436732380658988],
            [34.71946661503718, 2.438966939610558],
            [34.715090210720845, 2.441673366176027],
            [34.71148675370588, 2.44220614523379],
            [34.71017536340971, 2.443288156557916],
            [34.70795653813269, 2.444035224338886],
            [34.70461797453206, 2.446440217414772],
            [34.7025778331482, 2.446934978437181],
            [34.69863963151902, 2.447036034709695],
            [34.69591748378156, 2.446151230682923],
            [34.69324482243646, 2.446658786520404],
            [34.69215460634639, 2.447350212166428],
            [34.690181231347665, 2.449483555565243],
            [34.689801594325445, 2.451284590643595],
            [34.689965752460466, 2.458450608318491],
            [34.689587301214445, 2.461187943537009],
            [34.68985182182795, 2.462748094779476],
            [34.690880776408896, 2.464787415582332],
            [34.69081028740516, 2.465675779250463],
            [34.68769996505702, 2.469316884975677],
            [34.68546122772337, 2.473256981096064],
            [34.68233761929217, 2.475853788554515],
            [34.68084850630021, 2.477715524622874],
            [34.68379271128769, 2.477592886390644],
            [34.68552586510132, 2.478820044517393],
            [34.68965302285893, 2.480300242447148],
            [34.69113218700913, 2.482039951901411],
            [34.692048393140446, 2.481628981218603],
            [34.692355338489875, 2.48270428692461],
            [34.68443642335905, 2.484212989571246],
            [34.68222938218189, 2.485391804703998],
            [34.681192224185786, 2.487091779188723],
            [34.680935710256406, 2.489705407627616],
            [34.682111583403746, 2.494930493240168],
            [34.68172316894288, 2.495976313614898],
            [34.67574989332634, 2.49820530028243],
            [34.671855735197255, 2.500823606637316],
            [34.66861362460701, 2.505401063248237],
            [34.66757809974809, 2.508407704501279],
            [34.66537447755892, 2.512330510047688],
            [34.66550738150856, 2.514682327126515],
            [34.66934893609124, 2.518363802719807],
            [34.66740888679298, 2.518805452803345],
            [34.66651674922306, 2.518806602433439],
            [34.6659809338005, 2.51838856419858],
            [34.664792101556834, 2.518928457832608],
            [34.66325981373568, 2.52210320876131],
            [34.66008517919971, 2.521285559731691],
            [34.659503499391974, 2.521442365916607],
            [34.65725233206975, 2.5204698746981],
            [34.654185549266806, 2.518718116811417],
            [34.653719258057336, 2.518094469668085],
            [34.65317622017989, 2.518134178145811],
            [34.65232161691749, 2.51719890344084],
            [34.651313076551354, 2.517239205159299],
            [34.65080750291285, 2.516225452373111],
            [34.64910161206976, 2.515550214146679],
            [34.646661202954824, 2.520919645952884],
            [34.64612943623925, 2.523638328988314],
            [34.64621714684529, 2.525274861148139],
            [34.64709025809747, 2.527714596907089],
            [34.648612861181554, 2.530250275132473],
            [34.64184255083761, 2.538925046806406],
            [34.63815713063781, 2.540664504115091],
            [34.63399542008111, 2.542045648918276],
            [34.62810875373609, 2.543369159266263],
            [34.624660820249645, 2.544809198567527],
            [34.61972538714546, 2.545832379819661],
            [34.61399050733737, 2.550520953193961],
            [34.61231887644257, 2.549838420621637],
            [34.61098702971077, 2.550222944213617],
            [34.60884521610472, 2.549771006886425],
            [34.60644399240082, 2.551161848477281],
            [34.60503969294808, 2.550685058184667],
            [34.60487391694722, 2.551307390153546],
            [34.6042547746972, 2.550853541691809],
            [34.603660186997175, 2.551021781974689],
            [34.603613197921305, 2.551500402888823],
            [34.60228068463955, 2.551358502984226],
            [34.601686304450354, 2.551694234943719],
            [34.600686644829125, 2.551360499754412],
            [34.600425647408166, 2.551935101880525],
            [34.59990207332798, 2.55181611865574],
            [34.59820190654989, 2.5525719751022],
            [34.59703536061012, 2.551975229314543],
            [34.595180699772854, 2.552862894787876],
            [34.59337181169255, 2.552290871376095],
            [34.591920548316764, 2.552316610397932],
            [34.591802166532, 2.552795324162079],
            [34.5909698684381, 2.553131350998658],
            [34.5892800628285, 2.552654896175624],
            [34.58832921226997, 2.553326066769695],
            [34.58778184720776, 2.553207107006653],
            [34.587854782323994, 2.55447520798258],
            [34.58553619643971, 2.555399332189269],
            [34.585632449125775, 2.556284546233344],
            [34.582206841469095, 2.556647729017303],
            [34.58254099139859, 2.557508734282334],
            [34.579759463224185, 2.559258944479574],
            [34.579210979759495, 2.558230708875688],
            [34.577306822648346, 2.557587005501577],
            [34.57585404650965, 2.556392383969293],
            [34.570266746427976, 2.558012281316153],
            [34.55252280252448, 2.589881693670825],
            [34.55302112226709, 2.58993779807723],
            [34.554087068573146, 2.59154639943662],
            [34.5540897644173, 2.593753229301341],
            [34.55642276377031, 2.594991685800722],
            [34.55656126152925, 2.596094929049798],
            [34.557931029742484, 2.594713962939463],
            [34.56273621791021, 2.598845791906812],
            [34.56337721257782, 2.600257250413317],
            [34.564689777870385, 2.601636710923218],
            [34.56643883366118, 2.602638958941775],
            [34.569563429340896, 2.605460011881402],
            [34.57112382365064, 2.605332500411927],
            [34.57605765505866, 2.607335153720296],
            [34.577493514123965, 2.607458896866325],
            [34.57799241956815, 2.607081607347495],
            [34.57949218927434, 2.608398024505267],
            [34.580366172790676, 2.608459696359485],
            [34.58024203549988, 2.609024843866797],
            [34.58182189091194, 2.60964863514336],
            [34.58486631554583, 2.60878336226882],
            [34.592009622565385, 2.613081346387715],
            [34.60582373623986, 2.614918430641087],
            [34.602851594545314, 2.621101239000198],
            [34.59527929257022, 2.633261932901016],
            [34.57961667241652, 2.651076044074262],
            [34.573461931722704, 2.663853268428996],
            [34.56848278929176, 2.676815683254386],
            [34.56526541920277, 2.688687114085573],
            [34.56142656046424, 2.698350762222486],
            [34.559389011618265, 2.70152631260709],
            [34.55066496254941, 2.725178977656332],
            [34.54968016555459, 2.729161959090609],
            [34.548776635550254, 2.736208900460645],
            [34.54829550686723, 2.746953046633364],
            [34.55696895742937, 2.746947687161614],
            [34.55575069368207, 2.759740066573327],
            [34.55943598811774, 2.765394230622753],
            [34.56039319605358, 2.76948473099973],
            [34.560412455933246, 2.775095919074756],
            [34.55855859100334, 2.785878142955371],
            [34.55855836013629, 2.794719703300665],
            [34.55707617046022, 2.816556395813791],
            [34.5574883076311, 2.822250813323769],
            [34.55832284791995, 2.823470037448162],
            [34.56106151028559, 2.824925968550405],
            [34.56302747597985, 2.826921333001918],
            [34.56379130627941, 2.828643144900071],
            [34.56441425019971, 2.831776912095016],
            [34.56802921104018, 2.838914597565788],
            [34.57079377363213, 2.850671573922723],
            [34.57250282474835, 2.85618469864824],
            [34.574911024768774, 2.868253166938785],
            [34.57293194726464, 2.874154215556337],
            [34.56865643363619, 2.880142218908305],
            [34.56779235674081, 2.88348140611676],
            [34.566793042970964, 2.892324301892315],
            [34.565247080096256, 2.893020370858127],
            [34.564206234515865, 2.897616058560285],
            [34.56262793139262, 2.900764826875915],
            [34.560109435323305, 2.903831148917853],
            [34.55975373391185, 2.904764866109632],
            [34.55965982223538, 2.905698192264552],
            [34.5604605652083, 2.908221526463232],
            [34.55927643115359, 2.912458494962111],
            [34.557612908452604, 2.91423150951221],
            [34.55710476653066, 2.91680451782177],
            [34.55286279779152, 2.921344865867516],
            [34.552703875037984, 2.926920411605834],
            [34.55206373107495, 2.928692008268641],
            [34.550281348685445, 2.930584847082141],
            [34.54818844475333, 2.93166454076827],
            [34.54334331569143, 2.930319308721548],
            [34.539607517970495, 2.930898769050152],
            [34.537610192089694, 2.932265469836894],
            [34.53449624953095, 2.935093336709392],
            [34.528333083538065, 2.944613505210729],
            [34.525242586109904, 2.947226006977425],
            [34.52462564293571, 2.948590785857109],
            [34.525283435200855, 2.950994714006488],
            [34.52716641452912, 2.953002134029713],
            [34.5303115618659, 2.955534227820816],
            [34.53623055139152, 2.958840121402528],
            [34.5437079975608, 2.961772884151855],
            [34.55619998696976, 2.967940797793717],
            [34.56707140302975, 2.972531551260226],
            [34.57813240853046, 2.976523668451651],
            [34.589525040593024, 2.979390531656859],
            [34.58812758809937, 3.001097718275252],
            [34.58512423803356, 3.00788184460309],
            [34.57731854745946, 3.017774393968959],
            [34.57647891192631, 3.032489186109403],
            [34.57348720851817, 3.047351412832146],
            [34.57559530835162, 3.066173017683709],
            [34.57304547455362, 3.088679916757299],
            [34.56335798054593, 3.104782730190491],
            [34.55968948191115, 3.107657862605006],
            [34.55394451222576, 3.10393310803484],
            [34.55022328517872, 3.098847777058346],
            [34.54548877286427, 3.093424496993693],
            [34.539409725114616, 3.092075830984704],
            [34.52724919967247, 3.087681398471282],
            [34.52049493773107, 3.086333552210221],
            [34.513412175364984, 3.09143463729837],
            [34.50069206058626, 3.092595158710209],
            [34.49675579662316, 3.091173738002959],
            [34.49213852523306, 3.094806854595083],
            [34.48790741712573, 3.096779939376753],
            [34.44227455208294, 3.079757956196667],
            [34.39920259167575, 3.092859794586322],
            [34.39818887162368, 3.093093619117062],
            [34.39763030906149, 3.09192590335274],
            [34.37439815554042, 3.043860534973483],
            [34.37223449131337, 3.040408697117801],
            [34.36871239201876, 3.032318227593303],
            [34.365775069922975, 3.0264527455348],
            [34.363106356673526, 3.022543826875334],
            [34.358439712977116, 3.01148400570609],
            [34.34849669678011, 2.991037415082416],
            [34.305147416563194, 2.937958538755243],
            [34.29867389521609, 2.930380320566632],
            [34.28445029350252, 2.915530884055435],
            [34.28132548582042, 2.909928066556821],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 818,
        District: "MOROTO",
        County: "MATHENIKO",
        Subcounty: "NADUNGET",
        Population: 38836,
        Key: "MOROTONADUNGET",
        Dist2: "Moroto",
        "Sub Country": "Nadunget",
        id2_original: "MorotoNadunget",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.785049910001746, 2.686830036506421],
            [34.77615599130929, 2.695158264802947],
            [34.78453728548655, 2.739970751685449],
            [34.78487905851952, 2.745808111101852],
            [34.78424738387299, 2.752454557259908],
            [34.780943458411436, 2.762987320708601],
            [34.77890749868519, 2.767612352384488],
            [34.77612466795364, 2.785077319612388],
            [34.773069558757804, 2.791244582114132],
            [34.76797497472801, 2.799725946071391],
            [34.76773273143523, 2.808456734193268],
            [34.762895402444926, 2.8182216411295],
            [34.75575618455652, 2.825679075401909],
            [34.752687843176545, 2.82311594674219],
            [34.75077499217009, 2.822724190409014],
            [34.74986382109594, 2.823428633216039],
            [34.74353305911547, 2.838511700495417],
            [34.73709315721784, 2.852267102382627],
            [34.732564136321265, 2.855013536179996],
            [34.72195596436877, 2.85830749638119],
            [34.71245561548589, 2.862544838436202],
            [34.70910056151164, 2.870720826799504],
            [34.70249136042064, 2.874965760618032],
            [34.69312927124312, 2.860157113699897],
            [34.685718303099804, 2.861328541872042],
            [34.66921381959105, 2.86040770776288],
            [34.65364048119681, 2.864846399899691],
            [34.640036427771776, 2.90401567624918],
            [34.63221178184683, 2.908311113102128],
            [34.59978448655222, 2.921962756555401],
            [34.589525040593024, 2.979390531656859],
            [34.57813240853046, 2.976523668451651],
            [34.56707140302975, 2.972531551260226],
            [34.55619998696976, 2.967940797793717],
            [34.5437079975608, 2.961772884151855],
            [34.53623055139152, 2.958840121402528],
            [34.5303115618659, 2.955534227820816],
            [34.52716641452912, 2.953002134029713],
            [34.525283435200855, 2.950994714006488],
            [34.52462564293571, 2.948590785857109],
            [34.525242586109904, 2.947226006977425],
            [34.528333083538065, 2.944613505210729],
            [34.53449624953095, 2.935093336709392],
            [34.537610192089694, 2.932265469836894],
            [34.539607517970495, 2.930898769050152],
            [34.54334331569143, 2.930319308721548],
            [34.54818844475333, 2.93166454076827],
            [34.550281348685445, 2.930584847082141],
            [34.55206373107495, 2.928692008268641],
            [34.552703875037984, 2.926920411605834],
            [34.55286279779152, 2.921344865867516],
            [34.55710476653066, 2.91680451782177],
            [34.557612908452604, 2.91423150951221],
            [34.55927643115359, 2.912458494962111],
            [34.5604605652083, 2.908221526463232],
            [34.55965982223538, 2.905698192264552],
            [34.55975373391185, 2.904764866109632],
            [34.560109435323305, 2.903831148917853],
            [34.56262793139262, 2.900764826875915],
            [34.564206234515865, 2.897616058560285],
            [34.565247080096256, 2.893020370858127],
            [34.566793042970964, 2.892324301892315],
            [34.56779235674081, 2.88348140611676],
            [34.56865643363619, 2.880142218908305],
            [34.57293194726464, 2.874154215556337],
            [34.574911024768774, 2.868253166938785],
            [34.57250282474835, 2.85618469864824],
            [34.57079377363213, 2.850671573922723],
            [34.56802921104018, 2.838914597565788],
            [34.56441425019971, 2.831776912095016],
            [34.56379130627941, 2.828643144900071],
            [34.56302747597985, 2.826921333001918],
            [34.56106151028559, 2.824925968550405],
            [34.55832284791995, 2.823470037448162],
            [34.5574883076311, 2.822250813323769],
            [34.55707617046022, 2.816556395813791],
            [34.55855836013629, 2.794719703300665],
            [34.55855859100334, 2.785878142955371],
            [34.560412455933246, 2.775095919074756],
            [34.56039319605358, 2.76948473099973],
            [34.55943598811774, 2.765394230622753],
            [34.55575069368207, 2.759740066573327],
            [34.55696895742937, 2.746947687161614],
            [34.54829550686723, 2.746953046633364],
            [34.548776635550254, 2.736208900460645],
            [34.54968016555459, 2.729161959090609],
            [34.55066496254941, 2.725178977656332],
            [34.559389011618265, 2.70152631260709],
            [34.56142656046424, 2.698350762222486],
            [34.56526541920277, 2.688687114085573],
            [34.56848278929176, 2.676815683254386],
            [34.573461931722704, 2.663853268428996],
            [34.57961667241652, 2.651076044074262],
            [34.59527929257022, 2.633261932901016],
            [34.602851594545314, 2.621101239000198],
            [34.60582373623986, 2.614918430641087],
            [34.592009622565385, 2.613081346387715],
            [34.58486631554583, 2.60878336226882],
            [34.58182189091194, 2.60964863514336],
            [34.58024203549988, 2.609024843866797],
            [34.580366172790676, 2.608459696359485],
            [34.57949218927434, 2.608398024505267],
            [34.57799241956815, 2.607081607347495],
            [34.577493514123965, 2.607458896866325],
            [34.57605765505866, 2.607335153720296],
            [34.57112382365064, 2.605332500411927],
            [34.569563429340896, 2.605460011881402],
            [34.56643883366118, 2.602638958941775],
            [34.564689777870385, 2.601636710923218],
            [34.56337721257782, 2.600257250413317],
            [34.56273621791021, 2.598845791906812],
            [34.557931029742484, 2.594713962939463],
            [34.55656126152925, 2.596094929049798],
            [34.55642276377031, 2.594991685800722],
            [34.5540897644173, 2.593753229301341],
            [34.554087068573146, 2.59154639943662],
            [34.55302112226709, 2.58993779807723],
            [34.55252280252448, 2.589881693670825],
            [34.570266746427976, 2.558012281316153],
            [34.57585404650965, 2.556392383969293],
            [34.577306822648346, 2.557587005501577],
            [34.579210979759495, 2.558230708875688],
            [34.579759463224185, 2.559258944479574],
            [34.58254099139859, 2.557508734282334],
            [34.582206841469095, 2.556647729017303],
            [34.585632449125775, 2.556284546233344],
            [34.58553619643971, 2.555399332189269],
            [34.587854782323994, 2.55447520798258],
            [34.58778184720776, 2.553207107006653],
            [34.58832921226997, 2.553326066769695],
            [34.5892800628285, 2.552654896175624],
            [34.5909698684381, 2.553131350998658],
            [34.591802166532, 2.552795324162079],
            [34.591920548316764, 2.552316610397932],
            [34.59337181169255, 2.552290871376095],
            [34.595180699772854, 2.552862894787876],
            [34.59703536061012, 2.551975229314543],
            [34.59820190654989, 2.5525719751022],
            [34.59990207332798, 2.55181611865574],
            [34.600425647408166, 2.551935101880525],
            [34.600686644829125, 2.551360499754412],
            [34.601686304450354, 2.551694234943719],
            [34.60228068463955, 2.551358502984226],
            [34.603613197921305, 2.551500402888823],
            [34.603660186997175, 2.551021781974689],
            [34.6042547746972, 2.550853541691809],
            [34.60487391694722, 2.551307390153546],
            [34.60503969294808, 2.550685058184667],
            [34.60644399240082, 2.551161848477281],
            [34.60884521610472, 2.549771006886425],
            [34.61098702971077, 2.550222944213617],
            [34.61231887644257, 2.549838420621637],
            [34.61399050733737, 2.550520953193961],
            [34.61972538714546, 2.545832379819661],
            [34.624660820249645, 2.544809198567527],
            [34.62810875373609, 2.543369159266263],
            [34.63399542008111, 2.542045648918276],
            [34.63815713063781, 2.540664504115091],
            [34.64184255083761, 2.538925046806406],
            [34.648612861181554, 2.530250275132473],
            [34.65467242267607, 2.537499330277689],
            [34.65769429869798, 2.542502229570756],
            [34.65792502019894, 2.543527398666589],
            [34.658259468369096, 2.545910884183796],
            [34.66097807135445, 2.548150929536456],
            [34.6621451697581, 2.550653095485753],
            [34.664087609473384, 2.552699035071869],
            [34.66347702547308, 2.555561184925497],
            [34.663575654203065, 2.556829158834967],
            [34.66564814661527, 2.559427679036427],
            [34.66822913937722, 2.567699445628753],
            [34.67172726173857, 2.572637167726127],
            [34.671829560984825, 2.57670143461513],
            [34.67295077074882, 2.581138285298562],
            [34.674408891863486, 2.583607506773995],
            [34.6754120836604, 2.584321509340667],
            [34.67622347526268, 2.586694033371543],
            [34.67930146454882, 2.591664750778154],
            [34.6815180835635, 2.593141228219483],
            [34.68488134993611, 2.593787021605863],
            [34.690202774744826, 2.596039663081799],
            [34.69654116521868, 2.597201658603011],
            [34.70194501584462, 2.60064090536882],
            [34.704967962658344, 2.600653049748665],
            [34.70632637257312, 2.601041379087214],
            [34.70752383852492, 2.601950155529242],
            [34.71169646630728, 2.603407616958444],
            [34.71570999975784, 2.606751123560992],
            [34.719447218613546, 2.608973229921753],
            [34.728854332251416, 2.612824680081637],
            [34.728267302976164, 2.614108441829824],
            [34.7246395294648, 2.616184310868348],
            [34.72361159267507, 2.61738464442369],
            [34.720251761460126, 2.617280295496172],
            [34.71694507637399, 2.616412919041239],
            [34.71890039793045, 2.619734486966239],
            [34.720744149626896, 2.62071286830034],
            [34.72318308191149, 2.621036469129749],
            [34.72513289679525, 2.620325320373819],
            [34.72686782388326, 2.620976864549653],
            [34.72789635535771, 2.620212493281894],
            [34.728656265409356, 2.621137868071284],
            [34.7299031970923, 2.621572100790616],
            [34.734208425193735, 2.621619164525518],
            [34.73435427296832, 2.622657352593206],
            [34.73513187713613, 2.623859286241677],
            [34.73555572564337, 2.62642731255818],
            [34.734945074269454, 2.629061809850009],
            [34.734581844077546, 2.635256266031052],
            [34.73277531946478, 2.638152558476666],
            [34.73219606241338, 2.640104224983319],
            [34.73239334053462, 2.64247747902695],
            [34.73300993516248, 2.644134840058353],
            [34.73235331430052, 2.648573945324125],
            [34.73694218724951, 2.658565564531008],
            [34.73649477503408, 2.662305320272902],
            [34.73737011231154, 2.663994813757046],
            [34.73989216481103, 2.664121288170327],
            [34.74073082477378, 2.662721990109594],
            [34.74192755051379, 2.663045435518765],
            [34.74422617583251, 2.665220597340184],
            [34.74493718788829, 2.665024493656917],
            [34.746360377114826, 2.665445144983564],
            [34.74765480003191, 2.666256148425973],
            [34.748915404971804, 2.666026745407722],
            [34.75175947924615, 2.668218536874265],
            [34.75175996433641, 2.66856068322269],
            [34.752728556621825, 2.668743520950353],
            [34.753593441102666, 2.669610798919532],
            [34.75639313590703, 2.669159363951013],
            [34.75793513721137, 2.667683297752339],
            [34.7600028883155, 2.667838231874695],
            [34.76128212341605, 2.665625620469557],
            [34.76282760030223, 2.666597185307636],
            [34.7661000344232, 2.66732938431383],
            [34.76697396224399, 2.665367395559632],
            [34.76770615028598, 2.664945234874195],
            [34.76896484001766, 2.666680440747485],
            [34.76873458294575, 2.670365363223087],
            [34.769991283807386, 2.670705685579791],
            [34.7704390930782, 2.67273155987474],
            [34.77182480009951, 2.671782087880174],
            [34.77263720410311, 2.672544142726476],
            [34.77290114620159, 2.674096545832748],
            [34.77201208536154, 2.674624205048567],
            [34.772091765927215, 2.675439966388363],
            [34.77463078760245, 2.675725773286439],
            [34.77565331743248, 2.67701388302401],
            [34.77677772699554, 2.676354286026253],
            [34.77753737114588, 2.676826910711014],
            [34.77905536766918, 2.676877327481641],
            [34.7793072067658, 2.679100866073719],
            [34.77993733092017, 2.680494816212082],
            [34.7826350193291, 2.681912053203611],
            [34.783395278825395, 2.682805759014582],
            [34.7835272036114, 2.683542479860292],
            [34.782926793031685, 2.684596098457123],
            [34.78324332699846, 2.686306318234386],
            [34.783845915992735, 2.686752848371378],
            [34.785049910001746, 2.686830036506421],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 819,
        District: "MOROTO",
        County: "MATHENIKO",
        Subcounty: "RUPA",
        Population: 25112,
        Key: "MOROTORUPA",
        Dist2: "Moroto",
        "Sub Country": "Rupa",
        id2_original: "MorotoRupa",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.93486367829294, 2.282673916247993],
            [34.91853573439877, 2.387403040367328],
            [34.9204728057819, 2.390792887970894],
            [34.91654067766237, 2.392848109438132],
            [34.91573500922676, 2.394580869256992],
            [34.91572273464672, 2.398379868899231],
            [34.915092880885275, 2.400218411452751],
            [34.915622507813865, 2.40209065094011],
            [34.917066757143914, 2.404774400737272],
            [34.91706917900193, 2.406506022639974],
            [34.91784311445009, 2.40721171340381],
            [34.917458467523566, 2.408519816016531],
            [34.91788359882502, 2.411028299812977],
            [34.91755420816991, 2.414156299892334],
            [34.91818965843558, 2.41631109885817],
            [34.91738265240853, 2.417089708614076],
            [34.91773846970265, 2.42026974336327],
            [34.91738951284233, 2.421966531904201],
            [34.91907517542185, 2.421398693373673],
            [34.920270196159485, 2.421715048788446],
            [34.92192296153497, 2.422737524815836],
            [34.922978693097896, 2.423937552990775],
            [34.92680903940079, 2.424426810661676],
            [34.92716088344645, 2.424779697655388],
            [34.926319309348926, 2.425947104012271],
            [34.92923646606322, 2.426649699930024],
            [34.930605900103146, 2.426082300451705],
            [34.93148602090949, 2.427317907415353],
            [34.93310345554486, 2.428199050317946],
            [34.9332631939687, 2.429347340393241],
            [34.9324915501228, 2.430267265058533],
            [34.93207481537427, 2.433695752096555],
            [34.93221903719817, 2.4362752930695],
            [34.933904943221144, 2.435884126066438],
            [34.934854374441564, 2.43644817463398],
            [34.936152380738314, 2.435068080567845],
            [34.93653921596091, 2.435314894177395],
            [34.93826424271614, 2.437715446757188],
            [34.93735540726175, 2.440967941090554],
            [34.93855160658901, 2.442097045207766],
            [34.93945076449287, 2.444339763370692],
            [34.9411386432162, 2.445326789047595],
            [34.94061447804452, 2.447306525654558],
            [34.94310730026304, 2.446101380124327],
            [34.944442927105555, 2.446452819163378],
            [34.94398867691415, 2.448185079658714],
            [34.942830917396186, 2.449352949468823],
            [34.942867218316835, 2.450165687998059],
            [34.94554072228166, 2.452423462459819],
            [34.945927309569235, 2.452493570085749],
            [34.94687410603094, 2.451219991768313],
            [34.949582956007234, 2.453619046706506],
            [34.95105799239872, 2.453192821541893],
            [34.95214855344184, 2.454145362667809],
            [34.954644541323376, 2.455131165018135],
            [34.95329672793573, 2.458472643455112],
            [34.95351818241619, 2.459753346295784],
            [34.95501611686425, 2.46297578056762],
            [34.95568031591399, 2.46668533932183],
            [34.95418947097013, 2.46832194957373],
            [34.955157684166494, 2.469689883470905],
            [34.94928872541236, 2.469483219632758],
            [34.93752810568017, 2.497179974333992],
            [34.93544031316205, 2.508769615553753],
            [34.933805588652405, 2.51322186787904],
            [34.91374225756738, 2.513861690313437],
            [34.90590166474956, 2.544532012221104],
            [34.90404866579555, 2.554259804098606],
            [34.88538971052008, 2.552083386895373],
            [34.86980023479005, 2.551456438051825],
            [34.86624389081848, 2.549755745261282],
            [34.859053712402336, 2.548628953832375],
            [34.855581636692634, 2.549365095698466],
            [34.8501729127063, 2.551403774475027],
            [34.84629602468851, 2.551490615574942],
            [34.84435717104788, 2.551249713555304],
            [34.84128520586404, 2.549385758936428],
            [34.83934635132508, 2.549144847548324],
            [34.836113311024256, 2.547606040440006],
            [34.83417503050877, 2.547771289124823],
            [34.830458856485194, 2.547289202753],
            [34.82949040164205, 2.547859229818291],
            [34.826998929591404, 2.547646876079269],
            [34.824804303131494, 2.546914618196137],
            [34.82005100345119, 2.546553689694609],
            [34.81877037236867, 2.545820118251899],
            [34.81254793463503, 2.544037387541693],
            [34.81098075624824, 2.545354616535154],
            [34.80797522597124, 2.546608116916077],
            [34.804771718683696, 2.546546892573738],
            [34.78861945381809, 2.543413496812963],
            [34.786133702239205, 2.542364936983437],
            [34.784265882879644, 2.540916838706187],
            [34.78345895051443, 2.535079178841227],
            [34.782351298124695, 2.531899748990196],
            [34.77623919147427, 2.526655881468546],
            [34.767996287258114, 2.523042338954],
            [34.76269803539047, 2.521274134350841],
            [34.76140532645897, 2.521175897251101],
            [34.76047936552198, 2.520446252118179],
            [34.75560713159299, 2.519666389044958],
            [34.752172876753384, 2.515125606431514],
            [34.74712584953474, 2.511556258377452],
            [34.74516033569308, 2.509374426904163],
            [34.744609062061095, 2.508059225554217],
            [34.744263411899325, 2.503938731408526],
            [34.739475599844134, 2.501107488374027],
            [34.735783091936725, 2.497164554138149],
            [34.73018654190261, 2.492506319361226],
            [34.72899661910421, 2.492148996154444],
            [34.71661324769119, 2.482116110520299],
            [34.710895403534124, 2.475543721978474],
            [34.708988294558985, 2.472435720723129],
            [34.70744002031905, 2.470882486954197],
            [34.69313743243748, 2.447811409210285],
            [34.69215460634639, 2.447350212166428],
            [34.69324482243646, 2.446658786520404],
            [34.69591748378156, 2.446151230682923],
            [34.69863963151902, 2.447036034709695],
            [34.7025778331482, 2.446934978437181],
            [34.70461797453206, 2.446440217414772],
            [34.70795653813269, 2.444035224338886],
            [34.71017536340971, 2.443288156557916],
            [34.71148675370588, 2.44220614523379],
            [34.715090210720845, 2.441673366176027],
            [34.71946661503718, 2.438966939610558],
            [34.720943606162706, 2.436732380658988],
            [34.7223029988344, 2.435866372548156],
            [34.722850400727495, 2.434641311010114],
            [34.72567415061854, 2.43100061359625],
            [34.72772093145068, 2.426388625996336],
            [34.730103451332084, 2.423024587815197],
            [34.73336937356553, 2.419899483807472],
            [34.73522955544856, 2.418720753676744],
            [34.73718269859042, 2.415573332862387],
            [34.74095005053403, 2.412639644430718],
            [34.74166151713737, 2.409061710793726],
            [34.742494800683126, 2.407428175186797],
            [34.7426241032868, 2.405879562190231],
            [34.746365044761035, 2.400977369188526],
            [34.750551284714874, 2.399249634647393],
            [34.75230403797139, 2.399030487959126],
            [34.75491900950895, 2.397763810670912],
            [34.75687885857442, 2.395734734448387],
            [34.7578428281294, 2.392469961204779],
            [34.758809507003264, 2.391337007578936],
            [34.762471048186185, 2.390042662980854],
            [34.76544060902087, 2.389867745293624],
            [34.768553355922, 2.389126790431187],
            [34.776038621027524, 2.390643548287467],
            [34.7826716122022, 2.390700683470007],
            [34.79448110657403, 2.387540161355334],
            [34.79829726488534, 2.384508547973818],
            [34.801174547180786, 2.383846808713117],
            [34.80228434295079, 2.382147821415054],
            [34.80230745839967, 2.379805482312675],
            [34.802934420484256, 2.379041431891813],
            [34.801913106973124, 2.378358498154003],
            [34.80298479531042, 2.377541231668328],
            [34.80261763319256, 2.376883754183648],
            [34.802694284639124, 2.375462477090407],
            [34.804026806005716, 2.374013234645358],
            [34.80399896002852, 2.372723675633922],
            [34.804796764612135, 2.372551563269388],
            [34.80490046702686, 2.371814519575908],
            [34.805737214476345, 2.371418650702997],
            [34.806178839744746, 2.368970482424678],
            [34.805208736493014, 2.367418991631826],
            [34.80607219983908, 2.367444175048937],
            [34.80667470169677, 2.367996070355081],
            [34.80635697117402, 2.365101497784768],
            [34.807141467216695, 2.364758331146907],
            [34.80693061465322, 2.363574289496583],
            [34.80826391036757, 2.362730370462166],
            [34.80821082622249, 2.362151438796324],
            [34.808995617810886, 2.362045137225566],
            [34.808877426468975, 2.361689996485049],
            [34.81010744916331, 2.361925246707792],
            [34.810184240747056, 2.36060924889978],
            [34.81136132302679, 2.360370842657477],
            [34.81138688009661, 2.359897082629465],
            [34.812118901051974, 2.359448721415031],
            [34.81146420707629, 2.359002169524925],
            [34.811070347028156, 2.357923652966407],
            [34.81151357578934, 2.356712439181962],
            [34.81093741523074, 2.356292109402571],
            [34.810962760298146, 2.355660443633642],
            [34.81046529934496, 2.355397906639516],
            [34.808996881740505, 2.352899620108212],
            [34.809100612901304, 2.352188894066002],
            [34.80991112864618, 2.351740425355681],
            [34.809739486646535, 2.350516867447501],
            [34.810469290559766, 2.348357828676733],
            [34.81023256651608, 2.347384376922597],
            [34.81106760536992, 2.345672612150894],
            [34.810856571346726, 2.344330665702678],
            [34.8092350466819, 2.344832820042185],
            [34.80907585533207, 2.343122359001961],
            [34.8081064428848, 2.342070890857563],
            [34.808655003604606, 2.34138591315164],
            [34.80798537783227, 2.339478724666663],
            [34.80793216702474, 2.338794518499308],
            [34.80866482488561, 2.338846209380807],
            [34.808216940156306, 2.336425521292405],
            [34.80923577791054, 2.335213576214692],
            [34.80863303081277, 2.334451133995681],
            [34.80899713506542, 2.332739985324022],
            [34.80852416578013, 2.331161510058475],
            [34.80856066792335, 2.329016540566865],
            [34.808716648694364, 2.328226799773206],
            [34.80960520468121, 2.3274361124937],
            [34.80735056447212, 2.323859761134267],
            [34.80708681820638, 2.322202062014832],
            [34.804533700167724, 2.320507833090767],
            [34.80219820619314, 2.315036650788741],
            [34.80157021463928, 2.314984820806736],
            [34.80067861605852, 2.313380550699943],
            [34.797930542941955, 2.31267346593096],
            [34.79448554874311, 2.309111733048779],
            [34.79427247015436, 2.306111719712787],
            [34.7953152192648, 2.30308379578403],
            [34.79450332280931, 2.302426871306016],
            [34.794265576482864, 2.300611206108423],
            [34.79368929554999, 2.300059254725396],
            [34.79248837467758, 2.302139915322392],
            [34.79133606434015, 2.301246552442661],
            [34.79068072088249, 2.300247284885697],
            [34.790730752552236, 2.298404944052],
            [34.791304971851545, 2.297298846545456],
            [34.79135480050204, 2.295298590799431],
            [34.79339097672225, 2.29163777814944],
            [34.79349271362313, 2.289295318634726],
            [34.794338253782605, 2.285464947342146],
            [34.79666137436247, 2.281119505815773],
            [34.802186638587216, 2.274519849816722],
            [34.80848550498525, 2.269406201120205],
            [34.81600132808177, 2.264646319832517],
            [34.82235105709115, 2.258453592699527],
            [34.82380071607585, 2.256570033604822],
            [34.826388735459936, 2.254935057088819],
            [34.834006954820765, 2.248517046117937],
            [34.83494746217716, 2.247463151221431],
            [34.83535903969764, 2.246266957770843],
            [34.83535655046599, 2.244274611275182],
            [34.826877041682074, 2.201374487423682],
            [34.823708015328414, 2.176492694734087],
            [34.8255727094491, 2.173445507303944],
            [34.82926381778129, 2.165209215261148],
            [34.83009478008033, 2.165353978639671],
            [34.83100140837409, 2.164070741674122],
            [34.83133175034512, 2.164382248192995],
            [34.83118253119327, 2.165883610600376],
            [34.82972056259424, 2.166818490609153],
            [34.82947643014442, 2.168343292410158],
            [34.82997412825284, 2.168345649697011],
            [34.829996160333515, 2.168703406084282],
            [34.82866259063299, 2.170056148487763],
            [34.82853963013521, 2.171009291717779],
            [34.82971985292516, 2.172040133959783],
            [34.8298800638628, 2.173256895357886],
            [34.8302826429591, 2.173330322897121],
            [34.830323915156505, 2.17464188870321],
            [34.83131542705807, 2.17548108986139],
            [34.83039822918669, 2.176490085215468],
            [34.83181623782896, 2.177355141737192],
            [34.83288575673491, 2.176716429296221],
            [34.83302339929767, 2.177694650020579],
            [34.832309713855594, 2.178263508360295],
            [34.832543159946766, 2.179027594427781],
            [34.836101538602456, 2.178329111597776],
            [34.83765374656505, 2.18091148209079],
            [34.83860198122951, 2.180868276595819],
            [34.839073981232595, 2.181299673501824],
            [34.839361284918354, 2.183220394827571],
            [34.84061128704294, 2.184537657562229],
            [34.840391097390395, 2.186014886027443],
            [34.842574193973626, 2.18545294889989],
            [34.84377524420344, 2.187103766137353],
            [34.845442731169825, 2.187838835325327],
            [34.84584098038641, 2.188842113270404],
            [34.844931046292395, 2.190840636691544],
            [34.84501862843935, 2.192390835828425],
            [34.84546783279379, 2.19263137845601],
            [34.84646557810514, 2.192135374088388],
            [34.847039154210684, 2.191112834597488],
            [34.84739321440015, 2.191424460300091],
            [34.84854455365876, 2.19357573906465],
            [34.84974761431818, 2.19479737794588],
            [34.84888554246252, 2.196700757232025],
            [34.85073887109823, 2.198247330951332],
            [34.84997558787268, 2.199292831130784],
            [34.85073167110123, 2.199797087044339],
            [34.85191879834243, 2.199349655294033],
            [34.85172487722544, 2.200278608828145],
            [34.85072857460843, 2.200464673429213],
            [34.84950146964213, 2.204416819240445],
            [34.84991932638643, 2.20630242535729],
            [34.849784054477674, 2.207362733779755],
            [34.84916418908385, 2.208146643011918],
            [34.85062842323403, 2.209274125575117],
            [34.848869826436605, 2.21029111053849],
            [34.847774175539094, 2.211454267525868],
            [34.84724199020857, 2.216327644679819],
            [34.84776030644941, 2.21699766971411],
            [34.84690354363709, 2.217756620291754],
            [34.84673421390098, 2.218494957029966],
            [34.84722894128077, 2.219141039186686],
            [34.84801106487278, 2.219144713233664],
            [34.84926355533069, 2.219937398755322],
            [34.850047782777104, 2.219488065585602],
            [34.85151292063246, 2.220424798939979],
            [34.851551928177024, 2.222237039454994],
            [34.85105090091216, 2.222949978842411],
            [34.85168960307915, 2.223215243788569],
            [34.85240239110429, 2.222837092621663],
            [34.852136823055176, 2.223884937164577],
            [34.8524539723679, 2.22449441306836],
            [34.85440548955911, 2.222763030193573],
            [34.85486868517412, 2.225101800814425],
            [34.855650820444225, 2.22510545689381],
            [34.856522445882945, 2.22625399049255],
            [34.857496492738775, 2.225757854628903],
            [34.85789080823273, 2.227619435258621],
            [34.85727172437322, 2.228236448863388],
            [34.85741226759605, 2.228594750122021],
            [34.85826517214422, 2.228670261938884],
            [34.858713279655746, 2.229149221464246],
            [34.85942518194199, 2.22896180234296],
            [34.860543301501394, 2.228061017556812],
            [34.8607143874439, 2.226941210643146],
            [34.861354749697554, 2.22684882944759],
            [34.86156143767136, 2.228280357627628],
            [34.86219684930951, 2.229260882826864],
            [34.86178821017833, 2.230498790671721],
            [34.862029627919355, 2.232109303469147],
            [34.863405043840785, 2.231948832589042],
            [34.86388511251177, 2.230639730977013],
            [34.86421659534317, 2.230712799327739],
            [34.86541355734014, 2.233269560972908],
            [34.86476966740235, 2.234124881973905],
            [34.86493447232438, 2.234364083948095],
            [34.86555091783191, 2.234319275937903],
            [34.866051822925904, 2.233630177795525],
            [34.86603494268342, 2.232151856690975],
            [34.86674233273197, 2.23294196708908],
            [34.86666716620057, 2.233823792679889],
            [34.86775222416427, 2.234949469354375],
            [34.86811205692775, 2.236584361417438],
            [34.86837199433667, 2.23675247511771],
            [34.869256397412, 2.235135304289725],
            [34.86942390177145, 2.239928448491588],
            [34.86863638828771, 2.241093062284268],
            [34.86854921307762, 2.242010588805683],
            [34.86913612197859, 2.243229298221772],
            [34.86992099621202, 2.242636898472833],
            [34.87032171399899, 2.24311562364726],
            [34.86927250330673, 2.244493588076521],
            [34.86854085155894, 2.243822592664384],
            [34.868277615536314, 2.244369737212375],
            [34.86796188376507, 2.246906713826541],
            [34.868303531033945, 2.247577739239144],
            [34.86909449404833, 2.2479831439744],
            [34.868498081869966, 2.248620034961292],
            [34.86856892121664, 2.249079368614774],
            [34.8712415097982, 2.251125653842112],
            [34.8722240583099, 2.250240879215104],
            [34.872472552978714, 2.252254958852083],
            [34.87310477200432, 2.252148120367371],
            [34.87387870385927, 2.252959944188291],
            [34.874265094415804, 2.25292410039037],
            [34.87500144884407, 2.251827594094719],
            [34.875035496789955, 2.250979390814337],
            [34.87545720191695, 2.251084864101598],
            [34.87573997090712, 2.252427424213157],
            [34.8789008216934, 2.251681183927387],
            [34.880482802519424, 2.252527286365767],
            [34.881677668746825, 2.252843800118758],
            [34.88245027468842, 2.252630756050691],
            [34.8828756593148, 2.255598775774802],
            [34.88182388483069, 2.2572611244131],
            [34.884197984802896, 2.259396098849756],
            [34.88497054672704, 2.259147708479197],
            [34.88553300707924, 2.25942969665065],
            [34.887365410358726, 2.263738780065445],
            [34.888174434001925, 2.264515204500072],
            [34.88730100923771, 2.268262391485786],
            [34.88751592667786, 2.271442711450991],
            [34.88930785726052, 2.271617048739032],
            [34.89018783882801, 2.27292346828453],
            [34.88983698562412, 2.273277330658074],
            [34.89036437574763, 2.273594692608933],
            [34.893350439532426, 2.273520074444306],
            [34.894791656150076, 2.274154282942575],
            [34.89535481718821, 2.274966353847346],
            [34.89718104634675, 2.274504519577432],
            [34.898129766101476, 2.274644623542702],
            [34.89886595074819, 2.273442093835494],
            [34.90141113217132, 2.27204280633155],
            [34.90186413280616, 2.269215027976659],
            [34.90319859543208, 2.268824520533845],
            [34.90376120849789, 2.269212513768709],
            [34.905587596658236, 2.268892037940076],
            [34.90639736859805, 2.270233863491646],
            [34.90639903856616, 2.271506087165093],
            [34.90759470070092, 2.272423334187165],
            [34.90829922602206, 2.273871313861202],
            [34.91016223669988, 2.274681640873978],
            [34.912133672235875, 2.277788892381015],
            [34.9130502071506, 2.280155413885996],
            [34.9147019744978, 2.280612613811413],
            [34.91551139160309, 2.281671712236236],
            [34.91688262317191, 2.282518011668683],
            [34.917584868568845, 2.2822343584621],
            [34.918113668149076, 2.283611881786866],
            [34.92127545767478, 2.283607628051576],
            [34.92278876948389, 2.285619930663417],
            [34.92703771813277, 2.284200626812343],
            [34.929213842891095, 2.282713444864474],
            [34.93005726572147, 2.282924337438248],
            [34.93040781798974, 2.282358439467999],
            [34.931180416744795, 2.282145353070039],
            [34.93486367829294, 2.282673916247993],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 820,
        District: "MOROTO",
        County: "MATHENIKO",
        Subcounty: "TAPAC",
        Population: 15441,
        Key: "MOROTOTAPAC",
        Dist2: "Moroto",
        "Sub Country": "Tapac",
        id2_original: "MorotoTapac",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.66886375600631, 2.524490756062719],
            [34.6718046345323, 2.524664752388337],
            [34.67277517706021, 2.525248717738364],
            [34.67293414562784, 2.5282136378524],
            [34.672235166505274, 2.530101056067649],
            [34.669393186203834, 2.5329127186499],
            [34.668247424584806, 2.535691240007967],
            [34.666344861085015, 2.538527131928657],
            [34.661383555602356, 2.538871880154871],
            [34.65895435746217, 2.542607903858379],
            [34.65819329487201, 2.542800307644348],
            [34.65792502019894, 2.543527398666589],
            [34.65769429869798, 2.542502229570756],
            [34.65467242267607, 2.537499330277689],
            [34.648612861181554, 2.530250275132473],
            [34.64709025809747, 2.527714596907089],
            [34.651059585452906, 2.528866669521168],
            [34.65220944069468, 2.528328958103326],
            [34.652995384821615, 2.528497288371603],
            [34.65521143969432, 2.527845316394939],
            [34.6566491385093, 2.528451032482898],
            [34.65901546086781, 2.528387000086001],
            [34.659518750988894, 2.52737139020764],
            [34.66044442536328, 2.527849485906464],
            [34.66226626804829, 2.527649785494848],
            [34.66380857747477, 2.528070697050412],
            [34.664228556039774, 2.527675448725241],
            [34.66565805233789, 2.527560830215346],
            [34.66886375600631, 2.524490756062719],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 821,
        District: "MOROTO",
        County: "MOROTO MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 5097,
        Key: "MOROTONORTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.66886375600631, 2.524490756062719],
            [34.66565805233789, 2.527560830215346],
            [34.664228556039774, 2.527675448725241],
            [34.66380857747477, 2.528070697050412],
            [34.66226626804829, 2.527649785494848],
            [34.66044442536328, 2.527849485906464],
            [34.659518750988894, 2.52737139020764],
            [34.65901546086781, 2.528387000086001],
            [34.6566491385093, 2.528451032482898],
            [34.65521143969432, 2.527845316394939],
            [34.652995384821615, 2.528497288371603],
            [34.65220944069468, 2.528328958103326],
            [34.651059585452906, 2.528866669521168],
            [34.64709025809747, 2.527714596907089],
            [34.64621714684529, 2.525274861148139],
            [34.64612943623925, 2.523638328988314],
            [34.646661202954824, 2.520919645952884],
            [34.64910161206976, 2.515550214146679],
            [34.65080750291285, 2.516225452373111],
            [34.651313076551354, 2.517239205159299],
            [34.65232161691749, 2.51719890344084],
            [34.65317622017989, 2.518134178145811],
            [34.653719258057336, 2.518094469668085],
            [34.654185549266806, 2.518718116811417],
            [34.65725233206975, 2.5204698746981],
            [34.659503499391974, 2.521442365916607],
            [34.66008517919971, 2.521285559731691],
            [34.66325981373568, 2.52210320876131],
            [34.66435377220722, 2.522450521765139],
            [34.66489795004676, 2.52330815120537],
            [34.66664467740434, 2.524164227502337],
            [34.66886375600631, 2.524490756062719],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 822,
        District: "MOROTO",
        County: "MOROTO MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISON",
        Population: 9099,
        Key: "MOROTOSOUTHERN DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.94345387748614, 1.680723802558853],
            [34.946877160302904, 1.681595915725382],
            [34.95407063104457, 1.682172273440744],
            [34.95964088739035, 1.683800889939875],
            [34.9674726524639, 1.684610146839694],
            [34.97536147493101, 1.684602008927037],
            [34.99440000434664, 1.687015747526625],
            [34.997247522761825, 1.725445471855634],
            [35.001053643298135, 1.755821174552331],
            [35.00095096855608, 1.959683221550549],
            [34.986603680506015, 1.97991844092122],
            [34.985300350792905, 1.982442741235544],
            [34.98478978521633, 1.99482851922891],
            [34.98234131462005, 2.018526553518637],
            [34.98158764157141, 2.033110844648298],
            [34.980852216899436, 2.030498530702698],
            [34.977793382390104, 2.027016374332994],
            [34.9779616063001, 2.0255719732234],
            [34.97682923766366, 2.024493685954168],
            [34.97683309772442, 2.023659335085606],
            [34.9751263687532, 2.021255174055435],
            [34.97191068120871, 2.019737965093749],
            [34.9683120158075, 2.019053425083525],
            [34.965705217142386, 2.019088774287835],
            [34.9527431591082, 2.021614135613055],
            [34.943037705083, 2.0219615959396],
            [34.934751869481104, 2.022744746888451],
            [34.929034092697684, 2.024195743628741],
            [34.92525379962413, 2.024308945110397],
            [34.923097913010814, 2.024203318883188],
            [34.91819802354751, 2.023035676215494],
            [34.91354180300333, 2.022977743162188],
            [34.91110715837758, 2.02165481563762],
            [34.90712965635306, 2.020872925510816],
            [34.904159461307756, 2.017544629653459],
            [34.90278503892306, 2.017538037413432],
            [34.901366192152594, 2.016911429748667],
            [34.89945411369731, 2.017843976395521],
            [34.89562076432641, 2.021664354296597],
            [34.89289844770566, 2.021055282304676],
            [34.8899823617832, 2.021327414712808],
            [34.88577838639069, 2.02081863906763],
            [34.883419747322826, 2.018470723751217],
            [34.8826908489114, 2.017251315793954],
            [34.88125003563729, 2.016243020382464],
            [34.88095941626984, 2.015061484548051],
            [34.87919275349947, 2.012811753538673],
            [34.87434318406512, 2.011024225974615],
            [34.87306855911859, 2.009945227907048],
            [34.86935114811489, 2.007938446264686],
            [34.86995329962964, 2.006928882838895],
            [34.87161799014053, 2.005697121983934],
            [34.87197829901107, 2.004673669640295],
            [34.87361372420664, 2.004609983950405],
            [34.87397192742618, 2.004039481687825],
            [34.87400975458449, 2.001059317433291],
            [34.87334984409193, 2.000293129273824],
            [34.87183119988329, 2.000715080129883],
            [34.87145418773836, 2.000260164134177],
            [34.87166971333794, 1.999784347071631],
            [34.87292644294568, 1.999623449949594],
            [34.872456160521416, 1.99885824327856],
            [34.870656442443554, 1.998587369388066],
            [34.867740075348394, 1.998907199501676],
            [34.865189842698385, 1.996871787924532],
            [34.84989841091167, 1.970388069449593],
            [34.83777115457606, 1.951177622928459],
            [34.828415832407586, 1.93479489830534],
            [34.830961574379465, 1.889315654512842],
            [34.8311754147396, 1.886840456096279],
            [34.83212819038781, 1.883410046806775],
            [34.83255517132043, 1.883036886176834],
            [34.83153705760836, 1.879880590041729],
            [34.83111351542663, 1.877003877996638],
            [34.8277432188386, 1.871422291845738],
            [34.834468161565766, 1.86760718617543],
            [34.835222396061454, 1.864898377810507],
            [34.835304367331126, 1.86286729583242],
            [34.833277893814305, 1.855338044840412],
            [34.8326883043405, 1.854492387492685],
            [34.83369743489976, 1.854322078002185],
            [34.838408958427785, 1.855586495413197],
            [34.83908311620071, 1.856855121010915],
            [34.84017744657479, 1.857700216076577],
            [34.84093652298987, 1.859730322665706],
            [34.84169412526958, 1.860321916123903],
            [34.84362810015991, 1.859727516909091],
            [34.8468223826478, 1.857947122925165],
            [34.848166697995744, 1.856507066526595],
            [34.850673699222675, 1.849868901942662],
            [34.85118651058746, 1.845706534377164],
            [34.84856497416181, 1.839782823297394],
            [34.850014700520134, 1.837643970149988],
            [34.85052814429888, 1.834131816935619],
            [34.8524360114521, 1.830709723535228],
            [34.855437858636456, 1.831655558824705],
            [34.856859862985125, 1.831654156373183],
            [34.8578951012815, 1.832693564797316],
            [34.858670179386706, 1.832172528242298],
            [34.858150629758995, 1.829831927367076],
            [34.860473477251006, 1.825927787688644],
            [34.8590492262158, 1.823718211505742],
            [34.85555548134481, 1.820340289233115],
            [34.84727820758588, 1.816317021932015],
            [34.847017696153486, 1.814366411453268],
            [34.84843647285534, 1.811243522346453],
            [34.85011470816409, 1.809030841325473],
            [34.8538637713068, 1.809287013696979],
            [34.8559333352112, 1.810585554008949],
            [34.85916488430863, 1.810452136386048],
            [34.86084325975457, 1.8083695051805],
            [34.86148723952387, 1.806027751983814],
            [34.86070949521884, 1.803947641412557],
            [34.86019205124215, 1.803557909193089],
            [34.85838152553311, 1.802779427672124],
            [34.85321122969453, 1.803174911816454],
            [34.85333811672841, 1.800833713100338],
            [34.85643828631725, 1.798619616035903],
            [34.86005407630273, 1.794974249237639],
            [34.8612133934994, 1.790941244880338],
            [34.86017703320724, 1.78873120501825],
            [34.85681529846218, 1.787954400702456],
            [34.85448613491545, 1.785615707338021],
            [34.85306069181586, 1.782105417908544],
            [34.849048661246734, 1.777297400083928],
            [34.84736832028698, 1.777429136594145],
            [34.84594729779692, 1.778340908787807],
            [34.845169763697676, 1.776390818937797],
            [34.8463308362024, 1.77404860375906],
            [34.848784781132025, 1.771965088955509],
            [34.848911457061824, 1.769363884367954],
            [34.84748804864637, 1.767804506336458],
            [34.84554796880536, 1.766766043213245],
            [34.84283435416476, 1.7676790830884],
            [34.84167222883453, 1.768980878965008],
            [34.84076507143305, 1.76664075996562],
            [34.83921182771297, 1.764561305177318],
            [34.83753106634164, 1.764302881843962],
            [34.83662453955749, 1.762613024445447],
            [34.83403886567463, 1.762225389026145],
            [34.83080886078117, 1.763919314216533],
            [34.82757745182091, 1.764182648160772],
            [34.82382803833521, 1.76353602754954],
            [34.82111217880472, 1.762238155232191],
            [34.81373939624749, 1.757563227220684],
            [34.811031958422795, 1.754515440294382],
            [34.80905552376226, 1.754409937730326],
            [34.80884154236662, 1.754033944501525],
            [34.81156392905598, 1.752257656290477],
            [34.81220538276268, 1.75274069512387],
            [34.81241866257408, 1.752310547705555],
            [34.81311296147403, 1.752256252880241],
            [34.814660941066556, 1.751179760603529],
            [34.81620990341604, 1.751070750670567],
            [34.816903150388754, 1.749887772595547],
            [34.81797151406123, 1.749994256814985],
            [34.819893557527976, 1.749078683402595],
            [34.819412327335314, 1.748541768908473],
            [34.82117386791194, 1.747411400648046],
            [34.824805377516554, 1.746762949707385],
            [34.82597971364646, 1.745955683697076],
            [34.830518942997955, 1.744983848677734],
            [34.83268290007576, 1.743615253921384],
            [34.83389590688198, 1.743419259542494],
            [34.83489191395324, 1.743754288243681],
            [34.83550992702095, 1.742779366005751],
            [34.83766693652837, 1.741753234217223],
            [34.83750194116348, 1.740428269708521],
            [34.84002087291573, 1.739116632718674],
            [34.840412833026996, 1.739313329703935],
            [34.84084156836938, 1.738804190807007],
            [34.84082121613831, 1.737975876357717],
            [34.84206587418529, 1.737747192367267],
            [34.84185455898944, 1.736846484060552],
            [34.84254928009756, 1.736590721881915],
            [34.84228841742386, 1.7360683947505],
            [34.84253026096634, 1.735454593584699],
            [34.84320154053714, 1.735080281033631],
            [34.843702281239466, 1.735438460059278],
            [34.84463982774866, 1.734332215103302],
            [34.845787004214245, 1.734528911688691],
            [34.84629427207541, 1.733372580206038],
            [34.84694049763293, 1.733258377560012],
            [34.84727364594089, 1.73363914550408],
            [34.84799285961524, 1.733241401781637],
            [34.849138984153626, 1.733674640550665],
            [34.84995427534254, 1.733182897928998],
            [34.851233532002695, 1.733250240751424],
            [34.85240695634258, 1.732902864000054],
            [34.85286383410617, 1.732337745303932],
            [34.85370102173016, 1.732319506165347],
            [34.85446936247077, 1.731614370679288],
            [34.85578258712675, 1.732119722353655],
            [34.85693650095696, 1.73075462639085],
            [34.85983918221877, 1.728737985313123],
            [34.8612241319603, 1.729243758871939],
            [34.861181180811606, 1.7281076270665],
            [34.86223291127826, 1.728256342860872],
            [34.86206742543327, 1.727805705908519],
            [34.86249854580274, 1.727666389368582],
            [34.8629512832312, 1.72804799977412],
            [34.86334836643455, 1.727470674381501],
            [34.86449449007464, 1.727903914468892],
            [34.86463941438111, 1.72757365264102],
            [34.86397276562562, 1.726883106384918],
            [34.86454656451335, 1.726934034788213],
            [34.8645966033696, 1.726413809690801],
            [34.86536501417879, 1.725708811186476],
            [34.86662195399232, 1.72264048967511],
            [34.86827674866205, 1.72158614722425],
            [34.870094854355465, 1.721479380359088],
            [34.87157349568616, 1.719678509073773],
            [34.87196678889735, 1.71721991577227],
            [34.8728291015015, 1.716917852814664],
            [34.87614135883734, 1.714193950444322],
            [34.87700296895895, 1.714033728589495],
            [34.879211842699256, 1.712060141874899],
            [34.88428191978979, 1.7093119619401],
            [34.89415342200534, 1.702358574801325],
            [34.896553959396364, 1.700291536776057],
            [34.89766506311341, 1.697742846412671],
            [34.899167635563316, 1.695942233022545],
            [34.900151922315054, 1.695072932299365],
            [34.901301274500284, 1.694748979007318],
            [34.90269703187298, 1.692746471081949],
            [34.9044938034767, 1.692024343996154],
            [34.906659163723, 1.691789761441284],
            [34.91035769663097, 1.689765643699641],
            [34.91231019927407, 1.687467095323474],
            [34.913817613643324, 1.686590074924489],
            [34.92222493291266, 1.682671184704386],
            [34.93527499709863, 1.680907175776921],
            [34.94345387748614, 1.680723802558853],
          ],
          [
            [34.95578241214097, 1.928312327002327],
            [34.954809074055895, 1.929293881592188],
            [34.95321498573645, 1.929741381292261],
            [34.94874551595665, 1.933489716471235],
            [34.947334108135095, 1.938749716575357],
            [34.94538602699984, 1.939509480548695],
            [34.943791728474615, 1.939778820723217],
            [34.93993746452729, 1.939248417156819],
            [34.93759075598471, 1.940008742031475],
            [34.936174996723906, 1.941525462882198],
            [34.93396022913697, 1.94148351858296],
            [34.93177360307298, 1.942844526572771],
            [34.926407713454346, 1.940389465914675],
            [34.922261777314056, 1.939586495682586],
            [34.92062712466961, 1.938874988547718],
            [34.919395099630506, 1.939209980508894],
            [34.915070553258886, 1.943463726676787],
            [34.907665276841215, 1.951743513444266],
            [34.90659859840823, 1.95486236300314],
            [34.90569916023001, 1.956097949441013],
            [34.90744561090647, 1.957734876294975],
            [34.90904110329269, 1.958446094452934],
            [34.910061322655814, 1.959692760568132],
            [34.911656674904876, 1.96031476006022],
            [34.91369430639585, 1.960312375531167],
            [34.914447978546185, 1.960890888575935],
            [34.915776853651025, 1.960844736821371],
            [34.91626454093392, 1.961245235179979],
            [34.91688395717009, 1.960620710552094],
            [34.91861188099217, 1.960930587918095],
            [34.922287323604074, 1.959945965128783],
            [34.923528261727476, 1.960568385590037],
            [34.92645101494597, 1.959852118265604],
            [34.92888853687559, 1.960963272832252],
            [34.93039454897468, 1.960916981024568],
            [34.93070523940054, 1.961451305586853],
            [34.9298650343355, 1.962700072981599],
            [34.929068059795235, 1.963013036557905],
            [34.92822595928495, 1.962612819630343],
            [34.9275175541401, 1.96288103386969],
            [34.92481881829556, 1.965780746212135],
            [34.92415588946365, 1.967073839449033],
            [34.924210349827746, 1.967715476151234],
            [34.92473298696509, 1.968142765470855],
            [34.92393671490736, 1.969079548554966],
            [34.925664427625314, 1.969255738821062],
            [34.92840871074972, 1.967425519215862],
            [34.931022246779456, 1.967511510028985],
            [34.93266237375721, 1.968534564337128],
            [34.93527640116539, 1.969066221836703],
            [34.936207911894215, 1.97017919367236],
            [34.93913206828121, 1.970710569640728],
            [34.941658369812004, 1.971999871305222],
            [34.945033929629304, 1.974536949224423],
            [34.94573658106473, 1.974579733918037],
            [34.94453761043482, 1.971996504617963],
            [34.94521520695867, 1.970825739159204],
            [34.94555158381178, 1.967850985207424],
            [34.94723431069692, 1.96744796385905],
            [34.948209123815694, 1.967714212966915],
            [34.95139835328008, 1.967665956991393],
            [34.95254960001224, 1.967308105895717],
            [34.9559606720293, 1.967571409391181],
            [34.95777828634427, 1.968906162950372],
            [34.95871134127707, 1.971355851739683],
            [34.96088519419603, 1.974249799045981],
            [34.96473826518068, 1.973710568612404],
            [34.96597969468249, 1.974734040170753],
            [34.96744212411727, 1.975311566039516],
            [34.96921636687201, 1.977359207719415],
            [34.9695679027955, 1.974997061486053],
            [34.96921320839548, 1.974685503392999],
            [34.96996561751451, 1.97419452888847],
            [34.969964985998885, 1.9736151792355],
            [34.96848248550569, 1.972626356023198],
            [34.96805452181615, 1.971786367656896],
            [34.96889900915012, 1.971165493770949],
            [34.96769947707313, 1.970186909230194],
            [34.9680999289588, 1.969651465233043],
            [34.96725403935465, 1.966042928613325],
            [34.96667771350605, 1.965597963131122],
            [34.96572346462076, 1.966086134586994],
            [34.96601190737028, 1.96439562966919],
            [34.96516882500139, 1.963148827003415],
            [34.96339689810347, 1.963017245388548],
            [34.96273067065785, 1.962551236737123],
            [34.963128736618124, 1.960967761778277],
            [34.962283057219764, 1.960109390687124],
            [34.96241710292815, 1.958473168224713],
            [34.96166378112078, 1.958206636636563],
            [34.96082055771638, 1.956826142835908],
            [34.96112998511096, 1.956291115623061],
            [34.962396469524386, 1.955782319925889],
            [34.962412821557486, 1.954819016684134],
            [34.96198745489742, 1.954339819870234],
            [34.962144801107655, 1.95285860122914],
            [34.96115040741064, 1.952539323369233],
            [34.96098436011855, 1.952033753206901],
            [34.95987065937204, 1.953225154133465],
            [34.955413401290244, 1.953052609016339],
            [34.9558542072951, 1.952242210184002],
            [34.95802251581214, 1.95036806442619],
            [34.95943666080039, 1.947558946310559],
            [34.95930240488622, 1.946355898741275],
            [34.95832646977166, 1.945109362790204],
            [34.958023989947506, 1.943584228296452],
            [34.96363775888902, 1.941612577271278],
            [34.96363565323799, 1.939800284439892],
            [34.96460639519189, 1.936590644613252],
            [34.965309396970326, 1.931598857030186],
            [34.96025974217947, 1.931471059892907],
            [34.95698040001398, 1.930093489926085],
            [34.95578241214097, 1.928312327002327],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 823,
        District: "AMUDAT",
        County: "POKOT",
        Subcounty: "AMUDAT",
        Population: 28204,
        Key: "AMUDATAMUDAT",
        Dist2: "Amudat",
        "Sub Country": "amudat",
        id2_original: "Amudatamudat",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.96996564176903, 1.9741944866927],
            [34.96921320839548, 1.974685562646599],
            [34.96956793333823, 1.974997071361651],
            [34.969216363278754, 1.977359264279566],
            [34.96744214567683, 1.975311540901644],
            [34.96597972881848, 1.974733982712715],
            [34.964738264282346, 1.973710538985587],
            [34.96088522563707, 1.974249864584076],
            [34.95871136912481, 1.97135591458453],
            [34.95777830610721, 1.968906106389933],
            [34.95596064597818, 1.967571393231033],
            [34.95254961438526, 1.967308048437423],
            [34.95139835597503, 1.96766590222648],
            [34.94820915166347, 1.967714220149188],
            [34.9472343457312, 1.967447993485979],
            [34.945551588303324, 1.967851031892258],
            [34.945215187195735, 1.970825770581637],
            [34.94453761133312, 1.971996527062557],
            [34.94573659813274, 1.97457973302024],
            [34.94503392693434, 1.974537007580232],
            [34.941658403948, 1.971999913501048],
            [34.939132057501446, 1.970710566947364],
            [34.9362079280639, 1.970179243050494],
            [34.935276431708125, 1.969066266725935],
            [34.93266237016395, 1.968534571519397],
            [34.931022248576085, 1.967511541451482],
            [34.928408697274996, 1.967425461757573],
            [34.92566445816804, 1.969255734332129],
            [34.923936714009066, 1.969079493790067],
            [34.9247329627106, 1.968142746617379],
            [34.924210345336164, 1.96771541240845],
            [34.92415588856532, 1.967073905885178],
            [34.92481884255008, 1.965780810852795],
            [34.927517559529996, 1.962881087736989],
            [34.92822598443776, 1.962612888760043],
            [34.92906806069353, 1.963012975508317],
            [34.92986502445403, 1.962700109790906],
            [34.93070520706118, 1.961451374716602],
            [34.93039452382186, 1.960916983717915],
            [34.92888852699412, 1.96096329437919],
            [34.92645099069148, 1.959852050033561],
            [34.92352829137188, 1.960568443048562],
            [34.922287299349584, 1.959945997449225],
            [34.91861186661911, 1.960930631011971],
            [34.916883972441475, 1.960620684516196],
            [34.91626454273055, 1.961245283660572],
            [34.91577683029484, 1.96084477722187],
            [34.914448002800675, 1.960890871517952],
            [34.913694309989104, 1.960312419522864],
            [34.91165669466781, 1.960314764549177],
            [34.91006132984233, 1.959692712985266],
            [34.90904110419101, 1.958446111510942],
            [34.90744563965255, 1.957734927469055],
            [34.90569913328052, 1.956097947645433],
            [34.90659861098462, 1.954862364798722],
            [34.9076652939092, 1.951743567311923],
            [34.91507053619091, 1.943463763486515],
            [34.919395066392845, 1.939209939210061],
            [34.920627106703336, 1.938875006503741],
            [34.92226174677131, 1.939586489397976],
            [34.9264077287257, 1.940389478483856],
            [34.931773593191515, 1.942844456544443],
            [34.933960221950464, 1.94148350152478],
            [34.93617501828347, 1.941525510465578],
            [34.93759072544198, 1.940008749213866],
            [34.93993748518852, 1.939248474616073],
            [34.9437917329662, 1.939778769548591],
            [34.94538603238972, 1.939509547883747],
            [34.947334126101396, 1.938749730940184],
            [34.94874553302467, 1.933489744303158],
            [34.953214971363394, 1.929741343584413],
            [34.9548090506997, 1.929293877103148],
            [34.95578239776792, 1.92831238176852],
            [34.956980375759464, 1.930093480050223],
            [34.960259717026645, 1.93147109580511],
            [34.965309378105715, 1.931598905511632],
            [34.96460642932788, 1.936590653591258],
            [34.96363566401779, 1.939800244038854],
            [34.963637757990725, 1.941612601511875],
            [34.958023994439095, 1.943584277675368],
            [34.958326478754834, 1.945109328673883],
            [34.95930239859804, 1.946355923879582],
            [34.95943667427512, 1.947558939128168],
            [34.958022502337414, 1.950368006069505],
            [34.955854236041205, 1.952242154520777],
            [34.95541341476497, 1.95305267006629],
            [34.959870662965294, 1.953225221467969],
            [34.96098434125395, 1.952033814256888],
            [34.96115042627524, 1.95253930451558],
            [34.962144785836266, 1.952858636243079],
            [34.961987421659764, 1.954339753433583],
            [34.96241283413391, 1.954819046311287],
            [34.96239645694796, 1.955782326210439],
            [34.96113000217894, 1.956291101258384],
            [34.96082056220797, 1.956826209272461],
            [34.96166377034098, 1.958206637534369],
            [34.96241708945343, 1.958473118846233],
            [34.962283059914725, 1.960109409540726],
            [34.963128715956856, 1.96096774651587],
            [34.96273067245448, 1.962551171198567],
            [34.96339687834053, 1.963017277708897],
            [34.965168824103095, 1.963148864710515],
            [34.966011883115755, 1.964395598246635],
            [34.96572344216287, 1.966086164213947],
            [34.96667771350605, 1.965597979291289],
            [34.96725406720243, 1.966042911555395],
            [34.968099907399235, 1.969651411365962],
            [34.96769944383548, 1.970186860749859],
            [34.9688989965737, 1.971165561104731],
            [34.9680545146296, 1.971786406261567],
            [34.96848248730232, 1.972626350636475],
            [34.9699649581511, 1.973615184622186],
            [34.96996564176903, 1.9741944866927],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 824,
        District: "AMUDAT",
        County: "POKOT",
        Subcounty: "AMUDAT TOWN COUNCIL",
        Population: 11786,
        Key: "AMUDATAMUDAT TOWN COUNCIL",
        Dist2: "Amudat",
        "Sub Country": "amudat tC",
        id2_original: "Amudatamudat tC",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.787452299718886, 1.363597051413417],
            [34.79383001394431, 1.368286389429307],
            [34.80687680646601, 1.380209021574232],
            [34.80724289330048, 1.381108552461329],
            [34.8069738245167, 1.38512277462577],
            [34.80568663932586, 1.389568142570571],
            [34.80248915524232, 1.396957035082857],
            [34.80002806062134, 1.401473751151588],
            [34.797285743010804, 1.404237961985391],
            [34.79519690934527, 1.407549400947172],
            [34.794499309136654, 1.410304226322415],
            [34.79501364404415, 1.411884392007452],
            [34.79853992769134, 1.417538857989082],
            [34.8015431987054, 1.420462898926421],
            [34.805012568689484, 1.422870155593902],
            [34.81633599813581, 1.427430725412181],
            [34.81821085040574, 1.428908068647303],
            [34.82102804708679, 1.432442508182309],
            [34.82375388240851, 1.438402597716556],
            [34.826610678623915, 1.442805481077345],
            [34.827646605928095, 1.445175467591914],
            [34.83181691426038, 1.449053022940117],
            [34.833971427349596, 1.4502171121014],
            [34.837159679447, 1.451043900767807],
            [34.84245475397345, 1.451751573944121],
            [34.84498363277082, 1.45438632776476],
            [34.855956501864036, 1.495416077963212],
            [34.85893394272043, 1.504317650121348],
            [34.86482208589581, 1.525618240364097],
            [34.87826058969545, 1.53888422059984],
            [34.89097655246093, 1.552533964058495],
            [34.906321501380724, 1.549985054882197],
            [34.907348041290206, 1.550312724778367],
            [34.924250859355496, 1.559787885772444],
            [34.94441552040454, 1.573883623924069],
            [34.94968670603268, 1.582258098918337],
            [34.953798845755344, 1.589890337948673],
            [34.961075554391265, 1.601175948539033],
            [34.9723419309356, 1.622449908625542],
            [34.97526597143993, 1.629200624472405],
            [34.98870436295013, 1.654333113873389],
            [34.99198496185872, 1.661630179978171],
            [34.994399988176994, 1.68701579421876],
            [34.97536149469395, 1.684602067292278],
            [34.96747262281949, 1.684610112718458],
            [34.959640900865075, 1.683800946509288],
            [34.954070609485015, 1.682172334499855],
            [34.94687715131973, 1.681595920215033],
            [34.94345385682491, 1.680723861822155],
            [34.93527498362387, 1.680907149736981],
            [34.92222494818402, 1.682671156868617],
            [34.91231021813868, 1.687467113281991],
            [34.91035770471581, 1.689765643699641],
            [34.906659169112885, 1.691789709361697],
            [34.90449381964638, 1.692024365546317],
            [34.90269703905949, 1.692746471081949],
            [34.90130126282219, 1.694748981701097],
            [34.900151914230214, 1.695072941278572],
            [34.89916761490205, 1.695942216859947],
            [34.89766509365615, 1.697742908369194],
            [34.896553931548624, 1.700291504450934],
            [34.89415341571713, 1.70235860263681],
            [34.884281953027454, 1.709311956552582],
            [34.87921182922454, 1.712060116733309],
            [34.87700300039998, 1.714033797728822],
            [34.87614132919293, 1.714193949546393],
            [34.87282910689139, 1.716917834856421],
            [34.87196681315184, 1.717219967851169],
            [34.87157349478786, 1.719678527031989],
            [34.870094844473996, 1.721479396521471],
            [34.86827675135701, 1.721586112205778],
            [34.866621959382236, 1.722640442085914],
            [34.865365010585535, 1.725708758209919],
            [34.864596627624124, 1.726413784549367],
            [34.8645465384622, 1.726934078785679],
            [34.86397276742224, 1.726883089324692],
            [34.86456645501035, 1.72785710479027],
            [34.863348395180616, 1.727470712093598],
            [34.86295127873961, 1.728047948593438],
            [34.862498517954954, 1.727666429774409],
            [34.86206741824672, 1.727805664604807],
            [34.86223287983723, 1.728256339269252],
            [34.86118120865939, 1.728107647718336],
            [34.8612241095024, 1.729243801971429],
            [34.85983914898111, 1.728738010454494],
            [34.85693651263506, 1.730754610228546],
            [34.855782603296426, 1.732119777125839],
            [34.854469383132006, 1.731614439817977],
            [34.85226317379482, 1.732972893362436],
            [34.84995430858023, 1.733182961680213],
            [34.84913900930644, 1.733674704301863],
            [34.84799289195456, 1.733241424229257],
            [34.84727366480549, 1.73363912575019],
            [34.84674926247859, 1.733233482265814],
            [34.84615022632127, 1.733489966813339],
            [34.84578697277321, 1.734528878466262],
            [34.844639818765515, 1.734332239346713],
            [34.84370227045966, 1.735438478017346],
            [34.843201572876495, 1.735080310664443],
            [34.84253027893266, 1.735454658233756],
            [34.84683592205575, 1.727045773957571],
            [34.818879487132975, 1.712821818155441],
            [34.81907432183661, 1.712018461591936],
            [34.8187647614914, 1.711708834680247],
            [34.8194874157133, 1.7105302327287],
            [34.81896435996101, 1.70981692803277],
            [34.81824667342263, 1.709859643659911],
            [34.818234123958106, 1.707256439977098],
            [34.81882673895781, 1.705733854008647],
            [34.81837823618756, 1.704382083144665],
            [34.82018455508617, 1.70150656280779],
            [34.82033301156832, 1.700371606075595],
            [34.81976026281117, 1.697350665929645],
            [34.82031385589322, 1.69654961146639],
            [34.82034543796364, 1.69479862064314],
            [34.81882403592711, 1.692682679020353],
            [34.81897219596522, 1.691618706967115],
            [34.81969132609625, 1.691244693837541],
            [34.82000709829168, 1.690134469804508],
            [34.82003134382118, 1.687330353804366],
            [34.819649201397645, 1.687209577396879],
            [34.81616065148394, 1.681010602797085],
            [34.81591924631931, 1.678796390223684],
            [34.816451523278005, 1.677403581337442],
            [34.817316735643885, 1.676438887842954],
            [34.81665115498527, 1.675511684297266],
            [34.81706300828853, 1.674307420793984],
            [34.816853789760536, 1.672933518273313],
            [34.817333872804575, 1.672534300186429],
            [34.816644896422694, 1.671488610735841],
            [34.816712841397525, 1.669631349381524],
            [34.81640422428333, 1.669108740109827],
            [34.81681256158058, 1.668709070482546],
            [34.81679581428873, 1.667076083756676],
            [34.81465671988303, 1.664033197668728],
            [34.813989325525846, 1.660798625882787],
            [34.813159369339914, 1.659184065492418],
            [34.81288154377874, 1.657099764695851],
            [34.812002182947104, 1.65583984009739],
            [34.81229917226823, 1.653569924161633],
            [34.81031113406915, 1.651533750753049],
            [34.80988712745843, 1.650063780345464],
            [34.8090035050191, 1.649774102185956],
            [34.80833773122268, 1.648894199646525],
            [34.808539795567725, 1.646458006112462],
            [34.807994954771495, 1.645271242017756],
            [34.80795390715292, 1.643732757329219],
            [34.80692565325788, 1.643702443582193],
            [34.8067844551632, 1.643180903210426],
            [34.80632891858433, 1.643438277831397],
            [34.805291457855965, 1.642780787462945],
            [34.804120232591885, 1.642631221968819],
            [34.80301970833395, 1.642718777102558],
            [34.801843561200435, 1.64368145140864],
            [34.80119816209298, 1.643606282580055],
            [34.79929191819548, 1.64200839835224],
            [34.799342562516244, 1.641369767087928],
            [34.79857936193569, 1.640891531393713],
            [34.7986109062769, 1.63916418159646],
            [34.797510806023766, 1.639157075238426],
            [34.79672503617, 1.638371042203948],
            [34.795934367803035, 1.6386972406618],
            [34.79515017718753, 1.637556236798272],
            [34.7939668228705, 1.637442094082811],
            [34.79284101822386, 1.63783711863321],
            [34.79134176504893, 1.636147181044929],
            [34.79113061424478, 1.635222873394218],
            [34.790247408623735, 1.634838513276709],
            [34.78935845378487, 1.635755697673313],
            [34.786753116678746, 1.635407533099418],
            [34.78567524523733, 1.635779191616482],
            [34.78460102993909, 1.635322605045952],
            [34.78431760158548, 1.634516135865399],
            [34.78357664598631, 1.634416680742175],
            [34.78326877357551, 1.633728398498551],
            [34.78267182600124, 1.633511549817636],
            [34.78312822316618, 1.633064857247186],
            [34.782676542156466, 1.632446634450976],
            [34.782340884853944, 1.632633770959175],
            [34.781447243504225, 1.631906193772253],
            [34.77951186724206, 1.631491352967569],
            [34.77860087583095, 1.631982423519738],
            [34.778341359731876, 1.63117611462989],
            [34.777317494107024, 1.630151868056335],
            [34.77640409251602, 1.631187228572619],
            [34.7759038557686, 1.630734344110519],
            [34.77537655637492, 1.630991239925492],
            [34.7740879428628, 1.630343920165267],
            [34.774210562899064, 1.6296584255664],
            [34.77153767338187, 1.628363151924465],
            [34.77013693664756, 1.626034848598617],
            [34.76932401970591, 1.625982249172557],
            [34.76835862811785, 1.625254183790548],
            [34.767877900981766, 1.625795363473475],
            [34.767401897187455, 1.625271640014307],
            [34.76682581927385, 1.6257412123772],
            [34.76609399325289, 1.623582898725942],
            [34.76585252969778, 1.624101979300648],
            [34.762507591651946, 1.623346627090135],
            [34.76176314430126, 1.624028096508057],
            [34.76147983811852, 1.623197962594301],
            [34.76045272238897, 1.622907302681218],
            [34.76021671340427, 1.622195800772112],
            [34.75985798287363, 1.622193468782296],
            [34.759456146684144, 1.62112590655149],
            [34.75809411566047, 1.620856734424459],
            [34.75644148503225, 1.618704255873356],
            [34.755922820245075, 1.61702062028104],
            [34.75380041384245, 1.615634218242527],
            [34.75274675738782, 1.615935024328613],
            [34.75150566834746, 1.615358978780472],
            [34.75001970484887, 1.615409579627355],
            [34.74052532886432, 1.613149263863781],
            [34.73941698656845, 1.611930168858327],
            [34.73858782628985, 1.609913524348132],
            [34.737429159473486, 1.609075597544698],
            [34.73571749425975, 1.609093892603255],
            [34.73558043200864, 1.608330770137926],
            [34.73369479187047, 1.606131948862136],
            [34.73395818509832, 1.60587063282051],
            [34.73372430961239, 1.605345532137559],
            [34.73270304011872, 1.605223050021573],
            [34.73299025127798, 1.603329183736588],
            [34.733397670497, 1.602877671432613],
            [34.73285425173384, 1.602423062849269],
            [34.73310972810907, 1.599992838623665],
            [34.73251547098907, 1.599990918774375],
            [34.73211833748005, 1.599036282929619],
            [34.732203237257565, 1.597177518716132],
            [34.73170266094695, 1.59736656485424],
            [34.73103278454465, 1.596327614110533],
            [34.73022404746403, 1.596396492641284],
            [34.73034762420607, 1.595753378724951],
            [34.729255554891594, 1.595559164638464],
            [34.729214988769996, 1.594605677928851],
            [34.72852581655538, 1.594579591975646],
            [34.7285581325494, 1.593411846085132],
            [34.72820175111327, 1.593386857433627],
            [34.72811382221661, 1.592409380493435],
            [34.72759208788612, 1.592240840805158],
            [34.72750222491668, 1.591525538782635],
            [34.726908306461524, 1.591475934090604],
            [34.72705669557006, 1.590689904165145],
            [34.7264310558056, 1.590103937932182],
            [34.72638838133802, 1.589436443073647],
            [34.72485534522021, 1.587786926937391],
            [34.725174820271256, 1.586357928722697],
            [34.72453071114454, 1.58342426170172],
            [34.721864908436615, 1.58389225695538],
            [34.7205251017331, 1.583446952562725],
            [34.718952743660346, 1.583918511862311],
            [34.71821847422185, 1.583558606429684],
            [34.71666918398732, 1.584125562655159],
            [34.71534413840051, 1.583287051535335],
            [34.714651992762306, 1.583666138598468],
            [34.71433773332984, 1.584380137690023],
            [34.713436012532455, 1.584162690203481],
            [34.71261154684956, 1.58313513616411],
            [34.712787385778206, 1.581848676275944],
            [34.71219468364195, 1.581632226171938],
            [34.711634150176025, 1.580271858531855],
            [34.70970880899386, 1.578632932992492],
            [34.708793470635115, 1.577033051013648],
            [34.70716411715255, 1.575550002524091],
            [34.705668664749645, 1.575259111368456],
            [34.70476135732951, 1.575804328972711],
            [34.70386261444734, 1.575181694180122],
            [34.703749186871335, 1.574442463288305],
            [34.700916351419515, 1.573372570235607],
            [34.700200258492444, 1.573775408787208],
            [34.698637682174855, 1.572912259295679],
            [34.69717545036944, 1.571334403006379],
            [34.696606691928785, 1.571094193118384],
            [34.695344215798144, 1.571447563431552],
            [34.69435635105663, 1.570014276016596],
            [34.69266949371777, 1.569889573801309],
            [34.69123966414466, 1.568752752072737],
            [34.68660171982493, 1.569095030952005],
            [34.679067435450996, 1.570536090995419],
            [34.67163386300018, 1.572823600248149],
            [34.668931310214, 1.571813657124958],
            [34.6665246400245, 1.572592281401226],
            [34.6661499167869, 1.571828342645271],
            [34.663905550609705, 1.571546859079744],
            [34.66116694214296, 1.572205201221475],
            [34.660290217866674, 1.571820963068055],
            [34.65813919203739, 1.571778105306356],
            [34.6532232892058, 1.572727214105793],
            [34.64134498747645, 1.573295784254773],
            [34.63953430995214, 1.573838021988858],
            [34.635620139155115, 1.575946394986724],
            [34.632861055388126, 1.576151793401528],
            [34.63122887760229, 1.576874080692652],
            [34.62987481283858, 1.576535191149943],
            [34.63007095189604, 1.575725452594258],
            [34.62894081018317, 1.574243931529254],
            [34.62866785438914, 1.572574578683753],
            [34.62833717195665, 1.572287452330918],
            [34.62736130601237, 1.572451078114512],
            [34.62662894639213, 1.571828938004175],
            [34.62451253354907, 1.568699523493152],
            [34.62319419658082, 1.569078659906938],
            [34.62293037216163, 1.568296106562387],
            [34.6238246989259, 1.566296922864725],
            [34.6244950613168, 1.565655596481048],
            [34.625492565879625, 1.562560331951773],
            [34.62559062687435, 1.560546594580186],
            [34.62633247899218, 1.559881673749012],
            [34.62637261032918, 1.557665136859021],
            [34.625901931747855, 1.557020015656492],
            [34.62593098506078, 1.556305067926695],
            [34.625328432897426, 1.555814451665499],
            [34.62750906630018, 1.55346199955766],
            [34.627734617098334, 1.55188963959718],
            [34.62850111180104, 1.551105629610947],
            [34.62834369103065, 1.549889520779922],
            [34.628694452606375, 1.549068373801366],
            [34.62970006446467, 1.548094474363603],
            [34.62982526625907, 1.547236830671259],
            [34.63155281907691, 1.545073572560273],
            [34.63617994049411, 1.541382596130344],
            [34.63897137798439, 1.540009433020986],
            [34.64025714293876, 1.539727698262239],
            [34.643687577243476, 1.540346876390536],
            [34.644190287951204, 1.539871842863953],
            [34.644876125619454, 1.54035082305954],
            [34.64562218185281, 1.539113879165516],
            [34.64626277048193, 1.539282849671372],
            [34.64645733748764, 1.538687622460017],
            [34.649727880654915, 1.536815522453939],
            [34.65053537806044, 1.536913536499836],
            [34.65034855183753, 1.536460054024264],
            [34.65115870106979, 1.536200562069158],
            [34.65157003065524, 1.535224697322548],
            [34.65551405336744, 1.533891121882485],
            [34.65533813808197, 1.531959916188419],
            [34.65689397883157, 1.530511161904305],
            [34.65706688745578, 1.529629849866453],
            [34.658804256164736, 1.527740744671177],
            [34.65836247009789, 1.52640453703819],
            [34.65860404863736, 1.525880971776441],
            [34.65929427906738, 1.525764085823554],
            [34.65923845416236, 1.523666453203584],
            [34.66199163420133, 1.52424762464148],
            [34.662338338985215, 1.522365830710128],
            [34.663240571822314, 1.522511834437529],
            [34.664100529942104, 1.521942653503939],
            [34.664974054419325, 1.522755934565572],
            [34.6653130175221, 1.521922845455523],
            [34.66621048659322, 1.522712372680035],
            [34.66884162331432, 1.522113316293761],
            [34.66914730024258, 1.522567183450519],
            [34.66955281233827, 1.522377851314069],
            [34.67031011997053, 1.522833216275813],
            [34.67057792931631, 1.521976062635483],
            [34.671076541011374, 1.522025388787293],
            [34.67101940905764, 1.523081768641086],
            [34.67011186807553, 1.523673559957091],
            [34.67126585107603, 1.525107303443679],
            [34.672388559229915, 1.524391988498148],
            [34.67552926709257, 1.524001359610397],
            [34.676237127858364, 1.524741664152392],
            [34.6767708250535, 1.526484268351854],
            [34.68049330255538, 1.527783650917887],
            [34.682374407099665, 1.527359415141441],
            [34.684324892126625, 1.525567805268426],
            [34.6863766343541, 1.524552813533659],
            [34.69257584075614, 1.5252352051616],
            [34.696064271193904, 1.524426797569626],
            [34.69779668479577, 1.524813874801316],
            [34.69870399940241, 1.524268680884917],
            [34.69994073520686, 1.524198416178187],
            [34.70057819949541, 1.522081775000831],
            [34.69973747879743, 1.520689773878895],
            [34.70040526302346, 1.519992912248991],
            [34.7003725050583, 1.517605503743168],
            [34.69948629996252, 1.51692796249678],
            [34.700238889642925, 1.515763189125336],
            [34.6994918470594, 1.514996927472757],
            [34.70080309003184, 1.511404205512415],
            [34.70075557274657, 1.510293086662598],
            [34.701796621346205, 1.509492551671165],
            [34.70208304378465, 1.507576750063142],
            [34.701009971143485, 1.507557912626097],
            [34.7006206862151, 1.506735272243085],
            [34.700961867258314, 1.505621380662988],
            [34.70044030720099, 1.504831461970378],
            [34.701714573719705, 1.503672354818848],
            [34.70149635137764, 1.503015222705667],
            [34.7021018545067, 1.501904994889533],
            [34.70199237322974, 1.501226836310082],
            [34.705839278178274, 1.49852808309418],
            [34.70668040132152, 1.500311516492319],
            [34.70753570526985, 1.500342143929959],
            [34.70877920898166, 1.49940380421283],
            [34.71118136423852, 1.499095101472567],
            [34.71161650456891, 1.498705234034599],
            [34.71066380168422, 1.496103044218839],
            [34.71229059317156, 1.495706009237123],
            [34.71227650309635, 1.494617620004239],
            [34.71104812072568, 1.494482571021475],
            [34.711214661192834, 1.493954384992356],
            [34.7122636940187, 1.493477510237348],
            [34.712918914407155, 1.492632908204223],
            [34.71237404755978, 1.492257296434809],
            [34.71274680528356, 1.49110488269196],
            [34.711712642270605, 1.490249605085971],
            [34.71134846255948, 1.487073555439666],
            [34.710863149523874, 1.486601885873714],
            [34.71120432966875, 1.485733526957729],
            [34.71174885695296, 1.485673095153145],
            [34.71235746555795, 1.486236679251853],
            [34.71282507549426, 1.485819330329062],
            [34.712455725978664, 1.484792451943173],
            [34.71151207272217, 1.484325999350675],
            [34.71214094642165, 1.483812593995051],
            [34.71204852055868, 1.482512530573926],
            [34.71278689080647, 1.481243821484926],
            [34.71157399179807, 1.48055669434568],
            [34.71127512140472, 1.479922690007198],
            [34.71149280565596, 1.478360526596296],
            [34.71270427454645, 1.477187461101815],
            [34.71382089481763, 1.476734546310138],
            [34.716599483704435, 1.477364368597575],
            [34.717608444482075, 1.475959519849094],
            [34.718455147959865, 1.476006865113591],
            [34.72214664616086, 1.47439982499696],
            [34.723120810696, 1.474791103921234],
            [34.724573900346755, 1.473283654956868],
            [34.72452242867763, 1.472793813747413],
            [34.72528764507768, 1.471754800691165],
            [34.7253037815151, 1.470572985904449],
            [34.72608697230567, 1.469614620279391],
            [34.72604550607218, 1.468508205732698],
            [34.725143767308495, 1.468638659333547],
            [34.725079237728394, 1.468040911870171],
            [34.72440750810165, 1.468085439314799],
            [34.724108786828616, 1.467301593977847],
            [34.723464963366176, 1.467454109322928],
            [34.7228607457263, 1.469451215692893],
            [34.72209819642434, 1.468251250695698],
            [34.72066342072728, 1.468484387541663],
            [34.72130266008683, 1.467535796873337],
            [34.72088088129797, 1.466968066360656],
            [34.720105712462924, 1.466896661128727],
            [34.72047869207056, 1.466028283739663],
            [34.72120584595371, 1.465687686708459],
            [34.72199516325452, 1.463470853393374],
            [34.72149353950827, 1.462447139210083],
            [34.721568054761114, 1.461126949403655],
            [34.72057403925481, 1.46075567964081],
            [34.721911642390985, 1.459351542464818],
            [34.721735122539336, 1.456066314460987],
            [34.722187311097166, 1.454813841031413],
            [34.72116116195485, 1.45399986318797],
            [34.72163337845195, 1.452946080567221],
            [34.7208704320946, 1.45325869882375],
            [34.720313191852505, 1.452267026979009],
            [34.721170875438006, 1.452213302529105],
            [34.72115543609323, 1.451690322219958],
            [34.71963504016978, 1.451041218360494],
            [34.71898411372838, 1.450343850725528],
            [34.71913801669614, 1.448863583025793],
            [34.71808013726136, 1.44813231774135],
            [34.71875148690073, 1.447587748780234],
            [34.71822217258586, 1.446724065130087],
            [34.719460168726705, 1.443896059807227],
            [34.718815132538616, 1.442375170873469],
            [34.719753289902236, 1.44248246667497],
            [34.7199127723062, 1.44150554117473],
            [34.72109604128327, 1.441465340816965],
            [34.72060632829938, 1.44040160667397],
            [34.72172969851162, 1.440714848994941],
            [34.72143660248895, 1.439764910384685],
            [34.72222737056893, 1.439452277696733],
            [34.723160970779105, 1.43759687588626],
            [34.72382777853638, 1.437494864776472],
            [34.724150670778755, 1.438726739727618],
            [34.72539871457603, 1.43863377993413],
            [34.72542661175716, 1.439669195472207],
            [34.72594008068872, 1.439721477082108],
            [34.72855999206206, 1.437613538879821],
            [34.729117551206066, 1.436446730308899],
            [34.73061247539961, 1.436941635335165],
            [34.73120787158339, 1.435837076288931],
            [34.73319371789319, 1.435104194849194],
            [34.73321005555327, 1.434315403385604],
            [34.734577734285125, 1.434750399253138],
            [34.73464058940557, 1.433766259229797],
            [34.73421601505957, 1.433189663831052],
            [34.73636303709764, 1.430268618736315],
            [34.73738666916054, 1.427775608228445],
            [34.73888465481257, 1.427074402455262],
            [34.73864187971713, 1.426103743165726],
            [34.73910526757161, 1.424445994938963],
            [34.74198298644831, 1.424371796370391],
            [34.74213332490099, 1.423435599051146],
            [34.74330542063256, 1.422802649156205],
            [34.743384387037615, 1.422098525937773],
            [34.74251715525896, 1.421139100816196],
            [34.74370139711149, 1.420802170040984],
            [34.744070045042854, 1.419457770991553],
            [34.746653481222374, 1.419207781892231],
            [34.74673623402632, 1.418251636111036],
            [34.746111709969455, 1.41761205546219],
            [34.74633780155343, 1.416983828563774],
            [34.746707385529305, 1.416887539752467],
            [34.74756706517136, 1.418383015780422],
            [34.74807998343567, 1.418606643006213],
            [34.748102917424866, 1.41739052057449],
            [34.74846428720578, 1.416942207974542],
            [34.74894135550372, 1.41706585469107],
            [34.74926803504332, 1.418057690874691],
            [34.75004220764676, 1.416844997771838],
            [34.75216221824252, 1.415919968135591],
            [34.75227196362416, 1.415548210565333],
            [34.750895358333345, 1.414738620949128],
            [34.75019333212529, 1.413696879159991],
            [34.75362902157443, 1.412299692648434],
            [34.754878671559425, 1.40931647651677],
            [34.7563708118739, 1.408600944045895],
            [34.757008982238276, 1.409640408884103],
            [34.758998916780925, 1.409250040152245],
            [34.759293683670045, 1.40841786164057],
            [34.76116697556631, 1.407503089703912],
            [34.76207346102793, 1.405206649341859],
            [34.76387750269729, 1.403504018018887],
            [34.764917550573664, 1.40127865322179],
            [34.76571050694967, 1.401296135495617],
            [34.76708534166111, 1.400495293294993],
            [34.76762972611318, 1.399486077807272],
            [34.7685005062372, 1.39937092838038],
            [34.76913892902816, 1.400107917124049],
            [34.769022275601976, 1.399206059450331],
            [34.76974311163375, 1.39824558495272],
            [34.7707293558145, 1.398680558854316],
            [34.77034896330911, 1.397386044387491],
            [34.77053538978172, 1.396617249506458],
            [34.77188828943053, 1.39671569267437],
            [34.7723539095985, 1.396073288941576],
            [34.77399408508526, 1.395845967677021],
            [34.77413407764083, 1.395312328209978],
            [34.77478433843061, 1.395550603925791],
            [34.775803089048225, 1.395120340609775],
            [34.77593115287513, 1.394803525068316],
            [34.775471366366645, 1.394558970116782],
            [34.77568821069307, 1.394180780011726],
            [34.77672929971688, 1.393357081817306],
            [34.77757288783726, 1.393527588214945],
            [34.77765993907985, 1.392316859882454],
            [34.778585569436814, 1.390751307547248],
            [34.77785332210601, 1.389295949550098],
            [34.77794297037811, 1.386942238771124],
            [34.77678545789685, 1.385860444956514],
            [34.776357059422686, 1.384459114414324],
            [34.77685284591622, 1.382098534104574],
            [34.77764541601668, 1.38004456081949],
            [34.778460371235674, 1.379520087826086],
            [34.77920566749432, 1.378145003703328],
            [34.78062002987487, 1.377104001863922],
            [34.781357567384376, 1.375864566855576],
            [34.782372510941826, 1.370844990879672],
            [34.78300729016598, 1.369847510267272],
            [34.78279842467592, 1.368909487026268],
            [34.787452299718886, 1.363597051413417],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 825,
        District: "AMUDAT",
        County: "POKOT",
        Subcounty: "KARITA",
        Population: 32964,
        Key: "AMUDATKARITA",
        Dist2: "Amudat",
        "Sub Country": "karita",
        id2_original: "Amudatkarita",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.93486367829294, 2.282673916247993],
            [34.931180416744795, 2.282145353070039],
            [34.93040781798974, 2.282358439467999],
            [34.93005726572147, 2.282924337438248],
            [34.929213842891095, 2.282713444864474],
            [34.92703771813277, 2.284200626812343],
            [34.92278876948389, 2.285619930663417],
            [34.92127545767478, 2.283607628051576],
            [34.918113668149076, 2.283611881786866],
            [34.917584868568845, 2.2822343584621],
            [34.91688262317191, 2.282518011668683],
            [34.91551139160309, 2.281671712236236],
            [34.9147019744978, 2.280612613811413],
            [34.9130502071506, 2.280155413885996],
            [34.912133672235875, 2.277788892381015],
            [34.91016223669988, 2.274681640873978],
            [34.90829922602206, 2.273871313861202],
            [34.90759470070092, 2.272423334187165],
            [34.90639903856616, 2.271506087165093],
            [34.90639736859805, 2.270233863491646],
            [34.905587596658236, 2.268892037940076],
            [34.90376120849789, 2.269212513768709],
            [34.90319859543208, 2.268824520533845],
            [34.90186413280616, 2.269215027976659],
            [34.90141113217132, 2.27204280633155],
            [34.89886595074819, 2.273442093835494],
            [34.898129766101476, 2.274644623542702],
            [34.89718104634675, 2.274504519577432],
            [34.89535481718821, 2.274966353847346],
            [34.894791656150076, 2.274154282942575],
            [34.893350439532426, 2.273520074444306],
            [34.89036437574763, 2.273594692608933],
            [34.88983698562412, 2.273277330658074],
            [34.89018783882801, 2.27292346828453],
            [34.88930785726052, 2.271617048739032],
            [34.88751592667786, 2.271442711450991],
            [34.88730100923771, 2.268262391485786],
            [34.888174434001925, 2.264515204500072],
            [34.887365410358726, 2.263738780065445],
            [34.88553300707924, 2.25942969665065],
            [34.88497054672704, 2.259147708479197],
            [34.884197984802896, 2.259396098849756],
            [34.88182388483069, 2.2572611244131],
            [34.8828756593148, 2.255598775774802],
            [34.88245027468842, 2.252630756050691],
            [34.881677668746825, 2.252843800118758],
            [34.880482802519424, 2.252527286365767],
            [34.8789008216934, 2.251681183927387],
            [34.87573997090712, 2.252427424213157],
            [34.87545720191695, 2.251084864101598],
            [34.875035496789955, 2.250979390814337],
            [34.87500144884407, 2.251827594094719],
            [34.874265094415804, 2.25292410039037],
            [34.87387870385927, 2.252959944188291],
            [34.87310477200432, 2.252148120367371],
            [34.872472552978714, 2.252254958852083],
            [34.8722240583099, 2.250240879215104],
            [34.8712415097982, 2.251125653842112],
            [34.86856892121664, 2.249079368614774],
            [34.868498081869966, 2.248620034961292],
            [34.86909449404833, 2.2479831439744],
            [34.868303531033945, 2.247577739239144],
            [34.86796188376507, 2.246906713826541],
            [34.868277615536314, 2.244369737212375],
            [34.86854085155894, 2.243822592664384],
            [34.86927250330673, 2.244493588076521],
            [34.87032171399899, 2.24311562364726],
            [34.86992099621202, 2.242636898472833],
            [34.86913612197859, 2.243229298221772],
            [34.86854921307762, 2.242010588805683],
            [34.86863638828771, 2.241093062284268],
            [34.86942390177145, 2.239928448491588],
            [34.869256397412, 2.235135304289725],
            [34.86837199433667, 2.23675247511771],
            [34.86811205692775, 2.236584361417438],
            [34.86775222416427, 2.234949469354375],
            [34.86666716620057, 2.233823792679889],
            [34.86674233273197, 2.23294196708908],
            [34.86603494268342, 2.232151856690975],
            [34.866051822925904, 2.233630177795525],
            [34.86555091783191, 2.234319275937903],
            [34.86493447232438, 2.234364083948095],
            [34.86476966740235, 2.234124881973905],
            [34.86541355734014, 2.233269560972908],
            [34.86421659534317, 2.230712799327739],
            [34.86388511251177, 2.230639730977013],
            [34.863405043840785, 2.231948832589042],
            [34.862029627919355, 2.232109303469147],
            [34.86178821017833, 2.230498790671721],
            [34.86219684930951, 2.229260882826864],
            [34.86156143767136, 2.228280357627628],
            [34.861354749697554, 2.22684882944759],
            [34.8607143874439, 2.226941210643146],
            [34.860543301501394, 2.228061017556812],
            [34.85942518194199, 2.22896180234296],
            [34.858713279655746, 2.229149221464246],
            [34.85826517214422, 2.228670261938884],
            [34.85741226759605, 2.228594750122021],
            [34.85727172437322, 2.228236448863388],
            [34.85789080823273, 2.227619435258621],
            [34.857496492738775, 2.225757854628903],
            [34.856522445882945, 2.22625399049255],
            [34.855650820444225, 2.22510545689381],
            [34.85486868517412, 2.225101800814425],
            [34.85440548955911, 2.222763030193573],
            [34.8524539723679, 2.22449441306836],
            [34.852136823055176, 2.223884937164577],
            [34.85240239110429, 2.222837092621663],
            [34.85168960307915, 2.223215243788569],
            [34.85105090091216, 2.222949978842411],
            [34.851551928177024, 2.222237039454994],
            [34.85151292063246, 2.220424798939979],
            [34.850047782777104, 2.219488065585602],
            [34.84926355533069, 2.219937398755322],
            [34.84801106487278, 2.219144713233664],
            [34.84722894128077, 2.219141039186686],
            [34.84673421390098, 2.218494957029966],
            [34.84690354363709, 2.217756620291754],
            [34.84776030644941, 2.21699766971411],
            [34.84724199020857, 2.216327644679819],
            [34.847774175539094, 2.211454267525868],
            [34.848869826436605, 2.21029111053849],
            [34.85062842323403, 2.209274125575117],
            [34.84916418908385, 2.208146643011918],
            [34.849784054477674, 2.207362733779755],
            [34.84991932638643, 2.20630242535729],
            [34.84950146964213, 2.204416819240445],
            [34.85072857460843, 2.200464673429213],
            [34.85172487722544, 2.200278608828145],
            [34.85191879834243, 2.199349655294033],
            [34.85073167110123, 2.199797087044339],
            [34.84997558787268, 2.199292831130784],
            [34.85073887109823, 2.198247330951332],
            [34.84888554246252, 2.196700757232025],
            [34.84974761431818, 2.19479737794588],
            [34.84854455365876, 2.19357573906465],
            [34.84739321440015, 2.191424460300091],
            [34.847039154210684, 2.191112834597488],
            [34.84646557810514, 2.192135374088388],
            [34.84546783279379, 2.19263137845601],
            [34.84501862843935, 2.192390835828425],
            [34.844931046292395, 2.190840636691544],
            [34.84584098038641, 2.188842113270404],
            [34.845442731169825, 2.187838835325327],
            [34.84377524420344, 2.187103766137353],
            [34.842574193973626, 2.18545294889989],
            [34.840391097390395, 2.186014886027443],
            [34.84061128704294, 2.184537657562229],
            [34.839361284918354, 2.183220394827571],
            [34.839073981232595, 2.181299673501824],
            [34.83860198122951, 2.180868276595819],
            [34.83765374656505, 2.18091148209079],
            [34.836101538602456, 2.178329111597776],
            [34.832543159946766, 2.179027594427781],
            [34.832309713855594, 2.178263508360295],
            [34.83302339929767, 2.177694650020579],
            [34.83288575673491, 2.176716429296221],
            [34.83181623782896, 2.177355141737192],
            [34.83039822918669, 2.176490085215468],
            [34.83131542705807, 2.17548108986139],
            [34.830323915156505, 2.17464188870321],
            [34.8302826429591, 2.173330322897121],
            [34.8298800638628, 2.173256895357886],
            [34.82971985292516, 2.172040133959783],
            [34.82853963013521, 2.171009291717779],
            [34.82866259063299, 2.170056148487763],
            [34.829996160333515, 2.168703406084282],
            [34.82997412825284, 2.168345649697011],
            [34.82947643014442, 2.168343292410158],
            [34.82972056259424, 2.166818490609153],
            [34.83118253119327, 2.165883610600376],
            [34.83133175034512, 2.164382248192995],
            [34.831001406577464, 2.16407067614387],
            [34.83009478008033, 2.165353912211786],
            [34.829148212689056, 2.165039467805508],
            [34.82910706445914, 2.163704055918984],
            [34.83034885418543, 2.161707116832563],
            [34.83024038890306, 2.159560718145281],
            [34.82981468178149, 2.159367958996004],
            [34.829818358585946, 2.15858115444325],
            [34.827968687890085, 2.15627152274871],
            [34.827688859085804, 2.155292626597345],
            [34.82683688968384, 2.155026311912176],
            [34.82632018591893, 2.154022441487975],
            [34.826259585569865, 2.151780901024924],
            [34.82552734452727, 2.15125287369471],
            [34.82520102790704, 2.150083003076533],
            [34.822703874910594, 2.149391626437681],
            [34.82337070871902, 2.148703331233702],
            [34.82390116838588, 2.14677455432667],
            [34.82478344245397, 2.14563426978688],
            [34.82498030735018, 2.144085392622678],
            [34.82280965962013, 2.142000720164535],
            [34.82256724474912, 2.140628579818223],
            [34.821952505142306, 2.140315700368226],
            [34.82012492312098, 2.140879244921063],
            [34.81866774883059, 2.138273403614908],
            [34.817459945066496, 2.138076909183884],
            [34.81635132608952, 2.136951000968336],
            [34.815647275078845, 2.135469361096296],
            [34.81474690624599, 2.135417382966788],
            [34.81358660808903, 2.132681794207365],
            [34.812024550099366, 2.132221328773583],
            [34.809164953835214, 2.130490979947055],
            [34.808318495597504, 2.129056332684005],
            [34.80825593063289, 2.127243931768553],
            [34.80861569781934, 2.126339598619088],
            [34.806994915162925, 2.123256060193499],
            [34.80392922111809, 2.122514199253061],
            [34.8028110557446, 2.123414915122673],
            [34.8023622196994, 2.123102805092008],
            [34.80164931579162, 2.123504737928531],
            [34.800275848316076, 2.123259744348278],
            [34.79927695765272, 2.123994123514827],
            [34.79857080638093, 2.122965476048122],
            [34.7979311277452, 2.122914733628061],
            [34.79780041119326, 2.120482060610409],
            [34.798099084855544, 2.119970852610439],
            [34.797746178102926, 2.119420761431401],
            [34.798087319620294, 2.117443382135427],
            [34.797995676189934, 2.11677532120942],
            [34.796956722461566, 2.115959671383857],
            [34.79717925761534, 2.114005551669718],
            [34.798318091426886, 2.113748727540659],
            [34.79901394351395, 2.11193994529959],
            [34.79934506791758, 2.112084595207238],
            [34.800153672047536, 2.111492363840174],
            [34.80121915212793, 2.111712063743298],
            [34.80213960459559, 2.112527141270141],
            [34.801623506295186, 2.111404027835883],
            [34.80192544713015, 2.110201376832007],
            [34.80285187069951, 2.109752779566096],
            [34.80195759244429, 2.108413267351279],
            [34.80229186723961, 2.107890297204261],
            [34.802979947102855, 2.10772669360766],
            [34.80330553698601, 2.109039641475178],
            [34.80377897070029, 2.109161127229266],
            [34.804117978718864, 2.107636759470036],
            [34.804854353808395, 2.107282626359531],
            [34.80556308773664, 2.107762894560803],
            [34.80675099291889, 2.107148639876962],
            [34.806946106998595, 2.105981248473359],
            [34.80647346739501, 2.105692867661193],
            [34.807119445915816, 2.104408406679407],
            [34.80772552845824, 2.10404173093377],
            [34.80855263878136, 2.104546398079045],
            [34.80917052069503, 2.104191704095386],
            [34.810115570831805, 2.104816149842139],
            [34.81059113355331, 2.104484614129174],
            [34.81101604297092, 2.104844297513837],
            [34.812296705494475, 2.104659673734512],
            [34.812230337062985, 2.103657933081735],
            [34.813227735624615, 2.103233521832653],
            [34.81287855598209, 2.10189662353389],
            [34.813993893459084, 2.101591984419413],
            [34.81585302251659, 2.099359597164872],
            [34.81595435248061, 2.097977177006958],
            [34.81532089198329, 2.096615073586302],
            [34.81559811657155, 2.095626904809634],
            [34.81668940884334, 2.095393679468137],
            [34.817736795057264, 2.094421117596778],
            [34.817834851560434, 2.093730137997906],
            [34.8187376718957, 2.093257587634059],
            [34.81903096914102, 2.091375356480638],
            [34.819625137327805, 2.091020558068275],
            [34.82012044501928, 2.091523632376465],
            [34.821092448207835, 2.091456752471177],
            [34.821330906, 2.091147932451819],
            [34.820811780377106, 2.090668581998971],
            [34.821077084321516, 2.089692272815773],
            [34.82280329056477, 2.090511200474697],
            [34.82321141226632, 2.089079547029317],
            [34.824375821113996, 2.088417501242111],
            [34.824116933835654, 2.088034776822181],
            [34.82528370884579, 2.086872033913745],
            [34.8273958448098, 2.086262208458217],
            [34.82817701079774, 2.086456691369351],
            [34.827943848574144, 2.085644902961646],
            [34.82668735791826, 2.085734274594826],
            [34.827093495241385, 2.085044756253214],
            [34.82837403649236, 2.08488397898642],
            [34.82913848034127, 2.08360010062041],
            [34.829589996060946, 2.083339983143077],
            [34.829752847147226, 2.083984532687189],
            [34.83177321571341, 2.082730501044259],
            [34.83175211788064, 2.082182008159147],
            [34.8325930317164, 2.082269481306607],
            [34.832363355854476, 2.080718571331648],
            [34.832577998410144, 2.08043348231152],
            [34.83345305810817, 2.08081915849706],
            [34.83530976800262, 2.079087486802945],
            [34.83648091870651, 2.076994894538184],
            [34.838897400295515, 2.077173347019547],
            [34.838852930994, 2.076553211026919],
            [34.837928343581105, 2.076620319587473],
            [34.83812265816018, 2.075619848382018],
            [34.838883374000666, 2.075122767600482],
            [34.83937778607181, 2.075816586795241],
            [34.84042209735254, 2.075487778533626],
            [34.84128245432433, 2.073965930292825],
            [34.840843697376634, 2.069016407098724],
            [34.83989800674105, 2.068535028233891],
            [34.840284287703106, 2.067034765534587],
            [34.84106791148164, 2.066704704911097],
            [34.84255516765593, 2.06792781796897],
            [34.84331307895608, 2.068026805294771],
            [34.843693262154, 2.067814038734578],
            [34.843839731562745, 2.066908707073897],
            [34.84519189279641, 2.066629051326902],
            [34.84569338808356, 2.065820790694845],
            [34.84574743162934, 2.06441430703259],
            [34.84640223250458, 2.063761765980088],
            [34.84739745085503, 2.063790361456658],
            [34.84794442604836, 2.063387653825525],
            [34.84794780461215, 2.062672378755214],
            [34.84663083847303, 2.060520220791881],
            [34.847156148098335, 2.059688229921922],
            [34.84847986507684, 2.060409844338821],
            [34.849121413106666, 2.060055268796681],
            [34.849840475864035, 2.058342014813157],
            [34.85105504843383, 2.057084151090757],
            [34.85245301835708, 2.057138527879767],
            [34.85304716228934, 2.056783721789373],
            [34.85269607911676, 2.055852170829535],
            [34.85219515515813, 2.056541219789451],
            [34.851985023941815, 2.055872613200169],
            [34.85070272738278, 2.056414868733197],
            [34.85070621823597, 2.055675758304185],
            [34.851369880093145, 2.055655079826135],
            [34.85135012344508, 2.054820491956132],
            [34.85059449656072, 2.054244643424814],
            [34.851176506050116, 2.053949390844883],
            [34.85125244513269, 2.052924512908708],
            [34.853088013176915, 2.05064437704491],
            [34.85295406089333, 2.048903212075228],
            [34.853523600868286, 2.048739034096108],
            [34.85335343569894, 2.049644247698024],
            [34.85425362127548, 2.049720088818227],
            [34.85370090225421, 2.051338759926068],
            [34.8540789501567, 2.051578991434881],
            [34.854767653450764, 2.051272327194072],
            [34.8558752205005, 2.04758199178218],
            [34.855544697069824, 2.047318139187861],
            [34.85559682720409, 2.046316986133361],
            [34.85505380010639, 2.045885219552546],
            [34.854532558052675, 2.045858881578209],
            [34.85384215963769, 2.046523176007681],
            [34.85353588802475, 2.046140225130237],
            [34.85356668676424, 2.044638263491113],
            [34.85384197278813, 2.044055441215773],
            [34.85576410249313, 2.043516249984779],
            [34.85683423584669, 2.042734562561091],
            [34.857740614408826, 2.041499077235396],
            [34.8567140358718, 2.038084641921004],
            [34.8563522510692, 2.039418110798816],
            [34.85521881613251, 2.038554335910034],
            [34.855014337115975, 2.036693619124295],
            [34.85592174155412, 2.035243542122503],
            [34.85639835440624, 2.032182029757779],
            [34.857353144077315, 2.030732196480672],
            [34.85718974501871, 2.030206867458165],
            [34.85654821495519, 2.030561438824087],
            [34.855814715372865, 2.03031949395858],
            [34.85532349591428, 2.028958099265096],
            [34.85632523603369, 2.027603854924777],
            [34.857272354092224, 2.027775297879035],
            [34.85715793297956, 2.026916407718657],
            [34.85771122512598, 2.025178538781256],
            [34.86121869715282, 2.02514766860535],
            [34.860949517876236, 2.024443019378689],
            [34.861550082067886, 2.02272921930857],
            [34.86207210385925, 2.022588668489518],
            [34.86356222655761, 2.02319188474593],
            [34.86458596462171, 2.02219539043071],
            [34.864854312956616, 2.020575373044648],
            [34.86614086663183, 2.019127136365678],
            [34.866195266808795, 2.01764915476434],
            [34.86570123831828, 2.016883816484413],
            [34.86549710155987, 2.014951575405203],
            [34.86585460139855, 2.014524131239387],
            [34.86882821902509, 2.014621838056829],
            [34.86977961755596, 2.013887280763595],
            [34.8699974140966, 2.012934612129895],
            [34.86963034540351, 2.01038169219391],
            [34.86871383474331, 2.008755995473506],
            [34.86935113823342, 2.007938504619345],
            [34.873068590559626, 2.009945174939062],
            [34.87434316250555, 2.011024199939511],
            [34.87919273463486, 2.012811781369268],
            [34.880959424354685, 2.01506144235333],
            [34.88125005719688, 2.016243034746618],
            [34.8826908489114, 2.017251313100665],
            [34.88341971767842, 2.018470763252564],
            [34.885778399865416, 2.020818605850642],
            [34.88998233663035, 2.021327464089405],
            [34.89289843872252, 2.021055290384487],
            [34.895620793970814, 2.021664352501087],
            [34.89945411549394, 2.017844045522906],
            [34.90136616610144, 2.016911406406945],
            [34.90278505778766, 2.017538076914803],
            [34.90415947657911, 2.017544631448973],
            [34.90712967701429, 2.02087285817907],
            [34.911107161072536, 2.021654763567752],
            [34.913541771562265, 2.022977681217053],
            [34.91819803163236, 2.023035612474852],
            [34.92309788246811, 2.024203336838286],
            [34.92525383196345, 2.024308952292422],
            [34.92903407203645, 2.024195787618731],
            [34.934751888345744, 2.022744766639073],
            [34.94303767633693, 2.021961560927093],
            [34.95274317527785, 2.021614197558243],
            [34.96570524319354, 2.019088790447477],
            [34.9683120337738, 2.019053447527443],
            [34.971910708158184, 2.019738022550214],
            [34.97512635078689, 2.021255218045506],
            [34.97683312287724, 2.023659315334995],
            [34.97682922957882, 2.024493736228439],
            [34.977961632351246, 2.025571925642437],
            [34.977793366220425, 2.027016363559974],
            [34.98085223127249, 2.030498461575852],
            [34.98158761731689, 2.033110893126771],
            [34.98076592113997, 2.049283188077252],
            [34.97313744751017, 2.084603729435033],
            [34.973602776623984, 2.086465524931439],
            [34.97148721448547, 2.09042516144042],
            [34.97162475553863, 2.091427130507401],
            [34.95864212338945, 2.149622620969684],
            [34.94626259766419, 2.208623347111295],
            [34.94185591473288, 2.236819427605712],
            [34.939943109540515, 2.246786462641968],
            [34.94031061481484, 2.246785970743636],
            [34.93486367829294, 2.282673916247993],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 826,
        District: "AMUDAT",
        County: "POKOT",
        Subcounty: "LOROO",
        Population: 32815,
        Key: "AMUDATLOROO",
        Dist2: "Amudat",
        "Sub Country": "loroo",
        id2_original: "Amudatloroo",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32478850622702, 2.201725082552633],
            [34.32338773984827, 2.204858475782944],
            [34.323984038838944, 2.208452755392078],
            [34.32197993606763, 2.20885784146216],
            [34.31872959960433, 2.210384293469366],
            [34.31775042965642, 2.211281370976113],
            [34.31833171690036, 2.213790217674794],
            [34.31816000393382, 2.21474511308121],
            [34.31585274939852, 2.219536224044279],
            [34.317557645806566, 2.230118350609649],
            [34.31905823297968, 2.232770248057288],
            [34.31857476238869, 2.232951476614909],
            [34.29690786216472, 2.240034128133579],
            [34.28856477333652, 2.243245146721821],
            [34.27593930236119, 2.247012257422967],
            [34.273139708168124, 2.246795615720943],
            [34.26910560419586, 2.242346697352485],
            [34.265537271308496, 2.235508225388253],
            [34.257913341357416, 2.241071363020319],
            [34.25640205435097, 2.241145068167618],
            [34.25337839786814, 2.240025507306207],
            [34.24837577617062, 2.239124830737733],
            [34.243624493208124, 2.23757233320276],
            [34.24020126339199, 2.237346744317833],
            [34.237037776948696, 2.235758930284183],
            [34.230791799761384, 2.229904448685762],
            [34.21988043651899, 2.217440608834463],
            [34.21346797096682, 2.211334974824185],
            [34.21146825556733, 2.208155579997753],
            [34.20805378252861, 2.204809910212108],
            [34.20672074373242, 2.202801916408884],
            [34.20582613489716, 2.201970127196623],
            [34.205548246453915, 2.202677613219695],
            [34.20542485656143, 2.202095466335134],
            [34.20621007664621, 2.200938959917646],
            [34.20732232841021, 2.20037837038673],
            [34.20753931556876, 2.199490001623405],
            [34.20917216259944, 2.199586006555275],
            [34.20856840489701, 2.200791033047801],
            [34.209463483551154, 2.200887637527815],
            [34.21022601129354, 2.201592700403882],
            [34.21189315600177, 2.199230939710728],
            [34.213356431649544, 2.199022904880692],
            [34.2138769703224, 2.199606492801002],
            [34.21553285824182, 2.198291102365022],
            [34.21666964658948, 2.198168499854612],
            [34.21676723147711, 2.199190445658007],
            [34.217178535011406, 2.199299610210564],
            [34.21790345658105, 2.198374324779267],
            [34.221578092505865, 2.195791908061143],
            [34.222363185029884, 2.194501566061993],
            [34.22445493372854, 2.193769825962782],
            [34.225983691170626, 2.193760832338336],
            [34.22897967325448, 2.191157050561029],
            [34.2320616402807, 2.191192951513145],
            [34.235802292497404, 2.192166856745063],
            [34.23917338948435, 2.190577183728306],
            [34.240526568509196, 2.190747053978872],
            [34.2416005358724, 2.190376802031757],
            [34.24417788866081, 2.190935523696349],
            [34.24492544777564, 2.19051082160635],
            [34.245585255860234, 2.190859106018203],
            [34.24637313944987, 2.18986665698909],
            [34.2459780127772, 2.188929916968311],
            [34.24656926323594, 2.188594264877251],
            [34.24654830015047, 2.187910289993082],
            [34.246854194471034, 2.187827953885307],
            [34.2476095509625, 2.188613913756821],
            [34.24895545004033, 2.188209230627373],
            [34.2501458076233, 2.188816984180359],
            [34.25141640811736, 2.187803609333556],
            [34.251967684444296, 2.188459777450372],
            [34.25320510027345, 2.188424538008292],
            [34.2538991305771, 2.189046385629418],
            [34.25518354266867, 2.188292913204501],
            [34.256149954742895, 2.189413842593588],
            [34.25816216301302, 2.189008588768483],
            [34.25897868219893, 2.189753447792694],
            [34.25952896049759, 2.189212631303969],
            [34.26103160840595, 2.189259237791075],
            [34.2618063532362, 2.188834507398478],
            [34.262357082489146, 2.188834040615344],
            [34.262724934513145, 2.189668195290901],
            [34.264512414841874, 2.18884589152069],
            [34.26927189582968, 2.188964959811037],
            [34.27348452738825, 2.190717805564881],
            [34.274028467174254, 2.19131007259594],
            [34.27456617983868, 2.191303857209394],
            [34.27592735027634, 2.190284312638733],
            [34.277085163693194, 2.190888492668862],
            [34.27969619521992, 2.18913412917218],
            [34.28102597133501, 2.189841902240147],
            [34.28186738373576, 2.188924774275352],
            [34.28297880725307, 2.188877708175992],
            [34.283258301884025, 2.187425055093275],
            [34.28581974640708, 2.186865362646338],
            [34.28881295269669, 2.183974446996092],
            [34.288943061987496, 2.183178633739092],
            [34.28972773499831, 2.183115302698769],
            [34.289751812542846, 2.182137886213415],
            [34.29029927102982, 2.181429429083826],
            [34.292023574641284, 2.18043801331685],
            [34.29285712229174, 2.179265672411739],
            [34.29367936913591, 2.179446656142634],
            [34.298152225564294, 2.184503837232354],
            [34.303775233678486, 2.189148726016072],
            [34.31801218166225, 2.198526894555465],
            [34.32182044827375, 2.200620453895592],
            [34.32478850622702, 2.201725082552633],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 827,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "NAPAK TOWN COUNCIL",
        Population: 4733,
        Key: "NAPAKNAPAK TOWN COUNCIL",
        Dist2: "Napak",
        "Sub Country": "Matany",
        id2_original: "NapakMatany",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.360564799054245, 2.170295366133996],
              [34.3605662704947, 2.171938303183768],
              [34.35670809438429, 2.177010384718911],
              [34.35021158425074, 2.180025672696732],
              [34.3522053519047, 2.182250237817662],
              [34.351890050426505, 2.183204681232967],
              [34.33042989387193, 2.194270205864471],
              [34.325957176682394, 2.199630645062853],
              [34.32478850622702, 2.201725082552633],
              [34.32182044827375, 2.200620453895592],
              [34.31801218166225, 2.198526894555465],
              [34.303775233678486, 2.189148726016072],
              [34.298152225564294, 2.184503837232354],
              [34.29367936913591, 2.179446656142634],
              [34.29285712229174, 2.179265672411739],
              [34.292023574641284, 2.18043801331685],
              [34.29029927102982, 2.181429429083826],
              [34.289751812542846, 2.182137886213415],
              [34.28972773499831, 2.183115302698769],
              [34.288943061987496, 2.183178633739092],
              [34.28881295269669, 2.183974446996092],
              [34.28581974640708, 2.186865362646338],
              [34.283258301884025, 2.187425055093275],
              [34.28297880725307, 2.188877708175992],
              [34.28186738373576, 2.188924774275352],
              [34.28102597133501, 2.189841902240147],
              [34.27969619521992, 2.18913412917218],
              [34.277085163693194, 2.190888492668862],
              [34.27592735027634, 2.190284312638733],
              [34.27456617983868, 2.191303857209394],
              [34.274028467174254, 2.19131007259594],
              [34.27348452738825, 2.190717805564881],
              [34.26927189582968, 2.188964959811037],
              [34.264512414841874, 2.18884589152069],
              [34.262724934513145, 2.189668195290901],
              [34.262357082489146, 2.188834040615344],
              [34.2618063532362, 2.188834507398478],
              [34.26103160840595, 2.189259237791075],
              [34.25952896049759, 2.189212631303969],
              [34.25897868219893, 2.189753447792694],
              [34.25816216301302, 2.189008588768483],
              [34.256149954742895, 2.189413842593588],
              [34.25518354266867, 2.188292913204501],
              [34.2538991305771, 2.189046385629418],
              [34.25320510027345, 2.188424538008292],
              [34.251967684444296, 2.188459777450372],
              [34.25141640811736, 2.187803609333556],
              [34.2501458076233, 2.188816984180359],
              [34.24895545004033, 2.188209230627373],
              [34.2476095509625, 2.188613913756821],
              [34.246854194471034, 2.187827953885307],
              [34.24654830015047, 2.187910289993082],
              [34.24656926323594, 2.188594264877251],
              [34.2459780127772, 2.188929916968311],
              [34.24637313944987, 2.18986665698909],
              [34.245585255860234, 2.190859106018203],
              [34.24492544777564, 2.19051082160635],
              [34.24417788866081, 2.190935523696349],
              [34.2416005358724, 2.190376802031757],
              [34.240526568509196, 2.190747053978872],
              [34.23917338948435, 2.190577183728306],
              [34.235802292497404, 2.192166856745063],
              [34.2320616402807, 2.191192951513145],
              [34.23516678653619, 2.180184150976643],
              [34.23516577413486, 2.178943563040373],
              [34.235822798340415, 2.178115959862608],
              [34.2346716890505, 2.177951498418802],
              [34.234012777484544, 2.176463333834242],
              [34.23351943530691, 2.176381034801694],
              [34.233598822123504, 2.172907316020864],
              [34.23573532938117, 2.171664968050652],
              [34.236018851159585, 2.169735820823234],
              [34.24239644501077, 2.165231939876382],
              [34.250757880132035, 2.162514185688539],
              [34.25324466836677, 2.160717124410525],
              [34.25491900947874, 2.15988540079631],
              [34.255927158179375, 2.15987353619838],
              [34.27055627558185, 2.149290181044444],
              [34.277899888045205, 2.145940630954835],
              [34.288393793395244, 2.144875964163252],
              [34.29206799273883, 2.146104609322131],
              [34.30274211630453, 2.151374456659953],
              [34.304958471214526, 2.151206040717745],
              [34.30932540549116, 2.151624663978606],
              [34.310838862827325, 2.153904262738767],
              [34.31084052650725, 2.155847256156251],
              [34.309665124975425, 2.156101709661144],
              [34.309665414232924, 2.156439622147893],
              [34.311683806505464, 2.159985949602047],
              [34.31171424412225, 2.160823046652895],
              [34.312605262391315, 2.161093591071426],
              [34.31456376308553, 2.160391432050897],
              [34.31462712126251, 2.159661854951099],
              [34.31516043667365, 2.159790129427758],
              [34.31539473346945, 2.159425164383646],
              [34.31562816159432, 2.158051743456089],
              [34.31652374330504, 2.157814940428165],
              [34.31714166923616, 2.157127793569173],
              [34.3188696218043, 2.157555416224235],
              [34.319978111423865, 2.156889295579703],
              [34.32065951949949, 2.155622768051537],
              [34.3218113869675, 2.155793412443741],
              [34.324795168133164, 2.153301852506293],
              [34.32517933266442, 2.15360190592786],
              [34.32549877088449, 2.153043759334373],
              [34.32665028082301, 2.152806729311744],
              [34.32886727982509, 2.151517399061415],
              [34.33183188914598, 2.151536253076532],
              [34.33294139116686, 2.152050229794815],
              [34.33563283089465, 2.152330222076066],
              [34.3372492306708, 2.150988660675548],
              [34.338771478920364, 2.150795869022137],
              [34.34181321040499, 2.147251399030837],
              [34.344227246779795, 2.145698234363533],
              [34.36035033885659, 2.157279950999319],
              [34.36096295125278, 2.161828231273283],
              [34.361649816593754, 2.162898354855429],
              [34.36223980491953, 2.16534763477863],
              [34.361571359533485, 2.169065197420998],
              [34.360564799054245, 2.170295366133996],
            ],
          ],
          [
            [
              [34.31857476238869, 2.232951476614909],
              [34.32159183691542, 2.237954509145912],
              [34.3236437632975, 2.240476223733201],
              [34.33430114585959, 2.248774754736455],
              [34.340172435741934, 2.252048908964305],
              [34.371994829778735, 2.266052996461586],
              [34.37174605393719, 2.266618824531217],
              [34.37235274913063, 2.266448672207917],
              [34.387573640709704, 2.273648979049151],
              [34.37931458208978, 2.273656948911313],
              [34.37083877077161, 2.274320984852404],
              [34.36811056749078, 2.27490147569053],
              [34.36781689295307, 2.275576060632467],
              [34.35801620582968, 2.275207738372192],
              [34.3486717263267, 2.276747026035447],
              [34.34563008108033, 2.278061713265148],
              [34.337227714223125, 2.284916744782433],
              [34.336252130349834, 2.286436505537794],
              [34.33429806463818, 2.286348992217597],
              [34.329591888781046, 2.287604207402198],
              [34.32666501768526, 2.292074147483848],
              [34.32524401046654, 2.292164817301466],
              [34.32426758666847, 2.292791136677521],
              [34.317608096091256, 2.294852249272412],
              [34.31645345372732, 2.294853320103017],
              [34.315388366210726, 2.295658408584637],
              [34.31378979260304, 2.295838578194374],
              [34.31183651291725, 2.296644487419214],
              [34.31112677826577, 2.297538591001786],
              [34.3087296418964, 2.298612943170098],
              [34.3062447401238, 2.300848858621134],
              [34.30535622096782, 2.300492297707627],
              [34.30358056426485, 2.301298037353137],
              [34.30215920849983, 2.301031309251995],
              [34.3010937805217, 2.301479014082676],
              [34.30011822449619, 2.30308812306374],
              [34.299585549583846, 2.303356647754079],
              [34.296654739375555, 2.303627372385197],
              [34.294613093313586, 2.304969423058315],
              [34.29372497390793, 2.30505958132901],
              [34.29061570618192, 2.304437003100688],
              [34.2882165162638, 2.303277696678538],
              [34.28608491290927, 2.303368981531114],
              [34.28208624028845, 2.301407002176882],
              [34.28048755618802, 2.301497793474465],
              [34.2777355601286, 2.303108507324618],
              [34.276047253807185, 2.302305915653524],
              [34.27533724606789, 2.302931977461639],
              [34.274182578551134, 2.302933017768148],
              [34.273739349789956, 2.303916223777452],
              [34.269032166023074, 2.304277839054986],
              [34.26761237781818, 2.305797999297038],
              [34.26521436738807, 2.30597884081661],
              [34.2645043515639, 2.306604900112072],
              [34.26326496393272, 2.311252024901388],
              [34.259004130572634, 2.314204274189101],
              [34.25349945214091, 2.316800239655147],
              [34.25012624860463, 2.319126260530644],
              [34.24834909261343, 2.318323717406901],
              [34.24629086185468, 2.316683362937207],
              [34.24581191428114, 2.317812403674615],
              [34.24503249282154, 2.318356210700881],
              [34.24455223909759, 2.317994557720682],
              [34.24395353262196, 2.31938305351799],
              [34.23999573334658, 2.321317637279791],
              [34.2374184820678, 2.324095848867835],
              [34.23453236843476, 2.32488321250127],
              [34.23195210061326, 2.32300752275522],
              [34.22725550169538, 2.31802374792707],
              [34.22472959542328, 2.313120673425777],
              [34.21475673719255, 2.298104059312005],
              [34.192805976525335, 2.274887730629826],
              [34.18327455761171, 2.263332705612819],
              [34.17120310731648, 2.252026715273689],
              [34.167457615875335, 2.24543831769933],
              [34.137727033419246, 2.21537124404713],
              [34.13854422274836, 2.214641055463604],
              [34.145087128171404, 2.216573099830519],
              [34.14888158138881, 2.216399218265611],
              [34.15301709976677, 2.217848818039525],
              [34.154234519995995, 2.21753450583929],
              [34.15542483895142, 2.21878699673808],
              [34.1570388177679, 2.218614804795408],
              [34.15783222509818, 2.219269379486045],
              [34.16055139402217, 2.220121840650493],
              [34.16191169219568, 2.22145964826281],
              [34.16270467911439, 2.22157296814902],
              [34.16358364468729, 2.222996614792089],
              [34.165481918731615, 2.224248529264627],
              [34.16576574593721, 2.225074421958834],
              [34.16726607080224, 2.224418030328275],
              [34.171740677148804, 2.224927220993174],
              [34.17375006111568, 2.223444300624583],
              [34.17219097834624, 2.221739317008278],
              [34.17297881881671, 2.220906973798488],
              [34.1733697207126, 2.221515045227333],
              [34.174456109081234, 2.221050846714445],
              [34.1748001018513, 2.220043001738365],
              [34.173873541738004, 2.21970489712602],
              [34.17391139854072, 2.219173494315314],
              [34.17492167265532, 2.218887748049732],
              [34.17560192280253, 2.217531821888025],
              [34.176536855214266, 2.218778640590584],
              [34.17708742007551, 2.218000395716714],
              [34.17811123359806, 2.217845996749564],
              [34.1790676546097, 2.216653441582122],
              [34.1781598423364, 2.216052793460933],
              [34.17823190429019, 2.21498314677276],
              [34.17940050647363, 2.215309522951194],
              [34.18025410092794, 2.213740803224001],
              [34.18213616307634, 2.21200350484246],
              [34.18267075229853, 2.211923621535801],
              [34.183552169373854, 2.212497434420274],
              [34.18411685036144, 2.212056921954114],
              [34.185408596298984, 2.212281486005458],
              [34.186850918742756, 2.213727681451442],
              [34.186715684563254, 2.214385689100235],
              [34.18599833668974, 2.214586734517224],
              [34.186315883057844, 2.215363096133741],
              [34.187282610440754, 2.214978094831766],
              [34.18734850276515, 2.216081655390633],
              [34.188218189639464, 2.216293500124086],
              [34.18938688075611, 2.214412327597106],
              [34.19103587680067, 2.21360167813908],
              [34.19031951437904, 2.212040850502277],
              [34.19074925583454, 2.210846967531674],
              [34.19280938742845, 2.210613582986302],
              [34.19437282523039, 2.209895748173619],
              [34.19568989287917, 2.210654945650206],
              [34.19627095913753, 2.209494026769165],
              [34.19766357600001, 2.209402587013838],
              [34.198458828469896, 2.208004036322378],
              [34.19859917316503, 2.205189295759448],
              [34.19933130012159, 2.205089328063557],
              [34.20035231269713, 2.205619794286144],
              [34.20065152445028, 2.207477042157635],
              [34.2011771808253, 2.207860734839293],
              [34.20168103419006, 2.207169522960821],
              [34.20248030931579, 2.207089897019334],
              [34.204276037975475, 2.203627835417033],
              [34.205589028171175, 2.203003651892128],
              [34.205548246453915, 2.202677613219695],
              [34.20582613489716, 2.201970127196623],
              [34.20672074373242, 2.202801916408884],
              [34.20805378252861, 2.204809910212108],
              [34.21146825556733, 2.208155579997753],
              [34.21346797096682, 2.211334974824185],
              [34.21988043651899, 2.217440608834463],
              [34.230791799761384, 2.229904448685762],
              [34.237037776948696, 2.235758930284183],
              [34.24020126339199, 2.237346744317833],
              [34.243624493208124, 2.23757233320276],
              [34.24837577617062, 2.239124830737733],
              [34.25337839786814, 2.240025507306207],
              [34.25640205435097, 2.241145068167618],
              [34.257913341357416, 2.241071363020319],
              [34.265537271308496, 2.235508225388253],
              [34.26910560419586, 2.242346697352485],
              [34.273139708168124, 2.246795615720943],
              [34.27593930236119, 2.247012257422967],
              [34.28856477333652, 2.243245146721821],
              [34.29690786216472, 2.240034128133579],
              [34.31857476238869, 2.232951476614909],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 828,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "LORENGECORA",
        Population: 10188,
        Key: "NAPAKLORENGECORA",
        Dist2: "Napak",
        "Sub Country": "Lorengecora",
        id2_original: "NapakLorengecora",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.205548246453915, 2.202677613219695],
            [34.205589028171175, 2.203003651892128],
            [34.204276037975475, 2.203627835417033],
            [34.20248030931579, 2.207089897019334],
            [34.20168103419006, 2.207169522960821],
            [34.2011771808253, 2.207860734839293],
            [34.20065152445028, 2.207477042157635],
            [34.20035231269713, 2.205619794286144],
            [34.19933130012159, 2.205089328063557],
            [34.19859917316503, 2.205189295759448],
            [34.198458828469896, 2.208004036322378],
            [34.19766357600001, 2.209402587013838],
            [34.19627095913753, 2.209494026769165],
            [34.19568989287917, 2.210654945650206],
            [34.19437282523039, 2.209895748173619],
            [34.19280938742845, 2.210613582986302],
            [34.19074925583454, 2.210846967531674],
            [34.19031951437904, 2.212040850502277],
            [34.19103587680067, 2.21360167813908],
            [34.18938688075611, 2.214412327597106],
            [34.188218189639464, 2.216293500124086],
            [34.18734850276515, 2.216081655390633],
            [34.187282610440754, 2.214978094831766],
            [34.186315883057844, 2.215363096133741],
            [34.18599833668974, 2.214586734517224],
            [34.186715684563254, 2.214385689100235],
            [34.186850918742756, 2.213727681451442],
            [34.185408596298984, 2.212281486005458],
            [34.18411685036144, 2.212056921954114],
            [34.183552169373854, 2.212497434420274],
            [34.18267075229853, 2.211923621535801],
            [34.18213616307634, 2.21200350484246],
            [34.18025410092794, 2.213740803224001],
            [34.17940050647363, 2.215309522951194],
            [34.17823190429019, 2.21498314677276],
            [34.1781598423364, 2.216052793460933],
            [34.1790676546097, 2.216653441582122],
            [34.17811123359806, 2.217845996749564],
            [34.17708742007551, 2.218000395716714],
            [34.176536855214266, 2.218778640590584],
            [34.17560192280253, 2.217531821888025],
            [34.17492167265532, 2.218887748049732],
            [34.17391139854072, 2.219173494315314],
            [34.173873541738004, 2.21970489712602],
            [34.1748001018513, 2.220043001738365],
            [34.174456109081234, 2.221050846714445],
            [34.1733697207126, 2.221515045227333],
            [34.17297881881671, 2.220906973798488],
            [34.17219097834624, 2.221739317008278],
            [34.17375006111568, 2.223444300624583],
            [34.171740677148804, 2.224927220993174],
            [34.16726607080224, 2.224418030328275],
            [34.16576574593721, 2.225074421958834],
            [34.165481918731615, 2.224248529264627],
            [34.16358364468729, 2.222996614792089],
            [34.16270467911439, 2.22157296814902],
            [34.16191169219568, 2.22145964826281],
            [34.16055139402217, 2.220121840650493],
            [34.15783222509818, 2.219269379486045],
            [34.1570388177679, 2.218614804795408],
            [34.15542483895142, 2.21878699673808],
            [34.154234519995995, 2.21753450583929],
            [34.15301709976677, 2.217848818039525],
            [34.14888158138881, 2.216399218265611],
            [34.145087128171404, 2.216573099830519],
            [34.13854422274836, 2.214641055463604],
            [34.137727033419246, 2.21537124404713],
            [34.13579752135922, 2.21510585292117],
            [34.133939352600756, 2.213639451037637],
            [34.133407240033804, 2.211638261654618],
            [34.13241174679887, 2.210805017812253],
            [34.13207943122919, 2.209871200215965],
            [34.131150842719975, 2.209805194420868],
            [34.131415339079, 2.208737473169676],
            [34.1312157585757, 2.207936980195738],
            [34.130087652445255, 2.207137207602629],
            [34.13021943799237, 2.206002859990056],
            [34.12975482573418, 2.205536169231785],
            [34.129290659938654, 2.205669970214176],
            [34.12822859345636, 2.204469815626771],
            [34.12855955526489, 2.203602207481746],
            [34.12816136713374, 2.203268911430566],
            [34.126835457367655, 2.204003841610644],
            [34.126038820593905, 2.203003645608562],
            [34.12610438952481, 2.202002793648903],
            [34.12424683790895, 2.201336994280965],
            [34.12557204788743, 2.199667992828646],
            [34.12497398819882, 2.19813387912499],
            [34.12192138799758, 2.195800974383508],
            [34.120593088712816, 2.193333340233862],
            [34.11973044103705, 2.192733496876276],
            [34.118006346733075, 2.193135124953264],
            [34.117674483914286, 2.192801772705442],
            [34.11807173510259, 2.191867377407943],
            [34.117076337987385, 2.191134213231903],
            [34.11700957250055, 2.19053376845934],
            [34.115682612603855, 2.189867560034285],
            [34.11422385997357, 2.190335700921784],
            [34.11216771420458, 2.190137075014076],
            [34.11097517012218, 2.19187269692945],
            [34.11004664629169, 2.191873389921478],
            [34.109384301364734, 2.193074867014431],
            [34.10719687310517, 2.19474450329717],
            [34.10434433400588, 2.193879264696821],
            [34.1012275267197, 2.194415347054557],
            [34.09910474392292, 2.193816430512753],
            [34.09777866707017, 2.194351171794139],
            [34.095603151369616, 2.196555373896955],
            [34.09455029621223, 2.196489609878607],
            [34.09457175426943, 2.195680008992729],
            [34.09333666597516, 2.195154135233255],
            [34.09325914136615, 2.194666222278938],
            [34.09211459516773, 2.195154409018374],
            [34.09145225113906, 2.194874756812709],
            [34.09106879807351, 2.195173853146239],
            [34.09113738264883, 2.195883487788575],
            [34.09031438930464, 2.195940120880945],
            [34.08965895511715, 2.19665651270743],
            [34.08884179183919, 2.196221341091275],
            [34.08783127517943, 2.196845924218062],
            [34.087424200015164, 2.195843773707826],
            [34.15136815133292, 2.156302428945829],
            [34.21197248263125, 2.118646701700615],
            [34.22305789625657, 1.983577200477745],
            [34.22293035524913, 1.901085069036773],
            [34.2227803240203, 1.880048403776879],
            [34.24988649723846, 1.891019851318985],
            [34.308958971906975, 1.92439504605623],
            [34.395660592900946, 1.989995569085835],
            [34.41150240719091, 2.008065728504179],
            [34.43367994755161, 2.03226676212248],
            [34.433758880719004, 2.03317318259682],
            [34.438767103412296, 2.036675361627324],
            [34.43970904358156, 2.03845488262364],
            [34.44721027983454, 2.04738999713772],
            [34.461811898907875, 2.066771086726878],
            [34.43794924393998, 2.089144311114076],
            [34.4237263986079, 2.101006030349647],
            [34.41851106124098, 2.105909147215787],
            [34.4138220620704, 2.110811786334668],
            [34.40994477699727, 2.116000546483369],
            [34.405083260867954, 2.124213063988088],
            [34.385377102634834, 2.136565271367982],
            [34.383450123823934, 2.140009144174076],
            [34.382544612136066, 2.143718781951102],
            [34.38126578037907, 2.150722979899811],
            [34.38105606687937, 2.155679165668452],
            [34.37998978999332, 2.160851608026454],
            [34.37710270348482, 2.16581024822974],
            [34.37405870465242, 2.168652916530072],
            [34.3689792239975, 2.168883798618451],
            [34.360564799054245, 2.170295366133996],
            [34.361571359533485, 2.169065197420998],
            [34.36223980491953, 2.16534763477863],
            [34.361649816593754, 2.162898354855429],
            [34.36096295125278, 2.161828231273283],
            [34.36035033885659, 2.157279950999319],
            [34.344227246779795, 2.145698234363533],
            [34.34181321040499, 2.147251399030837],
            [34.338771478920364, 2.150795869022137],
            [34.3372492306708, 2.150988660675548],
            [34.33563283089465, 2.152330222076066],
            [34.33294139116686, 2.152050229794815],
            [34.33183188914598, 2.151536253076532],
            [34.32886727982509, 2.151517399061415],
            [34.32665028082301, 2.152806729311744],
            [34.32549877088449, 2.153043759334373],
            [34.32517933266442, 2.15360190592786],
            [34.324795168133164, 2.153301852506293],
            [34.3218113869675, 2.155793412443741],
            [34.32065951949949, 2.155622768051537],
            [34.319978111423865, 2.156889295579703],
            [34.3188696218043, 2.157555416224235],
            [34.31714166923616, 2.157127793569173],
            [34.31652374330504, 2.157814940428165],
            [34.31562816159432, 2.158051743456089],
            [34.31539473346945, 2.159425164383646],
            [34.31516043667365, 2.159790129427758],
            [34.31462712126251, 2.159661854951099],
            [34.31456376308553, 2.160391432050897],
            [34.312605262391315, 2.161093591071426],
            [34.31171424412225, 2.160823046652895],
            [34.311683806505464, 2.159985949602047],
            [34.309665414232924, 2.156439622147893],
            [34.309665124975425, 2.156101709661144],
            [34.31084052650725, 2.155847256156251],
            [34.310838862827325, 2.153904262738767],
            [34.30932540549116, 2.151624663978606],
            [34.304958471214526, 2.151206040717745],
            [34.30274211630453, 2.151374456659953],
            [34.29206799273883, 2.146104609322131],
            [34.288393793395244, 2.144875964163252],
            [34.277899888045205, 2.145940630954835],
            [34.27055627558185, 2.149290181044444],
            [34.255927158179375, 2.15987353619838],
            [34.25491900947874, 2.15988540079631],
            [34.25324466836677, 2.160717124410525],
            [34.250757880132035, 2.162514185688539],
            [34.24239644501077, 2.165231939876382],
            [34.236018851159585, 2.169735820823234],
            [34.23573532938117, 2.171664968050652],
            [34.233598822123504, 2.172907316020864],
            [34.23351943530691, 2.176381034801694],
            [34.234012777484544, 2.176463333834242],
            [34.2346716890505, 2.177951498418802],
            [34.235822798340415, 2.178115959862608],
            [34.23516577413486, 2.178943563040373],
            [34.23516678653619, 2.180184150976643],
            [34.2320616402807, 2.191192951513145],
            [34.22897967325448, 2.191157050561029],
            [34.225983691170626, 2.193760832338336],
            [34.22445493372854, 2.193769825962782],
            [34.222363185029884, 2.194501566061993],
            [34.221578092505865, 2.195791908061143],
            [34.21790345658105, 2.198374324779267],
            [34.217178535011406, 2.199299610210564],
            [34.21676723147711, 2.199190445658007],
            [34.21666964658948, 2.198168499854612],
            [34.21553285824182, 2.198291102365022],
            [34.2138769703224, 2.199606492801002],
            [34.213356431649544, 2.199022904880692],
            [34.21189315600177, 2.199230939710728],
            [34.21022601129354, 2.201592700403882],
            [34.209463483551154, 2.200887637527815],
            [34.20856840489701, 2.200791033047801],
            [34.20917216259944, 2.199586006555275],
            [34.20753931556876, 2.199490001623405],
            [34.20732232841021, 2.20037837038673],
            [34.20621007664621, 2.200938959917646],
            [34.20542485656143, 2.202095466335134],
            [34.205548246453915, 2.202677613219695],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 829,
        District: "NAPAK",
        County: "BOKORA",
        Subcounty: "IRIIRI",
        Population: 42297,
        Key: "NAPAKIRIIRI",
        Dist2: "Napak",
        "Sub Country": "Iriiri",
        id2_original: "NapakIriiri",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.932360011370644, 3.188178848504961],
            [30.931609625257654, 3.18824909566275],
            [30.931080089957206, 3.18893515685031],
            [30.92888625042149, 3.187791529341459],
            [30.92669224739236, 3.187714758814522],
            [30.923288484068436, 3.18916348414459],
            [30.922373816751218, 3.189161627511783],
            [30.91632737425311, 3.185745035356295],
            [30.915137459539547, 3.18574261365327],
            [30.912142817742104, 3.192756678554696],
            [30.911718425754124, 3.194395889939875],
            [30.911760129142877, 3.19717549979738],
            [30.909976411856842, 3.195926223611617],
            [30.907479387319448, 3.192810985321788],
            [30.903772590809147, 3.192052982852722],
            [30.90124337244861, 3.191098802289752],
            [30.8939381342176, 3.190378270207676],
            [30.893170225566656, 3.187735254455054],
            [30.89113196884824, 3.189404527077766],
            [30.88590922846507, 3.190994356570437],
            [30.885230360825062, 3.191686307805738],
            [30.883091835951284, 3.192548906800036],
            [30.88098795730136, 3.191187561724486],
            [30.880318769906875, 3.1919339712229],
            [30.879355731006513, 3.191586974601247],
            [30.880045146664575, 3.189603478223757],
            [30.8804032537644, 3.186058127426825],
            [30.880583765729146, 3.183570358092557],
            [30.880173865363343, 3.182169224976008],
            [30.879550212672257, 3.18233181418424],
            [30.879916002164393, 3.18190796712566],
            [30.877527708810675, 3.181604870982712],
            [30.873949954392625, 3.177424450817284],
            [30.874635539634326, 3.175760583454354],
            [30.87464043096106, 3.173370418275603],
            [30.875515300216236, 3.170589672332642],
            [30.876454844578635, 3.170353568937577],
            [30.874912746256282, 3.168874707755417],
            [30.873295549674474, 3.168616678223742],
            [30.8716214870402, 3.167574866192559],
            [30.87109472304243, 3.167828467778279],
            [30.871015558109722, 3.168416052027065],
            [30.86976892826071, 3.168041234204674],
            [30.867525756842817, 3.16889861932411],
            [30.866142536358247, 3.168601880475637],
            [30.8637182367313, 3.166236781791324],
            [30.86478406086645, 3.161048632175632],
            [30.86464607784219, 3.158704139841233],
            [30.863602637028947, 3.156931868171433],
            [30.86175050045762, 3.154966561876556],
            [30.864946937105543, 3.151217649081989],
            [30.86447305333531, 3.150212011837115],
            [30.86221520344569, 3.148819967328603],
            [30.863476056320614, 3.147805786915901],
            [30.86347919144095, 3.146268300526285],
            [30.864223727724845, 3.144199487892546],
            [30.867979968406683, 3.139994183157558],
            [30.866783892148593, 3.139241339065465],
            [30.86637476882548, 3.138083273847415],
            [30.868002242134146, 3.133323659681757],
            [30.871208830643106, 3.134307089833824],
            [30.872500439138392, 3.135271493416721],
            [30.87438105769412, 3.13413546598313],
            [30.875038927214344, 3.133032561617737],
            [30.87709691902123, 3.131807835415663],
            [30.880500216119536, 3.131042938169359],
            [30.883329764635747, 3.127758804240485],
            [30.883923917551176, 3.12419985583926],
            [30.893983933924055, 3.123438717671603],
            [30.90027711398629, 3.124029485208883],
            [30.905269785045427, 3.125168816409587],
            [30.906101800170003, 3.125016708438397],
            [30.908294965969265, 3.123534456913417],
            [30.91113148541209, 3.123344082604541],
            [30.912265821359004, 3.122393944408163],
            [30.915707290568665, 3.121633484844275],
            [30.917749255532573, 3.120455209070599],
            [30.918051929392835, 3.120797157905405],
            [30.918316547024393, 3.120379136806738],
            [30.91945123061932, 3.120530958414952],
            [30.919753679002447, 3.120150922673079],
            [30.92364972449196, 3.121670317629713],
            [30.92474636712957, 3.121138162106105],
            [30.925313744859643, 3.121328069486836],
            [30.92633467838341, 3.120567927580494],
            [30.929020327570903, 3.121631498028359],
            [30.931402777383703, 3.120719134728019],
            [30.932613106312076, 3.120870938347453],
            [30.93350672879716, 3.121527074926141],
            [30.932359035800264, 3.12291784886208],
            [30.933115739764677, 3.123753722931191],
            [30.935460572624955, 3.123449348688062],
            [30.93659553559594, 3.124437156397118],
            [30.93833515278803, 3.12390488297714],
            [30.940226817028506, 3.125652553660729],
            [30.94037822627299, 3.126032533592818],
            [30.939546523762136, 3.127172654649724],
            [30.93977402480279, 3.128920606921377],
            [30.942801560211024, 3.134392076086387],
            [30.944997194580672, 3.140395688662422],
            [30.94689053058588, 3.147235357931196],
            [30.949235733552054, 3.147842982048663],
            [30.950593628732165, 3.149152914880879],
            [30.95250913785353, 3.149686833025949],
            [30.95238036974742, 3.155104977973822],
            [30.95283689626977, 3.155788750604742],
            [30.953516395425407, 3.155745558727851],
            [30.953247632068813, 3.156126336760113],
            [30.953662842376293, 3.156384181936656],
            [30.95360245402961, 3.157052084852319],
            [30.954785643056642, 3.159588634917646],
            [30.955147849169084, 3.159831149470181],
            [30.958354196031216, 3.159184314112067],
            [30.96016729631188, 3.161028675968671],
            [30.960179947286036, 3.162112385621148],
            [30.95892473223783, 3.161991144315146],
            [30.95848573454164, 3.162852261255968],
            [30.960551769863603, 3.16923521636999],
            [30.96177000306817, 3.168259972428803],
            [30.96239894144634, 3.169360615944909],
            [30.962846851328464, 3.169486621836874],
            [30.967204457499168, 3.168504041146868],
            [30.96932974210399, 3.168940113639597],
            [30.972176684699065, 3.17797254837908],
            [30.966291579626002, 3.17953940624523],
            [30.966670062313053, 3.180760744983407],
            [30.968259078744413, 3.181903109350665],
            [30.967655561790473, 3.187064553220232],
            [30.966370192993125, 3.188888362516442],
            [30.96478124932533, 3.188279430558113],
            [30.965084891569465, 3.191245608740305],
            [30.96576641193447, 3.193453063873984],
            [30.965010042143344, 3.19413870272587],
            [30.96258917497911, 3.19375414024996],
            [30.960773949284487, 3.194283959761778],
            [30.960843941519865, 3.194853704457738],
            [30.958353463904253, 3.195273673286223],
            [30.95411711053397, 3.195274236551199],
            [30.95216640092821, 3.195803763779997],
            [30.950712680660125, 3.195050419426489],
            [30.949199940179543, 3.195427117234546],
            [30.948668839115584, 3.190109770888931],
            [30.946398946411268, 3.188739982523805],
            [30.94428081059948, 3.188663399524911],
            [30.943985047478687, 3.189114869065157],
            [30.941708811770166, 3.188820972106431],
            [30.939136266765153, 3.186998505388905],
            [30.938379204372925, 3.18577641524547],
            [30.937849917905837, 3.185775349696176],
            [30.936791077273732, 3.186614051460556],
            [30.93664005879635, 3.188060343189266],
            [30.936186215541763, 3.188285458789932],
            [30.933311757549564, 3.188596100586475],
            [30.93230092108957, 3.187915968744939],
            [30.932360011370644, 3.188178848504961],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 830,
        District: "MARACHA",
        County: "MARACHA",
        Subcounty: "KIJOMORO",
        Population: 30062,
        Key: "MARACHAKIJOMORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.57900360265698, 2.614207248799939],
            [32.57680639623555, 2.62955028130999],
            [32.57356145954543, 2.639622451087777],
            [32.573486666713194, 2.643726021234648],
            [32.572633793606045, 2.646022454552483],
            [32.57175790566129, 2.646402955614653],
            [32.569993585697226, 2.649210774244899],
            [32.57013474157107, 2.651697952310309],
            [32.56938815084011, 2.654613225722581],
            [32.56935189663188, 2.6567790385718],
            [32.56954083838726, 2.657969118435698],
            [32.57207234206189, 2.661206842136137],
            [32.57421394546218, 2.66259990446936],
            [32.57547934650738, 2.665265976900665],
            [32.575489150720365, 2.671180352092578],
            [32.5737203185186, 2.676124603130911],
            [32.574257986267284, 2.677590387389984],
            [32.57519955094076, 2.678289692547685],
            [32.57606030856117, 2.679818712855884],
            [32.578016981183794, 2.680550979348084],
            [32.57812287009792, 2.681905593315153],
            [32.58014213912615, 2.686174992460891],
            [32.5812230378901, 2.687262591474611],
            [32.58143406472675, 2.688229341152493],
            [32.58079573356396, 2.68939712517147],
            [32.580995221540796, 2.690747100029083],
            [32.58031870479189, 2.692202084507867],
            [32.57771898215629, 2.693302168882825],
            [32.57593782866208, 2.695178010364917],
            [32.57402378289632, 2.695866652453413],
            [32.57265152365483, 2.699226569731916],
            [32.571165967093044, 2.699829192611229],
            [32.57050866261313, 2.700748043375785],
            [32.569913488313226, 2.702674256771328],
            [32.56847315563782, 2.704782112293805],
            [32.568435413819465, 2.705626860925271],
            [32.56772297703562, 2.704761697491287],
            [32.56573118657359, 2.703693997726086],
            [32.56226921780914, 2.698669867753001],
            [32.56101832814905, 2.697370914321196],
            [32.55936685095767, 2.696504647582731],
            [32.556585270681005, 2.692557805143164],
            [32.55543360353729, 2.689591336980603],
            [32.55522890892508, 2.68759096929969],
            [32.55631125577324, 2.684308276433289],
            [32.55487426033912, 2.681698674967163],
            [32.551350449753905, 2.679620990921308],
            [32.55064762853686, 2.679816412094346],
            [32.54905857617288, 2.679152685282802],
            [32.548945194411, 2.678605254369629],
            [32.54787802819282, 2.67868337265675],
            [32.547579006882486, 2.677871951189945],
            [32.544456339885706, 2.67609114238336],
            [32.54211406632569, 2.674128638195713],
            [32.53755816424254, 2.672318344592912],
            [32.53745402255163, 2.670238442576608],
            [32.53692985827829, 2.669062670103857],
            [32.536210565552196, 2.668625325881071],
            [32.531358099051076, 2.668322046094994],
            [32.5296342598686, 2.668698170233067],
            [32.5287347525201, 2.669187646334533],
            [32.52783474211506, 2.670995870801834],
            [32.526019498454126, 2.673038732121024],
            [32.52236226828627, 2.675289433761927],
            [32.51906498945948, 2.675959943832424],
            [32.51255923386503, 2.679580571451358],
            [32.507429042413996, 2.679609211630489],
            [32.502847013729124, 2.683353374693144],
            [32.502693422476796, 2.685594786173199],
            [32.50350560459652, 2.686490991041521],
            [32.502930540880875, 2.686922305125642],
            [32.50305883377818, 2.687525501203779],
            [32.502444007034775, 2.689262875345232],
            [32.502900090687696, 2.691575110752713],
            [32.50201438864849, 2.692120447781102],
            [32.50080089136209, 2.69097110549557],
            [32.49891568241525, 2.690955967627778],
            [32.49808798908551, 2.689347244620686],
            [32.49683167000784, 2.688154799322555],
            [32.49620394525361, 2.686503076254915],
            [32.495561343499965, 2.686301762499463],
            [32.49551904093491, 2.684980576221355],
            [32.49392068022798, 2.682050362467026],
            [32.49222162556422, 2.680886451489489],
            [32.49107918861005, 2.680627485004922],
            [32.48882347132094, 2.678687869196029],
            [32.485196223323975, 2.677925234003239],
            [32.4845257019313, 2.676201689640338],
            [32.48314085100445, 2.675066622469072],
            [32.48325556137468, 2.673975272514899],
            [32.481300406006554, 2.670556641956512],
            [32.4775026236327, 2.667869610117263],
            [32.47131929674992, 2.666445265202958],
            [32.46980533815384, 2.666703098645353],
            [32.46664932120211, 2.666213470801304],
            [32.461650762584625, 2.666240001639395],
            [32.456009310260995, 2.666783203508775],
            [32.45579567471675, 2.665447587552324],
            [32.45710609034082, 2.661727119930282],
            [32.45710714765791, 2.659310795110036],
            [32.46037397629152, 2.657053653575024],
            [32.46036714101051, 2.65483948116186],
            [32.45961347425008, 2.651353083199415],
            [32.46067008616199, 2.648399461682286],
            [32.46066359852899, 2.646915245985333],
            [32.45948843594906, 2.64371686278693],
            [32.45794863551717, 2.64278407462125],
            [32.453934266633375, 2.64245965027688],
            [32.44937177271268, 2.640041301075774],
            [32.44685498523904, 2.639373358588994],
            [32.44260539698969, 2.638898222201753],
            [32.440824574075506, 2.6393690790681],
            [32.43909136815957, 2.638242395297813],
            [32.43821551614744, 2.638169358012961],
            [32.436629088660744, 2.636974350551003],
            [32.43341738873784, 2.633645750049913],
            [32.43275078759306, 2.634004493772148],
            [32.43229869695158, 2.63369311305008],
            [32.430253267185634, 2.630412918621592],
            [32.429868721768706, 2.629044035647342],
            [32.42772713094483, 2.627749205792382],
            [32.42733763940392, 2.626984614322375],
            [32.424862434944785, 2.6263758599594],
            [32.42414249902497, 2.623611883937159],
            [32.42353865328762, 2.622729590328635],
            [32.42309159680501, 2.619985339551795],
            [32.42359887005606, 2.618927157502802],
            [32.4227805623244, 2.618162366806026],
            [32.42182655867917, 2.615770688186344],
            [32.423153462880315, 2.612576451801999],
            [32.42424751926821, 2.607049667602809],
            [32.42272768748677, 2.605912150189449],
            [32.419610657418374, 2.602343454207904],
            [32.4160830065353, 2.60163620569301],
            [32.41432986071503, 2.599263752757183],
            [32.41397969292572, 2.597793568699466],
            [32.41168072175563, 2.595577663365503],
            [32.40790865725008, 2.593799701796358],
            [32.40791082937643, 2.592554715575244],
            [32.408427151357344, 2.59190624911379],
            [32.40703439345935, 2.590841728483614],
            [32.406570896908754, 2.588843507291499],
            [32.40526826428829, 2.588155268004295],
            [32.40498492846115, 2.587143155055313],
            [32.40336041060976, 2.585118438547894],
            [32.40017416445044, 2.583279893025061],
            [32.39971563827829, 2.583330913041819],
            [32.3991813158557, 2.582049761957162],
            [32.39951255793863, 2.581844976312926],
            [32.39768001452195, 2.578693103215053],
            [32.39592283257109, 2.57779564073879],
            [32.39577071275921, 2.576284114254101],
            [32.39513397700436, 2.576130104789854],
            [32.39484147386974, 2.575220528190065],
            [32.3931349146801, 2.575014768656096],
            [32.39176023627552, 2.573272102116034],
            [32.39731971373622, 2.569958049990698],
            [32.406556837376215, 2.56756357275153],
            [32.415914678420755, 2.568675063705263],
            [32.421053546699085, 2.566586124896275],
            [32.42319437485329, 2.56652558982381],
            [32.425763033746364, 2.567203348246831],
            [32.4271082698675, 2.568126585600252],
            [32.42924891117211, 2.56849660151575],
            [32.43285845966299, 2.566775973741663],
            [32.435367529710035, 2.563886179802028],
            [32.43732539799029, 2.562595361946962],
            [32.439833487077046, 2.561919871548562],
            [32.444542927411895, 2.562660041476672],
            [32.4457051838962, 2.562414512676983],
            [32.4493329071019, 2.557286243079083],
            [32.44924013179429, 2.555004740170899],
            [32.44865917782535, 2.554325706338533],
            [32.44879070914926, 2.553665835722152],
            [32.450031267285254, 2.552775686734333],
            [32.45036770073221, 2.554636083542186],
            [32.45128397962704, 2.556327267976542],
            [32.451895122379455, 2.556788660020304],
            [32.4540856111992, 2.557097021021345],
            [32.4583381755671, 2.560224245985777],
            [32.45861724259997, 2.562914268889579],
            [32.458336580159155, 2.564015728082471],
            [32.45656509343571, 2.56674330428162],
            [32.45829555050686, 2.570714858653661],
            [32.45868955698035, 2.57264919212117],
            [32.458279934193946, 2.577516465698507],
            [32.459132918692205, 2.578349415660473],
            [32.46160389747625, 2.578068670281096],
            [32.46290190197634, 2.580707899290447],
            [32.47018333485233, 2.589856658069167],
            [32.47373363585698, 2.597582035415971],
            [32.48024878962593, 2.613793612005377],
            [32.4908104333383, 2.615143878473337],
            [32.49565390321189, 2.615373249608522],
            [32.52095744242077, 2.619743817886446],
            [32.54214540405437, 2.620223776888908],
            [32.54669031884326, 2.618119311526902],
            [32.549146602087596, 2.617437784463029],
            [32.55409120249922, 2.616854632151044],
            [32.55741965556129, 2.617213275700862],
            [32.56189630827007, 2.617027102006164],
            [32.57900360265698, 2.614207248799939],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 831,
        District: "OMORO",
        County: "OMORO",
        Subcounty: "OMORO TOWN COUNCIL",
        Population: 18952,
        Key: "OMOROOMORO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.948994322099214, 3.422941242397105],
            [30.948831318299334, 3.423648201454738],
            [30.945517625455707, 3.42555357811437],
            [30.938103439547024, 3.425474048879468],
            [30.938787584789313, 3.406335537250303],
            [30.938589024772178, 3.401306081438693],
            [30.938101523440512, 3.400398624103147],
            [30.92854087334757, 3.392369444979713],
            [30.92594603934374, 3.389510269374346],
            [30.923497646900874, 3.388102959828994],
            [30.92122602583794, 3.387356502611336],
            [30.919592527528675, 3.386141483886744],
            [30.918582455535017, 3.38440028400453],
            [30.917868037965974, 3.381721705785528],
            [30.918164384093348, 3.37682415395081],
            [30.92228816328717, 3.377743414961289],
            [30.924752514301037, 3.380405847382833],
            [30.928155298461334, 3.380402030805203],
            [30.931222383996534, 3.381214490707378],
            [30.93270252012387, 3.38259910813284],
            [30.93337392186553, 3.383949396926816],
            [30.938103020932104, 3.383443300364103],
            [30.939418595580854, 3.389266793528779],
            [30.94082038064911, 3.391208148310296],
            [30.94134300610835, 3.391559071291629],
            [30.942033480880163, 3.390838153280151],
            [30.942819325294053, 3.390719906999939],
            [30.945386674443455, 3.392089266227495],
            [30.948068468960074, 3.396330850214647],
            [30.950635818109475, 3.398535558454732],
            [30.952753023266638, 3.399641725842319],
            [30.954591418309064, 3.399701578379841],
            [30.953596128093384, 3.401311549715777],
            [30.95362210737141, 3.404226207829129],
            [30.952858865468354, 3.40725623993318],
            [30.953787875287397, 3.408348765274585],
            [30.954153565066516, 3.410620855463757],
            [30.957090833263404, 3.410415462556428],
            [30.957233926803326, 3.411847056878986],
            [30.9589546685947, 3.411701570725343],
            [30.959007506601377, 3.412473055456117],
            [30.954646704224903, 3.413114188497386],
            [30.9543075003736, 3.414867123931354],
            [30.952017525831106, 3.416617589292294],
            [30.949849487706988, 3.417363540515074],
            [30.948738303141575, 3.419969201939288],
            [30.948994322099214, 3.422941242397105],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 832,
        District: "KOBOKO",
        County: "KOBOKO MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 11325,
        Key: "KOBOKOWESTERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.973781910331386, 3.414525755029235],
            [30.971729973169538, 3.416016195804079],
            [30.967142267132044, 3.411754222723025],
            [30.964785753478147, 3.410070873727757],
            [30.963219331472843, 3.412283877483738],
            [30.96214368156511, 3.412667284627969],
            [30.961589163218317, 3.413414557997282],
            [30.959986846330864, 3.413472682592691],
            [30.959966291978844, 3.412896017833379],
            [30.95905787693599, 3.412946167014444],
            [30.959007506601377, 3.412473055456117],
            [30.9589546685947, 3.411701570725343],
            [30.957233926803326, 3.411847056878986],
            [30.957090833263404, 3.410415462556428],
            [30.954153565066516, 3.410620855463757],
            [30.953787875287397, 3.408348765274585],
            [30.952858865468354, 3.40725623993318],
            [30.95362210737141, 3.404226207829129],
            [30.953596128093384, 3.401311549715777],
            [30.954591418309064, 3.399701578379841],
            [30.952753023266638, 3.399641725842319],
            [30.950635818109475, 3.398535558454732],
            [30.948068468960074, 3.396330850214647],
            [30.945386674443455, 3.392089266227495],
            [30.942819325294053, 3.390719906999939],
            [30.942033480880163, 3.390838153280151],
            [30.94134300610835, 3.391559071291629],
            [30.94082038064911, 3.391208148310296],
            [30.939418595580854, 3.389266793528779],
            [30.938103020932104, 3.383443300364103],
            [30.939238380958443, 3.382927048740957],
            [30.940549064280496, 3.381326755022921],
            [30.94258863972572, 3.380819003480581],
            [30.94423083282863, 3.379620179989474],
            [30.94556023973615, 3.379645272931257],
            [30.946936492887403, 3.378468140470671],
            [30.949708247391488, 3.377494352066353],
            [30.95199598962049, 3.374871892691556],
            [30.955033162155082, 3.374121295718976],
            [30.9557861929083, 3.374278744900441],
            [30.95616450132221, 3.373500255586126],
            [30.958400277808657, 3.374529185142999],
            [30.960285118446212, 3.373842932111002],
            [30.962189886411753, 3.374225458646566],
            [30.962722970057538, 3.373603146976684],
            [30.963763128426717, 3.374206505666692],
            [30.964850989134096, 3.37318458035221],
            [30.966292258752343, 3.372697768367644],
            [30.967843204581943, 3.372745557570543],
            [30.968418750692898, 3.373013952222036],
            [30.968992629530703, 3.374083904493907],
            [30.97041044952678, 3.374220472672224],
            [30.970496629403563, 3.375400730099452],
            [30.97268785035024, 3.376563137961929],
            [30.972462663369775, 3.378299383897891],
            [30.973501865033143, 3.379370314085307],
            [30.973234489573663, 3.380082253378518],
            [30.972369172104887, 3.380637076719428],
            [30.97254546378444, 3.381105025140641],
            [30.973298371468484, 3.38132926144311],
            [30.972719763000693, 3.382530391056803],
            [30.972784152443648, 3.383532478506038],
            [30.971741427587723, 3.38415372385152],
            [30.97093956351733, 3.386155941241033],
            [30.969233253161022, 3.386219145756881],
            [30.968591646740684, 3.385750216969938],
            [30.96783785601276, 3.385949017758978],
            [30.967108035929844, 3.385279514188928],
            [30.964135236668533, 3.387009951536629],
            [30.962140551834654, 3.387228389906733],
            [30.96107543018204, 3.387960897453861],
            [30.96191538102384, 3.388942355060787],
            [30.96231095865079, 3.390501775207407],
            [30.963838559062793, 3.391128440474576],
            [30.963482023116427, 3.392085102656978],
            [30.963790603399676, 3.392865047698398],
            [30.96257045947848, 3.39355269334813],
            [30.961889420610454, 3.394824161444914],
            [30.96223275132215, 3.394770760641706],
            [30.962646830650684, 3.395833210988706],
            [30.962689704544257, 3.398322505744397],
            [30.964154103984434, 3.399606464450509],
            [30.965567946240434, 3.40206241793533],
            [30.966199557106602, 3.404794635944093],
            [30.969170141122415, 3.4046559288977],
            [30.972817745842, 3.405830489035906],
            [30.974345392966416, 3.407636563444508],
            [30.974985323130404, 3.410137181137912],
            [30.974256953826675, 3.413022540827011],
            [30.974886393464793, 3.413705313653954],
            [30.973781910331386, 3.414525755029235],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 833,
        District: "KOBOKO",
        County: "KOBOKO MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 21118,
        Key: "KOBOKOSOUTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.074791784881416, 2.496315395748014],
            [31.074588769220476, 2.49697562396678],
            [31.074251268574972, 2.49639365809215],
            [31.071282624021833, 2.496354153576164],
            [31.070033281260645, 2.498254817720546],
            [31.070032016432737, 2.49911901989129],
            [31.06801026625768, 2.498963520423614],
            [31.065557545731803, 2.499696999833633],
            [31.063486445708264, 2.498728055355975],
            [31.060756867106743, 2.498673165733007],
            [31.059341268644385, 2.498823566758641],
            [31.05731721249398, 2.500243939068657],
            [31.05645772958296, 2.500344328056391],
            [31.046605065038907, 2.497381185347094],
            [31.045442522890397, 2.497328610222622],
            [31.042736499013934, 2.498455628301207],
            [31.03944839288454, 2.500102817047023],
            [31.031791458829897, 2.50777998337126],
            [31.028847749712416, 2.511492780672636],
            [31.026820263794264, 2.515175181563686],
            [31.02183865189462, 2.52215978010968],
            [31.01737540743974, 2.521342215475495],
            [31.012650267248645, 2.52115057492177],
            [31.009742373063247, 2.519525283479371],
            [30.999935501039136, 2.520156800542884],
            [30.991089061902702, 2.520100331416363],
            [30.9909906146324, 2.518579935924595],
            [30.989086435961728, 2.51459454033827],
            [30.989870939190915, 2.514176932426474],
            [30.99028865220478, 2.512733156238011],
            [30.99009826416177, 2.512155805779933],
            [30.989261228353087, 2.512426777907439],
            [30.988796264853598, 2.51213041686392],
            [30.988505864675076, 2.509814113709415],
            [30.989582972548497, 2.510271560966687],
            [30.98944802672819, 2.506004017524042],
            [30.990068970100356, 2.504354314337007],
            [30.989555461642922, 2.503563616518104],
            [30.989340356454882, 2.501921975722156],
            [30.989792154245546, 2.498708142487673],
            [30.98936338117392, 2.495258999932901],
            [30.98909265679506, 2.494469701166306],
            [30.987988583293433, 2.493893327180907],
            [30.986962912953175, 2.492289585038139],
            [30.98542886353574, 2.491879364240015],
            [30.98433407591921, 2.489427110164246],
            [30.984277456005156, 2.488160426615095],
            [30.98365573379364, 2.486772810557634],
            [30.98387515987822, 2.482651172731254],
            [30.983334130633736, 2.481263757302741],
            [30.983409699610366, 2.478969854577489],
            [30.982922773200503, 2.477725962262412],
            [30.982842091911564, 2.471715705408018],
            [30.982231967848705, 2.469503677712677],
            [30.980693346904808, 2.467038348026418],
            [30.981094278490826, 2.465916222265043],
            [30.980446242828023, 2.46479141118198],
            [30.979726872846815, 2.461838307060606],
            [30.980552193725888, 2.458064733994148],
            [30.97929890825891, 2.456902519692973],
            [30.979078795861483, 2.454703452295604],
            [30.979881929251377, 2.453032732294574],
            [30.980849294438123, 2.452628972972521],
            [30.98040380461735, 2.451875080061053],
            [30.97993764905351, 2.44790701761876],
            [30.97722815588342, 2.445044406759685],
            [30.978733370278558, 2.444618122324501],
            [30.97911942576347, 2.443362977426804],
            [30.979776630530377, 2.442221568760114],
            [30.98533227038818, 2.440130644959943],
            [30.990427304473943, 2.438962695325878],
            [30.99205461518754, 2.439552953226337],
            [30.996687940370066, 2.440063748843037],
            [30.997987184545277, 2.441599441815284],
            [31.001863393436686, 2.44099520983831],
            [31.00378519615492, 2.440074371662305],
            [31.00596132899808, 2.436550717960385],
            [31.008350073306072, 2.435477952685599],
            [31.012006737535323, 2.431346434598888],
            [31.01271340354178, 2.428128078919208],
            [31.012283983683147, 2.427133811198572],
            [31.012415239224243, 2.421510274902259],
            [31.010233853033295, 2.419389104189737],
            [31.009493139080945, 2.417856415969781],
            [31.0068811427636, 2.414585922837045],
            [31.006923532465233, 2.412049331703496],
            [31.00545854193357, 2.405394387855785],
            [31.007371132428563, 2.39828984590297],
            [31.008761685860847, 2.397657768539394],
            [31.011088465278853, 2.395292110224421],
            [31.010997910606612, 2.391762185941842],
            [31.01232366047261, 2.388557441141509],
            [31.01246389108171, 2.387337180104038],
            [31.015031731609557, 2.386503426720268],
            [31.015749739744802, 2.385860317688309],
            [31.01942811445784, 2.395484051573996],
            [31.02413783057551, 2.400648187780793],
            [31.02482821641407, 2.40084066420243],
            [31.025783095018355, 2.402373670456703],
            [31.027045846931774, 2.403213136802746],
            [31.027468037149003, 2.40602565925359],
            [31.029062606965457, 2.406243415453344],
            [31.028446119237092, 2.407271531486574],
            [31.029283077790694, 2.409306916296585],
            [31.02916683219966, 2.410622950976582],
            [31.028549154203574, 2.411076717428828],
            [31.029589066434344, 2.413459408409656],
            [31.029282522631853, 2.414799087762508],
            [31.029476176050906, 2.416402756836619],
            [31.031424126032118, 2.420677364517732],
            [31.03406928365818, 2.428446963734546],
            [31.03421692087682, 2.430816364407748],
            [31.03496944138695, 2.432289256869089],
            [31.034663276673495, 2.433820387716923],
            [31.035329444830303, 2.433797457362833],
            [31.035732358998185, 2.433032266851742],
            [31.036113842058306, 2.433415737677921],
            [31.036307882651244, 2.43521086359274],
            [31.037309868010723, 2.436504650021492],
            [31.037040203643905, 2.438430702091901],
            [31.0386157462443, 2.4409458419434],
            [31.03985024075216, 2.445386931235722],
            [31.040046730152547, 2.448378624518204],
            [31.04134990086387, 2.451503609500383],
            [31.04092499593785, 2.45315422041049],
            [31.041767188974607, 2.454987252377099],
            [31.042025645061642, 2.456147282059272],
            [31.042358515790173, 2.45602812858714],
            [31.04268059236224, 2.456447410763844],
            [31.04244564249126, 2.457906860333004],
            [31.043568519528392, 2.460134160995656],
            [31.04404871126858, 2.462240834939297],
            [31.045204954430343, 2.463331455787112],
            [31.0459985351355, 2.467424900043167],
            [31.046737036537298, 2.467856781975635],
            [31.046954512379376, 2.469484436617039],
            [31.04772853676079, 2.46983261343913],
            [31.048255484913206, 2.471532532517595],
            [31.049398738435933, 2.472084684317253],
            [31.0514215692843, 2.478058614189424],
            [31.05183618850032, 2.47718574924068],
            [31.052715948183927, 2.476875974656073],
            [31.05402640782547, 2.477739488114891],
            [31.053147185334392, 2.47831250900921],
            [31.05343418628786, 2.479030884644437],
            [31.05543425023366, 2.479680061943875],
            [31.056861044399437, 2.479251456950498],
            [31.060446226986553, 2.481255154126036],
            [31.06140041568474, 2.482429238629322],
            [31.06159297854902, 2.483506446323822],
            [31.06292773761901, 2.48460931182979],
            [31.063358346847068, 2.485734744195778],
            [31.064072876705517, 2.486070865520464],
            [31.065361620473386, 2.487939471680089],
            [31.067051399133515, 2.488109546440097],
            [31.0679090467864, 2.48861340484758],
            [31.068787152671582, 2.487489946676133],
            [31.06935960408637, 2.488160894196104],
            [31.07109397691387, 2.488474801668603],
            [31.070338140722015, 2.489598266180539],
            [31.071735323721047, 2.492125159466627],
            [31.071762453740956, 2.493752550001008],
            [31.073261591931487, 2.493778746093604],
            [31.074121601255275, 2.495431327278069],
            [31.075094796508214, 2.494260144187912],
            [31.075428124479235, 2.494356372989165],
            [31.075383430598915, 2.495768275384315],
            [31.074621887410032, 2.495719262226824],
            [31.074791784881416, 2.496315395748014],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 834,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "PAIDHA",
        Population: 15248,
        Key: "ZOMBOPAIDHA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.972655018723223, 2.426189480205094],
            [30.972230800110083, 2.426827939065105],
            [30.971425688629978, 2.427112384956651],
            [30.97137041349391, 2.427901271263202],
            [30.96849044613404, 2.427448020225669],
            [30.967216706028086, 2.429098843761616],
            [30.966074855673792, 2.428471381351176],
            [30.965371163989257, 2.428762777201178],
            [30.964345576294004, 2.430178804939984],
            [30.96356905190113, 2.430593175054318],
            [30.963224468039616, 2.431910241841001],
            [30.962439084461433, 2.431513771102972],
            [30.961380170167462, 2.432089874108787],
            [30.95957618060043, 2.432269562895516],
            [30.95929282950193, 2.433069820275199],
            [30.958194905866733, 2.432784359662336],
            [30.95659938203947, 2.433186525596005],
            [30.95501120912615, 2.432585035313115],
            [30.954979912719967, 2.430625447614069],
            [30.954414199568117, 2.43021775137427],
            [30.952908160519573, 2.430261668202937],
            [30.952475690880533, 2.429304702483652],
            [30.952582988353004, 2.427849946319177],
            [30.950045913327017, 2.426800975184037],
            [30.94912199785392, 2.426849793423629],
            [30.948680191125842, 2.427309543526441],
            [30.94452025653844, 2.426315364057194],
            [30.94395397475302, 2.425112862656351],
            [30.94290350641932, 2.424417165108902],
            [30.941840326924396, 2.422359224221875],
            [30.938181964879263, 2.421862898787339],
            [30.936288876809087, 2.420862191291196],
            [30.935924107803125, 2.420109188879228],
            [30.93520095321961, 2.419756394907659],
            [30.933720324815507, 2.42023666817899],
            [30.933168536448857, 2.419164395253845],
            [30.931097070811038, 2.418994118758756],
            [30.929349928431797, 2.417615341478824],
            [30.928011073044136, 2.417652600945131],
            [30.92794066668543, 2.41896961032218],
            [30.927510060152297, 2.419381775086063],
            [30.924479472268764, 2.420163446295063],
            [30.924061655948634, 2.419643034361207],
            [30.924457754598436, 2.418692048455153],
            [30.922059003956505, 2.417649754025424],
            [30.921876188711366, 2.416996949429755],
            [30.920860157294104, 2.416783313653217],
            [30.920488227817014, 2.416064966586009],
            [30.919121876795128, 2.415143891528412],
            [30.919356295761798, 2.413860961693822],
            [30.918535053234113, 2.413538872895656],
            [30.917653068423526, 2.41405409233513],
            [30.915627609104657, 2.412849242023973],
            [30.914438496586666, 2.411537461048029],
            [30.912374315387442, 2.410568698564771],
            [30.910500244651825, 2.408591546846862],
            [30.91022635820318, 2.406231550196523],
            [30.910668180202606, 2.405360498255595],
            [30.909286512905148, 2.400840627403846],
            [30.90939068873201, 2.399311573937124],
            [30.908569372542463, 2.398843482613751],
            [30.90915950459869, 2.39815202861033],
            [30.90955886682794, 2.396336988685556],
            [30.909423377526885, 2.395882615988467],
            [30.908589878385477, 2.395976047064258],
            [30.909905124250816, 2.394832448929803],
            [30.909553317036107, 2.393851810128276],
            [30.908474999131993, 2.39270203609776],
            [30.908540396484693, 2.3918778016128],
            [30.910016737229952, 2.390615138661192],
            [30.908831313194476, 2.389680138247475],
            [30.908212860850625, 2.389726337915407],
            [30.90726570775777, 2.38709536873379],
            [30.905378760570855, 2.385131051982623],
            [30.90453979697756, 2.385156185712171],
            [30.902751310535674, 2.382746654808818],
            [30.902574174439753, 2.38170673658008],
            [30.90308382014147, 2.381110664463794],
            [30.90329576685298, 2.379677473283823],
            [30.90262181659085, 2.378958864399286],
            [30.903033831590857, 2.376797367518818],
            [30.903677678409487, 2.376082153436716],
            [30.903786369168998, 2.376584239760269],
            [30.90432445553259, 2.376681207567567],
            [30.90432006905906, 2.374721759507178],
            [30.90670781533878, 2.372147155359682],
            [30.906746680051203, 2.371490132159137],
            [30.907634110449024, 2.371468516560696],
            [30.908170474742246, 2.370800807748465],
            [30.90789971892235, 2.369987660123585],
            [30.908535495276492, 2.365688054699699],
            [30.908116685419678, 2.364814787955713],
            [30.90843698602242, 2.363740297834881],
            [30.910851419452573, 2.361094050377745],
            [30.91171341584978, 2.361717548646549],
            [30.913487789758527, 2.361459240267399],
            [30.913863923351137, 2.361292927386123],
            [30.914102780893632, 2.359883683054387],
            [30.91574376216922, 2.360102939183464],
            [30.914166048340775, 2.358127504675606],
            [30.9135424252941, 2.355879706711041],
            [30.912517940730012, 2.354753978044969],
            [30.913564893956, 2.3539203055584],
            [30.913212475886894, 2.352676819285589],
            [30.913426050345684, 2.351984388065246],
            [30.91463565163867, 2.351724623835088],
            [30.917044671820953, 2.353366756747024],
            [30.919860810286593, 2.353460212239315],
            [30.922446294624965, 2.352081132304362],
            [30.925949894912947, 2.352164451755789],
            [30.927425749669613, 2.351363648124032],
            [30.9302686848802, 2.351067361201137],
            [30.931487518159397, 2.348689428005664],
            [30.934050631752214, 2.346769881967346],
            [30.93389263516172, 2.344014997992334],
            [30.93472371783504, 2.34083779054607],
            [30.936334500445742, 2.336357754869292],
            [30.937637288474736, 2.334647991673847],
            [30.93801584572198, 2.33680226035951],
            [30.939498923831867, 2.338526530104955],
            [30.941222458485456, 2.339558417802639],
            [30.942786763161628, 2.341521858388792],
            [30.942751759408296, 2.343851661147191],
            [30.944425448343374, 2.346603951489737],
            [30.945615770892054, 2.34966569449621],
            [30.946746790258953, 2.356204192917093],
            [30.947219588864353, 2.357149291928034],
            [30.947947638367822, 2.357987505005744],
            [30.949696344713978, 2.358254791369799],
            [30.950048040537613, 2.359163746288394],
            [30.949598422958104, 2.362484205249032],
            [30.944073406668355, 2.363222935018381],
            [30.942597494419477, 2.364652962330548],
            [30.944138930683508, 2.368384696097333],
            [30.943952735976257, 2.369292283700504],
            [30.942492028611877, 2.371498977474115],
            [30.943386098457953, 2.374392693875511],
            [30.94556065296118, 2.378615925584491],
            [30.946774042449732, 2.38000499298847],
            [30.948658602812923, 2.380870064575747],
            [30.950131374551553, 2.383968391881388],
            [30.950216011122684, 2.385713038212855],
            [30.94882290467838, 2.388099122995379],
            [30.948717330174603, 2.38898302246086],
            [30.949353111918633, 2.390645437595373],
            [30.952451028532717, 2.392875703161589],
            [30.95516464137669, 2.397602160343542],
            [30.956052549678237, 2.397771696358731],
            [30.95721984840621, 2.396615696763625],
            [30.958354477203912, 2.398840963252444],
            [30.95851862096588, 2.400386931142978],
            [30.957997044738878, 2.401337234253379],
            [30.956854331103603, 2.401615800400848],
            [30.95906781769294, 2.403955023749619],
            [30.96073181200947, 2.408213290779118],
            [30.96245660340613, 2.409037176149945],
            [30.9642631693414, 2.409228394858258],
            [30.962616714630794, 2.416415776210933],
            [30.965953046816235, 2.416997820020374],
            [30.96735478966366, 2.418411298557434],
            [30.96921166574644, 2.418893976747418],
            [30.969875809998925, 2.421201698187717],
            [30.97025289490743, 2.421441623224232],
            [30.971704448439045, 2.421086881995395],
            [30.97181564370153, 2.42268824600407],
            [30.973270392540623, 2.423743414953697],
            [30.97364876922651, 2.424556864514409],
            [30.9723067841084, 2.42579606381043],
            [30.972655018723223, 2.426189480205094],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 835,
        District: "ZOMBO",
        County: "OKORO",
        Subcounty: "ABANGA",
        Population: 17613,
        Key: "ZOMBOABANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.87959003870294, 3.300835961380237],
            [32.87733108837707, 3.3016700629474],
            [32.87460170740494, 3.301411199987846],
            [32.86884301864854, 3.299701348914458],
            [32.86796639228864, 3.299044668499066],
            [32.86780543125773, 3.29843257968926],
            [32.866043825104086, 3.29853821515727],
            [32.86596692482419, 3.297634252558812],
            [32.86539542203031, 3.297637639877593],
            [32.86524966318893, 3.297162468983365],
            [32.86770932499706, 3.294339419973498],
            [32.86837200589393, 3.291681708522606],
            [32.86849952444344, 3.289134260396738],
            [32.86907354791002, 3.287571922400489],
            [32.86871218172236, 3.286883833910588],
            [32.8694908405123, 3.285689181037448],
            [32.87019768797847, 3.282459991845008],
            [32.871409866537995, 3.282071989437471],
            [32.872633519278686, 3.279792213959753],
            [32.873093772911126, 3.280650870769628],
            [32.87346888242431, 3.280635958062052],
            [32.87324157721639, 3.281408378265545],
            [32.87393171691658, 3.281880982732684],
            [32.87719118116149, 3.282260409614292],
            [32.87875781427088, 3.286285617989434],
            [32.87855524507263, 3.287350791990046],
            [32.87729897630063, 3.286916578344977],
            [32.876947643396385, 3.28723968552518],
            [32.87694749517436, 3.288448506552349],
            [32.877539038483896, 3.289618567593804],
            [32.880666733351326, 3.290060403156982],
            [32.88097257017971, 3.292169877140341],
            [32.88043991682693, 3.293080752999306],
            [32.883462753147874, 3.293884799288735],
            [32.88218770150159, 3.298652909462895],
            [32.88084196861213, 3.299361883182536],
            [32.879689833446164, 3.299334815171138],
            [32.87959003870294, 3.300835961380237],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 836,
        District: "KITGUM",
        County: "KITGUM MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 10460,
        Key: "KITGUMCENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.90068699381172, 3.295336726731474],
            [32.898904572794635, 3.294733850572822],
            [32.89571301489705, 3.295882498706443],
            [32.89444053063584, 3.294331601402389],
            [32.892335092510585, 3.294726336927188],
            [32.88861704010976, 3.297099683827663],
            [32.88787854050459, 3.298698595619222],
            [32.886020656512066, 3.300230355031643],
            [32.884911991721005, 3.300146447137048],
            [32.88407238044241, 3.300732806774554],
            [32.88230402704267, 3.300337635983194],
            [32.880716562900126, 3.300943053933192],
            [32.87959003870294, 3.300835961380237],
            [32.879689833446164, 3.299334815171138],
            [32.88084196861213, 3.299361883182536],
            [32.88218770150159, 3.298652909462895],
            [32.883462753147874, 3.293884799288735],
            [32.88043991682693, 3.293080752999306],
            [32.88097257017971, 3.292169877140341],
            [32.880666733351326, 3.290060403156982],
            [32.877539038483896, 3.289618567593804],
            [32.87694749517436, 3.288448506552349],
            [32.876947643396385, 3.28723968552518],
            [32.87729897630063, 3.286916578344977],
            [32.87855524507263, 3.287350791990046],
            [32.87875781427088, 3.286285617989434],
            [32.87719118116149, 3.282260409614292],
            [32.87393171691658, 3.281880982732684],
            [32.87324157721639, 3.281408378265545],
            [32.87346888242431, 3.280635958062052],
            [32.873093772911126, 3.280650870769628],
            [32.872633519278686, 3.279792213959753],
            [32.87338904375515, 3.278561533517271],
            [32.87276027426023, 3.276970608147197],
            [32.87212457066962, 3.276200848152195],
            [32.869263822765284, 3.275048392668765],
            [32.86994096025005, 3.273288914967138],
            [32.87120922961595, 3.272768441548233],
            [32.87274555177103, 3.2713683193111],
            [32.876746773810645, 3.270471195722355],
            [32.879997863062115, 3.268855835280213],
            [32.88096241382709, 3.26885595097436],
            [32.88224863153236, 3.267599416018054],
            [32.88449933083232, 3.266845646037039],
            [32.89026911378247, 3.263740465664864],
            [32.89132966390859, 3.263527403510218],
            [32.89273401995521, 3.264171592511895],
            [32.899717938893936, 3.265267439231076],
            [32.90304159315578, 3.264620972017312],
            [32.907506667478835, 3.266588539061078],
            [32.90990108554616, 3.268193244937535],
            [32.91081320613958, 3.269262983453924],
            [32.91318488245715, 3.277153479600698],
            [32.912434315782775, 3.281282559334232],
            [32.911683984466976, 3.282539190121129],
            [32.91173748453204, 3.283454776013963],
            [32.91105859084088, 3.284890954902935],
            [32.90905769146189, 3.288409516601273],
            [32.90684255376909, 3.290491838834046],
            [32.905342050139296, 3.291102095811967],
            [32.90423447141143, 3.292215055090174],
            [32.901286976793344, 3.294027999907711],
            [32.900465197971435, 3.295069174529142],
            [32.90068699381172, 3.295336726731474],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 837,
        District: "KITGUM",
        County: "KITGUM MUNICIPALITY",
        Subcounty: "PANDWONG DIVISION",
        Population: 18723,
        Key: "KITGUMPANDWONG DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.093295191475544, 2.479433059989031],
            [31.09341977522903, 2.480753986228307],
            [31.09192130987666, 2.48140735388084],
            [31.090039985245106, 2.481211468726712],
            [31.088555900123765, 2.479958709681537],
            [31.087838810965092, 2.479792088249583],
            [31.085273505482952, 2.480141228943756],
            [31.08449465175857, 2.48083270182282],
            [31.0806144372793, 2.481271870459104],
            [31.07969896866484, 2.480979527556468],
            [31.078886857512018, 2.482516974617222],
            [31.077039623047188, 2.484233922185853],
            [31.075299254863527, 2.486904078002132],
            [31.0755191462754, 2.488082494049856],
            [31.077988774891548, 2.490959562854959],
            [31.076781489455346, 2.490806698281694],
            [31.07254206025353, 2.488969647564729],
            [31.071029386248302, 2.487546200918118],
            [31.07109397691387, 2.488474801668603],
            [31.06935960408637, 2.488160894196104],
            [31.068787152671582, 2.487489946676133],
            [31.0679090467864, 2.48861340484758],
            [31.067051399133515, 2.488109546440097],
            [31.065361620473386, 2.487939471680089],
            [31.064072876705517, 2.486070865520464],
            [31.063358346847068, 2.485734744195778],
            [31.06292773761901, 2.48460931182979],
            [31.06159297854902, 2.483506446323822],
            [31.06140041568474, 2.482429238629322],
            [31.060446226986553, 2.481255154126036],
            [31.056861044399437, 2.479251456950498],
            [31.05543425023366, 2.479680061943875],
            [31.05343418628786, 2.479030884644437],
            [31.053147185334392, 2.47831250900921],
            [31.05402640782547, 2.477739488114891],
            [31.052715948183927, 2.476875974656073],
            [31.05183618850032, 2.47718574924068],
            [31.0514215692843, 2.478058614189424],
            [31.049398738435933, 2.472084684317253],
            [31.048255484913206, 2.471532532517595],
            [31.04772853676079, 2.46983261343913],
            [31.046954512379376, 2.469484436617039],
            [31.046737036537298, 2.467856781975635],
            [31.0459985351355, 2.467424900043167],
            [31.045204954430343, 2.463331455787112],
            [31.04404871126858, 2.462240834939297],
            [31.043568519528392, 2.460134160995656],
            [31.04244564249126, 2.457906860333004],
            [31.04268059236224, 2.456447410763844],
            [31.042358515790173, 2.45602812858714],
            [31.042025645061642, 2.456147282059272],
            [31.041767188974607, 2.454987252377099],
            [31.050118062603058, 2.448641362629887],
            [31.052032807258126, 2.445839693381233],
            [31.053746566444765, 2.445444591841445],
            [31.056299487752383, 2.445480930604687],
            [31.061799918949475, 2.446581993138146],
            [31.064419777322144, 2.445358410568491],
            [31.065779057704443, 2.445386963545634],
            [31.066923889567143, 2.447676702293037],
            [31.068003962779315, 2.447497255196529],
            [31.06962148095802, 2.449038228599803],
            [31.069799634845154, 2.450305591154924],
            [31.074918276656568, 2.457644142888868],
            [31.076535552290125, 2.45936613868125],
            [31.078869994337502, 2.462989845959062],
            [31.078823864051028, 2.463781725820973],
            [31.078153969682422, 2.464559613431015],
            [31.08105648655253, 2.465196722163231],
            [31.084959166100415, 2.468920242228221],
            [31.085560213585666, 2.470313908069629],
            [31.088663499430204, 2.471216986714285],
            [31.090066524173558, 2.474072009771311],
            [31.090367007941133, 2.475911323990896],
            [31.092256849499897, 2.473041815100776],
            [31.093726867902184, 2.469217412649579],
            [31.09586774007381, 2.470539439507344],
            [31.098634568216912, 2.475076438864949],
            [31.096268044635785, 2.476241493953751],
            [31.093908554863336, 2.476727785200939],
            [31.09355497976414, 2.477099918240541],
            [31.093295191475544, 2.479433059989031],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 838,
        District: "NEBBI",
        County: "NEBBI MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 8746,
        Key: "NEBBICENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.133443072750893, 2.507355726727766],
            [31.131967210807687, 2.507392059305565],
            [31.12992299286903, 2.508902474678456],
            [31.12823974945259, 2.508503696233996],
            [31.127040692584398, 2.507727277635418],
            [31.126127112228634, 2.507743976580391],
            [31.12254820437378, 2.50518053570928],
            [31.120757446092565, 2.504817631076877],
            [31.1185216345718, 2.505751000372237],
            [31.118747951632912, 2.509769870145527],
            [31.119153146623287, 2.510792965045567],
            [31.11611762788715, 2.510680092390732],
            [31.113240848648214, 2.509218629801542],
            [31.105602391142337, 2.507637597647139],
            [31.104583548896557, 2.510177549145758],
            [31.104787184395054, 2.516337277225317],
            [31.10397405994261, 2.517463049426482],
            [31.10346844228661, 2.519716231443505],
            [31.104041903407797, 2.52311415694459],
            [31.10333085721603, 2.523247164480946],
            [31.10244303964429, 2.522731997239394],
            [31.101176285736297, 2.523109948827772],
            [31.100620024657868, 2.523734702808352],
            [31.098687401732, 2.523731859705842],
            [31.09677949864616, 2.522008731122007],
            [31.095336012884108, 2.521716162169022],
            [31.0933465804997, 2.519459689085127],
            [31.093233368519368, 2.51753446387323],
            [31.091785304044308, 2.516073953972509],
            [31.09114943157044, 2.514556306263573],
            [31.09225233546558, 2.514032914936691],
            [31.092369877325556, 2.512983056087339],
            [31.091268162799874, 2.512689759967244],
            [31.091849931540786, 2.511523914193812],
            [31.09080597060303, 2.511405708939565],
            [31.089589177397876, 2.510470559542362],
            [31.088486618455793, 2.510760611868515],
            [31.085994950572452, 2.508948560745111],
            [31.083299118981223, 2.507923728724009],
            [31.08144477524926, 2.506637629508049],
            [31.080983103176973, 2.505003576972169],
            [31.08133182288206, 2.504537413563884],
            [31.081159077751245, 2.503662138539533],
            [31.080579863818976, 2.503077938266988],
            [31.079361898312346, 2.502959472884308],
            [31.07924869082363, 2.501034263751517],
            [31.078206447464694, 2.499749365754959],
            [31.076111563645703, 2.500459124858962],
            [31.074638206205506, 2.49713088135503],
            [31.074791784881416, 2.496315395748014],
            [31.074621887410032, 2.495719262226824],
            [31.075383430598915, 2.495768275384315],
            [31.075428124479235, 2.494356372989165],
            [31.075094796508214, 2.494260144187912],
            [31.074121601255275, 2.495431327278069],
            [31.073261591931487, 2.493778746093604],
            [31.071762453740956, 2.493752550001008],
            [31.071735323721047, 2.492125159466627],
            [31.070338140722015, 2.489598266180539],
            [31.07109397691387, 2.488474801668603],
            [31.071029386248302, 2.487546200918118],
            [31.07254206025353, 2.488969647564729],
            [31.076781489455346, 2.490806698281694],
            [31.077988774891548, 2.490959562854959],
            [31.0755191462754, 2.488082494049856],
            [31.075299254863527, 2.486904078002132],
            [31.077039623047188, 2.484233922185853],
            [31.078886857512018, 2.482516974617222],
            [31.07969896866484, 2.480979527556468],
            [31.0806144372793, 2.481271870459104],
            [31.08449465175857, 2.48083270182282],
            [31.085273505482952, 2.480141228943756],
            [31.087838810965092, 2.479792088249583],
            [31.088555900123765, 2.479958709681537],
            [31.090039985245106, 2.481211468726712],
            [31.09192130987666, 2.48140735388084],
            [31.09341977522903, 2.480753986228307],
            [31.093295191475544, 2.479433059989031],
            [31.095641274790676, 2.480403852192591],
            [31.103870828245093, 2.487274748892231],
            [31.10510363032695, 2.48592137845704],
            [31.103006402803373, 2.484300889677847],
            [31.10573332328995, 2.482912019384537],
            [31.10928598327055, 2.481996086136059],
            [31.11269207412936, 2.480455906559924],
            [31.113768123787406, 2.480656613053402],
            [31.114622012889132, 2.47997163420365],
            [31.115645266761298, 2.480144652806338],
            [31.11478797124801, 2.483231344347203],
            [31.116790259422448, 2.484362971334658],
            [31.116468326580808, 2.484676824964962],
            [31.11695855879092, 2.485838259280724],
            [31.11886370315054, 2.486559029761028],
            [31.11976953553694, 2.487326193607388],
            [31.11998534500417, 2.488116276555625],
            [31.12036662504505, 2.48838009185125],
            [31.121151381599155, 2.488141922612225],
            [31.12222473720963, 2.489364047813767],
            [31.12270070057978, 2.48938867881032],
            [31.123047514059827, 2.490238785805746],
            [31.122026347872417, 2.491218510621706],
            [31.124359979639387, 2.492011707237265],
            [31.124718666152564, 2.492849866380716],
            [31.126625732008577, 2.494480069568597],
            [31.127862916072377, 2.494386156233844],
            [31.12812527084772, 2.494673729733537],
            [31.128378153786723, 2.496122012243513],
            [31.127190409402914, 2.497101494850855],
            [31.127063842169264, 2.497918237313747],
            [31.12790497429565, 2.499481777122484],
            [31.12761383031206, 2.501333839314785],
            [31.12818327506563, 2.502186753015948],
            [31.130198162111927, 2.502122657405003],
            [31.131972933076028, 2.504073013493722],
            [31.132673087194995, 2.506430255290875],
            [31.133443072750893, 2.507355726727766],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 839,
        District: "NEBBI",
        County: "NEBBI MUNICIPALITY",
        Subcounty: "THATHA DIVISION",
        Population: 12046,
        Key: "NEBBITHATHA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.308988899997715, 3.50542463632423],
            [31.307608011539607, 3.50493954614793],
            [31.307392813825064, 3.504224514419926],
            [31.30646400253368, 3.503558264543337],
            [31.305298139313567, 3.503440819521932],
            [31.301012669656817, 3.50122973473729],
            [31.298871086019457, 3.500875317653619],
            [31.298496640361265, 3.504953433230912],
            [31.297585965157147, 3.508400465716526],
            [31.297108865418167, 3.509152222049623],
            [31.295634357236086, 3.509058362714614],
            [31.29365411192209, 3.509908913727434],
            [31.292903983625564, 3.512106927565053],
            [31.29065239050189, 3.511207781263442],
            [31.288372346834876, 3.511545795989301],
            [31.28627762920422, 3.510831197007375],
            [31.28607004561004, 3.509725216587455],
            [31.28379366617105, 3.50806262379914],
            [31.28281378565578, 3.506626174266033],
            [31.281962262716497, 3.506637765045882],
            [31.280270199640594, 3.507734408004434],
            [31.279275604720933, 3.509435111768852],
            [31.278937689952098, 3.51294986343519],
            [31.279084406397548, 3.518662372516307],
            [31.27664754023811, 3.51878946954932],
            [31.273920096033716, 3.520205875241064],
            [31.269621966419674, 3.524226218957939],
            [31.266098011205695, 3.526198442264248],
            [31.26356313345884, 3.525852518433976],
            [31.259708102350267, 3.527767909163551],
            [31.258741683089504, 3.527129048825669],
            [31.257385477640465, 3.526987970239204],
            [31.254937801154895, 3.528803747724056],
            [31.254795794576463, 3.529304698197299],
            [31.25198220912284, 3.530601127699634],
            [31.251518071175113, 3.530003265051183],
            [31.24955350954765, 3.529040482866483],
            [31.246238204228067, 3.52812295531554],
            [31.244935833017358, 3.528895773291729],
            [31.23975518589178, 3.528338956467377],
            [31.238843601592606, 3.528649230968106],
            [31.2383213669005, 3.526860931709082],
            [31.238715111065936, 3.526257219830886],
            [31.238187769451432, 3.525280930736913],
            [31.237491432274098, 3.525548685179986],
            [31.234684025433015, 3.52426523074002],
            [31.233396953429907, 3.524308622491567],
            [31.22943929608833, 3.522224005861721],
            [31.22843791170177, 3.522273437329757],
            [31.228141251164008, 3.521655126414727],
            [31.22662697546262, 3.521175826973618],
            [31.226356597833473, 3.520440374607781],
            [31.225262642955183, 3.519793426202656],
            [31.22468831945135, 3.519922508199427],
            [31.22342150086463, 3.519001195983196],
            [31.218340534396212, 3.517104634236075],
            [31.216841580360317, 3.515895923332236],
            [31.21520928220027, 3.515367042050471],
            [31.212079929941126, 3.515241935955268],
            [31.210717412928886, 3.514342124687742],
            [31.209950170827856, 3.514584815309331],
            [31.20930443754712, 3.514141750276649],
            [31.208275704850056, 3.513796092749853],
            [31.206555705067153, 3.514042144965417],
            [31.205000770717664, 3.513232406802513],
            [31.20419550293067, 3.509613812940577],
            [31.20232111958132, 3.508138211668542],
            [31.201862768580664, 3.507281081346095],
            [31.201735450355446, 3.503773712780909],
            [31.200398353869108, 3.503062799311526],
            [31.200339223163827, 3.480087086391411],
            [31.201314027299475, 3.478819370567198],
            [31.20180130854385, 3.471305232460771],
            [31.206882222909968, 3.468420550473092],
            [31.21172184979078, 3.467427846777346],
            [31.21868156092922, 3.465042042242619],
            [31.22634816265296, 3.463978688745883],
            [31.22912969082733, 3.463065823913427],
            [31.226140617686323, 3.46663997322117],
            [31.2235149984177, 3.468705802624695],
            [31.224826867515915, 3.470209366544794],
            [31.22595818871674, 3.472924313261501],
            [31.226026800241517, 3.474280849816629],
            [31.224827852967802, 3.479152602524675],
            [31.224789014306495, 3.480970112825167],
            [31.226220636916906, 3.484454264366819],
            [31.230757717498207, 3.489029421636832],
            [31.240417193950503, 3.489156146998478],
            [31.24187210268975, 3.489837090640046],
            [31.245507387913506, 3.498660646524132],
            [31.248075768328878, 3.501116073238967],
            [31.249605057573593, 3.500223705723906],
            [31.250534531821664, 3.500216406181447],
            [31.252209504449297, 3.498257251225949],
            [31.25238344433944, 3.49651231009487],
            [31.253319451136246, 3.495709248411194],
            [31.253796965896882, 3.4944984009459],
            [31.25509079682418, 3.494093889327008],
            [31.259869472114634, 3.488261105950991],
            [31.26105350106645, 3.486083973025127],
            [31.261113212981716, 3.482973333234874],
            [31.262254366243337, 3.480705685680392],
            [31.263958449676036, 3.480012538179944],
            [31.267219250614094, 3.47985579323829],
            [31.272665421771332, 3.483419708213528],
            [31.272586418535365, 3.455250818812994],
            [31.27184076474725, 3.453621726799431],
            [31.27081273632938, 3.452634168019442],
            [31.270404846393145, 3.451150381315743],
            [31.271062411384484, 3.450083834382511],
            [31.27099768686995, 3.44870919041771],
            [31.27197264910908, 3.448249780931421],
            [31.272272607362222, 3.44752689336959],
            [31.272092686488897, 3.446405240732452],
            [31.27245311214046, 3.44458826755775],
            [31.27205674579269, 3.443104503271236],
            [31.272715010571673, 3.441357318086818],
            [31.272396359275767, 3.44067648033633],
            [31.272671811487953, 3.439823775816814],
            [31.274865109339583, 3.438726852207999],
            [31.275030646388554, 3.438066605260042],
            [31.275962845226893, 3.437572888317832],
            [31.278129232247544, 3.437963108313453],
            [31.281910136175494, 3.437618732948009],
            [31.283732657986842, 3.439235052009323],
            [31.283977423748947, 3.439911924699697],
            [31.28791130627824, 3.440907659309353],
            [31.289129484685553, 3.440220416134705],
            [31.289789184972324, 3.440533804327667],
            [31.291473078769062, 3.440042521401085],
            [31.293028436225015, 3.439030669541927],
            [31.29319789621684, 3.438380557287495],
            [31.294350690746242, 3.438057420377238],
            [31.295856014735822, 3.436056835482751],
            [31.297240700372633, 3.435762923053941],
            [31.297334426996123, 3.436265543372411],
            [31.299950598682912, 3.436796711654727],
            [31.30104807226216, 3.435841669509814],
            [31.301049393683925, 3.435387074482493],
            [31.303837164251224, 3.434195869204111],
            [31.304907700948345, 3.434317447659067],
            [31.306111795568665, 3.433518119966585],
            [31.306661786406423, 3.432609929997468],
            [31.307918341741033, 3.431708529011157],
            [31.307834315125962, 3.430386934556249],
            [31.308810142442702, 3.430340849261713],
            [31.309067082173534, 3.429538803911633],
            [31.313353328873006, 3.429097125638312],
            [31.313976809985846, 3.429441036892655],
            [31.31378781073825, 3.430500225246107],
            [31.314312843682487, 3.431042026277655],
            [31.316277919146263, 3.430339203806654],
            [31.318014021230674, 3.430539623799562],
            [31.320067853837802, 3.432277847408468],
            [31.321319493591158, 3.431719169306378],
            [31.322673043620235, 3.431991614087978],
            [31.323060031556405, 3.433052406506523],
            [31.324375662799035, 3.433614960274551],
            [31.326309920658684, 3.432808193839035],
            [31.327146961857288, 3.432913534966701],
            [31.328800509665374, 3.434336811939107],
            [31.328463062020468, 3.435819642956217],
            [31.330185745071173, 3.436743909491732],
            [31.331375702903834, 3.436722117894301],
            [31.331654931633484, 3.438923854021819],
            [31.332749148819822, 3.439093314627215],
            [31.334862962836812, 3.440556617174932],
            [31.33608071723933, 3.439147145172128],
            [31.33872132579679, 3.439486843709862],
            [31.34153182463908, 3.438678369545769],
            [31.342046118224083, 3.437758118508369],
            [31.343829997206857, 3.436594681605314],
            [31.343747511202512, 3.440255898413557],
            [31.34315450902896, 3.441064659078939],
            [31.342370203429127, 3.446156131966721],
            [31.342678975951856, 3.447907359584804],
            [31.34230644280688, 3.452963574081232],
            [31.342725253562026, 3.455681791130572],
            [31.34226654593016, 3.456863029807648],
            [31.34233974245615, 3.460095919869169],
            [31.340478693698884, 3.460813380136514],
            [31.340799686902724, 3.462190977252894],
            [31.339583778538117, 3.463350361236629],
            [31.336869548551565, 3.464115467394944],
            [31.336839297784373, 3.465237279326489],
            [31.33549863678299, 3.466464327806749],
            [31.33555919670788, 3.466850785156247],
            [31.33767076493662, 3.467799863752711],
            [31.336727906689127, 3.472524173480328],
            [31.337018573667283, 3.473099912641871],
            [31.33521373609063, 3.475411173360797],
            [31.335702259705062, 3.477462198529352],
            [31.335389650477765, 3.479237282160599],
            [31.33471623381491, 3.479815168309445],
            [31.333813127815404, 3.479910078764141],
            [31.332677481226458, 3.481143433196633],
            [31.33104413922405, 3.481352857452923],
            [31.330524512341217, 3.481873103397218],
            [31.32921190033626, 3.485403148609981],
            [31.329284057511448, 3.486441368098486],
            [31.326361257580544, 3.489548120201453],
            [31.32493786174151, 3.490530006739561],
            [31.321631936630126, 3.491392696360523],
            [31.3174257918062, 3.490728852935649],
            [31.315100862917685, 3.490917693389878],
            [31.31361258176567, 3.490119772789032],
            [31.313483465113254, 3.490538922118511],
            [31.309250457069094, 3.488224785309753],
            [31.30735584994776, 3.489559708502568],
            [31.306905381663707, 3.490571137812285],
            [31.306923730651686, 3.491943334892733],
            [31.30982681076551, 3.493883243987682],
            [31.310494830350102, 3.49498672444927],
            [31.30989120739497, 3.496768987591495],
            [31.308988899997715, 3.50542463632423],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 840,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "APO",
        Population: 40213,
        Key: "YUMBEAPO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.22912969082733, 3.463065823913427],
            [31.2297811086472, 3.462636286046965],
            [31.228926407468425, 3.461813474001588],
            [31.230735405143168, 3.460340361358051],
            [31.23560078402824, 3.458716246584824],
            [31.237433009441304, 3.457253721612983],
            [31.239053237837183, 3.457722124926572],
            [31.241065861128963, 3.457523871655129],
            [31.246486338672486, 3.451168081900715],
            [31.24681692408693, 3.451551497651439],
            [31.248596546851893, 3.448565578573464],
            [31.251010368529357, 3.446783259431839],
            [31.25190030163356, 3.445159934771716],
            [31.252825042658397, 3.444774771480801],
            [31.254091885499598, 3.445821806091334],
            [31.256045458036176, 3.448882055800341],
            [31.257892196630973, 3.449040299754393],
            [31.264319902101978, 3.442666881644435],
            [31.265963838834853, 3.442003856775438],
            [31.26812548454743, 3.441920931333727],
            [31.269478185668547, 3.442936930023201],
            [31.270573813209896, 3.442678306424838],
            [31.27097682170087, 3.442939663146261],
            [31.271661818546043, 3.442749855442702],
            [31.271554370156586, 3.442303639732755],
            [31.272715010571673, 3.441357318086818],
            [31.27205674579269, 3.443104503271236],
            [31.27245311214046, 3.44458826755775],
            [31.272092686488897, 3.446405240732452],
            [31.272272607362222, 3.44752689336959],
            [31.27197264910908, 3.448249780931421],
            [31.27099768686995, 3.44870919041771],
            [31.271062411384484, 3.450083834382511],
            [31.270404846393145, 3.451150381315743],
            [31.27081273632938, 3.452634168019442],
            [31.27184076474725, 3.453621726799431],
            [31.272586418535365, 3.455250818812994],
            [31.272665421771332, 3.483419708213528],
            [31.267219250614094, 3.47985579323829],
            [31.263958449676036, 3.480012538179944],
            [31.262254366243337, 3.480705685680392],
            [31.261113212981716, 3.482973333234874],
            [31.26105350106645, 3.486083973025127],
            [31.259869472114634, 3.488261105950991],
            [31.25509079682418, 3.494093889327008],
            [31.253796965896882, 3.4944984009459],
            [31.253319451136246, 3.495709248411194],
            [31.25238344433944, 3.49651231009487],
            [31.252209504449297, 3.498257251225949],
            [31.250534531821664, 3.500216406181447],
            [31.249605057573593, 3.500223705723906],
            [31.248075768328878, 3.501116073238967],
            [31.245507387913506, 3.498660646524132],
            [31.24187210268975, 3.489837090640046],
            [31.240417193950503, 3.489156146998478],
            [31.230757717498207, 3.489029421636832],
            [31.226220636916906, 3.484454264366819],
            [31.224789014306495, 3.480970112825167],
            [31.224827852967802, 3.479152602524675],
            [31.226026800241517, 3.474280849816629],
            [31.22595818871674, 3.472924313261501],
            [31.224826867515915, 3.470209366544794],
            [31.2235149984177, 3.468705802624695],
            [31.226140617686323, 3.46663997322117],
            [31.22912969082733, 3.463065823913427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 841,
        District: "YUMBE",
        County: "ARINGA",
        Subcounty: "YUMBE TOWN COUNCIL",
        Population: 34806,
        Key: "YUMBEYUMBE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.29835258664315, 2.216733927849931],
            [33.29344655809318, 2.216780882659015],
            [33.291255205992464, 2.215106188640035],
            [33.2856650555564, 2.213249945802081],
            [33.28657026990193, 2.215230561703067],
            [33.286653310166784, 2.218810520338777],
            [33.287962773576645, 2.222035089359281],
            [33.28418038114027, 2.221842899275027],
            [33.28331715045788, 2.220717659608005],
            [33.28335967221186, 2.220213898218808],
            [33.28524184575134, 2.217769318341377],
            [33.28530758715878, 2.217015367641042],
            [33.284277879789606, 2.215805950467013],
            [33.28458246706142, 2.215085093107598],
            [33.284005724394504, 2.213850734194688],
            [33.280397759633466, 2.210230862269779],
            [33.279087825506394, 2.207854445016864],
            [33.277356285965304, 2.207225212195437],
            [33.27451986803212, 2.210562409042006],
            [33.27345569859373, 2.209030678151786],
            [33.26674199558742, 2.203233267497004],
            [33.260408500033506, 2.198804816298332],
            [33.25743976924214, 2.197212676402874],
            [33.25645010517508, 2.196167664886629],
            [33.2561035827492, 2.194973231493391],
            [33.25636215561719, 2.194013188806184],
            [33.25491693161506, 2.192855681524189],
            [33.25239247522382, 2.191738778014478],
            [33.25100697661168, 2.190395205835029],
            [33.249522713623946, 2.190146601869812],
            [33.24818697179707, 2.190495220295447],
            [33.24541614794757, 2.188803477989984],
            [33.23854002414802, 2.181766094443888],
            [33.23576701829072, 2.177955031633552],
            [33.23452978302295, 2.175416921870855],
            [33.2334396962903, 2.164567083832014],
            [33.232186026344394, 2.161971493162879],
            [33.23056881179628, 2.155061322327203],
            [33.2266127426761, 2.150057270997347],
            [33.22587471738141, 2.150195375909665],
            [33.22548966172139, 2.150941157121775],
            [33.22360747201223, 2.151153454494007],
            [33.22237211602003, 2.151694651749943],
            [33.221870790514465, 2.152491626104422],
            [33.22101255895663, 2.152616550140966],
            [33.22427615814678, 2.146605496032393],
            [33.22096701706668, 2.121324378711318],
            [33.21977425469368, 2.107341173962034],
            [33.21591324439856, 2.098356827923636],
            [33.21319551277902, 2.089202159175504],
            [33.21862272229727, 2.086098225557941],
            [33.22267348013659, 2.08503643528159],
            [33.230959393891936, 2.085273157885154],
            [33.23439385444575, 2.084150797814609],
            [33.236189893024196, 2.08254013103476],
            [33.24125369448414, 2.081435604969173],
            [33.25111521282362, 2.084169025142498],
            [33.251931778721946, 2.083867118837682],
            [33.25305453628317, 2.08126720566843],
            [33.253892478492, 2.07652578372132],
            [33.25831854796545, 2.070392442902072],
            [33.26093512030085, 2.069221941388639],
            [33.26437294774034, 2.066876451604793],
            [33.2656053392921, 2.064591777016318],
            [33.26912127075397, 2.061853037179962],
            [33.278806731874205, 2.057009042872981],
            [33.28235893012073, 2.054724361308225],
            [33.28673508650202, 2.050822213941146],
            [33.287709011186976, 2.047882238775601],
            [33.28739910139713, 2.043327354764084],
            [33.288056343893274, 2.041520788303045],
            [33.28952417669449, 2.039730000392515],
            [33.290506465593054, 2.039359813848006],
            [33.29440461403864, 2.042795275219705],
            [33.29924433973413, 2.045203584952082],
            [33.305178323938435, 2.045749085849888],
            [33.309323800141314, 2.047370296193431],
            [33.31146441449647, 2.049124086861596],
            [33.31451210360808, 2.053442901271484],
            [33.31891162427162, 2.051909329001941],
            [33.32124468381177, 2.051833830921945],
            [33.322587149528566, 2.052573111005735],
            [33.3243804707033, 2.052638766241845],
            [33.327236267093795, 2.05150445302282],
            [33.32146373440053, 2.05982575302877],
            [33.3200251938641, 2.061065497414813],
            [33.319871406779036, 2.0620968984378],
            [33.31925487233832, 2.062151308271857],
            [33.31822777457504, 2.06359905283394],
            [33.317148647288874, 2.063445467818141],
            [33.31694312353165, 2.064323080377296],
            [33.31493977354854, 2.065771018667191],
            [33.31440067658021, 2.068069092875236],
            [33.31460668722434, 2.06962515206404],
            [33.31424714192177, 2.070394228484767],
            [33.31347666947897, 2.070756269026414],
            [33.3114220274898, 2.074375521698944],
            [33.31247652297088, 2.080708287016944],
            [33.31144934974915, 2.081848428033791],
            [33.310627566435684, 2.08428226726018],
            [33.309857228740185, 2.085368072962566],
            [33.30744251952722, 2.0872232082727],
            [33.305953310415504, 2.091104713659522],
            [33.306030845804315, 2.093864069075319],
            [33.30541440838162, 2.094488440846834],
            [33.30577430582379, 2.095474506099006],
            [33.30521000662019, 2.098315411040097],
            [33.300381095742424, 2.102034718392441],
            [33.2942668915258, 2.103429148114593],
            [33.291416403280316, 2.107518987413474],
            [33.29105736283091, 2.111110764510326],
            [33.29059498108958, 2.112087940953815],
            [33.290646598285804, 2.114621125961371],
            [33.28951638830095, 2.114983224516976],
            [33.28808015912979, 2.117259893650203],
            [33.28581746103256, 2.117571393524346],
            [33.282658320638596, 2.121426054864195],
            [33.28142521851948, 2.121634365144039],
            [33.2794786303842, 2.123371988977962],
            [33.2788253638315, 2.12466808907263],
            [33.27937539419513, 2.124872080990107],
            [33.27947336805327, 2.125606413607454],
            [33.27834383180491, 2.129795441738389],
            [33.27783017961704, 2.130157420937456],
            [33.27803605910712, 2.131089238339221],
            [33.27860097994487, 2.131396737993975],
            [33.277933788606965, 2.134346224837938],
            [33.27677805119671, 2.136644406398908],
            [33.27713799984284, 2.137938081435223],
            [33.27682958035804, 2.138770474115199],
            [33.27605905401633, 2.139078216404566],
            [33.27559666598678, 2.140109673642508],
            [33.272925561422056, 2.142127665753315],
            [33.26927787226084, 2.145747171683947],
            [33.26822466586216, 2.146290185975105],
            [33.26524564307255, 2.155455463008662],
            [33.26491403627364, 2.165235480302256],
            [33.26434899057002, 2.167506412259742],
            [33.265770319385595, 2.173124434394843],
            [33.27906092006529, 2.163269444799256],
            [33.28043406504566, 2.163208245799924],
            [33.284495715856124, 2.166073032269733],
            [33.284284486000224, 2.167605146364063],
            [33.28318490317669, 2.16925091579721],
            [33.28332608959327, 2.170187157288157],
            [33.28263532197071, 2.171208670602856],
            [33.28297385118722, 2.171747669496531],
            [33.28256522103918, 2.173379122881871],
            [33.28310127182038, 2.174485520258925],
            [33.28383553047912, 2.179805084942803],
            [33.28222886215242, 2.184486728683748],
            [33.285275201096155, 2.186911934197626],
            [33.29468136341811, 2.189931692399302],
            [33.29547115502937, 2.190527342119718],
            [33.29607790232511, 2.192513241328124],
            [33.296813623441125, 2.192810072446454],
            [33.29656595881562, 2.193928761493563],
            [33.297013997156824, 2.196649344033299],
            [33.29774059767774, 2.197751820361924],
            [33.29818844557613, 2.199487218897696],
            [33.29916789130681, 2.200119886716917],
            [33.29926532887075, 2.200896270253033],
            [33.30009565606088, 2.201770370896312],
            [33.300413735129965, 2.203199147774386],
            [33.29894492316508, 2.205527362389425],
            [33.29729153525711, 2.211025769748383],
            [33.29768239852542, 2.213419409527729],
            [33.297542814703334, 2.215477159736135],
            [33.29835258664315, 2.216733927849931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 842,
        District: "ALEBTONG",
        County: "MOROTO",
        Subcounty: "ABAKO",
        Population: 24329,
        Key: "ALEBTONGABAKO",
        Dist2: "Alebtong",
        "Sub Country": "Abako",
        id2_original: "Alebtong Abako",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.854609449168144, 3.535619492344975],
            [31.8616518196858, 3.567660245687671],
            [31.8630209294339, 3.589259014560965],
            [31.859752511680558, 3.608057740677043],
            [31.854299725329557, 3.606957477634432],
            [31.851143499968675, 3.607043224108171],
            [31.84486188841066, 3.606377101407642],
            [31.838493484324847, 3.603736431249283],
            [31.833972009276657, 3.600410060232541],
            [31.830252753133347, 3.598430884560047],
            [31.828943302299884, 3.597950556391039],
            [31.826799375856286, 3.598097362881103],
            [31.82522227018731, 3.597377366506671],
            [31.821529251138525, 3.598180281591898],
            [31.818549881599207, 3.599702065913542],
            [31.81702947309936, 3.601195827185279],
            [31.815721839557725, 3.601733975157015],
            [31.81440977911836, 3.60435029845667],
            [31.810552455509196, 3.601827716578097],
            [31.80508957568764, 3.600075736872637],
            [31.79164254238436, 3.593439540322012],
            [31.785533970604572, 3.590946955546176],
            [31.784834141675752, 3.590946020442894],
            [31.78450680995926, 3.591508098032953],
            [31.78333993164283, 3.591881548212591],
            [31.781282466248708, 3.591264328469288],
            [31.78059660612256, 3.590345860558261],
            [31.777201254622945, 3.591526254087364],
            [31.776514224890274, 3.591146507282121],
            [31.776138644659884, 3.590054105405737],
            [31.775008105891665, 3.589629195035624],
            [31.774302441506734, 3.588423343195925],
            [31.75998724397355, 3.585793722198636],
            [31.75991884984107, 3.583979955870388],
            [31.759039188972142, 3.583765013141154],
            [31.758557155685644, 3.582685919043531],
            [31.760038263790097, 3.581473475497315],
            [31.76014879250267, 3.580412589663333],
            [31.76092157092078, 3.578977748814072],
            [31.764531285599993, 3.576816046078999],
            [31.7653455572011, 3.575311214486167],
            [31.763689291090927, 3.572832802604233],
            [31.761829985963633, 3.568636536643625],
            [31.758533801284866, 3.566911234611192],
            [31.75345286176593, 3.562200717443396],
            [31.754174528739316, 3.56032324988271],
            [31.7540636541754, 3.559328535196632],
            [31.755226450547152, 3.558330602494947],
            [31.757506964033052, 3.553854793255714],
            [31.758185147156805, 3.553353252662193],
            [31.758849309375595, 3.551274081802658],
            [31.75907923227426, 3.548679535881101],
            [31.75861004489632, 3.546884050514035],
            [31.758979700737388, 3.544198804157327],
            [31.75815838814113, 3.542661948356062],
            [31.757713332206652, 3.537713043151519],
            [31.75778103194141, 3.533796277383513],
            [31.761361898123603, 3.522416594095668],
            [31.76449265983943, 3.514973197640983],
            [31.766355598652023, 3.512175078473991],
            [31.769389369266637, 3.508686423936042],
            [31.771794336250313, 3.512072989292812],
            [31.773864541551838, 3.513511480138582],
            [31.775840390510833, 3.514255895265733],
            [31.781198092883958, 3.515148322907824],
            [31.783173118087856, 3.516538818116627],
            [31.785361170676506, 3.518958554456532],
            [31.78750048427113, 3.522239685924288],
            [31.793805993710663, 3.526985949271658],
            [31.795140105993614, 3.528856131385693],
            [31.79846506820249, 3.536123625673701],
            [31.80231857846331, 3.54082301549987],
            [31.80847569609938, 3.544277164057163],
            [31.81505113131545, 3.548993649055531],
            [31.817900220884056, 3.549633656301626],
            [31.822096857040666, 3.548896637739467],
            [31.829326345733666, 3.54956872152748],
            [31.832874709072247, 3.549505752078459],
            [31.835297341426006, 3.549200740386849],
            [31.838456731551634, 3.548188067495326],
            [31.845260468207275, 3.5451549797185],
            [31.849595317356908, 3.541331828938966],
            [31.854609449168144, 3.535619492344975],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 843,
        District: "MOYO",
        County: "WEST MOYO",
        Subcounty: "LAROPI",
        Population: 9621,
        Key: "MOYOLAROPI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.10576983459764, 3.017606329770614],
            [34.10202515433518, 3.017268198138714],
            [34.10095088783301, 3.020050144890848],
            [34.10141520634212, 3.02059356143559],
            [34.10149344331516, 3.021525852494913],
            [34.089595967046066, 3.027520678925],
            [34.08341634661214, 3.026857081073835],
            [34.07950053998301, 3.028173851624461],
            [34.07900315358999, 3.027043618829132],
            [34.078274748353635, 3.026495609865297],
            [34.07822449659663, 3.025863779073911],
            [34.07738044584388, 3.025465543194009],
            [34.07771073661091, 3.024899846028276],
            [34.07699915322661, 3.024634501742314],
            [34.07656830235173, 3.023870022739441],
            [34.07250759656895, 3.024800713313041],
            [34.070048150356534, 3.026101209160456],
            [34.06808726463522, 3.025139493866828],
            [34.06088669630448, 3.024020845287948],
            [34.05570288621076, 3.023832942577308],
            [34.05286969322946, 3.024275703940968],
            [34.05207302052309, 3.020868619254117],
            [34.049444126895274, 3.018057871496889],
            [34.04857295959734, 3.016068559269991],
            [34.04889309401178, 3.011702499897366],
            [34.04456860513234, 3.009528995530006],
            [34.043549014589914, 3.007797919392877],
            [34.04243876966229, 3.003807419532091],
            [34.04092437179, 3.000209072605923],
            [34.03280885137609, 2.991480111715134],
            [34.021653020612305, 2.982170827237199],
            [34.01374955919931, 2.972862431041724],
            [34.01166044436109, 2.973987919450094],
            [34.00971275668793, 2.976228237023999],
            [34.00273599732201, 2.980343750426242],
            [34.004252813459026, 2.973438854908453],
            [34.00641538174141, 2.967711549296534],
            [34.00650401940882, 2.962520280559239],
            [34.00589705382249, 2.953426736615077],
            [34.00619749626756, 2.935450973980629],
            [34.03104698381273, 2.920755974262905],
            [34.04122631531995, 2.909570494719209],
            [34.040004929028704, 2.908745215603414],
            [34.038813579705675, 2.904630549424795],
            [34.03694897900976, 2.902153762791723],
            [34.03432976472914, 2.90027467722718],
            [34.03084584024081, 2.898504922583458],
            [34.027457952842916, 2.893478620281409],
            [34.02521487125657, 2.889012090863769],
            [34.022694516572926, 2.885079496899357],
            [34.021274653807914, 2.879960912160244],
            [34.02163341847451, 2.87836055508682],
            [34.02910030225269, 2.886604980616321],
            [34.03209941586362, 2.891459439538971],
            [34.04226163266804, 2.898347735492149],
            [34.0476334547608, 2.901731716530498],
            [34.052900924956916, 2.905914928238404],
            [34.06665470687859, 2.914936931256191],
            [34.07305215529416, 2.924664965683526],
            [34.07845464048085, 2.927821355850416],
            [34.08422447104175, 2.930327787598138],
            [34.08607251938022, 2.931603287662662],
            [34.087389992169165, 2.933181137203576],
            [34.08747559442921, 2.933906599855118],
            [34.08632969357132, 2.934163786807354],
            [34.08718017446487, 2.935699407217906],
            [34.08671392727287, 2.936425418179035],
            [34.08709813132996, 2.938644362924829],
            [34.08786351032508, 2.939966673071718],
            [34.08884015241378, 2.940264468237971],
            [34.08977496804453, 2.941202490060675],
            [34.08871424903512, 2.94175835108305],
            [34.08858662178946, 2.943027861410474],
            [34.088802223745866, 2.944916530294554],
            [34.08946154135031, 2.946303102344357],
            [34.08927104281453, 2.946836639394958],
            [34.089993573068895, 2.947732196473042],
            [34.090279629893054, 2.949381488207478],
            [34.09211809680068, 2.949778704743362],
            [34.092758107813076, 2.953107044419624],
            [34.09543323862689, 2.954376692513873],
            [34.09585959253546, 2.955750072274414],
            [34.09823845807028, 2.957412202435646],
            [34.098874423070605, 2.956600660333109],
            [34.09972369034021, 2.956855896192288],
            [34.10057210960018, 2.956257541665409],
            [34.10133735115308, 2.957409112758249],
            [34.1004919250796, 2.961037678148583],
            [34.10078941745731, 2.961378808225482],
            [34.10151078349506, 2.961079335726357],
            [34.102215695091786, 2.961831960989781],
            [34.101146531020404, 2.962599500273227],
            [34.10052726031133, 2.964209731124227],
            [34.10141064739204, 2.965325720750557],
            [34.10102018297571, 2.967001424186329],
            [34.101936023492705, 2.967887434978068],
            [34.10265769046609, 2.970401406339396],
            [34.10116841308243, 2.971491061403914],
            [34.099865687935505, 2.970861548362816],
            [34.09956790899522, 2.971161485605835],
            [34.09936504425123, 2.972249848086182],
            [34.1001965239799, 2.972264789400493],
            [34.100400935622794, 2.972737696471881],
            [34.099414248572614, 2.974410356446158],
            [34.09965064922278, 2.9754982833168],
            [34.097627391674656, 2.976004964959577],
            [34.097251629984584, 2.976762323936214],
            [34.096073995240936, 2.975722649950776],
            [34.094834811527335, 2.975897363635066],
            [34.09364491567841, 2.978327208060871],
            [34.0941944510703, 2.978784005073591],
            [34.09424213723886, 2.979414781194459],
            [34.09348943257409, 2.979746711208539],
            [34.09330209700642, 2.980677357737108],
            [34.09243991735291, 2.981356350073806],
            [34.09275424326073, 2.981923774284654],
            [34.09347572428285, 2.981749576491504],
            [34.09369575044202, 2.982143620922731],
            [34.093430813908526, 2.983925952912417],
            [34.093980696948464, 2.984729698896143],
            [34.09344747047054, 2.984903706929732],
            [34.092458269934184, 2.984053087744259],
            [34.091488500855704, 2.986987373122877],
            [34.093262692406476, 2.988420715317748],
            [34.09461156939945, 2.98810395598709],
            [34.095004728761644, 2.989065562196867],
            [34.094816986257165, 2.98958617571796],
            [34.093154984403895, 2.990549843940083],
            [34.093376266407844, 2.992205522707702],
            [34.09224765722086, 2.99316865485921],
            [34.09242185852076, 2.994808613578463],
            [34.09173258838976, 2.995834387069536],
            [34.093428588781585, 2.997504360992928],
            [34.09247225580482, 2.998167680697171],
            [34.092959504709874, 2.999081881490054],
            [34.09380632137539, 2.998718308158965],
            [34.09443410901171, 2.99897000602305],
            [34.09560974680044, 2.997975283612138],
            [34.09595523796039, 2.998321885228805],
            [34.09532966467125, 3.000293826407938],
            [34.096695388669055, 3.00112828459319],
            [34.09690059711764, 3.002389716577533],
            [34.09831238582487, 3.002214816929954],
            [34.09815685510984, 3.003571234214036],
            [34.099414295284994, 3.005744176325243],
            [34.10099544876266, 3.006108398597459],
            [34.100871887291966, 3.006607376337377],
            [34.09952839210587, 3.007149163323511],
            [34.10167987787257, 3.010080410276906],
            [34.10356967900713, 3.011142657951775],
            [34.103549857680406, 3.012060770782187],
            [34.104276897477504, 3.012665144792242],
            [34.10459048407184, 3.014897480951026],
            [34.10619034137204, 3.01656512112121],
            [34.10576983459764, 3.017606329770614],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 844,
        District: "KOTIDO",
        County: "KOTIDO MUNICIPALITY",
        Subcounty: "KANAWAT DIVISION",
        Population: 16564,
        Key: "KOTIDOKANAWAT DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.27401951815737, 2.845670566015002],
            [34.267764008946585, 2.847127189635187],
            [34.26164324702838, 2.85006126801864],
            [34.25842822423725, 2.853920055782713],
            [34.256411951090456, 2.859570872062032],
            [34.24664367069092, 2.870032835043463],
            [34.24409213548379, 2.874398150337059],
            [34.238965111492455, 2.887012465975669],
            [34.237285995834746, 2.893553790567047],
            [34.236452758103056, 2.897099608886757],
            [34.2350232716864, 2.910936109888192],
            [34.23377187896975, 2.915666132479751],
            [34.22727647106906, 2.924566290471279],
            [34.225257926981214, 2.928296617986106],
            [34.2214396863751, 2.937334477429124],
            [34.214372951750335, 2.94875255919365],
            [34.21111794853914, 2.952145336019022],
            [34.20575274433506, 2.955304875380777],
            [34.204315369811894, 2.954052059246221],
            [34.20299585964386, 2.954472563380268],
            [34.20065372891599, 2.95352761529856],
            [34.195270902460976, 2.952310871372132],
            [34.19484521330572, 2.952280768409616],
            [34.194480921305185, 2.952800757835202],
            [34.19335525050747, 2.952129555623082],
            [34.19174429182701, 2.95255919588651],
            [34.190863484707755, 2.953415953207462],
            [34.18925092612776, 2.952347931522443],
            [34.18776076659848, 2.952013322548564],
            [34.18748797339954, 2.952808294562146],
            [34.18651507369231, 2.952839903779157],
            [34.18639423681188, 2.953573582932391],
            [34.184570114202664, 2.953697799331219],
            [34.18426684925098, 2.954431673490118],
            [34.18371941322187, 2.954279437380901],
            [34.1832418364775, 2.954648772333445],
            [34.184885863041885, 2.95593980959544],
            [34.18636950888704, 2.964502329095751],
            [34.18628371798078, 2.966946202511015],
            [34.1851385995555, 2.970768625018512],
            [34.18301209324189, 2.975673924642243],
            [34.15400402936206, 2.953890078548856],
            [34.15529130348612, 2.95019831606147],
            [34.1520176781991, 2.951151418243059],
            [34.151324582143296, 2.950772264897171],
            [34.15012848252901, 2.951153385635822],
            [34.148177284239736, 2.95210510273733],
            [34.147611241406175, 2.952802128638543],
            [34.14685568998027, 2.952929538879765],
            [34.14312887810714, 2.950773015790168],
            [34.14263111442167, 2.948881218698112],
            [34.1404760919877, 2.94604354708128],
            [34.140339931645144, 2.944420890657142],
            [34.13764826733851, 2.942936092135718],
            [34.1301131098021, 2.940239125135949],
            [34.1280935919405, 2.938347910336159],
            [34.124999377283714, 2.937810113215805],
            [34.11477302975115, 2.934033863331976],
            [34.11192101706462, 2.934767817730165],
            [34.10648008757704, 2.932778685333922],
            [34.105500292401686, 2.930219796974946],
            [34.10197700912754, 2.924733320969695],
            [34.1018475807597, 2.921064194018565],
            [34.1004993532487, 2.91781988381908],
            [34.096457872311326, 2.911332564925159],
            [34.09564796382756, 2.908358182509317],
            [34.09672282860773, 2.90714001413532],
            [34.09887425598395, 2.906461734667142],
            [34.10250549429739, 2.906052469163653],
            [34.105465256308996, 2.906725733756106],
            [34.11218360001205, 2.899686903245819],
            [34.11500578773285, 2.897249889759515],
            [34.11917352329014, 2.895352478561156],
            [34.12441939080031, 2.895617724616607],
            [34.1296628391474, 2.893448740033166],
            [34.132079044953635, 2.88857790722388],
            [34.13368541683625, 2.880867983022777],
            [34.12817023081067, 2.880197322839836],
            [34.11862041260339, 2.879936324922799],
            [34.10960778873269, 2.878863311524634],
            [34.0980419542968, 2.880226928899372],
            [34.09198369356282, 2.87428242332472],
            [34.08498743446704, 2.871990124570611],
            [34.0683211742571, 2.884853389515851],
            [34.0578341194594, 2.88946130378329],
            [34.04909427890617, 2.892715153449365],
            [34.04358276609179, 2.896236443133442],
            [34.04226163266804, 2.898347735492149],
            [34.03209941586362, 2.891459439538971],
            [34.02910030225269, 2.886604980616321],
            [34.02163341847451, 2.87836055508682],
            [34.01711346696902, 2.87326962731864],
            [34.01682258709012, 2.868316489703534],
            [34.01743266174567, 2.861706312185508],
            [34.01666353677583, 2.857634140340021],
            [34.01449772827021, 2.855621856643817],
            [34.011093695451684, 2.854707036376955],
            [34.00356652573479, 2.858083914693313],
            [34.00128596463815, 2.855668944379745],
            [34.00053476644811, 2.855806939077609],
            [33.99515582161345, 2.853258998701133],
            [33.99276616371885, 2.853261075722927],
            [33.986643807290996, 2.854617774791929],
            [33.97827983083582, 2.854474807665028],
            [33.96319560535083, 2.855238398770288],
            [33.965881993851774, 2.852833629044212],
            [33.96916076199381, 2.844422105511965],
            [33.9694535759455, 2.837364518744153],
            [33.97034531107018, 2.832108299642732],
            [33.96974565327867, 2.829405993149922],
            [33.96361466404098, 2.820251583670064],
            [33.9621189331603, 2.817550011331873],
            [33.96181899736502, 2.81604869446148],
            [33.95105334804828, 2.800741557446662],
            [33.94791496412726, 2.798191438765421],
            [33.941243526855075, 2.790930926970553],
            [33.940360338302014, 2.791573325317678],
            [33.93962329306928, 2.790784149463188],
            [33.940849711722734, 2.789598507639354],
            [33.940554124671735, 2.788315370146189],
            [33.94202522734059, 2.786142324894437],
            [33.942220659423896, 2.784957513736871],
            [33.943644274451884, 2.784808286876986],
            [33.943839784688635, 2.78372219668504],
            [33.945066546498516, 2.782980802514138],
            [33.944525923292524, 2.782240830028226],
            [33.94393667607687, 2.782093222372298],
            [33.94177708481133, 2.782786006466227],
            [33.94212954510126, 2.78111384676721],
            [33.94153043887537, 2.781305387842647],
            [33.940793633492795, 2.780812371886734],
            [33.94030293056547, 2.781108928003036],
            [33.94020544539085, 2.781997498559796],
            [33.939076164264044, 2.781850319762102],
            [33.937309791649504, 2.783135109867202],
            [33.93716317312041, 2.783974358581735],
            [33.936328606780414, 2.784024384139157],
            [33.936082630987656, 2.783382895077175],
            [33.93505180701258, 2.78358115981564],
            [33.933580146489966, 2.785063152865474],
            [33.933580690869036, 2.785754201719007],
            [33.93304116001445, 2.78639632115582],
            [33.932304860383375, 2.786544987031235],
            [33.931125972489944, 2.785756156834827],
            [33.93019379880446, 2.786546665791789],
            [33.93010693530972, 2.787569131910157],
            [33.92932927993794, 2.788352243603511],
            [33.92873202693646, 2.787622391012092],
            [33.927798613575874, 2.788275207362693],
            [33.92766941158351, 2.788927388994372],
            [33.926942573009036, 2.788354136804635],
            [33.92619028426425, 2.788406896999113],
            [33.9261130300481, 2.789137287454472],
            [33.92499876515957, 2.790755321721882],
            [33.92551896516758, 2.792476394689892],
            [33.92510400728669, 2.792633220271336],
            [33.9245848933419, 2.792294551999123],
            [33.92352143087762, 2.79253014077547],
            [33.92235311974835, 2.791383406345272],
            [33.92105564615255, 2.790941017441246],
            [33.91900719984389, 2.792246786065713],
            [33.91825600075553, 2.793708034599582],
            [33.91781519834393, 2.793995296469259],
            [33.9171144243874, 2.793578513307664],
            [33.91654443525479, 2.794544039400147],
            [33.91563668496523, 2.79485775010535],
            [33.915194710252194, 2.793632188460241],
            [33.914753866518105, 2.793867280790371],
            [33.913326213562925, 2.792825070817317],
            [33.91298926088972, 2.793216583256415],
            [33.91275543481117, 2.792773352526498],
            [33.911432197533045, 2.792565717576475],
            [33.90904714080931, 2.794732484582105],
            [33.90863149302228, 2.794002478934761],
            [33.90601132113755, 2.794056679854921],
            [33.905076563897275, 2.792987991359151],
            [33.90413338315462, 2.792660422152396],
            [33.904297970684354, 2.790706371355975],
            [33.900855915773114, 2.789421729484694],
            [33.89204146474566, 2.752018717401638],
            [33.88982441004802, 2.744063528772461],
            [33.885913513610255, 2.732758731282242],
            [33.885354894454174, 2.727720841903865],
            [33.88594934830524, 2.724501970483449],
            [33.88412165848605, 2.717618130971269],
            [33.88188836314642, 2.696942836980308],
            [33.882196200522934, 2.69691368304348],
            [33.88103588350134, 2.680875818103936],
            [33.88090785291212, 2.670454802873253],
            [33.96576081381488, 2.61670450789719],
            [33.98672389928511, 2.644158034990319],
            [33.98659252067481, 2.65098655186912],
            [33.982610072526334, 2.65608147729793],
            [33.982865805819735, 2.662637591183951],
            [33.98650713670536, 2.668957447921821],
            [34.00016545017021, 2.681915207323331],
            [34.019642065492, 2.699035375348041],
            [34.02602852751167, 2.705741619289476],
            [34.031138361341746, 2.711857716225206],
            [34.040265580598316, 2.718793784776919],
            [34.047652607740986, 2.725680748250575],
            [34.052183244706775, 2.727809739852184],
            [34.06215354992548, 2.736018914304865],
            [34.070808803314925, 2.741181457693466],
            [34.0841784844857, 2.745373002794544],
            [34.09439553086183, 2.75187053890201],
            [34.10307545917551, 2.755358485698503],
            [34.11774821673448, 2.758143710187069],
            [34.12513599576705, 2.758755579550212],
            [34.14098292596257, 2.75889508593625],
            [34.148604438547224, 2.759617660525371],
            [34.15676534274762, 2.757361281959785],
            [34.17138454454601, 2.752186941098673],
            [34.19107822787476, 2.745923735102568],
            [34.20334321660468, 2.742885824275846],
            [34.21466223532296, 2.739472770033244],
            [34.226918756533, 2.736969939477217],
            [34.23581403078322, 2.733639532401671],
            [34.25092021648364, 2.729464123611161],
            [34.25586911443562, 2.728855918172685],
            [34.25760953382325, 2.72864531456276],
            [34.260913631761376, 2.727058718745099],
            [34.261893763804935, 2.735391441052776],
            [34.26181456114295, 2.744521214141828],
            [34.26442397031228, 2.769208084100284],
            [34.266485868892346, 2.778837408753556],
            [34.267450920917234, 2.790963127469291],
            [34.269290269970476, 2.802531029483357],
            [34.27038351787462, 2.81983598254913],
            [34.27191147851106, 2.835370385313655],
            [34.27401951815737, 2.845670566015002],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 845,
        District: "KOTIDO",
        County: "JIE",
        Subcounty: "PANYANGARA",
        Population: 17806,
        Key: "KOTIDOPANYANGARA",
        Dist2: "Kotido",
        "Sub Country": "Panyangara",
        id2_original: "KotidoPanyangara",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.18301209324189, 2.975673924642243],
            [34.18025736271074, 2.980587462932973],
            [34.18286657335238, 2.981157306120913],
            [34.18299875325993, 2.981554123698116],
            [34.182632458914625, 2.982070799823745],
            [34.18152880582454, 2.989698302432275],
            [34.179677987081725, 2.992613453034576],
            [34.17788626760315, 2.992541374523647],
            [34.17673221902563, 2.992049187621459],
            [34.17488988666732, 2.990546204438155],
            [34.17408028181414, 2.990843136440705],
            [34.17258575377761, 2.993287236664478],
            [34.171113851608176, 2.993930284709156],
            [34.16820785825793, 2.996504369554388],
            [34.16835589971843, 2.999132442989598],
            [34.16903413494445, 2.999496746409855],
            [34.17005420249231, 3.001520884932518],
            [34.15400242137773, 3.003282993899178],
            [34.1526194757776, 3.000899911395572],
            [34.153255940241216, 3.000619196010827],
            [34.15229753125787, 2.997499774191058],
            [34.15197860867074, 2.996980037295264],
            [34.15110357053227, 2.997461030830501],
            [34.15062545839197, 2.99694146167148],
            [34.14942949262669, 2.994982446875239],
            [34.14954700663889, 2.993182070836706],
            [34.14891062482024, 2.993542789673679],
            [34.14807271764573, 2.991463375582402],
            [34.14711716979654, 2.991064323342179],
            [34.14651933828002, 2.990224834667339],
            [34.14353401740197, 2.989707888763884],
            [34.141425260900036, 2.990190168333581],
            [34.14003215086248, 2.989991593366451],
            [34.13756253841598, 2.987873860344396],
            [34.13724271841192, 2.986473989853998],
            [34.13477377610862, 2.984996338422267],
            [34.13266444648154, 2.984918514404974],
            [34.130977823603025, 2.985827218976448],
            [34.12894834432324, 2.985619430044706],
            [34.1277694384635, 2.98496358004764],
            [34.12689536960721, 2.986404696420671],
            [34.126018197969934, 2.984805362718199],
            [34.123072225996275, 2.983848246339068],
            [34.12227551017077, 2.983088948226855],
            [34.12139818671823, 2.98132958242083],
            [34.12091802731737, 2.978769685539006],
            [34.11970392636312, 2.977113469796563],
            [34.11932400457495, 2.976650990736127],
            [34.117891471072845, 2.976812478281901],
            [34.117253992411236, 2.97609301748675],
            [34.11689372216824, 2.974013065314894],
            [34.115739209161724, 2.973614178089402],
            [34.11365822138187, 2.971346906094457],
            [34.113047362497085, 2.970028250473149],
            [34.112073609390336, 2.969663403503878],
            [34.11177630745549, 2.968871997934338],
            [34.110947043870624, 2.969272865896559],
            [34.11065894876912, 2.969017808733824],
            [34.11084284738252, 2.966668483778264],
            [34.11046924973395, 2.966378932073691],
            [34.109742528838765, 2.966916430980088],
            [34.10852877643085, 2.966503583930322],
            [34.10814361476962, 2.964726898020063],
            [34.10784692728242, 2.964550087809278],
            [34.107373203412294, 2.964939037401331],
            [34.10642149047104, 2.964519557256138],
            [34.10575490819087, 2.962440540513045],
            [34.10348880637707, 2.961015788519481],
            [34.102215695091786, 2.961831960989781],
            [34.10151078349506, 2.961079335726357],
            [34.10078941745731, 2.961378808225482],
            [34.1004919250796, 2.961037678148583],
            [34.10133735115308, 2.957409112758249],
            [34.10057210960018, 2.956257541665409],
            [34.09972369034021, 2.956855896192288],
            [34.098874423070605, 2.956600660333109],
            [34.09823845807028, 2.957412202435646],
            [34.09585959253546, 2.955750072274414],
            [34.09543323862689, 2.954376692513873],
            [34.092758107813076, 2.953107044419624],
            [34.09211809680068, 2.949778704743362],
            [34.090279629893054, 2.949381488207478],
            [34.089993573068895, 2.947732196473042],
            [34.08927104281453, 2.946836639394958],
            [34.08946154135031, 2.946303102344357],
            [34.088802223745866, 2.944916530294554],
            [34.08858662178946, 2.943027861410474],
            [34.08871424903512, 2.94175835108305],
            [34.08977496804453, 2.941202490060675],
            [34.08884015241378, 2.940264468237971],
            [34.08786351032508, 2.939966673071718],
            [34.08709813132996, 2.938644362924829],
            [34.08671392727287, 2.936425418179035],
            [34.08718017446487, 2.935699407217906],
            [34.08632969357132, 2.934163786807354],
            [34.08747559442921, 2.933906599855118],
            [34.087389992169165, 2.933181137203576],
            [34.08607251938022, 2.931603287662662],
            [34.08422447104175, 2.930327787598138],
            [34.07845464048085, 2.927821355850416],
            [34.07305215529416, 2.924664965683526],
            [34.06665470687859, 2.914936931256191],
            [34.052900924956916, 2.905914928238404],
            [34.0476334547608, 2.901731716530498],
            [34.04226163266804, 2.898347735492149],
            [34.04358276609179, 2.896236443133442],
            [34.04909427890617, 2.892715153449365],
            [34.0578341194594, 2.88946130378329],
            [34.0683211742571, 2.884853389515851],
            [34.08498743446704, 2.871990124570611],
            [34.09198369356282, 2.87428242332472],
            [34.0980419542968, 2.880226928899372],
            [34.10960778873269, 2.878863311524634],
            [34.11862041260339, 2.879936324922799],
            [34.12817023081067, 2.880197322839836],
            [34.13368541683625, 2.880867983022777],
            [34.132079044953635, 2.88857790722388],
            [34.1296628391474, 2.893448740033166],
            [34.12441939080031, 2.895617724616607],
            [34.11917352329014, 2.895352478561156],
            [34.11500578773285, 2.897249889759515],
            [34.11218360001205, 2.899686903245819],
            [34.105465256308996, 2.906725733756106],
            [34.10250549429739, 2.906052469163653],
            [34.09887425598395, 2.906461734667142],
            [34.09672282860773, 2.90714001413532],
            [34.09564796382756, 2.908358182509317],
            [34.096457872311326, 2.911332564925159],
            [34.1004993532487, 2.91781988381908],
            [34.1018475807597, 2.921064194018565],
            [34.10197700912754, 2.924733320969695],
            [34.105500292401686, 2.930219796974946],
            [34.10648008757704, 2.932778685333922],
            [34.11192101706462, 2.934767817730165],
            [34.11477302975115, 2.934033863331976],
            [34.124999377283714, 2.937810113215805],
            [34.1280935919405, 2.938347910336159],
            [34.1301131098021, 2.940239125135949],
            [34.13764826733851, 2.942936092135718],
            [34.140339931645144, 2.944420890657142],
            [34.1404760919877, 2.94604354708128],
            [34.14263111442167, 2.948881218698112],
            [34.14312887810714, 2.950773015790168],
            [34.14685568998027, 2.952929538879765],
            [34.147611241406175, 2.952802128638543],
            [34.148177284239736, 2.95210510273733],
            [34.15012848252901, 2.951153385635822],
            [34.151324582143296, 2.950772264897171],
            [34.1520176781991, 2.951151418243059],
            [34.15529130348612, 2.95019831606147],
            [34.15400402936206, 2.953890078548856],
            [34.18301209324189, 2.975673924642243],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 846,
        District: "KOTIDO",
        County: "KOTIDO MUNICIPALITY",
        Subcounty: "KAPADAKOOK DIVISION",
        Population: 22152,
        Key: "KOTIDOKAPADAKOOK DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.034532836085624, 3.028758738792634],
            [34.03321677993986, 3.028723805463539],
            [34.03169078661391, 3.027070482243981],
            [34.03146118171885, 3.024708960732794],
            [34.031460820596116, 3.024328035075369],
            [34.03358161631948, 3.022916579997397],
            [34.03388362183316, 3.021697327629941],
            [34.032936351061, 3.021812510937535],
            [34.03054834876144, 3.021167216931679],
            [34.027591203542265, 3.019760605497876],
            [34.026036288057426, 3.01846693323213],
            [34.024290578491055, 3.015764006329704],
            [34.02394831228299, 3.014469176569846],
            [34.02446929202861, 3.013361374279559],
            [34.02211268135666, 3.013975780428361],
            [34.01961480970797, 3.014071133867632],
            [34.016446776891, 3.013968658568351],
            [34.01638633015388, 3.013549775779632],
            [34.007773974912496, 3.015570225476064],
            [34.00277828102242, 3.015853864154475],
            [33.99398849413941, 3.015210968967726],
            [33.988436576001845, 3.014286045529438],
            [33.982608439389146, 3.014849356629763],
            [33.97350146726075, 3.013840517110099],
            [33.971380772148706, 3.015400347955516],
            [33.969855493881724, 3.017466763660047],
            [33.967278294705224, 3.019570830765712],
            [33.96568395934908, 3.021986808197109],
            [33.96333256070241, 3.023719929483557],
            [33.96078066077926, 3.028507351024562],
            [33.95949071057399, 3.031932947602381],
            [33.95711453729008, 3.030980974161957],
            [33.949789875685994, 3.026410608720205],
            [33.93652321061706, 3.015510953278168],
            [33.922965795026606, 3.005050699596147],
            [33.91793674130018, 3.001466684077857],
            [33.91266030052763, 2.998520882110095],
            [33.88828111157644, 2.970108155040182],
            [33.882867139632225, 2.962568082419828],
            [33.87723626856434, 2.959798888633919],
            [33.854824804208704, 2.950607771773391],
            [33.85150411259066, 2.948909160576762],
            [33.85257663366627, 2.948332604627811],
            [33.86173276879351, 2.946061158601913],
            [33.865844620157006, 2.943802083848117],
            [33.86854658275002, 2.937100769236362],
            [33.86738387261656, 2.932303291427594],
            [33.86757270118423, 2.930691235377425],
            [33.865706072092394, 2.924847094221723],
            [33.865202532239685, 2.922032285474872],
            [33.866073761521356, 2.919482874292189],
            [33.867775847999205, 2.918524897800482],
            [33.86909375736938, 2.916441839785756],
            [33.87327425619023, 2.912634793075103],
            [33.87406599714567, 2.908516419677045],
            [33.87385096112791, 2.89905659074951],
            [33.87478188166358, 2.894977599313418],
            [33.876839542890465, 2.891647811472654],
            [33.87720364444815, 2.890378610084024],
            [33.878267600087504, 2.889703571924516],
            [33.87828903299188, 2.88907173226912],
            [33.8799679618, 2.887613327335961],
            [33.88030550646295, 2.8861531046465],
            [33.881349559927216, 2.885925564686452],
            [33.882798690702494, 2.883798888631772],
            [33.88405830030907, 2.883096840601561],
            [33.884658926484455, 2.881566919215387],
            [33.887787383123225, 2.87778021188842],
            [33.88794681791651, 2.876715192157318],
            [33.88940702941082, 2.87582668431419],
            [33.8900690204016, 2.874574990886039],
            [33.89012746838724, 2.873438977437969],
            [33.89247930900504, 2.869817138344403],
            [33.89287014981546, 2.867673199908426],
            [33.89380199920913, 2.866380017698761],
            [33.894006687533164, 2.864220960501773],
            [33.8936939336771, 2.863342049198725],
            [33.89538578744555, 2.86102860404949],
            [33.89514524017201, 2.859732387196631],
            [33.89593519707332, 2.858179513814164],
            [33.89502432244321, 2.856075050115289],
            [33.89493955561637, 2.855527830101397],
            [33.89540241526146, 2.854913211241321],
            [33.894458459272705, 2.852920686342702],
            [33.894449216506736, 2.850415504792311],
            [33.893879440274844, 2.849463854621124],
            [33.89413899500146, 2.848456720483459],
            [33.89347095834886, 2.846237567853741],
            [33.89384432243544, 2.845490128589441],
            [33.89336008827649, 2.84465374858055],
            [33.89371852685464, 2.84425147438173],
            [33.89360719594652, 2.842797136807779],
            [33.89409676430164, 2.841085351670249],
            [33.89385698598599, 2.839299508973827],
            [33.894458810513974, 2.838811401938464],
            [33.89446331466678, 2.836623107502849],
            [33.8949507710827, 2.835832610040906],
            [33.895051618651415, 2.831840799422608],
            [33.89572055541595, 2.829989669721006],
            [33.89473047632726, 2.827192382869776],
            [33.89506046436203, 2.824171330545939],
            [33.893962039466885, 2.823059796603302],
            [33.89347804785308, 2.821777047546871],
            [33.89353064421297, 2.820704759608589],
            [33.89411055793281, 2.820224026231926],
            [33.89418771872417, 2.81744569765018],
            [33.894933200934034, 2.81658376850939],
            [33.89360480552955, 2.815614876259851],
            [33.89208974739556, 2.810890156820432],
            [33.8945669389281, 2.806706622273685],
            [33.89631255596797, 2.806380178449829],
            [33.8990243146892, 2.803992962353328],
            [33.900195571394285, 2.800154874817333],
            [33.903421405409894, 2.796020056433362],
            [33.90413338315462, 2.792660422152396],
            [33.905076563897275, 2.792987991359151],
            [33.90601132113755, 2.794056679854921],
            [33.90863149302228, 2.794002478934761],
            [33.90904714080931, 2.794732484582105],
            [33.911432197533045, 2.792565717576475],
            [33.91275543481117, 2.792773352526498],
            [33.91298926088972, 2.793216583256415],
            [33.913326213562925, 2.792825070817317],
            [33.914753866518105, 2.793867280790371],
            [33.915194710252194, 2.793632188460241],
            [33.91563668496523, 2.79485775010535],
            [33.91654443525479, 2.794544039400147],
            [33.9171144243874, 2.793578513307664],
            [33.91781519834393, 2.793995296469259],
            [33.91825600075553, 2.793708034599582],
            [33.91900719984389, 2.792246786065713],
            [33.92105564615255, 2.790941017441246],
            [33.92235311974835, 2.791383406345272],
            [33.92352143087762, 2.79253014077547],
            [33.9245848933419, 2.792294551999123],
            [33.92510400728669, 2.792633220271336],
            [33.92551896516758, 2.792476394689892],
            [33.92499876515957, 2.790755321721882],
            [33.9261130300481, 2.789137287454472],
            [33.92619028426425, 2.788406896999113],
            [33.926942573009036, 2.788354136804635],
            [33.92766941158351, 2.788927388994372],
            [33.927798613575874, 2.788275207362693],
            [33.92873202693646, 2.787622391012092],
            [33.92932927993794, 2.788352243603511],
            [33.93010693530972, 2.787569131910157],
            [33.93019379880446, 2.786546665791789],
            [33.931125972489944, 2.785756156834827],
            [33.932304860383375, 2.786544987031235],
            [33.93304116001445, 2.78639632115582],
            [33.933580690869036, 2.785754201719007],
            [33.933580146489966, 2.785063152865474],
            [33.93505180701258, 2.78358115981564],
            [33.936082630987656, 2.783382895077175],
            [33.936328606780414, 2.784024384139157],
            [33.93716317312041, 2.783974358581735],
            [33.937309791649504, 2.783135109867202],
            [33.939076164264044, 2.781850319762102],
            [33.94020544539085, 2.781997498559796],
            [33.94030293056547, 2.781108928003036],
            [33.940793633492795, 2.780812371886734],
            [33.94153043887537, 2.781305387842647],
            [33.94212954510126, 2.78111384676721],
            [33.94177708481133, 2.782786006466227],
            [33.94393667607687, 2.782093222372298],
            [33.944525923292524, 2.782240830028226],
            [33.945066546498516, 2.782980802514138],
            [33.943839784688635, 2.78372219668504],
            [33.943644274451884, 2.784808286876986],
            [33.942220659423896, 2.784957513736871],
            [33.94202522734059, 2.786142324894437],
            [33.940554124671735, 2.788315370146189],
            [33.940849711722734, 2.789598507639354],
            [33.93962329306928, 2.790784149463188],
            [33.940360338302014, 2.791573325317678],
            [33.941243526855075, 2.790930926970553],
            [33.94791496412726, 2.798191438765421],
            [33.95105334804828, 2.800741557446662],
            [33.96181899736502, 2.81604869446148],
            [33.9621189331603, 2.817550011331873],
            [33.96361466404098, 2.820251583670064],
            [33.96974565327867, 2.829405993149922],
            [33.97034531107018, 2.832108299642732],
            [33.9694535759455, 2.837364518744153],
            [33.96916076199381, 2.844422105511965],
            [33.965881993851774, 2.852833629044212],
            [33.96319560535083, 2.855238398770288],
            [33.97827983083582, 2.854474807665028],
            [33.986643807290996, 2.854617774791929],
            [33.99276616371885, 2.853261075722927],
            [33.99515582161345, 2.853258998701133],
            [34.00053476644811, 2.855806939077609],
            [34.00128596463815, 2.855668944379745],
            [34.00356652573479, 2.858083914693313],
            [34.011093695451684, 2.854707036376955],
            [34.01449772827021, 2.855621856643817],
            [34.01666353677583, 2.857634140340021],
            [34.01743266174567, 2.861706312185508],
            [34.01682258709012, 2.868316489703534],
            [34.01711346696902, 2.87326962731864],
            [34.02163341847451, 2.87836055508682],
            [34.021274653807914, 2.879960912160244],
            [34.022694516572926, 2.885079496899357],
            [34.02521487125657, 2.889012090863769],
            [34.027457952842916, 2.893478620281409],
            [34.03084584024081, 2.898504922583458],
            [34.03432976472914, 2.90027467722718],
            [34.03694897900976, 2.902153762791723],
            [34.038813579705675, 2.904630549424795],
            [34.040004929028704, 2.908745215603414],
            [34.04122631531995, 2.909570494719209],
            [34.03104698381273, 2.920755974262905],
            [34.00619749626756, 2.935450973980629],
            [34.00589705382249, 2.953426736615077],
            [34.00650401940882, 2.962520280559239],
            [34.00641538174141, 2.967711549296534],
            [34.004252813459026, 2.973438854908453],
            [34.00273599732201, 2.980343750426242],
            [34.00971275668793, 2.976228237023999],
            [34.01166044436109, 2.973987919450094],
            [34.01374955919931, 2.972862431041724],
            [34.021653020612305, 2.982170827237199],
            [34.03280885137609, 2.991480111715134],
            [34.04092437179, 3.000209072605923],
            [34.04243876966229, 3.003807419532091],
            [34.043549014589914, 3.007797919392877],
            [34.04456860513234, 3.009528995530006],
            [34.04889309401178, 3.011702499897366],
            [34.04857295959734, 3.016068559269991],
            [34.049444126895274, 3.018057871496889],
            [34.05207302052309, 3.020868619254117],
            [34.05286969322946, 3.024275703940968],
            [34.04330269833565, 3.025481742360988],
            [34.03921564586389, 3.027312400065612],
            [34.034532836085624, 3.028758738792634],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 847,
        District: "KOTIDO",
        County: "JIE",
        Subcounty: "KOTIDO",
        Population: 8455,
        Key: "KOTIDOKOTIDO",
        Dist2: "Kotido",
        "Sub Country": "Kotido SC",
        id2_original: "KotidoKotido SC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.13170566559566, 3.014139809258428],
            [34.13291019230561, 3.014374512117056],
            [34.13661522542301, 3.013659376568758],
            [34.141424447026395, 3.013596419987945],
            [34.144534074078514, 3.013057594755841],
            [34.14701553081204, 3.013545158544739],
            [34.15014372424447, 3.013419718123851],
            [34.15017602676376, 3.015251519297281],
            [34.14987214556776, 3.015099189347652],
            [34.14926550606988, 3.015863100398783],
            [34.15014703363798, 3.016564365787791],
            [34.150301271677286, 3.018823468752228],
            [34.14993783487292, 3.019800835404456],
            [34.150242170616444, 3.02038059227469],
            [34.15012261114032, 3.022212554849349],
            [34.14981914586431, 3.022457124583938],
            [34.15006356846996, 3.023830739386794],
            [34.14945654089989, 3.02422828692182],
            [34.1492162370698, 3.02676258006929],
            [34.149855601295194, 3.028227369382217],
            [34.15234772731932, 3.029720703844196],
            [34.152986135737216, 3.03026957235296],
            [34.15326088007699, 3.031582091183171],
            [34.15459791547786, 3.032191270624325],
            [34.15535963204157, 3.034449713083899],
            [34.154934904083646, 3.034908125516076],
            [34.155967831913124, 3.035151262477477],
            [34.15621126816859, 3.035578425708289],
            [34.15560524581331, 3.036922422884422],
            [34.156152149141406, 3.037105017250763],
            [34.15612235920997, 3.037654598756003],
            [34.15642615326937, 3.037715333733281],
            [34.156245702390066, 3.039394706306138],
            [34.156792899467284, 3.039852075162611],
            [34.156944340152826, 3.03945501508597],
            [34.15727876945838, 3.039759958759233],
            [34.158039485298836, 3.041071952050367],
            [34.167388044051535, 3.035261044082604],
            [34.16945524179344, 3.036999032163993],
            [34.17024496333614, 3.037028701315259],
            [34.17134067801404, 3.039164634963061],
            [34.17206991958192, 3.039438609806427],
            [34.17383360533541, 3.04136009531422],
            [34.17413941431601, 3.043283172350303],
            [34.17371644795439, 3.045359700151902],
            [34.17438511252937, 3.045786390184928],
            [34.174751308060024, 3.047373564461482],
            [34.17633334637823, 3.049814253377564],
            [34.17636478292159, 3.050791189230909],
            [34.177793631534435, 3.05201082856824],
            [34.17852481615823, 3.054055552034861],
            [34.17898070847001, 3.054329821802369],
            [34.17892961499159, 3.054960659045522],
            [34.18060794372511, 3.056271266717186],
            [34.18434327432208, 3.057893306762442],
            [34.1946450614739, 3.065215760535165],
            [34.20739525095002, 3.075090716303157],
            [34.20725224364836, 3.075505489230035],
            [34.20534070957212, 3.076195599892589],
            [34.20530097349384, 3.076661014578305],
            [34.2064707228259, 3.078642564137302],
            [34.207440093950694, 3.081433673044323],
            [34.206876623892086, 3.081575949710577],
            [34.206614365236476, 3.081070412716632],
            [34.20619178065882, 3.081192296655084],
            [34.205750409613636, 3.082507971692296],
            [34.20675712460311, 3.082709159701114],
            [34.20701937966546, 3.083214698607558],
            [34.20675840290574, 3.083842231241408],
            [34.20633576802245, 3.083923645163805],
            [34.20605333679882, 3.083377662888381],
            [34.20508767930942, 3.083884599025508],
            [34.206558245684036, 3.08485413119528],
            [34.20520955194737, 3.084855668676521],
            [34.20472746386364, 3.08576672100729],
            [34.20424368694717, 3.085346012953925],
            [34.204219770201014, 3.086764823982454],
            [34.20510113337741, 3.086857513120264],
            [34.20470318419813, 3.087305590190259],
            [34.20552494056218, 3.088553288492025],
            [34.20760936260134, 3.087137360156314],
            [34.20800866913504, 3.087890797636714],
            [34.20871112743269, 3.087277456321395],
            [34.20901652498489, 3.087889644977582],
            [34.209391055084744, 3.08746515237687],
            [34.20939214923274, 3.088431073503556],
            [34.195176164334484, 3.090022029048641],
            [34.18431168596344, 3.090599211254959],
            [34.16988931492527, 3.092498444305521],
            [34.16054490459258, 3.091204302660808],
            [34.16036523704416, 3.092370721250133],
            [34.158028095559374, 3.09280787672848],
            [34.13635644594249, 3.094798185040259],
            [34.123329777479796, 3.096708761251096],
            [34.12350732769908, 3.093239383576849],
            [34.122447817822064, 3.093103993895356],
            [34.121684805887696, 3.090784053338963],
            [34.12119541180575, 3.090347724965834],
            [34.121575150337605, 3.089828565674955],
            [34.122553339325215, 3.090013040119433],
            [34.123087554848276, 3.089272706767546],
            [34.124239616352384, 3.089599118728279],
            [34.123998924450085, 3.088026722601816],
            [34.125713215439404, 3.085731452257702],
            [34.12492853703871, 3.084725377448649],
            [34.12536825069218, 3.084245614960133],
            [34.1242899112285, 3.083701672661067],
            [34.12429818920386, 3.083308453708592],
            [34.124884724405675, 3.083133091772708],
            [34.125121070258615, 3.080577283921158],
            [34.12316539207101, 3.077685346873821],
            [34.12342230754732, 3.074601226650532],
            [34.121951396219615, 3.073494776104151],
            [34.120212374610574, 3.073239856452576],
            [34.12081637395982, 3.071495411038518],
            [34.12155054099039, 3.070817522895168],
            [34.12154928694227, 3.069617183855549],
            [34.121028207483604, 3.069094507980344],
            [34.12191309475088, 3.066138893792424],
            [34.12096148511589, 3.0638315525232],
            [34.121296468681955, 3.06207685840858],
            [34.12108094757396, 3.060938304418026],
            [34.119730008049075, 3.0611844773381],
            [34.11924326669215, 3.060447785666602],
            [34.1199159350584, 3.059523743291912],
            [34.11792461800851, 3.058510156227223],
            [34.118161695090095, 3.057578910773755],
            [34.11893381144984, 3.057308760132016],
            [34.11825929435077, 3.056447684390102],
            [34.117649813481634, 3.056803783069948],
            [34.117400330665966, 3.056310759692445],
            [34.117838273740034, 3.05542516978501],
            [34.11850040217303, 3.055212636279485],
            [34.11847590062363, 3.054825093171927],
            [34.114029433105046, 3.056639038601519],
            [34.111972029694655, 3.05800704018365],
            [34.10951010862364, 3.058118147968325],
            [34.10729688074913, 3.059450123639438],
            [34.10468632263454, 3.059950329922962],
            [34.10053364463803, 3.058697305665149],
            [34.09518328329739, 3.055934900002391],
            [34.090841500950425, 3.05451920469956],
            [34.08731951035197, 3.055752980711135],
            [34.083325884466404, 3.05886868967344],
            [34.08287839230086, 3.05958373877493],
            [34.07890440268909, 3.057624890171329],
            [34.07788212528567, 3.056612825378386],
            [34.07470684036944, 3.054779785536443],
            [34.07048324127955, 3.054015154760898],
            [34.068475809351796, 3.053112609797183],
            [34.06389194271386, 3.054275013603493],
            [34.06339391312708, 3.05508056350586],
            [34.06216972499048, 3.055751152547684],
            [34.05926700240617, 3.054858524909576],
            [34.05700294695456, 3.055493957368859],
            [34.05583985234214, 3.055386561256935],
            [34.057107065289244, 3.054288000040415],
            [34.05692529927635, 3.053741606132906],
            [34.05421667657379, 3.054561104494919],
            [34.052500607818544, 3.054149830873736],
            [34.053467014502885, 3.049524565873215],
            [34.052887853571214, 3.048939971630276],
            [34.05086716879808, 3.048342154638392],
            [34.04895764874473, 3.046142461897321],
            [34.04916641542012, 3.042875421613107],
            [34.04807534323559, 3.039985249589844],
            [34.04660623931827, 3.040289486237135],
            [34.04546581548867, 3.038599068754729],
            [34.04298634582855, 3.038022560000336],
            [34.04167950549931, 3.036956444542198],
            [34.04019551290445, 3.034117555717144],
            [34.03688821606562, 3.033505645823998],
            [34.03676573077665, 3.03185041199926],
            [34.034532836085624, 3.028758738792634],
            [34.03921564586389, 3.027312400065612],
            [34.04330269833565, 3.025481742360988],
            [34.05286969322946, 3.024275703940968],
            [34.05570288621076, 3.023832942577308],
            [34.06088669630448, 3.024020845287948],
            [34.06808726463522, 3.025139493866828],
            [34.070048150356534, 3.026101209160456],
            [34.07250759656895, 3.024800713313041],
            [34.07656830235173, 3.023870022739441],
            [34.07699915322661, 3.024634501742314],
            [34.07771073661091, 3.024899846028276],
            [34.07738044584388, 3.025465543194009],
            [34.07822449659663, 3.025863779073911],
            [34.078274748353635, 3.026495609865297],
            [34.07900315358999, 3.027043618829132],
            [34.07950053998301, 3.028173851624461],
            [34.08341634661214, 3.026857081073835],
            [34.089595967046066, 3.027520678925],
            [34.10149344331516, 3.021525852494913],
            [34.10141520634212, 3.02059356143559],
            [34.10095088783301, 3.020050144890848],
            [34.10202515433518, 3.017268198138714],
            [34.10576983459764, 3.017606329770614],
            [34.106190326998984, 3.020211848502357],
            [34.106922245546386, 3.019775399044634],
            [34.107580532783224, 3.020420762054809],
            [34.108327985896864, 3.020389021119911],
            [34.10966032670207, 3.022657215064985],
            [34.10932360579425, 3.023917482833374],
            [34.109529573319215, 3.024670927020442],
            [34.110761304609234, 3.025224984011136],
            [34.112009723003965, 3.026659610789404],
            [34.11375270708177, 3.029527550733782],
            [34.11538400182363, 3.030926762216929],
            [34.11651806108947, 3.031163027708607],
            [34.11713435298507, 3.0332518631202],
            [34.130219635621735, 3.032454648503018],
            [34.13142209081665, 3.030316435622213],
            [34.13283858310275, 3.029578884084047],
            [34.13288510505467, 3.028890260407411],
            [34.133900859790835, 3.028295386331912],
            [34.13282357674594, 3.027384039407509],
            [34.13334185705416, 3.026966363856964],
            [34.13328890585975, 3.02592358625315],
            [34.1325487623376, 3.024985814326412],
            [34.131950278644155, 3.02309630970622],
            [34.13145725806342, 3.022862188235818],
            [34.13206601129714, 3.022157639165967],
            [34.132245265620526, 3.019941433740152],
            [34.131492269003296, 3.019107955208474],
            [34.13128339273344, 3.017765527333518],
            [34.13050430005719, 3.016775649204402],
            [34.13117799160453, 3.016162283445063],
            [34.131137982438396, 3.015093419382096],
            [34.13170566559566, 3.014139809258428],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 848,
        District: "KOTIDO",
        County: "KOTIDO MUNICIPALITY",
        Subcounty: "LOSILANG DIVISION",
        Population: 13900,
        Key: "KOTIDOLOSILANG DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.88443748188543, 0.803761221607989],
            [33.87846136849092, 0.810040543139717],
            [33.87735245486653, 0.811768623556392],
            [33.8761319426361, 0.811687474304896],
            [33.87560517324844, 0.81202230208464],
            [33.868493547113985, 0.820663059887601],
            [33.865804196867515, 0.822843806745885],
            [33.86363921930354, 0.824011253497133],
            [33.86105443115955, 0.826644294539173],
            [33.86028180545502, 0.827711928001219],
            [33.85961610262554, 0.82972940224877],
            [33.85850250159199, 0.830607138412223],
            [33.85389202775363, 0.831874632978845],
            [33.84438992625764, 0.835676164815233],
            [33.8390959647438, 0.837387072736562],
            [33.827341677236056, 0.839425033094753],
            [33.813201820964856, 0.843788402807472],
            [33.788768385448606, 0.850252665756312],
            [33.78693617890019, 0.82500432265265],
            [33.79163529849076, 0.811316074359379],
            [33.794259505607755, 0.794199647143647],
            [33.79660178545597, 0.785921681817335],
            [33.79757197314933, 0.783913181632331],
            [33.797404781403614, 0.781932039721297],
            [33.7981671258897, 0.779787883024347],
            [33.79833306807886, 0.775156066773541],
            [33.79890108271448, 0.77304813419001],
            [33.80095283931498, 0.769926718564726],
            [33.80153494043258, 0.768053993305947],
            [33.80143715342401, 0.764743012258499],
            [33.803184213158254, 0.763177646593123],
            [33.80398760077136, 0.761250602954262],
            [33.80651131425582, 0.758988517163092],
            [33.80825798501952, 0.758373030221745],
            [33.80929777867271, 0.756156458394384],
            [33.810240718666876, 0.755622541765087],
            [33.8131523705051, 0.755486295353304],
            [33.81369994128148, 0.753369518050979],
            [33.81528721318455, 0.752220134824349],
            [33.81531505736511, 0.750935537714697],
            [33.81403930413456, 0.749795929375656],
            [33.81315075982581, 0.748332070067384],
            [33.81392569330229, 0.747005753109946],
            [33.81801345993466, 0.745885899622124],
            [33.81881617021806, 0.743844708133421],
            [33.81813978013162, 0.742648910360555],
            [33.81818735580739, 0.741287098633604],
            [33.816615708302045, 0.740138799118579],
            [33.816027510318634, 0.736761910906981],
            [33.82104061266057, 0.735501287848326],
            [33.822799025303354, 0.734668691769182],
            [33.826526840594674, 0.736752508120026],
            [33.827778149768, 0.736027473062082],
            [33.8297783439695, 0.736953230849871],
            [33.83255635434124, 0.735296197803896],
            [33.83304651378782, 0.734599891863979],
            [33.833383274221546, 0.732523221819808],
            [33.83473177661703, 0.730584880122885],
            [33.83638978545884, 0.732198598993369],
            [33.837178371531, 0.732158757472247],
            [33.84250865821998, 0.735913285050872],
            [33.84282205526976, 0.737237198946972],
            [33.84385241930742, 0.738667807269367],
            [33.85223688184264, 0.745031983985661],
            [33.85352136849437, 0.749554258336834],
            [33.856915273706385, 0.754609350784272],
            [33.85803888107386, 0.756074630794413],
            [33.8623102920964, 0.758869084945997],
            [33.86048070503535, 0.763193591173111],
            [33.85780530472694, 0.767762521566304],
            [33.858111043638935, 0.771534774815177],
            [33.856434853794106, 0.778944053175862],
            [33.857115285400994, 0.78297857285641],
            [33.85780894829374, 0.784173596815515],
            [33.863662901589386, 0.790899416904138],
            [33.866050545461135, 0.792325817100738],
            [33.87224291029401, 0.793225704526243],
            [33.87549968138966, 0.794569751601631],
            [33.87862920073547, 0.798408502600931],
            [33.88292089571714, 0.800709564656433],
            [33.88443748188543, 0.803761221607989],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 849,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUDUMBA",
        Population: 23009,
        Key: "BUTALEJABUDUMBA",
        Dist2: "Butaleja",
        "Sub Country": "Budumba",
        id2_original: "Butaleja Budumba",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.918867938516954, 0.887085168509891],
            [33.91758128872202, 0.887978356836762],
            [33.91412965507492, 0.887536109126442],
            [33.90535900679904, 0.883656633891103],
            [33.90479539301, 0.88324911040774],
            [33.90467564219273, 0.880119375957219],
            [33.90185275737928, 0.875823280606155],
            [33.895398318943755, 0.87901882418749],
            [33.879214132444496, 0.885106280069178],
            [33.87783373716149, 0.885956959388749],
            [33.875297353838235, 0.886554619686589],
            [33.86815445914538, 0.886284929207698],
            [33.860206373022315, 0.884730836250601],
            [33.85006159161922, 0.883340062105994],
            [33.84486223078965, 0.883784530688217],
            [33.831490899413666, 0.883914226592331],
            [33.82657523912722, 0.892265150670527],
            [33.82213030143957, 0.901300135315968],
            [33.82146814605713, 0.910182493939589],
            [33.821607447808226, 0.914498724425222],
            [33.81912669445556, 0.916990654306155],
            [33.81435077070485, 0.919958977614226],
            [33.801797738975694, 0.925760617653546],
            [33.79923307219572, 0.925842619539612],
            [33.795921688022375, 0.924920633538164],
            [33.79053799469309, 0.920443847223541],
            [33.79158395887395, 0.918326740382886],
            [33.79199916828309, 0.916318332503105],
            [33.791957088500254, 0.908855009612121],
            [33.79113494675898, 0.886202839300131],
            [33.790053913247746, 0.868535317036978],
            [33.788768385448606, 0.850252665756312],
            [33.813201820964856, 0.843788402807472],
            [33.827341677236056, 0.839425033094753],
            [33.8390959647438, 0.837387072736562],
            [33.84438992625764, 0.835676164815233],
            [33.85389202775363, 0.831874632978845],
            [33.85850250159199, 0.830607138412223],
            [33.85961610262554, 0.82972940224877],
            [33.86028180545502, 0.827711928001219],
            [33.86105443115955, 0.826644294539173],
            [33.86363921930354, 0.824011253497133],
            [33.86494469778684, 0.82476180984761],
            [33.86464178677135, 0.831718481814956],
            [33.86547932294165, 0.832116333357149],
            [33.868465319352794, 0.835435659287775],
            [33.868666248227335, 0.842374118989421],
            [33.88380387765767, 0.842822994525984],
            [33.89007193812963, 0.844264985504341],
            [33.89122204310306, 0.844095537618066],
            [33.89228019832063, 0.844982764724926],
            [33.895981521395875, 0.849852698068279],
            [33.89759578407996, 0.855678169077232],
            [33.899276646062596, 0.857807805966191],
            [33.90101097666926, 0.857896165132621],
            [33.90656932315099, 0.856614763005494],
            [33.90761690519768, 0.858637234311626],
            [33.90772665327423, 0.8601817648816],
            [33.91445400258806, 0.864438377330701],
            [33.916174977043056, 0.862166368309172],
            [33.918280844563014, 0.863671782059737],
            [33.92406869173523, 0.865198446032271],
            [33.92868817926913, 0.865422307618266],
            [33.92953144219937, 0.876301044940439],
            [33.92696881459511, 0.879594483062385],
            [33.918867938516954, 0.887085168509891],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 850,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUSABA",
        Population: 24702,
        Key: "BUTALEJABUSABA",
        Dist2: "Butaleja",
        "Sub Country": "Busaba",
        id2_original: "Butaleja Busaba",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.89835098785785, 0.732853789186986],
            [33.89807217504819, 0.734482166541348],
            [33.895971824980705, 0.738408654959003],
            [33.896091752766075, 0.739874119122715],
            [33.897545560170734, 0.743908437333023],
            [33.901785946078355, 0.748991535288073],
            [33.90415740051205, 0.752491923629649],
            [33.90543371788457, 0.753667661973229],
            [33.9085400301533, 0.755485293818811],
            [33.910315204461, 0.757185602598838],
            [33.91124463558992, 0.759374582772551],
            [33.911580799542264, 0.763445294743308],
            [33.91231386703495, 0.766620348708084],
            [33.91536511976328, 0.770916625511333],
            [33.91777849677465, 0.773322381941403],
            [33.918708669013704, 0.778858433675137],
            [33.9153536842097, 0.780397021765855],
            [33.913842512187614, 0.781500987322017],
            [33.90334759713121, 0.790115270385356],
            [33.902876028319426, 0.791146641148466],
            [33.90215587949887, 0.795832735801356],
            [33.8990498250466, 0.795444434241107],
            [33.89609718398029, 0.798032303111387],
            [33.889358037990185, 0.799010774356911],
            [33.88443748188543, 0.803761221607989],
            [33.88292089571714, 0.800709564656433],
            [33.87862920073547, 0.798408502600931],
            [33.87549968138966, 0.794569751601631],
            [33.87224291029401, 0.793225704526243],
            [33.866050545461135, 0.792325817100738],
            [33.863662901589386, 0.790899416904138],
            [33.85780894829374, 0.784173596815515],
            [33.857115285400994, 0.78297857285641],
            [33.856434853794106, 0.778944053175862],
            [33.858111043638935, 0.771534774815177],
            [33.85780530472694, 0.767762521566304],
            [33.86048070503535, 0.763193591173111],
            [33.8623102920964, 0.758869084945997],
            [33.85803888107386, 0.756074630794413],
            [33.856915273706385, 0.754609350784272],
            [33.85352136849437, 0.749554258336834],
            [33.85223688184264, 0.745031983985661],
            [33.84385241930742, 0.738667807269367],
            [33.84282205526976, 0.737237198946972],
            [33.84250865821998, 0.735913285050872],
            [33.837178371531, 0.732158757472247],
            [33.83638978545884, 0.732198598993369],
            [33.83473177661703, 0.730584880122885],
            [33.83559996150821, 0.729962999120386],
            [33.83775438746084, 0.730624117140951],
            [33.838094944174934, 0.728614520628854],
            [33.83898258028695, 0.727908015901643],
            [33.837823140919426, 0.726255575825275],
            [33.83765066797814, 0.723833605427064],
            [33.83974139888557, 0.722121745027472],
            [33.84163280620784, 0.721954572845032],
            [33.84211844982348, 0.721557568753756],
            [33.842102378064745, 0.720688435812476],
            [33.84048520573746, 0.719811240063655],
            [33.840218003652815, 0.717922809283346],
            [33.84063760312878, 0.716990467949684],
            [33.84297443110152, 0.715224059037081],
            [33.84400812609221, 0.711979535704948],
            [33.84381329318521, 0.708976840513117],
            [33.84217916875016, 0.70774167504345],
            [33.84233417395075, 0.70563213128942],
            [33.843394123103955, 0.703580325931973],
            [33.84418883388973, 0.702658489406904],
            [33.846250693842215, 0.702190353205778],
            [33.848312328317604, 0.700479731536679],
            [33.84925611721973, 0.700157973648599],
            [33.85562360951551, 0.701137911145611],
            [33.858444767767004, 0.699653306337103],
            [33.85932172740186, 0.698514254585068],
            [33.86201076054302, 0.695123316669447],
            [33.86493801072785, 0.693649261700304],
            [33.86833194558427, 0.694652804746521],
            [33.873438907500365, 0.695066620079555],
            [33.87752639475668, 0.694061684834638],
            [33.87960794128866, 0.692784252787063],
            [33.8809650926637, 0.69138191515752],
            [33.88684311901234, 0.696842984756348],
            [33.88779540238378, 0.698389711526924],
            [33.8884277920893, 0.701221066455701],
            [33.888974950538945, 0.701818013300134],
            [33.89185183398244, 0.702468789362695],
            [33.89387343952873, 0.703707732465174],
            [33.895158767901876, 0.705163926221764],
            [33.89488739224445, 0.707570276984653],
            [33.8911410554886, 0.715400950479566],
            [33.89055242361891, 0.717784322394513],
            [33.89140577373148, 0.720663425998527],
            [33.89147626902339, 0.722693656907008],
            [33.89336078896239, 0.727137763660716],
            [33.89639113879239, 0.728774338652963],
            [33.89809345074738, 0.731343123175253],
            [33.89835098785785, 0.732853789186986],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 851,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUSABI",
        Population: 18260,
        Key: "BUTALEJABUSABI",
        Dist2: "Butaleja",
        "Sub Country": "Busabi",
        id2_original: "Butaleja Busabi",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.948720561595955, 0.848152940697401],
            [33.946525803982006, 0.851818019449209],
            [33.94298296258748, 0.854541773203226],
            [33.94049842373424, 0.855546506908089],
            [33.93994940307698, 0.856704544971796],
            [33.93688890578606, 0.856678163502839],
            [33.93154160949718, 0.86016224130096],
            [33.92892664694275, 0.8630395575612],
            [33.92868817926913, 0.865422307618266],
            [33.92406869173523, 0.865198446032271],
            [33.918280844563014, 0.863671782059737],
            [33.916174977043056, 0.862166368309172],
            [33.91445400258806, 0.864438377330701],
            [33.90772665327423, 0.8601817648816],
            [33.90761690519768, 0.858637234311626],
            [33.90656932315099, 0.856614763005494],
            [33.90607367499804, 0.847134478512234],
            [33.903327624887474, 0.844218022188362],
            [33.9024881214067, 0.841454646145426],
            [33.90302090232026, 0.836925334073179],
            [33.9024856240902, 0.830553889182737],
            [33.90317131982467, 0.827713392102332],
            [33.90324676303718, 0.824105378219714],
            [33.90156857533917, 0.82203308168022],
            [33.90171987319258, 0.816582667223638],
            [33.9021771740627, 0.815431074660514],
            [33.90309234443649, 0.815661165589483],
            [33.9044656924361, 0.818654722268979],
            [33.905838733211894, 0.820266492555945],
            [33.90827916927627, 0.820803293176131],
            [33.91071934303259, 0.820188607619148],
            [33.91422725433561, 0.820034268610688],
            [33.915142861290626, 0.822183494479664],
            [33.91598187518958, 0.822874190923279],
            [33.91910846782418, 0.822643168053323],
            [33.922235713533965, 0.825252466397275],
            [33.923151414812075, 0.827785511208012],
            [33.924142968934504, 0.828552932747918],
            [33.92437197914481, 0.829550829604259],
            [33.92704162215056, 0.831929924744156],
            [33.928033357732666, 0.833464996908314],
            [33.93426881025812, 0.838664351214788],
            [33.936117346381785, 0.835478150472975],
            [33.941069105467946, 0.830666544046878],
            [33.94173353089309, 0.834694925201121],
            [33.944039306801464, 0.837760995144262],
            [33.946557187524775, 0.839976674179105],
            [33.94967365704444, 0.843929050250431],
            [33.94902510395202, 0.845444728785745],
            [33.948720561595955, 0.848152940697401],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 852,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUSOLWE TOWN COUNCIL",
        Population: 13640,
        Key: "BUTALEJABUSOLWE TOWN COUNCIL",
        Dist2: "Butaleja",
        "Sub Country": "Busolwe TC",
        id2_original: "Butaleja Busolwe TC",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.99826014501214, 0.926035924319931],
            [33.997190366493136, 0.926705629635074],
            [33.99244721418227, 0.927005491157152],
            [33.99070339556956, 0.927472823395264],
            [33.99063637136792, 0.920588918095315],
            [33.99000165233086, 0.918486368465895],
            [33.985787228633285, 0.91260752877927],
            [33.98769902052603, 0.908902860439514],
            [33.98923487376054, 0.903325862634694],
            [33.98913480503116, 0.901098851355266],
            [33.98793388775202, 0.898192260538551],
            [33.986410873239535, 0.897153483722652],
            [33.97857580685732, 0.893792455054972],
            [33.97168716772921, 0.89158875092132],
            [33.96506379751122, 0.888337637085487],
            [33.961762243602, 0.887603901337587],
            [33.95786008238205, 0.887459143520555],
            [33.953616641304166, 0.886286418436264],
            [33.95210694251915, 0.886233314593581],
            [33.946869680869405, 0.89071550006489],
            [33.943383782782426, 0.898395900650949],
            [33.94062606445466, 0.90031120523712],
            [33.938628884100915, 0.900886100908101],
            [33.93549027110952, 0.901078374994281],
            [33.92864227445979, 0.901080143558332],
            [33.92502795142316, 0.900698152563647],
            [33.922459777620325, 0.900028701983155],
            [33.91926477648023, 0.89801760818323],
            [33.91855496008208, 0.890623857826919],
            [33.918867938516954, 0.887085168509891],
            [33.92696881459511, 0.879594483062385],
            [33.92953144219937, 0.876301044940439],
            [33.92868817926913, 0.865422307618266],
            [33.92892664694275, 0.8630395575612],
            [33.93154160949718, 0.86016224130096],
            [33.93688890578606, 0.856678163502839],
            [33.93994940307698, 0.856704544971796],
            [33.94049842373424, 0.855546506908089],
            [33.94298296258748, 0.854541773203226],
            [33.946525803982006, 0.851818019449209],
            [33.948720561595955, 0.848152940697401],
            [33.9529130008236, 0.84702860745788],
            [33.95697463187109, 0.850775115071203],
            [33.96066314856369, 0.853506098402393],
            [33.9781890704494, 0.864619182223253],
            [34.000657384687784, 0.877069538256801],
            [34.00320005352307, 0.877313091493071],
            [34.005358618912524, 0.875711376171669],
            [34.00765725141775, 0.872825101812856],
            [34.00912917424844, 0.872200534298505],
            [34.01105786434995, 0.872127644458771],
            [34.01826370758805, 0.874843373421886],
            [34.02127828120503, 0.874874484741268],
            [34.02197647789498, 0.875193681815268],
            [34.0223897271802, 0.877876428089934],
            [34.0215778765388, 0.879971485792535],
            [34.02102191190438, 0.881381136160401],
            [34.02014234356196, 0.882045485608752],
            [34.02068366655552, 0.883493207554723],
            [34.02022656061984, 0.885689073366129],
            [34.02102356749946, 0.887417921184056],
            [34.019997748038854, 0.890777549083903],
            [34.01665653620481, 0.894706365159289],
            [34.015705524847796, 0.894975863704117],
            [34.0149689108064, 0.89670514189441],
            [34.01367924087549, 0.898009427332558],
            [34.013169838617216, 0.899380385136186],
            [34.01188062682709, 0.901054057912017],
            [34.01163747084599, 0.902221999833505],
            [34.00963298988397, 0.90371590934111],
            [34.0094952547947, 0.905299968191204],
            [34.00795135535016, 0.906990513674003],
            [34.007837210020284, 0.907899341132952],
            [34.005890326339326, 0.910584187788573],
            [34.00539010486326, 0.916409906727917],
            [34.00417491604919, 0.917824554087821],
            [34.00289978714776, 0.918533876950858],
            [34.0024486361441, 0.919442682629004],
            [34.00154591821678, 0.919778754779887],
            [34.00032955260968, 0.921458179136032],
            [34.00009446799139, 0.922999049262406],
            [33.9983091301446, 0.925370022747268],
            [33.99826014501214, 0.926035924319931],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 853,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUTALEJA",
        Population: 15846,
        Key: "BUTALEJABUTALEJA",
        Dist2: "Butaleja",
        "Sub Country": "Butaleja",
        id2_original: "Butaleja Butaleja",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.89538767211099, 0.936920258705707],
            [33.895781697449124, 0.932404967541407],
            [33.89699153769401, 0.925683316934138],
            [33.898244717159756, 0.92152173839934],
            [33.90714913895451, 0.909318411893805],
            [33.91390032506435, 0.902328398372904],
            [33.91926477648023, 0.89801760818323],
            [33.922459777620325, 0.900028701983155],
            [33.92502795142316, 0.900698152563647],
            [33.92864227445979, 0.901080143558332],
            [33.93549027110952, 0.901078374994281],
            [33.938628884100915, 0.900886100908101],
            [33.94062606445466, 0.90031120523712],
            [33.943383782782426, 0.898395900650949],
            [33.946869680869405, 0.89071550006489],
            [33.95210694251915, 0.886233314593581],
            [33.953616641304166, 0.886286418436264],
            [33.95786008238205, 0.887459143520555],
            [33.961762243602, 0.887603901337587],
            [33.96506379751122, 0.888337637085487],
            [33.97168716772921, 0.89158875092132],
            [33.97857580685732, 0.893792455054972],
            [33.986410873239535, 0.897153483722652],
            [33.98793388775202, 0.898192260538551],
            [33.98913480503116, 0.901098851355266],
            [33.98923487376054, 0.903325862634694],
            [33.98769902052603, 0.908902860439514],
            [33.985787228633285, 0.91260752877927],
            [33.99000165233086, 0.918486368465895],
            [33.99063637136792, 0.920588918095315],
            [33.99070339556956, 0.927472823395264],
            [33.99034805438254, 0.92820919893808],
            [33.98890078850977, 0.928716182834341],
            [33.9876992073756, 0.928056164959043],
            [33.98675637967083, 0.928798201717711],
            [33.985709950162686, 0.928617576939559],
            [33.98446785860247, 0.929730582441477],
            [33.98334342119168, 0.929785174855859],
            [33.982689857296606, 0.930554268532096],
            [33.982297103972904, 0.930020665036892],
            [33.980022055837175, 0.930943996105933],
            [33.978478991825874, 0.932364651100377],
            [33.97863647907158, 0.933160655966638],
            [33.97819176988682, 0.933631172392617],
            [33.97745935007947, 0.933604239984723],
            [33.97738144548308, 0.934210344410618],
            [33.97654416173937, 0.934789524416916],
            [33.97685840410385, 0.935766405547624],
            [33.97666267916976, 0.936833889154106],
            [33.97744782559271, 0.938624777659645],
            [33.977500368952, 0.939728375895779],
            [33.97700346854754, 0.940361736764624],
            [33.97697788183327, 0.941257299238918],
            [33.97648090776695, 0.941619280411488],
            [33.97701777511674, 0.943319777655375],
            [33.97686084752143, 0.94453198752433],
            [33.97557942232821, 0.945608826721624],
            [33.97526622650104, 0.946377826202449],
            [33.975763036175664, 0.947366466816543],
            [33.97240294085601, 0.950433375149609],
            [33.96770308644351, 0.951486078108189],
            [33.96531616841051, 0.953138908903196],
            [33.9617641534203, 0.954570253190143],
            [33.92209538860174, 0.937065712430548],
            [33.914135453700084, 0.93569362386907],
            [33.908093023976356, 0.935256633768814],
            [33.90402612790297, 0.935462361874125],
            [33.89538767211099, 0.936920258705707],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 854,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUTALEJA TOWN COUNCIL",
        Population: 19561,
        Key: "BUTALEJABUTALEJA TOWN COUNCIL",
        Dist2: "Butaleja",
        "Sub Country": "Butaleja TC",
        id2_original: "Butaleja Butaleja TC",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.08242425350056, 0.978560804198761],
            [34.07248452244254, 0.985580213789595],
            [34.06058261029258, 1.000283438468321],
            [34.04954886955907, 1.002485148700843],
            [34.04133062769074, 1.006293854113257],
            [34.03247225443577, 1.007010810143505],
            [34.02923015732024, 1.004744078524239],
            [34.02506792484237, 1.003904133669449],
            [34.023487409168574, 1.00217687071773],
            [34.022246065905016, 1.00200539059429],
            [34.020468089751965, 1.001065177815823],
            [34.01821008804706, 0.998967239509956],
            [34.013583741875955, 0.993902975993001],
            [34.00063764241278, 0.982192465717849],
            [33.998131164903654, 0.978235611178987],
            [33.99396945794022, 0.970651827922785],
            [33.98908174424228, 0.966573540154575],
            [33.9617641534203, 0.954570253190143],
            [33.96531616841051, 0.953138908903196],
            [33.96770308644351, 0.951486078108189],
            [33.97240294085601, 0.950433375149609],
            [33.975763036175664, 0.947366466816543],
            [33.97526622650104, 0.946377826202449],
            [33.97557942232821, 0.945608826721624],
            [33.97686084752143, 0.94453198752433],
            [33.97701777511674, 0.943319777655375],
            [33.97648090776695, 0.941619280411488],
            [33.97697788183327, 0.941257299238918],
            [33.97700346854754, 0.940361736764624],
            [33.977500368952, 0.939728375895779],
            [33.97744782559271, 0.938624777659645],
            [33.97666267916976, 0.936833889154106],
            [33.97685840410385, 0.935766405547624],
            [33.97654416173937, 0.934789524416916],
            [33.97738144548308, 0.934210344410618],
            [33.97745935007947, 0.933604239984723],
            [33.97819176988682, 0.933631172392617],
            [33.97863647907158, 0.933160655966638],
            [33.978478991825874, 0.932364651100377],
            [33.980022055837175, 0.930943996105933],
            [33.982297103972904, 0.930020665036892],
            [33.982689857296606, 0.930554268532096],
            [33.98334342119168, 0.929785174855859],
            [33.98446785860247, 0.929730582441477],
            [33.985709950162686, 0.928617576939559],
            [33.98675637967083, 0.928798201717711],
            [33.9876992073756, 0.928056164959043],
            [33.98890078850977, 0.928716182834341],
            [33.99034805438254, 0.92820919893808],
            [33.99527728641629, 0.930496430046287],
            [34.004770261028995, 0.937558586203406],
            [34.01598461703352, 0.944149781137483],
            [34.02836679997541, 0.953038192051604],
            [34.0415905920491, 0.960741224943979],
            [34.08242425350056, 0.978560804198761],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 855,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "KACHONGA",
        Population: 25340,
        Key: "BUTALEJAKACHONGA",
        Dist2: "Butaleja",
        "Sub Country": "Kachonga",
        id2_original: "Butaleja Kachonga",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.12957079506844, 0.991477227692408],
            [34.128019347080595, 0.995166793335061],
            [34.12490704484555, 0.998849040980842],
            [34.124588482482864, 0.999717530347535],
            [34.12320068957346, 1.000246589801529],
            [34.12050309009774, 1.002228203378952],
            [34.108901544934405, 0.992044842873016],
            [34.10457122778539, 0.988735601555883],
            [34.100088391074195, 0.986168138776856],
            [34.09941859192701, 0.985227614312587],
            [34.09626019533811, 0.984550240047475],
            [34.08242425350056, 0.978560804198761],
            [34.0415905920491, 0.960741224943979],
            [34.02836679997541, 0.953038192051604],
            [34.01598461703352, 0.944149781137483],
            [34.004770261028995, 0.937558586203406],
            [33.99527728641629, 0.930496430046287],
            [33.99034805438254, 0.92820919893808],
            [33.99070339556956, 0.927472823395264],
            [33.99244721418227, 0.927005491157152],
            [33.997190366493136, 0.926705629635074],
            [33.99826014501214, 0.926035924319931],
            [33.99892622243911, 0.925845770418216],
            [34.000138962445725, 0.926252492415405],
            [34.00123890998525, 0.925950339526583],
            [34.0017641962544, 0.92628214102983],
            [34.002289337894744, 0.926097573932533],
            [34.00298522232117, 0.925027756251351],
            [34.005012925631625, 0.925789434540694],
            [34.00508638805893, 0.926428725126748],
            [34.008237405886106, 0.92594218927811],
            [34.00893360112959, 0.925978873479856],
            [34.00991090348003, 0.926691668946853],
            [34.01103450186437, 0.926451605818898],
            [34.012011482617915, 0.926033312360259],
            [34.01328092787851, 0.923266698101171],
            [34.01430685423864, 0.923174193518445],
            [34.01444104188083, 0.922596317589916],
            [34.01578432416622, 0.921796792102013],
            [34.01761653879948, 0.922343365030982],
            [34.020156986999375, 0.922330337554264],
            [34.02052314659741, 0.921445033093759],
            [34.02118261062724, 0.921180512545794],
            [34.02167067430426, 0.919483744722637],
            [34.022745406133765, 0.919225250050831],
            [34.02312415292556, 0.919655443657975],
            [34.02412550946434, 0.919077317459312],
            [34.024284072891774, 0.918321167052472],
            [34.025554084091006, 0.917583136774312],
            [34.0254806342401, 0.916993026452984],
            [34.02711706824371, 0.916304066386019],
            [34.02802040870353, 0.914656358673024],
            [34.030121161216286, 0.914674191552096],
            [34.03151395864012, 0.916216730766318],
            [34.033614723729265, 0.91627759103065],
            [34.03679008500232, 0.915643506390643],
            [34.037987112576275, 0.915962809495325],
            [34.03831676553946, 0.915563147078885],
            [34.038817573615404, 0.915735121949955],
            [34.03994109115137, 0.915267607633831],
            [34.04100375591167, 0.915550065685395],
            [34.04157765630903, 0.915070419348037],
            [34.04367863340057, 0.915887373227733],
            [34.044838803098436, 0.915469026433676],
            [34.04565725545887, 0.915954410422481],
            [34.04580368624007, 0.915499478129114],
            [34.046438806824035, 0.915548467786517],
            [34.04653639710155, 0.915142727199789],
            [34.047733235131005, 0.914822722527278],
            [34.04813616187528, 0.914404596566458],
            [34.04814805017976, 0.913285812638738],
            [34.04869148062098, 0.913298762004916],
            [34.05364814271194, 0.916602385675651],
            [34.05396821963421, 0.91736121847152],
            [34.05600145746511, 0.916900654641203],
            [34.05600165509447, 0.917572195799014],
            [34.05729260871794, 0.917928273734557],
            [34.05711019591803, 0.919147220749517],
            [34.05881264980683, 0.920354100937801],
            [34.058835604457265, 0.92071055673789],
            [34.05807028205603, 0.920883271477505],
            [34.058519448681224, 0.921829283553532],
            [34.05772665849354, 0.922161215680547],
            [34.057757699778186, 0.922658744204204],
            [34.05849933450372, 0.923446292019955],
            [34.05904508798827, 0.923404666801431],
            [34.05953966984099, 0.924451425525435],
            [34.060157432278736, 0.924202468285089],
            [34.06044266894101, 0.925002805203107],
            [34.059938716761565, 0.925655425190124],
            [34.060257897165165, 0.926411363860323],
            [34.05941419495875, 0.926318406667817],
            [34.05973344093937, 0.92730219459093],
            [34.05914696682295, 0.927250592238202],
            [34.05896191567107, 0.927752945165445],
            [34.059414968408184, 0.92891275150646],
            [34.05885954994949, 0.929472186419156],
            [34.05897291284678, 0.930128759444759],
            [34.058211655322175, 0.930481116688604],
            [34.05827859328559, 0.931144778992717],
            [34.05902481391061, 0.931640816146236],
            [34.0595906393519, 0.931474939901398],
            [34.06020844311212, 0.933080035676188],
            [34.06077414189096, 0.93246881942024],
            [34.060836069051696, 0.93310055586572],
            [34.0625854194899, 0.934001059376066],
            [34.062359276701955, 0.934695019853916],
            [34.06265778148099, 0.935150623332317],
            [34.0636864701606, 0.934528910222143],
            [34.06464346968727, 0.935015381114636],
            [34.065415399197455, 0.935936882147011],
            [34.06508638583476, 0.93668783901801],
            [34.065714011774304, 0.936739436741517],
            [34.065858198563916, 0.937226153432858],
            [34.067257688436634, 0.937950680642142],
            [34.068101706850015, 0.939079303691679],
            [34.06947035755904, 0.939907404011245],
            [34.07028365987791, 0.941548685957135],
            [34.07173442019716, 0.941713939276788],
            [34.073329802988916, 0.943774415349694],
            [34.07553162046269, 0.943887642508423],
            [34.07634464879541, 0.94459164012852],
            [34.076694785143715, 0.945629263305632],
            [34.0795039257333, 0.946705472529463],
            [34.07958662374006, 0.947948237719579],
            [34.080430826308096, 0.949646456742972],
            [34.081325966946004, 0.949729019439408],
            [34.08250901044594, 0.949221174529748],
            [34.08345596141784, 0.950463666664314],
            [34.08409343828283, 0.949117105511156],
            [34.0847210139167, 0.949013349958482],
            [34.08460823222941, 0.950276887698306],
            [34.08501970195204, 0.950038554309902],
            [34.0856474985715, 0.950639038586386],
            [34.08719089316284, 0.950918172285526],
            [34.087613021396336, 0.951860490977351],
            [34.08827159339909, 0.952150260958426],
            [34.08973260259742, 0.952201573725728],
            [34.08998995555325, 0.952636471605893],
            [34.09056566336098, 0.951207079183708],
            [34.091728501055236, 0.95187988921526],
            [34.09247945400519, 0.951506812857065],
            [34.09348814438995, 0.952780343856401],
            [34.094681486176306, 0.952324269340534],
            [34.095371135396356, 0.953287209214109],
            [34.095206767055544, 0.954095076190802],
            [34.096462182428034, 0.954726422486997],
            [34.096575766310906, 0.956010593154785],
            [34.0980566758877, 0.953949161509395],
            [34.09813942150514, 0.955305840686566],
            [34.09959006953495, 0.955139670065218],
            [34.099744769308366, 0.956309914140469],
            [34.10080409772567, 0.955035712600917],
            [34.101267272679436, 0.955615529544842],
            [34.102594338577326, 0.955107632509333],
            [34.103551528546845, 0.956184402841586],
            [34.104024435848366, 0.955024312767149],
            [34.10511533106477, 0.955956049653939],
            [34.107512074870385, 0.95439143421237],
            [34.10880849025074, 0.954536003385472],
            [34.110084521060685, 0.955301965893104],
            [34.11096918374912, 0.954814930185049],
            [34.11188512847071, 0.955601721664674],
            [34.11405569894564, 0.95458607751238],
            [34.11331453763224, 0.95340567700557],
            [34.113470602844885, 0.952929044775947],
            [34.114357443947874, 0.953084031229747],
            [34.114489321123166, 0.953697520779345],
            [34.11540692682969, 0.953764914732188],
            [34.11599266522588, 0.952642939480143],
            [34.117784988372335, 0.953856005651721],
            [34.11825609814497, 0.954803563583593],
            [34.11952899293628, 0.954213243060593],
            [34.11928902327948, 0.954938612818067],
            [34.11998556437438, 0.954773984372166],
            [34.120480724742144, 0.955813403565982],
            [34.12046552614585, 0.95470825388803],
            [34.120941506583975, 0.954546412516598],
            [34.121224714850335, 0.953825865062857],
            [34.12223857503955, 0.954429939645821],
            [34.12293612314587, 0.953828457241511],
            [34.12350194768883, 0.95411039573202],
            [34.12448661352965, 0.953578192531059],
            [34.12431373005828, 0.953063361160134],
            [34.12372571173789, 0.952922653248494],
            [34.12409195757418, 0.952363979271469],
            [34.12538690959896, 0.952743630295743],
            [34.125648438822566, 0.953382297994077],
            [34.12594695078811, 0.952950101966698],
            [34.1266564339113, 0.95351347338704],
            [34.127682883090905, 0.952996494431681],
            [34.128177940152426, 0.954264445319703],
            [34.128728869729656, 0.95447801260555],
            [34.127555030368114, 0.96336402922168],
            [34.1257426685026, 0.966964772625852],
            [34.12527718757352, 0.971374813091201],
            [34.12625936957256, 0.973166480290536],
            [34.12654523415723, 0.974793686123524],
            [34.12561245770219, 0.979089653258777],
            [34.1244565648834, 0.981172464360795],
            [34.12390788109435, 0.986844626207214],
            [34.129104604470285, 0.98748315723255],
            [34.12957079506844, 0.991477227692408],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 856,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "MAZIMASA",
        Population: 32895,
        Key: "BUTALEJAMAZIMASA",
        Dist2: "Butaleja",
        "Sub Country": "Mazimasa",
        id2_original: "Butaleja Mazimasa",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.781606409640816, 0.955692913132855],
            [33.77281554477941, 0.95667901907959],
            [33.768486297523914, 0.955702977355377],
            [33.76572340310347, 0.953686226029476],
            [33.75978390773488, 0.945708513562346],
            [33.76416434009696, 0.939338792110162],
            [33.76717946438119, 0.936416099917162],
            [33.77753466625812, 0.930162669072812],
            [33.78611441894288, 0.924443376769946],
            [33.79053799469309, 0.920443847223541],
            [33.795921688022375, 0.924920633538164],
            [33.79923307219572, 0.925842619539612],
            [33.801797738975694, 0.925760617653546],
            [33.81435077070485, 0.919958977614226],
            [33.81912669445556, 0.916990654306155],
            [33.821607447808226, 0.914498724425222],
            [33.82146814605713, 0.910182493939589],
            [33.82213030143957, 0.901300135315968],
            [33.82657523912722, 0.892265150670527],
            [33.831490899413666, 0.883914226592331],
            [33.84486223078965, 0.883784530688217],
            [33.85006159161922, 0.883340062105994],
            [33.860206373022315, 0.884730836250601],
            [33.86815445914538, 0.886284929207698],
            [33.875297353838235, 0.886554619686589],
            [33.87783373716149, 0.885956959388749],
            [33.879214132444496, 0.885106280069178],
            [33.895398318943755, 0.87901882418749],
            [33.90185275737928, 0.875823280606155],
            [33.90467564219273, 0.880119375957219],
            [33.90479539301, 0.88324911040774],
            [33.90535900679904, 0.883656633891103],
            [33.91412965507492, 0.887536109126442],
            [33.91758128872202, 0.887978356836762],
            [33.918867938516954, 0.887085168509891],
            [33.91855496008208, 0.890623857826919],
            [33.91926477648023, 0.89801760818323],
            [33.91390032506435, 0.902328398372904],
            [33.90714913895451, 0.909318411893805],
            [33.898244717159756, 0.92152173839934],
            [33.89699153769401, 0.925683316934138],
            [33.895781697449124, 0.932404967541407],
            [33.89538767211099, 0.936920258705707],
            [33.87017900757256, 0.941157440715599],
            [33.863247331955804, 0.942263790216792],
            [33.82722033999401, 0.948351638330145],
            [33.781606409640816, 0.955692913132855],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 857,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "NAWANJOFU",
        Population: 19621,
        Key: "BUTALEJANAWANJOFU",
        Dist2: "Butaleja",
        "Sub Country": "Nawanjofu",
        id2_original: "Butaleja Nawanjofu",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.081182597623275, 1.040412459252944],
            [34.07835154263233, 1.041308962904851],
            [34.0763350673646, 1.041038286816484],
            [34.07330078201535, 1.038904538580329],
            [34.07258516878867, 1.038760052149299],
            [34.07216985786988, 1.038054627601706],
            [34.07123408104177, 1.037937352924467],
            [34.071052924984976, 1.037050932049375],
            [34.069875722331, 1.035531649737787],
            [34.06848741468696, 1.035930134773691],
            [34.066473635263385, 1.035333800260598],
            [34.06429001586065, 1.037442201910367],
            [34.0634304664743, 1.036854519736191],
            [34.05935534452783, 1.036213648820195],
            [34.05895079273122, 1.035761496455849],
            [34.0579215408079, 1.034938677893504],
            [34.05473204993376, 1.033935667555233],
            [34.05393689088867, 1.03443345254847],
            [34.05251813394975, 1.03449724858538],
            [34.05162882876792, 1.033945752197007],
            [34.05140255123271, 1.032471363397889],
            [34.049962729698684, 1.029966156781973],
            [34.05034310783101, 1.028645344319729],
            [34.049580641174046, 1.026067543601193],
            [34.04969318031619, 1.024982010961212],
            [34.04939635718339, 1.024177032696246],
            [34.04826765008006, 1.02320950395522],
            [34.048098245783756, 1.022160246629977],
            [34.0463202507661, 1.021192930147934],
            [34.0447398069575, 1.019746118360124],
            [34.04311694200625, 1.019113441637083],
            [34.04289481019604, 1.018272252938702],
            [34.04243927451546, 1.018200035303988],
            [34.04184638373302, 1.017178051186755],
            [34.04023810921861, 1.016500137430883],
            [34.03958886981331, 1.014908281854422],
            [34.038191641898486, 1.013787051989283],
            [34.03737279877092, 1.012249523893744],
            [34.035848821264445, 1.011716311427256],
            [34.03481204145908, 1.010142668502744],
            [34.033929583236365, 1.009898714099793],
            [34.033604998567995, 1.008315794829745],
            [34.03247225443577, 1.007010810143505],
            [34.04133062769074, 1.006293854113257],
            [34.04954886955907, 1.002485148700843],
            [34.06058261029258, 1.000283438468321],
            [34.07248452244254, 0.985580213789595],
            [34.08242425350056, 0.978560804198761],
            [34.09626019533811, 0.984550240047475],
            [34.09941859192701, 0.985227614312587],
            [34.100088391074195, 0.986168138776856],
            [34.10457122778539, 0.988735601555883],
            [34.108901544934405, 0.992044842873016],
            [34.12050309009774, 1.002228203378952],
            [34.12740787734141, 1.008349079442512],
            [34.13331551216182, 1.014644973947479],
            [34.13191931730956, 1.017021387230844],
            [34.12948733079876, 1.018434834000044],
            [34.12671977861356, 1.019111184527868],
            [34.12261298566346, 1.019493517969268],
            [34.12014982401901, 1.02022707649841],
            [34.11891832718927, 1.022461770254215],
            [34.117855425273746, 1.023357658328303],
            [34.11653920114303, 1.022598290637138],
            [34.114366110893734, 1.022472414493549],
            [34.11313420533055, 1.023540227949282],
            [34.11117831603886, 1.022961992879752],
            [34.108593768643324, 1.023541815019113],
            [34.081182597623275, 1.040412459252944],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 858,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "NAWEYO",
        Population: 21707,
        Key: "BUTALEJANAWEYO",
        Dist2: "Butaleja",
        "Sub Country": "Naweyo",
        id2_original: "Butaleja Naweyo",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.90656932315099, 0.856614763005494],
            [33.90101097666926, 0.857896165132621],
            [33.899276646062596, 0.857807805966191],
            [33.89759578407996, 0.855678169077232],
            [33.895981521395875, 0.849852698068279],
            [33.89228019832063, 0.844982764724926],
            [33.89122204310306, 0.844095537618066],
            [33.89007193812963, 0.844264985504341],
            [33.88380387765767, 0.842822994525984],
            [33.868666248227335, 0.842374118989421],
            [33.868465319352794, 0.835435659287775],
            [33.86547932294165, 0.832116333357149],
            [33.86464178677135, 0.831718481814956],
            [33.86494469778684, 0.82476180984761],
            [33.86363921930354, 0.824011253497133],
            [33.865804196867515, 0.822843806745885],
            [33.868493547113985, 0.820663059887601],
            [33.87560517324844, 0.81202230208464],
            [33.8761319426361, 0.811687474304896],
            [33.87735245486653, 0.811768623556392],
            [33.87846136849092, 0.810040543139717],
            [33.88443748188543, 0.803761221607989],
            [33.889358037990185, 0.799010774356911],
            [33.89609718398029, 0.798032303111387],
            [33.8990498250466, 0.795444434241107],
            [33.90215587949887, 0.795832735801356],
            [33.902876028319426, 0.791146641148466],
            [33.90334759713121, 0.790115270385356],
            [33.913842512187614, 0.781500987322017],
            [33.9153536842097, 0.780397021765855],
            [33.918708669013704, 0.778858433675137],
            [33.923254367133524, 0.785090232621561],
            [33.924659900871475, 0.788880257125623],
            [33.926336931539424, 0.791114278832392],
            [33.92679331882288, 0.792570605262035],
            [33.926608450028986, 0.794705537761112],
            [33.93261309751019, 0.809576014114565],
            [33.93385928808303, 0.813926911544028],
            [33.93415145973929, 0.816830650708775],
            [33.93518522749355, 0.818214464240382],
            [33.935583233266684, 0.819734119206622],
            [33.936457389259566, 0.820674709841672],
            [33.93713386109269, 0.824093983370809],
            [33.938115059436505, 0.826418601936447],
            [33.941069105467946, 0.830666544046878],
            [33.936117346381785, 0.835478150472975],
            [33.93426881025812, 0.838664351214788],
            [33.928033357732666, 0.833464996908314],
            [33.92704162215056, 0.831929924744156],
            [33.92437197914481, 0.829550829604259],
            [33.924142968934504, 0.828552932747918],
            [33.923151414812075, 0.827785511208012],
            [33.922235713533965, 0.825252466397275],
            [33.91910846782418, 0.822643168053323],
            [33.91598187518958, 0.822874190923279],
            [33.915142861290626, 0.822183494479664],
            [33.91422725433561, 0.820034268610688],
            [33.91071934303259, 0.820188607619148],
            [33.90827916927627, 0.820803293176131],
            [33.905838733211894, 0.820266492555945],
            [33.9044656924361, 0.818654722268979],
            [33.90309234443649, 0.815661165589483],
            [33.9021771740627, 0.815431074660514],
            [33.90171987319258, 0.816582667223638],
            [33.90156857533917, 0.82203308168022],
            [33.90324676303718, 0.824105378219714],
            [33.90317131982467, 0.827713392102332],
            [33.9024856240902, 0.830553889182737],
            [33.90302090232026, 0.836925334073179],
            [33.9024881214067, 0.841454646145426],
            [33.903327624887474, 0.844218022188362],
            [33.90607367499804, 0.847134478512234],
            [33.90656932315099, 0.856614763005494],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 859,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "BUSOLWE",
        Population: 14848,
        Key: "BUTALEJABUSOLWE",
        Dist2: "Butaleja",
        "Sub Country": "Busolwe SC",
        id2_original: "Butaleja Busolwe SC",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.97872653607713, 0.578002027919022],
            [33.97964590876985, 0.576442970371695],
            [33.98170381793174, 0.576922768600414],
            [33.982533184822834, 0.575021724091192],
            [33.983883897073945, 0.576841742872311],
            [33.98493090689378, 0.576138803626516],
            [33.98532584671686, 0.576829970148842],
            [33.98780938394857, 0.577860626812229],
            [33.988999517851056, 0.577589683543811],
            [33.99111123879341, 0.579282835328122],
            [33.99161470228933, 0.578856485228894],
            [33.99298819132445, 0.580025579190282],
            [33.99400673083799, 0.580140604363593],
            [33.99621517159036, 0.578682862319415],
            [33.996318090674144, 0.57823930133081],
            [33.99685602252753, 0.578596343698554],
            [33.99763403363217, 0.577565116767405],
            [33.997422246820776, 0.577150413504233],
            [33.998034488212795, 0.577069660853372],
            [33.99883536683131, 0.57591746543526],
            [33.99935608965877, 0.576032577823959],
            [34.000179866333895, 0.57493798017087],
            [34.00051749723511, 0.575128009198398],
            [34.00048906465805, 0.5761418218133],
            [34.001152724718594, 0.575617519632541],
            [34.001467568056, 0.576377818861243],
            [34.00207405753524, 0.576135780050154],
            [34.002474698067125, 0.576705974786402],
            [34.003178409514604, 0.576175905765067],
            [34.00402538338531, 0.576849704237147],
            [34.004677615977116, 0.576423329702051],
            [34.00478653311205, 0.577552320916322],
            [34.005747805026225, 0.577419662656964],
            [34.00564472424569, 0.576941580165383],
            [34.0060223508383, 0.576803266385353],
            [34.00732717085646, 0.577966604658236],
            [34.00785921784644, 0.577413523882081],
            [34.008643210832545, 0.577868443554227],
            [34.00883764219265, 0.577211740173468],
            [34.00967306372878, 0.577274952310146],
            [34.010170689972, 0.576226498120044],
            [34.01259899069519, 0.575648980639207],
            [34.01316339859496, 0.576554162700355],
            [34.01374518799714, 0.576045205701992],
            [34.01425078050029, 0.576731473072316],
            [34.01556731454976, 0.576500476707061],
            [34.01646076365998, 0.576825743789623],
            [34.016525728923035, 0.578577127019529],
            [34.017025412308236, 0.579079970169619],
            [34.01626751268619, 0.580790085321304],
            [34.016731891382406, 0.581074010221521],
            [34.01757231294142, 0.580677427100391],
            [34.01741376478533, 0.581488067342094],
            [34.01821303092792, 0.58103232245129],
            [34.01778414107531, 0.581985016690932],
            [34.017155295223574, 0.582292809433856],
            [34.018372349838515, 0.584493663008652],
            [34.02070587919755, 0.585232842753504],
            [34.02132296161063, 0.58488955060127],
            [34.0216754075275, 0.583747531465363],
            [34.022768621295654, 0.583670410608914],
            [34.022786490583286, 0.584978034537075],
            [34.02374444501914, 0.584492674913261],
            [34.024661445261145, 0.585048690537509],
            [34.024502918664666, 0.585965832434044],
            [34.025067264580635, 0.586510078801986],
            [34.024697114666125, 0.587255671915071],
            [34.02495579802693, 0.587646136468365],
            [34.025596330960504, 0.58697741270429],
            [34.02924066401583, 0.588325777700775],
            [34.02971666242026, 0.58787600864373],
            [34.03040435960118, 0.588006050002216],
            [34.032226552629126, 0.588828151981651],
            [34.03336698454358, 0.589839718259334],
            [34.033524029818174, 0.590481734388512],
            [34.034006180784004, 0.590292737090099],
            [34.0350298676441, 0.591023078911858],
            [34.03526421654216, 0.591779728194089],
            [34.03458132714464, 0.594476308214985],
            [34.03481384617449, 0.597757957496885],
            [34.034164360630804, 0.600975112023595],
            [34.03045201343037, 0.605158761244537],
            [34.02949900781343, 0.607852434176423],
            [34.02854139294078, 0.608274410186224],
            [34.02714766845558, 0.608010774891335],
            [34.02623038704084, 0.608487192911472],
            [34.02558637403388, 0.609380818824498],
            [34.020780544469034, 0.611653508314381],
            [34.01841524080006, 0.613359261260557],
            [34.01707085807846, 0.615707470560611],
            [34.01216989423007, 0.618248849387125],
            [34.01120428704631, 0.620492461035731],
            [34.00955604828154, 0.622523040757479],
            [34.00984245455034, 0.628267162489847],
            [34.00758178305239, 0.633692672159949],
            [34.00625997589221, 0.635586043825671],
            [34.00084993317904, 0.634674197549431],
            [33.990491164092134, 0.636603007901007],
            [33.98232640072927, 0.637337313706441],
            [33.98021014149812, 0.637057295607],
            [33.97344550491351, 0.634896590594447],
            [33.969332607012724, 0.634354610044439],
            [33.96045887615965, 0.640371915260201],
            [33.95824904571353, 0.641349309181562],
            [33.95022753309578, 0.642752965340618],
            [33.94170604963192, 0.643641079986738],
            [33.93663197324177, 0.64517986590771],
            [33.93397061270292, 0.646401588714702],
            [33.92930175016776, 0.649523375146645],
            [33.92573881435863, 0.653042990476572],
            [33.92323390890127, 0.656073919551348],
            [33.920171700319734, 0.661303175684674],
            [33.91406024135461, 0.670841157233214],
            [33.91251597809241, 0.672283203648146],
            [33.9110557450385, 0.672566176830163],
            [33.908781298774, 0.673810474101771],
            [33.90364237839337, 0.674744342017132],
            [33.900103992642656, 0.67480154546216],
            [33.89715767751253, 0.674320134836732],
            [33.896893752482065, 0.672551943106874],
            [33.89490189195143, 0.671059684391271],
            [33.89409777221139, 0.665722555494362],
            [33.89579967812786, 0.663315946565014],
            [33.89691323065236, 0.662302564716738],
            [33.898506750338235, 0.661668624613222],
            [33.89885154171058, 0.65993152505127],
            [33.89744785221394, 0.658464950841724],
            [33.89651993564457, 0.658642683356304],
            [33.895775623939514, 0.656303608196869],
            [33.89458678361101, 0.65548548522793],
            [33.894594242322846, 0.654304297555516],
            [33.89398836998618, 0.653844869768255],
            [33.89385947701428, 0.652288940551415],
            [33.895497320474576, 0.649656193304591],
            [33.89640368376533, 0.648869044772406],
            [33.89752076577059, 0.645648352519157],
            [33.89721876924007, 0.644535105917054],
            [33.89842788813775, 0.644050914051031],
            [33.89843001265342, 0.642174439957239],
            [33.898019558027045, 0.641741097407729],
            [33.89923293943078, 0.640934964741711],
            [33.89974669133166, 0.640093575274325],
            [33.90002738341692, 0.63614032681434],
            [33.900715774995525, 0.635117982968145],
            [33.90026281927647, 0.633534974470191],
            [33.90263607303568, 0.63165010678721],
            [33.90264320296408, 0.630755483072317],
            [33.902169600366534, 0.630058932937406],
            [33.90293241736643, 0.627808252459841],
            [33.90352657297682, 0.627473438103768],
            [33.90347816096954, 0.626831165882196],
            [33.90396088685714, 0.626245475081947],
            [33.90371286380383, 0.624170288207539],
            [33.904025912307304, 0.623773315682407],
            [33.9053590175788, 0.623576031283259],
            [33.904943613235254, 0.622417494042404],
            [33.90701467373288, 0.619611677647556],
            [33.907476736572306, 0.616320675436067],
            [33.909079985012724, 0.615897774848069],
            [33.90897171825804, 0.614816853986457],
            [33.909407435306825, 0.613881154305919],
            [33.90833941389248, 0.612075964597371],
            [33.90872206835575, 0.610075465563095],
            [33.9108339123673, 0.61040199093618],
            [33.91332911152803, 0.609560266912565],
            [33.91441103706632, 0.609744508133568],
            [33.91582406904194, 0.609047635452771],
            [33.915780195323464, 0.608057695748012],
            [33.91425490178511, 0.607533763076191],
            [33.913776778865035, 0.606628113581273],
            [33.91482567335032, 0.606385946739068],
            [33.91592867695847, 0.604837714074185],
            [33.91550266261307, 0.603723971068263],
            [33.916330376604044, 0.602277576717711],
            [33.917024964761524, 0.603078412827199],
            [33.91907173930546, 0.602469430089294],
            [33.918743765293534, 0.601384211029394],
            [33.919508508281446, 0.600768114734646],
            [33.91867035946009, 0.600259882151101],
            [33.91804400104341, 0.598539149185144],
            [33.917432072265115, 0.59823860185921],
            [33.91750219475621, 0.597010823472673],
            [33.91835727771895, 0.595384047296761],
            [33.920187563669316, 0.594949522400412],
            [33.920665774624304, 0.595209551785105],
            [33.921241166225016, 0.594828142293821],
            [33.92155259686269, 0.593194335635572],
            [33.92273392907202, 0.591784723458958],
            [33.923718314638435, 0.588669179230813],
            [33.92544312310307, 0.588528447601586],
            [33.92603300363104, 0.587238306596137],
            [33.92779972119863, 0.587096173632578],
            [33.92889393748664, 0.588072974559267],
            [33.92960723036495, 0.588217592107136],
            [33.93159130429868, 0.58724932115962],
            [33.9339922863558, 0.587366515502583],
            [33.93569898747924, 0.586671492209006],
            [33.93638914065415, 0.585896553490518],
            [33.93715575483278, 0.586231270712226],
            [33.93752720281289, 0.585959891287484],
            [33.93785506363708, 0.586385143165401],
            [33.93822280427, 0.58601792570768],
            [33.93880927479312, 0.586274987631898],
            [33.93955194437785, 0.584375641300239],
            [33.94309684381269, 0.583814983356972],
            [33.94499334009105, 0.585027344984188],
            [33.94728051368649, 0.584674976714361],
            [33.947550160087005, 0.585459548631935],
            [33.94902137953685, 0.584366699036691],
            [33.94916039382708, 0.58493054038834],
            [33.94979363333882, 0.585151183865321],
            [33.95021437187857, 0.583937441625938],
            [33.95117629596963, 0.583500903714597],
            [33.95275064920061, 0.583046144387367],
            [33.95332616027727, 0.583420021803679],
            [33.953600149133884, 0.582785847649343],
            [33.954557099253215, 0.582921176335975],
            [33.95514586856514, 0.583545453350623],
            [33.95893857725429, 0.581401403244547],
            [33.960318669805034, 0.581783593351055],
            [33.96286791251158, 0.580565900696403],
            [33.9638797380167, 0.580585886287084],
            [33.96449241598991, 0.581401564932966],
            [33.96598551750174, 0.580543364919472],
            [33.96704111521571, 0.580612478647379],
            [33.9673028950693, 0.581583203013362],
            [33.967835934697625, 0.581994945257525],
            [33.968495185826754, 0.581028325153818],
            [33.969125189606885, 0.581789402456529],
            [33.970450220820645, 0.581393368228001],
            [33.97065486333055, 0.581833133783061],
            [33.97008676874489, 0.5822292048097],
            [33.97055307432741, 0.582933075702678],
            [33.971244995386776, 0.582522316233128],
            [33.97168924732908, 0.58148009161146],
            [33.97221211353682, 0.581452862382503],
            [33.97256330360896, 0.581840133993084],
            [33.972264903034485, 0.583284752414775],
            [33.97323354921886, 0.582463307155106],
            [33.975710874600374, 0.582445792708732],
            [33.97630236490931, 0.582862061266391],
            [33.97565790274469, 0.580730907350558],
            [33.976259521558475, 0.580986449645042],
            [33.97631356330763, 0.580558394759231],
            [33.976792860325794, 0.58042600605101],
            [33.97690867562379, 0.579562111760223],
            [33.97785585117454, 0.580340211461726],
            [33.97838539545809, 0.580196139858816],
            [33.97831571942972, 0.579624126477698],
            [33.97878334104413, 0.579044237910876],
            [33.97825506248681, 0.578463868710584],
            [33.97872653607713, 0.578002027919022],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 860,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "IYOLWA",
        Population: 20295,
        Key: "TOROROIYOLWA",
        Dist2: "Tororo",
        "Sub Country": "Iyolwa",
        id2_original: "Tororo Iyolwa",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.9635721018628, 0.31422504453552],
            [33.95379960656798, 0.316316551364906],
            [33.94889247848011, 0.315871826490158],
            [33.948721279349876, 0.315627709425368],
            [33.94934884510231, 0.314694205084397],
            [33.95178787979484, 0.312008528688461],
            [33.95060370441763, 0.309811449836407],
            [33.94105147243722, 0.30776786973618],
            [33.94121251072326, 0.303788760699385],
            [33.93845336676913, 0.302152907420129],
            [33.935883280453034, 0.301506304559104],
            [33.93133643698121, 0.295891469264438],
            [33.93041143903821, 0.295640839944547],
            [33.92518172862676, 0.295354761772294],
            [33.92354253769352, 0.295829774691544],
            [33.91728461830282, 0.304846529992515],
            [33.91500789840234, 0.306709132360886],
            [33.913371360194155, 0.306351119317878],
            [33.91281566505433, 0.306099436529559],
            [33.91241054013256, 0.30066913478257],
            [33.90933082428443, 0.29577540039205],
            [33.9035167031868, 0.29094576230466],
            [33.90033111369594, 0.290113209012868],
            [33.90208513178036, 0.285399602451562],
            [33.902878646010166, 0.283816834465719],
            [33.904922211771904, 0.274797597475187],
            [33.90797708560916, 0.271061278003906],
            [33.91004114194253, 0.265443430301873],
            [33.91081704110795, 0.262123417063521],
            [33.9123826420531, 0.259879844021159],
            [33.91265968518165, 0.254434015178382],
            [33.91398940649952, 0.252090956025173],
            [33.917722238881694, 0.249675358180089],
            [33.91998644255532, 0.246898020672999],
            [33.923290378796636, 0.234499162144136],
            [33.92507141371323, 0.231290197152359],
            [33.92643207929769, 0.229598826883295],
            [33.92859916430931, 0.228414787626372],
            [33.932062179611066, 0.224576776343907],
            [33.95460710846506, 0.205220213372891],
            [33.976437140948, 0.236893715358972],
            [33.97926087826265, 0.244372982920617],
            [33.979880334923024, 0.248157981440899],
            [33.98154271317035, 0.2538249265761],
            [33.98143575975263, 0.257333120979205],
            [33.98057812467616, 0.259222211217388],
            [33.97628326043817, 0.263828097886409],
            [33.97179177295079, 0.273480420037628],
            [33.971466135456915, 0.274792192374284],
            [33.97208185063411, 0.279893375850426],
            [33.971683887980106, 0.28193390234051],
            [33.97037860892279, 0.284480684890181],
            [33.9649508667036, 0.292559277333088],
            [33.9629933739191, 0.297196290670511],
            [33.96333064190095, 0.299477096630394],
            [33.96255854979572, 0.301457326392898],
            [33.962592791777716, 0.302681845159449],
            [33.961384706840924, 0.307940216222132],
            [33.961807616608695, 0.309337653830498],
            [33.962475880535074, 0.309889291310786],
            [33.963141114444, 0.312492836503645],
            [33.9635721018628, 0.31422504453552],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 861,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BUSIME",
        Population: 18574,
        Key: "BUSIABUSIME",
        Dist2: "Busia",
        "Sub Country": "Busime",
        id2_original: "Busia Busime",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.0216913292676, 0.385585077668477],
            [34.02160016553761, 0.385590409048953],
            [34.02121517006474, 0.383638813658756],
            [34.019160452617044, 0.381647556286986],
            [34.01541234887504, 0.371996011400565],
            [34.00715424516427, 0.363756118409331],
            [34.00322621515907, 0.356736902377867],
            [34.002968611573245, 0.353136641481425],
            [34.00180891708417, 0.347944389181496],
            [34.00212562891737, 0.342344908932571],
            [34.0033088592669, 0.34180202625777],
            [34.00430124882253, 0.342263265208404],
            [34.00730126703694, 0.341955383912933],
            [34.01288774605845, 0.339295284905801],
            [34.01421185649902, 0.338037760697557],
            [34.01576683935751, 0.337322968368943],
            [34.01829637572166, 0.333034938226779],
            [34.01978029824792, 0.331694342002062],
            [34.023571298341395, 0.33131607136079],
            [34.033104919924064, 0.328821109433254],
            [34.03344260831746, 0.327611882815607],
            [34.03130280514101, 0.324551338072773],
            [34.02811211860921, 0.322397792654652],
            [34.02578463940363, 0.319299470073403],
            [34.02158032983784, 0.315332220278558],
            [34.01906159032507, 0.313920852601116],
            [34.02567516980477, 0.310898868789253],
            [34.035017751167544, 0.30467438916814],
            [34.03958312149381, 0.302972105638159],
            [34.04216401094949, 0.300584352953091],
            [34.049485398194356, 0.298367979810088],
            [34.04974393333314, 0.298795078012535],
            [34.04903110578212, 0.300778579517695],
            [34.04963801836786, 0.301430503069742],
            [34.04964423381131, 0.302667502857749],
            [34.05035095820828, 0.302264449677341],
            [34.05041359863135, 0.30323412257381],
            [34.051182875416465, 0.302900326758649],
            [34.05117672914329, 0.304021122848655],
            [34.05185850732483, 0.303125896860173],
            [34.052415123237786, 0.303964330359129],
            [34.05117954626002, 0.305160025906676],
            [34.05118317365717, 0.305960477222147],
            [34.05274615511496, 0.305599446756047],
            [34.0526217573127, 0.306357020266658],
            [34.05468574717077, 0.306262364341232],
            [34.055123679465034, 0.307427192167482],
            [34.056026809719064, 0.307822233196116],
            [34.056778378015004, 0.307670914169263],
            [34.05745669408943, 0.308151066636507],
            [34.05762563665163, 0.308856268047835],
            [34.05933944434731, 0.309510939016783],
            [34.05932075040624, 0.310203566803073],
            [34.06066189470124, 0.309874064191097],
            [34.06124095412327, 0.310833029536206],
            [34.061147175397515, 0.311223427114869],
            [34.0601088954056, 0.310946484188097],
            [34.060096562435085, 0.312696936088464],
            [34.05901108765309, 0.312602509286596],
            [34.05954632456062, 0.314283734183501],
            [34.05883599702106, 0.315377906105266],
            [34.05814457003507, 0.317748999157687],
            [34.05877119525141, 0.31851512362273],
            [34.05804317359569, 0.319241340095565],
            [34.05826473228075, 0.320020062226578],
            [34.05679497438988, 0.320580612984539],
            [34.05767700770947, 0.321959474726272],
            [34.059009165258374, 0.321392640427351],
            [34.05911554465265, 0.321896357395794],
            [34.058684026329495, 0.322318274145954],
            [34.05930949361741, 0.322456732882107],
            [34.059465725018384, 0.321184804979323],
            [34.05994109550041, 0.321436619455013],
            [34.06082919244818, 0.320976874307171],
            [34.060585351052524, 0.321801752814255],
            [34.06258054702778, 0.321788948430147],
            [34.06228047918016, 0.323218306202224],
            [34.06259945027633, 0.323130119095313],
            [34.06271819947204, 0.32229895797803],
            [34.063193632836175, 0.323142649495943],
            [34.06415057037907, 0.323098471951112],
            [34.064425693807884, 0.322374335318978],
            [34.06550158446411, 0.323432047039353],
            [34.066177015149826, 0.322877876171895],
            [34.06677123094736, 0.323230420689375],
            [34.06775315962148, 0.322928080419189],
            [34.06889151013942, 0.323186118281082],
            [34.07115555930282, 0.322373619373024],
            [34.071493410291254, 0.323387329616891],
            [34.072662898213586, 0.322379754769281],
            [34.07320712995205, 0.323229731692532],
            [34.07411404840164, 0.323368158975743],
            [34.074014049740846, 0.324054495034521],
            [34.07466457643193, 0.324602225020453],
            [34.07473968996273, 0.32515631404824],
            [34.07394543102956, 0.325754573392618],
            [34.07543580435788, 0.325780475895138],
            [34.07537150564477, 0.326188882040641],
            [34.07453342509539, 0.326403055795855],
            [34.075177764190805, 0.32756784901843],
            [34.075502880661816, 0.326472213272172],
            [34.07587374563528, 0.326312913116064],
            [34.07612216215069, 0.327265511573087],
            [34.0790979357339, 0.32811653729993],
            [34.07921834860954, 0.329179324713462],
            [34.08070685254376, 0.328562098856241],
            [34.08163878458243, 0.328662741750396],
            [34.081576287889796, 0.32910980344415],
            [34.08106967220555, 0.32910356295083],
            [34.0813511808594, 0.329619848553611],
            [34.080913412058514, 0.330041764980195],
            [34.082502033231115, 0.32984639722169],
            [34.08190800518152, 0.331212812643068],
            [34.080736458320565, 0.331662283463381],
            [34.08071975235124, 0.332138536185184],
            [34.08115142159135, 0.333133342511738],
            [34.081855835521374, 0.332068906242269],
            [34.08275254371946, 0.332862412502929],
            [34.08175774488225, 0.333254940005743],
            [34.08163940621662, 0.334342224407326],
            [34.08297162395262, 0.334430227263708],
            [34.084119477747954, 0.333655821683369],
            [34.084704040249406, 0.333718523925111],
            [34.08466047914466, 0.335708235869326],
            [34.08526717343977, 0.335777428314424],
            [34.08563007215331, 0.337017806069445],
            [34.08669329476739, 0.336652486421062],
            [34.08761288754733, 0.338276887163048],
            [34.088338408293296, 0.338283101599888],
            [34.089770844777355, 0.339687063866457],
            [34.091228202324054, 0.340240991252245],
            [34.091153178624765, 0.340511750379124],
            [34.09023998723954, 0.340190731398166],
            [34.09007796709491, 0.340524073250541],
            [34.09032142311331, 0.341311504522951],
            [34.09098442021717, 0.341500324348581],
            [34.09114088518012, 0.34240070858684],
            [34.0914722835699, 0.341619901462864],
            [34.09211804918997, 0.34178314759965],
            [34.092384873083866, 0.34242536061295],
            [34.091664083764506, 0.342949090615428],
            [34.09228989331059, 0.343846823836857],
            [34.09263511048436, 0.343846784311696],
            [34.09254152759134, 0.343093795834598],
            [34.093116850920104, 0.342746191774756],
            [34.09351247885269, 0.343332615854605],
            [34.09479268054049, 0.34351347671006],
            [34.094533999874656, 0.345533567108559],
            [34.09497918247159, 0.345616294153275],
            [34.0941309329932, 0.352999569256472],
            [34.093240117743385, 0.356500358087651],
            [34.09191960685215, 0.359268499464816],
            [34.08903737753439, 0.362407707767252],
            [34.083215936963825, 0.366834304745604],
            [34.08170265839241, 0.369141269153898],
            [34.081013689197036, 0.372994652786858],
            [34.07930187935457, 0.372228992640707],
            [34.07681547919204, 0.372020567229557],
            [34.075579488989256, 0.372889385042024],
            [34.07339109234582, 0.373603267338692],
            [34.06972786502511, 0.373323126482008],
            [34.06494856360891, 0.37365481606521],
            [34.0631056850749, 0.370364161607694],
            [34.06248138649514, 0.368419626111939],
            [34.06260004585934, 0.366654502540086],
            [34.06212447774795, 0.365906631720708],
            [34.05974684829498, 0.363932385873503],
            [34.05707191690715, 0.360851237758736],
            [34.05632893021712, 0.360432484706423],
            [34.054605333579794, 0.360582274018317],
            [34.05246586457664, 0.362227971049064],
            [34.05084836256761, 0.365314753711918],
            [34.049815012529976, 0.368945335383491],
            [34.04807629275485, 0.370646736043493],
            [34.04791515565413, 0.371776177619986],
            [34.04687648669171, 0.3730598214846],
            [34.04402814452143, 0.374570689160313],
            [34.04254748198133, 0.376723777957859],
            [34.03854397372933, 0.377447931055809],
            [34.03786846219525, 0.378171680758653],
            [34.03392725659978, 0.378678726456122],
            [34.03043322516621, 0.380434048107435],
            [34.02764806240818, 0.383356205509346],
            [34.023222491499716, 0.384236951546115],
            [34.0216913292676, 0.385585077668477],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 862,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BUHEHE",
        Population: 19908,
        Key: "BUSIABUHEHE",
        Dist2: "Busia",
        "Sub Country": "Buhehe",
        id2_original: "Busia Buhehe",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.025602654201776, 0.267090567911747],
            [34.02368894350763, 0.270540033687317],
            [34.0221996167166, 0.271973225762384],
            [34.022179752270716, 0.274780827020015],
            [34.022804149665156, 0.275837808513714],
            [34.023492928417674, 0.278758908756449],
            [34.024275414030754, 0.290120587680001],
            [34.02321861616757, 0.291405202418763],
            [34.01978355733579, 0.293540353249803],
            [34.01760365785663, 0.295729665973622],
            [34.012299469023276, 0.298012012826573],
            [34.01109486775313, 0.299073327384598],
            [34.00994226905649, 0.301087979288382],
            [34.008264459549196, 0.302876824464291],
            [34.00400872412833, 0.300348627484123],
            [34.00321413371684, 0.299276195651174],
            [33.99934883306791, 0.296952008790724],
            [33.996889050885585, 0.294981422402825],
            [33.99578470249948, 0.294577254146081],
            [33.996299887213226, 0.297208577661674],
            [33.995813662387604, 0.298311949950439],
            [33.9957363443911, 0.302389517678303],
            [33.995117476127255, 0.302516219690503],
            [33.993983913629776, 0.303882966596955],
            [33.99296448927567, 0.306078815098192],
            [33.990867139581255, 0.306949626778591],
            [33.989236583254545, 0.309078888897971],
            [33.986259126228475, 0.309845986859184],
            [33.98227757010705, 0.31016006023477],
            [33.975214780883036, 0.312391468520911],
            [33.974314580035106, 0.312252132009034],
            [33.9724793353844, 0.309568437542352],
            [33.97223688458078, 0.308557652618933],
            [33.9716829195962, 0.308522848796195],
            [33.967112992116526, 0.311346565458336],
            [33.963141114444, 0.312492836503645],
            [33.962475880535074, 0.309889291310786],
            [33.961807616608695, 0.309337653830498],
            [33.961384706840924, 0.307940216222132],
            [33.962592791777716, 0.302681845159449],
            [33.96255854979572, 0.301457326392898],
            [33.96333064190095, 0.299477096630394],
            [33.9629933739191, 0.297196290670511],
            [33.9649508667036, 0.292559277333088],
            [33.97037860892279, 0.284480684890181],
            [33.971683887980106, 0.28193390234051],
            [33.97208185063411, 0.279893375850426],
            [33.971466135456915, 0.274792192374284],
            [33.97179177295079, 0.273480420037628],
            [33.97628326043817, 0.263828097886409],
            [33.98057812467616, 0.259222211217388],
            [33.98143575975263, 0.257333120979205],
            [33.98154271317035, 0.2538249265761],
            [33.979880334923024, 0.248157981440899],
            [33.97926087826265, 0.244372982920617],
            [33.976437140948, 0.236893715358972],
            [33.95460710846506, 0.205220213372891],
            [33.972835669209815, 0.189858923814251],
            [33.973104175648245, 0.189662798408879],
            [33.997634945422185, 0.223427076314044],
            [34.0082053450136, 0.240794545517584],
            [34.009651562552456, 0.242386521220278],
            [34.01350762402867, 0.244747214065631],
            [34.01622652974628, 0.247850218812735],
            [34.01621676955071, 0.24912713503071],
            [34.01728122824664, 0.249621628656364],
            [34.01717895415323, 0.250569575812315],
            [34.01877555865377, 0.250239731963096],
            [34.0192668895035, 0.251012469750672],
            [34.02009592491627, 0.251218476619542],
            [34.02029044431126, 0.251950022500253],
            [34.021109228150024, 0.251939654245461],
            [34.02265475264687, 0.252835950404028],
            [34.023289423174894, 0.254257806083429],
            [34.02286978507138, 0.254113588373667],
            [34.02232737242137, 0.254515475401515],
            [34.02235826189074, 0.256823496577078],
            [34.02158045560197, 0.257307831862359],
            [34.02162143854185, 0.257853922984867],
            [34.02254261415334, 0.258379335974708],
            [34.02205141355936, 0.259244884463088],
            [34.022164038939785, 0.259780666542028],
            [34.022757704070024, 0.26034731978267],
            [34.023975668678325, 0.260635721822267],
            [34.02356633604776, 0.261367316571957],
            [34.02428278201271, 0.261480597441696],
            [34.02413958247157, 0.262541887462423],
            [34.02488675351419, 0.262923060189529],
            [34.024528566464326, 0.263304326328776],
            [34.02500965472318, 0.263932809795285],
            [34.02447747837579, 0.264334697409808],
            [34.02520418310131, 0.264746782577616],
            [34.0240477782428, 0.266282126151181],
            [34.02399667039134, 0.267065209645084],
            [34.02469263207288, 0.267013632534928],
            [34.02578768379413, 0.266148032482902],
            [34.025602654201776, 0.267090567911747],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 863,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "MAJANJI",
        Population: 10865,
        Key: "BUSIAMAJANJI",
        Dist2: "Busia",
        "Sub Country": "Majanji",
        id2_original: "Busia Majanji",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.26278271594884, 0.767643640210745],
            [34.26195879374665, 0.767268225712927],
            [34.26033072844823, 0.767649361067291],
            [34.255335627446264, 0.767618047708717],
            [34.253796459428344, 0.768240426378789],
            [34.251362957459634, 0.767863541523314],
            [34.2503895735605, 0.768245261575286],
            [34.247867773487556, 0.766476512558737],
            [34.24566845961849, 0.765735263900671],
            [34.24439661495775, 0.765968974776351],
            [34.24209732668241, 0.768913302797799],
            [34.23707619879172, 0.772899483725646],
            [34.23398274680458, 0.772207668678746],
            [34.23276673782866, 0.771548579771036],
            [34.23167861481323, 0.769975354352328],
            [34.23111990852056, 0.769933634967898],
            [34.22723896191436, 0.770610853183207],
            [34.22276932055635, 0.770330947280402],
            [34.22113497513578, 0.770810066217599],
            [34.22016047822398, 0.771683879833608],
            [34.218597326984614, 0.771714248220336],
            [34.217711885456836, 0.772246998739286],
            [34.21139409245413, 0.772034728148396],
            [34.21096098231628, 0.771667074777233],
            [34.21165081119938, 0.770699758590609],
            [34.21319315027026, 0.769841168944148],
            [34.21313878872084, 0.769010281571146],
            [34.21450511728482, 0.767797586849828],
            [34.216060468452596, 0.765113734596966],
            [34.21610087018249, 0.764432654895763],
            [34.21727765062829, 0.762838620129655],
            [34.21880401585675, 0.75328962520246],
            [34.22096831070113, 0.750714581907709],
            [34.22563588235723, 0.748097971998479],
            [34.22816338493559, 0.743013901115772],
            [34.21912909998841, 0.732921897472836],
            [34.21469866290606, 0.732796480461411],
            [34.20839990879747, 0.730998183821994],
            [34.20637470999002, 0.729123952631036],
            [34.2057166239758, 0.727481788898562],
            [34.204286153903894, 0.726503772069418],
            [34.20675326184738, 0.724486000604781],
            [34.210274598472324, 0.722768801290065],
            [34.215139004481905, 0.720902958085301],
            [34.21811459031722, 0.721470848679407],
            [34.21930111568724, 0.72103635363161],
            [34.22058239625169, 0.720031981821671],
            [34.222808125081706, 0.716377090566525],
            [34.22432636774337, 0.7152731589211],
            [34.23064637599159, 0.712784009179342],
            [34.231343614179146, 0.713941612492831],
            [34.23224591708481, 0.714240530635721],
            [34.23227287372985, 0.715415734698277],
            [34.23354497351213, 0.716390059428799],
            [34.23508937960647, 0.720768284333559],
            [34.23818420152439, 0.726024162342798],
            [34.241241685865845, 0.728827328679378],
            [34.24483310096442, 0.731114760384468],
            [34.24609542707639, 0.732706359859369],
            [34.25031454177637, 0.735545305263319],
            [34.25187476001634, 0.735289468179975],
            [34.25320645493287, 0.73435690137643],
            [34.253662178361346, 0.731017555312653],
            [34.25736203179282, 0.726977599755101],
            [34.25817663756718, 0.724046743358118],
            [34.26352732499627, 0.721783957687218],
            [34.264784141740606, 0.720390263633481],
            [34.26538598423489, 0.720374017089134],
            [34.26565547163358, 0.72106992460847],
            [34.26573588881781, 0.723735132776657],
            [34.26612365200011, 0.724642043457741],
            [34.26671330255935, 0.724871622797896],
            [34.26634737382834, 0.725537033370971],
            [34.26734512991949, 0.727152154410926],
            [34.26721926516841, 0.728213995111842],
            [34.26772427735986, 0.728747513535342],
            [34.26743317649544, 0.730032002099523],
            [34.268035532826026, 0.731243875505781],
            [34.267839453057384, 0.73179681625689],
            [34.26890316525332, 0.73383853426084],
            [34.2704308357339, 0.734591950511288],
            [34.27210569247887, 0.73458035241766],
            [34.27354297896715, 0.735285455736036],
            [34.27778676409979, 0.735021923404026],
            [34.2845479340857, 0.736532650151826],
            [34.28571792775953, 0.736524288425769],
            [34.28592965797704, 0.736168822085915],
            [34.28564574183824, 0.731033314971507],
            [34.28923460392476, 0.729374495824994],
            [34.29123534520026, 0.727668888394385],
            [34.293217446433665, 0.720771040146784],
            [34.294510604522806, 0.718902439410912],
            [34.30274078859455, 0.722632050853836],
            [34.30533360947382, 0.72277601778082],
            [34.30746132042824, 0.722226754233852],
            [34.30775534800387, 0.721603969346394],
            [34.30885886634666, 0.723724713150662],
            [34.30909613297276, 0.725055740233801],
            [34.309859624607476, 0.725804761953204],
            [34.30952981803238, 0.727179692742921],
            [34.30822894970312, 0.728193110070084],
            [34.30788018059069, 0.729009221007165],
            [34.308628311932374, 0.732353677765759],
            [34.30956095453844, 0.733836775503754],
            [34.309516363964356, 0.736495305779515],
            [34.310329044649066, 0.737192228515055],
            [34.30983446818626, 0.739679739898666],
            [34.31121528837242, 0.745079166701422],
            [34.311704419247995, 0.745504248563119],
            [34.31170134521309, 0.746073964850384],
            [34.310650654995506, 0.746684864424072],
            [34.306806810607156, 0.746563865341153],
            [34.30533151819584, 0.748337123558127],
            [34.30572805073194, 0.750704678831776],
            [34.30428276564437, 0.752201076911484],
            [34.30131120785477, 0.754212385537405],
            [34.297317022318786, 0.755096146010894],
            [34.29588514548513, 0.755858909275709],
            [34.290248705760796, 0.756020865017688],
            [34.28570572504469, 0.757569164983213],
            [34.28254674455084, 0.758311571076985],
            [34.27193828513747, 0.759671497494906],
            [34.26862508546889, 0.762096570515634],
            [34.26278271594884, 0.767643640210745],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 864,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "KWAPA",
        Population: 20160,
        Key: "TOROROKWAPA",
        Dist2: "Tororo",
        "Sub Country": "Kwapa",
        id2_original: "Tororo Kwapa",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.07761001121307, 0.478574452104893],
            [34.075703458295095, 0.478945630208313],
            [34.07495665556172, 0.479696546101109],
            [34.071359281937866, 0.481523590430756],
            [34.069729897014305, 0.481715773704366],
            [34.06872731158019, 0.482420308223752],
            [34.06638490327289, 0.48247495529674],
            [34.06428351654958, 0.483153721581567],
            [34.06025474767177, 0.482679116254435],
            [34.05616378752854, 0.481485288517951],
            [34.05391466926347, 0.48247753067534],
            [34.04947805267029, 0.482758037637643],
            [34.048515044312666, 0.483635632613433],
            [34.046848250845706, 0.483852992910408],
            [34.04481822988181, 0.481958153054849],
            [34.03669914764779, 0.47738678318594],
            [34.03373839209949, 0.477432464525564],
            [34.032592977230166, 0.476343537508454],
            [34.030200954071404, 0.476619699721392],
            [34.02892910132582, 0.475467295312319],
            [34.02753475700305, 0.475504553452342],
            [34.02198111230354, 0.470265177758301],
            [34.02099156232251, 0.470195345080001],
            [34.02078290883486, 0.469417370909242],
            [34.02018184877318, 0.46958623324182],
            [34.01826599739372, 0.469026272821219],
            [34.01761746136927, 0.469739990906457],
            [34.01578671368487, 0.469510950660897],
            [34.01394317938071, 0.468331941456053],
            [34.01276634144273, 0.468196851925428],
            [34.01141754350152, 0.46639979334265],
            [34.010099871286556, 0.46536874833161],
            [34.00993138686515, 0.464313401844541],
            [34.00913052082303, 0.463984677746147],
            [34.0080180705314, 0.461904455862769],
            [34.008739951303795, 0.459480041470983],
            [34.01044647366252, 0.458104816065249],
            [34.01195624610939, 0.455408913833845],
            [34.013084390867405, 0.45456748215009],
            [34.0133089202811, 0.45377140937617],
            [34.01546116422592, 0.451057327782184],
            [34.0179252825761, 0.448621954225893],
            [34.020245503394236, 0.447377059350524],
            [34.02313634935215, 0.444727133821752],
            [34.02344896576599, 0.443216345822121],
            [34.02626483473706, 0.437945477729035],
            [34.0314128119324, 0.434785222553402],
            [34.032595558089966, 0.434509992059881],
            [34.036003007201515, 0.430922867210748],
            [34.037704948152275, 0.430194410677731],
            [34.03873903391014, 0.42890741436994],
            [34.04048906796627, 0.428459758664682],
            [34.04356435422171, 0.423906743962136],
            [34.04431953644004, 0.422875442393739],
            [34.0556535417522, 0.42199641896637],
            [34.06434341172111, 0.420439345585653],
            [34.077844759861435, 0.416580185467336],
            [34.078101413029664, 0.415804702918456],
            [34.077825040044324, 0.411429686415896],
            [34.08019231371869, 0.406881988723392],
            [34.08102878897866, 0.404134306021555],
            [34.08172521508919, 0.403156696453281],
            [34.083078954662795, 0.402281972773329],
            [34.08951445751043, 0.400209638078405],
            [34.100073876095855, 0.399810200243966],
            [34.101734274456305, 0.400042646237525],
            [34.10292522672399, 0.401064341717936],
            [34.1019328371684, 0.404848382402119],
            [34.101112663635895, 0.411144279240611],
            [34.10018239617542, 0.413161593442528],
            [34.09177215917804, 0.421701905300117],
            [34.090740874367256, 0.424189618392599],
            [34.09043792562252, 0.426369675208572],
            [34.09102117748197, 0.432583984670501],
            [34.09018694172203, 0.436280232012263],
            [34.09231723892613, 0.439757030073056],
            [34.09202166355326, 0.442353188526183],
            [34.09087540067429, 0.44574549526341],
            [34.091115086463475, 0.448766722277834],
            [34.09013978376288, 0.449960901396587],
            [34.09010919972069, 0.451978096611469],
            [34.088923400189465, 0.454091557997365],
            [34.08733151453911, 0.455112828581753],
            [34.08251578733644, 0.456588680644274],
            [34.079201416264745, 0.456277857249205],
            [34.07873990229597, 0.455863007732618],
            [34.07864482909787, 0.457470685005037],
            [34.078061872784126, 0.459214726290304],
            [34.07790949605407, 0.468732644048457],
            [34.078942621512866, 0.47104819031472],
            [34.076580224792174, 0.472495878726134],
            [34.07651686751349, 0.473165273294827],
            [34.07761001121307, 0.478574452104893],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 865,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "DABANI",
        Population: 29142,
        Key: "BUSIADABANI",
        Dist2: "Busia",
        "Sub Country": "Dabani",
        id2_original: "Busia Dabani",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.0080180705314, 0.461904455862769],
            [34.00731250046957, 0.461370125631318],
            [34.0066690273501, 0.461943624729435],
            [34.0055245664916, 0.462058594568293],
            [33.99702146615171, 0.456486635267539],
            [33.99631977052372, 0.455233791900709],
            [33.994307034044205, 0.454580181233572],
            [33.99378543176606, 0.453530341449747],
            [33.99255024914872, 0.452434552322935],
            [33.99105902331919, 0.452158465519563],
            [33.986329002581165, 0.449976401348801],
            [33.98546905074956, 0.449958099637607],
            [33.98370319736127, 0.448401888097087],
            [33.982550463917335, 0.448153381271505],
            [33.982202744935485, 0.447564001144715],
            [33.981178276541044, 0.448715364473308],
            [33.974694305990575, 0.45204899124409],
            [33.973153812059266, 0.451653786131519],
            [33.97262590450615, 0.450864023507216],
            [33.97065725464583, 0.450189340416754],
            [33.968008367214715, 0.447507468295232],
            [33.96620716601831, 0.447165271805861],
            [33.963074491789264, 0.448048822366871],
            [33.95940196241381, 0.448323962530539],
            [33.95699324047223, 0.446189518159268],
            [33.95546086012457, 0.445542141698967],
            [33.95533586314605, 0.443858329163257],
            [33.95343208153073, 0.442656661819291],
            [33.951242419161076, 0.443544036036023],
            [33.94652608695132, 0.443305182951898],
            [33.942242177668234, 0.443957056439703],
            [33.93456432903714, 0.443876628194806],
            [33.92737038218837, 0.44224923768062],
            [33.92225380560377, 0.440277819289128],
            [33.93011070553897, 0.428805820452189],
            [33.93404783907127, 0.423848093663952],
            [33.943336960793175, 0.422988024282755],
            [33.94569521268716, 0.42331339328987],
            [33.95025068178235, 0.42523060066316],
            [33.957326881056936, 0.425202986313471],
            [33.959287111906406, 0.42428850312666],
            [33.96070789634294, 0.424194391909215],
            [33.96198641458791, 0.423229947466942],
            [33.96406251553259, 0.422972853049333],
            [33.965695241290724, 0.421965011122628],
            [33.966653745495535, 0.421956352496422],
            [33.96896042061747, 0.417750471514567],
            [33.97051262858006, 0.417284887962922],
            [33.9735636935605, 0.415042867141162],
            [33.97479676873017, 0.413003611737756],
            [33.97595272802432, 0.413165336624976],
            [33.97948537264205, 0.409177830334979],
            [33.98061717803481, 0.408677388941445],
            [33.98078710425226, 0.407232062337797],
            [33.9831516533364, 0.404483931506682],
            [33.98408068202008, 0.40377032759614],
            [33.98586783895533, 0.403319334204209],
            [33.987673488609026, 0.399478300583404],
            [33.99369874523945, 0.397340575688954],
            [33.997843680656544, 0.394771597287651],
            [33.99953458670236, 0.393345344402735],
            [34.000616314611285, 0.390315180416525],
            [34.0027670943022, 0.387784760055813],
            [34.006073287111555, 0.386453309329511],
            [34.009086431508884, 0.38575561716495],
            [34.01598474100105, 0.385334399478193],
            [34.01739335775704, 0.386002210795889],
            [34.01873239190945, 0.385329293569597],
            [34.02160016553761, 0.385590409048953],
            [34.0216913292676, 0.385585077668477],
            [34.026508221585196, 0.392247690904226],
            [34.03170662121741, 0.395492945273164],
            [34.02940121810993, 0.40062219367081],
            [34.030907957844406, 0.404704071653073],
            [34.038495585078245, 0.416942128679633],
            [34.04356435422171, 0.423906743962136],
            [34.04048906796627, 0.428459758664682],
            [34.03873903391014, 0.42890741436994],
            [34.037704948152275, 0.430194410677731],
            [34.036003007201515, 0.430922867210748],
            [34.032595558089966, 0.434509992059881],
            [34.0314128119324, 0.434785222553402],
            [34.02626483473706, 0.437945477729035],
            [34.02344896576599, 0.443216345822121],
            [34.02313634935215, 0.444727133821752],
            [34.020245503394236, 0.447377059350524],
            [34.0179252825761, 0.448621954225893],
            [34.01546116422592, 0.451057327782184],
            [34.0133089202811, 0.45377140937617],
            [34.013084390867405, 0.45456748215009],
            [34.01195624610939, 0.455408913833845],
            [34.01044647366252, 0.458104816065249],
            [34.008739951303795, 0.459480041470983],
            [34.0080180705314, 0.461904455862769],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 866,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "MASAFU",
        Population: 20153,
        Key: "BUSIAMASAFU",
        Dist2: "Busia",
        "Sub Country": "Masafu",
        id2_original: "Busia Masafu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.07968389331901, 0.799538215563753],
              [34.07806691862108, 0.799354096820844],
              [34.07422591290903, 0.799782391603809],
              [34.07066150026957, 0.802377333975797],
              [34.0675331442421, 0.802600667383916],
              [34.06607134003474, 0.801789249316636],
              [34.065824588097556, 0.801044726581465],
              [34.06290102819194, 0.800744113183089],
              [34.062319688845704, 0.80010604730784],
              [34.06126302662812, 0.800177236343309],
              [34.05932555369805, 0.799309055184497],
              [34.057220536882674, 0.800129738961509],
              [34.05559628493263, 0.800165069849355],
              [34.053933270678066, 0.800093135284679],
              [34.05084348830889, 0.79916221827888],
              [34.04959343587864, 0.797525248798233],
              [34.0482609935638, 0.796548643718228],
              [34.046956040594964, 0.794165720136507],
              [34.04678156800384, 0.793647353948912],
              [34.04471576534556, 0.79354634000074],
              [34.04246582691863, 0.792851789659401],
              [34.03989719317838, 0.793175976761145],
              [34.037847137987015, 0.792878145502785],
              [34.0338683028626, 0.791387353213523],
              [34.0333449327, 0.79076169044358],
              [34.033472384774186, 0.790062193981957],
              [34.03272074101975, 0.789776886520107],
              [34.0318552834138, 0.787992751761649],
              [34.030096412630186, 0.786066091274691],
              [34.02813371949855, 0.780354523716982],
              [34.031219877165555, 0.77801081399777],
              [34.03263740790411, 0.77791838407941],
              [34.035734410931546, 0.775653644752112],
              [34.03875437893179, 0.774159254298869],
              [34.04397769783002, 0.773003778520311],
              [34.04368495304861, 0.761213287536105],
              [34.03799939254623, 0.7565451983077],
              [34.03300716076327, 0.753941490585695],
              [34.029610278534406, 0.748986511439957],
              [34.030207615977545, 0.748789359755045],
              [34.03365817434125, 0.741622735017024],
              [34.0359802429939, 0.738092273021173],
              [34.038560871039834, 0.73798833399007],
              [34.03958181983495, 0.737599121756798],
              [34.04300270145494, 0.737643542461208],
              [34.04404723641617, 0.737254323910088],
              [34.04570761770864, 0.735770415296587],
              [34.04758007686664, 0.733354737713624],
              [34.048680758329766, 0.728979019397095],
              [34.050096728694655, 0.726153676429949],
              [34.05147117533387, 0.724389420567558],
              [34.05315575005358, 0.723113567911011],
              [34.05716574504025, 0.718912943482928],
              [34.06002895882005, 0.71700758041416],
              [34.062395346755544, 0.716148021899813],
              [34.06631061529385, 0.713431496124506],
              [34.08361767433867, 0.707240141637404],
              [34.08386163521027, 0.710586998305866],
              [34.083318431144484, 0.712468635976448],
              [34.08260825272528, 0.713599519257069],
              [34.08131507487317, 0.714567718339244],
              [34.08086737070524, 0.716548837715203],
              [34.08411448940318, 0.725376676286302],
              [34.084853297130515, 0.726543393571038],
              [34.083894491091776, 0.728370859728164],
              [34.081285797879765, 0.730813837576918],
              [34.078982098876345, 0.731076723422213],
              [34.07487737833958, 0.734089948485839],
              [34.072309175790664, 0.739147143475774],
              [34.0705531984806, 0.740034055312006],
              [34.068587145649786, 0.743146274705791],
              [34.06744844478891, 0.744268227177449],
              [34.07590481297107, 0.748951841228997],
              [34.07778183018083, 0.749258930111443],
              [34.081293812648696, 0.750976623126598],
              [34.08289691196876, 0.753129220615299],
              [34.08246102603672, 0.755119387900313],
              [34.080496286542854, 0.758891946861153],
              [34.072612486556466, 0.766763726752837],
              [34.06916080529863, 0.769288365043219],
              [34.06513175884142, 0.774038409583869],
              [34.06439613564179, 0.774472793394305],
              [34.06107083656467, 0.774880695451108],
              [34.05984698170307, 0.774609632037133],
              [34.05843588290194, 0.775713573957112],
              [34.05610664748993, 0.775071910417761],
              [34.05496717677284, 0.775379754648277],
              [34.05506458109912, 0.776813228324362],
              [34.05452122162477, 0.778056890628409],
              [34.054871958946, 0.779747679054117],
              [34.058106970150554, 0.78506362163125],
              [34.061666772635945, 0.788440162959031],
              [34.0625725654965, 0.790185763464998],
              [34.06393042474399, 0.79109247790037],
              [34.06663135876603, 0.791838526728779],
              [34.068677292486875, 0.791944519604584],
              [34.07742511277476, 0.791249817193851],
              [34.078148729990644, 0.793167082495542],
              [34.07909928410515, 0.798635607884689],
              [34.07968389331901, 0.799538215563753],
            ],
          ],
          [
            [
              [33.98935125679382, 0.736472099721401],
              [33.990658693604395, 0.742821850267083],
              [33.990910888433895, 0.747577244122572],
              [33.99298261009159, 0.750837625266119],
              [33.99858526417808, 0.755683119777319],
              [34.00002645923617, 0.759357770482056],
              [33.99899962467931, 0.761267166426021],
              [33.99919775620006, 0.776572759740752],
              [33.99851318066476, 0.785494600009051],
              [33.99935991378694, 0.788976537514677],
              [34.00072905228115, 0.791336239458074],
              [34.00145838817213, 0.798016799693488],
              [33.999800314651594, 0.799898765093486],
              [33.995746892409144, 0.802034608187941],
              [33.99217782649656, 0.805102068447522],
              [33.989458795014784, 0.809281979051894],
              [33.98785066782408, 0.811037295779501],
              [33.98329530203515, 0.813969319423943],
              [33.9826791008694, 0.811346131669966],
              [33.98113438485626, 0.810577599321265],
              [33.97940591126527, 0.807059124990693],
              [33.9790620765987, 0.804273038446292],
              [33.979441461194334, 0.800708819127549],
              [33.978681264580075, 0.799496837800729],
              [33.979317557465514, 0.79690952585458],
              [33.978863542632716, 0.793662117242474],
              [33.98003971851231, 0.791671714729011],
              [33.980786173597636, 0.787012844335734],
              [33.978026656842644, 0.77908919133978],
              [33.9760654513211, 0.77444904410792],
              [33.974079268143086, 0.771066292845848],
              [33.96982915976915, 0.775327955345807],
              [33.96909284307013, 0.775328126010061],
              [33.96818542066567, 0.773718140891835],
              [33.96813551026847, 0.769104672529149],
              [33.968747624997995, 0.766273121631506],
              [33.968514284009714, 0.765124328382794],
              [33.96746026912727, 0.763469142896786],
              [33.967275935729305, 0.760447807151928],
              [33.96994125963514, 0.750874003012847],
              [33.967622529122096, 0.744980605593376],
              [33.967383197269164, 0.734829390752425],
              [33.980234800252646, 0.738254997413787],
              [33.98588029499505, 0.737873804697638],
              [33.98935125679382, 0.736472099721401],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 867,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "NAGONGERA",
        Population: 25522,
        Key: "TORORONAGONGERA",
        Dist2: "Tororo",
        "Sub Country": "Nagongera  TC",
        id2_original: "Tororo Nagongera  TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.18429004554823, 0.711656573166626],
            [34.17728534857698, 0.712074474909127],
            [34.17285307982976, 0.707698225949638],
            [34.17224679247146, 0.707536834358501],
            [34.17173985698695, 0.706567231639255],
            [34.16836822909569, 0.70740931654754],
            [34.16631137545426, 0.706306294477585],
            [34.16115587127518, 0.706244280400547],
            [34.158799399842074, 0.70297051281304],
            [34.158127904675645, 0.700184571676346],
            [34.15720193295885, 0.699497352463116],
            [34.15716996101959, 0.697625760953277],
            [34.157600547789784, 0.697308433930795],
            [34.1574310563569, 0.696005732322195],
            [34.15779428924372, 0.694929233763085],
            [34.15774124103126, 0.692766864470958],
            [34.15709496337145, 0.691609169677759],
            [34.15744604115418, 0.688288845472174],
            [34.15624560177876, 0.687044071370694],
            [34.15624714328777, 0.685522623971669],
            [34.154903907714804, 0.684636175022413],
            [34.15419004440626, 0.682974269974191],
            [34.15119098469427, 0.682278060365027],
            [34.15419881735332, 0.68110860401631],
            [34.155738162339375, 0.678765448920928],
            [34.156187108877354, 0.677372334936597],
            [34.15810660921352, 0.674839137349312],
            [34.15289569245611, 0.671825988131236],
            [34.15288505460652, 0.670851325465211],
            [34.157371167473535, 0.668769793617427],
            [34.162519643233864, 0.665367467335128],
            [34.16698349584817, 0.664235721061659],
            [34.17036556395967, 0.660150049099631],
            [34.17289830910601, 0.659928678478963],
            [34.17966777593188, 0.687967837691985],
            [34.18390798846463, 0.688681362945109],
            [34.18478231873068, 0.688391690658301],
            [34.186568896252574, 0.686726890055053],
            [34.18842252402728, 0.683687175280054],
            [34.191645569672225, 0.68622811743081],
            [34.19167594620354, 0.688688451038944],
            [34.18885129530227, 0.689331386288947],
            [34.18473413579377, 0.691114366032767],
            [34.186784640142776, 0.696106903004859],
            [34.18453174625857, 0.696993924693478],
            [34.18424084661677, 0.699255348185919],
            [34.182479752502836, 0.699527159037626],
            [34.18401975954722, 0.70663644785617],
            [34.18429004554823, 0.711656573166626],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 868,
        District: "TORORO",
        County: "TORORO MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 22942,
        Key: "TOROROWESTERN DIVISION",
        Dist2: "Tororo",
        "Sub Country": "Western Division",
        id2_original: "Tororo Western Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.920171700319734, 0.661303175684674],
            [33.92253346282985, 0.661700763292491],
            [33.94133769005979, 0.662068083257549],
            [33.947006002908736, 0.660664846576794],
            [33.94985854649958, 0.660691434043227],
            [33.9549707105595, 0.661622189300936],
            [33.963445268727845, 0.662081882255605],
            [33.96849785202654, 0.662849800659681],
            [33.973942950595344, 0.665356309215096],
            [33.97437900630897, 0.666118922917202],
            [33.97543773465171, 0.666620211822507],
            [33.97747706665353, 0.666196662358805],
            [33.98247455627584, 0.666937459127394],
            [33.98585833477961, 0.668571873205257],
            [33.987078068170725, 0.669762686760843],
            [33.987919105974015, 0.671570002935133],
            [33.99113016719475, 0.673276140991128],
            [33.99178034533953, 0.674831063851558],
            [33.9914170720285, 0.680819576216768],
            [33.992656141656106, 0.684112053530215],
            [33.99439305402087, 0.685830424932712],
            [34.00046920650038, 0.688722779474034],
            [34.000927345498646, 0.689263404013228],
            [34.00133917095413, 0.691506336238426],
            [34.00120270069278, 0.694577579064884],
            [34.00034644183534, 0.69802856439554],
            [33.998079638437275, 0.70209428560019],
            [33.99849959274776, 0.706671449845556],
            [34.00036966059048, 0.711130698614072],
            [34.00019841654449, 0.719552526807658],
            [34.00081465993108, 0.720475175562719],
            [33.9977412224085, 0.723725120953276],
            [33.99661671762406, 0.726748161546014],
            [33.99603353313821, 0.730157669797813],
            [33.99670566610852, 0.732890900046863],
            [33.996634770167994, 0.734887154860322],
            [33.98935125679382, 0.736472099721401],
            [33.98588029499505, 0.737873804697638],
            [33.980234800252646, 0.738254997413787],
            [33.967383197269164, 0.734829390752425],
            [33.960048558077226, 0.733989705625534],
            [33.955971613449044, 0.734026772462179],
            [33.94780725432808, 0.735123105801602],
            [33.93524545683837, 0.737468729520559],
            [33.929385889970526, 0.737867999367404],
            [33.92110015947152, 0.7363318932699],
            [33.91379935442642, 0.733854757402422],
            [33.89835098785785, 0.732853789186986],
            [33.89809345074738, 0.731343123175253],
            [33.89639113879239, 0.728774338652963],
            [33.89336078896239, 0.727137763660716],
            [33.89147626902339, 0.722693656907008],
            [33.89140577373148, 0.720663425998527],
            [33.89055242361891, 0.717784322394513],
            [33.8911410554886, 0.715400950479566],
            [33.89488739224445, 0.707570276984653],
            [33.895158767901876, 0.705163926221764],
            [33.89387343952873, 0.703707732465174],
            [33.89185183398244, 0.702468789362695],
            [33.888974950538945, 0.701818013300134],
            [33.8884277920893, 0.701221066455701],
            [33.88779540238378, 0.698389711526924],
            [33.88684311901234, 0.696842984756348],
            [33.8809650926637, 0.69138191515752],
            [33.88370522287653, 0.68616907180879],
            [33.88670813995437, 0.682942564392161],
            [33.888605287511325, 0.681807696284292],
            [33.89047353446897, 0.678676662973133],
            [33.89274267797833, 0.678275769377786],
            [33.89428378096738, 0.676245077313529],
            [33.8954572241719, 0.676692628115369],
            [33.89610138270592, 0.676476343248643],
            [33.89715767751253, 0.674320134836732],
            [33.900103992642656, 0.67480154546216],
            [33.90364237839337, 0.674744342017132],
            [33.908781298774, 0.673810474101771],
            [33.9110557450385, 0.672566176830163],
            [33.91251597809241, 0.672283203648146],
            [33.91406024135461, 0.670841157233214],
            [33.920171700319734, 0.661303175684674],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 869,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "NABUYOGA",
        Population: 30926,
        Key: "TORORONABUYOGA",
        Dist2: "Tororo",
        "Sub Country": "Nabuyoga",
        id2_original: "Tororo Nabuyoga",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.40227600404552, 0.859823914590781],
            [34.40160131357157, 0.860276124961058],
            [34.400527339920195, 0.862149074104813],
            [34.39966581783346, 0.862615209202801],
            [34.39905834200404, 0.861290567749435],
            [34.39605361751584, 0.861793799177233],
            [34.3958671182797, 0.861261501551096],
            [34.394232103614236, 0.860318362577269],
            [34.39376305996673, 0.859556281799667],
            [34.39211613723387, 0.858921676350431],
            [34.388355440009896, 0.860365720012858],
            [34.38640738492579, 0.860465926562611],
            [34.38243823453845, 0.859029276140139],
            [34.380262131339684, 0.859002936903296],
            [34.37949065727536, 0.858244585249897],
            [34.37801150659988, 0.859503610518766],
            [34.3773317110002, 0.861760367664279],
            [34.37686052037917, 0.862044966657619],
            [34.37669083850349, 0.86070458650157],
            [34.37554217981766, 0.859171307175257],
            [34.371368196477555, 0.856016056028642],
            [34.37077757483951, 0.853087128400389],
            [34.36683989063993, 0.85079117248312],
            [34.363777728770785, 0.850371082110131],
            [34.36417148730928, 0.849194979004469],
            [34.36396694990222, 0.848045820251197],
            [34.36095900764869, 0.844122418582101],
            [34.36117345886321, 0.843249314858755],
            [34.36057831869927, 0.842002341968301],
            [34.36066856075779, 0.840231309306047],
            [34.36012272013662, 0.838227692777155],
            [34.35870356434572, 0.837137703684906],
            [34.35779249388288, 0.833622369582502],
            [34.35782034075837, 0.823918644971749],
            [34.35727624915709, 0.822653931455842],
            [34.35712855893785, 0.818327873063316],
            [34.357554315466764, 0.815243456257043],
            [34.355813099273476, 0.811581462179283],
            [34.354308019625634, 0.810667895223967],
            [34.35385132781329, 0.809611926072578],
            [34.35274449648374, 0.80906544108764],
            [34.35164983193637, 0.807185742542246],
            [34.35184574731332, 0.806263907322056],
            [34.35101481735361, 0.804140515861162],
            [34.351040171404186, 0.803123339441348],
            [34.35155371669257, 0.802373221891671],
            [34.35104772443911, 0.800054593232143],
            [34.35154416670275, 0.799373442852504],
            [34.35094434092632, 0.798149593741548],
            [34.351680505810066, 0.797321823446066],
            [34.35156032200486, 0.79640813653034],
            [34.35232241765758, 0.796321683832333],
            [34.353503771426475, 0.795200684602376],
            [34.35433591501013, 0.79569827366799],
            [34.35506508201786, 0.79613864641271],
            [34.35568048727629, 0.797518821975014],
            [34.3571439066545, 0.79830102332359],
            [34.3575400053043, 0.799112041471453],
            [34.358706172154996, 0.798741653581395],
            [34.362820178576825, 0.799330849785523],
            [34.36446031543608, 0.800141448257665],
            [34.36609324690838, 0.800539357715233],
            [34.36659501528338, 0.800275921024543],
            [34.36677191422407, 0.800845087432676],
            [34.36871583705786, 0.801193083220589],
            [34.371176068397844, 0.802494354115343],
            [34.37164961440156, 0.802387464182123],
            [34.372110167173005, 0.805695926429405],
            [34.37186297506134, 0.80629369699863],
            [34.37269033242117, 0.80735359585398],
            [34.373291204734926, 0.80753127305728],
            [34.37414697131562, 0.808989618260657],
            [34.374564316020205, 0.80990734976802],
            [34.374345501688346, 0.810811067854147],
            [34.37508126502515, 0.812731945635828],
            [34.37672147644457, 0.81374886904391],
            [34.37817757724816, 0.81379105865712],
            [34.379726071575355, 0.815313194395092],
            [34.38096301578896, 0.815248728833993],
            [34.38199518005043, 0.815782017170444],
            [34.38367735716662, 0.815503937717591],
            [34.38472038295819, 0.815945295469645],
            [34.385384954808764, 0.815980411544373],
            [34.38741252247358, 0.817845390397875],
            [34.39074516887143, 0.819919534956696],
            [34.39597239364448, 0.820686329256142],
            [34.39638206134667, 0.82102857471075],
            [34.39720811704763, 0.821077197320916],
            [34.397950642901925, 0.820462029460174],
            [34.39908956744331, 0.821949976306646],
            [34.39941635028918, 0.823473146394487],
            [34.39852129678785, 0.82461243459217],
            [34.39811916415428, 0.831820475665427],
            [34.39461341240122, 0.83347449558736],
            [34.39425321222679, 0.834401769548858],
            [34.392481284430545, 0.835349332280931],
            [34.390691217852094, 0.838209702345718],
            [34.38964545399556, 0.839020650444406],
            [34.38833086839192, 0.839267806164741],
            [34.387833016671564, 0.840349425960428],
            [34.389157424454496, 0.843086508352424],
            [34.389184027163346, 0.844920245186863],
            [34.391426959629335, 0.847374875532427],
            [34.39443240097316, 0.848669419849483],
            [34.39684584266325, 0.849008121200092],
            [34.399947601371785, 0.851649451247052],
            [34.40167341684787, 0.851545951606831],
            [34.40224097334267, 0.851111421592856],
            [34.402866181017494, 0.851314120235049],
            [34.40373784328713, 0.853638083999072],
            [34.40459988639672, 0.858241419941967],
            [34.403336390678234, 0.859546243357804],
            [34.40227600404552, 0.859823914590781],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 870,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUMWONI",
        Population: 19278,
        Key: "NAMISINDWABUMWONI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.302462305466555, 0.924525837665813],
            [34.30185629209445, 0.925172214365025],
            [34.301050360452464, 0.925237128044763],
            [34.3007033762925, 0.92610450712245],
            [34.29885398587097, 0.926307683083249],
            [34.29830182919508, 0.927222183144652],
            [34.29680035179154, 0.927643826739733],
            [34.29623713415955, 0.928297368688853],
            [34.296330897613956, 0.92956556837596],
            [34.295752713150996, 0.929884214547206],
            [34.29566739655519, 0.931953695708751],
            [34.29342872030701, 0.933065589987235],
            [34.29161714806065, 0.933217032145378],
            [34.29055498635691, 0.934761018378969],
            [34.289428003120605, 0.934589128860515],
            [34.28879714863589, 0.935068121367623],
            [34.288015845205756, 0.934747601131055],
            [34.28443582793149, 0.9359919388321],
            [34.28316913421061, 0.935519480823668],
            [34.2810074157345, 0.937910684022228],
            [34.280424115366, 0.9381007079325],
            [34.27876239738042, 0.938107253976765],
            [34.27949275016427, 0.937193527393761],
            [34.27860877468702, 0.936968455858868],
            [34.27783645530803, 0.935162227121695],
            [34.277792189025796, 0.922978535301668],
            [34.273644651189336, 0.922034922620462],
            [34.273427991915845, 0.92078356237641],
            [34.272581009960305, 0.920366720639246],
            [34.26532027696343, 0.921584498264352],
            [34.26222230375546, 0.920840445336602],
            [34.26106998173993, 0.916095484484394],
            [34.25741098817917, 0.911322056033005],
            [34.2570872084013, 0.906822002753567],
            [34.25642894721561, 0.904976736299433],
            [34.25598760761149, 0.901621741785366],
            [34.254893747954625, 0.900428163122761],
            [34.25448887276448, 0.898917763922359],
            [34.25409369668451, 0.894558136954163],
            [34.25560355536963, 0.892946842526233],
            [34.2560280335959, 0.89183896160932],
            [34.25394896731244, 0.889898114778709],
            [34.25064809522452, 0.888296145296542],
            [34.248281654288434, 0.885328871298893],
            [34.25269272818484, 0.883245308290938],
            [34.25842124971738, 0.882332816317681],
            [34.2610216380046, 0.882500593628128],
            [34.275935718083204, 0.87986572882708],
            [34.27867748322985, 0.878517069917766],
            [34.27978536109672, 0.87910850232788],
            [34.281240438719216, 0.882414579362867],
            [34.28237835085927, 0.883968134364739],
            [34.28139204828801, 0.888719977871536],
            [34.28125475966147, 0.891896163887382],
            [34.28382101286622, 0.896358660092872],
            [34.28342106134217, 0.897050343720746],
            [34.28324920823841, 0.899921470741025],
            [34.288872859546366, 0.908029013728412],
            [34.2872450215217, 0.910543500143228],
            [34.28604994239359, 0.911229853835493],
            [34.28558105325632, 0.913240168749829],
            [34.28608813516619, 0.914260119154726],
            [34.29130044970218, 0.91527836268863],
            [34.293436329935794, 0.916479882824479],
            [34.2952819231786, 0.915641245619803],
            [34.29696259382005, 0.914158670053801],
            [34.29933509748602, 0.914109570796925],
            [34.300203515040835, 0.913453457391318],
            [34.300565086044394, 0.912433196877993],
            [34.3029540666093, 0.912942387203234],
            [34.30413102042994, 0.912317098060606],
            [34.30449355263083, 0.91395452334398],
            [34.30425160937534, 0.915491017079364],
            [34.305935740327314, 0.917974491513585],
            [34.305566251572834, 0.921794099301316],
            [34.302462305466555, 0.924525837665813],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 871,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "KHABUTOOLA",
        Population: 14951,
        Key: "MANAFWAKHABUTOOLA",
        Dist2: "Manafwa",
        "Sub Country": "Khabutoola",
        id2_original: "Manafwa Khabutoola",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.967383197269164, 0.734829390752425],
            [33.967622529122096, 0.744980605593376],
            [33.96994125963514, 0.750874003012847],
            [33.967275935729305, 0.760447807151928],
            [33.96746026912727, 0.763469142896786],
            [33.968514284009714, 0.765124328382794],
            [33.968747624997995, 0.766273121631506],
            [33.96813551026847, 0.769104672529149],
            [33.96818542066567, 0.773718140891835],
            [33.96909284307013, 0.775328126010061],
            [33.96982915976915, 0.775327955345807],
            [33.974079268143086, 0.771066292845848],
            [33.9760654513211, 0.77444904410792],
            [33.978026656842644, 0.77908919133978],
            [33.980786173597636, 0.787012844335734],
            [33.98003971851231, 0.791671714729011],
            [33.978863542632716, 0.793662117242474],
            [33.979317557465514, 0.79690952585458],
            [33.978681264580075, 0.799496837800729],
            [33.979441461194334, 0.800708819127549],
            [33.9790620765987, 0.804273038446292],
            [33.97940591126527, 0.807059124990693],
            [33.98113438485626, 0.810577599321265],
            [33.9826791008694, 0.811346131669966],
            [33.98329530203515, 0.813969319423943],
            [33.97693372694211, 0.819479903128746],
            [33.974187713662495, 0.821344059378753],
            [33.97031711385172, 0.82255717849932],
            [33.96499498117057, 0.822866047636821],
            [33.963321417999616, 0.823526817883527],
            [33.96143853389274, 0.824920369419285],
            [33.95533312238614, 0.833253286391814],
            [33.95278382308572, 0.835795857982542],
            [33.950431076067815, 0.84056372026887],
            [33.94967365704444, 0.843929050250431],
            [33.946557187524775, 0.839976674179105],
            [33.944039306801464, 0.837760995144262],
            [33.94173353089309, 0.834694925201121],
            [33.941069105467946, 0.830666544046878],
            [33.938115059436505, 0.826418601936447],
            [33.93713386109269, 0.824093983370809],
            [33.936457389259566, 0.820674709841672],
            [33.935583233266684, 0.819734119206622],
            [33.93518522749355, 0.818214464240382],
            [33.93415145973929, 0.816830650708775],
            [33.93385928808303, 0.813926911544028],
            [33.93261309751019, 0.809576014114565],
            [33.926608450028986, 0.794705537761112],
            [33.92679331882288, 0.792570605262035],
            [33.926336931539424, 0.791114278832392],
            [33.924659900871475, 0.788880257125623],
            [33.923254367133524, 0.785090232621561],
            [33.918708669013704, 0.778858433675137],
            [33.91777849677465, 0.773322381941403],
            [33.91536511976328, 0.770916625511333],
            [33.91231386703495, 0.766620348708084],
            [33.911580799542264, 0.763445294743308],
            [33.91124463558992, 0.759374582772551],
            [33.910315204461, 0.757185602598838],
            [33.9085400301533, 0.755485293818811],
            [33.90543371788457, 0.753667661973229],
            [33.90415740051205, 0.752491923629649],
            [33.901785946078355, 0.748991535288073],
            [33.897545560170734, 0.743908437333023],
            [33.896091752766075, 0.739874119122715],
            [33.895971824980705, 0.738408654959003],
            [33.89807217504819, 0.734482166541348],
            [33.89835098785785, 0.732853789186986],
            [33.91379935442642, 0.733854757402422],
            [33.92110015947152, 0.7363318932699],
            [33.929385889970526, 0.737867999367404],
            [33.93524545683837, 0.737468729520559],
            [33.94780725432808, 0.735123105801602],
            [33.955971613449044, 0.734026772462179],
            [33.960048558077226, 0.733989705625534],
            [33.967383197269164, 0.734829390752425],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 872,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "KIREWA",
        Population: 28113,
        Key: "TOROROKIREWA",
        Dist2: "Tororo",
        "Sub Country": "Kirewa",
        id2_original: "Tororo Kirewa",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.029610278534406, 0.748986511439957],
            [34.02882395531846, 0.749163057524976],
            [34.02790008745607, 0.748795263877164],
            [34.01900079234665, 0.739571442642054],
            [34.01469533068327, 0.73708930806818],
            [34.00758855814627, 0.735146063053852],
            [34.000776367445475, 0.734523440736923],
            [33.996634770167994, 0.734887154860322],
            [33.99670566610852, 0.732890900046863],
            [33.99603353313821, 0.730157669797813],
            [33.99661671762406, 0.726748161546014],
            [33.9977412224085, 0.723725120953276],
            [34.00081465993108, 0.720475175562719],
            [34.00019841654449, 0.719552526807658],
            [34.00036966059048, 0.711130698614072],
            [33.99849959274776, 0.706671449845556],
            [33.998079638437275, 0.70209428560019],
            [34.00034644183534, 0.69802856439554],
            [34.00120270069278, 0.694577579064884],
            [34.00133917095413, 0.691506336238426],
            [34.000927345498646, 0.689263404013228],
            [34.00046920650038, 0.688722779474034],
            [33.99439305402087, 0.685830424932712],
            [33.992656141656106, 0.684112053530215],
            [33.9914170720285, 0.680819576216768],
            [33.99178034533953, 0.674831063851558],
            [33.99113016719475, 0.673276140991128],
            [33.987919105974015, 0.671570002935133],
            [33.987078068170725, 0.669762686760843],
            [33.98585833477961, 0.668571873205257],
            [33.98247455627584, 0.666937459127394],
            [33.97747706665353, 0.666196662358805],
            [33.97543773465171, 0.666620211822507],
            [33.97437900630897, 0.666118922917202],
            [33.973942950595344, 0.665356309215096],
            [33.96849785202654, 0.662849800659681],
            [33.963445268727845, 0.662081882255605],
            [33.9549707105595, 0.661622189300936],
            [33.94985854649958, 0.660691434043227],
            [33.947006002908736, 0.660664846576794],
            [33.94133769005979, 0.662068083257549],
            [33.92253346282985, 0.661700763292491],
            [33.920171700319734, 0.661303175684674],
            [33.92323390890127, 0.656073919551348],
            [33.92573881435863, 0.653042990476572],
            [33.92930175016776, 0.649523375146645],
            [33.93397061270292, 0.646401588714702],
            [33.93663197324177, 0.64517986590771],
            [33.94170604963192, 0.643641079986738],
            [33.95022753309578, 0.642752965340618],
            [33.95824904571353, 0.641349309181562],
            [33.96045887615965, 0.640371915260201],
            [33.969332607012724, 0.634354610044439],
            [33.97344550491351, 0.634896590594447],
            [33.98021014149812, 0.637057295607],
            [33.98232640072927, 0.637337313706441],
            [33.990491164092134, 0.636603007901007],
            [34.00084993317904, 0.634674197549431],
            [34.00625997589221, 0.635586043825671],
            [34.010736622312784, 0.637069423910233],
            [34.01821096929435, 0.638623831640379],
            [34.0334058402729, 0.640059057866911],
            [34.04528050472366, 0.64485091381508],
            [34.0506813432984, 0.649255099739392],
            [34.05590228884764, 0.652790907236969],
            [34.05942053526799, 0.654192255300111],
            [34.06834181933896, 0.654470761587929],
            [34.073127142162505, 0.653664657894389],
            [34.07626383725079, 0.654116265474977],
            [34.07902157803645, 0.655201154701016],
            [34.08023107063329, 0.654196815749525],
            [34.08146728721155, 0.654721198238789],
            [34.082235715987046, 0.665738715095432],
            [34.083764221002525, 0.669821055299516],
            [34.08330019624254, 0.673529360376093],
            [34.08402974593252, 0.676649066455515],
            [34.084653775017685, 0.682364194607864],
            [34.08695524170762, 0.687239303461846],
            [34.088417239951056, 0.687772663118661],
            [34.08896625072685, 0.689156528396839],
            [34.09161181439139, 0.692726883380154],
            [34.09233682848753, 0.692731303666576],
            [34.09474934670951, 0.694808738121216],
            [34.09430098946637, 0.696409929087097],
            [34.09155350294967, 0.700924371536146],
            [34.09111757120355, 0.702824068797971],
            [34.08931909100415, 0.706813645031659],
            [34.08585054297855, 0.706751145907998],
            [34.08361767433867, 0.707240141637404],
            [34.06631061529385, 0.713431496124506],
            [34.062395346755544, 0.716148021899813],
            [34.06002895882005, 0.71700758041416],
            [34.05716574504025, 0.718912943482928],
            [34.05315575005358, 0.723113567911011],
            [34.05147117533387, 0.724389420567558],
            [34.050096728694655, 0.726153676429949],
            [34.048680758329766, 0.728979019397095],
            [34.04758007686664, 0.733354737713624],
            [34.04570761770864, 0.735770415296587],
            [34.04404723641617, 0.737254323910088],
            [34.04300270145494, 0.737643542461208],
            [34.03958181983495, 0.737599121756798],
            [34.038560871039834, 0.73798833399007],
            [34.0359802429939, 0.738092273021173],
            [34.03365817434125, 0.741622735017024],
            [34.030207615977545, 0.748789359755045],
            [34.029610278534406, 0.748986511439957],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 873,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "MULANDA",
        Population: 38798,
        Key: "TOROROMULANDA",
        Dist2: "Tororo",
        "Sub Country": "Mulanda",
        id2_original: "Tororo Mulanda",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.01276634144273, 0.468196851925428],
            [34.0095051587207, 0.473338302678891],
            [34.0074829486082, 0.478087717828905],
            [34.005178984601805, 0.480186719791259],
            [34.003783476960734, 0.480765867545079],
            [34.00270627117096, 0.480467511603744],
            [34.00000857198223, 0.478432570848775],
            [33.99298344013491, 0.474697614693908],
            [33.9899490981918, 0.474897067076208],
            [33.98736389682275, 0.474101393633202],
            [33.981294845525596, 0.475974791818424],
            [33.97283278112618, 0.476029445230828],
            [33.973729160540884, 0.477504185324038],
            [33.97407800421347, 0.479656998258412],
            [33.97469587894063, 0.480398864763094],
            [33.97473500775776, 0.481552080392119],
            [33.975693812898164, 0.48358380615933],
            [33.97519200409899, 0.487850361186366],
            [33.97681429592511, 0.489208653453491],
            [33.97694030799988, 0.489770065644692],
            [33.97280293100763, 0.492143173888452],
            [33.972309048942506, 0.49300313616051],
            [33.97206575462086, 0.495004770519626],
            [33.97132816141579, 0.495022990368507],
            [33.970284837383545, 0.495729461983961],
            [33.96498303357727, 0.494958242219171],
            [33.963164349368824, 0.495712444037888],
            [33.95835103593932, 0.503575617050773],
            [33.95663998158001, 0.508709814077016],
            [33.95324869405874, 0.512832531131449],
            [33.95120065468689, 0.514072153751514],
            [33.950758771602, 0.514814000219953],
            [33.94924878715271, 0.520707244144161],
            [33.94697127493814, 0.522089804610771],
            [33.94518349097882, 0.524308049614962],
            [33.94450254373896, 0.525904665213331],
            [33.941341877107334, 0.529055316854548],
            [33.93997949843565, 0.529055526153116],
            [33.93988389882477, 0.53033060864804],
            [33.937428644151474, 0.530895928349085],
            [33.93694946840588, 0.530019182360415],
            [33.936085352882955, 0.530095111905386],
            [33.931228271736174, 0.521456786282859],
            [33.927993513856535, 0.518924347634326],
            [33.925875840677115, 0.516491245030594],
            [33.92312585055574, 0.51064782746834],
            [33.9202935379234, 0.506369399330554],
            [33.91815742053454, 0.505489027182932],
            [33.916952176969005, 0.50449731934169],
            [33.91602357139182, 0.502778677735127],
            [33.91247937354122, 0.50024624609819],
            [33.90649881977426, 0.497487991826307],
            [33.90432049324515, 0.495761936662499],
            [33.90281097951307, 0.493214281839638],
            [33.90168608216483, 0.492818101737484],
            [33.90047671263719, 0.491629263958361],
            [33.90008263968834, 0.488826666877233],
            [33.901441530201765, 0.486054271594516],
            [33.90157967941439, 0.4817392063286],
            [33.90205873388742, 0.480638463972405],
            [33.90301569388822, 0.479799171431428],
            [33.903555994599024, 0.479954499967255],
            [33.90381778613068, 0.479533084497702],
            [33.905281002489644, 0.479259865179809],
            [33.90543228147845, 0.478567759889504],
            [33.906081893684586, 0.478408938794139],
            [33.90625831741648, 0.477075541211479],
            [33.907790849579406, 0.476345155318381],
            [33.90838375742986, 0.476643497964758],
            [33.90816923614674, 0.476040334232836],
            [33.9087683208131, 0.475348170230078],
            [33.90846546369653, 0.474465644407656],
            [33.909543797770326, 0.473087683059282],
            [33.90936078130254, 0.472236888858612],
            [33.910344679083764, 0.472160564295962],
            [33.910559020703836, 0.47139225948294],
            [33.911542950824426, 0.471569912383342],
            [33.91233123955422, 0.470807882025567],
            [33.91217977191923, 0.470071372761147],
            [33.91150487573108, 0.469785739667859],
            [33.91144792164378, 0.468325386668375],
            [33.911012567514355, 0.467055566894933],
            [33.910381594452055, 0.466771720368497],
            [33.909921951674, 0.465120321141869],
            [33.91052676489693, 0.462111932998559],
            [33.911565370977286, 0.462033308713577],
            [33.91188125276714, 0.461635704827898],
            [33.9123172680566, 0.461864644721297],
            [33.9121844431587, 0.460824635051624],
            [33.91285522865609, 0.459540872527315],
            [33.912370575882186, 0.458725475466866],
            [33.912553089293404, 0.457816678065837],
            [33.911981873062125, 0.457889052119102],
            [33.91202918553152, 0.457281568714042],
            [33.91131829744321, 0.456957248591054],
            [33.91114612184429, 0.456072008538143],
            [33.911536015830436, 0.455909202133815],
            [33.911341004158636, 0.455478400817242],
            [33.91164053032214, 0.455143275119377],
            [33.91134079215625, 0.453793392258334],
            [33.911821060253224, 0.453850774838624],
            [33.91157848727874, 0.453343389029143],
            [33.91193986694112, 0.453295472595023],
            [33.91182092550593, 0.452783284503074],
            [33.91231065016792, 0.452414625616236],
            [33.912096594212116, 0.451792348754207],
            [33.91250551631261, 0.451682198062821],
            [33.91191067169438, 0.447986744390383],
            [33.91219107542044, 0.446823479530108],
            [33.91410126561703, 0.444078235532669],
            [33.91870646634462, 0.443498701218545],
            [33.92225380560377, 0.440277819289128],
            [33.92737038218837, 0.44224923768062],
            [33.93456432903714, 0.443876628194806],
            [33.942242177668234, 0.443957056439703],
            [33.94652608695132, 0.443305182951898],
            [33.951242419161076, 0.443544036036023],
            [33.95343208153073, 0.442656661819291],
            [33.95533586314605, 0.443858329163257],
            [33.95546086012457, 0.445542141698967],
            [33.95699324047223, 0.446189518159268],
            [33.95940196241381, 0.448323962530539],
            [33.963074491789264, 0.448048822366871],
            [33.96620716601831, 0.447165271805861],
            [33.968008367214715, 0.447507468295232],
            [33.97065725464583, 0.450189340416754],
            [33.97262590450615, 0.450864023507216],
            [33.973153812059266, 0.451653786131519],
            [33.974694305990575, 0.45204899124409],
            [33.981178276541044, 0.448715364473308],
            [33.982202744935485, 0.447564001144715],
            [33.982550463917335, 0.448153381271505],
            [33.98370319736127, 0.448401888097087],
            [33.98546905074956, 0.449958099637607],
            [33.986329002581165, 0.449976401348801],
            [33.99105902331919, 0.452158465519563],
            [33.99255024914872, 0.452434552322935],
            [33.99378543176606, 0.453530341449747],
            [33.994307034044205, 0.454580181233572],
            [33.99631977052372, 0.455233791900709],
            [33.99702146615171, 0.456486635267539],
            [34.0055245664916, 0.462058594568293],
            [34.0066690273501, 0.461943624729435],
            [34.00731250046957, 0.461370125631318],
            [34.0080180705314, 0.461904455862769],
            [34.00913052082303, 0.463984677746147],
            [34.00993138686515, 0.464313401844541],
            [34.010099871286556, 0.46536874833161],
            [34.01141754350152, 0.46639979334265],
            [34.01276634144273, 0.468196851925428],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 874,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BUYANGA",
        Population: 18359,
        Key: "BUSIABUYANGA",
        Dist2: "Busia",
        "Sub Country": "Buyanga",
        id2_original: "Busia Buyanga",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34277077766693, 1.002052554814554],
            [34.33933222259208, 1.002162515140779],
            [34.33746952003636, 1.002749285711505],
            [34.337202290103974, 1.004144081751979],
            [34.334825081960865, 1.004869977811413],
            [34.33439879093436, 1.007670213569992],
            [34.330656657395735, 1.007307247010252],
            [34.32884566007115, 1.006427090546145],
            [34.328483088344385, 1.005333703936437],
            [34.3265210815256, 1.004149844457738],
            [34.325404029164744, 1.002935261485325],
            [34.322646060206985, 0.998381646673475],
            [34.32182733745369, 0.997373862838028],
            [34.31915810138476, 0.995590978471527],
            [34.31768749548427, 0.994639282424787],
            [34.3157771355061, 0.994220985634366],
            [34.31249494029127, 0.992767896168344],
            [34.312373961477, 0.989874746134648],
            [34.31040482113656, 0.98750227772815],
            [34.309107739206226, 0.982365260012173],
            [34.31081918073946, 0.982556449089506],
            [34.31221443505558, 0.98206662215213],
            [34.313091032669405, 0.981394701015882],
            [34.314062469021025, 0.979513912301246],
            [34.31560617353114, 0.978669038096069],
            [34.31578250922814, 0.979157872138974],
            [34.31851289182183, 0.979474477531875],
            [34.319117254988775, 0.98129051621802],
            [34.318730585954505, 0.981392997161764],
            [34.318058240981784, 0.983746368265183],
            [34.32037114142867, 0.982885330527546],
            [34.32212127609611, 0.983902359274649],
            [34.32438037823722, 0.984188503248355],
            [34.32543746895119, 0.984914141427361],
            [34.32573407020011, 0.985544403257739],
            [34.325102466520484, 0.986152523878846],
            [34.32463653823038, 0.988502925825688],
            [34.32588072286519, 0.988746898883145],
            [34.325865102959035, 0.989290075016055],
            [34.32658685617071, 0.989884364757322],
            [34.328138429024385, 0.990309001458383],
            [34.329572044996425, 0.990196877018213],
            [34.32986988322548, 0.99303005436968],
            [34.330175746105006, 0.993575770751946],
            [34.331823637221774, 0.99442661676336],
            [34.33195761016659, 0.995390121240314],
            [34.333538573201444, 0.995904867102264],
            [34.33640858004143, 0.99077219432015],
            [34.33905826787145, 0.991420954869167],
            [34.339036844848536, 0.993504933073689],
            [34.3396838726016, 0.996888316117139],
            [34.33943961259102, 0.998479403566293],
            [34.34006288978628, 0.998187838520997],
            [34.34030830503033, 0.99944260057834],
            [34.343002618468724, 1.000315410924247],
            [34.34277077766693, 1.002052554814554],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 875,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUWANGANI TOWN COUNCIL",
        Population: 4922,
        Key: "MANAFWABUWANGANI TOWN COUNCIL",
        Dist2: "Manafwa",
        "Sub Country": "Manafwa Town Council",
        id2_original: "Manafwa Manafwa Town Council",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.204286153903894, 0.726503772069418],
            [34.198963687049456, 0.731968592463321],
            [34.19713524983195, 0.732421353106621],
            [34.196042359457294, 0.732331194770871],
            [34.19428749515986, 0.730957941674177],
            [34.189977083779276, 0.728942043241287],
            [34.188873146821535, 0.728606425666087],
            [34.187947122104184, 0.728796624950466],
            [34.18628232738873, 0.727964892634756],
            [34.18450092595949, 0.727920139484569],
            [34.183977404879904, 0.72749514487187],
            [34.181856871464596, 0.727375874385184],
            [34.179789557840024, 0.72669868003245],
            [34.17782482912593, 0.726617083634752],
            [34.17483565178036, 0.727233878349402],
            [34.17578334835396, 0.728419943301901],
            [34.17714323509903, 0.731540254077909],
            [34.18064047082321, 0.734252946988194],
            [34.18373706960878, 0.735691474264858],
            [34.18585535993081, 0.740321694320351],
            [34.18551661961021, 0.743975438818383],
            [34.1841856011251, 0.745974832484508],
            [34.18275300024935, 0.750317013588537],
            [34.181220902871004, 0.757752222936751],
            [34.18212037698185, 0.762098969703501],
            [34.17851023380626, 0.765749290739344],
            [34.17543904117355, 0.764077094712195],
            [34.17484848601083, 0.762898723772356],
            [34.17296681193464, 0.761649305642569],
            [34.172507740485074, 0.760390587711413],
            [34.16964378918843, 0.757494578096561],
            [34.166977154640556, 0.755579811724722],
            [34.16487561340702, 0.754658717910083],
            [34.162883705265706, 0.754513957974088],
            [34.158033314771174, 0.75219048668696],
            [34.15979684242117, 0.746549310275935],
            [34.16012823901433, 0.743155858923645],
            [34.1599005340561, 0.740413935513692],
            [34.15735487832251, 0.73985968170496],
            [34.14709741943672, 0.735831963682512],
            [34.145500080114246, 0.73709604038412],
            [34.14357969763247, 0.739508986186731],
            [34.1428759107265, 0.741200678952649],
            [34.13785164502051, 0.7481113862954],
            [34.12970943835444, 0.744605332854094],
            [34.12861396532335, 0.743312099636264],
            [34.12797979425862, 0.743113336255016],
            [34.12661266439739, 0.740001933338562],
            [34.12644259804276, 0.738183815429554],
            [34.12545179581024, 0.735479439925882],
            [34.12228365878872, 0.730640853190471],
            [34.1215056494807, 0.727665048406266],
            [34.120362370805125, 0.726046172893282],
            [34.12029485971659, 0.725328083120336],
            [34.11933814765079, 0.724400129426439],
            [34.117522254507925, 0.718982262812428],
            [34.11539462799513, 0.717978725019641],
            [34.11319320218683, 0.716034458565163],
            [34.11221872593629, 0.715700009551973],
            [34.108552713838215, 0.711856559548019],
            [34.10479618928875, 0.709867379086198],
            [34.10291477213073, 0.707434551893512],
            [34.10295001483596, 0.706310168617014],
            [34.102389916154635, 0.706123058367772],
            [34.10222178027953, 0.705218532468248],
            [34.10060213129698, 0.703002732956914],
            [34.100133627536955, 0.700099186895741],
            [34.097895527108854, 0.697358879580727],
            [34.096546562080995, 0.697127743105608],
            [34.096414092017625, 0.696108748008254],
            [34.09474934670951, 0.694808738121216],
            [34.09233682848753, 0.692731303666576],
            [34.09161181439139, 0.692726883380154],
            [34.08896625072685, 0.689156528396839],
            [34.088417239951056, 0.687772663118661],
            [34.08695524170762, 0.687239303461846],
            [34.084653775017685, 0.682364194607864],
            [34.08402974593252, 0.676649066455515],
            [34.08330019624254, 0.673529360376093],
            [34.083764221002525, 0.669821055299516],
            [34.082235715987046, 0.665738715095432],
            [34.08146728721155, 0.654721198238789],
            [34.082155758740235, 0.654431585020968],
            [34.083486836514155, 0.654720757194777],
            [34.08393717903409, 0.654404058842959],
            [34.085245910317006, 0.655245023754162],
            [34.08648088722017, 0.65523570793558],
            [34.088853924485385, 0.653751691793828],
            [34.08983063664266, 0.648893939085662],
            [34.09241065113927, 0.648290602724562],
            [34.0934917502275, 0.646497209188488],
            [34.09287626681566, 0.644063771723638],
            [34.09314441033469, 0.64238936814698],
            [34.09873583188688, 0.637476357121277],
            [34.100050192911674, 0.638443959666954],
            [34.10155067228695, 0.640469863236495],
            [34.10512579014965, 0.642694437494274],
            [34.106944671987456, 0.643341108313879],
            [34.11595812320655, 0.638996605719467],
            [34.12591311214968, 0.632692619063158],
            [34.127696063172756, 0.632093897854424],
            [34.12919384850049, 0.632093569091027],
            [34.13178554648569, 0.633433252770215],
            [34.13273685518505, 0.634964761352015],
            [34.13318901948836, 0.637022907528619],
            [34.134140140439825, 0.637692823328374],
            [34.13466341448271, 0.638769694606282],
            [34.13680335959297, 0.639918004217697],
            [34.138158772727955, 0.641162219792323],
            [34.14027113057585, 0.646522743971415],
            [34.14030981921847, 0.649413846109565],
            [34.138731605926736, 0.651213971948153],
            [34.137990181406984, 0.652707563360616],
            [34.13502357423293, 0.654661181221372],
            [34.13424101226306, 0.657203946625176],
            [34.13261688787377, 0.659425966957255],
            [34.132375142247675, 0.661760698483942],
            [34.12948900525845, 0.666257121178153],
            [34.12719380521594, 0.672123758269286],
            [34.12539273158032, 0.674512212778437],
            [34.1216905604954, 0.676620700535275],
            [34.12021808789578, 0.676865275861316],
            [34.11671887587795, 0.67646303653355],
            [34.11809311949793, 0.677498964285575],
            [34.11832093944049, 0.678843924727947],
            [34.11968499886007, 0.679823455215716],
            [34.12605806789718, 0.681070104943463],
            [34.1281378492396, 0.682026088210737],
            [34.12976167359159, 0.68175425929143],
            [34.13583186305423, 0.683572166771271],
            [34.13842673927889, 0.683111460816592],
            [34.14068127618172, 0.681862636051582],
            [34.14151369375157, 0.682387078465022],
            [34.144197563376444, 0.682286932396018],
            [34.14535129754361, 0.683155025112906],
            [34.15119098469427, 0.682278060365027],
            [34.15419004440626, 0.682974269974191],
            [34.154903907714804, 0.684636175022413],
            [34.15624714328777, 0.685522623971669],
            [34.15624560177876, 0.687044071370694],
            [34.15744604115418, 0.688288845472174],
            [34.15709496337145, 0.691609169677759],
            [34.15774124103126, 0.692766864470958],
            [34.15779428924372, 0.694929233763085],
            [34.1574310563569, 0.696005732322195],
            [34.157600547789784, 0.697308433930795],
            [34.15716996101959, 0.697625760953277],
            [34.15720193295885, 0.699497352463116],
            [34.158127904675645, 0.700184571676346],
            [34.158799399842074, 0.70297051281304],
            [34.16115587127518, 0.706244280400547],
            [34.16631137545426, 0.706306294477585],
            [34.16836822909569, 0.70740931654754],
            [34.17173985698695, 0.706567231639255],
            [34.17224679247146, 0.707536834358501],
            [34.17285307982976, 0.707698225949638],
            [34.17728534857698, 0.712074474909127],
            [34.18429004554823, 0.711656573166626],
            [34.19972817042423, 0.709020346184491],
            [34.20211156256975, 0.713316256596274],
            [34.210274598472324, 0.722768801290065],
            [34.20675326184738, 0.724486000604781],
            [34.204286153903894, 0.726503772069418],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 876,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "RUBONGI",
        Population: 36527,
        Key: "TORORORUBONGI",
        Dist2: "Tororo",
        "Sub Country": "Rubongi",
        id2_original: "Tororo Rubongi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.201314607792426, 0.813667678513899],
            [34.19910109694857, 0.814011682392222],
            [34.19625607674821, 0.815669742732883],
            [34.19218334342212, 0.817021018501697],
            [34.18947714078094, 0.819853730218571],
            [34.189370429010005, 0.820611309659352],
            [34.18670658373112, 0.822901131314855],
            [34.18461649961069, 0.823832114715333],
            [34.179887289153044, 0.824320781817135],
            [34.17920011838487, 0.823386807449823],
            [34.17886310013467, 0.821306463357327],
            [34.180072263049816, 0.813680825828816],
            [34.1808069178656, 0.794441032702876],
            [34.1806341098527, 0.7910761920984],
            [34.17937138219379, 0.785803245596864],
            [34.176928847664904, 0.785677039676368],
            [34.174604938364254, 0.787121212256021],
            [34.17435307141983, 0.788057187212004],
            [34.17263589234691, 0.789667747987598],
            [34.17128070918064, 0.789715721551638],
            [34.16694783632465, 0.791898090122791],
            [34.16617562564178, 0.791676230128849],
            [34.16879823016431, 0.787662195801707],
            [34.168939822619414, 0.786837289664172],
            [34.17032406359016, 0.785864001029485],
            [34.168914667096494, 0.783779871544016],
            [34.16603632029742, 0.781392683030681],
            [34.162473920782524, 0.780461168102474],
            [34.16024568655121, 0.783448974821105],
            [34.158152213087234, 0.784625217532898],
            [34.15742647944055, 0.785557474372774],
            [34.15234551836202, 0.789117646768915],
            [34.15137832744844, 0.792009405904851],
            [34.14962190906557, 0.794530685829901],
            [34.149001207340255, 0.794806239995553],
            [34.1488962230296, 0.795643001167066],
            [34.1482441144053, 0.796490508574511],
            [34.146455945068716, 0.798344533492116],
            [34.143720716962385, 0.799828121277428],
            [34.14138505859613, 0.800400723468366],
            [34.139354668424666, 0.801481633392106],
            [34.13800787282819, 0.801429054752965],
            [34.136787517802944, 0.802022525234614],
            [34.13349475031551, 0.803961711235309],
            [34.13334772844286, 0.804978546120134],
            [34.132821772928835, 0.805455315803452],
            [34.129129104223026, 0.807151009933696],
            [34.12375344632398, 0.810668936267158],
            [34.120071080396144, 0.811633807148725],
            [34.11913484632558, 0.812386076933394],
            [34.11818792140482, 0.812524032612201],
            [34.11786865476293, 0.813045837504482],
            [34.117436414194316, 0.812550942533574],
            [34.11842634506098, 0.810068495019193],
            [34.118151936691156, 0.809132796339466],
            [34.11871231834181, 0.807941062629549],
            [34.11737194300469, 0.804638464031692],
            [34.11704952597112, 0.802704851851471],
            [34.117297665805424, 0.798785119732076],
            [34.11697602671287, 0.796513017282086],
            [34.115110580702314, 0.793093583991615],
            [34.11504972433338, 0.792342815193716],
            [34.11518732737027, 0.790421642211164],
            [34.116226952140174, 0.788381053121698],
            [34.1188746582867, 0.785717204965846],
            [34.120285486694904, 0.784299341988782],
            [34.12354825224848, 0.78286246836143],
            [34.12561004752228, 0.780235246594097],
            [34.12598590353545, 0.777688765309564],
            [34.12575672354356, 0.77240645946857],
            [34.128082563323765, 0.767275216673878],
            [34.13165915891509, 0.764486305593617],
            [34.13286082988077, 0.763014564731822],
            [34.1379855973041, 0.759973558192387],
            [34.14015808478384, 0.756826857568301],
            [34.143281552179566, 0.755064049298266],
            [34.141647676577854, 0.753186642255054],
            [34.14094317910449, 0.749876731305286],
            [34.13785164502051, 0.7481113862954],
            [34.1428759107265, 0.741200678952649],
            [34.14357969763247, 0.739508986186731],
            [34.145500080114246, 0.73709604038412],
            [34.14709741943672, 0.735831963682512],
            [34.15735487832251, 0.73985968170496],
            [34.1599005340561, 0.740413935513692],
            [34.16012823901433, 0.743155858923645],
            [34.15979684242117, 0.746549310275935],
            [34.158033314771174, 0.75219048668696],
            [34.162883705265706, 0.754513957974088],
            [34.16487561340702, 0.754658717910083],
            [34.166977154640556, 0.755579811724722],
            [34.16964378918843, 0.757494578096561],
            [34.172507740485074, 0.760390587711413],
            [34.17296681193464, 0.761649305642569],
            [34.17484848601083, 0.762898723772356],
            [34.17543904117355, 0.764077094712195],
            [34.17851023380626, 0.765749290739344],
            [34.18212037698185, 0.762098969703501],
            [34.181220902871004, 0.757752222936751],
            [34.18275300024935, 0.750317013588537],
            [34.1841856011251, 0.745974832484508],
            [34.18551661961021, 0.743975438818383],
            [34.18585535993081, 0.740321694320351],
            [34.18373706960878, 0.735691474264858],
            [34.18064047082321, 0.734252946988194],
            [34.17714323509903, 0.731540254077909],
            [34.17578334835396, 0.728419943301901],
            [34.17483565178036, 0.727233878349402],
            [34.17782482912593, 0.726617083634752],
            [34.179789557840024, 0.72669868003245],
            [34.181856871464596, 0.727375874385184],
            [34.183977404879904, 0.72749514487187],
            [34.18450092595949, 0.727920139484569],
            [34.18628232738873, 0.727964892634756],
            [34.187947122104184, 0.728796624950466],
            [34.188873146821535, 0.728606425666087],
            [34.189977083779276, 0.728942043241287],
            [34.19428749515986, 0.730957941674177],
            [34.196042359457294, 0.732331194770871],
            [34.19713524983195, 0.732421353106621],
            [34.198963687049456, 0.731968592463321],
            [34.204286153903894, 0.726503772069418],
            [34.2057166239758, 0.727481788898562],
            [34.20637470999002, 0.729123952631036],
            [34.20839990879747, 0.730998183821994],
            [34.21469866290606, 0.732796480461411],
            [34.21912909998841, 0.732921897472836],
            [34.22816338493559, 0.743013901115772],
            [34.22563588235723, 0.748097971998479],
            [34.22096831070113, 0.750714581907709],
            [34.21880401585675, 0.75328962520246],
            [34.21727765062829, 0.762838620129655],
            [34.21610087018249, 0.764432654895763],
            [34.216060468452596, 0.765113734596966],
            [34.21450511728482, 0.767797586849828],
            [34.21313878872084, 0.769010281571146],
            [34.21319315027026, 0.769841168944148],
            [34.21165081119938, 0.770699758590609],
            [34.21096098231628, 0.771667074777233],
            [34.21139409245413, 0.772034728148396],
            [34.217711885456836, 0.772246998739286],
            [34.218597326984614, 0.771714248220336],
            [34.22016047822398, 0.771683879833608],
            [34.22113497513578, 0.770810066217599],
            [34.22276932055635, 0.770330947280402],
            [34.22723896191436, 0.770610853183207],
            [34.23111990852056, 0.769933634967898],
            [34.23167861481323, 0.769975354352328],
            [34.23276673782866, 0.771548579771036],
            [34.23398274680458, 0.772207668678746],
            [34.23707619879172, 0.772899483725646],
            [34.24209732668241, 0.768913302797799],
            [34.24439661495775, 0.765968974776351],
            [34.24566845961849, 0.765735263900671],
            [34.247867773487556, 0.766476512558737],
            [34.2503895735605, 0.768245261575286],
            [34.251362957459634, 0.767863541523314],
            [34.253796459428344, 0.768240426378789],
            [34.255335627446264, 0.767618047708717],
            [34.26033072844823, 0.767649361067291],
            [34.26195879374665, 0.767268225712927],
            [34.26278271594884, 0.767643640210745],
            [34.26063416407983, 0.769362185531448],
            [34.25735671376634, 0.77119932757783],
            [34.25304760224794, 0.772700159408136],
            [34.249020936326204, 0.774675154554884],
            [34.2468385539036, 0.776457705103291],
            [34.24400218717439, 0.77725452554652],
            [34.241595925718364, 0.779724581015678],
            [34.23779665842934, 0.78134480458363],
            [34.235765315145386, 0.783064000949897],
            [34.23468413970034, 0.78462010120884],
            [34.23438503215175, 0.785379989341851],
            [34.234571858374665, 0.78665531083986],
            [34.23247499377048, 0.790916240746397],
            [34.23203936924816, 0.791504311687441],
            [34.230561392670786, 0.792002243423149],
            [34.22969074190414, 0.793305019061772],
            [34.22809563848841, 0.794644194117867],
            [34.227438549604166, 0.796471531701229],
            [34.22796271028425, 0.798994997881403],
            [34.22589622041479, 0.799646879571172],
            [34.22397653053407, 0.802939933153674],
            [34.221172857989615, 0.804279480528767],
            [34.22081364416541, 0.804985120240801],
            [34.21762289834479, 0.80778107600545],
            [34.21446233591772, 0.808662743121646],
            [34.21072983321728, 0.809022856205828],
            [34.207912863809995, 0.81011263112544],
            [34.205529555207775, 0.81044840217213],
            [34.20462255411318, 0.811350875197332],
            [34.20299537545193, 0.811540824676071],
            [34.20142732929258, 0.81280435962926],
            [34.201314607792426, 0.813667678513899],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 877,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "MUKUJU",
        Population: 38209,
        Key: "TOROROMUKUJU",
        Dist2: "Tororo",
        "Sub Country": "Mukuju",
        id2_original: "Tororo Mukuju",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.19972817042423, 0.709020346184491],
            [34.18429004554823, 0.711656573166626],
            [34.18401975954722, 0.70663644785617],
            [34.182479752502836, 0.699527159037626],
            [34.18424084661677, 0.699255348185919],
            [34.18453174625857, 0.696993924693478],
            [34.186784640142776, 0.696106903004859],
            [34.18473413579377, 0.691114366032767],
            [34.18885129530227, 0.689331386288947],
            [34.19167594620354, 0.688688451038944],
            [34.191645569672225, 0.68622811743081],
            [34.18842252402728, 0.683687175280054],
            [34.186568896252574, 0.686726890055053],
            [34.18478231873068, 0.688391690658301],
            [34.18390798846463, 0.688681362945109],
            [34.17966777593188, 0.687967837691985],
            [34.17289830910601, 0.659928678478963],
            [34.17558327377726, 0.65854483364208],
            [34.179160389493134, 0.657504021671787],
            [34.182729071825094, 0.655002717249851],
            [34.1833340251852, 0.653468683402722],
            [34.184122518730895, 0.652803791835075],
            [34.18810286571993, 0.652969128604777],
            [34.189482314178655, 0.653755747423338],
            [34.202023817827765, 0.665954889951711],
            [34.21001351571141, 0.674281845002926],
            [34.21030850807766, 0.675721775913105],
            [34.208997015373555, 0.67948495700247],
            [34.20824630676534, 0.684505298031116],
            [34.210763110408664, 0.690239382488279],
            [34.2138099856466, 0.693458723225889],
            [34.20522205739446, 0.706187716885774],
            [34.20190080163444, 0.708359466661783],
            [34.19972817042423, 0.709020346184491],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 878,
        District: "TORORO",
        County: "TORORO MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 19074,
        Key: "TOROROEASTERN DIVISION",
        Dist2: "Tororo",
        "Sub Country": "Eastern Division",
        id2_original: "Tororo Eastern Division",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30775534800387, 0.721603969346394],
            [34.30746132042824, 0.722226754233852],
            [34.30533360947382, 0.72277601778082],
            [34.30274078859455, 0.722632050853836],
            [34.294510604522806, 0.718902439410912],
            [34.293217446433665, 0.720771040146784],
            [34.29123534520026, 0.727668888394385],
            [34.28923460392476, 0.729374495824994],
            [34.28564574183824, 0.731033314971507],
            [34.28592965797704, 0.736168822085915],
            [34.28571792775953, 0.736524288425769],
            [34.2845479340857, 0.736532650151826],
            [34.27778676409979, 0.735021923404026],
            [34.27354297896715, 0.735285455736036],
            [34.27210569247887, 0.73458035241766],
            [34.2704308357339, 0.734591950511288],
            [34.26890316525332, 0.73383853426084],
            [34.267839453057384, 0.73179681625689],
            [34.268035532826026, 0.731243875505781],
            [34.26743317649544, 0.730032002099523],
            [34.26772427735986, 0.728747513535342],
            [34.26721926516841, 0.728213995111842],
            [34.26734512991949, 0.727152154410926],
            [34.26634737382834, 0.725537033370971],
            [34.26671330255935, 0.724871622797896],
            [34.26612365200011, 0.724642043457741],
            [34.26573588881781, 0.723735132776657],
            [34.26565547163358, 0.72106992460847],
            [34.26538598423489, 0.720374017089134],
            [34.264784141740606, 0.720390263633481],
            [34.26352732499627, 0.721783957687218],
            [34.25817663756718, 0.724046743358118],
            [34.25736203179282, 0.726977599755101],
            [34.253662178361346, 0.731017555312653],
            [34.25320645493287, 0.73435690137643],
            [34.25187476001634, 0.735289468179975],
            [34.25031454177637, 0.735545305263319],
            [34.24609542707639, 0.732706359859369],
            [34.24483310096442, 0.731114760384468],
            [34.241241685865845, 0.728827328679378],
            [34.23818420152439, 0.726024162342798],
            [34.23508937960647, 0.720768284333559],
            [34.23354497351213, 0.716390059428799],
            [34.23227287372985, 0.715415734698277],
            [34.23224591708481, 0.714240530635721],
            [34.231343614179146, 0.713941612492831],
            [34.23064637599159, 0.712784009179342],
            [34.23290696304788, 0.711426614102918],
            [34.23797885653191, 0.706651679429945],
            [34.24132683537502, 0.705152695436374],
            [34.24326937480328, 0.699611464134194],
            [34.243381188106696, 0.69704173398654],
            [34.24303483097078, 0.696170740661617],
            [34.24342393713444, 0.69507306950868],
            [34.24338813208383, 0.693087544066002],
            [34.243795383317895, 0.692426789847033],
            [34.24129098451032, 0.690288132317381],
            [34.24110429213641, 0.689611109499222],
            [34.24046555403681, 0.689378000986509],
            [34.23953252335853, 0.687648581478849],
            [34.23895596574454, 0.687443903400838],
            [34.238463806648156, 0.685765573909928],
            [34.23798896437549, 0.685481212804465],
            [34.23801122822148, 0.684144130082278],
            [34.237247993504965, 0.683313633856615],
            [34.23825911383258, 0.681020426228079],
            [34.23804422064694, 0.680559615831923],
            [34.23721903271851, 0.680582589522826],
            [34.23716795271482, 0.679751906744511],
            [34.236596996994976, 0.67934808763111],
            [34.235952026383906, 0.676827718123419],
            [34.235985314355084, 0.674369761522178],
            [34.235329307940766, 0.672890608878639],
            [34.2356851315231, 0.671889131761027],
            [34.23552644682313, 0.670187952480186],
            [34.23597280980631, 0.669613179581389],
            [34.23571267207308, 0.669032896724929],
            [34.23617609586017, 0.668873467408781],
            [34.236757829566805, 0.667194859315948],
            [34.238176141839666, 0.665851731697025],
            [34.23917367964018, 0.663648673711153],
            [34.239903872523925, 0.663328041569703],
            [34.2407274704343, 0.662130865913878],
            [34.24054002617048, 0.661348644477091],
            [34.24110130433977, 0.65946351674384],
            [34.2407277363356, 0.658396389658415],
            [34.24226064579095, 0.65836748198457],
            [34.24382371438532, 0.657435963498731],
            [34.24498452458199, 0.660104923429895],
            [34.25795163114807, 0.656900785152074],
            [34.25947945973216, 0.658343911747586],
            [34.262690633242336, 0.659849364296693],
            [34.265091099666456, 0.660507741675952],
            [34.26795957937044, 0.662829171331387],
            [34.2707029192638, 0.663393311478363],
            [34.271295368075144, 0.664052150090183],
            [34.27117104842633, 0.665495690498863],
            [34.27167000507448, 0.666248694652221],
            [34.277031243216584, 0.664489982888701],
            [34.27818475819483, 0.664991770490974],
            [34.27980286477003, 0.666493165401438],
            [34.279404717961384, 0.666700569667963],
            [34.279772518781414, 0.668438957641985],
            [34.279324971818646, 0.668545339676535],
            [34.279063909719, 0.669916913361643],
            [34.27810518452864, 0.670428665637717],
            [34.27890382813874, 0.672757769784167],
            [34.27765006566637, 0.673888755067983],
            [34.277505048833405, 0.674622079902488],
            [34.27852890727174, 0.678842752508782],
            [34.27918431810305, 0.679643626049882],
            [34.27984293232663, 0.679333156884015],
            [34.28112203986644, 0.680180727769989],
            [34.281840771145475, 0.679873002798616],
            [34.282326384218415, 0.681437668675711],
            [34.283688101730036, 0.681952107306756],
            [34.284128448695796, 0.681752941556211],
            [34.284103822280606, 0.681113000958905],
            [34.284588714904665, 0.680523508799595],
            [34.286839641478394, 0.679977363516275],
            [34.28762930283395, 0.68024493661794],
            [34.28826944230539, 0.681237074683532],
            [34.28966064072803, 0.681596064590361],
            [34.28969456290979, 0.682131625591415],
            [34.28889657417154, 0.6823018640322],
            [34.288863444303885, 0.682732204672299],
            [34.29157196819174, 0.68307232130652],
            [34.29401040819956, 0.684183469893651],
            [34.293871285213214, 0.68498686214055],
            [34.293351997893545, 0.685242036404396],
            [34.29408690333926, 0.68601118445504],
            [34.295077710961664, 0.684645200650018],
            [34.29609217661539, 0.684654713129672],
            [34.295729185375386, 0.685156376489746],
            [34.29596583396058, 0.685874653910017],
            [34.294606506865904, 0.686929161750122],
            [34.294962427466324, 0.688208968548743],
            [34.2969822624332, 0.687719983417526],
            [34.29789178869206, 0.687876131701772],
            [34.298030849694676, 0.68822621495795],
            [34.29742763637129, 0.689023906228907],
            [34.29885490484754, 0.689384808825234],
            [34.29893981450648, 0.691080750825377],
            [34.30110325595132, 0.689891099473324],
            [34.3015176910127, 0.690504592619129],
            [34.30365455040996, 0.690829620795243],
            [34.305303453928055, 0.693074332611444],
            [34.304275703987926, 0.693634735210101],
            [34.30504250501611, 0.694065289509396],
            [34.30553009617929, 0.694944638737016],
            [34.30669503503298, 0.695147730183672],
            [34.306877207084405, 0.693763790300732],
            [34.30824875935178, 0.694989029314386],
            [34.30925833817036, 0.6945545883746],
            [34.310793223020994, 0.694988316104529],
            [34.311958218468575, 0.694065404485321],
            [34.3127158054769, 0.694182776034848],
            [34.31327922433154, 0.694788629913831],
            [34.31313170748715, 0.695552761495493],
            [34.312038266445235, 0.695983835706141],
            [34.312425292110646, 0.698550378547689],
            [34.313768445038654, 0.698460256374558],
            [34.312900479336406, 0.697563070379847],
            [34.31330442566851, 0.69686296091237],
            [34.31431901349311, 0.697990247804005],
            [34.314241097218634, 0.698496787244174],
            [34.31250416329431, 0.702495146646917],
            [34.31149205392156, 0.703553360540291],
            [34.31038845473041, 0.703951007532266],
            [34.310310721712234, 0.70458142362282],
            [34.308905258941195, 0.706099978807625],
            [34.31001702291997, 0.706378773131558],
            [34.31010715897727, 0.707669544032245],
            [34.30950559046916, 0.709207360204507],
            [34.31064259890404, 0.712580804423448],
            [34.310603936312525, 0.712879298682796],
            [34.30918610284173, 0.713340999671364],
            [34.308002151145025, 0.716724158076078],
            [34.30775534800387, 0.721603969346394],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 879,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "MELLA",
        Population: 19261,
        Key: "TOROROMELLA",
        Dist2: "Tororo",
        "Sub Country": "Mella",
        id2_original: "Tororo Mella",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30558928976663, 0.955250243597145],
            [34.30197966132567, 0.95627204464675],
            [34.30149716989834, 0.956731089851742],
            [34.301196838844376, 0.960505882352871],
            [34.30199044110906, 0.962128872772348],
            [34.30042279739498, 0.962656424723209],
            [34.3015245837859, 0.962897262282893],
            [34.301729383501005, 0.963425545240123],
            [34.299117740221554, 0.966328003537968],
            [34.29478082225184, 0.969123228430065],
            [34.29085911908119, 0.964182890337518],
            [34.28429605546317, 0.962466837785244],
            [34.28484153675821, 0.961390270623162],
            [34.28465093671282, 0.960820505391348],
            [34.28560060598677, 0.959282487557809],
            [34.285401109925104, 0.958947896727812],
            [34.284792344114955, 0.959002397966142],
            [34.28289239830587, 0.960459370530266],
            [34.28015973309305, 0.960822207459462],
            [34.27790292345253, 0.961655206676659],
            [34.27588454465471, 0.963311217545179],
            [34.27333043846926, 0.963610669027392],
            [34.26798379345894, 0.963404645296697],
            [34.26202863147179, 0.959399888093433],
            [34.257321093768695, 0.95766497115244],
            [34.25684316847796, 0.956154608974571],
            [34.25701184154562, 0.9551324459193],
            [34.25623756294096, 0.954110631057994],
            [34.25396447313257, 0.953478307417083],
            [34.25321491346961, 0.952474570856405],
            [34.25201958999972, 0.951806702789642],
            [34.25130046525858, 0.952010388327381],
            [34.249647880444485, 0.951424657982023],
            [34.24819489859155, 0.94391650325829],
            [34.247175614374626, 0.942744196327727],
            [34.24850281861306, 0.941596735742635],
            [34.25074344330711, 0.941312380091529],
            [34.25204238295344, 0.941102572732569],
            [34.251895763526015, 0.939597148784294],
            [34.252236433427846, 0.939071857658203],
            [34.25386464964325, 0.940310661843659],
            [34.254838043423845, 0.938951879512014],
            [34.254371639026644, 0.938020753317978],
            [34.25471932566917, 0.937663515140309],
            [34.25574912736144, 0.93842638260235],
            [34.256605255064876, 0.93983351584326],
            [34.256425364734284, 0.940663906379251],
            [34.25744836977309, 0.940766506205407],
            [34.257426386201445, 0.942848842177772],
            [34.258927294073104, 0.944381436863973],
            [34.26015466314411, 0.943843243910685],
            [34.26001785421792, 0.942699159099712],
            [34.2606089600479, 0.942859122004189],
            [34.26124520532263, 0.942115202011852],
            [34.26298404726862, 0.941553940391964],
            [34.263642789052994, 0.94015785653305],
            [34.26502940157611, 0.939951404758994],
            [34.266598060386485, 0.940259746800533],
            [34.26668849378615, 0.938886755009325],
            [34.26938171217822, 0.93726110310238],
            [34.26919928590356, 0.935693710994036],
            [34.26999486625853, 0.935533241179314],
            [34.27064233059284, 0.934388874309402],
            [34.27298375793985, 0.934342253454522],
            [34.27396137380231, 0.934673692195723],
            [34.274461599769964, 0.934982423620741],
            [34.27529195929945, 0.936709754083648],
            [34.276246660037316, 0.9365377838231],
            [34.276905527585846, 0.935507826736473],
            [34.27783645530803, 0.935162227121695],
            [34.27860877468702, 0.936968455858868],
            [34.27949275016427, 0.937193527393761],
            [34.27876239738042, 0.938107253976765],
            [34.280424115366, 0.9381007079325],
            [34.2810074157345, 0.937910684022228],
            [34.28316913421061, 0.935519480823668],
            [34.28443582793149, 0.9359919388321],
            [34.288015845205756, 0.934747601131055],
            [34.28879714863589, 0.935068121367623],
            [34.289428003120605, 0.934589128860515],
            [34.29055498635691, 0.934761018378969],
            [34.29161714806065, 0.933217032145378],
            [34.29342872030701, 0.933065589987235],
            [34.29566739655519, 0.931953695708751],
            [34.295752713150996, 0.929884214547206],
            [34.296330897613956, 0.92956556837596],
            [34.29623713415955, 0.928297368688853],
            [34.29680035179154, 0.927643826739733],
            [34.29830182919508, 0.927222183144652],
            [34.29885398587097, 0.926307683083249],
            [34.3007033762925, 0.92610450712245],
            [34.301050360452464, 0.925237128044763],
            [34.30185629209445, 0.925172214365025],
            [34.302462305466555, 0.924525837665813],
            [34.3043084871059, 0.924855992006731],
            [34.305072263506524, 0.924026907315641],
            [34.30627836316656, 0.924393693825533],
            [34.306565077557494, 0.925274445483476],
            [34.30633374250719, 0.926698714410325],
            [34.30703223474289, 0.9285838640019],
            [34.306997845437174, 0.934905547949966],
            [34.30732884946653, 0.936162363325214],
            [34.30901911231862, 0.938453792812829],
            [34.31227313726448, 0.940280052279594],
            [34.31082843518352, 0.941462927291809],
            [34.308629754626715, 0.941911724273629],
            [34.30604241347067, 0.944149951794192],
            [34.306848530165595, 0.947211214241269],
            [34.30753250382967, 0.952415164492458],
            [34.30711478901919, 0.953190419257821],
            [34.30739970498289, 0.953649879838531],
            [34.30558928976663, 0.955250243597145],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 880,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "MANAFWA TOWN COUNCIL",
        Population: 13645,
        Key: "MANAFWAMANAFWA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.13785164502051, 0.7481113862954],
            [34.14094317910449, 0.749876731305286],
            [34.141647676577854, 0.753186642255054],
            [34.143281552179566, 0.755064049298266],
            [34.14015808478384, 0.756826857568301],
            [34.1379855973041, 0.759973558192387],
            [34.13286082988077, 0.763014564731822],
            [34.13165915891509, 0.764486305593617],
            [34.128082563323765, 0.767275216673878],
            [34.12575672354356, 0.77240645946857],
            [34.12598590353545, 0.777688765309564],
            [34.12561004752228, 0.780235246594097],
            [34.12354825224848, 0.78286246836143],
            [34.120285486694904, 0.784299341988782],
            [34.1188746582867, 0.785717204965846],
            [34.118565741135214, 0.784978736110054],
            [34.118870791937695, 0.783214761001596],
            [34.11772680988125, 0.781234082248309],
            [34.117281745861966, 0.778122512796555],
            [34.11632951189786, 0.777019202963085],
            [34.11599190165788, 0.774586022875889],
            [34.11620392203122, 0.77355476660883],
            [34.11428116620047, 0.767956040824571],
            [34.11357371596478, 0.764347024324166],
            [34.11306080219206, 0.757183026455568],
            [34.109942214444956, 0.759653292041027],
            [34.10516866044993, 0.760423407464685],
            [34.097108298391106, 0.762614537272276],
            [34.09450495464657, 0.761692547617462],
            [34.0887974483018, 0.758211415897537],
            [34.084708435706105, 0.756608835702138],
            [34.08289691196876, 0.753129220615299],
            [34.081293812648696, 0.750976623126598],
            [34.07778183018083, 0.749258930111443],
            [34.07590481297107, 0.748951841228997],
            [34.06744844478891, 0.744268227177449],
            [34.068587145649786, 0.743146274705791],
            [34.0705531984806, 0.740034055312006],
            [34.072309175790664, 0.739147143475774],
            [34.07487737833958, 0.734089948485839],
            [34.078982098876345, 0.731076723422213],
            [34.081285797879765, 0.730813837576918],
            [34.083894491091776, 0.728370859728164],
            [34.084853297130515, 0.726543393571038],
            [34.08411448940318, 0.725376676286302],
            [34.08086737070524, 0.716548837715203],
            [34.08131507487317, 0.714567718339244],
            [34.08260825272528, 0.713599519257069],
            [34.083318431144484, 0.712468635976448],
            [34.08386163521027, 0.710586998305866],
            [34.08361767433867, 0.707240141637404],
            [34.08585054297855, 0.706751145907998],
            [34.08931909100415, 0.706813645031659],
            [34.09111757120355, 0.702824068797971],
            [34.09155350294967, 0.700924371536146],
            [34.09430098946637, 0.696409929087097],
            [34.09474934670951, 0.694808738121216],
            [34.096414092017625, 0.696108748008254],
            [34.096546562080995, 0.697127743105608],
            [34.097895527108854, 0.697358879580727],
            [34.100133627536955, 0.700099186895741],
            [34.10060213129698, 0.703002732956914],
            [34.10222178027953, 0.705218532468248],
            [34.102389916154635, 0.706123058367772],
            [34.10295001483596, 0.706310168617014],
            [34.10291477213073, 0.707434551893512],
            [34.10479618928875, 0.709867379086198],
            [34.108552713838215, 0.711856559548019],
            [34.11221872593629, 0.715700009551973],
            [34.11319320218683, 0.716034458565163],
            [34.11539462799513, 0.717978725019641],
            [34.117522254507925, 0.718982262812428],
            [34.11933814765079, 0.724400129426439],
            [34.12029485971659, 0.725328083120336],
            [34.120362370805125, 0.726046172893282],
            [34.1215056494807, 0.727665048406266],
            [34.12228365878872, 0.730640853190471],
            [34.12545179581024, 0.735479439925882],
            [34.12644259804276, 0.738183815429554],
            [34.12661266439739, 0.740001933338562],
            [34.12797979425862, 0.743113336255016],
            [34.12861396532335, 0.743312099636264],
            [34.12970943835444, 0.744605332854094],
            [34.13785164502051, 0.7481113862954],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 881,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "KISOKO",
        Population: 19014,
        Key: "TOROROKISOKO",
        Dist2: "Tororo",
        "Sub Country": "Kisoko",
        id2_original: "Tororo Kisoko",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.35433591501013, 0.79569827366799],
            [34.353503771426475, 0.795200684602376],
            [34.35232241765758, 0.796321683832333],
            [34.35156032200486, 0.79640813653034],
            [34.351680505810066, 0.797321823446066],
            [34.35094434092632, 0.798149593741548],
            [34.35154416670275, 0.799373442852504],
            [34.35104772443911, 0.800054593232143],
            [34.35155371669257, 0.802373221891671],
            [34.351040171404186, 0.803123339441348],
            [34.35101481735361, 0.804140515861162],
            [34.35184574731332, 0.806263907322056],
            [34.35164983193637, 0.807185742542246],
            [34.35274449648374, 0.80906544108764],
            [34.35385132781329, 0.809611926072578],
            [34.354308019625634, 0.810667895223967],
            [34.355813099273476, 0.811581462179283],
            [34.357554315466764, 0.815243456257043],
            [34.35712855893785, 0.818327873063316],
            [34.35727624915709, 0.822653931455842],
            [34.35782034075837, 0.823918644971749],
            [34.35779249388288, 0.833622369582502],
            [34.35870356434572, 0.837137703684906],
            [34.35629789667611, 0.836674207176577],
            [34.35145960199686, 0.837785327005694],
            [34.349620251146995, 0.83640298349934],
            [34.34713845664692, 0.832953540389474],
            [34.345560151727014, 0.833851374410023],
            [34.34422643470279, 0.835607033332642],
            [34.34022372415475, 0.839369568976939],
            [34.33919444258706, 0.839442454948069],
            [34.337383395855134, 0.841007638745841],
            [34.33677632786087, 0.841660612112532],
            [34.336025775559506, 0.844126867454858],
            [34.3351410742435, 0.845598482957852],
            [34.33199234981528, 0.84841785897309],
            [34.329959265596244, 0.84951850134768],
            [34.32963945547365, 0.850978837697576],
            [34.33056639198102, 0.85212680095078],
            [34.331042394877045, 0.8536582381603],
            [34.32980721315801, 0.856709910907394],
            [34.330034279414065, 0.860215766774332],
            [34.32829923464677, 0.861496702419178],
            [34.32377105906486, 0.863640150582594],
            [34.323807509105826, 0.865913616521964],
            [34.32535028924951, 0.867396847432523],
            [34.325364656005824, 0.868754392752025],
            [34.32640158762649, 0.869373823963613],
            [34.32599580064637, 0.869920206207728],
            [34.32514060000431, 0.870119050522169],
            [34.32495837405396, 0.869863176947151],
            [34.32428494661134, 0.870107730360131],
            [34.32265808595369, 0.86803163470232],
            [34.321232040982885, 0.86762901914874],
            [34.32096062490126, 0.867158750194866],
            [34.31922642994022, 0.859961262308046],
            [34.321851872240714, 0.856602945192175],
            [34.321990601765, 0.85373436731924],
            [34.32431836124498, 0.853790155487391],
            [34.32496527131871, 0.849125842372393],
            [34.32452063040592, 0.840236596221282],
            [34.323854107414554, 0.838798684362728],
            [34.32117915895872, 0.835715828402118],
            [34.32024777489239, 0.833056585125749],
            [34.31684502756304, 0.830663359853868],
            [34.31673407125242, 0.829688940981265],
            [34.31712103583239, 0.82893708853078],
            [34.31665057105011, 0.828101999552136],
            [34.313012661847395, 0.827161819361446],
            [34.311133120371686, 0.82532602988875],
            [34.306591808725386, 0.822938165932158],
            [34.305689757348006, 0.822125918397992],
            [34.30525922806999, 0.820667768373287],
            [34.304124560644716, 0.820585638441654],
            [34.303602517293754, 0.812893905464457],
            [34.30253600954068, 0.808395118528171],
            [34.30200303099779, 0.80699768632035],
            [34.3002335502124, 0.804758261423346],
            [34.29836386145871, 0.804012255358122],
            [34.298886102439035, 0.803292715415122],
            [34.29980027298792, 0.803233076734972],
            [34.30380243825856, 0.800758111161325],
            [34.30520763692492, 0.799291762501482],
            [34.30594584098437, 0.799220267154947],
            [34.30685203718846, 0.798192549704949],
            [34.30850875694783, 0.797298156926594],
            [34.30927740940383, 0.796076833915443],
            [34.31089442811922, 0.794998895708395],
            [34.31182197278607, 0.794815038147156],
            [34.312899705886934, 0.793218515997958],
            [34.31619721647905, 0.791238203084772],
            [34.31702132912406, 0.789905133993021],
            [34.31767133209736, 0.789561748766078],
            [34.31764716921283, 0.788364627185189],
            [34.3184398812471, 0.788021196919599],
            [34.319676042129814, 0.786001645014825],
            [34.320183394432604, 0.785841865029935],
            [34.3206267830939, 0.783966223082937],
            [34.31726066726523, 0.781567474433627],
            [34.32168887113579, 0.774173433809459],
            [34.32320235003152, 0.769102956901539],
            [34.323009599419315, 0.767208508372389],
            [34.32355153775886, 0.766346292747925],
            [34.3245332436508, 0.765982624355561],
            [34.32420866257572, 0.765214942347605],
            [34.32665070482784, 0.765386048059792],
            [34.328316189449424, 0.766184923042881],
            [34.33013409751348, 0.76550295785195],
            [34.33130018800739, 0.766121091771025],
            [34.332767799823024, 0.765388977204554],
            [34.333740309661415, 0.766425461377629],
            [34.334818127203945, 0.765611194282982],
            [34.33655599447785, 0.76703501971608],
            [34.33799997341501, 0.767475440377987],
            [34.33818783180215, 0.767984085504985],
            [34.3373312369748, 0.768255664927633],
            [34.33847779719611, 0.769032006267626],
            [34.34272651587627, 0.768660917788882],
            [34.344123022443924, 0.769482774382521],
            [34.344333475257095, 0.770233593075226],
            [34.345980993572994, 0.771925268485816],
            [34.347588365280544, 0.771604998736234],
            [34.34795088310842, 0.771973062605576],
            [34.348532985124315, 0.771880790644611],
            [34.34867453356196, 0.772433260066083],
            [34.34786804765943, 0.773002776091688],
            [34.34685408596058, 0.774928529958059],
            [34.34791028644409, 0.775078876215378],
            [34.34859197389576, 0.774333600477716],
            [34.34875842992129, 0.77475211876563],
            [34.34845125370483, 0.776393017969635],
            [34.34731204349917, 0.776719870505353],
            [34.347403683336246, 0.777230497823637],
            [34.348909688248824, 0.779674469544616],
            [34.34991624243984, 0.780603371690439],
            [34.35044883919874, 0.781733340999408],
            [34.35031609694584, 0.782721212484168],
            [34.351422397371074, 0.783499393442214],
            [34.352428690152344, 0.783616265907268],
            [34.35282805687314, 0.784210506031536],
            [34.35309467145959, 0.785750758377945],
            [34.35224671752691, 0.786663520667697],
            [34.352371684861026, 0.787358307379975],
            [34.35292903020603, 0.787860409197611],
            [34.354584075505706, 0.788253322982461],
            [34.35503332208098, 0.788788943947107],
            [34.3544185896607, 0.790831770326579],
            [34.35511761639398, 0.792271422124853],
            [34.35435298479718, 0.793669699194302],
            [34.35465259180906, 0.794356055753848],
            [34.35433591501013, 0.79569827366799],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 882,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUBUTU",
        Population: 23224,
        Key: "NAMISINDWABUBUTU",
        Dist2: "Manafwa",
        "Sub Country": "Bubutu",
        id2_original: "Manafwa Bubutu",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.088923400189465, 0.454091557997365],
            [34.09003605260207, 0.454782275147658],
            [34.091126406134364, 0.45681738983963],
            [34.093082614328, 0.458092531098115],
            [34.09381192147286, 0.460471434287364],
            [34.096598185565426, 0.461909263489934],
            [34.09986149190479, 0.465827760607744],
            [34.1040547539892, 0.468089563424188],
            [34.10984712867046, 0.473821608537909],
            [34.106207690535115, 0.4763200114442],
            [34.10424667994797, 0.47634737408043],
            [34.09849706866751, 0.478486628679344],
            [34.09610294165435, 0.480272072914774],
            [34.09301099524364, 0.475747559126566],
            [34.08867042113073, 0.465772593295998],
            [34.08244182454752, 0.459419935331253],
            [34.07864482909787, 0.457470685005037],
            [34.07873990229597, 0.455863007732618],
            [34.079201416264745, 0.456277857249205],
            [34.08251578733644, 0.456588680644274],
            [34.08733151453911, 0.455112828581753],
            [34.088923400189465, 0.454091557997365],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 883,
        District: "BUSIA",
        County: "BUSIA MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 31935,
        Key: "BUSIAEASTERN DIVISION",
        Dist2: "Busia",
        "Sub Country": "Eastern Division",
        id2_original: "Busia Eastern Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.44786047774226, 0.866339837284995],
            [34.446814764191366, 0.866096041719825],
            [34.44622040915499, 0.865499337450111],
            [34.44415318626022, 0.86516548880562],
            [34.443511027376, 0.864378868919522],
            [34.44237038435747, 0.864071795011888],
            [34.442157481838514, 0.865365233379257],
            [34.44300349630845, 0.869127399527644],
            [34.443236315375586, 0.878795822996756],
            [34.441112728586646, 0.88232398872189],
            [34.439691448280115, 0.888212488061787],
            [34.43749600076002, 0.891785917128123],
            [34.43478785326626, 0.892501497498296],
            [34.433173295036426, 0.893795495482233],
            [34.43267504356576, 0.894871985315817],
            [34.43141532256811, 0.894537835706698],
            [34.43015654480151, 0.895189535156093],
            [34.427590661702645, 0.894973477171607],
            [34.42680699121173, 0.895688301529896],
            [34.42047572527638, 0.896758040795246],
            [34.415273588652575, 0.898849368326323],
            [34.41349169764151, 0.898777708652926],
            [34.410675715482704, 0.898091419970575],
            [34.40722842519001, 0.895686901227476],
            [34.403870556793954, 0.89124713961146],
            [34.40513712475071, 0.88983509478321],
            [34.4067072020009, 0.88888599261036],
            [34.40852110717206, 0.886724829152623],
            [34.4094267401325, 0.882157652130408],
            [34.40984174921733, 0.872110458085285],
            [34.41141169082196, 0.869196366933929],
            [34.40982095232019, 0.869219805773825],
            [34.40743712628837, 0.870442713907893],
            [34.406491936912744, 0.870478641474323],
            [34.404893653460924, 0.869274754785351],
            [34.40310686573325, 0.865333830960489],
            [34.40273367052995, 0.861143867877706],
            [34.40227600404552, 0.859823914590781],
            [34.403336390678234, 0.859546243357804],
            [34.40459988639672, 0.858241419941967],
            [34.40670373091065, 0.85565204179611],
            [34.40869482517833, 0.854520020223262],
            [34.40921511052626, 0.853657500725307],
            [34.41537299801854, 0.850461011529689],
            [34.41709171949881, 0.850238555675265],
            [34.41881294458379, 0.849334002275711],
            [34.41974404118926, 0.8495527036371],
            [34.42130171629866, 0.847311247633075],
            [34.4227287494163, 0.846949885912013],
            [34.423205177215415, 0.848254696989665],
            [34.42449712347727, 0.848482361717423],
            [34.425244070839376, 0.849218871566482],
            [34.426083812373726, 0.849001940571237],
            [34.42596539914789, 0.84969256403327],
            [34.42759418040364, 0.850845313365348],
            [34.42918040666772, 0.850789437129331],
            [34.430576956354486, 0.851961575023773],
            [34.43332830293194, 0.851723272928721],
            [34.43413994785914, 0.852443901702924],
            [34.43792695404284, 0.85396758808467],
            [34.43822358134291, 0.853650095836055],
            [34.4398790147148, 0.854047518485402],
            [34.440604349509506, 0.853788922237446],
            [34.44140468105399, 0.854638370876128],
            [34.44351011289106, 0.855711063510759],
            [34.444219836762734, 0.858761996291626],
            [34.446525588416556, 0.860244402736096],
            [34.44716781826768, 0.861220956180144],
            [34.447121253196634, 0.862821837818218],
            [34.44786047774226, 0.866339837284995],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 884,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUKOKHO",
        Population: 19498,
        Key: "NAMISINDWABUKOKHO",
        Dist2: "Manafwa",
        "Sub Country": "Bukokho",
        id2_original: "Manafwa Bukokho",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.26222230375546, 0.920840445336602],
            [34.26007715560308, 0.921767744345308],
            [34.25865381006969, 0.921949621561625],
            [34.2551040237997, 0.921189136156136],
            [34.25333782635666, 0.919920177192378],
            [34.24938205547716, 0.914942240713989],
            [34.24702971000619, 0.914590135223962],
            [34.24550912363993, 0.913500823129018],
            [34.240600749588744, 0.911192658405626],
            [34.2399353027791, 0.910893987469846],
            [34.23470205839531, 0.90088523863202],
            [34.2338821130349, 0.89630100339239],
            [34.23486129196594, 0.894117984649893],
            [34.23447071256524, 0.892112599299537],
            [34.23223142905593, 0.888581676411978],
            [34.231552425770325, 0.888075521319406],
            [34.23155400500858, 0.883140870886879],
            [34.23290116352441, 0.88100763479184],
            [34.23410007576384, 0.876500550000096],
            [34.235993350683614, 0.872081381191464],
            [34.23934940358447, 0.867946582988693],
            [34.24030060179105, 0.869874648009509],
            [34.2416778466824, 0.870948903727406],
            [34.24318820123756, 0.873764890039268],
            [34.24290865719926, 0.874528400602753],
            [34.2465255844519, 0.879544980045759],
            [34.246312267809586, 0.880182467974551],
            [34.24701983931785, 0.882331650442704],
            [34.24801700252088, 0.883324016508836],
            [34.248281654288434, 0.885328871298893],
            [34.25064809522452, 0.888296145296542],
            [34.25394896731244, 0.889898114778709],
            [34.2560280335959, 0.89183896160932],
            [34.25560355536963, 0.892946842526233],
            [34.25409369668451, 0.894558136954163],
            [34.25448887276448, 0.898917763922359],
            [34.254893747954625, 0.900428163122761],
            [34.25598760761149, 0.901621741785366],
            [34.25642894721561, 0.904976736299433],
            [34.2570872084013, 0.906822002753567],
            [34.25741098817917, 0.911322056033005],
            [34.26106998173993, 0.916095484484394],
            [34.26222230375546, 0.920840445336602],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 885,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "NALONDO",
        Population: 5835,
        Key: "MANAFWANALONDO",
        Dist2: "Manafwa",
        "Sub Country": "Nalondo",
        id2_original: "Manafwa Nalondo",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.23064637599159, 0.712784009179342],
            [34.22432636774337, 0.7152731589211],
            [34.222808125081706, 0.716377090566525],
            [34.22058239625169, 0.720031981821671],
            [34.21930111568724, 0.72103635363161],
            [34.21811459031722, 0.721470848679407],
            [34.215139004481905, 0.720902958085301],
            [34.210274598472324, 0.722768801290065],
            [34.20211156256975, 0.713316256596274],
            [34.19972817042423, 0.709020346184491],
            [34.20190080163444, 0.708359466661783],
            [34.20522205739446, 0.706187716885774],
            [34.2138099856466, 0.693458723225889],
            [34.210763110408664, 0.690239382488279],
            [34.20824630676534, 0.684505298031116],
            [34.208997015373555, 0.67948495700247],
            [34.21030850807766, 0.675721775913105],
            [34.21001351571141, 0.674281845002926],
            [34.202023817827765, 0.665954889951711],
            [34.189482314178655, 0.653755747423338],
            [34.18810286571993, 0.652969128604777],
            [34.184122518730895, 0.652803791835075],
            [34.1833340251852, 0.653468683402722],
            [34.182729071825094, 0.655002717249851],
            [34.179160389493134, 0.657504021671787],
            [34.17558327377726, 0.65854483364208],
            [34.17289830910601, 0.659928678478963],
            [34.17036556395967, 0.660150049099631],
            [34.16698349584817, 0.664235721061659],
            [34.162519643233864, 0.665367467335128],
            [34.157371167473535, 0.668769793617427],
            [34.15288505460652, 0.670851325465211],
            [34.15289569245611, 0.671825988131236],
            [34.15810660921352, 0.674839137349312],
            [34.156187108877354, 0.677372334936597],
            [34.155738162339375, 0.678765448920928],
            [34.15419881735332, 0.68110860401631],
            [34.15119098469427, 0.682278060365027],
            [34.14535129754361, 0.683155025112906],
            [34.144197563376444, 0.682286932396018],
            [34.14151369375157, 0.682387078465022],
            [34.14068127618172, 0.681862636051582],
            [34.13842673927889, 0.683111460816592],
            [34.13583186305423, 0.683572166771271],
            [34.12976167359159, 0.68175425929143],
            [34.1281378492396, 0.682026088210737],
            [34.12605806789718, 0.681070104943463],
            [34.11968499886007, 0.679823455215716],
            [34.11832093944049, 0.678843924727947],
            [34.11809311949793, 0.677498964285575],
            [34.11671887587795, 0.67646303653355],
            [34.12021808789578, 0.676865275861316],
            [34.1216905604954, 0.676620700535275],
            [34.12539273158032, 0.674512212778437],
            [34.12719380521594, 0.672123758269286],
            [34.12948900525845, 0.666257121178153],
            [34.132375142247675, 0.661760698483942],
            [34.13261688787377, 0.659425966957255],
            [34.13424101226306, 0.657203946625176],
            [34.13502357423293, 0.654661181221372],
            [34.137990181406984, 0.652707563360616],
            [34.138731605926736, 0.651213971948153],
            [34.14030981921847, 0.649413846109565],
            [34.14027113057585, 0.646522743971415],
            [34.138158772727955, 0.641162219792323],
            [34.13680335959297, 0.639918004217697],
            [34.13466341448271, 0.638769694606282],
            [34.134140140439825, 0.637692823328374],
            [34.13318901948836, 0.637022907528619],
            [34.13273685518505, 0.634964761352015],
            [34.13178554648569, 0.633433252770215],
            [34.12919384850049, 0.632093569091027],
            [34.127696063172756, 0.632093897854424],
            [34.12591311214968, 0.632692619063158],
            [34.11595812320655, 0.638996605719467],
            [34.106944671987456, 0.643341108313879],
            [34.10512579014965, 0.642694437494274],
            [34.10155067228695, 0.640469863236495],
            [34.100050192911674, 0.638443959666954],
            [34.09873583188688, 0.637476357121277],
            [34.09700635218277, 0.636654333569522],
            [34.09727310151651, 0.633273684894378],
            [34.10079074606561, 0.629123741680103],
            [34.10404517794828, 0.626818588424288],
            [34.108061324598005, 0.621870606786907],
            [34.10651304856144, 0.619464793719609],
            [34.10672010664115, 0.615927902601909],
            [34.10530020524856, 0.612364214820894],
            [34.10529577745253, 0.609949026768448],
            [34.10457674074631, 0.606276641364474],
            [34.10343291050514, 0.604250651003897],
            [34.102488176575335, 0.60086776835299],
            [34.102260894723614, 0.593278506859018],
            [34.10084271719805, 0.591713937295064],
            [34.10010680653752, 0.590245783743672],
            [34.099055732739345, 0.586500267018243],
            [34.100408640473, 0.587091644564688],
            [34.10133403906461, 0.586494447138438],
            [34.10521744705469, 0.586258485545739],
            [34.10747946422892, 0.584360171319042],
            [34.107825916586236, 0.583225192705982],
            [34.11054050500059, 0.583489238797246],
            [34.11370219301669, 0.581051111545918],
            [34.1139983028872, 0.581552546888642],
            [34.11474190402485, 0.581377965608826],
            [34.11489366451066, 0.582112008562925],
            [34.115492913568694, 0.582155496456109],
            [34.1156663279444, 0.582860462347928],
            [34.11623671592899, 0.582998440925687],
            [34.117745578382504, 0.582649272162291],
            [34.1182002642568, 0.581849696066214],
            [34.118980050432434, 0.582111189341687],
            [34.12005553954175, 0.580824532145898],
            [34.12264029085483, 0.581231022266186],
            [34.12311667733148, 0.580642216746143],
            [34.123708752443655, 0.580925550592715],
            [34.123780813499124, 0.580235073541778],
            [34.12437294879844, 0.580823664417923],
            [34.125412549313786, 0.580612682554483],
            [34.126134740005014, 0.58170274016011],
            [34.126957635432824, 0.580924895754525],
            [34.127116705510055, 0.582102282107054],
            [34.12879904522134, 0.582814206894014],
            [34.129469864854684, 0.581793170694844],
            [34.129983343667725, 0.582210022277246],
            [34.13061746083353, 0.581589588807735],
            [34.1321117355451, 0.582869886085934],
            [34.13279314002749, 0.581784628156928],
            [34.13318152035236, 0.58186433785033],
            [34.13333222891094, 0.582450750254612],
            [34.13405338653957, 0.581991821078169],
            [34.13485808569297, 0.583128638696071],
            [34.13478295329757, 0.583942493488734],
            [34.135778013544524, 0.584466777831122],
            [34.13680393271811, 0.583850418258586],
            [34.137802442495754, 0.583840640604375],
            [34.13772149171225, 0.583251904523559],
            [34.13834413918851, 0.582913965034102],
            [34.13929932052506, 0.582488629354368],
            [34.14074502692251, 0.580552588347344],
            [34.14149426409028, 0.580923302225151],
            [34.14173060275668, 0.580470976999572],
            [34.14199358545442, 0.581257885002424],
            [34.142397369191485, 0.581257802361677],
            [34.14277569647004, 0.580344126118924],
            [34.143253285790834, 0.581519947807845],
            [34.144700915481295, 0.580777917367613],
            [34.14444232105371, 0.582252391824869],
            [34.145107881949414, 0.582632167327093],
            [34.145180468519314, 0.583328657993841],
            [34.14589313617018, 0.583373738508029],
            [34.14570143568855, 0.582396861308409],
            [34.146438895044646, 0.582848986065712],
            [34.14729294584312, 0.582224668551746],
            [34.14743692602024, 0.583273919293817],
            [34.14872018826822, 0.583418383361551],
            [34.1481049536897, 0.584730109740629],
            [34.14924682560354, 0.585516833003237],
            [34.15052823013552, 0.584820063246144],
            [34.152358605019096, 0.585579505187643],
            [34.1536158017508, 0.584602330146174],
            [34.15375362217999, 0.588455683410307],
            [34.15477451258463, 0.58807555887622],
            [34.15517959977718, 0.588952887249926],
            [34.15708126226675, 0.589549490658204],
            [34.157321979321836, 0.591268082263097],
            [34.158154396891675, 0.591955363715242],
            [34.159294977028146, 0.591927986323153],
            [34.15974716468765, 0.592452528616368],
            [34.159415381818945, 0.593004372792351],
            [34.159867550613804, 0.593438460385602],
            [34.16084067130659, 0.592904570817437],
            [34.16008276270137, 0.594026370781911],
            [34.160866152917954, 0.593908612467676],
            [34.160796055579674, 0.59438803821769],
            [34.16188960262282, 0.595030034058001],
            [34.16179594786456, 0.595654191144448],
            [34.162439197303556, 0.596748556591016],
            [34.16274745419328, 0.596486172023945],
            [34.16272195012405, 0.595382629831774],
            [34.163505932330395, 0.595409599393631],
            [34.164195691144876, 0.596024542915782],
            [34.16395942524201, 0.596793458241435],
            [34.16472042225515, 0.59701038691515],
            [34.16455486903651, 0.597553150059916],
            [34.16488792661463, 0.597724941715406],
            [34.16576553483312, 0.597001116804658],
            [34.16567318712361, 0.598484592084776],
            [34.166553322303, 0.599081402861832],
            [34.16643555586418, 0.599868383686185],
            [34.167290838252946, 0.599795835228146],
            [34.16807547622943, 0.600266028985257],
            [34.1687161564867, 0.599840754818919],
            [34.17137635101231, 0.599641179859708],
            [34.171544501260435, 0.600744687061579],
            [34.17076242977072, 0.601766991716711],
            [34.17147570737768, 0.602056290765802],
            [34.17235330840966, 0.601314374455959],
            [34.17252204974925, 0.602553562545146],
            [34.17369673712041, 0.60184776287305],
            [34.17357638892351, 0.601060836229595],
            [34.173955999894574, 0.60096125447602],
            [34.17474247133257, 0.60212794362297],
            [34.173866175552675, 0.603711085450882],
            [34.174864784145, 0.604208366061641],
            [34.175246910398876, 0.605357051482489],
            [34.17553220994321, 0.605420307313658],
            [34.17543539042021, 0.604371058978532],
            [34.1763371947609, 0.603891453550702],
            [34.176339127935414, 0.605040222577237],
            [34.17821850412109, 0.606468985945754],
            [34.178859809605804, 0.606351253949103],
            [34.179001203533176, 0.605772316748528],
            [34.179950800043635, 0.605564062969153],
            [34.17997374660923, 0.605202241770326],
            [34.18094813212992, 0.605364843932617],
            [34.18142254231295, 0.604767742805266],
            [34.183014723509054, 0.605174435073605],
            [34.183273323326496, 0.603835658694122],
            [34.184651512347195, 0.604115762090879],
            [34.18536603142588, 0.604956826737357],
            [34.18643282574153, 0.603970642830195],
            [34.18695819914723, 0.605309244912984],
            [34.186555693712826, 0.605996783305637],
            [34.18736454667611, 0.606783552936406],
            [34.18610735353769, 0.607670280458087],
            [34.186050332076704, 0.608855239762227],
            [34.184483076434795, 0.60943449371978],
            [34.185720446449864, 0.610338757619983],
            [34.18580478927187, 0.610818145095765],
            [34.1862904966679, 0.610528584221642],
            [34.18764510042081, 0.610808688169875],
            [34.18759987563617, 0.612002689607214],
            [34.18850230969585, 0.61185776188875],
            [34.18885705170661, 0.611043597737011],
            [34.18954615744591, 0.611233396467615],
            [34.18902514536088, 0.61185764421614],
            [34.18959645681358, 0.612671600745347],
            [34.18938434032052, 0.613404324460977],
            [34.18964551920116, 0.61359421832397],
            [34.19152105688564, 0.612906347645177],
            [34.19169106754472, 0.614760611009478],
            [34.19024354924536, 0.615864474427802],
            [34.19105230608892, 0.616198970636666],
            [34.19223884583196, 0.615809750425288],
            [34.19255026299487, 0.617148395371867],
            [34.191601968143274, 0.618134556199929],
            [34.19216400269405, 0.620142501505554],
            [34.19273141096683, 0.618568477397972],
            [34.193206511056005, 0.618568369606402],
            [34.193018081340306, 0.619735265127442],
            [34.193660030917066, 0.619997434777728],
            [34.194072380988686, 0.61815208580246],
            [34.194618152439546, 0.617763011252564],
            [34.19488053596099, 0.618314718113296],
            [34.196019920439824, 0.618006916618202],
            [34.197019099462345, 0.618549410868915],
            [34.195525069990836, 0.620078416751751],
            [34.19666696975244, 0.620964601314833],
            [34.19597917465514, 0.621606979349606],
            [34.19750252962913, 0.623108158881352],
            [34.19788534848411, 0.624781461132362],
            [34.19805027917027, 0.624012568671828],
            [34.19866735709176, 0.623560158992236],
            [34.19904758610373, 0.623722887250766],
            [34.199168598155666, 0.624916845364053],
            [34.200604149098815, 0.625985532533227],
            [34.20084193495114, 0.624120469699578],
            [34.20265248491471, 0.623597846476159],
            [34.2021773740458, 0.622589786134413],
            [34.203357631870034, 0.62306283347071],
            [34.20325396089635, 0.6220452191084],
            [34.204462366531736, 0.622243735082447],
            [34.205444931213066, 0.621765455294231],
            [34.206310211850926, 0.622427902207432],
            [34.20608946164966, 0.623450323096434],
            [34.20699706102221, 0.624122226700055],
            [34.20620262691757, 0.624860788434575],
            [34.20624035076962, 0.625338831698714],
            [34.20671989931605, 0.625191991945069],
            [34.207857896796064, 0.625906438796055],
            [34.20794697014636, 0.624770452034791],
            [34.20876978113254, 0.624765527763172],
            [34.20956889995141, 0.623960700328453],
            [34.2098982528773, 0.624954593021777],
            [34.210273905871226, 0.624977588524988],
            [34.21042192577216, 0.624215628879089],
            [34.2117973785245, 0.623240737883477],
            [34.21216864055335, 0.622459675540629],
            [34.212817632023594, 0.623098505257874],
            [34.213131784556566, 0.622507553817793],
            [34.21357448061677, 0.622497213920872],
            [34.21408721652307, 0.623552594727231],
            [34.215718701707814, 0.623419685172494],
            [34.21640010169857, 0.621871777222782],
            [34.21759017900718, 0.624171821540729],
            [34.217007213710296, 0.62440388392521],
            [34.217698542779914, 0.625137363254798],
            [34.2175106754096, 0.626013045389844],
            [34.21789903327661, 0.626457791788522],
            [34.217568361623904, 0.627209478590738],
            [34.21952812624771, 0.627697579473311],
            [34.219819495708435, 0.629154274474143],
            [34.22076054295232, 0.63006860451328],
            [34.221192974862085, 0.629509988562692],
            [34.222253277053206, 0.629450234439814],
            [34.22448163615035, 0.632065131058024],
            [34.22719630720972, 0.633250556485177],
            [34.22881608375302, 0.635657111462628],
            [34.22924010563513, 0.636936649439383],
            [34.23064777017692, 0.638261651607369],
            [34.23115383519391, 0.640898835863192],
            [34.23231537122934, 0.643358468060628],
            [34.23357956763372, 0.644451453802099],
            [34.233944910663126, 0.645309036352464],
            [34.23585517452155, 0.646637484764336],
            [34.236754020710016, 0.64684461229295],
            [34.2382523387387, 0.64818258363215],
            [34.23878633058125, 0.649539642591049],
            [34.24085595557108, 0.651678587411016],
            [34.241596193416335, 0.654128884185705],
            [34.241371752935855, 0.655175107057552],
            [34.24078202961308, 0.655627651383605],
            [34.24116604232906, 0.656240175129468],
            [34.2407277363356, 0.658396389658415],
            [34.24110130433977, 0.65946351674384],
            [34.24054002617048, 0.661348644477091],
            [34.2407274704343, 0.662130865913878],
            [34.239903872523925, 0.663328041569703],
            [34.23917367964018, 0.663648673711153],
            [34.238176141839666, 0.665851731697025],
            [34.236757829566805, 0.667194859315948],
            [34.23617609586017, 0.668873467408781],
            [34.23571267207308, 0.669032896724929],
            [34.23597280980631, 0.669613179581389],
            [34.23552644682313, 0.670187952480186],
            [34.2356851315231, 0.671889131761027],
            [34.235329307940766, 0.672890608878639],
            [34.235985314355084, 0.674369761522178],
            [34.235952026383906, 0.676827718123419],
            [34.236596996994976, 0.67934808763111],
            [34.23716795271482, 0.679751906744511],
            [34.23721903271851, 0.680582589522826],
            [34.23804422064694, 0.680559615831923],
            [34.23825911383258, 0.681020426228079],
            [34.237247993504965, 0.683313633856615],
            [34.23801122822148, 0.684144130082278],
            [34.23798896437549, 0.685481212804465],
            [34.238463806648156, 0.685765573909928],
            [34.23895596574454, 0.687443903400838],
            [34.23953252335853, 0.687648581478849],
            [34.24046555403681, 0.689378000986509],
            [34.24110429213641, 0.689611109499222],
            [34.24129098451032, 0.690288132317381],
            [34.243795383317895, 0.692426789847033],
            [34.24338813208383, 0.693087544066002],
            [34.24342393713444, 0.69507306950868],
            [34.24303483097078, 0.696170740661617],
            [34.243381188106696, 0.69704173398654],
            [34.24326937480328, 0.699611464134194],
            [34.24132683537502, 0.705152695436374],
            [34.23797885653191, 0.706651679429945],
            [34.23290696304788, 0.711426614102918],
            [34.23064637599159, 0.712784009179342],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 886,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "OSUKURU",
        Population: 45884,
        Key: "TOROROOSUKURU",
        Dist2: "Tororo",
        "Sub Country": "Osukuru",
        id2_original: "Tororo Osukuru",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.97872653607713, 0.578002027919022],
            [33.977006284765935, 0.572641201083333],
            [33.974542275111865, 0.568236209716288],
            [33.97210032718288, 0.561370685456129],
            [33.972251285473114, 0.557263760314769],
            [33.97191680496359, 0.555327965055371],
            [33.97293474619916, 0.553703342731664],
            [33.97298764169801, 0.552605559192122],
            [33.97409216256066, 0.550487705665082],
            [33.974436774269954, 0.548380195012657],
            [33.97546302132864, 0.545973783684135],
            [33.97615635004806, 0.545447726267579],
            [33.976661292170974, 0.544262306426103],
            [33.9770140641763, 0.541349467481006],
            [33.977617619757815, 0.540402741950661],
            [33.97655583983807, 0.538476737837764],
            [33.977402134582405, 0.537295549309009],
            [33.97698280909262, 0.534581120971501],
            [33.97641874884089, 0.533899939239574],
            [33.97492417139702, 0.533218906546042],
            [33.97434580277945, 0.531203567458083],
            [33.97187779382574, 0.526591172813087],
            [33.97246947098427, 0.523553737063198],
            [33.97390737641179, 0.522460636211023],
            [33.9790597849964, 0.519890713710554],
            [33.99125554056739, 0.520677415918613],
            [33.9937141630247, 0.519972623217106],
            [33.99802561016281, 0.519682464051458],
            [34.00133135561115, 0.520333243314999],
            [34.00866140710695, 0.523299128305623],
            [34.01599218174655, 0.530751763916387],
            [34.01759949416529, 0.52876281719996],
            [34.01918467928193, 0.527622562198306],
            [34.019932764809525, 0.525857931430922],
            [34.02278646093888, 0.523522961168077],
            [34.02411731503232, 0.523220392457913],
            [34.02499625545237, 0.521839899177599],
            [34.026061987061055, 0.521505186403903],
            [34.02861262934281, 0.518113396178466],
            [34.030077124902746, 0.519378742665586],
            [34.03129881662117, 0.519423106837874],
            [34.03649555526842, 0.521856245142835],
            [34.038308604345104, 0.524232508953656],
            [34.044456025566, 0.524696604101474],
            [34.04789056966311, 0.525898574892271],
            [34.054907931083235, 0.522139409317732],
            [34.05616221368016, 0.522169259993315],
            [34.06225496522947, 0.525445162149815],
            [34.06389772427101, 0.526948062883044],
            [34.06793032266688, 0.53277970866532],
            [34.06766161231088, 0.53314051935526],
            [34.069454223816535, 0.537679809221261],
            [34.07010785688188, 0.540611449931552],
            [34.06922337116154, 0.543994722048219],
            [34.06934376068099, 0.545161603350734],
            [34.07003471245819, 0.546192694972292],
            [34.06962851854121, 0.551602131911683],
            [34.068916437490216, 0.551765085038278],
            [34.06834193791658, 0.555158323485028],
            [34.067427453855665, 0.558039200542408],
            [34.06684933586803, 0.558569418542075],
            [34.065822056645096, 0.559032155567364],
            [34.06352466112005, 0.558948408720936],
            [34.060958669325025, 0.558813191754194],
            [34.05984154509897, 0.558288739788581],
            [34.05656474336907, 0.559175824375039],
            [34.0544541138798, 0.560089262342156],
            [34.05369018476557, 0.56088457197865],
            [34.052827991637336, 0.560718418559773],
            [34.05106930860165, 0.561592054746503],
            [34.05214780796545, 0.563864597464809],
            [34.051741737117666, 0.564304719182366],
            [34.05163732862715, 0.56541526407524],
            [34.05420001013034, 0.568136273461809],
            [34.05620572088601, 0.574080261552211],
            [34.05885556142961, 0.576280191302101],
            [34.06201954733622, 0.578178385181837],
            [34.06415693673951, 0.577878576035277],
            [34.06426370959588, 0.580160613310805],
            [34.06241221531997, 0.583346955727805],
            [34.06150447311525, 0.583934431527766],
            [34.0613399906884, 0.583267464334661],
            [34.06045657396328, 0.58330899758614],
            [34.05972198292788, 0.582688673826387],
            [34.0573925651579, 0.583716913977957],
            [34.05657877325718, 0.583423487324377],
            [34.05587289776817, 0.583934302177068],
            [34.05375845582884, 0.583988977991867],
            [34.05307499420448, 0.584871956216575],
            [34.05173389033365, 0.585579082103241],
            [34.05003364360552, 0.585416586251342],
            [34.050049864484606, 0.587771500550644],
            [34.04968711938297, 0.588720685012064],
            [34.04909542156321, 0.588859789873382],
            [34.048985046462576, 0.589280756793292],
            [34.04850372554007, 0.589002865075],
            [34.04818432594755, 0.58969788448518],
            [34.047407274243646, 0.590118979794006],
            [34.04618041721235, 0.590027875692889],
            [34.045683270669485, 0.589499800283723],
            [34.04473487969816, 0.59023728164067],
            [34.04318950611825, 0.589996780361474],
            [34.04157663492453, 0.589131257187531],
            [34.040720667121256, 0.589878544083242],
            [34.04014860377865, 0.58911961294205],
            [34.0391450688253, 0.589751309855026],
            [34.038420785059465, 0.589211276678863],
            [34.03791988805032, 0.589735571306663],
            [34.03736352815721, 0.588993060481733],
            [34.03641690686697, 0.589739825502488],
            [34.03535838064521, 0.589499690695045],
            [34.034006180784004, 0.590292737090099],
            [34.033524029818174, 0.590481734388512],
            [34.03336698454358, 0.589839718259334],
            [34.032226552629126, 0.588828151981651],
            [34.03040435960118, 0.588006050002216],
            [34.02971666242026, 0.58787600864373],
            [34.02924066401583, 0.588325777700775],
            [34.025596330960504, 0.58697741270429],
            [34.02495579802693, 0.587646136468365],
            [34.024697114666125, 0.587255671915071],
            [34.025067264580635, 0.586510078801986],
            [34.024502918664666, 0.585965832434044],
            [34.024661445261145, 0.585048690537509],
            [34.02374444501914, 0.584492674913261],
            [34.022786490583286, 0.584978034537075],
            [34.022768621295654, 0.583670410608914],
            [34.0216754075275, 0.583747531465363],
            [34.02132296161063, 0.58488955060127],
            [34.02070587919755, 0.585232842753504],
            [34.018372349838515, 0.584493663008652],
            [34.017155295223574, 0.582292809433856],
            [34.01778414107531, 0.581985016690932],
            [34.01821303092792, 0.58103232245129],
            [34.01741376478533, 0.581488067342094],
            [34.01757231294142, 0.580677427100391],
            [34.016731891382406, 0.581074010221521],
            [34.01626751268619, 0.580790085321304],
            [34.017025412308236, 0.579079970169619],
            [34.016525728923035, 0.578577127019529],
            [34.01646076365998, 0.576825743789623],
            [34.01556731454976, 0.576500476707061],
            [34.01425078050029, 0.576731473072316],
            [34.01374518799714, 0.576045205701992],
            [34.01316339859496, 0.576554162700355],
            [34.01259899069519, 0.575648980639207],
            [34.010170689972, 0.576226498120044],
            [34.00967306372878, 0.577274952310146],
            [34.00883764219265, 0.577211740173468],
            [34.008643210832545, 0.577868443554227],
            [34.00785921784644, 0.577413523882081],
            [34.00732717085646, 0.577966604658236],
            [34.0060223508383, 0.576803266385353],
            [34.00564472424569, 0.576941580165383],
            [34.005747805026225, 0.577419662656964],
            [34.00478653311205, 0.577552320916322],
            [34.004677615977116, 0.576423329702051],
            [34.00402538338531, 0.576849704237147],
            [34.003178409514604, 0.576175905765067],
            [34.002474698067125, 0.576705974786402],
            [34.00207405753524, 0.576135780050154],
            [34.001467568056, 0.576377818861243],
            [34.001152724718594, 0.575617519632541],
            [34.00048906465805, 0.5761418218133],
            [34.00051749723511, 0.575128009198398],
            [34.000179866333895, 0.57493798017087],
            [33.99935608965877, 0.576032577823959],
            [33.99883536683131, 0.57591746543526],
            [33.998034488212795, 0.577069660853372],
            [33.997422246820776, 0.577150413504233],
            [33.99763403363217, 0.577565116767405],
            [33.99685602252753, 0.578596343698554],
            [33.996318090674144, 0.57823930133081],
            [33.99621517159036, 0.578682862319415],
            [33.99400673083799, 0.580140604363593],
            [33.99298819132445, 0.580025579190282],
            [33.99161470228933, 0.578856485228894],
            [33.99111123879341, 0.579282835328122],
            [33.988999517851056, 0.577589683543811],
            [33.98780938394857, 0.577860626812229],
            [33.98532584671686, 0.576829970148842],
            [33.98493090689378, 0.576138803626516],
            [33.983883897073945, 0.576841742872311],
            [33.982533184822834, 0.575021724091192],
            [33.98170381793174, 0.576922768600414],
            [33.97964590876985, 0.576442970371695],
            [33.97872653607713, 0.578002027919022],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 887,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BUSITEMA",
        Population: 17340,
        Key: "BUSIABUSITEMA",
        Dist2: "Busia",
        "Sub Country": "Busitema",
        id2_original: "Busia Busitema",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.099055732739345, 0.586500267018243],
            [34.09819830966527, 0.585308102376333],
            [34.09836114907345, 0.584731131970157],
            [34.096589678519685, 0.584837131245692],
            [34.09645516928063, 0.584191490852628],
            [34.095398416333204, 0.584167101962102],
            [34.09492175856537, 0.583115680270919],
            [34.092667810059034, 0.583325196964437],
            [34.091104146779955, 0.583743650944745],
            [34.09073175197553, 0.584862882806641],
            [34.089455046530794, 0.584586418217534],
            [34.08830687203693, 0.58562586391963],
            [34.08821565889962, 0.587753514530112],
            [34.08751333445093, 0.588473113400735],
            [34.086371084346354, 0.588571726148567],
            [34.08619363384008, 0.586991407721938],
            [34.08528968611913, 0.587483524799914],
            [34.08511854088781, 0.586911679237674],
            [34.0835729615937, 0.586112580728773],
            [34.08318830029412, 0.586979698796697],
            [34.08151450625615, 0.586500384691364],
            [34.08094650509525, 0.586918645307202],
            [34.08042106072265, 0.58628537520603],
            [34.079944745212906, 0.587011079794215],
            [34.07889411158921, 0.587072776442693],
            [34.07773389428062, 0.589046913433794],
            [34.07557166286647, 0.589815992314972],
            [34.07560844079254, 0.590473956289549],
            [34.07474705974131, 0.58998833305241],
            [34.07432565285502, 0.590369668320728],
            [34.0739041220012, 0.590111481954032],
            [34.073690426269835, 0.59062806127699],
            [34.07324447381672, 0.590431373016455],
            [34.073299589052674, 0.591156974662559],
            [34.07281710481186, 0.591575218760093],
            [34.071699283493125, 0.591679974703578],
            [34.071833751409706, 0.592110396571712],
            [34.07126561819647, 0.591852239030485],
            [34.069927992602445, 0.592479724555855],
            [34.06915827474451, 0.592190858865932],
            [34.067570216815554, 0.592892186407722],
            [34.066824963676076, 0.592769345673478],
            [34.066048971085884, 0.591619582390383],
            [34.066537326715356, 0.589953034726368],
            [34.064582646556026, 0.590057950592075],
            [34.06376394176901, 0.589141867526754],
            [34.065494008073024, 0.588331467329828],
            [34.06524100026818, 0.587389797712953],
            [34.06551342156463, 0.586772830334244],
            [34.06493601144944, 0.586548265082107],
            [34.06554241199546, 0.586137870573951],
            [34.06515416282463, 0.585595790793108],
            [34.06548879155615, 0.584819129046928],
            [34.064586359293095, 0.584858376193637],
            [34.06436785308338, 0.583940175955656],
            [34.06381972355491, 0.584604540785022],
            [34.06347994747679, 0.583823123467468],
            [34.06241221531997, 0.583346955727805],
            [34.06426370959588, 0.580160613310805],
            [34.06415693673951, 0.577878576035277],
            [34.06201954733622, 0.578178385181837],
            [34.05885556142961, 0.576280191302101],
            [34.05620572088601, 0.574080261552211],
            [34.05420001013034, 0.568136273461809],
            [34.05163732862715, 0.56541526407524],
            [34.051741737117666, 0.564304719182366],
            [34.05214780796545, 0.563864597464809],
            [34.05106930860165, 0.561592054746503],
            [34.052827991637336, 0.560718418559773],
            [34.05369018476557, 0.56088457197865],
            [34.0544541138798, 0.560089262342156],
            [34.05656474336907, 0.559175824375039],
            [34.05984154509897, 0.558288739788581],
            [34.060958669325025, 0.558813191754194],
            [34.06352466112005, 0.558948408720936],
            [34.065822056645096, 0.559032155567364],
            [34.06684933586803, 0.558569418542075],
            [34.06724179723924, 0.55913064126796],
            [34.06838376796779, 0.559598811000706],
            [34.068953131872945, 0.559046915083187],
            [34.069642265460025, 0.559309115437253],
            [34.06980782496689, 0.558684927414069],
            [34.07014028516534, 0.558639637408774],
            [34.07061665906556, 0.559381301511826],
            [34.07220697985067, 0.558639255642922],
            [34.0724687507211, 0.558991992006062],
            [34.073798575345236, 0.558729419752988],
            [34.07410871869706, 0.559489204694994],
            [34.076436494346716, 0.559154080790771],
            [34.07665112163103, 0.559678693469881],
            [34.077208122022945, 0.559090616939553],
            [34.079131511165976, 0.558583699279795],
            [34.0798416958734, 0.557271936393747],
            [34.08131538748689, 0.557561126330042],
            [34.081954852323584, 0.556484566102514],
            [34.08228793685115, 0.556792059285451],
            [34.08337959833048, 0.556312433654527],
            [34.083472610793315, 0.555145518601729],
            [34.085678830012, 0.553489744107615],
            [34.08601192442104, 0.553851511120146],
            [34.087268523773076, 0.552440147513893],
            [34.087054483986954, 0.552051222011751],
            [34.088360770953976, 0.552105254066041],
            [34.088383068037636, 0.55119163431151],
            [34.08949949876433, 0.551046696049034],
            [34.08977059145244, 0.550178259307939],
            [34.09000936634993, 0.550702865596847],
            [34.09057935368592, 0.55051280074083],
            [34.0917860345559, 0.549463276382379],
            [34.091215730114655, 0.547907523141821],
            [34.09230795753262, 0.547473128497239],
            [34.09221118023042, 0.5464690742574],
            [34.09311118704224, 0.545184421322602],
            [34.09292072174412, 0.544723125849184],
            [34.09372703966166, 0.543981231757329],
            [34.094174879475204, 0.542244377663763],
            [34.09476902520413, 0.542117629255633],
            [34.09457737951973, 0.541330689936461],
            [34.095361406641814, 0.541547643153119],
            [34.095490399326735, 0.540579731830739],
            [34.09627434739708, 0.540362492029647],
            [34.09660554725918, 0.53957545816397],
            [34.097769750392686, 0.539665701609852],
            [34.09819591116345, 0.539168111792368],
            [34.09818038827534, 0.537169020875302],
            [34.096967768643005, 0.536409404673298],
            [34.09543817936096, 0.534356312081624],
            [34.09446876960862, 0.533813746036435],
            [34.09408729822659, 0.532981611564204],
            [34.09212420714127, 0.531199963572054],
            [34.0918854034977, 0.530485396111729],
            [34.090411089351726, 0.52977104954503],
            [34.089218933341535, 0.527202282537888],
            [34.08776755408306, 0.525963277816229],
            [34.08564812290065, 0.522906200915783],
            [34.08330606403798, 0.521730666772178],
            [34.082544387000134, 0.520844318699206],
            [34.08089452048808, 0.514856335211828],
            [34.08103981939201, 0.51291327925384],
            [34.07844734166917, 0.511297262930749],
            [34.07930604753747, 0.509863364331408],
            [34.07949985546675, 0.508467603682986],
            [34.08863854261624, 0.495822842853359],
            [34.0890721836584, 0.493874160663224],
            [34.0975492642961, 0.492376570042851],
            [34.09660173121588, 0.487825132916102],
            [34.096222837100385, 0.481990731102597],
            [34.09610294165435, 0.480272072914774],
            [34.09849706866751, 0.478486628679344],
            [34.10424667994797, 0.47634737408043],
            [34.106207690535115, 0.4763200114442],
            [34.10984712867046, 0.473821608537909],
            [34.11282769207076, 0.476800320418616],
            [34.11650099938727, 0.478834241207344],
            [34.11899189292284, 0.480767046991545],
            [34.120063581260176, 0.481038192112313],
            [34.120241602196636, 0.482159768292715],
            [34.11901758563829, 0.484025653728727],
            [34.11913512749826, 0.48487827626998],
            [34.11783587883147, 0.488196199126817],
            [34.1180795109197, 0.490863830453095],
            [34.11770240894319, 0.492408780642817],
            [34.11882623909288, 0.493202137066955],
            [34.11930445992934, 0.494569659888599],
            [34.118902004800574, 0.494949617815946],
            [34.11892783675488, 0.498934236434538],
            [34.118198821562466, 0.502167648312033],
            [34.11862685532061, 0.504252747210832],
            [34.11762124256401, 0.508229104972618],
            [34.1216221115657, 0.513023453207745],
            [34.12317341222987, 0.513609359430474],
            [34.123056423732095, 0.514947971348472],
            [34.12334999945516, 0.515353133792068],
            [34.122838769125295, 0.517083832331519],
            [34.12124564559644, 0.518114040244217],
            [34.120784373274454, 0.517818653011868],
            [34.12044070659284, 0.518679798510326],
            [34.11981174575678, 0.518544838455908],
            [34.11933383214417, 0.51899235000678],
            [34.11883925208807, 0.520030804701814],
            [34.117849694920565, 0.519870583293738],
            [34.116798672326325, 0.520358852329321],
            [34.12687594264088, 0.536521497829026],
            [34.128193110900945, 0.55578833808066],
            [34.13834413918851, 0.582913965034102],
            [34.13772149171225, 0.583251904523559],
            [34.137802442495754, 0.583840640604375],
            [34.13680393271811, 0.583850418258586],
            [34.135778013544524, 0.584466777831122],
            [34.13478295329757, 0.583942493488734],
            [34.13485808569297, 0.583128638696071],
            [34.13405338653957, 0.581991821078169],
            [34.13333222891094, 0.582450750254612],
            [34.13318152035236, 0.58186433785033],
            [34.13279314002749, 0.581784628156928],
            [34.1321117355451, 0.582869886085934],
            [34.13061746083353, 0.581589588807735],
            [34.129983343667725, 0.582210022277246],
            [34.129469864854684, 0.581793170694844],
            [34.12879904522134, 0.582814206894014],
            [34.127116705510055, 0.582102282107054],
            [34.126957635432824, 0.580924895754525],
            [34.126134740005014, 0.58170274016011],
            [34.125412549313786, 0.580612682554483],
            [34.12437294879844, 0.580823664417923],
            [34.123780813499124, 0.580235073541778],
            [34.123708752443655, 0.580925550592715],
            [34.12311667733148, 0.580642216746143],
            [34.12264029085483, 0.581231022266186],
            [34.12005553954175, 0.580824532145898],
            [34.118980050432434, 0.582111189341687],
            [34.1182002642568, 0.581849696066214],
            [34.117745578382504, 0.582649272162291],
            [34.11623671592899, 0.582998440925687],
            [34.1156663279444, 0.582860462347928],
            [34.115492913568694, 0.582155496456109],
            [34.11489366451066, 0.582112008562925],
            [34.11474190402485, 0.581377965608826],
            [34.1139983028872, 0.581552546888642],
            [34.11370219301669, 0.581051111545918],
            [34.11054050500059, 0.583489238797246],
            [34.107825916586236, 0.583225192705982],
            [34.10747946422892, 0.584360171319042],
            [34.10521744705469, 0.586258485545739],
            [34.10133403906461, 0.586494447138438],
            [34.100408640473, 0.587091644564688],
            [34.099055732739345, 0.586500267018243],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 888,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BUTEBA",
        Population: 27540,
        Key: "BUSIABUTEBA",
        Dist2: "Busia",
        "Sub Country": "Buteba",
        id2_original: "Busia Buteba",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.26562339728638, 0.843475520275985],
            [34.264643572466625, 0.842175700787897],
            [34.26253463540335, 0.843991310219474],
            [34.26117623447175, 0.841493006358882],
            [34.2605276867692, 0.841391637021675],
            [34.25962396093213, 0.840458583778533],
            [34.25478155556217, 0.832304185401727],
            [34.251476569190245, 0.833017643681188],
            [34.25061751118238, 0.828771511316481],
            [34.248059847668344, 0.822639731453314],
            [34.24554344018208, 0.818649847609593],
            [34.249976129340844, 0.814700027793216],
            [34.25094803371476, 0.807950048482167],
            [34.25330491837286, 0.803877584205858],
            [34.25631885328767, 0.80116131920285],
            [34.262756547126294, 0.803047919807678],
            [34.26449747046883, 0.806852059601613],
            [34.26635362520441, 0.807794309569199],
            [34.267708883829165, 0.809327699636765],
            [34.27015807487432, 0.809707659854475],
            [34.27262449291164, 0.809258156310418],
            [34.272981244453675, 0.809706766120016],
            [34.27437798727826, 0.809766151405728],
            [34.27535851637716, 0.809287204030625],
            [34.27930969596724, 0.805307286273539],
            [34.28144277525381, 0.80207699104164],
            [34.28181887560876, 0.803493441299143],
            [34.28531369486482, 0.808751491423922],
            [34.2866858759529, 0.809410203459831],
            [34.28967941731409, 0.809880064370791],
            [34.29189289851351, 0.808686605388519],
            [34.29285989269606, 0.809879041291878],
            [34.298264092766644, 0.813215943321232],
            [34.300347035280545, 0.815064933265067],
            [34.304124560644716, 0.820585638441654],
            [34.30525922806999, 0.820667768373287],
            [34.305689757348006, 0.822125918397992],
            [34.306591808725386, 0.822938165932158],
            [34.30589064669668, 0.825273394074041],
            [34.30377635657259, 0.829273647535575],
            [34.30081996863321, 0.831933028994497],
            [34.30308425674848, 0.834388863025256],
            [34.305330516574315, 0.839218134658525],
            [34.30730063068851, 0.841673100042393],
            [34.30699123024341, 0.842411470494793],
            [34.30542967171703, 0.843812390613896],
            [34.30137748914968, 0.841750019869097],
            [34.299912945080735, 0.841308276063431],
            [34.29788739054044, 0.84189860134798],
            [34.29596325849067, 0.840742620262784],
            [34.2903120585479, 0.842124661332302],
            [34.28807995078106, 0.841732229756577],
            [34.28634161907812, 0.839951436028557],
            [34.282864913451434, 0.84129957412313],
            [34.27597535355017, 0.840518244358344],
            [34.27305930805187, 0.840842774327156],
            [34.27108625195508, 0.841306342199144],
            [34.268472226343526, 0.841167200075656],
            [34.26606772738211, 0.843491585802116],
            [34.26562339728638, 0.843475520275985],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 889,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUTIRU",
        Population: 17681,
        Key: "MANAFWABUTIRU",
        Dist2: "Manafwa",
        "Sub Country": "Butiru",
        id2_original: "Manafwa Butiru",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.15325126540849, 0.872556725322906],
            [34.148201255783114, 0.87625503322339],
            [34.14649492296891, 0.876778070885097],
            [34.13997963085941, 0.880501428366492],
            [34.13599673714654, 0.883490847961032],
            [34.13140759649955, 0.888824358531288],
            [34.13110443665072, 0.889863100875788],
            [34.13129372066426, 0.891830738529151],
            [34.129471936369725, 0.892340811082283],
            [34.12814930096287, 0.893959603999268],
            [34.12432473531882, 0.895224751104546],
            [34.120528238434154, 0.894365333481893],
            [34.119790960537735, 0.893505079428161],
            [34.119157216172795, 0.893598139861714],
            [34.11561987246781, 0.88183088913964],
            [34.11148796621561, 0.870543200433393],
            [34.11229252343521, 0.870225159861383],
            [34.112744646416026, 0.869186086898501],
            [34.11249682817858, 0.867834118733873],
            [34.111584518040644, 0.866525043328427],
            [34.11212133418644, 0.86500917371419],
            [34.11320097261405, 0.863745594527394],
            [34.11522576268802, 0.86402007589935],
            [34.114990472355565, 0.863509376122669],
            [34.11605961486735, 0.861444950037734],
            [34.117531534104806, 0.860049615137183],
            [34.11835027302777, 0.85972442479909],
            [34.119862057700914, 0.860041000365914],
            [34.12060145472305, 0.857639338627011],
            [34.12127074362718, 0.857813502443259],
            [34.12152247941756, 0.857084278761222],
            [34.12316006416306, 0.856814324791265],
            [34.124994073630255, 0.855149417651675],
            [34.12523792850067, 0.854396419497665],
            [34.12557655473523, 0.854642011342932],
            [34.12576533748882, 0.854031689233812],
            [34.12659206872287, 0.854126551567253],
            [34.12708001741553, 0.853444810455815],
            [34.12974090005064, 0.852374076197501],
            [34.13005563469191, 0.851692387770374],
            [34.130669771529135, 0.851747684643967],
            [34.13357436081262, 0.849440496629268],
            [34.13481802981446, 0.84835433348759],
            [34.1346917787878, 0.847403309491027],
            [34.138242070809305, 0.845428806982509],
            [34.13993433061625, 0.843708472194648],
            [34.14057160086869, 0.842107333803897],
            [34.142141985342725, 0.841057916526786],
            [34.14230076526416, 0.840636932271077],
            [34.14173183344864, 0.83985415803786],
            [34.14286910958148, 0.839407629205774],
            [34.14298584295771, 0.838195296706881],
            [34.14362143066562, 0.838119340599375],
            [34.143972480600546, 0.837403644883421],
            [34.143913650830925, 0.836418670005863],
            [34.14496724440346, 0.835803792855447],
            [34.1454765316774, 0.834377985580682],
            [34.14537249419106, 0.833542147738712],
            [34.146254778140644, 0.833628958925937],
            [34.14711094626824, 0.833141116640507],
            [34.14741314671634, 0.831295153998021],
            [34.14812245826131, 0.831451670754479],
            [34.14922081757944, 0.830972465491057],
            [34.15015411415903, 0.828011829793392],
            [34.15165026634958, 0.827236473258646],
            [34.15189184219409, 0.825120615474114],
            [34.152843105977695, 0.824467316006467],
            [34.153309908328545, 0.823518123987993],
            [34.15471102954181, 0.823152022853368],
            [34.1565700283436, 0.820887677643231],
            [34.157459915633716, 0.81736111392137],
            [34.15740715667879, 0.81435724016964],
            [34.15781324818779, 0.812833410018702],
            [34.159213478272314, 0.809358943518211],
            [34.160995066551116, 0.808627048525879],
            [34.16034561155014, 0.806015160594981],
            [34.161954091778746, 0.804874092242611],
            [34.16250736236561, 0.803829104206755],
            [34.16347589985379, 0.803106151867001],
            [34.16408063222835, 0.800528734377366],
            [34.1651699140705, 0.798578076379733],
            [34.164624351927095, 0.796288316439012],
            [34.16550612743023, 0.792469560747805],
            [34.16617562564178, 0.791676230128849],
            [34.16694783632465, 0.791898090122791],
            [34.17128070918064, 0.789715721551638],
            [34.17263589234691, 0.789667747987598],
            [34.17435307141983, 0.788057187212004],
            [34.174604938364254, 0.787121212256021],
            [34.176928847664904, 0.785677039676368],
            [34.17937138219379, 0.785803245596864],
            [34.1806341098527, 0.7910761920984],
            [34.1808069178656, 0.794441032702876],
            [34.180072263049816, 0.813680825828816],
            [34.17886310013467, 0.821306463357327],
            [34.17920011838487, 0.823386807449823],
            [34.179887289153044, 0.824320781817135],
            [34.18115698684023, 0.825437731887833],
            [34.18197903605503, 0.826961232983436],
            [34.18214999353846, 0.828436868175234],
            [34.18306907427868, 0.829244075399071],
            [34.18356801296052, 0.829862003033311],
            [34.18419155066721, 0.83366291973345],
            [34.18228409943394, 0.837143937327565],
            [34.18216998734172, 0.838663598507229],
            [34.18017622148437, 0.84227332273831],
            [34.18073196782817, 0.848849161099312],
            [34.180222922201054, 0.849970948264354],
            [34.18014948223164, 0.85407758445235],
            [34.17961338653469, 0.857121062452654],
            [34.17569234362577, 0.860935392443524],
            [34.170073312353324, 0.864491994361686],
            [34.160639649007244, 0.869623699313324],
            [34.15325126540849, 0.872556725322906],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 890,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "MOLO",
        Population: 18803,
        Key: "TOROROMOLO",
        Dist2: "Tororo",
        "Sub Country": "Molo",
        id2_original: "Tororo Molo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.108290006024944, 0.902475230453971],
            [34.093712530073205, 0.902036447966145],
            [34.09162351315133, 0.90299592368001],
            [34.080155524114524, 0.899815291293223],
            [34.077256834965844, 0.8996442875224],
            [34.07385023206732, 0.900757927160393],
            [34.06975933480616, 0.902809286821984],
            [34.06216431803079, 0.877962195452197],
            [34.061790515566344, 0.87652277890537],
            [34.06561052226032, 0.876562919917544],
            [34.06934819746019, 0.875211358597577],
            [34.0735266373424, 0.875251388245688],
            [34.07666028893848, 0.874673175988191],
            [34.07779656883968, 0.872940930617316],
            [34.07896387295754, 0.872260197078889],
            [34.079670460810576, 0.87206412026621],
            [34.08095076131307, 0.872589510028505],
            [34.084155901737766, 0.871351498268024],
            [34.086132433416395, 0.871289068982087],
            [34.08677920425128, 0.870469474326611],
            [34.08880368710144, 0.869923003239101],
            [34.09205707604008, 0.86484124382468],
            [34.09411633986142, 0.862894024536085],
            [34.096063682581494, 0.859405131209749],
            [34.09538832915089, 0.855355983795718],
            [34.09600392215722, 0.84742607480172],
            [34.0951493772853, 0.845093259859171],
            [34.093904678814155, 0.843448192893164],
            [34.09161087205867, 0.84163151163392],
            [34.08680478018574, 0.841061490538203],
            [34.08533283220222, 0.841396595187352],
            [34.08260369736846, 0.842853720770455],
            [34.08033593726463, 0.843279505761945],
            [34.078006747666706, 0.842945465663069],
            [34.07688949048997, 0.842348760493143],
            [34.07560283440685, 0.840485698304503],
            [34.073777863788024, 0.839349994990838],
            [34.07681584390804, 0.834817949896057],
            [34.07802026731176, 0.833968890347312],
            [34.07896493207125, 0.832342199889785],
            [34.08156689061362, 0.830732244412468],
            [34.084799434146085, 0.829709694379762],
            [34.0983867780085, 0.822957842396972],
            [34.10121213678225, 0.822260540437534],
            [34.10145106349499, 0.823119810795138],
            [34.102307718509486, 0.823743721543707],
            [34.104862734688375, 0.824376202133604],
            [34.108236498773365, 0.824637578527514],
            [34.11284332904493, 0.823966904664872],
            [34.113126696313074, 0.823053216572069],
            [34.11512927194842, 0.820393241731757],
            [34.116239913931395, 0.817462151531256],
            [34.11626143307403, 0.81607816707789],
            [34.11754091071974, 0.814404370909694],
            [34.11786865476293, 0.813045837504482],
            [34.11818792140482, 0.812524032612201],
            [34.11913484632558, 0.812386076933394],
            [34.120071080396144, 0.811633807148725],
            [34.12375344632398, 0.810668936267158],
            [34.129129104223026, 0.807151009933696],
            [34.132821772928835, 0.805455315803452],
            [34.13334772844286, 0.804978546120134],
            [34.13349475031551, 0.803961711235309],
            [34.136787517802944, 0.802022525234614],
            [34.13800787282819, 0.801429054752965],
            [34.139354668424666, 0.801481633392106],
            [34.14138505859613, 0.800400723468366],
            [34.143720716962385, 0.799828121277428],
            [34.146455945068716, 0.798344533492116],
            [34.1482441144053, 0.796490508574511],
            [34.1488962230296, 0.795643001167066],
            [34.149001207340255, 0.794806239995553],
            [34.14962190906557, 0.794530685829901],
            [34.15137832744844, 0.792009405904851],
            [34.15234551836202, 0.789117646768915],
            [34.15742647944055, 0.785557474372774],
            [34.158152213087234, 0.784625217532898],
            [34.16024568655121, 0.783448974821105],
            [34.162473920782524, 0.780461168102474],
            [34.16603632029742, 0.781392683030681],
            [34.168914667096494, 0.783779871544016],
            [34.17032406359016, 0.785864001029485],
            [34.168939822619414, 0.786837289664172],
            [34.16879823016431, 0.787662195801707],
            [34.16617562564178, 0.791676230128849],
            [34.16550612743023, 0.792469560747805],
            [34.164624351927095, 0.796288316439012],
            [34.1651699140705, 0.798578076379733],
            [34.16408063222835, 0.800528734377366],
            [34.16347589985379, 0.803106151867001],
            [34.16250736236561, 0.803829104206755],
            [34.161954091778746, 0.804874092242611],
            [34.16034561155014, 0.806015160594981],
            [34.160995066551116, 0.808627048525879],
            [34.159213478272314, 0.809358943518211],
            [34.15781324818779, 0.812833410018702],
            [34.15740715667879, 0.81435724016964],
            [34.157459915633716, 0.81736111392137],
            [34.1565700283436, 0.820887677643231],
            [34.15471102954181, 0.823152022853368],
            [34.153309908328545, 0.823518123987993],
            [34.152843105977695, 0.824467316006467],
            [34.15189184219409, 0.825120615474114],
            [34.15165026634958, 0.827236473258646],
            [34.15015411415903, 0.828011829793392],
            [34.14922081757944, 0.830972465491057],
            [34.14812245826131, 0.831451670754479],
            [34.14741314671634, 0.831295153998021],
            [34.14711094626824, 0.833141116640507],
            [34.146254778140644, 0.833628958925937],
            [34.14537249419106, 0.833542147738712],
            [34.1454765316774, 0.834377985580682],
            [34.14496724440346, 0.835803792855447],
            [34.143913650830925, 0.836418670005863],
            [34.143972480600546, 0.837403644883421],
            [34.14362143066562, 0.838119340599375],
            [34.14298584295771, 0.838195296706881],
            [34.14286910958148, 0.839407629205774],
            [34.14173183344864, 0.83985415803786],
            [34.14230076526416, 0.840636932271077],
            [34.142141985342725, 0.841057916526786],
            [34.14057160086869, 0.842107333803897],
            [34.13993433061625, 0.843708472194648],
            [34.138242070809305, 0.845428806982509],
            [34.1346917787878, 0.847403309491027],
            [34.13481802981446, 0.84835433348759],
            [34.13357436081262, 0.849440496629268],
            [34.130669771529135, 0.851747684643967],
            [34.13005563469191, 0.851692387770374],
            [34.12974090005064, 0.852374076197501],
            [34.12708001741553, 0.853444810455815],
            [34.12659206872287, 0.854126551567253],
            [34.12576533748882, 0.854031689233812],
            [34.12557655473523, 0.854642011342932],
            [34.12523792850067, 0.854396419497665],
            [34.124994073630255, 0.855149417651675],
            [34.12316006416306, 0.856814324791265],
            [34.12152247941756, 0.857084278761222],
            [34.12127074362718, 0.857813502443259],
            [34.12060145472305, 0.857639338627011],
            [34.119862057700914, 0.860041000365914],
            [34.11835027302777, 0.85972442479909],
            [34.117531534104806, 0.860049615137183],
            [34.11605961486735, 0.861444950037734],
            [34.114990472355565, 0.863509376122669],
            [34.11522576268802, 0.86402007589935],
            [34.11320097261405, 0.863745594527394],
            [34.11212133418644, 0.86500917371419],
            [34.111584518040644, 0.866525043328427],
            [34.11249682817858, 0.867834118733873],
            [34.112744646416026, 0.869186086898501],
            [34.11229252343521, 0.870225159861383],
            [34.11148796621561, 0.870543200433393],
            [34.11561987246781, 0.88183088913964],
            [34.119157216172795, 0.893598139861714],
            [34.1157344292261, 0.894838439128418],
            [34.1110374431343, 0.898467173205556],
            [34.10840654716172, 0.901552540551005],
            [34.108290006024944, 0.902475230453971],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 891,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "MERIKIT",
        Population: 25769,
        Key: "TOROROMERIKIT",
        Dist2: "Tororo",
        "Sub Country": "Merikit",
        id2_original: "Tororo Merikit",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.046956040594964, 0.794165720136507],
            [34.04116664293056, 0.796533444794197],
            [34.041795274084926, 0.79951294212746],
            [34.04304571907894, 0.802070552548597],
            [34.043061429714946, 0.805577714435033],
            [34.042096662456004, 0.808933394718245],
            [34.04164918646015, 0.812876289478188],
            [34.04248699032842, 0.815313971359144],
            [34.04670438385632, 0.821543047202856],
            [34.051818531396364, 0.826868938904327],
            [34.053552910512046, 0.827741299845744],
            [34.05455023002194, 0.828853508142443],
            [34.05441765755063, 0.831192455928928],
            [34.054824772240764, 0.833028642389277],
            [34.05440196218597, 0.835516349963641],
            [34.05364408232686, 0.836755829280639],
            [34.05585946795469, 0.839903163057664],
            [34.056733420928296, 0.84484133227791],
            [34.0554083807314, 0.848235370956132],
            [34.054033217236594, 0.848860526235186],
            [34.05264442270566, 0.851239323082796],
            [34.05101735813044, 0.855020335138625],
            [34.05054770183192, 0.857290648092004],
            [34.05025606826651, 0.866010858823654],
            [34.051117595743094, 0.868362262105456],
            [34.05339529031566, 0.869301310420021],
            [34.05309815367081, 0.871529101604792],
            [34.04923643011336, 0.875353751902552],
            [34.04628323209154, 0.876188965369236],
            [34.04510897681005, 0.878627629648514],
            [34.04205770252212, 0.879880982218459],
            [34.0418109712462, 0.880715935989492],
            [34.04035731835174, 0.882051906903717],
            [34.0398830411194, 0.883182770520206],
            [34.03615769799177, 0.885445282652502],
            [34.03089557456821, 0.885320121854341],
            [34.028780264856294, 0.884823192710124],
            [34.02633843191167, 0.883593636244538],
            [34.0215778765388, 0.879971485792535],
            [34.0223897271802, 0.877876428089934],
            [34.02197647789498, 0.875193681815268],
            [34.02127828120503, 0.874874484741268],
            [34.01826370758805, 0.874843373421886],
            [34.01105786434995, 0.872127644458771],
            [34.00912917424844, 0.872200534298505],
            [34.00765725141775, 0.872825101812856],
            [34.005358618912524, 0.875711376171669],
            [34.00320005352307, 0.877313091493071],
            [34.000657384687784, 0.877069538256801],
            [33.9781890704494, 0.864619182223253],
            [33.96066314856369, 0.853506098402393],
            [33.95697463187109, 0.850775115071203],
            [33.9529130008236, 0.84702860745788],
            [33.948720561595955, 0.848152940697401],
            [33.94902510395202, 0.845444728785745],
            [33.94967365704444, 0.843929050250431],
            [33.950431076067815, 0.84056372026887],
            [33.95278382308572, 0.835795857982542],
            [33.95533312238614, 0.833253286391814],
            [33.96143853389274, 0.824920369419285],
            [33.963321417999616, 0.823526817883527],
            [33.96499498117057, 0.822866047636821],
            [33.97031711385172, 0.82255717849932],
            [33.974187713662495, 0.821344059378753],
            [33.97693372694211, 0.819479903128746],
            [33.98329530203515, 0.813969319423943],
            [33.98785066782408, 0.811037295779501],
            [33.989458795014784, 0.809281979051894],
            [33.99217782649656, 0.805102068447522],
            [33.995746892409144, 0.802034608187941],
            [33.999800314651594, 0.799898765093486],
            [34.00145838817213, 0.798016799693488],
            [34.003961156537436, 0.796089398336759],
            [34.00809036425051, 0.793872127692301],
            [34.01634401860566, 0.793046909306119],
            [34.01814783839113, 0.79237706468012],
            [34.02292629359433, 0.78796148256731],
            [34.023684789697754, 0.786839604404369],
            [34.02507833092665, 0.782732428700417],
            [34.02813371949855, 0.780354523716982],
            [34.030096412630186, 0.786066091274691],
            [34.0318552834138, 0.787992751761649],
            [34.03272074101975, 0.789776886520107],
            [34.033472384774186, 0.790062193981957],
            [34.0333449327, 0.79076169044358],
            [34.0338683028626, 0.791387353213523],
            [34.037847137987015, 0.792878145502785],
            [34.03989719317838, 0.793175976761145],
            [34.04246582691863, 0.792851789659401],
            [34.04471576534556, 0.79354634000074],
            [34.04678156800384, 0.793647353948912],
            [34.046956040594964, 0.794165720136507],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 892,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "PAYA",
        Population: 29487,
        Key: "TOROROPAYA",
        Dist2: "Tororo",
        "Sub Country": "Paya",
        id2_original: "Tororo Paya",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.02160016553761, 0.385590409048953],
            [34.01873239190945, 0.385329293569597],
            [34.01739335775704, 0.386002210795889],
            [34.01598474100105, 0.385334399478193],
            [34.009086431508884, 0.38575561716495],
            [34.006073287111555, 0.386453309329511],
            [34.0027670943022, 0.387784760055813],
            [34.000616314611285, 0.390315180416525],
            [33.99953458670236, 0.393345344402735],
            [33.997843680656544, 0.394771597287651],
            [33.99369874523945, 0.397340575688954],
            [33.987673488609026, 0.399478300583404],
            [33.98586783895533, 0.403319334204209],
            [33.98408068202008, 0.40377032759614],
            [33.9831516533364, 0.404483931506682],
            [33.98078710425226, 0.407232062337797],
            [33.98061717803481, 0.408677388941445],
            [33.97948537264205, 0.409177830334979],
            [33.97595272802432, 0.413165336624976],
            [33.97479676873017, 0.413003611737756],
            [33.9735636935605, 0.415042867141162],
            [33.97051262858006, 0.417284887962922],
            [33.96896042061747, 0.417750471514567],
            [33.966653745495535, 0.421956352496422],
            [33.965695241290724, 0.421965011122628],
            [33.96406251553259, 0.422972853049333],
            [33.96198641458791, 0.423229947466942],
            [33.96070789634294, 0.424194391909215],
            [33.959287111906406, 0.42428850312666],
            [33.957326881056936, 0.425202986313471],
            [33.95025068178235, 0.42523060066316],
            [33.94569521268716, 0.42331339328987],
            [33.943336960793175, 0.422988024282755],
            [33.93404783907127, 0.423848093663952],
            [33.93213544171405, 0.419135526251815],
            [33.931631734774676, 0.413155500328368],
            [33.93031351458741, 0.405969904552013],
            [33.92827714792435, 0.402401376591819],
            [33.926073396377795, 0.3971931755755],
            [33.92630054168556, 0.392846668087669],
            [33.931724261248945, 0.386922468056157],
            [33.93257489575443, 0.385031729762693],
            [33.932526372356044, 0.377776728868425],
            [33.93118051190579, 0.375542478390249],
            [33.93057206230259, 0.373416699303395],
            [33.930485089213434, 0.368812219495336],
            [33.93381500742774, 0.35921391171463],
            [33.93427202083694, 0.352311661425622],
            [33.936254779637125, 0.349489065804967],
            [33.9379229088989, 0.345345769626793],
            [33.93899493410447, 0.344495326601577],
            [33.94252012899354, 0.343477533964859],
            [33.94291929000015, 0.342875678910276],
            [33.94611166536466, 0.342033315867118],
            [33.947620238560646, 0.340179468519648],
            [33.948950660564414, 0.339944137416422],
            [33.9503079727379, 0.339021299951127],
            [33.956874440072525, 0.336928333617941],
            [33.962026121021786, 0.335953509457802],
            [33.963098687013115, 0.334958335113782],
            [33.96440606363659, 0.334587316573422],
            [33.966209943609165, 0.334686642498609],
            [33.97297970148923, 0.336694183700025],
            [33.974577462121545, 0.336730205520898],
            [33.97513089889673, 0.337409785442879],
            [33.977770291135286, 0.337942047767718],
            [33.98154289463003, 0.341189180405415],
            [33.98496191763569, 0.34116168795353],
            [33.98977580059708, 0.339677644297935],
            [33.992454592944, 0.339324572165462],
            [33.996439751309715, 0.339848822452069],
            [33.997861141210734, 0.340382088941654],
            [33.99934359229655, 0.342503261122848],
            [34.00021851006076, 0.343040570709804],
            [34.000726983461036, 0.342579770166581],
            [34.00212562891737, 0.342344908932571],
            [34.00180891708417, 0.347944389181496],
            [34.002968611573245, 0.353136641481425],
            [34.00322621515907, 0.356736902377867],
            [34.00715424516427, 0.363756118409331],
            [34.01541234887504, 0.371996011400565],
            [34.019160452617044, 0.381647556286986],
            [34.02121517006474, 0.383638813658756],
            [34.02160016553761, 0.385590409048953],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 893,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "MASABA",
        Population: 23378,
        Key: "BUSIAMASABA",
        Dist2: "Busia",
        "Sub Country": "Masaba",
        id2_original: "Busia Masaba",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.00212562891737, 0.342344908932571],
            [34.000726983461036, 0.342579770166581],
            [34.00021851006076, 0.343040570709804],
            [33.99934359229655, 0.342503261122848],
            [33.997861141210734, 0.340382088941654],
            [33.996439751309715, 0.339848822452069],
            [33.992454592944, 0.339324572165462],
            [33.98977580059708, 0.339677644297935],
            [33.98496191763569, 0.34116168795353],
            [33.98154289463003, 0.341189180405415],
            [33.977770291135286, 0.337942047767718],
            [33.97513089889673, 0.337409785442879],
            [33.974577462121545, 0.336730205520898],
            [33.97297970148923, 0.336694183700025],
            [33.966209943609165, 0.334686642498609],
            [33.96440606363659, 0.334587316573422],
            [33.96402047886888, 0.331276496742539],
            [33.96608814912463, 0.323885665664011],
            [33.96410174406274, 0.317753052293894],
            [33.9635721018628, 0.31422504453552],
            [33.963141114444, 0.312492836503645],
            [33.967112992116526, 0.311346565458336],
            [33.9716829195962, 0.308522848796195],
            [33.97223688458078, 0.308557652618933],
            [33.9724793353844, 0.309568437542352],
            [33.974314580035106, 0.312252132009034],
            [33.975214780883036, 0.312391468520911],
            [33.98227757010705, 0.31016006023477],
            [33.986259126228475, 0.309845986859184],
            [33.989236583254545, 0.309078888897971],
            [33.990867139581255, 0.306949626778591],
            [33.99296448927567, 0.306078815098192],
            [33.993983913629776, 0.303882966596955],
            [33.995117476127255, 0.302516219690503],
            [33.9957363443911, 0.302389517678303],
            [33.995813662387604, 0.298311949950439],
            [33.996299887213226, 0.297208577661674],
            [33.99578470249948, 0.294577254146081],
            [33.996889050885585, 0.294981422402825],
            [33.99934883306791, 0.296952008790724],
            [34.00321413371684, 0.299276195651174],
            [34.00400872412833, 0.300348627484123],
            [34.008264459549196, 0.302876824464291],
            [34.00994226905649, 0.301087979288382],
            [34.01109486775313, 0.299073327384598],
            [34.012299469023276, 0.298012012826573],
            [34.01760365785663, 0.295729665973622],
            [34.01978355733579, 0.293540353249803],
            [34.02321861616757, 0.291405202418763],
            [34.024275414030754, 0.290120587680001],
            [34.023492928417674, 0.278758908756449],
            [34.022804149665156, 0.275837808513714],
            [34.022179752270716, 0.274780827020015],
            [34.0221996167166, 0.271973225762384],
            [34.02368894350763, 0.270540033687317],
            [34.025602654201776, 0.267090567911747],
            [34.02572323416407, 0.267637726692315],
            [34.02677692026307, 0.267782794044012],
            [34.02724266529686, 0.26672199225153],
            [34.02790827290495, 0.268262832309892],
            [34.028684720042676, 0.268932721114129],
            [34.02900635913523, 0.268832199842435],
            [34.029372204322875, 0.26684463611114],
            [34.03029278075803, 0.266833391122359],
            [34.030459212529045, 0.267581493667216],
            [34.03160164678826, 0.267961036712993],
            [34.03172371615727, 0.268731474654582],
            [34.03242237278468, 0.267625988534567],
            [34.033121172244186, 0.268195390232353],
            [34.03297703126866, 0.26873136685795],
            [34.03370906120716, 0.268798298695063],
            [34.03391985178687, 0.269468234181821],
            [34.03457418553815, 0.268865218853843],
            [34.035594613310415, 0.269222439869718],
            [34.03533957710966, 0.269959411367307],
            [34.03566127459269, 0.270551175367572],
            [34.03594957900169, 0.269747206498007],
            [34.0371696851936, 0.270528713244322],
            [34.03863372081612, 0.270394594470017],
            [34.03784633579147, 0.271500086626885],
            [34.03844527582907, 0.271634024829562],
            [34.03811257757709, 0.272091855043414],
            [34.03830120671874, 0.272985108995141],
            [34.03904432725774, 0.273063205842624],
            [34.039399195930955, 0.272460216744435],
            [34.0394436149268, 0.273085501774752],
            [34.04061926888521, 0.27287324755352],
            [34.04033095818804, 0.27357672283024],
            [34.041196074434225, 0.273554314610899],
            [34.041318161769524, 0.274514568530534],
            [34.0419836687663, 0.274882984055512],
            [34.04147353438106, 0.275608810836431],
            [34.04230535996111, 0.275396585405716],
            [34.04254943941034, 0.276211672216688],
            [34.041484760627185, 0.277138535035501],
            [34.040431100579305, 0.277250287742269],
            [34.03996538788487, 0.278601400915976],
            [34.03917789236744, 0.27842281704906],
            [34.03865663504238, 0.278791338452631],
            [34.03989901675842, 0.280588933953153],
            [34.04023166829802, 0.279617471481233],
            [34.04135190428823, 0.279829521666818],
            [34.040653257542324, 0.280979670358589],
            [34.0410637247451, 0.281995728141275],
            [34.0395222480569, 0.284318372097688],
            [34.039799557985084, 0.284630990946416],
            [34.04100846937197, 0.284228908183084],
            [34.04080888437708, 0.284865380967324],
            [34.04208436451977, 0.284697777168559],
            [34.04321574950099, 0.285535112528557],
            [34.043027241631876, 0.286015262363639],
            [34.04225083042674, 0.285758518966655],
            [34.041430145752855, 0.28651787337317],
            [34.04158547075368, 0.287031489483103],
            [34.04246171892284, 0.287455711748232],
            [34.041740816415775, 0.287779588954948],
            [34.04149676930589, 0.287344143291861],
            [34.03968887476231, 0.287154490657573],
            [34.03956695990353, 0.288125932733691],
            [34.03985535414403, 0.288360390055869],
            [34.041008801748625, 0.287880149590517],
            [34.04066502726916, 0.288471972875168],
            [34.040920179352575, 0.289052575415627],
            [34.04154123681077, 0.288471891129502],
            [34.04243968774049, 0.289097097151078],
            [34.041929666542984, 0.291017674210714],
            [34.043072087327474, 0.291240883812722],
            [34.043149653258986, 0.29044810024599],
            [34.0435711661465, 0.290939359195869],
            [34.044103449393376, 0.289889718219488],
            [34.04466909337496, 0.289766841040495],
            [34.04541236123768, 0.291430483378804],
            [34.0461332547616, 0.291028444872039],
            [34.04698729208539, 0.291140022275215],
            [34.047031715572814, 0.291765306301769],
            [34.04761959734925, 0.292256548126428],
            [34.04873973991469, 0.291463666716076],
            [34.04866216679664, 0.292178288815031],
            [34.049438684002965, 0.29355161438242],
            [34.04848486451238, 0.293853182047677],
            [34.04840726983477, 0.294322156635338],
            [34.0488065745718, 0.294523102619734],
            [34.04977147567974, 0.294132206779801],
            [34.050714296197995, 0.294813232161651],
            [34.05004894011816, 0.29606387073513],
            [34.05042864092078, 0.297176904389169],
            [34.04947680670698, 0.29737873515049],
            [34.049485398194356, 0.298367979810088],
            [34.04216401094949, 0.300584352953091],
            [34.03958312149381, 0.302972105638159],
            [34.035017751167544, 0.30467438916814],
            [34.02567516980477, 0.310898868789253],
            [34.01906159032507, 0.313920852601116],
            [34.02158032983784, 0.315332220278558],
            [34.02578463940363, 0.319299470073403],
            [34.02811211860921, 0.322397792654652],
            [34.03130280514101, 0.324551338072773],
            [34.03344260831746, 0.327611882815607],
            [34.033104919924064, 0.328821109433254],
            [34.023571298341395, 0.33131607136079],
            [34.01978029824792, 0.331694342002062],
            [34.01829637572166, 0.333034938226779],
            [34.01576683935751, 0.337322968368943],
            [34.01421185649902, 0.338037760697557],
            [34.01288774605845, 0.339295284905801],
            [34.00730126703694, 0.341955383912933],
            [34.00430124882253, 0.342263265208404],
            [34.0033088592669, 0.34180202625777],
            [34.00212562891737, 0.342344908932571],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 894,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "LUMINO",
        Population: 14714,
        Key: "BUSIALUMINO",
        Dist2: "Busia",
        "Sub Country": "Lumino",
        id2_original: "Busia Lumino",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.90033111369594, 0.290113209012868],
            [33.9035167031868, 0.29094576230466],
            [33.90933082428443, 0.29577540039205],
            [33.91241054013256, 0.30066913478257],
            [33.91281566505433, 0.306099436529559],
            [33.913371360194155, 0.306351119317878],
            [33.91500789840234, 0.306709132360886],
            [33.91728461830282, 0.304846529992515],
            [33.92354253769352, 0.295829774691544],
            [33.92518172862676, 0.295354761772294],
            [33.93041143903821, 0.295640839944547],
            [33.93133643698121, 0.295891469264438],
            [33.935883280453034, 0.301506304559104],
            [33.93845336676913, 0.302152907420129],
            [33.94121251072326, 0.303788760699385],
            [33.94105147243722, 0.30776786973618],
            [33.95060370441763, 0.309811449836407],
            [33.95178787979484, 0.312008528688461],
            [33.94934884510231, 0.314694205084397],
            [33.948721279349876, 0.315627709425368],
            [33.94889247848011, 0.315871826490158],
            [33.95379960656798, 0.316316551364906],
            [33.9635721018628, 0.31422504453552],
            [33.96410174406274, 0.317753052293894],
            [33.96608814912463, 0.323885665664011],
            [33.96402047886888, 0.331276496742539],
            [33.96440606363659, 0.334587316573422],
            [33.963098687013115, 0.334958335113782],
            [33.962026121021786, 0.335953509457802],
            [33.956874440072525, 0.336928333617941],
            [33.9503079727379, 0.339021299951127],
            [33.948950660564414, 0.339944137416422],
            [33.947620238560646, 0.340179468519648],
            [33.94611166536466, 0.342033315867118],
            [33.94291929000015, 0.342875678910276],
            [33.94252012899354, 0.343477533964859],
            [33.93899493410447, 0.344495326601577],
            [33.9379229088989, 0.345345769626793],
            [33.936254779637125, 0.349489065804967],
            [33.93427202083694, 0.352311661425622],
            [33.93381500742774, 0.35921391171463],
            [33.930485089213434, 0.368812219495336],
            [33.93057206230259, 0.373416699303395],
            [33.93118051190579, 0.375542478390249],
            [33.932526372356044, 0.377776728868425],
            [33.93257489575443, 0.385031729762693],
            [33.931724261248945, 0.386922468056157],
            [33.92630054168556, 0.392846668087669],
            [33.92043617961071, 0.385129926880101],
            [33.91993500412382, 0.382929424561986],
            [33.91740010661407, 0.379286695635291],
            [33.91589088303782, 0.377893371673498],
            [33.9142880612972, 0.377149651933049],
            [33.9132055797017, 0.376112510056742],
            [33.912882858139284, 0.375242924520287],
            [33.91105104505292, 0.374237292849073],
            [33.910332784491096, 0.372812448661936],
            [33.910145306091295, 0.371418979941258],
            [33.90907324225821, 0.370465652944137],
            [33.90854233073876, 0.369166516679244],
            [33.90835501852729, 0.366091630589096],
            [33.90645998829946, 0.364680616176005],
            [33.90601668048653, 0.362762864874489],
            [33.905484253509194, 0.36260008711802],
            [33.903578480328896, 0.3604382347088],
            [33.9010184964665, 0.35900014292694],
            [33.89916019655402, 0.357390547902992],
            [33.89698451286847, 0.354269364927906],
            [33.89235876767032, 0.351384065977254],
            [33.89054965141793, 0.349810194064661],
            [33.88734885794088, 0.34829977680922],
            [33.88131716488142, 0.343071606048246],
            [33.87948313654958, 0.339263295561086],
            [33.879654814481874, 0.337309283671053],
            [33.88127938982541, 0.335300862262112],
            [33.88399940047084, 0.330180427524259],
            [33.885723567538356, 0.325371298991034],
            [33.88553369333169, 0.321297867858827],
            [33.88336685356013, 0.316334158974432],
            [33.882919778212916, 0.313419244456658],
            [33.887778001118406, 0.311354827142025],
            [33.89237785956504, 0.307536917104413],
            [33.89281691565173, 0.306035203411652],
            [33.893963643858, 0.305003834449171],
            [33.89536630568197, 0.302018458440287],
            [33.8959758682978, 0.297766676356926],
            [33.89680523698553, 0.296120193453025],
            [33.89689101890866, 0.294338078165347],
            [33.90033111369594, 0.290113209012868],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 895,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "LUNYO",
        Population: 14975,
        Key: "BUSIALUNYO",
        Dist2: "Busia",
        "Sub Country": "Lunyo",
        id2_original: "Busia Lunyo",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.0216913292676, 0.385585077668477],
            [34.023222491499716, 0.384236951546115],
            [34.02764806240818, 0.383356205509346],
            [34.03043322516621, 0.380434048107435],
            [34.03392725659978, 0.378678726456122],
            [34.03786846219525, 0.378171680758653],
            [34.03854397372933, 0.377447931055809],
            [34.04254748198133, 0.376723777957859],
            [34.04402814452143, 0.374570689160313],
            [34.04687648669171, 0.3730598214846],
            [34.04791515565413, 0.371776177619986],
            [34.04807629275485, 0.370646736043493],
            [34.049815012529976, 0.368945335383491],
            [34.05084836256761, 0.365314753711918],
            [34.05246586457664, 0.362227971049064],
            [34.054605333579794, 0.360582274018317],
            [34.05632893021712, 0.360432484706423],
            [34.05707191690715, 0.360851237758736],
            [34.05974684829498, 0.363932385873503],
            [34.06212447774795, 0.365906631720708],
            [34.06260004585934, 0.366654502540086],
            [34.06248138649514, 0.368419626111939],
            [34.0631056850749, 0.370364161607694],
            [34.06494856360891, 0.37365481606521],
            [34.06972786502511, 0.373323126482008],
            [34.07339109234582, 0.373603267338692],
            [34.075579488989256, 0.372889385042024],
            [34.07681547919204, 0.372020567229557],
            [34.07930187935457, 0.372228992640707],
            [34.081013689197036, 0.372994652786858],
            [34.08170265839241, 0.369141269153898],
            [34.083215936963825, 0.366834304745604],
            [34.08903737753439, 0.362407707767252],
            [34.09191960685215, 0.359268499464816],
            [34.093240117743385, 0.356500358087651],
            [34.0941309329932, 0.352999569256472],
            [34.09497918247159, 0.345616294153275],
            [34.09551204153857, 0.34490354152687],
            [34.095094828886324, 0.344244718231956],
            [34.09628872942478, 0.344461788606611],
            [34.09769854094011, 0.345989338831771],
            [34.09979875895525, 0.34727063367707],
            [34.09912279736518, 0.348023710754705],
            [34.09968388329503, 0.348950409135241],
            [34.09862658147697, 0.348313383339434],
            [34.09921652039542, 0.349956872740893],
            [34.09849016960614, 0.350326217156272],
            [34.09889298675596, 0.350876435746248],
            [34.098051671373234, 0.352158078465453],
            [34.099267594110906, 0.351967747914569],
            [34.09915928154214, 0.352491002188276],
            [34.09956928611254, 0.352990537765994],
            [34.098699093486715, 0.353345418562036],
            [34.0997995090485, 0.353649381109306],
            [34.09924578930402, 0.35419971538352],
            [34.09933217309837, 0.354873057171572],
            [34.10061241970193, 0.355444890339039],
            [34.10066296251309, 0.357102923719841],
            [34.101377477100186, 0.35689738329131],
            [34.102003094406754, 0.357581415524435],
            [34.10198643694645, 0.358297419020734],
            [34.10290012689665, 0.358615874539739],
            [34.10343219005627, 0.35960774425118],
            [34.10287131433222, 0.360440452605347],
            [34.10346837509425, 0.361454026780332],
            [34.10674640841437, 0.363748448748014],
            [34.10915650837159, 0.369625425877504],
            [34.10952724668263, 0.376027921121846],
            [34.108018975320576, 0.38578836630294],
            [34.10675726635122, 0.391324470751849],
            [34.10292522672399, 0.401064341717936],
            [34.101734274456305, 0.400042646237525],
            [34.100073876095855, 0.399810200243966],
            [34.08951445751043, 0.400209638078405],
            [34.083078954662795, 0.402281972773329],
            [34.08172521508919, 0.403156696453281],
            [34.08102878897866, 0.404134306021555],
            [34.08019231371869, 0.406881988723392],
            [34.077825040044324, 0.411429686415896],
            [34.078101413029664, 0.415804702918456],
            [34.077844759861435, 0.416580185467336],
            [34.06434341172111, 0.420439345585653],
            [34.0556535417522, 0.42199641896637],
            [34.04431953644004, 0.422875442393739],
            [34.04356435422171, 0.423906743962136],
            [34.038495585078245, 0.416942128679633],
            [34.030907957844406, 0.404704071653073],
            [34.02940121810993, 0.40062219367081],
            [34.03170662121741, 0.395492945273164],
            [34.026508221585196, 0.392247690904226],
            [34.0216913292676, 0.385585077668477],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 896,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "MASINYA",
        Population: 19997,
        Key: "BUSIAMASINYA",
        Dist2: "Busia",
        "Sub Country": "Masinya",
        id2_original: "Busia Masinya",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.02861262934281, 0.518113396178466],
            [34.026061987061055, 0.521505186403903],
            [34.02499625545237, 0.521839899177599],
            [34.02411731503232, 0.523220392457913],
            [34.02278646093888, 0.523522961168077],
            [34.019932764809525, 0.525857931430922],
            [34.01918467928193, 0.527622562198306],
            [34.01759949416529, 0.52876281719996],
            [34.01599218174655, 0.530751763916387],
            [34.00866140710695, 0.523299128305623],
            [34.00133135561115, 0.520333243314999],
            [33.99802561016281, 0.519682464051458],
            [33.9937141630247, 0.519972623217106],
            [33.99125554056739, 0.520677415918613],
            [33.9790597849964, 0.519890713710554],
            [33.97390737641179, 0.522460636211023],
            [33.97246947098427, 0.523553737063198],
            [33.97187779382574, 0.526591172813087],
            [33.97434580277945, 0.531203567458083],
            [33.97492417139702, 0.533218906546042],
            [33.97641874884089, 0.533899939239574],
            [33.97698280909262, 0.534581120971501],
            [33.977402134582405, 0.537295549309009],
            [33.97655583983807, 0.538476737837764],
            [33.977617619757815, 0.540402741950661],
            [33.9770140641763, 0.541349467481006],
            [33.976661292170974, 0.544262306426103],
            [33.97615635004806, 0.545447726267579],
            [33.97546302132864, 0.545973783684135],
            [33.974436774269954, 0.548380195012657],
            [33.97409216256066, 0.550487705665082],
            [33.97298764169801, 0.552605559192122],
            [33.97046721245424, 0.550582054957031],
            [33.97011760611195, 0.549846363272957],
            [33.96886522165523, 0.549160346950165],
            [33.96815282529556, 0.547563149053099],
            [33.95597583373424, 0.538061632087435],
            [33.95500208691572, 0.53871310378981],
            [33.952924646582936, 0.542259499226033],
            [33.949716846246666, 0.543408863605455],
            [33.94933813628581, 0.545851369528878],
            [33.948768175899275, 0.546403272062271],
            [33.946522333790085, 0.546937350985185],
            [33.942645691910705, 0.544884499996173],
            [33.94025373432893, 0.541239292231683],
            [33.939729422731894, 0.539185904833639],
            [33.93966715690629, 0.536019772990883],
            [33.93876346071362, 0.53571234431926],
            [33.9369344297097, 0.536861486264845],
            [33.93612567735773, 0.536762103718832],
            [33.93529318702439, 0.535685742773174],
            [33.93614565139809, 0.531461068343087],
            [33.936085352882955, 0.530095111905386],
            [33.93694946840588, 0.530019182360415],
            [33.937428644151474, 0.530895928349085],
            [33.93988389882477, 0.53033060864804],
            [33.93997949843565, 0.529055526153116],
            [33.941341877107334, 0.529055316854548],
            [33.94450254373896, 0.525904665213331],
            [33.94518349097882, 0.524308049614962],
            [33.94697127493814, 0.522089804610771],
            [33.94924878715271, 0.520707244144161],
            [33.950758771602, 0.514814000219953],
            [33.95120065468689, 0.514072153751514],
            [33.95324869405874, 0.512832531131449],
            [33.95663998158001, 0.508709814077016],
            [33.95835103593932, 0.503575617050773],
            [33.963164349368824, 0.495712444037888],
            [33.96498303357727, 0.494958242219171],
            [33.970284837383545, 0.495729461983961],
            [33.97132816141579, 0.495022990368507],
            [33.97206575462086, 0.495004770519626],
            [33.972309048942506, 0.49300313616051],
            [33.97280293100763, 0.492143173888452],
            [33.97694030799988, 0.489770065644692],
            [33.97681429592511, 0.489208653453491],
            [33.97519200409899, 0.487850361186366],
            [33.975693812898164, 0.48358380615933],
            [33.97473500775776, 0.481552080392119],
            [33.97469587894063, 0.480398864763094],
            [33.97407800421347, 0.479656998258412],
            [33.973729160540884, 0.477504185324038],
            [33.97283278112618, 0.476029445230828],
            [33.981294845525596, 0.475974791818424],
            [33.98736389682275, 0.474101393633202],
            [33.9899490981918, 0.474897067076208],
            [33.99298344013491, 0.474697614693908],
            [34.00000857198223, 0.478432570848775],
            [34.00270627117096, 0.480467511603744],
            [34.003783476960734, 0.480765867545079],
            [34.005178984601805, 0.480186719791259],
            [34.0074829486082, 0.478087717828905],
            [34.0095051587207, 0.473338302678891],
            [34.01276634144273, 0.468196851925428],
            [34.01394317938071, 0.468331941456053],
            [34.01578671368487, 0.469510950660897],
            [34.01761746136927, 0.469739990906457],
            [34.01826599739372, 0.469026272821219],
            [34.02018184877318, 0.46958623324182],
            [34.02078290883486, 0.469417370909242],
            [34.02099156232251, 0.470195345080001],
            [34.02198111230354, 0.470265177758301],
            [34.02753475700305, 0.475504553452342],
            [34.02892910132582, 0.475467295312319],
            [34.030200954071404, 0.476619699721392],
            [34.032592977230166, 0.476343537508454],
            [34.03373839209949, 0.477432464525564],
            [34.03669914764779, 0.47738678318594],
            [34.04481822988181, 0.481958153054849],
            [34.046848250845706, 0.483852992910408],
            [34.046005086730126, 0.485002330963809],
            [34.04511744612651, 0.485103581840982],
            [34.04356827985949, 0.486877617943641],
            [34.04391417615963, 0.487997622959209],
            [34.04315398583362, 0.490579571702477],
            [34.04205349391502, 0.492302555189375],
            [34.04111191307186, 0.495965038141895],
            [34.040735481238585, 0.496310072597963],
            [34.0405213785704, 0.498116658540843],
            [34.04094900359511, 0.499280946029686],
            [34.03975272970766, 0.50200612664608],
            [34.04017444830937, 0.50232509088105],
            [34.0401305566246, 0.503978203940917],
            [34.039464886134404, 0.504616114236724],
            [34.03883121722796, 0.50719592395904],
            [34.03816238017643, 0.507145915808104],
            [34.03782604644246, 0.507971150407397],
            [34.03638067242168, 0.508883892630294],
            [34.03411083541292, 0.509441945371547],
            [34.03268502400405, 0.510688947115505],
            [34.03122710411201, 0.511264405662531],
            [34.03082189295199, 0.511913692846435],
            [34.02996541400726, 0.512000966980386],
            [34.02954679549159, 0.514846845792318],
            [34.02999497935989, 0.516648555202689],
            [34.02896358136138, 0.51700749121733],
            [34.02861262934281, 0.518113396178466],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 897,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "BULUMBI",
        Population: 15291,
        Key: "BUSIABULUMBI",
        Dist2: "Busia",
        "Sub Country": "Bulumbi",
        id2_original: "Busia Bulumbi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.096222837100385, 0.481990731102597],
            [34.09660173121588, 0.487825132916102],
            [34.0975492642961, 0.492376570042851],
            [34.0890721836584, 0.493874160663224],
            [34.08863854261624, 0.495822842853359],
            [34.07949985546675, 0.508467603682986],
            [34.07930604753747, 0.509863364331408],
            [34.07844734166917, 0.511297262930749],
            [34.08103981939201, 0.51291327925384],
            [34.08089452048808, 0.514856335211828],
            [34.082544387000134, 0.520844318699206],
            [34.08330606403798, 0.521730666772178],
            [34.08564812290065, 0.522906200915783],
            [34.08776755408306, 0.525963277816229],
            [34.089218933341535, 0.527202282537888],
            [34.090411089351726, 0.52977104954503],
            [34.0918854034977, 0.530485396111729],
            [34.09212420714127, 0.531199963572054],
            [34.09408729822659, 0.532981611564204],
            [34.09446876960862, 0.533813746036435],
            [34.09543817936096, 0.534356312081624],
            [34.096967768643005, 0.536409404673298],
            [34.09818038827534, 0.537169020875302],
            [34.09819591116345, 0.539168111792368],
            [34.097769750392686, 0.539665701609852],
            [34.09660554725918, 0.53957545816397],
            [34.09627434739708, 0.540362492029647],
            [34.095490399326735, 0.540579731830739],
            [34.095361406641814, 0.541547643153119],
            [34.09457737951973, 0.541330689936461],
            [34.09476902520413, 0.542117629255633],
            [34.094174879475204, 0.542244377663763],
            [34.09372703966166, 0.543981231757329],
            [34.09292072174412, 0.544723125849184],
            [34.09311118704224, 0.545184421322602],
            [34.09221118023042, 0.5464690742574],
            [34.09230795753262, 0.547473128497239],
            [34.091215730114655, 0.547907523141821],
            [34.0917860345559, 0.549463276382379],
            [34.09057935368592, 0.55051280074083],
            [34.09000936634993, 0.550702865596847],
            [34.08977059145244, 0.550178259307939],
            [34.08949949876433, 0.551046696049034],
            [34.088383068037636, 0.55119163431151],
            [34.088360770953976, 0.552105254066041],
            [34.087054483986954, 0.552051222011751],
            [34.087268523773076, 0.552440147513893],
            [34.08601192442104, 0.553851511120146],
            [34.085678830012, 0.553489744107615],
            [34.083472610793315, 0.555145518601729],
            [34.08337959833048, 0.556312433654527],
            [34.08228793685115, 0.556792059285451],
            [34.081954852323584, 0.556484566102514],
            [34.08131538748689, 0.557561126330042],
            [34.0798416958734, 0.557271936393747],
            [34.079131511165976, 0.558583699279795],
            [34.077208122022945, 0.559090616939553],
            [34.07665112163103, 0.559678693469881],
            [34.076436494346716, 0.559154080790771],
            [34.07410871869706, 0.559489204694994],
            [34.073798575345236, 0.558729419752988],
            [34.0724687507211, 0.558991992006062],
            [34.07220697985067, 0.558639255642922],
            [34.07061665906556, 0.559381301511826],
            [34.07014028516534, 0.558639637408774],
            [34.06980782496689, 0.558684927414069],
            [34.069642265460025, 0.559309115437253],
            [34.068953131872945, 0.559046915083187],
            [34.06838376796779, 0.559598811000706],
            [34.06724179723924, 0.55913064126796],
            [34.06684933586803, 0.558569418542075],
            [34.067427453855665, 0.558039200542408],
            [34.06834193791658, 0.555158323485028],
            [34.068916437490216, 0.551765085038278],
            [34.06962851854121, 0.551602131911683],
            [34.07003471245819, 0.546192694972292],
            [34.06934376068099, 0.545161603350734],
            [34.06922337116154, 0.543994722048219],
            [34.07010785688188, 0.540611449931552],
            [34.069454223816535, 0.537679809221261],
            [34.06766161231088, 0.53314051935526],
            [34.06793032266688, 0.53277970866532],
            [34.06389772427101, 0.526948062883044],
            [34.06225496522947, 0.525445162149815],
            [34.05616221368016, 0.522169259993315],
            [34.054907931083235, 0.522139409317732],
            [34.04789056966311, 0.525898574892271],
            [34.044456025566, 0.524696604101474],
            [34.038308604345104, 0.524232508953656],
            [34.03649555526842, 0.521856245142835],
            [34.03129881662117, 0.519423106837874],
            [34.030077124902746, 0.519378742665586],
            [34.02861262934281, 0.518113396178466],
            [34.02896358136138, 0.51700749121733],
            [34.02999497935989, 0.516648555202689],
            [34.02954679549159, 0.514846845792318],
            [34.02996541400726, 0.512000966980386],
            [34.03082189295199, 0.511913692846435],
            [34.03122710411201, 0.511264405662531],
            [34.03268502400405, 0.510688947115505],
            [34.03411083541292, 0.509441945371547],
            [34.03638067242168, 0.508883892630294],
            [34.03782604644246, 0.507971150407397],
            [34.03816238017643, 0.507145915808104],
            [34.03883121722796, 0.50719592395904],
            [34.039464886134404, 0.504616114236724],
            [34.0401305566246, 0.503978203940917],
            [34.04017444830937, 0.50232509088105],
            [34.03975272970766, 0.50200612664608],
            [34.04094900359511, 0.499280946029686],
            [34.0405213785704, 0.498116658540843],
            [34.040735481238585, 0.496310072597963],
            [34.04111191307186, 0.495965038141895],
            [34.04205349391502, 0.492302555189375],
            [34.04315398583362, 0.490579571702477],
            [34.04391417615963, 0.487997622959209],
            [34.04356827985949, 0.486877617943641],
            [34.04511744612651, 0.485103581840982],
            [34.046005086730126, 0.485002330963809],
            [34.046848250845706, 0.483852992910408],
            [34.048515044312666, 0.483635632613433],
            [34.04947805267029, 0.482758037637643],
            [34.05391466926347, 0.48247753067534],
            [34.05616378752854, 0.481485288517951],
            [34.06025474767177, 0.482679116254435],
            [34.06428351654958, 0.483153721581567],
            [34.06638490327289, 0.48247495529674],
            [34.06872731158019, 0.482420308223752],
            [34.069729897014305, 0.481715773704366],
            [34.071359281937866, 0.481523590430756],
            [34.07495665556172, 0.479696546101109],
            [34.075703458295095, 0.478945630208313],
            [34.07761001121307, 0.478574452104893],
            [34.07801994930815, 0.478411563579889],
            [34.08309800703163, 0.48237880124064],
            [34.08384561914705, 0.482612818447198],
            [34.08636401909665, 0.482272368125515],
            [34.08920395303584, 0.480616795573519],
            [34.0919405052589, 0.481714923029848],
            [34.096222837100385, 0.481990731102597],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 898,
        District: "BUSIA",
        County: "SAMIA-BUGWE",
        Subcounty: "SIKUDA",
        Population: 18628,
        Key: "BUSIASIKUDA",
        Dist2: "Busia",
        "Sub Country": "Sikuda",
        id2_original: "Busia Sikuda",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.096222837100385, 0.481990731102597],
            [34.0919405052589, 0.481714923029848],
            [34.08920395303584, 0.480616795573519],
            [34.08636401909665, 0.482272368125515],
            [34.08384561914705, 0.482612818447198],
            [34.08309800703163, 0.48237880124064],
            [34.07801994930815, 0.478411563579889],
            [34.07761001121307, 0.478574452104893],
            [34.07651686751349, 0.473165273294827],
            [34.076580224792174, 0.472495878726134],
            [34.078942621512866, 0.47104819031472],
            [34.07790949605407, 0.468732644048457],
            [34.078061872784126, 0.459214726290304],
            [34.07864482909787, 0.457470685005037],
            [34.08244182454752, 0.459419935331253],
            [34.08867042113073, 0.465772593295998],
            [34.09301099524364, 0.475747559126566],
            [34.09610294165435, 0.480272072914774],
            [34.096222837100385, 0.481990731102597],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 899,
        District: "BUSIA",
        County: "BUSIA MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 22863,
        Key: "BUSIAWESTERN DIVISION",
        Dist2: "Busia",
        "Sub Country": "Western Division",
        id2_original: "Busia Western Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.09873583188688, 0.637476357121277],
            [34.09314441033469, 0.64238936814698],
            [34.09287626681566, 0.644063771723638],
            [34.0934917502275, 0.646497209188488],
            [34.09241065113927, 0.648290602724562],
            [34.08983063664266, 0.648893939085662],
            [34.088853924485385, 0.653751691793828],
            [34.08648088722017, 0.65523570793558],
            [34.085245910317006, 0.655245023754162],
            [34.08393717903409, 0.654404058842959],
            [34.083486836514155, 0.654720757194777],
            [34.082155758740235, 0.654431585020968],
            [34.08146728721155, 0.654721198238789],
            [34.08023107063329, 0.654196815749525],
            [34.07902157803645, 0.655201154701016],
            [34.07626383725079, 0.654116265474977],
            [34.073127142162505, 0.653664657894389],
            [34.06834181933896, 0.654470761587929],
            [34.05942053526799, 0.654192255300111],
            [34.05590228884764, 0.652790907236969],
            [34.0506813432984, 0.649255099739392],
            [34.04528050472366, 0.64485091381508],
            [34.0334058402729, 0.640059057866911],
            [34.01821096929435, 0.638623831640379],
            [34.010736622312784, 0.637069423910233],
            [34.00625997589221, 0.635586043825671],
            [34.00758178305239, 0.633692672159949],
            [34.00984245455034, 0.628267162489847],
            [34.00955604828154, 0.622523040757479],
            [34.01120428704631, 0.620492461035731],
            [34.01216989423007, 0.618248849387125],
            [34.01707085807846, 0.615707470560611],
            [34.01841524080006, 0.613359261260557],
            [34.020780544469034, 0.611653508314381],
            [34.02558637403388, 0.609380818824498],
            [34.02623038704084, 0.608487192911472],
            [34.02714766845558, 0.608010774891335],
            [34.02854139294078, 0.608274410186224],
            [34.02949900781343, 0.607852434176423],
            [34.03045201343037, 0.605158761244537],
            [34.034164360630804, 0.600975112023595],
            [34.03481384617449, 0.597757957496885],
            [34.03458132714464, 0.594476308214985],
            [34.03526421654216, 0.591779728194089],
            [34.0350298676441, 0.591023078911858],
            [34.034006180784004, 0.590292737090099],
            [34.03535838064521, 0.589499690695045],
            [34.03641690686697, 0.589739825502488],
            [34.03736352815721, 0.588993060481733],
            [34.03791988805032, 0.589735571306663],
            [34.038420785059465, 0.589211276678863],
            [34.0391450688253, 0.589751309855026],
            [34.04014860377865, 0.58911961294205],
            [34.040720667121256, 0.589878544083242],
            [34.04157663492453, 0.589131257187531],
            [34.04318950611825, 0.589996780361474],
            [34.04473487969816, 0.59023728164067],
            [34.045683270669485, 0.589499800283723],
            [34.04618041721235, 0.590027875692889],
            [34.047407274243646, 0.590118979794006],
            [34.04818432594755, 0.58969788448518],
            [34.04850372554007, 0.589002865075],
            [34.048985046462576, 0.589280756793292],
            [34.04909542156321, 0.588859789873382],
            [34.04968711938297, 0.588720685012064],
            [34.050049864484606, 0.587771500550644],
            [34.05003364360552, 0.585416586251342],
            [34.05173389033365, 0.585579082103241],
            [34.05307499420448, 0.584871956216575],
            [34.05375845582884, 0.583988977991867],
            [34.05587289776817, 0.583934302177068],
            [34.05657877325718, 0.583423487324377],
            [34.0573925651579, 0.583716913977957],
            [34.05972198292788, 0.582688673826387],
            [34.06045657396328, 0.58330899758614],
            [34.0613399906884, 0.583267464334661],
            [34.06150447311525, 0.583934431527766],
            [34.06241221531997, 0.583346955727805],
            [34.06347994747679, 0.583823123467468],
            [34.06381972355491, 0.584604540785022],
            [34.06436785308338, 0.583940175955656],
            [34.064586359293095, 0.584858376193637],
            [34.06548879155615, 0.584819129046928],
            [34.06515416282463, 0.585595790793108],
            [34.06554241199546, 0.586137870573951],
            [34.06493601144944, 0.586548265082107],
            [34.06551342156463, 0.586772830334244],
            [34.06524100026818, 0.587389797712953],
            [34.065494008073024, 0.588331467329828],
            [34.06376394176901, 0.589141867526754],
            [34.064582646556026, 0.590057950592075],
            [34.066537326715356, 0.589953034726368],
            [34.066048971085884, 0.591619582390383],
            [34.066824963676076, 0.592769345673478],
            [34.067570216815554, 0.592892186407722],
            [34.06915827474451, 0.592190858865932],
            [34.069927992602445, 0.592479724555855],
            [34.07126561819647, 0.591852239030485],
            [34.071833751409706, 0.592110396571712],
            [34.071699283493125, 0.591679974703578],
            [34.07281710481186, 0.591575218760093],
            [34.073299589052674, 0.591156974662559],
            [34.07324447381672, 0.590431373016455],
            [34.073690426269835, 0.59062806127699],
            [34.0739041220012, 0.590111481954032],
            [34.07432565285502, 0.590369668320728],
            [34.07474705974131, 0.58998833305241],
            [34.07560844079254, 0.590473956289549],
            [34.07557166286647, 0.589815992314972],
            [34.07773389428062, 0.589046913433794],
            [34.07889411158921, 0.587072776442693],
            [34.079944745212906, 0.587011079794215],
            [34.08042106072265, 0.58628537520603],
            [34.08094650509525, 0.586918645307202],
            [34.08151450625615, 0.586500384691364],
            [34.08318830029412, 0.586979698796697],
            [34.0835729615937, 0.586112580728773],
            [34.08511854088781, 0.586911679237674],
            [34.08528968611913, 0.587483524799914],
            [34.08619363384008, 0.586991407721938],
            [34.086371084346354, 0.588571726148567],
            [34.08751333445093, 0.588473113400735],
            [34.08821565889962, 0.587753514530112],
            [34.08830687203693, 0.58562586391963],
            [34.089455046530794, 0.584586418217534],
            [34.09073175197553, 0.584862882806641],
            [34.091104146779955, 0.583743650944745],
            [34.092667810059034, 0.583325196964437],
            [34.09492175856537, 0.583115680270919],
            [34.095398416333204, 0.584167101962102],
            [34.09645516928063, 0.584191490852628],
            [34.096589678519685, 0.584837131245692],
            [34.09836114907345, 0.584731131970157],
            [34.09819830966527, 0.585308102376333],
            [34.099055732739345, 0.586500267018243],
            [34.10010680653752, 0.590245783743672],
            [34.10084271719805, 0.591713937295064],
            [34.102260894723614, 0.593278506859018],
            [34.102488176575335, 0.60086776835299],
            [34.10343291050514, 0.604250651003897],
            [34.10457674074631, 0.606276641364474],
            [34.10529577745253, 0.609949026768448],
            [34.10530020524856, 0.612364214820894],
            [34.10672010664115, 0.615927902601909],
            [34.10651304856144, 0.619464793719609],
            [34.108061324598005, 0.621870606786907],
            [34.10404517794828, 0.626818588424288],
            [34.10079074606561, 0.629123741680103],
            [34.09727310151651, 0.633273684894378],
            [34.09700635218277, 0.636654333569522],
            [34.09873583188688, 0.637476357121277],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 900,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "MAGOLA",
        Population: 17824,
        Key: "TOROROMAGOLA",
        Dist2: "Tororo",
        "Sub Country": "Magola",
        id2_original: "Tororo Magola",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.02813371949855, 0.780354523716982],
            [34.02507833092665, 0.782732428700417],
            [34.023684789697754, 0.786839604404369],
            [34.02292629359433, 0.78796148256731],
            [34.01814783839113, 0.79237706468012],
            [34.01634401860566, 0.793046909306119],
            [34.00809036425051, 0.793872127692301],
            [34.003961156537436, 0.796089398336759],
            [34.00145838817213, 0.798016799693488],
            [34.00072905228115, 0.791336239458074],
            [33.99935991378694, 0.788976537514677],
            [33.99851318066476, 0.785494600009051],
            [33.99919775620006, 0.776572759740752],
            [33.99899962467931, 0.761267166426021],
            [34.00002645923617, 0.759357770482056],
            [33.99858526417808, 0.755683119777319],
            [33.99298261009159, 0.750837625266119],
            [33.990910888433895, 0.747577244122572],
            [33.990658693604395, 0.742821850267083],
            [33.98935125679382, 0.736472099721401],
            [33.996634770167994, 0.734887154860322],
            [34.000776367445475, 0.734523440736923],
            [34.00758855814627, 0.735146063053852],
            [34.01469533068327, 0.73708930806818],
            [34.01900079234665, 0.739571442642054],
            [34.02790008745607, 0.748795263877164],
            [34.02882395531846, 0.749163057524976],
            [34.029610278534406, 0.748986511439957],
            [34.03300716076327, 0.753941490585695],
            [34.03799939254623, 0.7565451983077],
            [34.04368495304861, 0.761213287536105],
            [34.04397769783002, 0.773003778520311],
            [34.03875437893179, 0.774159254298869],
            [34.035734410931546, 0.775653644752112],
            [34.03263740790411, 0.77791838407941],
            [34.031219877165555, 0.77801081399777],
            [34.02813371949855, 0.780354523716982],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 901,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "NAGONGERA TOWN COUNCIL",
        Population: 12341,
        Key: "TORORONAGONGERA TOWN COUNCIL",
        Dist2: "Tororo",
        "Sub Country": "Nagongera SC",
        id2_original: "Tororo Nagongera SC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.06216431803079, 0.877962195452197],
            [34.047212238317364, 0.880579179151435],
            [34.045614564821605, 0.881039117918494],
            [34.042748595010515, 0.882692491427061],
            [34.04035731835174, 0.882051906903717],
            [34.0418109712462, 0.880715935989492],
            [34.04205770252212, 0.879880982218459],
            [34.04510897681005, 0.878627629648514],
            [34.04628323209154, 0.876188965369236],
            [34.04923643011336, 0.875353751902552],
            [34.05309815367081, 0.871529101604792],
            [34.05339529031566, 0.869301310420021],
            [34.051117595743094, 0.868362262105456],
            [34.05025606826651, 0.866010858823654],
            [34.05054770183192, 0.857290648092004],
            [34.05101735813044, 0.855020335138625],
            [34.05264442270566, 0.851239323082796],
            [34.054033217236594, 0.848860526235186],
            [34.0554083807314, 0.848235370956132],
            [34.056733420928296, 0.84484133227791],
            [34.05585946795469, 0.839903163057664],
            [34.05364408232686, 0.836755829280639],
            [34.05440196218597, 0.835516349963641],
            [34.054824772240764, 0.833028642389277],
            [34.05441765755063, 0.831192455928928],
            [34.05455023002194, 0.828853508142443],
            [34.053552910512046, 0.827741299845744],
            [34.051818531396364, 0.826868938904327],
            [34.04670438385632, 0.821543047202856],
            [34.04248699032842, 0.815313971359144],
            [34.04164918646015, 0.812876289478188],
            [34.042096662456004, 0.808933394718245],
            [34.043061429714946, 0.805577714435033],
            [34.04304571907894, 0.802070552548597],
            [34.041795274084926, 0.79951294212746],
            [34.04116664293056, 0.796533444794197],
            [34.046956040594964, 0.794165720136507],
            [34.0482609935638, 0.796548643718228],
            [34.04959343587864, 0.797525248798233],
            [34.05084348830889, 0.79916221827888],
            [34.053933270678066, 0.800093135284679],
            [34.05559628493263, 0.800165069849355],
            [34.057220536882674, 0.800129738961509],
            [34.05932555369805, 0.799309055184497],
            [34.06126302662812, 0.800177236343309],
            [34.062319688845704, 0.80010604730784],
            [34.06290102819194, 0.800744113183089],
            [34.065824588097556, 0.801044726581465],
            [34.06607134003474, 0.801789249316636],
            [34.0675331442421, 0.802600667383916],
            [34.07066150026957, 0.802377333975797],
            [34.07422591290903, 0.799782391603809],
            [34.07806691862108, 0.799354096820844],
            [34.07968389331901, 0.799538215563753],
            [34.08338038974626, 0.803648113282945],
            [34.08597038272903, 0.807876441557865],
            [34.083931470240465, 0.811550727608643],
            [34.08190488623086, 0.818741408030147],
            [34.08061209914589, 0.827027559471013],
            [34.08066377652924, 0.828239008861991],
            [34.08156689061362, 0.830732244412468],
            [34.07896493207125, 0.832342199889785],
            [34.07802026731176, 0.833968890347312],
            [34.07681584390804, 0.834817949896057],
            [34.073777863788024, 0.839349994990838],
            [34.07560283440685, 0.840485698304503],
            [34.07688949048997, 0.842348760493143],
            [34.078006747666706, 0.842945465663069],
            [34.08033593726463, 0.843279505761945],
            [34.08260369736846, 0.842853720770455],
            [34.08533283220222, 0.841396595187352],
            [34.08680478018574, 0.841061490538203],
            [34.09161087205867, 0.84163151163392],
            [34.093904678814155, 0.843448192893164],
            [34.0951493772853, 0.845093259859171],
            [34.09600392215722, 0.84742607480172],
            [34.09538832915089, 0.855355983795718],
            [34.096063682581494, 0.859405131209749],
            [34.09411633986142, 0.862894024536085],
            [34.09205707604008, 0.86484124382468],
            [34.08880368710144, 0.869923003239101],
            [34.08677920425128, 0.870469474326611],
            [34.086132433416395, 0.871289068982087],
            [34.084155901737766, 0.871351498268024],
            [34.08095076131307, 0.872589510028505],
            [34.079670460810576, 0.87206412026621],
            [34.07896387295754, 0.872260197078889],
            [34.07779656883968, 0.872940930617316],
            [34.07666028893848, 0.874673175988191],
            [34.0735266373424, 0.875251388245688],
            [34.06934819746019, 0.875211358597577],
            [34.06561052226032, 0.876562919917544],
            [34.061790515566344, 0.87652277890537],
            [34.06216431803079, 0.877962195452197],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 902,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "SOP-SOP",
        Population: 14372,
        Key: "TOROROSOP-SOP",
        Dist2: "Tororo",
        "Sub Country": "Sopsop",
        id2_original: "Tororo Sopsop",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.403870556793954, 0.89124713961146],
            [34.402935940589195, 0.890243710659238],
            [34.40148657804856, 0.890388981243186],
            [34.40072650989338, 0.891185199283357],
            [34.39711636402283, 0.893221625346841],
            [34.396500469182584, 0.895103144838134],
            [34.39119796379208, 0.897773352117701],
            [34.38508662969278, 0.891127859568617],
            [34.38247406474187, 0.890954595504591],
            [34.37945006779758, 0.893158387144122],
            [34.3781455945291, 0.89379493949272],
            [34.37685258106869, 0.893789540376532],
            [34.37548975593431, 0.894850155323931],
            [34.37514414260349, 0.893725402181198],
            [34.37385098451431, 0.893337187646747],
            [34.37377472113996, 0.89278949835509],
            [34.37317803677204, 0.893031191272276],
            [34.37253412168146, 0.892136238295364],
            [34.371814471425864, 0.892112951396448],
            [34.36930919586259, 0.888986592711513],
            [34.367103276681235, 0.888475034957618],
            [34.36699767343139, 0.887691776568399],
            [34.365482098766094, 0.887062169005519],
            [34.36518350685048, 0.886508670970757],
            [34.3628314317724, 0.885904847162859],
            [34.36250970913655, 0.885523230939769],
            [34.36100494479739, 0.88552989743954],
            [34.36047046606795, 0.884920614163085],
            [34.36061887224447, 0.884436652398041],
            [34.36204336762142, 0.884240578020593],
            [34.362464026211086, 0.883588608073558],
            [34.36288437488201, 0.882089270594743],
            [34.362106480558325, 0.879743016359951],
            [34.3623005274395, 0.87915630863247],
            [34.36864795137184, 0.879538019820787],
            [34.369786799556444, 0.876879137484889],
            [34.37025367467085, 0.872808836108848],
            [34.37097837884823, 0.870456939783508],
            [34.37282164006454, 0.867815203282233],
            [34.373004827212235, 0.866967375259384],
            [34.37426492640063, 0.865691363663998],
            [34.374561539327644, 0.864648226838826],
            [34.376649957971516, 0.86379526661577],
            [34.37686052037917, 0.862044966657619],
            [34.3773317110002, 0.861760367664279],
            [34.37801150659988, 0.859503610518766],
            [34.37949065727536, 0.858244585249897],
            [34.380262131339684, 0.859002936903296],
            [34.38243823453845, 0.859029276140139],
            [34.38640738492579, 0.860465926562611],
            [34.388355440009896, 0.860365720012858],
            [34.39211613723387, 0.858921676350431],
            [34.39376305996673, 0.859556281799667],
            [34.394232103614236, 0.860318362577269],
            [34.3958671182797, 0.861261501551096],
            [34.39605361751584, 0.861793799177233],
            [34.39905834200404, 0.861290567749435],
            [34.39966581783346, 0.862615209202801],
            [34.400527339920195, 0.862149074104813],
            [34.40160131357157, 0.860276124961058],
            [34.40227600404552, 0.859823914590781],
            [34.40273367052995, 0.861143867877706],
            [34.40310686573325, 0.865333830960489],
            [34.404893653460924, 0.869274754785351],
            [34.406491936912744, 0.870478641474323],
            [34.40743712628837, 0.870442713907893],
            [34.40982095232019, 0.869219805773825],
            [34.41141169082196, 0.869196366933929],
            [34.40984174921733, 0.872110458085285],
            [34.4094267401325, 0.882157652130408],
            [34.40852110717206, 0.886724829152623],
            [34.4067072020009, 0.88888599261036],
            [34.40513712475071, 0.88983509478321],
            [34.403870556793954, 0.89124713961146],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 903,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUMBO",
        Population: 16595,
        Key: "NAMISINDWABUMBO",
        Dist2: "Manafwa",
        "Sub Country": "Bumbo",
        id2_original: "Manafwa Bumbo",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.38930392620264, 0.801663786718028],
            [34.38645150118938, 0.805243421466792],
            [34.38472038295819, 0.815945295469645],
            [34.38367735716662, 0.815503937717591],
            [34.38199518005043, 0.815782017170444],
            [34.38096301578896, 0.815248728833993],
            [34.379726071575355, 0.815313194395092],
            [34.37817757724816, 0.81379105865712],
            [34.37672147644457, 0.81374886904391],
            [34.37508126502515, 0.812731945635828],
            [34.374345501688346, 0.810811067854147],
            [34.374564316020205, 0.80990734976802],
            [34.37414697131562, 0.808989618260657],
            [34.373291204734926, 0.80753127305728],
            [34.37269033242117, 0.80735359585398],
            [34.37186297506134, 0.80629369699863],
            [34.372110167173005, 0.805695926429405],
            [34.37164961440156, 0.802387464182123],
            [34.371176068397844, 0.802494354115343],
            [34.36871583705786, 0.801193083220589],
            [34.36677191422407, 0.800845087432676],
            [34.36659501528338, 0.800275921024543],
            [34.36609324690838, 0.800539357715233],
            [34.36446031543608, 0.800141448257665],
            [34.362820178576825, 0.799330849785523],
            [34.358706172154996, 0.798741653581395],
            [34.3575400053043, 0.799112041471453],
            [34.3571439066545, 0.79830102332359],
            [34.35568048727629, 0.797518821975014],
            [34.35506508201786, 0.79613864641271],
            [34.35433591501013, 0.79569827366799],
            [34.35465259180906, 0.794356055753848],
            [34.35435298479718, 0.793669699194302],
            [34.35511761639398, 0.792271422124853],
            [34.3544185896607, 0.790831770326579],
            [34.35503332208098, 0.788788943947107],
            [34.354584075505706, 0.788253322982461],
            [34.35292903020603, 0.787860409197611],
            [34.352371684861026, 0.787358307379975],
            [34.35224671752691, 0.786663520667697],
            [34.35309467145959, 0.785750758377945],
            [34.35282805687314, 0.784210506031536],
            [34.352428690152344, 0.783616265907268],
            [34.351422397371074, 0.783499393442214],
            [34.35031609694584, 0.782721212484168],
            [34.35044883919874, 0.781733340999408],
            [34.34991624243984, 0.780603371690439],
            [34.348909688248824, 0.779674469544616],
            [34.347403683336246, 0.777230497823637],
            [34.34731204349917, 0.776719870505353],
            [34.34845125370483, 0.776393017969635],
            [34.34875842992129, 0.77475211876563],
            [34.34859197389576, 0.774333600477716],
            [34.34791028644409, 0.775078876215378],
            [34.34685408596058, 0.774928529958059],
            [34.34786804765943, 0.773002776091688],
            [34.34867453356196, 0.772433260066083],
            [34.348532985124315, 0.771880790644611],
            [34.34795088310842, 0.771973062605576],
            [34.347588365280544, 0.771604998736234],
            [34.348319807720884, 0.771260177535467],
            [34.34885214217173, 0.771948880356571],
            [34.350167875822294, 0.772394368345284],
            [34.35017131996307, 0.771481280498487],
            [34.35153015567929, 0.771849085687211],
            [34.35480729607403, 0.77120173304824],
            [34.354990453577294, 0.771998274230337],
            [34.354531711809464, 0.773208353896517],
            [34.35807804765046, 0.773943688185481],
            [34.35946718623615, 0.775698011172895],
            [34.360691311490676, 0.775040042904035],
            [34.36132178868294, 0.77393136442415],
            [34.36181078481121, 0.773957508403469],
            [34.363271322394, 0.77659481764293],
            [34.36458532768595, 0.777462388248621],
            [34.3644027127651, 0.778356740373194],
            [34.36480605453102, 0.778857668381223],
            [34.36709438066498, 0.779505664780256],
            [34.36762028497503, 0.778235446661953],
            [34.36830360017401, 0.778937880523719],
            [34.368143359591926, 0.779760832764903],
            [34.368624890720184, 0.779790734013005],
            [34.369028218113094, 0.780384291124312],
            [34.37020025635248, 0.780271179466591],
            [34.371716185852335, 0.781638418569807],
            [34.37222810519003, 0.783284045178446],
            [34.373109019208776, 0.783261208544748],
            [34.37348255846684, 0.784076466588944],
            [34.37252075295339, 0.787853094907799],
            [34.37479792829971, 0.788502387857886],
            [34.37518274051627, 0.789539334334843],
            [34.37629543155643, 0.790568521644372],
            [34.376983260789714, 0.793611878390271],
            [34.3782038403938, 0.793551347628129],
            [34.37960789280983, 0.795200422319586],
            [34.379730502964634, 0.793490713568775],
            [34.38072808657924, 0.792055009014302],
            [34.38080100822075, 0.79112687919794],
            [34.381565771869894, 0.789792706145839],
            [34.38298417397426, 0.789705807787586],
            [34.38379803953684, 0.790115101518126],
            [34.384624441987526, 0.794537404582162],
            [34.384394467884896, 0.798877398284933],
            [34.385234449269426, 0.799234074714059],
            [34.38576875192904, 0.800793256110653],
            [34.38930392620264, 0.801663786718028],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 904,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "LWAKHAKHA TOWN COUNCIL",
        Population: 9148,
        Key: "NAMISINDWALWAKHAKHA TOWN COUNCIL",
        Dist2: "Manafwa",
        "Sub Country": "Lwakhakha T/Council",
        id2_original: "Manafwa Lwakhakha T/Council",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.42130171629866, 0.847311247633075],
            [34.41974404118926, 0.8495527036371],
            [34.41881294458379, 0.849334002275711],
            [34.41709171949881, 0.850238555675265],
            [34.41537299801854, 0.850461011529689],
            [34.40921511052626, 0.853657500725307],
            [34.40869482517833, 0.854520020223262],
            [34.40670373091065, 0.85565204179611],
            [34.40459988639672, 0.858241419941967],
            [34.40373784328713, 0.853638083999072],
            [34.402866181017494, 0.851314120235049],
            [34.40224097334267, 0.851111421592856],
            [34.40167341684787, 0.851545951606831],
            [34.399947601371785, 0.851649451247052],
            [34.39684584266325, 0.849008121200092],
            [34.39443240097316, 0.848669419849483],
            [34.391426959629335, 0.847374875532427],
            [34.389184027163346, 0.844920245186863],
            [34.389157424454496, 0.843086508352424],
            [34.387833016671564, 0.840349425960428],
            [34.38833086839192, 0.839267806164741],
            [34.38964545399556, 0.839020650444406],
            [34.390691217852094, 0.838209702345718],
            [34.392481284430545, 0.835349332280931],
            [34.39425321222679, 0.834401769548858],
            [34.39461341240122, 0.83347449558736],
            [34.39811916415428, 0.831820475665427],
            [34.39852129678785, 0.82461243459217],
            [34.39941635028918, 0.823473146394487],
            [34.39908956744331, 0.821949976306646],
            [34.397950642901925, 0.820462029460174],
            [34.39720811704763, 0.821077197320916],
            [34.39638206134667, 0.82102857471075],
            [34.39597239364448, 0.820686329256142],
            [34.39074516887143, 0.819919534956696],
            [34.38741252247358, 0.817845390397875],
            [34.385384954808764, 0.815980411544373],
            [34.38472038295819, 0.815945295469645],
            [34.38645150118938, 0.805243421466792],
            [34.38930392620264, 0.801663786718028],
            [34.39045579277231, 0.802855249202363],
            [34.39203904651112, 0.80293641210353],
            [34.39230923729071, 0.802540840964194],
            [34.39193505753382, 0.800778525178864],
            [34.393173009657204, 0.801109259735068],
            [34.393986962356344, 0.800749755848582],
            [34.39458405276278, 0.802147156962044],
            [34.39499113421523, 0.802276112751506],
            [34.395332915333064, 0.801719321420323],
            [34.39502379606066, 0.799941146172821],
            [34.39550321255476, 0.799626660463422],
            [34.39893458470061, 0.800703481859355],
            [34.40169207305969, 0.803017951360236],
            [34.406195818957436, 0.804771040494226],
            [34.41218281993319, 0.806328232004673],
            [34.412723939907515, 0.807096999595084],
            [34.4140501901351, 0.80759924631406],
            [34.41471522821129, 0.809178657947464],
            [34.413586639685576, 0.81090266258542],
            [34.41260825486523, 0.811149503877251],
            [34.41099198085321, 0.813204370592871],
            [34.41194033589192, 0.814534275733206],
            [34.41400365470846, 0.815285663819097],
            [34.41422163001383, 0.817185240783936],
            [34.41264374820042, 0.81801004109911],
            [34.41118372265735, 0.81938964514899],
            [34.410208003138465, 0.819535925322043],
            [34.40899929836411, 0.821421143078182],
            [34.408866698943314, 0.82239377112547],
            [34.40928506772735, 0.822831996914511],
            [34.40897806398742, 0.82490784999851],
            [34.40819924619566, 0.825071042594189],
            [34.40664681545088, 0.824594364156898],
            [34.40635731987584, 0.825868582939653],
            [34.408889249351915, 0.827259660850644],
            [34.4087725761628, 0.828444011729891],
            [34.40946824409523, 0.829488743660949],
            [34.41089743676283, 0.829739812631184],
            [34.41432154243636, 0.831242814675436],
            [34.416004163320316, 0.832380645523314],
            [34.41575529225738, 0.833358329660374],
            [34.41436616984134, 0.834172062345248],
            [34.41531838314421, 0.836758460165519],
            [34.41493770766951, 0.839644264962774],
            [34.41615948742282, 0.840369996066015],
            [34.417236432701195, 0.840157083207315],
            [34.4178195165757, 0.839439941731648],
            [34.41852935094018, 0.841315740258694],
            [34.41962228982385, 0.841704253847875],
            [34.420502160898565, 0.84298825497508],
            [34.421405186948036, 0.843087411959736],
            [34.42165672780398, 0.846062970936144],
            [34.42130171629866, 0.847311247633075],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 905,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUKIABI",
        Population: 11262,
        Key: "NAMISINDWABUKIABI",
        Dist2: "Manafwa",
        "Sub Country": "Bukiabi",
        id2_original: "Manafwa Bukiabi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32096062490126, 0.867158750194866],
            [34.320346853678316, 0.866958817091163],
            [34.31970256488858, 0.867286105932708],
            [34.3179748701369, 0.86653447276376],
            [34.3177488809609, 0.866779846460076],
            [34.31735719573407, 0.866678286470553],
            [34.31739237735386, 0.86619076453042],
            [34.3168609358284, 0.86259828236979],
            [34.31614807324313, 0.862001565873919],
            [34.3159095893998, 0.860925301908873],
            [34.31466698579991, 0.860092583902151],
            [34.31227740695701, 0.859489957662757],
            [34.31144641860682, 0.858679892310291],
            [34.31138617129565, 0.857817831837636],
            [34.30881723392481, 0.858637697790245],
            [34.30782422902325, 0.859888062349079],
            [34.30778161204785, 0.860491530152109],
            [34.30701935290171, 0.86031937845732],
            [34.30605185656093, 0.86104386434212],
            [34.304364631811154, 0.860742718377251],
            [34.30318299417461, 0.861355201416713],
            [34.300994968535406, 0.860424185660348],
            [34.30071997266737, 0.859505312634696],
            [34.3000009862668, 0.859627544317003],
            [34.299928109541035, 0.859131491132105],
            [34.29878905564227, 0.859367723281425],
            [34.29730348919902, 0.858885401963872],
            [34.29637380923677, 0.859517863381835],
            [34.295238227326514, 0.858363380403918],
            [34.29522629680123, 0.858801020113555],
            [34.29440509829101, 0.858813455891562],
            [34.29409092869005, 0.858278675184874],
            [34.293390570653514, 0.858534204625942],
            [34.29186830084442, 0.856662613606903],
            [34.291095597884805, 0.857258549490278],
            [34.29051574255541, 0.856711700151412],
            [34.29034678382353, 0.857052141534545],
            [34.28987570818682, 0.85678485615864],
            [34.288488037448325, 0.857319340663197],
            [34.28819005459047, 0.856860579262447],
            [34.28737066708386, 0.856841243391747],
            [34.285334532186155, 0.855619366526562],
            [34.285125613695456, 0.854341714586112],
            [34.2847051671082, 0.854056149438037],
            [34.28412951499602, 0.854272798109155],
            [34.28383200644867, 0.853683939700824],
            [34.28285820842617, 0.853188800130272],
            [34.28283646829798, 0.852635474973936],
            [34.28196166102654, 0.852659524702391],
            [34.28006618343768, 0.850793745872667],
            [34.279945021367105, 0.849840468851076],
            [34.27733387485602, 0.848206645981409],
            [34.27628348287914, 0.845508252522503],
            [34.27665752788872, 0.84429119549856],
            [34.27512819103327, 0.842250260985413],
            [34.27305930805187, 0.840842774327156],
            [34.27597535355017, 0.840518244358344],
            [34.282864913451434, 0.84129957412313],
            [34.28634161907812, 0.839951436028557],
            [34.28807995078106, 0.841732229756577],
            [34.2903120585479, 0.842124661332302],
            [34.29596325849067, 0.840742620262784],
            [34.29788739054044, 0.84189860134798],
            [34.299912945080735, 0.841308276063431],
            [34.30137748914968, 0.841750019869097],
            [34.30542967171703, 0.843812390613896],
            [34.308177577746974, 0.844981875489511],
            [34.3090495625118, 0.846184076680797],
            [34.3106818220443, 0.847455803988867],
            [34.31194835406845, 0.847925575954739],
            [34.312156235903295, 0.850599323368059],
            [34.31268523850273, 0.850784335261035],
            [34.315950930767485, 0.850898959329664],
            [34.319584361868536, 0.850411561127779],
            [34.32496527131871, 0.849125842372393],
            [34.32431836124498, 0.853790155487391],
            [34.321990601765, 0.85373436731924],
            [34.321851872240714, 0.856602945192175],
            [34.31922642994022, 0.859961262308046],
            [34.32096062490126, 0.867158750194866],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 906,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "SISUNI",
        Population: 3990,
        Key: "MANAFWASISUNI",
        Dist2: "Manafwa",
        "Sub Country": "Sisuni",
        id2_original: "Manafwa Sisuni",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.36047046606795, 0.884920614163085],
            [34.36021087361208, 0.884776323309452],
            [34.359932710284355, 0.885584529144082],
            [34.35905269008933, 0.885009342755268],
            [34.357980492407236, 0.885460010569314],
            [34.35780014842742, 0.886441132932335],
            [34.35719291424482, 0.886560634983874],
            [34.35583968042272, 0.888067012600917],
            [34.35503178686014, 0.890318672307621],
            [34.35368225679197, 0.892154166494845],
            [34.35148749468644, 0.892584780981911],
            [34.35121199576183, 0.892196757644985],
            [34.34839928167406, 0.892813490341598],
            [34.34821069834646, 0.891919529829837],
            [34.34697449075138, 0.891132608387109],
            [34.34740798896139, 0.890444854197716],
            [34.346699854209454, 0.889779419424973],
            [34.34697173202512, 0.888717464687715],
            [34.345142344390055, 0.887696730182602],
            [34.344368515841374, 0.885043044422085],
            [34.34235776014706, 0.883023326819959],
            [34.341745949946414, 0.883193360399174],
            [34.341614991747655, 0.88290585730063],
            [34.34159844927171, 0.882225902526354],
            [34.34018610989718, 0.881077800190602],
            [34.34041635079945, 0.880155437264153],
            [34.33981464395079, 0.880073878062897],
            [34.33946344220056, 0.879355658149531],
            [34.33908339105498, 0.879530535041506],
            [34.3382133709057, 0.878977426606488],
            [34.33814028666911, 0.878213975333516],
            [34.33701189038287, 0.878739656152292],
            [34.33701176372041, 0.878385402255401],
            [34.335901257383036, 0.878031549824748],
            [34.335682627205784, 0.877488032253514],
            [34.33537781355854, 0.877660506521448],
            [34.33415939619933, 0.876786180824163],
            [34.333898582034685, 0.877055019589748],
            [34.33285031816673, 0.876657436774862],
            [34.332490152128294, 0.874991078757945],
            [34.33181644081803, 0.874423291093349],
            [34.330463384862355, 0.874515393614371],
            [34.32985032420682, 0.873874290320092],
            [34.32938926119229, 0.874100444523586],
            [34.327726511042435, 0.873508577486881],
            [34.32676151111981, 0.872824843128044],
            [34.326773452424895, 0.872275132534474],
            [34.32578395724112, 0.870950081282673],
            [34.32540775986812, 0.870944107277976],
            [34.32514060000431, 0.870119050522169],
            [34.32599580064637, 0.869920206207728],
            [34.32640158762649, 0.869373823963613],
            [34.325364656005824, 0.868754392752025],
            [34.32535028924951, 0.867396847432523],
            [34.323807509105826, 0.865913616521964],
            [34.32377105906486, 0.863640150582594],
            [34.32829923464677, 0.861496702419178],
            [34.330034279414065, 0.860215766774332],
            [34.32980721315801, 0.856709910907394],
            [34.331042394877045, 0.8536582381603],
            [34.33056639198102, 0.85212680095078],
            [34.32963945547365, 0.850978837697576],
            [34.329959265596244, 0.84951850134768],
            [34.33199234981528, 0.84841785897309],
            [34.3351410742435, 0.845598482957852],
            [34.336025775559506, 0.844126867454858],
            [34.33677632786087, 0.841660612112532],
            [34.337383395855134, 0.841007638745841],
            [34.33919444258706, 0.839442454948069],
            [34.34022372415475, 0.839369568976939],
            [34.34422643470279, 0.835607033332642],
            [34.345560151727014, 0.833851374410023],
            [34.34713845664692, 0.832953540389474],
            [34.349620251146995, 0.83640298349934],
            [34.35145960199686, 0.837785327005694],
            [34.35629789667611, 0.836674207176577],
            [34.35870356434572, 0.837137703684906],
            [34.36012272013662, 0.838227692777155],
            [34.36066856075779, 0.840231309306047],
            [34.36057831869927, 0.842002341968301],
            [34.36117345886321, 0.843249314858755],
            [34.36095900764869, 0.844122418582101],
            [34.36396694990222, 0.848045820251197],
            [34.36417148730928, 0.849194979004469],
            [34.363777728770785, 0.850371082110131],
            [34.36683989063993, 0.85079117248312],
            [34.37077757483951, 0.853087128400389],
            [34.371368196477555, 0.856016056028642],
            [34.37554217981766, 0.859171307175257],
            [34.37669083850349, 0.86070458650157],
            [34.37686052037917, 0.862044966657619],
            [34.376649957971516, 0.86379526661577],
            [34.374561539327644, 0.864648226838826],
            [34.37426492640063, 0.865691363663998],
            [34.373004827212235, 0.866967375259384],
            [34.37282164006454, 0.867815203282233],
            [34.37097837884823, 0.870456939783508],
            [34.37025367467085, 0.872808836108848],
            [34.369786799556444, 0.876879137484889],
            [34.36864795137184, 0.879538019820787],
            [34.3623005274395, 0.87915630863247],
            [34.362106480558325, 0.879743016359951],
            [34.36288437488201, 0.882089270594743],
            [34.362464026211086, 0.883588608073558],
            [34.36204336762142, 0.884240578020593],
            [34.36061887224447, 0.884436652398041],
            [34.36047046606795, 0.884920614163085],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 907,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "MAGALE",
        Population: 20582,
        Key: "NAMISINDWAMAGALE",
        Dist2: "Manafwa",
        "Sub Country": "Magale",
        id2_original: "Manafwa Magale",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34504467326418, 0.927933885255059],
            [34.344258175775025, 0.929475116338019],
            [34.341455316205916, 0.931086173456665],
            [34.34106163043096, 0.932157084205734],
            [34.338748302386016, 0.928792551158784],
            [34.338331234362535, 0.927609923374865],
            [34.33851566298196, 0.926096805075097],
            [34.33682679162025, 0.923628213162162],
            [34.32730744426745, 0.916057526532673],
            [34.32332436011173, 0.911364090073829],
            [34.32549441136041, 0.910038320848841],
            [34.32369093203646, 0.90767934708076],
            [34.322926221387924, 0.905924831004412],
            [34.32176556929474, 0.904954774332151],
            [34.320973313604625, 0.903200291068972],
            [34.31877431055266, 0.900446014036074],
            [34.31786164917346, 0.897417977288663],
            [34.31981890659934, 0.890691108362701],
            [34.320524472169545, 0.890264480794416],
            [34.322820720546, 0.890336930157881],
            [34.32429360906562, 0.889875106309793],
            [34.32384164688325, 0.88863611854974],
            [34.32369691571456, 0.885931743998483],
            [34.322198379395246, 0.883269580580485],
            [34.32320996684681, 0.879033959018667],
            [34.322807326665114, 0.878363778754525],
            [34.32287780758398, 0.877275822066261],
            [34.32191269896525, 0.876603756143932],
            [34.32155448227095, 0.875224440135007],
            [34.32023421302654, 0.873442266169208],
            [34.31977227864619, 0.87166564769353],
            [34.318482896176185, 0.870964271227908],
            [34.31841075337402, 0.870296069181223],
            [34.31899099408067, 0.869923621208769],
            [34.31822031682201, 0.869138047830101],
            [34.31840929720496, 0.867644809720773],
            [34.3177488809609, 0.866779846460076],
            [34.3179748701369, 0.86653447276376],
            [34.31970256488858, 0.867286105932708],
            [34.320346853678316, 0.866958817091163],
            [34.32096062490126, 0.867158750194866],
            [34.321232040982885, 0.86762901914874],
            [34.32265808595369, 0.86803163470232],
            [34.32428494661134, 0.870107730360131],
            [34.32495837405396, 0.869863176947151],
            [34.32514060000431, 0.870119050522169],
            [34.32540775986812, 0.870944107277976],
            [34.32578395724112, 0.870950081282673],
            [34.326773452424895, 0.872275132534474],
            [34.32676151111981, 0.872824843128044],
            [34.327726511042435, 0.873508577486881],
            [34.32938926119229, 0.874100444523586],
            [34.32985032420682, 0.873874290320092],
            [34.330463384862355, 0.874515393614371],
            [34.33181644081803, 0.874423291093349],
            [34.332490152128294, 0.874991078757945],
            [34.33285031816673, 0.876657436774862],
            [34.333898582034685, 0.877055019589748],
            [34.33415939619933, 0.876786180824163],
            [34.33537781355854, 0.877660506521448],
            [34.335682627205784, 0.877488032253514],
            [34.335901257383036, 0.878031549824748],
            [34.33701176372041, 0.878385402255401],
            [34.33701189038287, 0.878739656152292],
            [34.33814028666911, 0.878213975333516],
            [34.3382133709057, 0.878977426606488],
            [34.33908339105498, 0.879530535041506],
            [34.33946344220056, 0.879355658149531],
            [34.33981464395079, 0.880073878062897],
            [34.34041635079945, 0.880155437264153],
            [34.34018610989718, 0.881077800190602],
            [34.34159844927171, 0.882225902526354],
            [34.341614991747655, 0.88290585730063],
            [34.33916568032829, 0.884293495064473],
            [34.338709640692834, 0.885456716840553],
            [34.339337685247294, 0.886605186087791],
            [34.33869607972529, 0.887409509470437],
            [34.33769858684055, 0.890209826703849],
            [34.33660066769694, 0.891416363528601],
            [34.33940733522454, 0.894034931141756],
            [34.34052439207699, 0.894243589761511],
            [34.343148801314925, 0.893610837800364],
            [34.343961994039354, 0.89395514620316],
            [34.344746920375044, 0.895017400328052],
            [34.34516142640334, 0.897314636994493],
            [34.347774175508874, 0.900209861733192],
            [34.3466046606371, 0.904115726662732],
            [34.34378999001862, 0.907210964055077],
            [34.343305177344625, 0.90844992395857],
            [34.343392369622734, 0.909411401863478],
            [34.34521670333603, 0.911508555027123],
            [34.3505018451904, 0.915875522370118],
            [34.349359686713996, 0.916170955777412],
            [34.347706933914914, 0.91789596637856],
            [34.3465985538898, 0.917887168509455],
            [34.34608119165981, 0.918385281459215],
            [34.34332795233204, 0.917878069743316],
            [34.342341467402775, 0.918249377526296],
            [34.34528411830484, 0.926966111474689],
            [34.34409612418936, 0.927888031375469],
            [34.34504467326418, 0.927933885255059],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 908,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "NAMABYA",
        Population: 10478,
        Key: "NAMISINDWANAMABYA",
        Dist2: "Manafwa",
        "Sub Country": "Namabya",
        id2_original: "Manafwa Namabya",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.47839999311167, 0.933326628239054],
            [34.47146880078855, 0.937226233372237],
            [34.437257419898636, 0.951126612901616],
            [34.427260178696166, 0.960282666196826],
            [34.39700248998417, 0.973761779763052],
            [34.38881974414595, 0.974026679821043],
            [34.38192130260147, 0.974915238432977],
            [34.37804163789116, 0.974547933641013],
            [34.377163060390465, 0.973216234389405],
            [34.38771030680375, 0.961484865174562],
            [34.38719486247687, 0.961180109700357],
            [34.38674090783121, 0.958628705325012],
            [34.38709855140033, 0.957753405123154],
            [34.38564675622189, 0.956183866622066],
            [34.385294570816434, 0.9547361436036],
            [34.38563945561358, 0.9539251977794],
            [34.38450084458421, 0.952188220316658],
            [34.38242256522494, 0.950625362720465],
            [34.38229443761767, 0.949943308254201],
            [34.381606597604616, 0.949530366336417],
            [34.3813644351602, 0.94724109261566],
            [34.3800854983003, 0.945891481742419],
            [34.38014766531124, 0.94410886932961],
            [34.3791204624451, 0.943370930675062],
            [34.37893133833172, 0.942084167617901],
            [34.37773575345207, 0.941316526155262],
            [34.37723662881896, 0.939335824475318],
            [34.37617066544496, 0.939502953329932],
            [34.37582003412495, 0.938617081028875],
            [34.37533522234926, 0.939119046109165],
            [34.37460309898596, 0.938811945271992],
            [34.373878413673225, 0.9394578109713],
            [34.37253752899132, 0.938969740112794],
            [34.37368886286005, 0.936877269287638],
            [34.37544340915387, 0.931373998772516],
            [34.37669016836026, 0.929019275001313],
            [34.37848748344475, 0.925994553321784],
            [34.381095667312046, 0.925972009450936],
            [34.38094533245259, 0.924207440711562],
            [34.38326891566483, 0.922162902498128],
            [34.3833723153473, 0.919189824157232],
            [34.387621464320475, 0.920700476247116],
            [34.39636605785988, 0.929031861438664],
            [34.39685207697131, 0.928667624492853],
            [34.39859857166523, 0.928621704156156],
            [34.41169753564367, 0.929032496464091],
            [34.419733318898004, 0.929544784095924],
            [34.423846553667026, 0.930212406726256],
            [34.430026947550424, 0.929531546467544],
            [34.434424349088204, 0.927494737620034],
            [34.441507920836344, 0.925945229678277],
            [34.443886153957195, 0.927309963102275],
            [34.44740455398946, 0.927751689485335],
            [34.449567294748356, 0.925354024042232],
            [34.451801532420745, 0.924783303515761],
            [34.45315671558701, 0.925090253780574],
            [34.454273348434626, 0.922928179585906],
            [34.4565311722731, 0.922375539413293],
            [34.457078486131316, 0.923234530014317],
            [34.45890972429586, 0.92455425127197],
            [34.46100276746682, 0.927519936553245],
            [34.46150267453255, 0.929165804194819],
            [34.46946738847152, 0.930681916667469],
            [34.477312561799, 0.931076557363039],
            [34.47839999311167, 0.933326628239054],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 909,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "MUKOTO",
        Population: 8022,
        Key: "NAMISINDWAMUKOTO",
        Dist2: "Manafwa",
        "Sub Country": "Mukoto",
        id2_original: "Manafwa Mukoto",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.37804163789116, 0.974547933641013],
            [34.374175655420935, 0.973977441292603],
            [34.37066920028698, 0.974547242038303],
            [34.365585540669365, 0.973164565358609],
            [34.3637637357136, 0.971863815256132],
            [34.361136132964845, 0.9719838389586],
            [34.36040639822189, 0.97240397442752],
            [34.35815113458197, 0.975943121469472],
            [34.35629749962076, 0.980563387164948],
            [34.352220737350585, 0.976890389419896],
            [34.35179838184333, 0.97434712454171],
            [34.353048572614135, 0.97139808868798],
            [34.35301345657137, 0.970516791885279],
            [34.35121281682201, 0.967658707615528],
            [34.35132200165493, 0.966430945706829],
            [34.35012250640885, 0.96463445167598],
            [34.34962145399113, 0.961148687460359],
            [34.347930967458566, 0.959708303847644],
            [34.34663471287663, 0.959574506876923],
            [34.34508595893631, 0.958617849806067],
            [34.34404042145521, 0.959032044505352],
            [34.3422815839093, 0.95767490692807],
            [34.34271547019153, 0.956989844024315],
            [34.34384287473771, 0.956933766430515],
            [34.34447877236442, 0.955602388121916],
            [34.345422935864, 0.955536814836954],
            [34.345957264574764, 0.954613596276199],
            [34.347404435226146, 0.95394086941213],
            [34.3479100762383, 0.952016607403826],
            [34.35073320629182, 0.948813512997174],
            [34.35238039043447, 0.947872371902875],
            [34.35304331207983, 0.94690290245623],
            [34.354170231535775, 0.946967072030231],
            [34.35528345078532, 0.946044847273653],
            [34.35613903590631, 0.945921030491374],
            [34.3565443377962, 0.944582603406655],
            [34.35690108933824, 0.944941428880926],
            [34.35742169628307, 0.94482635507144],
            [34.358348176446285, 0.943002445864588],
            [34.35963887943976, 0.942413235292233],
            [34.36019969767163, 0.941133544261678],
            [34.36246816025803, 0.939542314908139],
            [34.36280122053108, 0.938204615605614],
            [34.36419291392544, 0.937353607315808],
            [34.36658198881344, 0.938434268752638],
            [34.368715502884605, 0.938332268852148],
            [34.37141932858354, 0.939299224843103],
            [34.37253752899132, 0.938969740112794],
            [34.373878413673225, 0.9394578109713],
            [34.37460309898596, 0.938811945271992],
            [34.37533522234926, 0.939119046109165],
            [34.37582003412495, 0.938617081028875],
            [34.37617066544496, 0.939502953329932],
            [34.37723662881896, 0.939335824475318],
            [34.37773575345207, 0.941316526155262],
            [34.37893133833172, 0.942084167617901],
            [34.3791204624451, 0.943370930675062],
            [34.38014766531124, 0.94410886932961],
            [34.3800854983003, 0.945891481742419],
            [34.3813644351602, 0.94724109261566],
            [34.381606597604616, 0.949530366336417],
            [34.38229443761767, 0.949943308254201],
            [34.38242256522494, 0.950625362720465],
            [34.38450084458421, 0.952188220316658],
            [34.38563945561358, 0.9539251977794],
            [34.385294570816434, 0.9547361436036],
            [34.38564675622189, 0.956183866622066],
            [34.38709855140033, 0.957753405123154],
            [34.38674090783121, 0.958628705325012],
            [34.38719486247687, 0.961180109700357],
            [34.38771030680375, 0.961484865174562],
            [34.377163060390465, 0.973216234389405],
            [34.37804163789116, 0.974547933641013],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 910,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "TSEKULULU",
        Population: 16416,
        Key: "NAMISINDWATSEKULULU",
        Dist2: "Manafwa",
        "Sub Country": "Tsekululu",
        id2_original: "Manafwa Tsekululu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.33950266444249, 0.958802372965153],
            [34.33921455945953, 0.958440708857373],
            [34.338189020273276, 0.958617826453144],
            [34.33662249945327, 0.957613971934924],
            [34.335897223947406, 0.9577212157976],
            [34.33546702255446, 0.956293732346524],
            [34.33455692586537, 0.956331291964408],
            [34.334039198021074, 0.955545588360388],
            [34.33339696727162, 0.955364476353243],
            [34.33277803702401, 0.955704194403283],
            [34.33280592971359, 0.956150615620928],
            [34.331900438686986, 0.956155621234931],
            [34.33136907172169, 0.955941913037496],
            [34.3313688022271, 0.955244362246177],
            [34.33052336357726, 0.955235392018251],
            [34.33051900944306, 0.955923644745822],
            [34.32977541369526, 0.956449424626065],
            [34.32796454033821, 0.956747754869885],
            [34.32772390772472, 0.95571082035326],
            [34.326837055841956, 0.956134348498157],
            [34.32640791266443, 0.955442807537783],
            [34.324988168477, 0.955627532960534],
            [34.32454937918997, 0.956482267845986],
            [34.322917398135196, 0.95668180975611],
            [34.3220540785196, 0.957411472339774],
            [34.320692495755246, 0.956594271253279],
            [34.320627053486795, 0.957706704643305],
            [34.319858804374356, 0.958252157298182],
            [34.31950058049354, 0.959268933880026],
            [34.318490645043816, 0.959372464576059],
            [34.31849817831577, 0.959932348171606],
            [34.31751729078905, 0.959446512204077],
            [34.316661455936405, 0.960618190114646],
            [34.31597333654732, 0.960191173957454],
            [34.31561510009009, 0.961178484876668],
            [34.31513917175426, 0.960618782021232],
            [34.31363889629657, 0.960759336026901],
            [34.313675681409144, 0.961260275751758],
            [34.312592476669856, 0.961157558872024],
            [34.31243180399814, 0.962041655062234],
            [34.31142188741302, 0.962204121218818],
            [34.310623851064086, 0.961423532351659],
            [34.30974582692561, 0.961998495300682],
            [34.308662235012434, 0.960886503418546],
            [34.30809887903989, 0.961365574023109],
            [34.30783523608041, 0.960923657902838],
            [34.307513276289335, 0.961085855554118],
            [34.30750561994817, 0.960201821989718],
            [34.308420131856856, 0.959346899412297],
            [34.30741543448353, 0.957633076432316],
            [34.306357402335145, 0.956823384267274],
            [34.30558928976663, 0.955250243597145],
            [34.30739970498289, 0.953649879838531],
            [34.30711478901919, 0.953190419257821],
            [34.30753250382967, 0.952415164492458],
            [34.306848530165595, 0.947211214241269],
            [34.30604241347067, 0.944149951794192],
            [34.308629754626715, 0.941911724273629],
            [34.31082843518352, 0.941462927291809],
            [34.31227313726448, 0.940280052279594],
            [34.31392970341191, 0.939402216322149],
            [34.317955560849896, 0.938902411440706],
            [34.319033658666754, 0.939134528289779],
            [34.32191661292493, 0.941591573821844],
            [34.32309372844232, 0.94186794091353],
            [34.32741248786688, 0.939031497282247],
            [34.32965264274201, 0.938499251348986],
            [34.332641280200114, 0.936737165205777],
            [34.336148966026, 0.937024160126482],
            [34.33926229952697, 0.937886625870986],
            [34.339646658992635, 0.936203435104974],
            [34.34194517741182, 0.93494026770451],
            [34.34302322671967, 0.933490364893645],
            [34.34215970498313, 0.933277341524029],
            [34.34106163043096, 0.932157084205734],
            [34.341455316205916, 0.931086173456665],
            [34.344258175775025, 0.929475116338019],
            [34.34504467326418, 0.927933885255059],
            [34.345839328354394, 0.928268789844438],
            [34.34767739820668, 0.930306853924999],
            [34.35260857688967, 0.931293130538878],
            [34.354604946963, 0.932085652441656],
            [34.35447611148328, 0.933022051724079],
            [34.35359798942845, 0.934082287724014],
            [34.35310768535311, 0.936493594411395],
            [34.3523328848273, 0.93701533715547],
            [34.35285538811567, 0.938147010776425],
            [34.351029054752566, 0.940492327925811],
            [34.35528345078532, 0.946044847273653],
            [34.354170231535775, 0.946967072030231],
            [34.35304331207983, 0.94690290245623],
            [34.35238039043447, 0.947872371902875],
            [34.35073320629182, 0.948813512997174],
            [34.3479100762383, 0.952016607403826],
            [34.347404435226146, 0.95394086941213],
            [34.345957264574764, 0.954613596276199],
            [34.345422935864, 0.955536814836954],
            [34.34447877236442, 0.955602388121916],
            [34.34384287473771, 0.956933766430515],
            [34.34271547019153, 0.956989844024315],
            [34.3422815839093, 0.95767490692807],
            [34.34031758462721, 0.958314163820217],
            [34.34024884554168, 0.959106101122616],
            [34.33950266444249, 0.958802372965153],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 911,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUKHABUSI",
        Population: 9853,
        Key: "NAMISINDWABUKHABUSI",
        Dist2: "Manafwa",
        "Sub Country": "Bukhabusi",
        id2_original: "Manafwa Bukhabusi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34106163043096, 0.932157084205734],
            [34.34215970498313, 0.933277341524029],
            [34.34302322671967, 0.933490364893645],
            [34.34194517741182, 0.93494026770451],
            [34.339646658992635, 0.936203435104974],
            [34.33926229952697, 0.937886625870986],
            [34.336148966026, 0.937024160126482],
            [34.332641280200114, 0.936737165205777],
            [34.32965264274201, 0.938499251348986],
            [34.32741248786688, 0.939031497282247],
            [34.32309372844232, 0.94186794091353],
            [34.32191661292493, 0.941591573821844],
            [34.319033658666754, 0.939134528289779],
            [34.317955560849896, 0.938902411440706],
            [34.31392970341191, 0.939402216322149],
            [34.31227313726448, 0.940280052279594],
            [34.30901911231862, 0.938453792812829],
            [34.30732884946653, 0.936162363325214],
            [34.306997845437174, 0.934905547949966],
            [34.30703223474289, 0.9285838640019],
            [34.30633374250719, 0.926698714410325],
            [34.306565077557494, 0.925274445483476],
            [34.30627836316656, 0.924393693825533],
            [34.305072263506524, 0.924026907315641],
            [34.3043084871059, 0.924855992006731],
            [34.302462305466555, 0.924525837665813],
            [34.305566251572834, 0.921794099301316],
            [34.305935740327314, 0.917974491513585],
            [34.30425160937534, 0.915491017079364],
            [34.30449355263083, 0.91395452334398],
            [34.30413102042994, 0.912317098060606],
            [34.306380250086086, 0.908882216158762],
            [34.307693812508596, 0.90838651895446],
            [34.30840216644947, 0.907524396357059],
            [34.311730804564505, 0.905689456901343],
            [34.31304877232519, 0.903648271919003],
            [34.31449617474188, 0.902700486499704],
            [34.31583049543399, 0.898967946620154],
            [34.31786164917346, 0.897417977288663],
            [34.31877431055266, 0.900446014036074],
            [34.320973313604625, 0.903200291068972],
            [34.32176556929474, 0.904954774332151],
            [34.322926221387924, 0.905924831004412],
            [34.32369093203646, 0.90767934708076],
            [34.32549441136041, 0.910038320848841],
            [34.32332436011173, 0.911364090073829],
            [34.32730744426745, 0.916057526532673],
            [34.33682679162025, 0.923628213162162],
            [34.33851566298196, 0.926096805075097],
            [34.338331234362535, 0.927609923374865],
            [34.338748302386016, 0.928792551158784],
            [34.34106163043096, 0.932157084205734],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 912,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUKHAWEKA",
        Population: 9119,
        Key: "NAMISINDWABUKHAWEKA",
        Dist2: "Manafwa",
        "Sub Country": "Bukhaweka",
        id2_original: "Manafwa Bukhaweka",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.37253752899132, 0.938969740112794],
            [34.37141932858354, 0.939299224843103],
            [34.368715502884605, 0.938332268852148],
            [34.36658198881344, 0.938434268752638],
            [34.36419291392544, 0.937353607315808],
            [34.36280122053108, 0.938204615605614],
            [34.36246816025803, 0.939542314908139],
            [34.36019969767163, 0.941133544261678],
            [34.35963887943976, 0.942413235292233],
            [34.358348176446285, 0.943002445864588],
            [34.35742169628307, 0.94482635507144],
            [34.35690108933824, 0.944941428880926],
            [34.3565443377962, 0.944582603406655],
            [34.35613903590631, 0.945921030491374],
            [34.35528345078532, 0.946044847273653],
            [34.351029054752566, 0.940492327925811],
            [34.35285538811567, 0.938147010776425],
            [34.3523328848273, 0.93701533715547],
            [34.35310768535311, 0.936493594411395],
            [34.35359798942845, 0.934082287724014],
            [34.35447611148328, 0.933022051724079],
            [34.354604946963, 0.932085652441656],
            [34.35260857688967, 0.931293130538878],
            [34.34767739820668, 0.930306853924999],
            [34.345839328354394, 0.928268789844438],
            [34.34504467326418, 0.927933885255059],
            [34.34409612418936, 0.927888031375469],
            [34.34528411830484, 0.926966111474689],
            [34.342341467402775, 0.918249377526296],
            [34.34332795233204, 0.917878069743316],
            [34.34608119165981, 0.918385281459215],
            [34.3465985538898, 0.917887168509455],
            [34.347706933914914, 0.91789596637856],
            [34.349359686713996, 0.916170955777412],
            [34.3505018451904, 0.915875522370118],
            [34.35140229127837, 0.915884454076067],
            [34.35443488420162, 0.917460030366246],
            [34.356814516897686, 0.918055045680601],
            [34.3611181981002, 0.915177034873562],
            [34.36229075646414, 0.914862801144085],
            [34.36381976992608, 0.915078875009618],
            [34.36649787596015, 0.916172681220493],
            [34.36735625843493, 0.918546000852428],
            [34.368720586450785, 0.91895743025057],
            [34.36819472885315, 0.919801162163692],
            [34.36821456095967, 0.920703532819326],
            [34.37016562629828, 0.922758773909769],
            [34.370808818245095, 0.924209636806697],
            [34.37131708682946, 0.92839364377045],
            [34.37174641955151, 0.929230171697458],
            [34.37669016836026, 0.929019275001313],
            [34.37544340915387, 0.931373998772516],
            [34.37368886286005, 0.936877269287638],
            [34.37253752899132, 0.938969740112794],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 913,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUWABWALA",
        Population: 6911,
        Key: "NAMISINDWABUWABWALA",
        Dist2: "Manafwa",
        "Sub Country": "Buwabwala",
        id2_original: "Manafwa Buwabwala",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.29460240066674, 0.876068133633733],
            [34.292639385039905, 0.877032614638464],
            [34.29094130504821, 0.878650812439821],
            [34.292301670595364, 0.88057169437421],
            [34.29145432751708, 0.882463843417813],
            [34.29255391932375, 0.885976625650507],
            [34.2916516523507, 0.889303445152794],
            [34.2896659524663, 0.891987296810663],
            [34.29002898862209, 0.893035359847108],
            [34.2894485969985, 0.89543159168854],
            [34.28759499257998, 0.897716834363484],
            [34.28698615041301, 0.897912076285844],
            [34.28532532086122, 0.897439033012468],
            [34.28382101286622, 0.896358660092872],
            [34.28125475966147, 0.891896163887382],
            [34.28139204828801, 0.888719977871536],
            [34.28237835085927, 0.883968134364739],
            [34.281240438719216, 0.882414579362867],
            [34.27978536109672, 0.87910850232788],
            [34.27867748322985, 0.878517069917766],
            [34.27346762828112, 0.874074195212592],
            [34.27089836572016, 0.872937283880558],
            [34.270795280448034, 0.871954681309622],
            [34.2714642711115, 0.869472386547815],
            [34.270279466913586, 0.865874157139775],
            [34.26781429483954, 0.861814368270256],
            [34.267910770307815, 0.861376663336547],
            [34.26950229303881, 0.860860638593247],
            [34.2701808795061, 0.859965625832134],
            [34.27054243164502, 0.857631256491579],
            [34.27020383595319, 0.856342671250857],
            [34.26802932007754, 0.854641341274282],
            [34.26580561335522, 0.850241044632849],
            [34.26582902973973, 0.847979730350325],
            [34.26515190662805, 0.845572756213461],
            [34.26562339728638, 0.843475520275985],
            [34.26606772738211, 0.843491585802116],
            [34.268472226343526, 0.841167200075656],
            [34.27108625195508, 0.841306342199144],
            [34.27305930805187, 0.840842774327156],
            [34.27512819103327, 0.842250260985413],
            [34.27665752788872, 0.84429119549856],
            [34.27628348287914, 0.845508252522503],
            [34.27733387485602, 0.848206645981409],
            [34.279945021367105, 0.849840468851076],
            [34.28006618343768, 0.850793745872667],
            [34.28196166102654, 0.852659524702391],
            [34.28283646829798, 0.852635474973936],
            [34.28285820842617, 0.853188800130272],
            [34.28383200644867, 0.853683939700824],
            [34.28412951499602, 0.854272798109155],
            [34.2847051671082, 0.854056149438037],
            [34.285125613695456, 0.854341714586112],
            [34.285334532186155, 0.855619366526562],
            [34.28737066708386, 0.856841243391747],
            [34.28819005459047, 0.856860579262447],
            [34.288488037448325, 0.857319340663197],
            [34.29047568128701, 0.858392065781397],
            [34.292781993489555, 0.860604962898971],
            [34.29439938410747, 0.863907836081353],
            [34.29465682689488, 0.868835012669454],
            [34.29424513439003, 0.874472054052117],
            [34.29460240066674, 0.876068133633733],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 915,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUKHOFU",
        Population: 7367,
        Key: "MANAFWABUKHOFU",
        Dist2: "Manafwa",
        "Sub Country": "Bukhofu",
        id2_original: "Manafwa Bukhofu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.27867748322985, 0.878517069917766],
            [34.275935718083204, 0.87986572882708],
            [34.2610216380046, 0.882500593628128],
            [34.25842124971738, 0.882332816317681],
            [34.25269272818484, 0.883245308290938],
            [34.248281654288434, 0.885328871298893],
            [34.24801700252088, 0.883324016508836],
            [34.24701983931785, 0.882331650442704],
            [34.246312267809586, 0.880182467974551],
            [34.2465255844519, 0.879544980045759],
            [34.24290865719926, 0.874528400602753],
            [34.24318820123756, 0.873764890039268],
            [34.2416778466824, 0.870948903727406],
            [34.24030060179105, 0.869874648009509],
            [34.23934940358447, 0.867946582988693],
            [34.23838207522867, 0.866407474489274],
            [34.23846709538043, 0.864769519723483],
            [34.2390485568975, 0.86407308843881],
            [34.23915738060768, 0.862891564329565],
            [34.23979299706167, 0.862635391161352],
            [34.2408487807269, 0.861232164091993],
            [34.24066438983671, 0.860424172187144],
            [34.24176103966086, 0.854522654688958],
            [34.24123207119738, 0.851879505927401],
            [34.24054721179443, 0.851062612525654],
            [34.24065460359004, 0.850476813849443],
            [34.239886376037155, 0.848911744347394],
            [34.24044829201028, 0.847562827443956],
            [34.23990530264187, 0.846928015222819],
            [34.23986504104916, 0.843339607323589],
            [34.23791820228392, 0.841351587258358],
            [34.23687650869394, 0.840943362228524],
            [34.23624035594572, 0.839501304451719],
            [34.23561442602542, 0.839457202803708],
            [34.234836657465905, 0.83862556611595],
            [34.2333305043313, 0.838493140779389],
            [34.232484054178435, 0.836952698328644],
            [34.23138361166718, 0.836322979081429],
            [34.23046879522961, 0.835072978778459],
            [34.228683604706504, 0.833956155382328],
            [34.22834626935101, 0.834192537271913],
            [34.227710469640705, 0.833862936299815],
            [34.22747137943456, 0.830083537574912],
            [34.226253580116264, 0.82633616223677],
            [34.22689090157267, 0.821783831124588],
            [34.22643999221581, 0.816629939856994],
            [34.2342417131347, 0.817026883005917],
            [34.23631401420575, 0.818165085291121],
            [34.23755369558605, 0.818094884617342],
            [34.23835138788022, 0.818487340994435],
            [34.24151977553174, 0.817770756984137],
            [34.24195759463827, 0.81784479757019],
            [34.242321936944485, 0.818603911556709],
            [34.24554344018208, 0.818649847609593],
            [34.248059847668344, 0.822639731453314],
            [34.25061751118238, 0.828771511316481],
            [34.251476569190245, 0.833017643681188],
            [34.25478155556217, 0.832304185401727],
            [34.25962396093213, 0.840458583778533],
            [34.2605276867692, 0.841391637021675],
            [34.26117623447175, 0.841493006358882],
            [34.26253463540335, 0.843991310219474],
            [34.264643572466625, 0.842175700787897],
            [34.26562339728638, 0.843475520275985],
            [34.26515190662805, 0.845572756213461],
            [34.26582902973973, 0.847979730350325],
            [34.26580561335522, 0.850241044632849],
            [34.26802932007754, 0.854641341274282],
            [34.27020383595319, 0.856342671250857],
            [34.27054243164502, 0.857631256491579],
            [34.2701808795061, 0.859965625832134],
            [34.26950229303881, 0.860860638593247],
            [34.267910770307815, 0.861376663336547],
            [34.26781429483954, 0.861814368270256],
            [34.270279466913586, 0.865874157139775],
            [34.2714642711115, 0.869472386547815],
            [34.270795280448034, 0.871954681309622],
            [34.27089836572016, 0.872937283880558],
            [34.27346762828112, 0.874074195212592],
            [34.27867748322985, 0.878517069917766],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 916,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUGOBERO",
        Population: 13423,
        Key: "MANAFWABUGOBERO",
        Dist2: "Manafwa",
        "Sub Country": "Bugobero",
        id2_original: "Manafwa Bugobero",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.27783645530803, 0.935162227121695],
            [34.276905527585846, 0.935507826736473],
            [34.276246660037316, 0.9365377838231],
            [34.27529195929945, 0.936709754083648],
            [34.274461599769964, 0.934982423620741],
            [34.27396137380231, 0.934673692195723],
            [34.27298375793985, 0.934342253454522],
            [34.27064233059284, 0.934388874309402],
            [34.26999486625853, 0.935533241179314],
            [34.26919928590356, 0.935693710994036],
            [34.26938171217822, 0.93726110310238],
            [34.26668849378615, 0.938886755009325],
            [34.266598060386485, 0.940259746800533],
            [34.26502940157611, 0.939951404758994],
            [34.263642789052994, 0.94015785653305],
            [34.26298404726862, 0.941553940391964],
            [34.26124520532263, 0.942115202011852],
            [34.2606089600479, 0.942859122004189],
            [34.26001785421792, 0.942699159099712],
            [34.26015466314411, 0.943843243910685],
            [34.258927294073104, 0.944381436863973],
            [34.257426386201445, 0.942848842177772],
            [34.25744836977309, 0.940766506205407],
            [34.256425364734284, 0.940663906379251],
            [34.256605255064876, 0.93983351584326],
            [34.25574912736144, 0.93842638260235],
            [34.25471932566917, 0.937663515140309],
            [34.254371639026644, 0.938020753317978],
            [34.254838043423845, 0.938951879512014],
            [34.25386464964325, 0.940310661843659],
            [34.252236433427846, 0.939071857658203],
            [34.251895763526015, 0.939597148784294],
            [34.25204238295344, 0.941102572732569],
            [34.25074344330711, 0.941312380091529],
            [34.24797867320433, 0.934753082819651],
            [34.24736457679127, 0.930215086047612],
            [34.24660320248571, 0.928587975949191],
            [34.2452710090042, 0.926329260491042],
            [34.242146984653004, 0.923958360400914],
            [34.24057433013624, 0.920827970246922],
            [34.24016558859712, 0.913014374439986],
            [34.240600749588744, 0.911192658405626],
            [34.24550912363993, 0.913500823129018],
            [34.24702971000619, 0.914590135223962],
            [34.24938205547716, 0.914942240713989],
            [34.25333782635666, 0.919920177192378],
            [34.2551040237997, 0.921189136156136],
            [34.25865381006969, 0.921949621561625],
            [34.26007715560308, 0.921767744345308],
            [34.26222230375546, 0.920840445336602],
            [34.26532027696343, 0.921584498264352],
            [34.272581009960305, 0.920366720639246],
            [34.273427991915845, 0.92078356237641],
            [34.273644651189336, 0.922034922620462],
            [34.277792189025796, 0.922978535301668],
            [34.27783645530803, 0.935162227121695],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 917,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUTTA",
        Population: 4081,
        Key: "MANAFWABUTTA",
        Dist2: "Manafwa",
        "Sub Country": "Butta",
        id2_original: "Manafwa Butta",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.247175614374626, 0.942744196327727],
            [34.245485149401624, 0.941893618480966],
            [34.24525018246263, 0.943185632448172],
            [34.24428550952681, 0.942673795007803],
            [34.24376119882808, 0.941840728332515],
            [34.24379824175712, 0.939226277071983],
            [34.24319804317983, 0.938546128134103],
            [34.24239361441931, 0.940182352089284],
            [34.24134582576013, 0.940863093516756],
            [34.24296364667105, 0.941451142986321],
            [34.24107287176273, 0.942116900496425],
            [34.23724494102963, 0.941162702336592],
            [34.23625730805344, 0.94015397274068],
            [34.23470792439412, 0.939818164802142],
            [34.23515577498743, 0.939191149579595],
            [34.23362286014221, 0.938346697453726],
            [34.234098788478036, 0.935315723362804],
            [34.23308806610411, 0.933420225660817],
            [34.23345200506676, 0.931722999331596],
            [34.23205628542326, 0.929534530278224],
            [34.231896014298485, 0.927447878651624],
            [34.230496057301856, 0.926777992040847],
            [34.22954637545147, 0.92568514835997],
            [34.22914335438407, 0.924186948314557],
            [34.22944632558671, 0.921847596933299],
            [34.22332331967693, 0.907051083076591],
            [34.22053642047545, 0.901543465096975],
            [34.21605773398086, 0.875257291284917],
            [34.216177445272265, 0.873330916758082],
            [34.21317020011138, 0.870094027242427],
            [34.21897261705918, 0.869787579851932],
            [34.22040706397284, 0.870153454724701],
            [34.22172533177082, 0.868743593548855],
            [34.2213557325236, 0.865742055198362],
            [34.224216375325035, 0.866610347471709],
            [34.2266722489376, 0.867478770684992],
            [34.22980329901263, 0.870085411595734],
            [34.230370432400925, 0.871497710913977],
            [34.23410007576384, 0.876500550000096],
            [34.23290116352441, 0.88100763479184],
            [34.23155400500858, 0.883140870886879],
            [34.231552425770325, 0.888075521319406],
            [34.23223142905593, 0.888581676411978],
            [34.23447071256524, 0.892112599299537],
            [34.23486129196594, 0.894117984649893],
            [34.2338821130349, 0.89630100339239],
            [34.23470205839531, 0.90088523863202],
            [34.2399353027791, 0.910893987469846],
            [34.240600749588744, 0.911192658405626],
            [34.24016558859712, 0.913014374439986],
            [34.24057433013624, 0.920827970246922],
            [34.242146984653004, 0.923958360400914],
            [34.2452710090042, 0.926329260491042],
            [34.24660320248571, 0.928587975949191],
            [34.24736457679127, 0.930215086047612],
            [34.24797867320433, 0.934753082819651],
            [34.25074344330711, 0.941312380091529],
            [34.24850281861306, 0.941596735742635],
            [34.247175614374626, 0.942744196327727],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 918,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "SIBANGA",
        Population: 7427,
        Key: "MANAFWASIBANGA",
        Dist2: "Manafwa",
        "Sub Country": "Sibanga",
        id2_original: "Manafwa Sibanga",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.18306907427868, 0.829244075399071],
            [34.18214999353846, 0.828436868175234],
            [34.18197903605503, 0.826961232983436],
            [34.18115698684023, 0.825437731887833],
            [34.179887289153044, 0.824320781817135],
            [34.18461649961069, 0.823832114715333],
            [34.18670658373112, 0.822901131314855],
            [34.189370429010005, 0.820611309659352],
            [34.18947714078094, 0.819853730218571],
            [34.19218334342212, 0.817021018501697],
            [34.19625607674821, 0.815669742732883],
            [34.19910109694857, 0.814011682392222],
            [34.201314607792426, 0.813667678513899],
            [34.20430993949601, 0.815298962928675],
            [34.212675531122066, 0.815149873853692],
            [34.21898127053032, 0.817571700707628],
            [34.2225005940307, 0.817417358005533],
            [34.22643999221581, 0.816629939856994],
            [34.22689090157267, 0.821783831124588],
            [34.226253580116264, 0.82633616223677],
            [34.22747137943456, 0.830083537574912],
            [34.227710469640705, 0.833862936299815],
            [34.22834626935101, 0.834192537271913],
            [34.228683604706504, 0.833956155382328],
            [34.23046879522961, 0.835072978778459],
            [34.23138361166718, 0.836322979081429],
            [34.232484054178435, 0.836952698328644],
            [34.2333305043313, 0.838493140779389],
            [34.234836657465905, 0.83862556611595],
            [34.23561442602542, 0.839457202803708],
            [34.23624035594572, 0.839501304451719],
            [34.23687650869394, 0.840943362228524],
            [34.23791820228392, 0.841351587258358],
            [34.23986504104916, 0.843339607323589],
            [34.23990530264187, 0.846928015222819],
            [34.24044829201028, 0.847562827443956],
            [34.239886376037155, 0.848911744347394],
            [34.24065460359004, 0.850476813849443],
            [34.24054721179443, 0.851062612525654],
            [34.24123207119738, 0.851879505927401],
            [34.24176103966086, 0.854522654688958],
            [34.24066438983671, 0.860424172187144],
            [34.2408487807269, 0.861232164091993],
            [34.23979299706167, 0.862635391161352],
            [34.23915738060768, 0.862891564329565],
            [34.2390485568975, 0.86407308843881],
            [34.23846709538043, 0.864769519723483],
            [34.23838207522867, 0.866407474489274],
            [34.23934940358447, 0.867946582988693],
            [34.235993350683614, 0.872081381191464],
            [34.23410007576384, 0.876500550000096],
            [34.230370432400925, 0.871497710913977],
            [34.22980329901263, 0.870085411595734],
            [34.2266722489376, 0.867478770684992],
            [34.224216375325035, 0.866610347471709],
            [34.2213557325236, 0.865742055198362],
            [34.22172533177082, 0.868743593548855],
            [34.22040706397284, 0.870153454724701],
            [34.21897261705918, 0.869787579851932],
            [34.21317020011138, 0.870094027242427],
            [34.21231453144706, 0.868038043446291],
            [34.212090960535775, 0.865449714785701],
            [34.21279111555304, 0.863278052067651],
            [34.21245710935401, 0.858499624268152],
            [34.213023155780824, 0.856545658842447],
            [34.210345609397216, 0.857215866325729],
            [34.20853713993183, 0.856954129234119],
            [34.20650664735242, 0.856095470811349],
            [34.204071246345215, 0.853571760657967],
            [34.20169962931645, 0.851909006035206],
            [34.20222776863491, 0.84901433326655],
            [34.20041095741381, 0.847865830157965],
            [34.20033482429517, 0.846174477432334],
            [34.19744997638837, 0.843437958597807],
            [34.195846479114664, 0.843195763101459],
            [34.19511690876338, 0.841702028062796],
            [34.194353620147936, 0.84134519553596],
            [34.194009432443444, 0.840625752144137],
            [34.19129499225111, 0.839213351642761],
            [34.19223363919655, 0.836212153154217],
            [34.19154831985618, 0.834924672794073],
            [34.18839479303444, 0.832157607489355],
            [34.18629344404035, 0.831498393500353],
            [34.185516033010344, 0.830465858143864],
            [34.1841999005078, 0.829834434832431],
            [34.18395721973546, 0.829242174763025],
            [34.18306907427868, 0.829244075399071],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 919,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUSUKUYA",
        Population: 12860,
        Key: "MANAFWABUSUKUYA",
        Dist2: "Manafwa",
        "Sub Country": "Busukuya",
        id2_original: "Manafwa Busukuya",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32986988322548, 0.99303005436968],
            [34.329572044996425, 0.990196877018213],
            [34.328138429024385, 0.990309001458383],
            [34.32658685617071, 0.989884364757322],
            [34.325865102959035, 0.989290075016055],
            [34.32588072286519, 0.988746898883145],
            [34.32463653823038, 0.988502925825688],
            [34.325102466520484, 0.986152523878846],
            [34.32573407020011, 0.985544403257739],
            [34.32543746895119, 0.984914141427361],
            [34.32438037823722, 0.984188503248355],
            [34.32212127609611, 0.983902359274649],
            [34.32037114142867, 0.982885330527546],
            [34.318058240981784, 0.983746368265183],
            [34.318730585954505, 0.981392997161764],
            [34.319117254988775, 0.98129051621802],
            [34.32232425133287, 0.981133932285445],
            [34.32333741353112, 0.980072633010003],
            [34.32494557575612, 0.979985946589528],
            [34.32581271680493, 0.978778205203286],
            [34.32694087593597, 0.97823371151907],
            [34.32806868741899, 0.976034925852159],
            [34.32924136975044, 0.9715873149545],
            [34.330043713521185, 0.971467339739981],
            [34.33589414811588, 0.968018674967854],
            [34.335221902856134, 0.96654418379552],
            [34.33551286538004, 0.965745359120682],
            [34.337438473361836, 0.96543348858415],
            [34.33853133678702, 0.963494626697267],
            [34.34001740179523, 0.962177136040024],
            [34.33914819911284, 0.960066745118714],
            [34.33909418431314, 0.959224398057292],
            [34.33950266444249, 0.958802372965153],
            [34.34024884554168, 0.959106101122616],
            [34.34031758462721, 0.958314163820217],
            [34.3422815839093, 0.95767490692807],
            [34.34404042145521, 0.959032044505352],
            [34.34508595893631, 0.958617849806067],
            [34.34663471287663, 0.959574506876923],
            [34.347930967458566, 0.959708303847644],
            [34.34962145399113, 0.961148687460359],
            [34.35012250640885, 0.96463445167598],
            [34.35132200165493, 0.966430945706829],
            [34.35121281682201, 0.967658707615528],
            [34.35301345657137, 0.970516791885279],
            [34.353048572614135, 0.97139808868798],
            [34.35179838184333, 0.97434712454171],
            [34.352220737350585, 0.976890389419896],
            [34.35023937004079, 0.976930918208622],
            [34.34936153185357, 0.97825344462935],
            [34.34941486034043, 0.979499738059286],
            [34.34575159259555, 0.983568000817291],
            [34.34393802698756, 0.983883503722319],
            [34.3351208028608, 0.99062685875446],
            [34.33413225450133, 0.991814250256141],
            [34.33348443353587, 0.992147235463746],
            [34.33075746993016, 0.991770622924871],
            [34.32986988322548, 0.99303005436968],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 920,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "WESWA",
        Population: 7566,
        Key: "MANAFWAWESWA",
        Dist2: "Manafwa",
        "Sub Country": "Wesswa",
        id2_original: "Manafwa Wesswa",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.319117254988775, 0.98129051621802],
            [34.31851289182183, 0.979474477531875],
            [34.31578250922814, 0.979157872138974],
            [34.31560617353114, 0.978669038096069],
            [34.314062469021025, 0.979513912301246],
            [34.313091032669405, 0.981394701015882],
            [34.31221443505558, 0.98206662215213],
            [34.31081918073946, 0.982556449089506],
            [34.309107739206226, 0.982365260012173],
            [34.3077546383348, 0.981847513016264],
            [34.30351267768054, 0.982199186823453],
            [34.30344000756731, 0.979919612116034],
            [34.30322037666686, 0.978705137916892],
            [34.30255798143422, 0.978079275002552],
            [34.302024985823316, 0.9747973902396],
            [34.301860718992145, 0.972165379414902],
            [34.30221713636092, 0.97163158744676],
            [34.3022166189313, 0.970283884954405],
            [34.29696111698972, 0.970376373011005],
            [34.29518004075062, 0.969724799753918],
            [34.29478082225184, 0.969123228430065],
            [34.299117740221554, 0.966328003537968],
            [34.301729383501005, 0.963425545240123],
            [34.3015245837859, 0.962897262282893],
            [34.30042279739498, 0.962656424723209],
            [34.30199044110906, 0.962128872772348],
            [34.301196838844376, 0.960505882352871],
            [34.30149716989834, 0.956731089851742],
            [34.30197966132567, 0.95627204464675],
            [34.30558928976663, 0.955250243597145],
            [34.306357402335145, 0.956823384267274],
            [34.30741543448353, 0.957633076432316],
            [34.308420131856856, 0.959346899412297],
            [34.30750561994817, 0.960201821989718],
            [34.307513276289335, 0.961085855554118],
            [34.30783523608041, 0.960923657902838],
            [34.30809887903989, 0.961365574023109],
            [34.308662235012434, 0.960886503418546],
            [34.30974582692561, 0.961998495300682],
            [34.310623851064086, 0.961423532351659],
            [34.31142188741302, 0.962204121218818],
            [34.31243180399814, 0.962041655062234],
            [34.312592476669856, 0.961157558872024],
            [34.313675681409144, 0.961260275751758],
            [34.31363889629657, 0.960759336026901],
            [34.31513917175426, 0.960618782021232],
            [34.31561510009009, 0.961178484876668],
            [34.31597333654732, 0.960191173957454],
            [34.316661455936405, 0.960618190114646],
            [34.31751729078905, 0.959446512204077],
            [34.31849817831577, 0.959932348171606],
            [34.318490645043816, 0.959372464576059],
            [34.31950058049354, 0.959268933880026],
            [34.319858804374356, 0.958252157298182],
            [34.320627053486795, 0.957706704643305],
            [34.320692495755246, 0.956594271253279],
            [34.3220540785196, 0.957411472339774],
            [34.322917398135196, 0.95668180975611],
            [34.32454937918997, 0.956482267845986],
            [34.324988168477, 0.955627532960534],
            [34.32640791266443, 0.955442807537783],
            [34.326837055841956, 0.956134348498157],
            [34.32772390772472, 0.95571082035326],
            [34.32796454033821, 0.956747754869885],
            [34.32977541369526, 0.956449424626065],
            [34.33051900944306, 0.955923644745822],
            [34.33052336357726, 0.955235392018251],
            [34.3313688022271, 0.955244362246177],
            [34.33136907172169, 0.955941913037496],
            [34.331900438686986, 0.956155621234931],
            [34.33280592971359, 0.956150615620928],
            [34.33277803702401, 0.955704194403283],
            [34.33339696727162, 0.955364476353243],
            [34.334039198021074, 0.955545588360388],
            [34.33455692586537, 0.956331291964408],
            [34.33546702255446, 0.956293732346524],
            [34.335897223947406, 0.9577212157976],
            [34.33662249945327, 0.957613971934924],
            [34.338189020273276, 0.958617826453144],
            [34.33921455945953, 0.958440708857373],
            [34.33950266444249, 0.958802372965153],
            [34.33909418431314, 0.959224398057292],
            [34.33914819911284, 0.960066745118714],
            [34.34001740179523, 0.962177136040024],
            [34.33853133678702, 0.963494626697267],
            [34.337438473361836, 0.96543348858415],
            [34.33551286538004, 0.965745359120682],
            [34.335221902856134, 0.96654418379552],
            [34.33589414811588, 0.968018674967854],
            [34.330043713521185, 0.971467339739981],
            [34.32924136975044, 0.9715873149545],
            [34.32806868741899, 0.976034925852159],
            [34.32694087593597, 0.97823371151907],
            [34.32581271680493, 0.978778205203286],
            [34.32494557575612, 0.979985946589528],
            [34.32333741353112, 0.980072633010003],
            [34.32232425133287, 0.981133932285445],
            [34.319117254988775, 0.98129051621802],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 921,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUWAGOGO",
        Population: 6994,
        Key: "MANAFWABUWAGOGO",
        Dist2: "Manafwa",
        "Sub Country": "Buwagogo",
        id2_original: "Manafwa Buwagogo",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.222253277053206, 0.629450234439814],
            [34.222443510585975, 0.628936979713667],
            [34.22290436249638, 0.629272924886643],
            [34.22333438422628, 0.628999672952909],
            [34.223619099865694, 0.629566211620705],
            [34.2242489680002, 0.628851353865815],
            [34.22495910509691, 0.629580092448765],
            [34.22535849966549, 0.628491371194953],
            [34.22599794384091, 0.628684900677281],
            [34.22671653049118, 0.627623154924698],
            [34.227414627468164, 0.627835345818823],
            [34.22739797988932, 0.627051094432869],
            [34.22850760048783, 0.627309985064561],
            [34.22837786669281, 0.626375352033981],
            [34.22965265064116, 0.625277392389063],
            [34.23055908489881, 0.625317204249751],
            [34.2302716608388, 0.626313419590864],
            [34.231514241082536, 0.625903854497179],
            [34.23283455075114, 0.627355812566682],
            [34.23364713890939, 0.627633088797399],
            [34.23486291701829, 0.62742430410239],
            [34.234965200993166, 0.626217676579334],
            [34.236285391185866, 0.625450978782577],
            [34.23655011122536, 0.625779103014754],
            [34.236151463156766, 0.626771482691312],
            [34.23699509888786, 0.626118768092035],
            [34.23724830342374, 0.626400561745844],
            [34.2369914229817, 0.626794447645684],
            [34.23776238859957, 0.626998898254118],
            [34.238107841131985, 0.628122373548867],
            [34.23908178737649, 0.62707580380983],
            [34.23968409340145, 0.627697283047059],
            [34.23950018760157, 0.628512003357339],
            [34.24056261520662, 0.628600551254515],
            [34.240252062222986, 0.62908325435597],
            [34.240923510677064, 0.630144872258522],
            [34.2406014637494, 0.630681632556028],
            [34.24104272250515, 0.631465313000609],
            [34.24056729273431, 0.632141106839303],
            [34.24127142459333, 0.632929855947613],
            [34.24167962624495, 0.632411108701391],
            [34.24314853792282, 0.632206119348836],
            [34.24373903469506, 0.631557325439147],
            [34.244778425902986, 0.631537768506892],
            [34.246013143193025, 0.630359861132863],
            [34.2475627137019, 0.63017606975966],
            [34.24821380722995, 0.628936229665581],
            [34.25048642632115, 0.628471397457979],
            [34.25096204383993, 0.629107874795472],
            [34.25179402482851, 0.628753478428669],
            [34.253420562092636, 0.630605424103864],
            [34.25430015738454, 0.630533414121975],
            [34.25483760235107, 0.631236885292612],
            [34.256588257143065, 0.631900541863066],
            [34.25677804421314, 0.632878461974319],
            [34.25797244780817, 0.632643320729319],
            [34.25761606547371, 0.633538466008253],
            [34.2582415013206, 0.63435917949423],
            [34.26126563750374, 0.635090754009824],
            [34.261534714372395, 0.636892764059481],
            [34.2638061584672, 0.636786821502769],
            [34.26555256692284, 0.637612120088099],
            [34.26650822706144, 0.637518547480217],
            [34.267710963429046, 0.636757213063025],
            [34.26835109751061, 0.637391715008847],
            [34.26864590572225, 0.638608748965376],
            [34.270087168153985, 0.639451301922105],
            [34.27069138309891, 0.638295641748489],
            [34.27216126405897, 0.637506574576952],
            [34.27234236172529, 0.637804788697277],
            [34.27085912910517, 0.639680700285178],
            [34.27255849997593, 0.640859849622199],
            [34.27309033316683, 0.64067630833865],
            [34.2727226545177, 0.639226897870907],
            [34.2733909921059, 0.638882897753219],
            [34.274106678096146, 0.639087516757867],
            [34.27335449175931, 0.639419020277879],
            [34.27380412910171, 0.639575690179051],
            [34.27381310057646, 0.640208735698881],
            [34.27630777961264, 0.639601684905356],
            [34.276901497743474, 0.640128089088443],
            [34.2774686014874, 0.639985953937026],
            [34.27757164364036, 0.64075800949664],
            [34.27719561604898, 0.641187038689513],
            [34.2780450620833, 0.642015110390991],
            [34.27718709283355, 0.642364390263797],
            [34.27828033444948, 0.642766423951571],
            [34.27784254408902, 0.642982481227623],
            [34.27807194326987, 0.643754503099313],
            [34.279473858593846, 0.644662303802678],
            [34.27966511710437, 0.645670988626981],
            [34.27817843315693, 0.64655290029208],
            [34.27870491238876, 0.647049266908835],
            [34.27883160089495, 0.64838790559952],
            [34.279726347172435, 0.648733623442968],
            [34.27879310988165, 0.649400964197547],
            [34.278912960411894, 0.650011929326925],
            [34.2781372202483, 0.65151311316558],
            [34.278309704867716, 0.652021619240324],
            [34.27935712521762, 0.652412829063241],
            [34.27928952519585, 0.653787697519618],
            [34.278862318786096, 0.654375736809413],
            [34.27793014779553, 0.654511653824859],
            [34.27686940812489, 0.65577449924782],
            [34.27811776992577, 0.656833159930315],
            [34.27860259876944, 0.656265849991016],
            [34.27943007111363, 0.656915384510796],
            [34.2796473645977, 0.656010706553831],
            [34.28022246783925, 0.656681879202407],
            [34.280146905150794, 0.657198790634638],
            [34.27814696876576, 0.659457275662654],
            [34.27838630241535, 0.66106543081605],
            [34.27955608498506, 0.661614361005185],
            [34.280083779637465, 0.661341401843466],
            [34.280493973752385, 0.661754117865121],
            [34.280237298126266, 0.662044955877978],
            [34.28057647412978, 0.663624366031887],
            [34.28024856030497, 0.664231122894729],
            [34.28120404886536, 0.663480611091444],
            [34.28144795314308, 0.663781937926575],
            [34.28141152106843, 0.665975444711799],
            [34.28034520016492, 0.665616748281802],
            [34.28044775543102, 0.667095598613052],
            [34.27980286477003, 0.666493165401438],
            [34.27818475819483, 0.664991770490974],
            [34.277031243216584, 0.664489982888701],
            [34.27167000507448, 0.666248694652221],
            [34.27117104842633, 0.665495690498863],
            [34.271295368075144, 0.664052150090183],
            [34.2707029192638, 0.663393311478363],
            [34.26795957937044, 0.662829171331387],
            [34.265091099666456, 0.660507741675952],
            [34.262690633242336, 0.659849364296693],
            [34.25947945973216, 0.658343911747586],
            [34.25795163114807, 0.656900785152074],
            [34.24498452458199, 0.660104923429895],
            [34.24382371438532, 0.657435963498731],
            [34.24226064579095, 0.65836748198457],
            [34.2407277363356, 0.658396389658415],
            [34.24116604232906, 0.656240175129468],
            [34.24078202961308, 0.655627651383605],
            [34.241371752935855, 0.655175107057552],
            [34.241596193416335, 0.654128884185705],
            [34.24085595557108, 0.651678587411016],
            [34.23878633058125, 0.649539642591049],
            [34.2382523387387, 0.64818258363215],
            [34.236754020710016, 0.64684461229295],
            [34.23585517452155, 0.646637484764336],
            [34.233944910663126, 0.645309036352464],
            [34.23357956763372, 0.644451453802099],
            [34.23231537122934, 0.643358468060628],
            [34.23115383519391, 0.640898835863192],
            [34.23064777017692, 0.638261651607369],
            [34.22924010563513, 0.636936649439383],
            [34.22881608375302, 0.635657111462628],
            [34.22719630720972, 0.633250556485177],
            [34.22448163615035, 0.632065131058024],
            [34.222253277053206, 0.629450234439814],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 922,
        District: "TORORO",
        County: "TORORO",
        Subcounty: "MALABA TOWN COUNCIL",
        Population: 17968,
        Key: "TOROROMALABA TOWN COUNCIL",
        Dist2: "Tororo",
        "Sub Country": "Malaba TC",
        id2_original: "Tororo Malaba TC",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.11786865476293, 0.813045837504482],
            [34.11754091071974, 0.814404370909694],
            [34.11626143307403, 0.81607816707789],
            [34.116239913931395, 0.817462151531256],
            [34.11512927194842, 0.820393241731757],
            [34.113126696313074, 0.823053216572069],
            [34.11284332904493, 0.823966904664872],
            [34.108236498773365, 0.824637578527514],
            [34.104862734688375, 0.824376202133604],
            [34.102307718509486, 0.823743721543707],
            [34.10145106349499, 0.823119810795138],
            [34.10121213678225, 0.822260540437534],
            [34.0983867780085, 0.822957842396972],
            [34.084799434146085, 0.829709694379762],
            [34.08156689061362, 0.830732244412468],
            [34.08066377652924, 0.828239008861991],
            [34.08061209914589, 0.827027559471013],
            [34.08190488623086, 0.818741408030147],
            [34.083931470240465, 0.811550727608643],
            [34.08597038272903, 0.807876441557865],
            [34.08338038974626, 0.803648113282945],
            [34.07968389331901, 0.799538215563753],
            [34.07909928410515, 0.798635607884689],
            [34.078148729990644, 0.793167082495542],
            [34.07742511277476, 0.791249817193851],
            [34.068677292486875, 0.791944519604584],
            [34.06663135876603, 0.791838526728779],
            [34.06393042474399, 0.79109247790037],
            [34.0625725654965, 0.790185763464998],
            [34.061666772635945, 0.788440162959031],
            [34.058106970150554, 0.78506362163125],
            [34.054871958946, 0.779747679054117],
            [34.05452122162477, 0.778056890628409],
            [34.05506458109912, 0.776813228324362],
            [34.05496717677284, 0.775379754648277],
            [34.05610664748993, 0.775071910417761],
            [34.05843588290194, 0.775713573957112],
            [34.05984698170307, 0.774609632037133],
            [34.06107083656467, 0.774880695451108],
            [34.06439613564179, 0.774472793394305],
            [34.06513175884142, 0.774038409583869],
            [34.06916080529863, 0.769288365043219],
            [34.072612486556466, 0.766763726752837],
            [34.080496286542854, 0.758891946861153],
            [34.08246102603672, 0.755119387900313],
            [34.08289691196876, 0.753129220615299],
            [34.084708435706105, 0.756608835702138],
            [34.0887974483018, 0.758211415897537],
            [34.09450495464657, 0.761692547617462],
            [34.097108298391106, 0.762614537272276],
            [34.10516866044993, 0.760423407464685],
            [34.109942214444956, 0.759653292041027],
            [34.11306080219206, 0.757183026455568],
            [34.11357371596478, 0.764347024324166],
            [34.11428116620047, 0.767956040824571],
            [34.11620392203122, 0.77355476660883],
            [34.11599190165788, 0.774586022875889],
            [34.11632951189786, 0.777019202963085],
            [34.117281745861966, 0.778122512796555],
            [34.11772680988125, 0.781234082248309],
            [34.118870791937695, 0.783214761001596],
            [34.118565741135214, 0.784978736110054],
            [34.1188746582867, 0.785717204965846],
            [34.116226952140174, 0.788381053121698],
            [34.11518732737027, 0.790421642211164],
            [34.11504972433338, 0.792342815193716],
            [34.115110580702314, 0.793093583991615],
            [34.11697602671287, 0.796513017282086],
            [34.117297665805424, 0.798785119732076],
            [34.11704952597112, 0.802704851851471],
            [34.11737194300469, 0.804638464031692],
            [34.11871231834181, 0.807941062629549],
            [34.118151936691156, 0.809132796339466],
            [34.11842634506098, 0.810068495019193],
            [34.117436414194316, 0.812550942533574],
            [34.11786865476293, 0.813045837504482],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 923,
        District: "TORORO",
        County: "WEST BUDAMA",
        Subcounty: "PETTA",
        Population: 15791,
        Key: "TOROROPETTA",
        Dist2: "Tororo",
        "Sub Country": "Petta",
        id2_original: "Tororo Petta",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.477312561799, 0.931076557363039],
            [34.46946738847152, 0.930681916667469],
            [34.46150267453255, 0.929165804194819],
            [34.46100276746682, 0.927519936553245],
            [34.45890972429586, 0.92455425127197],
            [34.457078486131316, 0.923234530014317],
            [34.4565311722731, 0.922375539413293],
            [34.454273348434626, 0.922928179585906],
            [34.45315671558701, 0.925090253780574],
            [34.451801532420745, 0.924783303515761],
            [34.449567294748356, 0.925354024042232],
            [34.44740455398946, 0.927751689485335],
            [34.443886153957195, 0.927309963102275],
            [34.441507920836344, 0.925945229678277],
            [34.434424349088204, 0.927494737620034],
            [34.430026947550424, 0.929531546467544],
            [34.423846553667026, 0.930212406726256],
            [34.419733318898004, 0.929544784095924],
            [34.41169753564367, 0.929032496464091],
            [34.39859857166523, 0.928621704156156],
            [34.39685207697131, 0.928667624492853],
            [34.39636605785988, 0.929031861438664],
            [34.387621464320475, 0.920700476247116],
            [34.3833723153473, 0.919189824157232],
            [34.38326891566483, 0.922162902498128],
            [34.38094533245259, 0.924207440711562],
            [34.381095667312046, 0.925972009450936],
            [34.37848748344475, 0.925994553321784],
            [34.37669016836026, 0.929019275001313],
            [34.37174641955151, 0.929230171697458],
            [34.37131708682946, 0.92839364377045],
            [34.370808818245095, 0.924209636806697],
            [34.37016562629828, 0.922758773909769],
            [34.36821456095967, 0.920703532819326],
            [34.36819472885315, 0.919801162163692],
            [34.368720586450785, 0.91895743025057],
            [34.36735625843493, 0.918546000852428],
            [34.36649787596015, 0.916172681220493],
            [34.36381976992608, 0.915078875009618],
            [34.36229075646414, 0.914862801144085],
            [34.3611181981002, 0.915177034873562],
            [34.356814516897686, 0.918055045680601],
            [34.35443488420162, 0.917460030366246],
            [34.35140229127837, 0.915884454076067],
            [34.3505018451904, 0.915875522370118],
            [34.34521670333603, 0.911508555027123],
            [34.343392369622734, 0.909411401863478],
            [34.343305177344625, 0.90844992395857],
            [34.34378999001862, 0.907210964055077],
            [34.3466046606371, 0.904115726662732],
            [34.347774175508874, 0.900209861733192],
            [34.34516142640334, 0.897314636994493],
            [34.344746920375044, 0.895017400328052],
            [34.343961994039354, 0.89395514620316],
            [34.343148801314925, 0.893610837800364],
            [34.34052439207699, 0.894243589761511],
            [34.33940733522454, 0.894034931141756],
            [34.33660066769694, 0.891416363528601],
            [34.33769858684055, 0.890209826703849],
            [34.33869607972529, 0.887409509470437],
            [34.339337685247294, 0.886605186087791],
            [34.338709640692834, 0.885456716840553],
            [34.33916568032829, 0.884293495064473],
            [34.341614991747655, 0.88290585730063],
            [34.341745949946414, 0.883193360399174],
            [34.34235776014706, 0.883023326819959],
            [34.344368515841374, 0.885043044422085],
            [34.345142344390055, 0.887696730182602],
            [34.34697173202512, 0.888717464687715],
            [34.346699854209454, 0.889779419424973],
            [34.34740798896139, 0.890444854197716],
            [34.34697449075138, 0.891132608387109],
            [34.34821069834646, 0.891919529829837],
            [34.34839928167406, 0.892813490341598],
            [34.35121199576183, 0.892196757644985],
            [34.35148749468644, 0.892584780981911],
            [34.35368225679197, 0.892154166494845],
            [34.35503178686014, 0.890318672307621],
            [34.35583968042272, 0.888067012600917],
            [34.35719291424482, 0.886560634983874],
            [34.35780014842742, 0.886441132932335],
            [34.357980492407236, 0.885460010569314],
            [34.35905269008933, 0.885009342755268],
            [34.359932710284355, 0.885584529144082],
            [34.36021087361208, 0.884776323309452],
            [34.36047046606795, 0.884920614163085],
            [34.36100494479739, 0.88552989743954],
            [34.36250970913655, 0.885523230939769],
            [34.3628314317724, 0.885904847162859],
            [34.36518350685048, 0.886508670970757],
            [34.365482098766094, 0.887062169005519],
            [34.36699767343139, 0.887691776568399],
            [34.367103276681235, 0.888475034957618],
            [34.36930919586259, 0.888986592711513],
            [34.371814471425864, 0.892112951396448],
            [34.37253412168146, 0.892136238295364],
            [34.37317803677204, 0.893031191272276],
            [34.37377472113996, 0.89278949835509],
            [34.37385098451431, 0.893337187646747],
            [34.37514414260349, 0.893725402181198],
            [34.37548975593431, 0.894850155323931],
            [34.37685258106869, 0.893789540376532],
            [34.3781455945291, 0.89379493949272],
            [34.37945006779758, 0.893158387144122],
            [34.38247406474187, 0.890954595504591],
            [34.38508662969278, 0.891127859568617],
            [34.39119796379208, 0.897773352117701],
            [34.396500469182584, 0.895103144838134],
            [34.39711636402283, 0.893221625346841],
            [34.40072650989338, 0.891185199283357],
            [34.40148657804856, 0.890388981243186],
            [34.402935940589195, 0.890243710659238],
            [34.403870556793954, 0.89124713961146],
            [34.40722842519001, 0.895686901227476],
            [34.410675715482704, 0.898091419970575],
            [34.41349169764151, 0.898777708652926],
            [34.415273588652575, 0.898849368326323],
            [34.42047572527638, 0.896758040795246],
            [34.42680699121173, 0.895688301529896],
            [34.427590661702645, 0.894973477171607],
            [34.43015654480151, 0.895189535156093],
            [34.43141532256811, 0.894537835706698],
            [34.43267504356576, 0.894871985315817],
            [34.433173295036426, 0.893795495482233],
            [34.43478785326626, 0.892501497498296],
            [34.43749600076002, 0.891785917128123],
            [34.439691448280115, 0.888212488061787],
            [34.441112728586646, 0.88232398872189],
            [34.443236315375586, 0.878795822996756],
            [34.44300349630845, 0.869127399527644],
            [34.442157481838514, 0.865365233379257],
            [34.44237038435747, 0.864071795011888],
            [34.443511027376, 0.864378868919522],
            [34.44415318626022, 0.86516548880562],
            [34.44622040915499, 0.865499337450111],
            [34.446814764191366, 0.866096041719825],
            [34.44786047774226, 0.866339837284995],
            [34.44769080305306, 0.869062276467239],
            [34.44709653694989, 0.870174971385635],
            [34.44700261449366, 0.872734581898303],
            [34.44757458710643, 0.876451620898823],
            [34.44852624165717, 0.87887515466613],
            [34.45097664273302, 0.882591449236374],
            [34.452428827780295, 0.888325032542199],
            [34.45238260676397, 0.892177968963989],
            [34.450957707145136, 0.89589579149027],
            [34.451220055632284, 0.89756890358607],
            [34.45333676402109, 0.899449290902488],
            [34.4558089923617, 0.900045226250447],
            [34.45704584404885, 0.900786367002214],
            [34.458068284945675, 0.90178988109078],
            [34.45937696861788, 0.905217171823675],
            [34.461779062789276, 0.907359710906547],
            [34.46313423248082, 0.907666666256961],
            [34.46498901369233, 0.908932117581546],
            [34.466582795686264, 0.911888967639822],
            [34.466987810115285, 0.913589138752211],
            [34.46827193384762, 0.914565397874583],
            [34.469508756788684, 0.916599863529111],
            [34.471482907033476, 0.918624975073093],
            [34.472602212369054, 0.923001963917251],
            [34.47469510911463, 0.925623939755415],
            [34.47524280026525, 0.927387351809542],
            [34.477312561799, 0.931076557363039],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 924,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "BUPOTO",
        Population: 13637,
        Key: "NAMISINDWABUPOTO",
        Dist2: "Manafwa",
        "Sub Country": "Bupoto",
        id2_original: "Manafwa Bupoto",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32420866257572, 0.765214942347605],
            [34.3245332436508, 0.765982624355561],
            [34.32355153775886, 0.766346292747925],
            [34.323009599419315, 0.767208508372389],
            [34.32320235003152, 0.769102956901539],
            [34.32168887113579, 0.774173433809459],
            [34.31726066726523, 0.781567474433627],
            [34.3206267830939, 0.783966223082937],
            [34.320183394432604, 0.785841865029935],
            [34.319676042129814, 0.786001645014825],
            [34.3184398812471, 0.788021196919599],
            [34.31764716921283, 0.788364627185189],
            [34.31767133209736, 0.789561748766078],
            [34.31702132912406, 0.789905133993021],
            [34.31619721647905, 0.791238203084772],
            [34.312899705886934, 0.793218515997958],
            [34.31182197278607, 0.794815038147156],
            [34.31089442811922, 0.794998895708395],
            [34.30927740940383, 0.796076833915443],
            [34.30850875694783, 0.797298156926594],
            [34.30685203718846, 0.798192549704949],
            [34.30594584098437, 0.799220267154947],
            [34.30520763692492, 0.799291762501482],
            [34.30380243825856, 0.800758111161325],
            [34.29980027298792, 0.803233076734972],
            [34.29976452183624, 0.802292839538775],
            [34.29869261520831, 0.801648524038771],
            [34.294312930244544, 0.797242550306222],
            [34.29291174255595, 0.790607492241114],
            [34.29212779628223, 0.789152084910258],
            [34.29115786191375, 0.783783892027017],
            [34.2900982720867, 0.78050087534365],
            [34.28915771711959, 0.774576173748913],
            [34.28958630962986, 0.773950104266152],
            [34.28802492447833, 0.771105939993531],
            [34.28704227535533, 0.767147231695439],
            [34.28502184480541, 0.762687991395289],
            [34.28577139638354, 0.760432489530597],
            [34.28507494062859, 0.75979145336156],
            [34.28570572504469, 0.757569164983213],
            [34.290248705760796, 0.756020865017688],
            [34.29588514548513, 0.755858909275709],
            [34.297317022318786, 0.755096146010894],
            [34.30131120785477, 0.754212385537405],
            [34.30428276564437, 0.752201076911484],
            [34.30572805073194, 0.750704678831776],
            [34.30533151819584, 0.748337123558127],
            [34.306806810607156, 0.746563865341153],
            [34.310650654995506, 0.746684864424072],
            [34.31043238863598, 0.747463650145257],
            [34.31114851839396, 0.751079212697863],
            [34.312240822168754, 0.752166963633483],
            [34.31219136811575, 0.753612172448829],
            [34.31319455003116, 0.753254753820411],
            [34.31351068694259, 0.753868446808812],
            [34.313660649001186, 0.754861622540037],
            [34.31321736364612, 0.755386269454788],
            [34.31321760259798, 0.756178614309524],
            [34.31529484080985, 0.75778615382887],
            [34.31432025586316, 0.758118540923841],
            [34.31400933277365, 0.758865832431678],
            [34.31409946433936, 0.759394126599817],
            [34.314755631552124, 0.7598203550127],
            [34.31472978522477, 0.76111852363655],
            [34.3157982647799, 0.761363485168765],
            [34.31705073906816, 0.762600878699988],
            [34.31820144142123, 0.762023145126064],
            [34.31888065670925, 0.76426452050817],
            [34.31932688764013, 0.764671942985295],
            [34.32044403432408, 0.764698012467829],
            [34.321860760172136, 0.763667349341665],
            [34.32295533309132, 0.763433038319349],
            [34.32326307344978, 0.764542412964399],
            [34.32237087569277, 0.764584201565485],
            [34.32222853494105, 0.764950295311575],
            [34.32420866257572, 0.765214942347605],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 925,
        District: "NAMISINDWA",
        County: "BUBULO",
        Subcounty: "NAMBOKO",
        Population: 10258,
        Key: "NAMISINDWANAMBOKO",
        Dist2: "Manafwa",
        "Sub Country": "Namboko",
        id2_original: "Manafwa Namboko",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34440425890822, 1.168289502888758],
            [34.34350348763014, 1.169916373358834],
            [34.34244625588065, 1.170101368864739],
            [34.34104516970171, 1.171164587814659],
            [34.34007870642348, 1.171229668835856],
            [34.33891867955774, 1.172631690578367],
            [34.33845957037897, 1.175059438585979],
            [34.33767311870394, 1.175845599025729],
            [34.336771637756755, 1.176271528120626],
            [34.334860277055384, 1.176152498583446],
            [34.33462430849486, 1.176433256356061],
            [34.33527612157345, 1.176566603804206],
            [34.33533496661445, 1.177187196149947],
            [34.33358891928154, 1.177807650944345],
            [34.33327851811321, 1.178302852147011],
            [34.330482897168636, 1.178543908974756],
            [34.33046263926066, 1.179492332670547],
            [34.32954108096688, 1.179492777242392],
            [34.329016966999205, 1.181291549383116],
            [34.32802506792373, 1.181458081393886],
            [34.32629695994706, 1.183793476647159],
            [34.324655869076985, 1.184039188870734],
            [34.32441809669939, 1.184847020282158],
            [34.32338717929955, 1.185479663589716],
            [34.321333189487234, 1.184433607849635],
            [34.32098293905293, 1.183689950841254],
            [34.31963201120614, 1.184531578735054],
            [34.319001315723256, 1.183945928625675],
            [34.31927252609071, 1.183393242226336],
            [34.316988954739564, 1.182990545092263],
            [34.31594599991489, 1.18448173468686],
            [34.315502473811364, 1.184223884364617],
            [34.31540014671736, 1.184709699035775],
            [34.31461889538946, 1.184679712496315],
            [34.31418314600134, 1.185805811551999],
            [34.31316193399985, 1.184793842406219],
            [34.30996910678273, 1.184660969561764],
            [34.30889214802962, 1.184990010475172],
            [34.30939993152376, 1.185802124757474],
            [34.30869078257386, 1.185856222291861],
            [34.30777067056766, 1.185301151756848],
            [34.3078599792766, 1.185919337876948],
            [34.307257686726366, 1.186048048759838],
            [34.30735135495935, 1.18675482552714],
            [34.30656614295941, 1.186691885095076],
            [34.306833979254606, 1.181762258118512],
            [34.307702625879855, 1.177961743228208],
            [34.30861330108397, 1.177596725267335],
            [34.310132482485145, 1.17546971705297],
            [34.31188233957315, 1.175026954253006],
            [34.31429215027287, 1.17356400478569],
            [34.316992851631234, 1.173085859072533],
            [34.31929151378086, 1.16994961217863],
            [34.322573128684034, 1.166617959434809],
            [34.32435933610002, 1.165939595276013],
            [34.32606461159713, 1.164204515823617],
            [34.32971217858747, 1.160627720423521],
            [34.330376494418175, 1.158016444695616],
            [34.3311581904121, 1.15671960852314],
            [34.332817911442845, 1.155735703603669],
            [34.33484417295729, 1.156479817088801],
            [34.33628627711044, 1.15773399120773],
            [34.33477871721408, 1.161336483095465],
            [34.332825661208794, 1.16217880837448],
            [34.33196381303365, 1.16321546362834],
            [34.33206989239059, 1.164251658658862],
            [34.332748659419266, 1.164971621893329],
            [34.33523780573162, 1.165055807172209],
            [34.338761522892064, 1.160485655857092],
            [34.34069059028602, 1.161661162735096],
            [34.34409189941258, 1.161176406551308],
            [34.34359177944612, 1.16254185245471],
            [34.34440425890822, 1.168289502888758],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 926,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUDADIRI TOWN COUNCIL",
        Population: 17001,
        Key: "SIRONKOBUDADIRI TOWN COUNCIL",
        Dist2: "Sironko",
        "Sub Country": "Budadiri T.C.",
        id2_original: "Sironko Budadiri T.C.",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.40972848962632, 1.170496448143099],
            [34.40824140323361, 1.170592744509984],
            [34.407212882538964, 1.170227016964048],
            [34.40641747376221, 1.170555137204099],
            [34.40123916854457, 1.169920277521356],
            [34.39759255376842, 1.168128304976952],
            [34.3947753642739, 1.168092524431609],
            [34.39184788591698, 1.170211311401005],
            [34.38946463301031, 1.170768779350744],
            [34.38761189277114, 1.170524494879055],
            [34.38566452040662, 1.168113798403836],
            [34.385595208195944, 1.167566573085606],
            [34.38569804373641, 1.166299580742104],
            [34.386740725473196, 1.165266419447933],
            [34.38680751880785, 1.162089082442562],
            [34.38591615378907, 1.161437087210665],
            [34.38489286398433, 1.15949920604264],
            [34.38283181610881, 1.157440193386509],
            [34.38162227500296, 1.15705656975073],
            [34.38084196870274, 1.154229217902707],
            [34.37979484749183, 1.153362431398145],
            [34.37826706472182, 1.150706923968533],
            [34.37952298943907, 1.150646736407869],
            [34.381512944642985, 1.148362582785088],
            [34.386136815057164, 1.146864449439284],
            [34.38852007874359, 1.147325471248091],
            [34.391876214289454, 1.147106754665116],
            [34.394347301769656, 1.145753530366493],
            [34.397616165087356, 1.146109270210639],
            [34.39856346999549, 1.147255688837776],
            [34.39953083248731, 1.147734867281896],
            [34.40266694277232, 1.147010471869928],
            [34.40316406146738, 1.145948879360422],
            [34.40479192194993, 1.145783634976123],
            [34.40671309494916, 1.144993665269869],
            [34.40890328822316, 1.143046073041281],
            [34.41102570810054, 1.141896534400014],
            [34.41281415052497, 1.139679865251525],
            [34.41464047400663, 1.13813539153476],
            [34.41815609644804, 1.136014179066845],
            [34.41880494508617, 1.134697908874216],
            [34.421289888181306, 1.132575706828526],
            [34.422131004138045, 1.129916201437082],
            [34.42328895320049, 1.128586085428063],
            [34.425408232567655, 1.128114723918093],
            [34.429833930138585, 1.126294590880095],
            [34.43387016760966, 1.12395007089513],
            [34.43458273644584, 1.121426310182893],
            [34.4366555208105, 1.118947103319757],
            [34.436946774388566, 1.116179354571157],
            [34.43870847037371, 1.113776420986389],
            [34.442009107103026, 1.111785972571544],
            [34.443483766202085, 1.110060489573461],
            [34.4468969851927, 1.108785134465861],
            [34.450084202430844, 1.106793789033536],
            [34.45422892674382, 1.105387344213495],
            [34.45441176893844, 1.104789716400978],
            [34.45392125465734, 1.103929092621228],
            [34.45436755925006, 1.103238946213263],
            [34.457256719070216, 1.102431995369676],
            [34.459697542308476, 1.10015103732635],
            [34.46071068833703, 1.099815325120038],
            [34.4667968705067, 1.10012570321796],
            [34.47108184339509, 1.101429113042947],
            [34.472806877336865, 1.101075525112788],
            [34.47453979848685, 1.099627570492889],
            [34.475888067320355, 1.097699249332878],
            [34.47745544962472, 1.093283839780309],
            [34.47897844437427, 1.091889007991115],
            [34.48279699489918, 1.090864461388632],
            [34.48760236362829, 1.092151633062434],
            [34.49326461913727, 1.095846735364007],
            [34.49434559964788, 1.096832010423135],
            [34.49625174742569, 1.099961545698751],
            [34.4999546317729, 1.103553589262543],
            [34.5052802472224, 1.107480288136575],
            [34.51618098698821, 1.111390028398971],
            [34.52023938859231, 1.113522609530113],
            [34.52490287740544, 1.115596477379838],
            [34.525847654454374, 1.116957173038985],
            [34.52635629853455, 1.119046711976567],
            [34.52538570210772, 1.123311192463062],
            [34.526996245766554, 1.125495470067499],
            [34.5267902854281, 1.129958014372803],
            [34.526881962994416, 1.12924157381826],
            [34.523465244167475, 1.130441904643131],
            [34.51699151530951, 1.131372858501107],
            [34.51442422455062, 1.131918604335396],
            [34.51337256864413, 1.132565250685121],
            [34.5114826417454, 1.132751698212282],
            [34.50764298799788, 1.132430669823499],
            [34.50461715938871, 1.130550955057742],
            [34.50118115732587, 1.131042970704195],
            [34.49981131455247, 1.130401090446543],
            [34.49731269460716, 1.12997901649244],
            [34.49415979031789, 1.130606782567098],
            [34.489671684987535, 1.130141750581235],
            [34.485366305969144, 1.130588471280689],
            [34.47999884968867, 1.129259342636128],
            [34.475967344542504, 1.130505943852498],
            [34.47331503632678, 1.130337433842692],
            [34.467332346366085, 1.132315817496003],
            [34.46596773268596, 1.133393703689158],
            [34.46523586983411, 1.134886038478516],
            [34.463720040047285, 1.135904319634856],
            [34.461583990032075, 1.135902105722861],
            [34.457820004075856, 1.137204940115413],
            [34.45646262363039, 1.137108454009199],
            [34.454418581761566, 1.138058408528226],
            [34.45089792426296, 1.138980532138602],
            [34.44488379865721, 1.139360862034863],
            [34.44406621317104, 1.139812869544075],
            [34.44386228572009, 1.140864786894313],
            [34.44172110632462, 1.140665796505953],
            [34.43899015958895, 1.142227751097645],
            [34.434555391728594, 1.142652879621072],
            [34.43176469445009, 1.14232213449419],
            [34.429101321685046, 1.141321521960903],
            [34.426342163357866, 1.138859413763748],
            [34.42428472401486, 1.14128209643788],
            [34.42355015903061, 1.143194435311982],
            [34.41719018563373, 1.152489428647191],
            [34.41602194547136, 1.154800362182134],
            [34.41913891355599, 1.156868599673796],
            [34.42405564463427, 1.158302779880658],
            [34.42493668531547, 1.160803736128386],
            [34.419065410704484, 1.163074335043697],
            [34.416693984118574, 1.165218436878529],
            [34.41319781828786, 1.166273470330486],
            [34.41011392976529, 1.168010032216076],
            [34.41121727203828, 1.169577233011903],
            [34.40972848962632, 1.170496448143099],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 927,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUGITIMWA",
        Population: 8496,
        Key: "SIRONKOBUGITIMWA",
        Dist2: "Sironko",
        "Sub Country": "Bugitimwa",
        id2_original: "Sironko Bugitimwa",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30937746196356, 1.218348559383668],
            [34.304615385742906, 1.217558052586508],
            [34.30164781647319, 1.219332987168854],
            [34.30085484931738, 1.219555392888745],
            [34.299390045635306, 1.21925035548692],
            [34.29505992162411, 1.225721496284649],
            [34.29067747703579, 1.227949422699456],
            [34.287831902574894, 1.228092037013778],
            [34.2863706759843, 1.229080400327343],
            [34.28206439326073, 1.213367154821861],
            [34.28204950817646, 1.212621163388602],
            [34.28299853066345, 1.21166017573933],
            [34.2834491345931, 1.211845241190735],
            [34.28361899164027, 1.212498517822043],
            [34.28417114112969, 1.21229346937417],
            [34.28414247409231, 1.213136997868742],
            [34.28506265257383, 1.212648977084087],
            [34.28577970669825, 1.212868044166843],
            [34.28518358198075, 1.212273482740425],
            [34.28593920796682, 1.212107343280483],
            [34.28548846659491, 1.211629729660296],
            [34.28620810786734, 1.211655106781542],
            [34.28581284465074, 1.211234635621279],
            [34.28699424333539, 1.210091197232268],
            [34.28678509667263, 1.209445926717371],
            [34.28750377764604, 1.208336595307911],
            [34.2882243271152, 1.208157627821985],
            [34.287941877925256, 1.207779820208561],
            [34.288710546550945, 1.20682025974718],
            [34.28899229415666, 1.205712363354238],
            [34.28838087292652, 1.205144438498563],
            [34.28894887857897, 1.203955784543442],
            [34.289657135501784, 1.204250246545288],
            [34.289564900980004, 1.203730371545092],
            [34.29114353558161, 1.20288071227578],
            [34.29177836241649, 1.203826862544036],
            [34.293306563801416, 1.203103617801003],
            [34.293494387154276, 1.202214280401929],
            [34.294968501874266, 1.200386117527703],
            [34.29389519387449, 1.199566973485669],
            [34.29446860828327, 1.199147896135054],
            [34.29420681854823, 1.198624517500946],
            [34.29516980714292, 1.198695853273687],
            [34.29467289955191, 1.197484552236556],
            [34.29566860389096, 1.197606726966635],
            [34.296256899790755, 1.197232515758035],
            [34.296804184902854, 1.198129689068072],
            [34.29718453608573, 1.19797096092092],
            [34.29756491062481, 1.197538039718659],
            [34.29691237440241, 1.197041155294681],
            [34.297060823698054, 1.196241110559817],
            [34.29824753591764, 1.194691589936103],
            [34.29965981420672, 1.194722788828758],
            [34.30004553641668, 1.193466868314496],
            [34.301087733063206, 1.194349210401593],
            [34.30250891545339, 1.194101644477548],
            [34.30246480817294, 1.193599573684654],
            [34.30318336068726, 1.193082913730178],
            [34.303774765656236, 1.191533680521425],
            [34.30514760880268, 1.190672342793225],
            [34.30427145136336, 1.189162025643907],
            [34.30494705362729, 1.189073242708938],
            [34.30507365859018, 1.189637124856205],
            [34.30543462143427, 1.189617183860989],
            [34.306520574119986, 1.188437772037185],
            [34.30579206378078, 1.187126685977123],
            [34.30656614295941, 1.186691885095076],
            [34.30735135495935, 1.18675482552714],
            [34.307257686726366, 1.186048048759838],
            [34.3078599792766, 1.185919337876948],
            [34.30777067056766, 1.185301151756848],
            [34.30869078257386, 1.185856222291861],
            [34.30939993152376, 1.185802124757474],
            [34.30889214802962, 1.184990010475172],
            [34.30996910678273, 1.184660969561764],
            [34.31316193399985, 1.184793842406219],
            [34.31418314600134, 1.185805811551999],
            [34.31461889538946, 1.184679712496315],
            [34.31540014671736, 1.184709699035775],
            [34.315502473811364, 1.184223884364617],
            [34.31594599991489, 1.18448173468686],
            [34.316988954739564, 1.182990545092263],
            [34.31927252609071, 1.183393242226336],
            [34.319001315723256, 1.183945928625675],
            [34.31963201120614, 1.184531578735054],
            [34.32098293905293, 1.183689950841254],
            [34.321333189487234, 1.184433607849635],
            [34.32338717929955, 1.185479663589716],
            [34.32441809669939, 1.184847020282158],
            [34.324655869076985, 1.184039188870734],
            [34.32629695994706, 1.183793476647159],
            [34.32802506792373, 1.181458081393886],
            [34.329016966999205, 1.181291549383116],
            [34.32954108096688, 1.179492777242392],
            [34.33046263926066, 1.179492332670547],
            [34.330482897168636, 1.178543908974756],
            [34.33327851811321, 1.178302852147011],
            [34.33358891928154, 1.177807650944345],
            [34.33533496661445, 1.177187196149947],
            [34.33527612157345, 1.176566603804206],
            [34.33462430849486, 1.176433256356061],
            [34.334860277055384, 1.176152498583446],
            [34.336771637756755, 1.176271528120626],
            [34.33767311870394, 1.175845599025729],
            [34.33845957037897, 1.175059438585979],
            [34.33891867955774, 1.172631690578367],
            [34.34007870642348, 1.171229668835856],
            [34.34104516970171, 1.171164587814659],
            [34.34244625588065, 1.170101368864739],
            [34.34350348763014, 1.169916373358834],
            [34.34440425890822, 1.168289502888758],
            [34.34475437639189, 1.167112289635454],
            [34.34561125149364, 1.166504909231215],
            [34.345622848743965, 1.165718490205298],
            [34.34674109766079, 1.165538872409896],
            [34.34776103854615, 1.166143858610124],
            [34.34976628936439, 1.166310361884733],
            [34.35023255542104, 1.167126801602502],
            [34.35149447729114, 1.166996592665689],
            [34.35258689425366, 1.167494186599846],
            [34.353038984895115, 1.167206258168346],
            [34.355098422091295, 1.170425308334331],
            [34.35712477433559, 1.171574428566658],
            [34.35993581665863, 1.170734028093501],
            [34.36172223967028, 1.171400615744058],
            [34.36315893686373, 1.170984012963332],
            [34.36430555008564, 1.171137069184161],
            [34.364674203406885, 1.171387926099906],
            [34.36453499687721, 1.172227118395732],
            [34.365146675923846, 1.173512293335379],
            [34.36655198418465, 1.174457606733119],
            [34.36694548221169, 1.175618829356261],
            [34.367920429179435, 1.176676581113237],
            [34.37267265357635, 1.179670678723875],
            [34.37230326812817, 1.180997780073223],
            [34.370218378066696, 1.181890036941516],
            [34.36903935632431, 1.181703283689668],
            [34.36678045181255, 1.183520156979335],
            [34.36470651401102, 1.182875012238648],
            [34.363429086320814, 1.183140577569485],
            [34.3630566717535, 1.183633191226205],
            [34.364326837462926, 1.184554903895578],
            [34.36322156291378, 1.184740876486354],
            [34.36026974829749, 1.183977120454831],
            [34.35563542508669, 1.185067135902894],
            [34.3486289970619, 1.183896627931676],
            [34.347036620931355, 1.182491602241816],
            [34.345514060068105, 1.18350986717674],
            [34.34377082356371, 1.183828046320678],
            [34.341583045859544, 1.187928897834797],
            [34.34212330075622, 1.188947288302957],
            [34.34369472817431, 1.189809127721796],
            [34.34475370984194, 1.191568986557353],
            [34.343185120201845, 1.191368166688333],
            [34.3426245508033, 1.192936682639167],
            [34.34159600405751, 1.193338901421412],
            [34.339329421645, 1.195343015161092],
            [34.33686150701441, 1.195459098040234],
            [34.337363723648735, 1.19698655413499],
            [34.338272948073666, 1.197619566476601],
            [34.33568557547656, 1.198065314600183],
            [34.3338891596057, 1.197271389948165],
            [34.33085123787616, 1.197235903463566],
            [34.32735082031923, 1.195269612727407],
            [34.32466792895969, 1.195535907935151],
            [34.322616410412714, 1.196353181501372],
            [34.32490085223139, 1.199193215196633],
            [34.32769277301528, 1.199738959563469],
            [34.3280904122758, 1.200275989380804],
            [34.32658574675133, 1.205575286540749],
            [34.32658016462016, 1.210750817670756],
            [34.32254764886929, 1.21372983742136],
            [34.3207659725556, 1.213694221822869],
            [34.31986847922996, 1.212479121250827],
            [34.31806312961359, 1.212107615409097],
            [34.3170636020447, 1.211356511560913],
            [34.31497682911444, 1.211748419072289],
            [34.31473341801179, 1.213347446611338],
            [34.312568558127104, 1.21538244522221],
            [34.311936950854225, 1.21711012614405],
            [34.31093159681242, 1.217283062212244],
            [34.30937746196356, 1.218348559383668],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 928,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUHUGU",
        Population: 7432,
        Key: "SIRONKOBUHUGU",
        Dist2: "Sironko",
        "Sub Country": "Buhugu",
        id2_original: "Sironko Buhugu",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.23184369821299, 1.218805526914246],
            [34.232628590412695, 1.219325153837139],
            [34.232770070578354, 1.220052427668914],
            [34.23474028530389, 1.220175105224185],
            [34.236362659775004, 1.22102537607026],
            [34.235678935842586, 1.222145720293147],
            [34.23202492523673, 1.224401551270248],
            [34.231872345487396, 1.229944262114865],
            [34.2325447668169, 1.230438362644784],
            [34.234537067522005, 1.23384628392246],
            [34.23780774363996, 1.236504880485142],
            [34.237510458773116, 1.24046143276565],
            [34.23589564182849, 1.245274240665361],
            [34.23487428879148, 1.247192306232783],
            [34.224184405182406, 1.25312197528794],
            [34.21976706823183, 1.247642629141677],
            [34.216741632186455, 1.24469528650668],
            [34.213798289581625, 1.240698643776486],
            [34.21055312741437, 1.238710179995653],
            [34.20898366820505, 1.237191293907695],
            [34.20786666165828, 1.235093298911043],
            [34.20417386090012, 1.231883905935276],
            [34.20275954343533, 1.231750668068049],
            [34.20155984337341, 1.23046400812283],
            [34.20064055422402, 1.227169378109922],
            [34.199237518700876, 1.226135634408758],
            [34.197310002697435, 1.22298782758802],
            [34.196120334122284, 1.222110116481314],
            [34.19098454257377, 1.213499076068512],
            [34.18944579676405, 1.212491399369346],
            [34.18961334334432, 1.211339842555341],
            [34.18873185260714, 1.209408084635047],
            [34.18927425896897, 1.208204317258163],
            [34.18927364092803, 1.206786107987076],
            [34.18850523011885, 1.203780787344803],
            [34.18644717363323, 1.202318035428901],
            [34.184416001029156, 1.198493654415326],
            [34.18371513364786, 1.191936352161617],
            [34.18366260555995, 1.190017233266279],
            [34.18428813034006, 1.186673103554891],
            [34.18389957125043, 1.184903758317428],
            [34.18505580183576, 1.183211813153168],
            [34.186114583179105, 1.180348911121692],
            [34.18599009015545, 1.176367562035933],
            [34.186822920051995, 1.174129292955044],
            [34.188089123292734, 1.172665001216105],
            [34.19162761684127, 1.172438644427152],
            [34.192314792101, 1.173640763196165],
            [34.196940323500144, 1.173222675246773],
            [34.19722671359926, 1.174855249547666],
            [34.19778911915424, 1.175307711240705],
            [34.19892379466432, 1.175379240712132],
            [34.20032789109781, 1.17403249106443],
            [34.20379907388213, 1.175323750878096],
            [34.20580100003551, 1.174355032594246],
            [34.207379077681644, 1.176603890398315],
            [34.211114587941665, 1.175915926790692],
            [34.213299084100136, 1.176116709159385],
            [34.210297021320144, 1.180585276867492],
            [34.21032722627324, 1.181589291065614],
            [34.21065926516183, 1.181806232075821],
            [34.20839462311035, 1.18591607769093],
            [34.209003430243, 1.188791242316075],
            [34.20985934055413, 1.189296083792813],
            [34.21055335468814, 1.192669670479303],
            [34.207793250434946, 1.196382076698727],
            [34.20853089125072, 1.198235817978126],
            [34.209664453748196, 1.203843054695577],
            [34.21086216583841, 1.206697974063004],
            [34.21659539903462, 1.20695444456453],
            [34.21843100390976, 1.206679161225749],
            [34.21960105058419, 1.207123773549629],
            [34.223152026223595, 1.209995102524298],
            [34.22336526920405, 1.209447356516677],
            [34.226821091695335, 1.211507767513942],
            [34.228466707379454, 1.213543769803846],
            [34.22878653457006, 1.214710191253121],
            [34.229824121062585, 1.215486849081793],
            [34.230479338756076, 1.21784542520793],
            [34.23184369821299, 1.218805526914246],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 929,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUKHULO",
        Population: 18100,
        Key: "SIRONKOBUKHULO",
        Dist2: "Sironko",
        "Sub Country": "Bukhulo",
        id2_original: "Sironko Bukhulo",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30449214047919, 1.284644665802887],
            [34.30369778093471, 1.285584114841519],
            [34.30265157241209, 1.285881314083257],
            [34.30227031842236, 1.286969010169194],
            [34.30153945629371, 1.287275476625553],
            [34.29987549611317, 1.287154930684378],
            [34.29946361586046, 1.287173486093148],
            [34.29809634496372, 1.285448466552267],
            [34.29642435743778, 1.282533904947338],
            [34.291216561427696, 1.280464659300281],
            [34.2897624836301, 1.279101193403747],
            [34.282813837041004, 1.278294994553096],
            [34.27874063569263, 1.275664553501379],
            [34.27719360651767, 1.27264394465965],
            [34.27588204015171, 1.264896690347162],
            [34.274513799972794, 1.262773422581265],
            [34.266871429405526, 1.254789935875322],
            [34.2641064553852, 1.253026309627304],
            [34.26074542042778, 1.25209447004807],
            [34.25759222508437, 1.24943369062771],
            [34.25718145964093, 1.248425520080834],
            [34.257502930748494, 1.246706051956887],
            [34.256477604462994, 1.24561524860277],
            [34.2567604462167, 1.245382973110071],
            [34.25768815527525, 1.246203391947294],
            [34.25819115254554, 1.245369922774105],
            [34.25761234105851, 1.244717717535106],
            [34.25881378475043, 1.244114799158165],
            [34.25832109385139, 1.243526521530308],
            [34.25750367365523, 1.243551908227993],
            [34.257189569631294, 1.24247740236206],
            [34.25770452886794, 1.241988675633978],
            [34.25711422792843, 1.241049573665975],
            [34.25721441793038, 1.239764447698096],
            [34.25657213777362, 1.239430333758323],
            [34.25768798279871, 1.238580595963447],
            [34.25698365151367, 1.237546325910772],
            [34.256656057489124, 1.235308273285162],
            [34.255273094821014, 1.235030979294906],
            [34.255974458072345, 1.233722392753421],
            [34.254697808323165, 1.231836884610192],
            [34.25487310646602, 1.231178559926575],
            [34.25421893081826, 1.23077661260446],
            [34.25329278842159, 1.231502336785346],
            [34.252771618233076, 1.230643213022443],
            [34.2531589610038, 1.230204201591516],
            [34.25367996859723, 1.23071591936096],
            [34.25373365461357, 1.228978869147666],
            [34.25443613447079, 1.229082148944786],
            [34.25456526010637, 1.227930105273243],
            [34.25529144830058, 1.228092821960993],
            [34.25532239795709, 1.227558967993585],
            [34.25589943616971, 1.22723943691703],
            [34.25575885072606, 1.226836508266639],
            [34.256826591866044, 1.226589899998957],
            [34.25640945287563, 1.224414576562091],
            [34.25765664147677, 1.224869937240303],
            [34.25732314462247, 1.223985847471823],
            [34.25850572189681, 1.22403387032802],
            [34.25966331163315, 1.222260095615789],
            [34.259480919494514, 1.221413576570668],
            [34.26082016475101, 1.221773040155716],
            [34.260497898634384, 1.221186748704654],
            [34.26081452782259, 1.220646453004924],
            [34.26197960232192, 1.22015719957337],
            [34.26244949218239, 1.219472792647549],
            [34.26347671930305, 1.219302547463083],
            [34.26332362122582, 1.217980322579969],
            [34.26416496086304, 1.21793011001776],
            [34.26433427263284, 1.217225314472596],
            [34.26509779570859, 1.216957865516447],
            [34.26571415407954, 1.217245434888475],
            [34.26635352818636, 1.216757254083814],
            [34.266605112161464, 1.218375681473813],
            [34.26713464386862, 1.217998918893645],
            [34.268763329004614, 1.218015586061918],
            [34.26959793576878, 1.21690257320988],
            [34.27018704644054, 1.216933683832908],
            [34.26997411876873, 1.216050332398758],
            [34.27055634205721, 1.215379966429812],
            [34.271004605875554, 1.21532247640791],
            [34.271395308345454, 1.216200761825364],
            [34.272499938802554, 1.21500809994505],
            [34.2731896886339, 1.215468459316843],
            [34.27326150894087, 1.216509457585821],
            [34.27408161599803, 1.216084278374221],
            [34.27479505889499, 1.216365137140088],
            [34.27531291160515, 1.217128129709379],
            [34.275655596428166, 1.215672634558019],
            [34.2762725602636, 1.215838394795226],
            [34.27673135143877, 1.215228104466869],
            [34.27687530915799, 1.216282124567313],
            [34.278283625876675, 1.21564058718846],
            [34.278566385883714, 1.216448698457304],
            [34.27886553205984, 1.215647786463073],
            [34.278491400812, 1.215164458773455],
            [34.27864210038744, 1.214429158081084],
            [34.279063442595046, 1.215258892686544],
            [34.279697285774695, 1.215133975911198],
            [34.28052233536255, 1.216152930127386],
            [34.28103843366294, 1.215542256375851],
            [34.280258331280336, 1.215172067588989],
            [34.280626074608186, 1.21427961858635],
            [34.281428004255574, 1.214309931714789],
            [34.28206439326073, 1.213367154821861],
            [34.2863706759843, 1.229080400327343],
            [34.287831902574894, 1.228092037013778],
            [34.29067747703579, 1.227949422699456],
            [34.29505992162411, 1.225721496284649],
            [34.299390045635306, 1.21925035548692],
            [34.30085484931738, 1.219555392888745],
            [34.30164781647319, 1.219332987168854],
            [34.304615385742906, 1.217558052586508],
            [34.30937746196356, 1.218348559383668],
            [34.311679152333994, 1.220757875401115],
            [34.31295593144057, 1.221066035364956],
            [34.31427375996236, 1.223719017087929],
            [34.314874451714765, 1.224114338315202],
            [34.316509128613696, 1.224050376697155],
            [34.31926760152632, 1.22482438509979],
            [34.322674176577074, 1.227224106192525],
            [34.32314577772818, 1.228056238391303],
            [34.32284804460198, 1.228801646262204],
            [34.323117893123445, 1.230011348110727],
            [34.32376094223812, 1.230837205258486],
            [34.32501352612083, 1.231423081466072],
            [34.323684660897456, 1.233148406195187],
            [34.32356088652602, 1.233995949857153],
            [34.32118113615067, 1.235183423006445],
            [34.31970391505645, 1.237202157396265],
            [34.31363056711725, 1.240066597144617],
            [34.31131329636655, 1.242166892739174],
            [34.31035830637116, 1.243699381343424],
            [34.30944697270193, 1.244038304986168],
            [34.30897837911037, 1.244911429431399],
            [34.305616544652324, 1.246917197674017],
            [34.3054575572201, 1.247531864384638],
            [34.302299254055995, 1.249537533635073],
            [34.30119416186483, 1.251773760031662],
            [34.29837058445029, 1.254809331240007],
            [34.29763812601541, 1.257908594787291],
            [34.296481071674926, 1.259366061437635],
            [34.29574408393437, 1.261540098745874],
            [34.29359366267127, 1.261555005368874],
            [34.29115289153528, 1.265798651981194],
            [34.291187789287456, 1.266814077819143],
            [34.29218533966437, 1.267055897265197],
            [34.29364087003777, 1.266074340517678],
            [34.29768795197094, 1.264824477110211],
            [34.29886310466944, 1.265780983737135],
            [34.30174292829884, 1.265779527025295],
            [34.30638102623048, 1.262556607558343],
            [34.31261968394488, 1.260701617679681],
            [34.31565818149449, 1.25812362567502],
            [34.32029445315116, 1.251358111716329],
            [34.32213395222309, 1.250632553744026],
            [34.32509267488389, 1.248537695718487],
            [34.32693281535291, 1.249100352974654],
            [34.33141885635473, 1.246868017577236],
            [34.33069287028146, 1.248719000953439],
            [34.33076408692055, 1.250852540952254],
            [34.33065728891136, 1.252244237331931],
            [34.32595848013789, 1.254640632156598],
            [34.32422973615397, 1.257549331893602],
            [34.32163425985471, 1.258577151120561],
            [34.31976624556076, 1.260268854833078],
            [34.318390603263886, 1.262340817246304],
            [34.317741527351956, 1.264147153366389],
            [34.31789633851645, 1.265281038749113],
            [34.317231498069646, 1.266633758154249],
            [34.31417661614754, 1.270629456850106],
            [34.31446585121116, 1.271791785622644],
            [34.31376700773419, 1.273638148557235],
            [34.311754648547094, 1.273081965573367],
            [34.3103794796624, 1.273742509696441],
            [34.30928568827749, 1.273490234374717],
            [34.307852132492584, 1.273796221962587],
            [34.307215191023545, 1.274317635117691],
            [34.3069920396255, 1.275273591292587],
            [34.30638231531291, 1.27509506930211],
            [34.304376469809974, 1.276563775786106],
            [34.30372462529034, 1.277908456744854],
            [34.30409226710856, 1.278961663219531],
            [34.30368118006825, 1.279286528935226],
            [34.30531507992446, 1.280781800346133],
            [34.30439091741465, 1.281157606435427],
            [34.30415319713936, 1.281768643039937],
            [34.30467151158356, 1.282831644295898],
            [34.30449214047919, 1.284644665802887],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 930,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUKIISE",
        Population: 20538,
        Key: "SIRONKOBUKIISE",
        Dist2: "Sironko",
        "Sub Country": "Bukiise",
        id2_original: "Sironko Bukiise",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.250615067764805, 1.204424006108849],
            [34.24900453668239, 1.204940567824396],
            [34.248270269938814, 1.205850525085398],
            [34.2398003039582, 1.211112476770059],
            [34.23749546948429, 1.21386255976771],
            [34.23184369821299, 1.218805526914246],
            [34.230479338756076, 1.21784542520793],
            [34.229824121062585, 1.215486849081793],
            [34.22878653457006, 1.214710191253121],
            [34.228466707379454, 1.213543769803846],
            [34.226821091695335, 1.211507767513942],
            [34.22336526920405, 1.209447356516677],
            [34.223152026223595, 1.209995102524298],
            [34.21960105058419, 1.207123773549629],
            [34.21843100390976, 1.206679161225749],
            [34.21659539903462, 1.20695444456453],
            [34.21086216583841, 1.206697974063004],
            [34.209664453748196, 1.203843054695577],
            [34.20853089125072, 1.198235817978126],
            [34.207793250434946, 1.196382076698727],
            [34.21055335468814, 1.192669670479303],
            [34.20985934055413, 1.189296083792813],
            [34.209003430243, 1.188791242316075],
            [34.20839462311035, 1.18591607769093],
            [34.21065926516183, 1.181806232075821],
            [34.21032722627324, 1.181589291065614],
            [34.210297021320144, 1.180585276867492],
            [34.213299084100136, 1.176116709159385],
            [34.211114587941665, 1.175915926790692],
            [34.207379077681644, 1.176603890398315],
            [34.20580100003551, 1.174355032594246],
            [34.20379907388213, 1.175323750878096],
            [34.20032789109781, 1.17403249106443],
            [34.19892379466432, 1.175379240712132],
            [34.19778911915424, 1.175307711240705],
            [34.19722671359926, 1.174855249547666],
            [34.196940323500144, 1.173222675246773],
            [34.192314792101, 1.173640763196165],
            [34.19162761684127, 1.172438644427152],
            [34.188776414435125, 1.169355565100925],
            [34.18783717819486, 1.168946455101196],
            [34.18801285003688, 1.168088310412184],
            [34.18766558111097, 1.167539192731666],
            [34.185394094795335, 1.165980951435287],
            [34.18323730088362, 1.162058530736485],
            [34.181894146159024, 1.161408584133764],
            [34.181044176406864, 1.161457034694055],
            [34.17734540364867, 1.162539409540087],
            [34.17524074975265, 1.161245485383588],
            [34.173059447105025, 1.160638152214881],
            [34.171548261608216, 1.161104124084666],
            [34.1699510606263, 1.160286679411147],
            [34.17326299367031, 1.15561786232572],
            [34.17495808317041, 1.154234712680462],
            [34.17601812754503, 1.15477633802696],
            [34.177670296439175, 1.155344660263648],
            [34.17954007053278, 1.155087514992428],
            [34.18053834764678, 1.154402738991375],
            [34.18496051124536, 1.154780788275154],
            [34.189716728653735, 1.152007674255588],
            [34.190653499916834, 1.152441472805367],
            [34.19130201528002, 1.151263792217297],
            [34.19304657410451, 1.150375110992394],
            [34.19357531439589, 1.150875579181437],
            [34.195417702449745, 1.15097732789009],
            [34.19564608563602, 1.158473395264366],
            [34.19968671586881, 1.159097612871212],
            [34.20205222794693, 1.158953478932966],
            [34.20472953178543, 1.162478320507441],
            [34.20809778380784, 1.162496037925711],
            [34.209983029585615, 1.163072219947089],
            [34.21117684208918, 1.162895846927719],
            [34.21516642375934, 1.163490073198836],
            [34.21686481007652, 1.162951997133089],
            [34.22091947828228, 1.160605730584428],
            [34.225111609387746, 1.160163623773071],
            [34.226909206543226, 1.160669565243906],
            [34.22859818300781, 1.162584804641462],
            [34.22861706918835, 1.163092070420833],
            [34.22398757621881, 1.167599307184834],
            [34.22696836599458, 1.167581120975433],
            [34.23243959655502, 1.170517178729739],
            [34.23756858246691, 1.174098876997024],
            [34.23786965552935, 1.174958929261794],
            [34.23821782097389, 1.175017317356907],
            [34.23590072449637, 1.178076652088825],
            [34.238414441528356, 1.180721114616212],
            [34.239382507401004, 1.182489928138725],
            [34.240151750050174, 1.185616147747337],
            [34.241114572456524, 1.188878384391356],
            [34.24408170065344, 1.193104862897809],
            [34.24411139087191, 1.195633910758537],
            [34.24505741029089, 1.197221955672744],
            [34.24861955288758, 1.199870545574784],
            [34.250615067764805, 1.204424006108849],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 931,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUKIYI",
        Population: 12967,
        Key: "SIRONKOBUKIYI",
        Dist2: "Sironko",
        "Sub Country": "Bukiyi",
        id2_original: "Sironko Bukiyi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.37311247323105, 1.208163953249993],
            [34.36801241666455, 1.211542240739642],
            [34.365512432178285, 1.21259629101652],
            [34.36488386570265, 1.213887909026526],
            [34.36240025211412, 1.21500775057898],
            [34.360310292859516, 1.213076428166395],
            [34.35415493502314, 1.209018438239771],
            [34.3482216739626, 1.208858610535044],
            [34.34436766783175, 1.20785745961587],
            [34.341611412859585, 1.207767741450398],
            [34.34018790113786, 1.207324772783826],
            [34.34152703949484, 1.203444102111664],
            [34.34133316239527, 1.200920692661514],
            [34.34109205277639, 1.199753574643426],
            [34.338272948073666, 1.197619566476601],
            [34.337363723648735, 1.19698655413499],
            [34.33686150701441, 1.195459098040234],
            [34.339329421645, 1.195343015161092],
            [34.34159600405751, 1.193338901421412],
            [34.3426245508033, 1.192936682639167],
            [34.343185120201845, 1.191368166688333],
            [34.34475370984194, 1.191568986557353],
            [34.34369472817431, 1.189809127721796],
            [34.34212330075622, 1.188947288302957],
            [34.341583045859544, 1.187928897834797],
            [34.34377082356371, 1.183828046320678],
            [34.345514060068105, 1.18350986717674],
            [34.347036620931355, 1.182491602241816],
            [34.3486289970619, 1.183896627931676],
            [34.35563542508669, 1.185067135902894],
            [34.36026974829749, 1.183977120454831],
            [34.36322156291378, 1.184740876486354],
            [34.364326837462926, 1.184554903895578],
            [34.365345436265294, 1.184583276508837],
            [34.36862794319552, 1.187791694395371],
            [34.36959158037384, 1.189480651402383],
            [34.36878233035521, 1.191538308539118],
            [34.368674192059615, 1.196261773595112],
            [34.36759682906465, 1.198640239069072],
            [34.36831083251034, 1.19946362969255],
            [34.37216265393842, 1.200391187404612],
            [34.37201595995083, 1.201667968918856],
            [34.37320489819569, 1.205993418086155],
            [34.37311247323105, 1.208163953249993],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 932,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUKYABO",
        Population: 7169,
        Key: "SIRONKOBUKYABO",
        Dist2: "Sironko",
        "Sub Country": "Bukyabo",
        id2_original: "Sironko Bukyabo",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34409189941258, 1.161176406551308],
            [34.34069059028602, 1.161661162735096],
            [34.338761522892064, 1.160485655857092],
            [34.33523780573162, 1.165055807172209],
            [34.332748659419266, 1.164971621893329],
            [34.33206989239059, 1.164251658658862],
            [34.33196381303365, 1.16321546362834],
            [34.332825661208794, 1.16217880837448],
            [34.33477871721408, 1.161336483095465],
            [34.33628627711044, 1.15773399120773],
            [34.33484417295729, 1.156479817088801],
            [34.332817911442845, 1.155735703603669],
            [34.3311581904121, 1.15671960852314],
            [34.330376494418175, 1.158016444695616],
            [34.32971217858747, 1.160627720423521],
            [34.32606461159713, 1.164204515823617],
            [34.32665602195599, 1.161392750088835],
            [34.327304831068254, 1.160442729684206],
            [34.32711085245909, 1.157575594864758],
            [34.32843260122878, 1.154427354121186],
            [34.32861373752268, 1.150961544082502],
            [34.32970368232152, 1.148922323725889],
            [34.331583420528275, 1.146235002900208],
            [34.33186093796731, 1.143788976451865],
            [34.33238168594763, 1.142820932658861],
            [34.33386848218447, 1.141942884549873],
            [34.334380808458995, 1.142195900472806],
            [34.334453031211204, 1.138433545512432],
            [34.33516708226763, 1.136411460822008],
            [34.33597099090359, 1.13556502794219],
            [34.33565385506556, 1.134258360450143],
            [34.33689549117994, 1.124430645324292],
            [34.33902150521677, 1.126211494806366],
            [34.339499293963556, 1.127097667786808],
            [34.34023783309459, 1.129539429631052],
            [34.33940542001637, 1.131810070402671],
            [34.3402694591825, 1.133582454890733],
            [34.341235560439635, 1.133799079836617],
            [34.34238837383365, 1.135461333318508],
            [34.34338902519494, 1.135896624382039],
            [34.344140336572714, 1.137788008777555],
            [34.34335996828876, 1.140499762354842],
            [34.34322726646003, 1.145535181899102],
            [34.340400173937816, 1.150819244619576],
            [34.34038475615257, 1.154370771744909],
            [34.34130003162926, 1.156333757421717],
            [34.343924361815446, 1.159038511329215],
            [34.34409189941258, 1.161176406551308],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 933,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUKYAMBI",
        Population: 3519,
        Key: "SIRONKOBUKYAMBI",
        Dist2: "Sironko",
        "Sub Country": "Bukyambi",
        id2_original: "Sironko Bukyambi",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34018790113786, 1.207324772783826],
            [34.33831436759477, 1.211314706125797],
            [34.335537828663476, 1.220912669385976],
            [34.332779058408484, 1.225545016818255],
            [34.32930131432935, 1.229131661671668],
            [34.327044235194236, 1.232729520865205],
            [34.32501352612083, 1.231423081466072],
            [34.32376094223812, 1.230837205258486],
            [34.323117893123445, 1.230011348110727],
            [34.32284804460198, 1.228801646262204],
            [34.32314577772818, 1.228056238391303],
            [34.322674176577074, 1.227224106192525],
            [34.31926760152632, 1.22482438509979],
            [34.316509128613696, 1.224050376697155],
            [34.314874451714765, 1.224114338315202],
            [34.31427375996236, 1.223719017087929],
            [34.31295593144057, 1.221066035364956],
            [34.311679152333994, 1.220757875401115],
            [34.30937746196356, 1.218348559383668],
            [34.31093159681242, 1.217283062212244],
            [34.311936950854225, 1.21711012614405],
            [34.312568558127104, 1.21538244522221],
            [34.31473341801179, 1.213347446611338],
            [34.31497682911444, 1.211748419072289],
            [34.3170636020447, 1.211356511560913],
            [34.31806312961359, 1.212107615409097],
            [34.31986847922996, 1.212479121250827],
            [34.3207659725556, 1.213694221822869],
            [34.32254764886929, 1.21372983742136],
            [34.32658016462016, 1.210750817670756],
            [34.32658574675133, 1.205575286540749],
            [34.3280904122758, 1.200275989380804],
            [34.32769277301528, 1.199738959563469],
            [34.32490085223139, 1.199193215196633],
            [34.322616410412714, 1.196353181501372],
            [34.32466792895969, 1.195535907935151],
            [34.32735082031923, 1.195269612727407],
            [34.33085123787616, 1.197235903463566],
            [34.3338891596057, 1.197271389948165],
            [34.33568557547656, 1.198065314600183],
            [34.338272948073666, 1.197619566476601],
            [34.34109205277639, 1.199753574643426],
            [34.34133316239527, 1.200920692661514],
            [34.34152703949484, 1.203444102111664],
            [34.34018790113786, 1.207324772783826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 934,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUMALIMBA",
        Population: 16910,
        Key: "SIRONKOBUMALIMBA",
        Dist2: "Sironko",
        "Sub Country": "Bumalimba",
        id2_original: "Sironko Bumalimba",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.37483743710422, 1.207369720787728],
            [34.37311247323105, 1.208163953249993],
            [34.37320489819569, 1.205993418086155],
            [34.37201595995083, 1.201667968918856],
            [34.37216265393842, 1.200391187404612],
            [34.36831083251034, 1.19946362969255],
            [34.36759682906465, 1.198640239069072],
            [34.368674192059615, 1.196261773595112],
            [34.36878233035521, 1.191538308539118],
            [34.36959158037384, 1.189480651402383],
            [34.36862794319552, 1.187791694395371],
            [34.365345436265294, 1.184583276508837],
            [34.364326837462926, 1.184554903895578],
            [34.3630566717535, 1.183633191226205],
            [34.363429086320814, 1.183140577569485],
            [34.36470651401102, 1.182875012238648],
            [34.36678045181255, 1.183520156979335],
            [34.36903935632431, 1.181703283689668],
            [34.370218378066696, 1.181890036941516],
            [34.37230326812817, 1.180997780073223],
            [34.37267265357635, 1.179670678723875],
            [34.367920429179435, 1.176676581113237],
            [34.36694548221169, 1.175618829356261],
            [34.36655198418465, 1.174457606733119],
            [34.365146675923846, 1.173512293335379],
            [34.36453499687721, 1.172227118395732],
            [34.364674203406885, 1.171387926099906],
            [34.36430555008564, 1.171137069184161],
            [34.36315893686373, 1.170984012963332],
            [34.36172223967028, 1.171400615744058],
            [34.35993581665863, 1.170734028093501],
            [34.35712477433559, 1.171574428566658],
            [34.355098422091295, 1.170425308334331],
            [34.353038984895115, 1.167206258168346],
            [34.35258689425366, 1.167494186599846],
            [34.35149447729114, 1.166996592665689],
            [34.35023255542104, 1.167126801602502],
            [34.34976628936439, 1.166310361884733],
            [34.34776103854615, 1.166143858610124],
            [34.34674109766079, 1.165538872409896],
            [34.345622848743965, 1.165718490205298],
            [34.345268867606244, 1.164809571466392],
            [34.34552881489667, 1.164182495475948],
            [34.34727497721391, 1.164177753350307],
            [34.349720080026195, 1.16247615152252],
            [34.35310399776885, 1.162655412955299],
            [34.35439665729304, 1.16134751034491],
            [34.35460842973138, 1.160534558193119],
            [34.35630868813761, 1.159610670426996],
            [34.36072458239384, 1.155819836167614],
            [34.363143924218704, 1.155921993349793],
            [34.365391791130584, 1.155232051490569],
            [34.369708856332515, 1.152350555640233],
            [34.370077389279516, 1.150016415918941],
            [34.37243373135521, 1.14978731980256],
            [34.374407729784714, 1.148970743064383],
            [34.3773599989485, 1.150642208913675],
            [34.37826706472182, 1.150706923968533],
            [34.37979484749183, 1.153362431398145],
            [34.38084196870274, 1.154229217902707],
            [34.38162227500296, 1.15705656975073],
            [34.38283181610881, 1.157440193386509],
            [34.38489286398433, 1.15949920604264],
            [34.38591615378907, 1.161437087210665],
            [34.38680751880785, 1.162089082442562],
            [34.386740725473196, 1.165266419447933],
            [34.38569804373641, 1.166299580742104],
            [34.385595208195944, 1.167566573085606],
            [34.38566452040662, 1.168113798403836],
            [34.38761189277114, 1.170524494879055],
            [34.38946463301031, 1.170768779350744],
            [34.39184788591698, 1.170211311401005],
            [34.3947753642739, 1.168092524431609],
            [34.39759255376842, 1.168128304976952],
            [34.40123916854457, 1.169920277521356],
            [34.40641747376221, 1.170555137204099],
            [34.407212882538964, 1.170227016964048],
            [34.40824140323361, 1.170592744509984],
            [34.40972848962632, 1.170496448143099],
            [34.40917545439806, 1.171866178082084],
            [34.40903414850557, 1.174015966431192],
            [34.40705817198578, 1.177201737702897],
            [34.405207558957166, 1.177998871733584],
            [34.403890568563526, 1.179082515533669],
            [34.40144435453526, 1.186102181316232],
            [34.3972806119894, 1.190218597495343],
            [34.39551953045189, 1.191443837879948],
            [34.39271196999887, 1.196933703408699],
            [34.39229559727141, 1.19983030448544],
            [34.39083957462127, 1.200022217096617],
            [34.389510880976076, 1.201615950838117],
            [34.385912976447905, 1.202147619422871],
            [34.38054969643517, 1.205156268490055],
            [34.37790137045111, 1.205742482585306],
            [34.375968099839966, 1.207153470650574],
            [34.37483743710422, 1.207369720787728],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 935,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUMASIFWA",
        Population: 10316,
        Key: "SIRONKOBUMASIFWA",
        Dist2: "Sironko",
        "Sub Country": "Bumasifwa",
        id2_original: "Sironko Bumasifwa",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.307952001796, 1.136493993470719],
            [34.303409259133424, 1.138121917667582],
            [34.30050178715622, 1.138412681767396],
            [34.29851520332958, 1.138268865624795],
            [34.2966238687708, 1.137609440043634],
            [34.29623226439238, 1.141055759598625],
            [34.29487708122611, 1.142431214996952],
            [34.292789962444445, 1.143553744667516],
            [34.29173297324011, 1.141878753984054],
            [34.28979912052065, 1.138299947486985],
            [34.28849434092666, 1.136844287250453],
            [34.28771272218785, 1.134238320268685],
            [34.286721054877724, 1.133163953300833],
            [34.286211728077944, 1.133337357108811],
            [34.28608049948629, 1.134101424081645],
            [34.285240601645086, 1.134356470487227],
            [34.2839549651498, 1.133630389492159],
            [34.281644422780566, 1.13437845334301],
            [34.27482078305147, 1.133685431968342],
            [34.27114144534448, 1.134359058924481],
            [34.27022818299232, 1.133785099398582],
            [34.26978246410118, 1.132689039493272],
            [34.2679261683301, 1.131101063313779],
            [34.26708316052137, 1.131244064301471],
            [34.26525291050363, 1.130049520527819],
            [34.263404925047226, 1.129899785223006],
            [34.26185211790837, 1.128932638508688],
            [34.261115301746024, 1.127772896759401],
            [34.26008423432751, 1.128764397849942],
            [34.25811791918864, 1.129368438002194],
            [34.25689676286615, 1.129052391226662],
            [34.25562150550563, 1.127897637801519],
            [34.25579177398121, 1.125750865707691],
            [34.25637247552361, 1.124863342410191],
            [34.25594844465836, 1.123509143095256],
            [34.253148778600064, 1.121407265055755],
            [34.252780727150075, 1.118506441515156],
            [34.25186387243512, 1.117463423870693],
            [34.252416361487676, 1.116010559023271],
            [34.25330155238551, 1.116151115101272],
            [34.253866958313516, 1.116910926675437],
            [34.254611828770706, 1.116346856780862],
            [34.257301053253016, 1.113592391852961],
            [34.257485598653396, 1.11245978240804],
            [34.258595117742296, 1.110949265768943],
            [34.26021561203952, 1.111562650314466],
            [34.2612953924009, 1.110681329817588],
            [34.26249926423903, 1.110538396983038],
            [34.263134718996284, 1.10848091676549],
            [34.264830037566774, 1.108666424567529],
            [34.266099866408034, 1.107845424581733],
            [34.267417937474946, 1.108574959958165],
            [34.2698495862192, 1.10596129762439],
            [34.27069466284801, 1.105865297284382],
            [34.27215571157222, 1.106465187314638],
            [34.27477454496717, 1.104283034082919],
            [34.27918006368186, 1.104109988715361],
            [34.279440358620285, 1.104713885739826],
            [34.27986044049153, 1.104774104787368],
            [34.28002948995328, 1.102503956863214],
            [34.28082368959764, 1.101845301031454],
            [34.28329965403152, 1.101878393337806],
            [34.28434426085795, 1.10244002841435],
            [34.28516925834354, 1.102368539345652],
            [34.285496857758, 1.101183778161269],
            [34.286145860906366, 1.100996828362154],
            [34.28730571529556, 1.101722984786606],
            [34.28898629790213, 1.102120232565989],
            [34.290703308990096, 1.103572210578741],
            [34.290707602937154, 1.104034002657151],
            [34.29198279382232, 1.103420882405546],
            [34.29336591639054, 1.103402707468303],
            [34.29403132906423, 1.104082122759982],
            [34.29416538465408, 1.105762732377529],
            [34.293949692866136, 1.110747489084694],
            [34.295788610728074, 1.113269734817931],
            [34.297878173825616, 1.115125999348297],
            [34.29800544803338, 1.117525648214817],
            [34.29995792193038, 1.117772283152479],
            [34.30154125022935, 1.120494112812387],
            [34.303499143662464, 1.120788594295203],
            [34.303450084868146, 1.125636450511434],
            [34.304463905531485, 1.130369902518946],
            [34.307952001796, 1.136493993470719],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 936,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUNYAFA",
        Population: 11757,
        Key: "SIRONKOBUNYAFA",
        Dist2: "Sironko",
        "Sub Country": "Bunyafa",
        id2_original: "Sironko Bunyafa",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.345622848743965, 1.165718490205298],
            [34.34561125149364, 1.166504909231215],
            [34.34475437639189, 1.167112289635454],
            [34.34440425890822, 1.168289502888758],
            [34.34359177944612, 1.16254185245471],
            [34.34409189941258, 1.161176406551308],
            [34.343924361815446, 1.159038511329215],
            [34.34130003162926, 1.156333757421717],
            [34.34038475615257, 1.154370771744909],
            [34.340400173937816, 1.150819244619576],
            [34.34322726646003, 1.145535181899102],
            [34.34335996828876, 1.140499762354842],
            [34.344140336572714, 1.137788008777555],
            [34.34338902519494, 1.135896624382039],
            [34.34238837383365, 1.135461333318508],
            [34.342855360339165, 1.135146000329575],
            [34.34632775674741, 1.136030763198213],
            [34.348887001296326, 1.137522245191172],
            [34.35357825254332, 1.135973965803585],
            [34.35622270319523, 1.135505228060144],
            [34.35717860228569, 1.134533725444554],
            [34.35995304634575, 1.133761725320338],
            [34.362945354320104, 1.131890918271951],
            [34.368286572607786, 1.129670955152151],
            [34.37058419540661, 1.12784713172704],
            [34.37191717491398, 1.127669364420707],
            [34.37315777257589, 1.130508238601286],
            [34.37439533842369, 1.131128475451971],
            [34.37506479890599, 1.132465306585848],
            [34.375764511952184, 1.134334457094527],
            [34.375783263385394, 1.135980583289746],
            [34.37706016825612, 1.137019189830717],
            [34.37738545630535, 1.138105315585464],
            [34.3800169074368, 1.139699170718688],
            [34.37872574450588, 1.141008014627464],
            [34.37721283065045, 1.141207728890699],
            [34.375469596841015, 1.142336351100826],
            [34.37527714177455, 1.145206421086572],
            [34.37575725266637, 1.146219194816759],
            [34.374407729784714, 1.148970743064383],
            [34.37243373135521, 1.14978731980256],
            [34.370077389279516, 1.150016415918941],
            [34.369708856332515, 1.152350555640233],
            [34.365391791130584, 1.155232051490569],
            [34.363143924218704, 1.155921993349793],
            [34.36072458239384, 1.155819836167614],
            [34.35630868813761, 1.159610670426996],
            [34.35460842973138, 1.160534558193119],
            [34.35439665729304, 1.16134751034491],
            [34.35310399776885, 1.162655412955299],
            [34.349720080026195, 1.16247615152252],
            [34.34727497721391, 1.164177753350307],
            [34.34552881489667, 1.164182495475948],
            [34.345268867606244, 1.164809571466392],
            [34.345622848743965, 1.165718490205298],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 937,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUSULANI",
        Population: 7569,
        Key: "SIRONKOBUSULANI",
        Dist2: "Sironko",
        "Sub Country": "Busulani",
        id2_original: "Sironko Busulani",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.33141885635473, 1.246868017577236],
            [34.32693281535291, 1.249100352974654],
            [34.32509267488389, 1.248537695718487],
            [34.32213395222309, 1.250632553744026],
            [34.32029445315116, 1.251358111716329],
            [34.31565818149449, 1.25812362567502],
            [34.31261968394488, 1.260701617679681],
            [34.30638102623048, 1.262556607558343],
            [34.30174292829884, 1.265779527025295],
            [34.29886310466944, 1.265780983737135],
            [34.29768795197094, 1.264824477110211],
            [34.29364087003777, 1.266074340517678],
            [34.29218533966437, 1.267055897265197],
            [34.291187789287456, 1.266814077819143],
            [34.29115289153528, 1.265798651981194],
            [34.29359366267127, 1.261555005368874],
            [34.29574408393437, 1.261540098745874],
            [34.296481071674926, 1.259366061437635],
            [34.29763812601541, 1.257908594787291],
            [34.29837058445029, 1.254809331240007],
            [34.30119416186483, 1.251773760031662],
            [34.302299254055995, 1.249537533635073],
            [34.3054575572201, 1.247531864384638],
            [34.305616544652324, 1.246917197674017],
            [34.30897837911037, 1.244911429431399],
            [34.30944697270193, 1.244038304986168],
            [34.31035830637116, 1.243699381343424],
            [34.31131329636655, 1.242166892739174],
            [34.31363056711725, 1.240066597144617],
            [34.31970391505645, 1.237202157396265],
            [34.32118113615067, 1.235183423006445],
            [34.32356088652602, 1.233995949857153],
            [34.323684660897456, 1.233148406195187],
            [34.32501352612083, 1.231423081466072],
            [34.327044235194236, 1.232729520865205],
            [34.32930131432935, 1.229131661671668],
            [34.332779058408484, 1.225545016818255],
            [34.335537828663476, 1.220912669385976],
            [34.33831436759477, 1.211314706125797],
            [34.34018790113786, 1.207324772783826],
            [34.341611412859585, 1.207767741450398],
            [34.34436766783175, 1.20785745961587],
            [34.3482216739626, 1.208858610535044],
            [34.35415493502314, 1.209018438239771],
            [34.360310292859516, 1.213076428166395],
            [34.36240025211412, 1.21500775057898],
            [34.3594754642115, 1.216325213328906],
            [34.34911339920581, 1.223203208882629],
            [34.34625341936103, 1.224163407467557],
            [34.34018449382797, 1.229123040727331],
            [34.33760618702874, 1.231819706504597],
            [34.33517129716295, 1.236086463597386],
            [34.33456430732209, 1.238108400842856],
            [34.3337499997884, 1.238599660944753],
            [34.33141885635473, 1.246868017577236],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 938,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUTANDIGA",
        Population: 5984,
        Key: "SIRONKOBUTANDIGA",
        Dist2: "Sironko",
        "Sub Country": "Butandiga",
        id2_original: "Sironko Butandiga",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.33689549117994, 1.124430645324292],
            [34.33565385506556, 1.134258360450143],
            [34.33597099090359, 1.13556502794219],
            [34.33516708226763, 1.136411460822008],
            [34.334453031211204, 1.138433545512432],
            [34.334380808458995, 1.142195900472806],
            [34.33386848218447, 1.141942884549873],
            [34.33238168594763, 1.142820932658861],
            [34.33186093796731, 1.143788976451865],
            [34.331583420528275, 1.146235002900208],
            [34.32970368232152, 1.148922323725889],
            [34.3266008088037, 1.148071994829226],
            [34.32599435615536, 1.146970171641355],
            [34.32525389373131, 1.147266553579346],
            [34.321750436275465, 1.147191208118019],
            [34.32146469116673, 1.146505824877903],
            [34.31886723947217, 1.145216711927133],
            [34.31565273411062, 1.14588632870473],
            [34.31221684164224, 1.143020331550185],
            [34.30936427649183, 1.139304084464821],
            [34.307952001796, 1.136493993470719],
            [34.304463905531485, 1.130369902518946],
            [34.303450084868146, 1.125636450511434],
            [34.303499143662464, 1.120788594295203],
            [34.30154125022935, 1.120494112812387],
            [34.29995792193038, 1.117772283152479],
            [34.29800544803338, 1.117525648214817],
            [34.297878173825616, 1.115125999348297],
            [34.295788610728074, 1.113269734817931],
            [34.293949692866136, 1.110747489084694],
            [34.29416538465408, 1.105762732377529],
            [34.295559982301725, 1.105419280563837],
            [34.29599341134147, 1.104439307417309],
            [34.296995932995195, 1.104181863946037],
            [34.29969353426754, 1.106710909760358],
            [34.30096268398242, 1.106493813080688],
            [34.30142403086457, 1.104940621476668],
            [34.30487052075834, 1.105458455089257],
            [34.305683156527294, 1.105089058433415],
            [34.305743303227125, 1.104292232919265],
            [34.308070414123456, 1.105546575989504],
            [34.30957758684593, 1.105477984421245],
            [34.31058712703694, 1.104454116986171],
            [34.31049770963189, 1.103443543595416],
            [34.31113837282115, 1.103745299986854],
            [34.312674571008735, 1.103338888612905],
            [34.31337362199653, 1.104001264245324],
            [34.31417009258195, 1.103539984106538],
            [34.31527062672135, 1.10427880110928],
            [34.31597443339028, 1.102613458286813],
            [34.31513428222416, 1.101726856707873],
            [34.31589907282277, 1.100730460579614],
            [34.31694910816847, 1.101519967130806],
            [34.31784169309941, 1.101536956522476],
            [34.31908574568188, 1.102804979562287],
            [34.32037728500689, 1.101987450200587],
            [34.32086329872843, 1.103001846607336],
            [34.32141606625872, 1.102076692093747],
            [34.322353312730606, 1.101896858386528],
            [34.323054181010235, 1.102301770946618],
            [34.32365196132282, 1.101654306907821],
            [34.32540644203957, 1.10070789277666],
            [34.32619940290721, 1.101052889951237],
            [34.326351471515125, 1.101886599726753],
            [34.327236451308835, 1.102216675814449],
            [34.327398472351796, 1.103441848788808],
            [34.32690963342872, 1.104201838768036],
            [34.327352298047884, 1.105694044712406],
            [34.32753106099279, 1.106064804681521],
            [34.32889186851104, 1.106037055503713],
            [34.32913125875449, 1.106344472657437],
            [34.329064821152684, 1.107230900414474],
            [34.32993780753908, 1.107718928605895],
            [34.33013013863804, 1.108288668356857],
            [34.33050583205617, 1.110721568577029],
            [34.33387601545643, 1.112908891281709],
            [34.33582883340818, 1.11673397062719],
            [34.33596197541139, 1.119293601859269],
            [34.33696603498087, 1.122712091739326],
            [34.33689549117994, 1.124430645324292],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 939,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUTEZA",
        Population: 11274,
        Key: "SIRONKOBUTEZA",
        Dist2: "Sironko",
        "Sub Country": "Buteza",
        id2_original: "Sironko Buteza",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.227425154824985, 1.12200076881933],
            [34.228487757601506, 1.121900821663046],
            [34.23119247712419, 1.122777060696413],
            [34.23302781160643, 1.12244160703247],
            [34.23392096876419, 1.122757809903363],
            [34.23662618864845, 1.122168717971783],
            [34.237507137701485, 1.122837687131669],
            [34.23835260060588, 1.121932806334168],
            [34.23852158628723, 1.120431231090181],
            [34.23993447722734, 1.119915051792078],
            [34.242045863996395, 1.120266912134387],
            [34.24250927790202, 1.122434208131141],
            [34.24381809721983, 1.12334571616797],
            [34.245555860289215, 1.12366996001118],
            [34.248161352803876, 1.121621292579531],
            [34.249338879749665, 1.118997461354329],
            [34.25186387243512, 1.117463423870693],
            [34.252780727150075, 1.118506441515156],
            [34.253148778600064, 1.121407265055755],
            [34.25594844465836, 1.123509143095256],
            [34.25637247552361, 1.124863342410191],
            [34.25579177398121, 1.125750865707691],
            [34.25562150550563, 1.127897637801519],
            [34.255290282287355, 1.129073217317199],
            [34.25619936837174, 1.129888994961648],
            [34.25600537988107, 1.130850570193156],
            [34.256528645839104, 1.131601001360661],
            [34.25604348461878, 1.135131546578816],
            [34.257178736847294, 1.136912488291731],
            [34.26048305666927, 1.139823562769555],
            [34.260486681371425, 1.140951578382024],
            [34.25952928029782, 1.142541155910492],
            [34.25886910390395, 1.144931971415026],
            [34.259180138384565, 1.146453074688496],
            [34.26021820098415, 1.148081875211825],
            [34.260620598620726, 1.152495714683982],
            [34.26197145011069, 1.153982692056274],
            [34.25981679329104, 1.154847806946643],
            [34.25703588854745, 1.155362407364921],
            [34.24826758397613, 1.154695559060221],
            [34.24720896702449, 1.155586848011596],
            [34.246701761147094, 1.15790661484849],
            [34.247120861159736, 1.159506772799202],
            [34.25234404980226, 1.160043055054828],
            [34.25030929202187, 1.16159068282909],
            [34.2484431767664, 1.167280923214445],
            [34.24728924856313, 1.173135938633996],
            [34.24714657543475, 1.177990979007349],
            [34.24491133703917, 1.178362837937036],
            [34.24337681870115, 1.179476083793997],
            [34.24067522351905, 1.183240098662167],
            [34.24070962540119, 1.184813946894675],
            [34.240151750050174, 1.185616147747337],
            [34.239382507401004, 1.182489928138725],
            [34.238414441528356, 1.180721114616212],
            [34.23590072449637, 1.178076652088825],
            [34.23821782097389, 1.175017317356907],
            [34.23786965552935, 1.174958929261794],
            [34.23756858246691, 1.174098876997024],
            [34.23243959655502, 1.170517178729739],
            [34.22696836599458, 1.167581120975433],
            [34.22398757621881, 1.167599307184834],
            [34.22861706918835, 1.163092070420833],
            [34.22859818300781, 1.162584804641462],
            [34.226909206543226, 1.160669565243906],
            [34.225111609387746, 1.160163623773071],
            [34.22527639095359, 1.129991898522865],
            [34.22709927119274, 1.128506958305012],
            [34.227425154824985, 1.12200076881933],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 940,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUWALASI",
        Population: 13698,
        Key: "SIRONKOBUWALASI",
        Dist2: "Sironko",
        "Sub Country": "Buwalasi",
        id2_original: "Sironko Buwalasi",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.29173297324011, 1.141878753984054],
            [34.29003997142473, 1.144169538329316],
            [34.28779220332757, 1.146292514109961],
            [34.28495815065852, 1.146883231245211],
            [34.2835055640643, 1.146247302866223],
            [34.281866471047444, 1.147591941658014],
            [34.28158572416496, 1.148370123525359],
            [34.278494676069556, 1.15050526680522],
            [34.27810722460264, 1.151972816787896],
            [34.27505266427744, 1.153548297380894],
            [34.275545762113325, 1.154469422668176],
            [34.2775474825525, 1.155832961476044],
            [34.27787176089532, 1.157374880328943],
            [34.281505851359775, 1.160843405673071],
            [34.28147251398129, 1.162833857078121],
            [34.28383793443121, 1.164982527881062],
            [34.28741229501412, 1.169226545389211],
            [34.28834697949083, 1.169644758774648],
            [34.28871256506539, 1.170471667897825],
            [34.28883384301863, 1.17199640295928],
            [34.28790260447935, 1.174537731297339],
            [34.287862615076165, 1.175820464068028],
            [34.286278556446845, 1.177737159768248],
            [34.2859609705529, 1.178824464428344],
            [34.28493432733719, 1.179319257701419],
            [34.28494596501169, 1.18035282245465],
            [34.28433254053846, 1.181364207643189],
            [34.284888259034474, 1.182056496168359],
            [34.28286705234013, 1.182396742385899],
            [34.2831358255782, 1.179972161269699],
            [34.2828079701439, 1.17862765735688],
            [34.27946162713293, 1.179192879835329],
            [34.278313852389374, 1.179016906597912],
            [34.277870877851406, 1.173228275068387],
            [34.276093423619535, 1.17236981285472],
            [34.276057423634526, 1.171013070088047],
            [34.27389316651943, 1.169295499184249],
            [34.27300249050845, 1.167034638306144],
            [34.270630179980294, 1.164765405042161],
            [34.27037144990712, 1.163652650005818],
            [34.27265063837799, 1.161776925487381],
            [34.271329101610675, 1.159463039191363],
            [34.270654215304035, 1.159083037095531],
            [34.26913766147507, 1.162201086501248],
            [34.26815914460239, 1.161510294743451],
            [34.267003507803445, 1.158272673607045],
            [34.264537086172865, 1.156528080023765],
            [34.26257364204961, 1.15418627726499],
            [34.26197145011069, 1.153982692056274],
            [34.260620598620726, 1.152495714683982],
            [34.26021820098415, 1.148081875211825],
            [34.259180138384565, 1.146453074688496],
            [34.25886910390395, 1.144931971415026],
            [34.25952928029782, 1.142541155910492],
            [34.260486681371425, 1.140951578382024],
            [34.26048305666927, 1.139823562769555],
            [34.257178736847294, 1.136912488291731],
            [34.25604348461878, 1.135131546578816],
            [34.256528645839104, 1.131601001360661],
            [34.25600537988107, 1.130850570193156],
            [34.25619936837174, 1.129888994961648],
            [34.255290282287355, 1.129073217317199],
            [34.25562150550563, 1.127897637801519],
            [34.25689676286615, 1.129052391226662],
            [34.25811791918864, 1.129368438002194],
            [34.26008423432751, 1.128764397849942],
            [34.261115301746024, 1.127772896759401],
            [34.26185211790837, 1.128932638508688],
            [34.263404925047226, 1.129899785223006],
            [34.26525291050363, 1.130049520527819],
            [34.26708316052137, 1.131244064301471],
            [34.2679261683301, 1.131101063313779],
            [34.26978246410118, 1.132689039493272],
            [34.27022818299232, 1.133785099398582],
            [34.27114144534448, 1.134359058924481],
            [34.27482078305147, 1.133685431968342],
            [34.281644422780566, 1.13437845334301],
            [34.2839549651498, 1.133630389492159],
            [34.285240601645086, 1.134356470487227],
            [34.28608049948629, 1.134101424081645],
            [34.286211728077944, 1.133337357108811],
            [34.286721054877724, 1.133163953300833],
            [34.28771272218785, 1.134238320268685],
            [34.28849434092666, 1.136844287250453],
            [34.28979912052065, 1.138299947486985],
            [34.29173297324011, 1.141878753984054],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 941,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUWASA",
        Population: 8742,
        Key: "SIRONKOBUWASA",
        Dist2: "Sironko",
        "Sub Country": "Buwasa",
        id2_original: "Sironko Buwasa",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30656614295941, 1.186691885095076],
            [34.30579206378078, 1.187126685977123],
            [34.306520574119986, 1.188437772037185],
            [34.30543462143427, 1.189617183860989],
            [34.30507365859018, 1.189637124856205],
            [34.30494705362729, 1.189073242708938],
            [34.30427145136336, 1.189162025643907],
            [34.30514760880268, 1.190672342793225],
            [34.303774765656236, 1.191533680521425],
            [34.30318336068726, 1.193082913730178],
            [34.30246480817294, 1.193599573684654],
            [34.30250891545339, 1.194101644477548],
            [34.301087733063206, 1.194349210401593],
            [34.30004553641668, 1.193466868314496],
            [34.29965981420672, 1.194722788828758],
            [34.29824753591764, 1.194691589936103],
            [34.297060823698054, 1.196241110559817],
            [34.29691237440241, 1.197041155294681],
            [34.29756491062481, 1.197538039718659],
            [34.29718453608573, 1.19797096092092],
            [34.296804184902854, 1.198129689068072],
            [34.296256899790755, 1.197232515758035],
            [34.29566860389096, 1.197606726966635],
            [34.29467289955191, 1.197484552236556],
            [34.29516980714292, 1.198695853273687],
            [34.29420681854823, 1.198624517500946],
            [34.29446860828327, 1.199147896135054],
            [34.29389519387449, 1.199566973485669],
            [34.294968501874266, 1.200386117527703],
            [34.293494387154276, 1.202214280401929],
            [34.293306563801416, 1.203103617801003],
            [34.29177836241649, 1.203826862544036],
            [34.29114353558161, 1.20288071227578],
            [34.289564900980004, 1.203730371545092],
            [34.289657135501784, 1.204250246545288],
            [34.28894887857897, 1.203955784543442],
            [34.28877757793913, 1.20270679993396],
            [34.2876080064735, 1.200666367196481],
            [34.287147363870545, 1.197791906535598],
            [34.29021056868372, 1.193152692305987],
            [34.288867876591496, 1.190400909860337],
            [34.28621053062365, 1.18709552471963],
            [34.2856447006908, 1.18571362641956],
            [34.28545242169414, 1.183153164774044],
            [34.284888259034474, 1.182056496168359],
            [34.28433254053846, 1.181364207643189],
            [34.28494596501169, 1.18035282245465],
            [34.28493432733719, 1.179319257701419],
            [34.2859609705529, 1.178824464428344],
            [34.286278556446845, 1.177737159768248],
            [34.287862615076165, 1.175820464068028],
            [34.28790260447935, 1.174537731297339],
            [34.28883384301863, 1.17199640295928],
            [34.28871256506539, 1.170471667897825],
            [34.28834697949083, 1.169644758774648],
            [34.28741229501412, 1.169226545389211],
            [34.28383793443121, 1.164982527881062],
            [34.28147251398129, 1.162833857078121],
            [34.281505851359775, 1.160843405673071],
            [34.27787176089532, 1.157374880328943],
            [34.2775474825525, 1.155832961476044],
            [34.275545762113325, 1.154469422668176],
            [34.27505266427744, 1.153548297380894],
            [34.27810722460264, 1.151972816787896],
            [34.278494676069556, 1.15050526680522],
            [34.28158572416496, 1.148370123525359],
            [34.281866471047444, 1.147591941658014],
            [34.2835055640643, 1.146247302866223],
            [34.28495815065852, 1.146883231245211],
            [34.28779220332757, 1.146292514109961],
            [34.29003997142473, 1.144169538329316],
            [34.29173297324011, 1.141878753984054],
            [34.292789962444445, 1.143553744667516],
            [34.29487708122611, 1.142431214996952],
            [34.29623226439238, 1.141055759598625],
            [34.2966238687708, 1.137609440043634],
            [34.29851520332958, 1.138268865624795],
            [34.30050178715622, 1.138412681767396],
            [34.303409259133424, 1.138121917667582],
            [34.307952001796, 1.136493993470719],
            [34.30936427649183, 1.139304084464821],
            [34.31221684164224, 1.143020331550185],
            [34.31565273411062, 1.14588632870473],
            [34.31886723947217, 1.145216711927133],
            [34.32146469116673, 1.146505824877903],
            [34.321750436275465, 1.147191208118019],
            [34.32525389373131, 1.147266553579346],
            [34.32599435615536, 1.146970171641355],
            [34.3266008088037, 1.148071994829226],
            [34.32970368232152, 1.148922323725889],
            [34.32861373752268, 1.150961544082502],
            [34.32843260122878, 1.154427354121186],
            [34.32711085245909, 1.157575594864758],
            [34.327304831068254, 1.160442729684206],
            [34.32665602195599, 1.161392750088835],
            [34.32606461159713, 1.164204515823617],
            [34.32435933610002, 1.165939595276013],
            [34.322573128684034, 1.166617959434809],
            [34.31929151378086, 1.16994961217863],
            [34.316992851631234, 1.173085859072533],
            [34.31429215027287, 1.17356400478569],
            [34.31188233957315, 1.175026954253006],
            [34.310132482485145, 1.17546971705297],
            [34.30861330108397, 1.177596725267335],
            [34.307702625879855, 1.177961743228208],
            [34.306833979254606, 1.181762258118512],
            [34.30656614295941, 1.186691885095076],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 942,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "BUYOBO",
        Population: 13517,
        Key: "SIRONKOBUYOBO",
        Dist2: "Sironko",
        "Sub Country": "Buyobo",
        id2_original: "Sironko Buyobo",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.45436755925006, 1.103238946213263],
            [34.45392125465734, 1.103929092621228],
            [34.45441176893844, 1.104789716400978],
            [34.45422892674382, 1.105387344213495],
            [34.450084202430844, 1.106793789033536],
            [34.4468969851927, 1.108785134465861],
            [34.443483766202085, 1.110060489573461],
            [34.442009107103026, 1.111785972571544],
            [34.43870847037371, 1.113776420986389],
            [34.436946774388566, 1.116179354571157],
            [34.4366555208105, 1.118947103319757],
            [34.43458273644584, 1.121426310182893],
            [34.43387016760966, 1.12395007089513],
            [34.429833930138585, 1.126294590880095],
            [34.425408232567655, 1.128114723918093],
            [34.42328895320049, 1.128586085428063],
            [34.422131004138045, 1.129916201437082],
            [34.421289888181306, 1.132575706828526],
            [34.41880494508617, 1.134697908874216],
            [34.41815609644804, 1.136014179066845],
            [34.41464047400663, 1.13813539153476],
            [34.41281415052497, 1.139679865251525],
            [34.41102570810054, 1.141896534400014],
            [34.40890328822316, 1.143046073041281],
            [34.40671309494916, 1.144993665269869],
            [34.40479192194993, 1.145783634976123],
            [34.40316406146738, 1.145948879360422],
            [34.40266694277232, 1.147010471869928],
            [34.39953083248731, 1.147734867281896],
            [34.39856346999549, 1.147255688837776],
            [34.397616165087356, 1.146109270210639],
            [34.394347301769656, 1.145753530366493],
            [34.391876214289454, 1.147106754665116],
            [34.38852007874359, 1.147325471248091],
            [34.386136815057164, 1.146864449439284],
            [34.381512944642985, 1.148362582785088],
            [34.37952298943907, 1.150646736407869],
            [34.37826706472182, 1.150706923968533],
            [34.3773599989485, 1.150642208913675],
            [34.374407729784714, 1.148970743064383],
            [34.37575725266637, 1.146219194816759],
            [34.37527714177455, 1.145206421086572],
            [34.375469596841015, 1.142336351100826],
            [34.37721283065045, 1.141207728890699],
            [34.37872574450588, 1.141008014627464],
            [34.3800169074368, 1.139699170718688],
            [34.38107360109538, 1.138067357576052],
            [34.381296946529524, 1.135135859442222],
            [34.38177784524387, 1.134439336404239],
            [34.38230122169468, 1.131468805016341],
            [34.38476153208641, 1.129337471904294],
            [34.385345491818306, 1.127577200751348],
            [34.3868154751863, 1.125640310725445],
            [34.3869813544934, 1.124627529785755],
            [34.38757863264773, 1.124256273685853],
            [34.38774816450479, 1.122378768462958],
            [34.391678170803615, 1.119376618194817],
            [34.39240947310673, 1.11797986496015],
            [34.39817100143775, 1.116854842034955],
            [34.399387438011765, 1.11546642597982],
            [34.39991702271952, 1.111944068746745],
            [34.399793559165175, 1.107288059422258],
            [34.39662194117192, 1.102471600147843],
            [34.39881193501994, 1.101826018666638],
            [34.40441838538683, 1.104030236720432],
            [34.40753452971632, 1.103567476437154],
            [34.41025642143395, 1.105483623893056],
            [34.413096015810005, 1.105717419912617],
            [34.414148300537164, 1.106549013242417],
            [34.41520182853271, 1.106734648702379],
            [34.4178750998339, 1.106512261035911],
            [34.41932462137635, 1.105370729371563],
            [34.420928214769816, 1.104939492504317],
            [34.42256594773733, 1.103318556321918],
            [34.42355513479897, 1.102898765166065],
            [34.42983813245747, 1.104324855466753],
            [34.43675163785097, 1.102875044156409],
            [34.442476844600115, 1.10109049456901],
            [34.444076428812465, 1.101406268615262],
            [34.44590602665332, 1.101224484985288],
            [34.450459099043314, 1.102805023571591],
            [34.45436755925006, 1.103238946213263],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 943,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "MASABA",
        Population: 10166,
        Key: "SIRONKOMASABA",
        Dist2: "Sironko",
        "Sub Country": "Masaba",
        id2_original: "Sironko Masaba",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.28206439326073, 1.213367154821861],
            [34.281428004255574, 1.214309931714789],
            [34.280626074608186, 1.21427961858635],
            [34.280258331280336, 1.215172067588989],
            [34.28103843366294, 1.215542256375851],
            [34.28052233536255, 1.216152930127386],
            [34.279697285774695, 1.215133975911198],
            [34.279063442595046, 1.215258892686544],
            [34.27864210038744, 1.214429158081084],
            [34.278491400812, 1.215164458773455],
            [34.27886553205984, 1.215647786463073],
            [34.278566385883714, 1.216448698457304],
            [34.278283625876675, 1.21564058718846],
            [34.27687530915799, 1.216282124567313],
            [34.27673135143877, 1.215228104466869],
            [34.2762725602636, 1.215838394795226],
            [34.275655596428166, 1.215672634558019],
            [34.27531291160515, 1.217128129709379],
            [34.27479505889499, 1.216365137140088],
            [34.27408161599803, 1.216084278374221],
            [34.27326150894087, 1.216509457585821],
            [34.2731896886339, 1.215468459316843],
            [34.272499938802554, 1.21500809994505],
            [34.271395308345454, 1.216200761825364],
            [34.271004605875554, 1.21532247640791],
            [34.27055634205721, 1.215379966429812],
            [34.26997411876873, 1.216050332398758],
            [34.27018704644054, 1.216933683832908],
            [34.26959793576878, 1.21690257320988],
            [34.268763329004614, 1.218015586061918],
            [34.26713464386862, 1.217998918893645],
            [34.266605112161464, 1.218375681473813],
            [34.26635352818636, 1.216757254083814],
            [34.26674253014542, 1.212110929450754],
            [34.26593694435481, 1.208724276724581],
            [34.26593409040717, 1.20442591011647],
            [34.264602428728296, 1.199535471084123],
            [34.25524073480954, 1.199362744943894],
            [34.25397269092079, 1.201759772714481],
            [34.250615067764805, 1.204424006108849],
            [34.24861955288758, 1.199870545574784],
            [34.24505741029089, 1.197221955672744],
            [34.24411139087191, 1.195633910758537],
            [34.24408170065344, 1.193104862897809],
            [34.241114572456524, 1.188878384391356],
            [34.240151750050174, 1.185616147747337],
            [34.24070962540119, 1.184813946894675],
            [34.24067522351905, 1.183240098662167],
            [34.24337681870115, 1.179476083793997],
            [34.24491133703917, 1.178362837937036],
            [34.24714657543475, 1.177990979007349],
            [34.24728924856313, 1.173135938633996],
            [34.2484431767664, 1.167280923214445],
            [34.25030929202187, 1.16159068282909],
            [34.25234404980226, 1.160043055054828],
            [34.247120861159736, 1.159506772799202],
            [34.246701761147094, 1.15790661484849],
            [34.24720896702449, 1.155586848011596],
            [34.24826758397613, 1.154695559060221],
            [34.25703588854745, 1.155362407364921],
            [34.25981679329104, 1.154847806946643],
            [34.26197145011069, 1.153982692056274],
            [34.26257364204961, 1.15418627726499],
            [34.264537086172865, 1.156528080023765],
            [34.267003507803445, 1.158272673607045],
            [34.26815914460239, 1.161510294743451],
            [34.26913766147507, 1.162201086501248],
            [34.270654215304035, 1.159083037095531],
            [34.271329101610675, 1.159463039191363],
            [34.27265063837799, 1.161776925487381],
            [34.27037144990712, 1.163652650005818],
            [34.270630179980294, 1.164765405042161],
            [34.27300249050845, 1.167034638306144],
            [34.27389316651943, 1.169295499184249],
            [34.276057423634526, 1.171013070088047],
            [34.276093423619535, 1.17236981285472],
            [34.277870877851406, 1.173228275068387],
            [34.278313852389374, 1.179016906597912],
            [34.27946162713293, 1.179192879835329],
            [34.2828079701439, 1.17862765735688],
            [34.2831358255782, 1.179972161269699],
            [34.28286705234013, 1.182396742385899],
            [34.284888259034474, 1.182056496168359],
            [34.28545242169414, 1.183153164774044],
            [34.2856447006908, 1.18571362641956],
            [34.28621053062365, 1.18709552471963],
            [34.288867876591496, 1.190400909860337],
            [34.29021056868372, 1.193152692305987],
            [34.287147363870545, 1.197791906535598],
            [34.2876080064735, 1.200666367196481],
            [34.28877757793913, 1.20270679993396],
            [34.28894887857897, 1.203955784543442],
            [34.28838087292652, 1.205144438498563],
            [34.28899229415666, 1.205712363354238],
            [34.288710546550945, 1.20682025974718],
            [34.287941877925256, 1.207779820208561],
            [34.2882243271152, 1.208157627821985],
            [34.28750377764604, 1.208336595307911],
            [34.28678509667263, 1.209445926717371],
            [34.28699424333539, 1.210091197232268],
            [34.28581284465074, 1.211234635621279],
            [34.28620810786734, 1.211655106781542],
            [34.28548846659491, 1.211629729660296],
            [34.28593920796682, 1.212107343280483],
            [34.28518358198075, 1.212273482740425],
            [34.28577970669825, 1.212868044166843],
            [34.28506265257383, 1.212648977084087],
            [34.28414247409231, 1.213136997868742],
            [34.28417114112969, 1.21229346937417],
            [34.28361899164027, 1.212498517822043],
            [34.2834491345931, 1.211845241190735],
            [34.28299853066345, 1.21166017573933],
            [34.28204950817646, 1.212621163388602],
            [34.28206439326073, 1.213367154821861],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 944,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "NALUSALA",
        Population: 9381,
        Key: "SIRONKONALUSALA",
        Dist2: "Sironko",
        "Sub Country": "Nalusala",
        id2_original: "Sironko Nalusala",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.25759222508437, 1.24943369062771],
            [34.25639315114817, 1.24979332285666],
            [34.25685261875475, 1.251499269846117],
            [34.255694342705524, 1.252371381450749],
            [34.25651537502742, 1.253342142805427],
            [34.256470288583294, 1.25391074804663],
            [34.25716739561685, 1.254416740327662],
            [34.25597589717343, 1.254799140500858],
            [34.25588148064383, 1.255683189443871],
            [34.256483158746384, 1.254956605243531],
            [34.25707278235618, 1.254889915045021],
            [34.257349188579184, 1.25516784729147],
            [34.25713089527021, 1.25569088436091],
            [34.25767535518077, 1.256030940755638],
            [34.25757245136833, 1.256412813508419],
            [34.25673117730814, 1.256230610706367],
            [34.257300654401035, 1.257147538571876],
            [34.25722714076977, 1.258625061984303],
            [34.25671582509991, 1.258612859519288],
            [34.25657119274593, 1.257965491141561],
            [34.25589069556199, 1.257704356335923],
            [34.25538785190362, 1.258165277697217],
            [34.25488472707254, 1.258036863948458],
            [34.254642003181104, 1.259207353094694],
            [34.25513706473418, 1.259717592353854],
            [34.254181695649734, 1.260180626583862],
            [34.253553679841325, 1.259780615494274],
            [34.253629844401026, 1.26047066911728],
            [34.2529850768092, 1.260693947026073],
            [34.25411122281567, 1.261602304573415],
            [34.254152728575065, 1.262166719288926],
            [34.25368276056115, 1.262395211404823],
            [34.25342685658783, 1.261876553905201],
            [34.25260205493498, 1.261656991527204],
            [34.25143160940861, 1.262960739588587],
            [34.25223484071482, 1.263835158166146],
            [34.25117200257969, 1.263321938032647],
            [34.250376424919686, 1.263853557474233],
            [34.24983701982922, 1.26546411925577],
            [34.2502292260789, 1.266451689884173],
            [34.24933460287062, 1.26681734868375],
            [34.249677194268834, 1.267526874739664],
            [34.24914144532159, 1.268162125430569],
            [34.24955400649727, 1.268156322837141],
            [34.25023458273296, 1.269016546169736],
            [34.24985570029557, 1.27001279283323],
            [34.24925374910513, 1.270179097497253],
            [34.24911737406524, 1.269556624495954],
            [34.24872609847019, 1.270507225301898],
            [34.248990283113784, 1.271088132477072],
            [34.249472580505, 1.270772477480509],
            [34.250384402857705, 1.271867699710391],
            [34.24934545002767, 1.272220979316733],
            [34.24985699656451, 1.272702159092274],
            [34.249807873091534, 1.273445079136287],
            [34.24917328610682, 1.274341845911661],
            [34.249548695657325, 1.274694433647338],
            [34.248979857266605, 1.275122189011443],
            [34.24957797534569, 1.275553522305716],
            [34.247974236425165, 1.276189297303009],
            [34.24921561831627, 1.276612015916948],
            [34.24970612361423, 1.27621335091321],
            [34.248523833800824, 1.278608629717571],
            [34.24870568335705, 1.279463494242256],
            [34.24988111273662, 1.279931895520174],
            [34.24922608997753, 1.281202196639314],
            [34.24967557999625, 1.281255928507473],
            [34.25016945307819, 1.280579762227837],
            [34.25036012768378, 1.28134689790757],
            [34.2500634222303, 1.281733017585507],
            [34.25050477351251, 1.282010867018768],
            [34.25057951603911, 1.283899336731147],
            [34.2490831365748, 1.284020293253023],
            [34.2492236771027, 1.284721616804013],
            [34.24820103139, 1.284697220203451],
            [34.247436661202926, 1.285460536871268],
            [34.24672553326445, 1.285383811312837],
            [34.2465981826999, 1.285960105231517],
            [34.24698863274318, 1.286499440868278],
            [34.24658408453982, 1.286965763578632],
            [34.2472663549981, 1.287688468009643],
            [34.24640581476999, 1.287817351778105],
            [34.24601175439758, 1.287355093972248],
            [34.24588444425719, 1.28801580325764],
            [34.24525354036518, 1.287939038260146],
            [34.24542529285759, 1.288680347207821],
            [34.246052554081146, 1.288764454052751],
            [34.24575018564809, 1.289384877447308],
            [34.24501372611694, 1.289711894554236],
            [34.244893834264154, 1.290629519100023],
            [34.24528074225029, 1.291378062253894],
            [34.24496355700494, 1.29152502971687],
            [34.24450778506745, 1.29102061457301],
            [34.243641928609485, 1.286932625902315],
            [34.240767145427135, 1.280928038271508],
            [34.224184405182406, 1.25312197528794],
            [34.23487428879148, 1.247192306232783],
            [34.23589564182849, 1.245274240665361],
            [34.237510458773116, 1.24046143276565],
            [34.23780774363996, 1.236504880485142],
            [34.234537067522005, 1.23384628392246],
            [34.2325447668169, 1.230438362644784],
            [34.231872345487396, 1.229944262114865],
            [34.23202492523673, 1.224401551270248],
            [34.235678935842586, 1.222145720293147],
            [34.236362659775004, 1.22102537607026],
            [34.23474028530389, 1.220175105224185],
            [34.232770070578354, 1.220052427668914],
            [34.232628590412695, 1.219325153837139],
            [34.23184369821299, 1.218805526914246],
            [34.23749546948429, 1.21386255976771],
            [34.2398003039582, 1.211112476770059],
            [34.248270269938814, 1.205850525085398],
            [34.24900453668239, 1.204940567824396],
            [34.250615067764805, 1.204424006108849],
            [34.25397269092079, 1.201759772714481],
            [34.25524073480954, 1.199362744943894],
            [34.264602428728296, 1.199535471084123],
            [34.26593409040717, 1.20442591011647],
            [34.26593694435481, 1.208724276724581],
            [34.26674253014542, 1.212110929450754],
            [34.26635352818636, 1.216757254083814],
            [34.26571415407954, 1.217245434888475],
            [34.26509779570859, 1.216957865516447],
            [34.26433427263284, 1.217225314472596],
            [34.26416496086304, 1.21793011001776],
            [34.26332362122582, 1.217980322579969],
            [34.26347671930305, 1.219302547463083],
            [34.26244949218239, 1.219472792647549],
            [34.26197960232192, 1.22015719957337],
            [34.26081452782259, 1.220646453004924],
            [34.260497898634384, 1.221186748704654],
            [34.26082016475101, 1.221773040155716],
            [34.259480919494514, 1.221413576570668],
            [34.25966331163315, 1.222260095615789],
            [34.25850572189681, 1.22403387032802],
            [34.25732314462247, 1.223985847471823],
            [34.25765664147677, 1.224869937240303],
            [34.25640945287563, 1.224414576562091],
            [34.256826591866044, 1.226589899998957],
            [34.25575885072606, 1.226836508266639],
            [34.25589943616971, 1.22723943691703],
            [34.25532239795709, 1.227558967993585],
            [34.25529144830058, 1.228092821960993],
            [34.25456526010637, 1.227930105273243],
            [34.25443613447079, 1.229082148944786],
            [34.25373365461357, 1.228978869147666],
            [34.25367996859723, 1.23071591936096],
            [34.2531589610038, 1.230204201591516],
            [34.252771618233076, 1.230643213022443],
            [34.25329278842159, 1.231502336785346],
            [34.25421893081826, 1.23077661260446],
            [34.25487310646602, 1.231178559926575],
            [34.254697808323165, 1.231836884610192],
            [34.255974458072345, 1.233722392753421],
            [34.255273094821014, 1.235030979294906],
            [34.256656057489124, 1.235308273285162],
            [34.25698365151367, 1.237546325910772],
            [34.25768798279871, 1.238580595963447],
            [34.25657213777362, 1.239430333758323],
            [34.25721441793038, 1.239764447698096],
            [34.25711422792843, 1.241049573665975],
            [34.25770452886794, 1.241988675633978],
            [34.257189569631294, 1.24247740236206],
            [34.25750367365523, 1.243551908227993],
            [34.25832109385139, 1.243526521530308],
            [34.25881378475043, 1.244114799158165],
            [34.25761234105851, 1.244717717535106],
            [34.25819115254554, 1.245369922774105],
            [34.25768815527525, 1.246203391947294],
            [34.2567604462167, 1.245382973110071],
            [34.256477604462994, 1.24561524860277],
            [34.257502930748494, 1.246706051956887],
            [34.25718145964093, 1.248425520080834],
            [34.25759222508437, 1.24943369062771],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 945,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "SIRONKO TOWN COUNCIL",
        Population: 17103,
        Key: "SIRONKOSIRONKO TOWN COUNCIL",
        Dist2: "Sironko",
        "Sub Country": "Sironko T.C.",
        id2_original: "Sironko Sironko T.C.",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39662194117192, 1.102471600147843],
            [34.399793559165175, 1.107288059422258],
            [34.39991702271952, 1.111944068746745],
            [34.399387438011765, 1.11546642597982],
            [34.39817100143775, 1.116854842034955],
            [34.39240947310673, 1.11797986496015],
            [34.391678170803615, 1.119376618194817],
            [34.38774816450479, 1.122378768462958],
            [34.38757863264773, 1.124256273685853],
            [34.3869813544934, 1.124627529785755],
            [34.3868154751863, 1.125640310725445],
            [34.385345491818306, 1.127577200751348],
            [34.38476153208641, 1.129337471904294],
            [34.38230122169468, 1.131468805016341],
            [34.38177784524387, 1.134439336404239],
            [34.381296946529524, 1.135135859442222],
            [34.38107360109538, 1.138067357576052],
            [34.3800169074368, 1.139699170718688],
            [34.37738545630535, 1.138105315585464],
            [34.37706016825612, 1.137019189830717],
            [34.375783263385394, 1.135980583289746],
            [34.375764511952184, 1.134334457094527],
            [34.37506479890599, 1.132465306585848],
            [34.37439533842369, 1.131128475451971],
            [34.37315777257589, 1.130508238601286],
            [34.37191717491398, 1.127669364420707],
            [34.37058419540661, 1.12784713172704],
            [34.368286572607786, 1.129670955152151],
            [34.362945354320104, 1.131890918271951],
            [34.35995304634575, 1.133761725320338],
            [34.35717860228569, 1.134533725444554],
            [34.35622270319523, 1.135505228060144],
            [34.35357825254332, 1.135973965803585],
            [34.348887001296326, 1.137522245191172],
            [34.34632775674741, 1.136030763198213],
            [34.342855360339165, 1.135146000329575],
            [34.34238837383365, 1.135461333318508],
            [34.341235560439635, 1.133799079836617],
            [34.3402694591825, 1.133582454890733],
            [34.33940542001637, 1.131810070402671],
            [34.34023783309459, 1.129539429631052],
            [34.339499293963556, 1.127097667786808],
            [34.33902150521677, 1.126211494806366],
            [34.33689549117994, 1.124430645324292],
            [34.33696603498087, 1.122712091739326],
            [34.33596197541139, 1.119293601859269],
            [34.33582883340818, 1.11673397062719],
            [34.33387601545643, 1.112908891281709],
            [34.33050583205617, 1.110721568577029],
            [34.33013013863804, 1.108288668356857],
            [34.32993780753908, 1.107718928605895],
            [34.329064821152684, 1.107230900414474],
            [34.32913125875449, 1.106344472657437],
            [34.32889186851104, 1.106037055503713],
            [34.32753106099279, 1.106064804681521],
            [34.327352298047884, 1.105694044712406],
            [34.32690963342872, 1.104201838768036],
            [34.327398472351796, 1.103441848788808],
            [34.327236451308835, 1.102216675814449],
            [34.326351471515125, 1.101886599726753],
            [34.32619940290721, 1.101052889951237],
            [34.32540644203957, 1.10070789277666],
            [34.32365196132282, 1.101654306907821],
            [34.323732493491406, 1.100359188000519],
            [34.324405223841346, 1.099660701444313],
            [34.324492578714526, 1.098278522172628],
            [34.32534352313878, 1.097507122376189],
            [34.327526356515655, 1.096711457042794],
            [34.33004755022576, 1.094147439509042],
            [34.330167658572506, 1.092508790404746],
            [34.330929065217425, 1.091043461375026],
            [34.33153959082722, 1.090552765639858],
            [34.333014192434106, 1.090557207902431],
            [34.33394567082357, 1.088486189523149],
            [34.336850768553504, 1.087337748672325],
            [34.33864773778659, 1.086325735157507],
            [34.33911045639619, 1.086368429797476],
            [34.33931391851982, 1.086885171771746],
            [34.339810720109604, 1.086375026737211],
            [34.340950319285774, 1.086284682342172],
            [34.342466890182756, 1.088094803979722],
            [34.34718094965481, 1.088885756292054],
            [34.347926405813546, 1.088303141408155],
            [34.350412804179435, 1.089481902634795],
            [34.35354493313111, 1.088411544909358],
            [34.35594751957931, 1.087006162048785],
            [34.35778381975051, 1.087350727888901],
            [34.359830193645834, 1.086289366214423],
            [34.36198262803347, 1.085733122427365],
            [34.36302068883646, 1.086431796344623],
            [34.36639238949125, 1.085506661868851],
            [34.36887965023983, 1.085740436095365],
            [34.372906532655534, 1.084761764227596],
            [34.37425731138197, 1.086226387666765],
            [34.374760648215435, 1.087754711926623],
            [34.37379485058886, 1.091852409188194],
            [34.37360328395619, 1.09542515763323],
            [34.3765564460454, 1.103193185533641],
            [34.38064081255443, 1.102639550411778],
            [34.384638174533286, 1.105839488104314],
            [34.386055369301914, 1.106363411002333],
            [34.38780934696214, 1.104083330769726],
            [34.39536219591975, 1.10284553547516],
            [34.39662194117192, 1.102471600147843],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 946,
        District: "SIRONKO",
        County: "BUDADIRI",
        Subcounty: "ZESUI",
        Population: 10782,
        Key: "SIRONKOZESUI",
        Dist2: "Sironko",
        "Sub Country": "Zesui",
        id2_original: "Sironko Zesui",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.78445163825029, 0.475529877884627],
            [33.78708068459171, 0.476453285384506],
            [33.78916561777231, 0.4788253877211],
            [33.79473559384373, 0.479051572013979],
            [33.79569103659, 0.478576885556106],
            [33.79702461347708, 0.478828966484193],
            [33.79779653310575, 0.478414141654883],
            [33.798080976555624, 0.479646896158719],
            [33.80008246522948, 0.482188757696982],
            [33.80028465623698, 0.483242626480212],
            [33.79986960582965, 0.484167437853941],
            [33.802220455605685, 0.487514383678069],
            [33.80225021229948, 0.489879463872023],
            [33.80161549595737, 0.490141438960539],
            [33.80147001110215, 0.491205413075032],
            [33.80163711211806, 0.493729374684797],
            [33.80249942382391, 0.495158625522663],
            [33.802277161758, 0.496334672937296],
            [33.80373074817711, 0.499867164299853],
            [33.80711753693542, 0.503883461394177],
            [33.80738878593039, 0.505427310832967],
            [33.81029918731376, 0.507344157239106],
            [33.81120220438008, 0.508556343856463],
            [33.81297742989172, 0.508564765230505],
            [33.81349754006819, 0.509140225763964],
            [33.816355937081454, 0.510019065847559],
            [33.81767625034332, 0.511325361113932],
            [33.81771821873508, 0.512416840693883],
            [33.81826984001508, 0.512045317729908],
            [33.81927805878432, 0.512918332973136],
            [33.82018374294873, 0.515300246720606],
            [33.82117315279255, 0.516035361344393],
            [33.82188584020635, 0.516062449841329],
            [33.82193433485865, 0.517157016893478],
            [33.82424104052329, 0.517898588128923],
            [33.824621911830725, 0.518305620600276],
            [33.82452709734745, 0.518947889715656],
            [33.82809418157654, 0.520286324445761],
            [33.8295693131894, 0.522050177975384],
            [33.830401026480054, 0.521697252625519],
            [33.8319584806039, 0.522013615366041],
            [33.83272029418567, 0.523831855535491],
            [33.83405267811, 0.525071057402717],
            [33.834850002993264, 0.524874910409289],
            [33.835107707190396, 0.524241905836509],
            [33.83623312825641, 0.524437982784109],
            [33.83752852674392, 0.525855577045727],
            [33.8380566382146, 0.525690939854243],
            [33.83876729004598, 0.526963054232779],
            [33.83950285575343, 0.526507249455088],
            [33.842087055500954, 0.527393034405113],
            [33.84353306283399, 0.526962422743829],
            [33.8437531500786, 0.527506723064948],
            [33.84424989058295, 0.527582585269856],
            [33.84431256154875, 0.528208712294131],
            [33.84509872845787, 0.528076146353266],
            [33.845477985492714, 0.528516162000069],
            [33.84665807712862, 0.528759538488779],
            [33.84853204725294, 0.527954878939559],
            [33.851669974829775, 0.528072006193963],
            [33.85280739648972, 0.529949896470155],
            [33.855269200779745, 0.529890525759176],
            [33.85537201565898, 0.531380472267666],
            [33.85686686888559, 0.53273743128418],
            [33.85689627433811, 0.533416050362422],
            [33.858010115221845, 0.534138742391813],
            [33.85921168198293, 0.534197550741006],
            [33.860208250501245, 0.53475799154957],
            [33.860092592408414, 0.536003226747431],
            [33.861321389800715, 0.53773451241639],
            [33.86349173390021, 0.53787851769039],
            [33.86371750568392, 0.54134136953017],
            [33.865253694888374, 0.545113141434741],
            [33.86578601676279, 0.545298621668485],
            [33.865909183873086, 0.547442269182719],
            [33.86715847363367, 0.549400225633351],
            [33.86762966874626, 0.551090384490418],
            [33.868284947525225, 0.551461343683594],
            [33.8687762837648, 0.55129635595871],
            [33.86848994576799, 0.553233959861937],
            [33.87037374076659, 0.553975736928602],
            [33.86980085456718, 0.556676030276275],
            [33.87043634256209, 0.561767129779165],
            [33.871132606975884, 0.562570943128337],
            [33.87027303153839, 0.564879641796349],
            [33.870941083462355, 0.565535731270706],
            [33.87052982304721, 0.568234896443953],
            [33.870673904733934, 0.570152704936891],
            [33.873014366392034, 0.574431278584584],
            [33.86706723893676, 0.578466826712029],
            [33.86219724720273, 0.582393666166037],
            [33.86076029398944, 0.584176028057093],
            [33.85826852100321, 0.58898000865032],
            [33.85577857429194, 0.591332417075899],
            [33.84897467773615, 0.586900798515504],
            [33.842277245914595, 0.580053675255956],
            [33.83654508261189, 0.575902266708458],
            [33.83287188488986, 0.575866616172347],
            [33.83204059290909, 0.575224493279561],
            [33.83161017322551, 0.573858491213148],
            [33.82785303961829, 0.571977457355284],
            [33.827330262343736, 0.572456979291605],
            [33.82227815155892, 0.571779206352763],
            [33.82170814176504, 0.572258728305685],
            [33.819473372290005, 0.571996755799164],
            [33.81768937383132, 0.570848092257761],
            [33.81528834596012, 0.570703667394681],
            [33.8140763919794, 0.571065712702769],
            [33.813362442432606, 0.570631595541187],
            [33.81025988602008, 0.570487310802939],
            [33.80866832376321, 0.571229365938055],
            [33.805625350806864, 0.57160972784844],
            [33.80195348708302, 0.572677757096171],
            [33.79779548028026, 0.575546046088661],
            [33.79724968367655, 0.576649795197627],
            [33.79508755107709, 0.578034183274891],
            [33.791368525800834, 0.579608821765044],
            [33.790275669562156, 0.580540776107733],
            [33.78233491279351, 0.579637243006262],
            [33.77414319009066, 0.57973921094494],
            [33.773168377870206, 0.581614347796259],
            [33.77239056259831, 0.582011480592181],
            [33.772412599170536, 0.582651146849364],
            [33.77177725221111, 0.58330197042986],
            [33.7693786803339, 0.589213979566635],
            [33.769442193919446, 0.591688987020249],
            [33.77111474468907, 0.595216860982133],
            [33.77239877409831, 0.595858981585057],
            [33.7737082788307, 0.597722393333619],
            [33.77551999840075, 0.604516090198538],
            [33.775642463926815, 0.608505579490033],
            [33.77641810347908, 0.612576400937036],
            [33.777988119643865, 0.614132151640962],
            [33.77832330353426, 0.616737466902131],
            [33.77976306398285, 0.618419955907745],
            [33.78095361290696, 0.621169902804388],
            [33.78188161481629, 0.622246273571737],
            [33.782538086557935, 0.625557210810492],
            [33.78232621081332, 0.628207854788563],
            [33.78431647054613, 0.634313922449052],
            [33.78521134618103, 0.638746554544307],
            [33.78319771677611, 0.639319966524234],
            [33.78222781654365, 0.638927960734253],
            [33.78119096487302, 0.639607479576189],
            [33.77911283822736, 0.63917694656492],
            [33.77799548852416, 0.64029731483493],
            [33.774657475590814, 0.642040358651763],
            [33.77423905739947, 0.642643595149405],
            [33.773113776470595, 0.642394188203802],
            [33.76760485799073, 0.643174269341426],
            [33.764428190567266, 0.642655174603299],
            [33.76240284084284, 0.641899514351474],
            [33.76119004514071, 0.640888691823315],
            [33.75782796005271, 0.640487072085441],
            [33.75727914510965, 0.63991780031284],
            [33.7434841808221, 0.634227394836485],
            [33.74147939353454, 0.63422767599195],
            [33.73704473347204, 0.635267973538286],
            [33.73403776409396, 0.636613819356388],
            [33.73148654868706, 0.638571182855255],
            [33.732487397677716, 0.632059990312488],
            [33.72960240244719, 0.621917074797491],
            [33.7296319480369, 0.606438587761142],
            [33.72355793354778, 0.606006999273917],
            [33.71888781696447, 0.606550379529801],
            [33.71460973056103, 0.607618473037732],
            [33.712541921066396, 0.609030011502608],
            [33.70905449314849, 0.610574324737128],
            [33.70573290141856, 0.613572350990636],
            [33.706552685082215, 0.611762910592428],
            [33.70804992333593, 0.610740433561272],
            [33.70909611029896, 0.609130013495869],
            [33.71235236216841, 0.607175516204791],
            [33.71273253278991, 0.606578380244694],
            [33.71627554396602, 0.598028856670008],
            [33.71715498025613, 0.597096905250717],
            [33.71783292802125, 0.592200929340629],
            [33.7213532010409, 0.586617212556648],
            [33.72186320517042, 0.582947364464326],
            [33.723400658304456, 0.581935970308179],
            [33.726926475726046, 0.577853476586233],
            [33.72765305828066, 0.576371401621559],
            [33.727752644614746, 0.574195623697077],
            [33.728567514493825, 0.57247957618296],
            [33.72859130637411, 0.570055088050858],
            [33.72978017005878, 0.568716031986856],
            [33.73220484967306, 0.564210499461401],
            [33.7330129821875, 0.563396230453823],
            [33.734457655522384, 0.558745706332989],
            [33.73101528350587, 0.557063200249457],
            [33.72968107510316, 0.555734668064018],
            [33.72820474962925, 0.552863211873657],
            [33.728403010507414, 0.549277204314867],
            [33.726908649557544, 0.547845861108326],
            [33.72683839860737, 0.54706787114591],
            [33.72783637029419, 0.546497818140691],
            [33.72816972970621, 0.544579860916032],
            [33.73247153702303, 0.54078879013291],
            [33.73110981771479, 0.531602304377452],
            [33.72696163578628, 0.52496733508821],
            [33.72452537688795, 0.522044914066334],
            [33.725145074296805, 0.520988314484403],
            [33.72453758858592, 0.516201051570916],
            [33.725298489479336, 0.514663030056022],
            [33.72847248980476, 0.511116441058188],
            [33.728591867821166, 0.508737122683472],
            [33.73047124131192, 0.502154903504288],
            [33.73290665848877, 0.50232283978944],
            [33.7334024162362, 0.50298812894379],
            [33.734476254242026, 0.502676116535647],
            [33.737166778586534, 0.503786334809457],
            [33.741235725513725, 0.503832442652104],
            [33.744229992713706, 0.504890518246316],
            [33.75040822614885, 0.505866836689929],
            [33.75651276988289, 0.508328615525752],
            [33.75868121853711, 0.508224400680561],
            [33.76155168711114, 0.506248957021689],
            [33.76262545415006, 0.505063788449912],
            [33.76596395936014, 0.499351494338139],
            [33.77014147577427, 0.494547302552408],
            [33.77112063943395, 0.491471388162406],
            [33.773789408378924, 0.490014556568279],
            [33.7752827874702, 0.489887745137925],
            [33.776360414569844, 0.488530636046372],
            [33.777277748985185, 0.484921012987389],
            [33.78104449726091, 0.478846370735011],
            [33.781733392794415, 0.476489146687221],
            [33.78445163825029, 0.475529877884627],
          ],
          [
            [33.770314752707726, 0.546398235437515],
            [33.76388099079509, 0.54911726932099],
            [33.750053812921465, 0.547848668215262],
            [33.75024463485076, 0.55278896328347],
            [33.74969308274105, 0.555916076994125],
            [33.748105381443274, 0.556030326539459],
            [33.745595502014176, 0.557297171571286],
            [33.74316415600214, 0.557478440322819],
            [33.74118940568275, 0.558102879990423],
            [33.737868236160985, 0.561351047429978],
            [33.73952555779158, 0.56529621524812],
            [33.74018602973119, 0.570466257132932],
            [33.73954408554432, 0.571064729994657],
            [33.73568897987558, 0.571490847125588],
            [33.73574203617288, 0.571917735839305],
            [33.73774513911929, 0.573962003381859],
            [33.73808179624675, 0.574481947308011],
            [33.73782542604781, 0.574674864289113],
            [33.74007879334415, 0.577701613329419],
            [33.74404864531573, 0.579180248473618],
            [33.74621716403856, 0.579179968213543],
            [33.75423680366893, 0.576441438821659],
            [33.75692859194306, 0.575090314194845],
            [33.760294255919156, 0.571762784170505],
            [33.76122324058538, 0.569059901804925],
            [33.76526671218945, 0.565508923255253],
            [33.76775041381286, 0.560804434416627],
            [33.76908300794298, 0.561201709679802],
            [33.7703045065236, 0.561064933364478],
            [33.775423639713495, 0.558568508591925],
            [33.77578008852328, 0.557132325037825],
            [33.77520916693941, 0.554870501500987],
            [33.77489026501355, 0.55073563642115],
            [33.772961344044994, 0.5475106224654],
            [33.772575418815784, 0.547818561656468],
            [33.770314752707726, 0.546398235437515],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 947,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "KAPYANGA",
        Population: 58531,
        Key: "BUGIRIKAPYANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.8809650926637, 0.69138191515752],
            [33.87960794128866, 0.692784252787063],
            [33.87752639475668, 0.694061684834638],
            [33.873438907500365, 0.695066620079555],
            [33.86833194558427, 0.694652804746521],
            [33.86493801072785, 0.693649261700304],
            [33.86201076054302, 0.695123316669447],
            [33.85932172740186, 0.698514254585068],
            [33.85925778262501, 0.697631732510603],
            [33.852993389076026, 0.695818019834308],
            [33.83338528465115, 0.691515485811505],
            [33.833657163365146, 0.682043879880971],
            [33.83487950097225, 0.676561561377217],
            [33.83966743699495, 0.662502676224965],
            [33.854320568161604, 0.630539457621235],
            [33.85881711765563, 0.620343505738594],
            [33.859800586042155, 0.61705953109365],
            [33.86008241090298, 0.612825808406189],
            [33.85818762950848, 0.607027422871024],
            [33.8540800738887, 0.598153627661421],
            [33.853841156159106, 0.596742437599184],
            [33.85413620511924, 0.594317974293733],
            [33.8550024963618, 0.592228136060606],
            [33.85577854554583, 0.591332427855124],
            [33.858268498545314, 0.588979996074558],
            [33.86076032004059, 0.584176012786536],
            [33.86219728133872, 0.582393666166037],
            [33.86706721108902, 0.578466815034529],
            [33.87301433405267, 0.574431248043417],
            [33.87632074694925, 0.571137890546779],
            [33.87960890428265, 0.566008146618745],
            [33.881897104652445, 0.559232141569397],
            [33.88240052952083, 0.555825332556611],
            [33.88448250814241, 0.548720996618344],
            [33.88441482188241, 0.546735285063758],
            [33.88506280454462, 0.544976850715203],
            [33.886386605964745, 0.544362158647049],
            [33.88925811658451, 0.540244926651089],
            [33.89062708889038, 0.536740652891152],
            [33.891615484536246, 0.532087563268773],
            [33.894068601219175, 0.528372509529993],
            [33.89444883651936, 0.527146988182872],
            [33.89520759942243, 0.512613620462103],
            [33.88891045329817, 0.502715025564578],
            [33.88750222820765, 0.497468683267139],
            [33.88750176916854, 0.494041201572372],
            [33.886328406812424, 0.493223237711162],
            [33.8913405874829, 0.489420832277411],
            [33.89615314542924, 0.485096083872057],
            [33.90157967941439, 0.4817392063286],
            [33.901441530201765, 0.486054271594516],
            [33.90008263968834, 0.488826666877233],
            [33.90047671263719, 0.491629263958361],
            [33.90168608216483, 0.492818101737484],
            [33.90281097951307, 0.493214281839638],
            [33.90432049324515, 0.495761936662499],
            [33.90649881977426, 0.497487991826307],
            [33.91247937354122, 0.50024624609819],
            [33.91602357139182, 0.502778677735127],
            [33.916952176969005, 0.50449731934169],
            [33.91815742053454, 0.505489027182932],
            [33.9202935379234, 0.506369399330554],
            [33.92312585055574, 0.51064782746834],
            [33.925875840677115, 0.516491245030594],
            [33.927993513856535, 0.518924347634326],
            [33.931228271736174, 0.521456786282859],
            [33.936085352882955, 0.530095111905386],
            [33.93614565139809, 0.531461068343087],
            [33.93529318702439, 0.535685742773174],
            [33.93612567735773, 0.536762103718832],
            [33.9369344297097, 0.536861486264845],
            [33.93876346071362, 0.53571234431926],
            [33.93966715690629, 0.536019772990883],
            [33.939729422731894, 0.539185904833639],
            [33.94025373432893, 0.541239292231683],
            [33.942645691910705, 0.544884499996173],
            [33.946522333790085, 0.546937350985185],
            [33.948768175899275, 0.546403272062271],
            [33.94933813628581, 0.545851369528878],
            [33.949716846246666, 0.543408863605455],
            [33.952924646582936, 0.542259499226033],
            [33.95500208691572, 0.53871310378981],
            [33.95597583373424, 0.538061632087435],
            [33.96815282529556, 0.547563149053099],
            [33.96886522165523, 0.549160346950165],
            [33.97011760611195, 0.549846363272957],
            [33.97046721245424, 0.550582054957031],
            [33.97298764169801, 0.552605559192122],
            [33.97293474619916, 0.553703342731664],
            [33.97191680496359, 0.555327965055371],
            [33.972251285473114, 0.557263760314769],
            [33.97210032718288, 0.561370685456129],
            [33.974542275111865, 0.568236209716288],
            [33.977006284765935, 0.572641201083333],
            [33.97872653607713, 0.578002027919022],
            [33.97825506248681, 0.578463868710584],
            [33.97878334104413, 0.579044237910876],
            [33.97831571942972, 0.579624126477698],
            [33.97838539545809, 0.580196139858816],
            [33.97785585117454, 0.580340211461726],
            [33.97690867562379, 0.579562111760223],
            [33.976792860325794, 0.58042600605101],
            [33.97631356330763, 0.580558394759231],
            [33.976259521558475, 0.580986449645042],
            [33.97565790274469, 0.580730907350558],
            [33.97630236490931, 0.582862061266391],
            [33.975710874600374, 0.582445792708732],
            [33.97323354921886, 0.582463307155106],
            [33.972264903034485, 0.583284752414775],
            [33.97256330360896, 0.581840133993084],
            [33.97221211353682, 0.581452862382503],
            [33.97168924732908, 0.58148009161146],
            [33.971244995386776, 0.582522316233128],
            [33.97055307432741, 0.582933075702678],
            [33.97008676874489, 0.5822292048097],
            [33.97065486333055, 0.581833133783061],
            [33.970450220820645, 0.581393368228001],
            [33.969125189606885, 0.581789402456529],
            [33.968495185826754, 0.581028325153818],
            [33.967835934697625, 0.581994945257525],
            [33.9673028950693, 0.581583203013362],
            [33.96704111521571, 0.580612478647379],
            [33.96598551750174, 0.580543364919472],
            [33.96449241598991, 0.581401564932966],
            [33.9638797380167, 0.580585886287084],
            [33.96286791251158, 0.580565900696403],
            [33.960318669805034, 0.581783593351055],
            [33.95893857725429, 0.581401403244547],
            [33.95514586856514, 0.583545453350623],
            [33.954557099253215, 0.582921176335975],
            [33.953600149133884, 0.582785847649343],
            [33.95332616027727, 0.583420021803679],
            [33.95275064920061, 0.583046144387367],
            [33.95117629596963, 0.583500903714597],
            [33.95021437187857, 0.583937441625938],
            [33.94979363333882, 0.585151183865321],
            [33.94916039382708, 0.58493054038834],
            [33.94902137953685, 0.584366699036691],
            [33.947550160087005, 0.585459548631935],
            [33.94728051368649, 0.584674976714361],
            [33.94499334009105, 0.585027344984188],
            [33.94309684381269, 0.583814983356972],
            [33.93955194437785, 0.584375641300239],
            [33.93880927479312, 0.586274987631898],
            [33.93822280427, 0.58601792570768],
            [33.93785506363708, 0.586385143165401],
            [33.93752720281289, 0.585959891287484],
            [33.93715575483278, 0.586231270712226],
            [33.93638914065415, 0.585896553490518],
            [33.93569898747924, 0.586671492209006],
            [33.9339922863558, 0.587366515502583],
            [33.93159130429868, 0.58724932115962],
            [33.92960723036495, 0.588217592107136],
            [33.92889393748664, 0.588072974559267],
            [33.92779972119863, 0.587096173632578],
            [33.92603300363104, 0.587238306596137],
            [33.92544312310307, 0.588528447601586],
            [33.923718314638435, 0.588669179230813],
            [33.92273392907202, 0.591784723458958],
            [33.92155259686269, 0.593194335635572],
            [33.921241166225016, 0.594828142293821],
            [33.920665774624304, 0.595209551785105],
            [33.920187563669316, 0.594949522400412],
            [33.91835727771895, 0.595384047296761],
            [33.91750219475621, 0.597010823472673],
            [33.917432072265115, 0.59823860185921],
            [33.91804400104341, 0.598539149185144],
            [33.91867035946009, 0.600259882151101],
            [33.919508508281446, 0.600768114734646],
            [33.918743765293534, 0.601384211029394],
            [33.91907173930546, 0.602469430089294],
            [33.917024964761524, 0.603078412827199],
            [33.916330376604044, 0.602277576717711],
            [33.91550266261307, 0.603723971068263],
            [33.91592867695847, 0.604837714074185],
            [33.91482567335032, 0.606385946739068],
            [33.913776778865035, 0.606628113581273],
            [33.91425490178511, 0.607533763076191],
            [33.915780195323464, 0.608057695748012],
            [33.91582406904194, 0.609047635452771],
            [33.91441103706632, 0.609744508133568],
            [33.91332911152803, 0.609560266912565],
            [33.9108339123673, 0.61040199093618],
            [33.90872206835575, 0.610075465563095],
            [33.90833941389248, 0.612075964597371],
            [33.909407435306825, 0.613881154305919],
            [33.90897171825804, 0.614816853986457],
            [33.909079985012724, 0.615897774848069],
            [33.907476736572306, 0.616320675436067],
            [33.90701467373288, 0.619611677647556],
            [33.904943613235254, 0.622417494042404],
            [33.9053590175788, 0.623576031283259],
            [33.904025912307304, 0.623773315682407],
            [33.90371286380383, 0.624170288207539],
            [33.90396088685714, 0.626245475081947],
            [33.90347816096954, 0.626831165882196],
            [33.90352657297682, 0.627473438103768],
            [33.90293241736643, 0.627808252459841],
            [33.902169600366534, 0.630058932937406],
            [33.90264320296408, 0.630755483072317],
            [33.90263607303568, 0.63165010678721],
            [33.90026281927647, 0.633534974470191],
            [33.900715774995525, 0.635117982968145],
            [33.90002738341692, 0.63614032681434],
            [33.89974669133166, 0.640093575274325],
            [33.89923293943078, 0.640934964741711],
            [33.898019558027045, 0.641741097407729],
            [33.89843001265342, 0.642174439957239],
            [33.89842788813775, 0.644050914051031],
            [33.89721876924007, 0.644535105917054],
            [33.89752076577059, 0.645648352519157],
            [33.89640368376533, 0.648869044772406],
            [33.895497320474576, 0.649656193304591],
            [33.89385947701428, 0.652288940551415],
            [33.89398836998618, 0.653844869768255],
            [33.894594242322846, 0.654304297555516],
            [33.89458678361101, 0.65548548522793],
            [33.895775623939514, 0.656303608196869],
            [33.89651993564457, 0.658642683356304],
            [33.89744785221394, 0.658464950841724],
            [33.89885154171058, 0.65993152505127],
            [33.898506750338235, 0.661668624613222],
            [33.89691323065236, 0.662302564716738],
            [33.89579967812786, 0.663315946565014],
            [33.89409777221139, 0.665722555494362],
            [33.89490189195143, 0.671059684391271],
            [33.896893752482065, 0.672551943106874],
            [33.89715767751253, 0.674320134836732],
            [33.89610138270592, 0.676476343248643],
            [33.8954572241719, 0.676692628115369],
            [33.89428378096738, 0.676245077313529],
            [33.89274267797833, 0.678275769377786],
            [33.89047353446897, 0.678676662973133],
            [33.888605287511325, 0.681807696284292],
            [33.88670813995437, 0.682942564392161],
            [33.88370522287653, 0.68616907180879],
            [33.8809650926637, 0.69138191515752],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 948,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "BULUGUYI",
        Population: 31411,
        Key: "BUGIRIBULUGUYI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.74969311777534, 0.555916059926951],
            [33.750244667190124, 0.552788961486926],
            [33.75005383448106, 0.547848646656684],
            [33.763881003371516, 0.549117273812369],
            [33.7703147500128, 0.546398260589189],
            [33.77257543408714, 0.547818591299517],
            [33.772961312603954, 0.547510602703366],
            [33.77489025423375, 0.550735617557416],
            [33.77520914627815, 0.554870509585448],
            [33.77578007864181, 0.557132348392945],
            [33.775423620848855, 0.558568532845294],
            [33.77030447328594, 0.561064917195572],
            [33.769082989976674, 0.561201710578089],
            [33.767750391354966, 0.560804416451179],
            [33.76526672835914, 0.565508897205373],
            [33.7612232351955, 0.569059893720483],
            [33.76029423705456, 0.571762777882605],
            [33.75687254156093, 0.57511972714875],
            [33.75470743643617, 0.570649327405419],
            [33.74945619520399, 0.564537338315875],
            [33.74956097290211, 0.561781485065667],
            [33.74875371175349, 0.561056519248632],
            [33.74969311777534, 0.555916059926951],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 949,
        District: "BUGIRI",
        County: "BUGIRI MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 13824,
        Key: "BUGIRIEASTERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.734882536193886, 0.484212844273536],
            [33.73137005066945, 0.485686082466367],
            [33.729591488814826, 0.487332759883163],
            [33.71975873093746, 0.489573869972234],
            [33.71738139882685, 0.491321662477659],
            [33.71661726130346, 0.486130966993234],
            [33.7184909448652, 0.481001325653993],
            [33.717929057638145, 0.478730680749032],
            [33.71619488872822, 0.475293143125978],
            [33.71610137859873, 0.472615348798784],
            [33.715646421433206, 0.472407323121177],
            [33.71503016008031, 0.471122765030547],
            [33.71715344593363, 0.468110015583991],
            [33.717523576983496, 0.462636763799772],
            [33.71699270678656, 0.455906121908217],
            [33.715976016904214, 0.45482062840871],
            [33.71512932600283, 0.452790856166172],
            [33.71396340169725, 0.452477750059709],
            [33.71027839202755, 0.449986679555302],
            [33.70465043599275, 0.448570838958034],
            [33.70210184995468, 0.447127968603071],
            [33.70160308644434, 0.446198298026627],
            [33.701413886872466, 0.437004300715471],
            [33.700980537782755, 0.433371698444055],
            [33.699971111677776, 0.429832667504442],
            [33.6992138516562, 0.423140479501709],
            [33.697073407082655, 0.416821559993713],
            [33.69480673753356, 0.411917459024258],
            [33.69677546644563, 0.411778455511688],
            [33.697998667333714, 0.411027473412416],
            [33.7020727741839, 0.410176725107625],
            [33.70383693424788, 0.410502247353607],
            [33.706975272354796, 0.408945942442653],
            [33.70914874169313, 0.401427981607549],
            [33.70774607268266, 0.398605548264875],
            [33.708231677670724, 0.38944124677803],
            [33.70716534329249, 0.38544271588484],
            [33.7070223970763, 0.381950719286292],
            [33.70503415495964, 0.374758790562454],
            [33.705609695680714, 0.372967505375896],
            [33.707579816083125, 0.371429413654042],
            [33.70895063712186, 0.369592832083912],
            [33.70890334711036, 0.368181558615559],
            [33.70989219281217, 0.365566997309493],
            [33.71120108938513, 0.363461464353272],
            [33.70758146898325, 0.361488034523553],
            [33.70519596220356, 0.36124306971612],
            [33.70319002776737, 0.357217462083078],
            [33.701287633150834, 0.355770142479257],
            [33.70030663063978, 0.355488358080762],
            [33.700389607124244, 0.353047378485017],
            [33.699051374269075, 0.350286094654035],
            [33.69885011032295, 0.342709141423731],
            [33.699786566277396, 0.340486494690883],
            [33.70233286789967, 0.336859737652031],
            [33.70427815976597, 0.335525917825427],
            [33.704767273573566, 0.332502879549368],
            [33.704289695032536, 0.32993167916624],
            [33.704516357945025, 0.328518686687219],
            [33.70323921861403, 0.327004871438432],
            [33.70277356251344, 0.324211392271377],
            [33.70146048697782, 0.320745122479351],
            [33.70128093171882, 0.312908877844762],
            [33.70034985397799, 0.310529946008388],
            [33.698058207670734, 0.3081991635377],
            [33.69394465759306, 0.305069294654518],
            [33.69385262070064, 0.304234770654438],
            [33.717448847033324, 0.30523717662031],
            [33.72768711700635, 0.306816383380386],
            [33.732619454516026, 0.308170245390405],
            [33.73882219399212, 0.309223077181931],
            [33.7408672428724, 0.308954390498556],
            [33.74615222213173, 0.32004112289989],
            [33.74668425205368, 0.324754866099373],
            [33.743876127458684, 0.332969373098214],
            [33.74136206996519, 0.338071839491326],
            [33.74077427352869, 0.341156771561137],
            [33.74015432369324, 0.3496063341914],
            [33.740350843636364, 0.355984163763851],
            [33.741069449151276, 0.359340389325101],
            [33.74257198566853, 0.361249094596999],
            [33.74479274861166, 0.361836937720544],
            [33.74727519169533, 0.361909103337821],
            [33.748953974078084, 0.362506036289027],
            [33.74780957250843, 0.365093452847366],
            [33.74797973138953, 0.371570783948461],
            [33.747683813758535, 0.372348814590342],
            [33.744924328444576, 0.377089458926387],
            [33.739443883864276, 0.383947248681694],
            [33.74156126239628, 0.390342998798694],
            [33.744176011151666, 0.387565464755331],
            [33.74623662693751, 0.387131044919988],
            [33.748116322025126, 0.385882450119238],
            [33.75150192590556, 0.386424941178087],
            [33.754610732795825, 0.388007809324105],
            [33.75711394313227, 0.387908070766281],
            [33.75634792812994, 0.388559492495908],
            [33.75545677152032, 0.390377930774371],
            [33.75534294599067, 0.392449603191447],
            [33.75425711278087, 0.396583979715257],
            [33.753137396016896, 0.398673839234772],
            [33.75370939647743, 0.4014148934751],
            [33.75570972183295, 0.40497000316969],
            [33.75526428231788, 0.407250628249127],
            [33.75355253895073, 0.408706083096569],
            [33.748892559855385, 0.410238414430358],
            [33.74350302388352, 0.410815239308533],
            [33.741534559076165, 0.411756269493759],
            [33.736805368381454, 0.415981473234636],
            [33.734477696038034, 0.419564146807472],
            [33.734367796146195, 0.421491083596928],
            [33.733112114872355, 0.423110544859461],
            [33.73256470669106, 0.425155129884444],
            [33.731275971008024, 0.427643070031341],
            [33.73128514190879, 0.429579043401747],
            [33.733035511036505, 0.432564251941058],
            [33.73328282352245, 0.434518294051016],
            [33.73110614989347, 0.437178209493916],
            [33.730691306098635, 0.439349436897356],
            [33.72897728640054, 0.44057994523386],
            [33.728429318568814, 0.442597393643778],
            [33.72675696453026, 0.444886353611047],
            [33.72460550211972, 0.446940150966985],
            [33.72332835380558, 0.447293096380039],
            [33.721815464204646, 0.449174945532021],
            [33.72669445346457, 0.448866870579552],
            [33.729100574783416, 0.449183259184472],
            [33.73270142398908, 0.450585117817982],
            [33.734695953414416, 0.451851438096279],
            [33.73763513502286, 0.45278293596765],
            [33.73714739473933, 0.455702731797683],
            [33.73756533592529, 0.465031412417381],
            [33.737302586789525, 0.465728982428197],
            [33.73809110369141, 0.466209961355641],
            [33.73864082862783, 0.467989836687127],
            [33.73333680957609, 0.470058973732603],
            [33.73266846929289, 0.476336925238172],
            [33.733036878272394, 0.481620649968748],
            [33.734882536193886, 0.484212844273536],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 950,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "BULIDHA",
        Population: 24272,
        Key: "BUGIRIBULIDHA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.705732908605064, 0.613572352787194],
            [33.70579199708951, 0.614440823777409],
            [33.70444746614589, 0.617982044613161],
            [33.7039543386656, 0.621550060052931],
            [33.7035113434664, 0.622034769622552],
            [33.70291720312739, 0.625250989780156],
            [33.70195103539491, 0.627460875917871],
            [33.70193877608622, 0.629793520168771],
            [33.70076150875356, 0.633846584575945],
            [33.69887566379952, 0.636968985893025],
            [33.69778857654157, 0.641907571733885],
            [33.67982408994764, 0.641529924811509],
            [33.680170937563666, 0.639277381844229],
            [33.679947233701746, 0.636266041881183],
            [33.67699984688148, 0.631407169481664],
            [33.675196392710355, 0.629547416406326],
            [33.674782892795186, 0.628126380692509],
            [33.673246039735744, 0.625690138276415],
            [33.67268872942507, 0.620216947718286],
            [33.67074265692279, 0.614125879963948],
            [33.67139680382448, 0.612809150102131],
            [33.67159734283018, 0.61032901504518],
            [33.67132409149042, 0.608492575313098],
            [33.67225130288231, 0.607687300778761],
            [33.67241830867676, 0.604692815806037],
            [33.67174176497841, 0.602277426707351],
            [33.67174320677445, 0.595700462660558],
            [33.67093612169562, 0.591294809312811],
            [33.6695935230282, 0.589476581859177],
            [33.668429905596255, 0.586057060562468],
            [33.668228878805365, 0.581732750428626],
            [33.66623344118326, 0.578286185610822],
            [33.66616258117535, 0.577517221928078],
            [33.6639173544121, 0.575337224368471],
            [33.65564053879396, 0.569340198274018],
            [33.654519872510704, 0.56806473514927],
            [33.651668714122025, 0.566753281603729],
            [33.647867431013516, 0.562302705634145],
            [33.6452533730626, 0.561678771242778],
            [33.64212693314161, 0.559752156883287],
            [33.64197463097172, 0.558919870602315],
            [33.640216358466105, 0.556531715549325],
            [33.63793865670702, 0.554571615471924],
            [33.63698528906905, 0.553085245307773],
            [33.63619991177908, 0.552919256053066],
            [33.63343525037244, 0.550783358114088],
            [33.63311048514273, 0.547941662951359],
            [33.63080789286377, 0.545884664972098],
            [33.62795784569109, 0.5389460724546],
            [33.626437715668985, 0.536358845213152],
            [33.6253569552456, 0.535210013078494],
            [33.62385950049789, 0.534658312538338],
            [33.62276692902517, 0.533346636955019],
            [33.62238880207094, 0.532164004805961],
            [33.62116252984288, 0.531546836694291],
            [33.61820515106173, 0.528389447442694],
            [33.618052114968236, 0.525738746181216],
            [33.6186879802556, 0.524036828140107],
            [33.618516702971945, 0.522682022194371],
            [33.6190222712206, 0.52184401778236],
            [33.6182784284361, 0.519641169298065],
            [33.61989283664728, 0.514576443141863],
            [33.61914784581585, 0.513471155582218],
            [33.619171904495786, 0.512512190352306],
            [33.61957614278038, 0.51085658405245],
            [33.62014676971683, 0.510621311152595],
            [33.61998041699757, 0.509571897708729],
            [33.62087290401212, 0.503754709943999],
            [33.62065982811833, 0.501583496293524],
            [33.62209756376426, 0.500316804277366],
            [33.62202668040012, 0.499113585464839],
            [33.62291050585873, 0.496670861995816],
            [33.62432138097931, 0.49647169770619],
            [33.624852494619695, 0.494155665141146],
            [33.62677478152989, 0.491179083523316],
            [33.62725984932542, 0.488962571642131],
            [33.629225296691764, 0.485063215693812],
            [33.631391769052335, 0.486664293728846],
            [33.632155079227374, 0.486818016876241],
            [33.63433484126428, 0.486401657368633],
            [33.63529520318508, 0.485587354874938],
            [33.63574043069778, 0.483796048938211],
            [33.634478738796396, 0.481588751919912],
            [33.63475276897548, 0.480955451207196],
            [33.63666245431886, 0.481434750186096],
            [33.63820206071463, 0.482493078164997],
            [33.64333222880948, 0.482266419692462],
            [33.6476374209783, 0.483143542234684],
            [33.65380943178345, 0.482681559585303],
            [33.656514774736884, 0.481034787617371],
            [33.658479109090585, 0.48332342257415],
            [33.660696143126955, 0.485123505759837],
            [33.66205650508082, 0.485430960205779],
            [33.66508910519059, 0.487638061942972],
            [33.66589125582355, 0.488705496639185],
            [33.66784697802862, 0.489067168562333],
            [33.66928545388633, 0.489817901880602],
            [33.67020610757664, 0.490812948149302],
            [33.67020349437748, 0.492757994091822],
            [33.67093558450309, 0.495254815327059],
            [33.66909983050759, 0.498231375354451],
            [33.669789092553756, 0.499307864821672],
            [33.67176120631779, 0.500646575813192],
            [33.67375647595491, 0.503233729653447],
            [33.675133973272835, 0.506273281551676],
            [33.676227503247965, 0.50612841859458],
            [33.67674988346717, 0.506508325548569],
            [33.67765270829402, 0.508824187561321],
            [33.6786030953219, 0.509439263108144],
            [33.687795295112835, 0.514162746997351],
            [33.688714362378334, 0.51610517198308],
            [33.691088307840346, 0.518232436949868],
            [33.69428898094315, 0.51812416564009],
            [33.695115904416674, 0.517692402648562],
            [33.69571303884057, 0.516582323312544],
            [33.69839311038842, 0.517260366550914],
            [33.69843211793302, 0.515879834240688],
            [33.69915757759355, 0.515887313310581],
            [33.70357658091898, 0.52011161022257],
            [33.70600075657839, 0.520780788873756],
            [33.71005077151098, 0.525113672588402],
            [33.71227404165204, 0.522308957488158],
            [33.71467441644802, 0.521141664934717],
            [33.71847677753484, 0.520878875460248],
            [33.723661569487156, 0.522543382879195],
            [33.724525395752586, 0.522044929337051],
            [33.726961646566046, 0.524967305445051],
            [33.73110981052824, 0.531602307970552],
            [33.732471566667435, 0.540788815284642],
            [33.728169759350614, 0.544579869000507],
            [33.72783636939586, 0.546497791192437],
            [33.726838378844434, 0.547067849587329],
            [33.72690868010025, 0.547845850329054],
            [33.72845982176262, 0.549505766537877],
            [33.72820477747703, 0.552863216365033],
            [33.729681089476216, 0.555734696808739],
            [33.73101529338734, 0.557063210130458],
            [33.73445763396282, 0.558745731484611],
            [33.733012975000996, 0.56339620350568],
            [33.732204855062975, 0.564210500359688],
            [33.7297801943133, 0.568716018512796],
            [33.728591337815146, 0.5700550682889],
            [33.72856749293425, 0.572479562708876],
            [33.72775266617431, 0.574195652441707],
            [33.727653079840216, 0.576371436654073],
            [33.726926455064785, 0.577853461315626],
            [33.723400668185924, 0.581935952342831],
            [33.72186320067883, 0.582947362667792],
            [33.721353208227434, 0.58661718021898],
            [33.71783294688589, 0.592200907782217],
            [33.71715495240836, 0.597096902555939],
            [33.716275513423284, 0.59802882163763],
            [33.71273255075622, 0.606578362279392],
            [33.712352383727975, 0.607175491053385],
            [33.70909612377371, 0.609130000021874],
            [33.708049957471914, 0.610740442543932],
            [33.70655269855694, 0.611762913287233],
            [33.705732908605064, 0.613572352787194],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 951,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "BUWUNGA",
        Population: 46762,
        Key: "BUGIRIBUWUNGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.797008364750205, 0.478829675230219],
            [33.79579723991448, 0.478559789416027],
            [33.7948205169774, 0.479047292589523],
            [33.79158934607071, 0.479111470481457],
            [33.79038963253403, 0.47866833265793],
            [33.78916561777231, 0.478825352688003],
            [33.787178592872856, 0.476529953942669],
            [33.785246720938595, 0.475591667271324],
            [33.78396187496077, 0.475629458093267],
            [33.78173338291295, 0.476489131416399],
            [33.781044523312055, 0.478846366243616],
            [33.77727771934078, 0.484920987835472],
            [33.776360410976594, 0.488530652215466],
            [33.77528277489378, 0.489887755019032],
            [33.77378938142948, 0.490014581720177],
            [33.771120620569356, 0.491471382772721],
            [33.770141469486056, 0.494547315128366],
            [33.76596395486859, 0.499351514100325],
            [33.76262542809891, 0.505063753416987],
            [33.761551658365065, 0.506248937259524],
            [33.75868124638489, 0.508224373732141],
            [33.75651278515424, 0.508328583187662],
            [33.75040823603032, 0.505866857350357],
            [33.74422999810359, 0.504890546991274],
            [33.74123573000531, 0.503832442652104],
            [33.73716680014609, 0.503786301573049],
            [33.734476263225154, 0.502676117433943],
            [33.73340238299854, 0.502988098402266],
            [33.73290665489552, 0.502322855060237],
            [33.7304712583799, 0.502154917876789],
            [33.73131366701232, 0.499066016983718],
            [33.73491866823124, 0.492150071797055],
            [33.73526874798566, 0.486078185683449],
            [33.734882536193886, 0.484212844273536],
            [33.733036878272394, 0.481620649968748],
            [33.73266846929289, 0.476336925238172],
            [33.73333680957609, 0.470058973732603],
            [33.73864082862783, 0.467989836687127],
            [33.73809110369141, 0.466209961355641],
            [33.737302586789525, 0.465728982428197],
            [33.73756533592529, 0.465031412417381],
            [33.73714739473933, 0.455702731797683],
            [33.73763513502286, 0.45278293596765],
            [33.734695953414416, 0.451851438096279],
            [33.73270142398908, 0.450585117817982],
            [33.729100574783416, 0.449183259184472],
            [33.72669445346457, 0.448866870579552],
            [33.721815464204646, 0.449174945532021],
            [33.72332835380558, 0.447293096380039],
            [33.72460550211972, 0.446940150966985],
            [33.72675696453026, 0.444886353611047],
            [33.728429318568814, 0.442597393643778],
            [33.72897728640054, 0.44057994523386],
            [33.730691306098635, 0.439349436897356],
            [33.73110614989347, 0.437178209493916],
            [33.73328282352245, 0.434518294051016],
            [33.733035511036505, 0.432564251941058],
            [33.73128514190879, 0.429579043401747],
            [33.731275971008024, 0.427643070031341],
            [33.73256470669106, 0.425155129884444],
            [33.733112114872355, 0.423110544859461],
            [33.734367796146195, 0.421491083596928],
            [33.734477696038034, 0.419564146807472],
            [33.736805368381454, 0.415981473234636],
            [33.741534559076165, 0.411756269493759],
            [33.74350302388352, 0.410815239308533],
            [33.748892559855385, 0.410238414430358],
            [33.75355253895073, 0.408706083096569],
            [33.75526428231788, 0.407250628249127],
            [33.75570972183295, 0.40497000316969],
            [33.75932110468368, 0.405458175012076],
            [33.76627044477216, 0.407502028003178],
            [33.77131087835661, 0.410622590664202],
            [33.772019780269844, 0.411816661670557],
            [33.776659879647916, 0.410323531214509],
            [33.778054445854565, 0.41056764931558],
            [33.78240911992417, 0.413715400278332],
            [33.78526686565885, 0.415162552833526],
            [33.78679861988072, 0.416908370885045],
            [33.78791857469827, 0.417442000035999],
            [33.789776281722666, 0.417795239663278],
            [33.790832820871046, 0.41664561342969],
            [33.79181561911436, 0.416021306179351],
            [33.79282256497085, 0.416022849444315],
            [33.79378125782185, 0.41519787725632],
            [33.79613567301123, 0.415631868014054],
            [33.79867978184593, 0.418360205647372],
            [33.798269120607046, 0.41961298869638],
            [33.79918812678711, 0.420887549712926],
            [33.798171863604495, 0.422811562238556],
            [33.7969844956148, 0.424776344104551],
            [33.79722903949302, 0.426018508326648],
            [33.79591338219924, 0.42776320557352],
            [33.79666012384715, 0.433053122729927],
            [33.796365690233024, 0.434073862636932],
            [33.79679027176552, 0.434820815474989],
            [33.79620665429175, 0.439378840587004],
            [33.79700597433323, 0.442607739232196],
            [33.79463567872623, 0.443753184513608],
            [33.794065526100255, 0.448253661629948],
            [33.793314751016716, 0.449484064281743],
            [33.794469479618904, 0.454649473296719],
            [33.79424725977378, 0.45635928065912],
            [33.79488705159725, 0.457146252604762],
            [33.795374437944524, 0.461162829927687],
            [33.79459552133808, 0.461832357624031],
            [33.79412296078624, 0.464853932720438],
            [33.79277415655683, 0.467088565410432],
            [33.79363741418866, 0.472208770748631],
            [33.794152021285676, 0.473484264048536],
            [33.79512544111746, 0.474352612371913],
            [33.79523675136431, 0.475275339129651],
            [33.796516949458855, 0.477211133608484],
            [33.797008364750205, 0.478829675230219],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 952,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "MUTERERE",
        Population: 27907,
        Key: "BUGIRIMUTERERE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.48659236433773, 0.461763064732088],
            [33.484646220868555, 0.465152808541865],
            [33.48307580405516, 0.465165235425966],
            [33.48183800015383, 0.464453289193985],
            [33.48044316175766, 0.465798334568164],
            [33.47870018127313, 0.464828484285976],
            [33.476225620007725, 0.46645639251657],
            [33.47380857517504, 0.470636970734513],
            [33.46884369349924, 0.475314630986523],
            [33.46868354274871, 0.472069266223249],
            [33.46758127126753, 0.469892552950283],
            [33.46755204008817, 0.468792820175313],
            [33.46673647221815, 0.468279748386547],
            [33.463984006339814, 0.467708163150726],
            [33.45744797572365, 0.468340123936585],
            [33.45616177149311, 0.468828749787275],
            [33.45387481529, 0.470607520461447],
            [33.45091078987406, 0.470656601854421],
            [33.44926739931685, 0.47177854532652],
            [33.44835925197197, 0.473063288342666],
            [33.447017301888145, 0.47139871545637],
            [33.44619743917274, 0.467830240129341],
            [33.448894806883104, 0.463854209812814],
            [33.45098158969487, 0.462351390907839],
            [33.45101742977973, 0.460659587531152],
            [33.44975768452759, 0.456487185917349],
            [33.45008178949558, 0.453828966224338],
            [33.45040600136308, 0.452896244121918],
            [33.45344000643797, 0.44907198020432],
            [33.45480663324263, 0.450027911853391],
            [33.45719233046517, 0.44998112634148],
            [33.45763240344475, 0.449864510646868],
            [33.45763505077989, 0.448630876918101],
            [33.457966131166074, 0.44860863621174],
            [33.45924632566737, 0.448764095684523],
            [33.459643693636664, 0.449875080797017],
            [33.464190576634365, 0.450219202189859],
            [33.464948534646894, 0.451483000140817],
            [33.467264490264036, 0.453248999708119],
            [33.470317484825706, 0.452113484680598],
            [33.4724382814474, 0.450320209234559],
            [33.47514849776125, 0.449282028608934],
            [33.476208974225514, 0.448273609906926],
            [33.47348392492969, 0.44772512883606],
            [33.472084502430626, 0.446298705070362],
            [33.47046404226936, 0.443362745272102],
            [33.468342807269856, 0.441160832598599],
            [33.46756202576087, 0.439529730658479],
            [33.46608893961189, 0.437794875976401],
            [33.46467464280836, 0.433857965937779],
            [33.46554357060627, 0.431885708137728],
            [33.46484430761606, 0.428538355460728],
            [33.46662174477995, 0.428247701996924],
            [33.46990933168312, 0.429024715787045],
            [33.47426444143563, 0.429459479200489],
            [33.477740615259655, 0.427326473909803],
            [33.480544316550215, 0.426445287007002],
            [33.484326923683966, 0.426586288057045],
            [33.48461299577947, 0.429454175696042],
            [33.48434896654441, 0.434542190346966],
            [33.48552244837647, 0.437545949294116],
            [33.486346075931245, 0.43831358309523],
            [33.48703239240155, 0.438344245291853],
            [33.48861847763016, 0.437361499999788],
            [33.49138374270464, 0.437158906158664],
            [33.494261413072294, 0.435963934482449],
            [33.49596948232992, 0.434612689899159],
            [33.497046071875445, 0.432035851880504],
            [33.498091433286746, 0.43088814651035],
            [33.50531705383411, 0.42691823329623],
            [33.50684945574133, 0.429425573242482],
            [33.506409244421164, 0.431479269736999],
            [33.504107731018856, 0.434510168124616],
            [33.5035283356269, 0.438192334740139],
            [33.502287684066104, 0.439314247328937],
            [33.5015312271384, 0.440951805316937],
            [33.50002661641114, 0.442462757266588],
            [33.49781219108234, 0.445973145718059],
            [33.4961334365474, 0.447122230339745],
            [33.49456149798789, 0.44970978150534],
            [33.490882787304976, 0.453129804185114],
            [33.48995389426689, 0.454767377956275],
            [33.49004334041805, 0.45684818490534],
            [33.48923976146379, 0.459363310949129],
            [33.48659236433773, 0.461763064732088],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 953,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "MAYUGE TOWN COUNCIL",
        Population: 17392,
        Key: "MAYUGEMAYUGE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.58416688001865, 0.376326894665716],
            [33.58109990228126, 0.375466286720798],
            [33.57904275668737, 0.3739925646434],
            [33.57589227964601, 0.373358454675484],
            [33.5719049329843, 0.374621529125554],
            [33.56896175207621, 0.377256585067092],
            [33.56637067303025, 0.376693682351403],
            [33.559707635005964, 0.376508820245868],
            [33.559008186962814, 0.376286508179948],
            [33.55819825422456, 0.375323011203164],
            [33.55731464525996, 0.373544207059088],
            [33.55665185027701, 0.37080183681199],
            [33.55591556681565, 0.370208929680197],
            [33.55473666454917, 0.369737036533372],
            [33.55105721904433, 0.369622280042831],
            [33.54680361173239, 0.370428870397012],
            [33.54270791117942, 0.370038036847985],
            [33.54221951782066, 0.369725196086128],
            [33.54144244365887, 0.367814495697051],
            [33.53876017393349, 0.365524984857031],
            [33.53692303563413, 0.364538777759562],
            [33.53188232806353, 0.364289097873151],
            [33.52189915537667, 0.364964407984182],
            [33.51978057759377, 0.365414726085527],
            [33.518221151667866, 0.36509887317174],
            [33.51370897687782, 0.362375974516271],
            [33.50575969060554, 0.356133882182934],
            [33.49845038120966, 0.352073840540455],
            [33.49626099641941, 0.351919673682469],
            [33.48899483041169, 0.357077757905953],
            [33.48656120357715, 0.358299237175341],
            [33.47523983935765, 0.361433291381228],
            [33.46782621848931, 0.365685588681989],
            [33.465007383281176, 0.360164064423675],
            [33.46171578989182, 0.355658802038842],
            [33.45989758718034, 0.353876623595172],
            [33.453562891477254, 0.349398643968545],
            [33.45021296598493, 0.346377086851514],
            [33.44895194512505, 0.344748674776625],
            [33.447337564761675, 0.341546088207737],
            [33.446231946157745, 0.33594600236604],
            [33.44370978855535, 0.317019635829529],
            [33.443333823846, 0.312088994984921],
            [33.44353220689504, 0.301313919528314],
            [33.45403636561574, 0.299178371349129],
            [33.46768180173096, 0.295007101303198],
            [33.48181242062611, 0.289514943178762],
            [33.48780408924806, 0.286474884134378],
            [33.493583415899806, 0.28279249896772],
            [33.49729086907859, 0.281308628557047],
            [33.5066783266797, 0.278693637041927],
            [33.51281892699264, 0.278503379707207],
            [33.51456120858784, 0.278928511368453],
            [33.51738915540793, 0.278901244229405],
            [33.52360958450856, 0.280565606781562],
            [33.52708688481996, 0.282365793617608],
            [33.53017950406883, 0.285342101105148],
            [33.53286494484716, 0.288788864842098],
            [33.53886240131451, 0.290643201935726],
            [33.542454864747, 0.292940950345484],
            [33.54769647963262, 0.297862222574775],
            [33.553143294881934, 0.305362252671556],
            [33.556917185662485, 0.308944229802103],
            [33.56097572650543, 0.316564266111301],
            [33.5633744025872, 0.31707174719966],
            [33.57174480558995, 0.31678842199526],
            [33.57865599333001, 0.318256143324865],
            [33.581699474732815, 0.31934109466226],
            [33.58886425058937, 0.320425805140424],
            [33.593350722782525, 0.321987799956571],
            [33.594650997325374, 0.322838128148251],
            [33.59611198406578, 0.325018333244981],
            [33.59722731884782, 0.332608577138547],
            [33.59577911962546, 0.337584437361971],
            [33.59415439605987, 0.339873393637767],
            [33.58951694311862, 0.341845899195455],
            [33.58740522217627, 0.343456373630242],
            [33.585786131945845, 0.346071021150881],
            [33.58422402454881, 0.352747712478581],
            [33.58523254425368, 0.358239100634299],
            [33.58690148828745, 0.362373412572324],
            [33.58655117047947, 0.36476180965622],
            [33.5854411770801, 0.367940664172949],
            [33.5843636182524, 0.370763212758501],
            [33.58574585418345, 0.375571301115269],
            [33.58416688001865, 0.376326894665716],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 954,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "KITYERERA",
        Population: 46149,
        Key: "MAYUGEKITYERERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.95178685212216, -0.028679181371895],
            [33.7035218052462, -0.011707451962308],
            [33.70446747522054, -0.021322102969558],
            [33.70431698854581, -0.028876058819664],
            [33.70326677533366, -0.035073036431846],
            [33.69921581627172, -0.045874774650708],
            [33.69306322255143, -0.055536700607013],
            [33.68976199113741, -0.059010666432531],
            [33.68390980482791, -0.062638456763721],
            [33.677757698892854, -0.065361600830353],
            [33.670104885410396, -0.067478627596807],
            [33.6591507425976, -0.067931109587812],
            [33.659087473353836, -0.355559711686727],
            [33.65793786604706, -0.999119706247201],
            [33.92961826796486, -0.995874038884226],
            [33.92934576761667, -0.675148938502892],
            [33.929322737507746, -0.539738483478412],
            [33.932724996153574, -0.519169301872466],
            [33.93612246588061, -0.462605011186167],
            [33.94122522727444, -0.421467092939738],
            [33.954838053646526, -0.347761485679045],
            [33.96504799345042, -0.286054987167088],
            [33.97185552997974, -0.250059637634743],
            [33.984707457255034, -0.168273074531305],
            [33.98675317088863, -0.152822405199182],
            [33.987775489614585, -0.131184345497787],
            [33.95178685212216, -0.028679181371895],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 955,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "LOLWE",
        Population: 12190,
        Key: "NAMAYINGOLOLWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.724525395752586, 0.522044929337051],
            [33.723661569487156, 0.522543382879195],
            [33.71847677753484, 0.520878875460248],
            [33.71467441644802, 0.521141664934717],
            [33.71227404165204, 0.522308957488158],
            [33.71005077151098, 0.525113672588402],
            [33.70600075657839, 0.520780788873756],
            [33.70357658091898, 0.52011161022257],
            [33.69915757759355, 0.515887313310581],
            [33.69843211793302, 0.515879834240688],
            [33.69839311038842, 0.517260366550914],
            [33.69571303884057, 0.516582323312544],
            [33.695115904416674, 0.517692402648562],
            [33.69428898094315, 0.51812416564009],
            [33.691088307840346, 0.518232436949868],
            [33.688714362378334, 0.51610517198308],
            [33.687795295112835, 0.514162746997351],
            [33.6786030953219, 0.509439263108144],
            [33.67765270829402, 0.508824187561321],
            [33.67674988346717, 0.506508325548569],
            [33.676227503247965, 0.50612841859458],
            [33.675133973272835, 0.506273281551676],
            [33.67375647595491, 0.503233729653447],
            [33.67176120631779, 0.500646575813192],
            [33.669789092553756, 0.499307864821672],
            [33.66909983050759, 0.498231375354451],
            [33.67093558450309, 0.495254815327059],
            [33.67020349437748, 0.492757994091822],
            [33.67020610757664, 0.490812948149302],
            [33.66928545388633, 0.489817901880602],
            [33.66784697802862, 0.489067168562333],
            [33.66589125582355, 0.488705496639185],
            [33.66508910519059, 0.487638061942972],
            [33.66205650508082, 0.485430960205779],
            [33.660696143126955, 0.485123505759837],
            [33.658479109090585, 0.48332342257415],
            [33.656514774736884, 0.481034787617371],
            [33.65380943178345, 0.482681559585303],
            [33.6476374209783, 0.483143542234684],
            [33.64333222880948, 0.482266419692462],
            [33.63820206071463, 0.482493078164997],
            [33.63666245431886, 0.481434750186096],
            [33.63475276897548, 0.480955451207196],
            [33.634478738796396, 0.481588751919912],
            [33.63574043069778, 0.483796048938211],
            [33.63529520318508, 0.485587354874938],
            [33.63433484126428, 0.486401657368633],
            [33.632155079227374, 0.486818016876241],
            [33.631391769052335, 0.486664293728846],
            [33.629225296691764, 0.485063215693812],
            [33.62725984932542, 0.488962571642131],
            [33.62677478152989, 0.491179083523316],
            [33.624852494619695, 0.494155665141146],
            [33.62432138097931, 0.49647169770619],
            [33.62291050585873, 0.496670861995816],
            [33.62304845205204, 0.494300585852568],
            [33.6207082518037, 0.490890159107755],
            [33.61990038968218, 0.488800420856425],
            [33.61641450596825, 0.486484760215364],
            [33.61577183324769, 0.485037328073318],
            [33.613876568559554, 0.482621999802007],
            [33.613543315148725, 0.480523167464946],
            [33.614065530077895, 0.479075628056375],
            [33.613616088568186, 0.477818159859175],
            [33.61375354428139, 0.476117344143638],
            [33.612669236410966, 0.4727067887933],
            [33.613024679107625, 0.471702559412235],
            [33.61249983301299, 0.468789527959985],
            [33.61362790231249, 0.465270212682786],
            [33.613653765707845, 0.463519936981164],
            [33.61536023237102, 0.46143929007217],
            [33.61701878559187, 0.461366987019484],
            [33.62046045871911, 0.458430217673332],
            [33.624153026813616, 0.460990138897694],
            [33.625602100995046, 0.46093572970186],
            [33.62770590508481, 0.452585344213481],
            [33.628311308500855, 0.451852500770232],
            [33.634655537125774, 0.448966016390817],
            [33.6444983687107, 0.433784661918622],
            [33.64622912671748, 0.430726704054556],
            [33.646251467818594, 0.429243032616842],
            [33.646939934855716, 0.427822631066401],
            [33.6497294742058, 0.425533560820955],
            [33.65632760356092, 0.423560803223754],
            [33.65687159634752, 0.420611516547123],
            [33.656001341737934, 0.417562835504965],
            [33.65763896511101, 0.415701255653825],
            [33.65819095559857, 0.414360101629348],
            [33.659980293643336, 0.413364808633133],
            [33.661083787731606, 0.411564414064077],
            [33.66559753098018, 0.408632892025677],
            [33.66662966200396, 0.406434449439975],
            [33.667181172791175, 0.406072534496284],
            [33.66924244883875, 0.406343763199944],
            [33.67157285295892, 0.40780008955502],
            [33.674243774267296, 0.41110191488413],
            [33.67711902996349, 0.413155272162204],
            [33.67892867891683, 0.413336049817739],
            [33.68113199208553, 0.412919710371252],
            [33.684176017867415, 0.411643860814362],
            [33.68503422696739, 0.411770440051426],
            [33.6856515366542, 0.41245793529331],
            [33.69480673753356, 0.411917459024258],
            [33.697073407082655, 0.416821559993713],
            [33.6992138516562, 0.423140479501709],
            [33.699971111677776, 0.429832667504442],
            [33.700980537782755, 0.433371698444055],
            [33.701413886872466, 0.437004300715471],
            [33.70160308644434, 0.446198298026627],
            [33.70210184995468, 0.447127968603071],
            [33.70465043599275, 0.448570838958034],
            [33.71027839202755, 0.449986679555302],
            [33.71396340169725, 0.452477750059709],
            [33.71512932600283, 0.452790856166172],
            [33.715976016904214, 0.45482062840871],
            [33.71699270678656, 0.455906121908217],
            [33.717523576983496, 0.462636763799772],
            [33.71715344593363, 0.468110015583991],
            [33.71503016008031, 0.471122765030547],
            [33.715646421433206, 0.472407323121177],
            [33.71610137859873, 0.472615348798784],
            [33.71619488872822, 0.475293143125978],
            [33.717929057638145, 0.478730680749032],
            [33.7184909448652, 0.481001325653993],
            [33.71661726130346, 0.486130966993234],
            [33.71738139882685, 0.491321662477659],
            [33.71975873093746, 0.489573869972234],
            [33.729591488814826, 0.487332759883163],
            [33.73137005066945, 0.485686082466367],
            [33.734882536193886, 0.484212844273536],
            [33.73526874798566, 0.486078185683449],
            [33.73491866823124, 0.492150071797055],
            [33.73131366701232, 0.499066016983718],
            [33.7304712583799, 0.502154917876789],
            [33.72859187141442, 0.508737148733594],
            [33.72847250866936, 0.511116421296038],
            [33.725298458936635, 0.514663058800935],
            [33.72453759577246, 0.51620107133305],
            [33.72514505363557, 0.520988334246522],
            [33.724525395752586, 0.522044929337051],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 956,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "NANKOMA",
        Population: 41159,
        Key: "BUGIRINANKOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.85577854554583, 0.591332427855124],
            [33.8550024963618, 0.592228136060606],
            [33.85413620511924, 0.594317974293733],
            [33.853841156159106, 0.596742437599184],
            [33.8540800738887, 0.598153627661421],
            [33.85818762950848, 0.607027422871024],
            [33.86008241090298, 0.612825808406189],
            [33.859800586042155, 0.61705953109365],
            [33.85881711765563, 0.620343505738594],
            [33.854320568161604, 0.630539457621235],
            [33.83966743699495, 0.662502676224965],
            [33.83487950097225, 0.676561561377217],
            [33.8310986922657, 0.674689615953256],
            [33.82482208971369, 0.670646955675204],
            [33.80930709779546, 0.657912193734311],
            [33.80655546555373, 0.653886978249947],
            [33.803033222528654, 0.649689997430454],
            [33.80056504109843, 0.647980613056457],
            [33.79848228273913, 0.647076299983321],
            [33.79467699943268, 0.643024086774805],
            [33.791237826316866, 0.641443057778379],
            [33.79113306299183, 0.640963947070816],
            [33.78880541041134, 0.639577981638574],
            [33.7860590539753, 0.638670401903067],
            [33.785591892298314, 0.638257006707261],
            [33.785648126835085, 0.637340886085303],
            [33.7849831471494, 0.636905243582666],
            [33.78232619464368, 0.628207857483359],
            [33.78253810542254, 0.62555720182789],
            [33.78188160134157, 0.622246283452622],
            [33.78095358955077, 0.621169889330457],
            [33.77976303883, 0.618419930756358],
            [33.77832327299152, 0.616737494748294],
            [33.77798814749165, 0.614132150742683],
            [33.776418098987534, 0.612576382971788],
            [33.77564242979083, 0.608505566914349],
            [33.775519980434446, 0.604516074029756],
            [33.77370824828796, 0.597722403214549],
            [33.77239877409831, 0.595859006736549],
            [33.77111474558737, 0.595216886133628],
            [33.76944221368239, 0.59168897803759],
            [33.7693786911137, 0.589213953516864],
            [33.771777223465, 0.583301987496953],
            [33.77241257761098, 0.58265117828877],
            [33.77239057697133, 0.582011489574855],
            [33.77332174634036, 0.581404757381114],
            [33.77392410626421, 0.579838533478769],
            [33.77604668873666, 0.579511445776859],
            [33.78233494513284, 0.579637222346053],
            [33.790275671358785, 0.580540754549276],
            [33.79136851052948, 0.579608812782333],
            [33.79508752682256, 0.578034200342],
            [33.79724967828667, 0.576649785316659],
            [33.79779544524594, 0.575546039800766],
            [33.80195348079481, 0.572677723860138],
            [33.80562537506138, 0.571609722458825],
            [33.80866831927166, 0.5712293398882],
            [33.810259918359435, 0.57048730541329],
            [33.81336246668713, 0.570631605422165],
            [33.81407637850467, 0.571065731566437],
            [33.81528835673991, 0.570703700630725],
            [33.817689407068976, 0.570848098545629],
            [33.81947335252707, 0.571996736037212],
            [33.82170817140945, 0.572258758846863],
            [33.822278171321855, 0.571779217132024],
            [33.82733025156397, 0.572456962224479],
            [33.827853071957655, 0.571977426814071],
            [33.83161017322551, 0.573858525347425],
            [33.83204059021413, 0.57522446633144],
            [33.832871914534266, 0.575866636832536],
            [33.83654506105233, 0.575902278385963],
            [33.842277229744916, 0.580053704000557],
            [33.848974709177185, 0.586900775160538],
            [33.85577854554583, 0.591332427855124],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 957,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "IWEMBA",
        Population: 19297,
        Key: "BUGIRIIWEMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.84432672438752, 0.418566862956502],
            [33.846641652331996, 0.422818396435151],
            [33.84821019885296, 0.427214749052979],
            [33.848765713431405, 0.427793654019734],
            [33.84894500728062, 0.42901489028991],
            [33.84979821545938, 0.429874197247865],
            [33.85034431659198, 0.431656266064542],
            [33.852349535969175, 0.433519584755702],
            [33.85810579029118, 0.434740179626891],
            [33.85890012827609, 0.436476982505716],
            [33.86074638627221, 0.438132245492955],
            [33.86156042790456, 0.440267082043564],
            [33.862820865757826, 0.441542464236188],
            [33.86349912074678, 0.443532668196712],
            [33.86729362337152, 0.445935561345044],
            [33.87054015906284, 0.450130880760755],
            [33.87161020078826, 0.45284125187638],
            [33.87207845661325, 0.455864559972304],
            [33.8736039370012, 0.461145385209912],
            [33.87681480149091, 0.470059950168454],
            [33.882640930368936, 0.478016847711433],
            [33.885103191003154, 0.479512531763835],
            [33.888253010477705, 0.482736066523985],
            [33.8913405874829, 0.489420832277411],
            [33.886328406812424, 0.493223237711162],
            [33.88750176916854, 0.494041201572372],
            [33.88750222820765, 0.497468683267139],
            [33.88891045329817, 0.502715025564578],
            [33.89520759942243, 0.512613620462103],
            [33.89444883651936, 0.527146988182872],
            [33.894068601219175, 0.528372509529993],
            [33.891615484536246, 0.532087563268773],
            [33.89062708889038, 0.536740652891152],
            [33.88925811658451, 0.540244926651089],
            [33.886386605964745, 0.544362158647049],
            [33.88506280454462, 0.544976850715203],
            [33.88441482188241, 0.546735285063758],
            [33.88448250814241, 0.548720996618344],
            [33.88240052952083, 0.555825332556611],
            [33.881897104652445, 0.559232141569397],
            [33.87960890428265, 0.566008146618745],
            [33.87632074694925, 0.571137890546779],
            [33.87301433405267, 0.574431248043417],
            [33.870673907428895, 0.570152712123045],
            [33.87052983921686, 0.568234919798995],
            [33.870941107716874, 0.56553573216896],
            [33.870273004588945, 0.564879622932627],
            [33.87113262224724, 0.562570917078477],
            [33.87043634256209, 0.561767142354953],
            [33.86980085456718, 0.556676002429847],
            [33.87037376681771, 0.553975706387295],
            [33.86848993139497, 0.553233943693043],
            [33.86877630352774, 0.551296345179444],
            [33.86828492057578, 0.551461315837107],
            [33.867629657966496, 0.551090391676596],
            [33.86715848082019, 0.549400251683303],
            [33.86590920722928, 0.547442263793082],
            [33.8657860455089, 0.545298601906444],
            [33.86525366344734, 0.545113168382967],
            [33.86371747873448, 0.541341335395737],
            [33.863491759951366, 0.537878497030067],
            [33.861321361952974, 0.537734520500874],
            [33.860092603188214, 0.536003259085378],
            [33.8602082540945, 0.534758014006486],
            [33.85921171252566, 0.534197580384121],
            [33.85801008737407, 0.534138742391813],
            [33.85689629320275, 0.533416052158972],
            [33.85686689044519, 0.532737465418695],
            [33.85537200667581, 0.531380492029752],
            [33.85526922413594, 0.529890555402312],
            [33.852807381218334, 0.529949907249459],
            [33.85166995596517, 0.528072016075011],
            [33.848532081388925, 0.527954847499862],
            [33.84665807263707, 0.528759527709473],
            [33.845477980102835, 0.528516143136233],
            [33.8450987302545, 0.528076167911914],
            [33.84431254268415, 0.528208727564833],
            [33.84424987800656, 0.527582591557803],
            [33.843753170739866, 0.527506706895952],
            [33.84353304217276, 0.526962408371383],
            [33.84208702136497, 0.527393006558516],
            [33.83950282071914, 0.526507242268848],
            [33.83876726758809, 0.526963059622433],
            [33.838056631028095, 0.525690945243899],
            [33.83752851865908, 0.525855581537123],
            [33.836233144426096, 0.524437968411657],
            [33.83510769012239, 0.524241909429614],
            [33.834849994908424, 0.524874886155785],
            [33.83405269607631, 0.525071034945765],
            [33.832720326525, 0.523831860026856],
            [33.83195850485842, 0.522013638721262],
            [33.83040104085311, 0.521697223880637],
            [33.82956930151131, 0.522050143840844],
            [33.82809420852598, 0.520286293904318],
            [33.82452706860134, 0.518947898698459],
            [33.82462190194926, 0.518305591855379],
            [33.82424105759131, 0.517898553096067],
            [33.821934312400764, 0.517157051028077],
            [33.82188586985075, 0.516062441756816],
            [33.821173146504336, 0.516035395478965],
            [33.82018372588072, 0.515300253906825],
            [33.81927802734329, 0.512918326685175],
            [33.81826981037067, 0.512045294374616],
            [33.81771825197274, 0.512416842490472],
            [33.817676266513004, 0.511325396146823],
            [33.81635593079324, 0.510019091897676],
            [33.81349751042379, 0.509140255407197],
            [33.81297746223108, 0.508564777806435],
            [33.81144512410429, 0.508678880012812],
            [33.81029919180534, 0.507344148256287],
            [33.80816102266438, 0.506142898871956],
            [33.80738875448935, 0.505427290172538],
            [33.80723879782068, 0.504070169901174],
            [33.80377378646235, 0.499934962963605],
            [33.80284421250129, 0.497902553180903],
            [33.80227714019843, 0.496334660361375],
            [33.80249940765423, 0.495158594082806],
            [33.801637118406276, 0.49372935941398],
            [33.80147000840722, 0.491205418464716],
            [33.80161550494051, 0.490141447943348],
            [33.80225021140114, 0.489879489023922],
            [33.80222047896188, 0.487514373796959],
            [33.799869622897624, 0.484167467497287],
            [33.80030359092654, 0.483027027697374],
            [33.79970249044072, 0.481390224065833],
            [33.7980809630809, 0.479646884481032],
            [33.797796502563024, 0.478414163213696],
            [33.797008364750205, 0.478829675230219],
            [33.796516949458855, 0.477211133608484],
            [33.79523675136431, 0.475275339129651],
            [33.79512544111746, 0.474352612371913],
            [33.794152021285676, 0.473484264048536],
            [33.79363741418866, 0.472208770748631],
            [33.79277415655683, 0.467088565410432],
            [33.79412296078624, 0.464853932720438],
            [33.79459552133808, 0.461832357624031],
            [33.795374437944524, 0.461162829927687],
            [33.79488705159725, 0.457146252604762],
            [33.79424725977378, 0.45635928065912],
            [33.794469479618904, 0.454649473296719],
            [33.793314751016716, 0.449484064281743],
            [33.794065526100255, 0.448253661629948],
            [33.79463567872623, 0.443753184513608],
            [33.79700597433323, 0.442607739232196],
            [33.79620665429175, 0.439378840587004],
            [33.79679027176552, 0.434820815474989],
            [33.796365690233024, 0.434073862636932],
            [33.79666012384715, 0.433053122729927],
            [33.79591338219924, 0.42776320557352],
            [33.79722903949302, 0.426018508326648],
            [33.7969844956148, 0.424776344104551],
            [33.798171863604495, 0.422811562238556],
            [33.801462254149676, 0.423197491322838],
            [33.80489461893393, 0.424242428900623],
            [33.80697126515601, 0.424126066124371],
            [33.81243681297397, 0.423210852499914],
            [33.81819051428392, 0.419798513672638],
            [33.821478694075175, 0.421235443454948],
            [33.821868135310424, 0.421888710291297],
            [33.8233967750732, 0.421844993166406],
            [33.825148096415134, 0.422748369275355],
            [33.82631620811841, 0.421997392713745],
            [33.82823531678915, 0.42216002109656],
            [33.830655270366705, 0.421128470469665],
            [33.83670558819695, 0.420051296397547],
            [33.83852515994093, 0.419065043625303],
            [33.84187910449583, 0.418141950493075],
            [33.84352018099285, 0.418141771733079],
            [33.84432672438752, 0.418566862956502],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 958,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "BULESA",
        Population: 39727,
        Key: "BUGIRIBULESA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.54568139944854, 0.510288271283574],
            [33.543324044073195, 0.509196890152853],
            [33.541617164185, 0.509416204266254],
            [33.5389204648212, 0.511295765498779],
            [33.53426841245995, 0.513623968144949],
            [33.52754790561369, 0.51008686081232],
            [33.52538585476089, 0.507942909383057],
            [33.5246021276761, 0.505554574697822],
            [33.52298666214786, 0.504360507632931],
            [33.521109476953136, 0.503401681181645],
            [33.51905854770099, 0.50310916687315],
            [33.5174023193201, 0.501900181610642],
            [33.51496761181229, 0.501164978243734],
            [33.51326802534588, 0.498706657780583],
            [33.51127604354268, 0.493215564586331],
            [33.510854606113654, 0.490827193110384],
            [33.5120159912321, 0.488432973859824],
            [33.51162843376404, 0.484827175638113],
            [33.512639094154224, 0.479563055737359],
            [33.51594147900505, 0.474907979435425],
            [33.518124677996255, 0.47255387288692],
            [33.51934079207506, 0.472136998692961],
            [33.524560471898056, 0.472071682609355],
            [33.52536396820731, 0.471761354849687],
            [33.52489525244488, 0.466124224491178],
            [33.524001877894825, 0.463301053452001],
            [33.52171174435055, 0.459173867731864],
            [33.52007339783368, 0.458632077924698],
            [33.51878621713442, 0.459456819869273],
            [33.51693135058295, 0.461735422671847],
            [33.51715860907845, 0.463631382819003],
            [33.5164132113102, 0.464901498745667],
            [33.51000100986271, 0.470172989460268],
            [33.50261851651726, 0.471675333296919],
            [33.501426300319956, 0.469614123197947],
            [33.49905170537602, 0.469218988227444],
            [33.498280861929025, 0.467931505631448],
            [33.49755572566201, 0.467596985066383],
            [33.49115089129814, 0.468269914857555],
            [33.49038463824225, 0.467913954034459],
            [33.489546886476276, 0.465759870877021],
            [33.49073792588057, 0.462791264498686],
            [33.48659236433773, 0.461763064732088],
            [33.48923976146379, 0.459363310949129],
            [33.49004334041805, 0.45684818490534],
            [33.48995389426689, 0.454767377956275],
            [33.490882787304976, 0.453129804185114],
            [33.49456149798789, 0.44970978150534],
            [33.4961334365474, 0.447122230339745],
            [33.49781219108234, 0.445973145718059],
            [33.50002661641114, 0.442462757266588],
            [33.5015312271384, 0.440951805316937],
            [33.502287684066104, 0.439314247328937],
            [33.5035283356269, 0.438192334740139],
            [33.504107731018856, 0.434510168124616],
            [33.506409244421164, 0.431479269736999],
            [33.50684945574133, 0.429425573242482],
            [33.50992123677053, 0.429751057856982],
            [33.51714577394969, 0.435251127532925],
            [33.52736093296538, 0.437032662398938],
            [33.528499222397855, 0.434074225545878],
            [33.53119172932423, 0.432364159708007],
            [33.53263508572889, 0.430581807197404],
            [33.5340841805716, 0.430554563860736],
            [33.536849093506476, 0.428202160480642],
            [33.538082498357895, 0.428039227704654],
            [33.54448921109899, 0.425306595144516],
            [33.54805877018672, 0.419977695810691],
            [33.549043874405385, 0.419217683968959],
            [33.55193824894577, 0.420981628631978],
            [33.552642072682644, 0.421831988608497],
            [33.554814623942775, 0.422383694629174],
            [33.55764551544035, 0.423939558521268],
            [33.56086157398904, 0.423658868724722],
            [33.569367529174876, 0.423825201623602],
            [33.57304127666586, 0.42253480062711],
            [33.57565884702956, 0.422534604799701],
            [33.57735803015239, 0.423320395466394],
            [33.57983807922587, 0.426602570468548],
            [33.579930001133924, 0.427619634536617],
            [33.57901186362476, 0.431687986473592],
            [33.57892023366916, 0.434508052652985],
            [33.57754969380311, 0.438901628202522],
            [33.57711031252626, 0.444049340292801],
            [33.571866895620204, 0.447451385487569],
            [33.57472780701794, 0.452065072383754],
            [33.576359169133475, 0.455747024526615],
            [33.57612445641773, 0.459872386010408],
            [33.577197340412695, 0.46086789292314],
            [33.577234727396494, 0.461790272920016],
            [33.574004782690174, 0.46404321364366],
            [33.56808754218441, 0.469679916293976],
            [33.56215252581584, 0.472319354095066],
            [33.55945630794903, 0.475147934556831],
            [33.558316891130865, 0.475760985782233],
            [33.55645218443379, 0.478049262290242],
            [33.55129178982627, 0.480573775869693],
            [33.54903965232352, 0.48243762712852],
            [33.54854100559417, 0.483858035872586],
            [33.54692971543535, 0.485531849966735],
            [33.543448159804434, 0.488381919965603],
            [33.5435089955121, 0.490544132666883],
            [33.54508152336644, 0.49562838014447],
            [33.54463231541871, 0.497175443780989],
            [33.54595569552896, 0.498224777478162],
            [33.5473813703939, 0.500115466257791],
            [33.54709613373163, 0.501219215547119],
            [33.54789120204688, 0.504874108459828],
            [33.5471061715066, 0.507054486164643],
            [33.545537015029566, 0.508845912459712],
            [33.54568139944854, 0.510288271283574],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 959,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "MPUNGWE",
        Population: 25642,
        Key: "MAYUGEMPUNGWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.69480673753356, 0.411917459024258],
            [33.6856515366542, 0.41245793529331],
            [33.68503422696739, 0.411770440051426],
            [33.684176017867415, 0.411643860814362],
            [33.68113199208553, 0.412919710371252],
            [33.67892867891683, 0.413336049817739],
            [33.67711902996349, 0.413155272162204],
            [33.674243774267296, 0.41110191488413],
            [33.67157285295892, 0.40780008955502],
            [33.66924244883875, 0.406343763199944],
            [33.667181172791175, 0.406072534496284],
            [33.66662966200396, 0.406434449439975],
            [33.66559753098018, 0.408632892025677],
            [33.661083787731606, 0.411564414064077],
            [33.659980293643336, 0.413364808633133],
            [33.65819095559857, 0.414360101629348],
            [33.65763896511101, 0.415701255653825],
            [33.65395823950687, 0.412747534750219],
            [33.652415760298844, 0.409763229489682],
            [33.65128443999632, 0.405623062041992],
            [33.65120225762256, 0.399977771488785],
            [33.65454308946922, 0.397837906988599],
            [33.65532907761362, 0.396240917726071],
            [33.65567968018752, 0.391824616767089],
            [33.655300485136436, 0.389648303665413],
            [33.656085380031094, 0.388164576118034],
            [33.65633321174326, 0.386042434644747],
            [33.654389924916686, 0.377429275248788],
            [33.65155694034448, 0.372370271296118],
            [33.650480902364556, 0.371460398591988],
            [33.64957736247876, 0.371029612455723],
            [33.6482459541248, 0.372106844101895],
            [33.64174045994008, 0.382136846973676],
            [33.63979107085778, 0.383494008479823],
            [33.63756471320707, 0.383973658558002],
            [33.63294262774539, 0.380527181585896],
            [33.62963135586141, 0.375904516818197],
            [33.62927125989158, 0.374891301807705],
            [33.62594127699856, 0.375570052483829],
            [33.62430863478376, 0.376691967504573],
            [33.617052607162314, 0.376321574059075],
            [33.61481106888162, 0.376584098339306],
            [33.60945822819082, 0.378492910402761],
            [33.60674582897079, 0.378222150605062],
            [33.60454369349341, 0.37174476599234],
            [33.60513558804424, 0.370576963558411],
            [33.605357069474174, 0.36889358810594],
            [33.60500622615175, 0.367336630545994],
            [33.60395982179639, 0.367093605320442],
            [33.592972772796415, 0.367702094515915],
            [33.58902876894883, 0.368998878355732],
            [33.5854411770801, 0.367940664172949],
            [33.58655117047947, 0.36476180965622],
            [33.58690148828745, 0.362373412572324],
            [33.58523254425368, 0.358239100634299],
            [33.58422402454881, 0.352747712478581],
            [33.585786131945845, 0.346071021150881],
            [33.58740522217627, 0.343456373630242],
            [33.58951694311862, 0.341845899195455],
            [33.59415439605987, 0.339873393637767],
            [33.59577911962546, 0.337584437361971],
            [33.59722731884782, 0.332608577138547],
            [33.59611198406578, 0.325018333244981],
            [33.594650997325374, 0.322838128148251],
            [33.60418512735451, 0.314767773301281],
            [33.619166321466295, 0.300527189446495],
            [33.62237707456489, 0.297161590116169],
            [33.624136563389406, 0.29440221253859],
            [33.62524957872137, 0.291353374788631],
            [33.62627496609232, 0.288078373828842],
            [33.626649411750506, 0.284939111079372],
            [33.62737667792307, 0.273196320282191],
            [33.62854356252768, 0.221394269718829],
            [33.65880507806278, 0.229257176065282],
            [33.658798792550755, 0.258475550851129],
            [33.67375809561737, 0.278440863990021],
            [33.69385262070064, 0.304234770654438],
            [33.69394465759306, 0.305069294654518],
            [33.698058207670734, 0.3081991635377],
            [33.70034985397799, 0.310529946008388],
            [33.70128093171882, 0.312908877844762],
            [33.70146048697782, 0.320745122479351],
            [33.70277356251344, 0.324211392271377],
            [33.70323921861403, 0.327004871438432],
            [33.704516357945025, 0.328518686687219],
            [33.704289695032536, 0.32993167916624],
            [33.704767273573566, 0.332502879549368],
            [33.70427815976597, 0.335525917825427],
            [33.70233286789967, 0.336859737652031],
            [33.699786566277396, 0.340486494690883],
            [33.69885011032295, 0.342709141423731],
            [33.699051374269075, 0.350286094654035],
            [33.700389607124244, 0.353047378485017],
            [33.70030663063978, 0.355488358080762],
            [33.701287633150834, 0.355770142479257],
            [33.70319002776737, 0.357217462083078],
            [33.70519596220356, 0.36124306971612],
            [33.70758146898325, 0.361488034523553],
            [33.71120108938513, 0.363461464353272],
            [33.70989219281217, 0.365566997309493],
            [33.70890334711036, 0.368181558615559],
            [33.70895063712186, 0.369592832083912],
            [33.707579816083125, 0.371429413654042],
            [33.705609695680714, 0.372967505375896],
            [33.70503415495964, 0.374758790562454],
            [33.7070223970763, 0.381950719286292],
            [33.70716534329249, 0.38544271588484],
            [33.708231677670724, 0.38944124677803],
            [33.70774607268266, 0.398605548264875],
            [33.70914874169313, 0.401427981607549],
            [33.706975272354796, 0.408945942442653],
            [33.70383693424788, 0.410502247353607],
            [33.7020727741839, 0.410176725107625],
            [33.697998667333714, 0.411027473412416],
            [33.69677546644563, 0.411778455511688],
            [33.69480673753356, 0.411917459024258],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 960,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "BUKABOOLI",
        Population: 43263,
        Key: "MAYUGEBUKABOOLI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.85601714617016, 0.280421443279056],
            [33.85453350661322, 0.28594471135666],
            [33.85295512264157, 0.289052668839236],
            [33.864118883732665, 0.293468275173749],
            [33.86637762295442, 0.29472468909083],
            [33.86691261731683, 0.295412778693928],
            [33.87191733388559, 0.29602990588764],
            [33.87341046234687, 0.296680819130248],
            [33.86997759540437, 0.299993705291234],
            [33.868128241813785, 0.303150454659707],
            [33.867519220882095, 0.305036889288259],
            [33.86667106662514, 0.305782197416373],
            [33.86369469925551, 0.307001218081511],
            [33.861415017609524, 0.306985576840306],
            [33.858010345190536, 0.307923947068999],
            [33.8553106158093, 0.310137105022327],
            [33.85396079468697, 0.31178489371706],
            [33.85076820821834, 0.312372766772967],
            [33.84486725147376, 0.310827750214986],
            [33.843571969767275, 0.311117636778967],
            [33.838822720590585, 0.313726056752067],
            [33.833449572584435, 0.313533305434374],
            [33.8265893309991, 0.314886175756484],
            [33.82260746765386, 0.31517627869905],
            [33.820448569887745, 0.314645182962048],
            [33.8090095317559, 0.3100857158526],
            [33.80766725109207, 0.31015818996975],
            [33.80481260095187, 0.311379682260626],
            [33.80245781745321, 0.312944905140215],
            [33.79913918746874, 0.313243692020722],
            [33.79726052364709, 0.312990536180954],
            [33.79363616014051, 0.310647779886151],
            [33.7919281986807, 0.309987517056674],
            [33.78997594307434, 0.309490108287575],
            [33.78753566780841, 0.309517430148296],
            [33.780983766656135, 0.310413526056793],
            [33.77637179263125, 0.312205084342895],
            [33.770841319974465, 0.316195251903325],
            [33.76485208488859, 0.311888628731322],
            [33.75177948915869, 0.30793551001631],
            [33.74616584418468, 0.3078250987805],
            [33.7408672428724, 0.308954390498556],
            [33.73882219399212, 0.309223077181931],
            [33.732619454516026, 0.308170245390405],
            [33.72768711700635, 0.306816383380386],
            [33.717448847033324, 0.30523717662031],
            [33.69385262070064, 0.304234770654438],
            [33.67375809561737, 0.278440863990021],
            [33.658798792550755, 0.258475550851129],
            [33.65880507806278, 0.229257176065282],
            [33.65880518586063, 0.229214484871411],
            [33.728493924505734, 0.247502545300076],
            [33.73341037261469, 0.250746261059792],
            [33.737219727984346, 0.253906844939363],
            [33.7382910893349, 0.253906782956238],
            [33.74836702026136, 0.259049483124562],
            [33.75378305114418, 0.262749200282149],
            [33.75543321859189, 0.264323199994845],
            [33.75709864931455, 0.267480344468897],
            [33.75934929291896, 0.270528890210444],
            [33.76135946470833, 0.272039535056154],
            [33.76593795942089, 0.273387175074654],
            [33.77314426888461, 0.274056147324254],
            [33.77795288232853, 0.273268784755564],
            [33.78418873460429, 0.274742950889884],
            [33.78558835922429, 0.275484670489676],
            [33.79046695053054, 0.279944258515807],
            [33.79619001389941, 0.281246556617198],
            [33.80023677423573, 0.284810580818908],
            [33.807706066397195, 0.28814818911174],
            [33.8093135135632, 0.28923364652172],
            [33.81363788386503, 0.295068280254497],
            [33.81416426428217, 0.296940851864714],
            [33.82357311705842, 0.288888839774624],
            [33.826233430161615, 0.287631193632479],
            [33.829961450268804, 0.287250970303623],
            [33.84072829793817, 0.287403958659309],
            [33.842723669983215, 0.28654440478331],
            [33.846631693608735, 0.282636086214575],
            [33.84821090133549, 0.281740380620129],
            [33.85179748349785, 0.280945701872861],
            [33.85601714617016, 0.280421443279056],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 961,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "BUHEMBA",
        Population: 27616,
        Key: "NAMAYINGOBUHEMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.84432672438752, 0.418566862956502],
            [33.84352018099285, 0.418141771733079],
            [33.84187910449583, 0.418141950493075],
            [33.83852515994093, 0.419065043625303],
            [33.83670558819695, 0.420051296397547],
            [33.830655270366705, 0.421128470469665],
            [33.82823531678915, 0.42216002109656],
            [33.82631620811841, 0.421997392713745],
            [33.825148096415134, 0.422748369275355],
            [33.8233967750732, 0.421844993166406],
            [33.821868135310424, 0.421888710291297],
            [33.821478694075175, 0.421235443454948],
            [33.81819051428392, 0.419798513672638],
            [33.81243681297397, 0.423210852499914],
            [33.80697126515601, 0.424126066124371],
            [33.80489461893393, 0.424242428900623],
            [33.801462254149676, 0.423197491322838],
            [33.798171863604495, 0.422811562238556],
            [33.79918812678711, 0.420887549712926],
            [33.798269120607046, 0.41961298869638],
            [33.79867978184593, 0.418360205647372],
            [33.79613567301123, 0.415631868014054],
            [33.79378125782185, 0.41519787725632],
            [33.79282256497085, 0.416022849444315],
            [33.79181561911436, 0.416021306179351],
            [33.790832820871046, 0.41664561342969],
            [33.789776281722666, 0.417795239663278],
            [33.78791857469827, 0.417442000035999],
            [33.78679861988072, 0.416908370885045],
            [33.78526686565885, 0.415162552833526],
            [33.78240911992417, 0.413715400278332],
            [33.778054445854565, 0.41056764931558],
            [33.776659879647916, 0.410323531214509],
            [33.772019780269844, 0.411816661670557],
            [33.77131087835661, 0.410622590664202],
            [33.76627044477216, 0.407502028003178],
            [33.75932110468368, 0.405458175012076],
            [33.75570972183295, 0.40497000316969],
            [33.75370939647743, 0.4014148934751],
            [33.753137396016896, 0.398673839234772],
            [33.75425711278087, 0.396583979715257],
            [33.75534294599067, 0.392449603191447],
            [33.75545677152032, 0.390377930774371],
            [33.75634792812994, 0.388559492495908],
            [33.75711394313227, 0.387908070766281],
            [33.754610732795825, 0.388007809324105],
            [33.75150192590556, 0.386424941178087],
            [33.748116322025126, 0.385882450119238],
            [33.74623662693751, 0.387131044919988],
            [33.744176011151666, 0.387565464755331],
            [33.74156126239628, 0.390342998798694],
            [33.739443883864276, 0.383947248681694],
            [33.744924328444576, 0.377089458926387],
            [33.747683813758535, 0.372348814590342],
            [33.74797973138953, 0.371570783948461],
            [33.74780957250843, 0.365093452847366],
            [33.748953974078084, 0.362506036289027],
            [33.74727519169533, 0.361909103337821],
            [33.74479274861166, 0.361836937720544],
            [33.74257198566853, 0.361249094596999],
            [33.741069449151276, 0.359340389325101],
            [33.740350843636364, 0.355984163763851],
            [33.74015432369324, 0.3496063341914],
            [33.74077427352869, 0.341156771561137],
            [33.74136206996519, 0.338071839491326],
            [33.743876127458684, 0.332969373098214],
            [33.74668425205368, 0.324754866099373],
            [33.74615222213173, 0.32004112289989],
            [33.7408672428724, 0.308954390498556],
            [33.74616584418468, 0.3078250987805],
            [33.75177948915869, 0.30793551001631],
            [33.76485208488859, 0.311888628731322],
            [33.770841319974465, 0.316195251903325],
            [33.77391965241703, 0.318908736832629],
            [33.78021054447026, 0.327068201634316],
            [33.78485109210768, 0.331591081491686],
            [33.78922127109909, 0.333291468480483],
            [33.79588043648619, 0.332359138048632],
            [33.79883462624807, 0.332630289951373],
            [33.80039772089359, 0.333661457617893],
            [33.80345049087645, 0.33755118051074],
            [33.80556816405587, 0.341567625832282],
            [33.80623013438537, 0.346519127664163],
            [33.807013901894344, 0.347303285939511],
            [33.80747537993053, 0.348551515131346],
            [33.80937860908197, 0.349393204770621],
            [33.8105611297624, 0.352354108715155],
            [33.81272518834984, 0.367826626296685],
            [33.814326894382894, 0.373249300905519],
            [33.82009650934809, 0.380818777274272],
            [33.82279278470708, 0.385595020895178],
            [33.82328494110855, 0.387349976422337],
            [33.82493456417715, 0.388589171252039],
            [33.82514433786398, 0.391502092284824],
            [33.8267692572623, 0.39281365757348],
            [33.82755685967921, 0.394821879291986],
            [33.82718799974547, 0.396115551842067],
            [33.828172664687955, 0.397427179284187],
            [33.82799650506074, 0.399326939932276],
            [33.82931398593453, 0.400567183085716],
            [33.83673492088594, 0.40525142124571],
            [33.83758875249549, 0.406771122344132],
            [33.83981186453309, 0.408589208962605],
            [33.840368095967115, 0.410687907287459],
            [33.84141011744217, 0.412596579477198],
            [33.8425020295515, 0.413618701853268],
            [33.84425912256912, 0.416639996412754],
            [33.84461648316895, 0.418177838131188],
            [33.84432672438752, 0.418566862956502],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 962,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "BUDHAYA",
        Population: 28472,
        Key: "BUGIRIBUDHAYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.95460710846506, 0.205220213372891],
            [33.932062179611066, 0.224576776343907],
            [33.92859916430931, 0.228414787626372],
            [33.92643207929769, 0.229598826883295],
            [33.92507141371323, 0.231290197152359],
            [33.923290378796636, 0.234499162144136],
            [33.91998644255532, 0.246898020672999],
            [33.917722238881694, 0.249675358180089],
            [33.91398940649952, 0.252090956025173],
            [33.91265968518165, 0.254434015178382],
            [33.9123826420531, 0.259879844021159],
            [33.91081704110795, 0.262123417063521],
            [33.91004114194253, 0.265443430301873],
            [33.90797708560916, 0.271061278003906],
            [33.904922211771904, 0.274797597475187],
            [33.902878646010166, 0.283816834465719],
            [33.90208513178036, 0.285399602451562],
            [33.89877661772434, 0.283536726125385],
            [33.897418630017725, 0.283401139669071],
            [33.89578371237032, 0.282559968394867],
            [33.88551503262832, 0.280507267293076],
            [33.88379637582674, 0.278924302811222],
            [33.88285452638731, 0.278589662768901],
            [33.87995825460506, 0.278209939499482],
            [33.87685424022681, 0.278572025455102],
            [33.87471993563823, 0.276283476417684],
            [33.87251442069874, 0.275568983590734],
            [33.87016069721212, 0.275632482966911],
            [33.866308732053575, 0.277776743730797],
            [33.85601714617016, 0.280421443279056],
            [33.85179748349785, 0.280945701872861],
            [33.85078700187242, 0.274707326810172],
            [33.850059958482035, 0.273592134151552],
            [33.84930016790629, 0.271043116967044],
            [33.84770844754597, 0.268846172084581],
            [33.847322410925656, 0.265920834826984],
            [33.84521226922158, 0.264294429957359],
            [33.84424767174422, 0.264124558546619],
            [33.8421616605853, 0.262740917902331],
            [33.83917123008988, 0.259585120584494],
            [33.839122640216175, 0.254122813980886],
            [33.839484270508514, 0.252739004263835],
            [33.83952021749293, 0.249243122606596],
            [33.83988188281958, 0.248405544927357],
            [33.83880852361582, 0.244327088410104],
            [33.839073645202255, 0.242093594003958],
            [33.840014045659125, 0.240952518254178],
            [33.8401224884836, 0.239787218651027],
            [33.838964971510755, 0.239532383207316],
            [33.83573916983451, 0.242176755697064],
            [33.83440777854857, 0.242559803788538],
            [33.831269414390476, 0.24208129438089],
            [33.831031605181956, 0.241171767226712],
            [33.831554527085245, 0.238969688809037],
            [33.833884031991815, 0.231118773940709],
            [33.83266839581676, 0.22895270351704],
            [33.82867394976932, 0.225434449722575],
            [33.82667662748177, 0.221916073806453],
            [33.823235022626505, 0.209866267743493],
            [33.82448303408442, 0.204887182182074],
            [33.82559623267273, 0.20269764146058],
            [33.827512040933065, 0.200351668776664],
            [33.82896187598757, 0.199256853681139],
            [33.83277698865985, 0.191255399302235],
            [33.84361768143881, 0.174883171244767],
            [33.86181393157943, 0.156294614700421],
            [33.91176631871644, 0.105265978348995],
            [33.91307799557518, 0.107030811815629],
            [33.91327705236067, 0.108433296887171],
            [33.91387409695303, 0.108433278022599],
            [33.97287493007933, 0.189017641776009],
            [33.972835669209815, 0.189858923814251],
            [33.95460710846506, 0.205220213372891],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 963,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "BANDA",
        Population: 43345,
        Key: "NAMAYINGOBANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.84930515355615, 0.376491755318849],
            [33.84919745363841, 0.37718128542037],
            [33.84547445062207, 0.377531005450224],
            [33.84526045036183, 0.383394349817355],
            [33.845567592442315, 0.389473659041306],
            [33.83962129143712, 0.394720401718042],
            [33.834992560238945, 0.39465915423857],
            [33.832406858508314, 0.393946837629077],
            [33.83081127718886, 0.394514657363607],
            [33.82913179232355, 0.395843390370416],
            [33.82891612838341, 0.398717939159297],
            [33.82931398593453, 0.400567183085716],
            [33.82799650506074, 0.399326939932276],
            [33.828172664687955, 0.397427179284187],
            [33.82718799974547, 0.396115551842067],
            [33.82755685967921, 0.394821879291986],
            [33.8267692572623, 0.39281365757348],
            [33.82514433786398, 0.391502092284824],
            [33.82493456417715, 0.388589171252039],
            [33.82328494110855, 0.387349976422337],
            [33.82279278470708, 0.385595020895178],
            [33.82009650934809, 0.380818777274272],
            [33.814326894382894, 0.373249300905519],
            [33.81272518834984, 0.367826626296685],
            [33.8105611297624, 0.352354108715155],
            [33.80937860908197, 0.349393204770621],
            [33.80747537993053, 0.348551515131346],
            [33.807013901894344, 0.347303285939511],
            [33.80623013438537, 0.346519127664163],
            [33.80556816405587, 0.341567625832282],
            [33.80345049087645, 0.33755118051074],
            [33.80039772089359, 0.333661457617893],
            [33.79883462624807, 0.332630289951373],
            [33.79588043648619, 0.332359138048632],
            [33.78922127109909, 0.333291468480483],
            [33.78485109210768, 0.331591081491686],
            [33.78021054447026, 0.327068201634316],
            [33.77391965241703, 0.318908736832629],
            [33.770841319974465, 0.316195251903325],
            [33.77637179263125, 0.312205084342895],
            [33.780983766656135, 0.310413526056793],
            [33.78753566780841, 0.309517430148296],
            [33.78997594307434, 0.309490108287575],
            [33.7919281986807, 0.309987517056674],
            [33.79363616014051, 0.310647779886151],
            [33.79726052364709, 0.312990536180954],
            [33.79913918746874, 0.313243692020722],
            [33.80245781745321, 0.312944905140215],
            [33.80481260095187, 0.311379682260626],
            [33.80766725109207, 0.31015818996975],
            [33.8090095317559, 0.3100857158526],
            [33.820448569887745, 0.314645182962048],
            [33.82260746765386, 0.31517627869905],
            [33.8265893309991, 0.314886175756484],
            [33.833449572584435, 0.313533305434374],
            [33.838822720590585, 0.313726056752067],
            [33.843571969767275, 0.311117636778967],
            [33.84486725147376, 0.310827750214986],
            [33.85076820821834, 0.312372766772967],
            [33.85396079468697, 0.31178489371706],
            [33.8553106158093, 0.310137105022327],
            [33.858010345190536, 0.307923947068999],
            [33.861415017609524, 0.306985576840306],
            [33.86369469925551, 0.307001218081511],
            [33.86667106662514, 0.305782197416373],
            [33.867519220882095, 0.305036889288259],
            [33.868128241813785, 0.303150454659707],
            [33.86997759540437, 0.299993705291234],
            [33.87341046234687, 0.296680819130248],
            [33.87191733388559, 0.29602990588764],
            [33.86691261731683, 0.295412778693928],
            [33.86637762295442, 0.29472468909083],
            [33.864118883732665, 0.293468275173749],
            [33.85295512264157, 0.289052668839236],
            [33.85453350661322, 0.28594471135666],
            [33.85601714617016, 0.280421443279056],
            [33.866308732053575, 0.277776743730797],
            [33.87016069721212, 0.275632482966911],
            [33.87251442069874, 0.275568983590734],
            [33.87471993563823, 0.276283476417684],
            [33.87685424022681, 0.278572025455102],
            [33.87995825460506, 0.278209939499482],
            [33.88285452638731, 0.278589662768901],
            [33.88379637582674, 0.278924302811222],
            [33.88551503262832, 0.280507267293076],
            [33.89578371237032, 0.282559968394867],
            [33.897418630017725, 0.283401139669071],
            [33.89877661772434, 0.283536726125385],
            [33.90208513178036, 0.285399602451562],
            [33.90033111369594, 0.290113209012868],
            [33.89689101890866, 0.294338078165347],
            [33.89680523698553, 0.296120193453025],
            [33.8959758682978, 0.297766676356926],
            [33.89536630568197, 0.302018458440287],
            [33.893963643858, 0.305003834449171],
            [33.89281691565173, 0.306035203411652],
            [33.89237785956504, 0.307536917104413],
            [33.887778001118406, 0.311354827142025],
            [33.882919778212916, 0.313419244456658],
            [33.88169525230978, 0.313763840224735],
            [33.87980523647788, 0.313039978716358],
            [33.879253312465636, 0.313157889819988],
            [33.87861770050319, 0.312534947999418],
            [33.87756401081091, 0.312568713371921],
            [33.87420214131858, 0.311525057170153],
            [33.871542695089616, 0.310026718961848],
            [33.870438818319016, 0.309942621712392],
            [33.870288489747814, 0.31235043768178],
            [33.86948585761787, 0.314539415118203],
            [33.86791386965102, 0.316846325614939],
            [33.86783038292347, 0.318496435360306],
            [33.86712797582979, 0.319186845542905],
            [33.86689383623918, 0.319355242908245],
            [33.86625820541214, 0.318547083389998],
            [33.86635849333043, 0.317789374215464],
            [33.86159202344974, 0.320803747412644],
            [33.85876538906831, 0.320248341238141],
            [33.8567583775521, 0.320652619013694],
            [33.855520659889024, 0.320181264185157],
            [33.85123901256379, 0.320838303263265],
            [33.84967273788219, 0.325407523869009],
            [33.848870642046464, 0.329207303179489],
            [33.847771198461814, 0.331152132459342],
            [33.84381869116173, 0.332887776905233],
            [33.84263006822555, 0.334593265115805],
            [33.83751519484676, 0.337274381133812],
            [33.837340316217144, 0.337824983152131],
            [33.83802495283788, 0.340845855774887],
            [33.83728589358229, 0.34132596624408],
            [33.83688065996438, 0.342238086778535],
            [33.837155014435275, 0.344194244603636],
            [33.841113126324416, 0.34736942408534],
            [33.844004557983915, 0.351141352036986],
            [33.84712452464498, 0.35437363577902],
            [33.84852753411695, 0.355196723835878],
            [33.8487742357485, 0.356806950747361],
            [33.84961673151748, 0.357562578219742],
            [33.8498676705022, 0.359302499131548],
            [33.84950085423573, 0.361547169441553],
            [33.8484423558617, 0.363257029872005],
            [33.84825781135966, 0.365699561691627],
            [33.84756060730806, 0.366547648327732],
            [33.84811941600866, 0.367445164563986],
            [33.84769205329201, 0.369471944717159],
            [33.848172323185636, 0.370322255176798],
            [33.84846805037378, 0.373569866889796],
            [33.84905810966647, 0.374248224214593],
            [33.84930515355615, 0.376491755318849],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 964,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "BUYINJA",
        Population: 22422,
        Key: "NAMAYINGOBUYINJA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.65763896511101, 0.415701255653825],
            [33.656001341737934, 0.417562835504965],
            [33.65687159634752, 0.420611516547123],
            [33.65632760356092, 0.423560803223754],
            [33.6497294742058, 0.425533560820955],
            [33.646939934855716, 0.427822631066401],
            [33.646251467818594, 0.429243032616842],
            [33.64622912671748, 0.430726704054556],
            [33.6444983687107, 0.433784661918622],
            [33.634655537125774, 0.448966016390817],
            [33.628311308500855, 0.451852500770232],
            [33.62770590508481, 0.452585344213481],
            [33.625602100995046, 0.46093572970186],
            [33.624153026813616, 0.460990138897694],
            [33.62046045871911, 0.458430217673332],
            [33.61701878559187, 0.461366987019484],
            [33.61536023237102, 0.46143929007217],
            [33.613653765707845, 0.463519936981164],
            [33.613636585428026, 0.46176004469416],
            [33.61490731707613, 0.458231672991992],
            [33.61481340809463, 0.456919891541351],
            [33.615449055091354, 0.455146658966307],
            [33.61575490539445, 0.45217022859191],
            [33.617893440149736, 0.442372340037218],
            [33.60960186880473, 0.444698070604492],
            [33.60590774931974, 0.443630852013051],
            [33.597044303278366, 0.444952422708165],
            [33.58432706131192, 0.443496907336683],
            [33.58279660156236, 0.444347435464506],
            [33.58174514418355, 0.44401278534838],
            [33.57711031252626, 0.444049340292801],
            [33.57754969380311, 0.438901628202522],
            [33.57892023366916, 0.434508052652985],
            [33.57901186362476, 0.431687986473592],
            [33.579930001133924, 0.427619634536617],
            [33.57983807922587, 0.426602570468548],
            [33.57735803015239, 0.423320395466394],
            [33.57565884702956, 0.422534604799701],
            [33.57304127666586, 0.42253480062711],
            [33.569367529174876, 0.423825201623602],
            [33.56086157398904, 0.423658868724722],
            [33.55764551544035, 0.423939558521268],
            [33.554814623942775, 0.422383694629174],
            [33.552642072682644, 0.421831988608497],
            [33.55193824894577, 0.420981628631978],
            [33.549043874405385, 0.419217683968959],
            [33.55079956066128, 0.416383011370033],
            [33.552986640374506, 0.415478984163766],
            [33.55102383495343, 0.412086840076658],
            [33.54924152532745, 0.409743854222802],
            [33.54826130794393, 0.409205689974728],
            [33.548528585487034, 0.408523910288096],
            [33.54781565462979, 0.407501317453746],
            [33.54884925439905, 0.406837423527443],
            [33.54877794523349, 0.40646066611187],
            [33.54681750417824, 0.40526950926979],
            [33.54576591834035, 0.403511354217897],
            [33.54589056856919, 0.401986350782894],
            [33.545124062188385, 0.399259351433308],
            [33.549169500204606, 0.398774669090576],
            [33.55473418969057, 0.398812558213157],
            [33.55802203171528, 0.395582963302741],
            [33.56021489837554, 0.396051542119372],
            [33.56114618811882, 0.397321580370722],
            [33.563421259610735, 0.398941999613853],
            [33.56456771742412, 0.398715591020008],
            [33.567241215100736, 0.395938691262247],
            [33.572149458896206, 0.392285612395174],
            [33.57080510581902, 0.387269646413452],
            [33.57143273265686, 0.386005749179488],
            [33.57736736095325, 0.384684041980772],
            [33.581304701996366, 0.38301778447271],
            [33.58172375799159, 0.38130108016821],
            [33.58285780288434, 0.379644309801668],
            [33.58265752169513, 0.377629427227121],
            [33.58416688001865, 0.376326894665716],
            [33.58574585418345, 0.375571301115269],
            [33.5843636182524, 0.370763212758501],
            [33.5854411770801, 0.367940664172949],
            [33.58902876894883, 0.368998878355732],
            [33.592972772796415, 0.367702094515915],
            [33.60395982179639, 0.367093605320442],
            [33.60500622615175, 0.367336630545994],
            [33.605357069474174, 0.36889358810594],
            [33.60513558804424, 0.370576963558411],
            [33.60454369349341, 0.37174476599234],
            [33.60674582897079, 0.378222150605062],
            [33.60945822819082, 0.378492910402761],
            [33.61481106888162, 0.376584098339306],
            [33.617052607162314, 0.376321574059075],
            [33.62430863478376, 0.376691967504573],
            [33.62594127699856, 0.375570052483829],
            [33.62927125989158, 0.374891301807705],
            [33.62963135586141, 0.375904516818197],
            [33.63294262774539, 0.380527181585896],
            [33.63756471320707, 0.383973658558002],
            [33.63979107085778, 0.383494008479823],
            [33.64174045994008, 0.382136846973676],
            [33.6482459541248, 0.372106844101895],
            [33.64957736247876, 0.371029612455723],
            [33.650480902364556, 0.371460398591988],
            [33.65155694034448, 0.372370271296118],
            [33.654389924916686, 0.377429275248788],
            [33.65633321174326, 0.386042434644747],
            [33.656085380031094, 0.388164576118034],
            [33.655300485136436, 0.389648303665413],
            [33.65567968018752, 0.391824616767089],
            [33.65532907761362, 0.396240917726071],
            [33.65454308946922, 0.397837906988599],
            [33.65120225762256, 0.399977771488785],
            [33.65128443999632, 0.405623062041992],
            [33.652415760298844, 0.409763229489682],
            [33.65395823950687, 0.412747534750219],
            [33.65763896511101, 0.415701255653825],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 965,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "KIGANDALO",
        Population: 31516,
        Key: "MAYUGEKIGANDALO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.549043874405385, 0.419217683968959],
            [33.54805877018672, 0.419977695810691],
            [33.54448921109899, 0.425306595144516],
            [33.538082498357895, 0.428039227704654],
            [33.536849093506476, 0.428202160480642],
            [33.5340841805716, 0.430554563860736],
            [33.53263508572889, 0.430581807197404],
            [33.53119172932423, 0.432364159708007],
            [33.528499222397855, 0.434074225545878],
            [33.52736093296538, 0.437032662398938],
            [33.51714577394969, 0.435251127532925],
            [33.50992123677053, 0.429751057856982],
            [33.50684945574133, 0.429425573242482],
            [33.50531705383411, 0.42691823329623],
            [33.502808948577716, 0.422848676920489],
            [33.49984656438381, 0.42052379123648],
            [33.49895342519233, 0.419157751773838],
            [33.497666929009334, 0.414770037078396],
            [33.4969524359818, 0.413946805649354],
            [33.495524065272704, 0.413123618151135],
            [33.49366590280245, 0.410436773527708],
            [33.492344227694616, 0.409287885523059],
            [33.489629609635855, 0.407994330939755],
            [33.48755749900765, 0.406049348662758],
            [33.48519955164255, 0.404936708843569],
            [33.48389485649018, 0.403571634169878],
            [33.482941399919, 0.400784261055977],
            [33.483477054543116, 0.397780617413934],
            [33.48326626037011, 0.394876535089244],
            [33.48238608566484, 0.394161872154393],
            [33.48158223991095, 0.39241584260004],
            [33.47756343424798, 0.39111330420907],
            [33.47494146573266, 0.389267859762011],
            [33.47409938408701, 0.386725690289708],
            [33.47394592309039, 0.384482033390413],
            [33.4746156395926, 0.378076694070746],
            [33.47465372187246, 0.376041109004505],
            [33.47423238954629, 0.374521229875886],
            [33.47138051609864, 0.369084114131697],
            [33.46782621848931, 0.365685588681989],
            [33.47523983935765, 0.361433291381228],
            [33.48656120357715, 0.358299237175341],
            [33.48899483041169, 0.357077757905953],
            [33.49626099641941, 0.351919673682469],
            [33.49845038120966, 0.352073840540455],
            [33.50575969060554, 0.356133882182934],
            [33.51370897687782, 0.362375974516271],
            [33.518221151667866, 0.36509887317174],
            [33.51978057759377, 0.365414726085527],
            [33.52189915537667, 0.364964407984182],
            [33.53188232806353, 0.364289097873151],
            [33.53692303563413, 0.364538777759562],
            [33.53876017393349, 0.365524984857031],
            [33.54144244365887, 0.367814495697051],
            [33.54221951782066, 0.369725196086128],
            [33.54270791117942, 0.370038036847985],
            [33.54680361173239, 0.370428870397012],
            [33.55105721904433, 0.369622280042831],
            [33.55473666454917, 0.369737036533372],
            [33.55591556681565, 0.370208929680197],
            [33.55665185027701, 0.37080183681199],
            [33.55731464525996, 0.373544207059088],
            [33.55819825422456, 0.375323011203164],
            [33.559008186962814, 0.376286508179948],
            [33.559707635005964, 0.376508820245868],
            [33.56637067303025, 0.376693682351403],
            [33.56896175207621, 0.377256585067092],
            [33.5719049329843, 0.374621529125554],
            [33.57589227964601, 0.373358454675484],
            [33.57904275668737, 0.3739925646434],
            [33.58109990228126, 0.375466286720798],
            [33.58416688001865, 0.376326894665716],
            [33.58265752169513, 0.377629427227121],
            [33.58285780288434, 0.379644309801668],
            [33.58172375799159, 0.38130108016821],
            [33.581304701996366, 0.38301778447271],
            [33.57736736095325, 0.384684041980772],
            [33.57143273265686, 0.386005749179488],
            [33.57080510581902, 0.387269646413452],
            [33.572149458896206, 0.392285612395174],
            [33.567241215100736, 0.395938691262247],
            [33.56456771742412, 0.398715591020008],
            [33.563421259610735, 0.398941999613853],
            [33.56114618811882, 0.397321580370722],
            [33.56021489837554, 0.396051542119372],
            [33.55802203171528, 0.395582963302741],
            [33.55473418969057, 0.398812558213157],
            [33.549169500204606, 0.398774669090576],
            [33.545124062188385, 0.399259351433308],
            [33.54589056856919, 0.401986350782894],
            [33.54576591834035, 0.403511354217897],
            [33.54681750417824, 0.40526950926979],
            [33.54877794523349, 0.40646066611187],
            [33.54884925439905, 0.406837423527443],
            [33.54781565462979, 0.407501317453746],
            [33.548528585487034, 0.408523910288096],
            [33.54826130794393, 0.409205689974728],
            [33.54924152532745, 0.409743854222802],
            [33.55102383495343, 0.412086840076658],
            [33.552986640374506, 0.415478984163766],
            [33.55079956066128, 0.416383011370033],
            [33.549043874405385, 0.419217683968959],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 966,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "BUSAKIRA",
        Population: 29097,
        Key: "MAYUGEBUSAKIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.50531705383411, 0.42691823329623],
              [33.498091433286746, 0.43088814651035],
              [33.497046071875445, 0.432035851880504],
              [33.49596948232992, 0.434612689899159],
              [33.494261413072294, 0.435963934482449],
              [33.49138374270464, 0.437158906158664],
              [33.48861847763016, 0.437361499999788],
              [33.48703239240155, 0.438344245291853],
              [33.486346075931245, 0.43831358309523],
              [33.48552244837647, 0.437545949294116],
              [33.48434896654441, 0.434542190346966],
              [33.48461299577947, 0.429454175696042],
              [33.484326923683966, 0.426586288057045],
              [33.480544316550215, 0.426445287007002],
              [33.477740615259655, 0.427326473909803],
              [33.47426444143563, 0.429459479200489],
              [33.46990933168312, 0.429024715787045],
              [33.470556804102245, 0.420159813560052],
              [33.47141189065827, 0.417386261051804],
              [33.474585659218306, 0.413480593967479],
              [33.47609131827951, 0.410673076483098],
              [33.477662801393116, 0.40956019656066],
              [33.479270134473126, 0.406827896235706],
              [33.48252034517227, 0.404095497969958],
              [33.48389485649018, 0.403571634169878],
              [33.48519955164255, 0.404936708843569],
              [33.48755749900765, 0.406049348662758],
              [33.489629609635855, 0.407994330939755],
              [33.492344227694616, 0.409287885523059],
              [33.49366590280245, 0.410436773527708],
              [33.495524065272704, 0.413123618151135],
              [33.4969524359818, 0.413946805649354],
              [33.497666929009334, 0.414770037078396],
              [33.49895342519233, 0.419157751773838],
              [33.49984656438381, 0.42052379123648],
              [33.502808948577716, 0.422848676920489],
              [33.50531705383411, 0.42691823329623],
            ],
          ],
          [
            [
              [33.483453972331894, 0.54263750503399],
              [33.48342411862005, 0.544106907586309],
              [33.482718409319375, 0.545901935197837],
              [33.482748814596796, 0.54741997850642],
              [33.48043285718302, 0.550935591264113],
              [33.48042331976967, 0.552336257688088],
              [33.48123409422934, 0.553453484404675],
              [33.48056386478912, 0.554281080674159],
              [33.47965126000377, 0.552608358212354],
              [33.477357543079805, 0.551046035817837],
              [33.475652661044776, 0.550874570629349],
              [33.47321046518076, 0.551224565924131],
              [33.472502705924605, 0.551985970519778],
              [33.461708721947154, 0.552839295342617],
              [33.45574087754486, 0.552730439868011],
              [33.452580572035956, 0.550640278370178],
              [33.45012648966411, 0.548379395548659],
              [33.44938333409079, 0.548495913381009],
              [33.448388190300534, 0.547866679511609],
              [33.446176754565, 0.548488856539476],
              [33.44482660106602, 0.550262184136677],
              [33.44215475000131, 0.551293750964985],
              [33.44022885725356, 0.552895228136364],
              [33.4377033686981, 0.552393937628625],
              [33.43512111919308, 0.552954258176434],
              [33.4333710177633, 0.552394259210539],
              [33.4314652167352, 0.552684389877679],
              [33.43065551486396, 0.551642831792537],
              [33.42769276864899, 0.551566449787192],
              [33.42667165366555, 0.552156899406919],
              [33.42681840245036, 0.551556848140031],
              [33.42631779829196, 0.551522632896167],
              [33.42628336586715, 0.55111165651061],
              [33.42667565745675, 0.550472505973714],
              [33.42678247073729, 0.547837017598642],
              [33.42750281898387, 0.546077585589609],
              [33.42768806866344, 0.542989680024125],
              [33.42843759059716, 0.54046635870732],
              [33.430129359025656, 0.538259404540926],
              [33.431216596302214, 0.535303592786217],
              [33.43211303590403, 0.534796155710329],
              [33.43383278595531, 0.530803978048358],
              [33.43554192241152, 0.528398691612172],
              [33.434905409438855, 0.52422884308245],
              [33.43548683143009, 0.521044932057498],
              [33.436895218217344, 0.518447889053776],
              [33.43639221555716, 0.5169793813815],
              [33.43575732853515, 0.516720904370404],
              [33.434537422667525, 0.515223722336075],
              [33.433367076854125, 0.511294100088541],
              [33.43308989089344, 0.507660463201628],
              [33.432000541677645, 0.507000716015463],
              [33.43050491769649, 0.504909838461248],
              [33.427130278652385, 0.503753874543089],
              [33.42495720457274, 0.50342809781783],
              [33.423667126806706, 0.503724473820162],
              [33.422426025189935, 0.502835683526263],
              [33.420390192126185, 0.504545751929118],
              [33.42030308788296, 0.505345063386918],
              [33.41767975213179, 0.508208316978133],
              [33.41637193802877, 0.507729658609697],
              [33.413495837017905, 0.505634252161268],
              [33.41208222742555, 0.501039234184571],
              [33.41008179337386, 0.496398192224],
              [33.40636661019209, 0.492689105738343],
              [33.40040036658759, 0.482068147868908],
              [33.39822089650315, 0.479471751474612],
              [33.395470285645914, 0.47835911547359],
              [33.38714667678463, 0.477192515771668],
              [33.382931726674286, 0.475428561290908],
              [33.378573489886264, 0.47258799962206],
              [33.37596029521635, 0.46965089270226],
              [33.373560346221836, 0.465469523405187],
              [33.3877174510448, 0.458817743861669],
              [33.39407602306985, 0.455252820312735],
              [33.399540842354064, 0.449625203234583],
              [33.40261295216667, 0.444739585893092],
              [33.40500612157577, 0.442233404447068],
              [33.406649571421745, 0.442016179414212],
              [33.4086855787587, 0.440686140027967],
              [33.40957859667758, 0.439826616016556],
              [33.41124206458137, 0.43661261699011],
              [33.413815350696495, 0.435377409948997],
              [33.414862655163745, 0.435558092764822],
              [33.41869864288662, 0.437518809285788],
              [33.419562350574424, 0.438997080383393],
              [33.42001899118277, 0.44095032673377],
              [33.42013338085443, 0.445488808536278],
              [33.42036167959905, 0.446063288027223],
              [33.4213318178851, 0.446235579675226],
              [33.42367147914425, 0.445201357227127],
              [33.42731911889816, 0.441371243238906],
              [33.42940537709378, 0.440738498581983],
              [33.432856380123546, 0.440492652229835],
              [33.436359758527644, 0.439719936134229],
              [33.43954891882174, 0.43815117962889],
              [33.44137666792977, 0.437722084918596],
              [33.44653658732848, 0.430022248014637],
              [33.44935898884828, 0.428356405888833],
              [33.45124063058511, 0.427899049515134],
              [33.45358623240327, 0.428397599679747],
              [33.4563208011462, 0.427837318111818],
              [33.459267305820816, 0.427777816264391],
              [33.46304004675781, 0.428582884601974],
              [33.46484430761606, 0.428538355460728],
              [33.46554357060627, 0.431885708137728],
              [33.46467464280836, 0.433857965937779],
              [33.46608893961189, 0.437794875976401],
              [33.46756202576087, 0.439529730658479],
              [33.468342807269856, 0.441160832598599],
              [33.47046404226936, 0.443362745272102],
              [33.472084502430626, 0.446298705070362],
              [33.47348392492969, 0.44772512883606],
              [33.476208974225514, 0.448273609906926],
              [33.47514849776125, 0.449282028608934],
              [33.4724382814474, 0.450320209234559],
              [33.470317484825706, 0.452113484680598],
              [33.467264490264036, 0.453248999708119],
              [33.464948534646894, 0.451483000140817],
              [33.464190576634365, 0.450219202189859],
              [33.459643693636664, 0.449875080797017],
              [33.45924632566737, 0.448764095684523],
              [33.457966131166074, 0.44860863621174],
              [33.45763505077989, 0.448630876918101],
              [33.45763240344475, 0.449864510646868],
              [33.45719233046517, 0.44998112634148],
              [33.45480663324263, 0.450027911853391],
              [33.45344000643797, 0.44907198020432],
              [33.45040600136308, 0.452896244121918],
              [33.45008178949558, 0.453828966224338],
              [33.44975768452759, 0.456487185917349],
              [33.45101742977973, 0.460659587531152],
              [33.45098158969487, 0.462351390907839],
              [33.448894806883104, 0.463854209812814],
              [33.44619743917274, 0.467830240129341],
              [33.447017301888145, 0.47139871545637],
              [33.44835925197197, 0.473063288342666],
              [33.44926739931685, 0.47177854532652],
              [33.45091078987406, 0.470656601854421],
              [33.45387481529, 0.470607520461447],
              [33.45616177149311, 0.468828749787275],
              [33.45744797572365, 0.468340123936585],
              [33.463984006339814, 0.467708163150726],
              [33.46673647221815, 0.468279748386547],
              [33.46755204008817, 0.468792820175313],
              [33.46758127126753, 0.469892552950283],
              [33.46868354274871, 0.472069266223249],
              [33.46884369349924, 0.475314630986523],
              [33.46845059612078, 0.476409350302907],
              [33.466557840427264, 0.477712254864135],
              [33.46541449617465, 0.481032599398464],
              [33.463735290685435, 0.483259553731315],
              [33.46194473003356, 0.48491402344651],
              [33.45993286671652, 0.485800773443466],
              [33.45641780212888, 0.489638962216045],
              [33.45530510839377, 0.491837326776522],
              [33.454830084661424, 0.493852312650527],
              [33.45530571745154, 0.494989290430032],
              [33.45546046303901, 0.497771962831246],
              [33.45478882953203, 0.499028705077116],
              [33.4514923133749, 0.501565983409815],
              [33.45415901888967, 0.502178225568216],
              [33.454623636537775, 0.50167842751263],
              [33.45590167059082, 0.501506743583107],
              [33.45711941331524, 0.501886633739314],
              [33.459406532113434, 0.50103474188159],
              [33.46146106720312, 0.50192191371846],
              [33.46279737227368, 0.50172653673986],
              [33.464543235451956, 0.502138672468771],
              [33.46922206659185, 0.505392660567331],
              [33.469964090287895, 0.507589179291726],
              [33.470095202098555, 0.51026898791413],
              [33.47207361934096, 0.511777153473397],
              [33.473444035239474, 0.513962956245141],
              [33.47542983932847, 0.513908819655853],
              [33.477053145352514, 0.514695788496095],
              [33.47809078754058, 0.518928327906111],
              [33.48037338691458, 0.522237267720434],
              [33.48028788257091, 0.523479603994065],
              [33.47901115376999, 0.525253431998785],
              [33.47832293826115, 0.528023662715174],
              [33.48164646586049, 0.533350062082783],
              [33.48169621276433, 0.53567382714174],
              [33.48247446371915, 0.536985457313604],
              [33.482229418580985, 0.538376035751163],
              [33.48329631979615, 0.540441854654875],
              [33.483453972331894, 0.54263750503399],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 967,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "IMANYIRO",
        Population: 31362,
        Key: "MAYUGEIMANYIRO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.37562061525796, 0.603151868489767],
            [33.37298690486358, 0.597476264740834],
            [33.372028512948205, 0.596231178382324],
            [33.371393315109096, 0.595625471760164],
            [33.36943213114711, 0.595692910033882],
            [33.368969548183124, 0.595953151374425],
            [33.368413273629976, 0.598035734695473],
            [33.36643036660779, 0.601181232597296],
            [33.365446316112944, 0.606782634011409],
            [33.362607188860856, 0.607041349569526],
            [33.35891213692461, 0.608822536644123],
            [33.357827841630574, 0.608865697358278],
            [33.35701455009146, 0.607817295856577],
            [33.35755659263561, 0.606208670550291],
            [33.35689334669839, 0.602444074745526],
            [33.3573651939879, 0.599001289195465],
            [33.356746175705375, 0.597776300994944],
            [33.35403946821102, 0.595210254229763],
            [33.35432257676437, 0.593108676880457],
            [33.35263118652662, 0.587622722213668],
            [33.35259117915712, 0.585674126081902],
            [33.353178487808435, 0.583181787461807],
            [33.35579065031408, 0.583804696384385],
            [33.363323040141104, 0.583345458313824],
            [33.365548733038494, 0.583977257382867],
            [33.367831410565934, 0.583345161885146],
            [33.37073184963279, 0.58400704666519],
            [33.37133608344235, 0.583770448993639],
            [33.37083241782548, 0.581878027469288],
            [33.36771034012352, 0.579951983989841],
            [33.364621639325925, 0.574984486306368],
            [33.360794500906934, 0.571301198844106],
            [33.3603915714677, 0.569746705381293],
            [33.35579222416246, 0.564103411996151],
            [33.35515425861399, 0.561670289757403],
            [33.35334135775932, 0.559034475805288],
            [33.35391194606823, 0.557547508515143],
            [33.35720152992628, 0.554134123168739],
            [33.360040793722305, 0.552437097875275],
            [33.36026952365825, 0.550218018705792],
            [33.36194374709093, 0.54870216070898],
            [33.3640035121722, 0.548665656646324],
            [33.36718345215826, 0.547853014964201],
            [33.37023098675962, 0.548568261276631],
            [33.36990613708825, 0.547783799342191],
            [33.36869030508046, 0.5468672622299],
            [33.36830432954559, 0.545868243615706],
            [33.367124082501114, 0.544900602467734],
            [33.366673127330166, 0.543721109336036],
            [33.36694556299967, 0.541877329889304],
            [33.366289228700246, 0.540950996187759],
            [33.36362197341652, 0.540384691107916],
            [33.36275354957348, 0.540587015945147],
            [33.361511013347204, 0.541693539206019],
            [33.358942037348825, 0.54165518824724],
            [33.35922282824876, 0.538382386559829],
            [33.35864837448918, 0.533653200705019],
            [33.3549902478027, 0.527713793026142],
            [33.353369093243735, 0.520718544483758],
            [33.34993874787223, 0.520655374866603],
            [33.35067823921749, 0.519245492948118],
            [33.353099514216844, 0.517794459674339],
            [33.354988071184756, 0.517816987603366],
            [33.35839754240398, 0.516691597127765],
            [33.35969283309363, 0.517103294437841],
            [33.360676759620965, 0.516872855405904],
            [33.36134237711049, 0.515761298257927],
            [33.361570560870774, 0.514248445519078],
            [33.36046712517298, 0.511873924219399],
            [33.359991547180094, 0.511567553434795],
            [33.36240715919993, 0.507335294807957],
            [33.3635865312853, 0.507009679952734],
            [33.36768872126791, 0.504335074617675],
            [33.36930122505065, 0.502742681830915],
            [33.37246947885317, 0.49787469118773],
            [33.373192217516696, 0.495883065451337],
            [33.37317313191016, 0.494772376041675],
            [33.37136593356093, 0.493451139036896],
            [33.368279716605116, 0.490003003757915],
            [33.36714177751558, 0.488774116447195],
            [33.366127300183756, 0.486245639098854],
            [33.36685164952657, 0.482939057010603],
            [33.369577600730985, 0.478721820974627],
            [33.370618839773435, 0.47642301949405],
            [33.37596029521635, 0.46965089270226],
            [33.378573489886264, 0.47258799962206],
            [33.382931726674286, 0.475428561290908],
            [33.38714667678463, 0.477192515771668],
            [33.395470285645914, 0.47835911547359],
            [33.39822089650315, 0.479471751474612],
            [33.40040036658759, 0.482068147868908],
            [33.40636661019209, 0.492689105738343],
            [33.41008179337386, 0.496398192224],
            [33.41208222742555, 0.501039234184571],
            [33.413495837017905, 0.505634252161268],
            [33.41637193802877, 0.507729658609697],
            [33.41767975213179, 0.508208316978133],
            [33.42030308788296, 0.505345063386918],
            [33.420390192126185, 0.504545751929118],
            [33.422426025189935, 0.502835683526263],
            [33.423667126806706, 0.503724473820162],
            [33.42495720457274, 0.50342809781783],
            [33.427130278652385, 0.503753874543089],
            [33.43050491769649, 0.504909838461248],
            [33.432000541677645, 0.507000716015463],
            [33.43308989089344, 0.507660463201628],
            [33.433367076854125, 0.511294100088541],
            [33.434537422667525, 0.515223722336075],
            [33.43575732853515, 0.516720904370404],
            [33.43639221555716, 0.5169793813815],
            [33.436895218217344, 0.518447889053776],
            [33.43548683143009, 0.521044932057498],
            [33.434905409438855, 0.52422884308245],
            [33.43554192241152, 0.528398691612172],
            [33.43383278595531, 0.530803978048358],
            [33.43211303590403, 0.534796155710329],
            [33.431216596302214, 0.535303592786217],
            [33.430129359025656, 0.538259404540926],
            [33.42843759059716, 0.54046635870732],
            [33.42768806866344, 0.542989680024125],
            [33.42750281898387, 0.546077585589609],
            [33.42678247073729, 0.547837017598642],
            [33.42667565745675, 0.550472505973714],
            [33.42628336586715, 0.55111165651061],
            [33.42631779829196, 0.551522632896167],
            [33.42681840245036, 0.551556848140031],
            [33.42667165366555, 0.552156899406919],
            [33.42650742097037, 0.553201260014996],
            [33.42561693630058, 0.553951540140786],
            [33.426115185076256, 0.554593053660189],
            [33.42530154768577, 0.55590964805425],
            [33.42571239397762, 0.558331624222474],
            [33.42522459620191, 0.558686916189559],
            [33.42497212648793, 0.559958191827012],
            [33.425422479787656, 0.560638764265943],
            [33.424655273619244, 0.562885614981477],
            [33.424710014257705, 0.563821260342488],
            [33.424300039331705, 0.564756940585691],
            [33.4238189879038, 0.564858929449134],
            [33.42283753354015, 0.564523135742354],
            [33.42229074250142, 0.563601285254532],
            [33.421484288938245, 0.563133520064563],
            [33.416505501341845, 0.561086929356137],
            [33.409657424742065, 0.561314821909791],
            [33.40809982598946, 0.559423893100914],
            [33.4055961485291, 0.56169331606491],
            [33.403170437648846, 0.566264410882454],
            [33.40251007620204, 0.566452252007441],
            [33.401789093744874, 0.567550986917571],
            [33.400240782674025, 0.56756927482116],
            [33.39899815931116, 0.568223027587815],
            [33.39567321417026, 0.568707873889348],
            [33.39603156561183, 0.570240583667563],
            [33.39666467576619, 0.570846812221998],
            [33.39664770659048, 0.572324757473337],
            [33.39606735898434, 0.573390292091263],
            [33.39648146975391, 0.575336508447313],
            [33.39573467600371, 0.576363388156393],
            [33.39649872189893, 0.577922907436088],
            [33.39641788340483, 0.581493177594557],
            [33.39739956863551, 0.582769122782242],
            [33.39714781757377, 0.583478038284787],
            [33.39821918970413, 0.585630430715979],
            [33.39888072524901, 0.585986980364733],
            [33.3983394247133, 0.586692010451011],
            [33.398765580094214, 0.587185668983407],
            [33.398014531922826, 0.588405885233908],
            [33.400080273495675, 0.590081310042227],
            [33.40116022363865, 0.592779335303079],
            [33.401992483105, 0.593251872340378],
            [33.4016938336972, 0.59460524275402],
            [33.402005478133916, 0.595902715496033],
            [33.40019168884542, 0.596349668734287],
            [33.39932389472138, 0.597223535674941],
            [33.396353971865636, 0.597340000414627],
            [33.39432596851785, 0.597867373529019],
            [33.39133845125892, 0.599464046275642],
            [33.38891053860792, 0.599438224717813],
            [33.38708312457154, 0.60021236837157],
            [33.38465395068588, 0.600526633906667],
            [33.38211340456961, 0.601704660158527],
            [33.37562061525796, 0.603151868489767],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 968,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "BAITAMBOGWE",
        Population: 37949,
        Key: "MAYUGEBAITAMBOGWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.85179748349785, 0.280945701872861],
            [33.84821090133549, 0.281740380620129],
            [33.846631693608735, 0.282636086214575],
            [33.842723669983215, 0.28654440478331],
            [33.84072829793817, 0.287403958659309],
            [33.829961450268804, 0.287250970303623],
            [33.826233430161615, 0.287631193632479],
            [33.82357311705842, 0.288888839774624],
            [33.81416426428217, 0.296940851864714],
            [33.81363788386503, 0.295068280254497],
            [33.8093135135632, 0.28923364652172],
            [33.807706066397195, 0.28814818911174],
            [33.80023677423573, 0.284810580818908],
            [33.79619001389941, 0.281246556617198],
            [33.79046695053054, 0.279944258515807],
            [33.78558835922429, 0.275484670489676],
            [33.78418873460429, 0.274742950889884],
            [33.77795288232853, 0.273268784755564],
            [33.77314426888461, 0.274056147324254],
            [33.76593795942089, 0.273387175074654],
            [33.76135946470833, 0.272039535056154],
            [33.75934929291896, 0.270528890210444],
            [33.75709864931455, 0.267480344468897],
            [33.75543321859189, 0.264323199994845],
            [33.75378305114418, 0.262749200282149],
            [33.74836702026136, 0.259049483124562],
            [33.7382910893349, 0.253906782956238],
            [33.737219727984346, 0.253906844939363],
            [33.73341037261469, 0.250746261059792],
            [33.728493924505734, 0.247502545300076],
            [33.65880518586063, 0.229214484871411],
            [33.65882710116029, 0.180904396855476],
            [33.70684983071021, 0.18090254992845],
            [33.74689266389455, 0.174635312837777],
            [33.76054640852783, 0.179319954389436],
            [33.761829611487, 0.180900275405503],
            [33.76795121063507, 0.180900012200432],
            [33.78157614450056, 0.183807324823857],
            [33.791872179739606, 0.186004295225636],
            [33.80193480841331, 0.207396156040008],
            [33.80275541403548, 0.211337087388485],
            [33.80709207059544, 0.211853863986125],
            [33.817591253547754, 0.21173841239629],
            [33.823235022626505, 0.209866267743493],
            [33.82667662748177, 0.221916073806453],
            [33.82867394976932, 0.225434449722575],
            [33.83266839581676, 0.22895270351704],
            [33.833884031991815, 0.231118773940709],
            [33.831554527085245, 0.238969688809037],
            [33.831031605181956, 0.241171767226712],
            [33.831269414390476, 0.24208129438089],
            [33.83440777854857, 0.242559803788538],
            [33.83573916983451, 0.242176755697064],
            [33.838964971510755, 0.239532383207316],
            [33.8401224884836, 0.239787218651027],
            [33.840014045659125, 0.240952518254178],
            [33.839073645202255, 0.242093594003958],
            [33.83880852361582, 0.244327088410104],
            [33.83988188281958, 0.248405544927357],
            [33.83952021749293, 0.249243122606596],
            [33.839484270508514, 0.252739004263835],
            [33.839122640216175, 0.254122813980886],
            [33.83917123008988, 0.259585120584494],
            [33.8421616605853, 0.262740917902331],
            [33.84424767174422, 0.264124558546619],
            [33.84521226922158, 0.264294429957359],
            [33.847322410925656, 0.265920834826984],
            [33.84770844754597, 0.268846172084581],
            [33.84930016790629, 0.271043116967044],
            [33.850059958482035, 0.273592134151552],
            [33.85078700187242, 0.274707326810172],
            [33.85179748349785, 0.280945701872861],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 969,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "MUTUMBA",
        Population: 42340,
        Key: "NAMAYINGOMUTUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.92225380560377, 0.440277819289128],
            [33.91870646634462, 0.443498701218545],
            [33.91410126561703, 0.444078235532669],
            [33.91219107542044, 0.446823479530108],
            [33.91191067169438, 0.447986744390383],
            [33.91250551631261, 0.451682198062821],
            [33.912096594212116, 0.451792348754207],
            [33.91231065016792, 0.452414625616236],
            [33.91182092550593, 0.452783284503074],
            [33.91193986694112, 0.453295472595023],
            [33.91157848727874, 0.453343389029143],
            [33.911821060253224, 0.453850774838624],
            [33.91134079215625, 0.453793392258334],
            [33.91164053032214, 0.455143275119377],
            [33.911341004158636, 0.455478400817242],
            [33.911536015830436, 0.455909202133815],
            [33.91114612184429, 0.456072008538143],
            [33.91131829744321, 0.456957248591054],
            [33.91202918553152, 0.457281568714042],
            [33.911981873062125, 0.457889052119102],
            [33.912553089293404, 0.457816678065837],
            [33.912370575882186, 0.458725475466866],
            [33.91285522865609, 0.459540872527315],
            [33.9121844431587, 0.460824635051624],
            [33.9123172680566, 0.461864644721297],
            [33.91188125276714, 0.461635704827898],
            [33.911565370977286, 0.462033308713577],
            [33.91052676489693, 0.462111932998559],
            [33.909921951674, 0.465120321141869],
            [33.910381594452055, 0.466771720368497],
            [33.911012567514355, 0.467055566894933],
            [33.91144792164378, 0.468325386668375],
            [33.91150487573108, 0.469785739667859],
            [33.91217977191923, 0.470071372761147],
            [33.91233123955422, 0.470807882025567],
            [33.911542950824426, 0.471569912383342],
            [33.910559020703836, 0.47139225948294],
            [33.910344679083764, 0.472160564295962],
            [33.90936078130254, 0.472236888858612],
            [33.909543797770326, 0.473087683059282],
            [33.90846546369653, 0.474465644407656],
            [33.9087683208131, 0.475348170230078],
            [33.90816923614674, 0.476040334232836],
            [33.90838375742986, 0.476643497964758],
            [33.907790849579406, 0.476345155318381],
            [33.90625831741648, 0.477075541211479],
            [33.906081893684586, 0.478408938794139],
            [33.90543228147845, 0.478567759889504],
            [33.905281002489644, 0.479259865179809],
            [33.90381778613068, 0.479533084497702],
            [33.903555994599024, 0.479954499967255],
            [33.90301569388822, 0.479799171431428],
            [33.90205873388742, 0.480638463972405],
            [33.90157967941439, 0.4817392063286],
            [33.89615314542924, 0.485096083872057],
            [33.8913405874829, 0.489420832277411],
            [33.888253010477705, 0.482736066523985],
            [33.885103191003154, 0.479512531763835],
            [33.882640930368936, 0.478016847711433],
            [33.87681480149091, 0.470059950168454],
            [33.8736039370012, 0.461145385209912],
            [33.87207845661325, 0.455864559972304],
            [33.87161020078826, 0.45284125187638],
            [33.87054015906284, 0.450130880760755],
            [33.86729362337152, 0.445935561345044],
            [33.86349912074678, 0.443532668196712],
            [33.862820865757826, 0.441542464236188],
            [33.86156042790456, 0.440267082043564],
            [33.86074638627221, 0.438132245492955],
            [33.85890012827609, 0.436476982505716],
            [33.85810579029118, 0.434740179626891],
            [33.852349535969175, 0.433519584755702],
            [33.85034431659198, 0.431656266064542],
            [33.84979821545938, 0.429874197247865],
            [33.84894500728062, 0.42901489028991],
            [33.848765713431405, 0.427793654019734],
            [33.84821019885296, 0.427214749052979],
            [33.846641652331996, 0.422818396435151],
            [33.84432672438752, 0.418566862956502],
            [33.84461648316895, 0.418177838131188],
            [33.84425912256912, 0.416639996412754],
            [33.8425020295515, 0.413618701853268],
            [33.84141011744217, 0.412596579477198],
            [33.840368095967115, 0.410687907287459],
            [33.83981186453309, 0.408589208962605],
            [33.83758875249549, 0.406771122344132],
            [33.83673492088594, 0.40525142124571],
            [33.82931398593453, 0.400567183085716],
            [33.82891612838341, 0.398717939159297],
            [33.82913179232355, 0.395843390370416],
            [33.83081127718886, 0.394514657363607],
            [33.832406858508314, 0.393946837629077],
            [33.834992560238945, 0.39465915423857],
            [33.83962129143712, 0.394720401718042],
            [33.845567592442315, 0.389473659041306],
            [33.84526045036183, 0.383394349817355],
            [33.84547445062207, 0.377531005450224],
            [33.84919745363841, 0.37718128542037],
            [33.84930515355615, 0.376491755318849],
            [33.850838702611966, 0.37611093624227],
            [33.856846527434314, 0.373209545907789],
            [33.86144415446579, 0.36904306287319],
            [33.86530630202803, 0.367036818586838],
            [33.866379233633715, 0.367653902689826],
            [33.87407338848382, 0.36907267252732],
            [33.877904685204314, 0.365214872963472],
            [33.88179742309692, 0.362776601636491],
            [33.883299166401805, 0.359999117232037],
            [33.882256849381, 0.35891914432574],
            [33.882226109930286, 0.358024228714212],
            [33.883084366640944, 0.357653832698753],
            [33.88927613589078, 0.355647375688566],
            [33.89041032720896, 0.355863278910228],
            [33.892678788897, 0.357128284464343],
            [33.89916019655402, 0.357390547902992],
            [33.9010184964665, 0.35900014292694],
            [33.903578480328896, 0.3604382347088],
            [33.905484253509194, 0.36260008711802],
            [33.90601668048653, 0.362762864874489],
            [33.90645998829946, 0.364680616176005],
            [33.90835501852729, 0.366091630589096],
            [33.90854233073876, 0.369166516679244],
            [33.90907324225821, 0.370465652944137],
            [33.910145306091295, 0.371418979941258],
            [33.910332784491096, 0.372812448661936],
            [33.91105104505292, 0.374237292849073],
            [33.912882858139284, 0.375242924520287],
            [33.9132055797017, 0.376112510056742],
            [33.9142880612972, 0.377149651933049],
            [33.91589088303782, 0.377893371673498],
            [33.91740010661407, 0.379286695635291],
            [33.91993500412382, 0.382929424561986],
            [33.92043617961071, 0.385129926880101],
            [33.92630054168556, 0.392846668087669],
            [33.926073396377795, 0.3971931755755],
            [33.92827714792435, 0.402401376591819],
            [33.93031351458741, 0.405969904552013],
            [33.931631734774676, 0.413155500328368],
            [33.93213544171405, 0.419135526251815],
            [33.93404783907127, 0.423848093663952],
            [33.93011070553897, 0.428805820452189],
            [33.92225380560377, 0.440277819289128],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 970,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "BUSWALE",
        Population: 26762,
        Key: "NAMAYINGOBUSWALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.89916019655402, 0.357390547902992],
            [33.892678788897, 0.357128284464343],
            [33.89041032720896, 0.355863278910228],
            [33.88927613589078, 0.355647375688566],
            [33.883084366640944, 0.357653832698753],
            [33.882226109930286, 0.358024228714212],
            [33.882256849381, 0.35891914432574],
            [33.883299166401805, 0.359999117232037],
            [33.88179742309692, 0.362776601636491],
            [33.877904685204314, 0.365214872963472],
            [33.87407338848382, 0.36907267252732],
            [33.866379233633715, 0.367653902689826],
            [33.86530630202803, 0.367036818586838],
            [33.86144415446579, 0.36904306287319],
            [33.856846527434314, 0.373209545907789],
            [33.850838702611966, 0.37611093624227],
            [33.84930515355615, 0.376491755318849],
            [33.84905810966647, 0.374248224214593],
            [33.84846805037378, 0.373569866889796],
            [33.848172323185636, 0.370322255176798],
            [33.84769205329201, 0.369471944717159],
            [33.84811941600866, 0.367445164563986],
            [33.84756060730806, 0.366547648327732],
            [33.84825781135966, 0.365699561691627],
            [33.8484423558617, 0.363257029872005],
            [33.84950085423573, 0.361547169441553],
            [33.8498676705022, 0.359302499131548],
            [33.84961673151748, 0.357562578219742],
            [33.8487742357485, 0.356806950747361],
            [33.84852753411695, 0.355196723835878],
            [33.84712452464498, 0.35437363577902],
            [33.844004557983915, 0.351141352036986],
            [33.841113126324416, 0.34736942408534],
            [33.837155014435275, 0.344194244603636],
            [33.83688065996438, 0.342238086778535],
            [33.83728589358229, 0.34132596624408],
            [33.83802495283788, 0.340845855774887],
            [33.837340316217144, 0.337824983152131],
            [33.83751519484676, 0.337274381133812],
            [33.84263006822555, 0.334593265115805],
            [33.84381869116173, 0.332887776905233],
            [33.847771198461814, 0.331152132459342],
            [33.848870642046464, 0.329207303179489],
            [33.84967273788219, 0.325407523869009],
            [33.85123901256379, 0.320838303263265],
            [33.855520659889024, 0.320181264185157],
            [33.8567583775521, 0.320652619013694],
            [33.85876538906831, 0.320248341238141],
            [33.86159202344974, 0.320803747412644],
            [33.86635849333043, 0.317789374215464],
            [33.86625820541214, 0.318547083389998],
            [33.86689383623918, 0.319355242908245],
            [33.86712797582979, 0.319186845542905],
            [33.86783038292347, 0.318496435360306],
            [33.86791386965102, 0.316846325614939],
            [33.86948585761787, 0.314539415118203],
            [33.870288489747814, 0.31235043768178],
            [33.870438818319016, 0.309942621712392],
            [33.871542695089616, 0.310026718961848],
            [33.87420214131858, 0.311525057170153],
            [33.87756401081091, 0.312568713371921],
            [33.87861770050319, 0.312534947999418],
            [33.879253312465636, 0.313157889819988],
            [33.87980523647788, 0.313039978716358],
            [33.88169525230978, 0.313763840224735],
            [33.882919778212916, 0.313419244456658],
            [33.88336685356013, 0.316334158974432],
            [33.88553369333169, 0.321297867858827],
            [33.885723567538356, 0.325371298991034],
            [33.88399940047084, 0.330180427524259],
            [33.88127938982541, 0.335300862262112],
            [33.879654814481874, 0.337309283671053],
            [33.87948313654958, 0.339263295561086],
            [33.88131716488142, 0.343071606048246],
            [33.88734885794088, 0.34829977680922],
            [33.89054965141793, 0.349810194064661],
            [33.89235876767032, 0.351384065977254],
            [33.89698451286847, 0.354269364927906],
            [33.89916019655402, 0.357390547902992],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 971,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "NAMAYINGO TOWN COUNCIL",
        Population: 15740,
        Key: "NAMAYINGONAMAYINGO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86181393157943, 0.156294614700421],
            [33.857432195761895, 0.152554952535985],
            [33.84703788483076, 0.146034279199947],
            [33.839807063936206, 0.141788253588854],
            [33.83528783377789, 0.140120229986008],
            [33.82338721520195, 0.136935921817147],
            [33.81480074850876, 0.13678456780168],
            [33.80907647241424, 0.137998005903787],
            [33.803954774534226, 0.139969698845221],
            [33.79913439405839, 0.143154628234215],
            [33.78889127587781, 0.155439097423782],
            [33.78346888851598, 0.172879721791567],
            [33.78157614450056, 0.183807324823857],
            [33.76795121063507, 0.180900012200432],
            [33.761829611487, 0.180900275405503],
            [33.76054640852783, 0.179319954389436],
            [33.74689266389455, 0.174635312837777],
            [33.70684983071021, 0.18090254992845],
            [33.65882710116029, 0.180904396855476],
            [33.65905315860827, 0.007627311187295],
            [33.66325701632148, 0.00867673117641],
            [33.66789219742338, 0.009210475975756],
            [33.67764779181448, 0.009626602559185],
            [33.68188420447356, 0.009282819999596],
            [33.69351337462851, 0.005320337839574],
            [33.6983018487421, 0.000923648673391],
            [33.70110437593455, -0.002767388690746],
            [33.702449492579746, -0.00654890256161],
            [33.7035218052462, -0.011707451962308],
            [33.95178685212216, -0.028679181371895],
            [33.94258013016631, -0.002714148238865],
            [33.913475730955426, 0.09691282522862],
            [33.91198313609341, 0.097513935629036],
            [33.910838834236735, 0.09876619338289],
            [33.91063983943501, 0.099467444193852],
            [33.91153544719684, 0.100869910736706],
            [33.91113751149228, 0.104125708238385],
            [33.91176631871644, 0.105265978348995],
            [33.86181393157943, 0.156294614700421],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 972,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "SIGULU ISLAND",
        Population: 16490,
        Key: "NAMAYINGOSIGULU ISLAND",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.25186387243512, 1.117463423870693],
            [34.249338879749665, 1.118997461354329],
            [34.248161352803876, 1.121621292579531],
            [34.245555860289215, 1.12366996001118],
            [34.24381809721983, 1.12334571616797],
            [34.24250927790202, 1.122434208131141],
            [34.242045863996395, 1.120266912134387],
            [34.23993447722734, 1.119915051792078],
            [34.24087658089, 1.116432251487036],
            [34.24084052071785, 1.113483535703749],
            [34.24059860351351, 1.112506757237877],
            [34.239343357922635, 1.111250007389122],
            [34.23893278471864, 1.10988435671458],
            [34.239934752111814, 1.108509063799592],
            [34.24116636212929, 1.10831859462244],
            [34.24393504080185, 1.106408889614727],
            [34.247348691882095, 1.106344126870528],
            [34.249365309083636, 1.10575533523064],
            [34.2512591535353, 1.103031939083747],
            [34.25135912794157, 1.101693213834378],
            [34.25257682215698, 1.1004806474666],
            [34.25301059255652, 1.096880494393144],
            [34.25465830311194, 1.092492902994288],
            [34.25449758462614, 1.089571390096286],
            [34.25350724592428, 1.0864512296982],
            [34.254385988715015, 1.08182879326856],
            [34.25529568295884, 1.081439472621017],
            [34.257077546122126, 1.079557340057061],
            [34.259500165001164, 1.078868899043645],
            [34.26196250917868, 1.077544594627157],
            [34.26477385333565, 1.08070042366682],
            [34.26487672031717, 1.081747701532597],
            [34.26447966675822, 1.082284032158631],
            [34.265186755871184, 1.083791791568562],
            [34.26646471805899, 1.084448843664078],
            [34.266088500923054, 1.085255445470828],
            [34.2649889118113, 1.085766004743314],
            [34.26419141445153, 1.086721412308735],
            [34.26676139925799, 1.089311494286565],
            [34.26868133437874, 1.088552344791407],
            [34.26926785700416, 1.088968169917923],
            [34.26974081910294, 1.090460409508132],
            [34.26870523585352, 1.0922369952321],
            [34.26992841787696, 1.094991721552367],
            [34.27038736895224, 1.097370581045588],
            [34.27408108419537, 1.098742983475153],
            [34.27624405761796, 1.10100701607119],
            [34.27912299011861, 1.101092596238598],
            [34.280321419962725, 1.100727476926938],
            [34.28106586192352, 1.101650654134903],
            [34.28082368959764, 1.101845301031454],
            [34.28002948995328, 1.102503956863214],
            [34.27986044049153, 1.104774104787368],
            [34.279440358620285, 1.104713885739826],
            [34.27918006368186, 1.104109988715361],
            [34.27477454496717, 1.104283034082919],
            [34.27215571157222, 1.106465187314638],
            [34.27069466284801, 1.105865297284382],
            [34.2698495862192, 1.10596129762439],
            [34.267417937474946, 1.108574959958165],
            [34.266099866408034, 1.107845424581733],
            [34.264830037566774, 1.108666424567529],
            [34.263134718996284, 1.10848091676549],
            [34.26249926423903, 1.110538396983038],
            [34.2612953924009, 1.110681329817588],
            [34.26021561203952, 1.111562650314466],
            [34.258595117742296, 1.110949265768943],
            [34.257485598653396, 1.11245978240804],
            [34.257301053253016, 1.113592391852961],
            [34.254611828770706, 1.116346856780862],
            [34.253866958313516, 1.116910926675437],
            [34.25330155238551, 1.116151115101272],
            [34.252416361487676, 1.116010559023271],
            [34.25186387243512, 1.117463423870693],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 973,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUFUMBO",
        Population: 19756,
        Key: "MBALEBUFUMBO",
        Dist2: "Mbale",
        "Sub Country": "gBufumbo",
        id2_original: "Mbale gBufumbo",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.1459169415252, 1.082182744520319],
            [34.14294135568988, 1.08246118335242],
            [34.14149232732253, 1.084117063620449],
            [34.14120262513496, 1.085917232316099],
            [34.13943976493321, 1.086451589857877],
            [34.138231969253916, 1.085864089444755],
            [34.137253625756074, 1.087555975720805],
            [34.13558747368624, 1.086869147812268],
            [34.135104608559764, 1.087312562651102],
            [34.13446234187773, 1.086493415083184],
            [34.13391219473311, 1.086571990963419],
            [34.133800432633656, 1.085939034104937],
            [34.13300428634005, 1.085986108148907],
            [34.13150753227828, 1.084748738295924],
            [34.130673322569464, 1.082410381012283],
            [34.129982412114764, 1.082207955732604],
            [34.129830038977964, 1.080655134175719],
            [34.12928442203734, 1.079616968622105],
            [34.12797072486753, 1.079127897593858],
            [34.12793015425435, 1.078320291815887],
            [34.12692962506392, 1.078582597423631],
            [34.12662870561343, 1.077438317571798],
            [34.126869787384535, 1.076820046363744],
            [34.12475861710948, 1.074363362428018],
            [34.12048395418557, 1.069091219978177],
            [34.11975587773262, 1.068648254259888],
            [34.11641451049002, 1.068568071110779],
            [34.115083695024154, 1.067926321125989],
            [34.11435538321263, 1.066832069268406],
            [34.11430174570531, 1.066054166880984],
            [34.11186231575405, 1.064155478942962],
            [34.11235795133061, 1.061712983002138],
            [34.11053472074848, 1.05802619492121],
            [34.10897114730095, 1.05699434837409],
            [34.11236018454239, 1.055191612812508],
            [34.12001730814155, 1.052545070375545],
            [34.123306409604304, 1.053488143925587],
            [34.12602366062516, 1.053432886215833],
            [34.12813679012589, 1.052596386060566],
            [34.1312520711744, 1.049968673235236],
            [34.13188823110917, 1.049903319196375],
            [34.13515462316153, 1.047720552433675],
            [34.13819503861428, 1.046829445889368],
            [34.14390955630986, 1.045915647835826],
            [34.148869992223325, 1.046977465332294],
            [34.151975361261, 1.046846072726324],
            [34.155662499039614, 1.045368626308043],
            [34.1570210517865, 1.04519446477497],
            [34.15745211107053, 1.044521387320508],
            [34.15725743447039, 1.042915140044942],
            [34.158141052418124, 1.041384468205037],
            [34.15802119380304, 1.037965657787184],
            [34.16178432096983, 1.037931704346619],
            [34.1625559037303, 1.038696937009381],
            [34.163520874906816, 1.038293398331695],
            [34.165489065728025, 1.037234349654521],
            [34.1679287786486, 1.033931857522216],
            [34.16957058188267, 1.032692022962997],
            [34.17360348570571, 1.033450337395687],
            [34.175668425083025, 1.034336017390324],
            [34.17595796108224, 1.035113814505613],
            [34.17680288409914, 1.035674313034082],
            [34.17685106164614, 1.036859244100904],
            [34.177237548322395, 1.037058097634798],
            [34.179193907433, 1.03744631462176],
            [34.182000625266284, 1.036238661911271],
            [34.182784086449736, 1.039261396720204],
            [34.18257859054028, 1.04257902098469],
            [34.17956751316641, 1.043777953667764],
            [34.17825165824327, 1.046066679769201],
            [34.177977784371016, 1.050711782080503],
            [34.17607535561852, 1.050237695931127],
            [34.173164108022156, 1.051612016457658],
            [34.17111097699926, 1.053078372098333],
            [34.16897558994074, 1.055619943100111],
            [34.16518078368545, 1.058334944424526],
            [34.16470435678463, 1.059499908870636],
            [34.16078527489798, 1.0602894198502],
            [34.15983612215529, 1.065194485927796],
            [34.15911067866443, 1.066833675177729],
            [34.1531994730408, 1.068716967018142],
            [34.15196715245592, 1.071853405862317],
            [34.15126574339051, 1.072345374615951],
            [34.15176910986838, 1.073873645679826],
            [34.15138313972343, 1.077985122358801],
            [34.148509333009784, 1.077419996976344],
            [34.14679438175876, 1.078280443319642],
            [34.1459169415252, 1.082182744520319],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 974,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUKASAKYA",
        Population: 29663,
        Key: "MBALEBUKASAKYA",
        Dist2: "Mbale",
        "Sub Country": "Bukassakya",
        id2_original: "Mbale Bukassakya",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.28429605546317, 0.962466837785244],
            [34.28370189805616, 0.962539423993444],
            [34.28370230139972, 0.963615784209422],
            [34.28270530079176, 0.964737749578546],
            [34.28264776010455, 0.967044259511406],
            [34.281888374669, 0.968310857007936],
            [34.28219764036683, 0.969314738912687],
            [34.282743957095065, 0.968961773064341],
            [34.283077173674975, 0.969441033845161],
            [34.28180993377842, 0.971775141836511],
            [34.28143090940722, 0.973430531609891],
            [34.28057576086743, 0.973928338389474],
            [34.280433890832924, 0.974507276383074],
            [34.28035333979972, 0.978315276537744],
            [34.27952264250365, 0.979609039867055],
            [34.279465734230435, 0.983543663652667],
            [34.27827822879844, 0.984358178948962],
            [34.27759029895388, 0.985959421879417],
            [34.276521614582876, 0.98614978172849],
            [34.274207893974136, 0.990926478456167],
            [34.27235541604302, 0.991714120172341],
            [34.271752562944066, 0.992564592121752],
            [34.270501558299586, 0.991832424942522],
            [34.268173161015774, 0.992032318642221],
            [34.26691309865833, 0.991119250534366],
            [34.26572459429977, 0.990812175948044],
            [34.26470131707142, 0.989320125470386],
            [34.26205168134366, 0.989877503551001],
            [34.260275231428274, 0.989604143881115],
            [34.25875977893386, 0.988093430440735],
            [34.25856001427592, 0.987306656406806],
            [34.25737119820197, 0.987060202464922],
            [34.25642799410312, 0.987665623772585],
            [34.255479191703394, 0.987720251190484],
            [34.253644889385384, 0.986882171114534],
            [34.25166263184515, 0.987597492189903],
            [34.24953143273251, 0.989294184195868],
            [34.246949507519304, 0.990342493733451],
            [34.24278825330677, 0.990838913897199],
            [34.242605109278216, 0.990545664087544],
            [34.24183947965315, 0.989654470775119],
            [34.23951287540664, 0.988705603190768],
            [34.23826785713522, 0.988986473528077],
            [34.23759709499406, 0.988498284921392],
            [34.23548985844158, 0.988453850979365],
            [34.23451772589564, 0.985532611021083],
            [34.23391262521181, 0.984908717302853],
            [34.2350041986563, 0.982773637863317],
            [34.234163412381264, 0.981154857268247],
            [34.23400180097008, 0.976930800546441],
            [34.233346241916756, 0.976542098517881],
            [34.234043597783625, 0.976044353201345],
            [34.23377411487649, 0.974769076745036],
            [34.233202892357, 0.97463360974335],
            [34.232521646876435, 0.973105218635432],
            [34.23047016516041, 0.971921049467575],
            [34.22920066330594, 0.969732569068202],
            [34.22623279849047, 0.967508525327814],
            [34.22507239433232, 0.965699898249199],
            [34.22337442034185, 0.96519398142006],
            [34.221609474252, 0.965863971088946],
            [34.220239672801135, 0.965873513434485],
            [34.218491032032, 0.965032936339276],
            [34.21692799128541, 0.96493400274068],
            [34.21507027976943, 0.963767831307835],
            [34.213775126522, 0.962067783370146],
            [34.21237125556568, 0.961028078653993],
            [34.212181207984145, 0.960427193804821],
            [34.20959432137564, 0.960329126825027],
            [34.209240605240964, 0.960740098614981],
            [34.206349877860625, 0.960339501807402],
            [34.20348112686541, 0.958192075595508],
            [34.20216444459392, 0.958408576124209],
            [34.19631592880066, 0.957614652762821],
            [34.18781853186451, 0.957584735856213],
            [34.18367639829282, 0.959412633400287],
            [34.18031344633056, 0.959805303796396],
            [34.17699646385633, 0.96081973923613],
            [34.17436594697279, 0.962202396696666],
            [34.171410395364944, 0.964406474495397],
            [34.16743464685185, 0.965582630862271],
            [34.159676363968515, 0.96947738166438],
            [34.16028422966678, 0.970466180876811],
            [34.16025052218239, 0.971029208094356],
            [34.15980993087488, 0.971285276501808],
            [34.158810043979884, 0.971660969809125],
            [34.15816576327495, 0.971064054129044],
            [34.157995652004566, 0.969272695689598],
            [34.15930020432476, 0.967651436790378],
            [34.16128279963156, 0.96623468275105],
            [34.16338427708471, 0.965534450276155],
            [34.16743365151851, 0.961103991784492],
            [34.168619465422786, 0.95924392738928],
            [34.16943322408585, 0.958989408350241],
            [34.1692662075116, 0.957387271511775],
            [34.16977439255264, 0.957134007106173],
            [34.171072610851795, 0.948645237598734],
            [34.17150363779647, 0.947173648236711],
            [34.17278648322617, 0.946165446724881],
            [34.173305330371356, 0.943912023967887],
            [34.17503015320904, 0.943085035664969],
            [34.177970968852975, 0.942613301661395],
            [34.17790795652737, 0.940650887952188],
            [34.178811837772976, 0.939970637795718],
            [34.18265689488697, 0.93989609574354],
            [34.18643981912603, 0.940501520944127],
            [34.18919349862828, 0.939831092514676],
            [34.192593348890824, 0.937584952718079],
            [34.19456180830829, 0.934612460393984],
            [34.19560847856497, 0.927991511808218],
            [34.1951007166304, 0.925587991174255],
            [34.1961941612656, 0.925060486594022],
            [34.195827064724725, 0.924002305659595],
            [34.19664254186494, 0.924002028116254],
            [34.197855422907026, 0.924996603144417],
            [34.1982734422464, 0.923838656588926],
            [34.19894970926365, 0.92405551493663],
            [34.19912904263877, 0.926244425700041],
            [34.19838838348362, 0.926606491951159],
            [34.19944684592502, 0.927682525580908],
            [34.19968875684115, 0.928903563847016],
            [34.20039742159911, 0.928595779487398],
            [34.20175942567334, 0.928794308930791],
            [34.202269500769766, 0.927491606503244],
            [34.202623907708904, 0.927563847636269],
            [34.203525275468365, 0.929110289322375],
            [34.202857549632824, 0.929237153383867],
            [34.20284508011838, 0.930557775092436],
            [34.2042096946968, 0.931823650332989],
            [34.20383137280817, 0.932447907613456],
            [34.206029835074354, 0.933234090686235],
            [34.2061888880836, 0.933568712738719],
            [34.205590330728334, 0.933957867828106],
            [34.20610099601789, 0.934391866199699],
            [34.20830834980877, 0.933886727116123],
            [34.20941966732486, 0.936002224067854],
            [34.210967960429436, 0.936691777604162],
            [34.21256072822541, 0.938115933233856],
            [34.2133126001519, 0.938004363955615],
            [34.213511972246046, 0.938961516242527],
            [34.21406501915239, 0.939473327281781],
            [34.21477260593205, 0.939183685582463],
            [34.21583428434215, 0.939650793450108],
            [34.216939893962916, 0.939249705579622],
            [34.218488131371934, 0.939783432521227],
            [34.219461022096, 0.939293342566852],
            [34.220456596179304, 0.940450563688642],
            [34.22127494343684, 0.940695142879548],
            [34.22151903366582, 0.943063625424153],
            [34.22481359329224, 0.941437406905172],
            [34.225962916731355, 0.939567081723437],
            [34.22640559213033, 0.940635456077188],
            [34.22711333701346, 0.94083554769784],
            [34.228395509605, 0.939432655236967],
            [34.23188997133158, 0.940299588904172],
            [34.23362286014221, 0.938346697453726],
            [34.23515577498743, 0.939191149579595],
            [34.23470792439412, 0.939818164802142],
            [34.23625730805344, 0.94015397274068],
            [34.23724494102963, 0.941162702336592],
            [34.24107287176273, 0.942116900496425],
            [34.24296364667105, 0.941451142986321],
            [34.24134582576013, 0.940863093516756],
            [34.24239361441931, 0.940182352089284],
            [34.24319804317983, 0.938546128134103],
            [34.24379824175712, 0.939226277071983],
            [34.24376119882808, 0.941840728332515],
            [34.24428550952681, 0.942673795007803],
            [34.24525018246263, 0.943185632448172],
            [34.245485149401624, 0.941893618480966],
            [34.247175614374626, 0.942744196327727],
            [34.24819489859155, 0.94391650325829],
            [34.249647880444485, 0.951424657982023],
            [34.25130046525858, 0.952010388327381],
            [34.25201958999972, 0.951806702789642],
            [34.25321491346961, 0.952474570856405],
            [34.25396447313257, 0.953478307417083],
            [34.25623756294096, 0.954110631057994],
            [34.25701184154562, 0.9551324459193],
            [34.25684316847796, 0.956154608974571],
            [34.257321093768695, 0.95766497115244],
            [34.26202863147179, 0.959399888093433],
            [34.26798379345894, 0.963404645296697],
            [34.27333043846926, 0.963610669027392],
            [34.27588454465471, 0.963311217545179],
            [34.27790292345253, 0.961655206676659],
            [34.28015973309305, 0.960822207459462],
            [34.28289239830587, 0.960459370530266],
            [34.284792344114955, 0.959002397966142],
            [34.285401109925104, 0.958947896727812],
            [34.28560060598677, 0.959282487557809],
            [34.28465093671282, 0.960820505391348],
            [34.28484153675821, 0.961390270623162],
            [34.28429605546317, 0.962466837785244],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 975,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUKIENDE",
        Population: 21815,
        Key: "MBALEBUKIENDE",
        Dist2: "Mbale",
        "Sub Country": "Bukhiende",
        id2_original: "Mbale Bukhiende",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.23993447722734, 1.119915051792078],
            [34.23852158628723, 1.120431231090181],
            [34.23835260060588, 1.121932806334168],
            [34.237507137701485, 1.122837687131669],
            [34.23662618864845, 1.122168717971783],
            [34.23392096876419, 1.122757809903363],
            [34.23302781160643, 1.12244160703247],
            [34.23119247712419, 1.122777060696413],
            [34.228487757601506, 1.121900821663046],
            [34.227425154824985, 1.12200076881933],
            [34.22480468739451, 1.121133534338359],
            [34.22504641954588, 1.11897161815968],
            [34.22417855984486, 1.118506835800407],
            [34.2191867278122, 1.119824891636668],
            [34.21768217637376, 1.118940980672226],
            [34.217246210491645, 1.117663331056514],
            [34.217137750599186, 1.112055308632452],
            [34.21603961496157, 1.106312016289486],
            [34.214024778220946, 1.103074637976559],
            [34.212651812903644, 1.096993217689397],
            [34.215182542230465, 1.098035941659022],
            [34.21658353228969, 1.097230337532113],
            [34.2176214304976, 1.097157549612906],
            [34.21866503210926, 1.096145870821093],
            [34.22260830293158, 1.095762528319249],
            [34.22289824047773, 1.094695068470336],
            [34.22596556855809, 1.090976210415527],
            [34.227555831851056, 1.090138737935601],
            [34.22889970792282, 1.088460428693444],
            [34.23196655360786, 1.08911042118923],
            [34.232810910686126, 1.087298264944969],
            [34.23623579070743, 1.085119395772538],
            [34.23837862659628, 1.083074621340175],
            [34.2380164115007, 1.080420892516029],
            [34.23905331347693, 1.078300953614769],
            [34.24091922840811, 1.077498791343588],
            [34.241943924974606, 1.075824326399229],
            [34.243184477720725, 1.074736452482574],
            [34.25006663011416, 1.080962256639465],
            [34.254385988715015, 1.08182879326856],
            [34.25350724592428, 1.0864512296982],
            [34.25449758462614, 1.089571390096286],
            [34.25465830311194, 1.092492902994288],
            [34.25301059255652, 1.096880494393144],
            [34.25257682215698, 1.1004806474666],
            [34.25135912794157, 1.101693213834378],
            [34.2512591535353, 1.103031939083747],
            [34.249365309083636, 1.10575533523064],
            [34.247348691882095, 1.106344126870528],
            [34.24393504080185, 1.106408889614727],
            [34.24116636212929, 1.10831859462244],
            [34.239934752111814, 1.108509063799592],
            [34.23893278471864, 1.10988435671458],
            [34.239343357922635, 1.111250007389122],
            [34.24059860351351, 1.112506757237877],
            [34.24084052071785, 1.113483535703749],
            [34.24087658089, 1.116432251487036],
            [34.23993447722734, 1.119915051792078],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 976,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUKONDE",
        Population: 19102,
        Key: "MBALEBUKONDE",
        Dist2: "Mbale",
        "Sub Country": "Bukonde",
        id2_original: "Mbale Bukonde",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.12740787734141, 1.008349079442512],
            [34.12050309009774, 1.002228203378952],
            [34.12320068957346, 1.000246589801529],
            [34.124588482482864, 0.999717530347535],
            [34.12490704484555, 0.998849040980842],
            [34.128019347080595, 0.995166793335061],
            [34.12957079506844, 0.991477227692408],
            [34.12971765973594, 0.991061246910425],
            [34.13101740427273, 0.991313271072691],
            [34.13131477537787, 0.994113211212865],
            [34.133206983099086, 0.993309264503086],
            [34.13831419923839, 0.992687812603144],
            [34.141574186302776, 0.991080097032963],
            [34.144515733175375, 0.991744653825931],
            [34.14738862630237, 0.991674800514568],
            [34.14962248039409, 0.989837932380645],
            [34.153885555050834, 0.987862648032715],
            [34.15712310219943, 0.987379543868603],
            [34.160884752535885, 0.986001156817042],
            [34.16552350174613, 0.98529454687022],
            [34.16566616678966, 0.984336519272774],
            [34.16640559615116, 0.983621668144846],
            [34.16964348915113, 0.982137072957191],
            [34.172270089380056, 0.983221594997628],
            [34.173111683240485, 0.983963020746429],
            [34.1750248028432, 0.984477930055207],
            [34.18179047967691, 0.985027285482911],
            [34.18267497527869, 0.986383777052978],
            [34.18836211322274, 0.989565703517799],
            [34.19604136142902, 0.98962141231468],
            [34.197874465394435, 0.990220155178613],
            [34.19875426640054, 0.990781219242649],
            [34.20426491413732, 0.991953545504793],
            [34.20929917988904, 0.9955008281768],
            [34.210471643929885, 0.994885313658205],
            [34.21187420065098, 0.995328013908121],
            [34.214296493441545, 0.995254752080311],
            [34.215699178621726, 0.996050215010314],
            [34.21949053534634, 0.996989508590079],
            [34.220056324855015, 0.997604375128453],
            [34.22082911225626, 0.997558859901153],
            [34.221797132314855, 0.99753136124869],
            [34.22266963900087, 0.998785325075648],
            [34.22660614371246, 1.001586395958258],
            [34.22616276223767, 1.001681489657802],
            [34.22658826633999, 1.002622034585182],
            [34.22608096074958, 1.003716701106917],
            [34.226527582447595, 1.005552716307693],
            [34.227662550808496, 1.006818619219714],
            [34.227613890866195, 1.007352306726543],
            [34.22691368194997, 1.007741517994037],
            [34.22674441509592, 1.008664197351909],
            [34.22894182723156, 1.010978940906238],
            [34.22941239352348, 1.012254138717364],
            [34.23257583145776, 1.013130313790962],
            [34.23313109181296, 1.015581354785549],
            [34.235038617606385, 1.017651974314599],
            [34.23601673383046, 1.019949079406955],
            [34.23140391808416, 1.026942823929721],
            [34.23063069859325, 1.027332069659026],
            [34.22919399780654, 1.027224085266167],
            [34.22885178729399, 1.027738542256359],
            [34.22591477781193, 1.026901023051361],
            [34.22252587711438, 1.025025755507853],
            [34.220822756675624, 1.022627647395786],
            [34.21855262322283, 1.021225160173553],
            [34.216752331121484, 1.019055547189324],
            [34.21284459046529, 1.016976473153039],
            [34.20785079022386, 1.01521599996703],
            [34.2040069278692, 1.010517811312437],
            [34.20204514293429, 1.010012678228947],
            [34.20035808257619, 1.007124979158043],
            [34.198882373346585, 1.005852712781858],
            [34.19649891382741, 1.004858181152956],
            [34.190744728325534, 1.00734067803609],
            [34.18923672016986, 1.006427407602534],
            [34.18571888877116, 1.00667348106429],
            [34.18398486538833, 1.008354903216818],
            [34.17612097296696, 1.004898291947136],
            [34.17213285824566, 1.004752872576852],
            [34.16803022449532, 1.00550040558396],
            [34.16404721669642, 1.004002873901807],
            [34.15822428761742, 1.002952170577931],
            [34.1558091930272, 1.003495708131201],
            [34.15125965640614, 1.005483524347992],
            [34.14600416524436, 1.005916988113686],
            [34.143229811015814, 1.006797223755017],
            [34.13729520427903, 1.007083784292158],
            [34.13503460015474, 1.007756953154396],
            [34.12740787734141, 1.008349079442512],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 977,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUMBOBI",
        Population: 16352,
        Key: "MBALEBUMBOBI",
        Dist2: "Mbale",
        "Sub Country": "Bumboi",
        id2_original: "Mbale Bumboi",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.182000625266284, 1.036238661911271],
            [34.179193907433, 1.03744631462176],
            [34.177237548322395, 1.037058097634798],
            [34.17685106164614, 1.036859244100904],
            [34.17680288409914, 1.035674313034082],
            [34.17595796108224, 1.035113814505613],
            [34.175668425083025, 1.034336017390324],
            [34.17360348570571, 1.033450337395687],
            [34.16957058188267, 1.032692022962997],
            [34.1679287786486, 1.033931857522216],
            [34.165489065728025, 1.037234349654521],
            [34.163520874906816, 1.038293398331695],
            [34.1625559037303, 1.038696937009381],
            [34.16178432096983, 1.037931704346619],
            [34.15802119380304, 1.037965657787184],
            [34.158141052418124, 1.041384468205037],
            [34.15725743447039, 1.042915140044942],
            [34.15745211107053, 1.044521387320508],
            [34.1570210517865, 1.04519446477497],
            [34.155662499039614, 1.045368626308043],
            [34.151975361261, 1.046846072726324],
            [34.148869992223325, 1.046977465332294],
            [34.14390955630986, 1.045915647835826],
            [34.13819503861428, 1.046829445889368],
            [34.13515462316153, 1.047720552433675],
            [34.13188823110917, 1.049903319196375],
            [34.1312520711744, 1.049968673235236],
            [34.12813679012589, 1.052596386060566],
            [34.12602366062516, 1.053432886215833],
            [34.123306409604304, 1.053488143925587],
            [34.12001730814155, 1.052545070375545],
            [34.11236018454239, 1.055191612812508],
            [34.10897114730095, 1.05699434837409],
            [34.106164539062114, 1.052389180587183],
            [34.103458644543096, 1.049766912260738],
            [34.09814978986014, 1.049741662161751],
            [34.094812790226456, 1.049308650730931],
            [34.090066301572634, 1.048107248410732],
            [34.087134992799356, 1.046552418450318],
            [34.085073566733136, 1.046227493616048],
            [34.08352735412674, 1.044753583884069],
            [34.08293307005726, 1.042998924604971],
            [34.081182597623275, 1.040412459252944],
            [34.108593768643324, 1.023541815019113],
            [34.11117831603886, 1.022961992879752],
            [34.11313420533055, 1.023540227949282],
            [34.114366110893734, 1.022472414493549],
            [34.11653920114303, 1.022598290637138],
            [34.117855425273746, 1.023357658328303],
            [34.11891832718927, 1.022461770254215],
            [34.12014982401901, 1.02022707649841],
            [34.12261298566346, 1.019493517969268],
            [34.12671977861356, 1.019111184527868],
            [34.12948733079876, 1.018434834000044],
            [34.13191931730956, 1.017021387230844],
            [34.13331551216182, 1.014644973947479],
            [34.12740787734141, 1.008349079442512],
            [34.13503460015474, 1.007756953154396],
            [34.13729520427903, 1.007083784292158],
            [34.143229811015814, 1.006797223755017],
            [34.14600416524436, 1.005916988113686],
            [34.15125965640614, 1.005483524347992],
            [34.1558091930272, 1.003495708131201],
            [34.15822428761742, 1.002952170577931],
            [34.16404721669642, 1.004002873901807],
            [34.16803022449532, 1.00550040558396],
            [34.17213285824566, 1.004752872576852],
            [34.17612097296696, 1.004898291947136],
            [34.18398486538833, 1.008354903216818],
            [34.18571888877116, 1.00667348106429],
            [34.18923672016986, 1.006427407602534],
            [34.190744728325534, 1.00734067803609],
            [34.19649891382741, 1.004858181152956],
            [34.198882373346585, 1.005852712781858],
            [34.20035808257619, 1.007124979158043],
            [34.20204514293429, 1.010012678228947],
            [34.2040069278692, 1.010517811312437],
            [34.20785079022386, 1.01521599996703],
            [34.21284459046529, 1.016976473153039],
            [34.216752331121484, 1.019055547189324],
            [34.21855262322283, 1.021225160173553],
            [34.220822756675624, 1.022627647395786],
            [34.22252587711438, 1.025025755507853],
            [34.22591477781193, 1.026901023051361],
            [34.22885178729399, 1.027738542256359],
            [34.225148782572504, 1.032245764783361],
            [34.22197615217792, 1.033848008053694],
            [34.219485547899886, 1.03451832411769],
            [34.2183142911948, 1.035350943605144],
            [34.21814554716023, 1.036156037605424],
            [34.219359288788375, 1.037729443218437],
            [34.21772308655011, 1.037341131958576],
            [34.21603316685448, 1.036003087607709],
            [34.21419791861048, 1.036492242675414],
            [34.21052686606535, 1.036023306277342],
            [34.204864103906544, 1.036694838001255],
            [34.19121189179915, 1.031398454017755],
            [34.18915789929187, 1.031594590930511],
            [34.187955967814766, 1.032447034682245],
            [34.186759178294345, 1.032631992914095],
            [34.18551432890625, 1.034059684935162],
            [34.18282438846665, 1.034869276394255],
            [34.182000625266284, 1.036238661911271],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 978,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUNGOKHO",
        Population: 28606,
        Key: "MBALEBUNGOKHO",
        Dist2: "Mbale",
        "Sub Country": "Bungokho",
        id2_original: "Mbale Bungokho",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.199502669931746, 1.083800505464285],
            [34.196633916241574, 1.083661401974904],
            [34.194853076259385, 1.084060106255335],
            [34.19240256648743, 1.08256859819444],
            [34.201685414375376, 1.076567849358058],
            [34.20201799045649, 1.072470186235418],
            [34.20244063701791, 1.071773529068919],
            [34.20677269240697, 1.06908535320418],
            [34.20594878637446, 1.063405223956766],
            [34.20614206609435, 1.062147850102254],
            [34.208061931146545, 1.059677726020957],
            [34.20806230215074, 1.059189279630707],
            [34.207772297230946, 1.05868285645234],
            [34.206826921005714, 1.058348551579388],
            [34.20386028328896, 1.058268307087694],
            [34.202121713532485, 1.059001659015833],
            [34.201249952448165, 1.058775866508586],
            [34.20052788123289, 1.057853525941793],
            [34.1999484130774, 1.058242701385461],
            [34.19690517242309, 1.057610714074551],
            [34.19556523726045, 1.058009230434897],
            [34.19491292382024, 1.057376309885821],
            [34.19322297897179, 1.053098513416035],
            [34.19167745537323, 1.051959394829827],
            [34.18993858827439, 1.051932928634686],
            [34.18868311630804, 1.051426870725774],
            [34.18701699388259, 1.052178276461401],
            [34.18468674337433, 1.050759046176857],
            [34.18123292053288, 1.051583497056704],
            [34.178184571159534, 1.050833890200815],
            [34.177977784371016, 1.050711782080503],
            [34.17825165824327, 1.046066679769201],
            [34.17956751316641, 1.043777953667764],
            [34.18257859054028, 1.04257902098469],
            [34.182784086449736, 1.039261396720204],
            [34.182000625266284, 1.036238661911271],
            [34.18282438846665, 1.034869276394255],
            [34.18551432890625, 1.034059684935162],
            [34.186759178294345, 1.032631992914095],
            [34.187955967814766, 1.032447034682245],
            [34.18915789929187, 1.031594590930511],
            [34.19121189179915, 1.031398454017755],
            [34.204864103906544, 1.036694838001255],
            [34.21052686606535, 1.036023306277342],
            [34.21419791861048, 1.036492242675414],
            [34.21603316685448, 1.036003087607709],
            [34.21772308655011, 1.037341131958576],
            [34.219359288788375, 1.037729443218437],
            [34.22184059819818, 1.039175717825508],
            [34.2237725141499, 1.041779995737865],
            [34.22576414381351, 1.047721940098751],
            [34.23047300024346, 1.050804499573443],
            [34.229699972093684, 1.053120385494779],
            [34.229745326235744, 1.054196749890254],
            [34.234906982077916, 1.057541417263674],
            [34.23929879968791, 1.061293407933177],
            [34.236008330090975, 1.061719861119513],
            [34.235464976904844, 1.062507013860381],
            [34.23383486344757, 1.063321740829102],
            [34.233381936474586, 1.064117902608207],
            [34.2333516749276, 1.065691782734481],
            [34.232295104338185, 1.06678668077429],
            [34.23187261408366, 1.067854188159545],
            [34.23036330965905, 1.068822637221047],
            [34.229653831027434, 1.068506341536074],
            [34.22886873940172, 1.06871469916661],
            [34.22826503380155, 1.070270722446642],
            [34.22781245896817, 1.070542262712891],
            [34.226574379284024, 1.069991003523751],
            [34.22548763697917, 1.070081893584592],
            [34.22274054841612, 1.072669942836953],
            [34.221231482943395, 1.072851456044154],
            [34.220265315210916, 1.073910140513531],
            [34.21800170891696, 1.073458788496024],
            [34.21757889706553, 1.073730316803504],
            [34.21683904010595, 1.074716548419644],
            [34.21569232986599, 1.075142137512258],
            [34.215510948332046, 1.076634681198351],
            [34.214152415348074, 1.07827242368287],
            [34.21454466381858, 1.078824028065968],
            [34.21297512555755, 1.079484965761154],
            [34.21264287915813, 1.078698159576656],
            [34.21167728724576, 1.078391008143207],
            [34.209835482198486, 1.079395775291057],
            [34.20950391672208, 1.078907462270908],
            [34.20886984087877, 1.07897103375355],
            [34.207179082156685, 1.079885287270688],
            [34.20698280116542, 1.079216012979163],
            [34.20642442635112, 1.078972012743605],
            [34.20442227741553, 1.080708925606688],
            [34.20483623547149, 1.082053190141666],
            [34.203154542547246, 1.083052368657026],
            [34.199502669931746, 1.083800505464285],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 979,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUNGOKHO MUTOTO",
        Population: 34372,
        Key: "MBALEBUNGOKHO MUTOTO",
        Dist2: "Mbale",
        "Sub Country": "Bungokho-\nMutoto",
        id2_original: "Mbale Bungokho-\nMutoto",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.15325125912028, 0.872556717239003],
            [34.1530025030417, 0.872743727483438],
            [34.15653663616786, 0.877060436694511],
            [34.15835688254659, 0.88033307701029],
            [34.15782382405362, 0.884450417439635],
            [34.15936380325026, 0.886452824902923],
            [34.16376645993247, 0.889294352602485],
            [34.17009084567104, 0.894355852020998],
            [34.17357802834887, 0.898770249960564],
            [34.178859209531176, 0.903729564729575],
            [34.18469976804764, 0.907467002108649],
            [34.19164799153023, 0.913829218015167],
            [34.19710634384275, 0.915914762954121],
            [34.20148292961876, 0.916707249665],
            [34.20584709259274, 0.918434565686686],
            [34.21069567927017, 0.923171057906839],
            [34.21653536013261, 0.929928522603911],
            [34.21470230557452, 0.931340621786681],
            [34.21126098548521, 0.932192084224684],
            [34.20932873086861, 0.932979690097403],
            [34.20815807872971, 0.934020298732801],
            [34.20610100679768, 0.934391857217756],
            [34.20559033521992, 0.933957881301072],
            [34.20618887281225, 0.933568710044119],
            [34.206029843159186, 0.933234096973614],
            [34.20383135663849, 0.932447894140483],
            [34.204209701883315, 0.931823647638387],
            [34.20284507023691, 0.930557786768991],
            [34.20285756220925, 0.929237156976649],
            [34.20352526289194, 0.929110286627771],
            [34.20262389513248, 0.927563843145305],
            [34.20226951693942, 0.927491601114067],
            [34.201759441843016, 0.928794303541616],
            [34.20039740632776, 0.928595787571177],
            [34.19968875504452, 0.928903561152412],
            [34.19944684143346, 0.927682539053865],
            [34.19838837360215, 0.92660649105298],
            [34.19912902736739, 0.926244440071217],
            [34.19894971555186, 0.924055503260053],
            [34.19827345212787, 0.923838671858292],
            [34.19785542021207, 0.924996611228204],
            [34.19664255354303, 0.924002031709041],
            [34.1958270521483, 0.924002312845171],
            [34.19619416845211, 0.925060502761595],
            [34.19244026338999, 0.926726098664391],
            [34.19155861544765, 0.925396730668443],
            [34.19194815459928, 0.924636805577862],
            [34.18989248673402, 0.924302823095047],
            [34.18950354406376, 0.925126078415438],
            [34.18887012668556, 0.92540669527836],
            [34.187990339154176, 0.924556739281338],
            [34.18833015475817, 0.926347592709783],
            [34.18729982934812, 0.925470550876437],
            [34.18654994629163, 0.926746203025276],
            [34.18516296186601, 0.927452199880272],
            [34.18383170083576, 0.926873739921679],
            [34.18276561798581, 0.928221877892607],
            [34.182280282492314, 0.927869265335334],
            [34.18010811391451, 0.928539370001448],
            [34.180109938392846, 0.928991626695033],
            [34.178693232307694, 0.929760953177157],
            [34.178575538632444, 0.930547963190463],
            [34.179002098255225, 0.931398091998029],
            [34.17866273809707, 0.932700722924331],
            [34.175684577690134, 0.934809308075954],
            [34.17543094375958, 0.933850589099716],
            [34.17473404783012, 0.934113136262383],
            [34.17467095555448, 0.935189567298469],
            [34.174290784932985, 0.935325384354611],
            [34.1732131578333, 0.934113662605156],
            [34.17333969362592, 0.932901518285702],
            [34.1723252998374, 0.932639568333112],
            [34.17118552728638, 0.935389731984342],
            [34.17118580756074, 0.936212878731026],
            [34.17010867183954, 0.936403183868547],
            [34.1676373921199, 0.936150741575234],
            [34.16770066046534, 0.935517548805045],
            [34.1683974512919, 0.934938423708762],
            [34.16814350115434, 0.934685209759897],
            [34.166559835088826, 0.935002350091846],
            [34.1645947353705, 0.933537659406888],
            [34.164151051163486, 0.933474469517949],
            [34.163137604199264, 0.934370314888898],
            [34.162059485721144, 0.933348546918486],
            [34.16142606834295, 0.933728666180493],
            [34.16047627510149, 0.935131009434141],
            [34.15971583055223, 0.93519458461924],
            [34.1597160757923, 0.935900124396865],
            [34.158955946551686, 0.936922523055779],
            [34.15718124745282, 0.937113074260215],
            [34.157308801934946, 0.9390306853143],
            [34.158386077793324, 0.939156958903796],
            [34.157246586415006, 0.942793627518635],
            [34.15604259779588, 0.943237250734107],
            [34.15572566138387, 0.942730788990575],
            [34.154965427040395, 0.943427555488896],
            [34.153887834076706, 0.942279130468805],
            [34.153190868078674, 0.942342705523908],
            [34.152683319943144, 0.941130776027446],
            [34.15223967166872, 0.941257539954955],
            [34.151163096496276, 0.943175569985562],
            [34.15141729187391, 0.944197616218896],
            [34.15059378918496, 0.945536625481022],
            [34.149326392981514, 0.946106907906801],
            [34.14888320105124, 0.947644816657849],
            [34.14793305656849, 0.948151663907219],
            [34.147870034361425, 0.949490426435738],
            [34.147173313603496, 0.95025953822676],
            [34.14571586712359, 0.950323324210647],
            [34.14362472299115, 0.951536128028294],
            [34.14413216602378, 0.952359095805977],
            [34.14394187050725, 0.952684795185979],
            [34.142991585887316, 0.952685111349247],
            [34.14273819809514, 0.952359552087097],
            [34.14267517498973, 0.953770694590145],
            [34.14210463968143, 0.954024152354756],
            [34.14172425975247, 0.953572004894111],
            [34.14115446106268, 0.954404375343398],
            [34.140647228235835, 0.954151267901188],
            [34.14064761451142, 0.955300074304072],
            [34.14001391596053, 0.954784667450678],
            [34.139379972169564, 0.955237165944353],
            [34.13874613348153, 0.954341887320546],
            [34.138493026862015, 0.954848523409682],
            [34.13728872293424, 0.954405673228886],
            [34.13500784383399, 0.955998452317307],
            [34.13418384976659, 0.955745450978935],
            [34.1339306021116, 0.95599880350968],
            [34.1337400263207, 0.955365684419347],
            [34.13317001742516, 0.955555848388875],
            [34.132853115149096, 0.955112717165618],
            [34.132346128460625, 0.955682752803917],
            [34.13139556356633, 0.954923255556533],
            [34.13025501936248, 0.955366842186772],
            [34.13019136474145, 0.954787965606394],
            [34.129747646398414, 0.954724776103677],
            [34.12993734543361, 0.954281505553747],
            [34.12871658436981, 0.953913597645394],
            [34.12863731433421, 0.949662907127517],
            [34.12660543745094, 0.938143998230836],
            [34.120992616232066, 0.937914853443061],
            [34.117325560291626, 0.9351625163407],
            [34.117932449521135, 0.933715473477623],
            [34.11991881415886, 0.931931010859067],
            [34.12101139012317, 0.928730658181623],
            [34.118988917702616, 0.925167338945343],
            [34.115736173754364, 0.920645574712368],
            [34.115143285666846, 0.917342656267299],
            [34.11455601204985, 0.916691636249008],
            [34.11442389682103, 0.915666635055406],
            [34.11227516888221, 0.91280411091439],
            [34.11099008664748, 0.908942018464936],
            [34.108202045687285, 0.903162713819961],
            [34.10840655255161, 0.901552543245629],
            [34.11103745840568, 0.898467175900183],
            [34.11573441934463, 0.894838426553559],
            [34.119790944368056, 0.893505082122791],
            [34.12041787052003, 0.894326484282511],
            [34.12432473442049, 0.895224760086587],
            [34.12814931174263, 0.893959588729743],
            [34.129471940861315, 0.892340817369733],
            [34.131293731444025, 0.89183073403811],
            [34.131104453718734, 0.889863099977599],
            [34.13140760009281, 0.888824372902613],
            [34.13599672726507, 0.88349084257179],
            [34.13997963265604, 0.880501421180831],
            [34.146494910392484, 0.876778061903011],
            [34.14820125308815, 0.876255029630555],
            [34.15325125912028, 0.872556717239003],
          ],
          [
            [34.158576969791206, 0.913767782860635],
            [34.15519526909068, 0.915944867042185],
            [34.154484055812254, 0.918658694392627],
            [34.154434122058866, 0.921577071056121],
            [34.155121298216926, 0.923215231317731],
            [34.155147089747025, 0.924341627960092],
            [34.154909001162444, 0.924275772053865],
            [34.15607582917321, 0.925774885529172],
            [34.16298713638918, 0.927974207135918],
            [34.16265037415886, 0.927206318279418],
            [34.16366599594435, 0.922086026548579],
            [34.16585262200834, 0.920574947502874],
            [34.1659538576493, 0.919115723580668],
            [34.16460536783021, 0.917170594347993],
            [34.162036396323415, 0.916070650139745],
            [34.16061161887544, 0.914176744551441],
            [34.158576969791206, 0.913767782860635],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 980,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUSIU",
        Population: 22125,
        Key: "MBALEBUSIU",
        Dist2: "Mbale",
        "Sub Country": "Busiu",
        id2_original: "Mbale Busiu",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.1699510606263, 1.160286679411147],
            [34.164614088674995, 1.163102034277269],
            [34.162349760135534, 1.16529197392672],
            [34.160870385779575, 1.165473498466666],
            [34.15291608421306, 1.164427519659484],
            [34.14920299320757, 1.162022949499063],
            [34.147180503719035, 1.159500084415106],
            [34.14645588039003, 1.159346607236498],
            [34.14547486170927, 1.159916874807682],
            [34.14451350445514, 1.157603636340449],
            [34.14467891753661, 1.155086747987099],
            [34.14703866422723, 1.151693735191879],
            [34.14847284344295, 1.148691606388533],
            [34.14980345049966, 1.146785656025733],
            [34.15164402934656, 1.145654227095408],
            [34.15403627349088, 1.145517156314624],
            [34.15453435068838, 1.142561477150997],
            [34.15423030599898, 1.13652920678937],
            [34.154715580407036, 1.12749193570282],
            [34.15834452082997, 1.124747535058698],
            [34.15739789774314, 1.122427842094165],
            [34.15800271725427, 1.118201924837868],
            [34.15887807968455, 1.11650587959664],
            [34.16800170747663, 1.116576481854883],
            [34.167699998406974, 1.111544413455081],
            [34.166714037195554, 1.11045682282166],
            [34.16649739139679, 1.10927292529036],
            [34.16784315303233, 1.107551790554461],
            [34.16832886671657, 1.104570658024792],
            [34.16925163593935, 1.105426452276389],
            [34.16987935260877, 1.104865386291678],
            [34.17055563759232, 1.104982707804977],
            [34.170604020853524, 1.106619910331178],
            [34.17077320236761, 1.106927387600409],
            [34.1715308226136, 1.106798600410684],
            [34.17184424840949, 1.106827460590012],
            [34.171547412700264, 1.107542167802601],
            [34.171909460709244, 1.108401338230444],
            [34.172540240633765, 1.108866883812002],
            [34.17133360737446, 1.113561507319381],
            [34.172204340786095, 1.114130909139205],
            [34.174103576027775, 1.116763989316004],
            [34.17391317001846, 1.123359465833538],
            [34.174342362603326, 1.123909808067025],
            [34.17209141896162, 1.126791758986702],
            [34.17604088636276, 1.134065599100565],
            [34.17824028467345, 1.13632612597845],
            [34.180546511536065, 1.137567613746318],
            [34.18010171251979, 1.142616836498983],
            [34.18233567800262, 1.142518142954154],
            [34.18196470433301, 1.145834182051083],
            [34.17940884733105, 1.150511704631056],
            [34.17719200014423, 1.152896483404507],
            [34.17601812754503, 1.15477633802696],
            [34.17495808317041, 1.154234712680462],
            [34.17326299367031, 1.15561786232572],
            [34.1699510606263, 1.160286679411147],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 981,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "NAKALOKE TOWN COUNCIL",
        Population: 28047,
        Key: "MBALENAKALOKE TOWN COUNCIL",
        Dist2: "Mbale",
        "Sub Country": "Nakaloke T.C.",
        id2_original: "Mbale Nakaloke T.C.",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "VL",
        heatwave: "L",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.25345848537067, 1.007749406676821],
            [34.25057149408363, 1.008600772647012],
            [34.24566569370573, 1.011569489411694],
            [34.243540593255545, 1.013297942853395],
            [34.24118599391149, 1.014112921418644],
            [34.240714757476404, 1.016971385896745],
            [34.2384930378275, 1.018672744849496],
            [34.23601673383046, 1.019949079406955],
            [34.235038617606385, 1.017651974314599],
            [34.23313109181296, 1.015581354785549],
            [34.23257583145776, 1.013130313790962],
            [34.22941239352348, 1.012254138717364],
            [34.22894182723156, 1.010978940906238],
            [34.22674441509592, 1.008664197351909],
            [34.22691368194997, 1.007741517994037],
            [34.227613890866195, 1.007352306726543],
            [34.227662550808496, 1.006818619219714],
            [34.226527582447595, 1.005552716307693],
            [34.22608096074958, 1.003716701106917],
            [34.22658826633999, 1.002622034585182],
            [34.22616276223767, 1.001681489657802],
            [34.22660614371246, 1.001586395958258],
            [34.22266963900087, 0.998785325075648],
            [34.221797132314855, 0.99753136124869],
            [34.22082911225626, 0.997558859901153],
            [34.22187157031257, 0.995702644657134],
            [34.22321768678267, 0.995647941025716],
            [34.22425828442799, 0.99452741680727],
            [34.225926277145874, 0.991238657393663],
            [34.22628461331609, 0.98952219022594],
            [34.22400718733978, 0.988929096797502],
            [34.22233302678916, 0.987656017718006],
            [34.22181144427398, 0.9847113380857],
            [34.218639399580944, 0.985656496418531],
            [34.21792584080133, 0.985363176093153],
            [34.215438965429996, 0.982577297717812],
            [34.214096154760156, 0.979361908126089],
            [34.21457566288242, 0.977663457814845],
            [34.21533361550507, 0.976637894417409],
            [34.21335472754545, 0.976439880594045],
            [34.21130831142933, 0.975627621409421],
            [34.20967872707975, 0.973500848766506],
            [34.20933259811592, 0.971762046283427],
            [34.206327555624114, 0.971894804471316],
            [34.206377628616394, 0.969425332643436],
            [34.20559266634808, 0.965035365039291],
            [34.209240605240964, 0.960740098614981],
            [34.20959432137564, 0.960329126825027],
            [34.212181207984145, 0.960427193804821],
            [34.21237125556568, 0.961028078653993],
            [34.213775126522, 0.962067783370146],
            [34.21507027976943, 0.963767831307835],
            [34.21692799128541, 0.96493400274068],
            [34.218491032032, 0.965032936339276],
            [34.220239672801135, 0.965873513434485],
            [34.221609474252, 0.965863971088946],
            [34.22337442034185, 0.96519398142006],
            [34.22507239433232, 0.965699898249199],
            [34.22623279849047, 0.967508525327814],
            [34.22920066330594, 0.969732569068202],
            [34.23047016516041, 0.971921049467575],
            [34.232521646876435, 0.973105218635432],
            [34.233202892357, 0.97463360974335],
            [34.23377411487649, 0.974769076745036],
            [34.234043597783625, 0.976044353201345],
            [34.233346241916756, 0.976542098517881],
            [34.23400180097008, 0.976930800546441],
            [34.234163412381264, 0.981154857268247],
            [34.2350041986563, 0.982773637863317],
            [34.23391262521181, 0.984908717302853],
            [34.23451772589564, 0.985532611021083],
            [34.23548985844158, 0.988453850979365],
            [34.23759709499406, 0.988498284921392],
            [34.23826785713522, 0.988986473528077],
            [34.23951287540664, 0.988705603190768],
            [34.24183947965315, 0.989654470775119],
            [34.242605109278216, 0.990545664087544],
            [34.24276432488255, 0.992970549021643],
            [34.24582360495627, 0.997024782785123],
            [34.24992885999062, 1.000885497267021],
            [34.25050799037955, 1.002612900117497],
            [34.25345848537067, 1.007749406676821],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 982,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "NYONDO",
        Population: 8578,
        Key: "MBALENYONDO",
        Dist2: "Mbale",
        "Sub Country": "Nyndo",
        id2_original: "Mbale Nyndo",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.183348359602185, 1.07048600745394],
            [34.17652836882979, 1.07502313168983],
            [34.17612233121967, 1.075976334067248],
            [34.174142755150555, 1.077439310932857],
            [34.17072834948547, 1.079217365602008],
            [34.173709638724524, 1.088446431874077],
            [34.171982020329665, 1.089993877579159],
            [34.171475973278994, 1.091459434352685],
            [34.17066181217069, 1.09208388904216],
            [34.169385041148935, 1.091767800557314],
            [34.16706242452398, 1.092808935717442],
            [34.166391012002514, 1.09221219994795],
            [34.164657202418724, 1.092294287453544],
            [34.163698311040065, 1.091932845001814],
            [34.1634054701389, 1.091372142031619],
            [34.1622961666457, 1.091300211705712],
            [34.162274031258754, 1.090703220561486],
            [34.16132665897698, 1.091083498315228],
            [34.160797733632656, 1.090034430971112],
            [34.158242029344265, 1.08963742409008],
            [34.157801016726886, 1.089348139824324],
            [34.15766864547819, 1.088353190098741],
            [34.156831297954106, 1.088579651341907],
            [34.156522613466265, 1.087711405663799],
            [34.158019901127346, 1.08598314154649],
            [34.15616917850425, 1.084364717134464],
            [34.15588284949061, 1.084672373624225],
            [34.15511157305565, 1.084365124896576],
            [34.155089796994844, 1.084699815831121],
            [34.15400995734464, 1.083831865429274],
            [34.15299622920777, 1.084013165108239],
            [34.15299607469753, 1.083606117863254],
            [34.15253382950009, 1.08360629569787],
            [34.151453867678995, 1.082412705437389],
            [34.1505726392499, 1.082458270635822],
            [34.15004443615104, 1.083299703413125],
            [34.14929517472875, 1.083281899291994],
            [34.14887659933225, 1.08292024020376],
            [34.1484801530344, 1.08314652851004],
            [34.14777473388958, 1.081726655062107],
            [34.1459169415252, 1.082182744520319],
            [34.14679438175876, 1.078280443319642],
            [34.148509333009784, 1.077419996976344],
            [34.15138313972343, 1.077985122358801],
            [34.15176910986838, 1.073873645679826],
            [34.15126574339051, 1.072345374615951],
            [34.15196715245592, 1.071853405862317],
            [34.1531994730408, 1.068716967018142],
            [34.15911067866443, 1.066833675177729],
            [34.15983612215529, 1.065194485927796],
            [34.16078527489798, 1.0602894198502],
            [34.16470435678463, 1.059499908870636],
            [34.16518078368545, 1.058334944424526],
            [34.16897558994074, 1.055619943100111],
            [34.17111097699926, 1.053078372098333],
            [34.173164108022156, 1.051612016457658],
            [34.17607535561852, 1.050237695931127],
            [34.177977784371016, 1.050711782080503],
            [34.178184571159534, 1.050833890200815],
            [34.18066606562231, 1.05861198339116],
            [34.181300961627464, 1.063650022998512],
            [34.18032439679387, 1.06599222079929],
            [34.183348359602185, 1.07048600745394],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 983,
        District: "MBALE",
        County: "MBALE MUNICIPALITY",
        Subcounty: "INDUSTRIAL DIVISON",
        Population: 40395,
        Key: "MBALEINDUSTRIAL DIVISON",
        Dist2: "Mbale",
        "Sub Country": "Industrial\nDivision",
        id2_original: "Mbale Industrial\nDivision",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "VL",
        heatwave: "H",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.19240256648743, 1.08256859819444],
            [34.19234260124725, 1.082903299207192],
            [34.19111027706914, 1.082750016505436],
            [34.188724546608945, 1.084431099726029],
            [34.1854551694549, 1.071063702048384],
            [34.18443329719164, 1.069858927495878],
            [34.183348359602185, 1.07048600745394],
            [34.18032439679387, 1.06599222079929],
            [34.181300961627464, 1.063650022998512],
            [34.18066606562231, 1.05861198339116],
            [34.178184571159534, 1.050833890200815],
            [34.18123292053288, 1.051583497056704],
            [34.18468674337433, 1.050759046176857],
            [34.18701699388259, 1.052178276461401],
            [34.18868311630804, 1.051426870725774],
            [34.18993858827439, 1.051932928634686],
            [34.19167745537323, 1.051959394829827],
            [34.19322297897179, 1.053098513416035],
            [34.19491292382024, 1.057376309885821],
            [34.19556523726045, 1.058009230434897],
            [34.19690517242309, 1.057610714074551],
            [34.1999484130774, 1.058242701385461],
            [34.20052788123289, 1.057853525941793],
            [34.201249952448165, 1.058775866508586],
            [34.202121713532485, 1.059001659015833],
            [34.20386028328896, 1.058268307087694],
            [34.206826921005714, 1.058348551579388],
            [34.207772297230946, 1.05868285645234],
            [34.20806230215074, 1.059189279630707],
            [34.208061931146545, 1.059677726020957],
            [34.20614206609435, 1.062147850102254],
            [34.20594878637446, 1.063405223956766],
            [34.20677269240697, 1.06908535320418],
            [34.20244063701791, 1.071773529068919],
            [34.20201799045649, 1.072470186235418],
            [34.201685414375376, 1.076567849358058],
            [34.19240256648743, 1.08256859819444],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 984,
        District: "MBALE",
        County: "MBALE MUNICIPALITY",
        Subcounty: "WANALE DIVISION",
        Population: 14554,
        Key: "MBALEWANALE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.243184477720725, 1.074736452482574],
            [34.241943924974606, 1.075824326399229],
            [34.24091922840811, 1.077498791343588],
            [34.23905331347693, 1.078300953614769],
            [34.2380164115007, 1.080420892516029],
            [34.23837862659628, 1.083074621340175],
            [34.23623579070743, 1.085119395772538],
            [34.232810910686126, 1.087298264944969],
            [34.23196655360786, 1.08911042118923],
            [34.22889970792282, 1.088460428693444],
            [34.227555831851056, 1.090138737935601],
            [34.22596556855809, 1.090976210415527],
            [34.22289824047773, 1.094695068470336],
            [34.22260830293158, 1.095762528319249],
            [34.21866503210926, 1.096145870821093],
            [34.2176214304976, 1.097157549612906],
            [34.21658353228969, 1.097230337532113],
            [34.215182542230465, 1.098035941659022],
            [34.212651812903644, 1.096993217689397],
            [34.211245686277614, 1.094627478989495],
            [34.20797430408384, 1.092403667102264],
            [34.20703254986584, 1.089925635035514],
            [34.20508849048813, 1.089456064572448],
            [34.202794565154996, 1.087675060987555],
            [34.201949471458214, 1.08532361716587],
            [34.201031910667446, 1.084347089955998],
            [34.199502669931746, 1.083800505464285],
            [34.203154542547246, 1.083052368657026],
            [34.20483623547149, 1.082053190141666],
            [34.20442227741553, 1.080708925606688],
            [34.20642442635112, 1.078972012743605],
            [34.20698280116542, 1.079216012979163],
            [34.207179082156685, 1.079885287270688],
            [34.20886984087877, 1.07897103375355],
            [34.20950391672208, 1.078907462270908],
            [34.209835482198486, 1.079395775291057],
            [34.21167728724576, 1.078391008143207],
            [34.21264287915813, 1.078698159576656],
            [34.21297512555755, 1.079484965761154],
            [34.21454466381858, 1.078824028065968],
            [34.214152415348074, 1.07827242368287],
            [34.215510948332046, 1.076634681198351],
            [34.21569232986599, 1.075142137512258],
            [34.21683904010595, 1.074716548419644],
            [34.21757889706553, 1.073730316803504],
            [34.21800170891696, 1.073458788496024],
            [34.220265315210916, 1.073910140513531],
            [34.221231482943395, 1.072851456044154],
            [34.22274054841612, 1.072669942836953],
            [34.22548763697917, 1.070081893584592],
            [34.226574379284024, 1.069991003523751],
            [34.22781245896817, 1.070542262712891],
            [34.22826503380155, 1.070270722446642],
            [34.22886873940172, 1.06871469916661],
            [34.229653831027434, 1.068506341536074],
            [34.23036330965905, 1.068822637221047],
            [34.23187261408366, 1.067854188159545],
            [34.232295104338185, 1.06678668077429],
            [34.2333516749276, 1.065691782734481],
            [34.233381936474586, 1.064117902608207],
            [34.23383486344757, 1.063321740829102],
            [34.235464976904844, 1.062507013860381],
            [34.236008330090975, 1.061719861119513],
            [34.23929879968791, 1.061293407933177],
            [34.239434100342734, 1.061479266217051],
            [34.23986481287706, 1.063807742672002],
            [34.23970780173845, 1.06722689030949],
            [34.24069749724651, 1.070238536934362],
            [34.243184477720725, 1.074736452482574],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 985,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "LWASSO",
        Population: 8962,
        Key: "MBALELWASSO",
        Dist2: "Mbale",
        "Sub Country": "Lwaso",
        id2_original: "Mbale Lwaso",
        drought: "VL",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.25826908139645, 1.038645710913934],
            [34.25486869483967, 1.040781729891412],
            [34.25121407248109, 1.048006437472879],
            [34.25214072152757, 1.054558593789759],
            [34.25298784990851, 1.056421550622629],
            [34.25000602257856, 1.059569396946176],
            [34.248656070302225, 1.059489621326503],
            [34.24717690525369, 1.058549525207939],
            [34.244973361217966, 1.059337348783761],
            [34.24349404974404, 1.059437445316346],
            [34.240777612596816, 1.061347080248554],
            [34.239434100342734, 1.061479266217051],
            [34.23929879968791, 1.061293407933177],
            [34.234906982077916, 1.057541417263674],
            [34.229745326235744, 1.054196749890254],
            [34.229699972093684, 1.053120385494779],
            [34.23047300024346, 1.050804499573443],
            [34.22576414381351, 1.047721940098751],
            [34.2237725141499, 1.041779995737865],
            [34.22184059819818, 1.039175717825508],
            [34.219359288788375, 1.037729443218437],
            [34.21814554716023, 1.036156037605424],
            [34.2183142911948, 1.035350943605144],
            [34.219485547899886, 1.03451832411769],
            [34.22197615217792, 1.033848008053694],
            [34.225148782572504, 1.032245764783361],
            [34.22885178729399, 1.027738542256359],
            [34.22919399780654, 1.027224085266167],
            [34.23063069859325, 1.027332069659026],
            [34.23140391808416, 1.026942823929721],
            [34.23601673383046, 1.019949079406955],
            [34.2384930378275, 1.018672744849496],
            [34.240714757476404, 1.016971385896745],
            [34.24118599391149, 1.014112921418644],
            [34.243540593255545, 1.013297942853395],
            [34.24566569370573, 1.011569489411694],
            [34.25057149408363, 1.008600772647012],
            [34.25345848537067, 1.007749406676821],
            [34.25703203028329, 1.014830359839003],
            [34.257404934432465, 1.017688476089232],
            [34.25946712945657, 1.018881622231157],
            [34.260269855011316, 1.020735556373814],
            [34.262906300775725, 1.024045025693831],
            [34.26566802738631, 1.028855923084762],
            [34.26362580909749, 1.031335101614512],
            [34.26125318236235, 1.033389294226294],
            [34.26048290665062, 1.035515206965722],
            [34.25826908139645, 1.038645710913934],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 986,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "WANALE",
        Population: 13300,
        Key: "MBALEWANALE",
        Dist2: "Mbale",
        "Sub Country": "Wanale\nDivision",
        id2_original: "Mbale Wanale\nDivision",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.188724546608945, 1.084431099726029],
            [34.189932548900735, 1.085762589063711],
            [34.18899654659549, 1.086459454092428],
            [34.18902701744994, 1.086821256462191],
            [34.1911466435668, 1.097863534513756],
            [34.18933982700155, 1.098393594977147],
            [34.17876188515498, 1.103773724593839],
            [34.1715308226136, 1.106798600410684],
            [34.17077320236761, 1.106927387600409],
            [34.170604020853524, 1.106619910331178],
            [34.17055563759232, 1.104982707804977],
            [34.16987935260877, 1.104865386291678],
            [34.16925163593935, 1.105426452276389],
            [34.16832886671657, 1.104570658024792],
            [34.1673196166814, 1.104233221871641],
            [34.16681260753503, 1.104667603258725],
            [34.16666751883686, 1.104206343880759],
            [34.16584680002698, 1.103871987437699],
            [34.16596741322693, 1.103501076305953],
            [34.165001758432496, 1.103094413416965],
            [34.16475998675522, 1.102434191343987],
            [34.16509807849218, 1.10236169455195],
            [34.16524325702189, 1.101610865225218],
            [34.164071940129666, 1.100960055429613],
            [34.16221279849574, 1.097948651325712],
            [34.162333336237204, 1.095931468722869],
            [34.16371019754789, 1.095080656486773],
            [34.16328739288302, 1.093950141666058],
            [34.16357748853265, 1.093217346911018],
            [34.16294934067193, 1.092665819700687],
            [34.163698311040065, 1.091932845001814],
            [34.164657202418724, 1.092294287453544],
            [34.166391012002514, 1.09221219994795],
            [34.16706242452398, 1.092808935717442],
            [34.169385041148935, 1.091767800557314],
            [34.17066181217069, 1.09208388904216],
            [34.171475973278994, 1.091459434352685],
            [34.171982020329665, 1.089993877579159],
            [34.173709638724524, 1.088446431874077],
            [34.17072834948547, 1.079217365602008],
            [34.174142755150555, 1.077439310932857],
            [34.17612233121967, 1.075976334067248],
            [34.17652836882979, 1.07502313168983],
            [34.183348359602185, 1.07048600745394],
            [34.18443329719164, 1.069858927495878],
            [34.1854551694549, 1.071063702048384],
            [34.188724546608945, 1.084431099726029],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 987,
        District: "MBALE",
        County: "MBALE MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 37908,
        Key: "MBALENORTHERN DIVISION",
        Dist2: "Mbale",
        "Sub Country": "Nothern\nDivision",
        id2_original: "Mbale Nothern\nDivision",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32365196132282, 1.101654306907821],
            [34.323054181010235, 1.102301770946618],
            [34.322353312730606, 1.101896858386528],
            [34.32141606625872, 1.102076692093747],
            [34.32086329872843, 1.103001846607336],
            [34.32037728500689, 1.101987450200587],
            [34.31908574568188, 1.102804979562287],
            [34.31784169309941, 1.101536956522476],
            [34.31694910816847, 1.101519967130806],
            [34.31589907282277, 1.100730460579614],
            [34.31513428222416, 1.101726856707873],
            [34.31597443339028, 1.102613458286813],
            [34.31527062672135, 1.10427880110928],
            [34.31417009258195, 1.103539984106538],
            [34.31337362199653, 1.104001264245324],
            [34.312674571008735, 1.103338888612905],
            [34.31113837282115, 1.103745299986854],
            [34.31049770963189, 1.103443543595416],
            [34.31058712703694, 1.104454116986171],
            [34.30957758684593, 1.105477984421245],
            [34.308070414123456, 1.105546575989504],
            [34.305743303227125, 1.104292232919265],
            [34.305683156527294, 1.105089058433415],
            [34.30487052075834, 1.105458455089257],
            [34.30142403086457, 1.104940621476668],
            [34.30096268398242, 1.106493813080688],
            [34.29969353426754, 1.106710909760358],
            [34.296995932995195, 1.104181863946037],
            [34.29599341134147, 1.104439307417309],
            [34.295559982301725, 1.105419280563837],
            [34.29416538465408, 1.105762732377529],
            [34.29403132906423, 1.104082122759982],
            [34.29336591639054, 1.103402707468303],
            [34.29198279382232, 1.103420882405546],
            [34.290707602937154, 1.104034002657151],
            [34.290703308990096, 1.103572210578741],
            [34.28898629790213, 1.102120232565989],
            [34.28730571529556, 1.101722984786606],
            [34.286145860906366, 1.100996828362154],
            [34.285496857758, 1.101183778161269],
            [34.28516925834354, 1.102368539345652],
            [34.28434426085795, 1.10244002841435],
            [34.28329965403152, 1.101878393337806],
            [34.28082368959764, 1.101845301031454],
            [34.28106586192352, 1.101650654134903],
            [34.280321419962725, 1.100727476926938],
            [34.27912299011861, 1.101092596238598],
            [34.27624405761796, 1.10100701607119],
            [34.27408108419537, 1.098742983475153],
            [34.27038736895224, 1.097370581045588],
            [34.26992841787696, 1.094991721552367],
            [34.26870523585352, 1.0922369952321],
            [34.26974081910294, 1.090460409508132],
            [34.26926785700416, 1.088968169917923],
            [34.26868133437874, 1.088552344791407],
            [34.26676139925799, 1.089311494286565],
            [34.26419141445153, 1.086721412308735],
            [34.2649889118113, 1.085766004743314],
            [34.266088500923054, 1.085255445470828],
            [34.26646471805899, 1.084448843664078],
            [34.265186755871184, 1.083791791568562],
            [34.26447966675822, 1.082284032158631],
            [34.26487672031717, 1.081747701532597],
            [34.26477385333565, 1.08070042366682],
            [34.26196250917868, 1.077544594627157],
            [34.26679311248245, 1.073692045412007],
            [34.26858704900316, 1.069792858044259],
            [34.26796323910692, 1.066093674235664],
            [34.268000958467375, 1.055648166968564],
            [34.26650225056985, 1.055713901708019],
            [34.26979822594115, 1.052023053092299],
            [34.27383151693809, 1.051610351261658],
            [34.27542165536522, 1.050830879554399],
            [34.27732789297455, 1.050569816441423],
            [34.27807597221392, 1.050773896424115],
            [34.279409503286885, 1.053196327916077],
            [34.2806797246919, 1.058452803939517],
            [34.28142547370142, 1.060082235547501],
            [34.284599387788546, 1.060484737630417],
            [34.28691495713011, 1.06417591927608],
            [34.28783224483303, 1.064820937549463],
            [34.29163315064911, 1.065529637923317],
            [34.29292679562515, 1.06674057465002],
            [34.29326470141084, 1.067759832036024],
            [34.296058092736885, 1.064914286027412],
            [34.29679878243474, 1.061480371853376],
            [34.3116216484777, 1.060096510028693],
            [34.313154089012464, 1.066192141287482],
            [34.31465521697137, 1.068624580583916],
            [34.31490634550062, 1.070134975656635],
            [34.315453153607315, 1.070948782687833],
            [34.31897515857883, 1.072421576132194],
            [34.32205020228916, 1.07670752080718],
            [34.32547958287002, 1.0795642037639],
            [34.32892698635044, 1.079951614274659],
            [34.33172754802908, 1.078105224714407],
            [34.33512597446189, 1.079532809624877],
            [34.33864283837505, 1.079206996391757],
            [34.338222516653616, 1.083964673745758],
            [34.336850768553504, 1.087337748672325],
            [34.33394567082357, 1.088486189523149],
            [34.333014192434106, 1.090557207902431],
            [34.33153959082722, 1.090552765639858],
            [34.330929065217425, 1.091043461375026],
            [34.330167658572506, 1.092508790404746],
            [34.33004755022576, 1.094147439509042],
            [34.327526356515655, 1.096711457042794],
            [34.32534352313878, 1.097507122376189],
            [34.324492578714526, 1.098278522172628],
            [34.324405223841346, 1.099660701444313],
            [34.323732493491406, 1.100359188000519],
            [34.32365196132282, 1.101654306907821],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 988,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUBYANGU",
        Population: 21039,
        Key: "MBALEBUBYANGU",
        Dist2: "Mbale",
        "Sub Country": "Bubyangu",
        id2_original: "Mbale Bubyangu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.225111609387746, 1.160163623773071],
            [34.22091947828228, 1.160605730584428],
            [34.21686481007652, 1.162951997133089],
            [34.21516642375934, 1.163490073198836],
            [34.21117684208918, 1.162895846927719],
            [34.209983029585615, 1.163072219947089],
            [34.20809778380784, 1.162496037925711],
            [34.20472953178543, 1.162478320507441],
            [34.20205222794693, 1.158953478932966],
            [34.19968671586881, 1.159097612871212],
            [34.19564608563602, 1.158473395264366],
            [34.195417702449745, 1.15097732789009],
            [34.195438310700695, 1.146517965872767],
            [34.19204219293817, 1.14035950922738],
            [34.1915900142618, 1.137537547670623],
            [34.191590177755174, 1.133828951953121],
            [34.19196744861494, 1.132055906584823],
            [34.19172605961999, 1.130988654773306],
            [34.192782797296026, 1.128862559266873],
            [34.19290352098876, 1.127406208109015],
            [34.1919073153898, 1.126465902427992],
            [34.19163574120468, 1.124367492447743],
            [34.190262086879564, 1.122007219282705],
            [34.188390806311226, 1.1210401328211],
            [34.18796796032382, 1.119855362060173],
            [34.18627753308006, 1.118879153337748],
            [34.18633827626126, 1.117694184111954],
            [34.18582542087901, 1.116147634790027],
            [34.18620272856973, 1.11442885989735],
            [34.18596100899475, 1.113913372014972],
            [34.184391548887135, 1.113452694280047],
            [34.183757755114854, 1.112846910237512],
            [34.18291220058229, 1.113607064857888],
            [34.18215746841994, 1.112549060809941],
            [34.180958759199754, 1.1136349917975],
            [34.18028591656038, 1.11369858140387],
            [34.17971274559502, 1.113002317307333],
            [34.179712414116686, 1.113581223412151],
            [34.17916882018206, 1.113816622879674],
            [34.178565392161296, 1.113301278593501],
            [34.17814269349765, 1.113880354389113],
            [34.177494566206676, 1.113952979334034],
            [34.17744826524028, 1.113337910364116],
            [34.17678438239756, 1.113338178011514],
            [34.17663365227941, 1.112822650419968],
            [34.176301243284925, 1.113057965522364],
            [34.17584876726618, 1.112207879398774],
            [34.17527494412396, 1.112696561517176],
            [34.17476191985846, 1.112117861812305],
            [34.17436934260456, 1.112181337386847],
            [34.17369033123414, 1.109431803885919],
            [34.173177044660555, 1.109612916995911],
            [34.172540240633765, 1.108866883812002],
            [34.171909460709244, 1.108401338230444],
            [34.171547412700264, 1.107542167802601],
            [34.17184424840949, 1.106827460590012],
            [34.1715308226136, 1.106798600410684],
            [34.17876188515498, 1.103773724593839],
            [34.18933982700155, 1.098393594977147],
            [34.1911466435668, 1.097863534513756],
            [34.18902701744994, 1.086821256462191],
            [34.18899654659549, 1.086459454092428],
            [34.189932548900735, 1.085762589063711],
            [34.188724546608945, 1.084431099726029],
            [34.19111027706914, 1.082750016505436],
            [34.19234260124725, 1.082903299207192],
            [34.19240256648743, 1.08256859819444],
            [34.194853076259385, 1.084060106255335],
            [34.196633916241574, 1.083661401974904],
            [34.199502669931746, 1.083800505464285],
            [34.201031910667446, 1.084347089955998],
            [34.201949471458214, 1.08532361716587],
            [34.202794565154996, 1.087675060987555],
            [34.20508849048813, 1.089456064572448],
            [34.20703254986584, 1.089925635035514],
            [34.20797430408384, 1.092403667102264],
            [34.211245686277614, 1.094627478989495],
            [34.212651812903644, 1.096993217689397],
            [34.214024778220946, 1.103074637976559],
            [34.21603961496157, 1.106312016289486],
            [34.217137750599186, 1.112055308632452],
            [34.217246210491645, 1.117663331056514],
            [34.21768217637376, 1.118940980672226],
            [34.2191867278122, 1.119824891636668],
            [34.22417855984486, 1.118506835800407],
            [34.22504641954588, 1.11897161815968],
            [34.22480468739451, 1.121133534338359],
            [34.227425154824985, 1.12200076881933],
            [34.22709927119274, 1.128506958305012],
            [34.22527639095359, 1.129991898522865],
            [34.225111609387746, 1.160163623773071],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 989,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "NAMANYONYI",
        Population: 30754,
        Key: "MBALENAMANYONYI",
        Dist2: "Mbale",
        "Sub Country": "Namanyonyi",
        id2_original: "Mbale Namanyonyi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.209240605240964, 0.960740098614981],
            [34.20559266634808, 0.965035365039291],
            [34.206377628616394, 0.969425332643436],
            [34.206327555624114, 0.971894804471316],
            [34.205485991408096, 0.975016023797726],
            [34.2032778264385, 0.979829588040132],
            [34.197874465394435, 0.990220155178613],
            [34.19604136142902, 0.98962141231468],
            [34.18836211322274, 0.989565703517799],
            [34.18267497527869, 0.986383777052978],
            [34.18179047967691, 0.985027285482911],
            [34.1750248028432, 0.984477930055207],
            [34.173111683240485, 0.983963020746429],
            [34.172270089380056, 0.983221594997628],
            [34.16964348915113, 0.982137072957191],
            [34.16640559615116, 0.983621668144846],
            [34.16566616678966, 0.984336519272774],
            [34.16552350174613, 0.98529454687022],
            [34.160884752535885, 0.986001156817042],
            [34.15712310219943, 0.987379543868603],
            [34.153885555050834, 0.987862648032715],
            [34.14962248039409, 0.989837932380645],
            [34.14738862630237, 0.991674800514568],
            [34.144515733175375, 0.991744653825931],
            [34.141574186302776, 0.991080097032963],
            [34.13831419923839, 0.992687812603144],
            [34.133206983099086, 0.993309264503086],
            [34.13131477537787, 0.994113211212865],
            [34.13101740427273, 0.991313271072691],
            [34.12971765973594, 0.991061246910425],
            [34.12957079506844, 0.991477227692408],
            [34.129104604470285, 0.98748315723255],
            [34.12390788109435, 0.986844626207214],
            [34.1244565648834, 0.981172464360795],
            [34.12561245770219, 0.979089653258777],
            [34.12654523415723, 0.974793686123524],
            [34.12625936957256, 0.973166480290536],
            [34.12527718757352, 0.971374813091201],
            [34.1257426685026, 0.966964772625852],
            [34.127555030368114, 0.96336402922168],
            [34.128728869729656, 0.95447801260555],
            [34.12871658257319, 0.953913597645394],
            [34.12993734273865, 0.954281488488102],
            [34.129747653584964, 0.954724784187395],
            [34.13019137102963, 0.954787955726298],
            [34.13025502744731, 0.955366850270489],
            [34.13139557524442, 0.954923239389131],
            [34.132346122172414, 0.955682750109367],
            [34.13285309808112, 0.955112710878278],
            [34.13317000934031, 0.955555837610576],
            [34.133740011947644, 0.955365691604858],
            [34.13393061828124, 0.955998816084356],
            [34.134183833596914, 0.955745456368067],
            [34.13500784563062, 0.955998456808267],
            [34.13728870586626, 0.954405680414432],
            [34.1384930088957, 0.954848509038624],
            [34.13874614066805, 0.954341874745864],
            [34.13937996588139, 0.955237170435314],
            [34.14001390967232, 0.954784681821736],
            [34.14064761001984, 0.955300064423978],
            [34.140647230032464, 0.954151282272215],
            [34.14115447363911, 0.954404387019873],
            [34.14172426334573, 0.953572008486869],
            [34.14210464147805, 0.954024156845719],
            [34.14267518307458, 0.953770690997388],
            [34.142738182823756, 0.952359569152717],
            [34.14299158948057, 0.952685123025729],
            [34.143941882185345, 0.952684804167875],
            [34.14413217051537, 0.952359102093322],
            [34.1436247382625, 0.951536129824674],
            [34.14571587880168, 0.950323330497995],
            [34.14717330911191, 0.950259523855683],
            [34.147870046039515, 0.949490421944803],
            [34.147933070043244, 0.948151666601808],
            [34.14888319206811, 0.947644799592172],
            [34.14932637771016, 0.94610691599054],
            [34.15059380176135, 0.945536626379197],
            [34.151417281094105, 0.944197617117071],
            [34.15116308481818, 0.943175561003642],
            [34.15223966987209, 0.94125755702063],
            [34.152683319943144, 0.941130772434675],
            [34.15319087526522, 0.94234269833837],
            [34.15388784485647, 0.942279147534475],
            [34.15496544051512, 0.943427562674432],
            [34.15572566407882, 0.942730806056243],
            [34.156042594202624, 0.94323724624313],
            [34.157246591804885, 0.942793614045703],
            [34.15838606701356, 0.939156951718218],
            [34.157308811816414, 0.939030675434159],
            [34.157181251046076, 0.937113077853023],
            [34.15895595014498, 0.936922530241328],
            [34.15971606411421, 0.935900138767968],
            [34.15971583234886, 0.935194591804793],
            [34.16047626162677, 0.935131020212504],
            [34.16205947853464, 0.93334853524194],
            [34.16313758802962, 0.934370312194332],
            [34.164151037688725, 0.933474473110727],
            [34.16655981891914, 0.935002347397247],
            [34.16814351373073, 0.934685225927427],
            [34.16820721326755, 0.935390748741745],
            [34.1675103748303, 0.935834209425386],
            [34.16827101341564, 0.936403816198046],
            [34.17118581474729, 0.936212880527413],
            [34.1711855407611, 0.93538974635548],
            [34.1723252998374, 0.932639552165573],
            [34.173339690032634, 0.93290152816586],
            [34.17321316501982, 0.934113658114201],
            [34.17429077505152, 0.935325380761801],
            [34.174670951961225, 0.935189570891245],
            [34.17473405860992, 0.934113144346149],
            [34.175430952742715, 0.933850592692494],
            [34.175684567808666, 0.934809320650706],
            [34.1786627452836, 0.93270073280449],
            [34.179002095560264, 0.931398080321477],
            [34.178575536835815, 0.9305479560049],
            [34.17869321703635, 0.929760965751894],
            [34.18010994737598, 0.928991628491425],
            [34.180108113016175, 0.928539359223098],
            [34.18228026542434, 0.927869267131726],
            [34.18276562876561, 0.928221873401644],
            [34.183831708022296, 0.926873750700067],
            [34.1851629564761, 0.927452205269448],
            [34.18654993730849, 0.926746196737919],
            [34.18729984461947, 0.925470544589044],
            [34.18833015924975, 0.926347597200781],
            [34.187990339154176, 0.924556728502943],
            [34.18887012848219, 0.92540669617654],
            [34.18950354765701, 0.925126074822651],
            [34.1898924804458, 0.924302815011258],
            [34.19194813932789, 0.924636796595894],
            [34.19155862622745, 0.925396739650409],
            [34.19244025979673, 0.926726108544566],
            [34.1951007166304, 0.925587991174255],
            [34.19560847856497, 0.927991511808218],
            [34.19456180830829, 0.934612460393984],
            [34.192593348890824, 0.937584952718079],
            [34.18919349862828, 0.939831092514676],
            [34.18643981912603, 0.940501520944127],
            [34.18265689488697, 0.93989609574354],
            [34.178811837772976, 0.939970637795718],
            [34.17790795652737, 0.940650887952188],
            [34.177970968852975, 0.942613301661395],
            [34.17503015320904, 0.943085035664969],
            [34.173305330371356, 0.943912023967887],
            [34.17278648322617, 0.946165446724881],
            [34.17150363779647, 0.947173648236711],
            [34.171072610851795, 0.948645237598734],
            [34.16977439255264, 0.957134007106173],
            [34.1692662075116, 0.957387271511775],
            [34.16943322408585, 0.958989408350241],
            [34.168619465422786, 0.95924392738928],
            [34.16743365151851, 0.961103991784492],
            [34.16338427708471, 0.965534450276155],
            [34.16128279963156, 0.96623468275105],
            [34.15930020432476, 0.967651436790378],
            [34.157995652004566, 0.969272695689598],
            [34.15816576327495, 0.971064054129044],
            [34.158810043979884, 0.971660969809125],
            [34.15980993087488, 0.971285276501808],
            [34.16025052218239, 0.971029208094356],
            [34.16028422966678, 0.970466180876811],
            [34.159676363968515, 0.96947738166438],
            [34.16743464685185, 0.965582630862271],
            [34.171410395364944, 0.964406474495397],
            [34.17436594697279, 0.962202396696666],
            [34.17699646385633, 0.96081973923613],
            [34.18031344633056, 0.959805303796396],
            [34.18367639829282, 0.959412633400287],
            [34.18781853186451, 0.957584735856213],
            [34.19631592880066, 0.957614652762821],
            [34.20216444459392, 0.958408576124209],
            [34.20348112686541, 0.958192075595508],
            [34.206349877860625, 0.960339501807402],
            [34.209240605240964, 0.960740098614981],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 990,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUSOBA",
        Population: 20796,
        Key: "MBALEBUSOBA",
        Dist2: "Mbale",
        "Sub Country": "Busoba",
        id2_original: "Mbale Busoba",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.195846479114664, 0.843195763101459],
            [34.19462819560443, 0.849532297953766],
            [34.18862856880736, 0.858276941630894],
            [34.189475915478894, 0.867559057392835],
            [34.19026159100953, 0.868504812856597],
            [34.19153758588687, 0.872306615734551],
            [34.19248895656999, 0.882956986030172],
            [34.194715940346455, 0.887373618893377],
            [34.19713213177959, 0.894075640528677],
            [34.1995471365383, 0.897082977311442],
            [34.20190170444129, 0.898837232682022],
            [34.204020746653214, 0.898940236106356],
            [34.20608051173447, 0.898371440736225],
            [34.20723800085951, 0.899990151047752],
            [34.21085010415907, 0.90038661308723],
            [34.21392531315943, 0.898567652684839],
            [34.214008865463995, 0.897245277594326],
            [34.213162320988005, 0.895272917381363],
            [34.21378272537101, 0.894051299148281],
            [34.21519956530509, 0.89427416109652],
            [34.21660191451536, 0.895176281233601],
            [34.21728748807894, 0.897752546995012],
            [34.217288903823835, 0.902011140171299],
            [34.21856145635702, 0.90476771721567],
            [34.217421244529824, 0.907746658380117],
            [34.21729169309278, 0.910339600233789],
            [34.21841736119554, 0.91259569407846],
            [34.21978700364462, 0.91315318964145],
            [34.22083082624182, 0.914432871032021],
            [34.222465242629326, 0.926484355010599],
            [34.221601846656945, 0.928421117831116],
            [34.21967824191824, 0.92888129394484],
            [34.21930352047723, 0.929587085584697],
            [34.217137364323605, 0.929595152292438],
            [34.21716678235255, 0.929919645723268],
            [34.2165353718107, 0.929928538771462],
            [34.21069567927017, 0.92317106599063],
            [34.20584707732136, 0.918434557602884],
            [34.20148291704236, 0.91670724697042],
            [34.19710634563938, 0.91591476115769],
            [34.19164798614032, 0.913829229691777],
            [34.18469976355606, 0.907466985940996],
            [34.178859214921054, 0.903729561136767],
            [34.1735780409253, 0.898770236487498],
            [34.17009084117946, 0.894355845733551],
            [34.163766463525725, 0.889294357991752],
            [34.15936379786038, 0.886452806938765],
            [34.15782382674858, 0.884450419236049],
            [34.158356869071866, 0.880333089585198],
            [34.15653662808302, 0.877060424119558],
            [34.153002498550116, 0.872743732872729],
            [34.15325126540849, 0.872556725322906],
            [34.160639649007244, 0.869623699313324],
            [34.170073312353324, 0.864491994361686],
            [34.17569234362577, 0.860935392443524],
            [34.17961338653469, 0.857121062452654],
            [34.18014948223164, 0.85407758445235],
            [34.180222922201054, 0.849970948264354],
            [34.18073196782817, 0.848849161099312],
            [34.18017622148437, 0.84227332273831],
            [34.18216998734172, 0.838663598507229],
            [34.18228409943394, 0.837143937327565],
            [34.18419155066721, 0.83366291973345],
            [34.18356801296052, 0.829862003033311],
            [34.18306907427868, 0.829244075399071],
            [34.18395721973546, 0.829242174763025],
            [34.1841999005078, 0.829834434832431],
            [34.185516033010344, 0.830465858143864],
            [34.18629344404035, 0.831498393500353],
            [34.18839479303444, 0.832157607489355],
            [34.19154831985618, 0.834924672794073],
            [34.19223363919655, 0.836212153154217],
            [34.19129499225111, 0.839213351642761],
            [34.194009432443444, 0.840625752144137],
            [34.194353620147936, 0.84134519553596],
            [34.19511690876338, 0.841702028062796],
            [34.195846479114664, 0.843195763101459],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 991,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUMASIKYE",
        Population: 12268,
        Key: "MBALEBUMASIKYE",
        Dist2: "Mbale",
        "Sub Country": "Bumasikye",
        id2_original: "Mbale Bumasikye",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.75845330061774, 0.628041878556293],
            [32.75739412491401, 0.628003055702007],
            [32.75667277145267, 0.626810054041501],
            [32.75470040077044, 0.628265833063137],
            [32.75181850742263, 0.633422837441027],
            [32.74957721528033, 0.633583889238377],
            [32.747816136437756, 0.635034248059733],
            [32.74623612561713, 0.63710000965477],
            [32.73791516588762, 0.623745849523674],
            [32.73443715860211, 0.617204514363306],
            [32.73360811151125, 0.611079487882983],
            [32.73321316180667, 0.60691773484856],
            [32.73176557613367, 0.602964016915222],
            [32.723287483094666, 0.593663026257875],
            [32.72039044504946, 0.589736378849342],
            [32.71769625557855, 0.584362183440618],
            [32.71416985245542, 0.580263607961781],
            [32.70614212619084, 0.574301069835346],
            [32.706962830627695, 0.572150872968353],
            [32.70696298962949, 0.569021523177264],
            [32.70689253027018, 0.565252074183393],
            [32.70566818762335, 0.560510572725823],
            [32.705880366998514, 0.555840266345474],
            [32.70724650691631, 0.550529921839787],
            [32.70915420788124, 0.54676057058939],
            [32.71165084434642, 0.538747655061517],
            [32.714170836110675, 0.534741254868189],
            [32.7221308401826, 0.529099303681952],
            [32.72410908944004, 0.527107984983947],
            [32.72827738015618, 0.526610318696339],
            [32.732092501811636, 0.524429418604944],
            [32.73388234920116, 0.52253291524652],
            [32.73557809536973, 0.518218266605894],
            [32.74066975268834, 0.512135193279171],
            [32.741159670488095, 0.509935178201182],
            [32.74121635687747, 0.505743734563748],
            [32.74178157954918, 0.504871330976803],
            [32.743703241231934, 0.50430243290139],
            [32.7464161444068, 0.504264609004765],
            [32.748789971291195, 0.503316410097436],
            [32.7573243770204, 0.50159084602753],
            [32.75928368889333, 0.501780577315139],
            [32.760564794286324, 0.501477171278424],
            [32.76356026702542, 0.502179017851856],
            [32.76608472970486, 0.503468788132682],
            [32.76815703077591, 0.505099926269591],
            [32.769965624208766, 0.505441377902955],
            [32.77850006497229, 0.502957149040027],
            [32.780044925614156, 0.502691679248978],
            [32.7830592512961, 0.503184894626518],
            [32.78658912640782, 0.507555164121642],
            [32.78973925220791, 0.509900437233453],
            [32.79533808396289, 0.511779420730722],
            [32.801532564328234, 0.513138749148083],
            [32.80383559857833, 0.515057596418795],
            [32.80509296419329, 0.517336182169048],
            [32.80477522738236, 0.519601393533097],
            [32.800863753327825, 0.522915279810262],
            [32.79924227896864, 0.524870551966425],
            [32.79512113992345, 0.526332659367396],
            [32.79409080912349, 0.528083915552161],
            [32.79225348397458, 0.529248159853654],
            [32.79261499119771, 0.529862507605342],
            [32.79238259074552, 0.531937368733295],
            [32.793360213794486, 0.532692740233938],
            [32.792478126575965, 0.534194220830967],
            [32.79133392353397, 0.536037064803351],
            [32.78960887701577, 0.536967306752138],
            [32.78901231931034, 0.537906685819734],
            [32.78695676822606, 0.538305075569331],
            [32.78568054787159, 0.540077032697729],
            [32.78717584845923, 0.540583190190664],
            [32.78891987098948, 0.543246458199418],
            [32.787277161355306, 0.544004753981111],
            [32.78742537439402, 0.544772280338104],
            [32.79085259991654, 0.546316698168092],
            [32.79284025633162, 0.549116353081498],
            [32.7939043071924, 0.54925241285056],
            [32.79414553898219, 0.550607912666835],
            [32.79552524795231, 0.550148422243014],
            [32.79537293500265, 0.55121643834357],
            [32.79667358504125, 0.552779947312598],
            [32.796752973654506, 0.553632740243521],
            [32.799122103248244, 0.558336483877424],
            [32.80116042644202, 0.560122079824599],
            [32.802404564364416, 0.562254095643383],
            [32.80595183086004, 0.563906494657168],
            [32.808982946054634, 0.56368007447221],
            [32.81131251743655, 0.564106546964573],
            [32.81335087386795, 0.565092650739729],
            [32.817837815880026, 0.570142909293719],
            [32.81863193198106, 0.572168310195172],
            [32.823185069948074, 0.577045346488469],
            [32.821664220375425, 0.58302005417079],
            [32.82252985674614, 0.585136564546483],
            [32.822921402734075, 0.587771805063503],
            [32.822673976162136, 0.590344775529003],
            [32.82138950747672, 0.591896340364504],
            [32.819451729119436, 0.590563597105487],
            [32.817265101258826, 0.591438573422896],
            [32.81476809378944, 0.59878734553912],
            [32.811272524440106, 0.6016836784671],
            [32.80889463178075, 0.602282034810158],
            [32.808716225467, 0.604173101960989],
            [32.80354644256646, 0.60758805150467],
            [32.80146577189191, 0.608461698364781],
            [32.797489767358954, 0.609009031636084],
            [32.7904704925273, 0.608431433134519],
            [32.780413404662234, 0.608906474077925],
            [32.77829549792083, 0.61115518370773],
            [32.775286059074034, 0.613064034275191],
            [32.773657561685944, 0.616487677853784],
            [32.770194685623075, 0.617649513916031],
            [32.76648433627582, 0.62171629968123],
            [32.763763467739324, 0.62337615718707],
            [32.761223944804144, 0.62605560412912],
            [32.75845330061774, 0.628041878556293],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1324,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "NABBAALE",
        Population: 36692,
        Key: "MUKONONABBAALE",
        Dist2: "Mukono",
        "Sub Country": "Nabbale",
        id2_original: "MukonoNabbale",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.27430554521626, 0.899211875659307],
            [32.26711337254016, 0.901030087536395],
            [32.261019773879525, 0.903316965927629],
            [32.2562650144369, 0.897730791571303],
            [32.252302185494194, 0.896134224615442],
            [32.24675287067432, 0.900122461053878],
            [32.238826845378014, 0.898525063405119],
            [32.22614750602837, 0.88495845477379],
            [32.24596715831277, 0.865813457721029],
            [32.24438463310767, 0.852089555528539],
            [32.22853367666304, 0.844107602479568],
            [32.217405820335536, 0.829733431668563],
            [32.20797376048223, 0.831236317844777],
            [32.20186859870726, 0.831216983643117],
            [32.18993471371971, 0.832227728871568],
            [32.19370044061097, 0.819907263429882],
            [32.195958204262304, 0.8165514916631],
            [32.198488659603015, 0.814597969730887],
            [32.20240884372251, 0.813332251754618],
            [32.203882092466564, 0.812038902182087],
            [32.20566419727666, 0.809641943873886],
            [32.20920451260862, 0.80782430223363],
            [32.209929674926784, 0.804721504191178],
            [32.20867173618664, 0.800704625303028],
            [32.20874323310009, 0.799845225330342],
            [32.20924269190649, 0.797710354775848],
            [32.21153617526848, 0.792409564415449],
            [32.21202942491964, 0.787214899494296],
            [32.22061859374521, 0.786419524398036],
            [32.23805578543705, 0.788018504923293],
            [32.24598014705347, 0.79759460369634],
            [32.24496828831069, 0.817379148460339],
            [32.262309516573964, 0.809960337888594],
            [32.266253851899926, 0.80888451686533],
            [32.26767409285568, 0.808749076992974],
            [32.27794260730767, 0.809872715089355],
            [32.28517968676481, 0.809647845216065],
            [32.28826990391861, 0.808697906865629],
            [32.288778954935616, 0.813480271111149],
            [32.292740917004046, 0.820661955971348],
            [32.295908550070706, 0.836620310412873],
            [32.29143071517901, 0.842775309923468],
            [32.28481043696223, 0.843799309867069],
            [32.28352501246937, 0.849832072323517],
            [32.281275561827634, 0.85036388560077],
            [32.28094899367914, 0.855571497947794],
            [32.2824863992025, 0.858333285727732],
            [32.28277703743455, 0.860048814828441],
            [32.28227692824789, 0.867077982036655],
            [32.28387303957336, 0.868685274438037],
            [32.28511353752225, 0.868651945381977],
            [32.29081108334717, 0.873812226647822],
            [32.290840588512665, 0.876476372876794],
            [32.290177886954524, 0.878909791424647],
            [32.28573098375302, 0.887467045052183],
            [32.28244247517835, 0.890632719534789],
            [32.277407377586655, 0.893734713882791],
            [32.272384962410186, 0.898003707563405],
            [32.27430554521626, 0.899211875659307],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1329,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "BUTALANGU TOWN COUNCIL",
        Population: 4096,
        Key: "NAKASEKEBUTALANGU TOWN COUNCIL",
        Dist2: "Nakaseke",
        "Sub Country": "Butalangu TC",
        id2_original: "NakasekeButalangu TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.317749244657726, 0.715079064279305],
            [32.31681888017922, 0.714913074828311],
            [32.31233555658113, 0.715572848570019],
            [32.30921890739843, 0.717333576847573],
            [32.30743259128627, 0.719185716098368],
            [32.30521290362657, 0.705396106063333],
            [32.30484777259955, 0.705655480326012],
            [32.30422807339406, 0.704362156047057],
            [32.30206928791734, 0.70508618561639],
            [32.296643921742046, 0.709553234485057],
            [32.28776729112727, 0.709800088757686],
            [32.28727321682267, 0.715757192739412],
            [32.28628619739583, 0.720473091636021],
            [32.279628739706084, 0.720472031707783],
            [32.27420374722994, 0.722705086161419],
            [32.27370911327496, 0.731889033374054],
            [32.26507898845896, 0.732383928756414],
            [32.25620110918588, 0.73982890349788],
            [32.24781599177881, 0.750004203002198],
            [32.23746095339525, 0.7440453514971],
            [32.22217412098277, 0.740567656759251],
            [32.20836575922108, 0.742799089769],
            [32.200808289329665, 0.745707400633347],
            [32.19907714774225, 0.742724048121256],
            [32.199581364026415, 0.742054703118972],
            [32.20149866349013, 0.741765566857055],
            [32.200195244843805, 0.74060738233224],
            [32.19840079718168, 0.737069893488263],
            [32.19728426225045, 0.736762111214739],
            [32.19583483592939, 0.735486297997985],
            [32.19530922447016, 0.730184986245605],
            [32.194915612357065, 0.729542618971941],
            [32.19481991033825, 0.727624755927068],
            [32.194154723141736, 0.727045664116032],
            [32.19306136025323, 0.724367720801307],
            [32.19374947964232, 0.722314302474694],
            [32.19372530957128, 0.720830682663346],
            [32.19213292984752, 0.71802600233558],
            [32.1905651325215, 0.717573400140376],
            [32.189376567975806, 0.714886397839411],
            [32.18956581515839, 0.711873970249266],
            [32.190752905568715, 0.710155358650048],
            [32.190396401961685, 0.709286837949525],
            [32.19044320957788, 0.706581963787917],
            [32.19111935352592, 0.703895291935265],
            [32.19050076463811, 0.700186145407208],
            [32.18957378141835, 0.698340511758807],
            [32.189275649440184, 0.69443240221798],
            [32.185307454860286, 0.689971827011485],
            [32.1793318184712, 0.684380108762865],
            [32.178547832671605, 0.683873374693052],
            [32.175626067599886, 0.684062842835152],
            [32.17372525940816, 0.681764727516622],
            [32.17169171704834, 0.682180508444422],
            [32.169902136458454, 0.67977385822841],
            [32.16712253517036, 0.677991237161949],
            [32.16671852056627, 0.677448384586239],
            [32.16662280956432, 0.675503396277491],
            [32.16697853612863, 0.672680987086421],
            [32.1711996361054, 0.667724292214905],
            [32.171663858494746, 0.665951278968207],
            [32.1716403630585, 0.663716816235119],
            [32.17243347394474, 0.663373186971698],
            [32.17333949497736, 0.661229344475681],
            [32.175061050642384, 0.658995174241223],
            [32.17797269080251, 0.65708686881034],
            [32.18091795849703, 0.653893974772046],
            [32.18168780032245, 0.651569172499371],
            [32.181596949206195, 0.650727841382516],
            [32.183057937743264, 0.648176991079078],
            [32.18545998699891, 0.64729083273264],
            [32.18552742173065, 0.645309676810638],
            [32.18625257865892, 0.644920798317351],
            [32.18690934953957, 0.643663451117197],
            [32.18720298455144, 0.640813874026899],
            [32.18802970770064, 0.63922183528105],
            [32.18952509003501, 0.637539437407194],
            [32.19133774115802, 0.636264177991905],
            [32.195167480199785, 0.635559160699921],
            [32.19693488408026, 0.634510051279595],
            [32.201432136056816, 0.630231779903475],
            [32.204784833750075, 0.625283881432226],
            [32.20684851458768, 0.624688979681813],
            [32.21155486651462, 0.63147766318732],
            [32.21368174652739, 0.636286972234947],
            [32.21472475974251, 0.641015296050503],
            [32.2147545451824, 0.643229141269446],
            [32.21327881708817, 0.646026111418781],
            [32.2104793055401, 0.649458276624147],
            [32.211521657595185, 0.65164304966211],
            [32.213006824288136, 0.652613163735599],
            [32.21581676707326, 0.653381428527195],
            [32.217301954427434, 0.654230307251561],
            [32.220031600402606, 0.655079382550485],
            [32.2253706815982, 0.655403513932288],
            [32.22597146497877, 0.656176552529171],
            [32.23401933865851, 0.651197537433278],
            [32.23608614204004, 0.651894437708199],
            [32.239577939363485, 0.652184460677496],
            [32.24302194182226, 0.650990841246402],
            [32.25043493297161, 0.651643313749743],
            [32.25104383263073, 0.651254402507356],
            [32.25456319296205, 0.651354442315046],
            [32.259104965444095, 0.652124078937409],
            [32.263956097947066, 0.651817214541261],
            [32.27445183855524, 0.652379643854746],
            [32.28285307263684, 0.645568749770734],
            [32.282187641098545, 0.644564478968173],
            [32.28520836548029, 0.641932337630191],
            [32.29178418068373, 0.639056428898104],
            [32.30205381263995, 0.638144136800829],
            [32.30293364778204, 0.63826186359663],
            [32.302813314856486, 0.63897050050416],
            [32.3025283494854, 0.642812282755712],
            [32.30291968436926, 0.645951530837867],
            [32.30275233541835, 0.649832528442472],
            [32.30635385117399, 0.653216487004124],
            [32.30931313168859, 0.65841874006354],
            [32.310345900516204, 0.663503120464815],
            [32.312240214786755, 0.668985679102681],
            [32.31340452212483, 0.671265609939331],
            [32.31239241185379, 0.677082485910804],
            [32.31437498200774, 0.687911657510667],
            [32.31682171436393, 0.697121546985424],
            [32.31646789132971, 0.700862386131462],
            [32.31917163977355, 0.702640033110726],
            [32.32075680782222, 0.705116960465833],
            [32.322997391193766, 0.712162114965218],
            [32.32184881066138, 0.715133978506797],
            [32.317749244657726, 0.715079064279305],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1330,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KAPEEKA",
        Population: 27833,
        Key: "NAKASEKEKAPEEKA",
        Dist2: "Nakaseke",
        "Sub Country": "Kapeeka",
        id2_original: "NakasekeKapeeka",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.463870478092105, 0.782960076475248],
            [32.46323641841848, 0.786560675955682],
            [32.46321662314288, 0.7898085248733],
            [32.462637187326756, 0.792287310006528],
            [32.46154762161695, 0.795553111830065],
            [32.45906909159463, 0.799958640056105],
            [32.45524675826408, 0.803757838885493],
            [32.45184416544497, 0.810578757133782],
            [32.45062170207374, 0.812017050162632],
            [32.44881678005542, 0.813238135761408],
            [32.444587786582254, 0.814721242956957],
            [32.44283058576678, 0.816105174881988],
            [32.43689162399747, 0.826571600550837],
            [32.43150271055812, 0.822047381387655],
            [32.43045383403911, 0.81932411705501],
            [32.42919623486215, 0.810982707933749],
            [32.42768292395137, 0.807598957085262],
            [32.42379129098653, 0.802794510187602],
            [32.42179047604916, 0.79906691270434],
            [32.41958897029078, 0.796524428376724],
            [32.41445105063339, 0.792968276521643],
            [32.41190773501109, 0.784617661613291],
            [32.410937102651665, 0.78276291826896],
            [32.40997947160934, 0.772241287769479],
            [32.41104517537024, 0.768993615730569],
            [32.40926868323403, 0.763827612515308],
            [32.40858573364938, 0.759204575364636],
            [32.40884417895661, 0.756653398135789],
            [32.40853372478769, 0.75545917038646],
            [32.40907776967659, 0.753043734436253],
            [32.40864826357968, 0.751659506809578],
            [32.408669102697644, 0.749153530807509],
            [32.40948369499728, 0.745901498443444],
            [32.41122893025318, 0.741355486143156],
            [32.41528517410394, 0.735005129883392],
            [32.41746177496937, 0.732463246209859],
            [32.41846130163993, 0.730310221885081],
            [32.418581038982445, 0.727370004367836],
            [32.42075784646039, 0.723145396279633],
            [32.42104363199332, 0.721833636868115],
            [32.42083005933113, 0.720657515551517],
            [32.42012860894322, 0.719879393458276],
            [32.420057725579085, 0.718522353491739],
            [32.41943970262991, 0.717608539478159],
            [32.41929717053705, 0.716523766797965],
            [32.418109119827726, 0.712704964449029],
            [32.416706959263685, 0.70973741271978],
            [32.41388996650017, 0.706308290382506],
            [32.412392088645994, 0.705177241838976],
            [32.410098025870646, 0.701793422865705],
            [32.4078048506308, 0.695822205674821],
            [32.407733949300344, 0.694600871566834],
            [32.40673544940417, 0.693189436105481],
            [32.40671212734276, 0.691036281165385],
            [32.40605896679125, 0.688159299788079],
            [32.4073199454303, 0.685906791531341],
            [32.40110377883566, 0.676949633457037],
            [32.40273649381403, 0.673907969601095],
            [32.40473188202876, 0.672670743404942],
            [32.40601419655414, 0.670788721672541],
            [32.40986076732935, 0.668207914991462],
            [32.411515721000896, 0.666380893467582],
            [32.413675727288066, 0.666900117792515],
            [32.41629152976727, 0.666511416136461],
            [32.423058534310975, 0.660577468765918],
            [32.42737587709234, 0.655955013758258],
            [32.428207962285484, 0.656380313899132],
            [32.431156781020285, 0.656525403853681],
            [32.43200964334767, 0.65698689379137],
            [32.4329603340061, 0.659094929147252],
            [32.434386823642996, 0.660741629461927],
            [32.43970141406901, 0.661312193271118],
            [32.441365760525144, 0.663148905250059],
            [32.442625842645526, 0.663655676507338],
            [32.44417167975614, 0.662941146023547],
            [32.44708478147524, 0.663647135000283],
            [32.44998535888266, 0.665873005061223],
            [32.45103125479153, 0.668071525869273],
            [32.461293545715264, 0.662970199188137],
            [32.46663085812807, 0.669258412379789],
            [32.46670213854756, 0.669756001955257],
            [32.46473960890929, 0.672252742975423],
            [32.46447736911828, 0.67419780713895],
            [32.46198030595334, 0.674912237175901],
            [32.45951836511935, 0.67800601341377],
            [32.459779739832754, 0.678820267458827],
            [32.4605643625379, 0.67931793779794],
            [32.46439276847977, 0.679897372376459],
            [32.4666278272123, 0.681553214390064],
            [32.46908762466601, 0.687732556230803],
            [32.47097745634328, 0.690048789083683],
            [32.47328388353021, 0.6914603727929],
            [32.474520028243234, 0.692699944873705],
            [32.47636005462622, 0.693378672128956],
            [32.480438506627436, 0.693297703917878],
            [32.48153244264108, 0.692917852145557],
            [32.48305426508915, 0.693677966159746],
            [32.48817875493308, 0.694700837727345],
            [32.48929615494195, 0.695515187735819],
            [32.49209067095872, 0.694646982294782],
            [32.49677552889583, 0.694122763097002],
            [32.498915995927305, 0.692856413669547],
            [32.499997772345246, 0.695950601390906],
            [32.500484442735264, 0.698954256215845],
            [32.50007934116969, 0.702726810128917],
            [32.49899042673848, 0.705992656246588],
            [32.495648791797905, 0.717319120494427],
            [32.4919136166095, 0.723968235972278],
            [32.49127056030828, 0.728202150883206],
            [32.49164928284555, 0.729468770865365],
            [32.49018407492162, 0.729649543058919],
            [32.48771097162194, 0.729224051881221],
            [32.4874257134001, 0.728482166368985],
            [32.486141634583525, 0.728834850562968],
            [32.48538044533087, 0.729630896444008],
            [32.48597458746653, 0.730798024921043],
            [32.48566526337822, 0.731756968444498],
            [32.48182419029252, 0.733412116494922],
            [32.479802414964645, 0.735375071474483],
            [32.47603271841815, 0.736650246971931],
            [32.47088316018792, 0.740747901236473],
            [32.46978875794861, 0.74256620672442],
            [32.469193708514545, 0.74433933630649],
            [32.46944258945895, 0.748600479940657],
            [32.46897069455873, 0.751486399280416],
            [32.46687299362301, 0.756416726166112],
            [32.46518425341533, 0.76545441273522],
            [32.46266005663726, 0.771533636752911],
            [32.46263049128463, 0.776581824705917],
            [32.463870478092105, 0.782960076475248],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1331,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KASANGOMBE",
        Population: 21757,
        Key: "NAKASEKEKASANGOMBE",
        Dist2: "Nakaseke",
        "Sub Country": "Kasangombe",
        id2_original: "NakasekeKasangombe",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.43689162399747, 0.826571600550837],
            [32.4336328478621, 0.834749523501019],
            [32.422044301320895, 0.855609911015986],
            [32.41901324092352, 0.865425299565132],
            [32.41697486293253, 0.87049122811364],
            [32.41558735029752, 0.872888429284368],
            [32.401076119708065, 0.892400152880056],
            [32.39898851673449, 0.895864745916291],
            [32.39581218707756, 0.903481647969008],
            [32.394959846671355, 0.906512191944624],
            [32.39460786518348, 0.910284659019545],
            [32.372716593649315, 0.909982336817479],
            [32.368894195640074, 0.903259904846155],
            [32.368109054607004, 0.902517931064792],
            [32.356292637817575, 0.899530408656903],
            [32.35058871754741, 0.899891257836766],
            [32.34704814080574, 0.900677686978843],
            [32.343361762103534, 0.898551034997515],
            [32.33815165832147, 0.898568179032836],
            [32.32577846212568, 0.896865114046097],
            [32.31902894778057, 0.897343326564167],
            [32.30479515557842, 0.900208416522292],
            [32.30068490411446, 0.901691274455726],
            [32.29245020151685, 0.902558144548699],
            [32.280863431843265, 0.902691549371922],
            [32.27773643406851, 0.90137011889091],
            [32.27430554521626, 0.899211875659307],
            [32.272384962410186, 0.898003707563405],
            [32.277407377586655, 0.893734713882791],
            [32.28244247517835, 0.890632719534789],
            [32.28573098375302, 0.887467045052183],
            [32.290177886954524, 0.878909791424647],
            [32.290840588512665, 0.876476372876794],
            [32.29081108334717, 0.873812226647822],
            [32.291423879898, 0.872152190774912],
            [32.2964357281918, 0.874550501973824],
            [32.30227259014089, 0.876134768260717],
            [32.304673001767746, 0.876162358585181],
            [32.306146409513616, 0.875755534887425],
            [32.307024791181576, 0.874851031565204],
            [32.30824845470203, 0.864058579602026],
            [32.30701556009374, 0.856142516618598],
            [32.31247860251033, 0.853040498429578],
            [32.311430794986535, 0.85126716059746],
            [32.30964632311568, 0.849502736749069],
            [32.309296145444875, 0.844545095601544],
            [32.31440944587362, 0.836992027764998],
            [32.3170119892192, 0.829935460449225],
            [32.32278495849369, 0.832453179521732],
            [32.32560590564106, 0.834662583893093],
            [32.32685132905264, 0.837798352083071],
            [32.32342422480269, 0.841873970405478],
            [32.321243600383106, 0.843127804824521],
            [32.318438299193055, 0.853788174922107],
            [32.319683695655186, 0.856923968977165],
            [32.31999451633673, 0.860686641085496],
            [32.329026804329025, 0.866332271640314],
            [32.33556804158056, 0.866960534473359],
            [32.34242044716168, 0.869470193114485],
            [32.34335496275514, 0.869156833034394],
            [32.34740360236701, 0.873860862966799],
            [32.349583161384665, 0.879191705273653],
            [32.35082881386667, 0.881073228306392],
            [32.355189821059014, 0.880446915150866],
            [32.364534607785835, 0.880762063520576],
            [32.3623546912387, 0.87762614909461],
            [32.36235581233618, 0.871355012969249],
            [32.367341165719004, 0.862576214162714],
            [32.37045648539509, 0.860068246791814],
            [32.37917814674189, 0.861323963337954],
            [32.38883401196675, 0.864147569169197],
            [32.394441026475654, 0.863834920033593],
            [32.393196344174186, 0.855682184098766],
            [32.39288690599984, 0.84282618679309],
            [32.38977224928041, 0.84063079025229],
            [32.38572381178948, 0.834358928944405],
            [32.37170742715747, 0.829339806915334],
            [32.367969498632654, 0.829464613848017],
            [32.37108580645559, 0.820685503789063],
            [32.367347812353785, 0.821312026052326],
            [32.36392106922658, 0.82350638242351],
            [32.35899918810677, 0.821616599085887],
            [32.359299936877385, 0.817621517099234],
            [32.35901363481319, 0.816599186462145],
            [32.353362927147195, 0.81166778880263],
            [32.34675225371745, 0.808780804124364],
            [32.34476481469466, 0.806328813157108],
            [32.34193078178854, 0.801171710796384],
            [32.333956461265906, 0.801116129378781],
            [32.328667162906726, 0.800264866536745],
            [32.32443556521755, 0.799214746646337],
            [32.31970365622079, 0.797259870842935],
            [32.31637547804317, 0.796616998904515],
            [32.314734631514874, 0.795874895958344],
            [32.31796292871099, 0.792482926400686],
            [32.332975280888405, 0.784795682022253],
            [32.33433673429537, 0.783529360234553],
            [32.33605995004699, 0.78025472116189],
            [32.33750868466528, 0.77935027869976],
            [32.33964710084291, 0.77891637504665],
            [32.34458758337728, 0.776121710333145],
            [32.347262733055736, 0.777252971604069],
            [32.349427247987336, 0.778782209682607],
            [32.35189898045789, 0.778664986772496],
            [32.3558342508843, 0.78004070391157],
            [32.366567310220866, 0.781987408515103],
            [32.37595429620644, 0.770626049506573],
            [32.380883961228164, 0.768826461495838],
            [32.38430687304069, 0.769089319009331],
            [32.3901088372376, 0.771306632395954],
            [32.401766074355315, 0.770367431752682],
            [32.40240983583399, 0.771941673827144],
            [32.405826452252995, 0.777180283924455],
            [32.40964546990187, 0.780844801152191],
            [32.410937102651665, 0.78276291826896],
            [32.41190773501109, 0.784617661613291],
            [32.41445105063339, 0.792968276521643],
            [32.41958897029078, 0.796524428376724],
            [32.42179047604916, 0.79906691270434],
            [32.42379129098653, 0.802794510187602],
            [32.42768292395137, 0.807598957085262],
            [32.42919623486215, 0.810982707933749],
            [32.43045383403911, 0.81932411705501],
            [32.43150271055812, 0.822047381387655],
            [32.43689162399747, 0.826571600550837],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1332,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KIKAMULO",
        Population: 18435,
        Key: "NAKASEKEKIKAMULO",
        Dist2: "Nakaseke",
        "Sub Country": "Kikamulo",
        id2_original: "NakasekeKikamulo",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.127104862000486, 1.397497321528444],
            [32.12617834770132, 1.398654893550862],
            [32.123898313017435, 1.40035473008598],
            [32.12010586843301, 1.404595981268025],
            [32.11767941105277, 1.406485720300997],
            [32.11557561055626, 1.407100059984097],
            [32.11300072723657, 1.406321099732662],
            [32.110883641555354, 1.40641979574126],
            [32.10781374339497, 1.409584785869964],
            [32.104296874091965, 1.410732291130798],
            [32.10072834088028, 1.41329097318627],
            [32.09482490658214, 1.41553211138178],
            [32.089792051185434, 1.41820778750711],
            [32.08481596302644, 1.422213250365573],
            [32.08272772853721, 1.423225582061189],
            [32.07572141909004, 1.423593652848965],
            [32.07068615710664, 1.42521991111061],
            [32.06363880363415, 1.430563272216996],
            [32.055874601751434, 1.433165332490604],
            [32.0525165411159, 1.43469271765298],
            [32.048950564509525, 1.437712607131846],
            [32.04695452501623, 1.441239725781324],
            [32.04475121993234, 1.442659023077689],
            [32.03767246225581, 1.443669169809819],
            [32.029034240025844, 1.445990287367971],
            [32.0249401995595, 1.446305127410842],
            [32.018867588238855, 1.449278612952758],
            [32.01170117116027, 1.451681693976897],
            [32.00462316537362, 1.456789513811982],
            [32.00335247594634, 1.457349795090004],
            [32.00083553755576, 1.457828104552074],
            [31.99865620401524, 1.457718576988989],
            [31.997730412859827, 1.458342329497185],
            [31.995272728243688, 1.462638029187585],
            [31.991852137677864, 1.461958040087998],
            [31.990007521802102, 1.463947299952734],
            [31.9892998487842, 1.46422740110191],
            [31.98815612005267, 1.464154513148317],
            [31.98668133518948, 1.463222116478947],
            [31.985245202138, 1.463158140466863],
            [31.9824740225557, 1.463735810356493],
            [31.980851542083393, 1.465191451715824],
            [31.9761553384242, 1.466663765684899],
            [31.975152559852347, 1.466102462088765],
            [31.97364107521654, 1.466210313535331],
            [31.970764709202637, 1.46525012395458],
            [31.9696102006877, 1.463585156358249],
            [31.966394640704, 1.460553313661942],
            [31.962056530669933, 1.459094922239432],
            [31.958329585846137, 1.459554521004156],
            [31.95824932047718, 1.460015819633712],
            [31.959202904609153, 1.461255540036247],
            [31.959311808269344, 1.462639598033056],
            [31.958745813046498, 1.46389670000043],
            [31.957799858306238, 1.464384729155752],
            [31.95694329851314, 1.46349783986026],
            [31.955986392411262, 1.460340409358871],
            [31.95410759743554, 1.459697278051782],
            [31.95301214506569, 1.458520812720467],
            [31.951320709912185, 1.457859676399869],
            [31.950669938879326, 1.457189983505076],
            [31.948524687420683, 1.456953785016837],
            [31.947006345046002, 1.457957149773685],
            [31.945951297101, 1.458092338372936],
            [31.941208527472433, 1.455937206269266],
            [31.938413016122347, 1.453972954735415],
            [31.936753876301594, 1.45395407643164],
            [31.93501639979482, 1.453274820192534],
            [31.93222539888576, 1.453689595168537],
            [31.929598747452868, 1.450459020952949],
            [31.929593213830714, 1.449681086579554],
            [31.93079514171456, 1.447175995450539],
            [31.930366241082186, 1.445981756090324],
            [31.929031174788385, 1.446107762159498],
            [31.926859421232205, 1.44911894807328],
            [31.9250947832645, 1.450664919779456],
            [31.920822826964585, 1.451467935710222],
            [31.920287129221315, 1.449830407936375],
            [31.918532891947965, 1.447812377150206],
            [31.913400155569718, 1.448425007620034],
            [31.912193410919333, 1.448053551671378],
            [31.911732282327787, 1.446732661961026],
            [31.913278183218758, 1.440907999355861],
            [31.912975064692457, 1.43984046538071],
            [31.91086378122963, 1.439142932660843],
            [31.90862062777805, 1.437567908050654],
            [31.905121360064708, 1.437276758697105],
            [31.90357988876642, 1.436181490863221],
            [31.902296773842128, 1.434009917403994],
            [31.90209511823053, 1.43104285175017],
            [31.901121720856644, 1.429640309075281],
            [31.8999334285005, 1.42947691417641],
            [31.89915469604866, 1.429802179996156],
            [31.8977354369515, 1.431592526399385],
            [31.894749901376098, 1.431310662865412],
            [31.89354377027503, 1.426769181328388],
            [31.892016404323336, 1.42557442031947],
            [31.89163260271144, 1.422914827610469],
            [31.890199880563106, 1.421159286936056],
            [31.88944861499942, 1.423375093735047],
            [31.885539979621218, 1.424639574137457],
            [31.883908484555008, 1.42330907715734],
            [31.882392665547968, 1.420323297825551],
            [31.87896066098816, 1.419290427588109],
            [31.877663235003073, 1.418321917625506],
            [31.877538383551613, 1.417462529046815],
            [31.878734370876494, 1.414441894563666],
            [31.877955511762227, 1.413880690359668],
            [31.876370544936183, 1.413943236274964],
            [31.87449103579983, 1.413236765573668],
            [31.87218151661169, 1.41138129953271],
            [31.871770749371617, 1.409924766234024],
            [31.871156413108366, 1.40950837135209],
            [31.868584142987835, 1.40388079130106],
            [31.867981235091655, 1.40189952576497],
            [31.868885020217533, 1.399059668733903],
            [31.86720502151588, 1.396435647943634],
            [31.86764956451235, 1.394816714715619],
            [31.867053655390528, 1.394635514441745],
            [31.866110400087674, 1.396037112848353],
            [31.865676132021445, 1.396145448045945],
            [31.8639821618222, 1.395719483798209],
            [31.86292576820091, 1.394678734854174],
            [31.862056266379522, 1.392814935457642],
            [31.86271305971803, 1.391367972810706],
            [31.86414379479294, 1.39016561410168],
            [31.864130199689438, 1.38864595975025],
            [31.863404837945286, 1.387831512251066],
            [31.86155731691788, 1.387830615995418],
            [31.860324874162163, 1.386102325510971],
            [31.859650331910274, 1.38356925683156],
            [31.85801587779353, 1.382636777284993],
            [31.85548357641495, 1.382147090982631],
            [31.85294003441719, 1.381096576906986],
            [31.851961858006007, 1.37979355181853],
            [31.85113491297289, 1.377640325233551],
            [31.84896383674645, 1.377096539918026],
            [31.84769251490522, 1.373893824612542],
            [31.84634876908917, 1.371785577317739],
            [31.843505807827427, 1.369649465896509],
            [31.842694734228754, 1.368382708066108],
            [31.841236915846345, 1.368128726161753],
            [31.839728724434366, 1.366915901399291],
            [31.836936277237704, 1.362563684854429],
            [31.836532209633024, 1.362382580014465],
            [31.834934669986232, 1.36300593598751],
            [31.833136832082264, 1.360816065957223],
            [31.83141554142029, 1.359476503841166],
            [31.8291700415692, 1.359574906335308],
            [31.82788139032783, 1.36032504426185],
            [31.825193000380388, 1.360387043774987],
            [31.822443293228336, 1.358902248531211],
            [31.821479303012083, 1.359091727167892],
            [31.821878061573454, 1.356314989749466],
            [31.82352396202355, 1.350906653422164],
            [31.825014130535966, 1.348673167729485],
            [31.831776760284228, 1.342977836624873],
            [31.83580462096527, 1.336204746205383],
            [31.840336113127194, 1.331041957770084],
            [31.841665659273566, 1.32852490424039],
            [31.853926389090745, 1.329205478847806],
            [31.908943671835697, 1.305503572699049],
            [31.941365647307197, 1.288710716055883],
            [31.950199563928553, 1.304532646967771],
            [31.988502332559783, 1.320366905072933],
            [31.996446134617262, 1.319755155761263],
            [32.00213137711604, 1.315344695777792],
            [32.0092671311007, 1.313951182786],
            [32.02403296220798, 1.314256271006783],
            [32.028592362330826, 1.312263223731021],
            [32.0274047356263, 1.308173337671628],
            [32.022947920413955, 1.301189663046731],
            [32.01948227035349, 1.293807419090578],
            [32.01938581195322, 1.286925201403112],
            [32.02523400525125, 1.283436495355497],
            [32.02807913684271, 1.283329529251394],
            [32.02879156464342, 1.281825203881257],
            [32.0553204759684, 1.263050442418839],
            [32.0739837871747, 1.264045896560273],
            [32.08478911417923, 1.264049760172174],
            [32.090672480113916, 1.2937123045688],
            [32.090661053543506, 1.325350116991687],
            [32.114228147511554, 1.350075930921694],
            [32.12208335232583, 1.359965703540909],
            [32.138777712736164, 1.375790876845282],
            [32.14283755433964, 1.381831213066972],
            [32.140876105374645, 1.38625791039436],
            [32.139041244304536, 1.388871613129706],
            [32.13822328422091, 1.391356493930151],
            [32.1358105521999, 1.391756184710278],
            [32.13009309521671, 1.394802654858714],
            [32.127104862000486, 1.397497321528444],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1333,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KINONI",
        Population: 6685,
        Key: "NAKASEKEKINONI",
        Dist2: "Nakaseke",
        "Sub Country": "Kinoni",
        id2_original: "NakasekeKinoni",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.30876859092965, 1.258900326480828],
            [32.30597826465538, 1.260048502891298],
            [32.30183693687249, 1.259956919340166],
            [32.298812894114086, 1.259451513692718],
            [32.2968821729217, 1.260111619425917],
            [32.290958488800456, 1.260379146651617],
            [32.28757644314681, 1.260133957818305],
            [32.28565482548152, 1.260495292267626],
            [32.282583596916204, 1.262747044570665],
            [32.280019010086306, 1.266256407916184],
            [32.278536489830216, 1.267341584165559],
            [32.2657750866844, 1.271517480760355],
            [32.264170162885996, 1.272367396449662],
            [32.26238554458975, 1.273950031211528],
            [32.25995953636713, 1.277956954602758],
            [32.25337911999278, 1.283392004878563],
            [32.251886936559174, 1.283843892261266],
            [32.25063284171015, 1.283680684197012],
            [32.245812989443706, 1.284294418958309],
            [32.243014577433556, 1.285171097072243],
            [32.242434693358085, 1.285650388432539],
            [32.240144697256035, 1.290245330758067],
            [32.23834930546456, 1.292081230246475],
            [32.23348731771969, 1.294558496604413],
            [32.23144280693028, 1.298149330163513],
            [32.22976572954996, 1.298818255908484],
            [32.22717607613035, 1.297596183555995],
            [32.22598480765566, 1.297740560581756],
            [32.22552782568748, 1.298608880973079],
            [32.22542750542983, 1.302435511310755],
            [32.22510712128375, 1.303014386935666],
            [32.22322276573643, 1.304542656096677],
            [32.22047218362527, 1.306007327556773],
            [32.21828494491023, 1.309625228224791],
            [32.21245985987456, 1.316272532014631],
            [32.21200106241118, 1.31841639473263],
            [32.21364629092142, 1.32170982853301],
            [32.211254023420906, 1.324278255312992],
            [32.21033898599779, 1.328430281385961],
            [32.20862829186288, 1.331387915181629],
            [32.204205692581375, 1.33505933180484],
            [32.20226594062544, 1.335791458382808],
            [32.19371557452857, 1.337299395733156],
            [32.1923687492877, 1.338095031380776],
            [32.190687447130585, 1.339569037341405],
            [32.18795970288887, 1.343891451444393],
            [32.18724947955391, 1.344461989608659],
            [32.18582008386706, 1.345212358519454],
            [32.18119820322126, 1.345780722153523],
            [32.179854230131404, 1.346431605464357],
            [32.177406240133806, 1.349995044817937],
            [32.17617356830769, 1.350428850143532],
            [32.17583411023318, 1.351133394321051],
            [32.171646329668626, 1.354884303063538],
            [32.16291203261902, 1.360529040857737],
            [32.16307998972936, 1.361610537208704],
            [32.16263015655422, 1.361923736182434],
            [32.1602388008437, 1.362274044808268],
            [32.15954284994195, 1.363640857027157],
            [32.15134410510852, 1.358399787820381],
            [32.137932117779435, 1.356145113828917],
            [32.137936090129635, 1.344895686355352],
            [32.14017703013233, 1.329147272903503],
            [32.14018629355957, 1.30214862490309],
            [32.149134699565565, 1.281902648018886],
            [32.122316491193196, 1.262769559865577],
            [32.1200856509492, 1.24926953918569],
            [32.11561907374466, 1.236893719983288],
            [32.10335005247744, 1.209702229910089],
            [32.098866427045415, 1.199765279819859],
            [32.101157292716664, 1.190938266623807],
            [32.10558066275268, 1.173894012497192],
            [32.10335982075784, 1.127771007070165],
            [32.127950937555894, 1.116529131665466],
            [32.16148335378779, 1.104164508124873],
            [32.186076479218826, 1.085047107832188],
            [32.19759520779781, 1.072874940176225],
            [32.202611758772136, 1.06757374060928],
            [32.22272324225134, 1.057458456708332],
            [32.23501547778212, 1.043405273042984],
            [32.240046758432186, 1.026426513884397],
            [32.2411674759194, 1.011245991807823],
            [32.24563918699578, 0.997752992333342],
            [32.266305723319356, 1.00113123792172],
            [32.2813852371407, 1.010692973508011],
            [32.299817348942284, 1.015757367278237],
            [32.31434031422428, 1.01688503007905],
            [32.32718861859406, 1.012951924584589],
            [32.34718261231555, 1.014808660844098],
            [32.34700866164564, 1.026517836331919],
            [32.346658749876134, 1.029059896690766],
            [32.345777544803234, 1.031095230102746],
            [32.34560268503825, 1.035989476763178],
            [32.34925505082885, 1.048257616494632],
            [32.35036207799114, 1.062461233704463],
            [32.35113318464449, 1.064533101456774],
            [32.35308885834054, 1.067247539893406],
            [32.35522528474983, 1.073245988001882],
            [32.35638643181471, 1.081080721540203],
            [32.35899228635047, 1.087974905900761],
            [32.35876348275266, 1.10460279197655],
            [32.35813322385099, 1.113622267768655],
            [32.358749449271265, 1.117548694600502],
            [32.360934214924335, 1.123375286615896],
            [32.3621124003352, 1.125022056700833],
            [32.364107886466314, 1.130749096501788],
            [32.36662688199892, 1.13279422153567],
            [32.373808353045035, 1.136396414306072],
            [32.37093601687351, 1.144628349360904],
            [32.369916765894274, 1.149540520538953],
            [32.36933723485674, 1.156280235918488],
            [32.367951082271034, 1.162712176588473],
            [32.36666271399898, 1.165145464751931],
            [32.36167746032913, 1.167451252450483],
            [32.359835948132684, 1.169034011834758],
            [32.35623608437887, 1.175763961156482],
            [32.35545787294991, 1.180196685273137],
            [32.355440149189384, 1.190021444558133],
            [32.3533726442236, 1.193413484036906],
            [32.350056332790906, 1.196841408179913],
            [32.34846550894922, 1.200061663348483],
            [32.3483341644749, 1.201970491773271],
            [32.349352326696014, 1.208004906855559],
            [32.35037919988045, 1.221032451391134],
            [32.34778084717562, 1.225301872441408],
            [32.346191152516255, 1.230648096036048],
            [32.344144068951856, 1.232972596309617],
            [32.342300155558625, 1.233768248302326],
            [32.33880130107031, 1.234463970410714],
            [32.33654637879019, 1.234436263816086],
            [32.33556851948432, 1.234852166265118],
            [32.332572144836675, 1.237882053085814],
            [32.33098273134996, 1.238587291339194],
            [32.32977282373146, 1.240269668532371],
            [32.32899646912021, 1.242467815999175],
            [32.32375313755408, 1.247188835964848],
            [32.31986872884076, 1.249639475357177],
            [32.31579669260732, 1.250977315049541],
            [32.31346632980965, 1.252641287639517],
            [32.312647865771126, 1.253600017044779],
            [32.31189517008949, 1.256539981673406],
            [32.30876859092965, 1.258900326480828],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1334,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KINYOGOGA",
        Population: 11639,
        Key: "NAKASEKEKINYOGOGA",
        Dist2: "Nakaseke",
        "Sub Country": "Kinyogoga",
        id2_original: "NakasekeKinyogoga",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "VH",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.28826990391861, 0.808697906865629],
            [32.28517968676481, 0.809647845216065],
            [32.27794260730767, 0.809872715089355],
            [32.26767409285568, 0.808749076992974],
            [32.266253851899926, 0.80888451686533],
            [32.262309516573964, 0.809960337888594],
            [32.24496828831069, 0.817379148460339],
            [32.24598014705347, 0.79759460369634],
            [32.23805578543705, 0.788018504923293],
            [32.22061859374521, 0.786419524398036],
            [32.21202942491964, 0.787214899494296],
            [32.211740403655064, 0.78316410434577],
            [32.20710902242682, 0.779264194821245],
            [32.20604020241019, 0.777545163075143],
            [32.20484232502995, 0.770642484494632],
            [32.20478383392518, 0.766517286135593],
            [32.20219587113494, 0.760826578953969],
            [32.200808289329665, 0.745707400633347],
            [32.20836575922108, 0.742799089769],
            [32.22217412098277, 0.740567656759251],
            [32.23746095339525, 0.7440453514971],
            [32.24781599177881, 0.750004203002198],
            [32.25620110918588, 0.73982890349788],
            [32.26507898845896, 0.732383928756414],
            [32.27370911327496, 0.731889033374054],
            [32.27420374722994, 0.722705086161419],
            [32.279628739706084, 0.720472031707783],
            [32.28628619739583, 0.720473091636021],
            [32.28727321682267, 0.715757192739412],
            [32.28776729112727, 0.709800088757686],
            [32.296643921742046, 0.709553234485057],
            [32.30206928791734, 0.70508618561639],
            [32.30422807339406, 0.704362156047057],
            [32.30484777259955, 0.705655480326012],
            [32.30521290362657, 0.705396106063333],
            [32.30743259128627, 0.719185716098368],
            [32.30921890739843, 0.717333576847573],
            [32.31233555658113, 0.715572848570019],
            [32.31681888017922, 0.714913074828311],
            [32.317749244657726, 0.715079064279305],
            [32.31864688351043, 0.71817347974847],
            [32.323566861100154, 0.726044852475837],
            [32.32569378243542, 0.730885163397314],
            [32.325836266019245, 0.73210649056988],
            [32.32326050145227, 0.737009413127916],
            [32.320648208690876, 0.743803082812775],
            [32.3193803687197, 0.744617088113477],
            [32.315119901872265, 0.750768170796977],
            [32.31419426163384, 0.752486894396136],
            [32.31429547481687, 0.753581559613771],
            [32.31505582953462, 0.754622050064263],
            [32.317790967809415, 0.756250889156659],
            [32.32126203201612, 0.757128968765579],
            [32.32185703383948, 0.757771378733071],
            [32.322786771293934, 0.760404116944681],
            [32.32337366582189, 0.764402853243784],
            [32.32518325458809, 0.767216667038603],
            [32.32959713212651, 0.771605025683237],
            [32.33433673429537, 0.783529360234553],
            [32.332975280888405, 0.784795682022253],
            [32.31796292871099, 0.792482926400686],
            [32.314734631514874, 0.795874895958344],
            [32.31253494843824, 0.798244756519115],
            [32.310851529850304, 0.801845050790775],
            [32.31018666694557, 0.802469157944821],
            [32.30499428872071, 0.803273424193876],
            [32.29657260628828, 0.806700649198901],
            [32.28826990391861, 0.808697906865629],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1335,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KITO",
        Population: 9751,
        Key: "NAKASEKEKITO",
        Dist2: "Nakaseke",
        "Sub Country": "Kito",
        id2_original: "NakasekeKito",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.35899918810677, 0.821616599085887],
            [32.36392106922658, 0.82350638242351],
            [32.367347812353785, 0.821312026052326],
            [32.37108580645559, 0.820685503789063],
            [32.367969498632654, 0.829464613848017],
            [32.37170742715747, 0.829339806915334],
            [32.38572381178948, 0.834358928944405],
            [32.38977224928041, 0.84063079025229],
            [32.39288690599984, 0.84282618679309],
            [32.393196344174186, 0.855682184098766],
            [32.394441026475654, 0.863834920033593],
            [32.38883401196675, 0.864147569169197],
            [32.37917814674189, 0.861323963337954],
            [32.37045648539509, 0.860068246791814],
            [32.367341165719004, 0.862576214162714],
            [32.36235581233618, 0.871355012969249],
            [32.3623546912387, 0.87762614909461],
            [32.364534607785835, 0.880762063520576],
            [32.355189821059014, 0.880446915150866],
            [32.35082881386667, 0.881073228306392],
            [32.349583161384665, 0.879191705273653],
            [32.34740360236701, 0.873860862966799],
            [32.34335496275514, 0.869156833034394],
            [32.34242044716168, 0.869470193114485],
            [32.33556804158056, 0.866960534473359],
            [32.329026804329025, 0.866332271640314],
            [32.31999451633673, 0.860686641085496],
            [32.319683695655186, 0.856923968977165],
            [32.318438299193055, 0.853788174922107],
            [32.321243600383106, 0.843127804824521],
            [32.32342422480269, 0.841873970405478],
            [32.32685132905264, 0.837798352083071],
            [32.32560590564106, 0.834662583893093],
            [32.32278495849369, 0.832453179521732],
            [32.3170119892192, 0.829935460449225],
            [32.3182255089635, 0.827701746659965],
            [32.32062543280517, 0.825512861875145],
            [32.33220123135416, 0.826320000530811],
            [32.33945045962721, 0.826321224807223],
            [32.34123225811181, 0.825697298294682],
            [32.344094122622074, 0.823825101394632],
            [32.34616151080683, 0.823400247553457],
            [32.34965526016938, 0.823373684418709],
            [32.355693099502005, 0.824062228515357],
            [32.358580963951525, 0.822913759426874],
            [32.35899918810677, 0.821616599085887],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1336,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "KIWOKO TOWN COUNCIL",
        Population: 11097,
        Key: "NAKASEKEKIWOKO TOWN COUNCIL",
        Dist2: "Nakaseke",
        "Sub Country": "Kiwoko TC",
        id2_original: "NakasekeKiwoko TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.7946496259089, 0.855675464551536],
            [32.79113091326292, 0.856010021820088],
            [32.78970413796177, 0.855530437839224],
            [32.78742133287358, 0.854137030148918],
            [32.78317685513984, 0.849622202242769],
            [32.7784211722291, 0.84582207712038],
            [32.77135906482635, 0.836674879943],
            [32.76490348283545, 0.825673025641377],
            [32.76106338621849, 0.818389751690927],
            [32.760124494931276, 0.813088001974722],
            [32.75919797614052, 0.797979025606534],
            [32.75890157341926, 0.780155910252558],
            [32.76117291061453, 0.774854346680308],
            [32.76142271682369, 0.772692065425225],
            [32.76000831222234, 0.762531913059454],
            [32.7603059842631, 0.758162102706347],
            [32.759699828957146, 0.754172228035264],
            [32.759842701511516, 0.750607615213139],
            [32.7585474413646, 0.744392076437281],
            [32.75854769828276, 0.739669406540771],
            [32.76183347058904, 0.723456892824665],
            [32.75401353273455, 0.703136331126879],
            [32.754014119334414, 0.691881542375964],
            [32.755735285130584, 0.679124996826219],
            [32.75542254025766, 0.676609842457286],
            [32.75177071435455, 0.663165431347646],
            [32.75101640529869, 0.644862792384015],
            [32.750606138420245, 0.643686628883812],
            [32.74623612561713, 0.63710000965477],
            [32.747816136437756, 0.635034248059733],
            [32.74957721528033, 0.633583889238377],
            [32.75181850742263, 0.633422837441027],
            [32.75470040077044, 0.628265833063137],
            [32.75667277145267, 0.626810054041501],
            [32.75739412491401, 0.628003055702007],
            [32.75845330061774, 0.628041878556293],
            [32.75966145023325, 0.628086161940805],
            [32.7648143124671, 0.631655355324453],
            [32.76918405397896, 0.632278045769314],
            [32.770500826082, 0.631727398526449],
            [32.772153917545936, 0.630029455605339],
            [32.7740768431583, 0.629418253650661],
            [32.77851730813418, 0.629902424434941],
            [32.78182000110714, 0.629254182668673],
            [32.78550570247964, 0.629541588488605],
            [32.78747931373527, 0.630259797560397],
            [32.789143726666715, 0.632821189783866],
            [32.78992828648979, 0.636292174057987],
            [32.78959530976004, 0.638111418594244],
            [32.78840626641232, 0.640553004307168],
            [32.78418916932846, 0.644562564779425],
            [32.7845189300895, 0.645351071248126],
            [32.78474538728779, 0.651887260633654],
            [32.78539247522795, 0.653538570480673],
            [32.785858892201574, 0.65924470252874],
            [32.78564479492328, 0.661279388083813],
            [32.78916399894775, 0.663170611584861],
            [32.79282160550969, 0.662298972593912],
            [32.79820009759347, 0.666988396440852],
            [32.79748343154126, 0.668105467303066],
            [32.79777163444061, 0.668695137922837],
            [32.7985655762685, 0.668864707635051],
            [32.79827995063569, 0.670034638513861],
            [32.80017768838581, 0.671855673613823],
            [32.80285958441203, 0.673562293931934],
            [32.80581982702229, 0.674581225558668],
            [32.808729429803364, 0.676593496055565],
            [32.809037756761704, 0.676363604452663],
            [32.810323216288886, 0.682858241034681],
            [32.81085996595936, 0.683938448507746],
            [32.812005198470665, 0.683300313686566],
            [32.81342256661417, 0.684514948841761],
            [32.81918473724062, 0.684774277542216],
            [32.81820927823316, 0.683813588882893],
            [32.81875622468042, 0.683095480923483],
            [32.82065858695759, 0.68220986061225],
            [32.82689792918822, 0.681454898940777],
            [32.82642265841917, 0.678260999414528],
            [32.826866314778435, 0.678740134376006],
            [32.82826210179554, 0.678091368948046],
            [32.83000981909656, 0.679396032737096],
            [32.83054481705222, 0.680317651911141],
            [32.83154353973058, 0.68030571863382],
            [32.83312010730874, 0.681696502605532],
            [32.8359705299772, 0.682609767600531],
            [32.83868006806304, 0.680695321932755],
            [32.84203896952165, 0.677390655694687],
            [32.84265684694377, 0.676060969636977],
            [32.8474562337914, 0.678614647636387],
            [32.855980497541076, 0.681686620938546],
            [32.87096536935565, 0.690465784623857],
            [32.87154071693891, 0.695206596044352],
            [32.871494928910586, 0.699559602869072],
            [32.87101358912348, 0.703973433178873],
            [32.869116679620056, 0.711145381344715],
            [32.86850050001386, 0.713029726998326],
            [32.863109616569076, 0.722126948554615],
            [32.86132608882757, 0.728084244845969],
            [32.859096762244846, 0.732861156566239],
            [32.8576375622535, 0.737185725250727],
            [32.85690765054245, 0.744613544558927],
            [32.85370564972964, 0.750611805494326],
            [32.85086825532775, 0.754854896538978],
            [32.84657175256268, 0.759993615808081],
            [32.837370563330644, 0.772596168208998],
            [32.82650759682422, 0.788509930297013],
            [32.82508880305439, 0.792309734303445],
            [32.82346725682997, 0.801854561221587],
            [32.82415562235745, 0.809083380451774],
            [32.82326397616602, 0.813317475058805],
            [32.821155631092495, 0.817397710256662],
            [32.81317089460415, 0.830497817742424],
            [32.806972607178636, 0.839508612360352],
            [32.79999707131813, 0.849713592179789],
            [32.7969166242414, 0.853305199001509],
            [32.7953602831302, 0.854445073131345],
            [32.7946496259089, 0.855675464551536],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1753,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "SEETA NAMUGANGA",
        Population: 37676,
        Key: "MUKONOSEETA NAMUGANGA",
        Dist2: "Mukono",
        "Sub Country": "Seeta-Namuganga",
        id2_original: "MukonoSeeta-Namuganga",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49056882784938, 1.275857173709623],
            [32.49256684812791, 1.287570584022206],
            [32.49486700237918, 1.293527113779021],
            [32.49631102802876, 1.293862814846896],
            [32.496448100161324, 1.29449694358557],
            [32.49683938114626, 1.294520187847811],
            [32.50407048590843, 1.303124848447087],
            [32.509987345528494, 1.307758525629331],
            [32.507685408121354, 1.31073611150769],
            [32.50529607182361, 1.311467488183634],
            [32.50522556665022, 1.314819506556077],
            [32.50356974430781, 1.317234715793609],
            [32.49880691619729, 1.319899267476768],
            [32.49880669611003, 1.320992015816856],
            [32.49617536175957, 1.326947549351799],
            [32.496173408822145, 1.336543438395742],
            [32.49551397174176, 1.345808297315814],
            [32.48959605480461, 1.346137948231015],
            [32.488310457835205, 1.34507192766851],
            [32.48728718150518, 1.346346717451731],
            [32.48006210623516, 1.344481457926277],
            [32.47019913262492, 1.344148428255094],
            [32.46493783565143, 1.348779746658669],
            [32.46139510115643, 1.353362003056749],
            [32.45739388271011, 1.352725054180061],
            [32.453282502063814, 1.354397799223061],
            [32.45210799884729, 1.352126761452949],
            [32.45029557589635, 1.351067861581098],
            [32.44820034802261, 1.350985960696274],
            [32.443168097192085, 1.351771882001233],
            [32.442277584674514, 1.347085392950145],
            [32.4440875597163, 1.344037010332334],
            [32.44263973059982, 1.34348683487039],
            [32.44356929198448, 1.342818896451971],
            [32.44620098566105, 1.335870808356914],
            [32.443901040717236, 1.329583374702219],
            [32.44200078768434, 1.329276925088907],
            [32.44080265787752, 1.328140890544296],
            [32.43835576921443, 1.32681044033221],
            [32.43626773774444, 1.324828697308647],
            [32.43419352595679, 1.321381363398652],
            [32.43387215725717, 1.319001963625449],
            [32.43414919589416, 1.316188451233981],
            [32.43514302455087, 1.312547542271463],
            [32.43338531079735, 1.308734932897954],
            [32.43404593904383, 1.294837726793159],
            [32.437992292884196, 1.289213487258794],
            [32.43848208941138, 1.289426793900099],
            [32.441621124610975, 1.285313145160312],
            [32.44400589656877, 1.284101387160684],
            [32.450363363666014, 1.286780654921875],
            [32.453895627398055, 1.286718091364909],
            [32.460809221724766, 1.288402300022699],
            [32.46120950382884, 1.288068662938805],
            [32.462649123241924, 1.289880638044876],
            [32.47415547483294, 1.291206629091494],
            [32.47415696962958, 1.28392701136686],
            [32.473171031774314, 1.282253441229887],
            [32.47317116292836, 1.281610564736626],
            [32.47514560692226, 1.272346004753594],
            [32.480077255424106, 1.271023443646546],
            [32.48122966996614, 1.272230645500723],
            [32.48303363258373, 1.271941508663742],
            [32.48992353653975, 1.272792359128852],
            [32.49056882784938, 1.275857173709623],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1756,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "NAKASONGOLA TOWN COUNCIL",
        Population: 9832,
        Key: "NAKASONGOLANAKASONGOLA TOWN COUNCIL",
        Dist2: "Nakasongola",
        "Sub Country": "Nakasongola TC",
        id2_original: "NakasongolaNakasongola TC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.34705040456023, 1.290239013610415],
            [32.351805931164144, 1.290041294245551],
            [32.35550762165037, 1.289372780204263],
            [32.358450235721484, 1.288333103226109],
            [32.36161511275686, 1.286768885468855],
            [32.36861705998503, 1.281164244223945],
            [32.383519689238696, 1.281146843716233],
            [32.39086250399806, 1.280409567705752],
            [32.3991844833154, 1.279426157891821],
            [32.406244538966014, 1.277296276847723],
            [32.40995528357199, 1.273023740372213],
            [32.40951377508459, 1.26319745550867],
            [32.422504536987056, 1.25937155959538],
            [32.43359101062438, 1.255357198142935],
            [32.434399214105696, 1.253710868661444],
            [32.43525640361779, 1.247468643366859],
            [32.43462835457175, 1.247468502364775],
            [32.43497771477563, 1.244971636476138],
            [32.435554320898625, 1.244121385849374],
            [32.437512227806465, 1.243040854836295],
            [32.43733895087297, 1.242624779440386],
            [32.43774129820391, 1.242967322579851],
            [32.4412382006531, 1.242277045214578],
            [32.45209749933825, 1.241817889431731],
            [32.45867892182571, 1.240905611093534],
            [32.4635199285188, 1.238862002006976],
            [32.466923841861345, 1.236173578105188],
            [32.46772565832102, 1.23633074668768],
            [32.49073460115528, 1.226481310482313],
            [32.500524903754, 1.225990437924931],
            [32.51097673201612, 1.222129124999348],
            [32.50047219779963, 1.20782695062604],
            [32.49718520647949, 1.205013742775055],
            [32.49291231323671, 1.20038043872668],
            [32.48486074209124, 1.185157855319918],
            [32.48492264140421, 1.183302950258452],
            [32.488971095963144, 1.179864256962862],
            [32.49242308264813, 1.178872250075208],
            [32.507710092927056, 1.178047798912027],
            [32.51790161996257, 1.176064203812904],
            [32.53318926175713, 1.171434360192056],
            [32.53779186455696, 1.170607802520759],
            [32.54593368854071, 1.166563698067957],
            [32.55160058474643, 1.163164978833358],
            [32.55390223648932, 1.160518160117002],
            [32.55406758309544, 1.154396689167782],
            [32.55302076461678, 1.14886039554256],
            [32.55375885728513, 1.149265818907313],
            [32.553082243518176, 1.148274923923376],
            [32.55127641869301, 1.133715137930223],
            [32.55045600441201, 1.124284518466468],
            [32.550457478547386, 1.114523098696329],
            [32.55210209710156, 1.108732721296193],
            [32.55736257481153, 1.104928224336412],
            [32.564759569660595, 1.102612965203025],
            [32.58218295604314, 1.10294640298133],
            [32.58788115224833, 1.109431873043228],
            [32.59217643330461, 1.105141955769355],
            [32.598327997555586, 1.11385510302741],
            [32.59942218779245, 1.114787209098087],
            [32.60497293452689, 1.117501991988869],
            [32.61148494778563, 1.119466120922745],
            [32.6123173635588, 1.120325673177472],
            [32.613269929001234, 1.1221171879151],
            [32.612796207826044, 1.123266109294516],
            [32.61264496836314, 1.126197420925094],
            [32.613168938600374, 1.127201655503525],
            [32.61336186528238, 1.12966256202743],
            [32.614183262320296, 1.131300124415791],
            [32.61432972993241, 1.134520937738916],
            [32.615995333131615, 1.136909565749262],
            [32.617088750817366, 1.137262646401815],
            [32.61774311780628, 1.138085986756041],
            [32.61822041786957, 1.139976846999946],
            [32.61807170446925, 1.144943684005729],
            [32.61852514348194, 1.146635547067528],
            [32.62133244881339, 1.149947278434818],
            [32.6222025516077, 1.152516643890201],
            [32.6232017863258, 1.153665833379332],
            [32.62290793931152, 1.156280382314065],
            [32.62364540046424, 1.157139922696888],
            [32.622364107323364, 1.15853300965134],
            [32.622317086806426, 1.159202537976379],
            [32.623260106750664, 1.163111091022175],
            [32.622384179280076, 1.165816005497455],
            [32.62313602695204, 1.168665880694025],
            [32.623496757132486, 1.172447700243831],
            [32.62275024275835, 1.174202696846967],
            [32.62270427416861, 1.175424148821519],
            [32.62205243414058, 1.176799123198119],
            [32.620960700796005, 1.177857508584126],
            [32.61946760197913, 1.18109623157651],
            [32.623687929404724, 1.194133739700867],
            [32.62375172416293, 1.198024000232198],
            [32.623232034398036, 1.200602301740855],
            [32.62168033578023, 1.20461899175264],
            [32.61810082964737, 1.211630047592801],
            [32.61276280127728, 1.218731175809413],
            [32.60536419305393, 1.231260371268095],
            [32.59790473744485, 1.242758092202215],
            [32.593966115404136, 1.247480149854446],
            [32.59075576115751, 1.247479588540464],
            [32.58757186588926, 1.250518961890045],
            [32.58625204400584, 1.253540369714247],
            [32.58474182150299, 1.259393591742599],
            [32.5812873078571, 1.266920205788203],
            [32.578341676344934, 1.270972859385054],
            [32.5737083340944, 1.275604215146566],
            [32.57150949723073, 1.278951291160908],
            [32.57086502608298, 1.281357614823328],
            [32.57087885115521, 1.287382953576759],
            [32.57160887335903, 1.291173866870848],
            [32.57512928651586, 1.301958467431954],
            [32.57551808815064, 1.306672138001844],
            [32.575111671451474, 1.314660561876996],
            [32.57715267162476, 1.321699525801916],
            [32.57830911241589, 1.333506113188699],
            [32.57947846559088, 1.337061914420362],
            [32.58363155950739, 1.342671763177153],
            [32.584928853440104, 1.345521865859223],
            [32.588620999326444, 1.365914509897642],
            [32.581068834885045, 1.366935631769756],
            [32.57748596006991, 1.369540424513488],
            [32.570301403310765, 1.373031344849522],
            [32.561813798011244, 1.372405511045562],
            [32.5532583968572, 1.372566740218041],
            [32.54821063751159, 1.371995912330182],
            [32.5328570953078, 1.367650150367661],
            [32.52483128065814, 1.364491365428343],
            [32.523572165124975, 1.365061072526938],
            [32.51863402809183, 1.370768800520556],
            [32.51657042900092, 1.372441994635042],
            [32.51347039954929, 1.368180286433923],
            [32.511012524490305, 1.363800981275822],
            [32.50906430321787, 1.358933345746021],
            [32.50915659074028, 1.355395958883272],
            [32.50769254793125, 1.352491562675094],
            [32.50673731539074, 1.351704351981276],
            [32.50381793085453, 1.351414164610971],
            [32.501029434448476, 1.354136845069674],
            [32.49060167834101, 1.368718279501016],
            [32.489931660903196, 1.371631216439329],
            [32.49082337985816, 1.376344893113859],
            [32.49060932749566, 1.377928137674948],
            [32.48575912744394, 1.38054161788871],
            [32.48270682009348, 1.38325500368394],
            [32.47880020143306, 1.392436741480358],
            [32.473633835723874, 1.400767824481495],
            [32.47660017160671, 1.404839620962673],
            [32.4826151640867, 1.411608066092617],
            [32.490266704656406, 1.416458895046504],
            [32.49218973088005, 1.419327291218937],
            [32.49494685721806, 1.424665569631884],
            [32.493659459126505, 1.424502380030213],
            [32.4926175535341, 1.423244705783683],
            [32.49175636382407, 1.42295494836823],
            [32.4888517179467, 1.422836659663282],
            [32.48472248508081, 1.423568560768703],
            [32.479410003000766, 1.425503410717581],
            [32.47677709749685, 1.427646912426928],
            [32.47331065332568, 1.431310196785253],
            [32.471730811388305, 1.434648078194679],
            [32.46773520292092, 1.439441889264838],
            [32.459662927404786, 1.44560476428849],
            [32.45377692760968, 1.451314118937764],
            [32.44673546888208, 1.455331102888685],
            [32.443969780701096, 1.456350922882232],
            [32.443365803809705, 1.455078253014784],
            [32.431155944688754, 1.443784710364572],
            [32.42732350710788, 1.441313863635447],
            [32.42315041220161, 1.437549426540839],
            [32.42235357779849, 1.435965942256944],
            [32.421579272244415, 1.432702851977567],
            [32.41851699988246, 1.43342324432715],
            [32.41452307575623, 1.436594986569546],
            [32.409627187389205, 1.442185936050984],
            [32.40963546895778, 1.441934347341399],
            [32.403750380952694, 1.444153604932467],
            [32.398391228698685, 1.44404640260494],
            [32.395555078463474, 1.440132812381173],
            [32.39458258209981, 1.43757889368276],
            [32.396661901708185, 1.426913749978077],
            [32.39823928675323, 1.42236659223918],
            [32.398871476134424, 1.415704259576622],
            [32.39841579133353, 1.412395818206446],
            [32.395158696844355, 1.409967453824434],
            [32.390791831738, 1.403116215773918],
            [32.394963173132844, 1.39696711836906],
            [32.411434906761286, 1.377593050686946],
            [32.41417947016006, 1.374816373280713],
            [32.41016996655183, 1.370753364696014],
            [32.40834786066047, 1.368237817900302],
            [32.40337652728429, 1.364391736384161],
            [32.39095401986762, 1.353152481860041],
            [32.38479978851856, 1.346573868294136],
            [32.38017241197982, 1.340276163910768],
            [32.36840595589325, 1.32914554860221],
            [32.364904420832104, 1.328873320032439],
            [32.360743536725465, 1.326691982515738],
            [32.35893855452005, 1.325334486895035],
            [32.35725533625643, 1.322556627206665],
            [32.35703012591974, 1.32103677325692],
            [32.35731765687927, 1.308498049667257],
            [32.355928496734016, 1.302336785022748],
            [32.353720956991864, 1.29793954115563],
            [32.35100860628088, 1.293967337714162],
            [32.34705040456023, 1.290239013610415],
          ],
          [
            [32.48007728327189, 1.271023377187583],
            [32.47514560243067, 1.272345960746989],
            [32.473171133283955, 1.281610623112497],
            [32.47317106321534, 1.282253460089802],
            [32.47415696423967, 1.283926994303167],
            [32.474155490104295, 1.291206562633054],
            [32.462649124140256, 1.289880620981223],
            [32.46120950382884, 1.288068728499256],
            [32.46080919208036, 1.288402283857107],
            [32.453895603143565, 1.28671808777256],
            [32.45036332953003, 1.286780672883652],
            [32.444005924416544, 1.284101420389996],
            [32.44162110754296, 1.285313139771786],
            [32.438482057072015, 1.289426805575238],
            [32.437992265036414, 1.289213509711003],
            [32.43404592377244, 1.294837778882153],
            [32.43338531079735, 1.30873491852865],
            [32.43514299131317, 1.312547550354182],
            [32.434149230030116, 1.316188418005091],
            [32.433872155460534, 1.319001926804261],
            [32.4341935142787, 1.321381410098612],
            [32.43626770989666, 1.324828758377754],
            [32.4383558015538, 1.326810416084191],
            [32.44080265787752, 1.328140828577182],
            [32.442000785887714, 1.329276891860192],
            [32.44390107395489, 1.329583359434979],
            [32.44620097128803, 1.335870847872044],
            [32.44356925874682, 1.342818962010983],
            [32.44263971263354, 1.343486900429385],
            [32.44408754444492, 1.344036967225069],
            [32.442277579284635, 1.347085345352591],
            [32.44316810437859, 1.351771846976696],
            [32.44820035431082, 1.350985899627818],
            [32.450295604642456, 1.351067848110122],
            [32.45210802579674, 1.35212672373421],
            [32.45328250296215, 1.354397845024347],
            [32.45739390965955, 1.352725059568475],
            [32.46139513259746, 1.353361983299325],
            [32.46493786349921, 1.348779744862539],
            [32.470199113760316, 1.344148383351698],
            [32.48006212420147, 1.344481510912281],
            [32.48728717521697, 1.346346685121297],
            [32.48831048298802, 1.345071990533246],
            [32.489596056601236, 1.346137884468223],
            [32.49551398880977, 1.345808265883456],
            [32.496173408822145, 1.336543418638183],
            [32.4961753734377, 1.326947512530762],
            [32.49880666556733, 1.320992009530314],
            [32.49880694584169, 1.319899302501759],
            [32.50356977125729, 1.317234678972427],
            [32.505225549582235, 1.314819549663852],
            [32.50529608080678, 1.311467468425875],
            [32.50768538925675, 1.310736094444178],
            [32.5099873221723, 1.307758535508226],
            [32.50407051195958, 1.303124852937511],
            [32.49683935509511, 1.294520221975088],
            [32.49644809656804, 1.294496927420015],
            [32.496311033418635, 1.293862794190897],
            [32.494866991599416, 1.29352713443499],
            [32.49256681309359, 1.287570569652782],
            [32.48992352037006, 1.272792341166976],
            [32.48303365234666, 1.271941537402732],
            [32.48122965289816, 1.272230611373149],
            [32.48007728327189, 1.271023377187583],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1759,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "WABINYONYI",
        Population: 18314,
        Key: "NAKASONGOLAWABINYONYI",
        Dist2: "Nakasongola",
        "Sub Country": "Wabinyonyi",
        id2_original: "NakasongolaWabinyonyi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.293868584696177, 0.187395383854943],
            [31.282269749750046, 0.179544678533869],
            [31.281106358693577, 0.177889652065306],
            [31.27791277060342, 0.171161179635024],
            [31.27482602723483, 0.168628794168355],
            [31.266007745790986, 0.163147824590684],
            [31.263740256080037, 0.162306609618783],
            [31.260511290537384, 0.162089290056029],
            [31.250601133815135, 0.166094512036663],
            [31.24748670077625, 0.166076143362887],
            [31.245253349741063, 0.166690869597939],
            [31.2434929060074, 0.168228031400553],
            [31.239633546815778, 0.17370776437176],
            [31.23718161231576, 0.17645661427323],
            [31.233590015757507, 0.179223430884661],
            [31.23157028858848, 0.179856242386404],
            [31.22404116144255, 0.180940651781282],
            [31.22190211285096, 0.181908034576164],
            [31.220356765322204, 0.182739831690276],
            [31.216906620183497, 0.185913553283436],
            [31.212150069500197, 0.189313198470062],
            [31.20658652895949, 0.192522836906559],
            [31.204161707411366, 0.193788578407122],
            [31.19360338836389, 0.197386475446213],
            [31.185557056193133, 0.190883819539304],
            [31.174491754948736, 0.182707997355124],
            [31.172161681408603, 0.180211966296318],
            [31.1662488165966, 0.172181453707203],
            [31.165747889943045, 0.17103298253074],
            [31.165499924381912, 0.169296765932723],
            [31.165939968615415, 0.167207947561877],
            [31.16551075357265, 0.164585528305435],
            [31.16455465954779, 0.162116786478536],
            [31.161679066085057, 0.157857426791884],
            [31.15889235103821, 0.154710332835661],
            [31.156008299937074, 0.154059006313507],
            [31.153270545768166, 0.149537453710597],
            [31.151819332698018, 0.143297926142278],
            [31.151699803764625, 0.135665952839007],
            [31.1505284563297, 0.132338181716808],
            [31.150296501441872, 0.129996130788154],
            [31.150944850616717, 0.126795096515608],
            [31.152926009517365, 0.122219675862465],
            [31.153765819323652, 0.11838566390217],
            [31.153891206171018, 0.115419691722785],
            [31.152497779028153, 0.112327026480077],
            [31.152974442185908, 0.111513219962292],
            [31.152811163501546, 0.110220116396285],
            [31.153145521840198, 0.109333960537741],
            [31.151443906079557, 0.105906704230711],
            [31.151928343257755, 0.10179234524191],
            [31.151148398080306, 0.100173672547291],
            [31.151222856739253, 0.098844412273319],
            [31.151987868323427, 0.096529547880675],
            [31.149690559036628, 0.093997488954036],
            [31.148846201060067, 0.089503274554985],
            [31.15088393585731, 0.080114974747996],
            [31.1449584344442, 0.079092046154966],
            [31.13717093295797, 0.07159226896724],
            [31.124812027161738, 0.072273502232823],
            [31.12262593469699, 0.071279470438546],
            [31.12121991047893, 0.053964972970977],
            [31.121342358038653, 0.041848090146745],
            [31.122047043259915, 0.034695523096901],
            [31.121523885998016, 0.013852653061823],
            [31.122353388534748, -0.00276737701265],
            [31.12318224877605, -0.005425862935514],
            [31.12247322020039, -0.011086439432151],
            [31.1196848693214, -0.015508182499041],
            [31.117180023152848, -0.017886322992241],
            [31.11025634793204, -0.022714902087169],
            [31.108223897923622, -0.024622822078138],
            [31.100756853346994, -0.028574232108663],
            [31.10040233861, -0.029451333564869],
            [31.099173516064848, -0.029496526902532],
            [31.09298248163694, -0.032833040053615],
            [31.087410077419307, -0.036440809220414],
            [31.08787823442964, -0.037254623410729],
            [31.087594710854603, -0.039063074508627],
            [31.088272520279197, -0.040582190864139],
            [31.0914477737544, -0.043891742472934],
            [31.100970532010344, -0.039696317464083],
            [31.116518102230675, -0.04087217055786],
            [31.12671445681256, -0.030699601768992],
            [31.16347964474897, -0.030456036190796],
            [31.16101704544988, -0.036035317867101],
            [31.191472944734368, -0.046118619561044],
            [31.206512353269822, -0.049491979127829],
            [31.206740219026504, -0.069567189375701],
            [31.21441252864553, -0.070797322538272],
            [31.21662273458743, -0.071665518436589],
            [31.23664844961823, -0.081631694152622],
            [31.253504520254463, -0.089283814601561],
            [31.265869895717362, -0.094040173245618],
            [31.268410117541812, -0.096461784461629],
            [31.27120401911094, -0.096624467332004],
            [31.27387818333751, -0.095922300181423],
            [31.304804873492724, -0.105170910701105],
            [31.32426368151066, -0.109986563836784],
            [31.3238354231737, -0.107671425371433],
            [31.32436166974185, -0.104144500064762],
            [31.324092538974305, -0.102742753213716],
            [31.325188250957282, -0.101250638619756],
            [31.32555499176527, -0.098917446095477],
            [31.321723475855883, -0.093138501261849],
            [31.314049324690505, -0.085722542134499],
            [31.31081951922303, -0.083425381775841],
            [31.307851138774605, -0.079039217181695],
            [31.30624018458569, -0.077528919731858],
            [31.30509881752506, -0.077230440377846],
            [31.305067147419724, -0.075774463043033],
            [31.30451391007053, -0.074517407529696],
            [31.302756089417485, -0.074336478000981],
            [31.301726488947867, -0.07277193206893],
            [31.299518478488533, -0.070610500050894],
            [31.2974929050836, -0.069262979619558],
            [31.295641325467773, -0.069299084681071],
            [31.290795212750616, -0.066594971626332],
            [31.289269027185178, -0.065392160598118],
            [31.285756337743166, -0.061340658737407],
            [31.284145316180606, -0.060427157949181],
            [31.28351751686622, -0.058013660056268],
            [31.285401670292565, -0.050427121389812],
            [31.29105367243091, -0.04453765252944],
            [31.294325870294937, -0.041742650418351],
            [31.2958876219591, -0.039340663747933],
            [31.29501506496742, -0.034179292837408],
            [31.281313628775703, -0.031978851949516],
            [31.27585512554621, -0.031565142790494],
            [31.273331293484137, -0.032215084577657],
            [31.270866169919096, -0.03209686810151],
            [31.26446858675623, -0.032864922156128],
            [31.259127378350012, -0.040369088972334],
            [31.2591273307393, -0.042732632219974],
            [31.257659929129424, -0.04615973723489],
            [31.257425111310774, -0.048109653866702],
            [31.258012037279755, -0.048286933630333],
            [31.25817533482876, -0.049191250231661],
            [31.256133883701192, -0.047341472394376],
            [31.25261236112499, -0.045096028969549],
            [31.245217055108633, -0.046041271046847],
            [31.24357367892448, -0.045332175322974],
            [31.241460789273976, -0.043441309353977],
            [31.240873890254438, -0.042259536402358],
            [31.24239995724226, -0.039186989886653],
            [31.24439567154544, -0.029142045449609],
            [31.243221863624935, -0.025833095193614],
            [31.243926202994807, -0.023351403330301],
            [31.2439262254527, -0.021224231526103],
            [31.24329543923997, -0.018190023611803],
            [31.243926252402147, -0.018210736964598],
            [31.24510012500135, -0.015492691950826],
            [31.245217532114058, -0.011711050613272],
            [31.247917405225728, -0.008638473725527],
            [31.251204204306422, -0.006865833581569],
            [31.258364732928296, -0.008874861796506],
            [31.26059507191235, -0.007811273579391],
            [31.261182007762798, -0.005329550961099],
            [31.256486561383422, 0.001997431881625],
            [31.254725752933744, 0.007197212205922],
            [31.253912920433752, 0.018235935605337],
            [31.258892768940527, 0.025573787529789],
            [31.263236070338646, 0.024746610811109],
            [31.26922282068442, 0.022028608127041],
            [31.27074886251943, 0.020965026261722],
            [31.27556179146997, 0.015115263899365],
            [31.279611671655264, 0.012692643295209],
            [31.286831032741752, 0.009265513057543],
            [31.291350467715937, 0.009501899331485],
            [31.29246565697088, 0.009029189665507],
            [31.296632961336865, 0.004833841724636],
            [31.30390209537829, -0.000909090575899],
            [31.309504070338416, 0.001166492040766],
            [31.310548887370675, 0.002450655298305],
            [31.315440052395925, 0.002812401472952],
            [31.320319717188937, 0.004539715335306],
            [31.325270688452584, 0.007921990038811],
            [31.32657684875715, 0.010029120564087],
            [31.326790739422943, 0.01239851152203],
            [31.326304506512482, 0.01585311130069],
            [31.32829925333012, 0.018385302073258],
            [31.32824026545698, 0.021478168171309],
            [31.32672071844149, 0.024019360874085],
            [31.326151110194555, 0.026189789206708],
            [31.32471492593914, 0.028957064390111],
            [31.319622360423768, 0.034618170978584],
            [31.31701078990788, 0.038443486835971],
            [31.311300904824225, 0.04500886905775],
            [31.310956993800875, 0.04648293390052],
            [31.309912139039405, 0.047893675591979],
            [31.309081427370284, 0.050832752803038],
            [31.30866639492926, 0.05567095106805],
            [31.308940053205813, 0.065446856285171],
            [31.307766061130696, 0.081073770854997],
            [31.30705400523252, 0.084853870420549],
            [31.30332691128837, 0.097695267492555],
            [31.297644041240265, 0.110039115184047],
            [31.29454590723388, 0.117852357709167],
            [31.292516247392747, 0.123983591106581],
            [31.291412389486794, 0.129635579399575],
            [31.290418739594806, 0.142190308631013],
            [31.29304830875574, 0.151622736320649],
            [31.29278186035763, 0.162316905168939],
            [31.293312372126753, 0.169446412927117],
            [31.295790278718293, 0.17728905482606],
            [31.29561293421321, 0.180497300359643],
            [31.293133902930972, 0.184774739803462],
            [31.293868584696177, 0.187395383854943],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1379,
        District: "SSEMBABULE",
        County: "LWEMIYAGA",
        Subcounty: "NTUUSI",
        Population: 23962,
        Key: "SSEMBABULENTUUSI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.474602348897115, -0.316960106285052],
            [31.478940964682714, -0.300771729059721],
            [31.478401241588646, -0.295643639057706],
            [31.477126264502527, -0.292396624198774],
            [31.477837654749088, -0.290407019019204],
            [31.47779530636995, -0.283623902962656],
            [31.47719974130288, -0.282357645098621],
            [31.47285699955518, -0.277771713224303],
            [31.472356618179, -0.276378854832029],
            [31.469392846087977, -0.271892610958456],
            [31.468774668628573, -0.271793041914742],
            [31.465519588162266, -0.273393434464306],
            [31.464402513343547, -0.273492775325288],
            [31.463784101423865, -0.2730585894528],
            [31.463568188650367, -0.270978421024019],
            [31.464184128406405, -0.268798882593584],
            [31.465940192853015, -0.266076825594982],
            [31.466227828915436, -0.264765466437738],
            [31.46177857212787, -0.261129204411467],
            [31.45983921722728, -0.259012657065831],
            [31.45710064918474, -0.254001929779855],
            [31.45575083704555, -0.24945262840815],
            [31.455237350147677, -0.244613996920391],
            [31.45519501883655, -0.239151393053183],
            [31.45624698376348, -0.236194110682922],
            [31.457213412905723, -0.234928055584525],
            [31.45982202976095, -0.232242256240641],
            [31.464596105677163, -0.228308598620055],
            [31.465666734900754, -0.226581288482471],
            [31.465701776383366, -0.224347404076073],
            [31.465315598727575, -0.223207817184943],
            [31.463054307392103, -0.220015022834065],
            [31.46273998148429, -0.218993006255697],
            [31.462583309908847, -0.21642448268609],
            [31.4632603584604, -0.214398678358544],
            [31.462709150405406, -0.207036748733577],
            [31.463604528198548, -0.205815894982063],
            [31.469563970658022, -0.200344778740549],
            [31.474283457751056, -0.197288306337608],
            [31.47783606922261, -0.195723986607317],
            [31.482191835643587, -0.19131083672443],
            [31.481961405196795, -0.188136619341443],
            [31.476885490853554, -0.177363788909894],
            [31.47547994184426, -0.173196255213104],
            [31.47227807218549, -0.167849132626402],
            [31.462636623124318, -0.161783482296878],
            [31.46148746767015, -0.159193530915638],
            [31.461711678181906, -0.156787831967982],
            [31.460773600768395, -0.154626236458431],
            [31.4612702514412, -0.154291632298969],
            [31.460861431748636, -0.151234711287199],
            [31.461717668148218, -0.14725538750538],
            [31.46134630191484, -0.146649404872494],
            [31.46165149554946, -0.146052529313959],
            [31.46138125176928, -0.144388399307232],
            [31.462897264812423, -0.139531832532143],
            [31.46244139855184, -0.138672613563081],
            [31.462457213392405, -0.137352180164413],
            [31.459251622013433, -0.144695042745266],
            [31.456695864724438, -0.148337626548341],
            [31.454919525301836, -0.150052702240457],
            [31.451342803048053, -0.151694661478552],
            [31.44930414118944, -0.154476133910446],
            [31.447515720324606, -0.15617903429242],
            [31.44036253632847, -0.15822574184372],
            [31.433221541572408, -0.163063940249354],
            [31.430732749196313, -0.165531735139173],
            [31.42858441561793, -0.168674480489148],
            [31.428474964883705, -0.171042070745981],
            [31.427388534294238, -0.173365794379652],
            [31.426311054518287, -0.173559631963305],
            [31.423219040733926, -0.176401215432306],
            [31.42124914041874, -0.176509577792813],
            [31.41882340887726, -0.175812997769559],
            [31.416424858559648, -0.175704267097458],
            [31.41235951387672, -0.176834405258685],
            [31.411962577098762, -0.176608274326174],
            [31.410570941196575, -0.177404018868774],
            [31.40020866598513, -0.177547834862546],
            [31.39707885917845, -0.180405395077047],
            [31.393347585373306, -0.188200796435879],
            [31.39245031033826, -0.18908700032154],
            [31.39159301033338, -0.188616649485334],
            [31.39115911327138, -0.187459008491176],
            [31.378597045388787, -0.182664700575141],
            [31.374452632791204, -0.18024061971718],
            [31.370805238277402, -0.179697672553037],
            [31.3590909015453, -0.180031247713727],
            [31.357566660832443, -0.17916292515461],
            [31.35410703577257, -0.176033532233927],
            [31.348563076708434, -0.175960704360794],
            [31.335215585721784, -0.177180400519043],
            [31.33253248415646, -0.177080675422627],
            [31.33125645963472, -0.185138313054074],
            [31.328923479146315, -0.190347135720964],
            [31.327907193505805, -0.191206163814054],
            [31.328222336880543, -0.192372805625714],
            [31.32770598076364, -0.193448927337552],
            [31.327216329763523, -0.197147657946803],
            [31.326744392642496, -0.19767213531403],
            [31.32698491566151, -0.198223807200564],
            [31.325377128932296, -0.199417378955954],
            [31.32401372079127, -0.201849929067534],
            [31.321636163203532, -0.203378024778008],
            [31.317697011156795, -0.210096888880985],
            [31.316019300464184, -0.211480341649975],
            [31.315544323444218, -0.211489339114578],
            [31.315145345693953, -0.212294157630123],
            [31.314480325584036, -0.212230781023447],
            [31.31464981342363, -0.212872880692098],
            [31.313568567011718, -0.214808048541767],
            [31.313449039874957, -0.216788546607842],
            [31.310807565341555, -0.226338072417372],
            [31.308529073065028, -0.232876173250121],
            [31.306030342626915, -0.238229548111365],
            [31.304670782868584, -0.247815340251489],
            [31.303984690078757, -0.250175562320973],
            [31.302526888764323, -0.25275273398102],
            [31.299762502242203, -0.256324481151958],
            [31.29674819901812, -0.262600152478266],
            [31.293485296022325, -0.267871958048322],
            [31.293439807132966, -0.269951916806077],
            [31.29522824686244, -0.275956913858024],
            [31.294664441732248, -0.282802630044079],
            [31.2928073186128, -0.291737144482701],
            [31.289012928277458, -0.3007527146821],
            [31.288057236697828, -0.301693062617518],
            [31.293860648978953, -0.305862941335463],
            [31.29550325710352, -0.308567152165314],
            [31.298084095355236, -0.310683706579511],
            [31.304835911184103, -0.312348764145289],
            [31.309577762734442, -0.312602742845099],
            [31.312548644092626, -0.312313831877851],
            [31.313000564952485, -0.312576170176129],
            [31.31487549088428, -0.314285670023823],
            [31.319065632221378, -0.315263026794866],
            [31.324049424332244, -0.314133410567696],
            [31.32954884941618, -0.315219501383211],
            [31.335800421311127, -0.315844503747658],
            [31.341889682007242, -0.318712272931534],
            [31.354008993642463, -0.32283809311452],
            [31.355335710095705, -0.324475190005842],
            [31.355910527672947, -0.326862796206063],
            [31.35719953913875, -0.329123901371643],
            [31.359684163331977, -0.333040198672215],
            [31.361910193097586, -0.335518519427622],
            [31.365404317955953, -0.337635317954691],
            [31.37161183467271, -0.338902464800092],
            [31.374722648399324, -0.340196237973775],
            [31.380443074314517, -0.343398668689603],
            [31.384039915237395, -0.345967688031528],
            [31.39743100954962, -0.339277559659423],
            [31.40124254692709, -0.335588323616292],
            [31.40840019016029, -0.326111552720586],
            [31.415253556938776, -0.321699231504044],
            [31.41734456273066, -0.320957960575628],
            [31.419327143664404, -0.318869130725174],
            [31.422795626112958, -0.316889042548388],
            [31.425314983666627, -0.316527680084782],
            [31.4299150136915, -0.31717048580835],
            [31.432504941097246, -0.316212219922297],
            [31.43533508699313, -0.317677771935583],
            [31.43802191477025, -0.318401695103898],
            [31.439887204473976, -0.317841241243732],
            [31.442573035121153, -0.317696950672065],
            [31.445209706362707, -0.31583428556656],
            [31.450474680140648, -0.315681316474754],
            [31.45451514867668, -0.315085021127972],
            [31.455703987208526, -0.315691142098164],
            [31.457723511358342, -0.314588063547523],
            [31.459910701564343, -0.314805448075706],
            [31.46238139288749, -0.313539641157205],
            [31.466138585783522, -0.315077688291178],
            [31.467992856751987, -0.315222666100057],
            [31.470228746426166, -0.316661011393646],
            [31.472201531231736, -0.3165165869586],
            [31.474602348897115, -0.316960106285052],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1380,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "LWEBITAKULI",
        Population: 61744,
        Key: "SSEMBABULELWEBITAKULI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.000513329829644, -0.607607302217042],
            [31.790882798521032, -0.578809323388322],
            [31.79023044824991, -0.579198130322285],
            [31.788357805835574, -0.578193696186245],
            [31.78740865578784, -0.578582439385228],
            [31.78586436108461, -0.578437383234276],
            [31.784399730777377, -0.577324500865983],
            [31.7849075600856, -0.575189928747645],
            [31.783594722603507, -0.571942391568784],
            [31.78423038846484, -0.570757590585857],
            [31.783961581090814, -0.569862046054768],
            [31.783604995737115, -0.569807705159275],
            [31.779093739025274, -0.570476100383905],
            [31.777820069886197, -0.571886882941263],
            [31.77390392818544, -0.573297109122549],
            [31.77372665195234, -0.573749331617545],
            [31.772480707517875, -0.574228464454556],
            [31.77006703046921, -0.577059103489304],
            [31.769027570989312, -0.57697747143108],
            [31.76748178598103, -0.576027388518826],
            [31.766947697120422, -0.576117726622279],
            [31.766326614509403, -0.57737486774506],
            [31.76597056994149, -0.577429068438635],
            [31.760861655087975, -0.576252078150639],
            [31.759882763617803, -0.576613678464143],
            [31.758321568010818, -0.575473641037883],
            [31.758468329372015, -0.574578196053285],
            [31.75736605968749, -0.572823187972394],
            [31.757393025315693, -0.571502588420583],
            [31.757748578505133, -0.571113724371343],
            [31.757387432404737, -0.568734767225739],
            [31.758140602396804, -0.566889707459598],
            [31.757159424714253, -0.566120653320427],
            [31.75668205278576, -0.564989895654719],
            [31.756736985663697, -0.56283714961736],
            [31.75724003413796, -0.562059383499831],
            [31.754695108734673, -0.558893023032495],
            [31.753833190490912, -0.558476761723029],
            [31.7529056467224, -0.555012264274542],
            [31.751954480855183, -0.554387935665813],
            [31.750721607806422, -0.554206781798405],
            [31.746598627214887, -0.551338589194874],
            [31.7433435189008, -0.550044448837782],
            [31.73691165153511, -0.552765667459138],
            [31.73088554240348, -0.552737243391363],
            [31.730010751301684, -0.552158169565765],
            [31.72961398700027, -0.550918905829106],
            [31.728468328687505, -0.549950837918496],
            [31.722810277294037, -0.547561722593551],
            [31.718591953111535, -0.54437695951993],
            [31.71306578068999, -0.537184975151866],
            [31.707808422829043, -0.533464251871408],
            [31.707043184869434, -0.534153616948212],
            [31.70495356427971, -0.534478803720182],
            [31.70114839685589, -0.536250814956529],
            [31.696440277044502, -0.540555225982203],
            [31.693727365784753, -0.542137507184723],
            [31.687534034364667, -0.544623529642522],
            [31.68515269576788, -0.546323460378127],
            [31.683470159325555, -0.548258703434046],
            [31.683252965554498, -0.548973210418458],
            [31.68423535955595, -0.551677860871653],
            [31.688831755895464, -0.555097864314376],
            [31.690892503733647, -0.555776700953679],
            [31.691313106627767, -0.557015953793427],
            [31.68772196282042, -0.560922571589182],
            [31.68683282742017, -0.563084109720462],
            [31.686207559558238, -0.569261671428435],
            [31.68398366778299, -0.574859976195058],
            [31.68267903551272, -0.581616226076745],
            [31.68338640490004, -0.582457575301451],
            [31.68694082288362, -0.583335760604667],
            [31.687364375845153, -0.58397806223156],
            [31.67891728456492, -0.59325615078673],
            [31.676187622420098, -0.60479679719446],
            [31.676076218748456, -0.605692219349337],
            [31.676917087668457, -0.608252131426054],
            [31.676895497558913, -0.60929229306306],
            [31.675978101159853, -0.610865872569233],
            [31.677597946873433, -0.616419851789253],
            [31.67859474176722, -0.618581830974723],
            [31.679538158766814, -0.619685558860491],
            [31.67993369417293, -0.621159973410795],
            [31.679540827661523, -0.623665308652593],
            [31.67978279696813, -0.625058299147482],
            [31.680816706656163, -0.626948942339016],
            [31.68762880932207, -0.637677963419023],
            [31.694519603508553, -0.647005084292342],
            [31.698952655586716, -0.654450249896628],
            [31.699972114975107, -0.656856475967893],
            [31.7034455354628, -0.659588980618661],
            [31.70596082364822, -0.659481095609488],
            [31.70721638993766, -0.659870356532664],
            [31.708561819196575, -0.663443496988938],
            [31.71042717807058, -0.665171572350618],
            [31.71029010414138, -0.668653874823861],
            [31.713504438823005, -0.673285779248661],
            [31.714158433909414, -0.675239685401362],
            [31.716621817437744, -0.678270424776343],
            [31.716591730163927, -0.679464370860468],
            [31.715164008038467, -0.680268998093485],
            [31.714802642749117, -0.681336212935894],
            [31.715887254250127, -0.682602801659898],
            [31.718124893842482, -0.683444587231762],
            [31.717306667857525, -0.685633278611223],
            [31.717358188934018, -0.68935080645976],
            [31.71882978118469, -0.691494888043974],
            [31.719714764571684, -0.696949295200793],
            [31.720533810718496, -0.699075106559771],
            [31.72164171283986, -0.700432165703893],
            [31.723156659582777, -0.701110958315289],
            [31.724832798223638, -0.702739536502583],
            [31.725072683438807, -0.704476256820471],
            [31.72601818812309, -0.705163936102483],
            [31.726952460273093, -0.707959124408443],
            [31.728539573174373, -0.710700227627375],
            [31.738497805933953, -0.72085159378813],
            [31.744029693437337, -0.727890251353954],
            [31.75043546564234, -0.733771388005665],
            [31.765123059776577, -0.741427731592788],
            [31.78496400482815, -0.748886554556832],
            [31.791913223644094, -0.752832221909311],
            [31.800992575272424, -0.752807606602209],
            [31.892175900202023, -0.79637744316399],
            [32.00050699401195, -0.818685384927538],
            [32.000513329829644, -0.607607302217042],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1381,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "KYESIIGA",
        Population: 24832,
        Key: "MASAKAKYESIIGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.00415065249292, 0.334162797965761],
            [32.995390977138214, 0.33386047599238],
            [32.992239325100485, 0.335343965386221],
            [32.98580284488576, 0.328771975091188],
            [32.98002833679722, 0.321883888078101],
            [32.978168206118184, 0.318024606129743],
            [32.97498226628435, 0.313308017620036],
            [32.97234193620462, 0.312024252566033],
            [32.966072698939655, 0.311623510171236],
            [32.95945517944913, 0.309219145313164],
            [32.957763486479124, 0.307966878732957],
            [32.95452935831848, 0.307716412284034],
            [32.950897186655496, 0.306764677992178],
            [32.95030012050358, 0.306013318966857],
            [32.949902085984334, 0.30345870543375],
            [32.950200625797656, 0.302306627687874],
            [32.9522903829313, 0.299401392143683],
            [32.952638678631594, 0.297998860770401],
            [32.95246021841892, 0.296808148224119],
            [32.95587281487704, 0.295494352721974],
            [32.95791280714059, 0.294041738639277],
            [32.959114034338505, 0.289299804802625],
            [32.957383314061, 0.286384986355667],
            [32.95495706239493, 0.28439834542755],
            [32.953161643654006, 0.281353255424078],
            [32.950476599032726, 0.278063903002756],
            [32.94640049163441, 0.276989149645333],
            [32.944718291162, 0.27601211020034],
            [32.94217882482071, 0.272836744027565],
            [32.93984963971437, 0.268635495213403],
            [32.94656229528507, 0.264939090062533],
            [32.963562285012955, 0.254045245218849],
            [32.96859272034831, 0.252368018926896],
            [32.972733524413385, 0.252596002844213],
            [32.98562501079887, 0.256357599010093],
            [32.990428991630885, 0.258458222525636],
            [32.99350224410053, 0.262920005949722],
            [32.995410898177944, 0.2643855549883],
            [32.99725485199538, 0.265199749622404],
            [33.00010165894483, 0.265753401440013],
            [33.00181621224217, 0.265427723427677],
            [33.00619964767224, 0.266779283484505],
            [33.01043751111051, 0.269645241656347],
            [33.022261489019684, 0.281581303481891],
            [33.02515682835068, 0.283486510017445],
            [33.031966531616476, 0.284447241024336],
            [33.03500744832914, 0.28636872884874],
            [33.043192036612005, 0.28802965521343],
            [33.04419489243898, 0.288615870379152],
            [33.04605503389781, 0.290846753066763],
            [33.04770490669811, 0.29449433175788],
            [33.04886363639656, 0.295340900053318],
            [33.04857594913018, 0.297304144545311],
            [33.04891255415534, 0.299167882762838],
            [33.05199534224174, 0.303551442609287],
            [33.04401953770227, 0.309002137058277],
            [33.03603501950455, 0.312853817328712],
            [33.03420523750906, 0.315198305954816],
            [33.02588801117789, 0.314863404706227],
            [33.022561123879335, 0.316705506964939],
            [33.0217294159786, 0.323738956053138],
            [33.019733288450354, 0.327925537041119],
            [33.01607370200151, 0.326418375416118],
            [33.0124141173493, 0.325915992649031],
            [33.0100852924674, 0.327423162434145],
            [33.00415065249292, 0.334162797965761],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1382,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "BUIKWE",
        Population: 18076,
        Key: "BUIKWEBUIKWE",
        Dist2: "Buikwe",
        "Sub Country": "Buikwe",
        id2_original: "Buikwe  Buikwe",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.77489069794109, 1.296709539184058],
            [32.74881795291399, 1.291247823452205],
            [32.73602982309182, 1.28802868364014],
            [32.7250177515196, 1.286239824924564],
            [32.72324173728711, 1.284809484978008],
            [32.72128822403934, 1.282306515673922],
            [32.719334909319265, 1.278015862242085],
            [32.71542798074008, 1.272294845737952],
            [32.707435995745726, 1.265858293642543],
            [32.70352904920023, 1.260673572778499],
            [32.693094449726935, 1.258393063360564],
            [32.69167348023746, 1.258839814402478],
            [32.68927572223393, 1.258526683369285],
            [32.68696700164807, 1.256291808095039],
            [32.685280184733415, 1.251956485838686],
            [32.683592992323, 1.25079429100473],
            [32.682971606081395, 1.24860431063795],
            [32.681950451572085, 1.24757627285129],
            [32.67977477147979, 1.246860936038391],
            [32.67684420920653, 1.246368963481085],
            [32.67235946537196, 1.246413097147918],
            [32.67258136541681, 1.247351653854655],
            [32.672248332991536, 1.247418649599627],
            [32.67321351796709, 1.25215611029711],
            [32.6729576795708, 1.256334768677198],
            [32.67230248703013, 1.258256437408735],
            [32.67130326758341, 1.259373607259486],
            [32.668716589384026, 1.260725205321086],
            [32.66436510523201, 1.260221860059531],
            [32.65899257436846, 1.2579530461868],
            [32.65379757575789, 1.256388144516462],
            [32.63843411615334, 1.255581593725233],
            [32.62831046492238, 1.253434962374573],
            [32.61783068019029, 1.257723835202142],
            [32.61374513239664, 1.260762257244697],
            [32.60859311727412, 1.268984727563353],
            [32.60539596377061, 1.269699303011675],
            [32.59953515632933, 1.266838136905268],
            [32.59065539418744, 1.261116230798188],
            [32.58639319898138, 1.257897766410063],
            [32.585235269681846, 1.257577069678589],
            [32.586252030531114, 1.253540429886949],
            [32.58757187577073, 1.250518915188788],
            [32.59075574588613, 1.247479597521506],
            [32.59396611001422, 1.247480098662614],
            [32.60060892426652, 1.238850195514632],
            [32.61276282014189, 1.218731243167821],
            [32.61810080629118, 1.211630026038057],
            [32.62168036093305, 1.204619014205571],
            [32.623232002957, 1.200602308925821],
            [32.62375172506126, 1.198023950835658],
            [32.62368793299798, 1.194133678628697],
            [32.61946763611508, 1.181096193855281],
            [32.62096072684716, 1.177857530139135],
            [32.622052408089424, 1.176799167206293],
            [32.62270425799893, 1.175424093137685],
            [32.62275020772403, 1.174202737262647],
            [32.623496767013954, 1.172447697549437],
            [32.62313604851161, 1.168665950748057],
            [32.62238420892448, 1.16581600459931],
            [32.62323600674823, 1.162631531669442],
            [32.6223171146542, 1.159202547855825],
            [32.62236411181492, 1.158533067131769],
            [32.62364542651539, 1.157139981973605],
            [32.62290792853172, 1.156280406563648],
            [32.62320180249545, 1.153665826194279],
            [32.62220255609928, 1.152516708555808],
            [32.6213324245589, 1.149947208380357],
            [32.618525115634164, 1.146635585687335],
            [32.6180717089608, 1.144943712746063],
            [32.618231580335305, 1.140338750578371],
            [32.62047142080009, 1.142076096207411],
            [32.62448843701904, 1.143786536215535],
            [32.62881218838163, 1.143316652823318],
            [32.63229091072609, 1.141598148163479],
            [32.64122538116712, 1.132371200392173],
            [32.64476286680591, 1.130037475564645],
            [32.64776400791442, 1.126428030487799],
            [32.65025730354507, 1.125152685182061],
            [32.6515965802426, 1.122673926057698],
            [32.65367217184255, 1.109610079750094],
            [32.65652806704773, 1.103494534190965],
            [32.65723607693385, 1.099450535273059],
            [32.65857586567109, 1.09720699370063],
            [32.664922161319474, 1.089499529783289],
            [32.670226084251496, 1.084234664373374],
            [32.671816818261675, 1.083339168331449],
            [32.680856246962136, 1.082724934631976],
            [32.68510676317119, 1.080798331595559],
            [32.689320563437946, 1.078048423515677],
            [32.69304680308425, 1.074728484031441],
            [32.695146643806986, 1.072249763903882],
            [32.69809073291181, 1.070585373421649],
            [32.70170125248153, 1.06995242581339],
            [32.70511214932711, 1.071364122522817],
            [32.70677525251488, 1.071364284191294],
            [32.709554625630915, 1.070921237967014],
            [32.712261079800385, 1.069283949605065],
            [32.71566989974105, 1.068931429420829],
            [32.72684550691581, 1.070551905342366],
            [32.73164782496623, 1.073022226375683],
            [32.73500516335626, 1.073692016670947],
            [32.74125901427704, 1.073855407693457],
            [32.74836205341571, 1.073141273591315],
            [32.75214777051698, 1.073521569713543],
            [32.76506111470996, 1.073549740426837],
            [32.78801119902846, 1.07513470436383],
            [32.79281110240739, 1.101670667594292],
            [32.796513501664364, 1.125790938104303],
            [32.80000313404798, 1.144093802995458],
            [32.80060730317885, 1.152571135448485],
            [32.800523197512064, 1.15829804852275],
            [32.796738317640624, 1.187348541079597],
            [32.79441803394047, 1.207324718896866],
            [32.792761869339934, 1.229255147109022],
            [32.79254199769099, 1.246345399061052],
            [32.79169483068251, 1.256613967089932],
            [32.78993275291336, 1.263308793485979],
            [32.788369185754036, 1.267515637769069],
            [32.785060693257535, 1.27441841553229],
            [32.7789978798617, 1.284903656838569],
            [32.77693506050848, 1.289635185289312],
            [32.77489069794109, 1.296709539184058],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1384,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "KALONGO",
        Population: 19472,
        Key: "NAKASONGOLAKALONGO",
        Dist2: "Nakasongola",
        "Sub Country": "Kalongo",
        id2_original: "NakasongolaKalongo",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49257970571457, 0.988606992736274],
            [32.49443685219023, 0.989244445605233],
            [32.500607720338344, 0.992708939603867],
            [32.50384846099775, 0.99507805496741],
            [32.509175431106705, 1.000888692985166],
            [32.5077544184981, 1.0025867361995],
            [32.50056140769388, 1.005356477214279],
            [32.50056076629675, 1.009557427957039],
            [32.49887330978163, 1.011523569301897],
            [32.49620871890102, 1.015813482502309],
            [32.49611971202605, 1.01715419569252],
            [32.49745140065436, 1.018942043243359],
            [32.49913834962136, 1.02028303805711],
            [32.50082546747164, 1.020551448023407],
            [32.503222804165304, 1.021892552641442],
            [32.504199581001274, 1.021892704432572],
            [32.505797600348416, 1.024127503911716],
            [32.51476509735083, 1.03145822002802],
            [32.51938143179809, 1.039279867535035],
            [32.522444687815266, 1.041246745982832],
            [32.524042661348325, 1.043928456684047],
            [32.52652859887847, 1.046789067967522],
            [32.527947792398614, 1.057336392857715],
            [32.52652640609086, 1.061268993217705],
            [32.5242171572956, 1.064307632691214],
            [32.51906643395044, 1.066630762063327],
            [32.51409361386249, 1.066987502064871],
            [32.50521385711048, 1.065913490803557],
            [32.49988616924762, 1.064303748147886],
            [32.49686674023656, 1.065912125600582],
            [32.49384719174952, 1.06823555374705],
            [32.491537144352016, 1.075922001862175],
            [32.490826615589846, 1.076726318328116],
            [32.48585384221424, 1.076814857712834],
            [32.48239097513451, 1.075026633604616],
            [32.480881283536014, 1.075652046422435],
            [32.47981537495924, 1.077528876889673],
            [32.47981523841531, 1.078333311488084],
            [32.48070246938714, 1.082802545991694],
            [32.482743696834206, 1.089595903382179],
            [32.48358636687635, 1.095003640019288],
            [32.4834971147613, 1.097640382756985],
            [32.482431301405946, 1.09889154109284],
            [32.472885380988714, 1.098577020598082],
            [32.467734922646564, 1.099023006908153],
            [32.46400540325115, 1.09866480848824],
            [32.46231830785875, 1.098128214927677],
            [32.46080894145041, 1.096876601808111],
            [32.46045484712495, 1.090709225609212],
            [32.45850308020211, 1.080519404014317],
            [32.457526610589944, 1.078731601520147],
            [32.444251500459025, 1.077030943414987],
            [32.4338182233058, 1.074034744594772],
            [32.430754921474566, 1.072738148045897],
            [32.42871284242463, 1.071218288565532],
            [32.42653727821504, 1.07126256956498],
            [32.42507232631094, 1.070740361439708],
            [32.42764438353073, 1.068266655202255],
            [32.42977987748877, 1.063553633310781],
            [32.43227317042445, 1.060496252059757],
            [32.432352316492555, 1.05928398450302],
            [32.43130727847478, 1.057293477763246],
            [32.43131941201931, 1.055438869876885],
            [32.43238038076038, 1.053231626640482],
            [32.43495824109692, 1.049948080120599],
            [32.43746442485692, 1.048510081668288],
            [32.448503620160835, 1.038062887153282],
            [32.45170278139902, 1.03612740938588],
            [32.45531418491098, 1.032979711091516],
            [32.464260950593285, 1.026675535415892],
            [32.46607125531677, 1.024386966868204],
            [32.467884166052905, 1.019899990661999],
            [32.47262951294801, 1.016082968853231],
            [32.47711941490892, 1.011306915940877],
            [32.47861989158923, 1.007317453887517],
            [32.48215645286161, 1.002848825356875],
            [32.48278528613692, 1.001256661313481],
            [32.48460476445607, 0.999384229745756],
            [32.488068740955185, 0.991939122519744],
            [32.49257970571457, 0.988606992736274],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1385,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "KAKOOGE TOWN COUNCIL",
        Population: 8976,
        Key: "NAKASONGOLAKAKOOGE TOWN COUNCIL",
        Dist2: "Nakasongola",
        "Sub Country": "Kakooge TC",
        id2_original: "NakasongolaKakooge TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.54310036883652, -0.700470351131256],
            [31.544553815118455, -0.697079147845731],
            [31.54703670915641, -0.694113381780648],
            [31.547889125919397, -0.692196215434945],
            [31.54866855546388, -0.688388757870568],
            [31.552891338883473, -0.681697173599569],
            [31.55538742737633, -0.678478098018166],
            [31.56246060741327, -0.664633132376015],
            [31.56620938938331, -0.657814706901197],
            [31.568216807836336, -0.655083832513538],
            [31.571063870805624, -0.652823523846065],
            [31.573864578909653, -0.652571064225788],
            [31.580682616744653, -0.653052368278965],
            [31.58534487306924, -0.650765427164613],
            [31.58651699934351, -0.648929683453168],
            [31.59103348964021, -0.638538726044909],
            [31.58871959116505, -0.627440402743588],
            [31.58508639721926, -0.621307203122734],
            [31.58310803297746, -0.616305036671762],
            [31.58393746544561, -0.609738903861873],
            [31.583123473220567, -0.606609293134343],
            [31.582305690105045, -0.599689981757779],
            [31.58252704038094, -0.59818864926905],
            [31.584774583001003, -0.592635887417821],
            [31.584060493317033, -0.586295485215205],
            [31.58127838213601, -0.582993506735272],
            [31.580762342226123, -0.579619768973228],
            [31.577741195636218, -0.57213918107956],
            [31.57683459878349, -0.565620119388481],
            [31.572081353002073, -0.561461050737167],
            [31.570003052083237, -0.554431014155079],
            [31.55493721690877, -0.558106599737527],
            [31.552530117324583, -0.559302530201668],
            [31.550632532288073, -0.561639897618377],
            [31.55473470969426, -0.567236025175489],
            [31.54940857771346, -0.572138969986],
            [31.54615867603479, -0.578489458612078],
            [31.54432642906216, -0.579574329121307],
            [31.541656958532926, -0.579691209229917],
            [31.530351555579387, -0.582166431981866],
            [31.5281495252049, -0.579063649512799],
            [31.528463127968912, -0.578086956611843],
            [31.52785220350711, -0.576983382944192],
            [31.52734472544019, -0.574215658715011],
            [31.523803012329655, -0.569945470264805],
            [31.522258121145054, -0.569137447741388],
            [31.51893042446444, -0.568328968783032],
            [31.513098602962444, -0.568125278623276],
            [31.510194588600744, -0.568805297669901],
            [31.507639724237162, -0.570267269496252],
            [31.506826327595167, -0.571551340260454],
            [31.506483002273352, -0.573649503251307],
            [31.506549569232533, -0.574526825781782],
            [31.507255694453203, -0.575630399027087],
            [31.5090386391881, -0.57717742357606],
            [31.51044348481653, -0.580668884560787],
            [31.509871125029886, -0.583535765522766],
            [31.50517991869864, -0.586898974132883],
            [31.501601361186722, -0.59053829200983],
            [31.496393868807186, -0.597045675315222],
            [31.49563275770798, -0.598624834803832],
            [31.491024189196366, -0.601003345418049],
            [31.483028867859023, -0.603225535243762],
            [31.48080430953386, -0.601381108419332],
            [31.479544913726325, -0.601190823381593],
            [31.478690215242512, -0.60147998772136],
            [31.478479988804775, -0.603333958583092],
            [31.476960678046215, -0.603885233961143],
            [31.475989971126605, -0.605440565887212],
            [31.47439935659237, -0.605964647873751],
            [31.473904896910522, -0.606552414998161],
            [31.47288867774536, -0.605890084688407],
            [31.47259921720464, -0.603026337679834],
            [31.467549632482353, -0.60120759580119],
            [31.4638924014162, -0.599066459305634],
            [31.4613293956212, -0.596957112524192],
            [31.460391954214867, -0.595414689871472],
            [31.45970421660975, -0.595194193219116],
            [31.45829719526171, -0.595760312376065],
            [31.45698383046856, -0.596955883695595],
            [31.451064529227548, -0.603203534925137],
            [31.475970285445477, -0.614520825830415],
            [31.476915235869246, -0.616727887822912],
            [31.476682656652297, -0.619251129337075],
            [31.479760474360226, -0.632139887001392],
            [31.4891925737394, -0.638573043150666],
            [31.489375149134343, -0.659085282777689],
            [31.49217189297302, -0.655857350828701],
            [31.493832653354538, -0.654664037677504],
            [31.505919169295385, -0.653157246960917],
            [31.513349991104818, -0.654344279859787],
            [31.516843209563042, -0.653269037727511],
            [31.524165847262793, -0.648052654232658],
            [31.525376046833784, -0.652493729685348],
            [31.525414611508914, -0.654139820461492],
            [31.526686183081804, -0.655958123521933],
            [31.526460236126596, -0.660543510213572],
            [31.5270260696527, -0.661194850567537],
            [31.52790154077916, -0.663881300198942],
            [31.527826938389744, -0.664568641270684],
            [31.526514801593585, -0.665942971011327],
            [31.525650629476782, -0.667823936459684],
            [31.526756293894767, -0.669615040763562],
            [31.52662007336511, -0.670700314642243],
            [31.527912909857395, -0.67295275543346],
            [31.52735307707737, -0.675620672168499],
            [31.529533246051123, -0.678334622870665],
            [31.531335140746922, -0.678534167824762],
            [31.533341752512822, -0.680425024457927],
            [31.533813403071274, -0.683210832575708],
            [31.53461469311819, -0.684215013782274],
            [31.535737692326233, -0.687154751126058],
            [31.53517656148064, -0.6923370232639],
            [31.537941477110483, -0.694381873897822],
            [31.540070309162346, -0.697783220354169],
            [31.54310036883652, -0.700470351131256],
          ],
          [
            [31.54005865891142, -0.639635163928079],
            [31.539461244213197, -0.639466600176877],
            [31.53814759914568, -0.636711575176675],
            [31.53755025451603, -0.636266340103463],
            [31.535937182099694, -0.636061389528792],
            [31.535340047675827, -0.634834246849559],
            [31.533818174922054, -0.633309274870131],
            [31.531290961601233, -0.633191272195479],
            [31.53060041676089, -0.627970657212495],
            [31.531320191882287, -0.625854724972398],
            [31.53109835022791, -0.623113447848942],
            [31.532482948728166, -0.623167975056635],
            [31.536165936290164, -0.622048410634486],
            [31.54003514820382, -0.619657909434903],
            [31.54410044617433, -0.618031035878718],
            [31.54483457367903, -0.618275426294039],
            [31.549104763891112, -0.624933586270203],
            [31.550788228293104, -0.626855304864111],
            [31.55179725374947, -0.627339839681812],
            [31.55230336368225, -0.628494455824064],
            [31.554212072556915, -0.630533193149804],
            [31.55541697296603, -0.632946180933418],
            [31.55544967703226, -0.633962443088359],
            [31.55184301213342, -0.635506854120558],
            [31.543785299206338, -0.635629733395972],
            [31.543044224131258, -0.634831229593724],
            [31.541250119625595, -0.637243899187243],
            [31.541002662510916, -0.639599339550276],
            [31.54005865891142, -0.639635163928079],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1386,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KASAALI",
        Population: 26552,
        Key: "KYOTERAKASAALI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.01402146031075, 0.095683161800567],
            [33.014733085915914, 0.096972718517835],
            [33.01933340250333, 0.101213648749043],
            [33.02869267097082, 0.108293691755202],
            [33.03108977140758, 0.109642269865175],
            [33.03903898042475, 0.113634769768608],
            [33.04400943794354, 0.114415520087076],
            [33.05456725752772, 0.118372520679323],
            [33.0596082211182, 0.120643803526376],
            [33.06777032906108, 0.125240491116509],
            [33.05825412581175, 0.136970680231143],
            [33.055261434256806, 0.139616124798414],
            [33.05569899464854, 0.140571936590024],
            [33.05549376104713, 0.141295100663912],
            [33.054878054853106, 0.14181164834215],
            [33.05183372274572, 0.142672565904582],
            [33.04913145472548, 0.144359956938996],
            [33.04752985559195, 0.147125710732153],
            [33.0463659210547, 0.147150750289814],
            [33.0463265757436, 0.150420771289743],
            [33.0472501408737, 0.151935972371284],
            [33.048481557753405, 0.152349205826568],
            [33.0503748766906, 0.152227312957915],
            [33.05066323769344, 0.152811874286565],
            [33.0496946445097, 0.154436805810189],
            [33.049292864015726, 0.159446368859708],
            [33.04883956244525, 0.16100213525414],
            [33.047046952736224, 0.162433442244445],
            [33.0456046213093, 0.16251642019194],
            [33.04283328542014, 0.163688435716242],
            [33.04104067840606, 0.16694517439048],
            [33.037280315355375, 0.169154368309926],
            [33.035652544704334, 0.171913261091617],
            [33.03205701801671, 0.17464104226605],
            [33.02707066930057, 0.177628119608793],
            [33.02326909603624, 0.182699918846832],
            [33.02290775410307, 0.18822245020895],
            [33.01749751645549, 0.193133142566063],
            [33.01387343951152, 0.195478597946061],
            [33.009148991921485, 0.196063378917762],
            [33.00643113633445, 0.200071781494039],
            [33.005864874311925, 0.201619128148835],
            [33.00482942311488, 0.202303219733898],
            [33.00227315288788, 0.207450186655365],
            [33.00101119598346, 0.209241851169216],
            [32.99965582776425, 0.209906480557383],
            [32.99235161720592, 0.206938753955312],
            [32.98453209527139, 0.204854023780286],
            [32.98304855093587, 0.203070077049201],
            [32.9822449656934, 0.201161672001114],
            [32.980874749220845, 0.19930512346264],
            [32.9796590672317, 0.198682816607908],
            [32.97428949811365, 0.198347252049331],
            [32.96962228398702, 0.195228674611995],
            [32.96598764016036, 0.193607011959441],
            [32.96172837166548, 0.193163400347835],
            [32.95786951373377, 0.192200420791797],
            [32.94737137192886, 0.194305858618734],
            [32.94582601182368, 0.194928159348584],
            [32.94531088639873, 0.196421691426689],
            [32.94542420707521, 0.198278238492715],
            [32.94493998459435, 0.201317163129515],
            [32.94441455998465, 0.201908352436003],
            [32.94340492457222, 0.202053553419678],
            [32.94109719392983, 0.200642985249737],
            [32.937460449842014, 0.200321446940291],
            [32.93196926769911, 0.201825329754452],
            [32.931042056307255, 0.201161532763122],
            [32.929167022577644, 0.200746654689112],
            [32.92642659592077, 0.198589316023451],
            [32.92416010513644, 0.190831229759402],
            [32.92343894391454, 0.189586614503506],
            [32.92003916282228, 0.188341988378374],
            [32.91553702311224, 0.188124159775634],
            [32.912549344156574, 0.186049793756643],
            [32.91078764906972, 0.183674652423415],
            [32.90842843597841, 0.177627907607396],
            [32.9073569955761, 0.176321060935845],
            [32.904771110589124, 0.174423016768224],
            [32.8971576765538, 0.171446282970682],
            [32.894499669425926, 0.170906936881111],
            [32.89117200867793, 0.170523163023908],
            [32.8833216080538, 0.170585347725607],
            [32.86907407791603, 0.125328078443946],
            [32.873850698759426, 0.113066690667689],
            [32.87917371178957, 0.099616421474059],
            [32.884532014237315, 0.069344406450593],
            [32.88869167483854, 0.06906050489192],
            [32.890277993629084, 0.065582595229113],
            [32.89498406348499, 0.059460767065094],
            [32.901664204533986, 0.054652031141077],
            [32.907304427962295, 0.051990370819442],
            [32.91645216294334, 0.049452925783706],
            [32.91994204865186, 0.048885107189903],
            [32.927820732732705, 0.048618949044004],
            [32.9398943326964, 0.049985286983587],
            [32.945146789349145, 0.051511317440156],
            [32.95605709347779, 0.055539323686406],
            [32.967778184642526, 0.060702976519919],
            [32.971091816400744, 0.062406449911726],
            [32.98334168199286, 0.070125307755424],
            [33.00100264671691, 0.084143456516976],
            [33.00519756798966, 0.086698662993669],
            [33.00849357749692, 0.089342591299204],
            [33.01332302736389, 0.094417513663657],
            [33.01402146031075, 0.095683161800567],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1387,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "SSI-BUKUNJA",
        Population: 25558,
        Key: "BUIKWESSI-BUKUNJA",
        Dist2: "Buikwe",
        "Sub Country": "Ssi - Bukunja",
        id2_original: "Buikwe  Ssi - Bukunja",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.12677877091785, 0.184730804329637],
            [33.12328198435132, 0.189005559501192],
            [33.10475337372526, 0.207867610365009],
            [33.096679460580354, 0.219226506335052],
            [33.08674232924676, 0.234441170089941],
            [33.06585870335669, 0.254312763572938],
            [33.06445367626858, 0.256614191216862],
            [33.06356148300311, 0.259214278276308],
            [33.06144837506197, 0.261672548349512],
            [33.06065009167631, 0.263421698963843],
            [33.05941981565706, 0.269548444764479],
            [33.05765420301726, 0.273443850937243],
            [33.05684654481329, 0.278795298179526],
            [33.05565645402995, 0.283059817269129],
            [33.05077582714125, 0.290902068812495],
            [33.04886363639656, 0.295340900053318],
            [33.04770490669811, 0.29449433175788],
            [33.04605503389781, 0.290846753066763],
            [33.04419489243898, 0.288615870379152],
            [33.043192036612005, 0.28802965521343],
            [33.03500744832914, 0.28636872884874],
            [33.031966531616476, 0.284447241024336],
            [33.02515682835068, 0.283486510017445],
            [33.022261489019684, 0.281581303481891],
            [33.01043751111051, 0.269645241656347],
            [33.00619964767224, 0.266779283484505],
            [33.00181621224217, 0.265427723427677],
            [33.00010165894483, 0.265753401440013],
            [32.99725485199538, 0.265199749622404],
            [32.995410898177944, 0.2643855549883],
            [32.99350224410053, 0.262920005949722],
            [32.990428991630885, 0.258458222525636],
            [32.98562501079887, 0.256357599010093],
            [32.972733524413385, 0.252596002844213],
            [32.96859272034831, 0.252368018926896],
            [32.963562285012955, 0.254045245218849],
            [32.94656229528507, 0.264939090062533],
            [32.93984963971437, 0.268635495213403],
            [32.92874617174849, 0.266939560955661],
            [32.92391357508313, 0.268979636909599],
            [32.92364302857069, 0.26710068732346],
            [32.92464248517265, 0.263966111786103],
            [32.924110046517214, 0.260924643076132],
            [32.926131332263296, 0.259718647492149],
            [32.92613134663632, 0.257128440107863],
            [32.928424588351525, 0.255157644103553],
            [32.929375447893236, 0.253806237310003],
            [32.93038224732433, 0.250934491342228],
            [32.93273142264068, 0.248456913705697],
            [32.934633130944334, 0.247330746798735],
            [32.93577976752243, 0.242910507419768],
            [32.93706622507789, 0.240207688499044],
            [32.93572388512523, 0.232155515629124],
            [32.935835759514084, 0.230072087906597],
            [32.940566996571015, 0.221080919920812],
            [32.93864815559829, 0.215627306301191],
            [32.93575924910303, 0.217006938064974],
            [32.93328706927146, 0.217310441585238],
            [32.932141422636796, 0.218099575323022],
            [32.92683527817108, 0.219495716876213],
            [32.926620049913836, 0.220335834904416],
            [32.92594038726483, 0.220609526189046],
            [32.92037393169101, 0.219946044406747],
            [32.91662800366861, 0.225983440068877],
            [32.91583516676851, 0.227942561399356],
            [32.910602654511685, 0.227816903356309],
            [32.9095145054451, 0.232286312853426],
            [32.90764290148325, 0.237588255341646],
            [32.90481376170048, 0.241093660302804],
            [32.90452491201415, 0.243333858042262],
            [32.90260615548305, 0.242496863892041],
            [32.8998531245644, 0.240214703381461],
            [32.89893792634283, 0.238355004840601],
            [32.897632215195884, 0.233732217499852],
            [32.89607805070261, 0.231346318942374],
            [32.89512696209051, 0.228784974120295],
            [32.8948600079409, 0.201656226543732],
            [32.8920799844446, 0.190488120136297],
            [32.89132423449104, 0.189890309879628],
            [32.88936996576011, 0.189933067655626],
            [32.8833216080538, 0.170585347725607],
            [32.89117200867793, 0.170523163023908],
            [32.894499669425926, 0.170906936881111],
            [32.8971576765538, 0.171446282970682],
            [32.904771110589124, 0.174423016768224],
            [32.9073569955761, 0.176321060935845],
            [32.90842843597841, 0.177627907607396],
            [32.91078764906972, 0.183674652423415],
            [32.912549344156574, 0.186049793756643],
            [32.91553702311224, 0.188124159775634],
            [32.92003916282228, 0.188341988378374],
            [32.92343894391454, 0.189586614503506],
            [32.92416010513644, 0.190831229759402],
            [32.92642659592077, 0.198589316023451],
            [32.929167022577644, 0.200746654689112],
            [32.931042056307255, 0.201161532763122],
            [32.93196926769911, 0.201825329754452],
            [32.937460449842014, 0.200321446940291],
            [32.94109719392983, 0.200642985249737],
            [32.94340492457222, 0.202053553419678],
            [32.94441455998465, 0.201908352436003],
            [32.94493998459435, 0.201317163129515],
            [32.94542420707521, 0.198278238492715],
            [32.94531088639873, 0.196421691426689],
            [32.94582601182368, 0.194928159348584],
            [32.94737137192886, 0.194305858618734],
            [32.95786951373377, 0.192200420791797],
            [32.96172837166548, 0.193163400347835],
            [32.96598764016036, 0.193607011959441],
            [32.96962228398702, 0.195228674611995],
            [32.97428949811365, 0.198347252049331],
            [32.9796590672317, 0.198682816607908],
            [32.980874749220845, 0.19930512346264],
            [32.9822449656934, 0.201161672001114],
            [32.98304855093587, 0.203070077049201],
            [32.98453209527139, 0.204854023780286],
            [32.99235161720592, 0.206938753955312],
            [32.99965582776425, 0.209906480557383],
            [33.00101119598346, 0.209241851169216],
            [33.00227315288788, 0.207450186655365],
            [33.00482942311488, 0.202303219733898],
            [33.005864874311925, 0.201619128148835],
            [33.00643113633445, 0.200071781494039],
            [33.009148991921485, 0.196063378917762],
            [33.01387343951152, 0.195478597946061],
            [33.01749751645549, 0.193133142566063],
            [33.02290775410307, 0.18822245020895],
            [33.02326909603624, 0.182699918846832],
            [33.02707066930057, 0.177628119608793],
            [33.03205701801671, 0.17464104226605],
            [33.035652544704334, 0.171913261091617],
            [33.037280315355375, 0.169154368309926],
            [33.04104067840606, 0.16694517439048],
            [33.04283328542014, 0.163688435716242],
            [33.0456046213093, 0.16251642019194],
            [33.047046952736224, 0.162433442244445],
            [33.04883956244525, 0.16100213525414],
            [33.049292864015726, 0.159446368859708],
            [33.0496946445097, 0.154436805810189],
            [33.05066323769344, 0.152811874286565],
            [33.0503748766906, 0.152227312957915],
            [33.048481557753405, 0.152349205826568],
            [33.0472501408737, 0.151935972371284],
            [33.0463265757436, 0.150420771289743],
            [33.0463659210547, 0.147150750289814],
            [33.04752985559195, 0.147125710732153],
            [33.04913145472548, 0.144359956938996],
            [33.05183372274572, 0.142672565904582],
            [33.054878054853106, 0.14181164834215],
            [33.05549376104713, 0.141295100663912],
            [33.05569899464854, 0.140571936590024],
            [33.055261434256806, 0.139616124798414],
            [33.05825412581175, 0.136970680231143],
            [33.06777032906108, 0.125240491116509],
            [33.07737498582316, 0.131361418246887],
            [33.09038894042966, 0.142882532975598],
            [33.093469360556945, 0.146668211041354],
            [33.10451356756183, 0.163491140432876],
            [33.12677877091785, 0.184730804329637],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1388,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "NGOGWE",
        Population: 35524,
        Key: "BUIKWENGOGWE",
        Dist2: "Buikwe",
        "Sub Country": "Ngogwe",
        id2_original: "Buikwe  Ngogwe",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.18164560381903, 0.291967416533535],
            [33.17826786828216, 0.297564203315938],
            [33.16915882463873, 0.304233740301326],
            [33.16356925361603, 0.313195826904348],
            [33.16281981073406, 0.316793487517731],
            [33.16188013521761, 0.318466220992513],
            [33.162939793316646, 0.321327000663687],
            [33.1629879969148, 0.32375140291102],
            [33.1626508555954, 0.324284777166746],
            [33.157954873820124, 0.326442572942213],
            [33.15583564296201, 0.326297141650394],
            [33.15429439803916, 0.327072975203947],
            [33.152849470481065, 0.327121486133694],
            [33.14976696985557, 0.328042807485102],
            [33.14745510067465, 0.329303533615375],
            [33.14663630785272, 0.329352033754683],
            [33.14519139376939, 0.330321817306287],
            [33.14470976562304, 0.331437050846566],
            [33.14191623775311, 0.331679532624436],
            [33.141434600623626, 0.332067444707838],
            [33.141025225772225, 0.333643314651712],
            [33.1369794203451, 0.333691861481389],
            [33.13654593381317, 0.333110010064926],
            [33.13514917032732, 0.333352469344206],
            [33.13418589786502, 0.33446771062696],
            [33.133559762230526, 0.334467718711663],
            [33.13177769964125, 0.335970875390345],
            [33.13139240502937, 0.337474013871788],
            [33.12676869721024, 0.343098701446393],
            [33.11990524145282, 0.341135019242138],
            [33.110224173992655, 0.339825957137058],
            [33.1090441497304, 0.34014114347178],
            [33.10667308336888, 0.342167890080984],
            [33.10120582785357, 0.340992686402087],
            [33.078232924530205, 0.338052070610986],
            [33.075660348084156, 0.338366747667588],
            [33.0693009639821, 0.328745547090609],
            [33.069120634375366, 0.327474818312634],
            [33.06591088649155, 0.321605272799182],
            [33.06398745602601, 0.319910977011042],
            [33.05742372855301, 0.309551531495464],
            [33.05199534224174, 0.303551442609287],
            [33.04891255415534, 0.299167882762838],
            [33.04857594913018, 0.297304144545311],
            [33.04886363639656, 0.295340900053318],
            [33.05077582714125, 0.290902068812495],
            [33.05565645402995, 0.283059817269129],
            [33.05684654481329, 0.278795298179526],
            [33.05765420301726, 0.273443850937243],
            [33.05941981565706, 0.269548444764479],
            [33.06065009167631, 0.263421698963843],
            [33.06144837506197, 0.261672548349512],
            [33.06356148300311, 0.259214278276308],
            [33.06445367626858, 0.256614191216862],
            [33.06585870335669, 0.254312763572938],
            [33.08674232924676, 0.234441170089941],
            [33.096679460580354, 0.219226506335052],
            [33.10475337372526, 0.207867610365009],
            [33.12328198435132, 0.189005559501192],
            [33.12677877091785, 0.184730804329637],
            [33.13195072594474, 0.188243382638752],
            [33.1420865538394, 0.197124409684831],
            [33.143940470871605, 0.199369947297833],
            [33.145158289054514, 0.20160706564589],
            [33.14903355740983, 0.209948865482935],
            [33.154758537783515, 0.217414328305324],
            [33.160420741190194, 0.223805458202972],
            [33.18065486896019, 0.244697690395755],
            [33.18088924031611, 0.246130121824464],
            [33.17888684434386, 0.260999245590034],
            [33.17649254485414, 0.279236583143876],
            [33.17695500025734, 0.28578503151418],
            [33.17844813770179, 0.289179169783637],
            [33.17989308592115, 0.290779251830868],
            [33.18164560381903, 0.291967416533535],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1389,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "NAJJA",
        Population: 43985,
        Key: "BUIKWENAJJA",
        Dist2: "Buikwe",
        "Sub Country": "Najja",
        id2_original: "Buikwe  Najja",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19668907004464, 0.413263470526049],
            [33.191862082459885, 0.412508016869205],
            [33.19476836596599, 0.407376792544393],
            [33.195046273273846, 0.403229548917249],
            [33.195647150079225, 0.401197924215046],
            [33.19506611166861, 0.39917331647709],
            [33.19602560042694, 0.396381929191091],
            [33.19588535454646, 0.394884096927717],
            [33.193755003443435, 0.392424606358401],
            [33.18867501254543, 0.389785216323929],
            [33.18320772289416, 0.388375600804192],
            [33.18070042881644, 0.387333145073483],
            [33.178798109658395, 0.385841166281617],
            [33.17617177892407, 0.385693082363571],
            [33.17491370453833, 0.385096487849025],
            [33.1742246733592, 0.385451335923225],
            [33.170455693668316, 0.385586388280797],
            [33.16822488756035, 0.384889059854626],
            [33.16412885732563, 0.378511853662129],
            [33.163494698837326, 0.37948843126591],
            [33.15919334067815, 0.38065251985398],
            [33.156817325497755, 0.382513420441694],
            [33.15590112745126, 0.383981966889512],
            [33.1536964766911, 0.391210673926764],
            [33.1506260790674, 0.393209887038844],
            [33.15001692428674, 0.394150199721781],
            [33.149891423353345, 0.397166446846455],
            [33.14848258471348, 0.398154490809553],
            [33.14684390043006, 0.398634431995468],
            [33.14434121470976, 0.401184007855841],
            [33.14307496385832, 0.401888900345527],
            [33.13511985111309, 0.402024013520737],
            [33.13436015935203, 0.406013292989264],
            [33.13148502133515, 0.407663037960723],
            [33.1311275529375, 0.411682306817843],
            [33.13231938735083, 0.414966684817011],
            [33.132617421412654, 0.420320696601579],
            [33.13163426923308, 0.424234994647139],
            [33.130889437403475, 0.42607966933015],
            [33.12983661638204, 0.427418162400122],
            [33.13091131407559, 0.424824325398355],
            [33.13067383365045, 0.423551433153065],
            [33.12649096956544, 0.422975656614945],
            [33.12255320900907, 0.419213841079008],
            [33.11853359306572, 0.416994766764753],
            [33.118774402647304, 0.415976512868365],
            [33.125059839231795, 0.41120033177266],
            [33.1282904406066, 0.408249913120362],
            [33.129116230406254, 0.406356238688844],
            [33.12919646433417, 0.402973049420883],
            [33.128563238297126, 0.401226291417918],
            [33.125744327630514, 0.402270418926941],
            [33.12349005483236, 0.399852527829482],
            [33.12124800541028, 0.406171614386428],
            [33.12053226282618, 0.405575775910263],
            [33.10690141355453, 0.389186964744075],
            [33.10632337192371, 0.383950248987366],
            [33.10507107011198, 0.382301665296243],
            [33.10362077332344, 0.381675955894633],
            [33.10216424222684, 0.378002248710375],
            [33.100200919376164, 0.374581455238918],
            [33.1000876346323, 0.372985076050564],
            [33.0992607767358, 0.37303009057381],
            [33.098799322055804, 0.367354627922803],
            [33.10275897275901, 0.365815710592914],
            [33.10391490959526, 0.364651980261375],
            [33.107190036865425, 0.359366729207787],
            [33.10849046232522, 0.357863580737055],
            [33.109646407246316, 0.357572636460105],
            [33.110513357852305, 0.356651351182998],
            [33.114617328295765, 0.350018381935783],
            [33.10931165364894, 0.349482387853377],
            [33.10504789447597, 0.349840138846517],
            [33.102832243845164, 0.349544216845658],
            [33.10485387723922, 0.343341411101639],
            [33.10667308336888, 0.342167890080984],
            [33.1090441497304, 0.34014114347178],
            [33.110224173992655, 0.339825957137058],
            [33.11990524145282, 0.341135019242138],
            [33.12676869721024, 0.343098701446393],
            [33.13139240502937, 0.337474013871788],
            [33.13177769964125, 0.335970875390345],
            [33.133559762230526, 0.334467718711663],
            [33.13418589786502, 0.33446771062696],
            [33.13514917032732, 0.333352469344206],
            [33.13654593381317, 0.333110010064926],
            [33.1369794203451, 0.333691861481389],
            [33.141025225772225, 0.333643314651712],
            [33.141434600623626, 0.332067444707838],
            [33.14191623775311, 0.331679532624436],
            [33.14470976562304, 0.331437050846566],
            [33.14519139376939, 0.330321817306287],
            [33.14663630785272, 0.329352033754683],
            [33.14745510067465, 0.329303533615375],
            [33.14976696985557, 0.328042807485102],
            [33.152849470481065, 0.327121486133694],
            [33.15429439803916, 0.327072975203947],
            [33.15583564296201, 0.326297141650394],
            [33.157954873820124, 0.326442572942213],
            [33.1626508555954, 0.324284777166746],
            [33.1629879969148, 0.32375140291102],
            [33.162939793316646, 0.321327000663687],
            [33.16188013521761, 0.318466220992513],
            [33.16281981073406, 0.316793487517731],
            [33.16356925361603, 0.313195826904348],
            [33.16915882463873, 0.304233740301326],
            [33.17826786828216, 0.297564203315938],
            [33.18164560381903, 0.291967416533535],
            [33.20831018590477, 0.307991977299397],
            [33.216883521923464, 0.314586160944449],
            [33.22856347384146, 0.322319724902177],
            [33.24318143416809, 0.329616799721982],
            [33.251658427669206, 0.33451385450015],
            [33.28909014578349, 0.358500428015008],
            [33.29116065202061, 0.376125303587345],
            [33.290368673011606, 0.379015890947618],
            [33.288883624896314, 0.381806827645224],
            [33.282177606977264, 0.388869506542161],
            [33.27255845589805, 0.394551493705155],
            [33.26703775691154, 0.39670492239372],
            [33.25714776467251, 0.399808448571806],
            [33.253556400777896, 0.400894237308223],
            [33.25141246445284, 0.401002865220739],
            [33.24637367658197, 0.40304770026922],
            [33.22632389119315, 0.405029652509269],
            [33.20555429744523, 0.408151524042665],
            [33.19992598298265, 0.410096836382934],
            [33.19668907004464, 0.413263470526049],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1390,
        District: "BUIKWE",
        County: "NJERU MUNICIPALITY",
        Subcounty: "NYENGA DIVISION",
        Population: 49625,
        Key: "BUIKWENYENGA DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Nyenga",
        id2_original: "Buikwe  Nyenga",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.53825903527751, 0.151833503703474],
            [33.53207941843685, 0.149666663347357],
            [33.52978887795575, 0.148181380399118],
            [33.529103955670735, 0.147407623594979],
            [33.52793796938139, 0.144039738198775],
            [33.52820193214112, 0.14015785670745],
            [33.52731221014101, 0.139952165579818],
            [33.49542827162576, 0.150928918641091],
            [33.47634777920828, 0.159888908691324],
            [33.42622443279123, 0.210017076799311],
            [33.42622440404516, 0.216060943367974],
            [33.42608562691016, 0.174182219080696],
            [33.40602629332816, 0.162440732941988],
            [33.39636718788006, 0.159807315031635],
            [33.386351640808705, 0.160305233979425],
            [33.38179110521533, 0.16092576348502],
            [33.36859742107671, 0.1634543994873],
            [33.36658513644977, 0.164872542445726],
            [33.36417038232105, 0.165885519862849],
            [33.36085143972289, 0.164785128645457],
            [33.361056495457866, 0.135027742932815],
            [33.361570250053674, 0.126605443758199],
            [33.36105626189589, 0.11855564455351],
            [33.361487818846584, 0.110754154856578],
            [33.36139678716895, 0.054606381474025],
            [33.361117229655896, 0.041347858022752],
            [33.3616926967151, 0.02110952655362],
            [33.36158989171737, -0.007923578260231],
            [33.36222710896919, -0.017587483155942],
            [33.361713251965455, -0.026630581690034],
            [33.36177518541437, -0.076688367780004],
            [33.36122028438528, -0.086683375481664],
            [33.36179605597337, -0.108742730912535],
            [33.36130297610383, -0.127946385318699],
            [33.36239367638583, -0.2002290503879],
            [33.362065257707854, -0.220632928925333],
            [33.362621038187605, -0.251487040660806],
            [33.363265432978565, -0.395663924732592],
            [33.36519796607289, -0.999253787260018],
            [33.52012788963881, -0.999186087940215],
            [33.52357513681237, -0.999184497265765],
            [33.52111824091705, -0.395823423993092],
            [33.52111380144292, -0.316132512722443],
            [33.5218972994573, -0.149301553325893],
            [33.5215608920615, -0.094604432158739],
            [33.522165832845175, -0.026934334393759],
            [33.537153390622464, 0.01642629661636],
            [33.54348710806022, 0.044674295225891],
            [33.55606861458724, 0.08597208485716],
            [33.55452596200434, 0.08775379685252],
            [33.553579812329644, 0.089925644815817],
            [33.548205553107515, 0.093774068361348],
            [33.54752431211854, 0.094498024163276],
            [33.547032323702034, 0.096174536877337],
            [33.54521567507601, 0.097698661322756],
            [33.54307736849283, 0.101851859433835],
            [33.542074466851744, 0.104995326290979],
            [33.54197992365968, 0.109148489311398],
            [33.540390371832416, 0.11128225455614],
            [33.5403903889004, 0.11219671262354],
            [33.53917929281077, 0.113339808523701],
            [33.5382710071253, 0.116083201308989],
            [33.53743837755308, 0.116845265742985],
            [33.5367571886664, 0.120122089212058],
            [33.53380520786178, 0.126066133403582],
            [33.5374387728118, 0.135667869838439],
            [33.5386500018521, 0.140440108320167],
            [33.53902863635446, 0.147136663854281],
            [33.53825903527751, 0.151833503703474],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1391,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "LUBYA",
        Population: 6458,
        Key: "BUVUMALUBYA",
        Dist2: "Buvuma",
        "Sub Country": "Lubya",
        id2_original: "Buvuma Lubya",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.391363881666315, 0.303202406200234],
            [33.38989625098605, 0.306233090460926],
            [33.385551911135444, 0.310719254189282],
            [33.36628687421589, 0.321690941082941],
            [33.34991107347328, 0.329886873739277],
            [33.34434161393313, 0.331794815984088],
            [33.33837496518847, 0.332688041667594],
            [33.31538089576039, 0.333541124935424],
            [33.31864379426461, 0.330188177161535],
            [33.321154582788765, 0.325421346921661],
            [33.325100155993155, 0.319498895662734],
            [33.3250282665159, 0.314804374605145],
            [33.32725191754266, 0.304404130340971],
            [33.32807262647107, 0.302201311567708],
            [33.32931301662211, 0.294551784549443],
            [33.33049416737176, 0.290777307003331],
            [33.33141828766074, 0.278781793067437],
            [33.3327480736573, 0.270414484745536],
            [33.33210805006851, 0.268398550989603],
            [33.3304476076906, 0.266392724635727],
            [33.32579830956398, 0.258369356691687],
            [33.32419316657666, 0.254413370300065],
            [33.31899057899858, 0.25285337755086],
            [33.307171646028046, 0.24804564008303],
            [33.30593280187757, 0.247858005336753],
            [33.30535058128405, 0.243072115580965],
            [33.305835651774544, 0.242095389720192],
            [33.306514678416335, 0.237504814246997],
            [33.30489948867088, 0.235566997605953],
            [33.303376787670445, 0.234924739930677],
            [33.30470574452199, 0.228729160439923],
            [33.30527629061006, 0.223486848860157],
            [33.303953225808485, 0.21947493899617],
            [33.30919367737579, 0.223439694852891],
            [33.31540812998484, 0.223840272146146],
            [33.31836138370221, 0.228803863743488],
            [33.31982511299918, 0.228648716048703],
            [33.32067250368818, 0.22717511065392],
            [33.32751034488359, 0.227563037868341],
            [33.329505425874515, 0.230215563869716],
            [33.330539882636586, 0.233732577721291],
            [33.332513002513736, 0.233382732638829],
            [33.3325365563405, 0.232603829659081],
            [33.340036254677685, 0.232893244692774],
            [33.34218653490531, 0.234894195671122],
            [33.346816618067976, 0.236163734409646],
            [33.35221383733045, 0.236584336419421],
            [33.35563174732347, 0.238374117231184],
            [33.36313328361375, 0.239312814411034],
            [33.3709186048888, 0.23845534848412],
            [33.37134885389246, 0.241521055161519],
            [33.37155460312679, 0.25268921292858],
            [33.372384073324184, 0.257932262470599],
            [33.378924811112405, 0.260043949263054],
            [33.39232952568096, 0.262370226602546],
            [33.40699520810879, 0.267088728182014],
            [33.397290740433775, 0.277135399951839],
            [33.396192942562735, 0.278940810057269],
            [33.394638035162735, 0.284784353929887],
            [33.39307584691732, 0.296779613621953],
            [33.39228537617971, 0.300746591849469],
            [33.391363881666315, 0.303202406200234],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1392,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "BUWOOYA",
        Population: 12833,
        Key: "BUVUMABUWOOYA",
        Dist2: "Buvuma",
        "Sub Country": "Buwooya",
        id2_original: "Buvuma Buwooya",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.23362286014221, 0.938346697453726],
            [34.23188997133158, 0.940299588904172],
            [34.228395509605, 0.939432655236967],
            [34.22711333701346, 0.94083554769784],
            [34.22640559213033, 0.940635456077188],
            [34.225962916731355, 0.939567081723437],
            [34.22481359329224, 0.941437406905172],
            [34.22151903366582, 0.943063625424153],
            [34.22127494343684, 0.940695142879548],
            [34.220456596179304, 0.940450563688642],
            [34.219461022096, 0.939293342566852],
            [34.218488131371934, 0.939783432521227],
            [34.216939893962916, 0.939249705579622],
            [34.21583428434215, 0.939650793450108],
            [34.21477260593205, 0.939183685582463],
            [34.21406501915239, 0.939473327281781],
            [34.213511972246046, 0.938961516242527],
            [34.2133126001519, 0.938004363955615],
            [34.21256072822541, 0.938115933233856],
            [34.210967960429436, 0.936691777604162],
            [34.20941966732486, 0.936002224067854],
            [34.20830834980877, 0.933886727116123],
            [34.209328720987145, 0.932979678420856],
            [34.21126099177342, 0.932192066260753],
            [34.21470231635433, 0.93134061280473],
            [34.2165353718107, 0.929928538771462],
            [34.21716678235255, 0.929919645723268],
            [34.217137364323605, 0.929595152292438],
            [34.21930352047723, 0.929587085584697],
            [34.21967824191824, 0.92888129394484],
            [34.221601846656945, 0.928421117831116],
            [34.222465242629326, 0.926484355010599],
            [34.22083082624182, 0.914432871032021],
            [34.21978700364462, 0.91315318964145],
            [34.21841736119554, 0.91259569407846],
            [34.21729169309278, 0.910339600233789],
            [34.217421244529824, 0.907746658380117],
            [34.21856145635702, 0.90476771721567],
            [34.217288903823835, 0.902011140171299],
            [34.21728748807894, 0.897752546995012],
            [34.21660191451536, 0.895176281233601],
            [34.21519956530509, 0.89427416109652],
            [34.21378272537101, 0.894051299148281],
            [34.213162320988005, 0.895272917381363],
            [34.214008865463995, 0.897245277594326],
            [34.21392531315943, 0.898567652684839],
            [34.21085010415907, 0.90038661308723],
            [34.20723800085951, 0.899990151047752],
            [34.20608051173447, 0.898371440736225],
            [34.204020746653214, 0.898940236106356],
            [34.20190170444129, 0.898837232682022],
            [34.1995471365383, 0.897082977311442],
            [34.19713213177959, 0.894075640528677],
            [34.194715940346455, 0.887373618893377],
            [34.19248895656999, 0.882956986030172],
            [34.19153758588687, 0.872306615734551],
            [34.19026159100953, 0.868504812856597],
            [34.189475915478894, 0.867559057392835],
            [34.18862856880736, 0.858276941630894],
            [34.19462819560443, 0.849532297953766],
            [34.195846479114664, 0.843195763101459],
            [34.19744997638837, 0.843437958597807],
            [34.20033482429517, 0.846174477432334],
            [34.20041095741381, 0.847865830157965],
            [34.20222776863491, 0.84901433326655],
            [34.20169962931645, 0.851909006035206],
            [34.204071246345215, 0.853571760657967],
            [34.20650664735242, 0.856095470811349],
            [34.20853713993183, 0.856954129234119],
            [34.210345609397216, 0.857215866325729],
            [34.213023155780824, 0.856545658842447],
            [34.21245710935401, 0.858499624268152],
            [34.21279111555304, 0.863278052067651],
            [34.212090960535775, 0.865449714785701],
            [34.21231453144706, 0.868038043446291],
            [34.21317020011138, 0.870094027242427],
            [34.216177445272265, 0.873330916758082],
            [34.21605773398086, 0.875257291284917],
            [34.22053642047545, 0.901543465096975],
            [34.22332331967693, 0.907051083076591],
            [34.22944632558671, 0.921847596933299],
            [34.22914335438407, 0.924186948314557],
            [34.22954637545147, 0.92568514835997],
            [34.230496057301856, 0.926777992040847],
            [34.231896014298485, 0.927447878651624],
            [34.23205628542326, 0.929534530278224],
            [34.23345200506676, 0.931722999331596],
            [34.23308806610411, 0.933420225660817],
            [34.234098788478036, 0.935315723362804],
            [34.23362286014221, 0.938346697453726],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 992,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "LUKHONGE",
        Population: 9625,
        Key: "MBALELUKHONGE",
        Dist2: "Mbale",
        "Sub Country": "Lukonge",
        id2_original: "Mbale Lukonge",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.27732789297455, 1.050569816441423],
            [34.27542165536522, 1.050830879554399],
            [34.27383151693809, 1.051610351261658],
            [34.26979822594115, 1.052023053092299],
            [34.26650225056985, 1.055713901708019],
            [34.268000958467375, 1.055648166968564],
            [34.26796323910692, 1.066093674235664],
            [34.26858704900316, 1.069792858044259],
            [34.26679311248245, 1.073692045412007],
            [34.26196250917868, 1.077544594627157],
            [34.259500165001164, 1.078868899043645],
            [34.257077546122126, 1.079557340057061],
            [34.25529568295884, 1.081439472621017],
            [34.254385988715015, 1.08182879326856],
            [34.25006663011416, 1.080962256639465],
            [34.243184477720725, 1.074736452482574],
            [34.24069749724651, 1.070238536934362],
            [34.23970780173845, 1.06722689030949],
            [34.23986481287706, 1.063807742672002],
            [34.239434100342734, 1.061479266217051],
            [34.240777612596816, 1.061347080248554],
            [34.24349404974404, 1.059437445316346],
            [34.244973361217966, 1.059337348783761],
            [34.24717690525369, 1.058549525207939],
            [34.248656070302225, 1.059489621326503],
            [34.25000602257856, 1.059569396946176],
            [34.25298784990851, 1.056421550622629],
            [34.25214072152757, 1.054558593789759],
            [34.25121407248109, 1.048006437472879],
            [34.25486869483967, 1.040781729891412],
            [34.25826908139645, 1.038645710913934],
            [34.26605720900843, 1.040098832728899],
            [34.27162752733796, 1.043126677103414],
            [34.278724357321394, 1.04617195914299],
            [34.279112161826156, 1.046868269086503],
            [34.27732789297455, 1.050569816441423],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 993,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUDWALE",
        Population: 7669,
        Key: "MBALEBUDWALE",
        Dist2: "Mbale",
        "Sub Country": "Budwale",
        id2_original: "Mbale Budwale",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.3116216484777, 1.060096510028693],
            [34.29679878243474, 1.061480371853376],
            [34.296058092736885, 1.064914286027412],
            [34.29326470141084, 1.067759832036024],
            [34.29292679562515, 1.06674057465002],
            [34.29163315064911, 1.065529637923317],
            [34.28783224483303, 1.064820937549463],
            [34.28691495713011, 1.06417591927608],
            [34.284599387788546, 1.060484737630417],
            [34.28142547370142, 1.060082235547501],
            [34.2806797246919, 1.058452803939517],
            [34.279409503286885, 1.053196327916077],
            [34.27807597221392, 1.050773896424115],
            [34.27732789297455, 1.050569816441423],
            [34.279112161826156, 1.046868269086503],
            [34.278724357321394, 1.04617195914299],
            [34.27162752733796, 1.043126677103414],
            [34.26605720900843, 1.040098832728899],
            [34.25826908139645, 1.038645710913934],
            [34.26048290665062, 1.035515206965722],
            [34.26125318236235, 1.033389294226294],
            [34.26362580909749, 1.031335101614512],
            [34.26566802738631, 1.028855923084762],
            [34.262906300775725, 1.024045025693831],
            [34.260269855011316, 1.020735556373814],
            [34.25946712945657, 1.018881622231157],
            [34.257404934432465, 1.017688476089232],
            [34.25703203028329, 1.014830359839003],
            [34.25345848537067, 1.007749406676821],
            [34.25050799037955, 1.002612900117497],
            [34.24992885999062, 1.000885497267021],
            [34.24582360495627, 0.997024782785123],
            [34.24276432488255, 0.992970549021643],
            [34.242605109278216, 0.990545664087544],
            [34.24278825330677, 0.990838913897199],
            [34.246949507519304, 0.990342493733451],
            [34.24953143273251, 0.989294184195868],
            [34.25166263184515, 0.987597492189903],
            [34.253644889385384, 0.986882171114534],
            [34.255479191703394, 0.987720251190484],
            [34.25642799410312, 0.987665623772585],
            [34.25737119820197, 0.987060202464922],
            [34.25856001427592, 0.987306656406806],
            [34.25875977893386, 0.988093430440735],
            [34.260275231428274, 0.989604143881115],
            [34.26205168134366, 0.989877503551001],
            [34.26470131707142, 0.989320125470386],
            [34.26572459429977, 0.990812175948044],
            [34.26691309865833, 0.991119250534366],
            [34.268173161015774, 0.992032318642221],
            [34.270501558299586, 0.991832424942522],
            [34.271752562944066, 0.992564592121752],
            [34.27137277769979, 0.993686330447721],
            [34.27187221943821, 0.994111255874839],
            [34.272349293126034, 0.99624571006975],
            [34.271792615229316, 0.997412743218318],
            [34.271733816002374, 0.99931223533832],
            [34.27188168678299, 0.999737296562685],
            [34.2732669176972, 1.000451316088477],
            [34.27303575153018, 1.002477505207881],
            [34.273740072933755, 1.00549828498817],
            [34.277564633187914, 1.009621326880114],
            [34.278457813701856, 1.011574706013734],
            [34.280512259858334, 1.011673384039486],
            [34.28122881092615, 1.012903225541193],
            [34.28292960382999, 1.013866291652016],
            [34.28375591555083, 1.014536290348796],
            [34.28640767938747, 1.018500767110509],
            [34.28686817107348, 1.019923471597768],
            [34.28895080636357, 1.02103337157687],
            [34.28847936601088, 1.023578760423819],
            [34.28973900166861, 1.027581398294399],
            [34.292668591964734, 1.030129387525246],
            [34.29706213703501, 1.032868219538851],
            [34.29839468624938, 1.035051781586275],
            [34.302022550490584, 1.038817766605939],
            [34.30420577732956, 1.042054956915936],
            [34.31019875928847, 1.047316606247883],
            [34.31071275014121, 1.051612738581509],
            [34.30998763184051, 1.052797933987455],
            [34.30814151847315, 1.053983606765731],
            [34.307914977731556, 1.056172581738398],
            [34.30919761295547, 1.058587038738985],
            [34.3116216484777, 1.060096510028693],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 994,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUSANO",
        Population: 14833,
        Key: "MBALEBUSANO",
        Dist2: "Mbale",
        "Sub Country": "Busano",
        id2_original: "Mbale Busano",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.22082911225626, 0.997558859901153],
            [34.220056324855015, 0.997604375128453],
            [34.21949053534634, 0.996989508590079],
            [34.215699178621726, 0.996050215010314],
            [34.214296493441545, 0.995254752080311],
            [34.21187420065098, 0.995328013908121],
            [34.210471643929885, 0.994885313658205],
            [34.20929917988904, 0.9955008281768],
            [34.20426491413732, 0.991953545504793],
            [34.19875426640054, 0.990781219242649],
            [34.197874465394435, 0.990220155178613],
            [34.2032778264385, 0.979829588040132],
            [34.205485991408096, 0.975016023797726],
            [34.206327555624114, 0.971894804471316],
            [34.20933259811592, 0.971762046283427],
            [34.20967872707975, 0.973500848766506],
            [34.21130831142933, 0.975627621409421],
            [34.21335472754545, 0.976439880594045],
            [34.21533361550507, 0.976637894417409],
            [34.21457566288242, 0.977663457814845],
            [34.214096154760156, 0.979361908126089],
            [34.215438965429996, 0.982577297717812],
            [34.21792584080133, 0.985363176093153],
            [34.218639399580944, 0.985656496418531],
            [34.22181144427398, 0.9847113380857],
            [34.22233302678916, 0.987656017718006],
            [34.22400718733978, 0.988929096797502],
            [34.22628461331609, 0.98952219022594],
            [34.225926277145874, 0.991238657393663],
            [34.22425828442799, 0.99452741680727],
            [34.22321768678267, 0.995647941025716],
            [34.22187157031257, 0.995702644657134],
            [34.22082911225626, 0.997558859901153],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 995,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "NABUMALI TOWN COUNCIL",
        Population: 3659,
        Key: "MBALENABUMALI TOWN COUNCIL",
        Dist2: "Mbale",
        "Sub Country": "Nabumali",
        id2_original: "Mbale Nabumali",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.16323462314829, 0.925081342756256],
            [34.16265038853191, 0.927206311093849],
            [34.16298712111782, 0.927974190070145],
            [34.15607582378329, 0.925774898103923],
            [34.15536355139115, 0.925211938077318],
            [34.154908986789394, 0.924275788221442],
            [34.15514709962849, 0.92434161807991],
            [34.15512130270848, 0.923215236706914],
            [34.15443411666898, 0.92157707644534],
            [34.15456020240562, 0.918249064952719],
            [34.1551952538193, 0.915944878718788],
            [34.15766154070261, 0.914126493801136],
            [34.15857696440132, 0.913767799926476],
            [34.16005202325069, 0.913844119170229],
            [34.16099320793679, 0.914509404033448],
            [34.1620364088998, 0.916070644750551],
            [34.16460535705045, 0.917170588958801],
            [34.16534310656233, 0.917887137072425],
            [34.16595386393748, 0.919115719987842],
            [34.16585261212687, 0.920574934928072],
            [34.16366598426625, 0.922086037326981],
            [34.16323462314829, 0.925081342756256],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 996,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "BUSIU TOWN COUNCIL",
        Population: 1981,
        Key: "MBALEBUSIU TOWN COUNCIL",
        Dist2: "Mbale",
        "Sub Country": "Busiu T.C.",
        id2_original: "Mbale Busiu T.C.",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.195417702449745, 1.15097732789009],
              [34.19357531439589, 1.150875579181437],
              [34.19304657410451, 1.150375110992394],
              [34.19130201528002, 1.151263792217297],
              [34.190653499916834, 1.152441472805367],
              [34.189716728653735, 1.152007674255588],
              [34.18496051124536, 1.154780788275154],
              [34.18053834764678, 1.154402738991375],
              [34.17954007053278, 1.155087514992428],
              [34.177670296439175, 1.155344660263648],
              [34.17601812754503, 1.15477633802696],
              [34.17719200014423, 1.152896483404507],
              [34.17940884733105, 1.150511704631056],
              [34.18196470433301, 1.145834182051083],
              [34.18233567800262, 1.142518142954154],
              [34.18010171251979, 1.142616836498983],
              [34.180546511536065, 1.137567613746318],
              [34.17824028467345, 1.13632612597845],
              [34.17604088636276, 1.134065599100565],
              [34.17209141896162, 1.126791758986702],
              [34.174342362603326, 1.123909808067025],
              [34.17391317001846, 1.123359465833538],
              [34.174103576027775, 1.116763989316004],
              [34.172204340786095, 1.114130909139205],
              [34.17133360737446, 1.113561507319381],
              [34.172540240633765, 1.108866883812002],
              [34.173177044660555, 1.109612916995911],
              [34.17369033123414, 1.109431803885919],
              [34.17436934260456, 1.112181337386847],
              [34.17476191985846, 1.112117861812305],
              [34.17527494412396, 1.112696561517176],
              [34.17584876726618, 1.112207879398774],
              [34.176301243284925, 1.113057965522364],
              [34.17663365227941, 1.112822650419968],
              [34.17678438239756, 1.113338178011514],
              [34.17744826524028, 1.113337910364116],
              [34.177494566206676, 1.113952979334034],
              [34.17814269349765, 1.113880354389113],
              [34.178565392161296, 1.113301278593501],
              [34.17916882018206, 1.113816622879674],
              [34.179712414116686, 1.113581223412151],
              [34.17971274559502, 1.113002317307333],
              [34.18028591656038, 1.11369858140387],
              [34.180958759199754, 1.1136349917975],
              [34.18215746841994, 1.112549060809941],
              [34.18291220058229, 1.113607064857888],
              [34.183757755114854, 1.112846910237512],
              [34.184391548887135, 1.113452694280047],
              [34.18596100899475, 1.113913372014972],
              [34.18620272856973, 1.11442885989735],
              [34.18582542087901, 1.116147634790027],
              [34.18633827626126, 1.117694184111954],
              [34.18627753308006, 1.118879153337748],
              [34.18796796032382, 1.119855362060173],
              [34.188390806311226, 1.1210401328211],
              [34.190262086879564, 1.122007219282705],
              [34.19163574120468, 1.124367492447743],
              [34.1919073153898, 1.126465902427992],
              [34.19290352098876, 1.127406208109015],
              [34.192782797296026, 1.128862559266873],
              [34.19172605961999, 1.130988654773306],
              [34.19196744861494, 1.132055906584823],
              [34.191590177755174, 1.133828951953121],
              [34.1915900142618, 1.137537547670623],
              [34.19204219293817, 1.14035950922738],
              [34.195438310700695, 1.146517965872767],
              [34.195417702449745, 1.15097732789009],
            ],
          ],
          [
            [
              [34.14547486170927, 1.159916874807682],
              [34.14387513646144, 1.161129625611401],
              [34.137173214860056, 1.163954559091129],
              [34.13644841366466, 1.165681009470421],
              [34.13564126839869, 1.166135154839737],
              [34.13404842604256, 1.169129876252182],
              [34.127859682318615, 1.170163584882492],
              [34.124447938361705, 1.17275199919851],
              [34.12029819336462, 1.174593414244181],
              [34.120966852549714, 1.173243787517196],
              [34.12268723142169, 1.172077167060633],
              [34.124946541971966, 1.169513484774549],
              [34.1253391758197, 1.166745382392893],
              [34.1296568563676, 1.152713984481667],
              [34.1343213243444, 1.147800386233476],
              [34.13652523938437, 1.144705932146435],
              [34.13709911013733, 1.142878505010364],
              [34.13697826696868, 1.14124131203295],
              [34.13346194024809, 1.13198912359206],
              [34.13353781016035, 1.129212112104896],
              [34.132722788466005, 1.124771069976861],
              [34.130866655289985, 1.122356634628468],
              [34.13110821047323, 1.120990662187262],
              [34.13202199923812, 1.119871449610186],
              [34.131347611496466, 1.117785444559646],
              [34.13356884425848, 1.113886779722263],
              [34.133169912322266, 1.109429750722148],
              [34.134052875398154, 1.105874413486188],
              [34.13489805084168, 1.1040468892921],
              [34.13838398575957, 1.101388357721641],
              [34.139227381640474, 1.099557158238472],
              [34.139049586181116, 1.092883107794284],
              [34.13868763159696, 1.09224101356443],
              [34.13634556554778, 1.090590458408386],
              [34.13446234187773, 1.086493415083184],
              [34.135104608559764, 1.087312562651102],
              [34.13558747368624, 1.086869147812268],
              [34.137253625756074, 1.087555975720805],
              [34.138231969253916, 1.085864089444755],
              [34.13943976493321, 1.086451589857877],
              [34.14120262513496, 1.085917232316099],
              [34.14149232732253, 1.084117063620449],
              [34.14294135568988, 1.08246118335242],
              [34.1459169415252, 1.082182744520319],
              [34.14777473388958, 1.081726655062107],
              [34.1484801530344, 1.08314652851004],
              [34.14887659933225, 1.08292024020376],
              [34.14929517472875, 1.083281899291994],
              [34.15004443615104, 1.083299703413125],
              [34.1505726392499, 1.082458270635822],
              [34.151453867678995, 1.082412705437389],
              [34.15253382950009, 1.08360629569787],
              [34.15299607469753, 1.083606117863254],
              [34.15299622920777, 1.084013165108239],
              [34.15400995734464, 1.083831865429274],
              [34.155089796994844, 1.084699815831121],
              [34.15511157305565, 1.084365124896576],
              [34.15588284949061, 1.084672373624225],
              [34.15616917850425, 1.084364717134464],
              [34.158019901127346, 1.08598314154649],
              [34.156522613466265, 1.087711405663799],
              [34.156831297954106, 1.088579651341907],
              [34.15766864547819, 1.088353190098741],
              [34.157801016726886, 1.089348139824324],
              [34.158242029344265, 1.08963742409008],
              [34.160797733632656, 1.090034430971112],
              [34.16132665897698, 1.091083498315228],
              [34.162274031258754, 1.090703220561486],
              [34.1622961666457, 1.091300211705712],
              [34.1634054701389, 1.091372142031619],
              [34.163698311040065, 1.091932845001814],
              [34.16294934067193, 1.092665819700687],
              [34.16357748853265, 1.093217346911018],
              [34.16328739288302, 1.093950141666058],
              [34.16371019754789, 1.095080656486773],
              [34.162333336237204, 1.095931468722869],
              [34.16221279849574, 1.097948651325712],
              [34.164071940129666, 1.100960055429613],
              [34.16524325702189, 1.101610865225218],
              [34.16509807849218, 1.10236169455195],
              [34.16475998675522, 1.102434191343987],
              [34.165001758432496, 1.103094413416965],
              [34.16596741322693, 1.103501076305953],
              [34.16584680002698, 1.103871987437699],
              [34.16666751883686, 1.104206343880759],
              [34.16681260753503, 1.104667603258725],
              [34.1673196166814, 1.104233221871641],
              [34.16832886671657, 1.104570658024792],
              [34.16784315303233, 1.107551790554461],
              [34.16649739139679, 1.10927292529036],
              [34.166714037195554, 1.11045682282166],
              [34.167699998406974, 1.111544413455081],
              [34.16800170747663, 1.116576481854883],
              [34.15887807968455, 1.11650587959664],
              [34.15800271725427, 1.118201924837868],
              [34.15739789774314, 1.122427842094165],
              [34.15834452082997, 1.124747535058698],
              [34.154715580407036, 1.12749193570282],
              [34.15423030599898, 1.13652920678937],
              [34.15453435068838, 1.142561477150997],
              [34.15403627349088, 1.145517156314624],
              [34.15164402934656, 1.145654227095408],
              [34.14980345049966, 1.146785656025733],
              [34.14847284344295, 1.148691606388533],
              [34.14703866422723, 1.151693735191879],
              [34.14467891753661, 1.155086747987099],
              [34.14451350445514, 1.157603636340449],
              [34.14547486170927, 1.159916874807682],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 997,
        District: "MBALE",
        County: "BUNGOKHO",
        Subcounty: "NAKALOKE",
        Population: 22801,
        Key: "MBALENAKALOKE",
        Dist2: "Mbale",
        "Sub Country": "Nakaloke",
        id2_original: "Mbale Nakaloke",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "VL",
        "Earthquakes and faults": "VL",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.75978390773488, 0.945708513562346],
            [33.75374551593836, 0.952983265874251],
            [33.75089157007735, 0.955869744347844],
            [33.73387160181755, 0.964883856910228],
            [33.73046590262417, 0.967191477801606],
            [33.72268763132748, 0.973724809547371],
            [33.718540815736525, 0.977733354532667],
            [33.716131753333414, 0.980927331193836],
            [33.710677103876506, 0.989513756303322],
            [33.70929541412115, 0.992743701881788],
            [33.70150409569329, 0.985851834909499],
            [33.692191873793846, 0.97441881590287],
            [33.68720792896937, 0.966811591259671],
            [33.68269805656139, 0.961818739001625],
            [33.676656382320814, 0.956690476392032],
            [33.6742562051542, 0.955297860264673],
            [33.671402108376235, 0.95460118507842],
            [33.67021531440999, 0.9537110098094],
            [33.668318138106926, 0.94998851245185],
            [33.66465349054977, 0.946877153968587],
            [33.66279474597119, 0.943886693118],
            [33.65790083569441, 0.943877112089095],
            [33.65554895914403, 0.942373629437691],
            [33.653632135787376, 0.940518080053489],
            [33.65090585220634, 0.936394610594281],
            [33.64767818922081, 0.932993635491431],
            [33.64398211679839, 0.927326035450695],
            [33.63944714456304, 0.926184638952492],
            [33.63665498752222, 0.922772815451377],
            [33.635028315510795, 0.922097585470906],
            [33.633133923985135, 0.921877012052741],
            [33.632075376203765, 0.920988210789943],
            [33.62867411468792, 0.915998205780265],
            [33.62376725339969, 0.906355200454003],
            [33.619748907674136, 0.906621063110629],
            [33.622142305255295, 0.905353581038745],
            [33.62391867701726, 0.903505222220645],
            [33.62542199506881, 0.901048813297673],
            [33.632111978958335, 0.894872930228236],
            [33.63385239565105, 0.893670178679413],
            [33.63805007475172, 0.891974567429184],
            [33.642122499955704, 0.889683479243262],
            [33.64485210550667, 0.885216774035016],
            [33.64595170449985, 0.884599087070998],
            [33.64709228912791, 0.87944464555877],
            [33.64756548568697, 0.878856216814803],
            [33.64860499277755, 0.875019602331569],
            [33.651918611061014, 0.87254860010512],
            [33.6521593496757, 0.869859086490822],
            [33.65381827120582, 0.866182053664323],
            [33.656039513849294, 0.856695883485797],
            [33.657147829195715, 0.855042788723669],
            [33.65886584010862, 0.853619966990679],
            [33.66974415163669, 0.856798960826357],
            [33.672026888452976, 0.856750685371026],
            [33.67359613206659, 0.855936578369244],
            [33.67823039958188, 0.851603739235626],
            [33.68217688906784, 0.848669351585026],
            [33.682685684065, 0.848750072526339],
            [33.68203141229748, 0.858203607805707],
            [33.68011670177841, 0.862784685914236],
            [33.68427162646143, 0.861389478152396],
            [33.68524248609465, 0.861867230838745],
            [33.68880333062577, 0.86214230426901],
            [33.69183691618742, 0.861676355941592],
            [33.69264148059356, 0.857876152013362],
            [33.692941185521775, 0.857776466360184],
            [33.69498369845801, 0.858079179045104],
            [33.69888391931697, 0.861094397852849],
            [33.7031168249532, 0.862936682487166],
            [33.705223272784814, 0.861788266181015],
            [33.70649290309838, 0.860422774566169],
            [33.7083000421588, 0.860302756108666],
            [33.7116625207089, 0.861096618237425],
            [33.713706272421895, 0.865755246350609],
            [33.7144967943635, 0.869316376128083],
            [33.71556818266354, 0.871080411769024],
            [33.7161299638894, 0.87129140972105],
            [33.71531648729732, 0.872669494828672],
            [33.7169225205151, 0.874785719979574],
            [33.71716499197995, 0.876632828511701],
            [33.72257396210469, 0.869924037979013],
            [33.72507271320404, 0.868756542173373],
            [33.72927930898224, 0.869153774622774],
            [33.73189502791809, 0.868728073343224],
            [33.73817523630764, 0.862575165947567],
            [33.742019457988434, 0.860680493709347],
            [33.74755592689975, 0.862884520539973],
            [33.75122292085642, 0.863549615178526],
            [33.76561984352088, 0.85939435982468],
            [33.76778398295669, 0.859203944689487],
            [33.771469557666734, 0.860949171044324],
            [33.78104134327593, 0.866945025937204],
            [33.78526271903547, 0.868436813710324],
            [33.790053913247746, 0.868535317036978],
            [33.79113494675898, 0.886202839300131],
            [33.791957088500254, 0.908855009612121],
            [33.79199916828309, 0.916318332503105],
            [33.79158395887395, 0.918326740382886],
            [33.79053799469309, 0.920443847223541],
            [33.78611441894288, 0.924443376769946],
            [33.77753466625812, 0.930162669072812],
            [33.76717946438119, 0.936416099917162],
            [33.76416434009696, 0.939338792110162],
            [33.75978390773488, 0.945708513562346],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 998,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "MAGADA",
        Population: 48559,
        Key: "NAMUTUMBAMAGADA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.47399970792141, 0.874047274937995],
            [33.471732970998694, 0.876793718603328],
            [33.46800648701064, 0.880079173905014],
            [33.462424577718984, 0.883952009727958],
            [33.46131957625765, 0.884219681204222],
            [33.45581459329708, 0.881892724533784],
            [33.45231504980092, 0.881741967356622],
            [33.44759910296842, 0.88302764450872],
            [33.44535306861975, 0.883241855577284],
            [33.44406329717919, 0.882635242299821],
            [33.44181687745328, 0.882835542833714],
            [33.43956911833924, 0.880764945873738],
            [33.43763073361916, 0.880322274247603],
            [33.43742454870189, 0.879224910283286],
            [33.43536064777707, 0.879000559095873],
            [33.43457116159298, 0.879302074564005],
            [33.43268464110585, 0.881789680213744],
            [33.43198628182082, 0.88218285227673],
            [33.431333080845114, 0.883445354598967],
            [33.42662481999821, 0.886462121353356],
            [33.42552106629681, 0.88801949563375],
            [33.42494956799452, 0.895580664171547],
            [33.42346900606573, 0.899346007252648],
            [33.420423665150295, 0.903086064709846],
            [33.417258536586644, 0.903327237784491],
            [33.410605327928195, 0.902522811006245],
            [33.40340770786823, 0.905952478590762],
            [33.39679245303052, 0.908178805155686],
            [33.389677873235414, 0.895260293999521],
            [33.38280128590516, 0.885435840689832],
            [33.37720692147208, 0.878786773534805],
            [33.36204039503572, 0.862593883818366],
            [33.3697722162457, 0.84144090430195],
            [33.37073403433556, 0.837071040535006],
            [33.37210017425336, 0.825454375044421],
            [33.37318105594929, 0.820840229906551],
            [33.378703241647585, 0.803924152777598],
            [33.381920825535616, 0.796656403288594],
            [33.38579056026878, 0.790134960482295],
            [33.40135379531103, 0.79050474463536],
            [33.40782185400292, 0.791569312967987],
            [33.41389749623931, 0.792047447718776],
            [33.417095739399294, 0.791436726199387],
            [33.41855806822272, 0.790514997928356],
            [33.422823150614114, 0.790898418970946],
            [33.424959749499955, 0.7895397798569],
            [33.4301391246111, 0.787767368699688],
            [33.431713972813775, 0.786794462928229],
            [33.433044075017314, 0.78777932504424],
            [33.43426006602692, 0.787693129060126],
            [33.43585614770799, 0.788477135013439],
            [33.439514209715824, 0.793812957751022],
            [33.44276336669114, 0.795266197815239],
            [33.442749952148986, 0.80115777120433],
            [33.443999089195955, 0.80788993740328],
            [33.44361290615026, 0.80998447320843],
            [33.44135434030338, 0.81423355464737],
            [33.43979702362176, 0.81617876908134],
            [33.438333861161716, 0.819952204236394],
            [33.43799647280562, 0.827086058853692],
            [33.43691259073662, 0.83124165866534],
            [33.43712212457329, 0.833731092849288],
            [33.43598119499219, 0.838078196771549],
            [33.437807953258414, 0.842539864495379],
            [33.44005319080146, 0.846599337794461],
            [33.443954071922114, 0.850274566966081],
            [33.44660844087312, 0.851656623502206],
            [33.45019734877373, 0.851284473713459],
            [33.458538667022516, 0.856838504734698],
            [33.461088896977536, 0.858027899078193],
            [33.46184058834268, 0.860826778624053],
            [33.46354954064425, 0.86375018170224],
            [33.465047199309495, 0.865414510232807],
            [33.46675318986557, 0.870771833900945],
            [33.47399970792141, 0.874047274937995],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 999,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAWANDALA",
        Population: 31250,
        Key: "IGANGANAWANDALA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.932230028025266, 1.165351157965761],
            [33.93052206117557, 1.162565523578774],
            [33.92858699483217, 1.157536519837648],
            [33.92831649682874, 1.154849909475555],
            [33.92904655137193, 1.150860327966773],
            [33.93062084261917, 1.146816193525747],
            [33.93153147380583, 1.14015795102914],
            [33.93323846149185, 1.136048337078366],
            [33.93181423381287, 1.132845142464646],
            [33.928450930609344, 1.128791025933139],
            [33.92648137345058, 1.119697241162169],
            [33.92581809876729, 1.118231978539328],
            [33.925621546484805, 1.112994328300446],
            [33.926207308237174, 1.109086213111238],
            [33.92742159154944, 1.107948400768003],
            [33.92934000582245, 1.107511196085527],
            [33.933287612812634, 1.105411246629048],
            [33.93772458334207, 1.10133577018051],
            [33.94072492494996, 1.100831456592807],
            [33.94370991255307, 1.101208023703641],
            [33.94561670532123, 1.101930991647165],
            [33.94723615308113, 1.101354144519483],
            [33.94834066945219, 1.100250167902293],
            [33.9489496661294, 1.098838784655473],
            [33.94973001375208, 1.094392989626238],
            [33.95076574612186, 1.093725310074234],
            [33.95209078362383, 1.090652302498256],
            [33.95571357148537, 1.091289124015024],
            [33.95834558226724, 1.087085377401028],
            [33.96077003370943, 1.084068867752445],
            [33.964048628476625, 1.081385329126078],
            [33.966382763300174, 1.081963282121044],
            [33.96978696320532, 1.084439833379309],
            [33.9711787464312, 1.086293795010975],
            [33.96971375500124, 1.087750680116011],
            [33.969448389971355, 1.090491711024046],
            [33.96756357718157, 1.094725863384774],
            [33.967590621861525, 1.096734072477928],
            [33.96678852153422, 1.098480217971882],
            [33.96668688434636, 1.100316595050436],
            [33.96458570154059, 1.105925822576991],
            [33.962784190425424, 1.108956835932744],
            [33.962653143293444, 1.110160002429128],
            [33.96378833892812, 1.114035964385323],
            [33.96695505930642, 1.114902585733394],
            [33.96930829321123, 1.116435453373075],
            [33.97182960280402, 1.118780173376075],
            [33.97311374540099, 1.119066956141171],
            [33.972709859255986, 1.120137621668869],
            [33.96787657358276, 1.121651639938726],
            [33.96720180944698, 1.122474361406126],
            [33.96691824275282, 1.124477055030991],
            [33.96768885443446, 1.126233500177362],
            [33.96711655663158, 1.129426570163468],
            [33.961281097851, 1.139831471768667],
            [33.95765126899424, 1.149701934162834],
            [33.95723054123429, 1.151357503511708],
            [33.95744222114616, 1.152786708145606],
            [33.95947295447409, 1.156594403499628],
            [33.959839107783885, 1.158023553408924],
            [33.9606819215565, 1.158765040157092],
            [33.958551123092455, 1.159733696450787],
            [33.955953949875614, 1.160250208103522],
            [33.94779200093456, 1.164423219414126],
            [33.932230028025266, 1.165351157965761],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1000,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "KACHOMO",
        Population: 14506,
        Key: "BUDAKAKACHOMO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.501528915773164, 0.868490930090629],
            [33.49836111472155, 0.86787277778851],
            [33.49469737895441, 0.868712669006902],
            [33.492773638570114, 0.869807609974503],
            [33.486217977968344, 0.870975532105415],
            [33.48108712176403, 0.870044354338452],
            [33.477856815934935, 0.871157552863812],
            [33.47464965969071, 0.873238777381348],
            [33.47399970792141, 0.874047274937995],
            [33.46675318986557, 0.870771833900945],
            [33.465047199309495, 0.865414510232807],
            [33.46354954064425, 0.86375018170224],
            [33.46184058834268, 0.860826778624053],
            [33.461088896977536, 0.858027899078193],
            [33.458538667022516, 0.856838504734698],
            [33.45019734877373, 0.851284473713459],
            [33.44660844087312, 0.851656623502206],
            [33.443954071922114, 0.850274566966081],
            [33.44005319080146, 0.846599337794461],
            [33.437807953258414, 0.842539864495379],
            [33.43598119499219, 0.838078196771549],
            [33.43712212457329, 0.833731092849288],
            [33.43691259073662, 0.83124165866534],
            [33.43799647280562, 0.827086058853692],
            [33.438333861161716, 0.819952204236394],
            [33.43979702362176, 0.81617876908134],
            [33.44135434030338, 0.81423355464737],
            [33.44361290615026, 0.80998447320843],
            [33.443999089195955, 0.80788993740328],
            [33.442749952148986, 0.80115777120433],
            [33.44276336669114, 0.795266197815239],
            [33.439514209715824, 0.793812957751022],
            [33.43585614770799, 0.788477135013439],
            [33.43426006602692, 0.787693129060126],
            [33.433044075017314, 0.78777932504424],
            [33.431713972813775, 0.786794462928229],
            [33.4301391246111, 0.787767368699688],
            [33.424959749499955, 0.7895397798569],
            [33.422823150614114, 0.790898418970946],
            [33.41855806822272, 0.790514997928356],
            [33.417095739399294, 0.791436726199387],
            [33.41389749623931, 0.792047447718776],
            [33.40782185400292, 0.791569312967987],
            [33.40135379531103, 0.79050474463536],
            [33.38579056026878, 0.790134960482295],
            [33.38822839571042, 0.785319754876068],
            [33.39040219023891, 0.77886894838228],
            [33.391007449924516, 0.775982857901035],
            [33.391625257278015, 0.763238095153535],
            [33.3993793369441, 0.759290134179538],
            [33.40261333215405, 0.755743361848018],
            [33.40368318343661, 0.753544813612189],
            [33.40486745583187, 0.749527784555972],
            [33.40493982051789, 0.748496406421067],
            [33.4042818997937, 0.74644579810714],
            [33.40438448021261, 0.744425257403191],
            [33.40487822124222, 0.743276294005599],
            [33.406327021437505, 0.742069952538474],
            [33.40651747685416, 0.741423932935531],
            [33.408247136221355, 0.741327881428726],
            [33.40951046934477, 0.74050007316256],
            [33.410994514041896, 0.740939013514239],
            [33.41272910605829, 0.739979942617991],
            [33.414279249692356, 0.738097623841299],
            [33.41613951152543, 0.734445201209778],
            [33.42010311571419, 0.730561758468885],
            [33.42146461942681, 0.729993526785832],
            [33.421556924915485, 0.729410931235286],
            [33.422236856160794, 0.728853519637253],
            [33.425299039589504, 0.732408734604572],
            [33.42662712058364, 0.734634190315418],
            [33.43044115078603, 0.735239975981615],
            [33.435971279388056, 0.73679553116987],
            [33.44060645330348, 0.736731740787651],
            [33.44237931444928, 0.743625429881379],
            [33.44663409496099, 0.747904257833335],
            [33.44886639406898, 0.748736357391342],
            [33.4505054673229, 0.748926175859184],
            [33.45324874613082, 0.748093560748138],
            [33.457115754477094, 0.744971923211804],
            [33.460258905757286, 0.743623582202478],
            [33.46111203308768, 0.742664505600371],
            [33.4638806506748, 0.742519460526355],
            [33.46515381316405, 0.741347327428461],
            [33.466896874496946, 0.741388260229117],
            [33.47010180112264, 0.739871904960156],
            [33.47347938664085, 0.740699979222762],
            [33.47682746160368, 0.740461649138772],
            [33.47496057469539, 0.741891211768779],
            [33.474546904998626, 0.742638090163626],
            [33.47409542610986, 0.744581088473679],
            [33.47431533189479, 0.747186608126654],
            [33.471702878334995, 0.75783524875284],
            [33.471648682075575, 0.760495081320992],
            [33.46957826836492, 0.765914482450832],
            [33.46804109820021, 0.773034669669535],
            [33.4677433462094, 0.777702972653569],
            [33.468187310690816, 0.784705328065096],
            [33.47001535714114, 0.791915605597696],
            [33.47428472898801, 0.795307749877168],
            [33.47747826767083, 0.797261534361766],
            [33.47896179673499, 0.797749899273062],
            [33.480851925754635, 0.797577783474206],
            [33.4817928436411, 0.798057164270048],
            [33.483701541736, 0.802942325132377],
            [33.48547503978735, 0.804489151804353],
            [33.48927411932848, 0.806515222961136],
            [33.49056787569559, 0.807682129223627],
            [33.492178080689555, 0.810558879405882],
            [33.49477406004538, 0.813191235851529],
            [33.49764380008573, 0.8174791549088],
            [33.500144696361986, 0.833494842072161],
            [33.49705798892601, 0.834043390520298],
            [33.493936302889495, 0.833918014260834],
            [33.487265681287575, 0.831620914393313],
            [33.48473352902935, 0.832019297691921],
            [33.481969131727425, 0.834923731459603],
            [33.48225504122783, 0.839483391272996],
            [33.482005985111954, 0.842287996929386],
            [33.48239832341397, 0.844404949386378],
            [33.48436093390061, 0.848747268293741],
            [33.492833483436016, 0.85912309552305],
            [33.49934418156116, 0.866558867318314],
            [33.501528915773164, 0.868490930090629],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1001,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NABITENDE",
        Population: 28284,
        Key: "IGANGANABITENDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.692329745427, 1.123417324181166],
            [33.6826951954272, 1.125274180451014],
            [33.67727545540056, 1.125058334457062],
            [33.673615515913795, 1.124244986730851],
            [33.6637161937722, 1.120529074844556],
            [33.64657973737625, 1.113349826961194],
            [33.62632972469709, 1.104262223085257],
            [33.63121740246244, 1.095992429820357],
            [33.636556948985394, 1.088898625927281],
            [33.64090818879566, 1.083587251226968],
            [33.648100739662475, 1.075886927936746],
            [33.656958183161144, 1.067941989514041],
            [33.66180857096072, 1.064457952388677],
            [33.66905968300092, 1.060484869660139],
            [33.68597500381835, 1.049932710730369],
            [33.69155075965028, 1.045055319126669],
            [33.69346456017597, 1.042494687633676],
            [33.694667768159114, 1.039907074908201],
            [33.7016644386833, 1.044211717627334],
            [33.70947090540182, 1.050008838251114],
            [33.72490741331031, 1.056310744301628],
            [33.7309553766562, 1.060606442990652],
            [33.73311840397767, 1.061696494561379],
            [33.733003761879424, 1.067929435942256],
            [33.73269696475202, 1.068818291029714],
            [33.73304685047034, 1.070177759441346],
            [33.73271807156792, 1.072827060281747],
            [33.73278645851389, 1.080108784335426],
            [33.73235384963599, 1.08581757674512],
            [33.734454630894824, 1.092987489206591],
            [33.74287902534109, 1.111526381372915],
            [33.7360624167257, 1.115463648017172],
            [33.73185483729228, 1.116948346073924],
            [33.72535300374236, 1.117954144802315],
            [33.7181105281053, 1.117892613834668],
            [33.708476179328144, 1.117894975954195],
            [33.70438755929622, 1.119017751324655],
            [33.699430760661336, 1.12130774898797],
            [33.69554099349734, 1.122484748428773],
            [33.692329745427, 1.123417324181166],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1002,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KASASIRA",
        Population: 22409,
        Key: "KIBUKUKASASIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.45857141780113, 0.620216964785264],
            [33.45674805067508, 0.620910643582826],
            [33.45671246481343, 0.621668316300179],
            [33.455924233575814, 0.622398139185031],
            [33.455480711963844, 0.624033147854391],
            [33.45383254326765, 0.626142381594143],
            [33.453821496684604, 0.627128477862943],
            [33.45307002810168, 0.628518625339165],
            [33.453073518056534, 0.629902825059334],
            [33.4516704160581, 0.632671426402793],
            [33.44593889325419, 0.62953251695016],
            [33.44246290717805, 0.626655847686059],
            [33.44187265834084, 0.627696311128261],
            [33.4412859461709, 0.630727131265024],
            [33.44036033378024, 0.631378599400581],
            [33.43600174934421, 0.633392884050006],
            [33.43420355480905, 0.633062058329451],
            [33.43211110811942, 0.633636725810795],
            [33.432054303152434, 0.63679643198439],
            [33.43072290467995, 0.639075358816831],
            [33.430099688570124, 0.642437199530827],
            [33.42790948990624, 0.645512925714156],
            [33.42753972177573, 0.647052547347071],
            [33.4267914332289, 0.647327356799343],
            [33.42549124222938, 0.649211727370475],
            [33.423901638299846, 0.65210844117952],
            [33.423620766551544, 0.653401005137492],
            [33.423076585118714, 0.653347345068232],
            [33.42217235622506, 0.655104467263437],
            [33.42112043531559, 0.655526913715714],
            [33.419974994395126, 0.655038868484215],
            [33.41919910421287, 0.655897446300864],
            [33.41893834035387, 0.65511093650721],
            [33.417108664359596, 0.653918990325122],
            [33.41732871387496, 0.651305720842275],
            [33.416444874043336, 0.650640392435889],
            [33.416556549904506, 0.650145000780664],
            [33.41584456048168, 0.649145776397499],
            [33.41661143876498, 0.647000786127755],
            [33.416461668047575, 0.645234292278026],
            [33.41701733174634, 0.644623667911242],
            [33.41700725175054, 0.643967573623865],
            [33.416260208268675, 0.643432666021357],
            [33.41573384671617, 0.644023194690969],
            [33.41478131720633, 0.644275617010653],
            [33.4141915148318, 0.643721025900062],
            [33.415182255978884, 0.642610110756776],
            [33.414865215362276, 0.641902565736975],
            [33.41525732189897, 0.640934538068654],
            [33.415081694972706, 0.63898645359149],
            [33.41583868729636, 0.638567499991332],
            [33.41573171052241, 0.637143655197545],
            [33.41612430125104, 0.636705175075487],
            [33.415775179999024, 0.635926721500012],
            [33.41618936712538, 0.635357650433159],
            [33.41599377065037, 0.634439132738078],
            [33.414840581760565, 0.633137129547854],
            [33.41526669042907, 0.632748484579059],
            [33.41486056119081, 0.632208500637672],
            [33.4149106314881, 0.631416135022089],
            [33.41596834742951, 0.629982732560516],
            [33.41535703848878, 0.627488895386185],
            [33.41578246533598, 0.625112501164217],
            [33.41363953063245, 0.619271799262736],
            [33.41374644811756, 0.618231377273714],
            [33.41278725490494, 0.616665357921599],
            [33.41437053199995, 0.612719124296448],
            [33.41465469607378, 0.609979840829709],
            [33.41401895565226, 0.608958280587669],
            [33.41455417728844, 0.608009601757649],
            [33.414442593953744, 0.607184462922622],
            [33.41614858001823, 0.603732188400274],
            [33.41535922229322, 0.602652561295252],
            [33.415958863016726, 0.601975258217258],
            [33.41599222554805, 0.600757181940316],
            [33.41532273092976, 0.598281834518638],
            [33.41622054315731, 0.596827896882749],
            [33.415863629918526, 0.596148721994938],
            [33.41620920911336, 0.594408590565399],
            [33.41739116026193, 0.592370894985405],
            [33.417301854247945, 0.591152829158182],
            [33.41797088892886, 0.59008626219175],
            [33.41786486077588, 0.588952395897407],
            [33.41995569948114, 0.58699883011161],
            [33.41960552540359, 0.586124466614663],
            [33.42189526458748, 0.581616603349721],
            [33.42199234462194, 0.57952217829884],
            [33.423095976152425, 0.578283958800643],
            [33.42277548420853, 0.576954140671167],
            [33.42320160814838, 0.576235558069794],
            [33.42333027654148, 0.575310811637507],
            [33.422993742483214, 0.574814897409666],
            [33.42343167387915, 0.573955373249429],
            [33.423033521680615, 0.573651071631194],
            [33.42326982531274, 0.573122247328917],
            [33.422659995897284, 0.572890516930801],
            [33.42226168020535, 0.571925859797974],
            [33.42315138513746, 0.570240724696089],
            [33.422709408627796, 0.5678666268372],
            [33.4238189879038, 0.564858929449134],
            [33.424300039331705, 0.564756940585691],
            [33.424710014257705, 0.563821260342488],
            [33.424655273619244, 0.562885614981477],
            [33.425422479787656, 0.560638764265943],
            [33.42497212648793, 0.559958191827012],
            [33.42522459620191, 0.558686916189559],
            [33.42571239397762, 0.558331624222474],
            [33.42530154768577, 0.55590964805425],
            [33.426115185076256, 0.554593053660189],
            [33.42561693630058, 0.553951540140786],
            [33.42650742097037, 0.553201260014996],
            [33.42667165366555, 0.552156899406919],
            [33.42769276864899, 0.551566449787192],
            [33.43065551486396, 0.551642831792537],
            [33.4314652167352, 0.552684389877679],
            [33.4333710177633, 0.552394259210539],
            [33.43512111919308, 0.552954258176434],
            [33.4377033686981, 0.552393937628625],
            [33.44022885725356, 0.552895228136364],
            [33.44215475000131, 0.551293750964985],
            [33.44482660106602, 0.550262184136677],
            [33.446176754565, 0.548488856539476],
            [33.448388190300534, 0.547866679511609],
            [33.44938333409079, 0.548495913381009],
            [33.45012648966411, 0.548379395548659],
            [33.452580572035956, 0.550640278370178],
            [33.45574087754486, 0.552730439868011],
            [33.461708721947154, 0.552839295342617],
            [33.472502705924605, 0.551985970519778],
            [33.47321046518076, 0.551224565924131],
            [33.475652661044776, 0.550874570629349],
            [33.477357543079805, 0.551046035817837],
            [33.47965126000377, 0.552608358212354],
            [33.48056386478912, 0.554281080674159],
            [33.47967837565063, 0.557180426648655],
            [33.47974618947141, 0.562177845821524],
            [33.480503619274586, 0.563452707499925],
            [33.480211030800035, 0.565374729571705],
            [33.48038953592846, 0.569135423936876],
            [33.479947909761734, 0.569948377967509],
            [33.479645235003176, 0.572710402937659],
            [33.4789237171501, 0.573745595711602],
            [33.478779082999466, 0.575152540054543],
            [33.477311046280704, 0.57815077147765],
            [33.47466759814862, 0.581875590465575],
            [33.47461733561185, 0.582960363311942],
            [33.47276972654957, 0.587241299625453],
            [33.47305075280811, 0.58920565801386],
            [33.4727227787962, 0.591126629390817],
            [33.47143176408729, 0.592688630076298],
            [33.47079725435773, 0.596961438575799],
            [33.47008766433501, 0.597830233807189],
            [33.46994603684563, 0.599707614720893],
            [33.469263732251356, 0.601791556589819],
            [33.467903461027326, 0.603848258662829],
            [33.46728757157696, 0.606615750760966],
            [33.4663479409763, 0.607615146763299],
            [33.46550786077709, 0.610455207706494],
            [33.46367780210049, 0.612260142853643],
            [33.46234664707145, 0.614924082402074],
            [33.46086745417517, 0.617265498347429],
            [33.459750458408166, 0.618202712803378],
            [33.459651479335214, 0.618808856146493],
            [33.458827546353255, 0.61893254784358],
            [33.45857141780113, 0.620216964785264],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1003,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "BULAMOGI",
        Population: 29413,
        Key: "IGANGABULAMOGI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.82722033999401, 0.948351638330145],
            [33.83708305758441, 0.967770871431453],
            [33.841721370213385, 0.97378945106342],
            [33.843755276390894, 0.977199699072953],
            [33.8446762417966, 0.980150669917801],
            [33.84459820514785, 0.981866841024549],
            [33.843250686407615, 0.984732224424216],
            [33.84288049067902, 0.987697886463425],
            [33.84348747872325, 0.990210923672976],
            [33.84527890984262, 0.993064244503355],
            [33.851104472782005, 0.999513218075139],
            [33.855706992038535, 1.002631914540407],
            [33.861177653067074, 1.007914129518442],
            [33.862330274221605, 1.007986191997939],
            [33.86632566888995, 1.010282879111931],
            [33.86863371124777, 1.012507642340158],
            [33.86965163272039, 1.012986820475604],
            [33.87012768412543, 1.014090336818787],
            [33.872620749787345, 1.01712920760099],
            [33.875593238231566, 1.019172851301958],
            [33.869654502837726, 1.02331254494473],
            [33.86514933400854, 1.024521390836503],
            [33.86643988428845, 1.028255353268861],
            [33.86679762218066, 1.030591696299012],
            [33.8664607243047, 1.031949720916784],
            [33.867833183870516, 1.035707706041715],
            [33.86765833039372, 1.038534067770229],
            [33.86290959505337, 1.04019085176114],
            [33.857397865744986, 1.043222881502572],
            [33.85314306636867, 1.047774346235387],
            [33.84963420464809, 1.050263048416805],
            [33.84660152997813, 1.054334729315963],
            [33.84646348856336, 1.050689094451755],
            [33.84389489794223, 1.044538596181278],
            [33.843261308985824, 1.040601659961119],
            [33.841995630361225, 1.038328094553155],
            [33.84205975390284, 1.036742837908049],
            [33.838571575891656, 1.034068335200684],
            [33.837821956939884, 1.03184256120004],
            [33.8324930976739, 1.03300723638758],
            [33.82926262835144, 1.032619094303448],
            [33.82628869900947, 1.03162477392259],
            [33.82374356968864, 1.029282871077244],
            [33.818164392173756, 1.01925141630452],
            [33.817236604063496, 1.013154377691462],
            [33.81671281169269, 1.012023710990971],
            [33.80261991305633, 0.997100641209806],
            [33.802211554199516, 0.99710074180588],
            [33.801121360567336, 0.992758718560612],
            [33.79921863447247, 0.989430091610434],
            [33.79611440180363, 0.985975100549282],
            [33.78865791782148, 0.979336784121618],
            [33.787423926370195, 0.977468275129645],
            [33.78581081263136, 0.973548019678637],
            [33.78378323508503, 0.966497090928053],
            [33.781606409640816, 0.955692913132855],
            [33.82722033999401, 0.948351638330145],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1004,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KIRIKA",
        Population: 23542,
        Key: "KIBUKUKIRIKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.541575810240914, 0.887425625110082],
            [33.53371469900365, 0.887233878454903],
            [33.531388543914765, 0.886601119003179],
            [33.52091708836199, 0.879587729425691],
            [33.514712254913, 0.878440909819282],
            [33.51311179753817, 0.877676896157337],
            [33.5093858884719, 0.874193165919687],
            [33.50808844811379, 0.873436152047569],
            [33.505598558894704, 0.87245666190854],
            [33.50367226370172, 0.870418947228321],
            [33.502966125006324, 0.868665270357668],
            [33.501528915773164, 0.868490930090629],
            [33.49934418156116, 0.866558867318314],
            [33.492833483436016, 0.85912309552305],
            [33.48436093390061, 0.848747268293741],
            [33.48239832341397, 0.844404949386378],
            [33.482005985111954, 0.842287996929386],
            [33.48225504122783, 0.839483391272996],
            [33.481969131727425, 0.834923731459603],
            [33.48473352902935, 0.832019297691921],
            [33.487265681287575, 0.831620914393313],
            [33.493936302889495, 0.833918014260834],
            [33.49705798892601, 0.834043390520298],
            [33.500144696361986, 0.833494842072161],
            [33.49764380008573, 0.8174791549088],
            [33.49477406004538, 0.813191235851529],
            [33.492178080689555, 0.810558879405882],
            [33.49056787569559, 0.807682129223627],
            [33.48927411932848, 0.806515222961136],
            [33.48547503978735, 0.804489151804353],
            [33.483701541736, 0.802942325132377],
            [33.4817928436411, 0.798057164270048],
            [33.480851925754635, 0.797577783474206],
            [33.47896179673499, 0.797749899273062],
            [33.47747826767083, 0.797261534361766],
            [33.47428472898801, 0.795307749877168],
            [33.47001535714114, 0.791915605597696],
            [33.468187310690816, 0.784705328065096],
            [33.4677433462094, 0.777702972653569],
            [33.46804109820021, 0.773034669669535],
            [33.46957826836492, 0.765914482450832],
            [33.471648682075575, 0.760495081320992],
            [33.471702878334995, 0.75783524875284],
            [33.47431533189479, 0.747186608126654],
            [33.47409542610986, 0.744581088473679],
            [33.474546904998626, 0.742638090163626],
            [33.47496057469539, 0.741891211768779],
            [33.47682746160368, 0.740461649138772],
            [33.47754207410716, 0.739776742677749],
            [33.47861095970079, 0.73948712121737],
            [33.47890239833178, 0.738819104224008],
            [33.48200980654517, 0.739432467775901],
            [33.485289545766, 0.739151649050302],
            [33.48639379623576, 0.738672035288012],
            [33.4882008239051, 0.739024668377233],
            [33.48927022513169, 0.739870517178789],
            [33.49060555463188, 0.739818165932171],
            [33.49238159761044, 0.739087129330547],
            [33.493431998570486, 0.739584998886877],
            [33.496193071207514, 0.737411138806551],
            [33.49794646496282, 0.737786210949494],
            [33.4993688690618, 0.73614096134052],
            [33.499921293435655, 0.734791690662228],
            [33.50136256934211, 0.735152986698125],
            [33.501636513282975, 0.73611357037506],
            [33.50206846639068, 0.736179911770962],
            [33.50672429347278, 0.733281874142696],
            [33.51055487064269, 0.731839784561641],
            [33.5125041240794, 0.731503865393456],
            [33.513800096590344, 0.732151885921386],
            [33.5158068763412, 0.731654911981317],
            [33.51770888468215, 0.732172737709808],
            [33.51895695812384, 0.732027840503892],
            [33.52220248141383, 0.733585450190449],
            [33.524403590116854, 0.733805343335178],
            [33.528379247900105, 0.735401241734547],
            [33.531783331024265, 0.737781416140031],
            [33.53428390480533, 0.741000590572276],
            [33.535685264072164, 0.745044402144514],
            [33.53772618878697, 0.747230170916606],
            [33.54821443295409, 0.753836455180924],
            [33.550299746122036, 0.756179340983285],
            [33.55410727252177, 0.759091293378502],
            [33.55741479753265, 0.761048348946561],
            [33.55679143320081, 0.761796636989335],
            [33.55664447510854, 0.763397958628353],
            [33.55554817922065, 0.764465638097042],
            [33.55686974114075, 0.767930431257968],
            [33.55721947773875, 0.775005067503482],
            [33.557677530498765, 0.777040561139648],
            [33.559805777747385, 0.781057101840542],
            [33.56297141206254, 0.792835737403928],
            [33.56415411869426, 0.799358387655358],
            [33.564133025353044, 0.801185863268255],
            [33.56234237936124, 0.805709561507169],
            [33.560862050096134, 0.808025774320159],
            [33.54883837490267, 0.821507343739035],
            [33.54778422257801, 0.822746918162356],
            [33.54693409292573, 0.824891156539211],
            [33.54439884147972, 0.835205003624412],
            [33.543516575496476, 0.840551861088461],
            [33.54360242658988, 0.843944445704151],
            [33.545711082480466, 0.859857685645643],
            [33.54584202540784, 0.864236377295245],
            [33.5428686242753, 0.878087652906952],
            [33.541575810240914, 0.887425625110082],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1005,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAMBALE",
        Population: 46640,
        Key: "IGANGANAMBALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.64595170449985, 0.884599087070998],
            [33.64207335941471, 0.880546494216987],
            [33.637556505300324, 0.873174270564748],
            [33.63577840338315, 0.871349217709278],
            [33.63154716412178, 0.870813067199769],
            [33.62724506575079, 0.871815950781497],
            [33.62376064179918, 0.872174449346901],
            [33.618818173988025, 0.871029947553752],
            [33.616933408808954, 0.869204896354286],
            [33.61599163572636, 0.872032575087518],
            [33.6151026063273, 0.871245310816133],
            [33.60816865168471, 0.867953628565273],
            [33.60560826897033, 0.865770762077357],
            [33.6021240678009, 0.867596690691876],
            [33.59878186332846, 0.868026724176244],
            [33.584274927584396, 0.867814266446863],
            [33.58171477034716, 0.867080935359095],
            [33.57751856538189, 0.863305560748709],
            [33.57517170951558, 0.862321647877304],
            [33.5727895543502, 0.863055740671567],
            [33.57040749350794, 0.864434084770566],
            [33.56893213731624, 0.865955457065563],
            [33.56551946090807, 0.870823653520895],
            [33.56104124513067, 0.883423041303322],
            [33.55677503445529, 0.887217622694043],
            [33.5432261196224, 0.896799243266624],
            [33.541674462327094, 0.893811389237071],
            [33.54139443948671, 0.891848248165919],
            [33.541575810240914, 0.887425625110082],
            [33.5428686242753, 0.878087652906952],
            [33.54584202540784, 0.864236377295245],
            [33.545711082480466, 0.859857685645643],
            [33.54360242658988, 0.843944445704151],
            [33.543516575496476, 0.840551861088461],
            [33.54439884147972, 0.835205003624412],
            [33.54693409292573, 0.824891156539211],
            [33.54778422257801, 0.822746918162356],
            [33.54883837490267, 0.821507343739035],
            [33.5581587597931, 0.821569367829572],
            [33.56372400264128, 0.820672935850964],
            [33.56594667180941, 0.820717853295082],
            [33.574599764750594, 0.824968640777151],
            [33.57874962024049, 0.828767719924335],
            [33.583105917565824, 0.830712151211709],
            [33.58797766640454, 0.831344701649928],
            [33.589071278126376, 0.831181693447797],
            [33.590222335313996, 0.832040971754215],
            [33.593220538033236, 0.830918707873503],
            [33.60432118618742, 0.829134783434697],
            [33.60672536984019, 0.829803876453381],
            [33.61505879099934, 0.833611285545145],
            [33.618052195816645, 0.834262181663045],
            [33.62113086872071, 0.834216458668897],
            [33.62234195133561, 0.834578136843707],
            [33.624049754691924, 0.836061538788315],
            [33.62742197277632, 0.8416609588248],
            [33.62985118439122, 0.844256991366246],
            [33.62644016357811, 0.848916645915833],
            [33.6231669793639, 0.854978534894794],
            [33.622132363600045, 0.858207386594193],
            [33.6356938252025, 0.857518128151216],
            [33.638918772580936, 0.858232757561283],
            [33.64071024322618, 0.859453767713754],
            [33.641937537737, 0.862656114742517],
            [33.647753909114456, 0.871687578421267],
            [33.64860499277755, 0.875019602331569],
            [33.64756548568697, 0.878856216814803],
            [33.64709228912791, 0.87944464555877],
            [33.64595170449985, 0.884599087070998],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1006,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "NABWEYO",
        Population: 16001,
        Key: "NAMUTUMBANABWEYO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.61059944882609, 0.789298864684784],
            [33.607270728066055, 0.78974941505541],
            [33.604915492714795, 0.790779288560444],
            [33.59701347399614, 0.79886516531827],
            [33.59578686040828, 0.79979717104346],
            [33.591742258723606, 0.801100508304743],
            [33.57854854224559, 0.801391911253058],
            [33.57099079477474, 0.8008954043424],
            [33.564133025353044, 0.801185863268255],
            [33.56415411869426, 0.799358387655358],
            [33.56297141206254, 0.792835737403928],
            [33.559805777747385, 0.781057101840542],
            [33.557677530498765, 0.777040561139648],
            [33.55721947773875, 0.775005067503482],
            [33.55686974114075, 0.767930431257968],
            [33.55554817922065, 0.764465638097042],
            [33.55664447510854, 0.763397958628353],
            [33.55679143320081, 0.761796636989335],
            [33.55741479753265, 0.761048348946561],
            [33.55863952555673, 0.760310816254121],
            [33.55983981042193, 0.757824646864967],
            [33.5597947455374, 0.756820445953207],
            [33.55908515371803, 0.755508736911273],
            [33.5592950693387, 0.750455117718555],
            [33.55967854486212, 0.749520694760097],
            [33.56164430753711, 0.747275722406977],
            [33.56492565384402, 0.745590413958162],
            [33.56718010989848, 0.74527564038213],
            [33.568130947880626, 0.744416061227553],
            [33.56965250173246, 0.743845909079759],
            [33.572694910546836, 0.74164711774264],
            [33.57336317087995, 0.740431402694113],
            [33.572517091731285, 0.739132106929214],
            [33.57258882220672, 0.73783839335077],
            [33.571994964836996, 0.736689515375243],
            [33.57116584318597, 0.722865977795659],
            [33.57429247714304, 0.716026135425709],
            [33.574126565496584, 0.714325342075585],
            [33.57468578832054, 0.712561129247187],
            [33.574186858621836, 0.711357956666645],
            [33.5742825534541, 0.708490082499168],
            [33.57695697639547, 0.705766635715381],
            [33.57743259481257, 0.704717138018272],
            [33.57736152998876, 0.702346864801974],
            [33.57927579584177, 0.69806745317111],
            [33.57937189581422, 0.693905878088471],
            [33.57773628556571, 0.691085698386072],
            [33.58784195611794, 0.689563351331389],
            [33.59925727782795, 0.695548991544049],
            [33.6018847377446, 0.697838412344881],
            [33.600397115955985, 0.708794329393732],
            [33.601287819814736, 0.712114402837875],
            [33.60048096829789, 0.719072283982845],
            [33.59951518234941, 0.721061963470586],
            [33.59943881207553, 0.722309793290309],
            [33.59844054304637, 0.723648693894109],
            [33.59821997610141, 0.727561525019669],
            [33.59759869675933, 0.728495977748345],
            [33.60014319007295, 0.728227919670615],
            [33.605430088133716, 0.725445311055841],
            [33.608450575360216, 0.724776563495003],
            [33.60945914447239, 0.724939684495819],
            [33.61200823716028, 0.723822038744207],
            [33.61305224301383, 0.723704554767282],
            [33.614613282313954, 0.724234930768933],
            [33.61670629673882, 0.723505083597517],
            [33.61770474453273, 0.723790647824945],
            [33.619757280870914, 0.723560783686833],
            [33.62191618043366, 0.722856434853594],
            [33.62313763589514, 0.723244003679402],
            [33.62470646358881, 0.722650777441298],
            [33.626102387149835, 0.722774224886178],
            [33.62683718659435, 0.72226394243015],
            [33.62734984255058, 0.722376127703679],
            [33.633469488761186, 0.724921569621534],
            [33.63690886220129, 0.729253213324801],
            [33.6383581169441, 0.730021982205917],
            [33.64013755824938, 0.731673608889396],
            [33.639771080647776, 0.736264052711856],
            [33.63934318343355, 0.737005949510777],
            [33.638569383630944, 0.742343658815729],
            [33.63866451611786, 0.743773035800184],
            [33.63986549448245, 0.748296245614559],
            [33.639364575015406, 0.749020061547214],
            [33.63950224991753, 0.74943619297978],
            [33.640663658392164, 0.752195286870162],
            [33.64316038019731, 0.756166445892165],
            [33.64360774390373, 0.757930497772176],
            [33.64291984370357, 0.76791671162269],
            [33.64116460480866, 0.77209418044241],
            [33.637535233194384, 0.776163573374059],
            [33.63540463056308, 0.779459436364259],
            [33.63471998406088, 0.777665057359929],
            [33.63429309206144, 0.773577793720551],
            [33.63380271701922, 0.772569444860572],
            [33.6324496871147, 0.770802022532177],
            [33.63099800961555, 0.769903043806405],
            [33.62990388405738, 0.767125492617647],
            [33.62706719034139, 0.764392612462685],
            [33.62587774185345, 0.761823296630288],
            [33.62258693898157, 0.760450006932288],
            [33.61953726728813, 0.763910357965035],
            [33.617235154709526, 0.767372192789715],
            [33.61873135540908, 0.769131586324976],
            [33.617156546732275, 0.772632516130343],
            [33.61163482815794, 0.779732859122715],
            [33.61030183876906, 0.784209526959581],
            [33.611157009766714, 0.787413035663616],
            [33.61059944882609, 0.789298864684784],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1007,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "NAMALEMBA",
        Population: 22991,
        Key: "IGANGANAMALEMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.65886584010862, 0.853619966990679],
            [33.657147829195715, 0.855042788723669],
            [33.656039513849294, 0.856695883485797],
            [33.65381827120582, 0.866182053664323],
            [33.6521593496757, 0.869859086490822],
            [33.651918611061014, 0.87254860010512],
            [33.64860499277755, 0.875019602331569],
            [33.647753909114456, 0.871687578421267],
            [33.641937537737, 0.862656114742517],
            [33.64071024322618, 0.859453767713754],
            [33.638918772580936, 0.858232757561283],
            [33.6356938252025, 0.857518128151216],
            [33.622132363600045, 0.858207386594193],
            [33.6231669793639, 0.854978534894794],
            [33.62644016357811, 0.848916645915833],
            [33.62985118439122, 0.844256991366246],
            [33.62742197277632, 0.8416609588248],
            [33.624049754691924, 0.836061538788315],
            [33.62234195133561, 0.834578136843707],
            [33.62113086872071, 0.834216458668897],
            [33.618052195816645, 0.834262181663045],
            [33.61505879099934, 0.833611285545145],
            [33.60672536984019, 0.829803876453381],
            [33.60432118618742, 0.829134783434697],
            [33.593220538033236, 0.830918707873503],
            [33.590222335313996, 0.832040971754215],
            [33.589071278126376, 0.831181693447797],
            [33.58797766640454, 0.831344701649928],
            [33.583105917565824, 0.830712151211709],
            [33.57874962024049, 0.828767719924335],
            [33.574599764750594, 0.824968640777151],
            [33.56594667180941, 0.820717853295082],
            [33.56372400264128, 0.820672935850964],
            [33.5581587597931, 0.821569367829572],
            [33.54883837490267, 0.821507343739035],
            [33.560862050096134, 0.808025774320159],
            [33.56234237936124, 0.805709561507169],
            [33.564133025353044, 0.801185863268255],
            [33.57099079477474, 0.8008954043424],
            [33.57854854224559, 0.801391911253058],
            [33.591742258723606, 0.801100508304743],
            [33.59578686040828, 0.79979717104346],
            [33.59701347399614, 0.79886516531827],
            [33.604915492714795, 0.790779288560444],
            [33.607270728066055, 0.78974941505541],
            [33.61059944882609, 0.789298864684784],
            [33.615824626338615, 0.789701639102349],
            [33.62124074615469, 0.789234784952753],
            [33.630320390633806, 0.786427149478179],
            [33.63540463056308, 0.779459436364259],
            [33.637535233194384, 0.776163573374059],
            [33.64116460480866, 0.77209418044241],
            [33.64291984370357, 0.76791671162269],
            [33.64453808053449, 0.770405844733235],
            [33.650261977539934, 0.771822338081802],
            [33.651653192132244, 0.773071383168166],
            [33.6528260756863, 0.773455589063569],
            [33.652933049765295, 0.77431909490896],
            [33.65423524760116, 0.775226267280632],
            [33.656730315607845, 0.775542512673107],
            [33.66077270833523, 0.775044306816553],
            [33.66673458433081, 0.772266019735873],
            [33.66828083736138, 0.771813438381498],
            [33.66975416964876, 0.77200318487421],
            [33.67141100259587, 0.774662654741974],
            [33.67191343392753, 0.776453823839355],
            [33.67191153578733, 0.778652175284778],
            [33.671189175314545, 0.781990528971764],
            [33.6712586725782, 0.791543847261783],
            [33.669870753006336, 0.795108480520157],
            [33.66785524432585, 0.797560471022888],
            [33.66713609533022, 0.799876549226691],
            [33.66912918655278, 0.801197042607225],
            [33.6744247865937, 0.803361180072774],
            [33.67970711133134, 0.805700538822296],
            [33.68148162897056, 0.81323613541475],
            [33.68264245713351, 0.815461423863341],
            [33.67858397917266, 0.820582548553993],
            [33.67253747379246, 0.824591272475899],
            [33.67182097662353, 0.825921260962926],
            [33.66881756547229, 0.829051936897266],
            [33.66641252931831, 0.834513268293922],
            [33.66502257326572, 0.84092600595186],
            [33.66377461391008, 0.843367709869285],
            [33.66293892287938, 0.846859960901951],
            [33.66103883783144, 0.851082620291121],
            [33.65886584010862, 0.853619966990679],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1008,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "NSINZE",
        Population: 25549,
        Key: "NAMUTUMBANSINZE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.83473177661703, 0.730584880122885],
            [33.833383274221546, 0.732523221819808],
            [33.83304651378782, 0.734599891863979],
            [33.83255635434124, 0.735296197803896],
            [33.8297783439695, 0.736953230849871],
            [33.827778149768, 0.736027473062082],
            [33.826526840594674, 0.736752508120026],
            [33.822799025303354, 0.734668691769182],
            [33.82104061266057, 0.735501287848326],
            [33.816027510318634, 0.736761910906981],
            [33.816615708302045, 0.740138799118579],
            [33.81818735580739, 0.741287098633604],
            [33.81813978013162, 0.742648910360555],
            [33.81881617021806, 0.743844708133421],
            [33.81801345993466, 0.745885899622124],
            [33.81392569330229, 0.747005753109946],
            [33.81315075982581, 0.748332070067384],
            [33.81403930413456, 0.749795929375656],
            [33.81531505736511, 0.750935537714697],
            [33.81528721318455, 0.752220134824349],
            [33.81369994128148, 0.753369518050979],
            [33.8131523705051, 0.755486295353304],
            [33.810240718666876, 0.755622541765087],
            [33.80929777867271, 0.756156458394384],
            [33.80825798501952, 0.758373030221745],
            [33.80651131425582, 0.758988517163092],
            [33.80398760077136, 0.761250602954262],
            [33.803184213158254, 0.763177646593123],
            [33.80143715342401, 0.764743012258499],
            [33.80153494043258, 0.768053993305947],
            [33.80095283931498, 0.769926718564726],
            [33.79890108271448, 0.77304813419001],
            [33.79833306807886, 0.775156066773541],
            [33.7981671258897, 0.779787883024347],
            [33.797404781403614, 0.781932039721297],
            [33.79757197314933, 0.783913181632331],
            [33.79660178545597, 0.785921681817335],
            [33.794259505607755, 0.794199647143647],
            [33.79163529849076, 0.811316074359379],
            [33.78693617890019, 0.82500432265265],
            [33.78602676582903, 0.824724063855293],
            [33.78405264972022, 0.822806602363661],
            [33.77426595834895, 0.811183772069113],
            [33.768629608456166, 0.805756946545841],
            [33.76437262797033, 0.802663843291802],
            [33.75991318788069, 0.798159506587144],
            [33.751499153704586, 0.794632912363003],
            [33.748682258857485, 0.794461534778235],
            [33.74612666057032, 0.793694829847998],
            [33.7441480834278, 0.792239895170896],
            [33.73434043795422, 0.782810950297368],
            [33.73210523818614, 0.782332627655376],
            [33.72802492846894, 0.78216100704177],
            [33.72603700615252, 0.781625191209887],
            [33.717513931772295, 0.7752692944404],
            [33.71581134672948, 0.774742994513191],
            [33.71201636799764, 0.774580875999689],
            [33.699403740235915, 0.769642606186056],
            [33.70095861349993, 0.765502603049099],
            [33.70088554902631, 0.76177539191419],
            [33.699898526904505, 0.757378877113949],
            [33.69989306424926, 0.755110471997159],
            [33.6942573458721, 0.750626465639934],
            [33.691674364240136, 0.746551339397886],
            [33.690070532793115, 0.745067938709785],
            [33.68802762729311, 0.740979160358506],
            [33.68599111779792, 0.738998321185056],
            [33.68540185081929, 0.737840371276995],
            [33.68383349384285, 0.736890712379166],
            [33.68167125883544, 0.734737933608092],
            [33.680887456292155, 0.733037274832558],
            [33.67783416259152, 0.729301454337438],
            [33.67545807734253, 0.728107650357392],
            [33.67508047680103, 0.727094474638327],
            [33.676563598928375, 0.725257769532251],
            [33.68043778391546, 0.723393562153957],
            [33.68213764616467, 0.721122584171197],
            [33.68403883075052, 0.720479980271267],
            [33.68627297769303, 0.719095498214651],
            [33.68952921249447, 0.716625257707428],
            [33.68974313280468, 0.716100518206725],
            [33.69056313835218, 0.715819945944448],
            [33.691395384343814, 0.714761357592265],
            [33.69201321146026, 0.714643656904948],
            [33.69415279454945, 0.711965515882469],
            [33.709428071034125, 0.706472335437954],
            [33.721092903407545, 0.700852087717256],
            [33.722352147399796, 0.700707145506719],
            [33.72430115739305, 0.700779214646531],
            [33.74117253262677, 0.707480062466199],
            [33.744761960651935, 0.709732078034629],
            [33.74776680102279, 0.712653628803762],
            [33.75079440919452, 0.717393528405292],
            [33.75464051284584, 0.719545967826715],
            [33.75749327652394, 0.719825933545433],
            [33.75907364577234, 0.718821501286435],
            [33.760426993680504, 0.717174803977839],
            [33.77589864278458, 0.696745168150735],
            [33.78092319505315, 0.692800057489063],
            [33.78460109815064, 0.691738873359887],
            [33.78554396538127, 0.689704518538448],
            [33.78557853704496, 0.688565951241942],
            [33.79003433985602, 0.685190444457412],
            [33.79205390712496, 0.684204041643446],
            [33.80190825960342, 0.684437595042876],
            [33.80592647597156, 0.68510635109168],
            [33.83338528465115, 0.691515485811505],
            [33.852993389076026, 0.695818019834308],
            [33.85925778262501, 0.697631732510603],
            [33.85932172740186, 0.698514254585068],
            [33.858444767767004, 0.699653306337103],
            [33.85562360951551, 0.701137911145611],
            [33.84925611721973, 0.700157973648599],
            [33.848312328317604, 0.700479731536679],
            [33.846250693842215, 0.702190353205778],
            [33.84418883388973, 0.702658489406904],
            [33.843394123103955, 0.703580325931973],
            [33.84233417395075, 0.70563213128942],
            [33.84217916875016, 0.70774167504345],
            [33.84381329318521, 0.708976840513117],
            [33.84400812609221, 0.711979535704948],
            [33.84297443110152, 0.715224059037081],
            [33.84063760312878, 0.716990467949684],
            [33.840218003652815, 0.717922809283346],
            [33.84048520573746, 0.719811240063655],
            [33.842102378064745, 0.720688435812476],
            [33.84211844982348, 0.721557568753756],
            [33.84163280620784, 0.721954572845032],
            [33.83974139888557, 0.722121745027472],
            [33.83765066797814, 0.723833605427064],
            [33.837823140919426, 0.726255575825275],
            [33.83898258028695, 0.727908015901643],
            [33.838094944174934, 0.728614520628854],
            [33.83775438746084, 0.730624117140951],
            [33.83559996150821, 0.729962999120386],
            [33.83473177661703, 0.730584880122885],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1009,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "BULANGE",
        Population: 44683,
        Key: "NAMUTUMBABULANGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.97003009762687, 1.049343263301535],
            [33.96716403708593, 1.051368375098133],
            [33.96513599421227, 1.052056507001456],
            [33.96319127097957, 1.051541489028565],
            [33.96092999311882, 1.049977226455309],
            [33.960202336179115, 1.047254590633816],
            [33.95980118899743, 1.04692001149321],
            [33.954686528519346, 1.047174876672253],
            [33.94743691486905, 1.04569353865694],
            [33.946295026785535, 1.045784347696437],
            [33.93728134020783, 1.050662930029024],
            [33.93386658779304, 1.046140903272941],
            [33.926289627154866, 1.039421888472583],
            [33.92091204955606, 1.033842000200945],
            [33.919019856207896, 1.030459290774142],
            [33.916317320489725, 1.023738776037887],
            [33.914409525201705, 1.020726951879009],
            [33.91104292787602, 1.017380830066059],
            [33.906290020759506, 1.01428423025125],
            [33.90248589448313, 1.012534494180511],
            [33.90629373978476, 1.011022708097218],
            [33.913332826061726, 1.010975486523451],
            [33.91379042966407, 1.010360216524341],
            [33.91803417437253, 1.000996232760221],
            [33.91845337140323, 0.997603803886532],
            [33.918007497103524, 0.99488095119861],
            [33.91845414125941, 0.993492614531701],
            [33.918405999645024, 0.991376801198746],
            [33.91889081231901, 0.990438426658567],
            [33.91843976731655, 0.987735724168415],
            [33.92209219598922, 0.989105547238894],
            [33.923297735100505, 0.989137712013953],
            [33.924697252820984, 0.990014918089677],
            [33.92679204950339, 0.993205020798683],
            [33.93018839364139, 0.996015701562944],
            [33.93082339115615, 0.99580966365762],
            [33.93157655126678, 0.994758500539181],
            [33.93553753327325, 0.994627354595324],
            [33.93841198228231, 0.996598411664572],
            [33.94175400349844, 1.000528092372328],
            [33.94362894559988, 1.000681332368593],
            [33.94497102324446, 1.000047694476331],
            [33.94502399869339, 0.999194982603757],
            [33.944280339165225, 0.997100929525344],
            [33.94421801225418, 0.992142132899734],
            [33.9433495812246, 0.990428028416315],
            [33.94295664913617, 0.988135724918778],
            [33.944953975017015, 0.988087284183341],
            [33.94932947023828, 0.988955951525434],
            [33.95099763094108, 0.988856509362316],
            [33.95087895900049, 0.987296938976621],
            [33.95158164097865, 0.985687024738747],
            [33.95219037894106, 0.981947557171486],
            [33.953247286398685, 0.978734093580011],
            [33.95570568787044, 0.980599900129875],
            [33.9569439984216, 0.980749865371871],
            [33.95754802472033, 0.982321819379042],
            [33.95923488924567, 0.984344427771603],
            [33.95966543649, 0.988515764433377],
            [33.960319153997, 0.989755738018643],
            [33.9645993900689, 0.995184229699203],
            [33.96628224092157, 0.996469037901905],
            [33.96463333291192, 1.000215553246816],
            [33.965132720751384, 1.003297405800416],
            [33.96690706142248, 1.006480751214581],
            [33.967310584648125, 1.007944592963633],
            [33.9664364502148, 1.010951009446076],
            [33.966551334858195, 1.013478440955067],
            [33.96544869506774, 1.015680734163179],
            [33.967031709854695, 1.020720461682794],
            [33.966555023340746, 1.023199218987174],
            [33.967800158393125, 1.024682389003243],
            [33.96879393225261, 1.025206755928193],
            [33.973260895732736, 1.026734164430122],
            [33.976275741539226, 1.029555591506532],
            [33.97912062070407, 1.03064590534692],
            [33.98071632239776, 1.031784303223803],
            [33.98221619002034, 1.03353398568483],
            [33.98663469208582, 1.036354948666255],
            [33.990531319683654, 1.037537409516354],
            [33.98858666831615, 1.040083197432945],
            [33.98652122139072, 1.04173734179645],
            [33.9829408995876, 1.04305013895358],
            [33.980201174514924, 1.043593761325571],
            [33.978460471259645, 1.045267817976663],
            [33.973485035277584, 1.046997167486464],
            [33.97003009762687, 1.049343263301535],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1010,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "BUDAKA TOWN COUNCIL",
        Population: 23809,
        Key: "BUDAKABUDAKA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86045312675613, 1.074268941837549],
            [33.85548993121811, 1.074505553309301],
            [33.84890754753329, 1.077601250333925],
            [33.846999559107495, 1.078126473295138],
            [33.840465028677855, 1.077630751179188],
            [33.84102915181165, 1.070031664063456],
            [33.84176298826218, 1.066801916255231],
            [33.84660152997813, 1.054334729315963],
            [33.84963420464809, 1.050263048416805],
            [33.85314306636867, 1.047774346235387],
            [33.857397865744986, 1.043222881502572],
            [33.86290959505337, 1.04019085176114],
            [33.86765833039372, 1.038534067770229],
            [33.867833183870516, 1.035707706041715],
            [33.8664607243047, 1.031949720916784],
            [33.86679762218066, 1.030591696299012],
            [33.86643988428845, 1.028255353268861],
            [33.86514933400854, 1.024521390836503],
            [33.869654502837726, 1.02331254494473],
            [33.875593238231566, 1.019172851301958],
            [33.872620749787345, 1.01712920760099],
            [33.87012768412543, 1.014090336818787],
            [33.86965163272039, 1.012986820475604],
            [33.86863371124777, 1.012507642340158],
            [33.86632566888995, 1.010282879111931],
            [33.862330274221605, 1.007986191997939],
            [33.861177653067074, 1.007914129518442],
            [33.855706992038535, 1.002631914540407],
            [33.851104472782005, 0.999513218075139],
            [33.84527890984262, 0.993064244503355],
            [33.84348747872325, 0.990210923672976],
            [33.84288049067902, 0.987697886463425],
            [33.843250686407615, 0.984732224424216],
            [33.84459820514785, 0.981866841024549],
            [33.8446762417966, 0.980150669917801],
            [33.843755276390894, 0.977199699072953],
            [33.841721370213385, 0.97378945106342],
            [33.83708305758441, 0.967770871431453],
            [33.82722033999401, 0.948351638330145],
            [33.863247331955804, 0.942263790216792],
            [33.867613176575986, 0.971969808394668],
            [33.86863143851008, 0.977046073569614],
            [33.87023056009006, 0.981077630545458],
            [33.873635701429635, 0.985258915971849],
            [33.880024578120796, 0.988179159188824],
            [33.885482314189034, 0.989507493284983],
            [33.88638628436785, 0.990294272186415],
            [33.8886697030054, 0.992953248271071],
            [33.891021619081684, 0.997575232808546],
            [33.89463012013695, 1.000387619076138],
            [33.89549778580191, 1.003978728199524],
            [33.89651545394962, 1.005606765901144],
            [33.89830493033494, 1.007397418536489],
            [33.89974710994658, 1.010590328211038],
            [33.90248589448313, 1.012534494180511],
            [33.906290020759506, 1.01428423025125],
            [33.899132879684515, 1.015564712516298],
            [33.89007375631976, 1.020037098558835],
            [33.8828473093223, 1.025238948190314],
            [33.88246702371647, 1.025861361200902],
            [33.88275293321688, 1.027919685332304],
            [33.88189690432812, 1.027919924245745],
            [33.88137347936826, 1.026842997611131],
            [33.87928040206133, 1.024785174864671],
            [33.879566404986534, 1.028444171183064],
            [33.87743720732035, 1.033266419291422],
            [33.87058317489022, 1.040738980730806],
            [33.8674801010481, 1.043443569058826],
            [33.86691511193837, 1.046481284645477],
            [33.865676241736786, 1.048502149076165],
            [33.86543333997889, 1.050484831238016],
            [33.86393208984911, 1.053190091966733],
            [33.86879982950672, 1.063302468099059],
            [33.87046747727152, 1.068604016334367],
            [33.863335031782036, 1.073481095138801],
            [33.86045312675613, 1.074268941837549],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1011,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KADAMA",
        Population: 19974,
        Key: "KIBUKUKADAMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.67159734283018, 0.61032901504518],
            [33.66771730621734, 0.611550164825557],
            [33.66755151045357, 0.610353483765155],
            [33.664586891251226, 0.607824642763842],
            [33.66303400416229, 0.604911105037888],
            [33.66239254596401, 0.604630734897332],
            [33.6606725246215, 0.605037264589962],
            [33.65959824105133, 0.604558705699994],
            [33.65828118058908, 0.60498406393505],
            [33.65675983604473, 0.606757412529246],
            [33.65403818687222, 0.608377114173507],
            [33.65335949620034, 0.610004860187351],
            [33.652064822653294, 0.611199943313399],
            [33.65062932650739, 0.611627297866232],
            [33.64833355693298, 0.611616737873448],
            [33.647323958351464, 0.612696866214745],
            [33.64587379002201, 0.61329954917337],
            [33.63919498386954, 0.618158479638529],
            [33.63594147635331, 0.619760995863446],
            [33.62971143707573, 0.616961194628473],
            [33.623433469982835, 0.610953909649041],
            [33.625770366227556, 0.610425391619591],
            [33.628870564562476, 0.608708413027588],
            [33.631652206822906, 0.603944282334446],
            [33.63334903905464, 0.602005707628019],
            [33.634376679400326, 0.598687354134793],
            [33.631325082617245, 0.597283209313653],
            [33.6295137942385, 0.597217712213328],
            [33.62638059808827, 0.595723223841243],
            [33.623010882710226, 0.595025465472841],
            [33.62220305382637, 0.594179571115736],
            [33.61962472277262, 0.593202460461849],
            [33.61858855382165, 0.593342206573656],
            [33.61745455114969, 0.59414725506279],
            [33.61654907359782, 0.595617570605877],
            [33.611481621384534, 0.60079320779257],
            [33.61067992709575, 0.60295415665437],
            [33.613921577748556, 0.614922733210241],
            [33.61437265688701, 0.61540216159587],
            [33.617091298499936, 0.626258023796841],
            [33.61964630030577, 0.631225085739165],
            [33.620322086724336, 0.633569540427369],
            [33.60494441038209, 0.639911130737854],
            [33.60192594526332, 0.639830068228714],
            [33.59973743543215, 0.640679893290797],
            [33.59837738788863, 0.640659630361468],
            [33.59701821440589, 0.641658111755134],
            [33.59370672423132, 0.642994125355399],
            [33.586018449753034, 0.644677587669714],
            [33.58480493000877, 0.645413987953947],
            [33.5843377871964, 0.646933916208008],
            [33.58369641074478, 0.647485849921254],
            [33.58379060000065, 0.650860321764059],
            [33.58287523738738, 0.652389350420467],
            [33.58346911092677, 0.653918201655672],
            [33.58337335590737, 0.656433243653549],
            [33.58399079764656, 0.657754013534055],
            [33.583383982078864, 0.660857162191369],
            [33.58148229982636, 0.662341074716477],
            [33.58023402695869, 0.66530859751747],
            [33.580353271126135, 0.666728942831804],
            [33.579555619256126, 0.670972022916435],
            [33.57874696122725, 0.672383432563176],
            [33.578805799081735, 0.67594789578305],
            [33.578496439060814, 0.677024511791974],
            [33.57954184808282, 0.677983354098957],
            [33.58030207344316, 0.680208793653172],
            [33.57883895230562, 0.685447112501852],
            [33.578536529075315, 0.688414247523485],
            [33.57739318392441, 0.690187854371043],
            [33.577317210705885, 0.688979066470576],
            [33.576438470610114, 0.686795390657602],
            [33.57394326156792, 0.685122020183251],
            [33.57270862422796, 0.679956397415758],
            [33.57105754678689, 0.67754107526005],
            [33.57046364539971, 0.675840330910818],
            [33.56811111038422, 0.674139793462564],
            [33.567862600444016, 0.672031895681941],
            [33.56833766460057, 0.670982400441264],
            [33.56757754703805, 0.66961640790604],
            [33.567119196037396, 0.664586387193621],
            [33.565809051704505, 0.66199007966393],
            [33.565524559745626, 0.659520308965366],
            [33.56460996249698, 0.657964346480975],
            [33.5646575660205, 0.656724915558997],
            [33.56209150056365, 0.654092558682933],
            [33.56180656124372, 0.652608898811321],
            [33.56229400957476, 0.651776528881539],
            [33.562270762971835, 0.649813352441146],
            [33.561178051361935, 0.647660312267038],
            [33.56034669470247, 0.647063309376139],
            [33.55930198906132, 0.642160000446007],
            [33.55797952702929, 0.63975366858224],
            [33.55796889906116, 0.634967853163352],
            [33.55746999002372, 0.633701340372239],
            [33.55914636222656, 0.63140324228573],
            [33.55869515552735, 0.629756753446998],
            [33.558695230087515, 0.623632297521525],
            [33.55947005486784, 0.623171890581344],
            [33.56106250376188, 0.620702568248377],
            [33.564465872725386, 0.620149211527647],
            [33.566462311070694, 0.619231193292068],
            [33.567116162426665, 0.618108072711638],
            [33.56681973455259, 0.616067251994618],
            [33.56733886556539, 0.614104678246203],
            [33.571516570625704, 0.611673256650518],
            [33.573808594225376, 0.60894339185279],
            [33.575107542854845, 0.605649631702972],
            [33.57353315638621, 0.599131410238086],
            [33.57366794589966, 0.598166850141798],
            [33.574381076182895, 0.596251846599514],
            [33.57568870792791, 0.594905274673233],
            [33.57657813887386, 0.593280870199811],
            [33.577798431915376, 0.5896988438351],
            [33.58079704336806, 0.585831727262219],
            [33.582175703105975, 0.583397972899805],
            [33.58267198007962, 0.581380372071558],
            [33.58368241858592, 0.580333042375187],
            [33.58651493333922, 0.57866768246368],
            [33.58952664941526, 0.578712755828916],
            [33.59130090923798, 0.577120767908964],
            [33.593205272063294, 0.576307382828559],
            [33.59388574678935, 0.567651175596365],
            [33.59512153666781, 0.560010485651881],
            [33.59578751348348, 0.55838198408086],
            [33.598556414938244, 0.557087999765592],
            [33.600814726561914, 0.555486476119311],
            [33.60294061393628, 0.552644166088869],
            [33.60294792801932, 0.545403731473392],
            [33.609728765720085, 0.541975986545507],
            [33.61186428572927, 0.541523945756136],
            [33.61502631241025, 0.541594782836694],
            [33.61681141759339, 0.542746887979354],
            [33.617632864936944, 0.542789836302557],
            [33.618426971156545, 0.544709879890658],
            [33.62041136938209, 0.545017265888068],
            [33.626281216570085, 0.543822473362453],
            [33.627540533325835, 0.544419429051102],
            [33.62849143239342, 0.544419329342592],
            [33.63080789286377, 0.545884664972098],
            [33.63311048514273, 0.547941662951359],
            [33.63343525037244, 0.550783358114088],
            [33.63619991177908, 0.552919256053066],
            [33.63698528906905, 0.553085245307773],
            [33.63793865670702, 0.554571615471924],
            [33.640216358466105, 0.556531715549325],
            [33.64197463097172, 0.558919870602315],
            [33.64212693314161, 0.559752156883287],
            [33.6452533730626, 0.561678771242778],
            [33.647867431013516, 0.562302705634145],
            [33.651668714122025, 0.566753281603729],
            [33.654519872510704, 0.56806473514927],
            [33.65564053879396, 0.569340198274018],
            [33.6639173544121, 0.575337224368471],
            [33.66616258117535, 0.577517221928078],
            [33.66623344118326, 0.578286185610822],
            [33.668228878805365, 0.581732750428626],
            [33.668429905596255, 0.586057060562468],
            [33.6695935230282, 0.589476581859177],
            [33.67093612169562, 0.591294809312811],
            [33.67174320677445, 0.595700462660558],
            [33.67174176497841, 0.602277426707351],
            [33.67241830867676, 0.604692815806037],
            [33.67225130288231, 0.607687300778761],
            [33.67132409149042, 0.608492575313098],
            [33.67159734283018, 0.61032901504518],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1012,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "IBULANKU",
        Population: 34540,
        Key: "IGANGAIBULANKU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.818164392173756, 1.01925141630452],
            [33.807370722606684, 1.026256099378667],
            [33.80005001897972, 1.035394861355961],
            [33.79545918590676, 1.035513630679855],
            [33.792555936011354, 1.035113096868828],
            [33.79253508341867, 1.034233231836794],
            [33.79193043548578, 1.033192146983856],
            [33.78891958897892, 1.031087031608576],
            [33.78757091680182, 1.029390970366262],
            [33.78660700743398, 1.032596817906027],
            [33.78419673500021, 1.034991766850882],
            [33.781946260279085, 1.038529501485536],
            [33.78058500090825, 1.040731243021277],
            [33.78012133277937, 1.040839068877261],
            [33.779066941502855, 1.04392309732642],
            [33.775569851305775, 1.045086802534379],
            [33.77183524025931, 1.045693041971311],
            [33.76844060741195, 1.045231933558284],
            [33.76349483739383, 1.043703942973582],
            [33.75836514091449, 1.042788133016152],
            [33.755515887852546, 1.041050207288968],
            [33.753050279197275, 1.042336130688642],
            [33.75072407020946, 1.044136953382012],
            [33.7460524507447, 1.049701708211131],
            [33.74327115703057, 1.051158872937552],
            [33.74063166328241, 1.053674450860338],
            [33.735126886934296, 1.061238706324113],
            [33.73425914670922, 1.061754568757053],
            [33.73311840397767, 1.061696494561379],
            [33.7309553766562, 1.060606442990652],
            [33.72490741331031, 1.056310744301628],
            [33.70947090540182, 1.050008838251114],
            [33.7016644386833, 1.044211717627334],
            [33.694667768159114, 1.039907074908201],
            [33.6955229409534, 1.035817795453634],
            [33.69657346138936, 1.020754881458289],
            [33.697915956750556, 1.012847811741272],
            [33.70133746539459, 1.007970923899437],
            [33.705420331717136, 1.004143304828586],
            [33.706461430622404, 1.002632289978703],
            [33.707410888792275, 1.000750382517677],
            [33.70929541412115, 0.992743701881788],
            [33.710677103876506, 0.989513756303322],
            [33.716131753333414, 0.980927331193836],
            [33.718540815736525, 0.977733354532667],
            [33.72268763132748, 0.973724809547371],
            [33.73046590262417, 0.967191477801606],
            [33.73387160181755, 0.964883856910228],
            [33.75089157007735, 0.955869744347844],
            [33.75374551593836, 0.952983265874251],
            [33.75978390773488, 0.945708513562346],
            [33.76572340310347, 0.953686226029476],
            [33.768486297523914, 0.955702977355377],
            [33.77281554477941, 0.95667901907959],
            [33.781606409640816, 0.955692913132855],
            [33.78378323508503, 0.966497090928053],
            [33.78581081263136, 0.973548019678637],
            [33.787423926370195, 0.977468275129645],
            [33.78865791782148, 0.979336784121618],
            [33.79611440180363, 0.985975100549282],
            [33.79921863447247, 0.989430091610434],
            [33.801121360567336, 0.992758718560612],
            [33.802211554199516, 0.99710074180588],
            [33.80261991305633, 0.997100641209806],
            [33.81671281169269, 1.012023710990971],
            [33.817236604063496, 1.013154377691462],
            [33.818164392173756, 1.01925141630452],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1013,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "TIRINYI",
        Population: 31431,
        Key: "KIBUKUTIRINYI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.4663479409763, 0.607615146763299],
            [33.46728757157696, 0.606615750760966],
            [33.467903461027326, 0.603848258662829],
            [33.469263732251356, 0.601791556589819],
            [33.46994603684563, 0.599707614720893],
            [33.47008766433501, 0.597830233807189],
            [33.47079725435773, 0.596961438575799],
            [33.47319192844489, 0.59594750037868],
            [33.47411927099078, 0.595965513320629],
            [33.47741831410878, 0.597670593004765],
            [33.477154579521134, 0.599171723525446],
            [33.48489674034003, 0.600804718171772],
            [33.48563253781286, 0.606992811827253],
            [33.492669520235395, 0.610000154180281],
            [33.491201418837946, 0.611665942984271],
            [33.489971381770516, 0.617001151172221],
            [33.48906652675113, 0.617861582149587],
            [33.48840954746136, 0.619351411397082],
            [33.48364502422989, 0.616474268579443],
            [33.47248121373145, 0.613254538071381],
            [33.471434735714254, 0.612630385701441],
            [33.4663479409763, 0.607615146763299],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1014,
        District: "IGANGA",
        County: "IGANGA MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 30445,
        Key: "IGANGACENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.558695230087515, 0.623632297521525],
            [33.55869515552735, 0.629756753446998],
            [33.55914636222656, 0.63140324228573],
            [33.55746999002372, 0.633701340372239],
            [33.55796889906116, 0.634967853163352],
            [33.55797952702929, 0.63975366858224],
            [33.55650613814805, 0.638867233006843],
            [33.55593646881568, 0.637718336597048],
            [33.55474794379586, 0.6376732313872],
            [33.55192060603357, 0.634009536180629],
            [33.550471452800366, 0.633892082358963],
            [33.54923566831178, 0.633105132612681],
            [33.54741834145771, 0.630400295449692],
            [33.54627749721656, 0.629749037384801],
            [33.54478100366621, 0.628102654018419],
            [33.54219093791991, 0.626664463810911],
            [33.54121642933001, 0.626764081914523],
            [33.539398716200395, 0.625705779707718],
            [33.53837645406829, 0.625705885702621],
            [33.53344569220361, 0.622639478900121],
            [33.532162840485704, 0.622956253764942],
            [33.530807994187676, 0.622286917246273],
            [33.529381907894376, 0.622549423618305],
            [33.52702947169353, 0.621473073572788],
            [33.525746064816786, 0.62187126970455],
            [33.52245542364164, 0.618831819339002],
            [33.52034008428532, 0.618424916115805],
            [33.517813455767744, 0.616615771993186],
            [33.51747744363066, 0.615322087694948],
            [33.51455362590855, 0.612662562413705],
            [33.51276150488304, 0.608980615037329],
            [33.51174845048262, 0.608191653960619],
            [33.50409170776913, 0.610188138453757],
            [33.50218699999076, 0.610029270521598],
            [33.49908322007282, 0.610551560923746],
            [33.49677424077216, 0.610420602972579],
            [33.494875501400514, 0.609698082235281],
            [33.492669520235395, 0.610000154180281],
            [33.48563253781286, 0.606992811827253],
            [33.48489674034003, 0.600804718171772],
            [33.477154579521134, 0.599171723525446],
            [33.47741831410878, 0.597670593004765],
            [33.47411927099078, 0.595965513320629],
            [33.47319192844489, 0.59594750037868],
            [33.47079725435773, 0.596961438575799],
            [33.47143176408729, 0.592688630076298],
            [33.4727227787962, 0.591126629390817],
            [33.47305075280811, 0.58920565801386],
            [33.47276972654957, 0.587241299625453],
            [33.47461733561185, 0.582960363311942],
            [33.47466759814862, 0.581875590465575],
            [33.477311046280704, 0.57815077147765],
            [33.478779082999466, 0.575152540054543],
            [33.4789237171501, 0.573745595711602],
            [33.479645235003176, 0.572710402937659],
            [33.479947909761734, 0.569948377967509],
            [33.48038953592846, 0.569135423936876],
            [33.480211030800035, 0.565374729571705],
            [33.480503619274586, 0.563452707499925],
            [33.47974618947141, 0.562177845821524],
            [33.47967837565063, 0.557180426648655],
            [33.48056386478912, 0.554281080674159],
            [33.48123409422934, 0.553453484404675],
            [33.48042331976967, 0.552336257688088],
            [33.48043285718302, 0.550935591264113],
            [33.482748814596796, 0.54741997850642],
            [33.482718409319375, 0.545901935197837],
            [33.48342411862005, 0.544106907586309],
            [33.483453972331894, 0.54263750503399],
            [33.487301867223856, 0.538055701671406],
            [33.49047100676525, 0.536365859849849],
            [33.49176410646392, 0.536511756925145],
            [33.49673382107596, 0.538593863095418],
            [33.50065134618222, 0.539326765210911],
            [33.5041295034864, 0.540524035168694],
            [33.507363501391296, 0.544698301129906],
            [33.51151114522898, 0.545366087480261],
            [33.51375148875034, 0.545305348846965],
            [33.51569118321408, 0.546062007713476],
            [33.521329557909525, 0.545092777548876],
            [33.52320905446948, 0.545228841900537],
            [33.52402112070652, 0.546712148210357],
            [33.523675442697005, 0.548407468412],
            [33.524268247241196, 0.549541476521195],
            [33.52732235212057, 0.552444747572627],
            [33.52843732218659, 0.552915088962505],
            [33.52900787635951, 0.551693698334218],
            [33.536426687693584, 0.543614961096055],
            [33.53892931951496, 0.542747380234043],
            [33.54192462876068, 0.542536509280462],
            [33.5418786332215, 0.545097307547824],
            [33.542555560500475, 0.546318582747895],
            [33.54279278310912, 0.548489825777265],
            [33.54226899612819, 0.551312518597385],
            [33.54173436288855, 0.552199167669667],
            [33.54173349691261, 0.555021812918003],
            [33.54299243547766, 0.557464368879966],
            [33.546805510770895, 0.562032712005728],
            [33.5476606134966, 0.564520536144106],
            [33.54731540620427, 0.56689086443306],
            [33.54477137103143, 0.570672725561351],
            [33.54499679067555, 0.57265398257309],
            [33.54808480246534, 0.577629494854099],
            [33.54994975440249, 0.57954726157168],
            [33.55151763257689, 0.581989776618051],
            [33.554131289879194, 0.583780806929542],
            [33.55405079274489, 0.58540969743103],
            [33.551901285966764, 0.586563360479408],
            [33.552117800611484, 0.588591231137435],
            [33.55075580911368, 0.589727803985851],
            [33.55121858521544, 0.591027682532744],
            [33.5508085420175, 0.596492065551109],
            [33.55230967716291, 0.599784992258494],
            [33.55349722481569, 0.601359035333738],
            [33.55409115494894, 0.603684032391223],
            [33.55405481090918, 0.605312481362304],
            [33.55466670644978, 0.606155150124539],
            [33.553908666690546, 0.606795667835235],
            [33.553775456415366, 0.610758303630221],
            [33.55446939419258, 0.611410060773298],
            [33.55463392333181, 0.613225862795106],
            [33.55523047654568, 0.61388699212186],
            [33.55552248381024, 0.615289148372996],
            [33.55830498935169, 0.621071760440144],
            [33.558695230087515, 0.623632297521525],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1015,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAKIGO",
        Population: 39279,
        Key: "IGANGANAKIGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.072031378077256, 1.127096406796172],
            [34.068169814419925, 1.13115478736814],
            [34.064708740377505, 1.132775260009877],
            [34.063246093550426, 1.13426835224944],
            [34.061906251812594, 1.13673834103948],
            [34.06058834244242, 1.137751954816916],
            [34.05898317070899, 1.135038820013308],
            [34.05507198321707, 1.13037253407053],
            [34.05388245208413, 1.111494525023468],
            [34.05599800074791, 1.107450299890336],
            [34.05587894612499, 1.105930651918509],
            [34.05678133616725, 1.103686975113962],
            [34.056039870324994, 1.100376485464152],
            [34.05409868555616, 1.095537683391035],
            [34.054171694334265, 1.092299266808493],
            [34.05275005021, 1.090599161506641],
            [34.052438462367206, 1.08778603053554],
            [34.04894183390414, 1.079148520152726],
            [34.04815566340179, 1.074752533988134],
            [34.04861347900655, 1.071604436427187],
            [34.049974664715556, 1.069016867688377],
            [34.057745204212594, 1.060904480765257],
            [34.05875558522671, 1.059404284287335],
            [34.05884982658484, 1.057252662571744],
            [34.055497447793485, 1.047646365792121],
            [34.05547171106061, 1.045973832800098],
            [34.05627769749982, 1.041425712029188],
            [34.05895079273122, 1.035761496455849],
            [34.05935534452783, 1.036213648820195],
            [34.0634304664743, 1.036854519736191],
            [34.06429001586065, 1.037442201910367],
            [34.066473635263385, 1.035333800260598],
            [34.06848741468696, 1.035930134773691],
            [34.069875722331, 1.035531649737787],
            [34.071052924984976, 1.037050932049375],
            [34.07123408104177, 1.037937352924467],
            [34.07216985786988, 1.038054627601706],
            [34.07258516878867, 1.038760052149299],
            [34.07330078201535, 1.038904538580329],
            [34.0763350673646, 1.041038286816484],
            [34.07835154263233, 1.041308962904851],
            [34.081182597623275, 1.040412459252944],
            [34.08293307005726, 1.042998924604971],
            [34.08352735412674, 1.044753583884069],
            [34.085073566733136, 1.046227493616048],
            [34.087134992799356, 1.046552418450318],
            [34.090066301572634, 1.048107248410732],
            [34.094812790226456, 1.049308650730931],
            [34.09814978986014, 1.049741662161751],
            [34.103458644543096, 1.049766912260738],
            [34.106164539062114, 1.052389180587183],
            [34.10897114730095, 1.05699434837409],
            [34.11053472074848, 1.05802619492121],
            [34.108286628359494, 1.067322130238245],
            [34.10925992602037, 1.07299405475939],
            [34.108238296302254, 1.074415219339174],
            [34.1065143915428, 1.075790097638347],
            [34.10538461544425, 1.078169512942508],
            [34.1048202542569, 1.080042165434297],
            [34.105177716366335, 1.082258214692341],
            [34.10146262032112, 1.090943395517786],
            [34.10101787879699, 1.094299493858377],
            [34.10178033647081, 1.096911318025954],
            [34.09896321165496, 1.097636835062729],
            [34.094854890670554, 1.097392185158266],
            [34.09361989130953, 1.097719851107309],
            [34.0932353467909, 1.098480660759927],
            [34.09195083408805, 1.099043173968849],
            [34.09023854903678, 1.102051840307799],
            [34.089681412999255, 1.103997241438051],
            [34.087888797002, 1.105261278345819],
            [34.08697290977263, 1.106835823242992],
            [34.08627576321325, 1.107277259198163],
            [34.08481458153841, 1.107707807744704],
            [34.08411541107466, 1.106294308406814],
            [34.08246150304214, 1.104777715343504],
            [34.08073388464728, 1.107713172379168],
            [34.081113597127995, 1.110042977509149],
            [34.07926903604946, 1.111054568944494],
            [34.07482053205009, 1.116103005972605],
            [34.072158968492, 1.120388090561735],
            [34.07080519747737, 1.124696630154456],
            [34.072031378077256, 1.127096406796172],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1016,
        District: "BUDAKA",
        County: "IKI-IKI",
        Subcounty: "KAMONKOLI",
        Population: 24764,
        Key: "BUDAKAKAMONKOLI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.057745204212594, 1.060904480765257],
            [34.05467246827424, 1.061283699708939],
            [34.0533349073589, 1.061074739808048],
            [34.05047800963386, 1.059376415226904],
            [34.04090879590129, 1.054227936812102],
            [34.04037379974225, 1.054228117342888],
            [34.03912651771634, 1.057369849404256],
            [34.0382346253865, 1.056682054588166],
            [34.033568959057106, 1.055225538223201],
            [34.027031206370545, 1.055428763748189],
            [34.02030041561091, 1.057965505207482],
            [34.01849256688141, 1.058013679930105],
            [34.016649471853405, 1.05868033620994],
            [34.01451468307289, 1.05865242492941],
            [34.012254221780736, 1.059752221343599],
            [34.010102941728206, 1.059523111979936],
            [34.0072165990248, 1.057685136695723],
            [34.004095425926295, 1.056698877172061],
            [33.99520827603954, 1.05628291563078],
            [33.99497044796638, 1.056133404780882],
            [33.995990022339136, 1.05365519962629],
            [33.99587637467591, 1.052389973665754],
            [33.99409778048192, 1.05029317195138],
            [33.993462803628404, 1.048372807044607],
            [33.98858666831615, 1.040083197432945],
            [33.990531319683654, 1.037537409516354],
            [33.992511460793054, 1.032418101949831],
            [33.997791981713625, 1.023940380592972],
            [34.000631054168494, 1.017929061754503],
            [34.00375972101306, 1.01484449440916],
            [34.006450785245086, 1.01031025819981],
            [34.00903955202749, 1.006958171608717],
            [34.01365435484716, 1.002532747632237],
            [34.01821008804706, 0.998967239509956],
            [34.020468089751965, 1.001065177815823],
            [34.022246065905016, 1.00200539059429],
            [34.023487409168574, 1.00217687071773],
            [34.02506792484237, 1.003904133669449],
            [34.02923015732024, 1.004744078524239],
            [34.03247225443577, 1.007010810143505],
            [34.033604998567995, 1.008315794829745],
            [34.033929583236365, 1.009898714099793],
            [34.03481204145908, 1.010142668502744],
            [34.035848821264445, 1.011716311427256],
            [34.03737279877092, 1.012249523893744],
            [34.038191641898486, 1.013787051989283],
            [34.03958886981331, 1.014908281854422],
            [34.04023810921861, 1.016500137430883],
            [34.04184638373302, 1.017178051186755],
            [34.04243927451546, 1.018200035303988],
            [34.04289481019604, 1.018272252938702],
            [34.04311694200625, 1.019113441637083],
            [34.0447398069575, 1.019746118360124],
            [34.0463202507661, 1.021192930147934],
            [34.048098245783756, 1.022160246629977],
            [34.04826765008006, 1.02320950395522],
            [34.04939635718339, 1.024177032696246],
            [34.04969318031619, 1.024982010961212],
            [34.049580641174046, 1.026067543601193],
            [34.05034310783101, 1.028645344319729],
            [34.049962729698684, 1.029966156781973],
            [34.05140255123271, 1.032471363397889],
            [34.05162882876792, 1.033945752197007],
            [34.05251813394975, 1.03449724858538],
            [34.05393689088867, 1.03443345254847],
            [34.05473204993376, 1.033935667555233],
            [34.0579215408079, 1.034938677893504],
            [34.05895079273122, 1.035761496455849],
            [34.05627769749982, 1.041425712029188],
            [34.05547171106061, 1.045973832800098],
            [34.055497447793485, 1.047646365792121],
            [34.05884982658484, 1.057252662571744],
            [34.05875558522671, 1.059404284287335],
            [34.057745204212594, 1.060904480765257],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1017,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "NABOA",
        Population: 13945,
        Key: "BUDAKANABOA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96628224092157, 0.996469037901905],
            [33.9645993900689, 0.995184229699203],
            [33.960319153997, 0.989755738018643],
            [33.95966543649, 0.988515764433377],
            [33.95923488924567, 0.984344427771603],
            [33.95754802472033, 0.982321819379042],
            [33.9569439984216, 0.980749865371871],
            [33.95570568787044, 0.980599900129875],
            [33.953247286398685, 0.978734093580011],
            [33.95219037894106, 0.981947557171486],
            [33.95158164097865, 0.985687024738747],
            [33.95087895900049, 0.987296938976621],
            [33.95099763094108, 0.988856509362316],
            [33.94932947023828, 0.988955951525434],
            [33.944953975017015, 0.988087284183341],
            [33.94295664913617, 0.988135724918778],
            [33.9433495812246, 0.990428028416315],
            [33.94421801225418, 0.992142132899734],
            [33.944280339165225, 0.997100929525344],
            [33.94502399869339, 0.999194982603757],
            [33.94497102324446, 1.000047694476331],
            [33.94362894559988, 1.000681332368593],
            [33.94175400349844, 1.000528092372328],
            [33.93841198228231, 0.996598411664572],
            [33.93553753327325, 0.994627354595324],
            [33.93157655126678, 0.994758500539181],
            [33.93082339115615, 0.99580966365762],
            [33.93018839364139, 0.996015701562944],
            [33.92679204950339, 0.993205020798683],
            [33.924697252820984, 0.990014918089677],
            [33.923297735100505, 0.989137712013953],
            [33.92209219598922, 0.989105547238894],
            [33.91843976731655, 0.987735724168415],
            [33.916730738658195, 0.98670521847132],
            [33.91253510502145, 0.982359836781721],
            [33.910726954458, 0.978597795019527],
            [33.908119779398774, 0.974500878608809],
            [33.907843549245534, 0.972988277546378],
            [33.905569752463, 0.970672008374271],
            [33.90125080798551, 0.96743718860409],
            [33.90049939060651, 0.967312928889286],
            [33.89998550216174, 0.966240786833635],
            [33.8984444117491, 0.965197641535433],
            [33.8933861322332, 0.963220449326774],
            [33.88302478767638, 0.956697405928331],
            [33.88012065833032, 0.954455690771693],
            [33.878039576227366, 0.952481593813089],
            [33.8755420477351, 0.949191177611135],
            [33.87017900757256, 0.941157440715599],
            [33.89538767211099, 0.936920258705707],
            [33.90402612790297, 0.935462361874125],
            [33.908093023976356, 0.935256633768814],
            [33.914135453700084, 0.93569362386907],
            [33.92209538860174, 0.937065712430548],
            [33.9617641534203, 0.954570253190143],
            [33.98908174424228, 0.966573540154575],
            [33.99396945794022, 0.970651827922785],
            [33.998131164903654, 0.978235611178987],
            [33.986579097149516, 0.982213213751935],
            [33.976915219850646, 0.988032107982456],
            [33.97028290959897, 0.993706505371045],
            [33.96628224092157, 0.996469037901905],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1018,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "LYAMA",
        Population: 19188,
        Key: "BUDAKALYAMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.05047800963386, 1.059376415226904],
            [34.04997280610122, 1.060679811996609],
            [34.0430642890525, 1.069326744179563],
            [34.03916336840594, 1.072617476945157],
            [34.0361079726475, 1.076186134527369],
            [34.03464571209601, 1.079165100111564],
            [34.03376918634742, 1.083403986360034],
            [34.03181875611772, 1.085172100357744],
            [34.030096332680145, 1.088085700297838],
            [34.03042808770108, 1.093447354589144],
            [34.02942069089035, 1.093918911140169],
            [34.02990394229238, 1.096032716380483],
            [34.02977442139807, 1.097636552145334],
            [34.02847231249542, 1.100383623957326],
            [34.024289370256994, 1.100048691371122],
            [34.022720098795595, 1.100300540625561],
            [34.021656875283185, 1.100924823721045],
            [34.02639495301101, 1.103602144975222],
            [34.029428711947496, 1.109524720772229],
            [34.029489066158185, 1.11214545824826],
            [34.02875267400068, 1.114251898310964],
            [34.02621832086996, 1.118098790936212],
            [34.02509439999043, 1.121382836457947],
            [34.02200182475905, 1.124884681369871],
            [34.01895275853009, 1.125926033908615],
            [34.01782830315299, 1.127511637331593],
            [34.01408397862337, 1.130713027185075],
            [34.0125444952968, 1.131066359174615],
            [34.009888686346414, 1.133982746644935],
            [34.01042298631111, 1.135534396916271],
            [34.00874909166183, 1.13745410703394],
            [34.00799461282436, 1.13660581800737],
            [34.00839405859691, 1.135250679324862],
            [34.007723863292675, 1.13221688379552],
            [34.00658085501002, 1.130434272245593],
            [34.00685114190934, 1.128150870507194],
            [34.00605914044243, 1.127634171651686],
            [34.00442689168973, 1.127866948315459],
            [34.000268508492844, 1.124077840637035],
            [34.000161021475854, 1.123553519421863],
            [33.99733880321236, 1.122794632860395],
            [33.990385659656965, 1.113054514846241],
            [33.98231059307522, 1.112079899872197],
            [33.981513753282215, 1.112817917191327],
            [33.980405946382284, 1.115179089605867],
            [33.978418471426856, 1.117162461043146],
            [33.97872154863068, 1.11937561047742],
            [33.97946978597355, 1.120530923223881],
            [33.979104439350856, 1.121181619134669],
            [33.97693261842106, 1.12198744576535],
            [33.972680265157244, 1.122142709546813],
            [33.972709859255986, 1.120137621668869],
            [33.97311374540099, 1.119066956141171],
            [33.97182960280402, 1.118780173376075],
            [33.96930829321123, 1.116435453373075],
            [33.96695505930642, 1.114902585733394],
            [33.96378833892812, 1.114035964385323],
            [33.962653143293444, 1.110160002429128],
            [33.962784190425424, 1.108956835932744],
            [33.96458570154059, 1.105925822576991],
            [33.96668688434636, 1.100316595050436],
            [33.96678852153422, 1.098480217971882],
            [33.967590621861525, 1.096734072477928],
            [33.96756357718157, 1.094725863384774],
            [33.969448389971355, 1.090491711024046],
            [33.96971375500124, 1.087750680116011],
            [33.9711787464312, 1.086293795010975],
            [33.96978696320532, 1.084439833379309],
            [33.969737350150496, 1.084247405592332],
            [33.97130449170637, 1.084303630958087],
            [33.974603705504244, 1.087269651569458],
            [33.97928316097329, 1.088986863177087],
            [33.98094310568451, 1.089429571756406],
            [33.98612532576016, 1.089581646103765],
            [33.9946910943709, 1.087814843296202],
            [34.00082750134809, 1.087668060779737],
            [34.00233010703562, 1.086238300779449],
            [34.006297063737016, 1.085495204117377],
            [34.01221831522052, 1.085339430067332],
            [34.015282078785795, 1.08464185972932],
            [34.01682115158229, 1.083121628067087],
            [34.01874356245999, 1.077367792529711],
            [34.021125548742084, 1.073658176788421],
            [34.02470722250974, 1.0714497753824],
            [34.02855542372721, 1.070136824067011],
            [34.036591469289604, 1.064579847104185],
            [34.03906802212001, 1.060212009108272],
            [34.03936463414873, 1.058386956089584],
            [34.03912651771634, 1.057369849404256],
            [34.04037379974225, 1.054228117342888],
            [34.04090879590129, 1.054227936812102],
            [34.05047800963386, 1.059376415226904],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1019,
        District: "BUDAKA",
        County: "IKI-IKI",
        Subcounty: "IKI-IKI",
        Population: 18605,
        Key: "BUDAKAIKI-IKI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.840465028677855, 1.077630751179188],
            [33.837445554751014, 1.078699060427202],
            [33.83205960934534, 1.08194819670761],
            [33.82413212428668, 1.081941333904295],
            [33.82064734280559, 1.084402905761489],
            [33.81389334407058, 1.086820136464566],
            [33.812862248804315, 1.087634593786579],
            [33.81067255319701, 1.091389449426827],
            [33.81005026774181, 1.091760521931862],
            [33.80828932454486, 1.09193288182604],
            [33.80473224754803, 1.090929691507662],
            [33.802971828967195, 1.090975398485694],
            [33.79668729069797, 1.095192727793019],
            [33.794204720053536, 1.096107083276363],
            [33.78882245863883, 1.092444701871188],
            [33.78348543638185, 1.089913098619365],
            [33.78212265346828, 1.089741572993425],
            [33.78899518221008, 1.074273108389709],
            [33.79401158945396, 1.07345418184556],
            [33.798838426121726, 1.071916144001225],
            [33.80266301242704, 1.06429322170907],
            [33.803498741186985, 1.059364394230204],
            [33.80406312662886, 1.058362724576278],
            [33.80659027257604, 1.056130617782099],
            [33.81515326179929, 1.052796264301227],
            [33.81671715594538, 1.050986570028154],
            [33.81910983577263, 1.044142751942482],
            [33.821567927325624, 1.041848149531737],
            [33.82092999681144, 1.038773264195483],
            [33.82129727930355, 1.037638523472114],
            [33.82120109668609, 1.034448918118425],
            [33.822190510123164, 1.031707262722761],
            [33.82374356968864, 1.029282871077244],
            [33.82628869900947, 1.03162477392259],
            [33.82926262835144, 1.032619094303448],
            [33.8324930976739, 1.03300723638758],
            [33.837821956939884, 1.03184256120004],
            [33.838571575891656, 1.034068335200684],
            [33.84205975390284, 1.036742837908049],
            [33.841995630361225, 1.038328094553155],
            [33.843261308985824, 1.040601659961119],
            [33.84389489794223, 1.044538596181278],
            [33.84646348856336, 1.050689094451755],
            [33.84660152997813, 1.054334729315963],
            [33.84176298826218, 1.066801916255231],
            [33.84102915181165, 1.070031664063456],
            [33.840465028677855, 1.077630751179188],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1020,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KIBUKU",
        Population: 12530,
        Key: "KIBUKUKIBUKU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.694667768159114, 1.039907074908201],
            [33.69346456017597, 1.042494687633676],
            [33.69155075965028, 1.045055319126669],
            [33.68597500381835, 1.049932710730369],
            [33.66905968300092, 1.060484869660139],
            [33.66180857096072, 1.064457952388677],
            [33.656958183161144, 1.067941989514041],
            [33.648100739662475, 1.075886927936746],
            [33.64090818879566, 1.083587251226968],
            [33.636556948985394, 1.088898625927281],
            [33.62990299742018, 1.08284774383897],
            [33.6203991918201, 1.070374194802124],
            [33.61648195327639, 1.063580845778222],
            [33.61080614039318, 1.051592799341117],
            [33.60806028162376, 1.039952251826343],
            [33.6053838958635, 1.032570566210643],
            [33.59793070420688, 1.019933564367312],
            [33.59562259537375, 1.017147569864887],
            [33.591760585253716, 1.013502409646452],
            [33.602195557527835, 1.006723789733531],
            [33.60254097322933, 1.006167257895835],
            [33.602676524514116, 0.991629519630686],
            [33.60198480018578, 0.987803932991899],
            [33.60184554245211, 0.981961048783749],
            [33.60661302473412, 0.978482259779799],
            [33.614420311614495, 0.971107646701163],
            [33.61797882681411, 0.969611489916504],
            [33.623575244795916, 0.96474138185058],
            [33.63076160537213, 0.963174988421565],
            [33.6325407071142, 0.961644378113008],
            [33.633681216283776, 0.963383115723159],
            [33.63627300499881, 0.965817158446626],
            [33.64422042726686, 0.969328320394262],
            [33.654238068311145, 0.95795368886404],
            [33.66171368281559, 0.958160278782948],
            [33.66581253465858, 0.957499313511732],
            [33.669802870015275, 0.956020431930625],
            [33.671402108376235, 0.95460118507842],
            [33.6742562051542, 0.955297860264673],
            [33.676656382320814, 0.956690476392032],
            [33.68269805656139, 0.961818739001625],
            [33.68720792896937, 0.966811591259671],
            [33.692191873793846, 0.97441881590287],
            [33.70150409569329, 0.985851834909499],
            [33.70929541412115, 0.992743701881788],
            [33.707410888792275, 1.000750382517677],
            [33.706461430622404, 1.002632289978703],
            [33.705420331717136, 1.004143304828586],
            [33.70133746539459, 1.007970923899437],
            [33.697915956750556, 1.012847811741272],
            [33.69657346138936, 1.020754881458289],
            [33.6955229409534, 1.035817795453634],
            [33.694667768159114, 1.039907074908201],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1021,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "IVUKULA",
        Population: 28127,
        Key: "NAMUTUMBAIVUKULA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.85251624621792, 1.160956589026962],
            [33.85024521624645, 1.162030191125635],
            [33.848325744656385, 1.163740528434643],
            [33.84612908980053, 1.164618688372028],
            [33.841132522748005, 1.16841966057236],
            [33.83948843958977, 1.168754870849261],
            [33.837803708563214, 1.168411616933468],
            [33.83617926437369, 1.166783762140745],
            [33.83404842368881, 1.162297407401527],
            [33.83052673133103, 1.157739086310034],
            [33.829454009931126, 1.154500803432742],
            [33.827439003408884, 1.150321971084164],
            [33.82306343362745, 1.14350227516627],
            [33.82108759095667, 1.138681121722639],
            [33.81845885543231, 1.135217106890529],
            [33.817285670942624, 1.130151459480446],
            [33.81560326206109, 1.125981545360802],
            [33.81600651758877, 1.123737924252271],
            [33.813370388031295, 1.119839665202608],
            [33.81242052921282, 1.113778836997964],
            [33.80942367396649, 1.111499972280514],
            [33.80555785229472, 1.109275617934872],
            [33.803057786061785, 1.105721056513904],
            [33.79800806299898, 1.102149086503733],
            [33.79657520700165, 1.100412556050882],
            [33.794204720053536, 1.096107083276363],
            [33.79668729069797, 1.095192727793019],
            [33.802971828967195, 1.090975398485694],
            [33.80473224754803, 1.090929691507662],
            [33.80828932454486, 1.09193288182604],
            [33.81005026774181, 1.091760521931862],
            [33.81067255319701, 1.091389449426827],
            [33.812862248804315, 1.087634593786579],
            [33.81389334407058, 1.086820136464566],
            [33.82064734280559, 1.084402905761489],
            [33.82413212428668, 1.081941333904295],
            [33.83205960934534, 1.08194819670761],
            [33.837445554751014, 1.078699060427202],
            [33.840465028677855, 1.077630751179188],
            [33.846999559107495, 1.078126473295138],
            [33.84890754753329, 1.077601250333925],
            [33.85548993121811, 1.074505553309301],
            [33.86045312675613, 1.074268941837549],
            [33.86226157106866, 1.077344167421618],
            [33.865050700787, 1.080192950501941],
            [33.87229245417857, 1.08483159841732],
            [33.88250320875442, 1.094535232557511],
            [33.883749283444594, 1.097140180278609],
            [33.88429213626909, 1.09986293693824],
            [33.88319187521754, 1.104105953334144],
            [33.88121501475551, 1.109127212622869],
            [33.87989533121267, 1.110276483067606],
            [33.875926002958906, 1.111281807157967],
            [33.872638608295205, 1.114259011622661],
            [33.872099262493556, 1.11527441872898],
            [33.87130679390273, 1.118743459043998],
            [33.87102974987586, 1.122707173509181],
            [33.86948996471533, 1.126477396845124],
            [33.86924556187262, 1.12870364669632],
            [33.871560415256894, 1.130406926563227],
            [33.87221931424642, 1.132297396647302],
            [33.87225178025913, 1.13379002120255],
            [33.870277449452956, 1.139770207112705],
            [33.86912348801202, 1.141009898919241],
            [33.86752438350002, 1.141699448133344],
            [33.8666332789927, 1.143794032061049],
            [33.86764489429204, 1.147054865798534],
            [33.864746320127686, 1.149814461424331],
            [33.86278484241662, 1.150951974464254],
            [33.85580044916743, 1.153916061357908],
            [33.853750262822025, 1.156639298436712],
            [33.85251624621792, 1.160956589026962],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1022,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KAGUMU",
        Population: 27442,
        Key: "KIBUKUKAGUMU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.932230028025266, 1.165351157965761],
            [33.92878493321511, 1.165062830545495],
            [33.926215484702894, 1.162856427092049],
            [33.92331639041402, 1.162613139756152],
            [33.9208638387714, 1.160578564816192],
            [33.91843525957045, 1.15971093151745],
            [33.9164975036711, 1.158481287147315],
            [33.914979758676054, 1.156772057648244],
            [33.911500734497636, 1.154032198049825],
            [33.8913365513523, 1.142367705952635],
            [33.89078011061082, 1.141664082194583],
            [33.887767211453536, 1.140490688473478],
            [33.88130647043797, 1.139441048663644],
            [33.87905684462477, 1.13972128376373],
            [33.87768974350965, 1.140439751512839],
            [33.87358787242898, 1.140740197298248],
            [33.87204244944173, 1.14154847579933],
            [33.87076506756557, 1.144091957325578],
            [33.86764489429204, 1.147054865798534],
            [33.8666332789927, 1.143794032061049],
            [33.86752438350002, 1.141699448133344],
            [33.86912348801202, 1.141009898919241],
            [33.870277449452956, 1.139770207112705],
            [33.87225178025913, 1.13379002120255],
            [33.87221931424642, 1.132297396647302],
            [33.871560415256894, 1.130406926563227],
            [33.86924556187262, 1.12870364669632],
            [33.86948996471533, 1.126477396845124],
            [33.87102974987586, 1.122707173509181],
            [33.87130679390273, 1.118743459043998],
            [33.872099262493556, 1.11527441872898],
            [33.872638608295205, 1.114259011622661],
            [33.875926002958906, 1.111281807157967],
            [33.87989533121267, 1.110276483067606],
            [33.88121501475551, 1.109127212622869],
            [33.88319187521754, 1.104105953334144],
            [33.88429213626909, 1.09986293693824],
            [33.883749283444594, 1.097140180278609],
            [33.88250320875442, 1.094535232557511],
            [33.87229245417857, 1.08483159841732],
            [33.865050700787, 1.080192950501941],
            [33.86226157106866, 1.077344167421618],
            [33.86045312675613, 1.074268941837549],
            [33.863335031782036, 1.073481095138801],
            [33.87046747727152, 1.068604016334367],
            [33.87524142652527, 1.06714529431842],
            [33.89151289603248, 1.065286102741912],
            [33.897554004334424, 1.063357490314889],
            [33.902908060445824, 1.070782841638475],
            [33.9039867520491, 1.073460194112715],
            [33.90609627661058, 1.076490036652047],
            [33.91053064831388, 1.081256038771067],
            [33.911513551660114, 1.082875006431399],
            [33.91639157882436, 1.087279002246026],
            [33.91857582345454, 1.091268466510965],
            [33.917682742653575, 1.093636083200333],
            [33.918624538194074, 1.094138421169873],
            [33.92002347021302, 1.096550600938295],
            [33.921422040210864, 1.097770834615528],
            [33.92245020517265, 1.100757557750384],
            [33.9247053690996, 1.103758254882332],
            [33.92691638352525, 1.103854091827396],
            [33.92785732836116, 1.104616902785203],
            [33.92742159154944, 1.107948400768003],
            [33.926207308237174, 1.109086213111238],
            [33.925621546484805, 1.112994328300446],
            [33.92581809876729, 1.118231978539328],
            [33.92648137345058, 1.119697241162169],
            [33.928450930609344, 1.128791025933139],
            [33.93181423381287, 1.132845142464646],
            [33.93323846149185, 1.136048337078366],
            [33.93153147380583, 1.14015795102914],
            [33.93062084261917, 1.146816193525747],
            [33.92904655137193, 1.150860327966773],
            [33.92831649682874, 1.154849909475555],
            [33.92858699483217, 1.157536519837648],
            [33.93052206117557, 1.162565523578774],
            [33.932230028025266, 1.165351157965761],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1023,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "BULANGIRA",
        Population: 24169,
        Key: "KIBUKUBULANGIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.47722107820837, 0.66655665582609],
            [33.47940487188428, 0.662578288655104],
            [33.48074075833993, 0.660913511556973],
            [33.48190133946618, 0.659915057329551],
            [33.48368467766316, 0.659555827794974],
            [33.4850519611363, 0.659884826533855],
            [33.488219676847955, 0.661952967346763],
            [33.49223176580756, 0.663234208046361],
            [33.49579876828998, 0.663353223252655],
            [33.4990620557647, 0.662077973048515],
            [33.50245825617227, 0.661824551864569],
            [33.5064807161818, 0.662960581570251],
            [33.50704523367602, 0.663557395729477],
            [33.50839084169969, 0.664004796783664],
            [33.50895440518306, 0.664977923893527],
            [33.51180405350376, 0.665191305210853],
            [33.51468771563439, 0.667252001767923],
            [33.51702804883337, 0.671051764488629],
            [33.517933075431, 0.671529471937055],
            [33.519511945391216, 0.674522843603097],
            [33.52100986816118, 0.673529303786153],
            [33.52471883050961, 0.669411773079588],
            [33.52555118609569, 0.670512774528615],
            [33.52889460329377, 0.672398629214665],
            [33.52975047587566, 0.671077225488917],
            [33.530492319908625, 0.670751604032113],
            [33.5335930671142, 0.671421492872392],
            [33.53507677853634, 0.67100004214363],
            [33.535932884680214, 0.67184252138568],
            [33.53690301128813, 0.671631770443764],
            [33.53853527531223, 0.667034889190994],
            [33.53968278235784, 0.66791863760934],
            [33.541119809233, 0.670349136043276],
            [33.54354445650795, 0.671403488277103],
            [33.543644295268635, 0.671975987486006],
            [33.54499132981696, 0.672638742230113],
            [33.5453407052922, 0.674105131671633],
            [33.54591946467693, 0.674677575769963],
            [33.54638882722637, 0.677408247071679],
            [33.546029600825705, 0.679797577472299],
            [33.54716045939415, 0.681262150280391],
            [33.547658842018855, 0.682718647362242],
            [33.54872838787422, 0.683532747908769],
            [33.5488230146096, 0.685830655783194],
            [33.549479297705055, 0.686892052317845],
            [33.550069419879804, 0.690878693988304],
            [33.55261876948587, 0.696398285984475],
            [33.553605730522236, 0.697425535925082],
            [33.5549014928274, 0.701270958742823],
            [33.554741297161065, 0.706646983394803],
            [33.55566209637844, 0.70941516143585],
            [33.55540045486543, 0.710301790756829],
            [33.55418789631849, 0.711405661615857],
            [33.553843166929916, 0.712645130500267],
            [33.5537478466951, 0.714038367010737],
            [33.55434120460154, 0.715802443637121],
            [33.55414602045323, 0.716924573598047],
            [33.554875214410366, 0.719131642676339],
            [33.554470603324944, 0.722171455643246],
            [33.5552548271781, 0.72300367497377],
            [33.55504052328727, 0.725156866266339],
            [33.55581381194846, 0.727239571413054],
            [33.5571265524125, 0.728938215829627],
            [33.55787586324214, 0.731016519639433],
            [33.557447922010454, 0.734131102320671],
            [33.55607896856918, 0.737786227117835],
            [33.5565971886903, 0.74109356561369],
            [33.556313698352945, 0.74424302796659],
            [33.55797763338067, 0.747819007788953],
            [33.55860566625703, 0.748280319842883],
            [33.5592950693387, 0.750455117718555],
            [33.55908515371803, 0.755508736911273],
            [33.5597947455374, 0.756820445953207],
            [33.55983981042193, 0.757824646864967],
            [33.55863952555673, 0.760310816254121],
            [33.55741479753265, 0.761048348946561],
            [33.55410727252177, 0.759091293378502],
            [33.550299746122036, 0.756179340983285],
            [33.54821443295409, 0.753836455180924],
            [33.53772618878697, 0.747230170916606],
            [33.535685264072164, 0.745044402144514],
            [33.53428390480533, 0.741000590572276],
            [33.531783331024265, 0.737781416140031],
            [33.528379247900105, 0.735401241734547],
            [33.524403590116854, 0.733805343335178],
            [33.52220248141383, 0.733585450190449],
            [33.51895695812384, 0.732027840503892],
            [33.51770888468215, 0.732172737709808],
            [33.5158068763412, 0.731654911981317],
            [33.513800096590344, 0.732151885921386],
            [33.5125041240794, 0.731503865393456],
            [33.51055487064269, 0.731839784561641],
            [33.50672429347278, 0.733281874142696],
            [33.50206846639068, 0.736179911770962],
            [33.501636513282975, 0.73611357037506],
            [33.50136256934211, 0.735152986698125],
            [33.499921293435655, 0.734791690662228],
            [33.4993688690618, 0.73614096134052],
            [33.49794646496282, 0.737786210949494],
            [33.496193071207514, 0.737411138806551],
            [33.493431998570486, 0.739584998886877],
            [33.49238159761044, 0.739087129330547],
            [33.49060555463188, 0.739818165932171],
            [33.48927022513169, 0.739870517178789],
            [33.4882008239051, 0.739024668377233],
            [33.48639379623576, 0.738672035288012],
            [33.485289545766, 0.739151649050302],
            [33.48200980654517, 0.739432467775901],
            [33.47890239833178, 0.738819104224008],
            [33.47861095970079, 0.73948712121737],
            [33.47754207410716, 0.739776742677749],
            [33.47682746160368, 0.740461649138772],
            [33.47347938664085, 0.740699979222762],
            [33.47010180112264, 0.739871904960156],
            [33.466896874496946, 0.741388260229117],
            [33.46515381316405, 0.741347327428461],
            [33.4638806506748, 0.742519460526355],
            [33.46111203308768, 0.742664505600371],
            [33.460258905757286, 0.743623582202478],
            [33.457115754477094, 0.744971923211804],
            [33.45324874613082, 0.748093560748138],
            [33.4505054673229, 0.748926175859184],
            [33.44886639406898, 0.748736357391342],
            [33.44663409496099, 0.747904257833335],
            [33.44237931444928, 0.743625429881379],
            [33.44060645330348, 0.736731740787651],
            [33.435971279388056, 0.73679553116987],
            [33.43044115078603, 0.735239975981615],
            [33.42662712058364, 0.734634190315418],
            [33.425299039589504, 0.732408734604572],
            [33.422236856160794, 0.728853519637253],
            [33.422791558662226, 0.729042209863711],
            [33.42399837068626, 0.72799252617553],
            [33.42821012279416, 0.726206859609435],
            [33.43120620638766, 0.723632494070097],
            [33.43206611959169, 0.721388746476207],
            [33.43313582534716, 0.720236302764795],
            [33.43822024673615, 0.718875554052497],
            [33.445496362483986, 0.719956072089217],
            [33.44809003316951, 0.719776792391003],
            [33.45073499316621, 0.718871823642791],
            [33.4559056366528, 0.718536583483413],
            [33.45714619299218, 0.71785457681395],
            [33.4575997155482, 0.716848242537069],
            [33.45962359203555, 0.715523657966408],
            [33.46055991503933, 0.714406366511056],
            [33.4636659766781, 0.714129864993888],
            [33.4738124460156, 0.708085403522122],
            [33.47407012955147, 0.706764510026018],
            [33.473751431543185, 0.699083614768796],
            [33.47462872714798, 0.698341668702928],
            [33.475437398651586, 0.695697378698787],
            [33.47763265303389, 0.693258669586588],
            [33.478013311440584, 0.692157643693196],
            [33.47578561350347, 0.690669670315528],
            [33.473359870283886, 0.687121430516953],
            [33.47232336895623, 0.68338150752845],
            [33.471960865501444, 0.680437158943381],
            [33.47396620615122, 0.679702856792009],
            [33.475958505059666, 0.679620777211555],
            [33.476379044173434, 0.67878498860203],
            [33.476591342126206, 0.676724958922275],
            [33.47602672222405, 0.673482879364891],
            [33.47722107820837, 0.66655665582609],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1024,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAMUNGALWE",
        Population: 37177,
        Key: "IGANGANAMUNGALWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.790053913247746, 0.868535317036978],
            [33.78526271903547, 0.868436813710324],
            [33.78104134327593, 0.866945025937204],
            [33.771469557666734, 0.860949171044324],
            [33.76778398295669, 0.859203944689487],
            [33.76561984352088, 0.85939435982468],
            [33.75122292085642, 0.863549615178526],
            [33.74755592689975, 0.862884520539973],
            [33.742019457988434, 0.860680493709347],
            [33.73817523630764, 0.862575165947567],
            [33.73189502791809, 0.868728073343224],
            [33.72927930898224, 0.869153774622774],
            [33.72507271320404, 0.868756542173373],
            [33.72257396210469, 0.869924037979013],
            [33.71716499197995, 0.876632828511701],
            [33.7169225205151, 0.874785719979574],
            [33.71531648729732, 0.872669494828672],
            [33.7161299638894, 0.87129140972105],
            [33.71556818266354, 0.871080411769024],
            [33.7144967943635, 0.869316376128083],
            [33.713706272421895, 0.865755246350609],
            [33.7116625207089, 0.861096618237425],
            [33.70974811112544, 0.858309405797373],
            [33.70825695895777, 0.851848948619142],
            [33.70529323986735, 0.848606486292971],
            [33.701327734843424, 0.845341187661493],
            [33.69980932689175, 0.840692150258993],
            [33.70178789145785, 0.835776813030025],
            [33.70892446740098, 0.831397012228082],
            [33.712766422632306, 0.828239040299738],
            [33.71104802364722, 0.824041713116314],
            [33.70770039604542, 0.81785440946276],
            [33.705873557829115, 0.816119723418661],
            [33.70170980450346, 0.813567362981424],
            [33.69838405267542, 0.808830832605718],
            [33.69838856581141, 0.806591688066069],
            [33.697983330396866, 0.805614840830593],
            [33.691058461315016, 0.797500775670979],
            [33.6744247865937, 0.803361180072774],
            [33.66912918655278, 0.801197042607225],
            [33.66713609533022, 0.799876549226691],
            [33.66785524432585, 0.797560471022888],
            [33.669870753006336, 0.795108480520157],
            [33.6712586725782, 0.791543847261783],
            [33.671189175314545, 0.781990528971764],
            [33.67191153578733, 0.778652175284778],
            [33.67191343392753, 0.776453823839355],
            [33.67141100259587, 0.774662654741974],
            [33.66975416964876, 0.77200318487421],
            [33.66828083736138, 0.771813438381498],
            [33.66673458433081, 0.772266019735873],
            [33.66077270833523, 0.775044306816553],
            [33.656730315607845, 0.775542512673107],
            [33.65423524760116, 0.775226267280632],
            [33.652933049765295, 0.77431909490896],
            [33.6528260756863, 0.773455589063569],
            [33.651653192132244, 0.773071383168166],
            [33.650261977539934, 0.771822338081802],
            [33.64453808053449, 0.770405844733235],
            [33.64291984370357, 0.76791671162269],
            [33.64360774390373, 0.757930497772176],
            [33.64316038019731, 0.756166445892165],
            [33.640663658392164, 0.752195286870162],
            [33.63950224991753, 0.74943619297978],
            [33.639364575015406, 0.749020061547214],
            [33.63986549448245, 0.748296245614559],
            [33.63866451611786, 0.743773035800184],
            [33.638569383630944, 0.742343658815729],
            [33.63934318343355, 0.737005949510777],
            [33.639771080647776, 0.736264052711856],
            [33.64013755824938, 0.731673608889396],
            [33.64261154908457, 0.732213472981531],
            [33.64442868280086, 0.733290608645154],
            [33.64541181521749, 0.733102547366456],
            [33.64715418754255, 0.733553297630281],
            [33.647904605096606, 0.731703849105752],
            [33.651884740083254, 0.731642395876698],
            [33.6561060861984, 0.72981096171425],
            [33.66101247676942, 0.730146390568719],
            [33.664790739650435, 0.728932728465674],
            [33.6663148231581, 0.729122790305179],
            [33.67072797216284, 0.727087162940695],
            [33.67508047680103, 0.727094474638327],
            [33.67545807734253, 0.728107650357392],
            [33.67783416259152, 0.729301454337438],
            [33.680887456292155, 0.733037274832558],
            [33.68167125883544, 0.734737933608092],
            [33.68383349384285, 0.736890712379166],
            [33.68540185081929, 0.737840371276995],
            [33.68599111779792, 0.738998321185056],
            [33.68802762729311, 0.740979160358506],
            [33.690070532793115, 0.745067938709785],
            [33.691674364240136, 0.746551339397886],
            [33.6942573458721, 0.750626465639934],
            [33.69989306424926, 0.755110471997159],
            [33.699898526904505, 0.757378877113949],
            [33.70088554902631, 0.76177539191419],
            [33.70095861349993, 0.765502603049099],
            [33.699403740235915, 0.769642606186056],
            [33.71201636799764, 0.774580875999689],
            [33.71581134672948, 0.774742994513191],
            [33.717513931772295, 0.7752692944404],
            [33.72603700615252, 0.781625191209887],
            [33.72802492846894, 0.78216100704177],
            [33.73210523818614, 0.782332627655376],
            [33.73434043795422, 0.782810950297368],
            [33.7441480834278, 0.792239895170896],
            [33.74612666057032, 0.793694829847998],
            [33.748682258857485, 0.794461534778235],
            [33.751499153704586, 0.794632912363003],
            [33.75991318788069, 0.798159506587144],
            [33.76437262797033, 0.802663843291802],
            [33.768629608456166, 0.805756946545841],
            [33.77426595834895, 0.811183772069113],
            [33.78405264972022, 0.822806602363661],
            [33.78602676582903, 0.824724063855293],
            [33.78693617890019, 0.82500432265265],
            [33.788768385448606, 0.850252665756312],
            [33.790053913247746, 0.868535317036978],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1025,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "NAMUTUMBA",
        Population: 37485,
        Key: "NAMUTUMBANAMUTUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.62734984255058, 0.722376127703679],
            [33.62683718659435, 0.72226394243015],
            [33.626102387149835, 0.722774224886178],
            [33.62470646358881, 0.722650777441298],
            [33.62313763589514, 0.723244003679402],
            [33.62191618043366, 0.722856434853594],
            [33.619757280870914, 0.723560783686833],
            [33.61770474453273, 0.723790647824945],
            [33.61670629673882, 0.723505083597517],
            [33.614613282313954, 0.724234930768933],
            [33.61305224301383, 0.723704554767282],
            [33.61200823716028, 0.723822038744207],
            [33.60945914447239, 0.724939684495819],
            [33.608450575360216, 0.724776563495003],
            [33.605430088133716, 0.725445311055841],
            [33.60014319007295, 0.728227919670615],
            [33.59759869675933, 0.728495977748345],
            [33.59821997610141, 0.727561525019669],
            [33.59844054304637, 0.723648693894109],
            [33.59943881207553, 0.722309793290309],
            [33.59951518234941, 0.721061963470586],
            [33.60048096829789, 0.719072283982845],
            [33.601287819814736, 0.712114402837875],
            [33.600397115955985, 0.708794329393732],
            [33.6018847377446, 0.697838412344881],
            [33.59925727782795, 0.695548991544049],
            [33.58784195611794, 0.689563351331389],
            [33.57773628556571, 0.691085698386072],
            [33.57739318392441, 0.690187854371043],
            [33.578536529075315, 0.688414247523485],
            [33.57883895230562, 0.685447112501852],
            [33.58030207344316, 0.680208793653172],
            [33.57954184808282, 0.677983354098957],
            [33.578496439060814, 0.677024511791974],
            [33.578805799081735, 0.67594789578305],
            [33.57874696122725, 0.672383432563176],
            [33.579555619256126, 0.670972022916435],
            [33.580353271126135, 0.666728942831804],
            [33.58023402695869, 0.66530859751747],
            [33.58148229982636, 0.662341074716477],
            [33.583383982078864, 0.660857162191369],
            [33.58399079764656, 0.657754013534055],
            [33.58337335590737, 0.656433243653549],
            [33.58346911092677, 0.653918201655672],
            [33.58287523738738, 0.652389350420467],
            [33.58379060000065, 0.650860321764059],
            [33.58369641074478, 0.647485849921254],
            [33.5843377871964, 0.646933916208008],
            [33.58480493000877, 0.645413987953947],
            [33.586018449753034, 0.644677587669714],
            [33.59370672423132, 0.642994125355399],
            [33.59701821440589, 0.641658111755134],
            [33.59837738788863, 0.640659630361468],
            [33.59973743543215, 0.640679893290797],
            [33.60192594526332, 0.639830068228714],
            [33.60494441038209, 0.639911130737854],
            [33.620322086724336, 0.633569540427369],
            [33.61964630030577, 0.631225085739165],
            [33.617091298499936, 0.626258023796841],
            [33.61437265688701, 0.61540216159587],
            [33.613921577748556, 0.614922733210241],
            [33.61067992709575, 0.60295415665437],
            [33.611481621384534, 0.60079320779257],
            [33.61654907359782, 0.595617570605877],
            [33.61745455114969, 0.59414725506279],
            [33.61858855382165, 0.593342206573656],
            [33.61962472277262, 0.593202460461849],
            [33.62220305382637, 0.594179571115736],
            [33.623010882710226, 0.595025465472841],
            [33.62638059808827, 0.595723223841243],
            [33.6295137942385, 0.597217712213328],
            [33.631325082617245, 0.597283209313653],
            [33.634376679400326, 0.598687354134793],
            [33.63334903905464, 0.602005707628019],
            [33.631652206822906, 0.603944282334446],
            [33.628870564562476, 0.608708413027588],
            [33.625770366227556, 0.610425391619591],
            [33.623433469982835, 0.610953909649041],
            [33.62971143707573, 0.616961194628473],
            [33.63594147635331, 0.619760995863446],
            [33.63919498386954, 0.618158479638529],
            [33.64587379002201, 0.61329954917337],
            [33.647323958351464, 0.612696866214745],
            [33.64833355693298, 0.611616737873448],
            [33.65062932650739, 0.611627297866232],
            [33.652064822653294, 0.611199943313399],
            [33.65335949620034, 0.610004860187351],
            [33.65403818687222, 0.608377114173507],
            [33.65675983604473, 0.606757412529246],
            [33.65828118058908, 0.60498406393505],
            [33.65959824105133, 0.604558705699994],
            [33.6606725246215, 0.605037264589962],
            [33.66239254596401, 0.604630734897332],
            [33.66303400416229, 0.604911105037888],
            [33.664586891251226, 0.607824642763842],
            [33.66755151045357, 0.610353483765155],
            [33.66771730621734, 0.611550164825557],
            [33.67159734283018, 0.61032901504518],
            [33.67139680382448, 0.612809150102131],
            [33.67074265692279, 0.614125879963948],
            [33.67268872942507, 0.620216947718286],
            [33.673246039735744, 0.625690138276415],
            [33.674782892795186, 0.628126380692509],
            [33.675196392710355, 0.629547416406326],
            [33.67699984688148, 0.631407169481664],
            [33.679947233701746, 0.636266041881183],
            [33.680170937563666, 0.639277381844229],
            [33.67982408994764, 0.641529924811509],
            [33.678124554685205, 0.64383684915776],
            [33.677260172362615, 0.646298015061558],
            [33.67742606873772, 0.647826886106246],
            [33.676916096049226, 0.650860284935488],
            [33.67718732258633, 0.651753189465673],
            [33.67679698752741, 0.652746748025374],
            [33.67761182147387, 0.655953152570951],
            [33.6769347774139, 0.657359902760604],
            [33.67693493372075, 0.658516295152285],
            [33.67748269673661, 0.659596643638524],
            [33.678315346970074, 0.660173026479303],
            [33.67981557751201, 0.660362674293701],
            [33.68056147474357, 0.660958027303856],
            [33.68148177449762, 0.660700310604647],
            [33.683956382475415, 0.662122575915719],
            [33.68476243538994, 0.663779382391106],
            [33.68469402149456, 0.667927649794189],
            [33.68313654491283, 0.6722521896513],
            [33.68149603974433, 0.673256603982631],
            [33.68144660814918, 0.676526043568767],
            [33.67882148475062, 0.678232668535589],
            [33.67787230775341, 0.679995728278856],
            [33.67713783888892, 0.680171633866872],
            [33.6750249321704, 0.68484635051736],
            [33.67242102518219, 0.69296162294975],
            [33.672088818308644, 0.694984454531205],
            [33.672585058451375, 0.695269576783589],
            [33.67121671766116, 0.696717969175064],
            [33.66943289257727, 0.699703955864234],
            [33.667732923428574, 0.701161800949981],
            [33.66513610235133, 0.702238918770538],
            [33.66332120454179, 0.704734692465937],
            [33.65865042320515, 0.709202476438476],
            [33.655786144921755, 0.711238405505409],
            [33.65471633585999, 0.712595570686309],
            [33.65314666554661, 0.713051595688654],
            [33.65034299390046, 0.715898262144373],
            [33.64804930212931, 0.717427492840164],
            [33.64648482946817, 0.718219189625349],
            [33.645539662550405, 0.71826240956748],
            [33.64476935539764, 0.718962655930202],
            [33.643611648880274, 0.718512270695569],
            [33.64167663104588, 0.719142118902278],
            [33.64041796287377, 0.718755028491639],
            [33.6396796887457, 0.718977741049309],
            [33.638292327925974, 0.718346417003933],
            [33.635267747975064, 0.719423579324547],
            [33.63143310952173, 0.719450593128658],
            [33.63052991369069, 0.720833107922663],
            [33.628142492601114, 0.720926371718021],
            [33.62734984255058, 0.722376127703679],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1026,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "BUYANGA",
        Population: 50478,
        Key: "IGANGABUYANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.57773628556571, 0.691085698386072],
            [33.57937189581422, 0.693905878088471],
            [33.57927579584177, 0.69806745317111],
            [33.57736152998876, 0.702346864801974],
            [33.57743259481257, 0.704717138018272],
            [33.57695697639547, 0.705766635715381],
            [33.5742825534541, 0.708490082499168],
            [33.574186858621836, 0.711357956666645],
            [33.57468578832054, 0.712561129247187],
            [33.574126565496584, 0.714325342075585],
            [33.57429247714304, 0.716026135425709],
            [33.57116584318597, 0.722865977795659],
            [33.571994964836996, 0.736689515375243],
            [33.57258882220672, 0.73783839335077],
            [33.572517091731285, 0.739132106929214],
            [33.57336317087995, 0.740431402694113],
            [33.572694910546836, 0.74164711774264],
            [33.56965250173246, 0.743845909079759],
            [33.568130947880626, 0.744416061227553],
            [33.56718010989848, 0.74527564038213],
            [33.56492565384402, 0.745590413958162],
            [33.56164430753711, 0.747275722406977],
            [33.55967854486212, 0.749520694760097],
            [33.5592950693387, 0.750455117718555],
            [33.55860566625703, 0.748280319842883],
            [33.55797763338067, 0.747819007788953],
            [33.556313698352945, 0.74424302796659],
            [33.5565971886903, 0.74109356561369],
            [33.55607896856918, 0.737786227117835],
            [33.557447922010454, 0.734131102320671],
            [33.55787586324214, 0.731016519639433],
            [33.5571265524125, 0.728938215829627],
            [33.55581381194846, 0.727239571413054],
            [33.55504052328727, 0.725156866266339],
            [33.5552548271781, 0.72300367497377],
            [33.554470603324944, 0.722171455643246],
            [33.554875214410366, 0.719131642676339],
            [33.55414602045323, 0.716924573598047],
            [33.55434120460154, 0.715802443637121],
            [33.5537478466951, 0.714038367010737],
            [33.553843166929916, 0.712645130500267],
            [33.55418789631849, 0.711405661615857],
            [33.55540045486543, 0.710301790756829],
            [33.55566209637844, 0.70941516143585],
            [33.554741297161065, 0.706646983394803],
            [33.5549014928274, 0.701270958742823],
            [33.553605730522236, 0.697425535925082],
            [33.55261876948587, 0.696398285984475],
            [33.550069419879804, 0.690878693988304],
            [33.549479297705055, 0.686892052317845],
            [33.5488230146096, 0.685830655783194],
            [33.54872838787422, 0.683532747908769],
            [33.547658842018855, 0.682718647362242],
            [33.54716045939415, 0.681262150280391],
            [33.546029600825705, 0.679797577472299],
            [33.54638882722637, 0.677408247071679],
            [33.54591946467693, 0.674677575769963],
            [33.5453407052922, 0.674105131671633],
            [33.54499132981696, 0.672638742230113],
            [33.543644295268635, 0.671975987486006],
            [33.54354445650795, 0.671403488277103],
            [33.541119809233, 0.670349136043276],
            [33.53968278235784, 0.66791863760934],
            [33.53853527531223, 0.667034889190994],
            [33.53690301128813, 0.671631770443764],
            [33.535932884680214, 0.67184252138568],
            [33.53507677853634, 0.67100004214363],
            [33.5335930671142, 0.671421492872392],
            [33.530492319908625, 0.670751604032113],
            [33.52975047587566, 0.671077225488917],
            [33.52889460329377, 0.672398629214665],
            [33.52555118609569, 0.670512774528615],
            [33.52471883050961, 0.669411773079588],
            [33.52100986816118, 0.673529303786153],
            [33.519511945391216, 0.674522843603097],
            [33.517933075431, 0.671529471937055],
            [33.51702804883337, 0.671051764488629],
            [33.51468771563439, 0.667252001767923],
            [33.51180405350376, 0.665191305210853],
            [33.50895440518306, 0.664977923893527],
            [33.50839084169969, 0.664004796783664],
            [33.50704523367602, 0.663557395729477],
            [33.5064807161818, 0.662960581570251],
            [33.50245825617227, 0.661824551864569],
            [33.4990620557647, 0.662077973048515],
            [33.49579876828998, 0.663353223252655],
            [33.49223176580756, 0.663234208046361],
            [33.488219676847955, 0.661952967346763],
            [33.4850519611363, 0.659884826533855],
            [33.48368467766316, 0.659555827794974],
            [33.48190133946618, 0.659915057329551],
            [33.48074075833993, 0.660913511556973],
            [33.47940487188428, 0.662578288655104],
            [33.47722107820837, 0.66655665582609],
            [33.47758077622455, 0.660874418578319],
            [33.477305175790306, 0.657396768989823],
            [33.47561216050021, 0.656233087886755],
            [33.474717297441735, 0.653711511868372],
            [33.473327005419215, 0.651744192521886],
            [33.47296181600171, 0.649982879680102],
            [33.47412078465203, 0.64778427544781],
            [33.476443882774, 0.645982868371428],
            [33.47933415111522, 0.641761098939453],
            [33.47945629234947, 0.638467970143735],
            [33.47888211796595, 0.637083829301874],
            [33.47869474377071, 0.633510272309979],
            [33.48041249866373, 0.628615670787352],
            [33.48199969600664, 0.627177046860609],
            [33.48233837703843, 0.625695544015434],
            [33.4844166150752, 0.622845474681226],
            [33.48674741625071, 0.621172488003831],
            [33.48840954746136, 0.619351411397082],
            [33.48906652675113, 0.617861582149587],
            [33.489971381770516, 0.617001151172221],
            [33.491201418837946, 0.611665942984271],
            [33.492669520235395, 0.610000154180281],
            [33.494875501400514, 0.609698082235281],
            [33.49677424077216, 0.610420602972579],
            [33.49908322007282, 0.610551560923746],
            [33.50218699999076, 0.610029270521598],
            [33.50409170776913, 0.610188138453757],
            [33.51174845048262, 0.608191653960619],
            [33.51276150488304, 0.608980615037329],
            [33.51455362590855, 0.612662562413705],
            [33.51747744363066, 0.615322087694948],
            [33.517813455767744, 0.616615771993186],
            [33.52034008428532, 0.618424916115805],
            [33.52245542364164, 0.618831819339002],
            [33.525746064816786, 0.62187126970455],
            [33.52702947169353, 0.621473073572788],
            [33.529381907894376, 0.622549423618305],
            [33.530807994187676, 0.622286917246273],
            [33.532162840485704, 0.622956253764942],
            [33.53344569220361, 0.622639478900121],
            [33.53837645406829, 0.625705885702621],
            [33.539398716200395, 0.625705779707718],
            [33.54121642933001, 0.626764081914523],
            [33.54219093791991, 0.626664463810911],
            [33.54478100366621, 0.628102654018419],
            [33.54627749721656, 0.629749037384801],
            [33.54741834145771, 0.630400295449692],
            [33.54923566831178, 0.633105132612681],
            [33.550471452800366, 0.633892082358963],
            [33.55192060603357, 0.634009536180629],
            [33.55474794379586, 0.6376732313872],
            [33.55593646881568, 0.637718336597048],
            [33.55650613814805, 0.638867233006843],
            [33.55797952702929, 0.63975366858224],
            [33.55930198906132, 0.642160000446007],
            [33.56034669470247, 0.647063309376139],
            [33.561178051361935, 0.647660312267038],
            [33.562270762971835, 0.649813352441146],
            [33.56229400957476, 0.651776528881539],
            [33.56180656124372, 0.652608898811321],
            [33.56209150056365, 0.654092558682933],
            [33.5646575660205, 0.656724915558997],
            [33.56460996249698, 0.657964346480975],
            [33.565524559745626, 0.659520308965366],
            [33.565809051704505, 0.66199007966393],
            [33.567119196037396, 0.664586387193621],
            [33.56757754703805, 0.66961640790604],
            [33.56833766460057, 0.670982400441264],
            [33.567862600444016, 0.672031895681941],
            [33.56811111038422, 0.674139793462564],
            [33.57046364539971, 0.675840330910818],
            [33.57105754678689, 0.67754107526005],
            [33.57270862422796, 0.679956397415758],
            [33.57394326156792, 0.685122020183251],
            [33.576438470610114, 0.686795390657602],
            [33.577317210705885, 0.688979066470576],
            [33.57739318392441, 0.690187854371043],
            [33.57773628556571, 0.691085698386072],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1027,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAKALAMA",
        Population: 46386,
        Key: "IGANGANAKALAMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.005004531773615, 1.153156704980531],
            [33.99972390485185, 1.157313106808187],
            [33.99672411391121, 1.16126724978691],
            [33.996634864491085, 1.163040286927381],
            [33.99736506815462, 1.167911176992012],
            [33.99649733870931, 1.169671013753573],
            [33.995963940653176, 1.176636583078119],
            [33.99447183806791, 1.180789210418599],
            [33.9934168116825, 1.182298396009226],
            [33.991508657966676, 1.183467881692208],
            [33.98802424748979, 1.184690341785154],
            [33.98665799528262, 1.185785395422106],
            [33.983960447010865, 1.186763329849991],
            [33.977790708045085, 1.190230152726094],
            [33.9745135128531, 1.189769976804695],
            [33.973302809327244, 1.190765468991299],
            [33.97173256319377, 1.193235587929769],
            [33.97041676845776, 1.189291993746268],
            [33.96942942923066, 1.18812540786599],
            [33.96905104625658, 1.185511242492612],
            [33.96800954939763, 1.183223546241725],
            [33.967305208231124, 1.18056368415598],
            [33.96739935167291, 1.178293098505899],
            [33.968005749524, 1.175940920741725],
            [33.967937950974566, 1.173172861532464],
            [33.966432477864636, 1.168008105730135],
            [33.96591648107384, 1.163702375872186],
            [33.9657208118353, 1.163132543759923],
            [33.96355033568346, 1.161387407109075],
            [33.963464105501046, 1.160537109783327],
            [33.9606819215565, 1.158765040157092],
            [33.959839107783885, 1.158023553408924],
            [33.95947295447409, 1.156594403499628],
            [33.95744222114616, 1.152786708145606],
            [33.95723054123429, 1.151357503511708],
            [33.95765126899424, 1.149701934162834],
            [33.961281097851, 1.139831471768667],
            [33.96711655663158, 1.129426570163468],
            [33.96768885443446, 1.126233500177362],
            [33.96691824275282, 1.124477055030991],
            [33.96720180944698, 1.122474361406126],
            [33.96787657358276, 1.121651639938726],
            [33.972709859255986, 1.120137621668869],
            [33.972680265157244, 1.122142709546813],
            [33.97693261842106, 1.12198744576535],
            [33.979104439350856, 1.121181619134669],
            [33.97946978597355, 1.120530923223881],
            [33.97872154863068, 1.11937561047742],
            [33.978418471426856, 1.117162461043146],
            [33.980405946382284, 1.115179089605867],
            [33.981513753282215, 1.112817917191327],
            [33.98231059307522, 1.112079899872197],
            [33.990385659656965, 1.113054514846241],
            [33.99733880321236, 1.122794632860395],
            [34.000161021475854, 1.123553519421863],
            [34.000268508492844, 1.124077840637035],
            [34.00442689168973, 1.127866948315459],
            [34.00605914044243, 1.127634171651686],
            [34.00685114190934, 1.128150870507194],
            [34.00658085501002, 1.130434272245593],
            [34.007723863292675, 1.13221688379552],
            [34.00839405859691, 1.135250679324862],
            [34.00799461282436, 1.13660581800737],
            [34.00874909166183, 1.13745410703394],
            [34.00848769359224, 1.138467341545721],
            [34.009071833885514, 1.141615112174698],
            [34.00840600259695, 1.142592306590438],
            [34.00708726318343, 1.147776083597457],
            [34.00517271615776, 1.151793152316055],
            [34.005004531773615, 1.153156704980531],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1028,
        District: "BUDAKA",
        County: "IKI-IKI",
        Subcounty: "KAMERUKA",
        Population: 14907,
        Key: "BUDAKAKAMERUKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.609728765720085, 0.541975986545507],
            [33.60294792801932, 0.545403731473392],
            [33.60294061393628, 0.552644166088869],
            [33.600814726561914, 0.555486476119311],
            [33.598556414938244, 0.557087999765592],
            [33.59578751348348, 0.55838198408086],
            [33.59512153666781, 0.560010485651881],
            [33.59388574678935, 0.567651175596365],
            [33.593205272063294, 0.576307382828559],
            [33.59130090923798, 0.577120767908964],
            [33.58952664941526, 0.578712755828916],
            [33.58651493333922, 0.57866768246368],
            [33.58368241858592, 0.580333042375187],
            [33.58267198007962, 0.581380372071558],
            [33.582175703105975, 0.583397972899805],
            [33.58079704336806, 0.585831727262219],
            [33.577798431915376, 0.5896988438351],
            [33.57657813887386, 0.593280870199811],
            [33.57568870792791, 0.594905274673233],
            [33.574381076182895, 0.596251846599514],
            [33.57366794589966, 0.598166850141798],
            [33.57353315638621, 0.599131410238086],
            [33.575107542854845, 0.605649631702972],
            [33.573808594225376, 0.60894339185279],
            [33.571516570625704, 0.611673256650518],
            [33.56733886556539, 0.614104678246203],
            [33.56681973455259, 0.616067251994618],
            [33.567116162426665, 0.618108072711638],
            [33.566462311070694, 0.619231193292068],
            [33.564465872725386, 0.620149211527647],
            [33.56106250376188, 0.620702568248377],
            [33.55947005486784, 0.623171890581344],
            [33.558695230087515, 0.623632297521525],
            [33.55830498935169, 0.621071760440144],
            [33.55552248381024, 0.615289148372996],
            [33.55523047654568, 0.61388699212186],
            [33.55463392333181, 0.613225862795106],
            [33.55446939419258, 0.611410060773298],
            [33.553775456415366, 0.610758303630221],
            [33.553908666690546, 0.606795667835235],
            [33.55466670644978, 0.606155150124539],
            [33.55405481090918, 0.605312481362304],
            [33.55409115494894, 0.603684032391223],
            [33.55349722481569, 0.601359035333738],
            [33.55230967716291, 0.599784992258494],
            [33.5508085420175, 0.596492065551109],
            [33.55121858521544, 0.591027682532744],
            [33.55075580911368, 0.589727803985851],
            [33.552117800611484, 0.588591231137435],
            [33.551901285966764, 0.586563360479408],
            [33.55405079274489, 0.58540969743103],
            [33.554131289879194, 0.583780806929542],
            [33.55151763257689, 0.581989776618051],
            [33.54994975440249, 0.57954726157168],
            [33.54808480246534, 0.577629494854099],
            [33.54499679067555, 0.57265398257309],
            [33.54477137103143, 0.570672725561351],
            [33.54731540620427, 0.56689086443306],
            [33.5476606134966, 0.564520536144106],
            [33.546805510770895, 0.562032712005728],
            [33.54299243547766, 0.557464368879966],
            [33.54173349691261, 0.555021812918003],
            [33.54173436288855, 0.552199167669667],
            [33.54226899612819, 0.551312518597385],
            [33.54279278310912, 0.548489825777265],
            [33.542555560500475, 0.546318582747895],
            [33.5418786332215, 0.545097307547824],
            [33.54192462876068, 0.542536509280462],
            [33.54221810656736, 0.541315657301117],
            [33.544020276147634, 0.538601414000053],
            [33.54585150802401, 0.534294908613943],
            [33.54521080710547, 0.529825780657089],
            [33.54590087583876, 0.527238296269558],
            [33.54941807482351, 0.527337499313499],
            [33.550604200443175, 0.527941931172753],
            [33.55526875555656, 0.526563547191565],
            [33.5579498224378, 0.526884384903721],
            [33.56039588734575, 0.530957415390339],
            [33.563924894684874, 0.533280001915675],
            [33.56558817394245, 0.535143510105938],
            [33.567797865149686, 0.535984664772649],
            [33.57142181722786, 0.536554277713068],
            [33.57268115194993, 0.537296003836555],
            [33.574107196920764, 0.536915899324211],
            [33.5742261949498, 0.536101667912552],
            [33.57501083023136, 0.535911608885165],
            [33.57678077454746, 0.537205145036665],
            [33.580108068782806, 0.536797716763652],
            [33.58058318863491, 0.536245811559544],
            [33.58196205139203, 0.535865709676758],
            [33.5821287858953, 0.535006240940169],
            [33.58391095358747, 0.534915600387452],
            [33.584933096243624, 0.533911299739716],
            [33.586905695097926, 0.534101093837568],
            [33.587452152861665, 0.53362155712502],
            [33.5885451950516, 0.533983325328125],
            [33.58921072630287, 0.533503776928838],
            [33.59014482597634, 0.533974123385997],
            [33.59180115496857, 0.533648275455974],
            [33.591896110487355, 0.534001094131041],
            [33.5935238595788, 0.534362809313487],
            [33.59625686255819, 0.533602606189395],
            [33.59706462137344, 0.534434836693186],
            [33.597778374189204, 0.533122973322428],
            [33.600808424880206, 0.531638992689277],
            [33.60257799100556, 0.53485949405977],
            [33.60342163751642, 0.535085581178146],
            [33.60365933084228, 0.536189271376772],
            [33.60510855324576, 0.537410450458527],
            [33.60675958487274, 0.540350505443565],
            [33.60879406597203, 0.541811161147829],
            [33.609728765720085, 0.541975986545507],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1029,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "IGOMBE",
        Population: 17067,
        Key: "IGANGAIGOMBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.48041249866373, 0.628615670787352],
            [33.47863592028927, 0.629068187821888],
            [33.4761639273073, 0.629023181345485],
            [33.475331475601465, 0.628697565262007],
            [33.471744188261646, 0.624861950785425],
            [33.468762095928724, 0.624063922310552],
            [33.46309820997752, 0.620662825519042],
            [33.45919975520641, 0.62056774083125],
            [33.45857141780113, 0.620216964785264],
            [33.458827546353255, 0.61893254784358],
            [33.459651479335214, 0.618808856146493],
            [33.459750458408166, 0.618202712803378],
            [33.46086745417517, 0.617265498347429],
            [33.46234664707145, 0.614924082402074],
            [33.46367780210049, 0.612260142853643],
            [33.46550786077709, 0.610455207706494],
            [33.4663479409763, 0.607615146763299],
            [33.471434735714254, 0.612630385701441],
            [33.47248121373145, 0.613254538071381],
            [33.48364502422989, 0.616474268579443],
            [33.48840954746136, 0.619351411397082],
            [33.48674741625071, 0.621172488003831],
            [33.4844166150752, 0.622845474681226],
            [33.48233837703843, 0.625695544015434],
            [33.48199969600664, 0.627177046860609],
            [33.48041249866373, 0.628615670787352],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1030,
        District: "IGANGA",
        County: "IGANGA MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 24818,
        Key: "IGANGANORTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.47722107820837, 0.66655665582609],
            [33.47602672222405, 0.673482879364891],
            [33.476591342126206, 0.676724958922275],
            [33.476379044173434, 0.67878498860203],
            [33.475958505059666, 0.679620777211555],
            [33.47396620615122, 0.679702856792009],
            [33.471960865501444, 0.680437158943381],
            [33.47232336895623, 0.68338150752845],
            [33.473359870283886, 0.687121430516953],
            [33.47578561350347, 0.690669670315528],
            [33.478013311440584, 0.692157643693196],
            [33.47763265303389, 0.693258669586588],
            [33.475437398651586, 0.695697378698787],
            [33.47462872714798, 0.698341668702928],
            [33.473751431543185, 0.699083614768796],
            [33.47407012955147, 0.706764510026018],
            [33.4738124460156, 0.708085403522122],
            [33.4636659766781, 0.714129864993888],
            [33.46055991503933, 0.714406366511056],
            [33.45962359203555, 0.715523657966408],
            [33.4575997155482, 0.716848242537069],
            [33.45714619299218, 0.71785457681395],
            [33.4559056366528, 0.718536583483413],
            [33.45073499316621, 0.718871823642791],
            [33.44809003316951, 0.719776792391003],
            [33.445496362483986, 0.719956072089217],
            [33.43822024673615, 0.718875554052497],
            [33.43313582534716, 0.720236302764795],
            [33.43206611959169, 0.721388746476207],
            [33.43141259791745, 0.720159063634124],
            [33.430008734147606, 0.719240665308151],
            [33.42987450158966, 0.718647679278015],
            [33.43079567181123, 0.717322778147604],
            [33.43058004739694, 0.716853437985985],
            [33.431296940722916, 0.716469807421605],
            [33.431321830344494, 0.714572179924258],
            [33.432650373971, 0.712024950120613],
            [33.43276536192064, 0.710812120355824],
            [33.43222221085544, 0.710073438588282],
            [33.4325796738632, 0.708783293536645],
            [33.43123618047374, 0.706800620451113],
            [33.43177224472963, 0.705997494205391],
            [33.43057879604375, 0.703378276817307],
            [33.42737493751497, 0.700653259602453],
            [33.42819698672978, 0.698891822559154],
            [33.4279512525838, 0.69807929837555],
            [33.42844745769225, 0.696661079480806],
            [33.42722388041005, 0.693446329179422],
            [33.42709328872394, 0.69074121413241],
            [33.42670218380877, 0.690140671089101],
            [33.42698289026708, 0.689610723251616],
            [33.425904727771496, 0.688603407385842],
            [33.426075319640596, 0.688101787503524],
            [33.42491712982963, 0.687198500425266],
            [33.42564396031926, 0.685835777609989],
            [33.4249018593681, 0.684599358402275],
            [33.425052230160134, 0.684220829060739],
            [33.425693947971546, 0.684175349702461],
            [33.426415735319175, 0.682479532803868],
            [33.42500177897715, 0.680632500889986],
            [33.42489632215269, 0.678654133009769],
            [33.42540256862936, 0.677367133156313],
            [33.42513173285943, 0.676115530406921],
            [33.42417403264682, 0.674606597613488],
            [33.42451960465514, 0.670513545230347],
            [33.423276153045585, 0.669140902789865],
            [33.42295505833214, 0.666420660991835],
            [33.421510835053205, 0.662267200406652],
            [33.421530815381786, 0.661404181814214],
            [33.41919910421287, 0.655897446300864],
            [33.419974994395126, 0.655038868484215],
            [33.42112043531559, 0.655526913715714],
            [33.42217235622506, 0.655104467263437],
            [33.423076585118714, 0.653347345068232],
            [33.423620766551544, 0.653401005137492],
            [33.423901638299846, 0.65210844117952],
            [33.42549124222938, 0.649211727370475],
            [33.4267914332289, 0.647327356799343],
            [33.42753972177573, 0.647052547347071],
            [33.42790948990624, 0.645512925714156],
            [33.430099688570124, 0.642437199530827],
            [33.43072290467995, 0.639075358816831],
            [33.432054303152434, 0.63679643198439],
            [33.43211110811942, 0.633636725810795],
            [33.43420355480905, 0.633062058329451],
            [33.43600174934421, 0.633392884050006],
            [33.44036033378024, 0.631378599400581],
            [33.4412859461709, 0.630727131265024],
            [33.44187265834084, 0.627696311128261],
            [33.44246290717805, 0.626655847686059],
            [33.44593889325419, 0.62953251695016],
            [33.4516704160581, 0.632671426402793],
            [33.453073518056534, 0.629902825059334],
            [33.45307002810168, 0.628518625339165],
            [33.453821496684604, 0.627128477862943],
            [33.45383254326765, 0.626142381594143],
            [33.455480711963844, 0.624033147854391],
            [33.455924233575814, 0.622398139185031],
            [33.45671246481343, 0.621668316300179],
            [33.45674805067508, 0.620910643582826],
            [33.45857141780113, 0.620216964785264],
            [33.45919975520641, 0.62056774083125],
            [33.46309820997752, 0.620662825519042],
            [33.468762095928724, 0.624063922310552],
            [33.471744188261646, 0.624861950785425],
            [33.475331475601465, 0.628697565262007],
            [33.4761639273073, 0.629023181345485],
            [33.47863592028927, 0.629068187821888],
            [33.48041249866373, 0.628615670787352],
            [33.47869474377071, 0.633510272309979],
            [33.47888211796595, 0.637083829301874],
            [33.47945629234947, 0.638467970143735],
            [33.47933415111522, 0.641761098939453],
            [33.476443882774, 0.645982868371428],
            [33.47412078465203, 0.64778427544781],
            [33.47296181600171, 0.649982879680102],
            [33.473327005419215, 0.651744192521886],
            [33.474717297441735, 0.653711511868372],
            [33.47561216050021, 0.656233087886755],
            [33.477305175790306, 0.657396768989823],
            [33.47758077622455, 0.660874418578319],
            [33.47722107820837, 0.66655665582609],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1031,
        District: "IGANGA",
        County: "KIGULU",
        Subcounty: "NAWANYINGI",
        Population: 25619,
        Key: "IGANGANAWANYINGI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.63540463056308, 0.779459436364259],
            [33.630320390633806, 0.786427149478179],
            [33.62124074615469, 0.789234784952753],
            [33.615824626338615, 0.789701639102349],
            [33.61059944882609, 0.789298864684784],
            [33.611157009766714, 0.787413035663616],
            [33.61030183876906, 0.784209526959581],
            [33.61163482815794, 0.779732859122715],
            [33.617156546732275, 0.772632516130343],
            [33.61873135540908, 0.769131586324976],
            [33.617235154709526, 0.767372192789715],
            [33.61953726728813, 0.763910357965035],
            [33.62258693898157, 0.760450006932288],
            [33.62587774185345, 0.761823296630288],
            [33.62706719034139, 0.764392612462685],
            [33.62990388405738, 0.767125492617647],
            [33.63099800961555, 0.769903043806405],
            [33.6324496871147, 0.770802022532177],
            [33.63380271701922, 0.772569444860572],
            [33.63429309206144, 0.773577793720551],
            [33.63471998406088, 0.777665057359929],
            [33.63540463056308, 0.779459436364259],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1032,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "BUSEMBATIA TOWN COUNCIL",
        Population: 11948,
        Key: "IGANGABUSEMBATIA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.74287902534109, 1.111526381372915],
            [33.734454630894824, 1.092987489206591],
            [33.73235384963599, 1.08581757674512],
            [33.73278645851389, 1.080108784335426],
            [33.73271807156792, 1.072827060281747],
            [33.73304685047034, 1.070177759441346],
            [33.73269696475202, 1.068818291029714],
            [33.733003761879424, 1.067929435942256],
            [33.73311840397767, 1.061696494561379],
            [33.73425914670922, 1.061754568757053],
            [33.735126886934296, 1.061238706324113],
            [33.74063166328241, 1.053674450860338],
            [33.74327115703057, 1.051158872937552],
            [33.7460524507447, 1.049701708211131],
            [33.75072407020946, 1.044136953382012],
            [33.753050279197275, 1.042336130688642],
            [33.755515887852546, 1.041050207288968],
            [33.75836514091449, 1.042788133016152],
            [33.76349483739383, 1.043703942973582],
            [33.76844060741195, 1.045231933558284],
            [33.77183524025931, 1.045693041971311],
            [33.775569851305775, 1.045086802534379],
            [33.779066941502855, 1.04392309732642],
            [33.78012133277937, 1.040839068877261],
            [33.78058500090825, 1.040731243021277],
            [33.781946260279085, 1.038529501485536],
            [33.78447985792664, 1.039623492033915],
            [33.7873310675193, 1.041694416608103],
            [33.7871874412784, 1.044643601665691],
            [33.7831283623446, 1.048625075510925],
            [33.784999412944245, 1.0552647133958],
            [33.78581086024207, 1.06323444770183],
            [33.78731337699639, 1.065142865975059],
            [33.789031939474874, 1.072777637351351],
            [33.78899518221008, 1.074273108389709],
            [33.78212265346828, 1.089741572993425],
            [33.77874964127315, 1.090267150415589],
            [33.77567250808148, 1.092402924330556],
            [33.77387647129965, 1.095985803262733],
            [33.77209452818629, 1.104119069894773],
            [33.77091446619479, 1.106779049531846],
            [33.767310246510156, 1.110452875467466],
            [33.764880592924136, 1.111946184778991],
            [33.76244355788141, 1.113140961376581],
            [33.75752231187055, 1.113422683640745],
            [33.74287902534109, 1.111526381372915],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1033,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "BUSETA",
        Population: 16691,
        Key: "KIBUKUBUSETA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.82374356968864, 1.029282871077244],
            [33.822190510123164, 1.031707262722761],
            [33.82120109668609, 1.034448918118425],
            [33.82129727930355, 1.037638523472114],
            [33.82092999681144, 1.038773264195483],
            [33.821567927325624, 1.041848149531737],
            [33.81910983577263, 1.044142751942482],
            [33.81671715594538, 1.050986570028154],
            [33.81515326179929, 1.052796264301227],
            [33.80659027257604, 1.056130617782099],
            [33.80406312662886, 1.058362724576278],
            [33.803498741186985, 1.059364394230204],
            [33.80266301242704, 1.06429322170907],
            [33.798838426121726, 1.071916144001225],
            [33.79401158945396, 1.07345418184556],
            [33.78899518221008, 1.074273108389709],
            [33.789031939474874, 1.072777637351351],
            [33.78731337699639, 1.065142865975059],
            [33.78581086024207, 1.06323444770183],
            [33.784999412944245, 1.0552647133958],
            [33.7831283623446, 1.048625075510925],
            [33.7871874412784, 1.044643601665691],
            [33.7873310675193, 1.041694416608103],
            [33.78447985792664, 1.039623492033915],
            [33.781946260279085, 1.038529501485536],
            [33.78419673500021, 1.034991766850882],
            [33.78660700743398, 1.032596817906027],
            [33.78757091680182, 1.029390970366262],
            [33.78891958897892, 1.031087031608576],
            [33.79193043548578, 1.033192146983856],
            [33.79253508341867, 1.034233231836794],
            [33.792555936011354, 1.035113096868828],
            [33.79545918590676, 1.035513630679855],
            [33.80005001897972, 1.035394861355961],
            [33.807370722606684, 1.026256099378667],
            [33.818164392173756, 1.01925141630452],
            [33.82374356968864, 1.029282871077244],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1034,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KIBUKU TOWN COUNCIL",
        Population: 8507,
        Key: "KIBUKUKIBUKU TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.7116625207089, 0.861096618237425],
            [33.7083000421588, 0.860302756108666],
            [33.70649290309838, 0.860422774566169],
            [33.705223272784814, 0.861788266181015],
            [33.7031168249532, 0.862936682487166],
            [33.69888391931697, 0.861094397852849],
            [33.69498369845801, 0.858079179045104],
            [33.692941185521775, 0.857776466360184],
            [33.69264148059356, 0.857876152013362],
            [33.69183691618742, 0.861676355941592],
            [33.68880333062577, 0.86214230426901],
            [33.68524248609465, 0.861867230838745],
            [33.68427162646143, 0.861389478152396],
            [33.68011670177841, 0.862784685914236],
            [33.68203141229748, 0.858203607805707],
            [33.682685684065, 0.848750072526339],
            [33.68217688906784, 0.848669351585026],
            [33.67823039958188, 0.851603739235626],
            [33.67359613206659, 0.855936578369244],
            [33.672026888452976, 0.856750685371026],
            [33.66974415163669, 0.856798960826357],
            [33.65886584010862, 0.853619966990679],
            [33.66103883783144, 0.851082620291121],
            [33.66293892287938, 0.846859960901951],
            [33.66377461391008, 0.843367709869285],
            [33.66502257326572, 0.84092600595186],
            [33.66641252931831, 0.834513268293922],
            [33.66881756547229, 0.829051936897266],
            [33.67182097662353, 0.825921260962926],
            [33.67253747379246, 0.824591272475899],
            [33.67858397917266, 0.820582548553993],
            [33.68264245713351, 0.815461423863341],
            [33.68148162897056, 0.81323613541475],
            [33.67970711133134, 0.805700538822296],
            [33.6744247865937, 0.803361180072774],
            [33.691058461315016, 0.797500775670979],
            [33.697983330396866, 0.805614840830593],
            [33.69838856581141, 0.806591688066069],
            [33.69838405267542, 0.808830832605718],
            [33.70170980450346, 0.813567362981424],
            [33.705873557829115, 0.816119723418661],
            [33.70770039604542, 0.81785440946276],
            [33.71104802364722, 0.824041713116314],
            [33.712766422632306, 0.828239040299738],
            [33.70892446740098, 0.831397012228082],
            [33.70178789145785, 0.835776813030025],
            [33.69980932689175, 0.840692150258993],
            [33.701327734843424, 0.845341187661493],
            [33.70529323986735, 0.848606486292971],
            [33.70825695895777, 0.851848948619142],
            [33.70974811112544, 0.858309405797373],
            [33.7116625207089, 0.861096618237425],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1035,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "NAMUTUMBA TOWN COUNCIL",
        Population: 18679,
        Key: "NAMUTUMBANAMUTUMBA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.897554004334424, 1.063357490314889],
            [33.89151289603248, 1.065286102741912],
            [33.87524142652527, 1.06714529431842],
            [33.87046747727152, 1.068604016334367],
            [33.86879982950672, 1.063302468099059],
            [33.86393208984911, 1.053190091966733],
            [33.86543333997889, 1.050484831238016],
            [33.865676241736786, 1.048502149076165],
            [33.86691511193837, 1.046481284645477],
            [33.8674801010481, 1.043443569058826],
            [33.87058317489022, 1.040738980730806],
            [33.87743720732035, 1.033266419291422],
            [33.879566404986534, 1.028444171183064],
            [33.87928040206133, 1.024785174864671],
            [33.88137347936826, 1.026842997611131],
            [33.88189690432812, 1.027919924245745],
            [33.88275293321688, 1.027919685332304],
            [33.88246702371647, 1.025861361200902],
            [33.8828473093223, 1.025238948190314],
            [33.89007375631976, 1.020037098558835],
            [33.899132879684515, 1.015564712516298],
            [33.906290020759506, 1.01428423025125],
            [33.91104292787602, 1.017380830066059],
            [33.914409525201705, 1.020726951879009],
            [33.916317320489725, 1.023738776037887],
            [33.919019856207896, 1.030459290774142],
            [33.92091204955606, 1.033842000200945],
            [33.926289627154866, 1.039421888472583],
            [33.93386658779304, 1.046140903272941],
            [33.93728134020783, 1.050662930029024],
            [33.9347845016217, 1.054046932666449],
            [33.93150986752661, 1.061700943153113],
            [33.93021327697476, 1.062913518729975],
            [33.92763592867793, 1.063837006535646],
            [33.923269386066764, 1.064136851097269],
            [33.90068936632282, 1.06317564422754],
            [33.897554004334424, 1.063357490314889],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1036,
        District: "KIBUKU",
        County: "KIBUKU",
        Subcounty: "KABWERI",
        Population: 15338,
        Key: "KIBUKUKABWERI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.91843976731655, 0.987735724168415],
            [33.91889081231901, 0.990438426658567],
            [33.918405999645024, 0.991376801198746],
            [33.91845414125941, 0.993492614531701],
            [33.918007497103524, 0.99488095119861],
            [33.91845337140323, 0.997603803886532],
            [33.91803417437253, 1.000996232760221],
            [33.91379042966407, 1.010360216524341],
            [33.913332826061726, 1.010975486523451],
            [33.90629373978476, 1.011022708097218],
            [33.90248589448313, 1.012534494180511],
            [33.89974710994658, 1.010590328211038],
            [33.89830493033494, 1.007397418536489],
            [33.89651545394962, 1.005606765901144],
            [33.89549778580191, 1.003978728199524],
            [33.89463012013695, 1.000387619076138],
            [33.891021619081684, 0.997575232808546],
            [33.8886697030054, 0.992953248271071],
            [33.88638628436785, 0.990294272186415],
            [33.885482314189034, 0.989507493284983],
            [33.880024578120796, 0.988179159188824],
            [33.873635701429635, 0.985258915971849],
            [33.87023056009006, 0.981077630545458],
            [33.86863143851008, 0.977046073569614],
            [33.867613176575986, 0.971969808394668],
            [33.863247331955804, 0.942263790216792],
            [33.87017900757256, 0.941157440715599],
            [33.8755420477351, 0.949191177611135],
            [33.878039576227366, 0.952481593813089],
            [33.88012065833032, 0.954455690771693],
            [33.88302478767638, 0.956697405928331],
            [33.8933861322332, 0.963220449326774],
            [33.8984444117491, 0.965197641535433],
            [33.89998550216174, 0.966240786833635],
            [33.90049939060651, 0.967312928889286],
            [33.90125080798551, 0.96743718860409],
            [33.905569752463, 0.970672008374271],
            [33.907843549245534, 0.972988277546378],
            [33.908119779398774, 0.974500878608809],
            [33.910726954458, 0.978597795019527],
            [33.91253510502145, 0.982359836781721],
            [33.916730738658195, 0.98670521847132],
            [33.91843976731655, 0.987735724168415],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1037,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "NANSANGA",
        Population: 9643,
        Key: "BUDAKANANSANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.01821008804706, 0.998967239509956],
            [34.01365435484716, 1.002532747632237],
            [34.00903955202749, 1.006958171608717],
            [34.006450785245086, 1.01031025819981],
            [34.00375972101306, 1.01484449440916],
            [34.000631054168494, 1.017929061754503],
            [33.997791981713625, 1.023940380592972],
            [33.992511460793054, 1.032418101949831],
            [33.990531319683654, 1.037537409516354],
            [33.98663469208582, 1.036354948666255],
            [33.98221619002034, 1.03353398568483],
            [33.98071632239776, 1.031784303223803],
            [33.97912062070407, 1.03064590534692],
            [33.976275741539226, 1.029555591506532],
            [33.973260895732736, 1.026734164430122],
            [33.96879393225261, 1.025206755928193],
            [33.967800158393125, 1.024682389003243],
            [33.966555023340746, 1.023199218987174],
            [33.967031709854695, 1.020720461682794],
            [33.96544869506774, 1.015680734163179],
            [33.966551334858195, 1.013478440955067],
            [33.9664364502148, 1.010951009446076],
            [33.967310584648125, 1.007944592963633],
            [33.96690706142248, 1.006480751214581],
            [33.965132720751384, 1.003297405800416],
            [33.96463333291192, 1.000215553246816],
            [33.96628224092157, 0.996469037901905],
            [33.97028290959897, 0.993706505371045],
            [33.976915219850646, 0.988032107982456],
            [33.986579097149516, 0.982213213751935],
            [33.998131164903654, 0.978235611178987],
            [34.00063764241278, 0.982192465717849],
            [34.013583741875955, 0.993902975993001],
            [34.01821008804706, 0.998967239509956],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1038,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "BUDAKA",
        Population: 11074,
        Key: "BUDAKABUDAKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.03912651771634, 1.057369849404256],
            [34.03936463414873, 1.058386956089584],
            [34.03906802212001, 1.060212009108272],
            [34.036591469289604, 1.064579847104185],
            [34.02855542372721, 1.070136824067011],
            [34.02470722250974, 1.0714497753824],
            [34.021125548742084, 1.073658176788421],
            [34.01874356245999, 1.077367792529711],
            [34.01682115158229, 1.083121628067087],
            [34.015282078785795, 1.08464185972932],
            [34.01221831522052, 1.085339430067332],
            [34.006297063737016, 1.085495204117377],
            [34.00233010703562, 1.086238300779449],
            [34.00082750134809, 1.087668060779737],
            [33.9946910943709, 1.087814843296202],
            [33.98612532576016, 1.089581646103765],
            [33.98094310568451, 1.089429571756406],
            [33.97928316097329, 1.088986863177087],
            [33.974603705504244, 1.087269651569458],
            [33.97130449170637, 1.084303630958087],
            [33.969737350150496, 1.084247405592332],
            [33.9682233672999, 1.071795606693632],
            [33.96988425075058, 1.058756506628548],
            [33.971119535775884, 1.054964921865248],
            [33.969349265371335, 1.051174281840971],
            [33.97003009762687, 1.049343263301535],
            [33.973485035277584, 1.046997167486464],
            [33.978460471259645, 1.045267817976663],
            [33.980201174514924, 1.043593761325571],
            [33.9829408995876, 1.04305013895358],
            [33.98652122139072, 1.04173734179645],
            [33.98858666831615, 1.040083197432945],
            [33.993462803628404, 1.048372807044607],
            [33.99409778048192, 1.05029317195138],
            [33.99587637467591, 1.052389973665754],
            [33.995990022339136, 1.05365519962629],
            [33.99497044796638, 1.056133404780882],
            [33.99520827603954, 1.05628291563078],
            [34.004095425926295, 1.056698877172061],
            [34.0072165990248, 1.057685136695723],
            [34.010102941728206, 1.059523111979936],
            [34.012254221780736, 1.059752221343599],
            [34.01451468307289, 1.05865242492941],
            [34.016649471853405, 1.05868033620994],
            [34.01849256688141, 1.058013679930105],
            [34.02030041561091, 1.057965505207482],
            [34.027031206370545, 1.055428763748189],
            [34.033568959057106, 1.055225538223201],
            [34.0382346253865, 1.056682054588166],
            [34.03912651771634, 1.057369849404256],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1039,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "KAKULE",
        Population: 12452,
        Key: "BUDAKAKAKULE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96978696320532, 1.084439833379309],
            [33.966382763300174, 1.081963282121044],
            [33.964048628476625, 1.081385329126078],
            [33.96077003370943, 1.084068867752445],
            [33.95834558226724, 1.087085377401028],
            [33.95571357148537, 1.091289124015024],
            [33.95209078362383, 1.090652302498256],
            [33.95076574612186, 1.093725310074234],
            [33.94973001375208, 1.094392989626238],
            [33.9489496661294, 1.098838784655473],
            [33.94834066945219, 1.100250167902293],
            [33.94723615308113, 1.101354144519483],
            [33.94561670532123, 1.101930991647165],
            [33.94370991255307, 1.101208023703641],
            [33.94072492494996, 1.100831456592807],
            [33.93772458334207, 1.10133577018051],
            [33.933287612812634, 1.105411246629048],
            [33.92934000582245, 1.107511196085527],
            [33.92742159154944, 1.107948400768003],
            [33.92785732836116, 1.104616902785203],
            [33.92691638352525, 1.103854091827396],
            [33.9247053690996, 1.103758254882332],
            [33.92245020517265, 1.100757557750384],
            [33.921422040210864, 1.097770834615528],
            [33.92002347021302, 1.096550600938295],
            [33.918624538194074, 1.094138421169873],
            [33.917682742653575, 1.093636083200333],
            [33.91857582345454, 1.091268466510965],
            [33.91639157882436, 1.087279002246026],
            [33.911513551660114, 1.082875006431399],
            [33.91053064831388, 1.081256038771067],
            [33.90609627661058, 1.076490036652047],
            [33.9039867520491, 1.073460194112715],
            [33.902908060445824, 1.070782841638475],
            [33.897554004334424, 1.063357490314889],
            [33.90068936632282, 1.06317564422754],
            [33.923269386066764, 1.064136851097269],
            [33.92763592867793, 1.063837006535646],
            [33.93021327697476, 1.062913518729975],
            [33.93150986752661, 1.061700943153113],
            [33.9347845016217, 1.054046932666449],
            [33.93728134020783, 1.050662930029024],
            [33.946295026785535, 1.045784347696437],
            [33.94743691486905, 1.04569353865694],
            [33.954686528519346, 1.047174876672253],
            [33.95980118899743, 1.04692001149321],
            [33.960202336179115, 1.047254590633816],
            [33.96092999311882, 1.049977226455309],
            [33.96319127097957, 1.051541489028565],
            [33.96513599421227, 1.052056507001456],
            [33.96716403708593, 1.051368375098133],
            [33.97003009762687, 1.049343263301535],
            [33.969349265371335, 1.051174281840971],
            [33.971119535775884, 1.054964921865248],
            [33.96988425075058, 1.058756506628548],
            [33.9682233672999, 1.071795606693632],
            [33.969737350150496, 1.084247405592332],
            [33.96978696320532, 1.084439833379309],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1040,
        District: "BUDAKA",
        County: "BUDAKA",
        Subcounty: "KADERUNA",
        Population: 17017,
        Key: "BUDAKAKADERUNA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.12475861710948, 1.074363362428018],
            [34.12210544201951, 1.077753380062629],
            [34.122291137263446, 1.079296023403025],
            [34.1209758509739, 1.082682679138366],
            [34.12092749915373, 1.08701035732434],
            [34.119184522262465, 1.09425652629287],
            [34.118427644024884, 1.103962730080568],
            [34.11698005925021, 1.109526320371789],
            [34.11688800259482, 1.111172653637091],
            [34.11527414684755, 1.115189515274601],
            [34.11261492250247, 1.118962548701812],
            [34.10368332846702, 1.123886778796124],
            [34.09727505984382, 1.126648139858608],
            [34.09486690294254, 1.126634032748178],
            [34.09447001197867, 1.126122395550646],
            [34.09160386070786, 1.125347713135246],
            [34.087462374821484, 1.123241629518105],
            [34.083710773039755, 1.12286311624836],
            [34.0739645247209, 1.126059886678387],
            [34.072031378077256, 1.127096406796172],
            [34.07080519747737, 1.124696630154456],
            [34.072158968492, 1.120388090561735],
            [34.07482053205009, 1.116103005972605],
            [34.07926903604946, 1.111054568944494],
            [34.081113597127995, 1.110042977509149],
            [34.08073388464728, 1.107713172379168],
            [34.08246150304214, 1.104777715343504],
            [34.08411541107466, 1.106294308406814],
            [34.08481458153841, 1.107707807744704],
            [34.08627576321325, 1.107277259198163],
            [34.08697290977263, 1.106835823242992],
            [34.087888797002, 1.105261278345819],
            [34.089681412999255, 1.103997241438051],
            [34.09023854903678, 1.102051840307799],
            [34.09195083408805, 1.099043173968849],
            [34.0932353467909, 1.098480660759927],
            [34.09361989130953, 1.097719851107309],
            [34.094854890670554, 1.097392185158266],
            [34.09896321165496, 1.097636835062729],
            [34.10178033647081, 1.096911318025954],
            [34.10101787879699, 1.094299493858377],
            [34.10146262032112, 1.090943395517786],
            [34.105177716366335, 1.082258214692341],
            [34.1048202542569, 1.080042165434297],
            [34.10538461544425, 1.078169512942508],
            [34.1065143915428, 1.075790097638347],
            [34.108238296302254, 1.074415219339174],
            [34.10925992602037, 1.07299405475939],
            [34.108286628359494, 1.067322130238245],
            [34.11053472074848, 1.05802619492121],
            [34.11235795133061, 1.061712983002138],
            [34.11186231575405, 1.064155478942962],
            [34.11430174570531, 1.066054166880984],
            [34.11435538321263, 1.066832069268406],
            [34.115083695024154, 1.067926321125989],
            [34.11641451049002, 1.068568071110779],
            [34.11975587773262, 1.068648254259888],
            [34.12048395418557, 1.069091219978177],
            [34.12475861710948, 1.074363362428018],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1041,
        District: "BUDAKA",
        County: "IKI-IKI",
        Subcounty: "MUGITI",
        Population: 11493,
        Key: "BUDAKAMUGITI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.057230599810495, 1.142120655469563],
            [34.054942599764985, 1.143317198890283],
            [34.05162199079198, 1.146674415673026],
            [34.04856695166472, 1.148213332526587],
            [34.047142906343716, 1.150864278858556],
            [34.04600364942567, 1.152004472408906],
            [34.042743177271056, 1.152439876821988],
            [34.03804736617566, 1.15385275644495],
            [34.03645562425574, 1.154133763426575],
            [34.033161446413324, 1.153040425449698],
            [34.03242618972631, 1.151493855505265],
            [34.03140202316583, 1.150951478694267],
            [34.02885376950442, 1.151395654443966],
            [34.02498042893371, 1.150157778667843],
            [34.013695312634226, 1.150008065065845],
            [34.00790845181222, 1.151511846024836],
            [34.005004531773615, 1.153156704980531],
            [34.00517271615776, 1.151793152316055],
            [34.00708726318343, 1.147776083597457],
            [34.00840600259695, 1.142592306590438],
            [34.009071833885514, 1.141615112174698],
            [34.00848769359224, 1.138467341545721],
            [34.00874909166183, 1.13745410703394],
            [34.01042298631111, 1.135534396916271],
            [34.009888686346414, 1.133982746644935],
            [34.0125444952968, 1.131066359174615],
            [34.01408397862337, 1.130713027185075],
            [34.01782830315299, 1.127511637331593],
            [34.01895275853009, 1.125926033908615],
            [34.02200182475905, 1.124884681369871],
            [34.02509439999043, 1.121382836457947],
            [34.02621832086996, 1.118098790936212],
            [34.02875267400068, 1.114251898310964],
            [34.029489066158185, 1.11214545824826],
            [34.029428711947496, 1.109524720772229],
            [34.02639495301101, 1.103602144975222],
            [34.021656875283185, 1.100924823721045],
            [34.022720098795595, 1.100300540625561],
            [34.024289370256994, 1.100048691371122],
            [34.02847231249542, 1.100383623957326],
            [34.02977442139807, 1.097636552145334],
            [34.02990394229238, 1.096032716380483],
            [34.02942069089035, 1.093918911140169],
            [34.03042808770108, 1.093447354589144],
            [34.030096332680145, 1.088085700297838],
            [34.03181875611772, 1.085172100357744],
            [34.03376918634742, 1.083403986360034],
            [34.03464571209601, 1.079165100111564],
            [34.0361079726475, 1.076186134527369],
            [34.03916336840594, 1.072617476945157],
            [34.0430642890525, 1.069326744179563],
            [34.04997280610122, 1.060679811996609],
            [34.05047800963386, 1.059376415226904],
            [34.0533349073589, 1.061074739808048],
            [34.05467246827424, 1.061283699708939],
            [34.057745204212594, 1.060904480765257],
            [34.049974664715556, 1.069016867688377],
            [34.04861347900655, 1.071604436427187],
            [34.04815566340179, 1.074752533988134],
            [34.04894183390414, 1.079148520152726],
            [34.052438462367206, 1.08778603053554],
            [34.05275005021, 1.090599161506641],
            [34.054171694334265, 1.092299266808493],
            [34.05409868555616, 1.095537683391035],
            [34.056039870324994, 1.100376485464152],
            [34.05678133616725, 1.103686975113962],
            [34.05587894612499, 1.105930651918509],
            [34.05599800074791, 1.107450299890336],
            [34.05388245208413, 1.111494525023468],
            [34.05507198321707, 1.13037253407053],
            [34.05898317070899, 1.135038820013308],
            [34.06058834244242, 1.137751954816916],
            [34.059840348543005, 1.139760393163685],
            [34.057943730992065, 1.141850670141465],
            [34.057230599810495, 1.142120655469563],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1042,
        District: "BUDAKA",
        County: "IKI-IKI",
        Subcounty: "KATIIRA",
        Population: 16194,
        Key: "BUDAKAKATIIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.12029819336462, 1.174593414244181],
            [34.11987399271775, 1.175703093350651],
            [34.11897895628444, 1.175959914312185],
            [34.118779859973074, 1.176643892026399],
            [34.11550653651997, 1.178114222470347],
            [34.11486698903828, 1.179024464320596],
            [34.11343971607048, 1.179618652144936],
            [34.11282166168027, 1.179495462635998],
            [34.11195043689016, 1.180626259190436],
            [34.10987856970541, 1.180721579844707],
            [34.10937245078949, 1.18154135996928],
            [34.10709695349612, 1.183344661817732],
            [34.105705504443534, 1.183048268407347],
            [34.10478377546983, 1.185161455895462],
            [34.10265217211529, 1.185303643150248],
            [34.10262231930178, 1.186110155748599],
            [34.10210956003929, 1.186592911981226],
            [34.09814038539742, 1.187411128534666],
            [34.087575725142344, 1.187773483170312],
            [34.07916556809504, 1.192299661803391],
            [34.07816806263388, 1.191024611997785],
            [34.07681703058253, 1.187732505443663],
            [34.07251976784272, 1.179674449950275],
            [34.06942524147051, 1.175286597189587],
            [34.06786753402176, 1.174743316047404],
            [34.0672309563704, 1.172472047574316],
            [34.06492892014858, 1.167537996424118],
            [34.06169722821904, 1.164475870475534],
            [34.061582456763375, 1.157928302038144],
            [34.05963804075448, 1.152938086741042],
            [34.060261512884175, 1.150079467643249],
            [34.05825795000036, 1.147168832875043],
            [34.05816148800684, 1.144161503603122],
            [34.057230599810495, 1.142120655469563],
            [34.057943730992065, 1.141850670141465],
            [34.059840348543005, 1.139760393163685],
            [34.06058834244242, 1.137751954816916],
            [34.061906251812594, 1.13673834103948],
            [34.063246093550426, 1.13426835224944],
            [34.064708740377505, 1.132775260009877],
            [34.068169814419925, 1.13115478736814],
            [34.072031378077256, 1.127096406796172],
            [34.0739645247209, 1.126059886678387],
            [34.083710773039755, 1.12286311624836],
            [34.087462374821484, 1.123241629518105],
            [34.09160386070786, 1.125347713135246],
            [34.09447001197867, 1.126122395550646],
            [34.09486690294254, 1.126634032748178],
            [34.09727505984382, 1.126648139858608],
            [34.10368332846702, 1.123886778796124],
            [34.11261492250247, 1.118962548701812],
            [34.11527414684755, 1.115189515274601],
            [34.11688800259482, 1.111172653637091],
            [34.11698005925021, 1.109526320371789],
            [34.118427644024884, 1.103962730080568],
            [34.119184522262465, 1.09425652629287],
            [34.12092749915373, 1.08701035732434],
            [34.1209758509739, 1.082682679138366],
            [34.122291137263446, 1.079296023403025],
            [34.12210544201951, 1.077753380062629],
            [34.12475861710948, 1.074363362428018],
            [34.126869787384535, 1.076820046363744],
            [34.12662870561343, 1.077438317571798],
            [34.12692962506392, 1.078582597423631],
            [34.12793015425435, 1.078320291815887],
            [34.12797072486753, 1.079127897593858],
            [34.12928442203734, 1.079616968622105],
            [34.129830038977964, 1.080655134175719],
            [34.129982412114764, 1.082207955732604],
            [34.130673322569464, 1.082410381012283],
            [34.13150753227828, 1.084748738295924],
            [34.13300428634005, 1.085986108148907],
            [34.133800432633656, 1.085939034104937],
            [34.13391219473311, 1.086571990963419],
            [34.13446234187773, 1.086493415083184],
            [34.13634556554778, 1.090590458408386],
            [34.13868763159696, 1.09224101356443],
            [34.139049586181116, 1.092883107794284],
            [34.139227381640474, 1.099557158238472],
            [34.13838398575957, 1.101388357721641],
            [34.13489805084168, 1.1040468892921],
            [34.134052875398154, 1.105874413486188],
            [34.133169912322266, 1.109429750722148],
            [34.13356884425848, 1.113886779722263],
            [34.131347611496466, 1.117785444559646],
            [34.13202199923812, 1.119871449610186],
            [34.13110821047323, 1.120990662187262],
            [34.130866655289985, 1.122356634628468],
            [34.132722788466005, 1.124771069976861],
            [34.13353781016035, 1.129212112104896],
            [34.13346194024809, 1.13198912359206],
            [34.13697826696868, 1.14124131203295],
            [34.13709911013733, 1.142878505010364],
            [34.13652523938437, 1.144705932146435],
            [34.1343213243444, 1.147800386233476],
            [34.1296568563676, 1.152713984481667],
            [34.1253391758197, 1.166745382392893],
            [34.124946541971966, 1.169513484774549],
            [34.12268723142169, 1.172077167060633],
            [34.120966852549714, 1.173243787517196],
            [34.12029819336462, 1.174593414244181],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1043,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "KABWANGASI",
        Population: 28552,
        Key: "BUTEBOKABWANGASI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.57330068317046, 0.982432956082982],
            [33.567790124366894, 0.983979639823119],
            [33.55865893725171, 0.984550455611315],
            [33.55438308675501, 0.985356469364851],
            [33.54969315333653, 0.987408247067399],
            [33.54801219523417, 0.987776373181955],
            [33.54532248296667, 0.987276548450613],
            [33.536799800251885, 0.983305198770163],
            [33.530719636794636, 0.988014628467925],
            [33.52759173980629, 0.989721943948754],
            [33.52642237944474, 0.990031123972748],
            [33.523221073927985, 0.98973735673923],
            [33.519654408313805, 0.989973346671472],
            [33.5161463990944, 0.991415864878545],
            [33.5143024982776, 0.993535517907013],
            [33.513650887319955, 0.994954255249188],
            [33.514736069251185, 1.000124433944289],
            [33.519655492580334, 1.009979298426572],
            [33.5225811338825, 1.020718484804593],
            [33.523418431100936, 1.02213089795061],
            [33.526650597340975, 1.025532856827979],
            [33.533024392216845, 1.029815279463135],
            [33.535682960791775, 1.032837471610036],
            [33.533167911558216, 1.034508040982435],
            [33.527888756975194, 1.035107350385537],
            [33.52691414777399, 1.037453315841533],
            [33.52760428208426, 1.0404692297057],
            [33.52760478693746, 1.043497228208877],
            [33.53214692772878, 1.043891411819616],
            [33.533419105664485, 1.043424429134463],
            [33.5341601996042, 1.050934319327723],
            [33.53708797171021, 1.0528796183766],
            [33.53905710037255, 1.052608988195349],
            [33.54751567930863, 1.053057979294695],
            [33.54796327388211, 1.053373235587543],
            [33.54865139057627, 1.055532969501844],
            [33.54893886943349, 1.05796653719579],
            [33.54829965612509, 1.061440665047895],
            [33.54775328459961, 1.062607813550314],
            [33.54687369290096, 1.06317792645373],
            [33.540368329870276, 1.061134478308152],
            [33.53748971896652, 1.059814133420346],
            [33.53601719156964, 1.059627702907484],
            [33.53216548422759, 1.064071957214682],
            [33.5282724436027, 1.067451231671311],
            [33.523557727462155, 1.067664242736857],
            [33.52207269731317, 1.067018165230833],
            [33.519909940384586, 1.066855689966807],
            [33.51892011372245, 1.063345640882328],
            [33.518728784245056, 1.057971782462705],
            [33.513709269728615, 1.056219486486865],
            [33.51050911136045, 1.055947490490447],
            [33.4996777925015, 1.058626319852313],
            [33.4950938935242, 1.058093987299759],
            [33.49161218158643, 1.058250040267685],
            [33.4887807924222, 1.059369457167912],
            [33.49123741163642, 1.055468256867878],
            [33.49322816813755, 1.0496637823155],
            [33.4949815286552, 1.046522078421897],
            [33.49872677036471, 1.044786217845405],
            [33.49869688341518, 1.043768998950473],
            [33.496347577843125, 1.037845547590556],
            [33.49572318134701, 1.036918177406436],
            [33.49429617787381, 1.035990934490575],
            [33.48912346197383, 1.03371794958023],
            [33.48716151174892, 1.033598580212127],
            [33.47936177520853, 1.031539070570948],
            [33.47726009024451, 1.029903238166443],
            [33.474087858701914, 1.028247611936247],
            [33.472224084456094, 1.026671596935764],
            [33.46770297053063, 1.019549014287062],
            [33.470140786209335, 1.015119071692776],
            [33.4705171398892, 1.012924177267311],
            [33.47029882502063, 1.011248150123238],
            [33.469545349601354, 1.010330417751778],
            [33.46742395200677, 1.009333071708381],
            [33.464350580959504, 1.005642191795322],
            [33.46244685503971, 1.001771562539705],
            [33.461712954808775, 0.999038090543415],
            [33.46222811706467, 0.997022752899953],
            [33.4612961329237, 0.995446588900941],
            [33.46137532660252, 0.994688359873933],
            [33.46439050298905, 0.992688048824622],
            [33.46568589249335, 0.991277439046318],
            [33.46943950739964, 0.984570734779392],
            [33.46959805016581, 0.983852193966528],
            [33.468169631846, 0.979328392387901],
            [33.468222346783506, 0.978130855037617],
            [33.4696761667646, 0.975229965222386],
            [33.472134646389776, 0.971796698302361],
            [33.47641995704474, 0.968464332911708],
            [33.48114794220034, 0.966384308218872],
            [33.48439345920212, 0.963030461828128],
            [33.486163584977895, 0.960122382548534],
            [33.48778636189424, 0.958613518736024],
            [33.496904127280786, 0.959133145606165],
            [33.49924484495873, 0.958931519141013],
            [33.50189126920933, 0.957912876918864],
            [33.50321949573053, 0.951459806907278],
            [33.50642914030808, 0.941004498916559],
            [33.507969518356695, 0.9375114363538],
            [33.51161610528507, 0.939061955960576],
            [33.514615019470014, 0.9415549104415],
            [33.52376421062012, 0.945619579887543],
            [33.52668205993549, 0.946669909489089],
            [33.53022226118141, 0.947126222772122],
            [33.539241581094245, 0.949852911533621],
            [33.54409200752139, 0.953552689299284],
            [33.54533117416702, 0.955219364707972],
            [33.54672373443562, 0.958243781679664],
            [33.54815710606592, 0.959820439183312],
            [33.55425868266458, 0.963022452682202],
            [33.55744084777758, 0.963928563879],
            [33.56836431581839, 0.963710996652603],
            [33.57180023793118, 0.96929394050061],
            [33.57170265034859, 0.970198645260301],
            [33.56987693502643, 0.972922066884393],
            [33.56961253388884, 0.973944409622704],
            [33.570142374616466, 0.978051602839276],
            [33.570698697678665, 0.979309023946695],
            [33.57330068317046, 0.982432956082982],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1044,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "BUMANYA",
        Population: 25961,
        Key: "KALIROBUMANYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.82306343362745, 1.14350227516627],
            [33.82259159442278, 1.1455107094962],
            [33.82130129387454, 1.147276819264693],
            [33.818671968157055, 1.149845063557655],
            [33.81483208354248, 1.152162050862592],
            [33.81144469201462, 1.155564476427005],
            [33.81036803060388, 1.156188989261512],
            [33.806239599035194, 1.161201891911064],
            [33.80077384729969, 1.158828857793632],
            [33.80092012267236, 1.165566586887444],
            [33.796954822464315, 1.167206857220318],
            [33.79427836483881, 1.169218442476166],
            [33.79189134260126, 1.170385400022586],
            [33.790652690690266, 1.170295265704108],
            [33.79000358423563, 1.170908750760816],
            [33.78851050248672, 1.170793425772334],
            [33.78656543969085, 1.171402848489128],
            [33.782110608856954, 1.174552278252875],
            [33.780042675394796, 1.177972430022777],
            [33.772200138622686, 1.179729654093978],
            [33.76803927068573, 1.179558932226928],
            [33.760881808013885, 1.178448193968872],
            [33.75813403134136, 1.17737241301191],
            [33.75593035076168, 1.175428013458804],
            [33.75325493248699, 1.171846315096493],
            [33.75210958678792, 1.169919713496946],
            [33.75154837239902, 1.167685370372304],
            [33.75017211475618, 1.163488145811691],
            [33.74875965051583, 1.15615177694189],
            [33.747880500788284, 1.153908466744308],
            [33.74680943588177, 1.152416070893324],
            [33.74051460830929, 1.143814448495139],
            [33.73683136472746, 1.139717308606863],
            [33.727241867035794, 1.132771987188729],
            [33.72328512238253, 1.128810575767268],
            [33.72138454236286, 1.125635695174067],
            [33.7181105281053, 1.117892613834668],
            [33.72535300374236, 1.117954144802315],
            [33.73185483729228, 1.116948346073924],
            [33.7360624167257, 1.115463648017172],
            [33.74287902534109, 1.111526381372915],
            [33.75752231187055, 1.113422683640745],
            [33.76244355788141, 1.113140961376581],
            [33.764880592924136, 1.111946184778991],
            [33.767310246510156, 1.110452875467466],
            [33.77091446619479, 1.106779049531846],
            [33.77209452818629, 1.104119069894773],
            [33.77387647129965, 1.095985803262733],
            [33.77567250808148, 1.092402924330556],
            [33.77874964127315, 1.090267150415589],
            [33.78212265346828, 1.089741572993425],
            [33.78348543638185, 1.089913098619365],
            [33.78882245863883, 1.092444701871188],
            [33.794204720053536, 1.096107083276363],
            [33.79657520700165, 1.100412556050882],
            [33.79800806299898, 1.102149086503733],
            [33.803057786061785, 1.105721056513904],
            [33.80555785229472, 1.109275617934872],
            [33.80942367396649, 1.111499972280514],
            [33.81242052921282, 1.113778836997964],
            [33.813370388031295, 1.119839665202608],
            [33.81600651758877, 1.123737924252271],
            [33.81560326206109, 1.125981545360802],
            [33.817285670942624, 1.130151459480446],
            [33.81845885543231, 1.135217106890529],
            [33.82108759095667, 1.138681121722639],
            [33.82306343362745, 1.14350227516627],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1045,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "PUTI-PUTI",
        Population: 24288,
        Key: "PALLISAPUTI-PUTI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.97368007832994, 1.477186523572353],
            [32.94965264718613, 1.479339359625868],
            [32.94739397174477, 1.479221693500643],
            [32.946266309382096, 1.479701173784449],
            [32.92775523207375, 1.480333952395138],
            [32.92133820667318, 1.480885621191431],
            [32.8945464402112, 1.481228293905714],
            [32.87786875971903, 1.480658618191183],
            [32.86820424731125, 1.4804397583716],
            [32.867252197501784, 1.480086857138051],
            [32.865291575885145, 1.480331014088518],
            [32.85034030914706, 1.479045333942632],
            [32.83613046782702, 1.477397721834605],
            [32.8202649218439, 1.475008011109088],
            [32.826367686913684, 1.4404997821617],
            [32.83540386640778, 1.414233029842676],
            [32.84233784081334, 1.387691480830718],
            [32.8512305728313, 1.36297003689236],
            [32.85459563583447, 1.352209412183656],
            [32.86471150496011, 1.332367093603301],
            [32.871599047245276, 1.323436368802738],
            [32.88378440391852, 1.311306673488794],
            [32.88934721323059, 1.306508126726519],
            [32.8947776306327, 1.299976658000318],
            [32.904976203155016, 1.286113853578931],
            [32.91000940260648, 1.274117022663057],
            [32.91292327328347, 1.269051717364162],
            [32.91733714183875, 1.262908235936188],
            [32.954094411125915, 1.275648433636508],
            [32.96734895882, 1.277096209767262],
            [32.98607191097462, 1.282977134893249],
            [32.99455306008224, 1.284080939454587],
            [32.99722954465718, 1.284732349871217],
            [33.00060829888359, 1.286324679059982],
            [33.00743266175649, 1.283954271982956],
            [33.01060045382496, 1.284099018000065],
            [33.01332610678867, 1.285808946963785],
            [33.01546663490554, 1.287907911416303],
            [33.019705022959954, 1.294666224711823],
            [33.02081801134247, 1.298113242424787],
            [33.02147458818701, 1.309150957187849],
            [33.022473530952624, 1.312136561263488],
            [33.026968699736045, 1.31580067806947],
            [33.0285671044604, 1.317782020568151],
            [33.0335811967458, 1.325960726165134],
            [33.037706716874666, 1.347493260827399],
            [33.043655097479714, 1.364185441978093],
            [33.06372994766161, 1.43726003822696],
            [33.01545454627677, 1.460874340851044],
            [32.97368007832994, 1.477186523572353],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1046,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "KIDERA",
        Population: 65777,
        Key: "BUYENDEKIDERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.54464968883631, 1.09125994663775],
            [33.544530516534095, 1.09080762270697],
            [33.540892086308496, 1.090953035387988],
            [33.54013949752638, 1.091830723303777],
            [33.533224694965604, 1.093822293382594],
            [33.528587471094745, 1.094040247820959],
            [33.52447394796652, 1.094770216791028],
            [33.51794885254233, 1.097030993905048],
            [33.516601455074635, 1.09705157412847],
            [33.51468940087384, 1.095858306243103],
            [33.51413268524789, 1.095261602515399],
            [33.512817964896946, 1.090849432603269],
            [33.51215098556142, 1.089800099324336],
            [33.50909291462008, 1.087122720831172],
            [33.50680922199636, 1.086118894815133],
            [33.503297254799854, 1.082123247136272],
            [33.503799084260294, 1.081268465648145],
            [33.50546111575793, 1.07995813488514],
            [33.510702258129704, 1.076609874110391],
            [33.511390712590405, 1.075098914598104],
            [33.51143638204111, 1.07273764956829],
            [33.51275446927774, 1.070701860082261],
            [33.51406207766656, 1.069842178632718],
            [33.51805645274706, 1.068529691875705],
            [33.519909940384586, 1.066855689966807],
            [33.52207269731317, 1.067018165230833],
            [33.523557727462155, 1.067664242736857],
            [33.5282724436027, 1.067451231671311],
            [33.53216548422759, 1.064071957214682],
            [33.53601719156964, 1.059627702907484],
            [33.53748971896652, 1.059814133420346],
            [33.540368329870276, 1.061134478308152],
            [33.54687369290096, 1.06317792645373],
            [33.54775328459961, 1.062607813550314],
            [33.54829965612509, 1.061440665047895],
            [33.54893886943349, 1.05796653719579],
            [33.54865139057627, 1.055532969501844],
            [33.54796327388211, 1.053373235587543],
            [33.54751567930863, 1.053057979294695],
            [33.53905710037255, 1.052608988195349],
            [33.53708797171021, 1.0528796183766],
            [33.5341601996042, 1.050934319327723],
            [33.533419105664485, 1.043424429134463],
            [33.53214692772878, 1.043891411819616],
            [33.52760478693746, 1.043497228208877],
            [33.52760428208426, 1.0404692297057],
            [33.52691414777399, 1.037453315841533],
            [33.527888756975194, 1.035107350385537],
            [33.533167911558216, 1.034508040982435],
            [33.535682960791775, 1.032837471610036],
            [33.533024392216845, 1.029815279463135],
            [33.526650597340975, 1.025532856827979],
            [33.523418431100936, 1.02213089795061],
            [33.5225811338825, 1.020718484804593],
            [33.519655492580334, 1.009979298426572],
            [33.514736069251185, 1.000124433944289],
            [33.513650887319955, 0.994954255249188],
            [33.5143024982776, 0.993535517907013],
            [33.5161463990944, 0.991415864878545],
            [33.519654408313805, 0.989973346671472],
            [33.523221073927985, 0.98973735673923],
            [33.52642237944474, 0.990031123972748],
            [33.52759173980629, 0.989721943948754],
            [33.530719636794636, 0.988014628467925],
            [33.536799800251885, 0.983305198770163],
            [33.54532248296667, 0.987276548450613],
            [33.54801219523417, 0.987776373181955],
            [33.54969315333653, 0.987408247067399],
            [33.55438308675501, 0.985356469364851],
            [33.55865893725171, 0.984550455611315],
            [33.567790124366894, 0.983979639823119],
            [33.57330068317046, 0.982432956082982],
            [33.5748737886415, 0.984519302145572],
            [33.57603637031591, 0.989892940591623],
            [33.57681582411488, 0.99182883401609],
            [33.58337516062277, 1.004692304897498],
            [33.58760420619823, 1.009694449169219],
            [33.591760585253716, 1.013502409646452],
            [33.59562259537375, 1.017147569864887],
            [33.59793070420688, 1.019933564367312],
            [33.6053838958635, 1.032570566210643],
            [33.60806028162376, 1.039952251826343],
            [33.61080614039318, 1.051592799341117],
            [33.60656792840857, 1.051169487440987],
            [33.60342904682088, 1.052031733845997],
            [33.5993388241945, 1.052319739953786],
            [33.589541821062106, 1.055768160620255],
            [33.58345446209944, 1.058545699037925],
            [33.580505605635395, 1.058354783027566],
            [33.57346596779284, 1.055579719775948],
            [33.568994978961925, 1.054527435612461],
            [33.56862050815091, 1.054955331280576],
            [33.56469679275402, 1.055644167449528],
            [33.554296913166446, 1.059953732879911],
            [33.547703931157905, 1.064434860688308],
            [33.54695708171216, 1.067577642213498],
            [33.54451618301541, 1.071155350123052],
            [33.543619380494235, 1.071656996642941],
            [33.54115269745387, 1.075566249077285],
            [33.541351412879564, 1.082621389046899],
            [33.54204275901716, 1.083863372691269],
            [33.54540024203596, 1.087141928743753],
            [33.545696581875156, 1.087936823300958],
            [33.54464968883631, 1.09125994663775],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1047,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "BUYINDA",
        Population: 8515,
        Key: "KALIROBUYINDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.712499277141546, 1.19967365468279],
            [33.71265287827535, 1.197187558606058],
            [33.711796933828225, 1.197830092758686],
            [33.70889711100565, 1.197622778150319],
            [33.70711417884718, 1.197903688219453],
            [33.7049982546876, 1.198691295321328],
            [33.70340542131461, 1.199867770389198],
            [33.70228811023896, 1.199940433548385],
            [33.69547902681072, 1.195283164457302],
            [33.69362514840606, 1.194930817661595],
            [33.68940559622656, 1.196325074852577],
            [33.68707611198123, 1.19453442431894],
            [33.68638686071486, 1.194625065288199],
            [33.68528342052552, 1.194010169137361],
            [33.68539282724228, 1.179797826261274],
            [33.68659446137701, 1.175409893761547],
            [33.68970622372456, 1.171881841423888],
            [33.69274402418152, 1.166578826154381],
            [33.69197332805825, 1.159775930175221],
            [33.69336635455248, 1.154718506354789],
            [33.69463109982753, 1.137158640185043],
            [33.69412986056025, 1.131766956088704],
            [33.692329745427, 1.123417324181166],
            [33.69554099349734, 1.122484748428773],
            [33.699266046469155, 1.12549638527417],
            [33.7023317045814, 1.128851945037289],
            [33.70885442935155, 1.137254663748337],
            [33.714711657006426, 1.143893421617629],
            [33.71625609094854, 1.146977927937769],
            [33.71897975234728, 1.150559694634454],
            [33.71964153492886, 1.152993062385161],
            [33.719747899950086, 1.155996507807797],
            [33.72107859324508, 1.157914046889524],
            [33.72683051409415, 1.158817223397431],
            [33.73349935074359, 1.155965817723594],
            [33.74680943588177, 1.152416070893324],
            [33.747880500788284, 1.153908466744308],
            [33.74875965051583, 1.15615177694189],
            [33.75017211475618, 1.163488145811691],
            [33.75154837239902, 1.167685370372304],
            [33.748215708933195, 1.17037309118008],
            [33.7469044929102, 1.172083241095766],
            [33.744752774479814, 1.177520796833679],
            [33.74501286011079, 1.181727372279535],
            [33.7472562282597, 1.191270870534254],
            [33.74169446997651, 1.191099665291476],
            [33.74049308377678, 1.189544729691113],
            [33.73908072104606, 1.189789458858659],
            [33.72276068232638, 1.187206494037023],
            [33.72086564850529, 1.199157550909426],
            [33.712499277141546, 1.19967365468279],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1048,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "PALLISA TOWN COUNCIL",
        Population: 33138,
        Key: "PALLISAPALLISA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.94124912695255, 1.230027685598606],
            [33.936901631320374, 1.230807193182845],
            [33.93417824750107, 1.232056519527756],
            [33.931733165350046, 1.234020390041441],
            [33.926442852792874, 1.242254229776819],
            [33.9255261714528, 1.24726610959832],
            [33.92409327772622, 1.249121074877808],
            [33.92176934506938, 1.250614510888991],
            [33.919850002836704, 1.2525239265441],
            [33.9180173471306, 1.25655915519458],
            [33.914326505598076, 1.259111477501818],
            [33.911997479493564, 1.25893137733662],
            [33.91045646094616, 1.260053645400774],
            [33.90869954489663, 1.260633218547813],
            [33.905647063272966, 1.26065238395601],
            [33.90550569629504, 1.261204250657062],
            [33.904698558215614, 1.261439734547178],
            [33.9025657502203, 1.263403503194416],
            [33.90292577791818, 1.26488695228805],
            [33.901860669740316, 1.266370899874926],
            [33.89971419657289, 1.267819043142353],
            [33.89482354987553, 1.269096268261549],
            [33.890138494309014, 1.267107730854336],
            [33.888784133101254, 1.267108199660222],
            [33.88590708257114, 1.266041738735434],
            [33.8812949585276, 1.267083642133559],
            [33.88117039363872, 1.255839209989275],
            [33.879604171059405, 1.247173440692255],
            [33.87911878885349, 1.247056003013814],
            [33.87811328389475, 1.245391831998899],
            [33.87565239947954, 1.240589097456031],
            [33.87334380286122, 1.23248441837005],
            [33.87314329709317, 1.227418577369118],
            [33.87408563162283, 1.222870425663354],
            [33.87383096462969, 1.220454515807894],
            [33.87200686447837, 1.216153525576267],
            [33.86808158960616, 1.211746888685354],
            [33.86707497971958, 1.208256221152428],
            [33.875323318743206, 1.201038974795133],
            [33.87646402015221, 1.198731811251739],
            [33.8813661230644, 1.194858432786795],
            [33.882962121202134, 1.190200553336872],
            [33.885441530675145, 1.188045297165414],
            [33.88788188050123, 1.186841374905783],
            [33.888760229829856, 1.184320561061662],
            [33.890273461688885, 1.184458993305902],
            [33.89449401818491, 1.186459222829592],
            [33.89717568783567, 1.183146581526873],
            [33.89866129739805, 1.183891803212117],
            [33.89969699293688, 1.18518021409471],
            [33.89969562570099, 1.180943758784611],
            [33.90162153821168, 1.180201151647345],
            [33.90271543290282, 1.180296532490558],
            [33.90330961366604, 1.179338947295767],
            [33.905116889270374, 1.179410159625635],
            [33.90723311885716, 1.178930769214637],
            [33.909110020184244, 1.180195406343537],
            [33.91235406035569, 1.180168523674349],
            [33.91450840815491, 1.180774389567647],
            [33.915612156466416, 1.180244171820934],
            [33.91908164772304, 1.180027843209899],
            [33.92247415605477, 1.182658046164493],
            [33.92755706198585, 1.185561764605133],
            [33.93884364792916, 1.186691361489595],
            [33.94609671739836, 1.186288419647437],
            [33.9510388088154, 1.184869739206871],
            [33.95402290708635, 1.185438571767439],
            [33.9563178457191, 1.184359643798527],
            [33.95947000261006, 1.184173723273337],
            [33.962988727832474, 1.182031640583342],
            [33.96800954939763, 1.183223546241725],
            [33.96905104625658, 1.185511242492612],
            [33.96942942923066, 1.18812540786599],
            [33.97041676845776, 1.189291993746268],
            [33.97173256319377, 1.193235587929769],
            [33.970593046662586, 1.19540703762992],
            [33.970742503867974, 1.197116680834807],
            [33.970167042198646, 1.201142362536503],
            [33.968051863640774, 1.203422717044425],
            [33.96786877261283, 1.205096295857179],
            [33.96736181826371, 1.205874435636677],
            [33.966364559839256, 1.206869855509777],
            [33.96323042494956, 1.207134575189813],
            [33.96213250670424, 1.207929438198015],
            [33.96125774524689, 1.208966017045629],
            [33.960830107645755, 1.212783087069704],
            [33.96036717703377, 1.21383679198768],
            [33.95950953566906, 1.214769739763925],
            [33.955083208379136, 1.217051112959995],
            [33.95311761189248, 1.221474910378322],
            [33.95143151901995, 1.223637522548684],
            [33.944732286974535, 1.226534656388556],
            [33.94274318786512, 1.228055106774042],
            [33.94124912695255, 1.230027685598606],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1049,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "BUTEBO",
        Population: 29393,
        Key: "BUTEBOBUTEBO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.4928625583085, 1.247058026438772],
            [33.490871602381354, 1.247130777231939],
            [33.49004947950471, 1.245891495193963],
            [33.48886645217443, 1.240300680091794],
            [33.487716448710636, 1.237071119256905],
            [33.481904024530564, 1.223447415016463],
            [33.48119487917392, 1.21930401946848],
            [33.480420145123425, 1.199970722587512],
            [33.47493403666526, 1.171591227143182],
            [33.47270100183705, 1.164933007708925],
            [33.47032247317049, 1.154800751971789],
            [33.46775003057341, 1.147292154923188],
            [33.4666050675567, 1.13985569274144],
            [33.46229037211049, 1.127181510190794],
            [33.45744507596192, 1.115388439146162],
            [33.45494775228556, 1.110300906368743],
            [33.44862351566731, 1.099599226679866],
            [33.47693600503947, 1.069992980370899],
            [33.48092496866873, 1.066147374310504],
            [33.48209111575649, 1.065839592905805],
            [33.48447152459695, 1.063975533410028],
            [33.48563863198373, 1.062636392128626],
            [33.48639098720387, 1.060148348319024],
            [33.4887807924222, 1.059369457167912],
            [33.49161218158643, 1.058250040267685],
            [33.4950938935242, 1.058093987299759],
            [33.4996777925015, 1.058626319852313],
            [33.51050911136045, 1.055947490490447],
            [33.513709269728615, 1.056219486486865],
            [33.518728784245056, 1.057971782462705],
            [33.51892011372245, 1.063345640882328],
            [33.519909940384586, 1.066855689966807],
            [33.51805645274706, 1.068529691875705],
            [33.51406207766656, 1.069842178632718],
            [33.51275446927774, 1.070701860082261],
            [33.51143638204111, 1.07273764956829],
            [33.511390712590405, 1.075098914598104],
            [33.510702258129704, 1.076609874110391],
            [33.50546111575793, 1.07995813488514],
            [33.503799084260294, 1.081268465648145],
            [33.503297254799854, 1.082123247136272],
            [33.50680922199636, 1.086118894815133],
            [33.50909291462008, 1.087122720831172],
            [33.51215098556142, 1.089800099324336],
            [33.512817964896946, 1.090849432603269],
            [33.51413268524789, 1.095261602515399],
            [33.51468940087384, 1.095858306243103],
            [33.516601455074635, 1.09705157412847],
            [33.51794885254233, 1.097030993905048],
            [33.52447394796652, 1.094770216791028],
            [33.528587471094745, 1.094040247820959],
            [33.533224694965604, 1.093822293382594],
            [33.54013949752638, 1.091830723303777],
            [33.540892086308496, 1.090953035387988],
            [33.544530516534095, 1.09080762270697],
            [33.54464968883631, 1.09125994663775],
            [33.54404497712302, 1.092888502094419],
            [33.54468789957524, 1.094435406622994],
            [33.544530417719415, 1.096795909256006],
            [33.545979535019974, 1.097788347650217],
            [33.546312593496395, 1.098482449875116],
            [33.548239899294074, 1.104250828275849],
            [33.55030960513228, 1.10841541938217],
            [33.55164235646759, 1.11389666022121],
            [33.55306950906115, 1.1154762094738],
            [33.55537633420173, 1.115858756367755],
            [33.55408333960597, 1.120025661777631],
            [33.55402161007458, 1.121586247931206],
            [33.55265748328135, 1.12370888999911],
            [33.55147982607984, 1.127953876710516],
            [33.550673583620764, 1.12832856952537],
            [33.54943290241556, 1.127267615010643],
            [33.548129835010535, 1.124271556476113],
            [33.54403544869281, 1.119965138570663],
            [33.54260840299874, 1.117281212812271],
            [33.54080945657371, 1.115908238764015],
            [33.538203893092124, 1.112849988183333],
            [33.536901300895856, 1.112350841791342],
            [33.53566128534227, 1.114910419355999],
            [33.53665423634495, 1.118031393293299],
            [33.536716567747554, 1.119716806325625],
            [33.5365306317551, 1.12046591918934],
            [33.53460829364096, 1.122713508110553],
            [33.534112623030126, 1.125585064218636],
            [33.53442307540242, 1.127395278626476],
            [33.53392748653825, 1.130703797894685],
            [33.536409264868645, 1.135072956481022],
            [33.53740224551572, 1.138256350071503],
            [33.53368133018411, 1.141253359643823],
            [33.53250339360654, 1.144125045561058],
            [33.530952892443004, 1.144749567185845],
            [33.52996080831459, 1.146435178441315],
            [33.523634819981524, 1.149370246808714],
            [33.52251871444498, 1.15124315130287],
            [33.522395178127105, 1.154052221028499],
            [33.52630356736694, 1.158483543254073],
            [33.529406331290296, 1.166597976960901],
            [33.53083334374667, 1.168907363167088],
            [33.532756678990815, 1.17184088501819],
            [33.53561042273088, 1.17489906913626],
            [33.53827792774627, 1.177083361142822],
            [33.54272654403501, 1.18321325553989],
            [33.54604460448759, 1.188982704840984],
            [33.54501993756549, 1.18985311232871],
            [33.543427367398884, 1.190088649195271],
            [33.54209614230123, 1.190948370487658],
            [33.54097848178095, 1.192287534478358],
            [33.540300245656596, 1.194241803316278],
            [33.54060854117389, 1.196512516870883],
            [33.53889608005283, 1.198448897564538],
            [33.53711266909231, 1.199543927767152],
            [33.53601945712079, 1.19952605071998],
            [33.53308326151237, 1.200494649714276],
            [33.52733057979026, 1.19982630247019],
            [33.52604698786053, 1.200134146878912],
            [33.52408540504658, 1.200813047832438],
            [33.52004297997983, 1.204287852494627],
            [33.51620243330689, 1.208884439434221],
            [33.50792623483135, 1.220294231640742],
            [33.50147944285551, 1.233332133781954],
            [33.4928625583085, 1.247058026438772],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1050,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "GADUMIRE",
        Population: 26473,
        Key: "KALIROGADUMIRE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96800954939763, 1.183223546241725],
            [33.962988727832474, 1.182031640583342],
            [33.95947000261006, 1.184173723273337],
            [33.9563178457191, 1.184359643798527],
            [33.95402290708635, 1.185438571767439],
            [33.9510388088154, 1.184869739206871],
            [33.94609671739836, 1.186288419647437],
            [33.93884364792916, 1.186691361489595],
            [33.92755706198585, 1.185561764605133],
            [33.92247415605477, 1.182658046164493],
            [33.91908164772304, 1.180027843209899],
            [33.915612156466416, 1.180244171820934],
            [33.91450840815491, 1.180774389567647],
            [33.91235406035569, 1.180168523674349],
            [33.909110020184244, 1.180195406343537],
            [33.90723311885716, 1.178930769214637],
            [33.905116889270374, 1.179410159625635],
            [33.90330961366604, 1.179338947295767],
            [33.90271543290282, 1.180296532490558],
            [33.90162153821168, 1.180201151647345],
            [33.89969562570099, 1.180943758784611],
            [33.89969699293688, 1.18518021409471],
            [33.89866129739805, 1.183891803212117],
            [33.89717568783567, 1.183146581526873],
            [33.89449401818491, 1.186459222829592],
            [33.890273461688885, 1.184458993305902],
            [33.888760229829856, 1.184320561061662],
            [33.88788188050123, 1.186841374905783],
            [33.885441530675145, 1.188045297165414],
            [33.882962121202134, 1.190200553336872],
            [33.8813661230644, 1.194858432786795],
            [33.87646402015221, 1.198731811251739],
            [33.875323318743206, 1.201038974795133],
            [33.86707497971958, 1.208256221152428],
            [33.86630513789412, 1.206496946940878],
            [33.863666982635735, 1.203349518700047],
            [33.85881694517909, 1.199669220672386],
            [33.85519046793667, 1.198105355434982],
            [33.854987127983925, 1.192695728552248],
            [33.85800255050882, 1.183800676903681],
            [33.85739057411984, 1.17803992145402],
            [33.856066799649156, 1.175669939921179],
            [33.853022808901564, 1.172448207685697],
            [33.85124915813661, 1.169918555809936],
            [33.85188272643179, 1.164964501521816],
            [33.85241177574364, 1.164405034082316],
            [33.85299350136543, 1.160659656164904],
            [33.85251624621792, 1.160956589026962],
            [33.853750262822025, 1.156639298436712],
            [33.85580044916743, 1.153916061357908],
            [33.86278484241662, 1.150951974464254],
            [33.864746320127686, 1.149814461424331],
            [33.86764489429204, 1.147054865798534],
            [33.87076506756557, 1.144091957325578],
            [33.87204244944173, 1.14154847579933],
            [33.87358787242898, 1.140740197298248],
            [33.87768974350965, 1.140439751512839],
            [33.87905684462477, 1.13972128376373],
            [33.88130647043797, 1.139441048663644],
            [33.887767211453536, 1.140490688473478],
            [33.89078011061082, 1.141664082194583],
            [33.8913365513523, 1.142367705952635],
            [33.911500734497636, 1.154032198049825],
            [33.914979758676054, 1.156772057648244],
            [33.9164975036711, 1.158481287147315],
            [33.91843525957045, 1.15971093151745],
            [33.9208638387714, 1.160578564816192],
            [33.92331639041402, 1.162613139756152],
            [33.926215484702894, 1.162856427092049],
            [33.92878493321511, 1.165062830545495],
            [33.932230028025266, 1.165351157965761],
            [33.94779200093456, 1.164423219414126],
            [33.955953949875614, 1.160250208103522],
            [33.958551123092455, 1.159733696450787],
            [33.9606819215565, 1.158765040157092],
            [33.963464105501046, 1.160537109783327],
            [33.96355033568346, 1.161387407109075],
            [33.9657208118353, 1.163132543759923],
            [33.96591648107384, 1.163702375872186],
            [33.966432477864636, 1.168008105730135],
            [33.967937950974566, 1.173172861532464],
            [33.968005749524, 1.175940920741725],
            [33.96739935167291, 1.178293098505899],
            [33.967305208231124, 1.18056368415598],
            [33.96800954939763, 1.183223546241725],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1051,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "PETETE",
        Population: 26625,
        Key: "BUTEBOPETETE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.68528342052552, 1.194010169137361],
            [33.685613335796766, 1.199184780965463],
            [33.68497084273926, 1.199809163678116],
            [33.6812991011863, 1.197141318939087],
            [33.675820237640885, 1.1969346132035],
            [33.67370421556496, 1.197414613007456],
            [33.66880669406071, 1.199234208918659],
            [33.65870293692004, 1.204067627945251],
            [33.65790615102597, 1.205533390306894],
            [33.657213618213845, 1.206022082365726],
            [33.65286596717314, 1.207615361746071],
            [33.6470531854636, 1.209019008542969],
            [33.640801379108375, 1.209255719392604],
            [33.636725091148676, 1.208695788504123],
            [33.63047338720143, 1.206996467410859],
            [33.62195067214731, 1.206184235460179],
            [33.61426896435375, 1.205607001726201],
            [33.59683794768119, 1.203195409872825],
            [33.58525036682892, 1.200547217464666],
            [33.58166094239702, 1.199181915069212],
            [33.566070014989506, 1.190138336869231],
            [33.5553633778004, 1.182188313841801],
            [33.55671911073562, 1.180324381540658],
            [33.55797858200161, 1.180278892423564],
            [33.55879916157263, 1.179473552877904],
            [33.560440081762756, 1.176677732510598],
            [33.561652916990795, 1.176605111849505],
            [33.5646487787004, 1.17366426537891],
            [33.56729956337338, 1.172768083756943],
            [33.56841700470474, 1.173238292776473],
            [33.57122175522755, 1.172568247773705],
            [33.57729545081476, 1.17215083595395],
            [33.57917385771827, 1.171535258532066],
            [33.580671725690976, 1.16983413716336],
            [33.581860828327535, 1.16911918762754],
            [33.58384603503683, 1.168838319549666],
            [33.586009168359524, 1.167833664894695],
            [33.59147800221477, 1.162911030717915],
            [33.595192489202226, 1.157293223062983],
            [33.60600777852327, 1.158054397051394],
            [33.61284671745997, 1.159988808829789],
            [33.61601667806151, 1.160095663087642],
            [33.62246368383638, 1.161384833964466],
            [33.639845811496244, 1.165539484934158],
            [33.65042748224957, 1.165957439308764],
            [33.655089742167405, 1.164675557944985],
            [33.65448594314244, 1.166881628564415],
            [33.658790758018846, 1.16688319669765],
            [33.66339252358882, 1.167564285551605],
            [33.66617484677225, 1.167384101154748],
            [33.669635159043295, 1.166338281128156],
            [33.67376533514025, 1.164329313657431],
            [33.67669309736479, 1.16197481868298],
            [33.67891759280791, 1.161141080371934],
            [33.68096598342106, 1.159484601528839],
            [33.68154648463911, 1.159199808554944],
            [33.68299405414246, 1.1594020650531],
            [33.6838621779482, 1.15888182599973],
            [33.68482878226191, 1.160043857085989],
            [33.68575556425905, 1.163126675377266],
            [33.68572072849064, 1.166353128101357],
            [33.68500959516228, 1.171307686485165],
            [33.68970622372456, 1.171881841423888],
            [33.68659446137701, 1.175409893761547],
            [33.68539282724228, 1.179797826261274],
            [33.68528342052552, 1.194010169137361],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1052,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "OLOK",
        Population: 16273,
        Key: "PALLISAOLOK",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.65412085074299, 1.26920898815351],
            [33.64723059105411, 1.279845860182782],
            [33.64510962195591, 1.276571480520181],
            [33.64244950288879, 1.269361897784789],
            [33.63714250682016, 1.26059691922834],
            [33.63292181467858, 1.25562223901833],
            [33.62861592272215, 1.252170294900647],
            [33.628320471316776, 1.251113046872824],
            [33.62846565254142, 1.247470753009348],
            [33.62565650117204, 1.244115780785331],
            [33.62423600509474, 1.238064552634897],
            [33.623856994198256, 1.234047873011771],
            [33.624263818732565, 1.224838157617124],
            [33.623232730652816, 1.214036545040643],
            [33.62195067214731, 1.206184235460179],
            [33.63047338720143, 1.206996467410859],
            [33.636725091148676, 1.208695788504123],
            [33.640801379108375, 1.209255719392604],
            [33.6470531854636, 1.209019008542969],
            [33.65286596717314, 1.207615361746071],
            [33.657213618213845, 1.206022082365726],
            [33.65790615102597, 1.205533390306894],
            [33.65870293692004, 1.204067627945251],
            [33.66880669406071, 1.199234208918659],
            [33.67370421556496, 1.197414613007456],
            [33.675820237640885, 1.1969346132035],
            [33.6812991011863, 1.197141318939087],
            [33.68497084273926, 1.199809163678116],
            [33.685613335796766, 1.199184780965463],
            [33.68528342052552, 1.194010169137361],
            [33.68638686071486, 1.194625065288199],
            [33.68707611198123, 1.19453442431894],
            [33.68940559622656, 1.196325074852577],
            [33.69362514840606, 1.194930817661595],
            [33.69547902681072, 1.195283164457302],
            [33.70228811023896, 1.199940433548385],
            [33.70340542131461, 1.199867770389198],
            [33.7049982546876, 1.198691295321328],
            [33.70711417884718, 1.197903688219453],
            [33.70889711100565, 1.197622778150319],
            [33.711796933828225, 1.197830092758686],
            [33.71265287827535, 1.197187558606058],
            [33.712499277141546, 1.19967365468279],
            [33.710871405879196, 1.22456309075014],
            [33.70871902000057, 1.242539301490369],
            [33.70571258961165, 1.244263429897529],
            [33.70289395023626, 1.246854869355429],
            [33.7018323688442, 1.247041643252647],
            [33.70022545437911, 1.249138814184675],
            [33.69834130095276, 1.250014283677199],
            [33.697615456813274, 1.251152527398153],
            [33.697084471632, 1.250938008753246],
            [33.69126238337609, 1.253906565594166],
            [33.68375843421097, 1.256604460709452],
            [33.671790892943, 1.258127436307895],
            [33.66462262174164, 1.260038142432073],
            [33.65915176398207, 1.263205894027821],
            [33.65412085074299, 1.26920898815351],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1053,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "APOPONG",
        Population: 26253,
        Key: "PALLISAAPOPONG",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.39539593568311, 1.333881509049832],
            [33.390870230468224, 1.346104869715594],
            [33.38520092318426, 1.356618514572041],
            [33.38053938281696, 1.362925092524881],
            [33.37626397339307, 1.366806981130084],
            [33.37424154229502, 1.367612492941587],
            [33.365977971437445, 1.369359873403548],
            [33.364147557028, 1.3693782485833],
            [33.36037030564998, 1.368600771175204],
            [33.35414252563537, 1.368773601729465],
            [33.35081218970445, 1.369814516493832],
            [33.34777131431426, 1.371723910380176],
            [33.34153927359024, 1.373660904528617],
            [33.33765153931374, 1.374339998165011],
            [33.32554137252811, 1.37424217462459],
            [33.31397304167405, 1.376026028391139],
            [33.311953258809474, 1.375926777010335],
            [33.30797480367242, 1.374696882345101],
            [33.298821533272594, 1.370355406330417],
            [33.292564437637004, 1.366706335578263],
            [33.278814502301394, 1.357393199279982],
            [33.26543350056139, 1.34688185772771],
            [33.247746609559954, 1.334371422466434],
            [33.24690626345942, 1.324464794536856],
            [33.24194756129447, 1.282377566292181],
            [33.241653116002176, 1.27578216052625],
            [33.242344856500196, 1.265404918550598],
            [33.24383442134476, 1.255706143970456],
            [33.24770509661402, 1.242134930109326],
            [33.24925825140092, 1.239746314060069],
            [33.25112892560645, 1.238479523180135],
            [33.25564256105717, 1.234082135790933],
            [33.25824101257665, 1.229657789796247],
            [33.259160383472704, 1.226626879654944],
            [33.25957009609064, 1.222492258169419],
            [33.25822594064281, 1.213047084987199],
            [33.258610982828095, 1.209382922142285],
            [33.258269150506294, 1.206614503154799],
            [33.25867415415552, 1.206089725789232],
            [33.258366712936024, 1.204606009474988],
            [33.258965312512125, 1.201737981684866],
            [33.26098061637675, 1.197485592258474],
            [33.260973519685976, 1.193730994736354],
            [33.261931448070676, 1.188610173743668],
            [33.26787915224431, 1.171546539013505],
            [33.27762685044405, 1.173273599045089],
            [33.28112446256235, 1.172676130807656],
            [33.28314738683547, 1.172060715164156],
            [33.29430140390069, 1.164704180440153],
            [33.298525822254135, 1.162957623919066],
            [33.29954883268282, 1.163011797338607],
            [33.30019201115491, 1.162432708056762],
            [33.30207065162037, 1.162839629361426],
            [33.30458650754105, 1.159446659071701],
            [33.304541878339414, 1.157130583021254],
            [33.305355493272046, 1.153348768096428],
            [33.304738524945, 1.152082227435905],
            [33.30449319773588, 1.148400046684228],
            [33.30542278427332, 1.146925254098552],
            [33.30555625595826, 1.144744866342045],
            [33.30636624798533, 1.143885295280718],
            [33.30598795394444, 1.141831623352195],
            [33.30635803289204, 1.140583071775281],
            [33.308622188954956, 1.137144895075543],
            [33.30890913241628, 1.135977776606218],
            [33.31169526265988, 1.133389978206383],
            [33.3139553942703, 1.129191837473792],
            [33.325379465571174, 1.122649461544747],
            [33.326659188456965, 1.122694553704252],
            [33.3299149821856, 1.125562138247253],
            [33.333850876042796, 1.126565922177502],
            [33.337392511898216, 1.128483509638556],
            [33.34370748059768, 1.129179395528819],
            [33.345067299070806, 1.131045470228524],
            [33.34864907614469, 1.132810749102704],
            [33.351152476025646, 1.132460980246339],
            [33.35712809894001, 1.134557022276591],
            [33.36346665650053, 1.135281608535912],
            [33.36473898175991, 1.137174479753184],
            [33.36609214731007, 1.140467465336617],
            [33.36902500028732, 1.143561207282566],
            [33.37041243207396, 1.146763710986412],
            [33.372502589856246, 1.149513765112425],
            [33.3725734696271, 1.150255620518065],
            [33.37443724027966, 1.153032842509492],
            [33.37507732854717, 1.154751712122561],
            [33.37822588678707, 1.157528757283052],
            [33.38006659768631, 1.160016467677688],
            [33.38077859249902, 1.161690088828984],
            [33.380563532226766, 1.162431981469272],
            [33.38236983675228, 1.163861180521135],
            [33.383616640874465, 1.165489490559472],
            [33.387093810930146, 1.171993884610167],
            [33.39060451329875, 1.174725890597484],
            [33.392618495741566, 1.17714091303846],
            [33.39810909847111, 1.191289793048186],
            [33.398487453597404, 1.193207722843498],
            [33.39780486783044, 1.196962368681428],
            [33.397802393870165, 1.199278426885518],
            [33.39863160984432, 1.203313311106199],
            [33.40348397393751, 1.212522532496026],
            [33.41615292786418, 1.231637073606828],
            [33.41837459810574, 1.233925632572742],
            [33.42756290549659, 1.239026702838862],
            [33.431121783615566, 1.245594285980407],
            [33.43235348346455, 1.247159222831946],
            [33.44011266106987, 1.291967947361794],
            [33.42481606127532, 1.292567679853455],
            [33.41276334534536, 1.293637238922598],
            [33.4063427356668, 1.295076771203644],
            [33.40460524209202, 1.296099371919024],
            [33.401029711004284, 1.315967355130563],
            [33.39539593568311, 1.333881509049832],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1054,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "KAGULU",
        Population: 76682,
        Key: "BUYENDEKAGULU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.93537575740993, 1.222588643420283],
            [32.947234614206636, 1.222531532555037],
            [32.94875682562525, 1.222052053608282],
            [32.95282375134304, 1.219491739214502],
            [32.95444089582258, 1.219229396249481],
            [32.97482300486593, 1.221952908443095],
            [32.98826044775524, 1.222676786705322],
            [32.99030568528174, 1.223156303261148],
            [33.000633002553904, 1.223943437804327],
            [33.01331315487892, 1.22445909947534],
            [33.029632929493886, 1.223662804357176],
            [33.03900649644578, 1.236437492889272],
            [33.046305588403605, 1.243937597939583],
            [33.049244990099275, 1.245728912516814],
            [33.05113491969292, 1.246398377244072],
            [33.05140686847553, 1.248207834505112],
            [33.0544903779091, 1.249800099033055],
            [33.064121221460006, 1.252577403946486],
            [33.068800013074025, 1.254811969857399],
            [33.089632135853904, 1.255037515952309],
            [33.095586218066096, 1.263939849302308],
            [33.120742344635154, 1.293740579917604],
            [33.125459098154785, 1.300055358902702],
            [33.14779725818657, 1.348249006427886],
            [33.15124401308336, 1.356436579475382],
            [33.110646614839844, 1.395523092199719],
            [33.08904405914308, 1.414668092364531],
            [33.06372994766161, 1.43726003822696],
            [33.043655097479714, 1.364185441978093],
            [33.037706716874666, 1.347493260827399],
            [33.0335811967458, 1.325960726165134],
            [33.0285671044604, 1.317782020568151],
            [33.026968699736045, 1.31580067806947],
            [33.022473530952624, 1.312136561263488],
            [33.02147458818701, 1.309150957187849],
            [33.02081801134247, 1.298113242424787],
            [33.019705022959954, 1.294666224711823],
            [33.01546663490554, 1.287907911416303],
            [33.01332610678867, 1.285808946963785],
            [33.01060045382496, 1.284099018000065],
            [33.00743266175649, 1.283954271982956],
            [33.00060829888359, 1.286324679059982],
            [32.99722954465718, 1.284732349871217],
            [32.99455306008224, 1.284080939454587],
            [32.98607191097462, 1.282977134893249],
            [32.96734895882, 1.277096209767262],
            [32.954094411125915, 1.275648433636508],
            [32.91733714183875, 1.262908235936188],
            [32.92201774804964, 1.257090615256782],
            [32.924299499414005, 1.253093153448465],
            [32.927257349810695, 1.246629148325277],
            [32.935032027846255, 1.236593001756132],
            [32.93579262510909, 1.234211512580033],
            [32.93537575740993, 1.222588643420283],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1055,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "NKONDO",
        Population: 30199,
        Key: "BUYENDENKONDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.7181105281053, 1.117892613834668],
              [33.72138454236286, 1.125635695174067],
              [33.72328512238253, 1.128810575767268],
              [33.727241867035794, 1.132771987188729],
              [33.73683136472746, 1.139717308606863],
              [33.74051460830929, 1.143814448495139],
              [33.74680943588177, 1.152416070893324],
              [33.73349935074359, 1.155965817723594],
              [33.72683051409415, 1.158817223397431],
              [33.72107859324508, 1.157914046889524],
              [33.719747899950086, 1.155996507807797],
              [33.71964153492886, 1.152993062385161],
              [33.71897975234728, 1.150559694634454],
              [33.71625609094854, 1.146977927937769],
              [33.714711657006426, 1.143893421617629],
              [33.70885442935155, 1.137254663748337],
              [33.7023317045814, 1.128851945037289],
              [33.699266046469155, 1.12549638527417],
              [33.69554099349734, 1.122484748428773],
              [33.699430760661336, 1.12130774898797],
              [33.70438755929622, 1.119017751324655],
              [33.708476179328144, 1.117894975954195],
              [33.7181105281053, 1.117892613834668],
            ],
          ],
          [
            [
              [33.71112001912567, 1.242638164782745],
              [33.70871902000057, 1.242539301490369],
              [33.710871405879196, 1.22456309075014],
              [33.712499277141546, 1.19967365468279],
              [33.72086564850529, 1.199157550909426],
              [33.72276068232638, 1.187206494037023],
              [33.73908072104606, 1.189789458858659],
              [33.74049308377678, 1.189544729691113],
              [33.74169446997651, 1.191099665291476],
              [33.7472562282597, 1.191270870534254],
              [33.74501286011079, 1.181727372279535],
              [33.744752774479814, 1.177520796833679],
              [33.7469044929102, 1.172083241095766],
              [33.748215708933195, 1.17037309118008],
              [33.75154837239902, 1.167685370372304],
              [33.75210958678792, 1.169919713496946],
              [33.75325493248699, 1.171846315096493],
              [33.75593035076168, 1.175428013458804],
              [33.75813403134136, 1.17737241301191],
              [33.760881808013885, 1.178448193968872],
              [33.76803927068573, 1.179558932226928],
              [33.767949083424476, 1.182517164646298],
              [33.76831080714161, 1.184416828211079],
              [33.76985384150851, 1.188206879219239],
              [33.77052156914065, 1.191581034850901],
              [33.770286773779894, 1.193643702828417],
              [33.76863342629609, 1.197199444315391],
              [33.76417011806086, 1.202402445899605],
              [33.762755164588846, 1.20473684532426],
              [33.76249230675693, 1.204881663945624],
              [33.760247168028606, 1.203461993503047],
              [33.7576101653087, 1.200857334928857],
              [33.753861382440355, 1.199989913578803],
              [33.75212526149134, 1.198823392412481],
              [33.750715379907405, 1.197150172598224],
              [33.75018732772553, 1.19711413287059],
              [33.74930793006298, 1.196155441633641],
              [33.74854737052936, 1.196327535699935],
              [33.74829450825162, 1.196047162544863],
              [33.745088233254684, 1.198798192999161],
              [33.74309078430468, 1.201358915816292],
              [33.74137897895379, 1.202870160295355],
              [33.73946956130834, 1.205298319093974],
              [33.73824097861342, 1.20780143605727],
              [33.73577940968197, 1.208978122741945],
              [33.73538651532277, 1.210208562890269],
              [33.73783339410436, 1.215997693997446],
              [33.73858741749597, 1.220665511827532],
              [33.738461655152825, 1.222972419601668],
              [33.73583345322778, 1.230038516784514],
              [33.73495867110915, 1.229577384843378],
              [33.730210962543175, 1.232591209631455],
              [33.72310254608922, 1.234936233537606],
              [33.7165287440103, 1.238773790102747],
              [33.71112001912567, 1.242638164782745],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1056,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "PALLISA",
        Population: 15400,
        Key: "PALLISAPALLISA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.83380310007295, 1.294754194026181],
            [33.8295133706051, 1.301178528605716],
            [33.828067895973, 1.302689749670739],
            [33.81999274494963, 1.308355447866309],
            [33.81069054465551, 1.317151598683046],
            [33.807287006808714, 1.319513826298082],
            [33.804747591671386, 1.320545946548413],
            [33.79989201160945, 1.321596912501755],
            [33.79275124772045, 1.321201178732046],
            [33.78982821422756, 1.320731702031883],
            [33.77411243447026, 1.316267727296032],
            [33.76957542934745, 1.316406060978252],
            [33.77099188210765, 1.302903177316251],
            [33.77071284921074, 1.296990671280015],
            [33.77221442363233, 1.292555028506044],
            [33.77287056389564, 1.290976079324015],
            [33.774212608302555, 1.289756726194302],
            [33.781711215186675, 1.285184133736647],
            [33.782105030319016, 1.284684687364758],
            [33.782089923350895, 1.282988463401541],
            [33.781649876422435, 1.275395934876399],
            [33.77700794358285, 1.269111737946641],
            [33.775125275071645, 1.267819942135848],
            [33.774001654229444, 1.267526559508137],
            [33.76447389684892, 1.266154918585516],
            [33.760489894615, 1.262059186501249],
            [33.760618642958164, 1.258100630755262],
            [33.76362188432782, 1.249258736817724],
            [33.76398590144388, 1.24661514331235],
            [33.764474652332076, 1.245623117781316],
            [33.7636072022628, 1.243173291027758],
            [33.7670101175771, 1.237712434156028],
            [33.76871793530647, 1.238005981781251],
            [33.76996496310917, 1.237419789992775],
            [33.77497294235904, 1.237237389190966],
            [33.77631643485019, 1.238413035536075],
            [33.78050328206516, 1.240682459930147],
            [33.80136755015918, 1.247375037747118],
            [33.805128009329586, 1.252932913463162],
            [33.80712713094266, 1.254262115344878],
            [33.80912517367904, 1.256661728905261],
            [33.81174183494769, 1.258641298707927],
            [33.812768347907685, 1.260304739235831],
            [33.814384661445544, 1.264339160134977],
            [33.81553058745627, 1.270343184755235],
            [33.81765758514837, 1.275309764673215],
            [33.81852284422666, 1.279344175623779],
            [33.82501123359002, 1.284950829882205],
            [33.830837812524024, 1.292014129684792],
            [33.83380310007295, 1.294754194026181],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1057,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "KAMEKE",
        Population: 17320,
        Key: "PALLISAKAMEKE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.46701182831061, 0.939911761152328],
            [33.46557884475253, 0.941196235514693],
            [33.464227176693974, 0.941685789878274],
            [33.45997048995722, 0.942033417868357],
            [33.456301605046896, 0.941677947746843],
            [33.454564480679686, 0.942051931440319],
            [33.45090939568873, 0.94588785663599],
            [33.449455377179945, 0.947894759347329],
            [33.449110757385846, 0.949162904322722],
            [33.44554546080414, 0.95165299260834],
            [33.4410515370857, 0.955746813533608],
            [33.43636613117625, 0.958212705215708],
            [33.43313133197411, 0.958747730707873],
            [33.423511031949666, 0.958767039986171],
            [33.41839263178507, 0.959998078555594],
            [33.410019238290744, 0.963636035659644],
            [33.40967982872528, 0.962640896840503],
            [33.40830232242418, 0.961609694553831],
            [33.40792248867092, 0.960777406691206],
            [33.40833797206625, 0.959076501289919],
            [33.40636622301821, 0.95866961875709],
            [33.406009902667485, 0.957158795352151],
            [33.40534476487831, 0.956824131561377],
            [33.40529753774887, 0.956471300944657],
            [33.40648491292511, 0.955295035455783],
            [33.40500055561425, 0.953196284444858],
            [33.40463253470696, 0.948801018246648],
            [33.40513064065056, 0.946338563502733],
            [33.40758926939605, 0.940747163593361],
            [33.40785051026046, 0.936205487481395],
            [33.40700692932663, 0.932595792042656],
            [33.404287271719106, 0.925014633575424],
            [33.39679245303052, 0.908178805155686],
            [33.40340770786823, 0.905952478590762],
            [33.410605327928195, 0.902522811006245],
            [33.417258536586644, 0.903327237784491],
            [33.420423665150295, 0.903086064709846],
            [33.42346900606573, 0.899346007252648],
            [33.42494956799452, 0.895580664171547],
            [33.42552106629681, 0.88801949563375],
            [33.42662481999821, 0.886462121353356],
            [33.431333080845114, 0.883445354598967],
            [33.43198628182082, 0.88218285227673],
            [33.43268464110585, 0.881789680213744],
            [33.43457116159298, 0.879302074564005],
            [33.43536064777707, 0.879000559095873],
            [33.43742454870189, 0.879224910283286],
            [33.43763073361916, 0.880322274247603],
            [33.43956911833924, 0.880764945873738],
            [33.44181687745328, 0.882835542833714],
            [33.44406329717919, 0.882635242299821],
            [33.44535306861975, 0.883241855577284],
            [33.44759910296842, 0.88302764450872],
            [33.45231504980092, 0.881741967356622],
            [33.45581459329708, 0.881892724533784],
            [33.46131957625765, 0.884219681204222],
            [33.462424577718984, 0.883952009727958],
            [33.46800648701064, 0.880079173905014],
            [33.471732970998694, 0.876793718603328],
            [33.47399970792141, 0.874047274937995],
            [33.47464965969071, 0.873238777381348],
            [33.477856815934935, 0.871157552863812],
            [33.48108712176403, 0.870044354338452],
            [33.486217977968344, 0.870975532105415],
            [33.492773638570114, 0.869807609974503],
            [33.49469737895441, 0.868712669006902],
            [33.49836111472155, 0.86787277778851],
            [33.501528915773164, 0.868490930090629],
            [33.502966125006324, 0.868665270357668],
            [33.50367226370172, 0.870418947228321],
            [33.505598558894704, 0.87245666190854],
            [33.50808844811379, 0.873436152047569],
            [33.50653802240873, 0.875834664523928],
            [33.5024949218089, 0.878404450588905],
            [33.50079566951576, 0.878932051752967],
            [33.49961941188949, 0.88105991415329],
            [33.49292858088861, 0.886489702619258],
            [33.490178988720885, 0.891635461253063],
            [33.48939922140986, 0.892170792294991],
            [33.489990132305465, 0.893098438171253],
            [33.49098313181716, 0.896678369988006],
            [33.48670980378977, 0.900591738707116],
            [33.484605661933465, 0.903284925207129],
            [33.48403513111674, 0.904649406775379],
            [33.48232384229712, 0.911040797646678],
            [33.483252947337625, 0.913285089586807],
            [33.48314000305526, 0.914751555384127],
            [33.483568168865744, 0.915661016810831],
            [33.48290273553083, 0.918724751599483],
            [33.48095269516997, 0.918246321850167],
            [33.480001576015134, 0.918916624137799],
            [33.48000169818601, 0.919826143787139],
            [33.48147636177662, 0.921980068710826],
            [33.480905758196364, 0.922889666620011],
            [33.47848034106523, 0.92413460220818],
            [33.47572215741013, 0.926576320588336],
            [33.47310686876726, 0.93064558191309],
            [33.47030113548753, 0.933230915562953],
            [33.46754326983604, 0.938161849853808],
            [33.46701182831061, 0.939911761152328],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1058,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "NAMUGONGO",
        Population: 20008,
        Key: "KALIRONAMUGONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86707497971958, 1.208256221152428],
            [33.86808158960616, 1.211746888685354],
            [33.87200686447837, 1.216153525576267],
            [33.87383096462969, 1.220454515807894],
            [33.87408563162283, 1.222870425663354],
            [33.87314329709317, 1.227418577369118],
            [33.853502500280136, 1.223326996358641],
            [33.84861519621397, 1.220994610369235],
            [33.843800871281445, 1.222099790899785],
            [33.84220975009738, 1.223023020951631],
            [33.840520079235084, 1.22316829662997],
            [33.83814714797106, 1.224535043669043],
            [33.830370212469184, 1.225776836009591],
            [33.81143903801822, 1.220168946872987],
            [33.80637473889161, 1.219035915995019],
            [33.80585398731801, 1.21256757471578],
            [33.80778832512774, 1.205845507309361],
            [33.80369033207416, 1.195968036413833],
            [33.80220526329761, 1.194629603488708],
            [33.79773206730602, 1.1924959577704],
            [33.7973170133054, 1.188850364784088],
            [33.79621302155047, 1.186290542809612],
            [33.79239503247262, 1.182890183346731],
            [33.78674008835175, 1.181218211240982],
            [33.78393736981811, 1.178514116363765],
            [33.780042675394796, 1.177972430022777],
            [33.782110608856954, 1.174552278252875],
            [33.78656543969085, 1.171402848489128],
            [33.78851050248672, 1.170793425772334],
            [33.79000358423563, 1.170908750760816],
            [33.790652690690266, 1.170295265704108],
            [33.79189134260126, 1.170385400022586],
            [33.79427836483881, 1.169218442476166],
            [33.796954822464315, 1.167206857220318],
            [33.80092012267236, 1.165566586887444],
            [33.80077384729969, 1.158828857793632],
            [33.806239599035194, 1.161201891911064],
            [33.81036803060388, 1.156188989261512],
            [33.81144469201462, 1.155564476427005],
            [33.81483208354248, 1.152162050862592],
            [33.818671968157055, 1.149845063557655],
            [33.82130129387454, 1.147276819264693],
            [33.82259159442278, 1.1455107094962],
            [33.82306343362745, 1.14350227516627],
            [33.827439003408884, 1.150321971084164],
            [33.829454009931126, 1.154500803432742],
            [33.83052673133103, 1.157739086310034],
            [33.83404842368881, 1.162297407401527],
            [33.83617926437369, 1.166783762140745],
            [33.837803708563214, 1.168411616933468],
            [33.83948843958977, 1.168754870849261],
            [33.841132522748005, 1.16841966057236],
            [33.84612908980053, 1.164618688372028],
            [33.848325744656385, 1.163740528434643],
            [33.85024521624645, 1.162030191125635],
            [33.85251624621792, 1.160956589026962],
            [33.85299350136543, 1.160659656164904],
            [33.85241177574364, 1.164405034082316],
            [33.85188272643179, 1.164964501521816],
            [33.85124915813661, 1.169918555809936],
            [33.853022808901564, 1.172448207685697],
            [33.856066799649156, 1.175669939921179],
            [33.85739057411984, 1.17803992145402],
            [33.85800255050882, 1.183800676903681],
            [33.854987127983925, 1.192695728552248],
            [33.85519046793667, 1.198105355434982],
            [33.85881694517909, 1.199669220672386],
            [33.863666982635735, 1.203349518700047],
            [33.86630513789412, 1.206496946940878],
            [33.86707497971958, 1.208256221152428],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1059,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "KAMUGE",
        Population: 21583,
        Key: "PALLISAKAMUGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.03642177932909, 1.211149649733247],
            [34.03309833706967, 1.213095785216317],
            [34.025068038030106, 1.212791306609458],
            [34.01451606558009, 1.207584013015282],
            [34.01223573265555, 1.206876025566726],
            [34.009119362848914, 1.206776058068643],
            [34.01194270759977, 1.197202030000537],
            [34.013704399093335, 1.194001367559084],
            [34.011649969106536, 1.189996175010605],
            [34.01129249262408, 1.185519224111686],
            [34.01252329415777, 1.182846299218993],
            [34.013128022939064, 1.179472986161069],
            [34.012111694179424, 1.179232578758141],
            [34.01005708452958, 1.175477236165856],
            [34.01076815856916, 1.173768797459544],
            [34.01227322743719, 1.172583542879433],
            [34.009729676456296, 1.167745125570901],
            [34.008538468168744, 1.161379108380974],
            [34.00753307370274, 1.159443293773474],
            [34.00739451036682, 1.154632882857637],
            [34.00790845181222, 1.151511846024836],
            [34.013695312634226, 1.150008065065845],
            [34.02498042893371, 1.150157778667843],
            [34.02885376950442, 1.151395654443966],
            [34.03140202316583, 1.150951478694267],
            [34.03242618972631, 1.151493855505265],
            [34.033161446413324, 1.153040425449698],
            [34.03645562425574, 1.154133763426575],
            [34.03804736617566, 1.15385275644495],
            [34.042743177271056, 1.152439876821988],
            [34.04600364942567, 1.152004472408906],
            [34.047142906343716, 1.150864278858556],
            [34.04856695166472, 1.148213332526587],
            [34.05162199079198, 1.146674415673026],
            [34.054942599764985, 1.143317198890283],
            [34.057230599810495, 1.142120655469563],
            [34.05816148800684, 1.144161503603122],
            [34.05825795000036, 1.147168832875043],
            [34.060261512884175, 1.150079467643249],
            [34.05963804075448, 1.152938086741042],
            [34.061582456763375, 1.157928302038144],
            [34.06169722821904, 1.164475870475534],
            [34.06492892014858, 1.167537996424118],
            [34.0672309563704, 1.172472047574316],
            [34.06786753402176, 1.174743316047404],
            [34.06942524147051, 1.175286597189587],
            [34.07251976784272, 1.179674449950275],
            [34.07681703058253, 1.187732505443663],
            [34.07816806263388, 1.191024611997785],
            [34.07916556809504, 1.192299661803391],
            [34.059716931701075, 1.196992990057585],
            [34.04772549794147, 1.200769736091449],
            [34.0452256077783, 1.202896465253563],
            [34.039030266826906, 1.209475164856084],
            [34.03642177932909, 1.211149649733247],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1060,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "KAKORO",
        Population: 17305,
        Key: "BUTEBOKAKORO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.247746609559954, 1.334371422466434],
            [33.18552980142826, 1.348002126114918],
            [33.15252493611837, 1.355676527513403],
            [33.15124401308336, 1.356436579475382],
            [33.14779725818657, 1.348249006427886],
            [33.125459098154785, 1.300055358902702],
            [33.120742344635154, 1.293740579917604],
            [33.095586218066096, 1.263939849302308],
            [33.089632135853904, 1.255037515952309],
            [33.068800013074025, 1.254811969857399],
            [33.064121221460006, 1.252577403946486],
            [33.0544903779091, 1.249800099033055],
            [33.05140686847553, 1.248207834505112],
            [33.05113491969292, 1.246398377244072],
            [33.049244990099275, 1.245728912516814],
            [33.046305588403605, 1.243937597939583],
            [33.03900649644578, 1.236437492889272],
            [33.029632929493886, 1.223662804357176],
            [33.03030428272651, 1.223590419350499],
            [33.03633487265479, 1.218406231657854],
            [33.040467997022525, 1.215538172655429],
            [33.045942931336896, 1.210417303646],
            [33.05211271881172, 1.201568917309886],
            [33.05512276761458, 1.198610385602849],
            [33.059239588458226, 1.197569857382991],
            [33.07413699939842, 1.197008558954824],
            [33.07752039162664, 1.196185158612464],
            [33.07944955693694, 1.194755628586281],
            [33.08153712487627, 1.19261135370745],
            [33.08553746207531, 1.18601574238357],
            [33.086179267921636, 1.184658626358159],
            [33.08889096825236, 1.173448923298988],
            [33.089924321883224, 1.171530860401702],
            [33.09206917089663, 1.169495145895778],
            [33.09560672390907, 1.168382207715466],
            [33.113529492741236, 1.16825487195004],
            [33.11629242489092, 1.167642192832999],
            [33.12227892640337, 1.179050621315761],
            [33.11864723533903, 1.18779623170903],
            [33.11827164612549, 1.191121096258993],
            [33.11723844520821, 1.192602352741907],
            [33.115593177172066, 1.193762164001943],
            [33.11432619419369, 1.196509142636277],
            [33.11712036705399, 1.19783343286317],
            [33.11926461419615, 1.196083810313441],
            [33.121668803238805, 1.194906451667799],
            [33.1300023330941, 1.193205590705456],
            [33.133235394954454, 1.200228071183108],
            [33.135477306934305, 1.202620072329745],
            [33.13690689575893, 1.203388482614949],
            [33.1394085511116, 1.202227454888126],
            [33.142576281196305, 1.201802171054095],
            [33.14636123383128, 1.199856233161329],
            [33.154971327114765, 1.205414997001728],
            [33.15679074165356, 1.205169631566498],
            [33.15744055148905, 1.205431204411802],
            [33.15968250838466, 1.208177990796466],
            [33.162427959318904, 1.209207921700279],
            [33.16190833692766, 1.212821458992154],
            [33.16246112152595, 1.220458838418518],
            [33.16187637486983, 1.221668826939351],
            [33.15870879660043, 1.224955510059566],
            [33.15853031931977, 1.228657319292357],
            [33.15789831229658, 1.229367118789634],
            [33.16156406028995, 1.238622265359265],
            [33.16657813640566, 1.242883220536156],
            [33.167593349457704, 1.243435039785938],
            [33.16865740211511, 1.243389734941929],
            [33.16962980954557, 1.242204479296953],
            [33.171032435436935, 1.239164502715587],
            [33.17290258592466, 1.233437454807976],
            [33.17602312840581, 1.233708666983498],
            [33.179667446189754, 1.232414661464758],
            [33.17984938737415, 1.235382154219552],
            [33.18196022706921, 1.237598591174269],
            [33.187389179319084, 1.241316636718676],
            [33.1903952917044, 1.240013613445891],
            [33.190754980737445, 1.237996046937155],
            [33.19062665819573, 1.222887120642871],
            [33.19105932187085, 1.220037200186213],
            [33.19294319053129, 1.218354273173462],
            [33.20169913428428, 1.215259462988461],
            [33.204468468727015, 1.214707370278892],
            [33.203397606839744, 1.202385081696197],
            [33.20266910817863, 1.200575683317356],
            [33.20172571543356, 1.194803599868721],
            [33.19939237472072, 1.191809127943421],
            [33.19748050197964, 1.190470270877675],
            [33.196243317017505, 1.188778521316999],
            [33.1959626096609, 1.187475734967333],
            [33.19209304740428, 1.184209945489176],
            [33.19225161891656, 1.182237628936117],
            [33.18836034348119, 1.173371572119488],
            [33.188859966679296, 1.172059684113986],
            [33.193997286262096, 1.164613428026303],
            [33.19599855934025, 1.163265245186488],
            [33.19729963428201, 1.162957546679862],
            [33.2088286710289, 1.163697666078431],
            [33.20954214177364, 1.167688373714814],
            [33.21105149919885, 1.169262483092497],
            [33.21407348930679, 1.171098844871881],
            [33.21523162521887, 1.171243511676543],
            [33.22166523711286, 1.175151419298806],
            [33.22442984731549, 1.175829739914664],
            [33.22841404358552, 1.175811319347787],
            [33.2320050840866, 1.176960021534769],
            [33.23406397870038, 1.176272257398923],
            [33.235982364227276, 1.174878819079684],
            [33.23831804505143, 1.172173493011433],
            [33.24073196734017, 1.171295702768909],
            [33.242009579185044, 1.166048192577455],
            [33.24283980845882, 1.165007688083518],
            [33.24570421609963, 1.163469407225759],
            [33.24840128826429, 1.162863004100038],
            [33.25816453450492, 1.162898308702754],
            [33.261114482422045, 1.163142310925723],
            [33.26361112427714, 1.163956326610833],
            [33.26452968219785, 1.164390506833043],
            [33.26540506798436, 1.165747506968639],
            [33.26528337051788, 1.167991229893061],
            [33.26630479901337, 1.169094894155644],
            [33.26715889921919, 1.171076153676881],
            [33.26787915224431, 1.171546539013505],
            [33.261931448070676, 1.188610173743668],
            [33.260973519685976, 1.193730994736354],
            [33.26098061637675, 1.197485592258474],
            [33.258965312512125, 1.201737981684866],
            [33.258366712936024, 1.204606009474988],
            [33.25867415415552, 1.206089725789232],
            [33.258269150506294, 1.206614503154799],
            [33.258610982828095, 1.209382922142285],
            [33.25822594064281, 1.213047084987199],
            [33.25957009609064, 1.222492258169419],
            [33.259160383472704, 1.226626879654944],
            [33.25824101257665, 1.229657789796247],
            [33.25564256105717, 1.234082135790933],
            [33.25112892560645, 1.238479523180135],
            [33.24925825140092, 1.239746314060069],
            [33.24770509661402, 1.242134930109326],
            [33.24383442134476, 1.255706143970456],
            [33.242344856500196, 1.265404918550598],
            [33.241653116002176, 1.27578216052625],
            [33.24194756129447, 1.282377566292181],
            [33.24690626345942, 1.324464794536856],
            [33.247746609559954, 1.334371422466434],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1061,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "BUYENDE",
        Population: 43263,
        Key: "BUYENDEBUYENDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.75730203867468, 1.316435769404738],
            [33.750960224721254, 1.316573401678617],
            [33.74485824657566, 1.320374796473446],
            [33.74203777373876, 1.32293581999962],
            [33.73639507545182, 1.335448907076486],
            [33.73357168039532, 1.339593085853775],
            [33.7310956081636, 1.342353035902361],
            [33.728344002871346, 1.344253643216723],
            [33.7246407771643, 1.344408547378716],
            [33.71042046957289, 1.34291102481596],
            [33.70281550036247, 1.341483092709318],
            [33.704140648357225, 1.334034886247191],
            [33.7022290666703, 1.317793498899169],
            [33.70125852324406, 1.301030872872872],
            [33.701450149165524, 1.284466774025547],
            [33.70097618185196, 1.282375749455511],
            [33.69892387009259, 1.278961642563445],
            [33.69617463635267, 1.275597743490819],
            [33.689413371145335, 1.2731750125531],
            [33.685050641882555, 1.269484213808066],
            [33.681821023264675, 1.265507967903682],
            [33.6791880009798, 1.264186238532029],
            [33.67842093045698, 1.26332612675673],
            [33.676643707990465, 1.26388371286844],
            [33.67553339029932, 1.263297384062491],
            [33.6727998914499, 1.264394521501663],
            [33.66995165887408, 1.264541919798811],
            [33.666298475616586, 1.26438922901865],
            [33.663973487439264, 1.263449798293044],
            [33.6621278385009, 1.263266740096731],
            [33.65879075532389, 1.265152989080558],
            [33.656923541428846, 1.267116724383819],
            [33.65412085074299, 1.26920898815351],
            [33.65915176398207, 1.263205894027821],
            [33.66462262174164, 1.260038142432073],
            [33.671790892943, 1.258127436307895],
            [33.68375843421097, 1.256604460709452],
            [33.69126238337609, 1.253906565594166],
            [33.697084471632, 1.250938008753246],
            [33.697615456813274, 1.251152527398153],
            [33.69834130095276, 1.250014283677199],
            [33.70022545437911, 1.249138814184675],
            [33.7018323688442, 1.247041643252647],
            [33.70289395023626, 1.246854869355429],
            [33.70571258961165, 1.244263429897529],
            [33.70871902000057, 1.242539301490369],
            [33.71112001912567, 1.242638164782745],
            [33.71343249826265, 1.24367790050001],
            [33.713580617876595, 1.245227555468437],
            [33.71409579360721, 1.246212011938023],
            [33.71619819722343, 1.248309003012889],
            [33.716267545366726, 1.249240783763408],
            [33.717189154864485, 1.250509083673479],
            [33.7169541528912, 1.25268774907769],
            [33.71738355837681, 1.254458466053162],
            [33.719086429083895, 1.257700263699363],
            [33.719326886525884, 1.259594292452804],
            [33.723196246661566, 1.260043205908941],
            [33.72594327773239, 1.261047739173122],
            [33.72885268557907, 1.263674083610716],
            [33.731906591032434, 1.264506392896982],
            [33.73308414402937, 1.265339233589303],
            [33.73387572418636, 1.267357144568784],
            [33.73391332137595, 1.270208446328926],
            [33.7358424642284, 1.272367394653478],
            [33.73729874469504, 1.274981431816353],
            [33.73673941407329, 1.275641992516037],
            [33.73637981127854, 1.27736094306841],
            [33.73495013531733, 1.279405879887684],
            [33.73351110160579, 1.280157160120889],
            [33.73541040422112, 1.287882377866404],
            [33.73972280087854, 1.294665967859206],
            [33.7407645115365, 1.294924166661371],
            [33.74239106676696, 1.294550289894543],
            [33.74490143128629, 1.29121769891409],
            [33.74762639703882, 1.28983819621828],
            [33.75045104165191, 1.287783677954111],
            [33.7527056342503, 1.288142042139635],
            [33.753547859626416, 1.289362508773721],
            [33.75435482343263, 1.29291727444766],
            [33.75574219054061, 1.295492050540487],
            [33.755000030300636, 1.297726877360679],
            [33.75507273544815, 1.299729420831004],
            [33.75541027651786, 1.302414240210081],
            [33.75687306707536, 1.307850754984635],
            [33.75730203867468, 1.316435769404738],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1062,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "AGULE",
        Population: 18132,
        Key: "PALLISAAGULE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.8812949585276, 1.267083642133559],
            [33.874379233397036, 1.268497222709429],
            [33.865126241017556, 1.268771747925575],
            [33.861671109330736, 1.269297595091851],
            [33.859393017702814, 1.270374868630719],
            [33.85659508359638, 1.27248359271981],
            [33.84838318652889, 1.280302348213526],
            [33.843333283803034, 1.284492479144752],
            [33.836070554749575, 1.291949074065245],
            [33.83380310007295, 1.294754194026181],
            [33.830837812524024, 1.292014129684792],
            [33.82501123359002, 1.284950829882205],
            [33.81852284422666, 1.279344175623779],
            [33.81765758514837, 1.275309764673215],
            [33.81553058745627, 1.270343184755235],
            [33.814384661445544, 1.264339160134977],
            [33.812768347907685, 1.260304739235831],
            [33.81174183494769, 1.258641298707927],
            [33.80912517367904, 1.256661728905261],
            [33.80712713094266, 1.254262115344878],
            [33.805128009329586, 1.252932913463162],
            [33.80136755015918, 1.247375037747118],
            [33.80166557793279, 1.247105395059246],
            [33.80128449282631, 1.245893641659923],
            [33.80150165156311, 1.243480173091364],
            [33.79954894590077, 1.241867478260111],
            [33.799757662270515, 1.241491656617499],
            [33.80188334662565, 1.241653026216668],
            [33.80350661492044, 1.240833428628945],
            [33.80006828622103, 1.237013221960761],
            [33.80542612603641, 1.235219492761363],
            [33.809141917377644, 1.233326734361634],
            [33.813874970828074, 1.232888955576044],
            [33.8144594902104, 1.232284230210096],
            [33.813717579702086, 1.229869142538213],
            [33.80961936566293, 1.223409540798509],
            [33.81143903801822, 1.220168946872987],
            [33.830370212469184, 1.225776836009591],
            [33.83814714797106, 1.224535043669043],
            [33.840520079235084, 1.22316829662997],
            [33.84220975009738, 1.223023020951631],
            [33.843800871281445, 1.222099790899785],
            [33.84861519621397, 1.220994610369235],
            [33.853502500280136, 1.223326996358641],
            [33.87314329709317, 1.227418577369118],
            [33.87334380286122, 1.23248441837005],
            [33.87565239947954, 1.240589097456031],
            [33.87811328389475, 1.245391831998899],
            [33.87911878885349, 1.247056003013814],
            [33.879604171059405, 1.247173440692255],
            [33.88117039363872, 1.255839209989275],
            [33.8812949585276, 1.267083642133559],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1063,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "OPWATETA",
        Population: 16799,
        Key: "BUTEBOOPWATETA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.26787915224431, 1.171546539013505],
            [33.26715889921919, 1.171076153676881],
            [33.26630479901337, 1.169094894155644],
            [33.26528337051788, 1.167991229893061],
            [33.26540506798436, 1.165747506968639],
            [33.26452968219785, 1.164390506833043],
            [33.26361112427714, 1.163956326610833],
            [33.261114482422045, 1.163142310925723],
            [33.25816453450492, 1.162898308702754],
            [33.24840128826429, 1.162863004100038],
            [33.24570421609963, 1.163469407225759],
            [33.24283980845882, 1.165007688083518],
            [33.242009579185044, 1.166048192577455],
            [33.24073196734017, 1.171295702768909],
            [33.23831804505143, 1.172173493011433],
            [33.235982364227276, 1.174878819079684],
            [33.23406397870038, 1.176272257398923],
            [33.2320050840866, 1.176960021534769],
            [33.22841404358552, 1.175811319347787],
            [33.22442984731549, 1.175829739914664],
            [33.22166523711286, 1.175151419298806],
            [33.21523162521887, 1.171243511676543],
            [33.21407348930679, 1.171098844871881],
            [33.21105149919885, 1.169262483092497],
            [33.20954214177364, 1.167688373714814],
            [33.2088286710289, 1.163697666078431],
            [33.20902185552736, 1.16291145912604],
            [33.20845745122088, 1.161681073393527],
            [33.2071832457876, 1.160649780316674],
            [33.2069017227607, 1.159699838698034],
            [33.20493251863986, 1.157655301380044],
            [33.20097379948961, 1.152227228421773],
            [33.194195077321346, 1.144564664330564],
            [33.192329608852894, 1.143533402776881],
            [33.19065154961394, 1.143298286831176],
            [33.186569445062766, 1.144664695129542],
            [33.183212230640265, 1.144655866452469],
            [33.18058949945527, 1.143914157787544],
            [33.179669797080855, 1.142891873773322],
            [33.17899646126637, 1.133175138731398],
            [33.17989609527733, 1.123096414215656],
            [33.18094253287035, 1.120563111788547],
            [33.182173066706106, 1.115333707981286],
            [33.18321594607225, 1.114365583759499],
            [33.18558701512873, 1.106810958024597],
            [33.185822138374554, 1.102613007416037],
            [33.182894855850364, 1.095474887361628],
            [33.180637455118394, 1.092236099774491],
            [33.175520774329236, 1.086518522971876],
            [33.1727705227981, 1.084826840894151],
            [33.168988927167355, 1.084320407584559],
            [33.16405827669375, 1.084754951727309],
            [33.16044493821068, 1.08438420798321],
            [33.15727510067834, 1.083651545626104],
            [33.152682219446504, 1.081408053353001],
            [33.14812170181943, 1.080304511310547],
            [33.14243317058841, 1.079680521228661],
            [33.14339510995082, 1.071646475618283],
            [33.14606043744995, 1.059921051474731],
            [33.14773850477374, 1.055406370751201],
            [33.14816465206979, 1.050448431333056],
            [33.14975820140007, 1.04664848981611],
            [33.151797849608855, 1.044088006920607],
            [33.15314800220955, 1.043065596397862],
            [33.15615393942336, 1.04171740069694],
            [33.160316584227935, 1.041111020379859],
            [33.164806812277284, 1.041997421253675],
            [33.169436683437574, 1.043698063577344],
            [33.17562358112362, 1.041978737589251],
            [33.17811013579637, 1.040322943419196],
            [33.18107381176765, 1.037002420191405],
            [33.18273041564436, 1.03149253011126],
            [33.18435793746203, 1.028307792062262],
            [33.185235348051165, 1.027267303454023],
            [33.19042270379529, 1.023430950060852],
            [33.1915728258367, 1.022055693979394],
            [33.193334217293, 1.017233389465843],
            [33.19505555197243, 1.014292920089825],
            [33.19680597230415, 1.013985205482077],
            [33.197565673048345, 1.012709492799385],
            [33.198584372461994, 1.011904223155007],
            [33.20014602980305, 1.011406526280751],
            [33.20207751725839, 1.009533620010003],
            [33.20396230399702, 1.006466475594307],
            [33.20751415549386, 1.004294904583951],
            [33.217859779533214, 0.994968014466181],
            [33.21937796649936, 0.992858382457165],
            [33.22574615948109, 0.986787238661487],
            [33.23306592796181, 0.988668557692979],
            [33.23335239711267, 0.988315694477996],
            [33.234700289552094, 0.990515737593295],
            [33.23691300179363, 0.991355316713555],
            [33.23814781340676, 0.99244994476886],
            [33.23900124436771, 0.994223143961006],
            [33.24094998666299, 0.994494418573558],
            [33.24180449380566, 0.995589072534259],
            [33.25030272527672, 0.995923180983951],
            [33.252014875580684, 0.994964040918558],
            [33.25400388306197, 0.992873974869086],
            [33.256617123545965, 0.992448550792678],
            [33.26040281459608, 0.992982039443268],
            [33.26323122315021, 0.990732651004122],
            [33.2658754537149, 0.987124945218075],
            [33.267670981151966, 0.985553606932717],
            [33.27148581534652, 0.985779524945445],
            [33.27524169490563, 0.988303459447614],
            [33.282070902392874, 0.988646626794013],
            [33.28670922759828, 0.98807625091921],
            [33.28875656358926, 0.987171718043655],
            [33.29023921050781, 0.987135313830702],
            [33.290949679082885, 0.987503174113634],
            [33.29572218474397, 0.987424678406849],
            [33.30062973773497, 0.985686546905743],
            [33.30181728089617, 0.985740721672207],
            [33.306892544859146, 0.984238417958406],
            [33.306771782538874, 0.984572937123235],
            [33.29920060884776, 0.997728507971518],
            [33.29879458381407, 0.999067531943847],
            [33.30017215479387, 1.000786373418549],
            [33.30366591852947, 1.00327402983108],
            [33.305244666318806, 1.005689483504267],
            [33.306931767999416, 1.007390197197933],
            [33.31009794399865, 1.014754312311658],
            [33.30997783295697, 1.0158490349277],
            [33.3102862838828, 1.016355648190063],
            [33.31647624931556, 1.022100007109038],
            [33.31695099097689, 1.022697074310124],
            [33.31700896195712, 1.023818920813114],
            [33.31650434771931, 1.027908300120237],
            [33.314419939154874, 1.030631712465322],
            [33.31420278490966, 1.033119712328872],
            [33.31304523469915, 1.035463050316094],
            [33.3130673593063, 1.037661515673992],
            [33.31239853123792, 1.039950521956086],
            [33.31329980018269, 1.042058427432122],
            [33.31296563408352, 1.042872708864212],
            [33.31078675419223, 1.044709506389946],
            [33.3105218796425, 1.047505115851587],
            [33.309257109214634, 1.050680807988411],
            [33.30693291694463, 1.054462766967585],
            [33.315220762077836, 1.056352793580949],
            [33.3204772153353, 1.056931271324384],
            [33.32126147781601, 1.057365453797874],
            [33.32274584411, 1.059247113166074],
            [33.32402594069495, 1.063128218651245],
            [33.328314829339654, 1.066927575962767],
            [33.33503182197654, 1.077303949770289],
            [33.34243244332443, 1.08687501814461],
            [33.352209417619264, 1.096726233418459],
            [33.358726548580165, 1.102135646600761],
            [33.35867799553737, 1.127929064661201],
            [33.36346665650053, 1.135281608535912],
            [33.35712809894001, 1.134557022276591],
            [33.351152476025646, 1.132460980246339],
            [33.34864907614469, 1.132810749102704],
            [33.345067299070806, 1.131045470228524],
            [33.34370748059768, 1.129179395528819],
            [33.337392511898216, 1.128483509638556],
            [33.333850876042796, 1.126565922177502],
            [33.3299149821856, 1.125562138247253],
            [33.326659188456965, 1.122694553704252],
            [33.325379465571174, 1.122649461544747],
            [33.3139553942703, 1.129191837473792],
            [33.31169526265988, 1.133389978206383],
            [33.30890913241628, 1.135977776606218],
            [33.308622188954956, 1.137144895075543],
            [33.30635803289204, 1.140583071775281],
            [33.30598795394444, 1.141831623352195],
            [33.30636624798533, 1.143885295280718],
            [33.30555625595826, 1.144744866342045],
            [33.30542278427332, 1.146925254098552],
            [33.30449319773588, 1.148400046684228],
            [33.304738524945, 1.152082227435905],
            [33.305355493272046, 1.153348768096428],
            [33.304541878339414, 1.157130583021254],
            [33.30458650754105, 1.159446659071701],
            [33.30207065162037, 1.162839629361426],
            [33.30019201115491, 1.162432708056762],
            [33.29954883268282, 1.163011797338607],
            [33.298525822254135, 1.162957623919066],
            [33.29430140390069, 1.164704180440153],
            [33.28314738683547, 1.172060715164156],
            [33.28112446256235, 1.172676130807656],
            [33.27762685044405, 1.173273599045089],
            [33.26787915224431, 1.171546539013505],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1064,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "BUGAYA",
        Population: 83945,
        Key: "BUYENDEBUGAYA",
        Dist2: "Dokolo",
        "Sub Country": "Adeknino",
        id2_original: "Dokolo Adeknino",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.428190469452375, 1.339937503668307],
            [33.42547983362527, 1.340535086319767],
            [33.4203218213499, 1.340445513771948],
            [33.4104971590899, 1.338954427047104],
            [33.4029556019554, 1.336847718263741],
            [33.39539593568311, 1.333881509049832],
            [33.401029711004284, 1.315967355130563],
            [33.40460524209202, 1.296099371919024],
            [33.4063427356668, 1.295076771203644],
            [33.41276334534536, 1.293637238922598],
            [33.42481606127532, 1.292567679853455],
            [33.44011266106987, 1.291967947361794],
            [33.44309400151292, 1.291216520623738],
            [33.45201583894607, 1.287514700466782],
            [33.45568168665245, 1.285017063075656],
            [33.47223609403312, 1.26940794669899],
            [33.492511600900045, 1.247908508726143],
            [33.4928625583085, 1.247058026438772],
            [33.50147944285551, 1.233332133781954],
            [33.50792623483135, 1.220294231640742],
            [33.51620243330689, 1.208884439434221],
            [33.52004297997983, 1.204287852494627],
            [33.52408540504658, 1.200813047832438],
            [33.52604698786053, 1.200134146878912],
            [33.52733057979026, 1.19982630247019],
            [33.53308326151237, 1.200494649714276],
            [33.53601945712079, 1.19952605071998],
            [33.53711266909231, 1.199543927767152],
            [33.53889608005283, 1.198448897564538],
            [33.54060854117389, 1.196512516870883],
            [33.540300245656596, 1.194241803316278],
            [33.54097848178095, 1.192287534478358],
            [33.54209614230123, 1.190948370487658],
            [33.543427367398884, 1.190088649195271],
            [33.54501993756549, 1.18985311232871],
            [33.54604460448759, 1.188982704840984],
            [33.549334797403375, 1.189408950753028],
            [33.55116541123881, 1.188449611980116],
            [33.55387644232467, 1.185318838494338],
            [33.5553633778004, 1.182188313841801],
            [33.566070014989506, 1.190138336869231],
            [33.58166094239702, 1.199181915069212],
            [33.58525036682892, 1.200547217464666],
            [33.59683794768119, 1.203195409872825],
            [33.61426896435375, 1.205607001726201],
            [33.62195067214731, 1.206184235460179],
            [33.623232730652816, 1.214036545040643],
            [33.624263818732565, 1.224838157617124],
            [33.623856994198256, 1.234047873011771],
            [33.62423600509474, 1.238064552634897],
            [33.62565650117204, 1.244115780785331],
            [33.62846565254142, 1.247470753009348],
            [33.628320471316776, 1.251113046872824],
            [33.62861592272215, 1.252170294900647],
            [33.63292181467858, 1.25562223901833],
            [33.63714250682016, 1.26059691922834],
            [33.64244950288879, 1.269361897784789],
            [33.64510962195591, 1.276571480520181],
            [33.64723059105411, 1.279845860182782],
            [33.64559478676949, 1.282451736874039],
            [33.633006939933196, 1.298078659875605],
            [33.630433238796414, 1.301915135807101],
            [33.6248637379338, 1.313378792918761],
            [33.62412125969022, 1.316463928645995],
            [33.61674539591158, 1.315895832169601],
            [33.60868098963732, 1.313916580696982],
            [33.593379715010016, 1.312409474207046],
            [33.579933317713945, 1.310313786548984],
            [33.57135368630177, 1.310560040177894],
            [33.57056896478195, 1.31101256303971],
            [33.56860231007987, 1.314297025829976],
            [33.56753794121549, 1.317789360557158],
            [33.56693658650643, 1.321706791239039],
            [33.5668507623625, 1.329677100337153],
            [33.565749535622004, 1.334137460413905],
            [33.56359192604, 1.337729567924525],
            [33.56249666770625, 1.338824492479604],
            [33.559429429457445, 1.339657513378092],
            [33.55707766789139, 1.339368553134211],
            [33.553958745971, 1.33773177987205],
            [33.553128720614765, 1.336637295782131],
            [33.5497053057457, 1.324859017223605],
            [33.546054990808905, 1.318291782888391],
            [33.54512054348742, 1.317468721653213],
            [33.54400366090815, 1.317324217336944],
            [33.53757555928013, 1.317226107716989],
            [33.53418080246524, 1.315453648872096],
            [33.52882993177983, 1.31130225942548],
            [33.52598076495611, 1.309891544142511],
            [33.523771665738664, 1.309340147780024],
            [33.512327957265676, 1.309831068296655],
            [33.509677009099285, 1.31070012004409],
            [33.50093779557013, 1.319766957390914],
            [33.49856342789995, 1.321594925058871],
            [33.4911167984365, 1.324726675969497],
            [33.48317891807336, 1.329676952155044],
            [33.47695999814238, 1.331035220427238],
            [33.47134935893131, 1.331642457728873],
            [33.46401929935072, 1.330730111817214],
            [33.45592954621239, 1.32912126289627],
            [33.453459162113084, 1.328470336377089],
            [33.449177506703, 1.324680418810376],
            [33.445403467700444, 1.322527911227246],
            [33.44049810031054, 1.321189831535895],
            [33.43602897817876, 1.32146203760018],
            [33.43405439225108, 1.322412327049328],
            [33.431312398932334, 1.336408600233271],
            [33.43039356343218, 1.338046279633127],
            [33.428190469452375, 1.339937503668307],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1065,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "GOGONYO",
        Population: 30406,
        Key: "PALLISAGOGONYO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.4928625583085, 1.247058026438772],
            [33.492511600900045, 1.247908508726143],
            [33.47223609403312, 1.26940794669899],
            [33.45568168665245, 1.285017063075656],
            [33.45201583894607, 1.287514700466782],
            [33.44309400151292, 1.291216520623738],
            [33.44011266106987, 1.291967947361794],
            [33.43235348346455, 1.247159222831946],
            [33.431121783615566, 1.245594285980407],
            [33.42756290549659, 1.239026702838862],
            [33.41837459810574, 1.233925632572742],
            [33.41615292786418, 1.231637073606828],
            [33.40348397393751, 1.212522532496026],
            [33.39863160984432, 1.203313311106199],
            [33.397802393870165, 1.199278426885518],
            [33.39780486783044, 1.196962368681428],
            [33.398487453597404, 1.193207722843498],
            [33.39810909847111, 1.191289793048186],
            [33.392618495741566, 1.17714091303846],
            [33.39060451329875, 1.174725890597484],
            [33.39319454401076, 1.170914375734624],
            [33.3950130153185, 1.166834238787686],
            [33.393053117744024, 1.15634713151046],
            [33.39206719965169, 1.154245880964424],
            [33.39217059843583, 1.15168765572408],
            [33.38913523151501, 1.146767432859347],
            [33.3881621925689, 1.143948310316537],
            [33.38853815009174, 1.142943247184878],
            [33.39061791795943, 1.140421572314901],
            [33.392462620971784, 1.134581183118353],
            [33.396590827961624, 1.131919046220256],
            [33.400281810529656, 1.13197597841545],
            [33.40311686302362, 1.133660603801538],
            [33.4036877486749, 1.13450303333425],
            [33.40694129661532, 1.135670597876044],
            [33.40966223432209, 1.137585005295049],
            [33.41167923959585, 1.139595249912886],
            [33.414190700059834, 1.14011188106943],
            [33.41689231230992, 1.139900860077099],
            [33.42058303436653, 1.138157858458194],
            [33.42259951592247, 1.13654913648391],
            [33.430417629298624, 1.127012319197069],
            [33.43566831537196, 1.124598897909153],
            [33.43943526037875, 1.123909005127691],
            [33.44382992115659, 1.122414801058997],
            [33.44993658311809, 1.119082134773846],
            [33.45239059003148, 1.117301004324262],
            [33.45744507596192, 1.115388439146162],
            [33.46229037211049, 1.127181510190794],
            [33.4666050675567, 1.13985569274144],
            [33.46775003057341, 1.147292154923188],
            [33.47032247317049, 1.154800751971789],
            [33.47270100183705, 1.164933007708925],
            [33.47493403666526, 1.171591227143182],
            [33.480420145123425, 1.199970722587512],
            [33.48119487917392, 1.21930401946848],
            [33.481904024530564, 1.223447415016463],
            [33.487716448710636, 1.237071119256905],
            [33.48886645217443, 1.240300680091794],
            [33.49004947950471, 1.245891495193963],
            [33.490871602381354, 1.247130777231939],
            [33.4928625583085, 1.247058026438772],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1066,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "BUKAMBA",
        Population: 26776,
        Key: "KALIROBUKAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.54427808185441, 0.89825850494617],
            [33.5367578588096, 0.905681198822415],
            [33.5332170529975, 0.912891528353457],
            [33.52771612323546, 0.918232359332328],
            [33.52418247160628, 0.920712742056776],
            [33.51855510127308, 0.922757674514482],
            [33.51633574778663, 0.92437426848927],
            [33.51269298139318, 0.925393351647104],
            [33.50827972099733, 0.926019069635207],
            [33.50497524217357, 0.925974898055628],
            [33.492422515871624, 0.924838145705533],
            [33.49200103801843, 0.924101505391994],
            [33.492408730325266, 0.921710286552534],
            [33.491838714243215, 0.918607246404865],
            [33.489243964681016, 0.912691502519274],
            [33.485135133453525, 0.913722210833945],
            [33.483252947337625, 0.913285089586807],
            [33.48232384229712, 0.911040797646678],
            [33.48403513111674, 0.904649406775379],
            [33.484605661933465, 0.903284925207129],
            [33.48670980378977, 0.900591738707116],
            [33.49098313181716, 0.896678369988006],
            [33.489990132305465, 0.893098438171253],
            [33.48939922140986, 0.892170792294991],
            [33.490178988720885, 0.891635461253063],
            [33.49292858088861, 0.886489702619258],
            [33.49961941188949, 0.88105991415329],
            [33.50079566951576, 0.878932051752967],
            [33.5024949218089, 0.878404450588905],
            [33.50653802240873, 0.875834664523928],
            [33.50808844811379, 0.873436152047569],
            [33.5093858884719, 0.874193165919687],
            [33.51311179753817, 0.877676896157337],
            [33.514712254913, 0.878440909819282],
            [33.52091708836199, 0.879587729425691],
            [33.531388543914765, 0.886601119003179],
            [33.53371469900365, 0.887233878454903],
            [33.541575810240914, 0.887425625110082],
            [33.54139443948671, 0.891848248165919],
            [33.541674462327094, 0.893811389237071],
            [33.5432261196224, 0.896799243266624],
            [33.54427808185441, 0.89825850494617],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1067,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "KALIRO TOWN COUNCIL",
        Population: 16753,
        Key: "KALIROKALIRO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.2088286710289, 1.163697666078431],
            [33.19729963428201, 1.162957546679862],
            [33.19599855934025, 1.163265245186488],
            [33.193997286262096, 1.164613428026303],
            [33.188859966679296, 1.172059684113986],
            [33.18836034348119, 1.173371572119488],
            [33.19225161891656, 1.182237628936117],
            [33.19209304740428, 1.184209945489176],
            [33.1959626096609, 1.187475734967333],
            [33.196243317017505, 1.188778521316999],
            [33.19748050197964, 1.190470270877675],
            [33.19939237472072, 1.191809127943421],
            [33.20172571543356, 1.194803599868721],
            [33.20266910817863, 1.200575683317356],
            [33.203397606839744, 1.202385081696197],
            [33.204468468727015, 1.214707370278892],
            [33.20169913428428, 1.215259462988461],
            [33.19294319053129, 1.218354273173462],
            [33.19105932187085, 1.220037200186213],
            [33.19062665819573, 1.222887120642871],
            [33.190754980737445, 1.237996046937155],
            [33.1903952917044, 1.240013613445891],
            [33.187389179319084, 1.241316636718676],
            [33.18196022706921, 1.237598591174269],
            [33.17984938737415, 1.235382154219552],
            [33.179667446189754, 1.232414661464758],
            [33.17602312840581, 1.233708666983498],
            [33.17290258592466, 1.233437454807976],
            [33.171032435436935, 1.239164502715587],
            [33.16962980954557, 1.242204479296953],
            [33.16865740211511, 1.243389734941929],
            [33.167593349457704, 1.243435039785938],
            [33.16657813640566, 1.242883220536156],
            [33.16156406028995, 1.238622265359265],
            [33.15789831229658, 1.229367118789634],
            [33.15853031931977, 1.228657319292357],
            [33.15870879660043, 1.224955510059566],
            [33.16187637486983, 1.221668826939351],
            [33.16246112152595, 1.220458838418518],
            [33.16190833692766, 1.212821458992154],
            [33.162427959318904, 1.209207921700279],
            [33.15968250838466, 1.208177990796466],
            [33.15744055148905, 1.205431204411802],
            [33.15679074165356, 1.205169631566498],
            [33.154971327114765, 1.205414997001728],
            [33.14636123383128, 1.199856233161329],
            [33.142576281196305, 1.201802171054095],
            [33.1394085511116, 1.202227454888126],
            [33.13690689575893, 1.203388482614949],
            [33.135477306934305, 1.202620072329745],
            [33.133235394954454, 1.200228071183108],
            [33.1300023330941, 1.193205590705456],
            [33.121668803238805, 1.194906451667799],
            [33.11926461419615, 1.196083810313441],
            [33.11712036705399, 1.19783343286317],
            [33.11432619419369, 1.196509142636277],
            [33.115593177172066, 1.193762164001943],
            [33.11723844520821, 1.192602352741907],
            [33.11827164612549, 1.191121096258993],
            [33.11864723533903, 1.18779623170903],
            [33.12227892640337, 1.179050621315761],
            [33.11629242489092, 1.167642192832999],
            [33.11913609761834, 1.167006110138232],
            [33.12332384494523, 1.1645179209106],
            [33.12502316012044, 1.162364587558677],
            [33.12592781301888, 1.159948918332818],
            [33.12702074022446, 1.152982449142753],
            [33.12973687553775, 1.125695670397062],
            [33.13177754782597, 1.113228399457295],
            [33.13225311503906, 1.107401916684915],
            [33.13592730629778, 1.098761577876879],
            [33.137945947403686, 1.090474159326182],
            [33.14216390597187, 1.081915218247588],
            [33.14243317058841, 1.079680521228661],
            [33.14812170181943, 1.080304511310547],
            [33.152682219446504, 1.081408053353001],
            [33.15727510067834, 1.083651545626104],
            [33.16044493821068, 1.08438420798321],
            [33.16405827669375, 1.084754951727309],
            [33.168988927167355, 1.084320407584559],
            [33.1727705227981, 1.084826840894151],
            [33.175520774329236, 1.086518522971876],
            [33.180637455118394, 1.092236099774491],
            [33.182894855850364, 1.095474887361628],
            [33.185822138374554, 1.102613007416037],
            [33.18558701512873, 1.106810958024597],
            [33.18321594607225, 1.114365583759499],
            [33.182173066706106, 1.115333707981286],
            [33.18094253287035, 1.120563111788547],
            [33.17989609527733, 1.123096414215656],
            [33.17899646126637, 1.133175138731398],
            [33.179669797080855, 1.142891873773322],
            [33.18058949945527, 1.143914157787544],
            [33.183212230640265, 1.144655866452469],
            [33.186569445062766, 1.144664695129542],
            [33.19065154961394, 1.143298286831176],
            [33.192329608852894, 1.143533402776881],
            [33.194195077321346, 1.144564664330564],
            [33.20097379948961, 1.152227228421773],
            [33.20493251863986, 1.157655301380044],
            [33.2069017227607, 1.159699838698034],
            [33.2071832457876, 1.160649780316674],
            [33.20845745122088, 1.161681073393527],
            [33.20902185552736, 1.16291145912604],
            [33.2088286710289, 1.163697666078431],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1068,
        District: "BUYENDE",
        County: "BUDIOPE",
        Subcounty: "BUYENDE TOWN COUNCIL",
        Population: 23201,
        Key: "BUYENDEBUYENDE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.65412085074299, 1.26920898815351],
            [33.656923541428846, 1.267116724383819],
            [33.65879075532389, 1.265152989080558],
            [33.6621278385009, 1.263266740096731],
            [33.663973487439264, 1.263449798293044],
            [33.666298475616586, 1.26438922901865],
            [33.66995165887408, 1.264541919798811],
            [33.6727998914499, 1.264394521501663],
            [33.67553339029932, 1.263297384062491],
            [33.676643707990465, 1.26388371286844],
            [33.67842093045698, 1.26332612675673],
            [33.6791880009798, 1.264186238532029],
            [33.681821023264675, 1.265507967903682],
            [33.685050641882555, 1.269484213808066],
            [33.689413371145335, 1.2731750125531],
            [33.69617463635267, 1.275597743490819],
            [33.69892387009259, 1.278961642563445],
            [33.70097618185196, 1.282375749455511],
            [33.701450149165524, 1.284466774025547],
            [33.70125852324406, 1.301030872872872],
            [33.7022290666703, 1.317793498899169],
            [33.704140648357225, 1.334034886247191],
            [33.70281550036247, 1.341483092709318],
            [33.697973376165194, 1.340300163022373],
            [33.696312357068884, 1.33895269107781],
            [33.686320106007784, 1.325611711844848],
            [33.68292626277954, 1.323170057924226],
            [33.67534642753248, 1.316007180414759],
            [33.67197480233617, 1.314642049778187],
            [33.66302881100164, 1.314047378728329],
            [33.65031952271873, 1.311707646430907],
            [33.63673044151452, 1.315899816045304],
            [33.63284415711886, 1.316525039272593],
            [33.62412125969022, 1.316463928645995],
            [33.6248637379338, 1.313378792918761],
            [33.630433238796414, 1.301915135807101],
            [33.633006939933196, 1.298078659875605],
            [33.64559478676949, 1.282451736874039],
            [33.64723059105411, 1.279845860182782],
            [33.65412085074299, 1.26920898815351],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1069,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "CHELEKURA",
        Population: 11738,
        Key: "PALLISACHELEKURA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.76957542934745, 1.316406060978252],
            [33.75730203867468, 1.316435769404738],
            [33.75687306707536, 1.307850754984635],
            [33.75541027651786, 1.302414240210081],
            [33.75507273544815, 1.299729420831004],
            [33.755000030300636, 1.297726877360679],
            [33.75574219054061, 1.295492050540487],
            [33.75435482343263, 1.29291727444766],
            [33.753547859626416, 1.289362508773721],
            [33.7527056342503, 1.288142042139635],
            [33.75045104165191, 1.287783677954111],
            [33.74762639703882, 1.28983819621828],
            [33.74490143128629, 1.29121769891409],
            [33.74239106676696, 1.294550289894543],
            [33.7407645115365, 1.294924166661371],
            [33.73972280087854, 1.294665967859206],
            [33.73541040422112, 1.287882377866404],
            [33.73351110160579, 1.280157160120889],
            [33.73495013531733, 1.279405879887684],
            [33.73637981127854, 1.27736094306841],
            [33.73673941407329, 1.275641992516037],
            [33.73729874469504, 1.274981431816353],
            [33.7358424642284, 1.272367394653478],
            [33.73391332137595, 1.270208446328926],
            [33.73387572418636, 1.267357144568784],
            [33.73308414402937, 1.265339233589303],
            [33.731906591032434, 1.264506392896982],
            [33.72885268557907, 1.263674083610716],
            [33.72594327773239, 1.261047739173122],
            [33.723196246661566, 1.260043205908941],
            [33.719326886525884, 1.259594292452804],
            [33.719086429083895, 1.257700263699363],
            [33.71738355837681, 1.254458466053162],
            [33.7169541528912, 1.25268774907769],
            [33.717189154864485, 1.250509083673479],
            [33.716267545366726, 1.249240783763408],
            [33.71619819722343, 1.248309003012889],
            [33.71409579360721, 1.246212011938023],
            [33.713580617876595, 1.245227555468437],
            [33.71343249826265, 1.24367790050001],
            [33.71112001912567, 1.242638164782745],
            [33.7165287440103, 1.238773790102747],
            [33.72310254608922, 1.234936233537606],
            [33.730210962543175, 1.232591209631455],
            [33.73495867110915, 1.229577384843378],
            [33.73583345322778, 1.230038516784514],
            [33.737314798487496, 1.230943178409536],
            [33.73911896592095, 1.231349352202023],
            [33.74243880144453, 1.230832767706781],
            [33.74313042516155, 1.231203482420625],
            [33.74640379083545, 1.231256839009832],
            [33.75160970038346, 1.233704352477252],
            [33.7556600117601, 1.233904841396249],
            [33.75753197235311, 1.2345918401581],
            [33.759106438771816, 1.23413001387036],
            [33.76389088753458, 1.236055539104973],
            [33.7656498894722, 1.237901704535109],
            [33.7670101175771, 1.237712434156028],
            [33.7636072022628, 1.243173291027758],
            [33.764474652332076, 1.245623117781316],
            [33.76398590144388, 1.24661514331235],
            [33.76362188432782, 1.249258736817724],
            [33.760618642958164, 1.258100630755262],
            [33.760489894615, 1.262059186501249],
            [33.76447389684892, 1.266154918585516],
            [33.774001654229444, 1.267526559508137],
            [33.775125275071645, 1.267819942135848],
            [33.77700794358285, 1.269111737946641],
            [33.781649876422435, 1.275395934876399],
            [33.782089923350895, 1.282988463401541],
            [33.782105030319016, 1.284684687364758],
            [33.781711215186675, 1.285184133736647],
            [33.774212608302555, 1.289756726194302],
            [33.77287056389564, 1.290976079324015],
            [33.77221442363233, 1.292555028506044],
            [33.77071284921074, 1.296990671280015],
            [33.77099188210765, 1.302903177316251],
            [33.76957542934745, 1.316406060978252],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1070,
        District: "PALLISA",
        County: "AGULE",
        Subcounty: "AKISIM",
        Population: 13055,
        Key: "PALLISAAKISIM",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.81143903801822, 1.220168946872987],
            [33.80961936566293, 1.223409540798509],
            [33.813717579702086, 1.229869142538213],
            [33.8144594902104, 1.232284230210096],
            [33.813874970828074, 1.232888955576044],
            [33.809141917377644, 1.233326734361634],
            [33.80542612603641, 1.235219492761363],
            [33.80006828622103, 1.237013221960761],
            [33.80350661492044, 1.240833428628945],
            [33.80188334662565, 1.241653026216668],
            [33.799757662270515, 1.241491656617499],
            [33.79954894590077, 1.241867478260111],
            [33.80150165156311, 1.243480173091364],
            [33.80128449282631, 1.245893641659923],
            [33.80166557793279, 1.247105395059246],
            [33.80136755015918, 1.247375037747118],
            [33.78050328206516, 1.240682459930147],
            [33.77631643485019, 1.238413035536075],
            [33.77497294235904, 1.237237389190966],
            [33.76996496310917, 1.237419789992775],
            [33.76871793530647, 1.238005981781251],
            [33.7670101175771, 1.237712434156028],
            [33.7656498894722, 1.237901704535109],
            [33.76389088753458, 1.236055539104973],
            [33.759106438771816, 1.23413001387036],
            [33.75753197235311, 1.2345918401581],
            [33.7556600117601, 1.233904841396249],
            [33.75160970038346, 1.233704352477252],
            [33.74640379083545, 1.231256839009832],
            [33.74313042516155, 1.231203482420625],
            [33.74243880144453, 1.230832767706781],
            [33.73911896592095, 1.231349352202023],
            [33.737314798487496, 1.230943178409536],
            [33.73583345322778, 1.230038516784514],
            [33.738461655152825, 1.222972419601668],
            [33.73858741749597, 1.220665511827532],
            [33.73783339410436, 1.215997693997446],
            [33.73538651532277, 1.210208562890269],
            [33.73577940968197, 1.208978122741945],
            [33.73824097861342, 1.20780143605727],
            [33.73946956130834, 1.205298319093974],
            [33.74137897895379, 1.202870160295355],
            [33.74309078430468, 1.201358915816292],
            [33.745088233254684, 1.198798192999161],
            [33.74829450825162, 1.196047162544863],
            [33.74854737052936, 1.196327535699935],
            [33.74930793006298, 1.196155441633641],
            [33.75018732772553, 1.19711413287059],
            [33.750715379907405, 1.197150172598224],
            [33.75212526149134, 1.198823392412481],
            [33.753861382440355, 1.199989913578803],
            [33.7576101653087, 1.200857334928857],
            [33.760247168028606, 1.203461993503047],
            [33.76249230675693, 1.204881663945624],
            [33.762755164588846, 1.20473684532426],
            [33.76417011806086, 1.202402445899605],
            [33.76863342629609, 1.197199444315391],
            [33.770286773779894, 1.193643702828417],
            [33.77052156914065, 1.191581034850901],
            [33.76985384150851, 1.188206879219239],
            [33.76831080714161, 1.184416828211079],
            [33.767949083424476, 1.182517164646298],
            [33.76803927068573, 1.179558932226928],
            [33.772200138622686, 1.179729654093978],
            [33.780042675394796, 1.177972430022777],
            [33.78393736981811, 1.178514116363765],
            [33.78674008835175, 1.181218211240982],
            [33.79239503247262, 1.182890183346731],
            [33.79621302155047, 1.186290542809612],
            [33.7973170133054, 1.188850364784088],
            [33.79773206730602, 1.1924959577704],
            [33.80220526329761, 1.194629603488708],
            [33.80369033207416, 1.195968036413833],
            [33.80778832512774, 1.205845507309361],
            [33.80585398731801, 1.21256757471578],
            [33.80637473889161, 1.219035915995019],
            [33.81143903801822, 1.220168946872987],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1071,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "KIBALE",
        Population: 16410,
        Key: "BUTEBOKIBALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.68970622372456, 1.171881841423888],
            [33.68500959516228, 1.171307686485165],
            [33.68572072849064, 1.166353128101357],
            [33.68575556425905, 1.163126675377266],
            [33.68482878226191, 1.160043857085989],
            [33.6838621779482, 1.15888182599973],
            [33.68299405414246, 1.1594020650531],
            [33.68154648463911, 1.159199808554944],
            [33.68096598342106, 1.159484601528839],
            [33.67891759280791, 1.161141080371934],
            [33.67669309736479, 1.16197481868298],
            [33.67376533514025, 1.164329313657431],
            [33.669635159043295, 1.166338281128156],
            [33.66617484677225, 1.167384101154748],
            [33.66339252358882, 1.167564285551605],
            [33.658790758018846, 1.16688319669765],
            [33.65448594314244, 1.166881628564415],
            [33.655089742167405, 1.164675557944985],
            [33.65042748224957, 1.165957439308764],
            [33.639845811496244, 1.165539484934158],
            [33.62246368383638, 1.161384833964466],
            [33.61601667806151, 1.160095663087642],
            [33.61284671745997, 1.159988808829789],
            [33.60600777852327, 1.158054397051394],
            [33.595192489202226, 1.157293223062983],
            [33.59779321166273, 1.151800185601653],
            [33.598840202617964, 1.148525013164144],
            [33.60296977774199, 1.130186235481801],
            [33.60533655913958, 1.125345693213848],
            [33.606454645461326, 1.123617517468141],
            [33.61000887659536, 1.121101758027734],
            [33.612124890586465, 1.120639925509371],
            [33.61298087725439, 1.120069796556422],
            [33.61440718093999, 1.120187103094852],
            [33.61559562511144, 1.119155516725591],
            [33.61683257830822, 1.116386934695041],
            [33.6210288955629, 1.114024831872053],
            [33.623264505861044, 1.110677044760611],
            [33.62632972469709, 1.104262223085257],
            [33.64657973737625, 1.113349826961194],
            [33.6637161937722, 1.120529074844556],
            [33.673615515913795, 1.124244986730851],
            [33.67727545540056, 1.125058334457062],
            [33.6826951954272, 1.125274180451014],
            [33.692329745427, 1.123417324181166],
            [33.69412986056025, 1.131766956088704],
            [33.69463109982753, 1.137158640185043],
            [33.69336635455248, 1.154718506354789],
            [33.69197332805825, 1.159775930175221],
            [33.69274402418152, 1.166578826154381],
            [33.68970622372456, 1.171881841423888],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1072,
        District: "PALLISA",
        County: "PALLISA",
        Subcounty: "KASODO",
        Population: 14333,
        Key: "PALLISAKASODO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.009119362848914, 1.206776058068643],
            [34.00366122882699, 1.207568532193682],
            [33.999923494338326, 1.209462847206835],
            [33.993492419286675, 1.215562199875976],
            [33.99229309561885, 1.216928583451069],
            [33.99128846292422, 1.219217583383588],
            [33.98599633936347, 1.22177050748256],
            [33.98275713841645, 1.22393369330727],
            [33.97993491835629, 1.225083576050461],
            [33.976881594112925, 1.22559127575893],
            [33.97246304264007, 1.225430070437884],
            [33.96080923978172, 1.227566138496755],
            [33.95240652617483, 1.231145403578959],
            [33.94928955809021, 1.23128221594576],
            [33.94124912695255, 1.230027685598606],
            [33.94274318786512, 1.228055106774042],
            [33.944732286974535, 1.226534656388556],
            [33.95143151901995, 1.223637522548684],
            [33.95311761189248, 1.221474910378322],
            [33.955083208379136, 1.217051112959995],
            [33.95950953566906, 1.214769739763925],
            [33.96036717703377, 1.21383679198768],
            [33.960830107645755, 1.212783087069704],
            [33.96125774524689, 1.208966017045629],
            [33.96213250670424, 1.207929438198015],
            [33.96323042494956, 1.207134575189813],
            [33.966364559839256, 1.206869855509777],
            [33.96736181826371, 1.205874435636677],
            [33.96786877261283, 1.205096295857179],
            [33.968051863640774, 1.203422717044425],
            [33.970167042198646, 1.201142362536503],
            [33.970742503867974, 1.197116680834807],
            [33.970593046662586, 1.19540703762992],
            [33.97173256319377, 1.193235587929769],
            [33.973302809327244, 1.190765468991299],
            [33.9745135128531, 1.189769976804695],
            [33.977790708045085, 1.190230152726094],
            [33.983960447010865, 1.186763329849991],
            [33.98665799528262, 1.185785395422106],
            [33.98802424748979, 1.184690341785154],
            [33.991508657966676, 1.183467881692208],
            [33.9934168116825, 1.182298396009226],
            [33.99447183806791, 1.180789210418599],
            [33.995963940653176, 1.176636583078119],
            [33.99649733870931, 1.169671013753573],
            [33.99736506815462, 1.167911176992012],
            [33.996634864491085, 1.163040286927381],
            [33.99672411391121, 1.16126724978691],
            [33.99972390485185, 1.157313106808187],
            [34.005004531773615, 1.153156704980531],
            [34.00790845181222, 1.151511846024836],
            [34.00739451036682, 1.154632882857637],
            [34.00753307370274, 1.159443293773474],
            [34.008538468168744, 1.161379108380974],
            [34.009729676456296, 1.167745125570901],
            [34.01227322743719, 1.172583542879433],
            [34.01076815856916, 1.173768797459544],
            [34.01005708452958, 1.175477236165856],
            [34.012111694179424, 1.179232578758141],
            [34.013128022939064, 1.179472986161069],
            [34.01252329415777, 1.182846299218993],
            [34.01129249262408, 1.185519224111686],
            [34.011649969106536, 1.189996175010605],
            [34.013704399093335, 1.194001367559084],
            [34.01194270759977, 1.197202030000537],
            [34.009119362848914, 1.206776058068643],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1073,
        District: "BUTEBO",
        County: "BUTEBO",
        Subcounty: "KANGINIMA",
        Population: 9887,
        Key: "BUTEBOKANGINIMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.05104375153179, 1.252537080126123],
            [34.049102561373104, 1.251986477916047],
            [34.04773427807503, 1.252113670544828],
            [34.04643226439381, 1.251235786758788],
            [34.04226957287685, 1.251220333133352],
            [34.03798678828446, 1.253374951309637],
            [34.03451163943818, 1.253846721586659],
            [34.02839336944659, 1.256581000560886],
            [34.02713287140622, 1.256572454248382],
            [34.0221024738001, 1.259347486070543],
            [34.01703149749598, 1.260573903674136],
            [34.01835938535233, 1.262576971014023],
            [34.01929261006669, 1.265353005894974],
            [34.019893134732435, 1.265766209158505],
            [34.01968823979595, 1.267022509661623],
            [34.02002032180365, 1.267801550938767],
            [34.021585201401635, 1.269782258223284],
            [34.023133920307636, 1.270847038170095],
            [34.024653415220826, 1.276340766878257],
            [34.02459253639403, 1.278452706639426],
            [34.02500487029597, 1.280112174738778],
            [34.01619465392673, 1.291249641180624],
            [34.013825062598926, 1.293512068138121],
            [34.01287473396153, 1.295213078174423],
            [34.01023810224585, 1.298353066063455],
            [34.00558581183104, 1.302507010407468],
            [34.002393055580825, 1.307076483083295],
            [33.99917424010254, 1.309323617706029],
            [33.99717953101415, 1.309867558207482],
            [33.99271850809299, 1.304728412768999],
            [33.99057851806698, 1.303851806079121],
            [33.98520813148205, 1.303338311979055],
            [33.98366128556339, 1.302343864612874],
            [33.981491245094475, 1.299296222713474],
            [33.97994959233648, 1.295732709647089],
            [33.97666964740141, 1.291400957188813],
            [33.973604455514824, 1.290434221009298],
            [33.96741767281314, 1.286420171055294],
            [33.963171281667854, 1.284295973551424],
            [33.954443284503334, 1.278916876294691],
            [33.952518088848265, 1.2785648010503],
            [33.94864605712292, 1.278602431987352],
            [33.940577455716316, 1.277565126083813],
            [33.93596572603318, 1.276390831936994],
            [33.933973767586195, 1.273180194552641],
            [33.93264033622625, 1.271986594775266],
            [33.92693150756135, 1.269157232740726],
            [33.925395835786524, 1.267909422070384],
            [33.9180173471306, 1.25655915519458],
            [33.919850002836704, 1.2525239265441],
            [33.92176934506938, 1.250614510888991],
            [33.92409327772622, 1.249121074877808],
            [33.9255261714528, 1.24726610959832],
            [33.926442852792874, 1.242254229776819],
            [33.931733165350046, 1.234020390041441],
            [33.93417824750107, 1.232056519527756],
            [33.936901631320374, 1.230807193182845],
            [33.94124912695255, 1.230027685598606],
            [33.94928955809021, 1.23128221594576],
            [33.95240652617483, 1.231145403578959],
            [33.96080923978172, 1.227566138496755],
            [33.97246304264007, 1.225430070437884],
            [33.976881594112925, 1.22559127575893],
            [33.97993491835629, 1.225083576050461],
            [33.98275713841645, 1.22393369330727],
            [33.98599633936347, 1.22177050748256],
            [33.99128846292422, 1.219217583383588],
            [33.99229309561885, 1.216928583451069],
            [33.993492419286675, 1.215562199875976],
            [33.999923494338326, 1.209462847206835],
            [34.00366122882699, 1.207568532193682],
            [34.009119362848914, 1.206776058068643],
            [34.01223573265555, 1.206876025566726],
            [34.01451606558009, 1.207584013015282],
            [34.025068038030106, 1.212791306609458],
            [34.03309833706967, 1.213095785216317],
            [34.03642177932909, 1.211149649733247],
            [34.0403581142591, 1.215282067600157],
            [34.046801418974994, 1.219567265028567],
            [34.047139228640965, 1.221593390995436],
            [34.04696957640966, 1.227328494324226],
            [34.04614816410036, 1.231146146314227],
            [34.04855116826518, 1.235478128570561],
            [34.05094217812432, 1.236426983251421],
            [34.05195656742123, 1.236281845704986],
            [34.054081881670456, 1.237212710140121],
            [34.05601377875757, 1.239084409692716],
            [34.05596571978818, 1.239708587362979],
            [34.05331680720422, 1.244232541424803],
            [34.05332469261581, 1.247109096139658],
            [34.052749383660085, 1.249633100631769],
            [34.05104375153179, 1.252537080126123],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1074,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "KIDONGOLE",
        Population: 28203,
        Key: "BUKEDEAKIDONGOLE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.80912871932949, 1.435250238442496],
            [33.803065477437265, 1.436913703821112],
            [33.79939074718932, 1.437094597255205],
            [33.796119356910744, 1.440296916861765],
            [33.78537177091772, 1.44834978607787],
            [33.78269700302326, 1.449217763478158],
            [33.77916510580384, 1.452536314647193],
            [33.77774490796721, 1.455198611792567],
            [33.77762555510362, 1.4524971202748],
            [33.77636132007166, 1.449498061330572],
            [33.77599694093453, 1.446267060855151],
            [33.77386513545908, 1.441956720881233],
            [33.77352312257589, 1.436278499089561],
            [33.759745940439416, 1.443799380584132],
            [33.75911831360155, 1.443936712729143],
            [33.75798575811552, 1.442353954899259],
            [33.75593687971718, 1.435587851400838],
            [33.7528810518691, 1.429844328398157],
            [33.75010734263093, 1.426063796681988],
            [33.74801673748765, 1.425603109915045],
            [33.74086432514435, 1.425162161020083],
            [33.706142942819874, 1.425951166668388],
            [33.69736578355479, 1.423827906951043],
            [33.691488067124915, 1.421586124814917],
            [33.68861514345522, 1.420193805945055],
            [33.68490082355443, 1.417526156106091],
            [33.677707221658714, 1.41476000960228],
            [33.67310896221329, 1.41322342336314],
            [33.67061345582872, 1.413341757461494],
            [33.66948255593777, 1.411433236038489],
            [33.66637537948974, 1.408086860598778],
            [33.66300453942096, 1.406070415929185],
            [33.65841842879145, 1.405727950112718],
            [33.65639672443048, 1.406560821078672],
            [33.65360116726627, 1.408533796410238],
            [33.65174676155055, 1.408959515853978],
            [33.64794536794927, 1.408209706731313],
            [33.646735982251904, 1.406843989793385],
            [33.6461573692926, 1.404980525159444],
            [33.64510100441739, 1.404365642499184],
            [33.64040568559877, 1.40532589805746],
            [33.63952641100539, 1.405154252898183],
            [33.63656005805458, 1.403047178491816],
            [33.63225045156445, 1.401021884611097],
            [33.63051850957813, 1.399330611441467],
            [33.62867048549418, 1.396318541519375],
            [33.62759565125671, 1.390082091775993],
            [33.62629223171209, 1.388218989227725],
            [33.62544635019279, 1.387759103233893],
            [33.624212005703576, 1.387782437313592],
            [33.62296723536723, 1.388676841943634],
            [33.62310586068691, 1.389452257154566],
            [33.61071626394898, 1.389845811874666],
            [33.60229188567239, 1.389531354804655],
            [33.5993201104905, 1.390273955855631],
            [33.59733579311333, 1.39022922843308],
            [33.59424737708168, 1.389605784382476],
            [33.59275166416731, 1.388891464555223],
            [33.58744676207165, 1.385382629780399],
            [33.583510675076646, 1.380552600197525],
            [33.57780493571803, 1.368802153717677],
            [33.573974149240655, 1.364768184496662],
            [33.570604430269356, 1.362326341616307],
            [33.561832880983246, 1.357081234555564],
            [33.55925975656487, 1.35436777334066],
            [33.55746357964587, 1.349057673044485],
            [33.55707766789139, 1.339368553134211],
            [33.559429429457445, 1.339657513378092],
            [33.56249666770625, 1.338824492479604],
            [33.56359192604, 1.337729567924525],
            [33.565749535622004, 1.334137460413905],
            [33.5668507623625, 1.329677100337153],
            [33.56693658650643, 1.321706791239039],
            [33.56753794121549, 1.317789360557158],
            [33.56860231007987, 1.314297025829976],
            [33.57056896478195, 1.31101256303971],
            [33.57135368630177, 1.310560040177894],
            [33.579933317713945, 1.310313786548984],
            [33.593379715010016, 1.312409474207046],
            [33.60868098963732, 1.313916580696982],
            [33.61674539591158, 1.315895832169601],
            [33.62412125969022, 1.316463928645995],
            [33.63284415711886, 1.316525039272593],
            [33.63673044151452, 1.315899816045304],
            [33.65031952271873, 1.311707646430907],
            [33.66302881100164, 1.314047378728329],
            [33.67197480233617, 1.314642049778187],
            [33.67534642753248, 1.316007180414759],
            [33.68292626277954, 1.323170057924226],
            [33.686320106007784, 1.325611711844848],
            [33.696312357068884, 1.33895269107781],
            [33.697973376165194, 1.340300163022373],
            [33.70281550036247, 1.341483092709318],
            [33.71042046957289, 1.34291102481596],
            [33.7246407771643, 1.344408547378716],
            [33.728344002871346, 1.344253643216723],
            [33.7340519260344, 1.35059356079048],
            [33.73858339663677, 1.354726451224085],
            [33.7473672528423, 1.35960886387017],
            [33.7507493038858, 1.359978713768602],
            [33.75375078904909, 1.363198332102087],
            [33.75624702845892, 1.363948403342443],
            [33.76054939452785, 1.364679803671584],
            [33.763067858257806, 1.364651859621305],
            [33.76558892979703, 1.365763770517591],
            [33.76782321328347, 1.365998261178078],
            [33.7743678803028, 1.365706655691815],
            [33.7803129209716, 1.363072195833479],
            [33.78572055619982, 1.359433747986754],
            [33.78948292608686, 1.358138869122978],
            [33.790502287558866, 1.357324352855993],
            [33.79677192367584, 1.356236706442193],
            [33.79824233913348, 1.355277296793662],
            [33.79986982052699, 1.355331034247782],
            [33.80182560561412, 1.356072188364099],
            [33.80417798522108, 1.358450607399061],
            [33.80575294301823, 1.361046398175218],
            [33.8058654228716, 1.363108941798681],
            [33.80653451055307, 1.364827532821033],
            [33.80796612957023, 1.365460296239383],
            [33.805875015980504, 1.36996611595944],
            [33.80322405883098, 1.378579199995383],
            [33.79626938454633, 1.38583679115114],
            [33.79061021564867, 1.393302017003316],
            [33.78984094066018, 1.394414989475047],
            [33.78941161871793, 1.397427599768175],
            [33.79061591635749, 1.400258727962536],
            [33.79542094642175, 1.407087142513392],
            [33.79962765269269, 1.412124548331491],
            [33.80233597086638, 1.416827741920936],
            [33.80453813958142, 1.423177551387884],
            [33.80739496903451, 1.429961346022586],
            [33.80845617852403, 1.431516949577901],
            [33.80912871932949, 1.435250238442496],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1075,
        District: "NGORA",
        County: "NGORA",
        Subcounty: "KOBWIN",
        Population: 33357,
        Key: "NGORAKOBWIN",
        Dist2: "Ngora",
        "Sub Country": "Kobwin",
        id2_original: "NgoraKobwin",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.274895167150255, 1.395151739994572],
            [34.27386733636172, 1.396551687480475],
            [34.27431373976914, 1.39775551842131],
            [34.27536732974842, 1.397944650911911],
            [34.27509198892731, 1.3993379772261],
            [34.27594708446651, 1.400677507909697],
            [34.2759695360604, 1.401583642412803],
            [34.274981615623304, 1.402085143865992],
            [34.27558947413505, 1.402644706587902],
            [34.27575701173215, 1.403622466662584],
            [34.27541307825091, 1.404278480900046],
            [34.2743896617837, 1.403860929225575],
            [34.273892028353934, 1.404089581514583],
            [34.273819132763606, 1.404916437957796],
            [34.27505671837434, 1.405591819070124],
            [34.27409063508348, 1.405872299156034],
            [34.27381161476296, 1.406594979103178],
            [34.27323780689209, 1.406584085822213],
            [34.2733016645324, 1.408790087334069],
            [34.271618221689934, 1.409070962174572],
            [34.27328030079829, 1.411386988633514],
            [34.27301822809394, 1.412540074338178],
            [34.271752467722635, 1.413638465128698],
            [34.27220674935508, 1.414448590361581],
            [34.271701814418705, 1.414714083762377],
            [34.27014245676477, 1.414353959229804],
            [34.268883845186515, 1.41514292905418],
            [34.268217640198756, 1.414988588977808],
            [34.267885259950376, 1.415880710273167],
            [34.26703938651591, 1.415482832271469],
            [34.26754746914901, 1.416850341113607],
            [34.26703363909471, 1.418370727898507],
            [34.267736574397794, 1.418760794253099],
            [34.26727373900723, 1.419187155715837],
            [34.26546727727652, 1.418599971467368],
            [34.26512938047397, 1.419792032091339],
            [34.2640839795368, 1.418946986652754],
            [34.26374100635458, 1.420179667213694],
            [34.26327897226126, 1.419308416221023],
            [34.26286187010179, 1.419566494849993],
            [34.26327532510121, 1.42163771355099],
            [34.262834390637245, 1.422874330573952],
            [34.263866653713364, 1.423124241147045],
            [34.264255007088785, 1.423838633115944],
            [34.265147939667735, 1.423631861672036],
            [34.26524084343442, 1.424186330022782],
            [34.26361178729423, 1.425570252528631],
            [34.2636634188635, 1.42628483142874],
            [34.2629114885465, 1.427384418158697],
            [34.26389287014662, 1.430903864648855],
            [34.26287595658374, 1.43195792239822],
            [34.263768365444875, 1.432866085000412],
            [34.26368992185934, 1.433571217004981],
            [34.26308771195411, 1.434285120786903],
            [34.26221834667664, 1.434138944222997],
            [34.262068487025985, 1.435150752498124],
            [34.26142127691496, 1.435634907448411],
            [34.261553552942225, 1.436570453207903],
            [34.26051403417352, 1.436453158428982],
            [34.26018869851361, 1.437428042171763],
            [34.25965059777693, 1.437065106758189],
            [34.25919703030515, 1.437573688686131],
            [34.26018745434693, 1.438639287565171],
            [34.26025241781332, 1.439923203729168],
            [34.25957420055361, 1.44014697793054],
            [34.259194886026584, 1.43910893227391],
            [34.25852686823858, 1.438856040180058],
            [34.25616705776756, 1.440147107247095],
            [34.25585306693137, 1.439807264252371],
            [34.256006215314265, 1.438953108460883],
            [34.25488613203767, 1.438762185951908],
            [34.2546667832082, 1.439226435259744],
            [34.25526621642088, 1.439987299836895],
            [34.25523737780533, 1.441404902431248],
            [34.25172594510638, 1.441500992647728],
            [34.25114757379386, 1.442885218100291],
            [34.24993307668255, 1.443656695273121],
            [34.249566399654924, 1.442433955959055],
            [34.249185203157374, 1.442308256812689],
            [34.24885972197037, 1.443953813016996],
            [34.249429316742585, 1.446088124057388],
            [34.24827984508145, 1.445713038789479],
            [34.247489646533325, 1.4464059859545],
            [34.246829053321164, 1.445789892138352],
            [34.246031685318776, 1.447428715993788],
            [34.24515463585237, 1.446635660466323],
            [34.244906248083076, 1.44754932213659],
            [34.24519040946196, 1.448785954782851],
            [34.24432117354188, 1.448536842668281],
            [34.2431417834902, 1.446997763677112],
            [34.242746545426456, 1.447093753975931],
            [34.24270484563096, 1.448868737706994],
            [34.24134956724327, 1.449253099081411],
            [34.24071360673452, 1.45114659915819],
            [34.24023063740348, 1.451198644322669],
            [34.23969582899233, 1.45040328757262],
            [34.23901527072299, 1.45080885649959],
            [34.239594451417595, 1.452429309384068],
            [34.23887826955731, 1.45462511642836],
            [34.239793409388376, 1.454830889151624],
            [34.23996940552221, 1.455398062364095],
            [34.23845452615294, 1.456142984260949],
            [34.23861594262972, 1.456820672582873],
            [34.23821364829941, 1.457402899780604],
            [34.238535984484606, 1.457852117727565],
            [34.23961939044648, 1.457873618230269],
            [34.23904157698775, 1.458757997074813],
            [34.23988886526878, 1.459078347410165],
            [34.2370961575607, 1.461390364737832],
            [34.23694622604484, 1.462503005199904],
            [34.23508986469673, 1.462757301851677],
            [34.23469973714861, 1.464277110208959],
            [34.23412538849192, 1.464820140418618],
            [34.23333247164178, 1.464232642856099],
            [34.23263802721477, 1.464983779727047],
            [34.23230645006023, 1.464694517054264],
            [34.23049779015202, 1.464876423031383],
            [34.230652211447676, 1.466830101615424],
            [34.229264880272346, 1.468106244651612],
            [34.228466609463105, 1.472104669739652],
            [34.227126983320936, 1.473308427690139],
            [34.22725725341019, 1.47526212134605],
            [34.22687281938434, 1.475904545028944],
            [34.2290563166162, 1.484143513948053],
            [34.23011060817975, 1.496127816696388],
            [34.22446039368883, 1.492585275932344],
            [34.221194802035384, 1.488109716415992],
            [34.21753769852999, 1.481581087195704],
            [34.217495645696594, 1.480694676200852],
            [34.21907291036739, 1.479517920197232],
            [34.22004815737243, 1.47760883476523],
            [34.219863415240994, 1.476704413351888],
            [34.21814915120115, 1.474905356915889],
            [34.21831462536809, 1.473439936181784],
            [34.217986156384434, 1.472671271933022],
            [34.217158869991515, 1.471902881314925],
            [34.216089792158414, 1.471713518760253],
            [34.21549346891323, 1.470076655907918],
            [34.214568610209106, 1.469615855056607],
            [34.21367463109287, 1.468087696040092],
            [34.21246340654413, 1.467844135828716],
            [34.210683621184096, 1.465348613567993],
            [34.210244396214144, 1.463349847584159],
            [34.20875503888041, 1.461912458242735],
            [34.2086208557298, 1.456792903856113],
            [34.20709466926606, 1.453691196349199],
            [34.20453013723339, 1.451123714731488],
            [34.203860075778124, 1.44809390008724],
            [34.20289060314372, 1.447162754016546],
            [34.202198876120434, 1.445643512459601],
            [34.20257729412882, 1.444223198660229],
            [34.20194901601235, 1.443716997098474],
            [34.20164835437836, 1.442387498140152],
            [34.20268264225713, 1.440532660886681],
            [34.20102030353565, 1.44017173216951],
            [34.201066606298674, 1.438489281172529],
            [34.20183243085815, 1.43778334065962],
            [34.20212609281946, 1.436480661586947],
            [34.20091332227015, 1.436472259590438],
            [34.20065466316387, 1.435965859637899],
            [34.20063987330102, 1.434536708543729],
            [34.19934255241887, 1.43289114824207],
            [34.199556694612916, 1.430973429145337],
            [34.198897783945256, 1.429879293412958],
            [34.199049296496035, 1.42850432691981],
            [34.197300299994055, 1.426750454567411],
            [34.19666148014775, 1.424308552961797],
            [34.19597793318343, 1.423359151762641],
            [34.195645888904956, 1.423232690931232],
            [34.19500020054001, 1.423802884022218],
            [34.19445723991764, 1.423151904315501],
            [34.19362579971487, 1.422980476901788],
            [34.191973836534935, 1.420928047280208],
            [34.19128612408263, 1.420611818073341],
            [34.19117395774132, 1.41767214064635],
            [34.19209180599299, 1.415464602933811],
            [34.19124404879135, 1.414135376791803],
            [34.19108416573878, 1.411240951611343],
            [34.18928746240701, 1.409514217615097],
            [34.188020010508005, 1.406891718163925],
            [34.185780375757425, 1.405680789282791],
            [34.18562969235167, 1.403175301807267],
            [34.18440255684263, 1.400959367086718],
            [34.185246067707894, 1.399892032880862],
            [34.184252208508454, 1.397305564905073],
            [34.18287820923025, 1.396121320174011],
            [34.18110176650141, 1.39604838515489],
            [34.17967159107689, 1.395480723153111],
            [34.178840919832005, 1.39563992565676],
            [34.17717819214002, 1.394456698474652],
            [34.17729972970638, 1.391272739051551],
            [34.17613312088454, 1.390509190383038],
            [34.17560999865693, 1.39079858542371],
            [34.17534626766258, 1.390013929710673],
            [34.17412291046764, 1.389429353257847],
            [34.174489519223286, 1.388825522438596],
            [34.17432865341376, 1.388265334977319],
            [34.175210778361524, 1.388309978020177],
            [34.17533138257831, 1.387975238247892],
            [34.17498149596166, 1.386971374275403],
            [34.17403775826354, 1.385732626934459],
            [34.17318167996745, 1.385696873665442],
            [34.17259363110436, 1.384702172459291],
            [34.171029904044886, 1.383762229637002],
            [34.1706952438723, 1.38401566835053],
            [34.17031965555707, 1.383283176520241],
            [34.16924417453262, 1.382569124201825],
            [34.167992198809344, 1.382768744481988],
            [34.16599624914756, 1.382444098949682],
            [34.16438428615058, 1.381648899108828],
            [34.16371759068267, 1.381784909400097],
            [34.16305711514983, 1.380853556211126],
            [34.160920620468566, 1.380293791645815],
            [34.159599203177194, 1.378621035001731],
            [34.159583426964176, 1.377363725881229],
            [34.15785236981842, 1.376541438972392],
            [34.157043514160186, 1.376587062014844],
            [34.15546622164161, 1.3777908788659],
            [34.15245766044884, 1.377828530743345],
            [34.15069097162733, 1.378842484640613],
            [34.14844635841342, 1.376564116683389],
            [34.14804295915532, 1.376392448776784],
            [34.147493236913824, 1.376817853420632],
            [34.146238487192946, 1.375932003697808],
            [34.14356820907828, 1.375073974541339],
            [34.14155598284186, 1.373609574277148],
            [34.14053364255638, 1.373601021180891],
            [34.1386410090337, 1.372018966370512],
            [34.13705212645134, 1.371323223875699],
            [34.131648907341045, 1.37013179607394],
            [34.12824611868923, 1.370422872065964],
            [34.12519053697953, 1.368452390266967],
            [34.11745193798072, 1.360586385710216],
            [34.12122373568666, 1.356550298566588],
            [34.12549225054076, 1.349221401299858],
            [34.125990263059535, 1.34383001908906],
            [34.12462565387099, 1.339723970538282],
            [34.126946777495974, 1.337497688817383],
            [34.127811755401574, 1.336122365252322],
            [34.130045509780324, 1.327084834386393],
            [34.13263388669392, 1.322144778512006],
            [34.13282012002871, 1.319105394282981],
            [34.130804807180986, 1.318111308816953],
            [34.12913780081329, 1.318455802371657],
            [34.12847634342182, 1.317741506486725],
            [34.127182312170206, 1.315589256931254],
            [34.12698599075474, 1.313707871598294],
            [34.124960093956346, 1.311646404566766],
            [34.12370514121622, 1.308933304602359],
            [34.1238583075654, 1.307268852142238],
            [34.125057190160454, 1.30391240869858],
            [34.12516579288504, 1.301822835285579],
            [34.12462584970372, 1.295165546086721],
            [34.124062523375585, 1.29404414743394],
            [34.12765015477019, 1.288967986840268],
            [34.127553515808536, 1.279958660432468],
            [34.128813283518575, 1.274512681176011],
            [34.1285555927962, 1.268361821392709],
            [34.128727681258525, 1.267547645891653],
            [34.13102150328539, 1.265873211017928],
            [34.134835422096664, 1.26452374681594],
            [34.13801329146599, 1.264006748525758],
            [34.13996927687743, 1.263065149655614],
            [34.14120668102849, 1.263028420181645],
            [34.14455690116822, 1.259761508456027],
            [34.14737546508512, 1.259696939688177],
            [34.15476303391194, 1.253660320885244],
            [34.15774181954629, 1.252673039088112],
            [34.160106431512496, 1.251143303001579],
            [34.1614377194922, 1.250929795617848],
            [34.16626665552279, 1.251507939215031],
            [34.1673839288692, 1.251942664964802],
            [34.16824933077963, 1.253211691029894],
            [34.17026783174832, 1.254443925814392],
            [34.17069997619721, 1.253827158270103],
            [34.17127650237016, 1.253754360961332],
            [34.1773668410446, 1.254767132221486],
            [34.1795263128342, 1.248926872029558],
            [34.18035455952618, 1.247693356654238],
            [34.18157936480535, 1.246858620729919],
            [34.18781229036994, 1.244498325256424],
            [34.193828693204935, 1.241485288159118],
            [34.20099882391889, 1.239922465674985],
            [34.20395284569581, 1.238180224139521],
            [34.206979652570325, 1.23803376198326],
            [34.20898366820505, 1.237191293907695],
            [34.21055312741437, 1.238710179995653],
            [34.213798289581625, 1.240698643776486],
            [34.216741632186455, 1.24469528650668],
            [34.21976706823183, 1.247642629141677],
            [34.224184405182406, 1.25312197528794],
            [34.240767145427135, 1.280928038271508],
            [34.243641928609485, 1.286932625902315],
            [34.24450778506745, 1.29102061457301],
            [34.243110008281974, 1.292340134309761],
            [34.24363559279179, 1.293602588955825],
            [34.243048737789714, 1.294417821307931],
            [34.243280464505446, 1.295205783921802],
            [34.24285396686644, 1.29642393099954],
            [34.243574896322976, 1.296853433988668],
            [34.243397356883484, 1.297704286933658],
            [34.24253414147246, 1.297436052315369],
            [34.24233879293245, 1.29826004694394],
            [34.24183140469707, 1.297821483415686],
            [34.240452633568054, 1.298610242469269],
            [34.24050620460003, 1.298986344089599],
            [34.24134721904713, 1.29920435766706],
            [34.241692938379174, 1.300245439282035],
            [34.24133468934554, 1.301009859510387],
            [34.241931061099734, 1.301457334168026],
            [34.242071371658916, 1.302241972577768],
            [34.241379902452124, 1.302487481588786],
            [34.241618254243086, 1.302867209988624],
            [34.24133623983773, 1.304171122953043],
            [34.242029399673896, 1.305980227934575],
            [34.2415598691395, 1.306580019965392],
            [34.24091023178054, 1.306383323895586],
            [34.24007416345739, 1.307046442255508],
            [34.24172942614937, 1.30759189741592],
            [34.2419039409613, 1.308233298058872],
            [34.241535445743544, 1.308770219396253],
            [34.24278623569065, 1.30888925463301],
            [34.24197377868645, 1.310421312812872],
            [34.24106091877955, 1.310871692880436],
            [34.241736644112684, 1.311732909417862],
            [34.24165145507764, 1.312565788554253],
            [34.242834662070976, 1.313316655710511],
            [34.24201805934174, 1.315490433270595],
            [34.244244031615196, 1.318534155137967],
            [34.24475122222122, 1.318560765171967],
            [34.246325608689844, 1.317494277355243],
            [34.24660671400014, 1.317852798070513],
            [34.24620170945261, 1.31883765050687],
            [34.24660145166921, 1.318896760159005],
            [34.24719408912677, 1.318276696982266],
            [34.2476340821563, 1.318478710531262],
            [34.246220579463476, 1.320035076463138],
            [34.246673039312526, 1.321384614435209],
            [34.246487795921134, 1.321839416446351],
            [34.245974280277196, 1.322026346516734],
            [34.245127477984724, 1.32143326053891],
            [34.2448518128718, 1.321758875172377],
            [34.245884951805316, 1.324084546739039],
            [34.24572387579004, 1.325314734634135],
            [34.24655229046698, 1.327171440183046],
            [34.24577990640927, 1.327369315579914],
            [34.24506427880953, 1.328186914139467],
            [34.24607763234895, 1.328980942485889],
            [34.244969614344896, 1.329082020672286],
            [34.244665540011134, 1.329656544335265],
            [34.24568933826234, 1.332302906571202],
            [34.245923377241596, 1.334308291618897],
            [34.24535288954404, 1.334691496089871],
            [34.24412588788397, 1.334615539890241],
            [34.24403094045002, 1.334945850598622],
            [34.24432127505152, 1.33541955720864],
            [34.24663256392075, 1.335480598215779],
            [34.246858168617855, 1.336842221172518],
            [34.247985163532256, 1.338264795403079],
            [34.246808051608156, 1.33940659806702],
            [34.24700405591832, 1.340432395671392],
            [34.246533904648054, 1.340320209729875],
            [34.24566848566965, 1.340910896013895],
            [34.24610651228701, 1.341922516072124],
            [34.24675344122538, 1.341856602303292],
            [34.247051557932195, 1.342320209692978],
            [34.245930232285545, 1.34307967040907],
            [34.24647533269491, 1.344133394595136],
            [34.24594024041611, 1.344456898461273],
            [34.244497037623375, 1.34379244660896],
            [34.24433894670978, 1.344649855544197],
            [34.24490271500906, 1.345258476989829],
            [34.24426987973918, 1.345582030100549],
            [34.24498219704708, 1.345961105289717],
            [34.24553110271998, 1.345342473259178],
            [34.24736517237431, 1.345800606265845],
            [34.24773316812875, 1.346385973768637],
            [34.24764052756845, 1.34726201668154],
            [34.2482599186518, 1.347959680789212],
            [34.249274792140675, 1.348376072967646],
            [34.250391716042444, 1.348113165770466],
            [34.25158369598284, 1.348997910324605],
            [34.25106285817098, 1.349888227056455],
            [34.25222296408847, 1.352145532810694],
            [34.25179099930262, 1.353888374882833],
            [34.25216872470992, 1.355284145429617],
            [34.25301125102163, 1.355433608417605],
            [34.252814824503304, 1.356172908001065],
            [34.25320301348703, 1.357241707688148],
            [34.254445677274056, 1.357114577850144],
            [34.25507436861556, 1.357784125261506],
            [34.25568856743655, 1.357427785489709],
            [34.25723000998876, 1.359033741961276],
            [34.25736060706479, 1.359563016887309],
            [34.25659257085306, 1.359450992581686],
            [34.25642982217472, 1.359750883450279],
            [34.25710972287729, 1.360439139458028],
            [34.25691451447446, 1.360973268998331],
            [34.25793396757464, 1.361235061203475],
            [34.257705493658555, 1.361819256601587],
            [34.258170382597854, 1.36274215836142],
            [34.25800013568184, 1.363169702813999],
            [34.256878334826396, 1.363006338318874],
            [34.25676214493091, 1.36333431021448],
            [34.25774907991613, 1.363713230853928],
            [34.25849830181255, 1.363445821546839],
            [34.25900116972544, 1.363810944362488],
            [34.25988068327067, 1.363482568404415],
            [34.26052999094792, 1.364815404514881],
            [34.25975655855629, 1.365653302838523],
            [34.26064982351187, 1.365707270862994],
            [34.25998475489297, 1.36669135504387],
            [34.25999448005421, 1.367487704891811],
            [34.26051096552853, 1.367192312469305],
            [34.26106908611959, 1.367418654896795],
            [34.2610832049409, 1.366704827735978],
            [34.26163727502838, 1.367074604699536],
            [34.26210709392198, 1.36654501440944],
            [34.26245164364751, 1.36677905326962],
            [34.262545291219254, 1.367847056164344],
            [34.26185649360209, 1.367955162744674],
            [34.26111217830378, 1.368705067257309],
            [34.260660425428846, 1.368180650147891],
            [34.26036329866549, 1.369628299552621],
            [34.26123450189601, 1.371201808227094],
            [34.26360782572383, 1.370376085920275],
            [34.264069216623426, 1.371523525825646],
            [34.2633340883955, 1.372039205897688],
            [34.26226802261353, 1.371655649900069],
            [34.26243610728467, 1.372653345292759],
            [34.26349084081932, 1.37338488306388],
            [34.26264622682288, 1.373927399372618],
            [34.26421986319824, 1.374760389324192],
            [34.26409458055547, 1.375495912922494],
            [34.26488144904883, 1.376006094236848],
            [34.265063358792155, 1.376736767948901],
            [34.26593383079404, 1.37691431091243],
            [34.26631165591435, 1.376522023000787],
            [34.26735552702059, 1.376894820405197],
            [34.26851037330207, 1.376747026442188],
            [34.26835059714899, 1.378655292217251],
            [34.26910760204903, 1.37858071591268],
            [34.267687834505445, 1.379579396270024],
            [34.267909898941966, 1.381426773496494],
            [34.26709808063993, 1.381601104668535],
            [34.26618789950922, 1.381009653329704],
            [34.265920323725446, 1.381771721476194],
            [34.26508968841315, 1.381974448192168],
            [34.26503635723137, 1.382473436571399],
            [34.26641690522798, 1.383308788107676],
            [34.26601525498972, 1.383915847039329],
            [34.26620307115606, 1.384347278069513],
            [34.2676563638261, 1.384674279832365],
            [34.26881573761661, 1.384062676945667],
            [34.269372341851465, 1.385080522139372],
            [34.27020313257233, 1.385174470136384],
            [34.270109829055336, 1.386091525532495],
            [34.26935284661319, 1.386213303234848],
            [34.269098736575515, 1.387096732466032],
            [34.26970863785619, 1.387554905105676],
            [34.270171522654095, 1.388707653190554],
            [34.2700716290962, 1.389826992317784],
            [34.270614407360526, 1.390042463482989],
            [34.27054757809329, 1.390352663724137],
            [34.27112371709233, 1.390311894911122],
            [34.27119914593181, 1.391159538890222],
            [34.27202860265445, 1.391147495134889],
            [34.27239740329939, 1.391754135359548],
            [34.27318461315253, 1.392045710713347],
            [34.27412592719605, 1.391834106735387],
            [34.27389871271797, 1.392892829608207],
            [34.273282499874114, 1.39316287228258],
            [34.273262669564225, 1.393661841238237],
            [34.2740265950852, 1.393991816051625],
            [34.274895167150255, 1.395151739994572],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1077,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "KOLIR",
        Population: 32733,
        Key: "BUKEDEAKOLIR",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.91487541127098, 1.412074237297998],
              [33.91390898033211, 1.414079678449706],
              [33.91362421259043, 1.415659333275149],
              [33.914018467897286, 1.420361900941983],
              [33.91359151840567, 1.423233964349346],
              [33.91366312042201, 1.423880111690976],
              [33.915019236039534, 1.425207819935291],
              [33.91494834279396, 1.426356604337893],
              [33.915769188266296, 1.427253741266595],
              [33.91602014162404, 1.430376822121984],
              [33.915200521453784, 1.432566969482225],
              [33.913849096838675, 1.433611643806352],
              [33.91186224441576, 1.436158415004873],
              [33.91070867823355, 1.436526054459089],
              [33.90770179868698, 1.435921168118514],
              [33.905630510017254, 1.434474609510119],
              [33.90280039915566, 1.433381149872972],
              [33.90059154338163, 1.433535812009779],
              [33.899164435703824, 1.433056929872905],
              [33.899513922570165, 1.430333889744885],
              [33.89859215317229, 1.427728952543774],
              [33.89877998640665, 1.426797121946409],
              [33.89773187255731, 1.425775314833846],
              [33.896758964765276, 1.421659680477368],
              [33.89604406300426, 1.42082771117091],
              [33.89625551025249, 1.419941101254104],
              [33.89570756487862, 1.419389497528217],
              [33.8953232656001, 1.417815609766645],
              [33.89496710964107, 1.417842887739393],
              [33.89138140603107, 1.409331804324006],
              [33.8937604134997, 1.410515936397032],
              [33.8953518832301, 1.410415811775307],
              [33.89641900902407, 1.409773118145101],
              [33.89751161103953, 1.409646046800725],
              [33.900957650877366, 1.409952275096585],
              [33.90488882857933, 1.409661260554255],
              [33.907005321372466, 1.410420307379168],
              [33.91009392605031, 1.410364814599917],
              [33.912137801730836, 1.410743946830867],
              [33.91487541127098, 1.412074237297998],
            ],
          ],
          [
            [
              [34.00996505212874, 1.341303099902552],
              [34.01080267813055, 1.344206483866475],
              [34.018230020764896, 1.352353704302559],
              [34.02020774001632, 1.357310001805587],
              [34.02045632810994, 1.359354261376742],
              [34.021646776422784, 1.36096391748008],
              [34.02386585502471, 1.365413529754252],
              [34.023991133175926, 1.368082003733499],
              [34.02306095734362, 1.372216360351485],
              [34.02224258852655, 1.37375450991873],
              [34.02104914343392, 1.374370143239675],
              [34.01660176592191, 1.383535528640347],
              [34.01596875907383, 1.387678813809724],
              [34.014884383829745, 1.389841247979454],
              [34.0147101969029, 1.391053471938986],
              [34.01764076366774, 1.398686913439336],
              [34.01814743953912, 1.401228581732934],
              [34.019999463821044, 1.404945619039658],
              [34.021266822295246, 1.408632964696231],
              [34.022325289228235, 1.411765170568788],
              [34.023930507674045, 1.413700271064051],
              [34.025116289238966, 1.416069755980417],
              [34.02361191027706, 1.426256056528144],
              [34.0170830616916, 1.433676589631403],
              [34.012554436952044, 1.440698219251159],
              [34.009073935044995, 1.447466103620351],
              [34.00859576720914, 1.449763975438235],
              [34.00881815863244, 1.452142944825915],
              [34.00060039826108, 1.46304695541414],
              [33.99007585496997, 1.47208167596826],
              [33.983012954354855, 1.470323436173866],
              [33.978393421006864, 1.468582541153114],
              [33.97377363882554, 1.466260650315176],
              [33.97127116600595, 1.464789925579496],
              [33.96568811854884, 1.460067032125564],
              [33.96133760188236, 1.457318924592398],
              [33.96272262348912, 1.455885235750098],
              [33.96252703869217, 1.448487466382498],
              [33.961333272901015, 1.447093617475554],
              [33.96213974083724, 1.442793997063507],
              [33.96208166295746, 1.438208777211297],
              [33.96105406213768, 1.435537775266165],
              [33.95850463258154, 1.433318590116456],
              [33.956921486640574, 1.431305541371788],
              [33.95959221660781, 1.426084857446795],
              [33.96463752355272, 1.41136486355422],
              [33.97340579398805, 1.382052160394687],
              [33.97718399758026, 1.373402634961008],
              [33.98081362251945, 1.366860895245015],
              [33.98230472617811, 1.364634971593592],
              [33.986677623471564, 1.365221154472221],
              [33.99162918223338, 1.364594929769568],
              [33.99499644700731, 1.362223492034354],
              [33.99696221866547, 1.360024511350112],
              [33.99926314007803, 1.358684754813257],
              [33.99940111322083, 1.356794098550517],
              [34.00186982735203, 1.355056252702521],
              [34.006580136357776, 1.34572795440114],
              [34.007967130664895, 1.344497134600767],
              [34.00996505212874, 1.341303099902552],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1078,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "ATUTUR",
        Population: 21570,
        Key: "KUMIATUTUR",
        Dist2: "Kumi",
        "Sub Country": "Atutur",
        id2_original: "KumiAtutur",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.78499743665063, 1.511975224735561],
            [33.78317950702701, 1.512274420296389],
            [33.781397737288486, 1.513143526596896],
            [33.78049605871196, 1.514817448441875],
            [33.778571570929316, 1.515650419959056],
            [33.775209420264325, 1.516574375681915],
            [33.77335542867193, 1.516602184066762],
            [33.768813989464846, 1.514287915843496],
            [33.76626858885279, 1.511665344698037],
            [33.765102163287295, 1.509802182373653],
            [33.76423456140273, 1.509359212508596],
            [33.763710545351415, 1.508210493183209],
            [33.76161787857453, 1.506899491251345],
            [33.75855052534136, 1.505778803652785],
            [33.755270631610294, 1.505779952201285],
            [33.750876824231966, 1.509562926411875],
            [33.75074779561443, 1.51011480877104],
            [33.74959232949539, 1.510694187843564],
            [33.746051120339764, 1.512179047051859],
            [33.73377379055445, 1.51600091151591],
            [33.728901782102604, 1.518065186397498],
            [33.72452097873632, 1.522354744922225],
            [33.722006390338514, 1.526164203521657],
            [33.72234518545633, 1.52955655370317],
            [33.72049207151799, 1.530633724721691],
            [33.71687600215645, 1.530227849912825],
            [33.716332204304244, 1.532073536697205],
            [33.71435164188494, 1.535122904445184],
            [33.71204690173411, 1.536489714709995],
            [33.71090737891477, 1.537801853465541],
            [33.70886445365183, 1.539186668534279],
            [33.70570226796903, 1.540318550172597],
            [33.702823726235565, 1.534357792831115],
            [33.70099278720998, 1.527672949566842],
            [33.70051134231997, 1.52434395282275],
            [33.6984671171948, 1.518220059063079],
            [33.69760457372363, 1.514294104870276],
            [33.698125548079375, 1.5060072291924],
            [33.695696985048116, 1.497802720557507],
            [33.695392248655985, 1.49707908734539],
            [33.69498327804647, 1.497196824358519],
            [33.68832845421715, 1.480869748771868],
            [33.68324831958867, 1.471182367426452],
            [33.676908063313974, 1.46141391539339],
            [33.67598544410985, 1.459152528683088],
            [33.67484225526577, 1.45386057126204],
            [33.67421367351875, 1.446578189305848],
            [33.67309689334745, 1.420053668698437],
            [33.67061345582872, 1.413341757461494],
            [33.67310896221329, 1.41322342336314],
            [33.677707221658714, 1.41476000960228],
            [33.68490082355443, 1.417526156106091],
            [33.68861514345522, 1.420193805945055],
            [33.691488067124915, 1.421586124814917],
            [33.69736578355479, 1.423827906951043],
            [33.706142942819874, 1.425951166668388],
            [33.74086432514435, 1.425162161020083],
            [33.74801673748765, 1.425603109915045],
            [33.75010734263093, 1.426063796681988],
            [33.7528810518691, 1.429844328398157],
            [33.75593687971718, 1.435587851400838],
            [33.75798575811552, 1.442353954899259],
            [33.75911831360155, 1.443936712729143],
            [33.759745940439416, 1.443799380584132],
            [33.75965918923412, 1.449846423362314],
            [33.76079501009621, 1.45583673250548],
            [33.760729194128594, 1.459922096495983],
            [33.75984596425303, 1.46064687602715],
            [33.756050801366555, 1.462130059056028],
            [33.75335238262731, 1.465374668763965],
            [33.75073487514572, 1.465968312084478],
            [33.74666706907894, 1.467686711031759],
            [33.750569576150276, 1.473102827286321],
            [33.75712378417621, 1.47616261092906],
            [33.764548086013306, 1.47672064680407],
            [33.768385514633884, 1.478117443456587],
            [33.771053767945894, 1.478205282028027],
            [33.77215648319481, 1.47862655402248],
            [33.775111302675725, 1.478425781845704],
            [33.776125806058694, 1.49447733742088],
            [33.78095534126558, 1.495220310124039],
            [33.78580328564761, 1.492984472989086],
            [33.788294561865484, 1.489495253792688],
            [33.78883426609491, 1.487197083374204],
            [33.80019749360328, 1.489872271421578],
            [33.80452349883892, 1.489296544437717],
            [33.80937545958858, 1.496949911491084],
            [33.810752439476886, 1.492308460589499],
            [33.80979884366682, 1.484701502913478],
            [33.80906488504541, 1.483210341680643],
            [33.80714743825797, 1.480990376463748],
            [33.80695341742795, 1.478931868720877],
            [33.8063086354631, 1.477457062774755],
            [33.80793401030725, 1.47372022921495],
            [33.80872291797631, 1.472901372116834],
            [33.809237375952975, 1.470307700177899],
            [33.80902752950261, 1.469011035946849],
            [33.80989690286491, 1.468021953760782],
            [33.809928025896255, 1.464997293156901],
            [33.810604270455606, 1.464413512553441],
            [33.810958115049395, 1.463051806531308],
            [33.81400111675185, 1.460157344563668],
            [33.815337000512535, 1.457612004819533],
            [33.81604143240889, 1.44868427195521],
            [33.81662820386764, 1.449398722387679],
            [33.820327143712454, 1.451170463332293],
            [33.820924812633926, 1.452500060414011],
            [33.82463550962919, 1.454145135958357],
            [33.82774320081186, 1.456776478082017],
            [33.82853211656575, 1.458730197839112],
            [33.828812357696734, 1.461534462417209],
            [33.83036523400587, 1.464772476119111],
            [33.832723340372794, 1.466942715231601],
            [33.8337256805668, 1.46870637544303],
            [33.83579770316012, 1.470514861597197],
            [33.83817225857819, 1.474575764651298],
            [33.83829467829017, 1.475932667337395],
            [33.84113212389603, 1.479866737346073],
            [33.84121795432817, 1.481024633049559],
            [33.84181497286938, 1.482046638759964],
            [33.84174756239212, 1.483548353341621],
            [33.844031843412345, 1.489454718439954],
            [33.845174305519336, 1.490286537602232],
            [33.8489903847789, 1.491126364015219],
            [33.851467749686286, 1.493576945100216],
            [33.852732639590066, 1.495738514476388],
            [33.85290289548925, 1.497267271336292],
            [33.859404116388156, 1.508862036350233],
            [33.860444797576804, 1.510842755258943],
            [33.85498044541651, 1.513115548445307],
            [33.85014406414884, 1.513660242294859],
            [33.84821960151905, 1.514402798976288],
            [33.8470804461106, 1.516339156980331],
            [33.845323142887196, 1.51786867525365],
            [33.844608975948105, 1.519035931358129],
            [33.844371041873764, 1.516846817377026],
            [33.841822235748445, 1.509891201450624],
            [33.84048927780063, 1.507521585656029],
            [33.8377885566793, 1.504284050340564],
            [33.83522934357145, 1.499372880419514],
            [33.83397068258581, 1.500287043996523],
            [33.83370968696148, 1.500929434348086],
            [33.83387705118374, 1.502268227781924],
            [33.83349842386792, 1.503824343217719],
            [33.830933411236565, 1.505833616984033],
            [33.82569216555853, 1.505473771062696],
            [33.82298342966826, 1.506288975543734],
            [33.81958422259944, 1.505593696960272],
            [33.81672025513314, 1.505965682093428],
            [33.81569939347458, 1.507332069909847],
            [33.81415530538385, 1.508219197536673],
            [33.81104250548212, 1.508745059677285],
            [33.809624990014925, 1.508573710657104],
            [33.80810433717333, 1.509035646521111],
            [33.80577494725113, 1.508719894017122],
            [33.80091286338654, 1.506758632936787],
            [33.79965337595084, 1.507021445662783],
            [33.7960040338895, 1.506009593639535],
            [33.79298716777193, 1.507756663428506],
            [33.79090742415876, 1.50801072588152],
            [33.789007327432735, 1.509449804007967],
            [33.78686935951439, 1.51028285750795],
            [33.78499743665063, 1.511975224735561],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1079,
        District: "NGORA",
        County: "NGORA",
        Subcounty: "NGORA",
        Population: 28620,
        Key: "NGORANGORA",
        Dist2: "Ngora",
        "Sub Country": "Ngora SC",
        id2_original: "NgoraNgora SC",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.00996505212874, 1.341303099902552],
            [34.007967130664895, 1.344497134600767],
            [34.006580136357776, 1.34572795440114],
            [34.00186982735203, 1.355056252702521],
            [33.99940111322083, 1.356794098550517],
            [33.99926314007803, 1.358684754813257],
            [33.99696221866547, 1.360024511350112],
            [33.99499644700731, 1.362223492034354],
            [33.99162918223338, 1.364594929769568],
            [33.986677623471564, 1.365221154472221],
            [33.98230472617811, 1.364634971593592],
            [33.98081362251945, 1.366860895245015],
            [33.97718399758026, 1.373402634961008],
            [33.97340579398805, 1.382052160394687],
            [33.96463752355272, 1.41136486355422],
            [33.95959221660781, 1.426084857446795],
            [33.956921486640574, 1.431305541371788],
            [33.952717372009225, 1.429009610466808],
            [33.950697719400324, 1.428793349043277],
            [33.94817664606447, 1.427799333451506],
            [33.94715073317909, 1.426135284022278],
            [33.94198019569373, 1.420610271649866],
            [33.94041094130031, 1.42004101352729],
            [33.94040964592966, 1.419615848410695],
            [33.93864792748662, 1.418205380759626],
            [33.93763313125286, 1.416215656196626],
            [33.932894728334915, 1.41231871588044],
            [33.92482816430737, 1.412041536876876],
            [33.91622875019598, 1.41249727723381],
            [33.91487541127098, 1.412074237297998],
            [33.912137801730836, 1.410743946830867],
            [33.91009392605031, 1.410364814599917],
            [33.907005321372466, 1.410420307379168],
            [33.90488882857933, 1.409661260554255],
            [33.900957650877366, 1.409952275096585],
            [33.89751161103953, 1.409646046800725],
            [33.89641900902407, 1.409773118145101],
            [33.8953518832301, 1.410415811775307],
            [33.8937604134997, 1.410515936397032],
            [33.89138140603107, 1.409331804324006],
            [33.888821662917195, 1.408554816024461],
            [33.885759843306175, 1.409659630605433],
            [33.88432099464761, 1.409289286452138],
            [33.87957207335599, 1.410186676959223],
            [33.87836297152628, 1.411263639764646],
            [33.87643897512211, 1.411508619540144],
            [33.87491751469507, 1.411065932042574],
            [33.873440608011165, 1.409582906265034],
            [33.871746960307114, 1.40686967027376],
            [33.87031144080499, 1.403360263335609],
            [33.869911515332085, 1.400483703999227],
            [33.870335055717185, 1.394286859394918],
            [33.869987180428474, 1.392387274190751],
            [33.867840139525775, 1.389484222387088],
            [33.86386378914143, 1.386084292618228],
            [33.862293330107214, 1.385252612401357],
            [33.86067761035573, 1.385090371982593],
            [33.85549022676383, 1.38676582989902],
            [33.853732477976024, 1.386893118014538],
            [33.849014394949826, 1.386080661792239],
            [33.846638663637016, 1.386135797720735],
            [33.839302546716446, 1.388083392409482],
            [33.8371861195003, 1.387487090513549],
            [33.835163924659184, 1.386474621197006],
            [33.83442482497939, 1.385443600373354],
            [33.82937063639129, 1.374490254748894],
            [33.84114431942433, 1.372884902223728],
            [33.84400388334915, 1.371671679335056],
            [33.84734330753577, 1.367581555693448],
            [33.85035420614492, 1.362234114304598],
            [33.85982572809035, 1.354559475041541],
            [33.8623356820796, 1.351329054051914],
            [33.862618467239464, 1.350351955055988],
            [33.864148440102134, 1.349573427069987],
            [33.8663237968009, 1.345384223526119],
            [33.86760303639305, 1.344090149023399],
            [33.87036628834297, 1.342334183642945],
            [33.873333759696344, 1.341437537256998],
            [33.87537357589009, 1.340025587235282],
            [33.88089738574243, 1.34006882120399],
            [33.883131694381696, 1.340592691186066],
            [33.884271427406865, 1.340375167092414],
            [33.88593544148634, 1.340600716334244],
            [33.88821883766599, 1.341721612659465],
            [33.88956802906931, 1.339739997490465],
            [33.89156265820763, 1.339250771270494],
            [33.89528497311446, 1.336445080772387],
            [33.900493829136614, 1.33403687457816],
            [33.903916293588125, 1.33471407271076],
            [33.90966258739024, 1.338031878177202],
            [33.9131347376601, 1.339387500611843],
            [33.91699180075784, 1.342543152560161],
            [33.925704906549925, 1.344801372169066],
            [33.93080971161101, 1.348137428836618],
            [33.934329692678205, 1.349682951616377],
            [33.93778680964178, 1.349898716467094],
            [33.94393700486028, 1.348756510986874],
            [33.94449858306686, 1.348303987859727],
            [33.94434271189033, 1.347616547443373],
            [33.94532853116798, 1.343102171514949],
            [33.94465289656469, 1.339113116909441],
            [33.94320614991814, 1.335549523388907],
            [33.94146480526574, 1.332809234368517],
            [33.941915773013115, 1.328068913508602],
            [33.94174943376857, 1.323455475362227],
            [33.94219193219945, 1.320063025513688],
            [33.94296957409651, 1.317575055859881],
            [33.949689797973456, 1.311819186153706],
            [33.950256018673436, 1.310290184996422],
            [33.95353430082692, 1.305711625983066],
            [33.956547486546775, 1.304245012696259],
            [33.95849166809536, 1.302760716196955],
            [33.95931902186193, 1.301041651673398],
            [33.95986687740425, 1.29253816692809],
            [33.963171281667854, 1.284295973551424],
            [33.96741767281314, 1.286420171055294],
            [33.973604455514824, 1.290434221009298],
            [33.97666964740141, 1.291400957188813],
            [33.97994959233648, 1.295732709647089],
            [33.981491245094475, 1.299296222713474],
            [33.98366128556339, 1.302343864612874],
            [33.98520813148205, 1.303338311979055],
            [33.99057851806698, 1.303851806079121],
            [33.99271850809299, 1.304728412768999],
            [33.99717953101415, 1.309867558207482],
            [33.9981760357521, 1.311112663049239],
            [34.004234062924105, 1.314629079723696],
            [34.008167064206084, 1.319557498887677],
            [34.00879536927201, 1.321655890969167],
            [34.00861798434275, 1.323347547322755],
            [34.00919542589895, 1.326061080626784],
            [34.00935975112063, 1.333267562803655],
            [34.0100316065115, 1.336481609806841],
            [34.00996505212874, 1.341303099902552],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1080,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "KANYUM",
        Population: 41801,
        Key: "KUMIKANYUM",
        Dist2: "Kumi",
        "Sub Country": "kanyum",
        id2_original: "Kumikanyum",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.96646643508068, 1.495320102315727],
            [33.96140761747393, 1.494155405404025],
            [33.958409795640364, 1.492546533065448],
            [33.95618653987236, 1.487108950611389],
            [33.955919406957996, 1.489790401498839],
            [33.95482415401413, 1.493727674291696],
            [33.9537278733976, 1.495290374613272],
            [33.95141052988333, 1.497041076434863],
            [33.948078267066144, 1.497063361417812],
            [33.94265479903105, 1.495295196923662],
            [33.94188853429706, 1.494212385026154],
            [33.940151492574884, 1.497816671117262],
            [33.939220402257625, 1.498504452910052],
            [33.937355573389645, 1.498926040716848],
            [33.931932844668026, 1.498181617189991],
            [33.93048266196551, 1.498362852299378],
            [33.92840834776993, 1.501135216251042],
            [33.92702733624262, 1.500675653044693],
            [33.936581329819305, 1.489014251706491],
            [33.934770780754036, 1.487583988513988],
            [33.91181387283265, 1.484031488503798],
            [33.906210743537365, 1.478123796922388],
            [33.90533093264978, 1.475422307012009],
            [33.90523254197333, 1.473555613502685],
            [33.9024477717791, 1.468153043188467],
            [33.90098912964155, 1.463487571873812],
            [33.90250194917388, 1.458565818102937],
            [33.901995779054, 1.455743616258914],
            [33.90576604962395, 1.455673932184783],
            [33.911380345876516, 1.457031623116921],
            [33.920816060076376, 1.460741511526407],
            [33.921881930923945, 1.461473360928863],
            [33.9221640468389, 1.462376351673732],
            [33.92261005678423, 1.462585574789062],
            [33.9244822257864, 1.46084970178555],
            [33.93012984773936, 1.45905242774272],
            [33.93091351373872, 1.458427504407658],
            [33.929960513511695, 1.453787250123953],
            [33.927646530594906, 1.453761071764128],
            [33.92540892693516, 1.452305572980135],
            [33.92128429613846, 1.446662488183487],
            [33.919933628803136, 1.443505941151797],
            [33.9185018876151, 1.441290222069427],
            [33.91697780051415, 1.439933920838451],
            [33.91070867823355, 1.436526054459089],
            [33.91186224441576, 1.436158415004873],
            [33.913849096838675, 1.433611643806352],
            [33.915200521453784, 1.432566969482225],
            [33.91602014162404, 1.430376822121984],
            [33.915769188266296, 1.427253741266595],
            [33.91494834279396, 1.426356604337893],
            [33.915019236039534, 1.425207819935291],
            [33.91366312042201, 1.423880111690976],
            [33.91359151840567, 1.423233964349346],
            [33.914018467897286, 1.420361900941983],
            [33.91362421259043, 1.415659333275149],
            [33.91390898033211, 1.414079678449706],
            [33.91487541127098, 1.412074237297998],
            [33.91622875019598, 1.41249727723381],
            [33.92482816430737, 1.412041536876876],
            [33.932894728334915, 1.41231871588044],
            [33.93763313125286, 1.416215656196626],
            [33.93864792748662, 1.418205380759626],
            [33.94040964592966, 1.419615848410695],
            [33.94041094130031, 1.42004101352729],
            [33.94198019569373, 1.420610271649866],
            [33.94715073317909, 1.426135284022278],
            [33.94817664606447, 1.427799333451506],
            [33.950697719400324, 1.428793349043277],
            [33.952717372009225, 1.429009610466808],
            [33.956921486640574, 1.431305541371788],
            [33.95850463258154, 1.433318590116456],
            [33.96105406213768, 1.435537775266165],
            [33.96208166295746, 1.438208777211297],
            [33.96213974083724, 1.442793997063507],
            [33.961333272901015, 1.447093617475554],
            [33.96252703869217, 1.448487466382498],
            [33.96272262348912, 1.455885235750098],
            [33.96133760188236, 1.457318924592398],
            [33.96568811854884, 1.460067032125564],
            [33.97127116600595, 1.464789925579496],
            [33.97377363882554, 1.466260650315176],
            [33.978393421006864, 1.468582541153114],
            [33.983012954354855, 1.470323436173866],
            [33.99007585496997, 1.47208167596826],
            [33.986136631058, 1.474939795893162],
            [33.9881118089755, 1.476151069612498],
            [33.99162793716841, 1.476095215638263],
            [33.992078320112505, 1.475733176387908],
            [33.99287727274308, 1.475977056329734],
            [33.98830570404137, 1.477607379978408],
            [33.987238681553634, 1.478403902577811],
            [33.986554054814334, 1.480077709951428],
            [33.98233066952351, 1.486565555862386],
            [33.97741139531468, 1.490909825693627],
            [33.97722572163028, 1.49660887380087],
            [33.971332450871266, 1.496240628181247],
            [33.96646643508068, 1.495320102315727],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1082,
        District: "KUMI",
        County: "KUMI MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 18632,
        Key: "KUMISOUTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.877297183323755, 1.503542849785645],
            [33.87402370895367, 1.506902176285133],
            [33.872206780951586, 1.508160338757016],
            [33.86774002947388, 1.509935204513853],
            [33.864270385503644, 1.510081338392195],
            [33.859404116388156, 1.508862036350233],
            [33.85290289548925, 1.497267271336292],
            [33.852732639590066, 1.495738514476388],
            [33.851467749686286, 1.493576945100216],
            [33.8489903847789, 1.491126364015219],
            [33.845174305519336, 1.490286537602232],
            [33.844031843412345, 1.489454718439954],
            [33.84174756239212, 1.483548353341621],
            [33.84181497286938, 1.482046638759964],
            [33.84121795432817, 1.481024633049559],
            [33.84113212389603, 1.479866737346073],
            [33.83829467829017, 1.475932667337395],
            [33.83817225857819, 1.474575764651298],
            [33.83579770316012, 1.470514861597197],
            [33.8337256805668, 1.46870637544303],
            [33.832723340372794, 1.466942715231601],
            [33.83036523400587, 1.464772476119111],
            [33.828812357696734, 1.461534462417209],
            [33.82853211656575, 1.458730197839112],
            [33.82774320081186, 1.456776478082017],
            [33.82463550962919, 1.454145135958357],
            [33.820924812633926, 1.452500060414011],
            [33.820327143712454, 1.451170463332293],
            [33.81662820386764, 1.449398722387679],
            [33.81604143240889, 1.44868427195521],
            [33.81236238845098, 1.444397615820666],
            [33.811157157461835, 1.44230833404333],
            [33.81049133246145, 1.442028134984626],
            [33.80977722660783, 1.43708001320364],
            [33.80912871932949, 1.435250238442496],
            [33.80845617852403, 1.431516949577901],
            [33.80739496903451, 1.429961346022586],
            [33.80453813958142, 1.423177551387884],
            [33.80233597086638, 1.416827741920936],
            [33.79962765269269, 1.412124548331491],
            [33.79542094642175, 1.407087142513392],
            [33.79061591635749, 1.400258727962536],
            [33.78941161871793, 1.397427599768175],
            [33.78984094066018, 1.394414989475047],
            [33.79061021564867, 1.393302017003316],
            [33.79626938454633, 1.38583679115114],
            [33.80322405883098, 1.378579199995383],
            [33.805875015980504, 1.36996611595944],
            [33.80796612957023, 1.365460296239383],
            [33.811889453301674, 1.366761644382205],
            [33.8180627388162, 1.369853394346883],
            [33.82681148616549, 1.372102910520099],
            [33.82834599462204, 1.372970825661372],
            [33.82937063639129, 1.374490254748894],
            [33.83442482497939, 1.385443600373354],
            [33.835163924659184, 1.386474621197006],
            [33.8371861195003, 1.387487090513549],
            [33.839302546716446, 1.388083392409482],
            [33.846638663637016, 1.386135797720735],
            [33.849014394949826, 1.386080661792239],
            [33.853732477976024, 1.386893118014538],
            [33.85549022676383, 1.38676582989902],
            [33.86067761035573, 1.385090371982593],
            [33.862293330107214, 1.385252612401357],
            [33.86386378914143, 1.386084292618228],
            [33.867840139525775, 1.389484222387088],
            [33.869987180428474, 1.392387274190751],
            [33.870335055717185, 1.394286859394918],
            [33.869911515332085, 1.400483703999227],
            [33.87031144080499, 1.403360263335609],
            [33.871746960307114, 1.40686967027376],
            [33.873440608011165, 1.409582906265034],
            [33.87491751469507, 1.411065932042574],
            [33.87643897512211, 1.411508619540144],
            [33.87836297152628, 1.411263639764646],
            [33.87957207335599, 1.410186676959223],
            [33.88432099464761, 1.409289286452138],
            [33.885759843306175, 1.409659630605433],
            [33.888821662917195, 1.408554816024461],
            [33.89138140603107, 1.409331804324006],
            [33.89496710964107, 1.417842887739393],
            [33.8953232656001, 1.417815609766645],
            [33.89570756487862, 1.419389497528217],
            [33.89625551025249, 1.419941101254104],
            [33.89604406300426, 1.42082771117091],
            [33.896758964765276, 1.421659680477368],
            [33.89773187255731, 1.425775314833846],
            [33.89877998640665, 1.426797121946409],
            [33.89859215317229, 1.427728952543774],
            [33.899513922570165, 1.430333889744885],
            [33.899164435703824, 1.433056929872905],
            [33.8991015742952, 1.434640036302954],
            [33.897918698780224, 1.436675896640698],
            [33.89773479747186, 1.439037025059452],
            [33.89859442501165, 1.440728319464474],
            [33.89934089087678, 1.448923864058125],
            [33.900141640137875, 1.45086847204191],
            [33.90014426771009, 1.451827366518343],
            [33.90059598824567, 1.451944785329476],
            [33.901646785362736, 1.45401593695608],
            [33.901995779054, 1.455743616258914],
            [33.90250194917388, 1.458565818102937],
            [33.90098912964155, 1.463487571873812],
            [33.90050216819737, 1.466038769035607],
            [33.898740745300074, 1.468301028860952],
            [33.897199674650395, 1.469495749395529],
            [33.89604092698563, 1.47145924108693],
            [33.89648759539603, 1.474380979193838],
            [33.896105990165, 1.478207671649463],
            [33.89308176325202, 1.489136703714037],
            [33.891934173561395, 1.49091927277116],
            [33.890582377043756, 1.492023461640115],
            [33.88484164560987, 1.495481450347604],
            [33.88270340101042, 1.49817809250782],
            [33.877297183323755, 1.503542849785645],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1083,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "NYERO",
        Population: 33061,
        Key: "KUMINYERO",
        Dist2: "Kumi",
        "Sub Country": "Nyero",
        id2_original: "KumiNyero",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "N",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.963171281667854, 1.284295973551424],
            [33.95986687740425, 1.29253816692809],
            [33.95931902186193, 1.301041651673398],
            [33.95849166809536, 1.302760716196955],
            [33.956547486546775, 1.304245012696259],
            [33.95353430082692, 1.305711625983066],
            [33.950256018673436, 1.310290184996422],
            [33.949689797973456, 1.311819186153706],
            [33.94296957409651, 1.317575055859881],
            [33.94219193219945, 1.320063025513688],
            [33.94174943376857, 1.323455475362227],
            [33.941915773013115, 1.328068913508602],
            [33.94146480526574, 1.332809234368517],
            [33.94320614991814, 1.335549523388907],
            [33.94465289656469, 1.339113116909441],
            [33.94532853116798, 1.343102171514949],
            [33.94434271189033, 1.347616547443373],
            [33.94449858306686, 1.348303987859727],
            [33.94393700486028, 1.348756510986874],
            [33.93778680964178, 1.349898716467094],
            [33.934329692678205, 1.349682951616377],
            [33.93080971161101, 1.348137428836618],
            [33.925704906549925, 1.344801372169066],
            [33.91699180075784, 1.342543152560161],
            [33.9131347376601, 1.339387500611843],
            [33.90966258739024, 1.338031878177202],
            [33.903916293588125, 1.33471407271076],
            [33.900493829136614, 1.33403687457816],
            [33.89528497311446, 1.336445080772387],
            [33.89156265820763, 1.339250771270494],
            [33.88956802906931, 1.339739997490465],
            [33.88821883766599, 1.341721612659465],
            [33.88593544148634, 1.340600716334244],
            [33.884271427406865, 1.340375167092414],
            [33.883131694381696, 1.340592691186066],
            [33.88089738574243, 1.34006882120399],
            [33.87537357589009, 1.340025587235282],
            [33.873333759696344, 1.341437537256998],
            [33.87036628834297, 1.342334183642945],
            [33.86760303639305, 1.344090149023399],
            [33.8663237968009, 1.345384223526119],
            [33.864148440102134, 1.349573427069987],
            [33.862618467239464, 1.350351955055988],
            [33.8623356820796, 1.351329054051914],
            [33.85982572809035, 1.354559475041541],
            [33.85035420614492, 1.362234114304598],
            [33.84734330753577, 1.367581555693448],
            [33.84400388334915, 1.371671679335056],
            [33.84114431942433, 1.372884902223728],
            [33.82937063639129, 1.374490254748894],
            [33.82834599462204, 1.372970825661372],
            [33.82681148616549, 1.372102910520099],
            [33.8180627388162, 1.369853394346883],
            [33.811889453301674, 1.366761644382205],
            [33.80796612957023, 1.365460296239383],
            [33.80653451055307, 1.364827532821033],
            [33.8058654228716, 1.363108941798681],
            [33.80575294301823, 1.361046398175218],
            [33.80417798522108, 1.358450607399061],
            [33.80182560561412, 1.356072188364099],
            [33.79986982052699, 1.355331034247782],
            [33.79824233913348, 1.355277296793662],
            [33.79677192367584, 1.356236706442193],
            [33.790502287558866, 1.357324352855993],
            [33.78948292608686, 1.358138869122978],
            [33.78572055619982, 1.359433747986754],
            [33.7803129209716, 1.363072195833479],
            [33.7743678803028, 1.365706655691815],
            [33.76782321328347, 1.365998261178078],
            [33.76558892979703, 1.365763770517591],
            [33.763067858257806, 1.364651859621305],
            [33.76054939452785, 1.364679803671584],
            [33.75624702845892, 1.363948403342443],
            [33.75375078904909, 1.363198332102087],
            [33.7507493038858, 1.359978713768602],
            [33.7473672528423, 1.35960886387017],
            [33.73858339663677, 1.354726451224085],
            [33.7340519260344, 1.35059356079048],
            [33.728344002871346, 1.344253643216723],
            [33.7310956081636, 1.342353035902361],
            [33.73357168039532, 1.339593085853775],
            [33.73639507545182, 1.335448907076486],
            [33.74203777373876, 1.32293581999962],
            [33.74485824657566, 1.320374796473446],
            [33.750960224721254, 1.316573401678617],
            [33.75730203867468, 1.316435769404738],
            [33.76957542934745, 1.316406060978252],
            [33.77411243447026, 1.316267727296032],
            [33.78982821422756, 1.320731702031883],
            [33.79275124772045, 1.321201178732046],
            [33.79989201160945, 1.321596912501755],
            [33.804747591671386, 1.320545946548413],
            [33.807287006808714, 1.319513826298082],
            [33.81069054465551, 1.317151598683046],
            [33.81999274494963, 1.308355447866309],
            [33.828067895973, 1.302689749670739],
            [33.8295133706051, 1.301178528605716],
            [33.83380310007295, 1.294754194026181],
            [33.836070554749575, 1.291949074065245],
            [33.843333283803034, 1.284492479144752],
            [33.84838318652889, 1.280302348213526],
            [33.85659508359638, 1.27248359271981],
            [33.859393017702814, 1.270374868630719],
            [33.861671109330736, 1.269297595091851],
            [33.865126241017556, 1.268771747925575],
            [33.874379233397036, 1.268497222709429],
            [33.8812949585276, 1.267083642133559],
            [33.88590708257114, 1.266041738735434],
            [33.888784133101254, 1.267108199660222],
            [33.890138494309014, 1.267107730854336],
            [33.89482354987553, 1.269096268261549],
            [33.89971419657289, 1.267819043142353],
            [33.901860669740316, 1.266370899874926],
            [33.90292577791818, 1.26488695228805],
            [33.9025657502203, 1.263403503194416],
            [33.904698558215614, 1.261439734547178],
            [33.90550569629504, 1.261204250657062],
            [33.905647063272966, 1.26065238395601],
            [33.90869954489663, 1.260633218547813],
            [33.91045646094616, 1.260053645400774],
            [33.911997479493564, 1.25893137733662],
            [33.914326505598076, 1.259111477501818],
            [33.9180173471306, 1.25655915519458],
            [33.925395835786524, 1.267909422070384],
            [33.92693150756135, 1.269157232740726],
            [33.93264033622625, 1.271986594775266],
            [33.933973767586195, 1.273180194552641],
            [33.93596572603318, 1.276390831936994],
            [33.940577455716316, 1.277565126083813],
            [33.94864605712292, 1.278602431987352],
            [33.952518088848265, 1.2785648010503],
            [33.954443284503334, 1.278916876294691],
            [33.963171281667854, 1.284295973551424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1084,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "MUKONGORO",
        Population: 46798,
        Key: "KUMIMUKONGORO",
        Dist2: "Kumi",
        "Sub Country": "Mukongoro",
        id2_original: "KumiMukongoro",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.860444797576804, 1.510842755258943],
            [33.862825143535204, 1.515048317390752],
            [33.87023043522426, 1.530767710922589],
            [33.87172185059828, 1.537235164924413],
            [33.87298366107731, 1.53995756327493],
            [33.87399861721115, 1.544878297729559],
            [33.87514109818278, 1.54702178055114],
            [33.876282435599, 1.547745004578832],
            [33.87757989931334, 1.54968940265222],
            [33.877533327055744, 1.551191096336375],
            [33.87656030966923, 1.552656992560484],
            [33.87655140377151, 1.555578928377191],
            [33.878075507042105, 1.559404843251504],
            [33.88157269605387, 1.563184689237257],
            [33.88420348063538, 1.568068528194329],
            [33.884479168206205, 1.57034805532855],
            [33.88545521830512, 1.572093557520792],
            [33.8854338581643, 1.574726012705997],
            [33.88600504744613, 1.575630388406187],
            [33.88625850261196, 1.579782487990371],
            [33.88697345917016, 1.581862806778182],
            [33.892269278400036, 1.589974950914884],
            [33.89357697482374, 1.590761398668355],
            [33.89564510771186, 1.590923325833823],
            [33.89756227961482, 1.59536415852669],
            [33.89910945252025, 1.597751667499113],
            [33.89956249986747, 1.599542608776984],
            [33.89945140162304, 1.60757565720578],
            [33.89742052905626, 1.621923791248368],
            [33.897329032051296, 1.625922240729974],
            [33.89962969834231, 1.646003700963177],
            [33.89837457312565, 1.651042987609604],
            [33.895141049531226, 1.654188329884584],
            [33.88951624568476, 1.658971465035017],
            [33.88066781049178, 1.665307802785226],
            [33.86791252127977, 1.672324342887519],
            [33.86531879220374, 1.669213588284546],
            [33.85154441101432, 1.655867335923243],
            [33.84686836734675, 1.649717875693584],
            [33.84383261684527, 1.644137607752357],
            [33.841177055829924, 1.638077710392416],
            [33.83896400672014, 1.635491399773174],
            [33.831347203104194, 1.623399649521501],
            [33.82793295194932, 1.619375439864418],
            [33.828119594915925, 1.615503529406739],
            [33.82738869505803, 1.608682887706631],
            [33.83166299955413, 1.604176062896503],
            [33.828674282145975, 1.597790568285048],
            [33.828220476620636, 1.595375379523184],
            [33.82822925316097, 1.59203727673913],
            [33.82704094014357, 1.591938246972272],
            [33.82461480166526, 1.590148049778712],
            [33.82152426830449, 1.588982311932793],
            [33.818505501351765, 1.588865917077433],
            [33.81357413132765, 1.589862981308998],
            [33.81271916334924, 1.590225176364218],
            [33.811531955259625, 1.591519279042487],
            [33.80346453064602, 1.594281614039482],
            [33.7999828438611, 1.594301073894032],
            [33.79770050230358, 1.593876785088061],
            [33.79297118404808, 1.594448550688871],
            [33.79180572776479, 1.59390621687782],
            [33.79130573266415, 1.592540401256699],
            [33.78919512293782, 1.593093048590603],
            [33.788147867877896, 1.582753381127416],
            [33.79020152800849, 1.580201500500982],
            [33.79229208015117, 1.578644713517781],
            [33.79447569236739, 1.575079584448574],
            [33.799236167790184, 1.5693966044187],
            [33.802141447878135, 1.562185501077891],
            [33.804339595733964, 1.561451895042625],
            [33.804980201431064, 1.560302755607767],
            [33.802814870829174, 1.557200673786826],
            [33.79979422909247, 1.555003553889046],
            [33.791079233245064, 1.55060125409372],
            [33.78768983308419, 1.547816225765958],
            [33.78554893575975, 1.545356394973304],
            [33.78575945235331, 1.541846297583709],
            [33.78859511121008, 1.536109801075627],
            [33.78899612993272, 1.532717238562845],
            [33.78763554609496, 1.525426315080773],
            [33.78821143356571, 1.517763770882153],
            [33.78568948167752, 1.514779369592631],
            [33.78499743665063, 1.511975224735561],
            [33.78686935951439, 1.51028285750795],
            [33.789007327432735, 1.509449804007967],
            [33.79090742415876, 1.50801072588152],
            [33.79298716777193, 1.507756663428506],
            [33.7960040338895, 1.506009593639535],
            [33.79965337595084, 1.507021445662783],
            [33.80091286338654, 1.506758632936787],
            [33.80577494725113, 1.508719894017122],
            [33.80810433717333, 1.509035646521111],
            [33.809624990014925, 1.508573710657104],
            [33.81104250548212, 1.508745059677285],
            [33.81415530538385, 1.508219197536673],
            [33.81569939347458, 1.507332069909847],
            [33.81672025513314, 1.505965682093428],
            [33.81958422259944, 1.505593696960272],
            [33.82298342966826, 1.506288975543734],
            [33.82569216555853, 1.505473771062696],
            [33.830933411236565, 1.505833616984033],
            [33.83349842386792, 1.503824343217719],
            [33.83387705118374, 1.502268227781924],
            [33.83370968696148, 1.500929434348086],
            [33.83397068258581, 1.500287043996523],
            [33.83522934357145, 1.499372880419514],
            [33.8377885566793, 1.504284050340564],
            [33.84048927780063, 1.507521585656029],
            [33.841822235748445, 1.509891201450624],
            [33.844371041873764, 1.516846817377026],
            [33.844608975948105, 1.519035931358129],
            [33.845323142887196, 1.51786867525365],
            [33.8470804461106, 1.516339156980331],
            [33.84821960151905, 1.514402798976288],
            [33.85014406414884, 1.513660242294859],
            [33.85498044541651, 1.513115548445307],
            [33.860444797576804, 1.510842755258943],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1085,
        District: "NGORA",
        County: "NGORA",
        Subcounty: "MUKURA",
        Population: 33586,
        Key: "NGORAMUKURA",
        Dist2: "Ngora",
        "Sub Country": "Mukura",
        id2_original: "NgoraMukura",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.168223048588093, -0.411085930673386],
            [31.167808049384725, -0.405842857213],
            [31.166918950815425, -0.401001821403944],
            [31.16617357011516, -0.399083637143289],
            [31.16444934286051, -0.396515639321918],
            [31.16111543163475, -0.392777625197565],
            [31.158106689880597, -0.390671157427952],
            [31.154785766497234, -0.389765303829776],
            [31.149079229434662, -0.390207376998377],
            [31.146555016486882, -0.391378757373037],
            [31.14427919041011, -0.394112084207785],
            [31.141453289952274, -0.395090460197529],
            [31.139870267080482, -0.396565635658249],
            [31.141159629787555, -0.400735428035079],
            [31.144681755133313, -0.406843205837151],
            [31.14503961699306, -0.408810825789749],
            [31.144387098736978, -0.41336880333726],
            [31.14448431172207, -0.415565909152906],
            [31.145037637106192, -0.417402407840601],
            [31.146991567172243, -0.419501577232018],
            [31.149672603510744, -0.420788812255295],
            [31.153089754427352, -0.420228452883335],
            [31.154141558555867, -0.419687236954635],
            [31.158579079752556, -0.420335663928081],
            [31.16095578124583, -0.419300510912192],
            [31.16477280193978, -0.426301540778867],
            [31.165837403467847, -0.424750142764378],
            [31.166627013619436, -0.422145768813142],
            [31.170276791363708, -0.417369307597284],
            [31.16767144168115, -0.412609172632636],
            [31.167683999230512, -0.411668741708901],
            [31.168223048588093, -0.411085930673386],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1902,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "LYANTONDE TOWN COUNCIL",
        Population: 13823,
        Key: "LYANTONDELYANTONDE TOWN COUNCIL",
        Dist2: "Lyantonde",
        "Sub Country": "Lyantonde T.C",
        id2_original: "Lyantonde Lyantonde T.C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86791252127977, 1.672324342887519],
            [33.85868184395026, 1.67602835743781],
            [33.852289398252495, 1.677994213785987],
            [33.84369897537878, 1.679997199324722],
            [33.83542780118064, 1.681032061496605],
            [33.828880168822565, 1.681577653657201],
            [33.818646994093854, 1.68139203208914],
            [33.81175138942905, 1.67886194986587],
            [33.807054791409456, 1.676059530907093],
            [33.804116765034486, 1.67312971918428],
            [33.799783415173074, 1.665433018142637],
            [33.798624806747185, 1.663886556559276],
            [33.79802297323604, 1.663669688715261],
            [33.792179701807434, 1.667951017122782],
            [33.78985127308259, 1.669127994511433],
            [33.78830700353215, 1.669825194444117],
            [33.782852903844194, 1.6708948703755],
            [33.77233407563492, 1.670265814107138],
            [33.76110504744685, 1.672586129751719],
            [33.751537712989865, 1.67277982187412],
            [33.74657903418109, 1.672184659578847],
            [33.744734105691606, 1.671316900787068],
            [33.743388010781075, 1.670177552619009],
            [33.741527779490696, 1.667455257453937],
            [33.738519404249196, 1.66100622103826],
            [33.735375038446726, 1.651381886286001],
            [33.72738732853478, 1.633490763167877],
            [33.714871902080056, 1.617356188787019],
            [33.71298957313205, 1.615402793756729],
            [33.71217692927825, 1.613204759541516],
            [33.71215398900084, 1.607016901346864],
            [33.71393014067555, 1.602574403897458],
            [33.71683761175445, 1.59906330720012],
            [33.72228914136238, 1.595632731480439],
            [33.723370918678675, 1.594664365485531],
            [33.724331108122946, 1.593044690316019],
            [33.72323371000218, 1.591109112919044],
            [33.71932994439111, 1.58930117381858],
            [33.71713941694382, 1.587981140858],
            [33.71659136197551, 1.587239512453389],
            [33.715849436195846, 1.584761007924906],
            [33.714894007822565, 1.575705709702848],
            [33.713118358306104, 1.573381349752838],
            [33.70961717089299, 1.570677620377507],
            [33.708141623360135, 1.570225794735228],
            [33.707201343277504, 1.56927622323846],
            [33.706866129742714, 1.568217884526838],
            [33.70585179793799, 1.552449998819168],
            [33.70670726627799, 1.545049589078546],
            [33.70570226796903, 1.540318550172597],
            [33.70886445365183, 1.539186668534279],
            [33.71090737891477, 1.537801853465541],
            [33.71204690173411, 1.536489714709995],
            [33.71435164188494, 1.535122904445184],
            [33.716332204304244, 1.532073536697205],
            [33.71687600215645, 1.530227849912825],
            [33.72049207151799, 1.530633724721691],
            [33.72234518545633, 1.52955655370317],
            [33.722006390338514, 1.526164203521657],
            [33.72452097873632, 1.522354744922225],
            [33.728901782102604, 1.518065186397498],
            [33.73377379055445, 1.51600091151591],
            [33.746051120339764, 1.512179047051859],
            [33.74959232949539, 1.510694187843564],
            [33.75074779561443, 1.51011480877104],
            [33.750876824231966, 1.509562926411875],
            [33.755270631610294, 1.505779952201285],
            [33.75855052534136, 1.505778803652785],
            [33.76161787857453, 1.506899491251345],
            [33.763710545351415, 1.508210493183209],
            [33.76423456140273, 1.509359212508596],
            [33.765102163287295, 1.509802182373653],
            [33.76626858885279, 1.511665344698037],
            [33.768813989464846, 1.514287915843496],
            [33.77335542867193, 1.516602184066762],
            [33.775209420264325, 1.516574375681915],
            [33.778571570929316, 1.515650419959056],
            [33.78049605871196, 1.514817448441875],
            [33.781397737288486, 1.513143526596896],
            [33.78317950702701, 1.512274420296389],
            [33.78499743665063, 1.511975224735561],
            [33.78568948167752, 1.514779369592631],
            [33.78821143356571, 1.517763770882153],
            [33.78763554609496, 1.525426315080773],
            [33.78899612993272, 1.532717238562845],
            [33.78859511121008, 1.536109801075627],
            [33.78575945235331, 1.541846297583709],
            [33.78554893575975, 1.545356394973304],
            [33.78768983308419, 1.547816225765958],
            [33.791079233245064, 1.55060125409372],
            [33.79979422909247, 1.555003553889046],
            [33.802814870829174, 1.557200673786826],
            [33.804980201431064, 1.560302755607767],
            [33.804339595733964, 1.561451895042625],
            [33.802141447878135, 1.562185501077891],
            [33.799236167790184, 1.5693966044187],
            [33.79447569236739, 1.575079584448574],
            [33.79229208015117, 1.578644713517781],
            [33.79020152800849, 1.580201500500982],
            [33.788147867877896, 1.582753381127416],
            [33.78919512293782, 1.593093048590603],
            [33.79130573266415, 1.592540401256699],
            [33.79180572776479, 1.59390621687782],
            [33.79297118404808, 1.594448550688871],
            [33.79770050230358, 1.593876785088061],
            [33.7999828438611, 1.594301073894032],
            [33.80346453064602, 1.594281614039482],
            [33.811531955259625, 1.591519279042487],
            [33.81271916334924, 1.590225176364218],
            [33.81357413132765, 1.589862981308998],
            [33.818505501351765, 1.588865917077433],
            [33.82152426830449, 1.588982311932793],
            [33.82461480166526, 1.590148049778712],
            [33.82704094014357, 1.591938246972272],
            [33.82822925316097, 1.59203727673913],
            [33.828220476620636, 1.595375379523184],
            [33.828674282145975, 1.597790568285048],
            [33.83166299955413, 1.604176062896503],
            [33.82738869505803, 1.608682887706631],
            [33.828119594915925, 1.615503529406739],
            [33.82793295194932, 1.619375439864418],
            [33.831347203104194, 1.623399649521501],
            [33.83896400672014, 1.635491399773174],
            [33.841177055829924, 1.638077710392416],
            [33.84383261684527, 1.644137607752357],
            [33.84686836734675, 1.649717875693584],
            [33.85154441101432, 1.655867335923243],
            [33.86531879220374, 1.669213588284546],
            [33.86791252127977, 1.672324342887519],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1086,
        District: "NGORA",
        County: "NGORA",
        Subcounty: "KAPIR",
        Population: 31208,
        Key: "NGORAKAPIR",
        Dist2: "Ngora",
        "Sub Country": "Kapir",
        id2_original: "NgoraKapir",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.20898366820505, 1.237191293907695],
            [34.206979652570325, 1.23803376198326],
            [34.20395284569581, 1.238180224139521],
            [34.20099882391889, 1.239922465674985],
            [34.193828693204935, 1.241485288159118],
            [34.18781229036994, 1.244498325256424],
            [34.18157936480535, 1.246858620729919],
            [34.18035455952618, 1.247693356654238],
            [34.1795263128342, 1.248926872029558],
            [34.1773668410446, 1.254767132221486],
            [34.17127650237016, 1.253754360961332],
            [34.17069997619721, 1.253827158270103],
            [34.17026783174832, 1.254443925814392],
            [34.16824933077963, 1.253211691029894],
            [34.1673839288692, 1.251942664964802],
            [34.16626665552279, 1.251507939215031],
            [34.1614377194922, 1.250929795617848],
            [34.160106431512496, 1.251143303001579],
            [34.15774181954629, 1.252673039088112],
            [34.15476303391194, 1.253660320885244],
            [34.14737546508512, 1.259696939688177],
            [34.14455690116822, 1.259761508456027],
            [34.14120668102849, 1.263028420181645],
            [34.13996927687743, 1.263065149655614],
            [34.13801329146599, 1.264006748525758],
            [34.134835422096664, 1.26452374681594],
            [34.13102150328539, 1.265873211017928],
            [34.128727681258525, 1.267547645891653],
            [34.1285555927962, 1.268361821392709],
            [34.128813283518575, 1.274512681176011],
            [34.127553515808536, 1.279958660432468],
            [34.12765015477019, 1.288967986840268],
            [34.124062523375585, 1.29404414743394],
            [34.12087914553693, 1.298740221346238],
            [34.118259804593855, 1.301093242090758],
            [34.1137964191035, 1.303582771922505],
            [34.110467605816964, 1.307175359164897],
            [34.10905815003453, 1.308189095403428],
            [34.10873533145402, 1.304733817428782],
            [34.10561463446264, 1.300013389638694],
            [34.10204567365291, 1.296514304427272],
            [34.09894755940946, 1.291992842330971],
            [34.09876731334603, 1.29083507961953],
            [34.09946521538857, 1.283580172675018],
            [34.09828641463173, 1.270916784174047],
            [34.0968360612493, 1.270863132020249],
            [34.095847351193086, 1.269289611926639],
            [34.09316590701943, 1.268313825389488],
            [34.08378977627576, 1.260013862350855],
            [34.07134196691078, 1.25233923483419],
            [34.065714504949376, 1.255079184189519],
            [34.06336581113005, 1.256924993208254],
            [34.058379416599784, 1.257274257651538],
            [34.05704121608398, 1.257043323155112],
            [34.05432211094038, 1.254568229136312],
            [34.05104375153179, 1.252537080126123],
            [34.052749383660085, 1.249633100631769],
            [34.05332469261581, 1.247109096139658],
            [34.05331680720422, 1.244232541424803],
            [34.05596571978818, 1.239708587362979],
            [34.05601377875757, 1.239084409692716],
            [34.054081881670456, 1.237212710140121],
            [34.05195656742123, 1.236281845704986],
            [34.05094217812432, 1.236426983251421],
            [34.04855116826518, 1.235478128570561],
            [34.04614816410036, 1.231146146314227],
            [34.04696957640966, 1.227328494324226],
            [34.047139228640965, 1.221593390995436],
            [34.046801418974994, 1.219567265028567],
            [34.0403581142591, 1.215282067600157],
            [34.03642177932909, 1.211149649733247],
            [34.039030266826906, 1.209475164856084],
            [34.0452256077783, 1.202896465253563],
            [34.04772549794147, 1.200769736091449],
            [34.059716931701075, 1.196992990057585],
            [34.07916556809504, 1.192299661803391],
            [34.087575725142344, 1.187773483170312],
            [34.09814038539742, 1.187411128534666],
            [34.10210956003929, 1.186592911981226],
            [34.10262231930178, 1.186110155748599],
            [34.10265217211529, 1.185303643150248],
            [34.10478377546983, 1.185161455895462],
            [34.105705504443534, 1.183048268407347],
            [34.10709695349612, 1.183344661817732],
            [34.10937245078949, 1.18154135996928],
            [34.10987856970541, 1.180721579844707],
            [34.11195043689016, 1.180626259190436],
            [34.11282166168027, 1.179495462635998],
            [34.11343971607048, 1.179618652144936],
            [34.11486698903828, 1.179024464320596],
            [34.11550653651997, 1.178114222470347],
            [34.118779859973074, 1.176643892026399],
            [34.11897895628444, 1.175959914312185],
            [34.11987399271775, 1.175703093350651],
            [34.12029819336462, 1.174593414244181],
            [34.124447938361705, 1.17275199919851],
            [34.127859682318615, 1.170163584882492],
            [34.13404842604256, 1.169129876252182],
            [34.13564126839869, 1.166135154839737],
            [34.13644841366466, 1.165681009470421],
            [34.137173214860056, 1.163954559091129],
            [34.14387513646144, 1.161129625611401],
            [34.14547486170927, 1.159916874807682],
            [34.14645588039003, 1.159346607236498],
            [34.147180503719035, 1.159500084415106],
            [34.14920299320757, 1.162022949499063],
            [34.15291608421306, 1.164427519659484],
            [34.160870385779575, 1.165473498466666],
            [34.162349760135534, 1.16529197392672],
            [34.164614088674995, 1.163102034277269],
            [34.1699510606263, 1.160286679411147],
            [34.171548261608216, 1.161104124084666],
            [34.173059447105025, 1.160638152214881],
            [34.17524074975265, 1.161245485383588],
            [34.17734540364867, 1.162539409540087],
            [34.181044176406864, 1.161457034694055],
            [34.181894146159024, 1.161408584133764],
            [34.18323730088362, 1.162058530736485],
            [34.185394094795335, 1.165980951435287],
            [34.18766558111097, 1.167539192731666],
            [34.18801285003688, 1.168088310412184],
            [34.18783717819486, 1.168946455101196],
            [34.188776414435125, 1.169355565100925],
            [34.19162761684127, 1.172438644427152],
            [34.188089123292734, 1.172665001216105],
            [34.186822920051995, 1.174129292955044],
            [34.18599009015545, 1.176367562035933],
            [34.186114583179105, 1.180348911121692],
            [34.18505580183576, 1.183211813153168],
            [34.18389957125043, 1.184903758317428],
            [34.18428813034006, 1.186673103554891],
            [34.18366260555995, 1.190017233266279],
            [34.18371513364786, 1.191936352161617],
            [34.184416001029156, 1.198493654415326],
            [34.18644717363323, 1.202318035428901],
            [34.18850523011885, 1.203780787344803],
            [34.18927364092803, 1.206786107987076],
            [34.18927425896897, 1.208204317258163],
            [34.18873185260714, 1.209408084635047],
            [34.18961334334432, 1.211339842555341],
            [34.18944579676405, 1.212491399369346],
            [34.19098454257377, 1.213499076068512],
            [34.196120334122284, 1.222110116481314],
            [34.197310002697435, 1.22298782758802],
            [34.199237518700876, 1.226135634408758],
            [34.20064055422402, 1.227169378109922],
            [34.20155984337341, 1.23046400812283],
            [34.20275954343533, 1.231750668068049],
            [34.20417386090012, 1.231883905935276],
            [34.20786666165828, 1.235093298911043],
            [34.20898366820505, 1.237191293907695],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1087,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "KACHUMBALA",
        Population: 55422,
        Key: "BUKEDEAKACHUMBALA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.11745193798072, 1.360586385710216],
            [34.11417092764376, 1.358190835533484],
            [34.10440548771718, 1.354830385986681],
            [34.0974514117105, 1.356289921201979],
            [34.09506285784536, 1.356092007731619],
            [34.092423512319186, 1.361556786423329],
            [34.089920001945444, 1.364316856090626],
            [34.088376740304774, 1.367637320691387],
            [34.084593848405085, 1.373446373041357],
            [34.08325015469133, 1.377119534637426],
            [34.07857757223255, 1.384430593147394],
            [34.07582093817131, 1.387742583571052],
            [34.074829485558524, 1.390257744241807],
            [34.074045810576024, 1.397576082140324],
            [34.072123524564155, 1.402497836529647],
            [34.070921199624955, 1.404533677573952],
            [34.065429014063895, 1.411064775363346],
            [34.06027431387698, 1.41029603616872],
            [34.058507303458605, 1.409117567046927],
            [34.05678614934053, 1.409088490190307],
            [34.05500588607677, 1.409597020813801],
            [34.05120701314818, 1.408385409926233],
            [34.04754274917162, 1.408368533885086],
            [34.046021189929924, 1.403983084983456],
            [34.04549269218366, 1.39983516763537],
            [34.04416377845125, 1.397957568433082],
            [34.04219236357649, 1.392992181758328],
            [34.04149498525175, 1.383298649083819],
            [34.04537232961366, 1.382402723814153],
            [34.04924743447561, 1.382363500414932],
            [34.04919317982571, 1.380402856785109],
            [34.05038467018425, 1.38136216657875],
            [34.05223942714128, 1.381453517550282],
            [34.05308683759318, 1.381891001014083],
            [34.05649435767163, 1.381282899821701],
            [34.05564856059396, 1.376463925060283],
            [34.057571016387406, 1.37503423643492],
            [34.05770669792794, 1.36946985057196],
            [34.056696227980574, 1.362671955119477],
            [34.05689996319208, 1.357300018036637],
            [34.05607482826428, 1.355399149704472],
            [34.05657787224696, 1.353785762928881],
            [34.056325731316385, 1.353163650193531],
            [34.06209438328759, 1.349727373555349],
            [34.063261256214105, 1.347675836915948],
            [34.06193247094081, 1.34597107563428],
            [34.06209206922743, 1.34439471713145],
            [34.0614049128323, 1.343841934658078],
            [34.060579704242635, 1.341745177989564],
            [34.059799592876885, 1.338023715615866],
            [34.059568441082895, 1.332953868001807],
            [34.05846815218357, 1.330096734073402],
            [34.056795895163035, 1.328311450048363],
            [34.05670258535786, 1.324255523229645],
            [34.05578607290101, 1.322781024949513],
            [34.05475388438504, 1.318495048356096],
            [34.053334514795104, 1.319094831996763],
            [34.0505654920678, 1.322737170107167],
            [34.04875717801097, 1.324074566426887],
            [34.043078950456234, 1.324768344861653],
            [34.04028610979748, 1.326267475248416],
            [34.03909682749791, 1.329563470700858],
            [34.03634983954617, 1.331223903739101],
            [34.035434502984046, 1.332560923665781],
            [34.03454142397974, 1.332376939171095],
            [34.0331908554591, 1.333276284879698],
            [34.03140491933431, 1.333438356350009],
            [34.02103204040922, 1.332659170083496],
            [34.01881129633074, 1.333420598771918],
            [34.01734569224975, 1.333029438081716],
            [34.01354485740056, 1.333422790965738],
            [34.011521650158116, 1.33293532819934],
            [34.010231495136935, 1.333453391871725],
            [34.00935975112063, 1.333267562803655],
            [34.00919542589895, 1.326061080626784],
            [34.00861798434275, 1.323347547322755],
            [34.00879536927201, 1.321655890969167],
            [34.008167064206084, 1.319557498887677],
            [34.004234062924105, 1.314629079723696],
            [33.9981760357521, 1.311112663049239],
            [33.99717953101415, 1.309867558207482],
            [33.99917424010254, 1.309323617706029],
            [34.002393055580825, 1.307076483083295],
            [34.00558581183104, 1.302507010407468],
            [34.01023810224585, 1.298353066063455],
            [34.01287473396153, 1.295213078174423],
            [34.013825062598926, 1.293512068138121],
            [34.01619465392673, 1.291249641180624],
            [34.02500487029597, 1.280112174738778],
            [34.02459253639403, 1.278452706639426],
            [34.024653415220826, 1.276340766878257],
            [34.023133920307636, 1.270847038170095],
            [34.021585201401635, 1.269782258223284],
            [34.02002032180365, 1.267801550938767],
            [34.01968823979595, 1.267022509661623],
            [34.019893134732435, 1.265766209158505],
            [34.01929261006669, 1.265353005894974],
            [34.01835938535233, 1.262576971014023],
            [34.01703149749598, 1.260573903674136],
            [34.0221024738001, 1.259347486070543],
            [34.02713287140622, 1.256572454248382],
            [34.02839336944659, 1.256581000560886],
            [34.03451163943818, 1.253846721586659],
            [34.03798678828446, 1.253374951309637],
            [34.04226957287685, 1.251220333133352],
            [34.04643226439381, 1.251235786758788],
            [34.04773427807503, 1.252113670544828],
            [34.049102561373104, 1.251986477916047],
            [34.05104375153179, 1.252537080126123],
            [34.05432211094038, 1.254568229136312],
            [34.05704121608398, 1.257043323155112],
            [34.058379416599784, 1.257274257651538],
            [34.06336581113005, 1.256924993208254],
            [34.065714504949376, 1.255079184189519],
            [34.07134196691078, 1.25233923483419],
            [34.08378977627576, 1.260013862350855],
            [34.09316590701943, 1.268313825389488],
            [34.095847351193086, 1.269289611926639],
            [34.0968360612493, 1.270863132020249],
            [34.09828641463173, 1.270916784174047],
            [34.09946521538857, 1.283580172675018],
            [34.09876731334603, 1.29083507961953],
            [34.09894755940946, 1.291992842330971],
            [34.10204567365291, 1.296514304427272],
            [34.10561463446264, 1.300013389638694],
            [34.10873533145402, 1.304733817428782],
            [34.10905815003453, 1.308189095403428],
            [34.110467605816964, 1.307175359164897],
            [34.1137964191035, 1.303582771922505],
            [34.118259804593855, 1.301093242090758],
            [34.12087914553693, 1.298740221346238],
            [34.124062523375585, 1.29404414743394],
            [34.12462584970372, 1.295165546086721],
            [34.12516579288504, 1.301822835285579],
            [34.125057190160454, 1.30391240869858],
            [34.1238583075654, 1.307268852142238],
            [34.12370514121622, 1.308933304602359],
            [34.124960093956346, 1.311646404566766],
            [34.12698599075474, 1.313707871598294],
            [34.127182312170206, 1.315589256931254],
            [34.12847634342182, 1.317741506486725],
            [34.12913780081329, 1.318455802371657],
            [34.130804807180986, 1.318111308816953],
            [34.13282012002871, 1.319105394282981],
            [34.13263388669392, 1.322144778512006],
            [34.130045509780324, 1.327084834386393],
            [34.127811755401574, 1.336122365252322],
            [34.126946777495974, 1.337497688817383],
            [34.12462565387099, 1.339723970538282],
            [34.125990263059535, 1.34383001908906],
            [34.12549225054076, 1.349221401299858],
            [34.12122373568666, 1.356550298566588],
            [34.11745193798072, 1.360586385710216],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1088,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "BUKEDEA",
        Population: 30439,
        Key: "BUKEDEABUKEDEA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.80912871932949, 1.435250238442496],
            [33.80977722660783, 1.43708001320364],
            [33.81049133246145, 1.442028134984626],
            [33.811157157461835, 1.44230833404333],
            [33.81236238845098, 1.444397615820666],
            [33.81604143240889, 1.44868427195521],
            [33.815337000512535, 1.457612004819533],
            [33.81400111675185, 1.460157344563668],
            [33.810958115049395, 1.463051806531308],
            [33.810604270455606, 1.464413512553441],
            [33.809928025896255, 1.464997293156901],
            [33.80989690286491, 1.468021953760782],
            [33.80902752950261, 1.469011035946849],
            [33.809237375952975, 1.470307700177899],
            [33.80872291797631, 1.472901372116834],
            [33.80793401030725, 1.47372022921495],
            [33.8063086354631, 1.477457062774755],
            [33.80695341742795, 1.478931868720877],
            [33.80714743825797, 1.480990376463748],
            [33.80906488504541, 1.483210341680643],
            [33.80979884366682, 1.484701502913478],
            [33.810752439476886, 1.492308460589499],
            [33.80937545958858, 1.496949911491084],
            [33.80452349883892, 1.489296544437717],
            [33.80019749360328, 1.489872271421578],
            [33.78883426609491, 1.487197083374204],
            [33.788294561865484, 1.489495253792688],
            [33.78580328564761, 1.492984472989086],
            [33.78095534126558, 1.495220310124039],
            [33.776125806058694, 1.49447733742088],
            [33.775111302675725, 1.478425781845704],
            [33.77215648319481, 1.47862655402248],
            [33.771053767945894, 1.478205282028027],
            [33.768385514633884, 1.478117443456587],
            [33.764548086013306, 1.47672064680407],
            [33.75712378417621, 1.47616261092906],
            [33.750569576150276, 1.473102827286321],
            [33.74666706907894, 1.467686711031759],
            [33.75073487514572, 1.465968312084478],
            [33.75335238262731, 1.465374668763965],
            [33.756050801366555, 1.462130059056028],
            [33.75984596425303, 1.46064687602715],
            [33.760729194128594, 1.459922096495983],
            [33.76079501009621, 1.45583673250548],
            [33.75965918923412, 1.449846423362314],
            [33.759745940439416, 1.443799380584132],
            [33.77352312257589, 1.436278499089561],
            [33.77386513545908, 1.441956720881233],
            [33.77599694093453, 1.446267060855151],
            [33.77636132007166, 1.449498061330572],
            [33.77762555510362, 1.4524971202748],
            [33.77774490796721, 1.455198611792567],
            [33.77916510580384, 1.452536314647193],
            [33.78269700302326, 1.449217763478158],
            [33.78537177091772, 1.44834978607787],
            [33.796119356910744, 1.440296916861765],
            [33.79939074718932, 1.437094597255205],
            [33.803065477437265, 1.436913703821112],
            [33.80912871932949, 1.435250238442496],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1090,
        District: "NGORA",
        County: "NGORA",
        Subcounty: "NGORA TOWN COUNCIL",
        Population: 15148,
        Key: "NGORANGORA TOWN COUNCIL",
        Dist2: "Ngora",
        "Sub Country": "Ngora TC",
        id2_original: "NgoraNgora TC",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.046021189929924, 1.403983084983456],
            [34.0431290171603, 1.404960951365818],
            [34.038925511586676, 1.404257801606557],
            [34.037830450882296, 1.408808115562286],
            [34.034833009036134, 1.408326818846918],
            [34.0347108444457, 1.407727389714196],
            [34.032476355245024, 1.406567234913269],
            [34.03186574339697, 1.406989954349643],
            [34.031292653279976, 1.408395132149518],
            [34.024842456689214, 1.408854133119331],
            [34.021266822295246, 1.408632964696231],
            [34.019999463821044, 1.404945619039658],
            [34.01814743953912, 1.401228581732934],
            [34.01764076366774, 1.398686913439336],
            [34.0147101969029, 1.391053471938986],
            [34.014884383829745, 1.389841247979454],
            [34.01596875907383, 1.387678813809724],
            [34.01660176592191, 1.383535528640347],
            [34.02104914343392, 1.374370143239675],
            [34.02224258852655, 1.37375450991873],
            [34.02306095734362, 1.372216360351485],
            [34.023991133175926, 1.368082003733499],
            [34.02386585502471, 1.365413529754252],
            [34.021646776422784, 1.36096391748008],
            [34.02045632810994, 1.359354261376742],
            [34.02020774001632, 1.357310001805587],
            [34.018230020764896, 1.352353704302559],
            [34.01080267813055, 1.344206483866475],
            [34.00996505212874, 1.341303099902552],
            [34.0100316065115, 1.336481609806841],
            [34.00935975112063, 1.333267562803655],
            [34.010231495136935, 1.333453391871725],
            [34.011521650158116, 1.33293532819934],
            [34.01354485740056, 1.333422790965738],
            [34.01734569224975, 1.333029438081716],
            [34.01881129633074, 1.333420598771918],
            [34.02103204040922, 1.332659170083496],
            [34.03140491933431, 1.333438356350009],
            [34.0331908554591, 1.333276284879698],
            [34.03454142397974, 1.332376939171095],
            [34.035434502984046, 1.332560923665781],
            [34.03634983954617, 1.331223903739101],
            [34.03909682749791, 1.329563470700858],
            [34.04028610979748, 1.326267475248416],
            [34.043078950456234, 1.324768344861653],
            [34.04875717801097, 1.324074566426887],
            [34.0505654920678, 1.322737170107167],
            [34.053334514795104, 1.319094831996763],
            [34.05475388438504, 1.318495048356096],
            [34.05578607290101, 1.322781024949513],
            [34.05670258535786, 1.324255523229645],
            [34.056795895163035, 1.328311450048363],
            [34.05846815218357, 1.330096734073402],
            [34.059568441082895, 1.332953868001807],
            [34.059799592876885, 1.338023715615866],
            [34.060579704242635, 1.341745177989564],
            [34.0614049128323, 1.343841934658078],
            [34.06209206922743, 1.34439471713145],
            [34.06193247094081, 1.34597107563428],
            [34.063261256214105, 1.347675836915948],
            [34.06209438328759, 1.349727373555349],
            [34.056325731316385, 1.353163650193531],
            [34.05657787224696, 1.353785762928881],
            [34.05607482826428, 1.355399149704472],
            [34.05689996319208, 1.357300018036637],
            [34.056696227980574, 1.362671955119477],
            [34.05770669792794, 1.36946985057196],
            [34.057571016387406, 1.37503423643492],
            [34.05564856059396, 1.376463925060283],
            [34.05649435767163, 1.381282899821701],
            [34.05308683759318, 1.381891001014083],
            [34.05223942714128, 1.381453517550282],
            [34.05038467018425, 1.38136216657875],
            [34.04919317982571, 1.380402856785109],
            [34.04924743447561, 1.382363500414932],
            [34.04537232961366, 1.382402723814153],
            [34.04149498525175, 1.383298649083819],
            [34.04219236357649, 1.392992181758328],
            [34.04416377845125, 1.397957568433082],
            [34.04549269218366, 1.39983516763537],
            [34.046021189929924, 1.403983084983456],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1091,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "BUKEDEA TOWN COUNCIL",
        Population: 10927,
        Key: "BUKEDEABUKEDEA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.369660918635674, 1.028387731041956],
            [34.365080298509184, 1.029031034883038],
            [34.3614934782933, 1.031139762260541],
            [34.35993791242819, 1.031124291285473],
            [34.35730655831479, 1.027977707160303],
            [34.35624778146304, 1.027138769806105],
            [34.35498081285767, 1.026977889423341],
            [34.35447572161444, 1.027158753211277],
            [34.354943988219226, 1.028276886011361],
            [34.35478411953968, 1.031650814555916],
            [34.35443975396879, 1.030577897713772],
            [34.35457524326984, 1.027915065142135],
            [34.354164999747546, 1.026977643324508],
            [34.352437907765456, 1.025165693324134],
            [34.35181611728199, 1.023240756749447],
            [34.34869778106319, 1.020829327402165],
            [34.34854838584156, 1.019966799461096],
            [34.34787743415584, 1.01926700859031],
            [34.34599652544428, 1.018087357647487],
            [34.34649347525608, 1.017635165893903],
            [34.347005396390415, 1.01461635631367],
            [34.34714624504045, 1.006190059909501],
            [34.34677708417105, 1.005415387744775],
            [34.3432161965208, 1.003592794831165],
            [34.34277077766693, 1.002052554814554],
            [34.34538954368826, 1.000869148626949],
            [34.34512660410965, 0.99978353389533],
            [34.34555124403266, 0.999471092600379],
            [34.34609550541553, 0.999908039400182],
            [34.346118769984756, 0.998442783914875],
            [34.347999227742044, 0.998518870444308],
            [34.35135477758636, 0.999435058572483],
            [34.354227500033474, 0.998434617672398],
            [34.35485780025761, 0.999193398216569],
            [34.35566421070165, 0.998654045463477],
            [34.355488177736895, 0.997152900871365],
            [34.356541659918356, 0.997181920144448],
            [34.356767915894, 0.99939723088145],
            [34.35748729216342, 0.999403859439758],
            [34.35769757519501, 1.00018678099958],
            [34.358726969052135, 1.000775339298739],
            [34.35997633966109, 1.000615442907488],
            [34.36243754297819, 1.001082137216074],
            [34.36291733137482, 1.000702497939687],
            [34.36430244640634, 1.001349797892548],
            [34.36526501369115, 1.001243122176417],
            [34.365296373877726, 1.001987011179509],
            [34.364830872287406, 1.002656095281587],
            [34.36539801645551, 1.003612136184996],
            [34.365223127944425, 1.005062674523665],
            [34.366459029214, 1.005137167533275],
            [34.36762720559597, 1.006624478343108],
            [34.369198106601296, 1.00583615219686],
            [34.36966155104966, 1.005956543821583],
            [34.36997097485095, 1.007683553285247],
            [34.3691480713383, 1.008343772119504],
            [34.369304602776566, 1.008905211219165],
            [34.37009234263573, 1.009805342442592],
            [34.37167210462303, 1.0101846168993],
            [34.371352565791625, 1.011336984157095],
            [34.37188278740493, 1.013595791975336],
            [34.37256819927176, 1.014148900495644],
            [34.37257458090354, 1.015356700759915],
            [34.37379942930186, 1.016661699154165],
            [34.373401732549155, 1.01772385604464],
            [34.37426939372253, 1.019087508682571],
            [34.37364371443219, 1.02074721465588],
            [34.37459697157739, 1.021912779484029],
            [34.37417593839026, 1.022352096235102],
            [34.37429153090606, 1.022957747220181],
            [34.37324365690692, 1.023341811879661],
            [34.37291309754362, 1.024280793090226],
            [34.37130413402138, 1.025932028419704],
            [34.370517779364405, 1.028107851194459],
            [34.369660918635674, 1.028387731041956],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1092,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUKIGAI",
        Population: 17756,
        Key: "BUDUDABUKIGAI",
        Dist2: "Bududa",
        "Sub Country": "Bukigai",
        id2_original: "Bududa Bukigai",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.681932182654975, 1.376005062370224],
            [34.682005409723665, 1.376479908662138],
            [34.684160425869464, 1.378341310530668],
            [34.6850049751872, 1.379814778241985],
            [34.68644738476757, 1.380157395105692],
            [34.68725456506779, 1.38119680425728],
            [34.68701877347539, 1.382101309989323],
            [34.68740130217449, 1.383014415138074],
            [34.688285812149324, 1.383809595662368],
            [34.689789058335684, 1.383618605762623],
            [34.69046729625666, 1.384178805997984],
            [34.69029026077201, 1.38794096679813],
            [34.691009219324854, 1.389685813306385],
            [34.69002329943589, 1.391594672158636],
            [34.69188071630446, 1.393483387111228],
            [34.692120725487136, 1.395346141547692],
            [34.692119230690494, 1.396395170203624],
            [34.69098835235911, 1.397417888275872],
            [34.69079319785521, 1.398593664661774],
            [34.690879394799964, 1.398973422945714],
            [34.6923651948052, 1.399505899507721],
            [34.693305764145315, 1.400925017695923],
            [34.69155550461205, 1.405927261297751],
            [34.69039210457241, 1.40780008369366],
            [34.690754314278145, 1.408550416507677],
            [34.69211343296366, 1.409399495252984],
            [34.692207605151516, 1.409932983330312],
            [34.69235489741706, 1.411696325723856],
            [34.69105595327919, 1.413288907689637],
            [34.691334990667684, 1.415504321498398],
            [34.689920102772696, 1.415975615245165],
            [34.68866804799768, 1.415632888658859],
            [34.6876489883596, 1.415968240532663],
            [34.687885748335866, 1.417966649356944],
            [34.6867711753252, 1.419794227797898],
            [34.688562169863346, 1.422949040174477],
            [34.68765556492578, 1.42501159426815],
            [34.69071683656447, 1.427288253710388],
            [34.69920594115222, 1.431794551911338],
            [34.70147198277894, 1.43253440675073],
            [34.701947077478195, 1.43402619426913],
            [34.70168143486888, 1.440076355832022],
            [34.70192549814843, 1.44278011530823],
            [34.70395712979162, 1.446215028149768],
            [34.70173269723058, 1.446316187537185],
            [34.69762691219022, 1.444944705418495],
            [34.69567033029744, 1.442739609642623],
            [34.693660922076035, 1.44123992604227],
            [34.69260974586992, 1.441439667906359],
            [34.69001114073851, 1.443639146866029],
            [34.69002487238595, 1.44701230455975],
            [34.69058201111844, 1.448558297460219],
            [34.68840422447682, 1.447689344548299],
            [34.68589439086181, 1.445686029659172],
            [34.68414737694165, 1.445126648011286],
            [34.68345484233294, 1.444268045375944],
            [34.68128533276834, 1.443482889614387],
            [34.6802253458859, 1.440110494501385],
            [34.67793644842346, 1.440564267100782],
            [34.677549109245994, 1.441533484306941],
            [34.67584915626695, 1.439917458122868],
            [34.67341465716826, 1.439813883643725],
            [34.67250937814407, 1.439381749870026],
            [34.67204414514998, 1.436030087867622],
            [34.66941242003239, 1.43391106990785],
            [34.669949491299725, 1.431635694936114],
            [34.669549906288324, 1.430668870388534],
            [34.66784385734174, 1.428279696649532],
            [34.66444591869412, 1.425607069361207],
            [34.66366048031872, 1.424583900295363],
            [34.666377461844974, 1.424011550310678],
            [34.66704545807341, 1.423382194522283],
            [34.66967502364109, 1.422502786058683],
            [34.66983443777307, 1.421903050766363],
            [34.66513745617289, 1.417285012496692],
            [34.66414913868045, 1.417037105718751],
            [34.66352480865965, 1.417768802111735],
            [34.662739878730704, 1.417447624270277],
            [34.662840898776, 1.416467683273611],
            [34.66185135957477, 1.414508662157165],
            [34.66015047863602, 1.413530021181159],
            [34.65943863384196, 1.413808407873358],
            [34.65812989447419, 1.412536982378511],
            [34.65775109019025, 1.411147886535603],
            [34.657009569550745, 1.410563422220734],
            [34.656341390964336, 1.410944151139629],
            [34.65482958652829, 1.410199362717589],
            [34.65357901936337, 1.408986388015004],
            [34.652007430248524, 1.405887018111487],
            [34.65076881966007, 1.401003157642411],
            [34.65012861550991, 1.399833614013725],
            [34.64864585181036, 1.399044915609729],
            [34.64832574973527, 1.398460142930949],
            [34.64851272867176, 1.395695885770683],
            [34.64814805488723, 1.39370714334737],
            [34.64692610086078, 1.391821378669199],
            [34.6444105862999, 1.389556269436808],
            [34.6430286009988, 1.387392733096647],
            [34.64141518632434, 1.386779610509573],
            [34.63974279814979, 1.38493802180897],
            [34.6376498349289, 1.384310603377136],
            [34.637648337437305, 1.382131467538474],
            [34.637051905496, 1.381195876567193],
            [34.634720965081605, 1.380304816164353],
            [34.634122801188404, 1.379654732297731],
            [34.63474586278802, 1.375853290860747],
            [34.635881246170555, 1.373004822521398],
            [34.638209566199286, 1.370350962737652],
            [34.6424762089643, 1.362642543613826],
            [34.644333895327456, 1.361384939625955],
            [34.644555316570255, 1.360658910503124],
            [34.64397161645145, 1.358928374071321],
            [34.6406411367901, 1.356334246029127],
            [34.63969831806851, 1.35680950303234],
            [34.635921759291556, 1.35671938146869],
            [34.638768726141116, 1.354807091998601],
            [34.6387683066279, 1.354185027122777],
            [34.638132797073396, 1.353778751739035],
            [34.63842823410572, 1.353414325203404],
            [34.64147593220049, 1.353115384600099],
            [34.64162688779577, 1.351454267721813],
            [34.64440430617773, 1.351871698363262],
            [34.64556637221917, 1.352883782661189],
            [34.64936067990948, 1.354483069529898],
            [34.65123844721253, 1.353639551731156],
            [34.658314459637516, 1.351871199038963],
            [34.66043765655762, 1.352421388771645],
            [34.662202499341234, 1.352067473885033],
            [34.66359842829215, 1.353268937508629],
            [34.66497618791813, 1.356153204484441],
            [34.66725947899492, 1.359217351749045],
            [34.66955455866316, 1.361449483320598],
            [34.67289113968193, 1.363310097592027],
            [34.674163950929916, 1.36447580652912],
            [34.67557896369073, 1.3690417396673],
            [34.678495515838826, 1.374158248511273],
            [34.68023317919519, 1.375290956678605],
            [34.68142304090812, 1.374933324506156],
            [34.681932182654975, 1.376005062370224],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1093,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KWANYIY",
        Population: 10054,
        Key: "KWEENKWANYIY",
        Dist2: "Kween",
        "Sub Country": "kwanyiy",
        id2_original: "Kween  kwanyiy",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.31915810138476, 0.995590978471527],
            [34.31867063418908, 0.996967250809063],
            [34.31863903505065, 0.999594567906244],
            [34.31746575444121, 0.99968767399444],
            [34.31541850109522, 1.000854506525449],
            [34.314696501745175, 1.001933977365507],
            [34.314769725220614, 1.003742407843553],
            [34.31239509793734, 1.00496387504364],
            [34.312053595297236, 1.007103486692257],
            [34.31112646924531, 1.007347964043417],
            [34.30869668989517, 1.006736066011547],
            [34.307206762131244, 1.008684281467285],
            [34.30668447443851, 1.011134321661904],
            [34.30557803836768, 1.013498855568975],
            [34.3060778915345, 1.015789242579457],
            [34.306979116461825, 1.017558874129379],
            [34.3069247665905, 1.018575575070405],
            [34.30768808664697, 1.019611553178805],
            [34.307619467037384, 1.0207084126955],
            [34.30816834396418, 1.021147769130829],
            [34.30818875548405, 1.022929317378179],
            [34.306467057885236, 1.024983455221046],
            [34.30401586719028, 1.026197034742659],
            [34.2997246186713, 1.032314385830634],
            [34.29839468624938, 1.035051781586275],
            [34.29706213703501, 1.032868219538851],
            [34.292668591964734, 1.030129387525246],
            [34.28973900166861, 1.027581398294399],
            [34.28847936601088, 1.023578760423819],
            [34.28895080636357, 1.02103337157687],
            [34.28686817107348, 1.019923471597768],
            [34.28640767938747, 1.018500767110509],
            [34.28375591555083, 1.014536290348796],
            [34.28292960382999, 1.013866291652016],
            [34.28622096994558, 1.012283199172363],
            [34.28648389604944, 1.011557373925308],
            [34.28540736489442, 1.009553434667282],
            [34.28722657371901, 1.00855052328638],
            [34.289090745918514, 1.004675541318582],
            [34.292510578306256, 1.000588547856441],
            [34.2934140148858, 0.998963962953857],
            [34.29531358340247, 0.998629147047934],
            [34.29524394420501, 0.996141000302945],
            [34.29610071869542, 0.992247130211126],
            [34.29544158704224, 0.988043748417548],
            [34.29681171188663, 0.986520730070585],
            [34.29676923774337, 0.985738993569375],
            [34.29891801778444, 0.984512850499453],
            [34.30042599449906, 0.982455498685621],
            [34.30344000756731, 0.979919612116034],
            [34.30351267768054, 0.982199186823453],
            [34.3077546383348, 0.981847513016264],
            [34.309107739206226, 0.982365260012173],
            [34.31040482113656, 0.98750227772815],
            [34.312373961477, 0.989874746134648],
            [34.31249494029127, 0.992767896168344],
            [34.3157771355061, 0.994220985634366],
            [34.31768749548427, 0.994639282424787],
            [34.31915810138476, 0.995590978471527],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1094,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUMASHETI",
        Population: 15930,
        Key: "BUDUDABUMASHETI",
        Dist2: "Bududa",
        "Sub Country": "Bumasheti",
        id2_original: "Bududa Bumasheti",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.619313072108156, 1.452915576404125],
            [34.62000280756645, 1.453545676592391],
            [34.620021325437726, 1.454542924615984],
            [34.620497360673106, 1.45511452337103],
            [34.61982768369676, 1.456441980830265],
            [34.61979169718647, 1.458576565656837],
            [34.62015008366236, 1.459453541814322],
            [34.61958070448581, 1.460394496416552],
            [34.61897918718167, 1.465070510657043],
            [34.618031900239856, 1.466888979458021],
            [34.61613509404269, 1.468210740099476],
            [34.61338475896823, 1.472870245898249],
            [34.61143542378483, 1.475349643030152],
            [34.608011100719004, 1.478436048865411],
            [34.60492149441963, 1.479948606738383],
            [34.60114815161141, 1.482727787354544],
            [34.598319587648724, 1.483317693002213],
            [34.59626335653981, 1.488700233070759],
            [34.59555164828964, 1.490111580722904],
            [34.59455928748013, 1.490980508151942],
            [34.5928929189163, 1.491026943409744],
            [34.591451382498384, 1.489752820609815],
            [34.58946871263146, 1.487321481476016],
            [34.58852198174677, 1.485251137518717],
            [34.58665488553101, 1.483416595800819],
            [34.586083473467006, 1.48153589549004],
            [34.582822487476015, 1.477477568086529],
            [34.58012637650872, 1.477967870743101],
            [34.57693873346911, 1.479127768217289],
            [34.57301325647596, 1.478153840059735],
            [34.571650132202585, 1.477349907835022],
            [34.57119355896785, 1.476617679282014],
            [34.57060096462942, 1.474140076904675],
            [34.567995163992585, 1.47288482792239],
            [34.56723557733445, 1.47334660514227],
            [34.56682336919664, 1.479008378788124],
            [34.564482670383306, 1.478575936442843],
            [34.56342697026142, 1.478061183628359],
            [34.56112415609857, 1.475584781712744],
            [34.560200500238594, 1.473541507432584],
            [34.5597108213907, 1.471235650495117],
            [34.558154720129686, 1.47075741842975],
            [34.55603752036241, 1.469456579565538],
            [34.55339501815633, 1.468734917217674],
            [34.550572942724976, 1.466611560132423],
            [34.54685419772308, 1.465718800454851],
            [34.545212462760986, 1.464860764226925],
            [34.54217988780401, 1.464546330884472],
            [34.53834969690968, 1.465778972375422],
            [34.53734026451649, 1.467217671245211],
            [34.53697735681982, 1.470383333176575],
            [34.53618061673979, 1.472382617315947],
            [34.535572726787045, 1.472943769364686],
            [34.53393599903431, 1.472854465917335],
            [34.53185634974424, 1.471454080171427],
            [34.530884801103205, 1.471626589625807],
            [34.53024782280325, 1.47009805840923],
            [34.530476024529804, 1.469008116483685],
            [34.531044652714776, 1.468067396288563],
            [34.53256003603892, 1.467182068313819],
            [34.53275770672393, 1.466689972631104],
            [34.5321496963969, 1.464317778928229],
            [34.532722149608354, 1.462816415981239],
            [34.53212443756775, 1.462507235784598],
            [34.532428956567585, 1.461236441777844],
            [34.53355479355363, 1.46001398946152],
            [34.5334769527376, 1.459162793995304],
            [34.534562452672446, 1.457562972675597],
            [34.53447424889131, 1.456560360288108],
            [34.535570386675744, 1.456043422899958],
            [34.537070294722454, 1.453419572154315],
            [34.53594414961431, 1.453055374875257],
            [34.53638276372987, 1.452391247421433],
            [34.53597455938332, 1.452037166248763],
            [34.536335475514996, 1.451340608043323],
            [34.53596398351746, 1.450592843203628],
            [34.5370714661256, 1.449762205425599],
            [34.53733076573068, 1.449074839632454],
            [34.5361465687939, 1.448463154962072],
            [34.5359420161155, 1.447764923527728],
            [34.53668373258771, 1.447099615409797],
            [34.5377751299624, 1.447600877958145],
            [34.538729249490274, 1.447419345064796],
            [34.53987040814177, 1.446423722028318],
            [34.539778352384715, 1.444841081776548],
            [34.540686695562336, 1.442209196842689],
            [34.54064989158515, 1.44070433215029],
            [34.54123930049757, 1.438894810018811],
            [34.54047236741701, 1.436922217172075],
            [34.54126037227919, 1.436248256928325],
            [34.54123451427374, 1.43538004917473],
            [34.5416788758105, 1.434692402443144],
            [34.54101669078365, 1.432169572115469],
            [34.54140339036066, 1.430921236240904],
            [34.5439165234877, 1.42722957959209],
            [34.546429865922235, 1.424543785852221],
            [34.5477906518809, 1.423754063087546],
            [34.548565945581814, 1.424097208751455],
            [34.552688017976585, 1.423551774641916],
            [34.557669520281785, 1.424553386772649],
            [34.55849262861033, 1.423665396206758],
            [34.55900649639388, 1.421114656195335],
            [34.56012667579024, 1.419015701066663],
            [34.560614295699516, 1.414167822139643],
            [34.560039312832245, 1.412685007584797],
            [34.5563281235602, 1.409458827191198],
            [34.55659249325674, 1.408373375239803],
            [34.55470216660773, 1.406041306704942],
            [34.55436148412948, 1.4047465897571],
            [34.56964630341742, 1.407536390980373],
            [34.574334391696304, 1.407486565689696],
            [34.59442705277536, 1.405881350550294],
            [34.595653837043095, 1.407275643822696],
            [34.597120034910496, 1.407796184386037],
            [34.59775173381154, 1.408663675100227],
            [34.59810483100702, 1.411213411332489],
            [34.599328349000416, 1.413026621932285],
            [34.59927317627228, 1.414424345933355],
            [34.60085721603695, 1.416893523397098],
            [34.60105698608478, 1.418156168161141],
            [34.60083331366389, 1.419129531199935],
            [34.599572849759504, 1.419846691264417],
            [34.597306672487186, 1.420510054067976],
            [34.59466192179798, 1.421889960954665],
            [34.59217343035747, 1.422163865429019],
            [34.59226527321378, 1.424079407845761],
            [34.59381356362341, 1.425666607432643],
            [34.59533780523459, 1.426031470042039],
            [34.59598203832878, 1.429137503347943],
            [34.59783231987907, 1.431129336121247],
            [34.59860758932546, 1.433534561946289],
            [34.59808238659964, 1.434749494933265],
            [34.60076828012888, 1.436904227778979],
            [34.60154845168177, 1.437029966736747],
            [34.60155044145014, 1.438087093832503],
            [34.602820087035056, 1.439433111901935],
            [34.603254120640976, 1.440600650841211],
            [34.603804853487176, 1.443627702369762],
            [34.604817836022356, 1.445182616805083],
            [34.607519929769424, 1.447528240915005],
            [34.6080499618382, 1.44867885774344],
            [34.608577581032115, 1.449051571726844],
            [34.61028484899252, 1.448897958642539],
            [34.61368266277431, 1.447103629598456],
            [34.61449719578518, 1.44711355461252],
            [34.61521905140475, 1.448019334094821],
            [34.61645648340358, 1.448149525760982],
            [34.617386325062604, 1.449565471788789],
            [34.618690701313, 1.45051344500793],
            [34.6186784869201, 1.451628527187812],
            [34.619313072108156, 1.452915576404125],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1095,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KAPTUM",
        Population: 9404,
        Key: "KWEENKAPTUM",
        Dist2: "Kween",
        "Sub Country": "Kaptum",
        id2_original: "Kween  Kaptum",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.507235960444326, 1.459853984990687],
            [34.50579247827553, 1.461331196689321],
            [34.50602845312424, 1.465268075405321],
            [34.50493091486629, 1.466194096171042],
            [34.505072453422464, 1.467800383371002],
            [34.503281334916814, 1.469439579151461],
            [34.50390921507961, 1.470362199185824],
            [34.50515347247796, 1.470775131861134],
            [34.505681220130946, 1.471724341684671],
            [34.50521765890163, 1.472164960026758],
            [34.50474822448698, 1.471709061892174],
            [34.503857625731136, 1.472033264671943],
            [34.50356314720122, 1.473587274930535],
            [34.50416764421716, 1.475134084697983],
            [34.50615954157871, 1.475993900438908],
            [34.506345362586806, 1.476525005724226],
            [34.50510422234248, 1.476568926837892],
            [34.504408293898635, 1.477182557032381],
            [34.504338534326905, 1.480076705970013],
            [34.503628553537055, 1.480048323289529],
            [34.50353570187267, 1.480604112251381],
            [34.5029119719265, 1.480864357986259],
            [34.500397270340954, 1.480110090596825],
            [34.498356059063546, 1.480078349338502],
            [34.495660432288226, 1.482051520368297],
            [34.493833475494306, 1.482278868961507],
            [34.492510774510386, 1.483998168593099],
            [34.488709671963264, 1.486099012944892],
            [34.48751544803128, 1.487610211377676],
            [34.486861922763794, 1.489672741317925],
            [34.48561937485942, 1.491156842511245],
            [34.48288289360327, 1.492822845492521],
            [34.476629616705935, 1.493451143761921],
            [34.4737749575826, 1.493127481128897],
            [34.47062603372835, 1.492044290998668],
            [34.465928139439825, 1.489478865078193],
            [34.46454677667124, 1.489181328618762],
            [34.46310063818413, 1.489462671232117],
            [34.460467981513574, 1.491915449806211],
            [34.458805449654314, 1.491979872199402],
            [34.45755723068557, 1.490877295238644],
            [34.45701804029248, 1.488354278382169],
            [34.455759699107105, 1.486374400329017],
            [34.45465532287323, 1.485344076523575],
            [34.453345319575845, 1.485091703302165],
            [34.45140849073787, 1.48399861670207],
            [34.44973842201336, 1.480255343711351],
            [34.448592866108534, 1.478944663653353],
            [34.44781030234204, 1.477859849242131],
            [34.44760055829961, 1.476506447304569],
            [34.44898924952428, 1.474367938178173],
            [34.4490651104534, 1.472685631249872],
            [34.4497973047836, 1.472323375920603],
            [34.45062739392021, 1.472214298973566],
            [34.451681587567364, 1.472964290882395],
            [34.45374498992724, 1.472655425497338],
            [34.45934008558892, 1.474740983756065],
            [34.46076264599475, 1.474486801618155],
            [34.462458620335426, 1.473192338165957],
            [34.463477321545696, 1.472920333776846],
            [34.465036930727905, 1.470097470206402],
            [34.46635323930025, 1.468848482639252],
            [34.46749902876705, 1.466233916225502],
            [34.46919321456197, 1.464794749752253],
            [34.46953715972131, 1.462536360454974],
            [34.47022277191247, 1.461426205737318],
            [34.470463618325, 1.459801124620408],
            [34.47096117539791, 1.459313886525882],
            [34.470769317711124, 1.458241188608598],
            [34.47196104881819, 1.458425324004696],
            [34.47706776998575, 1.455876278845833],
            [34.47883793259248, 1.456210611842938],
            [34.48030408644242, 1.454858922820133],
            [34.4803836843631, 1.453084919944252],
            [34.4795474175123, 1.452065291550702],
            [34.478924294827266, 1.448172879886565],
            [34.4790620927986, 1.443567968097119],
            [34.47844933577361, 1.442078439076616],
            [34.47826868546827, 1.439231521712361],
            [34.478896910584155, 1.438082415083994],
            [34.47972574746923, 1.437347450030803],
            [34.480066129910185, 1.436337866257702],
            [34.48155794413622, 1.435912038713091],
            [34.48366932910865, 1.432021409861773],
            [34.485785836274836, 1.430089121208041],
            [34.48525317663385, 1.425896982701607],
            [34.486424303083226, 1.424065166761898],
            [34.486824109978535, 1.419091163349345],
            [34.48553112706086, 1.414872498270838],
            [34.48459019390301, 1.413908953530528],
            [34.483771655304324, 1.410846248294615],
            [34.48265364803435, 1.409370494733571],
            [34.481525503276366, 1.408627645582721],
            [34.48154957543102, 1.407563858561136],
            [34.48286811631685, 1.407523877632008],
            [34.4831188208413, 1.407078996352574],
            [34.4810212986703, 1.405098664800797],
            [34.48059623833575, 1.403739869975131],
            [34.479932201881084, 1.403032714563532],
            [34.479991114295736, 1.402027720986943],
            [34.47847436104078, 1.40101912042322],
            [34.47826307638766, 1.400247646960228],
            [34.477153789962415, 1.398770331286173],
            [34.47694663486465, 1.397115510965512],
            [34.47864800358859, 1.393048506543425],
            [34.47812977538264, 1.39202082843726],
            [34.476938261667875, 1.391044283085788],
            [34.476864489321805, 1.390109404198258],
            [34.47832316829027, 1.389205115260424],
            [34.47955059215851, 1.38938645514957],
            [34.480404495633294, 1.386926614460503],
            [34.481946608328734, 1.386300478974182],
            [34.48167494161712, 1.384359355985501],
            [34.48266098098199, 1.383257969954658],
            [34.48357407984075, 1.383088440796683],
            [34.48388857373352, 1.382606969983196],
            [34.4836480731724, 1.381941801235282],
            [34.48249112752808, 1.38170655508013],
            [34.48292540637407, 1.380725746899881],
            [34.48272892865178, 1.379279710843053],
            [34.50053193409025, 1.389919894794922],
            [34.517092859646624, 1.391722290496502],
            [34.52165302154085, 1.394958896540513],
            [34.52177829430215, 1.397129648040704],
            [34.52119770415086, 1.399096898190287],
            [34.5190555015743, 1.401930847827075],
            [34.519689112090276, 1.403712711277117],
            [34.51840340462809, 1.406214352748769],
            [34.51895777385453, 1.408212970223122],
            [34.51815175058441, 1.40912677917841],
            [34.516806585430174, 1.409626452391242],
            [34.51532994015603, 1.411204977812387],
            [34.51574684827939, 1.413474077659087],
            [34.515392286830014, 1.415583931049403],
            [34.51576271522225, 1.416887944768784],
            [34.51482757889298, 1.418134854076625],
            [34.516679291459475, 1.421044000283483],
            [34.517070797023244, 1.423104456467453],
            [34.514828276883954, 1.424141940014743],
            [34.51437683123286, 1.426413095350698],
            [34.51291364182333, 1.427485553235031],
            [34.510818015995945, 1.428103049332884],
            [34.510232794131056, 1.429018346560042],
            [34.50735621970802, 1.42740583632998],
            [34.50307749011086, 1.426115269471052],
            [34.50180105505902, 1.426319531576792],
            [34.502150462873615, 1.431956218826305],
            [34.50166990192586, 1.435462641305365],
            [34.50347357348931, 1.438590503765653],
            [34.504088127144826, 1.441191290473577],
            [34.505793797900665, 1.44376363808835],
            [34.507751562874695, 1.445307560549703],
            [34.50792572914028, 1.446823628697452],
            [34.50706561740856, 1.452190526774438],
            [34.50733364684156, 1.453300067304693],
            [34.50661615344098, 1.45657224026113],
            [34.507235960444326, 1.459853984990687],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1096,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KAPTOYOY",
        Population: 8239,
        Key: "KWEENKAPTOYOY",
        Dist2: "Kween",
        "Sub Country": "kaptoyoy",
        id2_original: "Kween  kaptoyoy",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39366233187392, 1.026323984952665],
            [34.39597356953918, 1.027124255363684],
            [34.397521152076386, 1.028281315788857],
            [34.39913455597105, 1.027205403311082],
            [34.40014943574813, 1.024803290985808],
            [34.400805506841174, 1.024972461601323],
            [34.40275094423454, 1.026502588080866],
            [34.40701879972519, 1.02872120559696],
            [34.40875749165254, 1.028343878760859],
            [34.41049053048182, 1.029122856638773],
            [34.41107412010785, 1.03057613550427],
            [34.4123202531885, 1.03175137183409],
            [34.41425122950242, 1.032247956316933],
            [34.415359344524525, 1.033721720094063],
            [34.41734883440112, 1.034462476875763],
            [34.41900109312677, 1.035845546165336],
            [34.42163577909157, 1.035166014273075],
            [34.42223794228438, 1.035473256205784],
            [34.4234682614228, 1.035290960311279],
            [34.42471923282958, 1.036686146427164],
            [34.4263492600486, 1.03764573037193],
            [34.428909297809895, 1.037847365482438],
            [34.43180788544897, 1.039784582845524],
            [34.43231789227342, 1.040643271145857],
            [34.4331058746777, 1.040314849136284],
            [34.43471779994544, 1.040558662903927],
            [34.436182019722565, 1.041768830626424],
            [34.437609949358844, 1.041362571793915],
            [34.44053175485477, 1.042232073591201],
            [34.445368500838455, 1.04511078805337],
            [34.44772820440991, 1.047823627654849],
            [34.450075548061406, 1.049427032421089],
            [34.45180744423364, 1.052826092315539],
            [34.45302285762652, 1.054185468061851],
            [34.457912617686716, 1.056342371301985],
            [34.46106519678581, 1.056507887398766],
            [34.46330014143231, 1.05850498355889],
            [34.4640301771109, 1.060985931419256],
            [34.46642576119146, 1.06433095162709],
            [34.46905747193603, 1.06576120061428],
            [34.47324583640551, 1.067050590585423],
            [34.47575410874855, 1.068824442520621],
            [34.47905055034549, 1.073279297077796],
            [34.48171109970562, 1.078339877908006],
            [34.48370001915202, 1.080476266501231],
            [34.4850834749952, 1.084226988745453],
            [34.48635845657291, 1.085795017811596],
            [34.48824945426344, 1.086936173426867],
            [34.48969927045331, 1.087057516676216],
            [34.49233237538317, 1.086627729486619],
            [34.49255813099724, 1.085263719266786],
            [34.495638794567974, 1.085684167644928],
            [34.49780634760185, 1.086681651941976],
            [34.50101691474919, 1.089192273463349],
            [34.501341184108874, 1.090368637172824],
            [34.50585833107405, 1.09743455900133],
            [34.51098545118511, 1.101595028159431],
            [34.513913567345874, 1.107256623360251],
            [34.515223555371904, 1.107937012259787],
            [34.51769618975101, 1.10800813564846],
            [34.518406743666006, 1.108487425638047],
            [34.51942169800325, 1.110308824429338],
            [34.5193930246777, 1.111492084760065],
            [34.52023938859231, 1.113522609530113],
            [34.51618098698821, 1.111390028398971],
            [34.5052802472224, 1.107480288136575],
            [34.4999546317729, 1.103553589262543],
            [34.49625174742569, 1.099961545698751],
            [34.49434559964788, 1.096832010423135],
            [34.49326461913727, 1.095846735364007],
            [34.48760236362829, 1.092151633062434],
            [34.48279699489918, 1.090864461388632],
            [34.47878956100937, 1.084024046250138],
            [34.47626899073009, 1.081357217763523],
            [34.473951759505226, 1.079938397015099],
            [34.47065958041433, 1.079614410674342],
            [34.46814152721445, 1.080999422310323],
            [34.46558478357531, 1.081353398807184],
            [34.45713745693647, 1.079232072905348],
            [34.45489389475144, 1.07803929734973],
            [34.45224943781132, 1.075833737287556],
            [34.444623312377665, 1.072888906529968],
            [34.44159988676186, 1.070900567750148],
            [34.435162134532746, 1.06442777510196],
            [34.43395722873372, 1.063804272180029],
            [34.43211563209564, 1.063524756551667],
            [34.42224414964299, 1.064044901031515],
            [34.414637772772565, 1.062592258303408],
            [34.41258705103125, 1.061878684731465],
            [34.40954702993893, 1.057972830617936],
            [34.40773096701445, 1.058299267631829],
            [34.40643513464072, 1.057802408837321],
            [34.404860885614305, 1.053868731678],
            [34.39842107175159, 1.047685138681876],
            [34.39594537232076, 1.047306378840579],
            [34.39398551876371, 1.045816313411821],
            [34.39420600126704, 1.045028198110235],
            [34.39390706350004, 1.044263265175798],
            [34.39091651352871, 1.042759862327001],
            [34.38950998086419, 1.038346016592944],
            [34.38818961999161, 1.036971814213232],
            [34.38510116084083, 1.031302172914672],
            [34.38377818317581, 1.030353062409558],
            [34.38024741424037, 1.030042561420704],
            [34.37798219008061, 1.027993044323214],
            [34.37785962663819, 1.026673012453376],
            [34.37881146534357, 1.025308297805349],
            [34.37872367388916, 1.024883235442173],
            [34.37621536022358, 1.020094347202628],
            [34.37753988748246, 1.020669292781503],
            [34.37895534940093, 1.022763916283474],
            [34.38198751562443, 1.021123555295109],
            [34.38351879014593, 1.021601505247696],
            [34.38994914564703, 1.025705209625976],
            [34.39366233187392, 1.026323984952665],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1097,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUMAYOKA",
        Population: 19251,
        Key: "BUDUDABUMAYOKA",
        Dist2: "Bududa",
        "Sub Country": "Bumayoka",
        id2_original: "Bududa Bumayoka",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.36198262803347, 1.085733122427365],
            [34.359830193645834, 1.086289366214423],
            [34.35778381975051, 1.087350727888901],
            [34.35594751957931, 1.087006162048785],
            [34.35354493313111, 1.088411544909358],
            [34.350412804179435, 1.089481902634795],
            [34.347926405813546, 1.088303141408155],
            [34.34718094965481, 1.088885756292054],
            [34.342466890182756, 1.088094803979722],
            [34.340950319285774, 1.086284682342172],
            [34.339810720109604, 1.086375026737211],
            [34.33931391851982, 1.086885171771746],
            [34.33911045639619, 1.086368429797476],
            [34.33864773778659, 1.086325735157507],
            [34.336850768553504, 1.087337748672325],
            [34.338222516653616, 1.083964673745758],
            [34.33864283837505, 1.079206996391757],
            [34.33512597446189, 1.079532809624877],
            [34.33172754802908, 1.078105224714407],
            [34.32892698635044, 1.079951614274659],
            [34.32547958287002, 1.0795642037639],
            [34.32205020228916, 1.07670752080718],
            [34.31897515857883, 1.072421576132194],
            [34.315453153607315, 1.070948782687833],
            [34.31490634550062, 1.070134975656635],
            [34.31465521697137, 1.068624580583916],
            [34.313154089012464, 1.066192141287482],
            [34.3116216484777, 1.060096510028693],
            [34.30919761295547, 1.058587038738985],
            [34.307914977731556, 1.056172581738398],
            [34.30814151847315, 1.053983606765731],
            [34.30998763184051, 1.052797933987455],
            [34.31135223384254, 1.053024308040698],
            [34.314459089592006, 1.05106845385715],
            [34.31744431524864, 1.047104120110942],
            [34.321102662920715, 1.045301392312231],
            [34.32263949082731, 1.044064213601373],
            [34.32581519076523, 1.04303830111997],
            [34.329495019850704, 1.039808771390683],
            [34.33018436094857, 1.039851250215529],
            [34.33084506106025, 1.03914761146867],
            [34.332427134412775, 1.039111788055917],
            [34.332809338820105, 1.039540534596361],
            [34.33356249803241, 1.039175552562695],
            [34.33399980779418, 1.039823652227431],
            [34.33488539574736, 1.039858004433956],
            [34.335207881052874, 1.04094606033238],
            [34.335949584948686, 1.040691059025233],
            [34.335950097886695, 1.041906595039629],
            [34.336519545335186, 1.042259435340404],
            [34.33651978967697, 1.042838261484887],
            [34.335841470009285, 1.043400014279124],
            [34.33669850770611, 1.043909014080626],
            [34.337803660982715, 1.046409067651461],
            [34.340616031015735, 1.047316610738719],
            [34.3406565001193, 1.047820172413864],
            [34.341519261881096, 1.048265494299323],
            [34.34168624431937, 1.048780576581714],
            [34.3423301432403, 1.048415637834379],
            [34.34307779757655, 1.04863526788547],
            [34.34380276406198, 1.049584226492239],
            [34.346344096204106, 1.050437236613038],
            [34.34698803734587, 1.050764007636034],
            [34.34882856049719, 1.050574225529854],
            [34.35039570205306, 1.051567897744527],
            [34.35200308364208, 1.053296123761699],
            [34.35325245514934, 1.056118788979646],
            [34.354910841283555, 1.057945010943557],
            [34.354858414705255, 1.058785285532542],
            [34.352771677707615, 1.062638700401884],
            [34.352783208482585, 1.064889514770985],
            [34.35321066552233, 1.06550511546214],
            [34.3528438537474, 1.06801231987283],
            [34.35362327610538, 1.069351624975615],
            [34.353531649743, 1.070558869663196],
            [34.35557945914615, 1.071992106618079],
            [34.3566745405118, 1.072261749822136],
            [34.35741510264887, 1.071931856378622],
            [34.357898396271736, 1.07243408837033],
            [34.359100802957634, 1.072655059463034],
            [34.36054014029969, 1.074599372127056],
            [34.36144511569333, 1.075048401341663],
            [34.362056682450564, 1.076710975117726],
            [34.36198262803347, 1.085733122427365],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1098,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUSHIKA",
        Population: 30926,
        Key: "BUDUDABUSHIKA",
        Dist2: "Bududa",
        "Sub Country": "Bushika",
        id2_original: "Bududa Bushika",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.787452299718886, 1.363597051413417],
            [34.78279842467592, 1.368909487026268],
            [34.78300729016598, 1.369847510267272],
            [34.782372510941826, 1.370844990879672],
            [34.781357567384376, 1.375864566855576],
            [34.78062002987487, 1.377104001863922],
            [34.77920566749432, 1.378145003703328],
            [34.778460371235674, 1.379520087826086],
            [34.77764541601668, 1.38004456081949],
            [34.77685284591622, 1.382098534104574],
            [34.776357059422686, 1.384459114414324],
            [34.77678545789685, 1.385860444956514],
            [34.77794297037811, 1.386942238771124],
            [34.77785332210601, 1.389295949550098],
            [34.778585569436814, 1.390751307547248],
            [34.77765993907985, 1.392316859882454],
            [34.77757288783726, 1.393527588214945],
            [34.77672929971688, 1.393357081817306],
            [34.77568821069307, 1.394180780011726],
            [34.775471366366645, 1.394558970116782],
            [34.77593115287513, 1.394803525068316],
            [34.775803089048225, 1.395120340609775],
            [34.77478433843061, 1.395550603925791],
            [34.77413407764083, 1.395312328209978],
            [34.77399408508526, 1.395845967677021],
            [34.7723539095985, 1.396073288941576],
            [34.77188828943053, 1.39671569267437],
            [34.77053538978172, 1.396617249506458],
            [34.77034896330911, 1.397386044387491],
            [34.7707293558145, 1.398680558854316],
            [34.76974311163375, 1.39824558495272],
            [34.769022275601976, 1.399206059450331],
            [34.76913892902816, 1.400107917124049],
            [34.7685005062372, 1.39937092838038],
            [34.76762972611318, 1.399486077807272],
            [34.76708534166111, 1.400495293294993],
            [34.76571050694967, 1.401296135495617],
            [34.764917550573664, 1.40127865322179],
            [34.76387750269729, 1.403504018018887],
            [34.76207346102793, 1.405206649341859],
            [34.76116697556631, 1.407503089703912],
            [34.759293683670045, 1.40841786164057],
            [34.758998916780925, 1.409250040152245],
            [34.757008982238276, 1.409640408884103],
            [34.7563708118739, 1.408600944045895],
            [34.754878671559425, 1.40931647651677],
            [34.754020552291024, 1.407779813041443],
            [34.75396159316396, 1.404786610247792],
            [34.754384069045464, 1.404261793418769],
            [34.75379540214147, 1.403053244792245],
            [34.75416682766366, 1.402237674335794],
            [34.75397342217964, 1.400765505724561],
            [34.7535226385869, 1.400409715706557],
            [34.753245517304904, 1.400973949569949],
            [34.752787591207344, 1.400039624234339],
            [34.75182706758983, 1.400336290487016],
            [34.75159821368634, 1.399888464041415],
            [34.75068443570125, 1.399792634323916],
            [34.750642530191556, 1.399478794643451],
            [34.75128217109804, 1.399275628489704],
            [34.751152613372824, 1.398388385325031],
            [34.75016081490866, 1.397285306734603],
            [34.74988926946961, 1.393198928979389],
            [34.7504062076948, 1.390663826634837],
            [34.751007534556116, 1.389859872659203],
            [34.750114433093884, 1.388999976099315],
            [34.750819904341036, 1.38856059995746],
            [34.750778896248306, 1.388073434812495],
            [34.74936282167882, 1.386782250782943],
            [34.74837050039518, 1.385005488927664],
            [34.74855550124143, 1.384695969607499],
            [34.74950980492394, 1.384850016218622],
            [34.74907470591609, 1.38383603704535],
            [34.74979211577333, 1.382655303235471],
            [34.7496242961052, 1.379396962697902],
            [34.74909938892513, 1.37731744637492],
            [34.74686844267995, 1.37371086973223],
            [34.74548352258286, 1.37360341180903],
            [34.744749379806784, 1.371053801072104],
            [34.74301784655395, 1.369997030725372],
            [34.74224567449864, 1.367655433650976],
            [34.74167489574688, 1.367348385335003],
            [34.74294733329571, 1.36489677417738],
            [34.743088041808534, 1.36221991415771],
            [34.741642341699304, 1.358793631444711],
            [34.739141649340624, 1.357203859709949],
            [34.736799672224656, 1.356889048100155],
            [34.734755867511026, 1.351668853255499],
            [34.73499304071237, 1.349083964832958],
            [34.734352273318514, 1.348186679707974],
            [34.733909530545894, 1.345205254803892],
            [34.73440055057849, 1.342334381218072],
            [34.73531249240715, 1.340815104349801],
            [34.73514476975711, 1.339732314504067],
            [34.73571345902749, 1.33724401980073],
            [34.73708001037369, 1.334997877674406],
            [34.737271381173585, 1.33349564077116],
            [34.73789463680928, 1.332700786753672],
            [34.73712501237615, 1.33219080557526],
            [34.737949222937544, 1.330903610535182],
            [34.737524475216674, 1.330091010652662],
            [34.73420461004873, 1.327262821935639],
            [34.73158501308578, 1.32036375012928],
            [34.72782815256637, 1.315620413069957],
            [34.73320699050154, 1.312045337017209],
            [34.73590766760541, 1.310973243295029],
            [34.73887799739798, 1.310383562005288],
            [34.741111165176854, 1.308396295287926],
            [34.7425574285298, 1.30767889994401],
            [34.74349227739821, 1.308365472247354],
            [34.74426578075674, 1.309650982482872],
            [34.746881521252185, 1.310725839266],
            [34.74840363565275, 1.310914111003247],
            [34.7494676730388, 1.311679127904047],
            [34.75318050892275, 1.312026815918212],
            [34.756737098134394, 1.310155992024573],
            [34.76029438443867, 1.309297168330096],
            [34.76172445386198, 1.308128466842738],
            [34.76322083602121, 1.305827857552848],
            [34.764512229819154, 1.305341825412613],
            [34.76496188602621, 1.303395765034312],
            [34.7654764805468, 1.303026136555429],
            [34.76649814979082, 1.303323833086874],
            [34.76798075987842, 1.302425429428739],
            [34.76899520487092, 1.30339343271313],
            [34.769312912037435, 1.302310034715401],
            [34.77013051010003, 1.301791395181122],
            [34.77191173995103, 1.302081110591933],
            [34.776034542676136, 1.301164846301327],
            [34.780984285044454, 1.300754395096627],
            [34.781723946171304, 1.301221569264122],
            [34.782191451903046, 1.30077768330748],
            [34.782766290141545, 1.300986549747671],
            [34.784023069156675, 1.303519357397836],
            [34.78485975731735, 1.304296448577827],
            [34.78591840391336, 1.304485591937299],
            [34.78779424702505, 1.304095403813434],
            [34.788805025094526, 1.305610013387786],
            [34.789857368212196, 1.305694513928003],
            [34.789858009609326, 1.306598800650224],
            [34.79027639546131, 1.307439486718312],
            [34.79119505309507, 1.30808219231215],
            [34.79163326027381, 1.309265168814761],
            [34.79518061300769, 1.30859343844432],
            [34.79592373444499, 1.308873229277487],
            [34.796463001194894, 1.309921809456309],
            [34.79755837002142, 1.308853962747876],
            [34.80577030122491, 1.307325222919517],
            [34.805785030900616, 1.306623473649028],
            [34.81223375874589, 1.304447749436065],
            [34.813356116556804, 1.306462860711895],
            [34.81274102570873, 1.306901667014615],
            [34.81384455303465, 1.308014682650694],
            [34.81739853174209, 1.308155641880575],
            [34.81851804997838, 1.307407957773951],
            [34.819229968434335, 1.307862009739043],
            [34.82045989680557, 1.307821431733088],
            [34.82263947468784, 1.307346805612912],
            [34.823560477822795, 1.306646690857107],
            [34.82476774708932, 1.306609636006079],
            [34.82545442917398, 1.305731990891096],
            [34.82688432522241, 1.30527880878266],
            [34.82770077074649, 1.304473411244757],
            [34.82730915468994, 1.302601862358135],
            [34.83020277823875, 1.30307800533789],
            [34.82981789415695, 1.307003807629594],
            [34.8293877565444, 1.307772751237077],
            [34.826119309146684, 1.311961917979059],
            [34.82132417402528, 1.31711074871022],
            [34.81748935051898, 1.323163162498604],
            [34.809464603067916, 1.332718249769244],
            [34.79682834871589, 1.35218776522186],
            [34.79164995456504, 1.359380700335747],
            [34.787452299718886, 1.363597051413417],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1099,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "RIWO",
        Population: 7635,
        Key: "BUKWORIWO",
        Dist2: "BUKWO",
        "Sub Country": "Riwo",
        id2_original: "BUKWO Riwo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.332427134412775, 1.039111788055917],
            [34.33084506106025, 1.03914761146867],
            [34.33018436094857, 1.039851250215529],
            [34.329495019850704, 1.039808771390683],
            [34.32581519076523, 1.04303830111997],
            [34.32263949082731, 1.044064213601373],
            [34.321102662920715, 1.045301392312231],
            [34.31744431524864, 1.047104120110942],
            [34.314459089592006, 1.05106845385715],
            [34.31135223384254, 1.053024308040698],
            [34.30998763184051, 1.052797933987455],
            [34.31071275014121, 1.051612738581509],
            [34.31019875928847, 1.047316606247883],
            [34.30420577732956, 1.042054956915936],
            [34.302022550490584, 1.038817766605939],
            [34.29839468624938, 1.035051781586275],
            [34.2997246186713, 1.032314385830634],
            [34.30401586719028, 1.026197034742659],
            [34.306467057885236, 1.024983455221046],
            [34.30818875548405, 1.022929317378179],
            [34.30816834396418, 1.021147769130829],
            [34.307619467037384, 1.0207084126955],
            [34.30768808664697, 1.019611553178805],
            [34.3069247665905, 1.018575575070405],
            [34.306979116461825, 1.017558874129379],
            [34.3060778915345, 1.015789242579457],
            [34.30557803836768, 1.013498855568975],
            [34.30668447443851, 1.011134321661904],
            [34.307206762131244, 1.008684281467285],
            [34.30869668989517, 1.006736066011547],
            [34.31112646924531, 1.007347964043417],
            [34.312053595297236, 1.007103486692257],
            [34.31239509793734, 1.00496387504364],
            [34.314769725220614, 1.003742407843553],
            [34.314696501745175, 1.001933977365507],
            [34.31541850109522, 1.000854506525449],
            [34.31746575444121, 0.99968767399444],
            [34.31863903505065, 0.999594567906244],
            [34.31867063418908, 0.996967250809063],
            [34.31915810138476, 0.995590978471527],
            [34.32182733745369, 0.997373862838028],
            [34.322646060206985, 0.998381646673475],
            [34.32094643331638, 1.002881693270952],
            [34.31963221153047, 1.004616570596854],
            [34.32078927215912, 1.006692744258491],
            [34.32255788966354, 1.007376628446488],
            [34.32321588494792, 1.008699932185435],
            [34.32267217782556, 1.009681427416437],
            [34.323194139429816, 1.010981966859309],
            [34.323217607916625, 1.012944498474513],
            [34.32246978829037, 1.013743516564659],
            [34.32251540923207, 1.014428105233276],
            [34.321926341679465, 1.015363978665709],
            [34.3221536010733, 1.016710280480215],
            [34.32111106486357, 1.017532240586951],
            [34.32120216930474, 1.018559116043945],
            [34.32369683306956, 1.020611904032993],
            [34.323946852179425, 1.022163577052993],
            [34.325851254530605, 1.022231244457795],
            [34.32601029047188, 1.023052706465369],
            [34.32845692491173, 1.023031498826],
            [34.328126578449144, 1.02387981596726],
            [34.32739995277538, 1.024333319071419],
            [34.32732959133246, 1.025278592580712],
            [34.326384299548856, 1.025783981048094],
            [34.32725923527938, 1.026236813846872],
            [34.32756857553737, 1.027699870615419],
            [34.32689971692629, 1.027862007502678],
            [34.326597869516085, 1.028962761356939],
            [34.327235134378626, 1.030166708288944],
            [34.32852811909296, 1.030541672722249],
            [34.32874087788148, 1.031752270901896],
            [34.32936937698347, 1.031821026685298],
            [34.33029956718883, 1.032924425178381],
            [34.330068691177644, 1.034176958857752],
            [34.33073871400536, 1.034639313747753],
            [34.33118742338808, 1.034115517813464],
            [34.3320146262377, 1.034651065388636],
            [34.3315692585878, 1.035557065213748],
            [34.332427134412775, 1.039111788055917],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1100,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUDUDA",
        Population: 10796,
        Key: "BUDUDABUDUDA",
        Dist2: "Bududa",
        "Sub Country": "Bududa",
        id2_original: "Bududa Bududa",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.83020277823875, 1.30307800533789],
            [34.82730915468994, 1.302601862358135],
            [34.82770077074649, 1.304473411244757],
            [34.82688432522241, 1.30527880878266],
            [34.82545442917398, 1.305731990891096],
            [34.82476774708932, 1.306609636006079],
            [34.823560477822795, 1.306646690857107],
            [34.82263947468784, 1.307346805612912],
            [34.82045989680557, 1.307821431733088],
            [34.819229968434335, 1.307862009739043],
            [34.81851804997838, 1.307407957773951],
            [34.81739853174209, 1.308155641880575],
            [34.81384455303465, 1.308014682650694],
            [34.81274102570873, 1.306901667014615],
            [34.813356116556804, 1.306462860711895],
            [34.81223375874589, 1.304447749436065],
            [34.81194069326592, 1.3036077619741],
            [34.81230388842349, 1.302658007821146],
            [34.8136754730302, 1.302313388158221],
            [34.81350371335124, 1.301626263677635],
            [34.81275323650837, 1.301256054777233],
            [34.81290249967769, 1.300324542517669],
            [34.81365265222874, 1.300242613909851],
            [34.813952472141324, 1.299401420715758],
            [34.81223625336743, 1.297594110776007],
            [34.8121499055057, 1.296988308418006],
            [34.810369894668526, 1.295488493223128],
            [34.81024061542104, 1.294521009596504],
            [34.80693894922243, 1.293166967650662],
            [34.802370927967765, 1.289299920133694],
            [34.79915545601897, 1.288343675520354],
            [34.798532647744295, 1.286653109253311],
            [34.79500070111754, 1.284020611176778],
            [34.7948160074951, 1.283386313682615],
            [34.79286306288093, 1.281804092468134],
            [34.791495772221246, 1.279264901996712],
            [34.79157807496925, 1.278030553228035],
            [34.79094344576377, 1.277066187444888],
            [34.790504698697504, 1.274490006122766],
            [34.789038389439035, 1.273364119606014],
            [34.78852436804359, 1.270799834332243],
            [34.78725882865784, 1.269107568091918],
            [34.786147360224774, 1.268490359466372],
            [34.78577617634937, 1.26727427190421],
            [34.7840751570701, 1.266775182191331],
            [34.780487556218205, 1.264771818124822],
            [34.77628213813137, 1.263451649270739],
            [34.77501220957716, 1.262147985876687],
            [34.77166806833696, 1.260234362481734],
            [34.770499433814166, 1.25995867961241],
            [34.76721465773951, 1.257339097705271],
            [34.770696945497356, 1.249788112071273],
            [34.774956158296675, 1.242448351389417],
            [34.77640322474346, 1.240895379885829],
            [34.78018390768589, 1.223732324389776],
            [34.78260133430257, 1.221093750181155],
            [34.78388623507763, 1.221657058989718],
            [34.78629094783809, 1.220362561762755],
            [34.786885886779416, 1.219433635869879],
            [34.78786704559736, 1.219809090598675],
            [34.79093772439372, 1.219054807780193],
            [34.79508326797022, 1.219122543383579],
            [34.79750207709414, 1.221495108898124],
            [34.79936046773649, 1.224009086974219],
            [34.800516769288734, 1.224360906395877],
            [34.80128827659071, 1.225224420342919],
            [34.80275970085643, 1.225652260106349],
            [34.80655685171462, 1.228611528319396],
            [34.807118309546986, 1.230009797077716],
            [34.806931922600256, 1.230679866609097],
            [34.8079963471602, 1.233311893140542],
            [34.80930498142507, 1.234439317379202],
            [34.809854768345254, 1.235837588466967],
            [34.8114082078981, 1.236341914637761],
            [34.81229638749087, 1.237363843390057],
            [34.81142298248956, 1.240890448393396],
            [34.81259131877168, 1.241759387815162],
            [34.8125214379274, 1.242429505573237],
            [34.81351541031458, 1.244062401104117],
            [34.813644756037384, 1.245366931192723],
            [34.81596870127065, 1.245565122779212],
            [34.816868993746716, 1.24720995933487],
            [34.81913177089565, 1.247863153665342],
            [34.8185101322275, 1.249446065571053],
            [34.818885305521036, 1.251995854088687],
            [34.81851252354277, 1.252909430829143],
            [34.81895757857892, 1.255007032649323],
            [34.81969029393201, 1.25571185049502],
            [34.819707585602906, 1.257972520560693],
            [34.82063557134252, 1.260131071331222],
            [34.82558210043709, 1.261793441273574],
            [34.82609696085902, 1.262991027911529],
            [34.82763111088776, 1.263419672530963],
            [34.829173844319065, 1.264548912378236],
            [34.829413967587776, 1.265449703015726],
            [34.83149427893621, 1.266442687371405],
            [34.831364290917946, 1.267667073725832],
            [34.83226132430618, 1.268315175226572],
            [34.8312563134208, 1.269668348380795],
            [34.83074406080814, 1.271212243708935],
            [34.829741290321095, 1.272162441559439],
            [34.829974960991116, 1.276240520005841],
            [34.82912343086533, 1.283782724263872],
            [34.829275504863126, 1.292282730398121],
            [34.82896725156666, 1.293883507651954],
            [34.830500618264466, 1.298331385401766],
            [34.83079475543458, 1.300519496777995],
            [34.83020277823875, 1.30307800533789],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1101,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "KAPTERERWO",
        Population: 8736,
        Key: "BUKWOKAPTERERWO",
        Dist2: "BUKWO",
        "Sub Country": "Kaptererwo",
        id2_original: "BUKWO Kaptererwo",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.73738666916054, 1.427775608228445],
            [34.73634984084611, 1.4276410823744],
            [34.73661263849092, 1.426747190203711],
            [34.73735378902452, 1.426127915628481],
            [34.73681666565488, 1.425558719036256],
            [34.737128607433895, 1.425136187084121],
            [34.7368160314443, 1.424714130116357],
            [34.73744032104089, 1.42440921221327],
            [34.73727396203341, 1.423780807555637],
            [34.73769330998109, 1.423446582056793],
            [34.73743887026168, 1.422474517604552],
            [34.736980350377735, 1.422622177571897],
            [34.736853222595364, 1.422258904848985],
            [34.73769100580237, 1.420372676515151],
            [34.73756378998511, 1.419891555519894],
            [34.73841247065484, 1.419527542382882],
            [34.73762099470238, 1.418094306666099],
            [34.73827388935258, 1.416895676000463],
            [34.73785556458603, 1.415049228321504],
            [34.73867426847471, 1.41456775059568],
            [34.73795714697667, 1.413975806453298],
            [34.73757333278838, 1.414139245555401],
            [34.73791407814866, 1.413426286560595],
            [34.737538347899616, 1.412988646425067],
            [34.737922142324976, 1.412799447799618],
            [34.73774259604914, 1.412292964514817],
            [34.73875721890806, 1.411390589784936],
            [34.73890992531982, 1.410222676817148],
            [34.73637713525771, 1.408449036336085],
            [34.73409419003231, 1.407553499621022],
            [34.730596344352065, 1.40335697828392],
            [34.72856234025821, 1.401528099132869],
            [34.72795526507739, 1.400380065787597],
            [34.727810833047705, 1.39793964249868],
            [34.72873669427168, 1.396144448517859],
            [34.72812797158066, 1.392735335907773],
            [34.728412076365686, 1.391120069570263],
            [34.726841471804406, 1.389003709298668],
            [34.72617327525165, 1.386766701009621],
            [34.72631162568689, 1.384670659780865],
            [34.72276572642711, 1.381216519242872],
            [34.722718684350646, 1.38063782377436],
            [34.72340195732879, 1.379886538208103],
            [34.723229819459114, 1.378244320549777],
            [34.72301377642991, 1.377647015747954],
            [34.72259385445875, 1.377579164052495],
            [34.722430459891726, 1.376379702666588],
            [34.72177956938295, 1.375316913205773],
            [34.720193742869185, 1.373723168624233],
            [34.71948688462325, 1.370152199063697],
            [34.716871845712035, 1.368763663809057],
            [34.71709014980081, 1.370999094066127],
            [34.7160757092999, 1.372935520331269],
            [34.713868482171506, 1.373632331044994],
            [34.71056359371597, 1.373539297712526],
            [34.70889836511422, 1.374562876111782],
            [34.707408745472435, 1.374932007057038],
            [34.70563412991686, 1.374510702604335],
            [34.70358476103838, 1.372820384880193],
            [34.702441519193705, 1.372680327430238],
            [34.6999672678471, 1.370803711635069],
            [34.699114179144274, 1.370661263436024],
            [34.698997496073694, 1.368850765647921],
            [34.69851837422702, 1.367905223464676],
            [34.6987981617088, 1.364839500374329],
            [34.69820337098949, 1.363425396946641],
            [34.69567695716928, 1.360985089288617],
            [34.695330035891395, 1.35970408991241],
            [34.692093274768695, 1.3555186793178],
            [34.689567328072414, 1.353727570142238],
            [34.68774473978572, 1.35036077496027],
            [34.68796547920722, 1.348160898909731],
            [34.689677125556315, 1.344577470371403],
            [34.6891030625639, 1.3389177929753],
            [34.689237565514745, 1.332820022012317],
            [34.7017609276867, 1.331384938968482],
            [34.70216031596707, 1.330724500657062],
            [34.70227724248107, 1.328300679448237],
            [34.70268227307974, 1.327947296328039],
            [34.706196972053064, 1.328413623014206],
            [34.70897401943081, 1.32933096576521],
            [34.711019330619166, 1.330498420645725],
            [34.71346317219677, 1.330667172165932],
            [34.71486005515854, 1.331167789454081],
            [34.715904918004846, 1.332745260191058],
            [34.71613969539929, 1.334142114221804],
            [34.71697001450461, 1.33501879735066],
            [34.71696567025188, 1.335719016369721],
            [34.71934901299006, 1.337827706367201],
            [34.71993936243858, 1.3391450540726],
            [34.721723088707776, 1.340495592818485],
            [34.724130968927945, 1.343134270278369],
            [34.724090392924886, 1.344267543514077],
            [34.725504380707946, 1.344981076438406],
            [34.72637512939094, 1.346541345688212],
            [34.728679780608545, 1.346656399770614],
            [34.72979726955062, 1.34869301948783],
            [34.73299177661732, 1.35005710925625],
            [34.734755867511026, 1.351668853255499],
            [34.736799672224656, 1.356889048100155],
            [34.739141649340624, 1.357203859709949],
            [34.741642341699304, 1.358793631444711],
            [34.743088041808534, 1.36221991415771],
            [34.74294733329571, 1.36489677417738],
            [34.74167489574688, 1.367348385335003],
            [34.74224567449864, 1.367655433650976],
            [34.74301784655395, 1.369997030725372],
            [34.744749379806784, 1.371053801072104],
            [34.74548352258286, 1.37360341180903],
            [34.74686844267995, 1.37371086973223],
            [34.74909938892513, 1.37731744637492],
            [34.7496242961052, 1.379396962697902],
            [34.74979211577333, 1.382655303235471],
            [34.74907470591609, 1.38383603704535],
            [34.74950980492394, 1.384850016218622],
            [34.74855550124143, 1.384695969607499],
            [34.74837050039518, 1.385005488927664],
            [34.74936282167882, 1.386782250782943],
            [34.750778896248306, 1.388073434812495],
            [34.750819904341036, 1.38856059995746],
            [34.750114433093884, 1.388999976099315],
            [34.751007534556116, 1.389859872659203],
            [34.7504062076948, 1.390663826634837],
            [34.74988926946961, 1.393198928979389],
            [34.75016081490866, 1.397285306734603],
            [34.751152613372824, 1.398388385325031],
            [34.75128217109804, 1.399275628489704],
            [34.750642530191556, 1.399478794643451],
            [34.75068443570125, 1.399792634323916],
            [34.75159821368634, 1.399888464041415],
            [34.75182706758983, 1.400336290487016],
            [34.752787591207344, 1.400039624234339],
            [34.753245517304904, 1.400973949569949],
            [34.7535226385869, 1.400409715706557],
            [34.75397342217964, 1.400765505724561],
            [34.75416682766366, 1.402237674335794],
            [34.75379540214147, 1.403053244792245],
            [34.754384069045464, 1.404261793418769],
            [34.75396159316396, 1.404786610247792],
            [34.754020552291024, 1.407779813041443],
            [34.754878671559425, 1.40931647651677],
            [34.75362902157443, 1.412299692648434],
            [34.75019333212529, 1.413696879159991],
            [34.750895358333345, 1.414738620949128],
            [34.75227196362416, 1.415548210565333],
            [34.75216221824252, 1.415919968135591],
            [34.75004220764676, 1.416844997771838],
            [34.74926803504332, 1.418057690874691],
            [34.74894135550372, 1.41706585469107],
            [34.74846428720578, 1.416942207974542],
            [34.748102917424866, 1.41739052057449],
            [34.74807998343567, 1.418606643006213],
            [34.74756706517136, 1.418383015780422],
            [34.746707385529305, 1.416887539752467],
            [34.74633780155343, 1.416983828563774],
            [34.746111709969455, 1.41761205546219],
            [34.74673623402632, 1.418251636111036],
            [34.746653481222374, 1.419207781892231],
            [34.744070045042854, 1.419457770991553],
            [34.74370139711149, 1.420802170040984],
            [34.74251715525896, 1.421139100816196],
            [34.743384387037615, 1.422098525937773],
            [34.74330542063256, 1.422802649156205],
            [34.74213332490099, 1.423435599051146],
            [34.74198298644831, 1.424371796370391],
            [34.73910526757161, 1.424445994938963],
            [34.73864187971713, 1.426103743165726],
            [34.73888465481257, 1.427074402455262],
            [34.73738666916054, 1.427775608228445],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1102,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "KAMET",
        Population: 5117,
        Key: "BUKWOKAMET",
        Dist2: "BUKWO",
        "Sub Country": "Kamet",
        id2_original: "BUKWO Kamet",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.372906532655534, 1.084761764227596],
            [34.36887965023983, 1.085740436095365],
            [34.36639238949125, 1.085506661868851],
            [34.36302068883646, 1.086431796344623],
            [34.36198262803347, 1.085733122427365],
            [34.362056682450564, 1.076710975117726],
            [34.36144511569333, 1.075048401341663],
            [34.36054014029969, 1.074599372127056],
            [34.359100802957634, 1.072655059463034],
            [34.357898396271736, 1.07243408837033],
            [34.35741510264887, 1.071931856378622],
            [34.3566745405118, 1.072261749822136],
            [34.35557945914615, 1.071992106618079],
            [34.353531649743, 1.070558869663196],
            [34.35362327610538, 1.069351624975615],
            [34.3528438537474, 1.06801231987283],
            [34.35321066552233, 1.06550511546214],
            [34.352783208482585, 1.064889514770985],
            [34.352771677707615, 1.062638700401884],
            [34.354858414705255, 1.058785285532542],
            [34.354910841283555, 1.057945010943557],
            [34.35325245514934, 1.056118788979646],
            [34.35200308364208, 1.053296123761699],
            [34.35039570205306, 1.051567897744527],
            [34.351628797884004, 1.052375074925356],
            [34.353360920431676, 1.052537962307925],
            [34.35356191128999, 1.053110381749195],
            [34.3543079288958, 1.052931567261465],
            [34.35450308878958, 1.053441412481487],
            [34.356383310289964, 1.05309486597384],
            [34.35882164339823, 1.053860473964347],
            [34.360590445955616, 1.052218788140102],
            [34.362674426023666, 1.051129943969614],
            [34.363442764069326, 1.051725311758146],
            [34.36616337029777, 1.05207715758468],
            [34.36736607432605, 1.051412735420218],
            [34.370271021139004, 1.051322162761089],
            [34.37159858739847, 1.049854770711841],
            [34.37210263929093, 1.050153363684184],
            [34.37177423498597, 1.051747949980348],
            [34.37193033433459, 1.054256411280712],
            [34.370721218131834, 1.055568503518419],
            [34.3705415604649, 1.056697554178669],
            [34.37132769862791, 1.058587755472254],
            [34.373324732556256, 1.058594012966655],
            [34.37457213495644, 1.060602588980139],
            [34.375133760773736, 1.06367079385808],
            [34.375543177845934, 1.064163710582531],
            [34.37522979786414, 1.065791084189676],
            [34.376759724912716, 1.069727709203898],
            [34.378582313199416, 1.071685663156691],
            [34.37879868501199, 1.07420390715844],
            [34.37740680656469, 1.078726887997071],
            [34.373510815872436, 1.084472059158496],
            [34.372906532655534, 1.084761764227596],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1104,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "NAKATSI",
        Population: 10877,
        Key: "BUDUDANAKATSI",
        Dist2: "Bududa",
        "Sub Country": "Nakatsi",
        id2_original: "Bududa Nakatsi",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39366233187392, 1.026323984952665],
            [34.38994914564703, 1.025705209625976],
            [34.38351879014593, 1.021601505247696],
            [34.38198751562443, 1.021123555295109],
            [34.37895534940093, 1.022763916283474],
            [34.37753988748246, 1.020669292781503],
            [34.37621536022358, 1.020094347202628],
            [34.376365095906735, 1.018643414999934],
            [34.37507667283742, 1.017052101180931],
            [34.37379942930186, 1.016661699154165],
            [34.37257458090354, 1.015356700759915],
            [34.37256819927176, 1.014148900495644],
            [34.37188278740493, 1.013595791975336],
            [34.371352565791625, 1.011336984157095],
            [34.37167210462303, 1.0101846168993],
            [34.37009234263573, 1.009805342442592],
            [34.369304602776566, 1.008905211219165],
            [34.36982376433207, 1.008509012280531],
            [34.371076286231045, 1.008454336706442],
            [34.37248197807248, 1.007169746071311],
            [34.37334752191672, 1.007365170409591],
            [34.37460513726334, 1.006521691005907],
            [34.375524775857365, 1.006719827876445],
            [34.37587262150167, 1.005507882008924],
            [34.376325858393415, 1.005182824567281],
            [34.37824700534153, 1.005357329584257],
            [34.380984375031474, 1.003461120213375],
            [34.381778485742664, 1.003623213407795],
            [34.383268044299015, 1.001820176422589],
            [34.384022780952954, 1.001592513448825],
            [34.38488779389284, 1.00212759398485],
            [34.38540177037256, 1.001792345479958],
            [34.38586761691597, 1.000078107696779],
            [34.38672975255202, 0.999689610467387],
            [34.38805895464363, 0.999964100108425],
            [34.389840151256976, 1.001044667917132],
            [34.39266690241939, 0.998707978407515],
            [34.39420296585968, 0.998592812120881],
            [34.39615680160264, 0.999081497724772],
            [34.3965657982633, 1.000679359969094],
            [34.39613439851776, 1.002245215765671],
            [34.3965523864161, 1.003013374199277],
            [34.39642302632024, 1.00362230085946],
            [34.39748947029295, 1.005231001885434],
            [34.39842567651575, 1.005390063644717],
            [34.39872492420151, 1.006087739610555],
            [34.398342366756296, 1.006685529205616],
            [34.39844930220771, 1.007927894968273],
            [34.39775937540826, 1.00881300895867],
            [34.3955985947733, 1.008845016360024],
            [34.393768311517896, 1.009793541311114],
            [34.39342798117924, 1.010179266466828],
            [34.393513930188995, 1.012107112840418],
            [34.39140725688023, 1.012429339440764],
            [34.39085431058519, 1.013264996903266],
            [34.39089773514601, 1.015278547924492],
            [34.39147281592967, 1.016435029701361],
            [34.394086839744595, 1.018396694863765],
            [34.395666109455114, 1.0186395582437],
            [34.39643249097009, 1.019260429472044],
            [34.39556085834486, 1.019683776170906],
            [34.394009315135584, 1.022434505337251],
            [34.39320404734859, 1.025166340905768],
            [34.39366233187392, 1.026323984952665],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1105,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUWALI",
        Population: 6367,
        Key: "BUDUDABUWALI",
        Dist2: "Bududa",
        "Sub Country": "Buwali",
        id2_original: "Bududa Buwali",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.53423800275137, 1.103601765058336],
            [34.53484204342316, 1.104590782834982],
            [34.53445025309344, 1.105723158180254],
            [34.535981234764186, 1.107130989580969],
            [34.53586389772008, 1.10785511469363],
            [34.53787354579164, 1.111762610891468],
            [34.53791417389699, 1.113413864748399],
            [34.53626449333621, 1.114945915851053],
            [34.533461232220134, 1.116038234459514],
            [34.53080796370538, 1.118781755007726],
            [34.52635629853455, 1.119046711976567],
            [34.525847654454374, 1.116957173038985],
            [34.52490287740544, 1.115596477379838],
            [34.52023938859231, 1.113522609530113],
            [34.5193930246777, 1.111492084760065],
            [34.51942169800325, 1.110308824429338],
            [34.518406743666006, 1.108487425638047],
            [34.51769618975101, 1.10800813564846],
            [34.515223555371904, 1.107937012259787],
            [34.513913567345874, 1.107256623360251],
            [34.51098545118511, 1.101595028159431],
            [34.50585833107405, 1.09743455900133],
            [34.501341184108874, 1.090368637172824],
            [34.50101691474919, 1.089192273463349],
            [34.49780634760185, 1.086681651941976],
            [34.495638794567974, 1.085684167644928],
            [34.49255813099724, 1.085263719266786],
            [34.49233237538317, 1.086627729486619],
            [34.48969927045331, 1.087057516676216],
            [34.48824945426344, 1.086936173426867],
            [34.48635845657291, 1.085795017811596],
            [34.4850834749952, 1.084226988745453],
            [34.48370001915202, 1.080476266501231],
            [34.48171109970562, 1.078339877908006],
            [34.47905055034549, 1.073279297077796],
            [34.47575410874855, 1.068824442520621],
            [34.47324583640551, 1.067050590585423],
            [34.46905747193603, 1.06576120061428],
            [34.46642576119146, 1.06433095162709],
            [34.4640301771109, 1.060985931419256],
            [34.46330014143231, 1.05850498355889],
            [34.46106519678581, 1.056507887398766],
            [34.457912617686716, 1.056342371301985],
            [34.45302285762652, 1.054185468061851],
            [34.45180744423364, 1.052826092315539],
            [34.450075548061406, 1.049427032421089],
            [34.44772820440991, 1.047823627654849],
            [34.445368500838455, 1.04511078805337],
            [34.44053175485477, 1.042232073591201],
            [34.437609949358844, 1.041362571793915],
            [34.436182019722565, 1.041768830626424],
            [34.43471779994544, 1.040558662903927],
            [34.4331058746777, 1.040314849136284],
            [34.43231789227342, 1.040643271145857],
            [34.43180788544897, 1.039784582845524],
            [34.428909297809895, 1.037847365482438],
            [34.4263492600486, 1.03764573037193],
            [34.42471923282958, 1.036686146427164],
            [34.4234682614228, 1.035290960311279],
            [34.42223794228438, 1.035473256205784],
            [34.42163577909157, 1.035166014273075],
            [34.41900109312677, 1.035845546165336],
            [34.41734883440112, 1.034462476875763],
            [34.415359344524525, 1.033721720094063],
            [34.41425122950242, 1.032247956316933],
            [34.4123202531885, 1.03175137183409],
            [34.41107412010785, 1.03057613550427],
            [34.41049053048182, 1.029122856638773],
            [34.40875749165254, 1.028343878760859],
            [34.40701879972519, 1.02872120559696],
            [34.40275094423454, 1.026502588080866],
            [34.400805506841174, 1.024972461601323],
            [34.40014943574813, 1.024803290985808],
            [34.39913455597105, 1.027205403311082],
            [34.397521152076386, 1.028281315788857],
            [34.39597356953918, 1.027124255363684],
            [34.39366233187392, 1.026323984952665],
            [34.39320404734859, 1.025166340905768],
            [34.394009315135584, 1.022434505337251],
            [34.39556085834486, 1.019683776170906],
            [34.39643249097009, 1.019260429472044],
            [34.395666109455114, 1.0186395582437],
            [34.394086839744595, 1.018396694863765],
            [34.39147281592967, 1.016435029701361],
            [34.39089773514601, 1.015278547924492],
            [34.39085431058519, 1.013264996903266],
            [34.39140725688023, 1.012429339440764],
            [34.393513930188995, 1.012107112840418],
            [34.39342798117924, 1.010179266466828],
            [34.393768311517896, 1.009793541311114],
            [34.3955985947733, 1.008845016360024],
            [34.39775937540826, 1.00881300895867],
            [34.39844930220771, 1.007927894968273],
            [34.398342366756296, 1.006685529205616],
            [34.39872492420151, 1.006087739610555],
            [34.39842567651575, 1.005390063644717],
            [34.39748947029295, 1.005231001885434],
            [34.39642302632024, 1.00362230085946],
            [34.3965523864161, 1.003013374199277],
            [34.39613439851776, 1.002245215765671],
            [34.3965657982633, 1.000679359969094],
            [34.39615680160264, 0.999081497724772],
            [34.397958722349586, 0.996579100807525],
            [34.39734464839442, 0.99491379314516],
            [34.39668837428214, 0.994344195275811],
            [34.39677151156505, 0.993055061507374],
            [34.39867944160037, 0.991811816186471],
            [34.40022453939747, 0.991308614005066],
            [34.40799461716046, 0.989518687318791],
            [34.409149757191024, 0.990807994017461],
            [34.410052972785046, 0.991241746237639],
            [34.41679057457117, 0.993156286432401],
            [34.418315683954894, 0.994105303635513],
            [34.42008019526015, 0.99413167150785],
            [34.42349451828022, 0.995179351684814],
            [34.42979882577391, 1.000304827688405],
            [34.43366580357744, 1.002690867334363],
            [34.43353925610677, 1.003541104716706],
            [34.42850037840436, 1.006609415022523],
            [34.42695495451881, 1.009314405816782],
            [34.434593102105914, 1.017025951749945],
            [34.435830397560785, 1.017305775080682],
            [34.437978330490566, 1.017015386531892],
            [34.440661446428955, 1.01798193453447],
            [34.44847418967636, 1.017987446625233],
            [34.45191319121393, 1.01896268056972],
            [34.453339228998225, 1.018120902630156],
            [34.4559408704353, 1.017766986339367],
            [34.45820478664802, 1.018181995490387],
            [34.46124449422832, 1.017918319599208],
            [34.466529742083914, 1.018440470037949],
            [34.468940495116364, 1.019461371456373],
            [34.47302865790579, 1.020445317230841],
            [34.476334741120674, 1.023084724503705],
            [34.48456341961599, 1.024139072364272],
            [34.49188091446072, 1.025781694303915],
            [34.49189157207326, 1.028547766175235],
            [34.493219228164264, 1.033188294736015],
            [34.49306437028739, 1.035874506709767],
            [34.493748535292625, 1.03742978922815],
            [34.49391256676518, 1.039925920255011],
            [34.49468192350038, 1.04230418469754],
            [34.49610060677744, 1.044028018403752],
            [34.49597184675618, 1.045830814296096],
            [34.49698813329499, 1.046832156552413],
            [34.4977609108148, 1.051482589229214],
            [34.50045645853838, 1.054972346080707],
            [34.49973286108546, 1.059042591843508],
            [34.502499025373545, 1.06339582291009],
            [34.502781450308966, 1.066217807100529],
            [34.50333813539223, 1.067809246963847],
            [34.50593432315718, 1.070254718159172],
            [34.50903209514253, 1.074739561902984],
            [34.51165979580767, 1.076100690172866],
            [34.51438819671783, 1.078642809809262],
            [34.515375667997276, 1.081048356510866],
            [34.51831630936803, 1.085848034942612],
            [34.51850558978828, 1.08797220874631],
            [34.51901866435946, 1.08893532625742],
            [34.51912125645647, 1.091444772016412],
            [34.52105267114824, 1.096415743596821],
            [34.52300052500973, 1.099369204205806],
            [34.52496347326294, 1.100710469567628],
            [34.52690600460637, 1.101277817094217],
            [34.52665545818541, 1.102579085228216],
            [34.527031177654685, 1.104034807398229],
            [34.53423800275137, 1.103601765058336],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1106,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUKALASI",
        Population: 12906,
        Key: "BUDUDABUKALASI",
        Dist2: "Bududa",
        "Sub Country": "Bukalasi",
        id2_original: "Bududa Bukalasi",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.48548428800364, 0.962479310929503],
            [34.485967045332266, 0.965893325657506],
            [34.487037706895215, 0.967918768719593],
            [34.48678887535815, 0.969067500430542],
            [34.48821639626099, 0.971689702782698],
            [34.48800291432863, 0.972766065484415],
            [34.48850261657848, 0.973842109885087],
            [34.48900377140413, 0.97820121790342],
            [34.49007437637324, 0.980063854160888],
            [34.4895399560343, 0.98175536927939],
            [34.48950562961065, 0.984124979272132],
            [34.488722226817664, 0.986603459829165],
            [34.488439911476725, 0.993223984079736],
            [34.48858306610207, 0.994372540040463],
            [34.48929674076439, 0.995448481365602],
            [34.487724846222335, 0.997800705402132],
            [34.488762795634216, 1.000667260609449],
            [34.488459316883485, 1.004057033098519],
            [34.488725217309266, 1.008192099800035],
            [34.489595336273226, 1.011194389835944],
            [34.4894179234962, 1.014965925785939],
            [34.49087831824684, 1.017454055469946],
            [34.490971612780676, 1.022512770270566],
            [34.49188091446072, 1.025781694303915],
            [34.48456341961599, 1.024139072364272],
            [34.476334741120674, 1.023084724503705],
            [34.47302865790579, 1.020445317230841],
            [34.468940495116364, 1.019461371456373],
            [34.466529742083914, 1.018440470037949],
            [34.46124449422832, 1.017918319599208],
            [34.45820478664802, 1.018181995490387],
            [34.4559408704353, 1.017766986339367],
            [34.453339228998225, 1.018120902630156],
            [34.45191319121393, 1.01896268056972],
            [34.44847418967636, 1.017987446625233],
            [34.440661446428955, 1.01798193453447],
            [34.437978330490566, 1.017015386531892],
            [34.435830397560785, 1.017305775080682],
            [34.434593102105914, 1.017025951749945],
            [34.42695495451881, 1.009314405816782],
            [34.42850037840436, 1.006609415022523],
            [34.43353925610677, 1.003541104716706],
            [34.43366580357744, 1.002690867334363],
            [34.42979882577391, 1.000304827688405],
            [34.42349451828022, 0.995179351684814],
            [34.42008019526015, 0.99413167150785],
            [34.418315683954894, 0.994105303635513],
            [34.41679057457117, 0.993156286432401],
            [34.410052972785046, 0.991241746237639],
            [34.409149757191024, 0.990807994017461],
            [34.40799461716046, 0.989518687318791],
            [34.40022453939747, 0.991308614005066],
            [34.39867944160037, 0.991811816186471],
            [34.39677151156505, 0.993055061507374],
            [34.39668837428214, 0.994344195275811],
            [34.39734464839442, 0.99491379314516],
            [34.397958722349586, 0.996579100807525],
            [34.39615680160264, 0.999081497724772],
            [34.39420296585968, 0.998592812120881],
            [34.39266690241939, 0.998707978407515],
            [34.389840151256976, 1.001044667917132],
            [34.38805895464363, 0.999964100108425],
            [34.38672975255202, 0.999689610467387],
            [34.38586761691597, 1.000078107696779],
            [34.38540177037256, 1.001792345479958],
            [34.38488779389284, 1.00212759398485],
            [34.384022780952954, 1.001592513448825],
            [34.383268044299015, 1.001820176422589],
            [34.381778485742664, 1.003623213407795],
            [34.380984375031474, 1.003461120213375],
            [34.37824700534153, 1.005357329584257],
            [34.376325858393415, 1.005182824567281],
            [34.37587262150167, 1.005507882008924],
            [34.375524775857365, 1.006719827876445],
            [34.37460513726334, 1.006521691005907],
            [34.37334752191672, 1.007365170409591],
            [34.37248197807248, 1.007169746071311],
            [34.371076286231045, 1.008454336706442],
            [34.36982376433207, 1.008509012280531],
            [34.369304602776566, 1.008905211219165],
            [34.3691480713383, 1.008343772119504],
            [34.36997097485095, 1.007683553285247],
            [34.36966155104966, 1.005956543821583],
            [34.369198106601296, 1.00583615219686],
            [34.36762720559597, 1.006624478343108],
            [34.366459029214, 1.005137167533275],
            [34.365223127944425, 1.005062674523665],
            [34.36539801645551, 1.003612136184996],
            [34.364830872287406, 1.002656095281587],
            [34.365296373877726, 1.001987011179509],
            [34.36526501369115, 1.001243122176417],
            [34.36430244640634, 1.001349797892548],
            [34.36291733137482, 1.000702497939687],
            [34.36325830221227, 0.999725026545633],
            [34.36467835542014, 1.000160464371911],
            [34.3651514235201, 0.999624645212139],
            [34.36640822229817, 0.999718322541003],
            [34.36640778751354, 0.998668612127796],
            [34.36806537504547, 0.998030016797303],
            [34.368052375525004, 0.997391863246993],
            [34.36893877825015, 0.996816195909937],
            [34.36909160952773, 0.99626401766228],
            [34.370275751667286, 0.996300773861223],
            [34.37070343238754, 0.996830165293132],
            [34.3712435794864, 0.995447170921408],
            [34.37269746953607, 0.994946409648239],
            [34.37427528038258, 0.993728471265554],
            [34.37523657475463, 0.993758439945189],
            [34.37659403604847, 0.992251533990502],
            [34.37780669430838, 0.992155659499672],
            [34.37979589133419, 0.991226593028438],
            [34.3810584797542, 0.989693849736864],
            [34.38213171499048, 0.989549239854403],
            [34.38304307021926, 0.988435502925454],
            [34.38398872941377, 0.98843510503099],
            [34.38426420138892, 0.987605692590072],
            [34.385180998611695, 0.987111335066722],
            [34.38535599042905, 0.985838471753041],
            [34.38633140182579, 0.984724786574],
            [34.38963974699853, 0.98230400301585],
            [34.39030458744537, 0.982287644403993],
            [34.39066807545374, 0.982807121232388],
            [34.393134561763034, 0.982960047685033],
            [34.395389875708624, 0.98105379095637],
            [34.39840090906504, 0.979986374125069],
            [34.399181033007245, 0.980090741294856],
            [34.40031187899927, 0.979435912204149],
            [34.40213224215902, 0.979853927926353],
            [34.403237066652224, 0.979159849940403],
            [34.40570773372085, 0.980153416564012],
            [34.41255825733145, 0.977376069297597],
            [34.48548428800364, 0.962479310929503],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1107,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUBIITA",
        Population: 6983,
        Key: "BUDUDABUBIITA",
        Dist2: "Bududa",
        "Sub Country": "Bubiita",
        id2_original: "Bududa Bubiita",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39536219591975, 1.10284553547516],
            [34.38780934696214, 1.104083330769726],
            [34.386055369301914, 1.106363411002333],
            [34.384638174533286, 1.105839488104314],
            [34.38064081255443, 1.102639550411778],
            [34.3765564460454, 1.103193185533641],
            [34.37360328395619, 1.09542515763323],
            [34.37379485058886, 1.091852409188194],
            [34.374760648215435, 1.087754711926623],
            [34.37425731138197, 1.086226387666765],
            [34.372906532655534, 1.084761764227596],
            [34.373510815872436, 1.084472059158496],
            [34.37740680656469, 1.078726887997071],
            [34.37879868501199, 1.07420390715844],
            [34.378582313199416, 1.071685663156691],
            [34.376759724912716, 1.069727709203898],
            [34.37522979786414, 1.065791084189676],
            [34.375543177845934, 1.064163710582531],
            [34.375133760773736, 1.06367079385808],
            [34.37457213495644, 1.060602588980139],
            [34.373324732556256, 1.058594012966655],
            [34.37132769862791, 1.058587755472254],
            [34.3705415604649, 1.056697554178669],
            [34.370721218131834, 1.055568503518419],
            [34.37193033433459, 1.054256411280712],
            [34.37177423498597, 1.051747949980348],
            [34.37210263929093, 1.050153363684184],
            [34.37264777832783, 1.049722658796867],
            [34.37262789681397, 1.049170360318025],
            [34.37202678105677, 1.046176229021975],
            [34.37100322445235, 1.045080537827579],
            [34.370967890118955, 1.042144393661835],
            [34.36951984450853, 1.040706445525893],
            [34.369743673236286, 1.038266173967791],
            [34.3699683805164, 1.03785862491537],
            [34.37073743272271, 1.037745108165581],
            [34.37045825340041, 1.036993711552975],
            [34.371008370900626, 1.03542253303253],
            [34.37000814623908, 1.032428752443151],
            [34.36912498643212, 1.031036020052773],
            [34.36910913476061, 1.029148251508061],
            [34.369660918635674, 1.028387731041956],
            [34.370517779364405, 1.028107851194459],
            [34.37130413402138, 1.025932028419704],
            [34.37291309754362, 1.024280793090226],
            [34.37324365690692, 1.023341811879661],
            [34.37429153090606, 1.022957747220181],
            [34.37417593839026, 1.022352096235102],
            [34.37459697157739, 1.021912779484029],
            [34.37364371443219, 1.02074721465588],
            [34.37426939372253, 1.019087508682571],
            [34.373401732549155, 1.01772385604464],
            [34.37379942930186, 1.016661699154165],
            [34.37507667283742, 1.017052101180931],
            [34.376365095906735, 1.018643414999934],
            [34.37621536022358, 1.020094347202628],
            [34.37872367388916, 1.024883235442173],
            [34.37881146534357, 1.025308297805349],
            [34.37785962663819, 1.026673012453376],
            [34.37798219008061, 1.027993044323214],
            [34.38024741424037, 1.030042561420704],
            [34.38377818317581, 1.030353062409558],
            [34.38510116084083, 1.031302172914672],
            [34.38818961999161, 1.036971814213232],
            [34.38950998086419, 1.038346016592944],
            [34.39091651352871, 1.042759862327001],
            [34.39390706350004, 1.044263265175798],
            [34.39420600126704, 1.045028198110235],
            [34.39398551876371, 1.045816313411821],
            [34.392209950993916, 1.045544350639831],
            [34.391024810826124, 1.046449345881819],
            [34.390027941372175, 1.046386479687913],
            [34.389175774340806, 1.047164700459903],
            [34.38766081232654, 1.047708057160832],
            [34.38409035492354, 1.047621421052187],
            [34.38313271579641, 1.048649716663132],
            [34.37949306116706, 1.046795922765572],
            [34.37717797961069, 1.047660161608295],
            [34.37901170161702, 1.047975858546641],
            [34.37954705261058, 1.049596705590658],
            [34.38347849801052, 1.054193846128512],
            [34.383632863610615, 1.055668182526827],
            [34.38463726543822, 1.057360566896678],
            [34.38481867032835, 1.058634662878693],
            [34.38465686757602, 1.060773533336662],
            [34.38527263665214, 1.062830140673828],
            [34.385003040557265, 1.066543579503436],
            [34.3860070731773, 1.067389539796839],
            [34.38605288007026, 1.068718303478764],
            [34.3869396241552, 1.070128595137914],
            [34.38679567452082, 1.071730481247973],
            [34.387302422257434, 1.072613072378923],
            [34.392981025307925, 1.073220250394993],
            [34.39381335214793, 1.074257408598488],
            [34.3945728642459, 1.074238856259351],
            [34.39600245486715, 1.076367883740888],
            [34.3972233659496, 1.076922493700871],
            [34.399078490317535, 1.080270879873523],
            [34.39918732301086, 1.080989825519829],
            [34.39813117462965, 1.084812826094893],
            [34.39825828175075, 1.085941317212256],
            [34.397707097051985, 1.086751582189817],
            [34.39527497489558, 1.087098563194],
            [34.39439824522941, 1.087836171744529],
            [34.39276386207957, 1.09263328414662],
            [34.39273101877449, 1.094469633376593],
            [34.39398069750555, 1.1000312546924],
            [34.39536219591975, 1.10284553547516],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1108,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BULUCHEKE",
        Population: 15109,
        Key: "BUDUDABULUCHEKE",
        Dist2: "Bududa",
        "Sub Country": "Bulucheke",
        id2_original: "Bududa Bulucheke",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.45436755925006, 1.103238946213263],
            [34.450459099043314, 1.102805023571591],
            [34.44590602665332, 1.101224484985288],
            [34.444076428812465, 1.101406268615262],
            [34.442476844600115, 1.10109049456901],
            [34.43675163785097, 1.102875044156409],
            [34.42983813245747, 1.104324855466753],
            [34.42355513479897, 1.102898765166065],
            [34.42256594773733, 1.103318556321918],
            [34.420928214769816, 1.104939492504317],
            [34.41932462137635, 1.105370729371563],
            [34.4178750998339, 1.106512261035911],
            [34.41520182853271, 1.106734648702379],
            [34.414148300537164, 1.106549013242417],
            [34.413096015810005, 1.105717419912617],
            [34.41025642143395, 1.105483623893056],
            [34.40753452971632, 1.103567476437154],
            [34.40441838538683, 1.104030236720432],
            [34.39881193501994, 1.101826018666638],
            [34.39662194117192, 1.102471600147843],
            [34.39536219591975, 1.10284553547516],
            [34.39398069750555, 1.1000312546924],
            [34.39273101877449, 1.094469633376593],
            [34.39276386207957, 1.09263328414662],
            [34.39439824522941, 1.087836171744529],
            [34.39527497489558, 1.087098563194],
            [34.397707097051985, 1.086751582189817],
            [34.39825828175075, 1.085941317212256],
            [34.39813117462965, 1.084812826094893],
            [34.39918732301086, 1.080989825519829],
            [34.399078490317535, 1.080270879873523],
            [34.3972233659496, 1.076922493700871],
            [34.39600245486715, 1.076367883740888],
            [34.3945728642459, 1.074238856259351],
            [34.39381335214793, 1.074257408598488],
            [34.392981025307925, 1.073220250394993],
            [34.387302422257434, 1.072613072378923],
            [34.38679567452082, 1.071730481247973],
            [34.3869396241552, 1.070128595137914],
            [34.38605288007026, 1.068718303478764],
            [34.3860070731773, 1.067389539796839],
            [34.385003040557265, 1.066543579503436],
            [34.38527263665214, 1.062830140673828],
            [34.38465686757602, 1.060773533336662],
            [34.38481867032835, 1.058634662878693],
            [34.38463726543822, 1.057360566896678],
            [34.383632863610615, 1.055668182526827],
            [34.38347849801052, 1.054193846128512],
            [34.37954705261058, 1.049596705590658],
            [34.37901170161702, 1.047975858546641],
            [34.37717797961069, 1.047660161608295],
            [34.37949306116706, 1.046795922765572],
            [34.38313271579641, 1.048649716663132],
            [34.38409035492354, 1.047621421052187],
            [34.38766081232654, 1.047708057160832],
            [34.389175774340806, 1.047164700459903],
            [34.390027941372175, 1.046386479687913],
            [34.391024810826124, 1.046449345881819],
            [34.392209950993916, 1.045544350639831],
            [34.39398551876371, 1.045816313411821],
            [34.39594537232076, 1.047306378840579],
            [34.39842107175159, 1.047685138681876],
            [34.404860885614305, 1.053868731678],
            [34.40643513464072, 1.057802408837321],
            [34.40773096701445, 1.058299267631829],
            [34.40954702993893, 1.057972830617936],
            [34.41258705103125, 1.061878684731465],
            [34.414637772772565, 1.062592258303408],
            [34.42224414964299, 1.064044901031515],
            [34.43211563209564, 1.063524756551667],
            [34.43395722873372, 1.063804272180029],
            [34.435162134532746, 1.06442777510196],
            [34.44159988676186, 1.070900567750148],
            [34.444623312377665, 1.072888906529968],
            [34.45224943781132, 1.075833737287556],
            [34.45489389475144, 1.07803929734973],
            [34.45713745693647, 1.079232072905348],
            [34.46558478357531, 1.081353398807184],
            [34.46814152721445, 1.080999422310323],
            [34.47065958041433, 1.079614410674342],
            [34.473951759505226, 1.079938397015099],
            [34.47626899073009, 1.081357217763523],
            [34.47878956100937, 1.084024046250138],
            [34.48279699489918, 1.090864461388632],
            [34.47897844437427, 1.091889007991115],
            [34.47745544962472, 1.093283839780309],
            [34.475888067320355, 1.097699249332878],
            [34.47453979848685, 1.099627570492889],
            [34.472806877336865, 1.101075525112788],
            [34.47108184339509, 1.101429113042947],
            [34.4667968705067, 1.10012570321796],
            [34.46071068833703, 1.099815325120038],
            [34.459697542308476, 1.10015103732635],
            [34.457256719070216, 1.102431995369676],
            [34.45436755925006, 1.103238946213263],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1109,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUSHIYI",
        Population: 15751,
        Key: "BUDUDABUSHIYI",
        Dist2: "Bududa",
        "Sub Country": "Bushiyi",
        id2_original: "Bududa Bushiyi",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.37210263929093, 1.050153363684184],
            [34.37159858739847, 1.049854770711841],
            [34.370271021139004, 1.051322162761089],
            [34.36736607432605, 1.051412735420218],
            [34.36616337029777, 1.05207715758468],
            [34.363442764069326, 1.051725311758146],
            [34.362674426023666, 1.051129943969614],
            [34.360590445955616, 1.052218788140102],
            [34.35882164339823, 1.053860473964347],
            [34.356383310289964, 1.05309486597384],
            [34.35450308878958, 1.053441412481487],
            [34.3543079288958, 1.052931567261465],
            [34.35356191128999, 1.053110381749195],
            [34.353360920431676, 1.052537962307925],
            [34.351628797884004, 1.052375074925356],
            [34.35039570205306, 1.051567897744527],
            [34.34882856049719, 1.050574225529854],
            [34.34698803734587, 1.050764007636034],
            [34.346344096204106, 1.050437236613038],
            [34.3476935975262, 1.04867698943809],
            [34.34931871275725, 1.047521607960181],
            [34.347416806824235, 1.04607004789009],
            [34.34766314733302, 1.041256931195995],
            [34.34825817071597, 1.038618895219324],
            [34.35033131889832, 1.036405269445156],
            [34.354230935191104, 1.03602855068282],
            [34.35605621393208, 1.035065163401817],
            [34.356217402236766, 1.034440030737357],
            [34.35501200595758, 1.032815382931537],
            [34.35478411953968, 1.031650814555916],
            [34.354943988219226, 1.028276886011361],
            [34.35447572161444, 1.027158753211277],
            [34.35498081285767, 1.026977889423341],
            [34.35624778146304, 1.027138769806105],
            [34.35730655831479, 1.027977707160303],
            [34.35993791242819, 1.031124291285473],
            [34.3614934782933, 1.031139762260541],
            [34.365080298509184, 1.029031034883038],
            [34.369660918635674, 1.028387731041956],
            [34.36910913476061, 1.029148251508061],
            [34.36912498643212, 1.031036020052773],
            [34.37000814623908, 1.032428752443151],
            [34.371008370900626, 1.03542253303253],
            [34.37045825340041, 1.036993711552975],
            [34.37073743272271, 1.037745108165581],
            [34.3699683805164, 1.03785862491537],
            [34.369743673236286, 1.038266173967791],
            [34.36951984450853, 1.040706445525893],
            [34.370967890118955, 1.042144393661835],
            [34.37100322445235, 1.045080537827579],
            [34.37202678105677, 1.046176229021975],
            [34.37262789681397, 1.049170360318025],
            [34.37264777832783, 1.049722658796867],
            [34.37210263929093, 1.050153363684184],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1110,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "NABWEYA",
        Population: 10248,
        Key: "BUDUDANABWEYA",
        Dist2: "Bududa",
        "Sub Country": "Nabweya",
        id2_original: "Bududa Nabweya",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.35478411953968, 1.031650814555916],
            [34.35501200595758, 1.032815382931537],
            [34.356217402236766, 1.034440030737357],
            [34.35605621393208, 1.035065163401817],
            [34.354230935191104, 1.03602855068282],
            [34.35033131889832, 1.036405269445156],
            [34.34825817071597, 1.038618895219324],
            [34.34766314733302, 1.041256931195995],
            [34.347416806824235, 1.04607004789009],
            [34.34931871275725, 1.047521607960181],
            [34.3476935975262, 1.04867698943809],
            [34.346344096204106, 1.050437236613038],
            [34.34380276406198, 1.049584226492239],
            [34.34307779757655, 1.04863526788547],
            [34.3423301432403, 1.048415637834379],
            [34.34168624431937, 1.048780576581714],
            [34.341519261881096, 1.048265494299323],
            [34.3406565001193, 1.047820172413864],
            [34.340616031015735, 1.047316610738719],
            [34.337803660982715, 1.046409067651461],
            [34.33669850770611, 1.043909014080626],
            [34.335841470009285, 1.043400014279124],
            [34.33651978967697, 1.042838261484887],
            [34.336519545335186, 1.042259435340404],
            [34.335950097886695, 1.041906595039629],
            [34.335949584948686, 1.040691059025233],
            [34.335207881052874, 1.04094606033238],
            [34.33488539574736, 1.039858004433956],
            [34.33399980779418, 1.039823652227431],
            [34.33356249803241, 1.039175552562695],
            [34.332809338820105, 1.039540534596361],
            [34.332427134412775, 1.039111788055917],
            [34.3315692585878, 1.035557065213748],
            [34.3320146262377, 1.034651065388636],
            [34.33118742338808, 1.034115517813464],
            [34.33073871400536, 1.034639313747753],
            [34.330068691177644, 1.034176958857752],
            [34.33029956718883, 1.032924425178381],
            [34.32936937698347, 1.031821026685298],
            [34.32874087788148, 1.031752270901896],
            [34.32852811909296, 1.030541672722249],
            [34.327235134378626, 1.030166708288944],
            [34.326597869516085, 1.028962761356939],
            [34.32689971692629, 1.027862007502678],
            [34.32756857553737, 1.027699870615419],
            [34.32725923527938, 1.026236813846872],
            [34.326384299548856, 1.025783981048094],
            [34.32732959133246, 1.025278592580712],
            [34.32739995277538, 1.024333319071419],
            [34.328126578449144, 1.02387981596726],
            [34.32845692491173, 1.023031498826],
            [34.328376560728096, 1.021782047793371],
            [34.32889674187147, 1.019820126018965],
            [34.33051706998035, 1.018544021342754],
            [34.330368328732256, 1.01658237962245],
            [34.33092138282512, 1.016355550289118],
            [34.33123672652414, 1.016789194932391],
            [34.33230439849382, 1.016711059196947],
            [34.332053331050005, 1.016173800293456],
            [34.333557953455355, 1.015072549856495],
            [34.33354488206965, 1.014567562986999],
            [34.33854099457465, 1.01518116427774],
            [34.34283923288484, 1.017605867471008],
            [34.34599652544428, 1.018087357647487],
            [34.34787743415584, 1.01926700859031],
            [34.34854838584156, 1.019966799461096],
            [34.34869778106319, 1.020829327402165],
            [34.35181611728199, 1.023240756749447],
            [34.352437907765456, 1.025165693324134],
            [34.354164999747546, 1.026977643324508],
            [34.35457524326984, 1.027915065142135],
            [34.35443975396879, 1.030577897713772],
            [34.35478411953968, 1.031650814555916],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1111,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUSHIRIBO",
        Population: 11541,
        Key: "BUDUDABUSHIRIBO",
        Dist2: "Bududa",
        "Sub Country": "Bushiribo",
        id2_original: "Bududa Bushiribo",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.55436148412948, 1.4047465897571],
              [34.55470216660773, 1.406041306704942],
              [34.55659249325674, 1.408373375239803],
              [34.5563281235602, 1.409458827191198],
              [34.560039312832245, 1.412685007584797],
              [34.560614295699516, 1.414167822139643],
              [34.56012667579024, 1.419015701066663],
              [34.55900649639388, 1.421114656195335],
              [34.55849262861033, 1.423665396206758],
              [34.557669520281785, 1.424553386772649],
              [34.552688017976585, 1.423551774641916],
              [34.548565945581814, 1.424097208751455],
              [34.5477906518809, 1.423754063087546],
              [34.546429865922235, 1.424543785852221],
              [34.54748137270838, 1.422377985653494],
              [34.546530711694324, 1.421386557236988],
              [34.54570532793319, 1.418757765164547],
              [34.54502839706096, 1.418267971460214],
              [34.544638151833546, 1.417157290484006],
              [34.54394072050818, 1.417047108992534],
              [34.54244002374062, 1.415354323475352],
              [34.54164691734596, 1.412383477308311],
              [34.537940595146125, 1.409856325454115],
              [34.53841262030207, 1.408738280985656],
              [34.53761510767094, 1.407667102212902],
              [34.53822708046666, 1.405778269365645],
              [34.54127127872505, 1.404117392189283],
              [34.542205179870855, 1.403056217324363],
              [34.542510284572266, 1.402039191732952],
              [34.55436148412948, 1.4047465897571],
            ],
          ],
          [
            [
              [34.54101669078365, 1.432169572115469],
              [34.5416788758105, 1.434692402443144],
              [34.54123451427374, 1.43538004917473],
              [34.54126037227919, 1.436248256928325],
              [34.54047236741701, 1.436922217172075],
              [34.54123930049757, 1.438894810018811],
              [34.54064989158515, 1.44070433215029],
              [34.540686695562336, 1.442209196842689],
              [34.539778352384715, 1.444841081776548],
              [34.53987040814177, 1.446423722028318],
              [34.538729249490274, 1.447419345064796],
              [34.5377751299624, 1.447600877958145],
              [34.53668373258771, 1.447099615409797],
              [34.5359420161155, 1.447764923527728],
              [34.5361465687939, 1.448463154962072],
              [34.53733076573068, 1.449074839632454],
              [34.5370714661256, 1.449762205425599],
              [34.53596398351746, 1.450592843203628],
              [34.536335475514996, 1.451340608043323],
              [34.53597455938332, 1.452037166248763],
              [34.53638276372987, 1.452391247421433],
              [34.53594414961431, 1.453055374875257],
              [34.537070294722454, 1.453419572154315],
              [34.535570386675744, 1.456043422899958],
              [34.53447424889131, 1.456560360288108],
              [34.534562452672446, 1.457562972675597],
              [34.5334769527376, 1.459162793995304],
              [34.53355479355363, 1.46001398946152],
              [34.532428956567585, 1.461236441777844],
              [34.53212443756775, 1.462507235784598],
              [34.532722149608354, 1.462816415981239],
              [34.5321496963969, 1.464317778928229],
              [34.53275770672393, 1.466689972631104],
              [34.53256003603892, 1.467182068313819],
              [34.531044652714776, 1.468067396288563],
              [34.530476024529804, 1.469008116483685],
              [34.53024782280325, 1.47009805840923],
              [34.530884801103205, 1.471626589625807],
              [34.530531668873444, 1.473489909999267],
              [34.52770286056904, 1.475517739325268],
              [34.52523250791073, 1.479372225210589],
              [34.524067212425855, 1.48041310257945],
              [34.522928133374236, 1.48036867057106],
              [34.521746687078874, 1.479111213292998],
              [34.52164782568524, 1.477954290938593],
              [34.5203007013054, 1.477105569157274],
              [34.5170375512729, 1.473119364294978],
              [34.515999237144996, 1.470922356737561],
              [34.51226143079109, 1.468580463134357],
              [34.50951360650785, 1.466237260456291],
              [34.50857730955519, 1.464905104048257],
              [34.50718545895567, 1.464354653504169],
              [34.507235960444326, 1.459853984990687],
              [34.50661615344098, 1.45657224026113],
              [34.50733364684156, 1.453300067304693],
              [34.50706561740856, 1.452190526774438],
              [34.50792572914028, 1.446823628697452],
              [34.507751562874695, 1.445307560549703],
              [34.505793797900665, 1.44376363808835],
              [34.504088127144826, 1.441191290473577],
              [34.50347357348931, 1.438590503765653],
              [34.50166990192586, 1.435462641305365],
              [34.502150462873615, 1.431956218826305],
              [34.50180105505902, 1.426319531576792],
              [34.50307749011086, 1.426115269471052],
              [34.50735621970802, 1.42740583632998],
              [34.510232794131056, 1.429018346560042],
              [34.510818015995945, 1.428103049332884],
              [34.51291364182333, 1.427485553235031],
              [34.51437683123286, 1.426413095350698],
              [34.514828276883954, 1.424141940014743],
              [34.517070797023244, 1.423104456467453],
              [34.516679291459475, 1.421044000283483],
              [34.51482757889298, 1.418134854076625],
              [34.51576271522225, 1.416887944768784],
              [34.515392286830014, 1.415583931049403],
              [34.51574684827939, 1.413474077659087],
              [34.51532994015603, 1.411204977812387],
              [34.516806585430174, 1.409626452391242],
              [34.51815175058441, 1.40912677917841],
              [34.51895777385453, 1.408212970223122],
              [34.51840340462809, 1.406214352748769],
              [34.519689112090276, 1.403712711277117],
              [34.5190555015743, 1.401930847827075],
              [34.52119770415086, 1.399096898190287],
              [34.52177829430215, 1.397129648040704],
              [34.52165302154085, 1.394958896540513],
              [34.5260071278752, 1.397685583831305],
              [34.541095270014814, 1.401564574190938],
              [34.532557440806045, 1.405331230649169],
              [34.52789118248689, 1.408018909198898],
              [34.52215289177562, 1.406963018404438],
              [34.52198957356541, 1.408190590069171],
              [34.519147310294656, 1.41246688119523],
              [34.51756923175022, 1.41372166691113],
              [34.51942524634862, 1.4166317535227],
              [34.520296176491286, 1.419401074157326],
              [34.52139814883347, 1.421062281663466],
              [34.52316594078615, 1.421950390874495],
              [34.53104217695785, 1.423488262697415],
              [34.537434546298826, 1.426581863421876],
              [34.538174058305316, 1.427510913785509],
              [34.5385022892354, 1.429196194480197],
              [34.53992917143607, 1.430288597329946],
              [34.54101669078365, 1.432169572115469],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1112,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "BINYINY",
        Population: 5056,
        Key: "KWEENBINYINY",
        Dist2: "Kween",
        "Sub Country": "binyiny",
        id2_original: "Kween  binyiny",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.546429865922235, 1.424543785852221],
            [34.5439165234877, 1.42722957959209],
            [34.54140339036066, 1.430921236240904],
            [34.54101669078365, 1.432169572115469],
            [34.53992917143607, 1.430288597329946],
            [34.5385022892354, 1.429196194480197],
            [34.538174058305316, 1.427510913785509],
            [34.537434546298826, 1.426581863421876],
            [34.53104217695785, 1.423488262697415],
            [34.52316594078615, 1.421950390874495],
            [34.52139814883347, 1.421062281663466],
            [34.520296176491286, 1.419401074157326],
            [34.51942524634862, 1.4166317535227],
            [34.51756923175022, 1.41372166691113],
            [34.519147310294656, 1.41246688119523],
            [34.52198957356541, 1.408190590069171],
            [34.52215289177562, 1.406963018404438],
            [34.52789118248689, 1.408018909198898],
            [34.532557440806045, 1.405331230649169],
            [34.541095270014814, 1.401564574190938],
            [34.542510284572266, 1.402039191732952],
            [34.542205179870855, 1.403056217324363],
            [34.54127127872505, 1.404117392189283],
            [34.53822708046666, 1.405778269365645],
            [34.53761510767094, 1.407667102212902],
            [34.53841262030207, 1.408738280985656],
            [34.537940595146125, 1.409856325454115],
            [34.54164691734596, 1.412383477308311],
            [34.54244002374062, 1.415354323475352],
            [34.54394072050818, 1.417047108992534],
            [34.544638151833546, 1.417157290484006],
            [34.54502839706096, 1.418267971460214],
            [34.54570532793319, 1.418757765164547],
            [34.546530711694324, 1.421386557236988],
            [34.54748137270838, 1.422377985653494],
            [34.546429865922235, 1.424543785852221],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1113,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "BINYINY TOWN COUNCIL",
        Population: 3288,
        Key: "KWEENBINYINY TOWN COUNCIL",
        Dist2: "Kween",
        "Sub Country": "Binyiny T/C",
        id2_original: "Kween  Binyiny T/C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.57026290433349, 1.294804136584169],
            [34.56283204120159, 1.328113666330464],
            [34.56206469759092, 1.337204651976373],
            [34.56363059228519, 1.339049030637389],
            [34.563793196334764, 1.342380304861884],
            [34.5646367575057, 1.343974785884553],
            [34.564256630003335, 1.345580149547076],
            [34.56483991689708, 1.34797028965105],
            [34.5623360975029, 1.353847256999336],
            [34.5578826312099, 1.353870338155331],
            [34.55652013485893, 1.356743202601603],
            [34.555362221729034, 1.361379160598805],
            [34.55689585073492, 1.363920819406045],
            [34.55664108762202, 1.367263310361922],
            [34.55877336650964, 1.36851648294626],
            [34.55990533270085, 1.367931552766541],
            [34.56604466728754, 1.370781412849986],
            [34.56721573714306, 1.371805359735484],
            [34.56648430458422, 1.373736530815773],
            [34.5713589765409, 1.377932725840559],
            [34.569770543116164, 1.37892402535457],
            [34.56767932622016, 1.382263891872991],
            [34.56521821542952, 1.387442760875261],
            [34.56307885063095, 1.389924586213238],
            [34.56194890924238, 1.393578905462787],
            [34.55891365371263, 1.393906545359195],
            [34.55639527172937, 1.398841268064921],
            [34.553123821263625, 1.40176440300562],
            [34.55436148412948, 1.4047465897571],
            [34.542510284572266, 1.402039191732952],
            [34.541095270014814, 1.401564574190938],
            [34.5260071278752, 1.397685583831305],
            [34.52165302154085, 1.394958896540513],
            [34.52111818887518, 1.393455498180153],
            [34.520566483153566, 1.387845525450841],
            [34.52179466430159, 1.383038316834377],
            [34.52160205113161, 1.37852049501969],
            [34.522619076983894, 1.376733516986308],
            [34.52258450621849, 1.373913960847312],
            [34.52204755352877, 1.372572582980358],
            [34.522719781720504, 1.372079337403196],
            [34.525829627961585, 1.371650254368346],
            [34.52729373185605, 1.36981527625136],
            [34.52901898049516, 1.369275184667091],
            [34.53762860036648, 1.364218117017341],
            [34.54160067926166, 1.364296479095004],
            [34.54179468571861, 1.361518374530066],
            [34.54381924492559, 1.360949441620697],
            [34.54518398975972, 1.359293553250957],
            [34.547072246690306, 1.358102371845497],
            [34.54786920326429, 1.356904785762941],
            [34.547879655162625, 1.35622116365489],
            [34.54891958715633, 1.35495977996425],
            [34.547327261331496, 1.350772952105546],
            [34.54746563152964, 1.346790459642167],
            [34.548209191344824, 1.343282060911443],
            [34.547546660466594, 1.341550586191651],
            [34.5479208779527, 1.34033579033759],
            [34.54804102941858, 1.336246016160184],
            [34.54849674476221, 1.334523386966594],
            [34.5502461517943, 1.332271388718954],
            [34.551340636678574, 1.331722040437566],
            [34.55300362578032, 1.322107765202448],
            [34.55305277530445, 1.309996722842078],
            [34.552159092632266, 1.307901554052793],
            [34.55217134834766, 1.304799301104598],
            [34.55157517062957, 1.302760971252552],
            [34.55140052017205, 1.295118092131609],
            [34.55288907441192, 1.291030378577571],
            [34.5537298777549, 1.282204420764645],
            [34.551701824101514, 1.277879383715052],
            [34.551322677559405, 1.264193031734931],
            [34.55212040668452, 1.251631403849974],
            [34.554256998383856, 1.245020079265584],
            [34.55681906813431, 1.239822751775689],
            [34.558097665431035, 1.241047816973462],
            [34.560269343528724, 1.246883110191045],
            [34.56338754320361, 1.250461875874466],
            [34.56629852669526, 1.251789580977099],
            [34.56745213958989, 1.253645727654131],
            [34.56633120021879, 1.260426500661523],
            [34.56432080834217, 1.265329526965251],
            [34.56461463289856, 1.269245366384824],
            [34.5667592429601, 1.272725963064994],
            [34.56529095471303, 1.280631247085609],
            [34.56537573950618, 1.281526542974686],
            [34.56658000480641, 1.283678251271649],
            [34.56612907478827, 1.285577751879793],
            [34.5675050494618, 1.286571730732528],
            [34.56740331166262, 1.288263004747056],
            [34.567956884981704, 1.288904778509807],
            [34.56840515957985, 1.290921290611741],
            [34.56794601087521, 1.293146377221614],
            [34.56931680226954, 1.294827687988987],
            [34.57026290433349, 1.294804136584169],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1114,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KITAWOI",
        Population: 7499,
        Key: "KWEENKITAWOI",
        Dist2: "Kween",
        "Sub Country": "Kitawoi",
        id2_original: "Kween  Kitawoi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.677549109245994, 1.441533484306941],
            [34.6781768384918, 1.442734603122537],
            [34.67815393594364, 1.443666090464465],
            [34.67908223070372, 1.445130429613789],
            [34.68086650494522, 1.44671169208745],
            [34.6856021940527, 1.453047548574995],
            [34.68586481203445, 1.454268205028209],
            [34.685603989784966, 1.455462125705391],
            [34.68443963393788, 1.456032735501675],
            [34.68084994450296, 1.456207262209078],
            [34.679662611547556, 1.458360482160594],
            [34.675966552599824, 1.459764989043213],
            [34.672543716245784, 1.460798509966052],
            [34.669595689825094, 1.460656025987482],
            [34.66775390274412, 1.461842096352364],
            [34.66656516751855, 1.462123333763267],
            [34.66490051383861, 1.46133779805724],
            [34.66240081771155, 1.456845059347468],
            [34.659403129726975, 1.454089023701964],
            [34.65700189793824, 1.454425412545225],
            [34.656884572572224, 1.456035241890077],
            [34.65602955967806, 1.457256748053868],
            [34.65619605702609, 1.45760932152202],
            [34.65793188332769, 1.458186816825406],
            [34.66139425813064, 1.462000590207154],
            [34.662227617134874, 1.46341075055851],
            [34.66228783659827, 1.465101834549042],
            [34.6593654795368, 1.4678080219336],
            [34.65545887255447, 1.473173739307666],
            [34.65236899316725, 1.474930495124301],
            [34.65115665201262, 1.475211751542602],
            [34.64780353839936, 1.474165207937598],
            [34.64624397503123, 1.471209131091559],
            [34.64605319622109, 1.469916045992469],
            [34.646574530801274, 1.467817556217498],
            [34.649319874836024, 1.46645898635852],
            [34.64977033234032, 1.464975512539646],
            [34.64762675534133, 1.459786110561627],
            [34.64662515625743, 1.455617775963163],
            [34.64464149015882, 1.454045657127569],
            [34.64419907077972, 1.454235896748846],
            [34.643290268562986, 1.456425106041065],
            [34.64060220021244, 1.458552320798816],
            [34.639190574998544, 1.462830971130284],
            [34.638492203137126, 1.46322940303239],
            [34.63727614655049, 1.461493929248986],
            [34.63659855990807, 1.459577186227465],
            [34.6347333672224, 1.457200087181792],
            [34.63430269151899, 1.457327013101045],
            [34.63405407198434, 1.460682371299533],
            [34.633399192955686, 1.462202177469908],
            [34.63248847014089, 1.462528415648683],
            [34.63144819948231, 1.462339262437818],
            [34.629845509793995, 1.461833993491582],
            [34.628831297465176, 1.459619046709464],
            [34.626972689430566, 1.459367182449187],
            [34.623658632769214, 1.457958787770306],
            [34.62231314691645, 1.456639391876997],
            [34.62065163913661, 1.453204005426974],
            [34.619952049159664, 1.452698066299196],
            [34.61935948805888, 1.452635189172582],
            [34.619313072108156, 1.452915576404125],
            [34.6186784869201, 1.451628527187812],
            [34.618690701313, 1.45051344500793],
            [34.617386325062604, 1.449565471788789],
            [34.61645648340358, 1.448149525760982],
            [34.61521905140475, 1.448019334094821],
            [34.61449719578518, 1.44711355461252],
            [34.61368266277431, 1.447103629598456],
            [34.61028484899252, 1.448897958642539],
            [34.608577581032115, 1.449051571726844],
            [34.6080499618382, 1.44867885774344],
            [34.607519929769424, 1.447528240915005],
            [34.604817836022356, 1.445182616805083],
            [34.603804853487176, 1.443627702369762],
            [34.603254120640976, 1.440600650841211],
            [34.602820087035056, 1.439433111901935],
            [34.60155044145014, 1.438087093832503],
            [34.60154845168177, 1.437029966736747],
            [34.60076828012888, 1.436904227778979],
            [34.59808238659964, 1.434749494933265],
            [34.59860758932546, 1.433534561946289],
            [34.59783231987907, 1.431129336121247],
            [34.59598203832878, 1.429137503347943],
            [34.59533780523459, 1.426031470042039],
            [34.59381356362341, 1.425666607432643],
            [34.59226527321378, 1.424079407845761],
            [34.59217343035747, 1.422163865429019],
            [34.59466192179798, 1.421889960954665],
            [34.597306672487186, 1.420510054067976],
            [34.599572849759504, 1.419846691264417],
            [34.60083331366389, 1.419129531199935],
            [34.60105698608478, 1.418156168161141],
            [34.60085721603695, 1.416893523397098],
            [34.59927317627228, 1.414424345933355],
            [34.599328349000416, 1.413026621932285],
            [34.59810483100702, 1.411213411332489],
            [34.59775173381154, 1.408663675100227],
            [34.597120034910496, 1.407796184386037],
            [34.595653837043095, 1.407275643822696],
            [34.59442705277536, 1.405881350550294],
            [34.59995620131542, 1.405351837191513],
            [34.604401216258196, 1.404442826810462],
            [34.60801230086822, 1.402217797877609],
            [34.60916589310158, 1.403147669832515],
            [34.609618740124525, 1.40724206235265],
            [34.6107025161923, 1.409174556894608],
            [34.61033294299622, 1.41109385758356],
            [34.61178447227332, 1.412882671165084],
            [34.61779032349701, 1.41318952676617],
            [34.62078177986845, 1.41395312191864],
            [34.62228417714685, 1.413669712495661],
            [34.62831125196743, 1.410358609121795],
            [34.63377961959706, 1.410503097075033],
            [34.636984880396, 1.411055952990148],
            [34.63855837843084, 1.410475781298206],
            [34.63959614638304, 1.412154780032775],
            [34.64151847551403, 1.413369969450525],
            [34.64191788086238, 1.414685064450416],
            [34.644343837880996, 1.417521626390449],
            [34.64530617968871, 1.419591048150018],
            [34.648444966054946, 1.420900753179144],
            [34.65029363512927, 1.422854646472502],
            [34.651364615594154, 1.424786757108186],
            [34.65383390554547, 1.425663816332996],
            [34.65454819824868, 1.427430141688432],
            [34.65539086110432, 1.428013247501738],
            [34.656097877453746, 1.431032785674647],
            [34.65748893304424, 1.430918762154063],
            [34.65982893656155, 1.431821135537643],
            [34.661176371758486, 1.431776203264044],
            [34.66346703980037, 1.433469673591397],
            [34.665668459320464, 1.432520034606213],
            [34.66838931528057, 1.433867873574942],
            [34.66941242003239, 1.43391106990785],
            [34.67204414514998, 1.436030087867622],
            [34.67250937814407, 1.439381749870026],
            [34.67341465716826, 1.439813883643725],
            [34.67584915626695, 1.439917458122868],
            [34.677549109245994, 1.441533484306941],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1115,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KAPRORON",
        Population: 5113,
        Key: "KWEENKAPRORON",
        Dist2: "Kween",
        "Sub Country": "Kaproron",
        id2_original: "Kween  Kaproron",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.78260133430257, 1.221093750181155],
            [34.78018390768589, 1.223732324389776],
            [34.77640322474346, 1.240895379885829],
            [34.774956158296675, 1.242448351389417],
            [34.770696945497356, 1.249788112071273],
            [34.76721465773951, 1.257339097705271],
            [34.76683980694112, 1.256681381112431],
            [34.765525873514406, 1.255886726637603],
            [34.7647523728508, 1.254529435708946],
            [34.761410522314556, 1.25170241579311],
            [34.759285877310234, 1.248242211159811],
            [34.75687430142098, 1.245599946723699],
            [34.75452555460101, 1.244554225904955],
            [34.74865125805746, 1.243455738382943],
            [34.74446828886955, 1.243052011082691],
            [34.740073479869686, 1.243234080981536],
            [34.73600917274094, 1.242313081643051],
            [34.73609074246368, 1.241036825071712],
            [34.73075055813689, 1.239881879414233],
            [34.7090179290819, 1.233079945276055],
            [34.70857151399641, 1.23159838761547],
            [34.70623908237863, 1.229234717833844],
            [34.700255760003984, 1.225084816340281],
            [34.698650933223604, 1.224976033668966],
            [34.69613198530171, 1.226461129962259],
            [34.693992698656565, 1.226845333089179],
            [34.69037818338046, 1.225124876534146],
            [34.688190864715374, 1.224743431256384],
            [34.68621741066493, 1.224919313532427],
            [34.677571412617866, 1.221952178278842],
            [34.66936073815748, 1.220291372053575],
            [34.66327675596194, 1.219964000494532],
            [34.66194576622293, 1.218975105731039],
            [34.66049817336338, 1.216487135889945],
            [34.65822755392198, 1.216008236047587],
            [34.656057563758736, 1.214554097341866],
            [34.6545686636675, 1.215457417015561],
            [34.65208032134731, 1.215422481311508],
            [34.64909168119431, 1.217261925133249],
            [34.64617542279527, 1.217245223832029],
            [34.64220596787907, 1.218184969139934],
            [34.64015304796027, 1.217341423361528],
            [34.63926394939096, 1.216114839361561],
            [34.63400640018884, 1.214582599870507],
            [34.632413538968066, 1.214676068332025],
            [34.631101728260354, 1.21348673239225],
            [34.63039707537846, 1.213332998653608],
            [34.62988205056483, 1.212685828501323],
            [34.629184611154656, 1.209822068095598],
            [34.624134051760294, 1.206052933558109],
            [34.62029991277028, 1.201836763852428],
            [34.61749734425529, 1.201532255244832],
            [34.61393766663571, 1.199926744429402],
            [34.612591457639134, 1.197925051774981],
            [34.6115525164872, 1.19425912805399],
            [34.61074202679344, 1.192834806125404],
            [34.60334925672115, 1.185468437052098],
            [34.601682531526144, 1.185044181671566],
            [34.60012773192396, 1.181030128719773],
            [34.599042577840535, 1.179916738886499],
            [34.599153597931554, 1.17921386901748],
            [34.599759576269406, 1.178655861183123],
            [34.59946839365824, 1.177103099251745],
            [34.59833049768787, 1.175512949257365],
            [34.597378794628085, 1.17519696059093],
            [34.59618189461489, 1.173834099359377],
            [34.59619736629903, 1.172678860216026],
            [34.595675179217636, 1.1713913623359],
            [34.596201832722635, 1.170047546749755],
            [34.59556688551351, 1.168640322653383],
            [34.58951305077893, 1.16235059468652],
            [34.588263729577314, 1.160161846371552],
            [34.58558897785254, 1.159696752718947],
            [34.5848038197515, 1.158548627262528],
            [34.584945599056155, 1.157005156177267],
            [34.58455270200205, 1.155856806893936],
            [34.582216459730816, 1.152052263899615],
            [34.58210749947674, 1.149963500537607],
            [34.58256172810859, 1.148250283592643],
            [34.584319393353056, 1.148773548609906],
            [34.58774118227148, 1.148714172922321],
            [34.58945065110435, 1.149145848782683],
            [34.59869389586469, 1.152747041182663],
            [34.604520574511675, 1.153727294429024],
            [34.60666270342641, 1.155045718588833],
            [34.6095839807129, 1.155175323632791],
            [34.61195945959909, 1.156168182228321],
            [34.615312686400074, 1.158362866688499],
            [34.61698959489715, 1.15997705229252],
            [34.61805252645708, 1.161786389987814],
            [34.6206754121523, 1.163840511856375],
            [34.62107173717754, 1.164723228872645],
            [34.62596150891582, 1.166252979513003],
            [34.628924804001414, 1.166269196133665],
            [34.63394557975252, 1.168356734096315],
            [34.637919940368526, 1.169382623907279],
            [34.64149586940991, 1.17314056668236],
            [34.644608232730384, 1.174715308871285],
            [34.64914457669316, 1.176081569978154],
            [34.651855018484184, 1.179131102303669],
            [34.655728824382194, 1.180863175462961],
            [34.65751078546184, 1.184898475556802],
            [34.660752231298765, 1.186649435329383],
            [34.664119664057644, 1.189384556868588],
            [34.66513835179323, 1.19141299550419],
            [34.66820955340907, 1.202186095677112],
            [34.66975226258585, 1.205073833063008],
            [34.67555594076832, 1.206557760179584],
            [34.67772763323903, 1.206679024712105],
            [34.68288004362027, 1.208239923947651],
            [34.690732358554285, 1.209197834968058],
            [34.695775429592416, 1.210356835369828],
            [34.698249392579825, 1.211096290948627],
            [34.7018470204269, 1.213103821539887],
            [34.70546235496655, 1.212514833861642],
            [34.708832074836145, 1.212714245728844],
            [34.71117408968136, 1.21239623878522],
            [34.71248282455754, 1.212919912945394],
            [34.71466453504031, 1.212882416685474],
            [34.71700066142882, 1.213446009217211],
            [34.72107989137108, 1.214877432538293],
            [34.723584833659395, 1.214390700860654],
            [34.72662170885162, 1.215475278690044],
            [34.72762137655765, 1.215342347162529],
            [34.72883420549748, 1.2157916632793],
            [34.72991437842267, 1.215324854611685],
            [34.73175469316486, 1.215918911525611],
            [34.73348970020291, 1.215673622482411],
            [34.734528726694805, 1.216473375005301],
            [34.73744702426953, 1.216375522917188],
            [34.73831604100065, 1.216990789428293],
            [34.73969271815673, 1.216358070788133],
            [34.74065140561782, 1.21640009438668],
            [34.74144451830069, 1.217395430460112],
            [34.74325840101399, 1.218162936650087],
            [34.7447083034421, 1.218074380085466],
            [34.746335143438486, 1.21738794199792],
            [34.74897246775526, 1.21742694882054],
            [34.75073089027952, 1.216946515168585],
            [34.75818196370872, 1.218818008875436],
            [34.7620697680538, 1.217499034921685],
            [34.76355287401147, 1.217568578464521],
            [34.76899353939436, 1.215872460222368],
            [34.77242801881281, 1.217809531248865],
            [34.77411107807461, 1.220076855407024],
            [34.77669196034378, 1.220286700975423],
            [34.77803419878678, 1.219251493394684],
            [34.77890993042467, 1.219121620124501],
            [34.78137446469485, 1.219989738578342],
            [34.78260133430257, 1.221093750181155],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1116,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "SUAM",
        Population: 10736,
        Key: "BUKWOSUAM",
        Dist2: "BUKWO",
        "Sub Country": "Swam Silam",
        id2_original: "BUKWO Swam Silam",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.81223375874589, 1.304447749436065],
            [34.805785030900616, 1.306623473649028],
            [34.80577030122491, 1.307325222919517],
            [34.79755837002142, 1.308853962747876],
            [34.796463001194894, 1.309921809456309],
            [34.79592373444499, 1.308873229277487],
            [34.79518061300769, 1.30859343844432],
            [34.79163326027381, 1.309265168814761],
            [34.79119505309507, 1.30808219231215],
            [34.79027639546131, 1.307439486718312],
            [34.789858009609326, 1.306598800650224],
            [34.789857368212196, 1.305694513928003],
            [34.788805025094526, 1.305610013387786],
            [34.78779424702505, 1.304095403813434],
            [34.78591840391336, 1.304485591937299],
            [34.78485975731735, 1.304296448577827],
            [34.784023069156675, 1.303519357397836],
            [34.782766290141545, 1.300986549747671],
            [34.782191451903046, 1.30077768330748],
            [34.781723946171304, 1.301221569264122],
            [34.780984285044454, 1.300754395096627],
            [34.776034542676136, 1.301164846301327],
            [34.77191173995103, 1.302081110591933],
            [34.77013051010003, 1.301791395181122],
            [34.769312912037435, 1.302310034715401],
            [34.76899520487092, 1.30339343271313],
            [34.76798075987842, 1.302425429428739],
            [34.76649814979082, 1.303323833086874],
            [34.7654764805468, 1.303026136555429],
            [34.76496188602621, 1.303395765034312],
            [34.76348230056613, 1.30179555061316],
            [34.761564235737794, 1.297189884516894],
            [34.75885511536856, 1.293800220031063],
            [34.75873995404406, 1.291665131296082],
            [34.75516451907608, 1.281480393691191],
            [34.75295446584779, 1.280278580234559],
            [34.749873532782466, 1.275309925431831],
            [34.74838368047702, 1.276031347083274],
            [34.747096713576816, 1.277633674749263],
            [34.73702294309861, 1.282597430461404],
            [34.73467261973534, 1.28701051982757],
            [34.733903201016375, 1.286958383085846],
            [34.73354824790153, 1.28644945414087],
            [34.73335534816901, 1.285639614057096],
            [34.73270564972462, 1.285211121320146],
            [34.73093271761188, 1.287205290104746],
            [34.72992781452435, 1.28751941722749],
            [34.72884811141808, 1.286022051819911],
            [34.7273628126728, 1.285511947089452],
            [34.72706982983782, 1.284317748632232],
            [34.72737019502781, 1.283347273712722],
            [34.72570253468659, 1.281974597636873],
            [34.72304699792573, 1.282373977523345],
            [34.720753291781556, 1.281847939939915],
            [34.71820569928018, 1.280234893494229],
            [34.71668366662633, 1.280244089048424],
            [34.716778639213096, 1.27901835524415],
            [34.71546000939406, 1.273777827215693],
            [34.7125051503873, 1.269472090426424],
            [34.71105703111499, 1.266356895865951],
            [34.7108891602429, 1.264808257489032],
            [34.70970233753057, 1.262855327240977],
            [34.709529504364845, 1.259990836014307],
            [34.712085114330115, 1.245376328943447],
            [34.71126405056715, 1.243368499278327],
            [34.710523593532976, 1.238239324871572],
            [34.709244188650835, 1.234971757247011],
            [34.7090179290819, 1.233079945276055],
            [34.73075055813689, 1.239881879414233],
            [34.73609074246368, 1.241036825071712],
            [34.73600917274094, 1.242313081643051],
            [34.733569774230716, 1.243110494708555],
            [34.732000951926935, 1.24418766948037],
            [34.732832702048505, 1.246050007658883],
            [34.733076149083765, 1.250779415753881],
            [34.731952135677766, 1.251096675387293],
            [34.729852719858194, 1.250573568246672],
            [34.728018863104566, 1.250827995845834],
            [34.72462399220364, 1.250378090201857],
            [34.72449456473413, 1.250821292418286],
            [34.725116814256715, 1.253470534332348],
            [34.72592164546249, 1.254519009666515],
            [34.725699060901384, 1.255052705513904],
            [34.72666408867175, 1.256336194858931],
            [34.728410233921046, 1.256760059093238],
            [34.728961603672744, 1.257501231511234],
            [34.729738397560176, 1.257753920615661],
            [34.73374749872313, 1.26312286765599],
            [34.73417106875264, 1.264207760519552],
            [34.73527154989147, 1.264812908730337],
            [34.73614387332114, 1.266006014273026],
            [34.73836289892251, 1.266510930081659],
            [34.741506493072144, 1.266563059155172],
            [34.74243145777749, 1.267539087939948],
            [34.74388977472489, 1.266660916570568],
            [34.745164122092014, 1.266949429821572],
            [34.74643457346572, 1.266451196829538],
            [34.74777039614097, 1.267137561998193],
            [34.74855866331121, 1.266919992041425],
            [34.750258721393145, 1.267298642625207],
            [34.75141709446046, 1.2679851252198],
            [34.75582306053614, 1.267258671086171],
            [34.75707055097121, 1.267700926534533],
            [34.758151703958355, 1.268794392493843],
            [34.76040208076313, 1.268358784034771],
            [34.76206010218136, 1.268864054132228],
            [34.762166397133974, 1.268276185321287],
            [34.76348947361369, 1.268392835313473],
            [34.76396166136467, 1.269115950909906],
            [34.76368888433537, 1.270137997995922],
            [34.767706842887044, 1.274421602864638],
            [34.767312542664435, 1.275923011079176],
            [34.76792174595417, 1.277459896644654],
            [34.770950566851546, 1.280514314749123],
            [34.772562939480274, 1.280775436474355],
            [34.77343061682331, 1.281724341132998],
            [34.774815162322945, 1.282220736372036],
            [34.77708169263315, 1.282427137283462],
            [34.77755310244312, 1.282824695772542],
            [34.78173565481274, 1.282288229656911],
            [34.781932746982676, 1.281465186322924],
            [34.78302702974604, 1.280424483200727],
            [34.78476154181239, 1.281110525825184],
            [34.78591653721422, 1.280169252917141],
            [34.78730059313203, 1.279969336939915],
            [34.79003991126785, 1.281775984031729],
            [34.79162132256198, 1.281946682291776],
            [34.791961385202676, 1.282808342449213],
            [34.79500070111754, 1.284020611176778],
            [34.798532647744295, 1.286653109253311],
            [34.79915545601897, 1.288343675520354],
            [34.802370927967765, 1.289299920133694],
            [34.80693894922243, 1.293166967650662],
            [34.81024061542104, 1.294521009596504],
            [34.810369894668526, 1.295488493223128],
            [34.8121499055057, 1.296988308418006],
            [34.81223625336743, 1.297594110776007],
            [34.813952472141324, 1.299401420715758],
            [34.81365265222874, 1.300242613909851],
            [34.81290249967769, 1.300324542517669],
            [34.81275323650837, 1.301256054777233],
            [34.81350371335124, 1.301626263677635],
            [34.8136754730302, 1.302313388158221],
            [34.81230388842349, 1.302658007821146],
            [34.81194069326592, 1.3036077619741],
            [34.81223375874589, 1.304447749436065],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1117,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "BUKWO",
        Population: 8450,
        Key: "BUKWOBUKWO",
        Dist2: "BUKWO",
        "Sub Country": "Bukwo",
        id2_original: "BUKWO Bukwo",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.17169171704834, 0.682180508444422],
            [32.16290621782417, 0.684395331425936],
            [32.16003284050524, 0.687362031448585],
            [32.15677866374411, 0.68711719975621],
            [32.14990200904021, 0.687459728780329],
            [32.143502118105374, 0.692985877484943],
            [32.1407470516043, 0.693899051392975],
            [32.13763543029223, 0.694296515959482],
            [32.136162389059, 0.693364475295518],
            [32.132455314070974, 0.688189307642155],
            [32.1270510062026, 0.685754860470951],
            [32.12149144070702, 0.681637778501866],
            [32.116895373150875, 0.682243028552743],
            [32.11117045026938, 0.681056904234711],
            [32.10775008697731, 0.680748693364967],
            [32.101681548618174, 0.682086395927327],
            [32.099495967294835, 0.681778411482858],
            [32.09229800587505, 0.678466135992277],
            [32.088519852588476, 0.673915181675588],
            [32.086191658323905, 0.671924583132524],
            [32.08272343548845, 0.670919800243279],
            [32.0767012097738, 0.668168622658109],
            [32.071617957093004, 0.667443963213991],
            [32.07002567887884, 0.664648400911856],
            [32.0663316043096, 0.662666592531875],
            [32.06416952560907, 0.659988526561026],
            [32.059548370801984, 0.655609325155031],
            [32.05524854516869, 0.653862608543333],
            [32.05460687766291, 0.652378926147358],
            [32.0524448726242, 0.650867816823154],
            [32.05066355024673, 0.651419287504511],
            [32.04864506724435, 0.65277581651968],
            [32.045747652805055, 0.654014574726287],
            [32.03988090300818, 0.655207524238206],
            [32.039572045145505, 0.654990359035725],
            [32.039595202815214, 0.652837400119807],
            [32.0378843550684, 0.650512232666624],
            [32.03503459984818, 0.652212339882684],
            [32.03318183355785, 0.651949645489994],
            [32.032635100011305, 0.65041171137624],
            [32.03030642874131, 0.64681998205751],
            [32.03042447994607, 0.644766553877688],
            [32.027977070260135, 0.640930564170478],
            [32.02751342189423, 0.639582616656636],
            [32.02510581027033, 0.637646305155874],
            [32.01962661165334, 0.636007925097464],
            [32.01760718452158, 0.633583207458767],
            [32.01628792228858, 0.630633958258752],
            [32.01510011322604, 0.629005451466906],
            [32.01474239240181, 0.624337648784064],
            [32.013803539742206, 0.621858868294204],
            [32.01380317861943, 0.620782395045981],
            [32.015322768754054, 0.618629733540092],
            [32.01583159788718, 0.612541869874447],
            [32.01540283020544, 0.607756457283854],
            [32.01471328249503, 0.605531013999107],
            [32.01364420286531, 0.604164872053918],
            [32.01491219375347, 0.603334762530687],
            [32.017280150147464, 0.602641139848208],
            [32.02755703150802, 0.601682509823384],
            [32.03410580831973, 0.59990919101444],
            [32.03698381914889, 0.599706969765841],
            [32.040711958732025, 0.600590135020563],
            [32.042706685786726, 0.602236137926378],
            [32.044995818607774, 0.60317474731228],
            [32.04932505418518, 0.605896402186543],
            [32.0538463765198, 0.606711967510565],
            [32.05545536429653, 0.606645286610275],
            [32.0574947825366, 0.606054014465765],
            [32.059579281830906, 0.604640896074014],
            [32.06671598713146, 0.598279340931379],
            [32.073071481528345, 0.594097151526647],
            [32.080355091920566, 0.586491451413905],
            [32.08196450100721, 0.587817395758194],
            [32.09453136499507, 0.590011717654339],
            [32.1146127809634, 0.598526993845988],
            [32.124429273944216, 0.604695305797311],
            [32.12673490073221, 0.600490075380967],
            [32.1288075692142, 0.593683225589306],
            [32.132130066445946, 0.592818099126013],
            [32.13319391788074, 0.591675689968132],
            [32.13333975757048, 0.586938523083144],
            [32.13386072743467, 0.586071539749056],
            [32.13589965339797, 0.583813575769995],
            [32.139819278765394, 0.580644469605173],
            [32.14448747564895, 0.579736405649915],
            [32.14950731805046, 0.580004495912613],
            [32.1498471606039, 0.579708069744784],
            [32.14957367839715, 0.574844853818415],
            [32.15057052090162, 0.573864235651245],
            [32.151658241471814, 0.573614294650091],
            [32.15641776378209, 0.574829558075584],
            [32.16038337750216, 0.573738050241539],
            [32.16309199571314, 0.575122286320049],
            [32.16973292889325, 0.577549638683132],
            [32.17134091325182, 0.574218126263179],
            [32.17237174980328, 0.5732261188191],
            [32.17432051994635, 0.572543330029061],
            [32.1811874503873, 0.572961814446889],
            [32.190444281268014, 0.575068466471044],
            [32.19599878206203, 0.576710872153249],
            [32.20135977316743, 0.580518084031863],
            [32.20172258294772, 0.581157749560038],
            [32.20154196318512, 0.58325799029429],
            [32.20088532166189, 0.58508374636203],
            [32.207517236654844, 0.594440275135178],
            [32.21283483913203, 0.604229167191995],
            [32.21649783917894, 0.613376987598581],
            [32.21932056858385, 0.617067297477194],
            [32.2183466142545, 0.618824211052338],
            [32.21660199075132, 0.620192156567248],
            [32.21517448152658, 0.62105815535616],
            [32.213950593427285, 0.620782842380711],
            [32.21324784317718, 0.620165622786511],
            [32.212364006040474, 0.62023314159738],
            [32.20684851458768, 0.624688979681813],
            [32.204784833750075, 0.625283881432226],
            [32.201432136056816, 0.630231779903475],
            [32.19693488408026, 0.634510051279595],
            [32.195167480199785, 0.635559160699921],
            [32.19133774115802, 0.636264177991905],
            [32.18952509003501, 0.637539437407194],
            [32.18802970770064, 0.63922183528105],
            [32.18720298455144, 0.640813874026899],
            [32.18690934953957, 0.643663451117197],
            [32.18625257865892, 0.644920798317351],
            [32.18552742173065, 0.645309676810638],
            [32.18545998699891, 0.64729083273264],
            [32.183057937743264, 0.648176991079078],
            [32.181596949206195, 0.650727841382516],
            [32.18168780032245, 0.651569172499371],
            [32.18091795849703, 0.653893974772046],
            [32.17797269080251, 0.65708686881034],
            [32.175061050642384, 0.658995174241223],
            [32.17333949497736, 0.661229344475681],
            [32.17243347394474, 0.663373186971698],
            [32.1716403630585, 0.663716816235119],
            [32.171663858494746, 0.665951278968207],
            [32.1711996361054, 0.667724292214905],
            [32.16697853612863, 0.672680987086421],
            [32.16662280956432, 0.675503396277491],
            [32.16671852056627, 0.677448384586239],
            [32.16712253517036, 0.677991237161949],
            [32.169902136458454, 0.67977385822841],
            [32.17169171704834, 0.682180508444422],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1911,
        District: "MITYANA",
        County: "MITYANA",
        Subcounty: "KIKANDWA",
        Population: 29699,
        Key: "MITYANAKIKANDWA",
        Dist2: "Mityana",
        "Sub Country": "Kikandwa",
        id2_original: "Mityana Kikandwa",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.72695113813426, 1.297223155874036],
            [34.72317044800535, 1.298337933337009],
            [34.7206076515178, 1.298279814685849],
            [34.716080450607976, 1.297320409502537],
            [34.71287086711587, 1.298585516405051],
            [34.71097079015277, 1.298905581151987],
            [34.70514236428254, 1.298404600854487],
            [34.70497881790024, 1.297952158348928],
            [34.704018332910266, 1.297599309789594],
            [34.701499314919765, 1.298988792267735],
            [34.700120409941775, 1.298894021008851],
            [34.69874195322314, 1.299469207218132],
            [34.6976016740223, 1.300714192375094],
            [34.69650063323308, 1.30106963147077],
            [34.69365257493044, 1.296601389063475],
            [34.69260594958952, 1.295692860691464],
            [34.68951457360904, 1.294402869971373],
            [34.68780267932491, 1.294069037892281],
            [34.68376128642242, 1.294167456459604],
            [34.68214508158068, 1.294742794621477],
            [34.68124280203123, 1.296418315271946],
            [34.67962608784473, 1.29622797775242],
            [34.67514405602403, 1.293999727193009],
            [34.672736646521045, 1.291532472164403],
            [34.66858913653236, 1.280764467192641],
            [34.66795665609704, 1.277066107514705],
            [34.66909006857584, 1.277309538973312],
            [34.67141239145172, 1.279378964090264],
            [34.673810910328285, 1.279562087602852],
            [34.67448291483951, 1.280000940766817],
            [34.6759629296943, 1.279873298664379],
            [34.6773301817264, 1.28101192623753],
            [34.68209344551985, 1.282754151689556],
            [34.68431805864226, 1.283964488651775],
            [34.686562100527645, 1.28357274906414],
            [34.68836802237086, 1.283844229943017],
            [34.689659854546655, 1.282861006454532],
            [34.69109501472268, 1.283010423500024],
            [34.69291550454486, 1.281987311005],
            [34.69497891858283, 1.281461420628975],
            [34.69884355717335, 1.283068547888682],
            [34.69976636053212, 1.284144083242114],
            [34.700665504062925, 1.284261042355482],
            [34.70412484525518, 1.283562385106998],
            [34.70654567289354, 1.282602168785353],
            [34.70712135644671, 1.281878319646328],
            [34.70829583990034, 1.281416323008436],
            [34.70879169646245, 1.280565921748602],
            [34.71088228094445, 1.279551670642068],
            [34.71180773433332, 1.279551047366706],
            [34.71315320311811, 1.280372009540607],
            [34.71400430474751, 1.280010773068429],
            [34.71579600805641, 1.280497898544681],
            [34.71668366662633, 1.280244089048424],
            [34.71820569928018, 1.280234893494229],
            [34.720753291781556, 1.281847939939915],
            [34.72304699792573, 1.282373977523345],
            [34.72570253468659, 1.281974597636873],
            [34.72737019502781, 1.283347273712722],
            [34.72706982983782, 1.284317748632232],
            [34.7273628126728, 1.285511947089452],
            [34.72884811141808, 1.286022051819911],
            [34.72992781452435, 1.28751941722749],
            [34.73093271761188, 1.287205290104746],
            [34.73270564972462, 1.285211121320146],
            [34.73335534816901, 1.285639614057096],
            [34.73354824790153, 1.28644945414087],
            [34.730175621982, 1.289906000040041],
            [34.72695113813426, 1.297223155874036],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1118,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "KORTEK",
        Population: 5799,
        Key: "BUKWOKORTEK",
        Dist2: "BUKWO",
        "Sub Country": "Kortek",
        id2_original: "BUKWO Kortek",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.76496188602621, 1.303395765034312],
            [34.764512229819154, 1.305341825412613],
            [34.76322083602121, 1.305827857552848],
            [34.76172445386198, 1.308128466842738],
            [34.76029438443867, 1.309297168330096],
            [34.756737098134394, 1.310155992024573],
            [34.75318050892275, 1.312026815918212],
            [34.7494676730388, 1.311679127904047],
            [34.74840363565275, 1.310914111003247],
            [34.746881521252185, 1.310725839266],
            [34.74426578075674, 1.309650982482872],
            [34.74349227739821, 1.308365472247354],
            [34.7425574285298, 1.30767889994401],
            [34.742602709009994, 1.306825820429632],
            [34.743830112217, 1.304979160949662],
            [34.743528099516794, 1.303562713243311],
            [34.74278712325636, 1.302703408616697],
            [34.74022824162684, 1.301352218875079],
            [34.73939703049443, 1.300245255174847],
            [34.73842432302668, 1.299865626965672],
            [34.735082331454954, 1.29691465286257],
            [34.7343186359027, 1.296479403035937],
            [34.73198912830117, 1.296284536476388],
            [34.73006540408652, 1.29650137559118],
            [34.72819784164514, 1.297301128515221],
            [34.72695113813426, 1.297223155874036],
            [34.730175621982, 1.289906000040041],
            [34.73354824790153, 1.28644945414087],
            [34.733903201016375, 1.286958383085846],
            [34.73467261973534, 1.28701051982757],
            [34.73702294309861, 1.282597430461404],
            [34.747096713576816, 1.277633674749263],
            [34.74838368047702, 1.276031347083274],
            [34.749873532782466, 1.275309925431831],
            [34.75295446584779, 1.280278580234559],
            [34.75516451907608, 1.281480393691191],
            [34.75873995404406, 1.291665131296082],
            [34.75885511536856, 1.293800220031063],
            [34.761564235737794, 1.297189884516894],
            [34.76348230056613, 1.30179555061316],
            [34.76496188602621, 1.303395765034312],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1119,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "BUKWO TOWN COUNCIL",
        Population: 7589,
        Key: "BUKWOBUKWO TOWN COUNCIL",
        Dist2: "BUKWO",
        "Sub Country": "Bukwo  T/C",
        id2_original: "BUKWO Bukwo  T/C",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.73600917274094, 1.242313081643051],
            [34.740073479869686, 1.243234080981536],
            [34.74446828886955, 1.243052011082691],
            [34.74865125805746, 1.243455738382943],
            [34.75452555460101, 1.244554225904955],
            [34.75687430142098, 1.245599946723699],
            [34.759285877310234, 1.248242211159811],
            [34.761410522314556, 1.25170241579311],
            [34.7647523728508, 1.254529435708946],
            [34.765525873514406, 1.255886726637603],
            [34.76683980694112, 1.256681381112431],
            [34.76721465773951, 1.257339097705271],
            [34.770499433814166, 1.25995867961241],
            [34.77166806833696, 1.260234362481734],
            [34.77501220957716, 1.262147985876687],
            [34.77628213813137, 1.263451649270739],
            [34.780487556218205, 1.264771818124822],
            [34.7840751570701, 1.266775182191331],
            [34.78577617634937, 1.26727427190421],
            [34.786147360224774, 1.268490359466372],
            [34.78725882865784, 1.269107568091918],
            [34.78852436804359, 1.270799834332243],
            [34.789038389439035, 1.273364119606014],
            [34.790504698697504, 1.274490006122766],
            [34.79094344576377, 1.277066187444888],
            [34.79157807496925, 1.278030553228035],
            [34.791495772221246, 1.279264901996712],
            [34.79286306288093, 1.281804092468134],
            [34.7948160074951, 1.283386313682615],
            [34.79500070111754, 1.284020611176778],
            [34.791961385202676, 1.282808342449213],
            [34.79162132256198, 1.281946682291776],
            [34.79003991126785, 1.281775984031729],
            [34.78730059313203, 1.279969336939915],
            [34.78591653721422, 1.280169252917141],
            [34.78476154181239, 1.281110525825184],
            [34.78302702974604, 1.280424483200727],
            [34.781932746982676, 1.281465186322924],
            [34.78173565481274, 1.282288229656911],
            [34.77755310244312, 1.282824695772542],
            [34.77708169263315, 1.282427137283462],
            [34.774815162322945, 1.282220736372036],
            [34.77343061682331, 1.281724341132998],
            [34.772562939480274, 1.280775436474355],
            [34.770950566851546, 1.280514314749123],
            [34.76792174595417, 1.277459896644654],
            [34.767312542664435, 1.275923011079176],
            [34.767706842887044, 1.274421602864638],
            [34.76368888433537, 1.270137997995922],
            [34.76396166136467, 1.269115950909906],
            [34.76348947361369, 1.268392835313473],
            [34.762166397133974, 1.268276185321287],
            [34.76206010218136, 1.268864054132228],
            [34.76040208076313, 1.268358784034771],
            [34.758151703958355, 1.268794392493843],
            [34.75707055097121, 1.267700926534533],
            [34.75582306053614, 1.267258671086171],
            [34.75141709446046, 1.2679851252198],
            [34.750258721393145, 1.267298642625207],
            [34.74855866331121, 1.266919992041425],
            [34.74777039614097, 1.267137561998193],
            [34.74643457346572, 1.266451196829538],
            [34.745164122092014, 1.266949429821572],
            [34.74388977472489, 1.266660916570568],
            [34.74243145777749, 1.267539087939948],
            [34.741506493072144, 1.266563059155172],
            [34.73836289892251, 1.266510930081659],
            [34.73614387332114, 1.266006014273026],
            [34.73527154989147, 1.264812908730337],
            [34.73417106875264, 1.264207760519552],
            [34.73374749872313, 1.26312286765599],
            [34.729738397560176, 1.257753920615661],
            [34.728961603672744, 1.257501231511234],
            [34.728410233921046, 1.256760059093238],
            [34.72666408867175, 1.256336194858931],
            [34.725699060901384, 1.255052705513904],
            [34.72592164546249, 1.254519009666515],
            [34.725116814256715, 1.253470534332348],
            [34.72449456473413, 1.250821292418286],
            [34.72462399220364, 1.250378090201857],
            [34.728018863104566, 1.250827995845834],
            [34.729852719858194, 1.250573568246672],
            [34.731952135677766, 1.251096675387293],
            [34.733076149083765, 1.250779415753881],
            [34.732832702048505, 1.246050007658883],
            [34.732000951926935, 1.24418766948037],
            [34.733569774230716, 1.243110494708555],
            [34.73600917274094, 1.242313081643051],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1120,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "SENENDET",
        Population: 8811,
        Key: "BUKWOSENENDET",
        Dist2: "BUKWO",
        "Sub Country": "Senendet",
        id2_original: "BUKWO Senendet",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.723160970779105, 1.43759687588626],
            [34.72222737056893, 1.439452277696733],
            [34.72143660248895, 1.439764910384685],
            [34.72172969851162, 1.440714848994941],
            [34.72060632829938, 1.44040160667397],
            [34.72109604128327, 1.441465340816965],
            [34.7199127723062, 1.44150554117473],
            [34.719753289902236, 1.44248246667497],
            [34.718815132538616, 1.442375170873469],
            [34.719460168726705, 1.443896059807227],
            [34.71822217258586, 1.446724065130087],
            [34.71875148690073, 1.447587748780234],
            [34.71808013726136, 1.44813231774135],
            [34.71913801669614, 1.448863583025793],
            [34.71898411372838, 1.450343850725528],
            [34.71963504016978, 1.451041218360494],
            [34.72115543609323, 1.451690322219958],
            [34.721170875438006, 1.452213302529105],
            [34.720313191852505, 1.452267026979009],
            [34.7208704320946, 1.45325869882375],
            [34.72163337845195, 1.452946080567221],
            [34.72116116195485, 1.45399986318797],
            [34.722187311097166, 1.454813841031413],
            [34.721735122539336, 1.456066314460987],
            [34.721911642390985, 1.459351542464818],
            [34.72057403925481, 1.46075567964081],
            [34.721568054761114, 1.461126949403655],
            [34.72149353950827, 1.462447139210083],
            [34.72199516325452, 1.463470853393374],
            [34.72120584595371, 1.465687686708459],
            [34.72047869207056, 1.466028283739663],
            [34.720105712462924, 1.466896661128727],
            [34.72088088129797, 1.466968066360656],
            [34.72130266008683, 1.467535796873337],
            [34.72066342072728, 1.468484387541663],
            [34.72209819642434, 1.468251250695698],
            [34.7228607457263, 1.469451215692893],
            [34.723464963366176, 1.467454109322928],
            [34.724108786828616, 1.467301593977847],
            [34.72440750810165, 1.468085439314799],
            [34.725079237728394, 1.468040911870171],
            [34.725143767308495, 1.468638659333547],
            [34.72604550607218, 1.468508205732698],
            [34.72608697230567, 1.469614620279391],
            [34.7253037815151, 1.470572985904449],
            [34.72528764507768, 1.471754800691165],
            [34.72452242867763, 1.472793813747413],
            [34.724573900346755, 1.473283654956868],
            [34.723120810696, 1.474791103921234],
            [34.72214664616086, 1.47439982499696],
            [34.718455147959865, 1.476006865113591],
            [34.717608444482075, 1.475959519849094],
            [34.716599483704435, 1.477364368597575],
            [34.71382089481763, 1.476734546310138],
            [34.71270427454645, 1.477187461101815],
            [34.71149280565596, 1.478360526596296],
            [34.71127512140472, 1.479922690007198],
            [34.71157399179807, 1.48055669434568],
            [34.71278689080647, 1.481243821484926],
            [34.71204852055868, 1.482512530573926],
            [34.71214094642165, 1.483812593995051],
            [34.71151207272217, 1.484325999350675],
            [34.712455725978664, 1.484792451943173],
            [34.71282507549426, 1.485819330329062],
            [34.71235746555795, 1.486236679251853],
            [34.71174885695296, 1.485673095153145],
            [34.71120432966875, 1.485733526957729],
            [34.710863149523874, 1.486601885873714],
            [34.71134846255948, 1.487073555439666],
            [34.711712642270605, 1.490249605085971],
            [34.71274680528356, 1.49110488269196],
            [34.71237404755978, 1.492257296434809],
            [34.712918914407155, 1.492632908204223],
            [34.7122636940187, 1.493477510237348],
            [34.711214661192834, 1.493954384992356],
            [34.71104812072568, 1.494482571021475],
            [34.71227650309635, 1.494617620004239],
            [34.71229059317156, 1.495706009237123],
            [34.71066380168422, 1.496103044218839],
            [34.71161650456891, 1.498705234034599],
            [34.71118136423852, 1.499095101472567],
            [34.70877920898166, 1.49940380421283],
            [34.70753570526985, 1.500342143929959],
            [34.70668040132152, 1.500311516492319],
            [34.705839278178274, 1.49852808309418],
            [34.70199237322974, 1.501226836310082],
            [34.7021018545067, 1.501904994889533],
            [34.70149635137764, 1.503015222705667],
            [34.701714573719705, 1.503672354818848],
            [34.70044030720099, 1.504831461970378],
            [34.700961867258314, 1.505621380662988],
            [34.7006206862151, 1.506735272243085],
            [34.701009971143485, 1.507557912626097],
            [34.70208304378465, 1.507576750063142],
            [34.701796621346205, 1.509492551671165],
            [34.70075557274657, 1.510293086662598],
            [34.70080309003184, 1.511404205512415],
            [34.6994918470594, 1.514996927472757],
            [34.700238889642925, 1.515763189125336],
            [34.69948629996252, 1.51692796249678],
            [34.7003725050583, 1.517605503743168],
            [34.70040526302346, 1.519992912248991],
            [34.69973747879743, 1.520689773878895],
            [34.70057819949541, 1.522081775000831],
            [34.69994073520686, 1.524198416178187],
            [34.69870399940241, 1.524268680884917],
            [34.69779668479577, 1.524813874801316],
            [34.696064271193904, 1.524426797569626],
            [34.69257584075614, 1.5252352051616],
            [34.6863766343541, 1.524552813533659],
            [34.684324892126625, 1.525567805268426],
            [34.682374407099665, 1.527359415141441],
            [34.68049330255538, 1.527783650917887],
            [34.6767708250535, 1.526484268351854],
            [34.676237127858364, 1.524741664152392],
            [34.67552926709257, 1.524001359610397],
            [34.672388559229915, 1.524391988498148],
            [34.67126585107603, 1.525107303443679],
            [34.67011186807553, 1.523673559957091],
            [34.67101940905764, 1.523081768641086],
            [34.671076541011374, 1.522025388787293],
            [34.6713109644696, 1.522340957057657],
            [34.67230581630743, 1.519788952376482],
            [34.67248376268373, 1.518215258355437],
            [34.67163649236902, 1.517359750712316],
            [34.67218625593301, 1.511839875995601],
            [34.671766948409505, 1.510673599327557],
            [34.672346275529506, 1.509721197729913],
            [34.673023350132176, 1.506322738730494],
            [34.671903491434385, 1.5034116223692],
            [34.67252231747742, 1.502293063050159],
            [34.673760906506324, 1.501357331982169],
            [34.67571166551942, 1.497982632932029],
            [34.678539297929156, 1.496014314636725],
            [34.67864372797923, 1.495479665105125],
            [34.67951016205393, 1.49519530145975],
            [34.679605305320614, 1.494702861773443],
            [34.68024822956946, 1.494610662225367],
            [34.680119807314775, 1.494058559529846],
            [34.680658271869106, 1.493926996587302],
            [34.681504264779484, 1.49201932270873],
            [34.68243047634647, 1.491774934465601],
            [34.68257729340322, 1.49103320164926],
            [34.68305623019696, 1.490963967684622],
            [34.682932851084246, 1.487918128174404],
            [34.683626915523924, 1.486953490235555],
            [34.683226370213454, 1.486281044689455],
            [34.683487994658485, 1.484710932057321],
            [34.68319847033737, 1.484193939225505],
            [34.68408175051857, 1.482868942657518],
            [34.68389144332394, 1.481788444229944],
            [34.683306935619704, 1.481460461331977],
            [34.68421732965113, 1.481184305533121],
            [34.68547946352365, 1.479694805056906],
            [34.68543704238098, 1.479281650430939],
            [34.68787392021852, 1.479067892104271],
            [34.688963006227944, 1.478441979364651],
            [34.689377905718324, 1.477223291071654],
            [34.689050745580076, 1.475215458559044],
            [34.690277825393565, 1.472209839412421],
            [34.69144038011849, 1.471755142836384],
            [34.690925879921, 1.469266765099257],
            [34.69049370852262, 1.468951818708522],
            [34.68995595453569, 1.467094008394811],
            [34.68944785842783, 1.466803002936072],
            [34.689713013251925, 1.465938178980826],
            [34.68916778528181, 1.463461984525493],
            [34.68876814457482, 1.463165589562574],
            [34.68889451328078, 1.462112966089982],
            [34.68942239837603, 1.46226677045088],
            [34.68973731447697, 1.461780984096099],
            [34.6901368177417, 1.461861386782526],
            [34.69093133988129, 1.460719236954956],
            [34.690688439920024, 1.459612678822656],
            [34.69003799317898, 1.459195533255529],
            [34.69040407911516, 1.458554875677741],
            [34.690424347802896, 1.457050116142315],
            [34.689268544815654, 1.456871258326083],
            [34.68894761269725, 1.453140590396632],
            [34.68979052618284, 1.451963604380304],
            [34.68881702550272, 1.450663227895889],
            [34.68840422447682, 1.447689344548299],
            [34.69058201111844, 1.448558297460219],
            [34.69002487238595, 1.44701230455975],
            [34.69001114073851, 1.443639146866029],
            [34.69260974586992, 1.441439667906359],
            [34.693660922076035, 1.44123992604227],
            [34.69567033029744, 1.442739609642623],
            [34.69762691219022, 1.444944705418495],
            [34.70173269723058, 1.446316187537185],
            [34.70395712979162, 1.446215028149768],
            [34.70192549814843, 1.44278011530823],
            [34.70168143486888, 1.440076355832022],
            [34.701947077478195, 1.43402619426913],
            [34.70147198277894, 1.43253440675073],
            [34.69920594115222, 1.431794551911338],
            [34.69071683656447, 1.427288253710388],
            [34.68765556492578, 1.42501159426815],
            [34.688562169863346, 1.422949040174477],
            [34.6867711753252, 1.419794227797898],
            [34.687885748335866, 1.417966649356944],
            [34.6876489883596, 1.415968240532663],
            [34.68866804799768, 1.415632888658859],
            [34.689920102772696, 1.415975615245165],
            [34.691334990667684, 1.415504321498398],
            [34.69105595327919, 1.413288907689637],
            [34.69235489741706, 1.411696325723856],
            [34.692207605151516, 1.409932983330312],
            [34.69211343296366, 1.409399495252984],
            [34.690754314278145, 1.408550416507677],
            [34.69039210457241, 1.40780008369366],
            [34.69155550461205, 1.405927261297751],
            [34.693305764145315, 1.400925017695923],
            [34.6923651948052, 1.399505899507721],
            [34.690879394799964, 1.398973422945714],
            [34.69079319785521, 1.398593664661774],
            [34.69098835235911, 1.397417888275872],
            [34.692119230690494, 1.396395170203624],
            [34.692120725487136, 1.395346141547692],
            [34.69188071630446, 1.393483387111228],
            [34.69002329943589, 1.391594672158636],
            [34.691009219324854, 1.389685813306385],
            [34.69029026077201, 1.38794096679813],
            [34.69046729625666, 1.384178805997984],
            [34.689789058335684, 1.383618605762623],
            [34.688285812149324, 1.383809595662368],
            [34.68740130217449, 1.383014415138074],
            [34.68701877347539, 1.382101309989323],
            [34.68725456506779, 1.38119680425728],
            [34.68644738476757, 1.380157395105692],
            [34.6850049751872, 1.379814778241985],
            [34.684160425869464, 1.378341310530668],
            [34.682005409723665, 1.376479908662138],
            [34.681932182654975, 1.376005062370224],
            [34.686774935672986, 1.379405731306526],
            [34.68940609305532, 1.379927116812865],
            [34.69097721774116, 1.381296955268716],
            [34.69262064872253, 1.381986487503894],
            [34.69454438910683, 1.382047896434503],
            [34.69516501537369, 1.383440370002381],
            [34.69675992744827, 1.385387383173295],
            [34.696584454133905, 1.386086093213323],
            [34.69789616243368, 1.388456392754222],
            [34.699148020477665, 1.389154068230891],
            [34.69958776108059, 1.388888090576232],
            [34.70041991813897, 1.390530631344616],
            [34.70103569350331, 1.390353078623609],
            [34.70212128506628, 1.390952478968722],
            [34.70273710265145, 1.390833960536252],
            [34.70289386136348, 1.391306126771325],
            [34.70320628374118, 1.39072538800899],
            [34.70363644470992, 1.390734914530475],
            [34.70395037266405, 1.392249917433721],
            [34.70489914092778, 1.392908450287125],
            [34.707803193917066, 1.393624587448454],
            [34.70896782105533, 1.395365263702987],
            [34.70805884726039, 1.395661103443346],
            [34.70746310253027, 1.39649786833448],
            [34.709087273631944, 1.398316918684439],
            [34.71052477032601, 1.398857015329032],
            [34.711299092948096, 1.401611401928643],
            [34.7108500808331, 1.402566128449654],
            [34.71217009405767, 1.402870168238266],
            [34.71399060364279, 1.405791041360334],
            [34.71409878236258, 1.406666642162751],
            [34.71483221636788, 1.40696127260604],
            [34.718364277080674, 1.41083525355466],
            [34.71908912319185, 1.412743497075589],
            [34.71984187097575, 1.412713418049152],
            [34.720869412506765, 1.414119639509251],
            [34.72295215379805, 1.414669069433673],
            [34.72336801538409, 1.417352392471877],
            [34.72208028132262, 1.418206985557301],
            [34.7218341689859, 1.419320126658406],
            [34.72255383630949, 1.419762607827194],
            [34.72243668162339, 1.421037732869276],
            [34.7241334590579, 1.421609142447155],
            [34.72292130565119, 1.423036368107824],
            [34.723052701329465, 1.426472384645069],
            [34.72219572202316, 1.429066328617496],
            [34.72355974191687, 1.429724426277333],
            [34.72345555710684, 1.43397102534971],
            [34.722179302616404, 1.435819718204668],
            [34.72233057801192, 1.437105445490564],
            [34.72287809758433, 1.437051002255911],
            [34.723160970779105, 1.43759687588626],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1121,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KIRIKI",
        Population: 4863,
        Key: "KWEENKIRIKI",
        Dist2: "Kween",
        "Sub Country": "Kiriki",
        id2_original: "Kween  Kiriki",
        drought: "VH",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.36291733137482, 1.000702497939687],
            [34.36243754297819, 1.001082137216074],
            [34.35997633966109, 1.000615442907488],
            [34.358726969052135, 1.000775339298739],
            [34.35769757519501, 1.00018678099958],
            [34.35748729216342, 0.999403859439758],
            [34.356767915894, 0.99939723088145],
            [34.356541659918356, 0.997181920144448],
            [34.355488177736895, 0.997152900871365],
            [34.355244175542786, 0.994683074983314],
            [34.35613864334254, 0.993360432935712],
            [34.35582413777168, 0.985059887712315],
            [34.35629749962076, 0.980563387164948],
            [34.35815113458197, 0.975943121469472],
            [34.36040639822189, 0.97240397442752],
            [34.361136132964845, 0.9719838389586],
            [34.3637637357136, 0.971863815256132],
            [34.365585540669365, 0.973164565358609],
            [34.37066920028698, 0.974547242038303],
            [34.374175655420935, 0.973977441292603],
            [34.37804163789116, 0.974547933641013],
            [34.38192130260147, 0.974915238432977],
            [34.38881974414595, 0.974026679821043],
            [34.39700248998417, 0.973761779763052],
            [34.427260178696166, 0.960282666196826],
            [34.437257419898636, 0.951126612901616],
            [34.47146880078855, 0.937226233372237],
            [34.47839999311167, 0.933326628239054],
            [34.47989167887862, 0.934792670796542],
            [34.480641838616215, 0.937261443518329],
            [34.48007333260211, 0.942091339695838],
            [34.481501025981494, 0.945220051069309],
            [34.48135954042591, 0.947924353887024],
            [34.481788033223175, 0.949289856577373],
            [34.483286949529855, 0.952165289494325],
            [34.48346760971666, 0.958315321586647],
            [34.48464595233272, 0.961335594276089],
            [34.48548428800364, 0.962479310929503],
            [34.41255825733145, 0.977376069297597],
            [34.40570773372085, 0.980153416564012],
            [34.403237066652224, 0.979159849940403],
            [34.40213224215902, 0.979853927926353],
            [34.40031187899927, 0.979435912204149],
            [34.399181033007245, 0.980090741294856],
            [34.39840090906504, 0.979986374125069],
            [34.395389875708624, 0.98105379095637],
            [34.393134561763034, 0.982960047685033],
            [34.39066807545374, 0.982807121232388],
            [34.39030458744537, 0.982287644403993],
            [34.38963974699853, 0.98230400301585],
            [34.38633140182579, 0.984724786574],
            [34.38535599042905, 0.985838471753041],
            [34.385180998611695, 0.987111335066722],
            [34.38426420138892, 0.987605692590072],
            [34.38398872941377, 0.98843510503099],
            [34.38304307021926, 0.988435502925454],
            [34.38213171499048, 0.989549239854403],
            [34.3810584797542, 0.989693849736864],
            [34.37979589133419, 0.991226593028438],
            [34.37780669430838, 0.992155659499672],
            [34.37659403604847, 0.992251533990502],
            [34.37523657475463, 0.993758439945189],
            [34.37427528038258, 0.993728471265554],
            [34.37269746953607, 0.994946409648239],
            [34.3712435794864, 0.995447170921408],
            [34.37070343238754, 0.996830165293132],
            [34.370275751667286, 0.996300773861223],
            [34.36909160952773, 0.99626401766228],
            [34.36893877825015, 0.996816195909937],
            [34.368052375525004, 0.997391863246993],
            [34.36806537504547, 0.998030016797303],
            [34.36640778751354, 0.998668612127796],
            [34.36640822229817, 0.999718322541003],
            [34.3651514235201, 0.999624645212139],
            [34.36467835542014, 1.000160464371911],
            [34.36325830221227, 0.999725026545633],
            [34.36291733137482, 1.000702497939687],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1122,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "NALWANZA",
        Population: 8891,
        Key: "BUDUDANALWANZA",
        Dist2: "Bududa",
        "Sub Country": "Nalwanza",
        id2_original: "Bududa Nalwanza",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.55681906813431, 1.239822751775689],
            [34.554256998383856, 1.245020079265584],
            [34.55212040668452, 1.251631403849974],
            [34.551322677559405, 1.264193031734931],
            [34.551701824101514, 1.277879383715052],
            [34.5537298777549, 1.282204420764645],
            [34.55288907441192, 1.291030378577571],
            [34.55140052017205, 1.295118092131609],
            [34.55157517062957, 1.302760971252552],
            [34.55217134834766, 1.304799301104598],
            [34.552159092632266, 1.307901554052793],
            [34.55305277530445, 1.309996722842078],
            [34.55300362578032, 1.322107765202448],
            [34.551340636678574, 1.331722040437566],
            [34.5502461517943, 1.332271388718954],
            [34.54849674476221, 1.334523386966594],
            [34.54804102941858, 1.336246016160184],
            [34.5479208779527, 1.34033579033759],
            [34.547546660466594, 1.341550586191651],
            [34.548209191344824, 1.343282060911443],
            [34.54746563152964, 1.346790459642167],
            [34.547327261331496, 1.350772952105546],
            [34.54891958715633, 1.35495977996425],
            [34.547879655162625, 1.35622116365489],
            [34.54786920326429, 1.356904785762941],
            [34.547072246690306, 1.358102371845497],
            [34.54518398975972, 1.359293553250957],
            [34.54381924492559, 1.360949441620697],
            [34.54179468571861, 1.361518374530066],
            [34.54160067926166, 1.364296479095004],
            [34.53762860036648, 1.364218117017341],
            [34.52901898049516, 1.369275184667091],
            [34.52729373185605, 1.36981527625136],
            [34.525829627961585, 1.371650254368346],
            [34.522719781720504, 1.372079337403196],
            [34.52204755352877, 1.372572582980358],
            [34.52258450621849, 1.373913960847312],
            [34.522619076983894, 1.376733516986308],
            [34.52160205113161, 1.37852049501969],
            [34.52179466430159, 1.383038316834377],
            [34.520566483153566, 1.387845525450841],
            [34.52111818887518, 1.393455498180153],
            [34.52165302154085, 1.394958896540513],
            [34.517092859646624, 1.391722290496502],
            [34.50053193409025, 1.389919894794922],
            [34.48272892865178, 1.379279710843053],
            [34.48273754888526, 1.378418237053513],
            [34.483466299074664, 1.377612521431244],
            [34.48374301072488, 1.375762854793737],
            [34.48341370181644, 1.374256773437566],
            [34.483750800016715, 1.373042634328564],
            [34.484400851499025, 1.372416195236734],
            [34.4836831496893, 1.370865867140026],
            [34.48385171136582, 1.36771653940618],
            [34.48253432571346, 1.36653838762624],
            [34.481939893421966, 1.365188182188628],
            [34.48205857524406, 1.363065321175834],
            [34.48110372897909, 1.358100682589088],
            [34.48182696890254, 1.356924481190871],
            [34.48184263102953, 1.351579740028074],
            [34.483313795682115, 1.34796069919685],
            [34.48549316425696, 1.344159248179507],
            [34.489811446676086, 1.33820110156555],
            [34.49160833056924, 1.336407406697002],
            [34.49273917745959, 1.33596493698645],
            [34.49356571016598, 1.334809015935466],
            [34.49646922865765, 1.33442492957646],
            [34.49818987522757, 1.332206501187822],
            [34.49954013382945, 1.331678940134834],
            [34.5013790067756, 1.329553895441927],
            [34.50388492822758, 1.327768268858306],
            [34.50721055069819, 1.327502861010208],
            [34.508231160828466, 1.326253374578619],
            [34.50999544935154, 1.326430697612497],
            [34.510662044208104, 1.326022496643031],
            [34.5107031448273, 1.324204406575915],
            [34.512087149541145, 1.323668330956562],
            [34.51196764037069, 1.321468037648388],
            [34.513671974433386, 1.32022663086679],
            [34.514201263595396, 1.31610593131061],
            [34.51476640452044, 1.315434431787489],
            [34.51640743250841, 1.31484857736552],
            [34.51753113689394, 1.312934029891349],
            [34.517615680938604, 1.311014729208988],
            [34.517250777185346, 1.309915157373872],
            [34.5175179442357, 1.308825982139036],
            [34.519606298200856, 1.307714130776148],
            [34.52225056290153, 1.304682694986899],
            [34.52180473531422, 1.302618160770883],
            [34.52307292922162, 1.300482497517969],
            [34.52299044770889, 1.296924397984671],
            [34.52375067756078, 1.296282390950416],
            [34.524263947964684, 1.29470247864555],
            [34.52546901456213, 1.294486101891102],
            [34.52880307580651, 1.289497288403811],
            [34.52882881613267, 1.287755940493995],
            [34.530815293059796, 1.286503998669157],
            [34.532276279800236, 1.284314321522275],
            [34.53377030837344, 1.283639529230015],
            [34.53455567488361, 1.280253438176111],
            [34.53408371081311, 1.279240193706485],
            [34.53460252472063, 1.277972971172618],
            [34.53428457321233, 1.274733105530742],
            [34.535359325703105, 1.271567880901921],
            [34.53551834367806, 1.268742846328905],
            [34.53607504942256, 1.268144099760687],
            [34.5364297555007, 1.266461911112954],
            [34.53786153351968, 1.264811140378509],
            [34.53818380592449, 1.26090264699289],
            [34.53937054060193, 1.25616918699523],
            [34.54050545057232, 1.253799460859848],
            [34.53943166556713, 1.250634430775752],
            [34.54041761689709, 1.248975961379557],
            [34.540506696535594, 1.246793375372723],
            [34.541375043123544, 1.246072347967395],
            [34.54246489988748, 1.243819219802431],
            [34.542127879840656, 1.240879018215947],
            [34.54266134706707, 1.238366158023384],
            [34.53632521675444, 1.22784609525877],
            [34.53505936924656, 1.224139993733103],
            [34.53433357002289, 1.223040303294557],
            [34.53645932803985, 1.217222962315766],
            [34.53649593169275, 1.213433485917945],
            [34.53594062103188, 1.208649502330216],
            [34.53615653111042, 1.205113157098018],
            [34.537879641759176, 1.201358898752032],
            [34.53879489028638, 1.197080549498559],
            [34.53818611279814, 1.192025275111239],
            [34.539067112156836, 1.183677132821407],
            [34.53826014206237, 1.181705984349208],
            [34.53732287492921, 1.180750632377429],
            [34.536943103159686, 1.18049566289237],
            [34.53654636670605, 1.180015702359185],
            [34.53592898156072, 1.178641354664636],
            [34.53571438122588, 1.175430833575234],
            [34.53499408328497, 1.174096442175593],
            [34.53073465309338, 1.169898803280289],
            [34.529097453725136, 1.16769276017553],
            [34.52649745979828, 1.162801335780386],
            [34.524912138137715, 1.157619188393154],
            [34.52379175482378, 1.150258641841746],
            [34.52348819522465, 1.144398219956594],
            [34.52366809364008, 1.142625482860612],
            [34.52596506426201, 1.137469123905801],
            [34.5267902854281, 1.129958014372803],
            [34.526996245766554, 1.125495470067499],
            [34.52538570210772, 1.123311192463062],
            [34.52635629853455, 1.119046711976567],
            [34.53080796370538, 1.118781755007726],
            [34.533461232220134, 1.116038234459514],
            [34.53626449333621, 1.114945915851053],
            [34.53791417389699, 1.113413864748399],
            [34.53787354579164, 1.111762610891468],
            [34.53586389772008, 1.10785511469363],
            [34.535981234764186, 1.107130989580969],
            [34.53445025309344, 1.105723158180254],
            [34.53484204342316, 1.104590782834982],
            [34.53423800275137, 1.103601765058336],
            [34.575191139237305, 1.099430983447809],
            [34.57318755659054, 1.103457759492973],
            [34.57200620821153, 1.10381648275381],
            [34.57064014195559, 1.105720221236269],
            [34.56806964241451, 1.113394618384688],
            [34.56632332738362, 1.115297891751261],
            [34.564720468812055, 1.118744497298525],
            [34.563330289977294, 1.119786147512851],
            [34.56124739597241, 1.126064354933821],
            [34.55968348745325, 1.127399853758722],
            [34.55982865071158, 1.12887162510144],
            [34.55925914038103, 1.130058730061197],
            [34.55961700852895, 1.132427491306633],
            [34.55938763989083, 1.134848870789182],
            [34.55723005366501, 1.142900963813571],
            [34.554016619993604, 1.147774850458047],
            [34.55443986932455, 1.150463420936949],
            [34.55607165903817, 1.151998346238828],
            [34.55681131297847, 1.153285778415657],
            [34.5552174402547, 1.153927135339121],
            [34.554638697937975, 1.157175725834321],
            [34.55509067898498, 1.157860027851068],
            [34.55615269965318, 1.164159682079431],
            [34.55835683747536, 1.171158474259919],
            [34.55758673064688, 1.183956106161221],
            [34.55775258749612, 1.186298396892992],
            [34.558429371942964, 1.188432385999264],
            [34.557621190919505, 1.190323032853815],
            [34.55807222873546, 1.191471358105604],
            [34.55834445869072, 1.198181815887521],
            [34.55881961896699, 1.199275860960973],
            [34.55827276504624, 1.200497108761655],
            [34.55886673201041, 1.201147931765546],
            [34.55894973724097, 1.202929542914116],
            [34.55757285347239, 1.207605079218731],
            [34.55649894629633, 1.208305251974127],
            [34.55555258012763, 1.209674990977973],
            [34.55477658574081, 1.211831209051917],
            [34.554873354958175, 1.217165927676222],
            [34.55434595854644, 1.219037784067919],
            [34.55466806206796, 1.220404954422659],
            [34.554546795792824, 1.223259348876064],
            [34.55251679369356, 1.227253099852601],
            [34.552448596292116, 1.22903482760201],
            [34.55340230079836, 1.231748084212168],
            [34.553896823362244, 1.236337380997858],
            [34.55681906813431, 1.239822751775689],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1123,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "BENET",
        Population: 11117,
        Key: "KWEENBENET",
        Dist2: "Kween",
        "Sub Country": "Benet",
        id2_original: "Kween  Benet",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.59442705277536, 1.405881350550294],
            [34.574334391696304, 1.407486565689696],
            [34.56964630341742, 1.407536390980373],
            [34.55436148412948, 1.4047465897571],
            [34.553123821263625, 1.40176440300562],
            [34.55639527172937, 1.398841268064921],
            [34.55891365371263, 1.393906545359195],
            [34.56194890924238, 1.393578905462787],
            [34.56307885063095, 1.389924586213238],
            [34.56521821542952, 1.387442760875261],
            [34.56767932622016, 1.382263891872991],
            [34.569770543116164, 1.37892402535457],
            [34.5713589765409, 1.377932725840559],
            [34.56648430458422, 1.373736530815773],
            [34.56721573714306, 1.371805359735484],
            [34.56604466728754, 1.370781412849986],
            [34.55990533270085, 1.367931552766541],
            [34.55877336650964, 1.36851648294626],
            [34.55664108762202, 1.367263310361922],
            [34.55689585073492, 1.363920819406045],
            [34.555362221729034, 1.361379160598805],
            [34.55652013485893, 1.356743202601603],
            [34.5578826312099, 1.353870338155331],
            [34.5623360975029, 1.353847256999336],
            [34.56483991689708, 1.34797028965105],
            [34.564256630003335, 1.345580149547076],
            [34.5646367575057, 1.343974785884553],
            [34.563793196334764, 1.342380304861884],
            [34.56363059228519, 1.339049030637389],
            [34.56206469759092, 1.337204651976373],
            [34.56283204120159, 1.328113666330464],
            [34.57026290433349, 1.294804136584169],
            [34.57164352329704, 1.294817190262837],
            [34.57201061534632, 1.297222634984721],
            [34.57357808029569, 1.298171259596225],
            [34.57447511368389, 1.299319268454991],
            [34.574856235621276, 1.30260195575879],
            [34.57700579899329, 1.30398431189054],
            [34.578833352268546, 1.305927585963374],
            [34.579803128533534, 1.308432117945389],
            [34.5821832148788, 1.312011967067276],
            [34.58360306686405, 1.312191937757067],
            [34.585792417518306, 1.313420499720315],
            [34.587096587156196, 1.315391217145673],
            [34.58750428934454, 1.317127369438581],
            [34.58852258900791, 1.318184840713799],
            [34.58832130799377, 1.319595805466209],
            [34.5901008876396, 1.322009355813719],
            [34.589705993630574, 1.32451474548353],
            [34.59026067906403, 1.325111277536575],
            [34.59194168747202, 1.325300108585055],
            [34.59216829738393, 1.325743107378899],
            [34.59245849364487, 1.330753183312651],
            [34.595621190469046, 1.332948760665218],
            [34.5967481467559, 1.334395028280386],
            [34.59705268821363, 1.335498169878243],
            [34.60063213146443, 1.338597830365367],
            [34.608815924738266, 1.341296501788547],
            [34.609864400608636, 1.34209165387512],
            [34.61581897330095, 1.342775014126323],
            [34.61941148254755, 1.344382390249977],
            [34.621582366534504, 1.34397397223481],
            [34.62462042211301, 1.344505510880692],
            [34.62957301663234, 1.346799263394141],
            [34.63208353656024, 1.347050790427834],
            [34.63688642683751, 1.34926809894705],
            [34.63811113509862, 1.349483212736647],
            [34.64042549979941, 1.351419880797348],
            [34.64162688779577, 1.351454267721813],
            [34.64147593220049, 1.353115384600099],
            [34.63842823410572, 1.353414325203404],
            [34.638132797073396, 1.353778751739035],
            [34.6387683066279, 1.354185027122777],
            [34.638768726141116, 1.354807091998601],
            [34.635921759291556, 1.35671938146869],
            [34.63969831806851, 1.35680950303234],
            [34.6406411367901, 1.356334246029127],
            [34.64397161645145, 1.358928374071321],
            [34.644555316570255, 1.360658910503124],
            [34.644333895327456, 1.361384939625955],
            [34.6424762089643, 1.362642543613826],
            [34.638209566199286, 1.370350962737652],
            [34.635881246170555, 1.373004822521398],
            [34.63474586278802, 1.375853290860747],
            [34.634122801188404, 1.379654732297731],
            [34.632421969657024, 1.384984249977863],
            [34.63220187073432, 1.38763666195078],
            [34.6318969241364, 1.38791605933335],
            [34.60801230086822, 1.402217797877609],
            [34.604401216258196, 1.404442826810462],
            [34.59995620131542, 1.405351837191513],
            [34.59442705277536, 1.405881350550294],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1124,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "KWOSIR",
        Population: 11899,
        Key: "KWEENKWOSIR",
        Dist2: "Kween",
        "Sub Country": "kwosir",
        id2_original: "Kween  kwosir",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.7425574285298, 1.30767889994401],
            [34.741111165176854, 1.308396295287926],
            [34.73887799739798, 1.310383562005288],
            [34.73590766760541, 1.310973243295029],
            [34.73320699050154, 1.312045337017209],
            [34.72782815256637, 1.315620413069957],
            [34.73158501308578, 1.32036375012928],
            [34.73420461004873, 1.327262821935639],
            [34.737524475216674, 1.330091010652662],
            [34.737949222937544, 1.330903610535182],
            [34.73712501237615, 1.33219080557526],
            [34.73789463680928, 1.332700786753672],
            [34.737271381173585, 1.33349564077116],
            [34.73708001037369, 1.334997877674406],
            [34.73571345902749, 1.33724401980073],
            [34.73514476975711, 1.339732314504067],
            [34.73531249240715, 1.340815104349801],
            [34.73440055057849, 1.342334381218072],
            [34.733909530545894, 1.345205254803892],
            [34.734352273318514, 1.348186679707974],
            [34.73499304071237, 1.349083964832958],
            [34.734755867511026, 1.351668853255499],
            [34.73299177661732, 1.35005710925625],
            [34.72979726955062, 1.34869301948783],
            [34.728679780608545, 1.346656399770614],
            [34.72637512939094, 1.346541345688212],
            [34.725504380707946, 1.344981076438406],
            [34.724090392924886, 1.344267543514077],
            [34.724130968927945, 1.343134270278369],
            [34.721723088707776, 1.340495592818485],
            [34.71993936243858, 1.3391450540726],
            [34.71934901299006, 1.337827706367201],
            [34.71696567025188, 1.335719016369721],
            [34.71697001450461, 1.33501879735066],
            [34.71613969539929, 1.334142114221804],
            [34.715904918004846, 1.332745260191058],
            [34.71486005515854, 1.331167789454081],
            [34.71346317219677, 1.330667172165932],
            [34.711019330619166, 1.330498420645725],
            [34.70897401943081, 1.32933096576521],
            [34.706196972053064, 1.328413623014206],
            [34.70268227307974, 1.327947296328039],
            [34.70227724248107, 1.328300679448237],
            [34.70216031596707, 1.330724500657062],
            [34.7017609276867, 1.331384938968482],
            [34.689237565514745, 1.332820022012317],
            [34.67766695832977, 1.333924708101918],
            [34.672353272507266, 1.331611051229169],
            [34.67086287402613, 1.330709912359098],
            [34.6700092400459, 1.328261537795524],
            [34.6630397157113, 1.326962201435307],
            [34.65598380848065, 1.32999385080126],
            [34.65531770590086, 1.329348253680326],
            [34.65461969156888, 1.326766534370947],
            [34.65244189414749, 1.324989846112183],
            [34.64718186469688, 1.323104019719135],
            [34.64513734222937, 1.322872452665912],
            [34.64313352242735, 1.323762731270284],
            [34.641325303591955, 1.323199651316176],
            [34.63539603733951, 1.319748767739651],
            [34.63354113844868, 1.317792256857737],
            [34.62948918764667, 1.315572318272825],
            [34.628778636426595, 1.314492463967836],
            [34.62693403761882, 1.3132321311791],
            [34.6255632938352, 1.311144112915959],
            [34.62460004113583, 1.310527400347462],
            [34.6232219024208, 1.308023033009739],
            [34.62120943543589, 1.306201024062595],
            [34.620397371893745, 1.304074343776187],
            [34.618777231532746, 1.303697643893398],
            [34.61728135781997, 1.301575875805007],
            [34.61457126996516, 1.301840836469531],
            [34.61249039447471, 1.300849159999093],
            [34.60962894139289, 1.300659050926527],
            [34.60719873174971, 1.299920099358903],
            [34.606365110437395, 1.299198906295081],
            [34.605369683677814, 1.297581548364094],
            [34.60548045134222, 1.295869486281301],
            [34.60487824952185, 1.293587741792468],
            [34.60478458578043, 1.291247460624969],
            [34.60426133239878, 1.289917819771491],
            [34.603005801143624, 1.288794840861573],
            [34.602364595371924, 1.287217835504314],
            [34.60234880119259, 1.286532238174548],
            [34.603179909018735, 1.28510561827785],
            [34.60279713687618, 1.282727607736645],
            [34.60218206040115, 1.2819753744851],
            [34.60068178135017, 1.281945770729968],
            [34.59498684423285, 1.280240513747993],
            [34.59488733245895, 1.278858699722536],
            [34.595420585886316, 1.277021380728967],
            [34.594727392812494, 1.272809988706995],
            [34.58738011252787, 1.262280462414921],
            [34.58321299770643, 1.257544659983025],
            [34.578297496421776, 1.254215891033022],
            [34.576041156600176, 1.247177765055666],
            [34.576092115331285, 1.244222420696708],
            [34.57508137948261, 1.241722573620771],
            [34.57489922719413, 1.240029665274939],
            [34.571661577637606, 1.235160918252516],
            [34.5705473145457, 1.232609028082662],
            [34.56407346800848, 1.223772839945798],
            [34.56378730428481, 1.222265495956587],
            [34.565384179178274, 1.208625165198486],
            [34.56673747947569, 1.205465783692359],
            [34.567128577204315, 1.203419649974387],
            [34.566735323519026, 1.201697007758968],
            [34.565557555824746, 1.200010711303568],
            [34.56345077561646, 1.195094562882265],
            [34.56291290125526, 1.18985446669607],
            [34.56301705372593, 1.184829361383512],
            [34.562301205140606, 1.180127760487092],
            [34.56009162891774, 1.175173025524179],
            [34.55926148049233, 1.172164261160913],
            [34.55835683747536, 1.171158474259919],
            [34.55615269965318, 1.164159682079431],
            [34.55509067898498, 1.157860027851068],
            [34.554638697937975, 1.157175725834321],
            [34.5552174402547, 1.153927135339121],
            [34.55681131297847, 1.153285778415657],
            [34.55607165903817, 1.151998346238828],
            [34.55443986932455, 1.150463420936949],
            [34.554016619993604, 1.147774850458047],
            [34.55723005366501, 1.142900963813571],
            [34.55938763989083, 1.134848870789182],
            [34.55961700852895, 1.132427491306633],
            [34.55925914038103, 1.130058730061197],
            [34.55982865071158, 1.12887162510144],
            [34.55968348745325, 1.127399853758722],
            [34.56124739597241, 1.126064354933821],
            [34.563330289977294, 1.119786147512851],
            [34.564720468812055, 1.118744497298525],
            [34.56632332738362, 1.115297891751261],
            [34.56806964241451, 1.113394618384688],
            [34.57064014195559, 1.105720221236269],
            [34.57200620821153, 1.10381648275381],
            [34.57318755659054, 1.103457759492973],
            [34.575191139237305, 1.099430983447809],
            [34.58010101527163, 1.14732385280846],
            [34.578040201856425, 1.152582039687731],
            [34.57624666149277, 1.155532036775859],
            [34.57667057827198, 1.156486386926561],
            [34.575704156316256, 1.166915835603156],
            [34.57520647707244, 1.184135592544689],
            [34.57382162075572, 1.192400461490183],
            [34.57397530273789, 1.194370968259539],
            [34.57341676083696, 1.195842840336334],
            [34.57417136454023, 1.197402740770835],
            [34.574310965430335, 1.200709085283041],
            [34.57675770137981, 1.206138436920589],
            [34.57787043913235, 1.211872204379923],
            [34.57780717438016, 1.213924353581398],
            [34.57715195938159, 1.214791325919167],
            [34.57606486583547, 1.219481131615817],
            [34.581105529388644, 1.230740239228839],
            [34.58110314525988, 1.232214097890608],
            [34.58007267522103, 1.236058256774491],
            [34.58050822967475, 1.237986624911333],
            [34.58001247372395, 1.239795915500764],
            [34.580775008652886, 1.2410954695029],
            [34.58169774284137, 1.246637941648415],
            [34.58320102496032, 1.248332056395268],
            [34.587092427956435, 1.25014212842325],
            [34.5961899174687, 1.250938071620322],
            [34.598228472427785, 1.252494684386918],
            [34.601713351825225, 1.25365760413195],
            [34.60308237803003, 1.254928721040451],
            [34.60843834575636, 1.255802233436102],
            [34.61193269339691, 1.252792516999822],
            [34.62117080698033, 1.253184042110536],
            [34.62404889416631, 1.255823120536561],
            [34.62602354207775, 1.261830594666998],
            [34.62960755146512, 1.265198986878106],
            [34.63879084715501, 1.271275021390338],
            [34.647584335096994, 1.275617615587151],
            [34.650431944242015, 1.278038824653636],
            [34.65352436855645, 1.278728592301898],
            [34.656782285902416, 1.278489625391395],
            [34.65831436531442, 1.277492682391496],
            [34.66660548031526, 1.278006166442789],
            [34.66795665609704, 1.277066107514705],
            [34.66858913653236, 1.280764467192641],
            [34.672736646521045, 1.291532472164403],
            [34.67514405602403, 1.293999727193009],
            [34.67962608784473, 1.29622797775242],
            [34.68124280203123, 1.296418315271946],
            [34.68214508158068, 1.294742794621477],
            [34.68376128642242, 1.294167456459604],
            [34.68780267932491, 1.294069037892281],
            [34.68951457360904, 1.294402869971373],
            [34.69260594958952, 1.295692860691464],
            [34.69365257493044, 1.296601389063475],
            [34.69650063323308, 1.30106963147077],
            [34.6976016740223, 1.300714192375094],
            [34.69874195322314, 1.299469207218132],
            [34.700120409941775, 1.298894021008851],
            [34.701499314919765, 1.298988792267735],
            [34.704018332910266, 1.297599309789594],
            [34.70497881790024, 1.297952158348928],
            [34.70514236428254, 1.298404600854487],
            [34.71097079015277, 1.298905581151987],
            [34.71287086711587, 1.298585516405051],
            [34.716080450607976, 1.297320409502537],
            [34.7206076515178, 1.298279814685849],
            [34.72317044800535, 1.298337933337009],
            [34.72695113813426, 1.297223155874036],
            [34.72819784164514, 1.297301128515221],
            [34.73006540408652, 1.29650137559118],
            [34.73198912830117, 1.296284536476388],
            [34.7343186359027, 1.296479403035937],
            [34.735082331454954, 1.29691465286257],
            [34.73842432302668, 1.299865626965672],
            [34.73939703049443, 1.300245255174847],
            [34.74022824162684, 1.301352218875079],
            [34.74278712325636, 1.302703408616697],
            [34.743528099516794, 1.303562713243311],
            [34.743830112217, 1.304979160949662],
            [34.742602709009994, 1.306825820429632],
            [34.7425574285298, 1.30767889994401],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1125,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "KABEI",
        Population: 6322,
        Key: "BUKWOKABEI",
        Dist2: "BUKWO",
        "Sub Country": "Kabei",
        id2_original: "BUKWO Kabei",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.66359842829215, 1.353268937508629],
            [34.662202499341234, 1.352067473885033],
            [34.66043765655762, 1.352421388771645],
            [34.658314459637516, 1.351871199038963],
            [34.65123844721253, 1.353639551731156],
            [34.64936067990948, 1.354483069529898],
            [34.64556637221917, 1.352883782661189],
            [34.64440430617773, 1.351871698363262],
            [34.64162688779577, 1.351454267721813],
            [34.64042549979941, 1.351419880797348],
            [34.63811113509862, 1.349483212736647],
            [34.63688642683751, 1.34926809894705],
            [34.63208353656024, 1.347050790427834],
            [34.62957301663234, 1.346799263394141],
            [34.62462042211301, 1.344505510880692],
            [34.621582366534504, 1.34397397223481],
            [34.61941148254755, 1.344382390249977],
            [34.61581897330095, 1.342775014126323],
            [34.609864400608636, 1.34209165387512],
            [34.608815924738266, 1.341296501788547],
            [34.60063213146443, 1.338597830365367],
            [34.59705268821363, 1.335498169878243],
            [34.5967481467559, 1.334395028280386],
            [34.595621190469046, 1.332948760665218],
            [34.59245849364487, 1.330753183312651],
            [34.59216829738393, 1.325743107378899],
            [34.59194168747202, 1.325300108585055],
            [34.59026067906403, 1.325111277536575],
            [34.589705993630574, 1.32451474548353],
            [34.5901008876396, 1.322009355813719],
            [34.58832130799377, 1.319595805466209],
            [34.58852258900791, 1.318184840713799],
            [34.58750428934454, 1.317127369438581],
            [34.587096587156196, 1.315391217145673],
            [34.585792417518306, 1.313420499720315],
            [34.58360306686405, 1.312191937757067],
            [34.5821832148788, 1.312011967067276],
            [34.579803128533534, 1.308432117945389],
            [34.578833352268546, 1.305927585963374],
            [34.57700579899329, 1.30398431189054],
            [34.574856235621276, 1.30260195575879],
            [34.57447511368389, 1.299319268454991],
            [34.57357808029569, 1.298171259596225],
            [34.57201061534632, 1.297222634984721],
            [34.57164352329704, 1.294817190262837],
            [34.57026290433349, 1.294804136584169],
            [34.56931680226954, 1.294827687988987],
            [34.56794601087521, 1.293146377221614],
            [34.56840515957985, 1.290921290611741],
            [34.567956884981704, 1.288904778509807],
            [34.56740331166262, 1.288263004747056],
            [34.5675050494618, 1.286571730732528],
            [34.56612907478827, 1.285577751879793],
            [34.56658000480641, 1.283678251271649],
            [34.56537573950618, 1.281526542974686],
            [34.56529095471303, 1.280631247085609],
            [34.5667592429601, 1.272725963064994],
            [34.56461463289856, 1.269245366384824],
            [34.56432080834217, 1.265329526965251],
            [34.56633120021879, 1.260426500661523],
            [34.56745213958989, 1.253645727654131],
            [34.56629852669526, 1.251789580977099],
            [34.56338754320361, 1.250461875874466],
            [34.560269343528724, 1.246883110191045],
            [34.558097665431035, 1.241047816973462],
            [34.55681906813431, 1.239822751775689],
            [34.553896823362244, 1.236337380997858],
            [34.55340230079836, 1.231748084212168],
            [34.552448596292116, 1.22903482760201],
            [34.55251679369356, 1.227253099852601],
            [34.554546795792824, 1.223259348876064],
            [34.55466806206796, 1.220404954422659],
            [34.55434595854644, 1.219037784067919],
            [34.554873354958175, 1.217165927676222],
            [34.55477658574081, 1.211831209051917],
            [34.55555258012763, 1.209674990977973],
            [34.55649894629633, 1.208305251974127],
            [34.55757285347239, 1.207605079218731],
            [34.55894973724097, 1.202929542914116],
            [34.55886673201041, 1.201147931765546],
            [34.55827276504624, 1.200497108761655],
            [34.55881961896699, 1.199275860960973],
            [34.55834445869072, 1.198181815887521],
            [34.55807222873546, 1.191471358105604],
            [34.557621190919505, 1.190323032853815],
            [34.558429371942964, 1.188432385999264],
            [34.55775258749612, 1.186298396892992],
            [34.55758673064688, 1.183956106161221],
            [34.55835683747536, 1.171158474259919],
            [34.55926148049233, 1.172164261160913],
            [34.56009162891774, 1.175173025524179],
            [34.562301205140606, 1.180127760487092],
            [34.56301705372593, 1.184829361383512],
            [34.56291290125526, 1.18985446669607],
            [34.56345077561646, 1.195094562882265],
            [34.565557555824746, 1.200010711303568],
            [34.566735323519026, 1.201697007758968],
            [34.567128577204315, 1.203419649974387],
            [34.56673747947569, 1.205465783692359],
            [34.565384179178274, 1.208625165198486],
            [34.56378730428481, 1.222265495956587],
            [34.56407346800848, 1.223772839945798],
            [34.5705473145457, 1.232609028082662],
            [34.571661577637606, 1.235160918252516],
            [34.57489922719413, 1.240029665274939],
            [34.57508137948261, 1.241722573620771],
            [34.576092115331285, 1.244222420696708],
            [34.576041156600176, 1.247177765055666],
            [34.578297496421776, 1.254215891033022],
            [34.58321299770643, 1.257544659983025],
            [34.58738011252787, 1.262280462414921],
            [34.594727392812494, 1.272809988706995],
            [34.595420585886316, 1.277021380728967],
            [34.59488733245895, 1.278858699722536],
            [34.59498684423285, 1.280240513747993],
            [34.60068178135017, 1.281945770729968],
            [34.60218206040115, 1.2819753744851],
            [34.60279713687618, 1.282727607736645],
            [34.603179909018735, 1.28510561827785],
            [34.60234880119259, 1.286532238174548],
            [34.602364595371924, 1.287217835504314],
            [34.603005801143624, 1.288794840861573],
            [34.60426133239878, 1.289917819771491],
            [34.60478458578043, 1.291247460624969],
            [34.60487824952185, 1.293587741792468],
            [34.60548045134222, 1.295869486281301],
            [34.605369683677814, 1.297581548364094],
            [34.606365110437395, 1.299198906295081],
            [34.60719873174971, 1.299920099358903],
            [34.60962894139289, 1.300659050926527],
            [34.61249039447471, 1.300849159999093],
            [34.61457126996516, 1.301840836469531],
            [34.61728135781997, 1.301575875805007],
            [34.618777231532746, 1.303697643893398],
            [34.620397371893745, 1.304074343776187],
            [34.62120943543589, 1.306201024062595],
            [34.6232219024208, 1.308023033009739],
            [34.62460004113583, 1.310527400347462],
            [34.6255632938352, 1.311144112915959],
            [34.62693403761882, 1.3132321311791],
            [34.628778636426595, 1.314492463967836],
            [34.62948918764667, 1.315572318272825],
            [34.63354113844868, 1.317792256857737],
            [34.63539603733951, 1.319748767739651],
            [34.641325303591955, 1.323199651316176],
            [34.64313352242735, 1.323762731270284],
            [34.64513734222937, 1.322872452665912],
            [34.64718186469688, 1.323104019719135],
            [34.65244189414749, 1.324989846112183],
            [34.65461969156888, 1.326766534370947],
            [34.65531770590086, 1.329348253680326],
            [34.65598380848065, 1.32999385080126],
            [34.6630397157113, 1.326962201435307],
            [34.6700092400459, 1.328261537795524],
            [34.67086287402613, 1.330709912359098],
            [34.672353272507266, 1.331611051229169],
            [34.67236970898202, 1.335788270230185],
            [34.673205312876135, 1.339443877843711],
            [34.67264381551792, 1.341536749641757],
            [34.67055150806718, 1.344121696360021],
            [34.66881061886063, 1.344734779538595],
            [34.66799313757903, 1.345664498745878],
            [34.66736360541445, 1.347047336462024],
            [34.666833218511115, 1.350734112561863],
            [34.66359842829215, 1.353268937508629],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1126,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "CHESOWER",
        Population: 6555,
        Key: "BUKWOCHESOWER",
        Dist2: "BUKWO",
        "Sub Country": "Chesower",
        id2_original: "BUKWO Chesower",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.71668366662633, 1.280244089048424],
            [34.71579600805641, 1.280497898544681],
            [34.71400430474751, 1.280010773068429],
            [34.71315320311811, 1.280372009540607],
            [34.71180773433332, 1.279551047366706],
            [34.71088228094445, 1.279551670642068],
            [34.70879169646245, 1.280565921748602],
            [34.70829583990034, 1.281416323008436],
            [34.70712135644671, 1.281878319646328],
            [34.70654567289354, 1.282602168785353],
            [34.70412484525518, 1.283562385106998],
            [34.700665504062925, 1.284261042355482],
            [34.69976636053212, 1.284144083242114],
            [34.69884355717335, 1.283068547888682],
            [34.69497891858283, 1.281461420628975],
            [34.69291550454486, 1.281987311005],
            [34.69109501472268, 1.283010423500024],
            [34.689659854546655, 1.282861006454532],
            [34.68836802237086, 1.283844229943017],
            [34.686562100527645, 1.28357274906414],
            [34.68431805864226, 1.283964488651775],
            [34.68209344551985, 1.282754151689556],
            [34.6773301817264, 1.28101192623753],
            [34.6759629296943, 1.279873298664379],
            [34.67448291483951, 1.280000940766817],
            [34.673810910328285, 1.279562087602852],
            [34.67141239145172, 1.279378964090264],
            [34.66909006857584, 1.277309538973312],
            [34.66795665609704, 1.277066107514705],
            [34.66660548031526, 1.278006166442789],
            [34.65831436531442, 1.277492682391496],
            [34.656782285902416, 1.278489625391395],
            [34.65352436855645, 1.278728592301898],
            [34.650431944242015, 1.278038824653636],
            [34.647584335096994, 1.275617615587151],
            [34.63879084715501, 1.271275021390338],
            [34.62960755146512, 1.265198986878106],
            [34.62602354207775, 1.261830594666998],
            [34.62404889416631, 1.255823120536561],
            [34.62117080698033, 1.253184042110536],
            [34.61193269339691, 1.252792516999822],
            [34.60843834575636, 1.255802233436102],
            [34.60308237803003, 1.254928721040451],
            [34.601713351825225, 1.25365760413195],
            [34.598228472427785, 1.252494684386918],
            [34.5961899174687, 1.250938071620322],
            [34.587092427956435, 1.25014212842325],
            [34.58320102496032, 1.248332056395268],
            [34.58169774284137, 1.246637941648415],
            [34.580775008652886, 1.2410954695029],
            [34.58001247372395, 1.239795915500764],
            [34.58050822967475, 1.237986624911333],
            [34.58007267522103, 1.236058256774491],
            [34.58110314525988, 1.232214097890608],
            [34.581105529388644, 1.230740239228839],
            [34.57606486583547, 1.219481131615817],
            [34.57715195938159, 1.214791325919167],
            [34.57780717438016, 1.213924353581398],
            [34.57787043913235, 1.211872204379923],
            [34.57675770137981, 1.206138436920589],
            [34.574310965430335, 1.200709085283041],
            [34.57417136454023, 1.197402740770835],
            [34.57341676083696, 1.195842840336334],
            [34.57397530273789, 1.194370968259539],
            [34.57382162075572, 1.192400461490183],
            [34.57520647707244, 1.184135592544689],
            [34.575704156316256, 1.166915835603156],
            [34.57667057827198, 1.156486386926561],
            [34.57624666149277, 1.155532036775859],
            [34.578040201856425, 1.152582039687731],
            [34.58010101527163, 1.14732385280846],
            [34.58256172810859, 1.148250283592643],
            [34.58210749947674, 1.149963500537607],
            [34.582216459730816, 1.152052263899615],
            [34.58455270200205, 1.155856806893936],
            [34.584945599056155, 1.157005156177267],
            [34.5848038197515, 1.158548627262528],
            [34.58558897785254, 1.159696752718947],
            [34.588263729577314, 1.160161846371552],
            [34.58951305077893, 1.16235059468652],
            [34.59556688551351, 1.168640322653383],
            [34.596201832722635, 1.170047546749755],
            [34.595675179217636, 1.1713913623359],
            [34.59619736629903, 1.172678860216026],
            [34.59618189461489, 1.173834099359377],
            [34.597378794628085, 1.17519696059093],
            [34.59833049768787, 1.175512949257365],
            [34.59946839365824, 1.177103099251745],
            [34.599759576269406, 1.178655861183123],
            [34.599153597931554, 1.17921386901748],
            [34.599042577840535, 1.179916738886499],
            [34.60012773192396, 1.181030128719773],
            [34.601682531526144, 1.185044181671566],
            [34.60334925672115, 1.185468437052098],
            [34.61074202679344, 1.192834806125404],
            [34.6115525164872, 1.19425912805399],
            [34.612591457639134, 1.197925051774981],
            [34.61393766663571, 1.199926744429402],
            [34.61749734425529, 1.201532255244832],
            [34.62029991277028, 1.201836763852428],
            [34.624134051760294, 1.206052933558109],
            [34.629184611154656, 1.209822068095598],
            [34.62988205056483, 1.212685828501323],
            [34.63039707537846, 1.213332998653608],
            [34.631101728260354, 1.21348673239225],
            [34.632413538968066, 1.214676068332025],
            [34.63400640018884, 1.214582599870507],
            [34.63926394939096, 1.216114839361561],
            [34.64015304796027, 1.217341423361528],
            [34.64220596787907, 1.218184969139934],
            [34.64617542279527, 1.217245223832029],
            [34.64909168119431, 1.217261925133249],
            [34.65208032134731, 1.215422481311508],
            [34.6545686636675, 1.215457417015561],
            [34.656057563758736, 1.214554097341866],
            [34.65822755392198, 1.216008236047587],
            [34.66049817336338, 1.216487135889945],
            [34.66194576622293, 1.218975105731039],
            [34.66327675596194, 1.219964000494532],
            [34.66936073815748, 1.220291372053575],
            [34.677571412617866, 1.221952178278842],
            [34.68621741066493, 1.224919313532427],
            [34.688190864715374, 1.224743431256384],
            [34.69037818338046, 1.225124876534146],
            [34.693992698656565, 1.226845333089179],
            [34.69613198530171, 1.226461129962259],
            [34.698650933223604, 1.224976033668966],
            [34.700255760003984, 1.225084816340281],
            [34.70623908237863, 1.229234717833844],
            [34.70857151399641, 1.23159838761547],
            [34.7090179290819, 1.233079945276055],
            [34.709244188650835, 1.234971757247011],
            [34.710523593532976, 1.238239324871572],
            [34.71126405056715, 1.243368499278327],
            [34.712085114330115, 1.245376328943447],
            [34.709529504364845, 1.259990836014307],
            [34.70970233753057, 1.262855327240977],
            [34.7108891602429, 1.264808257489032],
            [34.71105703111499, 1.266356895865951],
            [34.7125051503873, 1.269472090426424],
            [34.71546000939406, 1.273777827215693],
            [34.716778639213096, 1.27901835524415],
            [34.71668366662633, 1.280244089048424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1127,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "CHEPKWASTA",
        Population: 8408,
        Key: "BUKWOCHEPKWASTA",
        Dist2: "BUKWO",
        "Sub Country": "Chepkwaster",
        id2_original: "BUKWO Chepkwaster",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.66941242003239, 1.43391106990785],
            [34.66838931528057, 1.433867873574942],
            [34.665668459320464, 1.432520034606213],
            [34.66346703980037, 1.433469673591397],
            [34.661176371758486, 1.431776203264044],
            [34.65982893656155, 1.431821135537643],
            [34.65748893304424, 1.430918762154063],
            [34.656097877453746, 1.431032785674647],
            [34.65539086110432, 1.428013247501738],
            [34.65454819824868, 1.427430141688432],
            [34.65383390554547, 1.425663816332996],
            [34.651364615594154, 1.424786757108186],
            [34.65029363512927, 1.422854646472502],
            [34.648444966054946, 1.420900753179144],
            [34.64530617968871, 1.419591048150018],
            [34.644343837880996, 1.417521626390449],
            [34.64191788086238, 1.414685064450416],
            [34.64151847551403, 1.413369969450525],
            [34.63959614638304, 1.412154780032775],
            [34.63855837843084, 1.410475781298206],
            [34.636984880396, 1.411055952990148],
            [34.63377961959706, 1.410503097075033],
            [34.62831125196743, 1.410358609121795],
            [34.62228417714685, 1.413669712495661],
            [34.62078177986845, 1.41395312191864],
            [34.61779032349701, 1.41318952676617],
            [34.61178447227332, 1.412882671165084],
            [34.61033294299622, 1.41109385758356],
            [34.6107025161923, 1.409174556894608],
            [34.609618740124525, 1.40724206235265],
            [34.60916589310158, 1.403147669832515],
            [34.60801230086822, 1.402217797877609],
            [34.6318969241364, 1.38791605933335],
            [34.63220187073432, 1.38763666195078],
            [34.632421969657024, 1.384984249977863],
            [34.634122801188404, 1.379654732297731],
            [34.634720965081605, 1.380304816164353],
            [34.637051905496, 1.381195876567193],
            [34.637648337437305, 1.382131467538474],
            [34.6376498349289, 1.384310603377136],
            [34.63974279814979, 1.38493802180897],
            [34.64141518632434, 1.386779610509573],
            [34.6430286009988, 1.387392733096647],
            [34.6444105862999, 1.389556269436808],
            [34.64692610086078, 1.391821378669199],
            [34.64814805488723, 1.39370714334737],
            [34.64851272867176, 1.395695885770683],
            [34.64832574973527, 1.398460142930949],
            [34.64864585181036, 1.399044915609729],
            [34.65012861550991, 1.399833614013725],
            [34.65076881966007, 1.401003157642411],
            [34.652007430248524, 1.405887018111487],
            [34.65357901936337, 1.408986388015004],
            [34.65482958652829, 1.410199362717589],
            [34.656341390964336, 1.410944151139629],
            [34.657009569550745, 1.410563422220734],
            [34.65775109019025, 1.411147886535603],
            [34.65812989447419, 1.412536982378511],
            [34.65943863384196, 1.413808407873358],
            [34.66015047863602, 1.413530021181159],
            [34.66185135957477, 1.414508662157165],
            [34.662840898776, 1.416467683273611],
            [34.662739878730704, 1.417447624270277],
            [34.66352480865965, 1.417768802111735],
            [34.66414913868045, 1.417037105718751],
            [34.66513745617289, 1.417285012496692],
            [34.66983443777307, 1.421903050766363],
            [34.66967502364109, 1.422502786058683],
            [34.66704545807341, 1.423382194522283],
            [34.666377461844974, 1.424011550310678],
            [34.66366048031872, 1.424583900295363],
            [34.66444591869412, 1.425607069361207],
            [34.66784385734174, 1.428279696649532],
            [34.669549906288324, 1.430668870388534],
            [34.669949491299725, 1.431635694936114],
            [34.66941242003239, 1.43391106990785],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1128,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "MOYOK",
        Population: 5774,
        Key: "KWEENMOYOK",
        Dist2: "Kween",
        "Sub Country": "moyok",
        id2_original: "Kween  moyok",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.73738666916054, 1.427775608228445],
            [34.73636303709764, 1.430268618736315],
            [34.73421601505957, 1.433189663831052],
            [34.73464058940557, 1.433766259229797],
            [34.734577734285125, 1.434750399253138],
            [34.73321005555327, 1.434315403385604],
            [34.73319371789319, 1.435104194849194],
            [34.73120787158339, 1.435837076288931],
            [34.73061247539961, 1.436941635335165],
            [34.729117551206066, 1.436446730308899],
            [34.72855999206206, 1.437613538879821],
            [34.72594008068872, 1.439721477082108],
            [34.72542661175716, 1.439669195472207],
            [34.72539871457603, 1.43863377993413],
            [34.724150670778755, 1.438726739727618],
            [34.72382777853638, 1.437494864776472],
            [34.723160970779105, 1.43759687588626],
            [34.72287809758433, 1.437051002255911],
            [34.72233057801192, 1.437105445490564],
            [34.722179302616404, 1.435819718204668],
            [34.72345555710684, 1.43397102534971],
            [34.72355974191687, 1.429724426277333],
            [34.72219572202316, 1.429066328617496],
            [34.723052701329465, 1.426472384645069],
            [34.72292130565119, 1.423036368107824],
            [34.7241334590579, 1.421609142447155],
            [34.72243668162339, 1.421037732869276],
            [34.72255383630949, 1.419762607827194],
            [34.7218341689859, 1.419320126658406],
            [34.72208028132262, 1.418206985557301],
            [34.72336801538409, 1.417352392471877],
            [34.72295215379805, 1.414669069433673],
            [34.720869412506765, 1.414119639509251],
            [34.71984187097575, 1.412713418049152],
            [34.71908912319185, 1.412743497075589],
            [34.718364277080674, 1.41083525355466],
            [34.71483221636788, 1.40696127260604],
            [34.71409878236258, 1.406666642162751],
            [34.71399060364279, 1.405791041360334],
            [34.71217009405767, 1.402870168238266],
            [34.7108500808331, 1.402566128449654],
            [34.711299092948096, 1.401611401928643],
            [34.71052477032601, 1.398857015329032],
            [34.709087273631944, 1.398316918684439],
            [34.70746310253027, 1.39649786833448],
            [34.70805884726039, 1.395661103443346],
            [34.70896782105533, 1.395365263702987],
            [34.707803193917066, 1.393624587448454],
            [34.70489914092778, 1.392908450287125],
            [34.70395037266405, 1.392249917433721],
            [34.70363644470992, 1.390734914530475],
            [34.70320628374118, 1.39072538800899],
            [34.70289386136348, 1.391306126771325],
            [34.70273710265145, 1.390833960536252],
            [34.70212128506628, 1.390952478968722],
            [34.70103569350331, 1.390353078623609],
            [34.70041991813897, 1.390530631344616],
            [34.69958776108059, 1.388888090576232],
            [34.699148020477665, 1.389154068230891],
            [34.69789616243368, 1.388456392754222],
            [34.696584454133905, 1.386086093213323],
            [34.69675992744827, 1.385387383173295],
            [34.69516501537369, 1.383440370002381],
            [34.69454438910683, 1.382047896434503],
            [34.69262064872253, 1.381986487503894],
            [34.69097721774116, 1.381296955268716],
            [34.68940609305532, 1.379927116812865],
            [34.686774935672986, 1.379405731306526],
            [34.681932182654975, 1.376005062370224],
            [34.68142304090812, 1.374933324506156],
            [34.68023317919519, 1.375290956678605],
            [34.678495515838826, 1.374158248511273],
            [34.67557896369073, 1.3690417396673],
            [34.674163950929916, 1.36447580652912],
            [34.67289113968193, 1.363310097592027],
            [34.66955455866316, 1.361449483320598],
            [34.66725947899492, 1.359217351749045],
            [34.66497618791813, 1.356153204484441],
            [34.66359842829215, 1.353268937508629],
            [34.666833218511115, 1.350734112561863],
            [34.66736360541445, 1.347047336462024],
            [34.66799313757903, 1.345664498745878],
            [34.66881061886063, 1.344734779538595],
            [34.67055150806718, 1.344121696360021],
            [34.67264381551792, 1.341536749641757],
            [34.673205312876135, 1.339443877843711],
            [34.67236970898202, 1.335788270230185],
            [34.672353272507266, 1.331611051229169],
            [34.67766695832977, 1.333924708101918],
            [34.689237565514745, 1.332820022012317],
            [34.6891030625639, 1.3389177929753],
            [34.689677125556315, 1.344577470371403],
            [34.68796547920722, 1.348160898909731],
            [34.68774473978572, 1.35036077496027],
            [34.689567328072414, 1.353727570142238],
            [34.692093274768695, 1.3555186793178],
            [34.695330035891395, 1.35970408991241],
            [34.69567695716928, 1.360985089288617],
            [34.69820337098949, 1.363425396946641],
            [34.6987981617088, 1.364839500374329],
            [34.69851837422702, 1.367905223464676],
            [34.698997496073694, 1.368850765647921],
            [34.699114179144274, 1.370661263436024],
            [34.6999672678471, 1.370803711635069],
            [34.702441519193705, 1.372680327430238],
            [34.70358476103838, 1.372820384880193],
            [34.70563412991686, 1.374510702604335],
            [34.707408745472435, 1.374932007057038],
            [34.70889836511422, 1.374562876111782],
            [34.71056359371597, 1.373539297712526],
            [34.713868482171506, 1.373632331044994],
            [34.7160757092999, 1.372935520331269],
            [34.71709014980081, 1.370999094066127],
            [34.716871845712035, 1.368763663809057],
            [34.71948688462325, 1.370152199063697],
            [34.720193742869185, 1.373723168624233],
            [34.72177956938295, 1.375316913205773],
            [34.722430459891726, 1.376379702666588],
            [34.72259385445875, 1.377579164052495],
            [34.72301377642991, 1.377647015747954],
            [34.723229819459114, 1.378244320549777],
            [34.72340195732879, 1.379886538208103],
            [34.722718684350646, 1.38063782377436],
            [34.72276572642711, 1.381216519242872],
            [34.72631162568689, 1.384670659780865],
            [34.72617327525165, 1.386766701009621],
            [34.726841471804406, 1.389003709298668],
            [34.728412076365686, 1.391120069570263],
            [34.72812797158066, 1.392735335907773],
            [34.72873669427168, 1.396144448517859],
            [34.727810833047705, 1.39793964249868],
            [34.72795526507739, 1.400380065787597],
            [34.72856234025821, 1.401528099132869],
            [34.730596344352065, 1.40335697828392],
            [34.73409419003231, 1.407553499621022],
            [34.73637713525771, 1.408449036336085],
            [34.73890992531982, 1.410222676817148],
            [34.73875721890806, 1.411390589784936],
            [34.73774259604914, 1.412292964514817],
            [34.737922142324976, 1.412799447799618],
            [34.737538347899616, 1.412988646425067],
            [34.73791407814866, 1.413426286560595],
            [34.73757333278838, 1.414139245555401],
            [34.73795714697667, 1.413975806453298],
            [34.73867426847471, 1.41456775059568],
            [34.73785556458603, 1.415049228321504],
            [34.73827388935258, 1.416895676000463],
            [34.73762099470238, 1.418094306666099],
            [34.73841247065484, 1.419527542382882],
            [34.73756378998511, 1.419891555519894],
            [34.73769100580237, 1.420372676515151],
            [34.736853222595364, 1.422258904848985],
            [34.736980350377735, 1.422622177571897],
            [34.73743887026168, 1.422474517604552],
            [34.73769330998109, 1.423446582056793],
            [34.73727396203341, 1.423780807555637],
            [34.73744032104089, 1.42440921221327],
            [34.7368160314443, 1.424714130116357],
            [34.737128607433895, 1.425136187084121],
            [34.73681666565488, 1.425558719036256],
            [34.73735378902452, 1.426127915628481],
            [34.73661263849092, 1.426747190203711],
            [34.73634984084611, 1.4276410823744],
            [34.73738666916054, 1.427775608228445],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1129,
        District: "BUKWO",
        County: "KONGASIS",
        Subcounty: "TULEL",
        Population: 5198,
        Key: "BUKWOTULEL",
        Dist2: "BUKWO",
        "Sub Country": "Tulel",
        id2_original: "BUKWO Tulel",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.62291050585873, 0.496670861995816],
            [33.62202668040012, 0.499113585464839],
            [33.62209756376426, 0.500316804277366],
            [33.62065982811833, 0.501583496293524],
            [33.62087290401212, 0.503754709943999],
            [33.61998041699757, 0.509571897708729],
            [33.62014676971683, 0.510621311152595],
            [33.61957614278038, 0.51085658405245],
            [33.619171904495786, 0.512512190352306],
            [33.61914784581585, 0.513471155582218],
            [33.61989283664728, 0.514576443141863],
            [33.6182784284361, 0.519641169298065],
            [33.6190222712206, 0.52184401778236],
            [33.618516702971945, 0.522682022194371],
            [33.6186879802556, 0.524036828140107],
            [33.618052114968236, 0.525738746181216],
            [33.61820515106173, 0.528389447442694],
            [33.62116252984288, 0.531546836694291],
            [33.62238880207094, 0.532164004805961],
            [33.62276692902517, 0.533346636955019],
            [33.62385950049789, 0.534658312538338],
            [33.6253569552456, 0.535210013078494],
            [33.626437715668985, 0.536358845213152],
            [33.62795784569109, 0.5389460724546],
            [33.63080789286377, 0.545884664972098],
            [33.62849143239342, 0.544419329342592],
            [33.627540533325835, 0.544419429051102],
            [33.626281216570085, 0.543822473362453],
            [33.62041136938209, 0.545017265888068],
            [33.618426971156545, 0.544709879890658],
            [33.617632864936944, 0.542789836302557],
            [33.61681141759339, 0.542746887979354],
            [33.61502631241025, 0.541594782836694],
            [33.61186428572927, 0.541523945756136],
            [33.609728765720085, 0.541975986545507],
            [33.60879406597203, 0.541811161147829],
            [33.60675958487274, 0.540350505443565],
            [33.60510855324576, 0.537410450458527],
            [33.60365933084228, 0.536189271376772],
            [33.60342163751642, 0.535085581178146],
            [33.60257799100556, 0.53485949405977],
            [33.600808424880206, 0.531638992689277],
            [33.597778374189204, 0.533122973322428],
            [33.59706462137344, 0.534434836693186],
            [33.59625686255819, 0.533602606189395],
            [33.5935238595788, 0.534362809313487],
            [33.591896110487355, 0.534001094131041],
            [33.59180115496857, 0.533648275455974],
            [33.59014482597634, 0.533974123385997],
            [33.58921072630287, 0.533503776928838],
            [33.5885451950516, 0.533983325328125],
            [33.587452152861665, 0.53362155712502],
            [33.586905695097926, 0.534101093837568],
            [33.584933096243624, 0.533911299739716],
            [33.58391095358747, 0.534915600387452],
            [33.5821287858953, 0.535006240940169],
            [33.58196205139203, 0.535865709676758],
            [33.58058318863491, 0.536245811559544],
            [33.580108068782806, 0.536797716763652],
            [33.57678077454746, 0.537205145036665],
            [33.57501083023136, 0.535911608885165],
            [33.5742261949498, 0.536101667912552],
            [33.574107196920764, 0.536915899324211],
            [33.57268115194993, 0.537296003836555],
            [33.57142181722786, 0.536554277713068],
            [33.567797865149686, 0.535984664772649],
            [33.56558817394245, 0.535143510105938],
            [33.563924894684874, 0.533280001915675],
            [33.56039588734575, 0.530957415390339],
            [33.5579498224378, 0.526884384903721],
            [33.55641743849689, 0.525237985218251],
            [33.5571306190858, 0.523654710671143],
            [33.55484954684776, 0.522225502973856],
            [33.553732808897266, 0.520669531730912],
            [33.55349615402385, 0.518471150873992],
            [33.552664726397474, 0.516698027905352],
            [33.55123913417758, 0.515856788896201],
            [33.550609407078554, 0.514780259961488],
            [33.5484946642036, 0.514156206627137],
            [33.54666515888921, 0.512482682774026],
            [33.54568139944854, 0.510288271283574],
            [33.545537015029566, 0.508845912459712],
            [33.5471061715066, 0.507054486164643],
            [33.54789120204688, 0.504874108459828],
            [33.54709613373163, 0.501219215547119],
            [33.5473813703939, 0.500115466257791],
            [33.54595569552896, 0.498224777478162],
            [33.54463231541871, 0.497175443780989],
            [33.54508152336644, 0.49562838014447],
            [33.5435089955121, 0.490544132666883],
            [33.543448159804434, 0.488381919965603],
            [33.54692971543535, 0.485531849966735],
            [33.54854100559417, 0.483858035872586],
            [33.54903965232352, 0.48243762712852],
            [33.55129178982627, 0.480573775869693],
            [33.55645218443379, 0.478049262290242],
            [33.558316891130865, 0.475760985782233],
            [33.55945630794903, 0.475147934556831],
            [33.56215252581584, 0.472319354095066],
            [33.56808754218441, 0.469679916293976],
            [33.574004782690174, 0.46404321364366],
            [33.577234727396494, 0.461790272920016],
            [33.577197340412695, 0.46086789292314],
            [33.57612445641773, 0.459872386010408],
            [33.576359169133475, 0.455747024526615],
            [33.57472780701794, 0.452065072383754],
            [33.571866895620204, 0.447451385487569],
            [33.57711031252626, 0.444049340292801],
            [33.58174514418355, 0.44401278534838],
            [33.58279660156236, 0.444347435464506],
            [33.58432706131192, 0.443496907336683],
            [33.597044303278366, 0.444952422708165],
            [33.60590774931974, 0.443630852013051],
            [33.60960186880473, 0.444698070604492],
            [33.617893440149736, 0.442372340037218],
            [33.61575490539445, 0.45217022859191],
            [33.615449055091354, 0.455146658966307],
            [33.61481340809463, 0.456919891541351],
            [33.61490731707613, 0.458231672991992],
            [33.613636585428026, 0.46176004469416],
            [33.613653765707845, 0.463519936981164],
            [33.61362790231249, 0.465270212682786],
            [33.61249983301299, 0.468789527959985],
            [33.613024679107625, 0.471702559412235],
            [33.612669236410966, 0.4727067887933],
            [33.61375354428139, 0.476117344143638],
            [33.613616088568186, 0.477818159859175],
            [33.614065530077895, 0.479075628056375],
            [33.613543315148725, 0.480523167464946],
            [33.613876568559554, 0.482621999802007],
            [33.61577183324769, 0.485037328073318],
            [33.61641450596825, 0.486484760215364],
            [33.61990038968218, 0.488800420856425],
            [33.6207082518037, 0.490890159107755],
            [33.62304845205204, 0.494300585852568],
            [33.62291050585873, 0.496670861995816],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1130,
        District: "IGANGA",
        County: "BUGWERI",
        Subcounty: "MAKUUTU",
        Population: 27862,
        Key: "IGANGAMAKUUTU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.67508047680103, 0.727094474638327],
            [33.67072797216284, 0.727087162940695],
            [33.6663148231581, 0.729122790305179],
            [33.664790739650435, 0.728932728465674],
            [33.66101247676942, 0.730146390568719],
            [33.6561060861984, 0.72981096171425],
            [33.651884740083254, 0.731642395876698],
            [33.647904605096606, 0.731703849105752],
            [33.64715418754255, 0.733553297630281],
            [33.64541181521749, 0.733102547366456],
            [33.64442868280086, 0.733290608645154],
            [33.64261154908457, 0.732213472981531],
            [33.64013755824938, 0.731673608889396],
            [33.6383581169441, 0.730021982205917],
            [33.63690886220129, 0.729253213324801],
            [33.633469488761186, 0.724921569621534],
            [33.62734984255058, 0.722376127703679],
            [33.628142492601114, 0.720926371718021],
            [33.63052991369069, 0.720833107922663],
            [33.63143310952173, 0.719450593128658],
            [33.635267747975064, 0.719423579324547],
            [33.638292327925974, 0.718346417003933],
            [33.6396796887457, 0.718977741049309],
            [33.64041796287377, 0.718755028491639],
            [33.64167663104588, 0.719142118902278],
            [33.643611648880274, 0.718512270695569],
            [33.64476935539764, 0.718962655930202],
            [33.645539662550405, 0.71826240956748],
            [33.64648482946817, 0.718219189625349],
            [33.64804930212931, 0.717427492840164],
            [33.65034299390046, 0.715898262144373],
            [33.65314666554661, 0.713051595688654],
            [33.65471633585999, 0.712595570686309],
            [33.655786144921755, 0.711238405505409],
            [33.65865042320515, 0.709202476438476],
            [33.66332120454179, 0.704734692465937],
            [33.66513610235133, 0.702238918770538],
            [33.667732923428574, 0.701161800949981],
            [33.66943289257727, 0.699703955864234],
            [33.67121671766116, 0.696717969175064],
            [33.672585058451375, 0.695269576783589],
            [33.672088818308644, 0.694984454531205],
            [33.67242102518219, 0.69296162294975],
            [33.6750249321704, 0.68484635051736],
            [33.67713783888892, 0.680171633866872],
            [33.67787230775341, 0.679995728278856],
            [33.67882148475062, 0.678232668535589],
            [33.68144660814918, 0.676526043568767],
            [33.68149603974433, 0.673256603982631],
            [33.68313654491283, 0.6722521896513],
            [33.68469402149456, 0.667927649794189],
            [33.68476243538994, 0.663779382391106],
            [33.683956382475415, 0.662122575915719],
            [33.68148177449762, 0.660700310604647],
            [33.68056147474357, 0.660958027303856],
            [33.67981557751201, 0.660362674293701],
            [33.678315346970074, 0.660173026479303],
            [33.67748269673661, 0.659596643638524],
            [33.67693493372075, 0.658516295152285],
            [33.6769347774139, 0.657359902760604],
            [33.67761182147387, 0.655953152570951],
            [33.67679698752741, 0.652746748025374],
            [33.67718732258633, 0.651753189465673],
            [33.676916096049226, 0.650860284935488],
            [33.67742606873772, 0.647826886106246],
            [33.677260172362615, 0.646298015061558],
            [33.678124554685205, 0.64383684915776],
            [33.67982408994764, 0.641529924811509],
            [33.69778857654157, 0.641907571733885],
            [33.69887566379952, 0.636968985893025],
            [33.70076150875356, 0.633846584575945],
            [33.70193877608622, 0.629793520168771],
            [33.70195103539491, 0.627460875917871],
            [33.70291720312739, 0.625250989780156],
            [33.7035113434664, 0.622034769622552],
            [33.7039543386656, 0.621550060052931],
            [33.70444746614589, 0.617982044613161],
            [33.70579199708951, 0.614440823777409],
            [33.705732908605064, 0.613572352787194],
            [33.70905452728448, 0.610574296890932],
            [33.71254190848997, 0.609030026773096],
            [33.71460976110376, 0.607618474834259],
            [33.718887793608275, 0.60655039929163],
            [33.72355792995453, 0.606006972325945],
            [33.72963198217288, 0.606438574287141],
            [33.72960238807418, 0.621917099948861],
            [33.73248741833895, 0.632059966059442],
            [33.73148652263591, 0.638571196329141],
            [33.734037776670355, 0.636613826542454],
            [33.73704474425184, 0.635267955573082],
            [33.741479390839615, 0.634227658026743],
            [33.74348416016087, 0.634227366990414],
            [33.75727913612651, 0.639917820972818],
            [33.75782792771334, 0.640487089152386],
            [33.76119004963229, 0.640888705297195],
            [33.762402863300736, 0.641899505368867],
            [33.76442821751671, 0.642655196161506],
            [33.76760482385475, 0.643174251376249],
            [33.773113789047024, 0.642394178322955],
            [33.77423908794217, 0.642643600538949],
            [33.77465747020093, 0.642040359550038],
            [33.77799547954099, 0.640297336393181],
            [33.77911282205768, 0.639176979800511],
            [33.78119098283933, 0.639607501134409],
            [33.78222783450995, 0.638927967920316],
            [33.78319770419971, 0.639319964727719],
            [33.7849260250771, 0.638891366543198],
            [33.785211324621464, 0.638746578797321],
            [33.7849831471494, 0.636905243582666],
            [33.785648126835085, 0.637340886085303],
            [33.785591892298314, 0.638257006707261],
            [33.7860590539753, 0.638670401903067],
            [33.78880541041134, 0.639577981638574],
            [33.79113306299183, 0.640963947070816],
            [33.791237826316866, 0.641443057778379],
            [33.79467699943268, 0.643024086774805],
            [33.79848228273913, 0.647076299983321],
            [33.80056504109843, 0.647980613056457],
            [33.803033222528654, 0.649689997430454],
            [33.80655546555373, 0.653886978249947],
            [33.80930709779546, 0.657912193734311],
            [33.82482208971369, 0.670646955675204],
            [33.8310986922657, 0.674689615953256],
            [33.83487950097225, 0.676561561377217],
            [33.833657163365146, 0.682043879880971],
            [33.83338528465115, 0.691515485811505],
            [33.80592647597156, 0.68510635109168],
            [33.80190825960342, 0.684437595042876],
            [33.79205390712496, 0.684204041643446],
            [33.79003433985602, 0.685190444457412],
            [33.78557853704496, 0.688565951241942],
            [33.78554396538127, 0.689704518538448],
            [33.78460109815064, 0.691738873359887],
            [33.78092319505315, 0.692800057489063],
            [33.77589864278458, 0.696745168150735],
            [33.760426993680504, 0.717174803977839],
            [33.75907364577234, 0.718821501286435],
            [33.75749327652394, 0.719825933545433],
            [33.75464051284584, 0.719545967826715],
            [33.75079440919452, 0.717393528405292],
            [33.74776680102279, 0.712653628803762],
            [33.744761960651935, 0.709732078034629],
            [33.74117253262677, 0.707480062466199],
            [33.72430115739305, 0.700779214646531],
            [33.722352147399796, 0.700707145506719],
            [33.721092903407545, 0.700852087717256],
            [33.709428071034125, 0.706472335437954],
            [33.69415279454945, 0.711965515882469],
            [33.69201321146026, 0.714643656904948],
            [33.691395384343814, 0.714761357592265],
            [33.69056313835218, 0.715819945944448],
            [33.68974313280468, 0.716100518206725],
            [33.68952921249447, 0.716625257707428],
            [33.68627297769303, 0.719095498214651],
            [33.68403883075052, 0.720479980271267],
            [33.68213764616467, 0.721122584171197],
            [33.68043778391546, 0.723393562153957],
            [33.676563598928375, 0.725257769532251],
            [33.67508047680103, 0.727094474638327],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1131,
        District: "BUGIRI",
        County: "BUKOOLI NORTH",
        Subcounty: "NABUKALU",
        Population: 36628,
        Key: "BUGIRINABUKALU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30344000756731, 0.979919612116034],
            [34.30042599449906, 0.982455498685621],
            [34.29891801778444, 0.984512850499453],
            [34.29676923774337, 0.985738993569375],
            [34.29681171188663, 0.986520730070585],
            [34.29544158704224, 0.988043748417548],
            [34.29610071869542, 0.992247130211126],
            [34.29524394420501, 0.996141000302945],
            [34.29531358340247, 0.998629147047934],
            [34.2934140148858, 0.998963962953857],
            [34.292510578306256, 1.000588547856441],
            [34.289090745918514, 1.004675541318582],
            [34.28722657371901, 1.00855052328638],
            [34.28540736489442, 1.009553434667282],
            [34.28648389604944, 1.011557373925308],
            [34.28622096994558, 1.012283199172363],
            [34.28292960382999, 1.013866291652016],
            [34.28122881092615, 1.012903225541193],
            [34.280512259858334, 1.011673384039486],
            [34.278457813701856, 1.011574706013734],
            [34.277564633187914, 1.009621326880114],
            [34.273740072933755, 1.00549828498817],
            [34.27303575153018, 1.002477505207881],
            [34.2732669176972, 1.000451316088477],
            [34.27188168678299, 0.999737296562685],
            [34.271733816002374, 0.99931223533832],
            [34.271792615229316, 0.997412743218318],
            [34.272349293126034, 0.99624571006975],
            [34.27187221943821, 0.994111255874839],
            [34.27137277769979, 0.993686330447721],
            [34.271752562944066, 0.992564592121752],
            [34.27235541604302, 0.991714120172341],
            [34.274207893974136, 0.990926478456167],
            [34.276521614582876, 0.98614978172849],
            [34.27759029895388, 0.985959421879417],
            [34.27827822879844, 0.984358178948962],
            [34.279465734230435, 0.983543663652667],
            [34.27952264250365, 0.979609039867055],
            [34.28035333979972, 0.978315276537744],
            [34.280433890832924, 0.974507276383074],
            [34.28057576086743, 0.973928338389474],
            [34.28143090940722, 0.973430531609891],
            [34.28180993377842, 0.971775141836511],
            [34.283077173674975, 0.969441033845161],
            [34.282743957095065, 0.968961773064341],
            [34.28219764036683, 0.969314738912687],
            [34.281888374669, 0.968310857007936],
            [34.28264776010455, 0.967044259511406],
            [34.28270530079176, 0.964737749578546],
            [34.28370230139972, 0.963615784209422],
            [34.28370189805616, 0.962539423993444],
            [34.28429605546317, 0.962466837785244],
            [34.29085911908119, 0.964182890337518],
            [34.29478082225184, 0.969123228430065],
            [34.29518004075062, 0.969724799753918],
            [34.29696111698972, 0.970376373011005],
            [34.3022166189313, 0.970283884954405],
            [34.30221713636092, 0.97163158744676],
            [34.301860718992145, 0.972165379414902],
            [34.302024985823316, 0.9747973902396],
            [34.30255798143422, 0.978079275002552],
            [34.30322037666686, 0.978705137916892],
            [34.30344000756731, 0.979919612116034],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1132,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUKIBOKOLO",
        Population: 10042,
        Key: "BUDUDABUKIBOKOLO",
        Dist2: "Bududa",
        "Sub Country": "Bukibokolo",
        id2_original: "Bududa Bukibokolo",
        drought: "M",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32845692491173, 1.023031498826],
            [34.32601029047188, 1.023052706465369],
            [34.325851254530605, 1.022231244457795],
            [34.323946852179425, 1.022163577052993],
            [34.32369683306956, 1.020611904032993],
            [34.32120216930474, 1.018559116043945],
            [34.32111106486357, 1.017532240586951],
            [34.3221536010733, 1.016710280480215],
            [34.321926341679465, 1.015363978665709],
            [34.32251540923207, 1.014428105233276],
            [34.32246978829037, 1.013743516564659],
            [34.323217607916625, 1.012944498474513],
            [34.323194139429816, 1.010981966859309],
            [34.32267217782556, 1.009681427416437],
            [34.32321588494792, 1.008699932185435],
            [34.32255788966354, 1.007376628446488],
            [34.32078927215912, 1.006692744258491],
            [34.31963221153047, 1.004616570596854],
            [34.32094643331638, 1.002881693270952],
            [34.322646060206985, 0.998381646673475],
            [34.325404029164744, 1.002935261485325],
            [34.3265210815256, 1.004149844457738],
            [34.328483088344385, 1.005333703936437],
            [34.32884566007115, 1.006427090546145],
            [34.330656657395735, 1.007307247010252],
            [34.33439879093436, 1.007670213569992],
            [34.334825081960865, 1.004869977811413],
            [34.337202290103974, 1.004144081751979],
            [34.33746952003636, 1.002749285711505],
            [34.33933222259208, 1.002162515140779],
            [34.34277077766693, 1.002052554814554],
            [34.3432161965208, 1.003592794831165],
            [34.34677708417105, 1.005415387744775],
            [34.34714624504045, 1.006190059909501],
            [34.347005396390415, 1.01461635631367],
            [34.34649347525608, 1.017635165893903],
            [34.34599652544428, 1.018087357647487],
            [34.34283923288484, 1.017605867471008],
            [34.33854099457465, 1.01518116427774],
            [34.33354488206965, 1.014567562986999],
            [34.333557953455355, 1.015072549856495],
            [34.332053331050005, 1.016173800293456],
            [34.33230439849382, 1.016711059196947],
            [34.33123672652414, 1.016789194932391],
            [34.33092138282512, 1.016355550289118],
            [34.330368328732256, 1.01658237962245],
            [34.33051706998035, 1.018544021342754],
            [34.32889674187147, 1.019820126018965],
            [34.328376560728096, 1.021782047793371],
            [34.32845692491173, 1.023031498826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1133,
        District: "BUDUDA",
        County: "MANJIYA",
        Subcounty: "BUDUDA TOWN COUNCIL",
        Population: 6799,
        Key: "BUDUDABUDUDA TOWN COUNCIL",
        Dist2: "Bududa",
        "Sub Country": "Bududa T.C",
        id2_original: "Bududa Bududa T.C",
        drought: "L",
        "Animal Vectors and diseases": "N",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.128728869729656, 0.95447801260555],
            [34.128177940152426, 0.954264445319703],
            [34.127682883090905, 0.952996494431681],
            [34.1266564339113, 0.95351347338704],
            [34.12594695078811, 0.952950101966698],
            [34.125648438822566, 0.953382297994077],
            [34.12538690959896, 0.952743630295743],
            [34.12409195757418, 0.952363979271469],
            [34.12372571173789, 0.952922653248494],
            [34.12431373005828, 0.953063361160134],
            [34.12448661352965, 0.953578192531059],
            [34.12350194768883, 0.95411039573202],
            [34.12293612314587, 0.953828457241511],
            [34.12223857503955, 0.954429939645821],
            [34.121224714850335, 0.953825865062857],
            [34.120941506583975, 0.954546412516598],
            [34.12046552614585, 0.95470825388803],
            [34.120480724742144, 0.955813403565982],
            [34.11998556437438, 0.954773984372166],
            [34.11928902327948, 0.954938612818067],
            [34.11952899293628, 0.954213243060593],
            [34.11825609814497, 0.954803563583593],
            [34.117784988372335, 0.953856005651721],
            [34.11599266522588, 0.952642939480143],
            [34.11540692682969, 0.953764914732188],
            [34.114489321123166, 0.953697520779345],
            [34.114357443947874, 0.953084031229747],
            [34.113470602844885, 0.952929044775947],
            [34.11331453763224, 0.95340567700557],
            [34.11405569894564, 0.95458607751238],
            [34.11188512847071, 0.955601721664674],
            [34.11096918374912, 0.954814930185049],
            [34.110084521060685, 0.955301965893104],
            [34.10880849025074, 0.954536003385472],
            [34.107512074870385, 0.95439143421237],
            [34.10511533106477, 0.955956049653939],
            [34.104024435848366, 0.955024312767149],
            [34.103551528546845, 0.956184402841586],
            [34.102594338577326, 0.955107632509333],
            [34.101267272679436, 0.955615529544842],
            [34.10080409772567, 0.955035712600917],
            [34.099744769308366, 0.956309914140469],
            [34.09959006953495, 0.955139670065218],
            [34.09813942150514, 0.955305840686566],
            [34.0980566758877, 0.953949161509395],
            [34.096575766310906, 0.956010593154785],
            [34.096462182428034, 0.954726422486997],
            [34.095206767055544, 0.954095076190802],
            [34.095371135396356, 0.953287209214109],
            [34.094681486176306, 0.952324269340534],
            [34.09348814438995, 0.952780343856401],
            [34.09247945400519, 0.951506812857065],
            [34.091728501055236, 0.95187988921526],
            [34.09056566336098, 0.951207079183708],
            [34.08998995555325, 0.952636471605893],
            [34.08973260259742, 0.952201573725728],
            [34.08827159339909, 0.952150260958426],
            [34.087613021396336, 0.951860490977351],
            [34.08719089316284, 0.950918172285526],
            [34.0856474985715, 0.950639038586386],
            [34.08501970195204, 0.950038554309902],
            [34.08460823222941, 0.950276887698306],
            [34.0847210139167, 0.949013349958482],
            [34.08409343828283, 0.949117105511156],
            [34.08345596141784, 0.950463666664314],
            [34.08250901044594, 0.949221174529748],
            [34.081325966946004, 0.949729019439408],
            [34.080430826308096, 0.949646456742972],
            [34.07958662374006, 0.947948237719579],
            [34.0795039257333, 0.946705472529463],
            [34.076694785143715, 0.945629263305632],
            [34.07634464879541, 0.94459164012852],
            [34.07553162046269, 0.943887642508423],
            [34.073329802988916, 0.943774415349694],
            [34.07173442019716, 0.941713939276788],
            [34.07028365987791, 0.941548685957135],
            [34.06947035755904, 0.939907404011245],
            [34.068101706850015, 0.939079303691679],
            [34.067257688436634, 0.937950680642142],
            [34.065858198563916, 0.937226153432858],
            [34.065714011774304, 0.936739436741517],
            [34.06508638583476, 0.93668783901801],
            [34.065415399197455, 0.935936882147011],
            [34.06464346968727, 0.935015381114636],
            [34.0636864701606, 0.934528910222143],
            [34.06265778148099, 0.935150623332317],
            [34.062359276701955, 0.934695019853916],
            [34.0625854194899, 0.934001059376066],
            [34.060836069051696, 0.93310055586572],
            [34.06077414189096, 0.93246881942024],
            [34.06020844311212, 0.933080035676188],
            [34.0595906393519, 0.931474939901398],
            [34.05902481391061, 0.931640816146236],
            [34.05827859328559, 0.931144778992717],
            [34.058211655322175, 0.930481116688604],
            [34.05897291284678, 0.930128759444759],
            [34.05885954994949, 0.929472186419156],
            [34.059414968408184, 0.92891275150646],
            [34.05896191567107, 0.927752945165445],
            [34.05914696682295, 0.927250592238202],
            [34.05973344093937, 0.92730219459093],
            [34.05941419495875, 0.926318406667817],
            [34.060257897165165, 0.926411363860323],
            [34.059938716761565, 0.925655425190124],
            [34.06044266894101, 0.925002805203107],
            [34.060157432278736, 0.924202468285089],
            [34.05953966984099, 0.924451425525435],
            [34.05904508798827, 0.923404666801431],
            [34.05849933450372, 0.923446292019955],
            [34.057757699778186, 0.922658744204204],
            [34.05772665849354, 0.922161215680547],
            [34.058519448681224, 0.921829283553532],
            [34.05807028205603, 0.920883271477505],
            [34.058835604457265, 0.92071055673789],
            [34.05881264980683, 0.920354100937801],
            [34.05711019591803, 0.919147220749517],
            [34.05729260871794, 0.917928273734557],
            [34.05600165509447, 0.917572195799014],
            [34.05600145746511, 0.916900654641203],
            [34.05396821963421, 0.91736121847152],
            [34.05364814271194, 0.916602385675651],
            [34.04869148062098, 0.913298762004916],
            [34.04814805017976, 0.913285812638738],
            [34.04813616187528, 0.914404596566458],
            [34.047733235131005, 0.914822722527278],
            [34.04653639710155, 0.915142727199789],
            [34.046438806824035, 0.915548467786517],
            [34.04580368624007, 0.915499478129114],
            [34.04565725545887, 0.915954410422481],
            [34.044838803098436, 0.915469026433676],
            [34.04367863340057, 0.915887373227733],
            [34.04157765630903, 0.915070419348037],
            [34.04100375591167, 0.915550065685395],
            [34.03994109115137, 0.915267607633831],
            [34.038817573615404, 0.915735121949955],
            [34.03831676553946, 0.915563147078885],
            [34.037987112576275, 0.915962809495325],
            [34.03679008500232, 0.915643506390643],
            [34.033614723729265, 0.91627759103065],
            [34.03151395864012, 0.916216730766318],
            [34.030121161216286, 0.914674191552096],
            [34.02802040870353, 0.914656358673024],
            [34.02711706824371, 0.916304066386019],
            [34.0254806342401, 0.916993026452984],
            [34.025554084091006, 0.917583136774312],
            [34.024284072891774, 0.918321167052472],
            [34.02412550946434, 0.919077317459312],
            [34.02312415292556, 0.919655443657975],
            [34.022745406133765, 0.919225250050831],
            [34.02167067430426, 0.919483744722637],
            [34.02118261062724, 0.921180512545794],
            [34.02052314659741, 0.921445033093759],
            [34.020156986999375, 0.922330337554264],
            [34.01761653879948, 0.922343365030982],
            [34.01578432416622, 0.921796792102013],
            [34.01444104188083, 0.922596317589916],
            [34.01430685423864, 0.923174193518445],
            [34.01328092787851, 0.923266698101171],
            [34.012011482617915, 0.926033312360259],
            [34.01103450186437, 0.926451605818898],
            [34.00991090348003, 0.926691668946853],
            [34.00893360112959, 0.925978873479856],
            [34.008237405886106, 0.92594218927811],
            [34.00508638805893, 0.926428725126748],
            [34.005012925631625, 0.925789434540694],
            [34.00298522232117, 0.925027756251351],
            [34.002289337894744, 0.926097573932533],
            [34.0017641962544, 0.92628214102983],
            [34.00123890998525, 0.925950339526583],
            [34.000138962445725, 0.926252492415405],
            [33.99892622243911, 0.925845770418216],
            [33.99826014501214, 0.926035924319931],
            [33.9983091301446, 0.925370022747268],
            [34.00009446799139, 0.922999049262406],
            [34.00032955260968, 0.921458179136032],
            [34.00154591821678, 0.919778754779887],
            [34.0024486361441, 0.919442682629004],
            [34.00289978714776, 0.918533876950858],
            [34.00417491604919, 0.917824554087821],
            [34.00539010486326, 0.916409906727917],
            [34.005890326339326, 0.910584187788573],
            [34.007837210020284, 0.907899341132952],
            [34.00795135535016, 0.906990513674003],
            [34.0094952547947, 0.905299968191204],
            [34.00963298988397, 0.90371590934111],
            [34.01163747084599, 0.902221999833505],
            [34.01188062682709, 0.901054057912017],
            [34.013169838617216, 0.899380385136186],
            [34.01367924087549, 0.898009427332558],
            [34.0149689108064, 0.89670514189441],
            [34.015705524847796, 0.894975863704117],
            [34.01665653620481, 0.894706365159289],
            [34.019997748038854, 0.890777549083903],
            [34.02102356749946, 0.887417921184056],
            [34.02022656061984, 0.885689073366129],
            [34.02068366655552, 0.883493207554723],
            [34.02014234356196, 0.882045485608752],
            [34.02102191190438, 0.881381136160401],
            [34.0215778765388, 0.879971485792535],
            [34.02633843191167, 0.883593636244538],
            [34.028780264856294, 0.884823192710124],
            [34.03089557456821, 0.885320121854341],
            [34.03615769799177, 0.885445282652502],
            [34.0398830411194, 0.883182770520206],
            [34.04035731835174, 0.882051906903717],
            [34.042748595010515, 0.882692491427061],
            [34.045614564821605, 0.881039117918494],
            [34.047212238317364, 0.880579179151435],
            [34.06216431803079, 0.877962195452197],
            [34.06975933480616, 0.902809286821984],
            [34.07385023206732, 0.900757927160393],
            [34.077256834965844, 0.8996442875224],
            [34.080155524114524, 0.899815291293223],
            [34.09162351315133, 0.90299592368001],
            [34.093712530073205, 0.902036447966145],
            [34.108290006024944, 0.902475230453971],
            [34.10820203850075, 0.903162725496605],
            [34.110990088444105, 0.908942019363153],
            [34.11227518145864, 0.91280409833956],
            [34.114339953749294, 0.915485755420171],
            [34.11455599588017, 0.916691632656213],
            [34.115143295548314, 0.917342658961878],
            [34.11573618543245, 0.920645557646593],
            [34.11898893117734, 0.925167327268737],
            [34.12101139371643, 0.928730645606883],
            [34.11991882583696, 0.931931004571685],
            [34.117932450419474, 0.933715476172223],
            [34.117325562088254, 0.93516252801724],
            [34.12099263150342, 0.937914848053901],
            [34.12660542397622, 0.938143993739886],
            [34.128637310740956, 0.949662908025724],
            [34.12871658257319, 0.953913597645394],
            [34.128728869729656, 0.95447801260555],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1134,
        District: "BUTALEJA",
        County: "BUNYOLE",
        Subcounty: "HIMUTU",
        Population: 14724,
        Key: "BUTALEJAHIMUTU",
        Dist2: "Butaleja",
        "Sub Country": "Himutu",
        id2_original: "Butaleja Himutu",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "VH",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.368279716605116, 0.490003003757915],
            [33.37136593356093, 0.493451139036896],
            [33.37317313191016, 0.494772376041675],
            [33.373192217516696, 0.495883065451337],
            [33.37246947885317, 0.49787469118773],
            [33.36930122505065, 0.502742681830915],
            [33.36768872126791, 0.504335074617675],
            [33.3635865312853, 0.507009679952734],
            [33.36240715919993, 0.507335294807957],
            [33.359991547180094, 0.511567553434795],
            [33.36046712517298, 0.511873924219399],
            [33.361570560870774, 0.514248445519078],
            [33.36134237711049, 0.515761298257927],
            [33.360676759620965, 0.516872855405904],
            [33.35969283309363, 0.517103294437841],
            [33.35839754240398, 0.516691597127765],
            [33.354988071184756, 0.517816987603366],
            [33.353099514216844, 0.517794459674339],
            [33.35067823921749, 0.519245492948118],
            [33.34993874787223, 0.520655374866603],
            [33.353369093243735, 0.520718544483758],
            [33.3549902478027, 0.527713793026142],
            [33.35864837448918, 0.533653200705019],
            [33.35922282824876, 0.538382386559829],
            [33.358942037348825, 0.54165518824724],
            [33.35687109183552, 0.541338607333988],
            [33.35527468316772, 0.539791636231677],
            [33.35065693028064, 0.537783434308517],
            [33.34662611234565, 0.535268551036298],
            [33.340188891020865, 0.533317677423225],
            [33.340158019517816, 0.530727231080228],
            [33.340816722674646, 0.52785018922854],
            [33.340649567759804, 0.526587375794727],
            [33.341255977289, 0.525663992428233],
            [33.34101021529525, 0.522520580094026],
            [33.33983723831639, 0.519644637550746],
            [33.33768693203765, 0.517137076903064],
            [33.330850376331384, 0.515099006181733],
            [33.325359306477885, 0.517440483998925],
            [33.32560733132786, 0.517102940516033],
            [33.325037200261406, 0.516750128971302],
            [33.32488494929547, 0.516098738510044],
            [33.327861508904576, 0.508562268910678],
            [33.33162275859243, 0.501369554533695],
            [33.33253090863231, 0.498461258116326],
            [33.33658233391988, 0.495401175061797],
            [33.339131435590915, 0.496358451348936],
            [33.339702181105004, 0.497564755363054],
            [33.347254398546966, 0.500915281295219],
            [33.348871153157674, 0.497487678326105],
            [33.35084952638261, 0.497621609389895],
            [33.35062141808082, 0.500704470022777],
            [33.35406455276701, 0.500972356270194],
            [33.35509170712413, 0.499574487244519],
            [33.358648916173294, 0.498750923284153],
            [33.359447815803236, 0.497736028880998],
            [33.36104569321657, 0.497123201527376],
            [33.36157830165356, 0.49662532181679],
            [33.36277657159759, 0.493657298338775],
            [33.365896167254405, 0.491263613681446],
            [33.368279716605116, 0.490003003757915],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1135,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "MAGAMAGA TOWN COUNCIL",
        Population: 16363,
        Key: "MAYUGEMAGAMAGA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.29291174255595, 0.790607492241114],
            [34.2897668566289, 0.793605561144889],
            [34.28807040618117, 0.794500663426604],
            [34.28361202879854, 0.79422595806697],
            [34.28056354557619, 0.788045278474459],
            [34.27983668364552, 0.783178074538169],
            [34.276257941979, 0.782449061815982],
            [34.275386398286976, 0.777340793603743],
            [34.273157959239754, 0.775609936735638],
            [34.27149396671985, 0.775269811822661],
            [34.27152205793708, 0.774900786231519],
            [34.274172549759314, 0.773395533175721],
            [34.27704881965342, 0.772457929154977],
            [34.28119334993033, 0.768851678528615],
            [34.282265999465, 0.772172483966431],
            [34.28220984397997, 0.772995688130907],
            [34.283676273612684, 0.772853311826106],
            [34.28802492447833, 0.771105939993531],
            [34.28958630962986, 0.773950104266152],
            [34.28915771711959, 0.774576173748913],
            [34.2900982720867, 0.78050087534365],
            [34.29115786191375, 0.783783892027017],
            [34.29212779628223, 0.789152084910258],
            [34.29291174255595, 0.790607492241114],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1136,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUNYINZA TOWN COUNCIL",
        Population: 2279,
        Key: "MANAFWABUNYINZA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.94268361429041, 1.54027138770134],
            [33.94243180843145, 1.541275613162938],
            [33.94267258387705, 1.544559227931498],
            [33.937177810269645, 1.553960553654291],
            [33.93621056455881, 1.552058281321689],
            [33.93254629968399, 1.550459204324401],
            [33.93153427565121, 1.551090236332776],
            [33.92762917873687, 1.549927811827809],
            [33.92652053011549, 1.55007381995751],
            [33.92362756593012, 1.548522888842491],
            [33.92189233790651, 1.548863195438953],
            [33.91919267679723, 1.548427818035687],
            [33.917071952040764, 1.549107835839123],
            [33.91181715348005, 1.548042975683667],
            [33.90993666068848, 1.546879631763212],
            [33.909984349551955, 1.545666945435442],
            [33.90810264313641, 1.541641704911116],
            [33.90824668170401, 1.540283456696373],
            [33.907522705162044, 1.538149474123246],
            [33.90299046829673, 1.535823090025206],
            [33.90009787242062, 1.535096718074946],
            [33.89836199132177, 1.533884783845142],
            [33.89411975937628, 1.533401507095936],
            [33.89161322527331, 1.533693601941891],
            [33.88756304774564, 1.531366966047929],
            [33.88452498138737, 1.528554828145486],
            [33.88153485003095, 1.525063562904303],
            [33.88110051279448, 1.523851066249467],
            [33.87936468379792, 1.522736119340656],
            [33.87796572123627, 1.520214327408864],
            [33.87632440938068, 1.514394149425692],
            [33.877297183323755, 1.503542849785645],
            [33.88270340101042, 1.49817809250782],
            [33.88484164560987, 1.495481450347604],
            [33.890582377043756, 1.492023461640115],
            [33.891934173561395, 1.49091927277116],
            [33.89308176325202, 1.489136703714037],
            [33.896105990165, 1.478207671649463],
            [33.89648759539603, 1.474380979193838],
            [33.89604092698563, 1.47145924108693],
            [33.897199674650395, 1.469495749395529],
            [33.898740745300074, 1.468301028860952],
            [33.90050216819737, 1.466038769035607],
            [33.90098912964155, 1.463487571873812],
            [33.9024477717791, 1.468153043188467],
            [33.90523254197333, 1.473555613502685],
            [33.90533093264978, 1.475422307012009],
            [33.906210743537365, 1.478123796922388],
            [33.91181387283265, 1.484031488503798],
            [33.934770780754036, 1.487583988513988],
            [33.936581329819305, 1.489014251706491],
            [33.92702733624262, 1.500675653044693],
            [33.92840834776993, 1.501135216251042],
            [33.93080371805145, 1.502616453131336],
            [33.93832814341514, 1.501430954178324],
            [33.94268361429041, 1.54027138770134],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1138,
        District: "KUMI",
        County: "KUMI MUNICIPALITY",
        Subcounty: "NORTHERN DIVISON",
        Population: 17861,
        Key: "KUMINORTHERN DIVISON",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.4887807924222, 1.059369457167912],
            [33.48639098720387, 1.060148348319024],
            [33.48563863198373, 1.062636392128626],
            [33.48447152459695, 1.063975533410028],
            [33.48209111575649, 1.065839592905805],
            [33.48092496866873, 1.066147374310504],
            [33.47693600503947, 1.069992980370899],
            [33.44862351566731, 1.099599226679866],
            [33.441058465791514, 1.085423628422183],
            [33.43596604131165, 1.076956322769383],
            [33.43369979576738, 1.072143610610087],
            [33.433026327900556, 1.06908330091106],
            [33.433870614011916, 1.068470477145658],
            [33.4367254456118, 1.068415787340055],
            [33.437861869243434, 1.067756262750982],
            [33.44157267223993, 1.067941706593874],
            [33.44412177391095, 1.066414152898491],
            [33.4463571910713, 1.06644733900069],
            [33.44798863762846, 1.066949777568373],
            [33.44894459061785, 1.066667179741523],
            [33.449734167531744, 1.066997394393865],
            [33.449676823575594, 1.065149464757001],
            [33.45030922406088, 1.063962095134089],
            [33.45147437222207, 1.063157639699428],
            [33.452201633903044, 1.06017019250509],
            [33.4515972716344, 1.057915413806039],
            [33.45017011275262, 1.055794802822713],
            [33.450231800961504, 1.05480858940359],
            [33.45088190364776, 1.054162546037744],
            [33.44998194534499, 1.05275686994565],
            [33.44990119039421, 1.05149976571782],
            [33.448625313196196, 1.050770012762029],
            [33.44874596502369, 1.049296600055923],
            [33.44906807034184, 1.047931297884987],
            [33.449779696845304, 1.047093118484486],
            [33.45114939678656, 1.046579259225977],
            [33.4524654700003, 1.046687206133768],
            [33.45276084145559, 1.046200537872185],
            [33.451659575189225, 1.04567352034023],
            [33.45135042806904, 1.04374058007274],
            [33.450276002565055, 1.043078384491439],
            [33.45071894835692, 1.041564373726082],
            [33.44972497507145, 1.040037053190491],
            [33.45040962696357, 1.038387835284156],
            [33.45019468796386, 1.037874205434101],
            [33.45054375711358, 1.037252355230115],
            [33.4507885300622, 1.034098293627037],
            [33.4502650035927, 1.034261215188105],
            [33.44921895497021, 1.033736635987973],
            [33.446866134290445, 1.032162783800289],
            [33.431666410612756, 1.024293952204369],
            [33.42738097688862, 1.021109961452385],
            [33.418228176307714, 1.010489896015476],
            [33.41344448033311, 1.002664779762116],
            [33.41269817975802, 1.000249300503915],
            [33.41589731853831, 1.000276033885673],
            [33.416635399528566, 0.999868820436104],
            [33.41732624260961, 0.999054493981499],
            [33.417732718597584, 0.997263118240956],
            [33.41724677135136, 0.996955579867268],
            [33.416937926963435, 0.993409160113553],
            [33.41588634202384, 0.988903842628785],
            [33.4138137597801, 0.986379965167878],
            [33.4119138696666, 0.985755953946486],
            [33.410987322129735, 0.983847131807987],
            [33.41092767129991, 0.98297861851854],
            [33.41304183835479, 0.981114653673021],
            [33.41318438212575, 0.979992796139859],
            [33.413065744321116, 0.979088101196596],
            [33.411681969575994, 0.9774055135846],
            [33.410452541566364, 0.974619159737889],
            [33.40916991712222, 0.973207969284631],
            [33.40845667904113, 0.96997824196261],
            [33.408480489786065, 0.967110308614652],
            [33.40959761670708, 0.965671684377349],
            [33.410019238290744, 0.963636035659644],
            [33.41839263178507, 0.959998078555594],
            [33.423511031949666, 0.958767039986171],
            [33.43313133197411, 0.958747730707873],
            [33.43636613117625, 0.958212705215708],
            [33.4410515370857, 0.955746813533608],
            [33.44554546080414, 0.95165299260834],
            [33.449110757385846, 0.949162904322722],
            [33.449455377179945, 0.947894759347329],
            [33.45090939568873, 0.94588785663599],
            [33.454564480679686, 0.942051931440319],
            [33.456301605046896, 0.941677947746843],
            [33.45997048995722, 0.942033417868357],
            [33.464227176693974, 0.941685789878274],
            [33.46557884475253, 0.941196235514693],
            [33.46701182831061, 0.939911761152328],
            [33.468532508101646, 0.940949535722538],
            [33.47565143664107, 0.943908054851325],
            [33.47588934825752, 0.9447218790394],
            [33.47548584479485, 0.950251370071072],
            [33.47584293679838, 0.95309981783476],
            [33.474897932475685, 0.957469146907326],
            [33.47639871098995, 0.965129123276624],
            [33.47641995704474, 0.968464332911708],
            [33.472134646389776, 0.971796698302361],
            [33.4696761667646, 0.975229965222386],
            [33.468222346783506, 0.978130855037617],
            [33.468169631846, 0.979328392387901],
            [33.46959805016581, 0.983852193966528],
            [33.46943950739964, 0.984570734779392],
            [33.46568589249335, 0.991277439046318],
            [33.46439050298905, 0.992688048824622],
            [33.46137532660252, 0.994688359873933],
            [33.4612961329237, 0.995446588900941],
            [33.46222811706467, 0.997022752899953],
            [33.461712954808775, 0.999038090543415],
            [33.46244685503971, 1.001771562539705],
            [33.464350580959504, 1.005642191795322],
            [33.46742395200677, 1.009333071708381],
            [33.469545349601354, 1.010330417751778],
            [33.47029882502063, 1.011248150123238],
            [33.4705171398892, 1.012924177267311],
            [33.470140786209335, 1.015119071692776],
            [33.46770297053063, 1.019549014287062],
            [33.472224084456094, 1.026671596935764],
            [33.474087858701914, 1.028247611936247],
            [33.47726009024451, 1.029903238166443],
            [33.47936177520853, 1.031539070570948],
            [33.48716151174892, 1.033598580212127],
            [33.48912346197383, 1.03371794958023],
            [33.49429617787381, 1.035990934490575],
            [33.49572318134701, 1.036918177406436],
            [33.496347577843125, 1.037845547590556],
            [33.49869688341518, 1.043768998950473],
            [33.49872677036471, 1.044786217845405],
            [33.4949815286552, 1.046522078421897],
            [33.49322816813755, 1.0496637823155],
            [33.49123741163642, 1.055468256867878],
            [33.4887807924222, 1.059369457167912],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1139,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "BUDOMERO",
        Population: 24340,
        Key: "KALIROBUDOMERO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.433026327900556, 1.06908330091106],
            [33.43261550855819, 1.067846793614267],
            [33.43193172893025, 1.067398111830185],
            [33.428186156640706, 1.067428559433798],
            [33.42690798694207, 1.068027110758889],
            [33.426283912941145, 1.069403455026887],
            [33.42548138771072, 1.070121613751073],
            [33.41989302851534, 1.072246614063849],
            [33.415642162861644, 1.072845573110541],
            [33.41394782614975, 1.073563852279049],
            [33.41088587538469, 1.072995813352283],
            [33.40871573340614, 1.072427653068773],
            [33.40734812384455, 1.071141332566348],
            [33.39887577104021, 1.069796114767701],
            [33.39138416113386, 1.066506026549985],
            [33.38671701438084, 1.066386946743189],
            [33.38534945153168, 1.065399799918477],
            [33.382673903899544, 1.064412817140781],
            [33.37934418061965, 1.061929973317401],
            [33.37729292707572, 1.061152337345913],
            [33.37533067411852, 1.058878750055625],
            [33.37402264711479, 1.058519883168099],
            [33.37179286598454, 1.056336079672856],
            [33.37027383370372, 1.05542877811877],
            [33.368718137582896, 1.056035716115942],
            [33.358372477610935, 1.057837623082207],
            [33.355349662849555, 1.059103165673294],
            [33.35345876666866, 1.060838955407355],
            [33.35205538709075, 1.058282612114734],
            [33.34979590406394, 1.055865201718271],
            [33.350152380721525, 1.05371080222682],
            [33.35193553117062, 1.04983275400576],
            [33.35433731721988, 1.048898925059795],
            [33.36052732128018, 1.04767087132911],
            [33.36439189788698, 1.044785118490292],
            [33.36752850404202, 1.037899875970944],
            [33.36969603371972, 1.035493082379108],
            [33.371008954745136, 1.031548375609049],
            [33.371771189636746, 1.030996410762482],
            [33.37620735078409, 1.030995884434972],
            [33.37880034952982, 1.030570359373167],
            [33.3831205453605, 1.028561376153434],
            [33.38612003446722, 1.026362560505919],
            [33.38347664472564, 0.999565296266284],
            [33.38385747830383, 0.999302885298504],
            [33.388979824767475, 1.002197355460331],
            [33.39598333775919, 1.004014977740024],
            [33.406441539568256, 1.000865291849661],
            [33.41269817975802, 1.000249300503915],
            [33.41344448033311, 1.002664779762116],
            [33.418228176307714, 1.010489896015476],
            [33.42738097688862, 1.021109961452385],
            [33.431666410612756, 1.024293952204369],
            [33.446866134290445, 1.032162783800289],
            [33.44921895497021, 1.033736635987973],
            [33.4502650035927, 1.034261215188105],
            [33.4507885300622, 1.034098293627037],
            [33.45054375711358, 1.037252355230115],
            [33.45019468796386, 1.037874205434101],
            [33.45040962696357, 1.038387835284156],
            [33.44972497507145, 1.040037053190491],
            [33.45071894835692, 1.041564373726082],
            [33.450276002565055, 1.043078384491439],
            [33.45135042806904, 1.04374058007274],
            [33.451659575189225, 1.04567352034023],
            [33.45276084145559, 1.046200537872185],
            [33.4524654700003, 1.046687206133768],
            [33.45114939678656, 1.046579259225977],
            [33.449779696845304, 1.047093118484486],
            [33.44906807034184, 1.047931297884987],
            [33.44874596502369, 1.049296600055923],
            [33.448625313196196, 1.050770012762029],
            [33.44990119039421, 1.05149976571782],
            [33.44998194534499, 1.05275686994565],
            [33.45088190364776, 1.054162546037744],
            [33.450231800961504, 1.05480858940359],
            [33.45017011275262, 1.055794802822713],
            [33.4515972716344, 1.057915413806039],
            [33.452201633903044, 1.06017019250509],
            [33.45147437222207, 1.063157639699428],
            [33.45030922406088, 1.063962095134089],
            [33.449676823575594, 1.065149464757001],
            [33.449734167531744, 1.066997394393865],
            [33.44894459061785, 1.066667179741523],
            [33.44798863762846, 1.066949777568373],
            [33.4463571910713, 1.06644733900069],
            [33.44412177391095, 1.066414152898491],
            [33.44157267223993, 1.067941706593874],
            [33.437861869243434, 1.067756262750982],
            [33.4367254456118, 1.068415787340055],
            [33.433870614011916, 1.068470477145658],
            [33.433026327900556, 1.06908330091106],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1140,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "NANSOLOLO",
        Population: 14302,
        Key: "KALIRONANSOLOLO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.45744507596192, 1.115388439146162],
            [33.45239059003148, 1.117301004324262],
            [33.44993658311809, 1.119082134773846],
            [33.44382992115659, 1.122414801058997],
            [33.43943526037875, 1.123909005127691],
            [33.43566831537196, 1.124598897909153],
            [33.430417629298624, 1.127012319197069],
            [33.42259951592247, 1.13654913648391],
            [33.42058303436653, 1.138157858458194],
            [33.41689231230992, 1.139900860077099],
            [33.414190700059834, 1.14011188106943],
            [33.41167923959585, 1.139595249912886],
            [33.40966223432209, 1.137585005295049],
            [33.40694129661532, 1.135670597876044],
            [33.4036877486749, 1.13450303333425],
            [33.40311686302362, 1.133660603801538],
            [33.400281810529656, 1.13197597841545],
            [33.396590827961624, 1.131919046220256],
            [33.392462620971784, 1.134581183118353],
            [33.39061791795943, 1.140421572314901],
            [33.38853815009174, 1.142943247184878],
            [33.3881621925689, 1.143948310316537],
            [33.38913523151501, 1.146767432859347],
            [33.39217059843583, 1.15168765572408],
            [33.39206719965169, 1.154245880964424],
            [33.393053117744024, 1.15634713151046],
            [33.3950130153185, 1.166834238787686],
            [33.39319454401076, 1.170914375734624],
            [33.39060451329875, 1.174725890597484],
            [33.387093810930146, 1.171993884610167],
            [33.383616640874465, 1.165489490559472],
            [33.38236983675228, 1.163861180521135],
            [33.380563532226766, 1.162431981469272],
            [33.38077859249902, 1.161690088828984],
            [33.38006659768631, 1.160016467677688],
            [33.37822588678707, 1.157528757283052],
            [33.37507732854717, 1.154751712122561],
            [33.37443724027966, 1.153032842509492],
            [33.3725734696271, 1.150255620518065],
            [33.372502589856246, 1.149513765112425],
            [33.37041243207396, 1.146763710986412],
            [33.36902500028732, 1.143561207282566],
            [33.36609214731007, 1.140467465336617],
            [33.36473898175991, 1.137174479753184],
            [33.36346665650053, 1.135281608535912],
            [33.35867799553737, 1.127929064661201],
            [33.358726548580165, 1.102135646600761],
            [33.352209417619264, 1.096726233418459],
            [33.34243244332443, 1.08687501814461],
            [33.33503182197654, 1.077303949770289],
            [33.33905923170331, 1.073386077246235],
            [33.34642630187366, 1.069467824272281],
            [33.35006682876712, 1.064666118087079],
            [33.3521696887275, 1.063568283207039],
            [33.3549121608483, 1.063097612928865],
            [33.35345876666866, 1.060838955407355],
            [33.355349662849555, 1.059103165673294],
            [33.358372477610935, 1.057837623082207],
            [33.368718137582896, 1.056035716115942],
            [33.37027383370372, 1.05542877811877],
            [33.37179286598454, 1.056336079672856],
            [33.37402264711479, 1.058519883168099],
            [33.37533067411852, 1.058878750055625],
            [33.37729292707572, 1.061152337345913],
            [33.37934418061965, 1.061929973317401],
            [33.382673903899544, 1.064412817140781],
            [33.38534945153168, 1.065399799918477],
            [33.38671701438084, 1.066386946743189],
            [33.39138416113386, 1.066506026549985],
            [33.39887577104021, 1.069796114767701],
            [33.40734812384455, 1.071141332566348],
            [33.40871573340614, 1.072427653068773],
            [33.41088587538469, 1.072995813352283],
            [33.41394782614975, 1.073563852279049],
            [33.415642162861644, 1.072845573110541],
            [33.41989302851534, 1.072246614063849],
            [33.42548138771072, 1.070121613751073],
            [33.426283912941145, 1.069403455026887],
            [33.42690798694207, 1.068027110758889],
            [33.428186156640706, 1.067428559433798],
            [33.43193172893025, 1.067398111830185],
            [33.43261550855819, 1.067846793614267],
            [33.433026327900556, 1.06908330091106],
            [33.43369979576738, 1.072143610610087],
            [33.43596604131165, 1.076956322769383],
            [33.441058465791514, 1.085423628422183],
            [33.44862351566731, 1.099599226679866],
            [33.45494775228556, 1.110300906368743],
            [33.45744507596192, 1.115388439146162],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1141,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "NAWAIKOKE",
        Population: 22290,
        Key: "KALIRONAWAIKOKE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.5553633778004, 1.182188313841801],
            [33.55387644232467, 1.185318838494338],
            [33.55116541123881, 1.188449611980116],
            [33.549334797403375, 1.189408950753028],
            [33.54604460448759, 1.188982704840984],
            [33.54272654403501, 1.18321325553989],
            [33.53827792774627, 1.177083361142822],
            [33.53561042273088, 1.17489906913626],
            [33.532756678990815, 1.17184088501819],
            [33.53083334374667, 1.168907363167088],
            [33.529406331290296, 1.166597976960901],
            [33.52630356736694, 1.158483543254073],
            [33.522395178127105, 1.154052221028499],
            [33.52251871444498, 1.15124315130287],
            [33.523634819981524, 1.149370246808714],
            [33.52996080831459, 1.146435178441315],
            [33.530952892443004, 1.144749567185845],
            [33.53250339360654, 1.144125045561058],
            [33.53368133018411, 1.141253359643823],
            [33.53740224551572, 1.138256350071503],
            [33.536409264868645, 1.135072956481022],
            [33.53392748653825, 1.130703797894685],
            [33.53442307540242, 1.127395278626476],
            [33.534112623030126, 1.125585064218636],
            [33.53460829364096, 1.122713508110553],
            [33.5365306317551, 1.12046591918934],
            [33.536716567747554, 1.119716806325625],
            [33.53665423634495, 1.118031393293299],
            [33.53566128534227, 1.114910419355999],
            [33.536901300895856, 1.112350841791342],
            [33.538203893092124, 1.112849988183333],
            [33.54080945657371, 1.115908238764015],
            [33.54260840299874, 1.117281212812271],
            [33.54403544869281, 1.119965138570663],
            [33.548129835010535, 1.124271556476113],
            [33.54943290241556, 1.127267615010643],
            [33.550673583620764, 1.12832856952537],
            [33.55147982607984, 1.127953876710516],
            [33.55265748328135, 1.12370888999911],
            [33.55402161007458, 1.121586247931206],
            [33.55408333960597, 1.120025661777631],
            [33.55537633420173, 1.115858756367755],
            [33.55827773177099, 1.11650449196303],
            [33.55974155449277, 1.116211693173695],
            [33.56095812850903, 1.116689977705088],
            [33.56369908876517, 1.119225419266028],
            [33.56517704647795, 1.121773512573405],
            [33.56778555373873, 1.123818687920404],
            [33.568930414347534, 1.125577891657025],
            [33.57108786582602, 1.126645689728287],
            [33.572870956986314, 1.128774801914849],
            [33.57968382411852, 1.140585856899035],
            [33.580221390357586, 1.143209336294269],
            [33.583842866678836, 1.15218827905983],
            [33.59147800221477, 1.162911030717915],
            [33.586009168359524, 1.167833664894695],
            [33.58384603503683, 1.168838319549666],
            [33.581860828327535, 1.16911918762754],
            [33.580671725690976, 1.16983413716336],
            [33.57917385771827, 1.171535258532066],
            [33.57729545081476, 1.17215083595395],
            [33.57122175522755, 1.172568247773705],
            [33.56841700470474, 1.173238292776473],
            [33.56729956337338, 1.172768083756943],
            [33.5646487787004, 1.17366426537891],
            [33.561652916990795, 1.176605111849505],
            [33.560440081762756, 1.176677732510598],
            [33.55879916157263, 1.179473552877904],
            [33.55797858200161, 1.180278892423564],
            [33.55671911073562, 1.180324381540658],
            [33.5553633778004, 1.182188313841801],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1142,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "KISINDA",
        Population: 8182,
        Key: "KALIROKISINDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.56836431581839, 0.963710996652603],
            [33.55744084777758, 0.963928563879],
            [33.55425868266458, 0.963022452682202],
            [33.54815710606592, 0.959820439183312],
            [33.54672373443562, 0.958243781679664],
            [33.54533117416702, 0.955219364707972],
            [33.54409200752139, 0.953552689299284],
            [33.539241581094245, 0.949852911533621],
            [33.53022226118141, 0.947126222772122],
            [33.52668205993549, 0.946669909489089],
            [33.52376421062012, 0.945619579887543],
            [33.514615019470014, 0.9415549104415],
            [33.51161610528507, 0.939061955960576],
            [33.507969518356695, 0.9375114363538],
            [33.50642914030808, 0.941004498916559],
            [33.50321949573053, 0.951459806907278],
            [33.50189126920933, 0.957912876918864],
            [33.49924484495873, 0.958931519141013],
            [33.496904127280786, 0.959133145606165],
            [33.48778636189424, 0.958613518736024],
            [33.486163584977895, 0.960122382548534],
            [33.48439345920212, 0.963030461828128],
            [33.48114794220034, 0.966384308218872],
            [33.47641995704474, 0.968464332911708],
            [33.47639871098995, 0.965129123276624],
            [33.474897932475685, 0.957469146907326],
            [33.47584293679838, 0.95309981783476],
            [33.47548584479485, 0.950251370071072],
            [33.47588934825752, 0.9447218790394],
            [33.47565143664107, 0.943908054851325],
            [33.468532508101646, 0.940949535722538],
            [33.46701182831061, 0.939911761152328],
            [33.46754326983604, 0.938161849853808],
            [33.47030113548753, 0.933230915562953],
            [33.47310686876726, 0.93064558191309],
            [33.47572215741013, 0.926576320588336],
            [33.47848034106523, 0.92413460220818],
            [33.480905758196364, 0.922889666620011],
            [33.48147636177662, 0.921980068710826],
            [33.48000169818601, 0.919826143787139],
            [33.480001576015134, 0.918916624137799],
            [33.48095269516997, 0.918246321850167],
            [33.48290273553083, 0.918724751599483],
            [33.483568168865744, 0.915661016810831],
            [33.48314000305526, 0.914751555384127],
            [33.483252947337625, 0.913285089586807],
            [33.485135133453525, 0.913722210833945],
            [33.489243964681016, 0.912691502519274],
            [33.491838714243215, 0.918607246404865],
            [33.492408730325266, 0.921710286552534],
            [33.49200103801843, 0.924101505391994],
            [33.492422515871624, 0.924838145705533],
            [33.50497524217357, 0.925974898055628],
            [33.50827972099733, 0.926019069635207],
            [33.51269298139318, 0.925393351647104],
            [33.51633574778663, 0.92437426848927],
            [33.51855510127308, 0.922757674514482],
            [33.52418247160628, 0.920712742056776],
            [33.52771612323546, 0.918232359332328],
            [33.5332170529975, 0.912891528353457],
            [33.5367578588096, 0.905681198822415],
            [33.54427808185441, 0.89825850494617],
            [33.549833229435436, 0.907642898918812],
            [33.55272596185545, 0.910564605192025],
            [33.557576973984176, 0.914282127771845],
            [33.55902307833527, 0.9158289210324],
            [33.56077229402621, 0.919583108053225],
            [33.56488734069715, 0.934385980322433],
            [33.56703884263353, 0.940715636976841],
            [33.56729476726807, 0.942814471899094],
            [33.56808842792328, 0.952802102535287],
            [33.56836431581839, 0.963710996652603],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1143,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "KASOKWE",
        Population: 15139,
        Key: "KALIROKASOKWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.595192489202226, 1.157293223062983],
            [33.59147800221477, 1.162911030717915],
            [33.583842866678836, 1.15218827905983],
            [33.580221390357586, 1.143209336294269],
            [33.57968382411852, 1.140585856899035],
            [33.572870956986314, 1.128774801914849],
            [33.57108786582602, 1.126645689728287],
            [33.568930414347534, 1.125577891657025],
            [33.56778555373873, 1.123818687920404],
            [33.56517704647795, 1.121773512573405],
            [33.56369908876517, 1.119225419266028],
            [33.56095812850903, 1.116689977705088],
            [33.55974155449277, 1.116211693173695],
            [33.55827773177099, 1.11650449196303],
            [33.55537633420173, 1.115858756367755],
            [33.55306950906115, 1.1154762094738],
            [33.55164235646759, 1.11389666022121],
            [33.55030960513228, 1.10841541938217],
            [33.548239899294074, 1.104250828275849],
            [33.546312593496395, 1.098482449875116],
            [33.545979535019974, 1.097788347650217],
            [33.544530417719415, 1.096795909256006],
            [33.54468789957524, 1.094435406622994],
            [33.54404497712302, 1.092888502094419],
            [33.54464968883631, 1.09125994663775],
            [33.545696581875156, 1.087936823300958],
            [33.54540024203596, 1.087141928743753],
            [33.54204275901716, 1.083863372691269],
            [33.541351412879564, 1.082621389046899],
            [33.54115269745387, 1.075566249077285],
            [33.543619380494235, 1.071656996642941],
            [33.54451618301541, 1.071155350123052],
            [33.54695708171216, 1.067577642213498],
            [33.547703931157905, 1.064434860688308],
            [33.554296913166446, 1.059953732879911],
            [33.56469679275402, 1.055644167449528],
            [33.56862050815091, 1.054955331280576],
            [33.568994978961925, 1.054527435612461],
            [33.57346596779284, 1.055579719775948],
            [33.580505605635395, 1.058354783027566],
            [33.58345446209944, 1.058545699037925],
            [33.589541821062106, 1.055768160620255],
            [33.5993388241945, 1.052319739953786],
            [33.60342904682088, 1.052031733845997],
            [33.60656792840857, 1.051169487440987],
            [33.61080614039318, 1.051592799341117],
            [33.61648195327639, 1.063580845778222],
            [33.6203991918201, 1.070374194802124],
            [33.62990299742018, 1.08284774383897],
            [33.636556948985394, 1.088898625927281],
            [33.63121740246244, 1.095992429820357],
            [33.62632972469709, 1.104262223085257],
            [33.623264505861044, 1.110677044760611],
            [33.6210288955629, 1.114024831872053],
            [33.61683257830822, 1.116386934695041],
            [33.61559562511144, 1.119155516725591],
            [33.61440718093999, 1.120187103094852],
            [33.61298087725439, 1.120069796556422],
            [33.612124890586465, 1.120639925509371],
            [33.61000887659536, 1.121101758027734],
            [33.606454645461326, 1.123617517468141],
            [33.60533655913958, 1.125345693213848],
            [33.60296977774199, 1.130186235481801],
            [33.598840202617964, 1.148525013164144],
            [33.59779321166273, 1.151800185601653],
            [33.595192489202226, 1.157293223062983],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1144,
        District: "KALIRO",
        County: "BULAMOGI",
        Subcounty: "NAMWIWA",
        Population: 27460,
        Key: "KALIRONAMWIWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [34.24554344018208, 0.818649847609593],
              [34.242321936944485, 0.818603911556709],
              [34.24195759463827, 0.81784479757019],
              [34.24151977553174, 0.817770756984137],
              [34.23835138788022, 0.818487340994435],
              [34.23755369558605, 0.818094884617342],
              [34.23631401420575, 0.818165085291121],
              [34.2342417131347, 0.817026883005917],
              [34.22643999221581, 0.816629939856994],
              [34.2225005940307, 0.817417358005533],
              [34.21898127053032, 0.817571700707628],
              [34.212675531122066, 0.815149873853692],
              [34.20430993949601, 0.815298962928675],
              [34.201314607792426, 0.813667678513899],
              [34.20142732929258, 0.81280435962926],
              [34.20299537545193, 0.811540824676071],
              [34.20462255411318, 0.811350875197332],
              [34.205529555207775, 0.81044840217213],
              [34.207912863809995, 0.81011263112544],
              [34.21072983321728, 0.809022856205828],
              [34.21446233591772, 0.808662743121646],
              [34.21762289834479, 0.80778107600545],
              [34.22081364416541, 0.804985120240801],
              [34.221172857989615, 0.804279480528767],
              [34.22397653053407, 0.802939933153674],
              [34.22589622041479, 0.799646879571172],
              [34.22796271028425, 0.798994997881403],
              [34.227438549604166, 0.796471531701229],
              [34.22809563848841, 0.794644194117867],
              [34.22969074190414, 0.793305019061772],
              [34.230561392670786, 0.792002243423149],
              [34.23203936924816, 0.791504311687441],
              [34.23247499377048, 0.790916240746397],
              [34.234571858374665, 0.78665531083986],
              [34.23438503215175, 0.785379989341851],
              [34.23468413970034, 0.78462010120884],
              [34.235765315145386, 0.783064000949897],
              [34.23779665842934, 0.78134480458363],
              [34.241595925718364, 0.779724581015678],
              [34.24400218717439, 0.77725452554652],
              [34.2468385539036, 0.776457705103291],
              [34.249020936326204, 0.774675154554884],
              [34.25304760224794, 0.772700159408136],
              [34.25378720318765, 0.773752918691632],
              [34.25710653834961, 0.775766289452484],
              [34.26017107805931, 0.779612585842752],
              [34.261100593629884, 0.783688157642781],
              [34.261002364650174, 0.785437822835607],
              [34.25960085805964, 0.788142232555573],
              [34.257973056865936, 0.789444590830356],
              [34.25765670795209, 0.790583243630336],
              [34.25792879238029, 0.79267810265322],
              [34.25930867652191, 0.795352686464524],
              [34.26081540278167, 0.800880812636259],
              [34.262756547126294, 0.803047919807678],
              [34.25631885328767, 0.80116131920285],
              [34.25330491837286, 0.803877584205858],
              [34.25094803371476, 0.807950048482167],
              [34.249976129340844, 0.814700027793216],
              [34.24554344018208, 0.818649847609593],
            ],
          ],
          [
            [
              [34.306591808725386, 0.822938165932158],
              [34.311133120371686, 0.82532602988875],
              [34.313012661847395, 0.827161819361446],
              [34.31665057105011, 0.828101999552136],
              [34.31712103583239, 0.82893708853078],
              [34.31673407125242, 0.829688940981265],
              [34.31684502756304, 0.830663359853868],
              [34.32024777489239, 0.833056585125749],
              [34.32117915895872, 0.835715828402118],
              [34.323854107414554, 0.838798684362728],
              [34.32452063040592, 0.840236596221282],
              [34.32496527131871, 0.849125842372393],
              [34.319584361868536, 0.850411561127779],
              [34.315950930767485, 0.850898959329664],
              [34.31268523850273, 0.850784335261035],
              [34.312156235903295, 0.850599323368059],
              [34.31194835406845, 0.847925575954739],
              [34.3106818220443, 0.847455803988867],
              [34.3090495625118, 0.846184076680797],
              [34.308177577746974, 0.844981875489511],
              [34.30542967171703, 0.843812390613896],
              [34.30699123024341, 0.842411470494793],
              [34.30730063068851, 0.841673100042393],
              [34.305330516574315, 0.839218134658525],
              [34.30308425674848, 0.834388863025256],
              [34.30081996863321, 0.831933028994497],
              [34.30377635657259, 0.829273647535575],
              [34.30589064669668, 0.825273394074041],
              [34.306591808725386, 0.822938165932158],
            ],
          ],
          [
            [
              [34.31739237735386, 0.86619076453042],
              [34.31168193531474, 0.869056878213422],
              [34.31245614834235, 0.873543757712596],
              [34.31114934574236, 0.875757881012858],
              [34.310199615382935, 0.8792881101009],
              [34.310200096879946, 0.880664171297085],
              [34.31156803252997, 0.883296147792685],
              [34.31275834340056, 0.887842702366765],
              [34.311914680720015, 0.889968015038153],
              [34.307879506854235, 0.890141873761499],
              [34.30631021832483, 0.889603975349143],
              [34.30374316292455, 0.887175949454603],
              [34.2967074327535, 0.884920534222545],
              [34.296330373896154, 0.884403340548145],
              [34.296370158483434, 0.882679311112835],
              [34.29479989079039, 0.879317468078398],
              [34.29519164069591, 0.877797672151891],
              [34.29460240066674, 0.876068133633733],
              [34.29424513439003, 0.874472054052117],
              [34.29465682689488, 0.868835012669454],
              [34.29439938410747, 0.863907836081353],
              [34.292781993489555, 0.860604962898971],
              [34.29047568128701, 0.858392065781397],
              [34.288488037448325, 0.857319340663197],
              [34.28987570818682, 0.85678485615864],
              [34.29034678382353, 0.857052141534545],
              [34.29051574255541, 0.856711700151412],
              [34.291095597884805, 0.857258549490278],
              [34.29186830084442, 0.856662613606903],
              [34.293390570653514, 0.858534204625942],
              [34.29409092869005, 0.858278675184874],
              [34.29440509829101, 0.858813455891562],
              [34.29522629680123, 0.858801020113555],
              [34.295238227326514, 0.858363380403918],
              [34.29637380923677, 0.859517863381835],
              [34.29730348919902, 0.858885401963872],
              [34.29878905564227, 0.859367723281425],
              [34.299928109541035, 0.859131491132105],
              [34.3000009862668, 0.859627544317003],
              [34.30071997266737, 0.859505312634696],
              [34.300994968535406, 0.860424185660348],
              [34.30318299417461, 0.861355201416713],
              [34.304364631811154, 0.860742718377251],
              [34.30605185656093, 0.86104386434212],
              [34.30701935290171, 0.86031937845732],
              [34.30778161204785, 0.860491530152109],
              [34.30782422902325, 0.859888062349079],
              [34.30881723392481, 0.858637697790245],
              [34.31138617129565, 0.857817831837636],
              [34.31144641860682, 0.858679892310291],
              [34.31227740695701, 0.859489957662757],
              [34.31466698579991, 0.860092583902151],
              [34.3159095893998, 0.860925301908873],
              [34.31614807324313, 0.862001565873919],
              [34.3168609358284, 0.86259828236979],
              [34.31739237735386, 0.86619076453042],
            ],
          ],
          [
            [
              [34.34277077766693, 1.002052554814554],
              [34.343002618468724, 1.000315410924247],
              [34.34030830503033, 0.99944260057834],
              [34.34006288978628, 0.998187838520997],
              [34.33943961259102, 0.998479403566293],
              [34.3396838726016, 0.996888316117139],
              [34.339036844848536, 0.993504933073689],
              [34.33905826787145, 0.991420954869167],
              [34.33640858004143, 0.99077219432015],
              [34.333538573201444, 0.995904867102264],
              [34.33195761016659, 0.995390121240314],
              [34.331823637221774, 0.99442661676336],
              [34.330175746105006, 0.993575770751946],
              [34.32986988322548, 0.99303005436968],
              [34.33075746993016, 0.991770622924871],
              [34.33348443353587, 0.992147235463746],
              [34.33413225450133, 0.991814250256141],
              [34.3351208028608, 0.99062685875446],
              [34.34393802698756, 0.983883503722319],
              [34.34575159259555, 0.983568000817291],
              [34.34941486034043, 0.979499738059286],
              [34.34936153185357, 0.97825344462935],
              [34.35023937004079, 0.976930918208622],
              [34.352220737350585, 0.976890389419896],
              [34.35629749962076, 0.980563387164948],
              [34.35582413777168, 0.985059887712315],
              [34.35613864334254, 0.993360432935712],
              [34.355244175542786, 0.994683074983314],
              [34.355488177736895, 0.997152900871365],
              [34.35566421070165, 0.998654045463477],
              [34.35485780025761, 0.999193398216569],
              [34.354227500033474, 0.998434617672398],
              [34.35135477758636, 0.999435058572483],
              [34.347999227742044, 0.998518870444308],
              [34.346118769984756, 0.998442783914875],
              [34.34609550541553, 0.999908039400182],
              [34.34555124403266, 0.999471092600379],
              [34.34512660410965, 0.99978353389533],
              [34.34538954368826, 1.000869148626949],
              [34.34277077766693, 1.002052554814554],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1147,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "KAATO",
        Population: 4351,
        Key: "MANAFWAKAATO",
        Dist2: "Manafwa",
        "Sub Country": "Kaato",
        id2_original: "Manafwa Kaato",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30413102042994, 0.912317098060606],
            [34.3029540666093, 0.912942387203234],
            [34.300565086044394, 0.912433196877993],
            [34.300203515040835, 0.913453457391318],
            [34.29933509748602, 0.914109570796925],
            [34.29696259382005, 0.914158670053801],
            [34.2952819231786, 0.915641245619803],
            [34.293436329935794, 0.916479882824479],
            [34.29130044970218, 0.91527836268863],
            [34.28608813516619, 0.914260119154726],
            [34.28558105325632, 0.913240168749829],
            [34.28604994239359, 0.911229853835493],
            [34.2872450215217, 0.910543500143228],
            [34.288872859546366, 0.908029013728412],
            [34.28324920823841, 0.899921470741025],
            [34.28342106134217, 0.897050343720746],
            [34.28382101286622, 0.896358660092872],
            [34.28532532086122, 0.897439033012468],
            [34.28698615041301, 0.897912076285844],
            [34.28759499257998, 0.897716834363484],
            [34.2894485969985, 0.89543159168854],
            [34.29002898862209, 0.893035359847108],
            [34.2896659524663, 0.891987296810663],
            [34.2916516523507, 0.889303445152794],
            [34.29255391932375, 0.885976625650507],
            [34.29145432751708, 0.882463843417813],
            [34.292301670595364, 0.88057169437421],
            [34.29094130504821, 0.878650812439821],
            [34.292639385039905, 0.877032614638464],
            [34.29460240066674, 0.876068133633733],
            [34.29519164069591, 0.877797672151891],
            [34.29479989079039, 0.879317468078398],
            [34.296370158483434, 0.882679311112835],
            [34.296330373896154, 0.884403340548145],
            [34.2967074327535, 0.884920534222545],
            [34.30374316292455, 0.887175949454603],
            [34.30631021832483, 0.889603975349143],
            [34.307879506854235, 0.890141873761499],
            [34.311914680720015, 0.889968015038153],
            [34.31275834340056, 0.887842702366765],
            [34.31156803252997, 0.883296147792685],
            [34.310200096879946, 0.880664171297085],
            [34.310199615382935, 0.8792881101009],
            [34.31114934574236, 0.875757881012858],
            [34.31245614834235, 0.873543757712596],
            [34.31168193531474, 0.869056878213422],
            [34.31739237735386, 0.86619076453042],
            [34.31735719573407, 0.866678286470553],
            [34.3177488809609, 0.866779846460076],
            [34.31840929720496, 0.867644809720773],
            [34.31822031682201, 0.869138047830101],
            [34.31899099408067, 0.869923621208769],
            [34.31841075337402, 0.870296069181223],
            [34.318482896176185, 0.870964271227908],
            [34.31977227864619, 0.87166564769353],
            [34.32023421302654, 0.873442266169208],
            [34.32155448227095, 0.875224440135007],
            [34.32191269896525, 0.876603756143932],
            [34.32287780758398, 0.877275822066261],
            [34.322807326665114, 0.878363778754525],
            [34.32320996684681, 0.879033959018667],
            [34.322198379395246, 0.883269580580485],
            [34.32369691571456, 0.885931743998483],
            [34.32384164688325, 0.88863611854974],
            [34.32429360906562, 0.889875106309793],
            [34.322820720546, 0.890336930157881],
            [34.320524472169545, 0.890264480794416],
            [34.31981890659934, 0.890691108362701],
            [34.31786164917346, 0.897417977288663],
            [34.31583049543399, 0.898967946620154],
            [34.31449617474188, 0.902700486499704],
            [34.31304877232519, 0.903648271919003],
            [34.311730804564505, 0.905689456901343],
            [34.30840216644947, 0.907524396357059],
            [34.307693812508596, 0.90838651895446],
            [34.306380250086086, 0.908882216158762],
            [34.30413102042994, 0.912317098060606],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1148,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUKUSU",
        Population: 12578,
        Key: "MANAFWABUKUSU",
        Dist2: "Manafwa",
        "Sub Country": "Bukusu",
        id2_original: "Manafwa Bukusu",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.304124560644716, 0.820585638441654],
            [34.300347035280545, 0.815064933265067],
            [34.298264092766644, 0.813215943321232],
            [34.29285989269606, 0.809879041291878],
            [34.29189289851351, 0.808686605388519],
            [34.28967941731409, 0.809880064370791],
            [34.2866858759529, 0.809410203459831],
            [34.28531369486482, 0.808751491423922],
            [34.28181887560876, 0.803493441299143],
            [34.28144277525381, 0.80207699104164],
            [34.27930969596724, 0.805307286273539],
            [34.27535851637716, 0.809287204030625],
            [34.27437798727826, 0.809766151405728],
            [34.272981244453675, 0.809706766120016],
            [34.27262449291164, 0.809258156310418],
            [34.27015807487432, 0.809707659854475],
            [34.267708883829165, 0.809327699636765],
            [34.26635362520441, 0.807794309569199],
            [34.26449747046883, 0.806852059601613],
            [34.262756547126294, 0.803047919807678],
            [34.26081540278167, 0.800880812636259],
            [34.25930867652191, 0.795352686464524],
            [34.25792879238029, 0.79267810265322],
            [34.25765670795209, 0.790583243630336],
            [34.257973056865936, 0.789444590830356],
            [34.25960085805964, 0.788142232555573],
            [34.261002364650174, 0.785437822835607],
            [34.261100593629884, 0.783688157642781],
            [34.26017107805931, 0.779612585842752],
            [34.25710653834961, 0.775766289452484],
            [34.25378720318765, 0.773752918691632],
            [34.25304760224794, 0.772700159408136],
            [34.25735671376634, 0.77119932757783],
            [34.26063416407983, 0.769362185531448],
            [34.26278271594884, 0.767643640210745],
            [34.26862508546889, 0.762096570515634],
            [34.27193828513747, 0.759671497494906],
            [34.28254674455084, 0.758311571076985],
            [34.28570572504469, 0.757569164983213],
            [34.28507494062859, 0.75979145336156],
            [34.28577139638354, 0.760432489530597],
            [34.28502184480541, 0.762687991395289],
            [34.28704227535533, 0.767147231695439],
            [34.28802492447833, 0.771105939993531],
            [34.283676273612684, 0.772853311826106],
            [34.28220984397997, 0.772995688130907],
            [34.282265999465, 0.772172483966431],
            [34.28119334993033, 0.768851678528615],
            [34.27704881965342, 0.772457929154977],
            [34.274172549759314, 0.773395533175721],
            [34.27152205793708, 0.774900786231519],
            [34.27149396671985, 0.775269811822661],
            [34.273157959239754, 0.775609936735638],
            [34.275386398286976, 0.777340793603743],
            [34.276257941979, 0.782449061815982],
            [34.27983668364552, 0.783178074538169],
            [34.28056354557619, 0.788045278474459],
            [34.28361202879854, 0.79422595806697],
            [34.28807040618117, 0.794500663426604],
            [34.2897668566289, 0.793605561144889],
            [34.29291174255595, 0.790607492241114],
            [34.294312930244544, 0.797242550306222],
            [34.29869261520831, 0.801648524038771],
            [34.29976452183624, 0.802292839538775],
            [34.29980027298792, 0.803233076734972],
            [34.298886102439035, 0.803292715415122],
            [34.29836386145871, 0.804012255358122],
            [34.3002335502124, 0.804758261423346],
            [34.30200303099779, 0.80699768632035],
            [34.30253600954068, 0.808395118528171],
            [34.303602517293754, 0.812893905464457],
            [34.304124560644716, 0.820585638441654],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1149,
        District: "MANAFWA",
        County: "BUBULO",
        Subcounty: "BUNABWANA",
        Population: 9594,
        Key: "MANAFWABUNABWANA",
        Dist2: "Manafwa",
        "Sub Country": "Bunabwana",
        id2_original: "Manafwa Bunabwana",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.75687254156093, 0.57511972714875],
            [33.74773164725078, 0.578867877980184],
            [33.74449615544755, 0.579284119853316],
            [33.74007875920817, 0.577701589076164],
            [33.737825397301705, 0.574674857102931],
            [33.73808183038271, 0.574481948206264],
            [33.73774513911929, 0.573962016855939],
            [33.73574201371499, 0.571917747516819],
            [33.735688951129475, 0.571490850718664],
            [33.73954411518872, 0.571064749756612],
            [33.740186010866594, 0.570466271505273],
            [33.739525546113484, 0.56529622243428],
            [33.73786822088964, 0.561351053717889],
            [33.738337106433654, 0.560591080380058],
            [33.741189431733865, 0.558102906040303],
            [33.74316412635773, 0.557478439424531],
            [33.7455954984209, 0.557297196722915],
            [33.74810536347697, 0.55603035528418],
            [33.74969311777534, 0.555916059926951],
            [33.74875371175349, 0.561056519248632],
            [33.74956097290211, 0.561781485065667],
            [33.74945619520399, 0.564537338315875],
            [33.75470743643617, 0.570649327405419],
            [33.75687254156093, 0.57511972714875],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1151,
        District: "BUGIRI",
        County: "BUGIRI MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 14923,
        Key: "BUGIRIWESTERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.86181393157943, 0.156294614700421],
            [33.84361768143881, 0.174883171244767],
            [33.83277698865985, 0.191255399302235],
            [33.82896187598757, 0.199256853681139],
            [33.827512040933065, 0.200351668776664],
            [33.82559623267273, 0.20269764146058],
            [33.82448303408442, 0.204887182182074],
            [33.823235022626505, 0.209866267743493],
            [33.817591253547754, 0.21173841239629],
            [33.80709207059544, 0.211853863986125],
            [33.80275541403548, 0.211337087388485],
            [33.80193480841331, 0.207396156040008],
            [33.791872179739606, 0.186004295225636],
            [33.78157614450056, 0.183807324823857],
            [33.78346888851598, 0.172879721791567],
            [33.78889127587781, 0.155439097423782],
            [33.79913439405839, 0.143154628234215],
            [33.803954774534226, 0.139969698845221],
            [33.80907647241424, 0.137998005903787],
            [33.81480074850876, 0.13678456780168],
            [33.82338721520195, 0.136935921817147],
            [33.83528783377789, 0.140120229986008],
            [33.839807063936206, 0.141788253588854],
            [33.84703788483076, 0.146034279199947],
            [33.857432195761895, 0.152554952535985],
            [33.86181393157943, 0.156294614700421],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1152,
        District: "NAMAYINGO",
        County: "BUKOOLI",
        Subcounty: "BUKANA",
        Population: 8538,
        Key: "NAMAYINGOBUKANA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.619748907674136, 0.906621063110629],
            [33.616220878600316, 0.907186475457148],
            [33.613637790068836, 0.907010684612737],
            [33.60488463558476, 0.903966685067384],
            [33.60230431116941, 0.90358006593275],
            [33.598013955575816, 0.90335669886375],
            [33.592580435392705, 0.904671539403149],
            [33.58968685765798, 0.906953592152288],
            [33.58750161320289, 0.909398496495205],
            [33.580410035668926, 0.91961583575139],
            [33.57683881829122, 0.923988062926392],
            [33.57403281551693, 0.925827511849125],
            [33.56488734069715, 0.934385980322433],
            [33.56077229402621, 0.919583108053225],
            [33.55902307833527, 0.9158289210324],
            [33.557576973984176, 0.914282127771845],
            [33.55272596185545, 0.910564605192025],
            [33.549833229435436, 0.907642898918812],
            [33.54427808185441, 0.89825850494617],
            [33.5432261196224, 0.896799243266624],
            [33.55677503445529, 0.887217622694043],
            [33.56104124513067, 0.883423041303322],
            [33.56551946090807, 0.870823653520895],
            [33.56893213731624, 0.865955457065563],
            [33.57040749350794, 0.864434084770566],
            [33.5727895543502, 0.863055740671567],
            [33.57517170951558, 0.862321647877304],
            [33.57751856538189, 0.863305560748709],
            [33.58171477034716, 0.867080935359095],
            [33.584274927584396, 0.867814266446863],
            [33.59878186332846, 0.868026724176244],
            [33.6021240678009, 0.867596690691876],
            [33.60560826897033, 0.865770762077357],
            [33.60816865168471, 0.867953628565273],
            [33.6151026063273, 0.871245310816133],
            [33.61599163572636, 0.872032575087518],
            [33.616933408808954, 0.869204896354286],
            [33.618818173988025, 0.871029947553752],
            [33.62376064179918, 0.872174449346901],
            [33.62724506575079, 0.871815950781497],
            [33.63154716412178, 0.870813067199769],
            [33.63577840338315, 0.871349217709278],
            [33.637556505300324, 0.873174270564748],
            [33.64207335941471, 0.880546494216987],
            [33.64595170449985, 0.884599087070998],
            [33.64485210550667, 0.885216774035016],
            [33.642122499955704, 0.889683479243262],
            [33.63805007475172, 0.891974567429184],
            [33.63385239565105, 0.893670178679413],
            [33.632111978958335, 0.894872930228236],
            [33.62542199506881, 0.901048813297673],
            [33.62391867701726, 0.903505222220645],
            [33.622142305255295, 0.905353581038745],
            [33.619748907674136, 0.906621063110629],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1153,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "224109",
        Population: 16813,
        Key: "NAMUTUMBA224109",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.671402108376235, 0.95460118507842],
            [33.669802870015275, 0.956020431930625],
            [33.66581253465858, 0.957499313511732],
            [33.66171368281559, 0.958160278782948],
            [33.654238068311145, 0.95795368886404],
            [33.64422042726686, 0.969328320394262],
            [33.63627300499881, 0.965817158446626],
            [33.633681216283776, 0.963383115723159],
            [33.6325407071142, 0.961644378113008],
            [33.63076160537213, 0.963174988421565],
            [33.623575244795916, 0.96474138185058],
            [33.61797882681411, 0.969611489916504],
            [33.614420311614495, 0.971107646701163],
            [33.60661302473412, 0.978482259779799],
            [33.60184554245211, 0.981961048783749],
            [33.60198480018578, 0.987803932991899],
            [33.602676524514116, 0.991629519630686],
            [33.60254097322933, 1.006167257895835],
            [33.602195557527835, 1.006723789733531],
            [33.591760585253716, 1.013502409646452],
            [33.58760420619823, 1.009694449169219],
            [33.58337516062277, 1.004692304897498],
            [33.57681582411488, 0.99182883401609],
            [33.57603637031591, 0.989892940591623],
            [33.5748737886415, 0.984519302145572],
            [33.57330068317046, 0.982432956082982],
            [33.570698697678665, 0.979309023946695],
            [33.570142374616466, 0.978051602839276],
            [33.56961253388884, 0.973944409622704],
            [33.56987693502643, 0.972922066884393],
            [33.57170265034859, 0.970198645260301],
            [33.57180023793118, 0.96929394050061],
            [33.56836431581839, 0.963710996652603],
            [33.56808842792328, 0.952802102535287],
            [33.56729476726807, 0.942814471899094],
            [33.56703884263353, 0.940715636976841],
            [33.56488734069715, 0.934385980322433],
            [33.57403281551693, 0.925827511849125],
            [33.57683881829122, 0.923988062926392],
            [33.580410035668926, 0.91961583575139],
            [33.58750161320289, 0.909398496495205],
            [33.58968685765798, 0.906953592152288],
            [33.592580435392705, 0.904671539403149],
            [33.598013955575816, 0.90335669886375],
            [33.60230431116941, 0.90358006593275],
            [33.60488463558476, 0.903966685067384],
            [33.613637790068836, 0.907010684612737],
            [33.616220878600316, 0.907186475457148],
            [33.619748907674136, 0.906621063110629],
            [33.62376725339969, 0.906355200454003],
            [33.62867411468792, 0.915998205780265],
            [33.632075376203765, 0.920988210789943],
            [33.633133923985135, 0.921877012052741],
            [33.635028315510795, 0.922097585470906],
            [33.63665498752222, 0.922772815451377],
            [33.63944714456304, 0.926184638952492],
            [33.64398211679839, 0.927326035450695],
            [33.64767818922081, 0.932993635491431],
            [33.65090585220634, 0.936394610594281],
            [33.653632135787376, 0.940518080053489],
            [33.65554895914403, 0.942373629437691],
            [33.65790083569441, 0.943877112089095],
            [33.66279474597119, 0.943886693118],
            [33.66465349054977, 0.946877153968587],
            [33.668318138106926, 0.94998851245185],
            [33.67021531440999, 0.9537110098094],
            [33.671402108376235, 0.95460118507842],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1154,
        District: "NAMUTUMBA",
        County: "BUSIKI",
        Subcounty: "224108",
        Population: 16661,
        Key: "NAMUTUMBA224108",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.347017550596206, 1.325703836362922],
            [34.345379247198466, 1.326126873578677],
            [34.342876925295855, 1.327469666392134],
            [34.34085317636929, 1.327525496071721],
            [34.33342972074519, 1.329590737108139],
            [34.331847490187506, 1.330619154894841],
            [34.330639045026274, 1.330224598145224],
            [34.31951751553329, 1.330753522784236],
            [34.31896730730324, 1.329890425088534],
            [34.31835822169282, 1.329696328088334],
            [34.31857708633035, 1.326647009639885],
            [34.317592563321675, 1.324702884161493],
            [34.317530061239154, 1.323346182247721],
            [34.31998435651172, 1.32187054736069],
            [34.32105939646338, 1.319744421047015],
            [34.32327171254787, 1.313158558722719],
            [34.3254650112978, 1.311569507371822],
            [34.32809908910313, 1.310185343089349],
            [34.330397396418206, 1.310622182843117],
            [34.331625159849644, 1.310222440995412],
            [34.33257286540637, 1.310937027314777],
            [34.33439282522254, 1.310680028192787],
            [34.33594579046491, 1.311438427213748],
            [34.33750184681017, 1.309764626500102],
            [34.339006199720956, 1.309834441487244],
            [34.34073465444732, 1.310707510346419],
            [34.342616127300886, 1.310675594370568],
            [34.34405962743599, 1.311773934604258],
            [34.346349249838894, 1.312258248369557],
            [34.34805300718318, 1.313086540839578],
            [34.349509665840564, 1.31287709614445],
            [34.351367583070754, 1.313874225490626],
            [34.352490373869635, 1.316062225431602],
            [34.35696102313739, 1.316878210276506],
            [34.358493766404365, 1.318247452883811],
            [34.36042517570629, 1.317446043392217],
            [34.361611666940284, 1.318232171196513],
            [34.362317247781874, 1.318118728733908],
            [34.36641093610863, 1.316989667145193],
            [34.370125184144186, 1.316756274627969],
            [34.369756813792264, 1.317218178587217],
            [34.36615816096747, 1.317972269340377],
            [34.36481705799494, 1.319661396522171],
            [34.363612693880064, 1.320414162769924],
            [34.361142367272905, 1.320829950715509],
            [34.3599076508812, 1.321859015163908],
            [34.35864208903759, 1.322258787476937],
            [34.35678099266961, 1.321246779462115],
            [34.35476791123701, 1.321186491589514],
            [34.35132050955322, 1.319684178041849],
            [34.34874305166194, 1.319424655325844],
            [34.34738540890842, 1.318765387612594],
            [34.34367987992099, 1.319366022565213],
            [34.34276542999608, 1.32044095778764],
            [34.34291000126461, 1.322256779378819],
            [34.34491317068634, 1.323951363946868],
            [34.34654069879227, 1.324652332406294],
            [34.347017550596206, 1.325703836362922],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1155,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "KASEREM",
        Population: 4710,
        Key: "KAPCHORWAKASEREM",
        Dist2: "Kapchorwa",
        "Sub Country": "Kaserem",
        id2_original: "Kapchorwa Kaserem",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.38385862820781, 1.393471630743627],
            [34.3810691176038, 1.393529435502998],
            [34.378234235789755, 1.394566114996276],
            [34.37681337140318, 1.394312689089099],
            [34.36865225520037, 1.39533454863432],
            [34.367707403591275, 1.395879529553417],
            [34.36689683394748, 1.397345770520788],
            [34.365087120315444, 1.397989974491678],
            [34.36414794336399, 1.398867736220831],
            [34.36222047766622, 1.399064927699985],
            [34.361307544995796, 1.398358605163598],
            [34.359458800462974, 1.398638977452423],
            [34.35817007016986, 1.397571429353335],
            [34.356675670592416, 1.397173018381368],
            [34.35366453033648, 1.397542113472388],
            [34.35347900307747, 1.396526939959291],
            [34.351684128715625, 1.394962283083516],
            [34.34973143383308, 1.39249418794316],
            [34.3484143545062, 1.392612530274403],
            [34.34557684871319, 1.393808078724409],
            [34.34071241305921, 1.394362610751206],
            [34.33883935472492, 1.393658189768777],
            [34.33616443681181, 1.390367402533982],
            [34.33295242068193, 1.387836676946792],
            [34.331268612225145, 1.38705977582789],
            [34.32801568232563, 1.388832493113487],
            [34.32731430739621, 1.388115105308012],
            [34.3268617083083, 1.386655554477854],
            [34.327812270507636, 1.385649904617065],
            [34.32933370668019, 1.385002900739356],
            [34.33068818736389, 1.383446604289291],
            [34.33153848050954, 1.380675995580307],
            [34.33106874336264, 1.378387615162626],
            [34.33280546258963, 1.377502610195643],
            [34.33344894648891, 1.376612527291251],
            [34.33530320308431, 1.376214452256053],
            [34.33636649936023, 1.375320004316244],
            [34.33996767465437, 1.375121518554865],
            [34.34052701695425, 1.374451753256998],
            [34.3403819408325, 1.372769066285383],
            [34.33948208134441, 1.371899216654396],
            [34.338294886729514, 1.372900618228422],
            [34.33722998965574, 1.372512784920808],
            [34.33529935559994, 1.370893160025761],
            [34.334579745768536, 1.369179091478901],
            [34.33431225532473, 1.366795052203172],
            [34.33762345624178, 1.362078398535468],
            [34.33911204102434, 1.358528076091749],
            [34.34061229312584, 1.358432583278451],
            [34.341839060325604, 1.357778374963772],
            [34.34315424420721, 1.357799791073411],
            [34.34379108416665, 1.357325485313721],
            [34.344237102196786, 1.35563923990255],
            [34.34768114597807, 1.354357958395683],
            [34.34848403592448, 1.353690654300129],
            [34.349726122993104, 1.351044070926664],
            [34.35146086233322, 1.349200410797867],
            [34.35357492698014, 1.345346332255913],
            [34.351143068928415, 1.346289385733534],
            [34.35075213379486, 1.345958227881677],
            [34.35002929002844, 1.341737034300067],
            [34.35210736277521, 1.339379338055019],
            [34.35423040159183, 1.336115011846658],
            [34.35589604252028, 1.335027258081697],
            [34.356216090696435, 1.333443654974914],
            [34.35741843090702, 1.333050627196365],
            [34.36159406984218, 1.333940587808192],
            [34.363505358678346, 1.335108586531793],
            [34.3632795042496, 1.336399076190999],
            [34.363755045411544, 1.33800963028057],
            [34.36226119290813, 1.340123208297973],
            [34.36619518054032, 1.338650001054974],
            [34.37041325139794, 1.335859930919365],
            [34.37326908102611, 1.334921831677077],
            [34.3744987470893, 1.335950897440973],
            [34.37920684444282, 1.337029512927527],
            [34.38002297555652, 1.338365110746567],
            [34.379727394793775, 1.339583302281693],
            [34.3781475869924, 1.341288817908949],
            [34.37729251121616, 1.340980848425647],
            [34.37592994479659, 1.341768993880705],
            [34.37522123602116, 1.343595774149773],
            [34.375037080489584, 1.345990464011841],
            [34.3739494371745, 1.348044745664821],
            [34.37251591732222, 1.349542093543678],
            [34.37113422756687, 1.349583039969461],
            [34.37060303667136, 1.350757347316715],
            [34.369261264453996, 1.351621208195487],
            [34.36933778384822, 1.354387601702788],
            [34.37096270594147, 1.355618995747121],
            [34.3744562531831, 1.35664471647225],
            [34.37557131577559, 1.358333292553595],
            [34.37829949210694, 1.357185192566724],
            [34.38334583660596, 1.356880853271748],
            [34.38342169573845, 1.357219512952716],
            [34.38643412507685, 1.358261954929943],
            [34.38663120107715, 1.358740356569815],
            [34.38496000317033, 1.360033260272258],
            [34.383722686155856, 1.360484051541648],
            [34.38237147264486, 1.361814128670087],
            [34.38187352031319, 1.363981064015963],
            [34.38187239472413, 1.366282066978818],
            [34.38078656331096, 1.369005141074471],
            [34.37939585626681, 1.369964683556125],
            [34.37666336263221, 1.371006406953408],
            [34.37457782578375, 1.371278029106417],
            [34.37346735448066, 1.372100135521777],
            [34.37335435899433, 1.372739117865091],
            [34.37377425221938, 1.373537519559342],
            [34.37524763840568, 1.374482888886922],
            [34.378173902240334, 1.375679894144458],
            [34.37876374863228, 1.376318465118427],
            [34.37865713567606, 1.376868876467996],
            [34.37936810640937, 1.378296651135243],
            [34.380562474970084, 1.379077584696149],
            [34.38093677240625, 1.380157126587349],
            [34.380506495554854, 1.382038669828078],
            [34.37807413085331, 1.384400754436281],
            [34.3766268874384, 1.386671817305388],
            [34.37611169104654, 1.389155150382652],
            [34.37822940015858, 1.38931313645415],
            [34.38082228661487, 1.390401732321867],
            [34.38385862820781, 1.393471630743627],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1156,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "KAPSINDA",
        Population: 7429,
        Key: "KAPCHORWAKAPSINDA",
        Dist2: "Kapchorwa",
        "Sub Country": "Kapsinda",
        id2_original: "Kapchorwa Kapsinda",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.44760055829961, 1.476506447304569],
            [34.446941083489975, 1.476453445441361],
            [34.44660938057131, 1.473902424516866],
            [34.44568944193999, 1.473592284974063],
            [34.44468050721346, 1.472185997014402],
            [34.44381971186381, 1.471977891034465],
            [34.444867817628314, 1.471457504318081],
            [34.44546964035966, 1.470464950574391],
            [34.44428309522674, 1.469094197989219],
            [34.44474460290729, 1.468445669398122],
            [34.44414106080053, 1.466764901703814],
            [34.444747454160016, 1.466796004658966],
            [34.44479797720824, 1.46627626869888],
            [34.445681789192086, 1.465779613562673],
            [34.44649764901459, 1.46217771981961],
            [34.446033554185995, 1.46106555335257],
            [34.44104999563711, 1.460489939249507],
            [34.436537576505295, 1.46065565869592],
            [34.434007417608655, 1.462737509434606],
            [34.42961251698062, 1.46490196276837],
            [34.42826639601894, 1.463491895850973],
            [34.42740976885222, 1.463383908672171],
            [34.42676179157991, 1.462823566934612],
            [34.426585732564, 1.458871238815019],
            [34.42872291625308, 1.453515543322218],
            [34.430045334267646, 1.447626751059551],
            [34.43131967983814, 1.444785975980864],
            [34.43138030893328, 1.443836268965754],
            [34.430537737705805, 1.442850959136453],
            [34.428707178667594, 1.442752631982963],
            [34.42203614114572, 1.446356557536652],
            [34.418889209754774, 1.447507193818288],
            [34.40970765050835, 1.449701748402141],
            [34.40868981437568, 1.449593856651467],
            [34.411627360151975, 1.446788202355443],
            [34.41317181026377, 1.444697944822],
            [34.41363324607912, 1.442454610663382],
            [34.41307464399105, 1.439253194813856],
            [34.413259499310236, 1.435707621203854],
            [34.412983476667826, 1.434405379188523],
            [34.417654593974376, 1.428360727351163],
            [34.417867005114886, 1.42302432900728],
            [34.41614704575615, 1.420076878526381],
            [34.41575010718153, 1.417580834191535],
            [34.416323002364116, 1.415717309011492],
            [34.41591354396938, 1.414795018849681],
            [34.41738509399926, 1.411972222363868],
            [34.41913066971662, 1.410885806188485],
            [34.41922600971437, 1.408796465240779],
            [34.42081880356146, 1.406778560964375],
            [34.4203529228821, 1.404499629978873],
            [34.420806581083724, 1.400501679306769],
            [34.42061408379644, 1.396097120457961],
            [34.42635165046558, 1.39820098251028],
            [34.42733573958795, 1.397435675914816],
            [34.42896372044475, 1.397463421111009],
            [34.42903429568675, 1.396098010424154],
            [34.430261772555575, 1.395048079994435],
            [34.43218943678107, 1.394745080031194],
            [34.43563002833667, 1.393147645849203],
            [34.43680127605862, 1.393578092727907],
            [34.437777290224915, 1.40106978911766],
            [34.43687696990111, 1.401914017539666],
            [34.4351015710146, 1.40263405665899],
            [34.43415192779176, 1.407204468419912],
            [34.431535090453366, 1.408987849132072],
            [34.429805581104844, 1.411521372644507],
            [34.42958968000944, 1.413084811468392],
            [34.43037894251302, 1.414040057747293],
            [34.43369382203118, 1.412774482226245],
            [34.435430303204605, 1.409809006652069],
            [34.43753779937017, 1.408187808826984],
            [34.4403711154207, 1.409060782849882],
            [34.44214156009842, 1.408994883508169],
            [34.44318326895976, 1.409648282928822],
            [34.443736813532766, 1.409152099518141],
            [34.443795407045506, 1.407623556948102],
            [34.44549618467799, 1.404077085210597],
            [34.44794590033925, 1.401841589198818],
            [34.44920396214856, 1.403568283970383],
            [34.45195127708704, 1.403789686365282],
            [34.45396211362972, 1.405165563776823],
            [34.453213585232696, 1.407344557049713],
            [34.452346136960074, 1.408520416454892],
            [34.45343344250861, 1.409852855414658],
            [34.455333673083615, 1.409910630134175],
            [34.45697093174066, 1.4113489349698],
            [34.45723411925428, 1.411151414945932],
            [34.451919446183254, 1.415908544156054],
            [34.450254744892604, 1.418379288914263],
            [34.45113460518752, 1.420452056898748],
            [34.453681439510774, 1.423682383493251],
            [34.45438178227593, 1.429322587631199],
            [34.455896764951476, 1.429657008946235],
            [34.45701725157166, 1.428955023353971],
            [34.45744027093388, 1.427186335537477],
            [34.458560005664204, 1.425295242974981],
            [34.46040725001047, 1.424074465943621],
            [34.46201359314705, 1.425171074939303],
            [34.4640430077481, 1.424590467644528],
            [34.46604326573, 1.4258087783924],
            [34.468194341864965, 1.425990335453986],
            [34.470040913373104, 1.423732902619199],
            [34.46991861134044, 1.421964573598885],
            [34.46882680972389, 1.420105396664818],
            [34.46946260224768, 1.419464702959372],
            [34.47179526922407, 1.419379360456661],
            [34.47455304684065, 1.420841095545451],
            [34.4770320305122, 1.423758256924776],
            [34.47783007045442, 1.428918748090667],
            [34.47677306508041, 1.434102681614165],
            [34.478896910584155, 1.438082415083994],
            [34.47826868546827, 1.439231521712361],
            [34.47844933577361, 1.442078439076616],
            [34.4790620927986, 1.443567968097119],
            [34.478924294827266, 1.448172879886565],
            [34.4795474175123, 1.452065291550702],
            [34.4803836843631, 1.453084919944252],
            [34.48030408644242, 1.454858922820133],
            [34.47883793259248, 1.456210611842938],
            [34.47706776998575, 1.455876278845833],
            [34.47196104881819, 1.458425324004696],
            [34.470769317711124, 1.458241188608598],
            [34.47096117539791, 1.459313886525882],
            [34.470463618325, 1.459801124620408],
            [34.47022277191247, 1.461426205737318],
            [34.46953715972131, 1.462536360454974],
            [34.46919321456197, 1.464794749752253],
            [34.46749902876705, 1.466233916225502],
            [34.46635323930025, 1.468848482639252],
            [34.465036930727905, 1.470097470206402],
            [34.463477321545696, 1.472920333776846],
            [34.462458620335426, 1.473192338165957],
            [34.46076264599475, 1.474486801618155],
            [34.45934008558892, 1.474740983756065],
            [34.45374498992724, 1.472655425497338],
            [34.451681587567364, 1.472964290882395],
            [34.45062739392021, 1.472214298973566],
            [34.4497973047836, 1.472323375920603],
            [34.4490651104534, 1.472685631249872],
            [34.44898924952428, 1.474367938178173],
            [34.44760055829961, 1.476506447304569],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1157,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "KAPTANYA",
        Population: 7233,
        Key: "KAPCHORWAKAPTANYA",
        Dist2: "Kapchorwa",
        "Sub Country": "kaptanya",
        id2_original: "Kapchorwa kaptanya",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.47826307638766, 1.400247646960228],
            [34.47847436104078, 1.40101912042322],
            [34.479991114295736, 1.402027720986943],
            [34.479932201881084, 1.403032714563532],
            [34.48059623833575, 1.403739869975131],
            [34.4810212986703, 1.405098664800797],
            [34.4831188208413, 1.407078996352574],
            [34.48286811631685, 1.407523877632008],
            [34.48154957543102, 1.407563858561136],
            [34.481525503276366, 1.408627645582721],
            [34.48265364803435, 1.409370494733571],
            [34.483771655304324, 1.410846248294615],
            [34.48459019390301, 1.413908953530528],
            [34.48553112706086, 1.414872498270838],
            [34.486824109978535, 1.419091163349345],
            [34.486424303083226, 1.424065166761898],
            [34.48525317663385, 1.425896982701607],
            [34.485785836274836, 1.430089121208041],
            [34.48366932910865, 1.432021409861773],
            [34.48155794413622, 1.435912038713091],
            [34.480066129910185, 1.436337866257702],
            [34.47972574746923, 1.437347450030803],
            [34.478896910584155, 1.438082415083994],
            [34.47677306508041, 1.434102681614165],
            [34.47783007045442, 1.428918748090667],
            [34.4770320305122, 1.423758256924776],
            [34.47455304684065, 1.420841095545451],
            [34.47179526922407, 1.419379360456661],
            [34.46946260224768, 1.419464702959372],
            [34.46882680972389, 1.420105396664818],
            [34.46991861134044, 1.421964573598885],
            [34.470040913373104, 1.423732902619199],
            [34.468194341864965, 1.425990335453986],
            [34.46604326573, 1.4258087783924],
            [34.4640430077481, 1.424590467644528],
            [34.46201359314705, 1.425171074939303],
            [34.46040725001047, 1.424074465943621],
            [34.458560005664204, 1.425295242974981],
            [34.45744027093388, 1.427186335537477],
            [34.45701725157166, 1.428955023353971],
            [34.455896764951476, 1.429657008946235],
            [34.45438178227593, 1.429322587631199],
            [34.453681439510774, 1.423682383493251],
            [34.45113460518752, 1.420452056898748],
            [34.450254744892604, 1.418379288914263],
            [34.451919446183254, 1.415908544156054],
            [34.45723411925428, 1.411151414945932],
            [34.45697093174066, 1.4113489349698],
            [34.455333673083615, 1.409910630134175],
            [34.45343344250861, 1.409852855414658],
            [34.452346136960074, 1.408520416454892],
            [34.453213585232696, 1.407344557049713],
            [34.45396211362972, 1.405165563776823],
            [34.45195127708704, 1.403789686365282],
            [34.44920396214856, 1.403568283970383],
            [34.44794590033925, 1.401841589198818],
            [34.44549618467799, 1.404077085210597],
            [34.443795407045506, 1.407623556948102],
            [34.440927463635724, 1.406567146904914],
            [34.43927955994257, 1.404768330535809],
            [34.440568578594885, 1.401104534544909],
            [34.44078710097425, 1.398409158965378],
            [34.44355593146211, 1.395386607631094],
            [34.442988567206754, 1.392483699617243],
            [34.44448166153208, 1.390049829296693],
            [34.44229653655291, 1.388147701888911],
            [34.44171346255988, 1.386975834002123],
            [34.44198932350551, 1.384575390727899],
            [34.44129424666455, 1.381617337894915],
            [34.44207050874933, 1.38125403096961],
            [34.444667361267605, 1.38221881675227],
            [34.44566777816859, 1.381556395043271],
            [34.44770103486413, 1.382577163579094],
            [34.450001974243, 1.385072000516225],
            [34.45652777125143, 1.388604312613456],
            [34.460999988079344, 1.396397757481375],
            [34.46343384488257, 1.399435128887833],
            [34.463593721646966, 1.400927344535123],
            [34.464435031639766, 1.402859788622262],
            [34.47144117849191, 1.403212685662107],
            [34.47604135314551, 1.401787270860345],
            [34.47826307638766, 1.400247646960228],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1158,
        District: "KAPCHORWA",
        County: "KAPCHORWA MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 12795,
        Key: "KAPCHORWACENTRAL DIVISION",
        Dist2: "Kapchorwa",
        "Sub Country": "Central division",
        id2_original: "Kapchorwa Central division",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32801568232563, 1.388832493113487],
            [34.326278611857376, 1.389106741826715],
            [34.32540772034225, 1.388153215926028],
            [34.32337883934043, 1.377407551000384],
            [34.312263746276486, 1.361093465595896],
            [34.30789581307329, 1.352231818010313],
            [34.305883469157536, 1.346236111482177],
            [34.30582415609428, 1.342718865978715],
            [34.30609319343703, 1.338195040489244],
            [34.30802864605602, 1.332712767037989],
            [34.31054512989911, 1.329844174312558],
            [34.31096194010609, 1.32886709907605],
            [34.31072848054015, 1.328254251721911],
            [34.311978335341045, 1.32628875063626],
            [34.31327028968771, 1.322217845086164],
            [34.316491444379, 1.315730924318289],
            [34.318145407208775, 1.314355217753125],
            [34.31867393639608, 1.3132785933131],
            [34.31888147417617, 1.312199328953052],
            [34.31947227907052, 1.311808122708106],
            [34.323186952009245, 1.311347272094177],
            [34.3254650112978, 1.311569507371822],
            [34.32327171254787, 1.313158558722719],
            [34.32105939646338, 1.319744421047015],
            [34.31998435651172, 1.32187054736069],
            [34.317530061239154, 1.323346182247721],
            [34.317592563321675, 1.324702884161493],
            [34.31857708633035, 1.326647009639885],
            [34.31835822169282, 1.329696328088334],
            [34.31896730730324, 1.329890425088534],
            [34.31951751553329, 1.330753522784236],
            [34.330639045026274, 1.330224598145224],
            [34.331847490187506, 1.330619154894841],
            [34.33342972074519, 1.329590737108139],
            [34.34085317636929, 1.327525496071721],
            [34.342876925295855, 1.327469666392134],
            [34.345379247198466, 1.326126873578677],
            [34.347017550596206, 1.325703836362922],
            [34.345566411187924, 1.328349325416169],
            [34.345056098936254, 1.33033820799347],
            [34.3450799159694, 1.331390984794348],
            [34.344522784423454, 1.332771615917888],
            [34.34501184702704, 1.33445580887219],
            [34.345802549530035, 1.335133836707402],
            [34.348081014857115, 1.33595141293378],
            [34.350776494308754, 1.334218670347958],
            [34.35196247619799, 1.335107032868251],
            [34.35437966296448, 1.334567600828339],
            [34.35589604252028, 1.335027258081697],
            [34.35423040159183, 1.336115011846658],
            [34.35210736277521, 1.339379338055019],
            [34.35002929002844, 1.341737034300067],
            [34.35075213379486, 1.345958227881677],
            [34.351143068928415, 1.346289385733534],
            [34.35357492698014, 1.345346332255913],
            [34.35146086233322, 1.349200410797867],
            [34.349726122993104, 1.351044070926664],
            [34.34848403592448, 1.353690654300129],
            [34.34768114597807, 1.354357958395683],
            [34.344237102196786, 1.35563923990255],
            [34.34379108416665, 1.357325485313721],
            [34.34315424420721, 1.357799791073411],
            [34.341839060325604, 1.357778374963772],
            [34.34061229312584, 1.358432583278451],
            [34.33911204102434, 1.358528076091749],
            [34.33762345624178, 1.362078398535468],
            [34.33431225532473, 1.366795052203172],
            [34.334579745768536, 1.369179091478901],
            [34.33529935559994, 1.370893160025761],
            [34.33722998965574, 1.372512784920808],
            [34.338294886729514, 1.372900618228422],
            [34.33948208134441, 1.371899216654396],
            [34.3403819408325, 1.372769066285383],
            [34.34052701695425, 1.374451753256998],
            [34.33996767465437, 1.375121518554865],
            [34.33636649936023, 1.375320004316244],
            [34.33530320308431, 1.376214452256053],
            [34.33344894648891, 1.376612527291251],
            [34.33280546258963, 1.377502610195643],
            [34.33106874336264, 1.378387615162626],
            [34.33153848050954, 1.380675995580307],
            [34.33068818736389, 1.383446604289291],
            [34.32933370668019, 1.385002900739356],
            [34.327812270507636, 1.385649904617065],
            [34.3268617083083, 1.386655554477854],
            [34.32731430739621, 1.388115105308012],
            [34.32801568232563, 1.388832493113487],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1159,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "KAWOWO",
        Population: 6910,
        Key: "KAPCHORWAKAWOWO",
        Dist2: "Kapchorwa",
        "Sub Country": "Kawowo",
        id2_original: "Kapchorwa Kawowo",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.35589604252028, 1.335027258081697],
            [34.35437966296448, 1.334567600828339],
            [34.35196247619799, 1.335107032868251],
            [34.350776494308754, 1.334218670347958],
            [34.348081014857115, 1.33595141293378],
            [34.345802549530035, 1.335133836707402],
            [34.34501184702704, 1.33445580887219],
            [34.344522784423454, 1.332771615917888],
            [34.3450799159694, 1.331390984794348],
            [34.345056098936254, 1.33033820799347],
            [34.345566411187924, 1.328349325416169],
            [34.347017550596206, 1.325703836362922],
            [34.34654069879227, 1.324652332406294],
            [34.34491317068634, 1.323951363946868],
            [34.34291000126461, 1.322256779378819],
            [34.34276542999608, 1.32044095778764],
            [34.34367987992099, 1.319366022565213],
            [34.34738540890842, 1.318765387612594],
            [34.34874305166194, 1.319424655325844],
            [34.35132050955322, 1.319684178041849],
            [34.35476791123701, 1.321186491589514],
            [34.35678099266961, 1.321246779462115],
            [34.35864208903759, 1.322258787476937],
            [34.3599076508812, 1.321859015163908],
            [34.361142367272905, 1.320829950715509],
            [34.363612693880064, 1.320414162769924],
            [34.36481705799494, 1.319661396522171],
            [34.36615816096747, 1.317972269340377],
            [34.369756813792264, 1.317218178587217],
            [34.370125184144186, 1.316756274627969],
            [34.371395733434284, 1.316624632545215],
            [34.37453215812964, 1.317476465778139],
            [34.380176889304046, 1.315716544286324],
            [34.38182875816089, 1.315849612565493],
            [34.38259602631304, 1.316361223525976],
            [34.38127435030687, 1.318333266884555],
            [34.381453892989455, 1.31984275957737],
            [34.38146052345456, 1.321095157210961],
            [34.379515678050986, 1.322434858878638],
            [34.37690641710367, 1.322816197193496],
            [34.37292145007913, 1.322734516292866],
            [34.37246361560974, 1.323351454850068],
            [34.371091289892895, 1.323956009691247],
            [34.36917236986842, 1.326944902726626],
            [34.36665567851451, 1.329207486940289],
            [34.36685659660928, 1.330556411020626],
            [34.363505358678346, 1.335108586531793],
            [34.36159406984218, 1.333940587808192],
            [34.35741843090702, 1.333050627196365],
            [34.356216090696435, 1.333443654974914],
            [34.35589604252028, 1.335027258081697],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1160,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "AMUKOL",
        Population: 3775,
        Key: "KAPCHORWAAMUKOL",
        Dist2: "Kapchorwa",
        "Sub Country": "Amukol",
        id2_original: "Kapchorwa Amukol",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.362317247781874, 1.318118728733908],
            [34.361611666940284, 1.318232171196513],
            [34.36042517570629, 1.317446043392217],
            [34.358493766404365, 1.318247452883811],
            [34.35696102313739, 1.316878210276506],
            [34.352490373869635, 1.316062225431602],
            [34.351367583070754, 1.313874225490626],
            [34.349509665840564, 1.31287709614445],
            [34.34805300718318, 1.313086540839578],
            [34.346349249838894, 1.312258248369557],
            [34.34405962743599, 1.311773934604258],
            [34.342616127300886, 1.310675594370568],
            [34.34073465444732, 1.310707510346419],
            [34.339006199720956, 1.309834441487244],
            [34.33750184681017, 1.309764626500102],
            [34.33594579046491, 1.311438427213748],
            [34.33439282522254, 1.310680028192787],
            [34.33257286540637, 1.310937027314777],
            [34.331625159849644, 1.310222440995412],
            [34.330397396418206, 1.310622182843117],
            [34.32809908910313, 1.310185343089349],
            [34.3286054281063, 1.309094559509145],
            [34.32854707624037, 1.308144880174057],
            [34.33000301265229, 1.305990084383784],
            [34.33079867924551, 1.305922922223798],
            [34.33190222723271, 1.306711051881034],
            [34.333963832961985, 1.306740284439305],
            [34.333744856035054, 1.305155461681968],
            [34.33431330904856, 1.304491238181795],
            [34.336744557144186, 1.304607577577889],
            [34.337375514036836, 1.304197848992418],
            [34.337912225978066, 1.303075219484531],
            [34.33977174400607, 1.303964622326541],
            [34.339947303558695, 1.302538642692803],
            [34.34066717120656, 1.302344063089283],
            [34.3420976834993, 1.303405647538021],
            [34.343586043703056, 1.30295911351921],
            [34.344687182408634, 1.302005271944395],
            [34.34636232122459, 1.302455909474364],
            [34.347877479969924, 1.30203365676666],
            [34.351048002018516, 1.30237812379368],
            [34.354471909164396, 1.301157119189555],
            [34.35590470946614, 1.301100929687011],
            [34.35735441067164, 1.300369003061324],
            [34.35804119157098, 1.301375340036884],
            [34.35814570336776, 1.302838147123039],
            [34.356220229234964, 1.303700709049814],
            [34.35546516020437, 1.305639528854718],
            [34.353340339130206, 1.307220131221829],
            [34.35449132624925, 1.307298982775492],
            [34.36142916700379, 1.309972655182719],
            [34.360850262091994, 1.311298279134794],
            [34.35970600155781, 1.311523281401114],
            [34.35886005086823, 1.31376549864336],
            [34.35941974800263, 1.315285110059752],
            [34.361752192196796, 1.316593211486009],
            [34.362317247781874, 1.318118728733908],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1161,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "CHEPTERECH",
        Population: 4077,
        Key: "KAPCHORWACHEPTERECH",
        Dist2: "Kapchorwa",
        "Sub Country": "Cheptarich",
        id2_original: "Kapchorwa Cheptarich",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.370125184144186, 1.316756274627969],
            [34.36641093610863, 1.316989667145193],
            [34.362317247781874, 1.318118728733908],
            [34.361752192196796, 1.316593211486009],
            [34.35941974800263, 1.315285110059752],
            [34.35886005086823, 1.31376549864336],
            [34.35970600155781, 1.311523281401114],
            [34.360850262091994, 1.311298279134794],
            [34.36142916700379, 1.309972655182719],
            [34.35449132624925, 1.307298982775492],
            [34.353340339130206, 1.307220131221829],
            [34.35546516020437, 1.305639528854718],
            [34.356220229234964, 1.303700709049814],
            [34.35814570336776, 1.302838147123039],
            [34.35804119157098, 1.301375340036884],
            [34.35735441067164, 1.300369003061324],
            [34.359416317336546, 1.300216244367895],
            [34.36008323199338, 1.299453924518336],
            [34.370734083803335, 1.296574105232732],
            [34.374120695593554, 1.295269294750379],
            [34.37766545489121, 1.294823464290983],
            [34.38441585228023, 1.296584066794646],
            [34.38822341820584, 1.296941567576654],
            [34.39058195127251, 1.296321555555735],
            [34.39011974021106, 1.296932067631902],
            [34.388445559897505, 1.297759386236718],
            [34.38442789419663, 1.298493702523651],
            [34.383237433307386, 1.298258423206844],
            [34.3814635642518, 1.298531872016999],
            [34.38084577037303, 1.298218469215041],
            [34.37912838109432, 1.298533158074119],
            [34.37695110379748, 1.297927423297408],
            [34.374265996294106, 1.299865982606979],
            [34.37368089839675, 1.300845884687597],
            [34.372300523774975, 1.301135225706155],
            [34.372360487218494, 1.30178832193963],
            [34.37190212364141, 1.302324058285194],
            [34.37043473101467, 1.302878813221536],
            [34.36773902069602, 1.30505916122083],
            [34.362998434871926, 1.305920338442004],
            [34.36887736582405, 1.306683455627247],
            [34.37324051549837, 1.309282078777341],
            [34.37533685638475, 1.309671217137254],
            [34.37749877159192, 1.311988395167357],
            [34.38003502465946, 1.312493743711629],
            [34.381807046778775, 1.313940632152971],
            [34.38257994736779, 1.315070783593342],
            [34.38259602631304, 1.316361223525976],
            [34.38182875816089, 1.315849612565493],
            [34.380176889304046, 1.315716544286324],
            [34.37453215812964, 1.317476465778139],
            [34.371395733434284, 1.316624632545215],
            [34.370125184144186, 1.316756274627969],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1162,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "GAMOGO",
        Population: 3376,
        Key: "KAPCHORWAGAMOGO",
        Dist2: "Kapchorwa",
        "Sub Country": "Gamogo",
        id2_original: "Kapchorwa Gamogo",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.405379022192086, 1.28767877673742],
            [34.396366108165516, 1.302398207628628],
            [34.393868352399515, 1.305450047005052],
            [34.39247142003041, 1.306163920708555],
            [34.39255090835665, 1.307550442878162],
            [34.39950042181997, 1.311587383652809],
            [34.40341859371326, 1.314673236463376],
            [34.39954287799696, 1.317131627226071],
            [34.39907096153716, 1.31788459900066],
            [34.39915155389286, 1.321222207192338],
            [34.39734210256891, 1.323322887062372],
            [34.396969012468475, 1.324828510508999],
            [34.396000310588576, 1.324745116147218],
            [34.3953019252524, 1.323632818354043],
            [34.39412371828194, 1.323332511739577],
            [34.39255787209671, 1.320096883011625],
            [34.38873956681191, 1.319683065324431],
            [34.38487918982908, 1.319763849146457],
            [34.38337583764152, 1.318686026312665],
            [34.381453892989455, 1.31984275957737],
            [34.38127435030687, 1.318333266884555],
            [34.38259602631304, 1.316361223525976],
            [34.38257994736779, 1.315070783593342],
            [34.381807046778775, 1.313940632152971],
            [34.38003502465946, 1.312493743711629],
            [34.37749877159192, 1.311988395167357],
            [34.37533685638475, 1.309671217137254],
            [34.37324051549837, 1.309282078777341],
            [34.36887736582405, 1.306683455627247],
            [34.362998434871926, 1.305920338442004],
            [34.36773902069602, 1.30505916122083],
            [34.37043473101467, 1.302878813221536],
            [34.37190212364141, 1.302324058285194],
            [34.372360487218494, 1.30178832193963],
            [34.372300523774975, 1.301135225706155],
            [34.37368089839675, 1.300845884687597],
            [34.374265996294106, 1.299865982606979],
            [34.37695110379748, 1.297927423297408],
            [34.37912838109432, 1.298533158074119],
            [34.38084577037303, 1.298218469215041],
            [34.3814635642518, 1.298531872016999],
            [34.383237433307386, 1.298258423206844],
            [34.38442789419663, 1.298493702523651],
            [34.388445559897505, 1.297759386236718],
            [34.39011974021106, 1.296932067631902],
            [34.39058195127251, 1.296321555555735],
            [34.39348995505239, 1.296145435619487],
            [34.39592340312214, 1.294911659019441],
            [34.39920931826059, 1.294584463862833],
            [34.40029532664185, 1.293659915602194],
            [34.40055845217174, 1.292723006638121],
            [34.40024801507079, 1.291897639728673],
            [34.400898567813016, 1.290882234591627],
            [34.401799032765624, 1.290566118620151],
            [34.40216667458384, 1.289406212421651],
            [34.404191804221, 1.287476716712064],
            [34.405379022192086, 1.28767877673742],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1163,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "KABEYWA",
        Population: 5221,
        Key: "KAPCHORWAKABEYWA",
        Dist2: "Kapchorwa",
        "Sub Country": "Kabaywa",
        id2_original: "Kapchorwa Kabaywa",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.443795407045506, 1.407623556948102],
            [34.443736813532766, 1.409152099518141],
            [34.44318326895976, 1.409648282928822],
            [34.44214156009842, 1.408994883508169],
            [34.4403711154207, 1.409060782849882],
            [34.43753779937017, 1.408187808826984],
            [34.435430303204605, 1.409809006652069],
            [34.43369382203118, 1.412774482226245],
            [34.43037894251302, 1.414040057747293],
            [34.42958968000944, 1.413084811468392],
            [34.429805581104844, 1.411521372644507],
            [34.431535090453366, 1.408987849132072],
            [34.43415192779176, 1.407204468419912],
            [34.4351015710146, 1.40263405665899],
            [34.43687696990111, 1.401914017539666],
            [34.437777290224915, 1.40106978911766],
            [34.43680127605862, 1.393578092727907],
            [34.43563002833667, 1.393147645849203],
            [34.43218943678107, 1.394745080031194],
            [34.430261772555575, 1.395048079994435],
            [34.42903429568675, 1.396098010424154],
            [34.42896372044475, 1.397463421111009],
            [34.42733573958795, 1.397435675914816],
            [34.42635165046558, 1.39820098251028],
            [34.42061408379644, 1.396097120457961],
            [34.420806581083724, 1.400501679306769],
            [34.4203529228821, 1.404499629978873],
            [34.42081880356146, 1.406778560964375],
            [34.41922600971437, 1.408796465240779],
            [34.41913066971662, 1.410885806188485],
            [34.41738509399926, 1.411972222363868],
            [34.41591354396938, 1.414795018849681],
            [34.416323002364116, 1.415717309011492],
            [34.41575010718153, 1.417580834191535],
            [34.41614704575615, 1.420076878526381],
            [34.417867005114886, 1.42302432900728],
            [34.417654593974376, 1.428360727351163],
            [34.412983476667826, 1.434405379188523],
            [34.413259499310236, 1.435707621203854],
            [34.41307464399105, 1.439253194813856],
            [34.41363324607912, 1.442454610663382],
            [34.41317181026377, 1.444697944822],
            [34.411627360151975, 1.446788202355443],
            [34.40868981437568, 1.449593856651467],
            [34.4072316977526, 1.447794905107648],
            [34.40478679975618, 1.447968274892485],
            [34.40338821628361, 1.446151189951931],
            [34.402966548885864, 1.444586742695537],
            [34.40197598111365, 1.443149267773832],
            [34.4016840214598, 1.441503337406669],
            [34.39990458644274, 1.439623166856087],
            [34.39856892187093, 1.435038386054442],
            [34.39806419983532, 1.434496019532888],
            [34.39730841574576, 1.434885402443989],
            [34.39500943199928, 1.438549883975448],
            [34.392998872137696, 1.444520567778366],
            [34.391655950076746, 1.445561529561912],
            [34.388811349389634, 1.446115007458873],
            [34.387514972636794, 1.447029315919555],
            [34.384814669232085, 1.445656197124236],
            [34.38298917759039, 1.442862519482545],
            [34.382029913410875, 1.442094309974294],
            [34.3769142297517, 1.441437176768294],
            [34.37517259404516, 1.440768928439473],
            [34.374107071743936, 1.437965726554619],
            [34.374853835849734, 1.434682054401095],
            [34.37483012122456, 1.432592744868524],
            [34.3738744278483, 1.432150130562982],
            [34.37038124711929, 1.432070837692279],
            [34.367717460230885, 1.429729864781074],
            [34.3650494674303, 1.425968861591219],
            [34.364331358683756, 1.425508007770361],
            [34.3614749173029, 1.425066519136683],
            [34.36021672254292, 1.42409044024042],
            [34.36023959814161, 1.4219106427853],
            [34.36205233460457, 1.418373072681077],
            [34.362109407269536, 1.416084722730623],
            [34.36319655920617, 1.413705315365153],
            [34.36297707473111, 1.412963776944257],
            [34.352324717344715, 1.409107937325144],
            [34.35094918104908, 1.407218381821155],
            [34.350338273655254, 1.404650020249159],
            [34.350281579181036, 1.401782859656214],
            [34.351002551756736, 1.400398589802623],
            [34.352409945905606, 1.399221932438653],
            [34.35366453033648, 1.397542113472388],
            [34.356675670592416, 1.397173018381368],
            [34.35817007016986, 1.397571429353335],
            [34.359458800462974, 1.398638977452423],
            [34.361307544995796, 1.398358605163598],
            [34.36222047766622, 1.399064927699985],
            [34.36414794336399, 1.398867736220831],
            [34.365087120315444, 1.397989974491678],
            [34.36689683394748, 1.397345770520788],
            [34.367707403591275, 1.395879529553417],
            [34.36865225520037, 1.39533454863432],
            [34.37681337140318, 1.394312689089099],
            [34.378234235789755, 1.394566114996276],
            [34.3810691176038, 1.393529435502998],
            [34.38385862820781, 1.393471630743627],
            [34.385856815572964, 1.392641163698844],
            [34.389058281888175, 1.390300435782548],
            [34.39021891601505, 1.386835654352524],
            [34.390997479583596, 1.385667122081377],
            [34.390907405510035, 1.384709759210642],
            [34.39234086427692, 1.384137251282074],
            [34.39518207562045, 1.380594740507722],
            [34.39728625251104, 1.380034840275227],
            [34.39967575769207, 1.377758671000812],
            [34.39990042814127, 1.375334222346688],
            [34.403157881956545, 1.372478697350008],
            [34.40425733093112, 1.369205504286258],
            [34.40443362889888, 1.366666833522692],
            [34.40414988254166, 1.365632429226998],
            [34.4048884917413, 1.364774086549969],
            [34.40515727126758, 1.360280938635061],
            [34.40559085212261, 1.359865481588496],
            [34.406496311708175, 1.359914401734644],
            [34.40765503691505, 1.358396135398861],
            [34.408853854831385, 1.359181545996007],
            [34.409972805332444, 1.359034918423278],
            [34.41035461537934, 1.357877650444364],
            [34.412365103375684, 1.356081686285667],
            [34.41877359837433, 1.35203487591511],
            [34.41946699087417, 1.350502925302186],
            [34.418966915823496, 1.34919183785759],
            [34.4180584828143, 1.348919565712766],
            [34.418441825387085, 1.345741390389196],
            [34.41900465315027, 1.34549039038612],
            [34.41985350809313, 1.343578456698696],
            [34.42161109698082, 1.342367748962721],
            [34.42482196326715, 1.337954316331039],
            [34.427300336982604, 1.337366572311792],
            [34.42825697448825, 1.336725876998861],
            [34.42799808271829, 1.334951904498389],
            [34.429264910288175, 1.333540222860863],
            [34.42936546410781, 1.332562097446324],
            [34.42987510352131, 1.331926451641863],
            [34.433631937989574, 1.330010320566988],
            [34.43602830899432, 1.329701403999096],
            [34.43739240344819, 1.328479602702848],
            [34.43911908400188, 1.327818345468665],
            [34.439773994471565, 1.326904472315652],
            [34.439928405885745, 1.325864271140057],
            [34.44059865419061, 1.325248856343531],
            [34.443259165821495, 1.325247293693046],
            [34.44497527769586, 1.325743727948598],
            [34.44693004319515, 1.324232159799093],
            [34.44892258914033, 1.323950609563485],
            [34.452575742753424, 1.322419951714799],
            [34.45520970198114, 1.322183242213957],
            [34.45666631482444, 1.320735280867255],
            [34.457941980918406, 1.320083331929831],
            [34.459534750511004, 1.318092630599408],
            [34.46180083435853, 1.317874225305587],
            [34.4627340545813, 1.318452510917771],
            [34.4637780748079, 1.318343359479452],
            [34.46535906838545, 1.317356589451386],
            [34.467798325860166, 1.314596621358297],
            [34.47043810886586, 1.313799155057128],
            [34.47066621626932, 1.31298503092429],
            [34.46977243298583, 1.311647002687971],
            [34.470350696500496, 1.31030810080208],
            [34.47257307820775, 1.309339043140726],
            [34.478750832840845, 1.304198222594768],
            [34.480667869098205, 1.303563986724728],
            [34.48219103632427, 1.301690919401295],
            [34.481820120146836, 1.299357717240128],
            [34.484228755850154, 1.298072006863769],
            [34.48697273444565, 1.294959158780802],
            [34.4881639651911, 1.292109516390537],
            [34.48954623974969, 1.290381250014424],
            [34.48968883023307, 1.288346211721386],
            [34.49039553935866, 1.286735921121134],
            [34.48993984287966, 1.286356331305147],
            [34.4898342818506, 1.28543388158342],
            [34.490485482278174, 1.281074176500482],
            [34.490908710049546, 1.280666938116002],
            [34.49342051097503, 1.280086632130081],
            [34.495232664431384, 1.280709618089116],
            [34.496157553678245, 1.280537234029922],
            [34.49712007155571, 1.277461636248891],
            [34.502248720599404, 1.275269063108795],
            [34.504000995952154, 1.275146056726404],
            [34.50528976038126, 1.273356572028677],
            [34.50672789308254, 1.272901065279176],
            [34.5073274421779, 1.271572630921425],
            [34.50807018272954, 1.271171375932357],
            [34.50864617620151, 1.270219843148647],
            [34.5097752075967, 1.269728624905968],
            [34.51184207745353, 1.267041336440635],
            [34.51388027757807, 1.266166715075755],
            [34.51574681504173, 1.26650660754645],
            [34.51841422753062, 1.264225769152982],
            [34.520022023243, 1.258700496872786],
            [34.52107680618499, 1.25771429918844],
            [34.526417695689275, 1.247291264549548],
            [34.52767495709967, 1.244070835194414],
            [34.531022906298375, 1.23274570386195],
            [34.534395205231135, 1.2236996915482],
            [34.53433357002289, 1.223040303294557],
            [34.53505936924656, 1.224139993733103],
            [34.53632521675444, 1.22784609525877],
            [34.54266134706707, 1.238366158023384],
            [34.542127879840656, 1.240879018215947],
            [34.54246489988748, 1.243819219802431],
            [34.541375043123544, 1.246072347967395],
            [34.540506696535594, 1.246793375372723],
            [34.54041761689709, 1.248975961379557],
            [34.53943166556713, 1.250634430775752],
            [34.54050545057232, 1.253799460859848],
            [34.53937054060193, 1.25616918699523],
            [34.53818380592449, 1.26090264699289],
            [34.53786153351968, 1.264811140378509],
            [34.5364297555007, 1.266461911112954],
            [34.53504443834824, 1.267636173854483],
            [34.53029345721967, 1.274387029873371],
            [34.52948635597119, 1.276493279129823],
            [34.52768110516947, 1.279270146850372],
            [34.521796064775096, 1.285394037854922],
            [34.52145099133176, 1.2865143033405],
            [34.51919303813587, 1.286765771795148],
            [34.51821051387871, 1.287897296012015],
            [34.516665944291, 1.288659430736467],
            [34.515802428842676, 1.290062744169575],
            [34.514281830798275, 1.28993769714509],
            [34.514078775611466, 1.291577221148373],
            [34.51153375229183, 1.293127688939597],
            [34.51088780072046, 1.293185443983939],
            [34.509272347768615, 1.292364136577014],
            [34.507771650102754, 1.292823981212154],
            [34.50634906544241, 1.296859733158147],
            [34.50432967334497, 1.29815364995102],
            [34.503731459146124, 1.299632259797854],
            [34.50067664010612, 1.302041658689217],
            [34.50020985841647, 1.303814601207067],
            [34.498599512387024, 1.306375076810504],
            [34.49883364029954, 1.308147599563805],
            [34.498480029267725, 1.309450177036564],
            [34.4961261198298, 1.309234534381812],
            [34.49367285402655, 1.312889874917085],
            [34.48904541280912, 1.31543409051762],
            [34.48833466755297, 1.318735666640829],
            [34.489077006557665, 1.321330914854534],
            [34.48837088942184, 1.322968350102341],
            [34.488093406118786, 1.325727012081923],
            [34.48755758889959, 1.326631761233054],
            [34.48228105021069, 1.328543294995744],
            [34.48181012549096, 1.329963530051178],
            [34.47966615682654, 1.331502354795478],
            [34.47954603859835, 1.333501212409833],
            [34.476799565381285, 1.334334950877241],
            [34.47580158381303, 1.335357559754034],
            [34.47323271471417, 1.33923007614777],
            [34.4686610840287, 1.348819823769038],
            [34.465859822562464, 1.351055477257205],
            [34.463732469137554, 1.354122802036462],
            [34.462706166383306, 1.354765575390205],
            [34.459953104921965, 1.354984315075407],
            [34.458945690144915, 1.356224004230177],
            [34.457004530528934, 1.356984910078455],
            [34.454649332008586, 1.365994539617457],
            [34.45609139663586, 1.367431713579429],
            [34.45627847977694, 1.370307708654146],
            [34.457151095159105, 1.371844715322984],
            [34.457040894331605, 1.372577376811442],
            [34.4561855840951, 1.373645138237742],
            [34.45748083436055, 1.374702532019988],
            [34.45740492851567, 1.376411963535647],
            [34.45674944132759, 1.37727158266751],
            [34.45615475930443, 1.379297888374348],
            [34.45449763350658, 1.379814439675313],
            [34.452476860698525, 1.381760227282194],
            [34.449875855268665, 1.381798007518506],
            [34.44770103486413, 1.382577163579094],
            [34.44566777816859, 1.381556395043271],
            [34.444667361267605, 1.38221881675227],
            [34.44207050874933, 1.38125403096961],
            [34.44129424666455, 1.381617337894915],
            [34.44198932350551, 1.384575390727899],
            [34.44171346255988, 1.386975834002123],
            [34.44229653655291, 1.388147701888911],
            [34.44448166153208, 1.390049829296693],
            [34.442988567206754, 1.392483699617243],
            [34.44355593146211, 1.395386607631094],
            [34.44078710097425, 1.398409158965378],
            [34.440568578594885, 1.401104534544909],
            [34.43927955994257, 1.404768330535809],
            [34.440927463635724, 1.406567146904914],
            [34.443795407045506, 1.407623556948102],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1164,
        District: "KAPCHORWA",
        County: "KAPCHORWA MUNICIPALITY",
        Subcounty: "WESTERN DIVISION",
        Population: 19575,
        Key: "KAPCHORWAWESTERN DIVISION",
        Dist2: "Kapchorwa",
        "Sub Country": "Western  division",
        id2_original: "Kapchorwa Western  division",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.48272892865178, 1.379279710843053],
            [34.48292540637407, 1.380725746899881],
            [34.48249112752808, 1.38170655508013],
            [34.4836480731724, 1.381941801235282],
            [34.48388857373352, 1.382606969983196],
            [34.48357407984075, 1.383088440796683],
            [34.48266098098199, 1.383257969954658],
            [34.48167494161712, 1.384359355985501],
            [34.481946608328734, 1.386300478974182],
            [34.480404495633294, 1.386926614460503],
            [34.47955059215851, 1.38938645514957],
            [34.47832316829027, 1.389205115260424],
            [34.476864489321805, 1.390109404198258],
            [34.476938261667875, 1.391044283085788],
            [34.47812977538264, 1.39202082843726],
            [34.47864800358859, 1.393048506543425],
            [34.47694663486465, 1.397115510965512],
            [34.477153789962415, 1.398770331286173],
            [34.47826307638766, 1.400247646960228],
            [34.47604135314551, 1.401787270860345],
            [34.47144117849191, 1.403212685662107],
            [34.464435031639766, 1.402859788622262],
            [34.463593721646966, 1.400927344535123],
            [34.46343384488257, 1.399435128887833],
            [34.460999988079344, 1.396397757481375],
            [34.45652777125143, 1.388604312613456],
            [34.450001974243, 1.385072000516225],
            [34.44770103486413, 1.382577163579094],
            [34.449875855268665, 1.381798007518506],
            [34.452476860698525, 1.381760227282194],
            [34.45449763350658, 1.379814439675313],
            [34.45615475930443, 1.379297888374348],
            [34.45674944132759, 1.37727158266751],
            [34.45740492851567, 1.376411963535647],
            [34.45748083436055, 1.374702532019988],
            [34.4561855840951, 1.373645138237742],
            [34.457040894331605, 1.372577376811442],
            [34.457151095159105, 1.371844715322984],
            [34.45627847977694, 1.370307708654146],
            [34.45609139663586, 1.367431713579429],
            [34.454649332008586, 1.365994539617457],
            [34.457004530528934, 1.356984910078455],
            [34.458945690144915, 1.356224004230177],
            [34.459953104921965, 1.354984315075407],
            [34.462706166383306, 1.354765575390205],
            [34.463732469137554, 1.354122802036462],
            [34.465859822562464, 1.351055477257205],
            [34.4686610840287, 1.348819823769038],
            [34.47323271471417, 1.33923007614777],
            [34.47580158381303, 1.335357559754034],
            [34.476799565381285, 1.334334950877241],
            [34.47954603859835, 1.333501212409833],
            [34.47966615682654, 1.331502354795478],
            [34.48181012549096, 1.329963530051178],
            [34.48228105021069, 1.328543294995744],
            [34.48755758889959, 1.326631761233054],
            [34.488093406118786, 1.325727012081923],
            [34.48837088942184, 1.322968350102341],
            [34.489077006557665, 1.321330914854534],
            [34.48833466755297, 1.318735666640829],
            [34.48904541280912, 1.31543409051762],
            [34.49367285402655, 1.312889874917085],
            [34.4961261198298, 1.309234534381812],
            [34.498480029267725, 1.309450177036564],
            [34.49883364029954, 1.308147599563805],
            [34.498599512387024, 1.306375076810504],
            [34.50020985841647, 1.303814601207067],
            [34.50067664010612, 1.302041658689217],
            [34.503731459146124, 1.299632259797854],
            [34.50432967334497, 1.29815364995102],
            [34.50634906544241, 1.296859733158147],
            [34.507771650102754, 1.292823981212154],
            [34.509272347768615, 1.292364136577014],
            [34.51088780072046, 1.293185443983939],
            [34.51153375229183, 1.293127688939597],
            [34.514078775611466, 1.291577221148373],
            [34.514281830798275, 1.28993769714509],
            [34.515802428842676, 1.290062744169575],
            [34.516665944291, 1.288659430736467],
            [34.51821051387871, 1.287897296012015],
            [34.51919303813587, 1.286765771795148],
            [34.52145099133176, 1.2865143033405],
            [34.521796064775096, 1.285394037854922],
            [34.52768110516947, 1.279270146850372],
            [34.52948635597119, 1.276493279129823],
            [34.53029345721967, 1.274387029873371],
            [34.53504443834824, 1.267636173854483],
            [34.5364297555007, 1.266461911112954],
            [34.53607504942256, 1.268144099760687],
            [34.53551834367806, 1.268742846328905],
            [34.535359325703105, 1.271567880901921],
            [34.53428457321233, 1.274733105530742],
            [34.53460252472063, 1.277972971172618],
            [34.53408371081311, 1.279240193706485],
            [34.53455567488361, 1.280253438176111],
            [34.53377030837344, 1.283639529230015],
            [34.532276279800236, 1.284314321522275],
            [34.530815293059796, 1.286503998669157],
            [34.52882881613267, 1.287755940493995],
            [34.52880307580651, 1.289497288403811],
            [34.52546901456213, 1.294486101891102],
            [34.524263947964684, 1.29470247864555],
            [34.52375067756078, 1.296282390950416],
            [34.52299044770889, 1.296924397984671],
            [34.52307292922162, 1.300482497517969],
            [34.52180473531422, 1.302618160770883],
            [34.52225056290153, 1.304682694986899],
            [34.519606298200856, 1.307714130776148],
            [34.5175179442357, 1.308825982139036],
            [34.517250777185346, 1.309915157373872],
            [34.517615680938604, 1.311014729208988],
            [34.51753113689394, 1.312934029891349],
            [34.51640743250841, 1.31484857736552],
            [34.51476640452044, 1.315434431787489],
            [34.514201263595396, 1.31610593131061],
            [34.513671974433386, 1.32022663086679],
            [34.51196764037069, 1.321468037648388],
            [34.512087149541145, 1.323668330956562],
            [34.5107031448273, 1.324204406575915],
            [34.510662044208104, 1.326022496643031],
            [34.50999544935154, 1.326430697612497],
            [34.508231160828466, 1.326253374578619],
            [34.50721055069819, 1.327502861010208],
            [34.50388492822758, 1.327768268858306],
            [34.5013790067756, 1.329553895441927],
            [34.49954013382945, 1.331678940134834],
            [34.49818987522757, 1.332206501187822],
            [34.49646922865765, 1.33442492957646],
            [34.49356571016598, 1.334809015935466],
            [34.49273917745959, 1.33596493698645],
            [34.49160833056924, 1.336407406697002],
            [34.489811446676086, 1.33820110156555],
            [34.48549316425696, 1.344159248179507],
            [34.483313795682115, 1.34796069919685],
            [34.48184263102953, 1.351579740028074],
            [34.48182696890254, 1.356924481190871],
            [34.48110372897909, 1.358100682589088],
            [34.48205857524406, 1.363065321175834],
            [34.481939893421966, 1.365188182188628],
            [34.48253432571346, 1.36653838762624],
            [34.48385171136582, 1.36771653940618],
            [34.4836831496893, 1.370865867140026],
            [34.484400851499025, 1.372416195236734],
            [34.483750800016715, 1.373042634328564],
            [34.48341370181644, 1.374256773437566],
            [34.48374301072488, 1.375762854793737],
            [34.483466299074664, 1.377612521431244],
            [34.48273754888526, 1.378418237053513],
            [34.48272892865178, 1.379279710843053],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1165,
        District: "KAPCHORWA",
        County: "KAPCHORWA MUNICIPALITY",
        Subcounty: "EASTERN DIVISION",
        Population: 11225,
        Key: "KAPCHORWAEASTERN DIVISION",
        Dist2: "Kapchorwa",
        "Sub Country": "Eastern division",
        id2_original: "Kapchorwa Eastern division",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.38002297555652, 1.338365110746567],
            [34.37920684444282, 1.337029512927527],
            [34.3744987470893, 1.335950897440973],
            [34.37326908102611, 1.334921831677077],
            [34.37041325139794, 1.335859930919365],
            [34.36619518054032, 1.338650001054974],
            [34.36226119290813, 1.340123208297973],
            [34.363755045411544, 1.33800963028057],
            [34.3632795042496, 1.336399076190999],
            [34.363505358678346, 1.335108586531793],
            [34.36685659660928, 1.330556411020626],
            [34.36665567851451, 1.329207486940289],
            [34.36917236986842, 1.326944902726626],
            [34.371091289892895, 1.323956009691247],
            [34.37246361560974, 1.323351454850068],
            [34.37292145007913, 1.322734516292866],
            [34.37690641710367, 1.322816197193496],
            [34.379515678050986, 1.322434858878638],
            [34.38146052345456, 1.321095157210961],
            [34.381453892989455, 1.31984275957737],
            [34.38337583764152, 1.318686026312665],
            [34.38487918982908, 1.319763849146457],
            [34.38873956681191, 1.319683065324431],
            [34.39255787209671, 1.320096883011625],
            [34.39412371828194, 1.323332511739577],
            [34.3953019252524, 1.323632818354043],
            [34.396000310588576, 1.324745116147218],
            [34.396969012468475, 1.324828510508999],
            [34.39734210256891, 1.323322887062372],
            [34.39915155389286, 1.321222207192338],
            [34.39907096153716, 1.31788459900066],
            [34.39954287799696, 1.317131627226071],
            [34.40341859371326, 1.314673236463376],
            [34.39950042181997, 1.311587383652809],
            [34.39255090835665, 1.307550442878162],
            [34.39247142003041, 1.306163920708555],
            [34.393868352399515, 1.305450047005052],
            [34.396366108165516, 1.302398207628628],
            [34.405379022192086, 1.28767877673742],
            [34.40709769246839, 1.286069185327002],
            [34.40855380854336, 1.285733349415708],
            [34.41601719158689, 1.281433680405941],
            [34.41895884805393, 1.280259450895602],
            [34.42002884755849, 1.280390470699026],
            [34.42219315677588, 1.277685466813601],
            [34.42424230287219, 1.278208895396334],
            [34.4254195261874, 1.277240477488615],
            [34.42674475233559, 1.276805599707193],
            [34.42908209683963, 1.274434638685575],
            [34.434127666092586, 1.271085360060173],
            [34.43741172620996, 1.266335173620832],
            [34.438867780301166, 1.264851071540927],
            [34.444709088012544, 1.261401876141572],
            [34.44684896934244, 1.259501351859235],
            [34.45009236362521, 1.258468462331774],
            [34.45207482867627, 1.257309667899232],
            [34.45310584039919, 1.255029909945259],
            [34.453770184976, 1.254930051126284],
            [34.454025443958926, 1.254423416803025],
            [34.45379847112767, 1.253265862649852],
            [34.45408083677428, 1.253021508382163],
            [34.45944170930206, 1.252303992464044],
            [34.461447136190124, 1.251045700962631],
            [34.46472529707103, 1.249976626280844],
            [34.466798539576466, 1.248483142307552],
            [34.46812370463923, 1.248012094936536],
            [34.46902680704548, 1.248029672592534],
            [34.47081948053491, 1.249005452350123],
            [34.4746535413715, 1.24878621580041],
            [34.476825435064825, 1.246976132061618],
            [34.47993170601106, 1.245907140146637],
            [34.486872972041795, 1.24032289561238],
            [34.49024974188974, 1.238937210241994],
            [34.492230301614086, 1.237470920951144],
            [34.49404774435081, 1.237596509365177],
            [34.49980949366739, 1.234907101652658],
            [34.505106898423705, 1.228446535855505],
            [34.50626199264022, 1.227215875919539],
            [34.50735744411176, 1.226772085085356],
            [34.50854229502206, 1.223524556420062],
            [34.51142953693909, 1.221569384485226],
            [34.514597871589984, 1.218148896461071],
            [34.5162124423962, 1.214050986707814],
            [34.51961788556971, 1.209843548312693],
            [34.52041768081999, 1.207970958982593],
            [34.52268266692623, 1.206052330922058],
            [34.52410458773159, 1.202949402083929],
            [34.52793952981548, 1.197538880358125],
            [34.52998277577697, 1.193784433793109],
            [34.53133086404913, 1.190193184250162],
            [34.532959553676676, 1.188293018110595],
            [34.535210436232944, 1.184267156848539],
            [34.53654636670605, 1.180015702359185],
            [34.536943103159686, 1.18049566289237],
            [34.53631668904746, 1.18674327207809],
            [34.53136062343784, 1.201103534205337],
            [34.5303916287072, 1.202884410722916],
            [34.53033640118184, 1.206157950292265],
            [34.52834038773966, 1.20799684357342],
            [34.526631661813525, 1.213396239340802],
            [34.526023312821664, 1.222317393293854],
            [34.523979734483504, 1.224137185342313],
            [34.52359057442096, 1.225448730465767],
            [34.52380115299829, 1.227851104012774],
            [34.52180616543216, 1.231508639705803],
            [34.52176871376964, 1.232542403779347],
            [34.522292202509895, 1.233326981341106],
            [34.522650436272166, 1.235473334478354],
            [34.522627270517624, 1.237781626911921],
            [34.520882368536675, 1.240665933905785],
            [34.51900579868796, 1.241660978930708],
            [34.51863918993228, 1.242811226727389],
            [34.516701676578045, 1.245486681561838],
            [34.51237201070763, 1.245015390268744],
            [34.51023012164309, 1.24332482179725],
            [34.50909827043625, 1.243028751090237],
            [34.5036904169174, 1.243791694722616],
            [34.501963174018364, 1.244729073153343],
            [34.50044068591864, 1.247722368052581],
            [34.50069182971924, 1.249632718938571],
            [34.49962866639396, 1.252555799237714],
            [34.49889112798612, 1.253529637415676],
            [34.49705019520302, 1.254588871963459],
            [34.49682644283206, 1.257283560161133],
            [34.49559960736032, 1.258641517844001],
            [34.495986613262836, 1.260169923051734],
            [34.4953379074568, 1.261189767036053],
            [34.495759521853955, 1.262716108716857],
            [34.49546949717122, 1.264211496601508],
            [34.49630638565621, 1.265261845534064],
            [34.49629174850698, 1.266908685914831],
            [34.495467008837856, 1.26812630130878],
            [34.494594937834776, 1.268554563388949],
            [34.49405028927803, 1.269628687619153],
            [34.49142701551058, 1.271010305425626],
            [34.49151138618041, 1.273200809390944],
            [34.48946651696319, 1.276161080135918],
            [34.48573242604131, 1.277302975716488],
            [34.48495387774411, 1.27835949909214],
            [34.48238303774153, 1.279014505126019],
            [34.48044540670797, 1.278796055143632],
            [34.47796320616941, 1.280047008350651],
            [34.47382365705077, 1.280723835765736],
            [34.469364091197015, 1.280096706017876],
            [34.46479448800913, 1.280569747615941],
            [34.46056320832359, 1.282427671647154],
            [34.45969376489272, 1.283120713448671],
            [34.45878597417897, 1.284872191377977],
            [34.45272658066942, 1.291069369035035],
            [34.44818397904236, 1.293463223914364],
            [34.44773031006094, 1.294744041164741],
            [34.44823762732945, 1.29648164555496],
            [34.4477055938142, 1.296939293625061],
            [34.4465371578191, 1.296966101466748],
            [34.446667960609304, 1.29867778920432],
            [34.44556523368229, 1.30010271936444],
            [34.44425444525738, 1.300939757789508],
            [34.441268564728894, 1.301242019526415],
            [34.43995763167522, 1.301830786916152],
            [34.43858296494873, 1.304497235576477],
            [34.43707727714146, 1.305073049164902],
            [34.4368440322729, 1.305857200585507],
            [34.43541636584297, 1.306655108576831],
            [34.43166457092346, 1.307127680017246],
            [34.429276636895885, 1.308762425849869],
            [34.427472376037635, 1.309416813338619],
            [34.42329703174986, 1.31328402130451],
            [34.42302829534274, 1.314393873764276],
            [34.42153491984472, 1.316487356811175],
            [34.41811986739263, 1.318423337769531],
            [34.415604690598286, 1.320522529198331],
            [34.41458359178453, 1.321756181841642],
            [34.414843347733765, 1.322625831144036],
            [34.413197193060455, 1.324258928731403],
            [34.41258792958361, 1.325610025260237],
            [34.41074281514286, 1.32601528779725],
            [34.409913879443074, 1.325468301857599],
            [34.40921237964782, 1.32553521921501],
            [34.40843543304678, 1.327024558330746],
            [34.406605909766114, 1.328038670867341],
            [34.406301318901015, 1.328790968470613],
            [34.4052139136395, 1.329651160385241],
            [34.40462896486246, 1.329063101853653],
            [34.40378009374989, 1.32922731460828],
            [34.40256991753512, 1.328741942626183],
            [34.40317443700892, 1.327979239922575],
            [34.402889240770854, 1.327068669048365],
            [34.403324141251005, 1.325892159953948],
            [34.40207268565229, 1.325728598082078],
            [34.400243117455844, 1.32659582927222],
            [34.398722556242426, 1.329225556180272],
            [34.398504605191555, 1.331062169798513],
            [34.39730330702673, 1.331612031026493],
            [34.395240572115135, 1.331451678347243],
            [34.39200198292081, 1.333254304565473],
            [34.38763912250402, 1.333633695987132],
            [34.38606603320267, 1.335021329014052],
            [34.38555850572837, 1.336405448902345],
            [34.38295994371612, 1.339061551528854],
            [34.38002297555652, 1.338365110746567],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1166,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "SIPI",
        Population: 4695,
        Key: "KAPCHORWASIPI",
        Dist2: "Kapchorwa",
        "Sub Country": "Sipi",
        id2_original: "Kapchorwa Sipi",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.53433357002289, 1.223040303294557],
            [34.534395205231135, 1.2236996915482],
            [34.531022906298375, 1.23274570386195],
            [34.52767495709967, 1.244070835194414],
            [34.526417695689275, 1.247291264549548],
            [34.52107680618499, 1.25771429918844],
            [34.520022023243, 1.258700496872786],
            [34.51841422753062, 1.264225769152982],
            [34.51574681504173, 1.26650660754645],
            [34.51388027757807, 1.266166715075755],
            [34.51184207745353, 1.267041336440635],
            [34.5097752075967, 1.269728624905968],
            [34.50864617620151, 1.270219843148647],
            [34.50807018272954, 1.271171375932357],
            [34.5073274421779, 1.271572630921425],
            [34.50672789308254, 1.272901065279176],
            [34.50528976038126, 1.273356572028677],
            [34.504000995952154, 1.275146056726404],
            [34.502248720599404, 1.275269063108795],
            [34.49712007155571, 1.277461636248891],
            [34.496157553678245, 1.280537234029922],
            [34.495232664431384, 1.280709618089116],
            [34.49342051097503, 1.280086632130081],
            [34.490908710049546, 1.280666938116002],
            [34.490485482278174, 1.281074176500482],
            [34.4898342818506, 1.28543388158342],
            [34.48993984287966, 1.286356331305147],
            [34.49039553935866, 1.286735921121134],
            [34.48968883023307, 1.288346211721386],
            [34.48954623974969, 1.290381250014424],
            [34.4881639651911, 1.292109516390537],
            [34.48697273444565, 1.294959158780802],
            [34.484228755850154, 1.298072006863769],
            [34.481820120146836, 1.299357717240128],
            [34.48219103632427, 1.301690919401295],
            [34.480667869098205, 1.303563986724728],
            [34.478750832840845, 1.304198222594768],
            [34.47257307820775, 1.309339043140726],
            [34.470350696500496, 1.31030810080208],
            [34.46977243298583, 1.311647002687971],
            [34.47066621626932, 1.31298503092429],
            [34.47043810886586, 1.313799155057128],
            [34.467798325860166, 1.314596621358297],
            [34.46535906838545, 1.317356589451386],
            [34.4637780748079, 1.318343359479452],
            [34.4627340545813, 1.318452510917771],
            [34.46180083435853, 1.317874225305587],
            [34.459534750511004, 1.318092630599408],
            [34.457941980918406, 1.320083331929831],
            [34.45666631482444, 1.320735280867255],
            [34.45520970198114, 1.322183242213957],
            [34.452575742753424, 1.322419951714799],
            [34.44892258914033, 1.323950609563485],
            [34.44693004319515, 1.324232159799093],
            [34.44497527769586, 1.325743727948598],
            [34.443259165821495, 1.325247293693046],
            [34.44059865419061, 1.325248856343531],
            [34.439928405885745, 1.325864271140057],
            [34.439773994471565, 1.326904472315652],
            [34.43911908400188, 1.327818345468665],
            [34.43739240344819, 1.328479602702848],
            [34.43602830899432, 1.329701403999096],
            [34.433631937989574, 1.330010320566988],
            [34.42987510352131, 1.331926451641863],
            [34.42936546410781, 1.332562097446324],
            [34.429264910288175, 1.333540222860863],
            [34.42799808271829, 1.334951904498389],
            [34.42825697448825, 1.336725876998861],
            [34.427300336982604, 1.337366572311792],
            [34.42482196326715, 1.337954316331039],
            [34.42161109698082, 1.342367748962721],
            [34.41985350809313, 1.343578456698696],
            [34.41900465315027, 1.34549039038612],
            [34.418441825387085, 1.345741390389196],
            [34.4180584828143, 1.348919565712766],
            [34.418966915823496, 1.34919183785759],
            [34.41946699087417, 1.350502925302186],
            [34.41877359837433, 1.35203487591511],
            [34.412365103375684, 1.356081686285667],
            [34.41035461537934, 1.357877650444364],
            [34.409972805332444, 1.359034918423278],
            [34.408853854831385, 1.359181545996007],
            [34.40765503691505, 1.358396135398861],
            [34.406496311708175, 1.359914401734644],
            [34.40559085212261, 1.359865481588496],
            [34.40515727126758, 1.360280938635061],
            [34.4048884917413, 1.364774086549969],
            [34.40414988254166, 1.365632429226998],
            [34.40443362889888, 1.366666833522692],
            [34.40425733093112, 1.369205504286258],
            [34.403157881956545, 1.372478697350008],
            [34.39990042814127, 1.375334222346688],
            [34.39967575769207, 1.377758671000812],
            [34.39728625251104, 1.380034840275227],
            [34.39518207562045, 1.380594740507722],
            [34.39234086427692, 1.384137251282074],
            [34.390907405510035, 1.384709759210642],
            [34.390997479583596, 1.385667122081377],
            [34.39021891601505, 1.386835654352524],
            [34.389058281888175, 1.390300435782548],
            [34.385856815572964, 1.392641163698844],
            [34.38385862820781, 1.393471630743627],
            [34.38082228661487, 1.390401732321867],
            [34.37822940015858, 1.38931313645415],
            [34.37611169104654, 1.389155150382652],
            [34.3766268874384, 1.386671817305388],
            [34.37807413085331, 1.384400754436281],
            [34.380506495554854, 1.382038669828078],
            [34.38093677240625, 1.380157126587349],
            [34.380562474970084, 1.379077584696149],
            [34.37936810640937, 1.378296651135243],
            [34.37865713567606, 1.376868876467996],
            [34.37876374863228, 1.376318465118427],
            [34.378173902240334, 1.375679894144458],
            [34.37524763840568, 1.374482888886922],
            [34.37377425221938, 1.373537519559342],
            [34.37335435899433, 1.372739117865091],
            [34.37346735448066, 1.372100135521777],
            [34.37457782578375, 1.371278029106417],
            [34.37666336263221, 1.371006406953408],
            [34.37939585626681, 1.369964683556125],
            [34.38078656331096, 1.369005141074471],
            [34.38187239472413, 1.366282066978818],
            [34.38187352031319, 1.363981064015963],
            [34.38237147264486, 1.361814128670087],
            [34.383722686155856, 1.360484051541648],
            [34.38496000317033, 1.360033260272258],
            [34.38663120107715, 1.358740356569815],
            [34.38716554146601, 1.358130466846239],
            [34.387063994109646, 1.356273952732885],
            [34.38784620573658, 1.35599898719154],
            [34.38843103952925, 1.354949172031023],
            [34.389385042276146, 1.354482551346802],
            [34.38910847166144, 1.353822979621165],
            [34.389535276524256, 1.353166709900202],
            [34.389604390207275, 1.351665597768697],
            [34.390083051218205, 1.351535599217399],
            [34.389982987878724, 1.35042375182407],
            [34.390678956746775, 1.350356636673039],
            [34.3909214785173, 1.349429909817061],
            [34.392838894762, 1.34731989170731],
            [34.3928985851177, 1.345968196430121],
            [34.39355405793273, 1.344420008522507],
            [34.3958766503032, 1.342677988588944],
            [34.40035126383628, 1.342554862477757],
            [34.40280832951318, 1.341410670621908],
            [34.404029231612455, 1.340064676612809],
            [34.404507737214864, 1.339046997406989],
            [34.40439115206066, 1.338334328491576],
            [34.405924281603234, 1.337495876511042],
            [34.406752610041885, 1.335845647995971],
            [34.40845829427244, 1.335812993231055],
            [34.41069260021678, 1.334567317935779],
            [34.41452290879043, 1.333970361583573],
            [34.416283970565, 1.332965528571167],
            [34.41863277038555, 1.332380264733234],
            [34.41966850994184, 1.330771544415028],
            [34.42415653711874, 1.329036382367372],
            [34.42624785103279, 1.327254752738311],
            [34.43114102019947, 1.325126897755843],
            [34.43413332098728, 1.320584025000191],
            [34.43733540264847, 1.320352591525407],
            [34.43987414674426, 1.319419409657463],
            [34.44346782919061, 1.319630822387941],
            [34.44438823314926, 1.319078975545247],
            [34.44453415638234, 1.31822618101935],
            [34.44525379675644, 1.31761109751678],
            [34.445908754836836, 1.317664687612259],
            [34.44802361718774, 1.319087556673157],
            [34.44999771173697, 1.319298003998884],
            [34.45073941653108, 1.318839684651999],
            [34.451791667122286, 1.317147274437835],
            [34.453663593579336, 1.316310985928471],
            [34.45605742774172, 1.316534434966187],
            [34.45772597831336, 1.313573897941087],
            [34.45894914955708, 1.313102046180134],
            [34.459480659354476, 1.312373623765993],
            [34.46168263313511, 1.311986856756677],
            [34.463021364555274, 1.309000821423759],
            [34.463509509978955, 1.306880453428929],
            [34.468369146832714, 1.303097859258044],
            [34.47029576631751, 1.300999450720187],
            [34.470880121308134, 1.299785713643767],
            [34.472112375417666, 1.299020861964294],
            [34.47408284436645, 1.296738287790349],
            [34.47474205417308, 1.295063620533042],
            [34.47654439802652, 1.293882040179027],
            [34.48928918952608, 1.279912841618259],
            [34.49235250842533, 1.277353338024933],
            [34.49318642887661, 1.275740526749145],
            [34.499156626865, 1.269806146643847],
            [34.49902101539307, 1.266849227489199],
            [34.50110685587208, 1.265083077671629],
            [34.501734026365796, 1.262677799485057],
            [34.50274062996416, 1.261169657731174],
            [34.504291411402065, 1.26022653196531],
            [34.50516447953512, 1.259068437034596],
            [34.50819490662021, 1.2575232241579],
            [34.50921929416628, 1.255943287146759],
            [34.5106094640179, 1.254784893942658],
            [34.5131265012232, 1.253435855086326],
            [34.5144269150049, 1.253223544159078],
            [34.51566059384245, 1.251186628297254],
            [34.519180435670755, 1.249809484194542],
            [34.52015066199169, 1.246529856787534],
            [34.52499415701811, 1.239704483921158],
            [34.5277885517623, 1.233250535355463],
            [34.53127558531981, 1.217114680473103],
            [34.53190244948798, 1.215736003620599],
            [34.53218505318816, 1.210969158332259],
            [34.533324507735564, 1.207924723988925],
            [34.53423444362621, 1.202583227062862],
            [34.53713904818104, 1.192990802486723],
            [34.53730703313919, 1.187247728634519],
            [34.53776222386669, 1.184950281996642],
            [34.53732287492921, 1.180750632377429],
            [34.53826014206237, 1.181705984349208],
            [34.539067112156836, 1.183677132821407],
            [34.53818611279814, 1.192025275111239],
            [34.53879489028638, 1.197080549498559],
            [34.537879641759176, 1.201358898752032],
            [34.53615653111042, 1.205113157098018],
            [34.53594062103188, 1.208649502330216],
            [34.53649593169275, 1.213433485917945],
            [34.53645932803985, 1.217222962315766],
            [34.53433357002289, 1.223040303294557],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1167,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "CHEMA",
        Population: 8650,
        Key: "KAPCHORWACHEMA",
        Dist2: "Kapchorwa",
        "Sub Country": "Chema",
        id2_original: "Kapchorwa Chema",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.53732287492921, 1.180750632377429],
            [34.53776222386669, 1.184950281996642],
            [34.53730703313919, 1.187247728634519],
            [34.53713904818104, 1.192990802486723],
            [34.53423444362621, 1.202583227062862],
            [34.533324507735564, 1.207924723988925],
            [34.53218505318816, 1.210969158332259],
            [34.53190244948798, 1.215736003620599],
            [34.53127558531981, 1.217114680473103],
            [34.5277885517623, 1.233250535355463],
            [34.52499415701811, 1.239704483921158],
            [34.52015066199169, 1.246529856787534],
            [34.519180435670755, 1.249809484194542],
            [34.51566059384245, 1.251186628297254],
            [34.5144269150049, 1.253223544159078],
            [34.5131265012232, 1.253435855086326],
            [34.5106094640179, 1.254784893942658],
            [34.50921929416628, 1.255943287146759],
            [34.50819490662021, 1.2575232241579],
            [34.50516447953512, 1.259068437034596],
            [34.504291411402065, 1.26022653196531],
            [34.50274062996416, 1.261169657731174],
            [34.501734026365796, 1.262677799485057],
            [34.50110685587208, 1.265083077671629],
            [34.49902101539307, 1.266849227489199],
            [34.499156626865, 1.269806146643847],
            [34.49318642887661, 1.275740526749145],
            [34.49235250842533, 1.277353338024933],
            [34.48928918952608, 1.279912841618259],
            [34.47654439802652, 1.293882040179027],
            [34.47474205417308, 1.295063620533042],
            [34.47408284436645, 1.296738287790349],
            [34.472112375417666, 1.299020861964294],
            [34.470880121308134, 1.299785713643767],
            [34.47029576631751, 1.300999450720187],
            [34.468369146832714, 1.303097859258044],
            [34.463509509978955, 1.306880453428929],
            [34.463021364555274, 1.309000821423759],
            [34.46168263313511, 1.311986856756677],
            [34.459480659354476, 1.312373623765993],
            [34.45894914955708, 1.313102046180134],
            [34.45772597831336, 1.313573897941087],
            [34.45605742774172, 1.316534434966187],
            [34.453663593579336, 1.316310985928471],
            [34.451791667122286, 1.317147274437835],
            [34.45073941653108, 1.318839684651999],
            [34.44999771173697, 1.319298003998884],
            [34.44802361718774, 1.319087556673157],
            [34.445908754836836, 1.317664687612259],
            [34.44525379675644, 1.31761109751678],
            [34.44453415638234, 1.31822618101935],
            [34.44438823314926, 1.319078975545247],
            [34.44346782919061, 1.319630822387941],
            [34.43987414674426, 1.319419409657463],
            [34.43733540264847, 1.320352591525407],
            [34.43413332098728, 1.320584025000191],
            [34.43114102019947, 1.325126897755843],
            [34.42624785103279, 1.327254752738311],
            [34.42415653711874, 1.329036382367372],
            [34.41966850994184, 1.330771544415028],
            [34.41863277038555, 1.332380264733234],
            [34.416283970565, 1.332965528571167],
            [34.41452290879043, 1.333970361583573],
            [34.41069260021678, 1.334567317935779],
            [34.40845829427244, 1.335812993231055],
            [34.406752610041885, 1.335845647995971],
            [34.405924281603234, 1.337495876511042],
            [34.40439115206066, 1.338334328491576],
            [34.404507737214864, 1.339046997406989],
            [34.404029231612455, 1.340064676612809],
            [34.40280832951318, 1.341410670621908],
            [34.40035126383628, 1.342554862477757],
            [34.3958766503032, 1.342677988588944],
            [34.39355405793273, 1.344420008522507],
            [34.3928985851177, 1.345968196430121],
            [34.392838894762, 1.34731989170731],
            [34.3909214785173, 1.349429909817061],
            [34.390678956746775, 1.350356636673039],
            [34.389982987878724, 1.35042375182407],
            [34.390083051218205, 1.351535599217399],
            [34.389604390207275, 1.351665597768697],
            [34.389535276524256, 1.353166709900202],
            [34.38910847166144, 1.353822979621165],
            [34.389385042276146, 1.354482551346802],
            [34.38843103952925, 1.354949172031023],
            [34.38784620573658, 1.35599898719154],
            [34.387063994109646, 1.356273952732885],
            [34.38716554146601, 1.358130466846239],
            [34.38663120107715, 1.358740356569815],
            [34.38643412507685, 1.358261954929943],
            [34.38342169573845, 1.357219512952716],
            [34.38334583660596, 1.356880853271748],
            [34.37829949210694, 1.357185192566724],
            [34.37557131577559, 1.358333292553595],
            [34.3744562531831, 1.35664471647225],
            [34.37096270594147, 1.355618995747121],
            [34.36933778384822, 1.354387601702788],
            [34.369261264453996, 1.351621208195487],
            [34.37060303667136, 1.350757347316715],
            [34.37113422756687, 1.349583039969461],
            [34.37251591732222, 1.349542093543678],
            [34.3739494371745, 1.348044745664821],
            [34.375037080489584, 1.345990464011841],
            [34.37522123602116, 1.343595774149773],
            [34.37592994479659, 1.341768993880705],
            [34.37729251121616, 1.340980848425647],
            [34.3781475869924, 1.341288817908949],
            [34.379727394793775, 1.339583302281693],
            [34.38002297555652, 1.338365110746567],
            [34.38295994371612, 1.339061551528854],
            [34.38555850572837, 1.336405448902345],
            [34.38606603320267, 1.335021329014052],
            [34.38763912250402, 1.333633695987132],
            [34.39200198292081, 1.333254304565473],
            [34.395240572115135, 1.331451678347243],
            [34.39730330702673, 1.331612031026493],
            [34.398504605191555, 1.331062169798513],
            [34.398722556242426, 1.329225556180272],
            [34.400243117455844, 1.32659582927222],
            [34.40207268565229, 1.325728598082078],
            [34.403324141251005, 1.325892159953948],
            [34.402889240770854, 1.327068669048365],
            [34.40317443700892, 1.327979239922575],
            [34.40256991753512, 1.328741942626183],
            [34.40378009374989, 1.32922731460828],
            [34.40462896486246, 1.329063101853653],
            [34.4052139136395, 1.329651160385241],
            [34.406301318901015, 1.328790968470613],
            [34.406605909766114, 1.328038670867341],
            [34.40843543304678, 1.327024558330746],
            [34.40921237964782, 1.32553521921501],
            [34.409913879443074, 1.325468301857599],
            [34.41074281514286, 1.32601528779725],
            [34.41258792958361, 1.325610025260237],
            [34.413197193060455, 1.324258928731403],
            [34.414843347733765, 1.322625831144036],
            [34.41458359178453, 1.321756181841642],
            [34.415604690598286, 1.320522529198331],
            [34.41811986739263, 1.318423337769531],
            [34.42153491984472, 1.316487356811175],
            [34.42302829534274, 1.314393873764276],
            [34.42329703174986, 1.31328402130451],
            [34.427472376037635, 1.309416813338619],
            [34.429276636895885, 1.308762425849869],
            [34.43166457092346, 1.307127680017246],
            [34.43541636584297, 1.306655108576831],
            [34.4368440322729, 1.305857200585507],
            [34.43707727714146, 1.305073049164902],
            [34.43858296494873, 1.304497235576477],
            [34.43995763167522, 1.301830786916152],
            [34.441268564728894, 1.301242019526415],
            [34.44425444525738, 1.300939757789508],
            [34.44556523368229, 1.30010271936444],
            [34.446667960609304, 1.29867778920432],
            [34.4465371578191, 1.296966101466748],
            [34.4477055938142, 1.296939293625061],
            [34.44823762732945, 1.29648164555496],
            [34.44773031006094, 1.294744041164741],
            [34.44818397904236, 1.293463223914364],
            [34.45272658066942, 1.291069369035035],
            [34.45878597417897, 1.284872191377977],
            [34.45969376489272, 1.283120713448671],
            [34.46056320832359, 1.282427671647154],
            [34.46479448800913, 1.280569747615941],
            [34.469364091197015, 1.280096706017876],
            [34.47382365705077, 1.280723835765736],
            [34.47796320616941, 1.280047008350651],
            [34.48044540670797, 1.278796055143632],
            [34.48238303774153, 1.279014505126019],
            [34.48495387774411, 1.27835949909214],
            [34.48573242604131, 1.277302975716488],
            [34.48946651696319, 1.276161080135918],
            [34.49151138618041, 1.273200809390944],
            [34.49142701551058, 1.271010305425626],
            [34.49405028927803, 1.269628687619153],
            [34.494594937834776, 1.268554563388949],
            [34.495467008837856, 1.26812630130878],
            [34.49629174850698, 1.266908685914831],
            [34.49630638565621, 1.265261845534064],
            [34.49546949717122, 1.264211496601508],
            [34.495759521853955, 1.262716108716857],
            [34.4953379074568, 1.261189767036053],
            [34.495986613262836, 1.260169923051734],
            [34.49559960736032, 1.258641517844001],
            [34.49682644283206, 1.257283560161133],
            [34.49705019520302, 1.254588871963459],
            [34.49889112798612, 1.253529637415676],
            [34.49962866639396, 1.252555799237714],
            [34.50069182971924, 1.249632718938571],
            [34.50044068591864, 1.247722368052581],
            [34.501963174018364, 1.244729073153343],
            [34.5036904169174, 1.243791694722616],
            [34.50909827043625, 1.243028751090237],
            [34.51023012164309, 1.24332482179725],
            [34.51237201070763, 1.245015390268744],
            [34.516701676578045, 1.245486681561838],
            [34.51863918993228, 1.242811226727389],
            [34.51900579868796, 1.241660978930708],
            [34.520882368536675, 1.240665933905785],
            [34.522627270517624, 1.237781626911921],
            [34.522650436272166, 1.235473334478354],
            [34.522292202509895, 1.233326981341106],
            [34.52176871376964, 1.232542403779347],
            [34.52180616543216, 1.231508639705803],
            [34.52380115299829, 1.227851104012774],
            [34.52359057442096, 1.225448730465767],
            [34.523979734483504, 1.224137185342313],
            [34.526023312821664, 1.222317393293854],
            [34.526631661813525, 1.213396239340802],
            [34.52834038773966, 1.20799684357342],
            [34.53033640118184, 1.206157950292265],
            [34.5303916287072, 1.202884410722916],
            [34.53136062343784, 1.201103534205337],
            [34.53631668904746, 1.18674327207809],
            [34.536943103159686, 1.18049566289237],
            [34.53732287492921, 1.180750632377429],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1168,
        District: "KAPCHORWA",
        County: "TINGEY",
        Subcounty: "MUNARYA",
        Population: 5515,
        Key: "KAPCHORWAMUNARYA",
        Dist2: "Kapchorwa",
        "Sub Country": "Munarya",
        id2_original: "Kapchorwa Munarya",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.161062379051565, 0.970838254584283],
            [33.160019810502476, 0.974803686518355],
            [33.15493664585659, 0.979779481951039],
            [33.15284408957248, 0.980078111033369],
            [33.151629349916064, 0.981724623562817],
            [33.15007486472423, 0.979861122379563],
            [33.144351804050316, 0.984312238699222],
            [33.141726592616834, 0.982322129252259],
            [33.13727691631602, 0.976939666527641],
            [33.1355674124489, 0.975528486927172],
            [33.13560874842667, 0.969666372713459],
            [33.135469696407235, 0.969295472807193],
            [33.133521196657064, 0.968598972930632],
            [33.128148771794706, 0.968373020529639],
            [33.12796701566328, 0.967694541690808],
            [33.127555248598306, 0.967821207634934],
            [33.12529366620868, 0.969802470441443],
            [33.11456981729871, 0.976218919931368],
            [33.113531604680446, 0.97378333980898],
            [33.1140716215236, 0.970200915875795],
            [33.1123319558225, 0.965189225515525],
            [33.111735156470225, 0.95883861670798],
            [33.11239041818117, 0.957807296509654],
            [33.11244064568365, 0.956115605064906],
            [33.11297736481142, 0.954948589918349],
            [33.11797467656731, 0.951709780757616],
            [33.1183265897832, 0.950868446603653],
            [33.12266987052009, 0.951818173591142],
            [33.12501813763967, 0.95155252181779],
            [33.123807320926105, 0.948642819665437],
            [33.12253264567391, 0.947430636381993],
            [33.123870147300444, 0.944986655598678],
            [33.12230407024816, 0.941125250337353],
            [33.119464504618215, 0.938066229823695],
            [33.11925044237424, 0.93905014739572],
            [33.11746922060805, 0.941483936049771],
            [33.11731035983828, 0.944858589426933],
            [33.115646643101144, 0.949137995661462],
            [33.11385535391558, 0.946517579601683],
            [33.11386143820503, 0.942193023322272],
            [33.11265806942347, 0.939651001831242],
            [33.112489761071814, 0.937724107373959],
            [33.11336969143534, 0.935742899771863],
            [33.11375878951413, 0.932734682826608],
            [33.11349475039763, 0.929120871881482],
            [33.11121359551456, 0.924588657657076],
            [33.110993878375865, 0.922308951438532],
            [33.109401761858486, 0.918988941792053],
            [33.109070544928386, 0.916935400619893],
            [33.106210917223194, 0.91643793057977],
            [33.100834771538956, 0.914542871895519],
            [33.103576135138674, 0.914810596816737],
            [33.10478242973311, 0.914340802746196],
            [33.10774096374772, 0.914340714722523],
            [33.11063782482481, 0.913099753855357],
            [33.11538378257431, 0.912390535905111],
            [33.11732883099713, 0.912800850443707],
            [33.122495135620916, 0.910457684141097],
            [33.12333121382553, 0.907761804769624],
            [33.1230665755327, 0.902054068931387],
            [33.12391266456284, 0.900578880014107],
            [33.12655533744879, 0.898009589009442],
            [33.12622989399103, 0.896938144418153],
            [33.1241169100174, 0.894789491406923],
            [33.124353951166356, 0.892667200389213],
            [33.1232480998988, 0.891840004427007],
            [33.12324892095895, 0.891290071192368],
            [33.12152849447626, 0.889207537294177],
            [33.12048746923285, 0.886032257053819],
            [33.119228839688276, 0.885118603484284],
            [33.121881917760184, 0.880087752702149],
            [33.12274352878013, 0.879717739849308],
            [33.12345804336722, 0.878831160359522],
            [33.12474219045575, 0.878505444389772],
            [33.126074321953496, 0.876886078852417],
            [33.129658572089355, 0.877329233224549],
            [33.12935729780434, 0.876649064558167],
            [33.13012358050464, 0.877927290120128],
            [33.1357277275911, 0.883931933872436],
            [33.136201747007, 0.885018606873852],
            [33.13428537640125, 0.887451769236754],
            [33.13528124962355, 0.888953753359495],
            [33.135748367283085, 0.890515248460525],
            [33.13528811454894, 0.892319041255194],
            [33.137283621341325, 0.894116127160091],
            [33.13759026845008, 0.895023850343071],
            [33.139634323793636, 0.897492947772668],
            [33.14060105117654, 0.898012238714028],
            [33.14358984494148, 0.897095260267233],
            [33.144757105041876, 0.895611592981244],
            [33.14806542865509, 0.892951797031563],
            [33.149224217642356, 0.890949800877324],
            [33.15138720813292, 0.889785396992314],
            [33.15760834151274, 0.888021712409608],
            [33.15922601959156, 0.89350316086004],
            [33.16027090579406, 0.894199692643747],
            [33.16252236776369, 0.893113486717132],
            [33.16474240127481, 0.893448636159253],
            [33.16976462780509, 0.897179524486589],
            [33.16968973525984, 0.899618094081247],
            [33.169297653875994, 0.900079481971599],
            [33.164304014433014, 0.898849656650041],
            [33.163224514345956, 0.898903721389618],
            [33.16168617098146, 0.901601411834586],
            [33.1612309577961, 0.904605843914412],
            [33.16146518362496, 0.906873735640201],
            [33.15822574372605, 0.911089532275567],
            [33.15851710959352, 0.912567130377598],
            [33.161105969800715, 0.914077913703966],
            [33.16229434839514, 0.914313088757293],
            [33.162863714096936, 0.915172556444921],
            [33.16054984436788, 0.920374857427513],
            [33.158346537487354, 0.923396754569763],
            [33.15784196457204, 0.926907129524462],
            [33.158131291263835, 0.940061888058113],
            [33.15765057400921, 0.94850583458026],
            [33.157829541769985, 0.951593437130486],
            [33.159039385608125, 0.956007263563554],
            [33.15881634200794, 0.95956592018716],
            [33.15761405389965, 0.96292893420318],
            [33.15885267167465, 0.966606623991325],
            [33.161062379051565, 0.970838254584283],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1170,
        District: "KAMULI",
        County: "KAMULI MUNICIPALITY",
        Subcounty: "NORTHERN DIVISION",
        Population: 30272,
        Key: "KAMULINORTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.10975650117429, 0.856677497027398],
            [33.10799389699237, 0.854620943701843],
            [33.10718528747253, 0.854928575262861],
            [33.10588445597422, 0.853952509740913],
            [33.10500505561672, 0.853773423528121],
            [33.10471855053325, 0.852239926755322],
            [33.10175633791756, 0.850511861351946],
            [33.101807525719096, 0.849266486028898],
            [33.100917036557725, 0.847775235099321],
            [33.10016772932134, 0.847433697969632],
            [33.09977067037251, 0.84572990833701],
            [33.10025061956758, 0.842407270426543],
            [33.0967198470389, 0.842615448654577],
            [33.09541130440216, 0.843330220047516],
            [33.093342727746276, 0.843683116401726],
            [33.09093965800447, 0.84491361005338],
            [33.085005261473434, 0.847021772923771],
            [33.08236348330949, 0.847513819825967],
            [33.078134796161834, 0.849478382505484],
            [33.076784107266946, 0.850704023948853],
            [33.07637455544745, 0.852094676257628],
            [33.077615227669476, 0.854392254472817],
            [33.07866395147488, 0.855240896380826],
            [33.07948654506877, 0.858994321231436],
            [33.079390618471145, 0.860595056497311],
            [33.08011034688017, 0.861899086884026],
            [33.0839447571614, 0.864427464940407],
            [33.086236927186434, 0.866890186473758],
            [33.0885600477663, 0.871784582548368],
            [33.0879731685097, 0.873979946855218],
            [33.08826738383326, 0.876923108461008],
            [33.08778578712798, 0.880958226105954],
            [33.09282295264142, 0.882858041163854],
            [33.09130940727037, 0.885409423493683],
            [33.08983319228924, 0.887001789692105],
            [33.08974850631077, 0.888431941666642],
            [33.085707658685656, 0.88533610456828],
            [33.08024853202537, 0.887771487091408],
            [33.076425692044985, 0.887757369066638],
            [33.07157306115213, 0.886557586466775],
            [33.06664282839514, 0.884321217365187],
            [33.06588586032605, 0.884432856569952],
            [33.06388526008602, 0.886676629530371],
            [33.06137244226762, 0.892473403401509],
            [33.05848153702086, 0.895657081702281],
            [33.05572778745003, 0.897582190733483],
            [33.05518082573139, 0.896888003908153],
            [33.0514280974623, 0.886903009305686],
            [33.041400246166496, 0.880965137824966],
            [33.037673321105636, 0.876374854466413],
            [33.036675798576496, 0.874462933621077],
            [33.030554132953114, 0.874242910625775],
            [33.02233646510826, 0.872856134106383],
            [33.0176980851056, 0.872711262542321],
            [33.01691665501298, 0.87222291772157],
            [33.01495130915631, 0.872531377805106],
            [33.01391128283947, 0.871905869814807],
            [33.012740440257716, 0.87253797067475],
            [33.01161538211106, 0.872228509984477],
            [33.01033988130713, 0.872643327244905],
            [33.00944408849233, 0.871911923758764],
            [33.00665737434381, 0.872234285482449],
            [33.00491431301089, 0.871930404455617],
            [33.005364960958, 0.866164311270149],
            [33.00726737803243, 0.862573638984657],
            [33.010566878392915, 0.858145139429609],
            [33.01015070239649, 0.850185825882502],
            [33.010774922822804, 0.846565232486374],
            [33.01410413226636, 0.842376108542713],
            [33.01704691791572, 0.840670528341163],
            [33.020911172027326, 0.837379063314664],
            [33.02373505397071, 0.836271924279707],
            [33.027747925362924, 0.833040296798173],
            [33.029917838271075, 0.830407123477214],
            [33.031344606385716, 0.825829009974301],
            [33.0315526624937, 0.823375383855724],
            [33.03511956705974, 0.811915137544979],
            [33.03636794682693, 0.804284954322768],
            [33.037252559209726, 0.802067743791938],
            [33.04326731004293, 0.80250053571475],
            [33.06002593233543, 0.802771741926823],
            [33.05927806869172, 0.811664729447789],
            [33.058790647310126, 0.8128796515339],
            [33.056736090660905, 0.815196859072106],
            [33.05627954886721, 0.817600219314172],
            [33.05443424847519, 0.8194865418979],
            [33.05354966034692, 0.821573929005646],
            [33.05250334402647, 0.821918647191772],
            [33.05222473243943, 0.823376971014928],
            [33.05110441290589, 0.823638625025123],
            [33.05211720050668, 0.824892675432941],
            [33.05349744217778, 0.825100163854272],
            [33.05365877960281, 0.82590312316695],
            [33.054913559866385, 0.827211302393105],
            [33.054877717984866, 0.827869911695144],
            [33.05429515153996, 0.827978184213031],
            [33.05442063360875, 0.828411241020819],
            [33.05503905002002, 0.828194703191539],
            [33.0564461809625, 0.828519476696855],
            [33.05687637606723, 0.827842817741323],
            [33.05767404680187, 0.827869871275161],
            [33.05809528390658, 0.827490939445707],
            [33.05867785124981, 0.827445820876332],
            [33.059188728541784, 0.828086377684472],
            [33.060102901785605, 0.827328512234262],
            [33.06040921561941, 0.826310342849333],
            [33.06196694013614, 0.825832689091514],
            [33.062378746726985, 0.825337030414649],
            [33.06302332746921, 0.825445161980757],
            [33.06330977955209, 0.823732902454332],
            [33.06472426769677, 0.823534618047657],
            [33.067490520918064, 0.819803657861067],
            [33.069039293723016, 0.819587346814395],
            [33.071223709033085, 0.820317269114668],
            [33.072262189349324, 0.819929739671634],
            [33.0724859776529, 0.818686097218816],
            [33.07307684542932, 0.818920395240366],
            [33.0738198698486, 0.817280221674517],
            [33.074589778149374, 0.817099970590085],
            [33.07484043146986, 0.816306921412367],
            [33.076102725242464, 0.816090612871906],
            [33.076899502153395, 0.816550202711573],
            [33.07748140115005, 0.815982443327478],
            [33.0779290361477, 0.816577217698314],
            [33.07892275431163, 0.816369925545892],
            [33.079083888717385, 0.815874269289044],
            [33.07984485428953, 0.816162633382784],
            [33.08031932016809, 0.815468710258881],
            [33.08218143522557, 0.815630886449603],
            [33.08293345267916, 0.81619861803837],
            [33.08495668956601, 0.815306401124414],
            [33.08550276554578, 0.814197930162289],
            [33.086415915608505, 0.814188898514083],
            [33.08812580934446, 0.813044353637023],
            [33.08929858599904, 0.813332708052833],
            [33.08914637905057, 0.812647808907582],
            [33.089773050979296, 0.81265680642668],
            [33.08992523097829, 0.81215213871973],
            [33.09342553624582, 0.811046076829906],
            [33.09510475251483, 0.80622700728547],
            [33.09572179899529, 0.806116377235377],
            [33.096178221313046, 0.805052762094485],
            [33.096888248815304, 0.805069762829518],
            [33.09718407661479, 0.80432097860583],
            [33.09837591551967, 0.804533670615733],
            [33.09829981114711, 0.803325418063549],
            [33.09916198091915, 0.803010570628467],
            [33.09892526675693, 0.801444949785128],
            [33.09963530324236, 0.801776777430158],
            [33.09966064381818, 0.801087561253852],
            [33.10029459030411, 0.800789736855148],
            [33.10075945858217, 0.799555943886201],
            [33.10207804977364, 0.798279586211913],
            [33.10353190029743, 0.797700948529897],
            [33.10465611312942, 0.79787109630566],
            [33.10516325612476, 0.797079761689417],
            [33.1074032034891, 0.79640750597393],
            [33.1080286752686, 0.795343884721158],
            [33.10858655780613, 0.795505538943632],
            [33.10944026185492, 0.794816300158673],
            [33.110944843836066, 0.794926874823439],
            [33.112836579043446, 0.793941019165624],
            [33.11426131337228, 0.79360662374995],
            [33.11545008632711, 0.794631653046129],
            [33.116634435079156, 0.793769335256053],
            [33.11732933854529, 0.794235652652344],
            [33.11773139751699, 0.793663717886724],
            [33.11974177951215, 0.793923224350079],
            [33.12053716762764, 0.793197299824245],
            [33.12145495120059, 0.793342452762658],
            [33.121996852709216, 0.792466954984422],
            [33.122516936834536, 0.792770498112505],
            [33.123122657355886, 0.792317048585411],
            [33.123943395030366, 0.792784076644713],
            [33.12500240903736, 0.792141019872691],
            [33.129053657356835, 0.793096969417552],
            [33.1296336240773, 0.793723054002522],
            [33.13089438891731, 0.794146056107333],
            [33.13224333328393, 0.795483122748107],
            [33.133410172972795, 0.795045617977981],
            [33.13432872640192, 0.795907644475493],
            [33.13653871944311, 0.796102228633677],
            [33.13820316022234, 0.797471730561645],
            [33.13984684812188, 0.797784517886429],
            [33.1418232567313, 0.799700011541479],
            [33.14310660521755, 0.800063649163894],
            [33.145900833773446, 0.802888200663188],
            [33.148643658033805, 0.804506541473869],
            [33.14866616172999, 0.805456507750046],
            [33.14959923822233, 0.806651247653225],
            [33.15226376801749, 0.806942686134411],
            [33.15429908904157, 0.8105939075014],
            [33.15520593832088, 0.810992890215732],
            [33.155220842269756, 0.812993612915424],
            [33.153741286454085, 0.814478853484167],
            [33.153296998579194, 0.816584925358883],
            [33.150253050950724, 0.820836869653942],
            [33.14951832516806, 0.82127116858285],
            [33.14847694958169, 0.823207331806481],
            [33.14077466587658, 0.827740315394933],
            [33.13875068608296, 0.833919701118231],
            [33.1371141622478, 0.836299201412425],
            [33.13509305346984, 0.836407840172548],
            [33.13159549974205, 0.838552173534034],
            [33.130311109210076, 0.838905061338125],
            [33.12716203803215, 0.838986591777331],
            [33.12650705300227, 0.8388237617395],
            [33.12574949024847, 0.836742903902143],
            [33.12494281120816, 0.835765820617163],
            [33.12272003873376, 0.835847316989335],
            [33.12257542973594, 0.837050614127211],
            [33.12031478428914, 0.838588729253876],
            [33.11936101690086, 0.840407269445568],
            [33.118355531705056, 0.840977280756426],
            [33.118423563816435, 0.843031020034757],
            [33.118016922538466, 0.84480430684883],
            [33.11925369158061, 0.848468432171464],
            [33.12013309193811, 0.848640303255476],
            [33.121790843861746, 0.850992553458988],
            [33.12019701246047, 0.853914886187599],
            [33.11869832612252, 0.854674908479997],
            [33.11767404278105, 0.855986801165063],
            [33.10973869566702, 0.856348931809072],
            [33.10975650117429, 0.856677497027398],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1171,
        District: "KAMULI",
        County: "BUZAAYA",
        Subcounty: "MBULAMUTI",
        Population: 29507,
        Key: "KAMULIMBULAMUTI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.25267565384581, 0.783077486097702],
            [33.250063604527874, 0.782290533830265],
            [33.24823848209376, 0.790225084374946],
            [33.24324098258998, 0.802203950074161],
            [33.24345971337851, 0.815286268324072],
            [33.24260897916005, 0.819936610181662],
            [33.24044197499679, 0.822216650577623],
            [33.23053610773005, 0.825492350076462],
            [33.221936831060916, 0.829337934124161],
            [33.21787187265357, 0.829157216509741],
            [33.2172520216328, 0.829482952829234],
            [33.216085964376546, 0.831156762432264],
            [33.21596255651776, 0.83431426764748],
            [33.214510276249094, 0.835617155371001],
            [33.21414070484962, 0.836476666246375],
            [33.213562674896885, 0.841470793417744],
            [33.210961896740834, 0.846176819084875],
            [33.21114584835483, 0.848551942080037],
            [33.21015070905613, 0.853000610465494],
            [33.2067021377658, 0.851716062050417],
            [33.20579529387638, 0.850308026423915],
            [33.2048751037168, 0.849748614539134],
            [33.202580847803645, 0.848875428548383],
            [33.201549430940524, 0.849137476074255],
            [33.200373391604856, 0.848846435011623],
            [33.19270093286548, 0.845237273774215],
            [33.19128171688744, 0.845268990733554],
            [33.18897637756032, 0.844109060287038],
            [33.187079673771095, 0.842171525869528],
            [33.1856622804748, 0.839988478569892],
            [33.185019739806584, 0.836071033868217],
            [33.1844380447275, 0.83557346057283],
            [33.1843941171101, 0.833157836113419],
            [33.18394357696081, 0.832470263675055],
            [33.180538961135696, 0.829961224123339],
            [33.17880588188222, 0.829645086234036],
            [33.177270166988265, 0.828775336841041],
            [33.17609131323079, 0.82746839677818],
            [33.17543082871479, 0.826001839555344],
            [33.173140964665066, 0.824045485650282],
            [33.17104264389182, 0.822984665120836],
            [33.16783905216265, 0.81909151759769],
            [33.16607967023766, 0.818061194042146],
            [33.16480794235794, 0.816702461567236],
            [33.16265023665617, 0.815761355318418],
            [33.161398765786096, 0.813936560273156],
            [33.160040572365325, 0.814171883445718],
            [33.1590135698235, 0.81310762279789],
            [33.15520593832088, 0.810992890215732],
            [33.15429908904157, 0.8105939075014],
            [33.15226376801749, 0.806942686134411],
            [33.14959923822233, 0.806651247653225],
            [33.14866616172999, 0.805456507750046],
            [33.148643658033805, 0.804506541473869],
            [33.145900833773446, 0.802888200663188],
            [33.14310660521755, 0.800063649163894],
            [33.1418232567313, 0.799700011541479],
            [33.13984684812188, 0.797784517886429],
            [33.13820316022234, 0.797471730561645],
            [33.13653871944311, 0.796102228633677],
            [33.13432872640192, 0.795907644475493],
            [33.133410172972795, 0.795045617977981],
            [33.13224333328393, 0.795483122748107],
            [33.13089438891731, 0.794146056107333],
            [33.1296336240773, 0.793723054002522],
            [33.129053657356835, 0.793096969417552],
            [33.12500240903736, 0.792141019872691],
            [33.123943395030366, 0.792784076644713],
            [33.123122657355886, 0.792317048585411],
            [33.124751269728314, 0.7904840090007],
            [33.12596402770124, 0.790194457431729],
            [33.1263204513582, 0.79046586655535],
            [33.12724923031025, 0.789343970204577],
            [33.12858106895721, 0.788891563148363],
            [33.12912956140508, 0.787823962602452],
            [33.131079023250905, 0.787606766003356],
            [33.13176771307021, 0.788086252148412],
            [33.131792684438494, 0.787253897967596],
            [33.13243445884379, 0.787371492504928],
            [33.13336268892518, 0.786683866489296],
            [33.13388482749753, 0.787163357231658],
            [33.13398059239841, 0.786855745607795],
            [33.134693427135936, 0.787018574148331],
            [33.13659707400396, 0.785788077173299],
            [33.138711435993244, 0.786629406767006],
            [33.13928461594174, 0.784838020141014],
            [33.14004547191941, 0.784810852245878],
            [33.14083294408061, 0.782811369771459],
            [33.141962561177365, 0.782494674910539],
            [33.14208246380991, 0.781752791307996],
            [33.14303456572164, 0.781110400221588],
            [33.14336848298749, 0.78029613055462],
            [33.14313142387222, 0.779943293341001],
            [33.144525266036744, 0.777735701552242],
            [33.14661767948868, 0.777482303861427],
            [33.14752340587392, 0.775953277295141],
            [33.14705010331363, 0.77449667741551],
            [33.14731213559382, 0.774161917560535],
            [33.149000110436866, 0.774044242710982],
            [33.14945228551995, 0.773691381621164],
            [33.15056329132064, 0.771348089482654],
            [33.15032480657901, 0.770407177712618],
            [33.150944074593156, 0.769529566998497],
            [33.15144317048016, 0.769674305770485],
            [33.151301864587666, 0.768742437953462],
            [33.15163551325725, 0.768335297909244],
            [33.15213460465267, 0.768362421896773],
            [33.153277113472036, 0.767412413045427],
            [33.153847545474115, 0.767484771239966],
            [33.154443216542376, 0.766507639991039],
            [33.15506084153787, 0.76679713120836],
            [33.15575952152147, 0.763983393488215],
            [33.156372914553664, 0.763766236085929],
            [33.15695678535235, 0.762707679823494],
            [33.157622978661976, 0.76249051966211],
            [33.15748139608838, 0.761703409086032],
            [33.15817282666763, 0.760364382569143],
            [33.158174198395066, 0.759459652045245],
            [33.15888784970115, 0.759061543787278],
            [33.159127110587214, 0.758174898985468],
            [33.15980566291854, 0.758002975591619],
            [33.16304988185475, 0.766855462578299],
            [33.16336357984015, 0.778168202287767],
            [33.164268486063506, 0.779404349582055],
            [33.16490878902836, 0.781731881372926],
            [33.16972466894463, 0.784546082478123],
            [33.17052724537903, 0.783280244761621],
            [33.17146362767161, 0.782876226572242],
            [33.17170438604923, 0.782135586189706],
            [33.17392492710847, 0.780654233174058],
            [33.175784319372355, 0.779980853812472],
            [33.1773761987345, 0.780048117020551],
            [33.17955661564326, 0.778809151262196],
            [33.18417173646657, 0.779239862609092],
            [33.19101922736477, 0.774268723784391],
            [33.19441849282407, 0.774368087244921],
            [33.19629742793697, 0.773825162702874],
            [33.19929018237398, 0.771591672539196],
            [33.202781985985645, 0.769892326974322],
            [33.20359371086291, 0.76902324309312],
            [33.20498529556113, 0.768724846032158],
            [33.20711121257991, 0.765923045325286],
            [33.20811022002422, 0.765325459404899],
            [33.207338589653034, 0.763823203975698],
            [33.20789401350164, 0.76396532278784],
            [33.21045447167451, 0.761823525680432],
            [33.21305263393645, 0.760705178752384],
            [33.214538426755134, 0.760976131666634],
            [33.214961293403775, 0.76031786830648],
            [33.21796061632216, 0.759140751175174],
            [33.22055226939157, 0.757307402614575],
            [33.22524142217408, 0.755548294378651],
            [33.23290577990623, 0.75032754633035],
            [33.23652370698378, 0.748563133873781],
            [33.23747135415004, 0.749124012893909],
            [33.239772881925404, 0.752281380274634],
            [33.24066162296523, 0.754172207375787],
            [33.24073078246233, 0.755411678789022],
            [33.24515278885575, 0.758333692848111],
            [33.250475445254715, 0.764883595057979],
            [33.25071116857516, 0.771089996341209],
            [33.25147122415388, 0.771922298026788],
            [33.25267565384581, 0.783077486097702],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1172,
        District: "KAMULI",
        County: "BUZAAYA",
        Subcounty: "BUGULUMBYA",
        Population: 36281,
        Key: "KAMULIBUGULUMBYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.05305459699722, 0.984082424270128],
            [33.05419081940624, 0.985024534349818],
            [33.05514150736973, 0.987261630546971],
            [33.0549745869152, 0.992447077776643],
            [33.05439654079282, 0.995705770322255],
            [33.05457107716432, 0.997887383273698],
            [33.05862060521002, 1.005993609782865],
            [33.0594852175013, 1.013412916411624],
            [33.06166929594316, 1.020282617712223],
            [33.0613508243103, 1.021427581325349],
            [33.05779835297593, 1.027498377670338],
            [33.053467898384696, 1.038445715908629],
            [33.05209104605714, 1.04060804952207],
            [33.050242860276455, 1.042218503191024],
            [33.04648044906692, 1.043512329078928],
            [33.04510973313107, 1.043222834797932],
            [33.040073216201264, 1.043476229080556],
            [33.03844945023975, 1.0451590518928],
            [33.03408742974774, 1.054486895222569],
            [33.02982647601342, 1.061154818965385],
            [33.028642035633226, 1.066800361541018],
            [33.02490265722757, 1.07297067032376],
            [33.022462051381616, 1.075006337048907],
            [33.017028322789336, 1.077991990559978],
            [33.01518261995206, 1.078625312830195],
            [33.00964044314545, 1.077738697900512],
            [33.0078422081861, 1.078281542662847],
            [33.006421766007726, 1.079032473910733],
            [33.00431146799678, 1.081384782149515],
            [33.001788822609164, 1.08315806081724],
            [32.97311436966967, 1.093951399078235],
            [32.96721708074641, 1.098013587595486],
            [32.95612275852845, 1.111295067390266],
            [32.95307723166172, 1.107888996404542],
            [32.94779192272068, 1.103378471823437],
            [32.941587478242205, 1.096670528314028],
            [32.937853423252946, 1.088285669633163],
            [32.93733643831534, 1.085394354885655],
            [32.937279069206376, 1.081520004814492],
            [32.93986449156098, 1.071227013275069],
            [32.94296691412451, 1.062148373730075],
            [32.94371384980852, 1.05671273402325],
            [32.943426640445885, 1.054746641300527],
            [32.94170326838738, 1.049715737541028],
            [32.93572890580938, 1.03450735478142],
            [32.934548438677645, 1.029489811312403],
            [32.93435028110575, 1.027799497513335],
            [32.93498232406156, 1.022248204645567],
            [32.93693567381595, 1.016696936311212],
            [32.94382955730869, 1.010740974702211],
            [32.9452083814383, 1.006519690766451],
            [32.945897936335214, 0.995648391013711],
            [32.94497896608777, 0.983851844573408],
            [32.9456110288065, 0.975293587269422],
            [32.94767922367843, 0.969684485545186],
            [32.94986228073578, 0.965810166953872],
            [32.950264434030615, 0.964248867641336],
            [32.94991981064323, 0.960143206165961],
            [32.948656040938566, 0.955574922359238],
            [32.94813909193361, 0.950544039549949],
            [32.94928809736913, 0.946091443721079],
            [32.95451586023303, 0.939325856312053],
            [32.956986090720434, 0.938111539264524],
            [32.95847971145853, 0.93788025227971],
            [32.96089247492055, 0.938227237541091],
            [32.961983968414955, 0.937938119386197],
            [32.96324780279828, 0.937533349617898],
            [32.964052067167124, 0.936723791976997],
            [32.96468399424023, 0.935509448877647],
            [32.965028719137266, 0.931056837454985],
            [32.96612023059797, 0.928628149620005],
            [32.966809620204884, 0.925447716884277],
            [32.96698199702642, 0.921515539927368],
            [32.967843727522286, 0.91793032522339],
            [32.97054374346612, 0.914460778133209],
            [32.97611607851345, 0.910297335343132],
            [32.97795437923278, 0.907695169817047],
            [32.979233400534305, 0.905065277580166],
            [32.98422130153929, 0.90690699519012],
            [32.986559278457285, 0.906653676855054],
            [32.990692595064495, 0.907033672315062],
            [32.99720545094293, 0.910272634790501],
            [33.00083039206625, 0.91585483950677],
            [33.00287178031172, 0.917772871657824],
            [33.014134211455335, 0.914054391616968],
            [33.02185783553836, 0.913269230048784],
            [33.02168298295986, 0.914036648554896],
            [33.01884330144726, 0.914508379186285],
            [33.01803896611152, 0.91632483906683],
            [33.01673173321848, 0.917637126683057],
            [33.01612254609846, 0.920147853692871],
            [33.01482161219221, 0.921999517413337],
            [33.01426148206985, 0.92400645982751],
            [33.01161594984633, 0.928512040551442],
            [33.010897807862115, 0.931633385366343],
            [33.00924340755278, 0.934028137288646],
            [33.00910198038771, 0.936461322254425],
            [33.00952628703577, 0.938778024050905],
            [33.013670778685096, 0.948155654575539],
            [33.015038198702165, 0.953302272774487],
            [33.016650010782165, 0.955590103572549],
            [33.028259679410624, 0.954971665330819],
            [33.03266219775227, 0.960548957703494],
            [33.035356813024606, 0.966614678038177],
            [33.037302965476925, 0.969690740516928],
            [33.03970136218266, 0.972050937046728],
            [33.04105595515577, 0.974914710300048],
            [33.046240836939596, 0.979475492479806],
            [33.05305459699722, 0.984082424270128],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1173,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "NAMASAGALI",
        Population: 37563,
        Key: "KAMULINAMASAGALI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.114443280607794, 0.997459763795864],
            [33.110207069171324, 0.997586572320024],
            [33.1042969567974, 1.002137565555723],
            [33.10233278773369, 1.002779987221958],
            [33.10132414226469, 1.002571930637332],
            [33.09648651593205, 1.001267091855996],
            [33.095400041325156, 1.000769567605274],
            [33.094982906826324, 1.000054907747458],
            [33.094013106306846, 0.993432909796013],
            [33.092400202773774, 0.990918032860807],
            [33.09199193913841, 0.985888199616474],
            [33.09253475333536, 0.980515096316197],
            [33.08772703730837, 0.976163342944091],
            [33.08517323924505, 0.97032260307863],
            [33.08424870752767, 0.969541405309281],
            [33.08052251818703, 0.969080126242342],
            [33.07916864835772, 0.968238834086201],
            [33.07604353884167, 0.967370443412083],
            [33.070318824369295, 0.964231436505321],
            [33.067918403759265, 0.963842486913928],
            [33.066068786064, 0.964049813889089],
            [33.066103814970184, 0.960321833529486],
            [33.067271939249885, 0.958249972900945],
            [33.07259718189852, 0.950333454915067],
            [33.07839349569232, 0.945438724243005],
            [33.07879905629701, 0.944434462600982],
            [33.07908691514157, 0.942742606524895],
            [33.078564304055384, 0.934509553204525],
            [33.07882799013399, 0.932084864723413],
            [33.07755577626567, 0.925851286252141],
            [33.07852529830741, 0.923435628606031],
            [33.08057535349878, 0.921065929274089],
            [33.085252473348035, 0.921811563883205],
            [33.08679305621253, 0.920615201204083],
            [33.0891085599771, 0.917688710313008],
            [33.092905393730014, 0.915452345949921],
            [33.09331860618428, 0.912732286247873],
            [33.09474168042645, 0.908724285251403],
            [33.09616199234912, 0.906561938011],
            [33.098036183459016, 0.904119111093318],
            [33.10195371215852, 0.901739556515597],
            [33.101681737324796, 0.896115329966372],
            [33.10544989685383, 0.893401115668658],
            [33.10587650768057, 0.887318017151072],
            [33.108163263559405, 0.884269003618796],
            [33.10940494548783, 0.879635484526211],
            [33.10937839757625, 0.8760153619832],
            [33.10853213427294, 0.873526552483168],
            [33.112334628310464, 0.86837727751737],
            [33.1128754662138, 0.866794906788885],
            [33.1125626512723, 0.862856041785384],
            [33.10975650117429, 0.856677497027398],
            [33.10973869566702, 0.856348931809072],
            [33.11767404278105, 0.855986801165063],
            [33.11869832612252, 0.854674908479997],
            [33.12019701246047, 0.853914886187599],
            [33.121790843861746, 0.850992553458988],
            [33.12379428816795, 0.851957233047757],
            [33.12390014833597, 0.85322056193514],
            [33.12537717359749, 0.854676240533346],
            [33.12774349415933, 0.858340740907966],
            [33.12887491327654, 0.861854372012059],
            [33.128728672938195, 0.86302678406875],
            [33.12766226489809, 0.865026092452543],
            [33.127109530605466, 0.869105149021543],
            [33.12718838112783, 0.871919513644014],
            [33.12749432216077, 0.873945925325473],
            [33.128515328448096, 0.874832445792069],
            [33.12935729780434, 0.876649064558167],
            [33.129658572089355, 0.877329233224549],
            [33.126074321953496, 0.876886078852417],
            [33.12474219045575, 0.878505444389772],
            [33.12345804336722, 0.878831160359522],
            [33.12274352878013, 0.879717739849308],
            [33.121881917760184, 0.880087752702149],
            [33.119228839688276, 0.885118603484284],
            [33.12048746923285, 0.886032257053819],
            [33.12152849447626, 0.889207537294177],
            [33.12324892095895, 0.891290071192368],
            [33.1232480998988, 0.891840004427007],
            [33.124353951166356, 0.892667200389213],
            [33.1241169100174, 0.894789491406923],
            [33.12622989399103, 0.896938144418153],
            [33.12655533744879, 0.898009589009442],
            [33.12391266456284, 0.900578880014107],
            [33.1230665755327, 0.902054068931387],
            [33.12333121382553, 0.907761804769624],
            [33.122495135620916, 0.910457684141097],
            [33.11732883099713, 0.912800850443707],
            [33.11538378257431, 0.912390535905111],
            [33.11063782482481, 0.913099753855357],
            [33.10774096374772, 0.914340714722523],
            [33.10478242973311, 0.914340802746196],
            [33.103576135138674, 0.914810596816737],
            [33.100834771538956, 0.914542871895519],
            [33.106210917223194, 0.91643793057977],
            [33.109070544928386, 0.916935400619893],
            [33.109401761858486, 0.918988941792053],
            [33.110993878375865, 0.922308951438532],
            [33.11121359551456, 0.924588657657076],
            [33.11349475039763, 0.929120871881482],
            [33.11375878951413, 0.932734682826608],
            [33.11336969143534, 0.935742899771863],
            [33.112489761071814, 0.937724107373959],
            [33.11265806942347, 0.939651001831242],
            [33.11386143820503, 0.942193023322272],
            [33.11385535391558, 0.946517579601683],
            [33.115646643101144, 0.949137995661462],
            [33.11731035983828, 0.944858589426933],
            [33.11746922060805, 0.941483936049771],
            [33.11925044237424, 0.93905014739572],
            [33.119464504618215, 0.938066229823695],
            [33.12230407024816, 0.941125250337353],
            [33.123870147300444, 0.944986655598678],
            [33.12253264567391, 0.947430636381993],
            [33.123807320926105, 0.948642819665437],
            [33.12501813763967, 0.95155252181779],
            [33.12266987052009, 0.951818173591142],
            [33.1183265897832, 0.950868446603653],
            [33.11797467656731, 0.951709780757616],
            [33.11297736481142, 0.954948589918349],
            [33.11244064568365, 0.956115605064906],
            [33.11239041818117, 0.957807296509654],
            [33.111735156470225, 0.95883861670798],
            [33.1123319558225, 0.965189225515525],
            [33.1140716215236, 0.970200915875795],
            [33.113531604680446, 0.97378333980898],
            [33.11456981729871, 0.976218919931368],
            [33.11574495831911, 0.978133857668016],
            [33.11624992020493, 0.980188152925761],
            [33.11658934594008, 0.983625802480804],
            [33.11732254728173, 0.986258301001925],
            [33.117613128919935, 0.990627739870065],
            [33.11475278615578, 0.995630542387575],
            [33.114443280607794, 0.997459763795864],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1174,
        District: "KAMULI",
        County: "KAMULI MUNICIPALITY",
        Subcounty: "SOUTHERN DIVISION",
        Population: 28712,
        Key: "KAMULISOUTHERN DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.30667793548071, 0.497471291876381],
            [32.29891005409861, 0.495436599699024],
            [32.296122562009046, 0.493747732872593],
            [32.29603611173934, 0.491848651420061],
            [32.294039441628684, 0.4864484785688],
            [32.29449623944226, 0.483691100707538],
            [32.290387767540885, 0.48248429385132],
            [32.28412785568685, 0.479082426268787],
            [32.281831324341105, 0.484944951333983],
            [32.283192165995324, 0.488650404966701],
            [32.28323003806939, 0.489628410989991],
            [32.28220578437236, 0.492779727128003],
            [32.283489573931405, 0.497829928030366],
            [32.283417864117204, 0.499336724799155],
            [32.282133611027454, 0.500101214130409],
            [32.27826327352477, 0.500571986152455],
            [32.27503112794596, 0.50178229303153],
            [32.27322708088675, 0.502992755987535],
            [32.27224978482453, 0.50458164541944],
            [32.27277554450581, 0.50798670322693],
            [32.27179828796946, 0.50919725754929],
            [32.26622458568625, 0.511933489128476],
            [32.264399578236535, 0.512456958748211],
            [32.26109102195968, 0.512678619055916],
            [32.25220542615834, 0.512133030222405],
            [32.251223704995006, 0.503038425474839],
            [32.25014001606382, 0.500016243927355],
            [32.24813910141344, 0.496700146872039],
            [32.245637692199146, 0.494895021148234],
            [32.240509364752356, 0.495104293849789],
            [32.239490475794156, 0.495961299493747],
            [32.23447569629758, 0.496649119091283],
            [32.22914670677588, 0.496503197745563],
            [32.22833828680053, 0.498423374899392],
            [32.219019103855985, 0.509744014395778],
            [32.21641978097066, 0.514539085512402],
            [32.213712947712146, 0.517527354730135],
            [32.21244319343108, 0.520576995602258],
            [32.20892934695897, 0.525335165373043],
            [32.205485764911764, 0.527174018243975],
            [32.200027722518016, 0.53417126627988],
            [32.19847995582621, 0.531803580317817],
            [32.19782608201237, 0.529828695565537],
            [32.197563485590216, 0.5259039942001],
            [32.19827506717789, 0.522913592844406],
            [32.201301385368886, 0.516420029488087],
            [32.20157338894872, 0.513010383244278],
            [32.20102591429206, 0.509587886190097],
            [32.20195121227239, 0.506454132304918],
            [32.202223536550754, 0.50402559183194],
            [32.20160535819305, 0.502254150954181],
            [32.20224601150087, 0.500292630636359],
            [32.198659444609866, 0.496988207786486],
            [32.19725713043391, 0.493086553324104],
            [32.19636606635076, 0.488550678528408],
            [32.193299428176545, 0.484624892156806],
            [32.192230042221304, 0.480029159025565],
            [32.19282470178657, 0.477851108917938],
            [32.19268213915097, 0.477061225257041],
            [32.194287246205704, 0.475110676414883],
            [32.19471540482968, 0.473483119633945],
            [32.1959519439031, 0.471879584403608],
            [32.19758125785979, 0.466147237668832],
            [32.198936605417764, 0.465213918018183],
            [32.2009103891499, 0.461863169735521],
            [32.200910491557835, 0.460953625359797],
            [32.20267016902857, 0.458679949408949],
            [32.203847473192155, 0.455197466973752],
            [32.203776359859326, 0.453210818011575],
            [32.20446590217981, 0.452851857055363],
            [32.20503664499895, 0.45179876072934],
            [32.2058450541945, 0.45155949919327],
            [32.20701028230573, 0.449740526297151],
            [32.209281110156255, 0.447694289715563],
            [32.21075556623604, 0.444558888926997],
            [32.21211090211591, 0.443601615421836],
            [32.21211110244023, 0.441710709199418],
            [32.212848250979235, 0.440777304654013],
            [32.214346233936304, 0.43989185244499],
            [32.21448898701475, 0.438982311615313],
            [32.214025549752925, 0.43717512656559],
            [32.21514311145854, 0.436217819773776],
            [32.215166963525974, 0.435523694571537],
            [32.215785176019665, 0.435236531229012],
            [32.21671238561489, 0.435739282211527],
            [32.21695023434931, 0.434877624195729],
            [32.21752086398072, 0.434829810046899],
            [32.219470417454716, 0.435643822802928],
            [32.21985091865624, 0.434806125748169],
            [32.220326436461995, 0.434877978121757],
            [32.22011037097493, 0.432167912149757],
            [32.22132546456757, 0.430593611625176],
            [32.22120680430504, 0.428439398019718],
            [32.22327546630088, 0.427003472066814],
            [32.224678293414875, 0.426620647664229],
            [32.22686599835554, 0.42353317090232],
            [32.22964804665447, 0.421044144298105],
            [32.23285791850578, 0.419943424206594],
            [32.23651970762371, 0.417215122156373],
            [32.23857675979283, 0.412847054720956],
            [32.24269022273392, 0.410765043638941],
            [32.243593807535476, 0.409735899844373],
            [32.24425952922963, 0.409831703617375],
            [32.245044203138704, 0.409233392413164],
            [32.24599521539402, 0.409568577628116],
            [32.24737424883109, 0.409377227884529],
            [32.25192215590821, 0.406985005820187],
            [32.25367944655523, 0.406864613947265],
            [32.254347961111556, 0.405922938214551],
            [32.265473885162905, 0.404346355253125],
            [32.27588778655374, 0.4036848352564],
            [32.282576085203814, 0.402642374262134],
            [32.2867649087124, 0.401354046684119],
            [32.289715798063945, 0.409551454379654],
            [32.29017965933057, 0.412044041850139],
            [32.29355309732715, 0.418490266554119],
            [32.295144619159814, 0.420058297678733],
            [32.29568788071778, 0.421465043039724],
            [32.295671324767106, 0.423611069776717],
            [32.29671384031557, 0.425022188271206],
            [32.29838300263994, 0.428675905241583],
            [32.29972620407695, 0.430393692710279],
            [32.30131946325137, 0.434491966983705],
            [32.30164702403825, 0.437422829790386],
            [32.3013404999987, 0.439243032782918],
            [32.29813577818891, 0.442839375489392],
            [32.29762215564544, 0.442862443536821],
            [32.29774902740794, 0.444151269964461],
            [32.29894744826892, 0.446645229551647],
            [32.29922696176452, 0.448455304779393],
            [32.3027694950369, 0.455904722377312],
            [32.30495464696553, 0.457428590394168],
            [32.30599631989428, 0.458780781169443],
            [32.3057441259631, 0.461071785927267],
            [32.304772992343736, 0.462960809687468],
            [32.30450043629999, 0.465487909515638],
            [32.30313140560364, 0.467807269176621],
            [32.302847999707915, 0.47123058347329],
            [32.303604980353434, 0.472622368893897],
            [32.3036674788427, 0.473658966928847],
            [32.30595062169746, 0.477032425369008],
            [32.30609023785892, 0.480119341324457],
            [32.30517275432326, 0.482432001179338],
            [32.305271592360704, 0.484340519959106],
            [32.306452319105524, 0.487093668440055],
            [32.30854380908938, 0.490363869851763],
            [32.308780143264194, 0.491916646889717],
            [32.31041663565832, 0.493307195637773],
            [32.3087144970782, 0.495309058967107],
            [32.306970776381874, 0.496562641527248],
            [32.30667793548071, 0.497471291876381],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1914,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "NAMAYUMBA",
        Population: 18176,
        Key: "WAKISONAMAYUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.112836579043446, 0.793941019165624],
            [33.110944843836066, 0.794926874823439],
            [33.10944026185492, 0.794816300158673],
            [33.10858655780613, 0.795505538943632],
            [33.1080286752686, 0.795343884721158],
            [33.1074032034891, 0.79640750597393],
            [33.10516325612476, 0.797079761689417],
            [33.10465611312942, 0.79787109630566],
            [33.10353190029743, 0.797700948529897],
            [33.10207804977364, 0.798279586211913],
            [33.10075945858217, 0.799555943886201],
            [33.10029459030411, 0.800789736855148],
            [33.09966064381818, 0.801087561253852],
            [33.09963530324236, 0.801776777430158],
            [33.09892526675693, 0.801444949785128],
            [33.09916198091915, 0.803010570628467],
            [33.09829981114711, 0.803325418063549],
            [33.09837591551967, 0.804533670615733],
            [33.09718407661479, 0.80432097860583],
            [33.096888248815304, 0.805069762829518],
            [33.096178221313046, 0.805052762094485],
            [33.09572179899529, 0.806116377235377],
            [33.09510475251483, 0.80622700728547],
            [33.09342553624582, 0.811046076829906],
            [33.08992523097829, 0.81215213871973],
            [33.089773050979296, 0.81265680642668],
            [33.08914637905057, 0.812647808907582],
            [33.08929858599904, 0.813332708052833],
            [33.08812580934446, 0.813044353637023],
            [33.086415915608505, 0.814188898514083],
            [33.08550276554578, 0.814197930162289],
            [33.08495668956601, 0.815306401124414],
            [33.08293345267916, 0.81619861803837],
            [33.08218143522557, 0.815630886449603],
            [33.08031932016809, 0.815468710258881],
            [33.07984485428953, 0.816162633382784],
            [33.079083888717385, 0.815874269289044],
            [33.07892275431163, 0.816369925545892],
            [33.0779290361477, 0.816577217698314],
            [33.07748140115005, 0.815982443327478],
            [33.076899502153395, 0.816550202711573],
            [33.076102725242464, 0.816090612871906],
            [33.07484043146986, 0.816306921412367],
            [33.074589778149374, 0.817099970590085],
            [33.0738198698486, 0.817280221674517],
            [33.07307684542932, 0.818920395240366],
            [33.0724859776529, 0.818686097218816],
            [33.072262189349324, 0.819929739671634],
            [33.071223709033085, 0.820317269114668],
            [33.069039293723016, 0.819587346814395],
            [33.067490520918064, 0.819803657861067],
            [33.06472426769677, 0.823534618047657],
            [33.06330977955209, 0.823732902454332],
            [33.06302332746921, 0.825445161980757],
            [33.062378746726985, 0.825337030414649],
            [33.06196694013614, 0.825832689091514],
            [33.06040921561941, 0.826310342849333],
            [33.060102901785605, 0.827328512234262],
            [33.059188728541784, 0.828086377684472],
            [33.05867785124981, 0.827445820876332],
            [33.05809528390658, 0.827490939445707],
            [33.05767404680187, 0.827869871275161],
            [33.05687637606723, 0.827842817741323],
            [33.0564461809625, 0.828519476696855],
            [33.05503905002002, 0.828194703191539],
            [33.05442063360875, 0.828411241020819],
            [33.05429515153996, 0.827978184213031],
            [33.054877717984866, 0.827869911695144],
            [33.054913559866385, 0.827211302393105],
            [33.05365877960281, 0.82590312316695],
            [33.05349744217778, 0.825100163854272],
            [33.05211720050668, 0.824892675432941],
            [33.05110441290589, 0.823638625025123],
            [33.05222473243943, 0.823376971014928],
            [33.05250334402647, 0.821918647191772],
            [33.05354966034692, 0.821573929005646],
            [33.05443424847519, 0.8194865418979],
            [33.05627954886721, 0.817600219314172],
            [33.056736090660905, 0.815196859072106],
            [33.058790647310126, 0.8128796515339],
            [33.05927806869172, 0.811664729447789],
            [33.06002593233543, 0.802771741926823],
            [33.04326731004293, 0.80250053571475],
            [33.037252559209726, 0.802067743791938],
            [33.0381513011936, 0.789174207418784],
            [33.03871605494472, 0.787348945123817],
            [33.04100483562621, 0.784625999892138],
            [33.04263968500168, 0.783459015250603],
            [33.04433396332306, 0.780406929264347],
            [33.04403670810063, 0.779599031519952],
            [33.04102345860037, 0.776340369849506],
            [33.040646859680436, 0.77485190168971],
            [33.040958876917976, 0.772915770496385],
            [33.04242383331361, 0.770961529125527],
            [33.046707510831396, 0.767849202105918],
            [33.048459496028315, 0.764818328386815],
            [33.046611379417904, 0.760737997605013],
            [33.048970755104286, 0.757217142388918],
            [33.05057579298875, 0.74955703030059],
            [33.05028250472656, 0.746702285769487],
            [33.050724344692334, 0.743452891519479],
            [33.052953641630644, 0.740311029513293],
            [33.05319141221162, 0.738216470072877],
            [33.0522402059202, 0.736062079599266],
            [33.04727617854223, 0.7312745774215],
            [33.04965407748978, 0.72660668108203],
            [33.05039714412988, 0.7227766258919],
            [33.05259668706933, 0.717809508280186],
            [33.05381528049834, 0.709042276872831],
            [33.05791710217167, 0.699048198630036],
            [33.05842238565435, 0.696893790609024],
            [33.05848178944748, 0.69333304285037],
            [33.05797635864107, 0.683279176034503],
            [33.056764133369136, 0.678187780170846],
            [33.056594653614376, 0.673668670465523],
            [33.05596446927286, 0.671589376468272],
            [33.05224178785342, 0.665242847966093],
            [33.05122652898729, 0.665160626218238],
            [33.049163894687, 0.658810659907184],
            [33.05142534143104, 0.658466835382744],
            [33.053085190022536, 0.657715891545442],
            [33.0560875330769, 0.657661572202452],
            [33.05906515090141, 0.6569377501929],
            [33.05946901369019, 0.6564130023454],
            [33.061393994647915, 0.656150602800711],
            [33.06362258640875, 0.656521515302105],
            [33.06600479098147, 0.655870077325801],
            [33.067759560955764, 0.6548115143496],
            [33.0699246714704, 0.654648633474288],
            [33.07148343084637, 0.655779526789156],
            [33.0743271053704, 0.656819929513874],
            [33.07562636841025, 0.658547951488482],
            [33.07670884551412, 0.662465430071616],
            [33.08592265517755, 0.666192778306054],
            [33.08681271224928, 0.667649383196744],
            [33.08614408720014, 0.672887800040464],
            [33.086669957374205, 0.678949503497842],
            [33.08642085364762, 0.679863288202757],
            [33.08858960772902, 0.678786616235109],
            [33.08928922196053, 0.678813745249309],
            [33.08960489444292, 0.678288994346928],
            [33.09277884805593, 0.678135129108722],
            [33.09662911719519, 0.678632655797981],
            [33.10225713880698, 0.675909293370058],
            [33.1063435947974, 0.675900157241059],
            [33.10750945891584, 0.677293419860235],
            [33.11065310786273, 0.678469499947144],
            [33.11250534774032, 0.678179942919017],
            [33.1144297340133, 0.676460905878209],
            [33.11545088942095, 0.674904741254929],
            [33.117052034905285, 0.674352815978125],
            [33.118736018533525, 0.673194717925126],
            [33.12242924778806, 0.672235608790806],
            [33.124159842301474, 0.670733709919564],
            [33.127225053951, 0.668924165766597],
            [33.13146677565341, 0.667494577150662],
            [33.13505613001674, 0.668381115463817],
            [33.13643515806389, 0.669385329380786],
            [33.13834195262868, 0.67179186078473],
            [33.136489873549536, 0.677627433252269],
            [33.1362012717982, 0.681816349142744],
            [33.13418067775491, 0.687769540799682],
            [33.13389199874847, 0.689226167047583],
            [33.134421166637935, 0.69043849219405],
            [33.133277821487034, 0.690566572770358],
            [33.13071938721849, 0.69345057071351],
            [33.13053712803049, 0.695199439693301],
            [33.127920561983316, 0.698373375080499],
            [33.12751312479798, 0.701158613067769],
            [33.12600109039322, 0.702993882522644],
            [33.12559362176689, 0.704624007733576],
            [33.126086954961345, 0.705671152942356],
            [33.125979732049025, 0.706318882511433],
            [33.123824255067525, 0.708175759951768],
            [33.12285915183864, 0.710345672780899],
            [33.1227090505412, 0.711662722558672],
            [33.12108977885109, 0.713800265469866],
            [33.121572399635795, 0.715322411506332],
            [33.121207824665944, 0.716920149741578],
            [33.12054294289661, 0.717244030814477],
            [33.119695789362844, 0.718982121788021],
            [33.11889157799464, 0.722523053454072],
            [33.11789428543418, 0.72423955762129],
            [33.1163178849427, 0.725621417036921],
            [33.11642514558426, 0.726409482595163],
            [33.115481472564795, 0.728136780369672],
            [33.11606402643331, 0.733725151018176],
            [33.11551532647461, 0.737331129795477],
            [33.1134000868313, 0.741660350614719],
            [33.11113253244166, 0.743477600295993],
            [33.1109332780268, 0.744812459675044],
            [33.108963498984195, 0.749148858170853],
            [33.10826610089649, 0.753600964240289],
            [33.10651854349562, 0.755676590491451],
            [33.10719310730707, 0.757620986956405],
            [33.10655694557567, 0.758824687810675],
            [33.105882527291286, 0.762775256788868],
            [33.10846568678971, 0.765498912201031],
            [33.108864320485246, 0.767721088697102],
            [33.110366705187225, 0.769719473478618],
            [33.112331010794826, 0.774852679559591],
            [33.11211747316695, 0.777411489898951],
            [33.112523382317946, 0.779604740683365],
            [33.11204634546107, 0.780213993526834],
            [33.1118541500077, 0.782127725765067],
            [33.11244514803987, 0.782844462414123],
            [33.11253063711221, 0.784600502705401],
            [33.112160416230765, 0.785761651222965],
            [33.11288672390093, 0.787438831045719],
            [33.11244532500796, 0.789460083501615],
            [33.11295801599851, 0.790764558491139],
            [33.11253522929994, 0.792149856653812],
            [33.11304806402088, 0.793261680401857],
            [33.112836579043446, 0.793941019165624],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1175,
        District: "KAMULI",
        County: "BUZAAYA",
        Subcounty: "KISOZI",
        Population: 47700,
        Key: "KAMULIKISOZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11629242489092, 1.167642192832999],
            [33.113529492741236, 1.16825487195004],
            [33.09560672390907, 1.168382207715466],
            [33.09206917089663, 1.169495145895778],
            [33.089924321883224, 1.171530860401702],
            [33.08889096825236, 1.173448923298988],
            [33.086179267921636, 1.184658626358159],
            [33.08553746207531, 1.18601574238357],
            [33.08153712487627, 1.19261135370745],
            [33.07944955693694, 1.194755628586281],
            [33.07752039162664, 1.196185158612464],
            [33.07413699939842, 1.197008558954824],
            [33.059239588458226, 1.197569857382991],
            [33.05512276761458, 1.198610385602849],
            [33.05211271881172, 1.201568917309886],
            [33.045942931336896, 1.210417303646],
            [33.040467997022525, 1.215538172655429],
            [33.03633487265479, 1.218406231657854],
            [33.03030428272651, 1.223590419350499],
            [33.029632929493886, 1.223662804357176],
            [33.01331315487892, 1.22445909947534],
            [33.000633002553904, 1.223943437804327],
            [32.99030568528174, 1.223156303261148],
            [32.98826044775524, 1.222676786705322],
            [32.97482300486593, 1.221952908443095],
            [32.95444089582258, 1.219229396249481],
            [32.95282375134304, 1.219491739214502],
            [32.94875682562525, 1.222052053608282],
            [32.947234614206636, 1.222531532555037],
            [32.93537575740993, 1.222588643420283],
            [32.93597682286146, 1.21671540652093],
            [32.939390810809954, 1.209843371384016],
            [32.942160564765935, 1.207704000381493],
            [32.951613716163784, 1.206932508081672],
            [32.95439753773708, 1.205907458475999],
            [32.96003309262086, 1.202422213465227],
            [32.962477455221354, 1.198731892980518],
            [32.96478603297507, 1.193743110379463],
            [32.96634774780828, 1.187455858621344],
            [32.96390361697314, 1.174471242988747],
            [32.96478634738542, 1.168799041701475],
            [32.96777390686515, 1.159778207836094],
            [32.96784185812819, 1.154857734008651],
            [32.967298736707406, 1.150620651897901],
            [32.96566929518996, 1.144675058721058],
            [32.96302141836355, 1.138934471141423],
            [32.96118829822844, 1.133535592667048],
            [32.96112045835651, 1.129366855478155],
            [32.961867387752335, 1.123557971514563],
            [32.96078114670739, 1.116792302427872],
            [32.96017011085451, 1.115015455640995],
            [32.95867643531923, 1.113238597003871],
            [32.95612275852845, 1.111295067390266],
            [32.96721708074641, 1.098013587595486],
            [32.97311436966967, 1.093951399078235],
            [33.001788822609164, 1.08315806081724],
            [33.00431146799678, 1.081384782149515],
            [33.006421766007726, 1.079032473910733],
            [33.0078422081861, 1.078281542662847],
            [33.00964044314545, 1.077738697900512],
            [33.01518261995206, 1.078625312830195],
            [33.017028322789336, 1.077991990559978],
            [33.022462051381616, 1.075006337048907],
            [33.02490265722757, 1.07297067032376],
            [33.028642035633226, 1.066800361541018],
            [33.02982647601342, 1.061154818965385],
            [33.03408742974774, 1.054486895222569],
            [33.03844945023975, 1.0451590518928],
            [33.040073216201264, 1.043476229080556],
            [33.04510973313107, 1.043222834797932],
            [33.04648044906692, 1.043512329078928],
            [33.050242860276455, 1.042218503191024],
            [33.05209104605714, 1.04060804952207],
            [33.053467898384696, 1.038445715908629],
            [33.05779835297593, 1.027498377670338],
            [33.0613508243103, 1.021427581325349],
            [33.06166929594316, 1.020282617712223],
            [33.0594852175013, 1.013412916411624],
            [33.05862060521002, 1.005993609782865],
            [33.05457107716432, 0.997887383273698],
            [33.05439654079282, 0.995705770322255],
            [33.0549745869152, 0.992447077776643],
            [33.05514150736973, 0.987261630546971],
            [33.05419081940624, 0.985024534349818],
            [33.05305459699722, 0.984082424270128],
            [33.06015507503899, 0.984613439771661],
            [33.06319031709402, 0.986550196731605],
            [33.066521520797494, 0.990294170691938],
            [33.0679467114705, 0.997175434392167],
            [33.07003523342064, 1.000455683929747],
            [33.0765697072564, 1.003673595774589],
            [33.07823442561506, 1.005109820736299],
            [33.07933446208779, 1.01151314148672],
            [33.080999271176296, 1.016390416503644],
            [33.08153436435339, 1.016958924633643],
            [33.08260450219853, 1.01612107568258],
            [33.08429891347058, 1.015941499254963],
            [33.08515075082021, 1.015002191371064],
            [33.085228977013486, 1.016206703999769],
            [33.086084554947966, 1.018078304957049],
            [33.08686405006944, 1.018750802396322],
            [33.09123470965953, 1.019731434129552],
            [33.09869543548644, 1.020599880194121],
            [33.100153607805105, 1.009688247265321],
            [33.10113475314829, 1.009167430104585],
            [33.10132414226469, 1.002571930637332],
            [33.10233278773369, 1.002779987221958],
            [33.1042969567974, 1.002137565555723],
            [33.110207069171324, 0.997586572320024],
            [33.114443280607794, 0.997459763795864],
            [33.123952208401626, 0.998906985188026],
            [33.12560548581682, 0.99952213878498],
            [33.12687931755097, 1.000689192326726],
            [33.12797508522947, 1.002218143786941],
            [33.128816746463585, 1.005972743338897],
            [33.13035722242855, 1.009302090028747],
            [33.13072423273113, 1.013816680076891],
            [33.13363652327153, 1.016865501984057],
            [33.13516603529849, 1.019688196080374],
            [33.138312356733344, 1.023831726049468],
            [33.14056014279682, 1.027875771070985],
            [33.145430563925565, 1.032733950407294],
            [33.14894808271054, 1.039564495907065],
            [33.151797849608855, 1.044088006920607],
            [33.14975820140007, 1.04664848981611],
            [33.14816465206979, 1.050448431333056],
            [33.14773850477374, 1.055406370751201],
            [33.14606043744995, 1.059921051474731],
            [33.14339510995082, 1.071646475618283],
            [33.14243317058841, 1.079680521228661],
            [33.14216390597187, 1.081915218247588],
            [33.137945947403686, 1.090474159326182],
            [33.13592730629778, 1.098761577876879],
            [33.13225311503906, 1.107401916684915],
            [33.13177754782597, 1.113228399457295],
            [33.12973687553775, 1.125695670397062],
            [33.12702074022446, 1.152982449142753],
            [33.12592781301888, 1.159948918332818],
            [33.12502316012044, 1.162364587558677],
            [33.12332384494523, 1.1645179209106],
            [33.11913609761834, 1.167006110138232],
            [33.11629242489092, 1.167642192832999],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1176,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "BALAWOLI",
        Population: 54298,
        Key: "KAMULIBALAWOLI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.066068786064, 0.964049813889089],
            [33.05859383541454, 0.96546990111581],
            [33.05996543349601, 0.969857830172357],
            [33.061222677838394, 0.971983928777184],
            [33.06247853967361, 0.973176416020868],
            [33.05970776882475, 0.974458009119741],
            [33.06159790952248, 0.98068185310633],
            [33.06360992016324, 0.982845127851332],
            [33.063755353814464, 0.984623700610175],
            [33.06319031709402, 0.986550196731605],
            [33.06015507503899, 0.984613439771661],
            [33.05305459699722, 0.984082424270128],
            [33.046240836939596, 0.979475492479806],
            [33.04105595515577, 0.974914710300048],
            [33.03970136218266, 0.972050937046728],
            [33.037302965476925, 0.969690740516928],
            [33.035356813024606, 0.966614678038177],
            [33.03266219775227, 0.960548957703494],
            [33.028259679410624, 0.954971665330819],
            [33.016650010782165, 0.955590103572549],
            [33.015038198702165, 0.953302272774487],
            [33.013670778685096, 0.948155654575539],
            [33.00952628703577, 0.938778024050905],
            [33.00910198038771, 0.936461322254425],
            [33.00924340755278, 0.934028137288646],
            [33.010897807862115, 0.931633385366343],
            [33.01161594984633, 0.928512040551442],
            [33.01426148206985, 0.92400645982751],
            [33.01482161219221, 0.921999517413337],
            [33.01612254609846, 0.920147853692871],
            [33.01673173321848, 0.917637126683057],
            [33.01803896611152, 0.91632483906683],
            [33.01884330144726, 0.914508379186285],
            [33.02168298295986, 0.914036648554896],
            [33.02185783553836, 0.913269230048784],
            [33.014134211455335, 0.914054391616968],
            [33.00287178031172, 0.917772871657824],
            [33.00083039206625, 0.91585483950677],
            [32.99720545094293, 0.910272634790501],
            [32.990692595064495, 0.907033672315062],
            [32.986559278457285, 0.906653676855054],
            [32.98422130153929, 0.90690699519012],
            [32.979233400534305, 0.905065277580166],
            [32.984427259182795, 0.897331961574818],
            [32.99255332761478, 0.887834843051701],
            [32.9952011397625, 0.883913445151057],
            [32.99979675366941, 0.880482222857093],
            [33.0027184648422, 0.877387990527745],
            [33.004331488749514, 0.875151564725315],
            [33.00491431301089, 0.871930404455617],
            [33.00665737434381, 0.872234285482449],
            [33.00944408849233, 0.871911923758764],
            [33.01033988130713, 0.872643327244905],
            [33.01161538211106, 0.872228509984477],
            [33.012740440257716, 0.87253797067475],
            [33.01391128283947, 0.871905869814807],
            [33.01495130915631, 0.872531377805106],
            [33.01691665501298, 0.87222291772157],
            [33.0176980851056, 0.872711262542321],
            [33.02233646510826, 0.872856134106383],
            [33.030554132953114, 0.874242910625775],
            [33.036675798576496, 0.874462933621077],
            [33.037673321105636, 0.876374854466413],
            [33.041400246166496, 0.880965137824966],
            [33.0514280974623, 0.886903009305686],
            [33.05518082573139, 0.896888003908153],
            [33.05572778745003, 0.897582190733483],
            [33.05848153702086, 0.895657081702281],
            [33.06137244226762, 0.892473403401509],
            [33.06388526008602, 0.886676629530371],
            [33.06588586032605, 0.884432856569952],
            [33.06664282839514, 0.884321217365187],
            [33.07157306115213, 0.886557586466775],
            [33.076425692044985, 0.887757369066638],
            [33.08024853202537, 0.887771487091408],
            [33.085707658685656, 0.88533610456828],
            [33.08974850631077, 0.888431941666642],
            [33.08983319228924, 0.887001789692105],
            [33.09130940727037, 0.885409423493683],
            [33.09282295264142, 0.882858041163854],
            [33.08778578712798, 0.880958226105954],
            [33.08826738383326, 0.876923108461008],
            [33.0879731685097, 0.873979946855218],
            [33.0885600477663, 0.871784582548368],
            [33.086236927186434, 0.866890186473758],
            [33.0839447571614, 0.864427464940407],
            [33.08011034688017, 0.861899086884026],
            [33.079390618471145, 0.860595056497311],
            [33.07948654506877, 0.858994321231436],
            [33.07866395147488, 0.855240896380826],
            [33.077615227669476, 0.854392254472817],
            [33.07637455544745, 0.852094676257628],
            [33.076784107266946, 0.850704023948853],
            [33.078134796161834, 0.849478382505484],
            [33.08236348330949, 0.847513819825967],
            [33.085005261473434, 0.847021772923771],
            [33.09093965800447, 0.84491361005338],
            [33.093342727746276, 0.843683116401726],
            [33.09541130440216, 0.843330220047516],
            [33.0967198470389, 0.842615448654577],
            [33.10025061956758, 0.842407270426543],
            [33.09977067037251, 0.84572990833701],
            [33.10016772932134, 0.847433697969632],
            [33.100917036557725, 0.847775235099321],
            [33.101807525719096, 0.849266486028898],
            [33.10175633791756, 0.850511861351946],
            [33.10471855053325, 0.852239926755322],
            [33.10500505561672, 0.853773423528121],
            [33.10588445597422, 0.853952509740913],
            [33.10718528747253, 0.854928575262861],
            [33.10799389699237, 0.854620943701843],
            [33.10975650117429, 0.856677497027398],
            [33.1125626512723, 0.862856041785384],
            [33.1128754662138, 0.866794906788885],
            [33.112334628310464, 0.86837727751737],
            [33.10853213427294, 0.873526552483168],
            [33.10937839757625, 0.8760153619832],
            [33.10940494548783, 0.879635484526211],
            [33.108163263559405, 0.884269003618796],
            [33.10587650768057, 0.887318017151072],
            [33.10544989685383, 0.893401115668658],
            [33.101681737324796, 0.896115329966372],
            [33.10195371215852, 0.901739556515597],
            [33.098036183459016, 0.904119111093318],
            [33.09616199234912, 0.906561938011],
            [33.09474168042645, 0.908724285251403],
            [33.09331860618428, 0.912732286247873],
            [33.092905393730014, 0.915452345949921],
            [33.0891085599771, 0.917688710313008],
            [33.08679305621253, 0.920615201204083],
            [33.085252473348035, 0.921811563883205],
            [33.08057535349878, 0.921065929274089],
            [33.07852529830741, 0.923435628606031],
            [33.07755577626567, 0.925851286252141],
            [33.07882799013399, 0.932084864723413],
            [33.078564304055384, 0.934509553204525],
            [33.07908691514157, 0.942742606524895],
            [33.07879905629701, 0.944434462600982],
            [33.07839349569232, 0.945438724243005],
            [33.07259718189852, 0.950333454915067],
            [33.067271939249885, 0.958249972900945],
            [33.066103814970184, 0.960321833529486],
            [33.066068786064, 0.964049813889089],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1177,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "BUTANSI",
        Population: 29570,
        Key: "KAMULIBUTANSI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19115107220073, 0.955730112583022],
            [33.188819237064294, 0.95545882406872],
            [33.18318435861192, 0.955938638235829],
            [33.177464424075204, 0.957440791053457],
            [33.17363170172838, 0.959331872704199],
            [33.17194482193166, 0.960435728397442],
            [33.16626817092026, 0.968605717416238],
            [33.16352069608166, 0.969718669630187],
            [33.16290139752478, 0.970406294296168],
            [33.161062379051565, 0.970838254584283],
            [33.15885267167465, 0.966606623991325],
            [33.15761405389965, 0.96292893420318],
            [33.15881634200794, 0.95956592018716],
            [33.159039385608125, 0.956007263563554],
            [33.157829541769985, 0.951593437130486],
            [33.15765057400921, 0.94850583458026],
            [33.158131291263835, 0.940061888058113],
            [33.15784196457204, 0.926907129524462],
            [33.158346537487354, 0.923396754569763],
            [33.16054984436788, 0.920374857427513],
            [33.162863714096936, 0.915172556444921],
            [33.16229434839514, 0.914313088757293],
            [33.161105969800715, 0.914077913703966],
            [33.15851710959352, 0.912567130377598],
            [33.15822574372605, 0.911089532275567],
            [33.16146518362496, 0.906873735640201],
            [33.1612309577961, 0.904605843914412],
            [33.16168617098146, 0.901601411834586],
            [33.163224514345956, 0.898903721389618],
            [33.164304014433014, 0.898849656650041],
            [33.169297653875994, 0.900079481971599],
            [33.16968973525984, 0.899618094081247],
            [33.16976462780509, 0.897179524486589],
            [33.16474240127481, 0.893448636159253],
            [33.16252236776369, 0.893113486717132],
            [33.16027090579406, 0.894199692643747],
            [33.15922601959156, 0.89350316086004],
            [33.15760834151274, 0.888021712409608],
            [33.15138720813292, 0.889785396992314],
            [33.149224217642356, 0.890949800877324],
            [33.14806542865509, 0.892951797031563],
            [33.144757105041876, 0.895611592981244],
            [33.14358984494148, 0.897095260267233],
            [33.14060105117654, 0.898012238714028],
            [33.139634323793636, 0.897492947772668],
            [33.13759026845008, 0.895023850343071],
            [33.137283621341325, 0.894116127160091],
            [33.13528811454894, 0.892319041255194],
            [33.135748367283085, 0.890515248460525],
            [33.13528124962355, 0.888953753359495],
            [33.13428537640125, 0.887451769236754],
            [33.136201747007, 0.885018606873852],
            [33.1357277275911, 0.883931933872436],
            [33.13012358050464, 0.877927290120128],
            [33.12935729780434, 0.876649064558167],
            [33.128515328448096, 0.874832445792069],
            [33.12749432216077, 0.873945925325473],
            [33.12718838112783, 0.871919513644014],
            [33.127109530605466, 0.869105149021543],
            [33.12766226489809, 0.865026092452543],
            [33.128728672938195, 0.86302678406875],
            [33.12887491327654, 0.861854372012059],
            [33.12774349415933, 0.858340740907966],
            [33.12537717359749, 0.854676240533346],
            [33.12390014833597, 0.85322056193514],
            [33.12379428816795, 0.851957233047757],
            [33.121790843861746, 0.850992553458988],
            [33.12013309193811, 0.848640303255476],
            [33.11925369158061, 0.848468432171464],
            [33.118016922538466, 0.84480430684883],
            [33.118423563816435, 0.843031020034757],
            [33.118355531705056, 0.840977280756426],
            [33.11936101690086, 0.840407269445568],
            [33.12031478428914, 0.838588729253876],
            [33.12257542973594, 0.837050614127211],
            [33.12272003873376, 0.835847316989335],
            [33.12494281120816, 0.835765820617163],
            [33.12574949024847, 0.836742903902143],
            [33.12650705300227, 0.8388237617395],
            [33.12716203803215, 0.838986591777331],
            [33.130311109210076, 0.838905061338125],
            [33.13159549974205, 0.838552173534034],
            [33.13509305346984, 0.836407840172548],
            [33.1371141622478, 0.836299201412425],
            [33.13875068608296, 0.833919701118231],
            [33.14077466587658, 0.827740315394933],
            [33.14847694958169, 0.823207331806481],
            [33.14951832516806, 0.82127116858285],
            [33.150253050950724, 0.820836869653942],
            [33.153296998579194, 0.816584925358883],
            [33.153741286454085, 0.814478853484167],
            [33.155220842269756, 0.812993612915424],
            [33.15520593832088, 0.810992890215732],
            [33.1590135698235, 0.81310762279789],
            [33.160040572365325, 0.814171883445718],
            [33.161398765786096, 0.813936560273156],
            [33.16265023665617, 0.815761355318418],
            [33.16480794235794, 0.816702461567236],
            [33.16607967023766, 0.818061194042146],
            [33.16783905216265, 0.81909151759769],
            [33.17104264389182, 0.822984665120836],
            [33.173140964665066, 0.824045485650282],
            [33.17543082871479, 0.826001839555344],
            [33.17609131323079, 0.82746839677818],
            [33.177270166988265, 0.828775336841041],
            [33.17880588188222, 0.829645086234036],
            [33.180538961135696, 0.829961224123339],
            [33.18394357696081, 0.832470263675055],
            [33.1843941171101, 0.833157836113419],
            [33.1844380447275, 0.83557346057283],
            [33.185019739806584, 0.836071033868217],
            [33.1856622804748, 0.839988478569892],
            [33.187079673771095, 0.842171525869528],
            [33.18897637756032, 0.844109060287038],
            [33.19128171688744, 0.845268990733554],
            [33.19270093286548, 0.845237273774215],
            [33.200373391604856, 0.848846435011623],
            [33.201549430940524, 0.849137476074255],
            [33.202580847803645, 0.848875428548383],
            [33.2048751037168, 0.849748614539134],
            [33.20579529387638, 0.850308026423915],
            [33.2067021377658, 0.851716062050417],
            [33.21015070905613, 0.853000610465494],
            [33.2134783976519, 0.854426788160478],
            [33.21616676334478, 0.856824396474274],
            [33.21766404561594, 0.857492258670233],
            [33.21900829808183, 0.859872814266162],
            [33.2226519690788, 0.859863374933922],
            [33.22145363715102, 0.866856983151616],
            [33.22149813340202, 0.868910710383449],
            [33.222409406884104, 0.871299134339236],
            [33.22297473196375, 0.875026575139872],
            [33.22452591854188, 0.878971088839692],
            [33.22633432332854, 0.882248336189124],
            [33.225908141896504, 0.884815537281912],
            [33.22545541704444, 0.885394590486325],
            [33.22281507438832, 0.885504524859984],
            [33.21777757020997, 0.884897453866038],
            [33.214664502610304, 0.883821588970953],
            [33.20824799913091, 0.887174111721869],
            [33.208342730969214, 0.889788967364962],
            [33.209069756393255, 0.89112177332045],
            [33.21329230894583, 0.894789433023532],
            [33.214143383625796, 0.898920937279673],
            [33.21410627601802, 0.907922973739035],
            [33.21346314336005, 0.908945354388105],
            [33.21227314510319, 0.90977777400323],
            [33.205611657571055, 0.91327041118334],
            [33.198014104851644, 0.919112015812264],
            [33.198757904517024, 0.921582152168352],
            [33.20058069402634, 0.923240798542772],
            [33.205294749006825, 0.926470404201649],
            [33.20766881035149, 0.928741130263606],
            [33.20914282805342, 0.928768183965298],
            [33.21023491263926, 0.929681892977155],
            [33.21113442088608, 0.932305547983841],
            [33.212568985479066, 0.934793459412389],
            [33.2135626290828, 0.938068510340507],
            [33.213047131755324, 0.941099377856149],
            [33.2122851789347, 0.942004151119234],
            [33.20643279409755, 0.944827255959158],
            [33.20088746869585, 0.948944094858821],
            [33.20000614953692, 0.950038866880652],
            [33.1903249149901, 0.95381213531812],
            [33.19115107220073, 0.955730112583022],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1178,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "KITAYUNJWA",
        Population: 40087,
        Key: "KAMULIKITAYUNJWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.123122657355886, 0.792317048585411],
            [33.122516936834536, 0.792770498112505],
            [33.121996852709216, 0.792466954984422],
            [33.12145495120059, 0.793342452762658],
            [33.12053716762764, 0.793197299824245],
            [33.11974177951215, 0.793923224350079],
            [33.11773139751699, 0.793663717886724],
            [33.11732933854529, 0.794235652652344],
            [33.116634435079156, 0.793769335256053],
            [33.11545008632711, 0.794631653046129],
            [33.11426131337228, 0.79360662374995],
            [33.112836579043446, 0.793941019165624],
            [33.11304806402088, 0.793261680401857],
            [33.11253522929994, 0.792149856653812],
            [33.11295801599851, 0.790764558491139],
            [33.11244532500796, 0.789460083501615],
            [33.11288672390093, 0.787438831045719],
            [33.112160416230765, 0.785761651222965],
            [33.11253063711221, 0.784600502705401],
            [33.11244514803987, 0.782844462414123],
            [33.1118541500077, 0.782127725765067],
            [33.11204634546107, 0.780213993526834],
            [33.112523382317946, 0.779604740683365],
            [33.11211747316695, 0.777411489898951],
            [33.112331010794826, 0.774852679559591],
            [33.110366705187225, 0.769719473478618],
            [33.108864320485246, 0.767721088697102],
            [33.10846568678971, 0.765498912201031],
            [33.105882527291286, 0.762775256788868],
            [33.10655694557567, 0.758824687810675],
            [33.10719310730707, 0.757620986956405],
            [33.10651854349562, 0.755676590491451],
            [33.10826610089649, 0.753600964240289],
            [33.108963498984195, 0.749148858170853],
            [33.1109332780268, 0.744812459675044],
            [33.11113253244166, 0.743477600295993],
            [33.1134000868313, 0.741660350614719],
            [33.11551532647461, 0.737331129795477],
            [33.11606402643331, 0.733725151018176],
            [33.115481472564795, 0.728136780369672],
            [33.11642514558426, 0.726409482595163],
            [33.1163178849427, 0.725621417036921],
            [33.11789428543418, 0.72423955762129],
            [33.11889157799464, 0.722523053454072],
            [33.119695789362844, 0.718982121788021],
            [33.12054294289661, 0.717244030814477],
            [33.121207824665944, 0.716920149741578],
            [33.121572399635795, 0.715322411506332],
            [33.12108977885109, 0.713800265469866],
            [33.1227090505412, 0.711662722558672],
            [33.12285915183864, 0.710345672780899],
            [33.123824255067525, 0.708175759951768],
            [33.125979732049025, 0.706318882511433],
            [33.126086954961345, 0.705671152942356],
            [33.12559362176689, 0.704624007733576],
            [33.12600109039322, 0.702993882522644],
            [33.12751312479798, 0.701158613067769],
            [33.127920561983316, 0.698373375080499],
            [33.13053712803049, 0.695199439693301],
            [33.13071938721849, 0.69345057071351],
            [33.133277821487034, 0.690566572770358],
            [33.134421166637935, 0.69043849219405],
            [33.13605714609402, 0.690076553096996],
            [33.13726002888702, 0.68918083325346],
            [33.14507818448401, 0.68767874563174],
            [33.149336020165975, 0.689406648882025],
            [33.15277651650019, 0.689587484620182],
            [33.156818190575365, 0.694192432215401],
            [33.158524978835395, 0.694898064515362],
            [33.16894729025395, 0.695096740171101],
            [33.17053045775448, 0.694553844624187],
            [33.17469218178589, 0.694408933658333],
            [33.177266172180204, 0.692852702102197],
            [33.17931108361823, 0.692807387205909],
            [33.18561390080686, 0.69600083686513],
            [33.18918756160213, 0.698367732283096],
            [33.18679878405651, 0.70515457277312],
            [33.186912522449575, 0.708585280470042],
            [33.184623144388425, 0.711241975135293],
            [33.18337369472772, 0.715121369837349],
            [33.18263987804013, 0.720566554848935],
            [33.18019864966168, 0.724904426646511],
            [33.17950906601866, 0.72537123921966],
            [33.179342583043685, 0.724677053393924],
            [33.17753540625399, 0.726101417542057],
            [33.17606117115976, 0.72829177484735],
            [33.17537158033022, 0.728602991684425],
            [33.17593045730277, 0.73017088833209],
            [33.17534791331573, 0.731475515077087],
            [33.17560953326921, 0.732672390149641],
            [33.175312305894515, 0.733079342188976],
            [33.17527215389625, 0.737302205540116],
            [33.173065347179396, 0.738138731828862],
            [33.172891213253145, 0.738536104531306],
            [33.17210173784885, 0.738582884904533],
            [33.17251973652695, 0.739623031285424],
            [33.17236883123735, 0.740254147547751],
            [33.171033699366525, 0.740628190965552],
            [33.169756654358615, 0.741995646536885],
            [33.16887429405228, 0.741948931771185],
            [33.16764370092772, 0.743643626419692],
            [33.16561201089401, 0.74515135729752],
            [33.165217303734586, 0.746027914824834],
            [33.16572819989119, 0.74752386089094],
            [33.16557731526279, 0.748727651662992],
            [33.16654340214689, 0.750086966680423],
            [33.16578675567466, 0.75130055113585],
            [33.166205092119306, 0.752343769180847],
            [33.165904336162214, 0.753441422870927],
            [33.166364201722445, 0.754086580193914],
            [33.16534021751997, 0.754645167999435],
            [33.16503344285046, 0.754009433270585],
            [33.16305727588782, 0.752936363591754],
            [33.16215265892199, 0.753813985768962],
            [33.162079675296745, 0.754908712631401],
            [33.161152003967445, 0.755198261215936],
            [33.160840313716676, 0.756935354705789],
            [33.15980566291854, 0.758002975591619],
            [33.159127110587214, 0.758174898985468],
            [33.15888784970115, 0.759061543787278],
            [33.158174198395066, 0.759459652045245],
            [33.15817282666763, 0.760364382569143],
            [33.15748139608838, 0.761703409086032],
            [33.157622978661976, 0.76249051966211],
            [33.15695678535235, 0.762707679823494],
            [33.156372914553664, 0.763766236085929],
            [33.15575952152147, 0.763983393488215],
            [33.15506084153787, 0.76679713120836],
            [33.154443216542376, 0.766507639991039],
            [33.153847545474115, 0.767484771239966],
            [33.153277113472036, 0.767412413045427],
            [33.15213460465267, 0.768362421896773],
            [33.15163551325725, 0.768335297909244],
            [33.151301864587666, 0.768742437953462],
            [33.15144317048016, 0.769674305770485],
            [33.150944074593156, 0.769529566998497],
            [33.15032480657901, 0.770407177712618],
            [33.15056329132064, 0.771348089482654],
            [33.14945228551995, 0.773691381621164],
            [33.149000110436866, 0.774044242710982],
            [33.14731213559382, 0.774161917560535],
            [33.14705010331363, 0.77449667741551],
            [33.14752340587392, 0.775953277295141],
            [33.14661767948868, 0.777482303861427],
            [33.144525266036744, 0.777735701552242],
            [33.14313142387222, 0.779943293341001],
            [33.14336848298749, 0.78029613055462],
            [33.14303456572164, 0.781110400221588],
            [33.14208246380991, 0.781752791307996],
            [33.141962561177365, 0.782494674910539],
            [33.14083294408061, 0.782811369771459],
            [33.14004547191941, 0.784810852245878],
            [33.13928461594174, 0.784838020141014],
            [33.138711435993244, 0.786629406767006],
            [33.13659707400396, 0.785788077173299],
            [33.134693427135936, 0.787018574148331],
            [33.13398059239841, 0.786855745607795],
            [33.13388482749753, 0.787163357231658],
            [33.13336268892518, 0.786683866489296],
            [33.13243445884379, 0.787371492504928],
            [33.131792684438494, 0.787253897967596],
            [33.13176771307021, 0.788086252148412],
            [33.131079023250905, 0.787606766003356],
            [33.12912956140508, 0.787823962602452],
            [33.12858106895721, 0.788891563148363],
            [33.12724923031025, 0.789343970204577],
            [33.1263204513582, 0.79046586655535],
            [33.12596402770124, 0.790194457431729],
            [33.124751269728314, 0.7904840090007],
            [33.123122657355886, 0.792317048585411],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1180,
        District: "KAMULI",
        County: "BUZAAYA",
        Subcounty: "NAWANYAGO",
        Population: 23839,
        Key: "KAMULINAWANYAGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.10132414226469, 1.002571930637332],
              [33.10113475314829, 1.009167430104585],
              [33.100153607805105, 1.009688247265321],
              [33.09869543548644, 1.020599880194121],
              [33.09123470965953, 1.019731434129552],
              [33.08686405006944, 1.018750802396322],
              [33.086084554947966, 1.018078304957049],
              [33.085228977013486, 1.016206703999769],
              [33.08515075082021, 1.015002191371064],
              [33.08429891347058, 1.015941499254963],
              [33.08260450219853, 1.01612107568258],
              [33.08153436435339, 1.016958924633643],
              [33.080999271176296, 1.016390416503644],
              [33.07933446208779, 1.01151314148672],
              [33.07823442561506, 1.005109820736299],
              [33.0765697072564, 1.003673595774589],
              [33.07003523342064, 1.000455683929747],
              [33.0679467114705, 0.997175434392167],
              [33.066521520797494, 0.990294170691938],
              [33.06319031709402, 0.986550196731605],
              [33.063755353814464, 0.984623700610175],
              [33.06360992016324, 0.982845127851332],
              [33.06159790952248, 0.98068185310633],
              [33.05970776882475, 0.974458009119741],
              [33.06247853967361, 0.973176416020868],
              [33.061222677838394, 0.971983928777184],
              [33.05996543349601, 0.969857830172357],
              [33.05859383541454, 0.96546990111581],
              [33.066068786064, 0.964049813889089],
              [33.067918403759265, 0.963842486913928],
              [33.070318824369295, 0.964231436505321],
              [33.07604353884167, 0.967370443412083],
              [33.07916864835772, 0.968238834086201],
              [33.08052251818703, 0.969080126242342],
              [33.08424870752767, 0.969541405309281],
              [33.08517323924505, 0.97032260307863],
              [33.08772703730837, 0.976163342944091],
              [33.09253475333536, 0.980515096316197],
              [33.09199193913841, 0.985888199616474],
              [33.092400202773774, 0.990918032860807],
              [33.094013106306846, 0.993432909796013],
              [33.094982906826324, 1.000054907747458],
              [33.095400041325156, 1.000769567605274],
              [33.09648651593205, 1.001267091855996],
              [33.10132414226469, 1.002571930637332],
            ],
          ],
          [
            [
              [33.20207751725839, 1.009533620010003],
              [33.20014602980305, 1.011406526280751],
              [33.198584372461994, 1.011904223155007],
              [33.197565673048345, 1.012709492799385],
              [33.19680597230415, 1.013985205482077],
              [33.19505555197243, 1.014292920089825],
              [33.193334217293, 1.017233389465843],
              [33.1915728258367, 1.022055693979394],
              [33.19042270379529, 1.023430950060852],
              [33.185235348051165, 1.027267303454023],
              [33.18435793746203, 1.028307792062262],
              [33.18273041564436, 1.03149253011126],
              [33.18107381176765, 1.037002420191405],
              [33.17811013579637, 1.040322943419196],
              [33.17562358112362, 1.041978737589251],
              [33.169436683437574, 1.043698063577344],
              [33.164806812277284, 1.041997421253675],
              [33.160316584227935, 1.041111020379859],
              [33.15615393942336, 1.04171740069694],
              [33.15314800220955, 1.043065596397862],
              [33.151797849608855, 1.044088006920607],
              [33.14894808271054, 1.039564495907065],
              [33.145430563925565, 1.032733950407294],
              [33.14056014279682, 1.027875771070985],
              [33.138312356733344, 1.023831726049468],
              [33.13516603529849, 1.019688196080374],
              [33.13363652327153, 1.016865501984057],
              [33.13072423273113, 1.013816680076891],
              [33.13035722242855, 1.009302090028747],
              [33.128816746463585, 1.005972743338897],
              [33.12797508522947, 1.002218143786941],
              [33.12687931755097, 1.000689192326726],
              [33.12560548581682, 0.99952213878498],
              [33.123952208401626, 0.998906985188026],
              [33.114443280607794, 0.997459763795864],
              [33.11475278615578, 0.995630542387575],
              [33.117613128919935, 0.990627739870065],
              [33.11732254728173, 0.986258301001925],
              [33.11658934594008, 0.983625802480804],
              [33.11624992020493, 0.980188152925761],
              [33.11574495831911, 0.978133857668016],
              [33.11456981729871, 0.976218919931368],
              [33.12529366620868, 0.969802470441443],
              [33.127555248598306, 0.967821207634934],
              [33.12796701566328, 0.967694541690808],
              [33.128148771794706, 0.968373020529639],
              [33.133521196657064, 0.968598972930632],
              [33.135469696407235, 0.969295472807193],
              [33.13560874842667, 0.969666372713459],
              [33.1355674124489, 0.975528486927172],
              [33.13727691631602, 0.976939666527641],
              [33.141726592616834, 0.982322129252259],
              [33.144351804050316, 0.984312238699222],
              [33.15007486472423, 0.979861122379563],
              [33.151629349916064, 0.981724623562817],
              [33.15284408957248, 0.980078111033369],
              [33.15493664585659, 0.979779481951039],
              [33.160019810502476, 0.974803686518355],
              [33.161062379051565, 0.970838254584283],
              [33.16290139752478, 0.970406294296168],
              [33.16352069608166, 0.969718669630187],
              [33.16626817092026, 0.968605717416238],
              [33.17194482193166, 0.960435728397442],
              [33.17363170172838, 0.959331872704199],
              [33.177464424075204, 0.957440791053457],
              [33.18318435861192, 0.955938638235829],
              [33.188819237064294, 0.95545882406872],
              [33.19115107220073, 0.955730112583022],
              [33.19168543325086, 0.958209037009135],
              [33.193272320674964, 0.96222594001651],
              [33.192890388457194, 0.963248303943618],
              [33.192622036528995, 0.971137547321556],
              [33.193696387472826, 0.976077299523065],
              [33.19379853490378, 0.979352408931516],
              [33.19541039369617, 0.98262742891412],
              [33.19534220258297, 0.988499115739344],
              [33.196773554800494, 0.993294087052512],
              [33.19684165518385, 0.9954473352883],
              [33.196415682160946, 0.997446808459651],
              [33.20049829426025, 1.007534270982429],
              [33.20207751725839, 1.009533620010003],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1181,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "NABWIGULU",
        Population: 21987,
        Key: "KAMULINABWIGULU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.874834422207083, -0.361696443112357],
            [31.86982166481821, -0.358204221530178],
            [31.86768310311348, -0.358900472310587],
            [31.866566469367537, -0.358466138195144],
            [31.862729146748144, -0.359144076260052],
            [31.86154069269526, -0.360509815545515],
            [31.85997244441496, -0.360934756965453],
            [31.85899841283049, -0.360844176242335],
            [31.857620422337455, -0.359984681590354],
            [31.855933331436642, -0.360979478704396],
            [31.854579168756548, -0.360454664570223],
            [31.853034853392053, -0.360454470537957],
            [31.84912665998495, -0.357595605036299],
            [31.846632002508343, -0.356690735256896],
            [31.845562779148178, -0.356645381993597],
            [31.8447313110976, -0.357124680493431],
            [31.8423911494768, -0.355677119232866],
            [31.840799432709726, -0.355287965762145],
            [31.838209435235374, -0.355649445367106],
            [31.835691453900726, -0.352664130316674],
            [31.83402847827373, -0.351777469461084],
            [31.83376732274925, -0.349769343938392],
            [31.832093033739582, -0.344929819467738],
            [31.830406525845394, -0.343636108016256],
            [31.828351166102266, -0.343862000600272],
            [31.82649787789076, -0.34486582284975],
            [31.82554744864206, -0.344702878594011],
            [31.824929687102642, -0.345082714448737],
            [31.82134194611356, -0.344268180007044],
            [31.808226622017163, -0.344456496726878],
            [31.798354057094645, -0.347114593787216],
            [31.793958665986462, -0.347593439136186],
            [31.791380449917074, -0.348416232250169],
            [31.77855063646909, -0.336601456705462],
            [31.7754848570843, -0.34090661135559],
            [31.773738020132274, -0.344135548843597],
            [31.771373607592057, -0.346251837039417],
            [31.767793346874374, -0.349028262880057],
            [31.76679533027184, -0.350050239194535],
            [31.765642441419335, -0.35233853761247],
            [31.761697921938776, -0.355820417521418],
            [31.757783840075, -0.362612844736176],
            [31.753903161166733, -0.365226365775713],
            [31.752334747596404, -0.367261309255446],
            [31.750782779484002, -0.368120389997342],
            [31.750184622777336, -0.370897178405844],
            [31.74894831457094, -0.373312063065799],
            [31.746976045398377, -0.374080622817648],
            [31.737364057485244, -0.371673237346512],
            [31.725352719753886, -0.366633400647795],
            [31.726469621197765, -0.378536899942275],
            [31.725993898576135, -0.38112371802936],
            [31.724567425108916, -0.384017943608622],
            [31.723046265617505, -0.385501108650031],
            [31.714169980854074, -0.388855479672046],
            [31.711270424831163, -0.390844947749241],
            [31.70913143822331, -0.393160156577379],
            [31.70581504504391, -0.399898172812358],
            [31.702805749927546, -0.413989826642025],
            [31.700998544391776, -0.420112998219333],
            [31.698956561461564, -0.436465997326831],
            [31.70363313783011, -0.441179263685227],
            [31.70688846802804, -0.4425637177068],
            [31.70824287954147, -0.442753892563177],
            [31.71182034290536, -0.442039960705335],
            [31.71507653728263, -0.4393684132498],
            [31.717072431248862, -0.439201336009246],
            [31.71883140623704, -0.440206770037422],
            [31.71987651881497, -0.445280479346626],
            [31.72201552159251, -0.448200525211957],
            [31.72900363566361, -0.453706062581661],
            [31.737625615454952, -0.463623521021033],
            [31.737212222439304, -0.468157612128892],
            [31.73792480475021, -0.469903455436223],
            [31.74135721714518, -0.475150255723679],
            [31.745622102805502, -0.47904045036119],
            [31.750866733335535, -0.480814271559939],
            [31.752372783163874, -0.47955726001017],
            [31.753882418168487, -0.475487202191841],
            [31.75704313241084, -0.470874721612288],
            [31.75939394086437, -0.468604795602909],
            [31.764194149670512, -0.465457904978699],
            [31.768269052428025, -0.464201332607086],
            [31.773436785373097, -0.464383133973308],
            [31.780041617058554, -0.466012435547603],
            [31.78130079637208, -0.46679959237014],
            [31.787228575014435, -0.467388558604035],
            [31.79148129658749, -0.469162170792497],
            [31.793157615789738, -0.462224695745881],
            [31.793537924751785, -0.461410686844478],
            [31.79427474360905, -0.461193719294691],
            [31.797161361196967, -0.461944973955156],
            [31.802934377183835, -0.464695736519035],
            [31.805203306894164, -0.465256934224065],
            [31.833025697006885, -0.46771290969054],
            [31.849071360594394, -0.488031765786333],
            [31.94026625762147, -0.488553329360439],
            [32.00053811075507, -0.491746752084751],
            [32.0005791305259, -0.447846739943441],
            [32.00063945599049, -0.406696700594698],
            [31.994362884879518, -0.407627652420682],
            [31.957937150526035, -0.407279273901521],
            [31.949442807861878, -0.406907293626807],
            [31.942754395125743, -0.405793788869747],
            [31.874834422207083, -0.361696443112357],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1183,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "BUWUNGA",
        Population: 42218,
        Key: "MASAKABUWUNGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.725352719753886, -0.366633400647795],
            [31.72506712825709, -0.362970096664593],
            [31.724940373275548, -0.361857534780932],
            [31.72137593189002, -0.36210124914186],
            [31.71985505716455, -0.361666871162411],
            [31.717265783732323, -0.357605269822193],
            [31.7159000238019, -0.354122737522498],
            [31.711955183622774, -0.354176457546897],
            [31.705747958858474, -0.349761619469182],
            [31.70458525591152, -0.352058902737633],
            [31.704038244785565, -0.354600475809573],
            [31.70445225763875, -0.363482735132862],
            [31.704202281648016, -0.366169067378749],
            [31.703108450737254, -0.369642193481655],
            [31.700267723585636, -0.374797431666065],
            [31.695811373700614, -0.37834240814603],
            [31.693577379471677, -0.379617401358016],
            [31.692032535897784, -0.3799970605813],
            [31.687030289696047, -0.380439498964395],
            [31.68151740605253, -0.380321077568585],
            [31.680899767582282, -0.380076780715789],
            [31.675660869202094, -0.374757570676391],
            [31.670766358850717, -0.372224254127582],
            [31.66839024755057, -0.372133444453081],
            [31.66306699287364, -0.373516502706158],
            [31.660975665484862, -0.374737250321001],
            [31.658682828011557, -0.375415260813189],
            [31.657350734243046, -0.38005505543864],
            [31.651456526541192, -0.384341385535394],
            [31.646334908611223, -0.387388667773957],
            [31.64067958540131, -0.386745592909743],
            [31.63881398398219, -0.388047732234727],
            [31.6327075996001, -0.384872044350416],
            [31.624581281436484, -0.382718084439236],
            [31.62009076951948, -0.381071230628397],
            [31.615136939816633, -0.37802238311094],
            [31.609363566300253, -0.373354409647669],
            [31.603126848946882, -0.369355697949108],
            [31.59938419348708, -0.370250528894236],
            [31.597031716862066, -0.370322519275962],
            [31.584768929004603, -0.367688599403284],
            [31.584021849590126, -0.376515973376005],
            [31.584412552958323, -0.382358821130292],
            [31.585991078863813, -0.390264037819003],
            [31.58808063387652, -0.396052909322591],
            [31.589611711666986, -0.403713937254241],
            [31.591428066543926, -0.409412349318928],
            [31.596211131901157, -0.431310177457547],
            [31.599849037510623, -0.432287668542485],
            [31.603460432937737, -0.434024904062183],
            [31.609436032495907, -0.437725271149915],
            [31.61630199994291, -0.442764438469714],
            [31.621398699505193, -0.444194443496309],
            [31.63106140270599, -0.441555168731969],
            [31.645091281830204, -0.439739747894327],
            [31.64990324958342, -0.440229045802333],
            [31.654893003812823, -0.442002733831166],
            [31.657494469180055, -0.444255368102623],
            [31.659785544158797, -0.451971042361019],
            [31.66246948654724, -0.457705982206369],
            [31.663728883253075, -0.458429797275248],
            [31.66596237173048, -0.458620157662773],
            [31.666795573529555, -0.459217273830613],
            [31.667530558027046, -0.459597300183296],
            [31.668790120921205, -0.459434719328889],
            [31.669135004820014, -0.457408729276191],
            [31.67037150706252, -0.45435178636767],
            [31.676563128988633, -0.44919733175925],
            [31.678773309777714, -0.447859086011547],
            [31.690168735600814, -0.444306453756968],
            [31.693412817993092, -0.442452813212898],
            [31.695908175257305, -0.441666337336111],
            [31.69702521594007, -0.440924845876981],
            [31.698593926852737, -0.439007575092786],
            [31.698956561461564, -0.436465997326831],
            [31.700998544391776, -0.420112998219333],
            [31.702805749927546, -0.413989826642025],
            [31.70581504504391, -0.399898172812358],
            [31.70913143822331, -0.393160156577379],
            [31.711270424831163, -0.390844947749241],
            [31.714169980854074, -0.388855479672046],
            [31.723046265617505, -0.385501108650031],
            [31.724567425108916, -0.384017943608622],
            [31.725993898576135, -0.38112371802936],
            [31.726469621197765, -0.378536899942275],
            [31.725352719753886, -0.366633400647795],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1184,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "KABONERA",
        Population: 33003,
        Key: "MASAKAKABONERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.00053811075507, -0.491746752084751],
            [31.94026625762147, -0.488553329360439],
            [31.849071360594394, -0.488031765786333],
            [31.833025697006885, -0.46771290969054],
            [31.805203306894164, -0.465256934224065],
            [31.802934377183835, -0.464695736519035],
            [31.797161361196967, -0.461944973955156],
            [31.79427474360905, -0.461193719294691],
            [31.793537924751785, -0.461410686844478],
            [31.793157615789738, -0.462224695745881],
            [31.79148129658749, -0.469162170792497],
            [31.787228575014435, -0.467388558604035],
            [31.78130079637208, -0.46679959237014],
            [31.780041617058554, -0.466012435547603],
            [31.773436785373097, -0.464383133973308],
            [31.768269052428025, -0.464201332607086],
            [31.764194149670512, -0.465457904978699],
            [31.75939394086437, -0.468604795602909],
            [31.75704313241084, -0.470874721612288],
            [31.753882418168487, -0.475487202191841],
            [31.752372783163874, -0.47955726001017],
            [31.750866733335535, -0.480814271559939],
            [31.745622102805502, -0.47904045036119],
            [31.74135721714518, -0.475150255723679],
            [31.73792480475021, -0.469903455436223],
            [31.737212222439304, -0.468157612128892],
            [31.737625615454952, -0.463623521021033],
            [31.72900363566361, -0.453706062581661],
            [31.72201552159251, -0.448200525211957],
            [31.71987651881497, -0.445280479346626],
            [31.71883140623704, -0.440206770037422],
            [31.717072431248862, -0.439201336009246],
            [31.71507653728263, -0.4393684132498],
            [31.71182034290536, -0.442039960705335],
            [31.70824287954147, -0.442753892563177],
            [31.70688846802804, -0.4425637177068],
            [31.70363313783011, -0.441179263685227],
            [31.698956561461564, -0.436465997326831],
            [31.698593926852737, -0.439007575092786],
            [31.69702521594007, -0.440924845876981],
            [31.695908175257305, -0.441666337336111],
            [31.693412817993092, -0.442452813212898],
            [31.690168735600814, -0.444306453756968],
            [31.678773309777714, -0.447859086011547],
            [31.676563128988633, -0.44919733175925],
            [31.67037150706252, -0.45435178636767],
            [31.669135004820014, -0.457408729276191],
            [31.668790120921205, -0.459434719328889],
            [31.667530558027046, -0.459597300183296],
            [31.666795573529555, -0.459217273830613],
            [31.666202734849378, -0.460673264837568],
            [31.66591848813054, -0.470552419660419],
            [31.666687875408474, -0.475072917928318],
            [31.665068414173813, -0.485202857392154],
            [31.662393884332925, -0.489064489883742],
            [31.659256645763886, -0.49145168973124],
            [31.658757152821536, -0.492934951164396],
            [31.65882702198768, -0.494544945460898],
            [31.658007409902265, -0.497565757845112],
            [31.658232726240144, -0.499655162771243],
            [31.66008565782047, -0.50180821561981],
            [31.66254433597333, -0.507452701808346],
            [31.66584628244631, -0.511216059360269],
            [31.66695859709238, -0.514264914568108],
            [31.66757057707464, -0.514933862080143],
            [31.66951369232297, -0.515395559506532],
            [31.675986671087657, -0.515116512740783],
            [31.677819109401433, -0.517305761063682],
            [31.678892638386785, -0.520770193682665],
            [31.679740911221362, -0.521846709921595],
            [31.680970827016214, -0.522597708033062],
            [31.68602690565965, -0.524371567727133],
            [31.69065147855639, -0.524680065013995],
            [31.698910396140793, -0.526454615791453],
            [31.707103181550618, -0.531847153020166],
            [31.708161148121984, -0.533167946428358],
            [31.707808422829043, -0.533464251871408],
            [31.71306578068999, -0.537184975151866],
            [31.718591953111535, -0.54437695951993],
            [31.722810277294037, -0.547561722593551],
            [31.728468328687505, -0.549950837918496],
            [31.72961398700027, -0.550918905829106],
            [31.730010751301684, -0.552158169565765],
            [31.73088554240348, -0.552737243391363],
            [31.73691165153511, -0.552765667459138],
            [31.7433435189008, -0.550044448837782],
            [31.746598627214887, -0.551338589194874],
            [31.750721607806422, -0.554206781798405],
            [31.751954480855183, -0.554387935665813],
            [31.7529056467224, -0.555012264274542],
            [31.753833190490912, -0.558476761723029],
            [31.754695108734673, -0.558893023032495],
            [31.75724003413796, -0.562059383499831],
            [31.756736985663697, -0.56283714961736],
            [31.75668205278576, -0.564989895654719],
            [31.757159424714253, -0.566120653320427],
            [31.758140602396804, -0.566889707459598],
            [31.757387432404737, -0.568734767225739],
            [31.757748578505133, -0.571113724371343],
            [31.757393025315693, -0.571502588420583],
            [31.75736605968749, -0.572823187972394],
            [31.758468329372015, -0.574578196053285],
            [31.758321568010818, -0.575473641037883],
            [31.759882763617803, -0.576613678464143],
            [31.760861655087975, -0.576252078150639],
            [31.76597056994149, -0.577429068438635],
            [31.766326614509403, -0.57737486774506],
            [31.766947697120422, -0.576117726622279],
            [31.76748178598103, -0.576027388518826],
            [31.769027570989312, -0.57697747143108],
            [31.77006703046921, -0.577059103489304],
            [31.772480707517875, -0.574228464454556],
            [31.77372665195234, -0.573749331617545],
            [31.77390392818544, -0.573297109122549],
            [31.777820069886197, -0.571886882941263],
            [31.779093739025274, -0.570476100383905],
            [31.783604995737115, -0.569807705159275],
            [31.783961581090814, -0.569862046054768],
            [31.78423038846484, -0.570757590585857],
            [31.783594722603507, -0.571942391568784],
            [31.7849075600856, -0.575189928747645],
            [31.784399730777377, -0.577324500865983],
            [31.78586436108461, -0.578437383234276],
            [31.78740865578784, -0.578582439385228],
            [31.788357805835574, -0.578193696186245],
            [31.79023044824991, -0.579198130322285],
            [31.790882798521032, -0.578809323388322],
            [32.000513329829644, -0.607607302217042],
            [32.00053811075507, -0.491746752084751],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1185,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "KYANAMUKAAKA",
        Population: 31521,
        Key: "MASAKAKYANAMUKAAKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.849055750569704, -0.262514751439194],
            [31.84758212902479, -0.262680957784037],
            [31.84652814738004, -0.261821532384744],
            [31.84221679636162, -0.25491942313172],
            [31.837025090974908, -0.249129865883338],
            [31.836625382894272, -0.24769159578305],
            [31.83396060246918, -0.246415955920926],
            [31.827960875060764, -0.24645160972477],
            [31.82666699921771, -0.247012314959864],
            [31.825211829068746, -0.245664416113899],
            [31.82445637106764, -0.244226130367835],
            [31.822914591647184, -0.244343584922001],
            [31.821719699368636, -0.24318566700043],
            [31.82031997593395, -0.24352022713726],
            [31.81752610580589, -0.241629498818712],
            [31.816181152654075, -0.238662475735385],
            [31.814381743596677, -0.237468340264836],
            [31.81366107375323, -0.236355687482588],
            [31.812981304204705, -0.232990746129588],
            [31.810805315091976, -0.233619704446244],
            [31.80847038975099, -0.236114875456311],
            [31.80704233255392, -0.242003618649671],
            [31.805510244158754, -0.242914855226678],
            [31.799243217647714, -0.239689457651098],
            [31.792593407315955, -0.23408046358572],
            [31.78923469450356, -0.232488300078605],
            [31.787224970973508, -0.233956409076385],
            [31.785761965718624, -0.235928162208691],
            [31.78533021652845, -0.238071859208553],
            [31.78541608648646, -0.241943256892475],
            [31.789100893136915, -0.242983797609991],
            [31.790852829824832, -0.24425029303283],
            [31.791635940665323, -0.244015189887495],
            [31.79310548655377, -0.244350000631429],
            [31.792367211527417, -0.245688639861175],
            [31.791717282216002, -0.251106729068529],
            [31.790868011353115, -0.253440340909895],
            [31.78809940364746, -0.257971784349294],
            [31.786935200513987, -0.259165652967496],
            [31.785449487645373, -0.263425846441674],
            [31.78251451733896, -0.269413539063905],
            [31.781744441053256, -0.274107968743454],
            [31.781316796265617, -0.274343106364069],
            [31.777491498494605, -0.274369845310287],
            [31.775840386917547, -0.273067159283284],
            [31.771967529640474, -0.274378330699142],
            [31.768807357980574, -0.274785040968538],
            [31.764780047068484, -0.27642182344704],
            [31.75082792791189, -0.275524892091521],
            [31.750827714112848, -0.274927902895933],
            [31.7431282681857, -0.275813530027861],
            [31.74127454518956, -0.276464581858554],
            [31.739825290446753, -0.275578004368481],
            [31.734396261840057, -0.270448845820732],
            [31.72425148852181, -0.256319355416246],
            [31.722255640369657, -0.254808637698726],
            [31.720961877714306, -0.254781336370564],
            [31.719213734611827, -0.256269884790168],
            [31.71797775069725, -0.258183172859215],
            [31.71264137343066, -0.267952755234951],
            [31.708611618202667, -0.279539512117419],
            [31.708149566143042, -0.284833693287285],
            [31.708778522487517, -0.289293490624982],
            [31.711272812553183, -0.294147588429741],
            [31.71228183082301, -0.304366637885028],
            [31.71231947562331, -0.304555403600481],
            [31.71428630010697, -0.306708352634377],
            [31.716900047240784, -0.30859003821188],
            [31.71851582538278, -0.308997267361931],
            [31.719165866983627, -0.308490817134137],
            [31.720476698527666, -0.306908081191113],
            [31.72191507916398, -0.302114362145526],
            [31.72329356373039, -0.299795700450317],
            [31.72885204855267, -0.301217368139664],
            [31.72928180168629, -0.300939362262176],
            [31.733618593891844, -0.300930815808443],
            [31.736375306106535, -0.30013516734723],
            [31.739927808881937, -0.301085316718648],
            [31.741614981529448, -0.300986015622833],
            [31.746344087782497, -0.300579529964712],
            [31.748982027445248, -0.299856208342764],
            [31.750834726361955, -0.303447361667436],
            [31.75170802626037, -0.302561026133917],
            [31.753279256947398, -0.3024436314372],
            [31.752828391607984, -0.301946093861063],
            [31.757767113444384, -0.302769770133878],
            [31.76266126985957, -0.303005508126616],
            [31.763730309065128, -0.304271954094729],
            [31.765654033279745, -0.308053089703371],
            [31.767091478769853, -0.309229125450634],
            [31.76530909638034, -0.31183394459847],
            [31.76964440636569, -0.315506825869396],
            [31.768361066862585, -0.317180043736516],
            [31.7672918201462, -0.317632176847419],
            [31.764226518665126, -0.320689096331119],
            [31.765306672725707, -0.325284206931558],
            [31.76684869289465, -0.338951744616052],
            [31.769354535294852, -0.344053587136842],
            [31.771373607592057, -0.346251837039417],
            [31.773738020132274, -0.344135548843597],
            [31.7754848570843, -0.34090661135559],
            [31.77855063646909, -0.336601456705462],
            [31.791380449917074, -0.348416232250169],
            [31.793958665986462, -0.347593439136186],
            [31.798354057094645, -0.347114593787216],
            [31.808226622017163, -0.344456496726878],
            [31.82134194611356, -0.344268180007044],
            [31.824929687102642, -0.345082714448737],
            [31.82554744864206, -0.344702878594011],
            [31.82649787789076, -0.34486582284975],
            [31.828351166102266, -0.343862000600272],
            [31.830406525845394, -0.343636108016256],
            [31.832093033739582, -0.344929819467738],
            [31.83376732274925, -0.349769343938392],
            [31.83402847827373, -0.351777469461084],
            [31.835691453900726, -0.352664130316674],
            [31.838209435235374, -0.355649445367106],
            [31.840799432709726, -0.355287965762145],
            [31.8423911494768, -0.355677119232866],
            [31.8447313110976, -0.357124680493431],
            [31.845562779148178, -0.356645381993597],
            [31.846632002508343, -0.356690735256896],
            [31.84912665998495, -0.357595605036299],
            [31.853034853392053, -0.360454470537957],
            [31.854579168756548, -0.360454664570223],
            [31.855933331436642, -0.360979478704396],
            [31.857620422337455, -0.359984681590354],
            [31.85899841283049, -0.360844176242335],
            [31.85997244441496, -0.360934756965453],
            [31.86154069269526, -0.360509815545515],
            [31.862729146748144, -0.359144076260052],
            [31.866566469367537, -0.358466138195144],
            [31.86768310311348, -0.358900472310587],
            [31.86982166481821, -0.358204221530178],
            [31.874834422207083, -0.361696443112357],
            [31.872875338506216, -0.354966282543093],
            [31.87178278230484, -0.352677620061737],
            [31.87013373325968, -0.338231644302207],
            [31.868780366486952, -0.333075509052837],
            [31.863697027567863, -0.325494745282749],
            [31.8612025614324, -0.322627028303728],
            [31.859979909414978, -0.315951283964183],
            [31.85958897158647, -0.308769077934508],
            [31.858817354690007, -0.306371928493963],
            [31.85553129671946, -0.299790014192429],
            [31.856228897826377, -0.289502346264343],
            [31.85556372590121, -0.284667811537208],
            [31.85429254599379, -0.279139710872015],
            [31.849055750569704, -0.262514751439194],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1186,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "MUKUNGWE",
        Population: 44460,
        Key: "MASAKAMUKUNGWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.750834726361955, -0.303447361667436],
            [31.748982027445248, -0.299856208342764],
            [31.746344087782497, -0.300579529964712],
            [31.741614981529448, -0.300986015622833],
            [31.739927808881937, -0.301085316718648],
            [31.736375306106535, -0.30013516734723],
            [31.733618593891844, -0.300930815808443],
            [31.72928180168629, -0.300939362262176],
            [31.72885204855267, -0.301217368139664],
            [31.72329356373039, -0.299795700450317],
            [31.72191507916398, -0.302114362145526],
            [31.720476698527666, -0.306908081191113],
            [31.719165866983627, -0.308490817134137],
            [31.72176689037976, -0.311114199875374],
            [31.726867825498594, -0.314407224625353],
            [31.731358535044954, -0.318713254774937],
            [31.73553463661249, -0.32187955377527],
            [31.738409011959725, -0.323236676457478],
            [31.737879358979985, -0.335456596921667],
            [31.7373223720628, -0.339309745731706],
            [31.73786752906601, -0.340114833179024],
            [31.736856441976062, -0.342475491100281],
            [31.7409886563504, -0.352633725615164],
            [31.73959172757458, -0.353284791517881],
            [31.738240170907098, -0.354659464349378],
            [31.73574114043169, -0.359832937573136],
            [31.730699109642657, -0.361252317688153],
            [31.728484477701357, -0.36247309752341],
            [31.72506712825709, -0.362970096664593],
            [31.725352719753886, -0.366633400647795],
            [31.737364057485244, -0.371673237346512],
            [31.746976045398377, -0.374080622817648],
            [31.74894831457094, -0.373312063065799],
            [31.750184622777336, -0.370897178405844],
            [31.750782779484002, -0.368120389997342],
            [31.752334747596404, -0.367261309255446],
            [31.753903161166733, -0.365226365775713],
            [31.757783840075, -0.362612844736176],
            [31.75091926232178, -0.361843058718802],
            [31.750627577552372, -0.36152642416139],
            [31.750097895826563, -0.354154537276143],
            [31.748612781235916, -0.352842782976077],
            [31.74618645500972, -0.349703795991581],
            [31.744423081869925, -0.346302576553232],
            [31.744317200142337, -0.344348813127643],
            [31.744914622925407, -0.340468522414351],
            [31.74646661978388, -0.337013469976568],
            [31.74779334432197, -0.332047840204324],
            [31.748721795388914, -0.330338424184924],
            [31.747267815507705, -0.32910808409707],
            [31.751480712967606, -0.327806114267577],
            [31.75166795331385, -0.325825244510158],
            [31.752880117500357, -0.322949014426058],
            [31.754092932067127, -0.317042655704614],
            [31.753104579540402, -0.310132010750984],
            [31.751740607257396, -0.307463530294182],
            [31.750834726361955, -0.303447361667436],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1187,
        District: "MASAKA",
        County: "MASAKA MUNICIPALITY",
        Subcounty: "KATWE-BUTEGO DIVISION",
        Population: 25353,
        Key: "MASAKAKATWE-BUTEGO DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.719165866983627, -0.308490817134137],
            [31.71851582538278, -0.308997267361931],
            [31.716900047240784, -0.30859003821188],
            [31.71428630010697, -0.306708352634377],
            [31.71231947562331, -0.304555403600481],
            [31.714833610371922, -0.317598660320865],
            [31.71460765533187, -0.319362430217173],
            [31.71258769729579, -0.320194314705805],
            [31.7102586622081, -0.320555818972462],
            [31.708203186582324, -0.320329444366365],
            [31.69616705984073, -0.321349991783476],
            [31.695560555988433, -0.321711718787955],
            [31.69509730827113, -0.323737735262136],
            [31.6947758389602, -0.328034058037609],
            [31.695380998932833, -0.3316069041521],
            [31.69592711713337, -0.333569746571954],
            [31.697756193053042, -0.336744775943175],
            [31.702044735846393, -0.340444764191156],
            [31.70651174424227, -0.342733752127288],
            [31.709303361395644, -0.345447630440965],
            [31.706736498234807, -0.348007022161218],
            [31.705747958858474, -0.349761619469182],
            [31.711955183622774, -0.354176457546897],
            [31.7159000238019, -0.354122737522498],
            [31.717265783732323, -0.357605269822193],
            [31.71985505716455, -0.361666871162411],
            [31.72137593189002, -0.36210124914186],
            [31.724940373275548, -0.361857534780932],
            [31.72506712825709, -0.362970096664593],
            [31.728484477701357, -0.36247309752341],
            [31.730699109642657, -0.361252317688153],
            [31.73574114043169, -0.359832937573136],
            [31.738240170907098, -0.354659464349378],
            [31.73959172757458, -0.353284791517881],
            [31.7409886563504, -0.352633725615164],
            [31.736856441976062, -0.342475491100281],
            [31.73786752906601, -0.340114833179024],
            [31.7373223720628, -0.339309745731706],
            [31.737879358979985, -0.335456596921667],
            [31.738409011959725, -0.323236676457478],
            [31.73553463661249, -0.32187955377527],
            [31.731358535044954, -0.318713254774937],
            [31.726867825498594, -0.314407224625353],
            [31.72176689037976, -0.311114199875374],
            [31.719165866983627, -0.308490817134137],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1188,
        District: "MASAKA",
        County: "MASAKA MUNICIPALITY",
        Subcounty: "KIMAANYA-KYABAKUZA DIVISION",
        Population: 34260,
        Key: "MASAKAKIMAANYA-KYABAKUZA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.771373607592057, -0.346251837039417],
            [31.769354535294852, -0.344053587136842],
            [31.76684869289465, -0.338951744616052],
            [31.765306672725707, -0.325284206931558],
            [31.764226518665126, -0.320689096331119],
            [31.7672918201462, -0.317632176847419],
            [31.768361066862585, -0.317180043736516],
            [31.76964440636569, -0.315506825869396],
            [31.76530909638034, -0.31183394459847],
            [31.767091478769853, -0.309229125450634],
            [31.765654033279745, -0.308053089703371],
            [31.763730309065128, -0.304271954094729],
            [31.76266126985957, -0.303005508126616],
            [31.757767113444384, -0.302769770133878],
            [31.752828391607984, -0.301946093861063],
            [31.753279256947398, -0.3024436314372],
            [31.75170802626037, -0.302561026133917],
            [31.750834726361955, -0.303447361667436],
            [31.751740607257396, -0.307463530294182],
            [31.753104579540402, -0.310132010750984],
            [31.754092932067127, -0.317042655704614],
            [31.752880117500357, -0.322949014426058],
            [31.75166795331385, -0.325825244510158],
            [31.751480712967606, -0.327806114267577],
            [31.747267815507705, -0.32910808409707],
            [31.748721795388914, -0.330338424184924],
            [31.74779334432197, -0.332047840204324],
            [31.74646661978388, -0.337013469976568],
            [31.744914622925407, -0.340468522414351],
            [31.744317200142337, -0.344348813127643],
            [31.744423081869925, -0.346302576553232],
            [31.74618645500972, -0.349703795991581],
            [31.748612781235916, -0.352842782976077],
            [31.750097895826563, -0.354154537276143],
            [31.750627577552372, -0.36152642416139],
            [31.75091926232178, -0.361843058718802],
            [31.757783840075, -0.362612844736176],
            [31.761697921938776, -0.355820417521418],
            [31.765642441419335, -0.35233853761247],
            [31.76679533027184, -0.350050239194535],
            [31.767793346874374, -0.349028262880057],
            [31.771373607592057, -0.346251837039417],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1189,
        District: "MASAKA",
        County: "MASAKA MUNICIPALITY",
        Subcounty: "NYENDO-SSENYANGE DIVISION",
        Population: 43614,
        Key: "MASAKANYENDO-SSENYANGE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.716621264973828, -0.114483960795393],
            [31.702309909535128, -0.100669580449964],
            [31.70029806957425, -0.108528351948596],
            [31.696320427412548, -0.120911111916645],
            [31.692253480135165, -0.141295446514243],
            [31.69249886753146, -0.146563137243211],
            [31.696576938646963, -0.158328147598731],
            [31.697748047130066, -0.164963373422774],
            [31.70415285903604, -0.179192131936623],
            [31.70465009091883, -0.181487596391229],
            [31.70494337648606, -0.186281487808306],
            [31.70473290480825, -0.19707608869331],
            [31.705521211504355, -0.206891034860271],
            [31.70619543934592, -0.210704779226603],
            [31.708983164099134, -0.216217168267437],
            [31.711724428884164, -0.220390654189203],
            [31.719344283178817, -0.230412336446288],
            [31.720921282846604, -0.234417877867902],
            [31.722518038264127, -0.243420391972911],
            [31.72176018984604, -0.252995921729582],
            [31.72096188220589, -0.254781305828131],
            [31.72225563228482, -0.254808606258005],
            [31.724251505589823, -0.256319375178985],
            [31.73439625734847, -0.270448812583443],
            [31.739825275175402, -0.275577994487127],
            [31.74127454518956, -0.276464579163627],
            [31.7431282681857, -0.275813519248187],
            [31.75082770782463, -0.274927916370501],
            [31.75082791803042, -0.27552486783728],
            [31.764780052458367, -0.276421839616533],
            [31.768807347200774, -0.274785030188897],
            [31.771967522453963, -0.274378336088996],
            [31.775840384222622, -0.273067161978212],
            [31.777491494901355, -0.274369844411967],
            [31.781744456324606, -0.274108002879019],
            [31.782514515542335, -0.269413515707972],
            [31.785449480458833, -0.26342581769587],
            [31.786697331118337, -0.259690269105535],
            [31.789382767405087, -0.255936682318697],
            [31.79160185229523, -0.25154087617705],
            [31.792367209730784, -0.245688617403487],
            [31.793105477570634, -0.244349999733106],
            [31.791635925393972, -0.244015170124738],
            [31.790852846892815, -0.244250273270073],
            [31.789100885950408, -0.242983801203214],
            [31.78541607391004, -0.241943238028005],
            [31.785330207545318, -0.238071884361154],
            [31.785761960328742, -0.235928157717144],
            [31.78722498624486, -0.233956442313767],
            [31.789481441949157, -0.232292256956803],
            [31.787753834334097, -0.231855594869084],
            [31.78594337869363, -0.23080387297463],
            [31.78910814972777, -0.228218008734147],
            [31.792590350349066, -0.22380170057878],
            [31.795306209879545, -0.223135899507178],
            [31.80011521409064, -0.219403567471971],
            [31.803752057891426, -0.212669479259759],
            [31.80643328287612, -0.209865421536171],
            [31.809427831248797, -0.207902685752735],
            [31.811173229998072, -0.206237865078916],
            [31.8099982964885, -0.203477318533763],
            [31.808020318522278, -0.201426575458733],
            [31.807348056194567, -0.199257648685329],
            [31.8062963598639, -0.198302632996469],
            [31.803836731293472, -0.196941342197246],
            [31.794958604085398, -0.189229139075985],
            [31.792242849657804, -0.188387674650229],
            [31.790815300008898, -0.188667975349238],
            [31.789004808435813, -0.187826581862852],
            [31.793635799795243, -0.185233060567143],
            [31.798042807916687, -0.180577776433172],
            [31.796880051070808, -0.176266094182145],
            [31.79586467362706, -0.164063867985603],
            [31.79741135515401, -0.151391424536981],
            [31.797158283568812, -0.147981276846323],
            [31.79563577929941, -0.144860554113053],
            [31.789548078976914, -0.13802200971686],
            [31.788720997399896, -0.136800865889402],
            [31.7880354004801, -0.135796790296361],
            [31.787114241038324, -0.134204741978705],
            [31.78670413944987, -0.132042895489048],
            [31.787283868116774, -0.127429848126531],
            [31.787792714317906, -0.126082378497865],
            [31.79017142534249, -0.119461038405605],
            [31.79143790975588, -0.115146466987236],
            [31.79151037145998, -0.114621865390619],
            [31.79134586747358, -0.113880125240277],
            [31.789907229919095, -0.112713230340608],
            [31.78905846211278, -0.112025739297745],
            [31.788269172659756, -0.111410535533114],
            [31.785889760050942, -0.10958337911786],
            [31.781450819516113, -0.106444475260584],
            [31.780408036269677, -0.106082622808406],
            [31.779602535819034, -0.105820287346174],
            [31.77756441294958, -0.105340812377342],
            [31.776116441000994, -0.105539774502835],
            [31.774598006998172, -0.1062180714528],
            [31.77187635782566, -0.109139626548882],
            [31.76795636953887, -0.112404786298156],
            [31.767875801437693, -0.112459035453724],
            [31.764179900593454, -0.115045828030699],
            [31.762434853085477, -0.115986460137791],
            [31.760986600862523, -0.116773326109565],
            [31.760227383411934, -0.116990395461491],
            [31.758756111859828, -0.11737021404734],
            [31.758258038255587, -0.11744256959831],
            [31.756952989167033, -0.11775003172977],
            [31.75180301142356, -0.119631226560695],
            [31.75071218986898, -0.120436198832072],
            [31.74296544854045, -0.120544347668326],
            [31.740244219779516, -0.121059824985427],
            [31.737985939596882, -0.122108956958716],
            [31.736088528833537, -0.123626966161236],
            [31.732099272353526, -0.129191033045522],
            [31.726814862626085, -0.125473209913638],
            [31.72332108272081, -0.121491787905286],
            [31.717739597433983, -0.115610221312371],
            [31.716621264973828, -0.114483960795393],
          ],
          [
            [31.757716978468405, -0.198001488073147],
            [31.756018952375634, -0.197313509321811],
            [31.752428638611594, -0.194741956734741],
            [31.749507394562762, -0.191628820593138],
            [31.747953027948547, -0.187576177821106],
            [31.74617685561257, -0.179415095393281],
            [31.743928400304227, -0.176340626150073],
            [31.743317792049393, -0.174132675425019],
            [31.734799587436335, -0.15776466800578],
            [31.73308043656135, -0.152970699456578],
            [31.7323836107005, -0.147697326618484],
            [31.732611487236944, -0.134162212256555],
            [31.73210102676326, -0.129207876414276],
            [31.745079471864866, -0.133872997747041],
            [31.761477094482355, -0.137137101644562],
            [31.766703991370363, -0.137189736481167],
            [31.770921160319432, -0.150811031338392],
            [31.774317353540457, -0.156536857988816],
            [31.77673448820468, -0.162497858377876],
            [31.7779715321313, -0.16749092644908],
            [31.778793209443585, -0.174745281388791],
            [31.780166088522638, -0.180923344925295],
            [31.780143875880608, -0.185464025201325],
            [31.777471036669056, -0.187643761310893],
            [31.7756879868313, -0.189624535777271],
            [31.774355005527266, -0.191840555015016],
            [31.766714763967254, -0.188036140623365],
            [31.76390149292398, -0.189512528152479],
            [31.763151435594363, -0.196283049853118],
            [31.761652230928476, -0.197330984145383],
            [31.757716978468405, -0.198001488073147],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1190,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "KALUNGU",
        Population: 39734,
        Key: "KALUNGUKALUNGU",
        Dist2: "Kalungu",
        "Sub Country": "Kalungu",
        id2_original: "Kalungu Kalungu",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.922086634398458, -0.094237884087926],
            [31.920803972225073, -0.09511528359775],
            [31.918542959367333, -0.098724464903291],
            [31.914574771973978, -0.102225024400961],
            [31.911000565901332, -0.104549645874204],
            [31.906344160304183, -0.108285362590758],
            [31.90160834992413, -0.110374746712874],
            [31.899911551828385, -0.11090837823433],
            [31.894812196846114, -0.111279061051349],
            [31.88006204313718, -0.111300879291793],
            [31.869988953581984, -0.115772973252218],
            [31.861218270271777, -0.120458107795138],
            [31.85676140744872, -0.121684791407819],
            [31.846469983262008, -0.122303705879443],
            [31.84753242434182, -0.129576344641318],
            [31.848718217584835, -0.134696152323813],
            [31.848619013034746, -0.136541433173439],
            [31.850261170205034, -0.139246117913322],
            [31.851468487082276, -0.140177864823929],
            [31.85271837871408, -0.143162951099343],
            [31.85263124213153, -0.144990136576557],
            [31.8523044071834, -0.145360986884846],
            [31.85298211958994, -0.147142999651084],
            [31.85468610869955, -0.148581321598868],
            [31.856532569714915, -0.150965071214215],
            [31.85325211543509, -0.15352855394748],
            [31.852605742553884, -0.154430595779213],
            [31.85131306506339, -0.155022050693854],
            [31.850815212444736, -0.155994753680533],
            [31.850945730468986, -0.156993779856232],
            [31.852120744826927, -0.159202204116201],
            [31.854047985047586, -0.160714380849864],
            [31.853050590079203, -0.16384103460518],
            [31.85290160359103, -0.166780822916365],
            [31.85206528014634, -0.169548692861187],
            [31.853064507677907, -0.170815135755485],
            [31.85379497903941, -0.172769008529719],
            [31.85497899271984, -0.173537942240287],
            [31.85654378607957, -0.173682764372284],
            [31.867084932932098, -0.173520573393935],
            [31.871534551740698, -0.1726705608084],
            [31.876496153667393, -0.169839580447421],
            [31.879253332107705, -0.166981326037274],
            [31.881228825333856, -0.163905931330818],
            [31.883379168443515, -0.162006472006293],
            [31.893147342841825, -0.157692230830711],
            [31.896804402329803, -0.155548605246878],
            [31.902178705569384, -0.154201065378524],
            [31.909894340036256, -0.150465587186447],
            [31.923803687707256, -0.144903137714618],
            [31.928596508768468, -0.143781686269293],
            [31.940218403467956, -0.142968097240179],
            [31.963220442749254, -0.137252157536293],
            [31.94759248049754, -0.13039476525114],
            [31.945192406637187, -0.127291955274452],
            [31.936616808660602, -0.112935948318876],
            [31.931500264415376, -0.105138327063995],
            [31.922086634398458, -0.094237884087926],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1192,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "LUKAYA TOWN COUNCIL",
        Population: 24163,
        Key: "KALUNGULUKAYA TOWN COUNCIL",
        Dist2: "Kalungu",
        "Sub Country": "Lukaya  TC",
        id2_original: "Kalungu Lukaya  TC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.812024860735168, 0.043147024045857],
            [31.80637696838928, 0.048185201257093],
            [31.78595653002937, 0.060558792505955],
            [31.780544847890823, 0.06283807307997],
            [31.750589154811053, 0.069603133638652],
            [31.732189807262802, 0.069403628740628],
            [31.719264595426594, 0.070335195370648],
            [31.708887767507537, 0.072595865109858],
            [31.698583031186644, 0.075924116848352],
            [31.694988107268575, 0.07643957239769],
            [31.690167136599612, 0.075788178508787],
            [31.673986661040793, 0.071156670834088],
            [31.666984306875804, 0.067439008326982],
            [31.663011901892215, 0.064797792470615],
            [31.658687214485077, 0.059479297502805],
            [31.652852709715315, 0.049448427920747],
            [31.646436446086117, 0.039435689312842],
            [31.649043029155546, 0.037889073715076],
            [31.650418760385623, 0.037509210399614],
            [31.65343382538104, 0.037572574851209],
            [31.655615888901707, 0.036948524338476],
            [31.65984138343684, 0.033032165976493],
            [31.66299490217377, 0.031738790701689],
            [31.663638724737886, 0.028844449803773],
            [31.66569448333299, 0.025669718609401],
            [31.666617391794645, 0.020785488980942],
            [31.668012507770214, 0.019039835215617],
            [31.670890881518766, 0.017068069197576],
            [31.672072362848418, 0.011405980054027],
            [31.672734397856615, 0.01049244642737],
            [31.6808675243518, 0.003573108329078],
            [31.682831189460597, 0.001302833842967],
            [31.68636486534427, 0.000172223209629],
            [31.68706340608898, -0.000370467019815],
            [31.687980647977845, -0.006439639575985],
            [31.688881334814305, -0.009505886952979],
            [31.693856161738633, -0.014200248065759],
            [31.694603825956325, -0.01552985794771],
            [31.69894378651991, -0.027577820016846],
            [31.70123023247997, -0.036677131669057],
            [31.701840152625287, -0.047386433957305],
            [31.703294368763405, -0.055698821286603],
            [31.70693189887708, -0.054501399905919],
            [31.71263213874953, -0.053495362692994],
            [31.7164446759519, -0.052042140707934],
            [31.71895245691651, -0.050188297177071],
            [31.72431047010673, -0.044067756521194],
            [31.72586925014396, -0.041076271331465],
            [31.727142924672886, -0.032229490857597],
            [31.730881465848714, -0.028055931202472],
            [31.732658213106433, -0.026528111774917],
            [31.73758119286582, -0.025410207926022],
            [31.740076623791904, -0.027505865869217],
            [31.74109890838186, -0.026908891412777],
            [31.743858053234323, -0.023272763918502],
            [31.74659005638878, -0.021668032483047],
            [31.75077089926439, -0.023022640624488],
            [31.753176846310065, -0.026041092889807],
            [31.759728490544177, -0.030401147338055],
            [31.76231136168336, -0.030583313973759],
            [31.767377541882187, -0.03381349712149],
            [31.767152052169468, -0.034877994253687],
            [31.767983400744093, -0.036162429454595],
            [31.769074197145823, -0.036117210967129],
            [31.76950852090761, -0.035667785715286],
            [31.770757982246376, -0.036925699948467],
            [31.77679148810608, -0.037745627168479],
            [31.779863738055862, -0.039236243603841],
            [31.78397245340069, -0.042590169336877],
            [31.786082313033784, -0.043559113488054],
            [31.788530223979638, -0.044020235656713],
            [31.79458790440193, -0.046106595614856],
            [31.79606622144084, -0.047126735588583],
            [31.798546214818767, -0.051648455992477],
            [31.803403277100905, -0.053493784353748],
            [31.805309435658483, -0.054723994247376],
            [31.806112711880484, -0.056062722346893],
            [31.806272701832572, -0.058694926743053],
            [31.80758415770576, -0.060757301207874],
            [31.81305246694487, -0.06494543588283],
            [31.81611566187661, -0.068346577417958],
            [31.819338398501095, -0.06937782644962],
            [31.822278700308715, -0.06943216999286],
            [31.823060652322482, -0.069794011122244],
            [31.8258476539319, -0.069495573937332],
            [31.826092334354048, -0.069767067073586],
            [31.832934966264883, -0.065981889821548],
            [31.83637179837103, -0.067079247676619],
            [31.83771907097292, -0.06491884936074],
            [31.840023750038302, -0.062937937831642],
            [31.844686685489222, -0.061481717512173],
            [31.848100966288506, -0.061671746119328],
            [31.858932834916416, -0.042334831372322],
            [31.862440732744712, -0.041919694838917],
            [31.867826038549914, -0.040517631655772],
            [31.87223206840598, -0.03809421474488],
            [31.875483285218273, -0.035747827388186],
            [31.88359180416287, -0.032625706224926],
            [31.893434029384977, -0.027017190494793],
            [31.905366009045817, -0.021329141269329],
            [31.912438165003337, -0.018932073320057],
            [31.915370414312708, -0.017439552195133],
            [31.914761959319623, -0.01707770632351],
            [31.913053653805065, -0.017511901606433],
            [31.911322892205032, -0.017385251733658],
            [31.910612796430826, -0.016743003046382],
            [31.909260241735094, -0.017077680272362],
            [31.908063533961347, -0.016706810823431],
            [31.904788724694786, -0.017728952535122],
            [31.900281845473334, -0.018271672382154],
            [31.8989321078943, -0.017385190648224],
            [31.8958145639896, -0.016987165130025],
            [31.89460720039995, -0.016145906376357],
            [31.892545123953454, -0.015576025063405],
            [31.89128861622959, -0.015521749754273],
            [31.88910382452541, -0.016806212100338],
            [31.888227503592688, -0.016399157614396],
            [31.88642909256357, -0.014608118226133],
            [31.885125131334803, -0.014436251653205],
            [31.883456450507406, -0.013043216215898],
            [31.881991318940266, -0.010799893929735],
            [31.876963636042944, -0.005643893037119],
            [31.875234848041604, -0.002848801208196],
            [31.871539466423616, 0.005807818507674],
            [31.869214030885303, 0.007264153762027],
            [31.852432546468798, 0.014138688317847],
            [31.838844176730294, 0.0202985868569],
            [31.827774978594185, 0.02827656639275],
            [31.821547267749846, 0.03362235722168],
            [31.812024860735168, 0.043147024045857],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1193,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "LWABENGE",
        Population: 34252,
        Key: "KALUNGULWABENGE",
        Dist2: "Kalungu",
        "Sub Country": "Lwabenge",
        id2_original: "Kalungu Lwabenge",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.922086634398458, -0.094237884087926],
            [31.917864863380164, -0.089253567464338],
            [31.902076436865862, -0.039492836524404],
            [31.915370414312708, -0.017439552195133],
            [31.912438165003337, -0.018932073320057],
            [31.905366009045817, -0.021329141269329],
            [31.893434029384977, -0.027017190494793],
            [31.88359180416287, -0.032625706224926],
            [31.875483285218273, -0.035747827388186],
            [31.87223206840598, -0.03809421474488],
            [31.867826038549914, -0.040517631655772],
            [31.862440732744712, -0.041919694838917],
            [31.858932834916416, -0.042334831372322],
            [31.848100966288506, -0.061671746119328],
            [31.844686685489222, -0.061481717512173],
            [31.840023750038302, -0.062937937831642],
            [31.83771907097292, -0.06491884936074],
            [31.83637179837103, -0.067079247676619],
            [31.835013625611523, -0.071087793461037],
            [31.83387123357314, -0.078161323226704],
            [31.83264131867662, -0.08196942981256],
            [31.829595586095685, -0.086546334946711],
            [31.82714939542361, -0.088264894527085],
            [31.825143776296095, -0.089033696979847],
            [31.824335388660113, -0.090010571438077],
            [31.822686393513884, -0.1060571151896],
            [31.821615532524945, -0.112940633023972],
            [31.822094627422143, -0.117825191814131],
            [31.810022144064348, -0.12222978907291],
            [31.80923846908185, -0.122781521381186],
            [31.805156241461503, -0.129447772696415],
            [31.801911710809875, -0.132866770573923],
            [31.799393630660546, -0.13477522001985],
            [31.79587963416979, -0.136728847259942],
            [31.78949052301835, -0.138193871304478],
            [31.795635790079178, -0.144860575672548],
            [31.79715827458564, -0.147981307388956],
            [31.797411343475915, -0.151391405672408],
            [31.79586468620349, -0.164063846426128],
            [31.796880068138783, -0.176266069927738],
            [31.79804279084868, -0.180577752178771],
            [31.793635792608733, -0.18523304080431],
            [31.789004810232438, -0.187826615100333],
            [31.790815294618977, -0.188668001400212],
            [31.79224285414939, -0.188387678243464],
            [31.79495861306857, -0.189229128296279],
            [31.803836723208637, -0.196941337705687],
            [31.806296374236954, -0.198302636589736],
            [31.80734805080468, -0.199257666651529],
            [31.808020324810496, -0.201426606001279],
            [31.809998293793548, -0.203477340093191],
            [31.81117321472669, -0.206237835434703],
            [31.809427820469, -0.20790271449862],
            [31.806433297249175, -0.209865443993914],
            [31.803752074061105, -0.212669457700344],
            [31.800115199717585, -0.219403546810889],
            [31.795306213472802, -0.223135905795343],
            [31.792590339569262, -0.223801684409255],
            [31.789108160507567, -0.228218018615537],
            [31.78594336342225, -0.230803846923726],
            [31.78775381816442, -0.231855576902956],
            [31.789481434762617, -0.232292270431448],
            [31.78923469450356, -0.232488300078605],
            [31.792593407315955, -0.23408046358572],
            [31.799243217647714, -0.239689457651098],
            [31.805510244158754, -0.242914855226678],
            [31.80704233255392, -0.242003618649671],
            [31.80847038975099, -0.236114875456311],
            [31.810805315091976, -0.233619704446244],
            [31.812981304204705, -0.232990746129588],
            [31.81366107375323, -0.236355687482588],
            [31.814381743596677, -0.237468340264836],
            [31.816181152654075, -0.238662475735385],
            [31.81752610580589, -0.241629498818712],
            [31.82031997593395, -0.24352022713726],
            [31.821719699368636, -0.24318566700043],
            [31.822914591647184, -0.244343584922001],
            [31.82445637106764, -0.244226130367835],
            [31.825211829068746, -0.245664416113899],
            [31.82666699921771, -0.247012314959864],
            [31.827960875060764, -0.24645160972477],
            [31.83396060246918, -0.246415955920926],
            [31.836625382894272, -0.24769159578305],
            [31.837025090974908, -0.249129865883338],
            [31.84221679636162, -0.25491942313172],
            [31.84652814738004, -0.261821532384744],
            [31.84758212902479, -0.262680957784037],
            [31.849055750569704, -0.262514751439194],
            [31.854389831742452, -0.258176899987269],
            [31.8558631739113, -0.257390071797055],
            [31.858904376288233, -0.257109934999355],
            [31.86435712401169, -0.257933563217949],
            [31.867921122527786, -0.257834379435449],
            [31.87096238509186, -0.256884863470747],
            [31.874229740138173, -0.255293126670504],
            [31.87608303823118, -0.253936444137315],
            [31.877128782324775, -0.252733476983635],
            [31.878285864513025, -0.249875164956871],
            [31.878245101660372, -0.247034840006267],
            [31.87693111433473, -0.246021633288181],
            [31.876814073734664, -0.245424604966166],
            [31.87857336043823, -0.243443766823942],
            [31.880662477971416, -0.242439880670547],
            [31.883005599541054, -0.239400738048879],
            [31.88336310387129, -0.238613798248985],
            [31.883248689046845, -0.236795620168044],
            [31.88499965735085, -0.233349382062223],
            [31.885121344037568, -0.231965411216382],
            [31.88481361356058, -0.231730206352887],
            [31.882772246874637, -0.232562235309181],
            [31.883395239303958, -0.229821466248925],
            [31.882849962824828, -0.229721916647947],
            [31.882946032254555, -0.229197284067991],
            [31.88221151757598, -0.228934906236694],
            [31.882118934507858, -0.227903700587633],
            [31.883463482519456, -0.225958988117023],
            [31.88780796250724, -0.223869786069554],
            [31.887241995132165, -0.222503844262984],
            [31.887504004954454, -0.222024452935544],
            [31.89096230949082, -0.223725293158357],
            [31.892029592490026, -0.223589694397679],
            [31.89368041301289, -0.222431964310709],
            [31.894320893844167, -0.222386782087274],
            [31.896072332865426, -0.223870406800677],
            [31.89685663307537, -0.223083493089137],
            [31.89612674472048, -0.220885341070132],
            [31.896462689483943, -0.219184788878562],
            [31.896914233949687, -0.218732532656275],
            [31.914491966169432, -0.216345733336608],
            [31.917457694791135, -0.215776067156359],
            [31.92021147400639, -0.214546047745073],
            [31.923750702376857, -0.212040624252533],
            [31.930619537246198, -0.205392457934612],
            [31.937924406269623, -0.194655603083373],
            [31.942132021635665, -0.190241523172141],
            [31.94882080178274, -0.18448878058378],
            [31.953590974519035, -0.177849428395666],
            [31.95811984988855, -0.172901604652268],
            [31.962908129966003, -0.1685960336501],
            [31.96635216566244, -0.1662171531168],
            [31.97832995131791, -0.160301749428089],
            [31.98774062497924, -0.156909998795582],
            [32.00042341655453, -0.15373546665462],
            [31.98642273267705, -0.14717651927705],
            [31.963220442749254, -0.137252157536293],
            [31.940218403467956, -0.142968097240179],
            [31.928596508768468, -0.143781686269293],
            [31.923803687707256, -0.144903137714618],
            [31.909894340036256, -0.150465587186447],
            [31.902178705569384, -0.154201065378524],
            [31.896804402329803, -0.155548605246878],
            [31.893147342841825, -0.157692230830711],
            [31.883379168443515, -0.162006472006293],
            [31.881228825333856, -0.163905931330818],
            [31.879253332107705, -0.166981326037274],
            [31.876496153667393, -0.169839580447421],
            [31.871534551740698, -0.1726705608084],
            [31.867084932932098, -0.173520573393935],
            [31.85654378607957, -0.173682764372284],
            [31.85497899271984, -0.173537942240287],
            [31.85379497903941, -0.172769008529719],
            [31.853064507677907, -0.170815135755485],
            [31.85206528014634, -0.169548692861187],
            [31.85290160359103, -0.166780822916365],
            [31.853050590079203, -0.16384103460518],
            [31.854047985047586, -0.160714380849864],
            [31.852120744826927, -0.159202204116201],
            [31.850945730468986, -0.156993779856232],
            [31.850815212444736, -0.155994753680533],
            [31.85131306506339, -0.155022050693854],
            [31.852605742553884, -0.154430595779213],
            [31.85325211543509, -0.15352855394748],
            [31.856532569714915, -0.150965071214215],
            [31.85468610869955, -0.148581321598868],
            [31.85298211958994, -0.147142999651084],
            [31.8523044071834, -0.145360986884846],
            [31.85263124213153, -0.144990136576557],
            [31.85271837871408, -0.143162951099343],
            [31.851468487082276, -0.140177864823929],
            [31.850261170205034, -0.139246117913322],
            [31.848619013034746, -0.136541433173439],
            [31.848718217584835, -0.134696152323813],
            [31.84753242434182, -0.129576344641318],
            [31.846469983262008, -0.122303705879443],
            [31.85676140744872, -0.121684791407819],
            [31.861218270271777, -0.120458107795138],
            [31.869988953581984, -0.115772973252218],
            [31.88006204313718, -0.111300879291793],
            [31.894812196846114, -0.111279061051349],
            [31.899911551828385, -0.11090837823433],
            [31.90160834992413, -0.110374746712874],
            [31.906344160304183, -0.108285362590758],
            [31.911000565901332, -0.104549645874204],
            [31.914574771973978, -0.102225024400961],
            [31.918542959367333, -0.098724464903291],
            [31.920803972225073, -0.09511528359775],
            [31.922086634398458, -0.094237884087926],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1194,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "BUKULULA",
        Population: 43887,
        Key: "KALUNGUBUKULULA",
        Dist2: "Kalungu",
        "Sub Country": "Bukulula",
        id2_original: "Kalungu Bukulula",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.588657379298795, 0.4036017961539],
            [32.58563275533042, 0.403433341961337],
            [32.58376373671998, 0.402012606994048],
            [32.57770188092821, 0.401520606419202],
            [32.575803187370646, 0.400403243652952],
            [32.573947660557444, 0.401146969427943],
            [32.57192213566155, 0.400900175026886],
            [32.56881675494578, 0.40137186163571],
            [32.564950711390125, 0.402546567708984],
            [32.56485914072333, 0.401882248484491],
            [32.56372446700984, 0.387463404100363],
            [32.55861536979832, 0.385094629276711],
            [32.55803618281553, 0.384522980373993],
            [32.55826157281524, 0.383771214277728],
            [32.5576112895676, 0.382263171546514],
            [32.557227274156695, 0.382470207049555],
            [32.554670256531374, 0.380443702088957],
            [32.55512117397305, 0.378777614435479],
            [32.54969780115938, 0.375924797645853],
            [32.54991184274213, 0.375051105081218],
            [32.55420685969372, 0.368052738371083],
            [32.555398667157576, 0.360884303190183],
            [32.55635330231845, 0.358311180043486],
            [32.55636006842916, 0.356758664542068],
            [32.553902048741435, 0.352268989561299],
            [32.55354487768612, 0.348551437877659],
            [32.55355820598999, 0.348037142117049],
            [32.554646760196796, 0.347805072031974],
            [32.55676684086117, 0.346402877011996],
            [32.55956175303499, 0.33400096562514],
            [32.56205403356935, 0.329145047364514],
            [32.5635956081739, 0.328067177480959],
            [32.563891465617786, 0.327265980486022],
            [32.56514582457153, 0.327860087759593],
            [32.56662426917116, 0.32767220100578],
            [32.569907485770486, 0.328116364826216],
            [32.573307395321834, 0.329796378058795],
            [32.57613708307693, 0.332457263867286],
            [32.57731912226038, 0.334873911987396],
            [32.579111476847864, 0.336637394086475],
            [32.58047389863867, 0.337132953723127],
            [32.58317650083223, 0.336682184211644],
            [32.58706849761473, 0.339933963276569],
            [32.58453539404061, 0.339335257438374],
            [32.58349181668348, 0.34211113643155],
            [32.58678741835559, 0.344677618425345],
            [32.586863596390025, 0.345225330192125],
            [32.58556437287607, 0.348156957198361],
            [32.58625690389154, 0.348179146972799],
            [32.589022525597166, 0.350168998749453],
            [32.58963587371362, 0.351715310808061],
            [32.589189657155785, 0.35270286134469],
            [32.589966257905445, 0.355510818225486],
            [32.589623597336946, 0.357285431787776],
            [32.58874336244454, 0.357981362843975],
            [32.598540094285745, 0.358860289659585],
            [32.598559345182274, 0.359441034589561],
            [32.59989887250976, 0.359871824874797],
            [32.60098223984409, 0.361283377220001],
            [32.60225317091819, 0.364663917731392],
            [32.60441286728659, 0.366521070417263],
            [32.60206075897082, 0.37080676935792],
            [32.599024801856835, 0.378600930458062],
            [32.59337272964992, 0.385164522016688],
            [32.59276115031629, 0.391247622569665],
            [32.59284664657515, 0.393362479362986],
            [32.593609778883724, 0.395958508522504],
            [32.588657379298795, 0.4036017961539],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1195,
        District: "KAMPALA",
        County: "KCCA",
        Subcounty: "KAWEMPE DIVISION",
        Population: 338665,
        Key: "KAMPALAKAWEMPE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.63387243161474, 0.378399694259169],
            [32.63238970923769, 0.378291825115086],
            [32.63116238328581, 0.377288355095023],
            [32.62982792874474, 0.377304883737877],
            [32.628073331246945, 0.376183998243103],
            [32.62480735241962, 0.376298715123074],
            [32.61928472924178, 0.377339515736017],
            [32.617616376299495, 0.387716520199644],
            [32.61551633076088, 0.386486011753494],
            [32.61257201258564, 0.385966630233183],
            [32.61071694301492, 0.384997631382714],
            [32.60891374216868, 0.386348424422131],
            [32.605072933187685, 0.390710535959579],
            [32.605131214086676, 0.393533243275573],
            [32.60647292521864, 0.396238400706829],
            [32.606531188151315, 0.399404901025286],
            [32.604248745084185, 0.403828130952519],
            [32.60291375784213, 0.405222056053548],
            [32.59894621633745, 0.405746584483668],
            [32.588657379298795, 0.4036017961539],
            [32.593609778883724, 0.395958508522504],
            [32.59284664657515, 0.393362479362986],
            [32.59276115031629, 0.391247622569665],
            [32.59337272964992, 0.385164522016688],
            [32.599024801856835, 0.378600930458062],
            [32.60206075897082, 0.37080676935792],
            [32.60441286728659, 0.366521070417263],
            [32.60225317091819, 0.364663917731392],
            [32.60098223984409, 0.361283377220001],
            [32.59989887250976, 0.359871824874797],
            [32.598559345182274, 0.359441034589561],
            [32.598540094285745, 0.358860289659585],
            [32.58874336244454, 0.357981362843975],
            [32.589623597336946, 0.357285431787776],
            [32.589966257905445, 0.355510818225486],
            [32.589189657155785, 0.35270286134469],
            [32.58963587371362, 0.351715310808061],
            [32.589022525597166, 0.350168998749453],
            [32.58625690389154, 0.348179146972799],
            [32.58920464824124, 0.347996979181585],
            [32.59338732547666, 0.345122053656396],
            [32.59801149233488, 0.347966000452073],
            [32.596276877860596, 0.344670127509728],
            [32.59538604374617, 0.342027251448703],
            [32.59643906599021, 0.339973460606068],
            [32.599231091876995, 0.338078984566688],
            [32.601365668655134, 0.335201207565406],
            [32.603008081845296, 0.328808285295441],
            [32.60667807886996, 0.325572448300631],
            [32.60802026970228, 0.322830346166461],
            [32.61218604783056, 0.320967964057677],
            [32.611043939659794, 0.314277120885894],
            [32.6114601551821, 0.314100550688402],
            [32.61276778243552, 0.310646265348839],
            [32.613324748691475, 0.309317003659668],
            [32.61677601313099, 0.306261282785078],
            [32.622646010337604, 0.302686925061482],
            [32.62408625946971, 0.302558501903168],
            [32.627393938990835, 0.300749479893317],
            [32.62783410719184, 0.300151692528458],
            [32.629344680037626, 0.299902660488152],
            [32.63179815155512, 0.296790501955463],
            [32.63246228143454, 0.296732841667437],
            [32.63269070773994, 0.296108889204454],
            [32.635929551157474, 0.293799553330419],
            [32.637028821367295, 0.292640171366184],
            [32.63748283979334, 0.290299472297726],
            [32.640207132707715, 0.285295430611552],
            [32.64803907385106, 0.276850272622758],
            [32.65874176653778, 0.263224249553031],
            [32.668758788642805, 0.274592553079941],
            [32.66284223624658, 0.281305400050824],
            [32.66283939846862, 0.282282497445813],
            [32.66447635439342, 0.283476774195569],
            [32.66750730968789, 0.2870595533987],
            [32.667652110026864, 0.290850331908755],
            [32.666045627651435, 0.294288217833301],
            [32.663380132167354, 0.296975153573129],
            [32.663785282241975, 0.300078352379844],
            [32.66460836901093, 0.30152592888306],
            [32.664399382248284, 0.302973474651496],
            [32.663588584432425, 0.303787696210754],
            [32.66276536201784, 0.306682770778238],
            [32.66150293888782, 0.308673113204091],
            [32.66173123314085, 0.309487367567615],
            [32.66559795492454, 0.313015897937924],
            [32.666785269913674, 0.315006318220757],
            [32.66687643633861, 0.318199982417876],
            [32.66541477855664, 0.323899668378892],
            [32.66139564321197, 0.326287989762707],
            [32.65517854506437, 0.328406470985919],
            [32.65076225015953, 0.328340348880428],
            [32.64867457442239, 0.326853465557043],
            [32.647344382387345, 0.326707771069099],
            [32.64601932152918, 0.325916954729124],
            [32.64173776403549, 0.328924662818367],
            [32.63907535516274, 0.331831228583515],
            [32.643779132518056, 0.334602117861976],
            [32.64050951910708, 0.335276054812002],
            [32.6396797830084, 0.337996636539528],
            [32.638332518491346, 0.338645520577605],
            [32.63730105042426, 0.340596392641595],
            [32.6389900080242, 0.342425436968407],
            [32.63846481338326, 0.34333990645055],
            [32.63890772324251, 0.343516249759527],
            [32.638656988175356, 0.344445191633336],
            [32.63977789700372, 0.345548535463917],
            [32.63926814080922, 0.346603448282443],
            [32.63960757193429, 0.350544152452676],
            [32.636884619306294, 0.360983003623613],
            [32.63461718349427, 0.364846498409644],
            [32.63389450861114, 0.368862959782783],
            [32.63383585850458, 0.374562671867709],
            [32.63433531731094, 0.377812825985098],
            [32.63387243161474, 0.378399694259169],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1196,
        District: "KAMPALA",
        County: "KCCA",
        Subcounty: "NAKAWA DIVISION",
        Population: 317023,
        Key: "KAMPALANAKAWA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.61276778243552, 0.310646265348839],
            [32.61084383274376, 0.312009624616837],
            [32.60958064694404, 0.311841378047354],
            [32.60729723279808, 0.313304067786785],
            [32.608619383114714, 0.314784082867446],
            [32.606092960311344, 0.31616900712358],
            [32.60532130029575, 0.31454013914942],
            [32.60195646187142, 0.315276488743902],
            [32.59792259685101, 0.314605840040715],
            [32.59407673125325, 0.314724308073789],
            [32.58701263138724, 0.308333051899685],
            [32.58689487482989, 0.308773308039746],
            [32.5832325062986, 0.308382008475326],
            [32.580165357881306, 0.30605081141706],
            [32.5795311984947, 0.307276852284617],
            [32.57805036886798, 0.30728744147288],
            [32.57729421736745, 0.303994560937917],
            [32.57710459738403, 0.301104446078497],
            [32.57222420854889, 0.302109317277025],
            [32.5733297615758, 0.299991391262763],
            [32.57370261541931, 0.297956689929703],
            [32.57301282516375, 0.296491339127653],
            [32.570818588572685, 0.294817716492163],
            [32.57138916250854, 0.293370048380428],
            [32.57264152181244, 0.293262293280848],
            [32.5703099040683, 0.289762778910736],
            [32.56849397499281, 0.28553343449645],
            [32.5714899983992, 0.286594054946358],
            [32.574423923964886, 0.281765589737169],
            [32.57650090256363, 0.279318321677181],
            [32.57823619526596, 0.276464260265404],
            [32.579513224104176, 0.275319987844333],
            [32.58028906308247, 0.273994265787003],
            [32.58266214975505, 0.272174705727526],
            [32.58458236425188, 0.26940098524658],
            [32.58559183796756, 0.26897753307838],
            [32.586585142906465, 0.267722966899362],
            [32.59187856273616, 0.264918673370995],
            [32.59221681167831, 0.263587152516339],
            [32.59445691265455, 0.26258387068474],
            [32.596479651874745, 0.262172289394996],
            [32.59804278155455, 0.260439788708098],
            [32.601426984063146, 0.258555919606578],
            [32.60258101826765, 0.257047736275159],
            [32.6034834379543, 0.256562199046218],
            [32.6041520558169, 0.254866007138565],
            [32.60498847448298, 0.254292327101534],
            [32.60565378025714, 0.251390631697896],
            [32.60628706468467, 0.250844281589602],
            [32.60717276223229, 0.248711451640711],
            [32.607358306559284, 0.247877228205627],
            [32.60635200299825, 0.248019193928851],
            [32.60653427566098, 0.247621124505642],
            [32.60934913941723, 0.245133246260071],
            [32.610454267541016, 0.243414323009625],
            [32.61201553141995, 0.239442673735146],
            [32.61592283998651, 0.226315376658775],
            [32.63425030793898, 0.214319319945125],
            [32.63674901232596, 0.220570973477711],
            [32.63950139555926, 0.234331786746332],
            [32.64147891179144, 0.23881018892682],
            [32.650055773697595, 0.252869732119646],
            [32.65874176653778, 0.263224249553031],
            [32.64803907385106, 0.276850272622758],
            [32.640207132707715, 0.285295430611552],
            [32.63748283979334, 0.290299472297726],
            [32.637028821367295, 0.292640171366184],
            [32.635929551157474, 0.293799553330419],
            [32.63269070773994, 0.296108889204454],
            [32.63246228143454, 0.296732841667437],
            [32.63179815155512, 0.296790501955463],
            [32.629344680037626, 0.299902660488152],
            [32.62783410719184, 0.300151692528458],
            [32.627393938990835, 0.300749479893317],
            [32.62408625946971, 0.302558501903168],
            [32.622646010337604, 0.302686925061482],
            [32.61677601313099, 0.306261282785078],
            [32.613324748691475, 0.309317003659668],
            [32.61276778243552, 0.310646265348839],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1197,
        District: "KAMPALA",
        County: "KCCA",
        Subcounty: "MAKINDYE DIVISION",
        Population: 393008,
        Key: "KAMPALAMAKINDYE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.93537575740993, 1.222588643420283],
            [32.933197172166025, 1.222305034390105],
            [32.93096003832517, 1.223924448159478],
            [32.89868572342849, 1.192701159487864],
            [32.89613163790427, 1.189534506371919],
            [32.894302301473175, 1.185707435658179],
            [32.8917018583887, 1.176035759262632],
            [32.89096538717941, 1.175103857221655],
            [32.88953958655035, 1.174560970321465],
            [32.88441829470886, 1.174687418451331],
            [32.8735458051621, 1.178179200943396],
            [32.86733153041948, 1.178667463164621],
            [32.86590572709546, 1.1782150298585],
            [32.865714831504334, 1.181680134537523],
            [32.86109119105885, 1.181764093884393],
            [32.854332475270304, 1.194788261775801],
            [32.85393552950917, 1.197729098379349],
            [32.85297846260885, 1.197372617855379],
            [32.85003716367129, 1.199580967966728],
            [32.84513491792698, 1.204514600048425],
            [32.84107308745345, 1.207850624955535],
            [32.831964628613264, 1.212672350503297],
            [32.83131583207743, 1.207568094811323],
            [32.834024315541114, 1.195585922426306],
            [32.83416455782834, 1.192484618996231],
            [32.83313285799587, 1.183523458481823],
            [32.83086453375005, 1.184030507609207],
            [32.82694308570092, 1.186373508693105],
            [32.82461413774984, 1.187042858816719],
            [32.820348465165296, 1.186870684237431],
            [32.8067673762722, 1.187819723892757],
            [32.796738317640624, 1.187348541079597],
            [32.800523197512064, 1.15829804852275],
            [32.80060730317885, 1.152571135448485],
            [32.80000313404798, 1.144093802995458],
            [32.796513501664364, 1.125790938104303],
            [32.79281110240739, 1.101670667594292],
            [32.78801119902846, 1.07513470436383],
            [32.78463186449036, 1.051095889178725],
            [32.79420828720308, 1.050734650240075],
            [32.80294126732251, 1.049685734354933],
            [32.80805056845157, 1.048871800483923],
            [32.81276750343088, 1.047596422422137],
            [32.81704516672782, 1.045769126483111],
            [32.818970413586854, 1.044385005299346],
            [32.82089540083279, 1.042593754509028],
            [32.82452018295426, 1.037536528413552],
            [32.826563947243685, 1.03627002145976],
            [32.83679394013968, 1.03619819224055],
            [32.83985950482713, 1.035773126839813],
            [32.84267539266281, 1.034796161863773],
            [32.85004254188488, 1.030879042414734],
            [32.85563889159471, 1.0293774511068],
            [32.86276795672378, 1.029043019170729],
            [32.8786531560487, 1.030455048717202],
            [32.88344134539634, 1.030491418315052],
            [32.88626898678922, 1.030364858974777],
            [32.890415977551676, 1.028890295169763],
            [32.89331495865281, 1.028872300324811],
            [32.89523987133859, 1.027913347839722],
            [32.89647547077421, 1.02778672552517],
            [32.901524822832805, 1.029732060401596],
            [32.902903107074934, 1.029858765270558],
            [32.905825619544935, 1.031984972276446],
            [32.90813052588408, 1.032365029116449],
            [32.90960370725452, 1.034011681395073],
            [32.912431354037274, 1.033939385974993],
            [32.91584124297311, 1.034717546047693],
            [32.91764701659431, 1.03537804853771],
            [32.9181461277527, 1.03610184661489],
            [32.919357840086604, 1.036699000112873],
            [32.92114003382992, 1.036979515107052],
            [32.92263714182791, 1.036861934114644],
            [32.923991571307646, 1.036147231064294],
            [32.92602381470357, 1.033767833890811],
            [32.92614265552744, 1.032564542188422],
            [32.934548438677645, 1.029489811312403],
            [32.93572890580938, 1.03450735478142],
            [32.94170326838738, 1.049715737541028],
            [32.943426640445885, 1.054746641300527],
            [32.94371384980852, 1.05671273402325],
            [32.94296691412451, 1.062148373730075],
            [32.93986449156098, 1.071227013275069],
            [32.937279069206376, 1.081520004814492],
            [32.93733643831534, 1.085394354885655],
            [32.937853423252946, 1.088285669633163],
            [32.941587478242205, 1.096670528314028],
            [32.94779192272068, 1.103378471823437],
            [32.95307723166172, 1.107888996404542],
            [32.95612275852845, 1.111295067390266],
            [32.95867643531923, 1.113238597003871],
            [32.96017011085451, 1.115015455640995],
            [32.96078114670739, 1.116792302427872],
            [32.961867387752335, 1.123557971514563],
            [32.96112045835651, 1.129366855478155],
            [32.96118829822844, 1.133535592667048],
            [32.96302141836355, 1.138934471141423],
            [32.96566929518996, 1.144675058721058],
            [32.967298736707406, 1.150620651897901],
            [32.96784185812819, 1.154857734008651],
            [32.96777390686515, 1.159778207836094],
            [32.96478634738542, 1.168799041701475],
            [32.96390361697314, 1.174471242988747],
            [32.96634774780828, 1.187455858621344],
            [32.96478603297507, 1.193743110379463],
            [32.962477455221354, 1.198731892980518],
            [32.96003309262086, 1.202422213465227],
            [32.95439753773708, 1.205907458475999],
            [32.951613716163784, 1.206932508081672],
            [32.942160564765935, 1.207704000381493],
            [32.939390810809954, 1.209843371384016],
            [32.93597682286146, 1.21671540652093],
            [32.93537575740993, 1.222588643420283],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1200,
        District: "KAYUNGA",
        County: "BBAALE",
        Subcounty: "BBAALE",
        Population: 17169,
        Key: "KAYUNGABBAALE",
        Dist2: "Kayunga",
        "Sub Country": "BBAALE",
        id2_original: "Kayunga BBAALE",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.39458258209981, 1.43757889368276],
            [32.39424143249763, 1.440661247301782],
            [32.384151317172844, 1.449647576673469],
            [32.378468981622305, 1.45946243763877],
            [32.377670393707795, 1.4597200582207],
            [32.37680765979374, 1.460895767686936],
            [32.36758568174944, 1.468718659460803],
            [32.36533182217632, 1.473123724174248],
            [32.36266172013146, 1.483101528386479],
            [32.359068880304854, 1.488664299117328],
            [32.352390187340085, 1.497121031533088],
            [32.35173034601783, 1.497184172315269],
            [32.35052772643122, 1.499201183134395],
            [32.345802447899565, 1.503904072668523],
            [32.33995911808046, 1.507593329917128],
            [32.334794716986785, 1.509672490022184],
            [32.33171258377224, 1.511381362118196],
            [32.32722563906524, 1.514618659671571],
            [32.3267015978611, 1.516002562939464],
            [32.32699684894215, 1.520453696240148],
            [32.32666257774008, 1.523158495376961],
            [32.32094571364501, 1.535288308439527],
            [32.314038721037335, 1.545174062878796],
            [32.306111159621885, 1.553132472217903],
            [32.302088811901726, 1.555356669188955],
            [32.300231474983235, 1.557599523909866],
            [32.30026523187496, 1.561742870732016],
            [32.299188867806606, 1.572300021315954],
            [32.299096720421375, 1.589940846036048],
            [32.29875009738415, 1.5930075494578],
            [32.29507009222891, 1.600216396887702],
            [32.29190009210147, 1.610003630211692],
            [32.290898049249805, 1.614951808533324],
            [32.29240693865277, 1.618833370384858],
            [32.295236912072106, 1.622371597955592],
            [32.29793452502255, 1.62846996696544],
            [32.3042724205247, 1.635456165138897],
            [32.312549061869674, 1.643221027024013],
            [32.30845204258982, 1.647497629717749],
            [32.30000949319168, 1.651840587429586],
            [32.297388307108996, 1.654505929766986],
            [32.28069311755363, 1.660428401552758],
            [32.280179954947585, 1.661764084012108],
            [32.27660999431291, 1.662938838212444],
            [32.271195609143675, 1.664501809096808],
            [32.26249739113083, 1.665973161480384],
            [32.24936900373357, 1.667362435228144],
            [32.23660766346981, 1.667703230240239],
            [32.23221946337549, 1.669039609057307],
            [32.23025292545441, 1.671126182475123],
            [32.22305250714232, 1.670425794442062],
            [32.217630401851515, 1.671560276567097],
            [32.198428141000626, 1.673371154308032],
            [32.18298055686469, 1.670778654454004],
            [32.175917904184566, 1.67333846418851],
            [32.157037422563405, 1.671276866438115],
            [32.143107359741975, 1.670845578325195],
            [32.15418120037145, 1.657489054698813],
            [32.15838307011291, 1.654044191504806],
            [32.16356312165548, 1.647695878669529],
            [32.1714943329259, 1.635016309988858],
            [32.18178158713305, 1.622084252276813],
            [32.18873581046342, 1.609177927388647],
            [32.20294982535628, 1.590557217551507],
            [32.20352243128133, 1.583440659573148],
            [32.20132204931539, 1.576542537485395],
            [32.20132352345075, 1.572758830973591],
            [32.1976115867804, 1.56674476322462],
            [32.2005690086807, 1.561562292911952],
            [32.202814165375344, 1.55509821761333],
            [32.2050022646764, 1.553881168194881],
            [32.2062278335236, 1.549447643060939],
            [32.199255995128816, 1.538113756507158],
            [32.19782507679756, 1.537598813930622],
            [32.195426153679115, 1.533778837684391],
            [32.18722888657431, 1.523744438911319],
            [32.18528908700767, 1.51422578401255],
            [32.18381234112221, 1.510534292108747],
            [32.18315832537457, 1.503839668586046],
            [32.18362025616166, 1.499769032893435],
            [32.18442038828015, 1.497145866859735],
            [32.18511903861934, 1.497046664742782],
            [32.18785897030451, 1.493157722522488],
            [32.18930357357079, 1.488083257381016],
            [32.18825619454334, 1.486979123112358],
            [32.184543485321846, 1.484860934464124],
            [32.18274867923198, 1.481323178180194],
            [32.17300167812488, 1.471377498900858],
            [32.1658746692395, 1.464698753022978],
            [32.15798528532533, 1.458128030352964],
            [32.15537350370533, 1.455033211641615],
            [32.14987862140178, 1.446790022660036],
            [32.15773937151631, 1.437212945393528],
            [32.17066802300173, 1.428931244260678],
            [32.17065770674899, 1.427076659221375],
            [32.16975412733732, 1.424733343630238],
            [32.16206925118576, 1.417439303027908],
            [32.1448425814774, 1.405383219376407],
            [32.142280348233534, 1.404568103245614],
            [32.1353382656342, 1.403498025359356],
            [32.13010852647668, 1.401786406041635],
            [32.12773865846776, 1.400256639105149],
            [32.12710485481398, 1.39749738798399],
            [32.13009308713187, 1.394802680902144],
            [32.13581058274263, 1.39175618740444],
            [32.13822326086473, 1.391356554997577],
            [32.139041219151714, 1.388871620314105],
            [32.14087609818814, 1.386257868185887],
            [32.14287962244438, 1.381753570007354],
            [32.14433229617518, 1.380424309512862],
            [32.14617454499019, 1.379800722786208],
            [32.149328894668734, 1.381321662536974],
            [32.15068422785365, 1.381276899921256],
            [32.15154057474601, 1.380653033225237],
            [32.1541227398094, 1.375144865331484],
            [32.15567514090978, 1.372983214362935],
            [32.15697629490325, 1.367944967077852],
            [32.160238793657186, 1.362273996312968],
            [32.162630136791286, 1.361923752347547],
            [32.16307999601758, 1.36161055337382],
            [32.16291205328025, 1.360529090251148],
            [32.17164634493997, 1.354884343476439],
            [32.175834108436554, 1.351133379053947],
            [32.17617357279928, 1.350428818711233],
            [32.17740623025234, 1.34999508074058],
            [32.17985420947017, 1.346431580318483],
            [32.18119817357685, 1.345780762566575],
            [32.185820075782225, 1.345212313616078],
            [32.18724944990951, 1.344462005773889],
            [32.18795968043101, 1.343891452342477],
            [32.19068747048678, 1.339569074162254],
            [32.193331816035794, 1.337480218651175],
            [32.20226591277767, 1.335791425154181],
            [32.20420571234431, 1.335059356052778],
            [32.208628300846016, 1.331387925060429],
            [32.21033895994664, 1.328430317308921],
            [32.21125404767543, 1.324278266089911],
            [32.21364630349784, 1.321709769259976],
            [32.21200105342801, 1.318416352522977],
            [32.21245982573858, 1.316272472741467],
            [32.21828497904621, 1.309625281211543],
            [32.22047216655726, 1.306007276366107],
            [32.22322276573643, 1.30454270100079],
            [32.22510712218205, 1.303014417470503],
            [32.225427498243285, 1.302435574176572],
            [32.22552785712851, 1.298608895342442],
            [32.22598480496074, 1.29774055968369],
            [32.22717605457079, 1.297596164696228],
            [32.22976572954996, 1.298818261296982],
            [32.231442841964565, 1.298149328367346],
            [32.23348735095738, 1.29455853073169],
            [32.2383492722269, 1.292081214979007],
            [32.24014470983242, 1.290245328961895],
            [32.242434712222696, 1.285650343528091],
            [32.24301454599253, 1.28517112940347],
            [32.24581300920664, 1.28429436956338],
            [32.25063282104892, 1.283680721018682],
            [32.251886953627185, 1.283843921000123],
            [32.253379139755715, 1.283392069541029],
            [32.259959509417676, 1.277956935742845],
            [32.26238552213185, 1.273950040192479],
            [32.2641701521062, 1.272367430577236],
            [32.26577511902376, 1.271517469085135],
            [32.27853645928748, 1.267341608414147],
            [32.28001903074758, 1.266256456413347],
            [32.28258357984823, 1.262747004156312],
            [32.28565483626132, 1.260495304841008],
            [32.2875764584182, 1.260133961410691],
            [32.290958475325695, 1.260379113421999],
            [32.29688216304023, 1.260111649063152],
            [32.29881290938547, 1.259451546922347],
            [32.301836933279205, 1.259956867250465],
            [32.305978236807604, 1.260048501095105],
            [32.308768558590295, 1.258900339054218],
            [32.3128266978863, 1.260321719574113],
            [32.31592462168693, 1.262231439773949],
            [32.32252127421172, 1.269768991568511],
            [32.3308461299346, 1.277524167700749],
            [32.3400471242322, 1.284212137782268],
            [32.34509179606819, 1.289008213098378],
            [32.34705040456023, 1.290239013610415],
            [32.35100860628088, 1.293967337714162],
            [32.353720956991864, 1.29793954115563],
            [32.355928496734016, 1.302336785022748],
            [32.35731765687927, 1.308498049667257],
            [32.35703012591974, 1.32103677325692],
            [32.35725533625643, 1.322556627206665],
            [32.35893855452005, 1.325334486895035],
            [32.360743536725465, 1.326691982515738],
            [32.364904420832104, 1.328873320032439],
            [32.36840595589325, 1.32914554860221],
            [32.38017241197982, 1.340276163910768],
            [32.38479978851856, 1.346573868294136],
            [32.39095401986762, 1.353152481860041],
            [32.40337652728429, 1.364391736384161],
            [32.40834786066047, 1.368237817900302],
            [32.41016996655183, 1.370753364696014],
            [32.41417947016006, 1.374816373280713],
            [32.411434906761286, 1.377593050686946],
            [32.394963173132844, 1.39696711836906],
            [32.390791831738, 1.403116215773918],
            [32.395158696844355, 1.409967453824434],
            [32.39841579133353, 1.412395818206446],
            [32.398871476134424, 1.415704259576622],
            [32.39823928675323, 1.42236659223918],
            [32.396661901708185, 1.426913749978077],
            [32.39458258209981, 1.43757889368276],
          ],
          [
            [32.22327708596335, 1.402023405874245],
            [32.22210653892731, 1.407709154927478],
            [32.22021151498769, 1.410806001601095],
            [32.21847264339729, 1.416596828718888],
            [32.21857131704303, 1.417393839731913],
            [32.218892464757104, 1.417298422934947],
            [32.218572791178396, 1.417405485520085],
            [32.21890572928057, 1.421766028919765],
            [32.21866767573028, 1.425697331081321],
            [32.219358817052004, 1.431781243933454],
            [32.22406037467026, 1.427273806097945],
            [32.229003634795525, 1.424202800035653],
            [32.236685213231674, 1.421470097301614],
            [32.241766098851684, 1.421828611441613],
            [32.2479101540852, 1.42325761508205],
            [32.25169065826287, 1.425518425002644],
            [32.25428931549654, 1.42849232915752],
            [32.25759637877339, 1.433250372742538],
            [32.25960467488045, 1.434797095206448],
            [32.26789212475493, 1.43543147236292],
            [32.26838177665335, 1.436078617578446],
            [32.27891726052634, 1.436081985202679],
            [32.28294234451482, 1.435130209981878],
            [32.2836472417385, 1.434480258142465],
            [32.28509759961248, 1.435416177058266],
            [32.2889202123191, 1.434867815353937],
            [32.2917021114977, 1.435371275388341],
            [32.29868560104171, 1.43787524440161],
            [32.30306474791461, 1.440497637662737],
            [32.302947264445116, 1.437399988531231],
            [32.29963599076454, 1.42667675178942],
            [32.29916360268924, 1.422983292251693],
            [32.29774454571299, 1.41809824008197],
            [32.29466900882759, 1.410829996411157],
            [32.29470697612308, 1.410221151041754],
            [32.28887108525283, 1.402607837304397],
            [32.28188949115406, 1.39450436064187],
            [32.2812985685804, 1.391406650046063],
            [32.28284044232395, 1.381280547817618],
            [32.28580179435358, 1.374490687612277],
            [32.28689584445327, 1.374067618399736],
            [32.28841715575999, 1.3698456243443],
            [32.28201700970361, 1.364005570297514],
            [32.28000499457126, 1.362932668568672],
            [32.28018269211424, 1.362503844336645],
            [32.27922584619947, 1.363181880521836],
            [32.277046308741376, 1.360787424067988],
            [32.27254848633459, 1.359594685261319],
            [32.267695267943566, 1.359593141492079],
            [32.2579883388847, 1.361019797583337],
            [32.25452238609197, 1.360809454425293],
            [32.254566108893464, 1.362068845855745],
            [32.25445767954371, 1.360805525404345],
            [32.25206984522911, 1.360660571917786],
            [32.25082399421945, 1.361426310634657],
            [32.23907571464432, 1.358728054906941],
            [32.233322636765195, 1.358395350491944],
            [32.231760831202116, 1.359056689256482],
            [32.22789702265491, 1.362033343689796],
            [32.22608818128698, 1.364183358477327],
            [32.22444426431705, 1.364596466351131],
            [32.219924685612426, 1.362196117326501],
            [32.21754183425269, 1.360127347554931],
            [32.21392618530272, 1.358306385692349],
            [32.20948857786774, 1.356567791945713],
            [32.20725001840055, 1.356127459693328],
            [32.208057449330724, 1.357310378094094],
            [32.20884649264538, 1.372222110614725],
            [32.211965331022434, 1.385292602689869],
            [32.21508627505052, 1.392076679075058],
            [32.21919396182434, 1.397537378962947],
            [32.22327708596335, 1.402023405874245],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1762,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "NABISWEERA",
        Population: 16522,
        Key: "NAKASONGOLANABISWEERA",
        Dist2: "Nakasongola",
        "Sub Country": "Nabiswera",
        id2_original: "NakasongolaNabiswera",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.66370090977556, 1.439868691413315],
            [32.66326022773818, 1.497390368552211],
            [32.66166759918109, 1.52489342567653],
            [32.660214245425614, 1.529072972455404],
            [32.65076583264089, 1.541918364875171],
            [32.64119590564602, 1.542279869580589],
            [32.62990540843799, 1.542140990056737],
            [32.623971135874456, 1.539715318559187],
            [32.62326020736197, 1.539090942674365],
            [32.589905195822304, 1.548041332366668],
            [32.58741941190406, 1.548547481120287],
            [32.585803234910124, 1.548420504827427],
            [32.58357048754279, 1.547913429320452],
            [32.563750461559216, 1.535313611182509],
            [32.54919521711411, 1.522984442727622],
            [32.55780335656185, 1.522387037835664],
            [32.5623508522106, 1.521073522002381],
            [32.56506023129462, 1.519126737074928],
            [32.568350566144254, 1.514843257898304],
            [32.57018963761809, 1.510608164537774],
            [32.57278914016644, 1.501165189030086],
            [32.57711362904588, 1.489848175076281],
            [32.57666892794595, 1.489839041400225],
            [32.58062454970511, 1.484257770053072],
            [32.59151607904431, 1.471322516783434],
            [32.60712607948193, 1.455293902181482],
            [32.62536103353656, 1.438001879542196],
            [32.639915645567704, 1.436539460294991],
            [32.65483395671131, 1.436175586295663],
            [32.66370090977556, 1.439868691413315],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1768,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "NAMASALE TOWN COUNCIL",
        Population: 10277,
        Key: "AMOLATARNAMASALE TOWN COUNCIL",
        Dist2: "Amolatar",
        "Sub Country": "Namasale T/C",
        id2_original: "Amolatar Namasale T/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.91733714183875, 1.262908235936188],
            [32.91292327328347, 1.269051717364162],
            [32.91000940260648, 1.274117022663057],
            [32.904976203155016, 1.286113853578931],
            [32.8947776306327, 1.299976658000318],
            [32.88934721323059, 1.306508126726519],
            [32.88378440391852, 1.311306673488794],
            [32.871599047245276, 1.323436368802738],
            [32.86471150496011, 1.332367093603301],
            [32.85459563583447, 1.352209412183656],
            [32.8512305728313, 1.36297003689236],
            [32.84233784081334, 1.387691480830718],
            [32.83540386640778, 1.414233029842676],
            [32.826367686913684, 1.4404997821617],
            [32.8202649218439, 1.475008011109088],
            [32.820144686834695, 1.474980857749987],
            [32.80762473556588, 1.472889889154548],
            [32.7848613615876, 1.467875621325578],
            [32.77637862785184, 1.466544838966828],
            [32.739882443122184, 1.456245140012194],
            [32.735438032745584, 1.455430369728775],
            [32.71836726924804, 1.454188820432029],
            [32.70925846455647, 1.453056757835935],
            [32.69637227194296, 1.450675641328191],
            [32.69696725580004, 1.383889454152132],
            [32.70897260356509, 1.377892682442919],
            [32.71684788482763, 1.374446657682557],
            [32.7270382925623, 1.372312713854489],
            [32.73839035670663, 1.369382695770131],
            [32.74327367764286, 1.367582831835849],
            [32.74595656451082, 1.366081281434755],
            [32.75034937206425, 1.361838598153178],
            [32.750450736164304, 1.362281922602719],
            [32.753321848830375, 1.357785749857573],
            [32.75598500510145, 1.351181546797632],
            [32.767665311854, 1.318675983113412],
            [32.77312827342222, 1.30482516497824],
            [32.77489069794109, 1.296709539184058],
            [32.77693506050848, 1.289635185289312],
            [32.7789978798617, 1.284903656838569],
            [32.785060693257535, 1.27441841553229],
            [32.788369185754036, 1.267515637769069],
            [32.78993275291336, 1.263308793485979],
            [32.79169483068251, 1.256613967089932],
            [32.79254199769099, 1.246345399061052],
            [32.792761869339934, 1.229255147109022],
            [32.79441803394047, 1.207324718896866],
            [32.796738317640624, 1.187348541079597],
            [32.8067673762722, 1.187819723892757],
            [32.820348465165296, 1.186870684237431],
            [32.82461413774984, 1.187042858816719],
            [32.82694308570092, 1.186373508693105],
            [32.83086453375005, 1.184030507609207],
            [32.83313285799587, 1.183523458481823],
            [32.83416455782834, 1.192484618996231],
            [32.834024315541114, 1.195585922426306],
            [32.83131583207743, 1.207568094811323],
            [32.831964628613264, 1.212672350503297],
            [32.84107308745345, 1.207850624955535],
            [32.84513491792698, 1.204514600048425],
            [32.85003716367129, 1.199580967966728],
            [32.85297846260885, 1.197372617855379],
            [32.85393552950917, 1.197729098379349],
            [32.854332475270304, 1.194788261775801],
            [32.86109119105885, 1.181764093884393],
            [32.865714831504334, 1.181680134537523],
            [32.86590572709546, 1.1782150298585],
            [32.86733153041948, 1.178667463164621],
            [32.8735458051621, 1.178179200943396],
            [32.88441829470886, 1.174687418451331],
            [32.88953958655035, 1.174560970321465],
            [32.89096538717941, 1.175103857221655],
            [32.8917018583887, 1.176035759262632],
            [32.894302301473175, 1.185707435658179],
            [32.89613163790427, 1.189534506371919],
            [32.89868572342849, 1.192701159487864],
            [32.93096003832517, 1.223924448159478],
            [32.933197172166025, 1.222305034390105],
            [32.93537575740993, 1.222588643420283],
            [32.93579262510909, 1.234211512580033],
            [32.935032027846255, 1.236593001756132],
            [32.927257349810695, 1.246629148325277],
            [32.924299499414005, 1.253093153448465],
            [32.92201774804964, 1.257090615256782],
            [32.91733714183875, 1.262908235936188],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1201,
        District: "KAYUNGA",
        County: "BBAALE",
        Subcounty: "GALIRAYA",
        Population: 24153,
        Key: "KAYUNGAGALIRAYA",
        Dist2: "Kayunga",
        "Sub Country": "Galiraaya",
        id2_original: "Kayunga Galiraaya",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.0027184648422, 0.877387990527745],
            [32.998290268158144, 0.875065654483236],
            [32.99765203311508, 0.87409006480017],
            [32.99587915669789, 0.873376218026135],
            [32.992286128225096, 0.87275754556256],
            [32.988297762873835, 0.86982359994044],
            [32.98692022692836, 0.871758146393272],
            [32.983587211322934, 0.874113824270851],
            [32.98188523982944, 0.875946021046439],
            [32.98117607650649, 0.878492066454576],
            [32.980597697109125, 0.878788101088649],
            [32.967173032754765, 0.866400473820436],
            [32.976602621342714, 0.858867670314236],
            [32.98527935255229, 0.859607902169256],
            [32.99008745575313, 0.85941995713386],
            [32.991441198021676, 0.857164448022179],
            [32.99260822006852, 0.852935363175845],
            [32.993728556670064, 0.85100878153109],
            [32.993355120718235, 0.846309794767496],
            [32.992748279997734, 0.843725351505213],
            [32.99181467439767, 0.842104199022174],
            [32.99130119558464, 0.839425776819992],
            [32.98901386568234, 0.836794338644585],
            [32.98765025721703, 0.834495133232033],
            [32.98730244391208, 0.829678948271538],
            [32.98521252957323, 0.826313332131675],
            [32.981666329377866, 0.82285723427622],
            [32.979592419424144, 0.822042963927797],
            [32.97617823025303, 0.819220175535571],
            [32.97241043184674, 0.817238784809505],
            [32.968128669537144, 0.813013646922482],
            [32.96445216691319, 0.810435124603985],
            [32.96054085365711, 0.809068940575072],
            [32.956968013023676, 0.805214739295913],
            [32.9541297795953, 0.804411193807068],
            [32.95271490158178, 0.803314750719781],
            [32.95140103732531, 0.801604789348451],
            [32.94407503363819, 0.797017696804105],
            [32.9433919825439, 0.796284852869791],
            [32.94223374602055, 0.792955418369849],
            [32.9403800975846, 0.789327410435603],
            [32.93720161286931, 0.786215080805487],
            [32.935310861317184, 0.784921282561663],
            [32.93244695493629, 0.781465155960232],
            [32.929427979574434, 0.780288952782857],
            [32.925517813466946, 0.779945086212183],
            [32.922263191141454, 0.779130766916938],
            [32.91878784376748, 0.77666077936577],
            [32.919781549354994, 0.775927965091807],
            [32.92113394954051, 0.773349501406024],
            [32.92376372351732, 0.770002037296489],
            [32.92679282738401, 0.769622103091256],
            [32.933928095380104, 0.771829770068078],
            [32.93543632811459, 0.77167598884956],
            [32.93945916900982, 0.768111399477146],
            [32.94147496784613, 0.764320594647116],
            [32.946594020187625, 0.7591093964358],
            [32.94285639349681, 0.753201438025924],
            [32.94116315183125, 0.747899676815679],
            [32.9406896444551, 0.746135440335803],
            [32.94077448224884, 0.744814530116837],
            [32.941494072317276, 0.742896504771829],
            [32.94267961223541, 0.740761349688891],
            [32.94593988316741, 0.737097219774473],
            [32.94712542398384, 0.734536838008391],
            [32.94860726421527, 0.732492157022932],
            [32.951994448232334, 0.7311712840679],
            [32.95411158691415, 0.72942517017523],
            [32.96046267417625, 0.728574781475616],
            [32.96190208877345, 0.727507207375394],
            [32.963405273874336, 0.724422078006009],
            [32.963574655712755, 0.721517883433228],
            [32.96255851649763, 0.720459335923357],
            [32.961076431026136, 0.719346500965885],
            [32.95476808650356, 0.716279394737058],
            [32.9543021546202, 0.714958478436061],
            [32.95726606774673, 0.713936158345872],
            [32.95883269456794, 0.714234735155842],
            [32.962918352854366, 0.713483840490923],
            [32.96435804143772, 0.712588165547891],
            [32.97070885740859, 0.706236977652088],
            [32.97379971685782, 0.703893735272341],
            [32.976297674744764, 0.702835209764185],
            [32.979452001067116, 0.700763383922098],
            [32.99050264360271, 0.698592058177064],
            [32.99143425134959, 0.697823036124382],
            [32.9949373899035, 0.69835683383336],
            [32.99683682996105, 0.700881044540513],
            [33.00102779415499, 0.703097643600844],
            [33.001623776938644, 0.708146060323853],
            [33.003231695720196, 0.714759665297955],
            [33.00508705275182, 0.718351457953091],
            [33.00787290182272, 0.722531326280006],
            [33.00832285447382, 0.731198677758355],
            [33.009005349510936, 0.733768121100911],
            [33.009621838137605, 0.734500954159974],
            [33.014654858824336, 0.737133716202292],
            [33.01928035339253, 0.738698888191589],
            [33.022298196877145, 0.738680779660527],
            [33.0241049658317, 0.738165072738443],
            [33.0269349257763, 0.740481170594464],
            [33.027573602790476, 0.74043593701101],
            [33.028608860849786, 0.741150666739045],
            [33.02935791835447, 0.74069829502235],
            [33.03050326315521, 0.741005896476898],
            [33.03145033719632, 0.741937765750157],
            [33.032551589089664, 0.742227272075636],
            [33.03283779054256, 0.743204385426073],
            [33.03424771973717, 0.743665782398166],
            [33.03462211419139, 0.744317192008541],
            [33.035657359674275, 0.744516222112683],
            [33.03607557484638, 0.745855231940432],
            [33.03719874832756, 0.746940898461786],
            [33.05028250472656, 0.746702285769487],
            [33.05057579298875, 0.74955703030059],
            [33.048970755104286, 0.757217142388918],
            [33.046611379417904, 0.760737997605013],
            [33.048459496028315, 0.764818328386815],
            [33.046707510831396, 0.767849202105918],
            [33.04242383331361, 0.770961529125527],
            [33.040958876917976, 0.772915770496385],
            [33.040646859680436, 0.77485190168971],
            [33.04102345860037, 0.776340369849506],
            [33.04403670810063, 0.779599031519952],
            [33.04433396332306, 0.780406929264347],
            [33.04263968500168, 0.783459015250603],
            [33.04100483562621, 0.784625999892138],
            [33.03871605494472, 0.787348945123817],
            [33.0381513011936, 0.789174207418784],
            [33.037252559209726, 0.802067743791938],
            [33.03636794682693, 0.804284954322768],
            [33.03511956705974, 0.811915137544979],
            [33.0315526624937, 0.823375383855724],
            [33.031344606385716, 0.825829009974301],
            [33.029917838271075, 0.830407123477214],
            [33.027747925362924, 0.833040296798173],
            [33.02373505397071, 0.836271924279707],
            [33.020911172027326, 0.837379063314664],
            [33.01704691791572, 0.840670528341163],
            [33.01410413226636, 0.842376108542713],
            [33.010774922822804, 0.846565232486374],
            [33.01015070239649, 0.850185825882502],
            [33.010566878392915, 0.858145139429609],
            [33.00726737803243, 0.862573638984657],
            [33.005364960958, 0.866164311270149],
            [33.00491431301089, 0.871930404455617],
            [33.004331488749514, 0.875151564725315],
            [33.0027184648422, 0.877387990527745],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1203,
        District: "KAYUNGA",
        County: "NTENJERU",
        Subcounty: "BUSAANA",
        Population: 56488,
        Key: "KAYUNGABUSAANA",
        Dist2: "Kayunga",
        "Sub Country": "BUSAANA",
        id2_original: "Kayunga BUSAANA",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.08472939244293, 0.54617086510616],
            [33.083538024255255, 0.546089458083449],
            [33.08267386291825, 0.546614209352879],
            [33.082349518998406, 0.549409842554633],
            [33.08078352998104, 0.551554080558879],
            [33.08078353626926, 0.551988351843102],
            [33.08151234754409, 0.552540235844342],
            [33.08152555816864, 0.553562579705016],
            [33.07955483948823, 0.554042117528196],
            [33.075262366565546, 0.55644876902852],
            [33.075019162973724, 0.557299214243622],
            [33.07661107557353, 0.561840962356186],
            [33.07310107209424, 0.566654189698707],
            [33.07312750771642, 0.569694094554432],
            [33.07239843054025, 0.570300277354604],
            [33.07183141662785, 0.572164037122418],
            [33.07176295242681, 0.577501967512823],
            [33.07249176909153, 0.578180507792766],
            [33.072599628011055, 0.579112382424393],
            [33.072167422476724, 0.580786144614603],
            [33.06857675747142, 0.582559467734666],
            [33.065768843082175, 0.585445600320403],
            [33.05688950314848, 0.591534560482525],
            [33.056763409327004, 0.592746904263743],
            [33.05549650809529, 0.594420673154002],
            [33.05168563097955, 0.594728327776087],
            [33.05067231696601, 0.59531640960404],
            [33.05024236171146, 0.598283943647933],
            [33.05085885033812, 0.600201973637466],
            [33.05072629942638, 0.601278608205975],
            [33.05173907894232, 0.604182792447485],
            [33.051463580017725, 0.606118928486052],
            [33.05322512059434, 0.609710704646957],
            [33.05377507280452, 0.613709625455567],
            [33.05258539434789, 0.615374345070979],
            [33.051395445498365, 0.618079510642581],
            [33.05183583468493, 0.619038525794382],
            [33.051713117630605, 0.620422770229167],
            [33.05335527659752, 0.621671289548748],
            [33.054489385270706, 0.623915013823862],
            [33.05435710834511, 0.624521189747268],
            [33.05283686513527, 0.625597839189011],
            [33.04981856350987, 0.629642026649699],
            [33.04947651559239, 0.632627655065772],
            [33.04866120913213, 0.634446178691189],
            [33.044144829328204, 0.638517521731162],
            [33.04400160553258, 0.640884979318506],
            [33.041742103641155, 0.632883402406979],
            [33.038056113909455, 0.627511423782336],
            [33.03343489262706, 0.624520844814674],
            [33.01902116877182, 0.623967104936623],
            [33.00303954428429, 0.618345896821111],
            [32.99819830582589, 0.613250795005989],
            [32.99412726312913, 0.610869375799729],
            [32.98194164594445, 0.611561618591268],
            [32.96781795665342, 0.61130607412264],
            [32.95863016579386, 0.607140516213297],
            [32.95525731529551, 0.604889430796361],
            [32.960931618110735, 0.597551199025232],
            [32.96366769781996, 0.59488225209354],
            [32.973265002769764, 0.589390570027453],
            [32.9751888437654, 0.58797014623099],
            [32.97664225950461, 0.586124494460983],
            [32.9780102984609, 0.583536959321858],
            [32.97978447024874, 0.57418201220909],
            [32.9786088567145, 0.566410338664587],
            [32.97865155992815, 0.562619501016707],
            [32.98078912899449, 0.558014410012991],
            [32.98366420143437, 0.554983558159819],
            [32.995168671953174, 0.550088965495028],
            [32.998777313145624, 0.547284290581283],
            [33.00494392777087, 0.540498779260032],
            [33.0069590214297, 0.538933586424535],
            [33.013561786091664, 0.536545075774798],
            [33.019921322009, 0.531433308001777],
            [33.0219793793929, 0.530257145774048],
            [33.02458031385586, 0.527895778590912],
            [33.02922495870928, 0.520395508369215],
            [33.03324079005036, 0.515898954106443],
            [33.03319780656234, 0.512949523924773],
            [33.03641348602196, 0.507692997107397],
            [33.04098651807926, 0.504698300608931],
            [33.042644356241155, 0.504155446365228],
            [33.0466601974637, 0.50371210359847],
            [33.053291296786384, 0.504598691189214],
            [33.058307545926745, 0.507086668845951],
            [33.061823237538455, 0.511121742704034],
            [33.06538186143422, 0.511194090137825],
            [33.06761122305123, 0.510705514086147],
            [33.06866889228022, 0.509583629242325],
            [33.06998353537602, 0.509809799013416],
            [33.07508547301474, 0.513881041271376],
            [33.07580025260485, 0.515898585812097],
            [33.07574297422568, 0.517445688625454],
            [33.07717220821576, 0.518024698356703],
            [33.07782970224022, 0.519200844918589],
            [33.07792972246058, 0.522439787180084],
            [33.077043660196935, 0.523706428115019],
            [33.078815878148994, 0.528682438472466],
            [33.07985904407775, 0.535486022773954],
            [33.08067380256572, 0.537033104558342],
            [33.080330904841986, 0.53847164102193],
            [33.08070247858619, 0.539132090944288],
            [33.08124535566524, 0.539104938770216],
            [33.08403227552795, 0.542913830585621],
            [33.084117959534694, 0.544614730143532],
            [33.08472939244293, 0.54617086510616],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1204,
        District: "KAYUNGA",
        County: "NTENJERU",
        Subcounty: "KANGULUMIRA",
        Population: 53754,
        Key: "KAYUNGAKANGULUMIRA",
        Dist2: "Kayunga",
        "Sub Country": "KANGULUMIRA",
        id2_original: "Kayunga KANGULUMIRA",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.87096536935565, 0.690465784623857],
            [32.90367354897499, 0.692966363911029],
            [32.90737004989379, 0.687659187123528],
            [32.912468817377864, 0.685300037371922],
            [32.91599835382474, 0.684305571877616],
            [32.92083140593596, 0.680062454929668],
            [32.92182452133034, 0.679682483536667],
            [32.92262611141455, 0.678026834904107],
            [32.925037027042045, 0.675204104705547],
            [32.92627062143798, 0.674617303891201],
            [32.9281348699943, 0.674994826145538],
            [32.9301919518078, 0.676903900722964],
            [32.93240971886944, 0.680811001504423],
            [32.93195244674543, 0.683279182322269],
            [32.934437368280996, 0.686744459839904],
            [32.935054412964796, 0.688558456240491],
            [32.930387964202794, 0.690249903691658],
            [32.92510785471063, 0.69298509061831],
            [32.92658638375192, 0.694473520477996],
            [32.92818687795766, 0.695279833890598],
            [32.92880418045796, 0.696684594738183],
            [32.928589892736845, 0.6969973730707],
            [32.92766847547857, 0.696975788151584],
            [32.92639031296644, 0.698544104281773],
            [32.926542738205534, 0.700524118468838],
            [32.92564340333358, 0.703074987998618],
            [32.922396982626594, 0.704638840492091],
            [32.921084757795555, 0.705730256706329],
            [32.922230447549346, 0.708462058103214],
            [32.922296117989866, 0.711511009706722],
            [32.923874738218444, 0.716677063988695],
            [32.924203557545034, 0.720648848392976],
            [32.9229537054391, 0.722367820744185],
            [32.918560962564364, 0.724214556809374],
            [32.91621454238101, 0.724548865970107],
            [32.91522684113284, 0.722100886006687],
            [32.9122958512615, 0.718235754155987],
            [32.911543205885536, 0.721323895947704],
            [32.911575226333845, 0.727633444630097],
            [32.91042879367328, 0.728097201099461],
            [32.90797523951083, 0.72795693869495],
            [32.90568238586784, 0.728377527383708],
            [32.90670469920391, 0.731577693705261],
            [32.90568517423849, 0.731803854881293],
            [32.90183320818165, 0.731394609514139],
            [32.90177810013225, 0.732403853558126],
            [32.8959534121519, 0.733001320909307],
            [32.89102873188167, 0.734481380580038],
            [32.88513333750535, 0.737180787620334],
            [32.88485672107653, 0.736878210661037],
            [32.8825097268697, 0.737089096083341],
            [32.876254746766605, 0.736313592505636],
            [32.859096762244846, 0.732861156566239],
            [32.86132608882757, 0.728084244845969],
            [32.863109616569076, 0.722126948554615],
            [32.86850050001386, 0.713029726998326],
            [32.869116679620056, 0.711145381344715],
            [32.87101358912348, 0.703973433178873],
            [32.871494928910586, 0.699559602869072],
            [32.87154071693891, 0.695206596044352],
            [32.87096536935565, 0.690465784623857],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1206,
        District: "KAYUNGA",
        County: "NTENJERU",
        Subcounty: "KAYUNGA TOWN COUNCIL",
        Population: 27061,
        Key: "KAYUNGAKAYUNGA TOWN COUNCIL",
        Dist2: "Kayunga",
        "Sub Country": "KAYUNGA TC",
        id2_original: "Kayunga KAYUNGA TC",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.05028250472656, 0.746702285769487],
            [33.03719874832756, 0.746940898461786],
            [33.03607557484638, 0.745855231940432],
            [33.035657359674275, 0.744516222112683],
            [33.03462211419139, 0.744317192008541],
            [33.03424771973717, 0.743665782398166],
            [33.03283779054256, 0.743204385426073],
            [33.032551589089664, 0.742227272075636],
            [33.03145033719632, 0.741937765750157],
            [33.03050326315521, 0.741005896476898],
            [33.02935791835447, 0.74069829502235],
            [33.028608860849786, 0.741150666739045],
            [33.027573602790476, 0.74043593701101],
            [33.0269349257763, 0.740481170594464],
            [33.0241049658317, 0.738165072738443],
            [33.022298196877145, 0.738680779660527],
            [33.01928035339253, 0.738698888191589],
            [33.014654858824336, 0.737133716202292],
            [33.009621838137605, 0.734500954159974],
            [33.009005349510936, 0.733768121100911],
            [33.00832285447382, 0.731198677758355],
            [33.00787290182272, 0.722531326280006],
            [33.00508705275182, 0.718351457953091],
            [33.003231695720196, 0.714759665297955],
            [33.001623776938644, 0.708146060323853],
            [33.00102779415499, 0.703097643600844],
            [32.99683682996105, 0.700881044540513],
            [32.9949373899035, 0.69835683383336],
            [32.99143425134959, 0.697823036124382],
            [32.98978281098913, 0.696122131918143],
            [32.98936433889885, 0.693344597033846],
            [32.98905662459154, 0.693167545764132],
            [32.98910969256698, 0.691297934182181],
            [32.98948252485092, 0.689689448594802],
            [32.99038796826681, 0.688295428749852],
            [32.99006840338425, 0.687062254659618],
            [32.991826030001185, 0.683041040598071],
            [32.99225212519496, 0.679234288964394],
            [32.991186903829366, 0.678430043316314],
            [32.99070755650555, 0.677357718571786],
            [32.98953581560849, 0.676231775089041],
            [32.986872764440314, 0.675481140266521],
            [32.98271840030602, 0.675910056884927],
            [32.98000208802463, 0.675641966150064],
            [32.979469485875825, 0.673443698457306],
            [32.979629277300255, 0.671513514462077],
            [32.97930971780758, 0.67001225851889],
            [32.97614940151892, 0.667494935554148],
            [32.975366544003336, 0.664854466856341],
            [32.9750278791412, 0.655264282374378],
            [32.969925878620444, 0.652432436218031],
            [32.9684016855183, 0.650984851666715],
            [32.964887669264606, 0.644841684210116],
            [32.96061136332208, 0.64637969996089],
            [32.95828279446002, 0.646678243224307],
            [32.9570973012543, 0.647184885001811],
            [32.9568009955511, 0.647700580269947],
            [32.95055589242455, 0.649211428250711],
            [32.94797318028716, 0.64631625329469],
            [32.94441674828067, 0.643330594196307],
            [32.93963241989216, 0.640860615837224],
            [32.9313891392819, 0.635088309844112],
            [32.934832481478914, 0.629415673844835],
            [32.945584237451506, 0.618631369276856],
            [32.95525731529551, 0.604889430796361],
            [32.95863016579386, 0.607140516213297],
            [32.96781795665342, 0.61130607412264],
            [32.98194164594445, 0.611561618591268],
            [32.99412726312913, 0.610869375799729],
            [32.99819830582589, 0.613250795005989],
            [33.00303954428429, 0.618345896821111],
            [33.01902116877182, 0.623967104936623],
            [33.03343489262706, 0.624520844814674],
            [33.038056113909455, 0.627511423782336],
            [33.041742103641155, 0.632883402406979],
            [33.04400160553258, 0.640884979318506],
            [33.044782705045165, 0.644344002327437],
            [33.04434177776772, 0.646271089773922],
            [33.04328661483839, 0.647754861095449],
            [33.04608061522215, 0.653762273259049],
            [33.046586755697625, 0.657734052487185],
            [33.04754476852396, 0.659443988663106],
            [33.049163894687, 0.658810659907184],
            [33.05122652898729, 0.665160626218238],
            [33.05224178785342, 0.665242847966093],
            [33.05596446927286, 0.671589376468272],
            [33.056594653614376, 0.673668670465523],
            [33.056764133369136, 0.678187780170846],
            [33.05797635864107, 0.683279176034503],
            [33.05848178944748, 0.69333304285037],
            [33.05842238565435, 0.696893790609024],
            [33.05791710217167, 0.699048198630036],
            [33.05381528049834, 0.709042276872831],
            [33.05259668706933, 0.717809508280186],
            [33.05039714412988, 0.7227766258919],
            [33.04965407748978, 0.72660668108203],
            [33.04727617854223, 0.7312745774215],
            [33.0522402059202, 0.736062079599266],
            [33.05319141221162, 0.738216470072877],
            [33.052953641630644, 0.740311029513293],
            [33.050724344692334, 0.743452891519479],
            [33.05028250472656, 0.746702285769487],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1207,
        District: "KAYUNGA",
        County: "NTENJERU",
        Subcounty: "NAZIGO",
        Population: 42728,
        Key: "KAYUNGANAZIGO",
        Dist2: "Kayunga",
        "Sub Country": "NAZIGO",
        id2_original: "Kayunga NAZIGO",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "H",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.06416952560907, 0.659988526561026],
              [32.05686657538706, 0.664464955711416],
              [32.04894667839761, 0.670325285608267],
              [32.04892462206245, 0.676883695429108],
              [32.049343918806166, 0.680342152631536],
              [32.04841437179455, 0.679548227186266],
              [32.04463904281122, 0.677957934454407],
              [32.04186926909234, 0.673091988289579],
              [32.038257448762096, 0.668568239767309],
              [32.03615454029267, 0.665057953902765],
              [32.034325019706934, 0.663646409210251],
              [32.02940811884707, 0.662731786097576],
              [32.02810179504913, 0.662586790640741],
              [32.02736566160639, 0.66318368299324],
              [32.025537338474955, 0.665716206630519],
              [32.022961299921796, 0.670582449378445],
              [32.01873398090832, 0.673042108283715],
              [32.01626457956594, 0.675411657712788],
              [32.01483934307885, 0.675908895444101],
              [32.01241652746878, 0.675646064877726],
              [32.00938706337765, 0.671683301454081],
              [32.00451655241739, 0.666508007260604],
              [32.00395803926254, 0.664988170285804],
              [32.00329092877298, 0.657470837395271],
              [32.00083166222361, 0.654204750051196],
              [32.002761124876294, 0.645608099770316],
              [32.00450405864843, 0.64313209340118],
              [32.00488024164838, 0.641274902794512],
              [32.005991076769156, 0.638953540467984],
              [32.0071202474032, 0.632151921897043],
              [32.00711924039175, 0.628587807622534],
              [32.00551420520228, 0.622666252504427],
              [32.005584635815474, 0.620312027022816],
              [32.00470523994956, 0.617442707699389],
              [32.005119855572325, 0.613679662071516],
              [32.006401519717414, 0.610396214198448],
              [32.0078974626005, 0.608514930424755],
              [32.01364420286531, 0.604164872053918],
              [32.01471328249503, 0.605531013999107],
              [32.01540283020544, 0.607756457283854],
              [32.01583159788718, 0.612541869874447],
              [32.015322768754054, 0.618629733540092],
              [32.01380317861943, 0.620782395045981],
              [32.013803539742206, 0.621858868294204],
              [32.01474239240181, 0.624337648784064],
              [32.01510011322604, 0.629005451466906],
              [32.01628792228858, 0.630633958258752],
              [32.01760718452158, 0.633583207458767],
              [32.01962661165334, 0.636007925097464],
              [32.02510581027033, 0.637646305155874],
              [32.02751342189423, 0.639582616656636],
              [32.027977070260135, 0.640930564170478],
              [32.03042447994607, 0.644766553877688],
              [32.03030642874131, 0.64681998205751],
              [32.032635100011305, 0.65041171137624],
              [32.03318183355785, 0.651949645489994],
              [32.03503459984818, 0.652212339882684],
              [32.0378843550684, 0.650512232666624],
              [32.039595202815214, 0.652837400119807],
              [32.039572045145505, 0.654990359035725],
              [32.03988090300818, 0.655207524238206],
              [32.045747652805055, 0.654014574726287],
              [32.04864506724435, 0.65277581651968],
              [32.05066355024673, 0.651419287504511],
              [32.0524448726242, 0.650867816823154],
              [32.05460687766291, 0.652378926147358],
              [32.05524854516869, 0.653862608543333],
              [32.059548370801984, 0.655609325155031],
              [32.06416952560907, 0.659988526561026],
            ],
          ],
          [
            [
              [32.19530922447016, 0.730184986245605],
              [32.17692208682322, 0.730127344238017],
              [32.17561535069855, 0.728761095862024],
              [32.1713628114835, 0.726824381058679],
              [32.16151642616329, 0.724958993135475],
              [32.15828601882456, 0.725121222174071],
              [32.15617175205671, 0.724614228451313],
              [32.15068440212682, 0.724396080144782],
              [32.14632539548258, 0.72284832999984],
              [32.143854228052334, 0.72073101977429],
              [32.13904368502718, 0.719065581282061],
              [32.135219414928855, 0.718892971014864],
              [32.13080082482846, 0.717743244761704],
              [32.120290677938065, 0.720400816207246],
              [32.11329544831163, 0.721141238905365],
              [32.10223931257808, 0.724278087776899],
              [32.093248971417985, 0.725832225739201],
              [32.08370072885572, 0.728381302697755],
              [32.08241855626417, 0.729430395251787],
              [32.0808270173635, 0.729981883768163],
              [32.07738318378804, 0.730460617287422],
              [32.069116659269774, 0.728821543098749],
              [32.064270224057466, 0.726133828849484],
              [32.05476648942429, 0.716126842178216],
              [32.05230711597541, 0.710409196755002],
              [32.05181928226708, 0.70927833425033],
              [32.049158077136795, 0.705921683946988],
              [32.04884889318567, 0.704555660990134],
              [32.04899133904028, 0.700987173447457],
              [32.05675022020159, 0.701151566312051],
              [32.058627267055726, 0.70067481306599],
              [32.0591676782593, 0.700293212999242],
              [32.059632577080066, 0.6982893358433],
              [32.060628249978045, 0.696686358898957],
              [32.06618385839482, 0.693719681762171],
              [32.065767144307564, 0.691753793289321],
              [32.06655430744833, 0.689916971772756],
              [32.0657186568418, 0.687296583109884],
              [32.059730761143996, 0.684936504387804],
              [32.058978760758414, 0.684120938133315],
              [32.058458586801585, 0.681295992814472],
              [32.058981202379364, 0.674179662426426],
              [32.05960838185621, 0.673592373737098],
              [32.0613945353733, 0.669638653164723],
              [32.06327614207585, 0.66749101826705],
              [32.066394115375296, 0.667167226316387],
              [32.071617957093004, 0.667443963213991],
              [32.0767012097738, 0.668168622658109],
              [32.08272343548845, 0.670919800243279],
              [32.086191658323905, 0.671924583132524],
              [32.088519852588476, 0.673915181675588],
              [32.09229800587505, 0.678466135992277],
              [32.099495967294835, 0.681778411482858],
              [32.101681548618174, 0.682086395927327],
              [32.10775008697731, 0.680748693364967],
              [32.11117045026938, 0.681056904234711],
              [32.116895373150875, 0.682243028552743],
              [32.12149144070702, 0.681637778501866],
              [32.1270510062026, 0.685754860470951],
              [32.132455314070974, 0.688189307642155],
              [32.136162389059, 0.693364475295518],
              [32.13763543029223, 0.694296515959482],
              [32.1407470516043, 0.693899051392975],
              [32.143502118105374, 0.692985877484943],
              [32.14990200904021, 0.687459728780329],
              [32.15677866374411, 0.68711719975621],
              [32.16003284050524, 0.687362031448585],
              [32.16290621782417, 0.684395331425936],
              [32.17169171704834, 0.682180508444422],
              [32.17372525940816, 0.681764727516622],
              [32.175626067599886, 0.684062842835152],
              [32.178547832671605, 0.683873374693052],
              [32.1793318184712, 0.684380108762865],
              [32.185307454860286, 0.689971827011485],
              [32.189275649440184, 0.69443240221798],
              [32.18957378141835, 0.698340511758807],
              [32.19050076463811, 0.700186145407208],
              [32.19111935352592, 0.703895291935265],
              [32.19044320957788, 0.706581963787917],
              [32.190396401961685, 0.709286837949525],
              [32.190752905568715, 0.710155358650048],
              [32.18956581515839, 0.711873970249266],
              [32.189376567975806, 0.714886397839411],
              [32.1905651325215, 0.717573400140376],
              [32.19213292984752, 0.71802600233558],
              [32.19372530957128, 0.720830682663346],
              [32.19374947964232, 0.722314302474694],
              [32.19306136025323, 0.724367720801307],
              [32.194154723141736, 0.727045664116032],
              [32.19481991033825, 0.727624755927068],
              [32.194915612357065, 0.729542618971941],
              [32.19530922447016, 0.730184986245605],
            ],
          ],
          [
            [
              [32.040721698266324, 0.713851169046207],
              [32.04169023665284, 0.715518012495099],
              [32.03873415503897, 0.720384167249547],
              [32.03695407143827, 0.725549084202564],
              [32.03526811960122, 0.727774050173411],
              [32.0331190952184, 0.729989865549908],
              [32.030292901909746, 0.73141852431159],
              [32.02566178927777, 0.734574573132112],
              [32.02164798992586, 0.736102462725022],
              [32.02106665507121, 0.738843275878506],
              [32.01952369077292, 0.74204521860338],
              [32.01809965982494, 0.747092568800552],
              [32.016230498382356, 0.747218790229838],
              [32.01411586330522, 0.748774221740373],
              [32.0120017393695, 0.749298408590503],
              [32.009578206005514, 0.750835671598129],
              [32.00412504236207, 0.756759526626824],
              [32.000822357473915, 0.759101661721759],
              [31.999923919120594, 0.761959973097505],
              [31.99901191890142, 0.767577293903545],
              [31.995477843267444, 0.772226069894276],
              [31.991576161747833, 0.774531848635101],
              [31.988179376537055, 0.779243954056779],
              [31.987635068441772, 0.793518280220946],
              [31.99228380871459, 0.807088320933941],
              [31.992277829528078, 0.809693547832329],
              [31.989648573879162, 0.816151675048198],
              [31.9869687547579, 0.811429026179872],
              [31.978538236496316, 0.803593143591541],
              [31.97721993546068, 0.803004827364662],
              [31.965308663763764, 0.800812934479688],
              [31.964968638852323, 0.796520753724016],
              [31.965345767778278, 0.788829417299545],
              [31.96463107352813, 0.782270918249542],
              [31.96357387681297, 0.778636714909868],
              [31.95844543348349, 0.774080507084221],
              [31.950733697704916, 0.764833766356058],
              [31.949252756687084, 0.764525843217596],
              [31.949520236351166, 0.760473386223098],
              [31.951253079347705, 0.756077546471946],
              [31.95392564996296, 0.751130132917326],
              [31.956588916726815, 0.747476261418585],
              [31.959493224837598, 0.740963953152513],
              [31.96449198467774, 0.733746546235418],
              [31.965701448528506, 0.732534684284293],
              [31.96976219563379, 0.730545538010125],
              [31.97367537648734, 0.727923137818987],
              [31.975772866318938, 0.725056074380332],
              [31.98726105307662, 0.721033251994549],
              [31.98840607178888, 0.71915195737456],
              [31.988192048172447, 0.715524495130985],
              [31.9976241223988, 0.717860442352361],
              [31.99864441901702, 0.718720033780057],
              [32.000669555840695, 0.716639911676668],
              [32.00329287272726, 0.71175566945978],
              [32.008849629190955, 0.705325188547703],
              [32.012316573723744, 0.702720688570715],
              [32.01639175495902, 0.708167249962834],
              [32.01708050137218, 0.708628743029231],
              [32.02093189250725, 0.709275084394693],
              [32.025850438182395, 0.714374558741159],
              [32.03763120443145, 0.714593816859959],
              [32.040721698266324, 0.713851169046207],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1208,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "BUKOMERO",
        Population: 15081,
        Key: "KIBOGABUKOMERO",
        Dist2: "Kiboga",
        "Sub Country": "Bukomero",
        id2_original: "KibogaBukomero",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.040721698266324, 0.713851169046207],
            [32.03763120443145, 0.714593816859959],
            [32.025850438182395, 0.714374558741159],
            [32.02093189250725, 0.709275084394693],
            [32.01708050137218, 0.708628743029231],
            [32.01639175495902, 0.708167249962834],
            [32.012316573723744, 0.702720688570715],
            [32.008849629190955, 0.705325188547703],
            [32.00329287272726, 0.71175566945978],
            [32.000669555840695, 0.716639911676668],
            [31.99864441901702, 0.718720033780057],
            [31.9976241223988, 0.717860442352361],
            [31.988192048172447, 0.715524495130985],
            [31.985566137849663, 0.715035814665042],
            [31.988196264864385, 0.710046560364194],
            [31.994880230939856, 0.701543232075329],
            [31.99619545704229, 0.698221542328504],
            [31.99616831714092, 0.697063670120626],
            [31.99417095981908, 0.69000087103172],
            [31.989387215335473, 0.686740627902189],
            [31.988061711607877, 0.684388405010945],
            [31.987171986912834, 0.680896489930426],
            [31.987136021962105, 0.678309349643093],
            [31.987815100706204, 0.676608859768885],
            [31.987831353026323, 0.67407600581443],
            [31.99155501720269, 0.669544774848875],
            [31.99226084148773, 0.667473402601445],
            [31.99449045822628, 0.666261707665889],
            [31.997539554997946, 0.663322402324299],
            [31.997734010612536, 0.657597735835258],
            [31.997918518283708, 0.657008407028023],
            [31.999329506592034, 0.656067913809101],
            [32.00083166222361, 0.654204750051196],
            [32.00329092877298, 0.657470837395271],
            [32.00395803926254, 0.664988170285804],
            [32.00451655241739, 0.666508007260604],
            [32.00938706337765, 0.671683301454081],
            [32.01241652746878, 0.675646064877726],
            [32.01483934307885, 0.675908895444101],
            [32.01626457956594, 0.675411657712788],
            [32.01873398090832, 0.673042108283715],
            [32.022961299921796, 0.670582449378445],
            [32.025537338474955, 0.665716206630519],
            [32.02736566160639, 0.66318368299324],
            [32.02810179504913, 0.662586790640741],
            [32.02940811884707, 0.662731786097576],
            [32.034325019706934, 0.663646409210251],
            [32.03615454029267, 0.665057953902765],
            [32.038257448762096, 0.668568239767309],
            [32.04186926909234, 0.673091988289579],
            [32.04463904281122, 0.677957934454407],
            [32.04841437179455, 0.679548227186266],
            [32.049343918806166, 0.680342152631536],
            [32.04892462206245, 0.676883695429108],
            [32.04894667839761, 0.670325285608267],
            [32.05686657538706, 0.664464955711416],
            [32.06416952560907, 0.659988526561026],
            [32.0663316043096, 0.662666592531875],
            [32.07002567887884, 0.664648400911856],
            [32.071617957093004, 0.667443963213991],
            [32.066394115375296, 0.667167226316387],
            [32.06327614207585, 0.66749101826705],
            [32.0613945353733, 0.669638653164723],
            [32.05960838185621, 0.673592373737098],
            [32.058981202379364, 0.674179662426426],
            [32.058458586801585, 0.681295992814472],
            [32.058978760758414, 0.684120938133315],
            [32.059730761143996, 0.684936504387804],
            [32.0657186568418, 0.687296583109884],
            [32.06655430744833, 0.689916971772756],
            [32.065767144307564, 0.691753793289321],
            [32.06618385839482, 0.693719681762171],
            [32.060628249978045, 0.696686358898957],
            [32.059632577080066, 0.6982893358433],
            [32.0591676782593, 0.700293212999242],
            [32.058627267055726, 0.70067481306599],
            [32.05675022020159, 0.701151566312051],
            [32.04899133904028, 0.700987173447457],
            [32.04884889318567, 0.704555660990134],
            [32.049158077136795, 0.705921683946988],
            [32.05181928226708, 0.70927833425033],
            [32.05230711597541, 0.710409196755002],
            [32.05036420284799, 0.711510201285306],
            [32.04490653145844, 0.711247880204974],
            [32.04358909370378, 0.712359717380186],
            [32.040721698266324, 0.713851169046207],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1209,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "BUKOMERO TOWN COUNCIL",
        Population: 14182,
        Key: "KIBOGABUKOMERO TOWN COUNCIL",
        Dist2: "Kiboga",
        "Sub Country": "Bukomero T/C",
        id2_original: "KibogaBukomero T/C",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.10596395681642, 0.902082467445706],
            [32.09643139344915, 0.903672221618676],
            [32.0884850177184, 0.904104434449009],
            [32.07025225555305, 0.903330844072085],
            [32.0642301538059, 0.903998696141157],
            [32.035173475797855, 0.913516501229403],
            [32.0280220066856, 0.91691586027339],
            [32.02088189497346, 0.92190729034117],
            [32.01534459781546, 0.928491228421088],
            [32.012836974954375, 0.932787363832866],
            [32.00840279189726, 0.944165934246144],
            [32.00627409998258, 0.95097693107916],
            [32.00529817385116, 0.956937934930283],
            [32.00534442900344, 0.961099089469455],
            [32.00581853465759, 0.963803970808104],
            [32.00204267117669, 0.960121153825742],
            [31.99568396620097, 0.956546130958938],
            [31.99414321085994, 0.954989775546027],
            [31.991208523522875, 0.950140293391313],
            [31.98709801424245, 0.945245241791366],
            [31.982141363829587, 0.941344998008424],
            [31.98015093431519, 0.939091983505216],
            [31.976895895171385, 0.934061513350782],
            [31.97393285880059, 0.931193099278003],
            [31.96981695693348, 0.928568587462002],
            [31.96936729892984, 0.927781465631238],
            [31.969526271090714, 0.920897612126838],
            [31.971337760692084, 0.913507667421498],
            [31.971129162899945, 0.911336599714201],
            [31.968983021210846, 0.904642043304604],
            [31.969062981152586, 0.895939949067309],
            [31.967608747946493, 0.887318833621747],
            [31.972444197661204, 0.878419056377063],
            [31.973803722385238, 0.86164838107585],
            [31.980939694660535, 0.840464826398074],
            [31.983124885216693, 0.831338086254268],
            [31.984871276604363, 0.829303210689628],
            [31.9868053628858, 0.825739620718835],
            [31.9895360329404, 0.819236305832472],
            [31.989648573879162, 0.816151675048198],
            [31.992277829528078, 0.809693547832329],
            [31.99228380871459, 0.807088320933941],
            [31.987635068441772, 0.793518280220946],
            [31.988179376537055, 0.779243954056779],
            [31.991576161747833, 0.774531848635101],
            [31.995477843267444, 0.772226069894276],
            [31.99901191890142, 0.767577293903545],
            [31.999923919120594, 0.761959973097505],
            [32.000822357473915, 0.759101661721759],
            [32.00412504236207, 0.756759526626824],
            [32.009578206005514, 0.750835671598129],
            [32.0120017393695, 0.749298408590503],
            [32.01411586330522, 0.748774221740373],
            [32.016230498382356, 0.747218790229838],
            [32.01809965982494, 0.747092568800552],
            [32.01952369077292, 0.74204521860338],
            [32.02106665507121, 0.738843275878506],
            [32.02164798992586, 0.736102462725022],
            [32.02566178927777, 0.734574573132112],
            [32.030292901909746, 0.73141852431159],
            [32.0331190952184, 0.729989865549908],
            [32.03526811960122, 0.727774050173411],
            [32.03695407143827, 0.725549084202564],
            [32.03873415503897, 0.720384167249547],
            [32.04169023665284, 0.715518012495099],
            [32.040721698266324, 0.713851169046207],
            [32.04358909370378, 0.712359717380186],
            [32.04490653145844, 0.711247880204974],
            [32.05036420284799, 0.711510201285306],
            [32.05230711597541, 0.710409196755002],
            [32.05476648942429, 0.716126842178216],
            [32.064270224057466, 0.726133828849484],
            [32.069116659269774, 0.728821543098749],
            [32.07738318378804, 0.730460617287422],
            [32.0808270173635, 0.729981883768163],
            [32.08241855626417, 0.729430395251787],
            [32.08370072885572, 0.728381302697755],
            [32.093248971417985, 0.725832225739201],
            [32.10223931257808, 0.724278087776899],
            [32.11329544831163, 0.721141238905365],
            [32.120290677938065, 0.720400816207246],
            [32.13080082482846, 0.717743244761704],
            [32.135219414928855, 0.718892971014864],
            [32.13904368502718, 0.719065581282061],
            [32.143854228052334, 0.72073101977429],
            [32.14632539548258, 0.72284832999984],
            [32.15068440212682, 0.724396080144782],
            [32.15617175205671, 0.724614228451313],
            [32.15828601882456, 0.725121222174071],
            [32.16151642616329, 0.724958993135475],
            [32.1713628114835, 0.726824381058679],
            [32.17561535069855, 0.728761095862024],
            [32.17692208682322, 0.730127344238017],
            [32.19530922447016, 0.730184986245605],
            [32.19583483592939, 0.735486297997985],
            [32.19728426225045, 0.736762111214739],
            [32.19840079718168, 0.737069893488263],
            [32.200195244843805, 0.74060738233224],
            [32.20149866349013, 0.741765566857055],
            [32.199581364026415, 0.742054703118972],
            [32.19907714774225, 0.742724048121256],
            [32.200808289329665, 0.745707400633347],
            [32.20219587113494, 0.760826578953969],
            [32.20478383392518, 0.766517286135593],
            [32.20484232502995, 0.770642484494632],
            [32.20604020241019, 0.777545163075143],
            [32.20710902242682, 0.779264194821245],
            [32.211740403655064, 0.78316410434577],
            [32.21202942491964, 0.787214899494296],
            [32.21153617526848, 0.792409564415449],
            [32.20924269190649, 0.797710354775848],
            [32.20874323310009, 0.799845225330342],
            [32.20867173618664, 0.800704625303028],
            [32.209929674926784, 0.804721504191178],
            [32.20920451260862, 0.80782430223363],
            [32.20566419727666, 0.809641943873886],
            [32.203882092466564, 0.812038902182087],
            [32.20240884372251, 0.813332251754618],
            [32.198488659603015, 0.814597969730887],
            [32.195958204262304, 0.8165514916631],
            [32.19370044061097, 0.819907263429882],
            [32.18993471371971, 0.832227728871568],
            [32.18459568732134, 0.844457371169152],
            [32.17589588108706, 0.86281969827382],
            [32.17468398370019, 0.864465876123016],
            [32.16823228782123, 0.870751686117798],
            [32.155412428604926, 0.88250001158889],
            [32.13799593319891, 0.893324403479378],
            [32.131818492077876, 0.896172516010143],
            [32.12622347995949, 0.897962335344861],
            [32.10596395681642, 0.902082467445706],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1210,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "DDWANIRO",
        Population: 12110,
        Key: "KIBOGADDWANIRO",
        Dist2: "Kiboga",
        "Sub Country": "Dwaniro",
        id2_original: "KibogaDwaniro",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.00581853465759, 0.963803970808104],
            [32.00600038511212, 0.967141984986656],
            [32.00497609458414, 0.975102125627914],
            [32.00284702986859, 0.98287196197011],
            [32.001539495141635, 0.985576306696203],
            [32.00073162493528, 0.986200231725787],
            [31.999507255339005, 0.991573150704671],
            [31.999696535759252, 0.993445718744612],
            [32.00213770754385, 1.000411844742784],
            [32.00243727952144, 1.002528688766866],
            [32.002279439237796, 1.016341804634886],
            [32.001631338896274, 1.020656518968614],
            [31.997914575577916, 1.023839522181276],
            [31.98111283145681, 1.045101061815403],
            [31.958479237985927, 1.066206520825123],
            [31.94987631325841, 1.071151622766064],
            [31.93373597083325, 1.079323356083487],
            [31.928612407152364, 1.083211204634269],
            [31.925032624338435, 1.087823244622948],
            [31.917773528970304, 1.101904782756564],
            [31.91646962792864, 1.103369707688241],
            [31.91143171861013, 1.106316743241529],
            [31.911411911656433, 1.104417142012942],
            [31.9104408085798, 1.099694938915918],
            [31.909217533131525, 1.097234064856994],
            [31.907940957044204, 1.092285612202911],
            [31.907287282656355, 1.086532325798964],
            [31.90654669177318, 1.083483665254411],
            [31.903340014331047, 1.082975939275415],
            [31.902170110488754, 1.08359966192777],
            [31.900566868336558, 1.08347243562658],
            [31.898072343810618, 1.082331769995976],
            [31.896341912790618, 1.082132131686233],
            [31.894941676417886, 1.081344647181903],
            [31.893985867158968, 1.079381394019093],
            [31.892687125142004, 1.078286396299011],
            [31.891384705422254, 1.072614312734967],
            [31.889740546805527, 1.069167330861233],
            [31.888212254690757, 1.067610927100706],
            [31.88742188007284, 1.065584422087013],
            [31.88668347389247, 1.065077598479053],
            [31.88568831752576, 1.061639905923027],
            [31.883638539015532, 1.060047134496444],
            [31.880862466309832, 1.057079169036205],
            [31.879080371381228, 1.056137779731285],
            [31.87633404279293, 1.040259481617954],
            [31.873938933921163, 1.040377835805954],
            [31.86939910180012, 1.039647658126144],
            [31.86613695159252, 1.035593158117288],
            [31.86170316379417, 1.032770129567215],
            [31.857715651842426, 1.03319256193804],
            [31.853253588672164, 1.03586664773561],
            [31.850437635259457, 1.035322529142466],
            [31.846924013366195, 1.035374225932086],
            [31.845930418271468, 1.034841518488636],
            [31.844246868529485, 1.03019152472833],
            [31.84101497807225, 1.025975152317017],
            [31.835154438328942, 1.021396007865899],
            [31.82672029716183, 1.008720276771643],
            [31.822418591354648, 0.998008947314162],
            [31.818182877584828, 0.992815357818694],
            [31.813555551351755, 0.98570401655247],
            [31.799846411208165, 0.971316977085767],
            [31.790303916965424, 0.962973773565276],
            [31.78193531957637, 0.953699358477798],
            [31.77763486871563, 0.950803336695396],
            [31.76698807998571, 0.947217604881113],
            [31.766087234147435, 0.946448437624444],
            [31.76400646106492, 0.942413524510604],
            [31.76160612579485, 0.940716759719601],
            [31.770582563729274, 0.94156696869579],
            [31.773146154327556, 0.941170899255898],
            [31.77747174004995, 0.939518342096606],
            [31.77801087923907, 0.939068620564733],
            [31.777893323006037, 0.936891795798472],
            [31.77982836060337, 0.929409365616318],
            [31.779532986453088, 0.927755494250029],
            [31.78072338625692, 0.926194123024306],
            [31.781332890482247, 0.924627927785769],
            [31.78097204711407, 0.924415931420769],
            [31.78450390301099, 0.92305927079181],
            [31.786590030950897, 0.920529223767143],
            [31.786711021443267, 0.918547601444546],
            [31.801022343644313, 0.914955409235172],
            [31.798967557026366, 0.912142097883375],
            [31.797524846510374, 0.909328513973443],
            [31.793124467057414, 0.905374228932433],
            [31.791209600231504, 0.904613778642574],
            [31.787003172438265, 0.898425380632401],
            [31.786143590712562, 0.895114515223624],
            [31.784990979439492, 0.89341227048996],
            [31.78354906213594, 0.88616786308694],
            [31.782618933016018, 0.883888143518906],
            [31.78287106496345, 0.883128423512435],
            [31.7874925000449, 0.883383217432588],
            [31.79615911083447, 0.880618192867495],
            [31.79944962355053, 0.88060117449805],
            [31.80660583576749, 0.878559243557053],
            [31.812135119953144, 0.876290632887566],
            [31.816870568312137, 0.873099121743257],
            [31.825719239762055, 0.863785137465515],
            [31.83361023974544, 0.857464822702676],
            [31.837577896234436, 0.852509128341957],
            [31.840523850241798, 0.85259143455389],
            [31.842066429162873, 0.853234132177644],
            [31.84524929945336, 0.853624054769821],
            [31.848530928729556, 0.857134700945674],
            [31.849413525292864, 0.858989296620476],
            [31.851808900964265, 0.86162226730873],
            [31.851720204008053, 0.862427290363858],
            [31.850550752916664, 0.862924436245631],
            [31.850483330761342, 0.863946558050944],
            [31.85296615742565, 0.866190602852154],
            [31.855435469834852, 0.869492970868747],
            [31.853633231982595, 0.872206072668764],
            [31.851204964497075, 0.874312927946647],
            [31.853326062054364, 0.87852879065599],
            [31.856367512366297, 0.88233789658648],
            [31.865890123298552, 0.899102247084884],
            [31.8726984674133, 0.906539835933685],
            [31.87935908537621, 0.912303966355999],
            [31.887226912418534, 0.915535716930802],
            [31.893626173634374, 0.922104848307637],
            [31.897028140327713, 0.924493965097632],
            [31.908439056699592, 0.929952071531927],
            [31.914677980315304, 0.93125659459476],
            [31.920234670303643, 0.932986049326432],
            [31.922073819930933, 0.932878069975333],
            [31.9327307973528, 0.918959934431449],
            [31.938432342477363, 0.914312124089517],
            [31.943774048550242, 0.910939635879528],
            [31.954710790995993, 0.902096045594764],
            [31.966305078670185, 0.889625158663145],
            [31.967608747946493, 0.887318833621747],
            [31.969062981152586, 0.895939949067309],
            [31.968983021210846, 0.904642043304604],
            [31.971129162899945, 0.911336599714201],
            [31.971337760692084, 0.913507667421498],
            [31.969526271090714, 0.920897612126838],
            [31.96936729892984, 0.927781465631238],
            [31.96981695693348, 0.928568587462002],
            [31.97393285880059, 0.931193099278003],
            [31.976895895171385, 0.934061513350782],
            [31.98015093431519, 0.939091983505216],
            [31.982141363829587, 0.941344998008424],
            [31.98709801424245, 0.945245241791366],
            [31.991208523522875, 0.950140293391313],
            [31.99414321085994, 0.954989775546027],
            [31.99568396620097, 0.956546130958938],
            [32.00204267117669, 0.960121153825742],
            [32.00581853465759, 0.963803970808104],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1211,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "KAPEKE",
        Population: 15572,
        Key: "KIBOGAKAPEKE",
        Dist2: "Kiboga",
        "Sub Country": "Kapeke",
        id2_original: "KibogaKapeke",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.784990979439492, 0.89341227048996],
            [31.781884789341643, 0.893084544718443],
            [31.779482147197925, 0.893846276455386],
            [31.776842525888966, 0.895681429359466],
            [31.772754381065806, 0.895130892207408],
            [31.76828753257005, 0.896368817897224],
            [31.768220040346126, 0.89723996920197],
            [31.76665516973131, 0.898814124568402],
            [31.76463088091722, 0.898363522162154],
            [31.763447576007536, 0.898932122623107],
            [31.762408662703372, 0.90012270626369],
            [31.76121590841521, 0.897773525471257],
            [31.760587827928106, 0.897691548095587],
            [31.759425456459475, 0.896710945198658],
            [31.758539234295714, 0.894925260591322],
            [31.758322857991548, 0.893501294387849],
            [31.75378842384706, 0.899713875020954],
            [31.751472102615594, 0.900193339263052],
            [31.748229273373138, 0.891564986173076],
            [31.746680563450273, 0.889312210755658],
            [31.745141496043654, 0.885946885987217],
            [31.74531182111312, 0.885476596878443],
            [31.746385809137553, 0.88488902867358],
            [31.74898854741758, 0.885120022653073],
            [31.74679642546068, 0.881298241349166],
            [31.746514245765294, 0.879543384825791],
            [31.746067375233977, 0.87904574981563],
            [31.74025586823381, 0.880798530811838],
            [31.738037749032575, 0.88182891667292],
            [31.73518928469142, 0.884351528301981],
            [31.73491703227826, 0.885635841071145],
            [31.723452595180078, 0.884510282121282],
            [31.717274740834014, 0.886063880258317],
            [31.712531812203665, 0.885094399470659],
            [31.709091271851996, 0.883220871629096],
            [31.699938506305365, 0.881236796666101],
            [31.69901157159462, 0.881299785370473],
            [31.698055211668414, 0.882004956629296],
            [31.695398838576054, 0.882899469240851],
            [31.69359447890309, 0.882781245222343],
            [31.69221221692092, 0.883296317554095],
            [31.6911228623152, 0.882906997127404],
            [31.68898253991253, 0.883168538405482],
            [31.685382765990234, 0.884668714375265],
            [31.684951010511877, 0.885156986610635],
            [31.684071541882396, 0.88520189611646],
            [31.683398427951797, 0.88612423803004],
            [31.682612681454252, 0.886350078914428],
            [31.681221200062303, 0.885155649178807],
            [31.680554230608244, 0.885381532337977],
            [31.678676945700545, 0.888220959953453],
            [31.675793664455615, 0.88369746644696],
            [31.675377139912886, 0.882412940131889],
            [31.675436184379873, 0.880613026368281],
            [31.679369509055373, 0.87677034627818],
            [31.680842414642964, 0.873975990236725],
            [31.681292895503447, 0.871316942278737],
            [31.678702458752944, 0.851317718488862],
            [31.677848435802208, 0.848414006521235],
            [31.676366352127342, 0.845293001884489],
            [31.673909393349955, 0.843727387765165],
            [31.671725281670405, 0.840759910970302],
            [31.667805530538878, 0.838008919819794],
            [31.666749427073423, 0.83649806363253],
            [31.66364699283177, 0.833964436073692],
            [31.663206284743275, 0.832743229272884],
            [31.66247415329513, 0.832245511841415],
            [31.661919952053648, 0.830354946720865],
            [31.660605357466864, 0.82850934835273],
            [31.659536973133157, 0.824285040652836],
            [31.65946282349464, 0.82183386213905],
            [31.654620397463443, 0.815817407205005],
            [31.656509674880194, 0.816243151990893],
            [31.66002318358573, 0.817908588523608],
            [31.662765105937567, 0.81952854102755],
            [31.664082923679565, 0.820985208501383],
            [31.664960338760284, 0.821139267227542],
            [31.666517831511698, 0.819584074586642],
            [31.669255476086125, 0.818888538844562],
            [31.670798446672666, 0.816238903390755],
            [31.672648063469605, 0.815217447272658],
            [31.67555133941616, 0.814630494439754],
            [31.678639179627705, 0.814658652879128],
            [31.68120716478432, 0.81158422871278],
            [31.68306717778406, 0.807939732356884],
            [31.683802231451796, 0.808111827060337],
            [31.684762003179443, 0.809758319776954],
            [31.686374356943563, 0.808718679235538],
            [31.689317220746343, 0.809045258853796],
            [31.694334350235728, 0.80569120804573],
            [31.694769286648505, 0.804841121036824],
            [31.69746416422892, 0.803575693736916],
            [31.69858338332624, 0.801857505610704],
            [31.69847109661068, 0.795535022402417],
            [31.698952907115007, 0.794730171687969],
            [31.70090629459861, 0.794079553028343],
            [31.705944622532066, 0.79380979867938],
            [31.711619750000725, 0.795493966165049],
            [31.716651103414318, 0.79605634352511],
            [31.719552802817535, 0.797025076648411],
            [31.722056967164797, 0.79869015547542],
            [31.723514017487652, 0.797749925321686],
            [31.72750699838283, 0.797470776643234],
            [31.73154246599769, 0.797842883856481],
            [31.7346834882707, 0.79859460647013],
            [31.73687734487443, 0.80042240309042],
            [31.73879407211129, 0.801291331338806],
            [31.742732332130974, 0.801898579749053],
            [31.744494326356794, 0.802830776106905],
            [31.747552834777675, 0.803528201783865],
            [31.751473601903818, 0.803538459535582],
            [31.756246923235167, 0.801559032747808],
            [31.759334792192817, 0.801777063964675],
            [31.762159623655474, 0.802709584610207],
            [31.765081901665198, 0.802692387153623],
            [31.76883916013825, 0.801201067564433],
            [31.772265602329835, 0.79888652248459],
            [31.77420232965821, 0.798706201420509],
            [31.774845270076735, 0.798064182126545],
            [31.776324456684836, 0.795441500626122],
            [31.780919532500885, 0.791390590432971],
            [31.783959055028248, 0.787040708345215],
            [31.78673017622004, 0.78056509084251],
            [31.786939710955014, 0.777426433794601],
            [31.787320260665584, 0.777191366318783],
            [31.789211476646713, 0.777556986510407],
            [31.797456420038564, 0.78072197423076],
            [31.803621100591002, 0.780814203781877],
            [31.812216094991175, 0.778066869991014],
            [31.818324078374467, 0.777173107943849],
            [31.821363734750797, 0.775681027384079],
            [31.82108730696819, 0.778953657973495],
            [31.81811760779292, 0.787021550884331],
            [31.81774140413171, 0.790592287007639],
            [31.818797653124264, 0.794506784856678],
            [31.81865924429854, 0.801408089227004],
            [31.819034608034936, 0.805299117801236],
            [31.8214933382901, 0.810361620122466],
            [31.823624265213226, 0.811691922315806],
            [31.82898641245039, 0.814054353451062],
            [31.832807684870605, 0.820640558499695],
            [31.83358498001795, 0.823462968635263],
            [31.833447049095955, 0.82652933562171],
            [31.8330891387272, 0.827081001865564],
            [31.827576125726264, 0.83252471020655],
            [31.826286354285745, 0.835436949131378],
            [31.82488105321145, 0.836847611143375],
            [31.825259009485798, 0.837824631283598],
            [31.825804517730276, 0.838159476624869],
            [31.82579935960391, 0.840384649605205],
            [31.827696649993005, 0.841751086054281],
            [31.828385782681746, 0.84165179520106],
            [31.830628271380007, 0.842746972938549],
            [31.833139478519083, 0.845777958477774],
            [31.834254047038197, 0.846592388287785],
            [31.835869525142858, 0.84664715079508],
            [31.838837135735105, 0.84753450576368],
            [31.841355400039074, 0.847661903472278],
            [31.841902533335897, 0.847273113827715],
            [31.841952532666284, 0.846278126320415],
            [31.845051334120942, 0.847011743431356],
            [31.845592337314272, 0.849300415262698],
            [31.84634960811562, 0.850494647934472],
            [31.845227977940088, 0.852619998715339],
            [31.84524929945336, 0.853624054769821],
            [31.842066429162873, 0.853234132177644],
            [31.840523850241798, 0.85259143455389],
            [31.837577896234436, 0.852509128341957],
            [31.83361023974544, 0.857464822702676],
            [31.825719239762055, 0.863785137465515],
            [31.816870568312137, 0.873099121743257],
            [31.812135119953144, 0.876290632887566],
            [31.80660583576749, 0.878559243557053],
            [31.79944962355053, 0.88060117449805],
            [31.79615911083447, 0.880618192867495],
            [31.7874925000449, 0.883383217432588],
            [31.78287106496345, 0.883128423512435],
            [31.782618933016018, 0.883888143518906],
            [31.78354906213594, 0.88616786308694],
            [31.784990979439492, 0.89341227048996],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1212,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "KIBIGA",
        Population: 25685,
        Key: "KIBOGAKIBIGA",
        Dist2: "Kiboga",
        "Sub Country": "Kibiga",
        id2_original: "KibogaKibiga",
        drought: "VH",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.784990979439492, 0.89341227048996],
            [31.786143590712562, 0.895114515223624],
            [31.787003172438265, 0.898425380632401],
            [31.791209600231504, 0.904613778642574],
            [31.793124467057414, 0.905374228932433],
            [31.797524846510374, 0.909328513973443],
            [31.798967557026366, 0.912142097883375],
            [31.801022343644313, 0.914955409235172],
            [31.786711021443267, 0.918547601444546],
            [31.786590030950897, 0.920529223767143],
            [31.78450390301099, 0.92305927079181],
            [31.78097204711407, 0.924415931420769],
            [31.781332890482247, 0.924627927785769],
            [31.78072338625692, 0.926194123024306],
            [31.779532986453088, 0.927755494250029],
            [31.77982836060337, 0.929409365616318],
            [31.777893323006037, 0.936891795798472],
            [31.77801087923907, 0.939068620564733],
            [31.77747174004995, 0.939518342096606],
            [31.773146154327556, 0.941170899255898],
            [31.770582563729274, 0.94156696869579],
            [31.76160612579485, 0.940716759719601],
            [31.760626646826477, 0.940024377664373],
            [31.753076755122766, 0.937887002214643],
            [31.753594085911754, 0.935273131825694],
            [31.755383352989615, 0.932198410221875],
            [31.756054802341996, 0.929693133014795],
            [31.75195316123001, 0.926191189509907],
            [31.754475331408862, 0.924690585201326],
            [31.75074406029864, 0.923640021778689],
            [31.74833932418195, 0.920183915502151],
            [31.748013217767532, 0.915615994506942],
            [31.746230806631917, 0.908741048400946],
            [31.748904604345874, 0.907186215876595],
            [31.750829527811387, 0.904717556154714],
            [31.75276080955252, 0.903352405450381],
            [31.751472102615594, 0.900193339263052],
            [31.75378842384706, 0.899713875020954],
            [31.758322857991548, 0.893501294387849],
            [31.758539234295714, 0.894925260591322],
            [31.759425456459475, 0.896710945198658],
            [31.760587827928106, 0.897691548095587],
            [31.76121590841521, 0.897773525471257],
            [31.762408662703372, 0.90012270626369],
            [31.763447576007536, 0.898932122623107],
            [31.76463088091722, 0.898363522162154],
            [31.76665516973131, 0.898814124568402],
            [31.768220040346126, 0.89723996920197],
            [31.76828753257005, 0.896368817897224],
            [31.772754381065806, 0.895130892207408],
            [31.776842525888966, 0.895681429359466],
            [31.779482147197925, 0.893846276455386],
            [31.781884789341643, 0.893084544718443],
            [31.784990979439492, 0.89341227048996],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1213,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "KIBOGA TOWN COUNCIL",
        Population: 19338,
        Key: "KIBOGAKIBOGA TOWN COUNCIL",
        Dist2: "Kiboga",
        "Sub Country": "Kiboga T/C",
        id2_original: "KibogaKiboga T/C",
        drought: "VH",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.967608747946493, 0.887318833621747],
            [31.966305078670185, 0.889625158663145],
            [31.954710790995993, 0.902096045594764],
            [31.943774048550242, 0.910939635879528],
            [31.938432342477363, 0.914312124089517],
            [31.9327307973528, 0.918959934431449],
            [31.922073819930933, 0.932878069975333],
            [31.920234670303643, 0.932986049326432],
            [31.914677980315304, 0.93125659459476],
            [31.908439056699592, 0.929952071531927],
            [31.897028140327713, 0.924493965097632],
            [31.893626173634374, 0.922104848307637],
            [31.887226912418534, 0.915535716930802],
            [31.87935908537621, 0.912303966355999],
            [31.8726984674133, 0.906539835933685],
            [31.865890123298552, 0.899102247084884],
            [31.856367512366297, 0.88233789658648],
            [31.853326062054364, 0.87852879065599],
            [31.851204964497075, 0.874312927946647],
            [31.853633231982595, 0.872206072668764],
            [31.855435469834852, 0.869492970868747],
            [31.85296615742565, 0.866190602852154],
            [31.850483330761342, 0.863946558050944],
            [31.850550752916664, 0.862924436245631],
            [31.851720204008053, 0.862427290363858],
            [31.851808900964265, 0.86162226730873],
            [31.849413525292864, 0.858989296620476],
            [31.848530928729556, 0.857134700945674],
            [31.84524929945336, 0.853624054769821],
            [31.845227977940088, 0.852619998715339],
            [31.84634960811562, 0.850494647934472],
            [31.845592337314272, 0.849300415262698],
            [31.845051334120942, 0.847011743431356],
            [31.841952532666284, 0.846278126320415],
            [31.841902533335897, 0.847273113827715],
            [31.841355400039074, 0.847661903472278],
            [31.838837135735105, 0.84753450576368],
            [31.835869525142858, 0.84664715079508],
            [31.834254047038197, 0.846592388287785],
            [31.833139478519083, 0.845777958477774],
            [31.830628271380007, 0.842746972938549],
            [31.828385782681746, 0.84165179520106],
            [31.827696649993005, 0.841751086054281],
            [31.82579935960391, 0.840384649605205],
            [31.825804517730276, 0.838159476624869],
            [31.825259009485798, 0.837824631283598],
            [31.82488105321145, 0.836847611143375],
            [31.826286354285745, 0.835436949131378],
            [31.827576125726264, 0.83252471020655],
            [31.8330891387272, 0.827081001865564],
            [31.833447049095955, 0.82652933562171],
            [31.83358498001795, 0.823462968635263],
            [31.832807684870605, 0.820640558499695],
            [31.82898641245039, 0.814054353451062],
            [31.823624265213226, 0.811691922315806],
            [31.8214933382901, 0.810361620122466],
            [31.819034608034936, 0.805299117801236],
            [31.81865924429854, 0.801408089227004],
            [31.818797653124264, 0.794506784856678],
            [31.81774140413171, 0.790592287007639],
            [31.81811760779292, 0.787021550884331],
            [31.82108730696819, 0.778953657973495],
            [31.821363734750797, 0.775681027384079],
            [31.823308018707316, 0.774252843918509],
            [31.823297168855337, 0.773881978656937],
            [31.832016098425367, 0.773947732031925],
            [31.838075118235764, 0.773551412605272],
            [31.840809577384217, 0.7725752564321],
            [31.846911847482303, 0.769094419184003],
            [31.849741510084545, 0.768091138898314],
            [31.855778577764337, 0.766934949173707],
            [31.857349434752237, 0.765768500394227],
            [31.85925593556791, 0.763236263651164],
            [31.861528531302927, 0.756696945561221],
            [31.862446895187563, 0.755132309043394],
            [31.86365859404674, 0.7550421736275],
            [31.86492118336509, 0.753631401020677],
            [31.86577745210403, 0.753278849943638],
            [31.866584097906678, 0.753704203175624],
            [31.86762638258812, 0.75504322007395],
            [31.871950248036743, 0.755008173549657],
            [31.87238076384003, 0.753769042453492],
            [31.87304755363104, 0.753172208473953],
            [31.875438724288593, 0.751680310899415],
            [31.877459581538265, 0.751011462190299],
            [31.882088720571584, 0.746462720930858],
            [31.88330616685196, 0.74587506865425],
            [31.886720259005013, 0.745731212954525],
            [31.887744275546844, 0.746084254179575],
            [31.8897634376756, 0.747694891848625],
            [31.891791240699032, 0.748455242839113],
            [31.89894116650563, 0.748529427469537],
            [31.90441474705884, 0.747192053250879],
            [31.90944759976062, 0.744163011892932],
            [31.91183890247055, 0.742173554633946],
            [31.91338352865214, 0.740319569083805],
            [31.914635452273114, 0.740012324183035],
            [31.915536750862298, 0.739270798859004],
            [31.91703605344453, 0.740184786328705],
            [31.918811343634886, 0.743604505389235],
            [31.9205749296754, 0.75123048677043],
            [31.92025733569658, 0.753491838253277],
            [31.919140869037296, 0.75560825709945],
            [31.91891214898281, 0.757299748738658],
            [31.917567175169758, 0.760230221112761],
            [31.916349627379745, 0.761152575764082],
            [31.915207553344967, 0.763449894607502],
            [31.917931632460295, 0.764678527049904],
            [31.9241023757426, 0.764938921857127],
            [31.92823944101946, 0.765692919303248],
            [31.93114172432759, 0.767215539754016],
            [31.932618975066244, 0.769297858481691],
            [31.93579877042354, 0.770972128286288],
            [31.94148275617924, 0.768576426263135],
            [31.94267279036872, 0.767663099566373],
            [31.949252756687084, 0.764525843217596],
            [31.950733697704916, 0.764833766356058],
            [31.95844543348349, 0.774080507084221],
            [31.96357387681297, 0.778636714909868],
            [31.96463107352813, 0.782270918249542],
            [31.965345767778278, 0.788829417299545],
            [31.964968638852323, 0.796520753724016],
            [31.965308663763764, 0.800812934479688],
            [31.97721993546068, 0.803004827364662],
            [31.978538236496316, 0.803593143591541],
            [31.9869687547579, 0.811429026179872],
            [31.989648573879162, 0.816151675048198],
            [31.9895360329404, 0.819236305832472],
            [31.9868053628858, 0.825739620718835],
            [31.984871276604363, 0.829303210689628],
            [31.983124885216693, 0.831338086254268],
            [31.980939694660535, 0.840464826398074],
            [31.973803722385238, 0.86164838107585],
            [31.972444197661204, 0.878419056377063],
            [31.967608747946493, 0.887318833621747],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1214,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "LWAMATA",
        Population: 28248,
        Key: "KIBOGALWAMATA",
        Dist2: "Kiboga",
        "Sub Country": "Lwamata",
        id2_original: "KibogaLwamata",
        drought: "H",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "M",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.949252756687084, 0.764525843217596],
            [31.94267279036872, 0.767663099566373],
            [31.94148275617924, 0.768576426263135],
            [31.93579877042354, 0.770972128286288],
            [31.932618975066244, 0.769297858481691],
            [31.93114172432759, 0.767215539754016],
            [31.92823944101946, 0.765692919303248],
            [31.9241023757426, 0.764938921857127],
            [31.917931632460295, 0.764678527049904],
            [31.915207553344967, 0.763449894607502],
            [31.916349627379745, 0.761152575764082],
            [31.917567175169758, 0.760230221112761],
            [31.91891214898281, 0.757299748738658],
            [31.919140869037296, 0.75560825709945],
            [31.92025733569658, 0.753491838253277],
            [31.9205749296754, 0.75123048677043],
            [31.918811343634886, 0.743604505389235],
            [31.91703605344453, 0.740184786328705],
            [31.915536750862298, 0.739270798859004],
            [31.914635452273114, 0.740012324183035],
            [31.91338352865214, 0.740319569083805],
            [31.912397966292687, 0.738844876543239],
            [31.913611730378694, 0.736104328371914],
            [31.912929626108745, 0.735018676261464],
            [31.910064992990797, 0.731960526250356],
            [31.908677947479713, 0.731345078648322],
            [31.907786940888744, 0.730196057082366],
            [31.90456891682624, 0.727716751263742],
            [31.90341454305857, 0.725283181733883],
            [31.898624680149563, 0.720017432957904],
            [31.892360877692074, 0.714733246104604],
            [31.889639250079124, 0.711467108830543],
            [31.889284433508212, 0.708617648785704],
            [31.889904399513338, 0.706395582027929],
            [31.892151897217612, 0.702033117616566],
            [31.893353836779557, 0.700450417208214],
            [31.8958116444649, 0.698406686628011],
            [31.899409091750616, 0.696996416435713],
            [31.905562221765138, 0.696518443844136],
            [31.905697184653427, 0.695758638386303],
            [31.90334619114692, 0.692483552939053],
            [31.902818167711118, 0.690520518592488],
            [31.904321851376995, 0.685753797840066],
            [31.905830397623532, 0.683022350680091],
            [31.91178584886817, 0.677478703302506],
            [31.91466730832972, 0.673200736222072],
            [31.91847653613862, 0.666381118929437],
            [31.92283792960655, 0.655074918215314],
            [31.921852040260326, 0.653681660997795],
            [31.92173989008866, 0.652876566818411],
            [31.920582389285528, 0.651673233798219],
            [31.91736920714238, 0.651355937015059],
            [31.916698498001807, 0.64942000815658],
            [31.915295430139324, 0.647583424983837],
            [31.914674975450676, 0.644372063023997],
            [31.911647314278323, 0.641892888793764],
            [31.90869977204953, 0.637676960961285],
            [31.907509642638658, 0.634094613106504],
            [31.907781735151666, 0.631444284716954],
            [31.907397562535596, 0.62892950168948],
            [31.90940518400787, 0.624081433928175],
            [31.909553169772813, 0.622618596099486],
            [31.913352415502267, 0.62277063237189],
            [31.914254032993384, 0.623560818316624],
            [31.914962519884927, 0.625593230208022],
            [31.92956994476993, 0.631014669946302],
            [31.931685068530555, 0.631254523540987],
            [31.933867667447156, 0.633216462112613],
            [31.934742877163835, 0.635152519272133],
            [31.936496627550326, 0.63754715705082],
            [31.937801864386767, 0.638525037468409],
            [31.941033991999273, 0.638888233414283],
            [31.944470517779916, 0.638212701851394],
            [31.94706049908459, 0.638718233321658],
            [31.950318021171842, 0.638409377573776],
            [31.95145832822043, 0.638653849675715],
            [31.952934024873638, 0.637867248281742],
            [31.954513255956613, 0.63852783644501],
            [31.957414674187138, 0.637958544693512],
            [31.958033992506927, 0.63745697357554],
            [31.959911382517525, 0.637723863588617],
            [31.962756088307525, 0.64130660055868],
            [31.9648748277872, 0.645269119549579],
            [31.966607151557522, 0.646581126255928],
            [31.968508175344923, 0.646843846977097],
            [31.975570112067757, 0.64613971412984],
            [31.977422763373756, 0.646791395893507],
            [31.976867547035983, 0.64897516134043],
            [31.978093379987858, 0.650631175417051],
            [31.983234751870903, 0.655291197733188],
            [31.985057452447005, 0.657691649409819],
            [31.986786080548235, 0.658622878609493],
            [31.988733361284574, 0.659414331849977],
            [31.990339314552276, 0.658589215569997],
            [31.99122757319679, 0.658830152060193],
            [31.997734010612536, 0.657597735835258],
            [31.997539554997946, 0.663322402324299],
            [31.99449045822628, 0.666261707665889],
            [31.99226084148773, 0.667473402601445],
            [31.99155501720269, 0.669544774848875],
            [31.987831353026323, 0.67407600581443],
            [31.987815100706204, 0.676608859768885],
            [31.987136021962105, 0.678309349643093],
            [31.987171986912834, 0.680896489930426],
            [31.988061711607877, 0.684388405010945],
            [31.989387215335473, 0.686740627902189],
            [31.99417095981908, 0.69000087103172],
            [31.99616831714092, 0.697063670120626],
            [31.99619545704229, 0.698221542328504],
            [31.994880230939856, 0.701543232075329],
            [31.988196264864385, 0.710046560364194],
            [31.985566137849663, 0.715035814665042],
            [31.988192048172447, 0.715524495130985],
            [31.98840607178888, 0.71915195737456],
            [31.98726105307662, 0.721033251994549],
            [31.975772866318938, 0.725056074380332],
            [31.97367537648734, 0.727923137818987],
            [31.96976219563379, 0.730545538010125],
            [31.965701448528506, 0.732534684284293],
            [31.96449198467774, 0.733746546235418],
            [31.959493224837598, 0.740963953152513],
            [31.956588916726815, 0.747476261418585],
            [31.95392564996296, 0.751130132917326],
            [31.951253079347705, 0.756077546471946],
            [31.949520236351166, 0.760473386223098],
            [31.949252756687084, 0.764525843217596],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1215,
        District: "KIBOGA",
        County: "KIBOGA",
        Subcounty: "MUWANGA",
        Population: 18002,
        Key: "KIBOGAMUWANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.700960797183544, 1.057768254423408],
            [31.700755088373374, 1.064850392711597],
            [31.6970980396652, 1.076191230669203],
            [31.69515921387231, 1.078379275529067],
            [31.69261107070368, 1.082412223128161],
            [31.692285571550375, 1.084456240863584],
            [31.69035738989532, 1.086029220435255],
            [31.689392495973923, 1.088669922019724],
            [31.68742334395535, 1.090812708046362],
            [31.685829380501744, 1.093543574477589],
            [31.68532155478678, 1.095090033185419],
            [31.68576709670982, 1.096627868848223],
            [31.684112201428785, 1.0999647116766],
            [31.684586697850076, 1.105247159456892],
            [31.68322596758693, 1.107571096233948],
            [31.683781920543225, 1.112772175520719],
            [31.683558173562137, 1.113893645146662],
            [31.68501714627972, 1.118000699212919],
            [31.683717173570823, 1.121310552991214],
            [31.68440658653393, 1.121916875970501],
            [31.68454825893907, 1.122857612429398],
            [31.685440471967475, 1.123979588346541],
            [31.684932886102704, 1.124938119929785],
            [31.684373382106084, 1.128320666781819],
            [31.68522540450865, 1.128890885733638],
            [31.685184426060353, 1.129469741993202],
            [31.686735768047008, 1.131722638266433],
            [31.686896797349878, 1.134562820663092],
            [31.68829600066001, 1.136055876054676],
            [31.689075668258024, 1.139520444929053],
            [31.691035744597286, 1.143099725022396],
            [31.67692310099096, 1.136222496946175],
            [31.67416406483468, 1.135633302661063],
            [31.669508134446332, 1.133795035514863],
            [31.658302465150577, 1.131271426142446],
            [31.647161407181656, 1.127308519065337],
            [31.64031541108006, 1.123244203594995],
            [31.634342280092316, 1.118411502291444],
            [31.630832555989056, 1.117550603157362],
            [31.6210432864529, 1.116315904915317],
            [31.618720537775605, 1.11550982794076],
            [31.617686420576707, 1.114098368431035],
            [31.617504226965725, 1.112786804520571],
            [31.617906193410963, 1.110685575356112],
            [31.619611196718527, 1.10794174998699],
            [31.61864735472433, 1.09541626503908],
            [31.615255547078537, 1.091348121845802],
            [31.607580790448647, 1.088335298886507],
            [31.603540692018512, 1.088414745029227],
            [31.599499546152728, 1.090771445124418],
            [31.5979641753135, 1.091096045504346],
            [31.59489279133965, 1.09312786404874],
            [31.589977044814923, 1.09821239945209],
            [31.589355846321244, 1.098239453534509],
            [31.58139433846951, 1.103125058253963],
            [31.58139228761574, 1.107435550512287],
            [31.56830187649711, 1.108893131261461],
            [31.56578540163719, 1.107797898215347],
            [31.55798727847101, 1.108118251201836],
            [31.55240498919202, 1.107313221923497],
            [31.553022244081607, 1.105378317824985],
            [31.55212468248402, 1.102622856517384],
            [31.54922802442618, 1.098432993234402],
            [31.548431259193375, 1.096094396894788],
            [31.54852247233069, 1.095443810435416],
            [31.55131207186791, 1.091246563269467],
            [31.55236394337004, 1.088156570879629],
            [31.553937776476467, 1.070539415550516],
            [31.55769936842248, 1.061025682240485],
            [31.55923530070873, 1.059399818627206],
            [31.563678582801337, 1.06082516593671],
            [31.568930562448692, 1.060746293001495],
            [31.572203344217673, 1.059853190875876],
            [31.577010796139945, 1.060099413784915],
            [31.579414757908832, 1.059714211143294],
            [31.581555844777835, 1.059938859324288],
            [31.58452445519496, 1.061648163616012],
            [31.582366162893347, 1.054835767817618],
            [31.582326915498562, 1.052294183601624],
            [31.582994889269102, 1.04924460889684],
            [31.584712601043005, 1.047639122090441],
            [31.58909688538104, 1.045607859039114],
            [31.590066835020835, 1.04481532650515],
            [31.588289372704132, 1.044529865109495],
            [31.58239286082359, 1.040420013737126],
            [31.571325416198913, 1.035941839705042],
            [31.56995178522999, 1.036063208307849],
            [31.558678504234393, 1.040246510286832],
            [31.5561743506669, 1.038944087594611],
            [31.551934265694943, 1.034957005026574],
            [31.54741101198246, 1.031823755324586],
            [31.54672486080215, 1.030440848649372],
            [31.546485214538876, 1.024381738610696],
            [31.544790743079684, 1.019338576821956],
            [31.544245062358662, 1.01230157224185],
            [31.547610159497793, 1.009221638615197],
            [31.5489346589089, 1.007295775500471],
            [31.551090820406696, 1.001625893336949],
            [31.551776601481105, 0.996941189238542],
            [31.554574487078487, 0.994138655756027],
            [31.555978275389837, 0.993858898701021],
            [31.557661421788218, 0.9942847294714],
            [31.560308889881185, 0.99580536497001],
            [31.56152165683725, 0.997017856924698],
            [31.563140837797544, 0.997335127064135],
            [31.57046217922832, 1.003814205452797],
            [31.576628395001585, 1.007660841997836],
            [31.586933887703935, 1.010071224015918],
            [31.59729100478905, 1.011414354776881],
            [31.601753542269776, 1.013740765455619],
            [31.604928894559656, 1.013506987643102],
            [31.605496689108023, 1.014104180383638],
            [31.610202988034366, 1.01576139469101],
            [31.611409600632413, 1.01701912562932],
            [31.612123813385587, 1.01853318398316],
            [31.61498783205588, 1.023523794097078],
            [31.619366173139955, 1.025217056158735],
            [31.620881100119938, 1.025190581656107],
            [31.623336599135012, 1.024106283705071],
            [31.623985622944616, 1.024540710509165],
            [31.62551754425316, 1.024179586198585],
            [31.630284024015314, 1.027736224077605],
            [31.632333167416657, 1.028080809970082],
            [31.634677045367756, 1.02735824325671],
            [31.637132054801, 1.027458793484918],
            [31.641178171943558, 1.03068047051918],
            [31.64395750373709, 1.031477607021442],
            [31.645215425409223, 1.031659043586418],
            [31.64564201198144, 1.030890420430848],
            [31.648056509191992, 1.030538708761324],
            [31.64868538648473, 1.030828411679659],
            [31.649608550067924, 1.030448924994091],
            [31.650521621078898, 1.030693525419258],
            [31.652023286230335, 1.030205748149721],
            [31.655451706512196, 1.031346857758439],
            [31.659334817159912, 1.037019623704202],
            [31.659598053182567, 1.03805989176351],
            [31.660936639973958, 1.039426235603096],
            [31.66196028371496, 1.041832602264785],
            [31.663440333604008, 1.044013045973937],
            [31.665844177693607, 1.045678330017472],
            [31.66738475696484, 1.048826603934367],
            [31.66740450642636, 1.049930086293817],
            [31.66817551516336, 1.050138449664296],
            [31.670254369444404, 1.052047811877196],
            [31.67492008607947, 1.054500981115246],
            [31.67596373170858, 1.057431976189348],
            [31.692479665143935, 1.057909379054475],
            [31.700960797183544, 1.057768254423408],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1217,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "BUTEMBA",
        Population: 19137,
        Key: "KYANKWANZIBUTEMBA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Butemba S/C",
        id2_original: "KyankwanziButemba S/C",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.691035744597286, 1.143099725022396],
            [31.69205035218482, 1.14515681434878],
            [31.692907826462868, 1.145482826871587],
            [31.691659017300967, 1.147960568612594],
            [31.69133319655079, 1.150574407868355],
            [31.69022683773508, 1.151650243959867],
            [31.688784853956175, 1.15465249448722],
            [31.68893620301355, 1.156515822314337],
            [31.68958465998622, 1.158252753045182],
            [31.689421940952283, 1.159130036315236],
            [31.686750616300337, 1.159224914022904],
            [31.680104214176797, 1.158142713942514],
            [31.670244823047884, 1.150152893715429],
            [31.664241629939138, 1.14928680561785],
            [31.662310495521726, 1.15230729972929],
            [31.661877206619156, 1.16180293984064],
            [31.664016144718005, 1.172810518466241],
            [31.665083069289363, 1.183611355146857],
            [31.6712989888473, 1.188146492181449],
            [31.67429876721151, 1.192464260395467],
            [31.67258061885639, 1.198290445158347],
            [31.67355165096612, 1.20027875109421],
            [31.673767436178863, 1.20215224203399],
            [31.675031402614525, 1.205583909356607],
            [31.675640513377765, 1.2102905033003],
            [31.673151595237506, 1.216566422186467],
            [31.672897115093924, 1.21839336081219],
            [31.673139217351203, 1.221188348240801],
            [31.672458125482578, 1.224227087076306],
            [31.67272976793964, 1.228604942487864],
            [31.67323371832246, 1.229845445949565],
            [31.658539934795918, 1.244808922619189],
            [31.648185964509278, 1.2614319713917],
            [31.64704046609663, 1.259000491399534],
            [31.64524443650132, 1.258203611244075],
            [31.644753795557758, 1.256647653894159],
            [31.642076577059218, 1.254149896843204],
            [31.641906919438, 1.252594109516205],
            [31.640113918961838, 1.249753119339112],
            [31.637415164252683, 1.247101598779992],
            [31.633641109080436, 1.245064560520976],
            [31.629879604271036, 1.240495010208098],
            [31.628886581403126, 1.237844391025777],
            [31.619332348874583, 1.232692969690978],
            [31.615254367590545, 1.231994394729837],
            [31.613955462978538, 1.23221983051107],
            [31.608922143152803, 1.234767770282914],
            [31.5996883648389, 1.237810909647054],
            [31.599374942636302, 1.235730484794932],
            [31.59779409638244, 1.232220341534283],
            [31.597804949827708, 1.230800346905377],
            [31.596689680622692, 1.229470200089784],
            [31.59660027848899, 1.225906585916849],
            [31.595790016967324, 1.223418896415664],
            [31.59497871429826, 1.222930060212363],
            [31.59443171395207, 1.221256523864922],
            [31.593589864071774, 1.220650093050542],
            [31.593590353653628, 1.21970945767607],
            [31.593063279737056, 1.219139371306914],
            [31.593023538268895, 1.217258078517145],
            [31.591798183220742, 1.213241644305797],
            [31.591415940185904, 1.20682884483825],
            [31.590625130783394, 1.205815440170226],
            [31.586821354849977, 1.204492946452667],
            [31.585219045149064, 1.203388673015796],
            [31.582926062148694, 1.20367689765589],
            [31.578665540503998, 1.202670718966137],
            [31.576860401093384, 1.201747229602782],
            [31.575501710904256, 1.200362705383869],
            [31.57158683942133, 1.197828187848335],
            [31.567489074539818, 1.196559802857532],
            [31.56306585901404, 1.196376579309525],
            [31.560550445064464, 1.195696915650991],
            [31.549707916129066, 1.190816224519232],
            [31.54236522443891, 1.186850880635014],
            [31.533958352530593, 1.180696245547354],
            [31.53384132989684, 1.161694021743078],
            [31.532924601844346, 1.159342014192566],
            [31.527539458634216, 1.15324588153756],
            [31.53210120246163, 1.153636294676742],
            [31.535253045840538, 1.152418008167467],
            [31.537840987071206, 1.147864954058599],
            [31.536549546560884, 1.145180448793985],
            [31.528235525418623, 1.138094253218869],
            [31.533285136192024, 1.128482913272874],
            [31.534405013754455, 1.127262496502627],
            [31.531427108469064, 1.126039583284805],
            [31.52770617606947, 1.122492079071097],
            [31.526027425127747, 1.117563637029032],
            [31.524947206388514, 1.116434942328727],
            [31.528790951962183, 1.114502914676147],
            [31.533974762954205, 1.114404796786647],
            [31.54188379212533, 1.119484456528887],
            [31.544238475910976, 1.113917960640421],
            [31.546309506764235, 1.110771543243778],
            [31.549070251516223, 1.108041501821074],
            [31.55240498919202, 1.107313221923497],
            [31.55798727847101, 1.108118251201836],
            [31.56578540163719, 1.107797898215347],
            [31.56830187649711, 1.108893131261461],
            [31.58139228761574, 1.107435550512287],
            [31.58139433846951, 1.103125058253963],
            [31.589355846321244, 1.098239453534509],
            [31.589977044814923, 1.09821239945209],
            [31.59489279133965, 1.09312786404874],
            [31.5979641753135, 1.091096045504346],
            [31.599499546152728, 1.090771445124418],
            [31.603540692018512, 1.088414745029227],
            [31.607580790448647, 1.088335298886507],
            [31.615255547078537, 1.091348121845802],
            [31.61864735472433, 1.09541626503908],
            [31.619611196718527, 1.10794174998699],
            [31.617906193410963, 1.110685575356112],
            [31.617504226965725, 1.112786804520571],
            [31.617686420576707, 1.114098368431035],
            [31.618720537775605, 1.11550982794076],
            [31.6210432864529, 1.116315904915317],
            [31.630832555989056, 1.117550603157362],
            [31.634342280092316, 1.118411502291444],
            [31.64031541108006, 1.123244203594995],
            [31.647161407181656, 1.127308519065337],
            [31.658302465150577, 1.131271426142446],
            [31.669508134446332, 1.133795035514863],
            [31.67416406483468, 1.135633302661063],
            [31.67692310099096, 1.136222496946175],
            [31.691035744597286, 1.143099725022396],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1218,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "BUTEMBA TOWN COUNCIL",
        Population: 14346,
        Key: "KYANKWANZIBUTEMBA TOWN COUNCIL",
        Dist2: "Kyankwanzi",
        "Sub Country": "Butemba T/C",
        id2_original: "KyankwanziButemba T/C",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.841665659273566, 1.32852490424039],
            [31.840336113127194, 1.331041957770084],
            [31.83580462096527, 1.336204746205383],
            [31.831776760284228, 1.342977836624873],
            [31.825014130535966, 1.348673167729485],
            [31.82352396202355, 1.350906653422164],
            [31.821878061573454, 1.356314989749466],
            [31.821479303012083, 1.359091727167892],
            [31.81728453714789, 1.35774189833628],
            [31.81623513241949, 1.356854934264073],
            [31.81502468671013, 1.35677292760329],
            [31.814159676465167, 1.356148370207749],
            [31.810427381275552, 1.356182704977444],
            [31.80841200374911, 1.354390727864661],
            [31.80744318598652, 1.354127931780405],
            [31.806872767459204, 1.354136694194842],
            [31.80514951397834, 1.35571877153788],
            [31.80102681725442, 1.354097604145026],
            [31.798068898585786, 1.354041854999201],
            [31.79701208904451, 1.354529772464298],
            [31.79461537578164, 1.354356710984328],
            [31.793467660326886, 1.354663674740245],
            [31.792791083390874, 1.354102527334188],
            [31.792938886797838, 1.352818170040696],
            [31.791320525101096, 1.351867602287649],
            [31.79044170685191, 1.35079981773943],
            [31.78938373399233, 1.350808332299786],
            [31.78828487521092, 1.350011795543822],
            [31.787478595920923, 1.349920937313453],
            [31.784864887414646, 1.346744733656091],
            [31.78217217836736, 1.346001667402841],
            [31.78017563402083, 1.346525285552154],
            [31.779103201878467, 1.34456192571341],
            [31.775644471540605, 1.34300439879755],
            [31.775155375699356, 1.340462441483059],
            [31.774368320356412, 1.339005762524051],
            [31.774577074455408, 1.337142550390603],
            [31.773484271217328, 1.336056573465216],
            [31.77292531339641, 1.334500513082265],
            [31.771037754456806, 1.333893533333899],
            [31.769178421481726, 1.334136816496457],
            [31.768170774041007, 1.333503143264622],
            [31.766335890513037, 1.333719301101769],
            [31.764170158364198, 1.332270974707542],
            [31.763716217193263, 1.331330044269943],
            [31.762649343825867, 1.331202872669594],
            [31.759160709470535, 1.328876493824823],
            [31.75786022023034, 1.327537148584064],
            [31.756597161991415, 1.327165656584535],
            [31.756155867303015, 1.325654889487877],
            [31.754546782508225, 1.32533749365],
            [31.75302827125026, 1.32417894254656],
            [31.748491971304936, 1.323814831325833],
            [31.745750934691962, 1.324365187209161],
            [31.744200584445405, 1.325657848644516],
            [31.742084488707622, 1.32386583213587],
            [31.73848021242913, 1.323176556400352],
            [31.737734228959315, 1.323854556797954],
            [31.73568734931249, 1.324043451705567],
            [31.73215054459666, 1.325443618268343],
            [31.729497534796703, 1.327423118308259],
            [31.727411092446477, 1.326996917398156],
            [31.725506590382277, 1.327213010245911],
            [31.72502577341465, 1.329428800095896],
            [31.72343107693577, 1.329572689424621],
            [31.723321831017426, 1.330658038763201],
            [31.72204063579293, 1.33227643319185],
            [31.720406962312158, 1.331760010948698],
            [31.71756731583384, 1.33348612300408],
            [31.71708376349618, 1.332291924941452],
            [31.71591766671406, 1.332372717332706],
            [31.714497408690324, 1.331910674302867],
            [31.714029749346675, 1.332240728525498],
            [31.713550410107704, 1.329761343211918],
            [31.715054452201358, 1.323935018973293],
            [31.714305554596756, 1.320805251812806],
            [31.714628091106274, 1.319078868674054],
            [31.716987394927457, 1.318000999741636],
            [31.717846393646514, 1.31551952382995],
            [31.71870445182951, 1.314872511164199],
            [31.718705608859604, 1.312606407795015],
            [31.720743423606887, 1.311204632736008],
            [31.722030781274235, 1.309694558252279],
            [31.72246024604866, 1.308507771394422],
            [31.722354069673656, 1.306457430011485],
            [31.72331993916544, 1.304623457471256],
            [31.7234296566993, 1.299659657652314],
            [31.722680451870886, 1.297069438733656],
            [31.723323960922972, 1.296638126139394],
            [31.7227882631797, 1.295882485171273],
            [31.721930649662806, 1.295666229759145],
            [31.720645801888345, 1.292212462289531],
            [31.719895459792745, 1.291888351713517],
            [31.715717654121118, 1.284764192531098],
            [31.716684471335537, 1.28098784572958],
            [31.716471225660154, 1.278613726387458],
            [31.717222369052934, 1.277319188972536],
            [31.719155698054582, 1.270306028789543],
            [31.72334006771603, 1.264157251565037],
            [31.724306574113353, 1.260920432920949],
            [31.72548640074628, 1.259949825263331],
            [31.72623768517457, 1.258331545399924],
            [31.72623815679008, 1.257360354810229],
            [31.727524880246882, 1.257037258291941],
            [31.728491215964326, 1.254124159090791],
            [31.730850544039992, 1.252830390797995],
            [31.7322451560607, 1.251104507727266],
            [31.73482118203743, 1.245062777786135],
            [31.736430519258832, 1.242689526453031],
            [31.739219304922386, 1.240101016116342],
            [31.737427942074994, 1.236926437085394],
            [31.73800021741998, 1.234938000113341],
            [31.737095990322995, 1.234122914335282],
            [31.737429824045513, 1.232949015604422],
            [31.737215822886938, 1.232421785253304],
            [31.738478713140914, 1.229882587219996],
            [31.738527867156627, 1.22660003785832],
            [31.738909070840712, 1.225929328747932],
            [31.73954208307872, 1.221299282940118],
            [31.739305180270314, 1.218831249741238],
            [31.739996185048106, 1.217441871857894],
            [31.739211028743693, 1.216531006904543],
            [31.739117021845836, 1.213919279239144],
            [31.73838005566485, 1.211762497913472],
            [31.73957220538683, 1.207695779030059],
            [31.73845372560298, 1.206892583233346],
            [31.737764764492454, 1.203873252083441],
            [31.737146008518014, 1.203477617148627],
            [31.737247915200477, 1.201884299423779],
            [31.739683108696852, 1.199484901627815],
            [31.746385753442002, 1.197084162632205],
            [31.754361323521195, 1.192710245774552],
            [31.75627991386397, 1.193219366077535],
            [31.76897081902291, 1.18181576656228],
            [31.77229602287861, 1.17814824345991],
            [31.77219178506801, 1.17134974130866],
            [31.77498916850715, 1.148473605723513],
            [31.784851641755775, 1.150851928616889],
            [31.790532972989823, 1.153012621036184],
            [31.79632529826374, 1.146216579446083],
            [31.79868581481054, 1.141793142676238],
            [31.800138754442646, 1.128304611611447],
            [31.79980896942711, 1.128089101746816],
            [31.804643658268812, 1.123396425300669],
            [31.808772627928327, 1.120160722820819],
            [31.81027317916883, 1.121186516710068],
            [31.812470042433773, 1.123615473295688],
            [31.81520233754072, 1.127609401812299],
            [31.818256842170378, 1.130200586869212],
            [31.8197033813061, 1.132251545708331],
            [31.821471998810516, 1.133223497261466],
            [31.824043620347414, 1.136893630977021],
            [31.825275016565847, 1.140725088833457],
            [31.826078698826333, 1.141750604217083],
            [31.826238969951117, 1.143099597487028],
            [31.827417723995612, 1.144556925092189],
            [31.827630808872577, 1.147848396939548],
            [31.82961223277623, 1.152813273137152],
            [31.829879317181557, 1.155133541600587],
            [31.83186120551421, 1.158965325287618],
            [31.832796387657574, 1.16004698527684],
            [31.83510585474342, 1.167118051132465],
            [31.83836604392875, 1.171497132121135],
            [31.839361749166063, 1.173960016729211],
            [31.844611359057716, 1.177972314164609],
            [31.850320531777335, 1.179503789152331],
            [31.856751621202005, 1.184038905961835],
            [31.864040999676686, 1.187279396431353],
            [31.867363565180376, 1.190086579923314],
            [31.876044394504273, 1.199263025949339],
            [31.87926030033936, 1.200775182279108],
            [31.88022455376196, 1.202502239323328],
            [31.884190773844836, 1.204554287828801],
            [31.886012159287358, 1.207792531240122],
            [31.896623397189945, 1.216106490503669],
            [31.899872142736854, 1.220169073506724],
            [31.896207136751887, 1.225948599486903],
            [31.893122943700394, 1.229149464878121],
            [31.891771257675565, 1.235833608957853],
            [31.891005947850726, 1.237172036721598],
            [31.889494743489276, 1.238410647473697],
            [31.88871046933048, 1.242109968201303],
            [31.883973663617073, 1.252085241164296],
            [31.876012974130596, 1.265170742648082],
            [31.870119153602626, 1.273309150898118],
            [31.866883443508794, 1.27528869092641],
            [31.864367171668125, 1.276219261259596],
            [31.861710207484307, 1.276480396893097],
            [31.8604952279777, 1.277158267933483],
            [31.8593549047594, 1.279853319728117],
            [31.857088873014174, 1.291484819664132],
            [31.851554134258105, 1.300184060629856],
            [31.84951616859384, 1.30596318503365],
            [31.847736970732015, 1.315152562636075],
            [31.846015643239095, 1.317539764097392],
            [31.843685979330708, 1.318714584274859],
            [31.84299582974905, 1.319519306364399],
            [31.842482328478155, 1.325787565674304],
            [31.841665659273566, 1.32852490424039],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1219,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "KYANKWANZI TOWN COUNCIL",
        Population: 6128,
        Key: "KYANKWANZIKYANKWANZI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.751472102615594, 0.900193339263052],
            [31.75276080955252, 0.903352405450381],
            [31.750829527811387, 0.904717556154714],
            [31.748904604345874, 0.907186215876595],
            [31.746230806631917, 0.908741048400946],
            [31.748013217767532, 0.915615994506942],
            [31.74833932418195, 0.920183915502151],
            [31.75074406029864, 0.923640021778689],
            [31.754475331408862, 0.924690585201326],
            [31.75195316123001, 0.926191189509907],
            [31.756054802341996, 0.929693133014795],
            [31.755383352989615, 0.932198410221875],
            [31.753594085911754, 0.935273131825694],
            [31.753076755122766, 0.937887002214643],
            [31.760626646826477, 0.940024377664373],
            [31.76160612579485, 0.940716759719601],
            [31.76400646106492, 0.942413524510604],
            [31.766087234147435, 0.946448437624444],
            [31.76698807998571, 0.947217604881113],
            [31.77763486871563, 0.950803336695396],
            [31.78193531957637, 0.953699358477798],
            [31.779925726302068, 0.956376039797619],
            [31.774585726129917, 0.958979151026608],
            [31.766934304137866, 0.959419592571329],
            [31.762462164565065, 0.956939575923411],
            [31.75596498338998, 0.951718130344501],
            [31.74874887330652, 0.949074307558617],
            [31.74550808323974, 0.947481175875655],
            [31.741370084613298, 0.945209332033497],
            [31.737830690054505, 0.942395001958643],
            [31.733831025693622, 0.942013641435717],
            [31.729875251220864, 0.940646378119002],
            [31.721085735629035, 0.939223062433566],
            [31.715538679173804, 0.937837116467648],
            [31.675575031583442, 0.937849213357172],
            [31.665697507062216, 0.933820461810408],
            [31.654935000052326, 0.931184276292351],
            [31.65075543817431, 0.929651549186728],
            [31.651040245441905, 0.9143956055756],
            [31.654882609406645, 0.905406505861896],
            [31.66097241627846, 0.896382024210516],
            [31.663936119199207, 0.891182323225755],
            [31.66942313136255, 0.885685042208836],
            [31.675436184379873, 0.880613026368281],
            [31.675377139912886, 0.882412940131889],
            [31.675793664455615, 0.88369746644696],
            [31.678676945700545, 0.888220959953453],
            [31.680554230608244, 0.885381532337977],
            [31.681221200062303, 0.885155649178807],
            [31.682612681454252, 0.886350078914428],
            [31.683398427951797, 0.88612423803004],
            [31.684071541882396, 0.88520189611646],
            [31.684951010511877, 0.885156986610635],
            [31.685382765990234, 0.884668714375265],
            [31.68898253991253, 0.883168538405482],
            [31.6911228623152, 0.882906997127404],
            [31.69221221692092, 0.883296317554095],
            [31.69359447890309, 0.882781245222343],
            [31.695398838576054, 0.882899469240851],
            [31.698055211668414, 0.882004956629296],
            [31.69901157159462, 0.881299785370473],
            [31.699938506305365, 0.881236796666101],
            [31.709091271851996, 0.883220871629096],
            [31.712531812203665, 0.885094399470659],
            [31.717274740834014, 0.886063880258317],
            [31.723452595180078, 0.884510282121282],
            [31.73491703227826, 0.885635841071145],
            [31.73518928469142, 0.884351528301981],
            [31.738037749032575, 0.88182891667292],
            [31.74025586823381, 0.880798530811838],
            [31.746067375233977, 0.87904574981563],
            [31.746514245765294, 0.879543384825791],
            [31.74679642546068, 0.881298241349166],
            [31.74898854741758, 0.885120022653073],
            [31.746385809137553, 0.88488902867358],
            [31.74531182111312, 0.885476596878443],
            [31.745141496043654, 0.885946885987217],
            [31.746680563450273, 0.889312210755658],
            [31.748229273373138, 0.891564986173076],
            [31.751472102615594, 0.900193339263052],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1220,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "MULAGI",
        Population: 13001,
        Key: "KYANKWANZIMULAGI",
        Dist2: "Kyankwanzi",
        "Sub Country": "Mulagi",
        id2_original: "KyankwanziMulagi",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.675575031583442, 0.937849213357172],
            [31.67848239845778, 0.941649186677932],
            [31.678061579967988, 0.943611770481622],
            [31.676494240782752, 0.946342729320749],
            [31.674821062989054, 0.947536011423096],
            [31.67475484008463, 0.951090630451246],
            [31.675441584153052, 0.951335108294787],
            [31.675462506814316, 0.951696912369958],
            [31.675003687791374, 0.955332783704591],
            [31.673797973508627, 0.957412639088426],
            [31.674368666022097, 0.961501154726641],
            [31.675517279792146, 0.963319629976984],
            [31.675584000363227, 0.969388782731673],
            [31.675020222182518, 0.972798486399505],
            [31.675782161528385, 0.975349450792121],
            [31.675745044039182, 0.976914202991224],
            [31.663053379803827, 0.977614628013588],
            [31.652482404392277, 0.978939949314028],
            [31.63453457346203, 0.983129381240358],
            [31.635937783258314, 0.987109650975527],
            [31.636072448804228, 0.993558613713368],
            [31.63538337091274, 0.993549281620829],
            [31.632157771357413, 0.99710251660809],
            [31.6285418151836, 0.99737233952611],
            [31.619782058082222, 1.009352854930728],
            [31.612123813385587, 1.01853318398316],
            [31.611409600632413, 1.01701912562932],
            [31.610202988034366, 1.01576139469101],
            [31.605496689108023, 1.014104180383638],
            [31.604928894559656, 1.013506987643102],
            [31.601753542269776, 1.013740765455619],
            [31.59729100478905, 1.011414354776881],
            [31.586933887703935, 1.010071224015918],
            [31.576628395001585, 1.007660841997836],
            [31.57046217922832, 1.003814205452797],
            [31.563140837797544, 0.997335127064135],
            [31.56152165683725, 0.997017856924698],
            [31.560308889881185, 0.99580536497001],
            [31.557661421788218, 0.9942847294714],
            [31.555978275389837, 0.993858898701021],
            [31.554574487078487, 0.994138655756027],
            [31.551776601481105, 0.996941189238542],
            [31.551090820406696, 1.001625893336949],
            [31.5489346589089, 1.007295775500471],
            [31.547610159497793, 1.009221638615197],
            [31.548216449551045, 1.004012332607675],
            [31.543974844629634, 1.000853937080446],
            [31.542734935077238, 0.997561224806826],
            [31.543244101078606, 0.995426976248771],
            [31.547507591655304, 0.984485145156646],
            [31.548102431781917, 0.981591195718384],
            [31.5481360485365, 0.98046970390575],
            [31.546200772885598, 0.974981460732209],
            [31.549081903563774, 0.969568984130966],
            [31.55023417796859, 0.966528240967911],
            [31.552752802497, 0.964501830626538],
            [31.555270997630657, 0.963489161221621],
            [31.55879620958774, 0.962694149537939],
            [31.574694817166606, 0.961180262392475],
            [31.58014991488284, 0.961069092654519],
            [31.587636672090067, 0.967109850539128],
            [31.59251206180063, 0.962318265720393],
            [31.59358022874204, 0.960587069660986],
            [31.598293476137094, 0.963626204091207],
            [31.60025394593842, 0.965487292725186],
            [31.600913508782973, 0.966626509861416],
            [31.601063350467285, 0.969113264844025],
            [31.60182909867001, 0.970937039809894],
            [31.602814050175063, 0.969392960198058],
            [31.60828745465848, 0.965082308827813],
            [31.6110105752714, 0.960712215235597],
            [31.612603569442847, 0.95893523944178],
            [31.616628768415687, 0.956255866445348],
            [31.62210324279261, 0.94917668618111],
            [31.627691594801483, 0.94690588176109],
            [31.627431682545385, 0.945273843850369],
            [31.62693952524563, 0.945273647146111],
            [31.62775150344778, 0.941806117327925],
            [31.62770602354159, 0.928782379973009],
            [31.63088701096324, 0.929546036182648],
            [31.63554309945508, 0.929646527367096],
            [31.647698363464634, 0.928911210200027],
            [31.65075543817431, 0.929651549186728],
            [31.654935000052326, 0.931184276292351],
            [31.665697507062216, 0.933820461810408],
            [31.675575031583442, 0.937849213357172],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1221,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "NKANDWA",
        Population: 12898,
        Key: "KYANKWANZINKANDWA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Nkandwa",
        id2_original: "KyankwanziNkandwa",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.62770602354159, 0.928782379973009],
            [31.62775150344778, 0.941806117327925],
            [31.62693952524563, 0.945273647146111],
            [31.627431682545385, 0.945273843850369],
            [31.627691594801483, 0.94690588176109],
            [31.62210324279261, 0.94917668618111],
            [31.616628768415687, 0.956255866445348],
            [31.612603569442847, 0.95893523944178],
            [31.6110105752714, 0.960712215235597],
            [31.60828745465848, 0.965082308827813],
            [31.602814050175063, 0.969392960198058],
            [31.60182909867001, 0.970937039809894],
            [31.601063350467285, 0.969113264844025],
            [31.600913508782973, 0.966626509861416],
            [31.60025394593842, 0.965487292725186],
            [31.598293476137094, 0.963626204091207],
            [31.59358022874204, 0.960587069660986],
            [31.59251206180063, 0.962318265720393],
            [31.587636672090067, 0.967109850539128],
            [31.58014991488284, 0.961069092654519],
            [31.574694817166606, 0.961180262392475],
            [31.55879620958774, 0.962694149537939],
            [31.555270997630657, 0.963489161221621],
            [31.552752802497, 0.964501830626538],
            [31.55023417796859, 0.966528240967911],
            [31.549081903563774, 0.969568984130966],
            [31.546200772885598, 0.974981460732209],
            [31.54437355468196, 0.971884925322954],
            [31.541399909207644, 0.968247789010782],
            [31.5406799499316, 0.966339112321258],
            [31.541594145633308, 0.952555869730272],
            [31.542511330029992, 0.95088305030049],
            [31.54258206876533, 0.949589732331396],
            [31.545907428029594, 0.946832604512736],
            [31.54607778454005, 0.946353323504262],
            [31.545211030665126, 0.94494203067033],
            [31.54519422767775, 0.944164205223983],
            [31.54642559155682, 0.941840313366927],
            [31.54782935112207, 0.940194821721363],
            [31.54873266642906, 0.940113801896232],
            [31.550906210327593, 0.941489465332099],
            [31.555508257070247, 0.939483528076996],
            [31.560733060883617, 0.938228524654312],
            [31.564983815146235, 0.935625478674273],
            [31.566892117084084, 0.933690435365769],
            [31.569896028596943, 0.935653631714346],
            [31.57507002639277, 0.934911775140749],
            [31.57588345178087, 0.934065260624126],
            [31.582270646825805, 0.930251070509632],
            [31.585981466890267, 0.926906085818692],
            [31.590495124798856, 0.919905666779412],
            [31.60260297842266, 0.923864203150936],
            [31.604338014206785, 0.924058955036734],
            [31.60698903244178, 0.923671878186985],
            [31.608579439465178, 0.923963604083643],
            [31.61330196466049, 0.926148695766163],
            [31.625013431275264, 0.927754345455394],
            [31.627519524305463, 0.92828900916583],
            [31.62770602354159, 0.928782379973009],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1223,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "NTWETWE  TOWN COUNCIL",
        Population: 10147,
        Key: "KYANKWANZINTWETWE  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.845930418271468, 1.034841518488636],
            [31.845943819338867, 1.040467812397906],
            [31.844306913719706, 1.048267052615508],
            [31.841014641204033, 1.055694691802072],
            [31.83715372702864, 1.059254419712085],
            [31.829435008645394, 1.058064428784618],
            [31.825147975920032, 1.054393711692431],
            [31.81593012114288, 1.04856284077051],
            [31.809252320205193, 1.064072376655584],
            [31.805142062453047, 1.061880911272592],
            [31.791359593731094, 1.056710636813792],
            [31.771050895012774, 1.051772942290022],
            [31.770510795524594, 1.052874761107756],
            [31.750566263042657, 1.048427067880871],
            [31.703560852195803, 1.050967513679127],
            [31.703195482216916, 1.05104876520107],
            [31.702605903522905, 1.054132860844226],
            [31.70142819781239, 1.056113218574695],
            [31.700960797183544, 1.057768254423408],
            [31.692479665143935, 1.057909379054475],
            [31.67596373170858, 1.057431976189348],
            [31.67492008607947, 1.054500981115246],
            [31.670254369444404, 1.052047811877196],
            [31.66817551516336, 1.050138449664296],
            [31.66740450642636, 1.049930086293817],
            [31.66738475696484, 1.048826603934367],
            [31.665844177693607, 1.045678330017472],
            [31.663440333604008, 1.044013045973937],
            [31.66196028371496, 1.041832602264785],
            [31.660936639973958, 1.039426235603096],
            [31.659598053182567, 1.03805989176351],
            [31.659334817159912, 1.037019623704202],
            [31.655451706512196, 1.031346857758439],
            [31.652023286230335, 1.030205748149721],
            [31.650521621078898, 1.030693525419258],
            [31.649608550067924, 1.030448924994091],
            [31.64868538648473, 1.030828411679659],
            [31.648056509191992, 1.030538708761324],
            [31.64564201198144, 1.030890420430848],
            [31.645215425409223, 1.031659043586418],
            [31.64395750373709, 1.031477607021442],
            [31.641178171943558, 1.03068047051918],
            [31.637132054801, 1.027458793484918],
            [31.634677045367756, 1.02735824325671],
            [31.632333167416657, 1.028080809970082],
            [31.630284024015314, 1.027736224077605],
            [31.62551754425316, 1.024179586198585],
            [31.623985622944616, 1.024540710509165],
            [31.623336599135012, 1.024106283705071],
            [31.620881100119938, 1.025190581656107],
            [31.619366173139955, 1.025217056158735],
            [31.61498783205588, 1.023523794097078],
            [31.612123813385587, 1.01853318398316],
            [31.619782058082222, 1.009352854930728],
            [31.6285418151836, 0.99737233952611],
            [31.632157771357413, 0.99710251660809],
            [31.63538337091274, 0.993549281620829],
            [31.636072448804228, 0.993558613713368],
            [31.635937783258314, 0.987109650975527],
            [31.63453457346203, 0.983129381240358],
            [31.652482404392277, 0.978939949314028],
            [31.663053379803827, 0.977614628013588],
            [31.675745044039182, 0.976914202991224],
            [31.675782161528385, 0.975349450792121],
            [31.675020222182518, 0.972798486399505],
            [31.675584000363227, 0.969388782731673],
            [31.675517279792146, 0.963319629976984],
            [31.674368666022097, 0.961501154726641],
            [31.673797973508627, 0.957412639088426],
            [31.675003687791374, 0.955332783704591],
            [31.675462506814316, 0.951696912369958],
            [31.675441584153052, 0.951335108294787],
            [31.67475484008463, 0.951090630451246],
            [31.674821062989054, 0.947536011423096],
            [31.676494240782752, 0.946342729320749],
            [31.678061579967988, 0.943611770481622],
            [31.67848239845778, 0.941649186677932],
            [31.675575031583442, 0.937849213357172],
            [31.715538679173804, 0.937837116467648],
            [31.721085735629035, 0.939223062433566],
            [31.729875251220864, 0.940646378119002],
            [31.733831025693622, 0.942013641435717],
            [31.737830690054505, 0.942395001958643],
            [31.741370084613298, 0.945209332033497],
            [31.74550808323974, 0.947481175875655],
            [31.74874887330652, 0.949074307558617],
            [31.75596498338998, 0.951718130344501],
            [31.762462164565065, 0.956939575923411],
            [31.766934304137866, 0.959419592571329],
            [31.774585726129917, 0.958979151026608],
            [31.779925726302068, 0.956376039797619],
            [31.78193531957637, 0.953699358477798],
            [31.790303916965424, 0.962973773565276],
            [31.799846411208165, 0.971316977085767],
            [31.813555551351755, 0.98570401655247],
            [31.818182877584828, 0.992815357818694],
            [31.822418591354648, 0.998008947314162],
            [31.82672029716183, 1.008720276771643],
            [31.835154438328942, 1.021396007865899],
            [31.84101497807225, 1.025975152317017],
            [31.844246868529485, 1.03019152472833],
            [31.845930418271468, 1.034841518488636],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1224,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "WATTUBA",
        Population: 20981,
        Key: "KYANKWANZIWATTUBA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Wattuba",
        id2_original: "KyankwanziWattuba",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.378703241647585, 0.803924152777598],
            [33.37379847612891, 0.799634286417446],
            [33.369867322681465, 0.798173677932208],
            [33.36616183232161, 0.797956256420812],
            [33.36215788389511, 0.798821518624601],
            [33.35693215571529, 0.80065896929385],
            [33.35626706374017, 0.801327900872287],
            [33.35398674608701, 0.801780679329678],
            [33.351292257477105, 0.803014909963397],
            [33.34825181507491, 0.80571428977128],
            [33.346553415282976, 0.809561919158269],
            [33.34508069025674, 0.811640734261123],
            [33.33667356682013, 0.82148523218465],
            [33.3260066243868, 0.819469712784212],
            [33.322467415779265, 0.8157622337817],
            [33.3186431483759, 0.813273725224174],
            [33.317716785892, 0.81222133438329],
            [33.31662413357087, 0.811790360604369],
            [33.3157215009835, 0.811957125076695],
            [33.31251472472665, 0.815708200204231],
            [33.310460037821684, 0.816734821884095],
            [33.30725326785304, 0.819242834120548],
            [33.30366647009505, 0.820627073475625],
            [33.29621961066287, 0.827028931953787],
            [33.29269211608666, 0.831807711950456],
            [33.28623470063425, 0.839167433792787],
            [33.283297467471684, 0.836009069287239],
            [33.281563269815685, 0.832274453404657],
            [33.281195207585895, 0.830410751391588],
            [33.28157570339754, 0.820087222465575],
            [33.281314463431436, 0.81817465047527],
            [33.27883242009807, 0.810475648941854],
            [33.27872566700463, 0.805168658475931],
            [33.27863637177045, 0.804824261322435],
            [33.28052482722873, 0.802817432943322],
            [33.28266271879025, 0.799495992568354],
            [33.284693733290844, 0.795696378405526],
            [33.2865228433465, 0.791753211093782],
            [33.28719988740644, 0.788932852092743],
            [33.28760376366997, 0.786160122559023],
            [33.28739001044643, 0.785084258487478],
            [33.28502674415655, 0.778150289736545],
            [33.284868690972196, 0.770916011119304],
            [33.28718856593892, 0.767896404334748],
            [33.29539547735659, 0.761327747952183],
            [33.296756886746074, 0.759590897850427],
            [33.302719809278976, 0.762706045932749],
            [33.302240689228924, 0.767282407042958],
            [33.299321321760694, 0.77422873623584],
            [33.30130029416193, 0.773634519854606],
            [33.30383069650202, 0.773716506107085],
            [33.30657317670766, 0.77174426988859],
            [33.30755266735409, 0.77151412711383],
            [33.309087253065755, 0.77184268846626],
            [33.31006124512436, 0.772297817208226],
            [33.30941467820705, 0.773737694534206],
            [33.31081767959417, 0.774478454958282],
            [33.317288443113384, 0.776413394380916],
            [33.32070413516597, 0.780104128973314],
            [33.322004498642, 0.784690927625104],
            [33.3244283374332, 0.783186452342095],
            [33.32497387442378, 0.781882813034734],
            [33.327476186444926, 0.781630720724181],
            [33.331667704899374, 0.783078788533239],
            [33.34029179842656, 0.785207177798888],
            [33.34044166616206, 0.779378113118521],
            [33.341993125828004, 0.779869201771001],
            [33.34417842418202, 0.779535885800805],
            [33.344986032080314, 0.778914861525245],
            [33.34898844798094, 0.778845638356194],
            [33.35017610253321, 0.778487807747375],
            [33.34823872392628, 0.776724796413705],
            [33.34776368582087, 0.774931628862319],
            [33.347836482596556, 0.773251179872473],
            [33.3454834328464, 0.770961997105445],
            [33.343281532727595, 0.766681760127811],
            [33.34708690406899, 0.765901416724184],
            [33.349862917485844, 0.765979906296425],
            [33.34994099994866, 0.764562988840591],
            [33.34915896888311, 0.763854597304895],
            [33.34868961980842, 0.761807986199717],
            [33.34895996150495, 0.75854882140751],
            [33.355832550433895, 0.756414233558436],
            [33.35761875425662, 0.754893243188387],
            [33.36353384778883, 0.748066811199152],
            [33.362333759654696, 0.746378286459562],
            [33.36170816839925, 0.746181545152803],
            [33.35748552062525, 0.746024460197094],
            [33.35389757482032, 0.746942319475799],
            [33.35043664450834, 0.746449592268903],
            [33.349749020989286, 0.74605747946767],
            [33.3492356634488, 0.745080522144561],
            [33.3473419636259, 0.743833320251998],
            [33.34222553346673, 0.741580505159911],
            [33.34159400973715, 0.741588466261403],
            [33.33887913476022, 0.743679567681547],
            [33.33678941805074, 0.744521448069759],
            [33.33628785179668, 0.743579880149726],
            [33.332729909722254, 0.740725084138602],
            [33.33133604959142, 0.740622253597611],
            [33.32682325047222, 0.742080167323099],
            [33.324355126534186, 0.743687164093959],
            [33.324096113491684, 0.744666811952966],
            [33.32224504591554, 0.7475067215958],
            [33.32066335883859, 0.749233592600469],
            [33.31883438622519, 0.748945578709902],
            [33.3164946953216, 0.749422196628387],
            [33.314451949721715, 0.748727659747142],
            [33.313083470590904, 0.748803077654508],
            [33.31404484670967, 0.744281150149027],
            [33.313539040407484, 0.736929156195132],
            [33.314798518860016, 0.732054905432549],
            [33.316387246932145, 0.730498282382589],
            [33.317205545680636, 0.728909483743972],
            [33.319232646221536, 0.72767255053042],
            [33.319822105439634, 0.725760784863737],
            [33.32067706533321, 0.725447858473805],
            [33.32031840037959, 0.724613306853565],
            [33.32190869601192, 0.723677440385114],
            [33.322927764633135, 0.722456772937455],
            [33.32416336227216, 0.722262087556464],
            [33.324947328308824, 0.721164337253189],
            [33.323799242748166, 0.719781923163002],
            [33.324202787533345, 0.714838596814062],
            [33.323056750131535, 0.712836517932101],
            [33.32336253126436, 0.711546355687443],
            [33.32262851604907, 0.70796729126753],
            [33.323123967470984, 0.706485564819722],
            [33.32267130729764, 0.706081042861118],
            [33.32257190691482, 0.70436234018778],
            [33.32304563168326, 0.70369243171674],
            [33.3228892008563, 0.702928894303428],
            [33.323791397760786, 0.70249645539391],
            [33.32468899888424, 0.699989545818028],
            [33.32659948821979, 0.701365013391618],
            [33.33214088708538, 0.706643743418004],
            [33.33514241806276, 0.708602445064064],
            [33.33651983902388, 0.70876805837689],
            [33.337187483112714, 0.710826830933081],
            [33.33689110284932, 0.717135236289264],
            [33.337912312155886, 0.723676305903412],
            [33.33920042620473, 0.72463871905878],
            [33.34279557649823, 0.725534899144992],
            [33.34486151570048, 0.725607425101898],
            [33.34641606916426, 0.728259845013501],
            [33.34715234364248, 0.732722255146792],
            [33.347772063509204, 0.733388904133091],
            [33.34777724768672, 0.735442132372633],
            [33.34839285057451, 0.736525053727161],
            [33.353262531491445, 0.737860957159565],
            [33.35564309394384, 0.739238579870058],
            [33.358890562086415, 0.740327102625172],
            [33.359819790196084, 0.741183816290857],
            [33.36134129913217, 0.741250885185557],
            [33.36272180580628, 0.741962990124875],
            [33.36324687198817, 0.742797038189315],
            [33.36455600661466, 0.74348548863663],
            [33.3647972132516, 0.744869515840376],
            [33.36565910903746, 0.745447822071744],
            [33.368182241311935, 0.743952122315983],
            [33.36954928852816, 0.744043528969073],
            [33.3717824670868, 0.743535462199539],
            [33.372925022618595, 0.744152782741316],
            [33.376681031535085, 0.744237016049601],
            [33.37799034851958, 0.744997091878376],
            [33.37930986048424, 0.745088628754501],
            [33.38002539645581, 0.746041480930482],
            [33.38164264783484, 0.746370868801378],
            [33.38630469754692, 0.750159003595447],
            [33.38679010400732, 0.751636610723327],
            [33.38859530629999, 0.754195534602673],
            [33.391625257278015, 0.763238095153535],
            [33.391007449924516, 0.775982857901035],
            [33.39040219023891, 0.77886894838228],
            [33.38822839571042, 0.785319754876068],
            [33.38579056026878, 0.790134960482295],
            [33.381920825535616, 0.796656403288594],
            [33.378703241647585, 0.803924152777598],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1226,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "BULONGO",
        Population: 28247,
        Key: "LUUKABULONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.52113525764304, 0.298483785452428],
            [32.52753759469041, 0.297496660798699],
            [32.52668129001888, 0.297055028],
            [32.53019903517932, 0.289318780572768],
            [32.52996607058509, 0.288696044899081],
            [32.530456026114095, 0.286095132376733],
            [32.53156191780588, 0.283413164370346],
            [32.53318845956159, 0.28184054066463],
            [32.535126154375504, 0.279039873295772],
            [32.535336686240456, 0.277380262559978],
            [32.53630098547714, 0.276867667396841],
            [32.53731452317116, 0.27515308009543],
            [32.541748477157874, 0.271292313124145],
            [32.54742107676734, 0.271412129073012],
            [32.557498331810514, 0.273045706859619],
            [32.56513074095957, 0.274309270808422],
            [32.57650090256363, 0.279318321677181],
            [32.574423923964886, 0.281765589737169],
            [32.5714899983992, 0.286594054946358],
            [32.56849397499281, 0.28553343449645],
            [32.5703099040683, 0.289762778910736],
            [32.57264152181244, 0.293262293280848],
            [32.57138916250854, 0.293370048380428],
            [32.570818588572685, 0.294817716492163],
            [32.57301282516375, 0.296491339127653],
            [32.57370261541931, 0.297956689929703],
            [32.5733297615758, 0.299991391262763],
            [32.57222420854889, 0.302109317277025],
            [32.57012148603073, 0.303226989152061],
            [32.566532607774526, 0.303687026126378],
            [32.56478306509684, 0.303369418638036],
            [32.5616308893413, 0.306432115655692],
            [32.56587454511653, 0.31184553538891],
            [32.564105087687324, 0.316416122706369],
            [32.563300551128954, 0.320162587603675],
            [32.56050270415912, 0.324640355197346],
            [32.563891465617786, 0.327265980486022],
            [32.5635956081739, 0.328067177480959],
            [32.56205403356935, 0.329145047364514],
            [32.55956175303499, 0.33400096562514],
            [32.55676684086117, 0.346402877011996],
            [32.554646760196796, 0.347805072031974],
            [32.55355820598999, 0.348037142117049],
            [32.55354487768612, 0.348551437877659],
            [32.54809072499757, 0.349133410529143],
            [32.54189889556063, 0.347136785360732],
            [32.53848111312836, 0.344866079763266],
            [32.53701085307926, 0.344431344353464],
            [32.533396658501715, 0.343263895070619],
            [32.52902854024558, 0.339491824756978],
            [32.525288934566156, 0.334884271182314],
            [32.52304269989316, 0.326492110632682],
            [32.51759834872264, 0.317278645802342],
            [32.51300253449145, 0.312651495486431],
            [32.511517061473, 0.310221116931532],
            [32.510371548687296, 0.307316828536407],
            [32.51133159170617, 0.305267020925424],
            [32.51293331570554, 0.303514468471037],
            [32.51995331727427, 0.30100476679733],
            [32.520477795059634, 0.300498152702646],
            [32.52113525764304, 0.298483785452428],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1701,
        District: "KAMPALA",
        County: "KCCA",
        Subcounty: "RUBAGA DIVISION",
        Population: 383216,
        Key: "KAMPALARUBAGA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.563891465617786, 0.327265980486022],
            [32.56050270415912, 0.324640355197346],
            [32.563300551128954, 0.320162587603675],
            [32.564105087687324, 0.316416122706369],
            [32.56587454511653, 0.31184553538891],
            [32.5616308893413, 0.306432115655692],
            [32.56478306509684, 0.303369418638036],
            [32.566532607774526, 0.303687026126378],
            [32.57012148603073, 0.303226989152061],
            [32.57222420854889, 0.302109317277025],
            [32.57710459738403, 0.301104446078497],
            [32.57729421736745, 0.303994560937917],
            [32.57805036886798, 0.30728744147288],
            [32.5795311984947, 0.307276852284617],
            [32.580165357881306, 0.30605081141706],
            [32.5832325062986, 0.308382008475326],
            [32.58689487482989, 0.308773308039746],
            [32.58701263138724, 0.308333051899685],
            [32.59407673125325, 0.314724308073789],
            [32.59792259685101, 0.314605840040715],
            [32.60195646187142, 0.315276488743902],
            [32.60532130029575, 0.31454013914942],
            [32.606092960311344, 0.31616900712358],
            [32.608619383114714, 0.314784082867446],
            [32.60729723279808, 0.313304067786785],
            [32.60958064694404, 0.311841378047354],
            [32.61084383274376, 0.312009624616837],
            [32.61276778243552, 0.310646265348839],
            [32.6114601551821, 0.314100550688402],
            [32.611043939659794, 0.314277120885894],
            [32.61218604783056, 0.320967964057677],
            [32.60802026970228, 0.322830346166461],
            [32.60667807886996, 0.325572448300631],
            [32.603008081845296, 0.328808285295441],
            [32.601365668655134, 0.335201207565406],
            [32.599231091876995, 0.338078984566688],
            [32.59643906599021, 0.339973460606068],
            [32.59538604374617, 0.342027251448703],
            [32.596276877860596, 0.344670127509728],
            [32.59801149233488, 0.347966000452073],
            [32.59338732547666, 0.345122053656396],
            [32.58920464824124, 0.347996979181585],
            [32.58625690389154, 0.348179146972799],
            [32.58556437287607, 0.348156957198361],
            [32.586863596390025, 0.345225330192125],
            [32.58678741835559, 0.344677618425345],
            [32.58349181668348, 0.34211113643155],
            [32.58453539404061, 0.339335257438374],
            [32.58706849761473, 0.339933963276569],
            [32.58317650083223, 0.336682184211644],
            [32.58047389863867, 0.337132953723127],
            [32.579111476847864, 0.336637394086475],
            [32.57731912226038, 0.334873911987396],
            [32.57613708307693, 0.332457263867286],
            [32.573307395321834, 0.329796378058795],
            [32.569907485770486, 0.328116364826216],
            [32.56662426917116, 0.32767220100578],
            [32.56514582457153, 0.327860087759593],
            [32.563891465617786, 0.327265980486022],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1704,
        District: "KAMPALA",
        County: "KCCA",
        Subcounty: "CENTRAL DIVISION",
        Population: 75168,
        Key: "KAMPALACENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.888771696764046, 0.527968830980187],
            [32.890016100587786, 0.537592071037031],
            [32.89046611522261, 0.538578119917329],
            [32.892901566535485, 0.539937302368267],
            [32.894278109842574, 0.541696213371126],
            [32.895561951503915, 0.546213370555661],
            [32.89646200862137, 0.546826332358276],
            [32.89944011063779, 0.55062397559897],
            [32.901266640731954, 0.555420966860762],
            [32.900485653508774, 0.55807260550661],
            [32.90096212083379, 0.560444443715338],
            [32.90012815546675, 0.565068166550837],
            [32.900525200940855, 0.567573252366045],
            [32.899386826168396, 0.570424757922015],
            [32.899030424071, 0.572843628115074],
            [32.89834640998275, 0.574005574876559],
            [32.89646540065988, 0.575511784275643],
            [32.89652947030256, 0.578459717807191],
            [32.89704243438096, 0.580267219902269],
            [32.896636345566876, 0.582424058195117],
            [32.88317979461318, 0.576275715223446],
            [32.87307293648812, 0.572183114591137],
            [32.87010801455355, 0.571330255204021],
            [32.86595181516111, 0.570957062373472],
            [32.862522756177114, 0.569824073450888],
            [32.85592060686109, 0.572419717236812],
            [32.85367078791012, 0.572349358406611],
            [32.843391698490585, 0.567224169791398],
            [32.841346384607306, 0.567150890617826],
            [32.84052132962954, 0.567741001817101],
            [32.83776390774582, 0.573402334302894],
            [32.83008508264601, 0.56996007075901],
            [32.82926074901541, 0.570156588161569],
            [32.823185069948074, 0.577045346488469],
            [32.81863193198106, 0.572168310195172],
            [32.817837815880026, 0.570142909293719],
            [32.81335087386795, 0.565092650739729],
            [32.81131251743655, 0.564106546964573],
            [32.808982946054634, 0.56368007447221],
            [32.80595183086004, 0.563906494657168],
            [32.802404564364416, 0.562254095643383],
            [32.80116042644202, 0.560122079824599],
            [32.799122103248244, 0.558336483877424],
            [32.796752973654506, 0.553632740243521],
            [32.79667358504125, 0.552779947312598],
            [32.79537293500265, 0.55121643834357],
            [32.79552524795231, 0.550148422243014],
            [32.79414553898219, 0.550607912666835],
            [32.7939043071924, 0.54925241285056],
            [32.79284025633162, 0.549116353081498],
            [32.79085259991654, 0.546316698168092],
            [32.78742537439402, 0.544772280338104],
            [32.787277161355306, 0.544004753981111],
            [32.78891987098948, 0.543246458199418],
            [32.78717584845923, 0.540583190190664],
            [32.78568054787159, 0.540077032697729],
            [32.78695676822606, 0.538305075569331],
            [32.78901231931034, 0.537906685819734],
            [32.78960887701577, 0.536967306752138],
            [32.79133392353397, 0.536037064803351],
            [32.792478126575965, 0.534194220830967],
            [32.793360213794486, 0.532692740233938],
            [32.79238259074552, 0.531937368733295],
            [32.79261499119771, 0.529862507605342],
            [32.79225348397458, 0.529248159853654],
            [32.79409080912349, 0.528083915552161],
            [32.79512113992345, 0.526332659367396],
            [32.79924227896864, 0.524870551966425],
            [32.800863753327825, 0.522915279810262],
            [32.80477522738236, 0.519601393533097],
            [32.80509296419329, 0.517336182169048],
            [32.80383559857833, 0.515057596418795],
            [32.801532564328234, 0.513138749148083],
            [32.79533808396289, 0.511779420730722],
            [32.78973925220791, 0.509900437233453],
            [32.78658912640782, 0.507555164121642],
            [32.7830592512961, 0.503184894626518],
            [32.782324648582644, 0.498879615546155],
            [32.78266383087434, 0.496793381307844],
            [32.784491393132775, 0.493133026842439],
            [32.785960943512805, 0.491274419118789],
            [32.78882463160308, 0.489188264236378],
            [32.80048648965461, 0.484693707832057],
            [32.80210673152524, 0.483479938560176],
            [32.802973393772, 0.482076486634533],
            [32.804216824720285, 0.481507547086365],
            [32.811402323812146, 0.481102251412091],
            [32.813561300630006, 0.480559516514453],
            [32.81626746823691, 0.480494001989959],
            [32.821687947577026, 0.484684074643644],
            [32.821933524517846, 0.483541123330465],
            [32.82339950499291, 0.481850312322909],
            [32.82897845074245, 0.476552144257594],
            [32.83024558733276, 0.475684118694669],
            [32.83074101539849, 0.475729473070079],
            [32.832504257384244, 0.476409524570053],
            [32.83521657216261, 0.480433971486886],
            [32.835974337935696, 0.479525866787185],
            [32.837707017438866, 0.479649158037351],
            [32.837908878764665, 0.47994673789724],
            [32.83832248108777, 0.481029392525915],
            [32.837122904095025, 0.483277933506511],
            [32.83666786158955, 0.485359930270296],
            [32.8530132956823, 0.492082653026912],
            [32.85366716680118, 0.491837309709172],
            [32.85490307885056, 0.49209927483987],
            [32.8566594029103, 0.491182533825513],
            [32.86114774809084, 0.490527787521055],
            [32.86348952128923, 0.488890728798163],
            [32.866676906512375, 0.487908529483711],
            [32.871750684661855, 0.487319271268763],
            [32.873376888651016, 0.48751575445755],
            [32.87467782165897, 0.489283854972434],
            [32.87644796450273, 0.494182383637141],
            [32.88357327826719, 0.496145738268453],
            [32.885020952873404, 0.497977936952631],
            [32.88597226875928, 0.49997668542518],
            [32.88696492331791, 0.503474484129994],
            [32.88878486516779, 0.505556528457517],
            [32.89078423741082, 0.512727850152263],
            [32.89122092823336, 0.518923929934875],
            [32.889261923584236, 0.521242424791225],
            [32.888653029315, 0.522841400047953],
            [32.88842798337002, 0.524507006438644],
            [32.888771696764046, 0.527968830980187],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1920,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "KIMENYEDDE",
        Population: 35612,
        Key: "MUKONOKIMENYEDDE",
        Dist2: "Mukono",
        "Sub Country": "Koome",
        id2_original: "MukonoKoome",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.22632389119315, 0.405029652509269],
            [33.23889944997465, 0.424634715116294],
            [33.23027076246311, 0.42760703871052],
            [33.227365984533435, 0.426668019905646],
            [33.22175428261538, 0.423891419122813],
            [33.2199662076019, 0.425811430815635],
            [33.21860502638451, 0.42666015806827],
            [33.21656118124671, 0.42481077378648],
            [33.21627581163377, 0.423642624933498],
            [33.215210559725435, 0.423853306444905],
            [33.21473501227528, 0.424332072019828],
            [33.214677966559805, 0.425117229209344],
            [33.21586695690692, 0.427953492191096],
            [33.21544386298451, 0.428145759533815],
            [33.2148547891437, 0.432922742277697],
            [33.21246940992477, 0.436550771574863],
            [33.21212878134544, 0.43777216453403],
            [33.21281047328869, 0.440757748908935],
            [33.212522900108375, 0.441137743885264],
            [33.209570418942135, 0.442051604321502],
            [33.20341527400646, 0.445788308572395],
            [33.20209251103878, 0.446195473808995],
            [33.20026112734716, 0.446150288123669],
            [33.198279471678156, 0.445354180296333],
            [33.19801883448163, 0.444820396799358],
            [33.20245598197916, 0.435312628015717],
            [33.20383461027601, 0.434100253484229],
            [33.203066994475854, 0.431476560494911],
            [33.203247537881666, 0.430019942104234],
            [33.20409004173548, 0.429051858520682],
            [33.2019232414898, 0.425414905626745],
            [33.20047918709415, 0.426989173081206],
            [33.1977299039469, 0.425576811712267],
            [33.19754928687926, 0.424246863761618],
            [33.19502505596517, 0.423704091374635],
            [33.19561112853461, 0.421831286144972],
            [33.19448547210999, 0.42032041633476],
            [33.19582551866369, 0.414864863449436],
            [33.19668907004464, 0.413263470526049],
            [33.19992598298265, 0.410096836382934],
            [33.20555429744523, 0.408151524042665],
            [33.22632389119315, 0.405029652509269],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1923,
        District: "JINJA",
        County: "JINJA MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 21467,
        Key: "JINJACENTRAL DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.313083470590904, 0.748803077654508],
            [33.314451949721715, 0.748727659747142],
            [33.3164946953216, 0.749422196628387],
            [33.31883438622519, 0.748945578709902],
            [33.32066335883859, 0.749233592600469],
            [33.32224504591554, 0.7475067215958],
            [33.324096113491684, 0.744666811952966],
            [33.324355126534186, 0.743687164093959],
            [33.32682325047222, 0.742080167323099],
            [33.33133604959142, 0.740622253597611],
            [33.332729909722254, 0.740725084138602],
            [33.33628785179668, 0.743579880149726],
            [33.33678941805074, 0.744521448069759],
            [33.33887913476022, 0.743679567681547],
            [33.34159400973715, 0.741588466261403],
            [33.34222553346673, 0.741580505159911],
            [33.3473419636259, 0.743833320251998],
            [33.3492356634488, 0.745080522144561],
            [33.349749020989286, 0.74605747946767],
            [33.35043664450834, 0.746449592268903],
            [33.35389757482032, 0.746942319475799],
            [33.35748552062525, 0.746024460197094],
            [33.36170816839925, 0.746181545152803],
            [33.362333759654696, 0.746378286459562],
            [33.36353384778883, 0.748066811199152],
            [33.35761875425662, 0.754893243188387],
            [33.355832550433895, 0.756414233558436],
            [33.34895996150495, 0.75854882140751],
            [33.34868961980842, 0.761807986199717],
            [33.34915896888311, 0.763854597304895],
            [33.34994099994866, 0.764562988840591],
            [33.349862917485844, 0.765979906296425],
            [33.34708690406899, 0.765901416724184],
            [33.343281532727595, 0.766681760127811],
            [33.3454834328464, 0.770961997105445],
            [33.347836482596556, 0.773251179872473],
            [33.34776368582087, 0.774931628862319],
            [33.34823872392628, 0.776724796413705],
            [33.35017610253321, 0.778487807747375],
            [33.34898844798094, 0.778845638356194],
            [33.344986032080314, 0.778914861525245],
            [33.34417842418202, 0.779535885800805],
            [33.341993125828004, 0.779869201771001],
            [33.34044166616206, 0.779378113118521],
            [33.34029179842656, 0.785207177798888],
            [33.331667704899374, 0.783078788533239],
            [33.327476186444926, 0.781630720724181],
            [33.32497387442378, 0.781882813034734],
            [33.3244283374332, 0.783186452342095],
            [33.322004498642, 0.784690927625104],
            [33.32070413516597, 0.780104128973314],
            [33.317288443113384, 0.776413394380916],
            [33.31081767959417, 0.774478454958282],
            [33.30941467820705, 0.773737694534206],
            [33.31006124512436, 0.772297817208226],
            [33.309087253065755, 0.77184268846626],
            [33.30755266735409, 0.77151412711383],
            [33.30657317670766, 0.77174426988859],
            [33.30383069650202, 0.773716506107085],
            [33.30130029416193, 0.773634519854606],
            [33.299321321760694, 0.77422873623584],
            [33.302240689228924, 0.767282407042958],
            [33.302719809278976, 0.762706045932749],
            [33.296756886746074, 0.759590897850427],
            [33.29848352507897, 0.756142322837836],
            [33.29961141381711, 0.755062014790852],
            [33.304475594349555, 0.751350883905046],
            [33.30575826191283, 0.751088742105897],
            [33.30687465580858, 0.751352410011486],
            [33.307967314417894, 0.750683761559274],
            [33.30901244945372, 0.75056490039362],
            [33.31065140682498, 0.750709371228045],
            [33.31160155400269, 0.749921102482985],
            [33.312694194645694, 0.749802272734985],
            [33.313083470590904, 0.748803077654508],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1229,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "LUUKA TOWN COUNCIL",
        Population: 10264,
        Key: "LUUKALUUKA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.313083470590904, 0.748803077654508],
            [33.312694194645694, 0.749802272734985],
            [33.31160155400269, 0.749921102482985],
            [33.31065140682498, 0.750709371228045],
            [33.30901244945372, 0.75056490039362],
            [33.307967314417894, 0.750683761559274],
            [33.30687465580858, 0.751352410011486],
            [33.30575826191283, 0.751088742105897],
            [33.304475594349555, 0.751350883905046],
            [33.29961141381711, 0.755062014790852],
            [33.295793705013615, 0.752294980493968],
            [33.29080079679927, 0.747696756592375],
            [33.288136659567904, 0.743092747702138],
            [33.2864322554366, 0.738694292792525],
            [33.281255972326655, 0.740296246274446],
            [33.2816192519259, 0.739534623765918],
            [33.27999961911303, 0.7377807505436],
            [33.279150645592516, 0.735846931973905],
            [33.27947984310984, 0.731175260585869],
            [33.27934576775706, 0.730410714538992],
            [33.27825110770128, 0.728982865671832],
            [33.27624058467065, 0.727566317145295],
            [33.27479974534541, 0.727127911732104],
            [33.26926821716817, 0.726932646286926],
            [33.26851896832227, 0.723839584136443],
            [33.26633246173422, 0.718507122855473],
            [33.26412449080073, 0.717226561747645],
            [33.26973375648773, 0.713501155073749],
            [33.27283071549775, 0.712728462558757],
            [33.27038427419568, 0.712115361266247],
            [33.26905509905351, 0.711148502749881],
            [33.268474220543055, 0.709641913860086],
            [33.268809193329325, 0.707921645962577],
            [33.268608085690055, 0.706808555564524],
            [33.26771444613699, 0.704773542561164],
            [33.262900398783906, 0.701412025894183],
            [33.26105173689608, 0.698078444141118],
            [33.25887752554931, 0.695930629722272],
            [33.25800317911361, 0.696032650150064],
            [33.25682715774422, 0.700049096083267],
            [33.250567217144116, 0.703608088967306],
            [33.24899935693603, 0.705206206719605],
            [33.24845324951526, 0.706303640157621],
            [33.24651677371514, 0.70749595155385],
            [33.24414406613163, 0.706779099352782],
            [33.24219936805174, 0.702023971656932],
            [33.24463772900779, 0.700479082103282],
            [33.25631637297875, 0.690399871932502],
            [33.25537605157363, 0.6870379165569],
            [33.255609581208134, 0.685365960014478],
            [33.25685162515763, 0.682998639536346],
            [33.25703427331614, 0.679989834847342],
            [33.25769775730689, 0.679152233628764],
            [33.257701411653485, 0.675857457896743],
            [33.26011896583093, 0.673033024248004],
            [33.26251710112691, 0.671951528941318],
            [33.26517480013261, 0.670105252045758],
            [33.26789945506804, 0.666515906510708],
            [33.26720480133358, 0.664393077355685],
            [33.27036555869505, 0.664097202965316],
            [33.274450375260066, 0.662604818622947],
            [33.27960139415094, 0.659724513937116],
            [33.282804659791665, 0.657422997171215],
            [33.2894674651523, 0.650742062592835],
            [33.29795081962389, 0.643575428061515],
            [33.298672607869854, 0.643602526727346],
            [33.30044883590135, 0.645764706603609],
            [33.30583102634915, 0.654467800933921],
            [33.30752182998703, 0.65575240124095],
            [33.313160897283566, 0.657932424257296],
            [33.313501481845435, 0.658378040085347],
            [33.31309068136771, 0.660444448789907],
            [33.31201296533482, 0.661975662665964],
            [33.31190087804525, 0.664673871826117],
            [33.31233192295623, 0.665937963241912],
            [33.31154911484796, 0.666584923894979],
            [33.31136336929836, 0.673079480112377],
            [33.30970067933561, 0.67831306122175],
            [33.309131689129615, 0.67891162959133],
            [33.30906673015477, 0.681442568639002],
            [33.31070483682145, 0.685353200358749],
            [33.31161117046779, 0.6865681215357],
            [33.31377758533622, 0.687874796901454],
            [33.31440035588169, 0.689759065679783],
            [33.316244672618446, 0.690589194299231],
            [33.31852771486191, 0.691012141596223],
            [33.32040984977384, 0.692701661428766],
            [33.322646919834305, 0.693745486672016],
            [33.32390160936804, 0.695475069236152],
            [33.32487115117272, 0.69704973289215],
            [33.32523221642475, 0.698839280413766],
            [33.32468899888424, 0.699989545818028],
            [33.323791397760786, 0.70249645539391],
            [33.3228892008563, 0.702928894303428],
            [33.32304563168326, 0.70369243171674],
            [33.32257190691482, 0.70436234018778],
            [33.32267130729764, 0.706081042861118],
            [33.323123967470984, 0.706485564819722],
            [33.32262851604907, 0.70796729126753],
            [33.32336253126436, 0.711546355687443],
            [33.323056750131535, 0.712836517932101],
            [33.324202787533345, 0.714838596814062],
            [33.323799242748166, 0.719781923163002],
            [33.324947328308824, 0.721164337253189],
            [33.32416336227216, 0.722262087556464],
            [33.322927764633135, 0.722456772937455],
            [33.32190869601192, 0.723677440385114],
            [33.32031840037959, 0.724613306853565],
            [33.32067706533321, 0.725447858473805],
            [33.319822105439634, 0.725760784863737],
            [33.319232646221536, 0.72767255053042],
            [33.317205545680636, 0.728909483743972],
            [33.316387246932145, 0.730498282382589],
            [33.314798518860016, 0.732054905432549],
            [33.313539040407484, 0.736929156195132],
            [33.31404484670967, 0.744281150149027],
            [33.313083470590904, 0.748803077654508],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1230,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "NAWAMPITI",
        Population: 21313,
        Key: "LUUKANAWAMPITI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.422236856160794, 0.728853519637253],
            [33.421556924915485, 0.729410931235286],
            [33.42146461942681, 0.729993526785832],
            [33.42010311571419, 0.730561758468885],
            [33.41613951152543, 0.734445201209778],
            [33.414279249692356, 0.738097623841299],
            [33.41272910605829, 0.739979942617991],
            [33.410994514041896, 0.740939013514239],
            [33.40951046934477, 0.74050007316256],
            [33.408247136221355, 0.741327881428726],
            [33.40651747685416, 0.741423932935531],
            [33.406327021437505, 0.742069952538474],
            [33.40487822124222, 0.743276294005599],
            [33.40438448021261, 0.744425257403191],
            [33.4042818997937, 0.74644579810714],
            [33.40493982051789, 0.748496406421067],
            [33.40486745583187, 0.749527784555972],
            [33.40368318343661, 0.753544813612189],
            [33.40261333215405, 0.755743361848018],
            [33.3993793369441, 0.759290134179538],
            [33.391625257278015, 0.763238095153535],
            [33.38859530629999, 0.754195534602673],
            [33.38679010400732, 0.751636610723327],
            [33.38630469754692, 0.750159003595447],
            [33.38164264783484, 0.746370868801378],
            [33.38002539645581, 0.746041480930482],
            [33.37930986048424, 0.745088628754501],
            [33.37799034851958, 0.744997091878376],
            [33.376681031535085, 0.744237016049601],
            [33.372925022618595, 0.744152782741316],
            [33.3717824670868, 0.743535462199539],
            [33.36954928852816, 0.744043528969073],
            [33.368182241311935, 0.743952122315983],
            [33.36565910903746, 0.745447822071744],
            [33.3647972132516, 0.744869515840376],
            [33.36455600661466, 0.74348548863663],
            [33.36324687198817, 0.742797038189315],
            [33.36272180580628, 0.741962990124875],
            [33.36134129913217, 0.741250885185557],
            [33.359819790196084, 0.741183816290857],
            [33.358890562086415, 0.740327102625172],
            [33.35564309394384, 0.739238579870058],
            [33.353262531491445, 0.737860957159565],
            [33.34839285057451, 0.736525053727161],
            [33.34777724768672, 0.735442132372633],
            [33.347772063509204, 0.733388904133091],
            [33.34715234364248, 0.732722255146792],
            [33.34641606916426, 0.728259845013501],
            [33.34486151570048, 0.725607425101898],
            [33.34279557649823, 0.725534899144992],
            [33.33920042620473, 0.72463871905878],
            [33.337912312155886, 0.723676305903412],
            [33.33689110284932, 0.717135236289264],
            [33.337187483112714, 0.710826830933081],
            [33.33651983902388, 0.70876805837689],
            [33.33514241806276, 0.708602445064064],
            [33.33214088708538, 0.706643743418004],
            [33.32659948821979, 0.701365013391618],
            [33.32468899888424, 0.699989545818028],
            [33.32523221642475, 0.698839280413766],
            [33.32487115117272, 0.69704973289215],
            [33.32390160936804, 0.695475069236152],
            [33.32437189897886, 0.694384968366723],
            [33.323893548784994, 0.693216518329062],
            [33.32229624359851, 0.69135903852942],
            [33.32275244043916, 0.688444929962044],
            [33.322204225570694, 0.68784968810391],
            [33.321820054751264, 0.686322831694737],
            [33.321224826552395, 0.685942608388177],
            [33.32186044929464, 0.683481588002294],
            [33.32284206535504, 0.681544786094092],
            [33.32497936402848, 0.680726665534071],
            [33.328156675544, 0.677565700851614],
            [33.33190892051945, 0.67616976331401],
            [33.33490831440478, 0.673152573677597],
            [33.33604886938839, 0.672982049270745],
            [33.338351468853894, 0.671733688987073],
            [33.33989269850539, 0.670201086747698],
            [33.342818309264814, 0.666205248774134],
            [33.343838746020246, 0.665533708230166],
            [33.3435983379856, 0.664460046748504],
            [33.34513273684767, 0.662450927740745],
            [33.346874849559626, 0.658218923018849],
            [33.34792871083016, 0.652894545431527],
            [33.355026068124616, 0.652789090961361],
            [33.357872906515134, 0.6551778638069],
            [33.36224470067742, 0.654400819729342],
            [33.364836134557905, 0.654584081158122],
            [33.36666805993367, 0.655223227559145],
            [33.36960260533693, 0.654784716659816],
            [33.37071775776095, 0.65396963673683],
            [33.372547634977835, 0.653797053762461],
            [33.37466047881429, 0.652716364482654],
            [33.37708984583773, 0.654619100592103],
            [33.37857440167628, 0.654184910254839],
            [33.38290309826449, 0.655174715417691],
            [33.384113446057505, 0.654407104831395],
            [33.38565392920901, 0.652588011640953],
            [33.38704316032117, 0.652058608570026],
            [33.390585635203074, 0.652334518114945],
            [33.39163042798078, 0.651901637239174],
            [33.39350869564541, 0.652063151056231],
            [33.395860244310754, 0.651387618547708],
            [33.39751952965857, 0.651778863451901],
            [33.39752343733004, 0.653720743253654],
            [33.395620626793544, 0.658311221517448],
            [33.39335929772883, 0.661282519402327],
            [33.393359362407516, 0.662102498113154],
            [33.390683265904755, 0.665499771269924],
            [33.3892437228485, 0.668610292432391],
            [33.38712920814561, 0.66993896818913],
            [33.38736947424645, 0.670952933229035],
            [33.38901121729337, 0.671580695745715],
            [33.3926341560719, 0.670233096022771],
            [33.39561441224839, 0.668413229846509],
            [33.39593425740531, 0.666480394917089],
            [33.4011124314689, 0.666362832263744],
            [33.4055360341686, 0.664803144169486],
            [33.40336855928813, 0.683070854461908],
            [33.40225189859274, 0.683289066680716],
            [33.40060995432316, 0.682840371219595],
            [33.39780353113733, 0.680042255936739],
            [33.396828523982435, 0.679734411489],
            [33.3951160350136, 0.679333669785971],
            [33.39333949616501, 0.679752792421049],
            [33.3898081936303, 0.679209909502432],
            [33.38968094996527, 0.680552980445037],
            [33.39129289679254, 0.684402024295633],
            [33.39124497796034, 0.685589976626692],
            [33.38671129031587, 0.690541998445759],
            [33.38140241497168, 0.691210471588711],
            [33.37956963080653, 0.691974093542031],
            [33.37919832565855, 0.692450794671575],
            [33.379269624942644, 0.699130095531181],
            [33.37969655197637, 0.698431800759066],
            [33.38266691859992, 0.697063666527637],
            [33.39281693718108, 0.696947238210996],
            [33.39491079512402, 0.697349121904568],
            [33.395133963590034, 0.703408991495457],
            [33.39928489346503, 0.703884960292556],
            [33.398413618369275, 0.706614072524205],
            [33.4011702048198, 0.709070887820225],
            [33.40175788267865, 0.711083853283567],
            [33.40338396629358, 0.709580803463504],
            [33.405598491335354, 0.705767118972321],
            [33.40645763558151, 0.703793289643424],
            [33.40728228362246, 0.700132395132454],
            [33.40973281405568, 0.695232215008503],
            [33.40990650241754, 0.693084591519677],
            [33.41181823232648, 0.692623507422285],
            [33.41409326249593, 0.690110215020515],
            [33.417316419531986, 0.688869291295627],
            [33.41908593984326, 0.687564871709381],
            [33.424426376596635, 0.68683273722879],
            [33.426051594235624, 0.688222677647582],
            [33.425904727771496, 0.688603407385842],
            [33.42698289026708, 0.689610723251616],
            [33.42670218380877, 0.690140671089101],
            [33.42709328872394, 0.69074121413241],
            [33.42722388041005, 0.693446329179422],
            [33.42844745769225, 0.696661079480806],
            [33.4279512525838, 0.69807929837555],
            [33.42819698672978, 0.698891822559154],
            [33.42737493751497, 0.700653259602453],
            [33.43057879604375, 0.703378276817307],
            [33.43177224472963, 0.705997494205391],
            [33.43123618047374, 0.706800620451113],
            [33.4325796738632, 0.708783293536645],
            [33.43222221085544, 0.710073438588282],
            [33.43276536192064, 0.710812120355824],
            [33.432650373971, 0.712024950120613],
            [33.431321830344494, 0.714572179924258],
            [33.431296940722916, 0.716469807421605],
            [33.43058004739694, 0.716853437985985],
            [33.43079567181123, 0.717322778147604],
            [33.42987450158966, 0.718647679278015],
            [33.430008734147606, 0.719240665308151],
            [33.43141259791745, 0.720159063634124],
            [33.43206611959169, 0.721388746476207],
            [33.43120620638766, 0.723632494070097],
            [33.42821012279416, 0.726206859609435],
            [33.42399837068626, 0.72799252617553],
            [33.422791558662226, 0.729042209863711],
            [33.422236856160794, 0.728853519637253],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1231,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "BUKANGA",
        Population: 41663,
        Key: "LUUKABUKANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.498915995927305, 0.692856413669547],
            [32.49677552889583, 0.694122763097002],
            [32.49209067095872, 0.694646982294782],
            [32.48929615494195, 0.695515187735819],
            [32.48817875493308, 0.694700837727345],
            [32.48305426508915, 0.693677966159746],
            [32.48153244264108, 0.692917852145557],
            [32.480438506627436, 0.693297703917878],
            [32.47636005462622, 0.693378672128956],
            [32.474520028243234, 0.692699944873705],
            [32.47328388353021, 0.6914603727929],
            [32.47097745634328, 0.690048789083683],
            [32.46908762466601, 0.687732556230803],
            [32.4666278272123, 0.681553214390064],
            [32.46439276847977, 0.679897372376459],
            [32.4605643625379, 0.67931793779794],
            [32.459779739832754, 0.678820267458827],
            [32.45951836511935, 0.67800601341377],
            [32.46198030595334, 0.674912237175901],
            [32.46447736911828, 0.67419780713895],
            [32.46473960890929, 0.672252742975423],
            [32.46670213854756, 0.669756001955257],
            [32.46663085812807, 0.669258412379789],
            [32.461293545715264, 0.662970199188137],
            [32.45103125479153, 0.668071525869273],
            [32.44998535888266, 0.665873005061223],
            [32.44708478147524, 0.663647135000283],
            [32.44417167975614, 0.662941146023547],
            [32.442625842645526, 0.663655676507338],
            [32.441365760525144, 0.663148905250059],
            [32.43970141406901, 0.661312193271118],
            [32.434386823642996, 0.660741629461927],
            [32.4329603340061, 0.659094929147252],
            [32.43200964334767, 0.65698689379137],
            [32.431156781020285, 0.656525403853681],
            [32.428207962285484, 0.656380313899132],
            [32.42737587709234, 0.655955013758258],
            [32.423058534310975, 0.660577468765918],
            [32.41629152976727, 0.666511416136461],
            [32.413675727288066, 0.666900117792515],
            [32.411515721000896, 0.666380893467582],
            [32.40703002585046, 0.663551976556797],
            [32.40423604612792, 0.662683139290956],
            [32.40162000379853, 0.662800429860539],
            [32.39605445462484, 0.661623658846771],
            [32.39486573916219, 0.660972140694463],
            [32.39427125117515, 0.660546866096432],
            [32.3931779556603, 0.658131227182415],
            [32.39088418034584, 0.65481075801754],
            [32.387246128311, 0.652991898520098],
            [32.38079632428399, 0.648883848058948],
            [32.37749178078154, 0.645916085569324],
            [32.374305584927825, 0.644332500127576],
            [32.36882499571876, 0.642386756010308],
            [32.35741227193655, 0.636133999471491],
            [32.35707954134521, 0.63565447866257],
            [32.355295996535716, 0.635265242827665],
            [32.35058882804019, 0.631347401008375],
            [32.347400032462076, 0.630583371799297],
            [32.34427556164819, 0.629745324871988],
            [32.34333903652346, 0.624778542679513],
            [32.34404165112801, 0.620535706990525],
            [32.34368564428934, 0.617523095960481],
            [32.34242579483257, 0.615442187317564],
            [32.340820974340446, 0.61422972373594],
            [32.33956086077903, 0.614301940541058],
            [32.339368246710755, 0.614010037183393],
            [32.339085216310814, 0.613587188511684],
            [32.33608936627931, 0.612863073782249],
            [32.33385438300523, 0.611451503985651],
            [32.33420083626088, 0.60539023878646],
            [32.331717752678365, 0.598125410421071],
            [32.33250520328, 0.59351167544169],
            [32.33168566216149, 0.589431502292384],
            [32.33006916716391, 0.587278186106664],
            [32.32504055720519, 0.585160644428479],
            [32.32330489799025, 0.583812472696092],
            [32.32218766506801, 0.582165835531284],
            [32.32133233237361, 0.579153178227254],
            [32.32094109271118, 0.574783572037205],
            [32.31958682043663, 0.570929514208117],
            [32.320717797582695, 0.565537812565824],
            [32.32372724092108, 0.560173468189442],
            [32.3265931945625, 0.557052685966026],
            [32.33004174519155, 0.555044710798491],
            [32.332967425121254, 0.551987343081844],
            [32.33602175907102, 0.55505613234136],
            [32.33963570571353, 0.557115647704727],
            [32.349847988323724, 0.561057373505513],
            [32.35896641846352, 0.565094014316001],
            [32.364875242653376, 0.566688712063172],
            [32.36978986987725, 0.56693133964009],
            [32.37756730574071, 0.566399774993013],
            [32.38108634537347, 0.567813415948039],
            [32.38735135786168, 0.571608872694828],
            [32.39103685531657, 0.573070472822667],
            [32.39394980701703, 0.573299715903027],
            [32.40375965515969, 0.570400373463772],
            [32.40972930876901, 0.566505729695712],
            [32.41330858583147, 0.564750164024395],
            [32.41644774140528, 0.563795568870963],
            [32.42352231742417, 0.563429686588983],
            [32.44155665431965, 0.563768794981823],
            [32.44343541965093, 0.563124265169223],
            [32.447573171240705, 0.562887901981851],
            [32.45915310563328, 0.566746742188396],
            [32.46767787782938, 0.568271388707525],
            [32.47321873950243, 0.567725016183091],
            [32.47452738364877, 0.566912208257734],
            [32.476416485894056, 0.570701856480937],
            [32.4771053904107, 0.573723606055935],
            [32.47434463218399, 0.584000698600843],
            [32.471157033161845, 0.587709648509491],
            [32.472546920044145, 0.593536022971052],
            [32.472356319100435, 0.59554442923563],
            [32.47073883865101, 0.596810846885369],
            [32.46430653111081, 0.596267400086403],
            [32.461499872566336, 0.598583139978945],
            [32.45831673457787, 0.599596079715802],
            [32.45879158852864, 0.60005752168425],
            [32.459195242908294, 0.602020747290598],
            [32.46043166070917, 0.603242208847895],
            [32.461774351903095, 0.606128317152004],
            [32.466244095669005, 0.610100375332026],
            [32.4695256000794, 0.611322042564498],
            [32.47215260724514, 0.613964015540703],
            [32.47353085106307, 0.618080520290202],
            [32.468548039014166, 0.622133052996063],
            [32.463482659214286, 0.623371965896026],
            [32.46931378092868, 0.626041414289682],
            [32.472297489330785, 0.628375834138183],
            [32.476054423512046, 0.630077045471594],
            [32.47861003796886, 0.633370400592312],
            [32.47918024539211, 0.635206992458395],
            [32.47858474769868, 0.639088080864751],
            [32.47897644011202, 0.642679766233775],
            [32.48009373591633, 0.644434993215789],
            [32.48140157157891, 0.64493271191819],
            [32.482173679853815, 0.647004547134028],
            [32.484361253640444, 0.648940825441282],
            [32.48895038710089, 0.65026215510921],
            [32.49022212665874, 0.65226166856844],
            [32.49224365225499, 0.652162358163527],
            [32.49314707266485, 0.652714316456708],
            [32.49545392924649, 0.652696457311109],
            [32.49764129642059, 0.653990398145487],
            [32.4980691864483, 0.655157503923844],
            [32.49924611421779, 0.656080416639819],
            [32.50103284804655, 0.656080596291093],
            [32.50263613870776, 0.656596437064001],
            [32.50456081783155, 0.656099044680837],
            [32.50598606330177, 0.656524396908343],
            [32.50717365137872, 0.657601108786991],
            [32.50877470433657, 0.660912473173615],
            [32.50654257321353, 0.663463505620394],
            [32.50137138624619, 0.67163241988111],
            [32.50105026458327, 0.672763261705208],
            [32.501072040644075, 0.676780130496533],
            [32.50001318204565, 0.680181690696121],
            [32.499941342874074, 0.682334868490247],
            [32.49890623842667, 0.684135110741528],
            [32.49826318392211, 0.688703774292339],
            [32.498417094974705, 0.691300277716185],
            [32.498915995927305, 0.692856413669547],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1233,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "MAKULUBITA",
        Population: 32897,
        Key: "LUWEROMAKULUBITA",
        Dist2: "Luweero",
        "Sub Country": "Makulubita",
        id2_original: "LuweeroMakulubita",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49090434770968, 0.867460886379352],
            [32.49664229346787, 0.8714222458886],
            [32.496855572380944, 0.872447945667639],
            [32.4926774846383, 0.876889445343799],
            [32.48884820463566, 0.879599465430072],
            [32.48723068735528, 0.883381251254124],
            [32.48632631652782, 0.888838710085823],
            [32.48566987353227, 0.890467979429963],
            [32.484601591606484, 0.891707262982698],
            [32.484415120218124, 0.89296587551537],
            [32.48269925538046, 0.89472934305901],
            [32.48095176265825, 0.895284559024397],
            [32.47961823428025, 0.895099212493757],
            [32.47906848419098, 0.894568732189736],
            [32.478958931947126, 0.894804952222291],
            [32.478242757273385, 0.890982602486887],
            [32.47738498834793, 0.889164040716754],
            [32.47644130095544, 0.885192293373912],
            [32.473393277670546, 0.880252222008996],
            [32.47121608301871, 0.878134925687998],
            [32.46727228758028, 0.880043264394744],
            [32.46544219117444, 0.880232985959182],
            [32.46111893388529, 0.882286011556646],
            [32.459265483078674, 0.882765227467245],
            [32.457815428835275, 0.882674544319354],
            [32.44132856757745, 0.890009117884691],
            [32.4335691662916, 0.891048315286331],
            [32.42903088286611, 0.892314172078587],
            [32.42338988509004, 0.895832517405409],
            [32.42215885179097, 0.899167486384996],
            [32.42372777650269, 0.902375229825067],
            [32.425915070913284, 0.904912852492192],
            [32.43165194138804, 0.908128736656825],
            [32.435032163461635, 0.912761082581549],
            [32.43725932240956, 0.916687787460664],
            [32.437281738070865, 0.925942763226632],
            [32.4281024928846, 0.932328377440698],
            [32.424791315323745, 0.936498441971394],
            [32.41986773369314, 0.943916052365208],
            [32.4186085768375, 0.944268667799894],
            [32.41124810389459, 0.940730098801722],
            [32.40727723413181, 0.939508095493533],
            [32.40480511358904, 0.93948053080189],
            [32.3974753765036, 0.942003327475461],
            [32.395954243063336, 0.942003061610057],
            [32.39235211196175, 0.941034420457601],
            [32.38880732930786, 0.938175001222991],
            [32.387382793506745, 0.935071693491753],
            [32.38900899300433, 0.933280710657635],
            [32.392721874702346, 0.927102380641077],
            [32.39405929637883, 0.922289702137864],
            [32.394483622789785, 0.919259087927054],
            [32.39460786518348, 0.910284659019545],
            [32.394959846671355, 0.906512191944624],
            [32.39581218707756, 0.903481647969008],
            [32.39898851673449, 0.895864745916291],
            [32.401076119708065, 0.892400152880056],
            [32.41558735029752, 0.872888429284368],
            [32.41697486293253, 0.87049122811364],
            [32.41901324092352, 0.865425299565132],
            [32.422044301320895, 0.855609911015986],
            [32.4336328478621, 0.834749523501019],
            [32.43689162399747, 0.826571600550837],
            [32.44283058576678, 0.816105174881988],
            [32.444587786582254, 0.814721242956957],
            [32.44881678005542, 0.813238135761408],
            [32.45062170207374, 0.812017050162632],
            [32.45184416544497, 0.810578757133782],
            [32.45524675826408, 0.803757838885493],
            [32.45906909159463, 0.799958640056105],
            [32.46154762161695, 0.795553111830065],
            [32.462637187326756, 0.792287310006528],
            [32.46321662314288, 0.7898085248733],
            [32.46323641841848, 0.786560675955682],
            [32.463870478092105, 0.782960076475248],
            [32.467580804083134, 0.782933413373963],
            [32.47119416861736, 0.783449551485594],
            [32.475082571240435, 0.785567033345491],
            [32.477293654836366, 0.786046801769453],
            [32.47869570580597, 0.785730335303946],
            [32.48062117724381, 0.786119597083307],
            [32.48534277897101, 0.789060453764257],
            [32.490966070054554, 0.790816265983452],
            [32.49315405706618, 0.791938362241535],
            [32.50077280104315, 0.79388440019586],
            [32.5088821275732, 0.789559327138022],
            [32.51255631793362, 0.790636510451762],
            [32.51350198611131, 0.790415163279596],
            [32.51944819099675, 0.791454153649724],
            [32.52125360619014, 0.792882627666832],
            [32.521823848647664, 0.796809101224081],
            [32.5226638417103, 0.798048564633801],
            [32.52532517709628, 0.798168518509885],
            [32.53145789559092, 0.789803053754726],
            [32.53350286811441, 0.789994781828784],
            [32.53730582119102, 0.788954946757332],
            [32.53844607973059, 0.790586650615833],
            [32.53986057596015, 0.794639885313895],
            [32.54337965511878, 0.797490100228003],
            [32.545678667611334, 0.801672184245537],
            [32.552295289684906, 0.800906935787321],
            [32.55881129954832, 0.795976619450159],
            [32.56057130131084, 0.792709404148283],
            [32.562473690537495, 0.792135118505306],
            [32.5650418337976, 0.792135391567058],
            [32.566750704352465, 0.79304833210122],
            [32.568875740123964, 0.792395439758543],
            [32.569757398846065, 0.791303876245234],
            [32.5716141958771, 0.790952700787859],
            [32.574173092777976, 0.791418237041566],
            [32.57731180368575, 0.79275903850313],
            [32.57888111646969, 0.793860306099663],
            [32.581863119869396, 0.789034229936447],
            [32.59696075360832, 0.788558889232958],
            [32.599691046370474, 0.788865072545138],
            [32.602557166200214, 0.79204993581438],
            [32.59683793953591, 0.796346756085016],
            [32.59416231105544, 0.801069082918059],
            [32.59391223984328, 0.805004549780891],
            [32.59489823339406, 0.811627134234054],
            [32.59776309737904, 0.818982725665247],
            [32.60264899468351, 0.826682316267396],
            [32.60464624151257, 0.828953344539297],
            [32.61143459451898, 0.834952268804189],
            [32.614105377486844, 0.839847031570093],
            [32.61472329084154, 0.84248885558392],
            [32.6181113228682, 0.848170792757494],
            [32.619109836239105, 0.850514099707011],
            [32.61871721766273, 0.853092494341042],
            [32.616255375643455, 0.859615228902343],
            [32.609299201172256, 0.865703231749036],
            [32.603472607865235, 0.872071791888355],
            [32.59963142428675, 0.878350077463367],
            [32.597526379623595, 0.883343854342371],
            [32.5967179434786, 0.884375135910166],
            [32.591925988393285, 0.885704531525053],
            [32.589096108398714, 0.887350788253832],
            [32.58555241360468, 0.890245459468],
            [32.581623962289605, 0.897031897280786],
            [32.57449034180375, 0.893983564540932],
            [32.57318702107378, 0.893858463313963],
            [32.56865667965371, 0.891296489776701],
            [32.56425055547453, 0.888047314014789],
            [32.56356770380623, 0.889359187883712],
            [32.5601195169949, 0.893194824672397],
            [32.55966899032033, 0.892337952091525],
            [32.55935898530906, 0.889714003909402],
            [32.55793170695133, 0.888214455135877],
            [32.557063043258104, 0.886340129466665],
            [32.556939154800666, 0.884340945612003],
            [32.558134012044896, 0.883169700687368],
            [32.55844446172227, 0.882045205367568],
            [32.55794824313911, 0.879608658603585],
            [32.55912774548018, 0.877047363247385],
            [32.559128206315926, 0.873111499090659],
            [32.559935361463324, 0.87023778781928],
            [32.55912893395131, 0.866864093401546],
            [32.559563490376746, 0.865864560635218],
            [32.56006049947736, 0.861491434395584],
            [32.556647436793604, 0.858054963180886],
            [32.55536372987956, 0.855599629147437],
            [32.55149464732329, 0.857681079559661],
            [32.535395197108166, 0.86251025744766],
            [32.534158871833796, 0.862365353151778],
            [32.53325540740644, 0.859569707407249],
            [32.528844713497406, 0.857949742734193],
            [32.524730752889624, 0.857469736835235],
            [32.5200584021962, 0.855116923817352],
            [32.51718131753012, 0.854899430871468],
            [32.511889969215424, 0.856970519857906],
            [32.50844304633368, 0.855226536614256],
            [32.50544684955246, 0.855274021659401],
            [32.50753982984136, 0.852114629226575],
            [32.5112974638102, 0.848093718564606],
            [32.515055262170776, 0.84268446055032],
            [32.51576897276568, 0.839991650180271],
            [32.51576984413149, 0.832906202379876],
            [32.514269957644345, 0.829902173275418],
            [32.50674876891059, 0.823525467855119],
            [32.51776807192085, 0.808424991724145],
            [32.508530124525755, 0.806713989655091],
            [32.50446697352877, 0.804987822106484],
            [32.50218414508435, 0.805370530404746],
            [32.5009475152811, 0.806375724823323],
            [32.49543404054609, 0.813867708659037],
            [32.49692832603747, 0.81797605590578],
            [32.49870773949497, 0.825367670566334],
            [32.49052802726748, 0.832622296468486],
            [32.481063531944216, 0.838673468138155],
            [32.47878463093424, 0.841088701169353],
            [32.475471387248234, 0.843123817634705],
            [32.47055184534147, 0.843702149638894],
            [32.46912067188867, 0.846681027057064],
            [32.47062959902087, 0.84882195770824],
            [32.47138994295882, 0.853130672101503],
            [32.47260076416397, 0.857019035133861],
            [32.47537566816144, 0.859308805816],
            [32.475405716807714, 0.864840028542565],
            [32.47623913689739, 0.865961431976339],
            [32.47699976290633, 0.868211591511107],
            [32.47780510345686, 0.872657728263391],
            [32.480036526707444, 0.871350954850128],
            [32.48245838381514, 0.869152879105481],
            [32.48483427951958, 0.868275651103004],
            [32.485975382475566, 0.868438653248687],
            [32.49090434770968, 0.867460886379352],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1234,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "LUWERO",
        Population: 33551,
        Key: "LUWEROLUWERO",
        Dist2: "Luweero",
        "Sub Country": "Luwero",
        id2_original: "LuweeroLuwero",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.785772684477024, 0.93555332842427],
            [32.77167461154462, 0.926378508680612],
            [32.76550393653429, 0.921076409462484],
            [32.756645963029634, 0.91501415066539],
            [32.755314481912144, 0.913195562282741],
            [32.752342501914384, 0.90634658938287],
            [32.739283575848155, 0.897189857438654],
            [32.727464599758484, 0.901450233308613],
            [32.71972341810322, 0.907276053209758],
            [32.71550237112708, 0.909202779143004],
            [32.71293404820389, 0.909944445268152],
            [32.705003348074854, 0.911056606895211],
            [32.69555048773116, 0.913769974471208],
            [32.6936955349414, 0.914900715994824],
            [32.69004499722242, 0.915913686011685],
            [32.68764330998781, 0.915678247890548],
            [32.68320830856552, 0.916663999523473],
            [32.6800691781445, 0.918274117544845],
            [32.67887983296283, 0.919920598447948],
            [32.67696177801595, 0.929248075461139],
            [32.675929199631156, 0.930369830998121],
            [32.67447458104777, 0.934032637250201],
            [32.66889676897215, 0.939662125969867],
            [32.66618562469859, 0.941624725263344],
            [32.65396315053611, 0.93544770062803],
            [32.64460630751987, 0.928624634075758],
            [32.64070676399066, 0.924602775538299],
            [32.638453685951816, 0.920944994831822],
            [32.63795630674533, 0.919102399686221],
            [32.63441132466546, 0.915103195590332],
            [32.62888985043286, 0.906019292317793],
            [32.62689247604305, 0.904598683437524],
            [32.62030538608447, 0.904055166193115],
            [32.61823641237319, 0.905176791303435],
            [32.615619894835056, 0.912857524249833],
            [32.61428773189624, 0.915616754384615],
            [32.61433518450282, 0.918367086624061],
            [32.615060654943115, 0.921304729897933],
            [32.61440840887656, 0.923745466695613],
            [32.61242017574307, 0.924678122699936],
            [32.60504861938621, 0.923485873836147],
            [32.602195120886186, 0.922528066155042],
            [32.59815297250058, 0.918458293432698],
            [32.593920226764475, 0.917643947614411],
            [32.591743034807564, 0.921117554171629],
            [32.58945430443175, 0.923330692060318],
            [32.58830755376761, 0.922861590723273],
            [32.58141255097403, 0.912639639476832],
            [32.5785593641894, 0.909192363590464],
            [32.577085513574126, 0.904883514479381],
            [32.57892510157923, 0.899148058218027],
            [32.581211946391306, 0.897699767569805],
            [32.581623962289605, 0.897031897280786],
            [32.58555241360468, 0.890245459468],
            [32.589096108398714, 0.887350788253832],
            [32.591925988393285, 0.885704531525053],
            [32.5967179434786, 0.884375135910166],
            [32.597526379623595, 0.883343854342371],
            [32.59963142428675, 0.878350077463367],
            [32.603472607865235, 0.872071791888355],
            [32.609299201172256, 0.865703231749036],
            [32.616255375643455, 0.859615228902343],
            [32.61871721766273, 0.853092494341042],
            [32.619109836239105, 0.850514099707011],
            [32.6181113228682, 0.848170792757494],
            [32.61472329084154, 0.84248885558392],
            [32.614105377486844, 0.839847031570093],
            [32.61143459451898, 0.834952268804189],
            [32.60464624151257, 0.828953344539297],
            [32.60264899468351, 0.826682316267396],
            [32.59776309737904, 0.818982725665247],
            [32.59489823339406, 0.811627134234054],
            [32.59391223984328, 0.805004549780891],
            [32.59416231105544, 0.801069082918059],
            [32.59683793953591, 0.796346756085016],
            [32.602557166200214, 0.79204993581438],
            [32.60885817597848, 0.798202587404121],
            [32.61052242361993, 0.799424109190902],
            [32.61362578043138, 0.800727192372336],
            [32.62018903089895, 0.798999807892029],
            [32.62210316829288, 0.798031942023682],
            [32.624172182428325, 0.795688924005872],
            [32.634480392534385, 0.79711026282966],
            [32.63524152070158, 0.797092236284825],
            [32.63526262212763, 0.796676069102227],
            [32.642904130312175, 0.800956052664363],
            [32.64523968088061, 0.801797644149227],
            [32.648462964579124, 0.800106104794415],
            [32.65187317870512, 0.796514671818949],
            [32.655423322504575, 0.795474548256882],
            [32.65822171744674, 0.793086328095905],
            [32.66070210967664, 0.791530419628056],
            [32.66313124223981, 0.791711563783847],
            [32.6738746950842, 0.794887994988491],
            [32.68335697705009, 0.796182489846866],
            [32.68807465583443, 0.798887966835177],
            [32.691811686043906, 0.800154860593498],
            [32.70348943888607, 0.802137070768234],
            [32.71913726288875, 0.815238572611257],
            [32.72537021899604, 0.818414585778246],
            [32.73944768098254, 0.82168158910679],
            [32.74536669476268, 0.824396148956222],
            [32.76490348283545, 0.825673025641377],
            [32.77135906482635, 0.836674879943],
            [32.7784211722291, 0.84582207712038],
            [32.78317685513984, 0.849622202242769],
            [32.78742133287358, 0.854137030148918],
            [32.78970413796177, 0.855530437839224],
            [32.79113091326292, 0.856010021820088],
            [32.7946496259089, 0.855675464551536],
            [32.79576774187505, 0.866450833006661],
            [32.7958830244721, 0.874493868894323],
            [32.795659346661324, 0.876466162921674],
            [32.79490089727028, 0.878402238298368],
            [32.79178212986013, 0.883604247679301],
            [32.79034891543506, 0.887566871835295],
            [32.78918898019746, 0.891556653511083],
            [32.786613722280315, 0.905516443228217],
            [32.78638221205855, 0.911541911540119],
            [32.786662560987345, 0.915604152630421],
            [32.785772684477024, 0.93555332842427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1235,
        District: "LUWERO",
        County: "BAMUNANIKA",
        Subcounty: "KIKYUSA",
        Population: 34739,
        Key: "LUWEROKIKYUSA",
        Dist2: "Luweero",
        "Sub Country": "kikyusa",
        id2_original: "Luweerokikyusa",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.74623612561713, 0.63710000965477],
            [32.750606138420245, 0.643686628883812],
            [32.75101640529869, 0.644862792384015],
            [32.75177071435455, 0.663165431347646],
            [32.75542254025766, 0.676609842457286],
            [32.755735285130584, 0.679124996826219],
            [32.754014119334414, 0.691881542375964],
            [32.75401353273455, 0.703136331126879],
            [32.76183347058904, 0.723456892824665],
            [32.75854769828276, 0.739669406540771],
            [32.7585474413646, 0.744392076437281],
            [32.759842701511516, 0.750607615213139],
            [32.759699828957146, 0.754172228035264],
            [32.7603059842631, 0.758162102706347],
            [32.76000831222234, 0.762531913059454],
            [32.76142271682369, 0.772692065425225],
            [32.76117291061453, 0.774854346680308],
            [32.75890157341926, 0.780155910252558],
            [32.75919797614052, 0.797979025606534],
            [32.760124494931276, 0.813088001974722],
            [32.76106338621849, 0.818389751690927],
            [32.76490348283545, 0.825673025641377],
            [32.74536669476268, 0.824396148956222],
            [32.73944768098254, 0.82168158910679],
            [32.72537021899604, 0.818414585778246],
            [32.71913726288875, 0.815238572611257],
            [32.70348943888607, 0.802137070768234],
            [32.691811686043906, 0.800154860593498],
            [32.68807465583443, 0.798887966835177],
            [32.68335697705009, 0.796182489846866],
            [32.6738746950842, 0.794887994988491],
            [32.66313124223981, 0.791711563783847],
            [32.66070210967664, 0.791530419628056],
            [32.65822171744674, 0.793086328095905],
            [32.6556265061505, 0.79061623291493],
            [32.65488949056218, 0.78772107570225],
            [32.652785368468805, 0.783513963652015],
            [32.64844603582759, 0.777687222146078],
            [32.64539126799155, 0.769508327351034],
            [32.64278787394138, 0.764351225370906],
            [32.63485803799165, 0.755981933625856],
            [32.63173199153275, 0.747432108488166],
            [32.6321945852765, 0.747115497247133],
            [32.632198910664584, 0.745776519241124],
            [32.637126763784394, 0.742700898684805],
            [32.63821959037867, 0.742465762849525],
            [32.638979815739, 0.743062938718191],
            [32.63976367846939, 0.743108238744554],
            [32.6428770946154, 0.741389533035307],
            [32.646701659361106, 0.74290072021107],
            [32.65121382696468, 0.747135158798693],
            [32.65068382723523, 0.747451767343579],
            [32.65250275848041, 0.74962323406417],
            [32.66042075732966, 0.755459292546712],
            [32.66115799210691, 0.755631247479683],
            [32.661633488353104, 0.755558907050916],
            [32.66402220032173, 0.747868988488565],
            [32.66458254424314, 0.747398579028274],
            [32.66838591773132, 0.74713650166584],
            [32.667869456511525, 0.746684103615642],
            [32.66568594221168, 0.741092775162371],
            [32.661827756219836, 0.734641838841318],
            [32.66148477585107, 0.731665290269864],
            [32.65984542501775, 0.731665164515991],
            [32.65780226798946, 0.73085076161931],
            [32.6582307068878, 0.729059453426188],
            [32.659431193873935, 0.727557713775215],
            [32.66002622624003, 0.725124066910745],
            [32.6617382417967, 0.722346712012749],
            [32.661537322803625, 0.720012524052499],
            [32.66018406023545, 0.717669202442165],
            [32.660316328177885, 0.714050339725336],
            [32.65946351346121, 0.708359599602292],
            [32.65939523521143, 0.701085660955988],
            [32.65637938868169, 0.697882737322875],
            [32.65545353823748, 0.696227035720986],
            [32.65527584518609, 0.695023748442278],
            [32.65293583627889, 0.694290753690023],
            [32.65013306025308, 0.692517299280968],
            [32.649491943414596, 0.691585393004432],
            [32.647591479277615, 0.690743863969905],
            [32.64660538152223, 0.691096629189556],
            [32.64548872711505, 0.69092464935524],
            [32.644939140519156, 0.690363683233597],
            [32.64408496665148, 0.687975166518048],
            [32.64089149264738, 0.683008032551871],
            [32.63931408514444, 0.677425814195781],
            [32.638261062002066, 0.667555282075801],
            [32.63539687624514, 0.653206274721367],
            [32.638252824450916, 0.653369332600107],
            [32.63967844631525, 0.652962313529286],
            [32.640831404337995, 0.651967209111631],
            [32.64237681654548, 0.649461255246255],
            [32.64375501185436, 0.648529495274152],
            [32.64848312726568, 0.648339838928095],
            [32.65672311105886, 0.658762761309359],
            [32.65915840606484, 0.658183910796111],
            [32.66027573510681, 0.656627872441332],
            [32.66260428690089, 0.656320428047037],
            [32.66414904693145, 0.655099163058403],
            [32.66695310305653, 0.654429859469875],
            [32.66789176976489, 0.653461873717475],
            [32.669032304985585, 0.653443855583086],
            [32.67157491273542, 0.652412644022303],
            [32.67474782789595, 0.650151053239364],
            [32.67966612833103, 0.649436642090421],
            [32.68319726377907, 0.644931359141099],
            [32.68701330081781, 0.638363325604444],
            [32.68887908549327, 0.636753037053154],
            [32.690684979488715, 0.6363007865738],
            [32.698874988206, 0.624259429030968],
            [32.70276075966358, 0.625453885557652],
            [32.70636425620442, 0.622007098650923],
            [32.71029741379326, 0.619537425451078],
            [32.71322096202081, 0.616144874523651],
            [32.71566861065861, 0.615330756835812],
            [32.716179841886806, 0.613738471399372],
            [32.717867253486176, 0.612471949008276],
            [32.71988685219612, 0.612300158717984],
            [32.72195421882132, 0.611685055349394],
            [32.723213883225114, 0.610635641154618],
            [32.72499588742391, 0.610391458787183],
            [32.73360811151125, 0.611079487882983],
            [32.73443715860211, 0.617204514363306],
            [32.73791516588762, 0.623745849523674],
            [32.74623612561713, 0.63710000965477],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1236,
        District: "LUWERO",
        County: "BAMUNANIKA",
        Subcounty: "ZIROBWE",
        Population: 44992,
        Key: "LUWEROZIROBWE",
        Dist2: "Luweero",
        "Sub Country": "Zirobwe",
        id2_original: "LuweeroZirobwe",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.59696075360832, 0.788558889232958],
            [32.581863119869396, 0.789034229936447],
            [32.57888111646969, 0.793860306099663],
            [32.57731180368575, 0.79275903850313],
            [32.574173092777976, 0.791418237041566],
            [32.5716141958771, 0.790952700787859],
            [32.569757398846065, 0.791303876245234],
            [32.568875740123964, 0.792395439758543],
            [32.566750704352465, 0.79304833210122],
            [32.5650418337976, 0.792135391567058],
            [32.562473690537495, 0.792135118505306],
            [32.56057130131084, 0.792709404148283],
            [32.55881129954832, 0.795976619450159],
            [32.552295289684906, 0.800906935787321],
            [32.545678667611334, 0.801672184245537],
            [32.54337965511878, 0.797490100228003],
            [32.53986057596015, 0.794639885313895],
            [32.53844607973059, 0.790586650615833],
            [32.53730582119102, 0.788954946757332],
            [32.53350286811441, 0.789994781828784],
            [32.53145789559092, 0.789803053754726],
            [32.52532517709628, 0.798168518509885],
            [32.5226638417103, 0.798048564633801],
            [32.521823848647664, 0.796809101224081],
            [32.52125360619014, 0.792882627666832],
            [32.51944819099675, 0.791454153649724],
            [32.51350198611131, 0.790415163279596],
            [32.51255631793362, 0.790636510451762],
            [32.5088821275732, 0.789559327138022],
            [32.50077280104315, 0.79388440019586],
            [32.49315405706618, 0.791938362241535],
            [32.490966070054554, 0.790816265983452],
            [32.48534277897101, 0.789060453764257],
            [32.48062117724381, 0.786119597083307],
            [32.47869570580597, 0.785730335303946],
            [32.477293654836366, 0.786046801769453],
            [32.475082571240435, 0.785567033345491],
            [32.47119416861736, 0.783449551485594],
            [32.467580804083134, 0.782933413373963],
            [32.463870478092105, 0.782960076475248],
            [32.46263049128463, 0.776581824705917],
            [32.46266005663726, 0.771533636752911],
            [32.46518425341533, 0.76545441273522],
            [32.46687299362301, 0.756416726166112],
            [32.46897069455873, 0.751486399280416],
            [32.46944258945895, 0.748600479940657],
            [32.469193708514545, 0.74433933630649],
            [32.46978875794861, 0.74256620672442],
            [32.47088316018792, 0.740747901236473],
            [32.47603271841815, 0.736650246971931],
            [32.479802414964645, 0.735375071474483],
            [32.48182419029252, 0.733412116494922],
            [32.48566526337822, 0.731756968444498],
            [32.48597458746653, 0.730798024921043],
            [32.48538044533087, 0.729630896444008],
            [32.486141634583525, 0.728834850562968],
            [32.4874257134001, 0.728482166368985],
            [32.48771097162194, 0.729224051881221],
            [32.49018407492162, 0.729649543058919],
            [32.49164928284555, 0.729468770865365],
            [32.493540396418744, 0.733042545715247],
            [32.494193230881805, 0.736760930926041],
            [32.492254095170146, 0.740578535346875],
            [32.49180161555818, 0.743301624364983],
            [32.4918840180192, 0.747191835877067],
            [32.49352887372861, 0.747906739666992],
            [32.49646580326063, 0.747192369430969],
            [32.50064269983719, 0.743872603861765],
            [32.50461684755245, 0.742796463315819],
            [32.51110598790741, 0.736799027123861],
            [32.513291172175364, 0.737803486814931],
            [32.51524784210307, 0.737921314449346],
            [32.51688246420474, 0.737233920367593],
            [32.52014786182211, 0.737022070241384],
            [32.52071848247034, 0.737644491901751],
            [32.52008647724379, 0.738034779325274],
            [32.52152668954495, 0.74013401868351],
            [32.52347641908874, 0.741283202966293],
            [32.52951607301824, 0.742576450251558],
            [32.531846977500024, 0.736975454229851],
            [32.53303609271297, 0.73525211930604],
            [32.53807766446291, 0.730513128530872],
            [32.53908539095538, 0.729048722122277],
            [32.5403112212123, 0.724326290218185],
            [32.54120491286766, 0.718481987275326],
            [32.54301295832821, 0.713506292140503],
            [32.53874899164442, 0.711768829661509],
            [32.537917757155824, 0.710963558367432],
            [32.536612006483, 0.708973076860232],
            [32.53658918657983, 0.706865113682266],
            [32.535485707762916, 0.70427754742855],
            [32.53147181229128, 0.701499701183166],
            [32.52859546244709, 0.697699655381726],
            [32.524141845237146, 0.696975440529295],
            [32.5224895640536, 0.697490951786956],
            [32.521934659431224, 0.696984261332713],
            [32.52036899740063, 0.701075325714082],
            [32.520769627152724, 0.703450616288494],
            [32.52319440109014, 0.709626593369745],
            [32.52319426813946, 0.7109191868051],
            [32.524383095891544, 0.71187678894505],
            [32.52343169286905, 0.714414003393916],
            [32.521814557372686, 0.716280912771254],
            [32.51915119898066, 0.717812592852766],
            [32.517962301160004, 0.717525223676675],
            [32.51729658755073, 0.716711298800621],
            [32.51748692708469, 0.715658094735952],
            [32.51905651026151, 0.713743309514193],
            [32.51991281672969, 0.711062465145576],
            [32.516916977477955, 0.708620585153793],
            [32.51777334592991, 0.705317382779375],
            [32.517470290285644, 0.704183780277596],
            [32.51493539097926, 0.702230806694509],
            [32.510822652978604, 0.707613344324779],
            [32.50700966482191, 0.706807753430021],
            [32.50066647285288, 0.706472329150253],
            [32.49899042673848, 0.705992656246588],
            [32.50007934116969, 0.702726810128917],
            [32.500484442735264, 0.698954256215845],
            [32.499997772345246, 0.695950601390906],
            [32.498915995927305, 0.692856413669547],
            [32.498417094974705, 0.691300277716185],
            [32.49826318392211, 0.688703774292339],
            [32.49890623842667, 0.684135110741528],
            [32.499941342874074, 0.682334868490247],
            [32.50001318204565, 0.680181690696121],
            [32.501072040644075, 0.676780130496533],
            [32.50105026458327, 0.672763261705208],
            [32.50137138624619, 0.67163241988111],
            [32.50654257321353, 0.663463505620394],
            [32.50877470433657, 0.660912473173615],
            [32.51248504110739, 0.657131191466348],
            [32.51547855462085, 0.657294331856902],
            [32.519577979588995, 0.655159635486662],
            [32.52480514686989, 0.654418282737667],
            [32.53111219512351, 0.656400184227557],
            [32.531587406603755, 0.656183099919881],
            [32.53703968361, 0.65693451826696],
            [32.53772791888178, 0.658228309794093],
            [32.538298014015574, 0.65847263362498],
            [32.542123156378054, 0.658328237180628],
            [32.545888693724756, 0.658916644221454],
            [32.54838310326637, 0.659703968133626],
            [32.54897676300669, 0.660255893257471],
            [32.55314585771503, 0.661133839259141],
            [32.55388217890563, 0.66180338896836],
            [32.557151058393025, 0.660757422591016],
            [32.560903162333, 0.660881220169192],
            [32.56643929257944, 0.660139851203104],
            [32.57428526630584, 0.660936680261566],
            [32.57031690643594, 0.666129039060199],
            [32.56742358651771, 0.668148813458176],
            [32.566471949034955, 0.673797876999349],
            [32.56772663048389, 0.676895162521746],
            [32.57160966387648, 0.679853908654908],
            [32.57495820506497, 0.68327400839415],
            [32.57800783723254, 0.690891934192994],
            [32.58001393067051, 0.694257634338793],
            [32.58633083254447, 0.700428322100004],
            [32.5865916404209, 0.70160446923045],
            [32.58632977792231, 0.702843898514143],
            [32.58226363823038, 0.710129832287096],
            [32.58288155248341, 0.713816205735771],
            [32.58197774669626, 0.71616195996922],
            [32.58411767024695, 0.717981378434656],
            [32.58506844265211, 0.722146524882948],
            [32.5856866263997, 0.722864696001755],
            [32.58720838237248, 0.723822320792721],
            [32.58892043116681, 0.724109723704683],
            [32.59000884433811, 0.723866348202633],
            [32.59291701250966, 0.725658760601445],
            [32.59462694307656, 0.728646333688644],
            [32.595081781664504, 0.733017017684238],
            [32.59460338835151, 0.733005228261003],
            [32.5946848790225, 0.736298530798725],
            [32.593843382180125, 0.738980149778415],
            [32.5885310734749, 0.750462212902337],
            [32.58860998777769, 0.752867943925884],
            [32.591223566926544, 0.756508543053099],
            [32.591969818094306, 0.756968943376044],
            [32.594118255877284, 0.756999993628613],
            [32.596008245658034, 0.758511648785603],
            [32.603962195084954, 0.760014214161925],
            [32.60757658459694, 0.759272683242626],
            [32.611404870164556, 0.762955214710483],
            [32.613318818013965, 0.763878195746669],
            [32.61595825516828, 0.764357933392476],
            [32.617266011779115, 0.766466033750325],
            [32.61707570278786, 0.768374963046976],
            [32.61627874980713, 0.770211458790101],
            [32.61672234328434, 0.773272468005847],
            [32.61410653092366, 0.774421214147863],
            [32.607828401235686, 0.779112320819829],
            [32.60402368117289, 0.779686453757435],
            [32.60050419417914, 0.781505341949404],
            [32.59845898090716, 0.783659488795735],
            [32.59696075360832, 0.788558889232958],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1238,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "KATIKAMU",
        Population: 43446,
        Key: "LUWEROKATIKAMU",
        Dist2: "Luweero",
        "Sub Country": "Katikamu",
        id2_original: "LuweeroKatikamu",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49899042673848, 0.705992656246588],
            [32.50066647285288, 0.706472329150253],
            [32.50700966482191, 0.706807753430021],
            [32.510822652978604, 0.707613344324779],
            [32.51493539097926, 0.702230806694509],
            [32.517470290285644, 0.704183780277596],
            [32.51777334592991, 0.705317382779375],
            [32.516916977477955, 0.708620585153793],
            [32.51991281672969, 0.711062465145576],
            [32.51905651026151, 0.713743309514193],
            [32.51748692708469, 0.715658094735952],
            [32.51729658755073, 0.716711298800621],
            [32.517962301160004, 0.717525223676675],
            [32.51915119898066, 0.717812592852766],
            [32.521814557372686, 0.716280912771254],
            [32.52343169286905, 0.714414003393916],
            [32.524383095891544, 0.71187678894505],
            [32.52319426813946, 0.7109191868051],
            [32.52319440109014, 0.709626593369745],
            [32.520769627152724, 0.703450616288494],
            [32.52036899740063, 0.701075325714082],
            [32.521934659431224, 0.696984261332713],
            [32.5224895640536, 0.697490951786956],
            [32.524141845237146, 0.696975440529295],
            [32.52859546244709, 0.697699655381726],
            [32.53147181229128, 0.701499701183166],
            [32.535485707762916, 0.70427754742855],
            [32.53658918657983, 0.706865113682266],
            [32.536612006483, 0.708973076860232],
            [32.537917757155824, 0.710963558367432],
            [32.53874899164442, 0.711768829661509],
            [32.54301295832821, 0.713506292140503],
            [32.54120491286766, 0.718481987275326],
            [32.5403112212123, 0.724326290218185],
            [32.53908539095538, 0.729048722122277],
            [32.53807766446291, 0.730513128530872],
            [32.53303609271297, 0.73525211930604],
            [32.531846977500024, 0.736975454229851],
            [32.52951607301824, 0.742576450251558],
            [32.52347641908874, 0.741283202966293],
            [32.52152668954495, 0.74013401868351],
            [32.52008647724379, 0.738034779325274],
            [32.52071848247034, 0.737644491901751],
            [32.52014786182211, 0.737022070241384],
            [32.51688246420474, 0.737233920367593],
            [32.51524784210307, 0.737921314449346],
            [32.513291172175364, 0.737803486814931],
            [32.51110598790741, 0.736799027123861],
            [32.50461684755245, 0.742796463315819],
            [32.50064269983719, 0.743872603861765],
            [32.49646580326063, 0.747192369430969],
            [32.49352887372861, 0.747906739666992],
            [32.4918840180192, 0.747191835877067],
            [32.49180161555818, 0.743301624364983],
            [32.492254095170146, 0.740578535346875],
            [32.494193230881805, 0.736760930926041],
            [32.493540396418744, 0.733042545715247],
            [32.49164928284555, 0.729468770865365],
            [32.49127056030828, 0.728202150883206],
            [32.4919136166095, 0.723968235972278],
            [32.495648791797905, 0.717319120494427],
            [32.49899042673848, 0.705992656246588],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1239,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "WOBULENZI TOWN COUNCIL",
        Population: 27048,
        Key: "LUWEROWOBULENZI TOWN COUNCIL",
        Dist2: "Luweero",
        "Sub Country": "Wobulenzi",
        id2_original: "LuweeroWobulenzi",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.65822171744674, 0.793086328095905],
            [32.655423322504575, 0.795474548256882],
            [32.65187317870512, 0.796514671818949],
            [32.648462964579124, 0.800106104794415],
            [32.64523968088061, 0.801797644149227],
            [32.642904130312175, 0.800956052664363],
            [32.63526262212763, 0.796676069102227],
            [32.63524152070158, 0.797092236284825],
            [32.634480392534385, 0.79711026282966],
            [32.624172182428325, 0.795688924005872],
            [32.62210316829288, 0.798031942023682],
            [32.62018903089895, 0.798999807892029],
            [32.61362578043138, 0.800727192372336],
            [32.61052242361993, 0.799424109190902],
            [32.60885817597848, 0.798202587404121],
            [32.602557166200214, 0.79204993581438],
            [32.599691046370474, 0.788865072545138],
            [32.59696075360832, 0.788558889232958],
            [32.59845898090716, 0.783659488795735],
            [32.60050419417914, 0.781505341949404],
            [32.60402368117289, 0.779686453757435],
            [32.607828401235686, 0.779112320819829],
            [32.61410653092366, 0.774421214147863],
            [32.61672234328434, 0.773272468005847],
            [32.61627874980713, 0.770211458790101],
            [32.61707570278786, 0.768374963046976],
            [32.617266011779115, 0.766466033750325],
            [32.61595825516828, 0.764357933392476],
            [32.613318818013965, 0.763878195746669],
            [32.611404870164556, 0.762955214710483],
            [32.60757658459694, 0.759272683242626],
            [32.603962195084954, 0.760014214161925],
            [32.596008245658034, 0.758511648785603],
            [32.594118255877284, 0.756999993628613],
            [32.591969818094306, 0.756968943376044],
            [32.591223566926544, 0.756508543053099],
            [32.58860998777769, 0.752867943925884],
            [32.5885310734749, 0.750462212902337],
            [32.593843382180125, 0.738980149778415],
            [32.5946848790225, 0.736298530798725],
            [32.59460338835151, 0.733005228261003],
            [32.595081781664504, 0.733017017684238],
            [32.59462694307656, 0.728646333688644],
            [32.59291701250966, 0.725658760601445],
            [32.59000884433811, 0.723866348202633],
            [32.58892043116681, 0.724109723704683],
            [32.58720838237248, 0.723822320792721],
            [32.5856866263997, 0.722864696001755],
            [32.58506844265211, 0.722146524882948],
            [32.58411767024695, 0.717981378434656],
            [32.58197774669626, 0.71616195996922],
            [32.58288155248341, 0.713816205735771],
            [32.58226363823038, 0.710129832287096],
            [32.58632977792231, 0.702843898514143],
            [32.5865916404209, 0.70160446923045],
            [32.58633083254447, 0.700428322100004],
            [32.58001393067051, 0.694257634338793],
            [32.57800783723254, 0.690891934192994],
            [32.57495820506497, 0.68327400839415],
            [32.57160966387648, 0.679853908654908],
            [32.56772663048389, 0.676895162521746],
            [32.566471949034955, 0.673797876999349],
            [32.56742358651771, 0.668148813458176],
            [32.57031690643594, 0.666129039060199],
            [32.57428526630584, 0.660936680261566],
            [32.57609083960275, 0.660918742098864],
            [32.57929772186078, 0.662348459272967],
            [32.58093705023626, 0.662140516768814],
            [32.581602022735424, 0.663045283437113],
            [32.583324153322216, 0.663416361601699],
            [32.58396693024734, 0.66107321599641],
            [32.584846387198695, 0.659616707079116],
            [32.591348130917105, 0.651429615666097],
            [32.59259671280521, 0.648787960847619],
            [32.59255360085811, 0.647059958873805],
            [32.588088727757665, 0.643042678035321],
            [32.5870794732309, 0.641667435683036],
            [32.58793663579352, 0.637958190779228],
            [32.588855170358045, 0.628784497184174],
            [32.59024574894315, 0.627409446858433],
            [32.59490249769672, 0.627029834379949],
            [32.59609078556131, 0.6266951834577],
            [32.59789672626913, 0.625455868919631],
            [32.59913247033355, 0.625211692622958],
            [32.60116382799056, 0.625320413739125],
            [32.604723058249135, 0.62627434880357],
            [32.60643517082386, 0.625364865121563],
            [32.60724362763012, 0.625460675518294],
            [32.607418817076834, 0.626175305578056],
            [32.60877811362877, 0.62583667979321],
            [32.60963325857528, 0.626298148245133],
            [32.61227044904309, 0.625836942085648],
            [32.61338708278903, 0.626036062446694],
            [32.61584551660012, 0.627456646004864],
            [32.62140453053012, 0.628606043223592],
            [32.62533670087048, 0.628334915642872],
            [32.63265414361292, 0.629059213294825],
            [32.63311543569784, 0.629543932949969],
            [32.63226384268995, 0.629984910843397],
            [32.631654578314816, 0.631596046763488],
            [32.63132379347438, 0.635034421423924],
            [32.63099322512791, 0.635422603617189],
            [32.63137898327049, 0.638513399618298],
            [32.630998380559326, 0.639255238852491],
            [32.63200699458729, 0.641969458179259],
            [32.633407709762075, 0.644195160895226],
            [32.63539687624514, 0.653206274721367],
            [32.638261062002066, 0.667555282075801],
            [32.63931408514444, 0.677425814195781],
            [32.64089149264738, 0.683008032551871],
            [32.64408496665148, 0.687975166518048],
            [32.644939140519156, 0.690363683233597],
            [32.64548872711505, 0.69092464935524],
            [32.64660538152223, 0.691096629189556],
            [32.647591479277615, 0.690743863969905],
            [32.649491943414596, 0.691585393004432],
            [32.65013306025308, 0.692517299280968],
            [32.65293583627889, 0.694290753690023],
            [32.65527584518609, 0.695023748442278],
            [32.65545353823748, 0.696227035720986],
            [32.65637938868169, 0.697882737322875],
            [32.65939523521143, 0.701085660955988],
            [32.65946351346121, 0.708359599602292],
            [32.660316328177885, 0.714050339725336],
            [32.66018406023545, 0.717669202442165],
            [32.661537322803625, 0.720012524052499],
            [32.6617382417967, 0.722346712012749],
            [32.66002622624003, 0.725124066910745],
            [32.659431193873935, 0.727557713775215],
            [32.6582307068878, 0.729059453426188],
            [32.65780226798946, 0.73085076161931],
            [32.65984542501775, 0.731665164515991],
            [32.66148477585107, 0.731665290269864],
            [32.661827756219836, 0.734641838841318],
            [32.66568594221168, 0.741092775162371],
            [32.667869456511525, 0.746684103615642],
            [32.66838591773132, 0.74713650166584],
            [32.66458254424314, 0.747398579028274],
            [32.66402220032173, 0.747868988488565],
            [32.661633488353104, 0.755558907050916],
            [32.66115799210691, 0.755631247479683],
            [32.66042075732966, 0.755459292546712],
            [32.65250275848041, 0.74962323406417],
            [32.65068382723523, 0.747451767343579],
            [32.65121382696468, 0.747135158798693],
            [32.646701659361106, 0.74290072021107],
            [32.6428770946154, 0.741389533035307],
            [32.63976367846939, 0.743108238744554],
            [32.638979815739, 0.743062938718191],
            [32.63821959037867, 0.742465762849525],
            [32.637126763784394, 0.742700898684805],
            [32.632198910664584, 0.745776519241124],
            [32.6321945852765, 0.747115497247133],
            [32.63173199153275, 0.747432108488166],
            [32.63485803799165, 0.755981933625856],
            [32.64278787394138, 0.764351225370906],
            [32.64539126799155, 0.769508327351034],
            [32.64844603582759, 0.777687222146078],
            [32.652785368468805, 0.783513963652015],
            [32.65488949056218, 0.78772107570225],
            [32.6556265061505, 0.79061623291493],
            [32.65822171744674, 0.793086328095905],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1240,
        District: "LUWERO",
        County: "BAMUNANIKA",
        Subcounty: "BAMUNANIKA",
        Population: 28775,
        Key: "LUWEROBAMUNANIKA",
        Dist2: "Luweero",
        "Sub Country": "Bamunanika",
        id2_original: "LuweeroBamunanika",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.526352142807184, 0.564700592005125],
            [32.530074081319924, 0.557208362034633],
            [32.53062199165947, 0.553788624801635],
            [32.531287971170094, 0.552431621999842],
            [32.53277348371439, 0.550577096485597],
            [32.53695864479158, 0.547656927088746],
            [32.543498786996786, 0.554323418987036],
            [32.54504282837514, 0.554631138647268],
            [32.54630149654729, 0.555445471750229],
            [32.54892506765706, 0.559770171736548],
            [32.55292684216056, 0.562647448952589],
            [32.55368638749623, 0.564375497603458],
            [32.558388782344316, 0.568419903459733],
            [32.56818875171379, 0.568863960156668],
            [32.56925518131345, 0.575441273675859],
            [32.56999088805641, 0.576807440644964],
            [32.58029841544288, 0.5842449351387],
            [32.580063949763826, 0.587483779908045],
            [32.57921988733298, 0.58914838176478],
            [32.5789099757465, 0.591012059864521],
            [32.577436267065, 0.592568047581364],
            [32.57572558191327, 0.593382154308695],
            [32.574406361002765, 0.594612455837336],
            [32.572647949258304, 0.595209426926013],
            [32.569380129782964, 0.59772425993121],
            [32.56553640487053, 0.599012197740107],
            [32.5652084425367, 0.599837392609079],
            [32.56487525110961, 0.603571548899083],
            [32.56558815501741, 0.609077132663386],
            [32.56420866613452, 0.613457503474426],
            [32.561259969570585, 0.61589884018844],
            [32.56049893213324, 0.617526496784626],
            [32.55959503471795, 0.621452098246512],
            [32.559594869427926, 0.62343887294938],
            [32.561021332115345, 0.626215691421123],
            [32.562923477000226, 0.627604201609355],
            [32.56587189418812, 0.628657681566115],
            [32.56658517538831, 0.629471601375956],
            [32.56387407872547, 0.633923666987811],
            [32.56354107055471, 0.635264114613028],
            [32.56201910437614, 0.637083200520045],
            [32.56116271436466, 0.641439671342018],
            [32.5612825568101, 0.643533936597696],
            [32.55991132344463, 0.646731507232649],
            [32.560494434268605, 0.647814058085703],
            [32.560035588296216, 0.655658991551832],
            [32.559319253722336, 0.657544483619256],
            [32.557151058393025, 0.660757422591016],
            [32.55388217890563, 0.66180338896836],
            [32.55314585771503, 0.661133839259141],
            [32.54897676300669, 0.660255893257471],
            [32.54838310326637, 0.659703968133626],
            [32.545888693724756, 0.658916644221454],
            [32.542123156378054, 0.658328237180628],
            [32.538298014015574, 0.65847263362498],
            [32.53772791888178, 0.658228309794093],
            [32.53703968361, 0.65693451826696],
            [32.531587406603755, 0.656183099919881],
            [32.53111219512351, 0.656400184227557],
            [32.52480514686989, 0.654418282737667],
            [32.519577979588995, 0.655159635486662],
            [32.51547855462085, 0.657294331856902],
            [32.51248504110739, 0.657131191466348],
            [32.50877470433657, 0.660912473173615],
            [32.50717365137872, 0.657601108786991],
            [32.50598606330177, 0.656524396908343],
            [32.50456081783155, 0.656099044680837],
            [32.50263613870776, 0.656596437064001],
            [32.50103284804655, 0.656080596291093],
            [32.49924611421779, 0.656080416639819],
            [32.4980691864483, 0.655157503923844],
            [32.49764129642059, 0.653990398145487],
            [32.49545392924649, 0.652696457311109],
            [32.49314707266485, 0.652714316456708],
            [32.49224365225499, 0.652162358163527],
            [32.49022212665874, 0.65226166856844],
            [32.48895038710089, 0.65026215510921],
            [32.484361253640444, 0.648940825441282],
            [32.482173679853815, 0.647004547134028],
            [32.48140157157891, 0.64493271191819],
            [32.48009373591633, 0.644434993215789],
            [32.47897644011202, 0.642679766233775],
            [32.47858474769868, 0.639088080864751],
            [32.47918024539211, 0.635206992458395],
            [32.47861003796886, 0.633370400592312],
            [32.476054423512046, 0.630077045471594],
            [32.472297489330785, 0.628375834138183],
            [32.46931378092868, 0.626041414289682],
            [32.463482659214286, 0.623371965896026],
            [32.468548039014166, 0.622133052996063],
            [32.47353085106307, 0.618080520290202],
            [32.47215260724514, 0.613964015540703],
            [32.4695256000794, 0.611322042564498],
            [32.466244095669005, 0.610100375332026],
            [32.461774351903095, 0.606128317152004],
            [32.46043166070917, 0.603242208847895],
            [32.459195242908294, 0.602020747290598],
            [32.45879158852864, 0.60005752168425],
            [32.45831673457787, 0.599596079715802],
            [32.461499872566336, 0.598583139978945],
            [32.46430653111081, 0.596267400086403],
            [32.47073883865101, 0.596810846885369],
            [32.472356319100435, 0.59554442923563],
            [32.472546920044145, 0.593536022971052],
            [32.471157033161845, 0.587709648509491],
            [32.47434463218399, 0.584000698600843],
            [32.4771053904107, 0.573723606055935],
            [32.476416485894056, 0.570701856480937],
            [32.47452738364877, 0.566912208257734],
            [32.48336200365099, 0.560307517370813],
            [32.48476514248037, 0.559538649203829],
            [32.486144343004106, 0.559538771368875],
            [32.49431201601013, 0.562497855228052],
            [32.50069728057553, 0.561394677407374],
            [32.511527545710685, 0.565322007319392],
            [32.51631477026768, 0.565123377916032],
            [32.51878493158481, 0.566489686568953],
            [32.52105382626085, 0.566716052748092],
            [32.52359462929529, 0.569701784651425],
            [32.52467526611357, 0.570072917930593],
            [32.524460164156395, 0.573302575097418],
            [32.522971232624116, 0.582304244396873],
            [32.52083048262336, 0.587641805918138],
            [32.520687728646614, 0.588646013800604],
            [32.521446975741576, 0.59039215555173],
            [32.52208840878704, 0.590509823215647],
            [32.52489241370815, 0.589605362910738],
            [32.526841300632235, 0.588167051959272],
            [32.528242994970654, 0.588031466494616],
            [32.53141773191456, 0.588760646254355],
            [32.53312067897847, 0.590642924910212],
            [32.534879995326406, 0.593707005413161],
            [32.53599754625225, 0.593898596790364],
            [32.54118118386943, 0.593587853879862],
            [32.54141904518024, 0.592606456590202],
            [32.54286966715893, 0.5906437441302],
            [32.54337614360432, 0.588763724618308],
            [32.54746298946355, 0.588422099868014],
            [32.54893595254336, 0.589136937833065],
            [32.55649022353404, 0.590793165546065],
            [32.55688366047568, 0.587572439863363],
            [32.559225674422564, 0.583211936954117],
            [32.55805083703275, 0.580515815902182],
            [32.557767161642424, 0.577213611269268],
            [32.55631867675583, 0.575901671155534],
            [32.55122323213999, 0.573802348425407],
            [32.54478730888077, 0.568491211810503],
            [32.54259005844192, 0.567767271757783],
            [32.53541445339459, 0.569024232362566],
            [32.53008002457383, 0.570570839203311],
            [32.52467625210136, 0.570072941183438],
            [32.526352142807184, 0.564700592005125],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1241,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "NYIMBWA",
        Population: 36537,
        Key: "LUWERONYIMBWA",
        Dist2: "Luweero",
        "Sub Country": "Nyimbwa",
        id2_original: "LuweeroNyimbwa",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.63539687624514, 0.653206274721367],
            [32.633407709762075, 0.644195160895226],
            [32.63200699458729, 0.641969458179259],
            [32.630998380559326, 0.639255238852491],
            [32.63137898327049, 0.638513399618298],
            [32.63099322512791, 0.635422603617189],
            [32.63132379347438, 0.635034421423924],
            [32.631654578314816, 0.631596046763488],
            [32.63226384268995, 0.629984910843397],
            [32.63311543569784, 0.629543932949969],
            [32.63265414361292, 0.629059213294825],
            [32.62533670087048, 0.628334915642872],
            [32.62140453053012, 0.628606043223592],
            [32.61584551660012, 0.627456646004864],
            [32.61338708278903, 0.626036062446694],
            [32.61227044904309, 0.625836942085648],
            [32.60963325857528, 0.626298148245133],
            [32.60877811362877, 0.62583667979321],
            [32.607418817076834, 0.626175305578056],
            [32.60724362763012, 0.625460675518294],
            [32.60643517082386, 0.625364865121563],
            [32.604723058249135, 0.62627434880357],
            [32.60116382799056, 0.625320413739125],
            [32.59913247033355, 0.625211692622958],
            [32.59789672626913, 0.625455868919631],
            [32.59609078556131, 0.6266951834577],
            [32.59490249769672, 0.627029834379949],
            [32.59024574894315, 0.627409446858433],
            [32.588855170358045, 0.628784497184174],
            [32.58793663579352, 0.637958190779228],
            [32.5870794732309, 0.641667435683036],
            [32.588088727757665, 0.643042678035321],
            [32.59255360085811, 0.647059958873805],
            [32.59259671280521, 0.648787960847619],
            [32.591348130917105, 0.651429615666097],
            [32.584846387198695, 0.659616707079116],
            [32.58396693024734, 0.66107321599641],
            [32.583324153322216, 0.663416361601699],
            [32.581602022735424, 0.663045283437113],
            [32.58093705023626, 0.662140516768814],
            [32.57929772186078, 0.662348459272967],
            [32.57609083960275, 0.660918742098864],
            [32.57428526630584, 0.660936680261566],
            [32.56643929257944, 0.660139851203104],
            [32.560903162333, 0.660881220169192],
            [32.557151058393025, 0.660757422591016],
            [32.559319253722336, 0.657544483619256],
            [32.560035588296216, 0.655658991551832],
            [32.560494434268605, 0.647814058085703],
            [32.55991132344463, 0.646731507232649],
            [32.5612825568101, 0.643533936597696],
            [32.56116271436466, 0.641439671342018],
            [32.56201910437614, 0.637083200520045],
            [32.56354107055471, 0.635264114613028],
            [32.56387407872547, 0.633923666987811],
            [32.56658517538831, 0.629471601375956],
            [32.56587189418812, 0.628657681566115],
            [32.562923477000226, 0.627604201609355],
            [32.561021332115345, 0.626215691421123],
            [32.559594869427926, 0.62343887294938],
            [32.55959503471795, 0.621452098246512],
            [32.56049893213324, 0.617526496784626],
            [32.561259969570585, 0.61589884018844],
            [32.56420866613452, 0.613457503474426],
            [32.56558815501741, 0.609077132663386],
            [32.56487525110961, 0.603571548899083],
            [32.5652084425367, 0.599837392609079],
            [32.56553640487053, 0.599012197740107],
            [32.569380129782964, 0.59772425993121],
            [32.572647949258304, 0.595209426926013],
            [32.574406361002765, 0.594612455837336],
            [32.57572558191327, 0.593382154308695],
            [32.577436267065, 0.592568047581364],
            [32.5789099757465, 0.591012059864521],
            [32.57921988733298, 0.58914838176478],
            [32.580063949763826, 0.587483779908045],
            [32.58029841544288, 0.5842449351387],
            [32.58188399941153, 0.581277605601285],
            [32.583452908851896, 0.579721621035493],
            [32.5835959440013, 0.5785545553039],
            [32.58714944211006, 0.574954068187558],
            [32.58831386173753, 0.574384185874186],
            [32.589691686940505, 0.574311908363054],
            [32.592281312512334, 0.574809687443233],
            [32.59471651589018, 0.57475558014484],
            [32.59656985800064, 0.574013848843421],
            [32.60008699230666, 0.572249909984398],
            [32.603033761984314, 0.570042618255285],
            [32.60402048406879, 0.56833277924902],
            [32.60580309732535, 0.566930597667977],
            [32.60738541681625, 0.566288360594765],
            [32.60860750109844, 0.564325215946342],
            [32.60953432351978, 0.5637734040144],
            [32.61161310863055, 0.564117336106494],
            [32.613798286610326, 0.565175997767194],
            [32.61679079401067, 0.567754633980556],
            [32.61828738188411, 0.568234232621612],
            [32.622372967406996, 0.566108424253101],
            [32.626317211104755, 0.565158732089119],
            [32.63007097962295, 0.565186116796533],
            [32.633315185982724, 0.562517413304126],
            [32.63640427125928, 0.561350524635559],
            [32.63823436497016, 0.559577395287475],
            [32.639553257097255, 0.558844657343551],
            [32.64135912234662, 0.558301939006724],
            [32.64470904424565, 0.558229767291225],
            [32.64729933546909, 0.557252830131377],
            [32.64963963812541, 0.556900132289686],
            [32.65094612002683, 0.557044965311047],
            [32.65180124970199, 0.557786884724668],
            [32.653678450168066, 0.557244166290218],
            [32.65698059966032, 0.557723861910601],
            [32.659463278102606, 0.557615442188187],
            [32.66510440433779, 0.56140654178612],
            [32.666886690607576, 0.56071001073134],
            [32.67192339618361, 0.560402693814782],
            [32.67767379977814, 0.558855945934743],
            [32.68166583025575, 0.557272904731814],
            [32.68417080668006, 0.560421469502688],
            [32.688303554653665, 0.56389582229019],
            [32.701427172895066, 0.570582415218349],
            [32.70614212619084, 0.574301069835346],
            [32.71416985245542, 0.580263607961781],
            [32.71769625557855, 0.584362183440618],
            [32.72039044504946, 0.589736378849342],
            [32.723287483094666, 0.593663026257875],
            [32.73176557613367, 0.602964016915222],
            [32.73321316180667, 0.60691773484856],
            [32.73360811151125, 0.611079487882983],
            [32.72499588742391, 0.610391458787183],
            [32.723213883225114, 0.610635641154618],
            [32.72195421882132, 0.611685055349394],
            [32.71988685219612, 0.612300158717984],
            [32.717867253486176, 0.612471949008276],
            [32.716179841886806, 0.613738471399372],
            [32.71566861065861, 0.615330756835812],
            [32.71322096202081, 0.616144874523651],
            [32.71029741379326, 0.619537425451078],
            [32.70636425620442, 0.622007098650923],
            [32.70276075966358, 0.625453885557652],
            [32.698874988206, 0.624259429030968],
            [32.690684979488715, 0.6363007865738],
            [32.68887908549327, 0.636753037053154],
            [32.68701330081781, 0.638363325604444],
            [32.68319726377907, 0.644931359141099],
            [32.67966612833103, 0.649436642090421],
            [32.67474782789595, 0.650151053239364],
            [32.67157491273542, 0.652412644022303],
            [32.669032304985585, 0.653443855583086],
            [32.66789176976489, 0.653461873717475],
            [32.66695310305653, 0.654429859469875],
            [32.66414904693145, 0.655099163058403],
            [32.66260428690089, 0.656320428047037],
            [32.66027573510681, 0.656627872441332],
            [32.65915840606484, 0.658183910796111],
            [32.65672311105886, 0.658762761309359],
            [32.64848312726568, 0.648339838928095],
            [32.64375501185436, 0.648529495274152],
            [32.64237681654548, 0.649461255246255],
            [32.640831404337995, 0.651967209111631],
            [32.63967844631525, 0.652962313529286],
            [32.638252824450916, 0.653369332600107],
            [32.63539687624514, 0.653206274721367],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1242,
        District: "LUWERO",
        County: "BAMUNANIKA",
        Subcounty: "KALAGALA",
        Population: 44570,
        Key: "LUWEROKALAGALA",
        Dist2: "Luweero",
        "Sub Country": "Kalagala",
        id2_original: "LuweeroKalagala",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.52467625210136, 0.570072941183438],
            [32.53008002457383, 0.570570839203311],
            [32.53541445339459, 0.569024232362566],
            [32.54259005844192, 0.567767271757783],
            [32.54478730888077, 0.568491211810503],
            [32.55122323213999, 0.573802348425407],
            [32.55631867675583, 0.575901671155534],
            [32.557767161642424, 0.577213611269268],
            [32.55805083703275, 0.580515815902182],
            [32.559225674422564, 0.583211936954117],
            [32.55688366047568, 0.587572439863363],
            [32.55649022353404, 0.590793165546065],
            [32.54893595254336, 0.589136937833065],
            [32.54746298946355, 0.588422099868014],
            [32.54337614360432, 0.588763724618308],
            [32.54286966715893, 0.5906437441302],
            [32.54141904518024, 0.592606456590202],
            [32.54118118386943, 0.593587853879862],
            [32.53599754625225, 0.593898596790364],
            [32.534879995326406, 0.593707005413161],
            [32.53312067897847, 0.590642924910212],
            [32.53141773191456, 0.588760646254355],
            [32.528242994970654, 0.588031466494616],
            [32.526841300632235, 0.588167051959272],
            [32.52489241370815, 0.589605362910738],
            [32.52208840878704, 0.590509823215647],
            [32.521446975741576, 0.59039215555173],
            [32.520687728646614, 0.588646013800604],
            [32.52083048262336, 0.587641805918138],
            [32.522971232624116, 0.582304244396873],
            [32.524460164156395, 0.573302575097418],
            [32.524675275632646, 0.570072802849732],
            [32.52467625210136, 0.570072941183438],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1243,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "BOMBO TOWN COUNCIL",
        Population: 25832,
        Key: "LUWEROBOMBO TOWN COUNCIL",
        Dist2: "Luweero",
        "Sub Country": "Bombo TC",
        id2_original: "LuweeroBombo TC",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.42507232631094, 1.070740361439708],
            [32.418377784369646, 1.076162805801906],
            [32.41358205636013, 1.076813251808779],
            [32.41188824426437, 1.077618092562884],
            [32.405268175355076, 1.084447156031998],
            [32.40366978859699, 1.08702518584061],
            [32.400323865099274, 1.094985724596534],
            [32.396707902637246, 1.100621162068636],
            [32.39643945728425, 1.101670538260822],
            [32.39689816671272, 1.104239928346176],
            [32.39624246842055, 1.106311516021141],
            [32.394797456420825, 1.107288274977668],
            [32.39114945554418, 1.108744057708839],
            [32.3838280144004, 1.113745408918082],
            [32.3786294117489, 1.121343610051812],
            [32.377516540147376, 1.124220249195805],
            [32.37559556747246, 1.132452407501727],
            [32.373808353045035, 1.136396414306072],
            [32.36662688199892, 1.13279422153567],
            [32.364107886466314, 1.130749096501788],
            [32.3621124003352, 1.125022056700833],
            [32.360934214924335, 1.123375286615896],
            [32.358749449271265, 1.117548694600502],
            [32.35813322385099, 1.113622267768655],
            [32.35876348275266, 1.10460279197655],
            [32.35899228635047, 1.087974905900761],
            [32.35638643181471, 1.081080721540203],
            [32.35522528474983, 1.073245988001882],
            [32.35308885834054, 1.067247539893406],
            [32.35113318464449, 1.064533101456774],
            [32.35036207799114, 1.062461233704463],
            [32.34925505082885, 1.048257616494632],
            [32.34560268503825, 1.035989476763178],
            [32.345777544803234, 1.031095230102746],
            [32.346658749876134, 1.029059896690766],
            [32.34700866164564, 1.026517836331919],
            [32.34718261231555, 1.014808660844098],
            [32.34765020877713, 1.006714657073632],
            [32.3479660959569, 1.005719578717674],
            [32.35090555783971, 1.001649134591342],
            [32.35132997857379, 0.9986095128584],
            [32.35241672267527, 0.996709911652854],
            [32.35274789918118, 0.995063469425446],
            [32.35243726445087, 0.993634021331316],
            [32.353196633716735, 0.992602842036022],
            [32.35310023550362, 0.991481026098949],
            [32.35357548920465, 0.99129113810052],
            [32.354168344054514, 0.990069943363149],
            [32.35370181029993, 0.987292499263383],
            [32.354557100773505, 0.986930796893049],
            [32.355363949595386, 0.98580915687856],
            [32.356029338912855, 0.985646445757883],
            [32.35557629426055, 0.984280296626815],
            [32.35690512444967, 0.982398830509114],
            [32.356630873285, 0.981620755834004],
            [32.35705768443603, 0.980661882889885],
            [32.35696153954782, 0.979666720344154],
            [32.357436304565375, 0.979087820064956],
            [32.35752931882483, 0.977350859950714],
            [32.35667165679889, 0.975432782610936],
            [32.357063277346995, 0.974899098942282],
            [32.357610084555404, 0.975043952866927],
            [32.358179554461756, 0.974157479875559],
            [32.35858056330292, 0.971506856338141],
            [32.358294515461935, 0.970719732608715],
            [32.35874538888619, 0.970222247805073],
            [32.35862562549252, 0.969362782022569],
            [32.359159911084156, 0.968874358826614],
            [32.358779161947595, 0.968367668233408],
            [32.358944215702955, 0.967363508508312],
            [32.35946671270315, 0.966838896156454],
            [32.359393209851646, 0.964902875140888],
            [32.360627345033365, 0.963184224492417],
            [32.3607796543898, 0.961239198851874],
            [32.360398633063724, 0.960669180305519],
            [32.36203713858237, 0.95930342794497],
            [32.36243983356133, 0.958091236738289],
            [32.36384120091297, 0.957204915608754],
            [32.36405401270209, 0.956110296760739],
            [32.36852703981039, 0.949579355520227],
            [32.37036725034802, 0.947887945660134],
            [32.37357362056635, 0.945816818561001],
            [32.37746994812685, 0.944360992188881],
            [32.378978328185056, 0.943411351179779],
            [32.38099513493112, 0.9404534100663],
            [32.38422511736668, 0.938210378423766],
            [32.387382793506745, 0.935071693491753],
            [32.38880732930786, 0.938175001222991],
            [32.39235211196175, 0.941034420457601],
            [32.395954243063336, 0.942003061610057],
            [32.3974753765036, 0.942003327475461],
            [32.40480511358904, 0.93948053080189],
            [32.40727723413181, 0.939508095493533],
            [32.41124810389459, 0.940730098801722],
            [32.4186085768375, 0.944268667799894],
            [32.41986773369314, 0.943916052365208],
            [32.424791315323745, 0.936498441971394],
            [32.4281024928846, 0.932328377440698],
            [32.437281738070865, 0.925942763226632],
            [32.43725932240956, 0.916687787460664],
            [32.435032163461635, 0.912761082581549],
            [32.43165194138804, 0.908128736656825],
            [32.425915070913284, 0.904912852492192],
            [32.42372777650269, 0.902375229825067],
            [32.42215885179097, 0.899167486384996],
            [32.42338988509004, 0.895832517405409],
            [32.42903088286611, 0.892314172078587],
            [32.4335691662916, 0.891048315286331],
            [32.44132856757745, 0.890009117884691],
            [32.457815428835275, 0.882674544319354],
            [32.459265483078674, 0.882765227467245],
            [32.46111893388529, 0.882286011556646],
            [32.46544219117444, 0.880232985959182],
            [32.46727228758028, 0.880043264394744],
            [32.47121608301871, 0.878134925687998],
            [32.473393277670546, 0.880252222008996],
            [32.47644130095544, 0.885192293373912],
            [32.47738498834793, 0.889164040716754],
            [32.478242757273385, 0.890982602486887],
            [32.478958931947126, 0.894804952222291],
            [32.47906848419098, 0.894568732189736],
            [32.47961823428025, 0.895099212493757],
            [32.48095176265825, 0.895284559024397],
            [32.48269925538046, 0.89472934305901],
            [32.484415120218124, 0.89296587551537],
            [32.484601591606484, 0.891707262982698],
            [32.48566987353227, 0.890467979429963],
            [32.48632631652782, 0.888838710085823],
            [32.48723068735528, 0.883381251254124],
            [32.48884820463566, 0.879599465430072],
            [32.4926774846383, 0.876889445343799],
            [32.496855572380944, 0.872447945667639],
            [32.49664229346787, 0.8714222458886],
            [32.49090434770968, 0.867460886379352],
            [32.498948691908694, 0.864857805075034],
            [32.49987453157311, 0.863853713348105],
            [32.50369900648732, 0.86147485965737],
            [32.508228151351396, 0.856897670145476],
            [32.511889969215424, 0.856970519857906],
            [32.51718131753012, 0.854899430871468],
            [32.5200584021962, 0.855116923817352],
            [32.524730752889624, 0.857469736835235],
            [32.528844713497406, 0.857949742734193],
            [32.53325540740644, 0.859569707407249],
            [32.534158871833796, 0.862365353151778],
            [32.535395197108166, 0.86251025744766],
            [32.55149464732329, 0.857681079559661],
            [32.55536372987956, 0.855599629147437],
            [32.556647436793604, 0.858054963180886],
            [32.56006049947736, 0.861491434395584],
            [32.559563490376746, 0.865864560635218],
            [32.55912893395131, 0.866864093401546],
            [32.559935361463324, 0.87023778781928],
            [32.559128206315926, 0.873111499090659],
            [32.55912774548018, 0.877047363247385],
            [32.55794824313911, 0.879608658603585],
            [32.55844446172227, 0.882045205367568],
            [32.558134012044896, 0.883169700687368],
            [32.556939154800666, 0.884340945612003],
            [32.557063043258104, 0.886340129466665],
            [32.55793170695133, 0.888214455135877],
            [32.55935898530906, 0.889714003909402],
            [32.55966899032033, 0.892337952091525],
            [32.5601195169949, 0.893194824672397],
            [32.56356770380623, 0.889359187883712],
            [32.56425055547453, 0.888047314014789],
            [32.56865667965371, 0.891296489776701],
            [32.57318702107378, 0.893858463313963],
            [32.57449034180375, 0.893983564540932],
            [32.581623962289605, 0.897031897280786],
            [32.581211946391306, 0.897699767569805],
            [32.57892510157923, 0.899148058218027],
            [32.577085513574126, 0.904883514479381],
            [32.5785593641894, 0.909192363590464],
            [32.58141255097403, 0.912639639476832],
            [32.58830755376761, 0.922861590723273],
            [32.58945430443175, 0.923330692060318],
            [32.58877751728995, 0.947034465216192],
            [32.59029444930966, 0.966232590872237],
            [32.58955548078387, 0.982435851825717],
            [32.586410056765985, 1.000095385955489],
            [32.58605439757535, 1.000692449121147],
            [32.58213478029277, 1.001044783782104],
            [32.58047399655506, 1.003134446746637],
            [32.57219000429614, 1.019834265058103],
            [32.572452734567264, 1.021100890806991],
            [32.57508183121436, 1.024457708667821],
            [32.57762678626205, 1.026936948993265],
            [32.57777048436815, 1.027769299216077],
            [32.577453246122204, 1.030890500367948],
            [32.57819323962568, 1.033858041500115],
            [32.5766394389501, 1.035974850090079],
            [32.57559806516035, 1.039349268937535],
            [32.57559978812908, 1.043257608207439],
            [32.57067715781434, 1.039149563186724],
            [32.55868358875933, 1.032552590248062],
            [32.556875886455195, 1.030498654870703],
            [32.55586364233516, 1.028291031300429],
            [32.55512141112828, 1.023387422850064],
            [32.55536858347705, 1.021324729789755],
            [32.556481792845126, 1.018475062287115],
            [32.55990861143079, 1.013092534760205],
            [32.56186402461539, 1.00907590687254],
            [32.5623832032389, 1.006018069832141],
            [32.561533962918745, 1.00094255224184],
            [32.56249385591897, 0.997658597303355],
            [32.56128470558026, 0.997658434732929],
            [32.56129725324815, 0.994102940523718],
            [32.561999473492236, 0.987390112774977],
            [32.56399803635322, 0.979609900327328],
            [32.564830656043966, 0.978669114441717],
            [32.565781719503256, 0.978361638118299],
            [32.566566470667475, 0.978361740511305],
            [32.5684214872376, 0.979366207733165],
            [32.57081119633621, 0.981031179184143],
            [32.57607745650162, 0.988133815384495],
            [32.5781461903627, 0.989418767340036],
            [32.581523078788265, 0.989636329309525],
            [32.583496965826676, 0.987990009306714],
            [32.58417492257496, 0.986280195091191],
            [32.58412788858333, 0.982778964987481],
            [32.582594996195965, 0.975179216862265],
            [32.58039570658142, 0.971270599240895],
            [32.573725969820046, 0.966203392591245],
            [32.57144309645987, 0.965967878823541],
            [32.57075362241134, 0.965488296000919],
            [32.56805488477016, 0.962240051457692],
            [32.56620015655924, 0.961235589030809],
            [32.554207048339954, 0.959361289304067],
            [32.55413213154018, 0.958791315354144],
            [32.55251092487896, 0.959089654375989],
            [32.54336339381549, 0.958762741251118],
            [32.5377153245015, 0.959594302969133],
            [32.53240011693288, 0.96223530632731],
            [32.51907053835298, 0.967634500572964],
            [32.514254661131666, 0.970537896571406],
            [32.50861862295427, 0.971658902184696],
            [32.501828994340144, 0.975168129664458],
            [32.500185990058526, 0.976606354658554],
            [32.49933016778231, 0.98052356978164],
            [32.495870820301846, 0.985507930765103],
            [32.49257970571457, 0.988606992736274],
            [32.488068740955185, 0.991939122519744],
            [32.48460476445607, 0.999384229745756],
            [32.48278528613692, 1.001256661313481],
            [32.48215645286161, 1.002848825356875],
            [32.47861989158923, 1.007317453887517],
            [32.47711941490892, 1.011306915940877],
            [32.47262951294801, 1.016082968853231],
            [32.467884166052905, 1.019899990661999],
            [32.46607125531677, 1.024386966868204],
            [32.464260950593285, 1.026675535415892],
            [32.45531418491098, 1.032979711091516],
            [32.45170278139902, 1.03612740938588],
            [32.448503620160835, 1.038062887153282],
            [32.43746442485692, 1.048510081668288],
            [32.43495824109692, 1.049948080120599],
            [32.43238038076038, 1.053231626640482],
            [32.43131941201931, 1.055438869876885],
            [32.43130727847478, 1.057293477763246],
            [32.432352316492555, 1.05928398450302],
            [32.43227317042445, 1.060496252059757],
            [32.42977987748877, 1.063553633310781],
            [32.42764438353073, 1.068266655202255],
            [32.42507232631094, 1.070740361439708],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1244,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "BUTUNTUMULA",
        Population: 35314,
        Key: "LUWEROBUTUNTUMULA",
        Dist2: "Luweero",
        "Sub Country": "Butuntumula",
        id2_original: "LuweeroButuntumula",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.78801119902846, 1.07513470436383],
            [32.76506111470996, 1.073549740426837],
            [32.75214777051698, 1.073521569713543],
            [32.74836205341571, 1.073141273591315],
            [32.74125901427704, 1.073855407693457],
            [32.73500516335626, 1.073692016670947],
            [32.73164782496623, 1.073022226375683],
            [32.72684550691581, 1.070551905342366],
            [32.71566989974105, 1.068931429420829],
            [32.712261079800385, 1.069283949605065],
            [32.709554625630915, 1.070921237967014],
            [32.70677525251488, 1.071364284191294],
            [32.70511214932711, 1.071364122522817],
            [32.70170125248153, 1.06995242581339],
            [32.69809073291181, 1.070585373421649],
            [32.695146643806986, 1.072249763903882],
            [32.69304680308425, 1.074728484031441],
            [32.689320563437946, 1.078048423515677],
            [32.68510676317119, 1.080798331595559],
            [32.680856246962136, 1.082724934631976],
            [32.671816818261675, 1.083339168331449],
            [32.670226084251496, 1.084234664373374],
            [32.664922161319474, 1.089499529783289],
            [32.65857586567109, 1.09720699370063],
            [32.65723607693385, 1.099450535273059],
            [32.65652806704773, 1.103494534190965],
            [32.65367217184255, 1.109610079750094],
            [32.6515965802426, 1.122673926057698],
            [32.65025730354507, 1.125152685182061],
            [32.64776400791442, 1.126428030487799],
            [32.64476286680591, 1.130037475564645],
            [32.64122538116712, 1.132371200392173],
            [32.63229091072609, 1.141598148163479],
            [32.62881218838163, 1.143316652823318],
            [32.62448843701904, 1.143786536215535],
            [32.62047142080009, 1.142076096207411],
            [32.618231580335305, 1.140338750578371],
            [32.617743135772585, 1.138085951728665],
            [32.61708878046177, 1.137262576347011],
            [32.615995339419825, 1.136909592693403],
            [32.6143297227459, 1.13452092965566],
            [32.61418324704891, 1.13130013609161],
            [32.613361874265514, 1.129662498259432],
            [32.6131689511768, 1.127201656401648],
            [32.61264495309176, 1.126197356258898],
            [32.61279617638501, 1.123266111090798],
            [32.61326989845853, 1.122117190609541],
            [32.61231737523689, 1.120325735149356],
            [32.61148494778563, 1.119466147867048],
            [32.60497291835721, 1.117502047673829],
            [32.59942218599581, 1.114787158801938],
            [32.59832799216567, 1.113855156916151],
            [32.592176447677666, 1.105141953074899],
            [32.589760707198764, 1.102192266817131],
            [32.58589294516595, 1.096265884435542],
            [32.58266949707575, 1.09262850508012],
            [32.57750920846946, 1.088294227237264],
            [32.57523750565982, 1.08589643017248],
            [32.574046633342185, 1.083489739474438],
            [32.57310348044731, 1.079192245976783],
            [32.57029501808574, 1.074876394360838],
            [32.56937746807476, 1.072306896630778],
            [32.56906448963989, 1.068868966057538],
            [32.57069392936071, 1.060274478934076],
            [32.57145276233234, 1.058935618072766],
            [32.57672809099056, 1.053499054815028],
            [32.57728045338065, 1.048152306653269],
            [32.57665901324016, 1.045040026954675],
            [32.57559978812908, 1.043257608207439],
            [32.57559806516035, 1.039349268937535],
            [32.5766394389501, 1.035974850090079],
            [32.57819323962568, 1.033858041500115],
            [32.577453246122204, 1.030890500367948],
            [32.57777048436815, 1.027769299216077],
            [32.57762678626205, 1.026936948993265],
            [32.57508183121436, 1.024457708667821],
            [32.572452734567264, 1.021100890806991],
            [32.57219000429614, 1.019834265058103],
            [32.58047399655506, 1.003134446746637],
            [32.58213478029277, 1.001044783782104],
            [32.58605439757535, 1.000692449121147],
            [32.586410056765985, 1.000095385955489],
            [32.58955548078387, 0.982435851825717],
            [32.59029444930966, 0.966232590872237],
            [32.58877751728995, 0.947034465216192],
            [32.58945430443175, 0.923330692060318],
            [32.591743034807564, 0.921117554171629],
            [32.593920226764475, 0.917643947614411],
            [32.59815297250058, 0.918458293432698],
            [32.602195120886186, 0.922528066155042],
            [32.60504861938621, 0.923485873836147],
            [32.61242017574307, 0.924678122699936],
            [32.61440840887656, 0.923745466695613],
            [32.615060654943115, 0.921304729897933],
            [32.61433518450282, 0.918367086624061],
            [32.61428773189624, 0.915616754384615],
            [32.615619894835056, 0.912857524249833],
            [32.61823641237319, 0.905176791303435],
            [32.62030538608447, 0.904055166193115],
            [32.62689247604305, 0.904598683437524],
            [32.62888985043286, 0.906019292317793],
            [32.63441132466546, 0.915103195590332],
            [32.63795630674533, 0.919102399686221],
            [32.638453685951816, 0.920944994831822],
            [32.64070676399066, 0.924602775538299],
            [32.64460630751987, 0.928624634075758],
            [32.65396315053611, 0.93544770062803],
            [32.66618562469859, 0.941624725263344],
            [32.66889676897215, 0.939662125969867],
            [32.67447458104777, 0.934032637250201],
            [32.675929199631156, 0.930369830998121],
            [32.67696177801595, 0.929248075461139],
            [32.67887983296283, 0.919920598447948],
            [32.6800691781445, 0.918274117544845],
            [32.68320830856552, 0.916663999523473],
            [32.68764330998781, 0.915678247890548],
            [32.69004499722242, 0.915913686011685],
            [32.6936955349414, 0.914900715994824],
            [32.69555048773116, 0.913769974471208],
            [32.705003348074854, 0.911056606895211],
            [32.71293404820389, 0.909944445268152],
            [32.71550237112708, 0.909202779143004],
            [32.71972341810322, 0.907276053209758],
            [32.727464599758484, 0.901450233308613],
            [32.739283575848155, 0.897189857438654],
            [32.752342501914384, 0.90634658938287],
            [32.755314481912144, 0.913195562282741],
            [32.756645963029634, 0.91501415066539],
            [32.76550393653429, 0.921076409462484],
            [32.77167461154462, 0.926378508680612],
            [32.785772684477024, 0.93555332842427],
            [32.7853278198837, 0.944130111601843],
            [32.7811695462813, 0.978518505108473],
            [32.77836735955031, 0.993762955995066],
            [32.776950356122825, 0.997616993646896],
            [32.77693086896936, 0.999209310350153],
            [32.7779407792663, 1.013467862252806],
            [32.78124788925553, 1.029400318522806],
            [32.78463186449036, 1.051095889178725],
            [32.78801119902846, 1.07513470436383],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1245,
        District: "LUWERO",
        County: "BAMUNANIKA",
        Subcounty: "KAMIRA",
        Population: 26388,
        Key: "LUWEROKAMIRA",
        Dist2: "Luweero",
        "Sub Country": "kamira",
        id2_original: "Luweerokamira",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.589590377577316, -0.325586816621625],
            [31.57110240942964, -0.331499329104703],
            [31.558023548848954, -0.321421904383919],
            [31.547224457949106, -0.31949392266662],
            [31.546487714550295, -0.319828454563474],
            [31.546770367657814, -0.332165082752395],
            [31.54638964187748, -0.334245238550174],
            [31.54543909405116, -0.335728379345447],
            [31.536729667758493, -0.339453365859764],
            [31.533712497112045, -0.337273222327167],
            [31.530647307920376, -0.337082818716601],
            [31.52516413605489, -0.340048533289096],
            [31.525591493381626, -0.341441429149582],
            [31.52527009144434, -0.344805867678624],
            [31.524105289134535, -0.346496973817754],
            [31.52202354407493, -0.351932282197949],
            [31.51715314450575, -0.355404518132022],
            [31.516047759463792, -0.357647328124497],
            [31.51243609454208, -0.358478821260425],
            [31.509156385863943, -0.360422794771196],
            [31.507825386243468, -0.362041511469952],
            [31.507147902008995, -0.363994944185985],
            [31.505420284512468, -0.3653041250615],
            [31.504795172957397, -0.366147085154335],
            [31.504438310024252, -0.368082498942336],
            [31.50597011814506, -0.371130670805654],
            [31.50440118085692, -0.373545215845723],
            [31.504192696252527, -0.378019416040139],
            [31.503674617166926, -0.381811523034964],
            [31.502093311873985, -0.387463886484641],
            [31.50238981251159, -0.388883890035185],
            [31.503743805410103, -0.390774370555818],
            [31.50360087626189, -0.39251988662854],
            [31.504419622371405, -0.396788910164225],
            [31.504490145511102, -0.399565506911026],
            [31.503753557520827, -0.40064163812809],
            [31.50309900278399, -0.404449134334566],
            [31.504654466241167, -0.408437929327492],
            [31.504677835913295, -0.409577518331722],
            [31.503607864256473, -0.412860374594182],
            [31.5048432148588, -0.414054454247807],
            [31.50525879976374, -0.415112693152483],
            [31.505257720887094, -0.419399675975224],
            [31.503700717717493, -0.422203087857073],
            [31.502451404600748, -0.429420143977417],
            [31.500775904662024, -0.432277783762469],
            [31.49623913220286, -0.436030235417301],
            [31.49109846729393, -0.442568144472434],
            [31.48442200754101, -0.459036193656352],
            [31.48436778433215, -0.472466749148559],
            [31.48510620308894, -0.47739596993746],
            [31.48655045152066, -0.479621158531015],
            [31.492948817116165, -0.484271283883743],
            [31.497484840380412, -0.487003645229887],
            [31.50209877093594, -0.489175296629594],
            [31.50250262833487, -0.48982656671319],
            [31.50281058339067, -0.492503732654268],
            [31.50560238110539, -0.493662013420688],
            [31.50610115449724, -0.494259053790895],
            [31.507835575833713, -0.49450363797123],
            [31.509023530423317, -0.495363104984736],
            [31.513975750345192, -0.502717211979818],
            [31.51708920422044, -0.505630181154918],
            [31.520366534159695, -0.502709626897532],
            [31.5210895468094, -0.501117992761765],
            [31.52217957065999, -0.50053035352278],
            [31.522804742402165, -0.499553707306951],
            [31.524375391879236, -0.499029486581782],
            [31.525529564424257, -0.497772596119633],
            [31.526683418067375, -0.497971826842856],
            [31.528831064434545, -0.497293973815713],
            [31.530048914956808, -0.497520363193834],
            [31.534360318077503, -0.496951531851411],
            [31.536347412147236, -0.497340879377944],
            [31.537533580886038, -0.496147289600775],
            [31.540835158151438, -0.495343059828304],
            [31.54270288408623, -0.493426061699133],
            [31.544305454298563, -0.493345014207657],
            [31.54530742797995, -0.492214677146862],
            [31.54767112096962, -0.492251377361705],
            [31.548931654044278, -0.4912205886557],
            [31.55058433228318, -0.490524530349185],
            [31.552806664583102, -0.488535235253456],
            [31.55466001477837, -0.488200987871769],
            [31.555135467007137, -0.487577030816136],
            [31.557036680339056, -0.486618714855389],
            [31.557345946935186, -0.485904272710996],
            [31.55851036027445, -0.485352813173691],
            [31.56060185025827, -0.483417736932649],
            [31.563916983999636, -0.482324058948828],
            [31.569550110737204, -0.476898540606677],
            [31.57123917344007, -0.469943670760537],
            [31.571228449352223, -0.464616447531298],
            [31.57182326073276, -0.462346397335762],
            [31.573748520168223, -0.46043839621642],
            [31.574830315450793, -0.45740869244645],
            [31.576743810549303, -0.455337881796229],
            [31.578098995512196, -0.452660963831108],
            [31.58352969588362, -0.448320639764032],
            [31.585859308588045, -0.444594727034714],
            [31.590528905945106, -0.443021869972616],
            [31.593038095468092, -0.43376068118107],
            [31.59384643639166, -0.432060445257112],
            [31.59451191823559, -0.431581203172693],
            [31.596211131901157, -0.431310177457547],
            [31.591428066543926, -0.409412349318928],
            [31.589611711666986, -0.403713937254241],
            [31.58808063387652, -0.396052909322591],
            [31.585991078863813, -0.390264037819003],
            [31.584412552958323, -0.382358821130292],
            [31.584021849590126, -0.376515973376005],
            [31.584768929004603, -0.367688599403284],
            [31.589590377577316, -0.325586816621625],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1246,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "KISEKKA",
        Population: 49230,
        Key: "LWENGOKISEKKA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.354732476111046, -0.40936329986158],
              [31.347805731346888, -0.411924984016899],
              [31.345215468869554, -0.41386366873917],
              [31.3412079370634, -0.415477765181955],
              [31.339307732539513, -0.413972689030382],
              [31.337658642171856, -0.413148664326785],
              [31.336318646822114, -0.413012184137807],
              [31.332581675901412, -0.41480792702415],
              [31.330648914635027, -0.415002089188657],
              [31.32893604567881, -0.411110342661151],
              [31.32520011500725, -0.407944573619244],
              [31.322430034064524, -0.407269492393517],
              [31.320716333268365, -0.407424790113258],
              [31.31659385573337, -0.404362726641456],
              [31.314500889817523, -0.400467693505579],
              [31.311525436034543, -0.400926830982049],
              [31.311427522363548, -0.402312209320446],
              [31.30719495269724, -0.408316296036094],
              [31.304492565201063, -0.410906973805041],
              [31.29981022524167, -0.416527156622667],
              [31.289099704635575, -0.42670757791887],
              [31.28085574759393, -0.43200607088051],
              [31.27908818381334, -0.434265484853292],
              [31.276854838168035, -0.435295900969568],
              [31.274111240458215, -0.437239563539828],
              [31.271130574649945, -0.439761939221459],
              [31.26689182816776, -0.444363919054244],
              [31.257356248257743, -0.452572835563375],
              [31.246560644617826, -0.460311109948021],
              [31.250374360409864, -0.464046841820104],
              [31.268037795500955, -0.48457017413679],
              [31.31409098675676, -0.493453373064156],
              [31.336242685281693, -0.509637775749194],
              [31.35526154608417, -0.522963874846393],
              [31.355735066935043, -0.522177206160296],
              [31.36038525529208, -0.519420127248512],
              [31.361499495926093, -0.51831708353259],
              [31.361687815149015, -0.517394687058296],
              [31.36095628916538, -0.51384940657433],
              [31.361644284586962, -0.507464790861282],
              [31.36115446200863, -0.506144301087411],
              [31.35869068591654, -0.504163121273865],
              [31.357689424599183, -0.502589280636951],
              [31.353163658298858, -0.498190377794858],
              [31.352176019932784, -0.496247269240846],
              [31.35018386385644, -0.498181029381092],
              [31.346581740839664, -0.503648702057303],
              [31.34357917859638, -0.501030837952641],
              [31.339312547509422, -0.495014343508311],
              [31.33849045427719, -0.49302983310237],
              [31.33962373021206, -0.491873907521929],
              [31.340958634809116, -0.49128050947252],
              [31.345397497190504, -0.491234738397988],
              [31.34904496536617, -0.490610660356467],
              [31.35117693523336, -0.489816044232488],
              [31.35029769028439, -0.484913309311427],
              [31.35066225896603, -0.478231719940687],
              [31.35535832877622, -0.477935885372207],
              [31.36036357175774, -0.479890498146879],
              [31.361410217759893, -0.480731812713167],
              [31.363222110704818, -0.480531658042397],
              [31.371673917241978, -0.475335194512366],
              [31.372718347100324, -0.473635229758582],
              [31.375389872974917, -0.470868500090731],
              [31.381997806543055, -0.47071628300968],
              [31.38156646069644, -0.468783601972423],
              [31.38036418246962, -0.46469280361611],
              [31.37953877894555, -0.458723775010528],
              [31.379771178499446, -0.45261932911527],
              [31.378376862922785, -0.448422743644309],
              [31.37462919576201, -0.444099032703425],
              [31.370919453675896, -0.442180972243909],
              [31.37011035277758, -0.441050329618796],
              [31.36615585121757, -0.431219021699789],
              [31.36316778329139, -0.425819342958159],
              [31.35436421894686, -0.415968999557356],
              [31.353947066481723, -0.414549064492066],
              [31.353944558385457, -0.411700337336752],
              [31.354732476111046, -0.40936329986158],
            ],
          ],
          [
            [
              [31.354732476111046, -0.40936329986158],
              [31.355414660331075, -0.407875200284614],
              [31.35612726060829, -0.407377956731571],
              [31.35757722232525, -0.407351109461265],
              [31.36789814808417, -0.409182710757485],
              [31.367907483376605, -0.405094124782648],
              [31.368446060220375, -0.403000592882826],
              [31.369249066947777, -0.401357062254554],
              [31.371976988157595, -0.398162044560386],
              [31.374604894536926, -0.39329575317768],
              [31.374076460571054, -0.390118451236974],
              [31.372180140362453, -0.385214550759256],
              [31.372271524179684, -0.384314668443293],
              [31.376503906098097, -0.384021629313459],
              [31.375050774226512, -0.380150363694661],
              [31.374714594104482, -0.374804257817856],
              [31.376021985101, -0.370010028859833],
              [31.379291568867583, -0.364343686491084],
              [31.378603647107823, -0.358745506979912],
              [31.378334926870355, -0.350967887018443],
              [31.37868978656043, -0.349240607196134],
              [31.384039915237395, -0.345967688031528],
              [31.380443074314517, -0.343398668689603],
              [31.374722648399324, -0.340196237973775],
              [31.37161183467271, -0.338902464800092],
              [31.365404317955953, -0.337635317954691],
              [31.361910193097586, -0.335518519427622],
              [31.359684163331977, -0.333040198672215],
              [31.35719953913875, -0.329123901371643],
              [31.355910527672947, -0.326862796206063],
              [31.355335710095705, -0.324475190005842],
              [31.354008993642463, -0.32283809311452],
              [31.341889682007242, -0.318712272931534],
              [31.335800421311127, -0.315844503747658],
              [31.32954884941618, -0.315219501383211],
              [31.324049424332244, -0.314133410567696],
              [31.319065632221378, -0.315263026794866],
              [31.31487549088428, -0.314285670023823],
              [31.313000564952485, -0.312576170176129],
              [31.312090216735147, -0.317712674541058],
              [31.310714251943097, -0.320416411604403],
              [31.310502048313413, -0.322062269117403],
              [31.30714377387887, -0.327388264353449],
              [31.307360063944746, -0.329947572795027],
              [31.305390279512256, -0.333193804396396],
              [31.30434745224837, -0.336286458000423],
              [31.306301457772914, -0.341522899508944],
              [31.308931864163707, -0.345963658262613],
              [31.314152104535417, -0.349238301263622],
              [31.315506877171607, -0.349139067115478],
              [31.320332869423005, -0.349980966904003],
              [31.323103062655168, -0.35133798326967],
              [31.325599144859808, -0.351844860701592],
              [31.32854859600857, -0.35395251541577],
              [31.3302294166687, -0.359469347133493],
              [31.331062373227702, -0.360717492942599],
              [31.3316347069632, -0.362607681323333],
              [31.33160045509974, -0.364199328345882],
              [31.330699246342064, -0.366161605226082],
              [31.3298218168883, -0.367120043094907],
              [31.329800356136168, -0.367828707650303],
              [31.333515603996663, -0.369782825404829],
              [31.336689746255857, -0.369967070521992],
              [31.344661962025757, -0.368517721909068],
              [31.343877492034228, -0.368756321188065],
              [31.342508887139328, -0.371033329606438],
              [31.341942715846653, -0.374559307748866],
              [31.34207002149545, -0.376652943735313],
              [31.342635220810966, -0.378342633618252],
              [31.34564435333229, -0.382989565426852],
              [31.34354596877865, -0.385578629707357],
              [31.342394326787748, -0.386021461255528],
              [31.341883401885067, -0.38671923334652],
              [31.341298493532232, -0.392632651295808],
              [31.340678108013858, -0.393348763310151],
              [31.339589474755343, -0.396653886732361],
              [31.342177778007045, -0.398346034848749],
              [31.35109225733973, -0.407635365160495],
              [31.354732476111046, -0.40936329986158],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1248,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "KYAZANGA",
        Population: 34772,
        Key: "LWENGOKYAZANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.52516413605489, -0.340048533289096],
            [31.525545037006697, -0.336711239717836],
            [31.526542788606257, -0.336928451295192],
            [31.52774323696482, -0.335264478421136],
            [31.52724481122102, -0.332107924809556],
            [31.52878971857527, -0.330552534970257],
            [31.528944392297536, -0.328770818978458],
            [31.528635799437865, -0.327142795621537],
            [31.527341411555092, -0.324212233979315],
            [31.527104703681086, -0.320558290199134],
            [31.526534761260898, -0.318695075849781],
            [31.526393047533222, -0.314245240155996],
            [31.525537828924886, -0.312662356854821],
            [31.52360089588231, -0.315049791531791],
            [31.515106385233164, -0.314840576164574],
            [31.512801365706284, -0.315464296675342],
            [31.50809626423424, -0.318023156271195],
            [31.50633807167867, -0.317263177948603],
            [31.503938134362276, -0.318122031412618],
            [31.501704661156182, -0.317190151425206],
            [31.500663107703385, -0.317208096794646],
            [31.500416983688602, -0.316574969374542],
            [31.499680295985346, -0.316620076689587],
            [31.49932448857266, -0.317406872054104],
            [31.49704183619804, -0.31682772089155],
            [31.49542462254822, -0.315823574217837],
            [31.493808586589765, -0.316302685181483],
            [31.492881326688867, -0.316013136522478],
            [31.492003004309716, -0.317188744685041],
            [31.49025566519944, -0.3171704022663],
            [31.488543531065158, -0.316329048536666],
            [31.484098987737887, -0.317070028748826],
            [31.48283855257958, -0.316400565021169],
            [31.481315758154352, -0.314790486860467],
            [31.480162509077413, -0.31453709031328],
            [31.477121798977254, -0.316499220992517],
            [31.47543473233097, -0.317141108653681],
            [31.474602348897115, -0.316960106285052],
            [31.472201531231736, -0.3165165869586],
            [31.470228746426166, -0.316661011393646],
            [31.467992856751987, -0.315222666100057],
            [31.466138585783522, -0.315077688291178],
            [31.46238139288749, -0.313539641157205],
            [31.459910701564343, -0.314805448075706],
            [31.457723511358342, -0.314588063547523],
            [31.455703987208526, -0.315691142098164],
            [31.45451514867668, -0.315085021127972],
            [31.450474680140648, -0.315681316474754],
            [31.445209706362707, -0.31583428556656],
            [31.442573035121153, -0.317696950672065],
            [31.439887204473976, -0.317841241243732],
            [31.43802191477025, -0.318401695103898],
            [31.43533508699313, -0.317677771935583],
            [31.432504941097246, -0.316212219922297],
            [31.4299150136915, -0.31717048580835],
            [31.425314983666627, -0.316527680084782],
            [31.422795626112958, -0.316889042548388],
            [31.419327143664404, -0.318869130725174],
            [31.41734456273066, -0.320957960575628],
            [31.415253556938776, -0.321699231504044],
            [31.40840019016029, -0.326111552720586],
            [31.40124254692709, -0.335588323616292],
            [31.39743100954962, -0.339277559659423],
            [31.384039915237395, -0.345967688031528],
            [31.37868978656043, -0.349240607196134],
            [31.378334926870355, -0.350967887018443],
            [31.378603647107823, -0.358745506979912],
            [31.379291568867583, -0.364343686491084],
            [31.376021985101, -0.370010028859833],
            [31.374714594104482, -0.374804257817856],
            [31.375050774226512, -0.380150363694661],
            [31.376503906098097, -0.384021629313459],
            [31.372271524179684, -0.384314668443293],
            [31.372180140362453, -0.385214550759256],
            [31.374076460571054, -0.390118451236974],
            [31.374604894536926, -0.39329575317768],
            [31.371976988157595, -0.398162044560386],
            [31.369249066947777, -0.401357062254554],
            [31.368446060220375, -0.403000592882826],
            [31.367907483376605, -0.405094124782648],
            [31.36789814808417, -0.409182710757485],
            [31.35757722232525, -0.407351109461265],
            [31.35612726060829, -0.407377956731571],
            [31.355414660331075, -0.407875200284614],
            [31.354732476111046, -0.40936329986158],
            [31.353944558385457, -0.411700337336752],
            [31.353947066481723, -0.414549064492066],
            [31.35436421894686, -0.415968999557356],
            [31.36316778329139, -0.425819342958159],
            [31.36615585121757, -0.431219021699789],
            [31.37011035277758, -0.441050329618796],
            [31.370919453675896, -0.442180972243909],
            [31.37462919576201, -0.444099032703425],
            [31.378376862922785, -0.448422743644309],
            [31.379771178499446, -0.45261932911527],
            [31.37953877894555, -0.458723775010528],
            [31.38036418246962, -0.46469280361611],
            [31.38156646069644, -0.468783601972423],
            [31.388606198251974, -0.46760555111566],
            [31.395443335168196, -0.468789093189943],
            [31.40120970092702, -0.471241280249894],
            [31.405734319180425, -0.467453027648276],
            [31.40763228150932, -0.463975920357595],
            [31.412212587225486, -0.463349585145008],
            [31.415677690211957, -0.467158227445466],
            [31.417519111678573, -0.468605306727195],
            [31.41836701440728, -0.470182010038619],
            [31.42396941516886, -0.475265955651008],
            [31.42544484232747, -0.477138376187016],
            [31.426540507598034, -0.479887974867741],
            [31.428563916063133, -0.483099023311887],
            [31.430074461061142, -0.487171081554925],
            [31.43540813260214, -0.489488953531279],
            [31.442354651082308, -0.49467415970653],
            [31.44602305000411, -0.496162563981141],
            [31.448028246923418, -0.497585322414215],
            [31.447889054766794, -0.503468973178507],
            [31.44677363194984, -0.507168326998133],
            [31.452945504414465, -0.505361689657796],
            [31.457947545800295, -0.505116735790284],
            [31.460665158842218, -0.502725255185246],
            [31.46295168565065, -0.502337019151253],
            [31.46122310246518, -0.499859677126923],
            [31.45981279597815, -0.496776192690975],
            [31.46505723965859, -0.49565298048637],
            [31.47446236173146, -0.492378236356169],
            [31.479506491883303, -0.489496507188836],
            [31.48038746519086, -0.487298265823932],
            [31.481527345539725, -0.485833374828113],
            [31.48277212396095, -0.482306431932584],
            [31.484932364708428, -0.478933450376909],
            [31.48510620308894, -0.47739596993746],
            [31.48436778433215, -0.472466749148559],
            [31.48442200754101, -0.459036193656352],
            [31.49109846729393, -0.442568144472434],
            [31.49623913220286, -0.436030235417301],
            [31.500775904662024, -0.432277783762469],
            [31.502451404600748, -0.429420143977417],
            [31.503700717717493, -0.422203087857073],
            [31.505257720887094, -0.419399675975224],
            [31.50525879976374, -0.415112693152483],
            [31.5048432148588, -0.414054454247807],
            [31.503607864256473, -0.412860374594182],
            [31.504677835913295, -0.409577518331722],
            [31.504654466241167, -0.408437929327492],
            [31.50309900278399, -0.404449134334566],
            [31.503753557520827, -0.40064163812809],
            [31.504490145511102, -0.399565506911026],
            [31.504419622371405, -0.396788910164225],
            [31.50360087626189, -0.39251988662854],
            [31.503743805410103, -0.390774370555818],
            [31.50238981251159, -0.388883890035185],
            [31.502093311873985, -0.387463886484641],
            [31.503674617166926, -0.381811523034964],
            [31.504192696252527, -0.378019416040139],
            [31.495369449820124, -0.380718211302366],
            [31.494430713043144, -0.38159421910181],
            [31.489164451081102, -0.382787100462506],
            [31.488708706991385, -0.383612609490973],
            [31.488622217195815, -0.386593602323208],
            [31.489653487633575, -0.388565099650947],
            [31.4907231260154, -0.389623069674243],
            [31.495212259018423, -0.391431716314881],
            [31.494714399213258, -0.397893702700582],
            [31.491641954329033, -0.398544371779341],
            [31.4871888374807, -0.404373834033336],
            [31.480881219695224, -0.408135018816405],
            [31.471082675053776, -0.415603591589476],
            [31.468796664776633, -0.416633470324753],
            [31.463272827076512, -0.421966072004196],
            [31.458734449327928, -0.423368373176066],
            [31.45054753440851, -0.419958441838139],
            [31.450236484656543, -0.420619172681977],
            [31.450741268675937, -0.424123976700269],
            [31.449382762641438, -0.423081050379609],
            [31.44649185559805, -0.419170177836654],
            [31.448792562313237, -0.409946737132362],
            [31.44498817013554, -0.412691589125801],
            [31.44061981472414, -0.409541795940474],
            [31.438055771374987, -0.408397037258041],
            [31.437346309811367, -0.408503491202393],
            [31.43641394478473, -0.409792335957077],
            [31.436447306417737, -0.413226738471192],
            [31.43243716231075, -0.411340830053386],
            [31.429932189479704, -0.413048741925015],
            [31.428175501602272, -0.41084507069392],
            [31.42782720769864, -0.404371599978861],
            [31.42962056480596, -0.402879698804936],
            [31.434177025641205, -0.394921907018251],
            [31.436337557442847, -0.392073471227349],
            [31.439195581655248, -0.385272943526011],
            [31.44176078742441, -0.383193293389454],
            [31.445001035807042, -0.37866284189387],
            [31.44591363969406, -0.375940767551192],
            [31.44614598175577, -0.370152662181844],
            [31.44657538813968, -0.370170349640663],
            [31.446288317117606, -0.368868788829882],
            [31.448248209302232, -0.367904605642579],
            [31.449511105844383, -0.368124036183835],
            [31.45181235334539, -0.370248422388859],
            [31.456946210821076, -0.370679087293138],
            [31.458514548932918, -0.370010106113339],
            [31.4590852998369, -0.368291842505304],
            [31.460330794215384, -0.369205500058363],
            [31.464275972161044, -0.369767710666615],
            [31.466186713923186, -0.372406716075723],
            [31.46897114545257, -0.375045878794875],
            [31.4710252664189, -0.375341662523234],
            [31.470353430790965, -0.376176556759673],
            [31.47090935679781, -0.376565702137922],
            [31.476676278613773, -0.373695130699447],
            [31.481076845814634, -0.370927353980565],
            [31.484446412072327, -0.366544406374217],
            [31.485019614478716, -0.36634758323283],
            [31.48549186601009, -0.367138892057549],
            [31.48642871273168, -0.366885634327044],
            [31.487474719133363, -0.367130001613727],
            [31.489211206594995, -0.368324124594676],
            [31.490209772966526, -0.368568493638574],
            [31.49113655047211, -0.368306362573567],
            [31.4913626797853, -0.367546692763882],
            [31.494012599380675, -0.364318359003709],
            [31.496593297495213, -0.363739960737927],
            [31.49793192381248, -0.363604514589544],
            [31.499437178631783, -0.364210729533134],
            [31.50063120852765, -0.364084309481557],
            [31.505420284512468, -0.3653041250615],
            [31.507147902008995, -0.363994944185985],
            [31.507825386243468, -0.362041511469952],
            [31.509156385863943, -0.360422794771196],
            [31.51243609454208, -0.358478821260425],
            [31.516047759463792, -0.357647328124497],
            [31.51715314450575, -0.355404518132022],
            [31.52202354407493, -0.351932282197949],
            [31.524105289134535, -0.346496973817754],
            [31.52527009144434, -0.344805867678624],
            [31.525591493381626, -0.341441429149582],
            [31.52516413605489, -0.340048533289096],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1249,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "LWENGO",
        Population: 49913,
        Key: "LWENGOLWENGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.505420284512468, -0.3653041250615],
            [31.50063120852765, -0.364084309481557],
            [31.499437178631783, -0.364210729533134],
            [31.49793192381248, -0.363604514589544],
            [31.496593297495213, -0.363739960737927],
            [31.494012599380675, -0.364318359003709],
            [31.4913626797853, -0.367546692763882],
            [31.49113655047211, -0.368306362573567],
            [31.490209772966526, -0.368568493638574],
            [31.489211206594995, -0.368324124594676],
            [31.487474719133363, -0.367130001613727],
            [31.48642871273168, -0.366885634327044],
            [31.48549186601009, -0.367138892057549],
            [31.485019614478716, -0.36634758323283],
            [31.484446412072327, -0.366544406374217],
            [31.481076845814634, -0.370927353980565],
            [31.476676278613773, -0.373695130699447],
            [31.47090935679781, -0.376565702137922],
            [31.470353430790965, -0.376176556759673],
            [31.4710252664189, -0.375341662523234],
            [31.46897114545257, -0.375045878794875],
            [31.466186713923186, -0.372406716075723],
            [31.464275972161044, -0.369767710666615],
            [31.460330794215384, -0.369205500058363],
            [31.4590852998369, -0.368291842505304],
            [31.458514548932918, -0.370010106113339],
            [31.456946210821076, -0.370679087293138],
            [31.45181235334539, -0.370248422388859],
            [31.449511105844383, -0.368124036183835],
            [31.448248209302232, -0.367904605642579],
            [31.446288317117606, -0.368868788829882],
            [31.44657538813968, -0.370170349640663],
            [31.44614598175577, -0.370152662181844],
            [31.44591363969406, -0.375940767551192],
            [31.445001035807042, -0.37866284189387],
            [31.44176078742441, -0.383193293389454],
            [31.439195581655248, -0.385272943526011],
            [31.436337557442847, -0.392073471227349],
            [31.434177025641205, -0.394921907018251],
            [31.42962056480596, -0.402879698804936],
            [31.42782720769864, -0.404371599978861],
            [31.428175501602272, -0.41084507069392],
            [31.429932189479704, -0.413048741925015],
            [31.43243716231075, -0.411340830053386],
            [31.436447306417737, -0.413226738471192],
            [31.43641394478473, -0.409792335957077],
            [31.437346309811367, -0.408503491202393],
            [31.438055771374987, -0.408397037258041],
            [31.44061981472414, -0.409541795940474],
            [31.44498817013554, -0.412691589125801],
            [31.448792562313237, -0.409946737132362],
            [31.44649185559805, -0.419170177836654],
            [31.449382762641438, -0.423081050379609],
            [31.450741268675937, -0.424123976700269],
            [31.450236484656543, -0.420619172681977],
            [31.45054753440851, -0.419958441838139],
            [31.458734449327928, -0.423368373176066],
            [31.463272827076512, -0.421966072004196],
            [31.468796664776633, -0.416633470324753],
            [31.471082675053776, -0.415603591589476],
            [31.480881219695224, -0.408135018816405],
            [31.4871888374807, -0.404373834033336],
            [31.491641954329033, -0.398544371779341],
            [31.494714399213258, -0.397893702700582],
            [31.495212259018423, -0.391431716314881],
            [31.4907231260154, -0.389623069674243],
            [31.489653487633575, -0.388565099650947],
            [31.488622217195815, -0.386593602323208],
            [31.488708706991385, -0.383612609490973],
            [31.489164451081102, -0.382787100462506],
            [31.494430713043144, -0.38159421910181],
            [31.495369449820124, -0.380718211302366],
            [31.504192696252527, -0.378019416040139],
            [31.50440118085692, -0.373545215845723],
            [31.50597011814506, -0.371130670805654],
            [31.504438310024252, -0.368082498942336],
            [31.504795172957397, -0.366147085154335],
            [31.505420284512468, -0.3653041250615],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1250,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "LWENGO TOWN COUNCIL",
        Population: 14305,
        Key: "LWENGOLWENGO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.313000564952485, -0.312576170176129],
            [31.312548644092626, -0.312313831877851],
            [31.309577762734442, -0.312602742845099],
            [31.304835911184103, -0.312348764145289],
            [31.298084095355236, -0.310683706579511],
            [31.29550325710352, -0.308567152165314],
            [31.293860648978953, -0.305862941335463],
            [31.288057236697828, -0.301693062617518],
            [31.286456051687654, -0.305174483187798],
            [31.284675211705455, -0.306892413000711],
            [31.28125728374613, -0.311910865298394],
            [31.27505762908473, -0.315970270467339],
            [31.271030769126927, -0.317895795989652],
            [31.27012866744387, -0.318944653616214],
            [31.266209233417623, -0.321412776745936],
            [31.262063882080575, -0.323618609776594],
            [31.257073036398133, -0.324069909878251],
            [31.254040595290157, -0.321971390690397],
            [31.25144899072976, -0.320894807306907],
            [31.250498217426298, -0.320912738297025],
            [31.25049898818081, -0.321410101605105],
            [31.244864248967318, -0.321761825126192],
            [31.237416946665704, -0.320792939950866],
            [31.23180258303948, -0.318766338996922],
            [31.231053626146068, -0.32230201579487],
            [31.228433312327496, -0.323477158815725],
            [31.228376071677616, -0.331398801221687],
            [31.22466323489533, -0.335747810469758],
            [31.2158851207211, -0.345955672385331],
            [31.21367305077502, -0.346561144694731],
            [31.21057991409656, -0.348396266663816],
            [31.20126316378975, -0.356822433809355],
            [31.19594582901053, -0.359660835435233],
            [31.19131400131956, -0.363835686878324],
            [31.187441618352953, -0.36851205186027],
            [31.186893611893687, -0.370329529582011],
            [31.186867390968843, -0.373630147055448],
            [31.178955029946312, -0.380283969879925],
            [31.176408021349882, -0.400973197288449],
            [31.168223048588093, -0.411085930673386],
            [31.167683999230512, -0.411668741708901],
            [31.16767144168115, -0.412609172632636],
            [31.170276791363708, -0.417369307597284],
            [31.186538423420235, -0.420254645255827],
            [31.193929141740416, -0.416205185570275],
            [31.20773138417838, -0.435804268951087],
            [31.211536297378952, -0.438499953806283],
            [31.219237117728465, -0.456596722107377],
            [31.228040613801046, -0.457069132895347],
            [31.234902114824447, -0.455587771737847],
            [31.237327179815985, -0.455633582572277],
            [31.24283125547816, -0.457335015872642],
            [31.24406287088552, -0.457959290944444],
            [31.246560644617826, -0.460311109948021],
            [31.257356248257743, -0.452572835563375],
            [31.26689182816776, -0.444363919054244],
            [31.271130574649945, -0.439761939221459],
            [31.274111240458215, -0.437239563539828],
            [31.276854838168035, -0.435295900969568],
            [31.27908818381334, -0.434265484853292],
            [31.28085574759393, -0.43200607088051],
            [31.289099704635575, -0.42670757791887],
            [31.29981022524167, -0.416527156622667],
            [31.304492565201063, -0.410906973805041],
            [31.30719495269724, -0.408316296036094],
            [31.311427522363548, -0.402312209320446],
            [31.311525436034543, -0.400926830982049],
            [31.31181348981355, -0.396851052328552],
            [31.311005446232354, -0.396292107896547],
            [31.31055703419198, -0.39503613138065],
            [31.309015418264895, -0.388238624343877],
            [31.309245625929506, -0.386189597804469],
            [31.308173792065112, -0.38321492433769],
            [31.30828349522592, -0.381804831632991],
            [31.30932336433756, -0.380350856064132],
            [31.311238592286234, -0.379315676447961],
            [31.320584399499225, -0.377015027930272],
            [31.323320827754745, -0.373545325437873],
            [31.32878222715271, -0.369304961257653],
            [31.3298218168883, -0.367120043094907],
            [31.330699246342064, -0.366161605226082],
            [31.33160045509974, -0.364199328345882],
            [31.3316347069632, -0.362607681323333],
            [31.331062373227702, -0.360717492942599],
            [31.3302294166687, -0.359469347133493],
            [31.32854859600857, -0.35395251541577],
            [31.325599144859808, -0.351844860701592],
            [31.323103062655168, -0.35133798326967],
            [31.320332869423005, -0.349980966904003],
            [31.315506877171607, -0.349139067115478],
            [31.314152104535417, -0.349238301263622],
            [31.308931864163707, -0.345963658262613],
            [31.306301457772914, -0.341522899508944],
            [31.30434745224837, -0.336286458000423],
            [31.305390279512256, -0.333193804396396],
            [31.307360063944746, -0.329947572795027],
            [31.30714377387887, -0.327388264353449],
            [31.310502048313413, -0.322062269117403],
            [31.310714251943097, -0.320416411604403],
            [31.312090216735147, -0.317712674541058],
            [31.313000564952485, -0.312576170176129],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1251,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "MALONGO",
        Population: 38511,
        Key: "LWENGOMALONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.48510620308894, -0.47739596993746],
            [31.484932364708428, -0.478933450376909],
            [31.48277212396095, -0.482306431932584],
            [31.481527345539725, -0.485833374828113],
            [31.48038746519086, -0.487298265823932],
            [31.479506491883303, -0.489496507188836],
            [31.47446236173146, -0.492378236356169],
            [31.46505723965859, -0.49565298048637],
            [31.45981279597815, -0.496776192690975],
            [31.46122310246518, -0.499859677126923],
            [31.46295168565065, -0.502337019151253],
            [31.460665158842218, -0.502725255185246],
            [31.457947545800295, -0.505116735790284],
            [31.452945504414465, -0.505361689657796],
            [31.44677363194984, -0.507168326998133],
            [31.447889054766794, -0.503468973178507],
            [31.448028246923418, -0.497585322414215],
            [31.44602305000411, -0.496162563981141],
            [31.442354651082308, -0.49467415970653],
            [31.43540813260214, -0.489488953531279],
            [31.430074461061142, -0.487171081554925],
            [31.428563916063133, -0.483099023311887],
            [31.426540507598034, -0.479887974867741],
            [31.42544484232747, -0.477138376187016],
            [31.42396941516886, -0.475265955651008],
            [31.41836701440728, -0.470182010038619],
            [31.417519111678573, -0.468605306727195],
            [31.415677690211957, -0.467158227445466],
            [31.412212587225486, -0.463349585145008],
            [31.40763228150932, -0.463975920357595],
            [31.405734319180425, -0.467453027648276],
            [31.40120970092702, -0.471241280249894],
            [31.395443335168196, -0.468789093189943],
            [31.388606198251974, -0.46760555111566],
            [31.38156646069644, -0.468783601972423],
            [31.381997806543055, -0.47071628300968],
            [31.375389872974917, -0.470868500090731],
            [31.372718347100324, -0.473635229758582],
            [31.371673917241978, -0.475335194512366],
            [31.363222110704818, -0.480531658042397],
            [31.361410217759893, -0.480731812713167],
            [31.36036357175774, -0.479890498146879],
            [31.35535832877622, -0.477935885372207],
            [31.35066225896603, -0.478231719940687],
            [31.35029769028439, -0.484913309311427],
            [31.35117693523336, -0.489816044232488],
            [31.34904496536617, -0.490610660356467],
            [31.345397497190504, -0.491234738397988],
            [31.340958634809116, -0.49128050947252],
            [31.33962373021206, -0.491873907521929],
            [31.33849045427719, -0.49302983310237],
            [31.339312547509422, -0.495014343508311],
            [31.34357917859638, -0.501030837952641],
            [31.346581740839664, -0.503648702057303],
            [31.35018386385644, -0.498181029381092],
            [31.352176019932784, -0.496247269240846],
            [31.353163658298858, -0.498190377794858],
            [31.357689424599183, -0.502589280636951],
            [31.35869068591654, -0.504163121273865],
            [31.36115446200863, -0.506144301087411],
            [31.361644284586962, -0.507464790861282],
            [31.36095628916538, -0.51384940657433],
            [31.361687815149015, -0.517394687058296],
            [31.361499495926093, -0.51831708353259],
            [31.36038525529208, -0.519420127248512],
            [31.355735066935043, -0.522177206160296],
            [31.35526154608417, -0.522963874846393],
            [31.360792581086308, -0.527107293310453],
            [31.366251014247194, -0.536251847973845],
            [31.38900091978445, -0.575055529585945],
            [31.4039924436237, -0.582122958461078],
            [31.407696492187508, -0.587351333873727],
            [31.4088385725105, -0.588274135379149],
            [31.418468465643883, -0.586838898856534],
            [31.420986492792615, -0.586712997588974],
            [31.42286423853606, -0.587256163267706],
            [31.42682452883973, -0.58990714672253],
            [31.43019966555049, -0.596853821753521],
            [31.43084089288179, -0.596835928283944],
            [31.433213361513435, -0.595253913589718],
            [31.439953579193677, -0.598086588248159],
            [31.440570270839586, -0.597489861799964],
            [31.442198451122408, -0.591982544386632],
            [31.44410324963061, -0.588193659554223],
            [31.444361916821734, -0.586810004264373],
            [31.443011298893747, -0.582513731477669],
            [31.441582000224955, -0.580487487187129],
            [31.440936793356983, -0.578624251134677],
            [31.440203302757833, -0.574129205599981],
            [31.44080246737424, -0.570801189951297],
            [31.440536411539927, -0.56835019852198],
            [31.439865387988966, -0.565365515102166],
            [31.438924405423816, -0.563999624779401],
            [31.43851744165065, -0.562498212740301],
            [31.439013105973277, -0.56087043586837],
            [31.441395621363096, -0.558347803909131],
            [31.441465677378837, -0.55777805739867],
            [31.444192369693322, -0.555219335093038],
            [31.44526019527494, -0.554667936408647],
            [31.458587707729638, -0.555024138547168],
            [31.460677686747168, -0.554708148506146],
            [31.46390131360214, -0.551100400242504],
            [31.465372130606713, -0.550051670959861],
            [31.46674478780189, -0.547546812139069],
            [31.467338366693845, -0.547275641996282],
            [31.46874034400158, -0.547565411805952],
            [31.470269666483983, -0.546091612145679],
            [31.472645352881006, -0.546182662144755],
            [31.478175614433706, -0.54368789203079],
            [31.481455992356704, -0.538786804605658],
            [31.486069044359905, -0.535134106951676],
            [31.487994767326065, -0.532593171677208],
            [31.491842365773987, -0.529482913753453],
            [31.500754641539256, -0.519563569726747],
            [31.51708920422044, -0.505630181154918],
            [31.513975750345192, -0.502717211979818],
            [31.509023530423317, -0.495363104984736],
            [31.507835575833713, -0.49450363797123],
            [31.50610115449724, -0.494259053790895],
            [31.50560238110539, -0.493662013420688],
            [31.50281058339067, -0.492503732654268],
            [31.50250262833487, -0.48982656671319],
            [31.50209877093594, -0.489175296629594],
            [31.497484840380412, -0.487003645229887],
            [31.492948817116165, -0.484271283883743],
            [31.48655045152066, -0.479621158531015],
            [31.48510620308894, -0.47739596993746],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1252,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "NDAGWE",
        Population: 38638,
        Key: "LWENGONDAGWE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19131400131956, -0.363835686878324],
            [31.173382009484403, -0.351690093776499],
            [31.171372418006726, -0.350707786500782],
            [31.169786848411093, -0.34896684350856],
            [31.164357712006584, -0.347826841403445],
            [31.16126941455255, -0.346651306950012],
            [31.159452637467442, -0.343910312922702],
            [31.159618475452035, -0.339613653933005],
            [31.158723118320154, -0.337383589226761],
            [31.1575426601716, -0.336116655080531],
            [31.15152723470361, -0.332138140933103],
            [31.14743868563859, -0.327950110053214],
            [31.146357424853623, -0.325628718759728],
            [31.14507767412006, -0.31900879143523],
            [31.142931308750484, -0.31299128985624],
            [31.140368791639, -0.311624723777231],
            [31.138394237152315, -0.312555758959974],
            [31.123063741227128, -0.31740884382591],
            [31.119792682426883, -0.317122333253554],
            [31.119852034117674, -0.317743684806181],
            [31.113747291855947, -0.319440888753279],
            [31.110886111861976, -0.319540349573556],
            [31.109390403439154, -0.317846145071398],
            [31.106831782321056, -0.317178123167884],
            [31.104714543926228, -0.317308903292076],
            [31.103672020292926, -0.318423624437969],
            [31.102759942818643, -0.318685788311728],
            [31.100985649758265, -0.318255706750377],
            [31.094421433601777, -0.318520295143908],
            [31.093444065674312, -0.319602228161071],
            [31.092140588637513, -0.322782743398462],
            [31.091391297570816, -0.323471220148026],
            [31.09034734381957, -0.323687423222713],
            [31.092305315406097, -0.327539623515149],
            [31.103237225813963, -0.339106870170106],
            [31.115364901662787, -0.375197522842779],
            [31.118002860190177, -0.377675714611596],
            [31.12467618482276, -0.391159466657509],
            [31.124179924018794, -0.403628921009188],
            [31.132337243042876, -0.420232827561099],
            [31.15294492264735, -0.440845838691927],
            [31.154740049435787, -0.4694752222683],
            [31.154691791938742, -0.470478925575334],
            [31.15317868135226, -0.474195044286299],
            [31.152820054127915, -0.477007200651766],
            [31.15466523234906, -0.490047148949664],
            [31.157996294118693, -0.488058684623857],
            [31.161373763754252, -0.487770245146556],
            [31.16490436021317, -0.489046223307875],
            [31.17213140818352, -0.492927516982252],
            [31.175686598718272, -0.493679040354823],
            [31.178588360105223, -0.49321866455752],
            [31.182133755410096, -0.490778090303611],
            [31.18888102666195, -0.484603699860717],
            [31.19048591093447, -0.482135441877827],
            [31.19220347179139, -0.478138973914404],
            [31.198287054236626, -0.468953057188489],
            [31.201774564799525, -0.464450614098956],
            [31.206328755592082, -0.461069731546725],
            [31.20802077554886, -0.460301519843537],
            [31.212801785560735, -0.459199482369537],
            [31.219237117728465, -0.456596722107377],
            [31.211536297378952, -0.438499953806283],
            [31.20773138417838, -0.435804268951087],
            [31.193929141740416, -0.416205185570275],
            [31.186538423420235, -0.420254645255827],
            [31.170276791363708, -0.417369307597284],
            [31.166627013619436, -0.422145768813142],
            [31.165837403467847, -0.424750142764378],
            [31.16477280193978, -0.426301540778867],
            [31.16095578124583, -0.419300510912192],
            [31.158579079752556, -0.420335663928081],
            [31.154141558555867, -0.419687236954635],
            [31.153089754427352, -0.420228452883335],
            [31.149672603510744, -0.420788812255295],
            [31.146991567172243, -0.419501577232018],
            [31.145037637106192, -0.417402407840601],
            [31.14448431172207, -0.415565909152906],
            [31.144387098736978, -0.41336880333726],
            [31.14503961699306, -0.408810825789749],
            [31.144681755133313, -0.406843205837151],
            [31.141159629787555, -0.400735428035079],
            [31.139870267080482, -0.396565635658249],
            [31.141453289952274, -0.395090460197529],
            [31.14427919041011, -0.394112084207785],
            [31.146555016486882, -0.391378757373037],
            [31.149079229434662, -0.390207376998377],
            [31.154785766497234, -0.389765303829776],
            [31.158106689880597, -0.390671157427952],
            [31.16111543163475, -0.392777625197565],
            [31.16444934286051, -0.396515639321918],
            [31.16617357011516, -0.399083637143289],
            [31.166918950815425, -0.401001821403944],
            [31.167808049384725, -0.405842857213],
            [31.168223048588093, -0.411085930673386],
            [31.176408021349882, -0.400973197288449],
            [31.178955029946312, -0.380283969879925],
            [31.186867390968843, -0.373630147055448],
            [31.186893611893687, -0.370329529582011],
            [31.187441618352953, -0.36851205186027],
            [31.19131400131956, -0.363835686878324],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1253,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "LYANTONDE",
        Population: 18044,
        Key: "LYANTONDELYANTONDE",
        Dist2: "Lyantonde",
        "Sub Country": "Lyantonde",
        id2_original: "Lyantonde Lyantonde",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.32426368151066, -0.109986563836784],
            [31.304804873492724, -0.105170910701105],
            [31.27387818333751, -0.095922300181423],
            [31.27120401911094, -0.096624467332004],
            [31.268410117541812, -0.096461784461629],
            [31.265869895717362, -0.094040173245618],
            [31.253504520254463, -0.089283814601561],
            [31.24195290075965, -0.097412851949629],
            [31.22994940352409, -0.107347809656675],
            [31.22614827223086, -0.110972727132451],
            [31.224503535997403, -0.116301893918577],
            [31.21801029483315, -0.125412826203268],
            [31.20984431694805, -0.139574398177316],
            [31.203598454745087, -0.146413396659614],
            [31.20219466194215, -0.146693630585655],
            [31.197799045356835, -0.148818335898464],
            [31.20209114907198, -0.157054552453609],
            [31.206186669961905, -0.166184357560377],
            [31.207306488235528, -0.174018334790119],
            [31.20524565326076, -0.178061962478547],
            [31.199455827998268, -0.182479688091755],
            [31.19252622838817, -0.189028028040795],
            [31.19523894112022, -0.191845641247637],
            [31.19685462134583, -0.19562609327011],
            [31.196473991685217, -0.199167076594274],
            [31.19162519390367, -0.204478070452675],
            [31.190488752305722, -0.207171865249364],
            [31.1905790806025, -0.208258223122817],
            [31.19100668496593, -0.209837371829575],
            [31.19238482098604, -0.212277959320112],
            [31.19490370243258, -0.214814387908163],
            [31.19832530989132, -0.220556994897153],
            [31.198467779102124, -0.221609750589074],
            [31.195567843990137, -0.225772492126613],
            [31.19475951743959, -0.228117122439516],
            [31.194426595507093, -0.229744035687374],
            [31.19485397349509, -0.232997999067217],
            [31.194568303844846, -0.236778240610649],
            [31.19100202001467, -0.247544369571112],
            [31.190811693057103, -0.249027740976964],
            [31.191381774716177, -0.251228989502248],
            [31.198437551691125, -0.257244213815319],
            [31.200521551522105, -0.262557026610959],
            [31.202605746287535, -0.266426942891627],
            [31.20367995978911, -0.271510073984081],
            [31.20580413946613, -0.277006464470071],
            [31.205470562661787, -0.278134609464204],
            [31.20564905072224, -0.28087453549645],
            [31.20611250415371, -0.281729534492533],
            [31.207395469059353, -0.282909178819839],
            [31.212152377272172, -0.285420535632939],
            [31.21680560732475, -0.285097496477306],
            [31.223467919510316, -0.286111076375937],
            [31.226965913412577, -0.287041548691436],
            [31.23104114136024, -0.28895059008047],
            [31.231820943705554, -0.289718754838194],
            [31.231985865408575, -0.290774488126274],
            [31.231397020638155, -0.293981518172129],
            [31.22846249499784, -0.299047066393317],
            [31.228032152569384, -0.300455131178667],
            [31.22794644520645, -0.306203430310472],
            [31.225482048378495, -0.314299788632719],
            [31.223252265451613, -0.3210161417469],
            [31.220635301450756, -0.3244913019304],
            [31.220162757966925, -0.325763577061199],
            [31.22034121009473, -0.327679823086301],
            [31.220968132653415, -0.329302298452234],
            [31.22466323489533, -0.335747810469758],
            [31.228376071677616, -0.331398801221687],
            [31.228433312327496, -0.323477158815725],
            [31.231053626146068, -0.32230201579487],
            [31.23180258303948, -0.318766338996922],
            [31.237416946665704, -0.320792939950866],
            [31.244864248967318, -0.321761825126192],
            [31.25049898818081, -0.321410101605105],
            [31.250498217426298, -0.320912738297025],
            [31.25144899072976, -0.320894807306907],
            [31.254040595290157, -0.321971390690397],
            [31.257073036398133, -0.324069909878251],
            [31.262063882080575, -0.323618609776594],
            [31.266209233417623, -0.321412776745936],
            [31.27012866744387, -0.318944653616214],
            [31.271030769126927, -0.317895795989652],
            [31.27505762908473, -0.315970270467339],
            [31.28125728374613, -0.311910865298394],
            [31.284675211705455, -0.306892413000711],
            [31.286456051687654, -0.305174483187798],
            [31.288057236697828, -0.301693062617518],
            [31.289012928277458, -0.3007527146821],
            [31.2928073186128, -0.291737144482701],
            [31.294664441732248, -0.282802630044079],
            [31.29522824686244, -0.275956913858024],
            [31.293439807132966, -0.269951916806077],
            [31.293485296022325, -0.267871958048322],
            [31.29674819901812, -0.262600152478266],
            [31.299762502242203, -0.256324481151958],
            [31.302526888764323, -0.25275273398102],
            [31.303984690078757, -0.250175562320973],
            [31.304670782868584, -0.247815340251489],
            [31.306030342626915, -0.238229548111365],
            [31.308529073065028, -0.232876173250121],
            [31.310807565341555, -0.226338072417372],
            [31.313449039874957, -0.216788546607842],
            [31.313568567011718, -0.214808048541767],
            [31.31464981342363, -0.212872880692098],
            [31.314480325584036, -0.212230781023447],
            [31.315145345693953, -0.212294157630123],
            [31.315544323444218, -0.211489339114578],
            [31.316019300464184, -0.211480341649975],
            [31.317697011156795, -0.210096888880985],
            [31.321636163203532, -0.203378024778008],
            [31.32401372079127, -0.201849929067534],
            [31.325377128932296, -0.199417378955954],
            [31.32698491566151, -0.198223807200564],
            [31.326744392642496, -0.19767213531403],
            [31.327216329763523, -0.197147657946803],
            [31.32770598076364, -0.193448927337552],
            [31.328222336880543, -0.192372805625714],
            [31.327907193505805, -0.191206163814054],
            [31.328923479146315, -0.190347135720964],
            [31.33125645963472, -0.185138313054074],
            [31.33253248415646, -0.177080675422627],
            [31.332836461472176, -0.167729737155651],
            [31.33212628305297, -0.153223912969959],
            [31.33143703268494, -0.146676381192085],
            [31.32758804364494, -0.127033688469724],
            [31.324331851962626, -0.115783423332551],
            [31.32404954380819, -0.114110371076716],
            [31.32426368151066, -0.109986563836784],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1255,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "MPUMUDDE",
        Population: 23799,
        Key: "LYANTONDEMPUMUDDE",
        Dist2: "Lyantonde",
        "Sub Country": "Mpumudde",
        id2_original: "Lyantonde Mpumudde",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.74961474509627, 0.268904449646911],
            [32.706888181525905, 0.269115374445745],
            [32.70549137492096, 0.269789540034848],
            [32.6874473955092, 0.289379372064335],
            [32.68705482993339, 0.289783324915147],
            [32.684837962085346, 0.287783828949597],
            [32.67421889446679, 0.281133832881306],
            [32.67206213648766, 0.278962442131259],
            [32.668758788642805, 0.274592553079941],
            [32.65874176653778, 0.263224249553031],
            [32.650055773697595, 0.252869732119646],
            [32.64147891179144, 0.23881018892682],
            [32.63950139555926, 0.234331786746332],
            [32.63674901232596, 0.220570973477711],
            [32.63425030793898, 0.214319319945125],
            [32.62594921175706, 0.186453746937607],
            [32.619610391888465, 0.164693055302676],
            [32.61991931442983, 0.158771266865502],
            [32.61992765708388, 0.126006849229838],
            [32.64271911060133, 0.131208070840562],
            [32.67570986247982, 0.141381945928068],
            [32.70097305385771, 0.155146357310878],
            [32.71940028062081, 0.171304455791404],
            [32.72770399000189, 0.180751819662656],
            [32.72941323784921, 0.182042429051338],
            [32.730338372336135, 0.183913497058946],
            [32.734702264018864, 0.187044872085516],
            [32.74477813655481, 0.196646930980981],
            [32.74853741174571, 0.201892275387201],
            [32.74978001175234, 0.202620476660376],
            [32.751655651844764, 0.205063415241715],
            [32.752361800421625, 0.209854802622446],
            [32.752771378292266, 0.216948625244764],
            [32.75835473027826, 0.218167009566056],
            [32.75980513755958, 0.219351942569328],
            [32.760280657161964, 0.221278924202091],
            [32.758794472677806, 0.226724697107281],
            [32.75867556268365, 0.228041260314838],
            [32.75910353445807, 0.229453584840316],
            [32.76090857954556, 0.230975536936646],
            [32.762472633591806, 0.231369209625826],
            [32.76490720455569, 0.233066456413843],
            [32.76374046457985, 0.236654170854088],
            [32.764697477581244, 0.237123813257076],
            [32.7645746940516, 0.240015100376441],
            [32.76330004395223, 0.242443260102407],
            [32.76373325200642, 0.244974706740604],
            [32.76349454987249, 0.245427033090111],
            [32.75985655532982, 0.247078659418479],
            [32.75771649793012, 0.251363444447506],
            [32.75464911235762, 0.255648208308014],
            [32.75101109535706, 0.258329144016781],
            [32.74880211651382, 0.259217194177878],
            [32.74983578186014, 0.263791682367448],
            [32.74961474509627, 0.268904449646911],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1710,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "MPATTA",
        Population: 17145,
        Key: "MUKONOMPATTA",
        Dist2: "Mukono",
        "Sub Country": "Mpunge",
        id2_original: "MukonoMpunge",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.61992765708388, 0.126006849229838],
            [32.61991931442983, 0.158771266865502],
            [32.619610391888465, 0.164693055302676],
            [32.5657379751422, 0.151483347920583],
            [32.55838586731123, 0.142567245052006],
            [32.55275286543949, 0.137019199897578],
            [32.54840526111114, 0.13717148546185],
            [32.539695998311885, 0.146120101268319],
            [32.53950390167319, 0.145307498669949],
            [32.53797863867757, 0.143445486542148],
            [32.533874023243705, 0.141002863419112],
            [32.52771016195482, 0.132180031037431],
            [32.52322193984349, 0.128351332259501],
            [32.51911680248843, 0.125693514919682],
            [32.51583443749202, 0.124265475493076],
            [32.5132192979695, 0.123625172229808],
            [32.49995424807145, 0.124182915122619],
            [32.49573301604234, 0.123333163846709],
            [32.481997983757275, 0.1183458946711],
            [32.47397063568344, 0.114698789771001],
            [32.4661093546646, 0.11028698147234],
            [32.46505078083213, 0.109509947367476],
            [32.46352773038702, 0.107239088545092],
            [32.46269542241166, 0.107167129125225],
            [32.460751604680766, 0.106078324377128],
            [32.46158565898102, 0.103121857821518],
            [32.463771548426486, 0.099776739068524],
            [32.470546896522556, 0.096672058211426],
            [32.477226448276724, 0.092276814114818],
            [32.48055326011676, 0.088071692291059],
            [32.48389291966201, 0.085647028039535],
            [32.48784941368532, 0.080569792227517],
            [32.49097320627116, 0.074703635316746],
            [32.491328484576115, 0.072074882186135],
            [32.490866743333584, 0.053577127314478],
            [32.48958484742312, 0.035592945286808],
            [32.49016545284576, 0.010069286036457],
            [32.490797695227585, -0.00092654394357],
            [32.49041931405011, -0.020104433986596],
            [32.48861280381039, -0.118225338321939],
            [32.48674501140029, -0.15264877764134],
            [32.500986982763074, -0.152486254118029],
            [32.52692766915521, -0.119257064684865],
            [32.587768924821546, -0.042619929615691],
            [32.59821977032678, -0.029926865679834],
            [32.61842303108528, -0.003726392357257],
            [32.62010043814734, -0.002106958972562],
            [32.62005702975616, 0.047641214050579],
            [32.61992765708388, 0.126006849229838],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1713,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "KATABI  TOWN COUNCIL",
        Population: 105669,
        Key: "WAKISOKATABI  TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [32.3170119892192, 0.829935460449225],
              [32.31440944587362, 0.836992027764998],
              [32.309296145444875, 0.844545095601544],
              [32.30964632311568, 0.849502736749069],
              [32.311430794986535, 0.85126716059746],
              [32.31247860251033, 0.853040498429578],
              [32.30701556009374, 0.856142516618598],
              [32.30824845470203, 0.864058579602026],
              [32.307024791181576, 0.874851031565204],
              [32.306146409513616, 0.875755534887425],
              [32.304673001767746, 0.876162358585181],
              [32.30227259014089, 0.876134768260717],
              [32.2964357281918, 0.874550501973824],
              [32.291423879898, 0.872152190774912],
              [32.29081108334717, 0.873812226647822],
              [32.28511353752225, 0.868651945381977],
              [32.28387303957336, 0.868685274438037],
              [32.28227692824789, 0.867077982036655],
              [32.28277703743455, 0.860048814828441],
              [32.2824863992025, 0.858333285727732],
              [32.28094899367914, 0.855571497947794],
              [32.281275561827634, 0.85036388560077],
              [32.28352501246937, 0.849832072323517],
              [32.28481043696223, 0.843799309867069],
              [32.29143071517901, 0.842775309923468],
              [32.295908550070706, 0.836620310412873],
              [32.292740917004046, 0.820661955971348],
              [32.288778954935616, 0.813480271111149],
              [32.28826990391861, 0.808697906865629],
              [32.29657260628828, 0.806700649198901],
              [32.30499428872071, 0.803273424193876],
              [32.31018666694557, 0.802469157944821],
              [32.310851529850304, 0.801845050790775],
              [32.31253494843824, 0.798244756519115],
              [32.314734631514874, 0.795874895958344],
              [32.31637547804317, 0.796616998904515],
              [32.31970365622079, 0.797259870842935],
              [32.32443556521755, 0.799214746646337],
              [32.328667162906726, 0.800264866536745],
              [32.333956461265906, 0.801116129378781],
              [32.34193078178854, 0.801171710796384],
              [32.34476481469466, 0.806328813157108],
              [32.34675225371745, 0.808780804124364],
              [32.353362927147195, 0.81166778880263],
              [32.35901363481319, 0.816599186462145],
              [32.359299936877385, 0.817621517099234],
              [32.35899918810677, 0.821616599085887],
              [32.358580963951525, 0.822913759426874],
              [32.355693099502005, 0.824062228515357],
              [32.34965526016938, 0.823373684418709],
              [32.34616151080683, 0.823400247553457],
              [32.344094122622074, 0.823825101394632],
              [32.34123225811181, 0.825697298294682],
              [32.33945045962721, 0.826321224807223],
              [32.33220123135416, 0.826320000530811],
              [32.32062543280517, 0.825512861875145],
              [32.3182255089635, 0.827701746659965],
              [32.3170119892192, 0.829935460449225],
            ],
          ],
          [
            [
              [32.34718261231555, 1.014808660844098],
              [32.32718861859406, 1.012951924584589],
              [32.31434031422428, 1.01688503007905],
              [32.299817348942284, 1.015757367278237],
              [32.2813852371407, 1.010692973508011],
              [32.266305723319356, 1.00113123792172],
              [32.24563918699578, 0.997752992333342],
              [32.2411674759194, 1.011245991807823],
              [32.240046758432186, 1.026426513884397],
              [32.23501547778212, 1.043405273042984],
              [32.22272324225134, 1.057458456708332],
              [32.202611758772136, 1.06757374060928],
              [32.19759520779781, 1.072874940176225],
              [32.18986839289893, 1.068022703491572],
              [32.184426163549126, 1.063986554736286],
              [32.178519368653504, 1.057996261871829],
              [32.173919895584135, 1.055507274858936],
              [32.16801246917289, 1.049933122987842],
              [32.162296409968285, 1.047208629722277],
              [32.159520385771636, 1.046411801667166],
              [32.15102357004547, 1.045993361614624],
              [32.14426110379061, 1.046371452481223],
              [32.12692758936064, 1.050111788552059],
              [32.124211307621984, 1.049712986463093],
              [32.12270335156861, 1.048952673933001],
              [32.12006567421391, 1.046681316863296],
              [32.11925399784569, 1.044736142399506],
              [32.11895612458231, 1.042338800938049],
              [32.11973471779527, 1.037001731296446],
              [32.11886472010385, 1.033690559015727],
              [32.11420936733223, 1.028623357105433],
              [32.11264682155734, 1.024217401924387],
              [32.10087191591722, 1.016488628230304],
              [32.099693164567675, 1.013593510611538],
              [32.096335149746224, 1.002203404688256],
              [32.09345491918001, 0.999760130057396],
              [32.091420586302746, 0.997344231008432],
              [32.08780976759407, 0.991264191777045],
              [32.085547857319355, 0.985121212021737],
              [32.08433766134162, 0.979114221289152],
              [32.09586347134, 0.971609034891414],
              [32.09643524812003, 0.97062315332249],
              [32.096893618883655, 0.966253962346736],
              [32.09792380774978, 0.961767322188277],
              [32.09961696048214, 0.956566203711193],
              [32.10167560177099, 0.954124270982485],
              [32.10275064351925, 0.952025831828259],
              [32.10405564859039, 0.945748098720415],
              [32.105702399745034, 0.9428446898285],
              [32.10602360405299, 0.938746833341434],
              [32.1055668637316, 0.936910331852535],
              [32.105820842615266, 0.927638018096159],
              [32.10520493699522, 0.921025071988046],
              [32.10596395681642, 0.902082467445706],
              [32.12622347995949, 0.897962335344861],
              [32.131818492077876, 0.896172516010143],
              [32.13799593319891, 0.893324403479378],
              [32.155412428604926, 0.88250001158889],
              [32.16823228782123, 0.870751686117798],
              [32.17468398370019, 0.864465876123016],
              [32.17589588108706, 0.86281969827382],
              [32.18459568732134, 0.844457371169152],
              [32.18993471371971, 0.832227728871568],
              [32.20186859870726, 0.831216983643117],
              [32.20797376048223, 0.831236317844777],
              [32.217405820335536, 0.829733431668563],
              [32.22853367666304, 0.844107602479568],
              [32.24438463310767, 0.852089555528539],
              [32.24596715831277, 0.865813457721029],
              [32.22614750602837, 0.88495845477379],
              [32.238826845378014, 0.898525063405119],
              [32.24675287067432, 0.900122461053878],
              [32.252302185494194, 0.896134224615442],
              [32.2562650144369, 0.897730791571303],
              [32.261019773879525, 0.903316965927629],
              [32.26711337254016, 0.901030087536395],
              [32.27430554521626, 0.899211875659307],
              [32.27773643406851, 0.90137011889091],
              [32.280863431843265, 0.902691549371922],
              [32.29245020151685, 0.902558144548699],
              [32.30068490411446, 0.901691274455726],
              [32.30479515557842, 0.900208416522292],
              [32.31902894778057, 0.897343326564167],
              [32.32577846212568, 0.896865114046097],
              [32.33815165832147, 0.898568179032836],
              [32.343361762103534, 0.898551034997515],
              [32.34704814080574, 0.900677686978843],
              [32.35058871754741, 0.899891257836766],
              [32.356292637817575, 0.899530408656903],
              [32.368109054607004, 0.902517931064792],
              [32.368894195640074, 0.903259904846155],
              [32.372716593649315, 0.909982336817479],
              [32.39460786518348, 0.910284659019545],
              [32.394483622789785, 0.919259087927054],
              [32.39405929637883, 0.922289702137864],
              [32.392721874702346, 0.927102380641077],
              [32.38900899300433, 0.933280710657635],
              [32.387382793506745, 0.935071693491753],
              [32.38422511736668, 0.938210378423766],
              [32.38099513493112, 0.9404534100663],
              [32.378978328185056, 0.943411351179779],
              [32.37746994812685, 0.944360992188881],
              [32.37357362056635, 0.945816818561001],
              [32.37036725034802, 0.947887945660134],
              [32.36852703981039, 0.949579355520227],
              [32.36405401270209, 0.956110296760739],
              [32.36384120091297, 0.957204915608754],
              [32.36243983356133, 0.958091236738289],
              [32.36203713858237, 0.95930342794497],
              [32.360398633063724, 0.960669180305519],
              [32.3607796543898, 0.961239198851874],
              [32.360627345033365, 0.963184224492417],
              [32.359393209851646, 0.964902875140888],
              [32.35946671270315, 0.966838896156454],
              [32.358944215702955, 0.967363508508312],
              [32.358779161947595, 0.968367668233408],
              [32.359159911084156, 0.968874358826614],
              [32.35862562549252, 0.969362782022569],
              [32.35874538888619, 0.970222247805073],
              [32.358294515461935, 0.970719732608715],
              [32.35858056330292, 0.971506856338141],
              [32.358179554461756, 0.974157479875559],
              [32.357610084555404, 0.975043952866927],
              [32.357063277346995, 0.974899098942282],
              [32.35667165679889, 0.975432782610936],
              [32.35752931882483, 0.977350859950714],
              [32.357436304565375, 0.979087820064956],
              [32.35696153954782, 0.979666720344154],
              [32.35705768443603, 0.980661882889885],
              [32.356630873285, 0.981620755834004],
              [32.35690512444967, 0.982398830509114],
              [32.35557629426055, 0.984280296626815],
              [32.356029338912855, 0.985646445757883],
              [32.355363949595386, 0.98580915687856],
              [32.354557100773505, 0.986930796893049],
              [32.35370181029993, 0.987292499263383],
              [32.354168344054514, 0.990069943363149],
              [32.35357548920465, 0.99129113810052],
              [32.35310023550362, 0.991481026098949],
              [32.353196633716735, 0.992602842036022],
              [32.35243726445087, 0.993634021331316],
              [32.35274789918118, 0.995063469425446],
              [32.35241672267527, 0.996709911652854],
              [32.35132997857379, 0.9986095128584],
              [32.35090555783971, 1.001649134591342],
              [32.3479660959569, 1.005719578717674],
              [32.34765020877713, 1.006714657073632],
              [32.34718261231555, 1.014808660844098],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2008,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "WAKYATO",
        Population: 12984,
        Key: "NAKASEKEWAKYATO",
        Dist2: "Nakaseke",
        "Sub Country": "Wakyato",
        id2_original: "NakasekeWakyato",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "VH",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.253504520254463, -0.089283814601561],
            [31.23664844961823, -0.081631694152622],
            [31.21662273458743, -0.071665518436589],
            [31.21441252864553, -0.070797322538272],
            [31.206740219026504, -0.069567189375701],
            [31.206512353269822, -0.049491979127829],
            [31.191472944734368, -0.046118619561044],
            [31.16101704544988, -0.036035317867101],
            [31.16347964474897, -0.030456036190796],
            [31.12671445681256, -0.030699601768992],
            [31.116518102230675, -0.04087217055786],
            [31.100970532010344, -0.039696317464083],
            [31.0914477737544, -0.043891742472934],
            [31.095835779812646, -0.049959242138447],
            [31.096750162363918, -0.052617707240091],
            [31.09855376745202, -0.054390053776728],
            [31.09817929753934, -0.055918205046247],
            [31.09855115245624, -0.057220312415929],
            [31.098226669297507, -0.057826133243271],
            [31.098373137807954, -0.059263874426784],
            [31.097699931350885, -0.063468539109451],
            [31.098480671537367, -0.066470613433823],
            [31.09838263928872, -0.068622686999714],
            [31.09895876750799, -0.071552422427277],
            [31.098720402242304, -0.073107697795559],
            [31.099220291341716, -0.073261441636045],
            [31.098883456347828, -0.073722579729712],
            [31.099546387874696, -0.074491208186599],
            [31.098943930034434, -0.077429943444324],
            [31.09928997186167, -0.078270903216201],
            [31.10024678274215, -0.078931034073142],
            [31.100441207814047, -0.080775676005105],
            [31.101522297919136, -0.082936849693075],
            [31.10120784534886, -0.08498944221769],
            [31.102400362481784, -0.086879355312503],
            [31.101767412227545, -0.087150596808158],
            [31.102116520903138, -0.088407499213994],
            [31.101643274038413, -0.088841508046235],
            [31.102350835665245, -0.089483550270343],
            [31.102572256908044, -0.090333545027137],
            [31.10183399176315, -0.091780283558424],
            [31.10216481612946, -0.093652063834217],
            [31.100338813346355, -0.096753490375935],
            [31.100013113868755, -0.098787993665821],
            [31.100162604311805, -0.100686901738556],
            [31.10082915964253, -0.101961908271955],
            [31.09935000986538, -0.106030883529919],
            [31.099543750421017, -0.109394641624632],
            [31.09880602875687, -0.110904656521094],
            [31.09906362066457, -0.112044008300756],
            [31.09854656835335, -0.112695026914909],
            [31.098195333365457, -0.114340707640971],
            [31.097978519581737, -0.120543740408532],
            [31.09848384259032, -0.123084670650729],
            [31.09817306053632, -0.124043130405838],
            [31.09861058858869, -0.124983558286439],
            [31.097225660406735, -0.129549834526722],
            [31.10500359124196, -0.137706620218464],
            [31.111933004002495, -0.146107559031095],
            [31.12029415256118, -0.154978893988886],
            [31.136817649811228, -0.167232764314197],
            [31.135969374281693, -0.174277301720659],
            [31.132435875366117, -0.182901689314193],
            [31.13420900690485, -0.190579354328747],
            [31.142033916934476, -0.192233815474535],
            [31.150603024583127, -0.191780554178443],
            [31.150204423226917, -0.184316046229058],
            [31.153507724359386, -0.181984013699805],
            [31.158498668856506, -0.179544136852412],
            [31.16049476853697, -0.181410514139861],
            [31.163963646244245, -0.189880455415087],
            [31.167907933061162, -0.197154208423059],
            [31.16942877005738, -0.198542053245223],
            [31.171805202056092, -0.199595036794332],
            [31.173183591401077, -0.199690890046528],
            [31.177319015455943, -0.197633746038762],
            [31.19048610497058, -0.188782646469816],
            [31.191531822114726, -0.188543496474733],
            [31.19252622838817, -0.189028028040795],
            [31.199455827998268, -0.182479688091755],
            [31.20524565326076, -0.178061962478547],
            [31.207306488235528, -0.174018334790119],
            [31.206186669961905, -0.166184357560377],
            [31.20209114907198, -0.157054552453609],
            [31.197799045356835, -0.148818335898464],
            [31.20219466194215, -0.146693630585655],
            [31.203598454745087, -0.146413396659614],
            [31.20984431694805, -0.139574398177316],
            [31.21801029483315, -0.125412826203268],
            [31.224503535997403, -0.116301893918577],
            [31.22614827223086, -0.110972727132451],
            [31.22994940352409, -0.107347809656675],
            [31.24195290075965, -0.097412851949629],
            [31.253504520254463, -0.089283814601561],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1257,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "KASAGAMA",
        Population: 11037,
        Key: "LYANTONDEKASAGAMA",
        Dist2: "Lyantonde",
        "Sub Country": "Kasagama",
        id2_original: "Lyantonde Kasagama",
        drought: "VH",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.150603024583127, -0.191780554178443],
            [31.142033916934476, -0.192233815474535],
            [31.13420900690485, -0.190579354328747],
            [31.132435875366117, -0.182901689314193],
            [31.135969374281693, -0.174277301720659],
            [31.136817649811228, -0.167232764314197],
            [31.12029415256118, -0.154978893988886],
            [31.111933004002495, -0.146107559031095],
            [31.10500359124196, -0.137706620218464],
            [31.097225660406735, -0.129549834526722],
            [31.096777752321238, -0.132452390522177],
            [31.095192761240703, -0.135960686560737],
            [31.09532737378602, -0.137389384683302],
            [31.094370335631776, -0.139930197345059],
            [31.09474920998433, -0.143845544606732],
            [31.092934081307757, -0.146874570453048],
            [31.09304082721465, -0.149153241975504],
            [31.091786976707372, -0.153041314870953],
            [31.091352947593027, -0.15739062351251],
            [31.089807272179193, -0.160094125322967],
            [31.08788466996035, -0.162381642000017],
            [31.085900229513943, -0.168756256469851],
            [31.08306877028114, -0.174000483551125],
            [31.08330303024599, -0.175067498393305],
            [31.08147324645387, -0.180899560350077],
            [31.081644228191777, -0.185872807713243],
            [31.07966327590367, -0.19279894602288],
            [31.078416592155726, -0.194435448835919],
            [31.075050501479872, -0.201053958373872],
            [31.074553107002004, -0.201261879351477],
            [31.072173119471415, -0.204634330502182],
            [31.07162925155064, -0.206298023067033],
            [31.071861284591886, -0.207048556112568],
            [31.070653797034733, -0.209453634770254],
            [31.070507630358243, -0.21123491909265],
            [31.071209699685387, -0.212772181141726],
            [31.07161575795674, -0.215692860394671],
            [31.073012452272284, -0.217646155758166],
            [31.07401246942299, -0.217989882838005],
            [31.074723363799485, -0.220756886531806],
            [31.0751513661166, -0.221010126915063],
            [31.07457801638652, -0.222655730265137],
            [31.074836352099275, -0.223930720126641],
            [31.074550172205953, -0.225187546980836],
            [31.07350046564366, -0.227086270665325],
            [31.0727861657539, -0.229057368089701],
            [31.072153749098934, -0.229409938745538],
            [31.071128429999945, -0.23358728182219],
            [31.07045192582747, -0.234111639357438],
            [31.069873505107598, -0.235693947346645],
            [31.06990973595964, -0.237638011699068],
            [31.06943671996193, -0.238099100384342],
            [31.06843302510847, -0.242113686442528],
            [31.069278565267975, -0.243045150195431],
            [31.069636684045864, -0.247231725528882],
            [31.07067042934223, -0.249184992276147],
            [31.0706581502706, -0.250649821549011],
            [31.07158697863, -0.252159995377897],
            [31.07118495109932, -0.252820023429121],
            [31.071950370518604, -0.254691866849157],
            [31.071426098447454, -0.256364593222882],
            [31.071377222909476, -0.258471423134401],
            [31.072243974987742, -0.260270942212223],
            [31.07195663357277, -0.26348991450871],
            [31.072146554491816, -0.264113856132047],
            [31.07347768167308, -0.265018289182588],
            [31.07379733189559, -0.267134216577041],
            [31.073249527557234, -0.268400031396943],
            [31.074223156696473, -0.270588405629413],
            [31.07386519512372, -0.272885058468937],
            [31.07432741247338, -0.275064298822693],
            [31.078947064398985, -0.284270029855791],
            [31.08217985676478, -0.304760292047233],
            [31.08965987570905, -0.318388341853359],
            [31.089681376885373, -0.322014296245754],
            [31.09034734381957, -0.323687423222713],
            [31.091391297570816, -0.323471220148026],
            [31.092140588637513, -0.322782743398462],
            [31.093444065674312, -0.319602228161071],
            [31.094421433601777, -0.318520295143908],
            [31.100985649758265, -0.318255706750377],
            [31.102759942818643, -0.318685788311728],
            [31.103672020292926, -0.318423624437969],
            [31.104714543926228, -0.317308903292076],
            [31.106831782321056, -0.317178123167884],
            [31.109390403439154, -0.317846145071398],
            [31.110886111861976, -0.319540349573556],
            [31.113747291855947, -0.319440888753279],
            [31.119852034117674, -0.317743684806181],
            [31.119792682426883, -0.317122333253554],
            [31.123063741227128, -0.31740884382591],
            [31.138394237152315, -0.312555758959974],
            [31.140368791639, -0.311624723777231],
            [31.14412360579615, -0.309988689340962],
            [31.148547833723292, -0.308696366656043],
            [31.153252847160452, -0.308931383181963],
            [31.155439357341752, -0.308405406554618],
            [31.15658024649869, -0.307544293963242],
            [31.156865620603217, -0.306443778316235],
            [31.156106144437828, -0.300366624085255],
            [31.15634417103864, -0.298117687410037],
            [31.1549668605703, -0.291466231373039],
            [31.159247235881075, -0.274862748838291],
            [31.159390390506463, -0.27113041876076],
            [31.157775044454112, -0.266392961788397],
            [31.15739787510398, -0.2625546227445],
            [31.15542402759145, -0.256869175450306],
            [31.152970415038485, -0.252922292034922],
            [31.151487414183713, -0.251628992870415],
            [31.151280051575085, -0.249932979080301],
            [31.151801638581883, -0.246916148507104],
            [31.15336574383207, -0.242554966404082],
            [31.153594209663343, -0.239144581187697],
            [31.1545390927135, -0.237177157456637],
            [31.15646117570608, -0.23517706828244],
            [31.157830050993912, -0.228946664191604],
            [31.158206331910247, -0.226347607959689],
            [31.157849645945202, -0.224938146937697],
            [31.158222863606394, -0.223047101714453],
            [31.156608201172, -0.211514905891708],
            [31.155610336384736, -0.209122259252468],
            [31.15201868862251, -0.195331373012037],
            [31.150603024583127, -0.191780554178443],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1258,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "KINUUKA",
        Population: 8738,
        Key: "LYANTONDEKINUUKA",
        Dist2: "Lyantonde",
        "Sub Country": "Kinuuka",
        id2_original: "Lyantonde Kinuuka",
        drought: "VH",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.19033188316135, 0.195048805087551],
            [32.18792383495623, 0.194658959169927],
            [32.18414990105652, 0.194949065719195],
            [32.18084249911484, 0.193382021196386],
            [32.174139841793234, 0.193154964316966],
            [32.17156372239173, 0.193458708138597],
            [32.15783176953149, 0.197227780907408],
            [32.15545611816876, 0.197115616128586],
            [32.15352907737409, 0.196299367654499],
            [32.14684502506037, 0.190450215932345],
            [32.14654006049614, 0.189150028473478],
            [32.146693938311046, 0.174849026439817],
            [32.145505654039745, 0.17212209869104],
            [32.145740292195306, 0.167160856278508],
            [32.14615727757378, 0.166694959610114],
            [32.14665922920509, 0.166860881333447],
            [32.14680314290686, 0.165334122770077],
            [32.14673349023468, 0.143005530819826],
            [32.147427840338594, 0.143063231227358],
            [32.14924769145861, 0.142280214442587],
            [32.15146261265745, 0.139867777195283],
            [32.15606136527795, 0.137103421206072],
            [32.15783140751043, 0.13428199508448],
            [32.15855985227262, 0.130846159423552],
            [32.15903333000436, 0.125125706460092],
            [32.16445611801479, 0.094163366240883],
            [32.165861546649836, 0.090706615797346],
            [32.167316805732014, 0.089288260358499],
            [32.16965835345331, 0.087836476795874],
            [32.173156557561356, 0.087333693013733],
            [32.174610803343874, 0.087693614290582],
            [32.1786887972043, 0.089737455181612],
            [32.184559241771936, 0.093500043039761],
            [32.18828285204941, 0.097564005853766],
            [32.19036990974565, 0.10095038798326],
            [32.19248658579509, 0.105723426665724],
            [32.193908014323675, 0.111880965286295],
            [32.19485756052843, 0.118305626876046],
            [32.19486693265181, 0.128334956012967],
            [32.19526636584794, 0.131696477286918],
            [32.19742100380299, 0.137583428310835],
            [32.20123677044883, 0.143282217352027],
            [32.202271266736766, 0.15170928061024],
            [32.20388808692446, 0.157354468255346],
            [32.20659207342184, 0.161598086930148],
            [32.208188535988576, 0.168440918627654],
            [32.20777410092719, 0.175998207948718],
            [32.207873999875005, 0.183821289961366],
            [32.20566560224176, 0.185818725824389],
            [32.200784360905445, 0.185077711224625],
            [32.199697267359284, 0.187415824909919],
            [32.19685008401575, 0.189864174438258],
            [32.19534316641482, 0.19003335681925],
            [32.19410430519641, 0.190874651384405],
            [32.19316379694172, 0.192498370529583],
            [32.19033188316135, 0.195048805087551],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1259,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "BUDDE",
        Population: 13734,
        Key: "BUTAMBALABUDDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.185085280829284, 0.253317798428687],
            [32.18111461588237, 0.256094047619187],
            [32.17591951666049, 0.258930041649677],
            [32.17109329174541, 0.256344711009701],
            [32.169655101551946, 0.253077442148322],
            [32.168727964720254, 0.25154552221893],
            [32.16806228345034, 0.251162515708424],
            [32.15876608569892, 0.252167192610238],
            [32.15689987162878, 0.250048800462367],
            [32.15599642067619, 0.249833327218626],
            [32.156303940049064, 0.249207831726228],
            [32.15605810798674, 0.247118438245951],
            [32.154882974152876, 0.245015370406832],
            [32.15302693350333, 0.244826710649475],
            [32.14996847359146, 0.24538909309212],
            [32.1490156296713, 0.245212108636882],
            [32.14790995357518, 0.244231018955194],
            [32.143904594793696, 0.238558437354608],
            [32.140453952886666, 0.229796173487232],
            [32.13954984706222, 0.229713387212861],
            [32.13724067462379, 0.231261599518275],
            [32.13522327768457, 0.233327541503845],
            [32.13441221306907, 0.234950618379837],
            [32.13275956357625, 0.235802497948395],
            [32.13200944785615, 0.235682091481827],
            [32.13026587538184, 0.234994023711046],
            [32.124972092632746, 0.229848406507526],
            [32.12136505942463, 0.225593144871436],
            [32.120414223239116, 0.223709033775672],
            [32.118091878803675, 0.221428275190013],
            [32.117651493210374, 0.22043833551335],
            [32.11824082666431, 0.213542782998972],
            [32.11810943457925, 0.209762815754071],
            [32.11695626006251, 0.200400956339933],
            [32.11658677759628, 0.199714983614427],
            [32.118317344261875, 0.199383680658778],
            [32.119541687807, 0.198490089611226],
            [32.12227200302704, 0.198287712068975],
            [32.124772069259976, 0.195871526844702],
            [32.12517062210715, 0.196375968345647],
            [32.12614482526983, 0.201021968665223],
            [32.12686913418848, 0.20191328685122],
            [32.12818865154302, 0.202891500277867],
            [32.13154588123691, 0.204328607011869],
            [32.135338600705815, 0.205439815015407],
            [32.1400810253813, 0.209276861875586],
            [32.143505015172146, 0.210357420119206],
            [32.15062612482105, 0.208780592696097],
            [32.1533743488546, 0.206254392176438],
            [32.15387832079698, 0.204777645909574],
            [32.15410863356448, 0.199546512792012],
            [32.15352907737409, 0.196299367654499],
            [32.15545611816876, 0.197115616128586],
            [32.15783176953149, 0.197227780907408],
            [32.17156372239173, 0.193458708138597],
            [32.174139841793234, 0.193154964316966],
            [32.18084249911484, 0.193382021196386],
            [32.18414990105652, 0.194949065719195],
            [32.18792383495623, 0.194658959169927],
            [32.19033188316135, 0.195048805087551],
            [32.192138837168834, 0.195423401284563],
            [32.193863836076325, 0.196514770715915],
            [32.19598987257102, 0.19923680699846],
            [32.197331976266746, 0.200119896763888],
            [32.19733832915245, 0.200617721185591],
            [32.19600231244109, 0.208590354136972],
            [32.19410703697318, 0.210915529752252],
            [32.191621465057345, 0.219128719143635],
            [32.18822988648194, 0.226180326788513],
            [32.18408243668037, 0.23732015454924],
            [32.18237669046608, 0.240531914581304],
            [32.18242451228023, 0.245214043590276],
            [32.183137759344454, 0.247101356939675],
            [32.18368015851974, 0.247391757109286],
            [32.183347179095065, 0.249330502703862],
            [32.185085280829284, 0.253317798428687],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1263,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "KIBIBI",
        Population: 14455,
        Key: "BUTAMBALAKIBIBI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.2387434485424, 0.09886881676834],
            [33.2211636007902, 0.105698514628685],
            [33.20986538346064, 0.109275501878672],
            [33.19860101644758, 0.113575123547645],
            [33.19856354951371, 0.070618558831168],
            [33.19817830071592, 0.062433711967795],
            [33.19852293667973, 0.05433050628],
            [33.19865090438688, 0.006140294873969],
            [33.19815592458051, -0.013991740111446],
            [33.19815597219123, -0.044155864156464],
            [33.23435090868695, -0.045187096551535],
            [33.259820129573555, -0.045263776720286],
            [33.26614845352638, -0.067973598074245],
            [33.27246642529384, -0.085119097716401],
            [33.27782305957008, -0.108210211464834],
            [33.28057025682927, -0.13752349737939],
            [33.28098248922158, -0.153701119693345],
            [33.28235610042756, -0.165592346913314],
            [33.28345524038167, -0.190757522500692],
            [33.28314209036856, -0.201630677716938],
            [33.28387142805616, -0.252473838542106],
            [33.2840371277002, -0.394043980045419],
            [33.285294183396424, -0.999285836969372],
            [33.36519796607289, -0.999253787260018],
            [33.363265432978565, -0.395663924732592],
            [33.362621038187605, -0.251487040660806],
            [33.362065257707854, -0.220632928925333],
            [33.36239367638583, -0.2002290503879],
            [33.36130297610383, -0.127946385318699],
            [33.36179605597337, -0.108742730912535],
            [33.36122028438528, -0.086683375481664],
            [33.36177518541437, -0.076688367780004],
            [33.361713251965455, -0.026630581690034],
            [33.36222710896919, -0.017587483155942],
            [33.36158989171737, -0.007923578260231],
            [33.3616926967151, 0.02110952655362],
            [33.361117229655896, 0.041347858022752],
            [33.36139678716895, 0.054606381474025],
            [33.353769775098094, 0.057073206174782],
            [33.348032340481325, 0.059564267303042],
            [33.34577049847859, 0.059930003595693],
            [33.33651790584939, 0.063158024044673],
            [33.313279971669424, 0.071990463074017],
            [33.274571570568305, 0.08553509718172],
            [33.2387434485424, 0.09886881676834],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1265,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "BUGAYA",
        Population: 4844,
        Key: "BUVUMABUGAYA",
        Dist2: "Buvuma",
        "Sub Country": "Bugaya",
        id2_original: "Buvuma Bugaya",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.31538089576039, 0.333541124935424],
            [33.30396014463279, 0.3338862302543],
            [33.30056257788771, 0.335243362085223],
            [33.29640799186953, 0.338496635503563],
            [33.29264587081582, 0.344422124211984],
            [33.28941472955353, 0.353716928640141],
            [33.28909014578349, 0.358500428015008],
            [33.251658427669206, 0.33451385450015],
            [33.24318143416809, 0.329616799721982],
            [33.22856347384146, 0.322319724902177],
            [33.216883521923464, 0.314586160944449],
            [33.20831018590477, 0.307991977299397],
            [33.18164560381903, 0.291967416533535],
            [33.17989308592115, 0.290779251830868],
            [33.17844813770179, 0.289179169783637],
            [33.17695500025734, 0.28578503151418],
            [33.17649254485414, 0.279236583143876],
            [33.17888684434386, 0.260999245590034],
            [33.18375743345752, 0.261632199142625],
            [33.19126899584471, 0.261584658098401],
            [33.19992155428829, 0.262202692557467],
            [33.210665940482265, 0.263961710087938],
            [33.2125676011752, 0.264532202497956],
            [33.21884308352806, 0.267574828240507],
            [33.22143555765764, 0.268303764495409],
            [33.226650178168946, 0.267700662872633],
            [33.229509332462, 0.267889419309988],
            [33.23615459821668, 0.256606493630403],
            [33.23903212665056, 0.254169332780238],
            [33.24618909435064, 0.250147686066786],
            [33.246712184238916, 0.249333799489727],
            [33.24605762590883, 0.24274316715827],
            [33.247121024592715, 0.240245077849163],
            [33.250411034252195, 0.237846529542673],
            [33.252566575912425, 0.237275419730057],
            [33.26020554276305, 0.237084920131572],
            [33.26674783284012, 0.237503576379165],
            [33.26867648790734, 0.237808108030649],
            [33.27184796486512, 0.242094840854432],
            [33.27592438936874, 0.240578499004737],
            [33.280218087593504, 0.237891355987355],
            [33.28573030738203, 0.236547714214078],
            [33.284627823000136, 0.234853726009289],
            [33.281552525066566, 0.232634048736182],
            [33.27824514737937, 0.231115345997474],
            [33.278100075749215, 0.230501999264438],
            [33.27920247928274, 0.228165409198169],
            [33.280362930153274, 0.22699710189536],
            [33.28216163582981, 0.225653539038031],
            [33.28517884240887, 0.224602024199326],
            [33.286647550169164, 0.223327330837885],
            [33.29168592571333, 0.224781953570537],
            [33.29534785496843, 0.226617105829358],
            [33.297580211568594, 0.228687981097053],
            [33.29809067024566, 0.230198436728734],
            [33.30012027439127, 0.232946154127491],
            [33.30178280804716, 0.234252416762976],
            [33.303376787670445, 0.234924739930677],
            [33.30489948867088, 0.235566997605953],
            [33.306514678416335, 0.237504814246997],
            [33.305835651774544, 0.242095389720192],
            [33.30535058128405, 0.243072115580965],
            [33.30593280187757, 0.247858005336753],
            [33.307171646028046, 0.24804564008303],
            [33.31899057899858, 0.25285337755086],
            [33.32419316657666, 0.254413370300065],
            [33.32579830956398, 0.258369356691687],
            [33.3304476076906, 0.266392724635727],
            [33.33210805006851, 0.268398550989603],
            [33.3327480736573, 0.270414484745536],
            [33.33141828766074, 0.278781793067437],
            [33.33049416737176, 0.290777307003331],
            [33.32931301662211, 0.294551784549443],
            [33.32807262647107, 0.302201311567708],
            [33.32725191754266, 0.304404130340971],
            [33.3250282665159, 0.314804374605145],
            [33.325100155993155, 0.319498895662734],
            [33.321154582788765, 0.325421346921661],
            [33.31864379426461, 0.330188177161535],
            [33.31538089576039, 0.333541124935424],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1266,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "BUSAMUZI",
        Population: 16287,
        Key: "BUVUMABUSAMUZI",
        Dist2: "Buvuma",
        "Sub Country": "Busamuzi",
        id2_original: "Buvuma Busamuzi",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.198607531928324, 0.115691683071342],
            [33.19831052104763, 0.234304739597608],
            [33.18065486896019, 0.244697690395755],
            [33.160420741190194, 0.223805458202972],
            [33.154758537783515, 0.217414328305324],
            [33.14903355740983, 0.209948865482935],
            [33.145158289054514, 0.20160706564589],
            [33.143940470871605, 0.199369947297833],
            [33.1420865538394, 0.197124409684831],
            [33.13195072594474, 0.188243382638752],
            [33.12677877091785, 0.184730804329637],
            [33.10451356756183, 0.163491140432876],
            [33.093469360556945, 0.146668211041354],
            [33.09038894042966, 0.142882532975598],
            [33.07737498582316, 0.131361418246887],
            [33.06777032906108, 0.125240491116509],
            [33.0596082211182, 0.120643803526376],
            [33.05456725752772, 0.118372520679323],
            [33.04400943794354, 0.114415520087076],
            [33.03903898042475, 0.113634769768608],
            [33.03108977140758, 0.109642269865175],
            [33.02869267097082, 0.108293691755202],
            [33.01933340250333, 0.101213648749043],
            [33.014733085915914, 0.096972718517835],
            [33.01402146031075, 0.095683161800567],
            [33.02774502110964, 0.076037568579087],
            [33.02840341255104, 0.076025516791839],
            [33.05732200243194, 0.060982104480884],
            [33.076264546859434, 0.049272303393215],
            [33.089919797967475, 0.041736547265924],
            [33.11096804821819, 0.043077209696698],
            [33.1301933912803, 0.054242403149716],
            [33.13426081825804, 0.059374573759942],
            [33.149472990788944, 0.073651815001717],
            [33.15671303558483, 0.086345734185562],
            [33.160590653034625, 0.090249446651293],
            [33.170352463767465, 0.094453413886896],
            [33.175884162624584, 0.098166019946406],
            [33.18616120029201, 0.106546683600452],
            [33.198607531928324, 0.115691683071342],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1268,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "BWEEMA",
        Population: 8774,
        Key: "BUVUMABWEEMA",
        Dist2: "Buvuma",
        "Sub Country": "Bweema",
        id2_original: "Buvuma Bweema",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "VH",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.01402146031075, 0.095683161800567],
            [33.01332302736389, 0.094417513663657],
            [33.00849357749692, 0.089342591299204],
            [33.00519756798966, 0.086698662993669],
            [33.00100264671691, 0.084143456516976],
            [32.98334168199286, 0.070125307755424],
            [32.971091816400744, 0.062406449911726],
            [32.967778184642526, 0.060702976519919],
            [32.95605709347779, 0.055539323686406],
            [32.945146789349145, 0.051511317440156],
            [32.9398943326964, 0.049985286983587],
            [32.927820732732705, 0.048618949044004],
            [32.91994204865186, 0.048885107189903],
            [32.91645216294334, 0.049452925783706],
            [32.907304427962295, 0.051990370819442],
            [32.901664204533986, 0.054652031141077],
            [32.89498406348499, 0.059460767065094],
            [32.890277993629084, 0.065582595229113],
            [32.88869167483854, 0.06906050489192],
            [32.884532014237315, 0.069344406450593],
            [32.87917371178957, 0.099616421474059],
            [32.873850698759426, 0.113066690667689],
            [32.87479917686733, 0.110694629003765],
            [32.86096023375842, 0.109350306252862],
            [32.84446990141034, 0.106643465226716],
            [32.84534736410177, 0.066863370084881],
            [32.846982535074105, 0.06166112175061],
            [32.85251887013644, 0.035046462474084],
            [32.85803450531967, 0.017231882372174],
            [32.860093940719224, 0.008660604620601],
            [32.868999700105455, -0.008827207967882],
            [32.872128988584215, -0.016600754827155],
            [32.87559983450029, -0.020798725655768],
            [32.87617222303302, -0.206877203590028],
            [32.87581258430564, -0.483406505696434],
            [32.87563939540706, -0.61578475265308],
            [32.875133705885865, -0.999419639540072],
            [33.029884969813146, -0.999375195865023],
            [33.02697907527755, -0.39720775847542],
            [33.02388592242944, -0.295494567416459],
            [33.07608777188624, -0.296047625818387],
            [33.078126943089615, -0.221305962392159],
            [33.079349520546906, -0.191938928970048],
            [33.08098208909984, -0.152724317603667],
            [33.08306228546395, -0.128595277246497],
            [33.07657609787131, 0.042256138076563],
            [33.081547045870245, 0.041521213064327],
            [33.089919797967475, 0.041736547265924],
            [33.076264546859434, 0.049272303393215],
            [33.05732200243194, 0.060982104480884],
            [33.02840341255104, 0.076025516791839],
            [33.02774502110964, 0.076037568579087],
            [33.01402146031075, 0.095683161800567],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1269,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "LWAJJE",
        Population: 4392,
        Key: "BUVUMALWAJJE",
        Dist2: "Buvuma",
        "Sub Country": "Lwajje",
        id2_original: "Buvuma Lwajje",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.19860101644758, 0.113575123547645],
            [33.198607531928324, 0.115691683071342],
            [33.18616120029201, 0.106546683600452],
            [33.175884162624584, 0.098166019946406],
            [33.170352463767465, 0.094453413886896],
            [33.160590653034625, 0.090249446651293],
            [33.15671303558483, 0.086345734185562],
            [33.149472990788944, 0.073651815001717],
            [33.13426081825804, 0.059374573759942],
            [33.1301933912803, 0.054242403149716],
            [33.11096804821819, 0.043077209696698],
            [33.089919797967475, 0.041736547265924],
            [33.081547045870245, 0.041521213064327],
            [33.07657609787131, 0.042256138076563],
            [33.08306228546395, -0.128595277246497],
            [33.08098208909984, -0.152724317603667],
            [33.079349520546906, -0.191938928970048],
            [33.078126943089615, -0.221305962392159],
            [33.07608777188624, -0.296047625818387],
            [33.02388592242944, -0.295494567416459],
            [33.02697907527755, -0.39720775847542],
            [33.029884969813146, -0.999375195865023],
            [33.285294183396424, -0.999285836969372],
            [33.2840371277002, -0.394043980045419],
            [33.28387142805616, -0.252473838542106],
            [33.28314209036856, -0.201630677716938],
            [33.28345524038167, -0.190757522500692],
            [33.28235610042756, -0.165592346913314],
            [33.28098248922158, -0.153701119693345],
            [33.28057025682927, -0.13752349737939],
            [33.27782305957008, -0.108210211464834],
            [33.27246642529384, -0.085119097716401],
            [33.26614845352638, -0.067973598074245],
            [33.259820129573555, -0.045263776720286],
            [33.23435090868695, -0.045187096551535],
            [33.19815597219123, -0.044155864156464],
            [33.19815592458051, -0.013991740111446],
            [33.19865090438688, 0.006140294873969],
            [33.19852293667973, 0.05433050628],
            [33.19817830071592, 0.062433711967795],
            [33.19856354951371, 0.070618558831168],
            [33.19860101644758, 0.113575123547645],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1270,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "LYABAANA",
        Population: 7034,
        Key: "BUVUMALYABAANA",
        Dist2: "Buvuma",
        "Sub Country": "Lyabaana",
        id2_original: "Buvuma Lyabaana",
        drought: "N",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.934548438677645, 1.029489811312403],
            [32.92614265552744, 1.032564542188422],
            [32.92602381470357, 1.033767833890811],
            [32.923991571307646, 1.036147231064294],
            [32.92263714182791, 1.036861934114644],
            [32.92114003382992, 1.036979515107052],
            [32.919357840086604, 1.036699000112873],
            [32.9181461277527, 1.03610184661489],
            [32.91764701659431, 1.03537804853771],
            [32.91584124297311, 1.034717546047693],
            [32.912431354037274, 1.033939385974993],
            [32.90960370725452, 1.034011681395073],
            [32.90813052588408, 1.032365029116449],
            [32.905825619544935, 1.031984972276446],
            [32.902903107074934, 1.029858765270558],
            [32.901524822832805, 1.029732060401596],
            [32.89647547077421, 1.02778672552517],
            [32.89523987133859, 1.027913347839722],
            [32.89331495865281, 1.028872300324811],
            [32.890415977551676, 1.028890295169763],
            [32.88626898678922, 1.030364858974777],
            [32.88344134539634, 1.030491418315052],
            [32.8786531560487, 1.030455048717202],
            [32.86276795672378, 1.029043019170729],
            [32.85563889159471, 1.0293774511068],
            [32.85004254188488, 1.030879042414734],
            [32.84267539266281, 1.034796161863773],
            [32.83985950482713, 1.035773126839813],
            [32.83679394013968, 1.03619819224055],
            [32.826563947243685, 1.03627002145976],
            [32.82452018295426, 1.037536528413552],
            [32.82089540083279, 1.042593754509028],
            [32.818970413586854, 1.044385005299346],
            [32.81704516672782, 1.045769126483111],
            [32.81276750343088, 1.047596422422137],
            [32.80805056845157, 1.048871800483923],
            [32.80294126732251, 1.049685734354933],
            [32.79420828720308, 1.050734650240075],
            [32.78463186449036, 1.051095889178725],
            [32.78124788925553, 1.029400318522806],
            [32.7779407792663, 1.013467862252806],
            [32.77693086896936, 0.999209310350153],
            [32.776950356122825, 0.997616993646896],
            [32.77836735955031, 0.993762955995066],
            [32.7811695462813, 0.978518505108473],
            [32.7853278198837, 0.944130111601843],
            [32.785772684477024, 0.93555332842427],
            [32.786662560987345, 0.915604152630421],
            [32.78638221205855, 0.911541911540119],
            [32.786613722280315, 0.905516443228217],
            [32.78918898019746, 0.891556653511083],
            [32.79034891543506, 0.887566871835295],
            [32.79178212986013, 0.883604247679301],
            [32.79490089727028, 0.878402238298368],
            [32.795659346661324, 0.876466162921674],
            [32.7958830244721, 0.874493868894323],
            [32.79576774187505, 0.866450833006661],
            [32.7946496259089, 0.855675464551536],
            [32.7953602831302, 0.854445073131345],
            [32.7969166242414, 0.853305199001509],
            [32.79999707131813, 0.849713592179789],
            [32.806972607178636, 0.839508612360352],
            [32.80784334598016, 0.838386792535827],
            [32.81088454745877, 0.838576935637475],
            [32.83099835308297, 0.84107491800654],
            [32.836963324673015, 0.842577026475136],
            [32.8419638856353, 0.842124869718918],
            [32.84336622586239, 0.842722048284065],
            [32.84588772589801, 0.845707760091738],
            [32.84802785785786, 0.847544448127689],
            [32.848853325162324, 0.847544481361712],
            [32.85207529821881, 0.84356379174523],
            [32.853521797828655, 0.842577690258343],
            [32.85636443659519, 0.842867311708301],
            [32.86313044580554, 0.844713208716775],
            [32.86568295927805, 0.844812819257382],
            [32.866763428647275, 0.845527594737553],
            [32.87372921329536, 0.853959926306381],
            [32.87694449210637, 0.856837078369553],
            [32.882601652371044, 0.859379553661182],
            [32.887532546288064, 0.860230150773969],
            [32.89459153114687, 0.862899314114857],
            [32.8977043840492, 0.863297482218162],
            [32.900226588364, 0.863071366889585],
            [32.90230462787308, 0.867215095058403],
            [32.905201466492265, 0.868879876562305],
            [32.91007088330453, 0.869169511295714],
            [32.91296415561207, 0.867369161833316],
            [32.91698959443511, 0.866138817300774],
            [32.92068834114212, 0.866790304348117],
            [32.92561522138647, 0.869544411460878],
            [32.92480879746771, 0.870846558813038],
            [32.92424857931043, 0.873337007526381],
            [32.924015092795045, 0.877425116239823],
            [32.92317481316988, 0.878670328739159],
            [32.91960368652198, 0.880808288955903],
            [32.918693386813686, 0.881889033793508],
            [32.91750938570964, 0.885005203812243],
            [32.91589251341962, 0.882934494886322],
            [32.91254319339181, 0.881618702552753],
            [32.91036086666477, 0.881524669955679],
            [32.907034818392695, 0.883110492574559],
            [32.90557604420284, 0.883051718295574],
            [32.90482913636657, 0.883615577680853],
            [32.90394220453374, 0.883462837329163],
            [32.90299689478386, 0.884320375744028],
            [32.901900638421814, 0.884425899946948],
            [32.899180544233076, 0.891356992074182],
            [32.896146207679855, 0.894082313300407],
            [32.89518905094799, 0.9009662871928],
            [32.892481505325485, 0.902516870286035],
            [32.89301821547008, 0.90667547983016],
            [32.89259797639362, 0.910352415778492],
            [32.894581830240114, 0.913641758964463],
            [32.89453506394643, 0.916531627248983],
            [32.89525850688914, 0.920531653396383],
            [32.894931671941016, 0.922740162332697],
            [32.89584597274561, 0.927058723742264],
            [32.90112978868664, 0.933139764822458],
            [32.90196998117523, 0.935818205378647],
            [32.90677806551145, 0.940000428209197],
            [32.90962556685862, 0.942913869601617],
            [32.911726167556075, 0.945733310872363],
            [32.91667433158446, 0.949586596743418],
            [32.92222943155477, 0.950667492399218],
            [32.92433008525281, 0.951795294861458],
            [32.93455337761509, 0.952453363664826],
            [32.93721426474176, 0.95104371880589],
            [32.94146231597368, 0.950338947357414],
            [32.94603026446478, 0.951261718866313],
            [32.94608857680483, 0.952170409184371],
            [32.94813909193361, 0.950544039549949],
            [32.948656040938566, 0.955574922359238],
            [32.94991981064323, 0.960143206165961],
            [32.950264434030615, 0.964248867641336],
            [32.94986228073578, 0.965810166953872],
            [32.94767922367843, 0.969684485545186],
            [32.9456110288065, 0.975293587269422],
            [32.94497896608777, 0.983851844573408],
            [32.945897936335214, 0.995648391013711],
            [32.9452083814383, 1.006519690766451],
            [32.94382955730869, 1.010740974702211],
            [32.93693567381595, 1.016696936311212],
            [32.93498232406156, 1.022248204645567],
            [32.93435028110575, 1.027799497513335],
            [32.934548438677645, 1.029489811312403],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1926,
        District: "KAYUNGA",
        County: "BBAALE",
        Subcounty: "KAYONZA",
        Population: 59427,
        Key: "KAYUNGAKAYONZA",
        Dist2: "Kayunga",
        "Sub Country": "KAYONZA",
        id2_original: "Kayunga KAYONZA",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.49090434770968, 0.867460886379352],
            [32.485975382475566, 0.868438653248687],
            [32.48483427951958, 0.868275651103004],
            [32.48245838381514, 0.869152879105481],
            [32.480036526707444, 0.871350954850128],
            [32.47780510345686, 0.872657728263391],
            [32.47699976290633, 0.868211591511107],
            [32.47623913689739, 0.865961431976339],
            [32.475405716807714, 0.864840028542565],
            [32.47537566816144, 0.859308805816],
            [32.47260076416397, 0.857019035133861],
            [32.47138994295882, 0.853130672101503],
            [32.47062959902087, 0.84882195770824],
            [32.46912067188867, 0.846681027057064],
            [32.47055184534147, 0.843702149638894],
            [32.475471387248234, 0.843123817634705],
            [32.47878463093424, 0.841088701169353],
            [32.481063531944216, 0.838673468138155],
            [32.49052802726748, 0.832622296468486],
            [32.49870773949497, 0.825367670566334],
            [32.49692832603747, 0.81797605590578],
            [32.49543404054609, 0.813867708659037],
            [32.5009475152811, 0.806375724823323],
            [32.50218414508435, 0.805370530404746],
            [32.50446697352877, 0.804987822106484],
            [32.508530124525755, 0.806713989655091],
            [32.51776807192085, 0.808424991724145],
            [32.50674876891059, 0.823525467855119],
            [32.514269957644345, 0.829902173275418],
            [32.51576984413149, 0.832906202379876],
            [32.51576897276568, 0.839991650180271],
            [32.515055262170776, 0.84268446055032],
            [32.5112974638102, 0.848093718564606],
            [32.50753982984136, 0.852114629226575],
            [32.50544684955246, 0.855274021659401],
            [32.50844304633368, 0.855226536614256],
            [32.511889969215424, 0.856970519857906],
            [32.508228151351396, 0.856897670145476],
            [32.50369900648732, 0.86147485965737],
            [32.49987453157311, 0.863853713348105],
            [32.498948691908694, 0.864857805075034],
            [32.49090434770968, 0.867460886379352],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2013,
        District: "LUWERO",
        County: "KATIKAMU",
        Subcounty: "LUWERO TOWN COUNCIL",
        Population: 42869,
        Key: "LUWEROLUWERO TOWN COUNCIL",
        Dist2: "Luweero",
        "Sub Country": "Luwero TC",
        id2_original: "LuweeroLuwero TC",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.42622440404516, 0.216060943367974],
            [33.42184700529378, 0.219839334320018],
            [33.42092687801627, 0.221289848532785],
            [33.41892766118177, 0.224656335924004],
            [33.41759598602818, 0.2299242308937],
            [33.417529036386696, 0.234678016116403],
            [33.4185226602275, 0.240862418027612],
            [33.42020764098573, 0.24554849767634],
            [33.42242125064423, 0.248570160553358],
            [33.42204949184702, 0.250461020837743],
            [33.41586721509481, 0.255945989670496],
            [33.40699520810879, 0.267088728182014],
            [33.39232952568096, 0.262370226602546],
            [33.378924811112405, 0.260043949263054],
            [33.372384073324184, 0.257932262470599],
            [33.37155460312679, 0.25268921292858],
            [33.37134885389246, 0.241521055161519],
            [33.3709186048888, 0.23845534848412],
            [33.36313328361375, 0.239312814411034],
            [33.35563174732347, 0.238374117231184],
            [33.35221383733045, 0.236584336419421],
            [33.346816618067976, 0.236163734409646],
            [33.34218653490531, 0.234894195671122],
            [33.340036254677685, 0.232893244692774],
            [33.3325365563405, 0.232603829659081],
            [33.332513002513736, 0.233382732638829],
            [33.330539882636586, 0.233732577721291],
            [33.329505425874515, 0.230215563869716],
            [33.32751034488359, 0.227563037868341],
            [33.32067250368818, 0.22717511065392],
            [33.31982511299918, 0.228648716048703],
            [33.31836138370221, 0.228803863743488],
            [33.31540812998484, 0.223840272146146],
            [33.30919367737579, 0.223439694852891],
            [33.303953225808485, 0.21947493899617],
            [33.302067641365866, 0.21831493317247],
            [33.30121912688446, 0.216713335698841],
            [33.300623014743394, 0.214063210250584],
            [33.29770416650139, 0.210373148615504],
            [33.294623665525734, 0.205055224455405],
            [33.29350604632794, 0.20055500209513],
            [33.29357727195016, 0.194570634625766],
            [33.290081923586385, 0.190094389820471],
            [33.289772802517355, 0.189160833350817],
            [33.289392233043884, 0.181165722653665],
            [33.29089564092695, 0.174619579816952],
            [33.282083894726824, 0.181217263235376],
            [33.279587270838036, 0.183922287028692],
            [33.279466580382994, 0.176777805377085],
            [33.27980705355376, 0.173806764549031],
            [33.27829638279162, 0.168854736550404],
            [33.2733995565834, 0.17337901572347],
            [33.26743528298433, 0.177559359294007],
            [33.26007703067682, 0.175048356282269],
            [33.2569989524575, 0.173065179933462],
            [33.25311560465452, 0.168716677768402],
            [33.251633517386395, 0.164074889370638],
            [33.25020676274648, 0.155074389045606],
            [33.25049194011994, 0.141860857004305],
            [33.248018851193315, 0.117636078879741],
            [33.2466508284067, 0.110319844479457],
            [33.2387434485424, 0.09886881676834],
            [33.274571570568305, 0.08553509718172],
            [33.313279971669424, 0.071990463074017],
            [33.33651790584939, 0.063158024044673],
            [33.34577049847859, 0.059930003595693],
            [33.348032340481325, 0.059564267303042],
            [33.353769775098094, 0.057073206174782],
            [33.36139678716895, 0.054606381474025],
            [33.361487818846584, 0.110754154856578],
            [33.36105626189589, 0.11855564455351],
            [33.361570250053674, 0.126605443758199],
            [33.361056495457866, 0.135027742932815],
            [33.36085143972289, 0.164785128645457],
            [33.36417038232105, 0.165885519862849],
            [33.36658513644977, 0.164872542445726],
            [33.36859742107671, 0.1634543994873],
            [33.38179110521533, 0.16092576348502],
            [33.386351640808705, 0.160305233979425],
            [33.39636718788006, 0.159807315031635],
            [33.40602629332816, 0.162440732941988],
            [33.42608562691016, 0.174182219080696],
            [33.42622440404516, 0.216060943367974],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1271,
        District: "BUVUMA",
        County: "BUVUMA ISLAND",
        Subcounty: "NAIRAMBI",
        Population: 19333,
        Key: "BUVUMANAIRAMBI",
        Dist2: "Buvuma",
        "Sub Country": "Nairambi",
        id2_original: "Buvuma Nairambi",
        drought: "N",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "VH",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.91126153457618, 0.212530827046807],
            [31.910836537123693, 0.21273747317339],
            [31.9095844760605, 0.21703409124629],
            [31.908588150087294, 0.218282323666022],
            [31.905539188062928, 0.220606840246234],
            [31.901020629844442, 0.226051996263022],
            [31.89232729866674, 0.225813542121384],
            [31.892139195937816, 0.22261428500574],
            [31.89271783404998, 0.216318713103781],
            [31.89169212328556, 0.211216973570149],
            [31.880540756250408, 0.209665423758311],
            [31.87570146354289, 0.206141546541226],
            [31.872098321836596, 0.202196955087739],
            [31.872571706143546, 0.198594146235729],
            [31.87159862228171, 0.190533979776374],
            [31.872019443466467, 0.186300102599232],
            [31.86988908427857, 0.18274991343142],
            [31.866364820942454, 0.18035687551237],
            [31.86181486929974, 0.174613491064236],
            [31.860934032536107, 0.171545400838485],
            [31.86257583577018, 0.168103151740876],
            [31.867068417405594, 0.162232844755062],
            [31.868623972490905, 0.159377290478342],
            [31.87162644490268, 0.161482858689979],
            [31.874644749223037, 0.165009098379492],
            [31.877408872538812, 0.167359955334767],
            [31.880172996752883, 0.169043619094138],
            [31.884398586509402, 0.165676227650785],
            [31.890212777675636, 0.156812943379408],
            [31.893199270855145, 0.153032575192734],
            [31.89462899712202, 0.149592078280288],
            [31.898155636502057, 0.144032691835942],
            [31.906320886751814, 0.134470544655866],
            [31.90790947378846, 0.131230192694736],
            [31.913215294860684, 0.127132139989446],
            [31.91731005128428, 0.123066207619315],
            [31.921612856629384, 0.122977397680085],
            [31.931080879636784, 0.120250543523534],
            [31.933662011637587, 0.123593008125918],
            [31.936490563922145, 0.12638827117766],
            [31.93886709473554, 0.128034704762133],
            [31.94903219513201, 0.129147771189711],
            [31.951171984833728, 0.131798288478798],
            [31.951555671461268, 0.135362359953037],
            [31.95306702404474, 0.138591788780293],
            [31.953440396216166, 0.140346696387453],
            [31.952547700792458, 0.141721621256584],
            [31.948419351868765, 0.145312618152309],
            [31.94620289455083, 0.149102706522065],
            [31.94482936329488, 0.152901877971221],
            [31.943659866389414, 0.158582582751845],
            [31.94184635557868, 0.161838974603912],
            [31.941397533906535, 0.164064216530515],
            [31.93780350021892, 0.167854205391043],
            [31.935381677247243, 0.168116398241056],
            [31.93289889460036, 0.170052279011486],
            [31.931561803503904, 0.175008905154019],
            [31.938769210708912, 0.182867775390039],
            [31.943889447029942, 0.185117765995819],
            [31.943074150451118, 0.186585217377746],
            [31.93717117519209, 0.189467883923652],
            [31.92983329398029, 0.189141793662124],
            [31.925919743919163, 0.185554790501868],
            [31.922821488640206, 0.188456973011457],
            [31.91867964791928, 0.195549536592701],
            [31.91398342180222, 0.202006218786686],
            [31.910885167421593, 0.209734603453306],
            [31.91126153457618, 0.212530827046807],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1273,
        District: "GOMBA",
        County: "GOMBA",
        Subcounty: "KANONI TOWN COUNCIL",
        Population: 12439,
        Key: "GOMBAKANONI TOWN COUNCIL",
        Dist2: "Gomba",
        "Sub Country": "Kanoni  town Council",
        id2_original: "Gomba Kanoni  town Council",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.86720859411577, 0.093986578031272],
              [31.88046537142839, 0.094156335136662],
              [31.88424188618789, 0.094889155493674],
              [31.887627252014795, 0.096282295931876],
              [31.890859555697062, 0.098815185629032],
              [31.8938191964361, 0.101981266935646],
              [31.90800106511649, 0.118155471999366],
              [31.912884366289788, 0.121556856328216],
              [31.916091739027973, 0.122922893424019],
              [31.91731005128428, 0.123066207619315],
              [31.913215294860684, 0.127132139989446],
              [31.90790947378846, 0.131230192694736],
              [31.906320886751814, 0.134470544655866],
              [31.898155636502057, 0.144032691835942],
              [31.89462899712202, 0.149592078280288],
              [31.893199270855145, 0.153032575192734],
              [31.890212777675636, 0.156812943379408],
              [31.884398586509402, 0.165676227650785],
              [31.880172996752883, 0.169043619094138],
              [31.877408872538812, 0.167359955334767],
              [31.874644749223037, 0.165009098379492],
              [31.87162644490268, 0.161482858689979],
              [31.868623972490905, 0.159377290478342],
              [31.869949224690213, 0.157655946217145],
              [31.87163051786419, 0.153115157022081],
              [31.87365685753205, 0.149162342776826],
              [31.87576763973493, 0.146557321569095],
              [31.8802704397067, 0.137729036713312],
              [31.88252304343504, 0.134454631942735],
              [31.883411262553686, 0.132274679080367],
              [31.885171057703705, 0.123156769268976],
              [31.884795124435385, 0.115449880444973],
              [31.884202884033208, 0.11264410421487],
              [31.87685349360596, 0.112245416489853],
              [31.876664908481736, 0.109944617980171],
              [31.874691926046804, 0.10532544672039],
              [31.873432022691176, 0.103626148743348],
              [31.868225858919917, 0.100658254508373],
              [31.86770290018572, 0.09936584937972],
              [31.866038836698873, 0.098264869516715],
              [31.866229091791244, 0.096182699856794],
              [31.86720859411577, 0.093986578031272],
            ],
          ],
          [
            [
              [32.0168176749813, 0.134940004722495],
              [32.01546193396127, 0.142954710587471],
              [32.01088674774389, 0.153140297183832],
              [32.00702045894818, 0.159282335326699],
              [32.00578789671653, 0.162321723712799],
              [32.00513854142855, 0.165433507467524],
              [32.005016716401286, 0.175429305757961],
              [32.00448892023924, 0.178776287650953],
              [32.00343637589896, 0.181010584378965],
              [31.99991641639133, 0.184366438760716],
              [31.989407774179046, 0.192118197557932],
              [31.98101844008003, 0.197463820831339],
              [31.978206428474785, 0.199743212102404],
              [31.973462366170533, 0.20500761764341],
              [31.97004706488511, 0.209503195391545],
              [31.96287089839073, 0.216947453850013],
              [31.960094567868598, 0.218864979296022],
              [31.955583707313778, 0.22119939424793],
              [31.932631411343028, 0.231499952958906],
              [31.931349033935618, 0.231599357919862],
              [31.930750273561074, 0.231227802477609],
              [31.92785538787931, 0.228659218169039],
              [31.926130978266645, 0.225972499572121],
              [31.925677668611335, 0.223729119053994],
              [31.924666664166395, 0.222118901095078],
              [31.924496243875534, 0.217984982563571],
              [31.92350911485422, 0.216230036542258],
              [31.917877318521587, 0.212502789921327],
              [31.91266450811557, 0.21214058809246],
              [31.91126153457618, 0.212530827046807],
              [31.910885167421593, 0.209734603453306],
              [31.91398342180222, 0.202006218786686],
              [31.91867964791928, 0.195549536592701],
              [31.922821488640206, 0.188456973011457],
              [31.925919743919163, 0.185554790501868],
              [31.92983329398029, 0.189141793662124],
              [31.93717117519209, 0.189467883923652],
              [31.943074150451118, 0.186585217377746],
              [31.943889447029942, 0.185117765995819],
              [31.938769210708912, 0.182867775390039],
              [31.931561803503904, 0.175008905154019],
              [31.93289889460036, 0.170052279011486],
              [31.935381677247243, 0.168116398241056],
              [31.93780350021892, 0.167854205391043],
              [31.941397533906535, 0.164064216530515],
              [31.94184635557868, 0.161838974603912],
              [31.943659866389414, 0.158582582751845],
              [31.94482936329488, 0.152901877971221],
              [31.94620289455083, 0.149102706522065],
              [31.948419351868765, 0.145312618152309],
              [31.952547700792458, 0.141721621256584],
              [31.953440396216166, 0.140346696387453],
              [31.95306702404474, 0.138591788780293],
              [31.951555671461268, 0.135362359953037],
              [31.951171984833728, 0.131798288478798],
              [31.94903219513201, 0.129147771189711],
              [31.93886709473554, 0.128034704762133],
              [31.936490563922145, 0.12638827117766],
              [31.933662011637587, 0.123593008125918],
              [31.931080879636784, 0.120250543523534],
              [31.932710610411757, 0.118816802212604],
              [31.936278256087903, 0.112928141075901],
              [31.93910086242361, 0.109744129648546],
              [31.943431857800633, 0.106885814998276],
              [31.948368996805538, 0.104995508648684],
              [31.949085622433547, 0.105031621760742],
              [31.95096321276846, 0.106542340253562],
              [31.955991142702477, 0.111707689580973],
              [31.959555148405087, 0.113661723665693],
              [31.9606235623832, 0.11354416676544],
              [31.964123986228344, 0.111309968428675],
              [31.96694933781555, 0.110514034730475],
              [31.972635955635013, 0.109881026358218],
              [31.97567499486874, 0.109157461668159],
              [31.980377415768007, 0.10949232604706],
              [31.98195795210307, 0.110840222283028],
              [31.98488256573255, 0.114395372712072],
              [31.990114875868432, 0.121849413600071],
              [31.994988686340722, 0.127268124825418],
              [31.995630015181625, 0.127412885280954],
              [31.998953265201603, 0.126191813695537],
              [32.000663303566334, 0.126191881967318],
              [32.002620115427845, 0.127395072631246],
              [32.00837576518363, 0.129638705528773],
              [32.009307672069475, 0.130968503357718],
              [32.01259820454846, 0.133718620889764],
              [32.015273023646884, 0.134749975633578],
              [32.0168176749813, 0.134940004722495],
            ],
          ],
          [
            [
              [31.89232729866674, 0.225813542121384],
              [31.86970208288419, 0.229514003245077],
              [31.867731765750715, 0.230183216695713],
              [31.866260372926032, 0.231241428911174],
              [31.86454068665515, 0.233303677057885],
              [31.860097104525245, 0.242276493853445],
              [31.858081151178688, 0.244718617357737],
              [31.856680823177822, 0.245433093069433],
              [31.851539872604654, 0.24651810689834],
              [31.846008455818485, 0.246526665967126],
              [31.8438210131859, 0.248227025305859],
              [31.842965029212902, 0.250045093150484],
              [31.842798550729512, 0.252921545542207],
              [31.84442656302734, 0.255635341866258],
              [31.846185850629237, 0.256693826966141],
              [31.847588221399068, 0.258195510196054],
              [31.850166987237415, 0.263713511799685],
              [31.85071358873159, 0.267612181579258],
              [31.84941739793005, 0.271573992890269],
              [31.845256881234363, 0.276096338856982],
              [31.844591001436754, 0.277561643763631],
              [31.842206752298438, 0.278818729557999],
              [31.84007393531995, 0.278755197859926],
              [31.834285524005754, 0.276800796689333],
              [31.827629382347887, 0.273308588652995],
              [31.82364740312, 0.272747376144441],
              [31.821389046580542, 0.273154195164068],
              [31.81739508292844, 0.274637242853692],
              [31.81218860474686, 0.277223700616054],
              [31.80277990558252, 0.283445946188924],
              [31.800767854517588, 0.280632628382864],
              [31.795966379985202, 0.27676072151549],
              [31.79235294448408, 0.27507791532884],
              [31.785061058811458, 0.273349511838439],
              [31.785472288683902, 0.2631554977181],
              [31.787257597784624, 0.246928388837518],
              [31.78996933584459, 0.246928640363436],
              [31.791782364260015, 0.243238315886611],
              [31.793751604313467, 0.241537972982937],
              [31.79564749422902, 0.240588383978987],
              [31.79685823099254, 0.240299041868729],
              [31.811877887371555, 0.240273244277248],
              [31.820959266497475, 0.238654914681209],
              [31.821931952405656, 0.237895184574083],
              [31.822868635633874, 0.224390442031353],
              [31.821545723545867, 0.219388214478003],
              [31.82284747042746, 0.21512792198998],
              [31.825064484700896, 0.211727012853161],
              [31.825061345088972, 0.208687746139437],
              [31.8255589596541, 0.207710876938207],
              [31.82545044047283, 0.205811327078327],
              [31.82666434289943, 0.196765977715773],
              [31.827897366865134, 0.19504743246974],
              [31.828951590156702, 0.192496690689492],
              [31.83186884748232, 0.189032484558675],
              [31.836080746913943, 0.18605681405358],
              [31.83890362454084, 0.183135313876537],
              [31.843542889384043, 0.179897332921638],
              [31.84581990932183, 0.177265239703571],
              [31.846156471227864, 0.169676083291755],
              [31.845178492446045, 0.165279910566644],
              [31.841659983717605, 0.161272549543147],
              [31.83822697214634, 0.159734618251569],
              [31.837846541911716, 0.159255185648751],
              [31.837964786254254, 0.158631054760539],
              [31.839412259637857, 0.157699453258252],
              [31.841501829023617, 0.157654345425377],
              [31.845421715800796, 0.159228485126714],
              [31.849592535274464, 0.162412745143483],
              [31.851519335320642, 0.165877291329322],
              [31.85445502427924, 0.168636352560396],
              [31.855666557848416, 0.169305794860233],
              [31.856380498412037, 0.17078026061616],
              [31.859492344302918, 0.171811641428886],
              [31.860934032536107, 0.171545400838485],
              [31.86181486929974, 0.174613491064236],
              [31.866364820942454, 0.18035687551237],
              [31.86988908427857, 0.18274991343142],
              [31.872019443466467, 0.186300102599232],
              [31.87159862228171, 0.190533979776374],
              [31.872571706143546, 0.198594146235729],
              [31.872098321836596, 0.202196955087739],
              [31.87570146354289, 0.206141546541226],
              [31.880540756250408, 0.209665423758311],
              [31.89169212328556, 0.211216973570149],
              [31.89271783404998, 0.216318713103781],
              [31.892139195937816, 0.22261428500574],
              [31.89232729866674, 0.225813542121384],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1274,
        District: "GOMBA",
        County: "GOMBA",
        Subcounty: "KYEGONZA",
        Population: 30240,
        Key: "GOMBAKYEGONZA",
        Dist2: "Gomba",
        "Sub Country": "Kyegonza",
        id2_original: "Gomba Kyegonza",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.23965061762198, 0.456572545617462],
            [33.24137908222984, 0.456312161923713],
            [33.24045972031693, 0.458171190459691],
            [33.24382309269073, 0.460364921788238],
            [33.246110500746454, 0.464084060496444],
            [33.24566376406407, 0.466801209283984],
            [33.24434699375769, 0.468129413156809],
            [33.243146915504994, 0.471122530578164],
            [33.24348282703076, 0.471424440538729],
            [33.243231502668785, 0.473820735405287],
            [33.24286316824948, 0.47427714299938],
            [33.24503761585315, 0.476965207664065],
            [33.245180877378054, 0.480716662260868],
            [33.24302775757584, 0.480268754654708],
            [33.24195238794247, 0.478622460890321],
            [33.24064491609757, 0.478415609450904],
            [33.23861023108074, 0.47902018507667],
            [33.238594450376134, 0.47977973346854],
            [33.237361096728684, 0.479254029029574],
            [33.234910637262374, 0.47988188989344],
            [33.23296913808322, 0.480904337969858],
            [33.23192037115869, 0.479951611086682],
            [33.23176145110007, 0.477782670452988],
            [33.23208953740143, 0.476238682584985],
            [33.23129767876667, 0.474910171249415],
            [33.22971885012896, 0.476248039113757],
            [33.228476399242645, 0.475027261725012],
            [33.22725221200438, 0.47485415423239],
            [33.225882735743625, 0.479392774359825],
            [33.22502375768581, 0.480363346625177],
            [33.22373933930603, 0.479822128870139],
            [33.22338087916832, 0.47913053026872],
            [33.2240514284088, 0.476557724399107],
            [33.22448580337453, 0.471454816041796],
            [33.22367314155445, 0.467969541726889],
            [33.2245935347333, 0.467944468786989],
            [33.226955300836664, 0.463746455933385],
            [33.22861787671338, 0.463131186684967],
            [33.23005405647724, 0.461457394131243],
            [33.23740415837015, 0.457141602174547],
            [33.23965061762198, 0.456572545617462],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1277,
        District: "JINJA",
        County: "BUTEMBE",
        Subcounty: "BUGEMBE TOWN COUNCIL",
        Population: 41707,
        Key: "JINJABUGEMBE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.325359306477885, 0.517440483998925],
            [33.32532822297245, 0.518089099540053],
            [33.33352910579623, 0.533179384181624],
            [33.33198191312787, 0.537992575348081],
            [33.3256424338959, 0.554115029472059],
            [33.30487450382787, 0.566085614446492],
            [33.27503986412253, 0.584199698332759],
            [33.27289539958808, 0.586126866787514],
            [33.27196539802894, 0.589601053022205],
            [33.270304499306874, 0.589196014210929],
            [33.25213834542321, 0.584236973784244],
            [33.23621124328355, 0.580573530594733],
            [33.234348092468544, 0.58062789294617],
            [33.237140174949175, 0.577768838929249],
            [33.238167349967576, 0.573688478299494],
            [33.238224530430344, 0.570983343078731],
            [33.23813909705356, 0.569635303623374],
            [33.23611006423647, 0.565138896455983],
            [33.23334256954345, 0.564749977183909],
            [33.23248651190863, 0.563944805050033],
            [33.231772365630775, 0.55810934396053],
            [33.23274279227603, 0.553459007887657],
            [33.23352343454613, 0.550518614368978],
            [33.233897375351155, 0.546709699514381],
            [33.233460720461196, 0.541082314146386],
            [33.23291247415174, 0.540344006421522],
            [33.23547115545695, 0.534279602885327],
            [33.236814791678555, 0.520748052023794],
            [33.238517265330294, 0.517740987843859],
            [33.23994479341964, 0.517070906999255],
            [33.244359308761894, 0.51333392366909],
            [33.24600322483354, 0.509316875182407],
            [33.25042420984249, 0.507109171660767],
            [33.25274845960464, 0.506448630338744],
            [33.25242686632617, 0.498514197425599],
            [33.25289910977274, 0.494922417843992],
            [33.256507718625826, 0.488507772956849],
            [33.25801916822734, 0.487105390132605],
            [33.25945531205859, 0.484626386899972],
            [33.261306902454216, 0.476909008312068],
            [33.26202467523085, 0.475235239714878],
            [33.26276141862966, 0.470186844608706],
            [33.26223218875642, 0.466956996236555],
            [33.25979480516738, 0.460814002037532],
            [33.25809361790316, 0.449631656532885],
            [33.2816619003423, 0.449042704110076],
            [33.2815396836496, 0.462623891361395],
            [33.283432467190885, 0.473302845587931],
            [33.28435991933126, 0.47588805977511],
            [33.288533190307334, 0.480986574938514],
            [33.28963699880595, 0.481623868518702],
            [33.29091209716465, 0.480204980103024],
            [33.292153433241694, 0.47393841068259],
            [33.29413929661947, 0.470988396876659],
            [33.29567102658683, 0.469944913088766],
            [33.29944360942034, 0.468642863134676],
            [33.302962927530835, 0.468310215528363],
            [33.308255496655974, 0.471957326462771],
            [33.30970052123212, 0.474292323109259],
            [33.3045021036336, 0.480111484934813],
            [33.30672782887033, 0.482275332460955],
            [33.322878183917666, 0.488460009472488],
            [33.332104587961396, 0.498877117426025],
            [33.33253090863231, 0.498461258116326],
            [33.33162275859243, 0.501369554533695],
            [33.327861508904576, 0.508562268910678],
            [33.32488494929547, 0.516098738510044],
            [33.325037200261406, 0.516750128971302],
            [33.32560733132786, 0.517102940516033],
            [33.325359306477885, 0.517440483998925],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1279,
        District: "JINJA",
        County: "BUTEMBE",
        Subcounty: "KAKIRA TOWN COUNCIL",
        Population: 32693,
        Key: "JINJAKAKIRA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.25809361790316, 0.449631656532885],
            [33.25979480516738, 0.460814002037532],
            [33.26223218875642, 0.466956996236555],
            [33.26276141862966, 0.470186844608706],
            [33.26202467523085, 0.475235239714878],
            [33.261306902454216, 0.476909008312068],
            [33.25945531205859, 0.484626386899972],
            [33.25801916822734, 0.487105390132605],
            [33.256507718625826, 0.488507772956849],
            [33.25289910977274, 0.494922417843992],
            [33.25242686632617, 0.498514197425599],
            [33.25274845960464, 0.506448630338744],
            [33.25042420984249, 0.507109171660767],
            [33.24600322483354, 0.509316875182407],
            [33.244359308761894, 0.51333392366909],
            [33.23994479341964, 0.517070906999255],
            [33.238517265330294, 0.517740987843859],
            [33.236814791678555, 0.520748052023794],
            [33.23547115545695, 0.534279602885327],
            [33.23291247415174, 0.540344006421522],
            [33.22749312579053, 0.537002223631989],
            [33.222086762576765, 0.535455340358786],
            [33.21984166696757, 0.535410185817842],
            [33.216909566778504, 0.533836064609251],
            [33.206014523229896, 0.529783258924439],
            [33.204371865697986, 0.530299009066575],
            [33.20270845079481, 0.531647110415006],
            [33.19514031430769, 0.536035294301425],
            [33.19447498607567, 0.536035315860045],
            [33.19435027026984, 0.535411056247324],
            [33.195431199576475, 0.533737273080053],
            [33.199922390619825, 0.529964406336232],
            [33.20460023630783, 0.523043076903523],
            [33.20636727816724, 0.512973387612216],
            [33.19946383300663, 0.507526817996714],
            [33.195941676219846, 0.506733106686198],
            [33.19144705271379, 0.508056276807384],
            [33.190316791525014, 0.507262490106323],
            [33.18865202825056, 0.503049055728164],
            [33.18867247570306, 0.501167216759764],
            [33.189771346162566, 0.498335381059764],
            [33.18949663865374, 0.496951152776629],
            [33.182902290307645, 0.493974779016001],
            [33.17452204715929, 0.491070822542616],
            [33.17125937772547, 0.487859114053185],
            [33.17084706628142, 0.486682974419568],
            [33.16803097542646, 0.484746923023418],
            [33.165351915381606, 0.481770424376136],
            [33.16226087177775, 0.479490577707107],
            [33.1595459195457, 0.478793998087892],
            [33.1589471142554, 0.476984551315098],
            [33.15926891684132, 0.474930803944361],
            [33.160421189449515, 0.473338449997588],
            [33.16358373805166, 0.471130831629071],
            [33.16455224948871, 0.469229635601447],
            [33.16631771210985, 0.468751323889658],
            [33.16760424153055, 0.467837514444037],
            [33.16921227529646, 0.464327119566792],
            [33.17057911679846, 0.462997131880116],
            [33.17544597341215, 0.46374377634665],
            [33.18185310746316, 0.464372038347371],
            [33.18795613304437, 0.46390141742871],
            [33.196472027190524, 0.460800490914341],
            [33.196494860568414, 0.459257446098003],
            [33.19816408577485, 0.459061110325977],
            [33.20058467985123, 0.45809396027205],
            [33.2024156125886, 0.458505635115149],
            [33.203295449527324, 0.460061558824969],
            [33.20534993880293, 0.461914274129742],
            [33.20601097488453, 0.461976493017326],
            [33.2062674061689, 0.46276475338447],
            [33.20938718598038, 0.465474403791062],
            [33.21380455706694, 0.465872982100987],
            [33.21680878119352, 0.466958562846396],
            [33.22104139667388, 0.467302226190741],
            [33.22367314155445, 0.467969541726889],
            [33.22448580337453, 0.471454816041796],
            [33.2240514284088, 0.476557724399107],
            [33.22338087916832, 0.47913053026872],
            [33.22373933930603, 0.479822128870139],
            [33.22502375768581, 0.480363346625177],
            [33.225882735743625, 0.479392774359825],
            [33.22725221200438, 0.47485415423239],
            [33.228476399242645, 0.475027261725012],
            [33.22971885012896, 0.476248039113757],
            [33.23129767876667, 0.474910171249415],
            [33.23208953740143, 0.476238682584985],
            [33.23176145110007, 0.477782670452988],
            [33.23192037115869, 0.479951611086682],
            [33.23296913808322, 0.480904337969858],
            [33.234910637262374, 0.47988188989344],
            [33.237361096728684, 0.479254029029574],
            [33.238594450376134, 0.47977973346854],
            [33.23861023108074, 0.47902018507667],
            [33.24064491609757, 0.478415609450904],
            [33.24195238794247, 0.478622460890321],
            [33.24302775757584, 0.480268754654708],
            [33.245180877378054, 0.480716662260868],
            [33.24503761585315, 0.476965207664065],
            [33.24286316824948, 0.47427714299938],
            [33.243231502668785, 0.473820735405287],
            [33.24348282703076, 0.471424440538729],
            [33.243146915504994, 0.471122530578164],
            [33.24434699375769, 0.468129413156809],
            [33.24566376406407, 0.466801209283984],
            [33.246110500746454, 0.464084060496444],
            [33.24382309269073, 0.460364921788238],
            [33.24045972031693, 0.458171190459691],
            [33.24137908222984, 0.456312161923713],
            [33.23965061762198, 0.456572545617462],
            [33.239564247302354, 0.456200653091523],
            [33.24326134200757, 0.45455388567786],
            [33.25809361790316, 0.449631656532885],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1280,
        District: "JINJA",
        County: "BUTEMBE",
        Subcounty: "MAFUBIRA",
        Population: 78671,
        Key: "JINJAMAFUBIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.23274279227603, 0.553459007887657],
            [33.225435065711665, 0.551731263239465],
            [33.219382778774346, 0.551333412443581],
            [33.218184190826705, 0.553287669425313],
            [33.21181840622826, 0.558833887055641],
            [33.20793605465693, 0.561593449763115],
            [33.204967248407044, 0.562914459391487],
            [33.20359731849709, 0.56435302733674],
            [33.2020558184527, 0.566651092459094],
            [33.20008624871754, 0.575408937753064],
            [33.19985800836341, 0.577996471223434],
            [33.19135098328403, 0.575354957116423],
            [33.183785986408836, 0.574405243122884],
            [33.18007508729265, 0.573373969621605],
            [33.17253888771051, 0.577454538874945],
            [33.17119699332224, 0.577653620579868],
            [33.166830024011354, 0.576568075103074],
            [33.16496150216924, 0.572585555925467],
            [33.16421759111279, 0.567946067243523],
            [33.162611015312564, 0.563811493433287],
            [33.16166423412224, 0.562445376381401],
            [33.16034506082246, 0.561594966046476],
            [33.14546457054895, 0.563196735050613],
            [33.141203576390424, 0.56557628553509],
            [33.139157306699694, 0.565693951018397],
            [33.13787217685421, 0.567331546442374],
            [33.134152048446786, 0.5677749537729],
            [33.128419889635666, 0.567349861294782],
            [33.12072563417425, 0.56321540114039],
            [33.11812155291286, 0.561206948403231],
            [33.11604153800847, 0.559216578998386],
            [33.11421536544381, 0.554647714482533],
            [33.109497370452466, 0.554602568169936],
            [33.108719706097546, 0.555045901908651],
            [33.10354169193403, 0.555625023958858],
            [33.10186555329317, 0.55410510265411],
            [33.10059915781295, 0.551599013105531],
            [33.09904013433231, 0.549889096857965],
            [33.09360842605115, 0.544958384883222],
            [33.091040036652636, 0.543357050211753],
            [33.094408208725, 0.540009482389086],
            [33.09537316822342, 0.537530497827675],
            [33.096606066425, 0.535693869476341],
            [33.10290459056487, 0.531296762764281],
            [33.10376227055712, 0.529405855965157],
            [33.10510219943154, 0.529460117281585],
            [33.105477404166145, 0.528926318888056],
            [33.10520944570005, 0.527198282509285],
            [33.10649599398535, 0.526121628855209],
            [33.112392375610185, 0.524393486600383],
            [33.11314305008241, 0.522828278902929],
            [33.11638598622439, 0.521606830160208],
            [33.117136376829, 0.519833542787662],
            [33.118637494008105, 0.519019255242299],
            [33.118046274092066, 0.517137422740359],
            [33.119387860358195, 0.515834581645789],
            [33.12131754669135, 0.514866481273323],
            [33.123461810901524, 0.514432167846287],
            [33.127079900574145, 0.510903639529642],
            [33.128741662577184, 0.510252198169018],
            [33.12911683317581, 0.508144165417123],
            [33.131153812489885, 0.507872703412271],
            [33.13474524196152, 0.505665082937779],
            [33.13560292015714, 0.504262729801986],
            [33.13729163161871, 0.503213204839195],
            [33.13798837124127, 0.501213732440441],
            [33.136701734022765, 0.497486263532876],
            [33.13696964487815, 0.496681045813566],
            [33.13852439686962, 0.49592103851099],
            [33.13997157111425, 0.494572956582891],
            [33.141231132211786, 0.492872033693533],
            [33.14165995199579, 0.491306838125538],
            [33.14337536408256, 0.491415369485362],
            [33.1447692197218, 0.492066745348234],
            [33.14841427951421, 0.490012923490814],
            [33.15029032474682, 0.489632894317861],
            [33.15168413277536, 0.488176244675445],
            [33.15377467862982, 0.484946305944917],
            [33.154069244296316, 0.483136835651198],
            [33.15278293675954, 0.481680247488748],
            [33.154069147278264, 0.478821267292771],
            [33.1547125512275, 0.478224129440923],
            [33.15669589213595, 0.478549787024217],
            [33.1580361228443, 0.480060657345411],
            [33.159751257351665, 0.480485841082604],
            [33.1595459195457, 0.478793998087892],
            [33.16226087177775, 0.479490577707107],
            [33.165351915381606, 0.481770424376136],
            [33.16803097542646, 0.484746923023418],
            [33.17084706628142, 0.486682974419568],
            [33.17125937772547, 0.487859114053185],
            [33.17452204715929, 0.491070822542616],
            [33.182902290307645, 0.493974779016001],
            [33.18949663865374, 0.496951152776629],
            [33.189771346162566, 0.498335381059764],
            [33.18867247570306, 0.501167216759764],
            [33.18865202825056, 0.503049055728164],
            [33.190316791525014, 0.507262490106323],
            [33.19144705271379, 0.508056276807384],
            [33.195941676219846, 0.506733106686198],
            [33.19946383300663, 0.507526817996714],
            [33.20636727816724, 0.512973387612216],
            [33.20460023630783, 0.523043076903523],
            [33.199922390619825, 0.529964406336232],
            [33.195431199576475, 0.533737273080053],
            [33.19435027026984, 0.535411056247324],
            [33.19447498607567, 0.536035315860045],
            [33.19514031430769, 0.536035294301425],
            [33.20270845079481, 0.531647110415006],
            [33.204371865697986, 0.530299009066575],
            [33.206014523229896, 0.529783258924439],
            [33.216909566778504, 0.533836064609251],
            [33.21984166696757, 0.535410185817842],
            [33.222086762576765, 0.535455340358786],
            [33.22749312579053, 0.537002223631989],
            [33.23291247415174, 0.540344006421522],
            [33.233460720461196, 0.541082314146386],
            [33.233897375351155, 0.546709699514381],
            [33.23352343454613, 0.550518614368978],
            [33.23274279227603, 0.553459007887657],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1282,
        District: "JINJA",
        County: "KAGOMA",
        Subcounty: "BUDONDO",
        Population: 50508,
        Key: "JINJABUDONDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.1063435947974, 0.675900157241059],
            [33.10225713880698, 0.675909293370058],
            [33.09662911719519, 0.678632655797981],
            [33.09277884805593, 0.678135129108722],
            [33.08960489444292, 0.678288994346928],
            [33.08928922196053, 0.678813745249309],
            [33.08858960772902, 0.678786616235109],
            [33.08642085364762, 0.679863288202757],
            [33.086669957374205, 0.678949503497842],
            [33.08614408720014, 0.672887800040464],
            [33.08681271224928, 0.667649383196744],
            [33.08592265517755, 0.666192778306054],
            [33.07670884551412, 0.662465430071616],
            [33.07562636841025, 0.658547951488482],
            [33.0743271053704, 0.656819929513874],
            [33.07148343084637, 0.655779526789156],
            [33.0699246714704, 0.654648633474288],
            [33.067759560955764, 0.6548115143496],
            [33.06600479098147, 0.655870077325801],
            [33.06362258640875, 0.656521515302105],
            [33.061393994647915, 0.656150602800711],
            [33.05946901369019, 0.6564130023454],
            [33.05906515090141, 0.6569377501929],
            [33.0560875330769, 0.657661572202452],
            [33.053085190022536, 0.657715891545442],
            [33.05142534143104, 0.658466835382744],
            [33.049163894687, 0.658810659907184],
            [33.04754476852396, 0.659443988663106],
            [33.046586755697625, 0.657734052487185],
            [33.04608061522215, 0.653762273259049],
            [33.04328661483839, 0.647754861095449],
            [33.04434177776772, 0.646271089773922],
            [33.044782705045165, 0.644344002327437],
            [33.04400160553258, 0.640884979318506],
            [33.044144829328204, 0.638517521731162],
            [33.04866120913213, 0.634446178691189],
            [33.04947651559239, 0.632627655065772],
            [33.04981856350987, 0.629642026649699],
            [33.05283686513527, 0.625597839189011],
            [33.05435710834511, 0.624521189747268],
            [33.054489385270706, 0.623915013823862],
            [33.05335527659752, 0.621671289548748],
            [33.051713117630605, 0.620422770229167],
            [33.05183583468493, 0.619038525794382],
            [33.051395445498365, 0.618079510642581],
            [33.05258539434789, 0.615374345070979],
            [33.05377507280452, 0.613709625455567],
            [33.05322512059434, 0.609710704646957],
            [33.051463580017725, 0.606118928486052],
            [33.05173907894232, 0.604182792447485],
            [33.05072629942638, 0.601278608205975],
            [33.05085885033812, 0.600201973637466],
            [33.05024236171146, 0.598283943647933],
            [33.05067231696601, 0.59531640960404],
            [33.05168563097955, 0.594728327776087],
            [33.05549650809529, 0.594420673154002],
            [33.056763409327004, 0.592746904263743],
            [33.05688950314848, 0.591534560482525],
            [33.065768843082175, 0.585445600320403],
            [33.06857675747142, 0.582559467734666],
            [33.072167422476724, 0.580786144614603],
            [33.072599628011055, 0.579112382424393],
            [33.07249176909153, 0.578180507792766],
            [33.07176295242681, 0.577501967512823],
            [33.07183141662785, 0.572164037122418],
            [33.07239843054025, 0.570300277354604],
            [33.07312750771642, 0.569694094554432],
            [33.07310107209424, 0.566654189698707],
            [33.07661107557353, 0.561840962356186],
            [33.075019162973724, 0.557299214243622],
            [33.075262366565546, 0.55644876902852],
            [33.07955483948823, 0.554042117528196],
            [33.08152555816864, 0.553562579705016],
            [33.08151234754409, 0.552540235844342],
            [33.08078353626926, 0.551988351843102],
            [33.08078352998104, 0.551554080558879],
            [33.082349518998406, 0.549409842554633],
            [33.08267386291825, 0.546614209352879],
            [33.083538024255255, 0.546089458083449],
            [33.08472939244293, 0.54617086510616],
            [33.086528244544894, 0.546976052237412],
            [33.08915503072505, 0.547030293635492],
            [33.09022701011654, 0.545845073522782],
            [33.090387915451906, 0.54417131568409],
            [33.091040036652636, 0.543357050211753],
            [33.09360842605115, 0.544958384883222],
            [33.09904013433231, 0.549889096857965],
            [33.10059915781295, 0.551599013105531],
            [33.10186555329317, 0.55410510265411],
            [33.10354169193403, 0.555625023958858],
            [33.108719706097546, 0.555045901908651],
            [33.109497370452466, 0.554602568169936],
            [33.11421536544381, 0.554647714482533],
            [33.11604153800847, 0.559216578998386],
            [33.11812155291286, 0.561206948403231],
            [33.12072563417425, 0.56321540114039],
            [33.128419889635666, 0.567349861294782],
            [33.134152048446786, 0.5677749537729],
            [33.13787217685421, 0.567331546442374],
            [33.139157306699694, 0.565693951018397],
            [33.141203576390424, 0.56557628553509],
            [33.14546457054895, 0.563196735050613],
            [33.16034506082246, 0.561594966046476],
            [33.16166423412224, 0.562445376381401],
            [33.162611015312564, 0.563811493433287],
            [33.16421759111279, 0.567946067243523],
            [33.16496150216924, 0.572585555925467],
            [33.159465024457745, 0.57693663608872],
            [33.158060099777565, 0.579165399182325],
            [33.156442393850966, 0.58486583451688],
            [33.157085327981285, 0.59071978337633],
            [33.15532374428554, 0.592147874080515],
            [33.154292225912776, 0.593866892455604],
            [33.15199265466813, 0.595233101646073],
            [33.1498621697161, 0.597169285768655],
            [33.14751183826799, 0.601376351203626],
            [33.1473765160536, 0.603149628215609],
            [33.14807000287651, 0.605510958433797],
            [33.14896622328939, 0.606316144363933],
            [33.14940579321243, 0.607673228563045],
            [33.15133361284645, 0.609545968339077],
            [33.15170550279764, 0.611047811494387],
            [33.14999777579814, 0.615861030485958],
            [33.15023460853794, 0.61848474402148],
            [33.1497951428195, 0.620873248015055],
            [33.147343395169045, 0.62429320188422],
            [33.14663317273238, 0.626265535958798],
            [33.146785488377034, 0.629585896113419],
            [33.146345701959994, 0.630644444556172],
            [33.1466777543233, 0.633611953586745],
            [33.145474000164484, 0.637653695138055],
            [33.14449481943682, 0.639925307963735],
            [33.1409185607137, 0.644082838159137],
            [33.13974780886182, 0.647168797201433],
            [33.13836414011789, 0.648968960667809],
            [33.13790833045116, 0.652240623303419],
            [33.13726575744357, 0.653027756937178],
            [33.13645408826186, 0.653054921125183],
            [33.12911501139243, 0.650404253145009],
            [33.12727378845347, 0.649350116530246],
            [33.12313596679512, 0.6507184132734],
            [33.12203076860276, 0.651650615682389],
            [33.115395221721116, 0.648187993838875],
            [33.11392314078692, 0.655172563194996],
            [33.10937287563218, 0.661822449947027],
            [33.10904572178212, 0.663740490644172],
            [33.106562488181, 0.667911362648184],
            [33.10607197120494, 0.674244502825804],
            [33.1063435947974, 0.675900157241059],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1283,
        District: "JINJA",
        County: "KAGOMA",
        Subcounty: "BUTAGAYA",
        Population: 53546,
        Key: "JINJABUTAGAYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.220353397659046, 0.551333374716083],
            [33.2254350549319, 0.551731246172278],
            [33.232742779699606, 0.553459019565207],
            [33.23177235395268, 0.558109336774328],
            [33.23248651460355, 0.56394480774486],
            [33.23334258032325, 0.564749988861437],
            [33.236110058846585, 0.565138912624878],
            [33.236654381314885, 0.56607072919045],
            [33.238139093460305, 0.569635286556205],
            [33.238167340984404, 0.573688486383929],
            [33.23714017315255, 0.577768842522355],
            [33.228034309545244, 0.586934098214222],
            [33.227063742762816, 0.588598841262934],
            [33.22652127980713, 0.59150305285478],
            [33.22246752698468, 0.592426022545974],
            [33.217272141200226, 0.594208556394553],
            [33.21421769406272, 0.596307623568141],
            [33.21067808570491, 0.602568503396998],
            [33.209194005973465, 0.607969778988333],
            [33.207538263581135, 0.611480202626278],
            [33.205497929957794, 0.62055469805837],
            [33.204428829666796, 0.623431769492631],
            [33.20469635873818, 0.627014500158009],
            [33.20621138902443, 0.63006336046575],
            [33.21003365048975, 0.633510225600452],
            [33.21160545609859, 0.637355269019714],
            [33.21270950714233, 0.644828258840196],
            [33.21233554837102, 0.648148620504602],
            [33.209829037624246, 0.657331719075199],
            [33.208818889273765, 0.659032651272372],
            [33.20709759771347, 0.660308419653969],
            [33.203038300489034, 0.664470324580807],
            [33.20193477675637, 0.670251573103876],
            [33.197950045988726, 0.677996234139997],
            [33.19783807278519, 0.679805685993601],
            [33.19847398209001, 0.681388925942467],
            [33.19972751728861, 0.683741186234006],
            [33.201671141881725, 0.686039095805013],
            [33.20157713498387, 0.687993317466396],
            [33.20100702008714, 0.688762373452617],
            [33.200770054396635, 0.690408978391714],
            [33.19819553938622, 0.692471865812517],
            [33.19360977999797, 0.693222992013456],
            [33.19096189059513, 0.694507803958791],
            [33.18996237380607, 0.695457808481299],
            [33.18926428491393, 0.698416309564689],
            [33.185613896315274, 0.696000827882622],
            [33.17931109170307, 0.692807376426932],
            [33.17726616140041, 0.692852709288181],
            [33.174692171904425, 0.694408926472351],
            [33.170530446076384, 0.694553839234701],
            [33.16894730552531, 0.695096753644833],
            [33.15852498871686, 0.694898051939894],
            [33.15681818967703, 0.694192434910128],
            [33.152776507517046, 0.689587500788692],
            [33.149336030047444, 0.689406657864512],
            [33.145078191670514, 0.687678753715999],
            [33.13726004146341, 0.689180832355228],
            [33.13605714070414, 0.690076555791758],
            [33.134421154061506, 0.690438487702824],
            [33.13389199066362, 0.689226166149351],
            [33.13418067955154, 0.687769526427664],
            [33.13620125742515, 0.681816332075941],
            [33.13648987624446, 0.677627424269759],
            [33.138341949933725, 0.671791867970746],
            [33.13584084345168, 0.668833454680966],
            [33.13146678463658, 0.667494564575123],
            [33.12655970236279, 0.669231809689187],
            [33.12242924149985, 0.672235625857609],
            [33.11873600775373, 0.673194722416401],
            [33.117052017837274, 0.674352802504335],
            [33.11545087594622, 0.674904736763655],
            [33.11442974389477, 0.676460889709655],
            [33.11250534953695, 0.678179955494562],
            [33.11065310067622, 0.678469500845378],
            [33.10714517949173, 0.677049139182631],
            [33.10607200803585, 0.675266844975987],
            [33.10656250255402, 0.667911376121992],
            [33.10904571279899, 0.663740492440679],
            [33.109372860360835, 0.661822436473202],
            [33.113923143481884, 0.655172570381036],
            [33.11539522261944, 0.648187989347611],
            [33.12203075512804, 0.651650631851024],
            [33.12313596320186, 0.650718408782105],
            [33.127273792945054, 0.649350110242436],
            [33.12911502307052, 0.650404264822352],
            [33.13645408377031, 0.653054930107737],
            [33.13726576103683, 0.65302777220757],
            [33.13790833673934, 0.652240639472019],
            [33.13836412664317, 0.64896894719395],
            [33.139747813353374, 0.647168782829297],
            [33.14091857059517, 0.644082844446953],
            [33.144494813148604, 0.639925308861976],
            [33.1466777543233, 0.633611946400674],
            [33.14634569297686, 0.630644458030079],
            [33.146785482088816, 0.629585914078643],
            [33.14663318890206, 0.626265539551838],
            [33.14734338438928, 0.624293188410297],
            [33.14979515359927, 0.620873230049802],
            [33.15023459146997, 0.618484728750985],
            [33.14999776591667, 0.615861028689435],
            [33.15170551267911, 0.611047807901336],
            [33.15133362362622, 0.609545952170311],
            [33.14940579051748, 0.607673245630063],
            [33.14896621250959, 0.606316129093437],
            [33.14807000197821, 0.605510953942463],
            [33.14737650976539, 0.603149638994777],
            [33.14751185353934, 0.601376335933117],
            [33.14986217600431, 0.597169292954774],
            [33.151992657363046, 0.595233107035664],
            [33.1542922393875, 0.593866898743446],
            [33.15532375776029, 0.592147874978798],
            [33.1570853333712, 0.590719770800572],
            [33.15644240642739, 0.58486583541513],
            [33.15806011055733, 0.579165406368501],
            [33.159465026254374, 0.576936645071402],
            [33.164961487796184, 0.572585544247921],
            [33.16683001862144, 0.576568074204789],
            [33.17119698883069, 0.577653611597187],
            [33.17253888232063, 0.57745455414552],
            [33.18007508100444, 0.573373986688729],
            [33.183786000781886, 0.574405243122884],
            [33.191350973402564, 0.575354953523349],
            [33.19985801914317, 0.577996463139005],
            [33.20008624692092, 0.575408954820215],
            [33.20205580318135, 0.566651096052173],
            [33.203597326581935, 0.564353030031567],
            [33.204967257390216, 0.562914462086315],
            [33.20793604926705, 0.561593440780409],
            [33.21181841970298, 0.558833884360811],
            [33.21818417735198, 0.553287681102864],
            [33.21938276080804, 0.551333409748748],
            [33.220353397659046, 0.551333374716083],
          ],
          [
            [33.1673539187901, 0.636169004660364],
            [33.16597023297819, 0.636169040590767],
            [33.164161882090426, 0.636935262526266],
            [33.163413508203625, 0.642703982391969],
            [33.16240335985319, 0.644775871512129],
            [33.15995271353727, 0.647245836296511],
            [33.158496741192764, 0.649351338160572],
            [33.15551833464746, 0.651448980295276],
            [33.1549436581057, 0.654599230256644],
            [33.15571003333246, 0.655777840761811],
            [33.160614729680866, 0.657549967472919],
            [33.162224223209094, 0.656870556134611],
            [33.167184291711614, 0.656248934027246],
            [33.169504682311334, 0.656848906362446],
            [33.17016466287247, 0.657684635826174],
            [33.170984340534936, 0.660459790097354],
            [33.173006778819506, 0.662849184456611],
            [33.17566694998889, 0.665048400065039],
            [33.17698764862804, 0.663459787742715],
            [33.1787119576294, 0.662731113304426],
            [33.18056396125006, 0.661209517282802],
            [33.181117371974096, 0.659795115939124],
            [33.1830967189728, 0.64755850730944],
            [33.183181777752125, 0.644301128450018],
            [33.180871949543516, 0.642297520283198],
            [33.17380420880563, 0.638097491977805],
            [33.17220762855961, 0.6375403599199],
            [33.16914216268684, 0.637326146541735],
            [33.1673539187901, 0.636169004660364],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1284,
        District: "JINJA",
        County: "KAGOMA",
        Subcounty: "BUWENGE",
        Population: 46616,
        Key: "JINJABUWENGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.1769876522213, 0.663459787742715],
            [33.17560398886726, 0.665045658591485],
            [33.17300677522625, 0.662849174575804],
            [33.170984334246725, 0.660459798181657],
            [33.170164652092666, 0.657684640317464],
            [33.16950469578606, 0.656848891990337],
            [33.16718428722006, 0.656248930434227],
            [33.16222420793775, 0.656870566913701],
            [33.160614738664, 0.657549960286882],
            [33.155710050400444, 0.655777843456559],
            [33.15494364642757, 0.654599215884529],
            [33.15551832386766, 0.651448982990027],
            [33.158496733107924, 0.649351336364026],
            [33.15995270455413, 0.647245849770374],
            [33.162403355361604, 0.644775856241746],
            [33.16341351988176, 0.642703990476301],
            [33.16416188927696, 0.636935267017574],
            [33.16597021680851, 0.636169039692492],
            [33.167353930468195, 0.63616899388123],
            [33.169142151008735, 0.637326156422591],
            [33.172207614186554, 0.637540354530318],
            [33.17380422497531, 0.638097479402159],
            [33.180871952238476, 0.642297514893621],
            [33.183181760684114, 0.644301137432621],
            [33.183096726159334, 0.647558501021629],
            [33.181436674548564, 0.658830744010844],
            [33.180563954063544, 0.661209506503755],
            [33.17871195403611, 0.662731105220126],
            [33.1769876522213, 0.663459787742715],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1285,
        District: "JINJA",
        County: "KAGOMA",
        Subcounty: "BUWENGE TOWN COUNCIL",
        Population: 22126,
        Key: "JINJABUWENGE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.198279471678156, 0.445354180296333],
            [33.197479681817754, 0.446004597478239],
            [33.19583414608368, 0.449155862308525],
            [33.193147486291515, 0.450501830396536],
            [33.18640055729779, 0.455594753223505],
            [33.184025211362275, 0.45940685268803],
            [33.18230362964611, 0.457894034914844],
            [33.18021112815926, 0.457185532885078],
            [33.17638889454171, 0.461854678237051],
            [33.17544597341215, 0.46374377634665],
            [33.17057911679846, 0.462997131880116],
            [33.17352732018732, 0.458636257651814],
            [33.174813518129646, 0.455722993556338],
            [33.17679683568191, 0.455451525869749],
            [33.17754750117097, 0.45410345850448],
            [33.18143378646493, 0.452511036094491],
            [33.18245209600977, 0.451217245403306],
            [33.182505651770356, 0.447815458865851],
            [33.1836848747354, 0.446141678930961],
            [33.18478370746566, 0.441744662711418],
            [33.18864295346958, 0.437374719222352],
            [33.188857467566166, 0.435375261240876],
            [33.1896078491876, 0.434081478335327],
            [33.19251008398673, 0.431051615504623],
            [33.19331409682725, 0.429377845295236],
            [33.1940110583337, 0.425758908669579],
            [33.19502505596517, 0.423704091374635],
            [33.19754928687926, 0.424246863761618],
            [33.1977299039469, 0.425576811712267],
            [33.20047918709415, 0.426989173081206],
            [33.2019232414898, 0.425414905626745],
            [33.20409004173548, 0.429051858520682],
            [33.203247537881666, 0.430019942104234],
            [33.203066994475854, 0.431476560494911],
            [33.20383461027601, 0.434100253484229],
            [33.20245598197916, 0.435312628015717],
            [33.19801883448163, 0.444820396799358],
            [33.198279471678156, 0.445354180296333],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1286,
        District: "JINJA",
        County: "JINJA MUNICIPALITY",
        Subcounty: "MASESE WALUKUBA",
        Population: 31105,
        Key: "JINJAMASESE WALUKUBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.22367314155445, 0.467969541726889],
            [33.22104139667388, 0.467302226190741],
            [33.21680878119352, 0.466958562846396],
            [33.21380455706694, 0.465872982100987],
            [33.20938718598038, 0.465474403791062],
            [33.2062674061689, 0.46276475338447],
            [33.20601097488453, 0.461976493017326],
            [33.20534993880293, 0.461914274129742],
            [33.203295449527324, 0.460061558824969],
            [33.2024156125886, 0.458505635115149],
            [33.20058467985123, 0.45809396027205],
            [33.19816408577485, 0.459061110325977],
            [33.196494860568414, 0.459257446098003],
            [33.196472027190524, 0.460800490914341],
            [33.18795613304437, 0.46390141742871],
            [33.18185310746316, 0.464372038347371],
            [33.17544597341215, 0.46374377634665],
            [33.17638889454171, 0.461854678237051],
            [33.18021112815926, 0.457185532885078],
            [33.18230362964611, 0.457894034914844],
            [33.184025211362275, 0.45940685268803],
            [33.18640055729779, 0.455594753223505],
            [33.193147486291515, 0.450501830396536],
            [33.19583414608368, 0.449155862308525],
            [33.197479681817754, 0.446004597478239],
            [33.198279471678156, 0.445354180296333],
            [33.20026112734716, 0.446150288123669],
            [33.20209251103878, 0.446195473808995],
            [33.20341527400646, 0.445788308572395],
            [33.209570418942135, 0.442051604321502],
            [33.212522900108375, 0.441137743885264],
            [33.21281047328869, 0.440757748908935],
            [33.21212878134544, 0.43777216453403],
            [33.21246940992477, 0.436550771574863],
            [33.2148547891437, 0.432922742277697],
            [33.21544386298451, 0.428145759533815],
            [33.21586695690692, 0.427953492191096],
            [33.214677966559805, 0.425117229209344],
            [33.21473501227528, 0.424332072019828],
            [33.215210559725435, 0.423853306444905],
            [33.21627581163377, 0.423642624933498],
            [33.21656118124671, 0.42481077378648],
            [33.21860502638451, 0.42666015806827],
            [33.2199662076019, 0.425811430815635],
            [33.22175428261538, 0.423891419122813],
            [33.227365984533435, 0.426668019905646],
            [33.23027076246311, 0.42760703871052],
            [33.23889944997465, 0.424634715116294],
            [33.22632389119315, 0.405029652509269],
            [33.24637367658197, 0.40304770026922],
            [33.25141246445284, 0.401002865220739],
            [33.253556400777896, 0.400894237308223],
            [33.25714776467251, 0.399808448571806],
            [33.26703775691154, 0.39670492239372],
            [33.27255845589805, 0.394551493705155],
            [33.282177606977264, 0.388869506542161],
            [33.28236997400881, 0.396921541437718],
            [33.2816619003423, 0.449042704110076],
            [33.25809361790316, 0.449631656532885],
            [33.24326134200757, 0.45455388567786],
            [33.239564247302354, 0.456200653091523],
            [33.23965061762198, 0.456572545617462],
            [33.23740415837015, 0.457141602174547],
            [33.23005405647724, 0.461457394131243],
            [33.22861787671338, 0.463131186684967],
            [33.226955300836664, 0.463746455933385],
            [33.2245935347333, 0.467944468786989],
            [33.22367314155445, 0.467969541726889],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1287,
        District: "JINJA",
        County: "JINJA MUNICIPALITY",
        Subcounty: "MPUMUDDE DIVISION",
        Population: 23616,
        Key: "JINJAMPUMUDDE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.3423657873716, -0.347267531851367],
            [32.30697542336682, -0.351182211140274],
            [32.295759088373735, -0.353896844286496],
            [32.294286405568286, -0.354917849007302],
            [32.2905396897234, -0.345053879051101],
            [32.283529680115585, -0.329734598346711],
            [32.27958667968615, -0.326977575674756],
            [32.27909436877449, -0.323662455846122],
            [32.27670043939068, -0.321101445325338],
            [32.272735653019005, -0.314623748584226],
            [32.2674302802061, -0.310519675720576],
            [32.26568353757717, -0.318095670756885],
            [32.26355081492177, -0.324753801612845],
            [32.263657805170446, -0.328698128502126],
            [32.26522223381416, -0.332678751447522],
            [32.264807865228086, -0.334795626943827],
            [32.2639658752106, -0.336795013357606],
            [32.263382092446804, -0.336917406699739],
            [32.25934175057322, -0.340833664953885],
            [32.25290729426286, -0.344900364243271],
            [32.25290676425684, -0.351679024045767],
            [32.254178157963274, -0.357629284016891],
            [32.25313042859289, -0.361470439572248],
            [32.25110994144912, -0.367119152882724],
            [32.24864072156642, -0.370734227426058],
            [32.244750044409024, -0.373821946763091],
            [32.23824192624537, -0.375888593624135],
            [32.23609646188602, -0.375473394038721],
            [32.22737268231177, -0.37587297585072],
            [32.21417267403352, -0.375066663568598],
            [32.210165700081156, -0.375211046689401],
            [32.19837857106492, -0.374070120837514],
            [32.164728327308815, -0.385972011917949],
            [32.05676376410113, -0.428056852158686],
            [32.125060355702665, -0.508110089166926],
            [32.125760380464214, -0.524103818996615],
            [32.13119314246924, -0.524426293496986],
            [32.144557921533526, -0.523223206762369],
            [32.14671534696091, -0.525485506487464],
            [32.14712584111312, -0.528381029688156],
            [32.1494997856768, -0.528886915068758],
            [32.15045854859641, -0.528703206637637],
            [32.15105213826816, -0.528059849809565],
            [32.1542602072007, -0.522941823023045],
            [32.154773591690606, -0.523280529463416],
            [32.155869504896195, -0.521672080179797],
            [32.15833437244136, -0.525119406294058],
            [32.16194019741541, -0.53155428700062],
            [32.17299082018807, -0.557268362166295],
            [32.18770464512858, -0.55165950644625],
            [32.197644907989236, -0.547336664464326],
            [32.206192941161305, -0.544506251794664],
            [32.224845615416335, -0.536810115665325],
            [32.23483495863086, -0.533138480267861],
            [32.24106289046076, -0.530018196950696],
            [32.245362646025484, -0.527123827900139],
            [32.25492840843071, -0.50990031506742],
            [32.260852920798676, -0.502763253357264],
            [32.26466854910393, -0.499624510724319],
            [32.28142199620212, -0.491683430375699],
            [32.290166148668725, -0.482610596992318],
            [32.292756114702016, -0.480683920719416],
            [32.30801546226006, -0.473782873608982],
            [32.30959107942064, -0.474769126220591],
            [32.320357356659784, -0.475177292287348],
            [32.322119146968035, -0.482080088751321],
            [32.32333344465334, -0.484966113087396],
            [32.32719218760069, -0.488811351159027],
            [32.330318177465706, -0.49070243157572],
            [32.332512920706634, -0.492846720105391],
            [32.33872751255456, -0.49702693359967],
            [32.343359093208825, -0.501170807188605],
            [32.34443675624109, -0.502817418784958],
            [32.35073125323356, -0.502836140751111],
            [32.35771834053028, -0.508165385484491],
            [32.361672262676926, -0.509920849741568],
            [32.371703752149614, -0.513359622539571],
            [32.38056491018199, -0.518263856936527],
            [32.40130219871565, -0.526525605752823],
            [32.401146641051135, -0.502017706383937],
            [32.40148940402757, -0.500443585864957],
            [32.40106301508471, -0.49509686775461],
            [32.39917973392248, -0.482657287967593],
            [32.395997136719835, -0.468923920409847],
            [32.391059823441765, -0.459424321663766],
            [32.38589004952439, -0.45253925129751],
            [32.381778512571245, -0.448115010907829],
            [32.37532496795943, -0.442577814547995],
            [32.36768630743431, -0.437492874781324],
            [32.362724854627935, -0.435022689849237],
            [32.352691229859786, -0.431131726790694],
            [32.34780371558783, -0.427946852928015],
            [32.34503051479613, -0.425051657591535],
            [32.342416345454104, -0.421188469123191],
            [32.34067188544433, -0.41752440030955],
            [32.33924400880864, -0.412593814534457],
            [32.33892703107409, -0.408224212972441],
            [32.3423657873716, -0.347267531851367],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1288,
        District: "KALANGALA",
        County: "BUJUMBA",
        Subcounty: "BUJUMBA",
        Population: 11556,
        Key: "KALANGALABUJUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.3423657873716, -0.347267531851367],
            [32.343642301475185, -0.323456587723556],
            [32.343239352273024, -0.314111272818532],
            [32.341958979006996, -0.306584301561904],
            [32.34017947122637, -0.300929974996957],
            [32.336452556945304, -0.293402875983814],
            [32.32958422243755, -0.283785791765274],
            [32.32659028222434, -0.280827342171643],
            [32.320352698895036, -0.275996044916183],
            [32.311988725134775, -0.271399854630684],
            [32.30881608755365, -0.270395487385488],
            [32.30111555376672, -0.268793783812136],
            [32.289393939782464, -0.268069387622154],
            [32.281004462851314, -0.268711201698226],
            [32.27038326263225, -0.270945085814906],
            [32.271107798824666, -0.279765569567645],
            [32.270723901991346, -0.289192118833525],
            [32.26972950739603, -0.298184379230373],
            [32.2674302802061, -0.310519675720576],
            [32.272735653019005, -0.314623748584226],
            [32.27670043939068, -0.321101445325338],
            [32.27909436877449, -0.323662455846122],
            [32.27958667968615, -0.326977575674756],
            [32.283529680115585, -0.329734598346711],
            [32.2905396897234, -0.345053879051101],
            [32.294286405568286, -0.354917849007302],
            [32.295759088373735, -0.353896844286496],
            [32.30697542336682, -0.351182211140274],
            [32.3423657873716, -0.347267531851367],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1289,
        District: "KALANGALA",
        County: "BUJUMBA",
        Subcounty: "KALANGALA TOWN COUNCIL",
        Population: 4980,
        Key: "KALANGALAKALANGALA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.117455180778045, -0.152781672135782],
            [32.00463846458122, -0.152903435644374],
            [32.001704988173174, -0.152957573320435],
            [32.00042341655453, -0.15373546665462],
            [32.00027404828236, -0.219119665090104],
            [32.0008398368927, -0.219354901598182],
            [32.053238757858246, -0.275154645840915],
            [32.05695130628129, -0.281541493324151],
            [32.05909411611899, -0.288434801059788],
            [32.06106687667003, -0.300493455476626],
            [32.061377771013476, -0.306445821954268],
            [32.06120771004872, -0.311728746249722],
            [32.060332931523355, -0.318838917256791],
            [32.05914915679478, -0.324130786832786],
            [32.05743320302387, -0.329829683444481],
            [32.0520052919214, -0.33848627271929],
            [32.04450195720393, -0.347160740294695],
            [32.0006630556313, -0.385366330271092],
            [32.00063945599049, -0.406696700594698],
            [32.0005791305259, -0.447846739943441],
            [32.0416314059849, -0.433722274811594],
            [32.05676376410113, -0.428056852158686],
            [32.164728327308815, -0.385972011917949],
            [32.19837857106492, -0.374070120837514],
            [32.210165700081156, -0.375211046689401],
            [32.21417267403352, -0.375066663568598],
            [32.22737268231177, -0.37587297585072],
            [32.23609646188602, -0.375473394038721],
            [32.23824192624537, -0.375888593624135],
            [32.244750044409024, -0.373821946763091],
            [32.24864072156642, -0.370734227426058],
            [32.25110994144912, -0.367119152882724],
            [32.25313042859289, -0.361470439572248],
            [32.254178157963274, -0.357629284016891],
            [32.25290676425684, -0.351679024045767],
            [32.25290729426286, -0.344900364243271],
            [32.25934175057322, -0.340833664953885],
            [32.263382092446804, -0.336917406699739],
            [32.2639658752106, -0.336795013357606],
            [32.264807865228086, -0.334795626943827],
            [32.26522223381416, -0.332678751447522],
            [32.263657805170446, -0.328698128502126],
            [32.26355081492177, -0.324753801612845],
            [32.26568353757717, -0.318095670756885],
            [32.2674302802061, -0.310519675720576],
            [32.26972950739603, -0.298184379230373],
            [32.270723901991346, -0.289192118833525],
            [32.271107798824666, -0.279765569567645],
            [32.27038326263225, -0.270945085814906],
            [32.26926092817752, -0.264648586086881],
            [32.26523219792729, -0.252118804427709],
            [32.2590122907478, -0.243886059134207],
            [32.25664384656862, -0.239435019257452],
            [32.25061629384432, -0.225774379472362],
            [32.24778838026192, -0.216872412722203],
            [32.24539830195574, -0.206513986541428],
            [32.24353479450952, -0.187986567361305],
            [32.24358565712091, -0.180324132980755],
            [32.24557005893974, -0.168880314170402],
            [32.24771267024975, -0.161046075274437],
            [32.25009194182308, -0.154885439896584],
            [32.25014788530572, -0.152868059216089],
            [32.117455180778045, -0.152781672135782],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1290,
        District: "KALANGALA",
        County: "BUJUMBA",
        Subcounty: "MUGOYE",
        Population: 12224,
        Key: "KALANGALAMUGOYE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.75090247736111, -0.442274251422795],
            [32.75131688277809, -0.266187485166146],
            [32.750922465774494, -0.25864206357165],
            [32.75171185224557, -0.245930681500448],
            [32.7513175708876, -0.228849445694115],
            [32.753290721307486, -0.193501821636541],
            [32.753291250415174, -0.151802980853915],
            [32.74500661675913, -0.151802886531151],
            [32.74027257336523, -0.152200911564888],
            [32.72725362592243, -0.151802671834531],
            [32.500986982763074, -0.152486254118029],
            [32.48674501140029, -0.15264877764134],
            [32.46204534757315, -0.152602934080118],
            [32.464499930306644, -0.157144570493203],
            [32.469470721100386, -0.171963608741671],
            [32.471127711252656, -0.177853231844252],
            [32.47307691707864, -0.187958741296831],
            [32.47707283905808, -0.205039536377758],
            [32.48101990256752, -0.228878435893667],
            [32.48184807919086, -0.236242703736898],
            [32.48184784203563, -0.242620824900511],
            [32.48082406534399, -0.253829975956768],
            [32.49605087502413, -0.253776306636675],
            [32.497860707233784, -0.256463324270434],
            [32.49938078874688, -0.257711872928416],
            [32.50061769073969, -0.261565938301306],
            [32.50061540362895, -0.262660623732958],
            [32.500106224152894, -0.263438651790681],
            [32.49602791318716, -0.266279238098736],
            [32.49012477623139, -0.269192124758431],
            [32.49303556568697, -0.275742272891691],
            [32.49523363628768, -0.282210963671073],
            [32.49744951778555, -0.292063231393938],
            [32.50285347980257, -0.311731664832894],
            [32.51008790383971, -0.312781453721228],
            [32.52701735335992, -0.316672453958974],
            [32.538855836366, -0.322381676235257],
            [32.55331211341624, -0.331872692324921],
            [32.55390441580219, -0.349939710747529],
            [32.55498187671353, -0.357846894856128],
            [32.555825407341736, -0.359846335681341],
            [32.56204396974323, -0.36474111109487],
            [32.563492430375305, -0.366342517736477],
            [32.569725689214856, -0.369337394257195],
            [32.5703426988644, -0.368984595438914],
            [32.57295361810169, -0.369029958521656],
            [32.57828675604339, -0.367112230607255],
            [32.58346147159316, -0.366262034823405],
            [32.58739210761102, -0.364787544070952],
            [32.590683041636936, -0.362399252992933],
            [32.59436299379158, -0.358427743154646],
            [32.59511429349125, -0.35701642392589],
            [32.59671174600146, -0.355605133226033],
            [32.60369576016157, -0.357595804458404],
            [32.61241865220036, -0.360970768812268],
            [32.61853179101503, -0.363477087538323],
            [32.63237475498315, -0.370842037375628],
            [32.646881069093055, -0.379428393680594],
            [32.65922413040431, -0.387526122140854],
            [32.66456361224854, -0.39009572887855],
            [32.676049926018806, -0.396963002184646],
            [32.69099195268591, -0.405169390942088],
            [32.702189955759, -0.410860522217864],
            [32.71054756854875, -0.416524382698365],
            [32.720162226254885, -0.422143058669494],
            [32.73709431861866, -0.433733175555233],
            [32.75090247736111, -0.442274251422795],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1291,
        District: "KALANGALA",
        County: "KYAMUSWA",
        Subcounty: "BUBEKE",
        Population: 5133,
        Key: "KALANGALABUBEKE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.46204534757315, -0.152602934080118],
            [32.40343573344801, -0.152547129135894],
            [32.25014788530572, -0.152868059216089],
            [32.25009194182308, -0.154885439896584],
            [32.24771267024975, -0.161046075274437],
            [32.24557005893974, -0.168880314170402],
            [32.24358565712091, -0.180324132980755],
            [32.24353479450952, -0.187986567361305],
            [32.24539830195574, -0.206513986541428],
            [32.24778838026192, -0.216872412722203],
            [32.25061629384432, -0.225774379472362],
            [32.25664384656862, -0.239435019257452],
            [32.2590122907478, -0.243886059134207],
            [32.26523219792729, -0.252118804427709],
            [32.26926092817752, -0.264648586086881],
            [32.27038326263225, -0.270945085814906],
            [32.281004462851314, -0.268711201698226],
            [32.289393939782464, -0.268069387622154],
            [32.30111555376672, -0.268793783812136],
            [32.30881608755365, -0.270395487385488],
            [32.311988725134775, -0.271399854630684],
            [32.320352698895036, -0.275996044916183],
            [32.32659028222434, -0.280827342171643],
            [32.32958422243755, -0.283785791765274],
            [32.336452556945304, -0.293402875983814],
            [32.34017947122637, -0.300929974996957],
            [32.341958979006996, -0.306584301561904],
            [32.343239352273024, -0.314111272818532],
            [32.343642301475185, -0.323456587723556],
            [32.3423657873716, -0.347267531851367],
            [32.33892703107409, -0.408224212972441],
            [32.33924400880864, -0.412593814534457],
            [32.34067188544433, -0.41752440030955],
            [32.342416345454104, -0.421188469123191],
            [32.34503051479613, -0.425051657591535],
            [32.34780371558783, -0.427946852928015],
            [32.352691229859786, -0.431131726790694],
            [32.362724854627935, -0.435022689849237],
            [32.36768630743431, -0.437492874781324],
            [32.37532496795943, -0.442577814547995],
            [32.381778512571245, -0.448115010907829],
            [32.38589004952439, -0.45253925129751],
            [32.391059823441765, -0.459424321663766],
            [32.395997136719835, -0.468923920409847],
            [32.406691254088834, -0.450840173076496],
            [32.41607764269477, -0.43758727149044],
            [32.4264670524177, -0.425112425151438],
            [32.44044335332344, -0.410348888208046],
            [32.45342158013442, -0.399059219729543],
            [32.46333933390902, -0.391460435682544],
            [32.47297781403818, -0.385680045409207],
            [32.47420199678486, -0.385019693507989],
            [32.474950996797396, -0.38513672068513],
            [32.49483670040802, -0.372592950864522],
            [32.49482224921005, -0.372047563729672],
            [32.4963447391064, -0.370464421379628],
            [32.498581776827535, -0.366384351424043],
            [32.50240727851609, -0.361227779795582],
            [32.50667799693757, -0.353836604412475],
            [32.50813934929232, -0.350263125161459],
            [32.508742463801035, -0.347132878659258],
            [32.50922808136552, -0.340166707277633],
            [32.508479316711586, -0.330160678390649],
            [32.507965243213846, -0.327645587952351],
            [32.50597073444977, -0.322859620000213],
            [32.50285347980257, -0.311731664832894],
            [32.49744951778555, -0.292063231393938],
            [32.49523363628768, -0.282210963671073],
            [32.49303556568697, -0.275742272891691],
            [32.49012477623139, -0.269192124758431],
            [32.49602791318716, -0.266279238098736],
            [32.500106224152894, -0.263438651790681],
            [32.50061540362895, -0.262660623732958],
            [32.50061769073969, -0.261565938301306],
            [32.49938078874688, -0.257711872928416],
            [32.497860707233784, -0.256463324270434],
            [32.49605087502413, -0.253776306636675],
            [32.48082406534399, -0.253829975956768],
            [32.48184784203563, -0.242620824900511],
            [32.48184807919086, -0.236242703736898],
            [32.48101990256752, -0.228878435893667],
            [32.47707283905808, -0.205039536377758],
            [32.47307691707864, -0.187958741296831],
            [32.471127711252656, -0.177853231844252],
            [32.469470721100386, -0.171963608741671],
            [32.464499930306644, -0.157144570493203],
            [32.46204534757315, -0.152602934080118],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1292,
        District: "KALANGALA",
        County: "KYAMUSWA",
        Subcounty: "BUFUMIRA",
        Population: 10292,
        Key: "KALANGALABUFUMIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.75090247736111, -0.442274251422795],
            [32.73709431861866, -0.433733175555233],
            [32.720162226254885, -0.422143058669494],
            [32.71054756854875, -0.416524382698365],
            [32.702189955759, -0.410860522217864],
            [32.69099195268591, -0.405169390942088],
            [32.676049926018806, -0.396963002184646],
            [32.66456361224854, -0.39009572887855],
            [32.65922413040431, -0.387526122140854],
            [32.646881069093055, -0.379428393680594],
            [32.63237475498315, -0.370842037375628],
            [32.61853179101503, -0.363477087538323],
            [32.61241865220036, -0.360970768812268],
            [32.60369576016157, -0.357595804458404],
            [32.59671174600146, -0.355605133226033],
            [32.59511429349125, -0.35701642392589],
            [32.59436299379158, -0.358427743154646],
            [32.590683041636936, -0.362399252992933],
            [32.58739210761102, -0.364787544070952],
            [32.58346147159316, -0.366262034823405],
            [32.57828675604339, -0.367112230607255],
            [32.57295361810169, -0.369029958521656],
            [32.5703426988644, -0.368984595438914],
            [32.569725689214856, -0.369337394257195],
            [32.563492430375305, -0.366342517736477],
            [32.56204396974323, -0.36474111109487],
            [32.555825407341736, -0.359846335681341],
            [32.55498187671353, -0.357846894856128],
            [32.55390441580219, -0.349939710747529],
            [32.55331211341624, -0.331872692324921],
            [32.538855836366, -0.322381676235257],
            [32.52701735335992, -0.316672453958974],
            [32.51008790383971, -0.312781453721228],
            [32.50285347980257, -0.311731664832894],
            [32.50597073444977, -0.322859620000213],
            [32.507965243213846, -0.327645587952351],
            [32.508479316711586, -0.330160678390649],
            [32.50922808136552, -0.340166707277633],
            [32.508742463801035, -0.347132878659258],
            [32.50813934929232, -0.350263125161459],
            [32.50667799693757, -0.353836604412475],
            [32.50240727851609, -0.361227779795582],
            [32.498581776827535, -0.366384351424043],
            [32.4963447391064, -0.370464421379628],
            [32.49482224921005, -0.372047563729672],
            [32.49483670040802, -0.372592950864522],
            [32.474950996797396, -0.38513672068513],
            [32.47420199678486, -0.385019693507989],
            [32.47297781403818, -0.385680045409207],
            [32.46333933390902, -0.391460435682544],
            [32.45342158013442, -0.399059219729543],
            [32.44044335332344, -0.410348888208046],
            [32.4264670524177, -0.425112425151438],
            [32.41607764269477, -0.43758727149044],
            [32.406691254088834, -0.450840173076496],
            [32.395997136719835, -0.468923920409847],
            [32.39917973392248, -0.482657287967593],
            [32.40106301508471, -0.49509686775461],
            [32.40148940402757, -0.500443585864957],
            [32.401146641051135, -0.502017706383937],
            [32.40130219871565, -0.526525605752823],
            [32.40266574968878, -0.75249768402873],
            [32.40192530972258, -1.000010808981554],
            [32.75099278679325, -1.000056022386913],
            [32.750642548037, -0.629299368795266],
            [32.75052127727027, -0.500511413267731],
            [32.75090247736111, -0.442274251422795],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1293,
        District: "KALANGALA",
        County: "KYAMUSWA",
        Subcounty: "KYAMUSWA",
        Population: 4731,
        Key: "KALANGALAKYAMUSWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.40130219871565, -0.526525605752823],
            [32.38056491018199, -0.518263856936527],
            [32.371703752149614, -0.513359622539571],
            [32.361672262676926, -0.509920849741568],
            [32.35771834053028, -0.508165385484491],
            [32.35073125323356, -0.502836140751111],
            [32.34443675624109, -0.502817418784958],
            [32.343359093208825, -0.501170807188605],
            [32.33872751255456, -0.49702693359967],
            [32.332512920706634, -0.492846720105391],
            [32.330318177465706, -0.49070243157572],
            [32.32719218760069, -0.488811351159027],
            [32.32333344465334, -0.484966113087396],
            [32.322119146968035, -0.482080088751321],
            [32.320357356659784, -0.475177292287348],
            [32.30959107942064, -0.474769126220591],
            [32.30801546226006, -0.473782873608982],
            [32.292756114702016, -0.480683920719416],
            [32.290166148668725, -0.482610596992318],
            [32.28142199620212, -0.491683430375699],
            [32.26466854910393, -0.499624510724319],
            [32.260852920798676, -0.502763253357264],
            [32.25492840843071, -0.50990031506742],
            [32.245362646025484, -0.527123827900139],
            [32.24106289046076, -0.530018196950696],
            [32.23483495863086, -0.533138480267861],
            [32.224845615416335, -0.536810115665325],
            [32.206192941161305, -0.544506251794664],
            [32.197644907989236, -0.547336664464326],
            [32.18770464512858, -0.55165950644625],
            [32.17299082018807, -0.557268362166295],
            [32.16194019741541, -0.53155428700062],
            [32.15833437244136, -0.525119406294058],
            [32.155869504896195, -0.521672080179797],
            [32.154773591690606, -0.523280529463416],
            [32.1542602072007, -0.522941823023045],
            [32.15105213826816, -0.528059849809565],
            [32.15045854859641, -0.528703206637637],
            [32.1494997856768, -0.528886915068758],
            [32.14712584111312, -0.528381029688156],
            [32.14671534696091, -0.525485506487464],
            [32.144557921533526, -0.523223206762369],
            [32.13119314246924, -0.524426293496986],
            [32.125760380464214, -0.524103818996615],
            [32.125060355702665, -0.508110089166926],
            [32.05676376410113, -0.428056852158686],
            [32.0416314059849, -0.433722274811594],
            [32.0005791305259, -0.447846739943441],
            [32.00053811075507, -0.491746752084751],
            [32.000513329829644, -0.607607302217042],
            [32.00050699401195, -0.818685384927538],
            [32.00050234792529, -0.820081490902883],
            [31.999898977396747, -0.999912568016137],
            [32.20083400450297, -0.999967846410857],
            [32.40192530972258, -1.000010808981554],
            [32.40266574968878, -0.75249768402873],
            [32.40130219871565, -0.526525605752823],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1294,
        District: "KALANGALA",
        County: "KYAMUSWA",
        Subcounty: "MAZINGA",
        Population: 5377,
        Key: "KALANGALAMAZINGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.075660348084156, 0.338366747667588],
            [33.07215586834555, 0.34085027181471],
            [33.06619130009907, 0.34288579825074],
            [33.05261937851341, 0.349323097955848],
            [33.05085022651139, 0.3504935117745],
            [33.046553700390135, 0.350646194666966],
            [33.045188929504846, 0.352223700953815],
            [33.041347363244036, 0.360162104338435],
            [33.04101880892046, 0.361103517412786],
            [33.04182757474716, 0.362579238536069],
            [33.041671890420226, 0.362935448440986],
            [33.03151389659595, 0.369383902666301],
            [33.02890967789235, 0.365720040167997],
            [33.02654809774022, 0.364970989806716],
            [33.02328071035454, 0.36532924414121],
            [33.022374888747905, 0.360932602848155],
            [33.024299718788654, 0.35466330726857],
            [33.02604660784298, 0.34394851758341],
            [33.02213221965366, 0.343915959630832],
            [33.01478871498821, 0.352806966028182],
            [33.011019903282246, 0.355852056473846],
            [33.01037289529213, 0.355591515028619],
            [33.010502288625645, 0.348328908635569],
            [33.009871457497155, 0.347596134032452],
            [33.00912739642206, 0.344013684691277],
            [33.0059408852597, 0.336734795832723],
            [33.00399632731699, 0.334826879697274],
            [33.00415065249292, 0.334162797965761],
            [33.0100852924674, 0.327423162434145],
            [33.0124141173493, 0.325915992649031],
            [33.01607370200151, 0.326418375416118],
            [33.019733288450354, 0.327925537041119],
            [33.0217294159786, 0.323738956053138],
            [33.022561123879335, 0.316705506964939],
            [33.02588801117789, 0.314863404706227],
            [33.03420523750906, 0.315198305954816],
            [33.03603501950455, 0.312853817328712],
            [33.04401953770227, 0.309002137058277],
            [33.05199534224174, 0.303551442609287],
            [33.05742372855301, 0.309551531495464],
            [33.06398745602601, 0.319910977011042],
            [33.06591088649155, 0.321605272799182],
            [33.069120634375366, 0.327474818312634],
            [33.0693009639821, 0.328745547090609],
            [33.075660348084156, 0.338366747667588],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1295,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "BUIKWE TOWN COUNCIL",
        Population: 16544,
        Key: "BUIKWEBUIKWE TOWN COUNCIL",
        Dist2: "Buikwe",
        "Sub Country": "Buikwe T.C",
        id2_original: "Buikwe  Buikwe T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.992239325100485, 0.335343965386221],
            [32.98191916560446, 0.345544289204794],
            [32.9711049551601, 0.349372459463157],
            [32.96986624036705, 0.350762447063381],
            [32.969307175646605, 0.350802712393039],
            [32.96824706659329, 0.352932042381295],
            [32.968345729459266, 0.361226980310854],
            [32.969761971115375, 0.362934802565231],
            [32.969564052495336, 0.366179519063629],
            [32.97024258686036, 0.367801880017128],
            [32.97194173045736, 0.369402652811563],
            [32.975557812395294, 0.367830358719777],
            [32.97748034095231, 0.368086526006654],
            [32.97790442571645, 0.368826550022157],
            [32.9785829654714, 0.36899732609914],
            [32.98070677863577, 0.368655782026572],
            [32.97733926592681, 0.37918320838823],
            [32.97819644016756, 0.381155638058428],
            [32.98419669219208, 0.383251355597387],
            [32.98525796097041, 0.384032110620757],
            [32.985706958712356, 0.384895047889198],
            [32.98413545583577, 0.388285155108922],
            [32.98213536763549, 0.388901534337566],
            [32.9819312748945, 0.389517917114374],
            [32.990625530438656, 0.391325990665854],
            [32.99054389424056, 0.391654728656515],
            [32.98780907846096, 0.392147832025192],
            [32.986625353139694, 0.392846397701098],
            [32.980461812549386, 0.394572260465471],
            [32.97952299222907, 0.395394101505124],
            [32.979461763059305, 0.396565231426071],
            [32.97584933546793, 0.404023462062006],
            [32.97380832541317, 0.409239825084825],
            [32.970093878849916, 0.409773605664154],
            [32.9650121398304, 0.396935012250465],
            [32.96370596515275, 0.395702239660705],
            [32.96186914845028, 0.395743323130322],
            [32.9595833367008, 0.395168020691396],
            [32.956358718105804, 0.392538101340088],
            [32.953542288586, 0.388921969641191],
            [32.95213408056347, 0.385942776012043],
            [32.95184837857387, 0.381833551033216],
            [32.95250147534498, 0.380272050396977],
            [32.95368520964938, 0.378176352794686],
            [32.95860380922342, 0.372813842817717],
            [32.958073179775006, 0.371868718315243],
            [32.95533838286001, 0.369937370142894],
            [32.95105250267316, 0.368006011668898],
            [32.950032057832914, 0.367266346904074],
            [32.949137038467576, 0.36579900945554],
            [32.94625446689169, 0.365295107955941],
            [32.94494209922851, 0.364323015775987],
            [32.94354028900744, 0.364323006793031],
            [32.94176645678281, 0.360753177809978],
            [32.939154114614084, 0.359808040357686],
            [32.93368454773353, 0.354589290201867],
            [32.930704828749604, 0.356109679341752],
            [32.92886799587743, 0.359397042260762],
            [32.92943942770441, 0.361903672231949],
            [32.92899041648775, 0.363711726359186],
            [32.92805159257418, 0.365026668953159],
            [32.92692906318505, 0.369320795532248],
            [32.926765761144495, 0.373019092732864],
            [32.92729638430473, 0.374292955768085],
            [32.9265616387591, 0.376881759453875],
            [32.9254187274945, 0.377621408140771],
            [32.92435745961446, 0.377621399157796],
            [32.92260228988986, 0.377046092796832],
            [32.92145939299827, 0.376183146658576],
            [32.91549997030174, 0.375525614679635],
            [32.91454075822451, 0.374518845798056],
            [32.91290804324615, 0.374066816005993],
            [32.91139777672587, 0.374066800734968],
            [32.91086713919261, 0.374518808967895],
            [32.91074467007329, 0.375874850594353],
            [32.91172425324622, 0.380723739412558],
            [32.91486720959202, 0.383887870476106],
            [32.92150011812165, 0.386415104849447],
            [32.927745249096006, 0.390154551894678],
            [32.928316674634736, 0.393318657881142],
            [32.929071796665966, 0.394900713569155],
            [32.93201881427862, 0.398663233981237],
            [32.930214676489534, 0.398391798414736],
            [32.923316405624945, 0.399050975191819],
            [32.92031624188345, 0.402399960881842],
            [32.91268328476206, 0.399812060609627],
            [32.91015259765604, 0.40030058938329],
            [32.908928124753494, 0.399893445094189],
            [32.90896888131794, 0.396808304326128],
            [32.90972412641833, 0.391452289051376],
            [32.90915261374302, 0.39058583832353],
            [32.90898946531436, 0.38922663522833],
            [32.90890780216683, 0.383391102480316],
            [32.908275069304885, 0.382803018254078],
            [32.89958077153994, 0.379591119026284],
            [32.8938664847114, 0.378071094993471],
            [32.89165856677851, 0.378003629390899],
            [32.89118304627783, 0.374843842132099],
            [32.891968359787406, 0.370652258770286],
            [32.89088684567752, 0.369892269367405],
            [32.88737631129384, 0.370344591319746],
            [32.88416860348407, 0.36981682862501],
            [32.88127420199424, 0.367901731092929],
            [32.88017219731269, 0.366381765227209],
            [32.879478235280985, 0.366463181469699],
            [32.877845404419965, 0.36753074440245],
            [32.874416779322225, 0.368642180018109],
            [32.867436759970175, 0.372461385490627],
            [32.86445701673169, 0.372995131578765],
            [32.864334623969185, 0.369466673512688],
            [32.865518396002834, 0.367982930832075],
            [32.8645388532541, 0.365721084887406],
            [32.86504922479454, 0.36019317734846],
            [32.864437023826724, 0.35789514871697],
            [32.86341647118867, 0.35616709405398],
            [32.86486561004878, 0.353848872470383],
            [32.86576365224506, 0.343120887639458],
            [32.86819236798993, 0.343066638453781],
            [32.871906839706, 0.338253511610133],
            [32.872886410302534, 0.338543038966258],
            [32.87472339858321, 0.338045460023874],
            [32.8777233799667, 0.335231780304529],
            [32.87837663304471, 0.333919925488402],
            [32.876825602773444, 0.329522904870247],
            [32.873641757810866, 0.325532993133626],
            [32.87305004292309, 0.324284453778404],
            [32.872845959165275, 0.318448105846296],
            [32.87378482529963, 0.315897590679279],
            [32.87425415371309, 0.312224381665336],
            [32.87556039396773, 0.307990248067468],
            [32.87756057379621, 0.304986558294398],
            [32.878887277673, 0.303738042531258],
            [32.88141797645712, 0.299467730923156],
            [32.884152825474416, 0.296916413525586],
            [32.885860941444456, 0.292465144101208],
            [32.886846171427244, 0.28817671924432],
            [32.889037593596534, 0.285426352152205],
            [32.89365716916536, 0.281201291055281],
            [32.89543405386534, 0.280034201259688],
            [32.90119413770539, 0.273266844416603],
            [32.90641894421371, 0.269487124644979],
            [32.908004543453714, 0.267928969902923],
            [32.92391357508313, 0.268979636909599],
            [32.92874617174849, 0.266939560955661],
            [32.93984963971437, 0.268635495213403],
            [32.94217882482071, 0.272836744027565],
            [32.944718291162, 0.27601211020034],
            [32.94640049163441, 0.276989149645333],
            [32.950476599032726, 0.278063903002756],
            [32.953161643654006, 0.281353255424078],
            [32.95495706239493, 0.28439834542755],
            [32.957383314061, 0.286384986355667],
            [32.959114034338505, 0.289299804802625],
            [32.95791280714059, 0.294041738639277],
            [32.95587281487704, 0.295494352721974],
            [32.95246021841892, 0.296808148224119],
            [32.952638678631594, 0.297998860770401],
            [32.9522903829313, 0.299401392143683],
            [32.950200625797656, 0.302306627687874],
            [32.949902085984334, 0.30345870543375],
            [32.95030012050358, 0.306013318966857],
            [32.950897186655496, 0.306764677992178],
            [32.95452935831848, 0.307716412284034],
            [32.957763486479124, 0.307966878732957],
            [32.95945517944913, 0.309219145313164],
            [32.966072698939655, 0.311623510171236],
            [32.97234193620462, 0.312024252566033],
            [32.97498226628435, 0.313308017620036],
            [32.978168206118184, 0.318024606129743],
            [32.98002833679722, 0.321883888078101],
            [32.98580284488576, 0.328771975091188],
            [32.992239325100485, 0.335343965386221],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1296,
        District: "BUIKWE",
        County: "LUGAZI MUNICIPALITY",
        Subcounty: "KAWOLO DIVISION",
        Population: 40970,
        Key: "BUIKWEKAWOLO DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Lugazi T.C",
        id2_original: "Buikwe  Lugazi T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "L",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.970093878849916, 0.409773605664154],
            [32.9605117841745, 0.41116209776378],
            [32.95298163115255, 0.4108188091217],
            [32.949664866968945, 0.411041278366466],
            [32.94735816849082, 0.405629802830952],
            [32.94550094745499, 0.4056840740869],
            [32.939623178024526, 0.403965037088309],
            [32.93774546282377, 0.403015051807958],
            [32.93417399930767, 0.399794169299684],
            [32.93201881427862, 0.398663233981237],
            [32.929071796665966, 0.394900713569155],
            [32.928316674634736, 0.393318657881142],
            [32.927745249096006, 0.390154551894678],
            [32.92150011812165, 0.386415104849447],
            [32.91486720959202, 0.383887870476106],
            [32.91172425324622, 0.380723739412558],
            [32.91074467007329, 0.375874850594353],
            [32.91086713919261, 0.374518808967895],
            [32.91139777672587, 0.374066800734968],
            [32.91290804324615, 0.374066816005993],
            [32.91454075822451, 0.374518845798056],
            [32.91549997030174, 0.375525614679635],
            [32.92145939299827, 0.376183146658576],
            [32.92260228988986, 0.377046092796832],
            [32.92435745961446, 0.377621399157796],
            [32.9254187274945, 0.377621408140771],
            [32.9265616387591, 0.376881759453875],
            [32.92729638430473, 0.374292955768085],
            [32.926765761144495, 0.373019092732864],
            [32.92692906318505, 0.369320795532248],
            [32.92805159257418, 0.365026668953159],
            [32.92899041648775, 0.363711726359186],
            [32.92943942770441, 0.361903672231949],
            [32.92886799587743, 0.359397042260762],
            [32.930704828749604, 0.356109679341752],
            [32.93368454773353, 0.354589290201867],
            [32.939154114614084, 0.359808040357686],
            [32.94176645678281, 0.360753177809978],
            [32.94354028900744, 0.364323006793031],
            [32.94494209922851, 0.364323015775987],
            [32.94625446689169, 0.365295107955941],
            [32.949137038467576, 0.36579900945554],
            [32.950032057832914, 0.367266346904074],
            [32.95105250267316, 0.368006011668898],
            [32.95533838286001, 0.369937370142894],
            [32.958073179775006, 0.371868718315243],
            [32.95860380922342, 0.372813842817717],
            [32.95368520964938, 0.378176352794686],
            [32.95250147534498, 0.380272050396977],
            [32.95184837857387, 0.381833551033216],
            [32.95213408056347, 0.385942776012043],
            [32.953542288586, 0.388921969641191],
            [32.956358718105804, 0.392538101340088],
            [32.9595833367008, 0.395168020691396],
            [32.96186914845028, 0.395743323130322],
            [32.96370596515275, 0.395702239660705],
            [32.9650121398304, 0.396935012250465],
            [32.970093878849916, 0.409773605664154],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1297,
        District: "BUIKWE",
        County: "LUGAZI MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 40233,
        Key: "BUIKWECENTRAL DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Kawolo",
        id2_original: "Buikwe  Kawolo",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.11853359306572, 0.416994766764753],
            [33.11563272550245, 0.413389517050272],
            [33.11081469052784, 0.41445973027317],
            [33.10520974214409, 0.414848951109608],
            [33.10464373434482, 0.415529959520753],
            [33.105140744343764, 0.417003138841465],
            [33.10489228830248, 0.419921717899079],
            [33.09503540257491, 0.42895553307634],
            [33.09081098961138, 0.430595546541647],
            [33.088188004203175, 0.433152807725612],
            [33.086766082499516, 0.435640563809264],
            [33.08552364957951, 0.439837769170488],
            [33.08299731481101, 0.443965500349891],
            [33.07895238434296, 0.447982063412528],
            [33.07759946672784, 0.448843753145111],
            [33.075694328656425, 0.449232917425478],
            [33.04900849782097, 0.445438994866101],
            [33.02338569915675, 0.442325971282525],
            [33.022916329420795, 0.446189616970953],
            [33.02113544452284, 0.449594630913552],
            [33.02040377391045, 0.455167730981305],
            [33.020583264490725, 0.46215842469206],
            [33.02008627245812, 0.463298061261594],
            [33.02101125243482, 0.469093524737903],
            [33.01813973642515, 0.473985628111614],
            [33.01475740780222, 0.47602864306294],
            [33.00768902387058, 0.478474702163205],
            [33.005825290947264, 0.481268202121839],
            [33.00339553046173, 0.480712283127986],
            [33.000303108842225, 0.482685800381275],
            [32.99831512274544, 0.483130536888389],
            [32.9894934339917, 0.484089489327879],
            [32.988637495832826, 0.483894915789672],
            [32.98579357696698, 0.481031922990889],
            [32.982383635030544, 0.479350256788971],
            [32.981362034058506, 0.478349599053146],
            [32.97860095333664, 0.475486603036176],
            [32.977620776377286, 0.472581918234448],
            [32.97618501971993, 0.470163662566709],
            [32.97156021415954, 0.466508469720774],
            [32.968440203481045, 0.463339713881125],
            [32.96115093549917, 0.464812863995555],
            [32.96004649368826, 0.466258249593274],
            [32.957561510168965, 0.467592443335576],
            [32.95504890794623, 0.46984390272878],
            [32.95402930482738, 0.470133576305845],
            [32.953691406228224, 0.468969829969648],
            [32.95230422596985, 0.467394292359726],
            [32.95027680473038, 0.466033593765912],
            [32.94967214062781, 0.46481613375559],
            [32.94956543784004, 0.464207405917395],
            [32.95059705323086, 0.462275247691568],
            [32.95157512903073, 0.457744170167112],
            [32.951575140708826, 0.455989603297479],
            [32.95004569246229, 0.453697913320895],
            [32.94985008251256, 0.450776067688897],
            [32.95056147545405, 0.449274213506224],
            [32.95340701577892, 0.447093822882156],
            [32.95518535305474, 0.443221570267488],
            [32.95676821153479, 0.440805938504638],
            [32.957372882823904, 0.438770289377251],
            [32.958440099347754, 0.437910797483893],
            [32.9626904511651, 0.42944250421341],
            [32.96558934602799, 0.426411656810844],
            [32.967438992469354, 0.425660735400408],
            [32.96822143047172, 0.4244755362214],
            [32.97005341064471, 0.416731014903564],
            [32.97380832541317, 0.409239825084825],
            [32.97584933546793, 0.404023462062006],
            [32.979461763059305, 0.396565231426071],
            [32.97952299222907, 0.395394101505124],
            [32.980461812549386, 0.394572260465471],
            [32.986625353139694, 0.392846397701098],
            [32.98780907846096, 0.392147832025192],
            [32.99054389424056, 0.391654728656515],
            [32.990625530438656, 0.391325990665854],
            [32.9819312748945, 0.389517917114374],
            [32.98213536763549, 0.388901534337566],
            [32.98413545583577, 0.388285155108922],
            [32.985706958712356, 0.384895047889198],
            [32.98525796097041, 0.384032110620757],
            [32.98419669219208, 0.383251355597387],
            [32.97819644016756, 0.381155638058428],
            [32.97733926592681, 0.37918320838823],
            [32.98070677863577, 0.368655782026572],
            [32.9785829654714, 0.36899732609914],
            [32.97790442571645, 0.368826550022157],
            [32.97748034095231, 0.368086526006654],
            [32.975557812395294, 0.367830358719777],
            [32.97194173045736, 0.369402652811563],
            [32.97024258686036, 0.367801880017128],
            [32.969564052495336, 0.366179519063629],
            [32.969761971115375, 0.362934802565231],
            [32.968345729459266, 0.361226980310854],
            [32.96824706659329, 0.352932042381295],
            [32.969307175646605, 0.350802712393039],
            [32.96986624036705, 0.350762447063381],
            [32.9711049551601, 0.349372459463157],
            [32.98191916560446, 0.345544289204794],
            [32.992239325100485, 0.335343965386221],
            [32.995390977138214, 0.33386047599238],
            [33.00415065249292, 0.334162797965761],
            [33.00399632731699, 0.334826879697274],
            [33.0059408852597, 0.336734795832723],
            [33.00912739642206, 0.344013684691277],
            [33.009871457497155, 0.347596134032452],
            [33.010502288625645, 0.348328908635569],
            [33.01037289529213, 0.355591515028619],
            [33.011019903282246, 0.355852056473846],
            [33.01478871498821, 0.352806966028182],
            [33.02213221965366, 0.343915959630832],
            [33.02604660784298, 0.34394851758341],
            [33.024299718788654, 0.35466330726857],
            [33.022374888747905, 0.360932602848155],
            [33.02328071035454, 0.36532924414121],
            [33.02654809774022, 0.364970989806716],
            [33.02890967789235, 0.365720040167997],
            [33.03151389659595, 0.369383902666301],
            [33.041671890420226, 0.362935448440986],
            [33.04182757474716, 0.362579238536069],
            [33.04101880892046, 0.361103517412786],
            [33.041347363244036, 0.360162104338435],
            [33.045188929504846, 0.352223700953815],
            [33.046553700390135, 0.350646194666966],
            [33.05085022651139, 0.3504935117745],
            [33.05261937851341, 0.349323097955848],
            [33.06619130009907, 0.34288579825074],
            [33.07215586834555, 0.34085027181471],
            [33.075660348084156, 0.338366747667588],
            [33.078232924530205, 0.338052070610986],
            [33.10120582785357, 0.340992686402087],
            [33.10667308336888, 0.342167890080984],
            [33.10485387723922, 0.343341411101639],
            [33.102832243845164, 0.349544216845658],
            [33.10504789447597, 0.349840138846517],
            [33.10931165364894, 0.349482387853377],
            [33.114617328295765, 0.350018381935783],
            [33.110513357852305, 0.356651351182998],
            [33.109646407246316, 0.357572636460105],
            [33.10849046232522, 0.357863580737055],
            [33.107190036865425, 0.359366729207787],
            [33.10391490959526, 0.364651980261375],
            [33.10275897275901, 0.365815710592914],
            [33.098799322055804, 0.367354627922803],
            [33.0992607767358, 0.37303009057381],
            [33.1000876346323, 0.372985076050564],
            [33.100200919376164, 0.374581455238918],
            [33.10216424222684, 0.378002248710375],
            [33.10362077332344, 0.381675955894633],
            [33.10507107011198, 0.382301665296243],
            [33.10632337192371, 0.383950248987366],
            [33.10690141355453, 0.389186964744075],
            [33.12053226282618, 0.405575775910263],
            [33.12124800541028, 0.406171614386428],
            [33.12349005483236, 0.399852527829482],
            [33.125744327630514, 0.402270418926941],
            [33.128563238297126, 0.401226291417918],
            [33.12919646433417, 0.402973049420883],
            [33.129116230406254, 0.406356238688844],
            [33.1282904406066, 0.408249913120362],
            [33.125059839231795, 0.41120033177266],
            [33.118774402647304, 0.415976512868365],
            [33.11853359306572, 0.416994766764753],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1298,
        District: "BUIKWE",
        County: "LUGAZI MUNICIPALITY",
        Subcounty: "NAJJEMBE DIVISION",
        Population: 33321,
        Key: "BUIKWENAJJEMBE DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Najjembe",
        id2_original: "Buikwe  Najjembe",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.17057911679846, 0.462997131880116],
            [33.16921227529646, 0.464327119566792],
            [33.16760424153055, 0.467837514444037],
            [33.16631771210985, 0.468751323889658],
            [33.16455224948871, 0.469229635601447],
            [33.16212727792197, 0.464571028407105],
            [33.15919032772868, 0.464403098374709],
            [33.158196733532286, 0.463402885837557],
            [33.154981105276605, 0.462347521989877],
            [33.156799010645734, 0.459887823061293],
            [33.1552159383666, 0.45984113911968],
            [33.15453742915443, 0.461109744807013],
            [33.15395583289003, 0.461402509745591],
            [33.15002438749013, 0.460490674681024],
            [33.14831091666265, 0.459453639935393],
            [33.147188792413715, 0.457250933545249],
            [33.147805899081284, 0.455443552675189],
            [33.14760651351242, 0.454132639359908],
            [33.148115348035425, 0.450790378306765],
            [33.14893928191571, 0.450643984394603],
            [33.1490714483485, 0.450241882153934],
            [33.1438219579328, 0.446638636117791],
            [33.14310579493716, 0.444923679282416],
            [33.14375037567939, 0.437760758059498],
            [33.142093804142036, 0.438069622171947],
            [33.14100576916149, 0.435685772015652],
            [33.13876579035615, 0.43594352984145],
            [33.137613759394746, 0.43375296667047],
            [33.13611637651228, 0.434350773845913],
            [33.13525452115058, 0.436502678967032],
            [33.131083312706416, 0.438302423650996],
            [33.128282605500715, 0.437357646339482],
            [33.12533291270513, 0.435633011890993],
            [33.1241708933761, 0.433728381383926],
            [33.12542225016014, 0.432858519957842],
            [33.12983661638204, 0.427418162400122],
            [33.130889437403475, 0.42607966933015],
            [33.13163426923308, 0.424234994647139],
            [33.132617421412654, 0.420320696601579],
            [33.13231938735083, 0.414966684817011],
            [33.1311275529375, 0.411682306817843],
            [33.13148502133515, 0.407663037960723],
            [33.13436015935203, 0.406013292989264],
            [33.13511985111309, 0.402024013520737],
            [33.14307496385832, 0.401888900345527],
            [33.14434121470976, 0.401184007855841],
            [33.14684390043006, 0.398634431995468],
            [33.14848258471348, 0.398154490809553],
            [33.149891423353345, 0.397166446846455],
            [33.15001692428674, 0.394150199721781],
            [33.1506260790674, 0.393209887038844],
            [33.1536964766911, 0.391210673926764],
            [33.15590112745126, 0.383981966889512],
            [33.156817325497755, 0.382513420441694],
            [33.15919334067815, 0.38065251985398],
            [33.163494698837326, 0.37948843126591],
            [33.16412885732563, 0.378511853662129],
            [33.16822488756035, 0.384889059854626],
            [33.170455693668316, 0.385586388280797],
            [33.1742246733592, 0.385451335923225],
            [33.17491370453833, 0.385096487849025],
            [33.17617177892407, 0.385693082363571],
            [33.178798109658395, 0.385841166281617],
            [33.18070042881644, 0.387333145073483],
            [33.18320772289416, 0.388375600804192],
            [33.18867501254543, 0.389785216323929],
            [33.193755003443435, 0.392424606358401],
            [33.19588535454646, 0.394884096927717],
            [33.19602560042694, 0.396381929191091],
            [33.19506611166861, 0.39917331647709],
            [33.195647150079225, 0.401197924215046],
            [33.195046273273846, 0.403229548917249],
            [33.19476836596599, 0.407376792544393],
            [33.191862082459885, 0.412508016869205],
            [33.19668907004464, 0.413263470526049],
            [33.19582551866369, 0.414864863449436],
            [33.19448547210999, 0.42032041633476],
            [33.19561112853461, 0.421831286144972],
            [33.19502505596517, 0.423704091374635],
            [33.1940110583337, 0.425758908669579],
            [33.19331409682725, 0.429377845295236],
            [33.19251008398673, 0.431051615504623],
            [33.1896078491876, 0.434081478335327],
            [33.188857467566166, 0.435375261240876],
            [33.18864295346958, 0.437374719222352],
            [33.18478370746566, 0.441744662711418],
            [33.1836848747354, 0.446141678930961],
            [33.182505651770356, 0.447815458865851],
            [33.18245209600977, 0.451217245403306],
            [33.18143378646493, 0.452511036094491],
            [33.17754750117097, 0.45410345850448],
            [33.17679683568191, 0.455451525869749],
            [33.174813518129646, 0.455722993556338],
            [33.17352732018732, 0.458636257651814],
            [33.17057911679846, 0.462997131880116],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1299,
        District: "BUIKWE",
        County: "NJERU MUNICIPALITY",
        Subcounty: "NJERU DIVISION",
        Population: 68794,
        Key: "BUIKWENJERU DIVISION",
        Dist2: "Buikwe",
        "Sub Country": "Njeru T.C",
        id2_original: "Buikwe  Njeru T.C",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.90452491201415, 0.243333858042262],
            [32.90481376170048, 0.241093660302804],
            [32.90764290148325, 0.237588255341646],
            [32.9095145054451, 0.232286312853426],
            [32.910602654511685, 0.227816903356309],
            [32.91583516676851, 0.227942561399356],
            [32.91662800366861, 0.225983440068877],
            [32.92037393169101, 0.219946044406747],
            [32.92594038726483, 0.220609526189046],
            [32.926620049913836, 0.220335834904416],
            [32.92683527817108, 0.219495716876213],
            [32.932141422636796, 0.218099575323022],
            [32.93328706927146, 0.217310441585238],
            [32.93575924910303, 0.217006938064974],
            [32.93864815559829, 0.215627306301191],
            [32.940566996571015, 0.221080919920812],
            [32.935835759514084, 0.230072087906597],
            [32.93572388512523, 0.232155515629124],
            [32.93706622507789, 0.240207688499044],
            [32.93577976752243, 0.242910507419768],
            [32.934633130944334, 0.247330746798735],
            [32.93273142264068, 0.248456913705697],
            [32.93038224732433, 0.250934491342228],
            [32.929375447893236, 0.253806237310003],
            [32.928424588351525, 0.255157644103553],
            [32.92613134663632, 0.257128440107863],
            [32.926131332263296, 0.259718647492149],
            [32.924110046517214, 0.260924643076132],
            [32.92464248517265, 0.263966111786103],
            [32.92364302857069, 0.26710068732346],
            [32.92391357508313, 0.268979636909599],
            [32.908004543453714, 0.267928969902923],
            [32.90824724219233, 0.265458459853574],
            [32.90619595361408, 0.258121740395439],
            [32.90279508196708, 0.253172722825728],
            [32.90290293370006, 0.251924190795645],
            [32.90584505010455, 0.245808212610449],
            [32.906007101690214, 0.244722533078367],
            [32.90452491201415, 0.243333858042262],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1300,
        District: "BUIKWE",
        County: "BUIKWE",
        Subcounty: "NKOKONJERU TOWN COUNCIL",
        Population: 9011,
        Key: "BUIKWENKOKONJERU TOWN COUNCIL",
        Dist2: "Buikwe",
        "Sub Country": "Nkokonjeru T.C",
        id2_original: "Buikwe  Nkokonjeru T.C",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.624147474205994, -0.138107125741257],
            [31.619751740839682, -0.139519310054201],
            [31.615555971557303, -0.140252397819853],
            [31.613982635219244, -0.13919631007113],
            [31.610165973851394, -0.134326780469935],
            [31.607390205674612, -0.133629810089193],
            [31.6042821255214, -0.139054193418861],
            [31.603182179778507, -0.141867585365174],
            [31.600670818129167, -0.144704796621545],
            [31.600069134636694, -0.145202225440101],
            [31.598945280232517, -0.145175019150757],
            [31.594659285959633, -0.144519566396571],
            [31.593678263685643, -0.145636758906404],
            [31.5933238163223, -0.14701400559455],
            [31.594196812590127, -0.151080853770664],
            [31.597796757192313, -0.160155464745963],
            [31.597691055127775, -0.161628121982185],
            [31.596622702235102, -0.163480444236346],
            [31.595823437889173, -0.164866212942449],
            [31.60092251169875, -0.170077367948535],
            [31.606991333027214, -0.175147148942628],
            [31.60967697862142, -0.176632555672918],
            [31.6189825655642, -0.179411567726474],
            [31.619268495725862, -0.179733259137961],
            [31.619290297837818, -0.185136502958205],
            [31.623484175268178, -0.187410121536691],
            [31.624251146077984, -0.1893356670093],
            [31.62512531464726, -0.190283565892257],
            [31.62972288059329, -0.189252562519271],
            [31.631592799315662, -0.189361024514664],
            [31.641806971981175, -0.194540343609006],
            [31.644801553591513, -0.192302229883078],
            [31.648849720689544, -0.188096754120622],
            [31.649777541139198, -0.186410415132608],
            [31.648177342479165, -0.186465147396502],
            [31.643686585322122, -0.184049275815782],
            [31.64158805793634, -0.182512759401172],
            [31.638919329415543, -0.17909075126413],
            [31.637578009050745, -0.170804325477386],
            [31.63816678914247, -0.166708163890595],
            [31.63896823369963, -0.164438811566446],
            [31.642422878499552, -0.160584167866341],
            [31.654914863416924, -0.154379654301056],
            [31.65578919188635, -0.153144125789919],
            [31.65566414819541, -0.151208936914851],
            [31.655171989099028, -0.150358246066388],
            [31.6525579140801, -0.149019092516696],
            [31.645036244747704, -0.146802359616078],
            [31.637643770221132, -0.14649154264753],
            [31.6294320995291, -0.146758475261809],
            [31.62733956749952, -0.145183953765906],
            [31.625044509390843, -0.142118679885683],
            [31.624751851745984, -0.140559577605551],
            [31.62530359160363, -0.138456448995141],
            [31.62454314974929, -0.138226680378147],
            [31.624147474205994, -0.138107125741257],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1303,
        District: "BUKOMANSIMBI",
        County: "BUKOMANSIMBI",
        Subcounty: "BUKOMANSIMBI  TOWN COUNCIL",
        Population: 9698,
        Key: "BUKOMANSIMBIBUKOMANSIMBI  TOWN COUNCIL",
        Dist2: "Bukomansimbi",
        "Sub Country": "Bukomansimbi TC",
        id2_original: "Bukomansimbi Bukomansimbi TC",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.695315221592768, -0.126238066040635],
            [31.689908483781515, -0.128473527984074],
            [31.68685920285525, -0.128367174908089],
            [31.681501828367168, -0.127456104919006],
            [31.68063380876602, -0.121620018530276],
            [31.681068003170395, -0.114845254394338],
            [31.67738040904762, -0.111417129154843],
            [31.674749852638175, -0.110761124871868],
            [31.672586335734852, -0.111973811383641],
            [31.671729819959243, -0.114985084073592],
            [31.67048415579914, -0.125110235711167],
            [31.66906015359727, -0.12591991228337],
            [31.667515001002947, -0.125677948949863],
            [31.663927416320764, -0.123793398442627],
            [31.66074765420112, -0.123949212661129],
            [31.65928471721822, -0.123235775915595],
            [31.656866078774218, -0.119543933861421],
            [31.654215312965846, -0.113931385704018],
            [31.65044574577676, -0.114966330881477],
            [31.647307782267305, -0.116805773190218],
            [31.645761266928684, -0.119434924437064],
            [31.64398954933822, -0.121358678540361],
            [31.641921121802646, -0.122863896703454],
            [31.638046508319214, -0.124750786484464],
            [31.628329888235026, -0.136007887506086],
            [31.62454314974929, -0.138226680378147],
            [31.62530359160363, -0.138456448995141],
            [31.624751851745984, -0.140559577605551],
            [31.625044509390843, -0.142118679885683],
            [31.62733956749952, -0.145183953765906],
            [31.6294320995291, -0.146758475261809],
            [31.637643770221132, -0.14649154264753],
            [31.645036244747704, -0.146802359616078],
            [31.6525579140801, -0.149019092516696],
            [31.655171989099028, -0.150358246066388],
            [31.65566414819541, -0.151208936914851],
            [31.65578919188635, -0.153144125789919],
            [31.654914863416924, -0.154379654301056],
            [31.642422878499552, -0.160584167866341],
            [31.63896823369963, -0.164438811566446],
            [31.63816678914247, -0.166708163890595],
            [31.637578009050745, -0.170804325477386],
            [31.638919329415543, -0.17909075126413],
            [31.64158805793634, -0.182512759401172],
            [31.643686585322122, -0.184049275815782],
            [31.648177342479165, -0.186465147396502],
            [31.649777541139198, -0.186410415132608],
            [31.648849720689544, -0.188096754120622],
            [31.644801553591513, -0.192302229883078],
            [31.641806971981175, -0.194540343609006],
            [31.631592799315662, -0.189361024514664],
            [31.62972288059329, -0.189252562519271],
            [31.62512531464726, -0.190283565892257],
            [31.624251146077984, -0.1893356670093],
            [31.623484175268178, -0.187410121536691],
            [31.619290297837818, -0.185136502958205],
            [31.619268495725862, -0.179733259137961],
            [31.6189825655642, -0.179411567726474],
            [31.60967697862142, -0.176632555672918],
            [31.606991333027214, -0.175147148942628],
            [31.60092251169875, -0.170077367948535],
            [31.595823437889173, -0.164866212942449],
            [31.596622702235102, -0.163480444236346],
            [31.590431826808974, -0.163415064217692],
            [31.586896524076327, -0.16419702740876],
            [31.58390501111101, -0.166426115642827],
            [31.58176073791771, -0.16920092149997],
            [31.574735488391095, -0.174148396768209],
            [31.565256029830145, -0.176404624522667],
            [31.562091870548695, -0.178375379571696],
            [31.559725783548796, -0.179228867462163],
            [31.552877211078986, -0.180040631468848],
            [31.55159501513126, -0.179806150776285],
            [31.552130918588734, -0.182484638682184],
            [31.552153320775286, -0.184205965446761],
            [31.55174859021391, -0.185209850916413],
            [31.552223319298843, -0.185831681259258],
            [31.55169980540577, -0.186811606898799],
            [31.552127275021945, -0.187098711426781],
            [31.5523639981673, -0.188222466378544],
            [31.552303407699707, -0.189716627860641],
            [31.553157948978328, -0.190792888079078],
            [31.552919922377484, -0.191318717600466],
            [31.553403690310812, -0.195514665993064],
            [31.554424177371885, -0.197069161825133],
            [31.55677492833324, -0.199078567920465],
            [31.56491107316777, -0.201628877504268],
            [31.578165054024925, -0.207636456497359],
            [31.581158420214656, -0.208331319452764],
            [31.58606507848365, -0.208417528403823],
            [31.589901823486304, -0.209316038940381],
            [31.593841731914495, -0.214936354909824],
            [31.60423779635706, -0.214451636368637],
            [31.607446486025466, -0.21335355240085],
            [31.612154666922322, -0.210638865788212],
            [31.61961558319209, -0.210116613057068],
            [31.621896631175588, -0.21021342294565],
            [31.624129594138566, -0.211027443806629],
            [31.62529310197605, -0.2120560778645],
            [31.627571633778455, -0.215308729123242],
            [31.63055281072811, -0.220620304994214],
            [31.63459712135863, -0.224264457871615],
            [31.641200575926735, -0.234683401471361],
            [31.642428103101242, -0.236350526705173],
            [31.644470413018233, -0.238031514420735],
            [31.656154314828502, -0.242674262502603],
            [31.65810438034221, -0.242809679621431],
            [31.662392542249894, -0.242260914510759],
            [31.663005676567295, -0.243873980496322],
            [31.66393978163064, -0.245003389685418],
            [31.668891391596418, -0.249938296157865],
            [31.6699858746841, -0.250960279031725],
            [31.673239616660634, -0.252700452540117],
            [31.678288339000204, -0.251632940928017],
            [31.679612124250653, -0.250831089956078],
            [31.689296660106145, -0.252116158914802],
            [31.69151102345118, -0.253407082908448],
            [31.692427346363484, -0.255526866883356],
            [31.691816476698897, -0.261173754996879],
            [31.690948649337198, -0.264175019973129],
            [31.689665116696325, -0.266231773428237],
            [31.688321723019865, -0.271026624082968],
            [31.68658637821524, -0.275020420219907],
            [31.686906589884806, -0.278475859245253],
            [31.689828695417983, -0.282708105969347],
            [31.69992762411403, -0.284524038847921],
            [31.706082265094835, -0.284355733468603],
            [31.708149566143042, -0.284833693287285],
            [31.708611618202667, -0.279539512117419],
            [31.71264137343066, -0.267952755234951],
            [31.71797775069725, -0.258183172859215],
            [31.719213734611827, -0.256269884790168],
            [31.720961877714306, -0.254781336370564],
            [31.721760204219095, -0.252995928017734],
            [31.72251805263718, -0.243420367718609],
            [31.720921281948307, -0.234417871579775],
            [31.719344268805795, -0.230412329259836],
            [31.71172443068079, -0.220390636223028],
            [31.70898316230251, -0.216217161080978],
            [31.70619543215938, -0.210704786413098],
            [31.705521220487526, -0.206891013300848],
            [31.704732918282975, -0.197076115642597],
            [31.70494337019785, -0.186281458164059],
            [31.704650088223907, -0.18148762334054],
            [31.704152870714132, -0.179192152597755],
            [31.697748055214902, -0.16496335006668],
            [31.69657694852843, -0.158328148497058],
            [31.692498875616295, -0.146563148022974],
            [31.69225347205032, -0.141295468972068],
            [31.695315221592768, -0.126238066040635],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1304,
        District: "BUKOMANSIMBI",
        County: "BUKOMANSIMBI",
        Subcounty: "BUTENGA",
        Population: 38455,
        Key: "BUKOMANSIMBIBUTENGA",
        Dist2: "Bukomansimbi",
        "Sub Country": "Butega",
        id2_original: "Bukomansimbi Butega",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.708149566143042, -0.284833693287285],
            [31.706082265094835, -0.284355733468603],
            [31.69992762411403, -0.284524038847921],
            [31.689828695417983, -0.282708105969347],
            [31.686906589884806, -0.278475859245253],
            [31.68658637821524, -0.275020420219907],
            [31.688321723019865, -0.271026624082968],
            [31.689665116696325, -0.266231773428237],
            [31.690948649337198, -0.264175019973129],
            [31.691816476698897, -0.261173754996879],
            [31.692427346363484, -0.255526866883356],
            [31.69151102345118, -0.253407082908448],
            [31.689296660106145, -0.252116158914802],
            [31.679612124250653, -0.250831089956078],
            [31.678288339000204, -0.251632940928017],
            [31.673239616660634, -0.252700452540117],
            [31.6699858746841, -0.250960279031725],
            [31.668891391596418, -0.249938296157865],
            [31.66393978163064, -0.245003389685418],
            [31.663005676567295, -0.243873980496322],
            [31.662392542249894, -0.242260914510759],
            [31.65810438034221, -0.242809679621431],
            [31.656154314828502, -0.242674262502603],
            [31.644470413018233, -0.238031514420735],
            [31.642428103101242, -0.236350526705173],
            [31.641200575926735, -0.234683401471361],
            [31.63459712135863, -0.224264457871615],
            [31.63055281072811, -0.220620304994214],
            [31.627571633778455, -0.215308729123242],
            [31.62529310197605, -0.2120560778645],
            [31.624129594138566, -0.211027443806629],
            [31.621896631175588, -0.21021342294565],
            [31.61961558319209, -0.210116613057068],
            [31.612154666922322, -0.210638865788212],
            [31.607446486025466, -0.21335355240085],
            [31.60423779635706, -0.214451636368637],
            [31.593841731914495, -0.214936354909824],
            [31.589901823486304, -0.209316038940381],
            [31.58606507848365, -0.208417528403823],
            [31.581158420214656, -0.208331319452764],
            [31.578165054024925, -0.207636456497359],
            [31.56491107316777, -0.201628877504268],
            [31.55677492833324, -0.199078567920465],
            [31.554424177371885, -0.197069161825133],
            [31.555031639726575, -0.200316551151898],
            [31.554816381824935, -0.202085573668845],
            [31.556074474176977, -0.203640185660179],
            [31.555217930553585, -0.205074171600031],
            [31.55506167579643, -0.207333320195738],
            [31.554633231508177, -0.208265470682654],
            [31.555842362083986, -0.21161310276092],
            [31.558988590094042, -0.214256487722022],
            [31.559248962287587, -0.215499790450766],
            [31.559890142008136, -0.215954368898385],
            [31.559937052930596, -0.216719421741374],
            [31.560601806240843, -0.217413072469589],
            [31.560101923429613, -0.218536448925346],
            [31.561039954130777, -0.219194395391926],
            [31.56191765487574, -0.221011797769067],
            [31.563889082326927, -0.22194520954581],
            [31.564102196848296, -0.222853799203534],
            [31.565100089483337, -0.222949955940502],
            [31.566416435784923, -0.225927100867326],
            [31.56719763770545, -0.229537502984352],
            [31.569512878263637, -0.231367636688567],
            [31.570081961894438, -0.232826283027892],
            [31.572005458835296, -0.234261742994324],
            [31.575648949270906, -0.239033190163982],
            [31.578380357740656, -0.240445172224943],
            [31.579187016119693, -0.241951768353886],
            [31.580517146170976, -0.242574065314182],
            [31.580801196158784, -0.243913029009605],
            [31.5820709845758, -0.245694813027038],
            [31.582779800250748, -0.250620119038338],
            [31.582404392496894, -0.25280911169957],
            [31.595954981789472, -0.284790006958123],
            [31.597248534239043, -0.295704470362121],
            [31.610995082926024, -0.298790578412458],
            [31.62162719228591, -0.302776932301634],
            [31.630240833016437, -0.30376816621266],
            [31.636451781297566, -0.303324556503191],
            [31.64027091303247, -0.302356378390634],
            [31.64548075091323, -0.298960132217166],
            [31.65106231794672, -0.296151431949767],
            [31.652436491498097, -0.296143382254039],
            [31.656472799936076, -0.297456429392644],
            [31.65921186744194, -0.296488747522759],
            [31.666643265071446, -0.295045765178761],
            [31.669848268053922, -0.296454173626959],
            [31.670897118521786, -0.297422318126009],
            [31.671373708017672, -0.30093588672828],
            [31.672160451645194, -0.301999396454791],
            [31.689172472509675, -0.301655748016185],
            [31.69115585743559, -0.305828189605505],
            [31.692296515725474, -0.306732830476843],
            [31.69709645773198, -0.30699930110419],
            [31.70450921711597, -0.306271458755217],
            [31.71228183082301, -0.304366637885028],
            [31.711272812553183, -0.294147588429741],
            [31.708778522487517, -0.289293490624982],
            [31.708149566143042, -0.284833693287285],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1305,
        District: "BUKOMANSIMBI",
        County: "BUKOMANSIMBI",
        Subcounty: "KIBINGE",
        Population: 32797,
        Key: "BUKOMANSIMBIKIBINGE",
        Dist2: "Bukomansimbi",
        "Sub Country": "Kibinge",
        id2_original: "Bukomansimbi Kibinge",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.09969118108755, 0.146124710509037],
            [32.09034655246422, 0.144025331962076],
            [32.08849136880744, 0.142035090108866],
            [32.08453711158921, 0.142242992863522],
            [32.08304442689566, 0.140723168410792],
            [32.081652329259434, 0.13777406104354],
            [32.08038290286345, 0.136073326895151],
            [32.07984408437289, 0.134824938938299],
            [32.0794081723897, 0.130464658490709],
            [32.0785599166231, 0.129180078118498],
            [32.07449336011288, 0.128944721907798],
            [32.068423776114756, 0.130961790265146],
            [32.06576851154342, 0.131441135433871],
            [32.06133524117466, 0.131350500151624],
            [32.05692644899907, 0.130364306153651],
            [32.054222442738755, 0.127976023360953],
            [32.05342785861544, 0.126239141321451],
            [32.053203995751694, 0.119888763108582],
            [32.05389221036221, 0.112362427220741],
            [32.05350085841037, 0.109639538991699],
            [32.04488376455587, 0.099209115157542],
            [32.03849573767099, 0.094893954287354],
            [32.03851007298627, 0.0942335919433],
            [32.042229933695765, 0.089584015932431],
            [32.05096072282417, 0.081026640790768],
            [32.05156334775106, 0.079832571647236],
            [32.05125395449248, 0.077932883658521],
            [32.04817760642837, 0.074314374972029],
            [32.04604360996192, 0.070949175434344],
            [32.046357300760825, 0.069474667461123],
            [32.04807049670378, 0.066860386781852],
            [32.04941189432369, 0.065847251314175],
            [32.05215391189696, 0.064698446050149],
            [32.057447619187556, 0.05960558169891],
            [32.06110647261113, 0.057687880794655],
            [32.065832337742684, 0.056521006651079],
            [32.07011817481038, 0.057172398099153],
            [32.07214443722312, 0.056738226367187],
            [32.07785993587897, 0.050478364867005],
            [32.07316817079564, 0.042047278032899],
            [32.06837140882526, 0.028677006550861],
            [32.06400169426285, 0.015912877112584],
            [32.05959431962875, -0.002116067889524],
            [32.059521869602776, -0.002676939121499],
            [32.06023594850698, -0.002785485252119],
            [32.05981137685592, -0.004549481819019],
            [32.06011940916683, -0.009108723804827],
            [32.057788468752435, -0.019339876995256],
            [32.053715392269886, -0.032483857772883],
            [32.05323911808268, -0.036735520353915],
            [32.05374030794262, -0.041168121350665],
            [32.05570190333301, -0.045962581348264],
            [32.06058322821266, -0.051833577137481],
            [32.081243700908054, -0.066380116314579],
            [32.086875656242505, -0.070740489766856],
            [32.091795197250974, -0.075028487405729],
            [32.09725668917541, -0.080628205121084],
            [32.10064277634949, -0.085368484136298],
            [32.10729078376244, -0.097246366519905],
            [32.111490766143504, -0.107423511451013],
            [32.11320968794806, -0.112996050884459],
            [32.116456291013066, -0.13200235372957],
            [32.117455180778045, -0.152781672135782],
            [32.25014788530572, -0.152868059216089],
            [32.24894182786652, -0.052695395309697],
            [32.22991200941418, -0.021710814745381],
            [32.22724280568461, -0.0163617984799],
            [32.2251632183783, -0.016490958246131],
            [32.21456850318876, -0.019865267438216],
            [32.20279975010999, -0.022380133244363],
            [32.19737422044132, -0.022886712956493],
            [32.194996604463064, -0.022669582084624],
            [32.18626824437918, -0.020136542467803],
            [32.1762535084865, -0.018851916651608],
            [32.168164564730255, -0.018345272247955],
            [32.15695869151696, -0.018752320441409],
            [32.15179409908211, -0.01833616422975],
            [32.1484070336427, -0.017006336075672],
            [32.144899779008156, -0.013270189041175],
            [32.14419103340182, -0.011831815625919],
            [32.14347301718173, -0.007127725722582],
            [32.14353367502297, -0.002206521052063],
            [32.14239950616269, 0.000154573110925],
            [32.13824302200434, 0.005898980440545],
            [32.14011738738738, 0.009354682526417],
            [32.14432242279189, 0.013914052909665],
            [32.146530939002744, 0.018428188541041],
            [32.146457627492424, 0.021983389633915],
            [32.14451321956837, 0.035308631248744],
            [32.14459543158653, 0.040799753787938],
            [32.14821739928622, 0.05269573038114],
            [32.15216002242321, 0.063669029482748],
            [32.153822055717484, 0.06727855046349],
            [32.15578145921858, 0.070888080160384],
            [32.16038937016343, 0.077193488212196],
            [32.16931937058756, 0.087931734036529],
            [32.16965835345331, 0.087836476795874],
            [32.167316805732014, 0.089288260358499],
            [32.165861546649836, 0.090706615797346],
            [32.16445611801479, 0.094163366240883],
            [32.15903333000436, 0.125125706460092],
            [32.15855985227262, 0.130846159423552],
            [32.15783140751043, 0.13428199508448],
            [32.15606136527795, 0.137103421206072],
            [32.15146261265745, 0.139867777195283],
            [32.14924769145861, 0.142280214442587],
            [32.147427840338594, 0.143063231227358],
            [32.14673349023468, 0.143005530819826],
            [32.1447350432564, 0.142482727319983],
            [32.13904074214629, 0.143198924920881],
            [32.13630225046053, 0.142761288636669],
            [32.132485623228675, 0.14349983444642],
            [32.12936612369156, 0.140210248094654],
            [32.12607675093762, 0.137574953628883],
            [32.123865288252645, 0.134676315780514],
            [32.118454287935364, 0.131524027258445],
            [32.11733392707933, 0.131254478584719],
            [32.11396098225786, 0.132307183633966],
            [32.11082389730076, 0.134151015685525],
            [32.10850163101873, 0.136529295171789],
            [32.10497976798103, 0.137086073889282],
            [32.102690789670184, 0.138349542601705],
            [32.099850362555884, 0.144812794435233],
            [32.09969118108755, 0.146124710509037],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1307,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "BUWAMA",
        Population: 50511,
        Key: "MPIGIBUWAMA",
        Dist2: "Mpigi",
        "Sub Country": "Buwama",
        id2_original: "MpigiBuwama",
        drought: "L",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.4062702640208, 0.049616430782433],
            [32.402063602665606, 0.052218641621919],
            [32.393649428352354, 0.058668581864526],
            [32.38660275310787, 0.065537147692011],
            [32.382882923839446, 0.068367930357068],
            [32.377879220570314, 0.071532886780028],
            [32.37486381691002, 0.072721798031661],
            [32.37042294769225, 0.071906884784198],
            [32.36383841793223, 0.069328870099135],
            [32.35575027637153, 0.06580231851161],
            [32.353347472531034, 0.063602945857964],
            [32.35165924885465, 0.063674106757608],
            [32.34784215090558, 0.062442163312969],
            [32.34242169312499, 0.064352311915943],
            [32.337393121793845, 0.065390296595121],
            [32.33682308684718, 0.066585020994637],
            [32.33468308514305, 0.066679945906533],
            [32.33270926817321, 0.066273058764026],
            [32.33053371654004, 0.066595002169012],
            [32.3255429723672, 0.071659806054181],
            [32.32198827321093, 0.071957416775734],
            [32.319373148061466, 0.072864712691481],
            [32.31511668680185, 0.07257659626248],
            [32.304036400760204, 0.073266137126202],
            [32.29956594732519, 0.072977941648089],
            [32.28904443854311, 0.073584008423411],
            [32.28156694296645, 0.074931870984704],
            [32.27254359590619, 0.07572958325067],
            [32.26982081216148, 0.075358308968144],
            [32.264314405371174, 0.073596810303988],
            [32.259509858600545, 0.067776820452698],
            [32.25371703476164, 0.062338270517019],
            [32.247315470265406, 0.058624596777988],
            [32.24320655100304, 0.055099266183288],
            [32.24073895976595, 0.054480234709111],
            [32.23863395103537, 0.055267127096057],
            [32.23677636169027, 0.054960030073427],
            [32.23498964043794, 0.053691709175382],
            [32.23339503019732, 0.051650220282993],
            [32.23069314306275, 0.051070327457339],
            [32.22827370421984, 0.04793690789824],
            [32.22308171676211, 0.047057948915574],
            [32.221540196056445, 0.046379120128807],
            [32.22060269266638, 0.04368866578584],
            [32.22157575676528, 0.041731392734179],
            [32.221585254652794, 0.040616876605158],
            [32.21731506713563, 0.036560248298058],
            [32.21382877019668, 0.030620019131025],
            [32.21297587103838, 0.026185727025424],
            [32.21196996902425, 0.01258942597326],
            [32.21273641970951, 0.008417981343169],
            [32.21382340905107, 0.006079812204572],
            [32.21649468249905, 0.002640105499952],
            [32.22301200300446, -0.003077266140864],
            [32.224633625585696, -0.009440844435727],
            [32.22724280568461, -0.0163617984799],
            [32.22991200941418, -0.021710814745381],
            [32.24894182786652, -0.052695395309697],
            [32.25014788530572, -0.152868059216089],
            [32.40343573344801, -0.152547129135894],
            [32.40367049287619, -0.128044308626855],
            [32.40279827005779, -0.029984499783969],
            [32.4062702640208, 0.049616430782433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1719,
        District: "WAKISO",
        County: "BUSIRO",
        Subcounty: "BUSSI",
        Population: 15827,
        Key: "WAKISOBUSSI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.49256733136108, 1.693622698528273],
            [31.489869441729574, 1.69847408436165],
            [31.483537131951834, 1.705569665346852],
            [31.479661803409414, 1.711708420741709],
            [31.471873449421967, 1.715117629112989],
            [31.470532663554778, 1.716374873683297],
            [31.469636987520932, 1.719489995408027],
            [31.47045067162384, 1.725842184618243],
            [31.473306668338658, 1.728630786956309],
            [31.47540276039167, 1.732287618874601],
            [31.474982376686476, 1.736721374801006],
            [31.47434280944185, 1.737497914062854],
            [31.473388537200364, 1.737918482458503],
            [31.471631978680353, 1.737827170305688],
            [31.470203365426112, 1.73719684381737],
            [31.467526569135774, 1.733719296013826],
            [31.466843765078185, 1.731262019233013],
            [31.46459642278244, 1.73060106569399],
            [31.460698729782713, 1.727392172164989],
            [31.45974616074699, 1.727181672210482],
            [31.45772031335594, 1.728767890984123],
            [31.4529398288585, 1.731130795767221],
            [31.446209307593428, 1.733372227329658],
            [31.44272332506482, 1.736485144683991],
            [31.441070164430585, 1.737412519963785],
            [31.439551747495738, 1.737411256615227],
            [31.430469124203142, 1.739710554957386],
            [31.426254033955622, 1.742403364161866],
            [31.42568825253182, 1.742522722893808],
            [31.424319302683806, 1.741802544204116],
            [31.42148999491608, 1.742878693469457],
            [31.42065558308635, 1.743806729152886],
            [31.41700714742511, 1.745331563508739],
            [31.415845155045528, 1.746349192047224],
            [31.415050012170113, 1.748175856091756],
            [31.412818716480288, 1.749412955065841],
            [31.406627480829762, 1.749589486913092],
            [31.404288345085014, 1.748697352004626],
            [31.401320541354984, 1.748867089533787],
            [31.395616590542122, 1.745244239282687],
            [31.39464797939207, 1.747025742840181],
            [31.393731589106117, 1.747671007052202],
            [31.39124910290328, 1.748878086974282],
            [31.38934824530421, 1.749141863905823],
            [31.387756888761544, 1.750408067545439],
            [31.386473559139915, 1.750146266163664],
            [31.38516696405075, 1.750743876169625],
            [31.383193667205475, 1.748978571504713],
            [31.382231450263593, 1.749277560337376],
            [31.381470794610244, 1.74882446726799],
            [31.37985581057899, 1.750329388499575],
            [31.38021304810959, 1.751737610571101],
            [31.37864513220595, 1.752454737097737],
            [31.37831292084086, 1.753266578676283],
            [31.37731525368292, 1.753887857980034],
            [31.37018798698107, 1.754046362380604],
            [31.37034083532667, 1.753544876639587],
            [31.36900917544443, 1.751753075922585],
            [31.369816592001584, 1.750822294808255],
            [31.369863615213447, 1.750035541188705],
            [31.367677169710806, 1.749391530355378],
            [31.36779552813938, 1.748604841682157],
            [31.369743804209037, 1.748606547686377],
            [31.369859462301864, 1.747042107026154],
            [31.370258521798867, 1.746427490551146],
            [31.372289778844568, 1.744973243596162],
            [31.374106602642097, 1.744992914760888],
            [31.37405676950001, 1.743500673879365],
            [31.376205763340128, 1.74393663811149],
            [31.377468671560408, 1.743386074076549],
            [31.37832318049971, 1.741569044340209],
            [31.378231033114474, 1.739633626371456],
            [31.37881236976579, 1.738024363067221],
            [31.37782425169933, 1.736477093190049],
            [31.377700137764716, 1.731837553049576],
            [31.375789926906904, 1.731673117912637],
            [31.375020959142248, 1.732983779555531],
            [31.37366613440379, 1.731336669276166],
            [31.37426404407372, 1.730378563790595],
            [31.37419675936062, 1.729248052659289],
            [31.374538464121674, 1.728696685208991],
            [31.375153060896345, 1.728254078340305],
            [31.37668815325781, 1.728300619535065],
            [31.378395177774774, 1.726963630709586],
            [31.378661329728846, 1.725091826276924],
            [31.378167259915838, 1.724159906941225],
            [31.37745098912238, 1.723951288645559],
            [31.376974164267878, 1.723218343606361],
            [31.376069681151023, 1.723389396166178],
            [31.37555720395952, 1.724293318193771],
            [31.37516482613163, 1.72432915551827],
            [31.37415961312531, 1.722736612658943],
            [31.3748344949404, 1.721742395195123],
            [31.373249052905557, 1.720474926061935],
            [31.374018415030637, 1.718350335275777],
            [31.37588700963629, 1.717565143093263],
            [31.375034328768614, 1.717256928596266],
            [31.37397778602698, 1.715917566921363],
            [31.37553152471879, 1.714490004997415],
            [31.37446749541758, 1.711703658203535],
            [31.375918435399882, 1.710610618566206],
            [31.376133738217277, 1.708404154731065],
            [31.376731065778955, 1.707780654343437],
            [31.379528196791508, 1.708587917717396],
            [31.381507799810077, 1.70770332130294],
            [31.383906278262454, 1.705652443443483],
            [31.389973085568055, 1.70272741287231],
            [31.390400764491684, 1.701443568387462],
            [31.39040258897002, 1.699245951129805],
            [31.3896813028823, 1.696251444935358],
            [31.39260724422179, 1.693601605422234],
            [31.396359493688827, 1.692346468673624],
            [31.400184686356916, 1.692918867851787],
            [31.40533562439945, 1.692383887837234],
            [31.406912615982392, 1.693493676886079],
            [31.407568109458694, 1.692865085843872],
            [31.408865647733187, 1.689840277398899],
            [31.410683287200975, 1.687924384588588],
            [31.410953186028074, 1.685527892694312],
            [31.409808559879576, 1.683579602005435],
            [31.406773700506843, 1.681300202734366],
            [31.405434125568647, 1.681119348243017],
            [31.40424384793572, 1.680399349423604],
            [31.403232838999227, 1.678900562637181],
            [31.40269811952129, 1.677462086885799],
            [31.402967989602313, 1.675095516484422],
            [31.40535013668286, 1.674558214016332],
            [31.40905585251985, 1.675579857927152],
            [31.41185428878452, 1.675701990930279],
            [31.415276764914122, 1.67726266553239],
            [31.42106783524159, 1.676668195107299],
            [31.426662603018197, 1.679578800213738],
            [31.43093385234403, 1.680840553055713],
            [31.442588748452085, 1.681898559779937],
            [31.44336261652664, 1.682168815519445],
            [31.446990629888198, 1.687444646282747],
            [31.451164783908215, 1.689987704941453],
            [31.45355171361931, 1.692123639977085],
            [31.455307600199525, 1.692993883945041],
            [31.46285326622812, 1.695097125914662],
            [31.467378838492344, 1.69492098410487],
            [31.46853973941885, 1.695221515069833],
            [31.47161911390715, 1.697890415225363],
            [31.47483509250577, 1.697233852672407],
            [31.478793680502, 1.698764962129411],
            [31.48199395924438, 1.699156976210162],
            [31.483274373832934, 1.698918320654847],
            [31.484287196468003, 1.698230036708025],
            [31.487475771958856, 1.694547431348778],
            [31.49256733136108, 1.693622698528273],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1775,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "KIHUNGYA",
        Population: 12396,
        Key: "BULIISAKIHUNGYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.586212399495306, 1.767433078876374],
            [31.587201020618302, 1.768712992514412],
            [31.587770934292422, 1.770983620590926],
            [31.58738960843746, 1.773278393606741],
            [31.58786445879497, 1.775405644659745],
            [31.587174501452786, 1.776218529438725],
            [31.58389223527106, 1.777581857518467],
            [31.58322600513048, 1.778562030327924],
            [31.58595925334991, 1.782816058091888],
            [31.589739741357906, 1.784727303365858],
            [31.58995336702066, 1.785802878302655],
            [31.589548542136196, 1.787308879330601],
            [31.588144946962647, 1.788671708059168],
            [31.584672371789654, 1.790106778950542],
            [31.58417252580937, 1.791278136181703],
            [31.585051412330504, 1.794002842158933],
            [31.582957822983868, 1.796274154651138],
            [31.5835043858505, 1.797325759468615],
            [31.586500182881416, 1.799022106284305],
            [31.586927917500564, 1.799882497792872],
            [31.586379069319843, 1.804878355335229],
            [31.586117262516805, 1.805452099315258],
            [31.585094526972597, 1.805810905821772],
            [31.584571099317778, 1.806456397309544],
            [31.586376130032242, 1.81262291048043],
            [31.586446928954715, 1.814057074516481],
            [31.585328570443444, 1.815706642245108],
            [31.582522578448923, 1.815133664695406],
            [31.579906130979364, 1.816401150884078],
            [31.579739007505587, 1.818050491109282],
            [31.58111579156116, 1.824623449257963],
            [31.5795214202724, 1.827205337563965],
            [31.576450354302153, 1.835452534292948],
            [31.57711566636453, 1.836886567891874],
            [31.579992933388624, 1.837674679425702],
            [31.57987331192877, 1.839467415868378],
            [31.581132588260356, 1.842383275249657],
            [31.58041741610648, 1.84670986264566],
            [31.581772318100057, 1.848358851733521],
            [31.582508701274428, 1.850486026279401],
            [31.581389503736666, 1.854119516108698],
            [31.582839840949383, 1.855027521753901],
            [31.582862013167244, 1.859019271071537],
            [31.583693739932617, 1.860596677246134],
            [31.582861111258687, 1.861266160844751],
            [31.582100363977172, 1.860549255941735],
            [31.58026896321754, 1.861027723798997],
            [31.57653432162841, 1.863155888686689],
            [31.576106308531504, 1.86301255115907],
            [31.576344517490327, 1.862032495192311],
            [31.57520319085387, 1.861530795966849],
            [31.574323677308662, 1.860503171522373],
            [31.573729075235583, 1.860622808927875],
            [31.57344322861722, 1.861770216978388],
            [31.571207111669267, 1.863252660612785],
            [31.570565153109367, 1.862894261574333],
            [31.56944847714259, 1.860265212025316],
            [31.56614229690966, 1.8614849503989],
            [31.565689731059415, 1.863182154108723],
            [31.563739343948843, 1.863827930157165],
            [31.563049029975485, 1.865381762849804],
            [31.560003719602758, 1.868298514193549],
            [31.55912258459846, 1.871167023542625],
            [31.557743028341907, 1.87164535563128],
            [31.558170339854556, 1.873461834108589],
            [31.560262334691608, 1.87539755564581],
            [31.560095239065614, 1.876855643919099],
            [31.559571779071437, 1.877453314427517],
            [31.559143768669475, 1.877309989739667],
            [31.558193259470734, 1.875493594264509],
            [31.55638593266239, 1.875231030754022],
            [31.55602905894948, 1.875589624797461],
            [31.556171432040525, 1.876330593583407],
            [31.55464858730966, 1.878195303259426],
            [31.55441012053434, 1.879701199645964],
            [31.55255519110077, 1.879558155266105],
            [31.5513183483968, 1.879964753691204],
            [31.55096102822117, 1.881351158914341],
            [31.551079792688263, 1.881685781412863],
            [31.551864559123835, 1.88178123789149],
            [31.552244659676724, 1.882713348551123],
            [31.55007937938053, 1.885319171700991],
            [31.550102984411225, 1.885725507514077],
            [31.55053012704062, 1.887900550284972],
            [31.5515527476005, 1.887876459772667],
            [31.552646313508244, 1.888832331756472],
            [31.55274106960104, 1.889692789372821],
            [31.55331169114764, 1.890051240380225],
            [31.553358941633267, 1.890768301088228],
            [31.552526385722874, 1.891198711728641],
            [31.55288204940512, 1.893636702565132],
            [31.55188284792471, 1.894449580294576],
            [31.549788636943852, 1.8976051164425],
            [31.548956025337937, 1.898131127309062],
            [31.54838470130881, 1.89937416553254],
            [31.54721968250507, 1.89868121221725],
            [31.546292157601158, 1.898729188237796],
            [31.54557908840336, 1.897821040980395],
            [31.542582596076425, 1.897702075001098],
            [31.540465732279056, 1.898276120229721],
            [31.539632987722477, 1.899112871556872],
            [31.539251444475216, 1.90140756176342],
            [31.53875176378497, 1.90198130319514],
            [31.539677846892832, 1.902792000685402],
            [31.539665353123866, 1.903658638235113],
            [31.53922371617734, 1.903945268882623],
            [31.53006060024202, 1.891338074963478],
            [31.527635940390674, 1.888900480430377],
            [31.520598702846566, 1.884073485582656],
            [31.514679343215082, 1.879031177198727],
            [31.51118532256131, 1.87489672485257],
            [31.506264118771217, 1.871455692247982],
            [31.49073721339571, 1.858266618540335],
            [31.486671809423978, 1.85554762414502],
            [31.478149429441473, 1.850981238106461],
            [31.47560535384444, 1.848834245963418],
            [31.460737316915733, 1.843245243331161],
            [31.45863318673752, 1.841563503069768],
            [31.453594058405184, 1.839704521604324],
            [31.443312610009716, 1.833778436416042],
            [31.440127440930418, 1.832443509253571],
            [31.437061527696628, 1.831848561105237],
            [31.435563914845428, 1.831013936237074],
            [31.432627739898273, 1.828688146706982],
            [31.42827596020048, 1.823414966359522],
            [31.420680598472057, 1.818418289012677],
            [31.410469714538785, 1.810606271387167],
            [31.39809486184961, 1.799883173890551],
            [31.39643014528761, 1.797568584806768],
            [31.394789685933205, 1.796137243249456],
            [31.392293416878967, 1.794109623732151],
            [31.389928525536703, 1.793287452057196],
            [31.38583873859325, 1.788706490938453],
            [31.380870331029943, 1.785200286477161],
            [31.37798138770377, 1.782038995380243],
            [31.362694611885154, 1.771730004501699],
            [31.365770260161657, 1.77246907214087],
            [31.368057319671074, 1.77081612799478],
            [31.368175382553897, 1.769414477604868],
            [31.3686978454181, 1.768691453096005],
            [31.368578197008762, 1.767090629782045],
            [31.36624899034286, 1.766211341246771],
            [31.367150821633018, 1.764276812522199],
            [31.365698040104405, 1.758713724582163],
            [31.3671226441775, 1.756327474186598],
            [31.36769263151348, 1.755848666255607],
            [31.368751839556573, 1.756048557090937],
            [31.368868414829308, 1.755053865129741],
            [31.37018798698107, 1.754046362380604],
            [31.37731525368292, 1.753887857980034],
            [31.37831292084086, 1.753266578676283],
            [31.37864513220595, 1.752454737097737],
            [31.38021304810959, 1.751737610571101],
            [31.37985581057899, 1.750329388499575],
            [31.381470794610244, 1.74882446726799],
            [31.382231450263593, 1.749277560337376],
            [31.383193667205475, 1.748978571504713],
            [31.38516696405075, 1.750743876169625],
            [31.386473559139915, 1.750146266163664],
            [31.387756888761544, 1.750408067545439],
            [31.38934824530421, 1.749141863905823],
            [31.39124910290328, 1.748878086974282],
            [31.393731589106117, 1.747671007052202],
            [31.39464797939207, 1.747025742840181],
            [31.395616590542122, 1.745244239282687],
            [31.401320541354984, 1.748867089533787],
            [31.404288345085014, 1.748697352004626],
            [31.406627480829762, 1.749589486913092],
            [31.412818716480288, 1.749412955065841],
            [31.415050012170113, 1.748175856091756],
            [31.415845155045528, 1.746349192047224],
            [31.41700714742511, 1.745331563508739],
            [31.42065558308635, 1.743806729152886],
            [31.42148999491608, 1.742878693469457],
            [31.424319302683806, 1.741802544204116],
            [31.42568825253182, 1.742522722893808],
            [31.426254033955622, 1.742403364161866],
            [31.430469124203142, 1.739710554957386],
            [31.439551747495738, 1.737411256615227],
            [31.441070164430585, 1.737412519963785],
            [31.44272332506482, 1.736485144683991],
            [31.446209307593428, 1.733372227329658],
            [31.4529398288585, 1.731130795767221],
            [31.45772031335594, 1.728767890984123],
            [31.45974616074699, 1.727181672210482],
            [31.460698729782713, 1.727392172164989],
            [31.46459642278244, 1.73060106569399],
            [31.466843765078185, 1.731262019233013],
            [31.467526569135774, 1.733719296013826],
            [31.470203365426112, 1.73719684381737],
            [31.471631978680353, 1.737827170305688],
            [31.473388537200364, 1.737918482458503],
            [31.47434280944185, 1.737497914062854],
            [31.474982376686476, 1.736721374801006],
            [31.47540276039167, 1.732287618874601],
            [31.473306668338658, 1.728630786956309],
            [31.47045067162384, 1.725842184618243],
            [31.469636987520932, 1.719489995408027],
            [31.470532663554778, 1.716374873683297],
            [31.471873449421967, 1.715117629112989],
            [31.479661803409414, 1.711708420741709],
            [31.483537131951834, 1.705569665346852],
            [31.489869441729574, 1.69847408436165],
            [31.49256733136108, 1.693622698528273],
            [31.497971280801714, 1.693866573463877],
            [31.500769204128343, 1.695336819939487],
            [31.502523394689305, 1.697974713831613],
            [31.503102521484955, 1.699862681269875],
            [31.502980306588878, 1.703907247061886],
            [31.503693116173586, 1.70615487029048],
            [31.504689465502945, 1.707533835102623],
            [31.505850225393985, 1.708044076920184],
            [31.50567042848816, 1.709541943242007],
            [31.50632428253909, 1.711040500687396],
            [31.506174488465458, 1.712238789093999],
            [31.507751363267413, 1.713678143198825],
            [31.509641583016894, 1.714188958944446],
            [31.514552211839455, 1.716799394873571],
            [31.515206027262778, 1.718357858874714],
            [31.516020317728486, 1.724140905399706],
            [31.515155778200736, 1.72554837659641],
            [31.514886476753276, 1.727285888699588],
            [31.513009278982157, 1.72914197222456],
            [31.51211485160661, 1.730699215745833],
            [31.51169593035869, 1.733365353872821],
            [31.519585915245784, 1.733491455538464],
            [31.522743727031443, 1.731216925534173],
            [31.523861665131175, 1.729390192099971],
            [31.52490410522118, 1.728941593664121],
            [31.52737533912674, 1.728943527754334],
            [31.52963614896523, 1.731551880975716],
            [31.536525561542785, 1.735841679630563],
            [31.538549781186592, 1.736412517818853],
            [31.54253952635012, 1.736415621868797],
            [31.54462264942541, 1.737825409519647],
            [31.54838640092135, 1.741363729541988],
            [31.551035160791674, 1.742893809610913],
            [31.554369009135335, 1.744064882356142],
            [31.556213938523154, 1.745504446680309],
            [31.556682315620716, 1.746833254209837],
            [31.55613245863196, 1.756618057566061],
            [31.56545414248629, 1.757284954098669],
            [31.567713046998044, 1.757953630913894],
            [31.569329775557595, 1.75893321968512],
            [31.574085790845, 1.759194895927852],
            [31.58797634486192, 1.757331812429958],
            [31.588702193492963, 1.760418233716205],
            [31.58846408245049, 1.761278833594658],
            [31.587678933332587, 1.762330776218436],
            [31.585276536428943, 1.763813402746606],
            [31.584634163745676, 1.764626270160763],
            [31.58499011758375, 1.766729632947033],
            [31.586212399495306, 1.767433078876374],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1778,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "BIISO",
        Population: 16378,
        Key: "BULIISABIISO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.01342990430396, 0.198242559419871],
            [31.008429299324256, 0.197726560319817],
            [31.000791688031377, 0.193837646802142],
            [30.9993389972326, 0.193511967151498],
            [30.993660665473296, 0.192688480817453],
            [30.98197629923399, 0.192958322420918],
            [30.977089611412108, 0.193536396696278],
            [30.973267681425114, 0.19480176172925],
            [30.97146569420282, 0.195949828937028],
            [30.95527676190392, 0.19966389673447],
            [30.952383210220344, 0.199383241385257],
            [30.94834302465362, 0.198071708959468],
            [30.946705122802815, 0.197953962088463],
            [30.93654961551525, 0.199878502053087],
            [30.93111729009144, 0.199633686574888],
            [30.927841454050494, 0.199958755255411],
            [30.924456083732036, 0.2009528697804],
            [30.92139844667697, 0.202543752031566],
            [30.917030496405754, 0.205897513585343],
            [30.91400013669432, 0.207135768482259],
            [30.9120347135825, 0.207298248400014],
            [30.90870424559924, 0.207189304129973],
            [30.905046396492153, 0.206085776794285],
            [30.894946951264814, 0.19976461702889],
            [30.89401179247764, 0.200080937067601],
            [30.89146934642454, 0.204827224511681],
            [30.889159133737003, 0.204266361344922],
            [30.8876303978545, 0.20465492604533],
            [30.885446493685812, 0.203994628984272],
            [30.881624601428033, 0.206525631326824],
            [30.879822776800843, 0.207131140392157],
            [30.87856724554566, 0.206579461622095],
            [30.876765490088747, 0.206687708808213],
            [30.874745484441952, 0.206135926717189],
            [30.873954137846905, 0.205611437046282],
            [30.873376008181204, 0.203531910605882],
            [30.870120771408036, 0.201795588516507],
            [30.86814819950318, 0.201270944195059],
            [30.85937880527544, 0.19933499945156],
            [30.849774082936335, 0.199212902074944],
            [30.842754921292386, 0.199737938125393],
            [30.84181134259605, 0.192356720482878],
            [30.84128140395207, 0.191378325877047],
            [30.84035385659027, 0.190889044111995],
            [30.840575195188062, 0.187064708577909],
            [30.839692265349836, 0.182928952145806],
            [30.840398237856895, 0.180404083543219],
            [30.85125163730554, 0.175579170993753],
            [30.852048350436082, 0.173503918704918],
            [30.85195505949551, 0.169872054402228],
            [30.850831029919835, 0.166240075331432],
            [30.850878195963833, 0.163362899261248],
            [30.852565122472935, 0.160768902084873],
            [30.856173000097424, 0.157750598645137],
            [30.863388514597833, 0.154166645654731],
            [30.866246519047298, 0.153695264495398],
            [30.870680107419698, 0.154516623528054],
            [30.87255115262943, 0.15888698649744],
            [30.875450687092805, 0.159601537850545],
            [30.878636583807516, 0.162015850380365],
            [30.880822542423232, 0.161853344896181],
            [30.880976154336835, 0.160904043205429],
            [30.883897277113125, 0.159276949049083],
            [30.88422933756127, 0.158734516029985],
            [30.8837050079979, 0.156817739466748],
            [30.88565252858443, 0.155624509913596],
            [30.887077956412625, 0.15533533879678],
            [30.886967994537024, 0.152026264417786],
            [30.88575593814834, 0.151492714621312],
            [30.886420311471248, 0.15063387160093],
            [30.88758444363782, 0.150489328679222],
            [30.88775009746777, 0.149747970484461],
            [30.887322165219263, 0.149205458171031],
            [30.88637163086767, 0.149078788958586],
            [30.885562898278636, 0.14817459454817],
            [30.88607240833476, 0.146728060202671],
            [30.885952944080056, 0.145769686680753],
            [30.884788280110804, 0.145624915555962],
            [30.883290570241584, 0.144648328702787],
            [30.884358050870116, 0.142641297443068],
            [30.8842860167641, 0.141655806388548],
            [30.883762934960696, 0.1412217830882],
            [30.883168800011536, 0.1413211795756],
            [30.881887226596298, 0.142921339176845],
            [30.881126455060297, 0.142324553351604],
            [30.8799446781849, 0.135977579332087],
            [30.879991341172328, 0.135118677339703],
            [30.881214463008668, 0.134287003178444],
            [30.8808803553, 0.132686695673928],
            [30.88123497334323, 0.130779050056864],
            [30.88031854532803, 0.128943623270963],
            [30.879912655939968, 0.126529610861881],
            [30.881657561514135, 0.124820985165855],
            [30.88327119088594, 0.122307682712167],
            [30.885848928153308, 0.122136110273134],
            [30.886252261834393, 0.121557509401969],
            [30.885775068670654, 0.119215813238013],
            [30.886297399482483, 0.118573932416897],
            [30.88610583464645, 0.117064045483057],
            [30.887183008096898, 0.112579714896287],
            [30.887087104855503, 0.111530932909506],
            [30.887514016617843, 0.110834795570549],
            [30.887442226853604, 0.110066291866203],
            [30.886586029979895, 0.109351978014582],
            [30.887380912343882, 0.108022985824977],
            [30.88723755380095, 0.107281600343106],
            [30.88987167382711, 0.103502577593052],
            [30.891616565028258, 0.101775831538092],
            [30.893229899752647, 0.099027417688476],
            [30.893203164991498, 0.095790668430423],
            [30.89246463753852, 0.093638819091369],
            [30.89630923920666, 0.088503650275834],
            [30.896128653580043, 0.085881689288426],
            [30.896791680328306, 0.08337731028096],
            [30.896813415964942, 0.08105371957962],
            [30.900550262019784, 0.075014375783022],
            [30.90272256714155, 0.073115823050691],
            [30.903433823539107, 0.071126782110968],
            [30.90492919689027, 0.06938188952668],
            [30.90170075147217, 0.059834187543182],
            [30.902626371947665, 0.058685986714029],
            [30.902124626928853, 0.057311697984141],
            [30.903686719952837, 0.049210794870105],
            [30.904659766085427, 0.047972174845603],
            [30.90522786965426, 0.045702836261898],
            [30.905060360803237, 0.044455136905607],
            [30.90625823369189, 0.042176772841077],
            [30.90692064778913, 0.039111800914948],
            [30.906619893628662, 0.035151716259549],
            [30.906903666036996, 0.03353333509064],
            [30.907757162574967, 0.031571397758867],
            [30.913389921003283, 0.024763415593542],
            [30.91523968332732, 0.024727282661261],
            [30.918994770572322, 0.025468738550901],
            [30.92200026581503, 0.02512522102309],
            [30.924281672226343, 0.025532123671053],
            [30.929009549584126, 0.024646151323902],
            [30.93106256023278, 0.022385833952709],
            [30.93329268541775, 0.01846189153213],
            [30.9347170155047, 0.017196109662574],
            [30.940998649520605, 0.013769472662171],
            [30.941972804174277, 0.013597694123504],
            [30.94320880425854, 0.013932241997024],
            [30.94406507209915, 0.014818316809163],
            [30.948314361209537, 0.023245051792593],
            [30.948813369061657, 0.023154644451486],
            [30.950806630964095, 0.020279471607162],
            [30.952754120109596, 0.019185474572972],
            [30.953324413771085, 0.019230689473604],
            [30.963512463428142, 0.025650363510214],
            [30.96552905098527, 0.022214588123092],
            [30.966004206769966, 0.022214596207899],
            [30.967751852205748, 0.02337195049407],
            [30.969890477690864, 0.023272527661618],
            [30.976318980865827, 0.024294339649694],
            [30.97974355456162, 0.02723294603892],
            [30.98349878823204, 0.028236645266361],
            [30.987595656594884, 0.025931081618179],
            [30.99646969646843, 0.024439344791421],
            [31.000770600080084, 0.024421332673291],
            [31.002910592801047, 0.028860900649499],
            [31.008451078079982, 0.03538922179251],
            [31.018291703402596, 0.040480041662086],
            [31.020140143406532, 0.041990089500659],
            [31.021799401804905, 0.042520827500921],
            [31.025345900240946, 0.042508812537283],
            [31.036443155458297, 0.047059957547873],
            [31.04152748162586, 0.050342424664324],
            [31.042355943015185, 0.051438447930346],
            [31.044519694378785, 0.052667898788765],
            [31.046512036406394, 0.054587525844777],
            [31.052345549436094, 0.057163580240733],
            [31.054567211592815, 0.061350152127891],
            [31.052109811742586, 0.063918010884136],
            [31.052578997323927, 0.066458857189618],
            [31.05321920147407, 0.06676631437097],
            [31.05335949766022, 0.067751908390682],
            [31.05290531035088, 0.069135330009106],
            [31.05301859778967, 0.071558615408038],
            [31.051944059996277, 0.074189813780997],
            [31.05246266818957, 0.075880707596969],
            [31.052030328806264, 0.078041745895365],
            [31.049876024126174, 0.08082660054959],
            [31.049461397723647, 0.082264270060719],
            [31.04679977936833, 0.082137545752296],
            [31.04629004203845, 0.082842800672843],
            [31.045442679197226, 0.083059766044454],
            [31.0455854870729, 0.084135776827904],
            [31.044541881867996, 0.085374483977451],
            [31.043163233808176, 0.085085065079404],
            [31.042775325098855, 0.085446726412327],
            [31.043739632420344, 0.087029133942265],
            [31.044634403850683, 0.087273318211899],
            [31.044509694333065, 0.088955131318173],
            [31.045137527783435, 0.089533856763211],
            [31.044409415397872, 0.090383768873902],
            [31.04440682555491, 0.091550192070973],
            [31.04542055369178, 0.092671464166343],
            [31.045929429537317, 0.092355021341941],
            [31.047816663286778, 0.09258118000504],
            [31.049580348142005, 0.093774835521575],
            [31.04977200191122, 0.094579591080023],
            [31.048487010406323, 0.095745942273216],
            [31.048217479888464, 0.097192656326401],
            [31.04702846259187, 0.098630273990489],
            [31.047778419310216, 0.098657444394297],
            [31.04823672090353, 0.099290417060368],
            [31.047461190945715, 0.099778640799096],
            [31.047991610188376, 0.10065575360248],
            [31.047941317108876, 0.101505704963938],
            [31.04888436130764, 0.101804151781061],
            [31.049994915255724, 0.102970649145872],
            [31.05032965178509, 0.104661538941216],
            [31.051465778972688, 0.105303599729585],
            [31.051438184523782, 0.10668703613743],
            [31.050492827163193, 0.107419383699538],
            [31.051194217363996, 0.107636439646131],
            [31.053898915327075, 0.110068940993089],
            [31.054040556291188, 0.111551854632827],
            [31.054811753674368, 0.112962475517686],
            [31.054880114569187, 0.114770900089223],
            [31.056667635322132, 0.116163510530427],
            [31.056787440936624, 0.11676934119125],
            [31.0563983751972, 0.1174836395885],
            [31.053081882304795, 0.118062095917233],
            [31.05114202165271, 0.119743782525269],
            [31.047628107806954, 0.121931705382092],
            [31.04975322802011, 0.123830698202753],
            [31.049991680422377, 0.12543116346925],
            [31.05143983832224, 0.127013639020178],
            [31.051117647664103, 0.130332058515031],
            [31.048972758226522, 0.137041104354824],
            [31.04874972091451, 0.139220223153382],
            [31.049496756311527, 0.140630849725617],
            [31.04971048797551, 0.142312693829809],
            [31.047256457705927, 0.146652670237848],
            [31.042932924633963, 0.150251012743282],
            [31.039368529062514, 0.151697408517048],
            [31.033860331929823, 0.151805400008474],
            [31.032884041980715, 0.153044061010983],
            [31.03199998026521, 0.155476268675088],
            [31.03107170886131, 0.156452713110037],
            [31.028218804147706, 0.158188494240767],
            [31.018870595738008, 0.16607212431719],
            [31.017797678505378, 0.168025063325829],
            [31.016371227496016, 0.168911021148337],
            [31.0157926684356, 0.172581967560561],
            [31.0159057977709, 0.175041373710151],
            [31.015115698037487, 0.177808105193318],
            [31.014673798782948, 0.184046955479384],
            [31.013212557819294, 0.189670834693381],
            [31.01342990430396, 0.198242559419871],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1957,
        District: "KIRUHURA",
        County: "KAZO",
        Subcounty: "BURUNGA",
        Population: 23969,
        Key: "KIRUHURABURUNGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.03851007298627, 0.0942335919433],
            [32.03505543177963, 0.094133987777504],
            [32.02979015706607, 0.095879717401662],
            [32.029040174296604, 0.094839397878314],
            [32.025861880922456, 0.093437180816455],
            [32.021393641834656, 0.090596597465596],
            [32.01895893253021, 0.087900814060868],
            [32.00920391845081, 0.084182637394141],
            [32.00577575508712, 0.081830604310381],
            [32.00329159083134, 0.080817382047314],
            [31.99501241533895, 0.079161768829229],
            [31.978714785992366, 0.072630213963788],
            [31.96552072096806, 0.070359390576267],
            [31.962562329785584, 0.069518059650666],
            [31.960068930848706, 0.068486767502943],
            [31.958192220862777, 0.066953039855408],
            [31.953610004430015, 0.063710421130535],
            [31.938048241726502, 0.056799104265803],
            [31.934245315599338, 0.053497315629566],
            [31.927813714134956, 0.045898777627388],
            [31.92240665023526, 0.041511505871907],
            [31.908138042925966, 0.033388260790262],
            [31.905014032947822, 0.032185145530587],
            [31.901183004823626, 0.031597127301323],
            [31.895977823809325, 0.031705616821629],
            [31.889520049030814, 0.033026203858948],
            [31.887786212497577, 0.032781952871792],
            [31.8869424590872, 0.032103512040334],
            [31.88722245138481, 0.027445021185374],
            [31.88653258567081, 0.026133393877372],
            [31.878437948392296, 0.017883731352775],
            [31.873335617291506, 0.00967933815721],
            [31.871539466423616, 0.005807818507674],
            [31.875234848041604, -0.002848801208196],
            [31.876963636042944, -0.005643893037119],
            [31.881991318940266, -0.010799893929735],
            [31.883456450507406, -0.013043216215898],
            [31.885125131334803, -0.014436251653205],
            [31.88642909256357, -0.014608118226133],
            [31.888227503592688, -0.016399157614396],
            [31.88910382452541, -0.016806212100338],
            [31.89128861622959, -0.015521749754273],
            [31.892545123953454, -0.015576025063405],
            [31.89460720039995, -0.016145906376357],
            [31.8958145639896, -0.016987165130025],
            [31.8989321078943, -0.017385190648224],
            [31.900281845473334, -0.018271672382154],
            [31.904788724694786, -0.017728952535122],
            [31.908063533961347, -0.016706810823431],
            [31.909260241735094, -0.017077680272362],
            [31.910612796430826, -0.016743003046382],
            [31.911322892205032, -0.017385251733658],
            [31.913053653805065, -0.017511901606433],
            [31.914761959319623, -0.01707770632351],
            [31.915370414312708, -0.017439552195133],
            [31.917978364618026, -0.018027531859746],
            [31.918806682276884, -0.018769284226355],
            [31.91954319301201, -0.018099901033784],
            [31.9210594297357, -0.01876929590445],
            [31.922531603196358, -0.017891872783805],
            [31.924404171948797, -0.018344159235375],
            [31.92535407837802, -0.017729054943053],
            [31.92597039632477, -0.017801428608761],
            [31.927131171487122, -0.018425593308327],
            [31.927985056097302, -0.018326086929427],
            [31.92888440624064, -0.019113082043189],
            [31.98630656883272, -0.017846941750401],
            [31.981130752846738, -0.009787013818845],
            [31.979303929003493, -0.00482985679806],
            [31.979308134017334, -0.002930209234088],
            [31.980249626825575, -0.002930209234088],
            [31.9807017039923, 0.002578744277914],
            [31.98304603649096, 0.002696341833319],
            [31.98424642556072, 0.003691396688839],
            [31.985055385423518, 0.005030191885448],
            [31.98773919216637, 0.005410130740017],
            [31.993312086864123, 0.009236580119239],
            [31.998222306054902, 0.015288340502412],
            [32.000601160809914, 0.018942930357983],
            [32.000793800929344, 0.018020237540009],
            [32.004781319169275, 0.022289968447812],
            [32.008596739963735, 0.024243925302144],
            [32.009427059967386, 0.026256083969426],
            [32.00271181724868, 0.028613083341526],
            [32.00168972489816, 0.02860402293473],
            [32.00080998587582, 0.029481468445415],
            [32.00061175284543, 0.029056310249952],
            [31.999472563301037, 0.029725695185761],
            [31.99892753924849, 0.030657423177488],
            [31.998956959972368, 0.036085004573951],
            [31.999554449230754, 0.039757668790003],
            [32.00127372586989, 0.041584979957987],
            [32.003803044841746, 0.046107997884571],
            [32.004912174061765, 0.046967387985638],
            [32.01045309143037, 0.047673060214698],
            [32.01188795875561, 0.047455973417965],
            [32.02004561195297, 0.047989810565104],
            [32.02196014730058, 0.042544129792975],
            [32.02516748230953, 0.035994848771556],
            [32.02562808628494, 0.027346844319217],
            [32.03080988055914, 0.02937321428144],
            [32.034661268100955, 0.031363386598011],
            [32.03720808894948, 0.031680017534892],
            [32.04292286086828, 0.033516436884732],
            [32.043738575163694, 0.034122526508076],
            [32.04533880795967, 0.03659213039928],
            [32.04643644952389, 0.036953990585844],
            [32.049287954662255, 0.036004175078981],
            [32.05183310464438, 0.036203223740117],
            [32.0536605680881, 0.034167866269027],
            [32.05582272134883, 0.034394041355849],
            [32.0597963300749, 0.031743568839951],
            [32.06360903256731, 0.030703307318987],
            [32.06837140882526, 0.028677006550861],
            [32.07316817079564, 0.042047278032899],
            [32.07785993587897, 0.050478364867005],
            [32.07214443722312, 0.056738226367187],
            [32.07011817481038, 0.057172398099153],
            [32.065832337742684, 0.056521006651079],
            [32.06110647261113, 0.057687880794655],
            [32.057447619187556, 0.05960558169891],
            [32.05215391189696, 0.064698446050149],
            [32.04941189432369, 0.065847251314175],
            [32.04807049670378, 0.066860386781852],
            [32.046357300760825, 0.069474667461123],
            [32.04604360996192, 0.070949175434344],
            [32.04817760642837, 0.074314374972029],
            [32.05125395449248, 0.077932883658521],
            [32.05156334775106, 0.079832571647236],
            [32.05096072282417, 0.081026640790768],
            [32.042229933695765, 0.089584015932431],
            [32.03851007298627, 0.0942335919433],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1310,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "KITUNTU",
        Population: 22271,
        Key: "MPIGIKITUNTU",
        Dist2: "Mpigi",
        "Sub Country": "Kituntu",
        id2_original: "MpigiKituntu",
        drought: "H",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.06837140882526, 0.028677006550861],
            [32.06360903256731, 0.030703307318987],
            [32.0597963300749, 0.031743568839951],
            [32.05582272134883, 0.034394041355849],
            [32.0536605680881, 0.034167866269027],
            [32.05183310464438, 0.036203223740117],
            [32.049287954662255, 0.036004175078981],
            [32.04643644952389, 0.036953990585844],
            [32.04533880795967, 0.03659213039928],
            [32.043738575163694, 0.034122526508076],
            [32.04292286086828, 0.033516436884732],
            [32.03720808894948, 0.031680017534892],
            [32.034661268100955, 0.031363386598011],
            [32.03080988055914, 0.02937321428144],
            [32.02562808628494, 0.027346844319217],
            [32.02516748230953, 0.035994848771556],
            [32.02196014730058, 0.042544129792975],
            [32.02004561195297, 0.047989810565104],
            [32.01188795875561, 0.047455973417965],
            [32.01045309143037, 0.047673060214698],
            [32.004912174061765, 0.046967387985638],
            [32.003803044841746, 0.046107997884571],
            [32.00127372586989, 0.041584979957987],
            [31.999554449230754, 0.039757668790003],
            [31.998956959972368, 0.036085004573951],
            [31.99892753924849, 0.030657423177488],
            [31.999472563301037, 0.029725695185761],
            [32.00061175284543, 0.029056310249952],
            [32.00080998587582, 0.029481468445415],
            [32.00168972489816, 0.02860402293473],
            [32.00271181724868, 0.028613083341526],
            [32.009427059967386, 0.026256083969426],
            [32.008596739963735, 0.024243925302144],
            [32.004781319169275, 0.022289968447812],
            [32.000793800929344, 0.018020237540009],
            [32.000601160809914, 0.018942930357983],
            [31.998222306054902, 0.015288340502412],
            [31.993312086864123, 0.009236580119239],
            [31.98773919216637, 0.005410130740017],
            [31.985055385423518, 0.005030191885448],
            [31.98424642556072, 0.003691396688839],
            [31.98304603649096, 0.002696341833319],
            [31.9807017039923, 0.002578744277914],
            [31.980249626825575, -0.002930209234088],
            [31.979308134017334, -0.002930209234088],
            [31.979303929003493, -0.00482985679806],
            [31.981130752846738, -0.009787013818845],
            [31.98630656883272, -0.017846941750401],
            [31.92888440624064, -0.019113082043189],
            [31.927985056097302, -0.018326086929427],
            [31.927131171487122, -0.018425593308327],
            [31.92597039632477, -0.017801428608761],
            [31.92535407837802, -0.017729054943053],
            [31.924404171948797, -0.018344159235375],
            [31.922531603196358, -0.017891872783805],
            [31.9210594297357, -0.01876929590445],
            [31.91954319301201, -0.018099901033784],
            [31.918806682276884, -0.018769284226355],
            [31.917978364618026, -0.018027531859746],
            [31.915370414312708, -0.017439552195133],
            [31.902076436865862, -0.039492836524404],
            [31.917864863380164, -0.089253567464338],
            [31.922086634398458, -0.094237884087926],
            [31.931500264415376, -0.105138327063995],
            [31.936616808660602, -0.112935948318876],
            [31.945192406637187, -0.127291955274452],
            [31.94759248049754, -0.13039476525114],
            [31.963220442749254, -0.137252157536293],
            [31.98642273267705, -0.14717651927705],
            [32.00042341655453, -0.15373546665462],
            [32.001704988173174, -0.152957573320435],
            [32.00463846458122, -0.152903435644374],
            [32.117455180778045, -0.152781672135782],
            [32.116456291013066, -0.13200235372957],
            [32.11320968794806, -0.112996050884459],
            [32.111490766143504, -0.107423511451013],
            [32.10729078376244, -0.097246366519905],
            [32.10064277634949, -0.085368484136298],
            [32.09725668917541, -0.080628205121084],
            [32.091795197250974, -0.075028487405729],
            [32.086875656242505, -0.070740489766856],
            [32.081243700908054, -0.066380116314579],
            [32.06058322821266, -0.051833577137481],
            [32.05570190333301, -0.045962581348264],
            [32.05374030794262, -0.041168121350665],
            [32.05323911808268, -0.036735520353915],
            [32.053715392269886, -0.032483857772883],
            [32.057788468752435, -0.019339876995256],
            [32.06011940916683, -0.009108723804827],
            [32.05981137685592, -0.004549481819019],
            [32.06023594850698, -0.002785485252119],
            [32.059521869602776, -0.002676939121499],
            [32.05959431962875, -0.002116067889524],
            [32.06400169426285, 0.015912877112584],
            [32.06837140882526, 0.028677006550861],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1313,
        District: "MPIGI",
        County: "MAWOKOTA",
        Subcounty: "NKOZI",
        Population: 42122,
        Key: "MPIGINKOZI",
        Dist2: "Mpigi",
        "Sub Country": "Nkozi",
        id2_original: "MpigiNkozi",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.84446990141034, 0.106643465226716],
            [32.821221282668404, 0.120084196560011],
            [32.7893775940678, 0.135196410141596],
            [32.78865698890308, 0.139313667429845],
            [32.788453663323345, 0.13900353307756],
            [32.78779934484345, 0.139453624536958],
            [32.78534116435725, 0.142032881158358],
            [32.777561953422754, 0.141746525175019],
            [32.77494643121794, 0.142297064090419],
            [32.773044227942556, 0.143254548429462],
            [32.770048240468824, 0.146438217029864],
            [32.76614871580421, 0.1491670598144],
            [32.7629625001876, 0.1529970361702],
            [32.76227684487732, 0.154461291100946],
            [32.76288735880902, 0.15475741696126],
            [32.76141171335978, 0.156707199489824],
            [32.76028144857774, 0.160652456627598],
            [32.75852722388078, 0.164881518374893],
            [32.758527212202694, 0.165764513707597],
            [32.759081153831076, 0.16646162140462],
            [32.76231249002778, 0.169668328169918],
            [32.76388200403432, 0.170690763658393],
            [32.767251854159625, 0.171945588618218],
            [32.76831359545183, 0.171806181493142],
            [32.770667878588874, 0.172363893530218],
            [32.769421440979336, 0.17626764736191],
            [32.76766724592679, 0.177615354609944],
            [32.76531288194138, 0.183285085624912],
            [32.76346636792542, 0.184168056737626],
            [32.76258927983144, 0.184075096857079],
            [32.76166605067122, 0.182448514912854],
            [32.75788074769332, 0.180403632591212],
            [32.756911339737606, 0.180031832514084],
            [32.754280070964164, 0.180450057294889],
            [32.75331064594047, 0.181333038428039],
            [32.753356788803345, 0.182634293655592],
            [32.75488008718345, 0.187467550525488],
            [32.75409532074788, 0.187606958429337],
            [32.7519718776894, 0.185190312661045],
            [32.751187119338674, 0.184911459084959],
            [32.74707865282717, 0.184957873895607],
            [32.74684782263007, 0.186212651170077],
            [32.74537061950213, 0.186352050100797],
            [32.74430890336278, 0.184911359372467],
            [32.74266431265638, 0.180735426388626],
            [32.73965041816578, 0.18150363034031],
            [32.73614208645118, 0.180434690789845],
            [32.73489569645237, 0.180713512096282],
            [32.73452637478455, 0.182107705700189],
            [32.732449045842834, 0.183362454429359],
            [32.730338372336135, 0.183913497058946],
            [32.72941323784921, 0.182042429051338],
            [32.72770399000189, 0.180751819662656],
            [32.71940028062081, 0.171304455791404],
            [32.70097305385771, 0.155146357310878],
            [32.67570986247982, 0.141381945928068],
            [32.64271911060133, 0.131208070840562],
            [32.61992765708388, 0.126006849229838],
            [32.62005702975616, 0.047641214050579],
            [32.84534736410177, 0.066863370084881],
            [32.84446990141034, 0.106643465226716],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1317,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "MPUNGE",
        Population: 13919,
        Key: "MUKONOMPUNGE",
        Dist2: "Mukono",
        "Sub Country": "Mukono Central Division",
        id2_original: "MukonoMukono Central Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.85894780180779, 0.375838711249761],
            [32.85816823751604, 0.376625973299962],
            [32.85770258141545, 0.378500973504803],
            [32.856771319519986, 0.379282212241947],
            [32.85661609243551, 0.380415028497173],
            [32.855878836996986, 0.381352521053668],
            [32.8544043503745, 0.381782185607482],
            [32.853977516765546, 0.382446244124927],
            [32.853550655308844, 0.384672810597903],
            [32.851767186856144, 0.385521826026456],
            [32.85316572541296, 0.387577422854803],
            [32.85334115650649, 0.388725512612374],
            [32.84926978053478, 0.388708474658512],
            [32.848370474408895, 0.390473528165741],
            [32.84802121840958, 0.392504781811497],
            [32.84390810581142, 0.397270353376586],
            [32.843112635050936, 0.398696124999126],
            [32.843229012694316, 0.400180509119254],
            [32.84427663247021, 0.402172726852099],
            [32.84495559263669, 0.406254790003098],
            [32.844412255620234, 0.411762617723945],
            [32.845362870820196, 0.413735301934603],
            [32.84602249744515, 0.414282192781806],
            [32.8494951283137, 0.423012771296092],
            [32.85067855719088, 0.425141712118432],
            [32.85252146896254, 0.435239454262629],
            [32.85102739367695, 0.444594939929016],
            [32.84930058376585, 0.449653522650179],
            [32.84553664542035, 0.454692529090901],
            [32.83709699847886, 0.460063457802281],
            [32.833527148337005, 0.461196190479981],
            [32.83212022849858, 0.466583492729439],
            [32.83105015533216, 0.468809670209354],
            [32.82936191279114, 0.468330874293119],
            [32.821253015655806, 0.464333174911275],
            [32.820780516189394, 0.462699788443547],
            [32.8199656840396, 0.461957577807228],
            [32.81420357270196, 0.46025820357999],
            [32.80417376936703, 0.453328697542525],
            [32.80329487745599, 0.452099756155498],
            [32.80217332094229, 0.451869267303568],
            [32.80075882471276, 0.450394533545119],
            [32.79663192028008, 0.443482738634154],
            [32.79232816541571, 0.440610104379479],
            [32.79075887868293, 0.438240236001592],
            [32.788666458942785, 0.436468792802885],
            [32.786339014771485, 0.433070991507133],
            [32.7826191010614, 0.438772903398086],
            [32.776546586758805, 0.437815689333885],
            [32.77286042095735, 0.436487452066548],
            [32.77108086826097, 0.433997158594029],
            [32.7663381507347, 0.433823392570271],
            [32.76541052701611, 0.432698157288109],
            [32.76380026183504, 0.431975450877756],
            [32.76213176606062, 0.432131648193255],
            [32.75945438227205, 0.433342498642636],
            [32.7591051424424, 0.434006551109183],
            [32.759687082761566, 0.43685813110273],
            [32.759764584912716, 0.440061257136323],
            [32.759298909947525, 0.441584676614384],
            [32.759376448031254, 0.443615927850265],
            [32.758348151017124, 0.444846362718401],
            [32.75698985967996, 0.451330688325088],
            [32.75485567277067, 0.453322801185572],
            [32.74975312787084, 0.454943716181262],
            [32.747541453183445, 0.453576452325125],
            [32.74280762448693, 0.452560661076144],
            [32.73865591307766, 0.449240204335076],
            [32.73659943133876, 0.448380756775441],
            [32.73543540427508, 0.447365091460824],
            [32.73479522707436, 0.445783041011023],
            [32.73343718007897, 0.445040805283256],
            [32.732622387455024, 0.443634529605593],
            [32.72986748534566, 0.442384431000551],
            [32.72656944564585, 0.438751508850281],
            [32.72460847188962, 0.437436162197278],
            [32.72113575388449, 0.436606625401136],
            [32.723446041132185, 0.434395938043835],
            [32.7269382714436, 0.432989821158042],
            [32.728451633558386, 0.430646133738109],
            [32.731342468736536, 0.428204837385432],
            [32.7349123072003, 0.426642467137558],
            [32.73669725697487, 0.424923782335414],
            [32.73937462279713, 0.424103563943003],
            [32.7410819769958, 0.422111437931376],
            [32.742149097399896, 0.420138821394597],
            [32.74199394218065, 0.418537257071336],
            [32.74040314079686, 0.416115333055843],
            [32.74013164476516, 0.41252158107841],
            [32.73902591926173, 0.408556708741961],
            [32.73914238134673, 0.406798903840736],
            [32.739840876277356, 0.404923930627785],
            [32.739821542735825, 0.402834090668703],
            [32.74155362845258, 0.397612060696234],
            [32.7477338067403, 0.398323042126416],
            [32.750135392465275, 0.397676802516186],
            [32.7570309692823, 0.397988198697706],
            [32.76294080767012, 0.397439432009885],
            [32.76252328150582, 0.394650631225334],
            [32.7619085113563, 0.394481489654587],
            [32.760541330291105, 0.392853695442941],
            [32.753466989630844, 0.380431148409625],
            [32.754277724564645, 0.379334818228837],
            [32.755889199776405, 0.378271177788282],
            [32.756744366282476, 0.378812008379384],
            [32.75956525054778, 0.379276870976302],
            [32.764295975565, 0.378871322840987],
            [32.76721172461926, 0.3792156736899],
            [32.76759365593873, 0.375817697412409],
            [32.76910687522133, 0.37385186092361],
            [32.76957521908123, 0.372508672706206],
            [32.76972331264403, 0.369012795665791],
            [32.77199158388925, 0.362027206982936],
            [32.7718060584269, 0.360810760474721],
            [32.77230531780731, 0.359783356936995],
            [32.77351366595048, 0.358813791975748],
            [32.77340213741301, 0.357771917534686],
            [32.776401979557654, 0.356933603559105],
            [32.783811957757536, 0.353753550459687],
            [32.784293790719715, 0.352789004554592],
            [32.787880654953064, 0.353602772010225],
            [32.7946076781784, 0.35639811202403],
            [32.79497325387149, 0.355529107572564],
            [32.79554392302877, 0.355505183202168],
            [32.79506841330785, 0.35335078679207],
            [32.79559155260344, 0.352129979694091],
            [32.7981358473894, 0.349042081407666],
            [32.799063189036964, 0.348730911660527],
            [32.79977655018726, 0.347486170586544],
            [32.80067859886968, 0.346825755685369],
            [32.80327703242288, 0.346704012837866],
            [32.80782475175211, 0.345637935073032],
            [32.81358728260295, 0.346840109602298],
            [32.81991578621883, 0.345458642687853],
            [32.821246821771915, 0.34576124636413],
            [32.82249444875091, 0.347764161711005],
            [32.82422181561748, 0.352546621224659],
            [32.82791683970598, 0.356087119487434],
            [32.82878470389859, 0.357619145828107],
            [32.830449144677814, 0.35821761874249],
            [32.83125757812789, 0.359031515972328],
            [32.833803674934295, 0.359312851113307],
            [32.83704262884461, 0.360888937506812],
            [32.84729931607758, 0.366704121765282],
            [32.84729926217866, 0.369856179404566],
            [32.85894780180779, 0.375838711249761],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1319,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "NAMA",
        Population: 54268,
        Key: "MUKONONAMA",
        Dist2: "Mukono",
        "Sub Country": "Nama",
        id2_original: "MukonoNama",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.88936996576011, 0.189933067655626],
            [32.88797732464311, 0.189944634299662],
            [32.88608793493695, 0.190759810497051],
            [32.883658717932164, 0.19206409502737],
            [32.88135301299072, 0.19408043487948],
            [32.87700034396084, 0.195933180557208],
            [32.8744588483253, 0.197624187122712],
            [32.87375772672079, 0.200432756506436],
            [32.873932997914174, 0.200844486012664],
            [32.87486779647695, 0.20088860739503],
            [32.875028460165495, 0.201594428224719],
            [32.872501544187045, 0.206329282439639],
            [32.87254535861671, 0.206917465818566],
            [32.87279365475787, 0.208079128983318],
            [32.87371384312082, 0.208696729232689],
            [32.87681037004116, 0.208108571072569],
            [32.877306978493166, 0.208608530527976],
            [32.8779642362607, 0.211578861012399],
            [32.877453006829136, 0.212769927284216],
            [32.87634292449656, 0.213828647392141],
            [32.87467783154044, 0.211520015474214],
            [32.87340709540075, 0.210725957764515],
            [32.87121614933855, 0.21199053363689],
            [32.86911281955929, 0.215666658520109],
            [32.86871842052199, 0.219122230659786],
            [32.86908026641001, 0.220996365725599],
            [32.86876221878199, 0.221489667394554],
            [32.867506073079184, 0.222357225940412],
            [32.86597518213828, 0.222411033722316],
            [32.86476459629174, 0.225106243787159],
            [32.859609223266666, 0.22991580296759],
            [32.855128671869544, 0.230404869710022],
            [32.850540114229176, 0.23486118016688],
            [32.84789496199302, 0.235785030355621],
            [32.83858285597624, 0.24678994895739],
            [32.83766512270896, 0.249235499575253],
            [32.83345441174846, 0.255159137987045],
            [32.827192435565905, 0.255485127977009],
            [32.82373758056022, 0.253691669997149],
            [32.81750251071706, 0.260131552965305],
            [32.812927181667575, 0.261943754088959],
            [32.811738287440186, 0.262781553665171],
            [32.80877742499236, 0.266268370397779],
            [32.80673209853268, 0.266571144291052],
            [32.79611695026366, 0.264127591226796],
            [32.78899122866409, 0.264627372597704],
            [32.787630410366056, 0.265278512164248],
            [32.78410262114243, 0.269003380917505],
            [32.780551324804435, 0.271788089558297],
            [32.778230074517026, 0.27211412043495],
            [32.77480216986816, 0.273282486602741],
            [32.773668519335764, 0.274315030739997],
            [32.77302068040403, 0.276977952276157],
            [32.76940392383128, 0.273608455455861],
            [32.76783845044691, 0.27279324180644],
            [32.76341189228993, 0.272901845096225],
            [32.761630494453975, 0.271923589910474],
            [32.75612432032731, 0.270727875605949],
            [32.7529124039104, 0.269124617109757],
            [32.74961474509627, 0.268904449646911],
            [32.74983578186014, 0.263791682367448],
            [32.74880211651382, 0.259217194177878],
            [32.75101109535706, 0.258329144016781],
            [32.75464911235762, 0.255648208308014],
            [32.75771649793012, 0.251363444447506],
            [32.75985655532982, 0.247078659418479],
            [32.76349454987249, 0.245427033090111],
            [32.76373325200642, 0.244974706740604],
            [32.76330004395223, 0.242443260102407],
            [32.7645746940516, 0.240015100376441],
            [32.764697477581244, 0.237123813257076],
            [32.76374046457985, 0.236654170854088],
            [32.76490720455569, 0.233066456413843],
            [32.762472633591806, 0.231369209625826],
            [32.76090857954556, 0.230975536936646],
            [32.75910353445807, 0.229453584840316],
            [32.75867556268365, 0.228041260314838],
            [32.758794472677806, 0.226724697107281],
            [32.760280657161964, 0.221278924202091],
            [32.75980513755958, 0.219351942569328],
            [32.75835473027826, 0.218167009566056],
            [32.752771378292266, 0.216948625244764],
            [32.752361800421625, 0.209854802622446],
            [32.751655651844764, 0.205063415241715],
            [32.74978001175234, 0.202620476660376],
            [32.74853741174571, 0.201892275387201],
            [32.74477813655481, 0.196646930980981],
            [32.734702264018864, 0.187044872085516],
            [32.730338372336135, 0.183913497058946],
            [32.732449045842834, 0.183362454429359],
            [32.73452637478455, 0.182107705700189],
            [32.73489569645237, 0.180713512096282],
            [32.73614208645118, 0.180434690789845],
            [32.73965041816578, 0.18150363034031],
            [32.74266431265638, 0.180735426388626],
            [32.74430890336278, 0.184911359372467],
            [32.74537061950213, 0.186352050100797],
            [32.74684782263007, 0.186212651170077],
            [32.74707865282717, 0.184957873895607],
            [32.751187119338674, 0.184911459084959],
            [32.7519718776894, 0.185190312661045],
            [32.75409532074788, 0.187606958429337],
            [32.75488008718345, 0.187467550525488],
            [32.753356788803345, 0.182634293655592],
            [32.75331064594047, 0.181333038428039],
            [32.754280070964164, 0.180450057294889],
            [32.756911339737606, 0.180031832514084],
            [32.75788074769332, 0.180403632591212],
            [32.76166605067122, 0.182448514912854],
            [32.76258927983144, 0.184075096857079],
            [32.76346636792542, 0.184168056737626],
            [32.76531288194138, 0.183285085624912],
            [32.76766724592679, 0.177615354609944],
            [32.769421440979336, 0.17626764736191],
            [32.770667878588874, 0.172363893530218],
            [32.76831359545183, 0.171806181493142],
            [32.767251854159625, 0.171945588618218],
            [32.76388200403432, 0.170690763658393],
            [32.76231249002778, 0.169668328169918],
            [32.759081153831076, 0.16646162140462],
            [32.758527212202694, 0.165764513707597],
            [32.75852722388078, 0.164881518374893],
            [32.76028144857774, 0.160652456627598],
            [32.76141171335978, 0.156707199489824],
            [32.76288735880902, 0.15475741696126],
            [32.76227684487732, 0.154461291100946],
            [32.7629625001876, 0.1529970361702],
            [32.76614871580421, 0.1491670598144],
            [32.770048240468824, 0.146438217029864],
            [32.773044227942556, 0.143254548429462],
            [32.77494643121794, 0.142297064090419],
            [32.777561953422754, 0.141746525175019],
            [32.78534116435725, 0.142032881158358],
            [32.78779934484345, 0.139453624536958],
            [32.788453663323345, 0.13900353307756],
            [32.78865698890308, 0.139313667429845],
            [32.7893775940678, 0.135196410141596],
            [32.821221282668404, 0.120084196560011],
            [32.84446990141034, 0.106643465226716],
            [32.86096023375842, 0.109350306252862],
            [32.87479917686733, 0.110694629003765],
            [32.873850698759426, 0.113066690667689],
            [32.86907407791603, 0.125328078443946],
            [32.8833216080538, 0.170585347725607],
            [32.88936996576011, 0.189933067655626],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1320,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "NTENJERU",
        Population: 41104,
        Key: "MUKONONTENJERU",
        Dist2: "Mukono",
        "Sub Country": "Ntenjeru",
        id2_original: "MukonoNtenjeru",
        drought: "L",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.754277724564645, 0.379334818228837],
            [32.75191304881808, 0.377188744868861],
            [32.748926503536275, 0.376369172064191],
            [32.74727520510966, 0.378798668688968],
            [32.74594097694402, 0.378691433746579],
            [32.74515766757584, 0.383009143771031],
            [32.74656334594255, 0.384453903280629],
            [32.744215965460135, 0.38617956385065],
            [32.74294371296425, 0.388169242758859],
            [32.74223936730619, 0.391279582085632],
            [32.742343896170944, 0.395490434541758],
            [32.73156021227655, 0.392706135353541],
            [32.73122164802575, 0.390276801684755],
            [32.72977767088522, 0.388765898141328],
            [32.72732752043937, 0.3873864058678],
            [32.72980798004292, 0.379668881778517],
            [32.72816399300437, 0.376796883071752],
            [32.72976991842434, 0.375096952314298],
            [32.7298649844359, 0.368739557175425],
            [32.731446450527294, 0.362558054889194],
            [32.73230902633782, 0.360532019663135],
            [32.73230601518499, 0.358975048083771],
            [32.73378777995795, 0.355239496296113],
            [32.73456827400604, 0.350939306755521],
            [32.73700838757521, 0.346003420565408],
            [32.73949728146098, 0.33832824474925],
            [32.740607609033596, 0.332618833929607],
            [32.739719539035306, 0.330369881764983],
            [32.74001366812058, 0.329569797949033],
            [32.738369795168104, 0.328610501084413],
            [32.73534276910466, 0.33026247288974],
            [32.73455726694886, 0.329399234951352],
            [32.733439379154774, 0.329624284361072],
            [32.73233044307252, 0.329293468158841],
            [32.7276483187088, 0.325944140004724],
            [32.7269911974852, 0.324786373103472],
            [32.726888601794926, 0.321664583131291],
            [32.72894689723237, 0.318501700304847],
            [32.73048856705837, 0.31388465373335],
            [32.72477379154632, 0.306551774031096],
            [32.71980413173149, 0.304815022029853],
            [32.71750413558372, 0.303615864385584],
            [32.71239080101898, 0.299170805840945],
            [32.71087118842647, 0.297392796290251],
            [32.7100908884145, 0.294870540324718],
            [32.71002941310636, 0.292405721319181],
            [32.71555537172884, 0.292365867182227],
            [32.71917170968665, 0.293194263857013],
            [32.72326638346528, 0.294850974378603],
            [32.731608849760995, 0.296546317083432],
            [32.7361435264506, 0.301959304302192],
            [32.74188369194585, 0.30619728592167],
            [32.74339524215868, 0.308489608019303],
            [32.7457294650171, 0.314884954066149],
            [32.747528025166574, 0.317312127296183],
            [32.75085995111555, 0.319448512636618],
            [32.75396826033916, 0.319949264408204],
            [32.755055396106115, 0.318381640524811],
            [32.75652069565821, 0.320573834403513],
            [32.759730649256234, 0.322058039915882],
            [32.761211590274065, 0.323207468200791],
            [32.76252004128259, 0.325589840302034],
            [32.76263776550058, 0.329325707263568],
            [32.76386774687245, 0.331513480028515],
            [32.77031003649206, 0.335120056049413],
            [32.77149625733317, 0.336279183568558],
            [32.77313606271406, 0.336665588123289],
            [32.77580323445446, 0.338492570697834],
            [32.776936864325585, 0.342104243781257],
            [32.78128498428687, 0.34679094660579],
            [32.784220591498794, 0.347274241245015],
            [32.78654182920981, 0.348306861690982],
            [32.788593117788054, 0.350969845309008],
            [32.7883209363418, 0.353439483857727],
            [32.787880654953064, 0.353602772010225],
            [32.784293790719715, 0.352789004554592],
            [32.783811957757536, 0.353753550459687],
            [32.776401979557654, 0.356933603559105],
            [32.77340213741301, 0.357771917534686],
            [32.77351366595048, 0.358813791975748],
            [32.77230531780731, 0.359783356936995],
            [32.7718060584269, 0.360810760474721],
            [32.77199158388925, 0.362027206982936],
            [32.76972331264403, 0.369012795665791],
            [32.76957521908123, 0.372508672706206],
            [32.76910687522133, 0.37385186092361],
            [32.76759365593873, 0.375817697412409],
            [32.76721172461926, 0.3792156736899],
            [32.764295975565, 0.378871322840987],
            [32.75956525054778, 0.379276870976302],
            [32.756744366282476, 0.378812008379384],
            [32.755889199776405, 0.378271177788282],
            [32.754277724564645, 0.379334818228837],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1321,
        District: "MUKONO",
        County: "MUKONO MUNICIPALITY",
        Subcounty: "CENTRAL DIVISION",
        Population: 69671,
        Key: "MUKONOCENTRAL DIVISION",
        Dist2: "Mukono",
        "Sub Country": "Goma Division",
        id2_original: "MukonoGoma Division",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.538046993223748, 2.16192408869633],
            [31.537364837749795, 2.237184171759298],
            [31.53762450476585, 2.2734092440674],
            [31.53529280527504, 2.271396204509203],
            [31.53206063364511, 2.265993651687761],
            [31.529373283048482, 2.260327957760846],
            [31.52559358555793, 2.256665874141834],
            [31.512233470546608, 2.250758689755914],
            [31.503100840737087, 2.249537238100549],
            [31.501776643159904, 2.248967927782441],
            [31.49806614738729, 2.249058329222523],
            [31.490618112958703, 2.247013641560051],
            [31.484748060954832, 2.242895486007782],
            [31.478089135417925, 2.234824374463043],
            [31.473487002436983, 2.230410938266587],
            [31.47042348501008, 2.228099214667583],
            [31.46686647089532, 2.227199466124164],
            [31.46404671311737, 2.227076681090624],
            [31.4547122192871, 2.228821559339929],
            [31.453325236658078, 2.228275983447285],
            [31.45230102069029, 2.228372473033172],
            [31.44607246273462, 2.229825615682389],
            [31.439629974587316, 2.232253038851063],
            [31.433969407012743, 2.233424853264738],
            [31.431468326581857, 2.236406113443321],
            [31.427993461603194, 2.237540983462657],
            [31.424832405102755, 2.237223477206661],
            [31.41959950028213, 2.235848300264261],
            [31.4229003867431, 2.236604383973274],
            [31.429466004271458, 2.216971129106806],
            [31.433118734778052, 2.210975956650432],
            [31.43722650958675, 2.205669027681951],
            [31.440590691342646, 2.203131566305152],
            [31.44304026417176, 2.197450910384387],
            [31.442948178770326, 2.196546679208437],
            [31.44478622796134, 2.188655051718063],
            [31.444903636870684, 2.179749617308353],
            [31.444243835074268, 2.17824104516193],
            [31.4425358628347, 2.177016521169906],
            [31.44010760433231, 2.174453870265505],
            [31.43893332569459, 2.171357577053488],
            [31.438785202487388, 2.167650978828443],
            [31.43956373371658, 2.162885730847728],
            [31.440464756522953, 2.159513822586489],
            [31.444174273131928, 2.153384808099112],
            [31.449059918908116, 2.148517926331399],
            [31.45251899599565, 2.145846689084273],
            [31.45613179009965, 2.14137966744124],
            [31.45685528873792, 2.13954627064166],
            [31.456460242015325, 2.135782078154483],
            [31.455360713989013, 2.133832199985383],
            [31.453084359702874, 2.131269756508044],
            [31.450847904090054, 2.126796806274641],
            [31.448913359667827, 2.124272926976674],
            [31.44798902647811, 2.122216861577639],
            [31.448719468195215, 2.121343971006206],
            [31.45066779546884, 2.12088056670987],
            [31.45120903761406, 2.120332476827985],
            [31.451537459885298, 2.118785120937006],
            [31.452591141492743, 2.11837913375269],
            [31.45261984805596, 2.117641330779442],
            [31.453898491166765, 2.116723369381404],
            [31.45507418465105, 2.117102574057555],
            [31.457905692392895, 2.11686079413555],
            [31.45832976547897, 2.11805016566647],
            [31.45914471620642, 2.118834435250059],
            [31.460048720521225, 2.118928423654757],
            [31.461197138458537, 2.120783194992533],
            [31.46138015762125, 2.121949091366916],
            [31.46110960751556, 2.122258831704874],
            [31.46068726907631, 2.12197381759607],
            [31.460478673080804, 2.123164038011637],
            [31.460632652405344, 2.124901143949507],
            [31.462082434459255, 2.12680311797855],
            [31.46333431136785, 2.127622500091185],
            [31.46363737599525, 2.128550251567694],
            [31.4656006224891, 2.131117899912236],
            [31.466685993066527, 2.131521028183638],
            [31.46719963177968, 2.132281904219658],
            [31.46813368024917, 2.132328245839215],
            [31.468797547820547, 2.132874739850465],
            [31.469881364312528, 2.132468700714666],
            [31.47054463630086, 2.132705800314675],
            [31.470817624434243, 2.133657397725201],
            [31.47295592203429, 2.133249938646116],
            [31.473981594171175, 2.13393873541985],
            [31.474103762354865, 2.134795332936451],
            [31.47518873587694, 2.134984268325497],
            [31.476305254638493, 2.135910925567762],
            [31.478173514172557, 2.136075008242701],
            [31.479576042147546, 2.136894190620573],
            [31.48069004562632, 2.136511908138631],
            [31.481987526408634, 2.137533516746914],
            [31.48301211607561, 2.137651133011881],
            [31.483493143249, 2.137126906115427],
            [31.485542038715348, 2.137219339503027],
            [31.486779366509584, 2.138288634717337],
            [31.48885976768956, 2.139094992422292],
            [31.48937171667167, 2.138975307093983],
            [31.490548466574705, 2.139878085199515],
            [31.49157693067553, 2.141994822356988],
            [31.497108823568766, 2.143712780916238],
            [31.499067399721476, 2.143829130071365],
            [31.500090374217574, 2.143113767101927],
            [31.501211318080255, 2.143152882912417],
            [31.50229090260891, 2.141573612015543],
            [31.505062992184616, 2.14160732288696],
            [31.50583245671766, 2.142196832575471],
            [31.506756467412156, 2.142228725616086],
            [31.50783349533554, 2.143283344645068],
            [31.508171497240955, 2.14412032518991],
            [31.507923676308586, 2.145576475000019],
            [31.509031204730782, 2.146940996749063],
            [31.50973774587144, 2.148893873556461],
            [31.515324577930826, 2.152679789996242],
            [31.51634007395219, 2.153672376560666],
            [31.51720042283915, 2.155842323407623],
            [31.51821712170466, 2.15559542114025],
            [31.52286445970731, 2.159473379530831],
            [31.529532529195507, 2.160068649890159],
            [31.528993077392663, 2.16023945087686],
            [31.538046993223748, 2.16192408869633],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1782,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "NGWEDO",
        Population: 17472,
        Key: "BULIISANGWEDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.41959950028213, 2.235848300264261],
            [31.41757381548612, 2.236351836385167],
            [31.41443469135331, 2.235870779647235],
            [31.40866579054878, 2.236824668871981],
            [31.40496532356796, 2.238183407499047],
            [31.40305144129557, 2.239516219541785],
            [31.40192209279511, 2.237198524872225],
            [31.39794329360331, 2.235191790464743],
            [31.395912840549776, 2.236053323749661],
            [31.388925817931753, 2.23679158489312],
            [31.387910472827365, 2.237340119804843],
            [31.38693298901725, 2.238948775083717],
            [31.381115856766755, 2.240591305096532],
            [31.38021727558133, 2.241414799120074],
            [31.375687723780395, 2.243412077483142],
            [31.37377339774028, 2.24513744885347],
            [31.371430346239215, 2.246312650473707],
            [31.37022024278798, 2.246507597552227],
            [31.368113034083283, 2.24619114615563],
            [31.365653823229476, 2.246541725249152],
            [31.36030709647249, 2.246339405083713],
            [31.35695239643443, 2.244765152261321],
            [31.353203718668954, 2.246488381199026],
            [31.350345778898173, 2.245707844996653],
            [31.347497010028164, 2.246182120535643],
            [31.3454016051863, 2.24510529500272],
            [31.336513839953565, 2.247427379098311],
            [31.33554916611939, 2.245450756096104],
            [31.3241074267535, 2.211449188643441],
            [31.321538563044555, 2.201830219154894],
            [31.31821046481701, 2.192668316167242],
            [31.311324404752064, 2.170233562388373],
            [31.309383908991066, 2.161802256122489],
            [31.30641025453361, 2.154195681253644],
            [31.30638684623395, 2.137450297271074],
            [31.320633429547403, 2.138289443535801],
            [31.373691570201036, 2.139569161711915],
            [31.389063075117257, 2.141117261557419],
            [31.395644935982602, 2.140778331292515],
            [31.398420874839267, 2.139916544882075],
            [31.40156449324345, 2.139722202421903],
            [31.410572748606935, 2.141313661341612],
            [31.41873925200651, 2.140825434793013],
            [31.428655156149922, 2.138160960784211],
            [31.43210617265441, 2.136608102887549],
            [31.435150474219068, 2.129968749775618],
            [31.435324717739803, 2.124411241576606],
            [31.438922521656664, 2.123157054814309],
            [31.439682785644543, 2.121924983652193],
            [31.439555603963242, 2.12115041528049],
            [31.448890705952994, 2.12109712153809],
            [31.448719468195215, 2.121343971006206],
            [31.44798902647811, 2.122216861577639],
            [31.448913359667827, 2.124272926976674],
            [31.450847904090054, 2.126796806274641],
            [31.453084359702874, 2.131269756508044],
            [31.455360713989013, 2.133832199985383],
            [31.456460242015325, 2.135782078154483],
            [31.45685528873792, 2.13954627064166],
            [31.45613179009965, 2.14137966744124],
            [31.45251899599565, 2.145846689084273],
            [31.449059918908116, 2.148517926331399],
            [31.444174273131928, 2.153384808099112],
            [31.440464756522953, 2.159513822586489],
            [31.43956373371658, 2.162885730847728],
            [31.438785202487388, 2.167650978828443],
            [31.43893332569459, 2.171357577053488],
            [31.44010760433231, 2.174453870265505],
            [31.4425358628347, 2.177016521169906],
            [31.444243835074268, 2.17824104516193],
            [31.444903636870684, 2.179749617308353],
            [31.44478622796134, 2.188655051718063],
            [31.442948178770326, 2.196546679208437],
            [31.44304026417176, 2.197450910384387],
            [31.440590691342646, 2.203131566305152],
            [31.43722650958675, 2.205669027681951],
            [31.433118734778052, 2.210975956650432],
            [31.429466004271458, 2.216971129106806],
            [31.4229003867431, 2.236604383973274],
            [31.41959950028213, 2.235848300264261],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1785,
        District: "BULIISA",
        County: "BULIISA",
        Subcounty: "KIGWERA",
        Population: 13628,
        Key: "BULIISAKIGWERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.88944416654213, 2.612614936009818],
            [31.887887751769096, 2.613660525954379],
            [31.886198144687153, 2.61325653223678],
            [31.88591457709469, 2.614761065196251],
            [31.881419344530872, 2.615601786138901],
            [31.881158192599678, 2.616031851553855],
            [31.881422001747488, 2.617702894151233],
            [31.880520439053626, 2.619637890670134],
            [31.876988359476194, 2.620226826172865],
            [31.874967389937115, 2.621160255793483],
            [31.873229961041062, 2.620565271519256],
            [31.87273136641397, 2.621353754148274],
            [31.871399034591903, 2.621283606320534],
            [31.870163554632196, 2.622550419666744],
            [31.86887861882282, 2.622336964783988],
            [31.867961467663825, 2.62134711805804],
            [31.86760476552913, 2.621466889834407],
            [31.867320036414988, 2.622064109040505],
            [31.86655847615813, 2.621850062704685],
            [31.865988815808926, 2.622877374405628],
            [31.866799083618773, 2.623998670770342],
            [31.865847359897757, 2.62390421503911],
            [31.865562453815517, 2.624358178238492],
            [31.86461112355659, 2.624574115807246],
            [31.864683118136707, 2.625075440295904],
            [31.863565947198232, 2.625840714039988],
            [31.862947021442206, 2.625530993213576],
            [31.863112386912963, 2.624599654144391],
            [31.862422415197763, 2.624552663208823],
            [31.862063831990845, 2.623168224114874],
            [31.860612379070535, 2.62295495060712],
            [31.861704325315813, 2.621043647236417],
            [31.860764316524413, 2.620793988372588],
            [31.859908298415462, 2.621129190450783],
            [31.85859913234794, 2.62055759805838],
            [31.857196700492675, 2.62149032837703],
            [31.857079062512973, 2.622541009798511],
            [31.855627844052936, 2.622518714530613],
            [31.853487894451096, 2.623428373701995],
            [31.85356059600536, 2.624502717222152],
            [31.85410886028113, 2.625385528260539],
            [31.853942948634675, 2.625887112661551],
            [31.852705941538996, 2.62593621955008],
            [31.851303276121754, 2.626701788899422],
            [31.848174691023857, 2.626526136503502],
            [31.846959901061766, 2.625309768491724],
            [31.846934421247063, 2.623948871033406],
            [31.846195505721905, 2.622803618321524],
            [31.84628786331289, 2.620535297370865],
            [31.845846741999367, 2.619712051657588],
            [31.84380118197771, 2.620000799549931],
            [31.84104330734305, 2.621412484666952],
            [31.840021533894497, 2.622368634927128],
            [31.83940508748863, 2.624064497593178],
            [31.83441952928994, 2.622768663799582],
            [31.833968062977604, 2.623198924175743],
            [31.833803052341374, 2.6244406513129],
            [31.832900156547623, 2.625348906492833],
            [31.83228171767849, 2.625421202401961],
            [31.831590645527044, 2.624466907551194],
            [31.82878547818596, 2.626117368431635],
            [31.827761351151352, 2.625163442932668],
            [31.824751536808733, 2.624820467097819],
            [31.822798575126548, 2.623007985417226],
            [31.821703872849973, 2.622698771802869],
            [31.820563423867547, 2.623893802814893],
            [31.81842323711047, 2.624612360945311],
            [31.817542790215647, 2.624422293751949],
            [31.81615255568534, 2.62562950943114],
            [31.814630601184895, 2.62610863341389],
            [31.813823177441193, 2.627279416892464],
            [31.81463268976791, 2.62782770508575],
            [31.814395685449863, 2.628568102044328],
            [31.81077730112986, 2.626614127372217],
            [31.808209353702456, 2.627715147882125],
            [31.807005321964237, 2.625507905619251],
            [31.80538685606293, 2.624864964224388],
            [31.80165222076198, 2.625131548517158],
            [31.798965249254387, 2.626161021085106],
            [31.797339569881355, 2.629421766340214],
            [31.794511019393422, 2.631430291209716],
            [31.790944256761193, 2.630474481707456],
            [31.787995223329013, 2.630377451915011],
            [31.786028906393515, 2.630610927512762],
            [31.785279234441145, 2.631316336231593],
            [31.783734094423213, 2.631691431564228],
            [31.780785936848446, 2.630699924043655],
            [31.780270738659972, 2.630981877215803],
            [31.78008312191961, 2.631358312419613],
            [31.781064974236948, 2.632583260544925],
            [31.783778533181994, 2.634139461229005],
            [31.78368421816201, 2.634845519437679],
            [31.781857662915026, 2.635785264549553],
            [31.781154662034922, 2.636631944201743],
            [31.77762018754897, 2.636816766235438],
            [31.7780433775911, 2.634887034260915],
            [31.77757636144117, 2.63375674260868],
            [31.77392553087141, 2.633282365043744],
            [31.77284799360327, 2.634175745329009],
            [31.773360574101, 2.636577169084032],
            [31.77293787453902, 2.63798904722565],
            [31.767975534197145, 2.638313640544288],
            [31.767600255800673, 2.639113564095112],
            [31.766476033985548, 2.639865659534291],
            [31.767269784472298, 2.641937813740344],
            [31.767175597013054, 2.64250264638732],
            [31.766426010400647, 2.643113885730591],
            [31.764085707744368, 2.642829085293252],
            [31.763267386537976, 2.641933810615308],
            [31.75961777498204, 2.640235409398828],
            [31.757511173538482, 2.640327441913369],
            [31.756808580493534, 2.640750421320496],
            [31.75577938157081, 2.640090311388699],
            [31.754094415185673, 2.639853234660503],
            [31.748944708733394, 2.640318794936681],
            [31.746930582560136, 2.641540728979635],
            [31.745762338804518, 2.639515277328519],
            [31.733427291363896, 2.639832219340376],
            [31.726640630783482, 2.638930809926272],
            [31.725026424693244, 2.638175940171907],
            [31.724653286083797, 2.636857432086456],
            [31.720911953842382, 2.633417044524205],
            [31.716885722705268, 2.633930716808775],
            [31.715763950595928, 2.632281912932929],
            [31.715202437966333, 2.632093035022146],
            [31.710754149562636, 2.6333594416627],
            [31.708881975170588, 2.633122117773479],
            [31.708274079827923, 2.632509500547385],
            [31.707434503583617, 2.629589953112927],
            [31.705281672140593, 2.62916403910471],
            [31.70181953269625, 2.627418631436447],
            [31.701163571197693, 2.628029927541652],
            [31.701208776219396, 2.629583448979759],
            [31.70069342172406, 2.63000659625596],
            [31.7006922018119, 2.631183479078964],
            [31.703310728881377, 2.633916574316752],
            [31.702889657964967, 2.635347667168915],
            [31.70187337681607, 2.6356568938012],
            [31.69987644709229, 2.634892736121629],
            [31.699021867186087, 2.632600301548167],
            [31.696739872378277, 2.631406320714346],
            [31.695980791471605, 2.6285407869955],
            [31.69124847823296, 2.629089970209717],
            [31.685923512265422, 2.626893010662911],
            [31.682784840883524, 2.626749682509768],
            [31.682213974995182, 2.627036231115008],
            [31.68102368388753, 2.629137582851716],
            [31.678693079443047, 2.62961511624707],
            [31.677886230621155, 2.627131666538756],
            [31.675510432833068, 2.624027300570431],
            [31.667597598398366, 2.61588432242214],
            [31.663741085967878, 2.622618144512653],
            [31.663644906943674, 2.624241919955114],
            [31.66545175135668, 2.624719546754588],
            [31.66549846914136, 2.625961260715289],
            [31.664737184667317, 2.62653435014545],
            [31.657841592578905, 2.626390841579464],
            [31.655844825450192, 2.625483371460307],
            [31.655131986221114, 2.624719200368648],
            [31.654157197356856, 2.624552007229164],
            [31.653157878197117, 2.625507144647528],
            [31.652823114718277, 2.628277099244453],
            [31.652204566254667, 2.6287546392507],
            [31.65058762030285, 2.62880233895038],
            [31.64882757182791, 2.62947087039759],
            [31.64649735006576, 2.629423002017988],
            [31.64431115159982, 2.627369321800377],
            [31.642028253985124, 2.627655754502572],
            [31.640410592974316, 2.628754106212942],
            [31.639935098524756, 2.628658559639367],
            [31.639555301602414, 2.627703383351996],
            [31.639222372483378, 2.627751132447239],
            [31.638317892959776, 2.629088297512546],
            [31.637602948977996, 2.631428394173687],
            [31.63703220436223, 2.631523875027217],
            [31.636176323695498, 2.631332800244454],
            [31.63579637226293, 2.630616407742985],
            [31.63684509786496, 2.62698687031368],
            [31.63670337515414, 2.625601899082584],
            [31.632733023719283, 2.624765930162452],
            [31.62845214804689, 2.626007384736559],
            [31.62716855881213, 2.625386455246195],
            [31.625174228812813, 2.621040402326587],
            [31.618565541558144, 2.618843145960661],
            [31.611646102792214, 2.619057579580085],
            [31.60907615391838, 2.621827321429132],
            [31.600564471972582, 2.620823770476386],
            [31.59975638976381, 2.620346132318291],
            [31.595406311475184, 2.614213363549973],
            [31.594930764923355, 2.614213308809779],
            [31.594502193972644, 2.615025154232153],
            [31.594786706592785, 2.61617133746029],
            [31.594547811321082, 2.617747286537688],
            [31.5931189339622, 2.620851373751442],
            [31.590028282922106, 2.620278015196101],
            [31.586033634753743, 2.62032542177732],
            [31.584367492565384, 2.622713100178484],
            [31.58294079002777, 2.622808470424036],
            [31.582227734304695, 2.622426353159699],
            [31.581610703993917, 2.620802578052579],
            [31.580280178683875, 2.619417509337522],
            [31.57469375176468, 2.617721608069772],
            [31.572506385488882, 2.617530355290995],
            [31.571792830302485, 2.617864579203526],
            [31.57069932637851, 2.617530164149484],
            [31.56737592454325, 2.610175371420248],
            [31.566663240722704, 2.609315678841328],
            [31.56590427030885, 2.606736747441638],
            [31.56233731274218, 2.607309461578681],
            [31.562099122647997, 2.607882513769159],
            [31.562430280289263, 2.610222600701395],
            [31.561383383657155, 2.611177614434332],
            [31.561382799752206, 2.61198946720413],
            [31.560811753302517, 2.612514725409509],
            [31.559576233816937, 2.611320675154609],
            [31.55886405395126, 2.609792403175939],
            [31.555844650092993, 2.609433910061184],
            [31.553705804520654, 2.608000983828118],
            [31.553041224585243, 2.60642496957493],
            [31.553280799881655, 2.603989436607908],
            [31.55266324136148, 2.603129769417178],
            [31.551093333892844, 2.603989186236717],
            [31.550379326853868, 2.604944241494376],
            [31.551615073613245, 2.605803975648047],
            [31.551614756507938, 2.60623378596943],
            [31.550279658773107, 2.611056990956388],
            [31.548472508932893, 2.611200045408717],
            [31.547378177660523, 2.612011768940999],
            [31.546712467644497, 2.611963927712588],
            [31.545572710364834, 2.609910291550453],
            [31.54495447451495, 2.609957971328015],
            [31.54414499093434, 2.611390550735474],
            [31.54219561892002, 2.610960516036105],
            [31.541387023773208, 2.611199188408384],
            [31.540815488639996, 2.612393016228128],
            [31.539555512520803, 2.612130198228554],
            [31.537985812562997, 2.612703060668462],
            [31.53679706116774, 2.612607397107486],
            [31.535276284358623, 2.61136556581409],
            [31.533707132373177, 2.611222091405596],
            [31.5331368234403, 2.610792227151318],
            [31.531709457946032, 2.611794896827211],
            [31.528999609941426, 2.610887197173614],
            [31.5282395965835, 2.609788714032143],
            [31.52624292377789, 2.609072115368198],
            [31.526624228073292, 2.607926041423803],
            [31.526386631765487, 2.60768721946419],
            [31.524247401714188, 2.606827338528181],
            [31.523153251003166, 2.607400252740917],
            [31.522770991798648, 2.609787974588079],
            [31.519133603618783, 2.609238285759798],
            [31.516565207033764, 2.609954251673687],
            [31.516136074636, 2.611434607724223],
            [31.51561284101729, 2.611625544656254],
            [31.513284936010248, 2.608807661639957],
            [31.51314419695469, 2.606324365426161],
            [31.51266956668444, 2.60517816603707],
            [31.512099120309337, 2.604939318429227],
            [31.510909778720958, 2.605607708253498],
            [31.51124120495848, 2.60747022007295],
            [31.510764572343465, 2.608902802315237],
            [31.510098902751643, 2.608807193205369],
            [31.507532610919327, 2.606801098970955],
            [31.50672559950236, 2.605034042111998],
            [31.506774045645628, 2.603887919621199],
            [31.505682752475536, 2.600783686403465],
            [31.505017581448705, 2.600067264785755],
            [31.503401169994426, 2.599589481438478],
            [31.502115918876406, 2.601308462900526],
            [31.501426508608258, 2.601188967393086],
            [31.50157050136177, 2.599469817956084],
            [31.502856309435256, 2.597034514748087],
            [31.502761542562695, 2.596604703086067],
            [31.4998280823243, 2.596209363741661],
            [31.499256557072552, 2.596603510450846],
            [31.499112436758253, 2.597751940474063],
            [31.498006665440748, 2.597212212836406],
            [31.496973004586007, 2.596062385081124],
            [31.494921016220154, 2.595880456518293],
            [31.493671288081757, 2.596345570078078],
            [31.49113475743481, 2.598460250985743],
            [31.489421322539958, 2.598709443154822],
            [31.48877743529712, 2.599929055875056],
            [31.48813453889605, 2.600323108991865],
            [31.485995516355615, 2.598310486185808],
            [31.485925842123834, 2.596874667571498],
            [31.484534261917204, 2.596585830912303],
            [31.484460700675225, 2.598416311998801],
            [31.483068991111214, 2.598235160916307],
            [31.483174010456118, 2.599958178891256],
            [31.482887747019458, 2.600568024729148],
            [31.482423726751023, 2.60060334959362],
            [31.481390644411352, 2.5989868977151],
            [31.48091114796722, 2.597048071658601],
            [31.479769188018473, 2.59693901152762],
            [31.4799490163653, 2.595790646275138],
            [31.48044914711152, 2.595396415854821],
            [31.48241245379255, 2.595111640463009],
            [31.482628262361448, 2.593712055024721],
            [31.48231060100901, 2.590732518849542],
            [31.481990081217308, 2.590157835480787],
            [31.480347268276834, 2.591053184821142],
            [31.4806307226816, 2.592776416295496],
            [31.479061188013823, 2.592092544080542],
            [31.478167291542597, 2.593455410798005],
            [31.477169479755926, 2.592197934279644],
            [31.476992358033026, 2.591085033436125],
            [31.47795856349475, 2.588932594724584],
            [31.478601065535397, 2.588861588075296],
            [31.478672963995788, 2.588430944440577],
            [31.47763867971026, 2.587819503455593],
            [31.47731854799077, 2.586921787181845],
            [31.47656729769847, 2.588392503467529],
            [31.47542625672626, 2.587529690154024],
            [31.473123307816113, 2.588316552120487],
            [31.472694167333543, 2.589033899332121],
            [31.473371329072798, 2.589824370595784],
            [31.473014088847247, 2.590111084658813],
            [31.469053246977957, 2.589496095275555],
            [31.46819578258138, 2.590248804663903],
            [31.468193060686072, 2.592510068337662],
            [31.466336802644232, 2.592830856802148],
            [31.464804864267713, 2.590567715449024],
            [31.4651268114824, 2.589957920425111],
            [31.466161637452043, 2.590102754117312],
            [31.465735961771507, 2.587948649061556],
            [31.464595219039964, 2.58683457068616],
            [31.46284643813365, 2.586832439361458],
            [31.460135102518947, 2.585931798658105],
            [31.459492172880218, 2.586361731503318],
            [31.458244208134683, 2.585391102172084],
            [31.456422345686736, 2.586788702783108],
            [31.455316057837933, 2.586715548535664],
            [31.455064797256348, 2.587899714786036],
            [31.453601519811944, 2.587897919987807],
            [31.452211457758143, 2.586388718122008],
            [31.452284157515777, 2.585312003460179],
            [31.451108492777568, 2.583587702903131],
            [31.45189400481483, 2.583301532088579],
            [31.451716216541985, 2.582762911969573],
            [31.45214553399268, 2.581902014374259],
            [31.45150529480823, 2.580106582694228],
            [31.450042681218815, 2.579566387172754],
            [31.45111419258805, 2.578885735804525],
            [31.450437566244666, 2.577664548523534],
            [31.449938138879332, 2.577484469568458],
            [31.44793746048586, 2.579204869309074],
            [31.44678749205639, 2.578567696157474],
            [31.45480580397678, 2.569933032842405],
            [31.458652456498694, 2.567057775170975],
            [31.461301282844367, 2.563408190803226],
            [31.464042902463955, 2.557546402610072],
            [31.464839612899535, 2.552962614716558],
            [31.465575204658165, 2.536329574200099],
            [31.46625779132342, 2.53261711881462],
            [31.469206478904184, 2.524284703926322],
            [31.47543998567873, 2.510007291471835],
            [31.478007423761344, 2.505387632810339],
            [31.48087424787028, 2.502511283049168],
            [31.485096757303726, 2.500242748139077],
            [31.49050362267573, 2.499175086066752],
            [31.492345123194095, 2.49832797429104],
            [31.495289634507113, 2.495571666316172],
            [31.49698073728399, 2.49546024265129],
            [31.501143851907486, 2.494911814326982],
            [31.50609163684679, 2.496381443624031],
            [31.512613142603115, 2.496506003372062],
            [31.515583415801867, 2.495982353541124],
            [31.519428242947143, 2.494464184454681],
            [31.52187556819142, 2.492944421512682],
            [31.52741371964726, 2.48721187580476],
            [31.529688479423783, 2.483759438138981],
            [31.529866147322355, 2.481065914738353],
            [31.52951826484713, 2.479718664997947],
            [31.52135068796079, 2.467499962778175],
            [31.51908187323483, 2.465623536729097],
            [31.51113961807629, 2.460373615082169],
            [31.504941315379394, 2.457760782350286],
            [31.498538570496876, 2.455762567524188],
            [31.494378078055714, 2.453327687657724],
            [31.490102270678143, 2.449897185580056],
            [31.486386538625712, 2.445622627449717],
            [31.483135970397093, 2.440311076701841],
            [31.480844863079025, 2.434924387458523],
            [31.47951922011258, 2.431122176402582],
            [31.476946705650295, 2.420714797120039],
            [31.47629573519145, 2.392841469496409],
            [31.474315590488764, 2.376788377733409],
            [31.473635378969092, 2.372589974614418],
            [31.471021064100007, 2.364526762258512],
            [31.46864888292923, 2.359218725053406],
            [31.466557027331092, 2.35577815183504],
            [31.462480893881622, 2.350089147088455],
            [31.457640100089254, 2.345116992085136],
            [31.452166833946393, 2.340940916350303],
            [31.44549193277047, 2.336700866557859],
            [31.434325197357452, 2.330879489362458],
            [31.40913005875221, 2.321189408365948],
            [31.402115165004172, 2.317526623039442],
            [31.40123558588195, 2.316563374295807],
            [31.3962380172079, 2.313395534055451],
            [31.389134329485596, 2.308654773813013],
            [31.377494797263832, 2.2994692039422],
            [31.36786445676946, 2.290434957474834],
            [31.357553633464203, 2.279434173608334],
            [31.3503967843417, 2.270991725462645],
            [31.343273940944297, 2.261068440789069],
            [31.33882583040702, 2.25297746933848],
            [31.336513839953565, 2.247427379098311],
            [31.3454016051863, 2.24510529500272],
            [31.347497010028164, 2.246182120535643],
            [31.350345778898173, 2.245707844996653],
            [31.353203718668954, 2.246488381199026],
            [31.35695239643443, 2.244765152261321],
            [31.36030709647249, 2.246339405083713],
            [31.365653823229476, 2.246541725249152],
            [31.368113034083283, 2.24619114615563],
            [31.37022024278798, 2.246507597552227],
            [31.371430346239215, 2.246312650473707],
            [31.37377339774028, 2.24513744885347],
            [31.375687723780395, 2.243412077483142],
            [31.38021727558133, 2.241414799120074],
            [31.381115856766755, 2.240591305096532],
            [31.38693298901725, 2.238948775083717],
            [31.387910472827365, 2.237340119804843],
            [31.388925817931753, 2.23679158489312],
            [31.395912840549776, 2.236053323749661],
            [31.39794329360331, 2.235191790464743],
            [31.40192209279511, 2.237198524872225],
            [31.40305144129557, 2.239516219541785],
            [31.40496532356796, 2.238183407499047],
            [31.40866579054878, 2.236824668871981],
            [31.41443469135331, 2.235870779647235],
            [31.41757381548612, 2.236351836385167],
            [31.41959950028213, 2.235848300264261],
            [31.424832405102755, 2.237223477206661],
            [31.427993461603194, 2.237540983462657],
            [31.431468326581857, 2.236406113443321],
            [31.433969407012743, 2.233424853264738],
            [31.439629974587316, 2.232253038851063],
            [31.44607246273462, 2.229825615682389],
            [31.45230102069029, 2.228372473033172],
            [31.453325236658078, 2.228275983447285],
            [31.4547122192871, 2.228821559339929],
            [31.46404671311737, 2.227076681090624],
            [31.46686647089532, 2.227199466124164],
            [31.47042348501008, 2.228099214667583],
            [31.473487002436983, 2.230410938266587],
            [31.478089135417925, 2.234824374463043],
            [31.484748060954832, 2.242895486007782],
            [31.490618112958703, 2.247013641560051],
            [31.49806614738729, 2.249058329222523],
            [31.501776643159904, 2.248967927782441],
            [31.503100840737087, 2.249537238100549],
            [31.512233470546608, 2.250758689755914],
            [31.52559358555793, 2.256665874141834],
            [31.529373283048482, 2.260327957760846],
            [31.53206063364511, 2.265993651687761],
            [31.53529280527504, 2.271396204509203],
            [31.53762450476585, 2.2734092440674],
            [31.54063535935754, 2.27462641916561],
            [31.54385025818118, 2.276621678023422],
            [31.547252288654914, 2.279807960300287],
            [31.55119934048626, 2.282635790583112],
            [31.554225663168836, 2.284250192366533],
            [31.556401843622712, 2.284865481887614],
            [31.559667421801436, 2.285097419297307],
            [31.568164655244185, 2.284628157037837],
            [31.571617642652438, 2.285908108902892],
            [31.573842783984244, 2.285665499153187],
            [31.579524877887927, 2.284558318274312],
            [31.588596319850186, 2.280751901260909],
            [31.59124965484029, 2.279316997621997],
            [31.598975396252413, 2.273678377508781],
            [31.603025614204252, 2.271930925638508],
            [31.607854740677688, 2.271349470470712],
            [31.61026774398993, 2.27191657466334],
            [31.611780881525863, 2.272771378384208],
            [31.619304100452155, 2.274376739751393],
            [31.622120289223464, 2.274490275443155],
            [31.62420378869283, 2.274057219225714],
            [31.626525432442367, 2.272813517518221],
            [31.63279117795585, 2.26303137639905],
            [31.635755607613643, 2.259665642414369],
            [31.637887871229918, 2.258422287391156],
            [31.64451495059169, 2.258265983448481],
            [31.647732582090434, 2.258879037302401],
            [31.649529513594302, 2.259876213415604],
            [31.65361422146313, 2.265324706464884],
            [31.658766844745116, 2.269174532263148],
            [31.666379928437475, 2.273591265541144],
            [31.66900572557253, 2.274324641706031],
            [31.67690923729119, 2.275166464601384],
            [31.677854605431573, 2.275927071556606],
            [31.681592938198243, 2.276586685741635],
            [31.68672522452051, 2.278649352917896],
            [31.687387830857226, 2.2786956603575],
            [31.690420446238342, 2.276926150513197],
            [31.693972656162998, 2.275775117511544],
            [31.69506147267782, 2.275725233015062],
            [31.696101935575882, 2.276247342067002],
            [31.696904473382734, 2.277484812327225],
            [31.69751388867485, 2.280867286411201],
            [31.69637027313102, 2.285158834947742],
            [31.696794445930077, 2.28620642278657],
            [31.698212849831105, 2.287156698392535],
            [31.698495030424784, 2.288204595341989],
            [31.69915656147811, 2.288870458360519],
            [31.70344138255122, 2.288361308040385],
            [31.705337035311544, 2.28711831433797],
            [31.707940547939334, 2.287112988879063],
            [31.70950123060831, 2.287919993598895],
            [31.716787340113687, 2.29004967173038],
            [31.7217803408545, 2.290635153142197],
            [31.72395508759718, 2.292203411258446],
            [31.727266116936008, 2.293674016442373],
            [31.732614484016725, 2.29409193149399],
            [31.734458137796832, 2.295517880312425],
            [31.73689399245327, 2.296680506059029],
            [31.740304532667675, 2.295386675340494],
            [31.741392953923803, 2.295575049894744],
            [31.74233878918815, 2.296097354582563],
            [31.74266874398527, 2.296906858523576],
            [31.744417263481825, 2.298618973196283],
            [31.746877253174986, 2.299519390998978],
            [31.750353065876283, 2.301543149627067],
            [31.751163410042945, 2.303062637800514],
            [31.75113033856577, 2.306036285538994],
            [31.751868822001256, 2.307229680070472],
            [31.754297363472958, 2.309639280059734],
            [31.757248224078396, 2.310854067293874],
            [31.76068767207866, 2.313131161686795],
            [31.76349744418391, 2.316209093591017],
            [31.76515536768575, 2.321426007267737],
            [31.76912122484927, 2.327118011252781],
            [31.77261996884481, 2.329096481128686],
            [31.77541713848494, 2.331326525044461],
            [31.77615484577603, 2.331588421198537],
            [31.780484308627205, 2.331416314529344],
            [31.784791761855587, 2.33322666879888],
            [31.78530431001399, 2.334432263488957],
            [31.78492557759525, 2.336582315729105],
            [31.78416519143647, 2.337562471743894],
            [31.78433315483506, 2.339186430296169],
            [31.788177716078994, 2.342084052748965],
            [31.792508287451216, 2.343082298915586],
            [31.796233352101122, 2.345335153714067],
            [31.797971575107915, 2.347124541826946],
            [31.799234750127834, 2.34972655534644],
            [31.80150816961796, 2.351407834051287],
            [31.80410395493768, 2.354438253451961],
            [31.808448624469982, 2.357812999726863],
            [31.810852487424192, 2.359028370920934],
            [31.814564034225715, 2.359382371550694],
            [31.820074914626137, 2.3632573632896],
            [31.82464437677851, 2.365210664101002],
            [31.828475042881642, 2.365707815153218],
            [31.833219591174462, 2.369187155771531],
            [31.839167686115236, 2.36456084673555],
            [31.841534735210793, 2.364474492510884],
            [31.842557316244797, 2.364043369338447],
            [31.84979666484637, 2.358863709248323],
            [31.85131961018858, 2.359267968447328],
            [31.853962035139535, 2.361104033855797],
            [31.854915602203498, 2.363204816150774],
            [31.85444149654938, 2.365044536564431],
            [31.85470414327721, 2.366071307460666],
            [31.856940836943558, 2.366498600160596],
            [31.85805887834956, 2.366377864536189],
            [31.85944987195628, 2.365576078192755],
            [31.868710282623432, 2.359199628697428],
            [31.871398756114132, 2.359387495685055],
            [31.87385045256062, 2.360746070968519],
            [31.88211985348439, 2.363065015351206],
            [31.887091898326275, 2.36286797229428],
            [31.889504342886394, 2.360464548994412],
            [31.89107385958786, 2.35976998367422],
            [31.893191861550687, 2.360436219527125],
            [31.896475242541715, 2.360718892169792],
            [31.898284678594315, 2.362125959988525],
            [31.900105083974864, 2.362565645502028],
            [31.905455319551383, 2.359788409549927],
            [31.90894016032128, 2.359270622513975],
            [31.91084432102564, 2.360199846213237],
            [31.91332239739873, 2.364161860391827],
            [31.91651122801116, 2.365797443562093],
            [31.916604430018516, 2.368537400405859],
            [31.918463772875057, 2.369968225540659],
            [31.921771100256585, 2.370165735210321],
            [31.929598096174306, 2.373342446688313],
            [31.930011482901744, 2.373407740372044],
            [31.933333507619647, 2.371318245822727],
            [31.935724277628594, 2.37055343587076],
            [31.937686942912496, 2.372075284402723],
            [31.94074836456983, 2.372870299493778],
            [31.94207933724089, 2.372585450986584],
            [31.943732429603116, 2.373457342279877],
            [31.94475305859803, 2.373523098193684],
            [31.945475610411957, 2.37479709664058],
            [31.94506121307982, 2.376057227771665],
            [31.944363227493948, 2.376459514541255],
            [31.944659744301237, 2.377304373908259],
            [31.945189118803242, 2.377759582075098],
            [31.948147252169214, 2.378489537404952],
            [31.950109660534938, 2.380388215752133],
            [31.951195015840984, 2.38029808656416],
            [31.952499312141374, 2.381130723577534],
            [31.95455321302044, 2.381652067461852],
            [31.95593490906401, 2.382653687757883],
            [31.956475985020873, 2.384733199783424],
            [31.95701860158846, 2.384772597182664],
            [31.958180306507135, 2.386241846966128],
            [31.95998842473126, 2.387178820708592],
            [31.96023277277675, 2.388686354956848],
            [31.960800830531493, 2.389258541299132],
            [31.962855833643438, 2.38833750201533],
            [31.963656544277, 2.388792913864755],
            [31.965607328442918, 2.389015298699545],
            [31.968358419898863, 2.390238856682447],
            [31.969894355778365, 2.392345113566256],
            [31.973110726042453, 2.393387095247378],
            [31.973936733234403, 2.394583206427332],
            [31.97636638592212, 2.393727401508462],
            [31.977322073010164, 2.394286880298713],
            [31.977372982333975, 2.39532647486783],
            [31.97620928495196, 2.396495101100627],
            [31.97584652907056, 2.39782026163967],
            [31.976569197665512, 2.398990306529947],
            [31.978687381986312, 2.400005466833453],
            [31.979254177608105, 2.402292917370039],
            [31.979008226968133, 2.402916466996508],
            [31.97787137753504, 2.40272069425612],
            [31.976876160082917, 2.403187744917119],
            [31.97578974117158, 2.404668291835526],
            [31.980195241021637, 2.405152407350003],
            [31.98122796762846, 2.406374663855312],
            [31.98337494654739, 2.4034265305821],
            [31.985791400288644, 2.402973531659829],
            [31.988103427573055, 2.40396283939477],
            [31.989458417601515, 2.406211898925643],
            [31.991292242914103, 2.407408759084049],
            [31.991627104309302, 2.40886439340359],
            [31.99231172835364, 2.409085810139239],
            [31.993113238487787, 2.408488658550155],
            [31.9937720602222, 2.408658077433165],
            [31.99693582334663, 2.411064413326808],
            [31.996960559356307, 2.412571796481105],
            [31.998252405006816, 2.412858634558718],
            [31.997992945501625, 2.414287841019679],
            [31.997449823182507, 2.414911176033728],
            [31.99750091486429, 2.4157168745518],
            [31.995949918729053, 2.416430420089976],
            [31.995315527577066, 2.418171214124451],
            [31.995470144705482, 2.418756083455562],
            [31.99615463040924, 2.41917241723998],
            [31.996657424660295, 2.420680156682759],
            [31.998981466911616, 2.422955930828826],
            [32.000543063167235, 2.425413059321109],
            [32.002170517611276, 2.426167951632038],
            [32.00394102606938, 2.425662477475995],
            [32.00492213368332, 2.426845708857515],
            [32.00639200296529, 2.427173172369972],
            [32.008009212123525, 2.428371056051687],
            [32.008959825526865, 2.429999268451149],
            [32.00862566391924, 2.431387175115122],
            [32.00734094190894, 2.431099027908463],
            [32.00771970307376, 2.43377989319057],
            [32.007338593712795, 2.434306154104906],
            [32.00747995440251, 2.436220963602893],
            [32.00671725059032, 2.437943648378489],
            [32.00557454054833, 2.438660796423046],
            [32.00493045387951, 2.440838302568027],
            [32.004739311251676, 2.441891254855687],
            [32.00568891764357, 2.444907621857682],
            [32.00502144333631, 2.446534612505841],
            [32.001593776740975, 2.448015951135758],
            [32.00003067401065, 2.447178337200264],
            [31.999344090740674, 2.448693151683245],
            [31.99987973907661, 2.449785976170545],
            [31.999714076263484, 2.450781161439141],
            [32.00090136969305, 2.451150755541692],
            [32.00218684269492, 2.450481584319035],
            [32.00260976503912, 2.457757773967385],
            [32.004797020822146, 2.460392127549944],
            [32.00558084133174, 2.462331364340467],
            [32.00500925140127, 2.463001071706518],
            [32.00324817255872, 2.463239091096544],
            [32.00315203036544, 2.464531437806936],
            [32.00357979552732, 2.465297656791312],
            [32.003294020774185, 2.465584637992793],
            [32.00029740717471, 2.464006021632596],
            [31.99948982802248, 2.465392440057865],
            [31.99781367950015, 2.466672463134322],
            [31.99669349022233, 2.464762954650273],
            [31.995931771861983, 2.464429496143215],
            [31.994861512744265, 2.464860787606052],
            [31.995531508622513, 2.468657884154142],
            [31.995392364076597, 2.472288808782007],
            [31.99481046507994, 2.473328581029689],
            [31.995073018382975, 2.474164285756122],
            [31.994573959326885, 2.474762074984959],
            [31.994361364031736, 2.476314940732603],
            [31.993363299818476, 2.477582175917484],
            [31.993209913382017, 2.478860291770189],
            [31.995422956203583, 2.479120289262859],
            [31.99809122478698, 2.482532716279552],
            [31.998525919552932, 2.483880994346466],
            [31.99676611002989, 2.484066569853813],
            [31.99586131250268, 2.484783889629341],
            [31.994005429058294, 2.484495263033055],
            [31.993314323669193, 2.485835022106628],
            [31.991362582797468, 2.486431865512964],
            [31.98833855351381, 2.488942572755429],
            [31.987529427462675, 2.489013748234892],
            [31.987524303472295, 2.490384135057526],
            [31.98679546614631, 2.491020055682752],
            [31.98655588096847, 2.492040647814711],
            [31.98583958951374, 2.491883974521959],
            [31.98593420097778, 2.493072951971478],
            [31.985049667646763, 2.494321215728363],
            [31.98501276934645, 2.495726256157621],
            [31.98548983315281, 2.496435166641233],
            [31.985083219722622, 2.497275489439082],
            [31.985644319127186, 2.497396016805277],
            [31.985333097796968, 2.4984045421082],
            [31.983900823907994, 2.497682880651563],
            [31.98295696314063, 2.498438720129402],
            [31.98248029818629, 2.497213418262998],
            [31.981262497969656, 2.497080368588875],
            [31.981000619301412, 2.49603537027124],
            [31.979520369986343, 2.495601886597958],
            [31.978480886251955, 2.496489748527991],
            [31.97677430370613, 2.495371566085792],
            [31.975579979162845, 2.495766930984483],
            [31.974386045386698, 2.495657912537701],
            [31.97414654285386, 2.496558406216582],
            [31.972928887266022, 2.49624521325734],
            [31.96981160566934, 2.49739562999913],
            [31.96741239239504, 2.496421000192047],
            [31.96800457261011, 2.496233325464337],
            [31.967226817525347, 2.495790377209846],
            [31.9667528466185, 2.496232336460272],
            [31.96587988897821, 2.495575478740296],
            [31.96451873021869, 2.497025995835366],
            [31.962806912291377, 2.496989223213778],
            [31.961371117904775, 2.498132669617587],
            [31.95924343749309, 2.498230503693915],
            [31.95785755080873, 2.498826573253268],
            [31.9533558225271, 2.497728150422472],
            [31.952811830638826, 2.497379363499062],
            [31.953257535156908, 2.496882075180034],
            [31.953556103716334, 2.494742438672445],
            [31.95296692297597, 2.488969280500399],
            [31.95163288794814, 2.486579517193576],
            [31.947381641408747, 2.48164943103377],
            [31.945999836669067, 2.477119759637064],
            [31.94481405690077, 2.474978939625652],
            [31.94427275367011, 2.471246175451374],
            [31.943334092351655, 2.469453906107051],
            [31.94353290749033, 2.468309483551253],
            [31.94240727621849, 2.4665336862395],
            [31.94088092626138, 2.465017109591058],
            [31.940357844457946, 2.464953551564511],
            [31.93939626531993, 2.463711032730299],
            [31.93860135510817, 2.463394697078827],
            [31.935147985017622, 2.464275878210107],
            [31.934374204079653, 2.463706998535572],
            [31.932553893920527, 2.463474019505409],
            [31.93124731500105, 2.462315266136616],
            [31.931759672716602, 2.461832863806877],
            [31.92985460381547, 2.460091472907435],
            [31.929448832106694, 2.458730453270312],
            [31.9284378842556, 2.458982480519805],
            [31.927581077425828, 2.458696876438431],
            [31.92598503616897, 2.456644600031026],
            [31.924890578234137, 2.456645909468467],
            [31.924581704201774, 2.457100114558196],
            [31.924127862743816, 2.455213666847913],
            [31.922462502988058, 2.455335093736276],
            [31.921176960815874, 2.454548398154187],
            [31.91996427201326, 2.455314196565901],
            [31.919035165176133, 2.454049343653803],
            [31.91836927100547, 2.454360667237544],
            [31.914942990510628, 2.454173666852482],
            [31.913216523755985, 2.452563413845247],
            [31.91259680568585, 2.45136986686221],
            [31.910550235059496, 2.450918481545338],
            [31.90926376313102, 2.449128577601679],
            [31.909834044216083, 2.448339672327318],
            [31.90871576745148, 2.448293220664767],
            [31.905981670324124, 2.450446189854902],
            [31.905540751131507, 2.449622657330885],
            [31.902756856794685, 2.449410973389209],
            [31.902256836541238, 2.449005515812],
            [31.901543748478797, 2.449722929888142],
            [31.90042530732252, 2.449509271474495],
            [31.899379167071874, 2.450274860962217],
            [31.898427282552408, 2.450061006085438],
            [31.898118807372057, 2.450945145180171],
            [31.897095629856715, 2.450826911175442],
            [31.895298333636823, 2.449766120904381],
            [31.894465606148252, 2.449767106353116],
            [31.89499018903651, 2.451008545914957],
            [31.893824854924084, 2.451535406784199],
            [31.892943130624925, 2.45000775237452],
            [31.892231652343483, 2.452468816345776],
            [31.89168466996364, 2.452732186386854],
            [31.890066085484712, 2.45194586891281],
            [31.889781000637722, 2.452423913001032],
            [31.88897222582785, 2.452592067187972],
            [31.88797231916992, 2.451900557191269],
            [31.887709900614183, 2.451136526681753],
            [31.884152841583667, 2.450985429175614],
            [31.883890997949713, 2.450842427941955],
            [31.884318157647083, 2.449647645369545],
            [31.88303289395263, 2.449099769815717],
            [31.881748729796126, 2.449770070776768],
            [31.880344926213425, 2.449700059937545],
            [31.87915584154318, 2.450274699413312],
            [31.877977353400055, 2.449404239487721],
            [31.87683587854154, 2.450002721022413],
            [31.876669771062385, 2.450480612333227],
            [31.875836962725412, 2.450386041611338],
            [31.87497964565252, 2.449503282493919],
            [31.87390929131341, 2.44981503434264],
            [31.87326656020234, 2.449433614483643],
            [31.872908856446113, 2.448526371071661],
            [31.87200459341648, 2.448360232148409],
            [31.871908071235854, 2.446855562586754],
            [31.871193748888203, 2.446235358432559],
            [31.869292197789736, 2.448220067617215],
            [31.868007151487582, 2.447911043783769],
            [31.867079463988635, 2.448127081712575],
            [31.86684221532884, 2.448867806894361],
            [31.86765270232761, 2.450586628786232],
            [31.86782078699875, 2.452282295854716],
            [31.867872160751553, 2.456462172676203],
            [31.86932390472602, 2.456938215542687],
            [31.868826006293247, 2.458849632528391],
            [31.869373826801286, 2.459517788092211],
            [31.871277308379312, 2.459635016141769],
            [31.872086760518894, 2.460207324161073],
            [31.873347328627865, 2.459752049426229],
            [31.874299687457803, 2.46049139860102],
            [31.874775079499393, 2.459989234733136],
            [31.87520357229666, 2.460251487714634],
            [31.875775460467793, 2.4612062468791],
            [31.875585708432006, 2.461851379844325],
            [31.87657606779509, 2.46513448703662],
            [31.877337043248662, 2.46470365607186],
            [31.877884947300032, 2.465467354822751],
            [31.877814244497277, 2.466207900760376],
            [31.879480250141746, 2.466803098947891],
            [31.878506135912275, 2.468309021348114],
            [31.879353381972468, 2.471186246233825],
            [31.880139270403856, 2.471997443046848],
            [31.880141463191467, 2.474409877858584],
            [31.879737684844283, 2.475174686593008],
            [31.88011949758614, 2.476416286457187],
            [31.880785601962558, 2.47631997557525],
            [31.881284719409155, 2.475746138909932],
            [31.881571056507642, 2.476653466098141],
            [31.88304569314881, 2.476102390480301],
            [31.88373622092118, 2.476698725821052],
            [31.885854111492925, 2.477078442540108],
            [31.887080639740823, 2.478402667555175],
            [31.88793707556639, 2.4783061153969],
            [31.88907966433584, 2.478901933697348],
            [31.889795741093188, 2.481409095875844],
            [31.891496900509672, 2.481395175172776],
            [31.891631383697614, 2.485348080850254],
            [31.89079904787447, 2.485802875630205],
            [31.890680649021697, 2.486424044065888],
            [31.892360823793148, 2.489467505175929],
            [31.89328887331316, 2.489609738506069],
            [31.894217578603357, 2.490468535529855],
            [31.895597702595165, 2.490610241938989],
            [31.895921406914546, 2.493344771660682],
            [31.895375763922743, 2.495089070588005],
            [31.894852772849177, 2.49559128127417],
            [31.8950280512291, 2.49719474925434],
            [31.895790988603277, 2.498507062707225],
            [31.89478235032079, 2.500287045872433],
            [31.895045273729718, 2.501241788698426],
            [31.89333303000095, 2.501601938223822],
            [31.891171897226393, 2.504326387260243],
            [31.889864614926054, 2.505139723863377],
            [31.890402464134407, 2.507132787157979],
            [31.889477141899583, 2.508972352254582],
            [31.889645377487696, 2.510285364695025],
            [31.890264367922406, 2.510666670084083],
            [31.890382594298643, 2.510117369515039],
            [31.891643607073682, 2.510306911649641],
            [31.892309206596927, 2.509947980568231],
            [31.893976534561492, 2.511593520599163],
            [31.893991709801558, 2.514088599954236],
            [31.895896237018572, 2.51520857028848],
            [31.89658748074826, 2.516258334012265],
            [31.8959603246276, 2.518730293378209],
            [31.897437052546746, 2.52013727390296],
            [31.90279229443432, 2.522303785931737],
            [31.9026505007566, 2.523020250153411],
            [31.904007071819983, 2.523496203459528],
            [31.90585452457541, 2.526418915487077],
            [31.905047664075425, 2.527900215560509],
            [31.905073466385353, 2.529428293006249],
            [31.906027643405412, 2.531432813536808],
            [31.907290041382613, 2.532649032601078],
            [31.910044641658015, 2.533648237681759],
            [31.913385531895234, 2.538326462140021],
            [31.913975235455045, 2.540044202383985],
            [31.912443014109236, 2.540898622629775],
            [31.91154016053628, 2.544367428116272],
            [31.91123656500456, 2.548666420499411],
            [31.911234470133326, 2.55115545791424],
            [31.912430973989476, 2.555229451094526],
            [31.912205096204538, 2.556285214812243],
            [31.910545222460225, 2.558170678655641],
            [31.910537189724945, 2.559792968967315],
            [31.90887051393728, 2.564495541300246],
            [31.908023656847593, 2.566003811571665],
            [31.907599226232037, 2.568893388037278],
            [31.907839551621688, 2.570755486254765],
            [31.90532319444106, 2.57484129335424],
            [31.904390385646657, 2.580131026201224],
            [31.90597708711953, 2.583746509872927],
            [31.90635787757856, 2.583865438074712],
            [31.90748116424751, 2.587851546887505],
            [31.90649694846264, 2.590204520791014],
            [31.904287655209092, 2.592642475498904],
            [31.903243502031852, 2.596333640133745],
            [31.90359005140722, 2.596971908149058],
            [31.903277465536117, 2.598584604332023],
            [31.903767693254636, 2.599162813309901],
            [31.90359897347462, 2.600498782105017],
            [31.90443616828513, 2.601233776751437],
            [31.904662143986414, 2.602895092482596],
            [31.90396003423507, 2.606061016700145],
            [31.903204820575702, 2.606482098958363],
            [31.90324598856855, 2.607367797905173],
            [31.902491030929067, 2.607493658877063],
            [31.902071158365246, 2.60808373168076],
            [31.901064729938383, 2.608040673363847],
            [31.900435065721457, 2.608757084164885],
            [31.90085358272749, 2.609727463116025],
            [31.900517690066327, 2.610191085498768],
            [31.899721787216166, 2.609178200518676],
            [31.897038837466116, 2.608079303086882],
            [31.89316134128893, 2.607825158308316],
            [31.892841933611535, 2.608939320466851],
            [31.891938532066284, 2.60941786753071],
            [31.891939348634875, 2.610062543415389],
            [31.890630724251476, 2.609920766707621],
            [31.89077412681186, 2.610445878607097],
            [31.8898698503075, 2.610232007969946],
            [31.890108284743498, 2.610661513462709],
            [31.889490116267226, 2.610948742374747],
            [31.889585973694565, 2.611497782544868],
            [31.88872996277213, 2.611833030182592],
            [31.88944416654213, 2.612614936009818],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1789,
        District: "NWOYA",
        County: "NWOYA",
        Subcounty: "PURONGO",
        Population: 31478,
        Key: "NWOYAPURONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.565199038911885, 0.073414387772736],
            [31.541218639064773, 0.097743008388865],
            [31.53221774000515, 0.108170751239717],
            [31.527894412647356, 0.11105568100334],
            [31.515867298703007, 0.117603126947912],
            [31.508297383551604, 0.122332864228817],
            [31.500807273831768, 0.126022480776291],
            [31.5005612576148, 0.127514764761862],
            [31.497905942737823, 0.128690352899887],
            [31.496097591850056, 0.130372467326888],
            [31.493579577277746, 0.131294820919947],
            [31.490020348815804, 0.1359252247664],
            [31.488601154397365, 0.136820507497111],
            [31.487502495041944, 0.138783022476069],
            [31.483439303620763, 0.13962386286327],
            [31.481813995251926, 0.141333099284859],
            [31.47904441107757, 0.142834241492642],
            [31.47347035306151, 0.142942391130019],
            [31.473241495564775, 0.143765389983055],
            [31.472532028611266, 0.144371299031778],
            [31.471181383733835, 0.144669659131213],
            [31.469601887647848, 0.145709622820236],
            [31.468011236282702, 0.145628110853116],
            [31.46581355914405, 0.146622810335587],
            [31.463913822642457, 0.146550322817604],
            [31.461670393408102, 0.147499792234513],
            [31.458087941699432, 0.147237261359439],
            [31.45719517710544, 0.147598959624864],
            [31.45600503062656, 0.149145406896167],
            [31.454746170214932, 0.149796486530576],
            [31.453258156760885, 0.151406216144815],
            [31.45126685408405, 0.15210246104846],
            [31.446471297652774, 0.156587929716994],
            [31.44507495008695, 0.156289374846847],
            [31.44196183038499, 0.157139272249582],
            [31.43899766932342, 0.159481430867755],
            [31.43744122580428, 0.160241005586244],
            [31.434122044254256, 0.161262710334813],
            [31.43158116845628, 0.16081936025567],
            [31.428719917495375, 0.161235154622576],
            [31.42484303037592, 0.161008751320107],
            [31.419642864655845, 0.163404967194949],
            [31.41754144020329, 0.165403490387414],
            [31.415190858125193, 0.169138418791563],
            [31.414395328075898, 0.17182438038068],
            [31.41418176978676, 0.17423907319222],
            [31.4117716806093, 0.177793096213815],
            [31.408507035780165, 0.184575688543525],
            [31.40843576883543, 0.187252657590488],
            [31.41037099507896, 0.19163910265237],
            [31.41041847194005, 0.194225647609761],
            [31.409801279932495, 0.195753997349187],
            [31.40648897768091, 0.198421606058014],
            [31.40420940023952, 0.199045405913593],
            [31.397928868456486, 0.199732108992947],
            [31.394319602934885, 0.202074083389505],
            [31.39170759314282, 0.203249512602552],
            [31.389178747583145, 0.203809964378991],
            [31.385070874858062, 0.203782416816762],
            [31.38071387684679, 0.205039046799041],
            [31.37665326269218, 0.206983019050474],
            [31.371298926306412, 0.207642647645633],
            [31.367523506593237, 0.207235287690342],
            [31.359984623743365, 0.205027849370717],
            [31.357871345122312, 0.205000497642058],
            [31.348361704066118, 0.206762996122105],
            [31.34546494090542, 0.206762687103682],
            [31.339873112416416, 0.205586435296267],
            [31.33794961457723, 0.205613359428625],
            [31.336881166463126, 0.205875509494539],
            [31.333806216177603, 0.208036576068871],
            [31.330790960739332, 0.208542686250581],
            [31.328250185552662, 0.208470062432326],
            [31.321732359295712, 0.206904841876173],
            [31.318360736794368, 0.203558408044593],
            [31.312650378298546, 0.201088951131993],
            [31.310109639942826, 0.200871639221911],
            [31.3022778595979, 0.201892711067389],
            [31.297703401914227, 0.201295363847068],
            [31.296171926170118, 0.200354695182349],
            [31.29465232884895, 0.198582044204892],
            [31.293916185524772, 0.196954170063713],
            [31.293583781021876, 0.194611918263178],
            [31.295044009584196, 0.189439290704486],
            [31.294854053630857, 0.18855302664997],
            [31.293868584696177, 0.187395383854943],
            [31.293133902930972, 0.184774739803462],
            [31.29561293421321, 0.180497300359643],
            [31.295790278718293, 0.17728905482606],
            [31.293312372126753, 0.169446412927117],
            [31.29278186035763, 0.162316905168939],
            [31.29304830875574, 0.151622736320649],
            [31.290418739594806, 0.142190308631013],
            [31.291412389486794, 0.129635579399575],
            [31.292516247392747, 0.123983591106581],
            [31.29454590723388, 0.117852357709167],
            [31.297644041240265, 0.110039115184047],
            [31.30332691128837, 0.097695267492555],
            [31.30705400523252, 0.084853870420549],
            [31.307766061130696, 0.081073770854997],
            [31.308940053205813, 0.065446856285171],
            [31.30866639492926, 0.05567095106805],
            [31.309081427370284, 0.050832752803038],
            [31.309912139039405, 0.047893675591979],
            [31.310956993800875, 0.04648293390052],
            [31.311300904824225, 0.04500886905775],
            [31.31701078990788, 0.038443486835971],
            [31.319622360423768, 0.034618170978584],
            [31.32471492593914, 0.028957064390111],
            [31.326151110194555, 0.026189789206708],
            [31.32672071844149, 0.024019360874085],
            [31.32824026545698, 0.021478168171309],
            [31.32829925333012, 0.018385302073258],
            [31.326304506512482, 0.01585311130069],
            [31.326790739422943, 0.01239851152203],
            [31.32657684875715, 0.010029120564087],
            [31.325270688452584, 0.007921990038811],
            [31.320319717188937, 0.004539715335306],
            [31.315440052395925, 0.002812401472952],
            [31.310548887370675, 0.002450655298305],
            [31.309504070338416, 0.001166492040766],
            [31.30390209537829, -0.000909090575899],
            [31.296632961336865, 0.004833841724636],
            [31.29246565697088, 0.009029189665507],
            [31.291350467715937, 0.009501899331485],
            [31.286831032741752, 0.009265513057543],
            [31.279611671655264, 0.012692643295209],
            [31.27556179146997, 0.015115263899365],
            [31.27074886251943, 0.020965026261722],
            [31.26922282068442, 0.022028608127041],
            [31.263236070338646, 0.024746610811109],
            [31.258892768940527, 0.025573787529789],
            [31.253912920433752, 0.018235935605337],
            [31.254725752933744, 0.007197212205922],
            [31.256486561383422, 0.001997431881625],
            [31.261182007762798, -0.005329550961099],
            [31.26059507191235, -0.007811273579391],
            [31.258364732928296, -0.008874861796506],
            [31.251204204306422, -0.006865833581569],
            [31.247917405225728, -0.008638473725527],
            [31.245217532114058, -0.011711050613272],
            [31.24510012500135, -0.015492691950826],
            [31.243926252402147, -0.018210736964598],
            [31.24329543923997, -0.018190023611803],
            [31.2439262254527, -0.021224231526103],
            [31.243926202994807, -0.023351403330301],
            [31.243221863624935, -0.025833095193614],
            [31.24439567154544, -0.029142045449609],
            [31.24239995724226, -0.039186989886653],
            [31.240873890254438, -0.042259536402358],
            [31.241460789273976, -0.043441309353977],
            [31.24357367892448, -0.045332175322974],
            [31.245217055108633, -0.046041271046847],
            [31.25261236112499, -0.045096028969549],
            [31.256133883701192, -0.047341472394376],
            [31.25817533482876, -0.049191250231661],
            [31.258012037279755, -0.048286933630333],
            [31.257425111310774, -0.048109653866702],
            [31.257659929129424, -0.04615973723489],
            [31.2591273307393, -0.042732632219974],
            [31.259127378350012, -0.040369088972334],
            [31.26446858675623, -0.032864922156128],
            [31.270866169919096, -0.03209686810151],
            [31.273331293484137, -0.032215084577657],
            [31.27585512554621, -0.031565142790494],
            [31.281313628775703, -0.031978851949516],
            [31.29501506496742, -0.034179292837408],
            [31.2958876219591, -0.039340663747933],
            [31.294325870294937, -0.041742650418351],
            [31.29105367243091, -0.04453765252944],
            [31.285401670292565, -0.050427121389812],
            [31.28351751686622, -0.058013660056268],
            [31.284145316180606, -0.060427157949181],
            [31.285756337743166, -0.061340658737407],
            [31.289269027185178, -0.065392160598118],
            [31.290795212750616, -0.066594971626332],
            [31.295641325467773, -0.069299084681071],
            [31.2974929050836, -0.069262979619558],
            [31.299518478488533, -0.070610500050894],
            [31.301726488947867, -0.07277193206893],
            [31.302756089417485, -0.074336478000981],
            [31.30451391007053, -0.074517407529696],
            [31.305067147419724, -0.075774463043033],
            [31.30509881752506, -0.077230440377846],
            [31.30624018458569, -0.077528919731858],
            [31.307851138774605, -0.079039217181695],
            [31.31081951922303, -0.083425381775841],
            [31.314049324690505, -0.085722542134499],
            [31.321723475855883, -0.093138501261849],
            [31.32627720311773, -0.088119584117171],
            [31.330335074715776, -0.085705152566678],
            [31.332884929175037, -0.083218306847084],
            [31.34096112493907, -0.077674952425435],
            [31.344727111443422, -0.073976275433329],
            [31.34628850108655, -0.073017723508162],
            [31.353720553587905, -0.073235036578174],
            [31.358733275942463, -0.071225511376117],
            [31.36239924132816, -0.070354234250415],
            [31.370255690309083, -0.071028961041709],
            [31.37431160268152, -0.070368912711086],
            [31.37711489074701, -0.070712672556963],
            [31.382525511975214, -0.072385932589262],
            [31.386280185995222, -0.073055302700908],
            [31.39220349551901, -0.073037423546341],
            [31.39384041730785, -0.072784252453116],
            [31.39894326134668, -0.070396861075128],
            [31.401121207888387, -0.068506784648128],
            [31.404658026977263, -0.067528758944768],
            [31.407916672856917, -0.068759103264102],
            [31.4097496456683, -0.069938147499065],
            [31.41484132544477, -0.070809735449386],
            [31.423090009421475, -0.067990683120616],
            [31.429501363757645, -0.064004594948856],
            [31.436638797591907, -0.06915003811454],
            [31.44481187216778, -0.074468169113973],
            [31.446301268129062, -0.071239510710665],
            [31.44954755049546, -0.065885565334028],
            [31.456746907897212, -0.058451572361419],
            [31.466598905891313, -0.051967217650847],
            [31.470866903315784, -0.050803465041357],
            [31.47740443591509, -0.050051004111473],
            [31.476836476975024, -0.052106821178331],
            [31.47713851213312, -0.054091020024],
            [31.476019417003293, -0.062375906311858],
            [31.476596954679245, -0.06935099379175],
            [31.47624247497657, -0.070616110025574],
            [31.47679402079807, -0.072415046964346],
            [31.479380292060636, -0.072217347690738],
            [31.481919828470502, -0.072714858551673],
            [31.48948963762069, -0.07345672893055],
            [31.495558429304744, -0.071828969469344],
            [31.499347629174355, -0.070092600120425],
            [31.500719077237175, -0.069133950197836],
            [31.504309071200936, -0.063228168950964],
            [31.50809326296287, -0.060198444309595],
            [31.513369280628922, -0.058652011549484],
            [31.519895837612093, -0.052710066588686],
            [31.521287243545554, -0.050711300624314],
            [31.522917600446277, -0.046858459209111],
            [31.522942040910205, -0.04599925056634],
            [31.52680598150979, -0.042372539942713],
            [31.52994360455775, -0.040364750110597],
            [31.53041889958129, -0.040292410595319],
            [31.534064894519908, -0.042218918189504],
            [31.53482543788385, -0.042029004508294],
            [31.535824351005065, -0.040500516957249],
            [31.53791028760379, -0.040265400956331],
            [31.534898507747357, -0.037262618415073],
            [31.53508213057795, -0.036312961913269],
            [31.534769109922255, -0.035634628904571],
            [31.53539887025893, -0.032025933544546],
            [31.53494467666141, -0.027648451844491],
            [31.536032889508387, -0.023035831485035],
            [31.53770784147475, -0.019725602776055],
            [31.537565798065405, -0.017609216096596],
            [31.536233955825153, -0.015791287448573],
            [31.536678943487658, -0.014787364458773],
            [31.536653681963575, -0.013530195613256],
            [31.538459163632286, -0.010952553626392],
            [31.53942774064635, -0.008555793686039],
            [31.53945553901283, -0.006249474316327],
            [31.540423550088253, -0.005091793855832],
            [31.540751742390803, -0.002839739901952],
            [31.542527735962015, 0.000407200928389],
            [31.54944669592589, 0.008004532636211],
            [31.557617800496367, 0.0136302275089],
            [31.566226807716667, 0.026645323042243],
            [31.567820881663053, 0.027839218055841],
            [31.573231168717967, 0.03013647853946],
            [31.58985623937553, 0.03777047815712],
            [31.593415547787544, 0.041234619122378],
            [31.60092745692437, 0.050008056572414],
            [31.578995486317947, 0.059287265645953],
            [31.565199038911885, 0.073414387772736],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1960,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "LUGUSULU",
        Population: 31261,
        Key: "SSEMBABULELUGUSULU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.765582189616588, -0.137181520513131],
            [31.761477087295848, -0.137137110627674],
            [31.745079488932873, -0.13387302379812],
            [31.7321010240683, -0.129207850363226],
            [31.73261149801671, -0.134162179018953],
            [31.732383596327445, -0.147697347279649],
            [31.73308044554449, -0.152970685083576],
            [31.734799598216103, -0.157764701243346],
            [31.74331777767634, -0.174132668238542],
            [31.74392838413454, -0.176340630641637],
            [31.74617685561257, -0.179415104376408],
            [31.747953028846844, -0.187576162549837],
            [31.749507383782966, -0.191628796338751],
            [31.752428630526758, -0.194741983684065],
            [31.756018937104283, -0.197313508423486],
            [31.75771697038357, -0.198001478191738],
            [31.76165222733522, -0.197331006603144],
            [31.763151432001106, -0.196283045361559],
            [31.763901478550927, -0.189512554203486],
            [31.76671476217063, -0.188036135233511],
            [31.7743549947475, -0.191840563099778],
            [31.775687983238043, -0.189624563624861],
            [31.77747101960108, -0.187643765802421],
            [31.78014386869407, -0.185464043167539],
            [31.78016607774284, -0.180923316179365],
            [31.778793204952, -0.174745292168506],
            [31.777971545606025, -0.167490930042319],
            [31.77673447652659, -0.162497867361011],
            [31.77431736611688, -0.156536891226351],
            [31.770921166607643, -0.150811050202966],
            [31.76670400484508, -0.13718973827779],
            [31.765582189616588, -0.137181520513131],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1966,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "KALUNGU TOWN COUNCIL",
        Population: 8116,
        Key: "KALUNGUKALUNGU TOWN COUNCIL",
        Dist2: "Kalungu",
        "Sub Country": "Kalungu TC",
        id2_original: "Kalungu Kalungu TC",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.87679839729508, 0.671783223178729],
            [32.87146827320115, 0.677588965590552],
            [32.87030617302374, 0.680338291944632],
            [32.86944033183713, 0.684737239055102],
            [32.87096536935565, 0.690465784623857],
            [32.855980497541076, 0.681686620938546],
            [32.8474562337914, 0.678614647636387],
            [32.84265684694377, 0.676060969636977],
            [32.84203896952165, 0.677390655694687],
            [32.83868006806304, 0.680695321932755],
            [32.8359705299772, 0.682609767600531],
            [32.83312010730874, 0.681696502605532],
            [32.83154353973058, 0.68030571863382],
            [32.83054481705222, 0.680317651911141],
            [32.83000981909656, 0.679396032737096],
            [32.82826210179554, 0.678091368948046],
            [32.826866314778435, 0.678740134376006],
            [32.82642265841917, 0.678260999414528],
            [32.82689792918822, 0.681454898940777],
            [32.82065858695759, 0.68220986061225],
            [32.81875622468042, 0.683095480923483],
            [32.81820927823316, 0.683813588882893],
            [32.81918473724062, 0.684774277542216],
            [32.81342256661417, 0.684514948841761],
            [32.812005198470665, 0.683300313686566],
            [32.81085996595936, 0.683938448507746],
            [32.810323216288886, 0.682858241034681],
            [32.809037756761704, 0.676363604452663],
            [32.808729429803364, 0.676593496055565],
            [32.80581982702229, 0.674581225558668],
            [32.80285958441203, 0.673562293931934],
            [32.80017768838581, 0.671855673613823],
            [32.79827995063569, 0.670034638513861],
            [32.7985655762685, 0.668864707635051],
            [32.79777163444061, 0.668695137922837],
            [32.79748343154126, 0.668105467303066],
            [32.79820009759347, 0.666988396440852],
            [32.79282160550969, 0.662298972593912],
            [32.78916399894775, 0.663170611584861],
            [32.78564479492328, 0.661279388083813],
            [32.785858892201574, 0.65924470252874],
            [32.78539247522795, 0.653538570480673],
            [32.78474538728779, 0.651887260633654],
            [32.7845189300895, 0.645351071248126],
            [32.78418916932846, 0.644562564779425],
            [32.78840626641232, 0.640553004307168],
            [32.78959530976004, 0.638111418594244],
            [32.78992828648979, 0.636292174057987],
            [32.789143726666715, 0.632821189783866],
            [32.78747931373527, 0.630259797560397],
            [32.78550570247964, 0.629541588488605],
            [32.78182000110714, 0.629254182668673],
            [32.77851730813418, 0.629902424434941],
            [32.7740768431583, 0.629418253650661],
            [32.772153917545936, 0.630029455605339],
            [32.770500826082, 0.631727398526449],
            [32.76918405397896, 0.632278045769314],
            [32.7648143124671, 0.631655355324453],
            [32.75966145023325, 0.628086161940805],
            [32.75845330061774, 0.628041878556293],
            [32.761223944804144, 0.62605560412912],
            [32.763763467739324, 0.62337615718707],
            [32.76648433627582, 0.62171629968123],
            [32.770194685623075, 0.617649513916031],
            [32.773657561685944, 0.616487677853784],
            [32.775286059074034, 0.613064034275191],
            [32.77829549792083, 0.61115518370773],
            [32.780413404662234, 0.608906474077925],
            [32.7904704925273, 0.608431433134519],
            [32.797489767358954, 0.609009031636084],
            [32.80146577189191, 0.608461698364781],
            [32.80354644256646, 0.60758805150467],
            [32.808716225467, 0.604173101960989],
            [32.80889463178075, 0.602282034810158],
            [32.811272524440106, 0.6016836784671],
            [32.81476809378944, 0.59878734553912],
            [32.817265101258826, 0.591438573422896],
            [32.819451729119436, 0.590563597105487],
            [32.82138950747672, 0.591896340364504],
            [32.822673976162136, 0.590344775529003],
            [32.822921402734075, 0.587771805063503],
            [32.82252985674614, 0.585136564546483],
            [32.821664220375425, 0.58302005417079],
            [32.823185069948074, 0.577045346488469],
            [32.82926074901541, 0.570156588161569],
            [32.83008508264601, 0.56996007075901],
            [32.83776390774582, 0.573402334302894],
            [32.84052132962954, 0.567741001817101],
            [32.841346384607306, 0.567150890617826],
            [32.843391698490585, 0.567224169791398],
            [32.85367078791012, 0.572349358406611],
            [32.85592060686109, 0.572419717236812],
            [32.862522756177114, 0.569824073450888],
            [32.86595181516111, 0.570957062373472],
            [32.87010801455355, 0.571330255204021],
            [32.87307293648812, 0.572183114591137],
            [32.88317979461318, 0.576275715223446],
            [32.896636345566876, 0.582424058195117],
            [32.89614461227191, 0.584527720860301],
            [32.89642244771456, 0.586571911992759],
            [32.89808957984639, 0.59242477575102],
            [32.8957168866359, 0.596792837539247],
            [32.89404962424837, 0.597825657139986],
            [32.893109106112206, 0.599030634653664],
            [32.89161277156364, 0.603721476585208],
            [32.891292069413964, 0.607573146597239],
            [32.889667537189524, 0.609423640888467],
            [32.888769709690635, 0.613382890090057],
            [32.88686725309033, 0.617406669382734],
            [32.88400297660356, 0.618826779185944],
            [32.883361711543046, 0.619601403318157],
            [32.88267765343735, 0.622269589766429],
            [32.882100429273414, 0.626723751767903],
            [32.882399650908035, 0.62801482292536],
            [32.8857340562072, 0.632361484296291],
            [32.88661027024037, 0.639699056213901],
            [32.88605446909935, 0.641936890904551],
            [32.88447267781785, 0.643615240679716],
            [32.88259164334215, 0.644863224446319],
            [32.87859448078929, 0.645874464775383],
            [32.877354695204424, 0.64716549879811],
            [32.87489646620921, 0.651060150779285],
            [32.87216031373646, 0.656525587097958],
            [32.872031998381296, 0.659107713124476],
            [32.87389148317165, 0.665025138859449],
            [32.87679839729508, 0.671783223178729],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2019,
        District: "MUKONO",
        County: "NAKIFUMA",
        Subcounty: "KASAWO",
        Population: 35927,
        Key: "MUKONOKASAWO",
        Dist2: "Mukono",
        "Sub Country": "Kimenyedde",
        id2_original: "MukonoKimenyedde",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.410937102651665, 0.78276291826896],
            [32.40964546990187, 0.780844801152191],
            [32.405826452252995, 0.777180283924455],
            [32.40240983583399, 0.771941673827144],
            [32.401766074355315, 0.770367431752682],
            [32.3901088372376, 0.771306632395954],
            [32.38430687304069, 0.769089319009331],
            [32.380883961228164, 0.768826461495838],
            [32.37595429620644, 0.770626049506573],
            [32.366567310220866, 0.781987408515103],
            [32.3558342508843, 0.78004070391157],
            [32.35189898045789, 0.778664986772496],
            [32.349427247987336, 0.778782209682607],
            [32.347262733055736, 0.777252971604069],
            [32.34458758337728, 0.776121710333145],
            [32.33964710084291, 0.77891637504665],
            [32.33750868466528, 0.77935027869976],
            [32.33605995004699, 0.78025472116189],
            [32.33433673429537, 0.783529360234553],
            [32.32959713212651, 0.771605025683237],
            [32.32518325458809, 0.767216667038603],
            [32.32337366582189, 0.764402853243784],
            [32.322786771293934, 0.760404116944681],
            [32.32185703383948, 0.757771378733071],
            [32.32126203201612, 0.757128968765579],
            [32.317790967809415, 0.756250889156659],
            [32.31505582953462, 0.754622050064263],
            [32.31429547481687, 0.753581559613771],
            [32.31419426163384, 0.752486894396136],
            [32.315119901872265, 0.750768170796977],
            [32.3193803687197, 0.744617088113477],
            [32.320648208690876, 0.743803082812775],
            [32.32326050145227, 0.737009413127916],
            [32.325836266019245, 0.73210649056988],
            [32.32569378243542, 0.730885163397314],
            [32.323566861100154, 0.726044852475837],
            [32.31864688351043, 0.71817347974847],
            [32.317749244657726, 0.715079064279305],
            [32.32184881066138, 0.715133978506797],
            [32.322997391193766, 0.712162114965218],
            [32.32075680782222, 0.705116960465833],
            [32.31917163977355, 0.702640033110726],
            [32.31646789132971, 0.700862386131462],
            [32.31682171436393, 0.697121546985424],
            [32.31437498200774, 0.687911657510667],
            [32.31239241185379, 0.677082485910804],
            [32.31340452212483, 0.671265609939331],
            [32.312240214786755, 0.668985679102681],
            [32.3133102169863, 0.668850130767921],
            [32.32338053344223, 0.670208550338743],
            [32.32478359052491, 0.670226839684893],
            [32.32631505459096, 0.669212262783705],
            [32.332910019181334, 0.667770842446368],
            [32.33463577447028, 0.667853805210406],
            [32.334546002230674, 0.669206593004418],
            [32.336146827914746, 0.674947934646738],
            [32.341748189325585, 0.67915901812745],
            [32.34149050938294, 0.680066443168562],
            [32.356050094487486, 0.684868765475604],
            [32.356429575202846, 0.688550850754198],
            [32.36040091208959, 0.688678046604635],
            [32.36376652037014, 0.68637157258138],
            [32.3653832561162, 0.686824128393682],
            [32.37149537624136, 0.685296036561842],
            [32.37276114649416, 0.685404957582185],
            [32.375861179539044, 0.681095388935625],
            [32.37682358243216, 0.677153110119625],
            [32.37864467682055, 0.674317579306751],
            [32.38111839905944, 0.672139198348246],
            [32.38300820199063, 0.669234506247717],
            [32.38087888125524, 0.66453101157806],
            [32.380535559526685, 0.662836423843679],
            [32.38249915456691, 0.663110225486387],
            [32.387246128311, 0.652991898520098],
            [32.39088418034584, 0.65481075801754],
            [32.3931779556603, 0.658131227182415],
            [32.39427125117515, 0.660546866096432],
            [32.39486573916219, 0.660972140694463],
            [32.39605445462484, 0.661623658846771],
            [32.40162000379853, 0.662800429860539],
            [32.40423604612792, 0.662683139290956],
            [32.40703002585046, 0.663551976556797],
            [32.411515721000896, 0.666380893467582],
            [32.40986076732935, 0.668207914991462],
            [32.40601419655414, 0.670788721672541],
            [32.40473188202876, 0.672670743404942],
            [32.40273649381403, 0.673907969601095],
            [32.40110377883566, 0.676949633457037],
            [32.4073199454303, 0.685906791531341],
            [32.40605896679125, 0.688159299788079],
            [32.40671212734276, 0.691036281165385],
            [32.40673544940417, 0.693189436105481],
            [32.407733949300344, 0.694600871566834],
            [32.4078048506308, 0.695822205674821],
            [32.410098025870646, 0.701793422865705],
            [32.412392088645994, 0.705177241838976],
            [32.41388996650017, 0.706308290382506],
            [32.416706959263685, 0.70973741271978],
            [32.418109119827726, 0.712704964449029],
            [32.41929717053705, 0.716523766797965],
            [32.409604435757984, 0.715891911551081],
            [32.40287428729377, 0.712710691664171],
            [32.39641908529025, 0.707732001824192],
            [32.39312263830343, 0.706625350014896],
            [32.387491390841426, 0.702753003032346],
            [32.38378280937866, 0.70219942640702],
            [32.38254603404834, 0.706347438682566],
            [32.38089650081121, 0.715334965382275],
            [32.3811706944837, 0.719759703291246],
            [32.38350555694266, 0.72114276861515],
            [32.38790090223676, 0.722249546274957],
            [32.386389807469754, 0.723493874414829],
            [32.38446626561314, 0.727226923254451],
            [32.38309180010931, 0.733725605528437],
            [32.38350287277657, 0.740763739906088],
            [32.38446426865826, 0.741870078876768],
            [32.38597523945773, 0.741732029269904],
            [32.38913549376263, 0.734542220271232],
            [32.39105891075344, 0.731500548185479],
            [32.392707445962266, 0.72956490436745],
            [32.396691032276195, 0.728597489049948],
            [32.39929952696058, 0.738691854967491],
            [32.40328230119751, 0.743255456641087],
            [32.40948369499728, 0.745901498443444],
            [32.408669102697644, 0.749153530807509],
            [32.40864826357968, 0.751659506809578],
            [32.40907776967659, 0.753043734436253],
            [32.40853372478769, 0.75545917038646],
            [32.40884417895661, 0.756653398135789],
            [32.40858573364938, 0.759204575364636],
            [32.40926868323403, 0.763827612515308],
            [32.41104517537024, 0.768993615730569],
            [32.40997947160934, 0.772241287769479],
            [32.410937102651665, 0.78276291826896],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1337,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "NAKASEKE",
        Population: 17635,
        Key: "NAKASEKENAKASEKE",
        Dist2: "Nakaseke",
        "Sub Country": "Nakaseke",
        id2_original: "NakasekeNakaseke",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.41929717053705, 0.716523766797965],
            [32.41943970262991, 0.717608539478159],
            [32.420057725579085, 0.718522353491739],
            [32.42012860894322, 0.719879393458276],
            [32.42083005933113, 0.720657515551517],
            [32.42104363199332, 0.721833636868115],
            [32.42075784646039, 0.723145396279633],
            [32.418581038982445, 0.727370004367836],
            [32.41846130163993, 0.730310221885081],
            [32.41746177496937, 0.732463246209859],
            [32.41528517410394, 0.735005129883392],
            [32.41122893025318, 0.741355486143156],
            [32.40948369499728, 0.745901498443444],
            [32.40328230119751, 0.743255456641087],
            [32.39929952696058, 0.738691854967491],
            [32.396691032276195, 0.728597489049948],
            [32.392707445962266, 0.72956490436745],
            [32.39105891075344, 0.731500548185479],
            [32.38913549376263, 0.734542220271232],
            [32.38597523945773, 0.741732029269904],
            [32.38446426865826, 0.741870078876768],
            [32.38350287277657, 0.740763739906088],
            [32.38309180010931, 0.733725605528437],
            [32.38446626561314, 0.727226923254451],
            [32.386389807469754, 0.723493874414829],
            [32.38790090223676, 0.722249546274957],
            [32.38350555694266, 0.72114276861515],
            [32.3811706944837, 0.719759703291246],
            [32.38089650081121, 0.715334965382275],
            [32.38254603404834, 0.706347438682566],
            [32.38378280937866, 0.70219942640702],
            [32.387491390841426, 0.702753003032346],
            [32.39312263830343, 0.706625350014896],
            [32.39641908529025, 0.707732001824192],
            [32.40287428729377, 0.712710691664171],
            [32.409604435757984, 0.715891911551081],
            [32.41929717053705, 0.716523766797965],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1338,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "NAKASEKE TOWN COUNCIL",
        Population: 7248,
        Key: "NAKASEKENAKASEKE TOWN COUNCIL",
        Dist2: "Nakaseke",
        "Sub Country": "Nakaseke TC",
        id2_original: "NakasekeNakaseke TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.15954284994195, 1.363640857027157],
            [32.15697630029317, 1.367944941932168],
            [32.15567515168954, 1.37298327992113],
            [32.15412277214874, 1.375144796181129],
            [32.15154059361061, 1.380653075433776],
            [32.15068422785365, 1.381276962785047],
            [32.14932892880473, 1.381321704745535],
            [32.14617454858344, 1.379800787446145],
            [32.14433227012403, 1.380424313105074],
            [32.14283755433964, 1.381831213066972],
            [32.138777712736164, 1.375790876845282],
            [32.12208335232583, 1.359965703540909],
            [32.114228147511554, 1.350075930921694],
            [32.090661053543506, 1.325350116991687],
            [32.090672480113916, 1.2937123045688],
            [32.08478911417923, 1.264049760172174],
            [32.0739837871747, 1.264045896560273],
            [32.0553204759684, 1.263050442418839],
            [32.02879156464342, 1.281825203881257],
            [32.02807913684271, 1.283329529251394],
            [32.02523400525125, 1.283436495355497],
            [32.01938581195322, 1.286925201403112],
            [32.01948227035349, 1.293807419090578],
            [32.022947920413955, 1.301189663046731],
            [32.0274047356263, 1.308173337671628],
            [32.028592362330826, 1.312263223731021],
            [32.02403296220798, 1.314256271006783],
            [32.0092671311007, 1.313951182786],
            [32.00213137711604, 1.315344695777792],
            [31.996446134617262, 1.319755155761263],
            [31.988502332559783, 1.320366905072933],
            [31.950199563928553, 1.304532646967771],
            [31.941365647307197, 1.288710716055883],
            [31.908943671835697, 1.305503572699049],
            [31.853926389090745, 1.329205478847806],
            [31.841665659273566, 1.32852490424039],
            [31.842482328478155, 1.325787565674304],
            [31.84299582974905, 1.319519306364399],
            [31.843685979330708, 1.318714584274859],
            [31.846015643239095, 1.317539764097392],
            [31.847736970732015, 1.315152562636075],
            [31.84951616859384, 1.30596318503365],
            [31.851554134258105, 1.300184060629856],
            [31.857088873014174, 1.291484819664132],
            [31.8593549047594, 1.279853319728117],
            [31.8604952279777, 1.277158267933483],
            [31.861710207484307, 1.276480396893097],
            [31.864367171668125, 1.276219261259596],
            [31.866883443508794, 1.27528869092641],
            [31.870119153602626, 1.273309150898118],
            [31.876012974130596, 1.265170742648082],
            [31.883973663617073, 1.252085241164296],
            [31.88871046933048, 1.242109968201303],
            [31.889494743489276, 1.238410647473697],
            [31.891005947850726, 1.237172036721598],
            [31.891771257675565, 1.235833608957853],
            [31.893122943700394, 1.229149464878121],
            [31.896207136751887, 1.225948599486903],
            [31.899872142736854, 1.220169073506724],
            [31.903677507790004, 1.216100981478851],
            [31.90475256750461, 1.213387724323413],
            [31.905918971510538, 1.208394997065337],
            [31.907720157435598, 1.206722279777898],
            [31.909977411742176, 1.205818626687058],
            [31.910370156082717, 1.20481471563441],
            [31.909705082972202, 1.202055517465247],
            [31.908594924282834, 1.199856972312701],
            [31.9086336120272, 1.196491999332843],
            [31.90794911374698, 1.195261513482876],
            [31.907771641681148, 1.193786998824689],
            [31.905947581055706, 1.192275642460923],
            [31.90577751829432, 1.186965771165204],
            [31.905330974749752, 1.185536379158939],
            [31.905558175753075, 1.184830907951676],
            [31.904065912369397, 1.183744834275029],
            [31.902800593070904, 1.181889971378446],
            [31.902321991348778, 1.179139903031154],
            [31.900259541203134, 1.177528957202682],
            [31.899263198161947, 1.175149556584789],
            [31.899344712189137, 1.173539464367441],
            [31.90013116206757, 1.172599030184265],
            [31.90071881028202, 1.169406149477102],
            [31.902458358303868, 1.168674138984868],
            [31.902333054101504, 1.16735342466616],
            [31.90374021648505, 1.165553892726281],
            [31.90382187514101, 1.164278487593064],
            [31.90523039308231, 1.164043852963238],
            [31.90592306513328, 1.162298310920767],
            [31.90712446390944, 1.162425419728487],
            [31.909981336481632, 1.1598846992569],
            [31.9123627217908, 1.15885441592318],
            [31.913438408529483, 1.157235654594774],
            [31.913375419560076, 1.155969234219496],
            [31.91374755924292, 1.155173357620261],
            [31.91307337811377, 1.154114752644423],
            [31.913258143601404, 1.151970997168952],
            [31.91389938800068, 1.151021446029887],
            [31.913854984276185, 1.147394108534325],
            [31.912714692498913, 1.146100138866325],
            [31.9135741790032, 1.145811006558599],
            [31.913241577769263, 1.144544483213428],
            [31.91355125130221, 1.143305342591119],
            [31.913012082468686, 1.142436751111673],
            [31.91363273029511, 1.141722378467645],
            [31.91402488444249, 1.139967664442299],
            [31.912666732344217, 1.138474609278042],
            [31.912665766655298, 1.137307715881006],
            [31.911277100583455, 1.136312162617253],
            [31.9108407636971, 1.134575226659396],
            [31.909492012468284, 1.131987651540628],
            [31.9092624884216, 1.129943241756248],
            [31.908069498774836, 1.127636143970038],
            [31.908067555718883, 1.125320450932302],
            [31.90879030875546, 1.122643205081682],
            [31.90813595164799, 1.120381540400878],
            [31.909210879310223, 1.117686333432035],
            [31.908420520862016, 1.114094906080275],
            [31.908469120617188, 1.110241467024791],
            [31.910413462065925, 1.10691338188602],
            [31.91143171861013, 1.106316743241529],
            [31.91646962792864, 1.103369707688241],
            [31.917773528970304, 1.101904782756564],
            [31.925032624338435, 1.087823244622948],
            [31.928612407152364, 1.083211204634269],
            [31.93373597083325, 1.079323356083487],
            [31.94987631325841, 1.071151622766064],
            [31.958479237985927, 1.066206520825123],
            [31.98111283145681, 1.045101061815403],
            [31.997914575577916, 1.023839522181276],
            [32.001631338896274, 1.020656518968614],
            [32.002279439237796, 1.016341804634886],
            [32.00243727952144, 1.002528688766866],
            [32.00213770754385, 1.000411844742784],
            [31.999696535759252, 0.993445718744612],
            [31.999507255339005, 0.991573150704671],
            [32.00073162493528, 0.986200231725787],
            [32.001539495141635, 0.985576306696203],
            [32.00284702986859, 0.98287196197011],
            [32.00497609458414, 0.975102125627914],
            [32.00600038511212, 0.967141984986656],
            [32.00581853465759, 0.963803970808104],
            [32.00534442900344, 0.961099089469455],
            [32.00529817385116, 0.956937934930283],
            [32.00627409998258, 0.95097693107916],
            [32.00840279189726, 0.944165934246144],
            [32.012836974954375, 0.932787363832866],
            [32.01534459781546, 0.928491228421088],
            [32.02088189497346, 0.92190729034117],
            [32.0280220066856, 0.91691586027339],
            [32.035173475797855, 0.913516501229403],
            [32.0642301538059, 0.903998696141157],
            [32.07025225555305, 0.903330844072085],
            [32.0884850177184, 0.904104434449009],
            [32.09643139344915, 0.903672221618676],
            [32.10596395681642, 0.902082467445706],
            [32.10520493699522, 0.921025071988046],
            [32.105820842615266, 0.927638018096159],
            [32.1055668637316, 0.936910331852535],
            [32.10602360405299, 0.938746833341434],
            [32.105702399745034, 0.9428446898285],
            [32.10405564859039, 0.945748098720415],
            [32.10275064351925, 0.952025831828259],
            [32.10167560177099, 0.954124270982485],
            [32.09961696048214, 0.956566203711193],
            [32.09792380774978, 0.961767322188277],
            [32.096893618883655, 0.966253962346736],
            [32.09643524812003, 0.97062315332249],
            [32.09586347134, 0.971609034891414],
            [32.08433766134162, 0.979114221289152],
            [32.085547857319355, 0.985121212021737],
            [32.08780976759407, 0.991264191777045],
            [32.091420586302746, 0.997344231008432],
            [32.09345491918001, 0.999760130057396],
            [32.096335149746224, 1.002203404688256],
            [32.099693164567675, 1.013593510611538],
            [32.10087191591722, 1.016488628230304],
            [32.11264682155734, 1.024217401924387],
            [32.11420936733223, 1.028623357105433],
            [32.11886472010385, 1.033690559015727],
            [32.11973471779527, 1.037001731296446],
            [32.11895612458231, 1.042338800938049],
            [32.11925399784569, 1.044736142399506],
            [32.12006567421391, 1.046681316863296],
            [32.12270335156861, 1.048952673933001],
            [32.124211307621984, 1.049712986463093],
            [32.12692758936064, 1.050111788552059],
            [32.14426110379061, 1.046371452481223],
            [32.15102357004547, 1.045993361614624],
            [32.159520385771636, 1.046411801667166],
            [32.162296409968285, 1.047208629722277],
            [32.16801246917289, 1.049933122987842],
            [32.173919895584135, 1.055507274858936],
            [32.178519368653504, 1.057996261871829],
            [32.184426163549126, 1.063986554736286],
            [32.18986839289893, 1.068022703491572],
            [32.19759520779781, 1.072874940176225],
            [32.186076479218826, 1.085047107832188],
            [32.16148335378779, 1.104164508124873],
            [32.127950937555894, 1.116529131665466],
            [32.10335982075784, 1.127771007070165],
            [32.10558066275268, 1.173894012497192],
            [32.101157292716664, 1.190938266623807],
            [32.087241521193086, 1.191057405995259],
            [32.07112033084978, 1.185473550964532],
            [32.06457224394418, 1.17989291702401],
            [32.06458063061568, 1.154572862432687],
            [32.06227953762491, 1.155539458045506],
            [32.04778805739531, 1.155346895715834],
            [32.04370640290011, 1.158367379800282],
            [32.042701334522555, 1.159526264943608],
            [32.03985250456711, 1.153171204445316],
            [32.03686321583044, 1.142263749317787],
            [32.03562452349527, 1.140575730401012],
            [32.03185106480437, 1.138041800158736],
            [32.02611210125497, 1.136119299914909],
            [32.02126612598007, 1.135724276938671],
            [32.01219752269407, 1.134194279111116],
            [32.00513644565899, 1.131188654439549],
            [31.997074921180154, 1.132200091273827],
            [31.98951404936876, 1.142339782881345],
            [31.983466381568586, 1.147408790349802],
            [31.977416332334638, 1.159070259379021],
            [31.97692889388503, 1.172668772451972],
            [31.984006509802843, 1.178273491531714],
            [31.992811150329096, 1.182570453035138],
            [31.993881697806017, 1.185666118410421],
            [31.99364006716425, 1.191153378326256],
            [31.991721716671663, 1.194529498130432],
            [31.991121468686995, 1.197664900831483],
            [31.99177933012241, 1.20080077055934],
            [31.989679759792566, 1.208156643487307],
            [31.99135584094128, 1.211956202319538],
            [31.992912594379185, 1.214429106888618],
            [31.994409909888006, 1.215635679898484],
            [32.005071824450724, 1.22154913656987],
            [32.006629417813414, 1.221790920648668],
            [32.007708722067704, 1.219318990993461],
            [32.010465745997784, 1.216244672361585],
            [32.01358187775088, 1.21413529173466],
            [32.016460646758155, 1.205694218708803],
            [32.020175910788296, 1.203464431891078],
            [32.01993663463092, 1.202439229198812],
            [32.01574403460487, 1.199241757604818],
            [32.014432506866484, 1.196194127233957],
            [32.01626519581021, 1.191629721991148],
            [32.02042021481636, 1.194812837930728],
            [32.02439994645941, 1.19711210761177],
            [32.02547317181418, 1.195551502886136],
            [32.026259098873105, 1.19713501144792],
            [32.029253250190436, 1.201055660029933],
            [32.03714749578693, 1.20717822003067],
            [32.0544855080815, 1.20884641233232],
            [32.07917401573111, 1.208854971371638],
            [32.10335005247744, 1.209702229910089],
            [32.11561907374466, 1.236893719983288],
            [32.1200856509492, 1.24926953918569],
            [32.122316491193196, 1.262769559865577],
            [32.149134699565565, 1.281902648018886],
            [32.14018629355957, 1.30214862490309],
            [32.14017703013233, 1.329147272903503],
            [32.137936090129635, 1.344895686355352],
            [32.137932117779435, 1.356145113828917],
            [32.15134410510852, 1.358399787820381],
            [32.15954284994195, 1.363640857027157],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1339,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "NGOMA",
        Population: 7853,
        Key: "NAKASEKENGOMA",
        Dist2: "Nakaseke",
        "Sub Country": "Ngoma",
        id2_original: "NakasekeNgoma",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "M",
        "Environmental degradation": "VH",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "VH",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.10335005247744, 1.209702229910089],
            [32.07917401573111, 1.208854971371638],
            [32.0544855080815, 1.20884641233232],
            [32.03714749578693, 1.20717822003067],
            [32.029253250190436, 1.201055660029933],
            [32.026259098873105, 1.19713501144792],
            [32.02547317181418, 1.195551502886136],
            [32.02439994645941, 1.19711210761177],
            [32.02042021481636, 1.194812837930728],
            [32.01626519581021, 1.191629721991148],
            [32.014432506866484, 1.196194127233957],
            [32.01574403460487, 1.199241757604818],
            [32.01993663463092, 1.202439229198812],
            [32.020175910788296, 1.203464431891078],
            [32.016460646758155, 1.205694218708803],
            [32.01358187775088, 1.21413529173466],
            [32.010465745997784, 1.216244672361585],
            [32.007708722067704, 1.219318990993461],
            [32.006629417813414, 1.221790920648668],
            [32.005071824450724, 1.22154913656987],
            [31.994409909888006, 1.215635679898484],
            [31.992912594379185, 1.214429106888618],
            [31.99135584094128, 1.211956202319538],
            [31.989679759792566, 1.208156643487307],
            [31.99177933012241, 1.20080077055934],
            [31.991121468686995, 1.197664900831483],
            [31.991721716671663, 1.194529498130432],
            [31.99364006716425, 1.191153378326256],
            [31.993881697806017, 1.185666118410421],
            [31.992811150329096, 1.182570453035138],
            [31.984006509802843, 1.178273491531714],
            [31.97692889388503, 1.172668772451972],
            [31.977416332334638, 1.159070259379021],
            [31.983466381568586, 1.147408790349802],
            [31.98951404936876, 1.142339782881345],
            [31.997074921180154, 1.132200091273827],
            [32.00513644565899, 1.131188654439549],
            [32.01219752269407, 1.134194279111116],
            [32.02126612598007, 1.135724276938671],
            [32.02611210125497, 1.136119299914909],
            [32.03185106480437, 1.138041800158736],
            [32.03562452349527, 1.140575730401012],
            [32.03686321583044, 1.142263749317787],
            [32.03985250456711, 1.153171204445316],
            [32.042701334522555, 1.159526264943608],
            [32.04370640290011, 1.158367379800282],
            [32.04778805739531, 1.155346895715834],
            [32.06227953762491, 1.155539458045506],
            [32.06458063061568, 1.154572862432687],
            [32.06457224394418, 1.17989291702401],
            [32.07112033084978, 1.185473550964532],
            [32.087241521193086, 1.191057405995259],
            [32.101157292716664, 1.190938266623807],
            [32.098866427045415, 1.199765279819859],
            [32.10335005247744, 1.209702229910089],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1340,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "NGOMA TOWN COUNCIL",
        Population: 6285,
        Key: "NAKASEKENGOMA TOWN COUNCIL",
        Dist2: "Nakaseke",
        "Sub Country": "Ngoma  TC",
        id2_original: "NakasekeNgoma  TC",
        drought: "VH",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.32631505459096, 0.669212262783705],
            [32.32478359052491, 0.670226839684893],
            [32.32338053344223, 0.670208550338743],
            [32.3133102169863, 0.668850130767921],
            [32.312240214786755, 0.668985679102681],
            [32.310345900516204, 0.663503120464815],
            [32.30931313168859, 0.65841874006354],
            [32.30635385117399, 0.653216487004124],
            [32.30275233541835, 0.649832528442472],
            [32.30291968436926, 0.645951530837867],
            [32.3025283494854, 0.642812282755712],
            [32.302813314856486, 0.63897050050416],
            [32.30725227335763, 0.63609604439678],
            [32.30826627817561, 0.635862868690801],
            [32.30916420089593, 0.637117047845671],
            [32.312235331544905, 0.635338451022777],
            [32.314408145113084, 0.635251250630548],
            [32.31536414032327, 0.635543020763875],
            [32.31765249610163, 0.638051443598714],
            [32.32153381910195, 0.643797306917146],
            [32.324112051341025, 0.645080878736815],
            [32.32138957032856, 0.639218510823096],
            [32.32075251297687, 0.636943620833502],
            [32.32008698801378, 0.630819054788798],
            [32.3191023715803, 0.627844179320978],
            [32.320753991603816, 0.625598753619445],
            [32.32524475774403, 0.623207874963],
            [32.327707561858965, 0.620904220107447],
            [32.331792704512424, 0.618746589460669],
            [32.33497995408994, 0.614984804119321],
            [32.33697902539733, 0.614255948543581],
            [32.339368246710755, 0.614010037183393],
            [32.33956086077903, 0.614301940541058],
            [32.340820974340446, 0.61422972373594],
            [32.34242579483257, 0.615442187317564],
            [32.34368564428934, 0.617523095960481],
            [32.34404165112801, 0.620535706990525],
            [32.34333903652346, 0.624778542679513],
            [32.34427556164819, 0.629745324871988],
            [32.347400032462076, 0.630583371799297],
            [32.34188720451411, 0.636717477641959],
            [32.342415591767605, 0.645030875389064],
            [32.33818018791656, 0.648227721086448],
            [32.33235681147654, 0.650092120364172],
            [32.32759189747792, 0.65515411570011],
            [32.32759077188889, 0.662881190186486],
            [32.32631505459096, 0.669212262783705],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1342,
        District: "NAKASEKE",
        County: "NAKASEKE",
        Subcounty: "SEMUTO TOWN COUNCIL",
        Population: 10671,
        Key: "NAKASEKESEMUTO TOWN COUNCIL",
        Dist2: "Nakaseke",
        "Sub Country": "Semuto TC",
        id2_original: "NakasekeSemuto TC",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.22327708596335, 1.402023405874245],
            [32.21919396811255, 1.397537435539963],
            [32.21508630020334, 1.392076631478397],
            [32.211965356175256, 1.385292664655486],
            [32.208846496238635, 1.37222210163413],
            [32.20805745292402, 1.357310324210292],
            [32.20725002199381, 1.356127469572029],
            [32.20948857786774, 1.356567846727578],
            [32.21392617272629, 1.358306394672996],
            [32.21754186928701, 1.360127387069667],
            [32.21992466495116, 1.362196131695493],
            [32.224444263418754, 1.364596446593799],
            [32.226088167812264, 1.364183388113329],
            [32.22789700468859, 1.362033283519696],
            [32.23176081593076, 1.359056647945607],
            [32.23332260712079, 1.358395397191199],
            [32.23907570835614, 1.358728107892634],
            [32.250823988829566, 1.36142628728506],
            [32.252069834449344, 1.360660559344939],
            [32.254457667865616, 1.360805502054741],
            [32.25456607565581, 1.362068860224737],
            [32.25452240136332, 1.360809431075689],
            [32.25798831732513, 1.361019810156181],
            [32.267695258960394, 1.35959317023006],
            [32.27254851867396, 1.359594650236862],
            [32.27704631143634, 1.360787374674582],
            [32.2792258776405, 1.363181864356731],
            [32.2801826948092, 1.362503826375416],
            [32.280004984689796, 1.362932719758154],
            [32.28201700161877, 1.364005550540178],
            [32.28841713150547, 1.369845561480208],
            [32.286895836368465, 1.37406757888523],
            [32.285801820404735, 1.374490688510316],
            [32.28284045310372, 1.381280562186495],
            [32.281298537139364, 1.391406673395368],
            [32.281889467797875, 1.39450439835994],
            [32.28887110860902, 1.402607812159114],
            [32.2947070021742, 1.410221097159154],
            [32.294669004336, 1.41083000628963],
            [32.297744576255724, 1.418098279595736],
            [32.29916361167238, 1.422983317396755],
            [32.299635998849375, 1.426676699703307],
            [32.30294729049626, 1.437400021758432],
            [32.303064725456714, 1.440497613415881],
            [32.29868557678719, 1.437875252483904],
            [32.29170211868421, 1.435371212526009],
            [32.28892019165783, 1.434867789310957],
            [32.28509757715458, 1.435416154607419],
            [32.283647250721636, 1.434480278797223],
            [32.282942337328315, 1.435130188429077],
            [32.27891724435666, 1.436082002265296],
            [32.26838177036514, 1.436078626558762],
            [32.26789214182291, 1.435431433747466],
            [32.2596046596091, 1.434797039528357],
            [32.25759636080708, 1.433250382620915],
            [32.254289296631946, 1.428492375855385],
            [32.251690647483066, 1.42551844924966],
            [32.24791013791551, 1.42325767165844],
            [32.24176609525843, 1.421828571029856],
            [32.23668518718052, 1.421470115262394],
            [32.22900366803319, 1.424202756929846],
            [32.2240603755686, 1.427273748623601],
            [32.21935883501831, 1.431781313980184],
            [32.21866765506905, 1.425697335571517],
            [32.21890572928057, 1.421765977731561],
            [32.218572789381774, 1.417405542096619],
            [32.2188924342144, 1.417298429221236],
            [32.21857133231438, 1.417393771480823],
            [32.218472618244434, 1.416596797287465],
            [32.22021151319105, 1.410806044707151],
            [32.22210651736774, 1.407709183664876],
            [32.22327708596335, 1.402023405874245],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1344,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "MIGEERA TOWN COUNCIL",
        Population: 5859,
        Key: "NAKASONGOLAMIGEERA TOWN COUNCIL",
        Dist2: "Nakasongola",
        "Sub Country": "Migera  TC",
        id2_original: "NakasongolaMigera  TC",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.592176447677666, 1.105141953074899],
            [32.58788112709548, 1.109431846996963],
            [32.58218295604314, 1.102946419148015],
            [32.56475960289825, 1.102613002027119],
            [32.55736254426879, 1.104928174938259],
            [32.55210208722009, 1.108732683574012],
            [32.550457492920444, 1.114523108575928],
            [32.55045600261539, 1.124284535531161],
            [32.553082265077734, 1.148274896081192],
            [32.5537588384205, 1.14926576591738],
            [32.553020777193176, 1.148860404523891],
            [32.55406755524766, 1.154396627196596],
            [32.55390222211627, 1.16051817538522],
            [32.55160056049194, 1.163164974342697],
            [32.54593369932051, 1.166563645976457],
            [32.53779188521819, 1.170607867185951],
            [32.53318925726555, 1.171434335942603],
            [32.517901631640676, 1.176064242432309],
            [32.50771006418095, 1.178047810587654],
            [32.49242310600435, 1.178872275222703],
            [32.488971069013665, 1.179864317137207],
            [32.48492263331937, 1.183303006840233],
            [32.48486073939629, 1.185157831968724],
            [32.49291229347377, 1.200380404598182],
            [32.49718520558117, 1.205013703257924],
            [32.500472208579424, 1.207826905720265],
            [32.51097670147339, 1.22212912589744],
            [32.50052493878828, 1.225990493607734],
            [32.490734603850214, 1.22648132934263],
            [32.46772563137158, 1.236330706272922],
            [32.4669238149119, 1.236173615825652],
            [32.463519937501935, 1.23886196338843],
            [32.458678944283605, 1.240905572475051],
            [32.45209750382983, 1.241817942419879],
            [32.44123821502616, 1.242277040724048],
            [32.43774129910221, 1.242967313598794],
            [32.4373389625511, 1.242624795606264],
            [32.437512217925, 1.243040876390785],
            [32.4355543083222, 1.244121384951255],
            [32.43497774262341, 1.244971666113544],
            [32.43462834379196, 1.24746852840975],
            [32.43525641349926, 1.247468664023195],
            [32.43439920242759, 1.253710820164014],
            [32.43359100703109, 1.25535717479235],
            [32.42250451273254, 1.25937153175433],
            [32.409513741846894, 1.263197407909528],
            [32.40995527997874, 1.273023771805484],
            [32.406244564118836, 1.277296264274422],
            [32.39918449768845, 1.279426216267742],
            [32.39086253274412, 1.280409612610292],
            [32.38351965869596, 1.281146873353227],
            [32.36861705998503, 1.281164293618934],
            [32.36161512084169, 1.286768859424275],
            [32.35550763782002, 1.2893727712234],
            [32.350143818818125, 1.290257975830357],
            [32.34705038569562, 1.290239082763154],
            [32.34509177720355, 1.289008222079242],
            [32.340047117045685, 1.284212152151712],
            [32.332388957689005, 1.278863549416759],
            [32.32976100819054, 1.276574045471851],
            [32.32252124187235, 1.269769029288491],
            [32.3152256865818, 1.261625092001776],
            [32.31282671315768, 1.26032173484177],
            [32.30876859092965, 1.258900326480828],
            [32.31189517008949, 1.256539981673406],
            [32.312647865771126, 1.253600017044779],
            [32.31346632980965, 1.252641287639517],
            [32.31579669260732, 1.250977315049541],
            [32.31986872884076, 1.249639475357177],
            [32.32375313755408, 1.247188835964848],
            [32.32899646912021, 1.242467815999175],
            [32.32977282373146, 1.240269668532371],
            [32.33098273134996, 1.238587291339194],
            [32.332572144836675, 1.237882053085814],
            [32.33556851948432, 1.234852166265118],
            [32.33654637879019, 1.234436263816086],
            [32.33880130107031, 1.234463970410714],
            [32.342300155558625, 1.233768248302326],
            [32.344144068951856, 1.232972596309617],
            [32.346191152516255, 1.230648096036048],
            [32.34778084717562, 1.225301872441408],
            [32.35037919988045, 1.221032451391134],
            [32.349352326696014, 1.208004906855559],
            [32.3483341644749, 1.201970491773271],
            [32.34846550894922, 1.200061663348483],
            [32.350056332790906, 1.196841408179913],
            [32.3533726442236, 1.193413484036906],
            [32.355440149189384, 1.190021444558133],
            [32.35545787294991, 1.180196685273137],
            [32.35623608437887, 1.175763961156482],
            [32.359835948132684, 1.169034011834758],
            [32.36167746032913, 1.167451252450483],
            [32.36666271399898, 1.165145464751931],
            [32.367951082271034, 1.162712176588473],
            [32.36933723485674, 1.156280235918488],
            [32.369916765894274, 1.149540520538953],
            [32.37093601687351, 1.144628349360904],
            [32.373808353045035, 1.136396414306072],
            [32.37559556747246, 1.132452407501727],
            [32.377516540147376, 1.124220249195805],
            [32.3786294117489, 1.121343610051812],
            [32.3838280144004, 1.113745408918082],
            [32.39114945554418, 1.108744057708839],
            [32.394797456420825, 1.107288274977668],
            [32.39624246842055, 1.106311516021141],
            [32.39689816671272, 1.104239928346176],
            [32.39643945728425, 1.101670538260822],
            [32.396707902637246, 1.100621162068636],
            [32.400323865099274, 1.094985724596534],
            [32.40366978859699, 1.08702518584061],
            [32.405268175355076, 1.084447156031998],
            [32.41188824426437, 1.077618092562884],
            [32.41358205636013, 1.076813251808779],
            [32.418377784369646, 1.076162805801906],
            [32.42507232631094, 1.070740361439708],
            [32.42653727821504, 1.07126256956498],
            [32.42871284242463, 1.071218288565532],
            [32.430754921474566, 1.072738148045897],
            [32.4338182233058, 1.074034744594772],
            [32.444251500459025, 1.077030943414987],
            [32.457526610589944, 1.078731601520147],
            [32.45850308020211, 1.080519404014317],
            [32.46045484712495, 1.090709225609212],
            [32.46080894145041, 1.096876601808111],
            [32.46231830785875, 1.098128214927677],
            [32.46400540325115, 1.09866480848824],
            [32.467734922646564, 1.099023006908153],
            [32.472885380988714, 1.098577020598082],
            [32.482431301405946, 1.09889154109284],
            [32.4834971147613, 1.097640382756985],
            [32.48358636687635, 1.095003640019288],
            [32.482743696834206, 1.089595903382179],
            [32.48070246938714, 1.082802545991694],
            [32.47981523841531, 1.078333311488084],
            [32.47981537495924, 1.077528876889673],
            [32.480881283536014, 1.075652046422435],
            [32.48239097513451, 1.075026633604616],
            [32.48585384221424, 1.076814857712834],
            [32.490826615589846, 1.076726318328116],
            [32.491537144352016, 1.075922001862175],
            [32.49384719174952, 1.06823555374705],
            [32.49686674023656, 1.065912125600582],
            [32.49988616924762, 1.064303748147886],
            [32.50521385711048, 1.065913490803557],
            [32.51409361386249, 1.066987502064871],
            [32.51906643395044, 1.066630762063327],
            [32.5242171572956, 1.064307632691214],
            [32.52652640609086, 1.061268993217705],
            [32.527947792398614, 1.057336392857715],
            [32.52652859887847, 1.046789067967522],
            [32.524042661348325, 1.043928456684047],
            [32.522444687815266, 1.041246745982832],
            [32.51938143179809, 1.039279867535035],
            [32.51476509735083, 1.03145822002802],
            [32.505797600348416, 1.024127503911716],
            [32.504199581001274, 1.021892704432572],
            [32.503222804165304, 1.021892552641442],
            [32.50082546747164, 1.020551448023407],
            [32.49913834962136, 1.02028303805711],
            [32.49745140065436, 1.018942043243359],
            [32.49611971202605, 1.01715419569252],
            [32.49620871890102, 1.015813482502309],
            [32.49887330978163, 1.011523569301897],
            [32.50056076629675, 1.009557427957039],
            [32.50056140769388, 1.005356477214279],
            [32.5077544184981, 1.0025867361995],
            [32.509175431106705, 1.000888692985166],
            [32.50384846099775, 0.99507805496741],
            [32.500607720338344, 0.992708939603867],
            [32.49443685219023, 0.989244445605233],
            [32.49257970571457, 0.988606992736274],
            [32.495870820301846, 0.985507930765103],
            [32.49933016778231, 0.98052356978164],
            [32.500185990058526, 0.976606354658554],
            [32.501828994340144, 0.975168129664458],
            [32.50861862295427, 0.971658902184696],
            [32.514254661131666, 0.970537896571406],
            [32.51907053835298, 0.967634500572964],
            [32.53240011693288, 0.96223530632731],
            [32.5377153245015, 0.959594302969133],
            [32.54336339381549, 0.958762741251118],
            [32.55251092487896, 0.959089654375989],
            [32.55413213154018, 0.958791315354144],
            [32.554207048339954, 0.959361289304067],
            [32.56620015655924, 0.961235589030809],
            [32.56805488477016, 0.962240051457692],
            [32.57075362241134, 0.965488296000919],
            [32.57144309645987, 0.965967878823541],
            [32.573725969820046, 0.966203392591245],
            [32.58039570658142, 0.971270599240895],
            [32.582594996195965, 0.975179216862265],
            [32.58412788858333, 0.982778964987481],
            [32.58417492257496, 0.986280195091191],
            [32.583496965826676, 0.987990009306714],
            [32.581523078788265, 0.989636329309525],
            [32.5781461903627, 0.989418767340036],
            [32.57607745650162, 0.988133815384495],
            [32.57081119633621, 0.981031179184143],
            [32.5684214872376, 0.979366207733165],
            [32.566566470667475, 0.978361740511305],
            [32.565781719503256, 0.978361638118299],
            [32.564830656043966, 0.978669114441717],
            [32.56399803635322, 0.979609900327328],
            [32.561999473492236, 0.987390112774977],
            [32.56129725324815, 0.994102940523718],
            [32.56128470558026, 0.997658434732929],
            [32.56249385591897, 0.997658597303355],
            [32.561533962918745, 1.00094255224184],
            [32.5623832032389, 1.006018069832141],
            [32.56186402461539, 1.00907590687254],
            [32.55990861143079, 1.013092534760205],
            [32.556481792845126, 1.018475062287115],
            [32.55536858347705, 1.021324729789755],
            [32.55512141112828, 1.023387422850064],
            [32.55586364233516, 1.028291031300429],
            [32.556875886455195, 1.030498654870703],
            [32.55868358875933, 1.032552590248062],
            [32.57067715781434, 1.039149563186724],
            [32.57559978812908, 1.043257608207439],
            [32.57665901324016, 1.045040026954675],
            [32.57728045338065, 1.048152306653269],
            [32.57672809099056, 1.053499054815028],
            [32.57145276233234, 1.058935618072766],
            [32.57069392936071, 1.060274478934076],
            [32.56906448963989, 1.068868966057538],
            [32.56937746807476, 1.072306896630778],
            [32.57029501808574, 1.074876394360838],
            [32.57310348044731, 1.079192245976783],
            [32.574046633342185, 1.083489739474438],
            [32.57523750565982, 1.08589643017248],
            [32.57750920846946, 1.088294227237264],
            [32.58266949707575, 1.09262850508012],
            [32.58589294516595, 1.096265884435542],
            [32.589760707198764, 1.102192266817131],
            [32.592176447677666, 1.105141953074899],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1345,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "KAKOOGE",
        Population: 20437,
        Key: "NAKASONGOLAKAKOOGE",
        Dist2: "Nakasongola",
        "Sub Country": "Kakooge",
        id2_original: "NakasongolaKakooge",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.66370090977556, 1.439868691413315],
            [32.65483395671131, 1.436175586295663],
            [32.639915645567704, 1.436539460294991],
            [32.62536103353656, 1.438001879542196],
            [32.60712607948193, 1.455293902181482],
            [32.58862100920791, 1.365914560189019],
            [32.584928847151886, 1.345521822751985],
            [32.58363154154108, 1.342671773055908],
            [32.57947845660775, 1.337061875803337],
            [32.57830909175462, 1.333506176951819],
            [32.57715264916687, 1.321699559030732],
            [32.5751116741464, 1.314660594207846],
            [32.57551808365905, 1.306672107467052],
            [32.57512926585463, 1.301958521316965],
            [32.57160885808768, 1.291173826456909],
            [32.57066391844368, 1.284424560223576],
            [32.570864992845316, 1.281357640867963],
            [32.571509494535796, 1.27895123188687],
            [32.57370836284047, 1.275604188203765],
            [32.5783416979045, 1.270972859385054],
            [32.5812872889925, 1.266920254285354],
            [32.5834351428705, 1.262731807454779],
            [32.585235269681846, 1.257577069678589],
            [32.58639319898138, 1.257897766410063],
            [32.59065539418744, 1.261116230798188],
            [32.59953515632933, 1.266838136905268],
            [32.60539596377061, 1.269699303011675],
            [32.60859311727412, 1.268984727563353],
            [32.61374513239664, 1.260762257244697],
            [32.61783068019029, 1.257723835202142],
            [32.62831046492238, 1.253434962374573],
            [32.63843411615334, 1.255581593725233],
            [32.65379757575789, 1.256388144516462],
            [32.65899257436846, 1.2579530461868],
            [32.66436510523201, 1.260221860059531],
            [32.668716589384026, 1.260725205321086],
            [32.67130326758341, 1.259373607259486],
            [32.67230248703013, 1.258256437408735],
            [32.6729576795708, 1.256334768677198],
            [32.67321351796709, 1.25215611029711],
            [32.672248332991536, 1.247418649599627],
            [32.67258136541681, 1.247351653854655],
            [32.67235946537196, 1.246413097147918],
            [32.67684420920653, 1.246368963481085],
            [32.67977477147979, 1.246860936038391],
            [32.681950451572085, 1.24757627285129],
            [32.682971606081395, 1.24860431063795],
            [32.683592992323, 1.25079429100473],
            [32.685280184733415, 1.251956485838686],
            [32.68696700164807, 1.256291808095039],
            [32.68927572223393, 1.258526683369285],
            [32.69167348023746, 1.258839814402478],
            [32.693094449726935, 1.258393063360564],
            [32.70352904920023, 1.260673572778499],
            [32.707435995745726, 1.265858293642543],
            [32.71542798074008, 1.272294845737952],
            [32.719334909319265, 1.278015862242085],
            [32.72128822403934, 1.282306515673922],
            [32.72324173728711, 1.284809484978008],
            [32.7250177515196, 1.286239824924564],
            [32.73602982309182, 1.28802868364014],
            [32.74881795291399, 1.291247823452205],
            [32.77489069794109, 1.296709539184058],
            [32.77312827342222, 1.30482516497824],
            [32.767665311854, 1.318675983113412],
            [32.75598500510145, 1.351181546797632],
            [32.753321848830375, 1.357785749857573],
            [32.750450736164304, 1.362281922602719],
            [32.75034937206425, 1.361838598153178],
            [32.74595656451082, 1.366081281434755],
            [32.74327367764286, 1.367582831835849],
            [32.73839035670663, 1.369382695770131],
            [32.7270382925623, 1.372312713854489],
            [32.71684788482763, 1.374446657682557],
            [32.70897260356509, 1.377892682442919],
            [32.69696725580004, 1.383889454152132],
            [32.69637227194296, 1.450675641328191],
            [32.67739188328914, 1.445697055663407],
            [32.66370090977556, 1.439868691413315],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1346,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "KALUNGI",
        Population: 23776,
        Key: "NAKASONGOLAKALUNGI",
        Dist2: "Nakasongola",
        "Sub Country": "Kalungi",
        id2_original: "NakasongolaKalungi",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.414314442929815, 1.587733398922912],
            [32.41066244814344, 1.590383068995981],
            [32.40421279323679, 1.592579575123529],
            [32.40132163017353, 1.59297678956036],
            [32.38431768965504, 1.593415030279393],
            [32.37728512514703, 1.595529840628368],
            [32.35976834541598, 1.602029015562503],
            [32.35743585630605, 1.603629548942066],
            [32.35080513427578, 1.610611497400421],
            [32.34436682778613, 1.614020023755778],
            [32.34009486968956, 1.615339448187596],
            [32.330611447761584, 1.617335635439874],
            [32.32506563008311, 1.619866848301486],
            [32.3232089812741, 1.621521762216996],
            [32.32057725346154, 1.625664239785839],
            [32.31712162410806, 1.636220496786933],
            [32.31254904659829, 1.643221017146608],
            [32.3042723971685, 1.635456131016813],
            [32.29793451424275, 1.628469926557564],
            [32.29523690668223, 1.622371568323071],
            [32.29240694673761, 1.618833354221631],
            [32.29089803218183, 1.614951833676151],
            [32.291900125339126, 1.610003698456686],
            [32.29507008144912, 1.600216381622307],
            [32.29875011624878, 1.593007504559405],
            [32.29909668987864, 1.589940821790864],
            [32.29918886151839, 1.572299958457565],
            [32.30026520941707, 1.561742921916964],
            [32.300231466000064, 1.557599560727171],
            [32.30208880112196, 1.555356619799817],
            [32.306111169503346, 1.553132486585677],
            [32.314038751580036, 1.545174048510969],
            [32.320945746882664, 1.53528828958166],
            [32.32666255977381, 1.523158529500889],
            [32.326996848043855, 1.52045368007616],
            [32.32670158079309, 1.516002625799518],
            [32.32722563457365, 1.514618649793556],
            [32.331712566704226, 1.511381337872113],
            [32.33479472776655, 1.509672467572085],
            [32.33995914053831, 1.507593314651064],
            [32.345802439814726, 1.503904036748283],
            [32.35052770038007, 1.499201167868272],
            [32.35173032805152, 1.497184109454673],
            [32.35239021518786, 1.497120978550585],
            [32.35906888838966, 1.488664264094866],
            [32.36266168958872, 1.483101570593165],
            [32.36533180061672, 1.473123787035529],
            [32.367585679054486, 1.468718667542987],
            [32.376807658895444, 1.460895828752516],
            [32.37767038023307, 1.459719989970909],
            [32.378469004080195, 1.459462461885424],
            [32.38415129651157, 1.449647606308385],
            [32.394241452260566, 1.44066118174549],
            [32.39458256682846, 1.437578922419786],
            [32.39555510002304, 1.440132758499272],
            [32.39839124846162, 1.444046451098544],
            [32.40375034771503, 1.444153630077296],
            [32.40963545907631, 1.441934317706382],
            [32.40962719547401, 1.44218596658401],
            [32.41452309102758, 1.43659494615805],
            [32.4185169666448, 1.433423312577731],
            [32.42157924080335, 1.432702833118859],
            [32.42235355354397, 1.435965959319562],
            [32.42315037986224, 1.437549360086443],
            [32.42732349363316, 1.441313908536991],
            [32.431155917739304, 1.443784668157145],
            [32.4433658163861, 1.455078213501657],
            [32.44396979687074, 1.456350930066421],
            [32.448554846589914, 1.465492457750992],
            [32.451506633358434, 1.472694509061367],
            [32.45284808308064, 1.473545248576441],
            [32.45406071259444, 1.475056379235877],
            [32.45466194423434, 1.477073984110911],
            [32.45486423764981, 1.484971967561297],
            [32.44690146227521, 1.494577755559072],
            [32.442968211261565, 1.497209392886888],
            [32.434589182635484, 1.505068948483449],
            [32.42888768961322, 1.511318821612716],
            [32.42592313868284, 1.515579096228688],
            [32.42431495130499, 1.520563473921373],
            [32.41987435697173, 1.52712122794267],
            [32.41777835475023, 1.531445040377606],
            [32.41624155828464, 1.536139920640366],
            [32.416084739385504, 1.540500447157825],
            [32.41425995831119, 1.550379069812854],
            [32.41464480646037, 1.567703837386395],
            [32.414314442929815, 1.587733398922912],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1347,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "LWABIYATA",
        Population: 15610,
        Key: "NAKASONGOLALWABIYATA",
        Dist2: "Nakasongola",
        "Sub Country": "Lwabyata",
        id2_original: "NakasongolaLwabyata",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.54919521711411, 1.522984442727622],
            [32.545661247481355, 1.522627910572677],
            [32.541993338141374, 1.520701439782628],
            [32.535593952059735, 1.516099203094912],
            [32.53349360019562, 1.515402401947425],
            [32.53164024461043, 1.515277650733022],
            [32.52968789198601, 1.515849223002693],
            [32.525387194088566, 1.519752783659205],
            [32.52149712958222, 1.52172731437906],
            [32.51834499964074, 1.522368942273893],
            [32.51340459615808, 1.521309329275769],
            [32.51047952708277, 1.52163435267723],
            [32.506028724294595, 1.525776837377904],
            [32.500833198372966, 1.534641641276154],
            [32.497821754486445, 1.537861643551027],
            [32.494537891998434, 1.539507405809114],
            [32.48380463952408, 1.543666399591636],
            [32.46933389780114, 1.551244116128179],
            [32.46512057274315, 1.55449088282151],
            [32.46228735640566, 1.558054634399498],
            [32.459645138965534, 1.560605176237825],
            [32.4567652731153, 1.561970508155323],
            [32.452255475267485, 1.563272078050089],
            [32.44870912415513, 1.565089564640999],
            [32.436378104760266, 1.576458155648539],
            [32.427251093014526, 1.579196837451659],
            [32.42318136634965, 1.580887460669172],
            [32.414314442929815, 1.587733398922912],
            [32.41464480646037, 1.567703837386395],
            [32.41425995831119, 1.550379069812854],
            [32.416084739385504, 1.540500447157825],
            [32.41624155828464, 1.536139920640366],
            [32.41777835475023, 1.531445040377606],
            [32.41987435697173, 1.52712122794267],
            [32.42431495130499, 1.520563473921373],
            [32.42592313868284, 1.515579096228688],
            [32.42888768961322, 1.511318821612716],
            [32.434589182635484, 1.505068948483449],
            [32.442968211261565, 1.497209392886888],
            [32.44690146227521, 1.494577755559072],
            [32.45486423764981, 1.484971967561297],
            [32.45466194423434, 1.477073984110911],
            [32.45406071259444, 1.475056379235877],
            [32.45284808308064, 1.473545248576441],
            [32.451506633358434, 1.472694509061367],
            [32.448554846589914, 1.465492457750992],
            [32.44396979687074, 1.456350930066421],
            [32.44673545630565, 1.455331133421568],
            [32.453776941084406, 1.451314134204215],
            [32.45966290315027, 1.445604727469298],
            [32.46773519483608, 1.439441901837295],
            [32.471730844626, 1.434648106033726],
            [32.47331061918969, 1.43131015996583],
            [32.476777067852446, 1.427646954634652],
            [32.47940997874625, 1.425503435862615],
            [32.48472245813136, 1.423568595792177],
            [32.48885174669281, 1.42283671983183],
            [32.491756353044266, 1.42295497710544],
            [32.49261756611053, 1.423244670760204],
            [32.49365947619448, 1.424502427626211],
            [32.49494686260794, 1.424665557957399],
            [32.49218975154131, 1.419327248113039],
            [32.49026669657156, 1.416458939948533],
            [32.48261518923955, 1.411608073276946],
            [32.47660016442018, 1.40483961467635],
            [32.47363383033396, 1.400767828073676],
            [32.4788001798735, 1.392436769319912],
            [32.48270680122885, 1.383254996499524],
            [32.485759161579935, 1.380541583762629],
            [32.49060929785126, 1.377928068524673],
            [32.49082340411268, 1.376344898502187],
            [32.48993168425939, 1.371631246075239],
            [32.4906017007989, 1.368718273214597],
            [32.50102940570237, 1.354136777714841],
            [32.50381793893937, 1.351414217596824],
            [32.506737318983994, 1.351704319650913],
            [32.50769251649022, 1.352491602189954],
            [32.50915656738406, 1.355395980436804],
            [32.509064278065054, 1.358933328682843],
            [32.51101249754086, 1.36380100103316],
            [32.51347038697287, 1.368180242429014],
            [32.51657045954366, 1.372442003615602],
            [32.51863405953286, 1.370768731370074],
            [32.523572132785645, 1.36506107342498],
            [32.52483126808172, 1.364491363632225],
            [32.5328570836297, 1.367650135100661],
            [32.54821060876548, 1.371995890776799],
            [32.55325843099316, 1.372566809368471],
            [32.56181382316406, 1.372405558642617],
            [32.57030138354783, 1.373031358320376],
            [32.57748597893451, 1.36954048378536],
            [32.58106886991936, 1.366935563517238],
            [32.58862100920791, 1.365914560189019],
            [32.60712607948193, 1.455293902181482],
            [32.59151607904431, 1.471322516783434],
            [32.58062454970511, 1.484257770053072],
            [32.57666892794595, 1.489839041400225],
            [32.57711362904588, 1.489848175076281],
            [32.57278914016644, 1.501165189030086],
            [32.57018963761809, 1.510608164537774],
            [32.568350566144254, 1.514843257898304],
            [32.56506023129462, 1.519126737074928],
            [32.5623508522106, 1.521073522002381],
            [32.55780335656185, 1.522387037835664],
            [32.54919521711411, 1.522984442727622],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1348,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "LWAMPANGA",
        Population: 29679,
        Key: "NAKASONGOLALWAMPANGA",
        Dist2: "Nakasongola",
        "Sub Country": "Lwampanga",
        id2_original: "NakasongolaLwampanga",
        drought: "H",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.58712267500954, 1.651179910343072],
            [32.578464875794566, 1.648784708027666],
            [32.566918762972456, 1.646560829724364],
            [32.557240175760775, 1.645875187125608],
            [32.54314633030014, 1.647068107165827],
            [32.5154662503964, 1.656972218656885],
            [32.496796358132336, 1.662123124282535],
            [32.465163955083185, 1.67939231015792],
            [32.4560359767502, 1.683750365360358],
            [32.44924092680333, 1.686154908454335],
            [32.43756710319222, 1.689082722500707],
            [32.4311534545588, 1.689904102777142],
            [32.42115034017097, 1.690181576717775],
            [32.41505874834669, 1.689772630451285],
            [32.409716670371274, 1.688613011611199],
            [32.40457757661577, 1.687019196460076],
            [32.398974735679715, 1.684258190841343],
            [32.39576313457145, 1.682013588878128],
            [32.393111275513384, 1.679443475971835],
            [32.386130655188396, 1.671570594715387],
            [32.37830563736096, 1.663543646246208],
            [32.3705154606918, 1.65747079599846],
            [32.360250225988906, 1.651605206291944],
            [32.354909170296295, 1.649586049583934],
            [32.344547136731634, 1.647112889435292],
            [32.330853762919574, 1.644882822424461],
            [32.315625254525216, 1.643213036203726],
            [32.31254904659829, 1.643221017146608],
            [32.31712162410806, 1.636220496786933],
            [32.32057725346154, 1.625664239785839],
            [32.3232089812741, 1.621521762216996],
            [32.32506563008311, 1.619866848301486],
            [32.330611447761584, 1.617335635439874],
            [32.34009486968956, 1.615339448187596],
            [32.34436682778613, 1.614020023755778],
            [32.35080513427578, 1.610611497400421],
            [32.35743585630605, 1.603629548942066],
            [32.35976834541598, 1.602029015562503],
            [32.37728512514703, 1.595529840628368],
            [32.38431768965504, 1.593415030279393],
            [32.40132163017353, 1.59297678956036],
            [32.40421279323679, 1.592579575123529],
            [32.41066244814344, 1.590383068995981],
            [32.414314442929815, 1.587733398922912],
            [32.42318136634965, 1.580887460669172],
            [32.427251093014526, 1.579196837451659],
            [32.436378104760266, 1.576458155648539],
            [32.44870912415513, 1.565089564640999],
            [32.452255475267485, 1.563272078050089],
            [32.4567652731153, 1.561970508155323],
            [32.459645138965534, 1.560605176237825],
            [32.46228735640566, 1.558054634399498],
            [32.46512057274315, 1.55449088282151],
            [32.46933389780114, 1.551244116128179],
            [32.48380463952408, 1.543666399591636],
            [32.494537891998434, 1.539507405809114],
            [32.497821754486445, 1.537861643551027],
            [32.500833198372966, 1.534641641276154],
            [32.506028724294595, 1.525776837377904],
            [32.51047952708277, 1.52163435267723],
            [32.51340459615808, 1.521309329275769],
            [32.51834499964074, 1.522368942273893],
            [32.52149712958222, 1.52172731437906],
            [32.525387194088566, 1.519752783659205],
            [32.52968789198601, 1.515849223002693],
            [32.53164024461043, 1.515277650733022],
            [32.53349360019562, 1.515402401947425],
            [32.535593952059735, 1.516099203094912],
            [32.541993338141374, 1.520701439782628],
            [32.545661247481355, 1.522627910572677],
            [32.54919521711411, 1.522984442727622],
            [32.563750461559216, 1.535313611182509],
            [32.58357048754279, 1.547913429320452],
            [32.585803234910124, 1.548420504827427],
            [32.58741941190406, 1.548547481120287],
            [32.589905195822304, 1.548041332366668],
            [32.62326020736197, 1.539090942674365],
            [32.623971135874456, 1.539715318559187],
            [32.62990540843799, 1.542140990056737],
            [32.64119590564602, 1.542279869580589],
            [32.65076583264089, 1.541918364875171],
            [32.660214245425614, 1.529072972455404],
            [32.66166759918109, 1.52489342567653],
            [32.66326022773818, 1.497390368552211],
            [32.66370090977556, 1.439868691413315],
            [32.67739188328914, 1.445697055663407],
            [32.69637227194296, 1.450675641328191],
            [32.70925846455647, 1.453056757835935],
            [32.71836726924804, 1.454188820432029],
            [32.735438032745584, 1.455430369728775],
            [32.739882443122184, 1.456245140012194],
            [32.77637862785184, 1.466544838966828],
            [32.7848613615876, 1.467875621325578],
            [32.80762473556588, 1.472889889154548],
            [32.820144686834695, 1.474980857749987],
            [32.75222696599242, 1.552047488431307],
            [32.74936927774993, 1.554399423079461],
            [32.749380704320345, 1.555168437300269],
            [32.73542995868781, 1.56832134605197],
            [32.73150224668621, 1.576372844403771],
            [32.73034895449018, 1.578035981119642],
            [32.72081809432868, 1.602371005182626],
            [32.717050059665446, 1.610158374866943],
            [32.714008895017756, 1.614480488935708],
            [32.71460372885619, 1.616436193502605],
            [32.7125181309223, 1.617478124215328],
            [32.70671659432348, 1.619050824967835],
            [32.701843910338546, 1.622379619389226],
            [32.69692605546786, 1.62459095403187],
            [32.691645153661625, 1.629789653156658],
            [32.689318720095, 1.63117656629936],
            [32.68748556402731, 1.631468025095217],
            [32.68811213983628, 1.63037747122988],
            [32.68898249595551, 1.625608082657412],
            [32.68898301428343, 1.62222570178411],
            [32.68532894169377, 1.60928043322778],
            [32.680728578393975, 1.609093037744347],
            [32.677752741030375, 1.609513061677295],
            [32.67527499164403, 1.608457475179735],
            [32.67086021219706, 1.607784732316295],
            [32.66633396978967, 1.608157340561973],
            [32.66455191798016, 1.608746175115417],
            [32.66145243200928, 1.608572517492592],
            [32.660105213306316, 1.608273555629339],
            [32.6567944256143, 1.606526535931891],
            [32.64830021949403, 1.604112208731349],
            [32.65076450762584, 1.615188865963328],
            [32.64427118022337, 1.611552948481851],
            [32.63500277455022, 1.607507239705256],
            [32.62819960832477, 1.605352793063951],
            [32.624183043958396, 1.605098734258166],
            [32.62115078790338, 1.6054419598599],
            [32.61900787296279, 1.606409597007522],
            [32.61084698403378, 1.61151060068927],
            [32.6078202795672, 1.613627031116002],
            [32.60449277063449, 1.616729528462002],
            [32.595957847475646, 1.634650065967293],
            [32.5896716958322, 1.645830941799255],
            [32.58712267500954, 1.651179910343072],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1796,
        District: "AMOLATAR",
        County: "KIOGA",
        Subcounty: "NAMASALE",
        Population: 20021,
        Key: "AMOLATARNAMASALE",
        Dist2: "Amolatar",
        "Sub Country": "Namasale S/C",
        id2_original: "Amolatar Namasale S/C",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "M",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "N",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.25899192414367, 2.253818361235201],
            [32.25279826124526, 2.251638929283811],
            [32.25066625634378, 2.2485710812641],
            [32.25070088100811, 2.246807040687896],
            [32.24874916079761, 2.246769845813576],
            [32.24798716306123, 2.244281678286532],
            [32.24732099220947, 2.243449060603034],
            [32.24413467328659, 2.241330539675884],
            [32.24330265007717, 2.241140132110391],
            [32.23703813076406, 2.24308184055911],
            [32.23203423795041, 2.243504385826233],
            [32.22938440100007, 2.245194661719549],
            [32.22702919169995, 2.246125188664895],
            [32.222866218111974, 2.246376264257269],
            [32.2220683578328, 2.244304213192876],
            [32.22118577743921, 2.24354384370052],
            [32.21790629333989, 2.242863603191123],
            [32.214059806107976, 2.241468386612477],
            [32.21351377953554, 2.240409666368824],
            [32.21309446841882, 2.237822176918557],
            [32.211203031452136, 2.23651847709961],
            [32.20601306430548, 2.231350188828559],
            [32.20281815030193, 2.22973819859011],
            [32.2008432391841, 2.227457440599705],
            [32.193738471686814, 2.22487533930749],
            [32.19256187988727, 2.223771039376454],
            [32.19111296201267, 2.22064021207068],
            [32.19039966104952, 2.21768167073833],
            [32.18922284556946, 2.217002547505524],
            [32.18543879663967, 2.216747159108289],
            [32.1769392069159, 2.218144601940782],
            [32.17668550112012, 2.209912332205203],
            [32.178305914568966, 2.125466000298392],
            [32.17768245411736, 2.115216200956497],
            [32.17784802440402, 2.113497490680008],
            [32.17930717139474, 2.108830371650761],
            [32.17925850246929, 2.106794925885088],
            [32.17779545589191, 2.103917423278767],
            [32.177579689543805, 2.100624451791915],
            [32.17592670138614, 2.098271536217399],
            [32.17328727590993, 2.095664799132801],
            [32.16893661551298, 2.093572787303185],
            [32.16635716336179, 2.091843567849446],
            [32.16459730263474, 2.089716749991217],
            [32.164929287624396, 2.088405216860657],
            [32.164501164034704, 2.087663193002334],
            [32.16363351633609, 2.087554173100997],
            [32.163395267851364, 2.086432306608254],
            [32.16261081313119, 2.086287146217359],
            [32.16215902342536, 2.085671757363152],
            [32.162538276866954, 2.083708918808472],
            [32.161967319350474, 2.082614013550287],
            [32.16227580800555, 2.081628135032354],
            [32.1619537152638, 2.079113097968576],
            [32.16242829163513, 2.078082076084474],
            [32.16197575542929, 2.076218301975707],
            [32.16243836264779, 2.074436432447718],
            [32.16200992824104, 2.073224002878877],
            [32.16198511048466, 2.071260947756762],
            [32.159381279853264, 2.068409984327269],
            [32.157977695459486, 2.06583104907207],
            [32.156765431560004, 2.06545045757748],
            [32.15500578732696, 2.064038299918324],
            [32.1534007153065, 2.062047263646788],
            [32.152093689924335, 2.062336042966933],
            [32.15183170435654, 2.061476508774594],
            [32.15054843582034, 2.06147581931496],
            [32.14969206018191, 2.060281254639159],
            [32.1491216901636, 2.060217624109071],
            [32.14871727491091, 2.059303735400961],
            [32.149738410555614, 2.057657867372248],
            [32.15119969823168, 2.05736012510343],
            [32.156568135472455, 2.052188529485497],
            [32.15666287449727, 2.051564387009138],
            [32.15812411096934, 2.05081432190974],
            [32.16266412724499, 2.052191755062162],
            [32.164850449678426, 2.051713453949033],
            [32.168711489617955, 2.050078099614369],
            [32.175854058222356, 2.051393533711545],
            [32.1798930310635, 2.049070720656162],
            [32.18477603040284, 2.047399659532859],
            [32.18565545591316, 2.046463941173975],
            [32.18699668015823, 2.046097896570007],
            [32.19123386626676, 2.043540057257345],
            [32.19235916246697, 2.041575978079849],
            [32.19304301575681, 2.036422221863929],
            [32.200734617594904, 2.02540698937637],
            [32.202063595107674, 2.022123815946839],
            [32.20269825575422, 2.009603949703548],
            [32.195814178271135, 2.002770549328623],
            [32.189258413464806, 1.996932402644632],
            [32.19056174856783, 1.995366408688682],
            [32.18833082567883, 1.990980531377293],
            [32.18533484269669, 1.986732230054908],
            [32.183522196963565, 1.982722656602509],
            [32.18206425641025, 1.979387988121461],
            [32.18215626186164, 1.976621518480754],
            [32.18075472023683, 1.97582389394002],
            [32.18569802617614, 1.969256697655149],
            [32.18765852113032, 1.965064643620284],
            [32.17893946310117, 1.957355618835464],
            [32.17754561464847, 1.957468334713713],
            [32.176757076187016, 1.95687415761833],
            [32.17361982683822, 1.956323597726815],
            [32.16864167974058, 1.954399594910709],
            [32.16734578628141, 1.954330321222888],
            [32.165298465561776, 1.956593950615166],
            [32.16222814159994, 1.958651181225996],
            [32.157950790018425, 1.959351674892648],
            [32.15654661992308, 1.955056967590797],
            [32.15503982089979, 1.952798911424222],
            [32.151621221898964, 1.949170709989184],
            [32.14881562516316, 1.947101668928442],
            [32.15181350179395, 1.940266274257628],
            [32.149669556485726, 1.938016992245103],
            [32.14743602488915, 1.934103029508152],
            [32.14600246191774, 1.932529602077117],
            [32.1418843951108, 1.930362738224218],
            [32.14127817871941, 1.929122773215709],
            [32.14126071816523, 1.927272530201236],
            [32.141739946013125, 1.925052492344131],
            [32.14337780474477, 1.922574007245998],
            [32.14478249855793, 1.921233383059249],
            [32.15740670290872, 1.916246474977135],
            [32.16074835581557, 1.915488772775433],
            [32.168927800345095, 1.914651135188062],
            [32.17487687175461, 1.913251271483321],
            [32.17775906513976, 1.911288800509246],
            [32.180217109082, 1.898745033899339],
            [32.18028532085647, 1.898419447677992],
            [32.19293510293835, 1.908460621835844],
            [32.197750235456304, 1.90270784173448],
            [32.201855628831204, 1.896240283621852],
            [32.20623532008318, 1.893702147700247],
            [32.21475647745856, 1.891999381071519],
            [32.22509061294376, 1.893790124639908],
            [32.22808859288082, 1.893672400972918],
            [32.23243959373923, 1.890524587946976],
            [32.232026867273525, 1.891370240473782],
            [32.236972887921596, 1.89342976203824],
            [32.24812096532617, 1.895190496160531],
            [32.2502883207307, 1.894776733068217],
            [32.26303702888494, 1.896585141130264],
            [32.27786976561624, 1.894650698309862],
            [32.280161999421665, 1.895057892054315],
            [32.30357909719516, 1.884386127794949],
            [32.30567129684806, 1.880362802869508],
            [32.31204007103977, 1.871520727006966],
            [32.317880847846865, 1.864616774923345],
            [32.32695603488553, 1.858110942457718],
            [32.32965058817412, 1.849155160924239],
            [32.33486878398026, 1.850750109941383],
            [32.33942488189616, 1.853067772121681],
            [32.34197253907619, 1.855701308137226],
            [32.34359594571156, 1.860288578359141],
            [32.34336411479127, 1.86416951336302],
            [32.34046182699155, 1.870682020398116],
            [32.33923455763352, 1.87667949259586],
            [32.33958669902154, 1.881673384164063],
            [32.34360665362976, 1.891065355836655],
            [32.34416015238869, 1.895579855408197],
            [32.34198318770558, 1.918467084517496],
            [32.34234715092271, 1.923343377827205],
            [32.34351788840157, 1.92724294476276],
            [32.34451916139706, 1.92904361993026],
            [32.347541872852176, 1.931360738519807],
            [32.35295516656838, 1.934393461738942],
            [32.35652674327219, 1.93795922500577],
            [32.36107551632524, 1.943198996387955],
            [32.36297059865537, 1.946537949520934],
            [32.36364095835131, 1.949695501910311],
            [32.36362136699328, 1.952472830969734],
            [32.36325451928577, 1.953657808773008],
            [32.3603107338115, 1.956452110318098],
            [32.358528478084416, 1.957148019883939],
            [32.35270484382793, 1.95786045389976],
            [32.34693803519967, 1.956953534047296],
            [32.34103972489191, 1.955368045435895],
            [32.339827273244524, 1.955412798581069],
            [32.33791392636804, 1.955782951971441],
            [32.33682122643623, 1.956406735928844],
            [32.334565766065246, 1.958604172019803],
            [32.333553311739465, 1.965180676301953],
            [32.33354481547347, 1.96746947390701],
            [32.33559525873705, 1.971441775913997],
            [32.33896609611087, 1.976020733354955],
            [32.33906444815975, 1.978128643027518],
            [32.33649580723296, 1.98557300064658],
            [32.3364522506198, 1.988395537497745],
            [32.337386594635, 1.99315445219813],
            [32.33999295402393, 1.997579319226278],
            [32.340646971568226, 2.004210780788158],
            [32.3434558471548, 2.013792327333455],
            [32.343960190101384, 2.018786286520681],
            [32.34366233031277, 2.034138340498874],
            [32.344981284423596, 2.041864725186962],
            [32.34575889937121, 2.043701514707015],
            [32.350116245030485, 2.052930895830937],
            [32.35072293483401, 2.060530343645409],
            [32.35252648422656, 2.070699537063104],
            [32.352774369837654, 2.074426783682512],
            [32.352446608726446, 2.075856381183276],
            [32.3515879459773, 2.077185668295326],
            [32.34476371336012, 2.081498757956568],
            [32.343366060542145, 2.083189718919749],
            [32.341821338240834, 2.090739130908345],
            [32.33920781029594, 2.093803199475347],
            [32.33243724662708, 2.099726728252571],
            [32.330175958884894, 2.103196730081033],
            [32.32909798773046, 2.106098306070274],
            [32.32857850817132, 2.10793994401509],
            [32.32873426077023, 2.112191373623353],
            [32.33260431440533, 2.122564156199713],
            [32.33276973557164, 2.124838709081609],
            [32.33174910837336, 2.126841152479955],
            [32.32898209697398, 2.129797122222945],
            [32.32098195707347, 2.13614643033765],
            [32.31878130201968, 2.140587717041594],
            [32.318451735294744, 2.146811312723325],
            [32.321173909083356, 2.155586516158505],
            [32.32209047004922, 2.166380068862029],
            [32.32145561177331, 2.171576516125264],
            [32.317311112937475, 2.184143230027225],
            [32.31677023460993, 2.186848825037034],
            [32.31725695081404, 2.193447450407321],
            [32.316873229152215, 2.194828725000413],
            [32.31008220725109, 2.203652097127112],
            [32.30724306023606, 2.208832818631639],
            [32.30404840494735, 2.212814375097499],
            [32.30325539557071, 2.213564172737774],
            [32.301274984068385, 2.214160184636074],
            [32.2983501566399, 2.214131280479659],
            [32.2969809947895, 2.215372578843549],
            [32.29659041718543, 2.216292089028795],
            [32.29725486506846, 2.218595243382991],
            [32.29659441199349, 2.220269714428347],
            [32.29527963864195, 2.221973236588406],
            [32.29319710126824, 2.223207467541003],
            [32.290843121761746, 2.225338712586001],
            [32.2901379487553, 2.226752297572978],
            [32.289660457350855, 2.229091510682144],
            [32.28417929950823, 2.237714544771276],
            [32.28261779667741, 2.239143329981811],
            [32.277995561197045, 2.241003478090821],
            [32.27321096511056, 2.24573863803414],
            [32.27087617002528, 2.246733897739055],
            [32.26775940406157, 2.248753747654235],
            [32.262833285588584, 2.250161919843823],
            [32.2618421015721, 2.253044187701831],
            [32.260913465452184, 2.25368951590497],
            [32.25899192414367, 2.253818361235201],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1799,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "MUTUNDA",
        Population: 63186,
        Key: "KIRYANDONGOMUTUNDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.127104862000486, 1.397497321528444],
            [32.12773864678964, 1.400256665148518],
            [32.13010849593394, 1.401786371017799],
            [32.13533828988872, 1.403498069363608],
            [32.14228035362341, 1.404568108633877],
            [32.14484261291843, 1.405383222070555],
            [32.162069230524494, 1.417439232980742],
            [32.16975409409962, 1.424733381347819],
            [32.17065773190181, 1.427076714899653],
            [32.17066802030677, 1.42893122091175],
            [32.157739368821346, 1.437212907676152],
            [32.14987863307991, 1.446790004699455],
            [32.155373535146396, 1.455033266421169],
            [32.15798528532533, 1.458128092316626],
            [32.16587467013784, 1.464698695549582],
            [32.17300170507437, 1.471377567150293],
            [32.18274867563869, 1.481323155729806],
            [32.184543464660614, 1.484860956914444],
            [32.18825622149282, 1.486979188667297],
            [32.18930358614718, 1.488083236726718],
            [32.18785900444047, 1.493157723420514],
            [32.18511903772101, 1.497046644088568],
            [32.18442039367007, 1.497145892003967],
            [32.18362024807682, 1.499769040975506],
            [32.183158332561085, 1.50383973593649],
            [32.18381230878288, 1.510534301088797],
            [32.185289055566635, 1.51422578221655],
            [32.18722890723558, 1.523744482913212],
            [32.19542616535721, 1.533778870012166],
            [32.197825070509374, 1.537598791480814],
            [32.199255976264176, 1.538113696341705],
            [32.206227818252216, 1.549447670898533],
            [32.20500228354104, 1.553881212196152],
            [32.20281417705343, 1.555098271492404],
            [32.20056902844364, 1.561562338709023],
            [32.19761156701746, 1.566744791061986],
            [32.20132350189119, 1.572758760931414],
            [32.201322059196855, 1.57654247821903],
            [32.203522430382996, 1.583440664063019],
            [32.20294982355965, 1.590557204081976],
            [32.18873581675163, 1.609177917511076],
            [32.18178155389539, 1.622084277419553],
            [32.17149430867141, 1.635016321662199],
            [32.16356311985886, 1.647695946015321],
            [32.158383044061765, 1.654044254360669],
            [32.15418122013438, 1.657489092412272],
            [32.14310736243689, 1.670845633997068],
            [32.138117569579954, 1.669595050403326],
            [32.131954442214635, 1.666905583839132],
            [32.126755505389895, 1.664126074825515],
            [32.11107043993049, 1.651110588299809],
            [32.10806334748321, 1.64889291558756],
            [32.105320829548326, 1.647435240571631],
            [32.10286622974688, 1.646665203182832],
            [32.09973519314658, 1.646500949405535],
            [32.09654858945775, 1.647467435454509],
            [32.09557515615124, 1.648208775153155],
            [32.094666890228744, 1.647095682132129],
            [32.092806540360755, 1.646108799990032],
            [32.09189727371502, 1.644733368433016],
            [32.09122150166951, 1.642001123190403],
            [32.09049189897889, 1.64089715882701],
            [32.086585740255885, 1.640325458395046],
            [32.0833668834551, 1.638749949304833],
            [32.08367462201693, 1.634742658049641],
            [32.08436024139459, 1.633711714585194],
            [32.090364232207335, 1.624342659803773],
            [32.09123561060935, 1.618092168012249],
            [32.09131280912992, 1.616319158167764],
            [32.0908558190769, 1.614934891893651],
            [32.086042719446446, 1.61355770418609],
            [32.08480104470452, 1.612399236066241],
            [32.08416564743945, 1.611087260103124],
            [32.084399867878425, 1.609965645577833],
            [32.08967394428512, 1.606892337855054],
            [32.090822786227264, 1.605183131984909],
            [32.08923488999508, 1.596706184243908],
            [32.08977527694414, 1.591152093303277],
            [32.088986849873756, 1.590319497262515],
            [32.08812930552714, 1.590156285055527],
            [32.08107992006544, 1.585666257471444],
            [32.07936683641189, 1.585909735188985],
            [32.07637378463251, 1.58776284337191],
            [32.0743486576903, 1.587273440476595],
            [32.07351103438338, 1.585916147601241],
            [32.07329223891616, 1.584586271607569],
            [32.07497497388614, 1.582461194307386],
            [32.07525444785587, 1.580624959691718],
            [32.07445223074761, 1.579240545442152],
            [32.072901776296455, 1.578271915849008],
            [32.073083517156526, 1.5757481345596],
            [32.07282071322351, 1.575467587213776],
            [32.07134633978872, 1.57587400020104],
            [32.06980654834001, 1.578098647173722],
            [32.06883240266951, 1.578650018750108],
            [32.067358270881506, 1.579137841450909],
            [32.06375099333165, 1.578882917358924],
            [32.06329304118297, 1.577173000416816],
            [32.06236042552635, 1.57594231099418],
            [32.06314212421524, 1.574820952116665],
            [32.062785984425894, 1.571573248839103],
            [32.06207042150488, 1.57116585172839],
            [32.060002316464505, 1.571988107162896],
            [32.05695486450813, 1.57181484694485],
            [32.05680916854882, 1.570982543072456],
            [32.05756499755416, 1.569291272457841],
            [32.05676816135442, 1.56596196026736],
            [32.05556070164507, 1.564387397916699],
            [32.05541055633018, 1.562198183269191],
            [32.054857866054974, 1.560660103106892],
            [32.05387727048071, 1.559329888643348],
            [32.05236350771737, 1.55865979504614],
            [32.050815799416036, 1.558523401315784],
            [32.049861310680555, 1.5578626060785],
            [32.050070193238625, 1.556225367363092],
            [32.049780027520384, 1.55495878936296],
            [32.04724252848956, 1.550841689023571],
            [32.048632634560825, 1.546599726218269],
            [32.047361442076976, 1.543722510450543],
            [32.04602431504794, 1.542564014206173],
            [32.03986970820309, 1.54218129094578],
            [32.03901470519039, 1.54268747881153],
            [32.03849804274801, 1.544758780810226],
            [32.03754703318762, 1.545129233489722],
            [32.03637725780445, 1.544133637726198],
            [32.03328287156942, 1.54415031338325],
            [32.030189875028135, 1.541109439157018],
            [32.0295944456067, 1.540946338061348],
            [32.023102591441265, 1.542861093436189],
            [32.01960832015751, 1.540824130541672],
            [32.016742737520296, 1.53809996604991],
            [32.01569553186772, 1.538153755747198],
            [32.01510427961235, 1.53930231632281],
            [32.01415478910312, 1.540043641980766],
            [32.012868641466454, 1.539880214832853],
            [32.01046441110127, 1.536314990545886],
            [32.00879270295139, 1.534704032935887],
            [32.008269371416326, 1.534758064278819],
            [32.005919090273856, 1.536647562891925],
            [32.003423148206394, 1.53765953344329],
            [32.00295272564491, 1.539305669421612],
            [32.003221692919084, 1.541395404165039],
            [32.00289174351185, 1.542381253531031],
            [32.001965858033344, 1.54309544267025],
            [32.00084210064722, 1.54286876316545],
            [32.00087716368939, 1.535143569955008],
            [31.998902637050488, 1.53419281890356],
            [31.997415785118093, 1.532554808525702],
            [31.997368207645685, 1.531577827705336],
            [31.99791526458572, 1.530637311312728],
            [31.999889730139188, 1.528684324498399],
            [31.999485222360033, 1.526911135430221],
            [31.9973798399303, 1.526494034961641],
            [31.99526278658844, 1.527017701547695],
            [31.99381183941963, 1.53031876830487],
            [31.99300312839016, 1.530960644176543],
            [31.989696585237837, 1.53008162490456],
            [31.98879269500906, 1.528235836728592],
            [31.987995584823175, 1.527502741603841],
            [31.989327749558612, 1.525332362149891],
            [31.989232360153522, 1.521478771735624],
            [31.986936595969038, 1.519152895801765],
            [31.98765023739366, 1.518167232420512],
            [31.989481586949317, 1.517091635647734],
            [31.989838504679714, 1.516087710480488],
            [31.98838719818476, 1.514151209469393],
            [31.985913340300247, 1.514267639866136],
            [31.985544553130037, 1.513616162976987],
            [31.98547317389587, 1.511273248868588],
            [31.98590128131588, 1.509997982132043],
            [31.987566333847827, 1.507710157583263],
            [31.987518703374825, 1.506841730695675],
            [31.98578216021764, 1.506415760357264],
            [31.98464028201556, 1.505338765854259],
            [31.984212064102778, 1.505646124296528],
            [31.9843548270627, 1.506704557788653],
            [31.983546095371956, 1.507418800972683],
            [31.98037053467291, 1.507046424557618],
            [31.979014647227487, 1.506521124157688],
            [31.978062915421628, 1.506692545179817],
            [31.976683299876274, 1.505253602625847],
            [31.975303520837514, 1.505370545362126],
            [31.97423301827638, 1.504248353715968],
            [31.971878086555666, 1.504174869907673],
            [31.97291285862641, 1.50301749376339],
            [31.972865275764125, 1.502058612395403],
            [31.974506465448844, 1.500937704993207],
            [31.975648067868107, 1.499572321637007],
            [31.975953252519595, 1.496252639949532],
            [31.97542414571556, 1.495465402921283],
            [31.97361653863285, 1.494469508572144],
            [31.973552858859005, 1.493085465024092],
            [31.971160117946326, 1.492197846334739],
            [31.969857313747653, 1.489899590730189],
            [31.969561464388608, 1.488253110119709],
            [31.968491489138504, 1.487221381801301],
            [31.968371166992746, 1.486235330436194],
            [31.968911348227593, 1.484942031380036],
            [31.969158000451774, 1.482445498273908],
            [31.971866931276477, 1.47985061347482],
            [31.972414723936737, 1.476657688631965],
            [31.971953324053995, 1.473400972067243],
            [31.972453807838118, 1.472288566919153],
            [31.974128576548175, 1.470760597418225],
            [31.975019698123504, 1.469187032601592],
            [31.975152559852347, 1.466102462088765],
            [31.9761553384242, 1.466663765684899],
            [31.980851542083393, 1.465191451715824],
            [31.9824740225557, 1.463735810356493],
            [31.985245202138, 1.463158140466863],
            [31.98668133518948, 1.463222116478947],
            [31.98815612005267, 1.464154513148317],
            [31.9892998487842, 1.46422740110191],
            [31.990007521802102, 1.463947299952734],
            [31.991852137677864, 1.461958040087998],
            [31.995272728243688, 1.462638029187585],
            [31.997730412859827, 1.458342329497185],
            [31.99865620401524, 1.457718576988989],
            [32.00083553755576, 1.457828104552074],
            [32.00335247594634, 1.457349795090004],
            [32.00462316537362, 1.456789513811982],
            [32.01170117116027, 1.451681693976897],
            [32.018867588238855, 1.449278612952758],
            [32.0249401995595, 1.446305127410842],
            [32.029034240025844, 1.445990287367971],
            [32.03767246225581, 1.443669169809819],
            [32.04475121993234, 1.442659023077689],
            [32.04695452501623, 1.441239725781324],
            [32.048950564509525, 1.437712607131846],
            [32.0525165411159, 1.43469271765298],
            [32.055874601751434, 1.433165332490604],
            [32.06363880363415, 1.430563272216996],
            [32.07068615710664, 1.42521991111061],
            [32.07572141909004, 1.423593652848965],
            [32.08272772853721, 1.423225582061189],
            [32.08481596302644, 1.422213250365573],
            [32.089792051185434, 1.41820778750711],
            [32.09482490658214, 1.41553211138178],
            [32.10072834088028, 1.41329097318627],
            [32.104296874091965, 1.410732291130798],
            [32.10781374339497, 1.409584785869964],
            [32.110883641555354, 1.40641979574126],
            [32.11300072723657, 1.406321099732662],
            [32.11557561055626, 1.407100059984097],
            [32.11767941105277, 1.406485720300997],
            [32.12010586843301, 1.404595981268025],
            [32.123898313017435, 1.40035473008598],
            [32.12617834770132, 1.398654893550862],
            [32.127104862000486, 1.397497321528444],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1350,
        District: "NAKASONGOLA",
        County: "BURULI",
        Subcounty: "NAKITOMA",
        Population: 13318,
        Key: "NAKASONGOLANAKITOMA",
        Dist2: "Nakasongola",
        "Sub Country": "Nakitoma",
        id2_original: "NakasongolaNakitoma",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.576124304481592, -0.790880487611379],
            [31.57602091917217, -0.786068772493473],
            [31.57517035743022, -0.784702759124313],
            [31.5738848170547, -0.784313407389932],
            [31.572646038481253, -0.782657829678827],
            [31.570558484016686, -0.780947719659546],
            [31.56905447785561, -0.780630636621879],
            [31.568350535541082, -0.779952061882313],
            [31.56767183049618, -0.780141774775362],
            [31.567221608350494, -0.778911558725175],
            [31.566057541760948, -0.778838809994345],
            [31.565304363684007, -0.77757232472962],
            [31.563654476510695, -0.776938662030973],
            [31.56260992268485, -0.775482142433276],
            [31.561085142084504, -0.777697507806816],
            [31.555284536140313, -0.78381860237642],
            [31.545969556412953, -0.791331264164285],
            [31.539273190891617, -0.798428727104069],
            [31.53212617562654, -0.803907043352375],
            [31.53028358006185, -0.804376681240463],
            [31.524354598575353, -0.804211738060865],
            [31.520826611722367, -0.804517961528514],
            [31.517579383429958, -0.80641608482632],
            [31.515978997920364, -0.806415499182757],
            [31.514426287799527, -0.805808962839539],
            [31.51085108190194, -0.807055753947871],
            [31.507820114031038, -0.807226482486834],
            [31.50525657823005, -0.809106737015102],
            [31.50420643418817, -0.809296278804637],
            [31.49798245764046, -0.809049770641643],
            [31.49060028948516, -0.808187829548928],
            [31.487416960155514, -0.807426934218155],
            [31.48702062884207, -0.807897080096314],
            [31.487149405931312, -0.808910073184714],
            [31.486378289396466, -0.810049349342588],
            [31.485408714354133, -0.810275087777631],
            [31.48534308882937, -0.810844849210702],
            [31.484213269611693, -0.811658392469373],
            [31.484089762938225, -0.812336653899586],
            [31.482540480788515, -0.813864537925993],
            [31.482588440943214, -0.816279337847954],
            [31.48169017057485, -0.816541273466181],
            [31.480022136534508, -0.818051010879783],
            [31.478209621955386, -0.817010245203606],
            [31.47643319809116, -0.81482994518235],
            [31.474028120614673, -0.814937563247955],
            [31.47304338470529, -0.813698139109881],
            [31.46798953837531, -0.810937779602269],
            [31.46626903284087, -0.813143876049975],
            [31.464064735118612, -0.813197304258328],
            [31.46222158080179, -0.813802546052482],
            [31.461214043853882, -0.814977883643704],
            [31.459249142663236, -0.815275586640196],
            [31.456739240776255, -0.817951649370226],
            [31.455236658444914, -0.817046678065346],
            [31.453801689610074, -0.817009941603889],
            [31.451479318225157, -0.818275205718563],
            [31.450120972989104, -0.817578295466997],
            [31.448173402096938, -0.819585306949101],
            [31.447523728805365, -0.821013994754082],
            [31.44772271372563, -0.821927516244268],
            [31.449383386970556, -0.822027645635646],
            [31.449505921666905, -0.82243467079991],
            [31.44703347503569, -0.827670173274085],
            [31.447177266566587, -0.829008736946248],
            [31.446769441309044, -0.830871638407551],
            [31.444957708264266, -0.832245609747469],
            [31.443682838975963, -0.832778688319652],
            [31.44275916155643, -0.832696935891119],
            [31.43725609110907, -0.839495791184387],
            [31.430941494312137, -0.849314941221468],
            [31.41267028784591, -0.901942527267971],
            [31.393622409663124, -0.941265376698176],
            [31.389896390104067, -0.948019310780414],
            [31.35288337045549, -0.947549655864501],
            [31.319993384399048, -0.953963652919371],
            [31.305809925700604, -0.957353936092494],
            [31.304912480884003, -0.962244348391963],
            [31.303119434593718, -0.968228312723448],
            [31.299919255564316, -0.975434263718186],
            [31.29787253671594, -0.977235113594688],
            [31.293907475459783, -0.979807212481996],
            [31.28700205131057, -0.981412494031156],
            [31.291919674415933, -0.991454078878857],
            [31.293579596669296, -0.99595964797283],
            [31.29419023816175, -0.99932645530275],
            [31.392241885022674, -0.999732467954865],
            [31.393302354300417, -1.000097197581387],
            [31.42172134523773, -1.000312005930019],
            [31.44114698565873, -1.000142157699234],
            [31.443553890308515, -0.999780646251373],
            [31.477076676600547, -1.000035349013443],
            [31.490229545784235, -0.985163826290525],
            [31.49463508785512, -0.981150212760991],
            [31.50125102990401, -0.976269323372793],
            [31.50635752918773, -0.970031083175576],
            [31.518529228773712, -0.957401601233075],
            [31.525375922866253, -0.953832076950475],
            [31.537241026547477, -0.948980336010892],
            [31.541676389092544, -0.946693991830884],
            [31.54692260874228, -0.943168894610914],
            [31.550410754414095, -0.939832975130225],
            [31.553719317877455, -0.938242533799318],
            [31.563930802783656, -0.929491715918273],
            [31.579461596067727, -0.906705822019199],
            [31.580342854141268, -0.903404909943429],
            [31.583875928153677, -0.896948498927856],
            [31.58410091391156, -0.892326819722135],
            [31.58523577896616, -0.888067285655932],
            [31.585583498846347, -0.884838514345014],
            [31.585369346770822, -0.877883171849414],
            [31.585850660506786, -0.874717762264426],
            [31.585765771509074, -0.864388857946961],
            [31.584367622821095, -0.850966228538477],
            [31.581714724412247, -0.832460141628604],
            [31.579653861589705, -0.82279983964527],
            [31.578696054477575, -0.812597279263855],
            [31.57769548935453, -0.807378234195912],
            [31.576491019238432, -0.803958980625703],
            [31.57631879782543, -0.801815372461938],
            [31.576883064689696, -0.797175727507865],
            [31.57620279298292, -0.79622581859562],
            [31.57678154338448, -0.79354884695824],
            [31.5762103091869, -0.792291463419277],
            [31.576124304481592, -0.790880487611379],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1353,
        District: "KYOTERA",
        County: "KAKUUTO",
        Subcounty: "KAKUUTO",
        Population: 39244,
        Key: "KYOTERAKAKUUTO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.543100360751676, -0.700470350232993],
            [31.540070319942142, -0.697783225743652],
            [31.537941479805404, -0.694381884676829],
            [31.535176571362108, -0.692337013383153],
            [31.535737707597583, -0.68715476370158],
            [31.534614696711444, -0.684215002105011],
            [31.533813416545993, -0.683210828084442],
            [31.533341739936393, -0.680425026254428],
            [31.531335130865454, -0.678534152554483],
            [31.529533239762912, -0.678334631853207],
            [31.52735309234872, -0.675620657796479],
            [31.52791289368771, -0.672952750942184],
            [31.52662008773813, -0.670700324523034],
            [31.526756294793103, -0.669615051542591],
            [31.525650635764993, -0.667823946340481],
            [31.52651481596664, -0.665942988078185],
            [31.52782693299986, -0.664568637677671],
            [31.527901545270712, -0.663881289419901],
            [31.527026081330792, -0.661194864939601],
            [31.52646025049965, -0.660543510213572],
            [31.526686201048115, -0.655958107353344],
            [31.52541459983082, -0.654139815071961],
            [31.52537605132534, -0.652493741362686],
            [31.524165854449308, -0.648052638962285],
            [31.516843223037768, -0.653269040422294],
            [31.513349974036803, -0.654344273571984],
            [31.505919186363393, -0.653157262231309],
            [31.493832664134334, -0.654664024203661],
            [31.492171909142698, -0.655857353523482],
            [31.48937516530403, -0.659085278286401],
            [31.48947140810862, -0.665814172976263],
            [31.502519622663428, -0.674220241908171],
            [31.50005250753343, -0.68180757412207],
            [31.49948666682078, -0.683978007494112],
            [31.499678443659228, -0.684855350993515],
            [31.519698457981217, -0.702796430614378],
            [31.503362922424575, -0.720933918765563],
            [31.510685578090637, -0.722455757023638],
            [31.50606403790633, -0.734944334212338],
            [31.48013726551961, -0.733542750476693],
            [31.478722100943514, -0.736436397333269],
            [31.479253681707856, -0.74111239093052],
            [31.47803347939619, -0.742821305933758],
            [31.47768099036015, -0.744819931230259],
            [31.48060979822368, -0.748375295108239],
            [31.48098169715807, -0.75033799104477],
            [31.482102099336604, -0.752319044285924],
            [31.482233741153284, -0.754028437281318],
            [31.483890102484853, -0.756045855769707],
            [31.48430819997767, -0.757556383972318],
            [31.48600847994346, -0.759239186210334],
            [31.486723608079906, -0.760776946918792],
            [31.489756222562725, -0.762939564750871],
            [31.48718783406255, -0.766845733796875],
            [31.48715464400772, -0.769432342120741],
            [31.486781298785772, -0.770029131631698],
            [31.487072763467886, -0.770716593292526],
            [31.486483059908075, -0.771023873747856],
            [31.486073652717312, -0.772760204527035],
            [31.486172488958132, -0.774324884022282],
            [31.486700660615952, -0.774985295596297],
            [31.48635796411484, -0.776242316957013],
            [31.48667626686444, -0.777255367190485],
            [31.484633974015427, -0.780456257468422],
            [31.484947135706637, -0.780944759985621],
            [31.484076538838924, -0.781595628608193],
            [31.48340426213818, -0.786651054124951],
            [31.482750015523482, -0.787600447850659],
            [31.483348407588753, -0.788161404382967],
            [31.48319304665531, -0.789201425586397],
            [31.484144561068874, -0.793054581980224],
            [31.48385633481332, -0.795044170033171],
            [31.482632443120774, -0.795939090560906],
            [31.483153951974124, -0.79943936738729],
            [31.484201868194106, -0.799928144326353],
            [31.484841453405036, -0.802207498071741],
            [31.48615534910251, -0.803211892050867],
            [31.487170187557098, -0.80509345265795],
            [31.487602222411518, -0.806802965251157],
            [31.487416960155514, -0.807426934218155],
            [31.49060028948516, -0.808187829548928],
            [31.49798245764046, -0.809049770641643],
            [31.50420643418817, -0.809296278804637],
            [31.50525657823005, -0.809106737015102],
            [31.507820114031038, -0.807226482486834],
            [31.51085108190194, -0.807055753947871],
            [31.514426287799527, -0.805808962839539],
            [31.515978997920364, -0.806415499182757],
            [31.517579383429958, -0.80641608482632],
            [31.520826611722367, -0.804517961528514],
            [31.524354598575353, -0.804211738060865],
            [31.53028358006185, -0.804376681240463],
            [31.53212617562654, -0.803907043352375],
            [31.539273190891617, -0.798428727104069],
            [31.545969556412953, -0.791331264164285],
            [31.555284536140313, -0.78381860237642],
            [31.561085142084504, -0.777697507806816],
            [31.56260992268485, -0.775482142433276],
            [31.563654476510695, -0.776938662030973],
            [31.565304363684007, -0.77757232472962],
            [31.566057541760948, -0.778838809994345],
            [31.567221608350494, -0.778911558725175],
            [31.56767183049618, -0.780141774775362],
            [31.568350535541082, -0.779952061882313],
            [31.56905447785561, -0.780630636621879],
            [31.570558484016686, -0.780947719659546],
            [31.572646038481253, -0.782657829678827],
            [31.5738848170547, -0.784313407389932],
            [31.57517035743022, -0.784702759124313],
            [31.57602091917217, -0.786068772493473],
            [31.576124304481592, -0.790880487611379],
            [31.57783529416221, -0.790238914419852],
            [31.578379526799004, -0.789135666162621],
            [31.580318553814514, -0.788349456076271],
            [31.581528972574432, -0.786703766788436],
            [31.58302856890575, -0.785962627666991],
            [31.58532685555955, -0.781386862488947],
            [31.588764393741556, -0.778909812561653],
            [31.59064030332857, -0.776233243907055],
            [31.590700338637323, -0.775527796023744],
            [31.589486805418304, -0.774740511796733],
            [31.585493125633814, -0.768507475988655],
            [31.58612387771056, -0.763786432910479],
            [31.584709279073103, -0.75966164563888],
            [31.58258415796165, -0.756866182380319],
            [31.583216023051033, -0.752995331101179],
            [31.58392652935535, -0.752552375033915],
            [31.58223083618737, -0.75023642005833],
            [31.582647317610977, -0.745524350259096],
            [31.581775466695113, -0.742150452801365],
            [31.57890650279919, -0.735112891899244],
            [31.57487169814098, -0.730987299821565],
            [31.57475576246872, -0.728237741056591],
            [31.57355338812218, -0.72677213116096],
            [31.566349122325754, -0.723070660603706],
            [31.56399990209362, -0.723133227771735],
            [31.563294108351315, -0.722029575317772],
            [31.558800956285708, -0.719296733729887],
            [31.555991691728625, -0.718934060314514],
            [31.552592623000358, -0.720126842711814],
            [31.55142994879947, -0.720144559682969],
            [31.549797243702606, -0.71937526185596],
            [31.54690533503769, -0.716679112885545],
            [31.545669247816846, -0.712672053621533],
            [31.543108897441826, -0.710066449333834],
            [31.543243338408935, -0.704829797994305],
            [31.542258217122257, -0.70270406020889],
            [31.54235967374878, -0.70149213973187],
            [31.543100360751676, -0.700470350232993],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1354,
        District: "KYOTERA",
        County: "KAKUUTO",
        Subcounty: "KASASA",
        Population: 17104,
        Key: "KYOTERAKASASA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.369316438797462, -0.805789440785967],
            [31.368064133392487, -0.806204937863966],
            [31.363803126657565, -0.8056515648203],
            [31.363593547006804, -0.806031314298493],
            [31.361343537613006, -0.806247458102982],
            [31.358236716897824, -0.80849805341542],
            [31.351296101247353, -0.808511252844242],
            [31.34631541820571, -0.812190419274272],
            [31.34330527418142, -0.813067316755047],
            [31.336848321361384, -0.811602063871616],
            [31.334064272514325, -0.809732052068295],
            [31.332177300174592, -0.807539393919086],
            [31.32943055836126, -0.813026074761462],
            [31.327435610321004, -0.81500576812222],
            [31.324758700842935, -0.816397334854205],
            [31.323171871809304, -0.816559450826496],
            [31.320059823797482, -0.8159070176454],
            [31.318261243885072, -0.816204699914029],
            [31.315806803983715, -0.817325051130697],
            [31.314690178322607, -0.818265088127078],
            [31.313663117390316, -0.819865338856763],
            [31.312722565118168, -0.820218539112221],
            [31.3117422812593, -0.830039053179138],
            [31.31246768252932, -0.845113932336502],
            [31.311272138073875, -0.855000120804137],
            [31.315513635197505, -0.862206361268732],
            [31.317082311075854, -0.865849832641386],
            [31.316276026395975, -0.869530843072875],
            [31.3125072012153, -0.87325699489587],
            [31.3015018490414, -0.878148609913971],
            [31.30046651552363, -0.894693186684341],
            [31.2983474840915, -0.900687913932916],
            [31.295127200766025, -0.903381306050387],
            [31.289277837861476, -0.904011581768169],
            [31.28580153917161, -0.907069878866611],
            [31.28326678179904, -0.906781611472765],
            [31.279320061446054, -0.908404657253408],
            [31.2736227949972, -0.913773193623734],
            [31.27128341760566, -0.914212147141384],
            [31.26990464647664, -0.914076071493783],
            [31.26792142145084, -0.912077819892402],
            [31.26162320094156, -0.91108820203883],
            [31.256574890928654, -0.908797848917439],
            [31.251137365157685, -0.90554875428814],
            [31.244879533801864, -0.905159926640411],
            [31.240502725243676, -0.900821870322123],
            [31.239024494443058, -0.897751915556873],
            [31.239742598698022, -0.894196607306535],
            [31.237790760808238, -0.89314448740409],
            [31.230768227787053, -0.894696589087783],
            [31.221990777467813, -0.882981431675887],
            [31.21740437847909, -0.878358292489535],
            [31.209605699255743, -0.868723887675185],
            [31.203729474927588, -0.873067506512804],
            [31.20539191426037, -0.875939416506048],
            [31.205990627024175, -0.876327473877887],
            [31.206274986930747, -0.877891767717602],
            [31.206184600243496, -0.880224771835364],
            [31.203477747222045, -0.883252822703668],
            [31.20338779891264, -0.885251244566016],
            [31.203490463773186, -0.88774711782493],
            [31.209893715305533, -0.901043267784906],
            [31.25109964130564, -0.932397624786352],
            [31.27084144828247, -0.949707013738378],
            [31.264322912356487, -0.984393210769129],
            [31.2647305498661, -0.986057357877558],
            [31.270800494088665, -0.999308781841387],
            [31.29419023816175, -0.99932645530275],
            [31.293579596669296, -0.99595964797283],
            [31.291919674415933, -0.991454078878857],
            [31.28700205131057, -0.981412494031156],
            [31.293907475459783, -0.979807212481996],
            [31.29787253671594, -0.977235113594688],
            [31.299919255564316, -0.975434263718186],
            [31.303119434593718, -0.968228312723448],
            [31.304912480884003, -0.962244348391963],
            [31.305809925700604, -0.957353936092494],
            [31.319993384399048, -0.953963652919371],
            [31.35288337045549, -0.947549655864501],
            [31.389896390104067, -0.948019310780414],
            [31.393622409663124, -0.941265376698176],
            [31.41267028784591, -0.901942527267971],
            [31.430941494312137, -0.849314941221468],
            [31.43725609110907, -0.839495791184387],
            [31.44275916155643, -0.832696935891119],
            [31.439198714080657, -0.832261413039238],
            [31.438421720767238, -0.830452312074095],
            [31.43765959187682, -0.830081208487856],
            [31.434891621076716, -0.830677018200516],
            [31.433053612309838, -0.831788678655477],
            [31.432068461378794, -0.831670717135764],
            [31.430608226528257, -0.830268330375576],
            [31.429540062281774, -0.82779891536791],
            [31.428200460394123, -0.826604589542984],
            [31.428074595643036, -0.824678198831805],
            [31.426368200845076, -0.822380371438484],
            [31.42512274958572, -0.818780410693781],
            [31.424011567715258, -0.817884626608404],
            [31.422358766407157, -0.818562263622822],
            [31.42122112196504, -0.818597985975625],
            [31.42059755461395, -0.817892327080719],
            [31.419841180331236, -0.815757673497254],
            [31.417233499520513, -0.815783770504142],
            [31.4167932307082, -0.814436070151727],
            [31.41681391711256, -0.811768143005947],
            [31.41636726397351, -0.810963065542864],
            [31.414496234035127, -0.811143195641255],
            [31.41246934549661, -0.809984797467844],
            [31.411744334095424, -0.810961247534859],
            [31.40909515291523, -0.81158422871278],
            [31.406105117678567, -0.810117953111489],
            [31.401474373355835, -0.80933835169495],
            [31.400861903791757, -0.80972699056715],
            [31.40130619705653, -0.811490705507439],
            [31.401123706103213, -0.812205088187254],
            [31.400513942264755, -0.812846954351764],
            [31.39935433311563, -0.813072587538362],
            [31.398621566558578, -0.810928925795385],
            [31.39804626928095, -0.810295628397285],
            [31.39367158254344, -0.81023962942937],
            [31.393147243098632, -0.809959068695923],
            [31.393179557296023, -0.808448775846781],
            [31.391494547791726, -0.808276273363004],
            [31.390501973183166, -0.808574316382233],
            [31.389453737162953, -0.810454995146701],
            [31.387714803588793, -0.809622285308432],
            [31.38727473779572, -0.81064405362792],
            [31.385553004264317, -0.810344908638172],
            [31.384115220109344, -0.811185405042595],
            [31.38136768238868, -0.811428489939418],
            [31.37965692447341, -0.811066051563747],
            [31.377223062280265, -0.811851872856539],
            [31.373742057316644, -0.811072709209523],
            [31.37321394404933, -0.810421356604711],
            [31.374079673844808, -0.809273163865082],
            [31.373764385841334, -0.808567622803348],
            [31.37098111852858, -0.807625967640688],
            [31.37020929232466, -0.80631432566462],
            [31.369316438797462, -0.805789440785967],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1355,
        District: "RAKAI",
        County: "KAKUUTO",
        Subcounty: "KIBANDA",
        Population: 24559,
        Key: "RAKAIKIBANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.48013726551961, -0.733542750476693],
            [31.47906576493021, -0.732231002172752],
            [31.476425493240985, -0.730565982902237],
            [31.46932884920883, -0.727732766035119],
            [31.469093363941937, -0.729197826792309],
            [31.461841832388497, -0.738610204893793],
            [31.4578521375306, -0.745500364576636],
            [31.45230664683891, -0.75261604751806],
            [31.45153085816626, -0.752778562982815],
            [31.4504165609384, -0.755102468703077],
            [31.446703648697657, -0.759550788902833],
            [31.443874903275287, -0.76151040872624],
            [31.4357272644967, -0.762633291535661],
            [31.43068178507528, -0.764662762122446],
            [31.426427734893913, -0.768087954656783],
            [31.425124982797534, -0.774452238225258],
            [31.426198960940503, -0.780501426858059],
            [31.42555539798949, -0.784709107821298],
            [31.421277798472946, -0.787875989901325],
            [31.41900955687213, -0.788661944979751],
            [31.415137930286978, -0.787918863334158],
            [31.409206910523096, -0.785176323566401],
            [31.406245593527743, -0.784207496058988],
            [31.403193357144158, -0.782442796651112],
            [31.398651034893163, -0.78102118963411],
            [31.3952952416054, -0.780911378097317],
            [31.390205769887892, -0.78167814466271],
            [31.386516798647797, -0.781423498667043],
            [31.38225838085751, -0.779956777600578],
            [31.380798991321644, -0.778626797526654],
            [31.379071955933437, -0.778996923126858],
            [31.376131177120424, -0.788319801902615],
            [31.374537898183036, -0.798466165249602],
            [31.373764385841334, -0.808567622803348],
            [31.374079673844808, -0.809273163865082],
            [31.37321394404933, -0.810421356604711],
            [31.373742057316644, -0.811072709209523],
            [31.377223062280265, -0.811851872856539],
            [31.37965692447341, -0.811066051563747],
            [31.38136768238868, -0.811428489939418],
            [31.384115220109344, -0.811185405042595],
            [31.385553004264317, -0.810344908638172],
            [31.38727473779572, -0.81064405362792],
            [31.387714803588793, -0.809622285308432],
            [31.389453737162953, -0.810454995146701],
            [31.390501973183166, -0.808574316382233],
            [31.391494547791726, -0.808276273363004],
            [31.393179557296023, -0.808448775846781],
            [31.393147243098632, -0.809959068695923],
            [31.39367158254344, -0.81023962942937],
            [31.39804626928095, -0.810295628397285],
            [31.398621566558578, -0.810928925795385],
            [31.39935433311563, -0.813072587538362],
            [31.400513942264755, -0.812846954351764],
            [31.401123706103213, -0.812205088187254],
            [31.40130619705653, -0.811490705507439],
            [31.400861903791757, -0.80972699056715],
            [31.401474373355835, -0.80933835169495],
            [31.406105117678567, -0.810117953111489],
            [31.40909515291523, -0.81158422871278],
            [31.411744334095424, -0.810961247534859],
            [31.41246934549661, -0.809984797467844],
            [31.414496234035127, -0.811143195641255],
            [31.41636726397351, -0.810963065542864],
            [31.41681391711256, -0.811768143005947],
            [31.4167932307082, -0.814436070151727],
            [31.417233499520513, -0.815783770504142],
            [31.419841180331236, -0.815757673497254],
            [31.42059755461395, -0.817892327080719],
            [31.42122112196504, -0.818597985975625],
            [31.422358766407157, -0.818562263622822],
            [31.424011567715258, -0.817884626608404],
            [31.42512274958572, -0.818780410693781],
            [31.426368200845076, -0.822380371438484],
            [31.428074595643036, -0.824678198831805],
            [31.428200460394123, -0.826604589542984],
            [31.429540062281774, -0.82779891536791],
            [31.430608226528257, -0.830268330375576],
            [31.432068461378794, -0.831670717135764],
            [31.433053612309838, -0.831788678655477],
            [31.434891621076716, -0.830677018200516],
            [31.43765959187682, -0.830081208487856],
            [31.438421720767238, -0.830452312074095],
            [31.439198714080657, -0.832261413039238],
            [31.44275916155643, -0.832696935891119],
            [31.443682838975963, -0.832778688319652],
            [31.444957708264266, -0.832245609747469],
            [31.446769441309044, -0.830871638407551],
            [31.447177266566587, -0.829008736946248],
            [31.44703347503569, -0.827670173274085],
            [31.449505921666905, -0.82243467079991],
            [31.449383386970556, -0.822027645635646],
            [31.44772271372563, -0.821927516244268],
            [31.447523728805365, -0.821013994754082],
            [31.448173402096938, -0.819585306949101],
            [31.450120972989104, -0.817578295466997],
            [31.451479318225157, -0.818275205718563],
            [31.453801689610074, -0.817009941603889],
            [31.455236658444914, -0.817046678065346],
            [31.456739240776255, -0.817951649370226],
            [31.459249142663236, -0.815275586640196],
            [31.461214043853882, -0.814977883643704],
            [31.46222158080179, -0.813802546052482],
            [31.464064735118612, -0.813197304258328],
            [31.46626903284087, -0.813143876049975],
            [31.46798953837531, -0.810937779602269],
            [31.47304338470529, -0.813698139109881],
            [31.474028120614673, -0.814937563247955],
            [31.47643319809116, -0.81482994518235],
            [31.478209621955386, -0.817010245203606],
            [31.480022136534508, -0.818051010879783],
            [31.48169017057485, -0.816541273466181],
            [31.482588440943214, -0.816279337847954],
            [31.482540480788515, -0.813864537925993],
            [31.484089762938225, -0.812336653899586],
            [31.484213269611693, -0.811658392469373],
            [31.48534308882937, -0.810844849210702],
            [31.485408714354133, -0.810275087777631],
            [31.486378289396466, -0.810049349342588],
            [31.487149405931312, -0.808910073184714],
            [31.48702062884207, -0.807897080096314],
            [31.487416960155514, -0.807426934218155],
            [31.487602222411518, -0.806802965251157],
            [31.487170187557098, -0.80509345265795],
            [31.48615534910251, -0.803211892050867],
            [31.484841453405036, -0.802207498071741],
            [31.484201868194106, -0.799928144326353],
            [31.483153951974124, -0.79943936738729],
            [31.482632443120774, -0.795939090560906],
            [31.48385633481332, -0.795044170033171],
            [31.484144561068874, -0.793054581980224],
            [31.48319304665531, -0.789201425586397],
            [31.483348407588753, -0.788161404382967],
            [31.482750015523482, -0.787600447850659],
            [31.48340426213818, -0.786651054124951],
            [31.484076538838924, -0.781595628608193],
            [31.484947135706637, -0.780944759985621],
            [31.484633974015427, -0.780456257468422],
            [31.48667626686444, -0.777255367190485],
            [31.48635796411484, -0.776242316957013],
            [31.486700660615952, -0.774985295596297],
            [31.486172488958132, -0.774324884022282],
            [31.486073652717312, -0.772760204527035],
            [31.486483059908075, -0.771023873747856],
            [31.487072763467886, -0.770716593292526],
            [31.486781298785772, -0.770029131631698],
            [31.48715464400772, -0.769432342120741],
            [31.48718783406255, -0.766845733796875],
            [31.489756222562725, -0.762939564750871],
            [31.486723608079906, -0.760776946918792],
            [31.48600847994346, -0.759239186210334],
            [31.48430819997767, -0.757556383972318],
            [31.483890102484853, -0.756045855769707],
            [31.482233741153284, -0.754028437281318],
            [31.482102099336604, -0.752319044285924],
            [31.48098169715807, -0.75033799104477],
            [31.48060979822368, -0.748375295108239],
            [31.47768099036015, -0.744819931230259],
            [31.47803347939619, -0.742821305933758],
            [31.479253681707856, -0.74111239093052],
            [31.478722100943514, -0.736436397333269],
            [31.48013726551961, -0.733542750476693],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1356,
        District: "RAKAI",
        County: "KAKUUTO",
        Subcounty: "KIFAMBA",
        Population: 14538,
        Key: "RAKAIKIFAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.00050234792529, -0.820081490902883],
            [31.80106742200359, -0.817508892405747],
            [31.793261555359663, -0.817859321848514],
            [31.755958446349666, -0.817467994477428],
            [31.73188969270277, -0.818165949382323],
            [31.70427234305367, -0.817551086470668],
            [31.695164029740546, -0.818316940783128],
            [31.693073066169465, -0.818895144380431],
            [31.679484472750474, -0.824914577682667],
            [31.668772396262305, -0.828121926595175],
            [31.65814845887659, -0.828959498253197],
            [31.653599843927022, -0.827646447649796],
            [31.648928182241427, -0.824904284954682],
            [31.6469876029371, -0.824261443454131],
            [31.639031426586605, -0.825371225729304],
            [31.636060742857783, -0.825279762468715],
            [31.63330140935911, -0.824636635394154],
            [31.63248333429112, -0.825034324170943],
            [31.63172707948436, -0.826164651260017],
            [31.630878230829676, -0.826254809383849],
            [31.627952150251335, -0.825503081135276],
            [31.62531478640869, -0.825384589477376],
            [31.62467868935598, -0.825746151690952],
            [31.624132015098272, -0.824868630923177],
            [31.623192903723837, -0.825356714951614],
            [31.62270685406968, -0.824587755935774],
            [31.622101091327526, -0.824895053925297],
            [31.620615063150233, -0.824442313989196],
            [31.618976337544318, -0.823003633786],
            [31.617734267543675, -0.823491611154506],
            [31.61649035150516, -0.822794741333456],
            [31.61380752123102, -0.822658132443372],
            [31.607470721673526, -0.821344451003979],
            [31.60117692446868, -0.818285158036847],
            [31.597113637826073, -0.816999409927987],
            [31.592971231166537, -0.813090688565196],
            [31.591210399360694, -0.810865120359892],
            [31.58866163635451, -0.808793013707494],
            [31.583257615048677, -0.801908237489037],
            [31.579798607131412, -0.798958521742843],
            [31.576883064689696, -0.797175727507865],
            [31.57631879782543, -0.801815372461938],
            [31.576491019238432, -0.803958980625703],
            [31.57769548935453, -0.807378234195912],
            [31.578696054477575, -0.812597279263855],
            [31.579653861589705, -0.82279983964527],
            [31.581714724412247, -0.832460141628604],
            [31.584367622821095, -0.850966228538477],
            [31.585765771509074, -0.864388857946961],
            [31.585850660506786, -0.874717762264426],
            [31.585369346770822, -0.877883171849414],
            [31.585583498846347, -0.884838514345014],
            [31.58523577896616, -0.888067285655932],
            [31.58410091391156, -0.892326819722135],
            [31.583875928153677, -0.896948498927856],
            [31.580342854141268, -0.903404909943429],
            [31.579461596067727, -0.906705822019199],
            [31.563930802783656, -0.929491715918273],
            [31.553719317877455, -0.938242533799318],
            [31.550410754414095, -0.939832975130225],
            [31.54692260874228, -0.943168894610914],
            [31.541676389092544, -0.946693991830884],
            [31.537241026547477, -0.948980336010892],
            [31.525375922866253, -0.953832076950475],
            [31.518529228773712, -0.957401601233075],
            [31.50635752918773, -0.970031083175576],
            [31.50125102990401, -0.976269323372793],
            [31.49463508785512, -0.981150212760991],
            [31.490229545784235, -0.985163826290525],
            [31.477076676600547, -1.000035349013443],
            [31.50052292201003, -1.000227077773921],
            [31.510674901613502, -1.000882899735593],
            [31.57146989404269, -1.001624573015258],
            [31.766951169109007, -0.999415836651773],
            [31.80060186292106, -0.999455217293373],
            [31.800954244159243, -0.999845673477863],
            [31.999898977396747, -0.999912568016137],
            [32.00050234792529, -0.820081490902883],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1357,
        District: "KYOTERA",
        County: "KAKUUTO",
        Subcounty: "KYEBE",
        Population: 20687,
        Key: "KYOTERAKYEBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.440471291766666, -0.721175027256529],
            [31.43877171069012, -0.726627943393203],
            [31.43692321678729, -0.729087254033349],
            [31.43317297774986, -0.73699938067458],
            [31.430741546397883, -0.738879655520753],
            [31.429079375661363, -0.739213691421755],
            [31.427201355033436, -0.738570898781319],
            [31.418554826082037, -0.732689316618834],
            [31.413063714007745, -0.730788164916255],
            [31.41164776969397, -0.729494389639038],
            [31.408503066124922, -0.72472719783326],
            [31.40750311095801, -0.723677755668645],
            [31.40588602307232, -0.72279993082744],
            [31.40213522618112, -0.717905931264164],
            [31.3979897311136, -0.717786900357072],
            [31.388966375968504, -0.719782383064157],
            [31.381101772081433, -0.719924288610458],
            [31.37911019272349, -0.719019212102134],
            [31.375759690512766, -0.718475395956058],
            [31.366470593045374, -0.717992759195684],
            [31.360396945068878, -0.7141470475322],
            [31.35826993390206, -0.716009268178492],
            [31.35514894855148, -0.717536511021366],
            [31.351730008190856, -0.71852102049667],
            [31.33429404629264, -0.718523724213085],
            [31.31709314745314, -0.717197057097256],
            [31.307598457058244, -0.714679504082569],
            [31.30786881941604, -0.717166591324611],
            [31.30851666643265, -0.728606616991765],
            [31.309752023323153, -0.735064041043239],
            [31.311509891586873, -0.741313684744044],
            [31.31319197437999, -0.745284373064519],
            [31.315193269017705, -0.748477462568277],
            [31.31827727971119, -0.752629571386118],
            [31.321101955765315, -0.754421258975774],
            [31.321263492616335, -0.756329484896517],
            [31.322981750565937, -0.757469616096449],
            [31.32345673028083, -0.757560238306268],
            [31.32422995695826, -0.756629063100236],
            [31.326117547338896, -0.756928232585458],
            [31.32709705505334, -0.757670173502407],
            [31.32863910486669, -0.757797379991348],
            [31.33031019587399, -0.75896462856418],
            [31.331661686964424, -0.758965151337789],
            [31.333556149456992, -0.761118240692197],
            [31.334697519212607, -0.761462331545353],
            [31.338610879729217, -0.760460023163739],
            [31.339525300009765, -0.761825936545514],
            [31.340495892843315, -0.76167257803677],
            [31.343138109385116, -0.762749776537284],
            [31.34403219450257, -0.764450306118265],
            [31.345530348139583, -0.764903062510265],
            [31.3473313391302, -0.770709700244702],
            [31.34692272425354, -0.772536339562102],
            [31.347090102848856, -0.773838674827212],
            [31.345409664871024, -0.776487773446089],
            [31.3453687376267, -0.780656821878389],
            [31.345818985823502, -0.782990239984138],
            [31.347402224290963, -0.784844779329352],
            [31.348561964594094, -0.787024745890363],
            [31.350705192148407, -0.789168917741877],
            [31.351558394937292, -0.789133084649366],
            [31.352373055508874, -0.790001581429088],
            [31.35466752522108, -0.789477971752278],
            [31.356684618529716, -0.789668689332611],
            [31.361885060032563, -0.79642632026814],
            [31.361660802808426, -0.79771042393942],
            [31.362042878756633, -0.799157553781386],
            [31.363167173335324, -0.800161840720845],
            [31.364399924213185, -0.800171371814782],
            [31.364881140931093, -0.800876976306464],
            [31.36561586042557, -0.800868214096931],
            [31.365812860967374, -0.803934084471974],
            [31.369316438797462, -0.805789440785967],
            [31.37020929232466, -0.80631432566462],
            [31.37098111852858, -0.807625967640688],
            [31.373764385841334, -0.808567622803348],
            [31.374537898183036, -0.798466165249602],
            [31.376131177120424, -0.788319801902615],
            [31.379071955933437, -0.778996923126858],
            [31.380798991321644, -0.778626797526654],
            [31.38225838085751, -0.779956777600578],
            [31.386516798647797, -0.781423498667043],
            [31.390205769887892, -0.78167814466271],
            [31.3952952416054, -0.780911378097317],
            [31.398651034893163, -0.78102118963411],
            [31.403193357144158, -0.782442796651112],
            [31.406245593527743, -0.784207496058988],
            [31.409206910523096, -0.785176323566401],
            [31.415137930286978, -0.787918863334158],
            [31.41900955687213, -0.788661944979751],
            [31.421277798472946, -0.787875989901325],
            [31.42555539798949, -0.784709107821298],
            [31.426198960940503, -0.780501426858059],
            [31.425124982797534, -0.774452238225258],
            [31.426427734893913, -0.768087954656783],
            [31.43068178507528, -0.764662762122446],
            [31.4357272644967, -0.762633291535661],
            [31.443874903275287, -0.76151040872624],
            [31.446703648697657, -0.759550788902833],
            [31.4504165609384, -0.755102468703077],
            [31.45153085816626, -0.752778562982815],
            [31.45230664683891, -0.75261604751806],
            [31.4578521375306, -0.745500364576636],
            [31.461841832388497, -0.738610204893793],
            [31.469093363941937, -0.729197826792309],
            [31.46932884920883, -0.727732766035119],
            [31.46193399953663, -0.724311588666792],
            [31.455695004055688, -0.722690578625411],
            [31.451420013246743, -0.723295068834411],
            [31.4496498775895, -0.723194980231837],
            [31.440471291766666, -0.721175027256529],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1358,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "BYAKABANDA",
        Population: 18755,
        Key: "RAKAIBYAKABANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.4039924436237, -0.582122958461078],
            [31.38900091978445, -0.575055529585945],
            [31.366251014247194, -0.536251847973845],
            [31.36174976207269, -0.538276412491935],
            [31.351552078882534, -0.540597851840102],
            [31.34941650677105, -0.541483231434267],
            [31.35103204146959, -0.547952729689564],
            [31.35504227540812, -0.553294711888746],
            [31.358448874713424, -0.560526340099436],
            [31.358280522344323, -0.567738564807355],
            [31.356335016679008, -0.575544098639379],
            [31.354426792894607, -0.593676382590814],
            [31.353364479375582, -0.599409060711581],
            [31.348736671645497, -0.603213458962396],
            [31.347556109292377, -0.608810084900646],
            [31.34765563723596, -0.615229748903075],
            [31.352045509095042, -0.626426149625694],
            [31.35260184293704, -0.630419598178366],
            [31.35501921385817, -0.637276988380627],
            [31.355073100198787, -0.646733614546019],
            [31.354104583371864, -0.655715215220283],
            [31.35086743327862, -0.658069822400315],
            [31.34275141070644, -0.662737182814762],
            [31.330100706953107, -0.669045979795058],
            [31.314715926733616, -0.678710929500422],
            [31.304042409530723, -0.686508503732101],
            [31.299153306139008, -0.692211631196783],
            [31.295467158303822, -0.693405933103086],
            [31.283260353454875, -0.694708053363601],
            [31.273733231183265, -0.694072082071167],
            [31.281655898577064, -0.700632101367988],
            [31.291590138233733, -0.70771797480284],
            [31.30786881941604, -0.717166591324611],
            [31.307598457058244, -0.714679504082569],
            [31.31709314745314, -0.717197057097256],
            [31.33429404629264, -0.718523724213085],
            [31.351730008190856, -0.71852102049667],
            [31.35514894855148, -0.717536511021366],
            [31.35826993390206, -0.716009268178492],
            [31.360396945068878, -0.7141470475322],
            [31.363307299739862, -0.710458298486881],
            [31.36741035210512, -0.700783064537842],
            [31.37062007932767, -0.695891574752952],
            [31.37546315304421, -0.694337734824567],
            [31.381008629362885, -0.693715627962455],
            [31.3880732044377, -0.692307231015927],
            [31.391657646813037, -0.69096997235373],
            [31.39954949390775, -0.68738226634075],
            [31.40780895227794, -0.680918700105679],
            [31.411444542030623, -0.677763618203981],
            [31.411893324176894, -0.676425262313659],
            [31.41073057272089, -0.670908153485838],
            [31.41068166753851, -0.670193680644855],
            [31.411239825858846, -0.669208076920033],
            [31.410621471431313, -0.668800898359994],
            [31.40911325756147, -0.656582211379004],
            [31.40707314312705, -0.651896868392007],
            [31.406124226641293, -0.646470277614095],
            [31.40715087255193, -0.642979688541273],
            [31.40963994610075, -0.640276363837544],
            [31.407206159366094, -0.634795045878462],
            [31.407350578819393, -0.62886235576873],
            [31.406613576705787, -0.622486238952499],
            [31.403283139265234, -0.613893622206389],
            [31.4037147878441, -0.603827993795469],
            [31.399560119180922, -0.592983276987818],
            [31.39946249476742, -0.591726165408886],
            [31.4039924436237, -0.582122958461078],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1359,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "DDWANIRO",
        Population: 32814,
        Key: "RAKAIDDWANIRO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.22140701536527, -0.66960392936236],
            [31.215202580768256, -0.661698156555361],
            [31.21183397840285, -0.658504802865588],
            [31.210664517429997, -0.65532128393743],
            [31.20890232737144, -0.653285998614171],
            [31.207269632156045, -0.65023797132434],
            [31.205849013907837, -0.646014442146716],
            [31.19862270165768, -0.638343556708711],
            [31.19843036696547, -0.636842373481786],
            [31.19742981891044, -0.635449432848039],
            [31.194818609517288, -0.629769623730897],
            [31.194160808269043, -0.62676718900117],
            [31.192729275490137, -0.623131487647915],
            [31.190944986875582, -0.604954850553902],
            [31.19096359996828, -0.601274438456032],
            [31.191661462484948, -0.598652258872506],
            [31.195587599739866, -0.592251242190214],
            [31.203192989361785, -0.581456542590728],
            [31.206556974386647, -0.572704106960373],
            [31.212737490440876, -0.563310466151271],
            [31.212346254371738, -0.555587708798166],
            [31.21115281197403, -0.552313823306305],
            [31.20902583045166, -0.536108316052939],
            [31.2068164374851, -0.529009014268759],
            [31.208777896331558, -0.520590650329226],
            [31.20651868459597, -0.511773205535216],
            [31.207595124122818, -0.507957404927126],
            [31.207282979324518, -0.50587744987132],
            [31.20777788007918, -0.50274875510675],
            [31.206887722396132, -0.497684498070684],
            [31.20850823196474, -0.488262250749881],
            [31.208140195786072, -0.485160442261856],
            [31.206341720976553, -0.476388369976387],
            [31.198287054236626, -0.468953057188489],
            [31.19220347179139, -0.478138973914404],
            [31.19048591093447, -0.482135441877827],
            [31.18888102666195, -0.484603699860717],
            [31.182133755410096, -0.490778090303611],
            [31.178588360105223, -0.49321866455752],
            [31.175686598718272, -0.493679040354823],
            [31.17213140818352, -0.492927516982252],
            [31.16490436021317, -0.489046223307875],
            [31.161373763754252, -0.487770245146556],
            [31.157996294118693, -0.488058684623857],
            [31.15466523234906, -0.490047148949664],
            [31.152932108179826, -0.495463182549337],
            [31.151946403886534, -0.501141668752106],
            [31.151877764514012, -0.502669848332843],
            [31.15265347054163, -0.505220086539788],
            [31.152944777120258, -0.509406891799791],
            [31.152792827988286, -0.519525529435069],
            [31.15167952160216, -0.522590638585845],
            [31.149059161071204, -0.527436696067946],
            [31.141417514546067, -0.537335995074408],
            [31.14070632462383, -0.538836845740696],
            [31.138725542117303, -0.550365466765516],
            [31.13634539378827, -0.557001932652763],
            [31.134922749839106, -0.559877002375302],
            [31.130972294291162, -0.565671981992262],
            [31.127232729035942, -0.569441479219223],
            [31.12439949113885, -0.575074003407548],
            [31.12581438442372, -0.584017463886352],
            [31.124869725952408, -0.588538385139293],
            [31.12243745198073, -0.591946566084885],
            [31.117724778609116, -0.596954459943142],
            [31.10840353942085, -0.604601111007065],
            [31.106125010313406, -0.607322062722467],
            [31.102791149393312, -0.612194711507307],
            [31.09863126780654, -0.621552034433772],
            [31.09625217230304, -0.629101514208358],
            [31.094798796988005, -0.635855568532064],
            [31.093528806450006, -0.655097097068294],
            [31.090996217610524, -0.663568745181922],
            [31.09102153483019, -0.664879889263761],
            [31.09280146212403, -0.671400073116896],
            [31.09970258693627, -0.676204236457136],
            [31.111452443054738, -0.679943345813809],
            [31.133837339735845, -0.689157337720343],
            [31.153139218361833, -0.70415752001367],
            [31.154722734408697, -0.706237945064132],
            [31.157058227484953, -0.707007490308304],
            [31.162455476391866, -0.70705486025625],
            [31.16390523598784, -0.706630434092726],
            [31.16591259964365, -0.705229609653177],
            [31.177502029228773, -0.704121922467306],
            [31.18239733279255, -0.702161563464737],
            [31.184059286136776, -0.700416954769504],
            [31.185304109473762, -0.697867384456947],
            [31.1856981231338, -0.690027456541158],
            [31.186837087201056, -0.688273595873993],
            [31.188238309025635, -0.687053353893424],
            [31.19433379235171, -0.684776877979245],
            [31.200580247442787, -0.679606725854097],
            [31.208367513570415, -0.679935170822067],
            [31.210815826961536, -0.679483947367102],
            [31.214485781765372, -0.676862856867039],
            [31.216500539454287, -0.672107031891272],
            [31.22140701536527, -0.66960392936236],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1360,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "KACHEERA",
        Population: 23823,
        Key: "RAKAIKACHEERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.273733231183265, -0.694072082071167],
            [31.283260353454875, -0.694708053363601],
            [31.295467158303822, -0.693405933103086],
            [31.299153306139008, -0.692211631196783],
            [31.304042409530723, -0.686508503732101],
            [31.314715926733616, -0.678710929500422],
            [31.330100706953107, -0.669045979795058],
            [31.34275141070644, -0.662737182814762],
            [31.35086743327862, -0.658069822400315],
            [31.354104583371864, -0.655715215220283],
            [31.355073100198787, -0.646733614546019],
            [31.35501921385817, -0.637276988380627],
            [31.35260184293704, -0.630419598178366],
            [31.352045509095042, -0.626426149625694],
            [31.34765563723596, -0.615229748903075],
            [31.347556109292377, -0.608810084900646],
            [31.348736671645497, -0.603213458962396],
            [31.353364479375582, -0.599409060711581],
            [31.354426792894607, -0.593676382590814],
            [31.356335016679008, -0.575544098639379],
            [31.358280522344323, -0.567738564807355],
            [31.358448874713424, -0.560526340099436],
            [31.35504227540812, -0.553294711888746],
            [31.35103204146959, -0.547952729689564],
            [31.34941650677105, -0.541483231434267],
            [31.345045414192985, -0.544222549683579],
            [31.338347094835928, -0.544519135748922],
            [31.33570015495236, -0.545296151413313],
            [31.333873164022453, -0.546308505905112],
            [31.331029516447867, -0.549861808194701],
            [31.324827888187784, -0.56101062113134],
            [31.322504743353434, -0.563379339349847],
            [31.320345833010883, -0.564717140863764],
            [31.3156095492187, -0.566099416387142],
            [31.307093956906463, -0.56610596927727],
            [31.30413526389007, -0.565499196771121],
            [31.301625556039188, -0.563608408550103],
            [31.29967614270237, -0.562802983843962],
            [31.295020573436755, -0.562883010891164],
            [31.290690763835904, -0.565486205968248],
            [31.285545150108064, -0.570051530898419],
            [31.282357065097354, -0.573523184892856],
            [31.28034390640964, -0.576651541434073],
            [31.278108747964097, -0.581461857648544],
            [31.275255960031473, -0.586317187376172],
            [31.271059162178116, -0.596335742008493],
            [31.26965685788364, -0.602023463646034],
            [31.27070007142308, -0.613372996612483],
            [31.26874925581609, -0.617948206146372],
            [31.262576655716114, -0.62585894680234],
            [31.25740125924338, -0.633462491145715],
            [31.256136641529118, -0.636699497175164],
            [31.250769685610223, -0.643642766916407],
            [31.24203285171825, -0.651606682821586],
            [31.236736417142428, -0.655818865031763],
            [31.24479251489863, -0.662631568663151],
            [31.254416290504913, -0.667525593872395],
            [31.266928967216522, -0.678436808952697],
            [31.270449602257234, -0.684733772703956],
            [31.272948308440828, -0.69342216177679],
            [31.273733231183265, -0.694072082071167],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1361,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "KAGAMBA",
        Population: 33902,
        Key: "RAKAIKAGAMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.273733231183265, -0.694072082071167],
            [31.272948308440828, -0.69342216177679],
            [31.270449602257234, -0.684733772703956],
            [31.266928967216522, -0.678436808952697],
            [31.254416290504913, -0.667525593872395],
            [31.24479251489863, -0.662631568663151],
            [31.236736417142428, -0.655818865031763],
            [31.23389852327722, -0.658485548749149],
            [31.225921973136085, -0.667643237340847],
            [31.22140701536527, -0.66960392936236],
            [31.216500539454287, -0.672107031891272],
            [31.214485781765372, -0.676862856867039],
            [31.210815826961536, -0.679483947367102],
            [31.208367513570415, -0.679935170822067],
            [31.200580247442787, -0.679606725854097],
            [31.19433379235171, -0.684776877979245],
            [31.188238309025635, -0.687053353893424],
            [31.186837087201056, -0.688273595873993],
            [31.1856981231338, -0.690027456541158],
            [31.185304109473762, -0.697867384456947],
            [31.184059286136776, -0.700416954769504],
            [31.18239733279255, -0.702161563464737],
            [31.177502029228773, -0.704121922467306],
            [31.16591259964365, -0.705229609653177],
            [31.16390523598784, -0.706630434092726],
            [31.162455476391866, -0.70705486025625],
            [31.157058227484953, -0.707007490308304],
            [31.154722734408697, -0.706237945064132],
            [31.157835000711117, -0.713328601186461],
            [31.158930576150173, -0.714857245286148],
            [31.164917849315454, -0.720637912269464],
            [31.168432810596826, -0.726625572031543],
            [31.170528404084887, -0.729284981467962],
            [31.173622566639402, -0.731772986794453],
            [31.180986213330183, -0.735537769019117],
            [31.187400133254833, -0.739441566053668],
            [31.18997250937656, -0.741729480963022],
            [31.192436610658795, -0.745206758003411],
            [31.194835257096134, -0.747681377845943],
            [31.196181254090316, -0.750069990874666],
            [31.197186254195888, -0.753431059903566],
            [31.19995341381732, -0.75801693239299],
            [31.197879420320266, -0.769563751099681],
            [31.198286208023628, -0.77162445448086],
            [31.199169864598947, -0.775456902984024],
            [31.200645691507866, -0.775046660187252],
            [31.202385447040506, -0.775329891936224],
            [31.20698587591736, -0.779682210508958],
            [31.210352534328475, -0.781717586015828],
            [31.218153381186557, -0.783133377647063],
            [31.219781143752762, -0.782851579101785],
            [31.219330686248465, -0.786297800667344],
            [31.219498394525484, -0.787879831632563],
            [31.2186556229737, -0.789969917028726],
            [31.219272574232733, -0.790987156878622],
            [31.22275294768073, -0.789632685580699],
            [31.225672185791545, -0.787995472501293],
            [31.230781428530133, -0.783760234412715],
            [31.233196237456074, -0.780427815851985],
            [31.233422054155568, -0.77726396776792],
            [31.234376874369385, -0.775625895640934],
            [31.236004856124513, -0.774835589775886],
            [31.240382227028082, -0.775967401109312],
            [31.24335691814139, -0.775968641568933],
            [31.247790390631092, -0.777213473620527],
            [31.251999947256458, -0.777045725079298],
            [31.25609510522699, -0.782132395671107],
            [31.256992272464185, -0.78422325911726],
            [31.25693518901946, -0.786539723827775],
            [31.25738364328063, -0.787895905464716],
            [31.258337308261012, -0.789082800830814],
            [31.257942916410233, -0.792698619108961],
            [31.258108793920698, -0.798687662892703],
            [31.257602604936206, -0.801173435393095],
            [31.257947783482436, -0.805966837810895],
            [31.26448355268884, -0.805336828046568],
            [31.271855927410957, -0.803863059877338],
            [31.277513239490908, -0.804082436515152],
            [31.281171046377167, -0.805738990100739],
            [31.28708861746293, -0.810234837396508],
            [31.291994879574876, -0.81312935534753],
            [31.2982571432183, -0.817748631037566],
            [31.300950991329408, -0.819131639444382],
            [31.30918452162558, -0.822207543496749],
            [31.310135219470542, -0.822085115728455],
            [31.31099833157531, -0.821261178546618],
            [31.310601073200456, -0.821835499599363],
            [31.312722565118168, -0.820218539112221],
            [31.313663117390316, -0.819865338856763],
            [31.314690178322607, -0.818265088127078],
            [31.315806803983715, -0.817325051130697],
            [31.318261243885072, -0.816204699914029],
            [31.320059823797482, -0.8159070176454],
            [31.323171871809304, -0.816559450826496],
            [31.324758700842935, -0.816397334854205],
            [31.327435610321004, -0.81500576812222],
            [31.32943055836126, -0.813026074761462],
            [31.332177300174592, -0.807539393919086],
            [31.334064272514325, -0.809732052068295],
            [31.336848321361384, -0.811602063871616],
            [31.34330527418142, -0.813067316755047],
            [31.34631541820571, -0.812190419274272],
            [31.351296101247353, -0.808511252844242],
            [31.358236716897824, -0.80849805341542],
            [31.361343537613006, -0.806247458102982],
            [31.363593547006804, -0.806031314298493],
            [31.363803126657565, -0.8056515648203],
            [31.368064133392487, -0.806204937863966],
            [31.369316438797462, -0.805789440785967],
            [31.365812860967374, -0.803934084471974],
            [31.36561586042557, -0.800868214096931],
            [31.364881140931093, -0.800876976306464],
            [31.364399924213185, -0.800171371814782],
            [31.363167173335324, -0.800161840720845],
            [31.362042878756633, -0.799157553781386],
            [31.361660802808426, -0.79771042393942],
            [31.361885060032563, -0.79642632026814],
            [31.356684618529716, -0.789668689332611],
            [31.35466752522108, -0.789477971752278],
            [31.352373055508874, -0.790001581429088],
            [31.351558394937292, -0.789133084649366],
            [31.350705192148407, -0.789168917741877],
            [31.348561964594094, -0.787024745890363],
            [31.347402224290963, -0.784844779329352],
            [31.345818985823502, -0.782990239984138],
            [31.3453687376267, -0.780656821878389],
            [31.345409664871024, -0.776487773446089],
            [31.347090102848856, -0.773838674827212],
            [31.34692272425354, -0.772536339562102],
            [31.3473313391302, -0.770709700244702],
            [31.345530348139583, -0.764903062510265],
            [31.34403219450257, -0.764450306118265],
            [31.343138109385116, -0.762749776537284],
            [31.340495892843315, -0.76167257803677],
            [31.339525300009765, -0.761825936545514],
            [31.338610879729217, -0.760460023163739],
            [31.334697519212607, -0.761462331545353],
            [31.333556149456992, -0.761118240692197],
            [31.331661686964424, -0.758965151337789],
            [31.33031019587399, -0.75896462856418],
            [31.32863910486669, -0.757797379991348],
            [31.32709705505334, -0.757670173502407],
            [31.326117547338896, -0.756928232585458],
            [31.32422995695826, -0.756629063100236],
            [31.32345673028083, -0.757560238306268],
            [31.322981750565937, -0.757469616096449],
            [31.321263492616335, -0.756329484896517],
            [31.321101955765315, -0.754421258975774],
            [31.31827727971119, -0.752629571386118],
            [31.315193269017705, -0.748477462568277],
            [31.31319197437999, -0.745284373064519],
            [31.311509891586873, -0.741313684744044],
            [31.309752023323153, -0.735064041043239],
            [31.30851666643265, -0.728606616991765],
            [31.30786881941604, -0.717166591324611],
            [31.291590138233733, -0.70771797480284],
            [31.281655898577064, -0.700632101367988],
            [31.273733231183265, -0.694072082071167],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1362,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "KYALULANGIRA",
        Population: 27822,
        Key: "RAKAIKYALULANGIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.246560644617826, -0.460311109948021],
            [31.24406287088552, -0.457959290944444],
            [31.24283125547816, -0.457335015872642],
            [31.237327179815985, -0.455633582572277],
            [31.234902114824447, -0.455587771737847],
            [31.228040613801046, -0.457069132895347],
            [31.219237117728465, -0.456596722107377],
            [31.212801785560735, -0.459199482369537],
            [31.20802077554886, -0.460301519843537],
            [31.206328755592082, -0.461069731546725],
            [31.201774564799525, -0.464450614098956],
            [31.198287054236626, -0.468953057188489],
            [31.206341720976553, -0.476388369976387],
            [31.208140195786072, -0.485160442261856],
            [31.20850823196474, -0.488262250749881],
            [31.206887722396132, -0.497684498070684],
            [31.20777788007918, -0.50274875510675],
            [31.207282979324518, -0.50587744987132],
            [31.207595124122818, -0.507957404927126],
            [31.20651868459597, -0.511773205535216],
            [31.208777896331558, -0.520590650329226],
            [31.2068164374851, -0.529009014268759],
            [31.20902583045166, -0.536108316052939],
            [31.21115281197403, -0.552313823306305],
            [31.212346254371738, -0.555587708798166],
            [31.212737490440876, -0.563310466151271],
            [31.206556974386647, -0.572704106960373],
            [31.203192989361785, -0.581456542590728],
            [31.195587599739866, -0.592251242190214],
            [31.191661462484948, -0.598652258872506],
            [31.19096359996828, -0.601274438456032],
            [31.190944986875582, -0.604954850553902],
            [31.192729275490137, -0.623131487647915],
            [31.194160808269043, -0.62676718900117],
            [31.194818609517288, -0.629769623730897],
            [31.19742981891044, -0.635449432848039],
            [31.19843036696547, -0.636842373481786],
            [31.19862270165768, -0.638343556708711],
            [31.205849013907837, -0.646014442146716],
            [31.207269632156045, -0.65023797132434],
            [31.20890232737144, -0.653285998614171],
            [31.210664517429997, -0.65532128393743],
            [31.21183397840285, -0.658504802865588],
            [31.215202580768256, -0.661698156555361],
            [31.22140701536527, -0.66960392936236],
            [31.225921973136085, -0.667643237340847],
            [31.23389852327722, -0.658485548749149],
            [31.236736417142428, -0.655818865031763],
            [31.24203285171825, -0.651606682821586],
            [31.250769685610223, -0.643642766916407],
            [31.256136641529118, -0.636699497175164],
            [31.25740125924338, -0.633462491145715],
            [31.262576655716114, -0.62585894680234],
            [31.26874925581609, -0.617948206146372],
            [31.27070007142308, -0.613372996612483],
            [31.26965685788364, -0.602023463646034],
            [31.271059162178116, -0.596335742008493],
            [31.275255960031473, -0.586317187376172],
            [31.278108747964097, -0.581461857648544],
            [31.28034390640964, -0.576651541434073],
            [31.282357065097354, -0.573523184892856],
            [31.285545150108064, -0.570051530898419],
            [31.290690763835904, -0.565486205968248],
            [31.295020573436755, -0.562883010891164],
            [31.29967614270237, -0.562802983843962],
            [31.301625556039188, -0.563608408550103],
            [31.30413526389007, -0.565499196771121],
            [31.307093956906463, -0.56610596927727],
            [31.3156095492187, -0.566099416387142],
            [31.320345833010883, -0.564717140863764],
            [31.322504743353434, -0.563379339349847],
            [31.324827888187784, -0.56101062113134],
            [31.331029516447867, -0.549861808194701],
            [31.333873164022453, -0.546308505905112],
            [31.33570015495236, -0.545296151413313],
            [31.338347094835928, -0.544519135748922],
            [31.345045414192985, -0.544222549683579],
            [31.34941650677105, -0.541483231434267],
            [31.351552078882534, -0.540597851840102],
            [31.36174976207269, -0.538276412491935],
            [31.366251014247194, -0.536251847973845],
            [31.360792581086308, -0.527107293310453],
            [31.35526154608417, -0.522963874846393],
            [31.336242685281693, -0.509637775749194],
            [31.31409098675676, -0.493453373064156],
            [31.268037795500955, -0.48457017413679],
            [31.250374360409864, -0.464046841820104],
            [31.246560644617826, -0.460311109948021],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1363,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "LWAMAGGWA",
        Population: 44004,
        Key: "RAKAILWAMAGGWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.439953579193677, -0.598086588248159],
            [31.433213361513435, -0.595253913589718],
            [31.43084089288179, -0.596835928283944],
            [31.43019966555049, -0.596853821753521],
            [31.42682452883973, -0.58990714672253],
            [31.42286423853606, -0.587256163267706],
            [31.420986492792615, -0.586712997588974],
            [31.418468465643883, -0.586838898856534],
            [31.4088385725105, -0.588274135379149],
            [31.407696492187508, -0.587351333873727],
            [31.4039924436237, -0.582122958461078],
            [31.39946249476742, -0.591726165408886],
            [31.399560119180922, -0.592983276987818],
            [31.4037147878441, -0.603827993795469],
            [31.403283139265234, -0.613893622206389],
            [31.406613576705787, -0.622486238952499],
            [31.407350578819393, -0.62886235576873],
            [31.407206159366094, -0.634795045878462],
            [31.40963994610075, -0.640276363837544],
            [31.40715087255193, -0.642979688541273],
            [31.406124226641293, -0.646470277614095],
            [31.40707314312705, -0.651896868392007],
            [31.40911325756147, -0.656582211379004],
            [31.410621471431313, -0.668800898359994],
            [31.411239825858846, -0.669208076920033],
            [31.41068166753851, -0.670193680644855],
            [31.41073057272089, -0.670908153485838],
            [31.411893324176894, -0.676425262313659],
            [31.411444542030623, -0.677763618203981],
            [31.40780895227794, -0.680918700105679],
            [31.411773109828918, -0.681788228475544],
            [31.417576170868806, -0.686113101797004],
            [31.417384570100158, -0.687001966767155],
            [31.42219124947129, -0.687807517935178],
            [31.43061347448613, -0.69231991250526],
            [31.43220461183987, -0.698500364069834],
            [31.43367327558271, -0.702079679192028],
            [31.43717288196093, -0.705530946440562],
            [31.43940195791369, -0.7071639927602],
            [31.438879115960447, -0.710389757808224],
            [31.44096524479865, -0.717981918279756],
            [31.440471291766666, -0.721175027256529],
            [31.4496498775895, -0.723194980231837],
            [31.451420013246743, -0.723295068834411],
            [31.455695004055688, -0.722690578625411],
            [31.46193399953663, -0.724311588666792],
            [31.46932884920883, -0.727732766035119],
            [31.476425493240985, -0.730565982902237],
            [31.47906576493021, -0.732231002172752],
            [31.48013726551961, -0.733542750476693],
            [31.50606403790633, -0.734944334212338],
            [31.510685578090637, -0.722455757023638],
            [31.503362922424575, -0.720933918765563],
            [31.519698457981217, -0.702796430614378],
            [31.499678443659228, -0.684855350993515],
            [31.49948666682078, -0.683978007494112],
            [31.50005250753343, -0.68180757412207],
            [31.502519622663428, -0.674220241908171],
            [31.48947140810862, -0.665814172976263],
            [31.48937516530403, -0.659085278286401],
            [31.48919256385793, -0.638573057522827],
            [31.479760486936616, -0.632139883408322],
            [31.476682641380947, -0.619251119456185],
            [31.47691525293726, -0.616727877942017],
            [31.475970302513453, -0.614520835711315],
            [31.451064539109016, -0.603203545704338],
            [31.439953579193677, -0.598086588248159],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1364,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "LWANDA",
        Population: 28697,
        Key: "RAKAILWANDA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.14673349023468, 0.143005530819826],
            [32.14680314290686, 0.165334122770077],
            [32.14665922920509, 0.166860881333447],
            [32.14615727757378, 0.166694959610114],
            [32.145740292195306, 0.167160856278508],
            [32.145505654039745, 0.17212209869104],
            [32.146693938311046, 0.174849026439817],
            [32.14654006049614, 0.189150028473478],
            [32.14684502506037, 0.190450215932345],
            [32.15352907737409, 0.196299367654499],
            [32.15410863356448, 0.199546512792012],
            [32.15387832079698, 0.204777645909574],
            [32.1533743488546, 0.206254392176438],
            [32.15062612482105, 0.208780592696097],
            [32.143505015172146, 0.210357420119206],
            [32.1400810253813, 0.209276861875586],
            [32.135338600705815, 0.205439815015407],
            [32.13154588123691, 0.204328607011869],
            [32.12818865154302, 0.202891500277867],
            [32.12686913418848, 0.20191328685122],
            [32.12614482526983, 0.201021968665223],
            [32.12517062210715, 0.196375968345647],
            [32.124772069259976, 0.195871526844702],
            [32.12227200302704, 0.198287712068975],
            [32.119541687807, 0.198490089611226],
            [32.118317344261875, 0.199383680658778],
            [32.11658677759628, 0.199714983614427],
            [32.11342938981542, 0.199970479096762],
            [32.11075779297395, 0.201049336570194],
            [32.10893128084609, 0.201310786926975],
            [32.103494418930104, 0.201064772226683],
            [32.1003776808142, 0.20236137989603],
            [32.09741552748732, 0.203017324713694],
            [32.09322184858462, 0.204934444941872],
            [32.090458425056454, 0.20440226480335],
            [32.08775943319206, 0.202035992363374],
            [32.086895123633, 0.201711309997353],
            [32.083723977255296, 0.202749394876777],
            [32.08091636200505, 0.202478596732672],
            [32.07937211760746, 0.195990912247905],
            [32.076915497494916, 0.191566271249636],
            [32.07680889801341, 0.189730210313257],
            [32.0782517324969, 0.182681081271092],
            [32.07986992710699, 0.180063297648193],
            [32.08057623019408, 0.177682919272634],
            [32.081576727045146, 0.1760099093484],
            [32.081038280457086, 0.174784191734292],
            [32.07801540011869, 0.171611866888334],
            [32.07715304259875, 0.169434432148552],
            [32.076807899985134, 0.168237511280858],
            [32.078130212896845, 0.166643189021029],
            [32.08275539035973, 0.164091965375874],
            [32.087558539351804, 0.160589985333261],
            [32.089696032061354, 0.160490326626879],
            [32.09073541787936, 0.160002262163789],
            [32.09403957780122, 0.1563543030373],
            [32.0954034324049, 0.155221746347933],
            [32.09730567161291, 0.154378375104732],
            [32.0977088292242, 0.152452509922173],
            [32.09873066196159, 0.150589512047154],
            [32.09972380340708, 0.147411006639118],
            [32.09969118108755, 0.146124710509037],
            [32.099850362555884, 0.144812794435233],
            [32.102690789670184, 0.138349542601705],
            [32.10497976798103, 0.137086073889282],
            [32.10850163101873, 0.136529295171789],
            [32.11082389730076, 0.134151015685525],
            [32.11396098225786, 0.132307183633966],
            [32.11733392707933, 0.131254478584719],
            [32.118454287935364, 0.131524027258445],
            [32.123865288252645, 0.134676315780514],
            [32.12607675093762, 0.137574953628883],
            [32.12936612369156, 0.140210248094654],
            [32.132485623228675, 0.14349983444642],
            [32.13630225046053, 0.142761288636669],
            [32.13904074214629, 0.143198924920881],
            [32.1447350432564, 0.142482727319983],
            [32.14673349023468, 0.143005530819826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1972,
        District: "BUTAMBALA",
        County: "BUTAMBALA",
        Subcounty: "GOMBE TOWN COUNCIL",
        Population: 15553,
        Key: "BUTAMBALAGOMBE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.94813909193361, 0.950544039549949],
            [32.94608857680483, 0.952170409184371],
            [32.94603026446478, 0.951261718866313],
            [32.94146231597368, 0.950338947357414],
            [32.93721426474176, 0.95104371880589],
            [32.93455337761509, 0.952453363664826],
            [32.92433008525281, 0.951795294861458],
            [32.92222943155477, 0.950667492399218],
            [32.91667433158446, 0.949586596743418],
            [32.911726167556075, 0.945733310872363],
            [32.90962556685862, 0.942913869601617],
            [32.90677806551145, 0.940000428209197],
            [32.90196998117523, 0.935818205378647],
            [32.90112978868664, 0.933139764822458],
            [32.89584597274561, 0.927058723742264],
            [32.894931671941016, 0.922740162332697],
            [32.89525850688914, 0.920531653396383],
            [32.89453506394643, 0.916531627248983],
            [32.894581830240114, 0.913641758964463],
            [32.89259797639362, 0.910352415778492],
            [32.89301821547008, 0.90667547983016],
            [32.892481505325485, 0.902516870286035],
            [32.89518905094799, 0.9009662871928],
            [32.896146207679855, 0.894082313300407],
            [32.899180544233076, 0.891356992074182],
            [32.901900638421814, 0.884425899946948],
            [32.90299689478386, 0.884320375744028],
            [32.90394220453374, 0.883462837329163],
            [32.90482913636657, 0.883615577680853],
            [32.90557604420284, 0.883051718295574],
            [32.907034818392695, 0.883110492574559],
            [32.91036086666477, 0.881524669955679],
            [32.91254319339181, 0.881618702552753],
            [32.91589251341962, 0.882934494886322],
            [32.91750938570964, 0.885005203812243],
            [32.918693386813686, 0.881889033793508],
            [32.91960368652198, 0.880808288955903],
            [32.92317481316988, 0.878670328739159],
            [32.924015092795045, 0.877425116239823],
            [32.92424857931043, 0.873337007526381],
            [32.92480879746771, 0.870846558813038],
            [32.92561522138647, 0.869544411460878],
            [32.92068834114212, 0.866790304348117],
            [32.91698959443511, 0.866138817300774],
            [32.91296415561207, 0.867369161833316],
            [32.91007088330453, 0.869169511295714],
            [32.905201466492265, 0.868879876562305],
            [32.90230462787308, 0.867215095058403],
            [32.900226588364, 0.863071366889585],
            [32.8977043840492, 0.863297482218162],
            [32.89459153114687, 0.862899314114857],
            [32.887532546288064, 0.860230150773969],
            [32.882601652371044, 0.859379553661182],
            [32.87694449210637, 0.856837078369553],
            [32.87372921329536, 0.853959926306381],
            [32.866763428647275, 0.845527594737553],
            [32.86568295927805, 0.844812819257382],
            [32.86313044580554, 0.844713208716775],
            [32.85636443659519, 0.842867311708301],
            [32.853521797828655, 0.842577690258343],
            [32.85207529821881, 0.84356379174523],
            [32.848853325162324, 0.847544481361712],
            [32.84802785785786, 0.847544448127689],
            [32.84588772589801, 0.845707760091738],
            [32.84336622586239, 0.842722048284065],
            [32.8419638856353, 0.842124869718918],
            [32.836963324673015, 0.842577026475136],
            [32.83099835308297, 0.84107491800654],
            [32.81088454745877, 0.838576935637475],
            [32.80784334598016, 0.838386792535827],
            [32.806972607178636, 0.839508612360352],
            [32.81317089460415, 0.830497817742424],
            [32.821155631092495, 0.817397710256662],
            [32.82326397616602, 0.813317475058805],
            [32.82415562235745, 0.809083380451774],
            [32.83190889713304, 0.80828754969094],
            [32.838558172068865, 0.805600773705552],
            [32.85296412010703, 0.793052707375801],
            [32.85675413924016, 0.791478609746444],
            [32.857461666731005, 0.79050152537982],
            [32.860164139567104, 0.790184962243957],
            [32.86289164395863, 0.788809862829163],
            [32.86722114364072, 0.788828098697685],
            [32.86869035086433, 0.788375780510179],
            [32.8725367060439, 0.790420593977007],
            [32.874268774692645, 0.790845871634879],
            [32.87697043096019, 0.789705991026521],
            [32.87909654650666, 0.790312224346137],
            [32.880277297506005, 0.790203691234618],
            [32.88064411826403, 0.789751336369271],
            [32.8820346761879, 0.789561382288229],
            [32.882860159662016, 0.788602390521622],
            [32.887505612100895, 0.789416778934277],
            [32.89577141347532, 0.789453185095124],
            [32.897739148850704, 0.789109436945914],
            [32.90041384667655, 0.787526219885084],
            [32.901437308957846, 0.787625765373001],
            [32.90495261339564, 0.786703020358782],
            [32.90855700286186, 0.7833555911006],
            [32.91010484680879, 0.782930400705791],
            [32.912646720635074, 0.779791031327806],
            [32.91372242983158, 0.779519634086639],
            [32.91374772369505, 0.778732516776585],
            [32.91715797465196, 0.77788213770369],
            [32.91878784376748, 0.77666077936577],
            [32.922263191141454, 0.779130766916938],
            [32.925517813466946, 0.779945086212183],
            [32.929427979574434, 0.780288952782857],
            [32.93244695493629, 0.781465155960232],
            [32.935310861317184, 0.784921282561663],
            [32.93720161286931, 0.786215080805487],
            [32.9403800975846, 0.789327410435603],
            [32.94223374602055, 0.792955418369849],
            [32.9433919825439, 0.796284852869791],
            [32.94407503363819, 0.797017696804105],
            [32.95140103732531, 0.801604789348451],
            [32.95271490158178, 0.803314750719781],
            [32.9541297795953, 0.804411193807068],
            [32.956968013023676, 0.805214739295913],
            [32.96054085365711, 0.809068940575072],
            [32.96445216691319, 0.810435124603985],
            [32.968128669537144, 0.813013646922482],
            [32.97241043184674, 0.817238784809505],
            [32.97617823025303, 0.819220175535571],
            [32.979592419424144, 0.822042963927797],
            [32.981666329377866, 0.82285723427622],
            [32.98521252957323, 0.826313332131675],
            [32.98730244391208, 0.829678948271538],
            [32.98765025721703, 0.834495133232033],
            [32.98901386568234, 0.836794338644585],
            [32.99130119558464, 0.839425776819992],
            [32.99181467439767, 0.842104199022174],
            [32.992748279997734, 0.843725351505213],
            [32.993355120718235, 0.846309794767496],
            [32.993728556670064, 0.85100878153109],
            [32.99260822006852, 0.852935363175845],
            [32.991441198021676, 0.857164448022179],
            [32.99008745575313, 0.85941995713386],
            [32.98527935255229, 0.859607902169256],
            [32.976602621342714, 0.858867670314236],
            [32.967173032754765, 0.866400473820436],
            [32.980597697109125, 0.878788101088649],
            [32.98117607650649, 0.878492066454576],
            [32.98188523982944, 0.875946021046439],
            [32.983587211322934, 0.874113824270851],
            [32.98692022692836, 0.871758146393272],
            [32.988297762873835, 0.86982359994044],
            [32.992286128225096, 0.87275754556256],
            [32.99587915669789, 0.873376218026135],
            [32.99765203311508, 0.87409006480017],
            [32.998290268158144, 0.875065654483236],
            [33.0027184648422, 0.877387990527745],
            [32.99979675366941, 0.880482222857093],
            [32.9952011397625, 0.883913445151057],
            [32.99255332761478, 0.887834843051701],
            [32.984427259182795, 0.897331961574818],
            [32.979233400534305, 0.905065277580166],
            [32.97795437923278, 0.907695169817047],
            [32.97611607851345, 0.910297335343132],
            [32.97054374346612, 0.914460778133209],
            [32.967843727522286, 0.91793032522339],
            [32.96698199702642, 0.921515539927368],
            [32.966809620204884, 0.925447716884277],
            [32.96612023059797, 0.928628149620005],
            [32.965028719137266, 0.931056837454985],
            [32.96468399424023, 0.935509448877647],
            [32.964052067167124, 0.936723791976997],
            [32.96324780279828, 0.937533349617898],
            [32.961983968414955, 0.937938119386197],
            [32.96089247492055, 0.938227237541091],
            [32.95847971145853, 0.93788025227971],
            [32.956986090720434, 0.938111539264524],
            [32.95451586023303, 0.939325856312053],
            [32.94928809736913, 0.946091443721079],
            [32.94813909193361, 0.950544039549949],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 2025,
        District: "KAYUNGA",
        County: "BBAALE",
        Subcounty: "KITIMBWA",
        Population: 45500,
        Key: "KAYUNGAKITIMBWA",
        Dist2: "Kayunga",
        "Sub Country": "KITIMBWA",
        id2_original: "Kayunga KITIMBWA",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "N",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.440471291766666, -0.721175027256529],
            [31.44096524479865, -0.717981918279756],
            [31.438879115960447, -0.710389757808224],
            [31.43940195791369, -0.7071639927602],
            [31.43717288196093, -0.705530946440562],
            [31.43367327558271, -0.702079679192028],
            [31.43220461183987, -0.698500364069834],
            [31.43061347448613, -0.69231991250526],
            [31.42219124947129, -0.687807517935178],
            [31.417384570100158, -0.687001966767155],
            [31.417576170868806, -0.686113101797004],
            [31.411773109828918, -0.681788228475544],
            [31.40780895227794, -0.680918700105679],
            [31.39954949390775, -0.68738226634075],
            [31.391657646813037, -0.69096997235373],
            [31.3880732044377, -0.692307231015927],
            [31.381008629362885, -0.693715627962455],
            [31.37546315304421, -0.694337734824567],
            [31.37062007932767, -0.695891574752952],
            [31.36741035210512, -0.700783064537842],
            [31.363307299739862, -0.710458298486881],
            [31.360396945068878, -0.7141470475322],
            [31.366470593045374, -0.717992759195684],
            [31.375759690512766, -0.718475395956058],
            [31.37911019272349, -0.719019212102134],
            [31.381101772081433, -0.719924288610458],
            [31.388966375968504, -0.719782383064157],
            [31.3979897311136, -0.717786900357072],
            [31.40213522618112, -0.717905931264164],
            [31.40588602307232, -0.72279993082744],
            [31.40750311095801, -0.723677755668645],
            [31.408503066124922, -0.72472719783326],
            [31.41164776969397, -0.729494389639038],
            [31.413063714007745, -0.730788164916255],
            [31.418554826082037, -0.732689316618834],
            [31.427201355033436, -0.738570898781319],
            [31.429079375661363, -0.739213691421755],
            [31.430741546397883, -0.738879655520753],
            [31.43317297774986, -0.73699938067458],
            [31.43692321678729, -0.729087254033349],
            [31.43877171069012, -0.726627943393203],
            [31.440471291766666, -0.721175027256529],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1365,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "RAKAI TOWN COUNCIL",
        Population: 7391,
        Key: "RAKAIRAKAI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.676895497558913, -0.60929229306306],
            [31.654631868949608, -0.600359525897786],
            [31.636933910703828, -0.610440037819021],
            [31.610623833473603, -0.626198129507952],
            [31.599251064060297, -0.630102368346454],
            [31.597959548091485, -0.632082787268803],
            [31.594319977903805, -0.636169946036759],
            [31.591033492335132, -0.638538733230973],
            [31.586517015513195, -0.648929699621812],
            [31.585344857797857, -0.650765414588998],
            [31.580682616744653, -0.653052365584216],
            [31.573864594181003, -0.652571069615321],
            [31.571063869907327, -0.652823522049554],
            [31.568216818616104, -0.655083825327498],
            [31.56620940555296, -0.657814694325633],
            [31.562460615498107, -0.664633139562075],
            [31.555387441749385, -0.678478102509437],
            [31.552891322713794, -0.681697169108301],
            [31.548668547379037, -0.68838875607407],
            [31.54788911963118, -0.692196215434945],
            [31.547036695681683, -0.694113374594665],
            [31.544553811525166, -0.697079164014216],
            [31.543100360751676, -0.700470350232993],
            [31.54235967374878, -0.70149213973187],
            [31.542258217122257, -0.70270406020889],
            [31.543243338408935, -0.704829797994305],
            [31.543108897441826, -0.710066449333834],
            [31.545669247816846, -0.712672053621533],
            [31.54690533503769, -0.716679112885545],
            [31.549797243702606, -0.71937526185596],
            [31.55142994879947, -0.720144559682969],
            [31.552592623000358, -0.720126842711814],
            [31.555991691728625, -0.718934060314514],
            [31.558800956285708, -0.719296733729887],
            [31.563294108351315, -0.722029575317772],
            [31.56399990209362, -0.723133227771735],
            [31.566349122325754, -0.723070660603706],
            [31.57355338812218, -0.72677213116096],
            [31.57475576246872, -0.728237741056591],
            [31.57487169814098, -0.730987299821565],
            [31.57890650279919, -0.735112891899244],
            [31.581775466695113, -0.742150452801365],
            [31.582647317610977, -0.745524350259096],
            [31.58223083618737, -0.75023642005833],
            [31.58392652935535, -0.752552375033915],
            [31.583216023051033, -0.752995331101179],
            [31.58258415796165, -0.756866182380319],
            [31.584709279073103, -0.75966164563888],
            [31.58612387771056, -0.763786432910479],
            [31.585493125633814, -0.768507475988655],
            [31.589486805418304, -0.774740511796733],
            [31.590700338637323, -0.775527796023744],
            [31.59064030332857, -0.776233243907055],
            [31.588764393741556, -0.778909812561653],
            [31.58532685555955, -0.781386862488947],
            [31.58302856890575, -0.785962627666991],
            [31.581528972574432, -0.786703766788436],
            [31.580318553814514, -0.788349456076271],
            [31.578379526799004, -0.789135666162621],
            [31.57783529416221, -0.790238914419852],
            [31.576124304481592, -0.790880487611379],
            [31.5762103091869, -0.792291463419277],
            [31.57678154338448, -0.79354884695824],
            [31.57620279298292, -0.79622581859562],
            [31.576883064689696, -0.797175727507865],
            [31.579798607131412, -0.798958521742843],
            [31.583257615048677, -0.801908237489037],
            [31.58866163635451, -0.808793013707494],
            [31.591210399360694, -0.810865120359892],
            [31.592971231166537, -0.813090688565196],
            [31.597113637826073, -0.816999409927987],
            [31.60117692446868, -0.818285158036847],
            [31.607470721673526, -0.821344451003979],
            [31.61380752123102, -0.822658132443372],
            [31.61649035150516, -0.822794741333456],
            [31.617734267543675, -0.823491611154506],
            [31.618976337544318, -0.823003633786],
            [31.620615063150233, -0.824442313989196],
            [31.622101091327526, -0.824895053925297],
            [31.62270685406968, -0.824587755935774],
            [31.623192903723837, -0.825356714951614],
            [31.624132015098272, -0.824868630923177],
            [31.62467868935598, -0.825746151690952],
            [31.62531478640869, -0.825384589477376],
            [31.627952150251335, -0.825503081135276],
            [31.630878230829676, -0.826254809383849],
            [31.63172707948436, -0.826164651260017],
            [31.63248333429112, -0.825034324170943],
            [31.63330140935911, -0.824636635394154],
            [31.636060742857783, -0.825279762468715],
            [31.639031426586605, -0.825371225729304],
            [31.6469876029371, -0.824261443454131],
            [31.648928182241427, -0.824904284954682],
            [31.653599843927022, -0.827646447649796],
            [31.65814845887659, -0.828959498253197],
            [31.668772396262305, -0.828121926595175],
            [31.679484472750474, -0.824914577682667],
            [31.693073066169465, -0.818895144380431],
            [31.695164029740546, -0.818316940783128],
            [31.70427234305367, -0.817551086470668],
            [31.73188969270277, -0.818165949382323],
            [31.755958446349666, -0.817467994477428],
            [31.793261555359663, -0.817859321848514],
            [31.80106742200359, -0.817508892405747],
            [32.00050234792529, -0.820081490902883],
            [32.00050699401195, -0.818685384927538],
            [31.892175900202023, -0.79637744316399],
            [31.800992575272424, -0.752807606602209],
            [31.791913223644094, -0.752832221909311],
            [31.78496400482815, -0.748886554556832],
            [31.765123059776577, -0.741427731592788],
            [31.75043546564234, -0.733771388005665],
            [31.744029693437337, -0.727890251353954],
            [31.738497805933953, -0.72085159378813],
            [31.728539573174373, -0.710700227627375],
            [31.726952460273093, -0.707959124408443],
            [31.72601818812309, -0.705163936102483],
            [31.725072683438807, -0.704476256820471],
            [31.724832798223638, -0.702739536502583],
            [31.723156659582777, -0.701110958315289],
            [31.72164171283986, -0.700432165703893],
            [31.720533810718496, -0.699075106559771],
            [31.719714764571684, -0.696949295200793],
            [31.71882978118469, -0.691494888043974],
            [31.717358188934018, -0.68935080645976],
            [31.717306667857525, -0.685633278611223],
            [31.718124893842482, -0.683444587231762],
            [31.715887254250127, -0.682602801659898],
            [31.714802642749117, -0.681336212935894],
            [31.715164008038467, -0.680268998093485],
            [31.716591730163927, -0.679464370860468],
            [31.716621817437744, -0.678270424776343],
            [31.714158433909414, -0.675239685401362],
            [31.713504438823005, -0.673285779248661],
            [31.71029010414138, -0.668653874823861],
            [31.71042717807058, -0.665171572350618],
            [31.708561819196575, -0.663443496988938],
            [31.70721638993766, -0.659870356532664],
            [31.70596082364822, -0.659481095609488],
            [31.7034455354628, -0.659588980618661],
            [31.699972114975107, -0.656856475967893],
            [31.698952655586716, -0.654450249896628],
            [31.694519603508553, -0.647005084292342],
            [31.68762880932207, -0.637677963419023],
            [31.680816706656163, -0.626948942339016],
            [31.67978279696813, -0.625058299147482],
            [31.679540827661523, -0.623665308652593],
            [31.67993369417293, -0.621159973410795],
            [31.679538158766814, -0.619685558860491],
            [31.67859474176722, -0.618581830974723],
            [31.677597946873433, -0.616419851789253],
            [31.675978101159853, -0.610865872569233],
            [31.676895497558913, -0.60929229306306],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1366,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KABIRA",
        Population: 30797,
        Key: "KYOTERAKABIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [31.61793950294171, -0.557082745767825],
              [31.614584400458412, -0.558645190529899],
              [31.612587468039703, -0.559123333821065],
              [31.609735015178664, -0.558500459052701],
              [31.60682910806668, -0.556052459087456],
              [31.605260623529475, -0.554161566315405],
              [31.603054393531025, -0.550033011116343],
              [31.603026563723514, -0.547017745641215],
              [31.603554746161098, -0.545036409917224],
              [31.60640775058772, -0.540481547644642],
              [31.606518408657674, -0.536793577508496],
              [31.607438812616323, -0.534812328274159],
              [31.60731816168713, -0.532199867598329],
              [31.610137976957255, -0.529896456183048],
              [31.611279380848828, -0.528221563046451],
              [31.60968689961543, -0.527272353553122],
              [31.608290045399773, -0.523129638550007],
              [31.60896065842062, -0.521050808593071],
              [31.608577162235935, -0.517326010959699],
              [31.609974252708497, -0.514935738584993],
              [31.608924926133543, -0.511499221314563],
              [31.60857367856926, -0.508828779567965],
              [31.606829780006507, -0.507498922808249],
              [31.599619833264203, -0.517066258406979],
              [31.598301415447576, -0.521364891536273],
              [31.597467443792322, -0.525837828879843],
              [31.596812824376798, -0.526563648696917],
              [31.595475864434384, -0.526296268354029],
              [31.594126170872812, -0.525443196718617],
              [31.590126364578087, -0.522151878314417],
              [31.58747062120473, -0.523397858918007],
              [31.58659026593808, -0.523020327118556],
              [31.57992602506965, -0.515774146340867],
              [31.579475982587013, -0.515674547871942],
              [31.57843152937248, -0.515791900823046],
              [31.577072057649037, -0.517166359890146],
              [31.576017103128834, -0.521561759058424],
              [31.574064127073594, -0.525305747682307],
              [31.567866197177565, -0.5332725300528],
              [31.566269771441746, -0.534601692394331],
              [31.56385904086719, -0.535125709866667],
              [31.56019930350137, -0.534093782767151],
              [31.554897161928555, -0.534074449167276],
              [31.5521018356314, -0.53327787479722],
              [31.550415795759466, -0.533603084072392],
              [31.545324372002842, -0.531856315441301],
              [31.541724004294156, -0.531560966585602],
              [31.538134499912204, -0.532038715888184],
              [31.537658955156974, -0.532588991098502],
              [31.539571507024423, -0.543178505498951],
              [31.540230774323234, -0.544164509456165],
              [31.538787014575036, -0.545765008517838],
              [31.550632518813348, -0.561639884144301],
              [31.55253010295153, -0.559302518524129],
              [31.554937215112144, -0.558106606025442],
              [31.570003064659666, -0.554431012358536],
              [31.572081361086916, -0.561461044449256],
              [31.576834614054842, -0.565620105914415],
              [31.57774121000924, -0.572139166707223],
              [31.580762344022748, -0.57961975999055],
              [31.581278385729266, -0.582993506735272],
              [31.58342479601463, -0.585390854454872],
              [31.58417544353742, -0.587010021634338],
              [31.5847745838993, -0.592635882028227],
              [31.582527054753992, -0.59818866364132],
              [31.582305701783138, -0.599689997926575],
              [31.583123477712153, -0.606609296727396],
              [31.58393745646244, -0.609738920928885],
              [31.583108028485906, -0.616305042061333],
              [31.58508639991422, -0.62130721839322],
              [31.58871957858866, -0.627440409031424],
              [31.591033492335132, -0.638538733230973],
              [31.594319977903805, -0.636169946036759],
              [31.597959548091485, -0.632082787268803],
              [31.599251064060297, -0.630102368346454],
              [31.610623833473603, -0.626198129507952],
              [31.636933910703828, -0.610440037819021],
              [31.63344291467762, -0.599793484465855],
              [31.632571717735278, -0.598527001032106],
              [31.627000556786026, -0.595486579957868],
              [31.624350401832046, -0.591904208288224],
              [31.623145885003563, -0.590845685451693],
              [31.620335400534287, -0.586168868015602],
              [31.615664019123056, -0.576661758354641],
              [31.6138514542383, -0.571677710762057],
              [31.612341593756547, -0.570049307678109],
              [31.610354641620624, -0.568674036019444],
              [31.612051631057543, -0.567381061848079],
              [31.61283787612007, -0.562207698994507],
              [31.614546618215854, -0.559847442925489],
              [31.61793950294171, -0.557082745767825],
            ],
          ],
          [
            [
              [31.65882702198768, -0.494544945460898],
              [31.64955997097399, -0.490612042813016],
              [31.6435251005734, -0.490743913355729],
              [31.637661966495536, -0.489978723183688],
              [31.63267251410006, -0.492269372647611],
              [31.63169795250957, -0.493707280542357],
              [31.63172123055352, -0.495235856192954],
              [31.633466987730603, -0.498257165011108],
              [31.63192178572891, -0.500264778534401],
              [31.626290574199523, -0.498328022339316],
              [31.621859025901166, -0.498055755065989],
              [31.619672885825736, -0.497196053950901],
              [31.61941142397578, -0.49748542902943],
              [31.617368473559992, -0.495305227795579],
              [31.6159189026102, -0.495232571176684],
              [31.614326434851524, -0.496408045474512],
              [31.611654725720623, -0.502892506067619],
              [31.608903424058923, -0.505651129051569],
              [31.61164735234878, -0.507009017920294],
              [31.61346628449226, -0.507300405610023],
              [31.615224481539375, -0.51151259669612],
              [31.617977561865334, -0.516602471705388],
              [31.62366912670708, -0.516361407813613],
              [31.624097246703517, -0.515284612175404],
              [31.625107757075053, -0.51426298416634],
              [31.62463251774703, -0.513363080914574],
              [31.62716221221467, -0.511506589002915],
              [31.629198890593123, -0.514114295618344],
              [31.633714608338654, -0.518363008920382],
              [31.639693587358934, -0.522154131195581],
              [31.64150465924368, -0.523748330975759],
              [31.642716640173877, -0.52552906396344],
              [31.64293770837879, -0.527048660956244],
              [31.64644395600188, -0.525746983385577],
              [31.656679085464678, -0.526092897452129],
              [31.66145041163778, -0.527875753298246],
              [31.66521086182505, -0.530128744288374],
              [31.665894062039666, -0.531069552660964],
              [31.668949800954532, -0.53198374675241],
              [31.669731442151235, -0.531893920891999],
              [31.667843142999814, -0.529548375684122],
              [31.66171348776032, -0.524423082154352],
              [31.66124401022651, -0.523062876743937],
              [31.66105123086824, -0.519174031308252],
              [31.662430854498435, -0.51733954891749],
              [31.66695859709238, -0.514264914568108],
              [31.66584628244631, -0.511216059360269],
              [31.66254433597333, -0.507452701808346],
              [31.66008565782047, -0.50180821561981],
              [31.658232726240144, -0.499655162771243],
              [31.658007409902265, -0.497565757845112],
              [31.65882702198768, -0.494544945460898],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1367,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KALISIZO",
        Population: 17992,
        Key: "KYOTERAKALISIZO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.64293770837879, -0.527048660956244],
            [31.642716640173877, -0.52552906396344],
            [31.64150465924368, -0.523748330975759],
            [31.639693587358934, -0.522154131195581],
            [31.633714608338654, -0.518363008920382],
            [31.629198890593123, -0.514114295618344],
            [31.62716221221467, -0.511506589002915],
            [31.62463251774703, -0.513363080914574],
            [31.625107757075053, -0.51426298416634],
            [31.624097246703517, -0.515284612175404],
            [31.62366912670708, -0.516361407813613],
            [31.617977561865334, -0.516602471705388],
            [31.615224481539375, -0.51151259669612],
            [31.61346628449226, -0.507300405610023],
            [31.61164735234878, -0.507009017920294],
            [31.608903424058923, -0.505651129051569],
            [31.606829780006507, -0.507498922808249],
            [31.60857367856926, -0.508828779567965],
            [31.608924926133543, -0.511499221314563],
            [31.609974252708497, -0.514935738584993],
            [31.608577162235935, -0.517326010959699],
            [31.60896065842062, -0.521050808593071],
            [31.608290045399773, -0.523129638550007],
            [31.60968689961543, -0.527272353553122],
            [31.611279380848828, -0.528221563046451],
            [31.610137976957255, -0.529896456183048],
            [31.60731816168713, -0.532199867598329],
            [31.607438812616323, -0.534812328274159],
            [31.606518408657674, -0.536793577508496],
            [31.60640775058772, -0.540481547644642],
            [31.603554746161098, -0.545036409917224],
            [31.603026563723514, -0.547017745641215],
            [31.603054393531025, -0.550033011116343],
            [31.605260623529475, -0.554161566315405],
            [31.60682910806668, -0.556052459087456],
            [31.609735015178664, -0.558500459052701],
            [31.612587468039703, -0.559123333821065],
            [31.614584400458412, -0.558645190529899],
            [31.61793950294171, -0.557082745767825],
            [31.622318883376586, -0.55477519381972],
            [31.624796256368814, -0.55287638325744],
            [31.62946138011576, -0.552226248820999],
            [31.631542616728943, -0.548961577769478],
            [31.63359207274401, -0.547162142341953],
            [31.633248370129778, -0.547058883911195],
            [31.641138610138455, -0.542415422705966],
            [31.64197760247782, -0.541111969804652],
            [31.64246794877399, -0.538184915032678],
            [31.64293770837879, -0.527048660956244],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1368,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KALISIZO TOWN COUNCIL",
        Population: 13981,
        Key: "KYOTERAKALISIZO TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.666795573529555, -0.459217273830613],
            [31.66596237173048, -0.458620157662773],
            [31.663728883253075, -0.458429797275248],
            [31.66246948654724, -0.457705982206369],
            [31.659785544158797, -0.451971042361019],
            [31.657494469180055, -0.444255368102623],
            [31.654893003812823, -0.442002733831166],
            [31.64990324958342, -0.440229045802333],
            [31.645091281830204, -0.439739747894327],
            [31.63106140270599, -0.441555168731969],
            [31.621398699505193, -0.444194443496309],
            [31.61630199994291, -0.442764438469714],
            [31.609436032495907, -0.437725271149915],
            [31.603460432937737, -0.434024904062183],
            [31.599849037510623, -0.432287668542485],
            [31.596211131901157, -0.431310177457547],
            [31.59451191823559, -0.431581203172693],
            [31.59384643639166, -0.432060445257112],
            [31.593038095468092, -0.43376068118107],
            [31.590528905945106, -0.443021869972616],
            [31.585859308588045, -0.444594727034714],
            [31.58352969588362, -0.448320639764032],
            [31.578098995512196, -0.452660963831108],
            [31.576743810549303, -0.455337881796229],
            [31.574830315450793, -0.45740869244645],
            [31.573748520168223, -0.46043839621642],
            [31.57182326073276, -0.462346397335762],
            [31.571228449352223, -0.464616447531298],
            [31.57123917344007, -0.469943670760537],
            [31.569550110737204, -0.476898540606677],
            [31.563916983999636, -0.482324058948828],
            [31.56060185025827, -0.483417736932649],
            [31.55851036027445, -0.485352813173691],
            [31.557345946935186, -0.485904272710996],
            [31.557036680339056, -0.486618714855389],
            [31.555135467007137, -0.487577030816136],
            [31.55466001477837, -0.488200987871769],
            [31.552806664583102, -0.488535235253456],
            [31.55058433228318, -0.490524530349185],
            [31.548931654044278, -0.4912205886557],
            [31.550016012220375, -0.492152401940928],
            [31.54986006738198, -0.494024558205499],
            [31.54794482685692, -0.502688689770767],
            [31.54755794671853, -0.502688603535832],
            [31.546703475508483, -0.510900730002118],
            [31.540861791402985, -0.512011872092483],
            [31.54423129208366, -0.516390133871425],
            [31.54485226510023, -0.51788259517698],
            [31.546660202762933, -0.528284082234625],
            [31.545324372002842, -0.531856315441301],
            [31.550415795759466, -0.533603084072392],
            [31.5521018356314, -0.53327787479722],
            [31.554897161928555, -0.534074449167276],
            [31.56019930350137, -0.534093782767151],
            [31.56385904086719, -0.535125709866667],
            [31.566269771441746, -0.534601692394331],
            [31.567866197177565, -0.5332725300528],
            [31.574064127073594, -0.525305747682307],
            [31.576017103128834, -0.521561759058424],
            [31.577072057649037, -0.517166359890146],
            [31.57843152937248, -0.515791900823046],
            [31.579475982587013, -0.515674547871942],
            [31.57992602506965, -0.515774146340867],
            [31.58659026593808, -0.523020327118556],
            [31.58747062120473, -0.523397858918007],
            [31.590126364578087, -0.522151878314417],
            [31.594126170872812, -0.525443196718617],
            [31.595475864434384, -0.526296268354029],
            [31.596812824376798, -0.526563648696917],
            [31.597467443792322, -0.525837828879843],
            [31.598301415447576, -0.521364891536273],
            [31.599619833264203, -0.517066258406979],
            [31.606829780006507, -0.507498922808249],
            [31.608903424058923, -0.505651129051569],
            [31.611654725720623, -0.502892506067619],
            [31.614326434851524, -0.496408045474512],
            [31.6159189026102, -0.495232571176684],
            [31.617368473559992, -0.495305227795579],
            [31.61941142397578, -0.49748542902943],
            [31.619672885825736, -0.497196053950901],
            [31.621859025901166, -0.498055755065989],
            [31.626290574199523, -0.498328022339316],
            [31.63192178572891, -0.500264778534401],
            [31.633466987730603, -0.498257165011108],
            [31.63172123055352, -0.495235856192954],
            [31.63169795250957, -0.493707280542357],
            [31.63267251410006, -0.492269372647611],
            [31.637661966495536, -0.489978723183688],
            [31.6435251005734, -0.490743913355729],
            [31.64955997097399, -0.490612042813016],
            [31.65882702198768, -0.494544945460898],
            [31.658757152821536, -0.492934951164396],
            [31.659256645763886, -0.49145168973124],
            [31.662393884332925, -0.489064489883742],
            [31.665068414173813, -0.485202857392154],
            [31.666687875408474, -0.475072917928318],
            [31.66591848813054, -0.470552419660419],
            [31.666202734849378, -0.460673264837568],
            [31.666795573529555, -0.459217273830613],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1369,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KIRUMBA",
        Population: 24992,
        Key: "KYOTERAKIRUMBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.548071577346878, -0.623051765084274],
            [31.54483456200093, -0.618275419107947],
            [31.544100440784447, -0.618031020608256],
            [31.540035136525724, -0.619657896859212],
            [31.53616592101878, -0.622048404346644],
            [31.53248293794837, -0.623167971463592],
            [31.53109834483803, -0.623113454136784],
            [31.53132018110249, -0.62585471868456],
            [31.530600405082758, -0.627970673381171],
            [31.53129096519449, -0.633191269500686],
            [31.533818184803522, -0.633309270378853],
            [31.535340061150553, -0.634834263916489],
            [31.53593717760811, -0.636061389528792],
            [31.5375502643975, -0.63626634189998],
            [31.53814759914568, -0.636711583261016],
            [31.53946124061994, -0.639466597482086],
            [31.540058654419866, -0.639635174707173],
            [31.541002653527745, -0.639599356617224],
            [31.541250117828962, -0.637243893797694],
            [31.543044208859875, -0.634831222407655],
            [31.543785301002995, -0.635629716329044],
            [31.5518430283031, -0.635506847832731],
            [31.55544969320194, -0.633962443986635],
            [31.55541698015254, -0.632946191712559],
            [31.554212070760254, -0.630533205725468],
            [31.552303354699077, -0.628494464806661],
            [31.55179725913939, -0.627339845969648],
            [31.55078821122512, -0.626855314744987],
            [31.549104747721433, -0.624933579982364],
            [31.548071577346878, -0.623051765084274],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1370,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "KYOTERA TOWN COUNCIL",
        Population: 12669,
        Key: "KYOTERAKYOTERA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.707808422829043, -0.533464251871408],
            [31.708161148121984, -0.533167946428358],
            [31.707103181550618, -0.531847153020166],
            [31.698910396140793, -0.526454615791453],
            [31.69065147855639, -0.524680065013995],
            [31.68602690565965, -0.524371567727133],
            [31.680970827016214, -0.522597708033062],
            [31.679740911221362, -0.521846709921595],
            [31.678892638386785, -0.520770193682665],
            [31.677819109401433, -0.517305761063682],
            [31.675986671087657, -0.515116512740783],
            [31.66951369232297, -0.515395559506532],
            [31.66757057707464, -0.514933862080143],
            [31.66695859709238, -0.514264914568108],
            [31.662430854498435, -0.51733954891749],
            [31.66105123086824, -0.519174031308252],
            [31.66124401022651, -0.523062876743937],
            [31.66171348776032, -0.524423082154352],
            [31.667843142999814, -0.529548375684122],
            [31.669731442151235, -0.531893920891999],
            [31.668949800954532, -0.53198374675241],
            [31.665894062039666, -0.531069552660964],
            [31.66521086182505, -0.530128744288374],
            [31.66145041163778, -0.527875753298246],
            [31.656679085464678, -0.526092897452129],
            [31.64644395600188, -0.525746983385577],
            [31.64293770837879, -0.527048660956244],
            [31.64246794877399, -0.538184915032678],
            [31.64197760247782, -0.541111969804652],
            [31.641138610138455, -0.542415422705966],
            [31.633248370129778, -0.547058883911195],
            [31.63359207274401, -0.547162142341953],
            [31.631542616728943, -0.548961577769478],
            [31.62946138011576, -0.552226248820999],
            [31.624796256368814, -0.55287638325744],
            [31.622318883376586, -0.55477519381972],
            [31.61793950294171, -0.557082745767825],
            [31.614546618215854, -0.559847442925489],
            [31.61283787612007, -0.562207698994507],
            [31.612051631057543, -0.567381061848079],
            [31.610354641620624, -0.568674036019444],
            [31.612341593756547, -0.570049307678109],
            [31.6138514542383, -0.571677710762057],
            [31.615664019123056, -0.576661758354641],
            [31.620335400534287, -0.586168868015602],
            [31.623145885003563, -0.590845685451693],
            [31.624350401832046, -0.591904208288224],
            [31.627000556786026, -0.595486579957868],
            [31.632571717735278, -0.598527001032106],
            [31.63344291467762, -0.599793484465855],
            [31.636933910703828, -0.610440037819021],
            [31.654631868949608, -0.600359525897786],
            [31.676895497558913, -0.60929229306306],
            [31.676917087668457, -0.608252131426054],
            [31.676076218748456, -0.605692219349337],
            [31.676187622420098, -0.60479679719446],
            [31.67891728456492, -0.59325615078673],
            [31.687364375845153, -0.58397806223156],
            [31.68694082288362, -0.583335760604667],
            [31.68338640490004, -0.582457575301451],
            [31.68267903551272, -0.581616226076745],
            [31.68398366778299, -0.574859976195058],
            [31.686207559558238, -0.569261671428435],
            [31.68683282742017, -0.563084109720462],
            [31.68772196282042, -0.560922571589182],
            [31.691313106627767, -0.557015953793427],
            [31.690892503733647, -0.555776700953679],
            [31.688831755895464, -0.555097864314376],
            [31.68423535955595, -0.551677860871653],
            [31.683252965554498, -0.548973210418458],
            [31.683470159325555, -0.548258703434046],
            [31.68515269576788, -0.546323460378127],
            [31.687534034364667, -0.544623529642522],
            [31.693727365784753, -0.542137507184723],
            [31.696440277044502, -0.540555225982203],
            [31.70114839685589, -0.536250814956529],
            [31.70495356427971, -0.534478803720182],
            [31.707043184869434, -0.534153616948212],
            [31.707808422829043, -0.533464251871408],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1371,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "LWANKONI",
        Population: 14887,
        Key: "KYOTERALWANKONI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.545324372002842, -0.531856315441301],
            [31.546660202762933, -0.528284082234625],
            [31.54485226510023, -0.51788259517698],
            [31.54423129208366, -0.516390133871425],
            [31.540861791402985, -0.512011872092483],
            [31.546703475508483, -0.510900730002118],
            [31.54755794671853, -0.502688603535832],
            [31.54794482685692, -0.502688689770767],
            [31.54986006738198, -0.494024558205499],
            [31.550016012220375, -0.492152401940928],
            [31.548931654044278, -0.4912205886557],
            [31.54767112096962, -0.492251377361705],
            [31.54530742797995, -0.492214677146862],
            [31.544305454298563, -0.493345014207657],
            [31.54270288408623, -0.493426061699133],
            [31.540835158151438, -0.495343059828304],
            [31.537533580886038, -0.496147289600775],
            [31.536347412147236, -0.497340879377944],
            [31.534360318077503, -0.496951531851411],
            [31.530048914956808, -0.497520363193834],
            [31.528831064434545, -0.497293973815713],
            [31.526683418067375, -0.497971826842856],
            [31.525529564424257, -0.497772596119633],
            [31.524375391879236, -0.499029486581782],
            [31.522804742402165, -0.499553707306951],
            [31.52217957065999, -0.50053035352278],
            [31.5210895468094, -0.501117992761765],
            [31.520366534159695, -0.502709626897532],
            [31.51708920422044, -0.505630181154918],
            [31.500754641539256, -0.519563569726747],
            [31.491842365773987, -0.529482913753453],
            [31.487994767326065, -0.532593171677208],
            [31.486069044359905, -0.535134106951676],
            [31.481455992356704, -0.538786804605658],
            [31.478175614433706, -0.54368789203079],
            [31.472645352881006, -0.546182662144755],
            [31.470269666483983, -0.546091612145679],
            [31.46874034400158, -0.547565411805952],
            [31.467338366693845, -0.547275641996282],
            [31.46674478780189, -0.547546812139069],
            [31.465372130606713, -0.550051670959861],
            [31.46390131360214, -0.551100400242504],
            [31.460677686747168, -0.554708148506146],
            [31.458587707729638, -0.555024138547168],
            [31.44526019527494, -0.554667936408647],
            [31.444192369693322, -0.555219335093038],
            [31.441465677378837, -0.55777805739867],
            [31.441395621363096, -0.558347803909131],
            [31.439013105973277, -0.56087043586837],
            [31.43851744165065, -0.562498212740301],
            [31.438924405423816, -0.563999624779401],
            [31.439865387988966, -0.565365515102166],
            [31.440536411539927, -0.56835019852198],
            [31.44080246737424, -0.570801189951297],
            [31.440203302757833, -0.574129205599981],
            [31.440936793356983, -0.578624251134677],
            [31.441582000224955, -0.580487487187129],
            [31.443011298893747, -0.582513731477669],
            [31.444361916821734, -0.586810004264373],
            [31.44410324963061, -0.588193659554223],
            [31.442198451122408, -0.591982544386632],
            [31.440570270839586, -0.597489861799964],
            [31.439953579193677, -0.598086588248159],
            [31.451064539109016, -0.603203545704338],
            [31.456983828671934, -0.596955884593844],
            [31.45829721232969, -0.595760313274347],
            [31.459704210321533, -0.595194208489676],
            [31.460391938943516, -0.59541470604028],
            [31.461329409095924, -0.596957105338072],
            [31.463892408602714, -0.599066461102163],
            [31.46754961810933, -0.601207600292529],
            [31.472599203729914, -0.603026345764226],
            [31.472888675948735, -0.60589006762135],
            [31.4739048825375, -0.606552414998161],
            [31.47439936018563, -0.60596466134772],
            [31.475989967533348, -0.605440549718434],
            [31.476960690622644, -0.603885242045535],
            [31.4784799906014, -0.60333396936226],
            [31.478690226920605, -0.601479995805755],
            [31.479544913726325, -0.601190811704141],
            [31.480804319415327, -0.601381093148789],
            [31.483028851689372, -0.603225533447234],
            [31.491024196382874, -0.601003339130182],
            [31.495632772081034, -0.598624826719433],
            [31.496393858925718, -0.597045688789213],
            [31.50160137196652, -0.59053827763754],
            [31.505179924088523, -0.586898972336349],
            [31.509871114250082, -0.583535765522766],
            [31.510443483918202, -0.580668881865967],
            [31.50903864278135, -0.577177428965669],
            [31.507255685470064, -0.575630398128802],
            [31.506549584503915, -0.574526811409451],
            [31.506483001375052, -0.573649507742668],
            [31.506826344663175, -0.571551327684653],
            [31.50763973052538, -0.570267254225658],
            [31.510194582312526, -0.568805293178537],
            [31.513098607454026, -0.568125281318101],
            [31.518930429854322, -0.568328953512433],
            [31.522258130128225, -0.569137436962121],
            [31.523803027601005, -0.569945463078617],
            [31.52734472005027, -0.57421567488388],
            [31.527852187337427, -0.576983370368437],
            [31.52846311539249, -0.578086939544733],
            [31.528149535984696, -0.579063638733551],
            [31.530351566359183, -0.582166431083582],
            [31.54165695493967, -0.57969120384031],
            [31.544326446130135, -0.579574316545558],
            [31.546158677831414, -0.578489454120722],
            [31.54940858669663, -0.572138973579076],
            [31.55473469801616, -0.567236017091045],
            [31.550632518813348, -0.561639884144301],
            [31.538787014575036, -0.545765008517838],
            [31.540230774323234, -0.544164509456165],
            [31.539571507024423, -0.543178505498951],
            [31.537658955156974, -0.532588991098502],
            [31.538134499912204, -0.532038715888184],
            [31.541724004294156, -0.531560966585602],
            [31.545324372002842, -0.531856315441301],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1372,
        District: "KYOTERA",
        County: "KYOTERA",
        Subcounty: "NABIGASA",
        Population: 20658,
        Key: "KYOTERANABIGASA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.17010001369556, 0.23101367190717],
            [31.167457287808976, 0.233038888244143],
            [31.158153948451062, 0.23528926961077],
            [31.15414710116116, 0.23496319558638],
            [31.151217922293398, 0.23400428439022],
            [31.144991781704185, 0.232773655661387],
            [31.130059606860815, 0.233006751280666],
            [31.12651299613537, 0.231740324893498],
            [31.118737420682837, 0.227263267029422],
            [31.11343462962806, 0.225598757501827],
            [31.112035515251137, 0.224802841036754],
            [31.111324606501586, 0.224278288227809],
            [31.10924704579456, 0.219349910595052],
            [31.107873567539205, 0.217812529734038],
            [31.104388874991333, 0.215533406967531],
            [31.10004890903787, 0.213543540273499],
            [31.095496848150898, 0.210803143186461],
            [31.080057999232775, 0.203621673295711],
            [31.07298586663145, 0.202400115009431],
            [31.06372832787829, 0.201829333520808],
            [31.060834396207337, 0.200743925624047],
            [31.053881069395636, 0.199531441847869],
            [31.051034577754837, 0.19852742696359],
            [31.044437476072407, 0.197233619023855],
            [31.03857217705471, 0.197784476157847],
            [31.02858690859832, 0.193678220107041],
            [31.02588067990598, 0.193668856121993],
            [31.01932517830607, 0.197438550474148],
            [31.01342990430396, 0.198242559419871],
            [31.013212557819294, 0.189670834693381],
            [31.014673798782948, 0.184046955479384],
            [31.015115698037487, 0.177808105193318],
            [31.0159057977709, 0.175041373710151],
            [31.0157926684356, 0.172581967560561],
            [31.016371227496016, 0.168911021148337],
            [31.017797678505378, 0.168025063325829],
            [31.018870595738008, 0.16607212431719],
            [31.028218804147706, 0.158188494240767],
            [31.03107170886131, 0.156452713110037],
            [31.03199998026521, 0.155476268675088],
            [31.032884041980715, 0.153044061010983],
            [31.033860331929823, 0.151805400008474],
            [31.039368529062514, 0.151697408517048],
            [31.042932924633963, 0.150251012743282],
            [31.047256457705927, 0.146652670237848],
            [31.04971048797551, 0.142312693829809],
            [31.049496756311527, 0.140630849725617],
            [31.04874972091451, 0.139220223153382],
            [31.048972758226522, 0.137041104354824],
            [31.051117647664103, 0.130332058515031],
            [31.05143983832224, 0.127013639020178],
            [31.049991680422377, 0.12543116346925],
            [31.04975322802011, 0.123830698202753],
            [31.047628107806954, 0.121931705382092],
            [31.05114202165271, 0.119743782525269],
            [31.053081882304795, 0.118062095917233],
            [31.0563983751972, 0.1174836395885],
            [31.056787440936624, 0.11676934119125],
            [31.056667635322132, 0.116163510530427],
            [31.054880114569187, 0.114770900089223],
            [31.054811753674368, 0.112962475517686],
            [31.054040556291188, 0.111551854632827],
            [31.053898915327075, 0.110068940993089],
            [31.051194217363996, 0.107636439646131],
            [31.050492827163193, 0.107419383699538],
            [31.051438184523782, 0.10668703613743],
            [31.051465778972688, 0.105303599729585],
            [31.05032965178509, 0.104661538941216],
            [31.049994915255724, 0.102970649145872],
            [31.04888436130764, 0.101804151781061],
            [31.047941317108876, 0.101505704963938],
            [31.047991610188376, 0.10065575360248],
            [31.047461190945715, 0.099778640799096],
            [31.04823672090353, 0.099290417060368],
            [31.047778419310216, 0.098657444394297],
            [31.04702846259187, 0.098630273990489],
            [31.048217479888464, 0.097192656326401],
            [31.048487010406323, 0.095745942273216],
            [31.04977200191122, 0.094579591080023],
            [31.049580348142005, 0.093774835521575],
            [31.047816663286778, 0.09258118000504],
            [31.045929429537317, 0.092355021341941],
            [31.04542055369178, 0.092671464166343],
            [31.04440682555491, 0.091550192070973],
            [31.044409415397872, 0.090383768873902],
            [31.045137527783435, 0.089533856763211],
            [31.044509694333065, 0.088955131318173],
            [31.044634403850683, 0.087273318211899],
            [31.043739632420344, 0.087029133942265],
            [31.042775325098855, 0.085446726412327],
            [31.043163233808176, 0.085085065079404],
            [31.044541881867996, 0.085374483977451],
            [31.0455854870729, 0.084135776827904],
            [31.045442679197226, 0.083059766044454],
            [31.04629004203845, 0.082842800672843],
            [31.04679977936833, 0.082137545752296],
            [31.049461397723647, 0.082264270060719],
            [31.049876024126174, 0.08082660054959],
            [31.052030328806264, 0.078041745895365],
            [31.05246266818957, 0.075880707596969],
            [31.051944059996277, 0.074189813780997],
            [31.05301859778967, 0.071558615408038],
            [31.05290531035088, 0.069135330009106],
            [31.05335949766022, 0.067751908390682],
            [31.05321920147407, 0.06676631437097],
            [31.052578997323927, 0.066458857189618],
            [31.052109811742586, 0.063918010884136],
            [31.054567211592815, 0.061350152127891],
            [31.056605514125284, 0.060165713311975],
            [31.057131840643535, 0.058447732065593],
            [31.056969107236544, 0.056829187931543],
            [31.056449050959, 0.055852620875187],
            [31.056597903598206, 0.053004362635386],
            [31.05545921890698, 0.052669765487144],
            [31.054559126755233, 0.051738400672015],
            [31.05437110217976, 0.050879395110859],
            [31.05365988979963, 0.050418225377001],
            [31.053734026861715, 0.049116166372895],
            [31.05397289967556, 0.048519395085042],
            [31.05694444758369, 0.046828610897129],
            [31.057993667259126, 0.044776080604801],
            [31.058897744337457, 0.043935188580561],
            [31.058166077318344, 0.041991112681478],
            [31.058383928656212, 0.040128442045198],
            [31.057480179462917, 0.039215164640656],
            [31.0570499493239, 0.037397689970807],
            [31.055862710691592, 0.036818965741771],
            [31.054791974568445, 0.035209447378698],
            [31.05566236482366, 0.034359509224208],
            [31.05703458903087, 0.03398881230164],
            [31.05740767104647, 0.03077887089489],
            [31.056616523877413, 0.026845535937689],
            [31.058794606963072, 0.023888799742085],
            [31.059370583367034, 0.021845289838764],
            [31.058963349200983, 0.019982605373524],
            [31.059333021211767, 0.01819227029823],
            [31.058354330964214, 0.016356706829093],
            [31.058471667109988, 0.014973265410672],
            [31.058289794197574, 0.014512114376498],
            [31.05698831231899, 0.013960532639409],
            [31.05726506708837, 0.012821229040115],
            [31.05694707156261, 0.011989352275599],
            [31.056011027036565, 0.011419691039954],
            [31.054547589692042, 0.011645730517051],
            [31.052743424055215, 0.010949473303335],
            [31.049827537558706, 0.006564043665622],
            [31.04738625348471, 0.004647113418747],
            [31.046540868733764, 0.004511478591063],
            [31.045126845018086, 0.003128039818968],
            [31.04049183369774, 0.000786139061314],
            [31.03816675479057, -0.002044014020651],
            [31.03723941763459, -0.002342402018444],
            [31.036600330090312, -0.003617323407261],
            [31.03450231384595, -0.005181587654639],
            [31.029924006881284, -0.009792983123837],
            [31.0279339995751, -0.018518459340942],
            [31.02786860851062, -0.018039236009016],
            [31.02353976100543, -0.025679628822619],
            [31.026449281141506, -0.036095990069377],
            [31.039934108365408, -0.035291521939107],
            [31.04328176022174, -0.030996620691477],
            [31.05258360298638, -0.027009216150912],
            [31.05391511644323, -0.027099655828676],
            [31.05853888983935, -0.030680402977479],
            [31.069475423875975, -0.030183264589608],
            [31.070333180225013, -0.02967691577406],
            [31.075609148483696, -0.023889985518184],
            [31.07903141440754, -0.026855879138733],
            [31.08313095974993, -0.029686162132043],
            [31.083975210827003, -0.031765895564582],
            [31.08584814788872, -0.033673844153308],
            [31.087410077419307, -0.036440809220414],
            [31.09298248163694, -0.032833040053615],
            [31.099173516064848, -0.029496526902532],
            [31.10040233861, -0.029451333564869],
            [31.100756853346994, -0.028574232108663],
            [31.108223897923622, -0.024622822078138],
            [31.11025634793204, -0.022714902087169],
            [31.117180023152848, -0.017886322992241],
            [31.1196848693214, -0.015508182499041],
            [31.12247322020039, -0.011086439432151],
            [31.12318224877605, -0.005425862935514],
            [31.122353388534748, -0.00276737701265],
            [31.121523885998016, 0.013852653061823],
            [31.122047043259915, 0.034695523096901],
            [31.121342358038653, 0.041848090146745],
            [31.12121991047893, 0.053964972970977],
            [31.12262593469699, 0.071279470438546],
            [31.124812027161738, 0.072273502232823],
            [31.13717093295797, 0.07159226896724],
            [31.1449584344442, 0.079092046154966],
            [31.15088393585731, 0.080114974747996],
            [31.148846201060067, 0.089503274554985],
            [31.149690559036628, 0.093997488954036],
            [31.151987868323427, 0.096529547880675],
            [31.151222856739253, 0.098844412273319],
            [31.151148398080306, 0.100173672547291],
            [31.151928343257755, 0.10179234524191],
            [31.151443906079557, 0.105906704230711],
            [31.153145521840198, 0.109333960537741],
            [31.152811163501546, 0.110220116396285],
            [31.152974442185908, 0.111513219962292],
            [31.152497779028153, 0.112327026480077],
            [31.153891206171018, 0.115419691722785],
            [31.153765819323652, 0.11838566390217],
            [31.152926009517365, 0.122219675862465],
            [31.150944850616717, 0.126795096515608],
            [31.150296501441872, 0.129996130788154],
            [31.1505284563297, 0.132338181716808],
            [31.151699803764625, 0.135665952839007],
            [31.151819332698018, 0.143297926142278],
            [31.153270545768166, 0.149537453710597],
            [31.156008299937074, 0.154059006313507],
            [31.15889235103821, 0.154710332835661],
            [31.161679066085057, 0.157857426791884],
            [31.16455465954779, 0.162116786478536],
            [31.16551075357265, 0.164585528305435],
            [31.165939968615415, 0.167207947561877],
            [31.165499924381912, 0.169296765932723],
            [31.165747889943045, 0.17103298253074],
            [31.1662488165966, 0.172181453707203],
            [31.172161681408603, 0.180211966296318],
            [31.174491754948736, 0.182707997355124],
            [31.185557056193133, 0.190883819539304],
            [31.19360338836389, 0.197386475446213],
            [31.18958822357276, 0.200496754790501],
            [31.188416409013843, 0.202142411519859],
            [31.186783257454287, 0.205108259751735],
            [31.185283491341348, 0.209964060383952],
            [31.180574956508266, 0.215777995825584],
            [31.179309557259728, 0.218264598237487],
            [31.174670374163203, 0.223780088176239],
            [31.170830177833228, 0.230425991626509],
            [31.17010001369556, 0.23101367190717],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1373,
        District: "SSEMBABULE",
        County: "LWEMIYAGA",
        Subcounty: "LWEMIYAGA",
        Population: 36679,
        Key: "SSEMBABULELWEMIYAGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.52516413605489, -0.340048517119699],
            [31.530647298038907, -0.337082795360781],
            [31.53371248273899, -0.337273192683276],
            [31.536729664165236, -0.339453393707052],
            [31.54543907608485, -0.335728397311447],
            [31.54638964187748, -0.334245219685856],
            [31.546770373047696, -0.332165093531979],
            [31.54648771904188, -0.319828477021019],
            [31.547224442677756, -0.319493929853052],
            [31.558023561425344, -0.321421908875434],
            [31.5711024004465, -0.331499299460795],
            [31.589590360509305, -0.32558679775729],
            [31.590376491485802, -0.321453560516358],
            [31.597105679650983, -0.297395835249895],
            [31.59724853334071, -0.295704498209527],
            [31.5959549943659, -0.28479003750048],
            [31.5824043996834, -0.25280910271652],
            [31.582791025598542, -0.251421007936823],
            [31.58242647128995, -0.24684259154122],
            [31.580801187175613, -0.243913057755451],
            [31.58051713000133, -0.242574088670164],
            [31.579187026899458, -0.241951799794637],
            [31.57838036852042, -0.240445170428331],
            [31.57564896364393, -0.239033213520003],
            [31.57200552261569, -0.234261796892766],
            [31.57008196997928, -0.232826258773571],
            [31.56951287377205, -0.231367631298728],
            [31.5671976412987, -0.229537468848636],
            [31.566416422310198, -0.225927111647007],
            [31.565100075110283, -0.222949921804771],
            [31.56410220852639, -0.222853774050872],
            [31.563889068852202, -0.221945219427204],
            [31.561917653079114, -0.221011821125084],
            [31.561039970300456, -0.219194430425956],
            [31.560232364198782, -0.21883538720981],
            [31.560601796359375, -0.217413041927074],
            [31.55993704304913, -0.216719448690627],
            [31.559890126736782, -0.215954342847421],
            [31.559248954202744, -0.215499784162631],
            [31.558988583805828, -0.214256468857515],
            [31.55631711272849, -0.212211060443277],
            [31.55472751598547, -0.209221796414203],
            [31.555217940435057, -0.205074203939152],
            [31.556074462498884, -0.203640207219606],
            [31.554816364756952, -0.202085570075613],
            [31.555031645116465, -0.200316531389083],
            [31.554653475043104, -0.197806105664373],
            [31.55340369390407, -0.195514643535335],
            [31.552919937648866, -0.191318693346079],
            [31.553157956164842, -0.190792900655435],
            [31.552303398716536, -0.189716612589375],
            [31.552363999963926, -0.18822246997178],
            [31.552127279513492, -0.187098739274409],
            [31.551699808100732, -0.186811631153192],
            [31.552223321993804, -0.18583170102209],
            [31.551748583027404, -0.18520983115358],
            [31.5521533162837, -0.184205969039998],
            [31.552130928470202, -0.182484651258546],
            [31.55159502770765, -0.179806140894866],
            [31.550603687384303, -0.179539806095702],
            [31.547874248021664, -0.177132192659748],
            [31.547484673835754, -0.173976243523244],
            [31.54657084823995, -0.17273980173765],
            [31.547029375310437, -0.171306785112533],
            [31.546795356992405, -0.169781410296688],
            [31.547084958568643, -0.167099179111825],
            [31.54674552834191, -0.166651987982013],
            [31.5472687269263, -0.166047382123253],
            [31.547414211781522, -0.163851571800382],
            [31.548251820715357, -0.162300440912465],
            [31.548017592191542, -0.16098539611324],
            [31.548581706342198, -0.158211296989035],
            [31.548217152033608, -0.156449132438655],
            [31.54889671317298, -0.156475800625052],
            [31.549707442716898, -0.155845017653521],
            [31.549656561240898, -0.154030497482661],
            [31.55010171868502, -0.152978770790631],
            [31.549318816253653, -0.151453113428724],
            [31.550741382049367, -0.148851657893204],
            [31.549703687759028, -0.150745342260697],
            [31.545811701756293, -0.149434437959367],
            [31.544442157223564, -0.150083187363357],
            [31.54210583590062, -0.15246736441112],
            [31.539257650037197, -0.153101516153194],
            [31.537211420770635, -0.154220616241538],
            [31.535970832990234, -0.15412320597973],
            [31.53324788575215, -0.156004538094318],
            [31.530287059236947, -0.154245952234013],
            [31.523718725203157, -0.149067954414632],
            [31.522929576785643, -0.147453097960735],
            [31.520582622104655, -0.144413082237922],
            [31.500672551691967, -0.140058793489055],
            [31.500672060313523, -0.139136267752946],
            [31.494660471550105, -0.136178433079997],
            [31.483862335559433, -0.131980926271963],
            [31.481491099416342, -0.12658760954839],
            [31.480202333190608, -0.124852040749831],
            [31.477254068716313, -0.12374894002461],
            [31.474879182718244, -0.123610684234608],
            [31.472688030941836, -0.124648586294969],
            [31.472387270493122, -0.125297337270132],
            [31.471807295687814, -0.124951275606869],
            [31.47144210986357, -0.125145887064822],
            [31.471033902822057, -0.12592440205232],
            [31.469702044412127, -0.126573152097519],
            [31.468176768840078, -0.128000346983241],
            [31.467532332726616, -0.12806519440504],
            [31.466498077187204, -0.129130818226716],
            [31.468020440421093, -0.134499641007767],
            [31.465256401546984, -0.136591797076776],
            [31.463081917112362, -0.136086075749701],
            [31.46245720171431, -0.137352205317159],
            [31.462441411128236, -0.138672584817058],
            [31.462897271100633, -0.139531806481071],
            [31.461381258955793, -0.144388378646065],
            [31.46165149015958, -0.1460525023646],
            [31.461346309101348, -0.146649388702866],
            [31.461717670843175, -0.147255399183437],
            [31.460861429053715, -0.151234711287199],
            [31.461270267610885, -0.154291639485453],
            [31.460773598073434, -0.154626260712865],
            [31.461711670995392, -0.156787823883171],
            [31.461487477551618, -0.159193545288602],
            [31.46263661953106, -0.161783490381653],
            [31.472278069490567, -0.167849128134836],
            [31.475479931064495, -0.17319625611143],
            [31.47688547917546, -0.177363788011568],
            [31.481961416874896, -0.188136639104273],
            [31.482191820372236, -0.191310833131162],
            [31.47783607910408, -0.195723991997168],
            [31.474283452361135, -0.1972883144224],
            [31.469563963471515, -0.200344743706477],
            [31.463604519215416, -0.205815870727698],
            [31.46270915130374, -0.207036728970769],
            [31.46326035217218, -0.214398654104192],
            [31.462583317095355, -0.216424480889475],
            [31.462739995857344, -0.218993012543864],
            [31.46305430110389, -0.220015048885022],
            [31.46531559962587, -0.223207834252825],
            [31.46570176919685, -0.224347422940534],
            [31.465666749273808, -0.226581263329816],
            [31.464596104778835, -0.228308611196381],
            [31.459822015387896, -0.232242288579705],
            [31.457213427278777, -0.234928087923616],
            [31.455532629974833, -0.237794812180661],
            [31.45519502512477, -0.239151397544696],
            [31.45518221694542, -0.243230274240625],
            [31.45597273439544, -0.250953958546009],
            [31.457100646489778, -0.25400195493246],
            [31.459839210040773, -0.259012679523496],
            [31.46177858829755, -0.261129172970728],
            [31.466227845085115, -0.264765487098751],
            [31.465940209022698, -0.266076802239043],
            [31.464184142779427, -0.268798879000335],
            [31.463568200328467, -0.270978392278234],
            [31.46378411220363, -0.273058600232476],
            [31.464402510648586, -0.273492804071068],
            [31.465519580077423, -0.273393429074484],
            [31.468774674916784, -0.271793042813029],
            [31.46939286315596, -0.271892628026242],
            [31.472356601111024, -0.276378889865909],
            [31.472856991470344, -0.277771682681961],
            [31.477199749387722, -0.282357668454528],
            [31.477795303674995, -0.283623926318561],
            [31.477837658342338, -0.290407034290359],
            [31.47712626989244, -0.292396635876717],
            [31.478401246080228, -0.295643652532249],
            [31.47894097186922, -0.300771699415725],
            [31.474602354286997, -0.316960088319018],
            [31.475434735025893, -0.317141082602931],
            [31.47712181335031, -0.316499217399316],
            [31.480162505484156, -0.314537059771005],
            [31.481315752764438, -0.314790479674032],
            [31.482838537308197, -0.316400545258535],
            [31.48409898594123, -0.317070060189409],
            [31.488543540946626, -0.316329031468948],
            [31.49025567418258, -0.317170417537417],
            [31.492003002513083, -0.317188733905408],
            [31.492881315909102, -0.316013152691879],
            [31.493808581199882, -0.316302713927152],
            [31.495424636022978, -0.31582359667539],
            [31.497041849672765, -0.316827728976267],
            [31.49932448228445, -0.317406853189788],
            [31.499680299578603, -0.316620067706553],
            [31.50041698818015, -0.316574941527191],
            [31.500663112194964, -0.317208103981046],
            [31.501704667444393, -0.317190137950689],
            [31.503938138853826, -0.318122055666733],
            [31.50633807886521, -0.317263195016353],
            [31.508096250759515, -0.318023172440627],
            [31.51280135223156, -0.315464276014389],
            [31.51510637355507, -0.314840587842526],
            [31.523600891390725, -0.315049794226708],
            [31.525537813653504, -0.312662346075216],
            [31.526393037651754, -0.314245252732232],
            [31.526534768447405, -0.318695073154865],
            [31.527104707274344, -0.320558276724622],
            [31.527341427724778, -0.32421225643685],
            [31.528635808421036, -0.327142822570577],
            [31.52894439409416, -0.32877085221557],
            [31.52878971498201, -0.330552504428031],
            [31.527244822899114, -0.332107897860529],
            [31.527743247744624, -0.335264509861629],
            [31.526542803877607, -0.336928470159505],
            [31.52554504239661, -0.336711263971905],
            [31.52516413605489, -0.340048517119699],
          ],
          [
            [31.489695244022922, -0.263414308602095],
            [31.48817600423127, -0.263117376314439],
            [31.486702205718263, -0.262067060047202],
            [31.48093460028434, -0.263039617166481],
            [31.480330413187165, -0.261632574634497],
            [31.47705177260592, -0.257043634608855],
            [31.46823529947073, -0.261563447298978],
            [31.467450957938283, -0.260033028556615],
            [31.466907652362888, -0.252180147089475],
            [31.467361477651167, -0.24962348276151],
            [31.46545715435173, -0.245879507644979],
            [31.466546010392427, -0.242135812648735],
            [31.465276613640878, -0.238300601541007],
            [31.465367533029074, -0.236291761215787],
            [31.466093238827977, -0.235196036948179],
            [31.46799815860879, -0.233643999181133],
            [31.4706285380501, -0.233278991558509],
            [31.47652394230789, -0.235288533896751],
            [31.483871003403596, -0.233371769690062],
            [31.49285068245958, -0.231637755194619],
            [31.499199349660298, -0.236569324800659],
            [31.49800918791006, -0.247924770198744],
            [31.495869653329883, -0.249167100699819],
            [31.49584179118304, -0.250950800998065],
            [31.493505856135652, -0.253758430337841],
            [31.49252977998558, -0.262615658135497],
            [31.49233236082886, -0.26287644799843],
            [31.49053446722934, -0.26156534272447],
            [31.490284834395027, -0.263003473831869],
            [31.489695244022922, -0.263414308602095],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1374,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "MATEETE",
        Population: 52071,
        Key: "SSEMBABULEMATEETE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.493640412985417, -0.23224500955436],
            [31.49285069773096, -0.231637763279394],
            [31.483870989030542, -0.23337174992729],
            [31.47652392703654, -0.235288517727206],
            [31.470628532660186, -0.233279011321282],
            [31.469268010806204, -0.233278863998779],
            [31.467998150523947, -0.233643974028524],
            [31.466093254997656, -0.235196068388946],
            [31.46536752584256, -0.236291730673345],
            [31.465276605556035, -0.238300581778242],
            [31.466546002307584, -0.242135821631826],
            [31.465457165131493, -0.245879483390681],
            [31.467361470464628, -0.249623489947952],
            [31.466907668532574, -0.252180170445439],
            [31.467450954345026, -0.260033059099035],
            [31.468235310250527, -0.261563426637927],
            [31.477051779792426, -0.257043639100396],
            [31.480330428458547, -0.261632578227714],
            [31.480934597589386, -0.263039584827494],
            [31.486702211108145, -0.262067081606541],
            [31.488176000638013, -0.26311735565339],
            [31.489695232344822, -0.263414305907166],
            [31.490284847869752, -0.263003468442044],
            [31.490534451059656, -0.261565321165131],
            [31.492332359930533, -0.262876457879794],
            [31.4935058705087, -0.25375841327003],
            [31.495841783098204, -0.250950805489608],
            [31.495869665007977, -0.249167075547238],
            [31.4980091968932, -0.247924746842738],
            [31.499199360440095, -0.236569350851587],
            [31.493640412985417, -0.23224500955436],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1375,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "MATEETE TOWN COUNCIL",
        Population: 10297,
        Key: "SSEMBABULEMATEETE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.55074136857464, -0.148851654299961],
            [31.55017272871158, -0.145814138770382],
            [31.551115652536094, -0.143001376124558],
            [31.55017578028862, -0.141816502823061],
            [31.55054250043534, -0.140785452014738],
            [31.54987906854689, -0.136597844518084],
            [31.550297399601654, -0.13643506216585],
            [31.550324094836963, -0.135964754120908],
            [31.549254616355224, -0.133070473795812],
            [31.55136003561587, -0.13118935269405],
            [31.551360651860143, -0.130348223656772],
            [31.55300904423682, -0.12798771490521],
            [31.55311469150413, -0.126612970723602],
            [31.551979759075877, -0.124134724214044],
            [31.55218983729156, -0.122633360784525],
            [31.55091206464831, -0.118816546193281],
            [31.549724032803592, -0.117306064589104],
            [31.54998929901876, -0.112286409232543],
            [31.549010416531758, -0.110558881240947],
            [31.549167971151117, -0.109455472729774],
            [31.548097835102638, -0.107746018645877],
            [31.547905465376097, -0.102843941979414],
            [31.547200573542344, -0.101550552385788],
            [31.547279784289138, -0.100628028940632],
            [31.54578051494456, -0.096015300835704],
            [31.545153630115124, -0.095201283692865],
            [31.54536367419485, -0.094043615585125],
            [31.544371581083265, -0.092515063188057],
            [31.544686364233574, -0.090941347981119],
            [31.543707460186976, -0.089376629322226],
            [31.543552592428636, -0.086853232334065],
            [31.54308234683528, -0.086455260253741],
            [31.54250944356789, -0.083796187065679],
            [31.5431114127246, -0.082511901192552],
            [31.54261505849584, -0.082086800872336],
            [31.542827455263293, -0.077854022429241],
            [31.542331993959912, -0.076253140700712],
            [31.542724495755333, -0.075565786381146],
            [31.542581630387485, -0.074317659209921],
            [31.54344437328467, -0.07410965627702],
            [31.542688109494733, -0.07184853745577],
            [31.542897851740538, -0.071079758935314],
            [31.543551153327556, -0.071061701015387],
            [31.54383950175397, -0.070139175038095],
            [31.54329093744087, -0.069795474476763],
            [31.543840675852046, -0.068402648421461],
            [31.54367199469957, -0.06675656496179],
            [31.54424812291884, -0.06536374690419],
            [31.543804871699763, -0.063762871930875],
            [31.54398907843531, -0.062107748577997],
            [31.543089363575977, -0.059457711896444],
            [31.54246247066166, -0.058960263785297],
            [31.541575078891416, -0.057142308145382],
            [31.54209840862985, -0.056355458902629],
            [31.541576228734968, -0.05556858269978],
            [31.541629325456473, -0.054564659239602],
            [31.539657407525173, -0.05261101928562],
            [31.53986714977097, -0.05155282857264],
            [31.538587829330456, -0.049689665010139],
            [31.539032543905105, -0.049110834873647],
            [31.53871982687999, -0.047844613221561],
            [31.53754522395045, -0.0457734231595],
            [31.53808146247951, -0.045176503620989],
            [31.537899275156743, -0.044253969139445],
            [31.538318155980463, -0.043259086150749],
            [31.537744065140274, -0.041992883260449],
            [31.538162953150504, -0.040943734826721],
            [31.53791028760379, -0.040265400956331],
            [31.535824351005065, -0.040500516957249],
            [31.53482543788385, -0.042029004508294],
            [31.534064894519908, -0.042218918189504],
            [31.53041889958129, -0.040292410595319],
            [31.52994360455775, -0.040364750110597],
            [31.52680598150979, -0.042372539942713],
            [31.522942040910205, -0.04599925056634],
            [31.522917600446277, -0.046858459209111],
            [31.521287243545554, -0.050711300624314],
            [31.519895837612093, -0.052710066588686],
            [31.513369280628922, -0.058652011549484],
            [31.50809326296287, -0.060198444309595],
            [31.504309071200936, -0.063228168950964],
            [31.500719077237175, -0.069133950197836],
            [31.499347629174355, -0.070092600120425],
            [31.495558429304744, -0.071828969469344],
            [31.48948963762069, -0.07345672893055],
            [31.481919828470502, -0.072714858551673],
            [31.48243559978416, -0.079344247929917],
            [31.481677765739104, -0.084491167037476],
            [31.48262279431632, -0.08847040815842],
            [31.481935209424805, -0.092968612997698],
            [31.476076438464283, -0.096486582419918],
            [31.47536750331343, -0.09962092023019],
            [31.474097077092537, -0.101673872015731],
            [31.4725481928965, -0.102786223518705],
            [31.471747762537305, -0.104025239026129],
            [31.47122530326639, -0.104007117341745],
            [31.471324090998163, -0.104649252703577],
            [31.470280307926835, -0.104839131982829],
            [31.47007001321715, -0.105436032738062],
            [31.4685764715308, -0.105806765927589],
            [31.46765532646208, -0.106665906900256],
            [31.465639803408536, -0.109234340248871],
            [31.465195334073965, -0.110400987351919],
            [31.46175962845514, -0.111657948161556],
            [31.465408309356455, -0.122990367526267],
            [31.4661034957919, -0.126617082302611],
            [31.463971094733406, -0.125278435863428],
            [31.46274554744577, -0.122691760127299],
            [31.461697594394877, -0.122103841963125],
            [31.46038104417575, -0.120186428207864],
            [31.45836645716675, -0.120765127024474],
            [31.456392641095253, -0.120204294761255],
            [31.449507411073622, -0.113855003902957],
            [31.44884235772608, -0.113809754953097],
            [31.448328920235543, -0.113276133365923],
            [31.446880061649786, -0.113140391903253],
            [31.443899347332476, -0.110852107870315],
            [31.440332693396428, -0.10989326857638],
            [31.435488201240037, -0.107550632721476],
            [31.430020653772264, -0.102078773515256],
            [31.42436779643778, -0.097429936983295],
            [31.4228612031287, -0.095485437491778],
            [31.422394477134645, -0.09269989221466],
            [31.424433972629824, -0.085989396271533],
            [31.42744547850012, -0.083203994004758],
            [31.429991547458744, -0.079975408130084],
            [31.43270695064507, -0.075218403669945],
            [31.434665682206344, -0.073156443936414],
            [31.436638797591907, -0.06915003811454],
            [31.429501363757645, -0.064004594948856],
            [31.423090009421475, -0.067990683120616],
            [31.41484132544477, -0.070809735449386],
            [31.4097496456683, -0.069938147499065],
            [31.407916672856917, -0.068759103264102],
            [31.404658026977263, -0.067528758944768],
            [31.401121207888387, -0.068506784648128],
            [31.39894326134668, -0.070396861075128],
            [31.39384041730785, -0.072784252453116],
            [31.39220349551901, -0.073037423546341],
            [31.386280185995222, -0.073055302700908],
            [31.382525511975214, -0.072385932589262],
            [31.37711489074701, -0.070712672556963],
            [31.37431160268152, -0.070368912711086],
            [31.370255690309083, -0.071028961041709],
            [31.36239924132816, -0.070354234250415],
            [31.358733275942463, -0.071225511376117],
            [31.353720553587905, -0.073235036578174],
            [31.34628850108655, -0.073017723508162],
            [31.344727111443422, -0.073976275433329],
            [31.34096112493907, -0.077674952425435],
            [31.332884929175037, -0.083218306847084],
            [31.330335074715776, -0.085705152566678],
            [31.32627720311773, -0.088119584117171],
            [31.321723475855883, -0.093138501261849],
            [31.32555499176527, -0.098917446095477],
            [31.325188250957282, -0.101250638619756],
            [31.324092538974305, -0.102742753213716],
            [31.32436166974185, -0.104144500064762],
            [31.3238354231737, -0.107671425371433],
            [31.32426368151066, -0.109986563836784],
            [31.32404954380819, -0.114110371076716],
            [31.324331851962626, -0.115783423332551],
            [31.32758804364494, -0.127033688469724],
            [31.33143703268494, -0.146676381192085],
            [31.33212628305297, -0.153223912969959],
            [31.332836461472176, -0.167729737155651],
            [31.33253248415646, -0.177080675422627],
            [31.335215585721784, -0.177180400519043],
            [31.348563076708434, -0.175960704360794],
            [31.35410703577257, -0.176033532233927],
            [31.357566660832443, -0.17916292515461],
            [31.3590909015453, -0.180031247713727],
            [31.370805238277402, -0.179697672553037],
            [31.374452632791204, -0.18024061971718],
            [31.378597045388787, -0.182664700575141],
            [31.39115911327138, -0.187459008491176],
            [31.39159301033338, -0.188616649485334],
            [31.39245031033826, -0.18908700032154],
            [31.393347585373306, -0.188200796435879],
            [31.39707885917845, -0.180405395077047],
            [31.40020866598513, -0.177547834862546],
            [31.410570941196575, -0.177404018868774],
            [31.411962577098762, -0.176608274326174],
            [31.41235951387672, -0.176834405258685],
            [31.416424858559648, -0.175704267097458],
            [31.41882340887726, -0.175812997769559],
            [31.42124914041874, -0.176509577792813],
            [31.423219040733926, -0.176401215432306],
            [31.426311054518287, -0.173559631963305],
            [31.427388534294238, -0.173365794379652],
            [31.428474964883705, -0.171042070745981],
            [31.42858441561793, -0.168674480489148],
            [31.430732749196313, -0.165531735139173],
            [31.433221541572408, -0.163063940249354],
            [31.44036253632847, -0.15822574184372],
            [31.447515720324606, -0.15617903429242],
            [31.44930414118944, -0.154476133910446],
            [31.451342803048053, -0.151694661478552],
            [31.454919525301836, -0.150052702240457],
            [31.456695864724438, -0.148337626548341],
            [31.459251622013433, -0.144695042745266],
            [31.462457213392405, -0.137352180164413],
            [31.46308192429887, -0.136086047902003],
            [31.465256392563813, -0.136591766534162],
            [31.46802044311602, -0.134499627533048],
            [31.466498073593915, -0.129130797565535],
            [31.467532342608084, -0.128065188116876],
            [31.468176785009764, -0.128000346983241],
            [31.46970203722562, -0.126573122453187],
            [31.47064723288946, -0.126227161417868],
            [31.47144210088043, -0.125145906827711],
            [31.471807294789485, -0.124951294471429],
            [31.472387269594794, -0.125297342660002],
            [31.47341843223474, -0.124216101506188],
            [31.47604575830238, -0.123505594167159],
            [31.480202325105765, -0.124852053326227],
            [31.480943388502748, -0.125598194914067],
            [31.483862322084676, -0.131980907407407],
            [31.49466045807538, -0.136178450147927],
            [31.50067206211015, -0.139136292007396],
            [31.500672565166692, -0.140058810557015],
            [31.520582623901287, -0.144413060678393],
            [31.52292958936204, -0.147453119520227],
            [31.523718740474546, -0.149067953516305],
            [31.53028707181337, -0.154245952234013],
            [31.533247877667307, -0.156004519229783],
            [31.535970838380116, -0.154123188013486],
            [31.53721141627908, -0.154220591987105],
            [31.539257648240564, -0.153101551187355],
            [31.542105844883793, -0.152467359021257],
            [31.54444216890166, -0.150083167600489],
            [31.545811690976496, -0.149434456823909],
            [31.54970368416577, -0.150745371006704],
            [31.55074136857464, -0.148851654299961],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1376,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "MIJWALA",
        Population: 29931,
        Key: "SSEMBABULEMIJWALA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.481919828470502, -0.072714858551673],
            [31.479380292060636, -0.072217347690738],
            [31.47679402079807, -0.072415046964346],
            [31.47624247497657, -0.070616110025574],
            [31.476596954679245, -0.06935099379175],
            [31.476019417003293, -0.062375906311858],
            [31.47713851213312, -0.054091020024],
            [31.476836476975024, -0.052106821178331],
            [31.47740443591509, -0.050051004111473],
            [31.470866903315784, -0.050803465041357],
            [31.466598905891313, -0.051967217650847],
            [31.456746907897212, -0.058451572361419],
            [31.44954755049546, -0.065885565334028],
            [31.446301268129062, -0.071239510710665],
            [31.44481187216778, -0.074468169113973],
            [31.436638797591907, -0.06915003811454],
            [31.434665682206344, -0.073156443936414],
            [31.43270695064507, -0.075218403669945],
            [31.429991547458744, -0.079975408130084],
            [31.42744547850012, -0.083203994004758],
            [31.424433972629824, -0.085989396271533],
            [31.422394477134645, -0.09269989221466],
            [31.4228612031287, -0.095485437491778],
            [31.42436779643778, -0.097429936983295],
            [31.430020653772264, -0.102078773515256],
            [31.435488201240037, -0.107550632721476],
            [31.440332693396428, -0.10989326857638],
            [31.443899347332476, -0.110852107870315],
            [31.446880061649786, -0.113140391903253],
            [31.448328920235543, -0.113276133365923],
            [31.44884235772608, -0.113809754953097],
            [31.449507411073622, -0.113855003902957],
            [31.456392641095253, -0.120204294761255],
            [31.45836645716675, -0.120765127024474],
            [31.46038104417575, -0.120186428207864],
            [31.461697594394877, -0.122103841963125],
            [31.46274554744577, -0.122691760127299],
            [31.463971094733406, -0.125278435863428],
            [31.4661034957919, -0.126617082302611],
            [31.465408309356455, -0.122990367526267],
            [31.46175962845514, -0.111657948161556],
            [31.465195334073965, -0.110400987351919],
            [31.465639803408536, -0.109234340248871],
            [31.46765532646208, -0.106665906900256],
            [31.4685764715308, -0.105806765927589],
            [31.47007001321715, -0.105436032738062],
            [31.470280307926835, -0.104839131982829],
            [31.471324090998163, -0.104649252703577],
            [31.47122530326639, -0.104007117341745],
            [31.471747762537305, -0.104025239026129],
            [31.4725481928965, -0.102786223518705],
            [31.474097077092537, -0.101673872015731],
            [31.47536750331343, -0.09962092023019],
            [31.476076438464283, -0.096486582419918],
            [31.481935209424805, -0.092968612997698],
            [31.48262279431632, -0.08847040815842],
            [31.481677765739104, -0.084491167037476],
            [31.48243559978416, -0.079344247929917],
            [31.481919828470502, -0.072714858551673],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1377,
        District: "SSEMBABULE",
        County: "MAWOGOLA",
        Subcounty: "SEMBABULE TOWN COUNCIL",
        Population: 6652,
        Key: "SSEMBABULESEMBABULE TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.23652370698378, 0.748563133873781],
            [33.23290577990623, 0.75032754633035],
            [33.22524142217408, 0.755548294378651],
            [33.22055226939157, 0.757307402614575],
            [33.21796061632216, 0.759140751175174],
            [33.214961293403775, 0.76031786830648],
            [33.214538426755134, 0.760976131666634],
            [33.21305263393645, 0.760705178752384],
            [33.21045447167451, 0.761823525680432],
            [33.20789401350164, 0.76396532278784],
            [33.207338589653034, 0.763823203975698],
            [33.20811022002422, 0.765325459404899],
            [33.20711121257991, 0.765923045325286],
            [33.20498529556113, 0.768724846032158],
            [33.20359371086291, 0.76902324309312],
            [33.202781985985645, 0.769892326974322],
            [33.19929018237398, 0.771591672539196],
            [33.19629742793697, 0.773825162702874],
            [33.19441849282407, 0.774368087244921],
            [33.19101922736477, 0.774268723784391],
            [33.18417173646657, 0.779239862609092],
            [33.17955661564326, 0.778809151262196],
            [33.1773761987345, 0.780048117020551],
            [33.175784319372355, 0.779980853812472],
            [33.17392492710847, 0.780654233174058],
            [33.17170438604923, 0.782135586189706],
            [33.17146362767161, 0.782876226572242],
            [33.17052724537903, 0.783280244761621],
            [33.16972466894463, 0.784546082478123],
            [33.16490878902836, 0.781731881372926],
            [33.164268486063506, 0.779404349582055],
            [33.16336357984015, 0.778168202287767],
            [33.16304988185475, 0.766855462578299],
            [33.15980566291854, 0.758002975591619],
            [33.160840313716676, 0.756935354705789],
            [33.161152003967445, 0.755198261215936],
            [33.162079675296745, 0.754908712631401],
            [33.16215265892199, 0.753813985768962],
            [33.16305727588782, 0.752936363591754],
            [33.16503344285046, 0.754009433270585],
            [33.16534021751997, 0.754645167999435],
            [33.166364201722445, 0.754086580193914],
            [33.165904336162214, 0.753441422870927],
            [33.166205092119306, 0.752343769180847],
            [33.16578675567466, 0.75130055113585],
            [33.16654340214689, 0.750086966680423],
            [33.16557731526279, 0.748727651662992],
            [33.16572819989119, 0.74752386089094],
            [33.165217303734586, 0.746027914824834],
            [33.16561201089401, 0.74515135729752],
            [33.16764370092772, 0.743643626419692],
            [33.16887429405228, 0.741948931771185],
            [33.169756654358615, 0.741995646536885],
            [33.171033699366525, 0.740628190965552],
            [33.17236883123735, 0.740254147547751],
            [33.17251973652695, 0.739623031285424],
            [33.17210173784885, 0.738582884904533],
            [33.172891213253145, 0.738536104531306],
            [33.173065347179396, 0.738138731828862],
            [33.17527215389625, 0.737302205540116],
            [33.175312305894515, 0.733079342188976],
            [33.17560953326921, 0.732672390149641],
            [33.17534791331573, 0.731475515077087],
            [33.17593045730277, 0.73017088833209],
            [33.17537158033022, 0.728602991684425],
            [33.17606117115976, 0.72829177484735],
            [33.17753540625399, 0.726101417542057],
            [33.179342583043685, 0.724677053393924],
            [33.17950906601866, 0.72537123921966],
            [33.18019864966168, 0.724904426646511],
            [33.18263987804013, 0.720566554848935],
            [33.18337369472772, 0.715121369837349],
            [33.184623144388425, 0.711241975135293],
            [33.186912522449575, 0.708585280470042],
            [33.18679878405651, 0.70515457277312],
            [33.18918756160213, 0.698367732283096],
            [33.1899623756027, 0.695457824649789],
            [33.190961904968184, 0.694507818330755],
            [33.19360976292999, 0.693222993809952],
            [33.19819554657273, 0.692471877489793],
            [33.2002021978645, 0.690969942711481],
            [33.2007700642781, 0.690408986475968],
            [33.201007037155115, 0.688762370757854],
            [33.20157714127209, 0.687993327347151],
            [33.201671146373315, 0.68603910927877],
            [33.206778695787605, 0.684039439796756],
            [33.21001517573762, 0.681867950108476],
            [33.21513991351657, 0.681379168233583],
            [33.22321797597977, 0.683912033632154],
            [33.22299238655404, 0.689222527337431],
            [33.22194858461807, 0.69318322201517],
            [33.2216269715767, 0.715446545408721],
            [33.22053560564308, 0.719359494970574],
            [33.22011612743969, 0.729609960209005],
            [33.2202942274279, 0.730342780474001],
            [33.22119526101407, 0.731202226713001],
            [33.22655136618265, 0.734151366649901],
            [33.22616105178496, 0.735698469767561],
            [33.22462264913166, 0.738430823539042],
            [33.22699261326031, 0.740050163456253],
            [33.2289474272686, 0.740864315860943],
            [33.231236021998825, 0.743958360589712],
            [33.235754036736566, 0.746355643649176],
            [33.23652370698378, 0.748563133873781],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1394,
        District: "KAMULI",
        County: "BUZAAYA",
        Subcounty: "WANKOLE",
        Population: 19988,
        Key: "KAMULIWANKOLE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.368279716605116, 0.490003003757915],
            [33.365896167254405, 0.491263613681446],
            [33.36277657159759, 0.493657298338775],
            [33.36157830165356, 0.49662532181679],
            [33.36104569321657, 0.497123201527376],
            [33.359447815803236, 0.497736028880998],
            [33.358648916173294, 0.498750923284153],
            [33.35509170712413, 0.499574487244519],
            [33.35406455276701, 0.500972356270194],
            [33.35062141808082, 0.500704470022777],
            [33.35084952638261, 0.497621609389895],
            [33.348871153157674, 0.497487678326105],
            [33.347254398546966, 0.500915281295219],
            [33.339702181105004, 0.497564755363054],
            [33.339131435590915, 0.496358451348936],
            [33.33658233391988, 0.495401175061797],
            [33.33253090863231, 0.498461258116326],
            [33.332104587961396, 0.498877117426025],
            [33.322878183917666, 0.488460009472488],
            [33.30672782887033, 0.482275332460955],
            [33.3045021036336, 0.480111484934813],
            [33.30970052123212, 0.474292323109259],
            [33.308255496655974, 0.471957326462771],
            [33.302962927530835, 0.468310215528363],
            [33.29944360942034, 0.468642863134676],
            [33.29567102658683, 0.469944913088766],
            [33.29413929661947, 0.470988396876659],
            [33.292153433241694, 0.47393841068259],
            [33.29091209716465, 0.480204980103024],
            [33.28963699880595, 0.481623868518702],
            [33.288533190307334, 0.480986574938514],
            [33.28435991933126, 0.47588805977511],
            [33.283432467190885, 0.473302845587931],
            [33.2815396836496, 0.462623891361395],
            [33.2816619003423, 0.449042704110076],
            [33.28236997400881, 0.396921541437718],
            [33.282177606977264, 0.388869506542161],
            [33.28272297418623, 0.388154757757308],
            [33.30142662873194, 0.396043278714491],
            [33.320916066606095, 0.403587906747574],
            [33.325257947767746, 0.406238562345414],
            [33.328263652317915, 0.410183016746632],
            [33.33235524846839, 0.417863916735519],
            [33.33569522152567, 0.42314732986722],
            [33.34028774702462, 0.428512111015411],
            [33.34702310032761, 0.434012490599453],
            [33.355790064612535, 0.439775126101408],
            [33.36124532582214, 0.444461295298385],
            [33.36683948543931, 0.45235013847042],
            [33.36998459684351, 0.457524951399661],
            [33.373560346221836, 0.465469523405187],
            [33.37596029521635, 0.46965089270226],
            [33.370618839773435, 0.47642301949405],
            [33.369577600730985, 0.478721820974627],
            [33.36685164952657, 0.482939057010603],
            [33.366127300183756, 0.486245639098854],
            [33.36714177751558, 0.488774116447195],
            [33.368279716605116, 0.490003003757915],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1395,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "WAIRASA",
        Population: 17858,
        Key: "MAYUGEWAIRASA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.54192462876068, 0.542536509280462],
            [33.53892931951496, 0.542747380234043],
            [33.536426687693584, 0.543614961096055],
            [33.52900787635951, 0.551693698334218],
            [33.52843732218659, 0.552915088962505],
            [33.52732235212057, 0.552444747572627],
            [33.524268247241196, 0.549541476521195],
            [33.523675442697005, 0.548407468412],
            [33.52402112070652, 0.546712148210357],
            [33.52320905446948, 0.545228841900537],
            [33.521329557909525, 0.545092777548876],
            [33.51569118321408, 0.546062007713476],
            [33.51375148875034, 0.545305348846965],
            [33.51151114522898, 0.545366087480261],
            [33.507363501391296, 0.544698301129906],
            [33.5041295034864, 0.540524035168694],
            [33.50065134618222, 0.539326765210911],
            [33.49673382107596, 0.538593863095418],
            [33.49176410646392, 0.536511756925145],
            [33.49047100676525, 0.536365859849849],
            [33.487301867223856, 0.538055701671406],
            [33.483453972331894, 0.54263750503399],
            [33.48329631979615, 0.540441854654875],
            [33.482229418580985, 0.538376035751163],
            [33.48247446371915, 0.536985457313604],
            [33.48169621276433, 0.53567382714174],
            [33.48164646586049, 0.533350062082783],
            [33.47832293826115, 0.528023662715174],
            [33.47901115376999, 0.525253431998785],
            [33.48028788257091, 0.523479603994065],
            [33.48037338691458, 0.522237267720434],
            [33.47809078754058, 0.518928327906111],
            [33.477053145352514, 0.514695788496095],
            [33.47542983932847, 0.513908819655853],
            [33.473444035239474, 0.513962956245141],
            [33.47207361934096, 0.511777153473397],
            [33.470095202098555, 0.51026898791413],
            [33.469964090287895, 0.507589179291726],
            [33.46922206659185, 0.505392660567331],
            [33.464543235451956, 0.502138672468771],
            [33.46279737227368, 0.50172653673986],
            [33.46146106720312, 0.50192191371846],
            [33.459406532113434, 0.50103474188159],
            [33.45711941331524, 0.501886633739314],
            [33.45590167059082, 0.501506743583107],
            [33.454623636537775, 0.50167842751263],
            [33.45415901888967, 0.502178225568216],
            [33.4514923133749, 0.501565983409815],
            [33.45478882953203, 0.499028705077116],
            [33.45546046303901, 0.497771962831246],
            [33.45530571745154, 0.494989290430032],
            [33.454830084661424, 0.493852312650527],
            [33.45530510839377, 0.491837326776522],
            [33.45641780212888, 0.489638962216045],
            [33.45993286671652, 0.485800773443466],
            [33.46194473003356, 0.48491402344651],
            [33.463735290685435, 0.483259553731315],
            [33.46541449617465, 0.481032599398464],
            [33.466557840427264, 0.477712254864135],
            [33.46845059612078, 0.476409350302907],
            [33.46884369349924, 0.475314630986523],
            [33.47380857517504, 0.470636970734513],
            [33.476225620007725, 0.46645639251657],
            [33.47870018127313, 0.464828484285976],
            [33.48044316175766, 0.465798334568164],
            [33.48183800015383, 0.464453289193985],
            [33.48307580405516, 0.465165235425966],
            [33.484646220868555, 0.465152808541865],
            [33.48659236433773, 0.461763064732088],
            [33.49073792588057, 0.462791264498686],
            [33.489546886476276, 0.465759870877021],
            [33.49038463824225, 0.467913954034459],
            [33.49115089129814, 0.468269914857555],
            [33.49755572566201, 0.467596985066383],
            [33.498280861929025, 0.467931505631448],
            [33.49905170537602, 0.469218988227444],
            [33.501426300319956, 0.469614123197947],
            [33.50261851651726, 0.471675333296919],
            [33.51000100986271, 0.470172989460268],
            [33.5164132113102, 0.464901498745667],
            [33.51715860907845, 0.463631382819003],
            [33.51693135058295, 0.461735422671847],
            [33.51878621713442, 0.459456819869273],
            [33.52007339783368, 0.458632077924698],
            [33.52171174435055, 0.459173867731864],
            [33.524001877894825, 0.463301053452001],
            [33.52489525244488, 0.466124224491178],
            [33.52536396820731, 0.471761354849687],
            [33.524560471898056, 0.472071682609355],
            [33.51934079207506, 0.472136998692961],
            [33.518124677996255, 0.47255387288692],
            [33.51594147900505, 0.474907979435425],
            [33.512639094154224, 0.479563055737359],
            [33.51162843376404, 0.484827175638113],
            [33.5120159912321, 0.488432973859824],
            [33.510854606113654, 0.490827193110384],
            [33.51127604354268, 0.493215564586331],
            [33.51326802534588, 0.498706657780583],
            [33.51496761181229, 0.501164978243734],
            [33.5174023193201, 0.501900181610642],
            [33.51905854770099, 0.50310916687315],
            [33.521109476953136, 0.503401681181645],
            [33.52298666214786, 0.504360507632931],
            [33.5246021276761, 0.505554574697822],
            [33.52538585476089, 0.507942909383057],
            [33.52754790561369, 0.51008686081232],
            [33.53426841245995, 0.513623968144949],
            [33.5389204648212, 0.511295765498779],
            [33.541617164185, 0.509416204266254],
            [33.543324044073195, 0.509196890152853],
            [33.54568139944854, 0.510288271283574],
            [33.54666515888921, 0.512482682774026],
            [33.5484946642036, 0.514156206627137],
            [33.550609407078554, 0.514780259961488],
            [33.55123913417758, 0.515856788896201],
            [33.552664726397474, 0.516698027905352],
            [33.55349615402385, 0.518471150873992],
            [33.553732808897266, 0.520669531730912],
            [33.55484954684776, 0.522225502973856],
            [33.5571306190858, 0.523654710671143],
            [33.55641743849689, 0.525237985218251],
            [33.5579498224378, 0.526884384903721],
            [33.55526875555656, 0.526563547191565],
            [33.550604200443175, 0.527941931172753],
            [33.54941807482351, 0.527337499313499],
            [33.54590087583876, 0.527238296269558],
            [33.54521080710547, 0.529825780657089],
            [33.54585150802401, 0.534294908613943],
            [33.544020276147634, 0.538601414000053],
            [33.54221810656736, 0.541315657301117],
            [33.54192462876068, 0.542536509280462],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1396,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "BUWAAYA",
        Population: 21272,
        Key: "MAYUGEBUWAAYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.106268993245884, 1.73786125377155],
            [32.10720983836882, 1.739200530836837],
            [32.11038313710996, 1.74125560167582],
            [32.11430273912117, 1.742315685129471],
            [32.11923308686252, 1.743005664564482],
            [32.12742165198714, 1.746257180840413],
            [32.14281961767836, 1.756233083154572],
            [32.151748450292644, 1.76148406809426],
            [32.1562453609094, 1.765520924119818],
            [32.162508583055235, 1.773837320700575],
            [32.16629091171125, 1.776896579624015],
            [32.171458610520325, 1.77782168025414],
            [32.17858365479019, 1.777743395640388],
            [32.19469564099511, 1.78200244265167],
            [32.19704740256116, 1.782130109630065],
            [32.203280166428975, 1.781219041453205],
            [32.20627324066625, 1.781491772853798],
            [32.20898502993019, 1.783456166824387],
            [32.213454429641374, 1.791509292626013],
            [32.216759668439884, 1.79333815328003],
            [32.22083310694349, 1.79325846684591],
            [32.22773848438029, 1.790176507169734],
            [32.23002918835479, 1.789535366424491],
            [32.23337864133327, 1.7896905312633],
            [32.237276346909425, 1.790940543638819],
            [32.24056937400996, 1.792633601175334],
            [32.2506494542547, 1.799268890116047],
            [32.256924186514276, 1.802654708047361],
            [32.25846507839924, 1.803252633277097],
            [32.268406621359176, 1.805210550900413],
            [32.271935596358965, 1.806713920438914],
            [32.27464387680341, 1.80856044306201],
            [32.27649679221408, 1.810560442470368],
            [32.27760340435471, 1.812198206447988],
            [32.2779966984642, 1.813682210423752],
            [32.27856249605769, 1.818648800932442],
            [32.278186747842334, 1.821706582297981],
            [32.27571385474843, 1.829395064115742],
            [32.27564507703533, 1.831140834797195],
            [32.27733966437718, 1.835728314736345],
            [32.278958316229755, 1.837095017178691],
            [32.28264519888683, 1.838634274217728],
            [32.28371517683186, 1.838680008144658],
            [32.28900148110621, 1.83644772030928],
            [32.292875045357434, 1.835689314640875],
            [32.296893180877206, 1.836025728931872],
            [32.300567290389246, 1.83683211396394],
            [32.3054904794561, 1.838335738140352],
            [32.31240343687727, 1.84287999054102],
            [32.31680476045958, 1.845107219918668],
            [32.32965052888531, 1.849155113338319],
            [32.326956004342826, 1.858110839205771],
            [32.31788091432219, 1.864616821611026],
            [32.31204004049707, 1.871520633632003],
            [32.30567126540702, 1.880362893550492],
            [32.30357903341477, 1.884386016464114],
            [32.280162058710474, 1.895057809454517],
            [32.27786981143032, 1.894650701901152],
            [32.263037081885535, 1.896585231810401],
            [32.25028830366272, 1.894776678300955],
            [32.2481209779026, 1.895190518606142],
            [32.23697288522668, 1.893429660584024],
            [32.23202681696785, 1.891370273693333],
            [32.23243962068867, 1.890524633736124],
            [32.22808854706674, 1.893672354286046],
            [32.22509055994316, 1.893790193772405],
            [32.2147564253563, 1.891999312836792],
            [32.20623534343937, 1.893702094728598],
            [32.201855635119415, 1.896240411112753],
            [32.19775019413381, 1.902707813902057],
            [32.19293508317541, 1.908460585923159],
            [32.180285260669365, 1.898419314800294],
            [32.180217044403314, 1.898745056344903],
            [32.177960869871704, 1.898278749951234],
            [32.17404407419744, 1.898165961021238],
            [32.172094309619354, 1.899071639087219],
            [32.16865418249272, 1.902233932771349],
            [32.166373304290794, 1.903620503351398],
            [32.15675515483314, 1.905206837487255],
            [32.152482542763046, 1.904705742355592],
            [32.150319708579346, 1.903927165253136],
            [32.14436022839063, 1.906847600369462],
            [32.14292545089694, 1.907845861289319],
            [32.140974983836294, 1.910231809155867],
            [32.139613895145345, 1.910934069969751],
            [32.13304889475959, 1.91135632341746],
            [32.13003280119315, 1.911983952888257],
            [32.12731146732933, 1.911630999268964],
            [32.12069256802653, 1.90949980878295],
            [32.118449728087, 1.908222103266825],
            [32.11686911359849, 1.906629879529799],
            [32.11375869692723, 1.904484935440991],
            [32.11264773424569, 1.904230740397889],
            [32.11146097531373, 1.901149534367553],
            [32.11106824265129, 1.898325604602912],
            [32.10462802454671, 1.902773185970366],
            [32.10356169555836, 1.904112340486426],
            [32.103470320724306, 1.905996356620622],
            [32.10458170471571, 1.90960446006128],
            [32.10415177641062, 1.914529817201719],
            [32.10465286835421, 1.915696414538545],
            [32.10391793416239, 1.91641438394181],
            [32.1061645640941, 1.919875168804712],
            [32.10941365818735, 1.923451258576774],
            [32.11153522646185, 1.927377485646658],
            [32.11201245645654, 1.928543792295966],
            [32.11265110292801, 1.9333220803251],
            [32.11310362925238, 1.933916594312753],
            [32.11502939264271, 1.93488678306863],
            [32.11611270428149, 1.936229840315369],
            [32.115966868185005, 1.940629626549602],
            [32.11554115118197, 1.941656485952657],
            [32.11338294871187, 1.943381382387122],
            [32.112460631341676, 1.945459223735261],
            [32.11432954844251, 1.947729246602561],
            [32.11557090787576, 1.95094335422574],
            [32.114897311549846, 1.952698541690457],
            [32.11364163566593, 1.954420060095678],
            [32.11352443336912, 1.955255007109083],
            [32.11274163604065, 1.955782459981435],
            [32.11222117462291, 1.956857565535435],
            [32.11019280655914, 1.958164693650869],
            [32.10974266616016, 1.958834108712751],
            [32.109721050897804, 1.959907247945286],
            [32.111246642676825, 1.962762497994714],
            [32.1115190846345, 1.967090392825803],
            [32.11322069051368, 1.968716506769598],
            [32.11548991936301, 1.970079175117174],
            [32.11725763495887, 1.970409391822727],
            [32.11738831198494, 1.97098060687505],
            [32.116558493241236, 1.97159502756226],
            [32.11625250459758, 1.972473171803645],
            [32.11625152184066, 1.97431783386641],
            [32.116687766200506, 1.974976862296597],
            [32.11895713518701, 1.975988268692407],
            [32.12336547730665, 1.976956749787199],
            [32.124494126019506, 1.977961702631729],
            [32.126026456061496, 1.980515603893955],
            [32.12689697926734, 1.985259516118765],
            [32.128250768248286, 1.984118498873746],
            [32.133184764946314, 1.981837022236008],
            [32.136023862554, 1.978412837044049],
            [32.13864413594837, 1.976306139736724],
            [32.14169110910269, 1.97202259689295],
            [32.1487845713021, 1.972300909679094],
            [32.15369344391827, 1.976283695213008],
            [32.15532921945678, 1.978549187346014],
            [32.16176410426352, 1.978736318746643],
            [32.163182179381145, 1.979085049535261],
            [32.16472419416021, 1.978753432221813],
            [32.16542937165824, 1.97808907517102],
            [32.166155322697215, 1.976143978046047],
            [32.165768625815176, 1.974902795307905],
            [32.1668075831368, 1.973923651851669],
            [32.167683300401634, 1.971644685761737],
            [32.16885125040817, 1.970614759928931],
            [32.17067932201136, 1.970959003502884],
            [32.1763401123681, 1.973181016998509],
            [32.17846996131288, 1.976189708317749],
            [32.17976900965536, 1.977076827936871],
            [32.1807547705425, 1.975823862517681],
            [32.182156282522904, 1.976621485262871],
            [32.18206420520629, 1.979388050068243],
            [32.18352214306464, 1.982722735606925],
            [32.18533477442471, 1.986732149255136],
            [32.18833079693276, 1.990980584345892],
            [32.190561706347005, 1.995366480510341],
            [32.1892584476008, 1.996932528332415],
            [32.195814183661014, 2.002770545737563],
            [32.20269822700815, 2.009603938032634],
            [32.202063650803225, 2.022123752206162],
            [32.2007345654926, 2.025407010922465],
            [32.19304302204502, 2.036422134782376],
            [32.19235917953499, 2.041576041819758],
            [32.191233898606114, 2.043540138952058],
            [32.186996657700334, 2.046097865149021],
            [32.18565550172724, 2.046463976185951],
            [32.184775994470215, 2.047399591304496],
            [32.17989308945398, 2.049070793373166],
            [32.17585403935776, 2.051393415209922],
            [32.16871145009208, 2.050078226195756],
            [32.164850519747034, 2.051713515893063],
            [32.162664103888794, 2.05219184214286],
            [32.1581241028845, 2.050814373080911],
            [32.15666293737934, 2.051564266712052],
            [32.156568192964635, 2.05218847562114],
            [32.15119963624792, 2.057360005704498],
            [32.14973846984442, 2.057657941884331],
            [32.1487173386913, 2.059303603433905],
            [32.14912172070633, 2.060217609745308],
            [32.14969201077457, 2.060281293241764],
            [32.15054849780411, 2.06147584086057],
            [32.151831685491935, 2.061476401944257],
            [32.15209374022997, 2.062335981921064],
            [32.15340064883119, 2.062047304044814],
            [32.1550058259545, 2.06403830799792],
            [32.15676540101727, 2.06545055273704],
            [32.157977705340954, 2.065830966480784],
            [32.15938132297239, 2.068409978043153],
            [32.161985174265055, 2.071260829256617],
            [32.16200987793537, 2.073224047765231],
            [32.16243840217366, 2.074436540174891],
            [32.16197576980234, 2.076218246316716],
            [32.16242829612672, 2.078082147902446],
            [32.16195373323011, 2.079113127593465],
            [32.16227586370111, 2.081628155679986],
            [32.16196734809655, 2.08261396686876],
            [32.16253833974902, 2.083708906240362],
            [32.16215908271417, 2.085671829180777],
            [32.1626107664188, 2.08628704746818],
            [32.16339524898677, 2.086432365857757],
            [32.163633582811414, 2.087554235043627],
            [32.164501158644825, 2.087663082582896],
            [32.164929262471574, 2.088405103748103],
            [32.16459730712633, 2.089716614435833],
            [32.16635716246345, 2.09184364325765],
            [32.16893659036017, 2.093572868995322],
            [32.17328724357056, 2.095664825166526],
            [32.17592674720023, 2.098271561353353],
            [32.177579647323014, 2.100624409599491],
            [32.17779552326556, 2.103917324530699],
            [32.17925851414739, 2.106795042587138],
            [32.179307219903784, 2.108830313299829],
            [32.177848019014135, 2.113497540951458],
            [32.17768239213363, 2.115216082459675],
            [32.178305878636344, 2.125466135850697],
            [32.17668554244262, 2.209912420174644],
            [32.176939176373196, 2.218144662980447],
            [32.174629102026216, 2.218296982079702],
            [32.17073237920699, 2.220764653786786],
            [32.168949924952244, 2.221523440855522],
            [32.165943375985705, 2.2220463161405],
            [32.16157012475602, 2.222116163288148],
            [32.15437953221652, 2.221090048466345],
            [32.15119472336162, 2.221621900305514],
            [32.148485179885895, 2.221547844997612],
            [32.147606234974255, 2.222958542320982],
            [32.145661101211445, 2.231107962233859],
            [32.140813988669386, 2.234750949956804],
            [32.13697607675517, 2.236195856817436],
            [32.13291358601992, 2.240644173618679],
            [32.130180883077855, 2.241746292201644],
            [32.12934952013017, 2.242921904070203],
            [32.12530850541843, 2.242421756955291],
            [32.124619188575046, 2.242656543044875],
            [32.121768300579255, 2.245124454823704],
            [32.120318644289505, 2.245820114586019],
            [32.11379420912705, 2.24593371983305],
            [32.11077488701548, 2.244647310128707],
            [32.10986000859415, 2.244845909869144],
            [32.107848624977464, 2.246907081852645],
            [32.10080723631843, 2.249498970636294],
            [32.09532709267376, 2.252245694502344],
            [32.090114196927786, 2.255942206660317],
            [32.08475658797943, 2.26268723717663],
            [32.079097763136524, 2.265786530203914],
            [32.0723490294274, 2.271128158545356],
            [32.06751118031254, 2.274164600046219],
            [32.06415583258917, 2.275058000443548],
            [32.062120727160774, 2.276277904669206],
            [32.05324775897739, 2.282504754976487],
            [32.04742948317156, 2.283685943812999],
            [32.041915370632715, 2.284053118564012],
            [32.03845475203615, 2.282259597255494],
            [32.032926182909456, 2.277190096931434],
            [32.029732531038896, 2.276238073382607],
            [32.025628072810214, 2.276524746420762],
            [32.02359170435052, 2.279752759433305],
            [32.0228178901749, 2.289033396729195],
            [32.018619950562794, 2.295724416772267],
            [32.01717169744152, 2.299658398356862],
            [32.0167775616106, 2.301992135158408],
            [32.01588415921278, 2.303710177689652],
            [32.01309839907508, 2.306476152857323],
            [32.00801084705734, 2.309104959865925],
            [32.003834803880295, 2.30968109767087],
            [32.00055132048133, 2.309678572762869],
            [31.99684198084048, 2.310734358205727],
            [31.995498718318025, 2.311583697594255],
            [31.992624249546022, 2.315724640124436],
            [31.99010503662112, 2.318255818169379],
            [31.98884458798809, 2.318399430972438],
            [31.982193827238802, 2.317345335098467],
            [31.97914980145692, 2.318546409685478],
            [31.978426096206157, 2.320255456395344],
            [31.979071479143922, 2.323403711413508],
            [31.98002537768625, 2.325385671785464],
            [31.979551095962336, 2.326796266684625],
            [31.97698079135565, 2.326016498501998],
            [31.973353983533194, 2.327153613542229],
            [31.97256851910664, 2.326800193573663],
            [31.970710690809675, 2.324863113982572],
            [31.967784850081525, 2.3252950723031],
            [31.966786316049355, 2.325846240157174],
            [31.96547912717378, 2.32718390667827],
            [31.964731701009622, 2.329064884757488],
            [31.962451243219242, 2.332365145325946],
            [31.960945020914366, 2.336959018851442],
            [31.95768764525251, 2.338802118198931],
            [31.955690999396374, 2.340672983117681],
            [31.95497754032973, 2.340980118425237],
            [31.953859278836514, 2.340816312696894],
            [31.94865915623557, 2.33894909478363],
            [31.94609011466017, 2.339236596197406],
            [31.942081101532093, 2.338826520352101],
            [31.94143950858651, 2.339594781811064],
            [31.941345185481676, 2.340571726025792],
            [31.941631242305796, 2.341259485684885],
            [31.94365511879315, 2.342617894615351],
            [31.944464725442963, 2.343622324616644],
            [31.944109189321505, 2.344870498843605],
            [31.94303893020378, 2.345086755882385],
            [31.938350005593374, 2.343156433231655],
            [31.93614997486869, 2.343498629536482],
            [31.934914229905978, 2.345035426051449],
            [31.935036204951896, 2.348092746620377],
            [31.93302861042907, 2.350660329754378],
            [31.929691649422924, 2.356555599432161],
            [31.928123107393542, 2.35815521128706],
            [31.92712583639266, 2.360325608672534],
            [31.92434414741984, 2.36197878748515],
            [31.92191813470567, 2.362600904024819],
            [31.920966903261426, 2.363178982829557],
            [31.919659994660215, 2.364851513018445],
            [31.918447409163836, 2.365547114262101],
            [31.91618618160875, 2.365815537264466],
            [31.9149411723205, 2.365234654714352],
            [31.913322380330747, 2.364161801153484],
            [31.910844293177867, 2.360199951226969],
            [31.908940145948225, 2.359270702396279],
            [31.905455384230073, 2.359788478661546],
            [31.900105074093396, 2.362565562927279],
            [31.898284722611766, 2.362126042563301],
            [31.89647517876132, 2.360718849087259],
            [31.893191836397868, 2.360436119898753],
            [31.89107391797837, 2.359769966620715],
            [31.889504392293734, 2.360464448468473],
            [31.887091854308817, 2.362867925621614],
            [31.88211982024673, 2.363065106003891],
            [31.873850406746538, 2.36074605571013],
            [31.871398707605127, 2.359387384388379],
            [31.868710218843034, 2.35919973999412],
            [31.859449851295047, 2.365576003696135],
            [31.85805886577313, 2.36637790851611],
            [31.856940884554273, 2.366498516688516],
            [31.854704079496816, 2.366071338874893],
            [31.85444146241339, 2.365044486301645],
            [31.85491560489845, 2.363204787429149],
            [31.85396198663049, 2.361103954871166],
            [31.851319676663895, 2.359267897540579],
            [31.849796610947443, 2.358863718223882],
            [31.84255731265154, 2.364043436654756],
            [31.84153477743162, 2.364474541876159],
            [31.83916771665797, 2.364560931105312],
            [31.833219606445812, 2.369187234755703],
            [31.82966508515596, 2.366327421371057],
            [31.828475097678865, 2.365707831309118],
            [31.8255248344531, 2.365472505435732],
            [31.82116968966627, 2.3638055856884],
            [31.81456398392004, 2.359382335648539],
            [31.81213740975881, 2.359337457960265],
            [31.80954352437592, 2.358480574770786],
            [31.804103945056212, 2.354438208574124],
            [31.80150823429665, 2.351407827768368],
            [31.79923479504359, 2.349726587658611],
            [31.7979715391753, 2.347124502334234],
            [31.79623329910053, 2.345335268602109],
            [31.792508238043876, 2.343082384184194],
            [31.788177656790182, 2.342084123656586],
            [31.78433314854685, 2.339186389008103],
            [31.784165134842613, 2.337562353264949],
            [31.784925615324497, 2.33658232111454],
            [31.785304310912288, 2.334432362221631],
            [31.784791709753293, 2.333226533265742],
            [31.780484287965933, 2.33141624451877],
            [31.77615482960635, 2.33158846607714],
            [31.775417088179267, 2.331326487346445],
            [31.772619958963343, 2.329096580759323],
            [31.769121161068874, 2.327117991506143],
            [31.76515538026218, 2.321425955208198],
            [31.763497427115926, 2.316209054097437],
            [31.760687664892153, 2.313131187716717],
            [31.753107147823798, 2.308685338415967],
            [31.751130292751686, 2.306036334906323],
            [31.75116341812779, 2.303062511240369],
            [31.750352407411174, 2.301912193965051],
            [31.749347838496938, 2.22361437896242],
            [31.746006245777195, 2.051805253185753],
            [31.745600319558182, 2.049561745339036],
            [31.745950522381808, 2.048943145388507],
            [31.745380513486264, 2.048348111805574],
            [31.74481836395113, 2.045241642972385],
            [31.745048978552553, 2.044316406305856],
            [31.744676317846825, 2.043044135331217],
            [31.74443672099089, 2.037087871303507],
            [31.743319020046393, 2.033212963683387],
            [31.7444848644019, 2.030553939010504],
            [31.74603782694932, 2.029022711379818],
            [31.74730389005288, 2.026797406932955],
            [31.748153920890477, 2.02396471271542],
            [31.751632366553864, 2.022261783064959],
            [31.753040475761722, 2.022204831231138],
            [31.753328216927006, 2.021713590833397],
            [31.752437902937128, 2.021018951895323],
            [31.7522666615861, 2.019515489173171],
            [31.754164352623796, 2.018071221436023],
            [31.753806429678615, 2.016451889417412],
            [31.75432436503378, 2.015469404098108],
            [31.753606554527902, 2.014716969195095],
            [31.75470025338631, 2.012404954627045],
            [31.75794738286405, 2.012609757296206],
            [31.75740277922305, 2.010788142380595],
            [31.757461309853696, 2.009458050675438],
            [31.758398224847262, 2.005411099437876],
            [31.757077280069737, 2.004282440448623],
            [31.758313866753863, 2.002953465659409],
            [31.758717126773124, 2.001652545913614],
            [31.75820017417489, 2.00127632487521],
            [31.75684919242921, 2.001795907650238],
            [31.75656201181265, 2.001535275075435],
            [31.75627567381584, 2.000234073202908],
            [31.755371042476963, 1.999423836551284],
            [31.755630711289612, 1.998065120120505],
            [31.75715475976299, 1.996649729944757],
            [31.757155882657095, 1.995319627658265],
            [31.75767339670239, 1.994973144724822],
            [31.76002964894653, 1.995119593580351],
            [31.76169672628114, 1.994686979359062],
            [31.762845305915196, 1.995699777807035],
            [31.7632480044874, 1.995324397513531],
            [31.76382348771629, 1.994197133904964],
            [31.763910512009446, 1.993127382582772],
            [31.76350893633134, 1.992231013747365],
            [31.764271241291556, 1.991132925640083],
            [31.76513586975252, 1.987606076709323],
            [31.765797394517637, 1.986970620799451],
            [31.76688898862335, 1.98731822763406],
            [31.76648713267089, 1.986826415657945],
            [31.76717855426697, 1.984542978421152],
            [31.76791096239622, 1.984861689040739],
            [31.77092902057817, 1.983909765775459],
            [31.841241702070178, 1.972048688269729],
            [31.969775600294447, 1.94962584018108],
            [31.96949024505455, 1.949281872332672],
            [31.969977019649136, 1.946749246012092],
            [31.971918924866813, 1.945375615444004],
            [31.972490618103514, 1.944254210285735],
            [31.9732614849067, 1.94420034239693],
            [31.974346621922145, 1.943251201585596],
            [31.97668743482151, 1.943424588944031],
            [31.97734390656315, 1.942990839952439],
            [31.977429948997706, 1.942393803642109],
            [31.97794381318799, 1.942357891676865],
            [31.97944399971247, 1.939717518005468],
            [31.981413977282774, 1.938913706214962],
            [31.98227102575937, 1.937828488945471],
            [31.98298476510037, 1.937566723213424],
            [31.983470978247897, 1.936481505080786],
            [31.98469858267752, 1.935731559914561],
            [31.98552657694289, 1.935731840028982],
            [31.98606963637991, 1.934384574383412],
            [31.98555619260116, 1.933579076680948],
            [31.986457034846183, 1.93101949179522],
            [31.987656566024846, 1.929726651889862],
            [31.988343637080014, 1.926316950714169],
            [31.989029304068385, 1.925476097099514],
            [31.990056893210113, 1.925277738065793],
            [31.991667123356894, 1.922845237300373],
            [31.99206729406987, 1.919163933541179],
            [31.991743620293228, 1.918394901348399],
            [31.992068276826796, 1.917653085088714],
            [31.992687412788605, 1.917617452718316],
            [31.99304280877288, 1.914741084452804],
            [31.99395740602153, 1.913674089086057],
            [31.993662926593288, 1.913203577781208],
            [31.994120225666773, 1.912398911331356],
            [31.993884698179055, 1.912190450361599],
            [31.995330705512124, 1.909821339270501],
            [31.995332249716103, 1.907089450032775],
            [31.99624698710193, 1.905696990759868],
            [31.997632918702045, 1.905281749681853],
            [31.99794325878494, 1.904042759492008],
            [31.998651243518232, 1.903445989673195],
            [31.998268476765556, 1.902676951339415],
            [31.998800026987166, 1.901284207483342],
            [31.998505688594438, 1.900180448762052],
            [31.99785721724871, 1.899709652750152],
            [31.99791673063628, 1.898814076414144],
            [31.99726839942774, 1.898578678238069],
            [31.994631422758978, 1.895139454870983],
            [31.992538769456853, 1.894658838881698],
            [31.992450622269594, 1.893862861002744],
            [31.991684106905655, 1.893618203784756],
            [31.99027010205458, 1.891690685274837],
            [31.990625077627318, 1.889999124240935],
            [31.989623315050014, 1.888786497677667],
            [31.99005184018664, 1.886742256131761],
            [31.989816452836095, 1.886172415207879],
            [31.990348003057704, 1.884752443085312],
            [31.990319509395203, 1.882997466044368],
            [31.991322253831108, 1.882410229326878],
            [31.99108672724171, 1.881668115692405],
            [31.993727212729976, 1.878259441731003],
            [31.995293509869473, 1.871792509155449],
            [31.996149295314776, 1.870490366406834],
            [31.997727522979567, 1.869152589324962],
            [31.999380423102348, 1.865381387553005],
            [31.999999979475696, 1.864884209005574],
            [32.00177064334234, 1.865075280910626],
            [32.003048778006686, 1.862705824594777],
            [32.00428283862825, 1.86205517106306],
            [32.00428059284004, 1.860987861433577],
            [32.00505089819617, 1.860110783221404],
            [32.00504921385501, 1.859133818708982],
            [32.00559465921743, 1.858772437098101],
            [32.00516599484195, 1.858129918368139],
            [32.00573516111775, 1.857705126380753],
            [32.00501917598854, 1.855913647371409],
            [32.00599188345629, 1.855217537963572],
            [32.007210925144605, 1.853110688238214],
            [32.0074679277575, 1.85079508756997],
            [32.008227284446946, 1.850460639660716],
            [32.00839178843336, 1.849547080285166],
            [32.00767804909235, 1.84891353668278],
            [32.00838898119809, 1.848027473107595],
            [32.0076996643547, 1.847737636060736],
            [32.00780451481636, 1.846679297181488],
            [32.00744743449092, 1.846199509199831],
            [32.00794529788938, 1.845774714352426],
            [32.0072524722265, 1.843630536962436],
            [32.0075365644351, 1.843105855632146],
            [32.00677468078476, 1.842101385060509],
            [32.00753389733702, 1.841767216542866],
            [32.007444065808606, 1.838112677337859],
            [32.008370593582534, 1.838203584957013],
            [32.00886593091842, 1.836503275017767],
            [32.010313902867004, 1.835997390860536],
            [32.010406962042225, 1.834948303686625],
            [32.01123664064875, 1.834134622732653],
            [32.01222254167307, 1.834171379122318],
            [32.016556912918944, 1.827877684425506],
            [32.02461550260173, 1.825385284043566],
            [32.02570681553476, 1.824662226924899],
            [32.02703281333576, 1.822636710661338],
            [32.03127047555141, 1.821580600685842],
            [32.03426298834163, 1.821618479659163],
            [32.03807914395799, 1.823854995124329],
            [32.04140417354051, 1.823675703208983],
            [32.04567552257932, 1.821678805163808],
            [32.049081680811774, 1.820649350347844],
            [32.053822961033596, 1.815966153726642],
            [32.05824828670198, 1.813788270754009],
            [32.0623986434518, 1.81055202407118],
            [32.06491504914144, 1.810019757774911],
            [32.06875071526745, 1.809894898579917],
            [32.072165717413895, 1.807264426106554],
            [32.074956109265194, 1.807093831095894],
            [32.07635607704162, 1.806425199958769],
            [32.07702153193611, 1.806660609483645],
            [32.07778088952388, 1.8062722812149],
            [32.07835314420763, 1.807394055857229],
            [32.08134692002914, 1.808119365454641],
            [32.08148461559254, 1.805505164289811],
            [32.080912360010444, 1.804265543058737],
            [32.081600553959724, 1.803958303619649],
            [32.08133807791181, 1.803451568129314],
            [32.0816931927234, 1.80278237358572],
            [32.0828085077425, 1.802303416097629],
            [32.082854686538, 1.801661157268251],
            [32.083720999340116, 1.801308742787653],
            [32.08514272341442, 1.799690328915593],
            [32.085359863286584, 1.795239683364877],
            [32.08483631346089, 1.794642316680429],
            [32.084977096533905, 1.793764924132224],
            [32.08205350159397, 1.792650997515779],
            [32.08140825879339, 1.790624323191171],
            [32.08181053515739, 1.789719712268246],
            [32.08089397329323, 1.788733449712129],
            [32.07919868346881, 1.784046522914991],
            [32.0792295630567, 1.781667420833216],
            [32.077303378356504, 1.78034585175921],
            [32.076969177223035, 1.779513346483541],
            [32.07772544640285, 1.777668478084378],
            [32.07731938004666, 1.776410881248191],
            [32.07799409926668, 1.775325564175434],
            [32.07818134140955, 1.773869307846677],
            [32.07782271688013, 1.772575511073502],
            [32.07834430119197, 1.772150418843803],
            [32.07786608933869, 1.77048596261141],
            [32.077366541599076, 1.770078546596499],
            [32.0767791278449, 1.767228595667551],
            [32.07683007849118, 1.762977091067888],
            [32.07746591772739, 1.760091775675619],
            [32.07921819397847, 1.757505285307737],
            [32.08023806210031, 1.756737025707932],
            [32.08264877560688, 1.756765365008777],
            [32.086094937615584, 1.757970224864824],
            [32.09066553793341, 1.757221606862201],
            [32.09304031882863, 1.757141357688188],
            [32.09425234197962, 1.757567015429869],
            [32.094726203292, 1.756988435750543],
            [32.0943653338727, 1.754518667325911],
            [32.09531375808168, 1.753768083347645],
            [32.09657266251073, 1.753814100439976],
            [32.097833953763505, 1.755171604154501],
            [32.099068294659425, 1.75478326503624],
            [32.10049366858873, 1.754919632683776],
            [32.10077719935028, 1.754250140392841],
            [32.100287617520436, 1.752857000355992],
            [32.10137457901423, 1.749917515412083],
            [32.10125316631368, 1.74863296201923],
            [32.10057760447393, 1.74747467458874],
            [32.10098928619898, 1.745864631426373],
            [32.10338399801539, 1.742998088985179],
            [32.10452724435161, 1.739624508184223],
            [32.106268993245884, 1.73786125377155],
          ],
          [
            [32.04208647184657, 1.855291890253243],
            [32.03660660847626, 1.86695597240907],
            [32.03631648048726, 1.870506639695595],
            [32.038043491620975, 1.8734063685485],
            [32.04121103575442, 1.875944434397806],
            [32.04315336138364, 1.879858705391274],
            [32.04549038518915, 1.886780693955325],
            [32.0416717026119, 1.889459867061745],
            [32.03925677870159, 1.89340777610404],
            [32.04004827890854, 1.89485776259063],
            [32.054159127680904, 1.904721174067738],
            [32.057944965156416, 1.901515957445498],
            [32.05866642461898, 1.899920921820955],
            [32.060718934906006, 1.897540571073239],
            [32.05945918785721, 1.892777335068613],
            [32.06095263701706, 1.892042240569525],
            [32.063702323507876, 1.888858884995495],
            [32.065435791731865, 1.888266037936196],
            [32.06648808364557, 1.885873606163517],
            [32.06733629000483, 1.885614358998957],
            [32.069845115710095, 1.883352389959474],
            [32.07282513652798, 1.882121240108808],
            [32.07394283747247, 1.879549233509747],
            [32.074313532664355, 1.869933146462669],
            [32.07420559469308, 1.859004753856446],
            [32.074782762263126, 1.857120967087293],
            [32.070750309394356, 1.855741934687338],
            [32.06621311472699, 1.855522243883806],
            [32.063114208169466, 1.859506142249163],
            [32.060086324214936, 1.865084539430411],
            [32.05778074144437, 1.866895088188238],
            [32.05144551393863, 1.861818926651863],
            [32.048133677912666, 1.859788121250987],
            [32.044678392613946, 1.856597692179338],
            [32.04208647184657, 1.855291890253243],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1397,
        District: "KIRYANDONGO",
        County: "KIBANDA",
        Subcounty: "KIRYANDONGO",
        Population: 94426,
        Key: "KIRYANDONGOKIRYANDONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.859198640060377, 0.47008613158455],
            [30.85738776670329, 0.469837707256577],
            [30.85393420616992, 0.472166907084788],
            [30.85076216237522, 0.477917767881531],
            [30.83958296732922, 0.477180648540036],
            [30.832089103549784, 0.476094985848155],
            [30.82428714817062, 0.476372200860196],
            [30.820558746279424, 0.477305713943446],
            [30.814514598976878, 0.478060578872289],
            [30.80540816224439, 0.481183174189422],
            [30.80550333335885, 0.48403091587188],
            [30.803457225364866, 0.482936053151017],
            [30.80298316821976, 0.481741839197626],
            [30.802430336010744, 0.47961225474188],
            [30.802669101026737, 0.474776396036608],
            [30.80225417279028, 0.474119529997831],
            [30.79974362142136, 0.47399931706978],
            [30.79685706581721, 0.475172539464626],
            [30.791875917448237, 0.473698266879463],
            [30.79159952829318, 0.472543929773198],
            [30.79446666321921, 0.470236352690023],
            [30.79422964362981, 0.469599448812404],
            [30.79280662777812, 0.468643753335354],
            [30.79258960289031, 0.467290427211899],
            [30.79413294088777, 0.462773422742509],
            [30.79427189858415, 0.460902785953146],
            [30.790659648859187, 0.457004423914283],
            [30.7886748733412, 0.453478590229036],
            [30.78696425376648, 0.452116342132535],
            [30.785586795076124, 0.449196003191774],
            [30.781284848520414, 0.444108925552475],
            [30.781284196343524, 0.444105586614868],
            [30.78377205087848, 0.443746621618985],
            [30.784629851244976, 0.443237063945921],
            [30.788568015144904, 0.439373497564809],
            [30.793838625851258, 0.431908663932609],
            [30.79590548762326, 0.430774507449758],
            [30.806082938058253, 0.430983058920317],
            [30.80874591286968, 0.430474009711661],
            [30.80938490698916, 0.430910341456684],
            [30.809947596411753, 0.429956521932832],
            [30.81123212169102, 0.424958248846588],
            [30.812828029098917, 0.425037983812548],
            [30.81335840701908, 0.42591572952555],
            [30.814478891842647, 0.426174592579194],
            [30.818892331901516, 0.425058800798117],
            [30.822551100883462, 0.420710007875228],
            [30.823233747735863, 0.419241176081383],
            [30.82313919915389, 0.418497098957918],
            [30.825300437031316, 0.415540572836699],
            [30.825563213116556, 0.41348872710224],
            [30.826702823072498, 0.412729616520171],
            [30.827931261138687, 0.410912755213544],
            [30.831130172645214, 0.408770961368721],
            [30.83275512348457, 0.408120465579716],
            [30.835858079647405, 0.403643860519959],
            [30.846065275996427, 0.401342369770236],
            [30.852362784141715, 0.400614090166752],
            [30.85281840695888, 0.397059637029748],
            [30.852122537803805, 0.402401507742627],
            [30.851250836906626, 0.416340768310897],
            [30.851656305883147, 0.419735706950223],
            [30.852690467997796, 0.421731765389618],
            [30.858714330442925, 0.427766821191768],
            [30.860748037194412, 0.433827126759861],
            [30.86378953871035, 0.436599612457311],
            [30.86584547427355, 0.439599560040379],
            [30.867534088717097, 0.444261316567617],
            [30.866763714190693, 0.447429537329457],
            [30.865801190025, 0.448546970554097],
            [30.86441358935508, 0.449964658933537],
            [30.862314403504197, 0.455763288908567],
            [30.859454395811632, 0.459936322439274],
            [30.858908933381247, 0.461657945494089],
            [30.858613923946983, 0.465614998068273],
            [30.859198640060377, 0.47008613158455],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1398,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "BUTUNDUZI",
        Population: 12588,
        Key: "KYENJOJOBUTUNDUZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.762571555950046, 0.463445652330967],
            [30.763266190819913, 0.465968568669879],
            [30.76205337265985, 0.46926906223524],
            [30.762123708949982, 0.472211175456956],
            [30.763405946220214, 0.474723137650028],
            [30.765828647744254, 0.477307236535025],
            [30.769774038590633, 0.482768175664037],
            [30.770813305831055, 0.483516008227786],
            [30.771673772397303, 0.486087649992699],
            [30.77176201390765, 0.488688936799311],
            [30.770514138993658, 0.490063892934087],
            [30.76588131956263, 0.488746756555774],
            [30.762376677228918, 0.488775474650451],
            [30.761544892073065, 0.48931338062082],
            [30.759404297480845, 0.495800793631996],
            [30.75093469441962, 0.510508227629729],
            [30.75161623275093, 0.514963432526629],
            [30.754051109142033, 0.516489157430695],
            [30.75716621681571, 0.519805840782742],
            [30.760222466871955, 0.521266657639755],
            [30.761358398226815, 0.522845141375352],
            [30.76247881837169, 0.526152404737509],
            [30.766554754191798, 0.529896302577714],
            [30.76687322582462, 0.531555459251617],
            [30.765495198500695, 0.533034290086211],
            [30.765092406503694, 0.535346414504986],
            [30.7639535349629, 0.538288126006303],
            [30.761990139348697, 0.539333933449295],
            [30.759979509418542, 0.541645449148118],
            [30.758371260955254, 0.542800978505337],
            [30.755787093547127, 0.543262454678925],
            [30.751952378736977, 0.545990098145571],
            [30.752511120962257, 0.549947152300656],
            [30.752419206240678, 0.553001945717173],
            [30.7533651106753, 0.55876327384959],
            [30.753072678507607, 0.563453154839314],
            [30.753693775491683, 0.570258357751738],
            [30.752008583629376, 0.569659918940466],
            [30.75053709199001, 0.569613339103575],
            [30.750515845935222, 0.567685656634445],
            [30.749980532670907, 0.567731601409154],
            [30.74613038749915, 0.568646692648989],
            [30.741185377455743, 0.571187541558655],
            [30.732833204863354, 0.574104798700752],
            [30.729955707870538, 0.573450633398418],
            [30.728747914886203, 0.572519083015206],
            [30.726350391342947, 0.572052144057377],
            [30.724205948368052, 0.570947103246416],
            [30.72086377982824, 0.570943383507492],
            [30.719500922354502, 0.570191429391276],
            [30.718758491721633, 0.568743489437426],
            [30.716801953846307, 0.567335815925599],
            [30.71298750413068, 0.566441152067951],
            [30.708767006923466, 0.566788603429101],
            [30.70772116760844, 0.567062507011609],
            [30.704906952435824, 0.570183384477952],
            [30.70184168239578, 0.572099323020941],
            [30.688827388226112, 0.575241562206299],
            [30.684410597451237, 0.577307059163548],
            [30.6841044803485, 0.578735987771967],
            [30.68302986440166, 0.580197729795357],
            [30.682497683562726, 0.581970436887699],
            [30.679905894847725, 0.585172057827225],
            [30.675849290772515, 0.581887847345526],
            [30.675898094445294, 0.579280539351592],
            [30.67465442274849, 0.575579171589952],
            [30.673115142441162, 0.575185622441163],
            [30.67296607869787, 0.574326401951997],
            [30.67387514052773, 0.57342778409695],
            [30.673308991692945, 0.571576794554088],
            [30.672457628653785, 0.570620959117413],
            [30.673011198379648, 0.569925361573744],
            [30.67727129871447, 0.568594823783992],
            [30.678248397147293, 0.567941551634436],
            [30.678886231541757, 0.566262565832962],
            [30.679829199383697, 0.565464267482574],
            [30.680125770988248, 0.562357478668823],
            [30.684689671670654, 0.554881919451139],
            [30.685104253157437, 0.553114818265566],
            [30.683108663720084, 0.546066764975172],
            [30.681556539300825, 0.543081982265323],
            [30.675673968375165, 0.536223232495478],
            [30.674121246576235, 0.529139984849801],
            [30.671378833744246, 0.52476288980301],
            [30.670209354805117, 0.521442210822707],
            [30.668745011060462, 0.519328916062134],
            [30.666236524020036, 0.517116253006345],
            [30.66377604294843, 0.513972490579947],
            [30.6635319563127, 0.511753570942975],
            [30.66079484174426, 0.509288735669584],
            [30.65969414860304, 0.507671539892554],
            [30.65854818306644, 0.504345152426407],
            [30.658777964031295, 0.50337516214137],
            [30.662633676062867, 0.499912003797238],
            [30.667589950081613, 0.498481765878125],
            [30.668677550277565, 0.497588917336428],
            [30.66828622347855, 0.494862040732813],
            [30.668454082672547, 0.491255212047426],
            [30.667944819653126, 0.489380131096678],
            [30.667091214419045, 0.488090271836395],
            [30.664552745207693, 0.48708706965444],
            [30.66372271176665, 0.486107721227009],
            [30.660187570730713, 0.485247829934102],
            [30.65565353903149, 0.48243580091826],
            [30.65281270947193, 0.475502349062548],
            [30.652279853998206, 0.473316789660282],
            [30.65258943230976, 0.470999833840433],
            [30.65173607501065, 0.469160616759152],
            [30.653007846009526, 0.464275902005948],
            [30.652096187150185, 0.460251125982218],
            [30.65257250984644, 0.456453223490942],
            [30.652264657198547, 0.455139499619368],
            [30.651517814041, 0.453837730811597],
            [30.64660749962882, 0.450756567664201],
            [30.646228125812982, 0.450159428339409],
            [30.645909388278824, 0.446684030202942],
            [30.644795386596677, 0.444008851743874],
            [30.644133340808683, 0.438849517563381],
            [30.64273398568327, 0.437511947255394],
            [30.64209432411555, 0.435314470407187],
            [30.642558383011526, 0.432269014658215],
            [30.641965987200784, 0.430477584905566],
            [30.63909627051663, 0.427396432758006],
            [30.638136214921364, 0.425306473875283],
            [30.63685561438155, 0.423706173612537],
            [30.63434052921537, 0.423539083451971],
            [30.63284654376132, 0.421556641770451],
            [30.629347448524484, 0.419848977873951],
            [30.625813282160667, 0.416958980628156],
            [30.623820563738942, 0.416027550204273],
            [30.621247103350687, 0.413770487128509],
            [30.616028308368236, 0.410880610726029],
            [30.615234281200383, 0.408910116744957],
            [30.615710051432725, 0.406115490854168],
            [30.615260230834007, 0.403798625621507],
            [30.6102678148964, 0.398651621740651],
            [30.602727765134965, 0.386255665595932],
            [30.59676259771219, 0.38096551832493],
            [30.59484171397049, 0.378529372224485],
            [30.59457106505012, 0.373191096699878],
            [30.594187602103094, 0.372699557972668],
            [30.595274397408545, 0.372590748242012],
            [30.598929543484967, 0.369554537700001],
            [30.602038249763925, 0.368533940656001],
            [30.60776554509609, 0.364133310692525],
            [30.60875475281896, 0.364269168253056],
            [30.61074694572625, 0.366538601579626],
            [30.614922494829898, 0.36766966330701],
            [30.615775987774576, 0.369559142368372],
            [30.617270593066223, 0.370083839192331],
            [30.618551274454376, 0.371539544793035],
            [30.619429022810085, 0.371928482870436],
            [30.624625611438685, 0.371306176368916],
            [30.626001588807164, 0.371622934545466],
            [30.62740132032669, 0.37231032169489],
            [30.630057709588726, 0.375122348939754],
            [30.63333163581138, 0.376126641150001],
            [30.63579876351777, 0.377410942828199],
            [30.6356079532666, 0.379978134392785],
            [30.63631919349448, 0.381316193089861],
            [30.63918985520631, 0.382510221612251],
            [30.63942685233782, 0.382917070307785],
            [30.639710900528996, 0.384670836145416],
            [30.63921236339405, 0.385339628453206],
            [30.641418199930403, 0.387319927564412],
            [30.64189244572174, 0.388233064798207],
            [30.642033722868156, 0.390764202761622],
            [30.642649823422605, 0.392635584226331],
            [30.645069816526064, 0.39342272615235],
            [30.64879365587393, 0.396650957396391],
            [30.65066866804398, 0.395648091404907],
            [30.651143122244434, 0.395829021262067],
            [30.651759597396378, 0.396877803515972],
            [30.65328571648647, 0.397718936081273],
            [30.653941533356285, 0.399554186617105],
            [30.65672857, 0.401788304084248],
            [30.657784020390224, 0.403008478997629],
            [30.658779464217815, 0.405485660076541],
            [30.66226667564175, 0.407592947786222],
            [30.664542976028994, 0.411444564828337],
            [30.666343981392664, 0.416977453094493],
            [30.667408119390025, 0.425203992398882],
            [30.668143403026484, 0.4258550832412],
            [30.66909252612474, 0.425990971232762],
            [30.669353034862205, 0.427048709069784],
            [30.670680982007376, 0.429037878431889],
            [30.67238876649905, 0.430475738919767],
            [30.676374558177024, 0.431932388663453],
            [30.67926918783895, 0.432493756861251],
            [30.685842609930496, 0.439823129757641],
            [30.687567540566008, 0.440626263695257],
            [30.69015451251447, 0.443205900524526],
            [30.690676637612132, 0.445311228648451],
            [30.68981291914456, 0.448889731103636],
            [30.689260988844108, 0.458310149999863],
            [30.691142153575505, 0.460968534216077],
            [30.69412136501134, 0.463022051230751],
            [30.69581974324368, 0.465101467023593],
            [30.696995954157586, 0.465286059340199],
            [30.704236826301834, 0.464525320932894],
            [30.708183605943656, 0.465421324092428],
            [30.718482558910733, 0.465661543635905],
            [30.721801921022145, 0.466873126018392],
            [30.72517382649284, 0.467295275258257],
            [30.72690942552068, 0.467105143268091],
            [30.729257856133668, 0.468751227773119],
            [30.733425299738503, 0.469973025818214],
            [30.737005124773262, 0.472921321636177],
            [30.747940971598705, 0.471785845687337],
            [30.75597985673572, 0.471390700958692],
            [30.757013622693318, 0.469438318020288],
            [30.757355710136668, 0.467684597532706],
            [30.762571555950046, 0.463445652330967],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1399,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KISOJO",
        Population: 22065,
        Key: "KYENJOJOKISOJO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.312722565118168, -0.820218539112221],
            [31.310601073200456, -0.821835499599363],
            [31.31099833157531, -0.821261178546618],
            [31.310135219470542, -0.822085115728455],
            [31.30918452162558, -0.822207543496749],
            [31.300950991329408, -0.819131639444382],
            [31.2982571432183, -0.817748631037566],
            [31.291994879574876, -0.81312935534753],
            [31.28708861746293, -0.810234837396508],
            [31.281171046377167, -0.805738990100739],
            [31.277513239490908, -0.804082436515152],
            [31.271855927410957, -0.803863059877338],
            [31.26448355268884, -0.805336828046568],
            [31.257947783482436, -0.805966837810895],
            [31.257602604936206, -0.801173435393095],
            [31.258108793920698, -0.798687662892703],
            [31.257942916410233, -0.792698619108961],
            [31.258337308261012, -0.789082800830814],
            [31.25738364328063, -0.787895905464716],
            [31.25693518901946, -0.786539723827775],
            [31.256992272464185, -0.78422325911726],
            [31.25609510522699, -0.782132395671107],
            [31.251999947256458, -0.777045725079298],
            [31.247790390631092, -0.777213473620527],
            [31.24335691814139, -0.775968641568933],
            [31.240382227028082, -0.775967401109312],
            [31.236004856124513, -0.774835589775886],
            [31.234376874369385, -0.775625895640934],
            [31.233422054155568, -0.77726396776792],
            [31.233196237456074, -0.780427815851985],
            [31.230781428530133, -0.783760234412715],
            [31.225672185791545, -0.787995472501293],
            [31.22275294768073, -0.789632685580699],
            [31.219272574232733, -0.790987156878622],
            [31.2186556229737, -0.789969917028726],
            [31.219498394525484, -0.787879831632563],
            [31.219330686248465, -0.786297800667344],
            [31.219781143752762, -0.782851579101785],
            [31.218153381186557, -0.783133377647063],
            [31.210352534328475, -0.781717586015828],
            [31.20698587591736, -0.779682210508958],
            [31.202385447040506, -0.775329891936224],
            [31.200645691507866, -0.775046660187252],
            [31.199169864598947, -0.775456902984024],
            [31.199658978406532, -0.778770101511134],
            [31.19522572959731, -0.790116927619479],
            [31.194484364366367, -0.7954897031716],
            [31.194915781179883, -0.79750774592229],
            [31.193469861881727, -0.800156251049969],
            [31.194264452293258, -0.801609267011853],
            [31.194138935190185, -0.802510479089502],
            [31.193596668965565, -0.802664181923409],
            [31.193099218792145, -0.803488970823608],
            [31.193005996123524, -0.804694788234841],
            [31.19366164231343, -0.805491808950424],
            [31.19394518475308, -0.809296136884954],
            [31.193602260079867, -0.810803308085431],
            [31.193999275011272, -0.812394962174958],
            [31.192646007951513, -0.813765821238339],
            [31.192160916799757, -0.817476920127871],
            [31.19160874125923, -0.818302499143032],
            [31.192417587934333, -0.82226488064999],
            [31.19374014428948, -0.824059694630046],
            [31.195551574602, -0.82464056691291],
            [31.19813889419851, -0.826450708876017],
            [31.19968299306901, -0.825946231533137],
            [31.201937237121083, -0.828340056076804],
            [31.20597520025582, -0.829497079153166],
            [31.21280958922559, -0.834494540406832],
            [31.215344279224514, -0.834725282340981],
            [31.221741494078138, -0.837345691771139],
            [31.227430980218337, -0.845008689979327],
            [31.227649940077256, -0.847526667922081],
            [31.227062023266505, -0.855683148781791],
            [31.209605699255743, -0.868723887675185],
            [31.21740437847909, -0.878358292489535],
            [31.221990777467813, -0.882981431675887],
            [31.230768227787053, -0.894696589087783],
            [31.237790760808238, -0.89314448740409],
            [31.239742598698022, -0.894196607306535],
            [31.239024494443058, -0.897751915556873],
            [31.240502725243676, -0.900821870322123],
            [31.244879533801864, -0.905159926640411],
            [31.251137365157685, -0.90554875428814],
            [31.256574890928654, -0.908797848917439],
            [31.26162320094156, -0.91108820203883],
            [31.26792142145084, -0.912077819892402],
            [31.26990464647664, -0.914076071493783],
            [31.27128341760566, -0.914212147141384],
            [31.2736227949972, -0.913773193623734],
            [31.279320061446054, -0.908404657253408],
            [31.28326678179904, -0.906781611472765],
            [31.28580153917161, -0.907069878866611],
            [31.289277837861476, -0.904011581768169],
            [31.295127200766025, -0.903381306050387],
            [31.2983474840915, -0.900687913932916],
            [31.30046651552363, -0.894693186684341],
            [31.3015018490414, -0.878148609913971],
            [31.3125072012153, -0.87325699489587],
            [31.316276026395975, -0.869530843072875],
            [31.317082311075854, -0.865849832641386],
            [31.315513635197505, -0.862206361268732],
            [31.311272138073875, -0.855000120804137],
            [31.31246768252932, -0.845113932336502],
            [31.3117422812593, -0.830039053179138],
            [31.312722565118168, -0.820218539112221],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1400,
        District: "RAKAI",
        County: "KOOKI",
        Subcounty: "KIZIBA",
        Population: 20441,
        Key: "RAKAIKIZIBA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.62770602354159, 0.928782379973009],
            [31.627519524305463, 0.92828900916583],
            [31.625013431275264, 0.927754345455394],
            [31.61330196466049, 0.926148695766163],
            [31.608579439465178, 0.923963604083643],
            [31.60698903244178, 0.923671878186985],
            [31.604338014206785, 0.924058955036734],
            [31.60260297842266, 0.923864203150936],
            [31.590495124798856, 0.919905666779412],
            [31.585981466890267, 0.926906085818692],
            [31.582270646825805, 0.930251070509632],
            [31.57588345178087, 0.934065260624126],
            [31.57507002639277, 0.934911775140749],
            [31.569896028596943, 0.935653631714346],
            [31.566892117084084, 0.933690435365769],
            [31.571822494469806, 0.930093469287691],
            [31.566413894451003, 0.926979491926117],
            [31.561318491157664, 0.92283334416857],
            [31.554354029728007, 0.914734171605814],
            [31.554693196748353, 0.913926481508734],
            [31.552795692560213, 0.91049638047387],
            [31.551329051823416, 0.90131968832185],
            [31.547929703719085, 0.89702333289429],
            [31.542046091646025, 0.897991282694289],
            [31.53398684439643, 0.898783931415515],
            [31.532361202752647, 0.898611429390769],
            [31.530002297783472, 0.893907415538947],
            [31.53039187825756, 0.890027550886817],
            [31.531038170290394, 0.889467061652578],
            [31.531970031362192, 0.887441502724681],
            [31.534535768035642, 0.884629735731807],
            [31.53451832993935, 0.881129562182624],
            [31.53417202670239, 0.879962703101607],
            [31.53493119474561, 0.878669660471176],
            [31.536518637328587, 0.869463125085391],
            [31.53974467166848, 0.861668131896979],
            [31.541263586270013, 0.860429639615714],
            [31.5423085596091, 0.857680547816595],
            [31.543267808517268, 0.856640811237147],
            [31.551794124019015, 0.856788786746795],
            [31.555990228373016, 0.856383386436177],
            [31.558729271624358, 0.855507115683005],
            [31.56316766149191, 0.855951976469756],
            [31.56596384029027, 0.853972291141039],
            [31.566605726984967, 0.853909222040545],
            [31.5726432896365, 0.854806897629423],
            [31.575284495573598, 0.854310439623277],
            [31.57962111979423, 0.851363541882455],
            [31.582146212192665, 0.850523336963564],
            [31.583747070216063, 0.849420495142812],
            [31.586077372826622, 0.849159064710954],
            [31.589064828101787, 0.847016602786017],
            [31.592620725610654, 0.843707589246472],
            [31.595600129285934, 0.839738096493157],
            [31.599091350789283, 0.839811718098576],
            [31.603201924748433, 0.836900833341171],
            [31.604904768506074, 0.836403990403457],
            [31.606280239224724, 0.836648689658498],
            [31.609106440618188, 0.83393630651389],
            [31.612648638818957, 0.833611961006765],
            [31.61577741974958, 0.834399960533717],
            [31.61740096203055, 0.833468933807649],
            [31.618656417827246, 0.832465418673848],
            [31.619737786410074, 0.828241928081628],
            [31.620432693469457, 0.827527641678252],
            [31.622428229007912, 0.827528342291107],
            [31.626786793681017, 0.831753754041062],
            [31.62897156292731, 0.831817833998582],
            [31.62978173282083, 0.831519642707126],
            [31.631314777921776, 0.830027797571508],
            [31.633244281896925, 0.829377250163216],
            [31.634666449738987, 0.826962796787451],
            [31.63547954185211, 0.82632994654148],
            [31.63842556592807, 0.826285743246998],
            [31.63964125690039, 0.825797746460138],
            [31.643679351189128, 0.823022391368734],
            [31.64905960486915, 0.820247479864838],
            [31.654620397463443, 0.815817407205005],
            [31.65946282349464, 0.82183386213905],
            [31.659536973133157, 0.824285040652836],
            [31.660605357466864, 0.82850934835273],
            [31.661919952053648, 0.830354946720865],
            [31.66247415329513, 0.832245511841415],
            [31.663206284743275, 0.832743229272884],
            [31.66364699283177, 0.833964436073692],
            [31.666749427073423, 0.83649806363253],
            [31.667805530538878, 0.838008919819794],
            [31.671725281670405, 0.840759910970302],
            [31.673909393349955, 0.843727387765165],
            [31.676366352127342, 0.845293001884489],
            [31.677848435802208, 0.848414006521235],
            [31.678702458752944, 0.851317718488862],
            [31.681292895503447, 0.871316942278737],
            [31.680842414642964, 0.873975990236725],
            [31.679369509055373, 0.87677034627818],
            [31.675436184379873, 0.880613026368281],
            [31.66942313136255, 0.885685042208836],
            [31.663936119199207, 0.891182323225755],
            [31.66097241627846, 0.896382024210516],
            [31.654882609406645, 0.905406505861896],
            [31.651040245441905, 0.9143956055756],
            [31.65075543817431, 0.929651549186728],
            [31.647698363464634, 0.928911210200027],
            [31.63554309945508, 0.929646527367096],
            [31.63088701096324, 0.929546036182648],
            [31.62770602354159, 0.928782379973009],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1402,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "NTWETWE",
        Population: 17489,
        Key: "KYANKWANZINTWETWE",
        Dist2: "Kyankwanzi",
        "Sub Country": "Ntwetwe T/C",
        id2_original: "KyankwanziNtwetwe T/C",
        drought: "M",
        "Animal Vectors and diseases": "VH",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.51465909435067, 0.393664064538493],
            [32.51390383038567, 0.39319384979375],
            [32.51268532499159, 0.390276457637982],
            [32.51185728581043, 0.389262499638405],
            [32.51212603299735, 0.386235806991173],
            [32.5133645717206, 0.384072871659372],
            [32.5129866819216, 0.381435126500397],
            [32.51450861845577, 0.377988292787816],
            [32.514938729118846, 0.375406668611923],
            [32.51531519418982, 0.375332005841109],
            [32.515708223296265, 0.374023240558478],
            [32.51515962394891, 0.369731299113105],
            [32.51745110945769, 0.364901979931504],
            [32.51981911076747, 0.364014499216756],
            [32.52073862539396, 0.363203020649185],
            [32.523963303277796, 0.358841225986525],
            [32.531873705074695, 0.350510780664405],
            [32.5333349199872, 0.347759261491368],
            [32.53701085307926, 0.344431344353464],
            [32.53848111312836, 0.344866079763266],
            [32.54189889556063, 0.347136785360732],
            [32.54809072499757, 0.349133410529143],
            [32.55354487768612, 0.348551437877659],
            [32.553902048741435, 0.352268989561299],
            [32.55636006842916, 0.356758664542068],
            [32.55635330231845, 0.358311180043486],
            [32.555398667157576, 0.360884303190183],
            [32.55420685969372, 0.368052738371083],
            [32.54991184274213, 0.375051105081218],
            [32.54969780115938, 0.375924797645853],
            [32.55512117397305, 0.378777614435479],
            [32.554670256531374, 0.380443702088957],
            [32.55118678479396, 0.381208974348045],
            [32.54845728524421, 0.379334348420219],
            [32.548284337094124, 0.377873860689862],
            [32.54675385758163, 0.375765688771062],
            [32.542852982749146, 0.376013358846373],
            [32.53997006172865, 0.376989880138299],
            [32.539285791620536, 0.376614646687264],
            [32.5378392452983, 0.374449279951721],
            [32.53536971729346, 0.372574295047154],
            [32.533196482415406, 0.372667784334939],
            [32.530333630656635, 0.378522735615997],
            [32.526597812274474, 0.381263626640076],
            [32.52549523177285, 0.382883378847104],
            [32.51955373226287, 0.387259394175302],
            [32.51535306626388, 0.393169207789097],
            [32.51465909435067, 0.393664064538493],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1403,
        District: "WAKISO",
        County: "NANSANA MUNICIPALITY",
        Subcounty: "NANSANA DIVISION",
        Population: 144490,
        Key: "WAKISONANSANA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.557498331810514, 0.273045706859619],
            [32.54742107676734, 0.271412129073012],
            [32.541748477157874, 0.271292313124145],
            [32.53731452317116, 0.27515308009543],
            [32.53630098547714, 0.276867667396841],
            [32.535336686240456, 0.277380262559978],
            [32.535126154375504, 0.279039873295772],
            [32.53318845956159, 0.28184054066463],
            [32.53156191780588, 0.283413164370346],
            [32.530456026114095, 0.286095132376733],
            [32.52996607058509, 0.288696044899081],
            [32.53019903517932, 0.289318780572768],
            [32.52668129001888, 0.297055028],
            [32.52753759469041, 0.297496660798699],
            [32.52113525764304, 0.298483785452428],
            [32.52209956855782, 0.294914511377138],
            [32.52165981358184, 0.287054990912637],
            [32.52231082356656, 0.284052068909151],
            [32.52797082071091, 0.271704000108663],
            [32.529499862918954, 0.269228451329229],
            [32.53059801652288, 0.267729375410625],
            [32.5369747434998, 0.262061147397855],
            [32.538458683094035, 0.258774603250806],
            [32.540201465949195, 0.256371251469116],
            [32.54136789061639, 0.251950904637307],
            [32.54146564438731, 0.248031397427645],
            [32.54288968072513, 0.240387184687234],
            [32.542928338825064, 0.236824280672371],
            [32.54376104834736, 0.237723083221111],
            [32.543927142351826, 0.239498983238607],
            [32.545246132395306, 0.240325259868005],
            [32.55075537157369, 0.241619468319449],
            [32.55618265834709, 0.241312967663025],
            [32.55932769429276, 0.248197047009496],
            [32.561956240272565, 0.249172309980894],
            [32.56380469375126, 0.248856069156695],
            [32.56421868234992, 0.25006161750279],
            [32.565951217224324, 0.250033068416608],
            [32.566747392264, 0.250646282220648],
            [32.56681673681404, 0.252574902521562],
            [32.567607141076365, 0.255823484043652],
            [32.567945152863246, 0.257123154473967],
            [32.56857780308019, 0.257866834339691],
            [32.568171942438205, 0.260114986405567],
            [32.56780381373309, 0.261182657208857],
            [32.56722340863474, 0.261108671832241],
            [32.566764304845854, 0.261674291062973],
            [32.56608038687737, 0.261751937931151],
            [32.56628264615684, 0.263014251705091],
            [32.56431741169121, 0.264878141818583],
            [32.56375225818978, 0.266550868636196],
            [32.56079416884127, 0.269407400045107],
            [32.560110644334834, 0.270832432947482],
            [32.557498331810514, 0.273045706859619],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1404,
        District: "WAKISO",
        County: "MAKINDYE SSABAGABO MUNICIPALITY",
        Subcounty: "BUNAMWAYA DIVISION",
        Population: 72533,
        Key: "WAKISOBUNAMWAYA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.63425030793898, 0.214319319945125],
            [32.61592283998651, 0.226315376658775],
            [32.61201553141995, 0.239442673735146],
            [32.610454267541016, 0.243414323009625],
            [32.60934913941723, 0.245133246260071],
            [32.60653427566098, 0.247621124505642],
            [32.60635200299825, 0.248019193928851],
            [32.607358306559284, 0.247877228205627],
            [32.60717276223229, 0.248711451640711],
            [32.60628706468467, 0.250844281589602],
            [32.60565378025714, 0.251390631697896],
            [32.60498847448298, 0.254292327101534],
            [32.6041520558169, 0.254866007138565],
            [32.6034834379543, 0.256562199046218],
            [32.60258101826765, 0.257047736275159],
            [32.601426984063146, 0.258555919606578],
            [32.59804278155455, 0.260439788708098],
            [32.596479651874745, 0.262172289394996],
            [32.59445691265455, 0.26258387068474],
            [32.59221681167831, 0.263587152516339],
            [32.59187856273616, 0.264918673370995],
            [32.586585142906465, 0.267722966899362],
            [32.58559183796756, 0.26897753307838],
            [32.58458236425188, 0.26940098524658],
            [32.58266214975505, 0.272174705727526],
            [32.58028906308247, 0.273994265787003],
            [32.579513224104176, 0.275319987844333],
            [32.57823619526596, 0.276464260265404],
            [32.57650090256363, 0.279318321677181],
            [32.56513074095957, 0.274309270808422],
            [32.557498331810514, 0.273045706859619],
            [32.560110644334834, 0.270832432947482],
            [32.56079416884127, 0.269407400045107],
            [32.56375225818978, 0.266550868636196],
            [32.56431741169121, 0.264878141818583],
            [32.56628264615684, 0.263014251705091],
            [32.56608038687737, 0.261751937931151],
            [32.566764304845854, 0.261674291062973],
            [32.56722340863474, 0.261108671832241],
            [32.56780381373309, 0.261182657208857],
            [32.568171942438205, 0.260114986405567],
            [32.568254846159135, 0.259820461500005],
            [32.5694615944028, 0.259970065388344],
            [32.57236792012971, 0.259424243848682],
            [32.57624961233764, 0.256854996584339],
            [32.57862339969613, 0.255857652921473],
            [32.58162903058443, 0.253311495910249],
            [32.58369904274815, 0.248470886868562],
            [32.584084473005646, 0.244932403663862],
            [32.58473752396267, 0.243153541738594],
            [32.59147998383787, 0.23379394112759],
            [32.59286365527672, 0.228999649098897],
            [32.59395310061228, 0.227592403563309],
            [32.59371814085983, 0.226996003264366],
            [32.59111856824288, 0.225047988490485],
            [32.59110799866523, 0.223506645781776],
            [32.59574543453851, 0.21539139869826],
            [32.596003447756104, 0.214156920948406],
            [32.595361829657676, 0.208354442833608],
            [32.596230183432134, 0.207037798857261],
            [32.59708092393881, 0.207001508953302],
            [32.59834336413684, 0.201987170129448],
            [32.59945948943632, 0.199942292829748],
            [32.60149163491585, 0.199773338718962],
            [32.620680819889465, 0.188950712261512],
            [32.62594921175706, 0.186453746937607],
            [32.63425030793898, 0.214319319945125],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1405,
        District: "WAKISO",
        County: "MAKINDYE SSABAGABO MUNICIPALITY",
        Subcounty: "MASAJJA DIVISION",
        Population: 117248,
        Key: "WAKISOMASAJJA DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.68705482993339, 0.289783324915147],
            [32.68531735342662, 0.325800227732305],
            [32.68400451594452, 0.339358842292465],
            [32.684558839356924, 0.352596858555775],
            [32.68344660825419, 0.362669722225758],
            [32.68365784709325, 0.367499834009425],
            [32.68336539965418, 0.369859993571772],
            [32.6812635808412, 0.373049296147516],
            [32.67839069310412, 0.375699611017945],
            [32.6770755137141, 0.378199710279882],
            [32.67572896964592, 0.383203878001722],
            [32.67249312480479, 0.386527485128157],
            [32.66921975104602, 0.381494250505387],
            [32.66718121944312, 0.379549023997468],
            [32.66679742142452, 0.376753426212896],
            [32.66639500222837, 0.376174390069907],
            [32.66416378738692, 0.374980074118289],
            [32.66116567899081, 0.371876770643852],
            [32.65893348139243, 0.367117862928472],
            [32.65856818058385, 0.363735771079892],
            [32.65661169840405, 0.360532973655098],
            [32.65522908248565, 0.35958272486665],
            [32.65150062579724, 0.359326276171225],
            [32.651369078303645, 0.35627043963679],
            [32.653771313510546, 0.34843645834312],
            [32.65415791337453, 0.345007335485187],
            [32.65648986529197, 0.337922499868823],
            [32.65551641132423, 0.33417719322334],
            [32.65517854506437, 0.328406470985919],
            [32.66139564321197, 0.326287989762707],
            [32.66541477855664, 0.323899668378892],
            [32.66687643633861, 0.318199982417876],
            [32.666785269913674, 0.315006318220757],
            [32.66559795492454, 0.313015897937924],
            [32.66173123314085, 0.309487367567615],
            [32.66150293888782, 0.308673113204091],
            [32.66276536201784, 0.306682770778238],
            [32.663588584432425, 0.303787696210754],
            [32.664399382248284, 0.302973474651496],
            [32.66460836901093, 0.30152592888306],
            [32.663785282241975, 0.300078352379844],
            [32.663380132167354, 0.296975153573129],
            [32.666045627651435, 0.294288217833301],
            [32.667652110026864, 0.290850331908755],
            [32.66750730968789, 0.2870595533987],
            [32.66447635439342, 0.283476774195569],
            [32.66283939846862, 0.282282497445813],
            [32.66284223624658, 0.281305400050824],
            [32.668758788642805, 0.274592553079941],
            [32.67206213648766, 0.278962442131259],
            [32.67421889446679, 0.281133832881306],
            [32.684837962085346, 0.287783828949597],
            [32.68705482993339, 0.289783324915147],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1406,
        District: "WAKISO",
        County: "KIRA MUNICIPALITY",
        Subcounty: "BWEYOGERERE DIVISION",
        Population: 106842,
        Key: "WAKISOBWEYOGERERE DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.67249312480479, 0.386527485128157],
            [32.674153782778376, 0.389125535768612],
            [32.674151400446235, 0.389912549567833],
            [32.67486109108025, 0.39108335058376],
            [32.67454451040109, 0.393562686661066],
            [32.672141177452865, 0.398170077101703],
            [32.669432179254514, 0.401655597432631],
            [32.666918658953584, 0.407278666655759],
            [32.664850553913205, 0.407197152890934],
            [32.663653381710496, 0.406111440452304],
            [32.66203772843433, 0.405749483274413],
            [32.659903425642376, 0.403976145379008],
            [32.65593280650955, 0.400112829001374],
            [32.651675313984, 0.392892996710976],
            [32.64651859618094, 0.392069482800886],
            [32.64243354695228, 0.389393581473358],
            [32.64098326184183, 0.392551109538422],
            [32.63733403656148, 0.388499437906676],
            [32.63367765170829, 0.386830969543866],
            [32.63305640740053, 0.384438845160498],
            [32.63405486597421, 0.382288958011104],
            [32.63355954570633, 0.37988927050709],
            [32.63387243161474, 0.378399694259169],
            [32.63433531731094, 0.377812825985098],
            [32.63383585850458, 0.374562671867709],
            [32.63389450861114, 0.368862959782783],
            [32.63461718349427, 0.364846498409644],
            [32.636884619306294, 0.360983003623613],
            [32.63960757193429, 0.350544152452676],
            [32.63926814080922, 0.346603448282443],
            [32.63977789700372, 0.345548535463917],
            [32.638656988175356, 0.344445191633336],
            [32.63890772324251, 0.343516249759527],
            [32.63846481338326, 0.34333990645055],
            [32.6389900080242, 0.342425436968407],
            [32.63730105042426, 0.340596392641595],
            [32.638332518491346, 0.338645520577605],
            [32.6396797830084, 0.337996636539528],
            [32.64050951910708, 0.335276054812002],
            [32.643779132518056, 0.334602117861976],
            [32.63907535516274, 0.331831228583515],
            [32.64173776403549, 0.328924662818367],
            [32.64601932152918, 0.325916954729124],
            [32.647344382387345, 0.326707771069099],
            [32.64867457442239, 0.326853465557043],
            [32.65076225015953, 0.328340348880428],
            [32.65517854506437, 0.328406470985919],
            [32.65551641132423, 0.33417719322334],
            [32.65648986529197, 0.337922499868823],
            [32.65415791337453, 0.345007335485187],
            [32.653771313510546, 0.34843645834312],
            [32.651369078303645, 0.35627043963679],
            [32.65150062579724, 0.359326276171225],
            [32.65522908248565, 0.35958272486665],
            [32.65661169840405, 0.360532973655098],
            [32.65856818058385, 0.363735771079892],
            [32.65893348139243, 0.367117862928472],
            [32.66116567899081, 0.371876770643852],
            [32.66416378738692, 0.374980074118289],
            [32.66639500222837, 0.376174390069907],
            [32.66679742142452, 0.376753426212896],
            [32.66718121944312, 0.379549023997468],
            [32.66921975104602, 0.381494250505387],
            [32.67249312480479, 0.386527485128157],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1407,
        District: "WAKISO",
        County: "KIRA MUNICIPALITY",
        Subcounty: "NAMUGONGO DIVISION",
        Population: 149816,
        Key: "WAKISONAMUGONGO DIVISION",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.53073465309338, 1.169898803280289],
            [34.52224305927395, 1.175264532022578],
            [34.516037637428454, 1.176581157036026],
            [34.512971375648355, 1.179457718934972],
            [34.51078689655786, 1.182759707503705],
            [34.50782606465277, 1.184997353530176],
            [34.50585183176298, 1.185850256959679],
            [34.50363249714114, 1.189933110711603],
            [34.500354653365555, 1.192845298868513],
            [34.49679406305765, 1.194586393137571],
            [34.490449062779916, 1.198848996877109],
            [34.48702895640603, 1.199596225202149],
            [34.48491409854671, 1.201301042001326],
            [34.48325838939204, 1.204354326613098],
            [34.47920439851599, 1.206699077847627],
            [34.47381161782934, 1.211316119758084],
            [34.46858962214954, 1.214163005723987],
            [34.466268120333844, 1.21664421222479],
            [34.46263696915699, 1.218491844199924],
            [34.458863532025646, 1.21806799360896],
            [34.45625361979977, 1.217324056559419],
            [34.45251615750062, 1.218248921018355],
            [34.44662699922898, 1.218074648621036],
            [34.44542896194863, 1.219814475676473],
            [34.44342136832413, 1.224394214608218],
            [34.44105998849632, 1.226844553530277],
            [34.434819815324055, 1.229793900816682],
            [34.43418567300542, 1.230930041784098],
            [34.428545739732954, 1.235334307596401],
            [34.42600699204387, 1.235868093546262],
            [34.42082504864931, 1.239491259412042],
            [34.42012136415129, 1.242508622255712],
            [34.41888839318618, 1.244922871266733],
            [34.41899518580549, 1.246768491643734],
            [34.41748059389709, 1.250105731963197],
            [34.41617611883198, 1.250709835359155],
            [34.411802889161855, 1.249966845955288],
            [34.40739535013609, 1.251034052590683],
            [34.40513941365805, 1.252951953193777],
            [34.40133129167527, 1.253876851051724],
            [34.39939217931981, 1.254765249804131],
            [34.39577002566885, 1.255069762224826],
            [34.39060777873523, 1.256475918455718],
            [34.38904502365291, 1.250951896989982],
            [34.390963167532995, 1.246350784085168],
            [34.39068435831659, 1.241003357204914],
            [34.391523869882214, 1.230922133045214],
            [34.3945148761977, 1.229012861661304],
            [34.39766457619634, 1.228035096906577],
            [34.400974274231906, 1.228015259475891],
            [34.4029488125489, 1.226621347300853],
            [34.40865804815062, 1.227088637189309],
            [34.40977837037908, 1.226825751610852],
            [34.412117252798915, 1.225169353631983],
            [34.41463389384716, 1.221911980626631],
            [34.41810401033123, 1.218346587129285],
            [34.418927382764466, 1.217324121223545],
            [34.41999120365652, 1.21430268483659],
            [34.42117634023109, 1.213424735594847],
            [34.42845621991994, 1.212131035534877],
            [34.430896882359775, 1.210813352500091],
            [34.433860984132494, 1.210065822790705],
            [34.43564841954548, 1.210108749092523],
            [34.43821927571775, 1.207694013334515],
            [34.44048625608394, 1.207736681914605],
            [34.440747549050606, 1.207209991778726],
            [34.44610932258861, 1.20637341645313],
            [34.449813584053175, 1.203870319731464],
            [34.45024876840102, 1.202422076951369],
            [34.451163636940855, 1.201236853518455],
            [34.45216618195076, 1.200973041262935],
            [34.45242738149267, 1.200270836876815],
            [34.45465041986841, 1.199699219622256],
            [34.455042332369, 1.198865308507912],
            [34.45770080482417, 1.19732811784832],
            [34.45831113190631, 1.197327790932971],
            [34.459161925413575, 1.196067645059576],
            [34.46258065107686, 1.192103917268589],
            [34.46397516877447, 1.191137835441374],
            [34.46833438921775, 1.190696708824545],
            [34.47003429548438, 1.190169251108981],
            [34.472388628028796, 1.190606768260571],
            [34.476180471640305, 1.188981216653048],
            [34.477443514607856, 1.186742730510164],
            [34.47888147123933, 1.185513357572273],
            [34.47944598244538, 1.181344596200017],
            [34.481231897010574, 1.178623171221359],
            [34.485894872885694, 1.175636936478383],
            [34.486766262965816, 1.174715023267046],
            [34.49261981112127, 1.172902738154848],
            [34.49870758600393, 1.168390138190209],
            [34.49909936824877, 1.167336852392725],
            [34.5025414590926, 1.163956391276178],
            [34.50594108836959, 1.162725978157088],
            [34.507248257482225, 1.161540568933059],
            [34.50960175549174, 1.160530110648327],
            [34.51160624813189, 1.159037182992741],
            [34.513262928365386, 1.159299557725047],
            [34.516357919166595, 1.15907849793907],
            [34.524912138137715, 1.157619188393154],
            [34.52649745979828, 1.162801335780386],
            [34.529097453725136, 1.16769276017553],
            [34.53073465309338, 1.169898803280289],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1408,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BULAAGO",
        Population: 9469,
        Key: "BULAMBULIBULAAGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.352409945905606, 1.399221932438653],
            [34.34943131837475, 1.400046755626429],
            [34.34442500639801, 1.405910683389707],
            [34.3407770998445, 1.414197856245166],
            [34.33730003399339, 1.41873133405423],
            [34.334081846437506, 1.42511886753453],
            [34.328854835463474, 1.428269518307376],
            [34.324801164387694, 1.434286721981235],
            [34.32309158416372, 1.438584036138173],
            [34.32251044244688, 1.442844517563925],
            [34.32077186640219, 1.444600240981035],
            [34.3181485252611, 1.451068879394757],
            [34.315682342582384, 1.464058810942813],
            [34.31516335889328, 1.464240882207557],
            [34.31476538815443, 1.463480980390427],
            [34.31377121364634, 1.462861453606492],
            [34.31373078496697, 1.461701264802268],
            [34.311444568077334, 1.460942473877972],
            [34.30837811944763, 1.461378632066026],
            [34.3077232880297, 1.46036314641615],
            [34.30495637364834, 1.459668708323287],
            [34.30123872638773, 1.463470999771006],
            [34.30006149768265, 1.464186563552887],
            [34.29936980120209, 1.46407409258363],
            [34.29923966855506, 1.465315792677547],
            [34.298005959174795, 1.465335327339667],
            [34.296174817129966, 1.466634458769894],
            [34.29544551717161, 1.466145759282926],
            [34.2940999935896, 1.466767356893049],
            [34.29305246184858, 1.465488714797573],
            [34.29241705739697, 1.46575246009131],
            [34.292025060454755, 1.466712128604442],
            [34.290922293103534, 1.466900895297237],
            [34.290211663730055, 1.466374557110404],
            [34.2896698304934, 1.46682637482859],
            [34.28912943905276, 1.469787785430382],
            [34.28754066426822, 1.469995649149265],
            [34.287429112374554, 1.471049218120508],
            [34.28520611711798, 1.473590210552039],
            [34.2853936619931, 1.474662417979203],
            [34.285076359068434, 1.475490356977914],
            [34.2856937127727, 1.476336564030176],
            [34.28567540870048, 1.477013828659306],
            [34.28490897687986, 1.476976649864794],
            [34.284516760748716, 1.477560068872612],
            [34.28531378110307, 1.478590880330099],
            [34.28432873168166, 1.479675005605958],
            [34.282888409786025, 1.480164206810021],
            [34.281115114753916, 1.48176767763568],
            [34.28008409314952, 1.482027720282557],
            [34.27864504057337, 1.48472980920316],
            [34.27861553091629, 1.486149128363209],
            [34.277964088841934, 1.487233062252161],
            [34.27615945608112, 1.48709676278269],
            [34.27421788503673, 1.486166953923411],
            [34.2728226711448, 1.485999888457037],
            [34.27098810741703, 1.486565624111388],
            [34.26845506582664, 1.48552931962614],
            [34.265632191792996, 1.481492788974294],
            [34.264707132764556, 1.48143227443649],
            [34.26378156888292, 1.480486600651916],
            [34.2622649171376, 1.480105937274856],
            [34.26150600691085, 1.478885460149467],
            [34.260762729166686, 1.478489088397965],
            [34.26004947761088, 1.477558549428539],
            [34.26001858095497, 1.476551314030488],
            [34.25889526643829, 1.474506924401705],
            [34.25686281463324, 1.473745010923532],
            [34.2554959659447, 1.472760970515899],
            [34.254288267283464, 1.471352679449148],
            [34.25412659299022, 1.47000209513429],
            [34.253160514190945, 1.469014739381493],
            [34.25277372568073, 1.467978468018656],
            [34.25201720946421, 1.467638798041592],
            [34.25021308155663, 1.464376489804823],
            [34.248796244317475, 1.463049282190275],
            [34.2477178419717, 1.462628811883632],
            [34.24739612652236, 1.462855723324847],
            [34.24618857428651, 1.461690346638965],
            [34.245898390601994, 1.460734993672882],
            [34.244868309533665, 1.460395468975999],
            [34.243597169152146, 1.460639106328756],
            [34.24354829630909, 1.459554056725838],
            [34.24277591225141, 1.459619266725273],
            [34.24224423357071, 1.458453507598534],
            [34.241616516901296, 1.458227124649135],
            [34.24090881244239, 1.458859131654029],
            [34.23988886526878, 1.459078347410165],
            [34.23904157698775, 1.458757997074813],
            [34.23961939044648, 1.457873618230269],
            [34.238535984484606, 1.457852117727565],
            [34.23821364829941, 1.457402899780604],
            [34.23861594262972, 1.456820672582873],
            [34.23845452615294, 1.456142984260949],
            [34.23996940552221, 1.455398062364095],
            [34.239793409388376, 1.454830889151624],
            [34.23887826955731, 1.45462511642836],
            [34.239594451417595, 1.452429309384068],
            [34.23901527072299, 1.45080885649959],
            [34.23969582899233, 1.45040328757262],
            [34.24023063740348, 1.451198644322669],
            [34.24071360673452, 1.45114659915819],
            [34.24134956724327, 1.449253099081411],
            [34.24270484563096, 1.448868737706994],
            [34.242746545426456, 1.447093753975931],
            [34.2431417834902, 1.446997763677112],
            [34.24432117354188, 1.448536842668281],
            [34.24519040946196, 1.448785954782851],
            [34.244906248083076, 1.44754932213659],
            [34.24515463585237, 1.446635660466323],
            [34.246031685318776, 1.447428715993788],
            [34.246829053321164, 1.445789892138352],
            [34.247489646533325, 1.4464059859545],
            [34.24827984508145, 1.445713038789479],
            [34.249429316742585, 1.446088124057388],
            [34.24885972197037, 1.443953813016996],
            [34.249185203157374, 1.442308256812689],
            [34.249566399654924, 1.442433955959055],
            [34.24993307668255, 1.443656695273121],
            [34.25114757379386, 1.442885218100291],
            [34.25172594510638, 1.441500992647728],
            [34.25523737780533, 1.441404902431248],
            [34.25526621642088, 1.439987299836895],
            [34.2546667832082, 1.439226435259744],
            [34.25488613203767, 1.438762185951908],
            [34.256006215314265, 1.438953108460883],
            [34.25585306693137, 1.439807264252371],
            [34.25616705776756, 1.440147107247095],
            [34.25852686823858, 1.438856040180058],
            [34.259194886026584, 1.43910893227391],
            [34.25957420055361, 1.44014697793054],
            [34.26025241781332, 1.439923203729168],
            [34.26018745434693, 1.438639287565171],
            [34.25919703030515, 1.437573688686131],
            [34.25965059777693, 1.437065106758189],
            [34.26018869851361, 1.437428042171763],
            [34.26051403417352, 1.436453158428982],
            [34.261553552942225, 1.436570453207903],
            [34.26142127691496, 1.435634907448411],
            [34.262068487025985, 1.435150752498124],
            [34.26221834667664, 1.434138944222997],
            [34.26308771195411, 1.434285120786903],
            [34.26368992185934, 1.433571217004981],
            [34.263768365444875, 1.432866085000412],
            [34.26287595658374, 1.43195792239822],
            [34.26389287014662, 1.430903864648855],
            [34.2629114885465, 1.427384418158697],
            [34.2636634188635, 1.42628483142874],
            [34.26361178729423, 1.425570252528631],
            [34.26524084343442, 1.424186330022782],
            [34.265147939667735, 1.423631861672036],
            [34.264255007088785, 1.423838633115944],
            [34.263866653713364, 1.423124241147045],
            [34.262834390637245, 1.422874330573952],
            [34.26327532510121, 1.42163771355099],
            [34.26286187010179, 1.419566494849993],
            [34.26327897226126, 1.419308416221023],
            [34.26374100635458, 1.420179667213694],
            [34.2640839795368, 1.418946986652754],
            [34.26512938047397, 1.419792032091339],
            [34.26546727727652, 1.418599971467368],
            [34.26727373900723, 1.419187155715837],
            [34.267736574397794, 1.418760794253099],
            [34.26703363909471, 1.418370727898507],
            [34.26754746914901, 1.416850341113607],
            [34.26703938651591, 1.415482832271469],
            [34.267885259950376, 1.415880710273167],
            [34.268217640198756, 1.414988588977808],
            [34.268883845186515, 1.41514292905418],
            [34.27014245676477, 1.414353959229804],
            [34.271701814418705, 1.414714083762377],
            [34.27220674935508, 1.414448590361581],
            [34.271752467722635, 1.413638465128698],
            [34.27301822809394, 1.412540074338178],
            [34.27328030079829, 1.411386988633514],
            [34.271618221689934, 1.409070962174572],
            [34.2733016645324, 1.408790087334069],
            [34.27323780689209, 1.406584085822213],
            [34.27381161476296, 1.406594979103178],
            [34.27409063508348, 1.405872299156034],
            [34.27505671837434, 1.405591819070124],
            [34.273819132763606, 1.404916437957796],
            [34.273892028353934, 1.404089581514583],
            [34.2743896617837, 1.403860929225575],
            [34.27541307825091, 1.404278480900046],
            [34.27575701173215, 1.403622466662584],
            [34.27558947413505, 1.402644706587902],
            [34.274981615623304, 1.402085143865992],
            [34.2759695360604, 1.401583642412803],
            [34.27594708446651, 1.400677507909697],
            [34.27509198892731, 1.3993379772261],
            [34.27536732974842, 1.397944650911911],
            [34.27431373976914, 1.39775551842131],
            [34.27386733636172, 1.396551687480475],
            [34.274895167150255, 1.395151739994572],
            [34.27878599881786, 1.390856684809225],
            [34.28008873564288, 1.388397343171127],
            [34.285873904038915, 1.384715670195166],
            [34.28850493745375, 1.383616479172251],
            [34.29297201681657, 1.384694882963425],
            [34.294039716634025, 1.38456444166565],
            [34.294305321514095, 1.384941326643523],
            [34.296156712483736, 1.384778516837889],
            [34.29635266648822, 1.385298592701579],
            [34.29780475900903, 1.385543736836707],
            [34.29827263394834, 1.384897652536167],
            [34.30026373719919, 1.38658487417525],
            [34.30124224508873, 1.385921309566988],
            [34.305335418680805, 1.387645737662658],
            [34.30701555662131, 1.385905211077945],
            [34.30757094723226, 1.384593509845235],
            [34.30852066501522, 1.384535577343748],
            [34.3092949508064, 1.383672490760087],
            [34.311795728505025, 1.383158335406727],
            [34.312463846904336, 1.383412084013204],
            [34.313830163790236, 1.382376322827639],
            [34.31533002153131, 1.382644646929881],
            [34.31624658968368, 1.381756272252064],
            [34.316496625861554, 1.380756533104642],
            [34.32054895395601, 1.380209805575935],
            [34.32107116978348, 1.378916093731581],
            [34.32337883934043, 1.377407551000384],
            [34.32540772034225, 1.388153215926028],
            [34.326278611857376, 1.389106741826715],
            [34.32801568232563, 1.388832493113487],
            [34.331268612225145, 1.38705977582789],
            [34.33295242068193, 1.387836676946792],
            [34.33616443681181, 1.390367402533982],
            [34.33883935472492, 1.393658189768777],
            [34.34071241305921, 1.394362610751206],
            [34.34557684871319, 1.393808078724409],
            [34.3484143545062, 1.392612530274403],
            [34.34973143383308, 1.39249418794316],
            [34.351684128715625, 1.394962283083516],
            [34.35347900307747, 1.396526939959291],
            [34.35366453033648, 1.397542113472388],
            [34.352409945905606, 1.399221932438653],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1409,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BWIKHONGE",
        Population: 7765,
        Key: "BULAMBULIBWIKHONGE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.354451526390584, 1.263507202849083],
            [34.35328447020776, 1.264570358024562],
            [34.350588420325906, 1.264868468566235],
            [34.34901399522973, 1.266404949383576],
            [34.34717822416623, 1.266887983911085],
            [34.34529839073805, 1.266623783004374],
            [34.34242860668028, 1.267058824158869],
            [34.33987351324628, 1.26780452902303],
            [34.34021566177507, 1.266206815059386],
            [34.33978059959813, 1.26554676925042],
            [34.33689427575933, 1.264508115446089],
            [34.333833992267444, 1.264871496947281],
            [34.33344908662608, 1.2623391387025],
            [34.335078593720546, 1.261515214258984],
            [34.34227448811686, 1.255967005953692],
            [34.344328432115084, 1.254826294550122],
            [34.346762644651164, 1.252654278664734],
            [34.34808731743712, 1.252138038713346],
            [34.35015359350757, 1.252064607298442],
            [34.351572588500055, 1.251485003511747],
            [34.35206128099778, 1.250693379449598],
            [34.35336607316816, 1.252420698853906],
            [34.35583124524221, 1.252834381058689],
            [34.35656898936421, 1.253308860103811],
            [34.35762911638384, 1.252796700352182],
            [34.35828629240467, 1.2529433332252],
            [34.35974742467217, 1.254299472714231],
            [34.36126235255049, 1.254622739311846],
            [34.364693820816065, 1.254547453390235],
            [34.36864719319375, 1.253853789635163],
            [34.373259159133795, 1.252444321596006],
            [34.37386823216779, 1.253234029481295],
            [34.37484286292856, 1.250995523152717],
            [34.37665309309185, 1.24949206544156],
            [34.38095565050196, 1.248141119886251],
            [34.38288219362997, 1.249941284189709],
            [34.38424529814041, 1.251887283575658],
            [34.385144490180224, 1.252298089248008],
            [34.38716018211702, 1.251940567899329],
            [34.38716792020489, 1.251258224916229],
            [34.38767483143487, 1.250914641058318],
            [34.38904502365291, 1.250951896989982],
            [34.39060777873523, 1.256475918455718],
            [34.39083912726025, 1.256949020054303],
            [34.38813118997226, 1.258035074935739],
            [34.38649428884469, 1.258242972215255],
            [34.38484569344874, 1.259519167434104],
            [34.38343162122405, 1.259789135751416],
            [34.38117905073333, 1.260912475774801],
            [34.38014720357717, 1.261054370726644],
            [34.377375625142875, 1.25966060443179],
            [34.375357835639896, 1.259801449575105],
            [34.372539185484705, 1.260332778752441],
            [34.36713463776614, 1.262680936538379],
            [34.36459504476239, 1.262898731374864],
            [34.363261579266414, 1.262628528976745],
            [34.36200794076154, 1.263117039006501],
            [34.36052845950607, 1.262539865230417],
            [34.35734775685034, 1.262788425293607],
            [34.35608126614869, 1.262137689190739],
            [34.35547931944985, 1.263112786517185],
            [34.354451526390584, 1.263507202849083],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1410,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "LUSHA",
        Population: 8814,
        Key: "BULAMBULILUSHA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.32337883934043, 1.377407551000384],
            [34.32107116978348, 1.378916093731581],
            [34.32054895395601, 1.380209805575935],
            [34.316496625861554, 1.380756533104642],
            [34.31624658968368, 1.381756272252064],
            [34.31533002153131, 1.382644646929881],
            [34.313830163790236, 1.382376322827639],
            [34.312463846904336, 1.383412084013204],
            [34.311795728505025, 1.383158335406727],
            [34.3092949508064, 1.383672490760087],
            [34.30852066501522, 1.384535577343748],
            [34.30757094723226, 1.384593509845235],
            [34.30701555662131, 1.385905211077945],
            [34.305335418680805, 1.387645737662658],
            [34.30124224508873, 1.385921309566988],
            [34.30026373719919, 1.38658487417525],
            [34.29827263394834, 1.384897652536167],
            [34.29780475900903, 1.385543736836707],
            [34.29635266648822, 1.385298592701579],
            [34.296156712483736, 1.384778516837889],
            [34.294305321514095, 1.384941326643523],
            [34.294039716634025, 1.38456444166565],
            [34.29297201681657, 1.384694882963425],
            [34.28850493745375, 1.383616479172251],
            [34.285873904038915, 1.384715670195166],
            [34.28008873564288, 1.388397343171127],
            [34.27878599881786, 1.390856684809225],
            [34.274895167150255, 1.395151739994572],
            [34.2740265950852, 1.393991816051625],
            [34.273262669564225, 1.393661841238237],
            [34.273282499874114, 1.39316287228258],
            [34.27389871271797, 1.392892829608207],
            [34.27412592719605, 1.391834106735387],
            [34.27318461315253, 1.392045710713347],
            [34.27239740329939, 1.391754135359548],
            [34.27202860265445, 1.391147495134889],
            [34.27119914593181, 1.391159538890222],
            [34.27112371709233, 1.390311894911122],
            [34.27054757809329, 1.390352663724137],
            [34.270614407360526, 1.390042463482989],
            [34.2700716290962, 1.389826992317784],
            [34.270171522654095, 1.388707653190554],
            [34.26970863785619, 1.387554905105676],
            [34.269098736575515, 1.387096732466032],
            [34.26935284661319, 1.386213303234848],
            [34.270109829055336, 1.386091525532495],
            [34.27020313257233, 1.385174470136384],
            [34.269372341851465, 1.385080522139372],
            [34.26881573761661, 1.384062676945667],
            [34.2676563638261, 1.384674279832365],
            [34.26620307115606, 1.384347278069513],
            [34.26601525498972, 1.383915847039329],
            [34.26641690522798, 1.383308788107676],
            [34.26503635723137, 1.382473436571399],
            [34.26508968841315, 1.381974448192168],
            [34.265920323725446, 1.381771721476194],
            [34.26618789950922, 1.381009653329704],
            [34.26709808063993, 1.381601104668535],
            [34.267909898941966, 1.381426773496494],
            [34.267687834505445, 1.379579396270024],
            [34.26910760204903, 1.37858071591268],
            [34.26835059714899, 1.378655292217251],
            [34.26851037330207, 1.376747026442188],
            [34.26735552702059, 1.376894820405197],
            [34.26631165591435, 1.376522023000787],
            [34.26675504367736, 1.375852450280041],
            [34.26808274737904, 1.37557134068105],
            [34.268138765421874, 1.374223593827158],
            [34.26749968865736, 1.372351604239819],
            [34.26797250882233, 1.372107134085496],
            [34.26854736323052, 1.372559080685307],
            [34.268710078671205, 1.372224326122979],
            [34.26870948129153, 1.371093691914577],
            [34.268300917618845, 1.370695926688085],
            [34.26886573065881, 1.370216236017944],
            [34.267910638255444, 1.36981876251471],
            [34.26797667071705, 1.369348382741985],
            [34.2670864124227, 1.368335807827064],
            [34.2681948274821, 1.367629701555578],
            [34.268084575450665, 1.366254907851522],
            [34.26879266708348, 1.365865592567536],
            [34.26973127450305, 1.363757589671023],
            [34.26967468243677, 1.362952608220059],
            [34.27012627900481, 1.362943323166001],
            [34.27051955065642, 1.362038606330022],
            [34.27041284607202, 1.360998480289064],
            [34.269485455915415, 1.360935657268906],
            [34.269472502209034, 1.359795984139774],
            [34.268896497957265, 1.359280720835945],
            [34.2698409857487, 1.358746560386938],
            [34.269959501382424, 1.357670133217161],
            [34.270453549635874, 1.35720857274598],
            [34.269797964531406, 1.355960700040762],
            [34.27038637631389, 1.355499089849957],
            [34.27045891796799, 1.353509135685538],
            [34.269760284696815, 1.352641177608233],
            [34.27020953396705, 1.352441948174623],
            [34.27057270666673, 1.353056821794661],
            [34.271278411475826, 1.352405203843366],
            [34.27080443607742, 1.351500947364795],
            [34.27172415462149, 1.35086730647352],
            [34.2717170947617, 1.350252245501387],
            [34.27228543548576, 1.350080089864901],
            [34.27249711360098, 1.347773486410973],
            [34.27282786520375, 1.347610500759461],
            [34.27333370115034, 1.348216253041219],
            [34.2740553366827, 1.346877203944024],
            [34.27251837313049, 1.345448893376069],
            [34.27392685334258, 1.344995898149171],
            [34.274317730983945, 1.345963513906549],
            [34.274722740921355, 1.346026615715473],
            [34.275714395655086, 1.345474344612231],
            [34.275922533509764, 1.344994847409842],
            [34.2750163741366, 1.344696837966522],
            [34.2747711205893, 1.344009542918224],
            [34.27498159496207, 1.343701899776419],
            [34.27598550900446, 1.344045083066788],
            [34.276070245288565, 1.342958810145008],
            [34.28047163893948, 1.345758606343288],
            [34.28709449981269, 1.34242139779313],
            [34.298963239874155, 1.341859455468327],
            [34.30582415609428, 1.342718865978715],
            [34.305883469157536, 1.346236111482177],
            [34.30789581307329, 1.352231818010313],
            [34.312263746276486, 1.361093465595896],
            [34.32337883934043, 1.377407551000384],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1411,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "NABBONGO",
        Population: 9582,
        Key: "BULAMBULINABBONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.53499408328497, 1.174096442175593],
            [34.53319286502059, 1.175643596982173],
            [34.52651638819965, 1.183594435396075],
            [34.52447212085366, 1.184934641181418],
            [34.52196391857921, 1.188486966671856],
            [34.5170907845383, 1.19236341490688],
            [34.51507057587226, 1.192197141313425],
            [34.51256281916218, 1.193573478797314],
            [34.5068345365815, 1.194987443224439],
            [34.4915530689079, 1.203726585083649],
            [34.48927334593944, 1.207453462903735],
            [34.481189498325804, 1.214271235594429],
            [34.478757724715706, 1.21815132585475],
            [34.476021049423444, 1.220806719188819],
            [34.47399453278749, 1.223748731070499],
            [34.47067582375127, 1.227516278172637],
            [34.466976954873395, 1.233596332650029],
            [34.464052643077835, 1.234326882488628],
            [34.45870422658981, 1.236433650791278],
            [34.45555453018443, 1.238499428788823],
            [34.45141343776012, 1.239984534604925],
            [34.448094222074104, 1.24383964357675],
            [34.445711685124756, 1.245116888503049],
            [34.444372606954886, 1.247302127098475],
            [34.43703056564499, 1.252135168383251],
            [34.425192701578155, 1.259134697835356],
            [34.42160425541162, 1.259031778453999],
            [34.415653364913645, 1.256949090106016],
            [34.41345604979609, 1.258017683253326],
            [34.41176372800539, 1.259626666198963],
            [34.40918941331926, 1.260230216861404],
            [34.40723722688317, 1.26165849135003],
            [34.40382950109051, 1.262835346376826],
            [34.401338908490565, 1.265283902778025],
            [34.40131285914397, 1.267183150228963],
            [34.398389218389944, 1.267049143586002],
            [34.395043941679205, 1.268498286952147],
            [34.39285147746418, 1.271050391862713],
            [34.39131909531992, 1.27420054622567],
            [34.39045010284329, 1.27508837401996],
            [34.38644015726396, 1.275536007702218],
            [34.38618448954758, 1.27603728976142],
            [34.38335529856085, 1.27585477580244],
            [34.38033799676035, 1.276896792889987],
            [34.37937843703513, 1.276076545384781],
            [34.37881020141395, 1.276248953991943],
            [34.37706727123507, 1.275484781392994],
            [34.37588972811963, 1.276399748198213],
            [34.373486233474665, 1.276046373967164],
            [34.36990922825159, 1.277326962857435],
            [34.369722897000415, 1.276239934449561],
            [34.367724401513094, 1.275978709880517],
            [34.367109519972466, 1.274740982704157],
            [34.367125726478505, 1.272999954364116],
            [34.36594270363983, 1.27057005329374],
            [34.36226568178963, 1.273810893214583],
            [34.35866292456227, 1.274283139361073],
            [34.35723468410889, 1.273298019927689],
            [34.357652911857414, 1.269700500171925],
            [34.355870165650224, 1.266702049356627],
            [34.35653755192256, 1.265632947862107],
            [34.355646199480205, 1.264168195770677],
            [34.354451526390584, 1.263507202849083],
            [34.35547931944985, 1.263112786517185],
            [34.35608126614869, 1.262137689190739],
            [34.35734775685034, 1.262788425293607],
            [34.36052845950607, 1.262539865230417],
            [34.36200794076154, 1.263117039006501],
            [34.363261579266414, 1.262628528976745],
            [34.36459504476239, 1.262898731374864],
            [34.36713463776614, 1.262680936538379],
            [34.372539185484705, 1.260332778752441],
            [34.375357835639896, 1.259801449575105],
            [34.377375625142875, 1.25966060443179],
            [34.38014720357717, 1.261054370726644],
            [34.38117905073333, 1.260912475774801],
            [34.38343162122405, 1.259789135751416],
            [34.38484569344874, 1.259519167434104],
            [34.38649428884469, 1.258242972215255],
            [34.38813118997226, 1.258035074935739],
            [34.39083912726025, 1.256949020054303],
            [34.39060777873523, 1.256475918455718],
            [34.39577002566885, 1.255069762224826],
            [34.39939217931981, 1.254765249804131],
            [34.40133129167527, 1.253876851051724],
            [34.40513941365805, 1.252951953193777],
            [34.40739535013609, 1.251034052590683],
            [34.411802889161855, 1.249966845955288],
            [34.41617611883198, 1.250709835359155],
            [34.41748059389709, 1.250105731963197],
            [34.41899518580549, 1.246768491643734],
            [34.41888839318618, 1.244922871266733],
            [34.42012136415129, 1.242508622255712],
            [34.42082504864931, 1.239491259412042],
            [34.42600699204387, 1.235868093546262],
            [34.428545739732954, 1.235334307596401],
            [34.43418567300542, 1.230930041784098],
            [34.434819815324055, 1.229793900816682],
            [34.44105998849632, 1.226844553530277],
            [34.44342136832413, 1.224394214608218],
            [34.44542896194863, 1.219814475676473],
            [34.44662699922898, 1.218074648621036],
            [34.45251615750062, 1.218248921018355],
            [34.45625361979977, 1.217324056559419],
            [34.458863532025646, 1.21806799360896],
            [34.46263696915699, 1.218491844199924],
            [34.466268120333844, 1.21664421222479],
            [34.46858962214954, 1.214163005723987],
            [34.47381161782934, 1.211316119758084],
            [34.47920439851599, 1.206699077847627],
            [34.48325838939204, 1.204354326613098],
            [34.48491409854671, 1.201301042001326],
            [34.48702895640603, 1.199596225202149],
            [34.490449062779916, 1.198848996877109],
            [34.49679406305765, 1.194586393137571],
            [34.500354653365555, 1.192845298868513],
            [34.50363249714114, 1.189933110711603],
            [34.50585183176298, 1.185850256959679],
            [34.50782606465277, 1.184997353530176],
            [34.51078689655786, 1.182759707503705],
            [34.512971375648355, 1.179457718934972],
            [34.516037637428454, 1.176581157036026],
            [34.52224305927395, 1.175264532022578],
            [34.53073465309338, 1.169898803280289],
            [34.53499408328497, 1.174096442175593],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1412,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BUMUGIBOLE",
        Population: 6482,
        Key: "BULAMBULIBUMUGIBOLE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.36990922825159, 1.277326962857435],
            [34.36834626925167, 1.278464732984908],
            [34.366237733735325, 1.278986396659026],
            [34.36528540365147, 1.278806970548263],
            [34.364846929673085, 1.279951186517973],
            [34.36570347060155, 1.280450826903213],
            [34.361921271302954, 1.283852518413545],
            [34.36134676364445, 1.2850895361921],
            [34.360797103386716, 1.284719642803335],
            [34.356279529721824, 1.28438740985003],
            [34.353692668266135, 1.284633002314568],
            [34.34628814284, 1.28427515673209],
            [34.3447708047818, 1.283706139655139],
            [34.343526227583226, 1.281671716620276],
            [34.3432774750979, 1.278560431834538],
            [34.34266201055066, 1.277701499550781],
            [34.340908756932535, 1.277087375234854],
            [34.340080477901225, 1.276328045399319],
            [34.33987351324628, 1.26780452902303],
            [34.34242860668028, 1.267058824158869],
            [34.34529839073805, 1.266623783004374],
            [34.34717822416623, 1.266887983911085],
            [34.34901399522973, 1.266404949383576],
            [34.350588420325906, 1.264868468566235],
            [34.35328447020776, 1.264570358024562],
            [34.354451526390584, 1.263507202849083],
            [34.355646199480205, 1.264168195770677],
            [34.35653755192256, 1.265632947862107],
            [34.355870165650224, 1.266702049356627],
            [34.357652911857414, 1.269700500171925],
            [34.35723468410889, 1.273298019927689],
            [34.35866292456227, 1.274283139361073],
            [34.36226568178963, 1.273810893214583],
            [34.36594270363983, 1.27057005329374],
            [34.367125726478505, 1.272999954364116],
            [34.367109519972466, 1.274740982704157],
            [34.367724401513094, 1.275978709880517],
            [34.369722897000415, 1.276239934449561],
            [34.36990922825159, 1.277326962857435],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1413,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BUGINYANYA",
        Population: 5518,
        Key: "BULAMBULIBUGINYANYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30032156444898, 1.309085134150925],
            [34.30022023089166, 1.311244149156569],
            [34.302674702234015, 1.322572592303182],
            [34.302906622985894, 1.326111975417775],
            [34.302184121477595, 1.32720398280316],
            [34.30001507274875, 1.327535928999342],
            [34.29932548910573, 1.328727157638337],
            [34.29718885338898, 1.328199017481807],
            [34.296466123708626, 1.328860991276905],
            [34.29689381071706, 1.329654675444506],
            [34.29666420851696, 1.330547945783853],
            [34.297091705980904, 1.33097775364007],
            [34.29699367642722, 1.332069431077407],
            [34.29784882856024, 1.333226761592508],
            [34.2970280881908, 1.335013495136868],
            [34.29399345699016, 1.32997873712608],
            [34.29054373855125, 1.332535961744989],
            [34.289393247302236, 1.332271932052781],
            [34.288850361240094, 1.331164048980652],
            [34.28924383052105, 1.329360999139527],
            [34.288522862436935, 1.32819572334665],
            [34.28482732810538, 1.329997347898602],
            [34.283023896392116, 1.331879225597224],
            [34.28032003835382, 1.337199148599448],
            [34.27801458494067, 1.338429877773719],
            [34.278327451086135, 1.338074118017227],
            [34.27820011579294, 1.337314400696837],
            [34.279518980072254, 1.336282573037769],
            [34.280072009012294, 1.334753670481385],
            [34.279979485232985, 1.332881395370682],
            [34.28108845994281, 1.332202436511841],
            [34.28036626116677, 1.33136162679546],
            [34.28109027723463, 1.330284887593881],
            [34.28094346646606, 1.329877938277176],
            [34.28190681977674, 1.328918660179913],
            [34.282328387461476, 1.327335558765591],
            [34.28374687041425, 1.326701664656622],
            [34.28359536325338, 1.325896736542965],
            [34.284269251531754, 1.324557720180685],
            [34.28268693473577, 1.322261108105535],
            [34.28438546119016, 1.321174819289629],
            [34.28471091902098, 1.320559588333428],
            [34.28521086112098, 1.320649777683909],
            [34.28455587159955, 1.319419996101838],
            [34.28574680859591, 1.317574191010966],
            [34.28507415190777, 1.316941389166601],
            [34.28436903908846, 1.317638223057266],
            [34.2838219165714, 1.317548056947643],
            [34.283532471302024, 1.317195451827749],
            [34.283977006213625, 1.31658015881848],
            [34.2834747069343, 1.316272888551673],
            [34.28316580595249, 1.315223825175518],
            [34.28182928348963, 1.314663725808679],
            [34.28160762149831, 1.313958327903133],
            [34.28241120853741, 1.313614201041591],
            [34.281233881017634, 1.312420865449046],
            [34.281347693970865, 1.312013779392258],
            [34.28219960049076, 1.311696763498848],
            [34.28205896204651, 1.310168224778223],
            [34.282345861490384, 1.309932906139252],
            [34.28133423181803, 1.307635988719785],
            [34.28192908182611, 1.307698997207877],
            [34.28213427949489, 1.306957198991923],
            [34.2832397211307, 1.305970720839194],
            [34.28240080604642, 1.305319910411588],
            [34.282423622356326, 1.30490382711165],
            [34.283651842131924, 1.304568529851865],
            [34.2841335852626, 1.302008538273533],
            [34.285173553188926, 1.301501483056745],
            [34.28473673480559, 1.300723835100962],
            [34.28544891287464, 1.300669199273795],
            [34.28758785097345, 1.298605835568337],
            [34.289289902417025, 1.297845180282167],
            [34.289776903387036, 1.29679570866472],
            [34.28957591073213, 1.294751639869789],
            [34.293217020632206, 1.293212119846627],
            [34.29684431264659, 1.294340875988486],
            [34.29657991600059, 1.298626191552946],
            [34.29685994153589, 1.299916150483136],
            [34.29946694771183, 1.304438426441838],
            [34.30032156444898, 1.309085134150925],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1414,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BULAMBULI TOWN COUNCIL",
        Population: 3263,
        Key: "BULAMBULIBULAMBULI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34066717120656, 1.302344063089283],
            [34.339947303558695, 1.302538642692803],
            [34.33977174400607, 1.303964622326541],
            [34.337912225978066, 1.303075219484531],
            [34.337375514036836, 1.304197848992418],
            [34.336744557144186, 1.304607577577889],
            [34.33431330904856, 1.304491238181795],
            [34.333744856035054, 1.305155461681968],
            [34.3327452574993, 1.304321633506231],
            [34.332546805279975, 1.30194004414967],
            [34.33133063191236, 1.301709137922385],
            [34.327715790547806, 1.302571119175908],
            [34.326696743486146, 1.302207789732178],
            [34.32436236791412, 1.300555067186012],
            [34.32416480682356, 1.299860507886214],
            [34.324788731704125, 1.298834722287468],
            [34.32439402634136, 1.298239504154782],
            [34.32189563366978, 1.297182287615295],
            [34.32064602590559, 1.295859775282433],
            [34.31982448693387, 1.296091762440977],
            [34.31803379872123, 1.29528186256227],
            [34.320774902707846, 1.29086473805484],
            [34.32123386725785, 1.288615107394949],
            [34.321275663173076, 1.28422680717854],
            [34.32330287151183, 1.284585745742731],
            [34.327016409878304, 1.28314566867626],
            [34.33125222785269, 1.283767543851968],
            [34.33513490551246, 1.28359364941156],
            [34.335566440005266, 1.283937126551669],
            [34.33627089166455, 1.287419018117707],
            [34.33724300714254, 1.289336008895853],
            [34.33891550311491, 1.291225491616562],
            [34.34003561154436, 1.293657954181666],
            [34.34140423350727, 1.294449206720835],
            [34.341142023360696, 1.295501582821736],
            [34.34030439646052, 1.296370353922087],
            [34.34066717120656, 1.302344063089283],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1415,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BULEGENI TOWN COUNCIL",
        Population: 10617,
        Key: "BULAMBULIBULEGENI TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.31803379872123, 1.29528186256227],
            [34.314492763838736, 1.297731986565525],
            [34.31265128577827, 1.295880506688851],
            [34.30837776191816, 1.294162605896371],
            [34.30633986991575, 1.293832870855151],
            [34.30275551108372, 1.290096745765425],
            [34.29950754976604, 1.287783635743945],
            [34.29987549611317, 1.287154930684378],
            [34.30153945629371, 1.287275476625553],
            [34.30227031842236, 1.286969010169194],
            [34.30265157241209, 1.285881314083257],
            [34.30369778093471, 1.285584114841519],
            [34.30449214047919, 1.284644665802887],
            [34.30529828502189, 1.28494784014264],
            [34.30540203325071, 1.285734698345572],
            [34.30571095938533, 1.285752628694644],
            [34.307545656063745, 1.284114545970736],
            [34.31002707327137, 1.282955513374454],
            [34.31261102688049, 1.282420526440914],
            [34.31319351427364, 1.281398148348285],
            [34.31566133727609, 1.281134568612201],
            [34.31839802424645, 1.279441752349573],
            [34.32066330320347, 1.279612430108975],
            [34.320645890259996, 1.281801304795226],
            [34.321275663173076, 1.28422680717854],
            [34.32123386725785, 1.288615107394949],
            [34.320774902707846, 1.29086473805484],
            [34.31803379872123, 1.29528186256227],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1416,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "KAMU",
        Population: 6353,
        Key: "BULAMBULIKAMU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.30582415609428, 1.342718865978715],
            [34.298963239874155, 1.341859455468327],
            [34.28709449981269, 1.34242139779313],
            [34.28047163893948, 1.345758606343288],
            [34.276070245288565, 1.342958810145008],
            [34.27694758760575, 1.342787314073861],
            [34.27865698457338, 1.340977404330014],
            [34.27839521639791, 1.33985595624925],
            [34.277683635708534, 1.340001051075363],
            [34.27710762876184, 1.339467696451426],
            [34.27702686303127, 1.338608459025362],
            [34.27787007026598, 1.338834142242255],
            [34.27801458494067, 1.338429877773719],
            [34.28032003835382, 1.337199148599448],
            [34.283023896392116, 1.331879225597224],
            [34.28482732810538, 1.329997347898602],
            [34.288522862436935, 1.32819572334665],
            [34.28924383052105, 1.329360999139527],
            [34.288850361240094, 1.331164048980652],
            [34.289393247302236, 1.332271932052781],
            [34.29054373855125, 1.332535961744989],
            [34.29399345699016, 1.32997873712608],
            [34.2970280881908, 1.335013495136868],
            [34.29784882856024, 1.333226761592508],
            [34.29699367642722, 1.332069431077407],
            [34.297091705980904, 1.33097775364007],
            [34.29666420851696, 1.330547945783853],
            [34.29689381071706, 1.329654675444506],
            [34.296466123708626, 1.328860991276905],
            [34.29718885338898, 1.328199017481807],
            [34.29932548910573, 1.328727157638337],
            [34.30001507274875, 1.327535928999342],
            [34.302184121477595, 1.32720398280316],
            [34.302906622985894, 1.326111975417775],
            [34.302674702234015, 1.322572592303182],
            [34.30022023089166, 1.311244149156569],
            [34.30032156444898, 1.309085134150925],
            [34.308881517366544, 1.312858672044198],
            [34.312846203126945, 1.313616349247029],
            [34.31587884006762, 1.312864012922808],
            [34.31659632897664, 1.313306832519045],
            [34.31867393639608, 1.3132785933131],
            [34.318145407208775, 1.314355217753125],
            [34.316491444379, 1.315730924318289],
            [34.31327028968771, 1.322217845086164],
            [34.311978335341045, 1.32628875063626],
            [34.31072848054015, 1.328254251721911],
            [34.31096194010609, 1.32886709907605],
            [34.31054512989911, 1.329844174312558],
            [34.30802864605602, 1.332712767037989],
            [34.30609319343703, 1.338195040489244],
            [34.30582415609428, 1.342718865978715],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1417,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "MUYEMBE",
        Population: 7580,
        Key: "BULAMBULIMUYEMBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.38904502365291, 1.250951896989982],
            [34.38767483143487, 1.250914641058318],
            [34.38716792020489, 1.251258224916229],
            [34.38716018211702, 1.251940567899329],
            [34.385144490180224, 1.252298089248008],
            [34.38424529814041, 1.251887283575658],
            [34.38288219362997, 1.249941284189709],
            [34.38095565050196, 1.248141119886251],
            [34.37665309309185, 1.24949206544156],
            [34.37484286292856, 1.250995523152717],
            [34.37386823216779, 1.253234029481295],
            [34.373259159133795, 1.252444321596006],
            [34.36864719319375, 1.253853789635163],
            [34.364693820816065, 1.254547453390235],
            [34.36126235255049, 1.254622739311846],
            [34.35974742467217, 1.254299472714231],
            [34.35828629240467, 1.2529433332252],
            [34.35762911638384, 1.252796700352182],
            [34.35656898936421, 1.253308860103811],
            [34.35583124524221, 1.252834381058689],
            [34.35336607316816, 1.252420698853906],
            [34.35206128099778, 1.250693379449598],
            [34.35241392723897, 1.248174176331654],
            [34.35310655706911, 1.247305518333246],
            [34.354002136983176, 1.244618755529259],
            [34.35490581251461, 1.24348769021958],
            [34.35491155454589, 1.242637478631268],
            [34.35409758477874, 1.242357511752103],
            [34.3493203198433, 1.243115552829492],
            [34.347794993067275, 1.244319691588613],
            [34.34553020908196, 1.245365875921594],
            [34.34310719224927, 1.244607109823139],
            [34.341682681600936, 1.24351807845725],
            [34.34203733737345, 1.242454167511452],
            [34.34325283969954, 1.241521928124555],
            [34.344234670457304, 1.239432073387925],
            [34.34526719045164, 1.238735094336128],
            [34.34646391798829, 1.236220025463767],
            [34.35256878152259, 1.231296534479371],
            [34.357288378210065, 1.229259042205773],
            [34.361918187386586, 1.226289987111526],
            [34.36570529957148, 1.225103180892416],
            [34.36686065250279, 1.224107666253997],
            [34.37006373129392, 1.226394330374207],
            [34.370607417755004, 1.226430228709062],
            [34.371338800906535, 1.225579647931627],
            [34.37168956338055, 1.222857008787746],
            [34.37257262976274, 1.222087753518778],
            [34.37349477375807, 1.222032843912853],
            [34.37493101191244, 1.221162461980106],
            [34.37699046258334, 1.220918709184741],
            [34.38120794324781, 1.225502816435045],
            [34.382536140124635, 1.225116175645096],
            [34.38431684715616, 1.225859577958177],
            [34.391523869882214, 1.230922133045214],
            [34.39068435831659, 1.241003357204914],
            [34.390963167532995, 1.246350784085168],
            [34.38904502365291, 1.250951896989982],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1418,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "SIMU",
        Population: 5351,
        Key: "BULAMBULISIMU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.31867393639608, 1.3132785933131],
            [34.31659632897664, 1.313306832519045],
            [34.31587884006762, 1.312864012922808],
            [34.312846203126945, 1.313616349247029],
            [34.308881517366544, 1.312858672044198],
            [34.30032156444898, 1.309085134150925],
            [34.29946694771183, 1.304438426441838],
            [34.29685994153589, 1.299916150483136],
            [34.29657991600059, 1.298626191552946],
            [34.29684431264659, 1.294340875988486],
            [34.297263062316304, 1.293834140749132],
            [34.29763094937459, 1.291608885901479],
            [34.29853537769423, 1.290776282740443],
            [34.298937475293506, 1.289555003116714],
            [34.30016668591084, 1.288993582347367],
            [34.29954355514097, 1.288523564375365],
            [34.29950754976604, 1.287783635743945],
            [34.30275551108372, 1.290096745765425],
            [34.30633986991575, 1.293832870855151],
            [34.30837776191816, 1.294162605896371],
            [34.31265128577827, 1.295880506688851],
            [34.314492763838736, 1.297731986565525],
            [34.31803379872123, 1.29528186256227],
            [34.31982448693387, 1.296091762440977],
            [34.32064602590559, 1.295859775282433],
            [34.32189563366978, 1.297182287615295],
            [34.32439402634136, 1.298239504154782],
            [34.324788731704125, 1.298834722287468],
            [34.32416480682356, 1.299860507886214],
            [34.32436236791412, 1.300555067186012],
            [34.326696743486146, 1.302207789732178],
            [34.327715790547806, 1.302571119175908],
            [34.33133063191236, 1.301709137922385],
            [34.332546805279975, 1.30194004414967],
            [34.3327452574993, 1.304321633506231],
            [34.333744856035054, 1.305155461681968],
            [34.333963832961985, 1.306740284439305],
            [34.33190222723271, 1.306711051881034],
            [34.33079867924551, 1.305922922223798],
            [34.33000301265229, 1.305990084383784],
            [34.32854707624037, 1.308144880174057],
            [34.3286054281063, 1.309094559509145],
            [34.32809908910313, 1.310185343089349],
            [34.3254650112978, 1.311569507371822],
            [34.323186952009245, 1.311347272094177],
            [34.31947227907052, 1.311808122708106],
            [34.31888147417617, 1.312199328953052],
            [34.31867393639608, 1.3132785933131],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1419,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BULEGENI",
        Population: 5092,
        Key: "BULAMBULIBULEGENI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.459161925413575, 1.196067645059576],
            [34.4502892042669, 1.199386872896679],
            [34.44711178495353, 1.202099849447395],
            [34.44178866682053, 1.203079267147935],
            [34.43677109536004, 1.202465150665018],
            [34.429852402195756, 1.203972237148129],
            [34.42650711919684, 1.203138771007983],
            [34.42201345509152, 1.203500932269072],
            [34.41608324740465, 1.20331832260004],
            [34.413667036208544, 1.20671083418687],
            [34.40849205745242, 1.210591422959405],
            [34.40688435157158, 1.213163601799502],
            [34.398917822137406, 1.219750028975693],
            [34.39689392768375, 1.21815998006453],
            [34.39505892018827, 1.217914697511894],
            [34.39185068686403, 1.218806636082628],
            [34.390345029599466, 1.218589589335912],
            [34.3889800134741, 1.217396963538164],
            [34.385401742524785, 1.21231671795857],
            [34.38434790371215, 1.21240250043726],
            [34.38331220458006, 1.213665073541046],
            [34.382318509772325, 1.212614899940842],
            [34.38002596155654, 1.212692798764719],
            [34.37630445423515, 1.210233608620436],
            [34.37647635764457, 1.208364939833631],
            [34.37483743710422, 1.207369720787728],
            [34.375968099839966, 1.207153470650574],
            [34.37790137045111, 1.205742482585306],
            [34.38054969643517, 1.205156268490055],
            [34.385912976447905, 1.202147619422871],
            [34.389510880976076, 1.201615950838117],
            [34.39083957462127, 1.200022217096617],
            [34.39229559727141, 1.19983030448544],
            [34.39271196999887, 1.196933703408699],
            [34.39551953045189, 1.191443837879948],
            [34.3972806119894, 1.190218597495343],
            [34.40144435453526, 1.186102181316232],
            [34.403890568563526, 1.179082515533669],
            [34.405207558957166, 1.177998871733584],
            [34.40705817198578, 1.177201737702897],
            [34.40903414850557, 1.174015966431192],
            [34.40917545439806, 1.171866178082084],
            [34.40972848962632, 1.170496448143099],
            [34.41121727203828, 1.169577233011903],
            [34.41011392976529, 1.168010032216076],
            [34.41319781828786, 1.166273470330486],
            [34.416693984118574, 1.165218436878529],
            [34.419065410704484, 1.163074335043697],
            [34.42493668531547, 1.160803736128386],
            [34.42405564463427, 1.158302779880658],
            [34.41913891355599, 1.156868599673796],
            [34.41602194547136, 1.154800362182134],
            [34.41719018563373, 1.152489428647191],
            [34.42355015903061, 1.143194435311982],
            [34.42428472401486, 1.14128209643788],
            [34.426342163357866, 1.138859413763748],
            [34.429101321685046, 1.141321521960903],
            [34.43176469445009, 1.14232213449419],
            [34.434555391728594, 1.142652879621072],
            [34.43899015958895, 1.142227751097645],
            [34.44172110632462, 1.140665796505953],
            [34.44386228572009, 1.140864786894313],
            [34.44406621317104, 1.139812869544075],
            [34.44488379865721, 1.139360862034863],
            [34.45089792426296, 1.138980532138602],
            [34.454418581761566, 1.138058408528226],
            [34.45646262363039, 1.137108454009199],
            [34.457820004075856, 1.137204940115413],
            [34.461583990032075, 1.135902105722861],
            [34.463720040047285, 1.135904319634856],
            [34.46523586983411, 1.134886038478516],
            [34.46596773268596, 1.133393703689158],
            [34.467332346366085, 1.132315817496003],
            [34.47331503632678, 1.130337433842692],
            [34.475967344542504, 1.130505943852498],
            [34.47999884968867, 1.129259342636128],
            [34.485366305969144, 1.130588471280689],
            [34.489671684987535, 1.130141750581235],
            [34.49415979031789, 1.130606782567098],
            [34.49731269460716, 1.12997901649244],
            [34.49981131455247, 1.130401090446543],
            [34.50118115732587, 1.131042970704195],
            [34.50461715938871, 1.130550955057742],
            [34.50764298799788, 1.132430669823499],
            [34.5114826417454, 1.132751698212282],
            [34.51337256864413, 1.132565250685121],
            [34.51442422455062, 1.131918604335396],
            [34.51699151530951, 1.131372858501107],
            [34.523465244167475, 1.130441904643131],
            [34.526881962994416, 1.12924157381826],
            [34.5267902854281, 1.129958014372803],
            [34.52596506426201, 1.137469123905801],
            [34.52366809364008, 1.142625482860612],
            [34.52348819522465, 1.144398219956594],
            [34.52379175482378, 1.150258641841746],
            [34.524912138137715, 1.157619188393154],
            [34.516357919166595, 1.15907849793907],
            [34.513262928365386, 1.159299557725047],
            [34.51160624813189, 1.159037182992741],
            [34.50960175549174, 1.160530110648327],
            [34.507248257482225, 1.161540568933059],
            [34.50594108836959, 1.162725978157088],
            [34.5025414590926, 1.163956391276178],
            [34.49909936824877, 1.167336852392725],
            [34.49870758600393, 1.168390138190209],
            [34.49261981112127, 1.172902738154848],
            [34.486766262965816, 1.174715023267046],
            [34.485894872885694, 1.175636936478383],
            [34.481231897010574, 1.178623171221359],
            [34.47944598244538, 1.181344596200017],
            [34.47888147123933, 1.185513357572273],
            [34.477443514607856, 1.186742730510164],
            [34.476180471640305, 1.188981216653048],
            [34.472388628028796, 1.190606768260571],
            [34.47003429548438, 1.190169251108981],
            [34.46833438921775, 1.190696708824545],
            [34.46397516877447, 1.191137835441374],
            [34.46258065107686, 1.192103917268589],
            [34.459161925413575, 1.196067645059576],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1420,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BUMASOBO",
        Population: 8045,
        Key: "BULAMBULIBUMASOBO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.391523869882214, 1.230922133045214],
            [34.38431684715616, 1.225859577958177],
            [34.382536140124635, 1.225116175645096],
            [34.38120794324781, 1.225502816435045],
            [34.37699046258334, 1.220918709184741],
            [34.37493101191244, 1.221162461980106],
            [34.37349477375807, 1.222032843912853],
            [34.37257262976274, 1.222087753518778],
            [34.37168956338055, 1.222857008787746],
            [34.371338800906535, 1.225579647931627],
            [34.370607417755004, 1.226430228709062],
            [34.37006373129392, 1.226394330374207],
            [34.36686065250279, 1.224107666253997],
            [34.36570529957148, 1.225103180892416],
            [34.361918187386586, 1.226289987111526],
            [34.357288378210065, 1.229259042205773],
            [34.35256878152259, 1.231296534479371],
            [34.34646391798829, 1.236220025463767],
            [34.34526719045164, 1.238735094336128],
            [34.344234670457304, 1.239432073387925],
            [34.34325283969954, 1.241521928124555],
            [34.34203733737345, 1.242454167511452],
            [34.341682681600936, 1.24351807845725],
            [34.33774724678286, 1.246508449611615],
            [34.33718433547638, 1.247349907943582],
            [34.33076408692055, 1.250852540952254],
            [34.33069287028146, 1.248719000953439],
            [34.33141885635473, 1.246868017577236],
            [34.3337499997884, 1.238599660944753],
            [34.33456430732209, 1.238108400842856],
            [34.33517129716295, 1.236086463597386],
            [34.33760618702874, 1.231819706504597],
            [34.34018449382797, 1.229123040727331],
            [34.34625341936103, 1.224163407467557],
            [34.34911339920581, 1.223203208882629],
            [34.3594754642115, 1.216325213328906],
            [34.36240025211412, 1.21500775057898],
            [34.36488386570265, 1.213887909026526],
            [34.365512432178285, 1.21259629101652],
            [34.36801241666455, 1.211542240739642],
            [34.37311247323105, 1.208163953249993],
            [34.37483743710422, 1.207369720787728],
            [34.37647635764457, 1.208364939833631],
            [34.37630445423515, 1.210233608620436],
            [34.38002596155654, 1.212692798764719],
            [34.382318509772325, 1.212614899940842],
            [34.38331220458006, 1.213665073541046],
            [34.38434790371215, 1.21240250043726],
            [34.385401742524785, 1.21231671795857],
            [34.3889800134741, 1.217396963538164],
            [34.390345029599466, 1.218589589335912],
            [34.39185068686403, 1.218806636082628],
            [34.39505892018827, 1.217914697511894],
            [34.39689392768375, 1.21815998006453],
            [34.398917822137406, 1.219750028975693],
            [34.40688435157158, 1.213163601799502],
            [34.40849205745242, 1.210591422959405],
            [34.413667036208544, 1.20671083418687],
            [34.41608324740465, 1.20331832260004],
            [34.42201345509152, 1.203500932269072],
            [34.42650711919684, 1.203138771007983],
            [34.429852402195756, 1.203972237148129],
            [34.43677109536004, 1.202465150665018],
            [34.44178866682053, 1.203079267147935],
            [34.44711178495353, 1.202099849447395],
            [34.4502892042669, 1.199386872896679],
            [34.459161925413575, 1.196067645059576],
            [34.45831113190631, 1.197327790932971],
            [34.45770080482417, 1.19732811784832],
            [34.455042332369, 1.198865308507912],
            [34.45465041986841, 1.199699219622256],
            [34.45242738149267, 1.200270836876815],
            [34.45216618195076, 1.200973041262935],
            [34.451163636940855, 1.201236853518455],
            [34.45024876840102, 1.202422076951369],
            [34.449813584053175, 1.203870319731464],
            [34.44610932258861, 1.20637341645313],
            [34.440747549050606, 1.207209991778726],
            [34.44048625608394, 1.207736681914605],
            [34.43821927571775, 1.207694013334515],
            [34.43564841954548, 1.210108749092523],
            [34.433860984132494, 1.210065822790705],
            [34.430896882359775, 1.210813352500091],
            [34.42845621991994, 1.212131035534877],
            [34.42117634023109, 1.213424735594847],
            [34.41999120365652, 1.21430268483659],
            [34.418927382764466, 1.217324121223545],
            [34.41810401033123, 1.218346587129285],
            [34.41463389384716, 1.221911980626631],
            [34.412117252798915, 1.225169353631983],
            [34.40977837037908, 1.226825751610852],
            [34.40865804815062, 1.227088637189309],
            [34.4029488125489, 1.226621347300853],
            [34.400974274231906, 1.228015259475891],
            [34.39766457619634, 1.228035096906577],
            [34.3945148761977, 1.229012861661304],
            [34.391523869882214, 1.230922133045214],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1421,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BULUGANYA",
        Population: 12944,
        Key: "BULAMBULIBULUGANYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.34140423350727, 1.294449206720835],
            [34.34003561154436, 1.293657954181666],
            [34.33891550311491, 1.291225491616562],
            [34.33724300714254, 1.289336008895853],
            [34.33627089166455, 1.287419018117707],
            [34.335566440005266, 1.283937126551669],
            [34.33513490551246, 1.28359364941156],
            [34.33125222785269, 1.283767543851968],
            [34.327016409878304, 1.28314566867626],
            [34.32330287151183, 1.284585745742731],
            [34.321275663173076, 1.28422680717854],
            [34.320645890259996, 1.281801304795226],
            [34.32066330320347, 1.279612430108975],
            [34.31839802424645, 1.279441752349573],
            [34.31566133727609, 1.281134568612201],
            [34.31319351427364, 1.281398148348285],
            [34.31261102688049, 1.282420526440914],
            [34.31002707327137, 1.282955513374454],
            [34.307545656063745, 1.284114545970736],
            [34.30571095938533, 1.285752628694644],
            [34.30540203325071, 1.285734698345572],
            [34.30529828502189, 1.28494784014264],
            [34.30449214047919, 1.284644665802887],
            [34.30467151158356, 1.282831644295898],
            [34.30415319713936, 1.281768643039937],
            [34.30439091741465, 1.281157606435427],
            [34.30531507992446, 1.280781800346133],
            [34.30368118006825, 1.279286528935226],
            [34.30409226710856, 1.278961663219531],
            [34.30372462529034, 1.277908456744854],
            [34.304376469809974, 1.276563775786106],
            [34.30638231531291, 1.27509506930211],
            [34.3069920396255, 1.275273591292587],
            [34.307215191023545, 1.274317635117691],
            [34.307852132492584, 1.273796221962587],
            [34.30928568827749, 1.273490234374717],
            [34.3103794796624, 1.273742509696441],
            [34.311754648547094, 1.273081965573367],
            [34.31376700773419, 1.273638148557235],
            [34.31446585121116, 1.271791785622644],
            [34.31417661614754, 1.270629456850106],
            [34.317231498069646, 1.266633758154249],
            [34.31789633851645, 1.265281038749113],
            [34.317741527351956, 1.264147153366389],
            [34.318390603263886, 1.262340817246304],
            [34.31976624556076, 1.260268854833078],
            [34.32163425985471, 1.258577151120561],
            [34.32422973615397, 1.257549331893602],
            [34.32595848013789, 1.254640632156598],
            [34.33065728891136, 1.252244237331931],
            [34.33076408692055, 1.250852540952254],
            [34.33718433547638, 1.247349907943582],
            [34.33774724678286, 1.246508449611615],
            [34.341682681600936, 1.24351807845725],
            [34.34310719224927, 1.244607109823139],
            [34.34553020908196, 1.245365875921594],
            [34.347794993067275, 1.244319691588613],
            [34.3493203198433, 1.243115552829492],
            [34.35409758477874, 1.242357511752103],
            [34.35491155454589, 1.242637478631268],
            [34.35490581251461, 1.24348769021958],
            [34.354002136983176, 1.244618755529259],
            [34.35310655706911, 1.247305518333246],
            [34.35241392723897, 1.248174176331654],
            [34.35206128099778, 1.250693379449598],
            [34.351572588500055, 1.251485003511747],
            [34.35015359350757, 1.252064607298442],
            [34.34808731743712, 1.252138038713346],
            [34.346762644651164, 1.252654278664734],
            [34.344328432115084, 1.254826294550122],
            [34.34227448811686, 1.255967005953692],
            [34.335078593720546, 1.261515214258984],
            [34.33344908662608, 1.2623391387025],
            [34.333833992267444, 1.264871496947281],
            [34.33689427575933, 1.264508115446089],
            [34.33978059959813, 1.26554676925042],
            [34.34021566177507, 1.266206815059386],
            [34.33987351324628, 1.26780452902303],
            [34.340080477901225, 1.276328045399319],
            [34.340908756932535, 1.277087375234854],
            [34.34266201055066, 1.277701499550781],
            [34.3432774750979, 1.278560431834538],
            [34.343526227583226, 1.281671716620276],
            [34.3447708047818, 1.283706139655139],
            [34.34628814284, 1.28427515673209],
            [34.353692668266135, 1.284633002314568],
            [34.356279529721824, 1.28438740985003],
            [34.360797103386716, 1.284719642803335],
            [34.36134676364445, 1.2850895361921],
            [34.361217576923465, 1.285388728351394],
            [34.356740072611764, 1.287543785960327],
            [34.35582337150875, 1.288457799176913],
            [34.35515692756913, 1.289977677311886],
            [34.35409189844301, 1.290801324109494],
            [34.349654308974344, 1.290828055678637],
            [34.34460208679842, 1.293408384962883],
            [34.34140423350727, 1.294449206720835],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1425,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "SISIYI",
        Population: 13009,
        Key: "BULAMBULISISIYI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.35735441067164, 1.300369003061324],
            [34.35590470946614, 1.301100929687011],
            [34.354471909164396, 1.301157119189555],
            [34.351048002018516, 1.30237812379368],
            [34.347877479969924, 1.30203365676666],
            [34.34636232122459, 1.302455909474364],
            [34.344687182408634, 1.302005271944395],
            [34.343586043703056, 1.30295911351921],
            [34.3420976834993, 1.303405647538021],
            [34.34066717120656, 1.302344063089283],
            [34.34030439646052, 1.296370353922087],
            [34.341142023360696, 1.295501582821736],
            [34.34140423350727, 1.294449206720835],
            [34.34460208679842, 1.293408384962883],
            [34.349654308974344, 1.290828055678637],
            [34.35409189844301, 1.290801324109494],
            [34.35515692756913, 1.289977677311886],
            [34.35582337150875, 1.288457799176913],
            [34.356740072611764, 1.287543785960327],
            [34.361217576923465, 1.285388728351394],
            [34.361490523734304, 1.286410637841892],
            [34.36015227381116, 1.28991167595393],
            [34.36034918092817, 1.290526612652761],
            [34.36280046684455, 1.290932302059922],
            [34.366815732246984, 1.290912039414617],
            [34.371805525103966, 1.289959634731592],
            [34.372025836927385, 1.290515970316781],
            [34.37067287259988, 1.294811229666677],
            [34.370734083803335, 1.296574105232732],
            [34.36008323199338, 1.299453924518336],
            [34.359416317336546, 1.300216244367895],
            [34.35735441067164, 1.300369003061324],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1426,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "NAMISUNI",
        Population: 8672,
        Key: "BULAMBULINAMISUNI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39058195127251, 1.296321555555735],
            [34.38822341820584, 1.296941567576654],
            [34.38441585228023, 1.296584066794646],
            [34.37766545489121, 1.294823464290983],
            [34.374120695593554, 1.295269294750379],
            [34.370734083803335, 1.296574105232732],
            [34.37067287259988, 1.294811229666677],
            [34.372025836927385, 1.290515970316781],
            [34.371805525103966, 1.289959634731592],
            [34.366815732246984, 1.290912039414617],
            [34.36280046684455, 1.290932302059922],
            [34.36034918092817, 1.290526612652761],
            [34.36015227381116, 1.28991167595393],
            [34.361490523734304, 1.286410637841892],
            [34.361217576923465, 1.285388728351394],
            [34.36134676364445, 1.2850895361921],
            [34.361921271302954, 1.283852518413545],
            [34.36570347060155, 1.280450826903213],
            [34.364846929673085, 1.279951186517973],
            [34.36528540365147, 1.278806970548263],
            [34.366237733735325, 1.278986396659026],
            [34.36834626925167, 1.278464732984908],
            [34.36990922825159, 1.277326962857435],
            [34.373486233474665, 1.276046373967164],
            [34.37588972811963, 1.276399748198213],
            [34.37706727123507, 1.275484781392994],
            [34.37881020141395, 1.276248953991943],
            [34.37937843703513, 1.276076545384781],
            [34.38033799676035, 1.276896792889987],
            [34.38335529856085, 1.27585477580244],
            [34.38618448954758, 1.27603728976142],
            [34.38644015726396, 1.275536007702218],
            [34.39045010284329, 1.27508837401996],
            [34.39131909531992, 1.27420054622567],
            [34.39285147746418, 1.271050391862713],
            [34.395043941679205, 1.268498286952147],
            [34.398389218389944, 1.267049143586002],
            [34.40131285914397, 1.267183150228963],
            [34.401338908490565, 1.265283902778025],
            [34.40382950109051, 1.262835346376826],
            [34.40723722688317, 1.26165849135003],
            [34.40918941331926, 1.260230216861404],
            [34.41176372800539, 1.259626666198963],
            [34.41345604979609, 1.258017683253326],
            [34.415653364913645, 1.256949090106016],
            [34.42160425541162, 1.259031778453999],
            [34.425192701578155, 1.259134697835356],
            [34.43703056564499, 1.252135168383251],
            [34.444372606954886, 1.247302127098475],
            [34.445711685124756, 1.245116888503049],
            [34.448094222074104, 1.24383964357675],
            [34.45141343776012, 1.239984534604925],
            [34.45555453018443, 1.238499428788823],
            [34.45870422658981, 1.236433650791278],
            [34.464052643077835, 1.234326882488628],
            [34.466976954873395, 1.233596332650029],
            [34.47067582375127, 1.227516278172637],
            [34.47399453278749, 1.223748731070499],
            [34.476021049423444, 1.220806719188819],
            [34.478757724715706, 1.21815132585475],
            [34.481189498325804, 1.214271235594429],
            [34.48927334593944, 1.207453462903735],
            [34.4915530689079, 1.203726585083649],
            [34.5068345365815, 1.194987443224439],
            [34.51256281916218, 1.193573478797314],
            [34.51507057587226, 1.192197141313425],
            [34.5170907845383, 1.19236341490688],
            [34.52196391857921, 1.188486966671856],
            [34.52447212085366, 1.184934641181418],
            [34.52651638819965, 1.183594435396075],
            [34.53319286502059, 1.175643596982173],
            [34.53499408328497, 1.174096442175593],
            [34.53571438122588, 1.175430833575234],
            [34.53592898156072, 1.178641354664636],
            [34.53654636670605, 1.180015702359185],
            [34.535210436232944, 1.184267156848539],
            [34.532959553676676, 1.188293018110595],
            [34.53133086404913, 1.190193184250162],
            [34.52998277577697, 1.193784433793109],
            [34.52793952981548, 1.197538880358125],
            [34.52410458773159, 1.202949402083929],
            [34.52268266692623, 1.206052330922058],
            [34.52041768081999, 1.207970958982593],
            [34.51961788556971, 1.209843548312693],
            [34.5162124423962, 1.214050986707814],
            [34.514597871589984, 1.218148896461071],
            [34.51142953693909, 1.221569384485226],
            [34.50854229502206, 1.223524556420062],
            [34.50735744411176, 1.226772085085356],
            [34.50626199264022, 1.227215875919539],
            [34.505106898423705, 1.228446535855505],
            [34.49980949366739, 1.234907101652658],
            [34.49404774435081, 1.237596509365177],
            [34.492230301614086, 1.237470920951144],
            [34.49024974188974, 1.238937210241994],
            [34.486872972041795, 1.24032289561238],
            [34.47993170601106, 1.245907140146637],
            [34.476825435064825, 1.246976132061618],
            [34.4746535413715, 1.24878621580041],
            [34.47081948053491, 1.249005452350123],
            [34.46902680704548, 1.248029672592534],
            [34.46812370463923, 1.248012094936536],
            [34.466798539576466, 1.248483142307552],
            [34.46472529707103, 1.249976626280844],
            [34.461447136190124, 1.251045700962631],
            [34.45944170930206, 1.252303992464044],
            [34.45408083677428, 1.253021508382163],
            [34.45379847112767, 1.253265862649852],
            [34.454025443958926, 1.254423416803025],
            [34.453770184976, 1.254930051126284],
            [34.45310584039919, 1.255029909945259],
            [34.45207482867627, 1.257309667899232],
            [34.45009236362521, 1.258468462331774],
            [34.44684896934244, 1.259501351859235],
            [34.444709088012544, 1.261401876141572],
            [34.438867780301166, 1.264851071540927],
            [34.43741172620996, 1.266335173620832],
            [34.434127666092586, 1.271085360060173],
            [34.42908209683963, 1.274434638685575],
            [34.42674475233559, 1.276805599707193],
            [34.4254195261874, 1.277240477488615],
            [34.42424230287219, 1.278208895396334],
            [34.42219315677588, 1.277685466813601],
            [34.42002884755849, 1.280390470699026],
            [34.41895884805393, 1.280259450895602],
            [34.41601719158689, 1.281433680405941],
            [34.40855380854336, 1.285733349415708],
            [34.40709769246839, 1.286069185327002],
            [34.405379022192086, 1.28767877673742],
            [34.404191804221, 1.287476716712064],
            [34.40216667458384, 1.289406212421651],
            [34.401799032765624, 1.290566118620151],
            [34.400898567813016, 1.290882234591627],
            [34.40024801507079, 1.291897639728673],
            [34.40055845217174, 1.292723006638121],
            [34.40029532664185, 1.293659915602194],
            [34.39920931826059, 1.294584463862833],
            [34.39592340312214, 1.294911659019441],
            [34.39348995505239, 1.296145435619487],
            [34.39058195127251, 1.296321555555735],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1427,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "MASIIRA",
        Population: 9522,
        Key: "BULAMBULIMASIIRA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.752082438680873, -0.061766452749841],
            [31.750992907107058, -0.060998603828358],
            [31.75473030293089, -0.055795714425601],
            [31.751646724327042, -0.056830430300984],
            [31.74608997235493, -0.059572538087382],
            [31.742603376276975, -0.061766238052626],
            [31.739879508265734, -0.061985552618175],
            [31.736603466510587, -0.061238730553697],
            [31.736392963391744, -0.062259693128927],
            [31.732688408178106, -0.066976208289091],
            [31.72582423466674, -0.06982792609232],
            [31.725497311683696, -0.072131366409836],
            [31.725933079936446, -0.073886387385865],
            [31.7324702379383, -0.076848154569424],
            [31.737917907485468, -0.078383951597493],
            [31.74162229471415, -0.080577833937982],
            [31.7450125698341, -0.084162881665726],
            [31.748813123510594, -0.086501258435456],
            [31.754696648447098, -0.087927407755236],
            [31.76112490009377, -0.091218302724854],
            [31.76265026190407, -0.091657112114387],
            [31.76493844520589, -0.08803742968826],
            [31.76275938385492, -0.086501703999342],
            [31.7638489558529, -0.08595329032594],
            [31.770168378399546, -0.0860631793142],
            [31.7708222162808, -0.082662810816975],
            [31.77104025806148, -0.078165529134934],
            [31.77300153904152, -0.075368487769817],
            [31.764503157551815, -0.069225631290576],
            [31.761445708244676, -0.066205682467785],
            [31.752082438680873, -0.061766452749841],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1428,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "KYAMULIBWA TOWN COUNCIL",
        Population: 4815,
        Key: "KALUNGUKYAMULIBWA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.789548078976914, -0.13802200971686],
            [31.79120522453774, -0.138040186175584],
            [31.795879622491697, -0.136728860734627],
            [31.799393614490867, -0.134775205646869],
            [31.801911704521665, -0.132866782251987],
            [31.805156236969918, -0.129447788866055],
            [31.809238483454905, -0.12278153395755],
            [31.810022158437402, -0.122229772903266],
            [31.82209463820194, -0.117825195407378],
            [31.82161554869459, -0.112940615956027],
            [31.822686403395352, -0.10605711249468],
            [31.824335373388763, -0.09001055796337],
            [31.825143787075866, -0.08903371135285],
            [31.827149381050557, -0.088264881052377],
            [31.82959557082433, -0.086546328658505],
            [31.83264131598166, -0.081969417236146],
            [31.833871235369767, -0.078161335803119],
            [31.835013639984577, -0.071087775494742],
            [31.836371815439037, -0.067079257558081],
            [31.832934952790158, -0.065981874550207],
            [31.826092351422023, -0.069767077853376],
            [31.825847666508327, -0.069495582920496],
            [31.823060643339343, -0.069794027291913],
            [31.822278687732286, -0.069432174484442],
            [31.819338389517956, -0.069377820161446],
            [31.81611564840189, -0.06834658280787],
            [31.813052463351617, -0.064945443967665],
            [31.807584144231036, -0.060757297614621],
            [31.806272709019083, -0.058694927641349],
            [31.8061126966091, -0.05606272504185],
            [31.80530944194666, -0.054723990654122],
            [31.803403294168888, -0.053493789743629],
            [31.798546215717064, -0.05164845509418],
            [31.79606623311894, -0.047126737385209],
            [31.79458790799522, -0.046106588428348],
            [31.78853021050492, -0.044020251826389],
            [31.78608230135569, -0.043559128759434],
            [31.78397245340069, -0.042590176523385],
            [31.77986374883566, -0.039236232824079],
            [31.776791475529684, -0.037745626270182],
            [31.77075799033122, -0.036925703541721],
            [31.769508524500868, -0.035667781223702],
            [31.76907421062055, -0.036117219950265],
            [31.767983389066, -0.036162415979841],
            [31.7671520611526, -0.034878001440196],
            [31.767377552661983, -0.033813498019786],
            [31.762311369768195, -0.030583317567013],
            [31.759728503120567, -0.0304011635077],
            [31.753176837326894, -0.026041106364562],
            [31.75077089567113, -0.023022627149733],
            [31.746590045608983, -0.021668030686419],
            [31.74385804425115, -0.02327275134211],
            [31.74109891826333, -0.026908893209404],
            [31.74007662828349, -0.027505851496165],
            [31.737581206340547, -0.025410215112532],
            [31.73265822837782, -0.026528127046266],
            [31.730881458662168, -0.028055929405844],
            [31.727142922876254, -0.0322294800778],
            [31.725869245652373, -0.041076269534838],
            [31.72431045753034, -0.044067764606033],
            [31.718952463204726, -0.050188307058535],
            [31.716444690324956, -0.052042134419724],
            [31.712632148631, -0.053495368981204],
            [31.706931881809098, -0.054501411584042],
            [31.703294371458366, -0.055698837456243],
            [31.70513900619873, -0.067629264185449],
            [31.705183816860075, -0.071283440090714],
            [31.70346494625945, -0.082354499449673],
            [31.702309909535128, -0.100669545415731],
            [31.716621264973828, -0.114483960795393],
            [31.717739597433983, -0.115610221312371],
            [31.72332108272081, -0.121491787905286],
            [31.726814862626085, -0.125473209913638],
            [31.732099272353526, -0.129190998011324],
            [31.736088528833537, -0.123626966161236],
            [31.737985939596882, -0.122108956958716],
            [31.740244219779516, -0.121059824985427],
            [31.74296544854045, -0.120544382702535],
            [31.75071218986898, -0.120436198832072],
            [31.75180301142356, -0.119631226560695],
            [31.756952989167033, -0.11775003172977],
            [31.758258038255587, -0.11744256959831],
            [31.758756111859828, -0.11737021404734],
            [31.760227383411934, -0.116990395461491],
            [31.760986600862523, -0.116773326109565],
            [31.762434853085477, -0.115986460137791],
            [31.764179900593454, -0.115045828030699],
            [31.767875801437693, -0.112459035453724],
            [31.76795636953887, -0.112404786298156],
            [31.77187635782566, -0.109139626548882],
            [31.774598006998172, -0.106218106487026],
            [31.776116441000994, -0.105539774502835],
            [31.77756441294958, -0.105340812377342],
            [31.779602535819034, -0.105820287346174],
            [31.780408036269677, -0.106082622808406],
            [31.781450819516113, -0.106444510294844],
            [31.785889760050942, -0.10958337911786],
            [31.788269172659756, -0.111410535533114],
            [31.78905846211278, -0.112025739297745],
            [31.789907229919095, -0.112713230340608],
            [31.79134586747358, -0.113880125240277],
            [31.79151037145998, -0.114621865390619],
            [31.79143790975588, -0.115146466987236],
            [31.79017142534249, -0.119461038405605],
            [31.787792714317906, -0.126082378497865],
            [31.787283868116774, -0.127429848126531],
            [31.78670413944987, -0.132042895489048],
            [31.787114241038324, -0.134204777012929],
            [31.7880354004801, -0.135796790296361],
            [31.788720997399896, -0.136800865889402],
            [31.789548078976914, -0.13802200971686],
          ],
          [
            [31.762650273582164, -0.091657104927852],
            [31.761124892008926, -0.091218299131604],
            [31.754696639463926, -0.087927416738363],
            [31.748813129798805, -0.086501271910164],
            [31.74501255456275, -0.084162883462351],
            [31.741622292019223, -0.080577836632937],
            [31.737917899400625, -0.078383949800867],
            [31.732470248718066, -0.07684814738292],
            [31.725933074546564, -0.073886376606108],
            [31.725497321565165, -0.07213136461321],
            [31.72582422478527, -0.069827924295694],
            [31.732688405483145, -0.066976196611004],
            [31.736392974171547, -0.062259693128927],
            [31.736603481781938, -0.061238737740203],
            [31.739879525333713, -0.06198556699122],
            [31.742603385260146, -0.061766252425637],
            [31.746089971456634, -0.059572538985712],
            [31.75164671803883, -0.056830432995941],
            [31.75473029125279, -0.055795721612108],
            [31.75099291339527, -0.060998613709821],
            [31.761445723516026, -0.066205681569488],
            [31.764503153958557, -0.069225633087202],
            [31.77300153275331, -0.075368490464773],
            [31.771040257163182, -0.078165512066972],
            [31.770822205500995, -0.082662803630472],
            [31.77016836492482, -0.086063168534447],
            [31.76384896303941, -0.085953300207397],
            [31.762759369481866, -0.086501693219556],
            [31.764938450595803, -0.08803742519668],
            [31.762650273582164, -0.091657104927852],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1429,
        District: "KALUNGU",
        County: "KALUNGU",
        Subcounty: "KYAMULIBWA",
        Population: 28265,
        Key: "KALUNGUKYAMULIBWA",
        Dist2: "Kalungu",
        "Sub Country": "Kyamulibwa",
        id2_original: "Kalungu Kyamulibwa",
        drought: "M",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "L",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "L",
        landslide: "L",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.55240498919202, 1.107313221923497],
            [31.549070251516223, 1.108041501821074],
            [31.546309506764235, 1.110771543243778],
            [31.544238475910976, 1.113917960640421],
            [31.54188379212533, 1.119484456528887],
            [31.533974762954205, 1.114404796786647],
            [31.528790951962183, 1.114502914676147],
            [31.524947206388514, 1.116434942328727],
            [31.526027425127747, 1.117563637029032],
            [31.52770617606947, 1.122492079071097],
            [31.531427108469064, 1.126039583284805],
            [31.534405013754455, 1.127262496502627],
            [31.533285136192024, 1.128482913272874],
            [31.528235525418623, 1.138094253218869],
            [31.536549546560884, 1.145180448793985],
            [31.537840987071206, 1.147864954058599],
            [31.535253045840538, 1.152418008167467],
            [31.53210120246163, 1.153636294676742],
            [31.527539458634216, 1.15324588153756],
            [31.527085299172654, 1.151805040912864],
            [31.52388977611138, 1.151296892045574],
            [31.521759396262247, 1.151747992352995],
            [31.518817587979928, 1.151502255751374],
            [31.516169026637264, 1.152712798047319],
            [31.510752614868732, 1.151262865343067],
            [31.509159570391656, 1.151949387173375],
            [31.507617690359893, 1.151984750290632],
            [31.505973530844802, 1.1532319838225],
            [31.50345801718225, 1.152941235596809],
            [31.50297179415325, 1.151105002131189],
            [31.503074648558346, 1.148798781705041],
            [31.501118520314765, 1.145216240405795],
            [31.498043399349324, 1.142220987229566],
            [31.495798723253365, 1.138439333113447],
            [31.49247411408238, 1.134657116292899],
            [31.48977040067285, 1.132937302374271],
            [31.489272705259353, 1.131562328346381],
            [31.487733464477895, 1.129806953407662],
            [31.486506696379802, 1.126523283800827],
            [31.48530473256337, 1.125771989106822],
            [31.482732601681683, 1.122116809796882],
            [31.481862437801936, 1.12155561855435],
            [31.480225386655754, 1.119456525154114],
            [31.476501048742893, 1.116433858267996],
            [31.47344218997904, 1.119364601928216],
            [31.465578713477658, 1.124120280559973],
            [31.458468578546555, 1.124116501176798],
            [31.44748088365787, 1.122890749407235],
            [31.439837902236242, 1.118344304941838],
            [31.435151251261786, 1.114604841596579],
            [31.435696319331782, 1.113992433069694],
            [31.43627809256431, 1.111535618807045],
            [31.43781218599917, 1.11085991367065],
            [31.43920871861797, 1.108677275082813],
            [31.44320268676166, 1.106144888038379],
            [31.445865369620595, 1.105490828836925],
            [31.445838960049556, 1.10438559365195],
            [31.446496188172652, 1.103575534626916],
            [31.450794543263868, 1.101284000852474],
            [31.453596846775806, 1.093874483174723],
            [31.455826967469264, 1.091673029331576],
            [31.4575372825151, 1.089237814309489],
            [31.45857199709363, 1.087330258970064],
            [31.459650457829884, 1.083754690599013],
            [31.461446369745914, 1.08181469851961],
            [31.462870443812985, 1.078809862348755],
            [31.46465849636857, 1.077903935315687],
            [31.46579492449179, 1.078137263744357],
            [31.466376378822385, 1.077560775813255],
            [31.46719031535188, 1.074144659306239],
            [31.469013548628926, 1.073262894024044],
            [31.470813010686953, 1.073626441288682],
            [31.471565264397444, 1.072818183788072],
            [31.474627130720876, 1.073041382284256],
            [31.475559145404546, 1.072777175698242],
            [31.475934834331092, 1.07177365840367],
            [31.476910781123774, 1.071698337066294],
            [31.477898180537988, 1.069155195836524],
            [31.478646843682284, 1.068534904790967],
            [31.47919333468368, 1.067299597214506],
            [31.48039612225525, 1.066546966463501],
            [31.480106076012955, 1.065554199903304],
            [31.48112282608247, 1.064586456665271],
            [31.480727660782218, 1.063497654557474],
            [31.480932535955812, 1.06272591091518],
            [31.485597542921806, 1.058654847272163],
            [31.486109625752878, 1.057552024560061],
            [31.48997324745053, 1.055428923621177],
            [31.49105770264468, 1.055890707744031],
            [31.49231461820369, 1.054787566100811],
            [31.49347111019878, 1.055213575591004],
            [31.49542725101876, 1.054843719255086],
            [31.49580138765649, 1.055160448354402],
            [31.498583202393466, 1.053877528289648],
            [31.49980369845422, 1.054059005777209],
            [31.501946254068702, 1.051997965579219],
            [31.50239457537924, 1.052785030070429],
            [31.502682140474718, 1.052703771408363],
            [31.504183543318103, 1.050972405979333],
            [31.50552778680085, 1.050643064432012],
            [31.506653464785035, 1.049467857594901],
            [31.50837293276533, 1.049043605926638],
            [31.508964278445493, 1.048437925796236],
            [31.509900894300063, 1.048637349831567],
            [31.51316657848001, 1.047209923080239],
            [31.51446561514436, 1.044723362396168],
            [31.51455961755066, 1.04353861750828],
            [31.514141548803945, 1.042489330069969],
            [31.514781421475757, 1.040590290961561],
            [31.51590152182036, 1.039315580471248],
            [31.518505465639493, 1.038303854801065],
            [31.52118779645035, 1.036586705728487],
            [31.523942280843094, 1.033675735632978],
            [31.52708284946687, 1.028160836078015],
            [31.52823295803355, 1.023421481531817],
            [31.536858576001777, 1.017094412350165],
            [31.544245062358662, 1.01230157224185],
            [31.544790743079684, 1.019338576821956],
            [31.546485214538876, 1.024381738610696],
            [31.54672486080215, 1.030440848649372],
            [31.54741101198246, 1.031823755324586],
            [31.551934265694943, 1.034957005026574],
            [31.5561743506669, 1.038944087594611],
            [31.558678504234393, 1.040246510286832],
            [31.56995178522999, 1.036063208307849],
            [31.571325416198913, 1.035941839705042],
            [31.58239286082359, 1.040420013737126],
            [31.588289372704132, 1.044529865109495],
            [31.590066835020835, 1.04481532650515],
            [31.58909688538104, 1.045607859039114],
            [31.584712601043005, 1.047639122090441],
            [31.582994889269102, 1.04924460889684],
            [31.582326915498562, 1.052294183601624],
            [31.582366162893347, 1.054835767817618],
            [31.58452445519496, 1.061648163616012],
            [31.581555844777835, 1.059938859324288],
            [31.579414757908832, 1.059714211143294],
            [31.577010796139945, 1.060099413784915],
            [31.572203344217673, 1.059853190875876],
            [31.568930562448692, 1.060746293001495],
            [31.563678582801337, 1.06082516593671],
            [31.55923530070873, 1.059399818627206],
            [31.55769936842248, 1.061025682240485],
            [31.553937776476467, 1.070539415550516],
            [31.55236394337004, 1.088156570879629],
            [31.55131207186791, 1.091246563269467],
            [31.54852247233069, 1.095443810435416],
            [31.548431259193375, 1.096094396894788],
            [31.54922802442618, 1.098432993234402],
            [31.55212468248402, 1.102622856517384],
            [31.553022244081607, 1.105378317824985],
            [31.55240498919202, 1.107313221923497],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1431,
        District: "KYANKWANZI",
        County: "KIBOGA",
        Subcounty: "BYERIMA",
        Population: 15811,
        Key: "KYANKWANZIBYERIMA",
        Dist2: "Kyankwanzi",
        "Sub Country": "Byerima",
        id2_original: "KyankwanziByerima",
        drought: "M",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "M",
        heatwave: "M",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.875133705885865, -0.999419639540072],
            [32.87563939540706, -0.61578475265308],
            [32.87581258430564, -0.483406505696434],
            [32.87617222303302, -0.206877203590028],
            [32.87559983450029, -0.020798725655768],
            [32.872128988584215, -0.016600754827155],
            [32.868999700105455, -0.008827207967882],
            [32.860093940719224, 0.008660604620601],
            [32.85803450531967, 0.017231882372174],
            [32.85251887013644, 0.035046462474084],
            [32.846982535074105, 0.06166112175061],
            [32.84534736410177, 0.066863370084881],
            [32.62005702975616, 0.047641214050579],
            [32.62010043814734, -0.002106958972562],
            [32.61842303108528, -0.003726392357257],
            [32.59821977032678, -0.029926865679834],
            [32.587768924821546, -0.042619929615691],
            [32.52692766915521, -0.119257064684865],
            [32.500986982763074, -0.152486254118029],
            [32.72725362592243, -0.151802671834531],
            [32.74027257336523, -0.152200911564888],
            [32.74500661675913, -0.151802886531151],
            [32.753291250415174, -0.151802980853915],
            [32.753290721307486, -0.193501821636541],
            [32.7513175708876, -0.228849445694115],
            [32.75171185224557, -0.245930681500448],
            [32.750922465774494, -0.25864206357165],
            [32.75131688277809, -0.266187485166146],
            [32.75090247736111, -0.442274251422795],
            [32.75052127727027, -0.500511413267731],
            [32.750642548037, -0.629299368795266],
            [32.75099278679325, -1.000056022386913],
            [32.875133705885865, -0.999419639540072],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1725,
        District: "MUKONO",
        County: "MUKONO",
        Subcounty: "KOOME ISLAND",
        Population: 18778,
        Key: "MUKONOKOOME ISLAND",
        Dist2: "Mukono",
        "Sub Country": "Kyampisi",
        id2_original: "MukonoKyampisi",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "L",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "L",
        landslide: "N",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.354732476111046, -0.40936329986158],
            [31.35109225733973, -0.407635365160495],
            [31.342177778007045, -0.398346034848749],
            [31.339589474755343, -0.396653886732361],
            [31.340678108013858, -0.393348763310151],
            [31.341298493532232, -0.392632651295808],
            [31.341883401885067, -0.38671923334652],
            [31.342394326787748, -0.386021461255528],
            [31.34354596877865, -0.385578629707357],
            [31.34564435333229, -0.382989565426852],
            [31.342635220810966, -0.378342633618252],
            [31.34207002149545, -0.376652943735313],
            [31.341942715846653, -0.374559307748866],
            [31.342508887139328, -0.371033329606438],
            [31.343877492034228, -0.368756321188065],
            [31.344661962025757, -0.368517721909068],
            [31.336689746255857, -0.369967070521992],
            [31.333515603996663, -0.369782825404829],
            [31.329800356136168, -0.367828707650303],
            [31.3298218168883, -0.367120043094907],
            [31.32878222715271, -0.369304961257653],
            [31.323320827754745, -0.373545325437873],
            [31.320584399499225, -0.377015027930272],
            [31.311238592286234, -0.379315676447961],
            [31.30932336433756, -0.380350856064132],
            [31.30828349522592, -0.381804831632991],
            [31.308173792065112, -0.38321492433769],
            [31.309245625929506, -0.386189597804469],
            [31.309015418264895, -0.388238624343877],
            [31.31055703419198, -0.39503613138065],
            [31.311005446232354, -0.396292107896547],
            [31.31181348981355, -0.396851052328552],
            [31.311525436034543, -0.400926830982049],
            [31.314500889817523, -0.400467693505579],
            [31.31659385573337, -0.404362726641456],
            [31.320716333268365, -0.407424790113258],
            [31.322430034064524, -0.407269492393517],
            [31.32520011500725, -0.407944573619244],
            [31.32893604567881, -0.411110342661151],
            [31.330648914635027, -0.415002089188657],
            [31.332581675901412, -0.41480792702415],
            [31.336318646822114, -0.413012184137807],
            [31.337658642171856, -0.413148664326785],
            [31.339307732539513, -0.413972689030382],
            [31.3412079370634, -0.415477765181955],
            [31.345215468869554, -0.41386366873917],
            [31.347805731346888, -0.411924984016899],
            [31.354732476111046, -0.40936329986158],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1432,
        District: "LWENGO",
        County: "BUKOTO",
        Subcounty: "KYAZANGA TOWN COUNCIL",
        Population: 15196,
        Key: "LWENGOKYAZANGA TOWN COUNCIL",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.22293035524913, 1.901085069036773],
            [34.206518311976396, 1.901301742820062],
            [34.200696261449735, 1.901007976750745],
            [34.194776277489126, 1.901806397003512],
            [34.168972031713906, 1.901178840136266],
            [34.16541993946861, 1.901578405357331],
            [34.157871061962865, 1.901434593348025],
            [34.13492773028034, 1.900159208105342],
            [34.13474052945994, 1.900644501111536],
            [34.131745081873696, 1.899714518045168],
            [34.11911266871783, 1.89719096606799],
            [34.111168534283735, 1.896352174854107],
            [34.1072141836407, 1.884986209088541],
            [34.105832005201826, 1.883894921621558],
            [34.09709932152647, 1.884396926888012],
            [34.09162256003884, 1.8842018168588],
            [34.087699618989696, 1.883434798183786],
            [34.084935793914624, 1.882096131376543],
            [34.08101704709956, 1.879409115152089],
            [34.08004878180092, 1.878152438931364],
            [34.07708700127486, 1.875820979548276],
            [34.07644462050676, 1.874232747480914],
            [34.07412395681923, 1.871404432088985],
            [34.07249546571934, 1.870908988968376],
            [34.0714106997081, 1.872051486327307],
            [34.07007827266464, 1.871605502484943],
            [34.070373282997195, 1.869917398403181],
            [34.068793589281846, 1.868528313056232],
            [34.06588222490452, 1.867934356552848],
            [34.065290305200875, 1.868182942719365],
            [34.06440175190895, 1.86743881189499],
            [34.063513827437724, 1.867737222756133],
            [34.06178627192492, 1.866596441052538],
            [34.06030600913514, 1.866448406313115],
            [34.05847992550366, 1.865555905045933],
            [34.056160153843216, 1.864167248113083],
            [34.05350501773099, 1.86157651942718],
            [34.05218571956538, 1.859738819843454],
            [34.05188884612691, 1.858324112804818],
            [34.050556279844564, 1.857629879940756],
            [34.0493228480437, 1.857705086875655],
            [34.04762034115431, 1.857184829792388],
            [34.044215024643265, 1.855623035876982],
            [34.04384359732442, 1.853265106879614],
            [34.04205885955221, 1.850767579344048],
            [34.04090966367385, 1.849773365619394],
            [34.040796988886086, 1.848390985709012],
            [34.041880705665086, 1.845536827397841],
            [34.041908516607954, 1.842046509301723],
            [34.0429637666739, 1.840216721099941],
            [34.043382484902544, 1.837097473706047],
            [34.04371711004084, 1.836765426777325],
            [34.045263845466685, 1.836724778244996],
            [34.04629073931238, 1.835895536491151],
            [34.04633429951884, 1.834168376695073],
            [34.045646162163415, 1.833760226116197],
            [34.04510665017344, 1.832066180783339],
            [34.045419429182346, 1.831305182942033],
            [34.04665904139233, 1.830786633046365],
            [34.04611985638916, 1.829021106459166],
            [34.04619644495363, 1.827877830776392],
            [34.04774906434462, 1.826550618113582],
            [34.04805955983605, 1.823681065230577],
            [34.05036222128532, 1.819617325262028],
            [34.05146200353481, 1.818454869742698],
            [34.053631897578335, 1.817416371602138],
            [34.05461239703287, 1.816324827961144],
            [34.05539438767421, 1.814410425688806],
            [34.0558366696111, 1.811338954774813],
            [34.057448904797596, 1.807367397247247],
            [34.0577433240387, 1.805415047839105],
            [34.05742806747626, 1.804115139964921],
            [34.057739746048924, 1.803592395491805],
            [34.057586471003575, 1.800684995028169],
            [34.056941142863025, 1.798128509233104],
            [34.06444026088855, 1.796058068725473],
            [34.06743990809876, 1.795666619880042],
            [34.06950687407535, 1.796319262935089],
            [34.07558285677324, 1.796978114552271],
            [34.07821692559543, 1.798491011031029],
            [34.08011767360006, 1.799071412952021],
            [34.085025046928, 1.802953261706739],
            [34.08958003272955, 1.805916640685942],
            [34.09112780121799, 1.80249238827931],
            [34.09183238492964, 1.799279170754763],
            [34.09020191394286, 1.796817815392338],
            [34.08968517783862, 1.794248043715448],
            [34.091006478349, 1.793009426739188],
            [34.09245830317184, 1.7902880010235],
            [34.09745633447827, 1.784687829888575],
            [34.098486851229495, 1.783048555238845],
            [34.10387260709064, 1.770659999033156],
            [34.1056223851269, 1.767808887130705],
            [34.109752703157696, 1.764658801586574],
            [34.112183420349, 1.763788251959116],
            [34.1193788027056, 1.764142340105645],
            [34.12206406921076, 1.764845373087346],
            [34.127057846095994, 1.765392020500201],
            [34.13539678291099, 1.765393826154771],
            [34.14124149703396, 1.767159324504038],
            [34.151988798261016, 1.765956808694199],
            [34.15935139482126, 1.766144725999618],
            [34.17552128912433, 1.765323784534153],
            [34.18012345354628, 1.76564218849278],
            [34.18573246770499, 1.766906154177682],
            [34.1859896526759, 1.767907931327934],
            [34.186771746623506, 1.768578508746417],
            [34.19051471829029, 1.766856054710898],
            [34.191631473308775, 1.767170765393478],
            [34.1919366777232, 1.768077457902172],
            [34.19038417870647, 1.769428503496937],
            [34.191019113339166, 1.771075215755141],
            [34.19051510905743, 1.772049771249362],
            [34.19065539176882, 1.77259835687005],
            [34.193326103769785, 1.773884884352034],
            [34.19498395271144, 1.77555998284037],
            [34.19577001361937, 1.775349066291287],
            [34.196560356796226, 1.774185215116582],
            [34.1987709615901, 1.774623911623787],
            [34.198958495685424, 1.775244183551439],
            [34.198004188409655, 1.775835532636927],
            [34.19754542777722, 1.777334410826177],
            [34.19796572075255, 1.779099285435354],
            [34.198964181122854, 1.779270504389998],
            [34.199468719003875, 1.778176834199558],
            [34.20127884136936, 1.777732250219741],
            [34.20296167695068, 1.779145387199069],
            [34.20605081612612, 1.779969176901936],
            [34.2062628966866, 1.780422771482449],
            [34.205719005409634, 1.782338204262834],
            [34.20620832852469, 1.78462750585143],
            [34.205682904813315, 1.785077817535272],
            [34.20560384049188, 1.786792812960631],
            [34.20588728860843, 1.787246739869632],
            [34.207646835823425, 1.7874689916664],
            [34.20809074101602, 1.789281605670813],
            [34.20770559103291, 1.790280499262889],
            [34.20796408305253, 1.790996380779898],
            [34.208604624070944, 1.791404239312836],
            [34.21037751306453, 1.791304916240168],
            [34.213295876216236, 1.793080892236802],
            [34.216611222858354, 1.796526291977597],
            [34.21851842525826, 1.800966045004741],
            [34.222483819789396, 1.802698982949471],
            [34.2227803240203, 1.880048403776879],
            [34.22293035524913, 1.901085069036773],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1433,
        District: "KATAKWI",
        County: "USUK",
        Subcounty: "NGARIAM",
        Population: 10946,
        Key: "KATAKWINGARIAM",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.65880518586063, 0.229214484871411],
            [33.65880507806278, 0.229257176065282],
            [33.62854356252768, 0.221394269718829],
            [33.62574824341704, 0.215062004977232],
            [33.621434098638105, 0.2104359431254],
            [33.605021720293756, 0.195613701981303],
            [33.597425185365566, 0.190043582285898],
            [33.585983403778876, 0.178997579356096],
            [33.57275978777495, 0.168518060220858],
            [33.55916110717365, 0.160304434481971],
            [33.55250248886055, 0.158133090856702],
            [33.546312739023485, 0.154451099751074],
            [33.53825903527751, 0.151833503703474],
            [33.53902863635446, 0.147136663854281],
            [33.5386500018521, 0.140440108320167],
            [33.5374387728118, 0.135667869838439],
            [33.53380520786178, 0.126066133403582],
            [33.5367571886664, 0.120122089212058],
            [33.53743837755308, 0.116845265742985],
            [33.5382710071253, 0.116083201308989],
            [33.53917929281077, 0.113339808523701],
            [33.5403903889004, 0.11219671262354],
            [33.540390371832416, 0.11128225455614],
            [33.54197992365968, 0.109148489311398],
            [33.542074466851744, 0.104995326290979],
            [33.54307736849283, 0.101851859433835],
            [33.54521567507601, 0.097698661322756],
            [33.547032323702034, 0.096174536877337],
            [33.54752431211854, 0.094498024163276],
            [33.548205553107515, 0.093774068361348],
            [33.553579812329644, 0.089925644815817],
            [33.55452596200434, 0.08775379685252],
            [33.55606861458724, 0.08597208485716],
            [33.54348710806022, 0.044674295225891],
            [33.537153390622464, 0.01642629661636],
            [33.522165832845175, -0.026934334393759],
            [33.5215608920615, -0.094604432158739],
            [33.5218972994573, -0.149301553325893],
            [33.52111380144292, -0.316132512722443],
            [33.52111824091705, -0.395823423993092],
            [33.52357513681237, -0.999184497265765],
            [33.52012788963881, -0.999186087940215],
            [33.65793786604706, -0.999119706247201],
            [33.659087473353836, -0.355559711686727],
            [33.6591507425976, -0.067931109587812],
            [33.670104885410396, -0.067478627596807],
            [33.677757698892854, -0.065361600830353],
            [33.68390980482791, -0.062638456763721],
            [33.68976199113741, -0.059010666432531],
            [33.69306322255143, -0.055536700607013],
            [33.69921581627172, -0.045874774650708],
            [33.70326677533366, -0.035073036431846],
            [33.70431698854581, -0.028876058819664],
            [33.70446747522054, -0.021322102969558],
            [33.7035218052462, -0.011707451962308],
            [33.702449492579746, -0.00654890256161],
            [33.70110437593455, -0.002767388690746],
            [33.6983018487421, 0.000923648673391],
            [33.69351337462851, 0.005320337839574],
            [33.68188420447356, 0.009282819999596],
            [33.67764779181448, 0.009626602559185],
            [33.66789219742338, 0.009210475975756],
            [33.66325701632148, 0.00867673117641],
            [33.65905315860827, 0.007627311187295],
            [33.65882710116029, 0.180904396855476],
            [33.65880518586063, 0.229214484871411],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1435,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "JAGUZI",
        Population: 13217,
        Key: "MAYUGEJAGUZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.62854356252768, 0.221394269718829],
            [33.62737667792307, 0.273196320282191],
            [33.626649411750506, 0.284939111079372],
            [33.62627496609232, 0.288078373828842],
            [33.62524957872137, 0.291353374788631],
            [33.624136563389406, 0.29440221253859],
            [33.62237707456489, 0.297161590116169],
            [33.619166321466295, 0.300527189446495],
            [33.60418512735451, 0.314767773301281],
            [33.594650997325374, 0.322838128148251],
            [33.593350722782525, 0.321987799956571],
            [33.58886425058937, 0.320425805140424],
            [33.581699474732815, 0.31934109466226],
            [33.57865599333001, 0.318256143324865],
            [33.57174480558995, 0.31678842199526],
            [33.5633744025872, 0.31707174719966],
            [33.56097572650543, 0.316564266111301],
            [33.556917185662485, 0.308944229802103],
            [33.553143294881934, 0.305362252671556],
            [33.54769647963262, 0.297862222574775],
            [33.542454864747, 0.292940950345484],
            [33.53886240131451, 0.290643201935726],
            [33.53286494484716, 0.288788864842098],
            [33.53017950406883, 0.285342101105148],
            [33.52708688481996, 0.282365793617608],
            [33.52360958450856, 0.280565606781562],
            [33.51738915540793, 0.278901244229405],
            [33.51456120858784, 0.278928511368453],
            [33.51281892699264, 0.278503379707207],
            [33.5066783266797, 0.278693637041927],
            [33.49729086907859, 0.281308628557047],
            [33.493583415899806, 0.28279249896772],
            [33.48780408924806, 0.286474884134378],
            [33.48181242062611, 0.289514943178762],
            [33.46768180173096, 0.295007101303198],
            [33.45403636561574, 0.299178371349129],
            [33.44353220689504, 0.301313919528314],
            [33.43332624303457, 0.30267139789845],
            [33.41235195287784, 0.303269337836341],
            [33.399436388049466, 0.3027722368732],
            [33.391950428546224, 0.301641624899018],
            [33.391363881666315, 0.303202406200234],
            [33.39228537617971, 0.300746591849469],
            [33.39307584691732, 0.296779613621953],
            [33.394638035162735, 0.284784353929887],
            [33.396192942562735, 0.278940810057269],
            [33.397290740433775, 0.277135399951839],
            [33.40699520810879, 0.267088728182014],
            [33.41586721509481, 0.255945989670496],
            [33.42204949184702, 0.250461020837743],
            [33.42242125064423, 0.248570160553358],
            [33.42020764098573, 0.24554849767634],
            [33.4185226602275, 0.240862418027612],
            [33.417529036386696, 0.234678016116403],
            [33.41759598602818, 0.2299242308937],
            [33.41892766118177, 0.224656335924004],
            [33.42092687801627, 0.221289848532785],
            [33.42184700529378, 0.219839334320018],
            [33.42622440404516, 0.216060943367974],
            [33.42622443279123, 0.210017076799311],
            [33.47634777920828, 0.159888908691324],
            [33.49542827162576, 0.150928918641091],
            [33.52731221014101, 0.139952165579818],
            [33.52820193214112, 0.14015785670745],
            [33.52793796938139, 0.144039738198775],
            [33.529103955670735, 0.147407623594979],
            [33.52978887795575, 0.148181380399118],
            [33.53207941843685, 0.149666663347357],
            [33.53825903527751, 0.151833503703474],
            [33.546312739023485, 0.154451099751074],
            [33.55250248886055, 0.158133090856702],
            [33.55916110717365, 0.160304434481971],
            [33.57275978777495, 0.168518060220858],
            [33.585983403778876, 0.178997579356096],
            [33.597425185365566, 0.190043582285898],
            [33.605021720293756, 0.195613701981303],
            [33.621434098638105, 0.2104359431254],
            [33.62574824341704, 0.215062004977232],
            [33.62854356252768, 0.221394269718829],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1436,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "MALONGO",
        Population: 102061,
        Key: "MAYUGEMALONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.46484430761606, 0.428538355460728],
            [33.46304004675781, 0.428582884601974],
            [33.459267305820816, 0.427777816264391],
            [33.4563208011462, 0.427837318111818],
            [33.45358623240327, 0.428397599679747],
            [33.45124063058511, 0.427899049515134],
            [33.44935898884828, 0.428356405888833],
            [33.44653658732848, 0.430022248014637],
            [33.44137666792977, 0.437722084918596],
            [33.43954891882174, 0.43815117962889],
            [33.436359758527644, 0.439719936134229],
            [33.432856380123546, 0.440492652229835],
            [33.42940537709378, 0.440738498581983],
            [33.42731911889816, 0.441371243238906],
            [33.42367147914425, 0.445201357227127],
            [33.4213318178851, 0.446235579675226],
            [33.42036167959905, 0.446063288027223],
            [33.42013338085443, 0.445488808536278],
            [33.42001899118277, 0.44095032673377],
            [33.419562350574424, 0.438997080383393],
            [33.41869864288662, 0.437518809285788],
            [33.414862655163745, 0.435558092764822],
            [33.413815350696495, 0.435377409948997],
            [33.41124206458137, 0.43661261699011],
            [33.40957859667758, 0.439826616016556],
            [33.4086855787587, 0.440686140027967],
            [33.406649571421745, 0.442016179414212],
            [33.40500612157577, 0.442233404447068],
            [33.40261295216667, 0.444739585893092],
            [33.399540842354064, 0.449625203234583],
            [33.39407602306985, 0.455252820312735],
            [33.3877174510448, 0.458817743861669],
            [33.373560346221836, 0.465469523405187],
            [33.36998459684351, 0.457524951399661],
            [33.36683948543931, 0.45235013847042],
            [33.36124532582214, 0.444461295298385],
            [33.355790064612535, 0.439775126101408],
            [33.34702310032761, 0.434012490599453],
            [33.34028774702462, 0.428512111015411],
            [33.33569522152567, 0.42314732986722],
            [33.33235524846839, 0.417863916735519],
            [33.328263652317915, 0.410183016746632],
            [33.325257947767746, 0.406238562345414],
            [33.320916066606095, 0.403587906747574],
            [33.30142662873194, 0.396043278714491],
            [33.28272297418623, 0.388154757757308],
            [33.282177606977264, 0.388869506542161],
            [33.288883624896314, 0.381806827645224],
            [33.290368673011606, 0.379015890947618],
            [33.29116065202061, 0.376125303587345],
            [33.28909014578349, 0.358500428015008],
            [33.28941472955353, 0.353716928640141],
            [33.29264587081582, 0.344422124211984],
            [33.29640799186953, 0.338496635503563],
            [33.30056257788771, 0.335243362085223],
            [33.30396014463279, 0.3338862302543],
            [33.31538089576039, 0.333541124935424],
            [33.33837496518847, 0.332688041667594],
            [33.34434161393313, 0.331794815984088],
            [33.34991107347328, 0.329886873739277],
            [33.36628687421589, 0.321690941082941],
            [33.385551911135444, 0.310719254189282],
            [33.38989625098605, 0.306233090460926],
            [33.391363881666315, 0.303202406200234],
            [33.391950428546224, 0.301641624899018],
            [33.399436388049466, 0.3027722368732],
            [33.41235195287784, 0.303269337836341],
            [33.43332624303457, 0.30267139789845],
            [33.44353220689504, 0.301313919528314],
            [33.443333823846, 0.312088994984921],
            [33.44370978855535, 0.317019635829529],
            [33.446231946157745, 0.33594600236604],
            [33.447337564761675, 0.341546088207737],
            [33.44895194512505, 0.344748674776625],
            [33.45021296598493, 0.346377086851514],
            [33.453562891477254, 0.349398643968545],
            [33.45989758718034, 0.353876623595172],
            [33.46171578989182, 0.355658802038842],
            [33.465007383281176, 0.360164064423675],
            [33.46782621848931, 0.365685588681989],
            [33.47138051609864, 0.369084114131697],
            [33.47423238954629, 0.374521229875886],
            [33.47465372187246, 0.376041109004505],
            [33.4746156395926, 0.378076694070746],
            [33.47394592309039, 0.384482033390413],
            [33.47409938408701, 0.386725690289708],
            [33.47494146573266, 0.389267859762011],
            [33.47756343424798, 0.39111330420907],
            [33.48158223991095, 0.39241584260004],
            [33.48238608566484, 0.394161872154393],
            [33.48326626037011, 0.394876535089244],
            [33.483477054543116, 0.397780617413934],
            [33.482941399919, 0.400784261055977],
            [33.48389485649018, 0.403571634169878],
            [33.48252034517227, 0.404095497969958],
            [33.479270134473126, 0.406827896235706],
            [33.477662801393116, 0.40956019656066],
            [33.47609131827951, 0.410673076483098],
            [33.474585659218306, 0.413480593967479],
            [33.47141189065827, 0.417386261051804],
            [33.470556804102245, 0.420159813560052],
            [33.46990933168312, 0.429024715787045],
            [33.46662174477995, 0.428247701996924],
            [33.46484430761606, 0.428538355460728],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1437,
        District: "MAYUGE",
        County: "BUNYA",
        Subcounty: "BUKATUBE",
        Population: 40098,
        Key: "MAYUGEBUKATUBE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.214657758776198, -0.758969673958422],
            [30.215668373352305, -0.758153544307624],
            [30.216196924997497, -0.748637986791902],
            [30.220572778646577, -0.739650846198744],
            [30.223471981631594, -0.737166085212754],
            [30.23178823149405, -0.731887259346099],
            [30.233030908755836, -0.730066239505438],
            [30.233833459139078, -0.729712872743679],
            [30.23369527129891, -0.729085359639788],
            [30.235785845001196, -0.725978011506996],
            [30.238391816317904, -0.724380103986074],
            [30.240685111033706, -0.720260738602932],
            [30.240975156377672, -0.71866140535407],
            [30.240591406868074, -0.716049545490447],
            [30.239142641707108, -0.712217084020522],
            [30.2393195415461, -0.708855514355151],
            [30.238060143941972, -0.705212949861649],
            [30.23827732872989, -0.704164815579391],
            [30.240038615981593, -0.703000119056194],
            [30.24046890540942, -0.702114771040404],
            [30.239678179550232, -0.700523831927682],
            [30.240039112749955, -0.699023942329491],
            [30.23921326635642, -0.697279359414934],
            [30.23931209900398, -0.692282088108281],
            [30.237108916989282, -0.690419231017953],
            [30.23656307726648, -0.690301435401216],
            [30.236300580557298, -0.690653714700418],
            [30.233761013604695, -0.690073882599362],
            [30.233045496497734, -0.687199789414982],
            [30.229971045675498, -0.679119199506646],
            [30.228666996411842, -0.67842262465048],
            [30.225630234407358, -0.675086351832172],
            [30.22984327380107, -0.674392936451107],
            [30.2350434440127, -0.671052313321611],
            [30.23841215687088, -0.6647465666914],
            [30.236933900917442, -0.662748615806795],
            [30.2346093412365, -0.657867481242095],
            [30.232509142984316, -0.65502039493939],
            [30.22634669294871, -0.658009786559721],
            [30.213791312125107, -0.660252918234794],
            [30.20886142971109, -0.660465910811034],
            [30.20454301434129, -0.662374547300436],
            [30.20022504992577, -0.663494082222477],
            [30.1941916994746, -0.665894883848949],
            [30.18720949362311, -0.667740289225406],
            [30.18286150930742, -0.667891906461122],
            [30.17578771751779, -0.669367335557073],
            [30.169143115618095, -0.669979947429052],
            [30.165346577410894, -0.669700340753112],
            [30.16458092083637, -0.670038947437614],
            [30.16320166461712, -0.672519367947329],
            [30.162833392181547, -0.673998641069437],
            [30.161498505550835, -0.675883561122697],
            [30.161352540096928, -0.677144474319607],
            [30.160916922761153, -0.676998016035795],
            [30.16022656207541, -0.677856551399935],
            [30.15875291897097, -0.687178371525889],
            [30.156556720459275, -0.691005228664577],
            [30.15646720334121, -0.692477548139986],
            [30.15679855681524, -0.694262440870981],
            [30.158635821777054, -0.697779402797328],
            [30.158301384386654, -0.701147816126555],
            [30.159117525381856, -0.70747283696891],
            [30.158915267000673, -0.712090616388084],
            [30.159379360930966, -0.714201308746381],
            [30.159023195090477, -0.716788899982313],
            [30.15962114787957, -0.717436225576702],
            [30.161059314716837, -0.721184993275073],
            [30.164116267255654, -0.72328393420539],
            [30.16624344550909, -0.723776061246969],
            [30.16646479847994, -0.724737755786437],
            [30.166175289430175, -0.724512708077795],
            [30.166853466265714, -0.72572735764052],
            [30.168491725646, -0.733270806008254],
            [30.172206136276635, -0.736152550447698],
            [30.183417419144583, -0.73965677099264],
            [30.18921338888362, -0.74319240380657],
            [30.191627131509307, -0.745990367530525],
            [30.192701322553024, -0.748032956581705],
            [30.192742754650553, -0.749941249070679],
            [30.192381230359405, -0.751585951897065],
            [30.19170724865624, -0.752579188330368],
            [30.19210196569714, -0.753499951135323],
            [30.195262819178335, -0.758192331063854],
            [30.19991501437176, -0.763576491024153],
            [30.201193083459092, -0.762906561776663],
            [30.20615182065834, -0.761815787378351],
            [30.20773758249342, -0.760978368274423],
            [30.21265953547843, -0.759544802157532],
            [30.214657758776198, -0.758969673958422],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1438,
        District: "SHEEMA",
        County: "SHEEMA",
        Subcounty: "KASAANA",
        Population: 17080,
        Key: "SHEEMAKASAANA",
        Dist2: "Sheema",
        "Sub Country": "Kasaana",
        id2_original: "Sheema Kasaana",
        drought: "L",
        "Animal Vectors and diseases": "M",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "H",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.11374942798928, -0.6497931102081],
            [30.112286399378203, -0.649972987170446],
            [30.1085122992902, -0.649293140050762],
            [30.10329913494796, -0.649362431641829],
            [30.101991655916557, -0.649786357108095],
            [30.10071028372393, -0.649433227813361],
            [30.100118014575617, -0.648953996593417],
            [30.09967063469951, -0.647706816874476],
            [30.09884144208155, -0.647064808568752],
            [30.093045294476116, -0.643718302380027],
            [30.092522715729256, -0.643763181175477],
            [30.088644504493082, -0.64601985594878],
            [30.084637773984166, -0.647643949601218],
            [30.07848300184932, -0.648914398700664],
            [30.075719789425236, -0.651596333102227],
            [30.0721903419116, -0.652479750111124],
            [30.063682278379783, -0.658239344869112],
            [30.0614962478988, -0.658617538477982],
            [30.058758077809937, -0.658216791457335],
            [30.05577146605281, -0.659074949242393],
            [30.05393803150739, -0.660618897211414],
            [30.05189467415478, -0.660942950983326],
            [30.050730265307074, -0.66330949799175],
            [30.051209975550282, -0.665062627522332],
            [30.05058574075091, -0.667230717630614],
            [30.051982903088707, -0.668505532646246],
            [30.05002012910869, -0.669624723042732],
            [30.050227977705852, -0.671486113236317],
            [30.054490367846334, -0.675391941960493],
            [30.054042494795123, -0.678093223839208],
            [30.05410506784458, -0.680839992583392],
            [30.05457555508472, -0.682267858921675],
            [30.05697477824049, -0.682088625387866],
            [30.057994835008554, -0.682423558257801],
            [30.059317100309546, -0.684863912224852],
            [30.059702002357653, -0.687041666753552],
            [30.061220730109593, -0.687431124887405],
            [30.06280743427739, -0.688814515988494],
            [30.06415211793462, -0.695393103106244],
            [30.063299187335286, -0.698538837850686],
            [30.065614055092617, -0.702364933056255],
            [30.065695068758217, -0.704520489216113],
            [30.06679449976645, -0.704735420046278],
            [30.067519326114695, -0.706229118888687],
            [30.068601934372612, -0.70718839183968],
            [30.06964231911722, -0.707296169784251],
            [30.07071662424697, -0.709879607811817],
            [30.073151653351644, -0.71080952172971],
            [30.074144959188875, -0.710584012535484],
            [30.074309939282372, -0.712501755198409],
            [30.072771524052644, -0.713641986512936],
            [30.071920521237924, -0.715420632829657],
            [30.075121565344926, -0.720401152150604],
            [30.075143794156634, -0.72106857454752],
            [30.074815965671817, -0.72420084332546],
            [30.07316100211884, -0.725938019924221],
            [30.07238443370854, -0.727943908785172],
            [30.07312633792864, -0.729896049522294],
            [30.07374175845842, -0.730510862265641],
            [30.071549136139907, -0.732939962013418],
            [30.071513576329366, -0.733526627038785],
            [30.070058864321226, -0.734555697486115],
            [30.070919753993966, -0.735735374008358],
            [30.07002961697219, -0.738120112196585],
            [30.070917474069766, -0.739232043373797],
            [30.07037741320916, -0.74228926769557],
            [30.07042571113044, -0.746329729451934],
            [30.071015279044655, -0.747640260964749],
            [30.07244804071885, -0.748897147484083],
            [30.072545722624536, -0.75175241335956],
            [30.075015230866434, -0.75188057125557],
            [30.076502999978736, -0.752884509226137],
            [30.076801841626015, -0.754185820164557],
            [30.07800873090517, -0.753662576152118],
            [30.081001055049168, -0.753637483885545],
            [30.08225477619904, -0.753981676833583],
            [30.086616230752437, -0.75223171041572],
            [30.08784179331139, -0.752115068837999],
            [30.08944924317239, -0.753073917019246],
            [30.09392267452255, -0.75424250793041],
            [30.094833964174313, -0.754947312583261],
            [30.09615969337905, -0.756881418274705],
            [30.098171719291162, -0.7583133531784],
            [30.09923744910321, -0.762349963731431],
            [30.10039720198277, -0.762444688979783],
            [30.10244425230951, -0.760854532959069],
            [30.107651848893635, -0.764362605114532],
            [30.10902461119167, -0.764313818359583],
            [30.11198715169244, -0.763213663145599],
            [30.11567540967024, -0.762228709086969],
            [30.12204219589021, -0.761889635840515],
            [30.1238645299537, -0.7610043623275],
            [30.131011525455836, -0.755360996652464],
            [30.13579830175351, -0.748520210642979],
            [30.137560384912543, -0.747094503607175],
            [30.138038063166583, -0.746261174048752],
            [30.138567231954358, -0.740455074918252],
            [30.138528263935665, -0.734050985461773],
            [30.139387060533807, -0.732861028117662],
            [30.14377119395483, -0.732170656483241],
            [30.14521965997682, -0.732270423316026],
            [30.147211335454486, -0.733325887986585],
            [30.150111618214517, -0.732475992262119],
            [30.15237829495009, -0.732947922232102],
            [30.157653607438657, -0.732105183627835],
            [30.168491725646, -0.733270806008254],
            [30.166853466265714, -0.72572735764052],
            [30.166175289430175, -0.724512708077795],
            [30.15874379208766, -0.725360807022009],
            [30.157036949030406, -0.724347685480121],
            [30.14762626997919, -0.714817754826676],
            [30.14652347208524, -0.7143291209943],
            [30.143799644498202, -0.711978058090413],
            [30.142138099887422, -0.711687872548069],
            [30.137406916729418, -0.709444008619765],
            [30.134819496521633, -0.7090538552702],
            [30.133659851439894, -0.707742923606422],
            [30.133211337889886, -0.703125283579147],
            [30.132054120056043, -0.701046306912932],
            [30.128643102836218, -0.698197901324016],
            [30.121662317221205, -0.693919663522055],
            [30.11993398466569, -0.692170148227749],
            [30.11931052241749, -0.690321969398156],
            [30.122530828200823, -0.68582407250212],
            [30.125805226937313, -0.683033961478371],
            [30.125784642042554, -0.682030966615426],
            [30.124794792922557, -0.67959068935946],
            [30.1215577515255, -0.678043625037686],
            [30.12017268500299, -0.669106361329554],
            [30.120147377664793, -0.665826339835251],
            [30.117486412384707, -0.658550951663335],
            [30.116760390378822, -0.655279568904111],
            [30.11486800389285, -0.652838813078016],
            [30.11374942798928, -0.6497931102081],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1439,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "MUTARA",
        Population: 23113,
        Key: "MITOOMAMUTARA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.120260183606604, -0.589039888979528],
            [30.116832999406583, -0.590374235113197],
            [30.114812446685793, -0.590432545255656],
            [30.105075551625678, -0.59666717633475],
            [30.102687670598694, -0.597054450480779],
            [30.10201906082091, -0.598246808420296],
            [30.09835780889552, -0.600987130820934],
            [30.096293890902714, -0.599183525844551],
            [30.094556283241896, -0.596590709595533],
            [30.091764651715504, -0.594408934601639],
            [30.090720453622517, -0.592503207058406],
            [30.088646357717526, -0.5912190620115],
            [30.08824698291188, -0.589791230667863],
            [30.08718186844581, -0.588643153715695],
            [30.081298348899182, -0.585101694663862],
            [30.07991525597536, -0.583711675275092],
            [30.07945971310827, -0.582908179284803],
            [30.079422794146723, -0.580804389358945],
            [30.078853660210253, -0.579216703838316],
            [30.076498869525082, -0.577302971138214],
            [30.073802485469937, -0.576058766882407],
            [30.072525494360956, -0.574314267220492],
            [30.070961549909192, -0.57316596345154],
            [30.069769596019945, -0.570761927436853],
            [30.06512948137049, -0.569901192698391],
            [30.06057052321874, -0.569718154739878],
            [30.05889754574937, -0.566918754859038],
            [30.057530843486223, -0.566219207169985],
            [30.056291876266584, -0.567122827724873],
            [30.05427252728827, -0.567615516924542],
            [30.05383824934056, -0.567348104276235],
            [30.0545362672658, -0.569272335701088],
            [30.053966901563978, -0.571756751385424],
            [30.05458141479532, -0.572886481001965],
            [30.053015198504227, -0.575603871318888],
            [30.05341193495786, -0.575972576988377],
            [30.055478192163676, -0.57567260693526],
            [30.055438571069764, -0.579167018762045],
            [30.056033630385336, -0.580850223541114],
            [30.05678401829499, -0.581634699876996],
            [30.05301922385499, -0.585312257766005],
            [30.04749794545512, -0.588255679566117],
            [30.044054052590855, -0.591706773612677],
            [30.047023005266105, -0.592073434668059],
            [30.04934896362393, -0.591318255889675],
            [30.050679375746235, -0.591370074243475],
            [30.053169875819712, -0.59353139689556],
            [30.058347565691374, -0.595024992086232],
            [30.058341301738917, -0.597057939347904],
            [30.059799527956475, -0.597826726076975],
            [30.060671113869322, -0.597574203628466],
            [30.06305278843603, -0.599472910365677],
            [30.064779086307382, -0.599853325154074],
            [30.064854559164292, -0.602708548392805],
            [30.065919732919173, -0.603413884448374],
            [30.066924424004316, -0.605501606595633],
            [30.06782101003149, -0.606242996849071],
            [30.066699181328296, -0.610227000063835],
            [30.06835232848778, -0.611556110435715],
            [30.06837171233498, -0.614348064582887],
            [30.06915562087946, -0.615197825516572],
            [30.07106553708986, -0.615262125014188],
            [30.07206113902094, -0.61573251683939],
            [30.071044035913538, -0.616373472658523],
            [30.06961868623875, -0.616508217542024],
            [30.06735471433047, -0.617810893165254],
            [30.064764906400633, -0.620747159798764],
            [30.062656243323502, -0.621672601011843],
            [30.062009252401364, -0.623560631478093],
            [30.062170133482244, -0.626516053933132],
            [30.061600000619194, -0.629171361197241],
            [30.062022472009083, -0.634308649661464],
            [30.06277141003789, -0.637218093083576],
            [30.060516567707847, -0.642703205398133],
            [30.061411736193495, -0.645075429003411],
            [30.06176436626505, -0.648234410412222],
            [30.060968278361923, -0.652281686227322],
            [30.058758077809937, -0.658216791457335],
            [30.0614962478988, -0.658617538477982],
            [30.063682278379783, -0.658239344869112],
            [30.0721903419116, -0.652479750111124],
            [30.075719789425236, -0.651596333102227],
            [30.07848300184932, -0.648914398700664],
            [30.084637773984166, -0.647643949601218],
            [30.088644504493082, -0.64601985594878],
            [30.092522715729256, -0.643763181175477],
            [30.093045294476116, -0.643718302380027],
            [30.09884144208155, -0.647064808568752],
            [30.09967063469951, -0.647706816874476],
            [30.100118014575617, -0.648953996593417],
            [30.10071028372393, -0.649433227813361],
            [30.101991655916557, -0.649786357108095],
            [30.10329913494796, -0.649362431641829],
            [30.1085122992902, -0.649293140050762],
            [30.112286399378203, -0.649972987170446],
            [30.11374942798928, -0.6497931102081],
            [30.116393264193547, -0.650508453697775],
            [30.11724563873574, -0.651349272844645],
            [30.121103822930955, -0.651703883231343],
            [30.12267140735626, -0.651668638314495],
            [30.12374250460211, -0.65090120414948],
            [30.126449668440657, -0.651029254321492],
            [30.12737778174106, -0.650388237215439],
            [30.130605310877627, -0.651212347000767],
            [30.133542922230937, -0.653581439788505],
            [30.136914387527128, -0.65337554135163],
            [30.136399095913855, -0.653221876545527],
            [30.13632242829761, -0.652805937771013],
            [30.135545276880695, -0.644073464831427],
            [30.130150117455166, -0.640679315710208],
            [30.129475339844642, -0.637894681130342],
            [30.13040242277744, -0.636008848508686],
            [30.130285012071475, -0.634407809506106],
            [30.128591063431795, -0.631575397546373],
            [30.12684388242501, -0.629946997941958],
            [30.12785527673876, -0.626136169216627],
            [30.127315126046643, -0.624157011895447],
            [30.130433472146922, -0.614128854114984],
            [30.130159169778285, -0.610640843901248],
            [30.127520591413365, -0.607594334866786],
            [30.124571482522732, -0.602729327072243],
            [30.123063000954918, -0.601321071027575],
            [30.12330301552748, -0.596631587012972],
            [30.120778381269826, -0.591262973816089],
            [30.120260183606604, -0.589039888979528],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1440,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KATENGA",
        Population: 17573,
        Key: "MITOOMAKATENGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.133471062398094, -0.521019384128873],
            [30.131880711968538, -0.520924031903317],
            [30.131269780320224, -0.518773203302092],
            [30.128833587897237, -0.517398944899127],
            [30.12753782379545, -0.516920038394375],
            [30.124209718381394, -0.51700799694824],
            [30.122185977539637, -0.516452005518267],
            [30.124115895638177, -0.510564208415763],
            [30.122126806410193, -0.510663883318008],
            [30.119392689519863, -0.511683704563399],
            [30.118443477488395, -0.511439309665555],
            [30.11619229219987, -0.509793779991073],
            [30.112215382165104, -0.50945767065726],
            [30.106228303934255, -0.510223014859276],
            [30.104671221712913, -0.510755419805617],
            [30.102890303577336, -0.510682330387957],
            [30.10280771067347, -0.506552979056308],
            [30.102311324105344, -0.505748579887625],
            [30.100003970755367, -0.503054916111208],
            [30.098495165794034, -0.502268140778871],
            [30.09475907432402, -0.498779492220981],
            [30.092225215266748, -0.494487659334078],
            [30.090362048282028, -0.492375697810911],
            [30.089547703917418, -0.494733622368531],
            [30.086615516591777, -0.494353323980023],
            [30.08437092314082, -0.496054419858213],
            [30.080987726745303, -0.496922957517016],
            [30.07812417430063, -0.497025444248955],
            [30.0771951294473, -0.499591942643585],
            [30.076430928143512, -0.499670101186377],
            [30.074895569880706, -0.497911047329482],
            [30.074175081496975, -0.495905159586531],
            [30.07479378357249, -0.491868710061218],
            [30.076876063129735, -0.487839264699896],
            [30.07547233590382, -0.483782641162245],
            [30.079282171872155, -0.479877609571271],
            [30.0788774655653, -0.478371576468906],
            [30.076904926898106, -0.475732986260055],
            [30.07258225531049, -0.47830037668415],
            [30.069756742026545, -0.48107392583479],
            [30.066454277225642, -0.485148987356036],
            [30.06427742034035, -0.482955650999345],
            [30.061317589158467, -0.481549873309405],
            [30.051211204445575, -0.481888058196193],
            [30.046208779479116, -0.482776530597911],
            [30.045726699480195, -0.483261422160649],
            [30.044119794896602, -0.483143264665116],
            [30.043212433577576, -0.483883756416884],
            [30.042635226481657, -0.483883503999268],
            [30.041605423891088, -0.482057943368472],
            [30.041441645743404, -0.47940152364442],
            [30.040968052129, -0.478136390449578],
            [30.039526023434338, -0.476148027737596],
            [30.03940340968625, -0.473609087880363],
            [30.03997724091335, -0.472604907137156],
            [30.038794678910385, -0.473985166393339],
            [30.03692525785468, -0.475226815603913],
            [30.035528094618552, -0.477065039371535],
            [30.034293690840567, -0.477604083496728],
            [30.034109954822238, -0.478477267662189],
            [30.0327793881897, -0.479686892245116],
            [30.03234456855788, -0.483787067003869],
            [30.033564973888826, -0.487340134784854],
            [30.033601501184904, -0.488957948181702],
            [30.03307149786223, -0.491509714272189],
            [30.031267873011192, -0.494599407389246],
            [30.030872087873412, -0.496516503091974],
            [30.03142128909202, -0.498511399279424],
            [30.03011600464486, -0.499824248920295],
            [30.02984373785865, -0.502753592348326],
            [30.034900492035202, -0.510000728365846],
            [30.036478414272775, -0.511230238702581],
            [30.037646418178234, -0.513339332208365],
            [30.03794710227016, -0.516109909505697],
            [30.041046016014192, -0.525191727517947],
            [30.04141918875963, -0.532618837232582],
            [30.04174005799597, -0.533188209747154],
            [30.04081310352229, -0.534353302856289],
            [30.039974420203357, -0.536855644776992],
            [30.038670253260385, -0.536213514048033],
            [30.035734501419697, -0.537214991935973],
            [30.034844609637993, -0.538066790884612],
            [30.033292676559913, -0.538335856780517],
            [30.033549724986862, -0.54022569367751],
            [30.03304137645242, -0.540595534289818],
            [30.0317831727093, -0.540257904035063],
            [30.0287012119713, -0.540476732888959],
            [30.02867423017341, -0.541392474202025],
            [30.029496830953804, -0.542984862575598],
            [30.027589082378164, -0.543920836251038],
            [30.02741800092728, -0.544615290666965],
            [30.028951630831465, -0.546147399482117],
            [30.02967813433433, -0.546405746808336],
            [30.032017880933473, -0.548985946147913],
            [30.03280117682693, -0.549103792515709],
            [30.033295163096607, -0.550658080360322],
            [30.0348859456158, -0.550758260344679],
            [30.035454202796533, -0.551282582728064],
            [30.03661905631031, -0.550885616701843],
            [30.037052844676165, -0.548807746539524],
            [30.03749386627668, -0.548274890334355],
            [30.040347292013177, -0.547038484100942],
            [30.0429329461331, -0.547952318279975],
            [30.044683227225963, -0.550275236954068],
            [30.04646138214373, -0.551233855870861],
            [30.048477168403625, -0.55604161333947],
            [30.049446338305803, -0.55747870621154],
            [30.050069197784445, -0.559611342799497],
            [30.050323756081447, -0.561807041805244],
            [30.049703110949977, -0.562836748089798],
            [30.052754017826928, -0.566967422300166],
            [30.05383824934056, -0.567348104276235],
            [30.05427252728827, -0.567615516924542],
            [30.056291876266584, -0.567122827724873],
            [30.057530843486223, -0.566219207169985],
            [30.05889754574937, -0.566918754859038],
            [30.06057052321874, -0.569718154739878],
            [30.06512948137049, -0.569901192698391],
            [30.069769596019945, -0.570761927436853],
            [30.070961549909192, -0.57316596345154],
            [30.072525494360956, -0.574314267220492],
            [30.073802485469937, -0.576058766882407],
            [30.076498869525082, -0.577302971138214],
            [30.078853660210253, -0.579216703838316],
            [30.079422794146723, -0.580804389358945],
            [30.07945971310827, -0.582908179284803],
            [30.07991525597536, -0.583711675275092],
            [30.081298348899182, -0.585101694663862],
            [30.08718186844581, -0.588643153715695],
            [30.08824698291188, -0.589791230667863],
            [30.088646357717526, -0.5912190620115],
            [30.090720453622517, -0.592503207058406],
            [30.091764651715504, -0.594408934601639],
            [30.094556283241896, -0.596590709595533],
            [30.096293890902714, -0.599183525844551],
            [30.09835780889552, -0.600987130820934],
            [30.10201906082091, -0.598246808420296],
            [30.102687670598694, -0.597054450480779],
            [30.105075551625678, -0.59666717633475],
            [30.114812446685793, -0.590432545255656],
            [30.116832999406583, -0.590374235113197],
            [30.120260183606604, -0.589039888979528],
            [30.120461312805475, -0.587709845230206],
            [30.12100812540373, -0.586595059466201],
            [30.121782243209942, -0.586060836882374],
            [30.122346707703535, -0.584077441281667],
            [30.121160954884722, -0.584441375694848],
            [30.120394083787893, -0.585653934805829],
            [30.11978939004092, -0.585065729791753],
            [30.1190355768551, -0.582862980195371],
            [30.118581723719043, -0.579238508429259],
            [30.116340084827037, -0.574123907602426],
            [30.120492736772402, -0.569593490909907],
            [30.122946043898185, -0.564597131769899],
            [30.125432156599807, -0.561369963245295],
            [30.125998358435183, -0.560040993676491],
            [30.126521732191076, -0.556796765336988],
            [30.124738713794322, -0.554208924180156],
            [30.124268169062, -0.552781027935579],
            [30.125181552686666, -0.545209407729299],
            [30.124925744833106, -0.544314733333664],
            [30.12610161438719, -0.539512879804429],
            [30.126529932012982, -0.539010770750241],
            [30.127648133319095, -0.539530698894686],
            [30.130569219264437, -0.538471188291021],
            [30.131664398546437, -0.537595220391787],
            [30.13211706680462, -0.537098457717345],
            [30.131765646763792, -0.535498932797342],
            [30.132128338864835, -0.533348551181962],
            [30.133828599067687, -0.532653577176722],
            [30.134448780668485, -0.531723163902182],
            [30.13508468188846, -0.526680896346655],
            [30.135917706719404, -0.525970328395794],
            [30.135874764553854, -0.524100798088698],
            [30.133479983567163, -0.522003566330025],
            [30.133471062398094, -0.521019384128873],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1441,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "NYABUBARE",
        Population: 35911,
        Key: "BUSHENYINYABUBARE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.17892511239368, -0.381717171481892],
            [30.175201841679378, -0.382309134621564],
            [30.173530399430838, -0.381712191332474],
            [30.169985758710794, -0.381647771877873],
            [30.16577666381947, -0.380616258361072],
            [30.163435258032024, -0.379621508365331],
            [30.16075273588006, -0.377876648101566],
            [30.15608051005246, -0.373555851672641],
            [30.15484040556566, -0.373239186090058],
            [30.151369385376405, -0.373391675465946],
            [30.147234467971376, -0.372613233496425],
            [30.13952102808874, -0.371942068704515],
            [30.137472753358292, -0.372799822209589],
            [30.13191530878509, -0.373575103956588],
            [30.123756039518508, -0.372343557760301],
            [30.118776431760256, -0.369287821758059],
            [30.112694570487132, -0.366575113755422],
            [30.10631561299335, -0.361815224076481],
            [30.102390598632535, -0.358231835202322],
            [30.099530599024813, -0.357505777053631],
            [30.097269661625564, -0.355302661917631],
            [30.09548459147674, -0.355175602154482],
            [30.09343835232871, -0.355562141582786],
            [30.092386687439046, -0.355138265295306],
            [30.08895195469571, -0.351489997814353],
            [30.083821403918574, -0.351994295325209],
            [30.07643481245879, -0.354356745079788],
            [30.067914265039473, -0.358048228535074],
            [30.057722866463042, -0.360986160240862],
            [30.048625783887594, -0.365202003960152],
            [30.042014522061347, -0.367533954915223],
            [30.021526104590627, -0.376049941050139],
            [30.017189969951847, -0.378148906267333],
            [30.010023866385314, -0.383515146263242],
            [30.00529140402634, -0.385226869976608],
            [30.0005465431198, -0.386554551650035],
            [29.9934884745426, -0.386375592451876],
            [29.98175477642116, -0.387205576437471],
            [29.976940819797903, -0.389053973131643],
            [29.97028804772068, -0.393721001111998],
            [29.960045695803014, -0.402439360018399],
            [29.953391299571777, -0.411511186663289],
            [29.947436593030467, -0.421552338956719],
            [29.94227451138687, -0.434544293242557],
            [29.939288806928182, -0.44445497853539],
            [29.936513813099165, -0.448870402646846],
            [29.93754109142379, -0.449561173292469],
            [29.93729520456421, -0.451710154562304],
            [29.93775220270207, -0.452585601123635],
            [29.938781524693958, -0.453189779227457],
            [29.94139639292529, -0.457106329150944],
            [29.943335622960046, -0.458025867454689],
            [29.94415062129817, -0.459280267064628],
            [29.94331587709178, -0.461547052071214],
            [29.94382874594871, -0.46276555555388],
            [29.944604746623742, -0.463415068390948],
            [29.94427358988078, -0.464923086347884],
            [29.944560754327654, -0.466936274587747],
            [29.934152924649833, -0.493514661046039],
            [29.948005542812297, -0.493559426927396],
            [29.95009891925822, -0.494415730314487],
            [29.953371446803988, -0.496932519723567],
            [29.957708099770688, -0.502346837359922],
            [29.961634119346293, -0.494714860854931],
            [29.964900714417897, -0.490730923294886],
            [29.969202169595125, -0.488524933748249],
            [29.974652844905247, -0.486706371993644],
            [29.97583235083958, -0.485918130522522],
            [29.975113413846334, -0.484541009577451],
            [29.97493609718906, -0.482789945562118],
            [29.978131260025904, -0.479480625620564],
            [29.979098034121197, -0.477921853277335],
            [29.97955159440646, -0.475480227013841],
            [29.980775215706117, -0.474157099849836],
            [29.98177977743381, -0.471061921498077],
            [29.98252610136513, -0.469991626606984],
            [29.981672706336802, -0.467829481078231],
            [29.981624184735047, -0.466284869386899],
            [29.982411649709732, -0.464765369832599],
            [29.981822184203423, -0.46322052661059],
            [29.983490799453794, -0.460511097219361],
            [29.982990433348956, -0.456592150726041],
            [29.98383268657282, -0.453354799970962],
            [29.983076200899035, -0.45133463270513],
            [29.982875503789842, -0.449072118540624],
            [29.981956517372712, -0.447576653529461],
            [29.982434748090633, -0.444561926937863],
            [29.981227932473306, -0.43967515823253],
            [29.98158845783788, -0.437703266660854],
            [29.982366924388344, -0.438342588846949],
            [29.984640938563206, -0.438803746148881],
            [29.98599318423847, -0.439767162770982],
            [29.98651864118753, -0.439535674635838],
            [29.990377314066272, -0.442253017678732],
            [29.99189194280555, -0.442817680924932],
            [29.994194556644107, -0.444813681196712],
            [29.995232052406756, -0.445012565797523],
            [29.995522157039563, -0.446046776594352],
            [29.997106747471523, -0.447175364968978],
            [29.99796987484764, -0.448439773383885],
            [29.999940921413124, -0.449317997843582],
            [30.000864446119056, -0.449130359921213],
            [30.003082716237266, -0.45064975229862],
            [30.007783788765263, -0.45246531237411],
            [30.010123186818067, -0.453923367215526],
            [30.012483786908195, -0.453421289389937],
            [30.014558467616425, -0.454431873148234],
            [30.01920508517024, -0.458883623293642],
            [30.01989007393057, -0.461973764024187],
            [30.020830970257474, -0.463025453937909],
            [30.020271730365568, -0.464798324342815],
            [30.020483177613762, -0.465578460300521],
            [30.020962550988724, -0.46601883852715],
            [30.02347297300026, -0.466516875876561],
            [30.026276844970702, -0.468874185053081],
            [30.027752720388634, -0.468975169376831],
            [30.029086070900245, -0.467896588382458],
            [30.030172342487894, -0.467407170179141],
            [30.030651833542144, -0.467577766250896],
            [30.03101169774665, -0.467116440105655],
            [30.03192427648085, -0.467492699524006],
            [30.03407253190582, -0.466890544671759],
            [30.034495498267443, -0.467316704754907],
            [30.03516594779492, -0.466188134813411],
            [30.035892480043884, -0.465868955086721],
            [30.03692171669582, -0.466870448229446],
            [30.036864785066367, -0.468098675630338],
            [30.037569282539735, -0.469881002800799],
            [30.03915549892234, -0.471266124115358],
            [30.040618995555672, -0.471821225533575],
            [30.03997724091335, -0.472604907137156],
            [30.03940340968625, -0.473609087880363],
            [30.039526023434338, -0.476148027737596],
            [30.040968052129, -0.478136390449578],
            [30.041441645743404, -0.47940152364442],
            [30.041605423891088, -0.482057943368472],
            [30.042635226481657, -0.483883503999268],
            [30.043212433577576, -0.483883756416884],
            [30.044119794896602, -0.483143264665116],
            [30.045726699480195, -0.483261422160649],
            [30.046208779479116, -0.482776530597911],
            [30.051211204445575, -0.481888058196193],
            [30.061317589158467, -0.481549873309405],
            [30.06427742034035, -0.482955650999345],
            [30.066454277225642, -0.485148987356036],
            [30.069756742026545, -0.48107392583479],
            [30.07258225531049, -0.47830037668415],
            [30.076904926898106, -0.475732986260055],
            [30.0788774655653, -0.478371576468906],
            [30.079282171872155, -0.479877609571271],
            [30.07547233590382, -0.483782641162245],
            [30.076876063129735, -0.487839264699896],
            [30.07479378357249, -0.491868710061218],
            [30.074175081496975, -0.495905159586531],
            [30.074895569880706, -0.497911047329482],
            [30.076430928143512, -0.499670101186377],
            [30.0771951294473, -0.499591942643585],
            [30.07812417430063, -0.497025444248955],
            [30.080987726745303, -0.496922957517016],
            [30.08437092314082, -0.496054419858213],
            [30.086615516591777, -0.494353323980023],
            [30.089547703917418, -0.494733622368531],
            [30.090362048282028, -0.492375697810911],
            [30.092225215266748, -0.494487659334078],
            [30.09475907432402, -0.498779492220981],
            [30.098495165794034, -0.502268140778871],
            [30.100003970755367, -0.503054916111208],
            [30.102311324105344, -0.505748579887625],
            [30.10280771067347, -0.506552979056308],
            [30.102890303577336, -0.510682330387957],
            [30.104671221712913, -0.510755419805617],
            [30.106228303934255, -0.510223014859276],
            [30.112215382165104, -0.50945767065726],
            [30.11619229219987, -0.509793779991073],
            [30.118443477488395, -0.511439309665555],
            [30.119392689519863, -0.511683704563399],
            [30.122126806410193, -0.510663883318008],
            [30.124115895638177, -0.510564208415763],
            [30.122185977539637, -0.516452005518267],
            [30.124209718381394, -0.51700799694824],
            [30.12753782379545, -0.516920038394375],
            [30.128833587897237, -0.517398944899127],
            [30.131269780320224, -0.518773203302092],
            [30.131880711968538, -0.520924031903317],
            [30.133471062398094, -0.521019384128873],
            [30.134110808407474, -0.519018168325408],
            [30.136654901072454, -0.517588813157759],
            [30.13764692411546, -0.515545676288147],
            [30.137707061832153, -0.514571993965711],
            [30.13875208278195, -0.514346591492976],
            [30.139645642384973, -0.513949807235031],
            [30.14060359951575, -0.509483172819973],
            [30.14260986273531, -0.505199780013908],
            [30.14378031904148, -0.500533480438954],
            [30.143980925420834, -0.497932392291207],
            [30.145578695036313, -0.493581848044971],
            [30.14679744207722, -0.490714273631801],
            [30.149039170800766, -0.487281193061102],
            [30.148422313864828, -0.485817764466279],
            [30.14893731083069, -0.484782486052594],
            [30.149897671853164, -0.478732058716578],
            [30.150937821239204, -0.476865024726046],
            [30.14705305948796, -0.477545040182526],
            [30.14652121372064, -0.47723879806466],
            [30.146369410115696, -0.476779703000083],
            [30.147277732632084, -0.475145131011228],
            [30.1485283536959, -0.473922736515433],
            [30.146288585096354, -0.472849770565895],
            [30.14550007897423, -0.472048200546514],
            [30.145226008370944, -0.471267446390723],
            [30.146004452463547, -0.469854346191114],
            [30.145398189359778, -0.4692974588255],
            [30.145246936422122, -0.468471343651579],
            [30.145755760165333, -0.467376126334155],
            [30.14444529333728, -0.465842886838845],
            [30.143384464733426, -0.465877012708453],
            [30.14173941588624, -0.467289428318549],
            [30.13918269919655, -0.466672686190845],
            [30.13747784590764, -0.467206943260458],
            [30.137586913959527, -0.470255197811638],
            [30.138250366509244, -0.470964288705573],
            [30.137630402300747, -0.471630792741041],
            [30.136426313070316, -0.471515282291196],
            [30.13630348911647, -0.470957853392309],
            [30.13526667068353, -0.470170019729956],
            [30.134141547858153, -0.47039958634893],
            [30.131116717277287, -0.469216520638099],
            [30.129121850983733, -0.469143985009233],
            [30.126214531720105, -0.470318930235781],
            [30.124547603505853, -0.469758859384818],
            [30.122082198768158, -0.47048934208818],
            [30.12105576755483, -0.471693739153383],
            [30.1191887144582, -0.472711325131082],
            [30.115795212589774, -0.478074212128784],
            [30.116148186716046, -0.485848292613683],
            [30.115505657725926, -0.488960457983231],
            [30.114037616515578, -0.489863435818258],
            [30.10889394404707, -0.489301839486951],
            [30.10595803589955, -0.490734863161208],
            [30.10456154280663, -0.490949400826129],
            [30.104363098672152, -0.488511022943382],
            [30.101030417240047, -0.484809125537016],
            [30.100090722858997, -0.48307323808819],
            [30.09966490793958, -0.479143118818929],
            [30.09596080278188, -0.477707267591035],
            [30.096987180096292, -0.476603306932972],
            [30.09956604654595, -0.477034680062207],
            [30.099481126107168, -0.475657731592571],
            [30.100336606125293, -0.474338550626359],
            [30.098912708128015, -0.471942700589524],
            [30.10028146124494, -0.469849215186722],
            [30.100881787383024, -0.465259752146184],
            [30.101793663634655, -0.465389213075336],
            [30.103174486515776, -0.468631272560278],
            [30.103358522571405, -0.471557297769062],
            [30.104455441890117, -0.472160156474661],
            [30.10531055539559, -0.471730226585304],
            [30.1057243867891, -0.470238734941924],
            [30.107149459782775, -0.469809038488141],
            [30.10804846587136, -0.466567906577731],
            [30.108675781892142, -0.465678900310551],
            [30.107808041667028, -0.463746737096867],
            [30.106208703593055, -0.463070491300491],
            [30.105549586312897, -0.460930848414559],
            [30.10278730274684, -0.459252009668549],
            [30.100920131072595, -0.457010548433063],
            [30.100707790000687, -0.45652629013706],
            [30.10113372798928, -0.454342058817323],
            [30.10045203155447, -0.452697853793477],
            [30.101806373897627, -0.450581548921743],
            [30.10151620368779, -0.448881200963494],
            [30.10196416926547, -0.447541459508702],
            [30.101908761178766, -0.446201519287535],
            [30.103072614867607, -0.444895836839615],
            [30.10494085643536, -0.44444617800531],
            [30.106351034463298, -0.442543813430479],
            [30.1074258480395, -0.440067059183603],
            [30.10743018420739, -0.439116897751231],
            [30.106148640436523, -0.436869343548201],
            [30.106172707201296, -0.436032682357269],
            [30.10275327905544, -0.435242507548166],
            [30.09653153841448, -0.434618590762488],
            [30.090785078424034, -0.433229913312493],
            [30.08456327849427, -0.432940665850903],
            [30.084516054958122, -0.432223515385563],
            [30.086818128010854, -0.427841505940928],
            [30.0870453649468, -0.425549444393739],
            [30.0881377055525, -0.424504315656612],
            [30.090108801525325, -0.423821433294077],
            [30.09586068913673, -0.41265984169051],
            [30.095857234216158, -0.408492762895633],
            [30.096194867812297, -0.407166188745018],
            [30.097063641998304, -0.406240899703043],
            [30.097103684402086, -0.404354112910737],
            [30.097793004838756, -0.40256150722174],
            [30.099765158128665, -0.399478498207961],
            [30.09957550760251, -0.398522241419348],
            [30.098958253611222, -0.39797221535944],
            [30.099006222749097, -0.396609662832247],
            [30.100146690596123, -0.394960636063311],
            [30.10271229521727, -0.392547146264414],
            [30.102855377977388, -0.390802145818342],
            [30.107559767983727, -0.384014774423479],
            [30.10831987296982, -0.383513028083272],
            [30.10881846220703, -0.383871770332633],
            [30.112000665049276, -0.383992370943477],
            [30.119933198639824, -0.382082634851884],
            [30.122783460509844, -0.38067318244608],
            [30.12406579300153, -0.380912662621866],
            [30.126013262384063, -0.380602543185939],
            [30.127912647644386, -0.382085306382149],
            [30.127152278553623, -0.383352034724847],
            [30.126522324180833, -0.390320921416292],
            [30.12798613522451, -0.391328844546933],
            [30.13116317724547, -0.395658134330335],
            [30.133822045857695, -0.397739207873843],
            [30.134127476647553, -0.398830694759369],
            [30.13778794344538, -0.398664064004496],
            [30.13863133573303, -0.398356530510862],
            [30.139159841564144, -0.39749852985209],
            [30.14215277746086, -0.398292457026671],
            [30.14368209904494, -0.397472111933617],
            [30.145285367248285, -0.397211478309609],
            [30.147166204992942, -0.398238225246521],
            [30.14941794274538, -0.39863078851686],
            [30.15228967614732, -0.401635460393681],
            [30.152577388566527, -0.400366926551081],
            [30.15521900233878, -0.398856672509644],
            [30.156015810690743, -0.399314030556854],
            [30.158397357696654, -0.399548061154106],
            [30.159536962262745, -0.40025740213334],
            [30.160154730988676, -0.400085101379554],
            [30.162111304796614, -0.397580145220981],
            [30.162478186640115, -0.397523524873291],
            [30.163051700761905, -0.398309706958251],
            [30.16405847234522, -0.397344166168812],
            [30.164980368405555, -0.397060379020333],
            [30.166654530752798, -0.397704821193268],
            [30.167990497158492, -0.397014008200439],
            [30.167849680847816, -0.396067026908275],
            [30.16827306492605, -0.395622067831553],
            [30.170144980603304, -0.395565884939596],
            [30.170878435269874, -0.396446868645271],
            [30.171536825812943, -0.396541735654255],
            [30.171847331185866, -0.396229388125102],
            [30.17111450354338, -0.393770855534725],
            [30.174933774517125, -0.392806251138008],
            [30.176862443059107, -0.391793590580928],
            [30.1771920744627, -0.390651691388244],
            [30.178575293150683, -0.389203255315896],
            [30.178632293950404, -0.387527154281476],
            [30.180475898323166, -0.387698264156105],
            [30.18172736200673, -0.386429687768093],
            [30.179724193483302, -0.385097679886481],
            [30.17892511239368, -0.381717171481892],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1442,
        District: "BUSHENYI",
        County: "IGARA",
        Subcounty: "KYAMUHUNGA",
        Population: 20976,
        Key: "BUSHENYIKYAMUHUNGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.03997724091335, -0.472604907137156],
            [30.040618995555672, -0.471821225533575],
            [30.03915549892234, -0.471266124115358],
            [30.037569282539735, -0.469881002800799],
            [30.036864785066367, -0.468098675630338],
            [30.03692171669582, -0.466870448229446],
            [30.035892480043884, -0.465868955086721],
            [30.03516594779492, -0.466188134813411],
            [30.034495498267443, -0.467316704754907],
            [30.03407253190582, -0.466890544671759],
            [30.03192427648085, -0.467492699524006],
            [30.03101169774665, -0.467116440105655],
            [30.030651833542144, -0.467577766250896],
            [30.030172342487894, -0.467407170179141],
            [30.029086070900245, -0.467896588382458],
            [30.027752720388634, -0.468975169376831],
            [30.026276844970702, -0.468874185053081],
            [30.02337803724441, -0.470412839645915],
            [30.013389782788, -0.485984850490411],
            [30.012348551830385, -0.489209869728058],
            [30.010641943233413, -0.492687562489755],
            [30.00862381416722, -0.494719513954638],
            [30.003715140977075, -0.497310307267279],
            [30.003548564577297, -0.497897499449924],
            [30.00427349063856, -0.500793083644535],
            [30.00369860389101, -0.502612518260951],
            [29.998125532225128, -0.502247390493109],
            [29.995097267384924, -0.503787846615629],
            [29.992179220440164, -0.503491259520212],
            [29.991302674030337, -0.502735160526597],
            [29.98790043245249, -0.503564498133659],
            [29.987119358991052, -0.504276782501996],
            [29.98535001295292, -0.508372228812768],
            [29.98356252543767, -0.509814660503286],
            [29.982784361619434, -0.511763194210737],
            [29.981649109390908, -0.513124905766401],
            [29.97878331924287, -0.514936461699585],
            [29.978396376222456, -0.516876262577116],
            [29.97671795945402, -0.519248195867819],
            [29.97560443747222, -0.524432686539056],
            [29.973828817600165, -0.523221212585565],
            [29.971727340147012, -0.525187529866962],
            [29.967324413970214, -0.526031699608029],
            [29.96564252970478, -0.527122173273412],
            [29.964098313154967, -0.532712170852013],
            [29.966015123935193, -0.533310918791827],
            [29.967299506382325, -0.533263066711176],
            [29.969075184644893, -0.534708393231307],
            [29.96404976370544, -0.538987341927745],
            [29.962442710899822, -0.539695943848915],
            [29.96019215892358, -0.539767122295448],
            [29.95765157328143, -0.541086492024447],
            [29.955920003197647, -0.541515291773198],
            [29.954626996025446, -0.541289873209928],
            [29.952913519808128, -0.542391541165959],
            [29.953668237597462, -0.543721080591256],
            [29.9547372830912, -0.544501002277188],
            [29.954206614116877, -0.546703101688966],
            [29.954739324063535, -0.549780983303667],
            [29.95459072295262, -0.550169343041494],
            [29.95304702203577, -0.550736267009347],
            [29.95233408758523, -0.551901206727795],
            [29.952099895892363, -0.553696549090393],
            [29.951585916717715, -0.554182031675206],
            [29.952127293610204, -0.557190442390444],
            [29.951100081760927, -0.559169945181499],
            [29.948413585462134, -0.561665106727267],
            [29.943191776631892, -0.564481040934664],
            [29.938828582940147, -0.564314357637851],
            [29.93607186623391, -0.566155305039171],
            [29.93510867282332, -0.566121358463493],
            [29.935038075123455, -0.568864226044903],
            [29.935773136876065, -0.572320092754805],
            [29.939272409080996, -0.575109600950688],
            [29.941820616029986, -0.574523171618906],
            [29.943129254786438, -0.575841969442433],
            [29.944624346066615, -0.57590511602061],
            [29.945446678250743, -0.576716012052921],
            [29.947021205754886, -0.577135444737778],
            [29.947277022591617, -0.57853383851469],
            [29.94800210945129, -0.579211093247747],
            [29.949548287921665, -0.578800826657648],
            [29.951460063644724, -0.579212476582623],
            [29.95403110037838, -0.578156438660238],
            [29.95423155673909, -0.57705654342059],
            [29.954785538791647, -0.576681599337636],
            [29.956721917573677, -0.576821703372244],
            [29.955437235089214, -0.575429599759193],
            [29.955817986022407, -0.573741070226096],
            [29.956640500564546, -0.57395534270826],
            [29.956861853535365, -0.573565865306761],
            [29.9588936684349, -0.573525206000965],
            [29.95928086028864, -0.573177557426754],
            [29.960004521521984, -0.574408645770154],
            [29.961947617905718, -0.574779112126243],
            [29.962998520125677, -0.573930904368801],
            [29.96370319007558, -0.574390449511887],
            [29.964767698178818, -0.573834394215985],
            [29.9655761684598, -0.575698773538636],
            [29.965206377871436, -0.576312274806105],
            [29.96548252627797, -0.57811632822987],
            [29.965093549471728, -0.580068799415278],
            [29.966257602586587, -0.579641694828988],
            [29.96708932036879, -0.578861069097834],
            [29.967311483620023, -0.577949935469639],
            [29.967939610819514, -0.577894480796671],
            [29.969156849589062, -0.581688924783048],
            [29.969836852699565, -0.581366917797884],
            [29.969508516666586, -0.580424515822428],
            [29.97056125953457, -0.580890007880436],
            [29.97214219382331, -0.583616924997024],
            [29.97266509237041, -0.583904415881378],
            [29.974472346415187, -0.583263956595257],
            [29.97493863492973, -0.582708935178099],
            [29.975509178322884, -0.582824126476473],
            [29.97548105476628, -0.582058217524815],
            [29.975852023944313, -0.581914812481291],
            [29.97773431965469, -0.583236993262449],
            [29.980150365560768, -0.582338365140589],
            [29.98254655690247, -0.583019386757067],
            [29.983022347796073, -0.582483512814953],
            [29.984439471597803, -0.582273652053138],
            [29.988985249667703, -0.582438842802466],
            [29.990635774644858, -0.581361652144775],
            [29.990619393865654, -0.579657105537319],
            [29.994523324766725, -0.58046857772256],
            [29.9956876617492, -0.579410945606184],
            [29.99605441693025, -0.576997481287698],
            [29.99859211359043, -0.576557204241928],
            [29.99883073307935, -0.573195902801769],
            [30.00089823535015, -0.571423140877105],
            [30.001441992778183, -0.569497870870669],
            [30.004013262175484, -0.567357943041163],
            [30.005168182118823, -0.564999736220189],
            [30.007048239227498, -0.564681975325052],
            [30.00855300266832, -0.565986989631189],
            [30.013245136959263, -0.565275652913737],
            [30.015557354686525, -0.562412754735294],
            [30.0152028381529, -0.561870474187507],
            [30.019886430363776, -0.56006586683837],
            [30.02131470135989, -0.558973356444092],
            [30.024119690834553, -0.554150063027931],
            [30.02626255906273, -0.552280881818704],
            [30.02604646662621, -0.549136567840204],
            [30.028951630831465, -0.546147399482117],
            [30.02741800092728, -0.544615290666965],
            [30.027589082378164, -0.543920836251038],
            [30.029496830953804, -0.542984862575598],
            [30.02867423017341, -0.541392474202025],
            [30.0287012119713, -0.540476732888959],
            [30.0317831727093, -0.540257904035063],
            [30.03304137645242, -0.540595534289818],
            [30.033549724986862, -0.54022569367751],
            [30.033292676559913, -0.538335856780517],
            [30.034844609637993, -0.538066790884612],
            [30.035734501419697, -0.537214991935973],
            [30.038670253260385, -0.536213514048033],
            [30.039974420203357, -0.536855644776992],
            [30.04081310352229, -0.534353302856289],
            [30.04174005799597, -0.533188209747154],
            [30.04141918875963, -0.532618837232582],
            [30.041046016014192, -0.525191727517947],
            [30.03794710227016, -0.516109909505697],
            [30.037646418178234, -0.513339332208365],
            [30.036478414272775, -0.511230238702581],
            [30.034900492035202, -0.510000728365846],
            [30.02984373785865, -0.502753592348326],
            [30.03011600464486, -0.499824248920295],
            [30.03142128909202, -0.498511399279424],
            [30.030872087873412, -0.496516503091974],
            [30.031267873011192, -0.494599407389246],
            [30.03307149786223, -0.491509714272189],
            [30.033601501184904, -0.488957948181702],
            [30.033564973888826, -0.487340134784854],
            [30.03234456855788, -0.483787067003869],
            [30.0327793881897, -0.479686892245116],
            [30.034109954822238, -0.478477267662189],
            [30.034293690840567, -0.477604083496728],
            [30.035528094618552, -0.477065039371535],
            [30.03692525785468, -0.475226815603913],
            [30.038794678910385, -0.473985166393339],
            [30.03997724091335, -0.472604907137156],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1443,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "BITEREKO",
        Population: 27876,
        Key: "MITOOMABITEREKO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.026276844970702, -0.468874185053081],
            [30.02347297300026, -0.466516875876561],
            [30.020962550988724, -0.46601883852715],
            [30.020483177613762, -0.465578460300521],
            [30.020271730365568, -0.464798324342815],
            [30.020830970257474, -0.463025453937909],
            [30.01989007393057, -0.461973764024187],
            [30.01920508517024, -0.458883623293642],
            [30.014558467616425, -0.454431873148234],
            [30.012483786908195, -0.453421289389937],
            [30.010123186818067, -0.453923367215526],
            [30.007783788765263, -0.45246531237411],
            [30.003082716237266, -0.45064975229862],
            [30.000864446119056, -0.449130359921213],
            [29.999940921413124, -0.449317997843582],
            [29.99796987484764, -0.448439773383885],
            [29.997106747471523, -0.447175364968978],
            [29.995522157039563, -0.446046776594352],
            [29.995232052406756, -0.445012565797523],
            [29.994194556644107, -0.444813681196712],
            [29.99189194280555, -0.442817680924932],
            [29.990377314066272, -0.442253017678732],
            [29.98651864118753, -0.439535674635838],
            [29.98599318423847, -0.439767162770982],
            [29.984640938563206, -0.438803746148881],
            [29.982366924388344, -0.438342588846949],
            [29.98158845783788, -0.437703266660854],
            [29.981227932473306, -0.43967515823253],
            [29.982434748090633, -0.444561926937863],
            [29.981956517372712, -0.447576653529461],
            [29.982875503789842, -0.449072118540624],
            [29.983076200899035, -0.45133463270513],
            [29.98383268657282, -0.453354799970962],
            [29.982990433348956, -0.456592150726041],
            [29.983490799453794, -0.460511097219361],
            [29.981822184203423, -0.46322052661059],
            [29.982411649709732, -0.464765369832599],
            [29.981624184735047, -0.466284869386899],
            [29.981672706336802, -0.467829481078231],
            [29.98252610136513, -0.469991626606984],
            [29.98177977743381, -0.471061921498077],
            [29.980775215706117, -0.474157099849836],
            [29.97955159440646, -0.475480227013841],
            [29.979098034121197, -0.477921853277335],
            [29.978131260025904, -0.479480625620564],
            [29.97493609718906, -0.482789945562118],
            [29.975113413846334, -0.484541009577451],
            [29.97583235083958, -0.485918130522522],
            [29.974652844905247, -0.486706371993644],
            [29.969202169595125, -0.488524933748249],
            [29.964900714417897, -0.490730923294886],
            [29.961634119346293, -0.494714860854931],
            [29.957708099770688, -0.502346837359922],
            [29.953371446803988, -0.496932519723567],
            [29.95009891925822, -0.494415730314487],
            [29.948005542812297, -0.493559426927396],
            [29.934152924649833, -0.493514661046039],
            [29.92462772028136, -0.517637383083122],
            [29.92584321003106, -0.52017387887208],
            [29.934568254433227, -0.534040612897081],
            [29.937584443221088, -0.53572137019668],
            [29.938184872665406, -0.538907105261428],
            [29.936715787612698, -0.539600724855789],
            [29.93598404962665, -0.541079968749753],
            [29.930937718602355, -0.543557315205478],
            [29.92975204753021, -0.543673660662473],
            [29.92861638297499, -0.544890886729011],
            [29.928046984035507, -0.544818238765348],
            [29.927713438672196, -0.544159268921158],
            [29.926883184245593, -0.544131525704806],
            [29.925749699901534, -0.546296195053781],
            [29.922414491508526, -0.545102416035652],
            [29.921277471395552, -0.545724096604199],
            [29.918787410598227, -0.545848399833346],
            [29.9187648556981, -0.546389773692303],
            [29.917841682233433, -0.547201112176713],
            [29.91938601915749, -0.548312226201216],
            [29.919696325104393, -0.549196754894461],
            [29.919535332632442, -0.551335128146335],
            [29.92055646378557, -0.551904427038684],
            [29.920665220122068, -0.552770746297357],
            [29.922780171406178, -0.554532012402705],
            [29.92280679387796, -0.555813335222217],
            [29.923949249696737, -0.557501623844496],
            [29.92670358496913, -0.559453065397436],
            [29.928699690039483, -0.559758982855366],
            [29.934235877778104, -0.563395527106968],
            [29.93510867282332, -0.566121358463493],
            [29.93607186623391, -0.566155305039171],
            [29.938828582940147, -0.564314357637851],
            [29.943191776631892, -0.564481040934664],
            [29.948413585462134, -0.561665106727267],
            [29.951100081760927, -0.559169945181499],
            [29.952127293610204, -0.557190442390444],
            [29.951585916717715, -0.554182031675206],
            [29.952099895892363, -0.553696549090393],
            [29.95233408758523, -0.551901206727795],
            [29.95304702203577, -0.550736267009347],
            [29.95459072295262, -0.550169343041494],
            [29.954739324063535, -0.549780983303667],
            [29.954206614116877, -0.546703101688966],
            [29.9547372830912, -0.544501002277188],
            [29.953668237597462, -0.543721080591256],
            [29.952913519808128, -0.542391541165959],
            [29.954626996025446, -0.541289873209928],
            [29.955920003197647, -0.541515291773198],
            [29.95765157328143, -0.541086492024447],
            [29.96019215892358, -0.539767122295448],
            [29.962442710899822, -0.539695943848915],
            [29.96404976370544, -0.538987341927745],
            [29.969075184644893, -0.534708393231307],
            [29.967299506382325, -0.533263066711176],
            [29.966015123935193, -0.533310918791827],
            [29.964098313154967, -0.532712170852013],
            [29.96564252970478, -0.527122173273412],
            [29.967324413970214, -0.526031699608029],
            [29.971727340147012, -0.525187529866962],
            [29.973828817600165, -0.523221212585565],
            [29.97560443747222, -0.524432686539056],
            [29.97671795945402, -0.519248195867819],
            [29.978396376222456, -0.516876262577116],
            [29.97878331924287, -0.514936461699585],
            [29.981649109390908, -0.513124905766401],
            [29.982784361619434, -0.511763194210737],
            [29.98356252543767, -0.509814660503286],
            [29.98535001295292, -0.508372228812768],
            [29.987119358991052, -0.504276782501996],
            [29.98790043245249, -0.503564498133659],
            [29.991302674030337, -0.502735160526597],
            [29.992179220440164, -0.503491259520212],
            [29.995097267384924, -0.503787846615629],
            [29.998125532225128, -0.502247390493109],
            [30.00369860389101, -0.502612518260951],
            [30.00427349063856, -0.500793083644535],
            [30.003548564577297, -0.497897499449924],
            [30.003715140977075, -0.497310307267279],
            [30.00862381416722, -0.494719513954638],
            [30.010641943233413, -0.492687562489755],
            [30.012348551830385, -0.489209869728058],
            [30.013389782788, -0.485984850490411],
            [30.02337803724441, -0.470412839645915],
            [30.026276844970702, -0.468874185053081],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1444,
        District: "MITOOMA",
        County: "RUHINDA",
        Subcounty: "KIYANGA",
        Population: 20116,
        Key: "MITOOMAKIYANGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.22321797597977, 0.683912033632154],
            [33.21513991351657, 0.681379168233583],
            [33.21001517573762, 0.681867950108476],
            [33.206778695787605, 0.684039439796756],
            [33.201671146373315, 0.68603910927877],
            [33.19972753076333, 0.683741180844507],
            [33.198473976700086, 0.68138893851797],
            [33.19783805571721, 0.679805689586603],
            [33.197950044192105, 0.677996227852258],
            [33.20193477406141, 0.670251584781172],
            [33.20303829420082, 0.664470322784301],
            [33.20709758513704, 0.660308402587091],
            [33.208818885680515, 0.659032662949695],
            [33.20982904391242, 0.657331730752526],
            [33.21233555645586, 0.648148633978463],
            [33.21270951343054, 0.644828266026251],
            [33.21160545430193, 0.637355258240582],
            [33.210033647794795, 0.633510228295245],
            [33.20621139171936, 0.630063368550102],
            [33.20469635604322, 0.627014493870172],
            [33.20442884673477, 0.623431779373514],
            [33.2054979371443, 0.620554699854892],
            [33.207538252801335, 0.611480193643652],
            [33.20919401495664, 0.607969782581386],
            [33.210678101874564, 0.602568496210851],
            [33.21421769855431, 0.596307638838664],
            [33.21727214389515, 0.594208548310181],
            [33.22246751710321, 0.592426026139037],
            [33.226521266332405, 0.591503038482493],
            [33.22706374905103, 0.588598841262934],
            [33.228034297867154, 0.586934102705572],
            [33.234348092468544, 0.58062789294617],
            [33.23621124328355, 0.580573530594733],
            [33.25213834542321, 0.584236973784244],
            [33.270304499306874, 0.589196014210929],
            [33.26951061047957, 0.590298176998736],
            [33.269152270716106, 0.592433159279393],
            [33.26995895065474, 0.596191859454566],
            [33.269395058387964, 0.600325478024372],
            [33.27330978164887, 0.605786500354069],
            [33.27585608955936, 0.608274360781668],
            [33.28073373044804, 0.616081870332445],
            [33.28918895776982, 0.625734805238534],
            [33.2969953121989, 0.642670762087835],
            [33.29795081962389, 0.643575428061515],
            [33.2894674651523, 0.650742062592835],
            [33.282804659791665, 0.657422997171215],
            [33.27960139415094, 0.659724513937116],
            [33.274450375260066, 0.662604818622947],
            [33.27036555869505, 0.664097202965316],
            [33.26720480133358, 0.664393077355685],
            [33.267156175527255, 0.66343647712562],
            [33.266439593916665, 0.662053845012564],
            [33.26491601975379, 0.661151113610275],
            [33.26092699773406, 0.662929699558104],
            [33.259717442255116, 0.664031539630274],
            [33.25762533872195, 0.663918374774945],
            [33.25567747048741, 0.664449400631703],
            [33.252610243018395, 0.664124241337283],
            [33.250037594707116, 0.666740794401166],
            [33.24756586223656, 0.666930665629145],
            [33.24466675806623, 0.668027113485735],
            [33.24088972767376, 0.67205824055856],
            [33.238976765276206, 0.672725586264467],
            [33.23612555478525, 0.674537917187243],
            [33.23074529391868, 0.680717987522619],
            [33.22825033460815, 0.682075065381227],
            [33.22413897102984, 0.682980096033192],
            [33.22342634200655, 0.68328776152145],
            [33.22321797597977, 0.683912033632154],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1802,
        District: "JINJA",
        County: "KAGOMA",
        Subcounty: "BUYENGO",
        Population: 32470,
        Key: "JINJABUYENGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.296756886746074, 0.759590897850427],
            [33.29539547735659, 0.761327747952183],
            [33.28718856593892, 0.767896404334748],
            [33.284868690972196, 0.770916011119304],
            [33.28502674415655, 0.778150289736545],
            [33.28739001044643, 0.785084258487478],
            [33.28760376366997, 0.786160122559023],
            [33.28719988740644, 0.788932852092743],
            [33.2865228433465, 0.791753211093782],
            [33.284693733290844, 0.795696378405526],
            [33.28266271879025, 0.799495992568354],
            [33.28052482722873, 0.802817432943322],
            [33.27863637177045, 0.804824261322435],
            [33.27872566700463, 0.805168658475931],
            [33.27550102415511, 0.797958732835859],
            [33.27115071589776, 0.792874477134411],
            [33.268672342182334, 0.791960869177446],
            [33.26617818955889, 0.790260151268005],
            [33.262746037675356, 0.789708489902271],
            [33.25887413710406, 0.790441562253491],
            [33.25714017570499, 0.791635907706723],
            [33.255358370932186, 0.791256034739323],
            [33.25410225756871, 0.789564276385259],
            [33.25267565384581, 0.783077486097702],
            [33.25147122415388, 0.771922298026788],
            [33.25071116857516, 0.771089996341209],
            [33.250475445254715, 0.764883595057979],
            [33.24515278885575, 0.758333692848111],
            [33.24073078246233, 0.755411678789022],
            [33.24066162296523, 0.754172207375787],
            [33.239772881925404, 0.752281380274634],
            [33.23747135415004, 0.749124012893909],
            [33.23652370698378, 0.748563133873781],
            [33.235754036736566, 0.746355643649176],
            [33.231236021998825, 0.743958360589712],
            [33.2289474272686, 0.740864315860943],
            [33.22699261326031, 0.740050163456253],
            [33.22462264913166, 0.738430823539042],
            [33.22616105178496, 0.735698469767561],
            [33.22655136618265, 0.734151366649901],
            [33.22119526101407, 0.731202226713001],
            [33.2202942274279, 0.730342780474001],
            [33.22011612743969, 0.729609960209005],
            [33.22053560564308, 0.719359494970574],
            [33.2216269715767, 0.715446545408721],
            [33.22194858461807, 0.69318322201517],
            [33.22299238655404, 0.689222527337431],
            [33.22321797597977, 0.683912033632154],
            [33.22342634200655, 0.68328776152145],
            [33.22413897102984, 0.682980096033192],
            [33.22825033460815, 0.682075065381227],
            [33.23074529391868, 0.680717987522619],
            [33.23612555478525, 0.674537917187243],
            [33.238976765276206, 0.672725586264467],
            [33.24088972767376, 0.67205824055856],
            [33.24466675806623, 0.668027113485735],
            [33.24756586223656, 0.666930665629145],
            [33.250037594707116, 0.666740794401166],
            [33.252610243018395, 0.664124241337283],
            [33.25567747048741, 0.664449400631703],
            [33.25762533872195, 0.663918374774945],
            [33.259717442255116, 0.664031539630274],
            [33.26092699773406, 0.662929699558104],
            [33.26491601975379, 0.661151113610275],
            [33.266439593916665, 0.662053845012564],
            [33.267156175527255, 0.66343647712562],
            [33.26720480133358, 0.664393077355685],
            [33.26789945506804, 0.666515906510708],
            [33.26517480013261, 0.670105252045758],
            [33.26251710112691, 0.671951528941318],
            [33.26011896583093, 0.673033024248004],
            [33.257701411653485, 0.675857457896743],
            [33.25769775730689, 0.679152233628764],
            [33.25703427331614, 0.679989834847342],
            [33.25685162515763, 0.682998639536346],
            [33.255609581208134, 0.685365960014478],
            [33.25537605157363, 0.6870379165569],
            [33.25631637297875, 0.690399871932502],
            [33.24463772900779, 0.700479082103282],
            [33.24219936805174, 0.702023971656932],
            [33.24414406613163, 0.706779099352782],
            [33.24651677371514, 0.70749595155385],
            [33.24845324951526, 0.706303640157621],
            [33.24899935693603, 0.705206206719605],
            [33.250567217144116, 0.703608088967306],
            [33.25682715774422, 0.700049096083267],
            [33.25800317911361, 0.696032650150064],
            [33.25887752554931, 0.695930629722272],
            [33.26105173689608, 0.698078444141118],
            [33.262900398783906, 0.701412025894183],
            [33.26771444613699, 0.704773542561164],
            [33.268608085690055, 0.706808555564524],
            [33.268809193329325, 0.707921645962577],
            [33.268474220543055, 0.709641913860086],
            [33.26905509905351, 0.711148502749881],
            [33.27038427419568, 0.712115361266247],
            [33.27283071549775, 0.712728462558757],
            [33.26973375648773, 0.713501155073749],
            [33.26412449080073, 0.717226561747645],
            [33.26633246173422, 0.718507122855473],
            [33.26851896832227, 0.723839584136443],
            [33.26926821716817, 0.726932646286926],
            [33.27479974534541, 0.727127911732104],
            [33.27624058467065, 0.727566317145295],
            [33.27825110770128, 0.728982865671832],
            [33.27934576775706, 0.730410714538992],
            [33.27947984310984, 0.731175260585869],
            [33.279150645592516, 0.735846931973905],
            [33.27999961911303, 0.7377807505436],
            [33.2816192519259, 0.739534623765918],
            [33.281255972326655, 0.740296246274446],
            [33.2864322554366, 0.738694292792525],
            [33.288136659567904, 0.743092747702138],
            [33.29080079679927, 0.747696756592375],
            [33.295793705013615, 0.752294980493968],
            [33.29961141381711, 0.755062014790852],
            [33.29848352507897, 0.756142322837836],
            [33.296756886746074, 0.759590897850427],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1805,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "IRONGO",
        Population: 26423,
        Key: "LUUKAIRONGO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.33297962687733, 0.443833975668353],
            [31.328424182036663, 0.442153428920883],
            [31.326972522503823, 0.439783710149401],
            [31.32448275635394, 0.438625582213357],
            [31.32083882394725, 0.435450508244435],
            [31.319998971920132, 0.435124754387516],
            [31.31900818675559, 0.433098803452133],
            [31.313608657026215, 0.431035691520216],
            [31.29775230080843, 0.432705132507354],
            [31.295448553296005, 0.43464892150535],
            [31.29323186870427, 0.437659835282419],
            [31.291465113407433, 0.43724343606425],
            [31.290287779599417, 0.434756259007577],
            [31.289655396182145, 0.434610571732642],
            [31.28975615661428, 0.43700933742279],
            [31.28862208477208, 0.437981329342908],
            [31.286554148614993, 0.437945263936238],
            [31.28590010232461, 0.438300978303991],
            [31.28519297548241, 0.438905786381982],
            [31.28413195194412, 0.441254255516496],
            [31.282523364815994, 0.442072370057817],
            [31.28052555474325, 0.444527373382208],
            [31.27953567687718, 0.444936383772397],
            [31.27623021439816, 0.445151203103817],
            [31.27585958927485, 0.443896835190682],
            [31.274437890353372, 0.441772151240366],
            [31.273019726302536, 0.439004225373406],
            [31.27203108811156, 0.440222260128991],
            [31.264427334321756, 0.428266327145722],
            [31.263999155036515, 0.42371751093972],
            [31.26448529901376, 0.418969981952499],
            [31.264173114689594, 0.417712898679798],
            [31.259746439751662, 0.415631969520988],
            [31.256609692561078, 0.414955645710003],
            [31.255132974523402, 0.414030299180537],
            [31.25461520086501, 0.413433347406945],
            [31.254195925680868, 0.411615587968771],
            [31.252306937521645, 0.409372476816288],
            [31.251463412283325, 0.407573414414618],
            [31.249247652058035, 0.404587998738403],
            [31.240287703598934, 0.397713345999914],
            [31.234327384383757, 0.394656994739845],
            [31.234936335246875, 0.390347991519159],
            [31.241750297425412, 0.382367565136558],
            [31.246510713559395, 0.379131098259627],
            [31.248850953333612, 0.376454831764506],
            [31.248603821409052, 0.374311581938034],
            [31.246503776768776, 0.368794378425093],
            [31.245805009648624, 0.362929516984151],
            [31.244364541327588, 0.358639080263873],
            [31.23953905842095, 0.349377392918996],
            [31.2329457889515, 0.340858263086044],
            [31.227751298787386, 0.334943220319103],
            [31.225168368359395, 0.332745287640473],
            [31.221284282141234, 0.330428928843461],
            [31.218731350952147, 0.330510483734902],
            [31.217331820655268, 0.329868164836916],
            [31.214946704642717, 0.326810933715284],
            [31.213554612396376, 0.322226209963781],
            [31.211124245548003, 0.316589891061945],
            [31.20712634368169, 0.302131783829927],
            [31.20553099592422, 0.297591995019332],
            [31.205185489492923, 0.295765279208609],
            [31.20508952516606, 0.287909965196719],
            [31.203180072486326, 0.278498786675408],
            [31.203645371955727, 0.275327238961585],
            [31.202251165075214, 0.273715219009581],
            [31.202561601277836, 0.269971716353488],
            [31.20085844310984, 0.261990426470009],
            [31.200549125309745, 0.258090853934434],
            [31.19920688237517, 0.254139143395498],
            [31.19714137346597, 0.25174714444485],
            [31.195644106466155, 0.248367352513618],
            [31.1938883860743, 0.246599329119323],
            [31.18583245540472, 0.240566994382323],
            [31.175504035899685, 0.23541828725832],
            [31.17010001369556, 0.23101367190717],
            [31.170830177833228, 0.230425991626509],
            [31.174670374163203, 0.223780088176239],
            [31.179309557259728, 0.218264598237487],
            [31.180574956508266, 0.215777995825584],
            [31.185283491341348, 0.209964060383952],
            [31.186783257454287, 0.205108259751735],
            [31.188416409013843, 0.202142411519859],
            [31.18958822357276, 0.200496754790501],
            [31.19360338836389, 0.197386475446213],
            [31.204161707411366, 0.193788578407122],
            [31.20658652895949, 0.192522836906559],
            [31.212150069500197, 0.189313198470062],
            [31.216906620183497, 0.185913553283436],
            [31.220356765322204, 0.182739831690276],
            [31.22190211285096, 0.181908034576164],
            [31.22404116144255, 0.180940651781282],
            [31.23157028858848, 0.179856242386404],
            [31.233590015757507, 0.179223430884661],
            [31.23718161231576, 0.17645661427323],
            [31.239633546815778, 0.17370776437176],
            [31.2434929060074, 0.168228031400553],
            [31.245253349741063, 0.166690869597939],
            [31.24748670077625, 0.166076143362887],
            [31.250601133815135, 0.166094512036663],
            [31.260511290537384, 0.162089290056029],
            [31.263740256080037, 0.162306609618783],
            [31.266007745790986, 0.163147824590684],
            [31.27482602723483, 0.168628794168355],
            [31.27791277060342, 0.171161179635024],
            [31.281106358693577, 0.177889652065306],
            [31.282269749750046, 0.179544678533869],
            [31.293868584696177, 0.187395383854943],
            [31.294854053630857, 0.18855302664997],
            [31.295044009584196, 0.189439290704486],
            [31.293583781021876, 0.194611918263178],
            [31.293916185524772, 0.196954170063713],
            [31.29465232884895, 0.198582044204892],
            [31.296171926170118, 0.200354695182349],
            [31.297703401914227, 0.201295363847068],
            [31.3022778595979, 0.201892711067389],
            [31.302350423709935, 0.205862750804923],
            [31.30327633793451, 0.207391179405958],
            [31.3048434633207, 0.208377076635838],
            [31.3094617048913, 0.209200531636573],
            [31.3110049566505, 0.210340168090447],
            [31.311479967806456, 0.212546808864075],
            [31.31137320752651, 0.218370743299195],
            [31.3119191855899, 0.220975303982109],
            [31.31107645176736, 0.223615877393856],
            [31.311076198442443, 0.225795335208606],
            [31.313438852979633, 0.234034157615816],
            [31.313047006056067, 0.238365897717476],
            [31.31430541192013, 0.24326758183649],
            [31.316691658911626, 0.246532558860835],
            [31.31688282848894, 0.248730134625976],
            [31.318198061777885, 0.252537587765479],
            [31.31796012500855, 0.253830766466457],
            [31.31968788443892, 0.254292210321695],
            [31.32117768643872, 0.256209616522149],
            [31.322721539170843, 0.256960428992726],
            [31.323390696022592, 0.259655466033925],
            [31.32468514049925, 0.261391984951258],
            [31.326877611900816, 0.263083410473329],
            [31.327775911913555, 0.265172574977844],
            [31.33027802720367, 0.268853615443053],
            [31.331243920949966, 0.271349752556021],
            [31.333901467242104, 0.273620042692596],
            [31.333708873835093, 0.275763324666557],
            [31.335168519390795, 0.276496056663],
            [31.335751658960845, 0.275908311971519],
            [31.33709039666922, 0.276062241899587],
            [31.33781452143323, 0.27901957520433],
            [31.339495768793117, 0.280946087245483],
            [31.340188578286313, 0.281027578733135],
            [31.340384300525447, 0.282583094342265],
            [31.342779555822634, 0.283596317834867],
            [31.34847004538099, 0.283868451926865],
            [31.351318600451954, 0.285433404738004],
            [31.355761590592106, 0.289485583915103],
            [31.35707478380705, 0.289729954889979],
            [31.3622102313008, 0.292552322666821],
            [31.388539317780737, 0.29656257727059],
            [31.403914705215648, 0.297912370347732],
            [31.411213231234843, 0.299396632934305],
            [31.40976622767012, 0.303981647837457],
            [31.409538426592167, 0.306739984557239],
            [31.411280727950352, 0.315521823913995],
            [31.41138482742043, 0.321318947393819],
            [31.41566882563673, 0.335391880702645],
            [31.41954606759071, 0.340402828878925],
            [31.41822767223197, 0.344210081616317],
            [31.41833164324297, 0.350314718037272],
            [31.415758573621815, 0.357694071947827],
            [31.414678934295907, 0.362161550944115],
            [31.41267191738981, 0.367207665663497],
            [31.412904126500887, 0.371675371698708],
            [31.41198819794898, 0.374189394801425],
            [31.410879060644078, 0.380094822082984],
            [31.408662120930835, 0.384534931291362],
            [31.408813335240914, 0.386578867593023],
            [31.408060893782523, 0.388459841977449],
            [31.408870851673605, 0.391227410048673],
            [31.41146557877795, 0.393253730978624],
            [31.411733736670033, 0.394429482923703],
            [31.411494385054137, 0.395297646299407],
            [31.40833421878412, 0.402748895654123],
            [31.398852186549924, 0.403434046223069],
            [31.38999447265835, 0.40343227478924],
            [31.38391083721253, 0.401269320563148],
            [31.380510552165386, 0.403160150390047],
            [31.3705772054341, 0.413336224984648],
            [31.367093978038454, 0.417992243948127],
            [31.366060815748742, 0.417092935651663],
            [31.3662710260168, 0.41600774287441],
            [31.365967950609598, 0.415465059744621],
            [31.363985273556125, 0.414912982242681],
            [31.360461864517813, 0.420202760858883],
            [31.35725326288433, 0.426234161810814],
            [31.35399254009972, 0.430447768866178],
            [31.351362072623527, 0.431957470710029],
            [31.34582059380787, 0.437979256091816],
            [31.34244392097797, 0.439633466850995],
            [31.337230034390235, 0.440672296500606],
            [31.33435445440222, 0.443637913457821],
            [31.33297962687733, 0.443833975668353],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1987,
        District: "MUBENDE",
        County: "KASAMBYA",
        Subcounty: "KIGANDO",
        Population: 40545,
        Key: "MUBENDEKIGANDO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [32.00063945599049, -0.406696700594698],
            [32.0006630556313, -0.385366330271092],
            [32.04450195720393, -0.347160740294695],
            [32.0520052919214, -0.33848627271929],
            [32.05743320302387, -0.329829683444481],
            [32.05914915679478, -0.324130786832786],
            [32.060332931523355, -0.318838917256791],
            [32.06120771004872, -0.311728746249722],
            [32.061377771013476, -0.306445821954268],
            [32.06106687667003, -0.300493455476626],
            [32.05909411611899, -0.288434801059788],
            [32.05695130628129, -0.281541493324151],
            [32.053238757858246, -0.275154645840915],
            [32.0008398368927, -0.219354901598182],
            [32.00027404828236, -0.219119665090104],
            [32.00042341655453, -0.15373546665462],
            [31.98774062497924, -0.156909998795582],
            [31.97832995131791, -0.160301749428089],
            [31.96635216566244, -0.1662171531168],
            [31.962908129966003, -0.1685960336501],
            [31.95811984988855, -0.172901604652268],
            [31.953590974519035, -0.177849428395666],
            [31.94882080178274, -0.18448878058378],
            [31.942132021635665, -0.190241523172141],
            [31.937924406269623, -0.194655603083373],
            [31.930619537246198, -0.205392457934612],
            [31.923750702376857, -0.212040624252533],
            [31.92021147400639, -0.214546047745073],
            [31.917457694791135, -0.215776067156359],
            [31.914491966169432, -0.216345733336608],
            [31.896914233949687, -0.218732532656275],
            [31.896462689483943, -0.219184788878562],
            [31.89612674472048, -0.220885341070132],
            [31.89685663307537, -0.223083493089137],
            [31.896072332865426, -0.223870406800677],
            [31.894320893844167, -0.222386782087274],
            [31.89368041301289, -0.222431964310709],
            [31.892029592490026, -0.223589694397679],
            [31.89096230949082, -0.223725293158357],
            [31.887504004954454, -0.222024452935544],
            [31.887241995132165, -0.222503844262984],
            [31.88780796250724, -0.223869786069554],
            [31.883463482519456, -0.225958988117023],
            [31.882118934507858, -0.227903700587633],
            [31.88221151757598, -0.228934906236694],
            [31.882946032254555, -0.229197284067991],
            [31.882849962824828, -0.229721916647947],
            [31.883395239303958, -0.229821466248925],
            [31.882772246874637, -0.232562235309181],
            [31.88481361356058, -0.231730206352887],
            [31.885121344037568, -0.231965411216382],
            [31.88499965735085, -0.233349382062223],
            [31.883248689046845, -0.236795620168044],
            [31.88336310387129, -0.238613798248985],
            [31.883005599541054, -0.239400738048879],
            [31.880662477971416, -0.242439880670547],
            [31.87857336043823, -0.243443766823942],
            [31.876814073734664, -0.245424604966166],
            [31.87693111433473, -0.246021633288181],
            [31.878245101660372, -0.247034840006267],
            [31.878285864513025, -0.249875164956871],
            [31.877128782324775, -0.252733476983635],
            [31.87608303823118, -0.253936444137315],
            [31.874229740138173, -0.255293126670504],
            [31.87096238509186, -0.256884863470747],
            [31.867921122527786, -0.257834379435449],
            [31.86435712401169, -0.257933563217949],
            [31.858904376288233, -0.257109934999355],
            [31.8558631739113, -0.257390071797055],
            [31.854389831742452, -0.258176899987269],
            [31.849055750569704, -0.262514751439194],
            [31.85429254599379, -0.279139710872015],
            [31.85556372590121, -0.284667811537208],
            [31.856228897826377, -0.289502346264343],
            [31.85553129671946, -0.299790014192429],
            [31.858817354690007, -0.306371928493963],
            [31.85958897158647, -0.308769077934508],
            [31.859979909414978, -0.315951283964183],
            [31.8612025614324, -0.322627028303728],
            [31.863697027567863, -0.325494745282749],
            [31.868780366486952, -0.333075509052837],
            [31.87013373325968, -0.338231644302207],
            [31.87178278230484, -0.352677620061737],
            [31.872875338506216, -0.354966282543093],
            [31.874834422207083, -0.361696443112357],
            [31.942754395125743, -0.405793788869747],
            [31.949442807861878, -0.406907293626807],
            [31.957937150526035, -0.407279273901521],
            [31.994362884879518, -0.407627652420682],
            [32.00063945599049, -0.406696700594698],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1503,
        District: "MASAKA",
        County: "BUKOTO",
        Subcounty: "BUKAKATA",
        Population: 17743,
        Key: "MASAKABUKAKATA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.624147474205994, -0.138107125741257],
            [31.62054855458153, -0.136525501597117],
            [31.62073579852106, -0.131849294685624],
            [31.62223725077175, -0.128087080903941],
            [31.622933063332972, -0.121308876052682],
            [31.620424498139137, -0.112824691288545],
            [31.61832931248619, -0.109086985368694],
            [31.618897655905215, -0.098454021199159],
            [31.62045142154651, -0.094377138938008],
            [31.622381937024688, -0.09180822561948],
            [31.622434577402036, -0.09112646717132],
            [31.617345283550918, -0.083270453994287],
            [31.61738692315931, -0.079848443964574],
            [31.619828716578066, -0.073123480283914],
            [31.619960054764196, -0.071733745428986],
            [31.60665529753394, -0.071819441944914],
            [31.60861090475465, -0.070535444967507],
            [31.611269962911393, -0.069540209394322],
            [31.615903182991026, -0.061089600420026],
            [31.614078874430582, -0.059721166965542],
            [31.612725997239668, -0.056521412689369],
            [31.610486985919874, -0.053347491976687],
            [31.609342443314667, -0.05035762055979],
            [31.605579792254975, -0.04385028972629],
            [31.603526875031122, -0.041687157006364],
            [31.595907192314687, -0.037749608500951],
            [31.593929521572274, -0.035880808566998],
            [31.59242026386007, -0.033173692830951],
            [31.5895387909238, -0.029918893132782],
            [31.58244762302161, -0.012874164063513],
            [31.581878181861335, -0.007393498585476],
            [31.581163098640673, -0.005124973130695],
            [31.58063152506287, 0.000726640945097],
            [31.579546198502904, 0.002899147288259],
            [31.57969618661261, 0.005378570229298],
            [31.57904851836076, 0.007061186611687],
            [31.579311743603622, 0.007752016212237],
            [31.57903161206712, 0.009302581138953],
            [31.578726722961378, 0.010519386003973],
            [31.577474641236883, 0.012501548282709],
            [31.57671394066778, 0.01604428446385],
            [31.57672054508174, 0.01821408408718],
            [31.575679487498974, 0.019337329373266],
            [31.575794323633325, 0.021971822927173],
            [31.573122601027695, 0.025483499666181],
            [31.573231168717967, 0.03013647853946],
            [31.567820881663053, 0.027839218055841],
            [31.566226807716667, 0.026645323042243],
            [31.557617800496367, 0.0136302275089],
            [31.54944669592589, 0.008004532636211],
            [31.542527735962015, 0.000407200928389],
            [31.540751742390803, -0.002839739901952],
            [31.540423550088253, -0.005091793855832],
            [31.53945553901283, -0.006249474316327],
            [31.53942774064635, -0.008555793686039],
            [31.538459163632286, -0.010952553626392],
            [31.536653681963575, -0.013530195613256],
            [31.536678943487658, -0.014787364458773],
            [31.536233955825153, -0.015791287448573],
            [31.537565798065405, -0.017609216096596],
            [31.53770784147475, -0.019725602776055],
            [31.536032889508387, -0.023035831485035],
            [31.53494467666141, -0.027648451844491],
            [31.53539887025893, -0.032025933544546],
            [31.534769109922255, -0.035634628904571],
            [31.53508213057795, -0.036312961913269],
            [31.534898507747357, -0.037262618415073],
            [31.53791028760379, -0.040265400956331],
            [31.538162953150504, -0.040943734826721],
            [31.537744065140274, -0.041992883260449],
            [31.538318155980463, -0.043259086150749],
            [31.537899275156743, -0.044253969139445],
            [31.53808146247951, -0.045176503620989],
            [31.53754522395045, -0.0457734231595],
            [31.53871982687999, -0.047844613221561],
            [31.539032543905105, -0.049110834873647],
            [31.538587829330456, -0.049689665010139],
            [31.53986714977097, -0.05155282857264],
            [31.539657407525173, -0.05261101928562],
            [31.541629325456473, -0.054564659239602],
            [31.541576228734968, -0.05556858269978],
            [31.54209840862985, -0.056355458902629],
            [31.541575078891416, -0.057142308145382],
            [31.54246247066166, -0.058960263785297],
            [31.543089363575977, -0.059457711896444],
            [31.54398907843531, -0.062107748577997],
            [31.543804871699763, -0.063762871930875],
            [31.54424812291884, -0.06536374690419],
            [31.54367199469957, -0.06675656496179],
            [31.543840675852046, -0.068402648421461],
            [31.54329093744087, -0.069795474476763],
            [31.54383950175397, -0.070139175038095],
            [31.543551153327556, -0.071061701015387],
            [31.542897851740538, -0.071079758935314],
            [31.542688109494733, -0.07184853745577],
            [31.54344437328467, -0.07410965627702],
            [31.542581630387485, -0.074317659209921],
            [31.542724495755333, -0.075565786381146],
            [31.542331993959912, -0.076253140700712],
            [31.542827455263293, -0.077854022429241],
            [31.54261505849584, -0.082086800872336],
            [31.5431114127246, -0.082511901192552],
            [31.54250944356789, -0.083796187065679],
            [31.54308234683528, -0.086455260253741],
            [31.543552592428636, -0.086853232334065],
            [31.543707460186976, -0.089376629322226],
            [31.544686364233574, -0.090941347981119],
            [31.544371581083265, -0.092515063188057],
            [31.54536367419485, -0.094043615585125],
            [31.545153630115124, -0.095201283692865],
            [31.54578051494456, -0.096015300835704],
            [31.547279784289138, -0.100628028940632],
            [31.547200573542344, -0.101550552385788],
            [31.547905465376097, -0.102843941979414],
            [31.548097835102638, -0.107746018645877],
            [31.549167971151117, -0.109455472729774],
            [31.549010416531758, -0.110558881240947],
            [31.54998929901876, -0.112286409232543],
            [31.549724032803592, -0.117306064589104],
            [31.55091206464831, -0.118816546193281],
            [31.55218983729156, -0.122633360784525],
            [31.551979759075877, -0.124134724214044],
            [31.55311469150413, -0.126612970723602],
            [31.55300904423682, -0.12798771490521],
            [31.551360651860143, -0.130348223656772],
            [31.55136003561587, -0.13118935269405],
            [31.549254616355224, -0.133070473795812],
            [31.550324094836963, -0.135964754120908],
            [31.550297399601654, -0.13643506216585],
            [31.54987906854689, -0.136597844518084],
            [31.55054250043534, -0.140785452014738],
            [31.55017578028862, -0.141816502823061],
            [31.551115652536094, -0.143001376124558],
            [31.55017272871158, -0.145814138770382],
            [31.55074136857464, -0.148851654299961],
            [31.5493188027789, -0.151453127801728],
            [31.550101729464785, -0.152978787858582],
            [31.54965657741058, -0.154030475024881],
            [31.54970744002197, -0.15584504819611],
            [31.54889669790163, -0.156475793438569],
            [31.548217158321822, -0.156449164777897],
            [31.54858170903715, -0.158211290700846],
            [31.548017595784795, -0.160985428452441],
            [31.548251806342304, -0.162300439115845],
            [31.547414208188233, -0.16385158527505],
            [31.54726873680777, -0.166047380326633],
            [31.54674552474862, -0.166651969117488],
            [31.54708495677201, -0.167099193484818],
            [31.54682313200266, -0.167677618922739],
            [31.547029377107062, -0.171306812061859],
            [31.546570858121417, -0.172739808025801],
            [31.547484682818926, -0.17397626867598],
            [31.54787425520818, -0.177132194456367],
            [31.55060368199442, -0.179539823163596],
            [31.55159501513126, -0.179806150776285],
            [31.552877211078986, -0.180040631468848],
            [31.559725783548796, -0.179228867462163],
            [31.562091870548695, -0.178375379571696],
            [31.565256029830145, -0.176404624522667],
            [31.574735488391095, -0.174148396768209],
            [31.58176073791771, -0.16920092149997],
            [31.58390501111101, -0.166426115642827],
            [31.586896524076327, -0.16419702740876],
            [31.590431826808974, -0.163415064217692],
            [31.596622702235102, -0.163480444236346],
            [31.597691055127775, -0.161628121982185],
            [31.597796757192313, -0.160155464745963],
            [31.594196812590127, -0.151080853770664],
            [31.5933238163223, -0.14701400559455],
            [31.593678263685643, -0.145636758906404],
            [31.594659285959633, -0.144519566396571],
            [31.598945280232517, -0.145175019150757],
            [31.600069134636694, -0.145202225440101],
            [31.600670818129167, -0.144704796621545],
            [31.603182179778507, -0.141867585365174],
            [31.6042821255214, -0.139054193418861],
            [31.607390205674612, -0.133629810089193],
            [31.610165973851394, -0.134326780469935],
            [31.613982635219244, -0.13919631007113],
            [31.615555971557303, -0.140252397819853],
            [31.619751740839682, -0.139519310054201],
            [31.624147474205994, -0.138107125741257],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1509,
        District: "BUKOMANSIMBI",
        County: "BUKOMANSIMBI",
        Subcounty: "KITANDA",
        Population: 28455,
        Key: "BUKOMANSIMBIKITANDA",
        Dist2: "Bukomansimbi",
        "Sub Country": "Kitanda",
        id2_original: "Bukomansimbi Kitanda",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.646436446086117, 0.039435689312842],
            [31.6435118126937, 0.038106052741079],
            [31.639712328012383, 0.037708017410653],
            [31.631871045288424, 0.039100776792336],
            [31.618314975374286, 0.042600836827928],
            [31.60092745692437, 0.050008056572414],
            [31.593415547787544, 0.041234619122378],
            [31.58985623937553, 0.03777047815712],
            [31.573231168717967, 0.03013647853946],
            [31.573122601027695, 0.025483499666181],
            [31.575794323633325, 0.021971822927173],
            [31.575679487498974, 0.019337329373266],
            [31.57672054508174, 0.01821408408718],
            [31.57671394066778, 0.01604428446385],
            [31.577474641236883, 0.012501548282709],
            [31.578726722961378, 0.010519386003973],
            [31.57903161206712, 0.009302581138953],
            [31.579311743603622, 0.007752016212237],
            [31.57904851836076, 0.007061186611687],
            [31.57969618661261, 0.005378570229298],
            [31.579546198502904, 0.002899147288259],
            [31.58063152506287, 0.000726640945097],
            [31.581163098640673, -0.005124973130695],
            [31.581878181861335, -0.007393498585476],
            [31.58244762302161, -0.012874164063513],
            [31.5895387909238, -0.029918893132782],
            [31.59242026386007, -0.033173692830951],
            [31.593929521572274, -0.035880808566998],
            [31.595907192314687, -0.037749608500951],
            [31.603526875031122, -0.041687157006364],
            [31.605579792254975, -0.04385028972629],
            [31.609342443314667, -0.05035762055979],
            [31.610486985919874, -0.053347491976687],
            [31.612725997239668, -0.056521412689369],
            [31.614078874430582, -0.059721166965542],
            [31.615903182991026, -0.061089600420026],
            [31.611269962911393, -0.069540209394322],
            [31.60861090475465, -0.070535444967507],
            [31.60665529753394, -0.071819441944914],
            [31.619960054764196, -0.071733745428986],
            [31.619828716578066, -0.073123480283914],
            [31.61738692315931, -0.079848443964574],
            [31.617345283550918, -0.083270453994287],
            [31.622434577402036, -0.09112646717132],
            [31.622381937024688, -0.09180822561948],
            [31.62045142154651, -0.094377138938008],
            [31.618897655905215, -0.098454021199159],
            [31.61832931248619, -0.109086985368694],
            [31.620424498139137, -0.112824691288545],
            [31.622933063332972, -0.121308876052682],
            [31.62223725077175, -0.128087080903941],
            [31.62073579852106, -0.131849294685624],
            [31.62054855458153, -0.136525501597117],
            [31.624147474205994, -0.138107125741257],
            [31.62454314974929, -0.138226680378147],
            [31.628329888235026, -0.136007887506086],
            [31.638046508319214, -0.124750786484464],
            [31.641921121802646, -0.122863896703454],
            [31.64398954933822, -0.121358678540361],
            [31.645761266928684, -0.119434924437064],
            [31.647307782267305, -0.116805773190218],
            [31.65044574577676, -0.114966330881477],
            [31.654215312965846, -0.113931385704018],
            [31.656866078774218, -0.119543933861421],
            [31.65928471721822, -0.123235775915595],
            [31.66074765420112, -0.123949212661129],
            [31.663927416320764, -0.123793398442627],
            [31.667515001002947, -0.125677948949863],
            [31.66906015359727, -0.12591991228337],
            [31.67048415579914, -0.125110235711167],
            [31.671729819959243, -0.114985084073592],
            [31.672586335734852, -0.111973811383641],
            [31.674749852638175, -0.110761124871868],
            [31.67738040904762, -0.111417129154843],
            [31.681068003170395, -0.114845254394338],
            [31.68063380876602, -0.121620018530276],
            [31.681501828367168, -0.127456104919006],
            [31.68685920285525, -0.128367174908089],
            [31.689908483781515, -0.128473527984074],
            [31.695315221592768, -0.126238066040635],
            [31.69705911835889, -0.11818587182225],
            [31.700298081252345, -0.108528325897494],
            [31.70231056979686, -0.100667199918164],
            [31.703464932784726, -0.082354495856422],
            [31.705183816860075, -0.071283436497462],
            [31.70513899721559, -0.06762925879557],
            [31.703294368763405, -0.055698821286603],
            [31.701840152625287, -0.047386433957305],
            [31.70123023247997, -0.036677131669057],
            [31.69894378651991, -0.027577820016846],
            [31.694603825956325, -0.01552985794771],
            [31.693856161738633, -0.014200248065759],
            [31.688881334814305, -0.009505886952979],
            [31.687980647977845, -0.006439639575985],
            [31.68706340608898, -0.000370467019815],
            [31.68636486534427, 0.000172223209629],
            [31.682831189460597, 0.001302833842967],
            [31.6808675243518, 0.003573108329078],
            [31.672734397856615, 0.01049244642737],
            [31.672072362848418, 0.011405980054027],
            [31.670890881518766, 0.017068069197576],
            [31.668012507770214, 0.019039835215617],
            [31.666617391794645, 0.020785488980942],
            [31.66569448333299, 0.025669718609401],
            [31.663638724737886, 0.028844449803773],
            [31.66299490217377, 0.031738790701689],
            [31.65984138343684, 0.033032165976493],
            [31.655615888901707, 0.036948524338476],
            [31.65343382538104, 0.037572574851209],
            [31.650418760385623, 0.037509210399614],
            [31.649043029155546, 0.037889073715076],
            [31.646436446086117, 0.039435689312842],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1520,
        District: "BUKOMANSIMBI",
        County: "BUKOMANSIMBI",
        Subcounty: "BIGASA",
        Population: 42008,
        Key: "BUKOMANSIMBIBIGASA",
        Dist2: "Bukomansimbi",
        "Sub Country": "Bigasa",
        id2_original: "Bukomansimbi Bigasa",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "M",
        flood: "N",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "M",
        landslide: "M",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.19252622838817, -0.189028028040795],
            [31.191531822114726, -0.188543496474733],
            [31.19048610497058, -0.188782646469816],
            [31.177319015455943, -0.197633746038762],
            [31.173183591401077, -0.199690890046528],
            [31.171805202056092, -0.199595036794332],
            [31.16942877005738, -0.198542053245223],
            [31.167907933061162, -0.197154208423059],
            [31.163963646244245, -0.189880455415087],
            [31.16049476853697, -0.181410514139861],
            [31.158498668856506, -0.179544136852412],
            [31.153507724359386, -0.181984013699805],
            [31.150204423226917, -0.184316046229058],
            [31.150603024583127, -0.191780554178443],
            [31.15201868862251, -0.195331373012037],
            [31.155610336384736, -0.209122259252468],
            [31.156608201172, -0.211514905891708],
            [31.158222863606394, -0.223047101714453],
            [31.157849645945202, -0.224938146937697],
            [31.158206331910247, -0.226347607959689],
            [31.157830050993912, -0.228946664191604],
            [31.15646117570608, -0.23517706828244],
            [31.1545390927135, -0.237177157456637],
            [31.153594209663343, -0.239144581187697],
            [31.15336574383207, -0.242554966404082],
            [31.151801638581883, -0.246916148507104],
            [31.151280051575085, -0.249932979080301],
            [31.151487414183713, -0.251628992870415],
            [31.152970415038485, -0.252922292034922],
            [31.15542402759145, -0.256869175450306],
            [31.15739787510398, -0.2625546227445],
            [31.157775044454112, -0.266392961788397],
            [31.159390390506463, -0.27113041876076],
            [31.159247235881075, -0.274862748838291],
            [31.1549668605703, -0.291466231373039],
            [31.15634417103864, -0.298117687410037],
            [31.156106144437828, -0.300366624085255],
            [31.156865620603217, -0.306443778316235],
            [31.15658024649869, -0.307544293963242],
            [31.155439357341752, -0.308405406554618],
            [31.153252847160452, -0.308931383181963],
            [31.148547833723292, -0.308696366656043],
            [31.14412360579615, -0.309988689340962],
            [31.140368791639, -0.311624723777231],
            [31.142931308750484, -0.31299128985624],
            [31.14507767412006, -0.31900879143523],
            [31.146357424853623, -0.325628718759728],
            [31.14743868563859, -0.327950110053214],
            [31.15152723470361, -0.332138140933103],
            [31.1575426601716, -0.336116655080531],
            [31.158723118320154, -0.337383589226761],
            [31.159618475452035, -0.339613653933005],
            [31.159452637467442, -0.343910312922702],
            [31.16126941455255, -0.346651306950012],
            [31.164357712006584, -0.347826841403445],
            [31.169786848411093, -0.34896684350856],
            [31.171372418006726, -0.350707786500782],
            [31.173382009484403, -0.351690093776499],
            [31.19131400131956, -0.363835686878324],
            [31.19594582901053, -0.359660835435233],
            [31.20126316378975, -0.356822433809355],
            [31.21057991409656, -0.348396266663816],
            [31.21367305077502, -0.346561144694731],
            [31.2158851207211, -0.345955672385331],
            [31.22466323489533, -0.335747810469758],
            [31.220968132653415, -0.329302298452234],
            [31.22034121009473, -0.327679823086301],
            [31.220162757966925, -0.325763577061199],
            [31.220635301450756, -0.3244913019304],
            [31.223252265451613, -0.3210161417469],
            [31.225482048378495, -0.314299788632719],
            [31.22794644520645, -0.306203430310472],
            [31.228032152569384, -0.300455131178667],
            [31.22846249499784, -0.299047066393317],
            [31.231397020638155, -0.293981518172129],
            [31.231985865408575, -0.290774488126274],
            [31.231820943705554, -0.289718754838194],
            [31.23104114136024, -0.28895059008047],
            [31.226965913412577, -0.287041548691436],
            [31.223467919510316, -0.286111076375937],
            [31.21680560732475, -0.285097496477306],
            [31.212152377272172, -0.285420535632939],
            [31.207395469059353, -0.282909178819839],
            [31.20611250415371, -0.281729534492533],
            [31.20564905072224, -0.28087453549645],
            [31.205470562661787, -0.278134609464204],
            [31.20580413946613, -0.277006464470071],
            [31.20367995978911, -0.271510073984081],
            [31.202605746287535, -0.266426942891627],
            [31.200521551522105, -0.262557026610959],
            [31.198437551691125, -0.257244213815319],
            [31.191381774716177, -0.251228989502248],
            [31.190811693057103, -0.249027740976964],
            [31.19100202001467, -0.247544369571112],
            [31.194568303844846, -0.236778240610649],
            [31.19485397349509, -0.232997999067217],
            [31.194426595507093, -0.229744035687374],
            [31.19475951743959, -0.228117122439516],
            [31.195567843990137, -0.225772492126613],
            [31.198467779102124, -0.221609750589074],
            [31.19832530989132, -0.220556994897153],
            [31.19490370243258, -0.214814387908163],
            [31.19238482098604, -0.212277959320112],
            [31.19100668496593, -0.209837371829575],
            [31.1905790806025, -0.208258223122817],
            [31.190488752305722, -0.207171865249364],
            [31.19162519390367, -0.204478070452675],
            [31.196473991685217, -0.199167076594274],
            [31.19685462134583, -0.19562609327011],
            [31.19523894112022, -0.191845641247637],
            [31.19252622838817, -0.189028028040795],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1529,
        District: "LYANTONDE",
        County: "KABULA",
        Subcounty: "KALIIRO",
        Population: 18312,
        Key: "LYANTONDEKALIIRO",
        Dist2: "Lyantonde",
        "Sub Country": "Kaliiro",
        id2_original: "Lyantonde Kaliiro",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "H",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "H",
        heatwave: "H",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.087410077419307, -0.036440809220414],
            [31.08584814788872, -0.033673844153308],
            [31.083975210827003, -0.031765895564582],
            [31.08313095974993, -0.029686162132043],
            [31.07903141440754, -0.026855879138733],
            [31.075609148483696, -0.023889985518184],
            [31.070333180225013, -0.02967691577406],
            [31.069475423875975, -0.030183264589608],
            [31.05853888983935, -0.030680402977479],
            [31.05391511644323, -0.027099655828676],
            [31.05258360298638, -0.027009216150912],
            [31.04328176022174, -0.030996620691477],
            [31.039934108365408, -0.035291521939107],
            [31.026449281141506, -0.036095990069377],
            [31.02353976100543, -0.025679628822619],
            [31.02786860851062, -0.018039236009016],
            [31.0279339995751, -0.018518459340942],
            [31.029924006881284, -0.009792983123837],
            [31.03450231384595, -0.005181587654639],
            [31.036600330090312, -0.003617323407261],
            [31.03723941763459, -0.002342402018444],
            [31.03816675479057, -0.002044014020651],
            [31.04049183369774, 0.000786139061314],
            [31.045126845018086, 0.003128039818968],
            [31.046540868733764, 0.004511478591063],
            [31.04738625348471, 0.004647113418747],
            [31.049827537558706, 0.006564043665622],
            [31.052743424055215, 0.010949473303335],
            [31.054547589692042, 0.011645730517051],
            [31.056011027036565, 0.011419691039954],
            [31.05694707156261, 0.011989352275599],
            [31.05726506708837, 0.012821229040115],
            [31.05698831231899, 0.013960532639409],
            [31.058289794197574, 0.014512114376498],
            [31.058471667109988, 0.014973265410672],
            [31.058354330964214, 0.016356706829093],
            [31.059333021211767, 0.01819227029823],
            [31.058963349200983, 0.019982605373524],
            [31.059370583367034, 0.021845289838764],
            [31.058794606963072, 0.023888799742085],
            [31.056616523877413, 0.026845535937689],
            [31.05740767104647, 0.03077887089489],
            [31.05703458903087, 0.03398881230164],
            [31.05566236482366, 0.034359509224208],
            [31.054791974568445, 0.035209447378698],
            [31.055862710691592, 0.036818965741771],
            [31.0570499493239, 0.037397689970807],
            [31.057480179462917, 0.039215164640656],
            [31.058383928656212, 0.040128442045198],
            [31.058166077318344, 0.041991112681478],
            [31.058897744337457, 0.043935188580561],
            [31.057993667259126, 0.044776080604801],
            [31.05694444758369, 0.046828610897129],
            [31.05397289967556, 0.048519395085042],
            [31.053734026861715, 0.049116166372895],
            [31.05365988979963, 0.050418225377001],
            [31.05437110217976, 0.050879395110859],
            [31.054559126755233, 0.051738400672015],
            [31.05545921890698, 0.052669765487144],
            [31.056597903598206, 0.053004362635386],
            [31.056449050959, 0.055852620875187],
            [31.056969107236544, 0.056829187931543],
            [31.057131840643535, 0.058447732065593],
            [31.056605514125284, 0.060165713311975],
            [31.054567211592815, 0.061350152127891],
            [31.052345549436094, 0.057163580240733],
            [31.046512036406394, 0.054587525844777],
            [31.044519694378785, 0.052667898788765],
            [31.042355943015185, 0.051438447930346],
            [31.04152748162586, 0.050342424664324],
            [31.036443155458297, 0.047059957547873],
            [31.025345900240946, 0.042508812537283],
            [31.021799401804905, 0.042520827500921],
            [31.020140143406532, 0.041990089500659],
            [31.018291703402596, 0.040480041662086],
            [31.008451078079982, 0.03538922179251],
            [31.002910592801047, 0.028860900649499],
            [31.000770600080084, 0.024421332673291],
            [30.99646969646843, 0.024439344791421],
            [30.987595656594884, 0.025931081618179],
            [30.98349878823204, 0.028236645266361],
            [30.97974355456162, 0.02723294603892],
            [30.976318980865827, 0.024294339649694],
            [30.969890477690864, 0.023272527661618],
            [30.967751852205748, 0.02337195049407],
            [30.966004206769966, 0.022214596207899],
            [30.96552905098527, 0.022214588123092],
            [30.963512463428142, 0.025650363510214],
            [30.953324413771085, 0.019230689473604],
            [30.952754120109596, 0.019185474572972],
            [30.950806630964095, 0.020279471607162],
            [30.948813369061657, 0.023154644451486],
            [30.948314361209537, 0.023245051792593],
            [30.94406507209915, 0.014818316809163],
            [30.94320880425854, 0.013932241997024],
            [30.941972804174277, 0.013597694123504],
            [30.940998649520605, 0.013769472662171],
            [30.9347170155047, 0.017196109662574],
            [30.93329268541775, 0.01846189153213],
            [30.93106256023278, 0.022385833952709],
            [30.929009549584126, 0.024646151323902],
            [30.924281672226343, 0.025532123671053],
            [30.92200026581503, 0.02512522102309],
            [30.918994770572322, 0.025468738550901],
            [30.91523968332732, 0.024727282661261],
            [30.913389921003283, 0.024763415593542],
            [30.91486201361554, 0.019338649896658],
            [30.91385057438604, 0.017675034756009],
            [30.91353853109735, 0.014347827787601],
            [30.915647944267754, 0.008832643673621],
            [30.91578940017889, 0.007612066777053],
            [30.916738846670672, 0.006463824019923],
            [30.916808735599783, 0.00517091387247],
            [30.917235888110646, 0.004501857634379],
            [30.91700940665783, 0.003769508795885],
            [30.91769784405055, 0.003145659374911],
            [30.91760242500106, 0.002603179351936],
            [30.918858903978855, -0.000434707342379],
            [30.920069350586548, -0.001799948944588],
            [30.920215850538018, -0.002667918239457],
            [30.923114966386485, -0.008083696669843],
            [30.925684604443227, -0.009711153789155],
            [30.92696324396075, -0.011853968978666],
            [30.930702230700934, -0.026021878826206],
            [30.933908629665375, -0.029774118864605],
            [30.936056938989235, -0.034801196395926],
            [30.93552394607329, -0.036347271262014],
            [30.93368730813555, -0.038309221968779],
            [30.933994037889313, -0.039385158191767],
            [30.933713932403958, -0.039972844892863],
            [30.934100935611514, -0.040732333446279],
            [30.936585246292655, -0.042106692589769],
            [30.93709124663095, -0.042866187410949],
            [30.938712849449256, -0.043490088758196],
            [30.93942623754896, -0.04484632614358],
            [30.9415960435576, -0.052332722225631],
            [30.9430500162523, -0.055443036909543],
            [30.943230133856655, -0.057323670724232],
            [30.944344255014716, -0.059629287328116],
            [30.944675058719792, -0.062088583930975],
            [30.94611242515815, -0.06601264811646],
            [30.947072786180627, -0.067097666720579],
            [30.94992727192913, -0.068689089519521],
            [30.951174737211343, -0.069982079575266],
            [30.956005919030176, -0.077369232657881],
            [30.957591759916998, -0.080642351776165],
            [30.95766905725224, -0.083987734628411],
            [30.955256586640974, -0.093417947013472],
            [30.955174397080672, -0.097549929273688],
            [30.956412121031963, -0.101790492918719],
            [30.956852181435146, -0.106455963794936],
            [30.95884075952172, -0.108969649435359],
            [30.96120123294939, -0.111139785613714],
            [30.964638659740285, -0.116429355611356],
            [30.965071369229488, -0.117396838259873],
            [30.965871388160245, -0.123210650095186],
            [30.96769886507872, -0.125588732981905],
            [30.96921500388602, -0.129051792733435],
            [30.968949007340516, -0.135254327061589],
            [30.967524081670533, -0.142134880053663],
            [30.967536588914218, -0.143554415013547],
            [30.968625922858667, -0.149393221597653],
            [30.971133200766705, -0.155240148269003],
            [30.97469645996932, -0.160356357800409],
            [30.977996006143886, -0.162682082337973],
            [30.981008817266257, -0.163311208613209],
            [30.982120712399077, -0.1654385514868],
            [30.98562066283205, -0.167351780700552],
            [30.988820544519083, -0.169869053144049],
            [30.992420049845112, -0.176212146112973],
            [30.994875910881213, -0.186484267037728],
            [30.994293143213696, -0.187192314481756],
            [30.994571760190656, -0.190474511633272],
            [30.995125141270293, -0.191252170775086],
            [30.99533011166528, -0.192933961146865],
            [30.99694991515807, -0.194679212469419],
            [31.00089918133659, -0.194516925562845],
            [31.002437754669767, -0.194905903716213],
            [31.0038328320178, -0.195918755494722],
            [31.007625522740636, -0.195629865274002],
            [31.009521807016586, -0.194798233167212],
            [31.012455955364487, -0.19195943379966],
            [31.01748325557951, -0.189907505336354],
            [31.020059503440123, -0.190016297905824],
            [31.023243546930395, -0.191418157852799],
            [31.026105826462278, -0.191382319764529],
            [31.023475395817, -0.198588437476366],
            [31.019651796760197, -0.205410342378702],
            [31.02056792204314, -0.208533366291227],
            [31.02486765694663, -0.212963828198425],
            [31.02296652266642, -0.220816625851273],
            [31.023466065914445, -0.22454185370717],
            [31.028765349048058, -0.232596993536102],
            [31.037665361013058, -0.237330229967019],
            [31.03899463317328, -0.238561738634658],
            [31.044329273996453, -0.240627350755789],
            [31.046672848316994, -0.241061699426226],
            [31.04896295940341, -0.240447171857173],
            [31.051646762552974, -0.238575835774238],
            [31.057068997201192, -0.237663349362007],
            [31.057634604351854, -0.237355998818163],
            [31.05748856882938, -0.235900193399417],
            [31.0581409613213, -0.235185961528852],
            [31.058023441020886, -0.234571074375093],
            [31.06069521393219, -0.232419415134606],
            [31.061307369984217, -0.232437581615096],
            [31.062677599931497, -0.230602226184197],
            [31.06632990733159, -0.227582637156613],
            [31.066962307816905, -0.227257206143883],
            [31.067962328560835, -0.22759189242596],
            [31.069524360499386, -0.227212334749997],
            [31.070661039252567, -0.227664593406474],
            [31.071292631254096, -0.227203522346361],
            [31.07350046564366, -0.227086270665325],
            [31.074550172205953, -0.225187546980836],
            [31.074836352099275, -0.223930720126641],
            [31.07457801638652, -0.222655730265137],
            [31.0751513661166, -0.221010126915063],
            [31.074723363799485, -0.220756886531806],
            [31.07401246942299, -0.217989882838005],
            [31.073012452272284, -0.217646155758166],
            [31.07161575795674, -0.215692860394671],
            [31.071209699685387, -0.212772181141726],
            [31.070507630358243, -0.21123491909265],
            [31.070653797034733, -0.209453634770254],
            [31.071861284591886, -0.207048556112568],
            [31.07162925155064, -0.206298023067033],
            [31.072173119471415, -0.204634330502182],
            [31.074553107002004, -0.201261879351477],
            [31.075050501479872, -0.201053958373872],
            [31.078416592155726, -0.194435448835919],
            [31.07966327590367, -0.19279894602288],
            [31.081644228191777, -0.185872807713243],
            [31.08147324645387, -0.180899560350077],
            [31.08330303024599, -0.175067498393305],
            [31.08306877028114, -0.174000483551125],
            [31.085900229513943, -0.168756256469851],
            [31.08788466996035, -0.162381642000017],
            [31.089807272179193, -0.160094125322967],
            [31.091352947593027, -0.15739062351251],
            [31.091786976707372, -0.153041314870953],
            [31.09304082721465, -0.149153241975504],
            [31.092934081307757, -0.146874570453048],
            [31.09474920998433, -0.143845544606732],
            [31.094370335631776, -0.139930197345059],
            [31.09532737378602, -0.137389384683302],
            [31.095192761240703, -0.135960686560737],
            [31.096777752321238, -0.132452390522177],
            [31.097225660406735, -0.129549834526722],
            [31.09861058858869, -0.124983558286439],
            [31.09817306053632, -0.124043130405838],
            [31.09848384259032, -0.123084670650729],
            [31.097978519581737, -0.120543740408532],
            [31.098195333365457, -0.114340707640971],
            [31.09854656835335, -0.112695026914909],
            [31.09906362066457, -0.112044008300756],
            [31.09880602875687, -0.110904656521094],
            [31.099543750421017, -0.109394641624632],
            [31.09935000986538, -0.106030883529919],
            [31.10082915964253, -0.101961908271955],
            [31.100162604311805, -0.100686901738556],
            [31.100013113868755, -0.098787993665821],
            [31.100338813346355, -0.096753490375935],
            [31.10216481612946, -0.093652063834217],
            [31.10183399176315, -0.091780283558424],
            [31.102572256908044, -0.090333545027137],
            [31.102350835665245, -0.089483550270343],
            [31.101643274038413, -0.088841508046235],
            [31.102116520903138, -0.088407499213994],
            [31.101767412227545, -0.087150596808158],
            [31.102400362481784, -0.086879355312503],
            [31.10120784534886, -0.08498944221769],
            [31.101522297919136, -0.082936849693075],
            [31.100441207814047, -0.080775676005105],
            [31.10024678274215, -0.078931034073142],
            [31.09928997186167, -0.078270903216201],
            [31.098943930034434, -0.077429943444324],
            [31.099546387874696, -0.074491208186599],
            [31.098883456347828, -0.073722579729712],
            [31.099220291341716, -0.073261441636045],
            [31.098720402242304, -0.073107697795559],
            [31.09895876750799, -0.071552422427277],
            [31.09838263928872, -0.068622686999714],
            [31.098480671537367, -0.066470613433823],
            [31.097699931350885, -0.063468539109451],
            [31.098373137807954, -0.059263874426784],
            [31.098226669297507, -0.057826133243271],
            [31.09855115245624, -0.057220312415929],
            [31.09817929753934, -0.055918205046247],
            [31.09855376745202, -0.054390053776728],
            [31.096750162363918, -0.052617707240091],
            [31.095835779812646, -0.049959242138447],
            [31.0914477737544, -0.043891742472934],
            [31.088272520279197, -0.040582190864139],
            [31.087594710854603, -0.039063074508627],
            [31.08787823442964, -0.037254623410729],
            [31.087410077419307, -0.036440809220414],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1535,
        District: "KIRUHURA",
        County: "NYABUSHOZI",
        Subcounty: "KINONI",
        Population: 20653,
        Key: "KIRUHURAKINONI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.65565353903149, 0.48243580091826],
            [30.65571435048464, 0.486095801910509],
            [30.654039807251724, 0.489571229021714],
            [30.653730242414923, 0.491816518967925],
            [30.65196114521015, 0.494527596944066],
            [30.65181202127972, 0.498101573702355],
            [30.648360337326963, 0.502901416113672],
            [30.643689698822463, 0.506758675332384],
            [30.64023436321807, 0.506353610259425],
            [30.637421582654948, 0.50747513455603],
            [30.636105036927376, 0.507058083776467],
            [30.632919068347455, 0.507053600460457],
            [30.629336433382473, 0.510167538903428],
            [30.62555262969276, 0.510903552396521],
            [30.62339915685265, 0.512434606863026],
            [30.620961819975996, 0.512883849827691],
            [30.615750865489346, 0.513359776145309],
            [30.608442333136185, 0.513154955004146],
            [30.60444641564833, 0.511546644183382],
            [30.596052371682266, 0.505841636335115],
            [30.594798253477048, 0.504530728188508],
            [30.59258492588953, 0.500734540876897],
            [30.591572173323076, 0.495915815003303],
            [30.59055367423371, 0.493906021824289],
            [30.583830040351916, 0.487803358542803],
            [30.57636887974041, 0.485737252259536],
            [30.5710667785918, 0.483933920146412],
            [30.569904530192343, 0.483169592451668],
            [30.559624451727707, 0.471979647941948],
            [30.55655448349872, 0.466545956971489],
            [30.55661439753493, 0.465315910271032],
            [30.557302925657496, 0.464384414928827],
            [30.556212875755755, 0.461518300626743],
            [30.55422052294835, 0.460085252923319],
            [30.551432985044734, 0.459404562057666],
            [30.549394013267317, 0.456251868015484],
            [30.54919107755646, 0.455007214290013],
            [30.547657974963332, 0.454665151998046],
            [30.547083600255494, 0.450330768604549],
            [30.546371868649143, 0.450402837315018],
            [30.545588452381434, 0.4512883915638],
            [30.54482949813723, 0.45078194877704],
            [30.544759063930776, 0.449136829389104],
            [30.54400028934962, 0.448088048799181],
            [30.544617755343324, 0.446723371623448],
            [30.54439255848136, 0.446379814191146],
            [30.54341962733313, 0.446804316352877],
            [30.542969371051452, 0.445710448553149],
            [30.542565890046642, 0.445710312013355],
            [30.542019799693843, 0.446758647392313],
            [30.54095238194738, 0.44613459682798],
            [30.54202089294355, 0.44432716558969],
            [30.541736502494278, 0.443531640554824],
            [30.54064565578691, 0.442482754066801],
            [30.540598915544333, 0.440855726155591],
            [30.53997037062826, 0.440539152146125],
            [30.53828551024431, 0.441234586588327],
            [30.537408002637093, 0.440321359345297],
            [30.53702914804751, 0.438820769622565],
            [30.53795656964512, 0.434256414824388],
            [30.537291890895062, 0.435042582467776],
            [30.534918922800095, 0.435692599014406],
            [30.533910815421958, 0.435177046506977],
            [30.533223567398657, 0.433332881554274],
            [30.532013592406514, 0.433214976552909],
            [30.531373455629993, 0.432310875857279],
            [30.531040769954394, 0.433341199715885],
            [30.530590033074073, 0.433286817263852],
            [30.53037620349375, 0.43379292438578],
            [30.52975940045673, 0.433620981885149],
            [30.528810780415018, 0.432671585879692],
            [30.529084396470772, 0.431225455251617],
            [30.528823696392152, 0.43048418104854],
            [30.528159023031982, 0.431270344591458],
            [30.527139331878235, 0.430149189862566],
            [30.5265707746602, 0.428286997701253],
            [30.525169560022135, 0.427825557695989],
            [30.525005833078456, 0.426108121781647],
            [30.526038929791177, 0.423930093232218],
            [30.5260157218158, 0.422800228503207],
            [30.5270125643203, 0.42211359652442],
            [30.527879507739755, 0.420071091141156],
            [30.527002058523045, 0.418968068592104],
            [30.52835525820916, 0.417323426463034],
            [30.528237943622944, 0.414286326720647],
            [30.52760984786449, 0.412984531118504],
            [30.528251864814898, 0.409667467037273],
            [30.529058992114525, 0.408637287370553],
            [30.529926021772262, 0.406242252531833],
            [30.531611425636953, 0.404570579042714],
            [30.533438403092138, 0.404209585664255],
            [30.53370015958951, 0.402447079051207],
            [30.534436472695276, 0.400838377837774],
            [30.535908001165584, 0.399383559369264],
            [30.53624014605536, 0.399600595151035],
            [30.535575263387692, 0.400676024796418],
            [30.535883685567452, 0.400938247391478],
            [30.537580432459258, 0.400260845291796],
            [30.539264312781235, 0.401788940075821],
            [30.54156525844832, 0.40264834431809],
            [30.54291674414886, 0.404790994064338],
            [30.545005248132693, 0.403480982931273],
            [30.54533696452609, 0.404656153117796],
            [30.54623858740709, 0.404312947739562],
            [30.546168016656676, 0.402929959200674],
            [30.54695143651763, 0.401908791251504],
            [30.547995260911467, 0.402216436000292],
            [30.548114079277482, 0.401782599922432],
            [30.547355090897284, 0.401330417978568],
            [30.54740277347258, 0.400923677972598],
            [30.54849444034183, 0.400282239046531],
            [30.547154634536575, 0.398428837753338],
            [30.547772339482144, 0.396566988488673],
            [30.548413193114246, 0.396088113457426],
            [30.548128748766054, 0.395392023751346],
            [30.548461073318908, 0.395012484691109],
            [30.54815283080221, 0.394605637476622],
            [30.548438044108284, 0.393656626663486],
            [30.547596659555282, 0.391441818532777],
            [30.5494714121122, 0.390393848551713],
            [30.54980405736359, 0.389390615304811],
            [30.55044015980618, 0.389102448699932],
            [30.551365372446526, 0.387419047204113],
            [30.552044456580507, 0.38728486173014],
            [30.552358337822252, 0.38563144585665],
            [30.553444054251067, 0.384223652287404],
            [30.55352555210857, 0.383370628536686],
            [30.557798344740046, 0.379194260119154],
            [30.558895776996764, 0.377383302266531],
            [30.561937820196817, 0.374392642382425],
            [30.56281456962592, 0.373060725170624],
            [30.562861343106125, 0.371822059005416],
            [30.563842718418066, 0.369911727369254],
            [30.56446397889551, 0.369006261455957],
            [30.565334600017746, 0.368842904411346],
            [30.564540181184427, 0.366248463353375],
            [30.563362560813836, 0.364191462856165],
            [30.561186171950833, 0.364015581664846],
            [30.560844009048996, 0.363045579684592],
            [30.560141850788643, 0.362659761007129],
            [30.560252277093245, 0.362087195279891],
            [30.55982865945303, 0.361859209207227],
            [30.560003085331736, 0.360702379985765],
            [30.558251268119772, 0.357207904194219],
            [30.55793316569453, 0.353024368575801],
            [30.558635552126976, 0.352545446250532],
            [30.55829907466257, 0.352001974877635],
            [30.558137550387972, 0.348233321570491],
            [30.55857883429654, 0.347485557048477],
            [30.55827132121188, 0.347140751349924],
            [30.558265985219087, 0.34532947987332],
            [30.55862484870036, 0.344703992484819],
            [30.559336538984184, 0.344758411439702],
            [30.563618232123503, 0.347136812309684],
            [30.576663028588616, 0.359026767570964],
            [30.580292137894833, 0.361820864485656],
            [30.590029963609574, 0.366921656929646],
            [30.59107339543964, 0.368304954942598],
            [30.591724781818478, 0.370926531141],
            [30.594187602103094, 0.372699557972668],
            [30.59457106505012, 0.373191096699878],
            [30.59484171397049, 0.378529372224485],
            [30.59676259771219, 0.38096551832493],
            [30.602727765134965, 0.386255665595932],
            [30.6102678148964, 0.398651621740651],
            [30.615260230834007, 0.403798625621507],
            [30.615710051432725, 0.406115490854168],
            [30.615234281200383, 0.408910116744957],
            [30.616028308368236, 0.410880610726029],
            [30.621247103350687, 0.413770487128509],
            [30.623820563738942, 0.416027550204273],
            [30.625813282160667, 0.416958980628156],
            [30.629347448524484, 0.419848977873951],
            [30.63284654376132, 0.421556641770451],
            [30.63434052921537, 0.423539083451971],
            [30.63685561438155, 0.423706173612537],
            [30.638136214921364, 0.425306473875283],
            [30.63909627051663, 0.427396432758006],
            [30.641965987200784, 0.430477584905566],
            [30.642558383011526, 0.432269014658215],
            [30.64209432411555, 0.435314470407187],
            [30.64273398568327, 0.437511947255394],
            [30.644133340808683, 0.438849517563381],
            [30.644795386596677, 0.444008851743874],
            [30.645909388278824, 0.446684030202942],
            [30.646228125812982, 0.450159428339409],
            [30.64660749962882, 0.450756567664201],
            [30.651517814041, 0.453837730811597],
            [30.652264657198547, 0.455139499619368],
            [30.65257250984644, 0.456453223490942],
            [30.652096187150185, 0.460251125982218],
            [30.653007846009526, 0.464275902005948],
            [30.65173607501065, 0.469160616759152],
            [30.65258943230976, 0.470999833840433],
            [30.652279853998206, 0.473316789660282],
            [30.65281270947193, 0.475502349062548],
            [30.65565353903149, 0.48243580091826],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1538,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KIGARAALE",
        Population: 23964,
        Key: "KYENJOJOKIGARAALE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.53408297125794, 0.744173399134678],
            [30.533674124615928, 0.745782620081691],
            [30.532942948076965, 0.746666601428648],
            [30.531530813518316, 0.747241715082811],
            [30.5291376297362, 0.749241543807502],
            [30.528678820594727, 0.751046506950251],
            [30.528794372686335, 0.754635417632822],
            [30.5284314209722, 0.756534315268524],
            [30.52366322273293, 0.761232774766159],
            [30.5234840887838, 0.76244286286648],
            [30.522212690585775, 0.763709985885591],
            [30.513743792702005, 0.765040778137711],
            [30.510584905632957, 0.767746322802848],
            [30.50741620985933, 0.768046839765803],
            [30.503465154236753, 0.767205032203883],
            [30.503802158113896, 0.761468953340788],
            [30.503316527074684, 0.754444584404854],
            [30.50258253880884, 0.753581563206716],
            [30.50111398196553, 0.752841327345289],
            [30.4965843475196, 0.753331615117555],
            [30.493524413472358, 0.752590466604064],
            [30.488115711943916, 0.749087644115005],
            [30.48726995169719, 0.747480091508984],
            [30.478981454387092, 0.751349963211023],
            [30.475444201411946, 0.751704426792608],
            [30.474756975846535, 0.751035589764242],
            [30.472550228418495, 0.750615816127873],
            [30.47214759362668, 0.750090430287333],
            [30.46077943796067, 0.749303700113306],
            [30.454773973910893, 0.749512548635845],
            [30.448435260941817, 0.750305685905867],
            [30.446504865837884, 0.754980839290542],
            [30.44505594347173, 0.755611756631433],
            [30.44365271750576, 0.757304604606909],
            [30.443841357427218, 0.758044522630445],
            [30.446903750163383, 0.757737353525991],
            [30.447472602028864, 0.758215188491393],
            [30.446826402522465, 0.761400181701073],
            [30.44601879462416, 0.761757319408074],
            [30.44711013720159, 0.762044755782002],
            [30.44732031243536, 0.76409714422466],
            [30.446440854585678, 0.76483600565656],
            [30.445824055141955, 0.764644485729081],
            [30.445422034797783, 0.763761168241401],
            [30.4439247803744, 0.76490507096425],
            [30.442382396387764, 0.764652974950768],
            [30.44168795914726, 0.765951993643451],
            [30.43738694504284, 0.764711362040476],
            [30.430967416037547, 0.764191881111587],
            [30.42607483436907, 0.766048217068307],
            [30.42460366342827, 0.765808117949324],
            [30.42444069017109, 0.763922847030602],
            [30.42581114559551, 0.760547725145187],
            [30.42486587986306, 0.758088992530966],
            [30.424986276569012, 0.757063030095914],
            [30.42966065565836, 0.750851583886946],
            [30.430281603522076, 0.748561427220428],
            [30.43023625297328, 0.747296681912983],
            [30.42963770999106, 0.746445182813415],
            [30.42954308235735, 0.743338941732824],
            [30.430469716132464, 0.741284567393015],
            [30.432500929160746, 0.738740943817457],
            [30.433118704174888, 0.737116494228721],
            [30.433095224010017, 0.734822672804936],
            [30.431302447214332, 0.729481462133342],
            [30.431207583323715, 0.728143359099531],
            [30.431480876884272, 0.726984657250128],
            [30.434996784989952, 0.723115662615406],
            [30.435178531239913, 0.715095349466993],
            [30.433658992309258, 0.709883762201143],
            [30.43092230444061, 0.703241113509479],
            [30.429605331114946, 0.698744865516694],
            [30.428137802842645, 0.69113233911566],
            [30.42509529880685, 0.686839514530641],
            [30.42428630570639, 0.681321866058582],
            [30.422867243340253, 0.67784731826334],
            [30.420433351502737, 0.674167873752781],
            [30.41444742940362, 0.67007788314923],
            [30.411910010322845, 0.670280868753855],
            [30.411199984617244, 0.669463137038052],
            [30.41109962393538, 0.667317533914935],
            [30.407750432366658, 0.667213574445879],
            [30.40754777872675, 0.666600457409853],
            [30.408844412397737, 0.665296551921605],
            [30.41008641682136, 0.664047579768989],
            [30.40856525553332, 0.661696879236241],
            [30.408363130102803, 0.660062062262323],
            [30.40450665180831, 0.659651358192984],
            [30.403695306918415, 0.658527070630686],
            [30.403899087943973, 0.656994648437411],
            [30.400246191249053, 0.655460192121396],
            [30.39831870489002, 0.653824492812888],
            [30.39679745197381, 0.651678160738861],
            [30.396493604015475, 0.650451992831131],
            [30.397002012737055, 0.648613225470326],
            [30.39811908755577, 0.64728562283646],
            [30.398424403361297, 0.645651084122486],
            [30.39659877248073, 0.643300266289153],
            [30.396701505613255, 0.640848291722456],
            [30.397311221841, 0.639316074366421],
            [30.400153732148432, 0.637785015308057],
            [30.401371631179707, 0.63778563780201],
            [30.401879959951245, 0.63604902228605],
            [30.403097595776146, 0.636560495059316],
            [30.40401172769746, 0.635130595438124],
            [30.406143095693395, 0.635029513330692],
            [30.404824778488074, 0.632883294615737],
            [30.405180787123378, 0.631299856066764],
            [30.40457301395162, 0.628949663161283],
            [30.405689875869626, 0.62803071137158],
            [30.40761810872868, 0.628236018872946],
            [30.408430642988, 0.627010396001237],
            [30.411069311184427, 0.62721605745767],
            [30.412592146033862, 0.626297291303568],
            [30.412390509286872, 0.623538617769137],
            [30.412898626055963, 0.62221067004676],
            [30.41492940519794, 0.620270451834719],
            [30.41471974649547, 0.617321505952991],
            [30.414224629246842, 0.617389348174771],
            [30.413983449559392, 0.616934323982899],
            [30.41343826650503, 0.611846837201193],
            [30.41388472201472, 0.610765173555184],
            [30.414546474951894, 0.610675404618787],
            [30.41642459619113, 0.61172273483311],
            [30.417873523947197, 0.610743723903233],
            [30.419607461091736, 0.610266600046928],
            [30.420391316635623, 0.609574019341223],
            [30.421293941138185, 0.607734592621579],
            [30.423312920010595, 0.607353157955631],
            [30.42402549782992, 0.606660539148786],
            [30.425225016432186, 0.606314588568976],
            [30.427220269899653, 0.604403939081786],
            [30.42847913570113, 0.605766419638292],
            [30.42923922361924, 0.605742841078234],
            [30.429357991679563, 0.605384485398221],
            [30.428550408934107, 0.604786811179812],
            [30.428930468164495, 0.603066620397399],
            [30.42935803300206, 0.602493341920121],
            [30.431210753478332, 0.601896772250792],
            [30.431685811346675, 0.601108490131218],
            [30.434405494107004, 0.601910056702469],
            [30.435711901448304, 0.601791138896243],
            [30.43587814636972, 0.602603597735856],
            [30.436566992495884, 0.602078223719132],
            [30.437707108203355, 0.604396415211599],
            [30.441151257985794, 0.604230604416528],
            [30.44148380172758, 0.605234293668063],
            [30.442101372824144, 0.604374364594873],
            [30.443312783324156, 0.604757181002534],
            [30.44470232794833, 0.604602447625792],
            [30.4454839188394, 0.602093796951325],
            [30.447924583075835, 0.603046914248307],
            [30.450764920358615, 0.606882281231644],
            [30.452349855743634, 0.610539615805332],
            [30.452611101997952, 0.612666313563887],
            [30.453430556878214, 0.613849420444999],
            [30.453454308334333, 0.614709625568687],
            [30.454681620811463, 0.617568489686551],
            [30.45673216648298, 0.618414638191028],
            [30.460057631748395, 0.618917841483847],
            [30.463976946298732, 0.61798764258837],
            [30.464855810362, 0.618609267517618],
            [30.465663411073795, 0.61963706794257],
            [30.466090917520877, 0.622217855247003],
            [30.468169248982413, 0.6265794981481],
            [30.469119359329213, 0.627846311793417],
            [30.47106712335916, 0.62906577509248],
            [30.473501766188246, 0.632185080289038],
            [30.474736903889863, 0.634503395171539],
            [30.480273631515967, 0.636083303477991],
            [30.482349881580994, 0.637696669676202],
            [30.484131311756315, 0.640947144236554],
            [30.482599006867176, 0.646502003191965],
            [30.48281270709009, 0.64838978385651],
            [30.483299639788164, 0.649142685492974],
            [30.48503366586595, 0.649597466124606],
            [30.487765420187078, 0.648188883114125],
            [30.49288441054484, 0.647988067698238],
            [30.493597029686658, 0.648203421416571],
            [30.496138622340247, 0.650522373992514],
            [30.49756388577678, 0.650164581894804],
            [30.499321669598874, 0.650714950491291],
            [30.503202717714714, 0.654381447925457],
            [30.507905468295657, 0.657330338455458],
            [30.5086163474008, 0.660965782841953],
            [30.51013561593856, 0.66326239978257],
            [30.51156038619998, 0.664506708394383],
            [30.514267609327334, 0.665716062909752],
            [30.51476376053685, 0.666486919837832],
            [30.51687342703214, 0.667737628596232],
            [30.51770040620122, 0.668904374534797],
            [30.519892654820616, 0.670509193190836],
            [30.52138200766277, 0.67105146447191],
            [30.52589266519831, 0.670283162894114],
            [30.52660841676554, 0.670597458300466],
            [30.526011122441567, 0.672327766899683],
            [30.526119313737752, 0.674399346384943],
            [30.530370343783144, 0.677836752120125],
            [30.535673628013, 0.683028492025276],
            [30.5421986704366, 0.690687185292571],
            [30.54751069257922, 0.697686586761624],
            [30.54728024865771, 0.699091145683516],
            [30.545568587935556, 0.700801060040107],
            [30.5425633541026, 0.70236341771225],
            [30.536937365378268, 0.704047063422438],
            [30.53402644926027, 0.705489946846124],
            [30.52735165318724, 0.711056085801716],
            [30.525748520629488, 0.713134029494071],
            [30.52504048828548, 0.716360634716813],
            [30.523134563289883, 0.719605627425973],
            [30.52368814828709, 0.721267517656665],
            [30.52716196313521, 0.72589850890117],
            [30.53281579963333, 0.730018237433467],
            [30.53239031259899, 0.737762345589366],
            [30.53408297125794, 0.744173399134678],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1544,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "BUGAAKI",
        Population: 31549,
        Key: "KYENJOJOBUGAAKI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.561326674749456, 0.940502070639019],
            [30.56080989911934, 0.940694628214252],
            [30.558801279618795, 0.938366174808255],
            [30.549660375427177, 0.930265738962942],
            [30.546145086260733, 0.92651981496304],
            [30.542525877287257, 0.92773137674832],
            [30.537801475511344, 0.928335095673331],
            [30.5331280261783, 0.927977696633046],
            [30.5305154899735, 0.92696412106854],
            [30.52941108050195, 0.925243392078718],
            [30.52961265436685, 0.924434159458364],
            [30.529010167780545, 0.923624344620933],
            [30.52760317248362, 0.923421014914538],
            [30.523887440431196, 0.918966795779283],
            [30.522582219764423, 0.916942425444081],
            [30.521679319479087, 0.914513649828905],
            [30.519771195407664, 0.912286526877384],
            [30.518968870501553, 0.909756663560627],
            [30.517964788474174, 0.908299078052924],
            [30.516196462023917, 0.907407534807668],
            [30.514911127362566, 0.905706953896815],
            [30.513867454784013, 0.903359032396805],
            [30.51113636341957, 0.899391215687408],
            [30.50776026371482, 0.898012952786972],
            [30.5069558816667, 0.898498023847018],
            [30.505909346157328, 0.900358852284781],
            [30.50534645641041, 0.90043940325203],
            [30.502938477375572, 0.894286528493066],
            [30.497436805605094, 0.885339243805393],
            [30.494705390847166, 0.881857113246303],
            [30.492498576943767, 0.875421185051308],
            [30.491051903060757, 0.874529908698424],
            [30.491294085268102, 0.873073204763373],
            [30.489767167575728, 0.871939076685389],
            [30.488160541469867, 0.869752730133073],
            [30.4872764779577, 0.869185577612354],
            [30.48767893308646, 0.868538351197363],
            [30.485108490139222, 0.864813584254987],
            [30.483301785863397, 0.861210733608792],
            [30.483142259441973, 0.859268161620697],
            [30.481857937181953, 0.856029883150765],
            [30.481617829184593, 0.854330077307103],
            [30.4822635418041, 0.850526532817189],
            [30.481299651300862, 0.849069049930534],
            [30.481300701431433, 0.847450343727568],
            [30.479372403893695, 0.845344748195721],
            [30.479212072581774, 0.84461622007104],
            [30.47945375263088, 0.843887965766223],
            [30.480660056208457, 0.843484069514368],
            [30.482991886853313, 0.84324279559253],
            [30.487093409387647, 0.841707689533075],
            [30.492119411537058, 0.840456444221754],
            [30.493085134603476, 0.839081149084415],
            [30.492603952919854, 0.837138376451249],
            [30.488508339503465, 0.829365859820556],
            [30.485937645926263, 0.825883967685448],
            [30.485939023043585, 0.823698698143396],
            [30.48300681236175, 0.819771440386516],
            [30.47907226507917, 0.811513521325344],
            [30.477226240645027, 0.806332497681506],
            [30.475779856917875, 0.804955679066603],
            [30.473529013887475, 0.804306799197986],
            [30.469153147661967, 0.79455140617442],
            [30.461802729562077, 0.784308643172063],
            [30.458429485601602, 0.778398377037376],
            [30.456983265367818, 0.776778818825097],
            [30.451983974623364, 0.774153519977575],
            [30.451727781392552, 0.772340445581955],
            [30.448771257807547, 0.768712822266041],
            [30.445877518376072, 0.767675128724842],
            [30.44491330717427, 0.766703342016774],
            [30.44168795914726, 0.765951993643451],
            [30.442382396387764, 0.764652974950768],
            [30.4439247803744, 0.76490507096425],
            [30.445422034797783, 0.763761168241401],
            [30.445824055141955, 0.764644485729081],
            [30.446440854585678, 0.76483600565656],
            [30.44732031243536, 0.76409714422466],
            [30.44711013720159, 0.762044755782002],
            [30.44601879462416, 0.761757319408074],
            [30.446826402522465, 0.761400181701073],
            [30.447472602028864, 0.758215188491393],
            [30.446903750163383, 0.757737353525991],
            [30.443841357427218, 0.758044522630445],
            [30.44365271750576, 0.757304604606909],
            [30.44505594347173, 0.755611756631433],
            [30.446504865837884, 0.754980839290542],
            [30.448435260941817, 0.750305685905867],
            [30.454773973910893, 0.749512548635845],
            [30.46077943796067, 0.749303700113306],
            [30.47214759362668, 0.750090430287333],
            [30.472550228418495, 0.750615816127873],
            [30.474756975846535, 0.751035589764242],
            [30.475444201411946, 0.751704426792608],
            [30.478981454387092, 0.751349963211023],
            [30.48726995169719, 0.747480091508984],
            [30.488115711943916, 0.749087644115005],
            [30.493524413472358, 0.752590466604064],
            [30.4965843475196, 0.753331615117555],
            [30.50111398196553, 0.752841327345289],
            [30.50258253880884, 0.753581563206716],
            [30.503316527074684, 0.754444584404854],
            [30.503802158113896, 0.761468953340788],
            [30.503465154236753, 0.767205032203883],
            [30.502105795701045, 0.767366427021071],
            [30.501525087870473, 0.767866890141952],
            [30.500777525162388, 0.770120074246283],
            [30.50094198872459, 0.772457266258536],
            [30.501769830276384, 0.774711386586353],
            [30.502993913310082, 0.77601422329551],
            [30.50734749592662, 0.776088959864384],
            [30.507956413552044, 0.776486098241917],
            [30.508367667679007, 0.777875058733389],
            [30.51028331064937, 0.78023882604858],
            [30.511446222903782, 0.783742035349525],
            [30.512904083507028, 0.785619543022501],
            [30.51565857239136, 0.787905799471978],
            [30.51727688917235, 0.792557574648998],
            [30.51930149688834, 0.795496153351923],
            [30.519541372222008, 0.800963038179702],
            [30.52035014523525, 0.80390088600723],
            [30.520668050031134, 0.81426341522508],
            [30.5193690088752, 0.81777111088431],
            [30.519025832673705, 0.820862682789302],
            [30.515023038582367, 0.824505617102611],
            [30.512142741540796, 0.830169564691276],
            [30.511351620422893, 0.835087225443861],
            [30.512203948252665, 0.834862162975529],
            [30.514999196396403, 0.835433914046724],
            [30.517776684846957, 0.834913281569162],
            [30.520948326196404, 0.832133837879168],
            [30.522584350568273, 0.832127987768775],
            [30.52531464782201, 0.830818944282104],
            [30.527769777629466, 0.829055991467968],
            [30.53090055192172, 0.828049672762422],
            [30.53417958955832, 0.830244777225257],
            [30.535055297840017, 0.83143007573237],
            [30.54041144433107, 0.835769137742574],
            [30.54128979545633, 0.832719586315274],
            [30.54236712521364, 0.831838002644252],
            [30.542843788371357, 0.830426680441618],
            [30.545200211295416, 0.829305730200079],
            [30.545700415703507, 0.827225377526504],
            [30.545559855412705, 0.823996670856682],
            [30.54705841778313, 0.821055970513876],
            [30.548627723380516, 0.818976272827495],
            [30.55140868920953, 0.816897316893287],
            [30.551908176762037, 0.815964908194881],
            [30.552927100754495, 0.812524077523439],
            [30.552717620816775, 0.811111400263219],
            [30.555585529192246, 0.808258882811351],
            [30.560783255088037, 0.80475234929537],
            [30.56440575189541, 0.806062073163018],
            [30.565567896090275, 0.806131593190175],
            [30.574319398572523, 0.804622870816109],
            [30.57513968978431, 0.804761001014702],
            [30.57958141958814, 0.808066951692372],
            [30.581046707462146, 0.812085588327778],
            [30.582045198375152, 0.81103387264294],
            [30.586228260089523, 0.808453422369143],
            [30.58888949216928, 0.808024523989646],
            [30.5913611105538, 0.806830180607435],
            [30.59293031913313, 0.804917796358222],
            [30.59226614164299, 0.803099743915313],
            [30.593743878370177, 0.801386953935957],
            [30.593591717235785, 0.800768151548886],
            [30.58952073921773, 0.799832531575685],
            [30.587296550100138, 0.796878220798441],
            [30.58486964805384, 0.796473120667456],
            [30.584309807188973, 0.794985152807582],
            [30.582053687454593, 0.795076185602189],
            [30.58138490160704, 0.794679246601877],
            [30.5808498937699, 0.793309554220905],
            [30.578989071388108, 0.79244921495452],
            [30.57863406347601, 0.791926111289711],
            [30.579335077282693, 0.790395588157406],
            [30.579027568689582, 0.785166417875635],
            [30.58018567316063, 0.784058776824226],
            [30.58238778079023, 0.78388955186393],
            [30.586932556340276, 0.784602665645796],
            [30.58741209141198, 0.785284991543502],
            [30.58876706616909, 0.785484711385447],
            [30.589586240774985, 0.784661048867705],
            [30.58975608434744, 0.78386542627177],
            [30.590631541100848, 0.783354399147631],
            [30.59136660734501, 0.78150761267922],
            [30.59303248542869, 0.781082297242947],
            [30.59492346784787, 0.781964372466963],
            [30.597379629819592, 0.781880537813987],
            [30.60191769315786, 0.778497111638199],
            [30.60323839898349, 0.775213776451697],
            [30.604282580906833, 0.769903918686487],
            [30.606784179665645, 0.765014122109675],
            [30.60754962333945, 0.761590699341703],
            [30.60755078216618, 0.75949446319562],
            [30.60490625695407, 0.758265820293335],
            [30.602752454432224, 0.759180823298857],
            [30.599844560246826, 0.758888688059189],
            [30.596782666075644, 0.756093663539657],
            [30.595096791493738, 0.753858078453051],
            [30.594031460533667, 0.753477594001318],
            [30.588836149309373, 0.754949547397693],
            [30.58546169711487, 0.755416926290779],
            [30.579380494306843, 0.753245928635471],
            [30.57924870067488, 0.750720739330402],
            [30.580382890196407, 0.746967216862933],
            [30.58262590710406, 0.745203113846571],
            [30.583647906928075, 0.743617098708856],
            [30.58298347341806, 0.740823453118161],
            [30.585092435634188, 0.734923740232122],
            [30.584236994243607, 0.732237891688333],
            [30.581012389123327, 0.729316644516554],
            [30.579714239096152, 0.72744765297446],
            [30.57903353080812, 0.727820941142946],
            [30.57643275444869, 0.732427956082749],
            [30.57643123899082, 0.735230377374841],
            [30.577358123395896, 0.737223720841935],
            [30.577495788416556, 0.738440566755675],
            [30.575669925770665, 0.742106485753261],
            [30.572380685967367, 0.747294200977202],
            [30.569986372104633, 0.749175634660381],
            [30.568826462918185, 0.749636159714728],
            [30.56770335950558, 0.751541854698805],
            [30.566612978125512, 0.751812183909722],
            [30.565402129072584, 0.751894009793332],
            [30.561596615797416, 0.75009126834367],
            [30.55980795328573, 0.747549575672126],
            [30.558997569593195, 0.747028237826967],
            [30.553862388899084, 0.745816122606743],
            [30.54387789748541, 0.743931699043049],
            [30.53408297125794, 0.744173399134678],
            [30.53239031259899, 0.737762345589366],
            [30.53281579963333, 0.730018237433467],
            [30.52716196313521, 0.72589850890117],
            [30.52368814828709, 0.721267517656665],
            [30.523134563289883, 0.719605627425973],
            [30.52504048828548, 0.716360634716813],
            [30.525748520629488, 0.713134029494071],
            [30.52735165318724, 0.711056085801716],
            [30.53402644926027, 0.705489946846124],
            [30.536937365378268, 0.704047063422438],
            [30.5425633541026, 0.70236341771225],
            [30.545568587935556, 0.700801060040107],
            [30.54728024865771, 0.699091145683516],
            [30.54751069257922, 0.697686586761624],
            [30.548124373072323, 0.697041059401677],
            [30.549718658122792, 0.693131684947416],
            [30.550275959450364, 0.689275528595553],
            [30.550615026757704, 0.688666911892751],
            [30.552176424485637, 0.687778355332467],
            [30.552934956521675, 0.687655291410746],
            [30.55495547151322, 0.688500526274292],
            [30.557252165454038, 0.690045901209468],
            [30.56031807599287, 0.691218416609213],
            [30.56261844134826, 0.691063164888042],
            [30.565199453873117, 0.690073901462632],
            [30.567334999933454, 0.687719419316153],
            [30.570187656712033, 0.688940675251019],
            [30.571205883611835, 0.688554554240685],
            [30.574488920548113, 0.685563489900143],
            [30.57763883793905, 0.674676460139752],
            [30.580797937908812, 0.670591895414947],
            [30.585655929947283, 0.671956741506415],
            [30.589074510981803, 0.672461303050496],
            [30.592837566283425, 0.675509029221111],
            [30.59389962917246, 0.676823305906608],
            [30.595845933440092, 0.681926542166347],
            [30.59921947114965, 0.685368892804032],
            [30.600920140085982, 0.68873715148019],
            [30.602846183750675, 0.689654256948205],
            [30.605631048268027, 0.689103867574235],
            [30.61245037967702, 0.691302452379192],
            [30.61431902638497, 0.692612348466894],
            [30.615459009141766, 0.694064111006211],
            [30.61570625066077, 0.694935782898074],
            [30.615307707695067, 0.698375017977107],
            [30.614538297959275, 0.701162159350951],
            [30.613690821930355, 0.702522578235291],
            [30.613567175119705, 0.703938502130777],
            [30.614014320535535, 0.71056041381126],
            [30.616025204688935, 0.714307616099465],
            [30.615265380875535, 0.716630878924749],
            [30.616518600765453, 0.723153272080708],
            [30.616052607796657, 0.727377796624962],
            [30.616278706567144, 0.729993010296457],
            [30.616948555121695, 0.731154872285772],
            [30.619010659415963, 0.730763089586495],
            [30.620032043894, 0.731019179334514],
            [30.621008594354528, 0.731822587718437],
            [30.621538513235578, 0.733484727657796],
            [30.620787034771176, 0.735082465769958],
            [30.621547199944374, 0.735292404530839],
            [30.62141666036056, 0.736232926860552],
            [30.622489478778512, 0.737321250043795],
            [30.62211471242175, 0.73832229360765],
            [30.622783542286765, 0.739270113501471],
            [30.62462560335384, 0.739985570093874],
            [30.625351140269494, 0.742859736224746],
            [30.626609853357397, 0.743138321691298],
            [30.627640152716335, 0.745249688452509],
            [30.62782706068591, 0.746967489029323],
            [30.62954803963249, 0.748066331539687],
            [30.629590471554955, 0.750127674840249],
            [30.63201815783049, 0.753234212023468],
            [30.63218490401185, 0.754595353551247],
            [30.631279863041193, 0.756973162394708],
            [30.632116994071307, 0.761527565930934],
            [30.631986251468216, 0.762832106124624],
            [30.63382858921644, 0.766891783601542],
            [30.634466205320265, 0.770405261779321],
            [30.633756972827037, 0.773421175944096],
            [30.632422783288973, 0.774321676431322],
            [30.63382701985964, 0.782484973111989],
            [30.63343920457508, 0.785580984667069],
            [30.63387496653962, 0.786477636328929],
            [30.634037193296784, 0.789971633546046],
            [30.63505891733799, 0.792616756285205],
            [30.634356061984953, 0.795028296533756],
            [30.635117765073943, 0.795187441117419],
            [30.63681731650606, 0.793963802745222],
            [30.637818502364922, 0.794334106631151],
            [30.639707883087944, 0.795715563671404],
            [30.640520949149916, 0.797616055183247],
            [30.64044024091152, 0.799204529304029],
            [30.641297370236487, 0.80335593352896],
            [30.64102511692503, 0.804780223065499],
            [30.64172582081295, 0.806077413971458],
            [30.64189098326446, 0.80990317122282],
            [30.640878549599908, 0.816192091541788],
            [30.63985529303282, 0.818954838519648],
            [30.64074873765144, 0.821560815849024],
            [30.640628003178943, 0.822663840648551],
            [30.641452599117592, 0.824528690636323],
            [30.64124691276532, 0.825431037438804],
            [30.64013993860363, 0.826507198944999],
            [30.640149334083173, 0.827549845715927],
            [30.64146081331255, 0.829398551478232],
            [30.640014778131704, 0.832397251823662],
            [30.640119610627043, 0.833486433832518],
            [30.641242537969887, 0.835502695226641],
            [30.644322502651313, 0.837181773921399],
            [30.64478627139146, 0.838552170839398],
            [30.647219565849344, 0.837014033242884],
            [30.648086546998037, 0.838309772940582],
            [30.64975677652096, 0.839100766186365],
            [30.649227222355936, 0.840977596031109],
            [30.64976845641629, 0.841719307089227],
            [30.64947559844714, 0.843499233229647],
            [30.648556125143152, 0.844289390979092],
            [30.647580066959392, 0.846715203323254],
            [30.647451152427898, 0.848233014933357],
            [30.647799363686556, 0.848644657810268],
            [30.646351367483444, 0.851430097899588],
            [30.645545646047243, 0.854304655115909],
            [30.65186664334057, 0.85575379429747],
            [30.65239526146108, 0.856412676327136],
            [30.652664774910953, 0.85996502582513],
            [30.65389845015526, 0.859764571378874],
            [30.655712082238566, 0.860649126282237],
            [30.658426843129437, 0.860020911807864],
            [30.659210628604747, 0.860227108523017],
            [30.65832242924904, 0.862341229830781],
            [30.657398442809036, 0.862633741143213],
            [30.65727101229441, 0.864317441924297],
            [30.656708503433162, 0.865175527232697],
            [30.657757180526183, 0.866860722410161],
            [30.65805440251096, 0.868208903162136],
            [30.657166305563187, 0.86985190708422],
            [30.658844200410442, 0.87149600341417],
            [30.659232817890583, 0.872440513868615],
            [30.660320131523925, 0.871814777717566],
            [30.661200418518632, 0.871949228269068],
            [30.661943845383146, 0.874039979670171],
            [30.662903711433888, 0.875097968504661],
            [30.663252486834526, 0.876895964552552],
            [30.66307710425004, 0.878532690682444],
            [30.662866911049964, 0.878937409573143],
            [30.661977808887407, 0.879146660065662],
            [30.66229346160687, 0.879902234750095],
            [30.663538192417384, 0.880934008592077],
            [30.664292529321045, 0.882918036111444],
            [30.66430443289685, 0.884245042115861],
            [30.665318412562012, 0.886037196298908],
            [30.664482684700367, 0.888224797095227],
            [30.665276396559538, 0.889632160186717],
            [30.66463391158687, 0.890558086636448],
            [30.66279557852821, 0.890894180326553],
            [30.658368658350167, 0.892686748950182],
            [30.656730249849563, 0.892795942086573],
            [30.65562129939426, 0.893658818169715],
            [30.652520440797613, 0.893626807903534],
            [30.651899141692596, 0.893229398422645],
            [30.652048424624848, 0.88867805225281],
            [30.650824569763213, 0.885999069170935],
            [30.64940870000963, 0.887077928956461],
            [30.648569158799603, 0.888838961583845],
            [30.6478617552763, 0.889437630102405],
            [30.64672034419818, 0.889329168905247],
            [30.645978561250654, 0.888743237845681],
            [30.643967280940203, 0.889661427363453],
            [30.645237445751338, 0.890882562022947],
            [30.6447485223866, 0.892000665715088],
            [30.645250429102155, 0.893423470221521],
            [30.643797781422506, 0.893297055798174],
            [30.64339731336716, 0.893679741878838],
            [30.643053455344397, 0.89242676942796],
            [30.64160002523214, 0.891965576382836],
            [30.640993785484532, 0.890596420304989],
            [30.639854078510538, 0.890677521189302],
            [30.638682555904115, 0.889858381696523],
            [30.63809861054527, 0.890977315642433],
            [30.637981754099844, 0.893845779747474],
            [30.636876200174598, 0.895087777437422],
            [30.634340677437393, 0.894505744609661],
            [30.631588673293162, 0.892302309467349],
            [30.630779663124688, 0.892167221026429],
            [30.62930738725609, 0.894905388688226],
            [30.62615154188258, 0.895359640929586],
            [30.62606690890474, 0.896521571187521],
            [30.623697053472213, 0.895866982447943],
            [30.624015653564154, 0.896954281573016],
            [30.62301488901512, 0.899285424248556],
            [30.620897770994546, 0.901650058566511],
            [30.617894648202505, 0.903240428197999],
            [30.616661424810804, 0.906118404523615],
            [30.613734530358833, 0.906961860108512],
            [30.61111282415156, 0.906036936616977],
            [30.60381307462695, 0.906705185193406],
            [30.60201350566941, 0.907384468065853],
            [30.60090853654744, 0.908677304779697],
            [30.60040922236981, 0.908634279990393],
            [30.60005617817493, 0.907677636004892],
            [30.598444550249564, 0.908118302238953],
            [30.595602244758002, 0.909091077819543],
            [30.594282899880007, 0.910334890961243],
            [30.591508687585304, 0.910951601723215],
            [30.590517914098893, 0.911742275161982],
            [30.586030368418967, 0.913381103697281],
            [30.5846212827424, 0.915218104201771],
            [30.583535052477252, 0.915962206802796],
            [30.580252327256403, 0.916832167768936],
            [30.576799361407716, 0.918592241078443],
            [30.573053287858258, 0.919454378984428],
            [30.572969800232375, 0.923412464063685],
            [30.57222540049241, 0.923857363369295],
            [30.571384754354586, 0.925499777344278],
            [30.569586049576355, 0.926273794076798],
            [30.568656603176088, 0.925950158988811],
            [30.567316659928615, 0.927549540247156],
            [30.567488021653887, 0.928116759154494],
            [30.566683271296487, 0.928455545735436],
            [30.565897425085932, 0.928249135489086],
            [30.56147875144225, 0.932280596088792],
            [30.560910390056915, 0.935152835588174],
            [30.561326674749456, 0.940502070639019],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1547,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "KYARUSOZI",
        Population: 57662,
        Key: "KYENJOJOKYARUSOZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.70452434019338, 0.884567638106409],
            [30.70340891198654, 0.883853875970333],
            [30.702969557659173, 0.882554303815124],
            [30.70063177208233, 0.88416271952719],
            [30.70062134354019, 0.883001556039795],
            [30.69965130406885, 0.883460382525346],
            [30.69807292997867, 0.884967305716725],
            [30.69616781706008, 0.884486407746108],
            [30.69511608210184, 0.883784692365725],
            [30.692592781842414, 0.884577121388898],
            [30.690596901350865, 0.884570988423099],
            [30.689318869992782, 0.885127300833263],
            [30.686176882030864, 0.884491391903693],
            [30.685025235548416, 0.883245490627282],
            [30.68347303926395, 0.883697580519456],
            [30.68150093627968, 0.883691237371451],
            [30.679951368465723, 0.883112402166005],
            [30.679226148655385, 0.884374809860564],
            [30.6774738194037, 0.885030091362854],
            [30.678239385248386, 0.885615818219032],
            [30.677537285378506, 0.886806923539664],
            [30.674680418196193, 0.886168490934242],
            [30.67289788219475, 0.88742833769685],
            [30.671944172298645, 0.887057553116562],
            [30.67212253459494, 0.885752572177168],
            [30.670944813613044, 0.884246229547234],
            [30.670329026570613, 0.884464927994001],
            [30.669958692501503, 0.885558314944021],
            [30.66868620195208, 0.886730724988025],
            [30.668198344887564, 0.887967330442672],
            [30.666564180028345, 0.888550462811522],
            [30.665276396559538, 0.889632160186717],
            [30.664482684700367, 0.888224797095227],
            [30.665318412562012, 0.886037196298908],
            [30.66430443289685, 0.884245042115861],
            [30.664292529321045, 0.882918036111444],
            [30.663538192417384, 0.880934008592077],
            [30.66229346160687, 0.879902234750095],
            [30.661977808887407, 0.879146660065662],
            [30.662866911049964, 0.878937409573143],
            [30.66307710425004, 0.878532690682444],
            [30.663252486834526, 0.876895964552552],
            [30.662903711433888, 0.875097968504661],
            [30.661943845383146, 0.874039979670171],
            [30.661200418518632, 0.871949228269068],
            [30.660320131523925, 0.871814777717566],
            [30.659232817890583, 0.872440513868615],
            [30.658844200410442, 0.87149600341417],
            [30.657166305563187, 0.86985190708422],
            [30.65805440251096, 0.868208903162136],
            [30.657757180526183, 0.866860722410161],
            [30.656708503433162, 0.865175527232697],
            [30.65727101229441, 0.864317441924297],
            [30.657398442809036, 0.862633741143213],
            [30.65832242924904, 0.862341229830781],
            [30.659210628604747, 0.860227108523017],
            [30.661244317389926, 0.858322330205634],
            [30.667449126584426, 0.856087405738766],
            [30.66831919973433, 0.855084387766626],
            [30.669684497032353, 0.854989407790621],
            [30.672599074683493, 0.851480033325108],
            [30.67331113686985, 0.848585351252633],
            [30.67564568761338, 0.848123513316464],
            [30.67673713888696, 0.845317455856514],
            [30.677870543280914, 0.84427355450178],
            [30.680784300770206, 0.838157821206928],
            [30.6805330159341, 0.835442298928462],
            [30.67876485118058, 0.831962205893826],
            [30.677753957228415, 0.830858479472348],
            [30.67460563075384, 0.829523718595779],
            [30.674729864164362, 0.828993915397297],
            [30.676012691627754, 0.828436402896544],
            [30.67972120481857, 0.829031766440941],
            [30.680242035443882, 0.82749681740783],
            [30.68183769940833, 0.82543911604804],
            [30.68384955104727, 0.822962947894347],
            [30.68563835279784, 0.821633162316576],
            [30.6883406648355, 0.822162068273044],
            [30.68952278307072, 0.823726684060329],
            [30.692269259881044, 0.825417702434012],
            [30.69027020743825, 0.823070106749835],
            [30.689801644389426, 0.820641349834262],
            [30.690224946720964, 0.820058129013834],
            [30.690461097639503, 0.81802401566391],
            [30.68991310645155, 0.817503307249892],
            [30.693332167186448, 0.808105101144544],
            [30.693913564923164, 0.808079945428885],
            [30.695309882844622, 0.804844531603451],
            [30.69641877670607, 0.803981547677027],
            [30.69910871984059, 0.803234896542882],
            [30.700033778869035, 0.803060809365834],
            [30.70215248331442, 0.803516011945975],
            [30.703640646787115, 0.802554862290189],
            [30.707399275191005, 0.801751327955139],
            [30.708529353123478, 0.800603754346162],
            [30.709867936321615, 0.800487065598576],
            [30.711847530357016, 0.802328075195911],
            [30.7114348793498, 0.803990674560007],
            [30.711687666169052, 0.805671062622442],
            [30.712191279683626, 0.806187993721951],
            [30.71428667464403, 0.806690803740973],
            [30.71482134381629, 0.808013209935486],
            [30.71609376339881, 0.806840682668395],
            [30.715805626974774, 0.801250223959957],
            [30.716612314998248, 0.80112456912415],
            [30.71853329396137, 0.802043656929476],
            [30.719454282723266, 0.801419304494469],
            [30.721330733096064, 0.801355263574378],
            [30.722581969505864, 0.80046730279459],
            [30.723990066137294, 0.800469786393966],
            [30.724751594953112, 0.797355293229035],
            [30.72639234895494, 0.794876006328211],
            [30.729857009071978, 0.787842061944274],
            [30.734511981856222, 0.783688859161386],
            [30.735422219580787, 0.781879589281378],
            [30.73700220524859, 0.780562095239066],
            [30.739068936764877, 0.780520014869686],
            [30.745157492283504, 0.782492244296052],
            [30.74728335450507, 0.783729438554574],
            [30.748155520729576, 0.782963289449014],
            [30.74797375471668, 0.781258524931433],
            [30.748442465987523, 0.780543357222864],
            [30.75032340434349, 0.780994880423854],
            [30.75876994944802, 0.779427130546317],
            [30.76045360878445, 0.779417172744501],
            [30.76246138925854, 0.778766386422303],
            [30.764014118243978, 0.779088055076005],
            [30.76529934780244, 0.779745705638189],
            [30.76705867223525, 0.779529361042525],
            [30.768537854351766, 0.778432844908529],
            [30.769725099272293, 0.778346564298397],
            [30.77285564359579, 0.777109686430969],
            [30.779925250134546, 0.77646157648663],
            [30.780097455377867, 0.777374287799407],
            [30.779016323051952, 0.780006804634443],
            [30.77873109267789, 0.780174090468371],
            [30.777828446615796, 0.779599536326387],
            [30.776188431927444, 0.780459768657106],
            [30.77547349243722, 0.784406128194513],
            [30.77316744613599, 0.786581572393179],
            [30.77257207600332, 0.789068889043078],
            [30.770289079573953, 0.792559909147055],
            [30.770551393925118, 0.794131217364291],
            [30.771596227127024, 0.794732138809164],
            [30.772425823986882, 0.79593373262728],
            [30.773688045894282, 0.799642260883852],
            [30.77570321321494, 0.799164672237525],
            [30.77948128744977, 0.799286336306919],
            [30.783401244295494, 0.799884708727529],
            [30.785242140247675, 0.800698428431051],
            [30.786502354420428, 0.801426282823178],
            [30.784490056318763, 0.803264485936945],
            [30.783411791415247, 0.80657178516832],
            [30.783355822779786, 0.80925735599134],
            [30.785629195557522, 0.80898310342936],
            [30.78730428586444, 0.809235185086779],
            [30.792400114959232, 0.81135490373743],
            [30.79357673370826, 0.810637953779404],
            [30.79535903614773, 0.810387775548872],
            [30.796849985296124, 0.811906880161688],
            [30.7988656413003, 0.812410982017552],
            [30.801810828146408, 0.814580674418212],
            [30.805237522764614, 0.818485100824701],
            [30.808287390290783, 0.81829599510544],
            [30.809837288684772, 0.819823181643373],
            [30.81333217082289, 0.825097905723802],
            [30.813348459075627, 0.826815041108513],
            [30.814139456226, 0.829729394164777],
            [30.81677292946518, 0.834778186597649],
            [30.816673246113037, 0.837968671515362],
            [30.81391473008128, 0.838461290828533],
            [30.81010827357506, 0.838477649194698],
            [30.80611900451862, 0.836587530789575],
            [30.80496061887491, 0.836420300274367],
            [30.800914401121016, 0.837750616220727],
            [30.798708094765782, 0.837194113659364],
            [30.796464599954408, 0.837377924372526],
            [30.794094049225862, 0.834600331859497],
            [30.790196285259228, 0.833580166705939],
            [30.78824696714384, 0.833856684687543],
            [30.787518407397258, 0.834252991075376],
            [30.7865188385059, 0.835860138177238],
            [30.783832587447176, 0.838420173052659],
            [30.783369074726867, 0.842065211858373],
            [30.780402585232093, 0.845610281044073],
            [30.779241829832678, 0.845848877232907],
            [30.776934781011583, 0.845495680172483],
            [30.77494995339133, 0.844087086286784],
            [30.773188099302658, 0.844015695935117],
            [30.767620210916, 0.848459975460419],
            [30.762361398682586, 0.850399163047659],
            [30.760877173424067, 0.853860575585793],
            [30.76107138290029, 0.856534809304613],
            [30.761699470573905, 0.858519658941293],
            [30.760761853996108, 0.859785793484503],
            [30.759724781339926, 0.860098731279247],
            [30.75694476143692, 0.859234633078464],
            [30.753014667103184, 0.860639723778711],
            [30.75086219049472, 0.860712091078941],
            [30.74908680687956, 0.859750635586335],
            [30.748028666035054, 0.858555271347289],
            [30.74584696453542, 0.857694677631047],
            [30.743785946304342, 0.858376477269217],
            [30.741422222771973, 0.861063570255666],
            [30.740417679908884, 0.861602747328314],
            [30.73874370081795, 0.861774510038636],
            [30.737787311247338, 0.863750018227446],
            [30.737633375041952, 0.865125953067564],
            [30.736114967090252, 0.865376351457592],
            [30.736458246597977, 0.866558296055136],
            [30.73574097777621, 0.867382263158681],
            [30.736628999265488, 0.868369811578288],
            [30.73668697114405, 0.869530576303961],
            [30.734805480324162, 0.871680133147612],
            [30.73297074591651, 0.871103832633015],
            [30.7310075272704, 0.872092834282843],
            [30.729764205916595, 0.871226916344236],
            [30.728527058683714, 0.871048231546602],
            [30.728197216175996, 0.871359239053898],
            [30.727920634781494, 0.872309647197256],
            [30.72891588187802, 0.873331801495836],
            [30.729052163493144, 0.875273952190891],
            [30.727592990451278, 0.876827275732619],
            [30.72727294676671, 0.878228370043132],
            [30.72599254475458, 0.878524045414197],
            [30.724721205845373, 0.877184386983133],
            [30.721845907928348, 0.879792963089366],
            [30.719696305030464, 0.879871154909846],
            [30.714986514352642, 0.881927087310578],
            [30.71381788162648, 0.881439700284896],
            [30.712825142626215, 0.882017223467511],
            [30.70796067283624, 0.882723640405836],
            [30.706339032288692, 0.884704942704806],
            [30.70452434019338, 0.884567638106409],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1550,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "NYANKWANZI",
        Population: 27320,
        Key: "KYENJOJONYANKWANZI",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.37562061525796, 0.603151868489767],
            [33.37578898289838, 0.605246511870827],
            [33.37748439489366, 0.608440035814947],
            [33.37738518315707, 0.611407507008358],
            [33.37955463253453, 0.613976743039202],
            [33.37903458524015, 0.615216237223537],
            [33.378369546265624, 0.615315803443631],
            [33.377919681649445, 0.616057701658606],
            [33.37723048697694, 0.616112034015751],
            [33.37578364331234, 0.617261125602396],
            [33.37575058980147, 0.6184282091478],
            [33.37444526762506, 0.619287782052966],
            [33.37390163236793, 0.620491092083534],
            [33.37292824487552, 0.620916378090848],
            [33.371905379973896, 0.620663130030057],
            [33.370955582240825, 0.621070319627085],
            [33.369767591718634, 0.620998026561601],
            [33.369445142345704, 0.620473314568245],
            [33.36668490604017, 0.619532604474769],
            [33.36618728249191, 0.620084515955339],
            [33.36402592334191, 0.620736061764774],
            [33.36262683411781, 0.62212037492157],
            [33.360892329238006, 0.622292391256741],
            [33.35857651196141, 0.623115842615877],
            [33.35510692907662, 0.623333212173367],
            [33.35427679682089, 0.624147514571481],
            [33.353325434222604, 0.623915293183329],
            [33.35223278459643, 0.624183842082563],
            [33.35123787346982, 0.625592755925827],
            [33.34805290561311, 0.628228211185871],
            [33.34768227599825, 0.629594359529053],
            [33.34275174140734, 0.630318463880003],
            [33.33862114489881, 0.632336259342819],
            [33.336272557979, 0.634303949065657],
            [33.33322982127955, 0.638868682797594],
            [33.33073750391425, 0.640408544472797],
            [33.323114071629824, 0.647880238131778],
            [33.321772302107384, 0.648287555834155],
            [33.31873863749399, 0.651952016888805],
            [33.3156533520911, 0.653895074238355],
            [33.31452856703229, 0.655617422937134],
            [33.313501481845435, 0.658378040085347],
            [33.313160897283566, 0.657932424257296],
            [33.30752182998703, 0.65575240124095],
            [33.30583102634915, 0.654467800933921],
            [33.30044883590135, 0.645764706603609],
            [33.298672607869854, 0.643602526727346],
            [33.29795081962389, 0.643575428061515],
            [33.2969953121989, 0.642670762087835],
            [33.28918895776982, 0.625734805238534],
            [33.28073373044804, 0.616081870332445],
            [33.27585608955936, 0.608274360781668],
            [33.27330978164887, 0.605786500354069],
            [33.269395058387964, 0.600325478024372],
            [33.26995895065474, 0.596191859454566],
            [33.269152270716106, 0.592433159279393],
            [33.26951061047957, 0.590298176998736],
            [33.270304499306874, 0.589196014210929],
            [33.27196539802894, 0.589601053022205],
            [33.27289539958808, 0.586126866787514],
            [33.27503986412253, 0.584199698332759],
            [33.30487450382787, 0.566085614446492],
            [33.3256424338959, 0.554115029472059],
            [33.33198191312787, 0.537992575348081],
            [33.33352910579623, 0.533179384181624],
            [33.32532822297245, 0.518089099540053],
            [33.325359306477885, 0.517440483998925],
            [33.330850376331384, 0.515099006181733],
            [33.33768693203765, 0.517137076903064],
            [33.33983723831639, 0.519644637550746],
            [33.34101021529525, 0.522520580094026],
            [33.341255977289, 0.525663992428233],
            [33.340649567759804, 0.526587375794727],
            [33.340816722674646, 0.52785018922854],
            [33.340158019517816, 0.530727231080228],
            [33.340188891020865, 0.533317677423225],
            [33.34662611234565, 0.535268551036298],
            [33.35065693028064, 0.537783434308517],
            [33.35527468316772, 0.539791636231677],
            [33.35687109183552, 0.541338607333988],
            [33.358942037348825, 0.54165518824724],
            [33.361511013347204, 0.541693539206019],
            [33.36275354957348, 0.540587015945147],
            [33.36362197341652, 0.540384691107916],
            [33.366289228700246, 0.540950996187759],
            [33.36694556299967, 0.541877329889304],
            [33.366673127330166, 0.543721109336036],
            [33.367124082501114, 0.544900602467734],
            [33.36830432954559, 0.545868243615706],
            [33.36869030508046, 0.5468672622299],
            [33.36990613708825, 0.547783799342191],
            [33.37023098675962, 0.548568261276631],
            [33.36718345215826, 0.547853014964201],
            [33.3640035121722, 0.548665656646324],
            [33.36194374709093, 0.54870216070898],
            [33.36026952365825, 0.550218018705792],
            [33.360040793722305, 0.552437097875275],
            [33.35720152992628, 0.554134123168739],
            [33.35391194606823, 0.557547508515143],
            [33.35334135775932, 0.559034475805288],
            [33.35515425861399, 0.561670289757403],
            [33.35579222416246, 0.564103411996151],
            [33.3603915714677, 0.569746705381293],
            [33.360794500906934, 0.571301198844106],
            [33.364621639325925, 0.574984486306368],
            [33.36771034012352, 0.579951983989841],
            [33.37083241782548, 0.581878027469288],
            [33.37133608344235, 0.583770448993639],
            [33.37073184963279, 0.58400704666519],
            [33.367831410565934, 0.583345161885146],
            [33.365548733038494, 0.583977257382867],
            [33.363323040141104, 0.583345458313824],
            [33.35579065031408, 0.583804696384385],
            [33.353178487808435, 0.583181787461807],
            [33.35259117915712, 0.585674126081902],
            [33.35263118652662, 0.587622722213668],
            [33.35432257676437, 0.593108676880457],
            [33.35403946821102, 0.595210254229763],
            [33.356746175705375, 0.597776300994944],
            [33.3573651939879, 0.599001289195465],
            [33.35689334669839, 0.602444074745526],
            [33.35755659263561, 0.606208670550291],
            [33.35701455009146, 0.607817295856577],
            [33.357827841630574, 0.608865697358278],
            [33.35891213692461, 0.608822536644123],
            [33.362607188860856, 0.607041349569526],
            [33.365446316112944, 0.606782634011409],
            [33.36643036660779, 0.601181232597296],
            [33.368413273629976, 0.598035734695473],
            [33.368969548183124, 0.595953151374425],
            [33.36943213114711, 0.595692910033882],
            [33.371393315109096, 0.595625471760164],
            [33.372028512948205, 0.596231178382324],
            [33.37298690486358, 0.597476264740834],
            [33.37562061525796, 0.603151868489767],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1808,
        District: "JINJA",
        County: "BUTEMBE",
        Subcounty: "BUSEDDE",
        Population: 36717,
        Key: "JINJABUSEDDE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.425904727771496, 0.688603407385842],
            [33.426051594235624, 0.688222677647582],
            [33.424426376596635, 0.68683273722879],
            [33.41908593984326, 0.687564871709381],
            [33.417316419531986, 0.688869291295627],
            [33.41409326249593, 0.690110215020515],
            [33.41181823232648, 0.692623507422285],
            [33.40990650241754, 0.693084591519677],
            [33.40973281405568, 0.695232215008503],
            [33.40728228362246, 0.700132395132454],
            [33.40645763558151, 0.703793289643424],
            [33.405598491335354, 0.705767118972321],
            [33.40338396629358, 0.709580803463504],
            [33.40175788267865, 0.711083853283567],
            [33.4011702048198, 0.709070887820225],
            [33.398413618369275, 0.706614072524205],
            [33.39928489346503, 0.703884960292556],
            [33.395133963590034, 0.703408991495457],
            [33.39491079512402, 0.697349121904568],
            [33.39281693718108, 0.696947238210996],
            [33.38266691859992, 0.697063666527637],
            [33.37969655197637, 0.698431800759066],
            [33.379269624942644, 0.699130095531181],
            [33.37919832565855, 0.692450794671575],
            [33.37956963080653, 0.691974093542031],
            [33.38140241497168, 0.691210471588711],
            [33.38671129031587, 0.690541998445759],
            [33.39124497796034, 0.685589976626692],
            [33.39129289679254, 0.684402024295633],
            [33.38968094996527, 0.680552980445037],
            [33.3898081936303, 0.679209909502432],
            [33.39333949616501, 0.679752792421049],
            [33.3951160350136, 0.679333669785971],
            [33.396828523982435, 0.679734411489],
            [33.39780353113733, 0.680042255936739],
            [33.40060995432316, 0.682840371219595],
            [33.40225189859274, 0.683289066680716],
            [33.40336855928813, 0.683070854461908],
            [33.4055360341686, 0.664803144169486],
            [33.4011124314689, 0.666362832263744],
            [33.39593425740531, 0.666480394917089],
            [33.39561441224839, 0.668413229846509],
            [33.3926341560719, 0.670233096022771],
            [33.38901121729337, 0.671580695745715],
            [33.38736947424645, 0.670952933229035],
            [33.38712920814561, 0.66993896818913],
            [33.3892437228485, 0.668610292432391],
            [33.390683265904755, 0.665499771269924],
            [33.393359362407516, 0.662102498113154],
            [33.39335929772883, 0.661282519402327],
            [33.395620626793544, 0.658311221517448],
            [33.39752343733004, 0.653720743253654],
            [33.39751952965857, 0.651778863451901],
            [33.395860244310754, 0.651387618547708],
            [33.39350869564541, 0.652063151056231],
            [33.39163042798078, 0.651901637239174],
            [33.390585635203074, 0.652334518114945],
            [33.38704316032117, 0.652058608570026],
            [33.38565392920901, 0.652588011640953],
            [33.384113446057505, 0.654407104831395],
            [33.38290309826449, 0.655174715417691],
            [33.37857440167628, 0.654184910254839],
            [33.37708984583773, 0.654619100592103],
            [33.37466047881429, 0.652716364482654],
            [33.372547634977835, 0.653797053762461],
            [33.37071775776095, 0.65396963673683],
            [33.36960260533693, 0.654784716659816],
            [33.36666805993367, 0.655223227559145],
            [33.364836134557905, 0.654584081158122],
            [33.36224470067742, 0.654400819729342],
            [33.357872906515134, 0.6551778638069],
            [33.355026068124616, 0.652789090961361],
            [33.34792871083016, 0.652894545431527],
            [33.346874849559626, 0.658218923018849],
            [33.34513273684767, 0.662450927740745],
            [33.3435983379856, 0.664460046748504],
            [33.343838746020246, 0.665533708230166],
            [33.342818309264814, 0.666205248774134],
            [33.33989269850539, 0.670201086747698],
            [33.338351468853894, 0.671733688987073],
            [33.33604886938839, 0.672982049270745],
            [33.33490831440478, 0.673152573677597],
            [33.33190892051945, 0.67616976331401],
            [33.328156675544, 0.677565700851614],
            [33.32497936402848, 0.680726665534071],
            [33.32284206535504, 0.681544786094092],
            [33.32186044929464, 0.683481588002294],
            [33.321224826552395, 0.685942608388177],
            [33.321820054751264, 0.686322831694737],
            [33.322204225570694, 0.68784968810391],
            [33.32275244043916, 0.688444929962044],
            [33.32229624359851, 0.69135903852942],
            [33.323893548784994, 0.693216518329062],
            [33.32437189897886, 0.694384968366723],
            [33.32390160936804, 0.695475069236152],
            [33.322646919834305, 0.693745486672016],
            [33.32040984977384, 0.692701661428766],
            [33.31852771486191, 0.691012141596223],
            [33.316244672618446, 0.690589194299231],
            [33.31440035588169, 0.689759065679783],
            [33.31377758533622, 0.687874796901454],
            [33.31161117046779, 0.6865681215357],
            [33.31070483682145, 0.685353200358749],
            [33.30906673015477, 0.681442568639002],
            [33.309131689129615, 0.67891162959133],
            [33.30970067933561, 0.67831306122175],
            [33.31136336929836, 0.673079480112377],
            [33.31154911484796, 0.666584923894979],
            [33.31233192295623, 0.665937963241912],
            [33.31190087804525, 0.664673871826117],
            [33.31201296533482, 0.661975662665964],
            [33.31309068136771, 0.660444448789907],
            [33.313501481845435, 0.658378040085347],
            [33.31452856703229, 0.655617422937134],
            [33.3156533520911, 0.653895074238355],
            [33.31873863749399, 0.651952016888805],
            [33.321772302107384, 0.648287555834155],
            [33.323114071629824, 0.647880238131778],
            [33.33073750391425, 0.640408544472797],
            [33.33322982127955, 0.638868682797594],
            [33.336272557979, 0.634303949065657],
            [33.33862114489881, 0.632336259342819],
            [33.34275174140734, 0.630318463880003],
            [33.34768227599825, 0.629594359529053],
            [33.34805290561311, 0.628228211185871],
            [33.35123787346982, 0.625592755925827],
            [33.35223278459643, 0.624183842082563],
            [33.353325434222604, 0.623915293183329],
            [33.35427679682089, 0.624147514571481],
            [33.35510692907662, 0.623333212173367],
            [33.35857651196141, 0.623115842615877],
            [33.360892329238006, 0.622292391256741],
            [33.36262683411781, 0.62212037492157],
            [33.36402592334191, 0.620736061764774],
            [33.36618728249191, 0.620084515955339],
            [33.36668490604017, 0.619532604474769],
            [33.369445142345704, 0.620473314568245],
            [33.369767591718634, 0.620998026561601],
            [33.370955582240825, 0.621070319627085],
            [33.371905379973896, 0.620663130030057],
            [33.37292824487552, 0.620916378090848],
            [33.37390163236793, 0.620491092083534],
            [33.37444526762506, 0.619287782052966],
            [33.37575058980147, 0.6184282091478],
            [33.37578364331234, 0.617261125602396],
            [33.37723048697694, 0.616112034015751],
            [33.377919681649445, 0.616057701658606],
            [33.378369546265624, 0.615315803443631],
            [33.37903458524015, 0.615216237223537],
            [33.37955463253453, 0.613976743039202],
            [33.37738518315707, 0.611407507008358],
            [33.37748439489366, 0.608440035814947],
            [33.37578898289838, 0.605246511870827],
            [33.37562061525796, 0.603151868489767],
            [33.38211340456961, 0.601704660158527],
            [33.38465395068588, 0.600526633906667],
            [33.38708312457154, 0.60021236837157],
            [33.38891053860792, 0.599438224717813],
            [33.39133845125892, 0.599464046275642],
            [33.39432596851785, 0.597867373529019],
            [33.396353971865636, 0.597340000414627],
            [33.39932389472138, 0.597223535674941],
            [33.40019168884542, 0.596349668734287],
            [33.402005478133916, 0.595902715496033],
            [33.4016938336972, 0.59460524275402],
            [33.401992483105, 0.593251872340378],
            [33.40116022363865, 0.592779335303079],
            [33.400080273495675, 0.590081310042227],
            [33.398014531922826, 0.588405885233908],
            [33.398765580094214, 0.587185668983407],
            [33.3983394247133, 0.586692010451011],
            [33.39888072524901, 0.585986980364733],
            [33.39821918970413, 0.585630430715979],
            [33.39714781757377, 0.583478038284787],
            [33.39739956863551, 0.582769122782242],
            [33.39641788340483, 0.581493177594557],
            [33.39649872189893, 0.577922907436088],
            [33.39573467600371, 0.576363388156393],
            [33.39648146975391, 0.575336508447313],
            [33.39606735898434, 0.573390292091263],
            [33.39664770659048, 0.572324757473337],
            [33.39666467576619, 0.570846812221998],
            [33.39603156561183, 0.570240583667563],
            [33.39567321417026, 0.568707873889348],
            [33.39899815931116, 0.568223027587815],
            [33.400240782674025, 0.56756927482116],
            [33.401789093744874, 0.567550986917571],
            [33.40251007620204, 0.566452252007441],
            [33.403170437648846, 0.566264410882454],
            [33.4055961485291, 0.56169331606491],
            [33.40809982598946, 0.559423893100914],
            [33.409657424742065, 0.561314821909791],
            [33.416505501341845, 0.561086929356137],
            [33.421484288938245, 0.563133520064563],
            [33.42229074250142, 0.563601285254532],
            [33.42283753354015, 0.564523135742354],
            [33.4238189879038, 0.564858929449134],
            [33.422709408627796, 0.5678666268372],
            [33.42315138513746, 0.570240724696089],
            [33.42226168020535, 0.571925859797974],
            [33.422659995897284, 0.572890516930801],
            [33.42326982531274, 0.573122247328917],
            [33.423033521680615, 0.573651071631194],
            [33.42343167387915, 0.573955373249429],
            [33.422993742483214, 0.574814897409666],
            [33.42333027654148, 0.575310811637507],
            [33.42320160814838, 0.576235558069794],
            [33.42277548420853, 0.576954140671167],
            [33.423095976152425, 0.578283958800643],
            [33.42199234462194, 0.57952217829884],
            [33.42189526458748, 0.581616603349721],
            [33.41960552540359, 0.586124466614663],
            [33.41995569948114, 0.58699883011161],
            [33.41786486077588, 0.588952395897407],
            [33.41797088892886, 0.59008626219175],
            [33.417301854247945, 0.591152829158182],
            [33.41739116026193, 0.592370894985405],
            [33.41620920911336, 0.594408590565399],
            [33.415863629918526, 0.596148721994938],
            [33.41622054315731, 0.596827896882749],
            [33.41532273092976, 0.598281834518638],
            [33.41599222554805, 0.600757181940316],
            [33.415958863016726, 0.601975258217258],
            [33.41535922229322, 0.602652561295252],
            [33.41614858001823, 0.603732188400274],
            [33.414442593953744, 0.607184462922622],
            [33.41455417728844, 0.608009601757649],
            [33.41401895565226, 0.608958280587669],
            [33.41465469607378, 0.609979840829709],
            [33.41437053199995, 0.612719124296448],
            [33.41278725490494, 0.616665357921599],
            [33.41374644811756, 0.618231377273714],
            [33.41363953063245, 0.619271799262736],
            [33.41578246533598, 0.625112501164217],
            [33.41535703848878, 0.627488895386185],
            [33.41596834742951, 0.629982732560516],
            [33.4149106314881, 0.631416135022089],
            [33.41486056119081, 0.632208500637672],
            [33.41526669042907, 0.632748484579059],
            [33.414840581760565, 0.633137129547854],
            [33.41599377065037, 0.634439132738078],
            [33.41618936712538, 0.635357650433159],
            [33.415775179999024, 0.635926721500012],
            [33.41612430125104, 0.636705175075487],
            [33.41573171052241, 0.637143655197545],
            [33.41583868729636, 0.638567499991332],
            [33.415081694972706, 0.63898645359149],
            [33.41525732189897, 0.640934538068654],
            [33.414865215362276, 0.641902565736975],
            [33.415182255978884, 0.642610110756776],
            [33.4141915148318, 0.643721025900062],
            [33.41478131720633, 0.644275617010653],
            [33.41573384671617, 0.644023194690969],
            [33.416260208268675, 0.643432666021357],
            [33.41700725175054, 0.643967573623865],
            [33.41701733174634, 0.644623667911242],
            [33.416461668047575, 0.645234292278026],
            [33.41661143876498, 0.647000786127755],
            [33.41584456048168, 0.649145776397499],
            [33.416556549904506, 0.650145000780664],
            [33.416444874043336, 0.650640392435889],
            [33.41732871387496, 0.651305720842275],
            [33.417108664359596, 0.653918990325122],
            [33.41893834035387, 0.65511093650721],
            [33.41919910421287, 0.655897446300864],
            [33.421530815381786, 0.661404181814214],
            [33.421510835053205, 0.662267200406652],
            [33.42295505833214, 0.666420660991835],
            [33.423276153045585, 0.669140902789865],
            [33.42451960465514, 0.670513545230347],
            [33.42417403264682, 0.674606597613488],
            [33.42513173285943, 0.676115530406921],
            [33.42540256862936, 0.677367133156313],
            [33.42489632215269, 0.678654133009769],
            [33.42500177897715, 0.680632500889986],
            [33.426415735319175, 0.682479532803868],
            [33.425693947971546, 0.684175349702461],
            [33.425052230160134, 0.684220829060739],
            [33.4249018593681, 0.684599358402275],
            [33.42564396031926, 0.685835777609989],
            [33.42491712982963, 0.687198500425266],
            [33.426075319640596, 0.688101787503524],
            [33.425904727771496, 0.688603407385842],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1811,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "WAIBUGA",
        Population: 36626,
        Key: "LUUKAWAIBUGA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.306771782538874, 0.984572937123235],
            [33.306892544859146, 0.984238417958406],
            [33.30181728089617, 0.985740721672207],
            [33.30062973773497, 0.985686546905743],
            [33.29572218474397, 0.987424678406849],
            [33.290949679082885, 0.987503174113634],
            [33.29023921050781, 0.987135313830702],
            [33.28875656358926, 0.987171718043655],
            [33.28670922759828, 0.98807625091921],
            [33.282070902392874, 0.988646626794013],
            [33.27524169490563, 0.988303459447614],
            [33.27148581534652, 0.985779524945445],
            [33.267670981151966, 0.985553606932717],
            [33.2658754537149, 0.987124945218075],
            [33.26323122315021, 0.990732651004122],
            [33.26040281459608, 0.992982039443268],
            [33.256617123545965, 0.992448550792678],
            [33.25400388306197, 0.992873974869086],
            [33.252014875580684, 0.994964040918558],
            [33.25030272527672, 0.995923180983951],
            [33.24180449380566, 0.995589072534259],
            [33.24094998666299, 0.994494418573558],
            [33.23900124436771, 0.994223143961006],
            [33.23814781340676, 0.99244994476886],
            [33.23691300179363, 0.991355316713555],
            [33.234700289552094, 0.990515737593295],
            [33.23335239711267, 0.988315694477996],
            [33.23306592796181, 0.988668557692979],
            [33.22574615948109, 0.986787238661487],
            [33.21937796649936, 0.992858382457165],
            [33.217859779533214, 0.994968014466181],
            [33.20751415549386, 1.004294904583951],
            [33.20396230399702, 1.006466475594307],
            [33.20207751725839, 1.009533620010003],
            [33.20049829426025, 1.007534270982429],
            [33.196415682160946, 0.997446808459651],
            [33.19684165518385, 0.9954473352883],
            [33.196773554800494, 0.993294087052512],
            [33.19534220258297, 0.988499115739344],
            [33.19541039369617, 0.98262742891412],
            [33.19379853490378, 0.979352408931516],
            [33.193696387472826, 0.976077299523065],
            [33.192622036528995, 0.971137547321556],
            [33.192890388457194, 0.963248303943618],
            [33.193272320674964, 0.96222594001651],
            [33.19168543325086, 0.958209037009135],
            [33.19115107220073, 0.955730112583022],
            [33.1903249149901, 0.95381213531812],
            [33.20000614953692, 0.950038866880652],
            [33.20088746869585, 0.948944094858821],
            [33.20643279409755, 0.944827255959158],
            [33.2122851789347, 0.942004151119234],
            [33.213047131755324, 0.941099377856149],
            [33.2135626290828, 0.938068510340507],
            [33.212568985479066, 0.934793459412389],
            [33.21113442088608, 0.932305547983841],
            [33.21023491263926, 0.929681892977155],
            [33.20914282805342, 0.928768183965298],
            [33.20766881035149, 0.928741130263606],
            [33.205294749006825, 0.926470404201649],
            [33.20058069402634, 0.923240798542772],
            [33.198757904517024, 0.921582152168352],
            [33.198014104851644, 0.919112015812264],
            [33.205611657571055, 0.91327041118334],
            [33.21227314510319, 0.90977777400323],
            [33.21346314336005, 0.908945354388105],
            [33.21410627601802, 0.907922973739035],
            [33.214143383625796, 0.898920937279673],
            [33.21329230894583, 0.894789433023532],
            [33.209069756393255, 0.89112177332045],
            [33.208342730969214, 0.889788967364962],
            [33.20824799913091, 0.887174111721869],
            [33.214664502610304, 0.883821588970953],
            [33.21777757020997, 0.884897453866038],
            [33.22281507438832, 0.885504524859984],
            [33.22545541704444, 0.885394590486325],
            [33.225908141896504, 0.884815537281912],
            [33.22633432332854, 0.882248336189124],
            [33.22452591854188, 0.878971088839692],
            [33.22297473196375, 0.875026575139872],
            [33.222409406884104, 0.871299134339236],
            [33.22149813340202, 0.868910710383449],
            [33.22145363715102, 0.866856983151616],
            [33.2226519690788, 0.859863374933922],
            [33.23080825593865, 0.85865055213669],
            [33.23724326830614, 0.855537898414195],
            [33.24278248785886, 0.855284225384083],
            [33.24637691321194, 0.853818338796595],
            [33.2491912011481, 0.85406243155715],
            [33.25084780592311, 0.854985142166309],
            [33.25176962562665, 0.854840534894467],
            [33.2529240766494, 0.853416150191394],
            [33.257453178394385, 0.850213017587163],
            [33.26180175380153, 0.848081552217014],
            [33.26498692377916, 0.84700614843689],
            [33.26484020284213, 0.859344508036048],
            [33.26525766073445, 0.86380538588562],
            [33.27110305667869, 0.868102241365802],
            [33.273003394153235, 0.868074960865451],
            [33.276352954929536, 0.867432361850278],
            [33.2787755279945, 0.865043714491517],
            [33.2806521840815, 0.863849340846321],
            [33.2822199337968, 0.863279248487802],
            [33.28325001127185, 0.863414118808241],
            [33.28398962927957, 0.868921334434818],
            [33.28898966652402, 0.877099995660806],
            [33.2918162919223, 0.882695542641974],
            [33.297156012718396, 0.905732198791699],
            [33.296016433305155, 0.912565627686774],
            [33.297619712288274, 0.923658545327607],
            [33.30366471658362, 0.933149156361394],
            [33.30226065518441, 0.934957456475372],
            [33.30176052353989, 0.937064203462691],
            [33.30140141212358, 0.947545398432329],
            [33.301816074458735, 0.953541701730235],
            [33.30286137119134, 0.95834569207262],
            [33.30272670025551, 0.960019437494527],
            [33.302242590962386, 0.96092564559497],
            [33.30242949444041, 0.965442765067338],
            [33.307002159086736, 0.983111352910265],
            [33.306771782538874, 0.984572937123235],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1820,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "NAMWENDWA",
        Population: 57606,
        Key: "KAMULINAMWENDWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.28325001127185, 0.863414118808241],
            [33.2822199337968, 0.863279248487802],
            [33.2806521840815, 0.863849340846321],
            [33.2787755279945, 0.865043714491517],
            [33.276352954929536, 0.867432361850278],
            [33.273003394153235, 0.868074960865451],
            [33.27110305667869, 0.868102241365802],
            [33.26525766073445, 0.86380538588562],
            [33.26484020284213, 0.859344508036048],
            [33.26498692377916, 0.84700614843689],
            [33.26180175380153, 0.848081552217014],
            [33.257453178394385, 0.850213017587163],
            [33.2529240766494, 0.853416150191394],
            [33.25176962562665, 0.854840534894467],
            [33.25084780592311, 0.854985142166309],
            [33.2491912011481, 0.85406243155715],
            [33.24637691321194, 0.853818338796595],
            [33.24278248785886, 0.855284225384083],
            [33.23724326830614, 0.855537898414195],
            [33.23080825593865, 0.85865055213669],
            [33.2226519690788, 0.859863374933922],
            [33.21900829808183, 0.859872814266162],
            [33.21766404561594, 0.857492258670233],
            [33.21616676334478, 0.856824396474274],
            [33.2134783976519, 0.854426788160478],
            [33.21015070905613, 0.853000610465494],
            [33.21114584835483, 0.848551942080037],
            [33.210961896740834, 0.846176819084875],
            [33.213562674896885, 0.841470793417744],
            [33.21414070484962, 0.836476666246375],
            [33.214510276249094, 0.835617155371001],
            [33.21596255651776, 0.83431426764748],
            [33.216085964376546, 0.831156762432264],
            [33.2172520216328, 0.829482952829234],
            [33.21787187265357, 0.829157216509741],
            [33.221936831060916, 0.829337934124161],
            [33.23053610773005, 0.825492350076462],
            [33.24044197499679, 0.822216650577623],
            [33.24260897916005, 0.819936610181662],
            [33.24345971337851, 0.815286268324072],
            [33.24324098258998, 0.802203950074161],
            [33.24823848209376, 0.790225084374946],
            [33.250063604527874, 0.782290533830265],
            [33.25267565384581, 0.783077486097702],
            [33.25410225756871, 0.789564276385259],
            [33.255358370932186, 0.791256034739323],
            [33.25714017570499, 0.791635907706723],
            [33.25887413710406, 0.790441562253491],
            [33.262746037675356, 0.789708489902271],
            [33.26617818955889, 0.790260151268005],
            [33.268672342182334, 0.791960869177446],
            [33.27115071589776, 0.792874477134411],
            [33.27550102415511, 0.797958732835859],
            [33.27872566700463, 0.805168658475931],
            [33.27883242009807, 0.810475648941854],
            [33.281314463431436, 0.81817465047527],
            [33.28157570339754, 0.820087222465575],
            [33.281195207585895, 0.830410751391588],
            [33.281563269815685, 0.832274453404657],
            [33.283297467471684, 0.836009069287239],
            [33.28623470063425, 0.839167433792787],
            [33.290269149559606, 0.843239045532382],
            [33.29545919935127, 0.846540885410067],
            [33.29914088794936, 0.8481690987205],
            [33.30494250270163, 0.849335730444433],
            [33.29873039559377, 0.857125870596291],
            [33.29699703876089, 0.858157182689982],
            [33.28363489086207, 0.862709166822352],
            [33.28325001127185, 0.863414118808241],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1823,
        District: "KAMULI",
        County: "BUGABULA",
        Subcounty: "BULOPA",
        Population: 28909,
        Key: "KAMULIBULOPA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.39679245303052, 0.908178805155686],
            [33.404287271719106, 0.925014633575424],
            [33.40700692932663, 0.932595792042656],
            [33.40785051026046, 0.936205487481395],
            [33.40758926939605, 0.940747163593361],
            [33.40513064065056, 0.946338563502733],
            [33.40463253470696, 0.948801018246648],
            [33.39347942494018, 0.939302631695097],
            [33.388977996695886, 0.936861684702792],
            [33.38707766101796, 0.936358551644881],
            [33.38529610687514, 0.936285784349751],
            [33.378941924916916, 0.937716293077648],
            [33.369285934826216, 0.940961581404224],
            [33.36129270656351, 0.944422989080392],
            [33.35604304995948, 0.946069271831224],
            [33.351957334180874, 0.946281955802064],
            [33.3496888024242, 0.945778589674966],
            [33.34417782231076, 0.943767245071609],
            [33.33958137925883, 0.941421775634582],
            [33.32789433334505, 0.93034668356686],
            [33.324354970227326, 0.926734874056723],
            [33.324034822338156, 0.925868556803316],
            [33.321954891875386, 0.924703258779264],
            [33.32160923991699, 0.929123253002209],
            [33.32075327750359, 0.930559575977038],
            [33.32021839902383, 0.932534460504958],
            [33.318293015620874, 0.941654790510088],
            [33.31865867036571, 0.947307090005136],
            [33.31595606547723, 0.945447945990418],
            [33.31416003049203, 0.944724981398605],
            [33.313492886764806, 0.943950260059996],
            [33.31082448163753, 0.942731511138311],
            [33.30959267938057, 0.93956018089506],
            [33.306564943648056, 0.936719582135912],
            [33.30366471658362, 0.933149156361394],
            [33.297619712288274, 0.923658545327607],
            [33.296016433305155, 0.912565627686774],
            [33.297156012718396, 0.905732198791699],
            [33.2918162919223, 0.882695542641974],
            [33.28898966652402, 0.877099995660806],
            [33.28398962927957, 0.868921334434818],
            [33.28325001127185, 0.863414118808241],
            [33.28363489086207, 0.862709166822352],
            [33.29699703876089, 0.858157182689982],
            [33.29873039559377, 0.857125870596291],
            [33.30494250270163, 0.849335730444433],
            [33.29914088794936, 0.8481690987205],
            [33.29545919935127, 0.846540885410067],
            [33.290269149559606, 0.843239045532382],
            [33.28623470063425, 0.839167433792787],
            [33.29269211608666, 0.831807711950456],
            [33.29621961066287, 0.827028931953787],
            [33.30366647009505, 0.820627073475625],
            [33.30725326785304, 0.819242834120548],
            [33.310460037821684, 0.816734821884095],
            [33.31251472472665, 0.815708200204231],
            [33.3157215009835, 0.811957125076695],
            [33.31662413357087, 0.811790360604369],
            [33.317716785892, 0.81222133438329],
            [33.3186431483759, 0.813273725224174],
            [33.322467415779265, 0.8157622337817],
            [33.3260066243868, 0.819469712784212],
            [33.33667356682013, 0.82148523218465],
            [33.34508069025674, 0.811640734261123],
            [33.346553415282976, 0.809561919158269],
            [33.34825181507491, 0.80571428977128],
            [33.351292257477105, 0.803014909963397],
            [33.35398674608701, 0.801780679329678],
            [33.35626706374017, 0.801327900872287],
            [33.35693215571529, 0.80065896929385],
            [33.36215788389511, 0.798821518624601],
            [33.36616183232161, 0.797956256420812],
            [33.369867322681465, 0.798173677932208],
            [33.37379847612891, 0.799634286417446],
            [33.378703241647585, 0.803924152777598],
            [33.37318105594929, 0.820840229906551],
            [33.37210017425336, 0.825454375044421],
            [33.37073403433556, 0.837071040535006],
            [33.3697722162457, 0.84144090430195],
            [33.36204039503572, 0.862593883818366],
            [33.37720692147208, 0.878786773534805],
            [33.38280128590516, 0.885435840689832],
            [33.389677873235414, 0.895260293999521],
            [33.39679245303052, 0.908178805155686],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1827,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "BUKOOMA",
        Population: 39206,
        Key: "LUUKABUKOOMA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.41269817975802, 1.000249300503915],
            [33.406441539568256, 1.000865291849661],
            [33.39598333775919, 1.004014977740024],
            [33.388979824767475, 1.002197355460331],
            [33.38385747830383, 0.999302885298504],
            [33.38347664472564, 0.999565296266284],
            [33.38612003446722, 1.026362560505919],
            [33.3831205453605, 1.028561376153434],
            [33.37880034952982, 1.030570359373167],
            [33.37620735078409, 1.030995884434972],
            [33.371771189636746, 1.030996410762482],
            [33.371008954745136, 1.031548375609049],
            [33.36969603371972, 1.035493082379108],
            [33.36752850404202, 1.037899875970944],
            [33.36439189788698, 1.044785118490292],
            [33.36052732128018, 1.04767087132911],
            [33.35433731721988, 1.048898925059795],
            [33.35193553117062, 1.04983275400576],
            [33.350152380721525, 1.05371080222682],
            [33.34979590406394, 1.055865201718271],
            [33.35205538709075, 1.058282612114734],
            [33.35345876666866, 1.060838955407355],
            [33.3549121608483, 1.063097612928865],
            [33.3521696887275, 1.063568283207039],
            [33.35006682876712, 1.064666118087079],
            [33.34642630187366, 1.069467824272281],
            [33.33905923170331, 1.073386077246235],
            [33.33503182197654, 1.077303949770289],
            [33.328314829339654, 1.066927575962767],
            [33.32402594069495, 1.063128218651245],
            [33.32274584411, 1.059247113166074],
            [33.32126147781601, 1.057365453797874],
            [33.3204772153353, 1.056931271324384],
            [33.315220762077836, 1.056352793580949],
            [33.30693291694463, 1.054462766967585],
            [33.309257109214634, 1.050680807988411],
            [33.3105218796425, 1.047505115851587],
            [33.31078675419223, 1.044709506389946],
            [33.31296563408352, 1.042872708864212],
            [33.31329980018269, 1.042058427432122],
            [33.31239853123792, 1.039950521956086],
            [33.3130673593063, 1.037661515673992],
            [33.31304523469915, 1.035463050316094],
            [33.31420278490966, 1.033119712328872],
            [33.314419939154874, 1.030631712465322],
            [33.31650434771931, 1.027908300120237],
            [33.31700896195712, 1.023818920813114],
            [33.31695099097689, 1.022697074310124],
            [33.31647624931556, 1.022100007109038],
            [33.3102862838828, 1.016355648190063],
            [33.30997783295697, 1.0158490349277],
            [33.31009794399865, 1.014754312311658],
            [33.306931767999416, 1.007390197197933],
            [33.305244666318806, 1.005689483504267],
            [33.30366591852947, 1.00327402983108],
            [33.30017215479387, 1.000786373418549],
            [33.29879458381407, 0.999067531943847],
            [33.29920060884776, 0.997728507971518],
            [33.306771782538874, 0.984572937123235],
            [33.307002159086736, 0.983111352910265],
            [33.30242949444041, 0.965442765067338],
            [33.302242590962386, 0.96092564559497],
            [33.30272670025551, 0.960019437494527],
            [33.30286137119134, 0.95834569207262],
            [33.301816074458735, 0.953541701730235],
            [33.30140141212358, 0.947545398432329],
            [33.30176052353989, 0.937064203462691],
            [33.30226065518441, 0.934957456475372],
            [33.30366471658362, 0.933149156361394],
            [33.306564943648056, 0.936719582135912],
            [33.30959267938057, 0.93956018089506],
            [33.31082448163753, 0.942731511138311],
            [33.313492886764806, 0.943950260059996],
            [33.31416003049203, 0.944724981398605],
            [33.31595606547723, 0.945447945990418],
            [33.31865867036571, 0.947307090005136],
            [33.318293015620874, 0.941654790510088],
            [33.32021839902383, 0.932534460504958],
            [33.32075327750359, 0.930559575977038],
            [33.32160923991699, 0.929123253002209],
            [33.321954891875386, 0.924703258779264],
            [33.324034822338156, 0.925868556803316],
            [33.324354970227326, 0.926734874056723],
            [33.32789433334505, 0.93034668356686],
            [33.33958137925883, 0.941421775634582],
            [33.34417782231076, 0.943767245071609],
            [33.3496888024242, 0.945778589674966],
            [33.351957334180874, 0.946281955802064],
            [33.35604304995948, 0.946069271831224],
            [33.36129270656351, 0.944422989080392],
            [33.369285934826216, 0.940961581404224],
            [33.378941924916916, 0.937716293077648],
            [33.38529610687514, 0.936285784349751],
            [33.38707766101796, 0.936358551644881],
            [33.388977996695886, 0.936861684702792],
            [33.39347942494018, 0.939302631695097],
            [33.40463253470696, 0.948801018246648],
            [33.40500055561425, 0.953196284444858],
            [33.40648491292511, 0.955295035455783],
            [33.40529753774887, 0.956471300944657],
            [33.40534476487831, 0.956824131561377],
            [33.406009902667485, 0.957158795352151],
            [33.40636622301821, 0.95866961875709],
            [33.40833797206625, 0.959076501289919],
            [33.40792248867092, 0.960777406691206],
            [33.40830232242418, 0.961609694553831],
            [33.40967982872528, 0.962640896840503],
            [33.410019238290744, 0.963636035659644],
            [33.40959761670708, 0.965671684377349],
            [33.408480489786065, 0.967110308614652],
            [33.40845667904113, 0.96997824196261],
            [33.40916991712222, 0.973207969284631],
            [33.410452541566364, 0.974619159737889],
            [33.411681969575994, 0.9774055135846],
            [33.413065744321116, 0.979088101196596],
            [33.41318438212575, 0.979992796139859],
            [33.41304183835479, 0.981114653673021],
            [33.41092767129991, 0.98297861851854],
            [33.410987322129735, 0.983847131807987],
            [33.4119138696666, 0.985755953946486],
            [33.4138137597801, 0.986379965167878],
            [33.41588634202384, 0.988903842628785],
            [33.416937926963435, 0.993409160113553],
            [33.41724677135136, 0.996955579867268],
            [33.417732718597584, 0.997263118240956],
            [33.41732624260961, 0.999054493981499],
            [33.416635399528566, 0.999868820436104],
            [33.41589731853831, 1.000276033885673],
            [33.41269817975802, 1.000249300503915],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1830,
        District: "LUUKA",
        County: "LUUKA",
        Subcounty: "IKUMBYA",
        Population: 34278,
        Key: "LUUKAIKUMBYA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.828948295974147, 0.83928614869313],
            [30.82237085571832, 0.839994815503143],
            [30.816673246113037, 0.837968671515362],
            [30.81677292946518, 0.834778186597649],
            [30.814139456226, 0.829729394164777],
            [30.813348459075627, 0.826815041108513],
            [30.81333217082289, 0.825097905723802],
            [30.809837288684772, 0.819823181643373],
            [30.808287390290783, 0.81829599510544],
            [30.805237522764614, 0.818485100824701],
            [30.801810828146408, 0.814580674418212],
            [30.7988656413003, 0.812410982017552],
            [30.796849985296124, 0.811906880161688],
            [30.79535903614773, 0.810387775548872],
            [30.79357673370826, 0.810637953779404],
            [30.792400114959232, 0.81135490373743],
            [30.78730428586444, 0.809235185086779],
            [30.785629195557522, 0.80898310342936],
            [30.783355822779786, 0.80925735599134],
            [30.783411791415247, 0.80657178516832],
            [30.784490056318763, 0.803264485936945],
            [30.786502354420428, 0.801426282823178],
            [30.785242140247675, 0.800698428431051],
            [30.783401244295494, 0.799884708727529],
            [30.77948128744977, 0.799286336306919],
            [30.77570321321494, 0.799164672237525],
            [30.773688045894282, 0.799642260883852],
            [30.772425823986882, 0.79593373262728],
            [30.771596227127024, 0.794732138809164],
            [30.770551393925118, 0.794131217364291],
            [30.770289079573953, 0.792559909147055],
            [30.77257207600332, 0.789068889043078],
            [30.77316744613599, 0.786581572393179],
            [30.77547349243722, 0.784406128194513],
            [30.776188431927444, 0.780459768657106],
            [30.777828446615796, 0.779599536326387],
            [30.77873109267789, 0.780174090468371],
            [30.779016323051952, 0.780006804634443],
            [30.780097455377867, 0.777374287799407],
            [30.779925250134546, 0.77646157648663],
            [30.77285564359579, 0.777109686430969],
            [30.769725099272293, 0.778346564298397],
            [30.768537854351766, 0.778432844908529],
            [30.76705867223525, 0.779529361042525],
            [30.76529934780244, 0.779745705638189],
            [30.764014118243978, 0.779088055076005],
            [30.763851655229917, 0.774439591101457],
            [30.761789532969342, 0.772532272360211],
            [30.762215992879106, 0.771445220002116],
            [30.762036293889665, 0.770401936516755],
            [30.76071477778365, 0.769856962596004],
            [30.755653237383264, 0.769189055358088],
            [30.75305756884453, 0.767280554882934],
            [30.750204232939577, 0.766737545003515],
            [30.748521062286674, 0.764670322568853],
            [30.746766820521735, 0.764316174430922],
            [30.745486505646195, 0.763520755510267],
            [30.744690640525285, 0.761881907419147],
            [30.744407808653044, 0.757461501425345],
            [30.744522695093032, 0.75585419622555],
            [30.746689827715375, 0.755625708949337],
            [30.748401253977217, 0.754421078430043],
            [30.748968912879985, 0.75323784270007],
            [30.74784411883801, 0.750640658701624],
            [30.746435167010414, 0.749466240851922],
            [30.746301758207565, 0.746477357736094],
            [30.749249525015202, 0.743752093343945],
            [30.754732701372273, 0.741961036452976],
            [30.755419223556785, 0.741424259894898],
            [30.75316647879293, 0.737406149976681],
            [30.75188871064123, 0.736525112112848],
            [30.75148679899321, 0.733071084652489],
            [30.75242924760893, 0.731852565647135],
            [30.75495613214638, 0.72927326389434],
            [30.75788072691122, 0.727317930532043],
            [30.764005943574894, 0.720751912036418],
            [30.766832405479814, 0.718857078059744],
            [30.769120143217236, 0.718045534667522],
            [30.772954482531564, 0.718724654350337],
            [30.77382922153106, 0.718386470632392],
            [30.776856535055373, 0.718523407132711],
            [30.777194681589584, 0.714866520567798],
            [30.775553118205675, 0.712340103283662],
            [30.77597127768223, 0.711034991390061],
            [30.775708154847305, 0.709579739939772],
            [30.77430222225738, 0.707339124846074],
            [30.773159319077614, 0.706458271584715],
            [30.771172190871898, 0.706020497415056],
            [30.769648279840776, 0.704806269304078],
            [30.76862371173335, 0.703280864559498],
            [30.76652806344807, 0.701327911258624],
            [30.766546336079266, 0.699781158508414],
            [30.76696418204376, 0.697138899355574],
            [30.766353005155402, 0.692546152856729],
            [30.76718881117046, 0.683488058106904],
            [30.766770723559144, 0.681734815735271],
            [30.76415045914792, 0.678589669037027],
            [30.76625162488567, 0.674039540330794],
            [30.766962326124393, 0.67091196208151],
            [30.76701830374302, 0.667367996946165],
            [30.768278624815263, 0.666673538496139],
            [30.76987606654567, 0.665040725376263],
            [30.77117935583461, 0.664687279177829],
            [30.772608093056313, 0.665877790063568],
            [30.776415241265337, 0.66620466850167],
            [30.7783319676039, 0.667620964227236],
            [30.781117038733758, 0.668952091587072],
            [30.784639271877367, 0.669852262436386],
            [30.78928905778917, 0.668113237202018],
            [30.794070611281796, 0.667268871883193],
            [30.796223029499778, 0.666417575487562],
            [30.797769962555016, 0.666796466415914],
            [30.79900778891424, 0.667390734458415],
            [30.803128529107447, 0.671941091235546],
            [30.80523558240358, 0.673309327856103],
            [30.805855793648778, 0.674907099168951],
            [30.805929922626028, 0.677675298430858],
            [30.80695430747714, 0.678962061063762],
            [30.809388643980718, 0.674458879902383],
            [30.81031556701337, 0.673430922601561],
            [30.813204562441836, 0.671528149707782],
            [30.814131012960647, 0.670022888455112],
            [30.815412318677954, 0.666488403754268],
            [30.815611373666822, 0.663302020018155],
            [30.816903133977377, 0.658347531719208],
            [30.819160205027654, 0.655073684909044],
            [30.82016815789559, 0.651838009194314],
            [30.824647536991236, 0.646232998239123],
            [30.823560514412016, 0.641879679896433],
            [30.824866960380852, 0.639729288926909],
            [30.824960984346685, 0.638607427625657],
            [30.826341180203734, 0.638771829768984],
            [30.826768304866818, 0.637649332290918],
            [30.826325097665197, 0.634678953837038],
            [30.824109571900184, 0.63201031470318],
            [30.826831427685196, 0.6295827279467],
            [30.826878035875403, 0.628628020980851],
            [30.82587578012302, 0.625766124929611],
            [30.82522058668402, 0.624920172525959],
            [30.82521918531218, 0.623559854481421],
            [30.825812888171665, 0.62246090346516],
            [30.824502733059006, 0.620983787304092],
            [30.824502190476593, 0.620458746545197],
            [30.82712521002079, 0.614523127181805],
            [30.829384331026542, 0.613325460491513],
            [30.831178737366134, 0.61140080955094],
            [30.83267480780998, 0.608605637185432],
            [30.832445496664008, 0.605467776134501],
            [30.831920155597672, 0.603655033688507],
            [30.831038712471198, 0.602606671600739],
            [30.831037507830427, 0.601461138512077],
            [30.832356099021894, 0.599608986901285],
            [30.834210853283963, 0.598531416010836],
            [30.83647073067117, 0.598073547217382],
            [30.83749300088808, 0.597260121170409],
            [30.83856194487221, 0.59558743106169],
            [30.839109555174463, 0.595438277458771],
            [30.8400615618648, 0.595633945110371],
            [30.84247577880099, 0.597456264838484],
            [30.843197840134803, 0.597454855458398],
            [30.846218952588718, 0.598996188840017],
            [30.846713608103272, 0.601233782944887],
            [30.848029547468037, 0.604194022560749],
            [30.86465172375374, 0.618350249803467],
            [30.870712045223, 0.622963794676026],
            [30.87232976642091, 0.624952062618153],
            [30.873459076293837, 0.62567430641357],
            [30.881196428431036, 0.627597693705557],
            [30.88345564914977, 0.627591809195172],
            [30.886885624415374, 0.62620411193044],
            [30.888279016523917, 0.626259154708228],
            [30.89115336492167, 0.627295343403028],
            [30.893328783604176, 0.629664962847117],
            [30.896143833311733, 0.631001666722872],
            [30.898085203133476, 0.630886701015623],
            [30.901035777176336, 0.629415687318745],
            [30.90290778268513, 0.631630892092635],
            [30.905088531072213, 0.63188719460802],
            [30.90883872249897, 0.634840542754899],
            [30.911016569327693, 0.635440663135282],
            [30.91319390860829, 0.637307336983368],
            [30.91622391977342, 0.638261900425259],
            [30.916310770691695, 0.640938048465126],
            [30.916682629201883, 0.641374005914627],
            [30.918197765489325, 0.641538056750021],
            [30.9211137984112, 0.642882414307078],
            [30.921220280213408, 0.644317562089019],
            [30.92260285121605, 0.645674157682074],
            [30.922300126151818, 0.650296723648075],
            [30.925105096761875, 0.655704620285376],
            [30.925564181686127, 0.657856609648882],
            [30.924999860024638, 0.664761188483446],
            [30.925350745567894, 0.666810992088634],
            [30.92449072456601, 0.669057754109017],
            [30.92577867152819, 0.674880095888302],
            [30.92526561043177, 0.67616718622694],
            [30.92293080546503, 0.678733348978465],
            [30.92311455495808, 0.679645380336218],
            [30.9240061535388, 0.680366661436044],
            [30.92380883858665, 0.682798926793942],
            [30.922748378292066, 0.684144269311235],
            [30.92277528822472, 0.686900555159257],
            [30.921333403260494, 0.688306346984258],
            [30.921651994369263, 0.689932698336552],
            [30.921417570012746, 0.691159610881718],
            [30.919484710829977, 0.693095639989263],
            [30.919546700872775, 0.693906888619025],
            [30.919953319692883, 0.694192349576434],
            [30.919666563979455, 0.695400773255495],
            [30.92009625423098, 0.696173184797056],
            [30.92002341343787, 0.697513898448763],
            [30.921122462662098, 0.700215065406383],
            [30.920808452961296, 0.702212397105515],
            [30.920999613555438, 0.703888265843348],
            [30.917251395727405, 0.708228504995755],
            [30.915051133237377, 0.711628549688095],
            [30.91306613314058, 0.713355155124739],
            [30.91324932747479, 0.714835964955114],
            [30.91261239948047, 0.717164728364645],
            [30.912764951382027, 0.7186378120608],
            [30.91039563943025, 0.723086596346076],
            [30.910655594805505, 0.724220396290523],
            [30.910164625078544, 0.725654616107158],
            [30.909885477197264, 0.729522425583074],
            [30.90884058380822, 0.731648521887438],
            [30.90850926267355, 0.733510739838395],
            [30.907368333092442, 0.734777817323613],
            [30.906097707445564, 0.737250400393735],
            [30.905814180277268, 0.739327325133882],
            [30.905338950830714, 0.740020347265941],
            [30.90548297592359, 0.741308868380632],
            [30.9046903213815, 0.74592853723863],
            [30.902276030783487, 0.750038329770616],
            [30.903419181898283, 0.756175699530278],
            [30.905269818283088, 0.761626101514124],
            [30.906683084718985, 0.763836054132161],
            [30.908455319739048, 0.762293445838333],
            [30.90690337857612, 0.763983325222304],
            [30.902334568600647, 0.766132062813049],
            [30.899446100483274, 0.768673467022322],
            [30.898584718533723, 0.770237858789033],
            [30.898722329655488, 0.772668987109389],
            [30.89797209984932, 0.774009886184969],
            [30.89669470000686, 0.774735769125626],
            [30.895695264066177, 0.774763210148669],
            [30.893502519576785, 0.773895872530301],
            [30.891003915801125, 0.774006389362666],
            [30.888059976714924, 0.776435952599567],
            [30.88661503568211, 0.779117751531915],
            [30.883033249625086, 0.7802057082349],
            [30.878839434178456, 0.783836144832248],
            [30.877116469056762, 0.787300173005609],
            [30.870617929629002, 0.791935313650685],
            [30.866647139816255, 0.793721579110354],
            [30.86303623936087, 0.797463999510896],
            [30.8516229065209, 0.804136219642342],
            [30.850538341732268, 0.807712262012142],
            [30.849899437444336, 0.808466363109101],
            [30.845651180498216, 0.810000911633649],
            [30.84440088013296, 0.811984137399528],
            [30.843983556987943, 0.813688387982574],
            [30.844191448704255, 0.816399665745733],
            [30.845506933521488, 0.82019975277316],
            [30.845506363091264, 0.821261558494923],
            [30.84419982908754, 0.824530085575494],
            [30.84472559775196, 0.82765990300879],
            [30.84255931852916, 0.829335243951728],
            [30.838284051937382, 0.829444656272198],
            [30.836341145996506, 0.828772972722559],
            [30.83453765589273, 0.826983687628098],
            [30.832539522426497, 0.825781079053018],
            [30.831012444833977, 0.826199367536268],
            [30.830095070892806, 0.828518044033784],
            [30.830870694275422, 0.831592088695731],
            [30.83092384759078, 0.835895182218457],
            [30.83000646197147, 0.838213852118227],
            [30.828948295974147, 0.83928614869313],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1553,
        District: "KYENJOJO",
        County: "MWENGE",
        Subcounty: "BUFUNJO",
        Population: 50040,
        Key: "KYENJOJOBUFUNJO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.91674155958284, 0.760693845707356],
            [30.916315898275357, 0.760065123497816],
            [30.916507046293077, 0.757912446807686],
            [30.91574691256091, 0.757242326254988],
            [30.914510505539834, 0.758629063573273],
            [30.910279487264013, 0.760684084575506],
            [30.908455319739048, 0.762293445838333],
            [30.906683084718985, 0.763836054132161],
            [30.905269818283088, 0.761626101514124],
            [30.903419181898283, 0.756175699530278],
            [30.902276030783487, 0.750038329770616],
            [30.9046903213815, 0.74592853723863],
            [30.90548297592359, 0.741308868380632],
            [30.905338950830714, 0.740020347265941],
            [30.905814180277268, 0.739327325133882],
            [30.906097707445564, 0.737250400393735],
            [30.907368333092442, 0.734777817323613],
            [30.90850926267355, 0.733510739838395],
            [30.90884058380822, 0.731648521887438],
            [30.909885477197264, 0.729522425583074],
            [30.910164625078544, 0.725654616107158],
            [30.910655594805505, 0.724220396290523],
            [30.91039563943025, 0.723086596346076],
            [30.912764951382027, 0.7186378120608],
            [30.91261239948047, 0.717164728364645],
            [30.91324932747479, 0.714835964955114],
            [30.91306613314058, 0.713355155124739],
            [30.915051133237377, 0.711628549688095],
            [30.917251395727405, 0.708228504995755],
            [30.920999613555438, 0.703888265843348],
            [30.920808452961296, 0.702212397105515],
            [30.921122462662098, 0.700215065406383],
            [30.92002341343787, 0.697513898448763],
            [30.92009625423098, 0.696173184797056],
            [30.919666563979455, 0.695400773255495],
            [30.919953319692883, 0.694192349576434],
            [30.919546700872775, 0.693906888619025],
            [30.919484710829977, 0.693095639989263],
            [30.921417570012746, 0.691159610881718],
            [30.921651994369263, 0.689932698336552],
            [30.921333403260494, 0.688306346984258],
            [30.92277528822472, 0.686900555159257],
            [30.922748378292066, 0.684144269311235],
            [30.92380883858665, 0.682798926793942],
            [30.92486963035959, 0.68176410233347],
            [30.926807238036954, 0.681448278825394],
            [30.93010246151835, 0.678821503453881],
            [30.930905461059243, 0.678599580352679],
            [30.93121406649531, 0.678013047628239],
            [30.930959722895658, 0.67687531742712],
            [30.93133454404964, 0.676565645732052],
            [30.93317599426236, 0.676851723026059],
            [30.93393884629657, 0.678234536900476],
            [30.934533794221036, 0.678305000305288],
            [30.937055190052085, 0.677417065216459],
            [30.93852889603863, 0.675838996107197],
            [30.94174008751508, 0.674687185280609],
            [30.942262638414164, 0.673755359083748],
            [30.942142589356255, 0.67270544472922],
            [30.942534250328524, 0.671761931875041],
            [30.944483386085935, 0.669729461246887],
            [30.94521884040231, 0.667579990357103],
            [30.94571837017561, 0.667411956615504],
            [30.94701341472686, 0.665655213342969],
            [30.952339430824967, 0.661611338375783],
            [30.95817816755805, 0.658652394401141],
            [30.959771179695768, 0.657408193011586],
            [30.960941562340114, 0.650186035875654],
            [30.96092912067341, 0.638252348333228],
            [30.961832093722283, 0.63705721386535],
            [30.965078809076655, 0.635750086761428],
            [30.967052182278753, 0.634170965229073],
            [30.967502470001428, 0.632427756164374],
            [30.970176530023437, 0.629641949399247],
            [30.97095888807572, 0.626895646687114],
            [30.972516047552148, 0.625520200629999],
            [30.97322645773671, 0.622248944105578],
            [30.975353487768132, 0.619726721750565],
            [30.975351530339125, 0.617888923480316],
            [30.97651629851294, 0.616740974620106],
            [30.978378674081878, 0.611498353849445],
            [30.978543026253007, 0.609421538051352],
            [30.981832616399245, 0.603722586841284],
            [30.98679166082234, 0.601528859667758],
            [30.993548272756517, 0.60025045484957],
            [30.999174162666165, 0.597559892447725],
            [31.005662455011503, 0.595725851271427],
            [31.006765158582322, 0.59123777741398],
            [31.00715736034041, 0.591059470422635],
            [31.008700813322232, 0.591038883928358],
            [31.01130977153729, 0.592310376922328],
            [31.018348099636142, 0.593173320675803],
            [31.019680919243402, 0.591838585366638],
            [31.020916472864972, 0.591482932562932],
            [31.02434388074547, 0.587979067828605],
            [31.030203824007437, 0.58504167146779],
            [31.032143032482626, 0.583358094259971],
            [31.033912128789094, 0.583282018983022],
            [31.03776799622924, 0.58444866424586],
            [31.039599790450954, 0.582971636585196],
            [31.043707564361362, 0.583028135894947],
            [31.04673918530745, 0.581255072522012],
            [31.04776049522533, 0.581137811579609],
            [31.04999794527317, 0.578801740197647],
            [31.053703794060834, 0.578116891444879],
            [31.055190385481804, 0.577033239609114],
            [31.057049064483362, 0.574194730816534],
            [31.057690949381403, 0.573861688156893],
            [31.063943644170443, 0.566538579479802],
            [31.069197842656532, 0.563549692113841],
            [31.073547779011356, 0.559799391639788],
            [31.08129641488683, 0.555549882519884],
            [31.086174978345298, 0.551749993143023],
            [31.0919260628628, 0.551597491429967],
            [31.092833062160793, 0.551169014881004],
            [31.093868919396368, 0.549424338900186],
            [31.095655796057258, 0.549428087397521],
            [31.096135073312464, 0.548948075812182],
            [31.09631372756125, 0.547859838255182],
            [31.098394404524004, 0.545952784721134],
            [31.099480235937175, 0.544360107885804],
            [31.102756486999777, 0.54239224810843],
            [31.1028255674451, 0.53969615943502],
            [31.10320387765565, 0.539342520064643],
            [31.104663410921948, 0.539421518003326],
            [31.10660486518535, 0.537855932344419],
            [31.106885291369295, 0.536286877142298],
            [31.10646009538911, 0.535121422394824],
            [31.11061611691512, 0.53363638946367],
            [31.114328571913376, 0.53353019703253],
            [31.115110832947643, 0.532620413707803],
            [31.116024398032017, 0.52930579869282],
            [31.11692319211816, 0.528170027091957],
            [31.117588064006025, 0.527865971958258],
            [31.11977664839735, 0.528300928523325],
            [31.126231477600054, 0.528605474993276],
            [31.12734011274667, 0.528050799667449],
            [31.130159977424135, 0.527575617333611],
            [31.131208084086936, 0.525970159519656],
            [31.131036905617965, 0.523767220858577],
            [31.13172790051429, 0.518705228773919],
            [31.13256990759978, 0.519200661669806],
            [31.134860162416636, 0.519205410867727],
            [31.13674630830631, 0.519842234528591],
            [31.13777578660506, 0.520907686833955],
            [31.138501698118162, 0.522656081724963],
            [31.14296030187627, 0.52585774728404],
            [31.144472242856235, 0.52919662031458],
            [31.14479493387599, 0.530957612112922],
            [31.149622909607544, 0.535265622656254],
            [31.152256310083164, 0.539420761655391],
            [31.155443379099285, 0.542400249942413],
            [31.15690630889568, 0.542554572692629],
            [31.15789584091037, 0.543899628881112],
            [31.163287843656, 0.546809715180642],
            [31.16421709691852, 0.547672432200532],
            [31.167189382343505, 0.552147181883432],
            [31.168216216002037, 0.554377269569417],
            [31.16930293944229, 0.557936667206752],
            [31.171328050214818, 0.562312876768266],
            [31.171434301150008, 0.56453798686803],
            [31.170542503143263, 0.566296229452315],
            [31.168510193272027, 0.567156898256108],
            [31.166976753810694, 0.568735489435624],
            [31.166584356219833, 0.569524904333601],
            [31.167101715754896, 0.57103058313351],
            [31.161641303605435, 0.573608275341039],
            [31.16137233543297, 0.57676085637485],
            [31.16153914180143, 0.578817732088627],
            [31.16205790630162, 0.580048624287962],
            [31.16183713813401, 0.582087309760618],
            [31.162827111221507, 0.583638683759297],
            [31.1649498886284, 0.583844527412812],
            [31.165361078076636, 0.583199671992624],
            [31.166631158446144, 0.582935576482994],
            [31.17075331348595, 0.585942616689625],
            [31.173899466935843, 0.587037957773373],
            [31.17494972506375, 0.58941894720404],
            [31.177373614160594, 0.590538325245724],
            [31.17793107089666, 0.591603490828238],
            [31.17775737355166, 0.593384854499623],
            [31.17806472134632, 0.594624206066766],
            [31.176833003531023, 0.596734391825611],
            [31.175718374824804, 0.601355027271694],
            [31.175683248900565, 0.603196149386175],
            [31.177200499822174, 0.60694841328915],
            [31.17811919338852, 0.608281230709766],
            [31.180305207699817, 0.616734915834538],
            [31.181533150794277, 0.619041437962558],
            [31.181680011868522, 0.620839313452646],
            [31.183649525908123, 0.623539839405577],
            [31.182537602029225, 0.630917632627129],
            [31.181629675669896, 0.633063770413873],
            [31.181629075595268, 0.634775848262508],
            [31.181126642466975, 0.635069120313557],
            [31.181266610768027, 0.636332946972491],
            [31.18183087583566, 0.637207609494259],
            [31.18457128811948, 0.638504666739382],
            [31.18944485604666, 0.645777711586219],
            [31.188067943532, 0.646757291730114],
            [31.185114920681652, 0.649957486839299],
            [31.17949539174255, 0.652711674682874],
            [31.178560056885576, 0.653528026741804],
            [31.16925828059625, 0.655477820405247],
            [31.164305685178583, 0.657058453373317],
            [31.160919929482837, 0.658883811172411],
            [31.1586481961305, 0.659506904294461],
            [31.15340245977437, 0.660599095167246],
            [31.147301506606496, 0.660805055286015],
            [31.14527459022024, 0.660542820353281],
            [31.143254923238317, 0.65922617779889],
            [31.14263735842993, 0.658245014661005],
            [31.1409263202403, 0.657837643870137],
            [31.140284385036594, 0.658483378562758],
            [31.13914356684656, 0.658554723440056],
            [31.13831224881466, 0.657190682076006],
            [31.137741408079137, 0.658386719034579],
            [31.136315394549367, 0.658457955224289],
            [31.13348840263843, 0.655203088647377],
            [31.13229992343273, 0.655633290637726],
            [31.130921599664724, 0.655297820578609],
            [31.1297576812972, 0.653598711470949],
            [31.12875876548103, 0.655560178848211],
            [31.126619913620477, 0.655248345506863],
            [31.125430856798005, 0.657233660041578],
            [31.12364814382846, 0.657878953768627],
            [31.121557064374716, 0.656945090742844],
            [31.119726957189112, 0.657231491651152],
            [31.118277759040147, 0.65579545377416],
            [31.118111789901516, 0.654742700706085],
            [31.11723297883884, 0.653306882188617],
            [31.115617310291327, 0.652157882148457],
            [31.115641345615064, 0.651440149528534],
            [31.11412091106408, 0.649836619107137],
            [31.111863205803214, 0.649644368642344],
            [31.111364421631603, 0.64883074126834],
            [31.110699016144466, 0.64871086608401],
            [31.109823222522845, 0.649134875142874],
            [31.108789510464167, 0.649377084917879],
            [31.10807466260208, 0.650426569451954],
            [31.107815416895928, 0.649589979147946],
            [31.10681757905811, 0.649802807796207],
            [31.105455826512173, 0.648235306873481],
            [31.105487848757107, 0.644700143836877],
            [31.104702872115745, 0.640195825917533],
            [31.105421844143304, 0.637378734257942],
            [31.104676988957475, 0.636027541297995],
            [31.103442745079604, 0.635786031532819],
            [31.101612846303127, 0.636403165743605],
            [31.099608774074518, 0.635706736734381],
            [31.095724045560967, 0.636294987407935],
            [31.09487880454046, 0.637260589751161],
            [31.09290542954177, 0.638307354154625],
            [31.092730601217788, 0.641985503777914],
            [31.092159244849334, 0.642605320342698],
            [31.090615589746573, 0.642673664361939],
            [31.08909405565767, 0.643434756269225],
            [31.084900409992624, 0.644488686615144],
            [31.081714816010166, 0.646034446356428],
            [31.079888238305326, 0.64524225803281],
            [31.07912820338784, 0.645312284454512],
            [31.077900943012974, 0.647160827856612],
            [31.077212827217117, 0.646944370134865],
            [31.075644425324914, 0.647442600598526],
            [31.07535841341654, 0.64789582200728],
            [31.074717388206228, 0.647846667540907],
            [31.071412128746456, 0.649798208717756],
            [31.069464244342264, 0.65010452619798],
            [31.056667608372685, 0.659201347313055],
            [31.053221517330886, 0.660459834111887],
            [31.051200385196733, 0.661625864063743],
            [31.04903836758163, 0.662122781616185],
            [31.048055880155378, 0.660866638787205],
            [31.04756405433395, 0.657975383353087],
            [31.046212081746514, 0.657327538591007],
            [31.04012385141803, 0.661303256527661],
            [31.035996045076786, 0.66467412333748],
            [31.03321710764368, 0.664978596686337],
            [31.031980207447496, 0.665883562247747],
            [31.028119717276926, 0.666675327819056],
            [31.027311243402693, 0.667151281402788],
            [31.023582519016305, 0.667453674241598],
            [31.012920130143158, 0.672792707348441],
            [31.005374606048374, 0.675511088016663],
            [31.001285081412973, 0.677771240774132],
            [31.00102123992581, 0.677178557614196],
            [30.998744724841217, 0.678168411155259],
            [30.996825863207224, 0.679538287128473],
            [30.99617966370086, 0.680838504180025],
            [30.99129111277306, 0.68223651802512],
            [30.98654974810958, 0.685616271127379],
            [30.984541133998917, 0.686560775640726],
            [30.98320153031465, 0.686675338545377],
            [30.980043749071687, 0.688349922012284],
            [30.979910172283894, 0.688730906843527],
            [30.976830184246243, 0.690058193762574],
            [30.976295696533658, 0.691425367097173],
            [30.973059636995192, 0.692976894989142],
            [30.97191137087316, 0.694602799209778],
            [30.971756914543217, 0.696417147415466],
            [30.967604515024437, 0.697096985270401],
            [30.966400070959487, 0.69837584975526],
            [30.965373177113786, 0.698579377602812],
            [30.96451433739652, 0.6993760736656],
            [30.962884461094475, 0.699468778285126],
            [30.961880880327048, 0.700657665509461],
            [30.96045225359809, 0.701041128512947],
            [30.95672559893015, 0.703198238353856],
            [30.95419425964723, 0.706103287949827],
            [30.950599213558284, 0.705908601876159],
            [30.948177404061294, 0.706708260904012],
            [30.947664349253092, 0.70720194548649],
            [30.94755364986064, 0.708142761962083],
            [30.940002098070295, 0.710530166268456],
            [30.938573776768546, 0.711392974788739],
            [30.936146832501414, 0.714073424635254],
            [30.9350277140154, 0.714481702356741],
            [30.934671087339165, 0.715151341588671],
            [30.9347679068622, 0.716704087689731],
            [30.934291753947527, 0.716943903829568],
            [30.93469839612382, 0.718663304243184],
            [30.93382991209365, 0.719608663492157],
            [30.932520897841407, 0.720686250384267],
            [30.92913920163244, 0.721385512797512],
            [30.92787823287486, 0.722869151290952],
            [30.92830839204697, 0.724301807693258],
            [30.92771352227596, 0.724924111650309],
            [30.927298542835498, 0.726824248118739],
            [30.92672734636716, 0.727303149944965],
            [30.927469416775587, 0.731028768967876],
            [30.926149573332598, 0.733217303138232],
            [30.926414027470784, 0.735701486061608],
            [30.92474850152667, 0.737592028348808],
            [30.923811625160678, 0.741691121623171],
            [30.92102773441708, 0.744778308613548],
            [30.920117953935, 0.746785694445613],
            [30.919763334993444, 0.749210334511439],
            [30.920119096592042, 0.753590327310824],
            [30.91674155958284, 0.760693845707356],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1556,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "HAPUUYO",
        Population: 45211,
        Key: "KYEGEGWAHAPUUYO",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.215540950982952, 0.631838417257736],
            [31.21077373280561, 0.636973127768841],
            [31.208819703924878, 0.638482603689391],
            [31.203948821960385, 0.640605960276601],
            [31.19311700094319, 0.644175123442692],
            [31.18944485604666, 0.645777711586219],
            [31.18457128811948, 0.638504666739382],
            [31.18183087583566, 0.637207609494259],
            [31.181266610768027, 0.636332946972491],
            [31.181126642466975, 0.635069120313557],
            [31.181629075595268, 0.634775848262508],
            [31.181629675669896, 0.633063770413873],
            [31.182537602029225, 0.630917632627129],
            [31.183649525908123, 0.623539839405577],
            [31.181680011868522, 0.620839313452646],
            [31.181533150794277, 0.619041437962558],
            [31.180305207699817, 0.616734915834538],
            [31.17811919338852, 0.608281230709766],
            [31.177200499822174, 0.60694841328915],
            [31.175683248900565, 0.603196149386175],
            [31.175718374824804, 0.601355027271694],
            [31.176833003531023, 0.596734391825611],
            [31.17806472134632, 0.594624206066766],
            [31.17775737355166, 0.593384854499623],
            [31.17793107089666, 0.591603490828238],
            [31.177373614160594, 0.590538325245724],
            [31.17494972506375, 0.58941894720404],
            [31.173899466935843, 0.587037957773373],
            [31.17075331348595, 0.585942616689625],
            [31.166631158446144, 0.582935576482994],
            [31.165361078076636, 0.583199671992624],
            [31.1649498886284, 0.583844527412812],
            [31.162827111221507, 0.583638683759297],
            [31.16183713813401, 0.582087309760618],
            [31.16205790630162, 0.580048624287962],
            [31.16153914180143, 0.578817732088627],
            [31.16137233543297, 0.57676085637485],
            [31.161641303605435, 0.573608275341039],
            [31.167101715754896, 0.57103058313351],
            [31.166584356219833, 0.569524904333601],
            [31.166976753810694, 0.568735489435624],
            [31.168510193272027, 0.567156898256108],
            [31.170542503143263, 0.566296229452315],
            [31.171434301150008, 0.56453798686803],
            [31.171328050214818, 0.562312876768266],
            [31.16930293944229, 0.557936667206752],
            [31.168216216002037, 0.554377269569417],
            [31.167189382343505, 0.552147181883432],
            [31.16421709691852, 0.547672432200532],
            [31.163287843656, 0.546809715180642],
            [31.15789584091037, 0.543899628881112],
            [31.15690630889568, 0.542554572692629],
            [31.155443379099285, 0.542400249942413],
            [31.152256310083164, 0.539420761655391],
            [31.149622909607544, 0.535265622656254],
            [31.14479493387599, 0.530957612112922],
            [31.144472242856235, 0.52919662031458],
            [31.14296030187627, 0.52585774728404],
            [31.138501698118162, 0.522656081724963],
            [31.13777578660506, 0.520907686833955],
            [31.13674630830631, 0.519842234528591],
            [31.134860162416636, 0.519205410867727],
            [31.13256990759978, 0.519200661669806],
            [31.13172790051429, 0.518705228773919],
            [31.136003481516425, 0.514449001596163],
            [31.138617439754327, 0.513618349408606],
            [31.142313316344012, 0.508146197326378],
            [31.143345286569375, 0.507260555211008],
            [31.14538861427758, 0.506863274665105],
            [31.150844553715228, 0.504016433861984],
            [31.154242739399578, 0.502950380495154],
            [31.15566724465799, 0.503140683948043],
            [31.15959157629918, 0.50569183282675],
            [31.163888109606948, 0.506326051920997],
            [31.167862775650136, 0.507638379885508],
            [31.170355322085836, 0.508000802629452],
            [31.17756177348336, 0.508265104439533],
            [31.181386588859066, 0.507533732058174],
            [31.188341190380186, 0.508159661644615],
            [31.19133616994417, 0.507744542211219],
            [31.194835651456554, 0.509101956348812],
            [31.198541417599223, 0.508605648643338],
            [31.199799478510233, 0.50886824729007],
            [31.20170315861592, 0.507159683747115],
            [31.202675388179948, 0.507684443685063],
            [31.203124218835228, 0.508778757057178],
            [31.206528518453393, 0.510307963370195],
            [31.207689814638595, 0.511312052204656],
            [31.20828095819785, 0.5124335379106],
            [31.214556054275114, 0.515112017752774],
            [31.218295110185583, 0.517192953430693],
            [31.238387203529342, 0.520083361167409],
            [31.242040490991435, 0.521883960612907],
            [31.248356723620486, 0.527474374305908],
            [31.248693827210634, 0.530594337322225],
            [31.248265968623954, 0.530756990090461],
            [31.24658157716059, 0.530087319353818],
            [31.246102121140634, 0.532040487289553],
            [31.243203561349336, 0.532609365805462],
            [31.241279990746623, 0.537871868653671],
            [31.243323013925938, 0.542837107124618],
            [31.243533065192178, 0.544510135934541],
            [31.246569109442778, 0.546138785029917],
            [31.250692381088435, 0.546791104732108],
            [31.251160923476032, 0.554378406783341],
            [31.25488404596828, 0.560239460665588],
            [31.256791587033092, 0.564770643719619],
            [31.256970014008072, 0.568876279045284],
            [31.256563439205422, 0.574736102954498],
            [31.25693694971741, 0.576997000713387],
            [31.258058740691386, 0.579637944554594],
            [31.25825000279517, 0.582079651119742],
            [31.256444084545205, 0.588544922733017],
            [31.255633361289497, 0.593030056047245],
            [31.25523741804823, 0.604035409559872],
            [31.250702488932014, 0.605399443309316],
            [31.244655240645113, 0.609629623706588],
            [31.24180273927507, 0.610813322315053],
            [31.237652847852587, 0.61342538515407],
            [31.235204344018612, 0.614491645736797],
            [31.230766606327954, 0.61828822205021],
            [31.228482974789667, 0.619933276364619],
            [31.227128372833388, 0.620339751899054],
            [31.222024288221164, 0.624732898400316],
            [31.215540950982952, 0.631838417257736],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1559,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "KASULE",
        Population: 23836,
        Key: "KYEGEGWAKASULE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.13172790051429, 0.518705228773919],
            [31.131036905617965, 0.523767220858577],
            [31.131208084086936, 0.525970159519656],
            [31.130159977424135, 0.527575617333611],
            [31.12734011274667, 0.528050799667449],
            [31.126231477600054, 0.528605474993276],
            [31.11977664839735, 0.528300928523325],
            [31.117588064006025, 0.527865971958258],
            [31.11692319211816, 0.528170027091957],
            [31.116583937062924, 0.527539878476753],
            [31.11694368538474, 0.525434673861625],
            [31.116712134738805, 0.522712581608625],
            [31.1154887559843, 0.516566400423011],
            [31.115150850198575, 0.516289844635755],
            [31.1129553155419, 0.515827870604292],
            [31.110556583764613, 0.51795183718503],
            [31.099549485265786, 0.52230677916411],
            [31.098612187589893, 0.521331180057608],
            [31.09829533382288, 0.51714330556752],
            [31.09526156231, 0.515418008395483],
            [31.093549498244286, 0.512609222486503],
            [31.093419204798842, 0.510701670347764],
            [31.089208061748707, 0.508437578676891],
            [31.08776860313404, 0.50666537905724],
            [31.08744914515104, 0.50483982468963],
            [31.085529597204157, 0.503389626255819],
            [31.083823633597532, 0.501080456296607],
            [31.085210621616433, 0.499899689261737],
            [31.08585101890438, 0.498503940849936],
            [31.085212348178384, 0.493940113419143],
            [31.083613008307818, 0.491738363027302],
            [31.083773174329703, 0.491147821503499],
            [31.08729433937643, 0.486853647265734],
            [31.095669049800964, 0.481540718003379],
            [31.0949227815652, 0.480144561538827],
            [31.093429707002805, 0.479285097075033],
            [31.090870697812527, 0.475848211883509],
            [31.089516179399574, 0.475625886514772],
            [31.08802455022648, 0.472955277695411],
            [31.087431408814048, 0.469366453412738],
            [31.08481915647686, 0.4644532056534],
            [31.080850934947524, 0.458512864525065],
            [31.079407138368374, 0.457326476759593],
            [31.076937933757023, 0.45361479660972],
            [31.075227925934996, 0.453155242780043],
            [31.07442979346631, 0.453422832647258],
            [31.06732209027471, 0.457820540698244],
            [31.065739931582232, 0.457600262853194],
            [31.05928189898725, 0.46233745849138],
            [31.05319560362988, 0.466072542529744],
            [31.049582637049344, 0.466545929124669],
            [31.04878002647896, 0.465687622663861],
            [31.048462145039263, 0.464646551781514],
            [31.04846312510123, 0.461083194161966],
            [31.047468916457152, 0.460842690604819],
            [31.04687254919454, 0.460121847311429],
            [31.04353181346759, 0.460040844342299],
            [31.042497913660995, 0.459520069112782],
            [31.03905364170765, 0.455463769520237],
            [31.038236533226915, 0.455926178856879],
            [31.034426622698415, 0.460897458217576],
            [31.034187492068106, 0.464851293556995],
            [31.031984336104554, 0.469643273448019],
            [31.03245954219492, 0.472698693451475],
            [31.027817882443152, 0.472697359498651],
            [31.02579420628012, 0.474074645414658],
            [31.023770822069547, 0.47443350468705],
            [31.022640132384353, 0.474552990895435],
            [31.021628629374455, 0.474073440815119],
            [31.02133076509422, 0.475204102483229],
            [31.019522488766643, 0.477697208606099],
            [31.018339720151186, 0.477854119067753],
            [31.014366597413648, 0.481177789877502],
            [31.012982997839995, 0.481312172205315],
            [31.012333486245165, 0.482003730163081],
            [31.01027873196658, 0.478388302516483],
            [31.008811414798334, 0.477556836449091],
            [31.00855961343093, 0.476056283270181],
            [31.009248114604045, 0.47402506459963],
            [31.00911073075605, 0.473332496167068],
            [31.00961562616654, 0.471855247172982],
            [31.010120204471768, 0.471486044017046],
            [31.00957106523689, 0.467284539849328],
            [31.00828729454245, 0.466083787268424],
            [31.007186643622063, 0.466037303685297],
            [31.005765226771572, 0.465067357319413],
            [31.005725467337108, 0.46375731351457],
            [31.00062908218517, 0.457191210955194],
            [30.99977647677596, 0.455010006165887],
            [30.999001669961935, 0.449355247137949],
            [30.999915061671476, 0.447167062093685],
            [31.000103577625435, 0.444178095547712],
            [30.996218516735183, 0.441345915990938],
            [30.995648065868536, 0.44060486376304],
            [30.995076681652268, 0.438022647943683],
            [30.994625253069184, 0.437783685989551],
            [30.99416247247584, 0.438584869960984],
            [30.992832002861356, 0.43798754101161],
            [30.99199996258396, 0.436648804570506],
            [30.9912826928639, 0.433827051303535],
            [30.992590181776773, 0.431916163753812],
            [30.993966098958108, 0.428496389141005],
            [30.994832816900423, 0.427982002126234],
            [30.99475730721257, 0.425382767486648],
            [30.99907461316302, 0.42718649153456],
            [31.006754515342813, 0.429223249574487],
            [31.015665108563592, 0.429844868977583],
            [31.01752911996465, 0.425952796583192],
            [31.019076228191352, 0.424148462307387],
            [31.019428201594426, 0.422343817700593],
            [31.020693898185332, 0.421317922738173],
            [31.024560474441937, 0.421495853522011],
            [31.025790927429316, 0.42085920144402],
            [31.026862984974223, 0.421089490029111],
            [31.030941270787103, 0.418118011926521],
            [31.034632461764293, 0.416915779993355],
            [31.03605628879467, 0.416119928715657],
            [31.03672502613321, 0.412652131650394],
            [31.037287526011315, 0.412333788641982],
            [31.038060902707393, 0.412157046989799],
            [31.040450977420317, 0.413042327222264],
            [31.043403590638864, 0.413503100670812],
            [31.05273670286024, 0.412036840242736],
            [31.05568923523044, 0.41292226331697],
            [31.05772777222322, 0.414019790064408],
            [31.061313165016124, 0.414409945145908],
            [31.062279724414076, 0.414887925293122],
            [31.062947750286877, 0.414321884703223],
            [31.06495139222248, 0.414393156970671],
            [31.06604132803815, 0.413473337565548],
            [31.07004900447308, 0.41205880617832],
            [31.074653898875198, 0.412201483700414],
            [31.075708585697434, 0.411670926355284],
            [31.075604028086573, 0.407955138437474],
            [31.076500857557225, 0.406062092741666],
            [31.076712812353577, 0.40167399986733],
            [31.080404246774183, 0.399728530101254],
            [31.082320850941873, 0.396278621811768],
            [31.082637756811188, 0.393943066590667],
            [31.08390341926614, 0.39312943491792],
            [31.085538958547712, 0.388971685755042],
            [31.088281517805093, 0.385964296463043],
            [31.091534533044538, 0.379577408340975],
            [31.095613162912176, 0.375260915592923],
            [31.0978118802999, 0.367422818532462],
            [31.09856857078959, 0.363087874213973],
            [31.099623685209938, 0.360504730283343],
            [31.105056012430342, 0.354436695407253],
            [31.106040808526867, 0.351853521195941],
            [31.107799010065577, 0.348987384903128],
            [31.10908342305544, 0.34231685594531],
            [31.109997725656672, 0.340547593424214],
            [31.110911783017826, 0.340123101127232],
            [31.111808727472845, 0.337274470065484],
            [31.11131708580605, 0.334726376102277],
            [31.11275847130696, 0.334089655684076],
            [31.112723601402596, 0.332567926361874],
            [31.113672999385326, 0.331152548372351],
            [31.11388420588503, 0.329595475866597],
            [31.11472803475393, 0.32874629806982],
            [31.114341739418826, 0.326729056303692],
            [31.11548534777611, 0.318721847925986],
            [31.116410807453157, 0.316495510108691],
            [31.11623666993365, 0.317144585080592],
            [31.117481506745353, 0.317823636331652],
            [31.11846857288461, 0.319352582139708],
            [31.121381495838964, 0.321621625472986],
            [31.12505289154055, 0.326306312402407],
            [31.127578012685056, 0.327645077717609],
            [31.128190535249736, 0.328847844652414],
            [31.129739628753228, 0.3289813554599],
            [31.131540808390067, 0.331895209118078],
            [31.13424814650179, 0.33324366184812],
            [31.1366607267075, 0.333072317392546],
            [31.138808829418856, 0.336107429541315],
            [31.138715246525834, 0.336807281437506],
            [31.139557524902518, 0.338688294909255],
            [31.139863630327156, 0.339366546109206],
            [31.139307952255347, 0.340333989498449],
            [31.142256011913734, 0.34498244361993],
            [31.14202986463424, 0.345949952916172],
            [31.14234328683684, 0.346519696287326],
            [31.14195655581884, 0.347622811708774],
            [31.14259759719884, 0.349359111644496],
            [31.14313680735486, 0.353600184013206],
            [31.141221965681776, 0.357524264022259],
            [31.138698863950005, 0.358645020706467],
            [31.13808364374451, 0.361104465116601],
            [31.137415499294082, 0.361565495606787],
            [31.136315633501226, 0.363455154713646],
            [31.136086021419658, 0.364838614056235],
            [31.13546751517688, 0.365507630657215],
            [31.135788108630415, 0.366656099711955],
            [31.1344703376008, 0.366257950267258],
            [31.133952558552494, 0.367125922447749],
            [31.13326095100515, 0.367035350769765],
            [31.133107738841858, 0.368156590457751],
            [31.132305544191464, 0.36937715825532],
            [31.130284333005534, 0.370443742594019],
            [31.129251803129776, 0.372450955372242],
            [31.128239199683634, 0.373137966070966],
            [31.127058921198127, 0.375615351753667],
            [31.127033073972477, 0.377025972766749],
            [31.125737832690167, 0.380217684654925],
            [31.125067755065224, 0.380524980762013],
            [31.12469791596781, 0.381293509334656],
            [31.12326584330145, 0.381220853406423],
            [31.123221358728546, 0.381835730297714],
            [31.12407761309444, 0.382459850603394],
            [31.12481206668761, 0.384277549992369],
            [31.12040004686519, 0.391085529845851],
            [31.119348948812497, 0.394421952525137],
            [31.119510862057606, 0.395859737521805],
            [31.11850353980703, 0.397984478863834],
            [31.118503277498977, 0.399132869016314],
            [31.117149569366408, 0.40128465263241],
            [31.11789226320566, 0.403780538492422],
            [31.11672541812692, 0.405037162237391],
            [31.116251263963758, 0.40652905043843],
            [31.1154219357002, 0.407243205657446],
            [31.115421586255536, 0.408735204838794],
            [31.113829044835025, 0.411881585730388],
            [31.113950108989226, 0.413879988905451],
            [31.11518312037854, 0.416511629653261],
            [31.115409164351803, 0.418491975104223],
            [31.11711994023338, 0.420988102615467],
            [31.118083463325675, 0.42136812013724],
            [31.11873474819487, 0.422209226777026],
            [31.117824823982325, 0.42763446351231],
            [31.122774408247157, 0.433947329576262],
            [31.124384541375886, 0.434770598401646],
            [31.126794839860803, 0.437113207495288],
            [31.128494284393398, 0.437746610904995],
            [31.13081618775602, 0.44112005119183],
            [31.132116718318713, 0.441961335304736],
            [31.132418899003905, 0.443580021467936],
            [31.1346165509897, 0.446564615390457],
            [31.137525793546345, 0.448346742210422],
            [31.138206960873458, 0.449775638563182],
            [31.139050372924043, 0.45009234602083],
            [31.14146764233557, 0.45264297113746],
            [31.141766483982813, 0.455220178362295],
            [31.140197472134513, 0.457064448330178],
            [31.14095392816393, 0.459316242537518],
            [31.138753798624574, 0.473223092284495],
            [31.138773579527125, 0.475863519546325],
            [31.14036938362875, 0.480909698926659],
            [31.1410872453386, 0.484590216630558],
            [31.142140463415384, 0.486498488672946],
            [31.144429779492775, 0.492810841821933],
            [31.145276008660083, 0.497115347852472],
            [31.144985795331127, 0.499005161126519],
            [31.141706670557944, 0.499980818416428],
            [31.142177449750577, 0.501798509695396],
            [31.142313316344012, 0.508146197326378],
            [31.138617439754327, 0.513618349408606],
            [31.136003481516425, 0.514449001596163],
            [31.13172790051429, 0.518705228773919],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1562,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "KABWEZA KYEGEGWA",
        Population: 25219,
        Key: "KYEGEGWAKABWEZA KYEGEGWA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [31.114341739418826, 0.326729056303692],
            [31.111037224662415, 0.327577755477481],
            [31.10811970682537, 0.326904815117941],
            [31.107557189879287, 0.327258591963322],
            [31.102389668936638, 0.327823821568634],
            [31.10087798397654, 0.328531306012866],
            [31.100051929173876, 0.32837189450023],
            [31.098927231251622, 0.327486966031824],
            [31.09716966212687, 0.327238902111775],
            [31.09653674421199, 0.328158881391335],
            [31.095517274942136, 0.328441797552407],
            [31.091615405674634, 0.328299485189072],
            [31.089400715342855, 0.328794492789686],
            [31.088328656001316, 0.328422708666238],
            [31.087098810275037, 0.325909897678431],
            [31.083900016447835, 0.325696946500056],
            [31.07715046796674, 0.327641987563553],
            [31.0736528055428, 0.327906720339028],
            [31.071684111665018, 0.328932589421831],
            [31.071648772840067, 0.329888066682182],
            [31.068906916963577, 0.329993683452184],
            [31.06410829098896, 0.332169092764416],
            [31.062772588687945, 0.331850339920658],
            [31.06178854807458, 0.330823897124762],
            [31.060452890689355, 0.330328204221804],
            [31.059538917769828, 0.330469576035719],
            [31.058730345080907, 0.330894066954916],
            [31.056268905506865, 0.335104717578298],
            [31.055671247365193, 0.335564636346846],
            [31.05365007480684, 0.335404990491299],
            [31.048869063896664, 0.337491890035822],
            [31.03496466953613, 0.347724827904131],
            [31.03241569362926, 0.350245630798206],
            [31.029559482217103, 0.351173936913599],
            [31.02430867756612, 0.351814197287489],
            [31.022550964710927, 0.352654261611901],
            [31.021848011441538, 0.352300244054189],
            [31.019475321824338, 0.352343961537586],
            [31.01907955285624, 0.353892059052273],
            [31.017585724607322, 0.353493629679436],
            [31.017058653385735, 0.352653075858193],
            [31.015301069887936, 0.352873872180178],
            [31.00787485104606, 0.355924365866036],
            [31.005677597912243, 0.357527338895625],
            [31.004194701262033, 0.357416424269635],
            [30.998469988586287, 0.359087370323301],
            [30.9978717465397, 0.358817697774036],
            [30.996541938085244, 0.359439907226088],
            [30.996114843964893, 0.360253052472021],
            [30.993145895781204, 0.360541128399764],
            [30.991839923224532, 0.361306794935548],
            [30.990667086382818, 0.361277653268789],
            [30.988418317562417, 0.359132204358504],
            [30.987514915118833, 0.357697890611672],
            [30.98585180923613, 0.356933378984655],
            [30.984485317178734, 0.355654668969858],
            [30.97638454261022, 0.353625387565094],
            [30.970931750869305, 0.350746243555902],
            [30.967867133006163, 0.349767099988622],
            [30.96562152535725, 0.347962714475356],
            [30.961604720242416, 0.343206060773758],
            [30.95985524673501, 0.336691081870904],
            [30.955633403851508, 0.326447070733808],
            [30.953161297681795, 0.32314840131721],
            [30.951486078017467, 0.32194159853435],
            [30.949869291965733, 0.319096904916973],
            [30.949014049102843, 0.318810328815478],
            [30.94742179424491, 0.317280705607704],
            [30.945533082766797, 0.316552209107584],
            [30.94318173352744, 0.316720536448358],
            [30.93966571492898, 0.315430818768705],
            [30.937145824674367, 0.315889279592586],
            [30.935996404217196, 0.316042016919538],
            [30.932171940082792, 0.315302375103519],
            [30.928454193109175, 0.314239881785935],
            [30.926434633925073, 0.313116933542932],
            [30.922931237554664, 0.31305859512443],
            [30.92171949916962, 0.31234178344094],
            [30.920769708623084, 0.312820369057708],
            [30.916043308095624, 0.313109229706095],
            [30.908046312298627, 0.316899364033133],
            [30.90299093613772, 0.311428909211086],
            [30.89946051035875, 0.305608311205176],
            [30.898722170653663, 0.302069980597491],
            [30.89861118649527, 0.295076425171167],
            [30.8983131138059, 0.293080084987174],
            [30.89726663578871, 0.290617823058797],
            [30.89629217570786, 0.289518384580674],
            [30.89444907349334, 0.285490381474369],
            [30.893118061296406, 0.283888996145252],
            [30.88982715960984, 0.281535304006572],
            [30.88844802645979, 0.278905827379696],
            [30.88697456122174, 0.277424070188012],
            [30.886950067757216, 0.276156866637931],
            [30.888386555643212, 0.275427001111513],
            [30.89021525247384, 0.275187117767303],
            [30.890357248272476, 0.274326328721832],
            [30.888488134440603, 0.266616285043714],
            [30.885923421846545, 0.260979862842252],
            [30.880078051055126, 0.254504501690272],
            [30.875870036837114, 0.245792862340138],
            [30.873999633024475, 0.242967394520387],
            [30.872363285259116, 0.238847104872728],
            [30.87084354959743, 0.23672799557082],
            [30.868622192867925, 0.234961927175844],
            [30.8639464573225, 0.22589718899749],
            [30.8632849693883, 0.223411159186554],
            [30.86316756946213, 0.214449789445341],
            [30.862337252153434, 0.21098461781419],
            [30.860082704470802, 0.207519252274815],
            [30.858539958463105, 0.206324196211486],
            [30.857116011058494, 0.204292768951485],
            [30.855691854346386, 0.203814638283851],
            [30.851882736131998, 0.199103192390373],
            [30.849774082936335, 0.199212902074944],
            [30.85937880527544, 0.19933499945156],
            [30.86814819950318, 0.201270944195059],
            [30.870120771408036, 0.201795588516507],
            [30.873376008181204, 0.203531910605882],
            [30.873954137846905, 0.205611437046282],
            [30.874745484441952, 0.206135926717189],
            [30.876765490088747, 0.206687708808213],
            [30.87856724554566, 0.206579461622095],
            [30.879822776800843, 0.207131140392157],
            [30.881624601428033, 0.206525631326824],
            [30.885446493685812, 0.203994628984272],
            [30.8876303978545, 0.20465492604533],
            [30.889159133737003, 0.204266361344922],
            [30.89146934642454, 0.204827224511681],
            [30.89401179247764, 0.200080937067601],
            [30.894946951264814, 0.19976461702889],
            [30.905046396492153, 0.206085776794285],
            [30.90870424559924, 0.207189304129973],
            [30.9120347135825, 0.207298248400014],
            [30.91400013669432, 0.207135768482259],
            [30.917030496405754, 0.205897513585343],
            [30.92139844667697, 0.202543752031566],
            [30.924456083732036, 0.2009528697804],
            [30.927841454050494, 0.199958755255411],
            [30.93111729009144, 0.199633686574888],
            [30.93654961551525, 0.199878502053087],
            [30.946705122802815, 0.197953962088463],
            [30.94834302465362, 0.198071708959468],
            [30.952383210220344, 0.199383241385257],
            [30.95527676190392, 0.19966389673447],
            [30.97146569420282, 0.195949828937028],
            [30.973267681425114, 0.19480176172925],
            [30.977089611412108, 0.193536396696278],
            [30.98197629923399, 0.192958322420918],
            [30.993660665473296, 0.192688480817453],
            [30.9993389972326, 0.193511967151498],
            [31.000791688031377, 0.193837646802142],
            [31.008429299324256, 0.197726560319817],
            [31.01342990430396, 0.198242559419871],
            [31.01932517830607, 0.197438550474148],
            [31.02527254111991, 0.204672825761463],
            [31.027614732034923, 0.209230263877621],
            [31.0281300128684, 0.211680700524843],
            [31.027926840002266, 0.213606610551397],
            [31.024167431860725, 0.222846974753938],
            [31.0232183222372, 0.226101939509058],
            [31.0231992554953, 0.228000742124826],
            [31.029904663458286, 0.234864530854736],
            [31.034940522821316, 0.238590554542538],
            [31.042617955532428, 0.243302570003058],
            [31.050028334380915, 0.247191755362348],
            [31.054772288887317, 0.2512161985139],
            [31.059132492985828, 0.253857158710457],
            [31.061801654494598, 0.256262775594116],
            [31.061739923166588, 0.25981632659728],
            [31.062950127229133, 0.26214938888318],
            [31.06856260439325, 0.267394732361683],
            [31.072138811014074, 0.268742591183951],
            [31.078669512823986, 0.27683643333906],
            [31.083353273918142, 0.278410556088502],
            [31.087151983353362, 0.280418568704573],
            [31.09439220242242, 0.28559197158656],
            [31.09910362983069, 0.28812461941334],
            [31.10152604569049, 0.290855819646115],
            [31.10749324600073, 0.295251436225764],
            [31.110599198045055, 0.299266797604876],
            [31.112229221670816, 0.303688819138498],
            [31.11398887398867, 0.306763552419248],
            [31.115200371625264, 0.308074921144128],
            [31.116005545089138, 0.31033567201006],
            [31.116887810174077, 0.315577745887267],
            [31.116410807453157, 0.316495510108691],
            [31.11548534777611, 0.318721847925986],
            [31.114341739418826, 0.326729056303692],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1565,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "RUYONZA",
        Population: 45618,
        Key: "KYEGEGWARUYONZA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [30.92588726796457, 0.478940227928917],
            [30.92218816911796, 0.480991377162778],
            [30.91491163385691, 0.482616862519162],
            [30.91387202346007, 0.483197872207827],
            [30.91197134193079, 0.478312749647725],
            [30.90706429379296, 0.479201264733801],
            [30.903085931182382, 0.478888522707478],
            [30.899240385384893, 0.477952803653603],
            [30.8978700476398, 0.477907877774316],
            [30.89512913050277, 0.478619045614787],
            [30.894289309018355, 0.478396279278152],
            [30.894156843446567, 0.4779067252759],
            [30.891637570334556, 0.476615412210894],
            [30.89119576899633, 0.475814256736736],
            [30.889339527124168, 0.47465665741416],
            [30.886953320556874, 0.471896862912079],
            [30.88518538487375, 0.471095302664047],
            [30.884169181878274, 0.469448459659434],
            [30.882400803325716, 0.47011542915135],
            [30.878750371607925, 0.46990347160536],
            [30.877786980567972, 0.469462271691596],
            [30.874963863090883, 0.46364150470423],
            [30.874920667600453, 0.461635390427752],
            [30.875766625476544, 0.458032799532216],
            [30.875203234469684, 0.454803260928183],
            [30.87410446012994, 0.454085296038197],
            [30.873867166554355, 0.452978868579949],
            [30.87309522177285, 0.451902184145049],
            [30.868610358462362, 0.451302822551171],
            [30.865801190025, 0.448546970554097],
            [30.866763714190693, 0.447429537329457],
            [30.867534088717097, 0.444261316567617],
            [30.86584547427355, 0.439599560040379],
            [30.86378953871035, 0.436599612457311],
            [30.860748037194412, 0.433827126759861],
            [30.858714330442925, 0.427766821191768],
            [30.852690467997796, 0.421731765389618],
            [30.851656305883147, 0.419735706950223],
            [30.851250836906626, 0.416340768310897],
            [30.852122537803805, 0.402401507742627],
            [30.85281840695888, 0.397059637029748],
            [30.854405714794567, 0.386854612663239],
            [30.858582424521558, 0.379051661977791],
            [30.859494983492823, 0.375498782578384],
            [30.859813390446952, 0.371403290296139],
            [30.85411988165092, 0.361709979555647],
            [30.8535220510327, 0.354178717664979],
            [30.85252216144278, 0.349730334425675],
            [30.852174698480805, 0.344287601232846],
            [30.85044912465154, 0.337560747402495],
            [30.847229561774935, 0.335155139152682],
            [30.84373724702186, 0.33327385191748],
            [30.83382036910469, 0.331445392462743],
            [30.83104021265772, 0.328886221845793],
            [30.83118165509417, 0.326951516870969],
            [30.82511070386016, 0.321923504953497],
            [30.822104183639695, 0.318207096066883],
            [30.821960489126855, 0.316245219031657],
            [30.823372026305837, 0.313216858845844],
            [30.823489079482325, 0.310378079055859],
            [30.822928828985685, 0.306752611095918],
            [30.821074814935425, 0.303931509973728],
            [30.82051435602966, 0.299881134453871],
            [30.818541882939517, 0.297873688516112],
            [30.81433475805363, 0.292068696673105],
            [30.811546710805224, 0.291046545691465],
            [30.81012818922491, 0.286977951462183],
            [30.811397365889235, 0.284736104215268],
            [30.808285190316656, 0.282972568563256],
            [30.80579106104941, 0.282230754215008],
            [30.805659341977638, 0.280540123679101],
            [30.803901025454568, 0.279111363971291],
            [30.802497928845984, 0.275738934790734],
            [30.802332978396883, 0.273126155469422],
            [30.801506581336092, 0.271236506810887],
            [30.80203292582065, 0.269591205895363],
            [30.801807645415355, 0.269220498631821],
            [30.799853850994932, 0.268632498466524],
            [30.798751747498702, 0.267429892937253],
            [30.797789814424476, 0.263903874468615],
            [30.797373293474998, 0.261887741122993],
            [30.793758576077977, 0.259003144004171],
            [30.792829134169267, 0.256552978830579],
            [30.789855736629942, 0.254021095148119],
            [30.78943925340971, 0.251733757879682],
            [30.788437558206088, 0.250015877520699],
            [30.788918765042528, 0.248786443192192],
            [30.788348421973694, 0.244365509903733],
            [30.787090303570505, 0.241318630592367],
            [30.786045424554512, 0.240206469495929],
            [30.7860455934378, 0.23916680621254],
            [30.786980515069743, 0.236499996112789],
            [30.782256716961676, 0.232892057129756],
            [30.78163396348422, 0.231373149604538],
            [30.779791040034457, 0.231662152340019],
            [30.77943690348821, 0.230667639176614],
            [30.778655409615197, 0.230342057318146],
            [30.778194599925584, 0.229573541307661],
            [30.778603176174702, 0.227873990841232],
            [30.77735159481185, 0.227792429848161],
            [30.77283526441527, 0.225549682019869],
            [30.772239072324126, 0.220034905099655],
            [30.771442788588303, 0.219166899958884],
            [30.77208388027397, 0.216319250292484],
            [30.77120186761561, 0.213498495464668],
            [30.771409674890293, 0.212504075401665],
            [30.773122993902454, 0.210831840572277],
            [30.771981318719654, 0.207540944649994],
            [30.76923028026434, 0.205081547619583],
            [30.768539982460656, 0.202794216037199],
            [30.770461884891898, 0.204485052114587],
            [30.775771459125398, 0.205453136047128],
            [30.77888596672444, 0.208590634409509],
            [30.782026925217057, 0.209278166220671],
            [30.784445641814504, 0.209341798857526],
            [30.790875540971424, 0.211268368533209],
            [30.79184276961424, 0.210970169409128],
            [30.792201931336187, 0.210292177716325],
            [30.794538208641708, 0.210030336742148],
            [30.797800204339037, 0.208349250605615],
            [30.8073625711125, 0.20729285135711],
            [30.810355745961083, 0.206624262110715],
            [30.817683689110925, 0.204202372058808],
            [30.827314312574615, 0.199403038337611],
            [30.83189882869451, 0.197975204423197],
            [30.837706746026782, 0.19797597876634],
            [30.842754921292386, 0.199737938125393],
            [30.849774082936335, 0.199212902074944],
            [30.851882736131998, 0.199103192390373],
            [30.855691854346386, 0.203814638283851],
            [30.857116011058494, 0.204292768951485],
            [30.858539958463105, 0.206324196211486],
            [30.860082704470802, 0.207519252274815],
            [30.862337252153434, 0.21098461781419],
            [30.86316756946213, 0.214449789445341],
            [30.8632849693883, 0.223411159186554],
            [30.8639464573225, 0.22589718899749],
            [30.868622192867925, 0.234961927175844],
            [30.87084354959743, 0.23672799557082],
            [30.872363285259116, 0.238847104872728],
            [30.873999633024475, 0.242967394520387],
            [30.875870036837114, 0.245792862340138],
            [30.880078051055126, 0.254504501690272],
            [30.885923421846545, 0.260979862842252],
            [30.888488134440603, 0.266616285043714],
            [30.890357248272476, 0.274326328721832],
            [30.89021525247384, 0.275187117767303],
            [30.888386555643212, 0.275427001111513],
            [30.886950067757216, 0.276156866637931],
            [30.88697456122174, 0.277424070188012],
            [30.88844802645979, 0.278905827379696],
            [30.88982715960984, 0.281535304006572],
            [30.893118061296406, 0.283888996145252],
            [30.89444907349334, 0.285490381474369],
            [30.89629217570786, 0.289518384580674],
            [30.89726663578871, 0.290617823058797],
            [30.8983131138059, 0.293080084987174],
            [30.89861118649527, 0.295076425171167],
            [30.898722170653663, 0.302069980597491],
            [30.89946051035875, 0.305608311205176],
            [30.90299093613772, 0.311428909211086],
            [30.908046312298627, 0.316899364033133],
            [30.916043308095624, 0.313109229706095],
            [30.920769708623084, 0.312820369057708],
            [30.92171949916962, 0.31234178344094],
            [30.922931237554664, 0.31305859512443],
            [30.926434633925073, 0.313116933542932],
            [30.928454193109175, 0.314239881785935],
            [30.932171940082792, 0.315302375103519],
            [30.935996404217196, 0.316042016919538],
            [30.937145824674367, 0.315889279592586],
            [30.93701322794854, 0.318498580504065],
            [30.9392112311756, 0.333397225348979],
            [30.938557970012784, 0.333960686750428],
            [30.937298269676408, 0.334289184284293],
            [30.926894921693506, 0.333159767805748],
            [30.92493593501072, 0.331139800593089],
            [30.922649997497114, 0.330951450378139],
            [30.920130623773765, 0.331608438448911],
            [30.918824767998085, 0.329635584980305],
            [30.91779845446407, 0.32944750422699],
            [30.91565234691096, 0.32991670809192],
            [30.91070720661181, 0.32991565438556],
            [30.90986738782238, 0.330291201433537],
            [30.910333073567333, 0.334236428922075],
            [30.911032606052146, 0.335410726136087],
            [30.91285071713544, 0.341563650857793],
            [30.91457623976074, 0.344381987311887],
            [30.915741105850902, 0.350910516290666],
            [30.917456870975595, 0.352695036268502],
            [30.921416322252806, 0.354980642735624],
            [30.923893753635515, 0.356962844052475],
            [30.925792617872993, 0.357289666363693],
            [30.92718169537324, 0.359015178633027],
            [30.929010888972197, 0.360227899242939],
            [30.928384763219178, 0.364004532609837],
            [30.929125157371285, 0.366848946984605],
            [30.931000566596683, 0.368481331011246],
            [30.932968047748822, 0.37251503174569],
            [30.934403687625192, 0.373168152417561],
            [30.93486655535512, 0.374403880964999],
            [30.935885517076816, 0.374357496547228],
            [30.93583881636015, 0.37598943453058],
            [30.93672385095111, 0.377658652381764],
            [30.933869191827768, 0.377372779629548],
            [30.928537683430008, 0.378845224657602],
            [30.924808302375144, 0.37820102987627],
            [30.921757432329112, 0.376493770196538],
            [30.92244541337768, 0.379348811877613],
            [30.921914157803485, 0.383618959539389],
            [30.92262664758793, 0.385956744497793],
            [30.921565623151338, 0.388312496503317],
            [30.92456246132965, 0.395049984869661],
            [30.92419519321056, 0.401381692556948],
            [30.924743102651817, 0.403737852508346],
            [30.926387616103128, 0.407695658556175],
            [30.926441020048436, 0.413272817253441],
            [30.92603861612365, 0.413898529649149],
            [30.921796808182954, 0.413897403191182],
            [30.916768192834382, 0.416270479690307],
            [30.913629385806885, 0.419508259620308],
            [30.911584798660652, 0.42333519750164],
            [30.909395818112305, 0.433764497115018],
            [30.9085398979197, 0.435486624865564],
            [30.90844421027394, 0.437783087729048],
            [30.908491588320327, 0.438309379102731],
            [30.909774433750023, 0.439457988818961],
            [30.910581440675404, 0.442711582278135],
            [30.912243834194108, 0.446156799813739],
            [30.912814077549964, 0.446348338178817],
            [30.9142613533042, 0.454155722642615],
            [30.91334406919454, 0.45530370287727],
            [30.911471209387937, 0.45564875284112],
            [30.909835390730265, 0.458959047916994],
            [30.908865744721023, 0.459437195904497],
            [30.90850424198944, 0.460508784132216],
            [30.906146494948658, 0.462268722541737],
            [30.905024448853137, 0.463837651709802],
            [30.905461273524644, 0.46519653619037],
            [30.909332562343252, 0.470419994486005],
            [30.910259391951108, 0.472625765308434],
            [30.91073902314257, 0.472980078437059],
            [30.911030590232624, 0.474918928624273],
            [30.912733000104, 0.474854380600084],
            [30.915261292301466, 0.475703653683852],
            [30.91687037170637, 0.475704145943661],
            [30.922923981862144, 0.47439466825542],
            [30.92384318207828, 0.475320591103334],
            [30.92588726796457, 0.478940227928917],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1568,
        District: "KYEGEGWA",
        County: "KYAKA",
        Subcounty: "RWENTUHA",
        Population: 36378,
        Key: "KYEGEGWARWENTUHA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.26631165591435, 1.376522023000787],
            [34.26593383079404, 1.37691431091243],
            [34.265063358792155, 1.376736767948901],
            [34.26488144904883, 1.376006094236848],
            [34.26409458055547, 1.375495912922494],
            [34.26421986319824, 1.374760389324192],
            [34.26264622682288, 1.373927399372618],
            [34.26349084081932, 1.37338488306388],
            [34.26243610728467, 1.372653345292759],
            [34.26226802261353, 1.371655649900069],
            [34.2633340883955, 1.372039205897688],
            [34.264069216623426, 1.371523525825646],
            [34.26360782572383, 1.370376085920275],
            [34.26123450189601, 1.371201808227094],
            [34.26036329866549, 1.369628299552621],
            [34.260660425428846, 1.368180650147891],
            [34.26111217830378, 1.368705067257309],
            [34.26185649360209, 1.367955162744674],
            [34.262545291219254, 1.367847056164344],
            [34.26245164364751, 1.36677905326962],
            [34.26210709392198, 1.36654501440944],
            [34.26163727502838, 1.367074604699536],
            [34.2610832049409, 1.366704827735978],
            [34.26106908611959, 1.367418654896795],
            [34.26051096552853, 1.367192312469305],
            [34.25999448005421, 1.367487704891811],
            [34.25998475489297, 1.36669135504387],
            [34.26064982351187, 1.365707270862994],
            [34.25975655855629, 1.365653302838523],
            [34.26052999094792, 1.364815404514881],
            [34.25988068327067, 1.363482568404415],
            [34.25900116972544, 1.363810944362488],
            [34.25849830181255, 1.363445821546839],
            [34.25774907991613, 1.363713230853928],
            [34.25676214493091, 1.36333431021448],
            [34.256878334826396, 1.363006338318874],
            [34.25800013568184, 1.363169702813999],
            [34.258170382597854, 1.36274215836142],
            [34.257705493658555, 1.361819256601587],
            [34.25793396757464, 1.361235061203475],
            [34.25691451447446, 1.360973268998331],
            [34.25710972287729, 1.360439139458028],
            [34.25642982217472, 1.359750883450279],
            [34.25659257085306, 1.359450992581686],
            [34.25736060706479, 1.359563016887309],
            [34.25723000998876, 1.359033741961276],
            [34.25568856743655, 1.357427785489709],
            [34.25507436861556, 1.357784125261506],
            [34.254445677274056, 1.357114577850144],
            [34.25320301348703, 1.357241707688148],
            [34.252814824503304, 1.356172908001065],
            [34.25301125102163, 1.355433608417605],
            [34.25216872470992, 1.355284145429617],
            [34.25179099930262, 1.353888374882833],
            [34.25222296408847, 1.352145532810694],
            [34.25106285817098, 1.349888227056455],
            [34.25158369598284, 1.348997910324605],
            [34.250391716042444, 1.348113165770466],
            [34.249274792140675, 1.348376072967646],
            [34.2482599186518, 1.347959680789212],
            [34.24764052756845, 1.34726201668154],
            [34.24773316812875, 1.346385973768637],
            [34.24736517237431, 1.345800606265845],
            [34.24553110271998, 1.345342473259178],
            [34.24498219704708, 1.345961105289717],
            [34.24426987973918, 1.345582030100549],
            [34.24490271500906, 1.345258476989829],
            [34.24433894670978, 1.344649855544197],
            [34.244497037623375, 1.34379244660896],
            [34.24594024041611, 1.344456898461273],
            [34.24647533269491, 1.344133394595136],
            [34.245930232285545, 1.34307967040907],
            [34.247051557932195, 1.342320209692978],
            [34.24675344122538, 1.341856602303292],
            [34.24610651228701, 1.341922516072124],
            [34.24566848566965, 1.340910896013895],
            [34.246533904648054, 1.340320209729875],
            [34.24700405591832, 1.340432395671392],
            [34.246808051608156, 1.33940659806702],
            [34.247985163532256, 1.338264795403079],
            [34.246858168617855, 1.336842221172518],
            [34.24663256392075, 1.335480598215779],
            [34.24432127505152, 1.33541955720864],
            [34.24403094045002, 1.334945850598622],
            [34.24412588788397, 1.334615539890241],
            [34.24535288954404, 1.334691496089871],
            [34.245923377241596, 1.334308291618897],
            [34.24568933826234, 1.332302906571202],
            [34.244665540011134, 1.329656544335265],
            [34.244969614344896, 1.329082020672286],
            [34.24607763234895, 1.328980942485889],
            [34.24506427880953, 1.328186914139467],
            [34.24577990640927, 1.327369315579914],
            [34.24655229046698, 1.327171440183046],
            [34.24572387579004, 1.325314734634135],
            [34.245884951805316, 1.324084546739039],
            [34.2448518128718, 1.321758875172377],
            [34.245127477984724, 1.32143326053891],
            [34.245974280277196, 1.322026346516734],
            [34.246487795921134, 1.321839416446351],
            [34.246673039312526, 1.321384614435209],
            [34.246220579463476, 1.320035076463138],
            [34.2476340821563, 1.318478710531262],
            [34.24719408912677, 1.318276696982266],
            [34.24660145166921, 1.318896760159005],
            [34.24620170945261, 1.31883765050687],
            [34.24660671400014, 1.317852798070513],
            [34.246325608689844, 1.317494277355243],
            [34.24475122222122, 1.318560765171967],
            [34.244244031615196, 1.318534155137967],
            [34.24201805934174, 1.315490433270595],
            [34.242834662070976, 1.313316655710511],
            [34.24165145507764, 1.312565788554253],
            [34.241736644112684, 1.311732909417862],
            [34.24106091877955, 1.310871692880436],
            [34.24197377868645, 1.310421312812872],
            [34.24278623569065, 1.30888925463301],
            [34.241535445743544, 1.308770219396253],
            [34.2419039409613, 1.308233298058872],
            [34.24172942614937, 1.30759189741592],
            [34.24007416345739, 1.307046442255508],
            [34.24091023178054, 1.306383323895586],
            [34.2415598691395, 1.306580019965392],
            [34.242029399673896, 1.305980227934575],
            [34.24133623983773, 1.304171122953043],
            [34.241618254243086, 1.302867209988624],
            [34.241379902452124, 1.302487481588786],
            [34.242071371658916, 1.302241972577768],
            [34.241931061099734, 1.301457334168026],
            [34.24133468934554, 1.301009859510387],
            [34.241692938379174, 1.300245439282035],
            [34.24134721904713, 1.29920435766706],
            [34.24050620460003, 1.298986344089599],
            [34.240452633568054, 1.298610242469269],
            [34.24183140469707, 1.297821483415686],
            [34.24233879293245, 1.29826004694394],
            [34.24253414147246, 1.297436052315369],
            [34.243397356883484, 1.297704286933658],
            [34.243574896322976, 1.296853433988668],
            [34.24285396686644, 1.29642393099954],
            [34.243280464505446, 1.295205783921802],
            [34.243048737789714, 1.294417821307931],
            [34.24363559279179, 1.293602588955825],
            [34.243110008281974, 1.292340134309761],
            [34.24450778506745, 1.29102061457301],
            [34.24496355700494, 1.29152502971687],
            [34.24528074225029, 1.291378062253894],
            [34.244893834264154, 1.290629519100023],
            [34.24501372611694, 1.289711894554236],
            [34.24575018564809, 1.289384877447308],
            [34.246052554081146, 1.288764454052751],
            [34.24542529285759, 1.288680347207821],
            [34.24525354036518, 1.287939038260146],
            [34.24588444425719, 1.28801580325764],
            [34.24601175439758, 1.287355093972248],
            [34.24640581476999, 1.287817351778105],
            [34.2472663549981, 1.287688468009643],
            [34.24658408453982, 1.286965763578632],
            [34.24698863274318, 1.286499440868278],
            [34.2465981826999, 1.285960105231517],
            [34.24672553326445, 1.285383811312837],
            [34.247436661202926, 1.285460536871268],
            [34.24820103139, 1.284697220203451],
            [34.2492236771027, 1.284721616804013],
            [34.2490831365748, 1.284020293253023],
            [34.25057951603911, 1.283899336731147],
            [34.25050477351251, 1.282010867018768],
            [34.2500634222303, 1.281733017585507],
            [34.25036012768378, 1.28134689790757],
            [34.25016945307819, 1.280579762227837],
            [34.24967557999625, 1.281255928507473],
            [34.24922608997753, 1.281202196639314],
            [34.24988111273662, 1.279931895520174],
            [34.24870568335705, 1.279463494242256],
            [34.248523833800824, 1.278608629717571],
            [34.24970612361423, 1.27621335091321],
            [34.24921561831627, 1.276612015916948],
            [34.247974236425165, 1.276189297303009],
            [34.24957797534569, 1.275553522305716],
            [34.248979857266605, 1.275122189011443],
            [34.249548695657325, 1.274694433647338],
            [34.24917328610682, 1.274341845911661],
            [34.249807873091534, 1.273445079136287],
            [34.24985699656451, 1.272702159092274],
            [34.24934545002767, 1.272220979316733],
            [34.250384402857705, 1.271867699710391],
            [34.249472580505, 1.270772477480509],
            [34.248990283113784, 1.271088132477072],
            [34.24872609847019, 1.270507225301898],
            [34.24911737406524, 1.269556624495954],
            [34.24925374910513, 1.270179097497253],
            [34.24985570029557, 1.27001279283323],
            [34.25023458273296, 1.269016546169736],
            [34.24955400649727, 1.268156322837141],
            [34.24914144532159, 1.268162125430569],
            [34.249677194268834, 1.267526874739664],
            [34.24933460287062, 1.26681734868375],
            [34.2502292260789, 1.266451689884173],
            [34.24983701982922, 1.26546411925577],
            [34.250376424919686, 1.263853557474233],
            [34.25117200257969, 1.263321938032647],
            [34.25223484071482, 1.263835158166146],
            [34.25143160940861, 1.262960739588587],
            [34.25260205493498, 1.261656991527204],
            [34.25342685658783, 1.261876553905201],
            [34.25368276056115, 1.262395211404823],
            [34.254152728575065, 1.262166719288926],
            [34.25411122281567, 1.261602304573415],
            [34.2529850768092, 1.260693947026073],
            [34.253629844401026, 1.26047066911728],
            [34.253553679841325, 1.259780615494274],
            [34.254181695649734, 1.260180626583862],
            [34.25513706473418, 1.259717592353854],
            [34.254642003181104, 1.259207353094694],
            [34.25488472707254, 1.258036863948458],
            [34.25538785190362, 1.258165277697217],
            [34.25589069556199, 1.257704356335923],
            [34.25657119274593, 1.257965491141561],
            [34.25671582509991, 1.258612859519288],
            [34.25722714076977, 1.258625061984303],
            [34.257300654401035, 1.257147538571876],
            [34.25673117730814, 1.256230610706367],
            [34.25757245136833, 1.256412813508419],
            [34.25767535518077, 1.256030940755638],
            [34.25713089527021, 1.25569088436091],
            [34.257349188579184, 1.25516784729147],
            [34.25707278235618, 1.254889915045021],
            [34.256483158746384, 1.254956605243531],
            [34.25588148064383, 1.255683189443871],
            [34.25597589717343, 1.254799140500858],
            [34.25716739561685, 1.254416740327662],
            [34.256470288583294, 1.25391074804663],
            [34.25651537502742, 1.253342142805427],
            [34.255694342705524, 1.252371381450749],
            [34.25685261875475, 1.251499269846117],
            [34.25639315114817, 1.24979332285666],
            [34.25759222508437, 1.24943369062771],
            [34.26074542042778, 1.25209447004807],
            [34.2641064553852, 1.253026309627304],
            [34.266871429405526, 1.254789935875322],
            [34.274513799972794, 1.262773422581265],
            [34.27588204015171, 1.264896690347162],
            [34.27719360651767, 1.27264394465965],
            [34.27874063569263, 1.275664553501379],
            [34.282813837041004, 1.278294994553096],
            [34.2897624836301, 1.279101193403747],
            [34.291216561427696, 1.280464659300281],
            [34.29642435743778, 1.282533904947338],
            [34.29809634496372, 1.285448466552267],
            [34.29946361586046, 1.287173486093148],
            [34.29987549611317, 1.287154930684378],
            [34.29950754976604, 1.287783635743945],
            [34.29954355514097, 1.288523564375365],
            [34.30016668591084, 1.288993582347367],
            [34.298937475293506, 1.289555003116714],
            [34.29853537769423, 1.290776282740443],
            [34.29763094937459, 1.291608885901479],
            [34.297263062316304, 1.293834140749132],
            [34.29684431264659, 1.294340875988486],
            [34.293217020632206, 1.293212119846627],
            [34.28957591073213, 1.294751639869789],
            [34.289776903387036, 1.29679570866472],
            [34.289289902417025, 1.297845180282167],
            [34.28758785097345, 1.298605835568337],
            [34.28544891287464, 1.300669199273795],
            [34.28473673480559, 1.300723835100962],
            [34.285173553188926, 1.301501483056745],
            [34.2841335852626, 1.302008538273533],
            [34.283651842131924, 1.304568529851865],
            [34.282423622356326, 1.30490382711165],
            [34.28240080604642, 1.305319910411588],
            [34.2832397211307, 1.305970720839194],
            [34.28213427949489, 1.306957198991923],
            [34.28192908182611, 1.307698997207877],
            [34.28133423181803, 1.307635988719785],
            [34.282345861490384, 1.309932906139252],
            [34.28205896204651, 1.310168224778223],
            [34.28219960049076, 1.311696763498848],
            [34.281347693970865, 1.312013779392258],
            [34.281233881017634, 1.312420865449046],
            [34.28241120853741, 1.313614201041591],
            [34.28160762149831, 1.313958327903133],
            [34.28182928348963, 1.314663725808679],
            [34.28316580595249, 1.315223825175518],
            [34.2834747069343, 1.316272888551673],
            [34.283977006213625, 1.31658015881848],
            [34.283532471302024, 1.317195451827749],
            [34.2838219165714, 1.317548056947643],
            [34.28436903908846, 1.317638223057266],
            [34.28507415190777, 1.316941389166601],
            [34.28574680859591, 1.317574191010966],
            [34.28455587159955, 1.319419996101838],
            [34.28521086112098, 1.320649777683909],
            [34.28471091902098, 1.320559588333428],
            [34.28438546119016, 1.321174819289629],
            [34.28268693473577, 1.322261108105535],
            [34.284269251531754, 1.324557720180685],
            [34.28359536325338, 1.325896736542965],
            [34.28374687041425, 1.326701664656622],
            [34.282328387461476, 1.327335558765591],
            [34.28190681977674, 1.328918660179913],
            [34.28094346646606, 1.329877938277176],
            [34.28109027723463, 1.330284887593881],
            [34.28036626116677, 1.33136162679546],
            [34.28108845994281, 1.332202436511841],
            [34.279979485232985, 1.332881395370682],
            [34.280072009012294, 1.334753670481385],
            [34.279518980072254, 1.336282573037769],
            [34.27820011579294, 1.337314400696837],
            [34.278327451086135, 1.338074118017227],
            [34.27801458494067, 1.338429877773719],
            [34.27787007026598, 1.338834142242255],
            [34.27702686303127, 1.338608459025362],
            [34.27710762876184, 1.339467696451426],
            [34.277683635708534, 1.340001051075363],
            [34.27839521639791, 1.33985595624925],
            [34.27865698457338, 1.340977404330014],
            [34.27694758760575, 1.342787314073861],
            [34.276070245288565, 1.342958810145008],
            [34.27598550900446, 1.344045083066788],
            [34.27498159496207, 1.343701899776419],
            [34.2747711205893, 1.344009542918224],
            [34.2750163741366, 1.344696837966522],
            [34.275922533509764, 1.344994847409842],
            [34.275714395655086, 1.345474344612231],
            [34.274722740921355, 1.346026615715473],
            [34.274317730983945, 1.345963513906549],
            [34.27392685334258, 1.344995898149171],
            [34.27251837313049, 1.345448893376069],
            [34.2740553366827, 1.346877203944024],
            [34.27333370115034, 1.348216253041219],
            [34.27282786520375, 1.347610500759461],
            [34.27249711360098, 1.347773486410973],
            [34.27228543548576, 1.350080089864901],
            [34.2717170947617, 1.350252245501387],
            [34.27172415462149, 1.35086730647352],
            [34.27080443607742, 1.351500947364795],
            [34.271278411475826, 1.352405203843366],
            [34.27057270666673, 1.353056821794661],
            [34.27020953396705, 1.352441948174623],
            [34.269760284696815, 1.352641177608233],
            [34.27045891796799, 1.353509135685538],
            [34.27038637631389, 1.355499089849957],
            [34.269797964531406, 1.355960700040762],
            [34.270453549635874, 1.35720857274598],
            [34.269959501382424, 1.357670133217161],
            [34.2698409857487, 1.358746560386938],
            [34.268896497957265, 1.359280720835945],
            [34.269472502209034, 1.359795984139774],
            [34.269485455915415, 1.360935657268906],
            [34.27041284607202, 1.360998480289064],
            [34.27051955065642, 1.362038606330022],
            [34.27012627900481, 1.362943323166001],
            [34.26967468243677, 1.362952608220059],
            [34.26973127450305, 1.363757589671023],
            [34.26879266708348, 1.365865592567536],
            [34.268084575450665, 1.366254907851522],
            [34.2681948274821, 1.367629701555578],
            [34.2670864124227, 1.368335807827064],
            [34.26797667071705, 1.369348382741985],
            [34.267910638255444, 1.36981876251471],
            [34.26886573065881, 1.370216236017944],
            [34.268300917618845, 1.370695926688085],
            [34.26870948129153, 1.371093691914577],
            [34.268710078671205, 1.372224326122979],
            [34.26854736323052, 1.372559080685307],
            [34.26797250882233, 1.372107134085496],
            [34.26749968865736, 1.372351604239819],
            [34.268138765421874, 1.374223593827158],
            [34.26808274737904, 1.37557134068105],
            [34.26675504367736, 1.375852450280041],
            [34.26631165591435, 1.376522023000787],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1849,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BUKHALU",
        Population: 28044,
        Key: "BULAMBULIBUKHALU",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.39389621634299, 1.56272388306511],
            [34.39589917915222, 1.563775793213221],
            [34.39578064645047, 1.564254248063625],
            [34.39490125148285, 1.564326595658775],
            [34.39414033801304, 1.563872654799624],
            [34.39387896329963, 1.564016338887612],
            [34.394093206105026, 1.564494570086037],
            [34.39354662257713, 1.564662369393661],
            [34.39304706046446, 1.564040818737131],
            [34.39093235711538, 1.565166416475672],
            [34.38964817319591, 1.56418660947597],
            [34.38917326624455, 1.564904485533867],
            [34.38876862461638, 1.564043686887208],
            [34.38760467031624, 1.565144715887794],
            [34.38690333670932, 1.564941889104468],
            [34.38628563356038, 1.565396753753663],
            [34.385833506087984, 1.564607745248683],
            [34.38490684536338, 1.565110642929207],
            [34.384050420317614, 1.564010967167528],
            [34.38336139363006, 1.56444195651487],
            [34.38319456300707, 1.563748429046475],
            [34.38212511416977, 1.564012256667686],
            [34.38164952899033, 1.56370162808601],
            [34.38126942933574, 1.564012824191445],
            [34.38100754348099, 1.563367196678815],
            [34.37929612350732, 1.563320484609994],
            [34.378725006090725, 1.562316289371226],
            [34.37820214257792, 1.562412308718519],
            [34.378012386948875, 1.563010399204449],
            [34.37708526988011, 1.56281966442879],
            [34.376598275198276, 1.56326248491969],
            [34.37626533529947, 1.562999606370196],
            [34.37571882633176, 1.563263074893154],
            [34.374411204468224, 1.562809483118692],
            [34.374577193369795, 1.562187483820805],
            [34.37315110527983, 1.562308020758962],
            [34.37182028981396, 1.562715525554348],
            [34.37172544658458, 1.563050447362962],
            [34.37141629048126, 1.562835379996502],
            [34.37117918914515, 1.563744447399867],
            [34.370846248348016, 1.563481559930932],
            [34.370513658792184, 1.563744885614491],
            [34.370252029855564, 1.563505882640058],
            [34.37063204237357, 1.563027253410737],
            [34.36951473219625, 1.562812716748737],
            [34.36899136293194, 1.562119419523356],
            [34.36832601493695, 1.562430800847456],
            [34.36711362796826, 1.562192411044762],
            [34.36664990055061, 1.561845898851496],
            [34.36650672975558, 1.560984915762735],
            [34.363677755262806, 1.560317047892537],
            [34.36372481800055, 1.559599440559772],
            [34.36305921398574, 1.559504210410695],
            [34.362440467892775, 1.558356512970807],
            [34.36163300552154, 1.559433390117841],
            [34.35992195385715, 1.559960724035015],
            [34.35970870099522, 1.561013291093126],
            [34.3583543909914, 1.561851330741897],
            [34.3583784703326, 1.562329706110463],
            [34.357807996109756, 1.562330077874743],
            [34.35733321941411, 1.563263227549922],
            [34.35694090626492, 1.563084091120101],
            [34.35520648403008, 1.564233334995214],
            [34.3521170843432, 1.565239947577157],
            [34.3519035862412, 1.565885904969919],
            [34.35026351855226, 1.565958731132043],
            [34.348909481636284, 1.567227315774713],
            [34.34755497220652, 1.567802254090937],
            [34.34682965268316, 1.567264545993875],
            [34.34568871501721, 1.567265285030779],
            [34.344048134390256, 1.566500946523707],
            [34.34238423709178, 1.566478108209545],
            [34.34221769662462, 1.566239028320354],
            [34.343405652112516, 1.56542501228699],
            [34.34328528505097, 1.563033185473492],
            [34.33999125093899, 1.559985627779466],
            [34.339324666862225, 1.558335633967087],
            [34.338587590188425, 1.558001242115693],
            [34.33704280500505, 1.558384942215599],
            [34.336495956474145, 1.558146103860806],
            [34.336186432061545, 1.557333051820761],
            [34.334950097804, 1.556831540562704],
            [34.334069994065636, 1.555827500272712],
            [34.33281000896331, 1.555517343720433],
            [34.33001609032621, 1.55392851624645],
            [34.32932641595331, 1.553378813806334],
            [34.328065114819104, 1.550963778330441],
            [34.32685278444427, 1.55084494601961],
            [34.323312172668274, 1.552545460069042],
            [34.3227294023058, 1.551888053754293],
            [34.3215882319762, 1.551506068524455],
            [34.32094699476343, 1.552391480691942],
            [34.31966369568454, 1.55282283879524],
            [34.31892668189284, 1.55256019870518],
            [34.3170015176788, 1.552872360893115],
            [34.31590782151531, 1.55239465686693],
            [34.31538525534487, 1.552992965713048],
            [34.31395896603229, 1.552826440614668],
            [34.312283691570734, 1.553604876169528],
            [34.309074754865634, 1.553606892145958],
            [34.30869450070081, 1.553702805928022],
            [34.308789811054154, 1.554061538340842],
            [34.307339464858266, 1.55344053681518],
            [34.306864548923734, 1.554230178994029],
            [34.3056753869984, 1.553130630450132],
            [34.30408270813564, 1.552988106714447],
            [34.29929420347935, 1.55479701924779],
            [34.29689203474777, 1.55252615787039],
            [34.295014084188416, 1.552312041294441],
            [34.289247927737044, 1.549122354492386],
            [34.28606252868902, 1.548741597209919],
            [34.28437412265463, 1.547522728403685],
            [34.28430253051975, 1.547068299913356],
            [34.283922301507744, 1.547212056984738],
            [34.28348228691868, 1.54674588723521],
            [34.282864470582005, 1.547105058147019],
            [34.282198709362014, 1.546770593578075],
            [34.28172374402014, 1.547488472868872],
            [34.28079684254705, 1.547704315864699],
            [34.28048759930715, 1.547297870490523],
            [34.27948926470096, 1.547322401719365],
            [34.27889469137399, 1.546772612254989],
            [34.278324356389966, 1.547012153223359],
            [34.2773019181881, 1.546486546497706],
            [34.27492524723753, 1.547038148175685],
            [34.27447345483676, 1.546775302626924],
            [34.27409349531934, 1.547373533139835],
            [34.27348702470474, 1.546811790571266],
            [34.27163313641861, 1.54709994590237],
            [34.27163416409129, 1.548822164613198],
            [34.2721576869675, 1.549802559752111],
            [34.270257278526074, 1.551812983038896],
            [34.26858333626608, 1.554911610155597],
            [34.26841801481276, 1.556681771246055],
            [34.26772884708973, 1.556969232886916],
            [34.26749220569108, 1.558739438046761],
            [34.26525783147476, 1.558788641221817],
            [34.26487791058493, 1.559458627020087],
            [34.2633799446958, 1.558741938929081],
            [34.262286504552186, 1.558718684764462],
            [34.262572108625434, 1.559316505110288],
            [34.26185903763097, 1.559388700218421],
            [34.2617642824365, 1.559938911145564],
            [34.261241428805164, 1.560082753547402],
            [34.26143195069714, 1.560680631874545],
            [34.260956552367325, 1.56070484416431],
            [34.26037475577861, 1.561650021229294],
            [34.259566476838806, 1.561530916534202],
            [34.258877399845616, 1.561961893818823],
            [34.25600078859163, 1.561293880785959],
            [34.25066468890444, 1.562019725622509],
            [34.22956819013982, 1.561541322345902],
            [34.23011060817975, 1.496127816696388],
            [34.2290563166162, 1.484143513948053],
            [34.22687281938434, 1.475904545028944],
            [34.22725725341019, 1.47526212134605],
            [34.227126983320936, 1.473308427690139],
            [34.228466609463105, 1.472104669739652],
            [34.229264880272346, 1.468106244651612],
            [34.230652211447676, 1.466830101615424],
            [34.23049779015202, 1.464876423031383],
            [34.23230645006023, 1.464694517054264],
            [34.23263802721477, 1.464983779727047],
            [34.23333247164178, 1.464232642856099],
            [34.23412538849192, 1.464820140418618],
            [34.23469973714861, 1.464277110208959],
            [34.23508986469673, 1.462757301851677],
            [34.23694622604484, 1.462503005199904],
            [34.2370961575607, 1.461390364737832],
            [34.23988886526878, 1.459078347410165],
            [34.24090881244239, 1.458859131654029],
            [34.241616516901296, 1.458227124649135],
            [34.24224423357071, 1.458453507598534],
            [34.24277591225141, 1.459619266725273],
            [34.24354829630909, 1.459554056725838],
            [34.243597169152146, 1.460639106328756],
            [34.244868309533665, 1.460395468975999],
            [34.245898390601994, 1.460734993672882],
            [34.24618857428651, 1.461690346638965],
            [34.24739612652236, 1.462855723324847],
            [34.2477178419717, 1.462628811883632],
            [34.248796244317475, 1.463049282190275],
            [34.25021308155663, 1.464376489804823],
            [34.25201720946421, 1.467638798041592],
            [34.25277372568073, 1.467978468018656],
            [34.253160514190945, 1.469014739381493],
            [34.25412659299022, 1.47000209513429],
            [34.254288267283464, 1.471352679449148],
            [34.2554959659447, 1.472760970515899],
            [34.25686281463324, 1.473745010923532],
            [34.25889526643829, 1.474506924401705],
            [34.26001858095497, 1.476551314030488],
            [34.26004947761088, 1.477558549428539],
            [34.260762729166686, 1.478489088397965],
            [34.26150600691085, 1.478885460149467],
            [34.2622649171376, 1.480105937274856],
            [34.26378156888292, 1.480486600651916],
            [34.264707132764556, 1.48143227443649],
            [34.265632191792996, 1.481492788974294],
            [34.26845506582664, 1.48552931962614],
            [34.27098810741703, 1.486565624111388],
            [34.2728226711448, 1.485999888457037],
            [34.27421788503673, 1.486166953923411],
            [34.27615945608112, 1.48709676278269],
            [34.277964088841934, 1.487233062252161],
            [34.27861553091629, 1.486149128363209],
            [34.27864504057337, 1.48472980920316],
            [34.28008409314952, 1.482027720282557],
            [34.281115114753916, 1.48176767763568],
            [34.282888409786025, 1.480164206810021],
            [34.28432873168166, 1.479675005605958],
            [34.28531378110307, 1.478590880330099],
            [34.284516760748716, 1.477560068872612],
            [34.28490897687986, 1.476976649864794],
            [34.28567540870048, 1.477013828659306],
            [34.2856937127727, 1.476336564030176],
            [34.285076359068434, 1.475490356977914],
            [34.2853936619931, 1.474662417979203],
            [34.28520611711798, 1.473590210552039],
            [34.287429112374554, 1.471049218120508],
            [34.28754066426822, 1.469995649149265],
            [34.28912943905276, 1.469787785430382],
            [34.2896698304934, 1.46682637482859],
            [34.290211663730055, 1.466374557110404],
            [34.290922293103534, 1.466900895297237],
            [34.292025060454755, 1.466712128604442],
            [34.29241705739697, 1.46575246009131],
            [34.29305246184858, 1.465488714797573],
            [34.2940999935896, 1.466767356893049],
            [34.29544551717161, 1.466145759282926],
            [34.296174817129966, 1.466634458769894],
            [34.298005959174795, 1.465335327339667],
            [34.29923966855506, 1.465315792677547],
            [34.29936980120209, 1.46407409258363],
            [34.30006149768265, 1.464186563552887],
            [34.30123872638773, 1.463470999771006],
            [34.30495637364834, 1.459668708323287],
            [34.3077232880297, 1.46036314641615],
            [34.30837811944763, 1.461378632066026],
            [34.311444568077334, 1.460942473877972],
            [34.31373078496697, 1.461701264802268],
            [34.31377121364634, 1.462861453606492],
            [34.31476538815443, 1.463480980390427],
            [34.31516335889328, 1.464240882207557],
            [34.315682342582384, 1.464058810942813],
            [34.3181485252611, 1.451068879394757],
            [34.32077186640219, 1.444600240981035],
            [34.32251044244688, 1.442844517563925],
            [34.32309158416372, 1.438584036138173],
            [34.324801164387694, 1.434286721981235],
            [34.328854835463474, 1.428269518307376],
            [34.334081846437506, 1.42511886753453],
            [34.33730003399339, 1.41873133405423],
            [34.3407770998445, 1.414197856245166],
            [34.34442500639801, 1.405910683389707],
            [34.34943131837475, 1.400046755626429],
            [34.352409945905606, 1.399221932438653],
            [34.351002551756736, 1.400398589802623],
            [34.350281579181036, 1.401782859656214],
            [34.350338273655254, 1.404650020249159],
            [34.35094918104908, 1.407218381821155],
            [34.352324717344715, 1.409107937325144],
            [34.36297707473111, 1.412963776944257],
            [34.36319655920617, 1.413705315365153],
            [34.362109407269536, 1.416084722730623],
            [34.36205233460457, 1.418373072681077],
            [34.36023959814161, 1.4219106427853],
            [34.36021672254292, 1.42409044024042],
            [34.3614749173029, 1.425066519136683],
            [34.364331358683756, 1.425508007770361],
            [34.3650494674303, 1.425968861591219],
            [34.367717460230885, 1.429729864781074],
            [34.37038124711929, 1.432070837692279],
            [34.3738744278483, 1.432150130562982],
            [34.37483012122456, 1.432592744868524],
            [34.374853835849734, 1.434682054401095],
            [34.374107071743936, 1.437965726554619],
            [34.37517259404516, 1.440768928439473],
            [34.3769142297517, 1.441437176768294],
            [34.382029913410875, 1.442094309974294],
            [34.38298917759039, 1.442862519482545],
            [34.384814669232085, 1.445656197124236],
            [34.387514972636794, 1.447029315919555],
            [34.388811349389634, 1.446115007458873],
            [34.391655950076746, 1.445561529561912],
            [34.392998872137696, 1.444520567778366],
            [34.39500943199928, 1.438549883975448],
            [34.39730841574576, 1.434885402443989],
            [34.39806419983532, 1.434496019532888],
            [34.39856892187093, 1.435038386054442],
            [34.39990458644274, 1.439623166856087],
            [34.4016840214598, 1.441503337406669],
            [34.40197598111365, 1.443149267773832],
            [34.402966548885864, 1.444586742695537],
            [34.40338821628361, 1.446151189951931],
            [34.40478679975618, 1.447968274892485],
            [34.4072316977526, 1.447794905107648],
            [34.40868981437568, 1.449593856651467],
            [34.40970765050835, 1.449701748402141],
            [34.418889209754774, 1.447507193818288],
            [34.42203614114572, 1.446356557536652],
            [34.428707178667594, 1.442752631982963],
            [34.430537737705805, 1.442850959136453],
            [34.43138030893328, 1.443836268965754],
            [34.43131967983814, 1.444785975980864],
            [34.430045334267646, 1.447626751059551],
            [34.42872291625308, 1.453515543322218],
            [34.426585732564, 1.458871238815019],
            [34.42676179157991, 1.462823566934612],
            [34.42740976885222, 1.463383908672171],
            [34.42826639601894, 1.463491895850973],
            [34.42961251698062, 1.46490196276837],
            [34.434007417608655, 1.462737509434606],
            [34.436537576505295, 1.46065565869592],
            [34.44104999563711, 1.460489939249507],
            [34.446033554185995, 1.46106555335257],
            [34.44649764901459, 1.46217771981961],
            [34.445681789192086, 1.465779613562673],
            [34.44479797720824, 1.46627626869888],
            [34.444747454160016, 1.466796004658966],
            [34.44414106080053, 1.466764901703814],
            [34.44474460290729, 1.468445669398122],
            [34.44428309522674, 1.469094197989219],
            [34.44546964035966, 1.470464950574391],
            [34.444867817628314, 1.471457504318081],
            [34.44381971186381, 1.471977891034465],
            [34.44468050721346, 1.472185997014402],
            [34.44568944193999, 1.473592284974063],
            [34.44660938057131, 1.473902424516866],
            [34.446941083489975, 1.476453445441361],
            [34.44760055829961, 1.476506447304569],
            [34.44781030234204, 1.477859849242131],
            [34.448592866108534, 1.478944663653353],
            [34.447797501349235, 1.480217423210336],
            [34.448240947502725, 1.481465691371437],
            [34.448023201267745, 1.482162268935829],
            [34.44756217418583, 1.482639410153578],
            [34.446788947508416, 1.482370129701868],
            [34.44597873000421, 1.482740839995281],
            [34.44526396748208, 1.48609172377227],
            [34.44382919897153, 1.488023542254603],
            [34.44328490075774, 1.488192483515457],
            [34.44295527025244, 1.49003867296413],
            [34.44224775713465, 1.49037630461875],
            [34.44300659010629, 1.491673883999688],
            [34.44187616362751, 1.492091871197632],
            [34.44141087493787, 1.494054892057436],
            [34.4415343843063, 1.49457025358623],
            [34.44233033836043, 1.494991181214474],
            [34.44320454286232, 1.495155794432857],
            [34.443423005054576, 1.494467853540248],
            [34.444348937245465, 1.495128923296254],
            [34.444223613280194, 1.495601035549547],
            [34.44484815171012, 1.496456173677656],
            [34.44505411923508, 1.497623465510404],
            [34.44455613636072, 1.498175901367817],
            [34.444816013582496, 1.49853396504696],
            [34.44457360949129, 1.499275886604449],
            [34.44492762656162, 1.499629549866466],
            [34.44418277766401, 1.500593265374731],
            [34.444837524640285, 1.501575410252095],
            [34.44547716285182, 1.501521741772631],
            [34.44624724991736, 1.502368279176312],
            [34.446281456865066, 1.503186266840777],
            [34.445603253080044, 1.503104434233281],
            [34.44522878316736, 1.504130827215802],
            [34.444757617699146, 1.504392517751547],
            [34.44548935299023, 1.505423012215978],
            [34.44491697164402, 1.50536047153924],
            [34.44479224865168, 1.505854265712153],
            [34.4443737999176, 1.505830342857575],
            [34.44442232601094, 1.506483750994771],
            [34.44342727025553, 1.507283065807129],
            [34.443346353608014, 1.508565800140487],
            [34.44379390506233, 1.508957565095004],
            [34.44160544194357, 1.508808978692684],
            [34.441682769821554, 1.509375242770797],
            [34.44111543970219, 1.509680561277374],
            [34.44155331091102, 1.509980366898531],
            [34.44157303701635, 1.510720921394191],
            [34.44111730640135, 1.512507299245149],
            [34.44061230139638, 1.51251247802442],
            [34.440427882658454, 1.513220499738056],
            [34.440160210754925, 1.512969413873187],
            [34.43969486008156, 1.51355448282168],
            [34.43918265328295, 1.513460634440678],
            [34.439084453049375, 1.514294789147439],
            [34.4383895720411, 1.514247866769487],
            [34.438063345252445, 1.515345879063471],
            [34.43740361981282, 1.515531778758059],
            [34.43654631621469, 1.518138853825824],
            [34.43572701225137, 1.518419686234453],
            [34.43327037956244, 1.520604401121416],
            [34.43225920264095, 1.522210882012073],
            [34.432262015266126, 1.523432838200593],
            [34.431552998368566, 1.523850714234409],
            [34.43174986775633, 1.524622877077409],
            [34.43120474039752, 1.52442159906296],
            [34.43082222786809, 1.525369596695912],
            [34.428470948697345, 1.527212918742987],
            [34.424207932431116, 1.528198773749437],
            [34.42366133992008, 1.528967921358243],
            [34.424090317807604, 1.530423792396057],
            [34.3949437714402, 1.557405060216313],
            [34.39363766862781, 1.558934469142248],
            [34.3931397019231, 1.560201048344572],
            [34.39297351359553, 1.561177977375923],
            [34.39389621634299, 1.56272388306511],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1858,
        District: "BULAMBULI",
        County: "BULAMBULI",
        Subcounty: "BUNAMBUTYE",
        Population: 8391,
        Key: "BULAMBULIBUNAMBUTYE",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.62319419658082, 1.569078659906938],
            [34.623217934562184, 1.569596083107756],
            [34.62286135729333, 1.569594889694695],
            [34.62228397322928, 1.57052255936753],
            [34.62299502121771, 1.570810935947968],
            [34.62239597428059, 1.57145249512359],
            [34.622534560074406, 1.572001156567503],
            [34.62198904284676, 1.571832502075968],
            [34.62198025642498, 1.573024240591854],
            [34.62152894192793, 1.572975077261962],
            [34.6214606151691, 1.572569650586233],
            [34.61946186006868, 1.572825218402409],
            [34.61967052074287, 1.573540963291501],
            [34.619148072251726, 1.573467721630381],
            [34.618664539677, 1.574562539756778],
            [34.617736391342305, 1.574702465080631],
            [34.61829899093339, 1.575776924554482],
            [34.61781723432796, 1.576633399107909],
            [34.61700722253796, 1.576869071787577],
            [34.61635129248043, 1.575555951612851],
            [34.615614373910155, 1.575553499241313],
            [34.6131434993307, 1.573745752217393],
            [34.61283147670328, 1.574149920599763],
            [34.60874075551191, 1.574398524417189],
            [34.608544601183105, 1.575208282346132],
            [34.60783179878494, 1.575158254317023],
            [34.60814682537866, 1.574348896865975],
            [34.607362696746925, 1.574298609301103],
            [34.60713537357273, 1.5761093398178],
            [34.60462012401486, 1.577090167612393],
            [34.60209960224458, 1.577177139183443],
            [34.60127496767836, 1.576173316973958],
            [34.60046407284444, 1.576528151922012],
            [34.60045915366994, 1.577195535098478],
            [34.59962818238772, 1.577049756940965],
            [34.59924554589079, 1.577358346033525],
            [34.59861990612633, 1.57838119485193],
            [34.597408931309246, 1.578186480758131],
            [34.5965254903296, 1.578707936297541],
            [34.59536382134353, 1.578275031820485],
            [34.594676188841305, 1.579643284081146],
            [34.593299006832055, 1.579424191009799],
            [34.59397482469165, 1.581261776341294],
            [34.59378747115768, 1.584097576460889],
            [34.59328402203481, 1.584667952015181],
            [34.59226305078177, 1.584497714528691],
            [34.59255642258725, 1.583402255095347],
            [34.59215510742061, 1.583019557236777],
            [34.591845721348534, 1.583066192536873],
            [34.59162455253235, 1.584042704984884],
            [34.591223412537175, 1.583636178655168],
            [34.59012725319318, 1.583990059580042],
            [34.5889050108075, 1.585320797111193],
            [34.58730046340322, 1.585303553365542],
            [34.58654469099173, 1.584633642311265],
            [34.58613879621375, 1.584870644876799],
            [34.58608561684725, 1.585633205841857],
            [34.58565666141761, 1.585774793462648],
            [34.58504668737339, 1.584676332785264],
            [34.584120968083226, 1.584482569336292],
            [34.58379555247324, 1.583480376885664],
            [34.58191877691029, 1.583307300811105],
            [34.5803401378171, 1.581395187317278],
            [34.57843236858023, 1.580590341915975],
            [34.57697890433198, 1.581038376760727],
            [34.57674769684247, 1.580155684986468],
            [34.57603523310918, 1.580057971978424],
            [34.575461524951294, 1.580485097624351],
            [34.575492176367085, 1.57955561309155],
            [34.575019367880245, 1.579196502507306],
            [34.57130472278931, 1.58001836325522],
            [34.57058342861678, 1.581112406575924],
            [34.56985053270234, 1.580561745950012],
            [34.568662803589845, 1.580438601452125],
            [34.56852790268532, 1.580998295722261],
            [34.567907877391384, 1.581258407145816],
            [34.56787828419097, 1.582044905804619],
            [34.567259671048674, 1.58211434335083],
            [34.5669935945531, 1.582733186622554],
            [34.56618461762231, 1.582825828653811],
            [34.566110132912215, 1.583254630244365],
            [34.566846195388024, 1.583376267777597],
            [34.566796708097314, 1.583638287991778],
            [34.565555418732686, 1.584325396427386],
            [34.565812507583836, 1.5849221435495],
            [34.56508893079215, 1.586326043568503],
            [34.56295326166265, 1.587403452246936],
            [34.56254400988045, 1.588093335058481],
            [34.561402751515935, 1.588113366080449],
            [34.560970965494846, 1.588636309752671],
            [34.560047533315384, 1.58813267782811],
            [34.55987442257025, 1.589037866632837],
            [34.558900810499026, 1.588891599016457],
            [34.55775407780117, 1.589650519925965],
            [34.556950206894456, 1.589051945003739],
            [34.55618154455698, 1.590121997891934],
            [34.55525829563383, 1.589594526135269],
            [34.55425331259623, 1.590473102084097],
            [34.553037728523435, 1.590898085720818],
            [34.552771989794394, 1.591469265774557],
            [34.552178911264065, 1.591300434169531],
            [34.55108006326241, 1.592011846270452],
            [34.549847057263015, 1.591578679674282],
            [34.550121575227315, 1.593033591430474],
            [34.54961581384089, 1.593913837031769],
            [34.5493537743742, 1.593984474762006],
            [34.54931100738015, 1.593340754861455],
            [34.548603109783436, 1.592623312464325],
            [34.54840268845701, 1.594005126222455],
            [34.54626473131851, 1.593783470974364],
            [34.5458045693142, 1.594926056509525],
            [34.5465885434357, 1.595000190889434],
            [34.54686693942707, 1.595930713710739],
            [34.54643937458951, 1.595881620067972],
            [34.54638265675911, 1.597120910023163],
            [34.545670344841064, 1.596999344239325],
            [34.54573461211314, 1.597953006738166],
            [34.54528116232065, 1.598189848833053],
            [34.54155252507085, 1.597676842682537],
            [34.54102598924517, 1.598151805612069],
            [34.538969181417826, 1.598204527880533],
            [34.53897288427343, 1.597703981910589],
            [34.53780343228372, 1.598319799750914],
            [34.53747766363584, 1.597365276272745],
            [34.5364034591174, 1.597957581874631],
            [34.53602592684788, 1.597574948675138],
            [34.535451837804324, 1.598049751790341],
            [34.53411842620727, 1.598331330529456],
            [34.533645267377466, 1.598019875566728],
            [34.53302468872131, 1.59835150961622],
            [34.53262602987296, 1.597611256138379],
            [34.53202710600504, 1.598228985775684],
            [34.52784937848683, 1.598965853700944],
            [34.5273048790504, 1.598654162669525],
            [34.52642333710925, 1.598913412515246],
            [34.5261419506263, 1.598388073883936],
            [34.52487825548183, 1.598884397453172],
            [34.523406620112034, 1.598569602142036],
            [34.52240602803954, 1.59885228620546],
            [34.52245003740361, 1.599329156141456],
            [34.5218585408065, 1.598945798539448],
            [34.52168682873825, 1.599660312261948],
            [34.52113863902264, 1.599849167802866],
            [34.520937220566246, 1.598156112256306],
            [34.52007307539891, 1.599273522698167],
            [34.519828488401565, 1.598593371293194],
            [34.518902045967565, 1.598494921927745],
            [34.518279518865576, 1.59908873937758],
            [34.5179067494637, 1.598062528947048],
            [34.51745665757376, 1.597846496301333],
            [34.5167166901214, 1.598249231312944],
            [34.51636467809079, 1.597628309412296],
            [34.51593605234285, 1.597722212417241],
            [34.51665455275487, 1.597009531667624],
            [34.51661550209115, 1.595865242050625],
            [34.515756478219245, 1.596291421564387],
            [34.51494942547978, 1.59612186569554],
            [34.51459000324641, 1.596502044124965],
            [34.51368891306635, 1.596189148546357],
            [34.513425110206754, 1.596498139766306],
            [34.513381982089975, 1.595902084732295],
            [34.51262052783435, 1.595994872541335],
            [34.511887451358525, 1.595468011109754],
            [34.51107774230078, 1.595655982538633],
            [34.510692957033655, 1.5962506035912],
            [34.509820244633445, 1.595318055998802],
            [34.50789443093747, 1.595335427172086],
            [34.507177693020026, 1.595809750392324],
            [34.50623047435018, 1.59530600168854],
            [34.5048280254269, 1.595277455314336],
            [34.5033979065963, 1.595773206731985],
            [34.50271309390573, 1.595151162522364],
            [34.50135836079544, 1.595098934955517],
            [34.50015864456381, 1.595369514002295],
            [34.49975523452591, 1.596278689294991],
            [34.49973059553432, 1.595082831709902],
            [34.499373947298515, 1.594915678701833],
            [34.498851379331455, 1.59537049278641],
            [34.49916074743719, 1.595896451786309],
            [34.49859051665776, 1.596183867604113],
            [34.49944650871559, 1.596637678379624],
            [34.49792602655389, 1.597595501323265],
            [34.499280939327264, 1.597737997762211],
            [34.49956660628255, 1.598359633512486],
            [34.498853949411476, 1.598910275921675],
            [34.4987345920563, 1.59819283995724],
            [34.498378003109316, 1.598097423901321],
            [34.498331520683266, 1.59955641948239],
            [34.49797520123087, 1.599843705481087],
            [34.49754717735419, 1.5995809276475],
            [34.498118400772015, 1.600656792974448],
            [34.497762071438146, 1.600920148959403],
            [34.49790497543354, 1.601326640451018],
            [34.4970494406182, 1.60149469449347],
            [34.496764528247745, 1.601925413843352],
            [34.495956334647865, 1.601830340085443],
            [34.49595559533439, 1.60082580968996],
            [34.495242615968095, 1.600922002358419],
            [34.49529092287251, 1.601974342116169],
            [34.49433998877061, 1.601711947986421],
            [34.494291970225426, 1.601042291902253],
            [34.493341575112716, 1.601521343382502],
            [34.4931037964469, 1.601378014793265],
            [34.493401913153726, 1.60073053832877],
            [34.493434690881784, 1.600300945673786],
            [34.49241369447596, 1.600254398764031],
            [34.49234264941508, 1.60061321384635],
            [34.49155846778275, 1.600876873348979],
            [34.491581693724434, 1.600111504701276],
            [34.49079733781894, 1.60013600208416],
            [34.49036924656861, 1.599753639578274],
            [34.49047582988043, 1.599239329074875],
            [34.489596814001885, 1.599837917197959],
            [34.489524724200315, 1.598737757880498],
            [34.48874051561854, 1.59895359108407],
            [34.48923841944119, 1.597255078756082],
            [34.48866783921713, 1.597064147776369],
            [34.488857611015824, 1.596537828990609],
            [34.48783564981938, 1.596658176261176],
            [34.48840545389902, 1.595772807136711],
            [34.48764472458385, 1.595582024183885],
            [34.48745390265454, 1.594649375716052],
            [34.48674087028766, 1.594673816592131],
            [34.487619688536874, 1.593812135901032],
            [34.48859423485599, 1.593883182210059],
            [34.48828440501618, 1.592711448945745],
            [34.48887810967229, 1.591993488201695],
            [34.48847386779444, 1.591754609698678],
            [34.48721467231122, 1.592496966529439],
            [34.487262669296875, 1.593142711611623],
            [34.48635962438277, 1.593358619933792],
            [34.48656029993241, 1.591457029154101],
            [34.48582383051977, 1.591959841320186],
            [34.48658325548119, 1.590332885984284],
            [34.486296899518074, 1.588754534683764],
            [34.48693842059843, 1.588443139334878],
            [34.48700913418097, 1.587605978716051],
            [34.48620100256486, 1.58760656419276],
            [34.48627131370215, 1.586219291874721],
            [34.48536873231874, 1.587080986512017],
            [34.4842983779796, 1.586005467894893],
            [34.483895009264224, 1.586962461563018],
            [34.4835378310224, 1.586053843395785],
            [34.48232495626853, 1.585098025650173],
            [34.4819923101188, 1.585241779214769],
            [34.48230162791889, 1.585719893295989],
            [34.482016872753604, 1.58636589013348],
            [34.481077699395435, 1.585900169101931],
            [34.480080063678564, 1.586809757145109],
            [34.47996089407128, 1.586355417097835],
            [34.479247691024476, 1.586140670915781],
            [34.47934336250056, 1.586977723473466],
            [34.47884494843484, 1.587982621611012],
            [34.47794095579813, 1.586883064785598],
            [34.4767289964275, 1.587218790883501],
            [34.47665713120477, 1.586429554479588],
            [34.47630115490883, 1.587195185929753],
            [34.47516042295708, 1.587411267284494],
            [34.47572993059268, 1.586095377253738],
            [34.47482687400051, 1.586311288108907],
            [34.474233253786025, 1.587148838073245],
            [34.473781215246845, 1.586527300412235],
            [34.47325870567026, 1.587077790634401],
            [34.473330254686005, 1.587436504746224],
            [34.47385314784322, 1.587412207459668],
            [34.47354458462799, 1.588010368892649],
            [34.472355493669525, 1.587078438969233],
            [34.4718093718757, 1.587868120518752],
            [34.47141701920063, 1.5876172617147],
            [34.471772584966494, 1.58625369853323],
            [34.470917050151186, 1.586445641629294],
            [34.47060781589438, 1.586111019012365],
            [34.47082136609868, 1.585584672288181],
            [34.47146316475847, 1.585655979292016],
            [34.47153409573331, 1.585129734820898],
            [34.47089224676786, 1.584986680768387],
            [34.47039334581525, 1.585321901616096],
            [34.47003608762339, 1.584293691734248],
            [34.46918073875931, 1.584748739835723],
            [34.46898991233846, 1.58379215910939],
            [34.46851527039011, 1.584820972677145],
            [34.46777829522595, 1.584606237111582],
            [34.46739823779218, 1.584941363733837],
            [34.466922624765004, 1.584606858508015],
            [34.46630480753004, 1.584822561189001],
            [34.46654199510439, 1.584128770211],
            [34.466208982442055, 1.583770240508175],
            [34.46578161792878, 1.584440245230817],
            [34.46504472630795, 1.584345100624127],
            [34.46530482631194, 1.582431494758747],
            [34.4647819008154, 1.582384031513503],
            [34.464354408741336, 1.582886609719051],
            [34.4640449993131, 1.582288885914475],
            [34.465185669281084, 1.581977123220102],
            [34.46549432142957, 1.581498562880762],
            [34.463925749755745, 1.581714941160858],
            [34.4637826544192, 1.581021430208598],
            [34.464626072757994, 1.580506590620814],
            [34.46367475687213, 1.579694061810613],
            [34.46284303549664, 1.579933836985588],
            [34.462724004229905, 1.579670824042484],
            [34.46312776640741, 1.579240012943545],
            [34.463983519513356, 1.579358997198802],
            [34.464006761624724, 1.578617523752847],
            [34.46298504836328, 1.579096608274986],
            [34.462438040830584, 1.578618645322785],
            [34.46182019754446, 1.578810423898246],
            [34.46110654983159, 1.577973809847736],
            [34.460583907304375, 1.578356870520038],
            [34.461249569709686, 1.578547740369552],
            [34.46113092382021, 1.578834834430347],
            [34.45991866441228, 1.578740022715128],
            [34.460155604051636, 1.577687472660746],
            [34.46091621568752, 1.577710846943208],
            [34.46122446898402, 1.576658246979484],
            [34.460297386051224, 1.576491475020821],
            [34.45984532146092, 1.575822083745321],
            [34.460034971088746, 1.575128344537688],
            [34.45939327304027, 1.575200555264238],
            [34.459630539666364, 1.574602434140247],
            [34.45841859916037, 1.574962067241264],
            [34.458418023340265, 1.574148860089766],
            [34.45772857624117, 1.573910169901769],
            [34.45803696518327, 1.573048900829323],
            [34.45760914702079, 1.573073124649813],
            [34.45725336655756, 1.57412575875212],
            [34.45699103783336, 1.572882219277491],
            [34.45589743509467, 1.572524219237935],
            [34.45577915212459, 1.573337511432707],
            [34.45634979612905, 1.573624130284331],
            [34.45617187580386, 1.574114573559547],
            [34.45562493025493, 1.573708354192099],
            [34.45517341363692, 1.573852177688846],
            [34.455196129335526, 1.572345318870562],
            [34.45488692562146, 1.572034620585383],
            [34.453841952282374, 1.573231254754621],
            [34.45339015269506, 1.572968473540724],
            [34.45424496167164, 1.57172413687053],
            [34.4538168452685, 1.571317832627854],
            [34.4538877510905, 1.570743751050863],
            [34.45338894356269, 1.571222462926556],
            [34.45355588647509, 1.572035555379628],
            [34.45291450283696, 1.572562201867447],
            [34.45305659745027, 1.571820641592202],
            [34.451796812672264, 1.571749776816588],
            [34.451106974805995, 1.570960971853674],
            [34.45122630251677, 1.571654505912523],
            [34.45084622352344, 1.57196570622353],
            [34.45020433323549, 1.571774815117564],
            [34.44984805151234, 1.572109920460442],
            [34.449419990804714, 1.571799285896592],
            [34.449183116742375, 1.572971432374214],
            [34.4480653690855, 1.572063333405496],
            [34.44775667651285, 1.5724940759468],
            [34.447899838324744, 1.57330718766004],
            [34.44756720205649, 1.573474848870337],
            [34.44716251641088, 1.572590163073626],
            [34.44668711269119, 1.572542659194923],
            [34.44659256590584, 1.573308101800271],
            [34.44586734699379, 1.572913968145557],
            [34.445676700236, 1.572196560885763],
            [34.444630702817484, 1.571934190815156],
            [34.44522404724916, 1.570666122670189],
            [34.444249855764575, 1.571145165917379],
            [34.443917828554085, 1.572197787522486],
            [34.44275203719918, 1.570572182519793],
            [34.44251508408513, 1.571624738861355],
            [34.441920429011454, 1.571003281865784],
            [34.44101781169543, 1.571864968443795],
            [34.440874529509294, 1.570884424646194],
            [34.44018533393849, 1.571028410871445],
            [34.44023354921473, 1.572009020153786],
            [34.439187015501986, 1.570981277821997],
            [34.439591084005, 1.570957074630702],
            [34.439733372654416, 1.570502532665868],
            [34.43885407290822, 1.57071840832307],
            [34.438829894752345, 1.570096552355716],
            [34.43814063989273, 1.570168789297742],
            [34.43790256029129, 1.569594917532023],
            [34.4371421247252, 1.569834631908396],
            [34.43661970138687, 1.570552538357175],
            [34.43611995242464, 1.569667910589011],
            [34.436666508104764, 1.569476188643203],
            [34.435929130495374, 1.568687407067686],
            [34.43531172109552, 1.569524963230871],
            [34.434027748280165, 1.568856142631119],
            [34.43398001989082, 1.568569160341933],
            [34.43500214907221, 1.568688048224433],
            [34.435191893921456, 1.568089957562328],
            [34.43599997792689, 1.568017648710182],
            [34.435845103880304, 1.567455675476056],
            [34.4348707929198, 1.567767276012723],
            [34.43484617279278, 1.566523564832654],
            [34.43422879573233, 1.567408965294281],
            [34.43365815172787, 1.567122336610517],
            [34.43437034506827, 1.565854184730561],
            [34.4336564907429, 1.564682687994819],
            [34.43299105561136, 1.564826662972914],
            [34.433560998929885, 1.564084802724905],
            [34.43208713124659, 1.563774879966821],
            [34.43135061242663, 1.564229840055016],
            [34.43130274659502, 1.563727583321582],
            [34.43211036706975, 1.562985569130292],
            [34.43165835278509, 1.562387928525919],
            [34.432394839265726, 1.561885133460954],
            [34.431443935706554, 1.561646608001103],
            [34.43106411722462, 1.562364413987003],
            [34.43144482773361, 1.562962113864851],
            [34.43118356620797, 1.563249307947302],
            [34.43047015115879, 1.562723603792988],
            [34.430683044694604, 1.561216598676223],
            [34.42826941076503, 1.559579869030943],
            [34.427936116031674, 1.558790800870573],
            [34.42686628541037, 1.558432758015195],
            [34.42639009925805, 1.557237177714993],
            [34.42579569571262, 1.556950567399152],
            [34.426104145740155, 1.556161051057986],
            [34.42541462947079, 1.555802747340416],
            [34.42558038930196, 1.554893733977958],
            [34.42474874338496, 1.555277006304866],
            [34.42391664651372, 1.55499055646185],
            [34.4236787268124, 1.554655857867221],
            [34.42415390774993, 1.554344596621524],
            [34.42374958322705, 1.553986096834896],
            [34.423107735159924, 1.553843025386091],
            [34.422513805026675, 1.554273962038182],
            [34.420410094361706, 1.554000338875331],
            [34.41998184949948, 1.553378751845347],
            [34.41917388137674, 1.553642402066887],
            [34.41914956757527, 1.552829196531817],
            [34.41762907283714, 1.553858714979251],
            [34.416131138389076, 1.553118263397066],
            [34.414610063339296, 1.553310644160043],
            [34.4143481280772, 1.552593269715068],
            [34.41351712894721, 1.553957183516911],
            [34.41263749682435, 1.553670749658568],
            [34.41237638980892, 1.554197133153328],
            [34.411128588556785, 1.55428169009517],
            [34.410772721855295, 1.555286508775211],
            [34.40958440614297, 1.555478645088937],
            [34.408466559671375, 1.554403085959158],
            [34.40694517739778, 1.554141004612103],
            [34.405567714215834, 1.555840151072873],
            [34.404617177169314, 1.556175643297498],
            [34.4044987181294, 1.55674976747258],
            [34.40385653858395, 1.556128316847953],
            [34.40380954411816, 1.556941575888947],
            [34.402668568722966, 1.556822755588257],
            [34.40290669144353, 1.557492314571721],
            [34.40193201576701, 1.557277699220699],
            [34.401766069984596, 1.557923606079679],
            [34.40114803625563, 1.557852261311466],
            [34.3998650776382, 1.558714195748006],
            [34.39893808723189, 1.558714817152177],
            [34.3986771742526, 1.559528228749766],
            [34.3979644940253, 1.560126676555244],
            [34.397988716198604, 1.560820293221545],
            [34.39737120169589, 1.561538262922351],
            [34.396634435839225, 1.561634439451969],
            [34.39634968426718, 1.562376100315973],
            [34.395493919483144, 1.562233164134248],
            [34.394971367685734, 1.562807561439046],
            [34.39389621634299, 1.56272388306511],
            [34.39297351359553, 1.561177977375923],
            [34.3931397019231, 1.560201048344572],
            [34.39363766862781, 1.558934469142248],
            [34.3949437714402, 1.557405060216313],
            [34.424090317807604, 1.530423792396057],
            [34.42366133992008, 1.528967921358243],
            [34.424207932431116, 1.528198773749437],
            [34.428470948697345, 1.527212918742987],
            [34.43082222786809, 1.525369596695912],
            [34.43120474039752, 1.52442159906296],
            [34.43174986775633, 1.524622877077409],
            [34.431552998368566, 1.523850714234409],
            [34.432262015266126, 1.523432838200593],
            [34.43225920264095, 1.522210882012073],
            [34.43327037956244, 1.520604401121416],
            [34.43572701225137, 1.518419686234453],
            [34.43654631621469, 1.518138853825824],
            [34.43740361981282, 1.515531778758059],
            [34.438063345252445, 1.515345879063471],
            [34.4383895720411, 1.514247866769487],
            [34.439084453049375, 1.514294789147439],
            [34.43918265328295, 1.513460634440678],
            [34.43969486008156, 1.51355448282168],
            [34.440160210754925, 1.512969413873187],
            [34.440427882658454, 1.513220499738056],
            [34.44061230139638, 1.51251247802442],
            [34.44111730640135, 1.512507299245149],
            [34.44157303701635, 1.510720921394191],
            [34.44155331091102, 1.509980366898531],
            [34.44111543970219, 1.509680561277374],
            [34.441682769821554, 1.509375242770797],
            [34.44160544194357, 1.508808978692684],
            [34.44379390506233, 1.508957565095004],
            [34.443346353608014, 1.508565800140487],
            [34.44342727025553, 1.507283065807129],
            [34.44442232601094, 1.506483750994771],
            [34.4443737999176, 1.505830342857575],
            [34.44479224865168, 1.505854265712153],
            [34.44491697164402, 1.50536047153924],
            [34.44548935299023, 1.505423012215978],
            [34.444757617699146, 1.504392517751547],
            [34.44522878316736, 1.504130827215802],
            [34.445603253080044, 1.503104434233281],
            [34.446281456865066, 1.503186266840777],
            [34.44624724991736, 1.502368279176312],
            [34.44547716285182, 1.501521741772631],
            [34.444837524640285, 1.501575410252095],
            [34.44418277766401, 1.500593265374731],
            [34.44492762656162, 1.499629549866466],
            [34.44457360949129, 1.499275886604449],
            [34.444816013582496, 1.49853396504696],
            [34.44455613636072, 1.498175901367817],
            [34.44505411923508, 1.497623465510404],
            [34.44484815171012, 1.496456173677656],
            [34.444223613280194, 1.495601035549547],
            [34.444348937245465, 1.495128923296254],
            [34.443423005054576, 1.494467853540248],
            [34.44320454286232, 1.495155794432857],
            [34.44233033836043, 1.494991181214474],
            [34.4415343843063, 1.49457025358623],
            [34.44141087493787, 1.494054892057436],
            [34.44187616362751, 1.492091871197632],
            [34.44300659010629, 1.491673883999688],
            [34.44224775713465, 1.49037630461875],
            [34.44295527025244, 1.49003867296413],
            [34.44328490075774, 1.488192483515457],
            [34.44382919897153, 1.488023542254603],
            [34.44526396748208, 1.48609172377227],
            [34.44597873000421, 1.482740839995281],
            [34.446788947508416, 1.482370129701868],
            [34.44756217418583, 1.482639410153578],
            [34.448023201267745, 1.482162268935829],
            [34.448240947502725, 1.481465691371437],
            [34.447797501349235, 1.480217423210336],
            [34.448592866108534, 1.478944663653353],
            [34.44973842201336, 1.480255343711351],
            [34.45140849073787, 1.48399861670207],
            [34.453345319575845, 1.485091703302165],
            [34.45465532287323, 1.485344076523575],
            [34.455759699107105, 1.486374400329017],
            [34.45701804029248, 1.488354278382169],
            [34.45755723068557, 1.490877295238644],
            [34.458805449654314, 1.491979872199402],
            [34.460467981513574, 1.491915449806211],
            [34.46310063818413, 1.489462671232117],
            [34.46454677667124, 1.489181328618762],
            [34.465928139439825, 1.489478865078193],
            [34.47062603372835, 1.492044290998668],
            [34.4737749575826, 1.493127481128897],
            [34.476629616705935, 1.493451143761921],
            [34.48288289360327, 1.492822845492521],
            [34.48561937485942, 1.491156842511245],
            [34.486861922763794, 1.489672741317925],
            [34.48751544803128, 1.487610211377676],
            [34.488709671963264, 1.486099012944892],
            [34.492510774510386, 1.483998168593099],
            [34.493833475494306, 1.482278868961507],
            [34.495660432288226, 1.482051520368297],
            [34.498356059063546, 1.480078349338502],
            [34.500397270340954, 1.480110090596825],
            [34.5029119719265, 1.480864357986259],
            [34.50353570187267, 1.480604112251381],
            [34.503628553537055, 1.480048323289529],
            [34.504338534326905, 1.480076705970013],
            [34.504408293898635, 1.477182557032381],
            [34.50510422234248, 1.476568926837892],
            [34.506345362586806, 1.476525005724226],
            [34.50615954157871, 1.475993900438908],
            [34.50416764421716, 1.475134084697983],
            [34.50356314720122, 1.473587274930535],
            [34.503857625731136, 1.472033264671943],
            [34.50474822448698, 1.471709061892174],
            [34.50521765890163, 1.472164960026758],
            [34.505681220130946, 1.471724341684671],
            [34.50515347247796, 1.470775131861134],
            [34.50390921507961, 1.470362199185824],
            [34.503281334916814, 1.469439579151461],
            [34.505072453422464, 1.467800383371002],
            [34.50493091486629, 1.466194096171042],
            [34.50602845312424, 1.465268075405321],
            [34.50579247827553, 1.461331196689321],
            [34.507235960444326, 1.459853984990687],
            [34.50718545895567, 1.464354653504169],
            [34.50857730955519, 1.464905104048257],
            [34.50951360650785, 1.466237260456291],
            [34.51226143079109, 1.468580463134357],
            [34.515999237144996, 1.470922356737561],
            [34.5170375512729, 1.473119364294978],
            [34.5203007013054, 1.477105569157274],
            [34.52164782568524, 1.477954290938593],
            [34.521746687078874, 1.479111213292998],
            [34.522928133374236, 1.48036867057106],
            [34.524067212425855, 1.48041310257945],
            [34.52523250791073, 1.479372225210589],
            [34.52770286056904, 1.475517739325268],
            [34.530531668873444, 1.473489909999267],
            [34.530884801103205, 1.471626589625807],
            [34.53185634974424, 1.471454080171427],
            [34.53393599903431, 1.472854465917335],
            [34.535572726787045, 1.472943769364686],
            [34.53618061673979, 1.472382617315947],
            [34.53697735681982, 1.470383333176575],
            [34.53734026451649, 1.467217671245211],
            [34.53834969690968, 1.465778972375422],
            [34.54217988780401, 1.464546330884472],
            [34.545212462760986, 1.464860764226925],
            [34.54685419772308, 1.465718800454851],
            [34.550572942724976, 1.466611560132423],
            [34.55339501815633, 1.468734917217674],
            [34.55603752036241, 1.469456579565538],
            [34.558154720129686, 1.47075741842975],
            [34.5597108213907, 1.471235650495117],
            [34.560200500238594, 1.473541507432584],
            [34.56112415609857, 1.475584781712744],
            [34.56342697026142, 1.478061183628359],
            [34.564482670383306, 1.478575936442843],
            [34.56682336919664, 1.479008378788124],
            [34.56723557733445, 1.47334660514227],
            [34.567995163992585, 1.47288482792239],
            [34.57060096462942, 1.474140076904675],
            [34.57119355896785, 1.476617679282014],
            [34.571650132202585, 1.477349907835022],
            [34.57301325647596, 1.478153840059735],
            [34.57693873346911, 1.479127768217289],
            [34.58012637650872, 1.477967870743101],
            [34.582822487476015, 1.477477568086529],
            [34.586083473467006, 1.48153589549004],
            [34.58665488553101, 1.483416595800819],
            [34.58852198174677, 1.485251137518717],
            [34.58946871263146, 1.487321481476016],
            [34.591451382498384, 1.489752820609815],
            [34.5928929189163, 1.491026943409744],
            [34.59455928748013, 1.490980508151942],
            [34.59555164828964, 1.490111580722904],
            [34.59626335653981, 1.488700233070759],
            [34.598319587648724, 1.483317693002213],
            [34.60114815161141, 1.482727787354544],
            [34.60492149441963, 1.479948606738383],
            [34.608011100719004, 1.478436048865411],
            [34.61143542378483, 1.475349643030152],
            [34.61338475896823, 1.472870245898249],
            [34.61613509404269, 1.468210740099476],
            [34.618031900239856, 1.466888979458021],
            [34.61897918718167, 1.465070510657043],
            [34.61958070448581, 1.460394496416552],
            [34.62015008366236, 1.459453541814322],
            [34.61979169718647, 1.458576565656837],
            [34.61982768369676, 1.456441980830265],
            [34.620497360673106, 1.45511452337103],
            [34.620021325437726, 1.454542924615984],
            [34.62000280756645, 1.453545676592391],
            [34.619313072108156, 1.452915576404125],
            [34.61935948805888, 1.452635189172582],
            [34.619952049159664, 1.452698066299196],
            [34.62065163913661, 1.453204005426974],
            [34.62231314691645, 1.456639391876997],
            [34.623658632769214, 1.457958787770306],
            [34.626972689430566, 1.459367182449187],
            [34.628831297465176, 1.459619046709464],
            [34.629845509793995, 1.461833993491582],
            [34.63144819948231, 1.462339262437818],
            [34.63248847014089, 1.462528415648683],
            [34.633399192955686, 1.462202177469908],
            [34.63405407198434, 1.460682371299533],
            [34.63430269151899, 1.457327013101045],
            [34.6347333672224, 1.457200087181792],
            [34.63659855990807, 1.459577186227465],
            [34.63727614655049, 1.461493929248986],
            [34.638492203137126, 1.46322940303239],
            [34.639190574998544, 1.462830971130284],
            [34.64060220021244, 1.458552320798816],
            [34.643290268562986, 1.456425106041065],
            [34.64419907077972, 1.454235896748846],
            [34.64464149015882, 1.454045657127569],
            [34.64662515625743, 1.455617775963163],
            [34.64762675534133, 1.459786110561627],
            [34.64977033234032, 1.464975512539646],
            [34.649319874836024, 1.46645898635852],
            [34.646574530801274, 1.467817556217498],
            [34.64605319622109, 1.469916045992469],
            [34.64624397503123, 1.471209131091559],
            [34.64780353839936, 1.474165207937598],
            [34.65115665201262, 1.475211751542602],
            [34.65236899316725, 1.474930495124301],
            [34.65545887255447, 1.473173739307666],
            [34.6593654795368, 1.4678080219336],
            [34.66228783659827, 1.465101834549042],
            [34.662227617134874, 1.46341075055851],
            [34.66139425813064, 1.462000590207154],
            [34.65793188332769, 1.458186816825406],
            [34.65619605702609, 1.45760932152202],
            [34.65602955967806, 1.457256748053868],
            [34.656884572572224, 1.456035241890077],
            [34.65700189793824, 1.454425412545225],
            [34.659403129726975, 1.454089023701964],
            [34.66240081771155, 1.456845059347468],
            [34.66490051383861, 1.46133779805724],
            [34.66656516751855, 1.462123333763267],
            [34.66775390274412, 1.461842096352364],
            [34.669595689825094, 1.460656025987482],
            [34.672543716245784, 1.460798509966052],
            [34.675966552599824, 1.459764989043213],
            [34.679662611547556, 1.458360482160594],
            [34.68084994450296, 1.456207262209078],
            [34.68443963393788, 1.456032735501675],
            [34.685603989784966, 1.455462125705391],
            [34.68586481203445, 1.454268205028209],
            [34.6856021940527, 1.453047548574995],
            [34.68086650494522, 1.44671169208745],
            [34.67908223070372, 1.445130429613789],
            [34.67815393594364, 1.443666090464465],
            [34.6781768384918, 1.442734603122537],
            [34.677549109245994, 1.441533484306941],
            [34.67793644842346, 1.440564267100782],
            [34.6802253458859, 1.440110494501385],
            [34.68128533276834, 1.443482889614387],
            [34.68345484233294, 1.444268045375944],
            [34.68414737694165, 1.445126648011286],
            [34.68589439086181, 1.445686029659172],
            [34.68840422447682, 1.447689344548299],
            [34.68881702550272, 1.450663227895889],
            [34.68979052618284, 1.451963604380304],
            [34.68894761269725, 1.453140590396632],
            [34.689268544815654, 1.456871258326083],
            [34.690424347802896, 1.457050116142315],
            [34.69040407911516, 1.458554875677741],
            [34.69003799317898, 1.459195533255529],
            [34.690688439920024, 1.459612678822656],
            [34.69093133988129, 1.460719236954956],
            [34.6901368177417, 1.461861386782526],
            [34.68973731447697, 1.461780984096099],
            [34.68942239837603, 1.46226677045088],
            [34.68889451328078, 1.462112966089982],
            [34.68876814457482, 1.463165589562574],
            [34.68916778528181, 1.463461984525493],
            [34.689713013251925, 1.465938178980826],
            [34.68944785842783, 1.466803002936072],
            [34.68995595453569, 1.467094008394811],
            [34.69049370852262, 1.468951818708522],
            [34.690925879921, 1.469266765099257],
            [34.69144038011849, 1.471755142836384],
            [34.690277825393565, 1.472209839412421],
            [34.689050745580076, 1.475215458559044],
            [34.689377905718324, 1.477223291071654],
            [34.688963006227944, 1.478441979364651],
            [34.68787392021852, 1.479067892104271],
            [34.68543704238098, 1.479281650430939],
            [34.68547946352365, 1.479694805056906],
            [34.68421732965113, 1.481184305533121],
            [34.683306935619704, 1.481460461331977],
            [34.68389144332394, 1.481788444229944],
            [34.68408175051857, 1.482868942657518],
            [34.68319847033737, 1.484193939225505],
            [34.683487994658485, 1.484710932057321],
            [34.683226370213454, 1.486281044689455],
            [34.683626915523924, 1.486953490235555],
            [34.682932851084246, 1.487918128174404],
            [34.68305623019696, 1.490963967684622],
            [34.68257729340322, 1.49103320164926],
            [34.68243047634647, 1.491774934465601],
            [34.681504264779484, 1.49201932270873],
            [34.680658271869106, 1.493926996587302],
            [34.680119807314775, 1.494058559529846],
            [34.68024822956946, 1.494610662225367],
            [34.679605305320614, 1.494702861773443],
            [34.67951016205393, 1.49519530145975],
            [34.67864372797923, 1.495479665105125],
            [34.678539297929156, 1.496014314636725],
            [34.67571166551942, 1.497982632932029],
            [34.673760906506324, 1.501357331982169],
            [34.67252231747742, 1.502293063050159],
            [34.671903491434385, 1.5034116223692],
            [34.673023350132176, 1.506322738730494],
            [34.672346275529506, 1.509721197729913],
            [34.671766948409505, 1.510673599327557],
            [34.67218625593301, 1.511839875995601],
            [34.67163649236902, 1.517359750712316],
            [34.67248376268373, 1.518215258355437],
            [34.67230581630743, 1.519788952376482],
            [34.6713109644696, 1.522340957057657],
            [34.671076541011374, 1.522025388787293],
            [34.67057792931631, 1.521976062635483],
            [34.67031011997053, 1.522833216275813],
            [34.66955281233827, 1.522377851314069],
            [34.66914730024258, 1.522567183450519],
            [34.66884162331432, 1.522113316293761],
            [34.66621048659322, 1.522712372680035],
            [34.6653130175221, 1.521922845455523],
            [34.664974054419325, 1.522755934565572],
            [34.664100529942104, 1.521942653503939],
            [34.663240571822314, 1.522511834437529],
            [34.662338338985215, 1.522365830710128],
            [34.66199163420133, 1.52424762464148],
            [34.65923845416236, 1.523666453203584],
            [34.65929427906738, 1.525764085823554],
            [34.65860404863736, 1.525880971776441],
            [34.65836247009789, 1.52640453703819],
            [34.658804256164736, 1.527740744671177],
            [34.65706688745578, 1.529629849866453],
            [34.65689397883157, 1.530511161904305],
            [34.65533813808197, 1.531959916188419],
            [34.65551405336744, 1.533891121882485],
            [34.65157003065524, 1.535224697322548],
            [34.65115870106979, 1.536200562069158],
            [34.65034855183753, 1.536460054024264],
            [34.65053537806044, 1.536913536499836],
            [34.649727880654915, 1.536815522453939],
            [34.64645733748764, 1.538687622460017],
            [34.64626277048193, 1.539282849671372],
            [34.64562218185281, 1.539113879165516],
            [34.644876125619454, 1.54035082305954],
            [34.644190287951204, 1.539871842863953],
            [34.643687577243476, 1.540346876390536],
            [34.64025714293876, 1.539727698262239],
            [34.63897137798439, 1.540009433020986],
            [34.63617994049411, 1.541382596130344],
            [34.63155281907691, 1.545073572560273],
            [34.62982526625907, 1.547236830671259],
            [34.62970006446467, 1.548094474363603],
            [34.628694452606375, 1.549068373801366],
            [34.62834369103065, 1.549889520779922],
            [34.62850111180104, 1.551105629610947],
            [34.627734617098334, 1.55188963959718],
            [34.62750906630018, 1.55346199955766],
            [34.625328432897426, 1.555814451665499],
            [34.62593098506078, 1.556305067926695],
            [34.625901931747855, 1.557020015656492],
            [34.62637261032918, 1.557665136859021],
            [34.62633247899218, 1.559881673749012],
            [34.62559062687435, 1.560546594580186],
            [34.625492565879625, 1.562560331951773],
            [34.6244950613168, 1.565655596481048],
            [34.6238246989259, 1.566296922864725],
            [34.62293037216163, 1.568296106562387],
            [34.62319419658082, 1.569078659906938],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1861,
        District: "KWEEN",
        County: "KWEEN",
        Subcounty: "NGENGE",
        Population: 11361,
        Key: "KWEENNGENGE",
        Dist2: "Kween",
        "Sub Country": "Ngenge",
        id2_original: "Kween  Ngenge",
        drought: "VH",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "M",
        "Environmental degradation": "M",
        flood: "VH",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "L",
        heatwave: "M",
        landslide: "L",
        "Earthquakes and faults": "L",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.02814118449856, 1.647718622689281],
            [34.01001721909392, 1.648726589540639],
            [34.005035777874156, 1.64724844307448],
            [34.000762180352176, 1.644702015778563],
            [33.981404812791084, 1.638515710608332],
            [33.974998266238316, 1.637387129758793],
            [33.954975724955396, 1.635427320311702],
            [33.95596815673185, 1.616930502156899],
            [33.95554613809283, 1.610725128896033],
            [33.952822898902255, 1.595927102986133],
            [33.953050797896594, 1.585723070318321],
            [33.95262131695252, 1.583932154751598],
            [33.95188390430884, 1.583235951521705],
            [33.95216824984232, 1.58215934166687],
            [33.951763267752696, 1.581110188581948],
            [33.95054991779002, 1.580224236295905],
            [33.95010961394339, 1.579328881843825],
            [33.9506074279345, 1.578206942903631],
            [33.949868880718626, 1.576244292050168],
            [33.95012969847652, 1.575312429578393],
            [33.94921237753592, 1.573078477489135],
            [33.948117953737075, 1.571785394188021],
            [33.94729426689349, 1.567877877390894],
            [33.946246731559214, 1.565897268904519],
            [33.94195143523159, 1.561484739621636],
            [33.940642020330735, 1.559305228244401],
            [33.9404736895212, 1.557251846275676],
            [33.937929056070395, 1.555489004235374],
            [33.937177810269645, 1.553960553654291],
            [33.94267258387705, 1.544559227931498],
            [33.94243180843145, 1.541275613162938],
            [33.94268361429041, 1.54027138770134],
            [33.94316706062688, 1.5396741322044],
            [33.944093966591545, 1.53952898183938],
            [33.94823076776373, 1.541417755141751],
            [33.95072601363684, 1.540819594791792],
            [33.952580201960274, 1.541388660258381],
            [33.95399410350508, 1.541062364706346],
            [33.95613364437347, 1.541540837269804],
            [33.95727374211464, 1.540753316807927],
            [33.962881868737846, 1.540099456598217],
            [33.96305548074292, 1.535133116420094],
            [33.962745991364585, 1.534011551772289],
            [33.963029497871645, 1.532310773268492],
            [33.96251491053752, 1.528575002515043],
            [33.96257989107193, 1.521844739350092],
            [33.963633373253394, 1.517058925084944],
            [33.96466583126395, 1.515538731980164],
            [33.964555249550784, 1.511938469492142],
            [33.965735921498386, 1.503832718918574],
            [33.96565045129068, 1.501100862993451],
            [33.96690679372454, 1.497699005978113],
            [33.96646643508068, 1.495320102315727],
            [33.971332450871266, 1.496240628181247],
            [33.97722572163028, 1.49660887380087],
            [33.97741139531468, 1.490909825693627],
            [33.98233066952351, 1.486565555862386],
            [33.986554054814334, 1.480077709951428],
            [33.987238681553634, 1.478403902577811],
            [33.98830570404137, 1.477607379978408],
            [33.99287727274308, 1.475977056329734],
            [33.992078320112505, 1.475733176387908],
            [33.99162793716841, 1.476095215638263],
            [33.9881118089755, 1.476151069612498],
            [33.986136631058, 1.474939795893162],
            [33.99007585496997, 1.47208167596826],
            [34.00060039826108, 1.46304695541414],
            [34.00881815863244, 1.452142944825915],
            [34.01118119225867, 1.452693679439448],
            [34.020227035828604, 1.453358973340499],
            [34.02824467580917, 1.45862903002721],
            [34.032542925797486, 1.465185268837259],
            [34.03248575341952, 1.466686902297408],
            [34.037316262400196, 1.470094920728743],
            [34.04378304997595, 1.477979812565541],
            [34.04502742595191, 1.480512043224381],
            [34.04522836650455, 1.482538203912863],
            [34.04600638030415, 1.483659510430675],
            [34.04631654162228, 1.490941218367999],
            [34.046734141448404, 1.492560213357454],
            [34.047841587225605, 1.494160784483003],
            [34.050991875620774, 1.496275976509047],
            [34.05415585254421, 1.499983207683297],
            [34.05683305217815, 1.500741749065883],
            [34.06065372901532, 1.503236508487982],
            [34.06415129262457, 1.504365509333477],
            [34.06841812493414, 1.507068076345341],
            [34.08625951897797, 1.516511898186319],
            [34.08801770883855, 1.518464869994307],
            [34.091349576397015, 1.524080523478719],
            [34.09391394224135, 1.527190911550394],
            [34.10549157335357, 1.537297924685129],
            [34.10699605652003, 1.539594721066745],
            [34.107354685541026, 1.541105147661142],
            [34.106484822596904, 1.554701139638849],
            [34.10886876091809, 1.563899244905423],
            [34.11118992676391, 1.56797756562539],
            [34.1133214744229, 1.570409684449237],
            [34.11659820518585, 1.573356776623033],
            [34.11859934710999, 1.574576847209831],
            [34.12043229566685, 1.57538090920937],
            [34.12185591698302, 1.575524865491113],
            [34.22950715500616, 1.579334968311825],
            [34.229070110247406, 1.637204170950427],
            [34.22900191643924, 1.640082106615967],
            [34.222213104393674, 1.640185995521553],
            [34.02814118449856, 1.647718622689281],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1868,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "ONGINO",
        Population: 41984,
        Key: "KUMIONGINO",
        Dist2: "Kumi",
        "Sub Country": "Ongino",
        id2_original: "KumiOngino",
        drought: "H",
        "Animal Vectors and diseases": "H",
        "Crop pest and diseases": "H",
        "Environmental degradation": "H",
        flood: "H",
        "Heavy storms, hailstorm, lightning, strong winds": "M",
        "Internal and land conflicts": "H",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [34.22956819013982, 1.561541322345902],
            [34.22950715500616, 1.579334968311825],
            [34.12185591698302, 1.575524865491113],
            [34.12043229566685, 1.57538090920937],
            [34.11859934710999, 1.574576847209831],
            [34.11659820518585, 1.573356776623033],
            [34.1133214744229, 1.570409684449237],
            [34.11118992676391, 1.56797756562539],
            [34.10886876091809, 1.563899244905423],
            [34.106484822596904, 1.554701139638849],
            [34.107354685541026, 1.541105147661142],
            [34.10699605652003, 1.539594721066745],
            [34.10549157335357, 1.537297924685129],
            [34.09391394224135, 1.527190911550394],
            [34.091349576397015, 1.524080523478719],
            [34.08801770883855, 1.518464869994307],
            [34.08625951897797, 1.516511898186319],
            [34.06841812493414, 1.507068076345341],
            [34.06415129262457, 1.504365509333477],
            [34.06065372901532, 1.503236508487982],
            [34.05683305217815, 1.500741749065883],
            [34.05415585254421, 1.499983207683297],
            [34.050991875620774, 1.496275976509047],
            [34.047841587225605, 1.494160784483003],
            [34.046734141448404, 1.492560213357454],
            [34.04631654162228, 1.490941218367999],
            [34.04600638030415, 1.483659510430675],
            [34.04522836650455, 1.482538203912863],
            [34.04502742595191, 1.480512043224381],
            [34.04378304997595, 1.477979812565541],
            [34.037316262400196, 1.470094920728743],
            [34.03248575341952, 1.466686902297408],
            [34.032542925797486, 1.465185268837259],
            [34.02824467580917, 1.45862903002721],
            [34.020227035828604, 1.453358973340499],
            [34.01118119225867, 1.452693679439448],
            [34.00881815863244, 1.452142944825915],
            [34.00859576720914, 1.449763975438235],
            [34.009073935044995, 1.447466103620351],
            [34.012554436952044, 1.440698219251159],
            [34.0170830616916, 1.433676589631403],
            [34.02361191027706, 1.426256056528144],
            [34.025116289238966, 1.416069755980417],
            [34.023930507674045, 1.413700271064051],
            [34.022325289228235, 1.411765170568788],
            [34.021266822295246, 1.408632964696231],
            [34.024842456689214, 1.408854133119331],
            [34.031292653279976, 1.408395132149518],
            [34.03186574339697, 1.406989954349643],
            [34.032476355245024, 1.406567234913269],
            [34.0347108444457, 1.407727389714196],
            [34.034833009036134, 1.408326818846918],
            [34.037830450882296, 1.408808115562286],
            [34.038925511586676, 1.404257801606557],
            [34.0431290171603, 1.404960951365818],
            [34.046021189929924, 1.403983084983456],
            [34.04754274917162, 1.408368533885086],
            [34.05120701314818, 1.408385409926233],
            [34.05500588607677, 1.409597020813801],
            [34.05678614934053, 1.409088490190307],
            [34.058507303458605, 1.409117567046927],
            [34.06027431387698, 1.41029603616872],
            [34.065429014063895, 1.411064775363346],
            [34.070921199624955, 1.404533677573952],
            [34.072123524564155, 1.402497836529647],
            [34.074045810576024, 1.397576082140324],
            [34.074829485558524, 1.390257744241807],
            [34.07582093817131, 1.387742583571052],
            [34.07857757223255, 1.384430593147394],
            [34.08325015469133, 1.377119534637426],
            [34.084593848405085, 1.373446373041357],
            [34.088376740304774, 1.367637320691387],
            [34.089920001945444, 1.364316856090626],
            [34.092423512319186, 1.361556786423329],
            [34.09506285784536, 1.356092007731619],
            [34.0974514117105, 1.356289921201979],
            [34.10440548771718, 1.354830385986681],
            [34.11417092764376, 1.358190835533484],
            [34.11745193798072, 1.360586385710216],
            [34.12519053697953, 1.368452390266967],
            [34.12824611868923, 1.370422872065964],
            [34.131648907341045, 1.37013179607394],
            [34.13705212645134, 1.371323223875699],
            [34.1386410090337, 1.372018966370512],
            [34.14053364255638, 1.373601021180891],
            [34.14155598284186, 1.373609574277148],
            [34.14356820907828, 1.375073974541339],
            [34.146238487192946, 1.375932003697808],
            [34.147493236913824, 1.376817853420632],
            [34.14804295915532, 1.376392448776784],
            [34.14844635841342, 1.376564116683389],
            [34.15069097162733, 1.378842484640613],
            [34.15245766044884, 1.377828530743345],
            [34.15546622164161, 1.3777908788659],
            [34.157043514160186, 1.376587062014844],
            [34.15785236981842, 1.376541438972392],
            [34.159583426964176, 1.377363725881229],
            [34.159599203177194, 1.378621035001731],
            [34.160920620468566, 1.380293791645815],
            [34.16305711514983, 1.380853556211126],
            [34.16371759068267, 1.381784909400097],
            [34.16438428615058, 1.381648899108828],
            [34.16599624914756, 1.382444098949682],
            [34.167992198809344, 1.382768744481988],
            [34.16924417453262, 1.382569124201825],
            [34.17031965555707, 1.383283176520241],
            [34.1706952438723, 1.38401566835053],
            [34.171029904044886, 1.383762229637002],
            [34.17259363110436, 1.384702172459291],
            [34.17318167996745, 1.385696873665442],
            [34.17403775826354, 1.385732626934459],
            [34.17498149596166, 1.386971374275403],
            [34.17533138257831, 1.387975238247892],
            [34.175210778361524, 1.388309978020177],
            [34.17432865341376, 1.388265334977319],
            [34.174489519223286, 1.388825522438596],
            [34.17412291046764, 1.389429353257847],
            [34.17534626766258, 1.390013929710673],
            [34.17560999865693, 1.39079858542371],
            [34.17613312088454, 1.390509190383038],
            [34.17729972970638, 1.391272739051551],
            [34.17717819214002, 1.394456698474652],
            [34.178840919832005, 1.39563992565676],
            [34.17967159107689, 1.395480723153111],
            [34.18110176650141, 1.39604838515489],
            [34.18287820923025, 1.396121320174011],
            [34.184252208508454, 1.397305564905073],
            [34.185246067707894, 1.399892032880862],
            [34.18440255684263, 1.400959367086718],
            [34.18562969235167, 1.403175301807267],
            [34.185780375757425, 1.405680789282791],
            [34.188020010508005, 1.406891718163925],
            [34.18928746240701, 1.409514217615097],
            [34.19108416573878, 1.411240951611343],
            [34.19124404879135, 1.414135376791803],
            [34.19209180599299, 1.415464602933811],
            [34.19117395774132, 1.41767214064635],
            [34.19128612408263, 1.420611818073341],
            [34.191973836534935, 1.420928047280208],
            [34.19362579971487, 1.422980476901788],
            [34.19445723991764, 1.423151904315501],
            [34.19500020054001, 1.423802884022218],
            [34.195645888904956, 1.423232690931232],
            [34.19597793318343, 1.423359151762641],
            [34.19666148014775, 1.424308552961797],
            [34.197300299994055, 1.426750454567411],
            [34.199049296496035, 1.42850432691981],
            [34.198897783945256, 1.429879293412958],
            [34.199556694612916, 1.430973429145337],
            [34.19934255241887, 1.43289114824207],
            [34.20063987330102, 1.434536708543729],
            [34.20065466316387, 1.435965859637899],
            [34.20091332227015, 1.436472259590438],
            [34.20212609281946, 1.436480661586947],
            [34.20183243085815, 1.43778334065962],
            [34.201066606298674, 1.438489281172529],
            [34.20102030353565, 1.44017173216951],
            [34.20268264225713, 1.440532660886681],
            [34.20164835437836, 1.442387498140152],
            [34.20194901601235, 1.443716997098474],
            [34.20257729412882, 1.444223198660229],
            [34.202198876120434, 1.445643512459601],
            [34.20289060314372, 1.447162754016546],
            [34.203860075778124, 1.44809390008724],
            [34.20453013723339, 1.451123714731488],
            [34.20709466926606, 1.453691196349199],
            [34.2086208557298, 1.456792903856113],
            [34.20875503888041, 1.461912458242735],
            [34.210244396214144, 1.463349847584159],
            [34.210683621184096, 1.465348613567993],
            [34.21246340654413, 1.467844135828716],
            [34.21367463109287, 1.468087696040092],
            [34.214568610209106, 1.469615855056607],
            [34.21549346891323, 1.470076655907918],
            [34.216089792158414, 1.471713518760253],
            [34.217158869991515, 1.471902881314925],
            [34.217986156384434, 1.472671271933022],
            [34.21831462536809, 1.473439936181784],
            [34.21814915120115, 1.474905356915889],
            [34.219863415240994, 1.476704413351888],
            [34.22004815737243, 1.47760883476523],
            [34.21907291036739, 1.479517920197232],
            [34.217495645696594, 1.480694676200852],
            [34.21753769852999, 1.481581087195704],
            [34.221194802035384, 1.488109716415992],
            [34.22446039368883, 1.492585275932344],
            [34.23011060817975, 1.496127816696388],
            [34.22956819013982, 1.561541322345902],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1871,
        District: "BUKEDEA",
        County: "BUKEDEA",
        Subcounty: "MALERA",
        Population: 45876,
        Key: "BUKEDEAMALERA",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [33.91070867823355, 1.436526054459089],
              [33.91697780051415, 1.439933920838451],
              [33.9185018876151, 1.441290222069427],
              [33.919933628803136, 1.443505941151797],
              [33.92128429613846, 1.446662488183487],
              [33.92540892693516, 1.452305572980135],
              [33.927646530594906, 1.453761071764128],
              [33.929960513511695, 1.453787250123953],
              [33.93091351373872, 1.458427504407658],
              [33.93012984773936, 1.45905242774272],
              [33.9244822257864, 1.46084970178555],
              [33.92261005678423, 1.462585574789062],
              [33.9221640468389, 1.462376351673732],
              [33.921881930923945, 1.461473360928863],
              [33.920816060076376, 1.460741511526407],
              [33.911380345876516, 1.457031623116921],
              [33.90576604962395, 1.455673932184783],
              [33.901995779054, 1.455743616258914],
              [33.901646785362736, 1.45401593695608],
              [33.90059598824567, 1.451944785329476],
              [33.90014426771009, 1.451827366518343],
              [33.900141640137875, 1.45086847204191],
              [33.89934089087678, 1.448923864058125],
              [33.89859442501165, 1.440728319464474],
              [33.89773479747186, 1.439037025059452],
              [33.897918698780224, 1.436675896640698],
              [33.8991015742952, 1.434640036302954],
              [33.899164435703824, 1.433056929872905],
              [33.90059154338163, 1.433535812009779],
              [33.90280039915566, 1.433381149872972],
              [33.905630510017254, 1.434474609510119],
              [33.90770179868698, 1.435921168118514],
              [33.91070867823355, 1.436526054459089],
            ],
          ],
          [
            [
              [33.96646643508068, 1.495320102315727],
              [33.96690679372454, 1.497699005978113],
              [33.96565045129068, 1.501100862993451],
              [33.965735921498386, 1.503832718918574],
              [33.964555249550784, 1.511938469492142],
              [33.96466583126395, 1.515538731980164],
              [33.963633373253394, 1.517058925084944],
              [33.96257989107193, 1.521844739350092],
              [33.96251491053752, 1.528575002515043],
              [33.963029497871645, 1.532310773268492],
              [33.962745991364585, 1.534011551772289],
              [33.96305548074292, 1.535133116420094],
              [33.962881868737846, 1.540099456598217],
              [33.95727374211464, 1.540753316807927],
              [33.95613364437347, 1.541540837269804],
              [33.95399410350508, 1.541062364706346],
              [33.952580201960274, 1.541388660258381],
              [33.95072601363684, 1.540819594791792],
              [33.94823076776373, 1.541417755141751],
              [33.944093966591545, 1.53952898183938],
              [33.94316706062688, 1.5396741322044],
              [33.94268361429041, 1.54027138770134],
              [33.93832814341514, 1.501430954178324],
              [33.93080371805145, 1.502616453131336],
              [33.92840834776993, 1.501135216251042],
              [33.93048266196551, 1.498362852299378],
              [33.931932844668026, 1.498181617189991],
              [33.937355573389645, 1.498926040716848],
              [33.939220402257625, 1.498504452910052],
              [33.940151492574884, 1.497816671117262],
              [33.94188853429706, 1.494212385026154],
              [33.94265479903105, 1.495295196923662],
              [33.948078267066144, 1.497063361417812],
              [33.95141052988333, 1.497041076434863],
              [33.9537278733976, 1.495290374613272],
              [33.95482415401413, 1.493727674291696],
              [33.955919406957996, 1.489790401498839],
              [33.95618653987236, 1.487108950611389],
              [33.958409795640364, 1.492546533065448],
              [33.96140761747393, 1.494155405404025],
              [33.96646643508068, 1.495320102315727],
            ],
          ],
          [
            [
              [33.954975724955396, 1.635427320311702],
              [33.946110435571065, 1.635819610105765],
              [33.92282670258296, 1.640422102650565],
              [33.912199536652096, 1.642647015045348],
              [33.89837439166597, 1.651046367464593],
              [33.895141049531226, 1.654188329884584],
              [33.89837457312565, 1.651042987609604],
              [33.89962969834231, 1.646003700963177],
              [33.897329032051296, 1.625922240729974],
              [33.89742052905626, 1.621923791248368],
              [33.89945140162304, 1.60757565720578],
              [33.89956249986747, 1.599542608776984],
              [33.89910945252025, 1.597751667499113],
              [33.89756227961482, 1.59536415852669],
              [33.89564510771186, 1.590923325833823],
              [33.89357697482374, 1.590761398668355],
              [33.892269278400036, 1.589974950914884],
              [33.88697345917016, 1.581862806778182],
              [33.88625850261196, 1.579782487990371],
              [33.88600504744613, 1.575630388406187],
              [33.8854338581643, 1.574726012705997],
              [33.88545521830512, 1.572093557520792],
              [33.884479168206205, 1.57034805532855],
              [33.88420348063538, 1.568068528194329],
              [33.88157269605387, 1.563184689237257],
              [33.878075507042105, 1.559404843251504],
              [33.87655140377151, 1.555578928377191],
              [33.87656030966923, 1.552656992560484],
              [33.877533327055744, 1.551191096336375],
              [33.87757989931334, 1.54968940265222],
              [33.876282435599, 1.547745004578832],
              [33.87514109818278, 1.54702178055114],
              [33.87399861721115, 1.544878297729559],
              [33.87298366107731, 1.53995756327493],
              [33.87172185059828, 1.537235164924413],
              [33.87023043522426, 1.530767710922589],
              [33.862825143535204, 1.515048317390752],
              [33.860444797576804, 1.510842755258943],
              [33.859404116388156, 1.508862036350233],
              [33.864270385503644, 1.510081338392195],
              [33.86774002947388, 1.509935204513853],
              [33.872206780951586, 1.508160338757016],
              [33.87402370895367, 1.506902176285133],
              [33.877297183323755, 1.503542849785645],
              [33.87632440938068, 1.514394149425692],
              [33.87796572123627, 1.520214327408864],
              [33.87936468379792, 1.522736119340656],
              [33.88110051279448, 1.523851066249467],
              [33.88153485003095, 1.525063562904303],
              [33.88452498138737, 1.528554828145486],
              [33.88756304774564, 1.531366966047929],
              [33.89161322527331, 1.533693601941891],
              [33.89411975937628, 1.533401507095936],
              [33.89836199132177, 1.533884783845142],
              [33.90009787242062, 1.535096718074946],
              [33.90299046829673, 1.535823090025206],
              [33.907522705162044, 1.538149474123246],
              [33.90824668170401, 1.540283456696373],
              [33.90810264313641, 1.541641704911116],
              [33.909984349551955, 1.545666945435442],
              [33.90993666068848, 1.546879631763212],
              [33.91181715348005, 1.548042975683667],
              [33.917071952040764, 1.549107835839123],
              [33.91919267679723, 1.548427818035687],
              [33.92189233790651, 1.548863195438953],
              [33.92362756593012, 1.548522888842491],
              [33.92652053011549, 1.55007381995751],
              [33.92762917873687, 1.549927811827809],
              [33.93153427565121, 1.551090236332776],
              [33.93254629968399, 1.550459204324401],
              [33.93621056455881, 1.552058281321689],
              [33.937177810269645, 1.553960553654291],
              [33.937929056070395, 1.555489004235374],
              [33.9404736895212, 1.557251846275676],
              [33.940642020330735, 1.559305228244401],
              [33.94195143523159, 1.561484739621636],
              [33.946246731559214, 1.565897268904519],
              [33.94729426689349, 1.567877877390894],
              [33.948117953737075, 1.571785394188021],
              [33.94921237753592, 1.573078477489135],
              [33.95012969847652, 1.575312429578393],
              [33.949868880718626, 1.576244292050168],
              [33.9506074279345, 1.578206942903631],
              [33.95010961394339, 1.579328881843825],
              [33.95054991779002, 1.580224236295905],
              [33.951763267752696, 1.581110188581948],
              [33.95216824984232, 1.58215934166687],
              [33.95188390430884, 1.583235951521705],
              [33.95262131695252, 1.583932154751598],
              [33.953050797896594, 1.585723070318321],
              [33.952822898902255, 1.595927102986133],
              [33.95554613809283, 1.610725128896033],
              [33.95596815673185, 1.616930502156899],
              [33.954975724955396, 1.635427320311702],
            ],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1874,
        District: "KUMI",
        County: "KUMI",
        Subcounty: "KUMI",
        Population: 17561,
        Key: "KUMIKUMI",
        Dist2: "Kumi",
        "Sub Country": "kumi TC",
        id2_original: "Kumikumi TC",
        drought: "M",
        "Animal Vectors and diseases": "L",
        "Crop pest and diseases": "L",
        "Environmental degradation": "H",
        flood: "L",
        "Heavy storms, hailstorm, lightning, strong winds": "N",
        "Internal and land conflicts": "M",
        "Proliferation of Invasive weed spices": "N",
        heatwave: "N",
        landslide: "N",
        "Earthquakes and faults": "N",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [33.94385927004548, 1.760263602461923],
            [33.942114501015205, 1.761568734703899],
            [33.9401435011621, 1.762432600575944],
            [33.9349656981027, 1.763900309484944],
            [33.927204470541916, 1.760681335601694],
            [33.921642802090254, 1.75899779338394],
            [33.91255307671701, 1.757500864981967],
            [33.90863322138089, 1.757891272279781],
            [33.90498750042845, 1.759057141349375],
            [33.902732252059884, 1.760709584155666],
            [33.89672153376399, 1.761104418282283],
            [33.88730476144023, 1.764503272795138],
            [33.87534530231484, 1.767620903549969],
            [33.871070460626214, 1.769253686695772],
            [33.86833719983036, 1.764062045437217],
            [33.866362757633084, 1.761602396627611],
            [33.85816892748261, 1.754206377923786],
            [33.84318393798871, 1.744587986648843],
            [33.840397550826985, 1.743187066322886],
            [33.82864686556349, 1.738804844479398],
            [33.82730450225468, 1.737403256305661],
            [33.8265284404942, 1.734554003606771],
            [33.82375530527952, 1.733867700693231],
            [33.822723418597484, 1.733198723492476],
            [33.81972897532769, 1.730060948498569],
            [33.81540693795067, 1.727149897071775],
            [33.81401283437643, 1.725594525471694],
            [33.81229564003211, 1.722673288505712],
            [33.8105973390549, 1.71524694651538],
            [33.81026162965004, 1.711927070975406],
            [33.810853985036616, 1.710940763906271],
            [33.81193643968263, 1.710316103338224],
            [33.8138963067144, 1.710496193669172],
            [33.814696037285955, 1.710957216398981],
            [33.81455029012268, 1.706434096427509],
            [33.81265039911085, 1.701884583161734],
            [33.80932224967934, 1.699995301350169],
            [33.80767200228159, 1.699869348325591],
            [33.80308246368095, 1.700676405800752],
            [33.8004006476048, 1.700596111136033],
            [33.798955771250675, 1.699818724495487],
            [33.79851653011104, 1.698787617560756],
            [33.798721819407966, 1.697928124310286],
            [33.800112820201235, 1.696136358315147],
            [33.802458716666806, 1.695049812598731],
            [33.80788782881683, 1.695988361059941],
            [33.811215883026925, 1.697669583245206],
            [33.81431005007299, 1.697641132618664],
            [33.81513530447674, 1.697351298964021],
            [33.81559854860079, 1.696654532693217],
            [33.81580234310107, 1.693587728922172],
            [33.8124542887995, 1.684325663782842],
            [33.81178115510597, 1.681548709832227],
            [33.81175138942905, 1.67886194986587],
            [33.818646994093854, 1.68139203208914],
            [33.828880168822565, 1.681577653657201],
            [33.83542780118064, 1.681032061496605],
            [33.84369897537878, 1.679997199324722],
            [33.852289398252495, 1.677994213785987],
            [33.85868184395026, 1.67602835743781],
            [33.86791252127977, 1.672324342887519],
            [33.88066781049178, 1.665307802785226],
            [33.88951624568476, 1.658971465035017],
            [33.895141049531226, 1.654188329884584],
            [33.89837439166597, 1.651046367464593],
            [33.912199536652096, 1.642647015045348],
            [33.92282670258296, 1.640422102650565],
            [33.92923696816104, 1.66681779810586],
            [33.93362037394668, 1.678692584159953],
            [33.93541819208775, 1.682694281206177],
            [33.93928490668491, 1.688414666214661],
            [33.945980646978796, 1.695566036981242],
            [33.947242812292345, 1.698456831714994],
            [33.947592492296465, 1.703750852173897],
            [33.946954089268445, 1.707002300852524],
            [33.947170464674315, 1.709583535583083],
            [33.94696912706632, 1.710241078041657],
            [33.945425371352215, 1.711007684596827],
            [33.94514306679104, 1.713924105937677],
            [33.9456914765939, 1.715859580631647],
            [33.94741600208922, 1.717710108236005],
            [33.94817936526485, 1.720768759110021],
            [33.95057238285864, 1.725845358722283],
            [33.95057324613961, 1.726729737527074],
            [33.949782043275036, 1.731642599916206],
            [33.9471236741261, 1.734657304726825],
            [33.9540136059299, 1.747079759468621],
            [33.94923048847037, 1.751596007062854],
            [33.947086988726525, 1.757271820620527],
            [33.94385927004548, 1.760263602461923],
          ],
        ],
      },
      properties: {
        FID_: 0,
        OBJECTID: 1881,
        District: "KATAKWI",
        County: "TOROMA",
        Subcounty: "KAPUJAN",
        Population: 13084,
        Key: "KATAKWIKAPUJAN",
        Dist2: null,
        "Sub Country": null,
        id2_original: null,
        drought: null,
        "Animal Vectors and diseases": null,
        "Crop pest and diseases": null,
        "Environmental degradation": null,
        flood: null,
        "Heavy storms, hailstorm, lightning, strong winds": null,
        "Internal and land conflicts": null,
        "Proliferation of Invasive weed spices": null,
        heatwave: null,
        landslide: null,
        "Earthquakes and faults": null,
      },
    },
  ],
}
